(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".fr-inline-field{display:inline-block;margin-right:16px}.fr-inline-container{display:inline-flex;flex-wrap:wrap}.ant-form-item-optional-hide{padding:0 8px}.ant-form-item-optional-hide .ant-form-item-label>label{font-size:16px;font-weight:#000000d9;font-weight:600}.fr-desc{word-break:break-all;color:#00000073;line-height:22px;margin-left:5px;font-weight:400;font-size:14px}.fr-hide-label>.ant-form-item-row>.ant-form-item-label{visibility:hidden}.fr-field .ant-form-item-row{flex-wrap:nowrap}.fr-field .ant-form-item-control-input-content{display:flex}.fr-field-visibility{width:0;height:0;visibility:hidden;position:absolute;opacity:0}.fr-form .ant-form-item-control{width:0}.fr-form .fr-inline-field .ant-form-item-control{width:auto}.rc-color-picker-panel-inner{position:relative;border-radius:4px;box-shadow:0 1px 5px #ccc;border:1px solid #ccc;padding-bottom:8px}.rc-color-picker-panel-wrap{margin:5px 0 0;height:30px;width:100%;position:relative}.rc-color-picker-panel-wrap-preview{position:absolute;right:8px}.rc-color-picker-panel-wrap-ribbon{position:absolute;left:8px;top:0;right:43px;height:30px}.rc-color-picker-panel-wrap-alpha{position:absolute;left:8px;right:43px;bottom:0;height:12.5px}.rc-color-picker-panel-wrap-has-alpha .rc-color-picker-panel-wrap-ribbon{height:12.5px}.rc-color-picker-trigger{border:1px solid #999;display:inline-block;padding:2px;border-radius:2px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:20px;height:20px;cursor:pointer;box-shadow:0 0 0 2px #fff inset}.rc-color-picker-trigger-open{box-shadow:0 0 3px #999}.rc-color-picker-panel{width:218px;background-color:#fff;box-sizing:border-box;outline:none;z-index:9;border-radius:4px;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.rc-color-picker-panel *{box-sizing:border-box}.rc-color-picker-panel-open{display:block}.rc-color-picker-panel-close{display:none}.rc-color-picker-panel-preview{height:30px;width:30px;overflow:hidden;border-radius:2px;background-image:url(data:image/png;base64,R0lGODdhCgAKAPAAAOXl5f///ywAAAAACgAKAEACEIQdqXt9GxyETrI279OIgwIAOw==)}.rc-color-picker-panel-preview span{box-shadow:0 0 2px gray inset}.rc-color-picker-panel-preview span,.rc-color-picker-panel-preview input[type=color]{position:absolute;display:block;height:100%;width:30px;border-radius:2px}.rc-color-picker-panel-preview input[type=color]{opacity:0}.rc-color-picker-panel-board{position:relative;font-size:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin:8px 8px 0}.rc-color-picker-panel-board span{position:absolute;border-radius:10px;border:1px solid #fff;width:9px;height:9px;margin:-4px 0 0 -4px;left:-999px;top:-999px;box-shadow:0 0 1px #787878b3;z-index:2}.rc-color-picker-panel-board-hsv{width:200px;height:150px;position:relative;z-index:1;border-radius:2px}.rc-color-picker-panel-board-value{border-radius:2px;position:absolute;width:100%;height:100%;left:0;top:0;z-index:2;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMSAxIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj48bGluZWFyR3JhZGllbnQgaWQ9Imxlc3NoYXQtZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9InJnYigwLDAsMCkiIHN0b3Atb3BhY2l0eT0iMCIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzAwMDAwMCIgc3RvcC1vcGFjaXR5PSIxIi8+PC9saW5lYXJHcmFkaWVudD48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2xlc3NoYXQtZ2VuZXJhdGVkKSIgLz48L3N2Zz4=);background-image:-webkit-linear-gradient(top,transparent 0%,#000000 100%);background-image:-moz-linear-gradient(top,transparent 0%,#000000 100%);background-image:-o-linear-gradient(top,transparent 0%,#000000 100%);background-image:linear-gradient(to bottom,transparent 0%,#000000 100%)}.rc-color-picker-panel-board-saturation{border-radius:2px;position:absolute;width:100%;height:100%;left:0;top:0;z-index:1;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMSAxIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj48bGluZWFyR3JhZGllbnQgaWQ9Imxlc3NoYXQtZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNmZmZmZmYiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0icmdiKDAsMCwwKSIgc3RvcC1vcGFjaXR5PSIwIi8+PC9saW5lYXJHcmFkaWVudD48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2xlc3NoYXQtZ2VuZXJhdGVkKSIgLz48L3N2Zz4=);background-image:-webkit-linear-gradient(left,#ffffff 0%,transparent 100%);background-image:-moz-linear-gradient(left,#ffffff 0%,transparent 100%);background-image:-o-linear-gradient(left,#ffffff 0%,transparent 100%);background-image:linear-gradient(to right,#ffffff 0%,transparent 100%)}.rc-color-picker-panel-board-handler{box-shadow:0 0 2px gray inset;border-radius:2px;cursor:crosshair;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:absolute;top:0;left:0;width:100%;height:100%;z-index:3}.rc-color-picker-panel-ribbon{position:relative;height:100%;border-radius:2px;box-shadow:0 0 2px gray inset;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMSAxIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj48bGluZWFyR3JhZGllbnQgaWQ9Imxlc3NoYXQtZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNmZjAwMDAiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iMTAlIiBzdG9wLWNvbG9yPSIjZmY5OTAwIiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjIwJSIgc3RvcC1jb2xvcj0iI2NkZmYwMCIgc3RvcC1vcGFjaXR5PSIxIi8+PHN0b3Agb2Zmc2V0PSIzMCUiIHN0b3AtY29sb3I9IiMzNWZmMDAiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iNDAlIiBzdG9wLWNvbG9yPSIjMDBmZjY2IiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjUwJSIgc3RvcC1jb2xvcj0iIzAwZmZmZCIgc3RvcC1vcGFjaXR5PSIxIi8+PHN0b3Agb2Zmc2V0PSI2MCUiIHN0b3AtY29sb3I9IiMwMDY2ZmYiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iNzAlIiBzdG9wLWNvbG9yPSIjMzIwMGZmIiBzdG9wLW9wYWNpdHk9IjEiLz48c3RvcCBvZmZzZXQ9IjgwJSIgc3RvcC1jb2xvcj0iI2NkMDBmZiIgc3RvcC1vcGFjaXR5PSIxIi8+PHN0b3Agb2Zmc2V0PSI5MCUiIHN0b3AtY29sb3I9IiNmZjAwOTkiIHN0b3Atb3BhY2l0eT0iMSIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI2ZmMDAwMCIgc3RvcC1vcGFjaXR5PSIxIi8+PC9saW5lYXJHcmFkaWVudD48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2xlc3NoYXQtZ2VuZXJhdGVkKSIgLz48L3N2Zz4=);background-image:-webkit-linear-gradient(left,#ff0000 0%,#ff9900 10%,#cdff00 20%,#35ff00 30%,#00ff66 40%,#00fffd 50%,#0066ff 60%,#3200ff 70%,#cd00ff 80%,#ff0099 90%,#ff0000 100%);background-image:-moz-linear-gradient(left,#ff0000 0%,#ff9900 10%,#cdff00 20%,#35ff00 30%,#00ff66 40%,#00fffd 50%,#0066ff 60%,#3200ff 70%,#cd00ff 80%,#ff0099 90%,#ff0000 100%);background-image:-o-linear-gradient(left,#ff0000 0%,#ff9900 10%,#cdff00 20%,#35ff00 30%,#00ff66 40%,#00fffd 50%,#0066ff 60%,#3200ff 70%,#cd00ff 80%,#ff0099 90%,#ff0000 100%);background-image:linear-gradient(to right,red,#f90,#cdff00,#35ff00,#0f6,#00fffd,#06f,#3200ff,#cd00ff,#f09,red)}.rc-color-picker-panel-ribbon span{position:absolute;top:0;height:100%;width:4px;border:1px solid #000000;padding:1px 0;margin-left:-2px;background-color:#fff;border-radius:3px}.rc-color-picker-panel-ribbon-handler{position:absolute;width:104%;height:100%;left:-2%;cursor:pointer}.rc-color-picker-panel-alpha{position:relative;height:100%;width:100%;border-radius:2px;background-image:url(data:image/png;base64,R0lGODdhCgAKAPAAAOXl5f///ywAAAAACgAKAEACEIQdqXt9GxyETrI279OIgwIAOw==);background-repeat:repeat;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rc-color-picker-panel-alpha-bg{position:absolute;width:100%;height:100%;border-radius:2px;box-shadow:0 0 2px gray inset}.rc-color-picker-panel-alpha span{position:absolute;top:0;height:100%;width:4px;border:1px solid #000000;padding:1px 0;margin-left:-2px;background-color:#fff;border-radius:3px}.rc-color-picker-panel-alpha-handler{position:absolute;width:104%;height:100%;left:-2%;cursor:pointer}.rc-color-picker-panel-params{font-size:12px}.rc-color-picker-panel-params-input{overflow:hidden;padding:2px 8px}.rc-color-picker-panel-params input{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;text-align:center;padding:1px;margin:0;float:left;border-radius:2px;border:1px solid #CACACA;font-family:Helvetica Neue,Helvetica,sans-serif}.rc-color-picker-panel-params-hex{width:52px}.rc-color-picker-panel-params input[type=number]{margin-left:5px;width:44px}.rc-color-picker-panel-params input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}.rc-color-picker-panel-params-lable{padding:2px 8px;height:22px;line-height:18px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.rc-color-picker-panel-params-lable label{float:left;text-align:center}.rc-color-picker-panel-params-lable-hex{width:52px}.rc-color-picker-panel-params-lable-number,.rc-color-picker-panel-params-lable-alpha{margin-left:5px;width:44px;text-transform:uppercase}.rc-color-picker-panel-params-lable-number:hover{border-radius:2px;background-color:#eee;box-shadow:0 0 0 1px #ccc inset;cursor:pointer}.rc-color-picker-panel-params-has-alpha input[type=number],.rc-color-picker-panel-params-has-alpha .rc-color-picker-panel-params-lable-number,.rc-color-picker-panel-params-has-alpha .rc-color-picker-panel-params-lable-alpha{width:32px}.rc-color-picker{position:absolute;left:-9999px;top:-9999px;z-index:1000}.rc-color-picker-wrap{display:inline-block}.rc-color-picker-slide-up-enter,.rc-color-picker-slide-up-appear{animation-duration:.3s;animation-fill-mode:both;transform-origin:0 0;display:block!important;opacity:0;animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-play-state:paused}.rc-color-picker-slide-up-leave{animation-duration:.3s;animation-fill-mode:both;transform-origin:0 0;display:block!important;opacity:1;animation-timing-function:cubic-bezier(.6,.04,.98,.34);animation-play-state:paused}.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-bottomLeft,.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-bottomRight,.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-bottomLeft,.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-bottomRight{animation-name:rcColorPickerSlideUpIn;animation-play-state:running}.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-topLeft,.rc-color-picker-slide-up-enter.rc-color-picker-slide-up-enter-active.rc-color-picker-placement-topRight,.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-topLeft,.rc-color-picker-slide-up-appear.rc-color-picker-slide-up-appear-active.rc-color-picker-placement-topRight{animation-name:rcColorPickerSlideDownIn;animation-play-state:running}.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-bottomLeft,.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-bottomRight{animation-name:rcColorPickerSlideUpOut;animation-play-state:running}.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-topLeft,.rc-color-picker-slide-up-leave.rc-color-picker-slide-up-leave-active.rc-color-picker-placement-topRight{animation-name:rcColorPickerSlideDownOut;animation-play-state:running}@keyframes rcColorPickerSlideUpIn{0%{opacity:0;transform-origin:0% 0%;transform:scaleY(0)}to{opacity:1;transform-origin:0% 0%;transform:scaleY(1)}}@keyframes rcColorPickerSlideUpOut{0%{opacity:1;transform-origin:0% 0%;transform:scaleY(1)}to{opacity:0;transform-origin:0% 0%;transform:scaleY(0)}}@keyframes rcColorPickerSlideDownIn{0%{opacity:0;transform-origin:100% 100%;transform:scaleY(0)}to{opacity:1;transform-origin:100% 100%;transform:scaleY(1)}}@keyframes rcColorPickerSlideDownOut{0%{opacity:1;transform-origin:100% 100%;transform:scaleY(1)}to{opacity:0;transform-origin:100% 100%;transform:scaleY(0)}}.fr-color-picker{width:100%;display:flex;flex-direction:row;align-items:center;color:#666}.fr-color-picker .rc-color-picker-trigger{margin-right:12px;height:32px;width:60px;border:1px solid #e5e5e5}.fr-color-picker>p{margin:0;font-size:14px;line-height:28px}.fr-color-picker .rc-color-picker-wrap{display:flex}.fr-preview-image{width:160px}.fr-preview{position:relative;cursor:pointer}.fr-slider{display:flex;width:100%;align-items:center}.fr-upload-mod,.fr-upload-file{display:flex}.fr-upload-mod{align-items:center}.fr-upload-mod .fr-upload-preview{margin:0 12px}.fr-upload-file .ant-upload-list-item{margin:5px 0 0 8px}.fr-upload-file .ant-upload-list-item-name{margin-right:6px}.fr-upload-file .ant-upload-list-item-info{cursor:pointer}.fr-upload-file .next-upload-list-text .next-upload-list-item-done,.fr-upload-file .next-upload-list-text .next-upload-list-item .next-icon{height:28px;line-height:28px;margin-left:12px}.fr-upload-file .next-upload-list-item-name-wrap{margin-top:-4px}.fr-panel-bordered{border-radius:4px;border:1px solid #f4f4f4;padding:52px 24px 0;margin-bottom:24px}.fr-obj-card{border-radius:4px;border-color:#f4f4f4;margin-bottom:24px!important}.fr-obj-card .ant-card-head{border:none}.fr-obj-card .ant-card-body{padding:12px 24px!important}.fr-obj-card .fr-header-desc{word-break:break-all;color:#00000073;margin-left:6px;font-weight:400}.fr-obj-collapse{border-radius:4px;border:1px solid #f1f1f1;margin-bottom:24px}.fr-obj-collapse .collapse-title{height:24px;color:#000000e0;font-weight:600;font-size:16px;line-height:24px}.fr-obj-collapse .fr-header-desc{word-break:break-all;color:#00000073;margin-left:6px;font-weight:400}.fr-obj-collapse .header-item-label{height:14px;margin-left:30px;color:#000;font-weight:600;font-size:14px;line-height:14px}.fr-obj-collapse .header-item-label span{color:#141414}.fr-obj-collapse .expand-icon-desc{margin-left:4px}.fr-obj-collapse .ant-collapse-header{display:flex;align-items:center!important;padding:16px!important;background-color:#fff;border-radius:4px!important}.fr-obj-collapse .ant-collapse-header-text{display:flex;align-items:center}.fr-obj-collapse .tag-no-data{color:#000000a6}.fr-obj-collapse .ant-collapse-content-box{padding:12px 24px!important}.fr-obj-collapse .ant-collapse-content-box .ant-skeleton-title,.fr-obj-collapse .ant-collapse-content-box .ant-skeleton-paragraph>li{animation:none!important}.fr-obj-subinline-label-hidden>.ant-form-item-row>.ant-form-item-label{visibility:hidden}.fr-obj-subinline-background>.ant-form-item-row>.ant-form-item-control{background-color:#f6f6f6;padding:24px 24px 0;border-radius:4px}.fr-obj-subinline .ant-form-item-row{flex-wrap:nowrap}.fr-obj-line-title .fr-obj-header{line-height:36px;border-bottom:1px solid #e9e9e9}.fr-obj-line-title .fr-header-title{color:#000000e0;font-size:16px;font-weight:600}.fr-obj-line-title .fr-header-desc{word-break:break-all;color:#00000073;margin-left:6px;font-weight:400}.fr-obj-line-title .fr-obj-content{padding:24px 0 0}.fr-list-simple{display:inline-block}.fr-list-simple .fr-inline-field{min-width:220px;margin-bottom:24px!important}.fr-list-simple .fr-list-item{display:flex;align-items:flex-start;position:relative}.fr-list-simple .fr-list-item-operate{height:32px;gap:0!important}.fr-list-simple-background{padding:24px 24px 0;background-color:#f6f6f6;border-radius:4px}.fr-list-simple-background .add-btn{margin-bottom:24px}.fr-list-simple-column .fr-list-item{align-items:center}.fr-list-card{margin-bottom:24px}.fr-list-card .fr-list-item{display:flex;align-items:flex-start;position:relative}.fr-list-card .fr-list-item-operate{padding:0 20px;height:32px;gap:0!important}.fr-list-card .fr-list-item-operate-fixed{position:absolute;right:8px}.fr-list-card .fr-list-add-btn{padding:0 8px}.fr-table-list{margin-bottom:24px}.fr-table-list .ant-form-item{margin-bottom:0}.fr-table-list .ant-form-item-label,.fr-table-list .ant-form-item-explain-error{display:none}.fr-table-list .fr-list-item-operate{gap:0!important}.fr-table-list-no-popover .ant-table-tbody .ant-table-cell{padding:24px 8px 0!important}.fr-table-list-no-popover .ant-form-item{margin-bottom:24px}.fr-table-list-no-popover .ant-form-item-explain-error{display:block;font-size:10px}.fr-list-drawer{margin-bottom:24px}.fr-list-drawer-table-header{width:100%;display:flex;justify-content:right;align-items:center;margin-bottom:10px}.fr-list-drawer .ant-form-item{margin-bottom:0}.fr-list-drawer .fr-list-item-operate{gap:0!important}.fr-virtual-list{margin-bottom:12px}.fr-virtual-list .ant-form-item{margin-bottom:0}.fr-virtual-list .ant-form-item-label,.fr-virtual-list .ant-form-item-explain-error{display:none}.fr-virtual-list .fr-list-item-operate{gap:0!important}.fr-popover-error .ant-popover-inner-content{color:#ff4d4f!important}.fr-virtual-list-no-popover .ant-table-tbody .ant-table-cell{padding:24px 8px 0!important}.fr-virtual-list-no-popover .ant-form-item{margin-bottom:24px}.fr-virtual-list-no-popover .ant-form-item-explain-error{display:block;font-size:10px}.fr-void-title{height:24px;color:#000000e0;font-weight:600;font-size:16px;line-height:24px}.fr-search{width:100%;background:#fff;padding:24px 24px 0 16px;margin-bottom:16px;box-sizing:border-box;position:relative}.fr-search .search-action-col{flex:1;display:flex;justify-content:flex-end;align-items:baseline;height:56px}.fr-search .search-action-fixed{position:absolute;right:0;bottom:0;background-color:#fff;padding-right:24px!important}.fr-search .search-action-column{height:auto}.fr-search .fr-form>.ant-row{align-items:center}.fr-column-search{padding-left:24px}")),document.head.appendChild(e)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
var mu = Object.defineProperty;
var Au = (a, s, $) => s in a ? mu(a, s, { enumerable: !0, configurable: !0, writable: !0, value: $ }) : a[s] = $;
var Ln = (a, s, $) => (Au(a, typeof s != "symbol" ? s + "" : s, $), $), ys = (a, s, $) => {
  if (!s.has(a))
    throw TypeError("Cannot " + $);
};
var mr = (a, s, $) => (ys(a, s, "read from private field"), $ ? $.call(a) : s.get(a)), _r = (a, s, $) => {
  if (s.has(a))
    throw TypeError("Cannot add the same private member more than once");
  s instanceof WeakSet ? s.add(a) : s.set(a, $);
}, tn = (a, s, $, _) => (ys(a, s, "write to private field"), _ ? _.call(a, $) : s.set(a, $), $);
var Wo = (a, s, $, _) => ({
  set _(_e) {
    tn(a, s, _e, $);
  },
  get _() {
    return mr(a, s, _);
  }
}), Ur = (a, s, $) => (ys(a, s, "access private method"), $);
function _mergeNamespaces(a, s) {
  for (var $ = 0; $ < s.length; $++) {
    const _ = s[$];
    if (typeof _ != "string" && !Array.isArray(_)) {
      for (const _e in _)
        if (_e !== "default" && !(_e in a)) {
          const tt = Object.getOwnPropertyDescriptor(_, _e);
          tt && Object.defineProperty(a, _e, tt.get ? tt : {
            enumerable: !0,
            get: () => _[_e]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }));
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
function getAugmentedNamespace(a) {
  if (a.__esModule)
    return a;
  var s = a.default;
  if (typeof s == "function") {
    var $ = function _() {
      return this instanceof _ ? Reflect.construct(s, arguments, this.constructor) : s.apply(this, arguments);
    };
    $.prototype = s.prototype;
  } else
    $ = {};
  return Object.defineProperty($, "__esModule", { value: !0 }), Object.keys(a).forEach(function(_) {
    var _e = Object.getOwnPropertyDescriptor(a, _);
    Object.defineProperty($, _, _e.get ? _e : {
      enumerable: !0,
      get: function() {
        return a[_];
      }
    });
  }), $;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {}, react = { exports: {} }, react_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty$g = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject$1(a) {
  if (a == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(a);
}
function shouldUseNative() {
  try {
    if (!Object.assign)
      return !1;
    var a = new String("abc");
    if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
      return !1;
    for (var s = {}, $ = 0; $ < 10; $++)
      s["_" + String.fromCharCode($)] = $;
    var _ = Object.getOwnPropertyNames(s).map(function(tt) {
      return s[tt];
    });
    if (_.join("") !== "0123456789")
      return !1;
    var _e = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(tt) {
      _e[tt] = tt;
    }), Object.keys(Object.assign({}, _e)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function(a, s) {
  for (var $, _ = toObject$1(a), _e, tt = 1; tt < arguments.length; tt++) {
    $ = Object(arguments[tt]);
    for (var nt in $)
      hasOwnProperty$g.call($, nt) && (_[nt] = $[nt]);
    if (getOwnPropertySymbols) {
      _e = getOwnPropertySymbols($);
      for (var at = 0; at < _e.length; at++)
        propIsEnumerable.call($, _e[at]) && (_[_e[at]] = $[_e[at]]);
    }
  }
  return _;
};
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l$3 = objectAssign, n$6 = typeof Symbol == "function" && Symbol.for, p$4 = n$6 ? Symbol.for("react.element") : 60103, q$5 = n$6 ? Symbol.for("react.portal") : 60106, r$4 = n$6 ? Symbol.for("react.fragment") : 60107, t$4 = n$6 ? Symbol.for("react.strict_mode") : 60108, u$4 = n$6 ? Symbol.for("react.profiler") : 60114, v$3 = n$6 ? Symbol.for("react.provider") : 60109, w$1 = n$6 ? Symbol.for("react.context") : 60110, x = n$6 ? Symbol.for("react.forward_ref") : 60112, y = n$6 ? Symbol.for("react.suspense") : 60113, z$1 = n$6 ? Symbol.for("react.memo") : 60115, A = n$6 ? Symbol.for("react.lazy") : 60116, B = typeof Symbol == "function" && Symbol.iterator;
function C$1(a) {
  for (var s = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, $ = 1; $ < arguments.length; $++)
    s += "&args[]=" + encodeURIComponent(arguments[$]);
  return "Minified React error #" + a + "; visit " + s + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var D = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, E$1 = {};
function F$1(a, s, $) {
  this.props = a, this.context = s, this.refs = E$1, this.updater = $ || D;
}
F$1.prototype.isReactComponent = {};
F$1.prototype.setState = function(a, s) {
  if (typeof a != "object" && typeof a != "function" && a != null)
    throw Error(C$1(85));
  this.updater.enqueueSetState(this, a, s, "setState");
};
F$1.prototype.forceUpdate = function(a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function G$1() {
}
G$1.prototype = F$1.prototype;
function H$1(a, s, $) {
  this.props = a, this.context = s, this.refs = E$1, this.updater = $ || D;
}
var I$1 = H$1.prototype = new G$1();
I$1.constructor = H$1;
l$3(I$1, F$1.prototype);
I$1.isPureReactComponent = !0;
var J$1 = { current: null }, K$1 = Object.prototype.hasOwnProperty, L$1 = { key: !0, ref: !0, __self: !0, __source: !0 };
function M$1(a, s, $) {
  var _, _e = {}, tt = null, nt = null;
  if (s != null)
    for (_ in s.ref !== void 0 && (nt = s.ref), s.key !== void 0 && (tt = "" + s.key), s)
      K$1.call(s, _) && !L$1.hasOwnProperty(_) && (_e[_] = s[_]);
  var at = arguments.length - 2;
  if (at === 1)
    _e.children = $;
  else if (1 < at) {
    for (var ot = Array(at), rt = 0; rt < at; rt++)
      ot[rt] = arguments[rt + 2];
    _e.children = ot;
  }
  if (a && a.defaultProps)
    for (_ in at = a.defaultProps, at)
      _e[_] === void 0 && (_e[_] = at[_]);
  return { $$typeof: p$4, type: a, key: tt, ref: nt, props: _e, _owner: J$1.current };
}
function N$1(a, s) {
  return { $$typeof: p$4, type: a.type, key: s, ref: a.ref, props: a.props, _owner: a._owner };
}
function O$1(a) {
  return typeof a == "object" && a !== null && a.$$typeof === p$4;
}
function escape$1(a) {
  var s = { "=": "=0", ":": "=2" };
  return "$" + ("" + a).replace(/[=:]/g, function($) {
    return s[$];
  });
}
var P$1 = /\/+/g, Q$1 = [];
function R$1(a, s, $, _) {
  if (Q$1.length) {
    var _e = Q$1.pop();
    return _e.result = a, _e.keyPrefix = s, _e.func = $, _e.context = _, _e.count = 0, _e;
  }
  return { result: a, keyPrefix: s, func: $, context: _, count: 0 };
}
function S$1(a) {
  a.result = null, a.keyPrefix = null, a.func = null, a.context = null, a.count = 0, 10 > Q$1.length && Q$1.push(a);
}
function T$1(a, s, $, _) {
  var _e = typeof a;
  (_e === "undefined" || _e === "boolean") && (a = null);
  var tt = !1;
  if (a === null)
    tt = !0;
  else
    switch (_e) {
      case "string":
      case "number":
        tt = !0;
        break;
      case "object":
        switch (a.$$typeof) {
          case p$4:
          case q$5:
            tt = !0;
        }
    }
  if (tt)
    return $(_, a, s === "" ? "." + U$1(a, 0) : s), 1;
  if (tt = 0, s = s === "" ? "." : s + ":", Array.isArray(a))
    for (var nt = 0; nt < a.length; nt++) {
      _e = a[nt];
      var at = s + U$1(_e, nt);
      tt += T$1(_e, at, $, _);
    }
  else if (a === null || typeof a != "object" ? at = null : (at = B && a[B] || a["@@iterator"], at = typeof at == "function" ? at : null), typeof at == "function")
    for (a = at.call(a), nt = 0; !(_e = a.next()).done; )
      _e = _e.value, at = s + U$1(_e, nt++), tt += T$1(_e, at, $, _);
  else if (_e === "object")
    throw $ = "" + a, Error(C$1(31, $ === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : $, ""));
  return tt;
}
function V$1(a, s, $) {
  return a == null ? 0 : T$1(a, "", s, $);
}
function U$1(a, s) {
  return typeof a == "object" && a !== null && a.key != null ? escape$1(a.key) : s.toString(36);
}
function W$1(a, s) {
  a.func.call(a.context, s, a.count++);
}
function aa$1(a, s, $) {
  var _ = a.result, _e = a.keyPrefix;
  a = a.func.call(a.context, s, a.count++), Array.isArray(a) ? X$1(a, _, $, function(tt) {
    return tt;
  }) : a != null && (O$1(a) && (a = N$1(a, _e + (!a.key || s && s.key === a.key ? "" : ("" + a.key).replace(P$1, "$&/") + "/") + $)), _.push(a));
}
function X$1(a, s, $, _, _e) {
  var tt = "";
  $ != null && (tt = ("" + $).replace(P$1, "$&/") + "/"), s = R$1(s, tt, _, _e), V$1(a, aa$1, s), S$1(s);
}
var Y$1 = { current: null };
function Z$1() {
  var a = Y$1.current;
  if (a === null)
    throw Error(C$1(321));
  return a;
}
var ba$1 = { ReactCurrentDispatcher: Y$1, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: J$1, IsSomeRendererActing: { current: !1 }, assign: l$3 };
react_production_min.Children = { map: function(a, s, $) {
  if (a == null)
    return a;
  var _ = [];
  return X$1(a, _, null, s, $), _;
}, forEach: function(a, s, $) {
  if (a == null)
    return a;
  s = R$1(null, null, s, $), V$1(a, W$1, s), S$1(s);
}, count: function(a) {
  return V$1(a, function() {
    return null;
  }, null);
}, toArray: function(a) {
  var s = [];
  return X$1(a, s, null, function($) {
    return $;
  }), s;
}, only: function(a) {
  if (!O$1(a))
    throw Error(C$1(143));
  return a;
} };
react_production_min.Component = F$1;
react_production_min.Fragment = r$4;
react_production_min.Profiler = u$4;
react_production_min.PureComponent = H$1;
react_production_min.StrictMode = t$4;
react_production_min.Suspense = y;
react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ba$1;
react_production_min.cloneElement = function(a, s, $) {
  if (a == null)
    throw Error(C$1(267, a));
  var _ = l$3({}, a.props), _e = a.key, tt = a.ref, nt = a._owner;
  if (s != null) {
    if (s.ref !== void 0 && (tt = s.ref, nt = J$1.current), s.key !== void 0 && (_e = "" + s.key), a.type && a.type.defaultProps)
      var at = a.type.defaultProps;
    for (ot in s)
      K$1.call(s, ot) && !L$1.hasOwnProperty(ot) && (_[ot] = s[ot] === void 0 && at !== void 0 ? at[ot] : s[ot]);
  }
  var ot = arguments.length - 2;
  if (ot === 1)
    _.children = $;
  else if (1 < ot) {
    at = Array(ot);
    for (var rt = 0; rt < ot; rt++)
      at[rt] = arguments[rt + 2];
    _.children = at;
  }
  return {
    $$typeof: p$4,
    type: a.type,
    key: _e,
    ref: tt,
    props: _,
    _owner: nt
  };
};
react_production_min.createContext = function(a, s) {
  return s === void 0 && (s = null), a = { $$typeof: w$1, _calculateChangedBits: s, _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null }, a.Provider = { $$typeof: v$3, _context: a }, a.Consumer = a;
};
react_production_min.createElement = M$1;
react_production_min.createFactory = function(a) {
  var s = M$1.bind(null, a);
  return s.type = a, s;
};
react_production_min.createRef = function() {
  return { current: null };
};
react_production_min.forwardRef = function(a) {
  return { $$typeof: x, render: a };
};
react_production_min.isValidElement = O$1;
react_production_min.lazy = function(a) {
  return { $$typeof: A, _ctor: a, _status: -1, _result: null };
};
react_production_min.memo = function(a, s) {
  return { $$typeof: z$1, type: a, compare: s === void 0 ? null : s };
};
react_production_min.useCallback = function(a, s) {
  return Z$1().useCallback(a, s);
};
react_production_min.useContext = function(a, s) {
  return Z$1().useContext(a, s);
};
react_production_min.useDebugValue = function() {
};
react_production_min.useEffect = function(a, s) {
  return Z$1().useEffect(a, s);
};
react_production_min.useImperativeHandle = function(a, s, $) {
  return Z$1().useImperativeHandle(a, s, $);
};
react_production_min.useLayoutEffect = function(a, s) {
  return Z$1().useLayoutEffect(a, s);
};
react_production_min.useMemo = function(a, s) {
  return Z$1().useMemo(a, s);
};
react_production_min.useReducer = function(a, s, $) {
  return Z$1().useReducer(a, s, $);
};
react_production_min.useRef = function(a) {
  return Z$1().useRef(a);
};
react_production_min.useState = function(a) {
  return Z$1().useState(a);
};
react_production_min.version = "16.14.0";
react.exports = react_production_min;
var reactExports = react.exports;
const React$a = /* @__PURE__ */ getDefaultExportFromCjs(reactExports), React$b = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: React$a
}, [reactExports]);
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$1 = reactExports, g$1 = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol == "function" && Symbol.for) {
  var h$4 = Symbol.for;
  g$1 = h$4("react.element"), reactJsxRuntime_production_min.Fragment = h$4("react.fragment");
}
var m$2 = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n$5 = Object.prototype.hasOwnProperty, p$3 = { key: !0, ref: !0, __self: !0, __source: !0 };
function q$4(a, s, $) {
  var _, _e = {}, tt = null, nt = null;
  $ !== void 0 && (tt = "" + $), s.key !== void 0 && (tt = "" + s.key), s.ref !== void 0 && (nt = s.ref);
  for (_ in s)
    n$5.call(s, _) && !p$3.hasOwnProperty(_) && (_e[_] = s[_]);
  if (a && a.defaultProps)
    for (_ in s = a.defaultProps, s)
      _e[_] === void 0 && (_e[_] = s[_]);
  return { $$typeof: g$1, type: a, key: tt, ref: nt, props: _e, _owner: m$2.current };
}
reactJsxRuntime_production_min.jsx = q$4;
reactJsxRuntime_production_min.jsxs = q$4;
jsxRuntime.exports = reactJsxRuntime_production_min;
var jsxRuntimeExports = jsxRuntime.exports, reactDom = { exports: {} }, reactDom_production_min = {}, scheduler = { exports: {} }, scheduler_production_min = {};
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(a) {
  var s, $, _, _e, tt;
  if (typeof window > "u" || typeof MessageChannel != "function") {
    var nt = null, at = null, ot = function() {
      if (nt !== null)
        try {
          var _t = a.unstable_now();
          nt(!0, _t), nt = null;
        } catch (Nt) {
          throw setTimeout(ot, 0), Nt;
        }
    }, rt = Date.now();
    a.unstable_now = function() {
      return Date.now() - rt;
    }, s = function(_t) {
      nt !== null ? setTimeout(s, 0, _t) : (nt = _t, setTimeout(ot, 0));
    }, $ = function(_t, Nt) {
      at = setTimeout(_t, Nt);
    }, _ = function() {
      clearTimeout(at);
    }, _e = function() {
      return !1;
    }, tt = a.unstable_forceFrameRate = function() {
    };
  } else {
    var st = window.performance, lt = window.Date, et = window.setTimeout, it = window.clearTimeout;
    if (typeof console < "u") {
      var ut = window.cancelAnimationFrame;
      typeof window.requestAnimationFrame != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), typeof ut != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if (typeof st == "object" && typeof st.now == "function")
      a.unstable_now = function() {
        return st.now();
      };
    else {
      var ft = lt.now();
      a.unstable_now = function() {
        return lt.now() - ft;
      };
    }
    var ht = !1, dt = null, gt = -1, pt = 5, mt = 0;
    _e = function() {
      return a.unstable_now() >= mt;
    }, tt = function() {
    }, a.unstable_forceFrameRate = function(_t) {
      0 > _t || 125 < _t ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : pt = 0 < _t ? Math.floor(1e3 / _t) : 5;
    };
    var ct = new MessageChannel(), vt = ct.port2;
    ct.port1.onmessage = function() {
      if (dt !== null) {
        var _t = a.unstable_now();
        mt = _t + pt;
        try {
          dt(!0, _t) ? vt.postMessage(null) : (ht = !1, dt = null);
        } catch (Nt) {
          throw vt.postMessage(null), Nt;
        }
      } else
        ht = !1;
    }, s = function(_t) {
      dt = _t, ht || (ht = !0, vt.postMessage(null));
    }, $ = function(_t, Nt) {
      gt = et(function() {
        _t(a.unstable_now());
      }, Nt);
    }, _ = function() {
      it(gt), gt = -1;
    };
  }
  function At(_t, Nt) {
    var Mt = _t.length;
    _t.push(Nt);
    e:
      for (; ; ) {
        var Lt = Mt - 1 >>> 1, $t = _t[Lt];
        if ($t !== void 0 && 0 < Et($t, Nt))
          _t[Lt] = Nt, _t[Mt] = $t, Mt = Lt;
        else
          break e;
      }
  }
  function xt(_t) {
    return _t = _t[0], _t === void 0 ? null : _t;
  }
  function bt(_t) {
    var Nt = _t[0];
    if (Nt !== void 0) {
      var Mt = _t.pop();
      if (Mt !== Nt) {
        _t[0] = Mt;
        e:
          for (var Lt = 0, $t = _t.length; Lt < $t; ) {
            var Tt = 2 * (Lt + 1) - 1, Dt = _t[Tt], Ut = Tt + 1, Vt = _t[Ut];
            if (Dt !== void 0 && 0 > Et(Dt, Mt))
              Vt !== void 0 && 0 > Et(Vt, Dt) ? (_t[Lt] = Vt, _t[Ut] = Mt, Lt = Ut) : (_t[Lt] = Dt, _t[Tt] = Mt, Lt = Tt);
            else if (Vt !== void 0 && 0 > Et(Vt, Mt))
              _t[Lt] = Vt, _t[Ut] = Mt, Lt = Ut;
            else
              break e;
          }
      }
      return Nt;
    }
    return null;
  }
  function Et(_t, Nt) {
    var Mt = _t.sortIndex - Nt.sortIndex;
    return Mt !== 0 ? Mt : _t.id - Nt.id;
  }
  var St = [], Bt = [], Ot = 1, Pt = null, wt = 3, Ct = !1, It = !1, yt = !1;
  function Rt(_t) {
    for (var Nt = xt(Bt); Nt !== null; ) {
      if (Nt.callback === null)
        bt(Bt);
      else if (Nt.startTime <= _t)
        bt(Bt), Nt.sortIndex = Nt.expirationTime, At(St, Nt);
      else
        break;
      Nt = xt(Bt);
    }
  }
  function kt(_t) {
    if (yt = !1, Rt(_t), !It)
      if (xt(St) !== null)
        It = !0, s(jt);
      else {
        var Nt = xt(Bt);
        Nt !== null && $(kt, Nt.startTime - _t);
      }
  }
  function jt(_t, Nt) {
    It = !1, yt && (yt = !1, _()), Ct = !0;
    var Mt = wt;
    try {
      for (Rt(Nt), Pt = xt(St); Pt !== null && (!(Pt.expirationTime > Nt) || _t && !_e()); ) {
        var Lt = Pt.callback;
        if (Lt !== null) {
          Pt.callback = null, wt = Pt.priorityLevel;
          var $t = Lt(Pt.expirationTime <= Nt);
          Nt = a.unstable_now(), typeof $t == "function" ? Pt.callback = $t : Pt === xt(St) && bt(St), Rt(Nt);
        } else
          bt(St);
        Pt = xt(St);
      }
      if (Pt !== null)
        var Tt = !0;
      else {
        var Dt = xt(Bt);
        Dt !== null && $(kt, Dt.startTime - Nt), Tt = !1;
      }
      return Tt;
    } finally {
      Pt = null, wt = Mt, Ct = !1;
    }
  }
  function Ht(_t) {
    switch (_t) {
      case 1:
        return -1;
      case 2:
        return 250;
      case 5:
        return 1073741823;
      case 4:
        return 1e4;
      default:
        return 5e3;
    }
  }
  var Ft = tt;
  a.unstable_IdlePriority = 5, a.unstable_ImmediatePriority = 1, a.unstable_LowPriority = 4, a.unstable_NormalPriority = 3, a.unstable_Profiling = null, a.unstable_UserBlockingPriority = 2, a.unstable_cancelCallback = function(_t) {
    _t.callback = null;
  }, a.unstable_continueExecution = function() {
    It || Ct || (It = !0, s(jt));
  }, a.unstable_getCurrentPriorityLevel = function() {
    return wt;
  }, a.unstable_getFirstCallbackNode = function() {
    return xt(St);
  }, a.unstable_next = function(_t) {
    switch (wt) {
      case 1:
      case 2:
      case 3:
        var Nt = 3;
        break;
      default:
        Nt = wt;
    }
    var Mt = wt;
    wt = Nt;
    try {
      return _t();
    } finally {
      wt = Mt;
    }
  }, a.unstable_pauseExecution = function() {
  }, a.unstable_requestPaint = Ft, a.unstable_runWithPriority = function(_t, Nt) {
    switch (_t) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        _t = 3;
    }
    var Mt = wt;
    wt = _t;
    try {
      return Nt();
    } finally {
      wt = Mt;
    }
  }, a.unstable_scheduleCallback = function(_t, Nt, Mt) {
    var Lt = a.unstable_now();
    if (typeof Mt == "object" && Mt !== null) {
      var $t = Mt.delay;
      $t = typeof $t == "number" && 0 < $t ? Lt + $t : Lt, Mt = typeof Mt.timeout == "number" ? Mt.timeout : Ht(_t);
    } else
      Mt = Ht(_t), $t = Lt;
    return Mt = $t + Mt, _t = { id: Ot++, callback: Nt, priorityLevel: _t, startTime: $t, expirationTime: Mt, sortIndex: -1 }, $t > Lt ? (_t.sortIndex = $t, At(Bt, _t), xt(St) === null && _t === xt(Bt) && (yt ? _() : yt = !0, $(kt, $t - Lt))) : (_t.sortIndex = Mt, At(St, _t), It || Ct || (It = !0, s(jt))), _t;
  }, a.unstable_shouldYield = function() {
    var _t = a.unstable_now();
    Rt(_t);
    var Nt = xt(St);
    return Nt !== Pt && Pt !== null && Nt !== null && Nt.callback !== null && Nt.startTime <= _t && Nt.expirationTime < Pt.expirationTime || _e();
  }, a.unstable_wrapCallback = function(_t) {
    var Nt = wt;
    return function() {
      var Mt = wt;
      wt = Nt;
      try {
        return _t.apply(this, arguments);
      } finally {
        wt = Mt;
      }
    };
  };
})(scheduler_production_min);
scheduler.exports = scheduler_production_min;
var schedulerExports = scheduler.exports;
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aa = reactExports, n$4 = objectAssign, r$3 = schedulerExports;
function u$3(a) {
  for (var s = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, $ = 1; $ < arguments.length; $++)
    s += "&args[]=" + encodeURIComponent(arguments[$]);
  return "Minified React error #" + a + "; visit " + s + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!aa)
  throw Error(u$3(227));
function ba(a, s, $, _, _e, tt, nt, at, ot) {
  var rt = Array.prototype.slice.call(arguments, 3);
  try {
    s.apply($, rt);
  } catch (st) {
    this.onError(st);
  }
}
var da = !1, ea = null, fa = !1, ha = null, ia = { onError: function(a) {
  da = !0, ea = a;
} };
function ja(a, s, $, _, _e, tt, nt, at, ot) {
  da = !1, ea = null, ba.apply(ia, arguments);
}
function ka(a, s, $, _, _e, tt, nt, at, ot) {
  if (ja.apply(this, arguments), da) {
    if (da) {
      var rt = ea;
      da = !1, ea = null;
    } else
      throw Error(u$3(198));
    fa || (fa = !0, ha = rt);
  }
}
var la = null, ma = null, na = null;
function oa(a, s, $) {
  var _ = a.type || "unknown-event";
  a.currentTarget = na($), ka(_, s, void 0, a), a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
  if (pa)
    for (var a in qa) {
      var s = qa[a], $ = pa.indexOf(a);
      if (!(-1 < $))
        throw Error(u$3(96, a));
      if (!sa[$]) {
        if (!s.extractEvents)
          throw Error(u$3(97, a));
        sa[$] = s, $ = s.eventTypes;
        for (var _ in $) {
          var _e = void 0, tt = $[_], nt = s, at = _;
          if (ta.hasOwnProperty(at))
            throw Error(u$3(99, at));
          ta[at] = tt;
          var ot = tt.phasedRegistrationNames;
          if (ot) {
            for (_e in ot)
              ot.hasOwnProperty(_e) && ua(ot[_e], nt, at);
            _e = !0;
          } else
            tt.registrationName ? (ua(tt.registrationName, nt, at), _e = !0) : _e = !1;
          if (!_e)
            throw Error(u$3(98, _, a));
        }
      }
    }
}
function ua(a, s, $) {
  if (va[a])
    throw Error(u$3(100, a));
  va[a] = s, wa[a] = s.eventTypes[$].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
  var s = !1, $;
  for ($ in a)
    if (a.hasOwnProperty($)) {
      var _ = a[$];
      if (!qa.hasOwnProperty($) || qa[$] !== _) {
        if (qa[$])
          throw Error(u$3(102, $));
        qa[$] = _, s = !0;
      }
    }
  s && ra();
}
var ya = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), za = null, Aa = null, Ba = null;
function Ca(a) {
  if (a = ma(a)) {
    if (typeof za != "function")
      throw Error(u$3(280));
    var s = a.stateNode;
    s && (s = la(s), za(a.stateNode, a.type, s));
  }
}
function Da(a) {
  Aa ? Ba ? Ba.push(a) : Ba = [a] : Aa = a;
}
function Ea() {
  if (Aa) {
    var a = Aa, s = Ba;
    if (Ba = Aa = null, Ca(a), s)
      for (a = 0; a < s.length; a++)
        Ca(s[a]);
  }
}
function Fa(a, s) {
  return a(s);
}
function Ga(a, s, $, _, _e) {
  return a(s, $, _, _e);
}
function Ha() {
}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
  (Aa !== null || Ba !== null) && (Ha(), Ea());
}
function Ma(a, s, $) {
  if (Ka)
    return a(s, $);
  Ka = !0;
  try {
    return Ia(a, s, $);
  } finally {
    Ka = !1, La();
  }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
  return Oa.call(Qa, a) ? !0 : Oa.call(Pa, a) ? !1 : Na.test(a) ? Qa[a] = !0 : (Pa[a] = !0, !1);
}
function Sa(a, s, $, _) {
  if ($ !== null && $.type === 0)
    return !1;
  switch (typeof s) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return _ ? !1 : $ !== null ? !$.acceptsBooleans : (a = a.toLowerCase().slice(0, 5), a !== "data-" && a !== "aria-");
    default:
      return !1;
  }
}
function Ta(a, s, $, _) {
  if (s === null || typeof s > "u" || Sa(a, s, $, _))
    return !0;
  if (_)
    return !1;
  if ($ !== null)
    switch ($.type) {
      case 3:
        return !s;
      case 4:
        return s === !1;
      case 5:
        return isNaN(s);
      case 6:
        return isNaN(s) || 1 > s;
    }
  return !1;
}
function v$2(a, s, $, _, _e, tt) {
  this.acceptsBooleans = s === 2 || s === 3 || s === 4, this.attributeName = _, this.attributeNamespace = _e, this.mustUseProperty = $, this.propertyName = a, this.type = s, this.sanitizeURL = tt;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
  C[a] = new v$2(a, 0, !1, a, null, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
  var s = a[0];
  C[s] = new v$2(s, 1, !1, a[1], null, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
  C[a] = new v$2(a, 2, !1, a.toLowerCase(), null, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
  C[a] = new v$2(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
  C[a] = new v$2(a, 3, !1, a.toLowerCase(), null, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function(a) {
  C[a] = new v$2(a, 3, !0, a, null, !1);
});
["capture", "download"].forEach(function(a) {
  C[a] = new v$2(a, 4, !1, a, null, !1);
});
["cols", "rows", "size", "span"].forEach(function(a) {
  C[a] = new v$2(a, 6, !1, a, null, !1);
});
["rowSpan", "start"].forEach(function(a) {
  C[a] = new v$2(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
  var s = a.replace(
    Ua,
    Va
  );
  C[s] = new v$2(s, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
  var s = a.replace(Ua, Va);
  C[s] = new v$2(s, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(a) {
  var s = a.replace(Ua, Va);
  C[s] = new v$2(s, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
["tabIndex", "crossOrigin"].forEach(function(a) {
  C[a] = new v$2(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v$2("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
["src", "href", "action", "formAction"].forEach(function(a) {
  C[a] = new v$2(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = { current: null });
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = { suspense: null });
function Xa(a, s, $, _) {
  var _e = C.hasOwnProperty(s) ? C[s] : null, tt = _e !== null ? _e.type === 0 : _ ? !1 : !(!(2 < s.length) || s[0] !== "o" && s[0] !== "O" || s[1] !== "n" && s[1] !== "N");
  tt || (Ta(s, $, _e, _) && ($ = null), _ || _e === null ? Ra(s) && ($ === null ? a.removeAttribute(s) : a.setAttribute(s, "" + $)) : _e.mustUseProperty ? a[_e.propertyName] = $ === null ? _e.type === 3 ? !1 : "" : $ : (s = _e.attributeName, _ = _e.attributeNamespace, $ === null ? a.removeAttribute(s) : (_e = _e.type, $ = _e === 3 || _e === 4 && $ === !0 ? "" : "" + $, _ ? a.setAttributeNS(_, s, $) : a.setAttribute(s, $))));
}
var Ya = /^(.*)[\\\/]/, E = typeof Symbol == "function" && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = typeof Symbol == "function" && Symbol.iterator;
function nb(a) {
  return a === null || typeof a != "object" ? null : (a = mb && a[mb] || a["@@iterator"], typeof a == "function" ? a : null);
}
function ob(a) {
  if (a._status === -1) {
    a._status = 0;
    var s = a._ctor;
    s = s(), a._result = s, s.then(function($) {
      a._status === 0 && ($ = $.default, a._status = 1, a._result = $);
    }, function($) {
      a._status === 0 && (a._status = 2, a._result = $);
    });
  }
}
function pb(a) {
  if (a == null)
    return null;
  if (typeof a == "function")
    return a.displayName || a.name || null;
  if (typeof a == "string")
    return a;
  switch (a) {
    case ab:
      return "Fragment";
    case $a:
      return "Portal";
    case cb:
      return "Profiler";
    case bb:
      return "StrictMode";
    case hb:
      return "Suspense";
    case ib:
      return "SuspenseList";
  }
  if (typeof a == "object")
    switch (a.$$typeof) {
      case eb:
        return "Context.Consumer";
      case db:
        return "Context.Provider";
      case gb:
        var s = a.render;
        return s = s.displayName || s.name || "", a.displayName || (s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef");
      case jb:
        return pb(a.type);
      case lb:
        return pb(a.render);
      case kb:
        if (a = a._status === 1 ? a._result : null)
          return pb(a);
    }
  return null;
}
function qb(a) {
  var s = "";
  do {
    e:
      switch (a.tag) {
        case 3:
        case 4:
        case 6:
        case 7:
        case 10:
        case 9:
          var $ = "";
          break e;
        default:
          var _ = a._debugOwner, _e = a._debugSource, tt = pb(a.type);
          $ = null, _ && ($ = pb(_.type)), _ = tt, tt = "", _e ? tt = " (at " + _e.fileName.replace(Ya, "") + ":" + _e.lineNumber + ")" : $ && (tt = " (created by " + $ + ")"), $ = `
    in ` + (_ || "Unknown") + tt;
      }
    s += $, a = a.return;
  } while (a);
  return s;
}
function rb(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return a;
    default:
      return "";
  }
}
function sb(a) {
  var s = a.type;
  return (a = a.nodeName) && a.toLowerCase() === "input" && (s === "checkbox" || s === "radio");
}
function tb(a) {
  var s = sb(a) ? "checked" : "value", $ = Object.getOwnPropertyDescriptor(a.constructor.prototype, s), _ = "" + a[s];
  if (!a.hasOwnProperty(s) && typeof $ < "u" && typeof $.get == "function" && typeof $.set == "function") {
    var _e = $.get, tt = $.set;
    return Object.defineProperty(a, s, { configurable: !0, get: function() {
      return _e.call(this);
    }, set: function(nt) {
      _ = "" + nt, tt.call(this, nt);
    } }), Object.defineProperty(a, s, { enumerable: $.enumerable }), { getValue: function() {
      return _;
    }, setValue: function(nt) {
      _ = "" + nt;
    }, stopTracking: function() {
      a._valueTracker = null, delete a[s];
    } };
  }
}
function xb(a) {
  a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
  if (!a)
    return !1;
  var s = a._valueTracker;
  if (!s)
    return !0;
  var $ = s.getValue(), _ = "";
  return a && (_ = sb(a) ? a.checked ? "true" : "false" : a.value), a = _, a !== $ ? (s.setValue(a), !0) : !1;
}
function zb(a, s) {
  var $ = s.checked;
  return n$4({}, s, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: $ ?? a._wrapperState.initialChecked });
}
function Ab(a, s) {
  var $ = s.defaultValue == null ? "" : s.defaultValue, _ = s.checked != null ? s.checked : s.defaultChecked;
  $ = rb(s.value != null ? s.value : $), a._wrapperState = { initialChecked: _, initialValue: $, controlled: s.type === "checkbox" || s.type === "radio" ? s.checked != null : s.value != null };
}
function Bb(a, s) {
  s = s.checked, s != null && Xa(a, "checked", s, !1);
}
function Cb(a, s) {
  Bb(a, s);
  var $ = rb(s.value), _ = s.type;
  if ($ != null)
    _ === "number" ? ($ === 0 && a.value === "" || a.value != $) && (a.value = "" + $) : a.value !== "" + $ && (a.value = "" + $);
  else if (_ === "submit" || _ === "reset") {
    a.removeAttribute("value");
    return;
  }
  s.hasOwnProperty("value") ? Db(a, s.type, $) : s.hasOwnProperty("defaultValue") && Db(a, s.type, rb(s.defaultValue)), s.checked == null && s.defaultChecked != null && (a.defaultChecked = !!s.defaultChecked);
}
function Eb(a, s, $) {
  if (s.hasOwnProperty("value") || s.hasOwnProperty("defaultValue")) {
    var _ = s.type;
    if (!(_ !== "submit" && _ !== "reset" || s.value !== void 0 && s.value !== null))
      return;
    s = "" + a._wrapperState.initialValue, $ || s === a.value || (a.value = s), a.defaultValue = s;
  }
  $ = a.name, $ !== "" && (a.name = ""), a.defaultChecked = !!a._wrapperState.initialChecked, $ !== "" && (a.name = $);
}
function Db(a, s, $) {
  (s !== "number" || a.ownerDocument.activeElement !== a) && ($ == null ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + $ && (a.defaultValue = "" + $));
}
function Fb(a) {
  var s = "";
  return aa.Children.forEach(a, function($) {
    $ != null && (s += $);
  }), s;
}
function Gb(a, s) {
  return a = n$4({ children: void 0 }, s), (s = Fb(s.children)) && (a.children = s), a;
}
function Hb(a, s, $, _) {
  if (a = a.options, s) {
    s = {};
    for (var _e = 0; _e < $.length; _e++)
      s["$" + $[_e]] = !0;
    for ($ = 0; $ < a.length; $++)
      _e = s.hasOwnProperty("$" + a[$].value), a[$].selected !== _e && (a[$].selected = _e), _e && _ && (a[$].defaultSelected = !0);
  } else {
    for ($ = "" + rb($), s = null, _e = 0; _e < a.length; _e++) {
      if (a[_e].value === $) {
        a[_e].selected = !0, _ && (a[_e].defaultSelected = !0);
        return;
      }
      s !== null || a[_e].disabled || (s = a[_e]);
    }
    s !== null && (s.selected = !0);
  }
}
function Ib(a, s) {
  if (s.dangerouslySetInnerHTML != null)
    throw Error(u$3(91));
  return n$4({}, s, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
}
function Jb(a, s) {
  var $ = s.value;
  if ($ == null) {
    if ($ = s.children, s = s.defaultValue, $ != null) {
      if (s != null)
        throw Error(u$3(92));
      if (Array.isArray($)) {
        if (!(1 >= $.length))
          throw Error(u$3(93));
        $ = $[0];
      }
      s = $;
    }
    s == null && (s = ""), $ = s;
  }
  a._wrapperState = { initialValue: rb($) };
}
function Kb(a, s) {
  var $ = rb(s.value), _ = rb(s.defaultValue);
  $ != null && ($ = "" + $, $ !== a.value && (a.value = $), s.defaultValue == null && a.defaultValue !== $ && (a.defaultValue = $)), _ != null && (a.defaultValue = "" + _);
}
function Lb(a) {
  var s = a.textContent;
  s === a._wrapperState.initialValue && s !== "" && s !== null && (a.value = s);
}
var Mb = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function Nb(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function Ob(a, s) {
  return a == null || a === "http://www.w3.org/1999/xhtml" ? Nb(s) : a === "http://www.w3.org/2000/svg" && s === "foreignObject" ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
  return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(s, $, _, _e) {
    MSApp.execUnsafeLocalFunction(function() {
      return a(s, $, _, _e);
    });
  } : a;
}(function(a, s) {
  if (a.namespaceURI !== Mb.svg || "innerHTML" in a)
    a.innerHTML = s;
  else {
    for (Pb = Pb || document.createElement("div"), Pb.innerHTML = "<svg>" + s.valueOf().toString() + "</svg>", s = Pb.firstChild; a.firstChild; )
      a.removeChild(a.firstChild);
    for (; s.firstChild; )
      a.appendChild(s.firstChild);
  }
});
function Rb(a, s) {
  if (s) {
    var $ = a.firstChild;
    if ($ && $ === a.lastChild && $.nodeType === 3) {
      $.nodeValue = s;
      return;
    }
  }
  a.textContent = s;
}
function Sb(a, s) {
  var $ = {};
  return $[a.toLowerCase()] = s.toLowerCase(), $["Webkit" + a] = "webkit" + s, $["Moz" + a] = "moz" + s, $;
}
var Tb = { animationend: Sb("Animation", "AnimationEnd"), animationiteration: Sb("Animation", "AnimationIteration"), animationstart: Sb("Animation", "AnimationStart"), transitionend: Sb("Transition", "TransitionEnd") }, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
  if (Ub[a])
    return Ub[a];
  if (!Tb[a])
    return a;
  var s = Tb[a], $;
  for ($ in s)
    if (s.hasOwnProperty($) && $ in Vb)
      return Ub[a] = s[$];
  return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new (typeof WeakMap == "function" ? WeakMap : Map)();
function cc(a) {
  var s = bc.get(a);
  return s === void 0 && (s = /* @__PURE__ */ new Map(), bc.set(a, s)), s;
}
function dc(a) {
  var s = a, $ = a;
  if (a.alternate)
    for (; s.return; )
      s = s.return;
  else {
    a = s;
    do
      s = a, s.effectTag & 1026 && ($ = s.return), a = s.return;
    while (a);
  }
  return s.tag === 3 ? $ : null;
}
function ec(a) {
  if (a.tag === 13) {
    var s = a.memoizedState;
    if (s === null && (a = a.alternate, a !== null && (s = a.memoizedState)), s !== null)
      return s.dehydrated;
  }
  return null;
}
function fc(a) {
  if (dc(a) !== a)
    throw Error(u$3(188));
}
function gc(a) {
  var s = a.alternate;
  if (!s) {
    if (s = dc(a), s === null)
      throw Error(u$3(188));
    return s !== a ? null : a;
  }
  for (var $ = a, _ = s; ; ) {
    var _e = $.return;
    if (_e === null)
      break;
    var tt = _e.alternate;
    if (tt === null) {
      if (_ = _e.return, _ !== null) {
        $ = _;
        continue;
      }
      break;
    }
    if (_e.child === tt.child) {
      for (tt = _e.child; tt; ) {
        if (tt === $)
          return fc(_e), a;
        if (tt === _)
          return fc(_e), s;
        tt = tt.sibling;
      }
      throw Error(u$3(188));
    }
    if ($.return !== _.return)
      $ = _e, _ = tt;
    else {
      for (var nt = !1, at = _e.child; at; ) {
        if (at === $) {
          nt = !0, $ = _e, _ = tt;
          break;
        }
        if (at === _) {
          nt = !0, _ = _e, $ = tt;
          break;
        }
        at = at.sibling;
      }
      if (!nt) {
        for (at = tt.child; at; ) {
          if (at === $) {
            nt = !0, $ = tt, _ = _e;
            break;
          }
          if (at === _) {
            nt = !0, _ = tt, $ = _e;
            break;
          }
          at = at.sibling;
        }
        if (!nt)
          throw Error(u$3(189));
      }
    }
    if ($.alternate !== _)
      throw Error(u$3(190));
  }
  if ($.tag !== 3)
    throw Error(u$3(188));
  return $.stateNode.current === $ ? a : s;
}
function hc(a) {
  if (a = gc(a), !a)
    return null;
  for (var s = a; ; ) {
    if (s.tag === 5 || s.tag === 6)
      return s;
    if (s.child)
      s.child.return = s, s = s.child;
    else {
      if (s === a)
        break;
      for (; !s.sibling; ) {
        if (!s.return || s.return === a)
          return null;
        s = s.return;
      }
      s.sibling.return = s.return, s = s.sibling;
    }
  }
  return null;
}
function ic(a, s) {
  if (s == null)
    throw Error(u$3(30));
  return a == null ? s : Array.isArray(a) ? Array.isArray(s) ? (a.push.apply(a, s), a) : (a.push(s), a) : Array.isArray(s) ? [a].concat(s) : [a, s];
}
function jc(a, s, $) {
  Array.isArray(a) ? a.forEach(s, $) : a && s.call($, a);
}
var kc = null;
function lc(a) {
  if (a) {
    var s = a._dispatchListeners, $ = a._dispatchInstances;
    if (Array.isArray(s))
      for (var _ = 0; _ < s.length && !a.isPropagationStopped(); _++)
        oa(a, s[_], $[_]);
    else
      s && oa(a, s, $);
    a._dispatchListeners = null, a._dispatchInstances = null, a.isPersistent() || a.constructor.release(a);
  }
}
function mc(a) {
  if (a !== null && (kc = ic(kc, a)), a = kc, kc = null, a) {
    if (jc(a, lc), kc)
      throw Error(u$3(95));
    if (fa)
      throw a = ha, fa = !1, ha = null, a;
  }
}
function nc(a) {
  return a = a.target || a.srcElement || window, a.correspondingUseElement && (a = a.correspondingUseElement), a.nodeType === 3 ? a.parentNode : a;
}
function oc(a) {
  if (!ya)
    return !1;
  a = "on" + a;
  var s = a in document;
  return s || (s = document.createElement("div"), s.setAttribute(a, "return;"), s = typeof s[a] == "function"), s;
}
var pc = [];
function qc(a) {
  a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > pc.length && pc.push(a);
}
function rc(a, s, $, _) {
  if (pc.length) {
    var _e = pc.pop();
    return _e.topLevelType = a, _e.eventSystemFlags = _, _e.nativeEvent = s, _e.targetInst = $, _e;
  }
  return { topLevelType: a, eventSystemFlags: _, nativeEvent: s, targetInst: $, ancestors: [] };
}
function sc(a) {
  var s = a.targetInst, $ = s;
  do {
    if (!$) {
      a.ancestors.push($);
      break;
    }
    var _ = $;
    if (_.tag === 3)
      _ = _.stateNode.containerInfo;
    else {
      for (; _.return; )
        _ = _.return;
      _ = _.tag !== 3 ? null : _.stateNode.containerInfo;
    }
    if (!_)
      break;
    s = $.tag, s !== 5 && s !== 6 || a.ancestors.push($), $ = tc(_);
  } while ($);
  for ($ = 0; $ < a.ancestors.length; $++) {
    s = a.ancestors[$];
    var _e = nc(a.nativeEvent);
    _ = a.topLevelType;
    var tt = a.nativeEvent, nt = a.eventSystemFlags;
    $ === 0 && (nt |= 64);
    for (var at = null, ot = 0; ot < sa.length; ot++) {
      var rt = sa[ot];
      rt && (rt = rt.extractEvents(_, s, tt, _e, nt)) && (at = ic(at, rt));
    }
    mc(at);
  }
}
function uc(a, s, $) {
  if (!$.has(a)) {
    switch (a) {
      case "scroll":
        vc(s, "scroll", !0);
        break;
      case "focus":
      case "blur":
        vc(s, "focus", !0), vc(s, "blur", !0), $.set("blur", null), $.set("focus", null);
        break;
      case "cancel":
      case "close":
        oc(a) && vc(s, a, !0);
        break;
      case "invalid":
      case "submit":
      case "reset":
        break;
      default:
        ac.indexOf(a) === -1 && F(a, s);
    }
    $.set(a, null);
  }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = /* @__PURE__ */ new Map(), Fc = /* @__PURE__ */ new Map(), Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, s) {
  var $ = cc(s);
  Hc.forEach(function(_) {
    uc(_, s, $);
  }), Ic.forEach(function(_) {
    uc(_, s, $);
  });
}
function Kc(a, s, $, _, _e) {
  return { blockedOn: a, topLevelType: s, eventSystemFlags: $ | 32, nativeEvent: _e, container: _ };
}
function Lc(a, s) {
  switch (a) {
    case "focus":
    case "blur":
      Bc = null;
      break;
    case "dragenter":
    case "dragleave":
      Cc = null;
      break;
    case "mouseover":
    case "mouseout":
      Dc = null;
      break;
    case "pointerover":
    case "pointerout":
      Ec.delete(s.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Fc.delete(s.pointerId);
  }
}
function Mc(a, s, $, _, _e, tt) {
  return a === null || a.nativeEvent !== tt ? (a = Kc(s, $, _, _e, tt), s !== null && (s = Nc(s), s !== null && xc(s)), a) : (a.eventSystemFlags |= _, a);
}
function Oc(a, s, $, _, _e) {
  switch (s) {
    case "focus":
      return Bc = Mc(Bc, a, s, $, _, _e), !0;
    case "dragenter":
      return Cc = Mc(Cc, a, s, $, _, _e), !0;
    case "mouseover":
      return Dc = Mc(Dc, a, s, $, _, _e), !0;
    case "pointerover":
      var tt = _e.pointerId;
      return Ec.set(tt, Mc(Ec.get(tt) || null, a, s, $, _, _e)), !0;
    case "gotpointercapture":
      return tt = _e.pointerId, Fc.set(tt, Mc(Fc.get(tt) || null, a, s, $, _, _e)), !0;
  }
  return !1;
}
function Pc(a) {
  var s = tc(a.target);
  if (s !== null) {
    var $ = dc(s);
    if ($ !== null) {
      if (s = $.tag, s === 13) {
        if (s = ec($), s !== null) {
          a.blockedOn = s, r$3.unstable_runWithPriority(a.priority, function() {
            yc($);
          });
          return;
        }
      } else if (s === 3 && $.stateNode.hydrate) {
        a.blockedOn = $.tag === 3 ? $.stateNode.containerInfo : null;
        return;
      }
    }
  }
  a.blockedOn = null;
}
function Qc(a) {
  if (a.blockedOn !== null)
    return !1;
  var s = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
  if (s !== null) {
    var $ = Nc(s);
    return $ !== null && xc($), a.blockedOn = s, !1;
  }
  return !0;
}
function Sc(a, s, $) {
  Qc(a) && $.delete(s);
}
function Tc() {
  for (zc = !1; 0 < Ac.length; ) {
    var a = Ac[0];
    if (a.blockedOn !== null) {
      a = Nc(a.blockedOn), a !== null && wc(a);
      break;
    }
    var s = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    s !== null ? a.blockedOn = s : Ac.shift();
  }
  Bc !== null && Qc(Bc) && (Bc = null), Cc !== null && Qc(Cc) && (Cc = null), Dc !== null && Qc(Dc) && (Dc = null), Ec.forEach(Sc), Fc.forEach(Sc);
}
function Uc(a, s) {
  a.blockedOn === s && (a.blockedOn = null, zc || (zc = !0, r$3.unstable_scheduleCallback(r$3.unstable_NormalPriority, Tc)));
}
function Vc(a) {
  function s(_e) {
    return Uc(_e, a);
  }
  if (0 < Ac.length) {
    Uc(Ac[0], a);
    for (var $ = 1; $ < Ac.length; $++) {
      var _ = Ac[$];
      _.blockedOn === a && (_.blockedOn = null);
    }
  }
  for (Bc !== null && Uc(Bc, a), Cc !== null && Uc(Cc, a), Dc !== null && Uc(Dc, a), Ec.forEach(s), Fc.forEach(s), $ = 0; $ < Gc.length; $++)
    _ = Gc[$], _.blockedOn === a && (_.blockedOn = null);
  for (; 0 < Gc.length && ($ = Gc[0], $.blockedOn === null); )
    Pc($), $.blockedOn === null && Gc.shift();
}
var Wc = {}, Yc = /* @__PURE__ */ new Map(), Zc = /* @__PURE__ */ new Map(), $c = [
  "abort",
  "abort",
  Xb,
  "animationEnd",
  Yb,
  "animationIteration",
  Zb,
  "animationStart",
  "canplay",
  "canPlay",
  "canplaythrough",
  "canPlayThrough",
  "durationchange",
  "durationChange",
  "emptied",
  "emptied",
  "encrypted",
  "encrypted",
  "ended",
  "ended",
  "error",
  "error",
  "gotpointercapture",
  "gotPointerCapture",
  "load",
  "load",
  "loadeddata",
  "loadedData",
  "loadedmetadata",
  "loadedMetadata",
  "loadstart",
  "loadStart",
  "lostpointercapture",
  "lostPointerCapture",
  "playing",
  "playing",
  "progress",
  "progress",
  "seeking",
  "seeking",
  "stalled",
  "stalled",
  "suspend",
  "suspend",
  "timeupdate",
  "timeUpdate",
  $b,
  "transitionEnd",
  "waiting",
  "waiting"
];
function ad(a, s) {
  for (var $ = 0; $ < a.length; $ += 2) {
    var _ = a[$], _e = a[$ + 1], tt = "on" + (_e[0].toUpperCase() + _e.slice(1));
    tt = { phasedRegistrationNames: { bubbled: tt, captured: tt + "Capture" }, dependencies: [_], eventPriority: s }, Zc.set(_, s), Yc.set(_, tt), Wc[_e] = tt;
  }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for (var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)
  Zc.set(bd[cd], 0);
var dd = r$3.unstable_UserBlockingPriority, ed = r$3.unstable_runWithPriority, fd = !0;
function F(a, s) {
  vc(s, a, !1);
}
function vc(a, s, $) {
  var _ = Zc.get(s);
  switch (_ === void 0 ? 2 : _) {
    case 0:
      _ = gd.bind(null, s, 1, a);
      break;
    case 1:
      _ = hd.bind(null, s, 1, a);
      break;
    default:
      _ = id$2.bind(null, s, 1, a);
  }
  $ ? a.addEventListener(s, _, !0) : a.addEventListener(s, _, !1);
}
function gd(a, s, $, _) {
  Ja || Ha();
  var _e = id$2, tt = Ja;
  Ja = !0;
  try {
    Ga(_e, a, s, $, _);
  } finally {
    (Ja = tt) || La();
  }
}
function hd(a, s, $, _) {
  ed(dd, id$2.bind(null, a, s, $, _));
}
function id$2(a, s, $, _) {
  if (fd)
    if (0 < Ac.length && -1 < Hc.indexOf(a))
      a = Kc(null, a, s, $, _), Ac.push(a);
    else {
      var _e = Rc(a, s, $, _);
      if (_e === null)
        Lc(a, _);
      else if (-1 < Hc.indexOf(a))
        a = Kc(_e, a, s, $, _), Ac.push(a);
      else if (!Oc(_e, a, s, $, _)) {
        Lc(a, _), a = rc(a, _, null, s);
        try {
          Ma(sc, a);
        } finally {
          qc(a);
        }
      }
    }
}
function Rc(a, s, $, _) {
  if ($ = nc(_), $ = tc($), $ !== null) {
    var _e = dc($);
    if (_e === null)
      $ = null;
    else {
      var tt = _e.tag;
      if (tt === 13) {
        if ($ = ec(_e), $ !== null)
          return $;
        $ = null;
      } else if (tt === 3) {
        if (_e.stateNode.hydrate)
          return _e.tag === 3 ? _e.stateNode.containerInfo : null;
        $ = null;
      } else
        _e !== $ && ($ = null);
    }
  }
  a = rc(a, _, $, s);
  try {
    Ma(sc, a);
  } finally {
    qc(a);
  }
  return null;
}
var jd = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, kd = ["Webkit", "ms", "Moz", "O"];
Object.keys(jd).forEach(function(a) {
  kd.forEach(function(s) {
    s = s + a.charAt(0).toUpperCase() + a.substring(1), jd[s] = jd[a];
  });
});
function ld(a, s, $) {
  return s == null || typeof s == "boolean" || s === "" ? "" : $ || typeof s != "number" || s === 0 || jd.hasOwnProperty(a) && jd[a] ? ("" + s).trim() : s + "px";
}
function md(a, s) {
  a = a.style;
  for (var $ in s)
    if (s.hasOwnProperty($)) {
      var _ = $.indexOf("--") === 0, _e = ld($, s[$], _);
      $ === "float" && ($ = "cssFloat"), _ ? a.setProperty($, _e) : a[$] = _e;
    }
}
var nd = n$4({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function od(a, s) {
  if (s) {
    if (nd[a] && (s.children != null || s.dangerouslySetInnerHTML != null))
      throw Error(u$3(137, a, ""));
    if (s.dangerouslySetInnerHTML != null) {
      if (s.children != null)
        throw Error(u$3(60));
      if (!(typeof s.dangerouslySetInnerHTML == "object" && "__html" in s.dangerouslySetInnerHTML))
        throw Error(u$3(61));
    }
    if (s.style != null && typeof s.style != "object")
      throw Error(u$3(62, ""));
  }
}
function pd(a, s) {
  if (a.indexOf("-") === -1)
    return typeof s.is == "string";
  switch (a) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var qd = Mb.html;
function rd(a, s) {
  a = a.nodeType === 9 || a.nodeType === 11 ? a : a.ownerDocument;
  var $ = cc(a);
  s = wa[s];
  for (var _ = 0; _ < s.length; _++)
    uc(s[_], a, $);
}
function sd() {
}
function td(a) {
  if (a = a || (typeof document < "u" ? document : void 0), typeof a > "u")
    return null;
  try {
    return a.activeElement || a.body;
  } catch {
    return a.body;
  }
}
function ud(a) {
  for (; a && a.firstChild; )
    a = a.firstChild;
  return a;
}
function vd(a, s) {
  var $ = ud(a);
  a = 0;
  for (var _; $; ) {
    if ($.nodeType === 3) {
      if (_ = a + $.textContent.length, a <= s && _ >= s)
        return { node: $, offset: s - a };
      a = _;
    }
    e: {
      for (; $; ) {
        if ($.nextSibling) {
          $ = $.nextSibling;
          break e;
        }
        $ = $.parentNode;
      }
      $ = void 0;
    }
    $ = ud($);
  }
}
function wd(a, s) {
  return a && s ? a === s ? !0 : a && a.nodeType === 3 ? !1 : s && s.nodeType === 3 ? wd(a, s.parentNode) : "contains" in a ? a.contains(s) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(s) & 16) : !1 : !1;
}
function xd() {
  for (var a = window, s = td(); s instanceof a.HTMLIFrameElement; ) {
    try {
      var $ = typeof s.contentWindow.location.href == "string";
    } catch {
      $ = !1;
    }
    if ($)
      a = s.contentWindow;
    else
      break;
    s = td(a.document);
  }
  return s;
}
function yd(a) {
  var s = a && a.nodeName && a.nodeName.toLowerCase();
  return s && (s === "input" && (a.type === "text" || a.type === "search" || a.type === "tel" || a.type === "url" || a.type === "password") || s === "textarea" || a.contentEditable === "true");
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, s) {
  switch (a) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      return !!s.autoFocus;
  }
  return !1;
}
function Gd(a, s) {
  return a === "textarea" || a === "option" || a === "noscript" || typeof s.children == "string" || typeof s.children == "number" || typeof s.dangerouslySetInnerHTML == "object" && s.dangerouslySetInnerHTML !== null && s.dangerouslySetInnerHTML.__html != null;
}
var Hd = typeof setTimeout == "function" ? setTimeout : void 0, Id = typeof clearTimeout == "function" ? clearTimeout : void 0;
function Jd(a) {
  for (; a != null; a = a.nextSibling) {
    var s = a.nodeType;
    if (s === 1 || s === 3)
      break;
  }
  return a;
}
function Kd(a) {
  a = a.previousSibling;
  for (var s = 0; a; ) {
    if (a.nodeType === 8) {
      var $ = a.data;
      if ($ === zd || $ === Cd || $ === Bd) {
        if (s === 0)
          return a;
        s--;
      } else
        $ === Ad && s++;
    }
    a = a.previousSibling;
  }
  return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
  var s = a[Md];
  if (s)
    return s;
  for (var $ = a.parentNode; $; ) {
    if (s = $[Od] || $[Md]) {
      if ($ = s.alternate, s.child !== null || $ !== null && $.child !== null)
        for (a = Kd(a); a !== null; ) {
          if ($ = a[Md])
            return $;
          a = Kd(a);
        }
      return s;
    }
    a = $, $ = a.parentNode;
  }
  return null;
}
function Nc(a) {
  return a = a[Md] || a[Od], !a || a.tag !== 5 && a.tag !== 6 && a.tag !== 13 && a.tag !== 3 ? null : a;
}
function Pd(a) {
  if (a.tag === 5 || a.tag === 6)
    return a.stateNode;
  throw Error(u$3(33));
}
function Qd(a) {
  return a[Nd] || null;
}
function Rd(a) {
  do
    a = a.return;
  while (a && a.tag !== 5);
  return a || null;
}
function Sd(a, s) {
  var $ = a.stateNode;
  if (!$)
    return null;
  var _ = la($);
  if (!_)
    return null;
  $ = _[s];
  e:
    switch (s) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (_ = !_.disabled) || (a = a.type, _ = !(a === "button" || a === "input" || a === "select" || a === "textarea")), a = !_;
        break e;
      default:
        a = !1;
    }
  if (a)
    return null;
  if ($ && typeof $ != "function")
    throw Error(u$3(
      231,
      s,
      typeof $
    ));
  return $;
}
function Td(a, s, $) {
  (s = Sd(a, $.dispatchConfig.phasedRegistrationNames[s])) && ($._dispatchListeners = ic($._dispatchListeners, s), $._dispatchInstances = ic($._dispatchInstances, a));
}
function Ud(a) {
  if (a && a.dispatchConfig.phasedRegistrationNames) {
    for (var s = a._targetInst, $ = []; s; )
      $.push(s), s = Rd(s);
    for (s = $.length; 0 < s--; )
      Td($[s], "captured", a);
    for (s = 0; s < $.length; s++)
      Td($[s], "bubbled", a);
  }
}
function Vd(a, s, $) {
  a && $ && $.dispatchConfig.registrationName && (s = Sd(a, $.dispatchConfig.registrationName)) && ($._dispatchListeners = ic($._dispatchListeners, s), $._dispatchInstances = ic($._dispatchInstances, a));
}
function Wd(a) {
  a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
  jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
  if ($d)
    return $d;
  var a, s = Zd, $ = s.length, _, _e = "value" in Yd ? Yd.value : Yd.textContent, tt = _e.length;
  for (a = 0; a < $ && s[a] === _e[a]; a++)
    ;
  var nt = $ - a;
  for (_ = 1; _ <= nt && s[$ - _] === _e[tt - _]; _++)
    ;
  return $d = _e.slice(a, 1 < _ ? 1 - _ : void 0);
}
function be() {
  return !0;
}
function ce() {
  return !1;
}
function G(a, s, $, _) {
  this.dispatchConfig = a, this._targetInst = s, this.nativeEvent = $, a = this.constructor.Interface;
  for (var _e in a)
    a.hasOwnProperty(_e) && ((s = a[_e]) ? this[_e] = s($) : _e === "target" ? this.target = _ : this[_e] = $[_e]);
  return this.isDefaultPrevented = ($.defaultPrevented != null ? $.defaultPrevented : $.returnValue === !1) ? be : ce, this.isPropagationStopped = ce, this;
}
n$4(G.prototype, { preventDefault: function() {
  this.defaultPrevented = !0;
  var a = this.nativeEvent;
  a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue != "unknown" && (a.returnValue = !1), this.isDefaultPrevented = be);
}, stopPropagation: function() {
  var a = this.nativeEvent;
  a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble != "unknown" && (a.cancelBubble = !0), this.isPropagationStopped = be);
}, persist: function() {
  this.isPersistent = be;
}, isPersistent: ce, destructor: function() {
  var a = this.constructor.Interface, s;
  for (s in a)
    this[s] = null;
  this.nativeEvent = this._targetInst = this.dispatchConfig = null, this.isPropagationStopped = this.isDefaultPrevented = ce, this._dispatchInstances = this._dispatchListeners = null;
} });
G.Interface = { type: null, target: null, currentTarget: function() {
  return null;
}, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function(a) {
  return a.timeStamp || Date.now();
}, defaultPrevented: null, isTrusted: null };
G.extend = function(a) {
  function s() {
  }
  function $() {
    return _.apply(this, arguments);
  }
  var _ = this;
  s.prototype = _.prototype;
  var _e = new s();
  return n$4(_e, $.prototype), $.prototype = _e, $.prototype.constructor = $, $.Interface = n$4({}, _.Interface, a), $.extend = _.extend, de($), $;
};
de(G);
function ee(a, s, $, _) {
  if (this.eventPool.length) {
    var _e = this.eventPool.pop();
    return this.call(_e, a, s, $, _), _e;
  }
  return new this(a, s, $, _);
}
function fe(a) {
  if (!(a instanceof this))
    throw Error(u$3(279));
  a.destructor(), 10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
  a.eventPool = [], a.getPooled = ee, a.release = fe;
}
var ge = G.extend({ data: null }), he = G.extend({ data: null }), ie = [9, 13, 27, 32], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = " ", oe = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["compositionend", "keypress", "textInput", "paste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ") }, compositionStart: { phasedRegistrationNames: {
  bubbled: "onCompositionStart",
  captured: "onCompositionStartCapture"
}, dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ") } }, pe = !1;
function qe(a, s) {
  switch (a) {
    case "keyup":
      return ie.indexOf(s.keyCode) !== -1;
    case "keydown":
      return s.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "blur":
      return !0;
    default:
      return !1;
  }
}
function re$1(a) {
  return a = a.detail, typeof a == "object" && "data" in a ? a.data : null;
}
var se = !1;
function te(a, s) {
  switch (a) {
    case "compositionend":
      return re$1(s);
    case "keypress":
      return s.which !== 32 ? null : (pe = !0, ne);
    case "textInput":
      return a = s.data, a === ne && pe ? null : a;
    default:
      return null;
  }
}
function ue(a, s) {
  if (se)
    return a === "compositionend" || !je && qe(a, s) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
  switch (a) {
    case "paste":
      return null;
    case "keypress":
      if (!(s.ctrlKey || s.altKey || s.metaKey) || s.ctrlKey && s.altKey) {
        if (s.char && 1 < s.char.length)
          return s.char;
        if (s.which)
          return String.fromCharCode(s.which);
      }
      return null;
    case "compositionend":
      return me && s.locale !== "ko" ? null : s.data;
    default:
      return null;
  }
}
var ve = { eventTypes: oe, extractEvents: function(a, s, $, _) {
  var _e;
  if (je)
    e: {
      switch (a) {
        case "compositionstart":
          var tt = oe.compositionStart;
          break e;
        case "compositionend":
          tt = oe.compositionEnd;
          break e;
        case "compositionupdate":
          tt = oe.compositionUpdate;
          break e;
      }
      tt = void 0;
    }
  else
    se ? qe(a, $) && (tt = oe.compositionEnd) : a === "keydown" && $.keyCode === 229 && (tt = oe.compositionStart);
  return tt ? (me && $.locale !== "ko" && (se || tt !== oe.compositionStart ? tt === oe.compositionEnd && se && (_e = ae()) : (Yd = _, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), tt = ge.getPooled(
    tt,
    s,
    $,
    _
  ), _e ? tt.data = _e : (_e = re$1($), _e !== null && (tt.data = _e)), Xd(tt), _e = tt) : _e = null, (a = le ? te(a, $) : ue(a, $)) ? (s = he.getPooled(oe.beforeInput, s, $, _), s.data = a, Xd(s)) : s = null, _e === null ? s : s === null ? _e : [_e, s];
} }, we = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
function xe(a) {
  var s = a && a.nodeName && a.nodeName.toLowerCase();
  return s === "input" ? !!we[a.type] : s === "textarea";
}
var ye = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "blur change click focus input keydown keyup selectionchange".split(" ") } };
function ze(a, s, $) {
  return a = G.getPooled(ye.change, a, s, $), a.type = "change", Da($), Xd(a), a;
}
var Ae = null, Be = null;
function Ce(a) {
  mc(a);
}
function De(a) {
  var s = Pd(a);
  if (yb(s))
    return a;
}
function Ee(a, s) {
  if (a === "change")
    return s;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
  Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
  if (a.propertyName === "value" && De(Be))
    if (a = ze(Be, a, nc(a)), Ja)
      mc(a);
    else {
      Ja = !0;
      try {
        Fa(Ce, a);
      } finally {
        Ja = !1, La();
      }
    }
}
function Ie(a, s, $) {
  a === "focus" ? (Ge(), Ae = s, Be = $, Ae.attachEvent("onpropertychange", He)) : a === "blur" && Ge();
}
function Je(a) {
  if (a === "selectionchange" || a === "keyup" || a === "keydown")
    return De(Be);
}
function Ke(a, s) {
  if (a === "click")
    return De(s);
}
function Le(a, s) {
  if (a === "input" || a === "change")
    return De(s);
}
var Me = { eventTypes: ye, _isInputEventSupported: Fe, extractEvents: function(a, s, $, _) {
  var _e = s ? Pd(s) : window, tt = _e.nodeName && _e.nodeName.toLowerCase();
  if (tt === "select" || tt === "input" && _e.type === "file")
    var nt = Ee;
  else if (xe(_e))
    if (Fe)
      nt = Le;
    else {
      nt = Je;
      var at = Ie;
    }
  else
    (tt = _e.nodeName) && tt.toLowerCase() === "input" && (_e.type === "checkbox" || _e.type === "radio") && (nt = Ke);
  if (nt && (nt = nt(a, s)))
    return ze(nt, $, _);
  at && at(a, _e, s), a === "blur" && (a = _e._wrapperState) && a.controlled && _e.type === "number" && Db(_e, "number", _e.value);
} }, Ne = G.extend({ view: null, detail: null }), Oe = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Pe(a) {
  var s = this.nativeEvent;
  return s.getModifierState ? s.getModifierState(a) : (a = Oe[a]) ? !!s[a] : !1;
}
function Qe() {
  return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: Qe, button: null, buttons: null, relatedTarget: function(a) {
  return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
}, movementX: function(a) {
  if ("movementX" in a)
    return a.movementX;
  var s = Re;
  return Re = a.screenX, Te ? a.type === "mousemove" ? a.screenX - s : 0 : (Te = !0, 0);
}, movementY: function(a) {
  if ("movementY" in a)
    return a.movementY;
  var s = Se;
  return Se = a.screenY, Ue ? a.type === "mousemove" ? a.screenY - s : 0 : (Ue = !0, 0);
} }), We = Ve.extend({ pointerId: null, width: null, height: null, pressure: null, tangentialPressure: null, tiltX: null, tiltY: null, twist: null, pointerType: null, isPrimary: null }), Xe = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["mouseout", "mouseover"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["mouseout", "mouseover"] }, pointerEnter: { registrationName: "onPointerEnter", dependencies: ["pointerout", "pointerover"] }, pointerLeave: {
  registrationName: "onPointerLeave",
  dependencies: ["pointerout", "pointerover"]
} }, Ye = { eventTypes: Xe, extractEvents: function(a, s, $, _, _e) {
  var tt = a === "mouseover" || a === "pointerover", nt = a === "mouseout" || a === "pointerout";
  if (tt && !(_e & 32) && ($.relatedTarget || $.fromElement) || !nt && !tt)
    return null;
  if (tt = _.window === _ ? _ : (tt = _.ownerDocument) ? tt.defaultView || tt.parentWindow : window, nt) {
    if (nt = s, s = (s = $.relatedTarget || $.toElement) ? tc(s) : null, s !== null) {
      var at = dc(s);
      (s !== at || s.tag !== 5 && s.tag !== 6) && (s = null);
    }
  } else
    nt = null;
  if (nt === s)
    return null;
  if (a === "mouseout" || a === "mouseover")
    var ot = Ve, rt = Xe.mouseLeave, st = Xe.mouseEnter, lt = "mouse";
  else
    (a === "pointerout" || a === "pointerover") && (ot = We, rt = Xe.pointerLeave, st = Xe.pointerEnter, lt = "pointer");
  if (a = nt == null ? tt : Pd(nt), tt = s == null ? tt : Pd(s), rt = ot.getPooled(rt, nt, $, _), rt.type = lt + "leave", rt.target = a, rt.relatedTarget = tt, $ = ot.getPooled(st, s, $, _), $.type = lt + "enter", $.target = tt, $.relatedTarget = a, _ = nt, lt = s, _ && lt)
    e: {
      for (ot = _, st = lt, nt = 0, a = ot; a; a = Rd(a))
        nt++;
      for (a = 0, s = st; s; s = Rd(s))
        a++;
      for (; 0 < nt - a; )
        ot = Rd(ot), nt--;
      for (; 0 < a - nt; )
        st = Rd(st), a--;
      for (; nt--; ) {
        if (ot === st || ot === st.alternate)
          break e;
        ot = Rd(ot), st = Rd(st);
      }
      ot = null;
    }
  else
    ot = null;
  for (st = ot, ot = []; _ && _ !== st && (nt = _.alternate, !(nt !== null && nt === st)); )
    ot.push(_), _ = Rd(_);
  for (_ = []; lt && lt !== st && (nt = lt.alternate, !(nt !== null && nt === st)); )
    _.push(lt), lt = Rd(lt);
  for (lt = 0; lt < ot.length; lt++)
    Vd(ot[lt], "bubbled", rt);
  for (lt = _.length; 0 < lt--; )
    Vd(_[lt], "captured", $);
  return _e & 64 ? [rt, $] : [rt];
} };
function Ze(a, s) {
  return a === s && (a !== 0 || 1 / a === 1 / s) || a !== a && s !== s;
}
var $e = typeof Object.is == "function" ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, s) {
  if ($e(a, s))
    return !0;
  if (typeof a != "object" || a === null || typeof s != "object" || s === null)
    return !1;
  var $ = Object.keys(a), _ = Object.keys(s);
  if ($.length !== _.length)
    return !1;
  for (_ = 0; _ < $.length; _++)
    if (!af.call(s, $[_]) || !$e(a[$[_]], s[$[_]]))
      return !1;
  return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ") } }, ef = null, ff = null, gf = null, hf = !1;
function jf(a, s) {
  var $ = s.window === s ? s.document : s.nodeType === 9 ? s : s.ownerDocument;
  return hf || ef == null || ef !== td($) ? null : ($ = ef, "selectionStart" in $ && yd($) ? $ = { start: $.selectionStart, end: $.selectionEnd } : ($ = ($.ownerDocument && $.ownerDocument.defaultView || window).getSelection(), $ = { anchorNode: $.anchorNode, anchorOffset: $.anchorOffset, focusNode: $.focusNode, focusOffset: $.focusOffset }), gf && bf(gf, $) ? null : (gf = $, a = G.getPooled(df.select, ff, a, s), a.type = "select", a.target = ef, Xd(a), a));
}
var kf = { eventTypes: df, extractEvents: function(a, s, $, _, _e, tt) {
  if (_e = tt || (_.window === _ ? _.document : _.nodeType === 9 ? _ : _.ownerDocument), !(tt = !_e)) {
    e: {
      _e = cc(_e), tt = wa.onSelect;
      for (var nt = 0; nt < tt.length; nt++)
        if (!_e.has(tt[nt])) {
          _e = !1;
          break e;
        }
      _e = !0;
    }
    tt = !_e;
  }
  if (tt)
    return null;
  switch (_e = s ? Pd(s) : window, a) {
    case "focus":
      (xe(_e) || _e.contentEditable === "true") && (ef = _e, ff = s, gf = null);
      break;
    case "blur":
      gf = ff = ef = null;
      break;
    case "mousedown":
      hf = !0;
      break;
    case "contextmenu":
    case "mouseup":
    case "dragend":
      return hf = !1, jf($, _);
    case "selectionchange":
      if (cf)
        break;
    case "keydown":
    case "keyup":
      return jf($, _);
  }
  return null;
} }, lf = G.extend({ animationName: null, elapsedTime: null, pseudoElement: null }), mf = G.extend({ clipboardData: function(a) {
  return "clipboardData" in a ? a.clipboardData : window.clipboardData;
} }), nf = Ne.extend({ relatedTarget: null });
function of(a) {
  var s = a.keyCode;
  return "charCode" in a ? (a = a.charCode, a === 0 && s === 13 && (a = 13)) : a = s, a === 10 && (a = 13), 32 <= a || a === 13 ? a : 0;
}
var pf = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" }, qf = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, rf = Ne.extend({ key: function(a) {
  if (a.key) {
    var s = pf[a.key] || a.key;
    if (s !== "Unidentified")
      return s;
  }
  return a.type === "keypress" ? (a = of(a), a === 13 ? "Enter" : String.fromCharCode(a)) : a.type === "keydown" || a.type === "keyup" ? qf[a.keyCode] || "Unidentified" : "";
}, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: Qe, charCode: function(a) {
  return a.type === "keypress" ? of(a) : 0;
}, keyCode: function(a) {
  return a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
}, which: function(a) {
  return a.type === "keypress" ? of(a) : a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
} }), sf = Ve.extend({ dataTransfer: null }), tf = Ne.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: Qe }), uf = G.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }), vf = Ve.extend({ deltaX: function(a) {
  return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
}, deltaY: function(a) {
  return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
}, deltaZ: null, deltaMode: null }), wf = { eventTypes: Wc, extractEvents: function(a, s, $, _) {
  var _e = Yc.get(a);
  if (!_e)
    return null;
  switch (a) {
    case "keypress":
      if (of($) === 0)
        return null;
    case "keydown":
    case "keyup":
      a = rf;
      break;
    case "blur":
    case "focus":
      a = nf;
      break;
    case "click":
      if ($.button === 2)
        return null;
    case "auxclick":
    case "dblclick":
    case "mousedown":
    case "mousemove":
    case "mouseup":
    case "mouseout":
    case "mouseover":
    case "contextmenu":
      a = Ve;
      break;
    case "drag":
    case "dragend":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "dragstart":
    case "drop":
      a = sf;
      break;
    case "touchcancel":
    case "touchend":
    case "touchmove":
    case "touchstart":
      a = tf;
      break;
    case Xb:
    case Yb:
    case Zb:
      a = lf;
      break;
    case $b:
      a = uf;
      break;
    case "scroll":
      a = Ne;
      break;
    case "wheel":
      a = vf;
      break;
    case "copy":
    case "cut":
    case "paste":
      a = mf;
      break;
    case "gotpointercapture":
    case "lostpointercapture":
    case "pointercancel":
    case "pointerdown":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "pointerup":
      a = We;
      break;
    default:
      a = G;
  }
  return s = a.getPooled(_e, s, $, _), Xd(s), s;
} };
if (pa)
  throw Error(u$3(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({ SimpleEventPlugin: wf, EnterLeaveEventPlugin: Ye, ChangeEventPlugin: Me, SelectEventPlugin: kf, BeforeInputEventPlugin: ve });
var yf = [], zf = -1;
function H(a) {
  0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, s) {
  zf++, yf[zf] = a.current, a.current = s;
}
var Af = {}, J = { current: Af }, K = { current: !1 }, Bf = Af;
function Cf(a, s) {
  var $ = a.type.contextTypes;
  if (!$)
    return Af;
  var _ = a.stateNode;
  if (_ && _.__reactInternalMemoizedUnmaskedChildContext === s)
    return _.__reactInternalMemoizedMaskedChildContext;
  var _e = {}, tt;
  for (tt in $)
    _e[tt] = s[tt];
  return _ && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = s, a.__reactInternalMemoizedMaskedChildContext = _e), _e;
}
function L(a) {
  return a = a.childContextTypes, a != null;
}
function Df() {
  H(K), H(J);
}
function Ef(a, s, $) {
  if (J.current !== Af)
    throw Error(u$3(168));
  I(J, s), I(K, $);
}
function Ff(a, s, $) {
  var _ = a.stateNode;
  if (a = s.childContextTypes, typeof _.getChildContext != "function")
    return $;
  _ = _.getChildContext();
  for (var _e in _)
    if (!(_e in a))
      throw Error(u$3(108, pb(s) || "Unknown", _e));
  return n$4({}, $, {}, _);
}
function Gf(a) {
  return a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af, Bf = J.current, I(J, a), I(K, K.current), !0;
}
function Hf(a, s, $) {
  var _ = a.stateNode;
  if (!_)
    throw Error(u$3(169));
  $ ? (a = Ff(a, s, Bf), _.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K), I(K, $);
}
var If = r$3.unstable_runWithPriority, Jf = r$3.unstable_scheduleCallback, Kf = r$3.unstable_cancelCallback, Lf = r$3.unstable_requestPaint, Mf = r$3.unstable_now, Nf = r$3.unstable_getCurrentPriorityLevel, Of = r$3.unstable_ImmediatePriority, Pf = r$3.unstable_UserBlockingPriority, Qf = r$3.unstable_NormalPriority, Rf = r$3.unstable_LowPriority, Sf = r$3.unstable_IdlePriority, Tf = {}, Uf = r$3.unstable_shouldYield, Vf = Lf !== void 0 ? Lf : function() {
}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1e4 > Zf ? Mf : function() {
  return Mf() - Zf;
};
function ag() {
  switch (Nf()) {
    case Of:
      return 99;
    case Pf:
      return 98;
    case Qf:
      return 97;
    case Rf:
      return 96;
    case Sf:
      return 95;
    default:
      throw Error(u$3(332));
  }
}
function bg(a) {
  switch (a) {
    case 99:
      return Of;
    case 98:
      return Pf;
    case 97:
      return Qf;
    case 96:
      return Rf;
    case 95:
      return Sf;
    default:
      throw Error(u$3(332));
  }
}
function cg(a, s) {
  return a = bg(a), If(a, s);
}
function dg(a, s, $) {
  return a = bg(a), Jf(a, s, $);
}
function eg(a) {
  return Wf === null ? (Wf = [a], Xf = Jf(Of, fg)) : Wf.push(a), Tf;
}
function gg() {
  if (Xf !== null) {
    var a = Xf;
    Xf = null, Kf(a);
  }
  fg();
}
function fg() {
  if (!Yf && Wf !== null) {
    Yf = !0;
    var a = 0;
    try {
      var s = Wf;
      cg(99, function() {
        for (; a < s.length; a++) {
          var $ = s[a];
          do
            $ = $(!0);
          while ($ !== null);
        }
      }), Wf = null;
    } catch ($) {
      throw Wf !== null && (Wf = Wf.slice(a + 1)), Jf(Of, gg), $;
    } finally {
      Yf = !1;
    }
  }
}
function hg(a, s, $) {
  return $ /= 10, 1073741821 - (((1073741821 - a + s / 10) / $ | 0) + 1) * $;
}
function ig(a, s) {
  if (a && a.defaultProps) {
    s = n$4({}, s), a = a.defaultProps;
    for (var $ in a)
      s[$] === void 0 && (s[$] = a[$]);
  }
  return s;
}
var jg = { current: null }, kg = null, lg = null, mg = null;
function ng() {
  mg = lg = kg = null;
}
function og(a) {
  var s = jg.current;
  H(jg), a.type._context._currentValue = s;
}
function pg(a, s) {
  for (; a !== null; ) {
    var $ = a.alternate;
    if (a.childExpirationTime < s)
      a.childExpirationTime = s, $ !== null && $.childExpirationTime < s && ($.childExpirationTime = s);
    else if ($ !== null && $.childExpirationTime < s)
      $.childExpirationTime = s;
    else
      break;
    a = a.return;
  }
}
function qg(a, s) {
  kg = a, mg = lg = null, a = a.dependencies, a !== null && a.firstContext !== null && (a.expirationTime >= s && (rg = !0), a.firstContext = null);
}
function sg(a, s) {
  if (mg !== a && s !== !1 && s !== 0)
    if ((typeof s != "number" || s === 1073741823) && (mg = a, s = 1073741823), s = { context: a, observedBits: s, next: null }, lg === null) {
      if (kg === null)
        throw Error(u$3(308));
      lg = s, kg.dependencies = { expirationTime: 0, firstContext: s, responders: null };
    } else
      lg = lg.next = s;
  return a._currentValue;
}
var tg = !1;
function ug(a) {
  a.updateQueue = { baseState: a.memoizedState, baseQueue: null, shared: { pending: null }, effects: null };
}
function vg(a, s) {
  a = a.updateQueue, s.updateQueue === a && (s.updateQueue = { baseState: a.baseState, baseQueue: a.baseQueue, shared: a.shared, effects: a.effects });
}
function wg(a, s) {
  return a = { expirationTime: a, suspenseConfig: s, tag: 0, payload: null, callback: null, next: null }, a.next = a;
}
function xg(a, s) {
  if (a = a.updateQueue, a !== null) {
    a = a.shared;
    var $ = a.pending;
    $ === null ? s.next = s : (s.next = $.next, $.next = s), a.pending = s;
  }
}
function yg(a, s) {
  var $ = a.alternate;
  $ !== null && vg($, a), a = a.updateQueue, $ = a.baseQueue, $ === null ? (a.baseQueue = s.next = s, s.next = s) : (s.next = $.next, $.next = s);
}
function zg(a, s, $, _) {
  var _e = a.updateQueue;
  tg = !1;
  var tt = _e.baseQueue, nt = _e.shared.pending;
  if (nt !== null) {
    if (tt !== null) {
      var at = tt.next;
      tt.next = nt.next, nt.next = at;
    }
    tt = nt, _e.shared.pending = null, at = a.alternate, at !== null && (at = at.updateQueue, at !== null && (at.baseQueue = nt));
  }
  if (tt !== null) {
    at = tt.next;
    var ot = _e.baseState, rt = 0, st = null, lt = null, et = null;
    if (at !== null) {
      var it = at;
      do {
        if (nt = it.expirationTime, nt < _) {
          var ut = { expirationTime: it.expirationTime, suspenseConfig: it.suspenseConfig, tag: it.tag, payload: it.payload, callback: it.callback, next: null };
          et === null ? (lt = et = ut, st = ot) : et = et.next = ut, nt > rt && (rt = nt);
        } else {
          et !== null && (et = et.next = { expirationTime: 1073741823, suspenseConfig: it.suspenseConfig, tag: it.tag, payload: it.payload, callback: it.callback, next: null }), Ag(nt, it.suspenseConfig);
          e: {
            var ft = a, ht = it;
            switch (nt = s, ut = $, ht.tag) {
              case 1:
                if (ft = ht.payload, typeof ft == "function") {
                  ot = ft.call(ut, ot, nt);
                  break e;
                }
                ot = ft;
                break e;
              case 3:
                ft.effectTag = ft.effectTag & -4097 | 64;
              case 0:
                if (ft = ht.payload, nt = typeof ft == "function" ? ft.call(ut, ot, nt) : ft, nt == null)
                  break e;
                ot = n$4({}, ot, nt);
                break e;
              case 2:
                tg = !0;
            }
          }
          it.callback !== null && (a.effectTag |= 32, nt = _e.effects, nt === null ? _e.effects = [it] : nt.push(it));
        }
        if (it = it.next, it === null || it === at) {
          if (nt = _e.shared.pending, nt === null)
            break;
          it = tt.next = nt.next, nt.next = at, _e.baseQueue = tt = nt, _e.shared.pending = null;
        }
      } while (!0);
    }
    et === null ? st = ot : et.next = lt, _e.baseState = st, _e.baseQueue = et, Bg(rt), a.expirationTime = rt, a.memoizedState = ot;
  }
}
function Cg(a, s, $) {
  if (a = s.effects, s.effects = null, a !== null)
    for (s = 0; s < a.length; s++) {
      var _ = a[s], _e = _.callback;
      if (_e !== null) {
        if (_.callback = null, _ = _e, _e = $, typeof _ != "function")
          throw Error(u$3(191, _));
        _.call(_e);
      }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = new aa.Component().refs;
function Fg(a, s, $, _) {
  s = a.memoizedState, $ = $(_, s), $ = $ == null ? s : n$4({}, s, $), a.memoizedState = $, a.expirationTime === 0 && (a.updateQueue.baseState = $);
}
var Jg = { isMounted: function(a) {
  return (a = a._reactInternalFiber) ? dc(a) === a : !1;
}, enqueueSetState: function(a, s, $) {
  a = a._reactInternalFiber;
  var _ = Gg(), _e = Dg.suspense;
  _ = Hg(_, a, _e), _e = wg(_, _e), _e.payload = s, $ != null && (_e.callback = $), xg(a, _e), Ig(a, _);
}, enqueueReplaceState: function(a, s, $) {
  a = a._reactInternalFiber;
  var _ = Gg(), _e = Dg.suspense;
  _ = Hg(_, a, _e), _e = wg(_, _e), _e.tag = 1, _e.payload = s, $ != null && (_e.callback = $), xg(a, _e), Ig(a, _);
}, enqueueForceUpdate: function(a, s) {
  a = a._reactInternalFiber;
  var $ = Gg(), _ = Dg.suspense;
  $ = Hg($, a, _), _ = wg($, _), _.tag = 2, s != null && (_.callback = s), xg(a, _), Ig(a, $);
} };
function Kg(a, s, $, _, _e, tt, nt) {
  return a = a.stateNode, typeof a.shouldComponentUpdate == "function" ? a.shouldComponentUpdate(_, tt, nt) : s.prototype && s.prototype.isPureReactComponent ? !bf($, _) || !bf(_e, tt) : !0;
}
function Lg(a, s, $) {
  var _ = !1, _e = Af, tt = s.contextType;
  return typeof tt == "object" && tt !== null ? tt = sg(tt) : (_e = L(s) ? Bf : J.current, _ = s.contextTypes, tt = (_ = _ != null) ? Cf(a, _e) : Af), s = new s($, tt), a.memoizedState = s.state !== null && s.state !== void 0 ? s.state : null, s.updater = Jg, a.stateNode = s, s._reactInternalFiber = a, _ && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = _e, a.__reactInternalMemoizedMaskedChildContext = tt), s;
}
function Mg(a, s, $, _) {
  a = s.state, typeof s.componentWillReceiveProps == "function" && s.componentWillReceiveProps($, _), typeof s.UNSAFE_componentWillReceiveProps == "function" && s.UNSAFE_componentWillReceiveProps($, _), s.state !== a && Jg.enqueueReplaceState(s, s.state, null);
}
function Ng(a, s, $, _) {
  var _e = a.stateNode;
  _e.props = $, _e.state = a.memoizedState, _e.refs = Eg, ug(a);
  var tt = s.contextType;
  typeof tt == "object" && tt !== null ? _e.context = sg(tt) : (tt = L(s) ? Bf : J.current, _e.context = Cf(a, tt)), zg(a, $, _e, _), _e.state = a.memoizedState, tt = s.getDerivedStateFromProps, typeof tt == "function" && (Fg(a, s, tt, $), _e.state = a.memoizedState), typeof s.getDerivedStateFromProps == "function" || typeof _e.getSnapshotBeforeUpdate == "function" || typeof _e.UNSAFE_componentWillMount != "function" && typeof _e.componentWillMount != "function" || (s = _e.state, typeof _e.componentWillMount == "function" && _e.componentWillMount(), typeof _e.UNSAFE_componentWillMount == "function" && _e.UNSAFE_componentWillMount(), s !== _e.state && Jg.enqueueReplaceState(_e, _e.state, null), zg(a, $, _e, _), _e.state = a.memoizedState), typeof _e.componentDidMount == "function" && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, s, $) {
  if (a = $.ref, a !== null && typeof a != "function" && typeof a != "object") {
    if ($._owner) {
      if ($ = $._owner, $) {
        if ($.tag !== 1)
          throw Error(u$3(309));
        var _ = $.stateNode;
      }
      if (!_)
        throw Error(u$3(147, a));
      var _e = "" + a;
      return s !== null && s.ref !== null && typeof s.ref == "function" && s.ref._stringRef === _e ? s.ref : (s = function(tt) {
        var nt = _.refs;
        nt === Eg && (nt = _.refs = {}), tt === null ? delete nt[_e] : nt[_e] = tt;
      }, s._stringRef = _e, s);
    }
    if (typeof a != "string")
      throw Error(u$3(284));
    if (!$._owner)
      throw Error(u$3(290, a));
  }
  return a;
}
function Qg(a, s) {
  if (a.type !== "textarea")
    throw Error(u$3(31, Object.prototype.toString.call(s) === "[object Object]" ? "object with keys {" + Object.keys(s).join(", ") + "}" : s, ""));
}
function Rg(a) {
  function s(ht, dt) {
    if (a) {
      var gt = ht.lastEffect;
      gt !== null ? (gt.nextEffect = dt, ht.lastEffect = dt) : ht.firstEffect = ht.lastEffect = dt, dt.nextEffect = null, dt.effectTag = 8;
    }
  }
  function $(ht, dt) {
    if (!a)
      return null;
    for (; dt !== null; )
      s(ht, dt), dt = dt.sibling;
    return null;
  }
  function _(ht, dt) {
    for (ht = /* @__PURE__ */ new Map(); dt !== null; )
      dt.key !== null ? ht.set(dt.key, dt) : ht.set(dt.index, dt), dt = dt.sibling;
    return ht;
  }
  function _e(ht, dt) {
    return ht = Sg(ht, dt), ht.index = 0, ht.sibling = null, ht;
  }
  function tt(ht, dt, gt) {
    return ht.index = gt, a ? (gt = ht.alternate, gt !== null ? (gt = gt.index, gt < dt ? (ht.effectTag = 2, dt) : gt) : (ht.effectTag = 2, dt)) : dt;
  }
  function nt(ht) {
    return a && ht.alternate === null && (ht.effectTag = 2), ht;
  }
  function at(ht, dt, gt, pt) {
    return dt === null || dt.tag !== 6 ? (dt = Tg(gt, ht.mode, pt), dt.return = ht, dt) : (dt = _e(dt, gt), dt.return = ht, dt);
  }
  function ot(ht, dt, gt, pt) {
    return dt !== null && dt.elementType === gt.type ? (pt = _e(dt, gt.props), pt.ref = Pg(ht, dt, gt), pt.return = ht, pt) : (pt = Ug(gt.type, gt.key, gt.props, null, ht.mode, pt), pt.ref = Pg(ht, dt, gt), pt.return = ht, pt);
  }
  function rt(ht, dt, gt, pt) {
    return dt === null || dt.tag !== 4 || dt.stateNode.containerInfo !== gt.containerInfo || dt.stateNode.implementation !== gt.implementation ? (dt = Vg(gt, ht.mode, pt), dt.return = ht, dt) : (dt = _e(dt, gt.children || []), dt.return = ht, dt);
  }
  function st(ht, dt, gt, pt, mt) {
    return dt === null || dt.tag !== 7 ? (dt = Wg(gt, ht.mode, pt, mt), dt.return = ht, dt) : (dt = _e(dt, gt), dt.return = ht, dt);
  }
  function lt(ht, dt, gt) {
    if (typeof dt == "string" || typeof dt == "number")
      return dt = Tg("" + dt, ht.mode, gt), dt.return = ht, dt;
    if (typeof dt == "object" && dt !== null) {
      switch (dt.$$typeof) {
        case Za:
          return gt = Ug(dt.type, dt.key, dt.props, null, ht.mode, gt), gt.ref = Pg(ht, null, dt), gt.return = ht, gt;
        case $a:
          return dt = Vg(dt, ht.mode, gt), dt.return = ht, dt;
      }
      if (Og(dt) || nb(dt))
        return dt = Wg(dt, ht.mode, gt, null), dt.return = ht, dt;
      Qg(ht, dt);
    }
    return null;
  }
  function et(ht, dt, gt, pt) {
    var mt = dt !== null ? dt.key : null;
    if (typeof gt == "string" || typeof gt == "number")
      return mt !== null ? null : at(ht, dt, "" + gt, pt);
    if (typeof gt == "object" && gt !== null) {
      switch (gt.$$typeof) {
        case Za:
          return gt.key === mt ? gt.type === ab ? st(ht, dt, gt.props.children, pt, mt) : ot(ht, dt, gt, pt) : null;
        case $a:
          return gt.key === mt ? rt(ht, dt, gt, pt) : null;
      }
      if (Og(gt) || nb(gt))
        return mt !== null ? null : st(ht, dt, gt, pt, null);
      Qg(ht, gt);
    }
    return null;
  }
  function it(ht, dt, gt, pt, mt) {
    if (typeof pt == "string" || typeof pt == "number")
      return ht = ht.get(gt) || null, at(dt, ht, "" + pt, mt);
    if (typeof pt == "object" && pt !== null) {
      switch (pt.$$typeof) {
        case Za:
          return ht = ht.get(pt.key === null ? gt : pt.key) || null, pt.type === ab ? st(dt, ht, pt.props.children, mt, pt.key) : ot(dt, ht, pt, mt);
        case $a:
          return ht = ht.get(pt.key === null ? gt : pt.key) || null, rt(dt, ht, pt, mt);
      }
      if (Og(pt) || nb(pt))
        return ht = ht.get(gt) || null, st(dt, ht, pt, mt, null);
      Qg(dt, pt);
    }
    return null;
  }
  function ut(ht, dt, gt, pt) {
    for (var mt = null, ct = null, vt = dt, At = dt = 0, xt = null; vt !== null && At < gt.length; At++) {
      vt.index > At ? (xt = vt, vt = null) : xt = vt.sibling;
      var bt = et(ht, vt, gt[At], pt);
      if (bt === null) {
        vt === null && (vt = xt);
        break;
      }
      a && vt && bt.alternate === null && s(ht, vt), dt = tt(bt, dt, At), ct === null ? mt = bt : ct.sibling = bt, ct = bt, vt = xt;
    }
    if (At === gt.length)
      return $(ht, vt), mt;
    if (vt === null) {
      for (; At < gt.length; At++)
        vt = lt(ht, gt[At], pt), vt !== null && (dt = tt(vt, dt, At), ct === null ? mt = vt : ct.sibling = vt, ct = vt);
      return mt;
    }
    for (vt = _(ht, vt); At < gt.length; At++)
      xt = it(vt, ht, At, gt[At], pt), xt !== null && (a && xt.alternate !== null && vt.delete(xt.key === null ? At : xt.key), dt = tt(xt, dt, At), ct === null ? mt = xt : ct.sibling = xt, ct = xt);
    return a && vt.forEach(function(Et) {
      return s(ht, Et);
    }), mt;
  }
  function ft(ht, dt, gt, pt) {
    var mt = nb(gt);
    if (typeof mt != "function")
      throw Error(u$3(150));
    if (gt = mt.call(gt), gt == null)
      throw Error(u$3(151));
    for (var ct = mt = null, vt = dt, At = dt = 0, xt = null, bt = gt.next(); vt !== null && !bt.done; At++, bt = gt.next()) {
      vt.index > At ? (xt = vt, vt = null) : xt = vt.sibling;
      var Et = et(ht, vt, bt.value, pt);
      if (Et === null) {
        vt === null && (vt = xt);
        break;
      }
      a && vt && Et.alternate === null && s(ht, vt), dt = tt(Et, dt, At), ct === null ? mt = Et : ct.sibling = Et, ct = Et, vt = xt;
    }
    if (bt.done)
      return $(ht, vt), mt;
    if (vt === null) {
      for (; !bt.done; At++, bt = gt.next())
        bt = lt(ht, bt.value, pt), bt !== null && (dt = tt(bt, dt, At), ct === null ? mt = bt : ct.sibling = bt, ct = bt);
      return mt;
    }
    for (vt = _(ht, vt); !bt.done; At++, bt = gt.next())
      bt = it(vt, ht, At, bt.value, pt), bt !== null && (a && bt.alternate !== null && vt.delete(bt.key === null ? At : bt.key), dt = tt(bt, dt, At), ct === null ? mt = bt : ct.sibling = bt, ct = bt);
    return a && vt.forEach(function(St) {
      return s(ht, St);
    }), mt;
  }
  return function(ht, dt, gt, pt) {
    var mt = typeof gt == "object" && gt !== null && gt.type === ab && gt.key === null;
    mt && (gt = gt.props.children);
    var ct = typeof gt == "object" && gt !== null;
    if (ct)
      switch (gt.$$typeof) {
        case Za:
          e: {
            for (ct = gt.key, mt = dt; mt !== null; ) {
              if (mt.key === ct) {
                switch (mt.tag) {
                  case 7:
                    if (gt.type === ab) {
                      $(ht, mt.sibling), dt = _e(mt, gt.props.children), dt.return = ht, ht = dt;
                      break e;
                    }
                    break;
                  default:
                    if (mt.elementType === gt.type) {
                      $(
                        ht,
                        mt.sibling
                      ), dt = _e(mt, gt.props), dt.ref = Pg(ht, mt, gt), dt.return = ht, ht = dt;
                      break e;
                    }
                }
                $(ht, mt);
                break;
              } else
                s(ht, mt);
              mt = mt.sibling;
            }
            gt.type === ab ? (dt = Wg(gt.props.children, ht.mode, pt, gt.key), dt.return = ht, ht = dt) : (pt = Ug(gt.type, gt.key, gt.props, null, ht.mode, pt), pt.ref = Pg(ht, dt, gt), pt.return = ht, ht = pt);
          }
          return nt(ht);
        case $a:
          e: {
            for (mt = gt.key; dt !== null; ) {
              if (dt.key === mt)
                if (dt.tag === 4 && dt.stateNode.containerInfo === gt.containerInfo && dt.stateNode.implementation === gt.implementation) {
                  $(ht, dt.sibling), dt = _e(dt, gt.children || []), dt.return = ht, ht = dt;
                  break e;
                } else {
                  $(ht, dt);
                  break;
                }
              else
                s(ht, dt);
              dt = dt.sibling;
            }
            dt = Vg(gt, ht.mode, pt), dt.return = ht, ht = dt;
          }
          return nt(ht);
      }
    if (typeof gt == "string" || typeof gt == "number")
      return gt = "" + gt, dt !== null && dt.tag === 6 ? ($(ht, dt.sibling), dt = _e(dt, gt), dt.return = ht, ht = dt) : ($(ht, dt), dt = Tg(gt, ht.mode, pt), dt.return = ht, ht = dt), nt(ht);
    if (Og(gt))
      return ut(ht, dt, gt, pt);
    if (nb(gt))
      return ft(ht, dt, gt, pt);
    if (ct && Qg(ht, gt), typeof gt > "u" && !mt)
      switch (ht.tag) {
        case 1:
        case 0:
          throw ht = ht.type, Error(u$3(152, ht.displayName || ht.name || "Component"));
      }
    return $(ht, dt);
  };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = { current: Zg }, ah = { current: Zg }, bh = { current: Zg };
function ch(a) {
  if (a === Zg)
    throw Error(u$3(174));
  return a;
}
function dh(a, s) {
  switch (I(bh, s), I(ah, a), I($g, Zg), a = s.nodeType, a) {
    case 9:
    case 11:
      s = (s = s.documentElement) ? s.namespaceURI : Ob(null, "");
      break;
    default:
      a = a === 8 ? s.parentNode : s, s = a.namespaceURI || null, a = a.tagName, s = Ob(s, a);
  }
  H($g), I($g, s);
}
function eh() {
  H($g), H(ah), H(bh);
}
function fh(a) {
  ch(bh.current);
  var s = ch($g.current), $ = Ob(s, a.type);
  s !== $ && (I(ah, a), I($g, $));
}
function gh(a) {
  ah.current === a && (H($g), H(ah));
}
var M = { current: 0 };
function hh(a) {
  for (var s = a; s !== null; ) {
    if (s.tag === 13) {
      var $ = s.memoizedState;
      if ($ !== null && ($ = $.dehydrated, $ === null || $.data === Bd || $.data === Cd))
        return s;
    } else if (s.tag === 19 && s.memoizedProps.revealOrder !== void 0) {
      if (s.effectTag & 64)
        return s;
    } else if (s.child !== null) {
      s.child.return = s, s = s.child;
      continue;
    }
    if (s === a)
      break;
    for (; s.sibling === null; ) {
      if (s.return === null || s.return === a)
        return null;
      s = s.return;
    }
    s.sibling.return = s.return, s = s.sibling;
  }
  return null;
}
function ih(a, s) {
  return { responder: a, props: s };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
  throw Error(u$3(321));
}
function nh(a, s) {
  if (s === null)
    return !1;
  for (var $ = 0; $ < s.length && $ < a.length; $++)
    if (!$e(a[$], s[$]))
      return !1;
  return !0;
}
function oh(a, s, $, _, _e, tt) {
  if (lh = tt, N = s, s.memoizedState = null, s.updateQueue = null, s.expirationTime = 0, jh.current = a === null || a.memoizedState === null ? ph : qh, a = $(_, _e), s.expirationTime === lh) {
    tt = 0;
    do {
      if (s.expirationTime = 0, !(25 > tt))
        throw Error(u$3(301));
      tt += 1, P = O = null, s.updateQueue = null, jh.current = rh, a = $(_, _e);
    } while (s.expirationTime === lh);
  }
  if (jh.current = sh, s = O !== null && O.next !== null, lh = 0, P = O = N = null, mh = !1, s)
    throw Error(u$3(300));
  return a;
}
function th() {
  var a = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return P === null ? N.memoizedState = P = a : P = P.next = a, P;
}
function uh() {
  if (O === null) {
    var a = N.alternate;
    a = a !== null ? a.memoizedState : null;
  } else
    a = O.next;
  var s = P === null ? N.memoizedState : P.next;
  if (s !== null)
    P = s, O = a;
  else {
    if (a === null)
      throw Error(u$3(310));
    O = a, a = { memoizedState: O.memoizedState, baseState: O.baseState, baseQueue: O.baseQueue, queue: O.queue, next: null }, P === null ? N.memoizedState = P = a : P = P.next = a;
  }
  return P;
}
function vh(a, s) {
  return typeof s == "function" ? s(a) : s;
}
function wh(a) {
  var s = uh(), $ = s.queue;
  if ($ === null)
    throw Error(u$3(311));
  $.lastRenderedReducer = a;
  var _ = O, _e = _.baseQueue, tt = $.pending;
  if (tt !== null) {
    if (_e !== null) {
      var nt = _e.next;
      _e.next = tt.next, tt.next = nt;
    }
    _.baseQueue = _e = tt, $.pending = null;
  }
  if (_e !== null) {
    _e = _e.next, _ = _.baseState;
    var at = nt = tt = null, ot = _e;
    do {
      var rt = ot.expirationTime;
      if (rt < lh) {
        var st = { expirationTime: ot.expirationTime, suspenseConfig: ot.suspenseConfig, action: ot.action, eagerReducer: ot.eagerReducer, eagerState: ot.eagerState, next: null };
        at === null ? (nt = at = st, tt = _) : at = at.next = st, rt > N.expirationTime && (N.expirationTime = rt, Bg(rt));
      } else
        at !== null && (at = at.next = { expirationTime: 1073741823, suspenseConfig: ot.suspenseConfig, action: ot.action, eagerReducer: ot.eagerReducer, eagerState: ot.eagerState, next: null }), Ag(rt, ot.suspenseConfig), _ = ot.eagerReducer === a ? ot.eagerState : a(_, ot.action);
      ot = ot.next;
    } while (ot !== null && ot !== _e);
    at === null ? tt = _ : at.next = nt, $e(_, s.memoizedState) || (rg = !0), s.memoizedState = _, s.baseState = tt, s.baseQueue = at, $.lastRenderedState = _;
  }
  return [s.memoizedState, $.dispatch];
}
function xh(a) {
  var s = uh(), $ = s.queue;
  if ($ === null)
    throw Error(u$3(311));
  $.lastRenderedReducer = a;
  var _ = $.dispatch, _e = $.pending, tt = s.memoizedState;
  if (_e !== null) {
    $.pending = null;
    var nt = _e = _e.next;
    do
      tt = a(tt, nt.action), nt = nt.next;
    while (nt !== _e);
    $e(tt, s.memoizedState) || (rg = !0), s.memoizedState = tt, s.baseQueue === null && (s.baseState = tt), $.lastRenderedState = tt;
  }
  return [tt, _];
}
function yh(a) {
  var s = th();
  return typeof a == "function" && (a = a()), s.memoizedState = s.baseState = a, a = s.queue = { pending: null, dispatch: null, lastRenderedReducer: vh, lastRenderedState: a }, a = a.dispatch = zh.bind(null, N, a), [s.memoizedState, a];
}
function Ah(a, s, $, _) {
  return a = { tag: a, create: s, destroy: $, deps: _, next: null }, s = N.updateQueue, s === null ? (s = { lastEffect: null }, N.updateQueue = s, s.lastEffect = a.next = a) : ($ = s.lastEffect, $ === null ? s.lastEffect = a.next = a : (_ = $.next, $.next = a, a.next = _, s.lastEffect = a)), a;
}
function Bh() {
  return uh().memoizedState;
}
function Ch(a, s, $, _) {
  var _e = th();
  N.effectTag |= a, _e.memoizedState = Ah(1 | s, $, void 0, _ === void 0 ? null : _);
}
function Dh(a, s, $, _) {
  var _e = uh();
  _ = _ === void 0 ? null : _;
  var tt = void 0;
  if (O !== null) {
    var nt = O.memoizedState;
    if (tt = nt.destroy, _ !== null && nh(_, nt.deps)) {
      Ah(s, $, tt, _);
      return;
    }
  }
  N.effectTag |= a, _e.memoizedState = Ah(1 | s, $, tt, _);
}
function Eh(a, s) {
  return Ch(516, 4, a, s);
}
function Fh(a, s) {
  return Dh(516, 4, a, s);
}
function Gh(a, s) {
  return Dh(4, 2, a, s);
}
function Hh(a, s) {
  if (typeof s == "function")
    return a = a(), s(a), function() {
      s(null);
    };
  if (s != null)
    return a = a(), s.current = a, function() {
      s.current = null;
    };
}
function Ih(a, s, $) {
  return $ = $ != null ? $.concat([a]) : null, Dh(4, 2, Hh.bind(null, s, a), $);
}
function Jh() {
}
function Kh(a, s) {
  return th().memoizedState = [a, s === void 0 ? null : s], a;
}
function Lh(a, s) {
  var $ = uh();
  s = s === void 0 ? null : s;
  var _ = $.memoizedState;
  return _ !== null && s !== null && nh(s, _[1]) ? _[0] : ($.memoizedState = [a, s], a);
}
function Mh(a, s) {
  var $ = uh();
  s = s === void 0 ? null : s;
  var _ = $.memoizedState;
  return _ !== null && s !== null && nh(s, _[1]) ? _[0] : (a = a(), $.memoizedState = [a, s], a);
}
function Nh(a, s, $) {
  var _ = ag();
  cg(98 > _ ? 98 : _, function() {
    a(!0);
  }), cg(97 < _ ? 97 : _, function() {
    var _e = kh.suspense;
    kh.suspense = s === void 0 ? null : s;
    try {
      a(!1), $();
    } finally {
      kh.suspense = _e;
    }
  });
}
function zh(a, s, $) {
  var _ = Gg(), _e = Dg.suspense;
  _ = Hg(_, a, _e), _e = { expirationTime: _, suspenseConfig: _e, action: $, eagerReducer: null, eagerState: null, next: null };
  var tt = s.pending;
  if (tt === null ? _e.next = _e : (_e.next = tt.next, tt.next = _e), s.pending = _e, tt = a.alternate, a === N || tt !== null && tt === N)
    mh = !0, _e.expirationTime = lh, N.expirationTime = lh;
  else {
    if (a.expirationTime === 0 && (tt === null || tt.expirationTime === 0) && (tt = s.lastRenderedReducer, tt !== null))
      try {
        var nt = s.lastRenderedState, at = tt(nt, $);
        if (_e.eagerReducer = tt, _e.eagerState = at, $e(at, nt))
          return;
      } catch {
      } finally {
      }
    Ig(
      a,
      _
    );
  }
}
var sh = { readContext: sg, useCallback: Q, useContext: Q, useEffect: Q, useImperativeHandle: Q, useLayoutEffect: Q, useMemo: Q, useReducer: Q, useRef: Q, useState: Q, useDebugValue: Q, useResponder: Q, useDeferredValue: Q, useTransition: Q }, ph = { readContext: sg, useCallback: Kh, useContext: sg, useEffect: Eh, useImperativeHandle: function(a, s, $) {
  return $ = $ != null ? $.concat([a]) : null, Ch(4, 2, Hh.bind(null, s, a), $);
}, useLayoutEffect: function(a, s) {
  return Ch(4, 2, a, s);
}, useMemo: function(a, s) {
  var $ = th();
  return s = s === void 0 ? null : s, a = a(), $.memoizedState = [
    a,
    s
  ], a;
}, useReducer: function(a, s, $) {
  var _ = th();
  return s = $ !== void 0 ? $(s) : s, _.memoizedState = _.baseState = s, a = _.queue = { pending: null, dispatch: null, lastRenderedReducer: a, lastRenderedState: s }, a = a.dispatch = zh.bind(null, N, a), [_.memoizedState, a];
}, useRef: function(a) {
  var s = th();
  return a = { current: a }, s.memoizedState = a;
}, useState: yh, useDebugValue: Jh, useResponder: ih, useDeferredValue: function(a, s) {
  var $ = yh(a), _ = $[0], _e = $[1];
  return Eh(function() {
    var tt = kh.suspense;
    kh.suspense = s === void 0 ? null : s;
    try {
      _e(a);
    } finally {
      kh.suspense = tt;
    }
  }, [a, s]), _;
}, useTransition: function(a) {
  var s = yh(!1), $ = s[0];
  return s = s[1], [Kh(Nh.bind(null, s, a), [s, a]), $];
} }, qh = { readContext: sg, useCallback: Lh, useContext: sg, useEffect: Fh, useImperativeHandle: Ih, useLayoutEffect: Gh, useMemo: Mh, useReducer: wh, useRef: Bh, useState: function() {
  return wh(vh);
}, useDebugValue: Jh, useResponder: ih, useDeferredValue: function(a, s) {
  var $ = wh(vh), _ = $[0], _e = $[1];
  return Fh(function() {
    var tt = kh.suspense;
    kh.suspense = s === void 0 ? null : s;
    try {
      _e(a);
    } finally {
      kh.suspense = tt;
    }
  }, [a, s]), _;
}, useTransition: function(a) {
  var s = wh(vh), $ = s[0];
  return s = s[1], [Lh(Nh.bind(null, s, a), [s, a]), $];
} }, rh = { readContext: sg, useCallback: Lh, useContext: sg, useEffect: Fh, useImperativeHandle: Ih, useLayoutEffect: Gh, useMemo: Mh, useReducer: xh, useRef: Bh, useState: function() {
  return xh(vh);
}, useDebugValue: Jh, useResponder: ih, useDeferredValue: function(a, s) {
  var $ = xh(vh), _ = $[0], _e = $[1];
  return Fh(function() {
    var tt = kh.suspense;
    kh.suspense = s === void 0 ? null : s;
    try {
      _e(a);
    } finally {
      kh.suspense = tt;
    }
  }, [a, s]), _;
}, useTransition: function(a) {
  var s = xh(vh), $ = s[0];
  return s = s[1], [Lh(Nh.bind(
    null,
    s,
    a
  ), [s, a]), $];
} }, Oh = null, Ph = null, Qh = !1;
function Rh(a, s) {
  var $ = Sh(5, null, null, 0);
  $.elementType = "DELETED", $.type = "DELETED", $.stateNode = s, $.return = a, $.effectTag = 8, a.lastEffect !== null ? (a.lastEffect.nextEffect = $, a.lastEffect = $) : a.firstEffect = a.lastEffect = $;
}
function Th(a, s) {
  switch (a.tag) {
    case 5:
      var $ = a.type;
      return s = s.nodeType !== 1 || $.toLowerCase() !== s.nodeName.toLowerCase() ? null : s, s !== null ? (a.stateNode = s, !0) : !1;
    case 6:
      return s = a.pendingProps === "" || s.nodeType !== 3 ? null : s, s !== null ? (a.stateNode = s, !0) : !1;
    case 13:
      return !1;
    default:
      return !1;
  }
}
function Uh(a) {
  if (Qh) {
    var s = Ph;
    if (s) {
      var $ = s;
      if (!Th(a, s)) {
        if (s = Jd($.nextSibling), !s || !Th(a, s)) {
          a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
          return;
        }
        Rh(Oh, $);
      }
      Oh = a, Ph = Jd(s.firstChild);
    } else
      a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
  }
}
function Vh(a) {
  for (a = a.return; a !== null && a.tag !== 5 && a.tag !== 3 && a.tag !== 13; )
    a = a.return;
  Oh = a;
}
function Wh(a) {
  if (a !== Oh)
    return !1;
  if (!Qh)
    return Vh(a), Qh = !0, !1;
  var s = a.type;
  if (a.tag !== 5 || s !== "head" && s !== "body" && !Gd(s, a.memoizedProps))
    for (s = Ph; s; )
      Rh(a, s), s = Jd(s.nextSibling);
  if (Vh(a), a.tag === 13) {
    if (a = a.memoizedState, a = a !== null ? a.dehydrated : null, !a)
      throw Error(u$3(317));
    e: {
      for (a = a.nextSibling, s = 0; a; ) {
        if (a.nodeType === 8) {
          var $ = a.data;
          if ($ === Ad) {
            if (s === 0) {
              Ph = Jd(a.nextSibling);
              break e;
            }
            s--;
          } else
            $ !== zd && $ !== Cd && $ !== Bd || s++;
        }
        a = a.nextSibling;
      }
      Ph = null;
    }
  } else
    Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
  return !0;
}
function Xh() {
  Ph = Oh = null, Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, s, $, _) {
  s.child = a === null ? Yg(s, null, $, _) : Xg(s, a.child, $, _);
}
function Zh(a, s, $, _, _e) {
  $ = $.render;
  var tt = s.ref;
  return qg(s, _e), _ = oh(a, s, $, _, tt, _e), a !== null && !rg ? (s.updateQueue = a.updateQueue, s.effectTag &= -517, a.expirationTime <= _e && (a.expirationTime = 0), $h(a, s, _e)) : (s.effectTag |= 1, R(a, s, _, _e), s.child);
}
function ai(a, s, $, _, _e, tt) {
  if (a === null) {
    var nt = $.type;
    return typeof nt == "function" && !bi(nt) && nt.defaultProps === void 0 && $.compare === null && $.defaultProps === void 0 ? (s.tag = 15, s.type = nt, ci(a, s, nt, _, _e, tt)) : (a = Ug($.type, null, _, null, s.mode, tt), a.ref = s.ref, a.return = s, s.child = a);
  }
  return nt = a.child, _e < tt && (_e = nt.memoizedProps, $ = $.compare, $ = $ !== null ? $ : bf, $(_e, _) && a.ref === s.ref) ? $h(a, s, tt) : (s.effectTag |= 1, a = Sg(nt, _), a.ref = s.ref, a.return = s, s.child = a);
}
function ci(a, s, $, _, _e, tt) {
  return a !== null && bf(a.memoizedProps, _) && a.ref === s.ref && (rg = !1, _e < tt) ? (s.expirationTime = a.expirationTime, $h(a, s, tt)) : di(a, s, $, _, tt);
}
function ei(a, s) {
  var $ = s.ref;
  (a === null && $ !== null || a !== null && a.ref !== $) && (s.effectTag |= 128);
}
function di(a, s, $, _, _e) {
  var tt = L($) ? Bf : J.current;
  return tt = Cf(s, tt), qg(s, _e), $ = oh(a, s, $, _, tt, _e), a !== null && !rg ? (s.updateQueue = a.updateQueue, s.effectTag &= -517, a.expirationTime <= _e && (a.expirationTime = 0), $h(a, s, _e)) : (s.effectTag |= 1, R(a, s, $, _e), s.child);
}
function fi(a, s, $, _, _e) {
  if (L($)) {
    var tt = !0;
    Gf(s);
  } else
    tt = !1;
  if (qg(s, _e), s.stateNode === null)
    a !== null && (a.alternate = null, s.alternate = null, s.effectTag |= 2), Lg(s, $, _), Ng(s, $, _, _e), _ = !0;
  else if (a === null) {
    var nt = s.stateNode, at = s.memoizedProps;
    nt.props = at;
    var ot = nt.context, rt = $.contextType;
    typeof rt == "object" && rt !== null ? rt = sg(rt) : (rt = L($) ? Bf : J.current, rt = Cf(s, rt));
    var st = $.getDerivedStateFromProps, lt = typeof st == "function" || typeof nt.getSnapshotBeforeUpdate == "function";
    lt || typeof nt.UNSAFE_componentWillReceiveProps != "function" && typeof nt.componentWillReceiveProps != "function" || (at !== _ || ot !== rt) && Mg(s, nt, _, rt), tg = !1;
    var et = s.memoizedState;
    nt.state = et, zg(s, _, nt, _e), ot = s.memoizedState, at !== _ || et !== ot || K.current || tg ? (typeof st == "function" && (Fg(s, $, st, _), ot = s.memoizedState), (at = tg || Kg(s, $, at, _, et, ot, rt)) ? (lt || typeof nt.UNSAFE_componentWillMount != "function" && typeof nt.componentWillMount != "function" || (typeof nt.componentWillMount == "function" && nt.componentWillMount(), typeof nt.UNSAFE_componentWillMount == "function" && nt.UNSAFE_componentWillMount()), typeof nt.componentDidMount == "function" && (s.effectTag |= 4)) : (typeof nt.componentDidMount == "function" && (s.effectTag |= 4), s.memoizedProps = _, s.memoizedState = ot), nt.props = _, nt.state = ot, nt.context = rt, _ = at) : (typeof nt.componentDidMount == "function" && (s.effectTag |= 4), _ = !1);
  } else
    nt = s.stateNode, vg(a, s), at = s.memoizedProps, nt.props = s.type === s.elementType ? at : ig(s.type, at), ot = nt.context, rt = $.contextType, typeof rt == "object" && rt !== null ? rt = sg(rt) : (rt = L($) ? Bf : J.current, rt = Cf(s, rt)), st = $.getDerivedStateFromProps, (lt = typeof st == "function" || typeof nt.getSnapshotBeforeUpdate == "function") || typeof nt.UNSAFE_componentWillReceiveProps != "function" && typeof nt.componentWillReceiveProps != "function" || (at !== _ || ot !== rt) && Mg(s, nt, _, rt), tg = !1, ot = s.memoizedState, nt.state = ot, zg(s, _, nt, _e), et = s.memoizedState, at !== _ || ot !== et || K.current || tg ? (typeof st == "function" && (Fg(s, $, st, _), et = s.memoizedState), (st = tg || Kg(s, $, at, _, ot, et, rt)) ? (lt || typeof nt.UNSAFE_componentWillUpdate != "function" && typeof nt.componentWillUpdate != "function" || (typeof nt.componentWillUpdate == "function" && nt.componentWillUpdate(
      _,
      et,
      rt
    ), typeof nt.UNSAFE_componentWillUpdate == "function" && nt.UNSAFE_componentWillUpdate(_, et, rt)), typeof nt.componentDidUpdate == "function" && (s.effectTag |= 4), typeof nt.getSnapshotBeforeUpdate == "function" && (s.effectTag |= 256)) : (typeof nt.componentDidUpdate != "function" || at === a.memoizedProps && ot === a.memoizedState || (s.effectTag |= 4), typeof nt.getSnapshotBeforeUpdate != "function" || at === a.memoizedProps && ot === a.memoizedState || (s.effectTag |= 256), s.memoizedProps = _, s.memoizedState = et), nt.props = _, nt.state = et, nt.context = rt, _ = st) : (typeof nt.componentDidUpdate != "function" || at === a.memoizedProps && ot === a.memoizedState || (s.effectTag |= 4), typeof nt.getSnapshotBeforeUpdate != "function" || at === a.memoizedProps && ot === a.memoizedState || (s.effectTag |= 256), _ = !1);
  return gi(a, s, $, _, tt, _e);
}
function gi(a, s, $, _, _e, tt) {
  ei(a, s);
  var nt = (s.effectTag & 64) !== 0;
  if (!_ && !nt)
    return _e && Hf(s, $, !1), $h(a, s, tt);
  _ = s.stateNode, Yh.current = s;
  var at = nt && typeof $.getDerivedStateFromError != "function" ? null : _.render();
  return s.effectTag |= 1, a !== null && nt ? (s.child = Xg(s, a.child, null, tt), s.child = Xg(s, null, at, tt)) : R(a, s, at, tt), s.memoizedState = _.state, _e && Hf(s, $, !0), s.child;
}
function hi(a) {
  var s = a.stateNode;
  s.pendingContext ? Ef(a, s.pendingContext, s.pendingContext !== s.context) : s.context && Ef(a, s.context, !1), dh(a, s.containerInfo);
}
var ii = { dehydrated: null, retryTime: 0 };
function ji(a, s, $) {
  var _ = s.mode, _e = s.pendingProps, tt = M.current, nt = !1, at;
  if ((at = (s.effectTag & 64) !== 0) || (at = (tt & 2) !== 0 && (a === null || a.memoizedState !== null)), at ? (nt = !0, s.effectTag &= -65) : a !== null && a.memoizedState === null || _e.fallback === void 0 || _e.unstable_avoidThisFallback === !0 || (tt |= 1), I(M, tt & 1), a === null) {
    if (_e.fallback !== void 0 && Uh(s), nt) {
      if (nt = _e.fallback, _e = Wg(null, _, 0, null), _e.return = s, !(s.mode & 2))
        for (a = s.memoizedState !== null ? s.child.child : s.child, _e.child = a; a !== null; )
          a.return = _e, a = a.sibling;
      return $ = Wg(nt, _, $, null), $.return = s, _e.sibling = $, s.memoizedState = ii, s.child = _e, $;
    }
    return _ = _e.children, s.memoizedState = null, s.child = Yg(s, null, _, $);
  }
  if (a.memoizedState !== null) {
    if (a = a.child, _ = a.sibling, nt) {
      if (_e = _e.fallback, $ = Sg(a, a.pendingProps), $.return = s, !(s.mode & 2) && (nt = s.memoizedState !== null ? s.child.child : s.child, nt !== a.child))
        for ($.child = nt; nt !== null; )
          nt.return = $, nt = nt.sibling;
      return _ = Sg(_, _e), _.return = s, $.sibling = _, $.childExpirationTime = 0, s.memoizedState = ii, s.child = $, _;
    }
    return $ = Xg(s, a.child, _e.children, $), s.memoizedState = null, s.child = $;
  }
  if (a = a.child, nt) {
    if (nt = _e.fallback, _e = Wg(null, _, 0, null), _e.return = s, _e.child = a, a !== null && (a.return = _e), !(s.mode & 2))
      for (a = s.memoizedState !== null ? s.child.child : s.child, _e.child = a; a !== null; )
        a.return = _e, a = a.sibling;
    return $ = Wg(nt, _, $, null), $.return = s, _e.sibling = $, $.effectTag |= 2, _e.childExpirationTime = 0, s.memoizedState = ii, s.child = _e, $;
  }
  return s.memoizedState = null, s.child = Xg(s, a, _e.children, $);
}
function ki(a, s) {
  a.expirationTime < s && (a.expirationTime = s);
  var $ = a.alternate;
  $ !== null && $.expirationTime < s && ($.expirationTime = s), pg(a.return, s);
}
function li(a, s, $, _, _e, tt) {
  var nt = a.memoizedState;
  nt === null ? a.memoizedState = { isBackwards: s, rendering: null, renderingStartTime: 0, last: _, tail: $, tailExpiration: 0, tailMode: _e, lastEffect: tt } : (nt.isBackwards = s, nt.rendering = null, nt.renderingStartTime = 0, nt.last = _, nt.tail = $, nt.tailExpiration = 0, nt.tailMode = _e, nt.lastEffect = tt);
}
function mi(a, s, $) {
  var _ = s.pendingProps, _e = _.revealOrder, tt = _.tail;
  if (R(a, s, _.children, $), _ = M.current, _ & 2)
    _ = _ & 1 | 2, s.effectTag |= 64;
  else {
    if (a !== null && a.effectTag & 64)
      e:
        for (a = s.child; a !== null; ) {
          if (a.tag === 13)
            a.memoizedState !== null && ki(a, $);
          else if (a.tag === 19)
            ki(a, $);
          else if (a.child !== null) {
            a.child.return = a, a = a.child;
            continue;
          }
          if (a === s)
            break e;
          for (; a.sibling === null; ) {
            if (a.return === null || a.return === s)
              break e;
            a = a.return;
          }
          a.sibling.return = a.return, a = a.sibling;
        }
    _ &= 1;
  }
  if (I(M, _), !(s.mode & 2))
    s.memoizedState = null;
  else
    switch (_e) {
      case "forwards":
        for ($ = s.child, _e = null; $ !== null; )
          a = $.alternate, a !== null && hh(a) === null && (_e = $), $ = $.sibling;
        $ = _e, $ === null ? (_e = s.child, s.child = null) : (_e = $.sibling, $.sibling = null), li(s, !1, _e, $, tt, s.lastEffect);
        break;
      case "backwards":
        for ($ = null, _e = s.child, s.child = null; _e !== null; ) {
          if (a = _e.alternate, a !== null && hh(a) === null) {
            s.child = _e;
            break;
          }
          a = _e.sibling, _e.sibling = $, $ = _e, _e = a;
        }
        li(s, !0, $, null, tt, s.lastEffect);
        break;
      case "together":
        li(s, !1, null, null, void 0, s.lastEffect);
        break;
      default:
        s.memoizedState = null;
    }
  return s.child;
}
function $h(a, s, $) {
  a !== null && (s.dependencies = a.dependencies);
  var _ = s.expirationTime;
  if (_ !== 0 && Bg(_), s.childExpirationTime < $)
    return null;
  if (a !== null && s.child !== a.child)
    throw Error(u$3(153));
  if (s.child !== null) {
    for (a = s.child, $ = Sg(a, a.pendingProps), s.child = $, $.return = s; a.sibling !== null; )
      a = a.sibling, $ = $.sibling = Sg(a, a.pendingProps), $.return = s;
    $.sibling = null;
  }
  return s.child;
}
var ni, oi, pi, qi;
ni = function(a, s) {
  for (var $ = s.child; $ !== null; ) {
    if ($.tag === 5 || $.tag === 6)
      a.appendChild($.stateNode);
    else if ($.tag !== 4 && $.child !== null) {
      $.child.return = $, $ = $.child;
      continue;
    }
    if ($ === s)
      break;
    for (; $.sibling === null; ) {
      if ($.return === null || $.return === s)
        return;
      $ = $.return;
    }
    $.sibling.return = $.return, $ = $.sibling;
  }
};
oi = function() {
};
pi = function(a, s, $, _, _e) {
  var tt = a.memoizedProps;
  if (tt !== _) {
    var nt = s.stateNode;
    switch (ch($g.current), a = null, $) {
      case "input":
        tt = zb(nt, tt), _ = zb(nt, _), a = [];
        break;
      case "option":
        tt = Gb(nt, tt), _ = Gb(nt, _), a = [];
        break;
      case "select":
        tt = n$4({}, tt, { value: void 0 }), _ = n$4({}, _, { value: void 0 }), a = [];
        break;
      case "textarea":
        tt = Ib(nt, tt), _ = Ib(nt, _), a = [];
        break;
      default:
        typeof tt.onClick != "function" && typeof _.onClick == "function" && (nt.onclick = sd);
    }
    od($, _);
    var at, ot;
    $ = null;
    for (at in tt)
      if (!_.hasOwnProperty(at) && tt.hasOwnProperty(at) && tt[at] != null)
        if (at === "style")
          for (ot in nt = tt[at], nt)
            nt.hasOwnProperty(ot) && ($ || ($ = {}), $[ot] = "");
        else
          at !== "dangerouslySetInnerHTML" && at !== "children" && at !== "suppressContentEditableWarning" && at !== "suppressHydrationWarning" && at !== "autoFocus" && (va.hasOwnProperty(at) ? a || (a = []) : (a = a || []).push(at, null));
    for (at in _) {
      var rt = _[at];
      if (nt = tt != null ? tt[at] : void 0, _.hasOwnProperty(at) && rt !== nt && (rt != null || nt != null))
        if (at === "style")
          if (nt) {
            for (ot in nt)
              !nt.hasOwnProperty(ot) || rt && rt.hasOwnProperty(ot) || ($ || ($ = {}), $[ot] = "");
            for (ot in rt)
              rt.hasOwnProperty(ot) && nt[ot] !== rt[ot] && ($ || ($ = {}), $[ot] = rt[ot]);
          } else
            $ || (a || (a = []), a.push(at, $)), $ = rt;
        else
          at === "dangerouslySetInnerHTML" ? (rt = rt ? rt.__html : void 0, nt = nt ? nt.__html : void 0, rt != null && nt !== rt && (a = a || []).push(at, rt)) : at === "children" ? nt === rt || typeof rt != "string" && typeof rt != "number" || (a = a || []).push(at, "" + rt) : at !== "suppressContentEditableWarning" && at !== "suppressHydrationWarning" && (va.hasOwnProperty(at) ? (rt != null && rd(_e, at), a || nt === rt || (a = [])) : (a = a || []).push(at, rt));
    }
    $ && (a = a || []).push("style", $), _e = a, (s.updateQueue = _e) && (s.effectTag |= 4);
  }
};
qi = function(a, s, $, _) {
  $ !== _ && (s.effectTag |= 4);
};
function ri(a, s) {
  switch (a.tailMode) {
    case "hidden":
      s = a.tail;
      for (var $ = null; s !== null; )
        s.alternate !== null && ($ = s), s = s.sibling;
      $ === null ? a.tail = null : $.sibling = null;
      break;
    case "collapsed":
      $ = a.tail;
      for (var _ = null; $ !== null; )
        $.alternate !== null && (_ = $), $ = $.sibling;
      _ === null ? s || a.tail === null ? a.tail = null : a.tail.sibling = null : _.sibling = null;
  }
}
function si(a, s, $) {
  var _ = s.pendingProps;
  switch (s.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return null;
    case 1:
      return L(s.type) && Df(), null;
    case 3:
      return eh(), H(K), H(J), $ = s.stateNode, $.pendingContext && ($.context = $.pendingContext, $.pendingContext = null), a !== null && a.child !== null || !Wh(s) || (s.effectTag |= 4), oi(s), null;
    case 5:
      gh(s), $ = ch(bh.current);
      var _e = s.type;
      if (a !== null && s.stateNode != null)
        pi(a, s, _e, _, $), a.ref !== s.ref && (s.effectTag |= 128);
      else {
        if (!_) {
          if (s.stateNode === null)
            throw Error(u$3(166));
          return null;
        }
        if (a = ch($g.current), Wh(s)) {
          _ = s.stateNode, _e = s.type;
          var tt = s.memoizedProps;
          switch (_[Md] = s, _[Nd] = tt, _e) {
            case "iframe":
            case "object":
            case "embed":
              F("load", _);
              break;
            case "video":
            case "audio":
              for (a = 0; a < ac.length; a++)
                F(ac[a], _);
              break;
            case "source":
              F("error", _);
              break;
            case "img":
            case "image":
            case "link":
              F("error", _), F("load", _);
              break;
            case "form":
              F("reset", _), F("submit", _);
              break;
            case "details":
              F("toggle", _);
              break;
            case "input":
              Ab(_, tt), F("invalid", _), rd($, "onChange");
              break;
            case "select":
              _._wrapperState = { wasMultiple: !!tt.multiple }, F("invalid", _), rd($, "onChange");
              break;
            case "textarea":
              Jb(_, tt), F("invalid", _), rd($, "onChange");
          }
          od(_e, tt), a = null;
          for (var nt in tt)
            if (tt.hasOwnProperty(nt)) {
              var at = tt[nt];
              nt === "children" ? typeof at == "string" ? _.textContent !== at && (a = ["children", at]) : typeof at == "number" && _.textContent !== "" + at && (a = ["children", "" + at]) : va.hasOwnProperty(nt) && at != null && rd($, nt);
            }
          switch (_e) {
            case "input":
              xb(_), Eb(_, tt, !0);
              break;
            case "textarea":
              xb(_), Lb(_);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof tt.onClick == "function" && (_.onclick = sd);
          }
          $ = a, s.updateQueue = $, $ !== null && (s.effectTag |= 4);
        } else {
          switch (nt = $.nodeType === 9 ? $ : $.ownerDocument, a === qd && (a = Nb(_e)), a === qd ? _e === "script" ? (a = nt.createElement("div"), a.innerHTML = "<script><\/script>", a = a.removeChild(a.firstChild)) : typeof _.is == "string" ? a = nt.createElement(_e, { is: _.is }) : (a = nt.createElement(_e), _e === "select" && (nt = a, _.multiple ? nt.multiple = !0 : _.size && (nt.size = _.size))) : a = nt.createElementNS(a, _e), a[Md] = s, a[Nd] = _, ni(a, s, !1, !1), s.stateNode = a, nt = pd(_e, _), _e) {
            case "iframe":
            case "object":
            case "embed":
              F(
                "load",
                a
              ), at = _;
              break;
            case "video":
            case "audio":
              for (at = 0; at < ac.length; at++)
                F(ac[at], a);
              at = _;
              break;
            case "source":
              F("error", a), at = _;
              break;
            case "img":
            case "image":
            case "link":
              F("error", a), F("load", a), at = _;
              break;
            case "form":
              F("reset", a), F("submit", a), at = _;
              break;
            case "details":
              F("toggle", a), at = _;
              break;
            case "input":
              Ab(a, _), at = zb(a, _), F("invalid", a), rd($, "onChange");
              break;
            case "option":
              at = Gb(a, _);
              break;
            case "select":
              a._wrapperState = { wasMultiple: !!_.multiple }, at = n$4({}, _, { value: void 0 }), F("invalid", a), rd($, "onChange");
              break;
            case "textarea":
              Jb(
                a,
                _
              ), at = Ib(a, _), F("invalid", a), rd($, "onChange");
              break;
            default:
              at = _;
          }
          od(_e, at);
          var ot = at;
          for (tt in ot)
            if (ot.hasOwnProperty(tt)) {
              var rt = ot[tt];
              tt === "style" ? md(a, rt) : tt === "dangerouslySetInnerHTML" ? (rt = rt ? rt.__html : void 0, rt != null && Qb(a, rt)) : tt === "children" ? typeof rt == "string" ? (_e !== "textarea" || rt !== "") && Rb(a, rt) : typeof rt == "number" && Rb(a, "" + rt) : tt !== "suppressContentEditableWarning" && tt !== "suppressHydrationWarning" && tt !== "autoFocus" && (va.hasOwnProperty(tt) ? rt != null && rd($, tt) : rt != null && Xa(a, tt, rt, nt));
            }
          switch (_e) {
            case "input":
              xb(a), Eb(a, _, !1);
              break;
            case "textarea":
              xb(a), Lb(a);
              break;
            case "option":
              _.value != null && a.setAttribute("value", "" + rb(_.value));
              break;
            case "select":
              a.multiple = !!_.multiple, $ = _.value, $ != null ? Hb(a, !!_.multiple, $, !1) : _.defaultValue != null && Hb(a, !!_.multiple, _.defaultValue, !0);
              break;
            default:
              typeof at.onClick == "function" && (a.onclick = sd);
          }
          Fd(_e, _) && (s.effectTag |= 4);
        }
        s.ref !== null && (s.effectTag |= 128);
      }
      return null;
    case 6:
      if (a && s.stateNode != null)
        qi(a, s, a.memoizedProps, _);
      else {
        if (typeof _ != "string" && s.stateNode === null)
          throw Error(u$3(166));
        $ = ch(bh.current), ch($g.current), Wh(s) ? ($ = s.stateNode, _ = s.memoizedProps, $[Md] = s, $.nodeValue !== _ && (s.effectTag |= 4)) : ($ = ($.nodeType === 9 ? $ : $.ownerDocument).createTextNode(_), $[Md] = s, s.stateNode = $);
      }
      return null;
    case 13:
      return H(M), _ = s.memoizedState, s.effectTag & 64 ? (s.expirationTime = $, s) : ($ = _ !== null, _ = !1, a === null ? s.memoizedProps.fallback !== void 0 && Wh(s) : (_e = a.memoizedState, _ = _e !== null, $ || _e === null || (_e = a.child.sibling, _e !== null && (tt = s.firstEffect, tt !== null ? (s.firstEffect = _e, _e.nextEffect = tt) : (s.firstEffect = s.lastEffect = _e, _e.nextEffect = null), _e.effectTag = 8))), $ && !_ && s.mode & 2 && (a === null && s.memoizedProps.unstable_avoidThisFallback !== !0 || M.current & 1 ? S === ti && (S = ui) : ((S === ti || S === ui) && (S = vi), wi !== 0 && T !== null && (xi(T, U), yi(T, wi)))), ($ || _) && (s.effectTag |= 4), null);
    case 4:
      return eh(), oi(s), null;
    case 10:
      return og(s), null;
    case 17:
      return L(s.type) && Df(), null;
    case 19:
      if (H(M), _ = s.memoizedState, _ === null)
        return null;
      if (_e = (s.effectTag & 64) !== 0, tt = _.rendering, tt === null) {
        if (_e)
          ri(_, !1);
        else if (S !== ti || a !== null && a.effectTag & 64)
          for (tt = s.child; tt !== null; ) {
            if (a = hh(tt), a !== null) {
              for (s.effectTag |= 64, ri(_, !1), _e = a.updateQueue, _e !== null && (s.updateQueue = _e, s.effectTag |= 4), _.lastEffect === null && (s.firstEffect = null), s.lastEffect = _.lastEffect, _ = s.child; _ !== null; )
                _e = _, tt = $, _e.effectTag &= 2, _e.nextEffect = null, _e.firstEffect = null, _e.lastEffect = null, a = _e.alternate, a === null ? (_e.childExpirationTime = 0, _e.expirationTime = tt, _e.child = null, _e.memoizedProps = null, _e.memoizedState = null, _e.updateQueue = null, _e.dependencies = null) : (_e.childExpirationTime = a.childExpirationTime, _e.expirationTime = a.expirationTime, _e.child = a.child, _e.memoizedProps = a.memoizedProps, _e.memoizedState = a.memoizedState, _e.updateQueue = a.updateQueue, tt = a.dependencies, _e.dependencies = tt === null ? null : { expirationTime: tt.expirationTime, firstContext: tt.firstContext, responders: tt.responders }), _ = _.sibling;
              return I(M, M.current & 1 | 2), s.child;
            }
            tt = tt.sibling;
          }
      } else {
        if (!_e)
          if (a = hh(tt), a !== null) {
            if (s.effectTag |= 64, _e = !0, $ = a.updateQueue, $ !== null && (s.updateQueue = $, s.effectTag |= 4), ri(_, !0), _.tail === null && _.tailMode === "hidden" && !tt.alternate)
              return s = s.lastEffect = _.lastEffect, s !== null && (s.nextEffect = null), null;
          } else
            2 * $f() - _.renderingStartTime > _.tailExpiration && 1 < $ && (s.effectTag |= 64, _e = !0, ri(_, !1), s.expirationTime = s.childExpirationTime = $ - 1);
        _.isBackwards ? (tt.sibling = s.child, s.child = tt) : ($ = _.last, $ !== null ? $.sibling = tt : s.child = tt, _.last = tt);
      }
      return _.tail !== null ? (_.tailExpiration === 0 && (_.tailExpiration = $f() + 500), $ = _.tail, _.rendering = $, _.tail = $.sibling, _.lastEffect = s.lastEffect, _.renderingStartTime = $f(), $.sibling = null, s = M.current, I(M, _e ? s & 1 | 2 : s & 1), $) : null;
  }
  throw Error(u$3(
    156,
    s.tag
  ));
}
function zi(a) {
  switch (a.tag) {
    case 1:
      L(a.type) && Df();
      var s = a.effectTag;
      return s & 4096 ? (a.effectTag = s & -4097 | 64, a) : null;
    case 3:
      if (eh(), H(K), H(J), s = a.effectTag, s & 64)
        throw Error(u$3(285));
      return a.effectTag = s & -4097 | 64, a;
    case 5:
      return gh(a), null;
    case 13:
      return H(M), s = a.effectTag, s & 4096 ? (a.effectTag = s & -4097 | 64, a) : null;
    case 19:
      return H(M), null;
    case 4:
      return eh(), null;
    case 10:
      return og(a), null;
    default:
      return null;
  }
}
function Ai(a, s) {
  return { value: a, source: s, stack: qb(s) };
}
var Bi = typeof WeakSet == "function" ? WeakSet : Set;
function Ci(a, s) {
  var $ = s.source, _ = s.stack;
  _ === null && $ !== null && (_ = qb($)), $ !== null && pb($.type), s = s.value, a !== null && a.tag === 1 && pb(a.type);
  try {
    console.error(s);
  } catch (_e) {
    setTimeout(function() {
      throw _e;
    });
  }
}
function Di(a, s) {
  try {
    s.props = a.memoizedProps, s.state = a.memoizedState, s.componentWillUnmount();
  } catch ($) {
    Ei(a, $);
  }
}
function Fi(a) {
  var s = a.ref;
  if (s !== null)
    if (typeof s == "function")
      try {
        s(null);
      } catch ($) {
        Ei(a, $);
      }
    else
      s.current = null;
}
function Gi(a, s) {
  switch (s.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      return;
    case 1:
      if (s.effectTag & 256 && a !== null) {
        var $ = a.memoizedProps, _ = a.memoizedState;
        a = s.stateNode, s = a.getSnapshotBeforeUpdate(s.elementType === s.type ? $ : ig(s.type, $), _), a.__reactInternalSnapshotBeforeUpdate = s;
      }
      return;
    case 3:
    case 5:
    case 6:
    case 4:
    case 17:
      return;
  }
  throw Error(u$3(163));
}
function Hi(a, s) {
  if (s = s.updateQueue, s = s !== null ? s.lastEffect : null, s !== null) {
    var $ = s = s.next;
    do {
      if (($.tag & a) === a) {
        var _ = $.destroy;
        $.destroy = void 0, _ !== void 0 && _();
      }
      $ = $.next;
    } while ($ !== s);
  }
}
function Ii(a, s) {
  if (s = s.updateQueue, s = s !== null ? s.lastEffect : null, s !== null) {
    var $ = s = s.next;
    do {
      if (($.tag & a) === a) {
        var _ = $.create;
        $.destroy = _();
      }
      $ = $.next;
    } while ($ !== s);
  }
}
function Ji(a, s, $) {
  switch ($.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      Ii(3, $);
      return;
    case 1:
      if (a = $.stateNode, $.effectTag & 4)
        if (s === null)
          a.componentDidMount();
        else {
          var _ = $.elementType === $.type ? s.memoizedProps : ig($.type, s.memoizedProps);
          a.componentDidUpdate(_, s.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
        }
      s = $.updateQueue, s !== null && Cg($, s, a);
      return;
    case 3:
      if (s = $.updateQueue, s !== null) {
        if (a = null, $.child !== null)
          switch ($.child.tag) {
            case 5:
              a = $.child.stateNode;
              break;
            case 1:
              a = $.child.stateNode;
          }
        Cg($, s, a);
      }
      return;
    case 5:
      a = $.stateNode, s === null && $.effectTag & 4 && Fd($.type, $.memoizedProps) && a.focus();
      return;
    case 6:
      return;
    case 4:
      return;
    case 12:
      return;
    case 13:
      $.memoizedState === null && ($ = $.alternate, $ !== null && ($ = $.memoizedState, $ !== null && ($ = $.dehydrated, $ !== null && Vc($))));
      return;
    case 19:
    case 17:
    case 20:
    case 21:
      return;
  }
  throw Error(u$3(163));
}
function Ki(a, s, $) {
  switch (typeof Li == "function" && Li(s), s.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      if (a = s.updateQueue, a !== null && (a = a.lastEffect, a !== null)) {
        var _ = a.next;
        cg(97 < $ ? 97 : $, function() {
          var _e = _;
          do {
            var tt = _e.destroy;
            if (tt !== void 0) {
              var nt = s;
              try {
                tt();
              } catch (at) {
                Ei(nt, at);
              }
            }
            _e = _e.next;
          } while (_e !== _);
        });
      }
      break;
    case 1:
      Fi(s), $ = s.stateNode, typeof $.componentWillUnmount == "function" && Di(s, $);
      break;
    case 5:
      Fi(s);
      break;
    case 4:
      Mi(a, s, $);
  }
}
function Ni(a) {
  var s = a.alternate;
  a.return = null, a.child = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.alternate = null, a.firstEffect = null, a.lastEffect = null, a.pendingProps = null, a.memoizedProps = null, a.stateNode = null, s !== null && Ni(s);
}
function Oi(a) {
  return a.tag === 5 || a.tag === 3 || a.tag === 4;
}
function Pi(a) {
  e: {
    for (var s = a.return; s !== null; ) {
      if (Oi(s)) {
        var $ = s;
        break e;
      }
      s = s.return;
    }
    throw Error(u$3(160));
  }
  switch (s = $.stateNode, $.tag) {
    case 5:
      var _ = !1;
      break;
    case 3:
      s = s.containerInfo, _ = !0;
      break;
    case 4:
      s = s.containerInfo, _ = !0;
      break;
    default:
      throw Error(u$3(161));
  }
  $.effectTag & 16 && (Rb(s, ""), $.effectTag &= -17);
  e:
    t:
      for ($ = a; ; ) {
        for (; $.sibling === null; ) {
          if ($.return === null || Oi($.return)) {
            $ = null;
            break e;
          }
          $ = $.return;
        }
        for ($.sibling.return = $.return, $ = $.sibling; $.tag !== 5 && $.tag !== 6 && $.tag !== 18; ) {
          if ($.effectTag & 2 || $.child === null || $.tag === 4)
            continue t;
          $.child.return = $, $ = $.child;
        }
        if (!($.effectTag & 2)) {
          $ = $.stateNode;
          break e;
        }
      }
  _ ? Qi(a, $, s) : Ri(a, $, s);
}
function Qi(a, s, $) {
  var _ = a.tag, _e = _ === 5 || _ === 6;
  if (_e)
    a = _e ? a.stateNode : a.stateNode.instance, s ? $.nodeType === 8 ? $.parentNode.insertBefore(a, s) : $.insertBefore(a, s) : ($.nodeType === 8 ? (s = $.parentNode, s.insertBefore(a, $)) : (s = $, s.appendChild(a)), $ = $._reactRootContainer, $ != null || s.onclick !== null || (s.onclick = sd));
  else if (_ !== 4 && (a = a.child, a !== null))
    for (Qi(a, s, $), a = a.sibling; a !== null; )
      Qi(a, s, $), a = a.sibling;
}
function Ri(a, s, $) {
  var _ = a.tag, _e = _ === 5 || _ === 6;
  if (_e)
    a = _e ? a.stateNode : a.stateNode.instance, s ? $.insertBefore(a, s) : $.appendChild(a);
  else if (_ !== 4 && (a = a.child, a !== null))
    for (Ri(a, s, $), a = a.sibling; a !== null; )
      Ri(a, s, $), a = a.sibling;
}
function Mi(a, s, $) {
  for (var _ = s, _e = !1, tt, nt; ; ) {
    if (!_e) {
      _e = _.return;
      e:
        for (; ; ) {
          if (_e === null)
            throw Error(u$3(160));
          switch (tt = _e.stateNode, _e.tag) {
            case 5:
              nt = !1;
              break e;
            case 3:
              tt = tt.containerInfo, nt = !0;
              break e;
            case 4:
              tt = tt.containerInfo, nt = !0;
              break e;
          }
          _e = _e.return;
        }
      _e = !0;
    }
    if (_.tag === 5 || _.tag === 6) {
      e:
        for (var at = a, ot = _, rt = $, st = ot; ; )
          if (Ki(at, st, rt), st.child !== null && st.tag !== 4)
            st.child.return = st, st = st.child;
          else {
            if (st === ot)
              break e;
            for (; st.sibling === null; ) {
              if (st.return === null || st.return === ot)
                break e;
              st = st.return;
            }
            st.sibling.return = st.return, st = st.sibling;
          }
      nt ? (at = tt, ot = _.stateNode, at.nodeType === 8 ? at.parentNode.removeChild(ot) : at.removeChild(ot)) : tt.removeChild(_.stateNode);
    } else if (_.tag === 4) {
      if (_.child !== null) {
        tt = _.stateNode.containerInfo, nt = !0, _.child.return = _, _ = _.child;
        continue;
      }
    } else if (Ki(a, _, $), _.child !== null) {
      _.child.return = _, _ = _.child;
      continue;
    }
    if (_ === s)
      break;
    for (; _.sibling === null; ) {
      if (_.return === null || _.return === s)
        return;
      _ = _.return, _.tag === 4 && (_e = !1);
    }
    _.sibling.return = _.return, _ = _.sibling;
  }
}
function Si(a, s) {
  switch (s.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      Hi(3, s);
      return;
    case 1:
      return;
    case 5:
      var $ = s.stateNode;
      if ($ != null) {
        var _ = s.memoizedProps, _e = a !== null ? a.memoizedProps : _;
        a = s.type;
        var tt = s.updateQueue;
        if (s.updateQueue = null, tt !== null) {
          for ($[Nd] = _, a === "input" && _.type === "radio" && _.name != null && Bb($, _), pd(a, _e), s = pd(a, _), _e = 0; _e < tt.length; _e += 2) {
            var nt = tt[_e], at = tt[_e + 1];
            nt === "style" ? md($, at) : nt === "dangerouslySetInnerHTML" ? Qb($, at) : nt === "children" ? Rb($, at) : Xa($, nt, at, s);
          }
          switch (a) {
            case "input":
              Cb($, _);
              break;
            case "textarea":
              Kb($, _);
              break;
            case "select":
              s = $._wrapperState.wasMultiple, $._wrapperState.wasMultiple = !!_.multiple, a = _.value, a != null ? Hb($, !!_.multiple, a, !1) : s !== !!_.multiple && (_.defaultValue != null ? Hb($, !!_.multiple, _.defaultValue, !0) : Hb($, !!_.multiple, _.multiple ? [] : "", !1));
          }
        }
      }
      return;
    case 6:
      if (s.stateNode === null)
        throw Error(u$3(162));
      s.stateNode.nodeValue = s.memoizedProps;
      return;
    case 3:
      s = s.stateNode, s.hydrate && (s.hydrate = !1, Vc(s.containerInfo));
      return;
    case 12:
      return;
    case 13:
      if ($ = s, s.memoizedState === null ? _ = !1 : (_ = !0, $ = s.child, Ti = $f()), $ !== null)
        e:
          for (a = $; ; ) {
            if (a.tag === 5)
              tt = a.stateNode, _ ? (tt = tt.style, typeof tt.setProperty == "function" ? tt.setProperty("display", "none", "important") : tt.display = "none") : (tt = a.stateNode, _e = a.memoizedProps.style, _e = _e != null && _e.hasOwnProperty("display") ? _e.display : null, tt.style.display = ld("display", _e));
            else if (a.tag === 6)
              a.stateNode.nodeValue = _ ? "" : a.memoizedProps;
            else if (a.tag === 13 && a.memoizedState !== null && a.memoizedState.dehydrated === null) {
              tt = a.child.sibling, tt.return = a, a = tt;
              continue;
            } else if (a.child !== null) {
              a.child.return = a, a = a.child;
              continue;
            }
            if (a === $)
              break;
            for (; a.sibling === null; ) {
              if (a.return === null || a.return === $)
                break e;
              a = a.return;
            }
            a.sibling.return = a.return, a = a.sibling;
          }
      Ui(s);
      return;
    case 19:
      Ui(s);
      return;
    case 17:
      return;
  }
  throw Error(u$3(163));
}
function Ui(a) {
  var s = a.updateQueue;
  if (s !== null) {
    a.updateQueue = null;
    var $ = a.stateNode;
    $ === null && ($ = a.stateNode = new Bi()), s.forEach(function(_) {
      var _e = Vi.bind(null, a, _);
      $.has(_) || ($.add(_), _.then(_e, _e));
    });
  }
}
var Wi = typeof WeakMap == "function" ? WeakMap : Map;
function Xi(a, s, $) {
  $ = wg($, null), $.tag = 3, $.payload = { element: null };
  var _ = s.value;
  return $.callback = function() {
    Yi || (Yi = !0, Zi = _), Ci(a, s);
  }, $;
}
function $i(a, s, $) {
  $ = wg($, null), $.tag = 3;
  var _ = a.type.getDerivedStateFromError;
  if (typeof _ == "function") {
    var _e = s.value;
    $.payload = function() {
      return Ci(a, s), _(_e);
    };
  }
  var tt = a.stateNode;
  return tt !== null && typeof tt.componentDidCatch == "function" && ($.callback = function() {
    typeof _ != "function" && (aj === null ? aj = /* @__PURE__ */ new Set([this]) : aj.add(this), Ci(a, s));
    var nt = s.stack;
    this.componentDidCatch(s.value, { componentStack: nt !== null ? nt : "" });
  }), $;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
  return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : wj !== 0 ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, s, $) {
  if (s = s.mode, !(s & 2))
    return 1073741823;
  var _ = ag();
  if (!(s & 4))
    return _ === 99 ? 1073741823 : 1073741822;
  if ((W & fj) !== V)
    return U;
  if ($ !== null)
    a = hg(a, $.timeoutMs | 0 || 5e3, 250);
  else
    switch (_) {
      case 99:
        a = 1073741823;
        break;
      case 98:
        a = hg(a, 150, 100);
        break;
      case 97:
      case 96:
        a = hg(a, 5e3, 250);
        break;
      case 95:
        a = 2;
        break;
      default:
        throw Error(u$3(326));
    }
  return T !== null && a === U && --a, a;
}
function Ig(a, s) {
  if (50 < uj)
    throw uj = 0, vj = null, Error(u$3(185));
  if (a = xj(a, s), a !== null) {
    var $ = ag();
    s === 1073741823 ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a), (W & 4) === V || $ !== 98 && $ !== 99 || (tj === null ? tj = /* @__PURE__ */ new Map([[a, s]]) : ($ = tj.get(a), ($ === void 0 || $ > s) && tj.set(a, s)));
  }
}
function xj(a, s) {
  a.expirationTime < s && (a.expirationTime = s);
  var $ = a.alternate;
  $ !== null && $.expirationTime < s && ($.expirationTime = s);
  var _ = a.return, _e = null;
  if (_ === null && a.tag === 3)
    _e = a.stateNode;
  else
    for (; _ !== null; ) {
      if ($ = _.alternate, _.childExpirationTime < s && (_.childExpirationTime = s), $ !== null && $.childExpirationTime < s && ($.childExpirationTime = s), _.return === null && _.tag === 3) {
        _e = _.stateNode;
        break;
      }
      _ = _.return;
    }
  return _e !== null && (T === _e && (Bg(s), S === vi && xi(_e, U)), yi(_e, s)), _e;
}
function zj(a) {
  var s = a.lastExpiredTime;
  if (s !== 0 || (s = a.firstPendingTime, !Aj(a, s)))
    return s;
  var $ = a.lastPingedTime;
  return a = a.nextKnownPendingLevel, a = $ > a ? $ : a, 2 >= a && s !== a ? 0 : a;
}
function Z(a) {
  if (a.lastExpiredTime !== 0)
    a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
  else {
    var s = zj(a), $ = a.callbackNode;
    if (s === 0)
      $ !== null && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
    else {
      var _ = Gg();
      if (s === 1073741823 ? _ = 99 : s === 1 || s === 2 ? _ = 95 : (_ = 10 * (1073741821 - s) - 10 * (1073741821 - _), _ = 0 >= _ ? 99 : 250 >= _ ? 98 : 5250 >= _ ? 97 : 95), $ !== null) {
        var _e = a.callbackPriority;
        if (a.callbackExpirationTime === s && _e >= _)
          return;
        $ !== Tf && Kf($);
      }
      a.callbackExpirationTime = s, a.callbackPriority = _, s = s === 1073741823 ? eg(yj.bind(null, a)) : dg(_, Bj.bind(null, a), { timeout: 10 * (1073741821 - s) - $f() }), a.callbackNode = s;
    }
  }
}
function Bj(a, s) {
  if (wj = 0, s)
    return s = Gg(), Cj(a, s), Z(a), null;
  var $ = zj(a);
  if ($ !== 0) {
    if (s = a.callbackNode, (W & (fj | gj)) !== V)
      throw Error(u$3(327));
    if (Dj(), a === T && $ === U || Ej(a, $), X !== null) {
      var _ = W;
      W |= fj;
      var _e = Fj();
      do
        try {
          Gj();
          break;
        } catch (at) {
          Hj(a, at);
        }
      while (!0);
      if (ng(), W = _, cj.current = _e, S === hj)
        throw s = kj, Ej(a, $), xi(a, $), Z(a), s;
      if (X === null)
        switch (_e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = $, _ = S, T = null, _) {
          case ti:
          case hj:
            throw Error(u$3(345));
          case ij:
            Cj(a, 2 < $ ? 2 : $);
            break;
          case ui:
            if (xi(a, $), _ = a.lastSuspendedTime, $ === _ && (a.nextKnownPendingLevel = Ij(_e)), lj === 1073741823 && (_e = Ti + pj - $f(), 10 < _e)) {
              if (oj) {
                var tt = a.lastPingedTime;
                if (tt === 0 || tt >= $) {
                  a.lastPingedTime = $, Ej(a, $);
                  break;
                }
              }
              if (tt = zj(a), tt !== 0 && tt !== $)
                break;
              if (_ !== 0 && _ !== $) {
                a.lastPingedTime = _;
                break;
              }
              a.timeoutHandle = Hd(Jj.bind(null, a), _e);
              break;
            }
            Jj(a);
            break;
          case vi:
            if (xi(a, $), _ = a.lastSuspendedTime, $ === _ && (a.nextKnownPendingLevel = Ij(_e)), oj && (_e = a.lastPingedTime, _e === 0 || _e >= $)) {
              a.lastPingedTime = $, Ej(a, $);
              break;
            }
            if (_e = zj(a), _e !== 0 && _e !== $)
              break;
            if (_ !== 0 && _ !== $) {
              a.lastPingedTime = _;
              break;
            }
            if (mj !== 1073741823 ? _ = 10 * (1073741821 - mj) - $f() : lj === 1073741823 ? _ = 0 : (_ = 10 * (1073741821 - lj) - 5e3, _e = $f(), $ = 10 * (1073741821 - $) - _e, _ = _e - _, 0 > _ && (_ = 0), _ = (120 > _ ? 120 : 480 > _ ? 480 : 1080 > _ ? 1080 : 1920 > _ ? 1920 : 3e3 > _ ? 3e3 : 4320 > _ ? 4320 : 1960 * bj(_ / 1960)) - _, $ < _ && (_ = $)), 10 < _) {
              a.timeoutHandle = Hd(Jj.bind(null, a), _);
              break;
            }
            Jj(a);
            break;
          case jj:
            if (lj !== 1073741823 && nj !== null) {
              tt = lj;
              var nt = nj;
              if (_ = nt.busyMinDurationMs | 0, 0 >= _ ? _ = 0 : (_e = nt.busyDelayMs | 0, tt = $f() - (10 * (1073741821 - tt) - (nt.timeoutMs | 0 || 5e3)), _ = tt <= _e ? 0 : _e + _ - tt), 10 < _) {
                xi(a, $), a.timeoutHandle = Hd(Jj.bind(null, a), _);
                break;
              }
            }
            Jj(a);
            break;
          default:
            throw Error(u$3(329));
        }
      if (Z(a), a.callbackNode === s)
        return Bj.bind(null, a);
    }
  }
  return null;
}
function yj(a) {
  var s = a.lastExpiredTime;
  if (s = s !== 0 ? s : 1073741823, (W & (fj | gj)) !== V)
    throw Error(u$3(327));
  if (Dj(), a === T && s === U || Ej(a, s), X !== null) {
    var $ = W;
    W |= fj;
    var _ = Fj();
    do
      try {
        Kj();
        break;
      } catch (_e) {
        Hj(a, _e);
      }
    while (!0);
    if (ng(), W = $, cj.current = _, S === hj)
      throw $ = kj, Ej(a, s), xi(a, s), Z(a), $;
    if (X !== null)
      throw Error(u$3(261));
    a.finishedWork = a.current.alternate, a.finishedExpirationTime = s, T = null, Jj(a), Z(a);
  }
  return null;
}
function Lj() {
  if (tj !== null) {
    var a = tj;
    tj = null, a.forEach(function(s, $) {
      Cj($, s), Z($);
    }), gg();
  }
}
function Mj(a, s) {
  var $ = W;
  W |= 1;
  try {
    return a(s);
  } finally {
    W = $, W === V && gg();
  }
}
function Nj(a, s) {
  var $ = W;
  W &= -2, W |= ej;
  try {
    return a(s);
  } finally {
    W = $, W === V && gg();
  }
}
function Ej(a, s) {
  a.finishedWork = null, a.finishedExpirationTime = 0;
  var $ = a.timeoutHandle;
  if ($ !== -1 && (a.timeoutHandle = -1, Id($)), X !== null)
    for ($ = X.return; $ !== null; ) {
      var _ = $;
      switch (_.tag) {
        case 1:
          _ = _.type.childContextTypes, _ != null && Df();
          break;
        case 3:
          eh(), H(K), H(J);
          break;
        case 5:
          gh(_);
          break;
        case 4:
          eh();
          break;
        case 13:
          H(M);
          break;
        case 19:
          H(M);
          break;
        case 10:
          og(_);
      }
      $ = $.return;
    }
  T = a, X = Sg(a.current, null), U = s, S = ti, kj = null, mj = lj = 1073741823, nj = null, wi = 0, oj = !1;
}
function Hj(a, s) {
  do {
    try {
      if (ng(), jh.current = sh, mh)
        for (var $ = N.memoizedState; $ !== null; ) {
          var _ = $.queue;
          _ !== null && (_.pending = null), $ = $.next;
        }
      if (lh = 0, P = O = N = null, mh = !1, X === null || X.return === null)
        return S = hj, kj = s, X = null;
      e: {
        var _e = a, tt = X.return, nt = X, at = s;
        if (s = U, nt.effectTag |= 2048, nt.firstEffect = nt.lastEffect = null, at !== null && typeof at == "object" && typeof at.then == "function") {
          var ot = at;
          if (!(nt.mode & 2)) {
            var rt = nt.alternate;
            rt ? (nt.updateQueue = rt.updateQueue, nt.memoizedState = rt.memoizedState, nt.expirationTime = rt.expirationTime) : (nt.updateQueue = null, nt.memoizedState = null);
          }
          var st = (M.current & 1) !== 0, lt = tt;
          do {
            var et;
            if (et = lt.tag === 13) {
              var it = lt.memoizedState;
              if (it !== null)
                et = it.dehydrated !== null;
              else {
                var ut = lt.memoizedProps;
                et = ut.fallback === void 0 ? !1 : ut.unstable_avoidThisFallback !== !0 ? !0 : !st;
              }
            }
            if (et) {
              var ft = lt.updateQueue;
              if (ft === null) {
                var ht = /* @__PURE__ */ new Set();
                ht.add(ot), lt.updateQueue = ht;
              } else
                ft.add(ot);
              if (!(lt.mode & 2)) {
                if (lt.effectTag |= 64, nt.effectTag &= -2981, nt.tag === 1)
                  if (nt.alternate === null)
                    nt.tag = 17;
                  else {
                    var dt = wg(1073741823, null);
                    dt.tag = 2, xg(nt, dt);
                  }
                nt.expirationTime = 1073741823;
                break e;
              }
              at = void 0, nt = s;
              var gt = _e.pingCache;
              if (gt === null ? (gt = _e.pingCache = new Wi(), at = /* @__PURE__ */ new Set(), gt.set(ot, at)) : (at = gt.get(ot), at === void 0 && (at = /* @__PURE__ */ new Set(), gt.set(ot, at))), !at.has(nt)) {
                at.add(nt);
                var pt = Oj.bind(null, _e, ot, nt);
                ot.then(pt, pt);
              }
              lt.effectTag |= 4096, lt.expirationTime = s;
              break e;
            }
            lt = lt.return;
          } while (lt !== null);
          at = Error((pb(nt.type) || "A React component") + ` suspended while rendering, but no fallback UI was specified.

Add a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.` + qb(nt));
        }
        S !== jj && (S = ij), at = Ai(at, nt), lt = tt;
        do {
          switch (lt.tag) {
            case 3:
              ot = at, lt.effectTag |= 4096, lt.expirationTime = s;
              var mt = Xi(lt, ot, s);
              yg(lt, mt);
              break e;
            case 1:
              ot = at;
              var ct = lt.type, vt = lt.stateNode;
              if (!(lt.effectTag & 64) && (typeof ct.getDerivedStateFromError == "function" || vt !== null && typeof vt.componentDidCatch == "function" && (aj === null || !aj.has(vt)))) {
                lt.effectTag |= 4096, lt.expirationTime = s;
                var At = $i(lt, ot, s);
                yg(lt, At);
                break e;
              }
          }
          lt = lt.return;
        } while (lt !== null);
      }
      X = Pj(X);
    } catch (xt) {
      s = xt;
      continue;
    }
    break;
  } while (!0);
}
function Fj() {
  var a = cj.current;
  return cj.current = sh, a === null ? sh : a;
}
function Ag(a, s) {
  a < lj && 2 < a && (lj = a), s !== null && a < mj && 2 < a && (mj = a, nj = s);
}
function Bg(a) {
  a > wi && (wi = a);
}
function Kj() {
  for (; X !== null; )
    X = Qj(X);
}
function Gj() {
  for (; X !== null && !Uf(); )
    X = Qj(X);
}
function Qj(a) {
  var s = Rj(a.alternate, a, U);
  return a.memoizedProps = a.pendingProps, s === null && (s = Pj(a)), dj.current = null, s;
}
function Pj(a) {
  X = a;
  do {
    var s = X.alternate;
    if (a = X.return, X.effectTag & 2048) {
      if (s = zi(X), s !== null)
        return s.effectTag &= 2047, s;
      a !== null && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
    } else {
      if (s = si(s, X, U), U === 1 || X.childExpirationTime !== 1) {
        for (var $ = 0, _ = X.child; _ !== null; ) {
          var _e = _.expirationTime, tt = _.childExpirationTime;
          _e > $ && ($ = _e), tt > $ && ($ = tt), _ = _.sibling;
        }
        X.childExpirationTime = $;
      }
      if (s !== null)
        return s;
      a !== null && !(a.effectTag & 2048) && (a.firstEffect === null && (a.firstEffect = X.firstEffect), X.lastEffect !== null && (a.lastEffect !== null && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (a.lastEffect !== null ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
    }
    if (s = X.sibling, s !== null)
      return s;
    X = a;
  } while (X !== null);
  return S === ti && (S = jj), null;
}
function Ij(a) {
  var s = a.expirationTime;
  return a = a.childExpirationTime, s > a ? s : a;
}
function Jj(a) {
  var s = ag();
  return cg(99, Sj.bind(null, a, s)), null;
}
function Sj(a, s) {
  do
    Dj();
  while (rj !== null);
  if ((W & (fj | gj)) !== V)
    throw Error(u$3(327));
  var $ = a.finishedWork, _ = a.finishedExpirationTime;
  if ($ === null)
    return null;
  if (a.finishedWork = null, a.finishedExpirationTime = 0, $ === a.current)
    throw Error(u$3(177));
  a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90, a.nextKnownPendingLevel = 0;
  var _e = Ij($);
  if (a.firstPendingTime = _e, _ <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : _ <= a.firstSuspendedTime && (a.firstSuspendedTime = _ - 1), _ <= a.lastPingedTime && (a.lastPingedTime = 0), _ <= a.lastExpiredTime && (a.lastExpiredTime = 0), a === T && (X = T = null, U = 0), 1 < $.effectTag ? $.lastEffect !== null ? ($.lastEffect.nextEffect = $, _e = $.firstEffect) : _e = $ : _e = $.firstEffect, _e !== null) {
    var tt = W;
    W |= gj, dj.current = null, Dd = fd;
    var nt = xd();
    if (yd(nt)) {
      if ("selectionStart" in nt)
        var at = { start: nt.selectionStart, end: nt.selectionEnd };
      else
        e: {
          at = (at = nt.ownerDocument) && at.defaultView || window;
          var ot = at.getSelection && at.getSelection();
          if (ot && ot.rangeCount !== 0) {
            at = ot.anchorNode;
            var rt = ot.anchorOffset, st = ot.focusNode;
            ot = ot.focusOffset;
            try {
              at.nodeType, st.nodeType;
            } catch {
              at = null;
              break e;
            }
            var lt = 0, et = -1, it = -1, ut = 0, ft = 0, ht = nt, dt = null;
            t:
              for (; ; ) {
                for (var gt; ht !== at || rt !== 0 && ht.nodeType !== 3 || (et = lt + rt), ht !== st || ot !== 0 && ht.nodeType !== 3 || (it = lt + ot), ht.nodeType === 3 && (lt += ht.nodeValue.length), (gt = ht.firstChild) !== null; )
                  dt = ht, ht = gt;
                for (; ; ) {
                  if (ht === nt)
                    break t;
                  if (dt === at && ++ut === rt && (et = lt), dt === st && ++ft === ot && (it = lt), (gt = ht.nextSibling) !== null)
                    break;
                  ht = dt, dt = ht.parentNode;
                }
                ht = gt;
              }
            at = et === -1 || it === -1 ? null : { start: et, end: it };
          } else
            at = null;
        }
      at = at || { start: 0, end: 0 };
    } else
      at = null;
    Ed = { activeElementDetached: null, focusedElem: nt, selectionRange: at }, fd = !1, Y = _e;
    do
      try {
        Tj();
      } catch (bt) {
        if (Y === null)
          throw Error(u$3(330));
        Ei(Y, bt), Y = Y.nextEffect;
      }
    while (Y !== null);
    Y = _e;
    do
      try {
        for (nt = a, at = s; Y !== null; ) {
          var pt = Y.effectTag;
          if (pt & 16 && Rb(Y.stateNode, ""), pt & 128) {
            var mt = Y.alternate;
            if (mt !== null) {
              var ct = mt.ref;
              ct !== null && (typeof ct == "function" ? ct(null) : ct.current = null);
            }
          }
          switch (pt & 1038) {
            case 2:
              Pi(Y), Y.effectTag &= -3;
              break;
            case 6:
              Pi(Y), Y.effectTag &= -3, Si(Y.alternate, Y);
              break;
            case 1024:
              Y.effectTag &= -1025;
              break;
            case 1028:
              Y.effectTag &= -1025, Si(Y.alternate, Y);
              break;
            case 4:
              Si(Y.alternate, Y);
              break;
            case 8:
              rt = Y, Mi(nt, rt, at), Ni(rt);
          }
          Y = Y.nextEffect;
        }
      } catch (bt) {
        if (Y === null)
          throw Error(u$3(330));
        Ei(Y, bt), Y = Y.nextEffect;
      }
    while (Y !== null);
    if (ct = Ed, mt = xd(), pt = ct.focusedElem, at = ct.selectionRange, mt !== pt && pt && pt.ownerDocument && wd(pt.ownerDocument.documentElement, pt)) {
      for (at !== null && yd(pt) && (mt = at.start, ct = at.end, ct === void 0 && (ct = mt), "selectionStart" in pt ? (pt.selectionStart = mt, pt.selectionEnd = Math.min(ct, pt.value.length)) : (ct = (mt = pt.ownerDocument || document) && mt.defaultView || window, ct.getSelection && (ct = ct.getSelection(), rt = pt.textContent.length, nt = Math.min(at.start, rt), at = at.end === void 0 ? nt : Math.min(at.end, rt), !ct.extend && nt > at && (rt = at, at = nt, nt = rt), rt = vd(pt, nt), st = vd(pt, at), rt && st && (ct.rangeCount !== 1 || ct.anchorNode !== rt.node || ct.anchorOffset !== rt.offset || ct.focusNode !== st.node || ct.focusOffset !== st.offset) && (mt = mt.createRange(), mt.setStart(rt.node, rt.offset), ct.removeAllRanges(), nt > at ? (ct.addRange(mt), ct.extend(st.node, st.offset)) : (mt.setEnd(st.node, st.offset), ct.addRange(mt)))))), mt = [], ct = pt; ct = ct.parentNode; )
        ct.nodeType === 1 && mt.push({
          element: ct,
          left: ct.scrollLeft,
          top: ct.scrollTop
        });
      for (typeof pt.focus == "function" && pt.focus(), pt = 0; pt < mt.length; pt++)
        ct = mt[pt], ct.element.scrollLeft = ct.left, ct.element.scrollTop = ct.top;
    }
    fd = !!Dd, Ed = Dd = null, a.current = $, Y = _e;
    do
      try {
        for (pt = a; Y !== null; ) {
          var vt = Y.effectTag;
          if (vt & 36 && Ji(pt, Y.alternate, Y), vt & 128) {
            mt = void 0;
            var At = Y.ref;
            if (At !== null) {
              var xt = Y.stateNode;
              switch (Y.tag) {
                case 5:
                  mt = xt;
                  break;
                default:
                  mt = xt;
              }
              typeof At == "function" ? At(mt) : At.current = mt;
            }
          }
          Y = Y.nextEffect;
        }
      } catch (bt) {
        if (Y === null)
          throw Error(u$3(330));
        Ei(Y, bt), Y = Y.nextEffect;
      }
    while (Y !== null);
    Y = null, Vf(), W = tt;
  } else
    a.current = $;
  if (qj)
    qj = !1, rj = a, sj = s;
  else
    for (Y = _e; Y !== null; )
      s = Y.nextEffect, Y.nextEffect = null, Y = s;
  if (s = a.firstPendingTime, s === 0 && (aj = null), s === 1073741823 ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0, typeof Uj == "function" && Uj($.stateNode, _), Z(a), Yi)
    throw Yi = !1, a = Zi, Zi = null, a;
  return (W & ej) !== V || gg(), null;
}
function Tj() {
  for (; Y !== null; ) {
    var a = Y.effectTag;
    a & 256 && Gi(Y.alternate, Y), !(a & 512) || qj || (qj = !0, dg(97, function() {
      return Dj(), null;
    })), Y = Y.nextEffect;
  }
}
function Dj() {
  if (sj !== 90) {
    var a = 97 < sj ? 97 : sj;
    return sj = 90, cg(a, Vj);
  }
}
function Vj() {
  if (rj === null)
    return !1;
  var a = rj;
  if (rj = null, (W & (fj | gj)) !== V)
    throw Error(u$3(331));
  var s = W;
  for (W |= gj, a = a.current.firstEffect; a !== null; ) {
    try {
      var $ = a;
      if ($.effectTag & 512)
        switch ($.tag) {
          case 0:
          case 11:
          case 15:
          case 22:
            Hi(5, $), Ii(5, $);
        }
    } catch (_) {
      if (a === null)
        throw Error(u$3(330));
      Ei(a, _);
    }
    $ = a.nextEffect, a.nextEffect = null, a = $;
  }
  return W = s, gg(), !0;
}
function Wj(a, s, $) {
  s = Ai($, s), s = Xi(a, s, 1073741823), xg(a, s), a = xj(a, 1073741823), a !== null && Z(a);
}
function Ei(a, s) {
  if (a.tag === 3)
    Wj(a, a, s);
  else
    for (var $ = a.return; $ !== null; ) {
      if ($.tag === 3) {
        Wj($, a, s);
        break;
      } else if ($.tag === 1) {
        var _ = $.stateNode;
        if (typeof $.type.getDerivedStateFromError == "function" || typeof _.componentDidCatch == "function" && (aj === null || !aj.has(_))) {
          a = Ai(s, a), a = $i($, a, 1073741823), xg($, a), $ = xj($, 1073741823), $ !== null && Z($);
          break;
        }
      }
      $ = $.return;
    }
}
function Oj(a, s, $) {
  var _ = a.pingCache;
  _ !== null && _.delete(s), T === a && U === $ ? S === vi || S === ui && lj === 1073741823 && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, $) && (s = a.lastPingedTime, s !== 0 && s < $ || (a.lastPingedTime = $, Z(a)));
}
function Vi(a, s) {
  var $ = a.stateNode;
  $ !== null && $.delete(s), s = 0, s === 0 && (s = Gg(), s = Hg(s, a, null)), a = xj(a, s), a !== null && Z(a);
}
var Rj;
Rj = function(a, s, $) {
  var _ = s.expirationTime;
  if (a !== null) {
    var _e = s.pendingProps;
    if (a.memoizedProps !== _e || K.current)
      rg = !0;
    else {
      if (_ < $) {
        switch (rg = !1, s.tag) {
          case 3:
            hi(s), Xh();
            break;
          case 5:
            if (fh(s), s.mode & 4 && $ !== 1 && _e.hidden)
              return s.expirationTime = s.childExpirationTime = 1, null;
            break;
          case 1:
            L(s.type) && Gf(s);
            break;
          case 4:
            dh(s, s.stateNode.containerInfo);
            break;
          case 10:
            _ = s.memoizedProps.value, _e = s.type._context, I(jg, _e._currentValue), _e._currentValue = _;
            break;
          case 13:
            if (s.memoizedState !== null)
              return _ = s.child.childExpirationTime, _ !== 0 && _ >= $ ? ji(a, s, $) : (I(M, M.current & 1), s = $h(a, s, $), s !== null ? s.sibling : null);
            I(M, M.current & 1);
            break;
          case 19:
            if (_ = s.childExpirationTime >= $, a.effectTag & 64) {
              if (_)
                return mi(a, s, $);
              s.effectTag |= 64;
            }
            if (_e = s.memoizedState, _e !== null && (_e.rendering = null, _e.tail = null), I(M, M.current), !_)
              return null;
        }
        return $h(a, s, $);
      }
      rg = !1;
    }
  } else
    rg = !1;
  switch (s.expirationTime = 0, s.tag) {
    case 2:
      if (_ = s.type, a !== null && (a.alternate = null, s.alternate = null, s.effectTag |= 2), a = s.pendingProps, _e = Cf(s, J.current), qg(s, $), _e = oh(
        null,
        s,
        _,
        a,
        _e,
        $
      ), s.effectTag |= 1, typeof _e == "object" && _e !== null && typeof _e.render == "function" && _e.$$typeof === void 0) {
        if (s.tag = 1, s.memoizedState = null, s.updateQueue = null, L(_)) {
          var tt = !0;
          Gf(s);
        } else
          tt = !1;
        s.memoizedState = _e.state !== null && _e.state !== void 0 ? _e.state : null, ug(s);
        var nt = _.getDerivedStateFromProps;
        typeof nt == "function" && Fg(s, _, nt, a), _e.updater = Jg, s.stateNode = _e, _e._reactInternalFiber = s, Ng(s, _, a, $), s = gi(null, s, _, !0, tt, $);
      } else
        s.tag = 0, R(null, s, _e, $), s = s.child;
      return s;
    case 16:
      e: {
        if (_e = s.elementType, a !== null && (a.alternate = null, s.alternate = null, s.effectTag |= 2), a = s.pendingProps, ob(_e), _e._status !== 1)
          throw _e._result;
        switch (_e = _e._result, s.type = _e, tt = s.tag = Xj(_e), a = ig(_e, a), tt) {
          case 0:
            s = di(null, s, _e, a, $);
            break e;
          case 1:
            s = fi(null, s, _e, a, $);
            break e;
          case 11:
            s = Zh(null, s, _e, a, $);
            break e;
          case 14:
            s = ai(null, s, _e, ig(_e.type, a), _, $);
            break e;
        }
        throw Error(u$3(306, _e, ""));
      }
      return s;
    case 0:
      return _ = s.type, _e = s.pendingProps, _e = s.elementType === _ ? _e : ig(_, _e), di(a, s, _, _e, $);
    case 1:
      return _ = s.type, _e = s.pendingProps, _e = s.elementType === _ ? _e : ig(_, _e), fi(a, s, _, _e, $);
    case 3:
      if (hi(s), _ = s.updateQueue, a === null || _ === null)
        throw Error(u$3(282));
      if (_ = s.pendingProps, _e = s.memoizedState, _e = _e !== null ? _e.element : null, vg(a, s), zg(s, _, null, $), _ = s.memoizedState.element, _ === _e)
        Xh(), s = $h(a, s, $);
      else {
        if ((_e = s.stateNode.hydrate) && (Ph = Jd(s.stateNode.containerInfo.firstChild), Oh = s, _e = Qh = !0), _e)
          for ($ = Yg(s, null, _, $), s.child = $; $; )
            $.effectTag = $.effectTag & -3 | 1024, $ = $.sibling;
        else
          R(a, s, _, $), Xh();
        s = s.child;
      }
      return s;
    case 5:
      return fh(s), a === null && Uh(s), _ = s.type, _e = s.pendingProps, tt = a !== null ? a.memoizedProps : null, nt = _e.children, Gd(_, _e) ? nt = null : tt !== null && Gd(_, tt) && (s.effectTag |= 16), ei(a, s), s.mode & 4 && $ !== 1 && _e.hidden ? (s.expirationTime = s.childExpirationTime = 1, s = null) : (R(a, s, nt, $), s = s.child), s;
    case 6:
      return a === null && Uh(s), null;
    case 13:
      return ji(a, s, $);
    case 4:
      return dh(s, s.stateNode.containerInfo), _ = s.pendingProps, a === null ? s.child = Xg(s, null, _, $) : R(a, s, _, $), s.child;
    case 11:
      return _ = s.type, _e = s.pendingProps, _e = s.elementType === _ ? _e : ig(_, _e), Zh(a, s, _, _e, $);
    case 7:
      return R(a, s, s.pendingProps, $), s.child;
    case 8:
      return R(
        a,
        s,
        s.pendingProps.children,
        $
      ), s.child;
    case 12:
      return R(a, s, s.pendingProps.children, $), s.child;
    case 10:
      e: {
        _ = s.type._context, _e = s.pendingProps, nt = s.memoizedProps, tt = _e.value;
        var at = s.type._context;
        if (I(jg, at._currentValue), at._currentValue = tt, nt !== null)
          if (at = nt.value, tt = $e(at, tt) ? 0 : (typeof _._calculateChangedBits == "function" ? _._calculateChangedBits(at, tt) : 1073741823) | 0, tt === 0) {
            if (nt.children === _e.children && !K.current) {
              s = $h(a, s, $);
              break e;
            }
          } else
            for (at = s.child, at !== null && (at.return = s); at !== null; ) {
              var ot = at.dependencies;
              if (ot !== null) {
                nt = at.child;
                for (var rt = ot.firstContext; rt !== null; ) {
                  if (rt.context === _ && rt.observedBits & tt) {
                    at.tag === 1 && (rt = wg($, null), rt.tag = 2, xg(at, rt)), at.expirationTime < $ && (at.expirationTime = $), rt = at.alternate, rt !== null && rt.expirationTime < $ && (rt.expirationTime = $), pg(at.return, $), ot.expirationTime < $ && (ot.expirationTime = $);
                    break;
                  }
                  rt = rt.next;
                }
              } else
                nt = at.tag === 10 && at.type === s.type ? null : at.child;
              if (nt !== null)
                nt.return = at;
              else
                for (nt = at; nt !== null; ) {
                  if (nt === s) {
                    nt = null;
                    break;
                  }
                  if (at = nt.sibling, at !== null) {
                    at.return = nt.return, nt = at;
                    break;
                  }
                  nt = nt.return;
                }
              at = nt;
            }
        R(a, s, _e.children, $), s = s.child;
      }
      return s;
    case 9:
      return _e = s.type, tt = s.pendingProps, _ = tt.children, qg(s, $), _e = sg(_e, tt.unstable_observedBits), _ = _(_e), s.effectTag |= 1, R(a, s, _, $), s.child;
    case 14:
      return _e = s.type, tt = ig(_e, s.pendingProps), tt = ig(_e.type, tt), ai(a, s, _e, tt, _, $);
    case 15:
      return ci(a, s, s.type, s.pendingProps, _, $);
    case 17:
      return _ = s.type, _e = s.pendingProps, _e = s.elementType === _ ? _e : ig(_, _e), a !== null && (a.alternate = null, s.alternate = null, s.effectTag |= 2), s.tag = 1, L(_) ? (a = !0, Gf(s)) : a = !1, qg(s, $), Lg(s, _, _e), Ng(s, _, _e, $), gi(
        null,
        s,
        _,
        !0,
        a,
        $
      );
    case 19:
      return mi(a, s, $);
  }
  throw Error(u$3(156, s.tag));
};
var Uj = null, Li = null;
function Yj(a) {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
    return !1;
  var s = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (s.isDisabled || !s.supportsFiber)
    return !0;
  try {
    var $ = s.inject(a);
    Uj = function(_) {
      try {
        s.onCommitFiberRoot($, _, void 0, (_.current.effectTag & 64) === 64);
      } catch {
      }
    }, Li = function(_) {
      try {
        s.onCommitFiberUnmount($, _);
      } catch {
      }
    };
  } catch {
  }
  return !0;
}
function Zj(a, s, $, _) {
  this.tag = a, this.key = $, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = s, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = _, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
}
function Sh(a, s, $, _) {
  return new Zj(a, s, $, _);
}
function bi(a) {
  return a = a.prototype, !(!a || !a.isReactComponent);
}
function Xj(a) {
  if (typeof a == "function")
    return bi(a) ? 1 : 0;
  if (a != null) {
    if (a = a.$$typeof, a === gb)
      return 11;
    if (a === jb)
      return 14;
  }
  return 2;
}
function Sg(a, s) {
  var $ = a.alternate;
  return $ === null ? ($ = Sh(a.tag, s, a.key, a.mode), $.elementType = a.elementType, $.type = a.type, $.stateNode = a.stateNode, $.alternate = a, a.alternate = $) : ($.pendingProps = s, $.effectTag = 0, $.nextEffect = null, $.firstEffect = null, $.lastEffect = null), $.childExpirationTime = a.childExpirationTime, $.expirationTime = a.expirationTime, $.child = a.child, $.memoizedProps = a.memoizedProps, $.memoizedState = a.memoizedState, $.updateQueue = a.updateQueue, s = a.dependencies, $.dependencies = s === null ? null : {
    expirationTime: s.expirationTime,
    firstContext: s.firstContext,
    responders: s.responders
  }, $.sibling = a.sibling, $.index = a.index, $.ref = a.ref, $;
}
function Ug(a, s, $, _, _e, tt) {
  var nt = 2;
  if (_ = a, typeof a == "function")
    bi(a) && (nt = 1);
  else if (typeof a == "string")
    nt = 5;
  else
    e:
      switch (a) {
        case ab:
          return Wg($.children, _e, tt, s);
        case fb:
          nt = 8, _e |= 7;
          break;
        case bb:
          nt = 8, _e |= 1;
          break;
        case cb:
          return a = Sh(12, $, s, _e | 8), a.elementType = cb, a.type = cb, a.expirationTime = tt, a;
        case hb:
          return a = Sh(13, $, s, _e), a.type = hb, a.elementType = hb, a.expirationTime = tt, a;
        case ib:
          return a = Sh(19, $, s, _e), a.elementType = ib, a.expirationTime = tt, a;
        default:
          if (typeof a == "object" && a !== null)
            switch (a.$$typeof) {
              case db:
                nt = 10;
                break e;
              case eb:
                nt = 9;
                break e;
              case gb:
                nt = 11;
                break e;
              case jb:
                nt = 14;
                break e;
              case kb:
                nt = 16, _ = null;
                break e;
              case lb:
                nt = 22;
                break e;
            }
          throw Error(u$3(130, a == null ? a : typeof a, ""));
      }
  return s = Sh(nt, $, s, _e), s.elementType = a, s.type = _, s.expirationTime = tt, s;
}
function Wg(a, s, $, _) {
  return a = Sh(7, a, _, s), a.expirationTime = $, a;
}
function Tg(a, s, $) {
  return a = Sh(6, a, null, s), a.expirationTime = $, a;
}
function Vg(a, s, $) {
  return s = Sh(4, a.children !== null ? a.children : [], a.key, s), s.expirationTime = $, s.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation }, s;
}
function ak(a, s, $) {
  this.tag = s, this.current = null, this.containerInfo = a, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = $, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, s) {
  var $ = a.firstSuspendedTime;
  return a = a.lastSuspendedTime, $ !== 0 && $ >= s && a <= s;
}
function xi(a, s) {
  var $ = a.firstSuspendedTime, _ = a.lastSuspendedTime;
  $ < s && (a.firstSuspendedTime = s), (_ > s || $ === 0) && (a.lastSuspendedTime = s), s <= a.lastPingedTime && (a.lastPingedTime = 0), s <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, s) {
  s > a.firstPendingTime && (a.firstPendingTime = s);
  var $ = a.firstSuspendedTime;
  $ !== 0 && (s >= $ ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : s >= a.lastSuspendedTime && (a.lastSuspendedTime = s + 1), s > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = s));
}
function Cj(a, s) {
  var $ = a.lastExpiredTime;
  ($ === 0 || $ > s) && (a.lastExpiredTime = s);
}
function bk(a, s, $, _) {
  var _e = s.current, tt = Gg(), nt = Dg.suspense;
  tt = Hg(tt, _e, nt);
  e:
    if ($) {
      $ = $._reactInternalFiber;
      t: {
        if (dc($) !== $ || $.tag !== 1)
          throw Error(u$3(170));
        var at = $;
        do {
          switch (at.tag) {
            case 3:
              at = at.stateNode.context;
              break t;
            case 1:
              if (L(at.type)) {
                at = at.stateNode.__reactInternalMemoizedMergedChildContext;
                break t;
              }
          }
          at = at.return;
        } while (at !== null);
        throw Error(u$3(171));
      }
      if ($.tag === 1) {
        var ot = $.type;
        if (L(ot)) {
          $ = Ff($, ot, at);
          break e;
        }
      }
      $ = at;
    } else
      $ = Af;
  return s.context === null ? s.context = $ : s.pendingContext = $, s = wg(tt, nt), s.payload = { element: a }, _ = _ === void 0 ? null : _, _ !== null && (s.callback = _), xg(_e, s), Ig(_e, tt), tt;
}
function ck(a) {
  if (a = a.current, !a.child)
    return null;
  switch (a.child.tag) {
    case 5:
      return a.child.stateNode;
    default:
      return a.child.stateNode;
  }
}
function dk(a, s) {
  a = a.memoizedState, a !== null && a.dehydrated !== null && a.retryTime < s && (a.retryTime = s);
}
function ek(a, s) {
  dk(a, s), (a = a.alternate) && dk(a, s);
}
function fk(a, s, $) {
  $ = $ != null && $.hydrate === !0;
  var _ = new ak(a, s, $), _e = Sh(3, null, null, s === 2 ? 7 : s === 1 ? 3 : 0);
  _.current = _e, _e.stateNode = _, ug(_e), a[Od] = _.current, $ && s !== 0 && Jc(a, a.nodeType === 9 ? a : a.ownerDocument), this._internalRoot = _;
}
fk.prototype.render = function(a) {
  bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
  var a = this._internalRoot, s = a.containerInfo;
  bk(null, a, null, function() {
    s[Od] = null;
  });
};
function gk(a) {
  return !(!a || a.nodeType !== 1 && a.nodeType !== 9 && a.nodeType !== 11 && (a.nodeType !== 8 || a.nodeValue !== " react-mount-point-unstable "));
}
function hk(a, s) {
  if (s || (s = a ? a.nodeType === 9 ? a.documentElement : a.firstChild : null, s = !(!s || s.nodeType !== 1 || !s.hasAttribute("data-reactroot"))), !s)
    for (var $; $ = a.lastChild; )
      a.removeChild($);
  return new fk(a, 0, s ? { hydrate: !0 } : void 0);
}
function ik(a, s, $, _, _e) {
  var tt = $._reactRootContainer;
  if (tt) {
    var nt = tt._internalRoot;
    if (typeof _e == "function") {
      var at = _e;
      _e = function() {
        var rt = ck(nt);
        at.call(rt);
      };
    }
    bk(s, nt, a, _e);
  } else {
    if (tt = $._reactRootContainer = hk($, _), nt = tt._internalRoot, typeof _e == "function") {
      var ot = _e;
      _e = function() {
        var rt = ck(nt);
        ot.call(rt);
      };
    }
    Nj(function() {
      bk(s, nt, a, _e);
    });
  }
  return ck(nt);
}
function jk(a, s, $) {
  var _ = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: $a, key: _ == null ? null : "" + _, children: a, containerInfo: s, implementation: $ };
}
wc = function(a) {
  if (a.tag === 13) {
    var s = hg(Gg(), 150, 100);
    Ig(a, s), ek(a, s);
  }
};
xc = function(a) {
  a.tag === 13 && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
  if (a.tag === 13) {
    var s = Gg();
    s = Hg(s, a, null), Ig(a, s), ek(a, s);
  }
};
za = function(a, s, $) {
  switch (s) {
    case "input":
      if (Cb(a, $), s = $.name, $.type === "radio" && s != null) {
        for ($ = a; $.parentNode; )
          $ = $.parentNode;
        for ($ = $.querySelectorAll("input[name=" + JSON.stringify("" + s) + '][type="radio"]'), s = 0; s < $.length; s++) {
          var _ = $[s];
          if (_ !== a && _.form === a.form) {
            var _e = Qd(_);
            if (!_e)
              throw Error(u$3(90));
            yb(_), Cb(_, _e);
          }
        }
      }
      break;
    case "textarea":
      Kb(a, $);
      break;
    case "select":
      s = $.value, s != null && Hb(a, !!$.multiple, s, !1);
  }
};
Fa = Mj;
Ga = function(a, s, $, _, _e) {
  var tt = W;
  W |= 4;
  try {
    return cg(98, a.bind(null, s, $, _, _e));
  } finally {
    W = tt, W === V && gg();
  }
};
Ha = function() {
  (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, s) {
  var $ = W;
  W |= 2;
  try {
    return a(s);
  } finally {
    W = $, W === V && gg();
  }
};
function kk(a, s) {
  var $ = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!gk(s))
    throw Error(u$3(200));
  return jk(a, s, null, $);
}
var lk = { Events: [Nc, Pd, Qd, xa, ta, Xd, function(a) {
  jc(a, Wd);
}, Da, Ea, id$2, mc, Dj, { current: !1 }] };
(function(a) {
  var s = a.findFiberByHostInstance;
  return Yj(n$4({}, a, { overrideHookState: null, overrideProps: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Wa.ReactCurrentDispatcher, findHostInstanceByFiber: function($) {
    return $ = hc($), $ === null ? null : $.stateNode;
  }, findFiberByHostInstance: function($) {
    return s ? s($) : null;
  }, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null }));
})({
  findFiberByHostInstance: tc,
  bundleType: 0,
  version: "16.14.0",
  rendererPackageName: "react-dom"
});
reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
reactDom_production_min.createPortal = kk;
reactDom_production_min.findDOMNode = function(a) {
  if (a == null)
    return null;
  if (a.nodeType === 1)
    return a;
  var s = a._reactInternalFiber;
  if (s === void 0)
    throw typeof a.render == "function" ? Error(u$3(188)) : Error(u$3(268, Object.keys(a)));
  return a = hc(s), a = a === null ? null : a.stateNode, a;
};
reactDom_production_min.flushSync = function(a, s) {
  if ((W & (fj | gj)) !== V)
    throw Error(u$3(187));
  var $ = W;
  W |= 1;
  try {
    return cg(99, a.bind(null, s));
  } finally {
    W = $, gg();
  }
};
reactDom_production_min.hydrate = function(a, s, $) {
  if (!gk(s))
    throw Error(u$3(200));
  return ik(null, a, s, !0, $);
};
reactDom_production_min.render = function(a, s, $) {
  if (!gk(s))
    throw Error(u$3(200));
  return ik(null, a, s, !1, $);
};
reactDom_production_min.unmountComponentAtNode = function(a) {
  if (!gk(a))
    throw Error(u$3(40));
  return a._reactRootContainer ? (Nj(function() {
    ik(null, null, a, !1, function() {
      a._reactRootContainer = null, a[Od] = null;
    });
  }), !0) : !1;
};
reactDom_production_min.unstable_batchedUpdates = Mj;
reactDom_production_min.unstable_createPortal = function(a, s) {
  return kk(a, s, 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null);
};
reactDom_production_min.unstable_renderSubtreeIntoContainer = function(a, s, $, _) {
  if (!gk($))
    throw Error(u$3(200));
  if (a == null || a._reactInternalFiber === void 0)
    throw Error(u$3(38));
  return ik(a, s, $, !1, _);
};
reactDom_production_min.version = "16.14.0";
function checkDCE() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (a) {
      console.error(a);
    }
}
checkDCE(), reactDom.exports = reactDom_production_min;
var reactDomExports = reactDom.exports;
const ReactDOM = /* @__PURE__ */ getDefaultExportFromCjs(reactDomExports), ReactDOM$1 = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: ReactDOM
}, [reactDomExports]), PDFME_VERSION = "5.0.0", PT_TO_PX_RATIO = 1.333, PT_TO_MM_RATIO = 0.3528, MM_TO_PT_RATIO = 2.8346, ZOOM = 3.7795275591, DEFAULT_FONT_NAME = "Roboto", DEFAULT_FONT_VALUE = "data:font/ttf;base64,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";
var util$1;
(function(a) {
  a.assertEqual = (_e) => _e;
  function s(_e) {
  }
  a.assertIs = s;
  function $(_e) {
    throw new Error();
  }
  a.assertNever = $, a.arrayToEnum = (_e) => {
    const tt = {};
    for (const nt of _e)
      tt[nt] = nt;
    return tt;
  }, a.getValidEnumValues = (_e) => {
    const tt = a.objectKeys(_e).filter((at) => typeof _e[_e[at]] != "number"), nt = {};
    for (const at of tt)
      nt[at] = _e[at];
    return a.objectValues(nt);
  }, a.objectValues = (_e) => a.objectKeys(_e).map(function(tt) {
    return _e[tt];
  }), a.objectKeys = typeof Object.keys == "function" ? (_e) => Object.keys(_e) : (_e) => {
    const tt = [];
    for (const nt in _e)
      Object.prototype.hasOwnProperty.call(_e, nt) && tt.push(nt);
    return tt;
  }, a.find = (_e, tt) => {
    for (const nt of _e)
      if (tt(nt))
        return nt;
  }, a.isInteger = typeof Number.isInteger == "function" ? (_e) => Number.isInteger(_e) : (_e) => typeof _e == "number" && isFinite(_e) && Math.floor(_e) === _e;
  function _(_e, tt = " | ") {
    return _e.map((nt) => typeof nt == "string" ? `'${nt}'` : nt).join(tt);
  }
  a.joinValues = _, a.jsonStringifyReplacer = (_e, tt) => typeof tt == "bigint" ? tt.toString() : tt;
})(util$1 || (util$1 = {}));
var objectUtil;
(function(a) {
  a.mergeShapes = (s, $) => ({
    ...s,
    ...$
    // second overwrites first
  });
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util$1.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), getParsedType = (a) => {
  switch (typeof a) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(a) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      return Array.isArray(a) ? ZodParsedType.array : a === null ? ZodParsedType.null : a.then && typeof a.then == "function" && a.catch && typeof a.catch == "function" ? ZodParsedType.promise : typeof Map < "u" && a instanceof Map ? ZodParsedType.map : typeof Set < "u" && a instanceof Set ? ZodParsedType.set : typeof Date < "u" && a instanceof Date ? ZodParsedType.date : ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
}, ZodIssueCode = util$1.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), quotelessJson = (a) => JSON.stringify(a, null, 2).replace(/"([^"]+)":/g, "$1:");
class ZodError extends Error {
  constructor(s) {
    super(), this.issues = [], this.addIssue = (_) => {
      this.issues = [...this.issues, _];
    }, this.addIssues = (_ = []) => {
      this.issues = [...this.issues, ..._];
    };
    const $ = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, $) : this.__proto__ = $, this.name = "ZodError", this.issues = s;
  }
  get errors() {
    return this.issues;
  }
  format(s) {
    const $ = s || function(tt) {
      return tt.message;
    }, _ = { _errors: [] }, _e = (tt) => {
      for (const nt of tt.issues)
        if (nt.code === "invalid_union")
          nt.unionErrors.map(_e);
        else if (nt.code === "invalid_return_type")
          _e(nt.returnTypeError);
        else if (nt.code === "invalid_arguments")
          _e(nt.argumentsError);
        else if (nt.path.length === 0)
          _._errors.push($(nt));
        else {
          let at = _, ot = 0;
          for (; ot < nt.path.length; ) {
            const rt = nt.path[ot];
            ot === nt.path.length - 1 ? (at[rt] = at[rt] || { _errors: [] }, at[rt]._errors.push($(nt))) : at[rt] = at[rt] || { _errors: [] }, at = at[rt], ot++;
          }
        }
    };
    return _e(this), _;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util$1.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(s = ($) => $.message) {
    const $ = {}, _ = [];
    for (const _e of this.issues)
      _e.path.length > 0 ? ($[_e.path[0]] = $[_e.path[0]] || [], $[_e.path[0]].push(s(_e))) : _.push(s(_e));
    return { formErrors: _, fieldErrors: $ };
  }
  get formErrors() {
    return this.flatten();
  }
}
ZodError.create = (a) => new ZodError(a);
const errorMap = (a, s) => {
  let $;
  switch (a.code) {
    case ZodIssueCode.invalid_type:
      a.received === ZodParsedType.undefined ? $ = "Required" : $ = `Expected ${a.expected}, received ${a.received}`;
      break;
    case ZodIssueCode.invalid_literal:
      $ = `Invalid literal value, expected ${JSON.stringify(a.expected, util$1.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      $ = `Unrecognized key(s) in object: ${util$1.joinValues(a.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      $ = "Invalid input";
      break;
    case ZodIssueCode.invalid_union_discriminator:
      $ = `Invalid discriminator value. Expected ${util$1.joinValues(a.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      $ = `Invalid enum value. Expected ${util$1.joinValues(a.options)}, received '${a.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      $ = "Invalid function arguments";
      break;
    case ZodIssueCode.invalid_return_type:
      $ = "Invalid function return type";
      break;
    case ZodIssueCode.invalid_date:
      $ = "Invalid date";
      break;
    case ZodIssueCode.invalid_string:
      typeof a.validation == "object" ? "includes" in a.validation ? ($ = `Invalid input: must include "${a.validation.includes}"`, typeof a.validation.position == "number" && ($ = `${$} at one or more positions greater than or equal to ${a.validation.position}`)) : "startsWith" in a.validation ? $ = `Invalid input: must start with "${a.validation.startsWith}"` : "endsWith" in a.validation ? $ = `Invalid input: must end with "${a.validation.endsWith}"` : util$1.assertNever(a.validation) : a.validation !== "regex" ? $ = `Invalid ${a.validation}` : $ = "Invalid";
      break;
    case ZodIssueCode.too_small:
      a.type === "array" ? $ = `Array must contain ${a.exact ? "exactly" : a.inclusive ? "at least" : "more than"} ${a.minimum} element(s)` : a.type === "string" ? $ = `String must contain ${a.exact ? "exactly" : a.inclusive ? "at least" : "over"} ${a.minimum} character(s)` : a.type === "number" ? $ = `Number must be ${a.exact ? "exactly equal to " : a.inclusive ? "greater than or equal to " : "greater than "}${a.minimum}` : a.type === "date" ? $ = `Date must be ${a.exact ? "exactly equal to " : a.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(a.minimum))}` : $ = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      a.type === "array" ? $ = `Array must contain ${a.exact ? "exactly" : a.inclusive ? "at most" : "less than"} ${a.maximum} element(s)` : a.type === "string" ? $ = `String must contain ${a.exact ? "exactly" : a.inclusive ? "at most" : "under"} ${a.maximum} character(s)` : a.type === "number" ? $ = `Number must be ${a.exact ? "exactly" : a.inclusive ? "less than or equal to" : "less than"} ${a.maximum}` : a.type === "bigint" ? $ = `BigInt must be ${a.exact ? "exactly" : a.inclusive ? "less than or equal to" : "less than"} ${a.maximum}` : a.type === "date" ? $ = `Date must be ${a.exact ? "exactly" : a.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(a.maximum))}` : $ = "Invalid input";
      break;
    case ZodIssueCode.custom:
      $ = "Invalid input";
      break;
    case ZodIssueCode.invalid_intersection_types:
      $ = "Intersection results could not be merged";
      break;
    case ZodIssueCode.not_multiple_of:
      $ = `Number must be a multiple of ${a.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      $ = "Number must be finite";
      break;
    default:
      $ = s.defaultError, util$1.assertNever(a);
  }
  return { message: $ };
};
let overrideErrorMap = errorMap;
function setErrorMap(a) {
  overrideErrorMap = a;
}
function getErrorMap() {
  return overrideErrorMap;
}
const makeIssue = (a) => {
  const { data: s, path: $, errorMaps: _, issueData: _e } = a, tt = [...$, ..._e.path || []], nt = {
    ..._e,
    path: tt
  };
  let at = "";
  const ot = _.filter((rt) => !!rt).slice().reverse();
  for (const rt of ot)
    at = rt(nt, { data: s, defaultError: at }).message;
  return {
    ..._e,
    path: tt,
    message: _e.message || at
  };
}, EMPTY_PATH = [];
function addIssueToContext(a, s) {
  const $ = makeIssue({
    issueData: s,
    data: a.data,
    path: a.path,
    errorMaps: [
      a.common.contextualErrorMap,
      a.schemaErrorMap,
      getErrorMap(),
      errorMap
      // then global default map
    ].filter((_) => !!_)
  });
  a.common.issues.push($);
}
class ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(s, $) {
    const _ = [];
    for (const _e of $) {
      if (_e.status === "aborted")
        return INVALID;
      _e.status === "dirty" && s.dirty(), _.push(_e.value);
    }
    return { status: s.value, value: _ };
  }
  static async mergeObjectAsync(s, $) {
    const _ = [];
    for (const _e of $)
      _.push({
        key: await _e.key,
        value: await _e.value
      });
    return ParseStatus.mergeObjectSync(s, _);
  }
  static mergeObjectSync(s, $) {
    const _ = {};
    for (const _e of $) {
      const { key: tt, value: nt } = _e;
      if (tt.status === "aborted" || nt.status === "aborted")
        return INVALID;
      tt.status === "dirty" && s.dirty(), nt.status === "dirty" && s.dirty(), tt.value !== "__proto__" && (typeof nt.value < "u" || _e.alwaysSet) && (_[tt.value] = nt.value);
    }
    return { status: s.value, value: _ };
  }
}
const INVALID = Object.freeze({
  status: "aborted"
}), DIRTY = (a) => ({ status: "dirty", value: a }), OK = (a) => ({ status: "valid", value: a }), isAborted = (a) => a.status === "aborted", isDirty = (a) => a.status === "dirty", isValid = (a) => a.status === "valid", isAsync = (a) => typeof Promise < "u" && a instanceof Promise;
var errorUtil;
(function(a) {
  a.errToObj = (s) => typeof s == "string" ? { message: s } : s || {}, a.toString = (s) => typeof s == "string" ? s : s == null ? void 0 : s.message;
})(errorUtil || (errorUtil = {}));
class ParseInputLazyPath {
  constructor(s, $, _, _e) {
    this._cachedPath = [], this.parent = s, this.data = $, this._path = _, this._key = _e;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const handleResult = (a, s) => {
  if (isValid(s))
    return { success: !0, data: s.value };
  if (!a.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const $ = new ZodError(a.common.issues);
      return this._error = $, this._error;
    }
  };
};
function processCreateParams(a) {
  if (!a)
    return {};
  const { errorMap: s, invalid_type_error: $, required_error: _, description: _e } = a;
  if (s && ($ || _))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return s ? { errorMap: s, description: _e } : { errorMap: (nt, at) => nt.code !== "invalid_type" ? { message: at.defaultError } : typeof at.data > "u" ? { message: _ ?? at.defaultError } : { message: $ ?? at.defaultError }, description: _e };
}
class ZodType {
  constructor(s) {
    this.spa = this.safeParseAsync, this._def = s, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(s) {
    return getParsedType(s.data);
  }
  _getOrReturnCtx(s, $) {
    return $ || {
      common: s.parent.common,
      data: s.data,
      parsedType: getParsedType(s.data),
      schemaErrorMap: this._def.errorMap,
      path: s.path,
      parent: s.parent
    };
  }
  _processInputParams(s) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: s.parent.common,
        data: s.data,
        parsedType: getParsedType(s.data),
        schemaErrorMap: this._def.errorMap,
        path: s.path,
        parent: s.parent
      }
    };
  }
  _parseSync(s) {
    const $ = this._parse(s);
    if (isAsync($))
      throw new Error("Synchronous parse encountered promise.");
    return $;
  }
  _parseAsync(s) {
    const $ = this._parse(s);
    return Promise.resolve($);
  }
  parse(s, $) {
    const _ = this.safeParse(s, $);
    if (_.success)
      return _.data;
    throw _.error;
  }
  safeParse(s, $) {
    var _;
    const _e = {
      common: {
        issues: [],
        async: (_ = $ == null ? void 0 : $.async) !== null && _ !== void 0 ? _ : !1,
        contextualErrorMap: $ == null ? void 0 : $.errorMap
      },
      path: ($ == null ? void 0 : $.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: s,
      parsedType: getParsedType(s)
    }, tt = this._parseSync({ data: s, path: _e.path, parent: _e });
    return handleResult(_e, tt);
  }
  async parseAsync(s, $) {
    const _ = await this.safeParseAsync(s, $);
    if (_.success)
      return _.data;
    throw _.error;
  }
  async safeParseAsync(s, $) {
    const _ = {
      common: {
        issues: [],
        contextualErrorMap: $ == null ? void 0 : $.errorMap,
        async: !0
      },
      path: ($ == null ? void 0 : $.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: s,
      parsedType: getParsedType(s)
    }, _e = this._parse({ data: s, path: _.path, parent: _ }), tt = await (isAsync(_e) ? _e : Promise.resolve(_e));
    return handleResult(_, tt);
  }
  refine(s, $) {
    const _ = (_e) => typeof $ == "string" || typeof $ > "u" ? { message: $ } : typeof $ == "function" ? $(_e) : $;
    return this._refinement((_e, tt) => {
      const nt = s(_e), at = () => tt.addIssue({
        code: ZodIssueCode.custom,
        ..._(_e)
      });
      return typeof Promise < "u" && nt instanceof Promise ? nt.then((ot) => ot ? !0 : (at(), !1)) : nt ? !0 : (at(), !1);
    });
  }
  refinement(s, $) {
    return this._refinement((_, _e) => s(_) ? !0 : (_e.addIssue(typeof $ == "function" ? $(_, _e) : $), !1));
  }
  _refinement(s) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement: s }
    });
  }
  superRefine(s) {
    return this._refinement(s);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(s) {
    return ZodUnion.create([this, s], this._def);
  }
  and(s) {
    return ZodIntersection.create(this, s, this._def);
  }
  transform(s) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform: s }
    });
  }
  default(s) {
    const $ = typeof s == "function" ? s : () => s;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: $,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(s) {
    const $ = typeof s == "function" ? s : () => s;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: $,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(s) {
    const $ = this.constructor;
    return new $({
      ...this._def,
      description: s
    });
  }
  pipe(s) {
    return ZodPipeline.create(this, s);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cuidRegex = /^c[^\s-]{8,}$/i, cuid2Regex = /^[a-z][a-z0-9]*$/, ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/, uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, _emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let emojiRegex;
const ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, datetimeRegex = (a) => a.precision ? a.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${a.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${a.precision}}Z$`) : a.precision === 0 ? a.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : a.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function isValidIP(a, s) {
  return !!((s === "v4" || !s) && ipv4Regex.test(a) || (s === "v6" || !s) && ipv6Regex.test(a));
}
class ZodString extends ZodType {
  _parse(s) {
    if (this._def.coerce && (s.data = String(s.data)), this._getType(s) !== ZodParsedType.string) {
      const tt = this._getOrReturnCtx(s);
      return addIssueToContext(
        tt,
        {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: tt.parsedType
        }
        //
      ), INVALID;
    }
    const _ = new ParseStatus();
    let _e;
    for (const tt of this._def.checks)
      if (tt.kind === "min")
        s.data.length < tt.value && (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          code: ZodIssueCode.too_small,
          minimum: tt.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: tt.message
        }), _.dirty());
      else if (tt.kind === "max")
        s.data.length > tt.value && (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          code: ZodIssueCode.too_big,
          maximum: tt.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: tt.message
        }), _.dirty());
      else if (tt.kind === "length") {
        const nt = s.data.length > tt.value, at = s.data.length < tt.value;
        (nt || at) && (_e = this._getOrReturnCtx(s, _e), nt ? addIssueToContext(_e, {
          code: ZodIssueCode.too_big,
          maximum: tt.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: tt.message
        }) : at && addIssueToContext(_e, {
          code: ZodIssueCode.too_small,
          minimum: tt.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: tt.message
        }), _.dirty());
      } else if (tt.kind === "email")
        emailRegex.test(s.data) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          validation: "email",
          code: ZodIssueCode.invalid_string,
          message: tt.message
        }), _.dirty());
      else if (tt.kind === "emoji")
        emojiRegex || (emojiRegex = new RegExp(_emojiRegex, "u")), emojiRegex.test(s.data) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          validation: "emoji",
          code: ZodIssueCode.invalid_string,
          message: tt.message
        }), _.dirty());
      else if (tt.kind === "uuid")
        uuidRegex.test(s.data) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          validation: "uuid",
          code: ZodIssueCode.invalid_string,
          message: tt.message
        }), _.dirty());
      else if (tt.kind === "cuid")
        cuidRegex.test(s.data) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          validation: "cuid",
          code: ZodIssueCode.invalid_string,
          message: tt.message
        }), _.dirty());
      else if (tt.kind === "cuid2")
        cuid2Regex.test(s.data) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          validation: "cuid2",
          code: ZodIssueCode.invalid_string,
          message: tt.message
        }), _.dirty());
      else if (tt.kind === "ulid")
        ulidRegex.test(s.data) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          validation: "ulid",
          code: ZodIssueCode.invalid_string,
          message: tt.message
        }), _.dirty());
      else if (tt.kind === "url")
        try {
          new URL(s.data);
        } catch {
          _e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: tt.message
          }), _.dirty();
        }
      else
        tt.kind === "regex" ? (tt.regex.lastIndex = 0, tt.regex.test(s.data) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          validation: "regex",
          code: ZodIssueCode.invalid_string,
          message: tt.message
        }), _.dirty())) : tt.kind === "trim" ? s.data = s.data.trim() : tt.kind === "includes" ? s.data.includes(tt.value, tt.position) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          code: ZodIssueCode.invalid_string,
          validation: { includes: tt.value, position: tt.position },
          message: tt.message
        }), _.dirty()) : tt.kind === "toLowerCase" ? s.data = s.data.toLowerCase() : tt.kind === "toUpperCase" ? s.data = s.data.toUpperCase() : tt.kind === "startsWith" ? s.data.startsWith(tt.value) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          code: ZodIssueCode.invalid_string,
          validation: { startsWith: tt.value },
          message: tt.message
        }), _.dirty()) : tt.kind === "endsWith" ? s.data.endsWith(tt.value) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          code: ZodIssueCode.invalid_string,
          validation: { endsWith: tt.value },
          message: tt.message
        }), _.dirty()) : tt.kind === "datetime" ? datetimeRegex(tt).test(s.data) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          code: ZodIssueCode.invalid_string,
          validation: "datetime",
          message: tt.message
        }), _.dirty()) : tt.kind === "ip" ? isValidIP(s.data, tt.version) || (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
          validation: "ip",
          code: ZodIssueCode.invalid_string,
          message: tt.message
        }), _.dirty()) : util$1.assertNever(tt);
    return { status: _.value, value: s.data };
  }
  _regex(s, $, _) {
    return this.refinement((_e) => s.test(_e), {
      validation: $,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(_)
    });
  }
  _addCheck(s) {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, s]
    });
  }
  email(s) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(s) });
  }
  url(s) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(s) });
  }
  emoji(s) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(s) });
  }
  uuid(s) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(s) });
  }
  cuid(s) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(s) });
  }
  cuid2(s) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(s) });
  }
  ulid(s) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(s) });
  }
  ip(s) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(s) });
  }
  datetime(s) {
    var $;
    return typeof s == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: s
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (s == null ? void 0 : s.precision) > "u" ? null : s == null ? void 0 : s.precision,
      offset: ($ = s == null ? void 0 : s.offset) !== null && $ !== void 0 ? $ : !1,
      ...errorUtil.errToObj(s == null ? void 0 : s.message)
    });
  }
  regex(s, $) {
    return this._addCheck({
      kind: "regex",
      regex: s,
      ...errorUtil.errToObj($)
    });
  }
  includes(s, $) {
    return this._addCheck({
      kind: "includes",
      value: s,
      position: $ == null ? void 0 : $.position,
      ...errorUtil.errToObj($ == null ? void 0 : $.message)
    });
  }
  startsWith(s, $) {
    return this._addCheck({
      kind: "startsWith",
      value: s,
      ...errorUtil.errToObj($)
    });
  }
  endsWith(s, $) {
    return this._addCheck({
      kind: "endsWith",
      value: s,
      ...errorUtil.errToObj($)
    });
  }
  min(s, $) {
    return this._addCheck({
      kind: "min",
      value: s,
      ...errorUtil.errToObj($)
    });
  }
  max(s, $) {
    return this._addCheck({
      kind: "max",
      value: s,
      ...errorUtil.errToObj($)
    });
  }
  length(s, $) {
    return this._addCheck({
      kind: "length",
      value: s,
      ...errorUtil.errToObj($)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(s) {
    return this.min(1, errorUtil.errToObj(s));
  }
  trim() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((s) => s.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((s) => s.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((s) => s.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((s) => s.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((s) => s.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((s) => s.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((s) => s.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((s) => s.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((s) => s.kind === "ip");
  }
  get minLength() {
    let s = null;
    for (const $ of this._def.checks)
      $.kind === "min" && (s === null || $.value > s) && (s = $.value);
    return s;
  }
  get maxLength() {
    let s = null;
    for (const $ of this._def.checks)
      $.kind === "max" && (s === null || $.value < s) && (s = $.value);
    return s;
  }
}
ZodString.create = (a) => {
  var s;
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (s = a == null ? void 0 : a.coerce) !== null && s !== void 0 ? s : !1,
    ...processCreateParams(a)
  });
};
function floatSafeRemainder(a, s) {
  const $ = (a.toString().split(".")[1] || "").length, _ = (s.toString().split(".")[1] || "").length, _e = $ > _ ? $ : _, tt = parseInt(a.toFixed(_e).replace(".", "")), nt = parseInt(s.toFixed(_e).replace(".", ""));
  return tt % nt / Math.pow(10, _e);
}
class ZodNumber extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(s) {
    if (this._def.coerce && (s.data = Number(s.data)), this._getType(s) !== ZodParsedType.number) {
      const tt = this._getOrReturnCtx(s);
      return addIssueToContext(tt, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: tt.parsedType
      }), INVALID;
    }
    let _;
    const _e = new ParseStatus();
    for (const tt of this._def.checks)
      tt.kind === "int" ? util$1.isInteger(s.data) || (_ = this._getOrReturnCtx(s, _), addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: "integer",
        received: "float",
        message: tt.message
      }), _e.dirty()) : tt.kind === "min" ? (tt.inclusive ? s.data < tt.value : s.data <= tt.value) && (_ = this._getOrReturnCtx(s, _), addIssueToContext(_, {
        code: ZodIssueCode.too_small,
        minimum: tt.value,
        type: "number",
        inclusive: tt.inclusive,
        exact: !1,
        message: tt.message
      }), _e.dirty()) : tt.kind === "max" ? (tt.inclusive ? s.data > tt.value : s.data >= tt.value) && (_ = this._getOrReturnCtx(s, _), addIssueToContext(_, {
        code: ZodIssueCode.too_big,
        maximum: tt.value,
        type: "number",
        inclusive: tt.inclusive,
        exact: !1,
        message: tt.message
      }), _e.dirty()) : tt.kind === "multipleOf" ? floatSafeRemainder(s.data, tt.value) !== 0 && (_ = this._getOrReturnCtx(s, _), addIssueToContext(_, {
        code: ZodIssueCode.not_multiple_of,
        multipleOf: tt.value,
        message: tt.message
      }), _e.dirty()) : tt.kind === "finite" ? Number.isFinite(s.data) || (_ = this._getOrReturnCtx(s, _), addIssueToContext(_, {
        code: ZodIssueCode.not_finite,
        message: tt.message
      }), _e.dirty()) : util$1.assertNever(tt);
    return { status: _e.value, value: s.data };
  }
  gte(s, $) {
    return this.setLimit("min", s, !0, errorUtil.toString($));
  }
  gt(s, $) {
    return this.setLimit("min", s, !1, errorUtil.toString($));
  }
  lte(s, $) {
    return this.setLimit("max", s, !0, errorUtil.toString($));
  }
  lt(s, $) {
    return this.setLimit("max", s, !1, errorUtil.toString($));
  }
  setLimit(s, $, _, _e) {
    return new ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: s,
          value: $,
          inclusive: _,
          message: errorUtil.toString(_e)
        }
      ]
    });
  }
  _addCheck(s) {
    return new ZodNumber({
      ...this._def,
      checks: [...this._def.checks, s]
    });
  }
  int(s) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(s)
    });
  }
  positive(s) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: errorUtil.toString(s)
    });
  }
  negative(s) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: errorUtil.toString(s)
    });
  }
  nonpositive(s) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: errorUtil.toString(s)
    });
  }
  nonnegative(s) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: errorUtil.toString(s)
    });
  }
  multipleOf(s, $) {
    return this._addCheck({
      kind: "multipleOf",
      value: s,
      message: errorUtil.toString($)
    });
  }
  finite(s) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(s)
    });
  }
  safe(s) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(s)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(s)
    });
  }
  get minValue() {
    let s = null;
    for (const $ of this._def.checks)
      $.kind === "min" && (s === null || $.value > s) && (s = $.value);
    return s;
  }
  get maxValue() {
    let s = null;
    for (const $ of this._def.checks)
      $.kind === "max" && (s === null || $.value < s) && (s = $.value);
    return s;
  }
  get isInt() {
    return !!this._def.checks.find((s) => s.kind === "int" || s.kind === "multipleOf" && util$1.isInteger(s.value));
  }
  get isFinite() {
    let s = null, $ = null;
    for (const _ of this._def.checks) {
      if (_.kind === "finite" || _.kind === "int" || _.kind === "multipleOf")
        return !0;
      _.kind === "min" ? ($ === null || _.value > $) && ($ = _.value) : _.kind === "max" && (s === null || _.value < s) && (s = _.value);
    }
    return Number.isFinite($) && Number.isFinite(s);
  }
}
ZodNumber.create = (a) => new ZodNumber({
  checks: [],
  typeName: ZodFirstPartyTypeKind.ZodNumber,
  coerce: (a == null ? void 0 : a.coerce) || !1,
  ...processCreateParams(a)
});
class ZodBigInt extends ZodType {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(s) {
    if (this._def.coerce && (s.data = BigInt(s.data)), this._getType(s) !== ZodParsedType.bigint) {
      const tt = this._getOrReturnCtx(s);
      return addIssueToContext(tt, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: tt.parsedType
      }), INVALID;
    }
    let _;
    const _e = new ParseStatus();
    for (const tt of this._def.checks)
      tt.kind === "min" ? (tt.inclusive ? s.data < tt.value : s.data <= tt.value) && (_ = this._getOrReturnCtx(s, _), addIssueToContext(_, {
        code: ZodIssueCode.too_small,
        type: "bigint",
        minimum: tt.value,
        inclusive: tt.inclusive,
        message: tt.message
      }), _e.dirty()) : tt.kind === "max" ? (tt.inclusive ? s.data > tt.value : s.data >= tt.value) && (_ = this._getOrReturnCtx(s, _), addIssueToContext(_, {
        code: ZodIssueCode.too_big,
        type: "bigint",
        maximum: tt.value,
        inclusive: tt.inclusive,
        message: tt.message
      }), _e.dirty()) : tt.kind === "multipleOf" ? s.data % tt.value !== BigInt(0) && (_ = this._getOrReturnCtx(s, _), addIssueToContext(_, {
        code: ZodIssueCode.not_multiple_of,
        multipleOf: tt.value,
        message: tt.message
      }), _e.dirty()) : util$1.assertNever(tt);
    return { status: _e.value, value: s.data };
  }
  gte(s, $) {
    return this.setLimit("min", s, !0, errorUtil.toString($));
  }
  gt(s, $) {
    return this.setLimit("min", s, !1, errorUtil.toString($));
  }
  lte(s, $) {
    return this.setLimit("max", s, !0, errorUtil.toString($));
  }
  lt(s, $) {
    return this.setLimit("max", s, !1, errorUtil.toString($));
  }
  setLimit(s, $, _, _e) {
    return new ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: s,
          value: $,
          inclusive: _,
          message: errorUtil.toString(_e)
        }
      ]
    });
  }
  _addCheck(s) {
    return new ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, s]
    });
  }
  positive(s) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: errorUtil.toString(s)
    });
  }
  negative(s) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: errorUtil.toString(s)
    });
  }
  nonpositive(s) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: errorUtil.toString(s)
    });
  }
  nonnegative(s) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: errorUtil.toString(s)
    });
  }
  multipleOf(s, $) {
    return this._addCheck({
      kind: "multipleOf",
      value: s,
      message: errorUtil.toString($)
    });
  }
  get minValue() {
    let s = null;
    for (const $ of this._def.checks)
      $.kind === "min" && (s === null || $.value > s) && (s = $.value);
    return s;
  }
  get maxValue() {
    let s = null;
    for (const $ of this._def.checks)
      $.kind === "max" && (s === null || $.value < s) && (s = $.value);
    return s;
  }
}
ZodBigInt.create = (a) => {
  var s;
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (s = a == null ? void 0 : a.coerce) !== null && s !== void 0 ? s : !1,
    ...processCreateParams(a)
  });
};
class ZodBoolean extends ZodType {
  _parse(s) {
    if (this._def.coerce && (s.data = !!s.data), this._getType(s) !== ZodParsedType.boolean) {
      const _ = this._getOrReturnCtx(s);
      return addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: _.parsedType
      }), INVALID;
    }
    return OK(s.data);
  }
}
ZodBoolean.create = (a) => new ZodBoolean({
  typeName: ZodFirstPartyTypeKind.ZodBoolean,
  coerce: (a == null ? void 0 : a.coerce) || !1,
  ...processCreateParams(a)
});
class ZodDate extends ZodType {
  _parse(s) {
    if (this._def.coerce && (s.data = new Date(s.data)), this._getType(s) !== ZodParsedType.date) {
      const tt = this._getOrReturnCtx(s);
      return addIssueToContext(tt, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: tt.parsedType
      }), INVALID;
    }
    if (isNaN(s.data.getTime())) {
      const tt = this._getOrReturnCtx(s);
      return addIssueToContext(tt, {
        code: ZodIssueCode.invalid_date
      }), INVALID;
    }
    const _ = new ParseStatus();
    let _e;
    for (const tt of this._def.checks)
      tt.kind === "min" ? s.data.getTime() < tt.value && (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
        code: ZodIssueCode.too_small,
        message: tt.message,
        inclusive: !0,
        exact: !1,
        minimum: tt.value,
        type: "date"
      }), _.dirty()) : tt.kind === "max" ? s.data.getTime() > tt.value && (_e = this._getOrReturnCtx(s, _e), addIssueToContext(_e, {
        code: ZodIssueCode.too_big,
        message: tt.message,
        inclusive: !0,
        exact: !1,
        maximum: tt.value,
        type: "date"
      }), _.dirty()) : util$1.assertNever(tt);
    return {
      status: _.value,
      value: new Date(s.data.getTime())
    };
  }
  _addCheck(s) {
    return new ZodDate({
      ...this._def,
      checks: [...this._def.checks, s]
    });
  }
  min(s, $) {
    return this._addCheck({
      kind: "min",
      value: s.getTime(),
      message: errorUtil.toString($)
    });
  }
  max(s, $) {
    return this._addCheck({
      kind: "max",
      value: s.getTime(),
      message: errorUtil.toString($)
    });
  }
  get minDate() {
    let s = null;
    for (const $ of this._def.checks)
      $.kind === "min" && (s === null || $.value > s) && (s = $.value);
    return s != null ? new Date(s) : null;
  }
  get maxDate() {
    let s = null;
    for (const $ of this._def.checks)
      $.kind === "max" && (s === null || $.value < s) && (s = $.value);
    return s != null ? new Date(s) : null;
  }
}
ZodDate.create = (a) => new ZodDate({
  checks: [],
  coerce: (a == null ? void 0 : a.coerce) || !1,
  typeName: ZodFirstPartyTypeKind.ZodDate,
  ...processCreateParams(a)
});
class ZodSymbol extends ZodType {
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.symbol) {
      const _ = this._getOrReturnCtx(s);
      return addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: _.parsedType
      }), INVALID;
    }
    return OK(s.data);
  }
}
ZodSymbol.create = (a) => new ZodSymbol({
  typeName: ZodFirstPartyTypeKind.ZodSymbol,
  ...processCreateParams(a)
});
class ZodUndefined extends ZodType {
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.undefined) {
      const _ = this._getOrReturnCtx(s);
      return addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: _.parsedType
      }), INVALID;
    }
    return OK(s.data);
  }
}
ZodUndefined.create = (a) => new ZodUndefined({
  typeName: ZodFirstPartyTypeKind.ZodUndefined,
  ...processCreateParams(a)
});
class ZodNull extends ZodType {
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.null) {
      const _ = this._getOrReturnCtx(s);
      return addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: _.parsedType
      }), INVALID;
    }
    return OK(s.data);
  }
}
ZodNull.create = (a) => new ZodNull({
  typeName: ZodFirstPartyTypeKind.ZodNull,
  ...processCreateParams(a)
});
class ZodAny extends ZodType {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(s) {
    return OK(s.data);
  }
}
ZodAny.create = (a) => new ZodAny({
  typeName: ZodFirstPartyTypeKind.ZodAny,
  ...processCreateParams(a)
});
class ZodUnknown extends ZodType {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(s) {
    return OK(s.data);
  }
}
ZodUnknown.create = (a) => new ZodUnknown({
  typeName: ZodFirstPartyTypeKind.ZodUnknown,
  ...processCreateParams(a)
});
class ZodNever extends ZodType {
  _parse(s) {
    const $ = this._getOrReturnCtx(s);
    return addIssueToContext($, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: $.parsedType
    }), INVALID;
  }
}
ZodNever.create = (a) => new ZodNever({
  typeName: ZodFirstPartyTypeKind.ZodNever,
  ...processCreateParams(a)
});
class ZodVoid extends ZodType {
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.undefined) {
      const _ = this._getOrReturnCtx(s);
      return addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: _.parsedType
      }), INVALID;
    }
    return OK(s.data);
  }
}
ZodVoid.create = (a) => new ZodVoid({
  typeName: ZodFirstPartyTypeKind.ZodVoid,
  ...processCreateParams(a)
});
class ZodArray extends ZodType {
  _parse(s) {
    const { ctx: $, status: _ } = this._processInputParams(s), _e = this._def;
    if ($.parsedType !== ZodParsedType.array)
      return addIssueToContext($, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: $.parsedType
      }), INVALID;
    if (_e.exactLength !== null) {
      const nt = $.data.length > _e.exactLength.value, at = $.data.length < _e.exactLength.value;
      (nt || at) && (addIssueToContext($, {
        code: nt ? ZodIssueCode.too_big : ZodIssueCode.too_small,
        minimum: at ? _e.exactLength.value : void 0,
        maximum: nt ? _e.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: _e.exactLength.message
      }), _.dirty());
    }
    if (_e.minLength !== null && $.data.length < _e.minLength.value && (addIssueToContext($, {
      code: ZodIssueCode.too_small,
      minimum: _e.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: _e.minLength.message
    }), _.dirty()), _e.maxLength !== null && $.data.length > _e.maxLength.value && (addIssueToContext($, {
      code: ZodIssueCode.too_big,
      maximum: _e.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: _e.maxLength.message
    }), _.dirty()), $.common.async)
      return Promise.all([...$.data].map((nt, at) => _e.type._parseAsync(new ParseInputLazyPath($, nt, $.path, at)))).then((nt) => ParseStatus.mergeArray(_, nt));
    const tt = [...$.data].map((nt, at) => _e.type._parseSync(new ParseInputLazyPath($, nt, $.path, at)));
    return ParseStatus.mergeArray(_, tt);
  }
  get element() {
    return this._def.type;
  }
  min(s, $) {
    return new ZodArray({
      ...this._def,
      minLength: { value: s, message: errorUtil.toString($) }
    });
  }
  max(s, $) {
    return new ZodArray({
      ...this._def,
      maxLength: { value: s, message: errorUtil.toString($) }
    });
  }
  length(s, $) {
    return new ZodArray({
      ...this._def,
      exactLength: { value: s, message: errorUtil.toString($) }
    });
  }
  nonempty(s) {
    return this.min(1, s);
  }
}
ZodArray.create = (a, s) => new ZodArray({
  type: a,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: ZodFirstPartyTypeKind.ZodArray,
  ...processCreateParams(s)
});
function deepPartialify(a) {
  if (a instanceof ZodObject) {
    const s = {};
    for (const $ in a.shape) {
      const _ = a.shape[$];
      s[$] = ZodOptional.create(deepPartialify(_));
    }
    return new ZodObject({
      ...a._def,
      shape: () => s
    });
  } else
    return a instanceof ZodArray ? new ZodArray({
      ...a._def,
      type: deepPartialify(a.element)
    }) : a instanceof ZodOptional ? ZodOptional.create(deepPartialify(a.unwrap())) : a instanceof ZodNullable ? ZodNullable.create(deepPartialify(a.unwrap())) : a instanceof ZodTuple ? ZodTuple.create(a.items.map((s) => deepPartialify(s))) : a;
}
class ZodObject extends ZodType {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const s = this._def.shape(), $ = util$1.objectKeys(s);
    return this._cached = { shape: s, keys: $ };
  }
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.object) {
      const rt = this._getOrReturnCtx(s);
      return addIssueToContext(rt, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: rt.parsedType
      }), INVALID;
    }
    const { status: _, ctx: _e } = this._processInputParams(s), { shape: tt, keys: nt } = this._getCached(), at = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip"))
      for (const rt in _e.data)
        nt.includes(rt) || at.push(rt);
    const ot = [];
    for (const rt of nt) {
      const st = tt[rt], lt = _e.data[rt];
      ot.push({
        key: { status: "valid", value: rt },
        value: st._parse(new ParseInputLazyPath(_e, lt, _e.path, rt)),
        alwaysSet: rt in _e.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const rt = this._def.unknownKeys;
      if (rt === "passthrough")
        for (const st of at)
          ot.push({
            key: { status: "valid", value: st },
            value: { status: "valid", value: _e.data[st] }
          });
      else if (rt === "strict")
        at.length > 0 && (addIssueToContext(_e, {
          code: ZodIssueCode.unrecognized_keys,
          keys: at
        }), _.dirty());
      else if (rt !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const rt = this._def.catchall;
      for (const st of at) {
        const lt = _e.data[st];
        ot.push({
          key: { status: "valid", value: st },
          value: rt._parse(
            new ParseInputLazyPath(_e, lt, _e.path, st)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: st in _e.data
        });
      }
    }
    return _e.common.async ? Promise.resolve().then(async () => {
      const rt = [];
      for (const st of ot) {
        const lt = await st.key;
        rt.push({
          key: lt,
          value: await st.value,
          alwaysSet: st.alwaysSet
        });
      }
      return rt;
    }).then((rt) => ParseStatus.mergeObjectSync(_, rt)) : ParseStatus.mergeObjectSync(_, ot);
  }
  get shape() {
    return this._def.shape();
  }
  strict(s) {
    return errorUtil.errToObj, new ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...s !== void 0 ? {
        errorMap: ($, _) => {
          var _e, tt, nt, at;
          const ot = (nt = (tt = (_e = this._def).errorMap) === null || tt === void 0 ? void 0 : tt.call(_e, $, _).message) !== null && nt !== void 0 ? nt : _.defaultError;
          return $.code === "unrecognized_keys" ? {
            message: (at = errorUtil.errToObj(s).message) !== null && at !== void 0 ? at : ot
          } : {
            message: ot
          };
        }
      } : {}
    });
  }
  strip() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(s) {
    return new ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...s
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(s) {
    return new ZodObject({
      unknownKeys: s._def.unknownKeys,
      catchall: s._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...s._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(s, $) {
    return this.augment({ [s]: $ });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(s) {
    return new ZodObject({
      ...this._def,
      catchall: s
    });
  }
  pick(s) {
    const $ = {};
    return util$1.objectKeys(s).forEach((_) => {
      s[_] && this.shape[_] && ($[_] = this.shape[_]);
    }), new ZodObject({
      ...this._def,
      shape: () => $
    });
  }
  omit(s) {
    const $ = {};
    return util$1.objectKeys(this.shape).forEach((_) => {
      s[_] || ($[_] = this.shape[_]);
    }), new ZodObject({
      ...this._def,
      shape: () => $
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(s) {
    const $ = {};
    return util$1.objectKeys(this.shape).forEach((_) => {
      const _e = this.shape[_];
      s && !s[_] ? $[_] = _e : $[_] = _e.optional();
    }), new ZodObject({
      ...this._def,
      shape: () => $
    });
  }
  required(s) {
    const $ = {};
    return util$1.objectKeys(this.shape).forEach((_) => {
      if (s && !s[_])
        $[_] = this.shape[_];
      else {
        let tt = this.shape[_];
        for (; tt instanceof ZodOptional; )
          tt = tt._def.innerType;
        $[_] = tt;
      }
    }), new ZodObject({
      ...this._def,
      shape: () => $
    });
  }
  keyof() {
    return createZodEnum(util$1.objectKeys(this.shape));
  }
}
ZodObject.create = (a, s) => new ZodObject({
  shape: () => a,
  unknownKeys: "strip",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(s)
});
ZodObject.strictCreate = (a, s) => new ZodObject({
  shape: () => a,
  unknownKeys: "strict",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(s)
});
ZodObject.lazycreate = (a, s) => new ZodObject({
  shape: a,
  unknownKeys: "strip",
  catchall: ZodNever.create(),
  typeName: ZodFirstPartyTypeKind.ZodObject,
  ...processCreateParams(s)
});
class ZodUnion extends ZodType {
  _parse(s) {
    const { ctx: $ } = this._processInputParams(s), _ = this._def.options;
    function _e(tt) {
      for (const at of tt)
        if (at.result.status === "valid")
          return at.result;
      for (const at of tt)
        if (at.result.status === "dirty")
          return $.common.issues.push(...at.ctx.common.issues), at.result;
      const nt = tt.map((at) => new ZodError(at.ctx.common.issues));
      return addIssueToContext($, {
        code: ZodIssueCode.invalid_union,
        unionErrors: nt
      }), INVALID;
    }
    if ($.common.async)
      return Promise.all(_.map(async (tt) => {
        const nt = {
          ...$,
          common: {
            ...$.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await tt._parseAsync({
            data: $.data,
            path: $.path,
            parent: nt
          }),
          ctx: nt
        };
      })).then(_e);
    {
      let tt;
      const nt = [];
      for (const ot of _) {
        const rt = {
          ...$,
          common: {
            ...$.common,
            issues: []
          },
          parent: null
        }, st = ot._parseSync({
          data: $.data,
          path: $.path,
          parent: rt
        });
        if (st.status === "valid")
          return st;
        st.status === "dirty" && !tt && (tt = { result: st, ctx: rt }), rt.common.issues.length && nt.push(rt.common.issues);
      }
      if (tt)
        return $.common.issues.push(...tt.ctx.common.issues), tt.result;
      const at = nt.map((ot) => new ZodError(ot));
      return addIssueToContext($, {
        code: ZodIssueCode.invalid_union,
        unionErrors: at
      }), INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
}
ZodUnion.create = (a, s) => new ZodUnion({
  options: a,
  typeName: ZodFirstPartyTypeKind.ZodUnion,
  ...processCreateParams(s)
});
const getDiscriminator = (a) => a instanceof ZodLazy ? getDiscriminator(a.schema) : a instanceof ZodEffects ? getDiscriminator(a.innerType()) : a instanceof ZodLiteral ? [a.value] : a instanceof ZodEnum ? a.options : a instanceof ZodNativeEnum ? Object.keys(a.enum) : a instanceof ZodDefault ? getDiscriminator(a._def.innerType) : a instanceof ZodUndefined ? [void 0] : a instanceof ZodNull ? [null] : null;
class ZodDiscriminatedUnion extends ZodType {
  _parse(s) {
    const { ctx: $ } = this._processInputParams(s);
    if ($.parsedType !== ZodParsedType.object)
      return addIssueToContext($, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: $.parsedType
      }), INVALID;
    const _ = this.discriminator, _e = $.data[_], tt = this.optionsMap.get(_e);
    return tt ? $.common.async ? tt._parseAsync({
      data: $.data,
      path: $.path,
      parent: $
    }) : tt._parseSync({
      data: $.data,
      path: $.path,
      parent: $
    }) : (addIssueToContext($, {
      code: ZodIssueCode.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [_]
    }), INVALID);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(s, $, _) {
    const _e = /* @__PURE__ */ new Map();
    for (const tt of $) {
      const nt = getDiscriminator(tt.shape[s]);
      if (!nt)
        throw new Error(`A discriminator value for key \`${s}\` could not be extracted from all schema options`);
      for (const at of nt) {
        if (_e.has(at))
          throw new Error(`Discriminator property ${String(s)} has duplicate value ${String(at)}`);
        _e.set(at, tt);
      }
    }
    return new ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator: s,
      options: $,
      optionsMap: _e,
      ...processCreateParams(_)
    });
  }
}
function mergeValues(a, s) {
  const $ = getParsedType(a), _ = getParsedType(s);
  if (a === s)
    return { valid: !0, data: a };
  if ($ === ZodParsedType.object && _ === ZodParsedType.object) {
    const _e = util$1.objectKeys(s), tt = util$1.objectKeys(a).filter((at) => _e.indexOf(at) !== -1), nt = { ...a, ...s };
    for (const at of tt) {
      const ot = mergeValues(a[at], s[at]);
      if (!ot.valid)
        return { valid: !1 };
      nt[at] = ot.data;
    }
    return { valid: !0, data: nt };
  } else if ($ === ZodParsedType.array && _ === ZodParsedType.array) {
    if (a.length !== s.length)
      return { valid: !1 };
    const _e = [];
    for (let tt = 0; tt < a.length; tt++) {
      const nt = a[tt], at = s[tt], ot = mergeValues(nt, at);
      if (!ot.valid)
        return { valid: !1 };
      _e.push(ot.data);
    }
    return { valid: !0, data: _e };
  } else
    return $ === ZodParsedType.date && _ === ZodParsedType.date && +a == +s ? { valid: !0, data: a } : { valid: !1 };
}
class ZodIntersection extends ZodType {
  _parse(s) {
    const { status: $, ctx: _ } = this._processInputParams(s), _e = (tt, nt) => {
      if (isAborted(tt) || isAborted(nt))
        return INVALID;
      const at = mergeValues(tt.value, nt.value);
      return at.valid ? ((isDirty(tt) || isDirty(nt)) && $.dirty(), { status: $.value, value: at.data }) : (addIssueToContext(_, {
        code: ZodIssueCode.invalid_intersection_types
      }), INVALID);
    };
    return _.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: _.data,
        path: _.path,
        parent: _
      }),
      this._def.right._parseAsync({
        data: _.data,
        path: _.path,
        parent: _
      })
    ]).then(([tt, nt]) => _e(tt, nt)) : _e(this._def.left._parseSync({
      data: _.data,
      path: _.path,
      parent: _
    }), this._def.right._parseSync({
      data: _.data,
      path: _.path,
      parent: _
    }));
  }
}
ZodIntersection.create = (a, s, $) => new ZodIntersection({
  left: a,
  right: s,
  typeName: ZodFirstPartyTypeKind.ZodIntersection,
  ...processCreateParams($)
});
class ZodTuple extends ZodType {
  _parse(s) {
    const { status: $, ctx: _ } = this._processInputParams(s);
    if (_.parsedType !== ZodParsedType.array)
      return addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: _.parsedType
      }), INVALID;
    if (_.data.length < this._def.items.length)
      return addIssueToContext(_, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), INVALID;
    !this._def.rest && _.data.length > this._def.items.length && (addIssueToContext(_, {
      code: ZodIssueCode.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), $.dirty());
    const tt = [..._.data].map((nt, at) => {
      const ot = this._def.items[at] || this._def.rest;
      return ot ? ot._parse(new ParseInputLazyPath(_, nt, _.path, at)) : null;
    }).filter((nt) => !!nt);
    return _.common.async ? Promise.all(tt).then((nt) => ParseStatus.mergeArray($, nt)) : ParseStatus.mergeArray($, tt);
  }
  get items() {
    return this._def.items;
  }
  rest(s) {
    return new ZodTuple({
      ...this._def,
      rest: s
    });
  }
}
ZodTuple.create = (a, s) => {
  if (!Array.isArray(a))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ZodTuple({
    items: a,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(s)
  });
};
class ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(s) {
    const { status: $, ctx: _ } = this._processInputParams(s);
    if (_.parsedType !== ZodParsedType.object)
      return addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: _.parsedType
      }), INVALID;
    const _e = [], tt = this._def.keyType, nt = this._def.valueType;
    for (const at in _.data)
      _e.push({
        key: tt._parse(new ParseInputLazyPath(_, at, _.path, at)),
        value: nt._parse(new ParseInputLazyPath(_, _.data[at], _.path, at))
      });
    return _.common.async ? ParseStatus.mergeObjectAsync($, _e) : ParseStatus.mergeObjectSync($, _e);
  }
  get element() {
    return this._def.valueType;
  }
  static create(s, $, _) {
    return $ instanceof ZodType ? new ZodRecord({
      keyType: s,
      valueType: $,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(_)
    }) : new ZodRecord({
      keyType: ZodString.create(),
      valueType: s,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams($)
    });
  }
}
class ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(s) {
    const { status: $, ctx: _ } = this._processInputParams(s);
    if (_.parsedType !== ZodParsedType.map)
      return addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: _.parsedType
      }), INVALID;
    const _e = this._def.keyType, tt = this._def.valueType, nt = [..._.data.entries()].map(([at, ot], rt) => ({
      key: _e._parse(new ParseInputLazyPath(_, at, _.path, [rt, "key"])),
      value: tt._parse(new ParseInputLazyPath(_, ot, _.path, [rt, "value"]))
    }));
    if (_.common.async) {
      const at = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const ot of nt) {
          const rt = await ot.key, st = await ot.value;
          if (rt.status === "aborted" || st.status === "aborted")
            return INVALID;
          (rt.status === "dirty" || st.status === "dirty") && $.dirty(), at.set(rt.value, st.value);
        }
        return { status: $.value, value: at };
      });
    } else {
      const at = /* @__PURE__ */ new Map();
      for (const ot of nt) {
        const rt = ot.key, st = ot.value;
        if (rt.status === "aborted" || st.status === "aborted")
          return INVALID;
        (rt.status === "dirty" || st.status === "dirty") && $.dirty(), at.set(rt.value, st.value);
      }
      return { status: $.value, value: at };
    }
  }
}
ZodMap.create = (a, s, $) => new ZodMap({
  valueType: s,
  keyType: a,
  typeName: ZodFirstPartyTypeKind.ZodMap,
  ...processCreateParams($)
});
class ZodSet extends ZodType {
  _parse(s) {
    const { status: $, ctx: _ } = this._processInputParams(s);
    if (_.parsedType !== ZodParsedType.set)
      return addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: _.parsedType
      }), INVALID;
    const _e = this._def;
    _e.minSize !== null && _.data.size < _e.minSize.value && (addIssueToContext(_, {
      code: ZodIssueCode.too_small,
      minimum: _e.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: _e.minSize.message
    }), $.dirty()), _e.maxSize !== null && _.data.size > _e.maxSize.value && (addIssueToContext(_, {
      code: ZodIssueCode.too_big,
      maximum: _e.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: _e.maxSize.message
    }), $.dirty());
    const tt = this._def.valueType;
    function nt(ot) {
      const rt = /* @__PURE__ */ new Set();
      for (const st of ot) {
        if (st.status === "aborted")
          return INVALID;
        st.status === "dirty" && $.dirty(), rt.add(st.value);
      }
      return { status: $.value, value: rt };
    }
    const at = [..._.data.values()].map((ot, rt) => tt._parse(new ParseInputLazyPath(_, ot, _.path, rt)));
    return _.common.async ? Promise.all(at).then((ot) => nt(ot)) : nt(at);
  }
  min(s, $) {
    return new ZodSet({
      ...this._def,
      minSize: { value: s, message: errorUtil.toString($) }
    });
  }
  max(s, $) {
    return new ZodSet({
      ...this._def,
      maxSize: { value: s, message: errorUtil.toString($) }
    });
  }
  size(s, $) {
    return this.min(s, $).max(s, $);
  }
  nonempty(s) {
    return this.min(1, s);
  }
}
ZodSet.create = (a, s) => new ZodSet({
  valueType: a,
  minSize: null,
  maxSize: null,
  typeName: ZodFirstPartyTypeKind.ZodSet,
  ...processCreateParams(s)
});
class ZodFunction extends ZodType {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(s) {
    const { ctx: $ } = this._processInputParams(s);
    if ($.parsedType !== ZodParsedType.function)
      return addIssueToContext($, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: $.parsedType
      }), INVALID;
    function _(at, ot) {
      return makeIssue({
        data: at,
        path: $.path,
        errorMaps: [
          $.common.contextualErrorMap,
          $.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((rt) => !!rt),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: ot
        }
      });
    }
    function _e(at, ot) {
      return makeIssue({
        data: at,
        path: $.path,
        errorMaps: [
          $.common.contextualErrorMap,
          $.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((rt) => !!rt),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: ot
        }
      });
    }
    const tt = { errorMap: $.common.contextualErrorMap }, nt = $.data;
    if (this._def.returns instanceof ZodPromise) {
      const at = this;
      return OK(async function(...ot) {
        const rt = new ZodError([]), st = await at._def.args.parseAsync(ot, tt).catch((it) => {
          throw rt.addIssue(_(ot, it)), rt;
        }), lt = await Reflect.apply(nt, this, st);
        return await at._def.returns._def.type.parseAsync(lt, tt).catch((it) => {
          throw rt.addIssue(_e(lt, it)), rt;
        });
      });
    } else {
      const at = this;
      return OK(function(...ot) {
        const rt = at._def.args.safeParse(ot, tt);
        if (!rt.success)
          throw new ZodError([_(ot, rt.error)]);
        const st = Reflect.apply(nt, this, rt.data), lt = at._def.returns.safeParse(st, tt);
        if (!lt.success)
          throw new ZodError([_e(st, lt.error)]);
        return lt.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...s) {
    return new ZodFunction({
      ...this._def,
      args: ZodTuple.create(s).rest(ZodUnknown.create())
    });
  }
  returns(s) {
    return new ZodFunction({
      ...this._def,
      returns: s
    });
  }
  implement(s) {
    return this.parse(s);
  }
  strictImplement(s) {
    return this.parse(s);
  }
  static create(s, $, _) {
    return new ZodFunction({
      args: s || ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: $ || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(_)
    });
  }
}
class ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(s) {
    const { ctx: $ } = this._processInputParams(s);
    return this._def.getter()._parse({ data: $.data, path: $.path, parent: $ });
  }
}
ZodLazy.create = (a, s) => new ZodLazy({
  getter: a,
  typeName: ZodFirstPartyTypeKind.ZodLazy,
  ...processCreateParams(s)
});
class ZodLiteral extends ZodType {
  _parse(s) {
    if (s.data !== this._def.value) {
      const $ = this._getOrReturnCtx(s);
      return addIssueToContext($, {
        received: $.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      }), INVALID;
    }
    return { status: "valid", value: s.data };
  }
  get value() {
    return this._def.value;
  }
}
ZodLiteral.create = (a, s) => new ZodLiteral({
  value: a,
  typeName: ZodFirstPartyTypeKind.ZodLiteral,
  ...processCreateParams(s)
});
function createZodEnum(a, s) {
  return new ZodEnum({
    values: a,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(s)
  });
}
class ZodEnum extends ZodType {
  _parse(s) {
    if (typeof s.data != "string") {
      const $ = this._getOrReturnCtx(s), _ = this._def.values;
      return addIssueToContext($, {
        expected: util$1.joinValues(_),
        received: $.parsedType,
        code: ZodIssueCode.invalid_type
      }), INVALID;
    }
    if (this._def.values.indexOf(s.data) === -1) {
      const $ = this._getOrReturnCtx(s), _ = this._def.values;
      return addIssueToContext($, {
        received: $.data,
        code: ZodIssueCode.invalid_enum_value,
        options: _
      }), INVALID;
    }
    return OK(s.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const s = {};
    for (const $ of this._def.values)
      s[$] = $;
    return s;
  }
  get Values() {
    const s = {};
    for (const $ of this._def.values)
      s[$] = $;
    return s;
  }
  get Enum() {
    const s = {};
    for (const $ of this._def.values)
      s[$] = $;
    return s;
  }
  extract(s) {
    return ZodEnum.create(s);
  }
  exclude(s) {
    return ZodEnum.create(this.options.filter(($) => !s.includes($)));
  }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
  _parse(s) {
    const $ = util$1.getValidEnumValues(this._def.values), _ = this._getOrReturnCtx(s);
    if (_.parsedType !== ZodParsedType.string && _.parsedType !== ZodParsedType.number) {
      const _e = util$1.objectValues($);
      return addIssueToContext(_, {
        expected: util$1.joinValues(_e),
        received: _.parsedType,
        code: ZodIssueCode.invalid_type
      }), INVALID;
    }
    if ($.indexOf(s.data) === -1) {
      const _e = util$1.objectValues($);
      return addIssueToContext(_, {
        received: _.data,
        code: ZodIssueCode.invalid_enum_value,
        options: _e
      }), INVALID;
    }
    return OK(s.data);
  }
  get enum() {
    return this._def.values;
  }
}
ZodNativeEnum.create = (a, s) => new ZodNativeEnum({
  values: a,
  typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
  ...processCreateParams(s)
});
class ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(s) {
    const { ctx: $ } = this._processInputParams(s);
    if ($.parsedType !== ZodParsedType.promise && $.common.async === !1)
      return addIssueToContext($, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: $.parsedType
      }), INVALID;
    const _ = $.parsedType === ZodParsedType.promise ? $.data : Promise.resolve($.data);
    return OK(_.then((_e) => this._def.type.parseAsync(_e, {
      path: $.path,
      errorMap: $.common.contextualErrorMap
    })));
  }
}
ZodPromise.create = (a, s) => new ZodPromise({
  type: a,
  typeName: ZodFirstPartyTypeKind.ZodPromise,
  ...processCreateParams(s)
});
class ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(s) {
    const { status: $, ctx: _ } = this._processInputParams(s), _e = this._def.effect || null, tt = {
      addIssue: (nt) => {
        addIssueToContext(_, nt), nt.fatal ? $.abort() : $.dirty();
      },
      get path() {
        return _.path;
      }
    };
    if (tt.addIssue = tt.addIssue.bind(tt), _e.type === "preprocess") {
      const nt = _e.transform(_.data, tt);
      return _.common.issues.length ? {
        status: "dirty",
        value: _.data
      } : _.common.async ? Promise.resolve(nt).then((at) => this._def.schema._parseAsync({
        data: at,
        path: _.path,
        parent: _
      })) : this._def.schema._parseSync({
        data: nt,
        path: _.path,
        parent: _
      });
    }
    if (_e.type === "refinement") {
      const nt = (at) => {
        const ot = _e.refinement(at, tt);
        if (_.common.async)
          return Promise.resolve(ot);
        if (ot instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return at;
      };
      if (_.common.async === !1) {
        const at = this._def.schema._parseSync({
          data: _.data,
          path: _.path,
          parent: _
        });
        return at.status === "aborted" ? INVALID : (at.status === "dirty" && $.dirty(), nt(at.value), { status: $.value, value: at.value });
      } else
        return this._def.schema._parseAsync({ data: _.data, path: _.path, parent: _ }).then((at) => at.status === "aborted" ? INVALID : (at.status === "dirty" && $.dirty(), nt(at.value).then(() => ({ status: $.value, value: at.value }))));
    }
    if (_e.type === "transform")
      if (_.common.async === !1) {
        const nt = this._def.schema._parseSync({
          data: _.data,
          path: _.path,
          parent: _
        });
        if (!isValid(nt))
          return nt;
        const at = _e.transform(nt.value, tt);
        if (at instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: $.value, value: at };
      } else
        return this._def.schema._parseAsync({ data: _.data, path: _.path, parent: _ }).then((nt) => isValid(nt) ? Promise.resolve(_e.transform(nt.value, tt)).then((at) => ({ status: $.value, value: at })) : nt);
    util$1.assertNever(_e);
  }
}
ZodEffects.create = (a, s, $) => new ZodEffects({
  schema: a,
  typeName: ZodFirstPartyTypeKind.ZodEffects,
  effect: s,
  ...processCreateParams($)
});
ZodEffects.createWithPreprocess = (a, s, $) => new ZodEffects({
  schema: s,
  effect: { type: "preprocess", transform: a },
  typeName: ZodFirstPartyTypeKind.ZodEffects,
  ...processCreateParams($)
});
class ZodOptional extends ZodType {
  _parse(s) {
    return this._getType(s) === ZodParsedType.undefined ? OK(void 0) : this._def.innerType._parse(s);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodOptional.create = (a, s) => new ZodOptional({
  innerType: a,
  typeName: ZodFirstPartyTypeKind.ZodOptional,
  ...processCreateParams(s)
});
class ZodNullable extends ZodType {
  _parse(s) {
    return this._getType(s) === ZodParsedType.null ? OK(null) : this._def.innerType._parse(s);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ZodNullable.create = (a, s) => new ZodNullable({
  innerType: a,
  typeName: ZodFirstPartyTypeKind.ZodNullable,
  ...processCreateParams(s)
});
class ZodDefault extends ZodType {
  _parse(s) {
    const { ctx: $ } = this._processInputParams(s);
    let _ = $.data;
    return $.parsedType === ZodParsedType.undefined && (_ = this._def.defaultValue()), this._def.innerType._parse({
      data: _,
      path: $.path,
      parent: $
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ZodDefault.create = (a, s) => new ZodDefault({
  innerType: a,
  typeName: ZodFirstPartyTypeKind.ZodDefault,
  defaultValue: typeof s.default == "function" ? s.default : () => s.default,
  ...processCreateParams(s)
});
class ZodCatch extends ZodType {
  _parse(s) {
    const { ctx: $ } = this._processInputParams(s), _ = {
      ...$,
      common: {
        ...$.common,
        issues: []
      }
    }, _e = this._def.innerType._parse({
      data: _.data,
      path: _.path,
      parent: {
        ..._
      }
    });
    return isAsync(_e) ? _e.then((tt) => ({
      status: "valid",
      value: tt.status === "valid" ? tt.value : this._def.catchValue({
        get error() {
          return new ZodError(_.common.issues);
        },
        input: _.data
      })
    })) : {
      status: "valid",
      value: _e.status === "valid" ? _e.value : this._def.catchValue({
        get error() {
          return new ZodError(_.common.issues);
        },
        input: _.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ZodCatch.create = (a, s) => new ZodCatch({
  innerType: a,
  typeName: ZodFirstPartyTypeKind.ZodCatch,
  catchValue: typeof s.catch == "function" ? s.catch : () => s.catch,
  ...processCreateParams(s)
});
class ZodNaN extends ZodType {
  _parse(s) {
    if (this._getType(s) !== ZodParsedType.nan) {
      const _ = this._getOrReturnCtx(s);
      return addIssueToContext(_, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: _.parsedType
      }), INVALID;
    }
    return { status: "valid", value: s.data };
  }
}
ZodNaN.create = (a) => new ZodNaN({
  typeName: ZodFirstPartyTypeKind.ZodNaN,
  ...processCreateParams(a)
});
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
  _parse(s) {
    const { ctx: $ } = this._processInputParams(s), _ = $.data;
    return this._def.type._parse({
      data: _,
      path: $.path,
      parent: $
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class ZodPipeline extends ZodType {
  _parse(s) {
    const { status: $, ctx: _ } = this._processInputParams(s);
    if (_.common.async)
      return (async () => {
        const tt = await this._def.in._parseAsync({
          data: _.data,
          path: _.path,
          parent: _
        });
        return tt.status === "aborted" ? INVALID : tt.status === "dirty" ? ($.dirty(), DIRTY(tt.value)) : this._def.out._parseAsync({
          data: tt.value,
          path: _.path,
          parent: _
        });
      })();
    {
      const _e = this._def.in._parseSync({
        data: _.data,
        path: _.path,
        parent: _
      });
      return _e.status === "aborted" ? INVALID : _e.status === "dirty" ? ($.dirty(), {
        status: "dirty",
        value: _e.value
      }) : this._def.out._parseSync({
        data: _e.value,
        path: _.path,
        parent: _
      });
    }
  }
  static create(s, $) {
    return new ZodPipeline({
      in: s,
      out: $,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
}
class ZodReadonly extends ZodType {
  _parse(s) {
    const $ = this._def.innerType._parse(s);
    return isValid($) && ($.value = Object.freeze($.value)), $;
  }
}
ZodReadonly.create = (a, s) => new ZodReadonly({
  innerType: a,
  typeName: ZodFirstPartyTypeKind.ZodReadonly,
  ...processCreateParams(s)
});
const custom = (a, s = {}, $) => a ? ZodAny.create().superRefine((_, _e) => {
  var tt, nt;
  if (!a(_)) {
    const at = typeof s == "function" ? s(_) : typeof s == "string" ? { message: s } : s, ot = (nt = (tt = at.fatal) !== null && tt !== void 0 ? tt : $) !== null && nt !== void 0 ? nt : !0, rt = typeof at == "string" ? { message: at } : at;
    _e.addIssue({ code: "custom", ...rt, fatal: ot });
  }
}) : ZodAny.create(), late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(a) {
  a.ZodString = "ZodString", a.ZodNumber = "ZodNumber", a.ZodNaN = "ZodNaN", a.ZodBigInt = "ZodBigInt", a.ZodBoolean = "ZodBoolean", a.ZodDate = "ZodDate", a.ZodSymbol = "ZodSymbol", a.ZodUndefined = "ZodUndefined", a.ZodNull = "ZodNull", a.ZodAny = "ZodAny", a.ZodUnknown = "ZodUnknown", a.ZodNever = "ZodNever", a.ZodVoid = "ZodVoid", a.ZodArray = "ZodArray", a.ZodObject = "ZodObject", a.ZodUnion = "ZodUnion", a.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", a.ZodIntersection = "ZodIntersection", a.ZodTuple = "ZodTuple", a.ZodRecord = "ZodRecord", a.ZodMap = "ZodMap", a.ZodSet = "ZodSet", a.ZodFunction = "ZodFunction", a.ZodLazy = "ZodLazy", a.ZodLiteral = "ZodLiteral", a.ZodEnum = "ZodEnum", a.ZodEffects = "ZodEffects", a.ZodNativeEnum = "ZodNativeEnum", a.ZodOptional = "ZodOptional", a.ZodNullable = "ZodNullable", a.ZodDefault = "ZodDefault", a.ZodCatch = "ZodCatch", a.ZodPromise = "ZodPromise", a.ZodBranded = "ZodBranded", a.ZodPipeline = "ZodPipeline", a.ZodReadonly = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (a, s = {
  message: `Input not instance of ${a.name}`
}) => custom(($) => $ instanceof a, s), stringType = ZodString.create, numberType = ZodNumber.create, nanType = ZodNaN.create, bigIntType = ZodBigInt.create, booleanType = ZodBoolean.create, dateType = ZodDate.create, symbolType = ZodSymbol.create, undefinedType = ZodUndefined.create, nullType = ZodNull.create, anyType = ZodAny.create, unknownType = ZodUnknown.create, neverType = ZodNever.create, voidType = ZodVoid.create, arrayType = ZodArray.create, objectType = ZodObject.create, strictObjectType = ZodObject.strictCreate, unionType = ZodUnion.create, discriminatedUnionType = ZodDiscriminatedUnion.create, intersectionType = ZodIntersection.create, tupleType = ZodTuple.create, recordType = ZodRecord.create, mapType = ZodMap.create, setType = ZodSet.create, functionType = ZodFunction.create, lazyType = ZodLazy.create, literalType = ZodLiteral.create, enumType = ZodEnum.create, nativeEnumType = ZodNativeEnum.create, promiseType = ZodPromise.create, effectsType = ZodEffects.create, optionalType = ZodOptional.create, nullableType = ZodNullable.create, preprocessType = ZodEffects.createWithPreprocess, pipelineType = ZodPipeline.create, ostring = () => stringType().optional(), onumber = () => numberType().optional(), oboolean = () => booleanType().optional(), coerce = {
  string: (a) => ZodString.create({ ...a, coerce: !0 }),
  number: (a) => ZodNumber.create({ ...a, coerce: !0 }),
  boolean: (a) => ZodBoolean.create({
    ...a,
    coerce: !0
  }),
  bigint: (a) => ZodBigInt.create({ ...a, coerce: !0 }),
  date: (a) => ZodDate.create({ ...a, coerce: !0 })
}, NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util$1;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  enum: enumType,
  function: functionType,
  instanceof: instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  null: nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  undefined: undefinedType,
  union: unionType,
  unknown: unknownType,
  void: voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
}), buffer$1 = {}, base64Js = {};
base64Js.byteLength = byteLength$1;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup$2 = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i$2 = 0, len = code$1.length; i$2 < len; ++i$2)
  lookup$2[i$2] = code$1[i$2], revLookup[code$1.charCodeAt(i$2)] = i$2;
revLookup[45] = 62;
revLookup[95] = 63;
function getLens(a) {
  var s = a.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var $ = a.indexOf("=");
  $ === -1 && ($ = s);
  var _ = $ === s ? 0 : 4 - $ % 4;
  return [$, _];
}
function byteLength$1(a) {
  var s = getLens(a), $ = s[0], _ = s[1];
  return ($ + _) * 3 / 4 - _;
}
function _byteLength(a, s, $) {
  return (s + $) * 3 / 4 - $;
}
function toByteArray(a) {
  var s, $ = getLens(a), _ = $[0], _e = $[1], tt = new Arr(_byteLength(a, _, _e)), nt = 0, at = _e > 0 ? _ - 4 : _, ot;
  for (ot = 0; ot < at; ot += 4)
    s = revLookup[a.charCodeAt(ot)] << 18 | revLookup[a.charCodeAt(ot + 1)] << 12 | revLookup[a.charCodeAt(ot + 2)] << 6 | revLookup[a.charCodeAt(ot + 3)], tt[nt++] = s >> 16 & 255, tt[nt++] = s >> 8 & 255, tt[nt++] = s & 255;
  return _e === 2 && (s = revLookup[a.charCodeAt(ot)] << 2 | revLookup[a.charCodeAt(ot + 1)] >> 4, tt[nt++] = s & 255), _e === 1 && (s = revLookup[a.charCodeAt(ot)] << 10 | revLookup[a.charCodeAt(ot + 1)] << 4 | revLookup[a.charCodeAt(ot + 2)] >> 2, tt[nt++] = s >> 8 & 255, tt[nt++] = s & 255), tt;
}
function tripletToBase64(a) {
  return lookup$2[a >> 18 & 63] + lookup$2[a >> 12 & 63] + lookup$2[a >> 6 & 63] + lookup$2[a & 63];
}
function encodeChunk(a, s, $) {
  for (var _, _e = [], tt = s; tt < $; tt += 3)
    _ = (a[tt] << 16 & 16711680) + (a[tt + 1] << 8 & 65280) + (a[tt + 2] & 255), _e.push(tripletToBase64(_));
  return _e.join("");
}
function fromByteArray(a) {
  for (var s, $ = a.length, _ = $ % 3, _e = [], tt = 16383, nt = 0, at = $ - _; nt < at; nt += tt)
    _e.push(encodeChunk(a, nt, nt + tt > at ? at : nt + tt));
  return _ === 1 ? (s = a[$ - 1], _e.push(
    lookup$2[s >> 2] + lookup$2[s << 4 & 63] + "=="
  )) : _ === 2 && (s = (a[$ - 2] << 8) + a[$ - 1], _e.push(
    lookup$2[s >> 10] + lookup$2[s >> 4 & 63] + lookup$2[s << 2 & 63] + "="
  )), _e.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(a, s, $, _, _e) {
  var tt, nt, at = _e * 8 - _ - 1, ot = (1 << at) - 1, rt = ot >> 1, st = -7, lt = $ ? _e - 1 : 0, et = $ ? -1 : 1, it = a[s + lt];
  for (lt += et, tt = it & (1 << -st) - 1, it >>= -st, st += at; st > 0; tt = tt * 256 + a[s + lt], lt += et, st -= 8)
    ;
  for (nt = tt & (1 << -st) - 1, tt >>= -st, st += _; st > 0; nt = nt * 256 + a[s + lt], lt += et, st -= 8)
    ;
  if (tt === 0)
    tt = 1 - rt;
  else {
    if (tt === ot)
      return nt ? NaN : (it ? -1 : 1) * (1 / 0);
    nt = nt + Math.pow(2, _), tt = tt - rt;
  }
  return (it ? -1 : 1) * nt * Math.pow(2, tt - _);
};
ieee754.write = function(a, s, $, _, _e, tt) {
  var nt, at, ot, rt = tt * 8 - _e - 1, st = (1 << rt) - 1, lt = st >> 1, et = _e === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, it = _ ? 0 : tt - 1, ut = _ ? 1 : -1, ft = s < 0 || s === 0 && 1 / s < 0 ? 1 : 0;
  for (s = Math.abs(s), isNaN(s) || s === 1 / 0 ? (at = isNaN(s) ? 1 : 0, nt = st) : (nt = Math.floor(Math.log(s) / Math.LN2), s * (ot = Math.pow(2, -nt)) < 1 && (nt--, ot *= 2), nt + lt >= 1 ? s += et / ot : s += et * Math.pow(2, 1 - lt), s * ot >= 2 && (nt++, ot /= 2), nt + lt >= st ? (at = 0, nt = st) : nt + lt >= 1 ? (at = (s * ot - 1) * Math.pow(2, _e), nt = nt + lt) : (at = s * Math.pow(2, lt - 1) * Math.pow(2, _e), nt = 0)); _e >= 8; a[$ + it] = at & 255, it += ut, at /= 256, _e -= 8)
    ;
  for (nt = nt << _e | at, rt += _e; rt > 0; a[$ + it] = nt & 255, it += ut, nt /= 256, rt -= 8)
    ;
  a[$ + it - ut] |= ft * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(a) {
  const s = base64Js, $ = ieee754, _ = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  a.Buffer = at, a.SlowBuffer = gt, a.INSPECT_MAX_BYTES = 50;
  const _e = 2147483647;
  a.kMaxLength = _e, at.TYPED_ARRAY_SUPPORT = tt(), !at.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function tt() {
    try {
      const Xt = new Uint8Array(1), Gt = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(Gt, Uint8Array.prototype), Object.setPrototypeOf(Xt, Gt), Xt.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(at.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (at.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(at.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (at.isBuffer(this))
        return this.byteOffset;
    }
  });
  function nt(Xt) {
    if (Xt > _e)
      throw new RangeError('The value "' + Xt + '" is invalid for option "size"');
    const Gt = new Uint8Array(Xt);
    return Object.setPrototypeOf(Gt, at.prototype), Gt;
  }
  function at(Xt, Gt, Wt) {
    if (typeof Xt == "number") {
      if (typeof Gt == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return lt(Xt);
    }
    return ot(Xt, Gt, Wt);
  }
  at.poolSize = 8192;
  function ot(Xt, Gt, Wt) {
    if (typeof Xt == "string")
      return et(Xt, Gt);
    if (ArrayBuffer.isView(Xt))
      return ut(Xt);
    if (Xt == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Xt
      );
    if (tr(Xt, ArrayBuffer) || Xt && tr(Xt.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (tr(Xt, SharedArrayBuffer) || Xt && tr(Xt.buffer, SharedArrayBuffer)))
      return ft(Xt, Gt, Wt);
    if (typeof Xt == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const er = Xt.valueOf && Xt.valueOf();
    if (er != null && er !== Xt)
      return at.from(er, Gt, Wt);
    const lr = ht(Xt);
    if (lr)
      return lr;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Xt[Symbol.toPrimitive] == "function")
      return at.from(Xt[Symbol.toPrimitive]("string"), Gt, Wt);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Xt
    );
  }
  at.from = function(Xt, Gt, Wt) {
    return ot(Xt, Gt, Wt);
  }, Object.setPrototypeOf(at.prototype, Uint8Array.prototype), Object.setPrototypeOf(at, Uint8Array);
  function rt(Xt) {
    if (typeof Xt != "number")
      throw new TypeError('"size" argument must be of type number');
    if (Xt < 0)
      throw new RangeError('The value "' + Xt + '" is invalid for option "size"');
  }
  function st(Xt, Gt, Wt) {
    return rt(Xt), Xt <= 0 ? nt(Xt) : Gt !== void 0 ? typeof Wt == "string" ? nt(Xt).fill(Gt, Wt) : nt(Xt).fill(Gt) : nt(Xt);
  }
  at.alloc = function(Xt, Gt, Wt) {
    return st(Xt, Gt, Wt);
  };
  function lt(Xt) {
    return rt(Xt), nt(Xt < 0 ? 0 : dt(Xt) | 0);
  }
  at.allocUnsafe = function(Xt) {
    return lt(Xt);
  }, at.allocUnsafeSlow = function(Xt) {
    return lt(Xt);
  };
  function et(Xt, Gt) {
    if ((typeof Gt != "string" || Gt === "") && (Gt = "utf8"), !at.isEncoding(Gt))
      throw new TypeError("Unknown encoding: " + Gt);
    const Wt = pt(Xt, Gt) | 0;
    let er = nt(Wt);
    const lr = er.write(Xt, Gt);
    return lr !== Wt && (er = er.slice(0, lr)), er;
  }
  function it(Xt) {
    const Gt = Xt.length < 0 ? 0 : dt(Xt.length) | 0, Wt = nt(Gt);
    for (let er = 0; er < Gt; er += 1)
      Wt[er] = Xt[er] & 255;
    return Wt;
  }
  function ut(Xt) {
    if (tr(Xt, Uint8Array)) {
      const Gt = new Uint8Array(Xt);
      return ft(Gt.buffer, Gt.byteOffset, Gt.byteLength);
    }
    return it(Xt);
  }
  function ft(Xt, Gt, Wt) {
    if (Gt < 0 || Xt.byteLength < Gt)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (Xt.byteLength < Gt + (Wt || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let er;
    return Gt === void 0 && Wt === void 0 ? er = new Uint8Array(Xt) : Wt === void 0 ? er = new Uint8Array(Xt, Gt) : er = new Uint8Array(Xt, Gt, Wt), Object.setPrototypeOf(er, at.prototype), er;
  }
  function ht(Xt) {
    if (at.isBuffer(Xt)) {
      const Gt = dt(Xt.length) | 0, Wt = nt(Gt);
      return Wt.length === 0 || Xt.copy(Wt, 0, 0, Gt), Wt;
    }
    if (Xt.length !== void 0)
      return typeof Xt.length != "number" || ir(Xt.length) ? nt(0) : it(Xt);
    if (Xt.type === "Buffer" && Array.isArray(Xt.data))
      return it(Xt.data);
  }
  function dt(Xt) {
    if (Xt >= _e)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + _e.toString(16) + " bytes");
    return Xt | 0;
  }
  function gt(Xt) {
    return +Xt != Xt && (Xt = 0), at.alloc(+Xt);
  }
  at.isBuffer = function(Gt) {
    return Gt != null && Gt._isBuffer === !0 && Gt !== at.prototype;
  }, at.compare = function(Gt, Wt) {
    if (tr(Gt, Uint8Array) && (Gt = at.from(Gt, Gt.offset, Gt.byteLength)), tr(Wt, Uint8Array) && (Wt = at.from(Wt, Wt.offset, Wt.byteLength)), !at.isBuffer(Gt) || !at.isBuffer(Wt))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (Gt === Wt)
      return 0;
    let er = Gt.length, lr = Wt.length;
    for (let ur = 0, pr = Math.min(er, lr); ur < pr; ++ur)
      if (Gt[ur] !== Wt[ur]) {
        er = Gt[ur], lr = Wt[ur];
        break;
      }
    return er < lr ? -1 : lr < er ? 1 : 0;
  }, at.isEncoding = function(Gt) {
    switch (String(Gt).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, at.concat = function(Gt, Wt) {
    if (!Array.isArray(Gt))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (Gt.length === 0)
      return at.alloc(0);
    let er;
    if (Wt === void 0)
      for (Wt = 0, er = 0; er < Gt.length; ++er)
        Wt += Gt[er].length;
    const lr = at.allocUnsafe(Wt);
    let ur = 0;
    for (er = 0; er < Gt.length; ++er) {
      let pr = Gt[er];
      if (tr(pr, Uint8Array))
        ur + pr.length > lr.length ? (at.isBuffer(pr) || (pr = at.from(pr)), pr.copy(lr, ur)) : Uint8Array.prototype.set.call(
          lr,
          pr,
          ur
        );
      else if (at.isBuffer(pr))
        pr.copy(lr, ur);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      ur += pr.length;
    }
    return lr;
  };
  function pt(Xt, Gt) {
    if (at.isBuffer(Xt))
      return Xt.length;
    if (ArrayBuffer.isView(Xt) || tr(Xt, ArrayBuffer))
      return Xt.byteLength;
    if (typeof Xt != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Xt
      );
    const Wt = Xt.length, er = arguments.length > 2 && arguments[2] === !0;
    if (!er && Wt === 0)
      return 0;
    let lr = !1;
    for (; ; )
      switch (Gt) {
        case "ascii":
        case "latin1":
        case "binary":
          return Wt;
        case "utf8":
        case "utf-8":
          return Jt(Xt).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Wt * 2;
        case "hex":
          return Wt >>> 1;
        case "base64":
          return Kt(Xt).length;
        default:
          if (lr)
            return er ? -1 : Jt(Xt).length;
          Gt = ("" + Gt).toLowerCase(), lr = !0;
      }
  }
  at.byteLength = pt;
  function mt(Xt, Gt, Wt) {
    let er = !1;
    if ((Gt === void 0 || Gt < 0) && (Gt = 0), Gt > this.length || ((Wt === void 0 || Wt > this.length) && (Wt = this.length), Wt <= 0) || (Wt >>>= 0, Gt >>>= 0, Wt <= Gt))
      return "";
    for (Xt || (Xt = "utf8"); ; )
      switch (Xt) {
        case "hex":
          return Rt(this, Gt, Wt);
        case "utf8":
        case "utf-8":
          return Pt(this, Gt, Wt);
        case "ascii":
          return It(this, Gt, Wt);
        case "latin1":
        case "binary":
          return yt(this, Gt, Wt);
        case "base64":
          return Ot(this, Gt, Wt);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return kt(this, Gt, Wt);
        default:
          if (er)
            throw new TypeError("Unknown encoding: " + Xt);
          Xt = (Xt + "").toLowerCase(), er = !0;
      }
  }
  at.prototype._isBuffer = !0;
  function ct(Xt, Gt, Wt) {
    const er = Xt[Gt];
    Xt[Gt] = Xt[Wt], Xt[Wt] = er;
  }
  at.prototype.swap16 = function() {
    const Gt = this.length;
    if (Gt % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let Wt = 0; Wt < Gt; Wt += 2)
      ct(this, Wt, Wt + 1);
    return this;
  }, at.prototype.swap32 = function() {
    const Gt = this.length;
    if (Gt % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let Wt = 0; Wt < Gt; Wt += 4)
      ct(this, Wt, Wt + 3), ct(this, Wt + 1, Wt + 2);
    return this;
  }, at.prototype.swap64 = function() {
    const Gt = this.length;
    if (Gt % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let Wt = 0; Wt < Gt; Wt += 8)
      ct(this, Wt, Wt + 7), ct(this, Wt + 1, Wt + 6), ct(this, Wt + 2, Wt + 5), ct(this, Wt + 3, Wt + 4);
    return this;
  }, at.prototype.toString = function() {
    const Gt = this.length;
    return Gt === 0 ? "" : arguments.length === 0 ? Pt(this, 0, Gt) : mt.apply(this, arguments);
  }, at.prototype.toLocaleString = at.prototype.toString, at.prototype.equals = function(Gt) {
    if (!at.isBuffer(Gt))
      throw new TypeError("Argument must be a Buffer");
    return this === Gt ? !0 : at.compare(this, Gt) === 0;
  }, at.prototype.inspect = function() {
    let Gt = "";
    const Wt = a.INSPECT_MAX_BYTES;
    return Gt = this.toString("hex", 0, Wt).replace(/(.{2})/g, "$1 ").trim(), this.length > Wt && (Gt += " ... "), "<Buffer " + Gt + ">";
  }, _ && (at.prototype[_] = at.prototype.inspect), at.prototype.compare = function(Gt, Wt, er, lr, ur) {
    if (tr(Gt, Uint8Array) && (Gt = at.from(Gt, Gt.offset, Gt.byteLength)), !at.isBuffer(Gt))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Gt
      );
    if (Wt === void 0 && (Wt = 0), er === void 0 && (er = Gt ? Gt.length : 0), lr === void 0 && (lr = 0), ur === void 0 && (ur = this.length), Wt < 0 || er > Gt.length || lr < 0 || ur > this.length)
      throw new RangeError("out of range index");
    if (lr >= ur && Wt >= er)
      return 0;
    if (lr >= ur)
      return -1;
    if (Wt >= er)
      return 1;
    if (Wt >>>= 0, er >>>= 0, lr >>>= 0, ur >>>= 0, this === Gt)
      return 0;
    let pr = ur - lr, yr = er - Wt;
    const Er = Math.min(pr, yr), br = this.slice(lr, ur), gr = Gt.slice(Wt, er);
    for (let Ar = 0; Ar < Er; ++Ar)
      if (br[Ar] !== gr[Ar]) {
        pr = br[Ar], yr = gr[Ar];
        break;
      }
    return pr < yr ? -1 : yr < pr ? 1 : 0;
  };
  function vt(Xt, Gt, Wt, er, lr) {
    if (Xt.length === 0)
      return -1;
    if (typeof Wt == "string" ? (er = Wt, Wt = 0) : Wt > 2147483647 ? Wt = 2147483647 : Wt < -2147483648 && (Wt = -2147483648), Wt = +Wt, ir(Wt) && (Wt = lr ? 0 : Xt.length - 1), Wt < 0 && (Wt = Xt.length + Wt), Wt >= Xt.length) {
      if (lr)
        return -1;
      Wt = Xt.length - 1;
    } else if (Wt < 0)
      if (lr)
        Wt = 0;
      else
        return -1;
    if (typeof Gt == "string" && (Gt = at.from(Gt, er)), at.isBuffer(Gt))
      return Gt.length === 0 ? -1 : At(Xt, Gt, Wt, er, lr);
    if (typeof Gt == "number")
      return Gt = Gt & 255, typeof Uint8Array.prototype.indexOf == "function" ? lr ? Uint8Array.prototype.indexOf.call(Xt, Gt, Wt) : Uint8Array.prototype.lastIndexOf.call(Xt, Gt, Wt) : At(Xt, [Gt], Wt, er, lr);
    throw new TypeError("val must be string, number or Buffer");
  }
  function At(Xt, Gt, Wt, er, lr) {
    let ur = 1, pr = Xt.length, yr = Gt.length;
    if (er !== void 0 && (er = String(er).toLowerCase(), er === "ucs2" || er === "ucs-2" || er === "utf16le" || er === "utf-16le")) {
      if (Xt.length < 2 || Gt.length < 2)
        return -1;
      ur = 2, pr /= 2, yr /= 2, Wt /= 2;
    }
    function Er(gr, Ar) {
      return ur === 1 ? gr[Ar] : gr.readUInt16BE(Ar * ur);
    }
    let br;
    if (lr) {
      let gr = -1;
      for (br = Wt; br < pr; br++)
        if (Er(Xt, br) === Er(Gt, gr === -1 ? 0 : br - gr)) {
          if (gr === -1 && (gr = br), br - gr + 1 === yr)
            return gr * ur;
        } else
          gr !== -1 && (br -= br - gr), gr = -1;
    } else
      for (Wt + yr > pr && (Wt = pr - yr), br = Wt; br >= 0; br--) {
        let gr = !0;
        for (let Ar = 0; Ar < yr; Ar++)
          if (Er(Xt, br + Ar) !== Er(Gt, Ar)) {
            gr = !1;
            break;
          }
        if (gr)
          return br;
      }
    return -1;
  }
  at.prototype.includes = function(Gt, Wt, er) {
    return this.indexOf(Gt, Wt, er) !== -1;
  }, at.prototype.indexOf = function(Gt, Wt, er) {
    return vt(this, Gt, Wt, er, !0);
  }, at.prototype.lastIndexOf = function(Gt, Wt, er) {
    return vt(this, Gt, Wt, er, !1);
  };
  function xt(Xt, Gt, Wt, er) {
    Wt = Number(Wt) || 0;
    const lr = Xt.length - Wt;
    er ? (er = Number(er), er > lr && (er = lr)) : er = lr;
    const ur = Gt.length;
    er > ur / 2 && (er = ur / 2);
    let pr;
    for (pr = 0; pr < er; ++pr) {
      const yr = parseInt(Gt.substr(pr * 2, 2), 16);
      if (ir(yr))
        return pr;
      Xt[Wt + pr] = yr;
    }
    return pr;
  }
  function bt(Xt, Gt, Wt, er) {
    return nr(Jt(Gt, Xt.length - Wt), Xt, Wt, er);
  }
  function Et(Xt, Gt, Wt, er) {
    return nr(rr(Gt), Xt, Wt, er);
  }
  function St(Xt, Gt, Wt, er) {
    return nr(Kt(Gt), Xt, Wt, er);
  }
  function Bt(Xt, Gt, Wt, er) {
    return nr(Yt(Gt, Xt.length - Wt), Xt, Wt, er);
  }
  at.prototype.write = function(Gt, Wt, er, lr) {
    if (Wt === void 0)
      lr = "utf8", er = this.length, Wt = 0;
    else if (er === void 0 && typeof Wt == "string")
      lr = Wt, er = this.length, Wt = 0;
    else if (isFinite(Wt))
      Wt = Wt >>> 0, isFinite(er) ? (er = er >>> 0, lr === void 0 && (lr = "utf8")) : (lr = er, er = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const ur = this.length - Wt;
    if ((er === void 0 || er > ur) && (er = ur), Gt.length > 0 && (er < 0 || Wt < 0) || Wt > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    lr || (lr = "utf8");
    let pr = !1;
    for (; ; )
      switch (lr) {
        case "hex":
          return xt(this, Gt, Wt, er);
        case "utf8":
        case "utf-8":
          return bt(this, Gt, Wt, er);
        case "ascii":
        case "latin1":
        case "binary":
          return Et(this, Gt, Wt, er);
        case "base64":
          return St(this, Gt, Wt, er);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Bt(this, Gt, Wt, er);
        default:
          if (pr)
            throw new TypeError("Unknown encoding: " + lr);
          lr = ("" + lr).toLowerCase(), pr = !0;
      }
  }, at.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function Ot(Xt, Gt, Wt) {
    return Gt === 0 && Wt === Xt.length ? s.fromByteArray(Xt) : s.fromByteArray(Xt.slice(Gt, Wt));
  }
  function Pt(Xt, Gt, Wt) {
    Wt = Math.min(Xt.length, Wt);
    const er = [];
    let lr = Gt;
    for (; lr < Wt; ) {
      const ur = Xt[lr];
      let pr = null, yr = ur > 239 ? 4 : ur > 223 ? 3 : ur > 191 ? 2 : 1;
      if (lr + yr <= Wt) {
        let Er, br, gr, Ar;
        switch (yr) {
          case 1:
            ur < 128 && (pr = ur);
            break;
          case 2:
            Er = Xt[lr + 1], (Er & 192) === 128 && (Ar = (ur & 31) << 6 | Er & 63, Ar > 127 && (pr = Ar));
            break;
          case 3:
            Er = Xt[lr + 1], br = Xt[lr + 2], (Er & 192) === 128 && (br & 192) === 128 && (Ar = (ur & 15) << 12 | (Er & 63) << 6 | br & 63, Ar > 2047 && (Ar < 55296 || Ar > 57343) && (pr = Ar));
            break;
          case 4:
            Er = Xt[lr + 1], br = Xt[lr + 2], gr = Xt[lr + 3], (Er & 192) === 128 && (br & 192) === 128 && (gr & 192) === 128 && (Ar = (ur & 15) << 18 | (Er & 63) << 12 | (br & 63) << 6 | gr & 63, Ar > 65535 && Ar < 1114112 && (pr = Ar));
        }
      }
      pr === null ? (pr = 65533, yr = 1) : pr > 65535 && (pr -= 65536, er.push(pr >>> 10 & 1023 | 55296), pr = 56320 | pr & 1023), er.push(pr), lr += yr;
    }
    return Ct(er);
  }
  const wt = 4096;
  function Ct(Xt) {
    const Gt = Xt.length;
    if (Gt <= wt)
      return String.fromCharCode.apply(String, Xt);
    let Wt = "", er = 0;
    for (; er < Gt; )
      Wt += String.fromCharCode.apply(
        String,
        Xt.slice(er, er += wt)
      );
    return Wt;
  }
  function It(Xt, Gt, Wt) {
    let er = "";
    Wt = Math.min(Xt.length, Wt);
    for (let lr = Gt; lr < Wt; ++lr)
      er += String.fromCharCode(Xt[lr] & 127);
    return er;
  }
  function yt(Xt, Gt, Wt) {
    let er = "";
    Wt = Math.min(Xt.length, Wt);
    for (let lr = Gt; lr < Wt; ++lr)
      er += String.fromCharCode(Xt[lr]);
    return er;
  }
  function Rt(Xt, Gt, Wt) {
    const er = Xt.length;
    (!Gt || Gt < 0) && (Gt = 0), (!Wt || Wt < 0 || Wt > er) && (Wt = er);
    let lr = "";
    for (let ur = Gt; ur < Wt; ++ur)
      lr += sr[Xt[ur]];
    return lr;
  }
  function kt(Xt, Gt, Wt) {
    const er = Xt.slice(Gt, Wt);
    let lr = "";
    for (let ur = 0; ur < er.length - 1; ur += 2)
      lr += String.fromCharCode(er[ur] + er[ur + 1] * 256);
    return lr;
  }
  at.prototype.slice = function(Gt, Wt) {
    const er = this.length;
    Gt = ~~Gt, Wt = Wt === void 0 ? er : ~~Wt, Gt < 0 ? (Gt += er, Gt < 0 && (Gt = 0)) : Gt > er && (Gt = er), Wt < 0 ? (Wt += er, Wt < 0 && (Wt = 0)) : Wt > er && (Wt = er), Wt < Gt && (Wt = Gt);
    const lr = this.subarray(Gt, Wt);
    return Object.setPrototypeOf(lr, at.prototype), lr;
  };
  function jt(Xt, Gt, Wt) {
    if (Xt % 1 !== 0 || Xt < 0)
      throw new RangeError("offset is not uint");
    if (Xt + Gt > Wt)
      throw new RangeError("Trying to access beyond buffer length");
  }
  at.prototype.readUintLE = at.prototype.readUIntLE = function(Gt, Wt, er) {
    Gt = Gt >>> 0, Wt = Wt >>> 0, er || jt(Gt, Wt, this.length);
    let lr = this[Gt], ur = 1, pr = 0;
    for (; ++pr < Wt && (ur *= 256); )
      lr += this[Gt + pr] * ur;
    return lr;
  }, at.prototype.readUintBE = at.prototype.readUIntBE = function(Gt, Wt, er) {
    Gt = Gt >>> 0, Wt = Wt >>> 0, er || jt(Gt, Wt, this.length);
    let lr = this[Gt + --Wt], ur = 1;
    for (; Wt > 0 && (ur *= 256); )
      lr += this[Gt + --Wt] * ur;
    return lr;
  }, at.prototype.readUint8 = at.prototype.readUInt8 = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 1, this.length), this[Gt];
  }, at.prototype.readUint16LE = at.prototype.readUInt16LE = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 2, this.length), this[Gt] | this[Gt + 1] << 8;
  }, at.prototype.readUint16BE = at.prototype.readUInt16BE = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 2, this.length), this[Gt] << 8 | this[Gt + 1];
  }, at.prototype.readUint32LE = at.prototype.readUInt32LE = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 4, this.length), (this[Gt] | this[Gt + 1] << 8 | this[Gt + 2] << 16) + this[Gt + 3] * 16777216;
  }, at.prototype.readUint32BE = at.prototype.readUInt32BE = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 4, this.length), this[Gt] * 16777216 + (this[Gt + 1] << 16 | this[Gt + 2] << 8 | this[Gt + 3]);
  }, at.prototype.readBigUInt64LE = cr(function(Gt) {
    Gt = Gt >>> 0, Qt(Gt, "offset");
    const Wt = this[Gt], er = this[Gt + 7];
    (Wt === void 0 || er === void 0) && qt(Gt, this.length - 8);
    const lr = Wt + this[++Gt] * 2 ** 8 + this[++Gt] * 2 ** 16 + this[++Gt] * 2 ** 24, ur = this[++Gt] + this[++Gt] * 2 ** 8 + this[++Gt] * 2 ** 16 + er * 2 ** 24;
    return BigInt(lr) + (BigInt(ur) << BigInt(32));
  }), at.prototype.readBigUInt64BE = cr(function(Gt) {
    Gt = Gt >>> 0, Qt(Gt, "offset");
    const Wt = this[Gt], er = this[Gt + 7];
    (Wt === void 0 || er === void 0) && qt(Gt, this.length - 8);
    const lr = Wt * 2 ** 24 + this[++Gt] * 2 ** 16 + this[++Gt] * 2 ** 8 + this[++Gt], ur = this[++Gt] * 2 ** 24 + this[++Gt] * 2 ** 16 + this[++Gt] * 2 ** 8 + er;
    return (BigInt(lr) << BigInt(32)) + BigInt(ur);
  }), at.prototype.readIntLE = function(Gt, Wt, er) {
    Gt = Gt >>> 0, Wt = Wt >>> 0, er || jt(Gt, Wt, this.length);
    let lr = this[Gt], ur = 1, pr = 0;
    for (; ++pr < Wt && (ur *= 256); )
      lr += this[Gt + pr] * ur;
    return ur *= 128, lr >= ur && (lr -= Math.pow(2, 8 * Wt)), lr;
  }, at.prototype.readIntBE = function(Gt, Wt, er) {
    Gt = Gt >>> 0, Wt = Wt >>> 0, er || jt(Gt, Wt, this.length);
    let lr = Wt, ur = 1, pr = this[Gt + --lr];
    for (; lr > 0 && (ur *= 256); )
      pr += this[Gt + --lr] * ur;
    return ur *= 128, pr >= ur && (pr -= Math.pow(2, 8 * Wt)), pr;
  }, at.prototype.readInt8 = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 1, this.length), this[Gt] & 128 ? (255 - this[Gt] + 1) * -1 : this[Gt];
  }, at.prototype.readInt16LE = function(Gt, Wt) {
    Gt = Gt >>> 0, Wt || jt(Gt, 2, this.length);
    const er = this[Gt] | this[Gt + 1] << 8;
    return er & 32768 ? er | 4294901760 : er;
  }, at.prototype.readInt16BE = function(Gt, Wt) {
    Gt = Gt >>> 0, Wt || jt(Gt, 2, this.length);
    const er = this[Gt + 1] | this[Gt] << 8;
    return er & 32768 ? er | 4294901760 : er;
  }, at.prototype.readInt32LE = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 4, this.length), this[Gt] | this[Gt + 1] << 8 | this[Gt + 2] << 16 | this[Gt + 3] << 24;
  }, at.prototype.readInt32BE = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 4, this.length), this[Gt] << 24 | this[Gt + 1] << 16 | this[Gt + 2] << 8 | this[Gt + 3];
  }, at.prototype.readBigInt64LE = cr(function(Gt) {
    Gt = Gt >>> 0, Qt(Gt, "offset");
    const Wt = this[Gt], er = this[Gt + 7];
    (Wt === void 0 || er === void 0) && qt(Gt, this.length - 8);
    const lr = this[Gt + 4] + this[Gt + 5] * 2 ** 8 + this[Gt + 6] * 2 ** 16 + (er << 24);
    return (BigInt(lr) << BigInt(32)) + BigInt(Wt + this[++Gt] * 2 ** 8 + this[++Gt] * 2 ** 16 + this[++Gt] * 2 ** 24);
  }), at.prototype.readBigInt64BE = cr(function(Gt) {
    Gt = Gt >>> 0, Qt(Gt, "offset");
    const Wt = this[Gt], er = this[Gt + 7];
    (Wt === void 0 || er === void 0) && qt(Gt, this.length - 8);
    const lr = (Wt << 24) + // Overflow
    this[++Gt] * 2 ** 16 + this[++Gt] * 2 ** 8 + this[++Gt];
    return (BigInt(lr) << BigInt(32)) + BigInt(this[++Gt] * 2 ** 24 + this[++Gt] * 2 ** 16 + this[++Gt] * 2 ** 8 + er);
  }), at.prototype.readFloatLE = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 4, this.length), $.read(this, Gt, !0, 23, 4);
  }, at.prototype.readFloatBE = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 4, this.length), $.read(this, Gt, !1, 23, 4);
  }, at.prototype.readDoubleLE = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 8, this.length), $.read(this, Gt, !0, 52, 8);
  }, at.prototype.readDoubleBE = function(Gt, Wt) {
    return Gt = Gt >>> 0, Wt || jt(Gt, 8, this.length), $.read(this, Gt, !1, 52, 8);
  };
  function Ht(Xt, Gt, Wt, er, lr, ur) {
    if (!at.isBuffer(Xt))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (Gt > lr || Gt < ur)
      throw new RangeError('"value" argument is out of bounds');
    if (Wt + er > Xt.length)
      throw new RangeError("Index out of range");
  }
  at.prototype.writeUintLE = at.prototype.writeUIntLE = function(Gt, Wt, er, lr) {
    if (Gt = +Gt, Wt = Wt >>> 0, er = er >>> 0, !lr) {
      const yr = Math.pow(2, 8 * er) - 1;
      Ht(this, Gt, Wt, er, yr, 0);
    }
    let ur = 1, pr = 0;
    for (this[Wt] = Gt & 255; ++pr < er && (ur *= 256); )
      this[Wt + pr] = Gt / ur & 255;
    return Wt + er;
  }, at.prototype.writeUintBE = at.prototype.writeUIntBE = function(Gt, Wt, er, lr) {
    if (Gt = +Gt, Wt = Wt >>> 0, er = er >>> 0, !lr) {
      const yr = Math.pow(2, 8 * er) - 1;
      Ht(this, Gt, Wt, er, yr, 0);
    }
    let ur = er - 1, pr = 1;
    for (this[Wt + ur] = Gt & 255; --ur >= 0 && (pr *= 256); )
      this[Wt + ur] = Gt / pr & 255;
    return Wt + er;
  }, at.prototype.writeUint8 = at.prototype.writeUInt8 = function(Gt, Wt, er) {
    return Gt = +Gt, Wt = Wt >>> 0, er || Ht(this, Gt, Wt, 1, 255, 0), this[Wt] = Gt & 255, Wt + 1;
  }, at.prototype.writeUint16LE = at.prototype.writeUInt16LE = function(Gt, Wt, er) {
    return Gt = +Gt, Wt = Wt >>> 0, er || Ht(this, Gt, Wt, 2, 65535, 0), this[Wt] = Gt & 255, this[Wt + 1] = Gt >>> 8, Wt + 2;
  }, at.prototype.writeUint16BE = at.prototype.writeUInt16BE = function(Gt, Wt, er) {
    return Gt = +Gt, Wt = Wt >>> 0, er || Ht(this, Gt, Wt, 2, 65535, 0), this[Wt] = Gt >>> 8, this[Wt + 1] = Gt & 255, Wt + 2;
  }, at.prototype.writeUint32LE = at.prototype.writeUInt32LE = function(Gt, Wt, er) {
    return Gt = +Gt, Wt = Wt >>> 0, er || Ht(this, Gt, Wt, 4, 4294967295, 0), this[Wt + 3] = Gt >>> 24, this[Wt + 2] = Gt >>> 16, this[Wt + 1] = Gt >>> 8, this[Wt] = Gt & 255, Wt + 4;
  }, at.prototype.writeUint32BE = at.prototype.writeUInt32BE = function(Gt, Wt, er) {
    return Gt = +Gt, Wt = Wt >>> 0, er || Ht(this, Gt, Wt, 4, 4294967295, 0), this[Wt] = Gt >>> 24, this[Wt + 1] = Gt >>> 16, this[Wt + 2] = Gt >>> 8, this[Wt + 3] = Gt & 255, Wt + 4;
  };
  function Ft(Xt, Gt, Wt, er, lr) {
    Vt(Gt, er, lr, Xt, Wt, 7);
    let ur = Number(Gt & BigInt(4294967295));
    Xt[Wt++] = ur, ur = ur >> 8, Xt[Wt++] = ur, ur = ur >> 8, Xt[Wt++] = ur, ur = ur >> 8, Xt[Wt++] = ur;
    let pr = Number(Gt >> BigInt(32) & BigInt(4294967295));
    return Xt[Wt++] = pr, pr = pr >> 8, Xt[Wt++] = pr, pr = pr >> 8, Xt[Wt++] = pr, pr = pr >> 8, Xt[Wt++] = pr, Wt;
  }
  function _t(Xt, Gt, Wt, er, lr) {
    Vt(Gt, er, lr, Xt, Wt, 7);
    let ur = Number(Gt & BigInt(4294967295));
    Xt[Wt + 7] = ur, ur = ur >> 8, Xt[Wt + 6] = ur, ur = ur >> 8, Xt[Wt + 5] = ur, ur = ur >> 8, Xt[Wt + 4] = ur;
    let pr = Number(Gt >> BigInt(32) & BigInt(4294967295));
    return Xt[Wt + 3] = pr, pr = pr >> 8, Xt[Wt + 2] = pr, pr = pr >> 8, Xt[Wt + 1] = pr, pr = pr >> 8, Xt[Wt] = pr, Wt + 8;
  }
  at.prototype.writeBigUInt64LE = cr(function(Gt, Wt = 0) {
    return Ft(this, Gt, Wt, BigInt(0), BigInt("0xffffffffffffffff"));
  }), at.prototype.writeBigUInt64BE = cr(function(Gt, Wt = 0) {
    return _t(this, Gt, Wt, BigInt(0), BigInt("0xffffffffffffffff"));
  }), at.prototype.writeIntLE = function(Gt, Wt, er, lr) {
    if (Gt = +Gt, Wt = Wt >>> 0, !lr) {
      const Er = Math.pow(2, 8 * er - 1);
      Ht(this, Gt, Wt, er, Er - 1, -Er);
    }
    let ur = 0, pr = 1, yr = 0;
    for (this[Wt] = Gt & 255; ++ur < er && (pr *= 256); )
      Gt < 0 && yr === 0 && this[Wt + ur - 1] !== 0 && (yr = 1), this[Wt + ur] = (Gt / pr >> 0) - yr & 255;
    return Wt + er;
  }, at.prototype.writeIntBE = function(Gt, Wt, er, lr) {
    if (Gt = +Gt, Wt = Wt >>> 0, !lr) {
      const Er = Math.pow(2, 8 * er - 1);
      Ht(this, Gt, Wt, er, Er - 1, -Er);
    }
    let ur = er - 1, pr = 1, yr = 0;
    for (this[Wt + ur] = Gt & 255; --ur >= 0 && (pr *= 256); )
      Gt < 0 && yr === 0 && this[Wt + ur + 1] !== 0 && (yr = 1), this[Wt + ur] = (Gt / pr >> 0) - yr & 255;
    return Wt + er;
  }, at.prototype.writeInt8 = function(Gt, Wt, er) {
    return Gt = +Gt, Wt = Wt >>> 0, er || Ht(this, Gt, Wt, 1, 127, -128), Gt < 0 && (Gt = 255 + Gt + 1), this[Wt] = Gt & 255, Wt + 1;
  }, at.prototype.writeInt16LE = function(Gt, Wt, er) {
    return Gt = +Gt, Wt = Wt >>> 0, er || Ht(this, Gt, Wt, 2, 32767, -32768), this[Wt] = Gt & 255, this[Wt + 1] = Gt >>> 8, Wt + 2;
  }, at.prototype.writeInt16BE = function(Gt, Wt, er) {
    return Gt = +Gt, Wt = Wt >>> 0, er || Ht(this, Gt, Wt, 2, 32767, -32768), this[Wt] = Gt >>> 8, this[Wt + 1] = Gt & 255, Wt + 2;
  }, at.prototype.writeInt32LE = function(Gt, Wt, er) {
    return Gt = +Gt, Wt = Wt >>> 0, er || Ht(this, Gt, Wt, 4, 2147483647, -2147483648), this[Wt] = Gt & 255, this[Wt + 1] = Gt >>> 8, this[Wt + 2] = Gt >>> 16, this[Wt + 3] = Gt >>> 24, Wt + 4;
  }, at.prototype.writeInt32BE = function(Gt, Wt, er) {
    return Gt = +Gt, Wt = Wt >>> 0, er || Ht(this, Gt, Wt, 4, 2147483647, -2147483648), Gt < 0 && (Gt = 4294967295 + Gt + 1), this[Wt] = Gt >>> 24, this[Wt + 1] = Gt >>> 16, this[Wt + 2] = Gt >>> 8, this[Wt + 3] = Gt & 255, Wt + 4;
  }, at.prototype.writeBigInt64LE = cr(function(Gt, Wt = 0) {
    return Ft(this, Gt, Wt, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), at.prototype.writeBigInt64BE = cr(function(Gt, Wt = 0) {
    return _t(this, Gt, Wt, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Nt(Xt, Gt, Wt, er, lr, ur) {
    if (Wt + er > Xt.length)
      throw new RangeError("Index out of range");
    if (Wt < 0)
      throw new RangeError("Index out of range");
  }
  function Mt(Xt, Gt, Wt, er, lr) {
    return Gt = +Gt, Wt = Wt >>> 0, lr || Nt(Xt, Gt, Wt, 4), $.write(Xt, Gt, Wt, er, 23, 4), Wt + 4;
  }
  at.prototype.writeFloatLE = function(Gt, Wt, er) {
    return Mt(this, Gt, Wt, !0, er);
  }, at.prototype.writeFloatBE = function(Gt, Wt, er) {
    return Mt(this, Gt, Wt, !1, er);
  };
  function Lt(Xt, Gt, Wt, er, lr) {
    return Gt = +Gt, Wt = Wt >>> 0, lr || Nt(Xt, Gt, Wt, 8), $.write(Xt, Gt, Wt, er, 52, 8), Wt + 8;
  }
  at.prototype.writeDoubleLE = function(Gt, Wt, er) {
    return Lt(this, Gt, Wt, !0, er);
  }, at.prototype.writeDoubleBE = function(Gt, Wt, er) {
    return Lt(this, Gt, Wt, !1, er);
  }, at.prototype.copy = function(Gt, Wt, er, lr) {
    if (!at.isBuffer(Gt))
      throw new TypeError("argument should be a Buffer");
    if (er || (er = 0), !lr && lr !== 0 && (lr = this.length), Wt >= Gt.length && (Wt = Gt.length), Wt || (Wt = 0), lr > 0 && lr < er && (lr = er), lr === er || Gt.length === 0 || this.length === 0)
      return 0;
    if (Wt < 0)
      throw new RangeError("targetStart out of bounds");
    if (er < 0 || er >= this.length)
      throw new RangeError("Index out of range");
    if (lr < 0)
      throw new RangeError("sourceEnd out of bounds");
    lr > this.length && (lr = this.length), Gt.length - Wt < lr - er && (lr = Gt.length - Wt + er);
    const ur = lr - er;
    return this === Gt && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(Wt, er, lr) : Uint8Array.prototype.set.call(
      Gt,
      this.subarray(er, lr),
      Wt
    ), ur;
  }, at.prototype.fill = function(Gt, Wt, er, lr) {
    if (typeof Gt == "string") {
      if (typeof Wt == "string" ? (lr = Wt, Wt = 0, er = this.length) : typeof er == "string" && (lr = er, er = this.length), lr !== void 0 && typeof lr != "string")
        throw new TypeError("encoding must be a string");
      if (typeof lr == "string" && !at.isEncoding(lr))
        throw new TypeError("Unknown encoding: " + lr);
      if (Gt.length === 1) {
        const pr = Gt.charCodeAt(0);
        (lr === "utf8" && pr < 128 || lr === "latin1") && (Gt = pr);
      }
    } else
      typeof Gt == "number" ? Gt = Gt & 255 : typeof Gt == "boolean" && (Gt = Number(Gt));
    if (Wt < 0 || this.length < Wt || this.length < er)
      throw new RangeError("Out of range index");
    if (er <= Wt)
      return this;
    Wt = Wt >>> 0, er = er === void 0 ? this.length : er >>> 0, Gt || (Gt = 0);
    let ur;
    if (typeof Gt == "number")
      for (ur = Wt; ur < er; ++ur)
        this[ur] = Gt;
    else {
      const pr = at.isBuffer(Gt) ? Gt : at.from(Gt, lr), yr = pr.length;
      if (yr === 0)
        throw new TypeError('The value "' + Gt + '" is invalid for argument "value"');
      for (ur = 0; ur < er - Wt; ++ur)
        this[ur + Wt] = pr[ur % yr];
    }
    return this;
  };
  const $t = {};
  function Tt(Xt, Gt, Wt) {
    $t[Xt] = class extends Wt {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: Gt.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${Xt}]`, this.stack, delete this.name;
      }
      get code() {
        return Xt;
      }
      set code(lr) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: lr,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${Xt}]: ${this.message}`;
      }
    };
  }
  Tt(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(Xt) {
      return Xt ? `${Xt} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Tt(
    "ERR_INVALID_ARG_TYPE",
    function(Xt, Gt) {
      return `The "${Xt}" argument must be of type number. Received type ${typeof Gt}`;
    },
    TypeError
  ), Tt(
    "ERR_OUT_OF_RANGE",
    function(Xt, Gt, Wt) {
      let er = `The value of "${Xt}" is out of range.`, lr = Wt;
      return Number.isInteger(Wt) && Math.abs(Wt) > 2 ** 32 ? lr = Dt(String(Wt)) : typeof Wt == "bigint" && (lr = String(Wt), (Wt > BigInt(2) ** BigInt(32) || Wt < -(BigInt(2) ** BigInt(32))) && (lr = Dt(lr)), lr += "n"), er += ` It must be ${Gt}. Received ${lr}`, er;
    },
    RangeError
  );
  function Dt(Xt) {
    let Gt = "", Wt = Xt.length;
    const er = Xt[0] === "-" ? 1 : 0;
    for (; Wt >= er + 4; Wt -= 3)
      Gt = `_${Xt.slice(Wt - 3, Wt)}${Gt}`;
    return `${Xt.slice(0, Wt)}${Gt}`;
  }
  function Ut(Xt, Gt, Wt) {
    Qt(Gt, "offset"), (Xt[Gt] === void 0 || Xt[Gt + Wt] === void 0) && qt(Gt, Xt.length - (Wt + 1));
  }
  function Vt(Xt, Gt, Wt, er, lr, ur) {
    if (Xt > Wt || Xt < Gt) {
      const pr = typeof Gt == "bigint" ? "n" : "";
      let yr;
      throw ur > 3 ? Gt === 0 || Gt === BigInt(0) ? yr = `>= 0${pr} and < 2${pr} ** ${(ur + 1) * 8}${pr}` : yr = `>= -(2${pr} ** ${(ur + 1) * 8 - 1}${pr}) and < 2 ** ${(ur + 1) * 8 - 1}${pr}` : yr = `>= ${Gt}${pr} and <= ${Wt}${pr}`, new $t.ERR_OUT_OF_RANGE("value", yr, Xt);
    }
    Ut(er, lr, ur);
  }
  function Qt(Xt, Gt) {
    if (typeof Xt != "number")
      throw new $t.ERR_INVALID_ARG_TYPE(Gt, "number", Xt);
  }
  function qt(Xt, Gt, Wt) {
    throw Math.floor(Xt) !== Xt ? (Qt(Xt, Wt), new $t.ERR_OUT_OF_RANGE(Wt || "offset", "an integer", Xt)) : Gt < 0 ? new $t.ERR_BUFFER_OUT_OF_BOUNDS() : new $t.ERR_OUT_OF_RANGE(
      Wt || "offset",
      `>= ${Wt ? 1 : 0} and <= ${Gt}`,
      Xt
    );
  }
  const Zt = /[^+/0-9A-Za-z-_]/g;
  function ar(Xt) {
    if (Xt = Xt.split("=")[0], Xt = Xt.trim().replace(Zt, ""), Xt.length < 2)
      return "";
    for (; Xt.length % 4 !== 0; )
      Xt = Xt + "=";
    return Xt;
  }
  function Jt(Xt, Gt) {
    Gt = Gt || 1 / 0;
    let Wt;
    const er = Xt.length;
    let lr = null;
    const ur = [];
    for (let pr = 0; pr < er; ++pr) {
      if (Wt = Xt.charCodeAt(pr), Wt > 55295 && Wt < 57344) {
        if (!lr) {
          if (Wt > 56319) {
            (Gt -= 3) > -1 && ur.push(239, 191, 189);
            continue;
          } else if (pr + 1 === er) {
            (Gt -= 3) > -1 && ur.push(239, 191, 189);
            continue;
          }
          lr = Wt;
          continue;
        }
        if (Wt < 56320) {
          (Gt -= 3) > -1 && ur.push(239, 191, 189), lr = Wt;
          continue;
        }
        Wt = (lr - 55296 << 10 | Wt - 56320) + 65536;
      } else
        lr && (Gt -= 3) > -1 && ur.push(239, 191, 189);
      if (lr = null, Wt < 128) {
        if ((Gt -= 1) < 0)
          break;
        ur.push(Wt);
      } else if (Wt < 2048) {
        if ((Gt -= 2) < 0)
          break;
        ur.push(
          Wt >> 6 | 192,
          Wt & 63 | 128
        );
      } else if (Wt < 65536) {
        if ((Gt -= 3) < 0)
          break;
        ur.push(
          Wt >> 12 | 224,
          Wt >> 6 & 63 | 128,
          Wt & 63 | 128
        );
      } else if (Wt < 1114112) {
        if ((Gt -= 4) < 0)
          break;
        ur.push(
          Wt >> 18 | 240,
          Wt >> 12 & 63 | 128,
          Wt >> 6 & 63 | 128,
          Wt & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return ur;
  }
  function rr(Xt) {
    const Gt = [];
    for (let Wt = 0; Wt < Xt.length; ++Wt)
      Gt.push(Xt.charCodeAt(Wt) & 255);
    return Gt;
  }
  function Yt(Xt, Gt) {
    let Wt, er, lr;
    const ur = [];
    for (let pr = 0; pr < Xt.length && !((Gt -= 2) < 0); ++pr)
      Wt = Xt.charCodeAt(pr), er = Wt >> 8, lr = Wt % 256, ur.push(lr), ur.push(er);
    return ur;
  }
  function Kt(Xt) {
    return s.toByteArray(ar(Xt));
  }
  function nr(Xt, Gt, Wt, er) {
    let lr;
    for (lr = 0; lr < er && !(lr + Wt >= Gt.length || lr >= Xt.length); ++lr)
      Gt[lr + Wt] = Xt[lr];
    return lr;
  }
  function tr(Xt, Gt) {
    return Xt instanceof Gt || Xt != null && Xt.constructor != null && Xt.constructor.name != null && Xt.constructor.name === Gt.name;
  }
  function ir(Xt) {
    return Xt !== Xt;
  }
  const sr = function() {
    const Xt = "0123456789abcdef", Gt = new Array(256);
    for (let Wt = 0; Wt < 16; ++Wt) {
      const er = Wt * 16;
      for (let lr = 0; lr < 16; ++lr)
        Gt[er + lr] = Xt[Wt] + Xt[lr];
    }
    return Gt;
  }();
  function cr(Xt) {
    return typeof BigInt > "u" ? or : Xt;
  }
  function or() {
    throw new Error("BigInt not supported");
  }
})(buffer$1);
const langs = ["en", "zh", "ja", "ko", "ar", "th", "pl", "it", "de", "es", "fr"], Lang = z.enum(langs);
z.object({
  // -----------------used in ui-----------------
  cancel: z.string(),
  close: z.string(),
  field: z.string(),
  fieldName: z.string(),
  align: z.string(),
  width: z.string(),
  opacity: z.string(),
  height: z.string(),
  rotate: z.string(),
  edit: z.string(),
  required: z.string(),
  editable: z.string(),
  plsInputName: z.string(),
  fieldMustUniq: z.string(),
  notUniq: z.string(),
  noKeyName: z.string(),
  fieldsList: z.string(),
  editField: z.string(),
  type: z.string(),
  errorOccurred: z.string(),
  errorBulkUpdateFieldName: z.string(),
  commitBulkUpdateFieldName: z.string(),
  bulkUpdateFieldName: z.string(),
  addPageAfter: z.string(),
  removePage: z.string(),
  removePageConfirm: z.string(),
  // --------------------validation-------------------
  "validation.uniqueName": z.string(),
  "validation.hexColor": z.string(),
  // -----------------used in schemas-----------------
  "schemas.color": z.string(),
  "schemas.borderWidth": z.string(),
  "schemas.borderColor": z.string(),
  "schemas.backgroundColor": z.string(),
  "schemas.textColor": z.string(),
  "schemas.bgColor": z.string(),
  "schemas.horizontal": z.string(),
  "schemas.vertical": z.string(),
  "schemas.left": z.string(),
  "schemas.center": z.string(),
  "schemas.right": z.string(),
  "schemas.top": z.string(),
  "schemas.middle": z.string(),
  "schemas.bottom": z.string(),
  "schemas.padding": z.string(),
  "schemas.text.fontName": z.string(),
  "schemas.text.size": z.string(),
  "schemas.text.spacing": z.string(),
  "schemas.text.textAlign": z.string(),
  "schemas.text.verticalAlign": z.string(),
  "schemas.text.lineHeight": z.string(),
  "schemas.text.min": z.string(),
  "schemas.text.max": z.string(),
  "schemas.text.fit": z.string(),
  "schemas.text.dynamicFontSize": z.string(),
  "schemas.text.format": z.string(),
  "schemas.mvt.typingInstructions": z.string(),
  "schemas.mvt.sampleField": z.string(),
  "schemas.mvt.variablesSampleData": z.string(),
  "schemas.barcodes.barColor": z.string(),
  "schemas.barcodes.includetext": z.string(),
  "schemas.table.alternateBackgroundColor": z.string(),
  "schemas.table.tableStyle": z.string(),
  "schemas.table.headStyle": z.string(),
  "schemas.table.bodyStyle": z.string(),
  "schemas.table.columnStyle": z.string(),
  "schemas.date.format": z.string(),
  "schemas.select.options": z.string(),
  "schemas.select.optionPlaceholder": z.string()
});
z.enum(["viewer", "form", "designer"]);
const ColorType = z.enum(["rgb", "cmyk"]).optional();
z.object({ height: z.number(), width: z.number() });
const Schema$1 = z.object({
  name: z.string(),
  type: z.string(),
  content: z.string().optional(),
  position: z.object({ x: z.number(), y: z.number() }),
  width: z.number(),
  height: z.number(),
  rotate: z.number().optional(),
  opacity: z.number().optional(),
  readOnly: z.boolean().optional(),
  required: z.boolean().optional(),
  __bodyRange: z.object({ start: z.number(), end: z.number().optional() }).optional(),
  __isSplit: z.boolean().optional()
}).passthrough(), SchemaForUIAdditionalInfo = z.object({ id: z.string() });
Schema$1.merge(SchemaForUIAdditionalInfo);
const ArrayBufferSchema = z.any().refine((a) => a instanceof ArrayBuffer), Uint8ArraySchema = z.any().refine((a) => a instanceof Uint8Array), BlankPdf = z.object({
  width: z.number(),
  height: z.number(),
  padding: z.tuple([z.number(), z.number(), z.number(), z.number()])
}), CustomPdf = z.union([z.string(), ArrayBufferSchema, Uint8ArraySchema]), BasePdf = z.union([CustomPdf, BlankPdf]);
z.array(z.record(Schema$1));
const SchemaPageArray = z.array(z.array(Schema$1)), Template = z.object({
  schemas: SchemaPageArray,
  basePdf: BasePdf,
  pdfmeVersion: z.string().optional()
}).passthrough(), Inputs = z.array(z.record(z.any())).min(1), Font = z.record(z.object({
  data: z.union([z.string(), ArrayBufferSchema, Uint8ArraySchema]),
  fallback: z.boolean().optional(),
  subset: z.boolean().optional()
})), CommonOptions = z.object({ font: Font.optional() }).passthrough(), CommonProps = z.object({
  template: Template,
  options: CommonOptions.optional(),
  plugins: z.record(z.object({ ui: z.any(), pdf: z.any(), propPanel: z.any() })).optional()
}), GeneratorOptions = CommonOptions.extend({
  colorType: ColorType,
  author: z.string().optional(),
  creationDate: z.date().optional(),
  creator: z.string().optional(),
  keywords: z.array(z.string()).optional(),
  lang: Lang.optional(),
  modificationDate: z.date().optional(),
  producer: z.string().optional(),
  subject: z.string().optional(),
  title: z.string().optional()
});
CommonProps.extend({
  inputs: Inputs,
  options: GeneratorOptions.optional()
}).strict();
const UIOptions = CommonOptions.extend({
  lang: Lang.optional(),
  labels: z.record(z.string(), z.string()).optional(),
  theme: z.record(z.string(), z.unknown()).optional(),
  icons: z.record(z.string(), z.string()).optional(),
  requiredByDefault: z.boolean().optional()
}), HTMLElementSchema = z.any().refine((a) => a instanceof HTMLElement), UIProps = CommonProps.extend({
  domContainer: HTMLElementSchema,
  options: UIOptions.optional()
}), PreviewProps = UIProps.extend({ inputs: Inputs }).strict(), DesignerProps = UIProps.extend({}).strict(), cloneDeep$1 = (a) => JSON.parse(JSON.stringify(a)), uniq = (a) => Array.from(new Set(a)), getFallbackFontName = (a) => {
  const s = "", $ = Object.entries(a).reduce((_, _e) => {
    const [tt, nt] = _e;
    return !_ && nt.fallback ? tt : _;
  }, s);
  if ($ === s)
    throw Error("[@pdfme/common] fallback flag is not found in font. true fallback flag must be only one.");
  return $;
}, getDefaultFont = () => ({
  [DEFAULT_FONT_NAME]: { data: b64toUint8Array(DEFAULT_FONT_VALUE), fallback: !0 }
}), mm2pt = (a) => parseFloat(String(a)) * MM_TO_PT_RATIO, pt2mm = (a) => a * PT_TO_MM_RATIO, pt2px = (a) => a * PT_TO_PX_RATIO, px2mm = (a) => {
  const s = 0.26458333333333;
  return parseFloat(String(a)) * s;
}, blob2Base64Pdf = (a) => new Promise((s, $) => {
  const _ = new FileReader();
  _.onloadend = () => {
    _.result.startsWith("data:application/pdf;") ? s(_.result) : $(Error("[@pdfme/common] template.basePdf must be pdf data."));
  }, _.readAsDataURL(a);
}), isHexValid = (a) => /^#(?:[A-Fa-f0-9]{3,4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/i.test(a), migrateTemplate = (a) => {
  a.schemas && Array.isArray(a.schemas) && a.schemas.length > 0 && !Array.isArray(a.schemas[0]) && (a.schemas = a.schemas.map((s) => Object.entries(s).map(([$, _]) => ({
    ..._,
    name: $
  }))));
}, getB64BasePdf = (a) => typeof a == "string" && !a.startsWith("data:application/pdf;") && typeof window < "u" ? fetch(a).then(($) => $.blob()).then(blob2Base64Pdf).catch(($) => {
  throw $;
}) : a, isBlankPdf = (a) => BlankPdf.safeParse(a).success, getByteString = (a) => buffer$1.Buffer.from(a, "base64").toString("binary"), b64toUint8Array = (a) => {
  const s = a.split(";base64,")[1] ? a.split(";base64,")[1] : a, $ = getByteString(s), _ = new Uint8Array($.length);
  for (let _e = 0; _e < $.length; _e += 1)
    _[_e] = $.charCodeAt(_e);
  return _;
}, getFontNamesInSchemas = (a) => uniq(a.map((s) => s.map(($) => $.fontName ?? "")).reduce((s, $) => s.concat($), []).filter(Boolean)), checkFont = (a) => {
  const { font: s, template: { schemas: $ } } = a, _e = Object.values(s).reduce((at, ot) => ot.fallback ? at + 1 : at, 0);
  if (_e === 0)
    throw Error(`[@pdfme/common] fallback flag is not found in font. true fallback flag must be only one.
Check this document: https://pdfme.com/docs/custom-fonts#about-font-type`);
  if (_e > 1)
    throw Error(`[@pdfme/common] ${_e} fallback flags found in font. true fallback flag must be only one.
Check this document: https://pdfme.com/docs/custom-fonts#about-font-type`);
  const tt = getFontNamesInSchemas($), nt = Object.keys(s);
  if (tt.some((at) => !nt.includes(at)))
    throw Error(`[@pdfme/common] ${tt.filter((at) => !nt.includes(at)).join()} of template.schemas is not found in font.
Check this document: https://pdfme.com/docs/custom-fonts`);
}, checkPlugins = (a) => {
  const { plugins: s, template: { schemas: $ } } = a, _ = uniq($.map((tt) => tt.map((nt) => nt.type)).flat()), _e = Object.values(s).map((tt) => tt == null ? void 0 : tt.propPanel.defaultSchema.type);
  if (_.some((tt) => !_e.includes(tt)))
    throw Error(`[@pdfme/common] ${_.filter((tt) => !_e.includes(tt)).join()} of template.schemas is not found in plugins.`);
}, checkProps = (a, s) => {
  try {
    s.parse(a);
  } catch ($) {
    if ($ instanceof z.ZodError) {
      const _e = $.issues.map((tt) => `ERROR POSITION: ${tt.path.join(".")}
ERROR MESSAGE: ${tt.message}
--------------------------`).join(`
`);
      throw Error(`[@pdfme/common] Invalid argument:
--------------------------
${_e}`);
    }
  }
  if (a && typeof a == "object" && "template" in a && "options" in a) {
    const { template: $, options: _ } = a;
    _ && _.font && checkFont({ font: _.font, template: $ });
  }
  if (a && typeof a == "object" && "template" in a && "plugins" in a) {
    const { template: $, plugins: _ } = a;
    _ && checkPlugins({ plugins: _, template: $ });
  }
}, checkInputs = (a) => checkProps(a, Inputs), checkUIOptions = (a) => checkProps(a, UIOptions), checkPreviewProps = (a) => checkProps(a, PreviewProps), checkDesignerProps = (a) => checkProps(a, DesignerProps), checkUIProps = (a) => {
  typeof a == "object" && a !== null && "template" in a && migrateTemplate(a.template), checkProps(a, UIProps);
}, checkTemplate = (a) => {
  migrateTemplate(a), checkProps(a, Template);
};
class Node {
  constructor({ width: s = 0, height: $ = 0 } = {}) {
    Object.defineProperty(this, "index", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "schema", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "children", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: []
    }), Object.defineProperty(this, "width", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "height", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "padding", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: [0, 0, 0, 0]
    }), Object.defineProperty(this, "position", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: { x: 0, y: 0 }
    }), this.width = s, this.height = $;
  }
  setIndex(s) {
    this.index = s;
  }
  setSchema(s) {
    this.schema = s;
  }
  setWidth(s) {
    this.width = s;
  }
  setHeight(s) {
    this.height = s;
  }
  setPadding(s) {
    this.padding = s;
  }
  setPosition(s) {
    this.position = s;
  }
  insertChild(s) {
    const $ = this.getChildCount();
    s.setIndex($), this.children.splice($, 0, s);
  }
  getChildCount() {
    return this.children.length;
  }
  getChild(s) {
    return this.children[s];
  }
}
function createPage(a) {
  const s = new Node({ ...a });
  return s.setPadding(a.padding), s;
}
function createNode(a) {
  const { position: s, width: $, height: _, schema: _e } = a, tt = new Node({ width: $, height: _ });
  return tt.setPosition(s), tt.setSchema(_e), tt;
}
function resortChildren(a, s) {
  a.children = a.children.sort(($, _) => {
    var nt, at;
    const _e = s.get((nt = $.schema) == null ? void 0 : nt.name), tt = s.get((at = _.schema) == null ? void 0 : at.name);
    if (_e === void 0 || tt === void 0)
      throw new Error("[@pdfme/common] order is not defined");
    return _e - tt;
  }).map(($, _) => ($.setIndex(_), $));
}
async function createOnePage(a) {
  const { basePdf: s, schemaPage: $, orderMap: _, input: _e, options: tt, _cache: nt, getDynamicHeights: at } = a, ot = createPage(s), rt = [], st = cloneDeep$1($).sort((it, ut) => it.position.y - ut.position.y), lt = /* @__PURE__ */ new Map();
  for (const it of st) {
    const { position: ut, width: ft } = it, ht = { schema: it, basePdf: s, options: tt, _cache: nt }, dt = (it.readOnly ? it.content : _e == null ? void 0 : _e[it.name]) || "", gt = await at(dt, ht), pt = gt.reduce((ct, vt) => ct + vt, 0), mt = it.height;
    pt !== mt && lt.set(ut.y + mt, pt - mt), gt.forEach((ct, vt) => {
      let At = it.position.y + gt.reduce((bt, Et, St) => St < vt ? bt + Et : bt, 0);
      for (const [bt, Et] of lt.entries())
        bt <= it.position.y && (At += Et);
      const xt = createNode({ schema: it, position: { ...ut, y: At }, width: ft, height: ct });
      rt.push(At + ct + s.padding[2]), ot.insertChild(xt);
    });
  }
  const et = Math.max(...rt, s.height - s.padding[2]);
  return ot.setHeight(et), resortChildren(ot, _), ot;
}
function breakIntoPages(a) {
  const { longPage: s, orderMap: $, basePdf: _ } = a, _e = [createPage(_)], [tt, , nt] = _.padding, at = [], ot = (lt) => _.height - nt - (lt > 0 ? tt : 0), rt = (lt, et) => {
    var ut;
    const it = lt - et * (_.height - tt - nt);
    for (; _e.length <= et; )
      _e[et] || (_e.push(createPage(_)), at.push({ page: et, value: (it - tt) * -1 }));
    return it + (((ut = at.find((ft) => ft.page === et)) == null ? void 0 : ut.value) || 0);
  }, st = s.children.sort((lt, et) => lt.position.y - et.position.y);
  for (let lt = 0; lt < st.length; lt++) {
    const { schema: et, position: it, height: ut, width: ft } = st[lt], { y: ht, x: dt } = it;
    let gt = Math.floor(ht / ot(_e.length - 1)), pt = rt(ht, gt);
    if (pt + ut > _.height - nt && (gt++, pt = rt(ht, gt)), !et)
      throw new Error("[@pdfme/common] schema is undefined");
    const mt = createNode({ schema: et, position: { x: dt, y: pt }, width: ft, height: ut });
    _e[gt].insertChild(mt);
  }
  return _e.forEach((lt) => resortChildren(lt, $)), _e;
}
function createNewTemplate(a, s) {
  const $ = {
    schemas: Array.from({ length: a.length }, () => []),
    basePdf: s
  }, _ = /* @__PURE__ */ new Map();
  return cloneDeep$1(a).forEach((_e, tt) => {
    _e.children.forEach((nt) => {
      const { schema: at } = nt;
      if (!at)
        throw new Error("[@pdfme/common] schema is undefined");
      const ot = at.name;
      _.has(ot) || _.set(ot, []), _.get(ot).push(nt);
      const rt = _e.children.filter((lt) => {
        var et;
        return ((et = lt.schema) == null ? void 0 : et.name) === ot;
      }), st = _.get(ot).length - rt.length;
      if (rt.length > 0) {
        if (!rt[0].schema)
          throw new Error("[@pdfme/common] schema is undefined");
        const lt = rt[0].schema, et = rt.reduce((ht, dt) => ht + dt.height, 0), it = rt[0].position;
        lt.__bodyRange = {
          start: Math.max(st - 1, 0),
          end: st + rt.length - 1
        }, lt.__isSplit = st > 0;
        const ut = Object.assign({}, lt, { position: it, height: et }), ft = $.schemas[tt].findIndex((ht) => ht.name === ot);
        ft !== -1 ? $.schemas[tt][ft] = ut : $.schemas[tt].push(ut);
      }
    });
  }), $;
}
const getDynamicTemplate = async (a) => {
  const { template: s } = a;
  if (!isBlankPdf(s.basePdf))
    return s;
  const $ = s.basePdf, _ = [];
  for (const _e of s.schemas) {
    const tt = new Map(_e.map((ot, rt) => [ot.name, rt])), nt = await createOnePage({ basePdf: $, schemaPage: _e, orderMap: tt, ...a }), at = breakIntoPages({ longPage: nt, basePdf: $, orderMap: tt });
    _.push(...at);
  }
  return createNewTemplate(_, s.basePdf);
}, DEFAULT_LANG = "en", DESTROYED_ERR_MSG = "[@pdfme/ui] this instance is already destroyed", SELECTABLE_CLASSNAME = "selectable", RULER_HEIGHT = 30, PAGE_GAP = 10, RIGHT_SIDEBAR_WIDTH = 400, BACKGROUND_COLOR = "rgb(74, 74, 74)";
var pdf_worker_entry = {}, pdf_worker = { exports: {} };
(function(a, s) {
  (function(_, _e) {
    a.exports = _.pdfjsWorker = _e();
  })(globalThis, () => (
    /******/
    (() => {
      var $ = [
        ,
        /* 1 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.WorkerTask = at.WorkerMessageHandler = void 0, ot(2), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138), ot(140), ot(144);
          var rt = ot(145), st = ot(150), lt = ot(151), et = ot(153), it = ot(157), ut = ot(219), ft = ot(224), ht = ot(258), dt = ot(259), gt = ot(223);
          class pt {
            constructor(At) {
              this.name = At, this.terminated = !1, this._capability = new rt.PromiseCapability();
            }
            get finished() {
              return this._capability.promise;
            }
            finish() {
              this._capability.resolve();
            }
            terminate() {
              this.terminated = !0;
            }
            ensureNotTerminated() {
              if (this.terminated)
                throw new Error("Worker task was terminated");
            }
          }
          at.WorkerTask = pt;
          class mt {
            static setup(At, xt) {
              let bt = !1;
              At.on("test", function(Et) {
                bt || (bt = !0, At.send("test", Et instanceof Uint8Array));
              }), At.on("configure", function(Et) {
                (0, rt.setVerbosityLevel)(Et.verbosity);
              }), At.on("GetDocRequest", function(Et) {
                return mt.createDocumentHandler(Et, xt);
              });
            }
            static createDocumentHandler(At, xt) {
              let bt, Et = !1, St = null;
              const Bt = /* @__PURE__ */ new Set(), Ot = (0, rt.getVerbosityLevel)(), {
                docId: Pt,
                apiVersion: wt
              } = At, Ct = "3.11.174";
              if (wt !== Ct)
                throw new Error(`The API version "${wt}" does not match the Worker version "${Ct}".`);
              const It = [];
              for (const Mt in [])
                It.push(Mt);
              if (It.length)
                throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + It.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
              const yt = Pt + "_worker";
              let Rt = new ht.MessageHandler(yt, Pt, xt);
              function kt() {
                if (Et)
                  throw new Error("Worker was terminated");
              }
              function jt(Mt) {
                Bt.add(Mt);
              }
              function Ht(Mt) {
                Mt.finish(), Bt.delete(Mt);
              }
              async function Ft(Mt) {
                await bt.ensureDoc("checkHeader"), await bt.ensureDoc("parseStartXRef"), await bt.ensureDoc("parse", [Mt]), await bt.ensureDoc("checkFirstPage", [Mt]), await bt.ensureDoc("checkLastPage", [Mt]);
                const Lt = await bt.ensureDoc("isPureXfa");
                if (Lt) {
                  const Ut = new pt("loadXfaFonts");
                  jt(Ut), await Promise.all([bt.loadXfaFonts(Rt, Ut).catch((Vt) => {
                  }).then(() => Ht(Ut)), bt.loadXfaImages()]);
                }
                const [$t, Tt] = await Promise.all([bt.ensureDoc("numPages"), bt.ensureDoc("fingerprints")]), Dt = Lt ? await bt.ensureDoc("htmlForXfa") : null;
                return {
                  numPages: $t,
                  fingerprints: Tt,
                  htmlForXfa: Dt
                };
              }
              function _t(Mt) {
                let {
                  data: Lt,
                  password: $t,
                  disableAutoFetch: Tt,
                  rangeChunkSize: Dt,
                  length: Ut,
                  docBaseUrl: Vt,
                  enableXfa: Qt,
                  evaluatorOptions: qt
                } = Mt;
                const Zt = {
                  source: null,
                  disableAutoFetch: Tt,
                  docBaseUrl: Vt,
                  docId: Pt,
                  enableXfa: Qt,
                  evaluatorOptions: qt,
                  handler: Rt,
                  length: Ut,
                  password: $t,
                  rangeChunkSize: Dt
                }, ar = new rt.PromiseCapability();
                let Jt;
                if (Lt) {
                  try {
                    Zt.source = Lt, Jt = new et.LocalPdfManager(Zt), ar.resolve(Jt);
                  } catch (ir) {
                    ar.reject(ir);
                  }
                  return ar.promise;
                }
                let rr, Yt = [];
                try {
                  rr = new dt.PDFWorkerStream(Rt);
                } catch (ir) {
                  return ar.reject(ir), ar.promise;
                }
                const Kt = rr.getFullReader();
                Kt.headersReady.then(function() {
                  if (Kt.isRangeSupported) {
                    Zt.source = rr, Zt.length = Kt.contentLength, Zt.disableAutoFetch || (Zt.disableAutoFetch = Kt.isStreamingSupported), Jt = new et.NetworkPdfManager(Zt);
                    for (const ir of Yt)
                      Jt.sendProgressiveData(ir);
                    Yt = [], ar.resolve(Jt), St = null;
                  }
                }).catch(function(ir) {
                  ar.reject(ir), St = null;
                });
                let nr = 0;
                const tr = function() {
                  const ir = (0, st.arrayBuffersToBytes)(Yt);
                  Ut && ir.length !== Ut && (0, rt.warn)("reported HTTP length is different from actual");
                  try {
                    Zt.source = ir, Jt = new et.LocalPdfManager(Zt), ar.resolve(Jt);
                  } catch (sr) {
                    ar.reject(sr);
                  }
                  Yt = [];
                };
                return new Promise(function(ir, sr) {
                  const cr = function(or) {
                    let {
                      value: Xt,
                      done: Gt
                    } = or;
                    try {
                      if (kt(), Gt) {
                        Jt || tr(), St = null;
                        return;
                      }
                      nr += Xt.byteLength, Kt.isStreamingSupported || Rt.send("DocProgress", {
                        loaded: nr,
                        total: Math.max(nr, Kt.contentLength || 0)
                      }), Jt ? Jt.sendProgressiveData(Xt) : Yt.push(Xt), Kt.read().then(cr, sr);
                    } catch (Wt) {
                      sr(Wt);
                    }
                  };
                  Kt.read().then(cr, sr);
                }).catch(function(ir) {
                  ar.reject(ir), St = null;
                }), St = function(ir) {
                  rr.cancelAllRequests(ir);
                }, ar.promise;
              }
              function Nt(Mt) {
                function Lt(Dt) {
                  kt(), Rt.send("GetDoc", {
                    pdfInfo: Dt
                  });
                }
                function $t(Dt) {
                  if (kt(), Dt instanceof rt.PasswordException) {
                    const Ut = new pt(`PasswordException: response ${Dt.code}`);
                    jt(Ut), Rt.sendWithPromise("PasswordRequest", Dt).then(function(Vt) {
                      let {
                        password: Qt
                      } = Vt;
                      Ht(Ut), bt.updatePassword(Qt), Tt();
                    }).catch(function() {
                      Ht(Ut), Rt.send("DocException", Dt);
                    });
                  } else
                    Dt instanceof rt.InvalidPDFException || Dt instanceof rt.MissingPDFException || Dt instanceof rt.UnexpectedResponseException || Dt instanceof rt.UnknownErrorException ? Rt.send("DocException", Dt) : Rt.send("DocException", new rt.UnknownErrorException(Dt.message, Dt.toString()));
                }
                function Tt() {
                  kt(), Ft(!1).then(Lt, function(Dt) {
                    if (kt(), !(Dt instanceof st.XRefParseException)) {
                      $t(Dt);
                      return;
                    }
                    bt.requestLoadedStream().then(function() {
                      kt(), Ft(!0).then(Lt, $t);
                    });
                  });
                }
                kt(), _t(Mt).then(function(Dt) {
                  if (Et)
                    throw Dt.terminate(new rt.AbortException("Worker was terminated.")), new Error("Worker was terminated");
                  bt = Dt, bt.requestLoadedStream(!0).then((Ut) => {
                    Rt.send("DataLoaded", {
                      length: Ut.bytes.byteLength
                    });
                  });
                }).then(Tt, $t);
              }
              return Rt.on("GetPage", function(Mt) {
                return bt.getPage(Mt.pageIndex).then(function(Lt) {
                  return Promise.all([bt.ensure(Lt, "rotate"), bt.ensure(Lt, "ref"), bt.ensure(Lt, "userUnit"), bt.ensure(Lt, "view")]).then(function($t) {
                    let [Tt, Dt, Ut, Vt] = $t;
                    return {
                      rotate: Tt,
                      ref: Dt,
                      userUnit: Ut,
                      view: Vt
                    };
                  });
                });
              }), Rt.on("GetPageIndex", function(Mt) {
                const Lt = lt.Ref.get(Mt.num, Mt.gen);
                return bt.ensureCatalog("getPageIndex", [Lt]);
              }), Rt.on("GetDestinations", function(Mt) {
                return bt.ensureCatalog("destinations");
              }), Rt.on("GetDestination", function(Mt) {
                return bt.ensureCatalog("getDestination", [Mt.id]);
              }), Rt.on("GetPageLabels", function(Mt) {
                return bt.ensureCatalog("pageLabels");
              }), Rt.on("GetPageLayout", function(Mt) {
                return bt.ensureCatalog("pageLayout");
              }), Rt.on("GetPageMode", function(Mt) {
                return bt.ensureCatalog("pageMode");
              }), Rt.on("GetViewerPreferences", function(Mt) {
                return bt.ensureCatalog("viewerPreferences");
              }), Rt.on("GetOpenAction", function(Mt) {
                return bt.ensureCatalog("openAction");
              }), Rt.on("GetAttachments", function(Mt) {
                return bt.ensureCatalog("attachments");
              }), Rt.on("GetDocJSActions", function(Mt) {
                return bt.ensureCatalog("jsActions");
              }), Rt.on("GetPageJSActions", function(Mt) {
                let {
                  pageIndex: Lt
                } = Mt;
                return bt.getPage(Lt).then(function($t) {
                  return bt.ensure($t, "jsActions");
                });
              }), Rt.on("GetOutline", function(Mt) {
                return bt.ensureCatalog("documentOutline");
              }), Rt.on("GetOptionalContentConfig", function(Mt) {
                return bt.ensureCatalog("optionalContentConfig");
              }), Rt.on("GetPermissions", function(Mt) {
                return bt.ensureCatalog("permissions");
              }), Rt.on("GetMetadata", function(Mt) {
                return Promise.all([bt.ensureDoc("documentInfo"), bt.ensureCatalog("metadata")]);
              }), Rt.on("GetMarkInfo", function(Mt) {
                return bt.ensureCatalog("markInfo");
              }), Rt.on("GetData", function(Mt) {
                return bt.requestLoadedStream().then(function(Lt) {
                  return Lt.bytes;
                });
              }), Rt.on("GetAnnotations", function(Mt) {
                let {
                  pageIndex: Lt,
                  intent: $t
                } = Mt;
                return bt.getPage(Lt).then(function(Tt) {
                  const Dt = new pt(`GetAnnotations: page ${Lt}`);
                  return jt(Dt), Tt.getAnnotationsData(Rt, Dt, $t).then((Ut) => (Ht(Dt), Ut), (Ut) => {
                    throw Ht(Dt), Ut;
                  });
                });
              }), Rt.on("GetFieldObjects", function(Mt) {
                return bt.ensureDoc("fieldObjects");
              }), Rt.on("HasJSActions", function(Mt) {
                return bt.ensureDoc("hasJSActions");
              }), Rt.on("GetCalculationOrderIds", function(Mt) {
                return bt.ensureDoc("calculationOrderIds");
              }), Rt.on("SaveDocument", async function(Mt) {
                let {
                  isPureXfa: Lt,
                  numPages: $t,
                  annotationStorage: Tt,
                  filename: Dt
                } = Mt;
                const Ut = [bt.requestLoadedStream(), bt.ensureCatalog("acroForm"), bt.ensureCatalog("acroFormRef"), bt.ensureDoc("startXRef"), bt.ensureDoc("xref"), bt.ensureDoc("linearization"), bt.ensureCatalog("structTreeRoot")], Vt = [], Qt = Lt ? null : (0, st.getNewAnnotationsMap)(Tt), [qt, Zt, ar, Jt, rr, Yt, Kt] = await Promise.all(Ut), nr = rr.trailer.getRaw("Root") || null;
                let tr;
                if (Qt) {
                  Kt ? await Kt.canUpdateStructTree({
                    pdfManager: bt,
                    newAnnotationsByPage: Qt
                  }) && (tr = Kt) : await gt.StructTreeRoot.canCreateStructureTree({
                    catalogRef: nr,
                    pdfManager: bt,
                    newAnnotationsByPage: Qt
                  }) && (tr = null);
                  const lr = it.AnnotationFactory.generateImages(Tt.values(), rr, bt.evaluatorOptions.isOffscreenCanvasSupported), ur = tr === void 0 ? Vt : [];
                  for (const [pr, yr] of Qt)
                    ur.push(bt.getPage(pr).then((Er) => {
                      const br = new pt(`Save (editor): page ${pr}`);
                      return Er.saveNewAnnotations(Rt, br, yr, lr).finally(function() {
                        Ht(br);
                      });
                    }));
                  tr === null ? Vt.push(Promise.all(ur).then(async (pr) => (await gt.StructTreeRoot.createStructureTree({
                    newAnnotationsByPage: Qt,
                    xref: rr,
                    catalogRef: nr,
                    pdfManager: bt,
                    newRefs: pr
                  }), pr))) : tr && Vt.push(Promise.all(ur).then(async (pr) => (await tr.updateStructureTree({
                    newAnnotationsByPage: Qt,
                    pdfManager: bt,
                    newRefs: pr
                  }), pr)));
                }
                if (Lt)
                  Vt.push(bt.serializeXfaData(Tt));
                else
                  for (let lr = 0; lr < $t; lr++)
                    Vt.push(bt.getPage(lr).then(function(ur) {
                      const pr = new pt(`Save: page ${lr}`);
                      return ur.save(Rt, pr, Tt).finally(function() {
                        Ht(pr);
                      });
                    }));
                const ir = await Promise.all(Vt);
                let sr = [], cr = null;
                if (Lt) {
                  if (cr = ir[0], !cr)
                    return qt.bytes;
                } else if (sr = ir.flat(2), sr.length === 0)
                  return qt.bytes;
                const or = ar && Zt instanceof lt.Dict && sr.some((lr) => lr.needAppearances), Xt = Zt instanceof lt.Dict && Zt.get("XFA") || null;
                let Gt = null, Wt = !1;
                if (Array.isArray(Xt)) {
                  for (let lr = 0, ur = Xt.length; lr < ur; lr += 2)
                    Xt[lr] === "datasets" && (Gt = Xt[lr + 1], Wt = !0);
                  Gt === null && (Gt = rr.getNewTemporaryRef());
                } else
                  Xt && (0, rt.warn)("Unsupported XFA type.");
                let er = /* @__PURE__ */ Object.create(null);
                if (rr.trailer) {
                  const lr = /* @__PURE__ */ Object.create(null), ur = rr.trailer.get("Info") || null;
                  ur instanceof lt.Dict && ur.forEach((pr, yr) => {
                    typeof yr == "string" && (lr[pr] = (0, rt.stringToPDFString)(yr));
                  }), er = {
                    rootRef: nr,
                    encryptRef: rr.trailer.getRaw("Encrypt") || null,
                    newRef: rr.getNewTemporaryRef(),
                    infoRef: rr.trailer.getRaw("Info") || null,
                    info: lr,
                    fileIds: rr.trailer.get("ID") || null,
                    startXRef: Yt ? Jt : rr.lastXRefStreamPos ?? Jt,
                    filename: Dt
                  };
                }
                return (0, ft.incrementalUpdate)({
                  originalData: qt.bytes,
                  xrefInfo: er,
                  newRefs: sr,
                  xref: rr,
                  hasXfa: !!Xt,
                  xfaDatasetsRef: Gt,
                  hasXfaDatasetsEntry: Wt,
                  needAppearances: or,
                  acroFormRef: ar,
                  acroForm: Zt,
                  xfaData: cr
                }).finally(() => {
                  rr.resetNewTemporaryRef();
                });
              }), Rt.on("GetOperatorList", function(Mt, Lt) {
                const $t = Mt.pageIndex;
                bt.getPage($t).then(function(Tt) {
                  const Dt = new pt(`GetOperatorList: page ${$t}`);
                  jt(Dt);
                  const Ut = Ot >= rt.VerbosityLevel.INFOS ? Date.now() : 0;
                  Tt.getOperatorList({
                    handler: Rt,
                    sink: Lt,
                    task: Dt,
                    intent: Mt.intent,
                    cacheKey: Mt.cacheKey,
                    annotationStorage: Mt.annotationStorage
                  }).then(function(Vt) {
                    Ht(Dt), Ut && (0, rt.info)(`page=${$t + 1} - getOperatorList: time=${Date.now() - Ut}ms, len=${Vt.length}`), Lt.close();
                  }, function(Vt) {
                    Ht(Dt), !Dt.terminated && Lt.error(Vt);
                  });
                });
              }), Rt.on("GetTextContent", function(Mt, Lt) {
                const {
                  pageIndex: $t,
                  includeMarkedContent: Tt,
                  disableNormalization: Dt
                } = Mt;
                bt.getPage($t).then(function(Ut) {
                  const Vt = new pt("GetTextContent: page " + $t);
                  jt(Vt);
                  const Qt = Ot >= rt.VerbosityLevel.INFOS ? Date.now() : 0;
                  Ut.extractTextContent({
                    handler: Rt,
                    task: Vt,
                    sink: Lt,
                    includeMarkedContent: Tt,
                    disableNormalization: Dt
                  }).then(function() {
                    Ht(Vt), Qt && (0, rt.info)(`page=${$t + 1} - getTextContent: time=${Date.now() - Qt}ms`), Lt.close();
                  }, function(qt) {
                    Ht(Vt), !Vt.terminated && Lt.error(qt);
                  });
                });
              }), Rt.on("GetStructTree", function(Mt) {
                return bt.getPage(Mt.pageIndex).then(function(Lt) {
                  return bt.ensure(Lt, "getStructTree");
                });
              }), Rt.on("FontFallback", function(Mt) {
                return bt.fontFallback(Mt.id, Rt);
              }), Rt.on("Cleanup", function(Mt) {
                return bt.cleanup(!0);
              }), Rt.on("Terminate", function(Mt) {
                Et = !0;
                const Lt = [];
                if (bt) {
                  bt.terminate(new rt.AbortException("Worker was terminated."));
                  const $t = bt.cleanup();
                  Lt.push($t), bt = null;
                } else
                  (0, ut.clearGlobalCaches)();
                St && St(new rt.AbortException("Worker was terminated."));
                for (const $t of Bt)
                  Lt.push($t.finished), $t.terminate();
                return Promise.all(Lt).then(function() {
                  Rt.destroy(), Rt = null;
                });
              }), Rt.on("Ready", function(Mt) {
                Nt(At), At = null;
              }), yt;
            }
            static initializeFromPort(At) {
              const xt = new ht.MessageHandler("worker", "main", At);
              mt.setup(xt, At), xt.send("ready", null);
            }
          }
          at.WorkerMessageHandler = mt;
          function ct(vt) {
            return typeof vt.postMessage == "function" && "onmessage" in vt;
          }
          typeof window > "u" && !rt.isNodeJS && typeof self < "u" && ct(self) && mt.initializeFromPort(self);
        },
        /* 2 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(4), lt = ot(69), et = ot(70), it = "WebAssembly", ut = st[it], ft = Error("e", { cause: 7 }).cause !== 7, ht = function(gt, pt) {
            var mt = {};
            mt[gt] = et(gt, pt, ft), rt({
              global: !0,
              constructor: !0,
              arity: 1,
              forced: ft
            }, mt);
          }, dt = function(gt, pt) {
            if (ut && ut[gt]) {
              var mt = {};
              mt[gt] = et(it + "." + gt, pt, ft), rt({
                target: it,
                stat: !0,
                constructor: !0,
                arity: 1,
                forced: ft
              }, mt);
            }
          };
          ht("Error", function(gt) {
            return function(mt) {
              return lt(gt, this, arguments);
            };
          }), ht("EvalError", function(gt) {
            return function(mt) {
              return lt(gt, this, arguments);
            };
          }), ht("RangeError", function(gt) {
            return function(mt) {
              return lt(gt, this, arguments);
            };
          }), ht("ReferenceError", function(gt) {
            return function(mt) {
              return lt(gt, this, arguments);
            };
          }), ht("SyntaxError", function(gt) {
            return function(mt) {
              return lt(gt, this, arguments);
            };
          }), ht("TypeError", function(gt) {
            return function(mt) {
              return lt(gt, this, arguments);
            };
          }), ht("URIError", function(gt) {
            return function(mt) {
              return lt(gt, this, arguments);
            };
          }), dt("CompileError", function(gt) {
            return function(mt) {
              return lt(gt, this, arguments);
            };
          }), dt("LinkError", function(gt) {
            return function(mt) {
              return lt(gt, this, arguments);
            };
          }), dt("RuntimeError", function(gt) {
            return function(mt) {
              return lt(gt, this, arguments);
            };
          });
        },
        /* 3 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(5).f, lt = ot(44), et = ot(48), it = ot(38), ut = ot(56), ft = ot(68);
          nt.exports = function(ht, dt) {
            var gt = ht.target, pt = ht.global, mt = ht.stat, ct, vt, At, xt, bt, Et;
            if (pt ? vt = rt : mt ? vt = rt[gt] || it(gt, {}) : vt = (rt[gt] || {}).prototype, vt)
              for (At in dt) {
                if (bt = dt[At], ht.dontCallGetSet ? (Et = st(vt, At), xt = Et && Et.value) : xt = vt[At], ct = ft(pt ? At : gt + (mt ? "." : "#") + At, ht.forced), !ct && xt !== void 0) {
                  if (typeof bt == typeof xt)
                    continue;
                  ut(bt, xt);
                }
                (ht.sham || xt && xt.sham) && lt(bt, "sham", !0), et(vt, At, bt, ht);
              }
          };
        },
        /* 4 */
        /***/
        function(nt) {
          var at = function(ot) {
            return ot && ot.Math === Math && ot;
          };
          nt.exports = at(typeof globalThis == "object" && globalThis) || at(typeof window == "object" && window) || at(typeof self == "object" && self) || at(typeof commonjsGlobal == "object" && commonjsGlobal) || /* @__PURE__ */ function() {
            return this;
          }() || this || Function("return this")();
        },
        /* 5 */
        /***/
        (nt, at, ot) => {
          var rt = ot(6), st = ot(8), lt = ot(10), et = ot(11), it = ot(12), ut = ot(18), ft = ot(39), ht = ot(42), dt = Object.getOwnPropertyDescriptor;
          at.f = rt ? dt : function(pt, mt) {
            if (pt = it(pt), mt = ut(mt), ht)
              try {
                return dt(pt, mt);
              } catch {
              }
            if (ft(pt, mt))
              return et(!st(lt.f, pt, mt), pt[mt]);
          };
        },
        /* 6 */
        /***/
        (nt, at, ot) => {
          var rt = ot(7);
          nt.exports = !rt(function() {
            return Object.defineProperty({}, 1, {
              get: function() {
                return 7;
              }
            })[1] !== 7;
          });
        },
        /* 7 */
        /***/
        (nt) => {
          nt.exports = function(at) {
            try {
              return !!at();
            } catch {
              return !0;
            }
          };
        },
        /* 8 */
        /***/
        (nt, at, ot) => {
          var rt = ot(9), st = Function.prototype.call;
          nt.exports = rt ? st.bind(st) : function() {
            return st.apply(st, arguments);
          };
        },
        /* 9 */
        /***/
        (nt, at, ot) => {
          var rt = ot(7);
          nt.exports = !rt(function() {
            var st = (function() {
            }).bind();
            return typeof st != "function" || st.hasOwnProperty("prototype");
          });
        },
        /* 10 */
        /***/
        (nt, at) => {
          var ot = {}.propertyIsEnumerable, rt = Object.getOwnPropertyDescriptor, st = rt && !ot.call({ 1: 2 }, 1);
          at.f = st ? function(et) {
            var it = rt(this, et);
            return !!it && it.enumerable;
          } : ot;
        },
        /* 11 */
        /***/
        (nt) => {
          nt.exports = function(at, ot) {
            return {
              enumerable: !(at & 1),
              configurable: !(at & 2),
              writable: !(at & 4),
              value: ot
            };
          };
        },
        /* 12 */
        /***/
        (nt, at, ot) => {
          var rt = ot(13), st = ot(16);
          nt.exports = function(lt) {
            return rt(st(lt));
          };
        },
        /* 13 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = ot(7), lt = ot(15), et = Object, it = rt("".split);
          nt.exports = st(function() {
            return !et("z").propertyIsEnumerable(0);
          }) ? function(ut) {
            return lt(ut) === "String" ? it(ut, "") : et(ut);
          } : et;
        },
        /* 14 */
        /***/
        (nt, at, ot) => {
          var rt = ot(9), st = Function.prototype, lt = st.call, et = rt && st.bind.bind(lt, lt);
          nt.exports = rt ? et : function(it) {
            return function() {
              return lt.apply(it, arguments);
            };
          };
        },
        /* 15 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = rt({}.toString), lt = rt("".slice);
          nt.exports = function(et) {
            return lt(st(et), 8, -1);
          };
        },
        /* 16 */
        /***/
        (nt, at, ot) => {
          var rt = ot(17), st = TypeError;
          nt.exports = function(lt) {
            if (rt(lt))
              throw st("Can't call method on " + lt);
            return lt;
          };
        },
        /* 17 */
        /***/
        (nt) => {
          nt.exports = function(at) {
            return at == null;
          };
        },
        /* 18 */
        /***/
        (nt, at, ot) => {
          var rt = ot(19), st = ot(23);
          nt.exports = function(lt) {
            var et = rt(lt, "string");
            return st(et) ? et : et + "";
          };
        },
        /* 19 */
        /***/
        (nt, at, ot) => {
          var rt = ot(8), st = ot(20), lt = ot(23), et = ot(30), it = ot(33), ut = ot(34), ft = TypeError, ht = ut("toPrimitive");
          nt.exports = function(dt, gt) {
            if (!st(dt) || lt(dt))
              return dt;
            var pt = et(dt, ht), mt;
            if (pt) {
              if (gt === void 0 && (gt = "default"), mt = rt(pt, dt, gt), !st(mt) || lt(mt))
                return mt;
              throw ft("Can't convert object to primitive value");
            }
            return gt === void 0 && (gt = "number"), it(dt, gt);
          };
        },
        /* 20 */
        /***/
        (nt, at, ot) => {
          var rt = ot(21), st = ot(22), lt = st.all;
          nt.exports = st.IS_HTMLDDA ? function(et) {
            return typeof et == "object" ? et !== null : rt(et) || et === lt;
          } : function(et) {
            return typeof et == "object" ? et !== null : rt(et);
          };
        },
        /* 21 */
        /***/
        (nt, at, ot) => {
          var rt = ot(22), st = rt.all;
          nt.exports = rt.IS_HTMLDDA ? function(lt) {
            return typeof lt == "function" || lt === st;
          } : function(lt) {
            return typeof lt == "function";
          };
        },
        /* 22 */
        /***/
        (nt) => {
          var at = typeof document == "object" && document.all, ot = typeof at > "u" && at !== void 0;
          nt.exports = {
            all: at,
            IS_HTMLDDA: ot
          };
        },
        /* 23 */
        /***/
        (nt, at, ot) => {
          var rt = ot(24), st = ot(21), lt = ot(25), et = ot(26), it = Object;
          nt.exports = et ? function(ut) {
            return typeof ut == "symbol";
          } : function(ut) {
            var ft = rt("Symbol");
            return st(ft) && lt(ft.prototype, it(ut));
          };
        },
        /* 24 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(21), lt = function(et) {
            return st(et) ? et : void 0;
          };
          nt.exports = function(et, it) {
            return arguments.length < 2 ? lt(rt[et]) : rt[et] && rt[et][it];
          };
        },
        /* 25 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14);
          nt.exports = rt({}.isPrototypeOf);
        },
        /* 26 */
        /***/
        (nt, at, ot) => {
          var rt = ot(27);
          nt.exports = rt && !Symbol.sham && typeof Symbol.iterator == "symbol";
        },
        /* 27 */
        /***/
        (nt, at, ot) => {
          var rt = ot(28), st = ot(7), lt = ot(4), et = lt.String;
          nt.exports = !!Object.getOwnPropertySymbols && !st(function() {
            var it = Symbol("symbol detection");
            return !et(it) || !(Object(it) instanceof Symbol) || !Symbol.sham && rt && rt < 41;
          });
        },
        /* 28 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(29), lt = rt.process, et = rt.Deno, it = lt && lt.versions || et && et.version, ut = it && it.v8, ft, ht;
          ut && (ft = ut.split("."), ht = ft[0] > 0 && ft[0] < 4 ? 1 : +(ft[0] + ft[1])), !ht && st && (ft = st.match(/Edge\/(\d+)/), (!ft || ft[1] >= 74) && (ft = st.match(/Chrome\/(\d+)/), ft && (ht = +ft[1]))), nt.exports = ht;
        },
        /* 29 */
        /***/
        (nt) => {
          nt.exports = typeof navigator < "u" && String(navigator.userAgent) || "";
        },
        /* 30 */
        /***/
        (nt, at, ot) => {
          var rt = ot(31), st = ot(17);
          nt.exports = function(lt, et) {
            var it = lt[et];
            return st(it) ? void 0 : rt(it);
          };
        },
        /* 31 */
        /***/
        (nt, at, ot) => {
          var rt = ot(21), st = ot(32), lt = TypeError;
          nt.exports = function(et) {
            if (rt(et))
              return et;
            throw lt(st(et) + " is not a function");
          };
        },
        /* 32 */
        /***/
        (nt) => {
          var at = String;
          nt.exports = function(ot) {
            try {
              return at(ot);
            } catch {
              return "Object";
            }
          };
        },
        /* 33 */
        /***/
        (nt, at, ot) => {
          var rt = ot(8), st = ot(21), lt = ot(20), et = TypeError;
          nt.exports = function(it, ut) {
            var ft, ht;
            if (ut === "string" && st(ft = it.toString) && !lt(ht = rt(ft, it)) || st(ft = it.valueOf) && !lt(ht = rt(ft, it)) || ut !== "string" && st(ft = it.toString) && !lt(ht = rt(ft, it)))
              return ht;
            throw et("Can't convert object to primitive value");
          };
        },
        /* 34 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(35), lt = ot(39), et = ot(41), it = ot(27), ut = ot(26), ft = rt.Symbol, ht = st("wks"), dt = ut ? ft.for || ft : ft && ft.withoutSetter || et;
          nt.exports = function(gt) {
            return lt(ht, gt) || (ht[gt] = it && lt(ft, gt) ? ft[gt] : dt("Symbol." + gt)), ht[gt];
          };
        },
        /* 35 */
        /***/
        (nt, at, ot) => {
          var rt = ot(36), st = ot(37);
          (nt.exports = function(lt, et) {
            return st[lt] || (st[lt] = et !== void 0 ? et : {});
          })("versions", []).push({
            version: "3.32.2",
            mode: rt ? "pure" : "global",
            copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
            license: "https://github.com/zloirock/core-js/blob/v3.32.2/LICENSE",
            source: "https://github.com/zloirock/core-js"
          });
        },
        /* 36 */
        /***/
        (nt) => {
          nt.exports = !1;
        },
        /* 37 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(38), lt = "__core-js_shared__", et = rt[lt] || st(lt, {});
          nt.exports = et;
        },
        /* 38 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = Object.defineProperty;
          nt.exports = function(lt, et) {
            try {
              st(rt, lt, {
                value: et,
                configurable: !0,
                writable: !0
              });
            } catch {
              rt[lt] = et;
            }
            return et;
          };
        },
        /* 39 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = ot(40), lt = rt({}.hasOwnProperty);
          nt.exports = Object.hasOwn || function(it, ut) {
            return lt(st(it), ut);
          };
        },
        /* 40 */
        /***/
        (nt, at, ot) => {
          var rt = ot(16), st = Object;
          nt.exports = function(lt) {
            return st(rt(lt));
          };
        },
        /* 41 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = 0, lt = Math.random(), et = rt(1 .toString);
          nt.exports = function(it) {
            return "Symbol(" + (it === void 0 ? "" : it) + ")_" + et(++st + lt, 36);
          };
        },
        /* 42 */
        /***/
        (nt, at, ot) => {
          var rt = ot(6), st = ot(7), lt = ot(43);
          nt.exports = !rt && !st(function() {
            return Object.defineProperty(lt("div"), "a", {
              get: function() {
                return 7;
              }
            }).a !== 7;
          });
        },
        /* 43 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(20), lt = rt.document, et = st(lt) && st(lt.createElement);
          nt.exports = function(it) {
            return et ? lt.createElement(it) : {};
          };
        },
        /* 44 */
        /***/
        (nt, at, ot) => {
          var rt = ot(6), st = ot(45), lt = ot(11);
          nt.exports = rt ? function(et, it, ut) {
            return st.f(et, it, lt(1, ut));
          } : function(et, it, ut) {
            return et[it] = ut, et;
          };
        },
        /* 45 */
        /***/
        (nt, at, ot) => {
          var rt = ot(6), st = ot(42), lt = ot(46), et = ot(47), it = ot(18), ut = TypeError, ft = Object.defineProperty, ht = Object.getOwnPropertyDescriptor, dt = "enumerable", gt = "configurable", pt = "writable";
          at.f = rt ? lt ? function(ct, vt, At) {
            if (et(ct), vt = it(vt), et(At), typeof ct == "function" && vt === "prototype" && "value" in At && pt in At && !At[pt]) {
              var xt = ht(ct, vt);
              xt && xt[pt] && (ct[vt] = At.value, At = {
                configurable: gt in At ? At[gt] : xt[gt],
                enumerable: dt in At ? At[dt] : xt[dt],
                writable: !1
              });
            }
            return ft(ct, vt, At);
          } : ft : function(ct, vt, At) {
            if (et(ct), vt = it(vt), et(At), st)
              try {
                return ft(ct, vt, At);
              } catch {
              }
            if ("get" in At || "set" in At)
              throw ut("Accessors not supported");
            return "value" in At && (ct[vt] = At.value), ct;
          };
        },
        /* 46 */
        /***/
        (nt, at, ot) => {
          var rt = ot(6), st = ot(7);
          nt.exports = rt && st(function() {
            return Object.defineProperty(function() {
            }, "prototype", {
              value: 42,
              writable: !1
            }).prototype !== 42;
          });
        },
        /* 47 */
        /***/
        (nt, at, ot) => {
          var rt = ot(20), st = String, lt = TypeError;
          nt.exports = function(et) {
            if (rt(et))
              return et;
            throw lt(st(et) + " is not an object");
          };
        },
        /* 48 */
        /***/
        (nt, at, ot) => {
          var rt = ot(21), st = ot(45), lt = ot(49), et = ot(38);
          nt.exports = function(it, ut, ft, ht) {
            ht || (ht = {});
            var dt = ht.enumerable, gt = ht.name !== void 0 ? ht.name : ut;
            if (rt(ft) && lt(ft, gt, ht), ht.global)
              dt ? it[ut] = ft : et(ut, ft);
            else {
              try {
                ht.unsafe ? it[ut] && (dt = !0) : delete it[ut];
              } catch {
              }
              dt ? it[ut] = ft : st.f(it, ut, {
                value: ft,
                enumerable: !1,
                configurable: !ht.nonConfigurable,
                writable: !ht.nonWritable
              });
            }
            return it;
          };
        },
        /* 49 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = ot(7), lt = ot(21), et = ot(39), it = ot(6), ut = ot(50).CONFIGURABLE, ft = ot(51), ht = ot(52), dt = ht.enforce, gt = ht.get, pt = String, mt = Object.defineProperty, ct = rt("".slice), vt = rt("".replace), At = rt([].join), xt = it && !st(function() {
            return mt(function() {
            }, "length", { value: 8 }).length !== 8;
          }), bt = String(String).split("String"), Et = nt.exports = function(St, Bt, Ot) {
            ct(pt(Bt), 0, 7) === "Symbol(" && (Bt = "[" + vt(pt(Bt), /^Symbol\(([^)]*)\)/, "$1") + "]"), Ot && Ot.getter && (Bt = "get " + Bt), Ot && Ot.setter && (Bt = "set " + Bt), (!et(St, "name") || ut && St.name !== Bt) && (it ? mt(St, "name", {
              value: Bt,
              configurable: !0
            }) : St.name = Bt), xt && Ot && et(Ot, "arity") && St.length !== Ot.arity && mt(St, "length", { value: Ot.arity });
            try {
              Ot && et(Ot, "constructor") && Ot.constructor ? it && mt(St, "prototype", { writable: !1 }) : St.prototype && (St.prototype = void 0);
            } catch {
            }
            var Pt = dt(St);
            return et(Pt, "source") || (Pt.source = At(bt, typeof Bt == "string" ? Bt : "")), St;
          };
          Function.prototype.toString = Et(function() {
            return lt(this) && gt(this).source || ft(this);
          }, "toString");
        },
        /* 50 */
        /***/
        (nt, at, ot) => {
          var rt = ot(6), st = ot(39), lt = Function.prototype, et = rt && Object.getOwnPropertyDescriptor, it = st(lt, "name"), ut = it && (function() {
          }).name === "something", ft = it && (!rt || rt && et(lt, "name").configurable);
          nt.exports = {
            EXISTS: it,
            PROPER: ut,
            CONFIGURABLE: ft
          };
        },
        /* 51 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = ot(21), lt = ot(37), et = rt(Function.toString);
          st(lt.inspectSource) || (lt.inspectSource = function(it) {
            return et(it);
          }), nt.exports = lt.inspectSource;
        },
        /* 52 */
        /***/
        (nt, at, ot) => {
          var rt = ot(53), st = ot(4), lt = ot(20), et = ot(44), it = ot(39), ut = ot(37), ft = ot(54), ht = ot(55), dt = "Object already initialized", gt = st.TypeError, pt = st.WeakMap, mt, ct, vt, At = function(St) {
            return vt(St) ? ct(St) : mt(St, {});
          }, xt = function(St) {
            return function(Bt) {
              var Ot;
              if (!lt(Bt) || (Ot = ct(Bt)).type !== St)
                throw gt("Incompatible receiver, " + St + " required");
              return Ot;
            };
          };
          if (rt || ut.state) {
            var bt = ut.state || (ut.state = new pt());
            bt.get = bt.get, bt.has = bt.has, bt.set = bt.set, mt = function(St, Bt) {
              if (bt.has(St))
                throw gt(dt);
              return Bt.facade = St, bt.set(St, Bt), Bt;
            }, ct = function(St) {
              return bt.get(St) || {};
            }, vt = function(St) {
              return bt.has(St);
            };
          } else {
            var Et = ft("state");
            ht[Et] = !0, mt = function(St, Bt) {
              if (it(St, Et))
                throw gt(dt);
              return Bt.facade = St, et(St, Et, Bt), Bt;
            }, ct = function(St) {
              return it(St, Et) ? St[Et] : {};
            }, vt = function(St) {
              return it(St, Et);
            };
          }
          nt.exports = {
            set: mt,
            get: ct,
            has: vt,
            enforce: At,
            getterFor: xt
          };
        },
        /* 53 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(21), lt = rt.WeakMap;
          nt.exports = st(lt) && /native code/.test(String(lt));
        },
        /* 54 */
        /***/
        (nt, at, ot) => {
          var rt = ot(35), st = ot(41), lt = rt("keys");
          nt.exports = function(et) {
            return lt[et] || (lt[et] = st(et));
          };
        },
        /* 55 */
        /***/
        (nt) => {
          nt.exports = {};
        },
        /* 56 */
        /***/
        (nt, at, ot) => {
          var rt = ot(39), st = ot(57), lt = ot(5), et = ot(45);
          nt.exports = function(it, ut, ft) {
            for (var ht = st(ut), dt = et.f, gt = lt.f, pt = 0; pt < ht.length; pt++) {
              var mt = ht[pt];
              !rt(it, mt) && !(ft && rt(ft, mt)) && dt(it, mt, gt(ut, mt));
            }
          };
        },
        /* 57 */
        /***/
        (nt, at, ot) => {
          var rt = ot(24), st = ot(14), lt = ot(58), et = ot(67), it = ot(47), ut = st([].concat);
          nt.exports = rt("Reflect", "ownKeys") || function(ht) {
            var dt = lt.f(it(ht)), gt = et.f;
            return gt ? ut(dt, gt(ht)) : dt;
          };
        },
        /* 58 */
        /***/
        (nt, at, ot) => {
          var rt = ot(59), st = ot(66), lt = st.concat("length", "prototype");
          at.f = Object.getOwnPropertyNames || function(it) {
            return rt(it, lt);
          };
        },
        /* 59 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = ot(39), lt = ot(12), et = ot(60).indexOf, it = ot(55), ut = rt([].push);
          nt.exports = function(ft, ht) {
            var dt = lt(ft), gt = 0, pt = [], mt;
            for (mt in dt)
              !st(it, mt) && st(dt, mt) && ut(pt, mt);
            for (; ht.length > gt; )
              st(dt, mt = ht[gt++]) && (~et(pt, mt) || ut(pt, mt));
            return pt;
          };
        },
        /* 60 */
        /***/
        (nt, at, ot) => {
          var rt = ot(12), st = ot(61), lt = ot(64), et = function(it) {
            return function(ut, ft, ht) {
              var dt = rt(ut), gt = lt(dt), pt = st(ht, gt), mt;
              if (it && ft !== ft) {
                for (; gt > pt; )
                  if (mt = dt[pt++], mt !== mt)
                    return !0;
              } else
                for (; gt > pt; pt++)
                  if ((it || pt in dt) && dt[pt] === ft)
                    return it || pt || 0;
              return !it && -1;
            };
          };
          nt.exports = {
            includes: et(!0),
            indexOf: et(!1)
          };
        },
        /* 61 */
        /***/
        (nt, at, ot) => {
          var rt = ot(62), st = Math.max, lt = Math.min;
          nt.exports = function(et, it) {
            var ut = rt(et);
            return ut < 0 ? st(ut + it, 0) : lt(ut, it);
          };
        },
        /* 62 */
        /***/
        (nt, at, ot) => {
          var rt = ot(63);
          nt.exports = function(st) {
            var lt = +st;
            return lt !== lt || lt === 0 ? 0 : rt(lt);
          };
        },
        /* 63 */
        /***/
        (nt) => {
          var at = Math.ceil, ot = Math.floor;
          nt.exports = Math.trunc || function(st) {
            var lt = +st;
            return (lt > 0 ? ot : at)(lt);
          };
        },
        /* 64 */
        /***/
        (nt, at, ot) => {
          var rt = ot(65);
          nt.exports = function(st) {
            return rt(st.length);
          };
        },
        /* 65 */
        /***/
        (nt, at, ot) => {
          var rt = ot(62), st = Math.min;
          nt.exports = function(lt) {
            return lt > 0 ? st(rt(lt), 9007199254740991) : 0;
          };
        },
        /* 66 */
        /***/
        (nt) => {
          nt.exports = [
            "constructor",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "toLocaleString",
            "toString",
            "valueOf"
          ];
        },
        /* 67 */
        /***/
        (nt, at) => {
          at.f = Object.getOwnPropertySymbols;
        },
        /* 68 */
        /***/
        (nt, at, ot) => {
          var rt = ot(7), st = ot(21), lt = /#|\.prototype\./, et = function(dt, gt) {
            var pt = ut[it(dt)];
            return pt === ht ? !0 : pt === ft ? !1 : st(gt) ? rt(gt) : !!gt;
          }, it = et.normalize = function(dt) {
            return String(dt).replace(lt, ".").toLowerCase();
          }, ut = et.data = {}, ft = et.NATIVE = "N", ht = et.POLYFILL = "P";
          nt.exports = et;
        },
        /* 69 */
        /***/
        (nt, at, ot) => {
          var rt = ot(9), st = Function.prototype, lt = st.apply, et = st.call;
          nt.exports = typeof Reflect == "object" && Reflect.apply || (rt ? et.bind(lt) : function() {
            return et.apply(lt, arguments);
          });
        },
        /* 70 */
        /***/
        (nt, at, ot) => {
          var rt = ot(24), st = ot(39), lt = ot(44), et = ot(25), it = ot(71), ut = ot(56), ft = ot(74), ht = ot(75), dt = ot(76), gt = ot(80), pt = ot(81), mt = ot(6), ct = ot(36);
          nt.exports = function(vt, At, xt, bt) {
            var Et = "stackTraceLimit", St = bt ? 2 : 1, Bt = vt.split("."), Ot = Bt[Bt.length - 1], Pt = rt.apply(null, Bt);
            if (Pt) {
              var wt = Pt.prototype;
              if (!ct && st(wt, "cause") && delete wt.cause, !xt)
                return Pt;
              var Ct = rt("Error"), It = At(function(yt, Rt) {
                var kt = dt(bt ? Rt : yt, void 0), jt = bt ? new Pt(yt) : new Pt();
                return kt !== void 0 && lt(jt, "message", kt), pt(jt, It, jt.stack, 2), this && et(wt, this) && ht(jt, this, It), arguments.length > St && gt(jt, arguments[St]), jt;
              });
              if (It.prototype = wt, Ot !== "Error" ? it ? it(It, Ct) : ut(It, Ct, { name: !0 }) : mt && Et in Pt && (ft(It, Pt, Et), ft(It, Pt, "prepareStackTrace")), ut(It, Pt), !ct)
                try {
                  wt.name !== Ot && lt(wt, "name", Ot), wt.constructor = It;
                } catch {
                }
              return It;
            }
          };
        },
        /* 71 */
        /***/
        (nt, at, ot) => {
          var rt = ot(72), st = ot(47), lt = ot(73);
          nt.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
            var et = !1, it = {}, ut;
            try {
              ut = rt(Object.prototype, "__proto__", "set"), ut(it, []), et = it instanceof Array;
            } catch {
            }
            return function(ht, dt) {
              return st(ht), lt(dt), et ? ut(ht, dt) : ht.__proto__ = dt, ht;
            };
          }() : void 0);
        },
        /* 72 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = ot(31);
          nt.exports = function(lt, et, it) {
            try {
              return rt(st(Object.getOwnPropertyDescriptor(lt, et)[it]));
            } catch {
            }
          };
        },
        /* 73 */
        /***/
        (nt, at, ot) => {
          var rt = ot(21), st = String, lt = TypeError;
          nt.exports = function(et) {
            if (typeof et == "object" || rt(et))
              return et;
            throw lt("Can't set " + st(et) + " as a prototype");
          };
        },
        /* 74 */
        /***/
        (nt, at, ot) => {
          var rt = ot(45).f;
          nt.exports = function(st, lt, et) {
            et in st || rt(st, et, {
              configurable: !0,
              get: function() {
                return lt[et];
              },
              set: function(it) {
                lt[et] = it;
              }
            });
          };
        },
        /* 75 */
        /***/
        (nt, at, ot) => {
          var rt = ot(21), st = ot(20), lt = ot(71);
          nt.exports = function(et, it, ut) {
            var ft, ht;
            return lt && rt(ft = it.constructor) && ft !== ut && st(ht = ft.prototype) && ht !== ut.prototype && lt(et, ht), et;
          };
        },
        /* 76 */
        /***/
        (nt, at, ot) => {
          var rt = ot(77);
          nt.exports = function(st, lt) {
            return st === void 0 ? arguments.length < 2 ? "" : lt : rt(st);
          };
        },
        /* 77 */
        /***/
        (nt, at, ot) => {
          var rt = ot(78), st = String;
          nt.exports = function(lt) {
            if (rt(lt) === "Symbol")
              throw TypeError("Cannot convert a Symbol value to a string");
            return st(lt);
          };
        },
        /* 78 */
        /***/
        (nt, at, ot) => {
          var rt = ot(79), st = ot(21), lt = ot(15), et = ot(34), it = et("toStringTag"), ut = Object, ft = lt(/* @__PURE__ */ function() {
            return arguments;
          }()) === "Arguments", ht = function(dt, gt) {
            try {
              return dt[gt];
            } catch {
            }
          };
          nt.exports = rt ? lt : function(dt) {
            var gt, pt, mt;
            return dt === void 0 ? "Undefined" : dt === null ? "Null" : typeof (pt = ht(gt = ut(dt), it)) == "string" ? pt : ft ? lt(gt) : (mt = lt(gt)) === "Object" && st(gt.callee) ? "Arguments" : mt;
          };
        },
        /* 79 */
        /***/
        (nt, at, ot) => {
          var rt = ot(34), st = rt("toStringTag"), lt = {};
          lt[st] = "z", nt.exports = String(lt) === "[object z]";
        },
        /* 80 */
        /***/
        (nt, at, ot) => {
          var rt = ot(20), st = ot(44);
          nt.exports = function(lt, et) {
            rt(et) && "cause" in et && st(lt, "cause", et.cause);
          };
        },
        /* 81 */
        /***/
        (nt, at, ot) => {
          var rt = ot(44), st = ot(82), lt = ot(83), et = Error.captureStackTrace;
          nt.exports = function(it, ut, ft, ht) {
            lt && (et ? et(it, ut) : rt(it, "stack", st(ft, ht)));
          };
        },
        /* 82 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = Error, lt = rt("".replace), et = function(ft) {
            return String(st(ft).stack);
          }("zxcasd"), it = /\n\s*at [^:]*:[^\n]*/, ut = it.test(et);
          nt.exports = function(ft, ht) {
            if (ut && typeof ft == "string" && !st.prepareStackTrace)
              for (; ht--; )
                ft = lt(ft, it, "");
            return ft;
          };
        },
        /* 83 */
        /***/
        (nt, at, ot) => {
          var rt = ot(7), st = ot(11);
          nt.exports = !rt(function() {
            var lt = Error("a");
            return "stack" in lt ? (Object.defineProperty(lt, "stack", st(1, 7)), lt.stack !== 7) : !0;
          });
        },
        /* 84 */
        /***/
        (nt, at, ot) => {
          var rt = ot(85), st = ot(90).findLast, lt = rt.aTypedArray, et = rt.exportTypedArrayMethod;
          et("findLast", function(ut) {
            return st(lt(this), ut, arguments.length > 1 ? arguments[1] : void 0);
          });
        },
        /* 85 */
        /***/
        (nt, at, ot) => {
          var rt = ot(86), st = ot(6), lt = ot(4), et = ot(21), it = ot(20), ut = ot(39), ft = ot(78), ht = ot(32), dt = ot(44), gt = ot(48), pt = ot(87), mt = ot(25), ct = ot(88), vt = ot(71), At = ot(34), xt = ot(41), bt = ot(52), Et = bt.enforce, St = bt.get, Bt = lt.Int8Array, Ot = Bt && Bt.prototype, Pt = lt.Uint8ClampedArray, wt = Pt && Pt.prototype, Ct = Bt && ct(Bt), It = Ot && ct(Ot), yt = Object.prototype, Rt = lt.TypeError, kt = At("toStringTag"), jt = xt("TYPED_ARRAY_TAG"), Ht = "TypedArrayConstructor", Ft = rt && !!vt && ft(lt.opera) !== "Opera", _t = !1, Nt, Mt, Lt, $t = {
            Int8Array: 1,
            Uint8Array: 1,
            Uint8ClampedArray: 1,
            Int16Array: 2,
            Uint16Array: 2,
            Int32Array: 4,
            Uint32Array: 4,
            Float32Array: 4,
            Float64Array: 8
          }, Tt = {
            BigInt64Array: 8,
            BigUint64Array: 8
          }, Dt = function(rr) {
            if (!it(rr))
              return !1;
            var Yt = ft(rr);
            return Yt === "DataView" || ut($t, Yt) || ut(Tt, Yt);
          }, Ut = function(Jt) {
            var rr = ct(Jt);
            if (it(rr)) {
              var Yt = St(rr);
              return Yt && ut(Yt, Ht) ? Yt[Ht] : Ut(rr);
            }
          }, Vt = function(Jt) {
            if (!it(Jt))
              return !1;
            var rr = ft(Jt);
            return ut($t, rr) || ut(Tt, rr);
          }, Qt = function(Jt) {
            if (Vt(Jt))
              return Jt;
            throw Rt("Target is not a typed array");
          }, qt = function(Jt) {
            if (et(Jt) && (!vt || mt(Ct, Jt)))
              return Jt;
            throw Rt(ht(Jt) + " is not a typed array constructor");
          }, Zt = function(Jt, rr, Yt, Kt) {
            if (st) {
              if (Yt)
                for (var nr in $t) {
                  var tr = lt[nr];
                  if (tr && ut(tr.prototype, Jt))
                    try {
                      delete tr.prototype[Jt];
                    } catch {
                      try {
                        tr.prototype[Jt] = rr;
                      } catch {
                      }
                    }
                }
              (!It[Jt] || Yt) && gt(It, Jt, Yt ? rr : Ft && Ot[Jt] || rr, Kt);
            }
          }, ar = function(Jt, rr, Yt) {
            var Kt, nr;
            if (st) {
              if (vt) {
                if (Yt) {
                  for (Kt in $t)
                    if (nr = lt[Kt], nr && ut(nr, Jt))
                      try {
                        delete nr[Jt];
                      } catch {
                      }
                }
                if (!Ct[Jt] || Yt)
                  try {
                    return gt(Ct, Jt, Yt ? rr : Ft && Ct[Jt] || rr);
                  } catch {
                  }
                else
                  return;
              }
              for (Kt in $t)
                nr = lt[Kt], nr && (!nr[Jt] || Yt) && gt(nr, Jt, rr);
            }
          };
          for (Nt in $t)
            Mt = lt[Nt], Lt = Mt && Mt.prototype, Lt ? Et(Lt)[Ht] = Mt : Ft = !1;
          for (Nt in Tt)
            Mt = lt[Nt], Lt = Mt && Mt.prototype, Lt && (Et(Lt)[Ht] = Mt);
          if ((!Ft || !et(Ct) || Ct === Function.prototype) && (Ct = function() {
            throw Rt("Incorrect invocation");
          }, Ft))
            for (Nt in $t)
              lt[Nt] && vt(lt[Nt], Ct);
          if ((!Ft || !It || It === yt) && (It = Ct.prototype, Ft))
            for (Nt in $t)
              lt[Nt] && vt(lt[Nt].prototype, It);
          if (Ft && ct(wt) !== It && vt(wt, It), st && !ut(It, kt)) {
            _t = !0, pt(It, kt, {
              configurable: !0,
              get: function() {
                return it(this) ? this[jt] : void 0;
              }
            });
            for (Nt in $t)
              lt[Nt] && dt(lt[Nt], jt, Nt);
          }
          nt.exports = {
            NATIVE_ARRAY_BUFFER_VIEWS: Ft,
            TYPED_ARRAY_TAG: _t && jt,
            aTypedArray: Qt,
            aTypedArrayConstructor: qt,
            exportTypedArrayMethod: Zt,
            exportTypedArrayStaticMethod: ar,
            getTypedArrayConstructor: Ut,
            isView: Dt,
            isTypedArray: Vt,
            TypedArray: Ct,
            TypedArrayPrototype: It
          };
        },
        /* 86 */
        /***/
        (nt) => {
          nt.exports = typeof ArrayBuffer < "u" && typeof DataView < "u";
        },
        /* 87 */
        /***/
        (nt, at, ot) => {
          var rt = ot(49), st = ot(45);
          nt.exports = function(lt, et, it) {
            return it.get && rt(it.get, et, { getter: !0 }), it.set && rt(it.set, et, { setter: !0 }), st.f(lt, et, it);
          };
        },
        /* 88 */
        /***/
        (nt, at, ot) => {
          var rt = ot(39), st = ot(21), lt = ot(40), et = ot(54), it = ot(89), ut = et("IE_PROTO"), ft = Object, ht = ft.prototype;
          nt.exports = it ? ft.getPrototypeOf : function(dt) {
            var gt = lt(dt);
            if (rt(gt, ut))
              return gt[ut];
            var pt = gt.constructor;
            return st(pt) && gt instanceof pt ? pt.prototype : gt instanceof ft ? ht : null;
          };
        },
        /* 89 */
        /***/
        (nt, at, ot) => {
          var rt = ot(7);
          nt.exports = !rt(function() {
            function st() {
            }
            return st.prototype.constructor = null, Object.getPrototypeOf(new st()) !== st.prototype;
          });
        },
        /* 90 */
        /***/
        (nt, at, ot) => {
          var rt = ot(91), st = ot(13), lt = ot(40), et = ot(64), it = function(ut) {
            var ft = ut === 1;
            return function(ht, dt, gt) {
              for (var pt = lt(ht), mt = st(pt), ct = rt(dt, gt), vt = et(mt), At, xt; vt-- > 0; )
                if (At = mt[vt], xt = ct(At, vt, pt), xt)
                  switch (ut) {
                    case 0:
                      return At;
                    case 1:
                      return vt;
                  }
              return ft ? -1 : void 0;
            };
          };
          nt.exports = {
            findLast: it(0),
            findLastIndex: it(1)
          };
        },
        /* 91 */
        /***/
        (nt, at, ot) => {
          var rt = ot(92), st = ot(31), lt = ot(9), et = rt(rt.bind);
          nt.exports = function(it, ut) {
            return st(it), ut === void 0 ? it : lt ? et(it, ut) : function() {
              return it.apply(ut, arguments);
            };
          };
        },
        /* 92 */
        /***/
        (nt, at, ot) => {
          var rt = ot(15), st = ot(14);
          nt.exports = function(lt) {
            if (rt(lt) === "Function")
              return st(lt);
          };
        },
        /* 93 */
        /***/
        (nt, at, ot) => {
          var rt = ot(85), st = ot(90).findLastIndex, lt = rt.aTypedArray, et = rt.exportTypedArrayMethod;
          et("findLastIndex", function(ut) {
            return st(lt(this), ut, arguments.length > 1 ? arguments[1] : void 0);
          });
        },
        /* 94 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(8), lt = ot(85), et = ot(64), it = ot(95), ut = ot(40), ft = ot(7), ht = rt.RangeError, dt = rt.Int8Array, gt = dt && dt.prototype, pt = gt && gt.set, mt = lt.aTypedArray, ct = lt.exportTypedArrayMethod, vt = !ft(function() {
            var xt = new Uint8ClampedArray(2);
            return st(pt, xt, {
              length: 1,
              0: 3
            }, 1), xt[1] !== 3;
          }), At = vt && lt.NATIVE_ARRAY_BUFFER_VIEWS && ft(function() {
            var xt = new dt(2);
            return xt.set(1), xt.set("2", 1), xt[0] !== 0 || xt[1] !== 2;
          });
          ct("set", function(bt) {
            mt(this);
            var Et = it(arguments.length > 1 ? arguments[1] : void 0, 1), St = ut(bt);
            if (vt)
              return st(pt, this, St, Et);
            var Bt = this.length, Ot = et(St), Pt = 0;
            if (Ot + Et > Bt)
              throw ht("Wrong length");
            for (; Pt < Ot; )
              this[Et + Pt] = St[Pt++];
          }, !vt || At);
        },
        /* 95 */
        /***/
        (nt, at, ot) => {
          var rt = ot(96), st = RangeError;
          nt.exports = function(lt, et) {
            var it = rt(lt);
            if (it % et)
              throw st("Wrong offset");
            return it;
          };
        },
        /* 96 */
        /***/
        (nt, at, ot) => {
          var rt = ot(62), st = RangeError;
          nt.exports = function(lt) {
            var et = rt(lt);
            if (et < 0)
              throw st("The argument can't be less than 0");
            return et;
          };
        },
        /* 97 */
        /***/
        (nt, at, ot) => {
          var rt = ot(98), st = ot(85), lt = st.aTypedArray, et = st.exportTypedArrayMethod, it = st.getTypedArrayConstructor;
          et("toReversed", function() {
            return rt(lt(this), it(this));
          });
        },
        /* 98 */
        /***/
        (nt, at, ot) => {
          var rt = ot(64);
          nt.exports = function(st, lt) {
            for (var et = rt(st), it = new lt(et), ut = 0; ut < et; ut++)
              it[ut] = st[et - ut - 1];
            return it;
          };
        },
        /* 99 */
        /***/
        (nt, at, ot) => {
          var rt = ot(85), st = ot(14), lt = ot(31), et = ot(100), it = rt.aTypedArray, ut = rt.getTypedArrayConstructor, ft = rt.exportTypedArrayMethod, ht = st(rt.TypedArrayPrototype.sort);
          ft("toSorted", function(gt) {
            gt !== void 0 && lt(gt);
            var pt = it(this), mt = et(ut(pt), pt);
            return ht(mt, gt);
          });
        },
        /* 100 */
        /***/
        (nt, at, ot) => {
          var rt = ot(64);
          nt.exports = function(st, lt) {
            for (var et = 0, it = rt(lt), ut = new st(it); it > et; )
              ut[et] = lt[et++];
            return ut;
          };
        },
        /* 101 */
        /***/
        (nt, at, ot) => {
          var rt = ot(102), st = ot(85), lt = ot(103), et = ot(62), it = ot(104), ut = st.aTypedArray, ft = st.getTypedArrayConstructor, ht = st.exportTypedArrayMethod, dt = !!function() {
            try {
              new Int8Array(1).with(2, {
                valueOf: function() {
                  throw 8;
                }
              });
            } catch (gt) {
              return gt === 8;
            }
          }();
          ht("with", function(gt, pt) {
            var mt = ut(this), ct = et(gt), vt = lt(mt) ? it(pt) : +pt;
            return rt(mt, ft(mt), ct, vt);
          }, !dt);
        },
        /* 102 */
        /***/
        (nt, at, ot) => {
          var rt = ot(64), st = ot(62), lt = RangeError;
          nt.exports = function(et, it, ut, ft) {
            var ht = rt(et), dt = st(ut), gt = dt < 0 ? ht + dt : dt;
            if (gt >= ht || gt < 0)
              throw lt("Incorrect index");
            for (var pt = new it(ht), mt = 0; mt < ht; mt++)
              pt[mt] = mt === gt ? ft : et[mt];
            return pt;
          };
        },
        /* 103 */
        /***/
        (nt, at, ot) => {
          var rt = ot(78);
          nt.exports = function(st) {
            var lt = rt(st);
            return lt === "BigInt64Array" || lt === "BigUint64Array";
          };
        },
        /* 104 */
        /***/
        (nt, at, ot) => {
          var rt = ot(19), st = TypeError;
          nt.exports = function(lt) {
            var et = rt(lt, "number");
            if (typeof et == "number")
              throw st("Can't convert number to bigint");
            return BigInt(et);
          };
        },
        /* 105 */
        /***/
        (nt, at, ot) => {
          var rt = ot(6), st = ot(87), lt = ot(106), et = ArrayBuffer.prototype;
          rt && !("detached" in et) && st(et, "detached", {
            configurable: !0,
            get: function() {
              return lt(this);
            }
          });
        },
        /* 106 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = ot(107), lt = rt(ArrayBuffer.prototype.slice);
          nt.exports = function(et) {
            if (st(et) !== 0)
              return !1;
            try {
              return lt(et, 0, 0), !1;
            } catch {
              return !0;
            }
          };
        },
        /* 107 */
        /***/
        (nt, at, ot) => {
          var rt = ot(72), st = ot(15), lt = TypeError;
          nt.exports = rt(ArrayBuffer.prototype, "byteLength", "get") || function(et) {
            if (st(et) !== "ArrayBuffer")
              throw lt("ArrayBuffer expected");
            return et.byteLength;
          };
        },
        /* 108 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(109);
          st && rt({
            target: "ArrayBuffer",
            proto: !0
          }, {
            transfer: function() {
              return st(this, arguments.length ? arguments[0] : void 0, !0);
            }
          });
        },
        /* 109 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(14), lt = ot(72), et = ot(110), it = ot(106), ut = ot(107), ft = ot(111), ht = rt.TypeError, dt = rt.structuredClone, gt = rt.ArrayBuffer, pt = rt.DataView, mt = Math.min, ct = gt.prototype, vt = pt.prototype, At = st(ct.slice), xt = lt(ct, "resizable", "get"), bt = lt(ct, "maxByteLength", "get"), Et = st(vt.getInt8), St = st(vt.setInt8);
          nt.exports = ft && function(Bt, Ot, Pt) {
            var wt = ut(Bt), Ct = Ot === void 0 ? wt : et(Ot), It = !xt || !xt(Bt);
            if (it(Bt))
              throw ht("ArrayBuffer is detached");
            var yt = dt(Bt, { transfer: [Bt] });
            if (wt === Ct && (Pt || It))
              return yt;
            if (wt >= Ct && (!Pt || It))
              return At(yt, 0, Ct);
            for (var Rt = Pt && !It && bt ? { maxByteLength: bt(yt) } : void 0, kt = new gt(Ct, Rt), jt = new pt(yt), Ht = new pt(kt), Ft = mt(Ct, wt), _t = 0; _t < Ft; _t++)
              St(Ht, _t, Et(jt, _t));
            return kt;
          };
        },
        /* 110 */
        /***/
        (nt, at, ot) => {
          var rt = ot(62), st = ot(65), lt = RangeError;
          nt.exports = function(et) {
            if (et === void 0)
              return 0;
            var it = rt(et), ut = st(it);
            if (it !== ut)
              throw lt("Wrong length or index");
            return ut;
          };
        },
        /* 111 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(7), lt = ot(28), et = ot(112), it = ot(113), ut = ot(114), ft = rt.structuredClone;
          nt.exports = !!ft && !st(function() {
            if (it && lt > 92 || ut && lt > 94 || et && lt > 97)
              return !1;
            var ht = new ArrayBuffer(8), dt = ft(ht, { transfer: [ht] });
            return ht.byteLength !== 0 || dt.byteLength !== 8;
          });
        },
        /* 112 */
        /***/
        (nt, at, ot) => {
          var rt = ot(113), st = ot(114);
          nt.exports = !rt && !st && typeof window == "object" && typeof document == "object";
        },
        /* 113 */
        /***/
        (nt) => {
          nt.exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";
        },
        /* 114 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(15);
          nt.exports = st(rt.process) === "process";
        },
        /* 115 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(109);
          st && rt({
            target: "ArrayBuffer",
            proto: !0
          }, {
            transferToFixedLength: function() {
              return st(this, arguments.length ? arguments[0] : void 0, !1);
            }
          });
        },
        /* 116 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(117), lt = ot(126);
          rt({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !lt("difference")
          }, { difference: st });
        },
        /* 117 */
        /***/
        (nt, at, ot) => {
          var rt = ot(118), st = ot(119), lt = ot(120), et = ot(123), it = ot(124), ut = ot(121), ft = ot(122), ht = st.has, dt = st.remove;
          nt.exports = function(pt) {
            var mt = rt(this), ct = it(pt), vt = lt(mt);
            return et(mt) <= ct.size ? ut(mt, function(At) {
              ct.includes(At) && dt(vt, At);
            }) : ft(ct.getIterator(), function(At) {
              ht(mt, At) && dt(vt, At);
            }), vt;
          };
        },
        /* 118 */
        /***/
        (nt, at, ot) => {
          var rt = ot(119).has;
          nt.exports = function(st) {
            return rt(st), st;
          };
        },
        /* 119 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = Set.prototype;
          nt.exports = {
            Set,
            add: rt(st.add),
            has: rt(st.has),
            remove: rt(st.delete),
            proto: st
          };
        },
        /* 120 */
        /***/
        (nt, at, ot) => {
          var rt = ot(119), st = ot(121), lt = rt.Set, et = rt.add;
          nt.exports = function(it) {
            var ut = new lt();
            return st(it, function(ft) {
              et(ut, ft);
            }), ut;
          };
        },
        /* 121 */
        /***/
        (nt, at, ot) => {
          var rt = ot(14), st = ot(122), lt = ot(119), et = lt.Set, it = lt.proto, ut = rt(it.forEach), ft = rt(it.keys), ht = ft(new et()).next;
          nt.exports = function(dt, gt, pt) {
            return pt ? st({
              iterator: ft(dt),
              next: ht
            }, gt) : ut(dt, gt);
          };
        },
        /* 122 */
        /***/
        (nt, at, ot) => {
          var rt = ot(8);
          nt.exports = function(st, lt, et) {
            for (var it = et ? st : st.iterator, ut = st.next, ft, ht; !(ft = rt(ut, it)).done; )
              if (ht = lt(ft.value), ht !== void 0)
                return ht;
          };
        },
        /* 123 */
        /***/
        (nt, at, ot) => {
          var rt = ot(72), st = ot(119);
          nt.exports = rt(st.proto, "size", "get") || function(lt) {
            return lt.size;
          };
        },
        /* 124 */
        /***/
        (nt, at, ot) => {
          var rt = ot(31), st = ot(47), lt = ot(8), et = ot(62), it = ot(125), ut = "Invalid size", ft = RangeError, ht = TypeError, dt = Math.max, gt = function(pt, mt, ct, vt) {
            this.set = pt, this.size = mt, this.has = ct, this.keys = vt;
          };
          gt.prototype = {
            getIterator: function() {
              return it(st(lt(this.keys, this.set)));
            },
            includes: function(pt) {
              return lt(this.has, this.set, pt);
            }
          }, nt.exports = function(pt) {
            st(pt);
            var mt = +pt.size;
            if (mt !== mt)
              throw ht(ut);
            var ct = et(mt);
            if (ct < 0)
              throw ft(ut);
            return new gt(pt, dt(ct, 0), rt(pt.has), rt(pt.keys));
          };
        },
        /* 125 */
        /***/
        (nt) => {
          nt.exports = function(at) {
            return {
              iterator: at,
              next: at.next,
              done: !1
            };
          };
        },
        /* 126 */
        /***/
        (nt, at, ot) => {
          var rt = ot(24), st = function(lt) {
            return {
              size: lt,
              has: function() {
                return !1;
              },
              keys: function() {
                return {
                  next: function() {
                    return { done: !0 };
                  }
                };
              }
            };
          };
          nt.exports = function(lt) {
            var et = rt("Set");
            try {
              new et()[lt](st(0));
              try {
                return new et()[lt](st(-1)), !1;
              } catch {
                return !0;
              }
            } catch {
              return !1;
            }
          };
        },
        /* 127 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(7), lt = ot(128), et = ot(126), it = !et("intersection") || st(function() {
            return Array.from((/* @__PURE__ */ new Set([
              1,
              2,
              3
            ])).intersection(/* @__PURE__ */ new Set([
              3,
              2
            ]))) !== "3,2";
          });
          rt({
            target: "Set",
            proto: !0,
            real: !0,
            forced: it
          }, { intersection: lt });
        },
        /* 128 */
        /***/
        (nt, at, ot) => {
          var rt = ot(118), st = ot(119), lt = ot(123), et = ot(124), it = ot(121), ut = ot(122), ft = st.Set, ht = st.add, dt = st.has;
          nt.exports = function(pt) {
            var mt = rt(this), ct = et(pt), vt = new ft();
            return lt(mt) > ct.size ? ut(ct.getIterator(), function(At) {
              dt(mt, At) && ht(vt, At);
            }) : it(mt, function(At) {
              ct.includes(At) && ht(vt, At);
            }), vt;
          };
        },
        /* 129 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(130), lt = ot(126);
          rt({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !lt("isDisjointFrom")
          }, { isDisjointFrom: st });
        },
        /* 130 */
        /***/
        (nt, at, ot) => {
          var rt = ot(118), st = ot(119).has, lt = ot(123), et = ot(124), it = ot(121), ut = ot(122), ft = ot(131);
          nt.exports = function(dt) {
            var gt = rt(this), pt = et(dt);
            if (lt(gt) <= pt.size)
              return it(gt, function(ct) {
                if (pt.includes(ct))
                  return !1;
              }, !0) !== !1;
            var mt = pt.getIterator();
            return ut(mt, function(ct) {
              if (st(gt, ct))
                return ft(mt, "normal", !1);
            }) !== !1;
          };
        },
        /* 131 */
        /***/
        (nt, at, ot) => {
          var rt = ot(8), st = ot(47), lt = ot(30);
          nt.exports = function(et, it, ut) {
            var ft, ht;
            st(et);
            try {
              if (ft = lt(et, "return"), !ft) {
                if (it === "throw")
                  throw ut;
                return ut;
              }
              ft = rt(ft, et);
            } catch (dt) {
              ht = !0, ft = dt;
            }
            if (it === "throw")
              throw ut;
            if (ht)
              throw ft;
            return st(ft), ut;
          };
        },
        /* 132 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(133), lt = ot(126);
          rt({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !lt("isSubsetOf")
          }, { isSubsetOf: st });
        },
        /* 133 */
        /***/
        (nt, at, ot) => {
          var rt = ot(118), st = ot(123), lt = ot(121), et = ot(124);
          nt.exports = function(ut) {
            var ft = rt(this), ht = et(ut);
            return st(ft) > ht.size ? !1 : lt(ft, function(dt) {
              if (!ht.includes(dt))
                return !1;
            }, !0) !== !1;
          };
        },
        /* 134 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(135), lt = ot(126);
          rt({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !lt("isSupersetOf")
          }, { isSupersetOf: st });
        },
        /* 135 */
        /***/
        (nt, at, ot) => {
          var rt = ot(118), st = ot(119).has, lt = ot(123), et = ot(124), it = ot(122), ut = ot(131);
          nt.exports = function(ht) {
            var dt = rt(this), gt = et(ht);
            if (lt(dt) < gt.size)
              return !1;
            var pt = gt.getIterator();
            return it(pt, function(mt) {
              if (!st(dt, mt))
                return ut(pt, "normal", !1);
            }) !== !1;
          };
        },
        /* 136 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(137), lt = ot(126);
          rt({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !lt("symmetricDifference")
          }, { symmetricDifference: st });
        },
        /* 137 */
        /***/
        (nt, at, ot) => {
          var rt = ot(118), st = ot(119), lt = ot(120), et = ot(124), it = ot(122), ut = st.add, ft = st.has, ht = st.remove;
          nt.exports = function(gt) {
            var pt = rt(this), mt = et(gt).getIterator(), ct = lt(pt);
            return it(mt, function(vt) {
              ft(pt, vt) ? ht(ct, vt) : ut(ct, vt);
            }), ct;
          };
        },
        /* 138 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(139), lt = ot(126);
          rt({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !lt("union")
          }, { union: st });
        },
        /* 139 */
        /***/
        (nt, at, ot) => {
          var rt = ot(118), st = ot(119).add, lt = ot(120), et = ot(124), it = ot(122);
          nt.exports = function(ft) {
            var ht = rt(this), dt = et(ft).getIterator(), gt = lt(ht);
            return it(dt, function(pt) {
              st(gt, pt);
            }), gt;
          };
        },
        /* 140 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(40), lt = ot(64), et = ot(141), it = ot(143), ut = ot(7), ft = ut(function() {
            return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
          }), ht = function() {
            try {
              Object.defineProperty([], "length", { writable: !1 }).push();
            } catch (gt) {
              return gt instanceof TypeError;
            }
          }, dt = ft || !ht();
          rt({
            target: "Array",
            proto: !0,
            arity: 1,
            forced: dt
          }, {
            push: function(pt) {
              var mt = st(this), ct = lt(mt), vt = arguments.length;
              it(ct + vt);
              for (var At = 0; At < vt; At++)
                mt[ct] = arguments[At], ct++;
              return et(mt, ct), ct;
            }
          });
        },
        /* 141 */
        /***/
        (nt, at, ot) => {
          var rt = ot(6), st = ot(142), lt = TypeError, et = Object.getOwnPropertyDescriptor, it = rt && !function() {
            if (this !== void 0)
              return !0;
            try {
              Object.defineProperty([], "length", { writable: !1 }).length = 1;
            } catch (ut) {
              return ut instanceof TypeError;
            }
          }();
          nt.exports = it ? function(ut, ft) {
            if (st(ut) && !et(ut, "length").writable)
              throw lt("Cannot set read only .length");
            return ut.length = ft;
          } : function(ut, ft) {
            return ut.length = ft;
          };
        },
        /* 142 */
        /***/
        (nt, at, ot) => {
          var rt = ot(15);
          nt.exports = Array.isArray || function(lt) {
            return rt(lt) === "Array";
          };
        },
        /* 143 */
        /***/
        (nt) => {
          var at = TypeError, ot = 9007199254740991;
          nt.exports = function(rt) {
            if (rt > ot)
              throw at("Maximum allowed index exceeded");
            return rt;
          };
        },
        /* 144 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(4), lt = ot(87), et = ot(6), it = TypeError, ut = Object.defineProperty, ft = st.self !== st;
          try {
            if (et) {
              var ht = Object.getOwnPropertyDescriptor(st, "self");
              (ft || !ht || !ht.get || !ht.enumerable) && lt(st, "self", {
                get: function() {
                  return st;
                },
                set: function(gt) {
                  if (this !== st)
                    throw it("Illegal invocation");
                  ut(st, "self", {
                    value: gt,
                    writable: !0,
                    configurable: !0,
                    enumerable: !0
                  });
                },
                configurable: !0,
                enumerable: !0
              });
            } else
              rt({
                global: !0,
                simple: !0,
                forced: ft
              }, { self: st });
          } catch {
          }
        },
        /* 145 */
        /***/
        (nt, at, ot) => {
          var Ir;
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.VerbosityLevel = at.Util = at.UnknownErrorException = at.UnexpectedResponseException = at.TextRenderingMode = at.RenderingIntentFlag = at.PromiseCapability = at.PermissionFlag = at.PasswordResponses = at.PasswordException = at.PageActionEventType = at.OPS = at.MissingPDFException = at.MAX_IMAGE_SIZE_TO_CACHE = at.LINE_FACTOR = at.LINE_DESCENT_FACTOR = at.InvalidPDFException = at.ImageKind = at.IDENTITY_MATRIX = at.FormatError = at.FeatureTest = at.FONT_IDENTITY_MATRIX = at.DocumentActionEventType = at.CMapCompressionType = at.BaseException = at.BASELINE_FACTOR = at.AnnotationType = at.AnnotationReplyType = at.AnnotationPrefix = at.AnnotationMode = at.AnnotationFlag = at.AnnotationFieldFlag = at.AnnotationEditorType = at.AnnotationEditorPrefix = at.AnnotationEditorParamsType = at.AnnotationBorderStyleType = at.AnnotationActionEventType = at.AbortException = void 0, at.assert = Mt, at.bytesToString = rr, at.createValidAbsoluteUrl = $t, at.getModificationDate = yr, at.getUuid = Sr, at.getVerbosityLevel = Ht, at.info = Ft, at.isArrayBuffer = ur, at.isArrayEqual = pr, at.isNodeJS = void 0, at.normalizeUnicode = Ar, at.objectFromMap = tr, at.objectSize = nr, at.setVerbosityLevel = jt, at.shadow = Tt, at.string32 = Kt, at.stringToBytes = Yt, at.stringToPDFString = Wt, at.stringToUTF8String = er, at.unreachable = Nt, at.utf8StringToString = lr, at.warn = _t, ot(2), ot(146), ot(148), ot(149), ot(140), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          const rt = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
          at.isNodeJS = rt;
          const st = [1, 0, 0, 1, 0, 0];
          at.IDENTITY_MATRIX = st;
          const lt = [1e-3, 0, 0, 1e-3, 0, 0];
          at.FONT_IDENTITY_MATRIX = lt;
          const et = 1e7;
          at.MAX_IMAGE_SIZE_TO_CACHE = et;
          const it = 1.35;
          at.LINE_FACTOR = it;
          const ut = 0.35;
          at.LINE_DESCENT_FACTOR = ut;
          const ft = ut / it;
          at.BASELINE_FACTOR = ft;
          const ht = {
            ANY: 1,
            DISPLAY: 2,
            PRINT: 4,
            SAVE: 8,
            ANNOTATIONS_FORMS: 16,
            ANNOTATIONS_STORAGE: 32,
            ANNOTATIONS_DISABLE: 64,
            OPLIST: 256
          };
          at.RenderingIntentFlag = ht;
          const dt = {
            DISABLE: 0,
            ENABLE: 1,
            ENABLE_FORMS: 2,
            ENABLE_STORAGE: 3
          };
          at.AnnotationMode = dt;
          const gt = "pdfjs_internal_editor_";
          at.AnnotationEditorPrefix = gt;
          const pt = {
            DISABLE: -1,
            NONE: 0,
            FREETEXT: 3,
            STAMP: 13,
            INK: 15
          };
          at.AnnotationEditorType = pt;
          const mt = {
            RESIZE: 1,
            CREATE: 2,
            FREETEXT_SIZE: 11,
            FREETEXT_COLOR: 12,
            FREETEXT_OPACITY: 13,
            INK_COLOR: 21,
            INK_THICKNESS: 22,
            INK_OPACITY: 23
          };
          at.AnnotationEditorParamsType = mt;
          const ct = {
            PRINT: 4,
            MODIFY_CONTENTS: 8,
            COPY: 16,
            MODIFY_ANNOTATIONS: 32,
            FILL_INTERACTIVE_FORMS: 256,
            COPY_FOR_ACCESSIBILITY: 512,
            ASSEMBLE: 1024,
            PRINT_HIGH_QUALITY: 2048
          };
          at.PermissionFlag = ct;
          const vt = {
            FILL: 0,
            STROKE: 1,
            FILL_STROKE: 2,
            INVISIBLE: 3,
            FILL_ADD_TO_PATH: 4,
            STROKE_ADD_TO_PATH: 5,
            FILL_STROKE_ADD_TO_PATH: 6,
            ADD_TO_PATH: 7,
            FILL_STROKE_MASK: 3,
            ADD_TO_PATH_FLAG: 4
          };
          at.TextRenderingMode = vt;
          const At = {
            GRAYSCALE_1BPP: 1,
            RGB_24BPP: 2,
            RGBA_32BPP: 3
          };
          at.ImageKind = At;
          const xt = {
            TEXT: 1,
            LINK: 2,
            FREETEXT: 3,
            LINE: 4,
            SQUARE: 5,
            CIRCLE: 6,
            POLYGON: 7,
            POLYLINE: 8,
            HIGHLIGHT: 9,
            UNDERLINE: 10,
            SQUIGGLY: 11,
            STRIKEOUT: 12,
            STAMP: 13,
            CARET: 14,
            INK: 15,
            POPUP: 16,
            FILEATTACHMENT: 17,
            SOUND: 18,
            MOVIE: 19,
            WIDGET: 20,
            SCREEN: 21,
            PRINTERMARK: 22,
            TRAPNET: 23,
            WATERMARK: 24,
            THREED: 25,
            REDACT: 26
          };
          at.AnnotationType = xt;
          const bt = {
            GROUP: "Group",
            REPLY: "R"
          };
          at.AnnotationReplyType = bt;
          const Et = {
            INVISIBLE: 1,
            HIDDEN: 2,
            PRINT: 4,
            NOZOOM: 8,
            NOROTATE: 16,
            NOVIEW: 32,
            READONLY: 64,
            LOCKED: 128,
            TOGGLENOVIEW: 256,
            LOCKEDCONTENTS: 512
          };
          at.AnnotationFlag = Et;
          const St = {
            READONLY: 1,
            REQUIRED: 2,
            NOEXPORT: 4,
            MULTILINE: 4096,
            PASSWORD: 8192,
            NOTOGGLETOOFF: 16384,
            RADIO: 32768,
            PUSHBUTTON: 65536,
            COMBO: 131072,
            EDIT: 262144,
            SORT: 524288,
            FILESELECT: 1048576,
            MULTISELECT: 2097152,
            DONOTSPELLCHECK: 4194304,
            DONOTSCROLL: 8388608,
            COMB: 16777216,
            RICHTEXT: 33554432,
            RADIOSINUNISON: 33554432,
            COMMITONSELCHANGE: 67108864
          };
          at.AnnotationFieldFlag = St;
          const Bt = {
            SOLID: 1,
            DASHED: 2,
            BEVELED: 3,
            INSET: 4,
            UNDERLINE: 5
          };
          at.AnnotationBorderStyleType = Bt;
          const Ot = {
            E: "Mouse Enter",
            X: "Mouse Exit",
            D: "Mouse Down",
            U: "Mouse Up",
            Fo: "Focus",
            Bl: "Blur",
            PO: "PageOpen",
            PC: "PageClose",
            PV: "PageVisible",
            PI: "PageInvisible",
            K: "Keystroke",
            F: "Format",
            V: "Validate",
            C: "Calculate"
          };
          at.AnnotationActionEventType = Ot;
          const Pt = {
            WC: "WillClose",
            WS: "WillSave",
            DS: "DidSave",
            WP: "WillPrint",
            DP: "DidPrint"
          };
          at.DocumentActionEventType = Pt;
          const wt = {
            O: "PageOpen",
            C: "PageClose"
          };
          at.PageActionEventType = wt;
          const Ct = {
            ERRORS: 0,
            WARNINGS: 1,
            INFOS: 5
          };
          at.VerbosityLevel = Ct;
          const It = {
            NONE: 0,
            BINARY: 1
          };
          at.CMapCompressionType = It;
          const yt = {
            dependency: 1,
            setLineWidth: 2,
            setLineCap: 3,
            setLineJoin: 4,
            setMiterLimit: 5,
            setDash: 6,
            setRenderingIntent: 7,
            setFlatness: 8,
            setGState: 9,
            save: 10,
            restore: 11,
            transform: 12,
            moveTo: 13,
            lineTo: 14,
            curveTo: 15,
            curveTo2: 16,
            curveTo3: 17,
            closePath: 18,
            rectangle: 19,
            stroke: 20,
            closeStroke: 21,
            fill: 22,
            eoFill: 23,
            fillStroke: 24,
            eoFillStroke: 25,
            closeFillStroke: 26,
            closeEOFillStroke: 27,
            endPath: 28,
            clip: 29,
            eoClip: 30,
            beginText: 31,
            endText: 32,
            setCharSpacing: 33,
            setWordSpacing: 34,
            setHScale: 35,
            setLeading: 36,
            setFont: 37,
            setTextRenderingMode: 38,
            setTextRise: 39,
            moveText: 40,
            setLeadingMoveText: 41,
            setTextMatrix: 42,
            nextLine: 43,
            showText: 44,
            showSpacedText: 45,
            nextLineShowText: 46,
            nextLineSetSpacingShowText: 47,
            setCharWidth: 48,
            setCharWidthAndBounds: 49,
            setStrokeColorSpace: 50,
            setFillColorSpace: 51,
            setStrokeColor: 52,
            setStrokeColorN: 53,
            setFillColor: 54,
            setFillColorN: 55,
            setStrokeGray: 56,
            setFillGray: 57,
            setStrokeRGBColor: 58,
            setFillRGBColor: 59,
            setStrokeCMYKColor: 60,
            setFillCMYKColor: 61,
            shadingFill: 62,
            beginInlineImage: 63,
            beginImageData: 64,
            endInlineImage: 65,
            paintXObject: 66,
            markPoint: 67,
            markPointProps: 68,
            beginMarkedContent: 69,
            beginMarkedContentProps: 70,
            endMarkedContent: 71,
            beginCompat: 72,
            endCompat: 73,
            paintFormXObjectBegin: 74,
            paintFormXObjectEnd: 75,
            beginGroup: 76,
            endGroup: 77,
            beginAnnotation: 80,
            endAnnotation: 81,
            paintImageMaskXObject: 83,
            paintImageMaskXObjectGroup: 84,
            paintImageXObject: 85,
            paintInlineImageXObject: 86,
            paintInlineImageXObjectGroup: 87,
            paintImageXObjectRepeat: 88,
            paintImageMaskXObjectRepeat: 89,
            paintSolidColorImageMask: 90,
            constructPath: 91
          };
          at.OPS = yt;
          const Rt = {
            NEED_PASSWORD: 1,
            INCORRECT_PASSWORD: 2
          };
          at.PasswordResponses = Rt;
          let kt = Ct.WARNINGS;
          function jt(hr) {
            Number.isInteger(hr) && (kt = hr);
          }
          function Ht() {
            return kt;
          }
          function Ft(hr) {
            kt >= Ct.INFOS && console.log(`Info: ${hr}`);
          }
          function _t(hr) {
            kt >= Ct.WARNINGS && console.log(`Warning: ${hr}`);
          }
          function Nt(hr) {
            throw new Error(hr);
          }
          function Mt(hr, vr) {
            hr || Nt(vr);
          }
          function Lt(hr) {
            switch (hr == null ? void 0 : hr.protocol) {
              case "http:":
              case "https:":
              case "ftp:":
              case "mailto:":
              case "tel:":
                return !0;
              default:
                return !1;
            }
          }
          function $t(hr) {
            let vr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, xr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            if (!hr)
              return null;
            try {
              if (xr && typeof hr == "string") {
                if (xr.addDefaultProtocol && hr.startsWith("www.")) {
                  const Rr = hr.match(/\./g);
                  (Rr == null ? void 0 : Rr.length) >= 2 && (hr = `http://${hr}`);
                }
                if (xr.tryConvertEncoding)
                  try {
                    hr = er(hr);
                  } catch {
                  }
              }
              const Pr = vr ? new URL(hr, vr) : new URL(hr);
              if (Lt(Pr))
                return Pr;
            } catch {
            }
            return null;
          }
          function Tt(hr, vr, xr) {
            let Pr = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
            return Object.defineProperty(hr, vr, {
              value: xr,
              enumerable: !Pr,
              configurable: !0,
              writable: !1
            }), xr;
          }
          const Dt = function() {
            function vr(xr, Pr) {
              this.constructor === vr && Nt("Cannot initialize BaseException."), this.message = xr, this.name = Pr;
            }
            return vr.prototype = new Error(), vr.constructor = vr, vr;
          }();
          at.BaseException = Dt;
          class Ut extends Dt {
            constructor(vr, xr) {
              super(vr, "PasswordException"), this.code = xr;
            }
          }
          at.PasswordException = Ut;
          class Vt extends Dt {
            constructor(vr, xr) {
              super(vr, "UnknownErrorException"), this.details = xr;
            }
          }
          at.UnknownErrorException = Vt;
          class Qt extends Dt {
            constructor(vr) {
              super(vr, "InvalidPDFException");
            }
          }
          at.InvalidPDFException = Qt;
          class qt extends Dt {
            constructor(vr) {
              super(vr, "MissingPDFException");
            }
          }
          at.MissingPDFException = qt;
          class Zt extends Dt {
            constructor(vr, xr) {
              super(vr, "UnexpectedResponseException"), this.status = xr;
            }
          }
          at.UnexpectedResponseException = Zt;
          class ar extends Dt {
            constructor(vr) {
              super(vr, "FormatError");
            }
          }
          at.FormatError = ar;
          class Jt extends Dt {
            constructor(vr) {
              super(vr, "AbortException");
            }
          }
          at.AbortException = Jt;
          function rr(hr) {
            (typeof hr != "object" || (hr == null ? void 0 : hr.length) === void 0) && Nt("Invalid argument for bytesToString");
            const vr = hr.length, xr = 8192;
            if (vr < xr)
              return String.fromCharCode.apply(null, hr);
            const Pr = [];
            for (let Rr = 0; Rr < vr; Rr += xr) {
              const Dr = Math.min(Rr + xr, vr), Gr = hr.subarray(Rr, Dr);
              Pr.push(String.fromCharCode.apply(null, Gr));
            }
            return Pr.join("");
          }
          function Yt(hr) {
            typeof hr != "string" && Nt("Invalid argument for stringToBytes");
            const vr = hr.length, xr = new Uint8Array(vr);
            for (let Pr = 0; Pr < vr; ++Pr)
              xr[Pr] = hr.charCodeAt(Pr) & 255;
            return xr;
          }
          function Kt(hr) {
            return String.fromCharCode(hr >> 24 & 255, hr >> 16 & 255, hr >> 8 & 255, hr & 255);
          }
          function nr(hr) {
            return Object.keys(hr).length;
          }
          function tr(hr) {
            const vr = /* @__PURE__ */ Object.create(null);
            for (const [xr, Pr] of hr)
              vr[xr] = Pr;
            return vr;
          }
          function ir() {
            const hr = new Uint8Array(4);
            return hr[0] = 1, new Uint32Array(hr.buffer, 0, 1)[0] === 1;
          }
          function sr() {
            try {
              return new Function(""), !0;
            } catch {
              return !1;
            }
          }
          class cr {
            static get isLittleEndian() {
              return Tt(this, "isLittleEndian", ir());
            }
            static get isEvalSupported() {
              return Tt(this, "isEvalSupported", sr());
            }
            static get isOffscreenCanvasSupported() {
              return Tt(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
            }
            static get platform() {
              return typeof navigator > "u" ? Tt(this, "platform", {
                isWin: !1,
                isMac: !1
              }) : Tt(this, "platform", {
                isWin: navigator.platform.includes("Win"),
                isMac: navigator.platform.includes("Mac")
              });
            }
            static get isCSSRoundSupported() {
              var vr, xr;
              return Tt(this, "isCSSRoundSupported", (xr = (vr = globalThis.CSS) == null ? void 0 : vr.supports) == null ? void 0 : xr.call(vr, "width: round(1.5px, 1px)"));
            }
          }
          at.FeatureTest = cr;
          const or = [...Array(256).keys()].map((hr) => hr.toString(16).padStart(2, "0"));
          class Xt {
            static makeHexColor(vr, xr, Pr) {
              return `#${or[vr]}${or[xr]}${or[Pr]}`;
            }
            static scaleMinMax(vr, xr) {
              let Pr;
              vr[0] ? (vr[0] < 0 && (Pr = xr[0], xr[0] = xr[1], xr[1] = Pr), xr[0] *= vr[0], xr[1] *= vr[0], vr[3] < 0 && (Pr = xr[2], xr[2] = xr[3], xr[3] = Pr), xr[2] *= vr[3], xr[3] *= vr[3]) : (Pr = xr[0], xr[0] = xr[2], xr[2] = Pr, Pr = xr[1], xr[1] = xr[3], xr[3] = Pr, vr[1] < 0 && (Pr = xr[2], xr[2] = xr[3], xr[3] = Pr), xr[2] *= vr[1], xr[3] *= vr[1], vr[2] < 0 && (Pr = xr[0], xr[0] = xr[1], xr[1] = Pr), xr[0] *= vr[2], xr[1] *= vr[2]), xr[0] += vr[4], xr[1] += vr[4], xr[2] += vr[5], xr[3] += vr[5];
            }
            static transform(vr, xr) {
              return [vr[0] * xr[0] + vr[2] * xr[1], vr[1] * xr[0] + vr[3] * xr[1], vr[0] * xr[2] + vr[2] * xr[3], vr[1] * xr[2] + vr[3] * xr[3], vr[0] * xr[4] + vr[2] * xr[5] + vr[4], vr[1] * xr[4] + vr[3] * xr[5] + vr[5]];
            }
            static applyTransform(vr, xr) {
              const Pr = vr[0] * xr[0] + vr[1] * xr[2] + xr[4], Rr = vr[0] * xr[1] + vr[1] * xr[3] + xr[5];
              return [Pr, Rr];
            }
            static applyInverseTransform(vr, xr) {
              const Pr = xr[0] * xr[3] - xr[1] * xr[2], Rr = (vr[0] * xr[3] - vr[1] * xr[2] + xr[2] * xr[5] - xr[4] * xr[3]) / Pr, Dr = (-vr[0] * xr[1] + vr[1] * xr[0] + xr[4] * xr[1] - xr[5] * xr[0]) / Pr;
              return [Rr, Dr];
            }
            static getAxialAlignedBoundingBox(vr, xr) {
              const Pr = this.applyTransform(vr, xr), Rr = this.applyTransform(vr.slice(2, 4), xr), Dr = this.applyTransform([vr[0], vr[3]], xr), Gr = this.applyTransform([vr[2], vr[1]], xr);
              return [Math.min(Pr[0], Rr[0], Dr[0], Gr[0]), Math.min(Pr[1], Rr[1], Dr[1], Gr[1]), Math.max(Pr[0], Rr[0], Dr[0], Gr[0]), Math.max(Pr[1], Rr[1], Dr[1], Gr[1])];
            }
            static inverseTransform(vr) {
              const xr = vr[0] * vr[3] - vr[1] * vr[2];
              return [vr[3] / xr, -vr[1] / xr, -vr[2] / xr, vr[0] / xr, (vr[2] * vr[5] - vr[4] * vr[3]) / xr, (vr[4] * vr[1] - vr[5] * vr[0]) / xr];
            }
            static singularValueDecompose2dScale(vr) {
              const xr = [vr[0], vr[2], vr[1], vr[3]], Pr = vr[0] * xr[0] + vr[1] * xr[2], Rr = vr[0] * xr[1] + vr[1] * xr[3], Dr = vr[2] * xr[0] + vr[3] * xr[2], Gr = vr[2] * xr[1] + vr[3] * xr[3], Or = (Pr + Gr) / 2, Hr = Math.sqrt((Pr + Gr) ** 2 - 4 * (Pr * Gr - Dr * Rr)) / 2, jr = Or + Hr || 1, Tr = Or - Hr || 1;
              return [Math.sqrt(jr), Math.sqrt(Tr)];
            }
            static normalizeRect(vr) {
              const xr = vr.slice(0);
              return vr[0] > vr[2] && (xr[0] = vr[2], xr[2] = vr[0]), vr[1] > vr[3] && (xr[1] = vr[3], xr[3] = vr[1]), xr;
            }
            static intersect(vr, xr) {
              const Pr = Math.max(Math.min(vr[0], vr[2]), Math.min(xr[0], xr[2])), Rr = Math.min(Math.max(vr[0], vr[2]), Math.max(xr[0], xr[2]));
              if (Pr > Rr)
                return null;
              const Dr = Math.max(Math.min(vr[1], vr[3]), Math.min(xr[1], xr[3])), Gr = Math.min(Math.max(vr[1], vr[3]), Math.max(xr[1], xr[3]));
              return Dr > Gr ? null : [Pr, Dr, Rr, Gr];
            }
            static bezierBoundingBox(vr, xr, Pr, Rr, Dr, Gr, Or, Hr) {
              const jr = [], Tr = [[], []];
              let fr, Cr, $r, wr, Mr, Fr, Qr, Yr;
              for (let zr = 0; zr < 2; ++zr) {
                if (zr === 0 ? (Cr = 6 * vr - 12 * Pr + 6 * Dr, fr = -3 * vr + 9 * Pr - 9 * Dr + 3 * Or, $r = 3 * Pr - 3 * vr) : (Cr = 6 * xr - 12 * Rr + 6 * Gr, fr = -3 * xr + 9 * Rr - 9 * Gr + 3 * Hr, $r = 3 * Rr - 3 * xr), Math.abs(fr) < 1e-12) {
                  if (Math.abs(Cr) < 1e-12)
                    continue;
                  wr = -$r / Cr, 0 < wr && wr < 1 && jr.push(wr);
                  continue;
                }
                Qr = Cr * Cr - 4 * $r * fr, Yr = Math.sqrt(Qr), !(Qr < 0) && (Mr = (-Cr + Yr) / (2 * fr), 0 < Mr && Mr < 1 && jr.push(Mr), Fr = (-Cr - Yr) / (2 * fr), 0 < Fr && Fr < 1 && jr.push(Fr));
              }
              let kr = jr.length, Nr;
              const Lr = kr;
              for (; kr--; )
                wr = jr[kr], Nr = 1 - wr, Tr[0][kr] = Nr * Nr * Nr * vr + 3 * Nr * Nr * wr * Pr + 3 * Nr * wr * wr * Dr + wr * wr * wr * Or, Tr[1][kr] = Nr * Nr * Nr * xr + 3 * Nr * Nr * wr * Rr + 3 * Nr * wr * wr * Gr + wr * wr * wr * Hr;
              return Tr[0][Lr] = vr, Tr[1][Lr] = xr, Tr[0][Lr + 1] = Or, Tr[1][Lr + 1] = Hr, Tr[0].length = Tr[1].length = Lr + 2, [Math.min(...Tr[0]), Math.min(...Tr[1]), Math.max(...Tr[0]), Math.max(...Tr[1])];
            }
          }
          at.Util = Xt;
          const Gt = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
          function Wt(hr) {
            if (hr[0] >= "ï") {
              let xr;
              if (hr[0] === "þ" && hr[1] === "ÿ" ? xr = "utf-16be" : hr[0] === "ÿ" && hr[1] === "þ" ? xr = "utf-16le" : hr[0] === "ï" && hr[1] === "»" && hr[2] === "¿" && (xr = "utf-8"), xr)
                try {
                  const Pr = new TextDecoder(xr, {
                    fatal: !0
                  }), Rr = Yt(hr);
                  return Pr.decode(Rr);
                } catch (Pr) {
                  _t(`stringToPDFString: "${Pr}".`);
                }
            }
            const vr = [];
            for (let xr = 0, Pr = hr.length; xr < Pr; xr++) {
              const Rr = Gt[hr.charCodeAt(xr)];
              vr.push(Rr ? String.fromCharCode(Rr) : hr.charAt(xr));
            }
            return vr.join("");
          }
          function er(hr) {
            return decodeURIComponent(escape(hr));
          }
          function lr(hr) {
            return unescape(encodeURIComponent(hr));
          }
          function ur(hr) {
            return typeof hr == "object" && (hr == null ? void 0 : hr.byteLength) !== void 0;
          }
          function pr(hr, vr) {
            if (hr.length !== vr.length)
              return !1;
            for (let xr = 0, Pr = hr.length; xr < Pr; xr++)
              if (hr[xr] !== vr[xr])
                return !1;
            return !0;
          }
          function yr() {
            let hr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Date();
            return [hr.getUTCFullYear().toString(), (hr.getUTCMonth() + 1).toString().padStart(2, "0"), hr.getUTCDate().toString().padStart(2, "0"), hr.getUTCHours().toString().padStart(2, "0"), hr.getUTCMinutes().toString().padStart(2, "0"), hr.getUTCSeconds().toString().padStart(2, "0")].join("");
          }
          class Er {
            constructor() {
              _r(this, Ir, !1);
              this.promise = new Promise((vr, xr) => {
                this.resolve = (Pr) => {
                  tn(this, Ir, !0), vr(Pr);
                }, this.reject = (Pr) => {
                  tn(this, Ir, !0), xr(Pr);
                };
              });
            }
            get settled() {
              return mr(this, Ir);
            }
          }
          Ir = new WeakMap(), at.PromiseCapability = Er;
          let br = null, gr = null;
          function Ar(hr) {
            return br || (br = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, gr = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), hr.replaceAll(br, (vr, xr, Pr) => xr ? xr.normalize("NFKC") : gr.get(Pr));
          }
          function Sr() {
            if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.randomUUID) == "function")
              return crypto.randomUUID();
            const hr = new Uint8Array(32);
            if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.getRandomValues) == "function")
              crypto.getRandomValues(hr);
            else
              for (let vr = 0; vr < 32; vr++)
                hr[vr] = Math.floor(Math.random() * 255);
            return rr(hr);
          }
          const Br = "pdfjs_internal_id_";
          at.AnnotationPrefix = Br;
        },
        /* 146 */
        /***/
        (nt, at, ot) => {
          var rt = ot(48), st = ot(14), lt = ot(77), et = ot(147), it = URLSearchParams, ut = it.prototype, ft = st(ut.append), ht = st(ut.delete), dt = st(ut.forEach), gt = st([].push), pt = new it("a=1&a=2&b=3");
          pt.delete("a", 1), pt.delete("b", void 0), pt + "" != "a=2" && rt(ut, "delete", function(mt) {
            var ct = arguments.length, vt = ct < 2 ? void 0 : arguments[1];
            if (ct && vt === void 0)
              return ht(this, mt);
            var At = [];
            dt(this, function(wt, Ct) {
              gt(At, {
                key: Ct,
                value: wt
              });
            }), et(ct, 1);
            for (var xt = lt(mt), bt = lt(vt), Et = 0, St = 0, Bt = !1, Ot = At.length, Pt; Et < Ot; )
              Pt = At[Et++], Bt || Pt.key === xt ? (Bt = !0, ht(this, Pt.key)) : St++;
            for (; St < Ot; )
              Pt = At[St++], Pt.key === xt && Pt.value === bt || ft(this, Pt.key, Pt.value);
          }, {
            enumerable: !0,
            unsafe: !0
          });
        },
        /* 147 */
        /***/
        (nt) => {
          var at = TypeError;
          nt.exports = function(ot, rt) {
            if (ot < rt)
              throw at("Not enough arguments");
            return ot;
          };
        },
        /* 148 */
        /***/
        (nt, at, ot) => {
          var rt = ot(48), st = ot(14), lt = ot(77), et = ot(147), it = URLSearchParams, ut = it.prototype, ft = st(ut.getAll), ht = st(ut.has), dt = new it("a=1");
          (dt.has("a", 2) || !dt.has("a", void 0)) && rt(ut, "has", function(pt) {
            var mt = arguments.length, ct = mt < 2 ? void 0 : arguments[1];
            if (mt && ct === void 0)
              return ht(this, pt);
            var vt = ft(this, pt);
            et(mt, 1);
            for (var At = lt(ct), xt = 0; xt < vt.length; )
              if (vt[xt++] === At)
                return !0;
            return !1;
          }, {
            enumerable: !0,
            unsafe: !0
          });
        },
        /* 149 */
        /***/
        (nt, at, ot) => {
          var rt = ot(6), st = ot(14), lt = ot(87), et = URLSearchParams.prototype, it = st(et.forEach);
          rt && !("size" in et) && lt(et, "size", {
            get: function() {
              var ft = 0;
              return it(this, function() {
                ft++;
              }), ft;
            },
            configurable: !0,
            enumerable: !0
          });
        },
        /* 150 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.XRefParseException = at.XRefEntryException = at.ParserEOFException = at.PDF_VERSION_REGEXP = at.MissingDataException = void 0, at.arrayBuffersToBytes = gt, at.collectActions = wt, at.encodeToXmlString = It, at.escapePDFName = Bt, at.escapeString = Ot, at.getInheritableProperty = pt, at.getLookupTableFactory = it, at.getNewAnnotationsMap = Ht, at.getRotationMatrix = Mt, at.isAscii = Ft, at.isWhiteSpace = Et, at.log2 = vt, at.numberToString = jt, at.parseXFAPath = St, at.readInt8 = At, at.readUint16 = xt, at.readUint32 = bt, at.recoverJsURL = kt, at.stringToUTF16HexString = _t, at.stringToUTF16String = Nt, at.toRomanNumerals = ct, at.validateCSSFont = Rt, at.validateFontName = yt, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(140), ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138), ot(2);
          var rt = ot(145), st = ot(151), lt = ot(152);
          const et = /^[1-9]\.\d$/;
          at.PDF_VERSION_REGEXP = et;
          function it(Lt) {
            let $t;
            return function() {
              return Lt && ($t = /* @__PURE__ */ Object.create(null), Lt($t), Lt = null), $t;
            };
          }
          class ut extends rt.BaseException {
            constructor($t, Tt) {
              super(`Missing data [${$t}, ${Tt})`, "MissingDataException"), this.begin = $t, this.end = Tt;
            }
          }
          at.MissingDataException = ut;
          class ft extends rt.BaseException {
            constructor($t) {
              super($t, "ParserEOFException");
            }
          }
          at.ParserEOFException = ft;
          class ht extends rt.BaseException {
            constructor($t) {
              super($t, "XRefEntryException");
            }
          }
          at.XRefEntryException = ht;
          class dt extends rt.BaseException {
            constructor($t) {
              super($t, "XRefParseException");
            }
          }
          at.XRefParseException = dt;
          function gt(Lt) {
            const $t = Lt.length;
            if ($t === 0)
              return new Uint8Array(0);
            if ($t === 1)
              return new Uint8Array(Lt[0]);
            let Tt = 0;
            for (let Vt = 0; Vt < $t; Vt++)
              Tt += Lt[Vt].byteLength;
            const Dt = new Uint8Array(Tt);
            let Ut = 0;
            for (let Vt = 0; Vt < $t; Vt++) {
              const Qt = new Uint8Array(Lt[Vt]);
              Dt.set(Qt, Ut), Ut += Qt.byteLength;
            }
            return Dt;
          }
          function pt(Lt) {
            let {
              dict: $t,
              key: Tt,
              getArray: Dt = !1,
              stopWhenFound: Ut = !0
            } = Lt, Vt;
            const Qt = new st.RefSet();
            for (; $t instanceof st.Dict && !($t.objId && Qt.has($t.objId)); ) {
              $t.objId && Qt.put($t.objId);
              const qt = Dt ? $t.getArray(Tt) : $t.get(Tt);
              if (qt !== void 0) {
                if (Ut)
                  return qt;
                (Vt || (Vt = [])).push(qt);
              }
              $t = $t.get("Parent");
            }
            return Vt;
          }
          const mt = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
          function ct(Lt) {
            let $t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            (0, rt.assert)(Number.isInteger(Lt) && Lt > 0, "The number should be a positive integer.");
            const Tt = [];
            let Dt;
            for (; Lt >= 1e3; )
              Lt -= 1e3, Tt.push("M");
            Dt = Lt / 100 | 0, Lt %= 100, Tt.push(mt[Dt]), Dt = Lt / 10 | 0, Lt %= 10, Tt.push(mt[10 + Dt]), Tt.push(mt[20 + Lt]);
            const Ut = Tt.join("");
            return $t ? Ut.toLowerCase() : Ut;
          }
          function vt(Lt) {
            return Lt <= 0 ? 0 : Math.ceil(Math.log2(Lt));
          }
          function At(Lt, $t) {
            return Lt[$t] << 24 >> 24;
          }
          function xt(Lt, $t) {
            return Lt[$t] << 8 | Lt[$t + 1];
          }
          function bt(Lt, $t) {
            return (Lt[$t] << 24 | Lt[$t + 1] << 16 | Lt[$t + 2] << 8 | Lt[$t + 3]) >>> 0;
          }
          function Et(Lt) {
            return Lt === 32 || Lt === 9 || Lt === 13 || Lt === 10;
          }
          function St(Lt) {
            const $t = /(.+)\[(\d+)\]$/;
            return Lt.split(".").map((Tt) => {
              const Dt = Tt.match($t);
              return Dt ? {
                name: Dt[1],
                pos: parseInt(Dt[2], 10)
              } : {
                name: Tt,
                pos: 0
              };
            });
          }
          function Bt(Lt) {
            const $t = [];
            let Tt = 0;
            for (let Dt = 0, Ut = Lt.length; Dt < Ut; Dt++) {
              const Vt = Lt.charCodeAt(Dt);
              (Vt < 33 || Vt > 126 || Vt === 35 || Vt === 40 || Vt === 41 || Vt === 60 || Vt === 62 || Vt === 91 || Vt === 93 || Vt === 123 || Vt === 125 || Vt === 47 || Vt === 37) && (Tt < Dt && $t.push(Lt.substring(Tt, Dt)), $t.push(`#${Vt.toString(16)}`), Tt = Dt + 1);
            }
            return $t.length === 0 ? Lt : (Tt < Lt.length && $t.push(Lt.substring(Tt, Lt.length)), $t.join(""));
          }
          function Ot(Lt) {
            return Lt.replaceAll(/([()\\\n\r])/g, ($t) => $t === `
` ? "\\n" : $t === "\r" ? "\\r" : `\\${$t}`);
          }
          function Pt(Lt, $t, Tt, Dt) {
            if (!Lt)
              return;
            let Ut = null;
            if (Lt instanceof st.Ref) {
              if (Dt.has(Lt))
                return;
              Ut = Lt, Dt.put(Ut), Lt = $t.fetch(Lt);
            }
            if (Array.isArray(Lt))
              for (const Vt of Lt)
                Pt(Vt, $t, Tt, Dt);
            else if (Lt instanceof st.Dict) {
              if ((0, st.isName)(Lt.get("S"), "JavaScript")) {
                const Vt = Lt.get("JS");
                let Qt;
                Vt instanceof lt.BaseStream ? Qt = Vt.getString() : typeof Vt == "string" && (Qt = Vt), Qt && (Qt = (0, rt.stringToPDFString)(Qt).replaceAll("\0", "")), Qt && Tt.push(Qt);
              }
              Pt(Lt.getRaw("Next"), $t, Tt, Dt);
            }
            Ut && Dt.remove(Ut);
          }
          function wt(Lt, $t, Tt) {
            const Dt = /* @__PURE__ */ Object.create(null), Ut = pt({
              dict: $t,
              key: "AA",
              stopWhenFound: !1
            });
            if (Ut)
              for (let Vt = Ut.length - 1; Vt >= 0; Vt--) {
                const Qt = Ut[Vt];
                if (Qt instanceof st.Dict)
                  for (const qt of Qt.getKeys()) {
                    const Zt = Tt[qt];
                    if (!Zt)
                      continue;
                    const ar = Qt.getRaw(qt), Jt = new st.RefSet(), rr = [];
                    Pt(ar, Lt, rr, Jt), rr.length > 0 && (Dt[Zt] = rr);
                  }
              }
            if ($t.has("A")) {
              const Vt = $t.get("A"), Qt = new st.RefSet(), qt = [];
              Pt(Vt, Lt, qt, Qt), qt.length > 0 && (Dt.Action = qt);
            }
            return (0, rt.objectSize)(Dt) > 0 ? Dt : null;
          }
          const Ct = {
            60: "&lt;",
            62: "&gt;",
            38: "&amp;",
            34: "&quot;",
            39: "&apos;"
          };
          function It(Lt) {
            const $t = [];
            let Tt = 0;
            for (let Dt = 0, Ut = Lt.length; Dt < Ut; Dt++) {
              const Vt = Lt.codePointAt(Dt);
              if (32 <= Vt && Vt <= 126) {
                const Qt = Ct[Vt];
                Qt && (Tt < Dt && $t.push(Lt.substring(Tt, Dt)), $t.push(Qt), Tt = Dt + 1);
              } else
                Tt < Dt && $t.push(Lt.substring(Tt, Dt)), $t.push(`&#x${Vt.toString(16).toUpperCase()};`), Vt > 55295 && (Vt < 57344 || Vt > 65533) && Dt++, Tt = Dt + 1;
            }
            return $t.length === 0 ? Lt : (Tt < Lt.length && $t.push(Lt.substring(Tt, Lt.length)), $t.join(""));
          }
          function yt(Lt) {
            let $t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            const Tt = /^("|').*("|')$/.exec(Lt);
            if (Tt && Tt[1] === Tt[2]) {
              if (new RegExp(`[^\\\\]${Tt[1]}`).test(Lt.slice(1, -1)))
                return $t && (0, rt.warn)(`FontFamily contains unescaped ${Tt[1]}: ${Lt}.`), !1;
            } else
              for (const Dt of Lt.split(/[ \t]+/))
                if (/^(\d|(-(\d|-)))/.test(Dt) || !/^[\w-\\]+$/.test(Dt))
                  return $t && (0, rt.warn)(`FontFamily contains invalid <custom-ident>: ${Lt}.`), !1;
            return !0;
          }
          function Rt(Lt) {
            const $t = "14", Tt = "400", Dt = /* @__PURE__ */ new Set(["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "normal", "bold", "bolder", "lighter"]), {
              fontFamily: Ut,
              fontWeight: Vt,
              italicAngle: Qt
            } = Lt;
            if (!yt(Ut, !0))
              return !1;
            const qt = Vt ? Vt.toString() : "";
            Lt.fontWeight = Dt.has(qt) ? qt : Tt;
            const Zt = parseFloat(Qt);
            return Lt.italicAngle = isNaN(Zt) || Zt < -90 || Zt > 90 ? $t : Qt.toString(), !0;
          }
          function kt(Lt) {
            const $t = ["app.launchURL", "window.open", "xfa.host.gotoURL"], Dt = new RegExp("^\\s*(" + $t.join("|").replaceAll(".", "\\.") + `)\\((?:'|")([^'"]*)(?:'|")(?:,\\s*(\\w+)\\)|\\))`, "i").exec(Lt);
            if (Dt != null && Dt[2]) {
              const Ut = Dt[2];
              let Vt = !1;
              return Dt[3] === "true" && Dt[1] === "app.launchURL" && (Vt = !0), {
                url: Ut,
                newWindow: Vt
              };
            }
            return null;
          }
          function jt(Lt) {
            if (Number.isInteger(Lt))
              return Lt.toString();
            const $t = Math.round(Lt * 100);
            return $t % 100 === 0 ? ($t / 100).toString() : $t % 10 === 0 ? Lt.toFixed(1) : Lt.toFixed(2);
          }
          function Ht(Lt) {
            if (!Lt)
              return null;
            const $t = /* @__PURE__ */ new Map();
            for (const [Tt, Dt] of Lt) {
              if (!Tt.startsWith(rt.AnnotationEditorPrefix))
                continue;
              let Ut = $t.get(Dt.pageIndex);
              Ut || (Ut = [], $t.set(Dt.pageIndex, Ut)), Ut.push(Dt);
            }
            return $t.size > 0 ? $t : null;
          }
          function Ft(Lt) {
            return /^[\x00-\x7F]*$/.test(Lt);
          }
          function _t(Lt) {
            const $t = [];
            for (let Tt = 0, Dt = Lt.length; Tt < Dt; Tt++) {
              const Ut = Lt.charCodeAt(Tt);
              $t.push((Ut >> 8 & 255).toString(16).padStart(2, "0"), (Ut & 255).toString(16).padStart(2, "0"));
            }
            return $t.join("");
          }
          function Nt(Lt) {
            let $t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            const Tt = [];
            $t && Tt.push("þÿ");
            for (let Dt = 0, Ut = Lt.length; Dt < Ut; Dt++) {
              const Vt = Lt.charCodeAt(Dt);
              Tt.push(String.fromCharCode(Vt >> 8 & 255), String.fromCharCode(Vt & 255));
            }
            return Tt.join("");
          }
          function Mt(Lt, $t, Tt) {
            switch (Lt) {
              case 90:
                return [0, 1, -1, 0, $t, 0];
              case 180:
                return [-1, 0, 0, -1, $t, Tt];
              case 270:
                return [0, -1, 1, 0, 0, Tt];
              default:
                throw new Error("Invalid rotation");
            }
          }
        },
        /* 151 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.RefSetCache = at.RefSet = at.Ref = at.Name = at.EOF = at.Dict = at.Cmd = at.CIRCULAR_REF = void 0, at.clearPrimitiveCaches = ft, at.isCmd = xt, at.isDict = bt, at.isName = At, at.isRefsEqual = Et, ot(140), ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138);
          var rt = ot(145);
          const st = Symbol("CIRCULAR_REF");
          at.CIRCULAR_REF = st;
          const lt = Symbol("EOF");
          at.EOF = lt;
          let et = /* @__PURE__ */ Object.create(null), it = /* @__PURE__ */ Object.create(null), ut = /* @__PURE__ */ Object.create(null);
          function ft() {
            et = /* @__PURE__ */ Object.create(null), it = /* @__PURE__ */ Object.create(null), ut = /* @__PURE__ */ Object.create(null);
          }
          class ht {
            constructor(Bt) {
              this.name = Bt;
            }
            static get(Bt) {
              return it[Bt] || (it[Bt] = new ht(Bt));
            }
          }
          at.Name = ht;
          class dt {
            constructor(Bt) {
              this.cmd = Bt;
            }
            static get(Bt) {
              return et[Bt] || (et[Bt] = new dt(Bt));
            }
          }
          at.Cmd = dt;
          const gt = function() {
            return gt;
          };
          class pt {
            constructor() {
              let Bt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              this._map = /* @__PURE__ */ Object.create(null), this.xref = Bt, this.objId = null, this.suppressEncryption = !1, this.__nonSerializable__ = gt;
            }
            assignXref(Bt) {
              this.xref = Bt;
            }
            get size() {
              return Object.keys(this._map).length;
            }
            get(Bt, Ot, Pt) {
              let wt = this._map[Bt];
              return wt === void 0 && Ot !== void 0 && (wt = this._map[Ot], wt === void 0 && Pt !== void 0 && (wt = this._map[Pt])), wt instanceof mt && this.xref ? this.xref.fetch(wt, this.suppressEncryption) : wt;
            }
            async getAsync(Bt, Ot, Pt) {
              let wt = this._map[Bt];
              return wt === void 0 && Ot !== void 0 && (wt = this._map[Ot], wt === void 0 && Pt !== void 0 && (wt = this._map[Pt])), wt instanceof mt && this.xref ? this.xref.fetchAsync(wt, this.suppressEncryption) : wt;
            }
            getArray(Bt, Ot, Pt) {
              let wt = this._map[Bt];
              if (wt === void 0 && Ot !== void 0 && (wt = this._map[Ot], wt === void 0 && Pt !== void 0 && (wt = this._map[Pt])), wt instanceof mt && this.xref && (wt = this.xref.fetch(wt, this.suppressEncryption)), Array.isArray(wt)) {
                wt = wt.slice();
                for (let Ct = 0, It = wt.length; Ct < It; Ct++)
                  wt[Ct] instanceof mt && this.xref && (wt[Ct] = this.xref.fetch(wt[Ct], this.suppressEncryption));
              }
              return wt;
            }
            getRaw(Bt) {
              return this._map[Bt];
            }
            getKeys() {
              return Object.keys(this._map);
            }
            getRawValues() {
              return Object.values(this._map);
            }
            set(Bt, Ot) {
              this._map[Bt] = Ot;
            }
            has(Bt) {
              return this._map[Bt] !== void 0;
            }
            forEach(Bt) {
              for (const Ot in this._map)
                Bt(Ot, this.get(Ot));
            }
            static get empty() {
              const Bt = new pt(null);
              return Bt.set = (Ot, Pt) => {
                (0, rt.unreachable)("Should not call `set` on the empty dictionary.");
              }, (0, rt.shadow)(this, "empty", Bt);
            }
            static merge(Bt) {
              let {
                xref: Ot,
                dictArray: Pt,
                mergeSubDicts: wt = !1
              } = Bt;
              const Ct = new pt(Ot), It = /* @__PURE__ */ new Map();
              for (const yt of Pt)
                if (yt instanceof pt)
                  for (const [Rt, kt] of Object.entries(yt._map)) {
                    let jt = It.get(Rt);
                    if (jt === void 0)
                      jt = [], It.set(Rt, jt);
                    else if (!wt || !(kt instanceof pt))
                      continue;
                    jt.push(kt);
                  }
              for (const [yt, Rt] of It) {
                if (Rt.length === 1 || !(Rt[0] instanceof pt)) {
                  Ct._map[yt] = Rt[0];
                  continue;
                }
                const kt = new pt(Ot);
                for (const jt of Rt)
                  for (const [Ht, Ft] of Object.entries(jt._map))
                    kt._map[Ht] === void 0 && (kt._map[Ht] = Ft);
                kt.size > 0 && (Ct._map[yt] = kt);
              }
              return It.clear(), Ct.size > 0 ? Ct : pt.empty;
            }
            clone() {
              const Bt = new pt(this.xref);
              for (const Ot of this.getKeys())
                Bt.set(Ot, this.getRaw(Ot));
              return Bt;
            }
          }
          at.Dict = pt;
          class mt {
            constructor(Bt, Ot) {
              this.num = Bt, this.gen = Ot;
            }
            toString() {
              return this.gen === 0 ? `${this.num}R` : `${this.num}R${this.gen}`;
            }
            static fromString(Bt) {
              const Ot = ut[Bt];
              if (Ot)
                return Ot;
              const Pt = /^(\d+)R(\d*)$/.exec(Bt);
              return !Pt || Pt[1] === "0" ? null : ut[Bt] = new mt(parseInt(Pt[1]), Pt[2] ? parseInt(Pt[2]) : 0);
            }
            static get(Bt, Ot) {
              const Pt = Ot === 0 ? `${Bt}R` : `${Bt}R${Ot}`;
              return ut[Pt] || (ut[Pt] = new mt(Bt, Ot));
            }
          }
          at.Ref = mt;
          class ct {
            constructor() {
              let Bt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              this._set = new Set(Bt == null ? void 0 : Bt._set);
            }
            has(Bt) {
              return this._set.has(Bt.toString());
            }
            put(Bt) {
              this._set.add(Bt.toString());
            }
            remove(Bt) {
              this._set.delete(Bt.toString());
            }
            [Symbol.iterator]() {
              return this._set.values();
            }
            clear() {
              this._set.clear();
            }
          }
          at.RefSet = ct;
          class vt {
            constructor() {
              this._map = /* @__PURE__ */ new Map();
            }
            get size() {
              return this._map.size;
            }
            get(Bt) {
              return this._map.get(Bt.toString());
            }
            has(Bt) {
              return this._map.has(Bt.toString());
            }
            put(Bt, Ot) {
              this._map.set(Bt.toString(), Ot);
            }
            putAlias(Bt, Ot) {
              this._map.set(Bt.toString(), this.get(Ot));
            }
            [Symbol.iterator]() {
              return this._map.values();
            }
            clear() {
              this._map.clear();
            }
          }
          at.RefSetCache = vt;
          function At(St, Bt) {
            return St instanceof ht && (Bt === void 0 || St.name === Bt);
          }
          function xt(St, Bt) {
            return St instanceof dt && (Bt === void 0 || St.cmd === Bt);
          }
          function bt(St, Bt) {
            return St instanceof pt && (Bt === void 0 || At(St.get("Type"), Bt));
          }
          function Et(St, Bt) {
            return St.num === Bt.num && St.gen === Bt.gen;
          }
        },
        /* 152 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.BaseStream = void 0;
          var rt = ot(145);
          class st {
            constructor() {
              this.constructor === st && (0, rt.unreachable)("Cannot initialize BaseStream.");
            }
            get length() {
              (0, rt.unreachable)("Abstract getter `length` accessed");
            }
            get isEmpty() {
              (0, rt.unreachable)("Abstract getter `isEmpty` accessed");
            }
            get isDataLoaded() {
              return (0, rt.shadow)(this, "isDataLoaded", !0);
            }
            getByte() {
              (0, rt.unreachable)("Abstract method `getByte` called");
            }
            getBytes(et) {
              (0, rt.unreachable)("Abstract method `getBytes` called");
            }
            peekByte() {
              const et = this.getByte();
              return et !== -1 && this.pos--, et;
            }
            peekBytes(et) {
              const it = this.getBytes(et);
              return this.pos -= it.length, it;
            }
            getUint16() {
              const et = this.getByte(), it = this.getByte();
              return et === -1 || it === -1 ? -1 : (et << 8) + it;
            }
            getInt32() {
              const et = this.getByte(), it = this.getByte(), ut = this.getByte(), ft = this.getByte();
              return (et << 24) + (it << 16) + (ut << 8) + ft;
            }
            getByteRange(et, it) {
              (0, rt.unreachable)("Abstract method `getByteRange` called");
            }
            getString(et) {
              return (0, rt.bytesToString)(this.getBytes(et));
            }
            skip(et) {
              this.pos += et || 1;
            }
            reset() {
              (0, rt.unreachable)("Abstract method `reset` called");
            }
            moveStart() {
              (0, rt.unreachable)("Abstract method `moveStart` called");
            }
            makeSubStream(et, it) {
              (0, rt.unreachable)("Abstract method `makeSubStream` called");
            }
            getBaseStreams() {
              return null;
            }
          }
          at.BaseStream = st;
        },
        /* 153 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.NetworkPdfManager = at.LocalPdfManager = void 0;
          var rt = ot(145), st = ot(154), lt = ot(150), et = ot(156), it = ot(155);
          function ut(gt) {
            if (gt) {
              const pt = (0, rt.createValidAbsoluteUrl)(gt);
              if (pt)
                return pt.href;
              (0, rt.warn)(`Invalid absolute docBaseUrl: "${gt}".`);
            }
            return null;
          }
          class ft {
            constructor(pt) {
              var mt;
              this.constructor === ft && (0, rt.unreachable)("Cannot initialize BasePdfManager."), this._docBaseUrl = ut(pt.docBaseUrl), this._docId = pt.docId, this._password = pt.password, this.enableXfa = pt.enableXfa, (mt = pt.evaluatorOptions).isOffscreenCanvasSupported && (mt.isOffscreenCanvasSupported = rt.FeatureTest.isOffscreenCanvasSupported), this.evaluatorOptions = pt.evaluatorOptions;
            }
            get docId() {
              return this._docId;
            }
            get password() {
              return this._password;
            }
            get docBaseUrl() {
              return this._docBaseUrl;
            }
            get catalog() {
              return this.pdfDocument.catalog;
            }
            ensureDoc(pt, mt) {
              return this.ensure(this.pdfDocument, pt, mt);
            }
            ensureXRef(pt, mt) {
              return this.ensure(this.pdfDocument.xref, pt, mt);
            }
            ensureCatalog(pt, mt) {
              return this.ensure(this.pdfDocument.catalog, pt, mt);
            }
            getPage(pt) {
              return this.pdfDocument.getPage(pt);
            }
            fontFallback(pt, mt) {
              return this.pdfDocument.fontFallback(pt, mt);
            }
            loadXfaFonts(pt, mt) {
              return this.pdfDocument.loadXfaFonts(pt, mt);
            }
            loadXfaImages() {
              return this.pdfDocument.loadXfaImages();
            }
            serializeXfaData(pt) {
              return this.pdfDocument.serializeXfaData(pt);
            }
            cleanup() {
              let pt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              return this.pdfDocument.cleanup(pt);
            }
            async ensure(pt, mt, ct) {
              (0, rt.unreachable)("Abstract method `ensure` called");
            }
            requestRange(pt, mt) {
              (0, rt.unreachable)("Abstract method `requestRange` called");
            }
            requestLoadedStream() {
              (0, rt.unreachable)("Abstract method `requestLoadedStream` called");
            }
            sendProgressiveData(pt) {
              (0, rt.unreachable)("Abstract method `sendProgressiveData` called");
            }
            updatePassword(pt) {
              this._password = pt;
            }
            terminate(pt) {
              (0, rt.unreachable)("Abstract method `terminate` called");
            }
          }
          class ht extends ft {
            constructor(pt) {
              super(pt);
              const mt = new it.Stream(pt.source);
              this.pdfDocument = new et.PDFDocument(this, mt), this._loadedStreamPromise = Promise.resolve(mt);
            }
            async ensure(pt, mt, ct) {
              const vt = pt[mt];
              return typeof vt == "function" ? vt.apply(pt, ct) : vt;
            }
            requestRange(pt, mt) {
              return Promise.resolve();
            }
            requestLoadedStream() {
              return this._loadedStreamPromise;
            }
            terminate(pt) {
            }
          }
          at.LocalPdfManager = ht;
          class dt extends ft {
            constructor(pt) {
              super(pt), this.streamManager = new st.ChunkedStreamManager(pt.source, {
                msgHandler: pt.handler,
                length: pt.length,
                disableAutoFetch: pt.disableAutoFetch,
                rangeChunkSize: pt.rangeChunkSize
              }), this.pdfDocument = new et.PDFDocument(this, this.streamManager.getStream());
            }
            async ensure(pt, mt, ct) {
              try {
                const vt = pt[mt];
                return typeof vt == "function" ? vt.apply(pt, ct) : vt;
              } catch (vt) {
                if (!(vt instanceof lt.MissingDataException))
                  throw vt;
                return await this.requestRange(vt.begin, vt.end), this.ensure(pt, mt, ct);
              }
            }
            requestRange(pt, mt) {
              return this.streamManager.requestRange(pt, mt);
            }
            requestLoadedStream() {
              let pt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              return this.streamManager.requestAllChunks(pt);
            }
            sendProgressiveData(pt) {
              this.streamManager.onReceiveData({
                chunk: pt
              });
            }
            terminate(pt) {
              this.streamManager.abort(pt);
            }
          }
          at.NetworkPdfManager = dt;
        },
        /* 154 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.ChunkedStreamManager = at.ChunkedStream = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138), ot(140), ot(2);
          var rt = ot(150), st = ot(145), lt = ot(155);
          class et extends lt.Stream {
            constructor(ft, ht, dt) {
              super(new Uint8Array(ft), 0, ft, null), this.chunkSize = ht, this._loadedChunks = /* @__PURE__ */ new Set(), this.numChunks = Math.ceil(ft / ht), this.manager = dt, this.progressiveDataLength = 0, this.lastSuccessfulEnsureByteChunk = -1;
            }
            getMissingChunks() {
              const ft = [];
              for (let ht = 0, dt = this.numChunks; ht < dt; ++ht)
                this._loadedChunks.has(ht) || ft.push(ht);
              return ft;
            }
            get numChunksLoaded() {
              return this._loadedChunks.size;
            }
            get isDataLoaded() {
              return this.numChunksLoaded === this.numChunks;
            }
            onReceiveData(ft, ht) {
              const dt = this.chunkSize;
              if (ft % dt !== 0)
                throw new Error(`Bad begin offset: ${ft}`);
              const gt = ft + ht.byteLength;
              if (gt % dt !== 0 && gt !== this.bytes.length)
                throw new Error(`Bad end offset: ${gt}`);
              this.bytes.set(new Uint8Array(ht), ft);
              const pt = Math.floor(ft / dt), mt = Math.floor((gt - 1) / dt) + 1;
              for (let ct = pt; ct < mt; ++ct)
                this._loadedChunks.add(ct);
            }
            onReceiveProgressiveData(ft) {
              let ht = this.progressiveDataLength;
              const dt = Math.floor(ht / this.chunkSize);
              this.bytes.set(new Uint8Array(ft), ht), ht += ft.byteLength, this.progressiveDataLength = ht;
              const gt = ht >= this.end ? this.numChunks : Math.floor(ht / this.chunkSize);
              for (let pt = dt; pt < gt; ++pt)
                this._loadedChunks.add(pt);
            }
            ensureByte(ft) {
              if (ft < this.progressiveDataLength)
                return;
              const ht = Math.floor(ft / this.chunkSize);
              if (!(ht > this.numChunks) && ht !== this.lastSuccessfulEnsureByteChunk) {
                if (!this._loadedChunks.has(ht))
                  throw new rt.MissingDataException(ft, ft + 1);
                this.lastSuccessfulEnsureByteChunk = ht;
              }
            }
            ensureRange(ft, ht) {
              if (ft >= ht || ht <= this.progressiveDataLength)
                return;
              const dt = Math.floor(ft / this.chunkSize);
              if (dt > this.numChunks)
                return;
              const gt = Math.min(Math.floor((ht - 1) / this.chunkSize) + 1, this.numChunks);
              for (let pt = dt; pt < gt; ++pt)
                if (!this._loadedChunks.has(pt))
                  throw new rt.MissingDataException(ft, ht);
            }
            nextEmptyChunk(ft) {
              const ht = this.numChunks;
              for (let dt = 0; dt < ht; ++dt) {
                const gt = (ft + dt) % ht;
                if (!this._loadedChunks.has(gt))
                  return gt;
              }
              return null;
            }
            hasChunk(ft) {
              return this._loadedChunks.has(ft);
            }
            getByte() {
              const ft = this.pos;
              return ft >= this.end ? -1 : (ft >= this.progressiveDataLength && this.ensureByte(ft), this.bytes[this.pos++]);
            }
            getBytes(ft) {
              const ht = this.bytes, dt = this.pos, gt = this.end;
              if (!ft)
                return gt > this.progressiveDataLength && this.ensureRange(dt, gt), ht.subarray(dt, gt);
              let pt = dt + ft;
              return pt > gt && (pt = gt), pt > this.progressiveDataLength && this.ensureRange(dt, pt), this.pos = pt, ht.subarray(dt, pt);
            }
            getByteRange(ft, ht) {
              return ft < 0 && (ft = 0), ht > this.end && (ht = this.end), ht > this.progressiveDataLength && this.ensureRange(ft, ht), this.bytes.subarray(ft, ht);
            }
            makeSubStream(ft, ht) {
              let dt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
              ht ? ft + ht > this.progressiveDataLength && this.ensureRange(ft, ft + ht) : ft >= this.progressiveDataLength && this.ensureByte(ft);
              function gt() {
              }
              gt.prototype = Object.create(this), gt.prototype.getMissingChunks = function() {
                const mt = this.chunkSize, ct = Math.floor(this.start / mt), vt = Math.floor((this.end - 1) / mt) + 1, At = [];
                for (let xt = ct; xt < vt; ++xt)
                  this._loadedChunks.has(xt) || At.push(xt);
                return At;
              }, Object.defineProperty(gt.prototype, "isDataLoaded", {
                get() {
                  return this.numChunksLoaded === this.numChunks ? !0 : this.getMissingChunks().length === 0;
                },
                configurable: !0
              });
              const pt = new gt();
              return pt.pos = pt.start = ft, pt.end = ft + ht || this.end, pt.dict = dt, pt;
            }
            getBaseStreams() {
              return [this];
            }
          }
          at.ChunkedStream = et;
          class it {
            constructor(ft, ht) {
              this.length = ht.length, this.chunkSize = ht.rangeChunkSize, this.stream = new et(this.length, this.chunkSize, this), this.pdfNetworkStream = ft, this.disableAutoFetch = ht.disableAutoFetch, this.msgHandler = ht.msgHandler, this.currRequestId = 0, this._chunksNeededByRequest = /* @__PURE__ */ new Map(), this._requestsByChunk = /* @__PURE__ */ new Map(), this._promisesByRequest = /* @__PURE__ */ new Map(), this.progressiveDataLength = 0, this.aborted = !1, this._loadedStreamCapability = new st.PromiseCapability();
            }
            sendRequest(ft, ht) {
              const dt = this.pdfNetworkStream.getRangeReader(ft, ht);
              dt.isStreamingSupported || (dt.onProgress = this.onProgress.bind(this));
              let gt = [], pt = 0;
              return new Promise((mt, ct) => {
                const vt = (At) => {
                  let {
                    value: xt,
                    done: bt
                  } = At;
                  try {
                    if (bt) {
                      const Et = (0, rt.arrayBuffersToBytes)(gt);
                      gt = null, mt(Et);
                      return;
                    }
                    pt += xt.byteLength, dt.isStreamingSupported && this.onProgress({
                      loaded: pt
                    }), gt.push(xt), dt.read().then(vt, ct);
                  } catch (Et) {
                    ct(Et);
                  }
                };
                dt.read().then(vt, ct);
              }).then((mt) => {
                this.aborted || this.onReceiveData({
                  chunk: mt,
                  begin: ft
                });
              });
            }
            requestAllChunks() {
              if (!(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1)) {
                const ht = this.stream.getMissingChunks();
                this._requestChunks(ht);
              }
              return this._loadedStreamCapability.promise;
            }
            _requestChunks(ft) {
              const ht = this.currRequestId++, dt = /* @__PURE__ */ new Set();
              this._chunksNeededByRequest.set(ht, dt);
              for (const mt of ft)
                this.stream.hasChunk(mt) || dt.add(mt);
              if (dt.size === 0)
                return Promise.resolve();
              const gt = new st.PromiseCapability();
              this._promisesByRequest.set(ht, gt);
              const pt = [];
              for (const mt of dt) {
                let ct = this._requestsByChunk.get(mt);
                ct || (ct = [], this._requestsByChunk.set(mt, ct), pt.push(mt)), ct.push(ht);
              }
              if (pt.length > 0) {
                const mt = this.groupChunks(pt);
                for (const ct of mt) {
                  const vt = ct.beginChunk * this.chunkSize, At = Math.min(ct.endChunk * this.chunkSize, this.length);
                  this.sendRequest(vt, At).catch(gt.reject);
                }
              }
              return gt.promise.catch((mt) => {
                if (!this.aborted)
                  throw mt;
              });
            }
            getStream() {
              return this.stream;
            }
            requestRange(ft, ht) {
              ht = Math.min(ht, this.length);
              const dt = this.getBeginChunk(ft), gt = this.getEndChunk(ht), pt = [];
              for (let mt = dt; mt < gt; ++mt)
                pt.push(mt);
              return this._requestChunks(pt);
            }
            requestRanges() {
              let ft = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
              const ht = [];
              for (const dt of ft) {
                const gt = this.getBeginChunk(dt.begin), pt = this.getEndChunk(dt.end);
                for (let mt = gt; mt < pt; ++mt)
                  ht.includes(mt) || ht.push(mt);
              }
              return ht.sort(function(dt, gt) {
                return dt - gt;
              }), this._requestChunks(ht);
            }
            groupChunks(ft) {
              const ht = [];
              let dt = -1, gt = -1;
              for (let pt = 0, mt = ft.length; pt < mt; ++pt) {
                const ct = ft[pt];
                dt < 0 && (dt = ct), gt >= 0 && gt + 1 !== ct && (ht.push({
                  beginChunk: dt,
                  endChunk: gt + 1
                }), dt = ct), pt + 1 === ft.length && ht.push({
                  beginChunk: dt,
                  endChunk: ct + 1
                }), gt = ct;
              }
              return ht;
            }
            onProgress(ft) {
              this.msgHandler.send("DocProgress", {
                loaded: this.stream.numChunksLoaded * this.chunkSize + ft.loaded,
                total: this.length
              });
            }
            onReceiveData(ft) {
              const ht = ft.chunk, dt = ft.begin === void 0, gt = dt ? this.progressiveDataLength : ft.begin, pt = gt + ht.byteLength, mt = Math.floor(gt / this.chunkSize), ct = pt < this.length ? Math.floor(pt / this.chunkSize) : Math.ceil(pt / this.chunkSize);
              dt ? (this.stream.onReceiveProgressiveData(ht), this.progressiveDataLength = pt) : this.stream.onReceiveData(gt, ht), this.stream.isDataLoaded && this._loadedStreamCapability.resolve(this.stream);
              const vt = [];
              for (let At = mt; At < ct; ++At) {
                const xt = this._requestsByChunk.get(At);
                if (xt) {
                  this._requestsByChunk.delete(At);
                  for (const bt of xt) {
                    const Et = this._chunksNeededByRequest.get(bt);
                    Et.has(At) && Et.delete(At), !(Et.size > 0) && vt.push(bt);
                  }
                }
              }
              if (!this.disableAutoFetch && this._requestsByChunk.size === 0) {
                let At;
                if (this.stream.numChunksLoaded === 1) {
                  const xt = this.stream.numChunks - 1;
                  this.stream.hasChunk(xt) || (At = xt);
                } else
                  At = this.stream.nextEmptyChunk(ct);
                Number.isInteger(At) && this._requestChunks([At]);
              }
              for (const At of vt) {
                const xt = this._promisesByRequest.get(At);
                this._promisesByRequest.delete(At), xt.resolve();
              }
              this.msgHandler.send("DocProgress", {
                loaded: this.stream.numChunksLoaded * this.chunkSize,
                total: this.length
              });
            }
            onError(ft) {
              this._loadedStreamCapability.reject(ft);
            }
            getBeginChunk(ft) {
              return Math.floor(ft / this.chunkSize);
            }
            getEndChunk(ft) {
              return Math.floor((ft - 1) / this.chunkSize) + 1;
            }
            abort(ft) {
              var ht;
              this.aborted = !0, (ht = this.pdfNetworkStream) == null || ht.cancelAllRequests(ft);
              for (const dt of this._promisesByRequest.values())
                dt.reject(ft);
            }
          }
          at.ChunkedStreamManager = it;
        },
        /* 155 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.StringStream = at.Stream = at.NullStream = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(152), st = ot(145);
          class lt extends rt.BaseStream {
            constructor(ft, ht, dt, gt) {
              super(), this.bytes = ft instanceof Uint8Array ? ft : new Uint8Array(ft), this.start = ht || 0, this.pos = this.start, this.end = ht + dt || this.bytes.length, this.dict = gt;
            }
            get length() {
              return this.end - this.start;
            }
            get isEmpty() {
              return this.length === 0;
            }
            getByte() {
              return this.pos >= this.end ? -1 : this.bytes[this.pos++];
            }
            getBytes(ft) {
              const ht = this.bytes, dt = this.pos, gt = this.end;
              if (!ft)
                return ht.subarray(dt, gt);
              let pt = dt + ft;
              return pt > gt && (pt = gt), this.pos = pt, ht.subarray(dt, pt);
            }
            getByteRange(ft, ht) {
              return ft < 0 && (ft = 0), ht > this.end && (ht = this.end), this.bytes.subarray(ft, ht);
            }
            reset() {
              this.pos = this.start;
            }
            moveStart() {
              this.start = this.pos;
            }
            makeSubStream(ft, ht) {
              let dt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
              return new lt(this.bytes.buffer, ft, ht, dt);
            }
          }
          at.Stream = lt;
          class et extends lt {
            constructor(ft) {
              super((0, st.stringToBytes)(ft));
            }
          }
          at.StringStream = et;
          class it extends lt {
            constructor() {
              super(new Uint8Array(0));
            }
          }
          at.NullStream = it;
        },
        /* 156 */
        /***/
        (nt, at, ot) => {
          var Ft, Es, Nt, Cs;
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Page = at.PDFDocument = void 0, ot(2), ot(140), ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(145), st = ot(157), lt = ot(150), et = ot(151), it = ot(202), ut = ot(152), ft = ot(225), ht = ot(217), dt = ot(219), gt = ot(256), pt = ot(167), mt = ot(155), ct = ot(227), vt = ot(215), At = ot(164), xt = ot(169), bt = ot(223), Et = ot(224), St = ot(228), Bt = ot(257);
          const Ot = 1, Pt = [0, 0, 612, 792];
          class wt {
            constructor($t) {
              _r(this, Ft);
              let {
                pdfManager: Tt,
                xref: Dt,
                pageIndex: Ut,
                pageDict: Vt,
                ref: Qt,
                globalIdFactory: qt,
                fontCache: Zt,
                builtInCMapCache: ar,
                standardFontDataCache: Jt,
                globalImageCache: rr,
                systemFontCache: Yt,
                nonBlendModesSet: Kt,
                xfaFactory: nr
              } = $t;
              this.pdfManager = Tt, this.pageIndex = Ut, this.pageDict = Vt, this.xref = Dt, this.ref = Qt, this.fontCache = Zt, this.builtInCMapCache = ar, this.standardFontDataCache = Jt, this.globalImageCache = rr, this.systemFontCache = Yt, this.nonBlendModesSet = Kt, this.evaluatorOptions = Tt.evaluatorOptions, this.resourcesPromise = null, this.xfaFactory = nr;
              const tr = {
                obj: 0
              };
              this._localIdFactory = class extends qt {
                static createObjId() {
                  return `p${Ut}_${++tr.obj}`;
                }
                static getPageObjId() {
                  return `p${Qt.toString()}`;
                }
              };
            }
            _getInheritableProperty($t) {
              let Tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
              const Dt = (0, lt.getInheritableProperty)({
                dict: this.pageDict,
                key: $t,
                getArray: Tt,
                stopWhenFound: !1
              });
              return Array.isArray(Dt) ? Dt.length === 1 || !(Dt[0] instanceof et.Dict) ? Dt[0] : et.Dict.merge({
                xref: this.xref,
                dictArray: Dt
              }) : Dt;
            }
            get content() {
              return this.pageDict.getArray("Contents");
            }
            get resources() {
              const $t = this._getInheritableProperty("Resources");
              return (0, rt.shadow)(this, "resources", $t instanceof et.Dict ? $t : et.Dict.empty);
            }
            _getBoundingBox($t) {
              if (this.xfaData)
                return this.xfaData.bbox;
              let Tt = this._getInheritableProperty($t, !0);
              if (Array.isArray(Tt) && Tt.length === 4) {
                if (Tt = rt.Util.normalizeRect(Tt), Tt[2] - Tt[0] > 0 && Tt[3] - Tt[1] > 0)
                  return Tt;
                (0, rt.warn)(`Empty, or invalid, /${$t} entry.`);
              }
              return null;
            }
            get mediaBox() {
              return (0, rt.shadow)(this, "mediaBox", this._getBoundingBox("MediaBox") || Pt);
            }
            get cropBox() {
              return (0, rt.shadow)(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
            }
            get userUnit() {
              let $t = this.pageDict.get("UserUnit");
              return (typeof $t != "number" || $t <= 0) && ($t = Ot), (0, rt.shadow)(this, "userUnit", $t);
            }
            get view() {
              const {
                cropBox: $t,
                mediaBox: Tt
              } = this;
              if ($t !== Tt && !(0, rt.isArrayEqual)($t, Tt)) {
                const Dt = rt.Util.intersect($t, Tt);
                if (Dt && Dt[2] - Dt[0] > 0 && Dt[3] - Dt[1] > 0)
                  return (0, rt.shadow)(this, "view", Dt);
                (0, rt.warn)("Empty /CropBox and /MediaBox intersection.");
              }
              return (0, rt.shadow)(this, "view", Tt);
            }
            get rotate() {
              let $t = this._getInheritableProperty("Rotate") || 0;
              return $t % 90 !== 0 ? $t = 0 : $t >= 360 ? $t %= 360 : $t < 0 && ($t = ($t % 360 + 360) % 360), (0, rt.shadow)(this, "rotate", $t);
            }
            _onSubStreamError($t, Tt) {
              if (this.evaluatorOptions.ignoreErrors) {
                (0, rt.warn)(`getContentStream - ignoring sub-stream (${Tt}): "${$t}".`);
                return;
              }
              throw $t;
            }
            getContentStream() {
              return this.pdfManager.ensure(this, "content").then(($t) => $t instanceof ut.BaseStream ? $t : Array.isArray($t) ? new xt.StreamsSequenceStream($t, this._onSubStreamError.bind(this)) : new mt.NullStream());
            }
            get xfaData() {
              return (0, rt.shadow)(this, "xfaData", this.xfaFactory ? {
                bbox: this.xfaFactory.getBoundingBox(this.pageIndex)
              } : null);
            }
            async saveNewAnnotations($t, Tt, Dt, Ut) {
              if (this.xfaFactory)
                throw new Error("XFA: Cannot save new annotations.");
              const Vt = new At.PartialEvaluator({
                xref: this.xref,
                handler: $t,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              }), Qt = new et.RefSet(), qt = new et.RefSet();
              Ur(this, Ft, Es).call(this, Dt, Qt, qt);
              const Zt = this.pageDict, ar = this.annotations.filter((nr) => !(nr instanceof et.Ref && Qt.has(nr))), Jt = await st.AnnotationFactory.saveNewAnnotations(Vt, Tt, Dt, Ut);
              for (const {
                ref: nr
              } of Jt.annotations)
                nr instanceof et.Ref && !qt.has(nr) && ar.push(nr);
              const rr = Zt.get("Annots");
              Zt.set("Annots", ar);
              const Yt = [];
              await (0, Et.writeObject)(this.ref, Zt, Yt, this.xref), rr && Zt.set("Annots", rr);
              const Kt = Jt.dependencies;
              return Kt.push({
                ref: this.ref,
                data: Yt.join("")
              }, ...Jt.annotations), Kt;
            }
            save($t, Tt, Dt) {
              const Ut = new At.PartialEvaluator({
                xref: this.xref,
                handler: $t,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              });
              return this._parsedAnnotations.then(function(Vt) {
                const Qt = [];
                for (const qt of Vt)
                  qt.mustBePrinted(Dt) && Qt.push(qt.save(Ut, Tt, Dt).catch(function(Zt) {
                    return (0, rt.warn)(`save - ignoring annotation data during "${Tt.name}" task: "${Zt}".`), null;
                  }));
                return Promise.all(Qt).then(function(qt) {
                  return qt.filter((Zt) => !!Zt);
                });
              });
            }
            loadResources($t) {
              return this.resourcesPromise || (this.resourcesPromise = this.pdfManager.ensure(this, "resources")), this.resourcesPromise.then(() => new ct.ObjectLoader(this.resources, $t, this.xref).load());
            }
            getOperatorList($t) {
              let {
                handler: Tt,
                sink: Dt,
                task: Ut,
                intent: Vt,
                cacheKey: Qt,
                annotationStorage: qt = null
              } = $t;
              const Zt = this.getContentStream(), ar = this.loadResources(["ColorSpace", "ExtGState", "Font", "Pattern", "Properties", "Shading", "XObject"]), Jt = new At.PartialEvaluator({
                xref: this.xref,
                handler: Tt,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              }), rr = this.xfaFactory ? null : (0, lt.getNewAnnotationsMap)(qt);
              let Yt = null, Kt = Promise.resolve(null);
              if (rr) {
                const ir = rr.get(this.pageIndex);
                if (ir) {
                  const sr = this.pdfManager.ensureDoc("annotationGlobals");
                  let cr;
                  const or = /* @__PURE__ */ new Set();
                  for (const {
                    bitmapId: Gt,
                    bitmap: Wt
                  } of ir)
                    Gt && !Wt && !or.has(Gt) && or.add(Gt);
                  const {
                    isOffscreenCanvasSupported: Xt
                  } = this.evaluatorOptions;
                  if (or.size > 0) {
                    const Gt = ir.slice();
                    for (const [Wt, er] of qt)
                      Wt.startsWith(rt.AnnotationEditorPrefix) && er.bitmap && or.has(er.bitmapId) && Gt.push(er);
                    cr = st.AnnotationFactory.generateImages(Gt, this.xref, Xt);
                  } else
                    cr = st.AnnotationFactory.generateImages(ir, this.xref, Xt);
                  Yt = new et.RefSet(), Ur(this, Ft, Es).call(this, ir, Yt, null), Kt = sr.then((Gt) => Gt ? st.AnnotationFactory.printNewAnnotations(Gt, Jt, Ut, ir, cr) : null);
                }
              }
              const tr = Promise.all([Zt, ar]).then((ir) => {
                let [sr] = ir;
                const cr = new vt.OperatorList(Vt, Dt);
                return Tt.send("StartRenderPage", {
                  transparency: Jt.hasBlendModes(this.resources, this.nonBlendModesSet),
                  pageIndex: this.pageIndex,
                  cacheKey: Qt
                }), Jt.getOperatorList({
                  stream: sr,
                  task: Ut,
                  resources: this.resources,
                  operatorList: cr
                }).then(function() {
                  return cr;
                });
              });
              return Promise.all([tr, this._parsedAnnotations, Kt]).then(function(ir) {
                let [sr, cr, or] = ir;
                if (or) {
                  cr = cr.filter((ur) => !(ur.ref && Yt.has(ur.ref)));
                  for (let ur = 0, pr = or.length; ur < pr; ur++) {
                    const yr = or[ur];
                    if (yr.refToReplace) {
                      const Er = cr.findIndex((br) => br.ref && (0, et.isRefsEqual)(br.ref, yr.refToReplace));
                      Er >= 0 && (cr.splice(Er, 1, yr), or.splice(ur--, 1), pr--);
                    }
                  }
                  cr = cr.concat(or);
                }
                if (cr.length === 0 || Vt & rt.RenderingIntentFlag.ANNOTATIONS_DISABLE)
                  return sr.flush(!0), {
                    length: sr.totalLength
                  };
                const Xt = !!(Vt & rt.RenderingIntentFlag.ANNOTATIONS_FORMS), Gt = !!(Vt & rt.RenderingIntentFlag.ANY), Wt = !!(Vt & rt.RenderingIntentFlag.DISPLAY), er = !!(Vt & rt.RenderingIntentFlag.PRINT), lr = [];
                for (const ur of cr)
                  (Gt || Wt && ur.mustBeViewed(qt, Xt) || er && ur.mustBePrinted(qt)) && lr.push(ur.getOperatorList(Jt, Ut, Vt, Xt, qt).catch(function(pr) {
                    return (0, rt.warn)(`getOperatorList - ignoring annotation data during "${Ut.name}" task: "${pr}".`), {
                      opList: null,
                      separateForm: !1,
                      separateCanvas: !1
                    };
                  }));
                return Promise.all(lr).then(function(ur) {
                  let pr = !1, yr = !1;
                  for (const {
                    opList: Er,
                    separateForm: br,
                    separateCanvas: gr
                  } of ur)
                    sr.addOpList(Er), pr || (pr = br), yr || (yr = gr);
                  return sr.flush(!0, {
                    form: pr,
                    canvas: yr
                  }), {
                    length: sr.totalLength
                  };
                });
              });
            }
            extractTextContent($t) {
              let {
                handler: Tt,
                task: Dt,
                includeMarkedContent: Ut,
                disableNormalization: Vt,
                sink: Qt
              } = $t;
              const qt = this.getContentStream(), Zt = this.loadResources(["ExtGState", "Font", "Properties", "XObject"]);
              return Promise.all([qt, Zt]).then((Jt) => {
                let [rr] = Jt;
                return new At.PartialEvaluator({
                  xref: this.xref,
                  handler: Tt,
                  pageIndex: this.pageIndex,
                  idFactory: this._localIdFactory,
                  fontCache: this.fontCache,
                  builtInCMapCache: this.builtInCMapCache,
                  standardFontDataCache: this.standardFontDataCache,
                  globalImageCache: this.globalImageCache,
                  systemFontCache: this.systemFontCache,
                  options: this.evaluatorOptions
                }).getTextContent({
                  stream: rr,
                  task: Dt,
                  resources: this.resources,
                  includeMarkedContent: Ut,
                  disableNormalization: Vt,
                  sink: Qt,
                  viewBox: this.view
                });
              });
            }
            async getStructTree() {
              const $t = await this.pdfManager.ensureCatalog("structTreeRoot");
              return $t ? (await this._parsedAnnotations, (await this.pdfManager.ensure(this, "_parseStructTree", [$t])).serializable) : null;
            }
            _parseStructTree($t) {
              const Tt = new bt.StructTreePage($t, this.pageDict);
              return Tt.parse(this.ref), Tt;
            }
            async getAnnotationsData($t, Tt, Dt) {
              const Ut = await this._parsedAnnotations;
              if (Ut.length === 0)
                return Ut;
              const Vt = [], Qt = [];
              let qt;
              const Zt = !!(Dt & rt.RenderingIntentFlag.ANY), ar = !!(Dt & rt.RenderingIntentFlag.DISPLAY), Jt = !!(Dt & rt.RenderingIntentFlag.PRINT);
              for (const rr of Ut) {
                const Yt = Zt || ar && rr.viewable;
                (Yt || Jt && rr.printable) && Vt.push(rr.data), rr.hasTextContent && Yt && (qt || (qt = new At.PartialEvaluator({
                  xref: this.xref,
                  handler: $t,
                  pageIndex: this.pageIndex,
                  idFactory: this._localIdFactory,
                  fontCache: this.fontCache,
                  builtInCMapCache: this.builtInCMapCache,
                  standardFontDataCache: this.standardFontDataCache,
                  globalImageCache: this.globalImageCache,
                  systemFontCache: this.systemFontCache,
                  options: this.evaluatorOptions
                })), Qt.push(rr.extractTextContent(qt, Tt, [-1 / 0, -1 / 0, 1 / 0, 1 / 0]).catch(function(Kt) {
                  (0, rt.warn)(`getAnnotationsData - ignoring textContent during "${Tt.name}" task: "${Kt}".`);
                })));
              }
              return await Promise.all(Qt), Vt;
            }
            get annotations() {
              const $t = this._getInheritableProperty("Annots");
              return (0, rt.shadow)(this, "annotations", Array.isArray($t) ? $t : []);
            }
            get _parsedAnnotations() {
              const $t = this.pdfManager.ensure(this, "annotations").then(async (Tt) => {
                if (Tt.length === 0)
                  return Tt;
                const Dt = await this.pdfManager.ensureDoc("annotationGlobals");
                if (!Dt)
                  return [];
                const Ut = [];
                for (const qt of Tt)
                  Ut.push(st.AnnotationFactory.create(this.xref, qt, Dt, this._localIdFactory, !1, this.ref).catch(function(Zt) {
                    return (0, rt.warn)(`_parsedAnnotations: "${Zt}".`), null;
                  }));
                const Vt = [];
                let Qt;
                for (const qt of await Promise.all(Ut))
                  if (qt) {
                    if (qt instanceof st.PopupAnnotation) {
                      (Qt || (Qt = [])).push(qt);
                      continue;
                    }
                    Vt.push(qt);
                  }
                return Qt && Vt.push(...Qt), Vt;
              });
              return (0, rt.shadow)(this, "_parsedAnnotations", $t);
            }
            get jsActions() {
              const $t = (0, lt.collectActions)(this.xref, this.pageDict, rt.PageActionEventType);
              return (0, rt.shadow)(this, "jsActions", $t);
            }
          }
          Ft = new WeakSet(), Es = function($t, Tt, Dt) {
            for (const Ut of $t)
              if (Ut.id) {
                const Vt = et.Ref.fromString(Ut.id);
                if (!Vt) {
                  (0, rt.warn)(`A non-linked annotation cannot be modified: ${Ut.id}`);
                  continue;
                }
                if (Ut.deleted) {
                  Tt.put(Vt);
                  continue;
                }
                Dt == null || Dt.put(Vt), Ut.ref = Vt, delete Ut.id;
              }
          }, at.Page = wt;
          const Ct = new Uint8Array([37, 80, 68, 70, 45]), It = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]), yt = new Uint8Array([101, 110, 100, 111, 98, 106]), Rt = 1024, kt = "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
          function jt(Lt, $t) {
            let Tt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1024, Dt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
            const Ut = $t.length, Vt = Lt.peekBytes(Tt), Qt = Vt.length - Ut;
            if (Qt <= 0)
              return !1;
            if (Dt) {
              const qt = Ut - 1;
              let Zt = Vt.length - 1;
              for (; Zt >= qt; ) {
                let ar = 0;
                for (; ar < Ut && Vt[Zt - ar] === $t[qt - ar]; )
                  ar++;
                if (ar >= Ut)
                  return Lt.pos += Zt - qt, !0;
                Zt--;
              }
            } else {
              let qt = 0;
              for (; qt <= Qt; ) {
                let Zt = 0;
                for (; Zt < Ut && Vt[qt + Zt] === $t[Zt]; )
                  Zt++;
                if (Zt >= Ut)
                  return Lt.pos += qt, !0;
                qt++;
              }
            }
            return !1;
          }
          class Ht {
            constructor($t, Tt) {
              _r(this, Nt);
              if (Tt.length <= 0)
                throw new rt.InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
              this.pdfManager = $t, this.stream = Tt, this.xref = new Bt.XRef(Tt, $t), this._pagePromises = /* @__PURE__ */ new Map(), this._version = null;
              const Dt = {
                font: 0
              };
              this._globalIdFactory = class {
                static getDocId() {
                  return `g_${$t.docId}`;
                }
                static createFontId() {
                  return `f${++Dt.font}`;
                }
                static createObjId() {
                  (0, rt.unreachable)("Abstract method `createObjId` called.");
                }
                static getPageObjId() {
                  (0, rt.unreachable)("Abstract method `getPageObjId` called.");
                }
              };
            }
            parse($t) {
              this.xref.parse($t), this.catalog = new ht.Catalog(this.pdfManager, this.xref);
            }
            get linearization() {
              let $t = null;
              try {
                $t = pt.Linearization.create(this.stream);
              } catch (Tt) {
                if (Tt instanceof lt.MissingDataException)
                  throw Tt;
                (0, rt.info)(Tt);
              }
              return (0, rt.shadow)(this, "linearization", $t);
            }
            get startXRef() {
              const $t = this.stream;
              let Tt = 0;
              if (this.linearization)
                $t.reset(), jt($t, yt) && (Tt = $t.pos + 6 - $t.start);
              else {
                const Ut = It.length;
                let Vt = !1, Qt = $t.end;
                for (; !Vt && Qt > 0; )
                  Qt -= 1024 - Ut, Qt < 0 && (Qt = 0), $t.pos = Qt, Vt = jt($t, It, 1024, !0);
                if (Vt) {
                  $t.skip(9);
                  let qt;
                  do
                    qt = $t.getByte();
                  while ((0, lt.isWhiteSpace)(qt));
                  let Zt = "";
                  for (; qt >= 32 && qt <= 57; )
                    Zt += String.fromCharCode(qt), qt = $t.getByte();
                  Tt = parseInt(Zt, 10), isNaN(Tt) && (Tt = 0);
                }
              }
              return (0, rt.shadow)(this, "startXRef", Tt);
            }
            checkHeader() {
              const $t = this.stream;
              if ($t.reset(), !jt($t, Ct))
                return;
              $t.moveStart(), $t.skip(Ct.length);
              let Tt = "", Dt;
              for (; (Dt = $t.getByte()) > 32 && Tt.length < 7; )
                Tt += String.fromCharCode(Dt);
              lt.PDF_VERSION_REGEXP.test(Tt) ? this._version = Tt : (0, rt.warn)(`Invalid PDF header version: ${Tt}`);
            }
            parseStartXRef() {
              this.xref.setStartXRef(this.startXRef);
            }
            get numPages() {
              let $t = 0;
              return this.catalog.hasActualNumPages ? $t = this.catalog.numPages : this.xfaFactory ? $t = this.xfaFactory.getNumPages() : this.linearization ? $t = this.linearization.numPages : $t = this.catalog.numPages, (0, rt.shadow)(this, "numPages", $t);
            }
            _hasOnlyDocumentSignatures($t) {
              let Tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
              const Dt = 10;
              return Array.isArray($t) ? $t.every((Ut) => {
                if (Ut = this.xref.fetchIfRef(Ut), !(Ut instanceof et.Dict))
                  return !1;
                if (Ut.has("Kids"))
                  return ++Tt > Dt ? ((0, rt.warn)("_hasOnlyDocumentSignatures: maximum recursion depth reached"), !1) : this._hasOnlyDocumentSignatures(Ut.get("Kids"), Tt);
                const Vt = (0, et.isName)(Ut.get("FT"), "Sig"), Qt = Ut.get("Rect"), qt = Array.isArray(Qt) && Qt.every((Zt) => Zt === 0);
                return Vt && qt;
              }) : !1;
            }
            get _xfaStreams() {
              const $t = this.catalog.acroForm;
              if (!$t)
                return null;
              const Tt = $t.get("XFA"), Dt = {
                "xdp:xdp": "",
                template: "",
                datasets: "",
                config: "",
                connectionSet: "",
                localeSet: "",
                stylesheet: "",
                "/xdp:xdp": ""
              };
              if (Tt instanceof ut.BaseStream && !Tt.isEmpty)
                return Dt["xdp:xdp"] = Tt, Dt;
              if (!Array.isArray(Tt) || Tt.length === 0)
                return null;
              for (let Ut = 0, Vt = Tt.length; Ut < Vt; Ut += 2) {
                let Qt;
                if (Ut === 0 ? Qt = "xdp:xdp" : Ut === Vt - 2 ? Qt = "/xdp:xdp" : Qt = Tt[Ut], !Dt.hasOwnProperty(Qt))
                  continue;
                const qt = this.xref.fetchIfRef(Tt[Ut + 1]);
                !(qt instanceof ut.BaseStream) || qt.isEmpty || (Dt[Qt] = qt);
              }
              return Dt;
            }
            get xfaDatasets() {
              const $t = this._xfaStreams;
              if (!$t)
                return (0, rt.shadow)(this, "xfaDatasets", null);
              for (const Tt of ["datasets", "xdp:xdp"]) {
                const Dt = $t[Tt];
                if (Dt)
                  try {
                    const Ut = (0, rt.stringToUTF8String)(Dt.getString()), Vt = {
                      [Tt]: Ut
                    };
                    return (0, rt.shadow)(this, "xfaDatasets", new gt.DatasetReader(Vt));
                  } catch {
                    (0, rt.warn)("XFA - Invalid utf-8 string.");
                    break;
                  }
              }
              return (0, rt.shadow)(this, "xfaDatasets", null);
            }
            get xfaData() {
              const $t = this._xfaStreams;
              if (!$t)
                return null;
              const Tt = /* @__PURE__ */ Object.create(null);
              for (const [Dt, Ut] of Object.entries($t))
                if (Ut)
                  try {
                    Tt[Dt] = (0, rt.stringToUTF8String)(Ut.getString());
                  } catch {
                    return (0, rt.warn)("XFA - Invalid utf-8 string."), null;
                  }
              return Tt;
            }
            get xfaFactory() {
              let $t;
              return this.pdfManager.enableXfa && this.catalog.needsRendering && this.formInfo.hasXfa && !this.formInfo.hasAcroForm && ($t = this.xfaData), (0, rt.shadow)(this, "xfaFactory", $t ? new St.XFAFactory($t) : null);
            }
            get isPureXfa() {
              return this.xfaFactory ? this.xfaFactory.isValid() : !1;
            }
            get htmlForXfa() {
              return this.xfaFactory ? this.xfaFactory.getPages() : null;
            }
            async loadXfaImages() {
              const $t = await this.pdfManager.ensureCatalog("xfaImages");
              if (!$t)
                return;
              const Tt = $t.getKeys();
              await new ct.ObjectLoader($t, Tt, this.xref).load();
              const Ut = /* @__PURE__ */ new Map();
              for (const Vt of Tt) {
                const Qt = $t.get(Vt);
                Qt instanceof ut.BaseStream && Ut.set(Vt, Qt.getBytes());
              }
              this.xfaFactory.setImages(Ut);
            }
            async loadXfaFonts($t, Tt) {
              const Dt = await this.pdfManager.ensureCatalog("acroForm");
              if (!Dt)
                return;
              const Ut = await Dt.getAsync("DR");
              if (!(Ut instanceof et.Dict))
                return;
              await new ct.ObjectLoader(Ut, ["Font"], this.xref).load();
              const Qt = Ut.get("Font");
              if (!(Qt instanceof et.Dict))
                return;
              const qt = Object.assign(/* @__PURE__ */ Object.create(null), this.pdfManager.evaluatorOptions);
              qt.useSystemFonts = !1;
              const Zt = new At.PartialEvaluator({
                xref: this.xref,
                handler: $t,
                pageIndex: -1,
                idFactory: this._globalIdFactory,
                fontCache: this.catalog.fontCache,
                builtInCMapCache: this.catalog.builtInCMapCache,
                standardFontDataCache: this.catalog.standardFontDataCache,
                options: qt
              }), ar = new vt.OperatorList(), Jt = [], rr = {
                get font() {
                  return Jt.at(-1);
                },
                set font(ir) {
                  Jt.push(ir);
                },
                clone() {
                  return this;
                }
              }, Yt = /* @__PURE__ */ new Map();
              Qt.forEach((ir, sr) => {
                Yt.set(ir, sr);
              });
              const Kt = [];
              for (const [ir, sr] of Yt) {
                const cr = sr.get("FontDescriptor");
                if (!(cr instanceof et.Dict))
                  continue;
                let or = cr.get("FontFamily");
                or = or.replaceAll(/[ ]+(\d)/g, "$1");
                const Xt = cr.get("FontWeight"), Gt = -cr.get("ItalicAngle"), Wt = {
                  fontFamily: or,
                  fontWeight: Xt,
                  italicAngle: Gt
                };
                (0, lt.validateCSSFont)(Wt) && Kt.push(Zt.handleSetFont(Ut, [et.Name.get(ir), 1], null, ar, Tt, rr, null, Wt).catch(function(er) {
                  return (0, rt.warn)(`loadXfaFonts: "${er}".`), null;
                }));
              }
              await Promise.all(Kt);
              const nr = this.xfaFactory.setFonts(Jt);
              if (!nr)
                return;
              qt.ignoreErrors = !0, Kt.length = 0, Jt.length = 0;
              const tr = /* @__PURE__ */ new Set();
              for (const ir of nr)
                (0, it.getXfaFontName)(`${ir}-Regular`) || tr.add(ir);
              tr.size && nr.push("PdfJS-Fallback");
              for (const ir of nr)
                if (!tr.has(ir))
                  for (const sr of [{
                    name: "Regular",
                    fontWeight: 400,
                    italicAngle: 0
                  }, {
                    name: "Bold",
                    fontWeight: 700,
                    italicAngle: 0
                  }, {
                    name: "Italic",
                    fontWeight: 400,
                    italicAngle: 12
                  }, {
                    name: "BoldItalic",
                    fontWeight: 700,
                    italicAngle: 12
                  }]) {
                    const cr = `${ir}-${sr.name}`, or = (0, it.getXfaFontDict)(cr);
                    Kt.push(Zt.handleSetFont(Ut, [et.Name.get(cr), 1], null, ar, Tt, rr, or, {
                      fontFamily: ir,
                      fontWeight: sr.fontWeight,
                      italicAngle: sr.italicAngle
                    }).catch(function(Xt) {
                      return (0, rt.warn)(`loadXfaFonts: "${Xt}".`), null;
                    }));
                  }
              await Promise.all(Kt), this.xfaFactory.appendFonts(Jt, tr);
            }
            async serializeXfaData($t) {
              return this.xfaFactory ? this.xfaFactory.serializeData($t) : null;
            }
            get version() {
              return this.catalog.version || this._version;
            }
            get formInfo() {
              const $t = {
                hasFields: !1,
                hasAcroForm: !1,
                hasXfa: !1,
                hasSignatures: !1
              }, Tt = this.catalog.acroForm;
              if (!Tt)
                return (0, rt.shadow)(this, "formInfo", $t);
              try {
                const Dt = Tt.get("Fields"), Ut = Array.isArray(Dt) && Dt.length > 0;
                $t.hasFields = Ut;
                const Vt = Tt.get("XFA");
                $t.hasXfa = Array.isArray(Vt) && Vt.length > 0 || Vt instanceof ut.BaseStream && !Vt.isEmpty;
                const qt = !!(Tt.get("SigFlags") & 1), Zt = qt && this._hasOnlyDocumentSignatures(Dt);
                $t.hasAcroForm = Ut && !Zt, $t.hasSignatures = qt;
              } catch (Dt) {
                if (Dt instanceof lt.MissingDataException)
                  throw Dt;
                (0, rt.warn)(`Cannot fetch form information: "${Dt}".`);
              }
              return (0, rt.shadow)(this, "formInfo", $t);
            }
            get documentInfo() {
              const $t = {
                PDFFormatVersion: this.version,
                Language: this.catalog.lang,
                EncryptFilterName: this.xref.encrypt ? this.xref.encrypt.filterName : null,
                IsLinearized: !!this.linearization,
                IsAcroFormPresent: this.formInfo.hasAcroForm,
                IsXFAPresent: this.formInfo.hasXfa,
                IsCollectionPresent: !!this.catalog.collection,
                IsSignaturesPresent: this.formInfo.hasSignatures
              };
              let Tt;
              try {
                Tt = this.xref.trailer.get("Info");
              } catch (Dt) {
                if (Dt instanceof lt.MissingDataException)
                  throw Dt;
                (0, rt.info)("The document information dictionary is invalid.");
              }
              if (!(Tt instanceof et.Dict))
                return (0, rt.shadow)(this, "documentInfo", $t);
              for (const Dt of Tt.getKeys()) {
                const Ut = Tt.get(Dt);
                switch (Dt) {
                  case "Title":
                  case "Author":
                  case "Subject":
                  case "Keywords":
                  case "Creator":
                  case "Producer":
                  case "CreationDate":
                  case "ModDate":
                    if (typeof Ut == "string") {
                      $t[Dt] = (0, rt.stringToPDFString)(Ut);
                      continue;
                    }
                    break;
                  case "Trapped":
                    if (Ut instanceof et.Name) {
                      $t[Dt] = Ut;
                      continue;
                    }
                    break;
                  default:
                    let Vt;
                    switch (typeof Ut) {
                      case "string":
                        Vt = (0, rt.stringToPDFString)(Ut);
                        break;
                      case "number":
                      case "boolean":
                        Vt = Ut;
                        break;
                      default:
                        Ut instanceof et.Name && (Vt = Ut);
                        break;
                    }
                    if (Vt === void 0) {
                      (0, rt.warn)(`Bad value, for custom key "${Dt}", in Info: ${Ut}.`);
                      continue;
                    }
                    $t.Custom || ($t.Custom = /* @__PURE__ */ Object.create(null)), $t.Custom[Dt] = Vt;
                    continue;
                }
                (0, rt.warn)(`Bad value, for key "${Dt}", in Info: ${Ut}.`);
              }
              return (0, rt.shadow)(this, "documentInfo", $t);
            }
            get fingerprints() {
              function $t(Qt) {
                return typeof Qt == "string" && Qt.length > 0 && Qt !== kt;
              }
              function Tt(Qt) {
                const qt = [];
                for (const Zt of Qt) {
                  const ar = Zt.toString(16);
                  qt.push(ar.padStart(2, "0"));
                }
                return qt.join("");
              }
              const Dt = this.xref.trailer.get("ID");
              let Ut, Vt;
              return Array.isArray(Dt) && $t(Dt[0]) ? (Ut = (0, rt.stringToBytes)(Dt[0]), Dt[1] !== Dt[0] && $t(Dt[1]) && (Vt = (0, rt.stringToBytes)(Dt[1]))) : Ut = (0, ft.calculateMD5)(this.stream.getByteRange(0, Rt), 0, Rt), (0, rt.shadow)(this, "fingerprints", [Tt(Ut), Vt ? Tt(Vt) : null]);
            }
            async _getLinearizationPage($t) {
              const {
                catalog: Tt,
                linearization: Dt,
                xref: Ut
              } = this, Vt = et.Ref.get(Dt.objectNumberFirst, 0);
              try {
                const Qt = await Ut.fetchAsync(Vt);
                if (Qt instanceof et.Dict) {
                  let qt = Qt.getRaw("Type");
                  if (qt instanceof et.Ref && (qt = await Ut.fetchAsync(qt)), (0, et.isName)(qt, "Page") || !Qt.has("Type") && !Qt.has("Kids"))
                    return Tt.pageKidsCountCache.has(Vt) || Tt.pageKidsCountCache.put(Vt, 1), Tt.pageIndexCache.has(Vt) || Tt.pageIndexCache.put(Vt, 0), [Qt, Vt];
                }
                throw new rt.FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
              } catch (Qt) {
                return (0, rt.warn)(`_getLinearizationPage: "${Qt.message}".`), Tt.getPageDict($t);
              }
            }
            getPage($t) {
              const Tt = this._pagePromises.get($t);
              if (Tt)
                return Tt;
              const {
                catalog: Dt,
                linearization: Ut,
                xfaFactory: Vt
              } = this;
              let Qt;
              return Vt ? Qt = Promise.resolve([et.Dict.empty, null]) : (Ut == null ? void 0 : Ut.pageFirst) === $t ? Qt = this._getLinearizationPage($t) : Qt = Dt.getPageDict($t), Qt = Qt.then((qt) => {
                let [Zt, ar] = qt;
                return new wt({
                  pdfManager: this.pdfManager,
                  xref: this.xref,
                  pageIndex: $t,
                  pageDict: Zt,
                  ref: ar,
                  globalIdFactory: this._globalIdFactory,
                  fontCache: Dt.fontCache,
                  builtInCMapCache: Dt.builtInCMapCache,
                  standardFontDataCache: Dt.standardFontDataCache,
                  globalImageCache: Dt.globalImageCache,
                  systemFontCache: Dt.systemFontCache,
                  nonBlendModesSet: Dt.nonBlendModesSet,
                  xfaFactory: Vt
                });
              }), this._pagePromises.set($t, Qt), Qt;
            }
            async checkFirstPage() {
              if (!(arguments.length > 0 && arguments[0] !== void 0 && arguments[0]))
                try {
                  await this.getPage(0);
                } catch (Tt) {
                  if (Tt instanceof lt.XRefEntryException)
                    throw this._pagePromises.delete(0), await this.cleanup(), new lt.XRefParseException();
                }
            }
            async checkLastPage() {
              let $t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              const {
                catalog: Tt,
                pdfManager: Dt
              } = this;
              Tt.setActualNumPages();
              let Ut;
              try {
                if (await Promise.all([Dt.ensureDoc("xfaFactory"), Dt.ensureDoc("linearization"), Dt.ensureCatalog("numPages")]), this.xfaFactory)
                  return;
                if (this.linearization ? Ut = this.linearization.numPages : Ut = Tt.numPages, Number.isInteger(Ut)) {
                  if (Ut <= 1)
                    return;
                } else
                  throw new rt.FormatError("Page count is not an integer.");
                await this.getPage(Ut - 1);
              } catch (Vt) {
                if (this._pagePromises.delete(Ut - 1), await this.cleanup(), Vt instanceof lt.XRefEntryException && !$t)
                  throw new lt.XRefParseException();
                (0, rt.warn)(`checkLastPage - invalid /Pages tree /Count: ${Ut}.`);
                let Qt;
                try {
                  Qt = await Tt.getAllPageDicts($t);
                } catch (qt) {
                  if (qt instanceof lt.XRefEntryException && !$t)
                    throw new lt.XRefParseException();
                  Tt.setActualNumPages(1);
                  return;
                }
                for (const [qt, [Zt, ar]] of Qt) {
                  let Jt;
                  Zt instanceof Error ? (Jt = Promise.reject(Zt), Jt.catch(() => {
                  })) : Jt = Promise.resolve(new wt({
                    pdfManager: Dt,
                    xref: this.xref,
                    pageIndex: qt,
                    pageDict: Zt,
                    ref: ar,
                    globalIdFactory: this._globalIdFactory,
                    fontCache: Tt.fontCache,
                    builtInCMapCache: Tt.builtInCMapCache,
                    standardFontDataCache: Tt.standardFontDataCache,
                    globalImageCache: Tt.globalImageCache,
                    systemFontCache: Tt.systemFontCache,
                    nonBlendModesSet: Tt.nonBlendModesSet,
                    xfaFactory: null
                  })), this._pagePromises.set(qt, Jt);
                }
                Tt.setActualNumPages(Qt.size);
              }
            }
            fontFallback($t, Tt) {
              return this.catalog.fontFallback($t, Tt);
            }
            async cleanup() {
              let $t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              return this.catalog ? this.catalog.cleanup($t) : (0, dt.clearGlobalCaches)();
            }
            get fieldObjects() {
              if (!this.formInfo.hasFields)
                return (0, rt.shadow)(this, "fieldObjects", Promise.resolve(null));
              const $t = this.pdfManager.ensureDoc("annotationGlobals").then(async (Tt) => {
                if (!Tt)
                  return null;
                const Dt = /* @__PURE__ */ Object.create(null), Ut = /* @__PURE__ */ new Map();
                for (const Qt of this.catalog.acroForm.get("Fields"))
                  Ur(this, Nt, Cs).call(this, "", Qt, Ut, Tt);
                const Vt = [];
                for (const [Qt, qt] of Ut)
                  Vt.push(Promise.all(qt).then((Zt) => {
                    Zt = Zt.filter((ar) => !!ar), Zt.length > 0 && (Dt[Qt] = Zt);
                  }));
                return await Promise.all(Vt), Dt;
              });
              return (0, rt.shadow)(this, "fieldObjects", $t);
            }
            get hasJSActions() {
              const $t = this.pdfManager.ensureDoc("_parseHasJSActions");
              return (0, rt.shadow)(this, "hasJSActions", $t);
            }
            async _parseHasJSActions() {
              const [$t, Tt] = await Promise.all([this.pdfManager.ensureCatalog("jsActions"), this.pdfManager.ensureDoc("fieldObjects")]);
              return $t ? !0 : Tt ? Object.values(Tt).some((Dt) => Dt.some((Ut) => Ut.actions !== null)) : !1;
            }
            get calculationOrderIds() {
              const $t = this.catalog.acroForm;
              if (!($t != null && $t.has("CO")))
                return (0, rt.shadow)(this, "calculationOrderIds", null);
              const Tt = $t.get("CO");
              if (!Array.isArray(Tt) || Tt.length === 0)
                return (0, rt.shadow)(this, "calculationOrderIds", null);
              const Dt = [];
              for (const Ut of Tt)
                Ut instanceof et.Ref && Dt.push(Ut.toString());
              return Dt.length === 0 ? (0, rt.shadow)(this, "calculationOrderIds", null) : (0, rt.shadow)(this, "calculationOrderIds", Dt);
            }
            get annotationGlobals() {
              return (0, rt.shadow)(this, "annotationGlobals", st.AnnotationFactory.createGlobals(this.pdfManager));
            }
          }
          Nt = new WeakSet(), Cs = function($t, Tt, Dt, Ut) {
            const Vt = this.xref.fetchIfRef(Tt);
            if (Vt.has("T")) {
              const Qt = (0, rt.stringToPDFString)(Vt.get("T"));
              $t = $t === "" ? Qt : `${$t}.${Qt}`;
            }
            if (Dt.has($t) || Dt.set($t, []), Dt.get($t).push(st.AnnotationFactory.create(this.xref, Tt, Ut, this._localIdFactory, !0, null).then((Qt) => Qt == null ? void 0 : Qt.getFieldObject()).catch(function(Qt) {
              return (0, rt.warn)(`#collectFieldObjects: "${Qt}".`), null;
            })), Vt.has("Kids"))
              for (const Qt of Vt.get("Kids"))
                Ur(this, Nt, Cs).call(this, $t, Qt, Dt, Ut);
          }, at.PDFDocument = Ht;
        },
        /* 157 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.PopupAnnotation = at.MarkupAnnotation = at.AnnotationFactory = at.AnnotationBorderStyle = at.Annotation = void 0, at.getQuadPoints = St, ot(140), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(158), ot(160);
          var rt = ot(145), st = ot(150), lt = ot(162), et = ot(151), it = ot(155), ut = ot(152), ft = ot(211), ht = ot(217), dt = ot(163), gt = ot(220), pt = ot(177), mt = ot(227), ct = ot(215), vt = ot(224), At = ot(228);
          class xt {
            static createGlobals(Yt) {
              return Promise.all([Yt.ensureCatalog("acroForm"), Yt.ensureDoc("xfaDatasets"), Yt.ensureCatalog("structTreeRoot"), Yt.ensureCatalog("baseUrl"), Yt.ensureCatalog("attachments")]).then((Kt) => {
                let [nr, tr, ir, sr, cr] = Kt;
                return {
                  pdfManager: Yt,
                  acroForm: nr instanceof et.Dict ? nr : et.Dict.empty,
                  xfaDatasets: tr,
                  structTreeRoot: ir,
                  baseUrl: sr,
                  attachments: cr
                };
              }, (Kt) => ((0, rt.warn)(`createGlobals: "${Kt}".`), null));
            }
            static async create(Yt, Kt, nr, tr, ir, sr) {
              const cr = ir ? await this._getPageIndex(Yt, Kt, nr.pdfManager) : null;
              return nr.pdfManager.ensure(this, "_create", [Yt, Kt, nr, tr, ir, cr, sr]);
            }
            static _create(Yt, Kt, nr, tr) {
              let ir = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, sr = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, cr = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
              const or = Yt.fetchIfRef(Kt);
              if (!(or instanceof et.Dict))
                return;
              const {
                acroForm: Xt,
                pdfManager: Gt
              } = nr, Wt = Kt instanceof et.Ref ? Kt.toString() : `annot_${tr.createObjId()}`;
              let er = or.get("Subtype");
              er = er instanceof et.Name ? er.name : null;
              const lr = {
                xref: Yt,
                ref: Kt,
                dict: or,
                subtype: er,
                id: Wt,
                annotationGlobals: nr,
                collectFields: ir,
                needAppearances: !ir && Xt.get("NeedAppearances") === !0,
                pageIndex: sr,
                evaluatorOptions: Gt.evaluatorOptions,
                pageRef: cr
              };
              switch (er) {
                case "Link":
                  return new Ht(lr);
                case "Text":
                  return new jt(lr);
                case "Widget":
                  let ur = (0, st.getInheritableProperty)({
                    dict: or,
                    key: "FT"
                  });
                  switch (ur = ur instanceof et.Name ? ur.name : null, ur) {
                    case "Tx":
                      return new It(lr);
                    case "Btn":
                      return new yt(lr);
                    case "Ch":
                      return new Rt(lr);
                    case "Sig":
                      return new kt(lr);
                  }
                  return (0, rt.warn)(`Unimplemented widget field type "${ur}", falling back to base field type.`), new Ct(lr);
                case "Popup":
                  return new Ft(lr);
                case "FreeText":
                  return new _t(lr);
                case "Line":
                  return new Nt(lr);
                case "Square":
                  return new Mt(lr);
                case "Circle":
                  return new Lt(lr);
                case "PolyLine":
                  return new $t(lr);
                case "Polygon":
                  return new Tt(lr);
                case "Caret":
                  return new Dt(lr);
                case "Ink":
                  return new Ut(lr);
                case "Highlight":
                  return new Vt(lr);
                case "Underline":
                  return new Qt(lr);
                case "Squiggly":
                  return new qt(lr);
                case "StrikeOut":
                  return new Zt(lr);
                case "Stamp":
                  return new ar(lr);
                case "FileAttachment":
                  return new Jt(lr);
                default:
                  return ir || (er ? (0, rt.warn)(`Unimplemented annotation type "${er}", falling back to base annotation.`) : (0, rt.warn)("Annotation is missing the required /Subtype.")), new Ot(lr);
              }
            }
            static async _getPageIndex(Yt, Kt, nr) {
              try {
                const tr = await Yt.fetchIfRefAsync(Kt);
                if (!(tr instanceof et.Dict))
                  return -1;
                const ir = tr.getRaw("P");
                if (ir instanceof et.Ref)
                  try {
                    return await nr.ensureCatalog("getPageIndex", [ir]);
                  } catch (cr) {
                    (0, rt.info)(`_getPageIndex -- not a valid page reference: "${cr}".`);
                  }
                if (tr.has("Kids"))
                  return -1;
                const sr = await nr.ensureDoc("numPages");
                for (let cr = 0; cr < sr; cr++) {
                  const or = await nr.getPage(cr), Xt = await nr.ensure(or, "annotations");
                  for (const Gt of Xt)
                    if (Gt instanceof et.Ref && (0, et.isRefsEqual)(Gt, Kt))
                      return cr;
                }
              } catch (tr) {
                (0, rt.warn)(`_getPageIndex: "${tr}".`);
              }
              return -1;
            }
            static generateImages(Yt, Kt, nr) {
              if (!nr)
                return (0, rt.warn)("generateImages: OffscreenCanvas is not supported, cannot save or print some annotations with images."), null;
              let tr;
              for (const {
                bitmapId: ir,
                bitmap: sr
              } of Yt)
                sr && (tr || (tr = /* @__PURE__ */ new Map()), tr.set(ir, ar.createImage(sr, Kt)));
              return tr;
            }
            static async saveNewAnnotations(Yt, Kt, nr, tr) {
              const ir = Yt.xref;
              let sr;
              const cr = [], or = [], {
                isOffscreenCanvasSupported: Xt
              } = Yt.options;
              for (const Gt of nr)
                if (!Gt.deleted)
                  switch (Gt.annotationType) {
                    case rt.AnnotationEditorType.FREETEXT:
                      if (!sr) {
                        const er = new et.Dict(ir);
                        er.set("BaseFont", et.Name.get("Helvetica")), er.set("Type", et.Name.get("Font")), er.set("Subtype", et.Name.get("Type1")), er.set("Encoding", et.Name.get("WinAnsiEncoding"));
                        const lr = [];
                        sr = ir.getNewTemporaryRef(), await (0, vt.writeObject)(sr, er, lr, ir), cr.push({
                          ref: sr,
                          data: lr.join("")
                        });
                      }
                      or.push(_t.createNewAnnotation(ir, Gt, cr, {
                        evaluator: Yt,
                        task: Kt,
                        baseFontRef: sr
                      }));
                      break;
                    case rt.AnnotationEditorType.INK:
                      or.push(Ut.createNewAnnotation(ir, Gt, cr));
                      break;
                    case rt.AnnotationEditorType.STAMP:
                      if (!Xt)
                        break;
                      const Wt = await tr.get(Gt.bitmapId);
                      if (Wt.imageStream) {
                        const {
                          imageStream: er,
                          smaskStream: lr
                        } = Wt, ur = [];
                        if (lr) {
                          const yr = ir.getNewTemporaryRef();
                          await (0, vt.writeObject)(yr, lr, ur, ir), cr.push({
                            ref: yr,
                            data: ur.join("")
                          }), er.dict.set("SMask", yr), ur.length = 0;
                        }
                        const pr = Wt.imageRef = ir.getNewTemporaryRef();
                        await (0, vt.writeObject)(pr, er, ur, ir), cr.push({
                          ref: pr,
                          data: ur.join("")
                        }), Wt.imageStream = Wt.smaskStream = null;
                      }
                      or.push(ar.createNewAnnotation(ir, Gt, cr, {
                        image: Wt
                      }));
                      break;
                  }
              return {
                annotations: await Promise.all(or),
                dependencies: cr
              };
            }
            static async printNewAnnotations(Yt, Kt, nr, tr, ir) {
              if (!tr)
                return null;
              const {
                options: sr,
                xref: cr
              } = Kt, or = [];
              for (const Xt of tr)
                if (!Xt.deleted)
                  switch (Xt.annotationType) {
                    case rt.AnnotationEditorType.FREETEXT:
                      or.push(_t.createNewPrintAnnotation(Yt, cr, Xt, {
                        evaluator: Kt,
                        task: nr,
                        evaluatorOptions: sr
                      }));
                      break;
                    case rt.AnnotationEditorType.INK:
                      or.push(Ut.createNewPrintAnnotation(Yt, cr, Xt, {
                        evaluatorOptions: sr
                      }));
                      break;
                    case rt.AnnotationEditorType.STAMP:
                      if (!sr.isOffscreenCanvasSupported)
                        break;
                      const Gt = await ir.get(Xt.bitmapId);
                      if (Gt.imageStream) {
                        const {
                          imageStream: Wt,
                          smaskStream: er
                        } = Gt;
                        er && Wt.dict.set("SMask", er), Gt.imageRef = new pt.JpegStream(Wt, Wt.length), Gt.imageStream = Gt.smaskStream = null;
                      }
                      or.push(ar.createNewPrintAnnotation(Yt, cr, Xt, {
                        image: Gt,
                        evaluatorOptions: sr
                      }));
                      break;
                  }
              return Promise.all(or);
            }
          }
          at.AnnotationFactory = xt;
          function bt(rr) {
            let Yt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Uint8ClampedArray(3);
            if (!Array.isArray(rr))
              return Yt;
            const Kt = Yt || new Uint8ClampedArray(3);
            switch (rr.length) {
              case 0:
                return null;
              case 1:
                return dt.ColorSpace.singletons.gray.getRgbItem(rr, 0, Kt, 0), Kt;
              case 3:
                return dt.ColorSpace.singletons.rgb.getRgbItem(rr, 0, Kt, 0), Kt;
              case 4:
                return dt.ColorSpace.singletons.cmyk.getRgbItem(rr, 0, Kt, 0), Kt;
              default:
                return Yt;
            }
          }
          function Et(rr) {
            return Array.from(rr, (Yt) => Yt / 255);
          }
          function St(rr, Yt) {
            const Kt = rr.getArray("QuadPoints");
            if (!Array.isArray(Kt) || Kt.length === 0 || Kt.length % 8 > 0)
              return null;
            const nr = [];
            for (let tr = 0, ir = Kt.length / 8; tr < ir; tr++) {
              let sr = 1 / 0, cr = -1 / 0, or = 1 / 0, Xt = -1 / 0;
              for (let Gt = tr * 8, Wt = tr * 8 + 8; Gt < Wt; Gt += 2) {
                const er = Kt[Gt], lr = Kt[Gt + 1];
                sr = Math.min(er, sr), cr = Math.max(er, cr), or = Math.min(lr, or), Xt = Math.max(lr, Xt);
              }
              if (Yt !== null && (sr < Yt[0] || cr > Yt[2] || or < Yt[1] || Xt > Yt[3]))
                return null;
              nr.push([{
                x: sr,
                y: Xt
              }, {
                x: cr,
                y: Xt
              }, {
                x: sr,
                y: or
              }, {
                x: cr,
                y: or
              }]);
            }
            return nr;
          }
          function Bt(rr, Yt, Kt) {
            const [nr, tr, ir, sr] = rt.Util.getAxialAlignedBoundingBox(Yt, Kt);
            if (nr === ir || tr === sr)
              return [1, 0, 0, 1, rr[0], rr[1]];
            const cr = (rr[2] - rr[0]) / (ir - nr), or = (rr[3] - rr[1]) / (sr - tr);
            return [cr, 0, 0, or, rr[0] - nr * cr, rr[1] - tr * or];
          }
          class Ot {
            constructor(Yt) {
              const {
                dict: Kt,
                xref: nr,
                annotationGlobals: tr
              } = Yt;
              this.setTitle(Kt.get("T")), this.setContents(Kt.get("Contents")), this.setModificationDate(Kt.get("M")), this.setFlags(Kt.get("F")), this.setRectangle(Kt.getArray("Rect")), this.setColor(Kt.getArray("C")), this.setBorderStyle(Kt), this.setAppearance(Kt), this.setOptionalContent(Kt);
              const ir = Kt.get("MK");
              this.setBorderAndBackgroundColors(ir), this.setRotation(ir, Kt), this.ref = Yt.ref instanceof et.Ref ? Yt.ref : null, this._streams = [], this.appearance && this._streams.push(this.appearance);
              const sr = !!(this.flags & rt.AnnotationFlag.LOCKED), cr = !!(this.flags & rt.AnnotationFlag.LOCKEDCONTENTS);
              if (tr.structTreeRoot) {
                let or = Kt.get("StructParent");
                or = Number.isInteger(or) && or >= 0 ? or : -1, tr.structTreeRoot.addAnnotationIdToPage(Yt.pageRef, or);
              }
              if (this.data = {
                annotationFlags: this.flags,
                borderStyle: this.borderStyle,
                color: this.color,
                backgroundColor: this.backgroundColor,
                borderColor: this.borderColor,
                rotation: this.rotation,
                contentsObj: this._contents,
                hasAppearance: !!this.appearance,
                id: Yt.id,
                modificationDate: this.modificationDate,
                rect: this.rectangle,
                subtype: Yt.subtype,
                hasOwnCanvas: !1,
                noRotate: !!(this.flags & rt.AnnotationFlag.NOROTATE),
                noHTML: sr && cr
              }, Yt.collectFields) {
                const or = Kt.get("Kids");
                if (Array.isArray(or)) {
                  const Xt = [];
                  for (const Gt of or)
                    Gt instanceof et.Ref && Xt.push(Gt.toString());
                  Xt.length !== 0 && (this.data.kidIds = Xt);
                }
                this.data.actions = (0, st.collectActions)(nr, Kt, rt.AnnotationActionEventType), this.data.fieldName = this._constructFieldName(Kt), this.data.pageIndex = Yt.pageIndex;
              }
              this._isOffscreenCanvasSupported = Yt.evaluatorOptions.isOffscreenCanvasSupported, this._fallbackFontDict = null, this._needAppearances = !1;
            }
            _hasFlag(Yt, Kt) {
              return !!(Yt & Kt);
            }
            _isViewable(Yt) {
              return !this._hasFlag(Yt, rt.AnnotationFlag.INVISIBLE) && !this._hasFlag(Yt, rt.AnnotationFlag.NOVIEW);
            }
            _isPrintable(Yt) {
              return this._hasFlag(Yt, rt.AnnotationFlag.PRINT) && !this._hasFlag(Yt, rt.AnnotationFlag.HIDDEN) && !this._hasFlag(Yt, rt.AnnotationFlag.INVISIBLE);
            }
            mustBeViewed(Yt, Kt) {
              var tr;
              const nr = (tr = Yt == null ? void 0 : Yt.get(this.data.id)) == null ? void 0 : tr.noView;
              return nr !== void 0 ? !nr : this.viewable && !this._hasFlag(this.flags, rt.AnnotationFlag.HIDDEN);
            }
            mustBePrinted(Yt) {
              var nr;
              const Kt = (nr = Yt == null ? void 0 : Yt.get(this.data.id)) == null ? void 0 : nr.noPrint;
              return Kt !== void 0 ? !Kt : this.printable;
            }
            get viewable() {
              return this.data.quadPoints === null ? !1 : this.flags === 0 ? !0 : this._isViewable(this.flags);
            }
            get printable() {
              return this.data.quadPoints === null || this.flags === 0 ? !1 : this._isPrintable(this.flags);
            }
            _parseStringHelper(Yt) {
              const Kt = typeof Yt == "string" ? (0, rt.stringToPDFString)(Yt) : "", nr = Kt && (0, ft.bidi)(Kt).dir === "rtl" ? "rtl" : "ltr";
              return {
                str: Kt,
                dir: nr
              };
            }
            setDefaultAppearance(Yt) {
              const {
                dict: Kt,
                annotationGlobals: nr
              } = Yt, tr = (0, st.getInheritableProperty)({
                dict: Kt,
                key: "DA"
              }) || nr.acroForm.get("DA");
              this._defaultAppearance = typeof tr == "string" ? tr : "", this.data.defaultAppearanceData = (0, lt.parseDefaultAppearance)(this._defaultAppearance);
            }
            setTitle(Yt) {
              this._title = this._parseStringHelper(Yt);
            }
            setContents(Yt) {
              this._contents = this._parseStringHelper(Yt);
            }
            setModificationDate(Yt) {
              this.modificationDate = typeof Yt == "string" ? Yt : null;
            }
            setFlags(Yt) {
              this.flags = Number.isInteger(Yt) && Yt > 0 ? Yt : 0;
            }
            hasFlag(Yt) {
              return this._hasFlag(this.flags, Yt);
            }
            setRectangle(Yt) {
              this.rectangle = Array.isArray(Yt) && Yt.length === 4 ? rt.Util.normalizeRect(Yt) : [0, 0, 0, 0];
            }
            setColor(Yt) {
              this.color = bt(Yt);
            }
            setLineEndings(Yt) {
              if (this.lineEndings = ["None", "None"], Array.isArray(Yt) && Yt.length === 2)
                for (let Kt = 0; Kt < 2; Kt++) {
                  const nr = Yt[Kt];
                  if (nr instanceof et.Name)
                    switch (nr.name) {
                      case "None":
                        continue;
                      case "Square":
                      case "Circle":
                      case "Diamond":
                      case "OpenArrow":
                      case "ClosedArrow":
                      case "Butt":
                      case "ROpenArrow":
                      case "RClosedArrow":
                      case "Slash":
                        this.lineEndings[Kt] = nr.name;
                        continue;
                    }
                  (0, rt.warn)(`Ignoring invalid lineEnding: ${nr}`);
                }
            }
            setRotation(Yt, Kt) {
              this.rotation = 0;
              let nr = Yt instanceof et.Dict ? Yt.get("R") || 0 : Kt.get("Rotate") || 0;
              Number.isInteger(nr) && nr !== 0 && (nr %= 360, nr < 0 && (nr += 360), nr % 90 === 0 && (this.rotation = nr));
            }
            setBorderAndBackgroundColors(Yt) {
              Yt instanceof et.Dict ? (this.borderColor = bt(Yt.getArray("BC"), null), this.backgroundColor = bt(Yt.getArray("BG"), null)) : this.borderColor = this.backgroundColor = null;
            }
            setBorderStyle(Yt) {
              if (this.borderStyle = new Pt(), Yt instanceof et.Dict)
                if (Yt.has("BS")) {
                  const Kt = Yt.get("BS"), nr = Kt.get("Type");
                  (!nr || (0, et.isName)(nr, "Border")) && (this.borderStyle.setWidth(Kt.get("W"), this.rectangle), this.borderStyle.setStyle(Kt.get("S")), this.borderStyle.setDashArray(Kt.getArray("D")));
                } else if (Yt.has("Border")) {
                  const Kt = Yt.getArray("Border");
                  Array.isArray(Kt) && Kt.length >= 3 && (this.borderStyle.setHorizontalCornerRadius(Kt[0]), this.borderStyle.setVerticalCornerRadius(Kt[1]), this.borderStyle.setWidth(Kt[2], this.rectangle), Kt.length === 4 && this.borderStyle.setDashArray(Kt[3], !0));
                } else
                  this.borderStyle.setWidth(0);
            }
            setAppearance(Yt) {
              this.appearance = null;
              const Kt = Yt.get("AP");
              if (!(Kt instanceof et.Dict))
                return;
              const nr = Kt.get("N");
              if (nr instanceof ut.BaseStream) {
                this.appearance = nr;
                return;
              }
              if (!(nr instanceof et.Dict))
                return;
              const tr = Yt.get("AS");
              if (!(tr instanceof et.Name) || !nr.has(tr.name))
                return;
              const ir = nr.get(tr.name);
              ir instanceof ut.BaseStream && (this.appearance = ir);
            }
            setOptionalContent(Yt) {
              this.oc = null;
              const Kt = Yt.get("OC");
              Kt instanceof et.Name ? (0, rt.warn)("setOptionalContent: Support for /Name-entry is not implemented.") : Kt instanceof et.Dict && (this.oc = Kt);
            }
            loadResources(Yt, Kt) {
              return Kt.dict.getAsync("Resources").then((nr) => nr ? new mt.ObjectLoader(nr, Yt, nr.xref).load().then(function() {
                return nr;
              }) : void 0);
            }
            async getOperatorList(Yt, Kt, nr, tr, ir) {
              const sr = this.data;
              let cr = this.appearance;
              const or = !!(this.data.hasOwnCanvas && nr & rt.RenderingIntentFlag.DISPLAY);
              if (!cr) {
                if (!or)
                  return {
                    opList: new ct.OperatorList(),
                    separateForm: !1,
                    separateCanvas: !1
                  };
                cr = new it.StringStream(""), cr.dict = new et.Dict();
              }
              const Xt = cr.dict, Gt = await this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"], cr), Wt = Xt.getArray("BBox") || [0, 0, 1, 1], er = Xt.getArray("Matrix") || [1, 0, 0, 1, 0, 0], lr = Bt(sr.rect, Wt, er), ur = new ct.OperatorList();
              let pr;
              return this.oc && (pr = await Yt.parseMarkedContentProps(this.oc, null)), pr !== void 0 && ur.addOp(rt.OPS.beginMarkedContentProps, ["OC", pr]), ur.addOp(rt.OPS.beginAnnotation, [sr.id, sr.rect, lr, er, or]), await Yt.getOperatorList({
                stream: cr,
                task: Kt,
                resources: Gt,
                operatorList: ur,
                fallbackFontDict: this._fallbackFontDict
              }), ur.addOp(rt.OPS.endAnnotation, []), pr !== void 0 && ur.addOp(rt.OPS.endMarkedContent, []), this.reset(), {
                opList: ur,
                separateForm: !1,
                separateCanvas: or
              };
            }
            async save(Yt, Kt, nr) {
              return null;
            }
            get hasTextContent() {
              return !1;
            }
            async extractTextContent(Yt, Kt, nr) {
              if (!this.appearance)
                return;
              const tr = await this.loadResources(["ExtGState", "Font", "Properties", "XObject"], this.appearance), ir = [], sr = [];
              let cr = null;
              const or = {
                desiredSize: Math.Infinity,
                ready: !0,
                enqueue(Xt, Gt) {
                  for (const Wt of Xt.items)
                    Wt.str !== void 0 && (cr || (cr = Wt.transform.slice(-2)), sr.push(Wt.str), Wt.hasEOL && (ir.push(sr.join("")), sr.length = 0));
                }
              };
              if (await Yt.getTextContent({
                stream: this.appearance,
                task: Kt,
                resources: tr,
                includeMarkedContent: !0,
                sink: or,
                viewBox: nr
              }), this.reset(), sr.length && ir.push(sr.join("")), ir.length > 1 || ir[0]) {
                const Xt = this.appearance.dict, Gt = Xt.getArray("BBox") || [0, 0, 1, 1], Wt = Xt.getArray("Matrix") || [1, 0, 0, 1, 0, 0], er = this.data.rect, lr = Bt(er, Gt, Wt);
                lr[4] -= er[0], lr[5] -= er[1], cr = rt.Util.applyTransform(cr, lr), cr = rt.Util.applyTransform(cr, Wt), this.data.textPosition = cr, this.data.textContent = ir;
              }
            }
            getFieldObject() {
              return this.data.kidIds ? {
                id: this.data.id,
                actions: this.data.actions,
                name: this.data.fieldName,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                type: "",
                kidIds: this.data.kidIds,
                page: this.data.pageIndex,
                rotation: this.rotation
              } : null;
            }
            reset() {
              for (const Yt of this._streams)
                Yt.reset();
            }
            _constructFieldName(Yt) {
              if (!Yt.has("T") && !Yt.has("Parent"))
                return (0, rt.warn)("Unknown field name, falling back to empty field name."), "";
              if (!Yt.has("Parent"))
                return (0, rt.stringToPDFString)(Yt.get("T"));
              const Kt = [];
              Yt.has("T") && Kt.unshift((0, rt.stringToPDFString)(Yt.get("T")));
              let nr = Yt;
              const tr = new et.RefSet();
              for (Yt.objId && tr.put(Yt.objId); nr.has("Parent") && (nr = nr.get("Parent"), !(!(nr instanceof et.Dict) || nr.objId && tr.has(nr.objId))); )
                nr.objId && tr.put(nr.objId), nr.has("T") && Kt.unshift((0, rt.stringToPDFString)(nr.get("T")));
              return Kt.join(".");
            }
          }
          at.Annotation = Ot;
          class Pt {
            constructor() {
              this.width = 1, this.style = rt.AnnotationBorderStyleType.SOLID, this.dashArray = [3], this.horizontalCornerRadius = 0, this.verticalCornerRadius = 0;
            }
            setWidth(Yt) {
              let Kt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [0, 0, 0, 0];
              if (Yt instanceof et.Name) {
                this.width = 0;
                return;
              }
              if (typeof Yt == "number") {
                if (Yt > 0) {
                  const nr = (Kt[2] - Kt[0]) / 2, tr = (Kt[3] - Kt[1]) / 2;
                  nr > 0 && tr > 0 && (Yt > nr || Yt > tr) && ((0, rt.warn)(`AnnotationBorderStyle.setWidth - ignoring width: ${Yt}`), Yt = 1);
                }
                this.width = Yt;
              }
            }
            setStyle(Yt) {
              if (Yt instanceof et.Name)
                switch (Yt.name) {
                  case "S":
                    this.style = rt.AnnotationBorderStyleType.SOLID;
                    break;
                  case "D":
                    this.style = rt.AnnotationBorderStyleType.DASHED;
                    break;
                  case "B":
                    this.style = rt.AnnotationBorderStyleType.BEVELED;
                    break;
                  case "I":
                    this.style = rt.AnnotationBorderStyleType.INSET;
                    break;
                  case "U":
                    this.style = rt.AnnotationBorderStyleType.UNDERLINE;
                    break;
                }
            }
            setDashArray(Yt) {
              let Kt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
              if (Array.isArray(Yt) && Yt.length > 0) {
                let nr = !0, tr = !0;
                for (const ir of Yt)
                  if (+ir >= 0)
                    ir > 0 && (tr = !1);
                  else {
                    nr = !1;
                    break;
                  }
                nr && !tr ? (this.dashArray = Yt, Kt && this.setStyle(et.Name.get("D"))) : this.width = 0;
              } else
                Yt && (this.width = 0);
            }
            setHorizontalCornerRadius(Yt) {
              Number.isInteger(Yt) && (this.horizontalCornerRadius = Yt);
            }
            setVerticalCornerRadius(Yt) {
              Number.isInteger(Yt) && (this.verticalCornerRadius = Yt);
            }
          }
          at.AnnotationBorderStyle = Pt;
          class wt extends Ot {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt
              } = Yt;
              if (Kt.has("IRT")) {
                const tr = Kt.getRaw("IRT");
                this.data.inReplyTo = tr instanceof et.Ref ? tr.toString() : null;
                const ir = Kt.get("RT");
                this.data.replyType = ir instanceof et.Name ? ir.name : rt.AnnotationReplyType.REPLY;
              }
              let nr = null;
              if (this.data.replyType === rt.AnnotationReplyType.GROUP) {
                const tr = Kt.get("IRT");
                this.setTitle(tr.get("T")), this.data.titleObj = this._title, this.setContents(tr.get("Contents")), this.data.contentsObj = this._contents, tr.has("CreationDate") ? (this.setCreationDate(tr.get("CreationDate")), this.data.creationDate = this.creationDate) : this.data.creationDate = null, tr.has("M") ? (this.setModificationDate(tr.get("M")), this.data.modificationDate = this.modificationDate) : this.data.modificationDate = null, nr = tr.getRaw("Popup"), tr.has("C") ? (this.setColor(tr.getArray("C")), this.data.color = this.color) : this.data.color = null;
              } else
                this.data.titleObj = this._title, this.setCreationDate(Kt.get("CreationDate")), this.data.creationDate = this.creationDate, nr = Kt.getRaw("Popup"), Kt.has("C") || (this.data.color = null);
              this.data.popupRef = nr instanceof et.Ref ? nr.toString() : null, Kt.has("RC") && (this.data.richText = At.XFAFactory.getRichTextAsHtml(Kt.get("RC")));
            }
            setCreationDate(Yt) {
              this.creationDate = typeof Yt == "string" ? Yt : null;
            }
            _setDefaultAppearance(Yt) {
              let {
                xref: Kt,
                extra: nr,
                strokeColor: tr,
                fillColor: ir,
                blendMode: sr,
                strokeAlpha: cr,
                fillAlpha: or,
                pointsCallback: Xt
              } = Yt, Gt = Number.MAX_VALUE, Wt = Number.MAX_VALUE, er = Number.MIN_VALUE, lr = Number.MIN_VALUE;
              const ur = ["q"];
              nr && ur.push(nr), tr && ur.push(`${tr[0]} ${tr[1]} ${tr[2]} RG`), ir && ur.push(`${ir[0]} ${ir[1]} ${ir[2]} rg`);
              let pr = this.data.quadPoints;
              pr || (pr = [[{
                x: this.rectangle[0],
                y: this.rectangle[3]
              }, {
                x: this.rectangle[2],
                y: this.rectangle[3]
              }, {
                x: this.rectangle[0],
                y: this.rectangle[1]
              }, {
                x: this.rectangle[2],
                y: this.rectangle[1]
              }]]);
              for (const hr of pr) {
                const [vr, xr, Pr, Rr] = Xt(ur, hr);
                Gt = Math.min(Gt, vr), er = Math.max(er, xr), Wt = Math.min(Wt, Pr), lr = Math.max(lr, Rr);
              }
              ur.push("Q");
              const yr = new et.Dict(Kt), Er = new et.Dict(Kt);
              Er.set("Subtype", et.Name.get("Form"));
              const br = new it.StringStream(ur.join(" "));
              br.dict = Er, yr.set("Fm0", br);
              const gr = new et.Dict(Kt);
              sr && gr.set("BM", et.Name.get(sr)), typeof cr == "number" && gr.set("CA", cr), typeof or == "number" && gr.set("ca", or);
              const Ar = new et.Dict(Kt);
              Ar.set("GS0", gr);
              const Sr = new et.Dict(Kt);
              Sr.set("ExtGState", Ar), Sr.set("XObject", yr);
              const Br = new et.Dict(Kt);
              Br.set("Resources", Sr);
              const Ir = this.data.rect = [Gt, Wt, er, lr];
              Br.set("BBox", Ir), this.appearance = new it.StringStream("/GS0 gs /Fm0 Do"), this.appearance.dict = Br, this._streams.push(this.appearance, br);
            }
            static async createNewAnnotation(Yt, Kt, nr, tr) {
              const ir = Kt.ref || (Kt.ref = Yt.getNewTemporaryRef()), sr = await this.createNewAppearanceStream(Kt, Yt, tr), cr = [];
              let or;
              if (sr) {
                const Xt = Yt.getNewTemporaryRef();
                or = this.createNewDict(Kt, Yt, {
                  apRef: Xt
                }), await (0, vt.writeObject)(Xt, sr, cr, Yt), nr.push({
                  ref: Xt,
                  data: cr.join("")
                });
              } else
                or = this.createNewDict(Kt, Yt, {});
              return Number.isInteger(Kt.parentTreeId) && or.set("StructParent", Kt.parentTreeId), cr.length = 0, await (0, vt.writeObject)(ir, or, cr, Yt), {
                ref: ir,
                data: cr.join("")
              };
            }
            static async createNewPrintAnnotation(Yt, Kt, nr, tr) {
              const ir = await this.createNewAppearanceStream(nr, Kt, tr), sr = this.createNewDict(nr, Kt, {
                ap: ir
              }), cr = new this.prototype.constructor({
                dict: sr,
                xref: Kt,
                annotationGlobals: Yt,
                evaluatorOptions: tr.evaluatorOptions
              });
              return nr.ref && (cr.ref = cr.refToReplace = nr.ref), cr;
            }
          }
          at.MarkupAnnotation = wt;
          class Ct extends Ot {
            constructor(Yt) {
              var er;
              super(Yt);
              const {
                dict: Kt,
                xref: nr,
                annotationGlobals: tr
              } = Yt, ir = this.data;
              this._needAppearances = Yt.needAppearances, ir.annotationType = rt.AnnotationType.WIDGET, ir.fieldName === void 0 && (ir.fieldName = this._constructFieldName(Kt)), ir.actions === void 0 && (ir.actions = (0, st.collectActions)(nr, Kt, rt.AnnotationActionEventType));
              let sr = (0, st.getInheritableProperty)({
                dict: Kt,
                key: "V",
                getArray: !0
              });
              ir.fieldValue = this._decodeFormValue(sr);
              const cr = (0, st.getInheritableProperty)({
                dict: Kt,
                key: "DV",
                getArray: !0
              });
              if (ir.defaultFieldValue = this._decodeFormValue(cr), sr === void 0 && tr.xfaDatasets) {
                const lr = this._title.str;
                lr && (this._hasValueFromXFA = !0, ir.fieldValue = sr = tr.xfaDatasets.getValue(lr));
              }
              sr === void 0 && ir.defaultFieldValue !== null && (ir.fieldValue = ir.defaultFieldValue), ir.alternativeText = (0, rt.stringToPDFString)(Kt.get("TU") || ""), this.setDefaultAppearance(Yt), ir.hasAppearance || (ir.hasAppearance = this._needAppearances && ir.fieldValue !== void 0 && ir.fieldValue !== null);
              const or = (0, st.getInheritableProperty)({
                dict: Kt,
                key: "FT"
              });
              ir.fieldType = or instanceof et.Name ? or.name : null;
              const Xt = (0, st.getInheritableProperty)({
                dict: Kt,
                key: "DR"
              }), Gt = tr.acroForm.get("DR"), Wt = (er = this.appearance) == null ? void 0 : er.dict.get("Resources");
              this._fieldResources = {
                localResources: Xt,
                acroFormResources: Gt,
                appearanceResources: Wt,
                mergedResources: et.Dict.merge({
                  xref: nr,
                  dictArray: [Xt, Wt, Gt],
                  mergeSubDicts: !0
                })
              }, ir.fieldFlags = (0, st.getInheritableProperty)({
                dict: Kt,
                key: "Ff"
              }), (!Number.isInteger(ir.fieldFlags) || ir.fieldFlags < 0) && (ir.fieldFlags = 0), ir.readOnly = this.hasFieldFlag(rt.AnnotationFieldFlag.READONLY), ir.required = this.hasFieldFlag(rt.AnnotationFieldFlag.REQUIRED), ir.hidden = this._hasFlag(ir.annotationFlags, rt.AnnotationFlag.HIDDEN) || this._hasFlag(ir.annotationFlags, rt.AnnotationFlag.NOVIEW);
            }
            _decodeFormValue(Yt) {
              return Array.isArray(Yt) ? Yt.filter((Kt) => typeof Kt == "string").map((Kt) => (0, rt.stringToPDFString)(Kt)) : Yt instanceof et.Name ? (0, rt.stringToPDFString)(Yt.name) : typeof Yt == "string" ? (0, rt.stringToPDFString)(Yt) : null;
            }
            hasFieldFlag(Yt) {
              return !!(this.data.fieldFlags & Yt);
            }
            _isViewable(Yt) {
              return !this._hasFlag(Yt, rt.AnnotationFlag.INVISIBLE);
            }
            mustBeViewed(Yt, Kt) {
              return Kt ? this.viewable : super.mustBeViewed(Yt, Kt) && !this._hasFlag(this.flags, rt.AnnotationFlag.NOVIEW);
            }
            getRotationMatrix(Yt) {
              var ir;
              let Kt = (ir = Yt == null ? void 0 : Yt.get(this.data.id)) == null ? void 0 : ir.rotation;
              if (Kt === void 0 && (Kt = this.rotation), Kt === 0)
                return rt.IDENTITY_MATRIX;
              const nr = this.data.rect[2] - this.data.rect[0], tr = this.data.rect[3] - this.data.rect[1];
              return (0, st.getRotationMatrix)(Kt, nr, tr);
            }
            getBorderAndBackgroundAppearances(Yt) {
              var cr;
              let Kt = (cr = Yt == null ? void 0 : Yt.get(this.data.id)) == null ? void 0 : cr.rotation;
              if (Kt === void 0 && (Kt = this.rotation), !this.backgroundColor && !this.borderColor)
                return "";
              const nr = this.data.rect[2] - this.data.rect[0], tr = this.data.rect[3] - this.data.rect[1], ir = Kt === 0 || Kt === 180 ? `0 0 ${nr} ${tr} re` : `0 0 ${tr} ${nr} re`;
              let sr = "";
              if (this.backgroundColor && (sr = `${(0, lt.getPdfColor)(this.backgroundColor, !0)} ${ir} f `), this.borderColor) {
                const or = this.borderStyle.width || 1;
                sr += `${or} w ${(0, lt.getPdfColor)(this.borderColor, !1)} ${ir} S `;
              }
              return sr;
            }
            async getOperatorList(Yt, Kt, nr, tr, ir) {
              if (tr && !(this instanceof kt) && !this.data.noHTML && !this.data.hasOwnCanvas)
                return {
                  opList: new ct.OperatorList(),
                  separateForm: !0,
                  separateCanvas: !1
                };
              if (!this._hasText)
                return super.getOperatorList(Yt, Kt, nr, tr, ir);
              const sr = await this._getAppearance(Yt, Kt, nr, ir);
              if (this.appearance && sr === null)
                return super.getOperatorList(Yt, Kt, nr, tr, ir);
              const cr = new ct.OperatorList();
              if (!this._defaultAppearance || sr === null)
                return {
                  opList: cr,
                  separateForm: !1,
                  separateCanvas: !1
                };
              const or = !!(this.data.hasOwnCanvas && nr & rt.RenderingIntentFlag.DISPLAY), Xt = [1, 0, 0, 1, 0, 0], Gt = [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]], Wt = Bt(this.data.rect, Gt, Xt);
              let er;
              this.oc && (er = await Yt.parseMarkedContentProps(this.oc, null)), er !== void 0 && cr.addOp(rt.OPS.beginMarkedContentProps, ["OC", er]), cr.addOp(rt.OPS.beginAnnotation, [this.data.id, this.data.rect, Wt, this.getRotationMatrix(ir), or]);
              const lr = new it.StringStream(sr);
              return await Yt.getOperatorList({
                stream: lr,
                task: Kt,
                resources: this._fieldResources.mergedResources,
                operatorList: cr
              }), cr.addOp(rt.OPS.endAnnotation, []), er !== void 0 && cr.addOp(rt.OPS.endMarkedContent, []), {
                opList: cr,
                separateForm: !1,
                separateCanvas: or
              };
            }
            _getMKDict(Yt) {
              const Kt = new et.Dict(null);
              return Yt && Kt.set("R", Yt), this.borderColor && Kt.set("BC", Et(this.borderColor)), this.backgroundColor && Kt.set("BG", Et(this.backgroundColor)), Kt.size > 0 ? Kt : null;
            }
            amendSavedDict(Yt, Kt) {
            }
            async save(Yt, Kt, nr) {
              const tr = nr == null ? void 0 : nr.get(this.data.id);
              let ir = tr == null ? void 0 : tr.value, sr = tr == null ? void 0 : tr.rotation;
              if (ir === this.data.fieldValue || ir === void 0) {
                if (!this._hasValueFromXFA && sr === void 0)
                  return null;
                ir || (ir = this.data.fieldValue);
              }
              if (sr === void 0 && !this._hasValueFromXFA && Array.isArray(ir) && Array.isArray(this.data.fieldValue) && ir.length === this.data.fieldValue.length && ir.every((Er, br) => Er === this.data.fieldValue[br]))
                return null;
              sr === void 0 && (sr = this.rotation);
              let cr = null;
              if (!this._needAppearances && (cr = await this._getAppearance(Yt, Kt, rt.RenderingIntentFlag.SAVE, nr), cr === null))
                return null;
              let or = !1;
              cr != null && cr.needAppearances && (or = !0, cr = null);
              const {
                xref: Xt
              } = Yt, Gt = Xt.fetchIfRef(this.ref);
              if (!(Gt instanceof et.Dict))
                return null;
              const Wt = new et.Dict(Xt);
              for (const Er of Gt.getKeys())
                Er !== "AP" && Wt.set(Er, Gt.getRaw(Er));
              const er = {
                path: this.data.fieldName,
                value: ir
              }, lr = (Er) => (0, st.isAscii)(Er) ? Er : (0, st.stringToUTF16String)(Er, !0);
              Wt.set("V", Array.isArray(ir) ? ir.map(lr) : lr(ir)), this.amendSavedDict(nr, Wt);
              const ur = this._getMKDict(sr);
              ur && Wt.set("MK", ur);
              const pr = [], yr = [{
                ref: this.ref,
                data: "",
                xfa: er,
                needAppearances: or
              }];
              if (cr !== null) {
                const Er = Xt.getNewTemporaryRef(), br = new et.Dict(Xt);
                Wt.set("AP", br), br.set("N", Er);
                const gr = this._getSaveFieldResources(Xt), Ar = new it.StringStream(cr), Sr = Ar.dict = new et.Dict(Xt);
                Sr.set("Subtype", et.Name.get("Form")), Sr.set("Resources", gr), Sr.set("BBox", [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]]);
                const Br = this.getRotationMatrix(nr);
                Br !== rt.IDENTITY_MATRIX && Sr.set("Matrix", Br), await (0, vt.writeObject)(Er, Ar, pr, Xt), yr.push({
                  ref: Er,
                  data: pr.join(""),
                  xfa: null,
                  needAppearances: !1
                }), pr.length = 0;
              }
              return Wt.set("M", `D:${(0, rt.getModificationDate)()}`), await (0, vt.writeObject)(this.ref, Wt, pr, Xt), yr[0].data = pr.join(""), yr;
            }
            async _getAppearance(Yt, Kt, nr, tr) {
              if (this.hasFieldFlag(rt.AnnotationFieldFlag.PASSWORD))
                return null;
              const sr = tr == null ? void 0 : tr.get(this.data.id);
              let cr, or;
              if (sr && (cr = sr.formattedValue || sr.value, or = sr.rotation), or === void 0 && cr === void 0 && !this._needAppearances && (!this._hasValueFromXFA || this.appearance))
                return null;
              const Xt = this.getBorderAndBackgroundAppearances(tr);
              if (cr === void 0 && (cr = this.data.fieldValue, !cr))
                return `/Tx BMC q ${Xt}Q EMC`;
              if (Array.isArray(cr) && cr.length === 1 && (cr = cr[0]), (0, rt.assert)(typeof cr == "string", "Expected `value` to be a string."), cr = cr.trim(), this.data.combo) {
                const Rr = this.data.options.find((Dr) => {
                  let {
                    exportValue: Gr
                  } = Dr;
                  return cr === Gr;
                });
                cr = (Rr == null ? void 0 : Rr.displayValue) || cr;
              }
              if (cr === "")
                return `/Tx BMC q ${Xt}Q EMC`;
              or === void 0 && (or = this.rotation);
              let Gt = -1, Wt;
              this.data.multiLine ? (Wt = cr.split(/\r\n?|\n/).map((Rr) => Rr.normalize("NFC")), Gt = Wt.length) : Wt = [cr.replace(/\r\n?|\n/, "").normalize("NFC")];
              const er = 1, lr = 2;
              let ur = this.data.rect[3] - this.data.rect[1], pr = this.data.rect[2] - this.data.rect[0];
              (or === 90 || or === 270) && ([pr, ur] = [ur, pr]), this._defaultAppearance || (this.data.defaultAppearanceData = (0, lt.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
              let yr = await Ct._getFontData(Yt, Kt, this.data.defaultAppearanceData, this._fieldResources.mergedResources), Er, br, gr;
              const Ar = [];
              let Sr = !1;
              for (const Rr of Wt) {
                const Dr = yr.encodeString(Rr);
                Dr.length > 1 && (Sr = !0), Ar.push(Dr.join(""));
              }
              if (Sr && nr & rt.RenderingIntentFlag.SAVE)
                return {
                  needAppearances: !0
                };
              if (Sr && this._isOffscreenCanvasSupported) {
                const Rr = this.data.comb ? "monospace" : "sans-serif", Dr = new lt.FakeUnicodeFont(Yt.xref, Rr), Gr = Dr.createFontResources(Wt.join("")), Or = Gr.getRaw("Font");
                if (this._fieldResources.mergedResources.has("Font")) {
                  const Tr = this._fieldResources.mergedResources.get("Font");
                  for (const fr of Or.getKeys())
                    Tr.set(fr, Or.getRaw(fr));
                } else
                  this._fieldResources.mergedResources.set("Font", Or);
                const Hr = Dr.fontName.name;
                yr = await Ct._getFontData(Yt, Kt, {
                  fontName: Hr,
                  fontSize: 0
                }, Gr);
                for (let Tr = 0, fr = Ar.length; Tr < fr; Tr++)
                  Ar[Tr] = (0, st.stringToUTF16String)(Wt[Tr]);
                const jr = Object.assign(/* @__PURE__ */ Object.create(null), this.data.defaultAppearanceData);
                this.data.defaultAppearanceData.fontSize = 0, this.data.defaultAppearanceData.fontName = Hr, [Er, br, gr] = this._computeFontSize(ur - 2 * er, pr - 2 * lr, cr, yr, Gt), this.data.defaultAppearanceData = jr;
              } else
                this._isOffscreenCanvasSupported || (0, rt.warn)("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly."), [Er, br, gr] = this._computeFontSize(ur - 2 * er, pr - 2 * lr, cr, yr, Gt);
              let Br = yr.descent;
              isNaN(Br) ? Br = rt.BASELINE_FACTOR * gr : Br = Math.max(rt.BASELINE_FACTOR * gr, Math.abs(Br) * br);
              const Ir = Math.min(Math.floor((ur - br) / 2), er), hr = this.data.textAlignment;
              if (this.data.multiLine)
                return this._getMultilineAppearance(Er, Ar, yr, br, pr, ur, hr, lr, Ir, Br, gr, tr);
              if (this.data.comb)
                return this._getCombAppearance(Er, yr, Ar[0], br, pr, ur, lr, Ir, Br, gr, tr);
              const vr = Ir + Br;
              if (hr === 0 || hr > 2)
                return `/Tx BMC q ${Xt}BT ` + Er + ` 1 0 0 1 ${(0, st.numberToString)(lr)} ${(0, st.numberToString)(vr)} Tm (${(0, st.escapeString)(Ar[0])}) Tj ET Q EMC`;
              const xr = {
                shift: 0
              }, Pr = this._renderText(Ar[0], yr, br, pr, hr, xr, lr, vr);
              return `/Tx BMC q ${Xt}BT ` + Er + ` 1 0 0 1 0 0 Tm ${Pr} ET Q EMC`;
            }
            static async _getFontData(Yt, Kt, nr, tr) {
              const ir = new ct.OperatorList(), sr = {
                font: null,
                clone() {
                  return this;
                }
              }, {
                fontName: cr,
                fontSize: or
              } = nr;
              return await Yt.handleSetFont(tr, [cr && et.Name.get(cr), or], null, ir, Kt, sr, null), sr.font;
            }
            _getTextWidth(Yt, Kt) {
              return Kt.charsToGlyphs(Yt).reduce((nr, tr) => nr + tr.width, 0) / 1e3;
            }
            _computeFontSize(Yt, Kt, nr, tr, ir) {
              let {
                fontSize: sr
              } = this.data.defaultAppearanceData, cr = (sr || 12) * rt.LINE_FACTOR, or = Math.round(Yt / cr);
              if (!sr) {
                const Xt = (er) => Math.floor(er * 100) / 100;
                if (ir === -1) {
                  const er = this._getTextWidth(nr, tr);
                  sr = Xt(Math.min(Yt / rt.LINE_FACTOR, er > Kt ? Kt / er : 1 / 0)), or = 1;
                } else {
                  const er = nr.split(/\r\n?|\n/), lr = [];
                  for (const pr of er) {
                    const yr = tr.encodeString(pr).join(""), Er = tr.charsToGlyphs(yr), br = tr.getCharPositions(yr);
                    lr.push({
                      line: yr,
                      glyphs: Er,
                      positions: br
                    });
                  }
                  const ur = (pr) => {
                    let yr = 0;
                    for (const Er of lr) {
                      const br = this._splitLine(null, tr, pr, Kt, Er);
                      if (yr += br.length * pr, yr > Yt)
                        return !0;
                    }
                    return !1;
                  };
                  for (or = Math.max(or, ir); ; ) {
                    if (cr = Yt / or, sr = Xt(cr / rt.LINE_FACTOR), ur(sr)) {
                      or++;
                      continue;
                    }
                    break;
                  }
                }
                const {
                  fontName: Gt,
                  fontColor: Wt
                } = this.data.defaultAppearanceData;
                this._defaultAppearance = (0, lt.createDefaultAppearance)({
                  fontSize: sr,
                  fontName: Gt,
                  fontColor: Wt
                });
              }
              return [this._defaultAppearance, sr, Yt / or];
            }
            _renderText(Yt, Kt, nr, tr, ir, sr, cr, or) {
              let Xt;
              if (ir === 1) {
                const Wt = this._getTextWidth(Yt, Kt) * nr;
                Xt = (tr - Wt) / 2;
              } else if (ir === 2) {
                const Wt = this._getTextWidth(Yt, Kt) * nr;
                Xt = tr - Wt - cr;
              } else
                Xt = cr;
              const Gt = (0, st.numberToString)(Xt - sr.shift);
              return sr.shift = Xt, or = (0, st.numberToString)(or), `${Gt} ${or} Td (${(0, st.escapeString)(Yt)}) Tj`;
            }
            _getSaveFieldResources(Yt) {
              var sr;
              const {
                localResources: Kt,
                appearanceResources: nr,
                acroFormResources: tr
              } = this._fieldResources, ir = (sr = this.data.defaultAppearanceData) == null ? void 0 : sr.fontName;
              if (!ir)
                return Kt || et.Dict.empty;
              for (const cr of [Kt, nr])
                if (cr instanceof et.Dict) {
                  const or = cr.get("Font");
                  if (or instanceof et.Dict && or.has(ir))
                    return cr;
                }
              if (tr instanceof et.Dict) {
                const cr = tr.get("Font");
                if (cr instanceof et.Dict && cr.has(ir)) {
                  const or = new et.Dict(Yt);
                  or.set(ir, cr.getRaw(ir));
                  const Xt = new et.Dict(Yt);
                  return Xt.set("Font", or), et.Dict.merge({
                    xref: Yt,
                    dictArray: [Xt, Kt],
                    mergeSubDicts: !0
                  });
                }
              }
              return Kt || et.Dict.empty;
            }
            getFieldObject() {
              return null;
            }
          }
          class It extends Ct {
            constructor(Yt) {
              super(Yt), this.data.hasOwnCanvas = this.data.readOnly && !this.data.noHTML, this._hasText = !0;
              const Kt = Yt.dict;
              typeof this.data.fieldValue != "string" && (this.data.fieldValue = "");
              let nr = (0, st.getInheritableProperty)({
                dict: Kt,
                key: "Q"
              });
              (!Number.isInteger(nr) || nr < 0 || nr > 2) && (nr = null), this.data.textAlignment = nr;
              let tr = (0, st.getInheritableProperty)({
                dict: Kt,
                key: "MaxLen"
              });
              (!Number.isInteger(tr) || tr < 0) && (tr = 0), this.data.maxLen = tr, this.data.multiLine = this.hasFieldFlag(rt.AnnotationFieldFlag.MULTILINE), this.data.comb = this.hasFieldFlag(rt.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(rt.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(rt.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(rt.AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== 0, this.data.doNotScroll = this.hasFieldFlag(rt.AnnotationFieldFlag.DONOTSCROLL);
            }
            get hasTextContent() {
              return !!this.appearance && !this._needAppearances;
            }
            _getCombAppearance(Yt, Kt, nr, tr, ir, sr, cr, or, Xt, Gt, Wt) {
              const er = ir / this.data.maxLen, lr = this.getBorderAndBackgroundAppearances(Wt), ur = [], pr = Kt.getCharPositions(nr);
              for (const [Er, br] of pr)
                ur.push(`(${(0, st.escapeString)(nr.substring(Er, br))}) Tj`);
              const yr = ur.join(` ${(0, st.numberToString)(er)} 0 Td `);
              return `/Tx BMC q ${lr}BT ` + Yt + ` 1 0 0 1 ${(0, st.numberToString)(cr)} ${(0, st.numberToString)(or + Xt)} Tm ${yr} ET Q EMC`;
            }
            _getMultilineAppearance(Yt, Kt, nr, tr, ir, sr, cr, or, Xt, Gt, Wt, er) {
              const lr = [], ur = ir - 2 * or, pr = {
                shift: 0
              };
              for (let br = 0, gr = Kt.length; br < gr; br++) {
                const Ar = Kt[br], Sr = this._splitLine(Ar, nr, tr, ur);
                for (let Br = 0, Ir = Sr.length; Br < Ir; Br++) {
                  const hr = Sr[Br], vr = br === 0 && Br === 0 ? -Xt - (Wt - Gt) : -Wt;
                  lr.push(this._renderText(hr, nr, tr, ir, cr, pr, or, vr));
                }
              }
              const yr = this.getBorderAndBackgroundAppearances(er), Er = lr.join(`
`);
              return `/Tx BMC q ${yr}BT ` + Yt + ` 1 0 0 1 0 ${(0, st.numberToString)(sr)} Tm ${Er} ET Q EMC`;
            }
            _splitLine(Yt, Kt, nr, tr) {
              let ir = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
              Yt = ir.line || Yt;
              const sr = ir.glyphs || Kt.charsToGlyphs(Yt);
              if (sr.length <= 1)
                return [Yt];
              const cr = ir.positions || Kt.getCharPositions(Yt), or = nr / 1e3, Xt = [];
              let Gt = -1, Wt = -1, er = -1, lr = 0, ur = 0;
              for (let pr = 0, yr = sr.length; pr < yr; pr++) {
                const [Er, br] = cr[pr], gr = sr[pr], Ar = gr.width * or;
                gr.unicode === " " ? ur + Ar > tr ? (Xt.push(Yt.substring(lr, Er)), lr = Er, ur = Ar, Gt = -1, er = -1) : (ur += Ar, Gt = Er, Wt = br, er = pr) : ur + Ar > tr ? Gt !== -1 ? (Xt.push(Yt.substring(lr, Wt)), lr = Wt, pr = er + 1, Gt = -1, ur = 0) : (Xt.push(Yt.substring(lr, Er)), lr = Er, ur = Ar) : ur += Ar;
              }
              return lr < Yt.length && Xt.push(Yt.substring(lr, Yt.length)), Xt;
            }
            getFieldObject() {
              return {
                id: this.data.id,
                value: this.data.fieldValue,
                defaultValue: this.data.defaultFieldValue || "",
                multiline: this.data.multiLine,
                password: this.hasFieldFlag(rt.AnnotationFieldFlag.PASSWORD),
                charLimit: this.data.maxLen,
                comb: this.data.comb,
                editable: !this.data.readOnly,
                hidden: this.data.hidden,
                name: this.data.fieldName,
                rect: this.data.rect,
                actions: this.data.actions,
                page: this.data.pageIndex,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                rotation: this.rotation,
                type: "text"
              };
            }
          }
          class yt extends Ct {
            constructor(Yt) {
              super(Yt), this.checkedAppearance = null, this.uncheckedAppearance = null, this.data.checkBox = !this.hasFieldFlag(rt.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(rt.AnnotationFieldFlag.PUSHBUTTON), this.data.radioButton = this.hasFieldFlag(rt.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(rt.AnnotationFieldFlag.PUSHBUTTON), this.data.pushButton = this.hasFieldFlag(rt.AnnotationFieldFlag.PUSHBUTTON), this.data.isTooltipOnly = !1, this.data.checkBox ? this._processCheckBox(Yt) : this.data.radioButton ? this._processRadioButton(Yt) : this.data.pushButton ? (this.data.hasOwnCanvas = !0, this._processPushButton(Yt)) : (0, rt.warn)("Invalid field flags for button widget annotation");
            }
            async getOperatorList(Yt, Kt, nr, tr, ir) {
              if (this.data.pushButton)
                return super.getOperatorList(Yt, Kt, nr, !1, ir);
              let sr = null, cr = null;
              if (ir) {
                const Xt = ir.get(this.data.id);
                sr = Xt ? Xt.value : null, cr = Xt ? Xt.rotation : null;
              }
              if (sr === null && this.appearance)
                return super.getOperatorList(Yt, Kt, nr, tr, ir);
              sr == null && (sr = this.data.checkBox ? this.data.fieldValue === this.data.exportValue : this.data.fieldValue === this.data.buttonValue);
              const or = sr ? this.checkedAppearance : this.uncheckedAppearance;
              if (or) {
                const Xt = this.appearance, Gt = or.dict.getArray("Matrix") || rt.IDENTITY_MATRIX;
                cr && or.dict.set("Matrix", this.getRotationMatrix(ir)), this.appearance = or;
                const Wt = super.getOperatorList(Yt, Kt, nr, tr, ir);
                return this.appearance = Xt, or.dict.set("Matrix", Gt), Wt;
              }
              return {
                opList: new ct.OperatorList(),
                separateForm: !1,
                separateCanvas: !1
              };
            }
            async save(Yt, Kt, nr) {
              return this.data.checkBox ? this._saveCheckbox(Yt, Kt, nr) : this.data.radioButton ? this._saveRadioButton(Yt, Kt, nr) : null;
            }
            async _saveCheckbox(Yt, Kt, nr) {
              if (!nr)
                return null;
              const tr = nr.get(this.data.id);
              let ir = tr == null ? void 0 : tr.rotation, sr = tr == null ? void 0 : tr.value;
              if (ir === void 0 && (sr === void 0 || this.data.fieldValue === this.data.exportValue === sr))
                return null;
              const cr = Yt.xref.fetchIfRef(this.ref);
              if (!(cr instanceof et.Dict))
                return null;
              ir === void 0 && (ir = this.rotation), sr === void 0 && (sr = this.data.fieldValue === this.data.exportValue);
              const or = {
                path: this.data.fieldName,
                value: sr ? this.data.exportValue : ""
              }, Xt = et.Name.get(sr ? this.data.exportValue : "Off");
              cr.set("V", Xt), cr.set("AS", Xt), cr.set("M", `D:${(0, rt.getModificationDate)()}`);
              const Gt = this._getMKDict(ir);
              Gt && cr.set("MK", Gt);
              const Wt = [];
              return await (0, vt.writeObject)(this.ref, cr, Wt, Yt.xref), [{
                ref: this.ref,
                data: Wt.join(""),
                xfa: or
              }];
            }
            async _saveRadioButton(Yt, Kt, nr) {
              if (!nr)
                return null;
              const tr = nr.get(this.data.id);
              let ir = tr == null ? void 0 : tr.rotation, sr = tr == null ? void 0 : tr.value;
              if (ir === void 0 && (sr === void 0 || this.data.fieldValue === this.data.buttonValue === sr))
                return null;
              const cr = Yt.xref.fetchIfRef(this.ref);
              if (!(cr instanceof et.Dict))
                return null;
              sr === void 0 && (sr = this.data.fieldValue === this.data.buttonValue), ir === void 0 && (ir = this.rotation);
              const or = {
                path: this.data.fieldName,
                value: sr ? this.data.buttonValue : ""
              }, Xt = et.Name.get(sr ? this.data.buttonValue : "Off"), Gt = [];
              let Wt = null;
              if (sr)
                if (this.parent instanceof et.Ref) {
                  const ur = Yt.xref.fetch(this.parent);
                  ur.set("V", Xt), await (0, vt.writeObject)(this.parent, ur, Gt, Yt.xref), Wt = Gt.join(""), Gt.length = 0;
                } else
                  this.parent instanceof et.Dict && this.parent.set("V", Xt);
              cr.set("AS", Xt), cr.set("M", `D:${(0, rt.getModificationDate)()}`);
              const er = this._getMKDict(ir);
              er && cr.set("MK", er), await (0, vt.writeObject)(this.ref, cr, Gt, Yt.xref);
              const lr = [{
                ref: this.ref,
                data: Gt.join(""),
                xfa: or
              }];
              return Wt && lr.push({
                ref: this.parent,
                data: Wt,
                xfa: null
              }), lr;
            }
            _getDefaultCheckedAppearance(Yt, Kt) {
              const nr = this.data.rect[2] - this.data.rect[0], tr = this.data.rect[3] - this.data.rect[1], ir = [0, 0, nr, tr], sr = 0.8, cr = Math.min(nr, tr) * sr;
              let or, Xt;
              Kt === "check" ? (or = {
                width: 0.755 * cr,
                height: 0.705 * cr
              }, Xt = "3") : Kt === "disc" ? (or = {
                width: 0.791 * cr,
                height: 0.705 * cr
              }, Xt = "l") : (0, rt.unreachable)(`_getDefaultCheckedAppearance - unsupported type: ${Kt}`);
              const Gt = (0, st.numberToString)((nr - or.width) / 2), Wt = (0, st.numberToString)((tr - or.height) / 2), er = `q BT /PdfJsZaDb ${cr} Tf 0 g ${Gt} ${Wt} Td (${Xt}) Tj ET Q`, lr = new et.Dict(Yt.xref);
              lr.set("FormType", 1), lr.set("Subtype", et.Name.get("Form")), lr.set("Type", et.Name.get("XObject")), lr.set("BBox", ir), lr.set("Matrix", [1, 0, 0, 1, 0, 0]), lr.set("Length", er.length);
              const ur = new et.Dict(Yt.xref), pr = new et.Dict(Yt.xref);
              pr.set("PdfJsZaDb", this.fallbackFontDict), ur.set("Font", pr), lr.set("Resources", ur), this.checkedAppearance = new it.StringStream(er), this.checkedAppearance.dict = lr, this._streams.push(this.checkedAppearance);
            }
            _processCheckBox(Yt) {
              const Kt = Yt.dict.get("AP");
              if (!(Kt instanceof et.Dict))
                return;
              const nr = Kt.get("N");
              if (!(nr instanceof et.Dict))
                return;
              const tr = this._decodeFormValue(Yt.dict.get("AS"));
              typeof tr == "string" && (this.data.fieldValue = tr);
              const ir = this.data.fieldValue !== null && this.data.fieldValue !== "Off" ? this.data.fieldValue : "Yes", sr = nr.getKeys();
              if (sr.length === 0)
                sr.push("Off", ir);
              else if (sr.length === 1)
                sr[0] === "Off" ? sr.push(ir) : sr.unshift("Off");
              else if (sr.includes(ir))
                sr.length = 0, sr.push("Off", ir);
              else {
                const Xt = sr.find((Gt) => Gt !== "Off");
                sr.length = 0, sr.push("Off", Xt);
              }
              sr.includes(this.data.fieldValue) || (this.data.fieldValue = "Off"), this.data.exportValue = sr[1];
              const cr = nr.get(this.data.exportValue);
              this.checkedAppearance = cr instanceof ut.BaseStream ? cr : null;
              const or = nr.get("Off");
              this.uncheckedAppearance = or instanceof ut.BaseStream ? or : null, this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(Yt, "check"), this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance), this._fallbackFontDict = this.fallbackFontDict, this.data.defaultFieldValue === null && (this.data.defaultFieldValue = "Off");
            }
            _processRadioButton(Yt) {
              this.data.fieldValue = this.data.buttonValue = null;
              const Kt = Yt.dict.get("Parent");
              if (Kt instanceof et.Dict) {
                this.parent = Yt.dict.getRaw("Parent");
                const cr = Kt.get("V");
                cr instanceof et.Name && (this.data.fieldValue = this._decodeFormValue(cr));
              }
              const nr = Yt.dict.get("AP");
              if (!(nr instanceof et.Dict))
                return;
              const tr = nr.get("N");
              if (!(tr instanceof et.Dict))
                return;
              for (const cr of tr.getKeys())
                if (cr !== "Off") {
                  this.data.buttonValue = this._decodeFormValue(cr);
                  break;
                }
              const ir = tr.get(this.data.buttonValue);
              this.checkedAppearance = ir instanceof ut.BaseStream ? ir : null;
              const sr = tr.get("Off");
              this.uncheckedAppearance = sr instanceof ut.BaseStream ? sr : null, this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(Yt, "disc"), this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance), this._fallbackFontDict = this.fallbackFontDict, this.data.defaultFieldValue === null && (this.data.defaultFieldValue = "Off");
            }
            _processPushButton(Yt) {
              const {
                dict: Kt,
                annotationGlobals: nr
              } = Yt;
              if (!Kt.has("A") && !Kt.has("AA") && !this.data.alternativeText) {
                (0, rt.warn)("Push buttons without action dictionaries are not supported");
                return;
              }
              this.data.isTooltipOnly = !Kt.has("A") && !Kt.has("AA"), ht.Catalog.parseDestDictionary({
                destDict: Kt,
                resultObj: this.data,
                docBaseUrl: nr.baseUrl,
                docAttachments: nr.attachments
              });
            }
            getFieldObject() {
              let Yt = "button", Kt;
              return this.data.checkBox ? (Yt = "checkbox", Kt = this.data.exportValue) : this.data.radioButton && (Yt = "radiobutton", Kt = this.data.buttonValue), {
                id: this.data.id,
                value: this.data.fieldValue || "Off",
                defaultValue: this.data.defaultFieldValue,
                exportValues: Kt,
                editable: !this.data.readOnly,
                name: this.data.fieldName,
                rect: this.data.rect,
                hidden: this.data.hidden,
                actions: this.data.actions,
                page: this.data.pageIndex,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                rotation: this.rotation,
                type: Yt
              };
            }
            get fallbackFontDict() {
              const Yt = new et.Dict();
              return Yt.set("BaseFont", et.Name.get("ZapfDingbats")), Yt.set("Type", et.Name.get("FallbackType")), Yt.set("Subtype", et.Name.get("FallbackType")), Yt.set("Encoding", et.Name.get("ZapfDingbatsEncoding")), (0, rt.shadow)(this, "fallbackFontDict", Yt);
            }
          }
          class Rt extends Ct {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt,
                xref: nr
              } = Yt;
              this.indices = Kt.getArray("I"), this.hasIndices = Array.isArray(this.indices) && this.indices.length > 0, this.data.options = [];
              const tr = (0, st.getInheritableProperty)({
                dict: Kt,
                key: "Opt"
              });
              if (Array.isArray(tr))
                for (let ir = 0, sr = tr.length; ir < sr; ir++) {
                  const cr = nr.fetchIfRef(tr[ir]), or = Array.isArray(cr);
                  this.data.options[ir] = {
                    exportValue: this._decodeFormValue(or ? nr.fetchIfRef(cr[0]) : cr),
                    displayValue: this._decodeFormValue(or ? nr.fetchIfRef(cr[1]) : cr)
                  };
                }
              if (!this.hasIndices)
                typeof this.data.fieldValue == "string" ? this.data.fieldValue = [this.data.fieldValue] : this.data.fieldValue || (this.data.fieldValue = []);
              else {
                this.data.fieldValue = [];
                const ir = this.data.options.length;
                for (const sr of this.indices)
                  Number.isInteger(sr) && sr >= 0 && sr < ir && this.data.fieldValue.push(this.data.options[sr].exportValue);
              }
              this.data.combo = this.hasFieldFlag(rt.AnnotationFieldFlag.COMBO), this.data.multiSelect = this.hasFieldFlag(rt.AnnotationFieldFlag.MULTISELECT), this._hasText = !0;
            }
            getFieldObject() {
              const Yt = this.data.combo ? "combobox" : "listbox", Kt = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
              return {
                id: this.data.id,
                value: Kt,
                defaultValue: this.data.defaultFieldValue,
                editable: !this.data.readOnly,
                name: this.data.fieldName,
                rect: this.data.rect,
                numItems: this.data.fieldValue.length,
                multipleSelection: this.data.multiSelect,
                hidden: this.data.hidden,
                actions: this.data.actions,
                items: this.data.options,
                page: this.data.pageIndex,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                rotation: this.rotation,
                type: Yt
              };
            }
            amendSavedDict(Yt, Kt) {
              var sr;
              if (!this.hasIndices)
                return;
              let nr = (sr = Yt == null ? void 0 : Yt.get(this.data.id)) == null ? void 0 : sr.value;
              Array.isArray(nr) || (nr = [nr]);
              const tr = [], {
                options: ir
              } = this.data;
              for (let cr = 0, or = 0, Xt = ir.length; cr < Xt; cr++)
                ir[cr].exportValue === nr[or] && (tr.push(cr), or += 1);
              Kt.set("I", tr);
            }
            async _getAppearance(Yt, Kt, nr, tr) {
              if (this.data.combo)
                return super._getAppearance(Yt, Kt, nr, tr);
              let ir, sr;
              const cr = tr == null ? void 0 : tr.get(this.data.id);
              if (cr && (sr = cr.rotation, ir = cr.value), sr === void 0 && ir === void 0 && !this._needAppearances)
                return null;
              ir === void 0 ? ir = this.data.fieldValue : Array.isArray(ir) || (ir = [ir]);
              const or = 1, Xt = 2;
              let Gt = this.data.rect[3] - this.data.rect[1], Wt = this.data.rect[2] - this.data.rect[0];
              (sr === 90 || sr === 270) && ([Wt, Gt] = [Gt, Wt]);
              const er = this.data.options.length, lr = [];
              for (let hr = 0; hr < er; hr++) {
                const {
                  exportValue: vr
                } = this.data.options[hr];
                ir.includes(vr) && lr.push(hr);
              }
              this._defaultAppearance || (this.data.defaultAppearanceData = (0, lt.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
              const ur = await Ct._getFontData(Yt, Kt, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
              let pr, {
                fontSize: yr
              } = this.data.defaultAppearanceData;
              if (yr)
                pr = this._defaultAppearance;
              else {
                const hr = (Gt - or) / er;
                let vr = -1, xr;
                for (const {
                  displayValue: Pr
                } of this.data.options) {
                  const Rr = this._getTextWidth(Pr, ur);
                  Rr > vr && (vr = Rr, xr = Pr);
                }
                [pr, yr] = this._computeFontSize(hr, Wt - 2 * Xt, xr, ur, -1);
              }
              const Er = yr * rt.LINE_FACTOR, br = (Er - yr) / 2, gr = Math.floor(Gt / Er);
              let Ar = 0;
              if (lr.length > 0) {
                const hr = Math.min(...lr), vr = Math.max(...lr);
                Ar = Math.max(0, vr - gr + 1), Ar > hr && (Ar = hr);
              }
              const Sr = Math.min(Ar + gr + 1, er), Br = ["/Tx BMC q", `1 1 ${Wt} ${Gt} re W n`];
              if (lr.length) {
                Br.push("0.600006 0.756866 0.854904 rg");
                for (const hr of lr)
                  Ar <= hr && hr < Sr && Br.push(`1 ${Gt - (hr - Ar + 1) * Er} ${Wt} ${Er} re f`);
              }
              Br.push("BT", pr, `1 0 0 1 0 ${Gt} Tm`);
              const Ir = {
                shift: 0
              };
              for (let hr = Ar; hr < Sr; hr++) {
                const {
                  displayValue: vr
                } = this.data.options[hr], xr = hr === Ar ? br : 0;
                Br.push(this._renderText(vr, ur, yr, Wt, 0, Ir, Xt, -Er + xr));
              }
              return Br.push("ET Q EMC"), Br.join(`
`);
            }
          }
          class kt extends Ct {
            constructor(Yt) {
              super(Yt), this.data.fieldValue = null, this.data.hasOwnCanvas = this.data.noRotate;
            }
            getFieldObject() {
              return {
                id: this.data.id,
                value: null,
                page: this.data.pageIndex,
                type: "signature"
              };
            }
          }
          class jt extends wt {
            constructor(Yt) {
              super(Yt), this.data.noRotate = !0, this.data.hasOwnCanvas = this.data.noRotate;
              const {
                dict: nr
              } = Yt;
              this.data.annotationType = rt.AnnotationType.TEXT, this.data.hasAppearance ? this.data.name = "NoIcon" : (this.data.rect[1] = this.data.rect[3] - 22, this.data.rect[2] = this.data.rect[0] + 22, this.data.name = nr.has("Name") ? nr.get("Name").name : "Note"), nr.has("State") ? (this.data.state = nr.get("State") || null, this.data.stateModel = nr.get("StateModel") || null) : (this.data.state = null, this.data.stateModel = null);
            }
          }
          class Ht extends Ot {
            constructor(Yt) {
              var ir;
              super(Yt);
              const {
                dict: Kt,
                annotationGlobals: nr
              } = Yt;
              this.data.annotationType = rt.AnnotationType.LINK;
              const tr = St(Kt, this.rectangle);
              tr && (this.data.quadPoints = tr), (ir = this.data).borderColor || (ir.borderColor = this.data.color), ht.Catalog.parseDestDictionary({
                destDict: Kt,
                resultObj: this.data,
                docBaseUrl: nr.baseUrl,
                docAttachments: nr.attachments
              });
            }
          }
          class Ft extends Ot {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt
              } = Yt;
              this.data.annotationType = rt.AnnotationType.POPUP, (this.data.rect[0] === this.data.rect[2] || this.data.rect[1] === this.data.rect[3]) && (this.data.rect = null);
              let nr = Kt.get("Parent");
              if (!nr) {
                (0, rt.warn)("Popup annotation has a missing or invalid parent annotation.");
                return;
              }
              const tr = nr.getArray("Rect");
              this.data.parentRect = Array.isArray(tr) && tr.length === 4 ? rt.Util.normalizeRect(tr) : null;
              const ir = nr.get("RT");
              if ((0, et.isName)(ir, rt.AnnotationReplyType.GROUP) && (nr = nr.get("IRT")), nr.has("M") ? (this.setModificationDate(nr.get("M")), this.data.modificationDate = this.modificationDate) : this.data.modificationDate = null, nr.has("C") ? (this.setColor(nr.getArray("C")), this.data.color = this.color) : this.data.color = null, !this.viewable) {
                const sr = nr.get("F");
                this._isViewable(sr) && this.setFlags(sr);
              }
              this.setTitle(nr.get("T")), this.data.titleObj = this._title, this.setContents(nr.get("Contents")), this.data.contentsObj = this._contents, nr.has("RC") && (this.data.richText = At.XFAFactory.getRichTextAsHtml(nr.get("RC"))), this.data.open = !!Kt.get("Open");
            }
          }
          at.PopupAnnotation = Ft;
          class _t extends wt {
            constructor(Yt) {
              var tr;
              super(Yt), this.data.hasOwnCanvas = !0;
              const {
                evaluatorOptions: Kt,
                xref: nr
              } = Yt;
              if (this.data.annotationType = rt.AnnotationType.FREETEXT, this.setDefaultAppearance(Yt), this.appearance) {
                const {
                  fontColor: ir,
                  fontSize: sr
                } = (0, lt.parseAppearanceStream)(this.appearance, Kt, nr);
                this.data.defaultAppearanceData.fontColor = ir, this.data.defaultAppearanceData.fontSize = sr || 10;
              } else if (this._isOffscreenCanvasSupported) {
                const ir = Yt.dict.get("CA"), sr = new lt.FakeUnicodeFont(nr, "sans-serif");
                (tr = this.data.defaultAppearanceData).fontSize || (tr.fontSize = 10);
                const {
                  fontColor: cr,
                  fontSize: or
                } = this.data.defaultAppearanceData;
                this.appearance = sr.createAppearance(this._contents.str, this.rectangle, this.rotation, or, cr, ir), this._streams.push(this.appearance, lt.FakeUnicodeFont.toUnicodeStream);
              } else
                (0, rt.warn)("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.");
            }
            get hasTextContent() {
              return !!this.appearance;
            }
            static createNewDict(Yt, Kt, nr) {
              let {
                apRef: tr,
                ap: ir
              } = nr;
              const {
                color: sr,
                fontSize: cr,
                rect: or,
                rotation: Xt,
                user: Gt,
                value: Wt
              } = Yt, er = new et.Dict(Kt);
              er.set("Type", et.Name.get("Annot")), er.set("Subtype", et.Name.get("FreeText")), er.set("CreationDate", `D:${(0, rt.getModificationDate)()}`), er.set("Rect", or);
              const lr = `/Helv ${cr} Tf ${(0, lt.getPdfColor)(sr, !0)}`;
              if (er.set("DA", lr), er.set("Contents", (0, st.isAscii)(Wt) ? Wt : (0, st.stringToUTF16String)(Wt, !0)), er.set("F", 4), er.set("Border", [0, 0, 0]), er.set("Rotate", Xt), Gt && er.set("T", (0, st.isAscii)(Gt) ? Gt : (0, st.stringToUTF16String)(Gt, !0)), tr || ir) {
                const ur = new et.Dict(Kt);
                er.set("AP", ur), tr ? ur.set("N", tr) : ur.set("N", ir);
              }
              return er;
            }
            static async createNewAppearanceStream(Yt, Kt, nr) {
              const {
                baseFontRef: tr,
                evaluator: ir,
                task: sr
              } = nr, {
                color: cr,
                fontSize: or,
                rect: Xt,
                rotation: Gt,
                value: Wt
              } = Yt, er = new et.Dict(Kt), lr = new et.Dict(Kt);
              if (tr)
                lr.set("Helv", tr);
              else {
                const Fr = new et.Dict(Kt);
                Fr.set("BaseFont", et.Name.get("Helvetica")), Fr.set("Type", et.Name.get("Font")), Fr.set("Subtype", et.Name.get("Type1")), Fr.set("Encoding", et.Name.get("WinAnsiEncoding")), lr.set("Helv", Fr);
              }
              er.set("Font", lr);
              const ur = await Ct._getFontData(ir, sr, {
                fontName: "Helv",
                fontSize: or
              }, er), [pr, yr, Er, br] = Xt;
              let gr = Er - pr, Ar = br - yr;
              Gt % 180 !== 0 && ([gr, Ar] = [Ar, gr]);
              const Sr = Wt.split(`
`), Br = or / 1e3;
              let Ir = -1 / 0;
              const hr = [];
              for (let Fr of Sr) {
                const Qr = ur.encodeString(Fr);
                if (Qr.length > 1)
                  return null;
                Fr = Qr.join(""), hr.push(Fr);
                let Yr = 0;
                const kr = ur.charsToGlyphs(Fr);
                for (const Nr of kr)
                  Yr += Nr.width * Br;
                Ir = Math.max(Ir, Yr);
              }
              let vr = 1;
              Ir > gr && (vr = gr / Ir);
              let xr = 1;
              const Pr = rt.LINE_FACTOR * or, Rr = (rt.LINE_FACTOR - rt.LINE_DESCENT_FACTOR) * or, Dr = Pr * Sr.length;
              Dr > Ar && (xr = Ar / Dr);
              const Gr = Math.min(vr, xr), Or = or * Gr;
              let Hr, jr, Tr;
              switch (Gt) {
                case 0:
                  Tr = [1, 0, 0, 1], jr = [Xt[0], Xt[1], gr, Ar], Hr = [Xt[0], Xt[3] - Rr];
                  break;
                case 90:
                  Tr = [0, 1, -1, 0], jr = [Xt[1], -Xt[2], gr, Ar], Hr = [Xt[1], -Xt[0] - Rr];
                  break;
                case 180:
                  Tr = [-1, 0, 0, -1], jr = [-Xt[2], -Xt[3], gr, Ar], Hr = [-Xt[2], -Xt[1] - Rr];
                  break;
                case 270:
                  Tr = [0, -1, 1, 0], jr = [-Xt[3], Xt[0], gr, Ar], Hr = [-Xt[3], Xt[2] - Rr];
                  break;
              }
              const fr = ["q", `${Tr.join(" ")} 0 0 cm`, `${jr.join(" ")} re W n`, "BT", `${(0, lt.getPdfColor)(cr, !0)}`, `0 Tc /Helv ${(0, st.numberToString)(Or)} Tf`];
              fr.push(`${Hr.join(" ")} Td (${(0, st.escapeString)(hr[0])}) Tj`);
              const Cr = (0, st.numberToString)(Pr);
              for (let Fr = 1, Qr = hr.length; Fr < Qr; Fr++) {
                const Yr = hr[Fr];
                fr.push(`0 -${Cr} Td (${(0, st.escapeString)(Yr)}) Tj`);
              }
              fr.push("ET", "Q");
              const $r = fr.join(`
`), wr = new et.Dict(Kt);
              wr.set("FormType", 1), wr.set("Subtype", et.Name.get("Form")), wr.set("Type", et.Name.get("XObject")), wr.set("BBox", Xt), wr.set("Resources", er), wr.set("Matrix", [1, 0, 0, 1, -Xt[0], -Xt[1]]);
              const Mr = new it.StringStream($r);
              return Mr.dict = wr, Mr;
            }
          }
          class Nt extends wt {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt,
                xref: nr
              } = Yt;
              this.data.annotationType = rt.AnnotationType.LINE, this.data.hasOwnCanvas = this.data.noRotate;
              const tr = Kt.getArray("L");
              if (this.data.lineCoordinates = rt.Util.normalizeRect(tr), this.setLineEndings(Kt.getArray("LE")), this.data.lineEndings = this.lineEndings, !this.appearance) {
                const ir = this.color ? Et(this.color) : [0, 0, 0], sr = Kt.get("CA"), cr = bt(Kt.getArray("IC"), null), or = cr ? Et(cr) : null, Xt = or ? sr : null, Gt = this.borderStyle.width || 1, Wt = 2 * Gt, er = [this.data.lineCoordinates[0] - Wt, this.data.lineCoordinates[1] - Wt, this.data.lineCoordinates[2] + Wt, this.data.lineCoordinates[3] + Wt];
                rt.Util.intersect(this.rectangle, er) || (this.rectangle = er), this._setDefaultAppearance({
                  xref: nr,
                  extra: `${Gt} w`,
                  strokeColor: ir,
                  fillColor: or,
                  strokeAlpha: sr,
                  fillAlpha: Xt,
                  pointsCallback: (lr, ur) => (lr.push(`${tr[0]} ${tr[1]} m`, `${tr[2]} ${tr[3]} l`, "S"), [ur[0].x - Gt, ur[1].x + Gt, ur[3].y - Gt, ur[1].y + Gt])
                });
              }
            }
          }
          class Mt extends wt {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt,
                xref: nr
              } = Yt;
              if (this.data.annotationType = rt.AnnotationType.SQUARE, this.data.hasOwnCanvas = this.data.noRotate, !this.appearance) {
                const tr = this.color ? Et(this.color) : [0, 0, 0], ir = Kt.get("CA"), sr = bt(Kt.getArray("IC"), null), cr = sr ? Et(sr) : null, or = cr ? ir : null;
                if (this.borderStyle.width === 0 && !cr)
                  return;
                this._setDefaultAppearance({
                  xref: nr,
                  extra: `${this.borderStyle.width} w`,
                  strokeColor: tr,
                  fillColor: cr,
                  strokeAlpha: ir,
                  fillAlpha: or,
                  pointsCallback: (Xt, Gt) => {
                    const Wt = Gt[2].x + this.borderStyle.width / 2, er = Gt[2].y + this.borderStyle.width / 2, lr = Gt[3].x - Gt[2].x - this.borderStyle.width, ur = Gt[1].y - Gt[3].y - this.borderStyle.width;
                    return Xt.push(`${Wt} ${er} ${lr} ${ur} re`), cr ? Xt.push("B") : Xt.push("S"), [Gt[0].x, Gt[1].x, Gt[3].y, Gt[1].y];
                  }
                });
              }
            }
          }
          class Lt extends wt {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt,
                xref: nr
              } = Yt;
              if (this.data.annotationType = rt.AnnotationType.CIRCLE, !this.appearance) {
                const tr = this.color ? Et(this.color) : [0, 0, 0], ir = Kt.get("CA"), sr = bt(Kt.getArray("IC"), null), cr = sr ? Et(sr) : null, or = cr ? ir : null;
                if (this.borderStyle.width === 0 && !cr)
                  return;
                const Xt = 4 / 3 * Math.tan(Math.PI / (2 * 4));
                this._setDefaultAppearance({
                  xref: nr,
                  extra: `${this.borderStyle.width} w`,
                  strokeColor: tr,
                  fillColor: cr,
                  strokeAlpha: ir,
                  fillAlpha: or,
                  pointsCallback: (Gt, Wt) => {
                    const er = Wt[0].x + this.borderStyle.width / 2, lr = Wt[0].y - this.borderStyle.width / 2, ur = Wt[3].x - this.borderStyle.width / 2, pr = Wt[3].y + this.borderStyle.width / 2, yr = er + (ur - er) / 2, Er = lr + (pr - lr) / 2, br = (ur - er) / 2 * Xt, gr = (pr - lr) / 2 * Xt;
                    return Gt.push(`${yr} ${pr} m`, `${yr + br} ${pr} ${ur} ${Er + gr} ${ur} ${Er} c`, `${ur} ${Er - gr} ${yr + br} ${lr} ${yr} ${lr} c`, `${yr - br} ${lr} ${er} ${Er - gr} ${er} ${Er} c`, `${er} ${Er + gr} ${yr - br} ${pr} ${yr} ${pr} c`, "h"), cr ? Gt.push("B") : Gt.push("S"), [Wt[0].x, Wt[1].x, Wt[3].y, Wt[1].y];
                  }
                });
              }
            }
          }
          class $t extends wt {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt,
                xref: nr
              } = Yt;
              this.data.annotationType = rt.AnnotationType.POLYLINE, this.data.hasOwnCanvas = this.data.noRotate, this.data.vertices = [], this instanceof Tt || (this.setLineEndings(Kt.getArray("LE")), this.data.lineEndings = this.lineEndings);
              const tr = Kt.getArray("Vertices");
              if (Array.isArray(tr)) {
                for (let ir = 0, sr = tr.length; ir < sr; ir += 2)
                  this.data.vertices.push({
                    x: tr[ir],
                    y: tr[ir + 1]
                  });
                if (!this.appearance) {
                  const ir = this.color ? Et(this.color) : [0, 0, 0], sr = Kt.get("CA"), cr = this.borderStyle.width || 1, or = 2 * cr, Xt = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                  for (const Gt of this.data.vertices)
                    Xt[0] = Math.min(Xt[0], Gt.x - or), Xt[1] = Math.min(Xt[1], Gt.y - or), Xt[2] = Math.max(Xt[2], Gt.x + or), Xt[3] = Math.max(Xt[3], Gt.y + or);
                  rt.Util.intersect(this.rectangle, Xt) || (this.rectangle = Xt), this._setDefaultAppearance({
                    xref: nr,
                    extra: `${cr} w`,
                    strokeColor: ir,
                    strokeAlpha: sr,
                    pointsCallback: (Gt, Wt) => {
                      const er = this.data.vertices;
                      for (let lr = 0, ur = er.length; lr < ur; lr++)
                        Gt.push(`${er[lr].x} ${er[lr].y} ${lr === 0 ? "m" : "l"}`);
                      return Gt.push("S"), [Wt[0].x, Wt[1].x, Wt[3].y, Wt[1].y];
                    }
                  });
                }
              }
            }
          }
          class Tt extends $t {
            constructor(Yt) {
              super(Yt), this.data.annotationType = rt.AnnotationType.POLYGON;
            }
          }
          class Dt extends wt {
            constructor(Yt) {
              super(Yt), this.data.annotationType = rt.AnnotationType.CARET;
            }
          }
          class Ut extends wt {
            constructor(Yt) {
              super(Yt), this.data.hasOwnCanvas = this.data.noRotate;
              const {
                dict: Kt,
                xref: nr
              } = Yt;
              this.data.annotationType = rt.AnnotationType.INK, this.data.inkLists = [];
              const tr = Kt.getArray("InkList");
              if (Array.isArray(tr)) {
                for (let ir = 0, sr = tr.length; ir < sr; ++ir) {
                  this.data.inkLists.push([]);
                  for (let cr = 0, or = tr[ir].length; cr < or; cr += 2)
                    this.data.inkLists[ir].push({
                      x: nr.fetchIfRef(tr[ir][cr]),
                      y: nr.fetchIfRef(tr[ir][cr + 1])
                    });
                }
                if (!this.appearance) {
                  const ir = this.color ? Et(this.color) : [0, 0, 0], sr = Kt.get("CA"), cr = this.borderStyle.width || 1, or = 2 * cr, Xt = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                  for (const Gt of this.data.inkLists)
                    for (const Wt of Gt)
                      Xt[0] = Math.min(Xt[0], Wt.x - or), Xt[1] = Math.min(Xt[1], Wt.y - or), Xt[2] = Math.max(Xt[2], Wt.x + or), Xt[3] = Math.max(Xt[3], Wt.y + or);
                  rt.Util.intersect(this.rectangle, Xt) || (this.rectangle = Xt), this._setDefaultAppearance({
                    xref: nr,
                    extra: `${cr} w`,
                    strokeColor: ir,
                    strokeAlpha: sr,
                    pointsCallback: (Gt, Wt) => {
                      for (const er of this.data.inkLists) {
                        for (let lr = 0, ur = er.length; lr < ur; lr++)
                          Gt.push(`${er[lr].x} ${er[lr].y} ${lr === 0 ? "m" : "l"}`);
                        Gt.push("S");
                      }
                      return [Wt[0].x, Wt[1].x, Wt[3].y, Wt[1].y];
                    }
                  });
                }
              }
            }
            static createNewDict(Yt, Kt, nr) {
              let {
                apRef: tr,
                ap: ir
              } = nr;
              const {
                color: sr,
                opacity: cr,
                paths: or,
                rect: Xt,
                rotation: Gt,
                thickness: Wt
              } = Yt, er = new et.Dict(Kt);
              er.set("Type", et.Name.get("Annot")), er.set("Subtype", et.Name.get("Ink")), er.set("CreationDate", `D:${(0, rt.getModificationDate)()}`), er.set("Rect", Xt), er.set("InkList", or.map((pr) => pr.points)), er.set("F", 4), er.set("Rotate", Gt);
              const lr = new et.Dict(Kt);
              er.set("BS", lr), lr.set("W", Wt), er.set("C", Array.from(sr, (pr) => pr / 255)), er.set("CA", cr);
              const ur = new et.Dict(Kt);
              return er.set("AP", ur), tr ? ur.set("N", tr) : ur.set("N", ir), er;
            }
            static async createNewAppearanceStream(Yt, Kt, nr) {
              const {
                color: tr,
                rect: ir,
                paths: sr,
                thickness: cr,
                opacity: or
              } = Yt, Xt = [`${cr} w 1 J 1 j`, `${(0, lt.getPdfColor)(tr, !1)}`];
              or !== 1 && Xt.push("/R0 gs");
              const Gt = [];
              for (const {
                bezier: ur
              } of sr) {
                Gt.length = 0, Gt.push(`${(0, st.numberToString)(ur[0])} ${(0, st.numberToString)(ur[1])} m`);
                for (let pr = 2, yr = ur.length; pr < yr; pr += 6) {
                  const Er = ur.slice(pr, pr + 6).map(st.numberToString).join(" ");
                  Gt.push(`${Er} c`);
                }
                Gt.push("S"), Xt.push(Gt.join(`
`));
              }
              const Wt = Xt.join(`
`), er = new et.Dict(Kt);
              if (er.set("FormType", 1), er.set("Subtype", et.Name.get("Form")), er.set("Type", et.Name.get("XObject")), er.set("BBox", ir), er.set("Length", Wt.length), or !== 1) {
                const ur = new et.Dict(Kt), pr = new et.Dict(Kt), yr = new et.Dict(Kt);
                yr.set("CA", or), yr.set("Type", et.Name.get("ExtGState")), pr.set("R0", yr), ur.set("ExtGState", pr), er.set("Resources", ur);
              }
              const lr = new it.StringStream(Wt);
              return lr.dict = er, lr;
            }
          }
          class Vt extends wt {
            constructor(Yt) {
              var ir;
              super(Yt);
              const {
                dict: Kt,
                xref: nr
              } = Yt;
              if (this.data.annotationType = rt.AnnotationType.HIGHLIGHT, this.data.quadPoints = St(Kt, null)) {
                const sr = (ir = this.appearance) == null ? void 0 : ir.dict.get("Resources");
                if (!this.appearance || !(sr != null && sr.has("ExtGState"))) {
                  this.appearance && (0, rt.warn)("HighlightAnnotation - ignoring built-in appearance stream.");
                  const cr = this.color ? Et(this.color) : [1, 1, 0], or = Kt.get("CA");
                  this._setDefaultAppearance({
                    xref: nr,
                    fillColor: cr,
                    blendMode: "Multiply",
                    fillAlpha: or,
                    pointsCallback: (Xt, Gt) => (Xt.push(`${Gt[0].x} ${Gt[0].y} m`, `${Gt[1].x} ${Gt[1].y} l`, `${Gt[3].x} ${Gt[3].y} l`, `${Gt[2].x} ${Gt[2].y} l`, "f"), [Gt[0].x, Gt[1].x, Gt[3].y, Gt[1].y])
                  });
                }
              } else
                this.data.popupRef = null;
            }
          }
          class Qt extends wt {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt,
                xref: nr
              } = Yt;
              if (this.data.annotationType = rt.AnnotationType.UNDERLINE, this.data.quadPoints = St(Kt, null)) {
                if (!this.appearance) {
                  const ir = this.color ? Et(this.color) : [0, 0, 0], sr = Kt.get("CA");
                  this._setDefaultAppearance({
                    xref: nr,
                    extra: "[] 0 d 0.571 w",
                    strokeColor: ir,
                    strokeAlpha: sr,
                    pointsCallback: (cr, or) => (cr.push(`${or[2].x} ${or[2].y + 1.3} m`, `${or[3].x} ${or[3].y + 1.3} l`, "S"), [or[0].x, or[1].x, or[3].y, or[1].y])
                  });
                }
              } else
                this.data.popupRef = null;
            }
          }
          class qt extends wt {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt,
                xref: nr
              } = Yt;
              if (this.data.annotationType = rt.AnnotationType.SQUIGGLY, this.data.quadPoints = St(Kt, null)) {
                if (!this.appearance) {
                  const ir = this.color ? Et(this.color) : [0, 0, 0], sr = Kt.get("CA");
                  this._setDefaultAppearance({
                    xref: nr,
                    extra: "[] 0 d 1 w",
                    strokeColor: ir,
                    strokeAlpha: sr,
                    pointsCallback: (cr, or) => {
                      const Xt = (or[0].y - or[2].y) / 6;
                      let Gt = Xt, Wt = or[2].x;
                      const er = or[2].y, lr = or[3].x;
                      cr.push(`${Wt} ${er + Gt} m`);
                      do
                        Wt += 2, Gt = Gt === 0 ? Xt : 0, cr.push(`${Wt} ${er + Gt} l`);
                      while (Wt < lr);
                      return cr.push("S"), [or[2].x, lr, er - 2 * Xt, er + 2 * Xt];
                    }
                  });
                }
              } else
                this.data.popupRef = null;
            }
          }
          class Zt extends wt {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt,
                xref: nr
              } = Yt;
              if (this.data.annotationType = rt.AnnotationType.STRIKEOUT, this.data.quadPoints = St(Kt, null)) {
                if (!this.appearance) {
                  const ir = this.color ? Et(this.color) : [0, 0, 0], sr = Kt.get("CA");
                  this._setDefaultAppearance({
                    xref: nr,
                    extra: "[] 0 d 1 w",
                    strokeColor: ir,
                    strokeAlpha: sr,
                    pointsCallback: (cr, or) => (cr.push(`${(or[0].x + or[2].x) / 2} ${(or[0].y + or[2].y) / 2} m`, `${(or[1].x + or[3].x) / 2} ${(or[1].y + or[3].y) / 2} l`, "S"), [or[0].x, or[1].x, or[3].y, or[1].y])
                  });
                }
              } else
                this.data.popupRef = null;
            }
          }
          class ar extends wt {
            constructor(Yt) {
              super(Yt), this.data.annotationType = rt.AnnotationType.STAMP, this.data.hasOwnCanvas = this.data.noRotate;
            }
            static async createImage(Yt, Kt) {
              const {
                width: nr,
                height: tr
              } = Yt, ir = new OffscreenCanvas(nr, tr), sr = ir.getContext("2d", {
                alpha: !0
              });
              sr.drawImage(Yt, 0, 0);
              const cr = sr.getImageData(0, 0, nr, tr).data, or = new Uint32Array(cr.buffer), Xt = or.some(rt.FeatureTest.isLittleEndian ? (yr) => yr >>> 24 !== 255 : (yr) => (yr & 255) !== 255);
              Xt && (sr.fillStyle = "white", sr.fillRect(0, 0, nr, tr), sr.drawImage(Yt, 0, 0));
              const Gt = ir.convertToBlob({
                type: "image/jpeg",
                quality: 1
              }).then((yr) => yr.arrayBuffer()), Wt = et.Name.get("XObject"), er = et.Name.get("Image"), lr = new et.Dict(Kt);
              lr.set("Type", Wt), lr.set("Subtype", er), lr.set("BitsPerComponent", 8), lr.set("ColorSpace", et.Name.get("DeviceRGB")), lr.set("Filter", et.Name.get("DCTDecode")), lr.set("BBox", [0, 0, nr, tr]), lr.set("Width", nr), lr.set("Height", tr);
              let ur = null;
              if (Xt) {
                const yr = new Uint8Array(or.length);
                if (rt.FeatureTest.isLittleEndian)
                  for (let br = 0, gr = or.length; br < gr; br++)
                    yr[br] = or[br] >>> 24;
                else
                  for (let br = 0, gr = or.length; br < gr; br++)
                    yr[br] = or[br] & 255;
                const Er = new et.Dict(Kt);
                Er.set("Type", Wt), Er.set("Subtype", er), Er.set("BitsPerComponent", 8), Er.set("ColorSpace", et.Name.get("DeviceGray")), Er.set("Width", nr), Er.set("Height", tr), ur = new it.Stream(yr, 0, 0, Er);
              }
              return {
                imageStream: new it.Stream(await Gt, 0, 0, lr),
                smaskStream: ur,
                width: nr,
                height: tr
              };
            }
            static createNewDict(Yt, Kt, nr) {
              let {
                apRef: tr,
                ap: ir
              } = nr;
              const {
                rect: sr,
                rotation: cr,
                user: or
              } = Yt, Xt = new et.Dict(Kt);
              if (Xt.set("Type", et.Name.get("Annot")), Xt.set("Subtype", et.Name.get("Stamp")), Xt.set("CreationDate", `D:${(0, rt.getModificationDate)()}`), Xt.set("Rect", sr), Xt.set("F", 4), Xt.set("Border", [0, 0, 0]), Xt.set("Rotate", cr), or && Xt.set("T", (0, st.isAscii)(or) ? or : (0, st.stringToUTF16String)(or, !0)), tr || ir) {
                const Gt = new et.Dict(Kt);
                Xt.set("AP", Gt), tr ? Gt.set("N", tr) : Gt.set("N", ir);
              }
              return Xt;
            }
            static async createNewAppearanceStream(Yt, Kt, nr) {
              const {
                rotation: tr
              } = Yt, {
                imageRef: ir,
                width: sr,
                height: cr
              } = nr.image, or = new et.Dict(Kt), Xt = new et.Dict(Kt);
              or.set("XObject", Xt), Xt.set("Im0", ir);
              const Gt = `q ${sr} 0 0 ${cr} 0 0 cm /Im0 Do Q`, Wt = new et.Dict(Kt);
              if (Wt.set("FormType", 1), Wt.set("Subtype", et.Name.get("Form")), Wt.set("Type", et.Name.get("XObject")), Wt.set("BBox", [0, 0, sr, cr]), Wt.set("Resources", or), tr) {
                const lr = (0, st.getRotationMatrix)(tr, sr, cr);
                Wt.set("Matrix", lr);
              }
              const er = new it.StringStream(Gt);
              return er.dict = Wt, er;
            }
          }
          class Jt extends wt {
            constructor(Yt) {
              super(Yt);
              const {
                dict: Kt,
                xref: nr
              } = Yt, tr = new gt.FileSpec(Kt.get("FS"), nr);
              this.data.annotationType = rt.AnnotationType.FILEATTACHMENT, this.data.hasOwnCanvas = this.data.noRotate, this.data.file = tr.serializable;
              const ir = Kt.get("Name");
              this.data.name = ir instanceof et.Name ? (0, rt.stringToPDFString)(ir.name) : "PushPin";
              const sr = Kt.get("ca");
              this.data.fillAlpha = typeof sr == "number" && sr >= 0 && sr <= 1 ? sr : null;
            }
          }
        },
        /* 158 */
        /***/
        (nt, at, ot) => {
          var rt = ot(4), st = ot(6), lt = ot(87), et = ot(159), it = ot(7), ut = rt.RegExp, ft = ut.prototype, ht = st && it(function() {
            var dt = !0;
            try {
              ut(".", "d");
            } catch {
              dt = !1;
            }
            var gt = {}, pt = "", mt = dt ? "dgimsy" : "gimsy", ct = function(bt, Et) {
              Object.defineProperty(gt, bt, {
                get: function() {
                  return pt += Et, !0;
                }
              });
            }, vt = {
              dotAll: "s",
              global: "g",
              ignoreCase: "i",
              multiline: "m",
              sticky: "y"
            };
            dt && (vt.hasIndices = "d");
            for (var At in vt)
              ct(At, vt[At]);
            var xt = Object.getOwnPropertyDescriptor(ft, "flags").get.call(gt);
            return xt !== mt || pt !== mt;
          });
          ht && lt(ft, "flags", {
            configurable: !0,
            get: et
          });
        },
        /* 159 */
        /***/
        (nt, at, ot) => {
          var rt = ot(47);
          nt.exports = function() {
            var st = rt(this), lt = "";
            return st.hasIndices && (lt += "d"), st.global && (lt += "g"), st.ignoreCase && (lt += "i"), st.multiline && (lt += "m"), st.dotAll && (lt += "s"), st.unicode && (lt += "u"), st.unicodeSets && (lt += "v"), st.sticky && (lt += "y"), lt;
          };
        },
        /* 160 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(40), lt = ot(64), et = ot(141), it = ot(161), ut = ot(143), ft = [].unshift(0) !== 1, ht = function() {
            try {
              Object.defineProperty([], "length", { writable: !1 }).unshift();
            } catch (gt) {
              return gt instanceof TypeError;
            }
          }, dt = ft || !ht();
          rt({
            target: "Array",
            proto: !0,
            arity: 1,
            forced: dt
          }, {
            unshift: function(pt) {
              var mt = st(this), ct = lt(mt), vt = arguments.length;
              if (vt) {
                ut(ct + vt);
                for (var At = ct; At--; ) {
                  var xt = At + vt;
                  At in mt ? mt[xt] = mt[At] : it(mt, xt);
                }
                for (var bt = 0; bt < vt; bt++)
                  mt[bt] = arguments[bt];
              }
              return et(mt, ct + vt);
            }
          });
        },
        /* 161 */
        /***/
        (nt, at, ot) => {
          var rt = ot(32), st = TypeError;
          nt.exports = function(lt, et) {
            if (!delete lt[et])
              throw st("Cannot delete property " + rt(et) + " of " + rt(lt));
          };
        },
        /* 162 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.FakeUnicodeFont = void 0, at.createDefaultAppearance = vt, at.getPdfColor = ct, at.parseAppearanceStream = mt, at.parseDefaultAppearance = gt, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(140);
          var rt = ot(151), st = ot(150), lt = ot(145), et = ot(163), it = ot(164), ut = ot(210), ft = ot(208), ht = ot(155);
          class dt extends it.EvaluatorPreprocessor {
            constructor(bt) {
              super(new ht.StringStream(bt));
            }
            parse() {
              const bt = {
                fn: 0,
                args: []
              }, Et = {
                fontSize: 0,
                fontName: "",
                fontColor: new Uint8ClampedArray(3)
              };
              try {
                for (; bt.args.length = 0, !!this.read(bt); ) {
                  if (this.savedStatesDepth !== 0)
                    continue;
                  const {
                    fn: St,
                    args: Bt
                  } = bt;
                  switch (St | 0) {
                    case lt.OPS.setFont:
                      const [Ot, Pt] = Bt;
                      Ot instanceof rt.Name && (Et.fontName = Ot.name), typeof Pt == "number" && Pt > 0 && (Et.fontSize = Pt);
                      break;
                    case lt.OPS.setFillRGBColor:
                      et.ColorSpace.singletons.rgb.getRgbItem(Bt, 0, Et.fontColor, 0);
                      break;
                    case lt.OPS.setFillGray:
                      et.ColorSpace.singletons.gray.getRgbItem(Bt, 0, Et.fontColor, 0);
                      break;
                    case lt.OPS.setFillCMYKColor:
                      et.ColorSpace.singletons.cmyk.getRgbItem(Bt, 0, Et.fontColor, 0);
                      break;
                  }
                }
              } catch (St) {
                (0, lt.warn)(`parseDefaultAppearance - ignoring errors: "${St}".`);
              }
              return Et;
            }
          }
          function gt(xt) {
            return new dt(xt).parse();
          }
          class pt extends it.EvaluatorPreprocessor {
            constructor(bt, Et, St) {
              var Bt;
              super(bt), this.stream = bt, this.evaluatorOptions = Et, this.xref = St, this.resources = (Bt = bt.dict) == null ? void 0 : Bt.get("Resources");
            }
            parse() {
              const bt = {
                fn: 0,
                args: []
              };
              let Et = {
                scaleFactor: 1,
                fontSize: 0,
                fontName: "",
                fontColor: new Uint8ClampedArray(3),
                fillColorSpace: et.ColorSpace.singletons.gray
              }, St = !1;
              const Bt = [];
              try {
                for (; bt.args.length = 0, !(St || !this.read(bt)); ) {
                  const {
                    fn: Ot,
                    args: Pt
                  } = bt;
                  switch (Ot | 0) {
                    case lt.OPS.save:
                      Bt.push({
                        scaleFactor: Et.scaleFactor,
                        fontSize: Et.fontSize,
                        fontName: Et.fontName,
                        fontColor: Et.fontColor.slice(),
                        fillColorSpace: Et.fillColorSpace
                      });
                      break;
                    case lt.OPS.restore:
                      Et = Bt.pop() || Et;
                      break;
                    case lt.OPS.setTextMatrix:
                      Et.scaleFactor *= Math.hypot(Pt[0], Pt[1]);
                      break;
                    case lt.OPS.setFont:
                      const [wt, Ct] = Pt;
                      wt instanceof rt.Name && (Et.fontName = wt.name), typeof Ct == "number" && Ct > 0 && (Et.fontSize = Ct * Et.scaleFactor);
                      break;
                    case lt.OPS.setFillColorSpace:
                      Et.fillColorSpace = et.ColorSpace.parse({
                        cs: Pt[0],
                        xref: this.xref,
                        resources: this.resources,
                        pdfFunctionFactory: this._pdfFunctionFactory,
                        localColorSpaceCache: this._localColorSpaceCache
                      });
                      break;
                    case lt.OPS.setFillColor:
                      Et.fillColorSpace.getRgbItem(Pt, 0, Et.fontColor, 0);
                      break;
                    case lt.OPS.setFillRGBColor:
                      et.ColorSpace.singletons.rgb.getRgbItem(Pt, 0, Et.fontColor, 0);
                      break;
                    case lt.OPS.setFillGray:
                      et.ColorSpace.singletons.gray.getRgbItem(Pt, 0, Et.fontColor, 0);
                      break;
                    case lt.OPS.setFillCMYKColor:
                      et.ColorSpace.singletons.cmyk.getRgbItem(Pt, 0, Et.fontColor, 0);
                      break;
                    case lt.OPS.showText:
                    case lt.OPS.showSpacedText:
                    case lt.OPS.nextLineShowText:
                    case lt.OPS.nextLineSetSpacingShowText:
                      St = !0;
                      break;
                  }
                }
              } catch (Ot) {
                (0, lt.warn)(`parseAppearanceStream - ignoring errors: "${Ot}".`);
              }
              return this.stream.reset(), delete Et.scaleFactor, delete Et.fillColorSpace, Et;
            }
            get _localColorSpaceCache() {
              return (0, lt.shadow)(this, "_localColorSpaceCache", new ut.LocalColorSpaceCache());
            }
            get _pdfFunctionFactory() {
              const bt = new ft.PDFFunctionFactory({
                xref: this.xref,
                isEvalSupported: this.evaluatorOptions.isEvalSupported
              });
              return (0, lt.shadow)(this, "_pdfFunctionFactory", bt);
            }
          }
          function mt(xt, bt, Et) {
            return new pt(xt, bt, Et).parse();
          }
          function ct(xt, bt) {
            if (xt[0] === xt[1] && xt[1] === xt[2]) {
              const Et = xt[0] / 255;
              return `${(0, st.numberToString)(Et)} ${bt ? "g" : "G"}`;
            }
            return Array.from(xt, (Et) => (0, st.numberToString)(Et / 255)).join(" ") + ` ${bt ? "rg" : "RG"}`;
          }
          function vt(xt) {
            let {
              fontSize: bt,
              fontName: Et,
              fontColor: St
            } = xt;
            return `/${(0, st.escapePDFName)(Et)} ${bt} Tf ${ct(St, !0)}`;
          }
          class At {
            constructor(bt, Et) {
              this.xref = bt, this.widths = null, this.firstChar = 1 / 0, this.lastChar = -1 / 0, this.fontFamily = Et;
              const St = new OffscreenCanvas(1, 1);
              this.ctxMeasure = St.getContext("2d"), At._fontNameId || (At._fontNameId = 1), this.fontName = rt.Name.get(`InvalidPDFjsFont_${Et}_${At._fontNameId++}`);
            }
            get toUnicodeRef() {
              if (!At._toUnicodeRef) {
                const bt = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo
<< /Registry (Adobe)
/Ordering (UCS) /Supplement 0 >> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000> <FFFF>
endcodespacerange
1 beginbfrange
<0000> <FFFF> <0000>
endbfrange
endcmap CMapName currentdict /CMap defineresource pop end end`, Et = At.toUnicodeStream = new ht.StringStream(bt), St = new rt.Dict(this.xref);
                Et.dict = St, St.set("Length", bt.length), At._toUnicodeRef = this.xref.getNewPersistentRef(Et);
              }
              return At._toUnicodeRef;
            }
            get fontDescriptorRef() {
              if (!At._fontDescriptorRef) {
                const bt = new rt.Dict(this.xref);
                bt.set("Type", rt.Name.get("FontDescriptor")), bt.set("FontName", this.fontName), bt.set("FontFamily", "MyriadPro Regular"), bt.set("FontBBox", [0, 0, 0, 0]), bt.set("FontStretch", rt.Name.get("Normal")), bt.set("FontWeight", 400), bt.set("ItalicAngle", 0), At._fontDescriptorRef = this.xref.getNewPersistentRef(bt);
              }
              return At._fontDescriptorRef;
            }
            get descendantFontRef() {
              const bt = new rt.Dict(this.xref);
              bt.set("BaseFont", this.fontName), bt.set("Type", rt.Name.get("Font")), bt.set("Subtype", rt.Name.get("CIDFontType0")), bt.set("CIDToGIDMap", rt.Name.get("Identity")), bt.set("FirstChar", this.firstChar), bt.set("LastChar", this.lastChar), bt.set("FontDescriptor", this.fontDescriptorRef), bt.set("DW", 1e3);
              const Et = [], St = [...this.widths.entries()].sort();
              let Bt = null, Ot = null;
              for (const [wt, Ct] of St) {
                if (!Bt) {
                  Bt = wt, Ot = [Ct];
                  continue;
                }
                wt === Bt + Ot.length ? Ot.push(Ct) : (Et.push(Bt, Ot), Bt = wt, Ot = [Ct]);
              }
              Bt && Et.push(Bt, Ot), bt.set("W", Et);
              const Pt = new rt.Dict(this.xref);
              return Pt.set("Ordering", "Identity"), Pt.set("Registry", "Adobe"), Pt.set("Supplement", 0), bt.set("CIDSystemInfo", Pt), this.xref.getNewPersistentRef(bt);
            }
            get baseFontRef() {
              const bt = new rt.Dict(this.xref);
              return bt.set("BaseFont", this.fontName), bt.set("Type", rt.Name.get("Font")), bt.set("Subtype", rt.Name.get("Type0")), bt.set("Encoding", rt.Name.get("Identity-H")), bt.set("DescendantFonts", [this.descendantFontRef]), bt.set("ToUnicode", this.toUnicodeRef), this.xref.getNewPersistentRef(bt);
            }
            get resources() {
              const bt = new rt.Dict(this.xref), Et = new rt.Dict(this.xref);
              return Et.set(this.fontName.name, this.baseFontRef), bt.set("Font", Et), bt;
            }
            _createContext() {
              return this.widths = /* @__PURE__ */ new Map(), this.ctxMeasure.font = `1000px ${this.fontFamily}`, this.ctxMeasure;
            }
            createFontResources(bt) {
              const Et = this._createContext();
              for (const St of bt.split(/\r\n?|\n/))
                for (const Bt of St.split("")) {
                  const Ot = Bt.charCodeAt(0);
                  if (this.widths.has(Ot))
                    continue;
                  const Pt = Et.measureText(Bt), wt = Math.ceil(Pt.width);
                  this.widths.set(Ot, wt), this.firstChar = Math.min(Ot, this.firstChar), this.lastChar = Math.max(Ot, this.lastChar);
                }
              return this.resources;
            }
            createAppearance(bt, Et, St, Bt, Ot, Pt) {
              const wt = this._createContext(), Ct = [];
              let It = -1 / 0;
              for (const Jt of bt.split(/\r\n?|\n/)) {
                Ct.push(Jt);
                const rr = wt.measureText(Jt).width;
                It = Math.max(It, rr);
                for (const Yt of Jt.split("")) {
                  const Kt = Yt.charCodeAt(0);
                  let nr = this.widths.get(Kt);
                  if (nr === void 0) {
                    const tr = wt.measureText(Yt);
                    nr = Math.ceil(tr.width), this.widths.set(Kt, nr), this.firstChar = Math.min(Kt, this.firstChar), this.lastChar = Math.max(Kt, this.lastChar);
                  }
                }
              }
              It *= Bt / 1e3;
              const [yt, Rt, kt, jt] = Et;
              let Ht = kt - yt, Ft = jt - Rt;
              St % 180 !== 0 && ([Ht, Ft] = [Ft, Ht]);
              let _t = 1;
              It > Ht && (_t = Ht / It);
              let Nt = 1;
              const Mt = lt.LINE_FACTOR * Bt, Lt = lt.LINE_DESCENT_FACTOR * Bt, $t = Mt * Ct.length;
              $t > Ft && (Nt = Ft / $t);
              const Tt = Math.min(_t, Nt), Dt = Bt * Tt, Ut = ["q", `0 0 ${(0, st.numberToString)(Ht)} ${(0, st.numberToString)(Ft)} re W n`, "BT", `1 0 0 1 0 ${(0, st.numberToString)(Ft + Lt)} Tm 0 Tc ${ct(Ot, !0)}`, `/${this.fontName.name} ${(0, st.numberToString)(Dt)} Tf`], {
                resources: Vt
              } = this;
              if (Pt = typeof Pt == "number" && Pt >= 0 && Pt <= 1 ? Pt : 1, Pt !== 1) {
                Ut.push("/R0 gs");
                const Jt = new rt.Dict(this.xref), rr = new rt.Dict(this.xref);
                rr.set("ca", Pt), rr.set("CA", Pt), rr.set("Type", rt.Name.get("ExtGState")), Jt.set("R0", rr), Vt.set("ExtGState", Jt);
              }
              const Qt = (0, st.numberToString)(Mt);
              for (const Jt of Ct)
                Ut.push(`0 -${Qt} Td <${(0, st.stringToUTF16HexString)(Jt)}> Tj`);
              Ut.push("ET", "Q");
              const qt = Ut.join(`
`), Zt = new rt.Dict(this.xref);
              if (Zt.set("Subtype", rt.Name.get("Form")), Zt.set("Type", rt.Name.get("XObject")), Zt.set("BBox", [0, 0, Ht, Ft]), Zt.set("Length", qt.length), Zt.set("Resources", Vt), St) {
                const Jt = (0, st.getRotationMatrix)(St, Ht, Ft);
                Zt.set("Matrix", Jt);
              }
              const ar = new ht.StringStream(qt);
              return ar.dict = Zt, ar;
            }
          }
          at.FakeUnicodeFont = At;
        },
        /* 163 */
        /***/
        (nt, at, ot) => {
          var xt, ws, Et, Ss, Bt, Ot, Pt, wt, Ct, It, yt, Rt, kt, Mo, Ht, ml, _t, Al, Mt, qo, $t, ko, Dt, Fo, Vt, vl, qt, bl, ar, xl, rr, $s, nr, Jo, ir, ts, cr, Is;
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.ColorSpace = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(2);
          var rt = ot(145), st = ot(151), lt = ot(152), et = ot(150);
          function it(Xt, Gt, Wt, er, lr, ur, pr) {
            pr = pr !== 1 ? 0 : pr;
            const Er = Wt / lr, br = er / ur;
            let gr = 0, Ar;
            const Sr = new Uint16Array(lr), Br = Wt * 3;
            for (let Ir = 0; Ir < lr; Ir++)
              Sr[Ir] = Math.floor(Ir * Er) * 3;
            for (let Ir = 0; Ir < ur; Ir++) {
              const hr = Math.floor(Ir * br) * Br;
              for (let vr = 0; vr < lr; vr++)
                Ar = hr + Sr[vr], Gt[gr++] = Xt[Ar++], Gt[gr++] = Xt[Ar++], Gt[gr++] = Xt[Ar++], gr += pr;
            }
          }
          class ut {
            constructor(Gt, Wt) {
              this.constructor === ut && (0, rt.unreachable)("Cannot initialize ColorSpace."), this.name = Gt, this.numComps = Wt;
            }
            getRgb(Gt, Wt) {
              const er = new Uint8ClampedArray(3);
              return this.getRgbItem(Gt, Wt, er, 0), er;
            }
            getRgbItem(Gt, Wt, er, lr) {
              (0, rt.unreachable)("Should not call ColorSpace.getRgbItem");
            }
            getRgbBuffer(Gt, Wt, er, lr, ur, pr, yr) {
              (0, rt.unreachable)("Should not call ColorSpace.getRgbBuffer");
            }
            getOutputLength(Gt, Wt) {
              (0, rt.unreachable)("Should not call ColorSpace.getOutputLength");
            }
            isPassthrough(Gt) {
              return !1;
            }
            isDefaultDecode(Gt, Wt) {
              return ut.isDefaultDecode(Gt, this.numComps);
            }
            fillRgb(Gt, Wt, er, lr, ur, pr, yr, Er, br) {
              const gr = Wt * er;
              let Ar = null;
              const Sr = 1 << yr, Br = er !== ur || Wt !== lr;
              if (this.isPassthrough(yr))
                Ar = Er;
              else if (this.numComps === 1 && gr > Sr && this.name !== "DeviceGray" && this.name !== "DeviceRGB") {
                const Ir = yr <= 8 ? new Uint8Array(Sr) : new Uint16Array(Sr);
                for (let vr = 0; vr < Sr; vr++)
                  Ir[vr] = vr;
                const hr = new Uint8ClampedArray(Sr * 3);
                if (this.getRgbBuffer(Ir, 0, Sr, hr, 0, yr, 0), Br) {
                  Ar = new Uint8Array(gr * 3);
                  let vr = 0;
                  for (let xr = 0; xr < gr; ++xr) {
                    const Pr = Er[xr] * 3;
                    Ar[vr++] = hr[Pr], Ar[vr++] = hr[Pr + 1], Ar[vr++] = hr[Pr + 2];
                  }
                } else {
                  let vr = 0;
                  for (let xr = 0; xr < gr; ++xr) {
                    const Pr = Er[xr] * 3;
                    Gt[vr++] = hr[Pr], Gt[vr++] = hr[Pr + 1], Gt[vr++] = hr[Pr + 2], vr += br;
                  }
                }
              } else
                Br ? (Ar = new Uint8ClampedArray(gr * 3), this.getRgbBuffer(Er, 0, gr, Ar, 0, yr, 0)) : this.getRgbBuffer(Er, 0, lr * pr, Gt, 0, yr, br);
              if (Ar)
                if (Br)
                  it(Ar, Gt, Wt, er, lr, ur, br);
                else {
                  let Ir = 0, hr = 0;
                  for (let vr = 0, xr = lr * pr; vr < xr; vr++)
                    Gt[Ir++] = Ar[hr++], Gt[Ir++] = Ar[hr++], Gt[Ir++] = Ar[hr++], Ir += br;
                }
            }
            get usesZeroToOneRange() {
              return (0, rt.shadow)(this, "usesZeroToOneRange", !0);
            }
            static _cache(Gt, Wt, er, lr) {
              if (!er)
                throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
              if (!lr)
                throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
              let ur, pr;
              Gt instanceof st.Ref && (pr = Gt, Gt = Wt.fetch(Gt)), Gt instanceof st.Name && (ur = Gt.name), (ur || pr) && er.set(ur, pr, lr);
            }
            static getCached(Gt, Wt, er) {
              if (!er)
                throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
              if (Gt instanceof st.Ref) {
                const lr = er.getByRef(Gt);
                if (lr)
                  return lr;
                try {
                  Gt = Wt.fetch(Gt);
                } catch (ur) {
                  if (ur instanceof et.MissingDataException)
                    throw ur;
                }
              }
              if (Gt instanceof st.Name) {
                const lr = er.getByName(Gt.name);
                if (lr)
                  return lr;
              }
              return null;
            }
            static async parseAsync(Gt) {
              let {
                cs: Wt,
                xref: er,
                resources: lr = null,
                pdfFunctionFactory: ur,
                localColorSpaceCache: pr
              } = Gt;
              const yr = this._parse(Wt, er, lr, ur);
              return this._cache(Wt, er, pr, yr), yr;
            }
            static parse(Gt) {
              let {
                cs: Wt,
                xref: er,
                resources: lr = null,
                pdfFunctionFactory: ur,
                localColorSpaceCache: pr
              } = Gt;
              const yr = this.getCached(Wt, er, pr);
              if (yr)
                return yr;
              const Er = this._parse(Wt, er, lr, ur);
              return this._cache(Wt, er, pr, Er), Er;
            }
            static _parse(Gt, Wt) {
              let er = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, lr = arguments.length > 3 ? arguments[3] : void 0;
              if (Gt = Wt.fetchIfRef(Gt), Gt instanceof st.Name)
                switch (Gt.name) {
                  case "G":
                  case "DeviceGray":
                    return this.singletons.gray;
                  case "RGB":
                  case "DeviceRGB":
                    return this.singletons.rgb;
                  case "CMYK":
                  case "DeviceCMYK":
                    return this.singletons.cmyk;
                  case "Pattern":
                    return new ht(null);
                  default:
                    if (er instanceof st.Dict) {
                      const ur = er.get("ColorSpace");
                      if (ur instanceof st.Dict) {
                        const pr = ur.get(Gt.name);
                        if (pr) {
                          if (pr instanceof st.Name)
                            return this._parse(pr, Wt, er, lr);
                          Gt = pr;
                          break;
                        }
                      }
                    }
                    throw new rt.FormatError(`Unrecognized ColorSpace: ${Gt.name}`);
                }
              if (Array.isArray(Gt)) {
                const ur = Wt.fetchIfRef(Gt[0]).name;
                let pr, yr, Er, br, gr, Ar;
                switch (ur) {
                  case "G":
                  case "DeviceGray":
                    return this.singletons.gray;
                  case "RGB":
                  case "DeviceRGB":
                    return this.singletons.rgb;
                  case "CMYK":
                  case "DeviceCMYK":
                    return this.singletons.cmyk;
                  case "CalGray":
                    return pr = Wt.fetchIfRef(Gt[1]), br = pr.getArray("WhitePoint"), gr = pr.getArray("BlackPoint"), Ar = pr.get("Gamma"), new ct(br, gr, Ar);
                  case "CalRGB":
                    pr = Wt.fetchIfRef(Gt[1]), br = pr.getArray("WhitePoint"), gr = pr.getArray("BlackPoint"), Ar = pr.getArray("Gamma");
                    const Sr = pr.getArray("Matrix");
                    return new vt(br, gr, Ar, Sr);
                  case "ICCBased":
                    const Ir = Wt.fetchIfRef(Gt[1]).dict;
                    yr = Ir.get("N");
                    const hr = Ir.get("Alternate");
                    if (hr) {
                      const Gr = this._parse(hr, Wt, er, lr);
                      if (Gr.numComps === yr)
                        return Gr;
                      (0, rt.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                    }
                    if (yr === 1)
                      return this.singletons.gray;
                    if (yr === 3)
                      return this.singletons.rgb;
                    if (yr === 4)
                      return this.singletons.cmyk;
                    break;
                  case "Pattern":
                    return Er = Gt[1] || null, Er && (Er = this._parse(Er, Wt, er, lr)), new ht(Er);
                  case "I":
                  case "Indexed":
                    Er = this._parse(Gt[1], Wt, er, lr);
                    const vr = Wt.fetchIfRef(Gt[2]) + 1, xr = Wt.fetchIfRef(Gt[3]);
                    return new dt(Er, vr, xr);
                  case "Separation":
                  case "DeviceN":
                    const Pr = Wt.fetchIfRef(Gt[1]);
                    yr = Array.isArray(Pr) ? Pr.length : 1, Er = this._parse(Gt[2], Wt, er, lr);
                    const Rr = lr.create(Gt[3]);
                    return new ft(yr, Er, Rr);
                  case "Lab":
                    pr = Wt.fetchIfRef(Gt[1]), br = pr.getArray("WhitePoint"), gr = pr.getArray("BlackPoint");
                    const Dr = pr.getArray("Range");
                    return new At(br, gr, Dr);
                  default:
                    throw new rt.FormatError(`Unimplemented ColorSpace object: ${ur}`);
                }
              }
              throw new rt.FormatError(`Unrecognized ColorSpace object: ${Gt}`);
            }
            static isDefaultDecode(Gt, Wt) {
              if (!Array.isArray(Gt))
                return !0;
              if (Wt * 2 !== Gt.length)
                return (0, rt.warn)("The decode map is not the correct length"), !0;
              for (let er = 0, lr = Gt.length; er < lr; er += 2)
                if (Gt[er] !== 0 || Gt[er + 1] !== 1)
                  return !1;
              return !0;
            }
            static get singletons() {
              return (0, rt.shadow)(this, "singletons", {
                get gray() {
                  return (0, rt.shadow)(this, "gray", new gt());
                },
                get rgb() {
                  return (0, rt.shadow)(this, "rgb", new pt());
                },
                get cmyk() {
                  return (0, rt.shadow)(this, "cmyk", new mt());
                }
              });
            }
          }
          at.ColorSpace = ut;
          class ft extends ut {
            constructor(Gt, Wt, er) {
              super("Alternate", Gt), this.base = Wt, this.tintFn = er, this.tmpBuf = new Float32Array(Wt.numComps);
            }
            getRgbItem(Gt, Wt, er, lr) {
              const ur = this.tmpBuf;
              this.tintFn(Gt, Wt, ur, 0), this.base.getRgbItem(ur, 0, er, lr);
            }
            getRgbBuffer(Gt, Wt, er, lr, ur, pr, yr) {
              const Er = this.tintFn, br = this.base, gr = 1 / ((1 << pr) - 1), Ar = br.numComps, Sr = br.usesZeroToOneRange, Br = (br.isPassthrough(8) || !Sr) && yr === 0;
              let Ir = Br ? ur : 0;
              const hr = Br ? lr : new Uint8ClampedArray(Ar * er), vr = this.numComps, xr = new Float32Array(vr), Pr = new Float32Array(Ar);
              let Rr, Dr;
              for (Rr = 0; Rr < er; Rr++) {
                for (Dr = 0; Dr < vr; Dr++)
                  xr[Dr] = Gt[Wt++] * gr;
                if (Er(xr, 0, Pr, 0), Sr)
                  for (Dr = 0; Dr < Ar; Dr++)
                    hr[Ir++] = Pr[Dr] * 255;
                else
                  br.getRgbItem(Pr, 0, hr, Ir), Ir += Ar;
              }
              Br || br.getRgbBuffer(hr, 0, er, lr, ur, 8, yr);
            }
            getOutputLength(Gt, Wt) {
              return this.base.getOutputLength(Gt * this.base.numComps / this.numComps, Wt);
            }
          }
          class ht extends ut {
            constructor(Gt) {
              super("Pattern", null), this.base = Gt;
            }
            isDefaultDecode(Gt, Wt) {
              (0, rt.unreachable)("Should not call PatternCS.isDefaultDecode");
            }
          }
          class dt extends ut {
            constructor(Gt, Wt, er) {
              super("Indexed", 1), this.base = Gt, this.highVal = Wt;
              const lr = Gt.numComps * Wt;
              if (this.lookup = new Uint8Array(lr), er instanceof lt.BaseStream) {
                const ur = er.getBytes(lr);
                this.lookup.set(ur);
              } else if (typeof er == "string")
                for (let ur = 0; ur < lr; ++ur)
                  this.lookup[ur] = er.charCodeAt(ur) & 255;
              else
                throw new rt.FormatError(`IndexedCS - unrecognized lookup table: ${er}`);
            }
            getRgbItem(Gt, Wt, er, lr) {
              const ur = this.base.numComps, pr = Gt[Wt] * ur;
              this.base.getRgbBuffer(this.lookup, pr, 1, er, lr, 8, 0);
            }
            getRgbBuffer(Gt, Wt, er, lr, ur, pr, yr) {
              const Er = this.base, br = Er.numComps, gr = Er.getOutputLength(br, yr), Ar = this.lookup;
              for (let Sr = 0; Sr < er; ++Sr) {
                const Br = Gt[Wt++] * br;
                Er.getRgbBuffer(Ar, Br, 1, lr, ur, 8, yr), ur += gr;
              }
            }
            getOutputLength(Gt, Wt) {
              return this.base.getOutputLength(Gt * this.base.numComps, Wt);
            }
            isDefaultDecode(Gt, Wt) {
              return Array.isArray(Gt) ? Gt.length !== 2 ? ((0, rt.warn)("Decode map length is not correct"), !0) : !Number.isInteger(Wt) || Wt < 1 ? ((0, rt.warn)("Bits per component is not correct"), !0) : Gt[0] === 0 && Gt[1] === (1 << Wt) - 1 : !0;
            }
          }
          class gt extends ut {
            constructor() {
              super("DeviceGray", 1);
            }
            getRgbItem(Gt, Wt, er, lr) {
              const ur = Gt[Wt] * 255;
              er[lr] = er[lr + 1] = er[lr + 2] = ur;
            }
            getRgbBuffer(Gt, Wt, er, lr, ur, pr, yr) {
              const Er = 255 / ((1 << pr) - 1);
              let br = Wt, gr = ur;
              for (let Ar = 0; Ar < er; ++Ar) {
                const Sr = Er * Gt[br++];
                lr[gr++] = Sr, lr[gr++] = Sr, lr[gr++] = Sr, gr += yr;
              }
            }
            getOutputLength(Gt, Wt) {
              return Gt * (3 + Wt);
            }
          }
          class pt extends ut {
            constructor() {
              super("DeviceRGB", 3);
            }
            getRgbItem(Gt, Wt, er, lr) {
              er[lr] = Gt[Wt] * 255, er[lr + 1] = Gt[Wt + 1] * 255, er[lr + 2] = Gt[Wt + 2] * 255;
            }
            getRgbBuffer(Gt, Wt, er, lr, ur, pr, yr) {
              if (pr === 8 && yr === 0) {
                lr.set(Gt.subarray(Wt, Wt + er * 3), ur);
                return;
              }
              const Er = 255 / ((1 << pr) - 1);
              let br = Wt, gr = ur;
              for (let Ar = 0; Ar < er; ++Ar)
                lr[gr++] = Er * Gt[br++], lr[gr++] = Er * Gt[br++], lr[gr++] = Er * Gt[br++], gr += yr;
            }
            getOutputLength(Gt, Wt) {
              return Gt * (3 + Wt) / 3 | 0;
            }
            isPassthrough(Gt) {
              return Gt === 8;
            }
          }
          class mt extends ut {
            constructor() {
              super("DeviceCMYK", 4);
              _r(this, xt);
            }
            getRgbItem(Wt, er, lr, ur) {
              Ur(this, xt, ws).call(this, Wt, er, 1, lr, ur);
            }
            getRgbBuffer(Wt, er, lr, ur, pr, yr, Er) {
              const br = 1 / ((1 << yr) - 1);
              for (let gr = 0; gr < lr; gr++)
                Ur(this, xt, ws).call(this, Wt, er, br, ur, pr), er += 4, pr += 3 + Er;
            }
            getOutputLength(Wt, er) {
              return Wt / 4 * (3 + er) | 0;
            }
          }
          xt = new WeakSet(), ws = function(Wt, er, lr, ur, pr) {
            const yr = Wt[er] * lr, Er = Wt[er + 1] * lr, br = Wt[er + 2] * lr, gr = Wt[er + 3] * lr;
            ur[pr] = 255 + yr * (-4.387332384609988 * yr + 54.48615194189176 * Er + 18.82290502165302 * br + 212.25662451639585 * gr + -285.2331026137004) + Er * (1.7149763477362134 * Er - 5.6096736904047315 * br + -17.873870861415444 * gr - 5.497006427196366) + br * (-2.5217340131683033 * br - 21.248923337353073 * gr + 17.5119270841813) + gr * (-21.86122147463605 * gr - 189.48180835922747), ur[pr + 1] = 255 + yr * (8.841041422036149 * yr + 60.118027045597366 * Er + 6.871425592049007 * br + 31.159100130055922 * gr + -79.2970844816548) + Er * (-15.310361306967817 * Er + 17.575251261109482 * br + 131.35250912493976 * gr - 190.9453302588951) + br * (4.444339102852739 * br + 9.8632861493405 * gr - 24.86741582555878) + gr * (-20.737325471181034 * gr - 187.80453709719578), ur[pr + 2] = 255 + yr * (0.8842522430003296 * yr + 8.078677503112928 * Er + 30.89978309703729 * br - 0.23883238689178934 * gr + -14.183576799673286) + Er * (10.49593273432072 * Er + 63.02378494754052 * br + 50.606957656360734 * gr - 112.23884253719248) + br * (0.03296041114873217 * br + 115.60384449646641 * gr + -193.58209356861505) + gr * (-22.33816807309886 * gr - 180.12613974708367);
          };
          class ct extends ut {
            constructor(Wt, er, lr) {
              super("CalGray", 1);
              _r(this, Et);
              if (!Wt)
                throw new rt.FormatError("WhitePoint missing - required for color space CalGray");
              if ([this.XW, this.YW, this.ZW] = Wt, [this.XB, this.YB, this.ZB] = er || [0, 0, 0], this.G = lr || 1, this.XW < 0 || this.ZW < 0 || this.YW !== 1)
                throw new rt.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
              (this.XB < 0 || this.YB < 0 || this.ZB < 0) && ((0, rt.info)(`Invalid BlackPoint for ${this.name}, falling back to default.`), this.XB = this.YB = this.ZB = 0), (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) && (0, rt.warn)(`${this.name}, BlackPoint: XB: ${this.XB}, YB: ${this.YB}, ZB: ${this.ZB}, only default values are supported.`), this.G < 1 && ((0, rt.info)(`Invalid Gamma: ${this.G} for ${this.name}, falling back to default.`), this.G = 1);
            }
            getRgbItem(Wt, er, lr, ur) {
              Ur(this, Et, Ss).call(this, Wt, er, lr, ur, 1);
            }
            getRgbBuffer(Wt, er, lr, ur, pr, yr, Er) {
              const br = 1 / ((1 << yr) - 1);
              for (let gr = 0; gr < lr; ++gr)
                Ur(this, Et, Ss).call(this, Wt, er, ur, pr, br), er += 1, pr += 3 + Er;
            }
            getOutputLength(Wt, er) {
              return Wt * (3 + er);
            }
          }
          Et = new WeakSet(), Ss = function(Wt, er, lr, ur, pr) {
            const Er = (Wt[er] * pr) ** this.G, br = this.YW * Er, gr = Math.max(295.8 * br ** 0.3333333333333333 - 40.8, 0);
            lr[ur] = gr, lr[ur + 1] = gr, lr[ur + 2] = gr;
          };
          const Kt = class Kt extends ut {
            constructor(Wt, er, lr, ur) {
              super("CalRGB", 3);
              _r(this, kt);
              _r(this, Ht);
              _r(this, _t);
              _r(this, Mt);
              _r(this, $t);
              _r(this, Dt);
              _r(this, Vt);
              _r(this, qt);
              _r(this, ar);
              _r(this, rr);
              if (!Wt)
                throw new rt.FormatError("WhitePoint missing - required for color space CalRGB");
              const [pr, yr, Er] = this.whitePoint = Wt, [br, gr, Ar] = this.blackPoint = er || new Float32Array(3);
              if ([this.GR, this.GG, this.GB] = lr || new Float32Array([1, 1, 1]), [this.MXA, this.MYA, this.MZA, this.MXB, this.MYB, this.MZB, this.MXC, this.MYC, this.MZC] = ur || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]), pr < 0 || Er < 0 || yr !== 1)
                throw new rt.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
              (br < 0 || gr < 0 || Ar < 0) && ((0, rt.info)(`Invalid BlackPoint for ${this.name} [${br}, ${gr}, ${Ar}], falling back to default.`), this.blackPoint = new Float32Array(3)), (this.GR < 0 || this.GG < 0 || this.GB < 0) && ((0, rt.info)(`Invalid Gamma [${this.GR}, ${this.GG}, ${this.GB}] for ${this.name}, falling back to default.`), this.GR = this.GG = this.GB = 1);
            }
            getRgbItem(Wt, er, lr, ur) {
              Ur(this, rr, $s).call(this, Wt, er, lr, ur, 1);
            }
            getRgbBuffer(Wt, er, lr, ur, pr, yr, Er) {
              const br = 1 / ((1 << yr) - 1);
              for (let gr = 0; gr < lr; ++gr)
                Ur(this, rr, $s).call(this, Wt, er, ur, pr, br), er += 3, pr += 3 + Er;
            }
            getOutputLength(Wt, er) {
              return Wt * (3 + er) / 3 | 0;
            }
          };
          Bt = new WeakMap(), Ot = new WeakMap(), Pt = new WeakMap(), wt = new WeakMap(), Ct = new WeakMap(), It = new WeakMap(), yt = new WeakMap(), Rt = new WeakMap(), kt = new WeakSet(), Mo = function(Wt, er, lr) {
            lr[0] = Wt[0] * er[0] + Wt[1] * er[1] + Wt[2] * er[2], lr[1] = Wt[3] * er[0] + Wt[4] * er[1] + Wt[5] * er[2], lr[2] = Wt[6] * er[0] + Wt[7] * er[1] + Wt[8] * er[2];
          }, Ht = new WeakSet(), ml = function(Wt, er, lr) {
            lr[0] = er[0] * 1 / Wt[0], lr[1] = er[1] * 1 / Wt[1], lr[2] = er[2] * 1 / Wt[2];
          }, _t = new WeakSet(), Al = function(Wt, er, lr) {
            lr[0] = er[0] * 0.95047 / Wt[0], lr[1] = er[1] * 1 / Wt[1], lr[2] = er[2] * 1.08883 / Wt[2];
          }, Mt = new WeakSet(), qo = function(Wt) {
            return Wt <= 31308e-7 ? Ur(this, $t, ko).call(this, 0, 1, 12.92 * Wt) : Wt >= 0.99554525 ? 1 : Ur(this, $t, ko).call(this, 0, 1, 1.055 * Wt ** 0.4166666666666667 - 0.055);
          }, $t = new WeakSet(), ko = function(Wt, er, lr) {
            return Math.max(Wt, Math.min(er, lr));
          }, Dt = new WeakSet(), Fo = function(Wt) {
            return Wt < 0 ? -Ur(this, Dt, Fo).call(this, -Wt) : Wt > 8 ? ((Wt + 16) / 116) ** 3 : Wt * mr(Kt, Rt);
          }, Vt = new WeakSet(), vl = function(Wt, er, lr) {
            if (Wt[0] === 0 && Wt[1] === 0 && Wt[2] === 0) {
              lr[0] = er[0], lr[1] = er[1], lr[2] = er[2];
              return;
            }
            const ur = Ur(this, Dt, Fo).call(this, 0), pr = ur, yr = Ur(this, Dt, Fo).call(this, Wt[0]), Er = ur, br = Ur(this, Dt, Fo).call(this, Wt[1]), gr = ur, Ar = Ur(this, Dt, Fo).call(this, Wt[2]), Sr = (1 - pr) / (1 - yr), Br = 1 - Sr, Ir = (1 - Er) / (1 - br), hr = 1 - Ir, vr = (1 - gr) / (1 - Ar), xr = 1 - vr;
            lr[0] = er[0] * Sr + Br, lr[1] = er[1] * Ir + hr, lr[2] = er[2] * vr + xr;
          }, qt = new WeakSet(), bl = function(Wt, er, lr) {
            if (Wt[0] === 1 && Wt[2] === 1) {
              lr[0] = er[0], lr[1] = er[1], lr[2] = er[2];
              return;
            }
            const ur = lr;
            Ur(this, kt, Mo).call(this, mr(Kt, Bt), er, ur);
            const pr = mr(Kt, Ct);
            Ur(this, Ht, ml).call(this, Wt, ur, pr), Ur(this, kt, Mo).call(this, mr(Kt, Ot), pr, lr);
          }, ar = new WeakSet(), xl = function(Wt, er, lr) {
            const ur = lr;
            Ur(this, kt, Mo).call(this, mr(Kt, Bt), er, ur);
            const pr = mr(Kt, Ct);
            Ur(this, _t, Al).call(this, Wt, ur, pr), Ur(this, kt, Mo).call(this, mr(Kt, Ot), pr, lr);
          }, rr = new WeakSet(), $s = function(Wt, er, lr, ur, pr) {
            const yr = Ur(this, $t, ko).call(this, 0, 1, Wt[er] * pr), Er = Ur(this, $t, ko).call(this, 0, 1, Wt[er + 1] * pr), br = Ur(this, $t, ko).call(this, 0, 1, Wt[er + 2] * pr), gr = yr === 1 ? 1 : yr ** this.GR, Ar = Er === 1 ? 1 : Er ** this.GG, Sr = br === 1 ? 1 : br ** this.GB, Br = this.MXA * gr + this.MXB * Ar + this.MXC * Sr, Ir = this.MYA * gr + this.MYB * Ar + this.MYC * Sr, hr = this.MZA * gr + this.MZB * Ar + this.MZC * Sr, vr = mr(Kt, It);
            vr[0] = Br, vr[1] = Ir, vr[2] = hr;
            const xr = mr(Kt, yt);
            Ur(this, qt, bl).call(this, this.whitePoint, vr, xr);
            const Pr = mr(Kt, It);
            Ur(this, Vt, vl).call(this, this.blackPoint, xr, Pr);
            const Rr = mr(Kt, yt);
            Ur(this, ar, xl).call(this, mr(Kt, wt), Pr, Rr);
            const Dr = mr(Kt, It);
            Ur(this, kt, Mo).call(this, mr(Kt, Pt), Rr, Dr), lr[ur] = Ur(this, Mt, qo).call(this, Dr[0]) * 255, lr[ur + 1] = Ur(this, Mt, qo).call(this, Dr[1]) * 255, lr[ur + 2] = Ur(this, Mt, qo).call(this, Dr[2]) * 255;
          }, _r(Kt, Bt, new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296])), _r(Kt, Ot, new Float32Array([0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912, -85287e-7, 0.0400428, 0.9684867])), _r(Kt, Pt, new Float32Array([3.2404542, -1.5371385, -0.4985314, -0.969266, 1.8760108, 0.041556, 0.0556434, -0.2040259, 1.0572252])), _r(Kt, wt, new Float32Array([1, 1, 1])), _r(Kt, Ct, new Float32Array(3)), _r(Kt, It, new Float32Array(3)), _r(Kt, yt, new Float32Array(3)), _r(Kt, Rt, 0.0011070564598794539);
          let vt = Kt;
          class At extends ut {
            constructor(Wt, er, lr) {
              super("Lab", 3);
              _r(this, nr);
              _r(this, ir);
              _r(this, cr);
              if (!Wt)
                throw new rt.FormatError("WhitePoint missing - required for color space Lab");
              if ([this.XW, this.YW, this.ZW] = Wt, [this.amin, this.amax, this.bmin, this.bmax] = lr || [-100, 100, -100, 100], [this.XB, this.YB, this.ZB] = er || [0, 0, 0], this.XW < 0 || this.ZW < 0 || this.YW !== 1)
                throw new rt.FormatError("Invalid WhitePoint components, no fallback available");
              (this.XB < 0 || this.YB < 0 || this.ZB < 0) && ((0, rt.info)("Invalid BlackPoint, falling back to default"), this.XB = this.YB = this.ZB = 0), (this.amin > this.amax || this.bmin > this.bmax) && ((0, rt.info)("Invalid Range, falling back to defaults"), this.amin = -100, this.amax = 100, this.bmin = -100, this.bmax = 100);
            }
            getRgbItem(Wt, er, lr, ur) {
              Ur(this, cr, Is).call(this, Wt, er, !1, lr, ur);
            }
            getRgbBuffer(Wt, er, lr, ur, pr, yr, Er) {
              const br = (1 << yr) - 1;
              for (let gr = 0; gr < lr; gr++)
                Ur(this, cr, Is).call(this, Wt, er, br, ur, pr), er += 3, pr += 3 + Er;
            }
            getOutputLength(Wt, er) {
              return Wt * (3 + er) / 3 | 0;
            }
            isDefaultDecode(Wt, er) {
              return !0;
            }
            get usesZeroToOneRange() {
              return (0, rt.shadow)(this, "usesZeroToOneRange", !1);
            }
          }
          nr = new WeakSet(), Jo = function(Wt) {
            return Wt >= 0.20689655172413793 ? Wt ** 3 : 0.12841854934601665 * (Wt - 0.13793103448275862);
          }, ir = new WeakSet(), ts = function(Wt, er, lr, ur) {
            return lr + Wt * (ur - lr) / er;
          }, cr = new WeakSet(), Is = function(Wt, er, lr, ur, pr) {
            let yr = Wt[er], Er = Wt[er + 1], br = Wt[er + 2];
            lr !== !1 && (yr = Ur(this, ir, ts).call(this, yr, lr, 0, 100), Er = Ur(this, ir, ts).call(this, Er, lr, this.amin, this.amax), br = Ur(this, ir, ts).call(this, br, lr, this.bmin, this.bmax)), Er > this.amax ? Er = this.amax : Er < this.amin && (Er = this.amin), br > this.bmax ? br = this.bmax : br < this.bmin && (br = this.bmin);
            const gr = (yr + 16) / 116, Ar = gr + Er / 500, Sr = gr - br / 200, Br = this.XW * Ur(this, nr, Jo).call(this, Ar), Ir = this.YW * Ur(this, nr, Jo).call(this, gr), hr = this.ZW * Ur(this, nr, Jo).call(this, Sr);
            let vr, xr, Pr;
            this.ZW < 1 ? (vr = Br * 3.1339 + Ir * -1.617 + hr * -0.4906, xr = Br * -0.9785 + Ir * 1.916 + hr * 0.0333, Pr = Br * 0.072 + Ir * -0.229 + hr * 1.4057) : (vr = Br * 3.2406 + Ir * -1.5372 + hr * -0.4986, xr = Br * -0.9689 + Ir * 1.8758 + hr * 0.0415, Pr = Br * 0.0557 + Ir * -0.204 + hr * 1.057), ur[pr] = Math.sqrt(vr) * 255, ur[pr + 1] = Math.sqrt(xr) * 255, ur[pr + 2] = Math.sqrt(Pr) * 255;
          };
        },
        /* 164 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.PartialEvaluator = at.EvaluatorPreprocessor = void 0, ot(140), ot(2), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138), ot(158), ot(160);
          var rt = ot(145), st = ot(165), lt = ot(151), et = ot(185), it = ot(188), ut = ot(192), ft = ot(201), ht = ot(202), dt = ot(193), gt = ot(208), pt = ot(167), mt = ot(210), ct = ot(155), vt = ot(152), At = ot(211), xt = ot(163), bt = ot(169), Et = ot(189), St = ot(212), Bt = ot(190), Ot = ot(196), Pt = ot(191), wt = ot(213), Ct = ot(214), It = ot(215), yt = ot(216);
          const Rt = Object.freeze({
            maxImageSize: -1,
            disableFontFace: !1,
            ignoreErrors: !1,
            isEvalSupported: !0,
            isOffscreenCanvasSupported: !1,
            canvasMaxAreaInBytes: -1,
            fontExtraProperties: !1,
            useSystemFonts: !0,
            cMapUrl: null,
            standardFontDataUrl: null
          }), kt = {
            TILING: 1,
            SHADING: 2
          }, jt = 10, Ht = Promise.resolve();
          function Ft(qt) {
            let Zt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            if (Array.isArray(qt)) {
              for (const ar of qt) {
                const Jt = Ft(ar, !0);
                if (Jt)
                  return Jt;
              }
              return (0, rt.warn)(`Unsupported blend mode Array: ${qt}`), "source-over";
            }
            if (!(qt instanceof lt.Name))
              return Zt ? null : "source-over";
            switch (qt.name) {
              case "Normal":
              case "Compatible":
                return "source-over";
              case "Multiply":
                return "multiply";
              case "Screen":
                return "screen";
              case "Overlay":
                return "overlay";
              case "Darken":
                return "darken";
              case "Lighten":
                return "lighten";
              case "ColorDodge":
                return "color-dodge";
              case "ColorBurn":
                return "color-burn";
              case "HardLight":
                return "hard-light";
              case "SoftLight":
                return "soft-light";
              case "Difference":
                return "difference";
              case "Exclusion":
                return "exclusion";
              case "Hue":
                return "hue";
              case "Saturation":
                return "saturation";
              case "Color":
                return "color";
              case "Luminosity":
                return "luminosity";
            }
            return Zt ? null : ((0, rt.warn)(`Unsupported blend mode: ${qt.name}`), "source-over");
          }
          function _t(qt) {
            var Zt;
            qt.fn === rt.OPS.paintImageMaskXObject && ((Zt = qt.args[0]) == null ? void 0 : Zt.count) > 0 && qt.args[0].count++;
          }
          const Vt = class Vt {
            constructor() {
              this.reset();
            }
            check() {
              return ++this.checked < Vt.CHECK_TIME_EVERY ? !1 : (this.checked = 0, this.endTime <= Date.now());
            }
            reset() {
              this.endTime = Date.now() + Vt.TIME_SLOT_DURATION_MS, this.checked = 0;
            }
          };
          Ln(Vt, "TIME_SLOT_DURATION_MS", 20), Ln(Vt, "CHECK_TIME_EVERY", 100);
          let Nt = Vt;
          class Mt {
            constructor(Zt) {
              let {
                xref: ar,
                handler: Jt,
                pageIndex: rr,
                idFactory: Yt,
                fontCache: Kt,
                builtInCMapCache: nr,
                standardFontDataCache: tr,
                globalImageCache: ir,
                systemFontCache: sr,
                options: cr = null
              } = Zt;
              this.xref = ar, this.handler = Jt, this.pageIndex = rr, this.idFactory = Yt, this.fontCache = Kt, this.builtInCMapCache = nr, this.standardFontDataCache = tr, this.globalImageCache = ir, this.systemFontCache = sr, this.options = cr || Rt, this.parsingType3Font = !1, this._regionalImageCache = new mt.RegionalImageCache(), this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this), wt.ImageResizer.setMaxArea(this.options.canvasMaxAreaInBytes);
            }
            get _pdfFunctionFactory() {
              const Zt = new gt.PDFFunctionFactory({
                xref: this.xref,
                isEvalSupported: this.options.isEvalSupported
              });
              return (0, rt.shadow)(this, "_pdfFunctionFactory", Zt);
            }
            clone() {
              let Zt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              const ar = Object.create(this);
              return ar.options = Object.assign(/* @__PURE__ */ Object.create(null), this.options, Zt), ar;
            }
            hasBlendModes(Zt, ar) {
              if (!(Zt instanceof lt.Dict) || Zt.objId && ar.has(Zt.objId))
                return !1;
              const Jt = new lt.RefSet(ar);
              Zt.objId && Jt.put(Zt.objId);
              const rr = [Zt], Yt = this.xref;
              for (; rr.length; ) {
                const Kt = rr.shift(), nr = Kt.get("ExtGState");
                if (nr instanceof lt.Dict)
                  for (let ir of nr.getRawValues()) {
                    if (ir instanceof lt.Ref) {
                      if (Jt.has(ir))
                        continue;
                      try {
                        ir = Yt.fetch(ir);
                      } catch (cr) {
                        Jt.put(ir), (0, rt.info)(`hasBlendModes - ignoring ExtGState: "${cr}".`);
                        continue;
                      }
                    }
                    if (!(ir instanceof lt.Dict))
                      continue;
                    ir.objId && Jt.put(ir.objId);
                    const sr = ir.get("BM");
                    if (sr instanceof lt.Name) {
                      if (sr.name !== "Normal")
                        return !0;
                      continue;
                    }
                    if (sr !== void 0 && Array.isArray(sr)) {
                      for (const cr of sr)
                        if (cr instanceof lt.Name && cr.name !== "Normal")
                          return !0;
                    }
                  }
                const tr = Kt.get("XObject");
                if (tr instanceof lt.Dict)
                  for (let ir of tr.getRawValues()) {
                    if (ir instanceof lt.Ref) {
                      if (Jt.has(ir))
                        continue;
                      try {
                        ir = Yt.fetch(ir);
                      } catch (cr) {
                        Jt.put(ir), (0, rt.info)(`hasBlendModes - ignoring XObject: "${cr}".`);
                        continue;
                      }
                    }
                    if (!(ir instanceof vt.BaseStream))
                      continue;
                    ir.dict.objId && Jt.put(ir.dict.objId);
                    const sr = ir.dict.get("Resources");
                    sr instanceof lt.Dict && (sr.objId && Jt.has(sr.objId) || (rr.push(sr), sr.objId && Jt.put(sr.objId)));
                  }
              }
              for (const Kt of Jt)
                ar.put(Kt);
              return !1;
            }
            async fetchBuiltInCMap(Zt) {
              const ar = this.builtInCMapCache.get(Zt);
              if (ar)
                return ar;
              let Jt;
              if (this.options.cMapUrl !== null) {
                const rr = `${this.options.cMapUrl}${Zt}.bcmap`, Yt = await fetch(rr);
                if (!Yt.ok)
                  throw new Error(`fetchBuiltInCMap: failed to fetch file "${rr}" with "${Yt.statusText}".`);
                Jt = {
                  cMapData: new Uint8Array(await Yt.arrayBuffer()),
                  compressionType: rt.CMapCompressionType.BINARY
                };
              } else
                Jt = await this.handler.sendWithPromise("FetchBuiltInCMap", {
                  name: Zt
                });
              return Jt.compressionType !== rt.CMapCompressionType.NONE && this.builtInCMapCache.set(Zt, Jt), Jt;
            }
            async fetchStandardFontData(Zt) {
              const ar = this.standardFontDataCache.get(Zt);
              if (ar)
                return new ct.Stream(ar);
              if (this.options.useSystemFonts && Zt !== "Symbol" && Zt !== "ZapfDingbats")
                return null;
              const Jt = (0, ut.getFontNameToFileMap)(), rr = Jt[Zt];
              let Yt;
              if (this.options.standardFontDataUrl !== null) {
                const Kt = `${this.options.standardFontDataUrl}${rr}`, nr = await fetch(Kt);
                nr.ok ? Yt = await nr.arrayBuffer() : (0, rt.warn)(`fetchStandardFontData: failed to fetch file "${Kt}" with "${nr.statusText}".`);
              } else
                try {
                  Yt = await this.handler.sendWithPromise("FetchStandardFontData", {
                    filename: rr
                  });
                } catch (Kt) {
                  (0, rt.warn)(`fetchStandardFontData: failed to fetch file "${rr}" with "${Kt}".`);
                }
              return Yt ? (this.standardFontDataCache.set(Zt, Yt), new ct.Stream(Yt)) : null;
            }
            async buildFormXObject(Zt, ar, Jt, rr, Yt, Kt, nr) {
              const tr = ar.dict, ir = tr.getArray("Matrix");
              let sr = tr.getArray("BBox");
              sr = Array.isArray(sr) && sr.length === 4 ? rt.Util.normalizeRect(sr) : null;
              let cr, or;
              tr.has("OC") && (cr = await this.parseMarkedContentProps(tr.get("OC"), Zt)), cr !== void 0 && rr.addOp(rt.OPS.beginMarkedContentProps, ["OC", cr]);
              const Xt = tr.get("Group");
              if (Xt) {
                or = {
                  matrix: ir,
                  bbox: sr,
                  smask: Jt,
                  isolated: !1,
                  knockout: !1
                };
                const Wt = Xt.get("S");
                let er = null;
                if ((0, lt.isName)(Wt, "Transparency") && (or.isolated = Xt.get("I") || !1, or.knockout = Xt.get("K") || !1, Xt.has("CS"))) {
                  const lr = Xt.getRaw("CS"), ur = xt.ColorSpace.getCached(lr, this.xref, nr);
                  ur ? er = ur : er = await this.parseColorSpace({
                    cs: lr,
                    resources: Zt,
                    localColorSpaceCache: nr
                  });
                }
                Jt != null && Jt.backdrop && (er || (er = xt.ColorSpace.singletons.rgb), Jt.backdrop = er.getRgb(Jt.backdrop, 0)), rr.addOp(rt.OPS.beginGroup, [or]);
              }
              const Gt = Xt ? [ir, null] : [ir, sr];
              return rr.addOp(rt.OPS.paintFormXObjectBegin, Gt), this.getOperatorList({
                stream: ar,
                task: Yt,
                resources: tr.get("Resources") || Zt,
                operatorList: rr,
                initialState: Kt
              }).then(function() {
                rr.addOp(rt.OPS.paintFormXObjectEnd, []), Xt && rr.addOp(rt.OPS.endGroup, [or]), cr !== void 0 && rr.addOp(rt.OPS.endMarkedContent, []);
              });
            }
            _sendImgData(Zt, ar) {
              let Jt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
              const rr = ar ? [ar.bitmap || ar.data.buffer] : null;
              return this.parsingType3Font || Jt ? this.handler.send("commonobj", [Zt, "Image", ar], rr) : this.handler.send("obj", [Zt, this.pageIndex, "Image", ar], rr);
            }
            async buildPaintImageXObject(Zt) {
              let {
                resources: ar,
                image: Jt,
                isInline: rr = !1,
                operatorList: Yt,
                cacheKey: Kt,
                localImageCache: nr,
                localColorSpaceCache: tr
              } = Zt;
              const ir = Jt.dict, sr = ir.objId, cr = ir.get("W", "Width"), or = ir.get("H", "Height");
              if (!(cr && typeof cr == "number") || !(or && typeof or == "number")) {
                (0, rt.warn)("Image dimensions are missing, or not numbers.");
                return;
              }
              const Xt = this.options.maxImageSize;
              if (Xt !== -1 && cr * or > Xt) {
                const Er = "Image exceeded maximum allowed size and was removed.";
                if (this.options.ignoreErrors) {
                  (0, rt.warn)(Er);
                  return;
                }
                throw new Error(Er);
              }
              let Gt;
              ir.has("OC") && (Gt = await this.parseMarkedContentProps(ir.get("OC"), ar));
              const Wt = ir.get("IM", "ImageMask") || !1;
              let er, lr;
              if (Wt) {
                const Er = ir.get("I", "Interpolate"), br = cr + 7 >> 3, gr = Jt.getBytes(br * or), Ar = ir.getArray("D", "Decode");
                if (this.parsingType3Font) {
                  if (er = yt.PDFImage.createRawMask({
                    imgArray: gr,
                    width: cr,
                    height: or,
                    imageIsFromDecodeStream: Jt instanceof bt.DecodeStream,
                    inverseDecode: (Ar == null ? void 0 : Ar[0]) > 0,
                    interpolate: Er
                  }), er.cached = !!Kt, lr = [er], Yt.addImageOps(rt.OPS.paintImageMaskXObject, lr, Gt), Kt) {
                    const Br = {
                      fn: rt.OPS.paintImageMaskXObject,
                      args: lr,
                      optionalContent: Gt
                    };
                    nr.set(Kt, sr, Br), sr && this._regionalImageCache.set(null, sr, Br);
                  }
                  return;
                }
                if (er = await yt.PDFImage.createMask({
                  imgArray: gr,
                  width: cr,
                  height: or,
                  imageIsFromDecodeStream: Jt instanceof bt.DecodeStream,
                  inverseDecode: (Ar == null ? void 0 : Ar[0]) > 0,
                  interpolate: Er,
                  isOffscreenCanvasSupported: this.options.isOffscreenCanvasSupported
                }), er.isSingleOpaquePixel) {
                  if (Yt.addImageOps(rt.OPS.paintSolidColorImageMask, [], Gt), Kt) {
                    const Br = {
                      fn: rt.OPS.paintSolidColorImageMask,
                      args: [],
                      optionalContent: Gt
                    };
                    nr.set(Kt, sr, Br), sr && this._regionalImageCache.set(null, sr, Br);
                  }
                  return;
                }
                const Sr = `mask_${this.idFactory.createObjId()}`;
                if (Yt.addDependency(Sr), this._sendImgData(Sr, er), lr = [{
                  data: Sr,
                  width: er.width,
                  height: er.height,
                  interpolate: er.interpolate,
                  count: 1
                }], Yt.addImageOps(rt.OPS.paintImageMaskXObject, lr, Gt), Kt) {
                  const Br = {
                    fn: rt.OPS.paintImageMaskXObject,
                    args: lr,
                    optionalContent: Gt
                  };
                  nr.set(Kt, sr, Br), sr && this._regionalImageCache.set(null, sr, Br);
                }
                return;
              }
              const ur = 200;
              if (rr && !ir.has("SMask") && !ir.has("Mask") && cr + or < ur) {
                er = await new yt.PDFImage({
                  xref: this.xref,
                  res: ar,
                  image: Jt,
                  isInline: rr,
                  pdfFunctionFactory: this._pdfFunctionFactory,
                  localColorSpaceCache: tr
                }).createImageData(!0, !1), Yt.isOffscreenCanvasSupported = this.options.isOffscreenCanvasSupported, Yt.addImageOps(rt.OPS.paintInlineImageXObject, [er], Gt);
                return;
              }
              let pr = `img_${this.idFactory.createObjId()}`, yr = !1;
              if (this.parsingType3Font ? pr = `${this.idFactory.getDocId()}_type3_${pr}` : sr && (yr = this.globalImageCache.shouldCache(sr, this.pageIndex), yr && (pr = `${this.idFactory.getDocId()}_${pr}`)), Yt.addDependency(pr), lr = [pr, cr, or], yt.PDFImage.buildImage({
                xref: this.xref,
                res: ar,
                image: Jt,
                isInline: rr,
                pdfFunctionFactory: this._pdfFunctionFactory,
                localColorSpaceCache: tr
              }).then(async (Er) => {
                if (er = await Er.createImageData(!1, this.options.isOffscreenCanvasSupported), Kt && sr && yr) {
                  const br = er.bitmap ? er.width * er.height * 4 : er.data.length;
                  this.globalImageCache.addByteSize(sr, br);
                }
                return this._sendImgData(pr, er, yr);
              }).catch((Er) => ((0, rt.warn)(`Unable to decode image "${pr}": "${Er}".`), this._sendImgData(pr, null, yr))), Yt.addImageOps(rt.OPS.paintImageXObject, lr, Gt), Kt) {
                const Er = {
                  fn: rt.OPS.paintImageXObject,
                  args: lr,
                  optionalContent: Gt
                };
                nr.set(Kt, sr, Er), sr && (this._regionalImageCache.set(null, sr, Er), yr && ((0, rt.assert)(!rr, "Cannot cache an inline image globally."), this.globalImageCache.setData(sr, {
                  objId: pr,
                  fn: rt.OPS.paintImageXObject,
                  args: lr,
                  optionalContent: Gt,
                  byteSize: 0
                })));
              }
            }
            handleSMask(Zt, ar, Jt, rr, Yt, Kt) {
              const nr = Zt.get("G"), tr = {
                subtype: Zt.get("S").name,
                backdrop: Zt.get("BC")
              }, ir = Zt.get("TR");
              if ((0, gt.isPDFFunction)(ir)) {
                const sr = this._pdfFunctionFactory.create(ir), cr = new Uint8Array(256), or = new Float32Array(1);
                for (let Xt = 0; Xt < 256; Xt++)
                  or[0] = Xt / 255, sr(or, 0, or, 0), cr[Xt] = or[0] * 255 | 0;
                tr.transferMap = cr;
              }
              return this.buildFormXObject(ar, nr, tr, Jt, rr, Yt.state.clone(), Kt);
            }
            handleTransferFunction(Zt) {
              let ar;
              if (Array.isArray(Zt))
                ar = Zt;
              else if ((0, gt.isPDFFunction)(Zt))
                ar = [Zt];
              else
                return null;
              const Jt = [];
              let rr = 0, Yt = 0;
              for (const Kt of ar) {
                const nr = this.xref.fetchIfRef(Kt);
                if (rr++, (0, lt.isName)(nr, "Identity")) {
                  Jt.push(null);
                  continue;
                } else if (!(0, gt.isPDFFunction)(nr))
                  return null;
                const tr = this._pdfFunctionFactory.create(nr), ir = new Uint8Array(256), sr = new Float32Array(1);
                for (let cr = 0; cr < 256; cr++)
                  sr[0] = cr / 255, tr(sr, 0, sr, 0), ir[cr] = sr[0] * 255 | 0;
                Jt.push(ir), Yt++;
              }
              return !(rr === 1 || rr === 4) || Yt === 0 ? null : Jt;
            }
            handleTilingType(Zt, ar, Jt, rr, Yt, Kt, nr, tr) {
              const ir = new It.OperatorList(), sr = lt.Dict.merge({
                xref: this.xref,
                dictArray: [Yt.get("Resources"), Jt]
              });
              return this.getOperatorList({
                stream: rr,
                task: nr,
                resources: sr,
                operatorList: ir
              }).then(function() {
                const cr = ir.getIR(), or = (0, ft.getTilingPatternIR)(cr, Yt, ar);
                Kt.addDependencies(ir.dependencies), Kt.addOp(Zt, or), Yt.objId && tr.set(null, Yt.objId, {
                  operatorListIR: cr,
                  dict: Yt
                });
              }).catch((cr) => {
                if (!(cr instanceof rt.AbortException)) {
                  if (this.options.ignoreErrors) {
                    (0, rt.warn)(`handleTilingType - ignoring pattern: "${cr}".`);
                    return;
                  }
                  throw cr;
                }
              });
            }
            handleSetFont(Zt, ar, Jt, rr, Yt, Kt) {
              let nr = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, tr = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
              const ir = (ar == null ? void 0 : ar[0]) instanceof lt.Name ? ar[0].name : null;
              return this.loadFont(ir, Jt, Zt, nr, tr).then((sr) => sr.font.isType3Font ? sr.loadType3Data(this, Zt, Yt).then(function() {
                return rr.addDependencies(sr.type3Dependencies), sr;
              }).catch((cr) => new Lt({
                loadedName: "g_font_error",
                font: new et.ErrorFont(`Type3 font load error: ${cr}`),
                dict: sr.font,
                evaluatorOptions: this.options
              })) : sr).then((sr) => (Kt.font = sr.font, sr.send(this.handler), sr.loadedName));
            }
            handleText(Zt, ar) {
              const Jt = ar.font, rr = Jt.charsToGlyphs(Zt);
              return Jt.data && (ar.textRenderingMode & rt.TextRenderingMode.ADD_TO_PATH_FLAG || ar.fillColorSpace.name === "Pattern" || Jt.disableFontFace || this.options.disableFontFace) && Mt.buildFontPaths(Jt, rr, this.handler, this.options), rr;
            }
            ensureStateFont(Zt) {
              if (Zt.font)
                return;
              const ar = new rt.FormatError("Missing setFont (Tf) operator before text rendering operator.");
              if (this.options.ignoreErrors) {
                (0, rt.warn)(`ensureStateFont: "${ar}".`);
                return;
              }
              throw ar;
            }
            async setGState(Zt) {
              let {
                resources: ar,
                gState: Jt,
                operatorList: rr,
                cacheKey: Yt,
                task: Kt,
                stateManager: nr,
                localGStateCache: tr,
                localColorSpaceCache: ir
              } = Zt;
              const sr = Jt.objId;
              let cr = !0;
              const or = [];
              let Xt = Promise.resolve();
              for (const Gt of Jt.getKeys()) {
                const Wt = Jt.get(Gt);
                switch (Gt) {
                  case "Type":
                    break;
                  case "LW":
                  case "LC":
                  case "LJ":
                  case "ML":
                  case "D":
                  case "RI":
                  case "FL":
                  case "CA":
                  case "ca":
                    or.push([Gt, Wt]);
                    break;
                  case "Font":
                    cr = !1, Xt = Xt.then(() => this.handleSetFont(ar, null, Wt[0], rr, Kt, nr.state).then(function(lr) {
                      rr.addDependency(lr), or.push([Gt, [lr, Wt[1]]]);
                    }));
                    break;
                  case "BM":
                    or.push([Gt, Ft(Wt)]);
                    break;
                  case "SMask":
                    if ((0, lt.isName)(Wt, "None")) {
                      or.push([Gt, !1]);
                      break;
                    }
                    Wt instanceof lt.Dict ? (cr = !1, Xt = Xt.then(() => this.handleSMask(Wt, ar, rr, Kt, nr, ir)), or.push([Gt, !0])) : (0, rt.warn)("Unsupported SMask type");
                    break;
                  case "TR":
                    const er = this.handleTransferFunction(Wt);
                    or.push([Gt, er]);
                    break;
                  case "OP":
                  case "op":
                  case "OPM":
                  case "BG":
                  case "BG2":
                  case "UCR":
                  case "UCR2":
                  case "TR2":
                  case "HT":
                  case "SM":
                  case "SA":
                  case "AIS":
                  case "TK":
                    (0, rt.info)("graphic state operator " + Gt);
                    break;
                  default:
                    (0, rt.info)("Unknown graphic state operator " + Gt);
                    break;
                }
              }
              return Xt.then(function() {
                or.length > 0 && rr.addOp(rt.OPS.setGState, [or]), cr && tr.set(Yt, sr, or);
              });
            }
            loadFont(Zt, ar, Jt) {
              let rr = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, Yt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
              const Kt = async () => new Lt({
                loadedName: "g_font_error",
                font: new et.ErrorFont(`Font "${Zt}" is not available.`),
                dict: ar,
                evaluatorOptions: this.options
              });
              let nr;
              if (ar)
                ar instanceof lt.Ref && (nr = ar);
              else {
                const Gt = Jt.get("Font");
                Gt && (nr = Gt.getRaw(Zt));
              }
              if (nr) {
                if (this.parsingType3Font && this.type3FontRefs.has(nr))
                  return Kt();
                if (this.fontCache.has(nr))
                  return this.fontCache.get(nr);
                ar = this.xref.fetchIfRef(nr);
              }
              if (!(ar instanceof lt.Dict)) {
                if (!this.options.ignoreErrors && !this.parsingType3Font)
                  return (0, rt.warn)(`Font "${Zt}" is not available.`), Kt();
                (0, rt.warn)(`Font "${Zt}" is not available -- attempting to fallback to a default font.`), ar = rr || Mt.fallbackFontDict;
              }
              if (ar.cacheKey && this.fontCache.has(ar.cacheKey))
                return this.fontCache.get(ar.cacheKey);
              const tr = new rt.PromiseCapability();
              let ir;
              try {
                ir = this.preEvaluateFont(ar), ir.cssFontInfo = Yt;
              } catch (Gt) {
                return (0, rt.warn)(`loadFont - preEvaluateFont failed: "${Gt}".`), Kt();
              }
              const {
                descriptor: sr,
                hash: cr
              } = ir, or = nr instanceof lt.Ref;
              let Xt;
              if (cr && sr instanceof lt.Dict) {
                const Gt = sr.fontAliases || (sr.fontAliases = /* @__PURE__ */ Object.create(null));
                if (Gt[cr]) {
                  const Wt = Gt[cr].aliasRef;
                  if (or && Wt && this.fontCache.has(Wt))
                    return this.fontCache.putAlias(nr, Wt), this.fontCache.get(nr);
                } else
                  Gt[cr] = {
                    fontID: this.idFactory.createFontId()
                  };
                or && (Gt[cr].aliasRef = nr), Xt = Gt[cr].fontID;
              } else
                Xt = this.idFactory.createFontId();
              return (0, rt.assert)(Xt == null ? void 0 : Xt.startsWith("f"), 'The "fontID" must be (correctly) defined.'), or ? this.fontCache.put(nr, tr.promise) : (ar.cacheKey = `cacheKey_${Xt}`, this.fontCache.put(ar.cacheKey, tr.promise)), ar.loadedName = `${this.idFactory.getDocId()}_${Xt}`, this.translateFont(ir).then((Gt) => {
                tr.resolve(new Lt({
                  loadedName: ar.loadedName,
                  font: Gt,
                  dict: ar,
                  evaluatorOptions: this.options
                }));
              }).catch((Gt) => {
                (0, rt.warn)(`loadFont - translateFont failed: "${Gt}".`), tr.resolve(new Lt({
                  loadedName: ar.loadedName,
                  font: new et.ErrorFont(Gt instanceof Error ? Gt.message : Gt),
                  dict: ar,
                  evaluatorOptions: this.options
                }));
              }), tr.promise;
            }
            buildPath(Zt, ar, Jt) {
              let rr = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
              const Yt = Zt.length - 1;
              if (Jt || (Jt = []), Yt < 0 || Zt.fnArray[Yt] !== rt.OPS.constructPath) {
                rr && ((0, rt.warn)(`Encountered path operator "${ar}" inside of a text object.`), Zt.addOp(rt.OPS.save, null));
                let Kt;
                switch (ar) {
                  case rt.OPS.rectangle:
                    const nr = Jt[0] + Jt[2], tr = Jt[1] + Jt[3];
                    Kt = [Math.min(Jt[0], nr), Math.max(Jt[0], nr), Math.min(Jt[1], tr), Math.max(Jt[1], tr)];
                    break;
                  case rt.OPS.moveTo:
                  case rt.OPS.lineTo:
                    Kt = [Jt[0], Jt[0], Jt[1], Jt[1]];
                    break;
                  default:
                    Kt = [1 / 0, -1 / 0, 1 / 0, -1 / 0];
                    break;
                }
                Zt.addOp(rt.OPS.constructPath, [[ar], Jt, Kt]), rr && Zt.addOp(rt.OPS.restore, null);
              } else {
                const Kt = Zt.argsArray[Yt];
                Kt[0].push(ar), Kt[1].push(...Jt);
                const nr = Kt[2];
                switch (ar) {
                  case rt.OPS.rectangle:
                    const tr = Jt[0] + Jt[2], ir = Jt[1] + Jt[3];
                    nr[0] = Math.min(nr[0], Jt[0], tr), nr[1] = Math.max(nr[1], Jt[0], tr), nr[2] = Math.min(nr[2], Jt[1], ir), nr[3] = Math.max(nr[3], Jt[1], ir);
                    break;
                  case rt.OPS.moveTo:
                  case rt.OPS.lineTo:
                    nr[0] = Math.min(nr[0], Jt[0]), nr[1] = Math.max(nr[1], Jt[0]), nr[2] = Math.min(nr[2], Jt[1]), nr[3] = Math.max(nr[3], Jt[1]);
                    break;
                }
              }
            }
            parseColorSpace(Zt) {
              let {
                cs: ar,
                resources: Jt,
                localColorSpaceCache: rr
              } = Zt;
              return xt.ColorSpace.parseAsync({
                cs: ar,
                xref: this.xref,
                resources: Jt,
                pdfFunctionFactory: this._pdfFunctionFactory,
                localColorSpaceCache: rr
              }).catch((Yt) => {
                if (Yt instanceof rt.AbortException)
                  return null;
                if (this.options.ignoreErrors)
                  return (0, rt.warn)(`parseColorSpace - ignoring ColorSpace: "${Yt}".`), null;
                throw Yt;
              });
            }
            parseShading(Zt) {
              let {
                shading: ar,
                resources: Jt,
                localColorSpaceCache: rr,
                localShadingPatternCache: Yt
              } = Zt, Kt = Yt.get(ar);
              if (!Kt) {
                var nr = ft.Pattern.parseShading(ar, this.xref, Jt, this._pdfFunctionFactory, rr);
                const tr = nr.getIR();
                Kt = `pattern_${this.idFactory.createObjId()}`, this.parsingType3Font && (Kt = `${this.idFactory.getDocId()}_type3_${Kt}`), Yt.set(ar, Kt), this.parsingType3Font ? this.handler.send("commonobj", [Kt, "Pattern", tr]) : this.handler.send("obj", [Kt, this.pageIndex, "Pattern", tr]);
              }
              return Kt;
            }
            handleColorN(Zt, ar, Jt, rr, Yt, Kt, nr, tr, ir, sr) {
              const cr = Jt.pop();
              if (cr instanceof lt.Name) {
                const or = Yt.getRaw(cr.name), Xt = or instanceof lt.Ref && ir.getByRef(or);
                if (Xt)
                  try {
                    const Wt = rr.base ? rr.base.getRgb(Jt, 0) : null, er = (0, ft.getTilingPatternIR)(Xt.operatorListIR, Xt.dict, Wt);
                    Zt.addOp(ar, er);
                    return;
                  } catch {
                  }
                const Gt = this.xref.fetchIfRef(or);
                if (Gt) {
                  const Wt = Gt instanceof vt.BaseStream ? Gt.dict : Gt, er = Wt.get("PatternType");
                  if (er === kt.TILING) {
                    const lr = rr.base ? rr.base.getRgb(Jt, 0) : null;
                    return this.handleTilingType(ar, lr, Kt, Gt, Wt, Zt, nr, ir);
                  } else if (er === kt.SHADING) {
                    const lr = Wt.get("Shading"), ur = Wt.getArray("Matrix"), pr = this.parseShading({
                      shading: lr,
                      resources: Kt,
                      localColorSpaceCache: tr,
                      localShadingPatternCache: sr
                    });
                    Zt.addOp(ar, ["Shading", pr, ur]);
                    return;
                  }
                  throw new rt.FormatError(`Unknown PatternType: ${er}`);
                }
              }
              throw new rt.FormatError(`Unknown PatternName: ${cr}`);
            }
            _parseVisibilityExpression(Zt, ar, Jt) {
              if (++ar > 10) {
                (0, rt.warn)("Visibility expression is too deeply nested");
                return;
              }
              const Yt = Zt.length, Kt = this.xref.fetchIfRef(Zt[0]);
              if (Yt < 2 || !(Kt instanceof lt.Name)) {
                (0, rt.warn)("Invalid visibility expression");
                return;
              }
              switch (Kt.name) {
                case "And":
                case "Or":
                case "Not":
                  Jt.push(Kt.name);
                  break;
                default:
                  (0, rt.warn)(`Invalid operator ${Kt.name} in visibility expression`);
                  return;
              }
              for (let nr = 1; nr < Yt; nr++) {
                const tr = Zt[nr], ir = this.xref.fetchIfRef(tr);
                if (Array.isArray(ir)) {
                  const sr = [];
                  Jt.push(sr), this._parseVisibilityExpression(ir, ar, sr);
                } else
                  tr instanceof lt.Ref && Jt.push(tr.toString());
              }
            }
            async parseMarkedContentProps(Zt, ar) {
              var Yt;
              let Jt;
              if (Zt instanceof lt.Name)
                Jt = ar.get("Properties").get(Zt.name);
              else if (Zt instanceof lt.Dict)
                Jt = Zt;
              else
                throw new rt.FormatError("Optional content properties malformed.");
              const rr = (Yt = Jt.get("Type")) == null ? void 0 : Yt.name;
              if (rr === "OCG")
                return {
                  type: rr,
                  id: Jt.objId
                };
              if (rr === "OCMD") {
                const Kt = Jt.get("VE");
                if (Array.isArray(Kt)) {
                  const tr = [];
                  if (this._parseVisibilityExpression(Kt, 0, tr), tr.length > 0)
                    return {
                      type: "OCMD",
                      expression: tr
                    };
                }
                const nr = Jt.get("OCGs");
                if (Array.isArray(nr) || nr instanceof lt.Dict) {
                  const tr = [];
                  if (Array.isArray(nr))
                    for (const ir of nr)
                      tr.push(ir.toString());
                  else
                    tr.push(nr.objId);
                  return {
                    type: rr,
                    ids: tr,
                    policy: Jt.get("P") instanceof lt.Name ? Jt.get("P").name : null,
                    expression: null
                  };
                } else if (nr instanceof lt.Ref)
                  return {
                    type: rr,
                    id: nr.toString()
                  };
              }
              return null;
            }
            getOperatorList(Zt) {
              let {
                stream: ar,
                task: Jt,
                resources: rr,
                operatorList: Yt,
                initialState: Kt = null,
                fallbackFontDict: nr = null
              } = Zt;
              if (rr || (rr = lt.Dict.empty), Kt || (Kt = new Dt()), !Yt)
                throw new Error('getOperatorList: missing "operatorList" parameter');
              const tr = this, ir = this.xref;
              let sr = !1;
              const cr = new mt.LocalImageCache(), or = new mt.LocalColorSpaceCache(), Xt = new mt.LocalGStateCache(), Gt = new mt.LocalTilingPatternCache(), Wt = /* @__PURE__ */ new Map(), er = rr.get("XObject") || lt.Dict.empty, lr = rr.get("Pattern") || lt.Dict.empty, ur = new $t(Kt), pr = new Ut(ar, ir, ur), yr = new Nt();
              function Er(br) {
                for (let gr = 0, Ar = pr.savedStatesDepth; gr < Ar; gr++)
                  Yt.addOp(rt.OPS.restore, []);
              }
              return new Promise(function br(gr, Ar) {
                const Sr = function(fr) {
                  Promise.all([fr, Yt.ready]).then(function() {
                    try {
                      br(gr, Ar);
                    } catch (Cr) {
                      Ar(Cr);
                    }
                  }, Ar);
                };
                Jt.ensureNotTerminated(), yr.reset();
                const Br = {};
                let Ir, hr, vr, xr, Pr, Rr;
                for (; !(Ir = yr.check()) && (Br.args = null, !!pr.read(Br)); ) {
                  let fr = Br.args, Cr = Br.fn;
                  switch (Cr | 0) {
                    case rt.OPS.paintXObject:
                      if (Rr = fr[0] instanceof lt.Name, Pr = fr[0].name, Rr) {
                        const wr = cr.getByName(Pr);
                        if (wr) {
                          Yt.addImageOps(wr.fn, wr.args, wr.optionalContent), _t(wr), fr = null;
                          continue;
                        }
                      }
                      Sr(new Promise(function(wr, Mr) {
                        if (!Rr)
                          throw new rt.FormatError("XObject must be referred to by name.");
                        let Fr = er.getRaw(Pr);
                        if (Fr instanceof lt.Ref) {
                          const Yr = cr.getByRef(Fr) || tr._regionalImageCache.getByRef(Fr);
                          if (Yr) {
                            Yt.addImageOps(Yr.fn, Yr.args, Yr.optionalContent), _t(Yr), wr();
                            return;
                          }
                          const kr = tr.globalImageCache.getData(Fr, tr.pageIndex);
                          if (kr) {
                            Yt.addDependency(kr.objId), Yt.addImageOps(kr.fn, kr.args, kr.optionalContent), wr();
                            return;
                          }
                          Fr = ir.fetch(Fr);
                        }
                        if (!(Fr instanceof vt.BaseStream))
                          throw new rt.FormatError("XObject should be a stream");
                        const Qr = Fr.dict.get("Subtype");
                        if (!(Qr instanceof lt.Name))
                          throw new rt.FormatError("XObject should have a Name subtype");
                        if (Qr.name === "Form") {
                          ur.save(), tr.buildFormXObject(rr, Fr, null, Yt, Jt, ur.state.clone(), or).then(function() {
                            ur.restore(), wr();
                          }, Mr);
                          return;
                        } else if (Qr.name === "Image") {
                          tr.buildPaintImageXObject({
                            resources: rr,
                            image: Fr,
                            operatorList: Yt,
                            cacheKey: Pr,
                            localImageCache: cr,
                            localColorSpaceCache: or
                          }).then(wr, Mr);
                          return;
                        } else if (Qr.name === "PS")
                          (0, rt.info)("Ignored XObject subtype PS");
                        else
                          throw new rt.FormatError(`Unhandled XObject subtype ${Qr.name}`);
                        wr();
                      }).catch(function(wr) {
                        if (!(wr instanceof rt.AbortException)) {
                          if (tr.options.ignoreErrors) {
                            (0, rt.warn)(`getOperatorList - ignoring XObject: "${wr}".`);
                            return;
                          }
                          throw wr;
                        }
                      }));
                      return;
                    case rt.OPS.setFont:
                      var Dr = fr[1];
                      Sr(tr.handleSetFont(rr, fr, null, Yt, Jt, ur.state, nr).then(function(wr) {
                        Yt.addDependency(wr), Yt.addOp(rt.OPS.setFont, [wr, Dr]);
                      }));
                      return;
                    case rt.OPS.beginText:
                      sr = !0;
                      break;
                    case rt.OPS.endText:
                      sr = !1;
                      break;
                    case rt.OPS.endInlineImage:
                      var Gr = fr[0].cacheKey;
                      if (Gr) {
                        const wr = cr.getByName(Gr);
                        if (wr) {
                          Yt.addImageOps(wr.fn, wr.args, wr.optionalContent), _t(wr), fr = null;
                          continue;
                        }
                      }
                      Sr(tr.buildPaintImageXObject({
                        resources: rr,
                        image: fr[0],
                        isInline: !0,
                        operatorList: Yt,
                        cacheKey: Gr,
                        localImageCache: cr,
                        localColorSpaceCache: or
                      }));
                      return;
                    case rt.OPS.showText:
                      if (!ur.state.font) {
                        tr.ensureStateFont(ur.state);
                        continue;
                      }
                      fr[0] = tr.handleText(fr[0], ur.state);
                      break;
                    case rt.OPS.showSpacedText:
                      if (!ur.state.font) {
                        tr.ensureStateFont(ur.state);
                        continue;
                      }
                      var Or = [], Hr = ur.state;
                      for (const wr of fr[0])
                        typeof wr == "string" ? Or.push(...tr.handleText(wr, Hr)) : typeof wr == "number" && Or.push(wr);
                      fr[0] = Or, Cr = rt.OPS.showText;
                      break;
                    case rt.OPS.nextLineShowText:
                      if (!ur.state.font) {
                        tr.ensureStateFont(ur.state);
                        continue;
                      }
                      Yt.addOp(rt.OPS.nextLine), fr[0] = tr.handleText(fr[0], ur.state), Cr = rt.OPS.showText;
                      break;
                    case rt.OPS.nextLineSetSpacingShowText:
                      if (!ur.state.font) {
                        tr.ensureStateFont(ur.state);
                        continue;
                      }
                      Yt.addOp(rt.OPS.nextLine), Yt.addOp(rt.OPS.setWordSpacing, [fr.shift()]), Yt.addOp(rt.OPS.setCharSpacing, [fr.shift()]), fr[0] = tr.handleText(fr[0], ur.state), Cr = rt.OPS.showText;
                      break;
                    case rt.OPS.setTextRenderingMode:
                      ur.state.textRenderingMode = fr[0];
                      break;
                    case rt.OPS.setFillColorSpace: {
                      const wr = xt.ColorSpace.getCached(fr[0], ir, or);
                      if (wr) {
                        ur.state.fillColorSpace = wr;
                        continue;
                      }
                      Sr(tr.parseColorSpace({
                        cs: fr[0],
                        resources: rr,
                        localColorSpaceCache: or
                      }).then(function(Mr) {
                        Mr && (ur.state.fillColorSpace = Mr);
                      }));
                      return;
                    }
                    case rt.OPS.setStrokeColorSpace: {
                      const wr = xt.ColorSpace.getCached(fr[0], ir, or);
                      if (wr) {
                        ur.state.strokeColorSpace = wr;
                        continue;
                      }
                      Sr(tr.parseColorSpace({
                        cs: fr[0],
                        resources: rr,
                        localColorSpaceCache: or
                      }).then(function(Mr) {
                        Mr && (ur.state.strokeColorSpace = Mr);
                      }));
                      return;
                    }
                    case rt.OPS.setFillColor:
                      xr = ur.state.fillColorSpace, fr = xr.getRgb(fr, 0), Cr = rt.OPS.setFillRGBColor;
                      break;
                    case rt.OPS.setStrokeColor:
                      xr = ur.state.strokeColorSpace, fr = xr.getRgb(fr, 0), Cr = rt.OPS.setStrokeRGBColor;
                      break;
                    case rt.OPS.setFillGray:
                      ur.state.fillColorSpace = xt.ColorSpace.singletons.gray, fr = xt.ColorSpace.singletons.gray.getRgb(fr, 0), Cr = rt.OPS.setFillRGBColor;
                      break;
                    case rt.OPS.setStrokeGray:
                      ur.state.strokeColorSpace = xt.ColorSpace.singletons.gray, fr = xt.ColorSpace.singletons.gray.getRgb(fr, 0), Cr = rt.OPS.setStrokeRGBColor;
                      break;
                    case rt.OPS.setFillCMYKColor:
                      ur.state.fillColorSpace = xt.ColorSpace.singletons.cmyk, fr = xt.ColorSpace.singletons.cmyk.getRgb(fr, 0), Cr = rt.OPS.setFillRGBColor;
                      break;
                    case rt.OPS.setStrokeCMYKColor:
                      ur.state.strokeColorSpace = xt.ColorSpace.singletons.cmyk, fr = xt.ColorSpace.singletons.cmyk.getRgb(fr, 0), Cr = rt.OPS.setStrokeRGBColor;
                      break;
                    case rt.OPS.setFillRGBColor:
                      ur.state.fillColorSpace = xt.ColorSpace.singletons.rgb, fr = xt.ColorSpace.singletons.rgb.getRgb(fr, 0);
                      break;
                    case rt.OPS.setStrokeRGBColor:
                      ur.state.strokeColorSpace = xt.ColorSpace.singletons.rgb, fr = xt.ColorSpace.singletons.rgb.getRgb(fr, 0);
                      break;
                    case rt.OPS.setFillColorN:
                      if (xr = ur.state.fillColorSpace, xr.name === "Pattern") {
                        Sr(tr.handleColorN(Yt, rt.OPS.setFillColorN, fr, xr, lr, rr, Jt, or, Gt, Wt));
                        return;
                      }
                      fr = xr.getRgb(fr, 0), Cr = rt.OPS.setFillRGBColor;
                      break;
                    case rt.OPS.setStrokeColorN:
                      if (xr = ur.state.strokeColorSpace, xr.name === "Pattern") {
                        Sr(tr.handleColorN(Yt, rt.OPS.setStrokeColorN, fr, xr, lr, rr, Jt, or, Gt, Wt));
                        return;
                      }
                      fr = xr.getRgb(fr, 0), Cr = rt.OPS.setStrokeRGBColor;
                      break;
                    case rt.OPS.shadingFill:
                      var jr = rr.get("Shading");
                      if (!jr)
                        throw new rt.FormatError("No shading resource found");
                      var Tr = jr.get(fr[0].name);
                      if (!Tr)
                        throw new rt.FormatError("No shading object found");
                      fr = [tr.parseShading({
                        shading: Tr,
                        resources: rr,
                        localColorSpaceCache: or,
                        localShadingPatternCache: Wt
                      })], Cr = rt.OPS.shadingFill;
                      break;
                    case rt.OPS.setGState:
                      if (Rr = fr[0] instanceof lt.Name, Pr = fr[0].name, Rr) {
                        const wr = Xt.getByName(Pr);
                        if (wr) {
                          wr.length > 0 && Yt.addOp(rt.OPS.setGState, [wr]), fr = null;
                          continue;
                        }
                      }
                      Sr(new Promise(function(wr, Mr) {
                        if (!Rr)
                          throw new rt.FormatError("GState must be referred to by name.");
                        const Fr = rr.get("ExtGState");
                        if (!(Fr instanceof lt.Dict))
                          throw new rt.FormatError("ExtGState should be a dictionary.");
                        const Qr = Fr.get(Pr);
                        if (!(Qr instanceof lt.Dict))
                          throw new rt.FormatError("GState should be a dictionary.");
                        tr.setGState({
                          resources: rr,
                          gState: Qr,
                          operatorList: Yt,
                          cacheKey: Pr,
                          task: Jt,
                          stateManager: ur,
                          localGStateCache: Xt,
                          localColorSpaceCache: or
                        }).then(wr, Mr);
                      }).catch(function(wr) {
                        if (!(wr instanceof rt.AbortException)) {
                          if (tr.options.ignoreErrors) {
                            (0, rt.warn)(`getOperatorList - ignoring ExtGState: "${wr}".`);
                            return;
                          }
                          throw wr;
                        }
                      }));
                      return;
                    case rt.OPS.moveTo:
                    case rt.OPS.lineTo:
                    case rt.OPS.curveTo:
                    case rt.OPS.curveTo2:
                    case rt.OPS.curveTo3:
                    case rt.OPS.closePath:
                    case rt.OPS.rectangle:
                      tr.buildPath(Yt, Cr, fr, sr);
                      continue;
                    case rt.OPS.markPoint:
                    case rt.OPS.markPointProps:
                    case rt.OPS.beginCompat:
                    case rt.OPS.endCompat:
                      continue;
                    case rt.OPS.beginMarkedContentProps:
                      if (!(fr[0] instanceof lt.Name)) {
                        (0, rt.warn)(`Expected name for beginMarkedContentProps arg0=${fr[0]}`);
                        continue;
                      }
                      if (fr[0].name === "OC") {
                        Sr(tr.parseMarkedContentProps(fr[1], rr).then((wr) => {
                          Yt.addOp(rt.OPS.beginMarkedContentProps, ["OC", wr]);
                        }).catch((wr) => {
                          if (!(wr instanceof rt.AbortException)) {
                            if (tr.options.ignoreErrors) {
                              (0, rt.warn)(`getOperatorList - ignoring beginMarkedContentProps: "${wr}".`);
                              return;
                            }
                            throw wr;
                          }
                        }));
                        return;
                      }
                      fr = [fr[0].name, fr[1] instanceof lt.Dict ? fr[1].get("MCID") : null];
                      break;
                    case rt.OPS.beginMarkedContent:
                    case rt.OPS.endMarkedContent:
                    default:
                      if (fr !== null) {
                        for (hr = 0, vr = fr.length; hr < vr && !(fr[hr] instanceof lt.Dict); hr++)
                          ;
                        if (hr < vr) {
                          (0, rt.warn)("getOperatorList - ignoring operator: " + Cr);
                          continue;
                        }
                      }
                  }
                  Yt.addOp(Cr, fr);
                }
                if (Ir) {
                  Sr(Ht);
                  return;
                }
                Er(), gr();
              }).catch((br) => {
                if (!(br instanceof rt.AbortException)) {
                  if (this.options.ignoreErrors) {
                    (0, rt.warn)(`getOperatorList - ignoring errors during "${Jt.name}" task: "${br}".`), Er();
                    return;
                  }
                  throw br;
                }
              });
            }
            getTextContent(Zt) {
              let {
                stream: ar,
                task: Jt,
                resources: rr,
                stateManager: Yt = null,
                includeMarkedContent: Kt = !1,
                sink: nr,
                seenStyles: tr = /* @__PURE__ */ new Set(),
                viewBox: ir,
                markedContentData: sr = null,
                disableNormalization: cr = !1
              } = Zt;
              rr || (rr = lt.Dict.empty), Yt || (Yt = new $t(new Tt())), Kt && (sr || (sr = {
                level: 0
              }));
              const or = {
                items: [],
                styles: /* @__PURE__ */ Object.create(null)
              }, Xt = {
                initialized: !1,
                str: [],
                totalWidth: 0,
                totalHeight: 0,
                width: 0,
                height: 0,
                vertical: !1,
                prevTransform: null,
                textAdvanceScale: 0,
                spaceInFlowMin: 0,
                spaceInFlowMax: 0,
                trackingSpaceMin: 1 / 0,
                negativeSpaceMax: -1 / 0,
                notASpace: -1 / 0,
                transform: null,
                fontName: null,
                hasEOL: !1
              }, Gt = [" ", " "];
              let Wt = 0;
              function er(kr) {
                const Nr = (Wt + 1) % 2, Lr = Gt[Wt] !== " " && Gt[Nr] === " ";
                return Gt[Wt] = kr, Wt = Nr, Lr;
              }
              function lr() {
                return Gt[Wt] !== " " && Gt[(Wt + 1) % 2] === " ";
              }
              function ur() {
                Gt[0] = Gt[1] = " ", Wt = 0;
              }
              const pr = 0.102, yr = 0.03, Er = -0.2, br = 0.102, gr = 0.6, Ar = 0.25, Sr = this, Br = this.xref, Ir = [];
              let hr = null;
              const vr = new mt.LocalImageCache(), xr = new mt.LocalGStateCache(), Pr = new Ut(ar, Br, Yt);
              let Rr;
              function Dr(kr) {
                let {
                  width: Nr = 0,
                  height: Lr = 0,
                  transform: zr = Xt.prevTransform,
                  fontName: Vr = Xt.fontName
                } = kr;
                or.items.push({
                  str: " ",
                  dir: "ltr",
                  width: Nr,
                  height: Lr,
                  transform: zr,
                  fontName: Vr,
                  hasEOL: !1
                });
              }
              function Gr() {
                const kr = Rr.font, Nr = [Rr.fontSize * Rr.textHScale, 0, 0, Rr.fontSize, 0, Rr.textRise];
                if (kr.isType3Font && (Rr.fontSize <= 1 || kr.isCharBBox) && !(0, rt.isArrayEqual)(Rr.fontMatrix, rt.FONT_IDENTITY_MATRIX)) {
                  const Lr = kr.bbox[3] - kr.bbox[1];
                  Lr > 0 && (Nr[3] *= Lr * Rr.fontMatrix[3]);
                }
                return rt.Util.transform(Rr.ctm, rt.Util.transform(Rr.textMatrix, Nr));
              }
              function Or() {
                if (Xt.initialized)
                  return Xt;
                const {
                  font: kr,
                  loadedName: Nr
                } = Rr;
                tr.has(Nr) || (tr.add(Nr), or.styles[Nr] = {
                  fontFamily: kr.fallbackName,
                  ascent: kr.ascent,
                  descent: kr.descent,
                  vertical: kr.vertical
                }), Xt.fontName = Nr;
                const Lr = Xt.transform = Gr();
                kr.vertical ? (Xt.width = Xt.totalWidth = Math.hypot(Lr[0], Lr[1]), Xt.height = Xt.totalHeight = 0, Xt.vertical = !0) : (Xt.width = Xt.totalWidth = 0, Xt.height = Xt.totalHeight = Math.hypot(Lr[2], Lr[3]), Xt.vertical = !1);
                const zr = Math.hypot(Rr.textLineMatrix[0], Rr.textLineMatrix[1]), Vr = Math.hypot(Rr.ctm[0], Rr.ctm[1]);
                Xt.textAdvanceScale = Vr * zr;
                const {
                  fontSize: an
                } = Rr;
                return Xt.trackingSpaceMin = an * pr, Xt.notASpace = an * yr, Xt.negativeSpaceMax = an * Er, Xt.spaceInFlowMin = an * br, Xt.spaceInFlowMax = an * gr, Xt.hasEOL = !1, Xt.initialized = !0, Xt;
              }
              function Hr() {
                if (!Xt.initialized)
                  return;
                const kr = Math.hypot(Rr.textLineMatrix[0], Rr.textLineMatrix[1]), Lr = Math.hypot(Rr.ctm[0], Rr.ctm[1]) * kr;
                Lr !== Xt.textAdvanceScale && (Xt.vertical ? (Xt.totalHeight += Xt.height * Xt.textAdvanceScale, Xt.height = 0) : (Xt.totalWidth += Xt.width * Xt.textAdvanceScale, Xt.width = 0), Xt.textAdvanceScale = Lr);
              }
              function jr(kr) {
                let Nr = kr.str.join("");
                cr || (Nr = (0, rt.normalizeUnicode)(Nr));
                const Lr = (0, At.bidi)(Nr, -1, kr.vertical);
                return {
                  str: Lr.str,
                  dir: Lr.dir,
                  width: Math.abs(kr.totalWidth),
                  height: Math.abs(kr.totalHeight),
                  transform: kr.transform,
                  fontName: kr.fontName,
                  hasEOL: kr.hasEOL
                };
              }
              function Tr(kr, Nr) {
                return Sr.loadFont(kr, Nr, rr).then(function(Lr) {
                  return Lr.font.isType3Font ? Lr.loadType3Data(Sr, rr, Jt).catch(function() {
                  }).then(function() {
                    return Lr;
                  }) : Lr;
                }).then(function(Lr) {
                  Rr.loadedName = Lr.loadedName, Rr.font = Lr.font, Rr.fontMatrix = Lr.font.fontMatrix || rt.FONT_IDENTITY_MATRIX;
                });
              }
              function fr(kr, Nr, Lr) {
                const zr = Math.hypot(Lr[0], Lr[1]);
                return [(Lr[0] * kr + Lr[1] * Nr) / zr, (Lr[2] * kr + Lr[3] * Nr) / zr];
              }
              function Cr(kr) {
                var rn;
                const Nr = Gr();
                let Lr = Nr[4], zr = Nr[5];
                if ((rn = Rr.font) != null && rn.vertical) {
                  if (Lr < ir[0] || Lr > ir[2] || zr + kr < ir[1] || zr > ir[3])
                    return !1;
                } else if (Lr + kr < ir[0] || Lr > ir[2] || zr < ir[1] || zr > ir[3])
                  return !1;
                if (!Rr.font || !Xt.prevTransform)
                  return !0;
                let Vr = Xt.prevTransform[4], an = Xt.prevTransform[5];
                if (Vr === Lr && an === zr)
                  return !0;
                let Zr = -1;
                switch (Nr[0] && Nr[1] === 0 && Nr[2] === 0 ? Zr = Nr[0] > 0 ? 0 : 180 : Nr[1] && Nr[0] === 0 && Nr[3] === 0 && (Zr = Nr[1] > 0 ? 90 : 270), Zr) {
                  case 0:
                    break;
                  case 90:
                    [Lr, zr] = [zr, Lr], [Vr, an] = [an, Vr];
                    break;
                  case 180:
                    [Lr, zr, Vr, an] = [-Lr, -zr, -Vr, -an];
                    break;
                  case 270:
                    [Lr, zr] = [-zr, -Lr], [Vr, an] = [-an, -Vr];
                    break;
                  default:
                    [Lr, zr] = fr(Lr, zr, Nr), [Vr, an] = fr(Vr, an, Xt.prevTransform);
                }
                if (Rr.font.vertical) {
                  const nn = (an - zr) / Xt.textAdvanceScale, sn = Lr - Vr, gn = Math.sign(Xt.height);
                  return nn < gn * Xt.negativeSpaceMax ? Math.abs(sn) > 0.5 * Xt.width ? (wr(), !0) : (ur(), Fr(), !0) : Math.abs(sn) > Xt.width ? (wr(), !0) : (nn <= gn * Xt.notASpace && ur(), nn <= gn * Xt.trackingSpaceMin ? lr() ? (ur(), Fr(), Dr({
                    height: Math.abs(nn)
                  })) : Xt.height += nn : Mr(nn, Xt.prevTransform, gn) || (Xt.str.length === 0 ? (ur(), Dr({
                    height: Math.abs(nn)
                  })) : Xt.height += nn), Math.abs(sn) > Xt.width * Ar && Fr(), !0);
                }
                const un = (Lr - Vr) / Xt.textAdvanceScale, Xr = zr - an, Kr = Math.sign(Xt.width);
                return un < Kr * Xt.negativeSpaceMax ? Math.abs(Xr) > 0.5 * Xt.height ? (wr(), !0) : (ur(), Fr(), !0) : Math.abs(Xr) > Xt.height ? (wr(), !0) : (un <= Kr * Xt.notASpace && ur(), un <= Kr * Xt.trackingSpaceMin ? lr() ? (ur(), Fr(), Dr({
                  width: Math.abs(un)
                })) : Xt.width += un : Mr(un, Xt.prevTransform, Kr) || (Xt.str.length === 0 ? (ur(), Dr({
                  width: Math.abs(un)
                })) : Xt.width += un), Math.abs(Xr) > Xt.height * Ar && Fr(), !0);
              }
              function $r(kr) {
                let {
                  chars: Nr,
                  extraSpacing: Lr
                } = kr;
                const zr = Rr.font;
                if (!Nr) {
                  const Zr = Rr.charSpacing + Lr;
                  Zr && (zr.vertical ? Rr.translateTextMatrix(0, -Zr) : Rr.translateTextMatrix(Zr * Rr.textHScale, 0));
                  return;
                }
                const Vr = zr.charsToGlyphs(Nr), an = Rr.fontMatrix[0] * Rr.fontSize;
                for (let Zr = 0, un = Vr.length; Zr < un; Zr++) {
                  const Xr = Vr[Zr], {
                    category: Kr
                  } = Xr;
                  if (Kr.isInvisibleFormatMark)
                    continue;
                  let rn = Rr.charSpacing + (Zr + 1 === un ? Lr : 0), nn = Xr.width;
                  zr.vertical && (nn = Xr.vmetric ? Xr.vmetric[0] : -nn);
                  let sn = nn * an;
                  if (Kr.isWhitespace) {
                    zr.vertical ? (rn += -sn + Rr.wordSpacing, Rr.translateTextMatrix(0, -rn)) : (rn += sn + Rr.wordSpacing, Rr.translateTextMatrix(rn * Rr.textHScale, 0)), er(" ");
                    continue;
                  }
                  if (!Kr.isZeroWidthDiacritic && !Cr(sn)) {
                    zr.vertical ? Rr.translateTextMatrix(0, sn) : Rr.translateTextMatrix(sn * Rr.textHScale, 0);
                    continue;
                  }
                  const gn = Or();
                  Kr.isZeroWidthDiacritic && (sn = 0), zr.vertical ? (Rr.translateTextMatrix(0, sn), sn = Math.abs(sn), gn.height += sn) : (sn *= Rr.textHScale, Rr.translateTextMatrix(sn, 0), gn.width += sn), sn && (gn.prevTransform = Gr());
                  const en = Xr.unicode;
                  er(en) && gn.str.push(" "), gn.str.push(en), rn && (zr.vertical ? Rr.translateTextMatrix(0, -rn) : Rr.translateTextMatrix(rn * Rr.textHScale, 0));
                }
              }
              function wr() {
                ur(), Xt.initialized ? (Xt.hasEOL = !0, Fr()) : or.items.push({
                  str: "",
                  dir: "ltr",
                  width: 0,
                  height: 0,
                  transform: Gr(),
                  fontName: Rr.loadedName,
                  hasEOL: !0
                });
              }
              function Mr(kr, Nr, Lr) {
                if (Lr * Xt.spaceInFlowMin <= kr && kr <= Lr * Xt.spaceInFlowMax)
                  return Xt.initialized && (ur(), Xt.str.push(" ")), !1;
                const zr = Xt.fontName;
                let Vr = 0;
                return Xt.vertical && (Vr = kr, kr = 0), Fr(), ur(), Dr({
                  width: Math.abs(kr),
                  height: Math.abs(Vr),
                  transform: Nr || Gr(),
                  fontName: zr
                }), !0;
              }
              function Fr() {
                !Xt.initialized || !Xt.str || (Xt.vertical ? Xt.totalHeight += Xt.height * Xt.textAdvanceScale : Xt.totalWidth += Xt.width * Xt.textAdvanceScale, or.items.push(jr(Xt)), Xt.initialized = !1, Xt.str.length = 0);
              }
              function Qr() {
                let kr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                const Nr = or.items.length;
                Nr !== 0 && (kr && Nr < jt || (nr.enqueue(or, Nr), or.items = [], or.styles = /* @__PURE__ */ Object.create(null)));
              }
              const Yr = new Nt();
              return new Promise(function kr(Nr, Lr) {
                const zr = function(nn) {
                  Qr(!0), Promise.all([nn, nr.ready]).then(function() {
                    try {
                      kr(Nr, Lr);
                    } catch (sn) {
                      Lr(sn);
                    }
                  }, Lr);
                };
                Jt.ensureNotTerminated(), Yr.reset();
                const Vr = {};
                let an, Zr = [];
                for (; !(an = Yr.check()) && (Zr.length = 0, Vr.args = Zr, !!Pr.read(Vr)); ) {
                  const nn = Rr;
                  Rr = Yt.state;
                  const sn = Vr.fn;
                  switch (Zr = Vr.args, sn | 0) {
                    case rt.OPS.setFont:
                      var un = Zr[0].name, Xr = Zr[1];
                      if (Rr.font && un === Rr.fontName && Xr === Rr.fontSize)
                        break;
                      Fr(), Rr.fontName = un, Rr.fontSize = Xr, zr(Tr(un, null));
                      return;
                    case rt.OPS.setTextRise:
                      Rr.textRise = Zr[0];
                      break;
                    case rt.OPS.setHScale:
                      Rr.textHScale = Zr[0] / 100;
                      break;
                    case rt.OPS.setLeading:
                      Rr.leading = Zr[0];
                      break;
                    case rt.OPS.moveText:
                      Rr.translateTextLineMatrix(Zr[0], Zr[1]), Rr.textMatrix = Rr.textLineMatrix.slice();
                      break;
                    case rt.OPS.setLeadingMoveText:
                      Rr.leading = -Zr[1], Rr.translateTextLineMatrix(Zr[0], Zr[1]), Rr.textMatrix = Rr.textLineMatrix.slice();
                      break;
                    case rt.OPS.nextLine:
                      Rr.carriageReturn();
                      break;
                    case rt.OPS.setTextMatrix:
                      Rr.setTextMatrix(Zr[0], Zr[1], Zr[2], Zr[3], Zr[4], Zr[5]), Rr.setTextLineMatrix(Zr[0], Zr[1], Zr[2], Zr[3], Zr[4], Zr[5]), Hr();
                      break;
                    case rt.OPS.setCharSpacing:
                      Rr.charSpacing = Zr[0];
                      break;
                    case rt.OPS.setWordSpacing:
                      Rr.wordSpacing = Zr[0];
                      break;
                    case rt.OPS.beginText:
                      Rr.textMatrix = rt.IDENTITY_MATRIX.slice(), Rr.textLineMatrix = rt.IDENTITY_MATRIX.slice();
                      break;
                    case rt.OPS.showSpacedText:
                      if (!Yt.state.font) {
                        Sr.ensureStateFont(Yt.state);
                        continue;
                      }
                      const gn = (Rr.font.vertical ? 1 : -1) * Rr.fontSize / 1e3, en = Zr[0];
                      for (let Wr = 0, dn = en.length; Wr < dn; Wr++) {
                        const hn = en[Wr];
                        if (typeof hn == "string")
                          Ir.push(hn);
                        else if (typeof hn == "number" && hn !== 0) {
                          const En = Ir.join("");
                          Ir.length = 0, $r({
                            chars: En,
                            extraSpacing: hn * gn
                          });
                        }
                      }
                      if (Ir.length > 0) {
                        const Wr = Ir.join("");
                        Ir.length = 0, $r({
                          chars: Wr,
                          extraSpacing: 0
                        });
                      }
                      break;
                    case rt.OPS.showText:
                      if (!Yt.state.font) {
                        Sr.ensureStateFont(Yt.state);
                        continue;
                      }
                      $r({
                        chars: Zr[0],
                        extraSpacing: 0
                      });
                      break;
                    case rt.OPS.nextLineShowText:
                      if (!Yt.state.font) {
                        Sr.ensureStateFont(Yt.state);
                        continue;
                      }
                      Rr.carriageReturn(), $r({
                        chars: Zr[0],
                        extraSpacing: 0
                      });
                      break;
                    case rt.OPS.nextLineSetSpacingShowText:
                      if (!Yt.state.font) {
                        Sr.ensureStateFont(Yt.state);
                        continue;
                      }
                      Rr.wordSpacing = Zr[0], Rr.charSpacing = Zr[1], Rr.carriageReturn(), $r({
                        chars: Zr[2],
                        extraSpacing: 0
                      });
                      break;
                    case rt.OPS.paintXObject:
                      Fr(), hr || (hr = rr.get("XObject") || lt.Dict.empty);
                      var Kr = Zr[0] instanceof lt.Name, rn = Zr[0].name;
                      if (Kr && vr.getByName(rn))
                        break;
                      zr(new Promise(function(Wr, dn) {
                        if (!Kr)
                          throw new rt.FormatError("XObject must be referred to by name.");
                        let hn = hr.getRaw(rn);
                        if (hn instanceof lt.Ref) {
                          if (vr.getByRef(hn)) {
                            Wr();
                            return;
                          }
                          if (Sr.globalImageCache.getData(hn, Sr.pageIndex)) {
                            Wr();
                            return;
                          }
                          hn = Br.fetch(hn);
                        }
                        if (!(hn instanceof vt.BaseStream))
                          throw new rt.FormatError("XObject should be a stream");
                        const En = hn.dict.get("Subtype");
                        if (!(En instanceof lt.Name))
                          throw new rt.FormatError("XObject should have a Name subtype");
                        if (En.name !== "Form") {
                          vr.set(rn, hn.dict.objId, !0), Wr();
                          return;
                        }
                        const bn = Yt.state.clone(), Cn = new $t(bn), wn = hn.dict.getArray("Matrix");
                        Array.isArray(wn) && wn.length === 6 && Cn.transform(wn), Qr();
                        const vn = {
                          enqueueInvoked: !1,
                          enqueue(fn, on) {
                            this.enqueueInvoked = !0, nr.enqueue(fn, on);
                          },
                          get desiredSize() {
                            return nr.desiredSize;
                          },
                          get ready() {
                            return nr.ready;
                          }
                        };
                        Sr.getTextContent({
                          stream: hn,
                          task: Jt,
                          resources: hn.dict.get("Resources") || rr,
                          stateManager: Cn,
                          includeMarkedContent: Kt,
                          sink: vn,
                          seenStyles: tr,
                          viewBox: ir,
                          markedContentData: sr,
                          disableNormalization: cr
                        }).then(function() {
                          vn.enqueueInvoked || vr.set(rn, hn.dict.objId, !0), Wr();
                        }, dn);
                      }).catch(function(Wr) {
                        if (!(Wr instanceof rt.AbortException)) {
                          if (Sr.options.ignoreErrors) {
                            (0, rt.warn)(`getTextContent - ignoring XObject: "${Wr}".`);
                            return;
                          }
                          throw Wr;
                        }
                      }));
                      return;
                    case rt.OPS.setGState:
                      if (Kr = Zr[0] instanceof lt.Name, rn = Zr[0].name, Kr && xr.getByName(rn))
                        break;
                      zr(new Promise(function(Wr, dn) {
                        if (!Kr)
                          throw new rt.FormatError("GState must be referred to by name.");
                        const hn = rr.get("ExtGState");
                        if (!(hn instanceof lt.Dict))
                          throw new rt.FormatError("ExtGState should be a dictionary.");
                        const En = hn.get(rn);
                        if (!(En instanceof lt.Dict))
                          throw new rt.FormatError("GState should be a dictionary.");
                        const bn = En.get("Font");
                        if (!bn) {
                          xr.set(rn, En.objId, !0), Wr();
                          return;
                        }
                        Fr(), Rr.fontName = null, Rr.fontSize = bn[1], Tr(null, bn[0]).then(Wr, dn);
                      }).catch(function(Wr) {
                        if (!(Wr instanceof rt.AbortException)) {
                          if (Sr.options.ignoreErrors) {
                            (0, rt.warn)(`getTextContent - ignoring ExtGState: "${Wr}".`);
                            return;
                          }
                          throw Wr;
                        }
                      }));
                      return;
                    case rt.OPS.beginMarkedContent:
                      Fr(), Kt && (sr.level++, or.items.push({
                        type: "beginMarkedContent",
                        tag: Zr[0] instanceof lt.Name ? Zr[0].name : null
                      }));
                      break;
                    case rt.OPS.beginMarkedContentProps:
                      if (Fr(), Kt) {
                        sr.level++;
                        let Wr = null;
                        Zr[1] instanceof lt.Dict && (Wr = Zr[1].get("MCID")), or.items.push({
                          type: "beginMarkedContentProps",
                          id: Number.isInteger(Wr) ? `${Sr.idFactory.getPageObjId()}_mc${Wr}` : null,
                          tag: Zr[0] instanceof lt.Name ? Zr[0].name : null
                        });
                      }
                      break;
                    case rt.OPS.endMarkedContent:
                      if (Fr(), Kt) {
                        if (sr.level === 0)
                          break;
                        sr.level--, or.items.push({
                          type: "endMarkedContent"
                        });
                      }
                      break;
                    case rt.OPS.restore:
                      nn && (nn.font !== Rr.font || nn.fontSize !== Rr.fontSize || nn.fontName !== Rr.fontName) && Fr();
                      break;
                  }
                  if (or.items.length >= nr.desiredSize) {
                    an = !0;
                    break;
                  }
                }
                if (an) {
                  zr(Ht);
                  return;
                }
                Fr(), Qr(), Nr();
              }).catch((kr) => {
                if (!(kr instanceof rt.AbortException)) {
                  if (this.options.ignoreErrors) {
                    (0, rt.warn)(`getTextContent - ignoring errors during "${Jt.name}" task: "${kr}".`), Fr(), Qr();
                    return;
                  }
                  throw kr;
                }
              });
            }
            extractDataStructures(Zt, ar, Jt) {
              const rr = this.xref;
              let Yt;
              const Kt = this.readToUnicode(Jt.toUnicode || Zt.get("ToUnicode") || ar.get("ToUnicode"));
              if (Jt.composite) {
                const or = Zt.get("CIDSystemInfo");
                or instanceof lt.Dict && (Jt.cidSystemInfo = {
                  registry: (0, rt.stringToPDFString)(or.get("Registry")),
                  ordering: (0, rt.stringToPDFString)(or.get("Ordering")),
                  supplement: or.get("Supplement")
                });
                try {
                  const Xt = Zt.get("CIDToGIDMap");
                  Xt instanceof vt.BaseStream && (Yt = Xt.getBytes());
                } catch (Xt) {
                  if (!this.options.ignoreErrors)
                    throw Xt;
                  (0, rt.warn)(`extractDataStructures - ignoring CIDToGIDMap data: "${Xt}".`);
                }
              }
              const nr = [];
              let tr = null, ir;
              if (Zt.has("Encoding")) {
                if (ir = Zt.get("Encoding"), ir instanceof lt.Dict) {
                  if (tr = ir.get("BaseEncoding"), tr = tr instanceof lt.Name ? tr.name : null, ir.has("Differences")) {
                    const or = ir.get("Differences");
                    let Xt = 0;
                    for (const Gt of or) {
                      const Wt = rr.fetchIfRef(Gt);
                      if (typeof Wt == "number")
                        Xt = Wt;
                      else if (Wt instanceof lt.Name)
                        nr[Xt++] = Wt.name;
                      else
                        throw new rt.FormatError(`Invalid entry in 'Differences' array: ${Wt}`);
                    }
                  }
                } else if (ir instanceof lt.Name)
                  tr = ir.name;
                else {
                  const or = "Encoding is not a Name nor a Dict";
                  if (!this.options.ignoreErrors)
                    throw new rt.FormatError(or);
                  (0, rt.warn)(or);
                }
                tr !== "MacRomanEncoding" && tr !== "MacExpertEncoding" && tr !== "WinAnsiEncoding" && (tr = null);
              }
              const sr = !Jt.file || Jt.isInternalFont, cr = (0, ut.getSymbolsFonts)()[Jt.name];
              if (tr && sr && cr && (tr = null), tr)
                Jt.defaultEncoding = (0, it.getEncoding)(tr);
              else {
                const or = !!(Jt.flags & Et.FontFlags.Symbolic), Xt = !!(Jt.flags & Et.FontFlags.Nonsymbolic);
                ir = it.StandardEncoding, Jt.type === "TrueType" && !Xt && (ir = it.WinAnsiEncoding), (or || cr) && (ir = it.MacRomanEncoding, sr && (/Symbol/i.test(Jt.name) ? ir = it.SymbolSetEncoding : /Dingbats/i.test(Jt.name) ? ir = it.ZapfDingbatsEncoding : /Wingdings/i.test(Jt.name) && (ir = it.WinAnsiEncoding))), Jt.defaultEncoding = ir;
              }
              return Jt.differences = nr, Jt.baseEncodingName = tr, Jt.hasEncoding = !!tr || nr.length > 0, Jt.dict = Zt, Kt.then((or) => (Jt.toUnicode = or, this.buildToUnicode(Jt))).then((or) => (Jt.toUnicode = or, Yt && (Jt.cidToGidMap = this.readCidToGidMap(Yt, or)), Jt));
            }
            _simpleFontToUnicode(Zt) {
              let ar = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
              (0, rt.assert)(!Zt.composite, "Must be a simple font.");
              const Jt = [], rr = Zt.defaultEncoding.slice(), Yt = Zt.baseEncodingName, Kt = Zt.differences;
              for (const tr in Kt) {
                const ir = Kt[tr];
                ir !== ".notdef" && (rr[tr] = ir);
              }
              const nr = (0, Bt.getGlyphsUnicode)();
              for (const tr in rr) {
                let ir = rr[tr];
                if (ir === "")
                  continue;
                let sr = nr[ir];
                if (sr !== void 0) {
                  Jt[tr] = String.fromCharCode(sr);
                  continue;
                }
                let cr = 0;
                switch (ir[0]) {
                  case "G":
                    ir.length === 3 && (cr = parseInt(ir.substring(1), 16));
                    break;
                  case "g":
                    ir.length === 5 && (cr = parseInt(ir.substring(1), 16));
                    break;
                  case "C":
                  case "c":
                    if (ir.length >= 3 && ir.length <= 4) {
                      const or = ir.substring(1);
                      if (ar) {
                        cr = parseInt(or, 16);
                        break;
                      }
                      if (cr = +or, Number.isNaN(cr) && Number.isInteger(parseInt(or, 16)))
                        return this._simpleFontToUnicode(Zt, !0);
                    }
                    break;
                  case "u":
                    sr = (0, Pt.getUnicodeForGlyph)(ir, nr), sr !== -1 && (cr = sr);
                    break;
                  default:
                    switch (ir) {
                      case "f_h":
                      case "f_t":
                      case "T_h":
                        Jt[tr] = ir.replaceAll("_", "");
                        continue;
                    }
                    break;
                }
                if (cr > 0 && cr <= 1114111 && Number.isInteger(cr)) {
                  if (Yt && cr === +tr) {
                    const or = (0, it.getEncoding)(Yt);
                    if (or && (ir = or[tr])) {
                      Jt[tr] = String.fromCharCode(nr[ir]);
                      continue;
                    }
                  }
                  Jt[tr] = String.fromCodePoint(cr);
                }
              }
              return Jt;
            }
            async buildToUnicode(Zt) {
              var ar;
              if (Zt.hasIncludedToUnicodeMap = ((ar = Zt.toUnicode) == null ? void 0 : ar.length) > 0, Zt.hasIncludedToUnicodeMap)
                return !Zt.composite && Zt.hasEncoding && (Zt.fallbackToUnicode = this._simpleFontToUnicode(Zt)), Zt.toUnicode;
              if (!Zt.composite)
                return new dt.ToUnicodeMap(this._simpleFontToUnicode(Zt));
              if (Zt.composite && (Zt.cMap.builtInCMap && !(Zt.cMap instanceof st.IdentityCMap) || Zt.cidSystemInfo.registry === "Adobe" && (Zt.cidSystemInfo.ordering === "GB1" || Zt.cidSystemInfo.ordering === "CNS1" || Zt.cidSystemInfo.ordering === "Japan1" || Zt.cidSystemInfo.ordering === "Korea1"))) {
                const {
                  registry: Jt,
                  ordering: rr
                } = Zt.cidSystemInfo, Yt = lt.Name.get(`${Jt}-${rr}-UCS2`), Kt = await st.CMapFactory.create({
                  encoding: Yt,
                  fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                  useCMap: null
                }), nr = [], tr = [];
                return Zt.cMap.forEach(function(ir, sr) {
                  if (sr > 65535)
                    throw new rt.FormatError("Max size of CID is 65,535");
                  const cr = Kt.lookup(sr);
                  if (cr) {
                    tr.length = 0;
                    for (let or = 0, Xt = cr.length; or < Xt; or += 2)
                      tr.push((cr.charCodeAt(or) << 8) + cr.charCodeAt(or + 1));
                    nr[ir] = String.fromCharCode(...tr);
                  }
                }), new dt.ToUnicodeMap(nr);
              }
              return new dt.IdentityToUnicodeMap(Zt.firstChar, Zt.lastChar);
            }
            readToUnicode(Zt) {
              return Zt ? Zt instanceof lt.Name ? st.CMapFactory.create({
                encoding: Zt,
                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                useCMap: null
              }).then(function(ar) {
                return ar instanceof st.IdentityCMap ? new dt.IdentityToUnicodeMap(0, 65535) : new dt.ToUnicodeMap(ar.getMap());
              }) : Zt instanceof vt.BaseStream ? st.CMapFactory.create({
                encoding: Zt,
                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                useCMap: null
              }).then(function(ar) {
                if (ar instanceof st.IdentityCMap)
                  return new dt.IdentityToUnicodeMap(0, 65535);
                const Jt = new Array(ar.length);
                return ar.forEach(function(rr, Yt) {
                  if (typeof Yt == "number") {
                    Jt[rr] = String.fromCodePoint(Yt);
                    return;
                  }
                  const Kt = [];
                  for (let nr = 0; nr < Yt.length; nr += 2) {
                    const tr = Yt.charCodeAt(nr) << 8 | Yt.charCodeAt(nr + 1);
                    if ((tr & 63488) !== 55296) {
                      Kt.push(tr);
                      continue;
                    }
                    nr += 2;
                    const ir = Yt.charCodeAt(nr) << 8 | Yt.charCodeAt(nr + 1);
                    Kt.push(((tr & 1023) << 10) + (ir & 1023) + 65536);
                  }
                  Jt[rr] = String.fromCodePoint(...Kt);
                }), new dt.ToUnicodeMap(Jt);
              }, (ar) => {
                if (ar instanceof rt.AbortException)
                  return null;
                if (this.options.ignoreErrors)
                  return (0, rt.warn)(`readToUnicode - ignoring ToUnicode data: "${ar}".`), null;
                throw ar;
              }) : Promise.resolve(null) : Promise.resolve(null);
            }
            readCidToGidMap(Zt, ar) {
              const Jt = [];
              for (let rr = 0, Yt = Zt.length; rr < Yt; rr++) {
                const Kt = Zt[rr++] << 8 | Zt[rr], nr = rr >> 1;
                Kt === 0 && !ar.has(nr) || (Jt[nr] = Kt);
              }
              return Jt;
            }
            extractWidths(Zt, ar, Jt) {
              const rr = this.xref;
              let Yt = [], Kt = 0;
              const nr = [];
              let tr, ir, sr, cr, or, Xt, Gt, Wt;
              if (Jt.composite) {
                if (Kt = Zt.has("DW") ? Zt.get("DW") : 1e3, Wt = Zt.get("W"), Wt)
                  for (ir = 0, sr = Wt.length; ir < sr; ir++)
                    if (Xt = rr.fetchIfRef(Wt[ir++]), Gt = rr.fetchIfRef(Wt[ir]), Array.isArray(Gt))
                      for (cr = 0, or = Gt.length; cr < or; cr++)
                        Yt[Xt++] = rr.fetchIfRef(Gt[cr]);
                    else {
                      const ur = rr.fetchIfRef(Wt[++ir]);
                      for (cr = Xt; cr <= Gt; cr++)
                        Yt[cr] = ur;
                    }
                if (Jt.vertical) {
                  let ur = Zt.getArray("DW2") || [880, -1e3];
                  if (tr = [ur[1], Kt * 0.5, ur[0]], ur = Zt.get("W2"), ur)
                    for (ir = 0, sr = ur.length; ir < sr; ir++)
                      if (Xt = rr.fetchIfRef(ur[ir++]), Gt = rr.fetchIfRef(ur[ir]), Array.isArray(Gt))
                        for (cr = 0, or = Gt.length; cr < or; cr++)
                          nr[Xt++] = [rr.fetchIfRef(Gt[cr++]), rr.fetchIfRef(Gt[cr++]), rr.fetchIfRef(Gt[cr])];
                      else {
                        const pr = [rr.fetchIfRef(ur[++ir]), rr.fetchIfRef(ur[++ir]), rr.fetchIfRef(ur[++ir])];
                        for (cr = Xt; cr <= Gt; cr++)
                          nr[cr] = pr;
                      }
                }
              } else {
                const ur = Jt.firstChar;
                if (Wt = Zt.get("Widths"), Wt) {
                  for (cr = ur, ir = 0, sr = Wt.length; ir < sr; ir++)
                    Yt[cr++] = rr.fetchIfRef(Wt[ir]);
                  Kt = parseFloat(ar.get("MissingWidth")) || 0;
                } else {
                  const pr = Zt.get("BaseFont");
                  if (pr instanceof lt.Name) {
                    const yr = this.getBaseFontMetrics(pr.name);
                    Yt = this.buildCharCodeToWidth(yr.widths, Jt), Kt = yr.defaultWidth;
                  }
                }
              }
              let er = !0, lr = Kt;
              for (const ur in Yt) {
                const pr = Yt[ur];
                if (pr) {
                  if (!lr) {
                    lr = pr;
                    continue;
                  }
                  if (lr !== pr) {
                    er = !1;
                    break;
                  }
                }
              }
              er ? Jt.flags |= Et.FontFlags.FixedPitch : Jt.flags &= ~Et.FontFlags.FixedPitch, Jt.defaultWidth = Kt, Jt.widths = Yt, Jt.defaultVMetrics = tr, Jt.vmetrics = nr;
            }
            isSerifFont(Zt) {
              const ar = Zt.split("-")[0];
              return ar in (0, ut.getSerifFonts)() || /serif/gi.test(ar);
            }
            getBaseFontMetrics(Zt) {
              let ar = 0, Jt = /* @__PURE__ */ Object.create(null), rr = !1, Kt = (0, ut.getStdFontMap)()[Zt] || Zt;
              const nr = (0, Ot.getMetrics)();
              Kt in nr || (Kt = this.isSerifFont(Zt) ? "Times-Roman" : "Helvetica");
              const tr = nr[Kt];
              return typeof tr == "number" ? (ar = tr, rr = !0) : Jt = tr(), {
                defaultWidth: ar,
                monospace: rr,
                widths: Jt
              };
            }
            buildCharCodeToWidth(Zt, ar) {
              const Jt = /* @__PURE__ */ Object.create(null), rr = ar.differences, Yt = ar.defaultEncoding;
              for (let Kt = 0; Kt < 256; Kt++) {
                if (Kt in rr && Zt[rr[Kt]]) {
                  Jt[Kt] = Zt[rr[Kt]];
                  continue;
                }
                if (Kt in Yt && Zt[Yt[Kt]]) {
                  Jt[Kt] = Zt[Yt[Kt]];
                  continue;
                }
              }
              return Jt;
            }
            preEvaluateFont(Zt) {
              const ar = Zt;
              let Jt = Zt.get("Subtype");
              if (!(Jt instanceof lt.Name))
                throw new rt.FormatError("invalid font Subtype");
              let rr = !1, Yt, Kt;
              if (Jt.name === "Type0") {
                const sr = Zt.get("DescendantFonts");
                if (!sr)
                  throw new rt.FormatError("Descendant fonts are not specified");
                if (Zt = Array.isArray(sr) ? this.xref.fetchIfRef(sr[0]) : sr, !(Zt instanceof lt.Dict))
                  throw new rt.FormatError("Descendant font is not a dictionary.");
                if (Jt = Zt.get("Subtype"), !(Jt instanceof lt.Name))
                  throw new rt.FormatError("invalid font Subtype");
                rr = !0;
              }
              const nr = Zt.get("FirstChar") || 0, tr = Zt.get("LastChar") || (rr ? 65535 : 255), ir = Zt.get("FontDescriptor");
              if (ir) {
                Yt = new Ct.MurmurHash3_64();
                const sr = ar.getRaw("Encoding");
                if (sr instanceof lt.Name)
                  Yt.update(sr.name);
                else if (sr instanceof lt.Ref)
                  Yt.update(sr.toString());
                else if (sr instanceof lt.Dict) {
                  for (const or of sr.getRawValues())
                    if (or instanceof lt.Name)
                      Yt.update(or.name);
                    else if (or instanceof lt.Ref)
                      Yt.update(or.toString());
                    else if (Array.isArray(or)) {
                      const Xt = or.length, Gt = new Array(Xt);
                      for (let Wt = 0; Wt < Xt; Wt++) {
                        const er = or[Wt];
                        er instanceof lt.Name ? Gt[Wt] = er.name : (typeof er == "number" || er instanceof lt.Ref) && (Gt[Wt] = er.toString());
                      }
                      Yt.update(Gt.join());
                    }
                }
                if (Yt.update(`${nr}-${tr}`), Kt = Zt.get("ToUnicode") || ar.get("ToUnicode"), Kt instanceof vt.BaseStream) {
                  const or = Kt.str || Kt, Xt = or.buffer ? new Uint8Array(or.buffer.buffer, 0, or.bufferLength) : new Uint8Array(or.bytes.buffer, or.start, or.end - or.start);
                  Yt.update(Xt);
                } else
                  Kt instanceof lt.Name && Yt.update(Kt.name);
                const cr = Zt.get("Widths") || ar.get("Widths");
                if (Array.isArray(cr)) {
                  const or = [];
                  for (const Xt of cr)
                    (typeof Xt == "number" || Xt instanceof lt.Ref) && or.push(Xt.toString());
                  Yt.update(or.join());
                }
                if (rr) {
                  Yt.update("compositeFont");
                  const or = Zt.get("W") || ar.get("W");
                  if (Array.isArray(or)) {
                    const Gt = [];
                    for (const Wt of or)
                      if (typeof Wt == "number" || Wt instanceof lt.Ref)
                        Gt.push(Wt.toString());
                      else if (Array.isArray(Wt)) {
                        const er = [];
                        for (const lr of Wt)
                          (typeof lr == "number" || lr instanceof lt.Ref) && er.push(lr.toString());
                        Gt.push(`[${er.join()}]`);
                      }
                    Yt.update(Gt.join());
                  }
                  const Xt = Zt.getRaw("CIDToGIDMap") || ar.getRaw("CIDToGIDMap");
                  Xt instanceof lt.Name ? Yt.update(Xt.name) : Xt instanceof lt.Ref ? Yt.update(Xt.toString()) : Xt instanceof vt.BaseStream && Yt.update(Xt.peekBytes());
                }
              }
              return {
                descriptor: ir,
                dict: Zt,
                baseDict: ar,
                composite: rr,
                type: Jt.name,
                firstChar: nr,
                lastChar: tr,
                toUnicode: Kt,
                hash: Yt ? Yt.hexdigest() : ""
              };
            }
            async translateFont(Zt) {
              let {
                descriptor: ar,
                dict: Jt,
                baseDict: rr,
                composite: Yt,
                type: Kt,
                firstChar: nr,
                lastChar: tr,
                toUnicode: ir,
                cssFontInfo: sr
              } = Zt;
              const cr = Kt === "Type3";
              let or;
              if (!ar)
                if (cr)
                  ar = new lt.Dict(null), ar.set("FontName", lt.Name.get(Kt)), ar.set("FontBBox", Jt.getArray("FontBBox") || [0, 0, 0, 0]);
                else {
                  let Sr = Jt.get("BaseFont");
                  if (!(Sr instanceof lt.Name))
                    throw new rt.FormatError("Base font is not specified");
                  Sr = Sr.name.replaceAll(/[,_]/g, "-");
                  const Br = this.getBaseFontMetrics(Sr), Ir = Sr.split("-")[0], hr = (this.isSerifFont(Ir) ? Et.FontFlags.Serif : 0) | (Br.monospace ? Et.FontFlags.FixedPitch : 0) | ((0, ut.getSymbolsFonts)()[Ir] ? Et.FontFlags.Symbolic : Et.FontFlags.Nonsymbolic);
                  or = {
                    type: Kt,
                    name: Sr,
                    loadedName: rr.loadedName,
                    systemFontInfo: null,
                    widths: Br.widths,
                    defaultWidth: Br.defaultWidth,
                    isSimulatedFlags: !0,
                    flags: hr,
                    firstChar: nr,
                    lastChar: tr,
                    toUnicode: ir,
                    xHeight: 0,
                    capHeight: 0,
                    italicAngle: 0,
                    isType3Font: cr
                  };
                  const vr = Jt.get("Widths"), xr = (0, ut.getStandardFontName)(Sr);
                  let Pr = null;
                  return xr && (Pr = await this.fetchStandardFontData(xr), or.isInternalFont = !!Pr), !or.isInternalFont && this.options.useSystemFonts && (or.systemFontInfo = (0, St.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, Sr, xr)), this.extractDataStructures(Jt, Jt, or).then((Rr) => {
                    if (vr) {
                      const Dr = [];
                      let Gr = nr;
                      for (const Or of vr)
                        Dr[Gr++] = this.xref.fetchIfRef(Or);
                      Rr.widths = Dr;
                    } else
                      Rr.widths = this.buildCharCodeToWidth(Br.widths, Rr);
                    return new et.Font(Sr, Pr, Rr);
                  });
                }
              let Xt = ar.get("FontName"), Gt = Jt.get("BaseFont");
              typeof Xt == "string" && (Xt = lt.Name.get(Xt)), typeof Gt == "string" && (Gt = lt.Name.get(Gt));
              const Wt = Xt == null ? void 0 : Xt.name, er = Gt == null ? void 0 : Gt.name;
              if (!cr && Wt !== er && ((0, rt.info)(`The FontDescriptor's FontName is "${Wt}" but should be the same as the Font's BaseFont "${er}".`), Wt && er && (er.startsWith(Wt) || !(0, ut.isKnownFontName)(Wt) && (0, ut.isKnownFontName)(er)) && (Xt = null)), Xt || (Xt = Gt), !(Xt instanceof lt.Name))
                throw new rt.FormatError("invalid font name");
              let lr, ur, pr, yr, Er;
              try {
                lr = ar.get("FontFile", "FontFile2", "FontFile3");
              } catch (Sr) {
                if (!this.options.ignoreErrors)
                  throw Sr;
                (0, rt.warn)(`translateFont - fetching "${Xt.name}" font file: "${Sr}".`), lr = new ct.NullStream();
              }
              let br = !1, gr = null, Ar = null;
              if (lr) {
                if (lr.dict) {
                  const Sr = lr.dict.get("Subtype");
                  Sr instanceof lt.Name && (ur = Sr.name), pr = lr.dict.get("Length1"), yr = lr.dict.get("Length2"), Er = lr.dict.get("Length3");
                }
              } else if (sr) {
                const Sr = (0, ht.getXfaFontName)(Xt.name);
                Sr && (sr.fontFamily = `${sr.fontFamily}-PdfJS-XFA`, sr.metrics = Sr.metrics || null, gr = Sr.factors || null, lr = await this.fetchStandardFontData(Sr.name), br = !!lr, rr = Jt = (0, ht.getXfaFontDict)(Xt.name), Yt = !0);
              } else if (!cr) {
                const Sr = (0, ut.getStandardFontName)(Xt.name);
                Sr && (lr = await this.fetchStandardFontData(Sr), br = !!lr), !br && this.options.useSystemFonts && (Ar = (0, St.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, Xt.name, Sr));
              }
              if (or = {
                type: Kt,
                name: Xt.name,
                subtype: ur,
                file: lr,
                length1: pr,
                length2: yr,
                length3: Er,
                isInternalFont: br,
                loadedName: rr.loadedName,
                composite: Yt,
                fixedPitch: !1,
                fontMatrix: Jt.getArray("FontMatrix") || rt.FONT_IDENTITY_MATRIX,
                firstChar: nr,
                lastChar: tr,
                toUnicode: ir,
                bbox: ar.getArray("FontBBox") || Jt.getArray("FontBBox"),
                ascent: ar.get("Ascent"),
                descent: ar.get("Descent"),
                xHeight: ar.get("XHeight") || 0,
                capHeight: ar.get("CapHeight") || 0,
                flags: ar.get("Flags"),
                italicAngle: ar.get("ItalicAngle") || 0,
                isType3Font: cr,
                cssFontInfo: sr,
                scaleFactors: gr,
                systemFontInfo: Ar
              }, Yt) {
                const Sr = rr.get("Encoding");
                Sr instanceof lt.Name && (or.cidEncoding = Sr.name);
                const Br = await st.CMapFactory.create({
                  encoding: Sr,
                  fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                  useCMap: null
                });
                or.cMap = Br, or.vertical = or.cMap.vertical;
              }
              return this.extractDataStructures(Jt, rr, or).then((Sr) => (this.extractWidths(Jt, ar, Sr), new et.Font(Xt.name, lr, Sr)));
            }
            static buildFontPaths(Zt, ar, Jt, rr) {
              function Yt(Kt) {
                const nr = `${Zt.loadedName}_path_${Kt}`;
                try {
                  if (Zt.renderer.hasBuiltPath(Kt))
                    return;
                  Jt.send("commonobj", [nr, "FontPath", Zt.renderer.getPathJs(Kt)]);
                } catch (tr) {
                  if (rr.ignoreErrors) {
                    (0, rt.warn)(`buildFontPaths - ignoring ${nr} glyph: "${tr}".`);
                    return;
                  }
                  throw tr;
                }
              }
              for (const Kt of ar) {
                Yt(Kt.fontChar);
                const nr = Kt.accent;
                nr != null && nr.fontChar && Yt(nr.fontChar);
              }
            }
            static get fallbackFontDict() {
              const Zt = new lt.Dict();
              return Zt.set("BaseFont", lt.Name.get("Helvetica")), Zt.set("Type", lt.Name.get("FallbackType")), Zt.set("Subtype", lt.Name.get("FallbackType")), Zt.set("Encoding", lt.Name.get("WinAnsiEncoding")), (0, rt.shadow)(this, "fallbackFontDict", Zt);
            }
          }
          at.PartialEvaluator = Mt;
          class Lt {
            constructor(Zt) {
              let {
                loadedName: ar,
                font: Jt,
                dict: rr,
                evaluatorOptions: Yt
              } = Zt;
              this.loadedName = ar, this.font = Jt, this.dict = rr, this._evaluatorOptions = Yt || Rt, this.type3Loaded = null, this.type3Dependencies = Jt.isType3Font ? /* @__PURE__ */ new Set() : null, this.sent = !1;
            }
            send(Zt) {
              this.sent || (this.sent = !0, Zt.send("commonobj", [this.loadedName, "Font", this.font.exportData(this._evaluatorOptions.fontExtraProperties)]));
            }
            fallback(Zt) {
              this.font.data && (this.font.disableFontFace = !0, Mt.buildFontPaths(this.font, this.font.glyphCacheValues, Zt, this._evaluatorOptions));
            }
            loadType3Data(Zt, ar, Jt) {
              if (this.type3Loaded)
                return this.type3Loaded;
              if (!this.font.isType3Font)
                throw new Error("Must be a Type3 font.");
              const rr = Zt.clone({
                ignoreErrors: !1
              });
              rr.parsingType3Font = !0;
              const Yt = new lt.RefSet(Zt.type3FontRefs);
              this.dict.objId && !Yt.has(this.dict.objId) && Yt.put(this.dict.objId), rr.type3FontRefs = Yt;
              const Kt = this.font, nr = this.type3Dependencies;
              let tr = Promise.resolve();
              const ir = this.dict.get("CharProcs"), sr = this.dict.get("Resources") || ar, cr = /* @__PURE__ */ Object.create(null), or = rt.Util.normalizeRect(Kt.bbox || [0, 0, 0, 0]), Xt = or[2] - or[0], Gt = or[3] - or[1], Wt = Math.hypot(Xt, Gt);
              for (const er of ir.getKeys())
                tr = tr.then(() => {
                  const lr = ir.get(er), ur = new It.OperatorList();
                  return rr.getOperatorList({
                    stream: lr,
                    task: Jt,
                    resources: sr,
                    operatorList: ur
                  }).then(() => {
                    ur.fnArray[0] === rt.OPS.setCharWidthAndBounds && this._removeType3ColorOperators(ur, Wt), cr[er] = ur.getIR();
                    for (const pr of ur.dependencies)
                      nr.add(pr);
                  }).catch(function(pr) {
                    (0, rt.warn)(`Type3 font resource "${er}" is not available.`);
                    const yr = new It.OperatorList();
                    cr[er] = yr.getIR();
                  });
                });
              return this.type3Loaded = tr.then(() => {
                Kt.charProcOperatorList = cr, this._bbox && (Kt.isCharBBox = !0, Kt.bbox = this._bbox);
              }), this.type3Loaded;
            }
            _removeType3ColorOperators(Zt) {
              let ar = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
              const Jt = rt.Util.normalizeRect(Zt.argsArray[0].slice(2)), rr = Jt[2] - Jt[0], Yt = Jt[3] - Jt[1], Kt = Math.hypot(rr, Yt);
              rr === 0 || Yt === 0 ? (Zt.fnArray.splice(0, 1), Zt.argsArray.splice(0, 1)) : (ar === 0 || Math.round(Kt / ar) >= 10) && (this._bbox || (this._bbox = [1 / 0, 1 / 0, -1 / 0, -1 / 0]), this._bbox[0] = Math.min(this._bbox[0], Jt[0]), this._bbox[1] = Math.min(this._bbox[1], Jt[1]), this._bbox[2] = Math.max(this._bbox[2], Jt[2]), this._bbox[3] = Math.max(this._bbox[3], Jt[3]));
              let nr = 0, tr = Zt.length;
              for (; nr < tr; ) {
                switch (Zt.fnArray[nr]) {
                  case rt.OPS.setCharWidthAndBounds:
                    break;
                  case rt.OPS.setStrokeColorSpace:
                  case rt.OPS.setFillColorSpace:
                  case rt.OPS.setStrokeColor:
                  case rt.OPS.setStrokeColorN:
                  case rt.OPS.setFillColor:
                  case rt.OPS.setFillColorN:
                  case rt.OPS.setStrokeGray:
                  case rt.OPS.setFillGray:
                  case rt.OPS.setStrokeRGBColor:
                  case rt.OPS.setFillRGBColor:
                  case rt.OPS.setStrokeCMYKColor:
                  case rt.OPS.setFillCMYKColor:
                  case rt.OPS.shadingFill:
                  case rt.OPS.setRenderingIntent:
                    Zt.fnArray.splice(nr, 1), Zt.argsArray.splice(nr, 1), tr--;
                    continue;
                  case rt.OPS.setGState:
                    const [ir] = Zt.argsArray[nr];
                    let sr = 0, cr = ir.length;
                    for (; sr < cr; ) {
                      const [or] = ir[sr];
                      switch (or) {
                        case "TR":
                        case "TR2":
                        case "HT":
                        case "BG":
                        case "BG2":
                        case "UCR":
                        case "UCR2":
                          ir.splice(sr, 1), cr--;
                          continue;
                      }
                      sr++;
                    }
                    break;
                }
                nr++;
              }
            }
          }
          class $t {
            constructor() {
              let Zt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Dt();
              this.state = Zt, this.stateStack = [];
            }
            save() {
              const Zt = this.state;
              this.stateStack.push(this.state), this.state = Zt.clone();
            }
            restore() {
              const Zt = this.stateStack.pop();
              Zt && (this.state = Zt);
            }
            transform(Zt) {
              this.state.ctm = rt.Util.transform(this.state.ctm, Zt);
            }
          }
          class Tt {
            constructor() {
              this.ctm = new Float32Array(rt.IDENTITY_MATRIX), this.fontName = null, this.fontSize = 0, this.loadedName = null, this.font = null, this.fontMatrix = rt.FONT_IDENTITY_MATRIX, this.textMatrix = rt.IDENTITY_MATRIX.slice(), this.textLineMatrix = rt.IDENTITY_MATRIX.slice(), this.charSpacing = 0, this.wordSpacing = 0, this.leading = 0, this.textHScale = 1, this.textRise = 0;
            }
            setTextMatrix(Zt, ar, Jt, rr, Yt, Kt) {
              const nr = this.textMatrix;
              nr[0] = Zt, nr[1] = ar, nr[2] = Jt, nr[3] = rr, nr[4] = Yt, nr[5] = Kt;
            }
            setTextLineMatrix(Zt, ar, Jt, rr, Yt, Kt) {
              const nr = this.textLineMatrix;
              nr[0] = Zt, nr[1] = ar, nr[2] = Jt, nr[3] = rr, nr[4] = Yt, nr[5] = Kt;
            }
            translateTextMatrix(Zt, ar) {
              const Jt = this.textMatrix;
              Jt[4] = Jt[0] * Zt + Jt[2] * ar + Jt[4], Jt[5] = Jt[1] * Zt + Jt[3] * ar + Jt[5];
            }
            translateTextLineMatrix(Zt, ar) {
              const Jt = this.textLineMatrix;
              Jt[4] = Jt[0] * Zt + Jt[2] * ar + Jt[4], Jt[5] = Jt[1] * Zt + Jt[3] * ar + Jt[5];
            }
            carriageReturn() {
              this.translateTextLineMatrix(0, -this.leading), this.textMatrix = this.textLineMatrix.slice();
            }
            clone() {
              const Zt = Object.create(this);
              return Zt.textMatrix = this.textMatrix.slice(), Zt.textLineMatrix = this.textLineMatrix.slice(), Zt.fontMatrix = this.fontMatrix.slice(), Zt;
            }
          }
          class Dt {
            constructor() {
              this.ctm = new Float32Array(rt.IDENTITY_MATRIX), this.font = null, this.textRenderingMode = rt.TextRenderingMode.FILL, this.fillColorSpace = xt.ColorSpace.singletons.gray, this.strokeColorSpace = xt.ColorSpace.singletons.gray;
            }
            clone() {
              return Object.create(this);
            }
          }
          const Qt = class Qt {
            static get opMap() {
              return (0, rt.shadow)(this, "opMap", {
                w: {
                  id: rt.OPS.setLineWidth,
                  numArgs: 1,
                  variableArgs: !1
                },
                J: {
                  id: rt.OPS.setLineCap,
                  numArgs: 1,
                  variableArgs: !1
                },
                j: {
                  id: rt.OPS.setLineJoin,
                  numArgs: 1,
                  variableArgs: !1
                },
                M: {
                  id: rt.OPS.setMiterLimit,
                  numArgs: 1,
                  variableArgs: !1
                },
                d: {
                  id: rt.OPS.setDash,
                  numArgs: 2,
                  variableArgs: !1
                },
                ri: {
                  id: rt.OPS.setRenderingIntent,
                  numArgs: 1,
                  variableArgs: !1
                },
                i: {
                  id: rt.OPS.setFlatness,
                  numArgs: 1,
                  variableArgs: !1
                },
                gs: {
                  id: rt.OPS.setGState,
                  numArgs: 1,
                  variableArgs: !1
                },
                q: {
                  id: rt.OPS.save,
                  numArgs: 0,
                  variableArgs: !1
                },
                Q: {
                  id: rt.OPS.restore,
                  numArgs: 0,
                  variableArgs: !1
                },
                cm: {
                  id: rt.OPS.transform,
                  numArgs: 6,
                  variableArgs: !1
                },
                m: {
                  id: rt.OPS.moveTo,
                  numArgs: 2,
                  variableArgs: !1
                },
                l: {
                  id: rt.OPS.lineTo,
                  numArgs: 2,
                  variableArgs: !1
                },
                c: {
                  id: rt.OPS.curveTo,
                  numArgs: 6,
                  variableArgs: !1
                },
                v: {
                  id: rt.OPS.curveTo2,
                  numArgs: 4,
                  variableArgs: !1
                },
                y: {
                  id: rt.OPS.curveTo3,
                  numArgs: 4,
                  variableArgs: !1
                },
                h: {
                  id: rt.OPS.closePath,
                  numArgs: 0,
                  variableArgs: !1
                },
                re: {
                  id: rt.OPS.rectangle,
                  numArgs: 4,
                  variableArgs: !1
                },
                S: {
                  id: rt.OPS.stroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                s: {
                  id: rt.OPS.closeStroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                f: {
                  id: rt.OPS.fill,
                  numArgs: 0,
                  variableArgs: !1
                },
                F: {
                  id: rt.OPS.fill,
                  numArgs: 0,
                  variableArgs: !1
                },
                "f*": {
                  id: rt.OPS.eoFill,
                  numArgs: 0,
                  variableArgs: !1
                },
                B: {
                  id: rt.OPS.fillStroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                "B*": {
                  id: rt.OPS.eoFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                b: {
                  id: rt.OPS.closeFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                "b*": {
                  id: rt.OPS.closeEOFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                },
                n: {
                  id: rt.OPS.endPath,
                  numArgs: 0,
                  variableArgs: !1
                },
                W: {
                  id: rt.OPS.clip,
                  numArgs: 0,
                  variableArgs: !1
                },
                "W*": {
                  id: rt.OPS.eoClip,
                  numArgs: 0,
                  variableArgs: !1
                },
                BT: {
                  id: rt.OPS.beginText,
                  numArgs: 0,
                  variableArgs: !1
                },
                ET: {
                  id: rt.OPS.endText,
                  numArgs: 0,
                  variableArgs: !1
                },
                Tc: {
                  id: rt.OPS.setCharSpacing,
                  numArgs: 1,
                  variableArgs: !1
                },
                Tw: {
                  id: rt.OPS.setWordSpacing,
                  numArgs: 1,
                  variableArgs: !1
                },
                Tz: {
                  id: rt.OPS.setHScale,
                  numArgs: 1,
                  variableArgs: !1
                },
                TL: {
                  id: rt.OPS.setLeading,
                  numArgs: 1,
                  variableArgs: !1
                },
                Tf: {
                  id: rt.OPS.setFont,
                  numArgs: 2,
                  variableArgs: !1
                },
                Tr: {
                  id: rt.OPS.setTextRenderingMode,
                  numArgs: 1,
                  variableArgs: !1
                },
                Ts: {
                  id: rt.OPS.setTextRise,
                  numArgs: 1,
                  variableArgs: !1
                },
                Td: {
                  id: rt.OPS.moveText,
                  numArgs: 2,
                  variableArgs: !1
                },
                TD: {
                  id: rt.OPS.setLeadingMoveText,
                  numArgs: 2,
                  variableArgs: !1
                },
                Tm: {
                  id: rt.OPS.setTextMatrix,
                  numArgs: 6,
                  variableArgs: !1
                },
                "T*": {
                  id: rt.OPS.nextLine,
                  numArgs: 0,
                  variableArgs: !1
                },
                Tj: {
                  id: rt.OPS.showText,
                  numArgs: 1,
                  variableArgs: !1
                },
                TJ: {
                  id: rt.OPS.showSpacedText,
                  numArgs: 1,
                  variableArgs: !1
                },
                "'": {
                  id: rt.OPS.nextLineShowText,
                  numArgs: 1,
                  variableArgs: !1
                },
                '"': {
                  id: rt.OPS.nextLineSetSpacingShowText,
                  numArgs: 3,
                  variableArgs: !1
                },
                d0: {
                  id: rt.OPS.setCharWidth,
                  numArgs: 2,
                  variableArgs: !1
                },
                d1: {
                  id: rt.OPS.setCharWidthAndBounds,
                  numArgs: 6,
                  variableArgs: !1
                },
                CS: {
                  id: rt.OPS.setStrokeColorSpace,
                  numArgs: 1,
                  variableArgs: !1
                },
                cs: {
                  id: rt.OPS.setFillColorSpace,
                  numArgs: 1,
                  variableArgs: !1
                },
                SC: {
                  id: rt.OPS.setStrokeColor,
                  numArgs: 4,
                  variableArgs: !0
                },
                SCN: {
                  id: rt.OPS.setStrokeColorN,
                  numArgs: 33,
                  variableArgs: !0
                },
                sc: {
                  id: rt.OPS.setFillColor,
                  numArgs: 4,
                  variableArgs: !0
                },
                scn: {
                  id: rt.OPS.setFillColorN,
                  numArgs: 33,
                  variableArgs: !0
                },
                G: {
                  id: rt.OPS.setStrokeGray,
                  numArgs: 1,
                  variableArgs: !1
                },
                g: {
                  id: rt.OPS.setFillGray,
                  numArgs: 1,
                  variableArgs: !1
                },
                RG: {
                  id: rt.OPS.setStrokeRGBColor,
                  numArgs: 3,
                  variableArgs: !1
                },
                rg: {
                  id: rt.OPS.setFillRGBColor,
                  numArgs: 3,
                  variableArgs: !1
                },
                K: {
                  id: rt.OPS.setStrokeCMYKColor,
                  numArgs: 4,
                  variableArgs: !1
                },
                k: {
                  id: rt.OPS.setFillCMYKColor,
                  numArgs: 4,
                  variableArgs: !1
                },
                sh: {
                  id: rt.OPS.shadingFill,
                  numArgs: 1,
                  variableArgs: !1
                },
                BI: {
                  id: rt.OPS.beginInlineImage,
                  numArgs: 0,
                  variableArgs: !1
                },
                ID: {
                  id: rt.OPS.beginImageData,
                  numArgs: 0,
                  variableArgs: !1
                },
                EI: {
                  id: rt.OPS.endInlineImage,
                  numArgs: 1,
                  variableArgs: !1
                },
                Do: {
                  id: rt.OPS.paintXObject,
                  numArgs: 1,
                  variableArgs: !1
                },
                MP: {
                  id: rt.OPS.markPoint,
                  numArgs: 1,
                  variableArgs: !1
                },
                DP: {
                  id: rt.OPS.markPointProps,
                  numArgs: 2,
                  variableArgs: !1
                },
                BMC: {
                  id: rt.OPS.beginMarkedContent,
                  numArgs: 1,
                  variableArgs: !1
                },
                BDC: {
                  id: rt.OPS.beginMarkedContentProps,
                  numArgs: 2,
                  variableArgs: !1
                },
                EMC: {
                  id: rt.OPS.endMarkedContent,
                  numArgs: 0,
                  variableArgs: !1
                },
                BX: {
                  id: rt.OPS.beginCompat,
                  numArgs: 0,
                  variableArgs: !1
                },
                EX: {
                  id: rt.OPS.endCompat,
                  numArgs: 0,
                  variableArgs: !1
                },
                BM: null,
                BD: null,
                true: null,
                fa: null,
                fal: null,
                fals: null,
                false: null,
                nu: null,
                nul: null,
                null: null
              });
            }
            constructor(Zt, ar) {
              let Jt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $t();
              this.parser = new pt.Parser({
                lexer: new pt.Lexer(Zt, Qt.opMap),
                xref: ar
              }), this.stateManager = Jt, this.nonProcessedArgs = [], this._isPathOp = !1, this._numInvalidPathOPS = 0;
            }
            get savedStatesDepth() {
              return this.stateManager.stateStack.length;
            }
            read(Zt) {
              let ar = Zt.args;
              for (; ; ) {
                const Jt = this.parser.getObj();
                if (Jt instanceof lt.Cmd) {
                  const rr = Jt.cmd, Yt = Qt.opMap[rr];
                  if (!Yt) {
                    (0, rt.warn)(`Unknown command "${rr}".`);
                    continue;
                  }
                  const Kt = Yt.id, nr = Yt.numArgs;
                  let tr = ar !== null ? ar.length : 0;
                  if (this._isPathOp || (this._numInvalidPathOPS = 0), this._isPathOp = Kt >= rt.OPS.moveTo && Kt <= rt.OPS.endPath, Yt.variableArgs)
                    tr > nr && (0, rt.info)(`Command ${rr}: expected [0, ${nr}] args, but received ${tr} args.`);
                  else {
                    if (tr !== nr) {
                      const ir = this.nonProcessedArgs;
                      for (; tr > nr; )
                        ir.push(ar.shift()), tr--;
                      for (; tr < nr && ir.length !== 0; )
                        ar === null && (ar = []), ar.unshift(ir.pop()), tr++;
                    }
                    if (tr < nr) {
                      const ir = `command ${rr}: expected ${nr} args, but received ${tr} args.`;
                      if (this._isPathOp && ++this._numInvalidPathOPS > Qt.MAX_INVALID_PATH_OPS)
                        throw new rt.FormatError(`Invalid ${ir}`);
                      (0, rt.warn)(`Skipping ${ir}`), ar !== null && (ar.length = 0);
                      continue;
                    }
                  }
                  return this.preprocessCommand(Kt, ar), Zt.fn = Kt, Zt.args = ar, !0;
                }
                if (Jt === lt.EOF)
                  return !1;
                if (Jt !== null && (ar === null && (ar = []), ar.push(Jt), ar.length > 33))
                  throw new rt.FormatError("Too many arguments");
              }
            }
            preprocessCommand(Zt, ar) {
              switch (Zt | 0) {
                case rt.OPS.save:
                  this.stateManager.save();
                  break;
                case rt.OPS.restore:
                  this.stateManager.restore();
                  break;
                case rt.OPS.transform:
                  this.stateManager.transform(ar);
                  break;
              }
            }
          };
          Ln(Qt, "MAX_INVALID_PATH_OPS", 10);
          let Ut = Qt;
          at.EvaluatorPreprocessor = Ut;
        },
        /* 165 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.IdentityCMap = at.CMapFactory = at.CMap = void 0, ot(140), ot(2);
          var rt = ot(145), st = ot(151), lt = ot(152), et = ot(166), it = ot(167), ut = ot(150), ft = ot(155);
          const ht = ["Adobe-GB1-UCS2", "Adobe-CNS1-UCS2", "Adobe-Japan1-UCS2", "Adobe-Korea1-UCS2", "78-EUC-H", "78-EUC-V", "78-H", "78-RKSJ-H", "78-RKSJ-V", "78-V", "78ms-RKSJ-H", "78ms-RKSJ-V", "83pv-RKSJ-H", "90ms-RKSJ-H", "90ms-RKSJ-V", "90msp-RKSJ-H", "90msp-RKSJ-V", "90pv-RKSJ-H", "90pv-RKSJ-V", "Add-H", "Add-RKSJ-H", "Add-RKSJ-V", "Add-V", "Adobe-CNS1-0", "Adobe-CNS1-1", "Adobe-CNS1-2", "Adobe-CNS1-3", "Adobe-CNS1-4", "Adobe-CNS1-5", "Adobe-CNS1-6", "Adobe-GB1-0", "Adobe-GB1-1", "Adobe-GB1-2", "Adobe-GB1-3", "Adobe-GB1-4", "Adobe-GB1-5", "Adobe-Japan1-0", "Adobe-Japan1-1", "Adobe-Japan1-2", "Adobe-Japan1-3", "Adobe-Japan1-4", "Adobe-Japan1-5", "Adobe-Japan1-6", "Adobe-Korea1-0", "Adobe-Korea1-1", "Adobe-Korea1-2", "B5-H", "B5-V", "B5pc-H", "B5pc-V", "CNS-EUC-H", "CNS-EUC-V", "CNS1-H", "CNS1-V", "CNS2-H", "CNS2-V", "ETHK-B5-H", "ETHK-B5-V", "ETen-B5-H", "ETen-B5-V", "ETenms-B5-H", "ETenms-B5-V", "EUC-H", "EUC-V", "Ext-H", "Ext-RKSJ-H", "Ext-RKSJ-V", "Ext-V", "GB-EUC-H", "GB-EUC-V", "GB-H", "GB-V", "GBK-EUC-H", "GBK-EUC-V", "GBK2K-H", "GBK2K-V", "GBKp-EUC-H", "GBKp-EUC-V", "GBT-EUC-H", "GBT-EUC-V", "GBT-H", "GBT-V", "GBTpc-EUC-H", "GBTpc-EUC-V", "GBpc-EUC-H", "GBpc-EUC-V", "H", "HKdla-B5-H", "HKdla-B5-V", "HKdlb-B5-H", "HKdlb-B5-V", "HKgccs-B5-H", "HKgccs-B5-V", "HKm314-B5-H", "HKm314-B5-V", "HKm471-B5-H", "HKm471-B5-V", "HKscs-B5-H", "HKscs-B5-V", "Hankaku", "Hiragana", "KSC-EUC-H", "KSC-EUC-V", "KSC-H", "KSC-Johab-H", "KSC-Johab-V", "KSC-V", "KSCms-UHC-H", "KSCms-UHC-HW-H", "KSCms-UHC-HW-V", "KSCms-UHC-V", "KSCpc-EUC-H", "KSCpc-EUC-V", "Katakana", "NWP-H", "NWP-V", "RKSJ-H", "RKSJ-V", "Roman", "UniCNS-UCS2-H", "UniCNS-UCS2-V", "UniCNS-UTF16-H", "UniCNS-UTF16-V", "UniCNS-UTF32-H", "UniCNS-UTF32-V", "UniCNS-UTF8-H", "UniCNS-UTF8-V", "UniGB-UCS2-H", "UniGB-UCS2-V", "UniGB-UTF16-H", "UniGB-UTF16-V", "UniGB-UTF32-H", "UniGB-UTF32-V", "UniGB-UTF8-H", "UniGB-UTF8-V", "UniJIS-UCS2-H", "UniJIS-UCS2-HW-H", "UniJIS-UCS2-HW-V", "UniJIS-UCS2-V", "UniJIS-UTF16-H", "UniJIS-UTF16-V", "UniJIS-UTF32-H", "UniJIS-UTF32-V", "UniJIS-UTF8-H", "UniJIS-UTF8-V", "UniJIS2004-UTF16-H", "UniJIS2004-UTF16-V", "UniJIS2004-UTF32-H", "UniJIS2004-UTF32-V", "UniJIS2004-UTF8-H", "UniJIS2004-UTF8-V", "UniJISPro-UCS2-HW-V", "UniJISPro-UCS2-V", "UniJISPro-UTF8-V", "UniJISX0213-UTF32-H", "UniJISX0213-UTF32-V", "UniJISX02132004-UTF32-H", "UniJISX02132004-UTF32-V", "UniKS-UCS2-H", "UniKS-UCS2-V", "UniKS-UTF16-H", "UniKS-UTF16-V", "UniKS-UTF32-H", "UniKS-UTF32-V", "UniKS-UTF8-H", "UniKS-UTF8-V", "V", "WP-Symbol"], dt = 2 ** 24 - 1;
          class gt {
            constructor() {
              let Rt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              this.codespaceRanges = [[], [], [], []], this.numCodespaceRanges = 0, this._map = [], this.name = "", this.vertical = !1, this.useCMap = null, this.builtInCMap = Rt;
            }
            addCodespaceRange(Rt, kt, jt) {
              this.codespaceRanges[Rt - 1].push(kt, jt), this.numCodespaceRanges++;
            }
            mapCidRange(Rt, kt, jt) {
              if (kt - Rt > dt)
                throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
              for (; Rt <= kt; )
                this._map[Rt++] = jt++;
            }
            mapBfRange(Rt, kt, jt) {
              if (kt - Rt > dt)
                throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
              const Ht = jt.length - 1;
              for (; Rt <= kt; ) {
                this._map[Rt++] = jt;
                const Ft = jt.charCodeAt(Ht) + 1;
                if (Ft > 255) {
                  jt = jt.substring(0, Ht - 1) + String.fromCharCode(jt.charCodeAt(Ht - 1) + 1) + "\0";
                  continue;
                }
                jt = jt.substring(0, Ht) + String.fromCharCode(Ft);
              }
            }
            mapBfRangeToArray(Rt, kt, jt) {
              if (kt - Rt > dt)
                throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
              const Ht = jt.length;
              let Ft = 0;
              for (; Rt <= kt && Ft < Ht; )
                this._map[Rt] = jt[Ft++], ++Rt;
            }
            mapOne(Rt, kt) {
              this._map[Rt] = kt;
            }
            lookup(Rt) {
              return this._map[Rt];
            }
            contains(Rt) {
              return this._map[Rt] !== void 0;
            }
            forEach(Rt) {
              const kt = this._map, jt = kt.length;
              if (jt <= 65536)
                for (let Ht = 0; Ht < jt; Ht++)
                  kt[Ht] !== void 0 && Rt(Ht, kt[Ht]);
              else
                for (const Ht in kt)
                  Rt(Ht, kt[Ht]);
            }
            charCodeOf(Rt) {
              const kt = this._map;
              if (kt.length <= 65536)
                return kt.indexOf(Rt);
              for (const jt in kt)
                if (kt[jt] === Rt)
                  return jt | 0;
              return -1;
            }
            getMap() {
              return this._map;
            }
            readCharCode(Rt, kt, jt) {
              let Ht = 0;
              const Ft = this.codespaceRanges;
              for (let _t = 0, Nt = Ft.length; _t < Nt; _t++) {
                Ht = (Ht << 8 | Rt.charCodeAt(kt + _t)) >>> 0;
                const Mt = Ft[_t];
                for (let Lt = 0, $t = Mt.length; Lt < $t; ) {
                  const Tt = Mt[Lt++], Dt = Mt[Lt++];
                  if (Ht >= Tt && Ht <= Dt) {
                    jt.charcode = Ht, jt.length = _t + 1;
                    return;
                  }
                }
              }
              jt.charcode = 0, jt.length = 1;
            }
            getCharCodeLength(Rt) {
              const kt = this.codespaceRanges;
              for (let jt = 0, Ht = kt.length; jt < Ht; jt++) {
                const Ft = kt[jt];
                for (let _t = 0, Nt = Ft.length; _t < Nt; ) {
                  const Mt = Ft[_t++], Lt = Ft[_t++];
                  if (Rt >= Mt && Rt <= Lt)
                    return jt + 1;
                }
              }
              return 1;
            }
            get length() {
              return this._map.length;
            }
            get isIdentityCMap() {
              if (!(this.name === "Identity-H" || this.name === "Identity-V") || this._map.length !== 65536)
                return !1;
              for (let Rt = 0; Rt < 65536; Rt++)
                if (this._map[Rt] !== Rt)
                  return !1;
              return !0;
            }
          }
          at.CMap = gt;
          class pt extends gt {
            constructor(Rt, kt) {
              super(), this.vertical = Rt, this.addCodespaceRange(kt, 0, 65535);
            }
            mapCidRange(Rt, kt, jt) {
              (0, rt.unreachable)("should not call mapCidRange");
            }
            mapBfRange(Rt, kt, jt) {
              (0, rt.unreachable)("should not call mapBfRange");
            }
            mapBfRangeToArray(Rt, kt, jt) {
              (0, rt.unreachable)("should not call mapBfRangeToArray");
            }
            mapOne(Rt, kt) {
              (0, rt.unreachable)("should not call mapCidOne");
            }
            lookup(Rt) {
              return Number.isInteger(Rt) && Rt <= 65535 ? Rt : void 0;
            }
            contains(Rt) {
              return Number.isInteger(Rt) && Rt <= 65535;
            }
            forEach(Rt) {
              for (let kt = 0; kt <= 65535; kt++)
                Rt(kt, kt);
            }
            charCodeOf(Rt) {
              return Number.isInteger(Rt) && Rt <= 65535 ? Rt : -1;
            }
            getMap() {
              const Rt = new Array(65536);
              for (let kt = 0; kt <= 65535; kt++)
                Rt[kt] = kt;
              return Rt;
            }
            get length() {
              return 65536;
            }
            get isIdentityCMap() {
              (0, rt.unreachable)("should not access .isIdentityCMap");
            }
          }
          at.IdentityCMap = pt;
          function mt(yt) {
            let Rt = 0;
            for (let kt = 0; kt < yt.length; kt++)
              Rt = Rt << 8 | yt.charCodeAt(kt);
            return Rt >>> 0;
          }
          function ct(yt) {
            if (typeof yt != "string")
              throw new rt.FormatError("Malformed CMap: expected string.");
          }
          function vt(yt) {
            if (!Number.isInteger(yt))
              throw new rt.FormatError("Malformed CMap: expected int.");
          }
          function At(yt, Rt) {
            for (; ; ) {
              let kt = Rt.getObj();
              if (kt === st.EOF)
                break;
              if ((0, st.isCmd)(kt, "endbfchar"))
                return;
              ct(kt);
              const jt = mt(kt);
              kt = Rt.getObj(), ct(kt);
              const Ht = kt;
              yt.mapOne(jt, Ht);
            }
          }
          function xt(yt, Rt) {
            for (; ; ) {
              let kt = Rt.getObj();
              if (kt === st.EOF)
                break;
              if ((0, st.isCmd)(kt, "endbfrange"))
                return;
              ct(kt);
              const jt = mt(kt);
              kt = Rt.getObj(), ct(kt);
              const Ht = mt(kt);
              if (kt = Rt.getObj(), Number.isInteger(kt) || typeof kt == "string") {
                const Ft = Number.isInteger(kt) ? String.fromCharCode(kt) : kt;
                yt.mapBfRange(jt, Ht, Ft);
              } else if ((0, st.isCmd)(kt, "[")) {
                kt = Rt.getObj();
                const Ft = [];
                for (; !(0, st.isCmd)(kt, "]") && kt !== st.EOF; )
                  Ft.push(kt), kt = Rt.getObj();
                yt.mapBfRangeToArray(jt, Ht, Ft);
              } else
                break;
            }
            throw new rt.FormatError("Invalid bf range.");
          }
          function bt(yt, Rt) {
            for (; ; ) {
              let kt = Rt.getObj();
              if (kt === st.EOF)
                break;
              if ((0, st.isCmd)(kt, "endcidchar"))
                return;
              ct(kt);
              const jt = mt(kt);
              kt = Rt.getObj(), vt(kt);
              const Ht = kt;
              yt.mapOne(jt, Ht);
            }
          }
          function Et(yt, Rt) {
            for (; ; ) {
              let kt = Rt.getObj();
              if (kt === st.EOF)
                break;
              if ((0, st.isCmd)(kt, "endcidrange"))
                return;
              ct(kt);
              const jt = mt(kt);
              kt = Rt.getObj(), ct(kt);
              const Ht = mt(kt);
              kt = Rt.getObj(), vt(kt);
              const Ft = kt;
              yt.mapCidRange(jt, Ht, Ft);
            }
          }
          function St(yt, Rt) {
            for (; ; ) {
              let kt = Rt.getObj();
              if (kt === st.EOF)
                break;
              if ((0, st.isCmd)(kt, "endcodespacerange"))
                return;
              if (typeof kt != "string")
                break;
              const jt = mt(kt);
              if (kt = Rt.getObj(), typeof kt != "string")
                break;
              const Ht = mt(kt);
              yt.addCodespaceRange(kt.length, jt, Ht);
            }
            throw new rt.FormatError("Invalid codespace range.");
          }
          function Bt(yt, Rt) {
            const kt = Rt.getObj();
            Number.isInteger(kt) && (yt.vertical = !!kt);
          }
          function Ot(yt, Rt) {
            const kt = Rt.getObj();
            kt instanceof st.Name && (yt.name = kt.name);
          }
          async function Pt(yt, Rt, kt, jt) {
            let Ht, Ft;
            e:
              for (; ; )
                try {
                  const _t = Rt.getObj();
                  if (_t === st.EOF)
                    break;
                  if (_t instanceof st.Name)
                    _t.name === "WMode" ? Bt(yt, Rt) : _t.name === "CMapName" && Ot(yt, Rt), Ht = _t;
                  else if (_t instanceof st.Cmd)
                    switch (_t.cmd) {
                      case "endcmap":
                        break e;
                      case "usecmap":
                        Ht instanceof st.Name && (Ft = Ht.name);
                        break;
                      case "begincodespacerange":
                        St(yt, Rt);
                        break;
                      case "beginbfchar":
                        At(yt, Rt);
                        break;
                      case "begincidchar":
                        bt(yt, Rt);
                        break;
                      case "beginbfrange":
                        xt(yt, Rt);
                        break;
                      case "begincidrange":
                        Et(yt, Rt);
                        break;
                    }
                } catch (_t) {
                  if (_t instanceof ut.MissingDataException)
                    throw _t;
                  (0, rt.warn)("Invalid cMap data: " + _t);
                  continue;
                }
            return !jt && Ft && (jt = Ft), jt ? wt(yt, kt, jt) : yt;
          }
          async function wt(yt, Rt, kt) {
            if (yt.useCMap = await Ct(kt, Rt), yt.numCodespaceRanges === 0) {
              const jt = yt.useCMap.codespaceRanges;
              for (let Ht = 0; Ht < jt.length; Ht++)
                yt.codespaceRanges[Ht] = jt[Ht].slice();
              yt.numCodespaceRanges = yt.useCMap.numCodespaceRanges;
            }
            return yt.useCMap.forEach(function(jt, Ht) {
              yt.contains(jt) || yt.mapOne(jt, yt.useCMap.lookup(jt));
            }), yt;
          }
          async function Ct(yt, Rt) {
            if (yt === "Identity-H")
              return new pt(!1, 2);
            if (yt === "Identity-V")
              return new pt(!0, 2);
            if (!ht.includes(yt))
              throw new Error("Unknown CMap name: " + yt);
            if (!Rt)
              throw new Error("Built-in CMap parameters are not provided.");
            const {
              cMapData: kt,
              compressionType: jt
            } = await Rt(yt), Ht = new gt(!0);
            if (jt === rt.CMapCompressionType.BINARY)
              return new et.BinaryCMapReader().process(kt, Ht, (Ft) => wt(Ht, Rt, Ft));
            if (jt === rt.CMapCompressionType.NONE) {
              const Ft = new it.Lexer(new ft.Stream(kt));
              return Pt(Ht, Ft, Rt, null);
            }
            throw new Error(`Invalid CMap "compressionType" value: ${jt}`);
          }
          class It {
            static async create(Rt) {
              let {
                encoding: kt,
                fetchBuiltInCMap: jt,
                useCMap: Ht
              } = Rt;
              if (kt instanceof st.Name)
                return Ct(kt.name, jt);
              if (kt instanceof lt.BaseStream) {
                const Ft = await Pt(new gt(), new it.Lexer(kt), jt, Ht);
                return Ft.isIdentityCMap ? Ct(Ft.name, jt) : Ft;
              }
              throw new Error("Encoding required.");
            }
          }
          at.CMapFactory = It;
        },
        /* 166 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.BinaryCMapReader = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(2);
          var rt = ot(145);
          function st(gt, pt) {
            let mt = 0;
            for (let ct = 0; ct <= pt; ct++)
              mt = mt << 8 | gt[ct];
            return mt >>> 0;
          }
          function lt(gt, pt) {
            return pt === 1 ? String.fromCharCode(gt[0], gt[1]) : pt === 3 ? String.fromCharCode(gt[0], gt[1], gt[2], gt[3]) : String.fromCharCode(...gt.subarray(0, pt + 1));
          }
          function et(gt, pt, mt) {
            let ct = 0;
            for (let vt = mt; vt >= 0; vt--)
              ct += gt[vt] + pt[vt], gt[vt] = ct & 255, ct >>= 8;
          }
          function it(gt, pt) {
            let mt = 1;
            for (let ct = pt; ct >= 0 && mt > 0; ct--)
              mt += gt[ct], gt[ct] = mt & 255, mt >>= 8;
          }
          const ut = 16, ft = 19;
          class ht {
            constructor(pt) {
              this.buffer = pt, this.pos = 0, this.end = pt.length, this.tmpBuf = new Uint8Array(ft);
            }
            readByte() {
              return this.pos >= this.end ? -1 : this.buffer[this.pos++];
            }
            readNumber() {
              let pt = 0, mt;
              do {
                const ct = this.readByte();
                if (ct < 0)
                  throw new rt.FormatError("unexpected EOF in bcmap");
                mt = !(ct & 128), pt = pt << 7 | ct & 127;
              } while (!mt);
              return pt;
            }
            readSigned() {
              const pt = this.readNumber();
              return pt & 1 ? ~(pt >>> 1) : pt >>> 1;
            }
            readHex(pt, mt) {
              pt.set(this.buffer.subarray(this.pos, this.pos + mt + 1)), this.pos += mt + 1;
            }
            readHexNumber(pt, mt) {
              let ct;
              const vt = this.tmpBuf;
              let At = 0;
              do {
                const St = this.readByte();
                if (St < 0)
                  throw new rt.FormatError("unexpected EOF in bcmap");
                ct = !(St & 128), vt[At++] = St & 127;
              } while (!ct);
              let xt = mt, bt = 0, Et = 0;
              for (; xt >= 0; ) {
                for (; Et < 8 && vt.length > 0; )
                  bt |= vt[--At] << Et, Et += 7;
                pt[xt] = bt & 255, xt--, bt >>= 8, Et -= 8;
              }
            }
            readHexSigned(pt, mt) {
              this.readHexNumber(pt, mt);
              const ct = pt[mt] & 1 ? 255 : 0;
              let vt = 0;
              for (let At = 0; At <= mt; At++)
                vt = (vt & 1) << 8 | pt[At], pt[At] = vt >> 1 ^ ct;
            }
            readString() {
              const pt = this.readNumber(), mt = new Array(pt);
              for (let ct = 0; ct < pt; ct++)
                mt[ct] = this.readNumber();
              return String.fromCharCode(...mt);
            }
          }
          class dt {
            async process(pt, mt, ct) {
              const vt = new ht(pt), At = vt.readByte();
              mt.vertical = !!(At & 1);
              let xt = null;
              const bt = new Uint8Array(ut), Et = new Uint8Array(ut), St = new Uint8Array(ut), Bt = new Uint8Array(ut), Ot = new Uint8Array(ut);
              let Pt, wt;
              for (; (wt = vt.readByte()) >= 0; ) {
                const Ct = wt >> 5;
                if (Ct === 7) {
                  switch (wt & 31) {
                    case 0:
                      vt.readString();
                      break;
                    case 1:
                      xt = vt.readString();
                      break;
                  }
                  continue;
                }
                const It = !!(wt & 16), yt = wt & 15;
                if (yt + 1 > ut)
                  throw new Error("BinaryCMapReader.process: Invalid dataSize.");
                const Rt = 1, kt = vt.readNumber();
                switch (Ct) {
                  case 0:
                    vt.readHex(bt, yt), vt.readHexNumber(Et, yt), et(Et, bt, yt), mt.addCodespaceRange(yt + 1, st(bt, yt), st(Et, yt));
                    for (let jt = 1; jt < kt; jt++)
                      it(Et, yt), vt.readHexNumber(bt, yt), et(bt, Et, yt), vt.readHexNumber(Et, yt), et(Et, bt, yt), mt.addCodespaceRange(yt + 1, st(bt, yt), st(Et, yt));
                    break;
                  case 1:
                    vt.readHex(bt, yt), vt.readHexNumber(Et, yt), et(Et, bt, yt), vt.readNumber();
                    for (let jt = 1; jt < kt; jt++)
                      it(Et, yt), vt.readHexNumber(bt, yt), et(bt, Et, yt), vt.readHexNumber(Et, yt), et(Et, bt, yt), vt.readNumber();
                    break;
                  case 2:
                    vt.readHex(St, yt), Pt = vt.readNumber(), mt.mapOne(st(St, yt), Pt);
                    for (let jt = 1; jt < kt; jt++)
                      it(St, yt), It || (vt.readHexNumber(Ot, yt), et(St, Ot, yt)), Pt = vt.readSigned() + (Pt + 1), mt.mapOne(st(St, yt), Pt);
                    break;
                  case 3:
                    vt.readHex(bt, yt), vt.readHexNumber(Et, yt), et(Et, bt, yt), Pt = vt.readNumber(), mt.mapCidRange(st(bt, yt), st(Et, yt), Pt);
                    for (let jt = 1; jt < kt; jt++)
                      it(Et, yt), It ? bt.set(Et) : (vt.readHexNumber(bt, yt), et(bt, Et, yt)), vt.readHexNumber(Et, yt), et(Et, bt, yt), Pt = vt.readNumber(), mt.mapCidRange(st(bt, yt), st(Et, yt), Pt);
                    break;
                  case 4:
                    vt.readHex(St, Rt), vt.readHex(Bt, yt), mt.mapOne(st(St, Rt), lt(Bt, yt));
                    for (let jt = 1; jt < kt; jt++)
                      it(St, Rt), It || (vt.readHexNumber(Ot, Rt), et(St, Ot, Rt)), it(Bt, yt), vt.readHexSigned(Ot, yt), et(Bt, Ot, yt), mt.mapOne(st(St, Rt), lt(Bt, yt));
                    break;
                  case 5:
                    vt.readHex(bt, Rt), vt.readHexNumber(Et, Rt), et(Et, bt, Rt), vt.readHex(Bt, yt), mt.mapBfRange(st(bt, Rt), st(Et, Rt), lt(Bt, yt));
                    for (let jt = 1; jt < kt; jt++)
                      it(Et, Rt), It ? bt.set(Et) : (vt.readHexNumber(bt, Rt), et(bt, Et, Rt)), vt.readHexNumber(Et, Rt), et(Et, bt, Rt), vt.readHex(Bt, yt), mt.mapBfRange(st(bt, Rt), st(Et, Rt), lt(Bt, yt));
                    break;
                  default:
                    throw new Error(`BinaryCMapReader.process - unknown type: ${Ct}`);
                }
              }
              return xt ? ct(xt) : mt;
            }
          }
          at.BinaryCMapReader = dt;
        },
        /* 167 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Parser = at.Linearization = at.Lexer = void 0, ot(140), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(2);
          var rt = ot(145), st = ot(151), lt = ot(150), et = ot(155), it = ot(168), ut = ot(170), ft = ot(171), ht = ot(173), dt = ot(174), gt = ot(177), pt = ot(180), mt = ot(182), ct = ot(183), vt = ot(184);
          const At = 1e3;
          function xt(Pt) {
            const wt = [], Ct = Pt.length;
            let It = 0;
            for (; It < Ct - 1; )
              wt.push(Pt[It++] << 8 | Pt[It++]);
            return It < Ct && wt.push(Pt[It]), Ct + "_" + String.fromCharCode.apply(null, wt);
          }
          class bt {
            constructor(wt) {
              let {
                lexer: Ct,
                xref: It,
                allowStreams: yt = !1,
                recoveryMode: Rt = !1
              } = wt;
              this.lexer = Ct, this.xref = It, this.allowStreams = yt, this.recoveryMode = Rt, this.imageCache = /* @__PURE__ */ Object.create(null), this._imageId = 0, this.refill();
            }
            refill() {
              this.buf1 = this.lexer.getObj(), this.buf2 = this.lexer.getObj();
            }
            shift() {
              this.buf2 instanceof st.Cmd && this.buf2.cmd === "ID" ? (this.buf1 = this.buf2, this.buf2 = null) : (this.buf1 = this.buf2, this.buf2 = this.lexer.getObj());
            }
            tryShift() {
              try {
                return this.shift(), !0;
              } catch (wt) {
                if (wt instanceof lt.MissingDataException)
                  throw wt;
                return !1;
              }
            }
            getObj() {
              let wt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              const Ct = this.buf1;
              if (this.shift(), Ct instanceof st.Cmd)
                switch (Ct.cmd) {
                  case "BI":
                    return this.makeInlineImage(wt);
                  case "[":
                    const It = [];
                    for (; !(0, st.isCmd)(this.buf1, "]") && this.buf1 !== st.EOF; )
                      It.push(this.getObj(wt));
                    if (this.buf1 === st.EOF) {
                      if (this.recoveryMode)
                        return It;
                      throw new lt.ParserEOFException("End of file inside array.");
                    }
                    return this.shift(), It;
                  case "<<":
                    const yt = new st.Dict(this.xref);
                    for (; !(0, st.isCmd)(this.buf1, ">>") && this.buf1 !== st.EOF; ) {
                      if (!(this.buf1 instanceof st.Name)) {
                        (0, rt.info)("Malformed dictionary: key must be a name object"), this.shift();
                        continue;
                      }
                      const Rt = this.buf1.name;
                      if (this.shift(), this.buf1 === st.EOF)
                        break;
                      yt.set(Rt, this.getObj(wt));
                    }
                    if (this.buf1 === st.EOF) {
                      if (this.recoveryMode)
                        return yt;
                      throw new lt.ParserEOFException("End of file inside dictionary.");
                    }
                    return (0, st.isCmd)(this.buf2, "stream") ? this.allowStreams ? this.makeStream(yt, wt) : yt : (this.shift(), yt);
                  default:
                    return Ct;
                }
              if (Number.isInteger(Ct)) {
                if (Number.isInteger(this.buf1) && (0, st.isCmd)(this.buf2, "R")) {
                  const It = st.Ref.get(Ct, this.buf1);
                  return this.shift(), this.shift(), It;
                }
                return Ct;
              }
              return typeof Ct == "string" && wt ? wt.decryptString(Ct) : Ct;
            }
            findDefaultInlineStreamEnd(wt) {
              const {
                knownCommands: Ht
              } = this.lexer, Ft = wt.pos, _t = 15;
              let Nt = 0, Mt, Lt;
              for (; (Mt = wt.getByte()) !== -1; )
                if (Nt === 0)
                  Nt = Mt === 69 ? 1 : 0;
                else if (Nt === 1)
                  Nt = Mt === 73 ? 2 : 0;
                else if (Mt === 32 || Mt === 10 || Mt === 13) {
                  Lt = wt.pos;
                  const Tt = wt.peekBytes(_t), Dt = Tt.length;
                  if (Dt === 0)
                    break;
                  for (let Qt = 0; Qt < Dt; Qt++)
                    if (Mt = Tt[Qt], !(Mt === 0 && Tt[Qt + 1] !== 0) && Mt !== 10 && Mt !== 13 && (Mt < 32 || Mt > 127)) {
                      Nt = 0;
                      break;
                    }
                  if (Nt !== 2)
                    continue;
                  if (!Ht) {
                    (0, rt.warn)("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
                    continue;
                  }
                  const Ut = new Bt(new et.Stream(Tt.slice()), Ht);
                  Ut._hexStringWarn = () => {
                  };
                  let Vt = 0;
                  for (; ; ) {
                    const Qt = Ut.getObj();
                    if (Qt === st.EOF) {
                      Nt = 0;
                      break;
                    }
                    if (Qt instanceof st.Cmd) {
                      const qt = Ht[Qt.cmd];
                      if (qt) {
                        if (qt.variableArgs ? Vt <= qt.numArgs : Vt === qt.numArgs)
                          break;
                      } else {
                        Nt = 0;
                        break;
                      }
                      Vt = 0;
                      continue;
                    }
                    Vt++;
                  }
                  if (Nt === 2)
                    break;
                } else
                  Nt = 0;
              Mt === -1 && ((0, rt.warn)("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker"), Lt && ((0, rt.warn)('... trying to recover by using the last "EI" occurrence.'), wt.skip(-(wt.pos - Lt))));
              let $t = 4;
              return wt.skip(-$t), Mt = wt.peekByte(), wt.skip($t), (0, lt.isWhiteSpace)(Mt) || $t--, wt.pos - $t - Ft;
            }
            findDCTDecodeInlineStreamEnd(wt) {
              const Ct = wt.pos;
              let It = !1, yt, Rt;
              for (; (yt = wt.getByte()) !== -1; )
                if (yt === 255) {
                  switch (wt.getByte()) {
                    case 0:
                      break;
                    case 255:
                      wt.skip(-1);
                      break;
                    case 217:
                      It = !0;
                      break;
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 197:
                    case 198:
                    case 199:
                    case 201:
                    case 202:
                    case 203:
                    case 205:
                    case 206:
                    case 207:
                    case 196:
                    case 204:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 224:
                    case 225:
                    case 226:
                    case 227:
                    case 228:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 239:
                    case 254:
                      Rt = wt.getUint16(), Rt > 2 ? wt.skip(Rt - 2) : wt.skip(-2);
                      break;
                  }
                  if (It)
                    break;
                }
              const kt = wt.pos - Ct;
              return yt === -1 ? ((0, rt.warn)("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead."), wt.skip(-kt), this.findDefaultInlineStreamEnd(wt)) : (this.inlineStreamSkipEI(wt), kt);
            }
            findASCII85DecodeInlineStreamEnd(wt) {
              const yt = wt.pos;
              let Rt;
              for (; (Rt = wt.getByte()) !== -1; )
                if (Rt === 126) {
                  const jt = wt.pos;
                  for (Rt = wt.peekByte(); (0, lt.isWhiteSpace)(Rt); )
                    wt.skip(), Rt = wt.peekByte();
                  if (Rt === 62) {
                    wt.skip();
                    break;
                  }
                  if (wt.pos > jt) {
                    const Ht = wt.peekBytes(2);
                    if (Ht[0] === 69 && Ht[1] === 73)
                      break;
                  }
                }
              const kt = wt.pos - yt;
              return Rt === -1 ? ((0, rt.warn)("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead."), wt.skip(-kt), this.findDefaultInlineStreamEnd(wt)) : (this.inlineStreamSkipEI(wt), kt);
            }
            findASCIIHexDecodeInlineStreamEnd(wt) {
              const It = wt.pos;
              let yt;
              for (; (yt = wt.getByte()) !== -1 && yt !== 62; )
                ;
              const Rt = wt.pos - It;
              return yt === -1 ? ((0, rt.warn)("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead."), wt.skip(-Rt), this.findDefaultInlineStreamEnd(wt)) : (this.inlineStreamSkipEI(wt), Rt);
            }
            inlineStreamSkipEI(wt) {
              let yt = 0, Rt;
              for (; (Rt = wt.getByte()) !== -1; )
                if (yt === 0)
                  yt = Rt === 69 ? 1 : 0;
                else if (yt === 1)
                  yt = Rt === 73 ? 2 : 0;
                else if (yt === 2)
                  break;
            }
            makeInlineImage(wt) {
              const Ct = this.lexer, It = Ct.stream, yt = /* @__PURE__ */ Object.create(null);
              let Rt;
              for (; !(0, st.isCmd)(this.buf1, "ID") && this.buf1 !== st.EOF; ) {
                if (!(this.buf1 instanceof st.Name))
                  throw new rt.FormatError("Dictionary key must be a name object");
                const Lt = this.buf1.name;
                if (this.shift(), this.buf1 === st.EOF)
                  break;
                yt[Lt] = this.getObj(wt);
              }
              Ct.beginInlineImagePos !== -1 && (Rt = It.pos - Ct.beginInlineImagePos);
              const kt = this.xref.fetchIfRef(yt.F || yt.Filter);
              let jt;
              if (kt instanceof st.Name)
                jt = kt.name;
              else if (Array.isArray(kt)) {
                const Lt = this.xref.fetchIfRef(kt[0]);
                Lt instanceof st.Name && (jt = Lt.name);
              }
              const Ht = It.pos;
              let Ft;
              switch (jt) {
                case "DCT":
                case "DCTDecode":
                  Ft = this.findDCTDecodeInlineStreamEnd(It);
                  break;
                case "A85":
                case "ASCII85Decode":
                  Ft = this.findASCII85DecodeInlineStreamEnd(It);
                  break;
                case "AHx":
                case "ASCIIHexDecode":
                  Ft = this.findASCIIHexDecodeInlineStreamEnd(It);
                  break;
                default:
                  Ft = this.findDefaultInlineStreamEnd(It);
              }
              let _t;
              if (Ft < At && Rt > 0) {
                const Lt = It.pos;
                It.pos = Ct.beginInlineImagePos, _t = xt(It.getBytes(Rt + Ft)), It.pos = Lt;
                const $t = this.imageCache[_t];
                if ($t !== void 0)
                  return this.buf2 = st.Cmd.get("EI"), this.shift(), $t.reset(), $t;
              }
              const Nt = new st.Dict(this.xref);
              for (const Lt in yt)
                Nt.set(Lt, yt[Lt]);
              let Mt = It.makeSubStream(Ht, Ft, Nt);
              return wt && (Mt = wt.createStream(Mt, Ft)), Mt = this.filter(Mt, Nt, Ft), Mt.dict = Nt, _t !== void 0 && (Mt.cacheKey = `inline_img_${++this._imageId}`, this.imageCache[_t] = Mt), this.buf2 = st.Cmd.get("EI"), this.shift(), Mt;
            }
            _findStreamLength(wt, Ct) {
              const {
                stream: It
              } = this.lexer;
              It.pos = wt;
              const yt = 2048, Rt = Ct.length;
              for (; It.pos < It.end; ) {
                const kt = It.peekBytes(yt), jt = kt.length - Rt;
                if (jt <= 0)
                  break;
                let Ht = 0;
                for (; Ht < jt; ) {
                  let Ft = 0;
                  for (; Ft < Rt && kt[Ht + Ft] === Ct[Ft]; )
                    Ft++;
                  if (Ft >= Rt)
                    return It.pos += Ht, It.pos - wt;
                  Ht++;
                }
                It.pos += jt;
              }
              return -1;
            }
            makeStream(wt, Ct) {
              const It = this.lexer;
              let yt = It.stream;
              It.skipToNextLine();
              const Rt = yt.pos - 1;
              let kt = wt.get("Length");
              if (Number.isInteger(kt) || ((0, rt.info)(`Bad length "${kt && kt.toString()}" in stream.`), kt = 0), yt.pos = Rt + kt, It.nextChar(), this.tryShift() && (0, st.isCmd)(this.buf2, "endstream"))
                this.shift();
              else {
                const jt = new Uint8Array([101, 110, 100, 115, 116, 114, 101, 97, 109]);
                let Ht = this._findStreamLength(Rt, jt);
                if (Ht < 0) {
                  for (let _t = 1; _t <= 1; _t++) {
                    const Nt = jt.length - _t, Mt = jt.slice(0, Nt), Lt = this._findStreamLength(Rt, Mt);
                    if (Lt >= 0) {
                      const $t = yt.peekBytes(Nt + 1)[Nt];
                      if (!(0, lt.isWhiteSpace)($t))
                        break;
                      (0, rt.info)(`Found "${(0, rt.bytesToString)(Mt)}" when searching for endstream command.`), Ht = Lt;
                      break;
                    }
                  }
                  if (Ht < 0)
                    throw new rt.FormatError("Missing endstream command.");
                }
                kt = Ht, It.nextChar(), this.shift(), this.shift();
              }
              return this.shift(), yt = yt.makeSubStream(Rt, kt, wt), Ct && (yt = Ct.createStream(yt, kt)), yt = this.filter(yt, wt, kt), yt.dict = wt, yt;
            }
            filter(wt, Ct, It) {
              let yt = Ct.get("F", "Filter"), Rt = Ct.get("DP", "DecodeParms");
              if (yt instanceof st.Name)
                return Array.isArray(Rt) && (0, rt.warn)("/DecodeParms should not be an Array, when /Filter is a Name."), this.makeFilter(wt, yt.name, It, Rt);
              let kt = It;
              if (Array.isArray(yt)) {
                const jt = yt, Ht = Rt;
                for (let Ft = 0, _t = jt.length; Ft < _t; ++Ft) {
                  if (yt = this.xref.fetchIfRef(jt[Ft]), !(yt instanceof st.Name))
                    throw new rt.FormatError(`Bad filter name "${yt}"`);
                  Rt = null, Array.isArray(Ht) && Ft in Ht && (Rt = this.xref.fetchIfRef(Ht[Ft])), wt = this.makeFilter(wt, yt.name, kt, Rt), kt = null;
                }
              }
              return wt;
            }
            makeFilter(wt, Ct, It, yt) {
              if (It === 0)
                return (0, rt.warn)(`Empty "${Ct}" stream.`), new et.NullStream();
              try {
                switch (Ct) {
                  case "Fl":
                  case "FlateDecode":
                    return yt ? new ct.PredictorStream(new ht.FlateStream(wt, It), It, yt) : new ht.FlateStream(wt, It);
                  case "LZW":
                  case "LZWDecode":
                    let Rt = 1;
                    return yt ? (yt.has("EarlyChange") && (Rt = yt.get("EarlyChange")), new ct.PredictorStream(new mt.LZWStream(wt, It, Rt), It, yt)) : new mt.LZWStream(wt, It, Rt);
                  case "DCT":
                  case "DCTDecode":
                    return new gt.JpegStream(wt, It, yt);
                  case "JPX":
                  case "JPXDecode":
                    return new pt.JpxStream(wt, It, yt);
                  case "A85":
                  case "ASCII85Decode":
                    return new it.Ascii85Stream(wt, It);
                  case "AHx":
                  case "ASCIIHexDecode":
                    return new ut.AsciiHexStream(wt, It);
                  case "CCF":
                  case "CCITTFaxDecode":
                    return new ft.CCITTFaxStream(wt, It, yt);
                  case "RL":
                  case "RunLengthDecode":
                    return new vt.RunLengthStream(wt, It);
                  case "JBIG2Decode":
                    return new dt.Jbig2Stream(wt, It, yt);
                }
                return (0, rt.warn)(`Filter "${Ct}" is not supported.`), wt;
              } catch (Rt) {
                if (Rt instanceof lt.MissingDataException)
                  throw Rt;
                return (0, rt.warn)(`Invalid stream: "${Rt}"`), new et.NullStream();
              }
            }
          }
          at.Parser = bt;
          const Et = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          function St(Pt) {
            return Pt >= 48 && Pt <= 57 ? Pt & 15 : Pt >= 65 && Pt <= 70 || Pt >= 97 && Pt <= 102 ? (Pt & 15) + 9 : -1;
          }
          class Bt {
            constructor(wt) {
              let Ct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              this.stream = wt, this.nextChar(), this.strBuf = [], this.knownCommands = Ct, this._hexStringNumWarn = 0, this.beginInlineImagePos = -1;
            }
            nextChar() {
              return this.currentChar = this.stream.getByte();
            }
            peekChar() {
              return this.stream.peekByte();
            }
            getNumber() {
              let wt = this.currentChar, Ct = !1, It = 0, yt = 1;
              if (wt === 45 ? (yt = -1, wt = this.nextChar(), wt === 45 && (wt = this.nextChar())) : wt === 43 && (wt = this.nextChar()), wt === 10 || wt === 13)
                do
                  wt = this.nextChar();
                while (wt === 10 || wt === 13);
              if (wt === 46 && (It = 10, wt = this.nextChar()), wt < 48 || wt > 57) {
                const Ht = `Invalid number: ${String.fromCharCode(wt)} (charCode ${wt})`;
                if ((0, lt.isWhiteSpace)(wt) || wt === -1)
                  return (0, rt.info)(`Lexer.getNumber - "${Ht}".`), 0;
                throw new rt.FormatError(Ht);
              }
              let Rt = wt - 48, kt = 0, jt = 1;
              for (; (wt = this.nextChar()) >= 0; )
                if (wt >= 48 && wt <= 57) {
                  const Ht = wt - 48;
                  Ct ? kt = kt * 10 + Ht : (It !== 0 && (It *= 10), Rt = Rt * 10 + Ht);
                } else if (wt === 46)
                  if (It === 0)
                    It = 1;
                  else
                    break;
                else if (wt === 45)
                  (0, rt.warn)("Badly formatted number: minus sign in the middle");
                else if (wt === 69 || wt === 101) {
                  if (wt = this.peekChar(), wt === 43 || wt === 45)
                    jt = wt === 45 ? -1 : 1, this.nextChar();
                  else if (wt < 48 || wt > 57)
                    break;
                  Ct = !0;
                } else
                  break;
              return It !== 0 && (Rt /= It), Ct && (Rt *= 10 ** (jt * kt)), yt * Rt;
            }
            getString() {
              let wt = 1, Ct = !1;
              const It = this.strBuf;
              It.length = 0;
              let yt = this.nextChar();
              for (; ; ) {
                let Rt = !1;
                switch (yt | 0) {
                  case -1:
                    (0, rt.warn)("Unterminated string"), Ct = !0;
                    break;
                  case 40:
                    ++wt, It.push("(");
                    break;
                  case 41:
                    --wt === 0 ? (this.nextChar(), Ct = !0) : It.push(")");
                    break;
                  case 92:
                    switch (yt = this.nextChar(), yt) {
                      case -1:
                        (0, rt.warn)("Unterminated string"), Ct = !0;
                        break;
                      case 110:
                        It.push(`
`);
                        break;
                      case 114:
                        It.push("\r");
                        break;
                      case 116:
                        It.push("	");
                        break;
                      case 98:
                        It.push("\b");
                        break;
                      case 102:
                        It.push("\f");
                        break;
                      case 92:
                      case 40:
                      case 41:
                        It.push(String.fromCharCode(yt));
                        break;
                      case 48:
                      case 49:
                      case 50:
                      case 51:
                      case 52:
                      case 53:
                      case 54:
                      case 55:
                        let kt = yt & 15;
                        yt = this.nextChar(), Rt = !0, yt >= 48 && yt <= 55 && (kt = (kt << 3) + (yt & 15), yt = this.nextChar(), yt >= 48 && yt <= 55 && (Rt = !1, kt = (kt << 3) + (yt & 15))), It.push(String.fromCharCode(kt));
                        break;
                      case 13:
                        this.peekChar() === 10 && this.nextChar();
                        break;
                      case 10:
                        break;
                      default:
                        It.push(String.fromCharCode(yt));
                        break;
                    }
                    break;
                  default:
                    It.push(String.fromCharCode(yt));
                    break;
                }
                if (Ct)
                  break;
                Rt || (yt = this.nextChar());
              }
              return It.join("");
            }
            getName() {
              let wt, Ct;
              const It = this.strBuf;
              for (It.length = 0; (wt = this.nextChar()) >= 0 && !Et[wt]; )
                if (wt === 35) {
                  if (wt = this.nextChar(), Et[wt]) {
                    (0, rt.warn)("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number."), It.push("#");
                    break;
                  }
                  const yt = St(wt);
                  if (yt !== -1) {
                    Ct = wt, wt = this.nextChar();
                    const Rt = St(wt);
                    if (Rt === -1) {
                      if ((0, rt.warn)(`Lexer_getName: Illegal digit (${String.fromCharCode(wt)}) in hexadecimal number.`), It.push("#", String.fromCharCode(Ct)), Et[wt])
                        break;
                      It.push(String.fromCharCode(wt));
                      continue;
                    }
                    It.push(String.fromCharCode(yt << 4 | Rt));
                  } else
                    It.push("#", String.fromCharCode(wt));
                } else
                  It.push(String.fromCharCode(wt));
              return It.length > 127 && (0, rt.warn)(`Name token is longer than allowed by the spec: ${It.length}`), st.Name.get(It.join(""));
            }
            _hexStringWarn(wt) {
              if (this._hexStringNumWarn++ === 5) {
                (0, rt.warn)("getHexString - ignoring additional invalid characters.");
                return;
              }
              this._hexStringNumWarn > 5 || (0, rt.warn)(`getHexString - ignoring invalid character: ${wt}`);
            }
            getHexString() {
              const wt = this.strBuf;
              wt.length = 0;
              let Ct = this.currentChar, It = !0, yt, Rt;
              for (this._hexStringNumWarn = 0; ; )
                if (Ct < 0) {
                  (0, rt.warn)("Unterminated hex string");
                  break;
                } else if (Ct === 62) {
                  this.nextChar();
                  break;
                } else if (Et[Ct] === 1) {
                  Ct = this.nextChar();
                  continue;
                } else {
                  if (It) {
                    if (yt = St(Ct), yt === -1) {
                      this._hexStringWarn(Ct), Ct = this.nextChar();
                      continue;
                    }
                  } else {
                    if (Rt = St(Ct), Rt === -1) {
                      this._hexStringWarn(Ct), Ct = this.nextChar();
                      continue;
                    }
                    wt.push(String.fromCharCode(yt << 4 | Rt));
                  }
                  It = !It, Ct = this.nextChar();
                }
              return wt.join("");
            }
            getObj() {
              let wt = !1, Ct = this.currentChar;
              for (; ; ) {
                if (Ct < 0)
                  return st.EOF;
                if (wt)
                  (Ct === 10 || Ct === 13) && (wt = !1);
                else if (Ct === 37)
                  wt = !0;
                else if (Et[Ct] !== 1)
                  break;
                Ct = this.nextChar();
              }
              switch (Ct | 0) {
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 43:
                case 45:
                case 46:
                  return this.getNumber();
                case 40:
                  return this.getString();
                case 47:
                  return this.getName();
                case 91:
                  return this.nextChar(), st.Cmd.get("[");
                case 93:
                  return this.nextChar(), st.Cmd.get("]");
                case 60:
                  return Ct = this.nextChar(), Ct === 60 ? (this.nextChar(), st.Cmd.get("<<")) : this.getHexString();
                case 62:
                  return Ct = this.nextChar(), Ct === 62 ? (this.nextChar(), st.Cmd.get(">>")) : st.Cmd.get(">");
                case 123:
                  return this.nextChar(), st.Cmd.get("{");
                case 125:
                  return this.nextChar(), st.Cmd.get("}");
                case 41:
                  throw this.nextChar(), new rt.FormatError(`Illegal character: ${Ct}`);
              }
              let It = String.fromCharCode(Ct);
              if (Ct < 32 || Ct > 127) {
                const kt = this.peekChar();
                if (kt >= 32 && kt <= 127)
                  return this.nextChar(), st.Cmd.get(It);
              }
              const yt = this.knownCommands;
              let Rt = (yt == null ? void 0 : yt[It]) !== void 0;
              for (; (Ct = this.nextChar()) >= 0 && !Et[Ct]; ) {
                const kt = It + String.fromCharCode(Ct);
                if (Rt && yt[kt] === void 0)
                  break;
                if (It.length === 128)
                  throw new rt.FormatError(`Command token too long: ${It.length}`);
                It = kt, Rt = (yt == null ? void 0 : yt[It]) !== void 0;
              }
              return It === "true" ? !0 : It === "false" ? !1 : It === "null" ? null : (It === "BI" && (this.beginInlineImagePos = this.stream.pos), st.Cmd.get(It));
            }
            skipToNextLine() {
              let wt = this.currentChar;
              for (; wt >= 0; ) {
                if (wt === 13) {
                  wt = this.nextChar(), wt === 10 && this.nextChar();
                  break;
                } else if (wt === 10) {
                  this.nextChar();
                  break;
                }
                wt = this.nextChar();
              }
            }
          }
          at.Lexer = Bt;
          class Ot {
            static create(wt) {
              function Ct(Nt, Mt) {
                let Lt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                const $t = Nt.get(Mt);
                if (Number.isInteger($t) && (Lt ? $t >= 0 : $t > 0))
                  return $t;
                throw new Error(`The "${Mt}" parameter in the linearization dictionary is invalid.`);
              }
              function It(Nt) {
                const Mt = Nt.get("H");
                let Lt;
                if (Array.isArray(Mt) && ((Lt = Mt.length) === 2 || Lt === 4)) {
                  for (let $t = 0; $t < Lt; $t++) {
                    const Tt = Mt[$t];
                    if (!(Number.isInteger(Tt) && Tt > 0))
                      throw new Error(`Hint (${$t}) in the linearization dictionary is invalid.`);
                  }
                  return Mt;
                }
                throw new Error("Hint array in the linearization dictionary is invalid.");
              }
              const yt = new bt({
                lexer: new Bt(wt),
                xref: null
              }), Rt = yt.getObj(), kt = yt.getObj(), jt = yt.getObj(), Ht = yt.getObj();
              let Ft, _t;
              if (Number.isInteger(Rt) && Number.isInteger(kt) && (0, st.isCmd)(jt, "obj") && Ht instanceof st.Dict && typeof (Ft = Ht.get("Linearized")) == "number" && Ft > 0) {
                if ((_t = Ct(Ht, "L")) !== wt.length)
                  throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
              } else
                return null;
              return {
                length: _t,
                hints: It(Ht),
                objectNumberFirst: Ct(Ht, "O"),
                endFirst: Ct(Ht, "E"),
                numPages: Ct(Ht, "N"),
                mainXRefEntriesOffset: Ct(Ht, "T"),
                pageFirst: Ht.has("P") ? Ct(Ht, "P", !0) : 0
              };
            }
          }
          at.Linearization = Ot;
        },
        /* 168 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Ascii85Stream = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(169), st = ot(150);
          class lt extends rt.DecodeStream {
            constructor(it, ut) {
              ut && (ut *= 0.8), super(ut), this.str = it, this.dict = it.dict, this.input = new Uint8Array(5);
            }
            readBlock() {
              const ht = this.str;
              let dt = ht.getByte();
              for (; (0, st.isWhiteSpace)(dt); )
                dt = ht.getByte();
              if (dt === -1 || dt === 126) {
                this.eof = !0;
                return;
              }
              const gt = this.bufferLength;
              let pt, mt;
              if (dt === 122) {
                for (pt = this.ensureBuffer(gt + 4), mt = 0; mt < 4; ++mt)
                  pt[gt + mt] = 0;
                this.bufferLength += 4;
              } else {
                const ct = this.input;
                for (ct[0] = dt, mt = 1; mt < 5; ++mt) {
                  for (dt = ht.getByte(); (0, st.isWhiteSpace)(dt); )
                    dt = ht.getByte();
                  if (ct[mt] = dt, dt === -1 || dt === 126)
                    break;
                }
                if (pt = this.ensureBuffer(gt + mt - 1), this.bufferLength += mt - 1, mt < 5) {
                  for (; mt < 5; ++mt)
                    ct[mt] = 117;
                  this.eof = !0;
                }
                let vt = 0;
                for (mt = 0; mt < 5; ++mt)
                  vt = vt * 85 + (ct[mt] - 33);
                for (mt = 3; mt >= 0; --mt)
                  pt[gt + mt] = vt & 255, vt >>= 8;
              }
            }
          }
          at.Ascii85Stream = lt;
        },
        /* 169 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.StreamsSequenceStream = at.DecodeStream = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(140);
          var rt = ot(152), st = ot(155);
          const lt = new Uint8Array(0);
          class et extends rt.BaseStream {
            constructor(ft) {
              if (super(), this._rawMinBufferLength = ft || 0, this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = lt, this.minBufferLength = 512, ft)
                for (; this.minBufferLength < ft; )
                  this.minBufferLength *= 2;
            }
            get isEmpty() {
              for (; !this.eof && this.bufferLength === 0; )
                this.readBlock();
              return this.bufferLength === 0;
            }
            ensureBuffer(ft) {
              const ht = this.buffer;
              if (ft <= ht.byteLength)
                return ht;
              let dt = this.minBufferLength;
              for (; dt < ft; )
                dt *= 2;
              const gt = new Uint8Array(dt);
              return gt.set(ht), this.buffer = gt;
            }
            getByte() {
              const ft = this.pos;
              for (; this.bufferLength <= ft; ) {
                if (this.eof)
                  return -1;
                this.readBlock();
              }
              return this.buffer[this.pos++];
            }
            getBytes(ft) {
              const ht = this.pos;
              let dt;
              if (ft) {
                for (this.ensureBuffer(ht + ft), dt = ht + ft; !this.eof && this.bufferLength < dt; )
                  this.readBlock();
                const gt = this.bufferLength;
                dt > gt && (dt = gt);
              } else {
                for (; !this.eof; )
                  this.readBlock();
                dt = this.bufferLength;
              }
              return this.pos = dt, this.buffer.subarray(ht, dt);
            }
            reset() {
              this.pos = 0;
            }
            makeSubStream(ft, ht) {
              let dt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
              if (ht === void 0)
                for (; !this.eof; )
                  this.readBlock();
              else {
                const gt = ft + ht;
                for (; this.bufferLength <= gt && !this.eof; )
                  this.readBlock();
              }
              return new st.Stream(this.buffer, ft, ht, dt);
            }
            getBaseStreams() {
              return this.str ? this.str.getBaseStreams() : null;
            }
          }
          at.DecodeStream = et;
          class it extends et {
            constructor(ft) {
              let ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, dt = 0;
              for (const gt of ft)
                dt += gt instanceof et ? gt._rawMinBufferLength : gt.length;
              super(dt), this.streams = ft, this._onError = ht;
            }
            readBlock() {
              var ct;
              const ft = this.streams;
              if (ft.length === 0) {
                this.eof = !0;
                return;
              }
              const ht = ft.shift();
              let dt;
              try {
                dt = ht.getBytes();
              } catch (vt) {
                if (this._onError) {
                  this._onError(vt, (ct = ht.dict) == null ? void 0 : ct.objId);
                  return;
                }
                throw vt;
              }
              const gt = this.bufferLength, pt = gt + dt.length;
              this.ensureBuffer(pt).set(dt, gt), this.bufferLength = pt;
            }
            getBaseStreams() {
              const ft = [];
              for (const ht of this.streams) {
                const dt = ht.getBaseStreams();
                dt && ft.push(...dt);
              }
              return ft.length > 0 ? ft : null;
            }
          }
          at.StreamsSequenceStream = it;
        },
        /* 170 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.AsciiHexStream = void 0;
          var rt = ot(169);
          class st extends rt.DecodeStream {
            constructor(et, it) {
              it && (it *= 0.5), super(it), this.str = et, this.dict = et.dict, this.firstDigit = -1;
            }
            readBlock() {
              const it = this.str.getBytes(8e3);
              if (!it.length) {
                this.eof = !0;
                return;
              }
              const ut = it.length + 1 >> 1, ft = this.ensureBuffer(this.bufferLength + ut);
              let ht = this.bufferLength, dt = this.firstDigit;
              for (const gt of it) {
                let pt;
                if (gt >= 48 && gt <= 57)
                  pt = gt & 15;
                else if (gt >= 65 && gt <= 70 || gt >= 97 && gt <= 102)
                  pt = (gt & 15) + 9;
                else if (gt === 62) {
                  this.eof = !0;
                  break;
                } else
                  continue;
                dt < 0 ? dt = pt : (ft[ht++] = dt << 4 | pt, dt = -1);
              }
              dt >= 0 && this.eof && (ft[ht++] = dt << 4, dt = -1), this.firstDigit = dt, this.bufferLength = ht;
            }
          }
          at.AsciiHexStream = st;
        },
        /* 171 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.CCITTFaxStream = void 0;
          var rt = ot(172), st = ot(169), lt = ot(151);
          class et extends st.DecodeStream {
            constructor(ut, ft, ht) {
              super(ft), this.str = ut, this.dict = ut.dict, ht instanceof lt.Dict || (ht = lt.Dict.empty);
              const dt = {
                next() {
                  return ut.getByte();
                }
              };
              this.ccittFaxDecoder = new rt.CCITTFaxDecoder(dt, {
                K: ht.get("K"),
                EndOfLine: ht.get("EndOfLine"),
                EncodedByteAlign: ht.get("EncodedByteAlign"),
                Columns: ht.get("Columns"),
                Rows: ht.get("Rows"),
                EndOfBlock: ht.get("EndOfBlock"),
                BlackIs1: ht.get("BlackIs1")
              });
            }
            readBlock() {
              for (; !this.eof; ) {
                const ut = this.ccittFaxDecoder.readNextChar();
                if (ut === -1) {
                  this.eof = !0;
                  return;
                }
                this.ensureBuffer(this.bufferLength + 1), this.buffer[this.bufferLength++] = ut;
              }
            }
          }
          at.CCITTFaxStream = et;
        },
        /* 172 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.CCITTFaxDecoder = void 0, ot(2), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(145);
          const st = -2, lt = -1, et = 0, it = 1, ut = 2, ft = 3, ht = 4, dt = 5, gt = 6, pt = 7, mt = 8, ct = [[-1, -1], [-1, -1], [7, mt], [7, pt], [6, gt], [6, gt], [6, dt], [6, dt], [4, et], [4, et], [4, et], [4, et], [4, et], [4, et], [4, et], [4, et], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, it], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ht], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [3, ft], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut], [1, ut]], vt = [[-1, -1], [12, st], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]], At = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]], xt = [[-1, -1], [-1, -1], [12, st], [12, st], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]], bt = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]], Et = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
          class St {
            constructor(Ot) {
              let Pt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              if (!Ot || typeof Ot.next != "function")
                throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
              this.source = Ot, this.eof = !1, this.encoding = Pt.K || 0, this.eoline = Pt.EndOfLine || !1, this.byteAlign = Pt.EncodedByteAlign || !1, this.columns = Pt.Columns || 1728, this.rows = Pt.Rows || 0, this.eoblock = Pt.EndOfBlock ?? !0, this.black = Pt.BlackIs1 || !1, this.codingLine = new Uint32Array(this.columns + 1), this.refLine = new Uint32Array(this.columns + 2), this.codingLine[0] = this.columns, this.codingPos = 0, this.row = 0, this.nextLine2D = this.encoding < 0, this.inputBits = 0, this.inputBuf = 0, this.outputBits = 0, this.rowsDone = !1;
              let wt;
              for (; (wt = this._lookBits(12)) === 0; )
                this._eatBits(1);
              wt === 1 && this._eatBits(12), this.encoding > 0 && (this.nextLine2D = !this._lookBits(1), this._eatBits(1));
            }
            readNextChar() {
              if (this.eof)
                return -1;
              const Ot = this.refLine, Pt = this.codingLine, wt = this.columns;
              let Ct, It, yt, Rt;
              if (this.outputBits === 0) {
                if (this.rowsDone && (this.eof = !0), this.eof)
                  return -1;
                this.err = !1;
                let jt, Ht, Ft;
                if (this.nextLine2D) {
                  for (Rt = 0; Pt[Rt] < wt; ++Rt)
                    Ot[Rt] = Pt[Rt];
                  for (Ot[Rt++] = wt, Ot[Rt] = wt, Pt[0] = 0, this.codingPos = 0, Ct = 0, It = 0; Pt[this.codingPos] < wt; )
                    switch (jt = this._getTwoDimCode(), jt) {
                      case et:
                        this._addPixels(Ot[Ct + 1], It), Ot[Ct + 1] < wt && (Ct += 2);
                        break;
                      case it:
                        if (jt = Ht = 0, It) {
                          do
                            jt += Ft = this._getBlackCode();
                          while (Ft >= 64);
                          do
                            Ht += Ft = this._getWhiteCode();
                          while (Ft >= 64);
                        } else {
                          do
                            jt += Ft = this._getWhiteCode();
                          while (Ft >= 64);
                          do
                            Ht += Ft = this._getBlackCode();
                          while (Ft >= 64);
                        }
                        for (this._addPixels(Pt[this.codingPos] + jt, It), Pt[this.codingPos] < wt && this._addPixels(Pt[this.codingPos] + Ht, It ^ 1); Ot[Ct] <= Pt[this.codingPos] && Ot[Ct] < wt; )
                          Ct += 2;
                        break;
                      case pt:
                        if (this._addPixels(Ot[Ct] + 3, It), It ^= 1, Pt[this.codingPos] < wt)
                          for (++Ct; Ot[Ct] <= Pt[this.codingPos] && Ot[Ct] < wt; )
                            Ct += 2;
                        break;
                      case dt:
                        if (this._addPixels(Ot[Ct] + 2, It), It ^= 1, Pt[this.codingPos] < wt)
                          for (++Ct; Ot[Ct] <= Pt[this.codingPos] && Ot[Ct] < wt; )
                            Ct += 2;
                        break;
                      case ft:
                        if (this._addPixels(Ot[Ct] + 1, It), It ^= 1, Pt[this.codingPos] < wt)
                          for (++Ct; Ot[Ct] <= Pt[this.codingPos] && Ot[Ct] < wt; )
                            Ct += 2;
                        break;
                      case ut:
                        if (this._addPixels(Ot[Ct], It), It ^= 1, Pt[this.codingPos] < wt)
                          for (++Ct; Ot[Ct] <= Pt[this.codingPos] && Ot[Ct] < wt; )
                            Ct += 2;
                        break;
                      case mt:
                        if (this._addPixelsNeg(Ot[Ct] - 3, It), It ^= 1, Pt[this.codingPos] < wt)
                          for (Ct > 0 ? --Ct : ++Ct; Ot[Ct] <= Pt[this.codingPos] && Ot[Ct] < wt; )
                            Ct += 2;
                        break;
                      case gt:
                        if (this._addPixelsNeg(Ot[Ct] - 2, It), It ^= 1, Pt[this.codingPos] < wt)
                          for (Ct > 0 ? --Ct : ++Ct; Ot[Ct] <= Pt[this.codingPos] && Ot[Ct] < wt; )
                            Ct += 2;
                        break;
                      case ht:
                        if (this._addPixelsNeg(Ot[Ct] - 1, It), It ^= 1, Pt[this.codingPos] < wt)
                          for (Ct > 0 ? --Ct : ++Ct; Ot[Ct] <= Pt[this.codingPos] && Ot[Ct] < wt; )
                            Ct += 2;
                        break;
                      case lt:
                        this._addPixels(wt, 0), this.eof = !0;
                        break;
                      default:
                        (0, rt.info)("bad 2d code"), this._addPixels(wt, 0), this.err = !0;
                    }
                } else
                  for (Pt[0] = 0, this.codingPos = 0, It = 0; Pt[this.codingPos] < wt; ) {
                    if (jt = 0, It)
                      do
                        jt += Ft = this._getBlackCode();
                      while (Ft >= 64);
                    else
                      do
                        jt += Ft = this._getWhiteCode();
                      while (Ft >= 64);
                    this._addPixels(Pt[this.codingPos] + jt, It), It ^= 1;
                  }
                let _t = !1;
                if (this.byteAlign && (this.inputBits &= -8), !this.eoblock && this.row === this.rows - 1)
                  this.rowsDone = !0;
                else {
                  if (jt = this._lookBits(12), this.eoline)
                    for (; jt !== lt && jt !== 1; )
                      this._eatBits(1), jt = this._lookBits(12);
                  else
                    for (; jt === 0; )
                      this._eatBits(1), jt = this._lookBits(12);
                  jt === 1 ? (this._eatBits(12), _t = !0) : jt === lt && (this.eof = !0);
                }
                if (!this.eof && this.encoding > 0 && !this.rowsDone && (this.nextLine2D = !this._lookBits(1), this._eatBits(1)), this.eoblock && _t && this.byteAlign) {
                  if (jt = this._lookBits(12), jt === 1) {
                    if (this._eatBits(12), this.encoding > 0 && (this._lookBits(1), this._eatBits(1)), this.encoding >= 0)
                      for (Rt = 0; Rt < 4; ++Rt)
                        jt = this._lookBits(12), jt !== 1 && (0, rt.info)("bad rtc code: " + jt), this._eatBits(12), this.encoding > 0 && (this._lookBits(1), this._eatBits(1));
                    this.eof = !0;
                  }
                } else if (this.err && this.eoline) {
                  for (; ; ) {
                    if (jt = this._lookBits(13), jt === lt)
                      return this.eof = !0, -1;
                    if (jt >> 1 === 1)
                      break;
                    this._eatBits(1);
                  }
                  this._eatBits(12), this.encoding > 0 && (this._eatBits(1), this.nextLine2D = !(jt & 1));
                }
                this.outputBits = Pt[0] > 0 ? Pt[this.codingPos = 0] : Pt[this.codingPos = 1], this.row++;
              }
              let kt;
              if (this.outputBits >= 8)
                kt = this.codingPos & 1 ? 0 : 255, this.outputBits -= 8, this.outputBits === 0 && Pt[this.codingPos] < wt && (this.codingPos++, this.outputBits = Pt[this.codingPos] - Pt[this.codingPos - 1]);
              else {
                yt = 8, kt = 0;
                do {
                  if (typeof this.outputBits != "number")
                    throw new rt.FormatError('Invalid /CCITTFaxDecode data, "outputBits" must be a number.');
                  this.outputBits > yt ? (kt <<= yt, this.codingPos & 1 || (kt |= 255 >> 8 - yt), this.outputBits -= yt, yt = 0) : (kt <<= this.outputBits, this.codingPos & 1 || (kt |= 255 >> 8 - this.outputBits), yt -= this.outputBits, this.outputBits = 0, Pt[this.codingPos] < wt ? (this.codingPos++, this.outputBits = Pt[this.codingPos] - Pt[this.codingPos - 1]) : yt > 0 && (kt <<= yt, yt = 0));
                } while (yt);
              }
              return this.black && (kt ^= 255), kt;
            }
            _addPixels(Ot, Pt) {
              const wt = this.codingLine;
              let Ct = this.codingPos;
              Ot > wt[Ct] && (Ot > this.columns && ((0, rt.info)("row is wrong length"), this.err = !0, Ot = this.columns), Ct & 1 ^ Pt && ++Ct, wt[Ct] = Ot), this.codingPos = Ct;
            }
            _addPixelsNeg(Ot, Pt) {
              const wt = this.codingLine;
              let Ct = this.codingPos;
              if (Ot > wt[Ct])
                Ot > this.columns && ((0, rt.info)("row is wrong length"), this.err = !0, Ot = this.columns), Ct & 1 ^ Pt && ++Ct, wt[Ct] = Ot;
              else if (Ot < wt[Ct]) {
                for (Ot < 0 && ((0, rt.info)("invalid code"), this.err = !0, Ot = 0); Ct > 0 && Ot < wt[Ct - 1]; )
                  --Ct;
                wt[Ct] = Ot;
              }
              this.codingPos = Ct;
            }
            _findTableCode(Ot, Pt, wt, Ct) {
              const It = Ct || 0;
              for (let yt = Ot; yt <= Pt; ++yt) {
                let Rt = this._lookBits(yt);
                if (Rt === lt)
                  return [!0, 1, !1];
                if (yt < Pt && (Rt <<= Pt - yt), !It || Rt >= It) {
                  const kt = wt[Rt - It];
                  if (kt[0] === yt)
                    return this._eatBits(yt), [!0, kt[1], !0];
                }
              }
              return [!1, 0, !1];
            }
            _getTwoDimCode() {
              let Ot = 0, Pt;
              if (this.eoblock) {
                if (Ot = this._lookBits(7), Pt = ct[Ot], (Pt == null ? void 0 : Pt[0]) > 0)
                  return this._eatBits(Pt[0]), Pt[1];
              } else {
                const wt = this._findTableCode(1, 7, ct);
                if (wt[0] && wt[2])
                  return wt[1];
              }
              return (0, rt.info)("Bad two dim code"), lt;
            }
            _getWhiteCode() {
              let Ot = 0, Pt;
              if (this.eoblock) {
                if (Ot = this._lookBits(12), Ot === lt)
                  return 1;
                if (Pt = Ot >> 5 ? At[Ot >> 3] : vt[Ot], Pt[0] > 0)
                  return this._eatBits(Pt[0]), Pt[1];
              } else {
                let wt = this._findTableCode(1, 9, At);
                if (wt[0] || (wt = this._findTableCode(11, 12, vt), wt[0]))
                  return wt[1];
              }
              return (0, rt.info)("bad white code"), this._eatBits(1), 1;
            }
            _getBlackCode() {
              let Ot, Pt;
              if (this.eoblock) {
                if (Ot = this._lookBits(13), Ot === lt)
                  return 1;
                if (Ot >> 7 ? !(Ot >> 9) && Ot >> 7 ? Pt = bt[(Ot >> 1) - 64] : Pt = Et[Ot >> 7] : Pt = xt[Ot], Pt[0] > 0)
                  return this._eatBits(Pt[0]), Pt[1];
              } else {
                let wt = this._findTableCode(2, 6, Et);
                if (wt[0] || (wt = this._findTableCode(7, 12, bt, 64), wt[0]) || (wt = this._findTableCode(10, 13, xt), wt[0]))
                  return wt[1];
              }
              return (0, rt.info)("bad black code"), this._eatBits(1), 1;
            }
            _lookBits(Ot) {
              let Pt;
              for (; this.inputBits < Ot; ) {
                if ((Pt = this.source.next()) === -1)
                  return this.inputBits === 0 ? lt : this.inputBuf << Ot - this.inputBits & 65535 >> 16 - Ot;
                this.inputBuf = this.inputBuf << 8 | Pt, this.inputBits += 8;
              }
              return this.inputBuf >> this.inputBits - Ot & 65535 >> 16 - Ot;
            }
            _eatBits(Ot) {
              (this.inputBits -= Ot) < 0 && (this.inputBits = 0);
            }
          }
          at.CCITTFaxDecoder = St;
        },
        /* 173 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.FlateStream = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(169), st = ot(145);
          const lt = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), et = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 65547, 65549, 65551, 65553, 131091, 131095, 131099, 131103, 196643, 196651, 196659, 196667, 262211, 262227, 262243, 262259, 327811, 327843, 327875, 327907, 258, 258, 258]), it = new Int32Array([1, 2, 3, 4, 65541, 65543, 131081, 131085, 196625, 196633, 262177, 262193, 327745, 327777, 393345, 393409, 459009, 459137, 524801, 525057, 590849, 591361, 657409, 658433, 724993, 727041, 794625, 798721, 868353, 876545]), ut = [new Int32Array([459008, 524368, 524304, 524568, 459024, 524400, 524336, 590016, 459016, 524384, 524320, 589984, 524288, 524416, 524352, 590048, 459012, 524376, 524312, 589968, 459028, 524408, 524344, 590032, 459020, 524392, 524328, 59e4, 524296, 524424, 524360, 590064, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590024, 459018, 524388, 524324, 589992, 524292, 524420, 524356, 590056, 459014, 524380, 524316, 589976, 459030, 524412, 524348, 590040, 459022, 524396, 524332, 590008, 524300, 524428, 524364, 590072, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590020, 459017, 524386, 524322, 589988, 524290, 524418, 524354, 590052, 459013, 524378, 524314, 589972, 459029, 524410, 524346, 590036, 459021, 524394, 524330, 590004, 524298, 524426, 524362, 590068, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590028, 459019, 524390, 524326, 589996, 524294, 524422, 524358, 590060, 459015, 524382, 524318, 589980, 459031, 524414, 524350, 590044, 459023, 524398, 524334, 590012, 524302, 524430, 524366, 590076, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590018, 459016, 524385, 524321, 589986, 524289, 524417, 524353, 590050, 459012, 524377, 524313, 589970, 459028, 524409, 524345, 590034, 459020, 524393, 524329, 590002, 524297, 524425, 524361, 590066, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590026, 459018, 524389, 524325, 589994, 524293, 524421, 524357, 590058, 459014, 524381, 524317, 589978, 459030, 524413, 524349, 590042, 459022, 524397, 524333, 590010, 524301, 524429, 524365, 590074, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590022, 459017, 524387, 524323, 589990, 524291, 524419, 524355, 590054, 459013, 524379, 524315, 589974, 459029, 524411, 524347, 590038, 459021, 524395, 524331, 590006, 524299, 524427, 524363, 590070, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590030, 459019, 524391, 524327, 589998, 524295, 524423, 524359, 590062, 459015, 524383, 524319, 589982, 459031, 524415, 524351, 590046, 459023, 524399, 524335, 590014, 524303, 524431, 524367, 590078, 459008, 524368, 524304, 524568, 459024, 524400, 524336, 590017, 459016, 524384, 524320, 589985, 524288, 524416, 524352, 590049, 459012, 524376, 524312, 589969, 459028, 524408, 524344, 590033, 459020, 524392, 524328, 590001, 524296, 524424, 524360, 590065, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590025, 459018, 524388, 524324, 589993, 524292, 524420, 524356, 590057, 459014, 524380, 524316, 589977, 459030, 524412, 524348, 590041, 459022, 524396, 524332, 590009, 524300, 524428, 524364, 590073, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590021, 459017, 524386, 524322, 589989, 524290, 524418, 524354, 590053, 459013, 524378, 524314, 589973, 459029, 524410, 524346, 590037, 459021, 524394, 524330, 590005, 524298, 524426, 524362, 590069, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590029, 459019, 524390, 524326, 589997, 524294, 524422, 524358, 590061, 459015, 524382, 524318, 589981, 459031, 524414, 524350, 590045, 459023, 524398, 524334, 590013, 524302, 524430, 524366, 590077, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590019, 459016, 524385, 524321, 589987, 524289, 524417, 524353, 590051, 459012, 524377, 524313, 589971, 459028, 524409, 524345, 590035, 459020, 524393, 524329, 590003, 524297, 524425, 524361, 590067, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590027, 459018, 524389, 524325, 589995, 524293, 524421, 524357, 590059, 459014, 524381, 524317, 589979, 459030, 524413, 524349, 590043, 459022, 524397, 524333, 590011, 524301, 524429, 524365, 590075, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590023, 459017, 524387, 524323, 589991, 524291, 524419, 524355, 590055, 459013, 524379, 524315, 589975, 459029, 524411, 524347, 590039, 459021, 524395, 524331, 590007, 524299, 524427, 524363, 590071, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590031, 459019, 524391, 524327, 589999, 524295, 524423, 524359, 590063, 459015, 524383, 524319, 589983, 459031, 524415, 524351, 590047, 459023, 524399, 524335, 590015, 524303, 524431, 524367, 590079]), 9], ft = [new Int32Array([327680, 327696, 327688, 327704, 327684, 327700, 327692, 327708, 327682, 327698, 327690, 327706, 327686, 327702, 327694, 0, 327681, 327697, 327689, 327705, 327685, 327701, 327693, 327709, 327683, 327699, 327691, 327707, 327687, 327703, 327695, 0]), 5];
          class ht extends rt.DecodeStream {
            constructor(gt, pt) {
              super(pt), this.str = gt, this.dict = gt.dict;
              const mt = gt.getByte(), ct = gt.getByte();
              if (mt === -1 || ct === -1)
                throw new st.FormatError(`Invalid header in flate stream: ${mt}, ${ct}`);
              if ((mt & 15) !== 8)
                throw new st.FormatError(`Unknown compression method in flate stream: ${mt}, ${ct}`);
              if (((mt << 8) + ct) % 31 !== 0)
                throw new st.FormatError(`Bad FCHECK in flate stream: ${mt}, ${ct}`);
              if (ct & 32)
                throw new st.FormatError(`FDICT bit set in flate stream: ${mt}, ${ct}`);
              this.codeSize = 0, this.codeBuf = 0;
            }
            getBits(gt) {
              const pt = this.str;
              let mt = this.codeSize, ct = this.codeBuf, vt;
              for (; mt < gt; ) {
                if ((vt = pt.getByte()) === -1)
                  throw new st.FormatError("Bad encoding in flate stream");
                ct |= vt << mt, mt += 8;
              }
              return vt = ct & (1 << gt) - 1, this.codeBuf = ct >> gt, this.codeSize = mt -= gt, vt;
            }
            getCode(gt) {
              const pt = this.str, mt = gt[0], ct = gt[1];
              let vt = this.codeSize, At = this.codeBuf, xt;
              for (; vt < ct && (xt = pt.getByte()) !== -1; )
                At |= xt << vt, vt += 8;
              const bt = mt[At & (1 << ct) - 1], Et = bt >> 16, St = bt & 65535;
              if (Et < 1 || vt < Et)
                throw new st.FormatError("Bad encoding in flate stream");
              return this.codeBuf = At >> Et, this.codeSize = vt - Et, St;
            }
            generateHuffmanTable(gt) {
              const pt = gt.length;
              let mt = 0, ct;
              for (ct = 0; ct < pt; ++ct)
                gt[ct] > mt && (mt = gt[ct]);
              const vt = 1 << mt, At = new Int32Array(vt);
              for (let xt = 1, bt = 0, Et = 2; xt <= mt; ++xt, bt <<= 1, Et <<= 1)
                for (let St = 0; St < pt; ++St)
                  if (gt[St] === xt) {
                    let Bt = 0, Ot = bt;
                    for (ct = 0; ct < xt; ++ct)
                      Bt = Bt << 1 | Ot & 1, Ot >>= 1;
                    for (ct = Bt; ct < vt; ct += Et)
                      At[ct] = xt << 16 | St;
                    ++bt;
                  }
              return [At, mt];
            }
            readBlock() {
              let gt, pt;
              const mt = this.str;
              let ct = this.getBits(3);
              if (ct & 1 && (this.eof = !0), ct >>= 1, ct === 0) {
                let Et;
                if ((Et = mt.getByte()) === -1)
                  throw new st.FormatError("Bad block header in flate stream");
                let St = Et;
                if ((Et = mt.getByte()) === -1)
                  throw new st.FormatError("Bad block header in flate stream");
                if (St |= Et << 8, (Et = mt.getByte()) === -1)
                  throw new st.FormatError("Bad block header in flate stream");
                let Bt = Et;
                if ((Et = mt.getByte()) === -1)
                  throw new st.FormatError("Bad block header in flate stream");
                if (Bt |= Et << 8, Bt !== (~St & 65535) && (St !== 0 || Bt !== 0))
                  throw new st.FormatError("Bad uncompressed block length in flate stream");
                this.codeBuf = 0, this.codeSize = 0;
                const Ot = this.bufferLength, Pt = Ot + St;
                if (gt = this.ensureBuffer(Pt), this.bufferLength = Pt, St === 0)
                  mt.peekByte() === -1 && (this.eof = !0);
                else {
                  const wt = mt.getBytes(St);
                  gt.set(wt, Ot), wt.length < St && (this.eof = !0);
                }
                return;
              }
              let vt, At;
              if (ct === 1)
                vt = ut, At = ft;
              else if (ct === 2) {
                const Et = this.getBits(5) + 257, St = this.getBits(5) + 1, Bt = this.getBits(4) + 4, Ot = new Uint8Array(lt.length);
                let Pt;
                for (Pt = 0; Pt < Bt; ++Pt)
                  Ot[lt[Pt]] = this.getBits(3);
                const wt = this.generateHuffmanTable(Ot);
                pt = 0, Pt = 0;
                const Ct = Et + St, It = new Uint8Array(Ct);
                let yt, Rt, kt;
                for (; Pt < Ct; ) {
                  const jt = this.getCode(wt);
                  if (jt === 16)
                    yt = 2, Rt = 3, kt = pt;
                  else if (jt === 17)
                    yt = 3, Rt = 3, kt = pt = 0;
                  else if (jt === 18)
                    yt = 7, Rt = 11, kt = pt = 0;
                  else {
                    It[Pt++] = pt = jt;
                    continue;
                  }
                  let Ht = this.getBits(yt) + Rt;
                  for (; Ht-- > 0; )
                    It[Pt++] = kt;
                }
                vt = this.generateHuffmanTable(It.subarray(0, Et)), At = this.generateHuffmanTable(It.subarray(Et, Ct));
              } else
                throw new st.FormatError("Unknown block type in flate stream");
              gt = this.buffer;
              let xt = gt ? gt.length : 0, bt = this.bufferLength;
              for (; ; ) {
                let Et = this.getCode(vt);
                if (Et < 256) {
                  bt + 1 >= xt && (gt = this.ensureBuffer(bt + 1), xt = gt.length), gt[bt++] = Et;
                  continue;
                }
                if (Et === 256) {
                  this.bufferLength = bt;
                  return;
                }
                Et -= 257, Et = et[Et];
                let St = Et >> 16;
                St > 0 && (St = this.getBits(St)), pt = (Et & 65535) + St, Et = this.getCode(At), Et = it[Et], St = Et >> 16, St > 0 && (St = this.getBits(St));
                const Bt = (Et & 65535) + St;
                bt + pt >= xt && (gt = this.ensureBuffer(bt + pt), xt = gt.length);
                for (let Ot = 0; Ot < pt; ++Ot, ++bt)
                  gt[bt] = gt[bt - Bt];
              }
            }
          }
          at.FlateStream = ht;
        },
        /* 174 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Jbig2Stream = void 0, ot(140);
          var rt = ot(152), st = ot(169), lt = ot(151), et = ot(175), it = ot(145);
          class ut extends st.DecodeStream {
            constructor(ht, dt, gt) {
              super(dt), this.stream = ht, this.dict = ht.dict, this.maybeLength = dt, this.params = gt;
            }
            get bytes() {
              return (0, it.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
            }
            ensureBuffer(ht) {
            }
            readBlock() {
              if (this.eof)
                return;
              const ht = new et.Jbig2Image(), dt = [];
              if (this.params instanceof lt.Dict) {
                const mt = this.params.get("JBIG2Globals");
                if (mt instanceof rt.BaseStream) {
                  const ct = mt.getBytes();
                  dt.push({
                    data: ct,
                    start: 0,
                    end: ct.length
                  });
                }
              }
              dt.push({
                data: this.bytes,
                start: 0,
                end: this.bytes.length
              });
              const gt = ht.parseChunks(dt), pt = gt.length;
              for (let mt = 0; mt < pt; mt++)
                gt[mt] ^= 255;
              this.buffer = gt, this.bufferLength = pt, this.eof = !0;
            }
          }
          at.Jbig2Stream = ut;
        },
        /* 175 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Jbig2Image = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(140), ot(2);
          var rt = ot(145), st = ot(150), lt = ot(176), et = ot(172);
          class it extends rt.BaseException {
            constructor(rr) {
              super(`JBIG2 error: ${rr}`, "Jbig2Error");
            }
          }
          class ut {
            getContexts(rr) {
              return rr in this ? this[rr] : this[rr] = new Int8Array(65536);
            }
          }
          class ft {
            constructor(rr, Yt, Kt) {
              this.data = rr, this.start = Yt, this.end = Kt;
            }
            get decoder() {
              const rr = new lt.ArithmeticDecoder(this.data, this.start, this.end);
              return (0, rt.shadow)(this, "decoder", rr);
            }
            get contextCache() {
              const rr = new ut();
              return (0, rt.shadow)(this, "contextCache", rr);
            }
          }
          const ht = 2 ** 31 - 1, dt = -(2 ** 31);
          function gt(Jt, rr, Yt) {
            const Kt = Jt.getContexts(rr);
            let nr = 1;
            function tr(or) {
              let Xt = 0;
              for (let Gt = 0; Gt < or; Gt++) {
                const Wt = Yt.readBit(Kt, nr);
                nr = nr < 256 ? nr << 1 | Wt : (nr << 1 | Wt) & 511 | 256, Xt = Xt << 1 | Wt;
              }
              return Xt >>> 0;
            }
            const ir = tr(1), sr = tr(1) ? tr(1) ? tr(1) ? tr(1) ? tr(1) ? tr(32) + 4436 : tr(12) + 340 : tr(8) + 84 : tr(6) + 20 : tr(4) + 4 : tr(2);
            let cr;
            return ir === 0 ? cr = sr : sr > 0 && (cr = -sr), cr >= dt && cr <= ht ? cr : null;
          }
          function pt(Jt, rr, Yt) {
            const Kt = Jt.getContexts("IAID");
            let nr = 1;
            for (let tr = 0; tr < Yt; tr++) {
              const ir = rr.readBit(Kt, nr);
              nr = nr << 1 | ir;
            }
            return Yt < 31 ? nr & (1 << Yt) - 1 : nr & 2147483647;
          }
          const mt = ["SymbolDictionary", null, null, null, "IntermediateTextRegion", null, "ImmediateTextRegion", "ImmediateLosslessTextRegion", null, null, null, null, null, null, null, null, "PatternDictionary", null, null, null, "IntermediateHalftoneRegion", null, "ImmediateHalftoneRegion", "ImmediateLosslessHalftoneRegion", null, null, null, null, null, null, null, null, null, null, null, null, "IntermediateGenericRegion", null, "ImmediateGenericRegion", "ImmediateLosslessGenericRegion", "IntermediateGenericRefinementRegion", null, "ImmediateGenericRefinementRegion", "ImmediateLosslessGenericRefinementRegion", null, null, null, null, "PageInformation", "EndOfPage", "EndOfStripe", "EndOfFile", "Profiles", "Tables", null, null, null, null, null, null, null, null, "Extension"], ct = [[{
            x: -1,
            y: -2
          }, {
            x: 0,
            y: -2
          }, {
            x: 1,
            y: -2
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: 2,
            y: -1
          }, {
            x: -4,
            y: 0
          }, {
            x: -3,
            y: 0
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }], [{
            x: -1,
            y: -2
          }, {
            x: 0,
            y: -2
          }, {
            x: 1,
            y: -2
          }, {
            x: 2,
            y: -2
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: 2,
            y: -1
          }, {
            x: -3,
            y: 0
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }], [{
            x: -1,
            y: -2
          }, {
            x: 0,
            y: -2
          }, {
            x: 1,
            y: -2
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }], [{
            x: -3,
            y: -1
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: -4,
            y: 0
          }, {
            x: -3,
            y: 0
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }]], vt = [{
            coding: [{
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -1,
              y: 0
            }],
            reference: [{
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -1,
              y: 0
            }, {
              x: 0,
              y: 0
            }, {
              x: 1,
              y: 0
            }, {
              x: -1,
              y: 1
            }, {
              x: 0,
              y: 1
            }, {
              x: 1,
              y: 1
            }]
          }, {
            coding: [{
              x: -1,
              y: -1
            }, {
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -1,
              y: 0
            }],
            reference: [{
              x: 0,
              y: -1
            }, {
              x: -1,
              y: 0
            }, {
              x: 0,
              y: 0
            }, {
              x: 1,
              y: 0
            }, {
              x: 0,
              y: 1
            }, {
              x: 1,
              y: 1
            }]
          }], At = [39717, 1941, 229, 405], xt = [32, 8];
          function bt(Jt, rr, Yt) {
            const Kt = Yt.decoder, nr = Yt.contextCache.getContexts("GB"), tr = [];
            let ir, sr, cr, or, Xt, Gt, Wt;
            const er = 31735;
            for (sr = 0; sr < rr; sr++)
              for (Xt = tr[sr] = new Uint8Array(Jt), Gt = sr < 1 ? Xt : tr[sr - 1], Wt = sr < 2 ? Xt : tr[sr - 2], ir = Wt[0] << 13 | Wt[1] << 12 | Wt[2] << 11 | Gt[0] << 7 | Gt[1] << 6 | Gt[2] << 5 | Gt[3] << 4, cr = 0; cr < Jt; cr++)
                Xt[cr] = or = Kt.readBit(nr, ir), ir = (ir & er) << 1 | (cr + 3 < Jt ? Wt[cr + 3] << 11 : 0) | (cr + 4 < Jt ? Gt[cr + 4] << 4 : 0) | or;
            return tr;
          }
          function Et(Jt, rr, Yt, Kt, nr, tr, ir, sr) {
            if (Jt) {
              const wr = new Dt(sr.data, sr.start, sr.end);
              return Zt(wr, rr, Yt, !1);
            }
            if (Kt === 0 && !tr && !nr && ir.length === 4 && ir[0].x === 3 && ir[0].y === -1 && ir[1].x === -3 && ir[1].y === -1 && ir[2].x === 2 && ir[2].y === -2 && ir[3].x === -2 && ir[3].y === -2)
              return bt(rr, Yt, sr);
            const cr = !!tr, or = ct[Kt].concat(ir);
            or.sort(function(wr, Mr) {
              return wr.y - Mr.y || wr.x - Mr.x;
            });
            const Xt = or.length, Gt = new Int8Array(Xt), Wt = new Int8Array(Xt), er = [];
            let lr = 0, ur = 0, pr = 0, yr = 0, Er, br;
            for (br = 0; br < Xt; br++)
              Gt[br] = or[br].x, Wt[br] = or[br].y, ur = Math.min(ur, or[br].x), pr = Math.max(pr, or[br].x), yr = Math.min(yr, or[br].y), br < Xt - 1 && or[br].y === or[br + 1].y && or[br].x === or[br + 1].x - 1 ? lr |= 1 << Xt - 1 - br : er.push(br);
            const gr = er.length, Ar = new Int8Array(gr), Sr = new Int8Array(gr), Br = new Uint16Array(gr);
            for (Er = 0; Er < gr; Er++)
              br = er[Er], Ar[Er] = or[br].x, Sr[Er] = or[br].y, Br[Er] = 1 << Xt - 1 - br;
            const Ir = -ur, hr = -yr, vr = rr - pr, xr = At[Kt];
            let Pr = new Uint8Array(rr);
            const Rr = [], Dr = sr.decoder, Gr = sr.contextCache.getContexts("GB");
            let Or = 0, Hr, jr, Tr, fr = 0, Cr, $r;
            for (let wr = 0; wr < Yt; wr++) {
              if (nr) {
                const Mr = Dr.readBit(Gr, xr);
                if (Or ^= Mr, Or) {
                  Rr.push(Pr);
                  continue;
                }
              }
              for (Pr = new Uint8Array(Pr), Rr.push(Pr), Hr = 0; Hr < rr; Hr++) {
                if (cr && tr[wr][Hr]) {
                  Pr[Hr] = 0;
                  continue;
                }
                if (Hr >= Ir && Hr < vr && wr >= hr)
                  for (fr = fr << 1 & lr, br = 0; br < gr; br++)
                    jr = wr + Sr[br], Tr = Hr + Ar[br], Cr = Rr[jr][Tr], Cr && (Cr = Br[br], fr |= Cr);
                else
                  for (fr = 0, $r = Xt - 1, br = 0; br < Xt; br++, $r--)
                    Tr = Hr + Gt[br], Tr >= 0 && Tr < rr && (jr = wr + Wt[br], jr >= 0 && (Cr = Rr[jr][Tr], Cr && (fr |= Cr << $r)));
                const Mr = Dr.readBit(Gr, fr);
                Pr[Hr] = Mr;
              }
            }
            return Rr;
          }
          function St(Jt, rr, Yt, Kt, nr, tr, ir, sr, cr) {
            let or = vt[Yt].coding;
            Yt === 0 && (or = or.concat([sr[0]]));
            const Xt = or.length, Gt = new Int32Array(Xt), Wt = new Int32Array(Xt);
            let er;
            for (er = 0; er < Xt; er++)
              Gt[er] = or[er].x, Wt[er] = or[er].y;
            let lr = vt[Yt].reference;
            Yt === 0 && (lr = lr.concat([sr[1]]));
            const ur = lr.length, pr = new Int32Array(ur), yr = new Int32Array(ur);
            for (er = 0; er < ur; er++)
              pr[er] = lr[er].x, yr[er] = lr[er].y;
            const Er = Kt[0].length, br = Kt.length, gr = xt[Yt], Ar = [], Sr = cr.decoder, Br = cr.contextCache.getContexts("GR");
            let Ir = 0;
            for (let hr = 0; hr < rr; hr++) {
              if (ir) {
                const xr = Sr.readBit(Br, gr);
                if (Ir ^= xr, Ir)
                  throw new it("prediction is not supported");
              }
              const vr = new Uint8Array(Jt);
              Ar.push(vr);
              for (let xr = 0; xr < Jt; xr++) {
                let Pr, Rr, Dr = 0;
                for (er = 0; er < Xt; er++)
                  Pr = hr + Wt[er], Rr = xr + Gt[er], Pr < 0 || Rr < 0 || Rr >= Jt ? Dr <<= 1 : Dr = Dr << 1 | Ar[Pr][Rr];
                for (er = 0; er < ur; er++)
                  Pr = hr + yr[er] - tr, Rr = xr + pr[er] - nr, Pr < 0 || Pr >= br || Rr < 0 || Rr >= Er ? Dr <<= 1 : Dr = Dr << 1 | Kt[Pr][Rr];
                const Gr = Sr.readBit(Br, Dr);
                vr[xr] = Gr;
              }
            }
            return Ar;
          }
          function Bt(Jt, rr, Yt, Kt, nr, tr, ir, sr, cr, or, Xt, Gt) {
            if (Jt && rr)
              throw new it("symbol refinement with Huffman is not supported");
            const Wt = [];
            let er = 0, lr = (0, st.log2)(Yt.length + Kt);
            const ur = Xt.decoder, pr = Xt.contextCache;
            let yr, Er;
            for (Jt && (yr = Tt(1), Er = [], lr = Math.max(lr, 1)); Wt.length < Kt; ) {
              const hr = Jt ? tr.tableDeltaHeight.decode(Gt) : gt(pr, "IADH", ur);
              er += hr;
              let vr = 0, xr = 0;
              const Pr = Jt ? Er.length : 0;
              for (; ; ) {
                const Rr = Jt ? tr.tableDeltaWidth.decode(Gt) : gt(pr, "IADW", ur);
                if (Rr === null)
                  break;
                vr += Rr, xr += vr;
                let Dr;
                if (rr) {
                  const Gr = gt(pr, "IAAI", ur);
                  if (Gr > 1)
                    Dr = Ot(Jt, rr, vr, er, 0, Gr, 1, Yt.concat(Wt), lr, 0, 0, 1, 0, tr, cr, or, Xt, 0, Gt);
                  else {
                    const Or = pt(pr, ur, lr), Hr = gt(pr, "IARDX", ur), jr = gt(pr, "IARDY", ur), Tr = Or < Yt.length ? Yt[Or] : Wt[Or - Yt.length];
                    Dr = St(vr, er, cr, Tr, Hr, jr, !1, or, Xt);
                  }
                  Wt.push(Dr);
                } else
                  Jt ? Er.push(vr) : (Dr = Et(!1, vr, er, ir, !1, null, sr, Xt), Wt.push(Dr));
              }
              if (Jt && !rr) {
                const Rr = tr.tableBitmapSize.decode(Gt);
                Gt.byteAlign();
                let Dr;
                if (Rr === 0)
                  Dr = qt(Gt, xr, er);
                else {
                  const Or = Gt.end, Hr = Gt.position + Rr;
                  Gt.end = Hr, Dr = Zt(Gt, xr, er, !1), Gt.end = Or, Gt.position = Hr;
                }
                const Gr = Er.length;
                if (Pr === Gr - 1)
                  Wt.push(Dr);
                else {
                  let Or, Hr, jr = 0, Tr, fr, Cr;
                  for (Or = Pr; Or < Gr; Or++) {
                    for (fr = Er[Or], Tr = jr + fr, Cr = [], Hr = 0; Hr < er; Hr++)
                      Cr.push(Dr[Hr].subarray(jr, Tr));
                    Wt.push(Cr), jr = Tr;
                  }
                }
              }
            }
            const br = [], gr = [];
            let Ar = !1, Sr, Br;
            const Ir = Yt.length + Kt;
            for (; gr.length < Ir; ) {
              let hr = Jt ? yr.decode(Gt) : gt(pr, "IAEX", ur);
              for (; hr--; )
                gr.push(Ar);
              Ar = !Ar;
            }
            for (Sr = 0, Br = Yt.length; Sr < Br; Sr++)
              gr[Sr] && br.push(Yt[Sr]);
            for (let hr = 0; hr < Kt; Sr++, hr++)
              gr[Sr] && br.push(Wt[hr]);
            return br;
          }
          function Ot(Jt, rr, Yt, Kt, nr, tr, ir, sr, cr, or, Xt, Gt, Wt, er, lr, ur, pr, yr, Er) {
            if (Jt && rr)
              throw new it("refinement with Huffman is not supported");
            const br = [];
            let gr, Ar;
            for (gr = 0; gr < Kt; gr++) {
              if (Ar = new Uint8Array(Yt), nr)
                for (let vr = 0; vr < Yt; vr++)
                  Ar[vr] = nr;
              br.push(Ar);
            }
            const Sr = pr.decoder, Br = pr.contextCache;
            let Ir = Jt ? -er.tableDeltaT.decode(Er) : -gt(Br, "IADT", Sr), hr = 0;
            for (gr = 0; gr < tr; ) {
              const vr = Jt ? er.tableDeltaT.decode(Er) : gt(Br, "IADT", Sr);
              Ir += vr;
              const xr = Jt ? er.tableFirstS.decode(Er) : gt(Br, "IAFS", Sr);
              hr += xr;
              let Pr = hr;
              do {
                let Rr = 0;
                ir > 1 && (Rr = Jt ? Er.readBits(yr) : gt(Br, "IAIT", Sr));
                const Dr = ir * Ir + Rr, Gr = Jt ? er.symbolIDTable.decode(Er) : pt(Br, Sr, cr), Or = rr && (Jt ? Er.readBit() : gt(Br, "IARI", Sr));
                let Hr = sr[Gr], jr = Hr[0].length, Tr = Hr.length;
                if (Or) {
                  const Qr = gt(Br, "IARDW", Sr), Yr = gt(Br, "IARDH", Sr), kr = gt(Br, "IARDX", Sr), Nr = gt(Br, "IARDY", Sr);
                  jr += Qr, Tr += Yr, Hr = St(jr, Tr, lr, Hr, (Qr >> 1) + kr, (Yr >> 1) + Nr, !1, ur, pr);
                }
                const fr = Dr - (Gt & 1 ? 0 : Tr - 1), Cr = Pr - (Gt & 2 ? jr - 1 : 0);
                let $r, wr, Mr;
                if (or) {
                  for ($r = 0; $r < Tr; $r++) {
                    if (Ar = br[Cr + $r], !Ar)
                      continue;
                    Mr = Hr[$r];
                    const Qr = Math.min(Yt - fr, jr);
                    switch (Wt) {
                      case 0:
                        for (wr = 0; wr < Qr; wr++)
                          Ar[fr + wr] |= Mr[wr];
                        break;
                      case 2:
                        for (wr = 0; wr < Qr; wr++)
                          Ar[fr + wr] ^= Mr[wr];
                        break;
                      default:
                        throw new it(`operator ${Wt} is not supported`);
                    }
                  }
                  Pr += Tr - 1;
                } else {
                  for (wr = 0; wr < Tr; wr++)
                    if (Ar = br[fr + wr], !!Ar)
                      switch (Mr = Hr[wr], Wt) {
                        case 0:
                          for ($r = 0; $r < jr; $r++)
                            Ar[Cr + $r] |= Mr[$r];
                          break;
                        case 2:
                          for ($r = 0; $r < jr; $r++)
                            Ar[Cr + $r] ^= Mr[$r];
                          break;
                        default:
                          throw new it(`operator ${Wt} is not supported`);
                      }
                  Pr += jr - 1;
                }
                gr++;
                const Fr = Jt ? er.tableDeltaS.decode(Er) : gt(Br, "IADS", Sr);
                if (Fr === null)
                  break;
                Pr += Fr + Xt;
              } while (!0);
            }
            return br;
          }
          function Pt(Jt, rr, Yt, Kt, nr, tr) {
            const ir = [];
            Jt || (ir.push({
              x: -rr,
              y: 0
            }), nr === 0 && ir.push({
              x: -3,
              y: -1
            }, {
              x: 2,
              y: -2
            }, {
              x: -2,
              y: -2
            }));
            const sr = (Kt + 1) * rr, cr = Et(Jt, sr, Yt, nr, !1, null, ir, tr), or = [];
            for (let Xt = 0; Xt <= Kt; Xt++) {
              const Gt = [], Wt = rr * Xt, er = Wt + rr;
              for (let lr = 0; lr < Yt; lr++)
                Gt.push(cr[lr].subarray(Wt, er));
              or.push(Gt);
            }
            return or;
          }
          function wt(Jt, rr, Yt, Kt, nr, tr, ir, sr, cr, or, Xt, Gt, Wt, er, lr) {
            if (ir)
              throw new it("skip is not supported");
            if (sr !== 0)
              throw new it(`operator "${sr}" is not supported in halftone region`);
            const pr = [];
            let yr, Er, br;
            for (yr = 0; yr < nr; yr++) {
              if (br = new Uint8Array(Kt), tr)
                for (Er = 0; Er < Kt; Er++)
                  br[Er] = tr;
              pr.push(br);
            }
            const gr = rr.length, Ar = rr[0], Sr = Ar[0].length, Br = Ar.length, Ir = (0, st.log2)(gr), hr = [];
            Jt || (hr.push({
              x: Yt <= 1 ? 3 : 2,
              y: -1
            }), Yt === 0 && hr.push({
              x: -3,
              y: -1
            }, {
              x: 2,
              y: -2
            }, {
              x: -2,
              y: -2
            }));
            const vr = [];
            let xr, Pr;
            for (Jt && (xr = new Dt(lr.data, lr.start, lr.end)), yr = Ir - 1; yr >= 0; yr--)
              Jt ? Pr = Zt(xr, cr, or, !0) : Pr = Et(!1, cr, or, Yt, !1, null, hr, lr), vr[yr] = Pr;
            let Rr, Dr, Gr, Or, Hr, jr, Tr, fr, Cr;
            for (Rr = 0; Rr < or; Rr++)
              for (Dr = 0; Dr < cr; Dr++) {
                for (Gr = 0, Or = 0, Er = Ir - 1; Er >= 0; Er--)
                  Gr ^= vr[Er][Rr][Dr], Or |= Gr << Er;
                if (Hr = rr[Or], jr = Xt + Rr * er + Dr * Wt >> 8, Tr = Gt + Rr * Wt - Dr * er >> 8, jr >= 0 && jr + Sr <= Kt && Tr >= 0 && Tr + Br <= nr)
                  for (yr = 0; yr < Br; yr++)
                    for (Cr = pr[Tr + yr], fr = Hr[yr], Er = 0; Er < Sr; Er++)
                      Cr[jr + Er] |= fr[Er];
                else {
                  let $r, wr;
                  for (yr = 0; yr < Br; yr++)
                    if (wr = Tr + yr, !(wr < 0 || wr >= nr))
                      for (Cr = pr[wr], fr = Hr[yr], Er = 0; Er < Sr; Er++)
                        $r = jr + Er, $r >= 0 && $r < Kt && (Cr[$r] |= fr[Er]);
                }
              }
            return pr;
          }
          function Ct(Jt, rr) {
            const Yt = {};
            Yt.number = (0, st.readUint32)(Jt, rr);
            const Kt = Jt[rr + 4], nr = Kt & 63;
            if (!mt[nr])
              throw new it("invalid segment type: " + nr);
            Yt.type = nr, Yt.typeName = mt[nr], Yt.deferredNonRetain = !!(Kt & 128);
            const tr = !!(Kt & 64), ir = Jt[rr + 5];
            let sr = ir >> 5 & 7;
            const cr = [ir & 31];
            let or = rr + 6;
            if (ir === 7) {
              sr = (0, st.readUint32)(Jt, or - 1) & 536870911, or += 3;
              let lr = sr + 7 >> 3;
              for (cr[0] = Jt[or++]; --lr > 0; )
                cr.push(Jt[or++]);
            } else if (ir === 5 || ir === 6)
              throw new it("invalid referred-to flags");
            Yt.retainBits = cr;
            let Xt = 4;
            Yt.number <= 256 ? Xt = 1 : Yt.number <= 65536 && (Xt = 2);
            const Gt = [];
            let Wt, er;
            for (Wt = 0; Wt < sr; Wt++) {
              let lr;
              Xt === 1 ? lr = Jt[or] : Xt === 2 ? lr = (0, st.readUint16)(Jt, or) : lr = (0, st.readUint32)(Jt, or), Gt.push(lr), or += Xt;
            }
            if (Yt.referredTo = Gt, tr ? (Yt.pageAssociation = (0, st.readUint32)(Jt, or), or += 4) : Yt.pageAssociation = Jt[or++], Yt.length = (0, st.readUint32)(Jt, or), or += 4, Yt.length === 4294967295)
              if (nr === 38) {
                const lr = yt(Jt, or), pr = !!(Jt[or + Rt] & 1), yr = 6, Er = new Uint8Array(yr);
                for (pr || (Er[0] = 255, Er[1] = 172), Er[2] = lr.height >>> 24 & 255, Er[3] = lr.height >> 16 & 255, Er[4] = lr.height >> 8 & 255, Er[5] = lr.height & 255, Wt = or, er = Jt.length; Wt < er; Wt++) {
                  let br = 0;
                  for (; br < yr && Er[br] === Jt[Wt + br]; )
                    br++;
                  if (br === yr) {
                    Yt.length = Wt + yr;
                    break;
                  }
                }
                if (Yt.length === 4294967295)
                  throw new it("segment end was not found");
              } else
                throw new it("invalid unknown segment length");
            return Yt.headerEnd = or, Yt;
          }
          function It(Jt, rr, Yt, Kt) {
            const nr = [];
            let tr = Yt;
            for (; tr < Kt; ) {
              const ir = Ct(rr, tr);
              tr = ir.headerEnd;
              const sr = {
                header: ir,
                data: rr
              };
              if (Jt.randomAccess || (sr.start = tr, tr += ir.length, sr.end = tr), nr.push(sr), ir.type === 51)
                break;
            }
            if (Jt.randomAccess)
              for (let ir = 0, sr = nr.length; ir < sr; ir++)
                nr[ir].start = tr, tr += nr[ir].header.length, nr[ir].end = tr;
            return nr;
          }
          function yt(Jt, rr) {
            return {
              width: (0, st.readUint32)(Jt, rr),
              height: (0, st.readUint32)(Jt, rr + 4),
              x: (0, st.readUint32)(Jt, rr + 8),
              y: (0, st.readUint32)(Jt, rr + 12),
              combinationOperator: Jt[rr + 16] & 7
            };
          }
          const Rt = 17;
          function kt(Jt, rr) {
            const Yt = Jt.header, Kt = Jt.data, nr = Jt.end;
            let tr = Jt.start, ir, sr, cr, or;
            switch (Yt.type) {
              case 0:
                const Gt = {}, Wt = (0, st.readUint16)(Kt, tr);
                if (Gt.huffman = !!(Wt & 1), Gt.refinement = !!(Wt & 2), Gt.huffmanDHSelector = Wt >> 2 & 3, Gt.huffmanDWSelector = Wt >> 4 & 3, Gt.bitmapSizeSelector = Wt >> 6 & 1, Gt.aggregationInstancesSelector = Wt >> 7 & 1, Gt.bitmapCodingContextUsed = !!(Wt & 256), Gt.bitmapCodingContextRetained = !!(Wt & 512), Gt.template = Wt >> 10 & 3, Gt.refinementTemplate = Wt >> 12 & 1, tr += 2, !Gt.huffman) {
                  for (or = Gt.template === 0 ? 4 : 1, sr = [], cr = 0; cr < or; cr++)
                    sr.push({
                      x: (0, st.readInt8)(Kt, tr),
                      y: (0, st.readInt8)(Kt, tr + 1)
                    }), tr += 2;
                  Gt.at = sr;
                }
                if (Gt.refinement && !Gt.refinementTemplate) {
                  for (sr = [], cr = 0; cr < 2; cr++)
                    sr.push({
                      x: (0, st.readInt8)(Kt, tr),
                      y: (0, st.readInt8)(Kt, tr + 1)
                    }), tr += 2;
                  Gt.refinementAt = sr;
                }
                Gt.numberOfExportedSymbols = (0, st.readUint32)(Kt, tr), tr += 4, Gt.numberOfNewSymbols = (0, st.readUint32)(Kt, tr), tr += 4, ir = [Gt, Yt.number, Yt.referredTo, Kt, tr, nr];
                break;
              case 6:
              case 7:
                const er = {};
                er.info = yt(Kt, tr), tr += Rt;
                const lr = (0, st.readUint16)(Kt, tr);
                if (tr += 2, er.huffman = !!(lr & 1), er.refinement = !!(lr & 2), er.logStripSize = lr >> 2 & 3, er.stripSize = 1 << er.logStripSize, er.referenceCorner = lr >> 4 & 3, er.transposed = !!(lr & 64), er.combinationOperator = lr >> 7 & 3, er.defaultPixelValue = lr >> 9 & 1, er.dsOffset = lr << 17 >> 27, er.refinementTemplate = lr >> 15 & 1, er.huffman) {
                  const Br = (0, st.readUint16)(Kt, tr);
                  tr += 2, er.huffmanFS = Br & 3, er.huffmanDS = Br >> 2 & 3, er.huffmanDT = Br >> 4 & 3, er.huffmanRefinementDW = Br >> 6 & 3, er.huffmanRefinementDH = Br >> 8 & 3, er.huffmanRefinementDX = Br >> 10 & 3, er.huffmanRefinementDY = Br >> 12 & 3, er.huffmanRefinementSizeSelector = !!(Br & 16384);
                }
                if (er.refinement && !er.refinementTemplate) {
                  for (sr = [], cr = 0; cr < 2; cr++)
                    sr.push({
                      x: (0, st.readInt8)(Kt, tr),
                      y: (0, st.readInt8)(Kt, tr + 1)
                    }), tr += 2;
                  er.refinementAt = sr;
                }
                er.numberOfSymbolInstances = (0, st.readUint32)(Kt, tr), tr += 4, ir = [er, Yt.referredTo, Kt, tr, nr];
                break;
              case 16:
                const ur = {}, pr = Kt[tr++];
                ur.mmr = !!(pr & 1), ur.template = pr >> 1 & 3, ur.patternWidth = Kt[tr++], ur.patternHeight = Kt[tr++], ur.maxPatternIndex = (0, st.readUint32)(Kt, tr), tr += 4, ir = [ur, Yt.number, Kt, tr, nr];
                break;
              case 22:
              case 23:
                const yr = {};
                yr.info = yt(Kt, tr), tr += Rt;
                const Er = Kt[tr++];
                yr.mmr = !!(Er & 1), yr.template = Er >> 1 & 3, yr.enableSkip = !!(Er & 8), yr.combinationOperator = Er >> 4 & 7, yr.defaultPixelValue = Er >> 7 & 1, yr.gridWidth = (0, st.readUint32)(Kt, tr), tr += 4, yr.gridHeight = (0, st.readUint32)(Kt, tr), tr += 4, yr.gridOffsetX = (0, st.readUint32)(Kt, tr) & 4294967295, tr += 4, yr.gridOffsetY = (0, st.readUint32)(Kt, tr) & 4294967295, tr += 4, yr.gridVectorX = (0, st.readUint16)(Kt, tr), tr += 2, yr.gridVectorY = (0, st.readUint16)(Kt, tr), tr += 2, ir = [yr, Yt.referredTo, Kt, tr, nr];
                break;
              case 38:
              case 39:
                const br = {};
                br.info = yt(Kt, tr), tr += Rt;
                const gr = Kt[tr++];
                if (br.mmr = !!(gr & 1), br.template = gr >> 1 & 3, br.prediction = !!(gr & 8), !br.mmr) {
                  for (or = br.template === 0 ? 4 : 1, sr = [], cr = 0; cr < or; cr++)
                    sr.push({
                      x: (0, st.readInt8)(Kt, tr),
                      y: (0, st.readInt8)(Kt, tr + 1)
                    }), tr += 2;
                  br.at = sr;
                }
                ir = [br, Kt, tr, nr];
                break;
              case 48:
                const Ar = {
                  width: (0, st.readUint32)(Kt, tr),
                  height: (0, st.readUint32)(Kt, tr + 4),
                  resolutionX: (0, st.readUint32)(Kt, tr + 8),
                  resolutionY: (0, st.readUint32)(Kt, tr + 12)
                };
                Ar.height === 4294967295 && delete Ar.height;
                const Sr = Kt[tr + 16];
                (0, st.readUint16)(Kt, tr + 17), Ar.lossless = !!(Sr & 1), Ar.refinement = !!(Sr & 2), Ar.defaultPixelValue = Sr >> 2 & 1, Ar.combinationOperator = Sr >> 3 & 3, Ar.requiresBuffer = !!(Sr & 32), Ar.combinationOperatorOverride = !!(Sr & 64), ir = [Ar];
                break;
              case 49:
                break;
              case 50:
                break;
              case 51:
                break;
              case 53:
                ir = [Yt.number, Kt, tr, nr];
                break;
              case 62:
                break;
              default:
                throw new it(`segment type ${Yt.typeName}(${Yt.type}) is not implemented`);
            }
            const Xt = "on" + Yt.typeName;
            Xt in rr && rr[Xt].apply(rr, ir);
          }
          function jt(Jt, rr) {
            for (let Yt = 0, Kt = Jt.length; Yt < Kt; Yt++)
              kt(Jt[Yt], rr);
          }
          function Ht(Jt) {
            const rr = new Ft();
            for (let Yt = 0, Kt = Jt.length; Yt < Kt; Yt++) {
              const nr = Jt[Yt], tr = It({}, nr.data, nr.start, nr.end);
              jt(tr, rr);
            }
            return rr.buffer;
          }
          class Ft {
            onPageInformation(rr) {
              this.currentPageInfo = rr;
              const Yt = rr.width + 7 >> 3, Kt = new Uint8ClampedArray(Yt * rr.height);
              rr.defaultPixelValue && Kt.fill(255), this.buffer = Kt;
            }
            drawBitmap(rr, Yt) {
              const Kt = this.currentPageInfo, nr = rr.width, tr = rr.height, ir = Kt.width + 7 >> 3, sr = Kt.combinationOperatorOverride ? rr.combinationOperator : Kt.combinationOperator, cr = this.buffer, or = 128 >> (rr.x & 7);
              let Xt = rr.y * ir + (rr.x >> 3), Gt, Wt, er, lr;
              switch (sr) {
                case 0:
                  for (Gt = 0; Gt < tr; Gt++) {
                    for (er = or, lr = Xt, Wt = 0; Wt < nr; Wt++)
                      Yt[Gt][Wt] && (cr[lr] |= er), er >>= 1, er || (er = 128, lr++);
                    Xt += ir;
                  }
                  break;
                case 2:
                  for (Gt = 0; Gt < tr; Gt++) {
                    for (er = or, lr = Xt, Wt = 0; Wt < nr; Wt++)
                      Yt[Gt][Wt] && (cr[lr] ^= er), er >>= 1, er || (er = 128, lr++);
                    Xt += ir;
                  }
                  break;
                default:
                  throw new it(`operator ${sr} is not supported`);
              }
            }
            onImmediateGenericRegion(rr, Yt, Kt, nr) {
              const tr = rr.info, ir = new ft(Yt, Kt, nr), sr = Et(rr.mmr, tr.width, tr.height, rr.template, rr.prediction, null, rr.at, ir);
              this.drawBitmap(tr, sr);
            }
            onImmediateLosslessGenericRegion() {
              this.onImmediateGenericRegion(...arguments);
            }
            onSymbolDictionary(rr, Yt, Kt, nr, tr, ir) {
              let sr, cr;
              rr.huffman && (sr = Qt(rr, Kt, this.customTables), cr = new Dt(nr, tr, ir));
              let or = this.symbols;
              or || (this.symbols = or = {});
              const Xt = [];
              for (const Wt of Kt) {
                const er = or[Wt];
                er && Xt.push(...er);
              }
              const Gt = new ft(nr, tr, ir);
              or[Yt] = Bt(rr.huffman, rr.refinement, Xt, rr.numberOfNewSymbols, rr.numberOfExportedSymbols, sr, rr.template, rr.at, rr.refinementTemplate, rr.refinementAt, Gt, cr);
            }
            onImmediateTextRegion(rr, Yt, Kt, nr, tr) {
              const ir = rr.info;
              let sr, cr;
              const or = this.symbols, Xt = [];
              for (const lr of Yt) {
                const ur = or[lr];
                ur && Xt.push(...ur);
              }
              const Gt = (0, st.log2)(Xt.length);
              rr.huffman && (cr = new Dt(Kt, nr, tr), sr = Vt(rr, Yt, this.customTables, Xt.length, cr));
              const Wt = new ft(Kt, nr, tr), er = Ot(rr.huffman, rr.refinement, ir.width, ir.height, rr.defaultPixelValue, rr.numberOfSymbolInstances, rr.stripSize, Xt, Gt, rr.transposed, rr.dsOffset, rr.referenceCorner, rr.combinationOperator, sr, rr.refinementTemplate, rr.refinementAt, Wt, rr.logStripSize, cr);
              this.drawBitmap(ir, er);
            }
            onImmediateLosslessTextRegion() {
              this.onImmediateTextRegion(...arguments);
            }
            onPatternDictionary(rr, Yt, Kt, nr, tr) {
              let ir = this.patterns;
              ir || (this.patterns = ir = {});
              const sr = new ft(Kt, nr, tr);
              ir[Yt] = Pt(rr.mmr, rr.patternWidth, rr.patternHeight, rr.maxPatternIndex, rr.template, sr);
            }
            onImmediateHalftoneRegion(rr, Yt, Kt, nr, tr) {
              const ir = this.patterns[Yt[0]], sr = rr.info, cr = new ft(Kt, nr, tr), or = wt(rr.mmr, ir, rr.template, sr.width, sr.height, rr.defaultPixelValue, rr.enableSkip, rr.combinationOperator, rr.gridWidth, rr.gridHeight, rr.gridOffsetX, rr.gridOffsetY, rr.gridVectorX, rr.gridVectorY, cr);
              this.drawBitmap(sr, or);
            }
            onImmediateLosslessHalftoneRegion() {
              this.onImmediateHalftoneRegion(...arguments);
            }
            onTables(rr, Yt, Kt, nr) {
              let tr = this.customTables;
              tr || (this.customTables = tr = {}), tr[rr] = Lt(Yt, Kt, nr);
            }
          }
          class _t {
            constructor(rr) {
              rr.length === 2 ? (this.isOOB = !0, this.rangeLow = 0, this.prefixLength = rr[0], this.rangeLength = 0, this.prefixCode = rr[1], this.isLowerRange = !1) : (this.isOOB = !1, this.rangeLow = rr[0], this.prefixLength = rr[1], this.rangeLength = rr[2], this.prefixCode = rr[3], this.isLowerRange = rr[4] === "lower");
            }
          }
          class Nt {
            constructor(rr) {
              this.children = [], rr ? (this.isLeaf = !0, this.rangeLength = rr.rangeLength, this.rangeLow = rr.rangeLow, this.isLowerRange = rr.isLowerRange, this.isOOB = rr.isOOB) : this.isLeaf = !1;
            }
            buildTree(rr, Yt) {
              const Kt = rr.prefixCode >> Yt & 1;
              if (Yt <= 0)
                this.children[Kt] = new Nt(rr);
              else {
                let nr = this.children[Kt];
                nr || (this.children[Kt] = nr = new Nt(null)), nr.buildTree(rr, Yt - 1);
              }
            }
            decodeNode(rr) {
              if (this.isLeaf) {
                if (this.isOOB)
                  return null;
                const Kt = rr.readBits(this.rangeLength);
                return this.rangeLow + (this.isLowerRange ? -Kt : Kt);
              }
              const Yt = this.children[rr.readBit()];
              if (!Yt)
                throw new it("invalid Huffman data");
              return Yt.decodeNode(rr);
            }
          }
          class Mt {
            constructor(rr, Yt) {
              Yt || this.assignPrefixCodes(rr), this.rootNode = new Nt(null);
              for (let Kt = 0, nr = rr.length; Kt < nr; Kt++) {
                const tr = rr[Kt];
                tr.prefixLength > 0 && this.rootNode.buildTree(tr, tr.prefixLength - 1);
              }
            }
            decode(rr) {
              return this.rootNode.decodeNode(rr);
            }
            assignPrefixCodes(rr) {
              const Yt = rr.length;
              let Kt = 0;
              for (let Xt = 0; Xt < Yt; Xt++)
                Kt = Math.max(Kt, rr[Xt].prefixLength);
              const nr = new Uint32Array(Kt + 1);
              for (let Xt = 0; Xt < Yt; Xt++)
                nr[rr[Xt].prefixLength]++;
              let tr = 1, ir = 0, sr, cr, or;
              for (nr[0] = 0; tr <= Kt; ) {
                for (ir = ir + nr[tr - 1] << 1, sr = ir, cr = 0; cr < Yt; )
                  or = rr[cr], or.prefixLength === tr && (or.prefixCode = sr, sr++), cr++;
                tr++;
              }
            }
          }
          function Lt(Jt, rr, Yt) {
            const Kt = Jt[rr], nr = (0, st.readUint32)(Jt, rr + 1) & 4294967295, tr = (0, st.readUint32)(Jt, rr + 5) & 4294967295, ir = new Dt(Jt, rr + 9, Yt), sr = (Kt >> 1 & 7) + 1, cr = (Kt >> 4 & 7) + 1, or = [];
            let Xt, Gt, Wt = nr;
            do
              Xt = ir.readBits(sr), Gt = ir.readBits(cr), or.push(new _t([Wt, Xt, Gt, 0])), Wt += 1 << Gt;
            while (Wt < tr);
            return Xt = ir.readBits(sr), or.push(new _t([nr - 1, Xt, 32, 0, "lower"])), Xt = ir.readBits(sr), or.push(new _t([tr, Xt, 32, 0])), Kt & 1 && (Xt = ir.readBits(sr), or.push(new _t([Xt, 0]))), new Mt(or, !1);
          }
          const $t = {};
          function Tt(Jt) {
            let rr = $t[Jt];
            if (rr)
              return rr;
            let Yt;
            switch (Jt) {
              case 1:
                Yt = [[0, 1, 4, 0], [16, 2, 8, 2], [272, 3, 16, 6], [65808, 3, 32, 7]];
                break;
              case 2:
                Yt = [[0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [75, 6, 32, 62], [6, 63]];
                break;
              case 3:
                Yt = [[-256, 8, 8, 254], [0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [-257, 8, 32, 255, "lower"], [75, 7, 32, 126], [6, 62]];
                break;
              case 4:
                Yt = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [76, 5, 32, 31]];
                break;
              case 5:
                Yt = [[-255, 7, 8, 126], [1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [-256, 7, 32, 127, "lower"], [76, 6, 32, 62]];
                break;
              case 6:
                Yt = [[-2048, 5, 10, 28], [-1024, 4, 9, 8], [-512, 4, 8, 9], [-256, 4, 7, 10], [-128, 5, 6, 29], [-64, 5, 5, 30], [-32, 4, 5, 11], [0, 2, 7, 0], [128, 3, 7, 2], [256, 3, 8, 3], [512, 4, 9, 12], [1024, 4, 10, 13], [-2049, 6, 32, 62, "lower"], [2048, 6, 32, 63]];
                break;
              case 7:
                Yt = [[-1024, 4, 9, 8], [-512, 3, 8, 0], [-256, 4, 7, 9], [-128, 5, 6, 26], [-64, 5, 5, 27], [-32, 4, 5, 10], [0, 4, 5, 11], [32, 5, 5, 28], [64, 5, 6, 29], [128, 4, 7, 12], [256, 3, 8, 1], [512, 3, 9, 2], [1024, 3, 10, 3], [-1025, 5, 32, 30, "lower"], [2048, 5, 32, 31]];
                break;
              case 8:
                Yt = [[-15, 8, 3, 252], [-7, 9, 1, 508], [-5, 8, 1, 253], [-3, 9, 0, 509], [-2, 7, 0, 124], [-1, 4, 0, 10], [0, 2, 1, 0], [2, 5, 0, 26], [3, 6, 0, 58], [4, 3, 4, 4], [20, 6, 1, 59], [22, 4, 4, 11], [38, 4, 5, 12], [70, 5, 6, 27], [134, 5, 7, 28], [262, 6, 7, 60], [390, 7, 8, 125], [646, 6, 10, 61], [-16, 9, 32, 510, "lower"], [1670, 9, 32, 511], [2, 1]];
                break;
              case 9:
                Yt = [[-31, 8, 4, 252], [-15, 9, 2, 508], [-11, 8, 2, 253], [-7, 9, 1, 509], [-5, 7, 1, 124], [-3, 4, 1, 10], [-1, 3, 1, 2], [1, 3, 1, 3], [3, 5, 1, 26], [5, 6, 1, 58], [7, 3, 5, 4], [39, 6, 2, 59], [43, 4, 5, 11], [75, 4, 6, 12], [139, 5, 7, 27], [267, 5, 8, 28], [523, 6, 8, 60], [779, 7, 9, 125], [1291, 6, 11, 61], [-32, 9, 32, 510, "lower"], [3339, 9, 32, 511], [2, 0]];
                break;
              case 10:
                Yt = [[-21, 7, 4, 122], [-5, 8, 0, 252], [-4, 7, 0, 123], [-3, 5, 0, 24], [-2, 2, 2, 0], [2, 5, 0, 25], [3, 6, 0, 54], [4, 7, 0, 124], [5, 8, 0, 253], [6, 2, 6, 1], [70, 5, 5, 26], [102, 6, 5, 55], [134, 6, 6, 56], [198, 6, 7, 57], [326, 6, 8, 58], [582, 6, 9, 59], [1094, 6, 10, 60], [2118, 7, 11, 125], [-22, 8, 32, 254, "lower"], [4166, 8, 32, 255], [2, 2]];
                break;
              case 11:
                Yt = [[1, 1, 0, 0], [2, 2, 1, 2], [4, 4, 0, 12], [5, 4, 1, 13], [7, 5, 1, 28], [9, 5, 2, 29], [13, 6, 2, 60], [17, 7, 2, 122], [21, 7, 3, 123], [29, 7, 4, 124], [45, 7, 5, 125], [77, 7, 6, 126], [141, 7, 32, 127]];
                break;
              case 12:
                Yt = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 1, 6], [5, 5, 0, 28], [6, 5, 1, 29], [8, 6, 1, 60], [10, 7, 0, 122], [11, 7, 1, 123], [13, 7, 2, 124], [17, 7, 3, 125], [25, 7, 4, 126], [41, 8, 5, 254], [73, 8, 32, 255]];
                break;
              case 13:
                Yt = [[1, 1, 0, 0], [2, 3, 0, 4], [3, 4, 0, 12], [4, 5, 0, 28], [5, 4, 1, 13], [7, 3, 3, 5], [15, 6, 1, 58], [17, 6, 2, 59], [21, 6, 3, 60], [29, 6, 4, 61], [45, 6, 5, 62], [77, 7, 6, 126], [141, 7, 32, 127]];
                break;
              case 14:
                Yt = [[-2, 3, 0, 4], [-1, 3, 0, 5], [0, 1, 0, 0], [1, 3, 0, 6], [2, 3, 0, 7]];
                break;
              case 15:
                Yt = [[-24, 7, 4, 124], [-8, 6, 2, 60], [-4, 5, 1, 28], [-2, 4, 0, 12], [-1, 3, 0, 4], [0, 1, 0, 0], [1, 3, 0, 5], [2, 4, 0, 13], [3, 5, 1, 29], [5, 6, 2, 61], [9, 7, 4, 125], [-25, 7, 32, 126, "lower"], [25, 7, 32, 127]];
                break;
              default:
                throw new it(`standard table B.${Jt} does not exist`);
            }
            for (let Kt = 0, nr = Yt.length; Kt < nr; Kt++)
              Yt[Kt] = new _t(Yt[Kt]);
            return rr = new Mt(Yt, !0), $t[Jt] = rr, rr;
          }
          class Dt {
            constructor(rr, Yt, Kt) {
              this.data = rr, this.start = Yt, this.end = Kt, this.position = Yt, this.shift = -1, this.currentByte = 0;
            }
            readBit() {
              if (this.shift < 0) {
                if (this.position >= this.end)
                  throw new it("end of data while reading bit");
                this.currentByte = this.data[this.position++], this.shift = 7;
              }
              const rr = this.currentByte >> this.shift & 1;
              return this.shift--, rr;
            }
            readBits(rr) {
              let Yt = 0, Kt;
              for (Kt = rr - 1; Kt >= 0; Kt--)
                Yt |= this.readBit() << Kt;
              return Yt;
            }
            byteAlign() {
              this.shift = -1;
            }
            next() {
              return this.position >= this.end ? -1 : this.data[this.position++];
            }
          }
          function Ut(Jt, rr, Yt) {
            let Kt = 0;
            for (let nr = 0, tr = rr.length; nr < tr; nr++) {
              const ir = Yt[rr[nr]];
              if (ir) {
                if (Jt === Kt)
                  return ir;
                Kt++;
              }
            }
            throw new it("can't find custom Huffman table");
          }
          function Vt(Jt, rr, Yt, Kt, nr) {
            const tr = [];
            for (let Wt = 0; Wt <= 34; Wt++) {
              const er = nr.readBits(4);
              tr.push(new _t([Wt, er, 0, 0]));
            }
            const ir = new Mt(tr, !1);
            tr.length = 0;
            for (let Wt = 0; Wt < Kt; ) {
              const er = ir.decode(nr);
              if (er >= 32) {
                let lr, ur, pr;
                switch (er) {
                  case 32:
                    if (Wt === 0)
                      throw new it("no previous value in symbol ID table");
                    ur = nr.readBits(2) + 3, lr = tr[Wt - 1].prefixLength;
                    break;
                  case 33:
                    ur = nr.readBits(3) + 3, lr = 0;
                    break;
                  case 34:
                    ur = nr.readBits(7) + 11, lr = 0;
                    break;
                  default:
                    throw new it("invalid code length in symbol ID table");
                }
                for (pr = 0; pr < ur; pr++)
                  tr.push(new _t([Wt, lr, 0, 0])), Wt++;
              } else
                tr.push(new _t([Wt, er, 0, 0])), Wt++;
            }
            nr.byteAlign();
            const sr = new Mt(tr, !1);
            let cr = 0, or, Xt, Gt;
            switch (Jt.huffmanFS) {
              case 0:
              case 1:
                or = Tt(Jt.huffmanFS + 6);
                break;
              case 3:
                or = Ut(cr, rr, Yt), cr++;
                break;
              default:
                throw new it("invalid Huffman FS selector");
            }
            switch (Jt.huffmanDS) {
              case 0:
              case 1:
              case 2:
                Xt = Tt(Jt.huffmanDS + 8);
                break;
              case 3:
                Xt = Ut(cr, rr, Yt), cr++;
                break;
              default:
                throw new it("invalid Huffman DS selector");
            }
            switch (Jt.huffmanDT) {
              case 0:
              case 1:
              case 2:
                Gt = Tt(Jt.huffmanDT + 11);
                break;
              case 3:
                Gt = Ut(cr, rr, Yt), cr++;
                break;
              default:
                throw new it("invalid Huffman DT selector");
            }
            if (Jt.refinement)
              throw new it("refinement with Huffman is not supported");
            return {
              symbolIDTable: sr,
              tableFirstS: or,
              tableDeltaS: Xt,
              tableDeltaT: Gt
            };
          }
          function Qt(Jt, rr, Yt) {
            let Kt = 0, nr, tr;
            switch (Jt.huffmanDHSelector) {
              case 0:
              case 1:
                nr = Tt(Jt.huffmanDHSelector + 4);
                break;
              case 3:
                nr = Ut(Kt, rr, Yt), Kt++;
                break;
              default:
                throw new it("invalid Huffman DH selector");
            }
            switch (Jt.huffmanDWSelector) {
              case 0:
              case 1:
                tr = Tt(Jt.huffmanDWSelector + 2);
                break;
              case 3:
                tr = Ut(Kt, rr, Yt), Kt++;
                break;
              default:
                throw new it("invalid Huffman DW selector");
            }
            let ir, sr;
            return Jt.bitmapSizeSelector ? (ir = Ut(Kt, rr, Yt), Kt++) : ir = Tt(1), Jt.aggregationInstancesSelector ? sr = Ut(Kt, rr, Yt) : sr = Tt(1), {
              tableDeltaHeight: nr,
              tableDeltaWidth: tr,
              tableBitmapSize: ir,
              tableAggregateInstances: sr
            };
          }
          function qt(Jt, rr, Yt) {
            const Kt = [];
            for (let nr = 0; nr < Yt; nr++) {
              const tr = new Uint8Array(rr);
              Kt.push(tr);
              for (let ir = 0; ir < rr; ir++)
                tr[ir] = Jt.readBit();
              Jt.byteAlign();
            }
            return Kt;
          }
          function Zt(Jt, rr, Yt, Kt) {
            const nr = {
              K: -1,
              Columns: rr,
              Rows: Yt,
              BlackIs1: !0,
              EndOfBlock: Kt
            }, tr = new et.CCITTFaxDecoder(Jt, nr), ir = [];
            let sr, cr = !1;
            for (let or = 0; or < Yt; or++) {
              const Xt = new Uint8Array(rr);
              ir.push(Xt);
              let Gt = -1;
              for (let Wt = 0; Wt < rr; Wt++)
                Gt < 0 && (sr = tr.readNextChar(), sr === -1 && (sr = 0, cr = !0), Gt = 7), Xt[Wt] = sr >> Gt & 1, Gt--;
            }
            if (Kt && !cr)
              for (let Xt = 0; Xt < 5 && tr.readNextChar() !== -1; Xt++)
                ;
            return ir;
          }
          class ar {
            parseChunks(rr) {
              return Ht(rr);
            }
            parse(rr) {
              throw new Error("Not implemented: Jbig2Image.parse");
            }
          }
          at.Jbig2Image = ar;
        },
        /* 176 */
        /***/
        (nt, at) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.ArithmeticDecoder = void 0;
          const ot = [{
            qe: 22017,
            nmps: 1,
            nlps: 1,
            switchFlag: 1
          }, {
            qe: 13313,
            nmps: 2,
            nlps: 6,
            switchFlag: 0
          }, {
            qe: 6145,
            nmps: 3,
            nlps: 9,
            switchFlag: 0
          }, {
            qe: 2753,
            nmps: 4,
            nlps: 12,
            switchFlag: 0
          }, {
            qe: 1313,
            nmps: 5,
            nlps: 29,
            switchFlag: 0
          }, {
            qe: 545,
            nmps: 38,
            nlps: 33,
            switchFlag: 0
          }, {
            qe: 22017,
            nmps: 7,
            nlps: 6,
            switchFlag: 1
          }, {
            qe: 21505,
            nmps: 8,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 18433,
            nmps: 9,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 14337,
            nmps: 10,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 12289,
            nmps: 11,
            nlps: 17,
            switchFlag: 0
          }, {
            qe: 9217,
            nmps: 12,
            nlps: 18,
            switchFlag: 0
          }, {
            qe: 7169,
            nmps: 13,
            nlps: 20,
            switchFlag: 0
          }, {
            qe: 5633,
            nmps: 29,
            nlps: 21,
            switchFlag: 0
          }, {
            qe: 22017,
            nmps: 15,
            nlps: 14,
            switchFlag: 1
          }, {
            qe: 21505,
            nmps: 16,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 20737,
            nmps: 17,
            nlps: 15,
            switchFlag: 0
          }, {
            qe: 18433,
            nmps: 18,
            nlps: 16,
            switchFlag: 0
          }, {
            qe: 14337,
            nmps: 19,
            nlps: 17,
            switchFlag: 0
          }, {
            qe: 13313,
            nmps: 20,
            nlps: 18,
            switchFlag: 0
          }, {
            qe: 12289,
            nmps: 21,
            nlps: 19,
            switchFlag: 0
          }, {
            qe: 10241,
            nmps: 22,
            nlps: 19,
            switchFlag: 0
          }, {
            qe: 9217,
            nmps: 23,
            nlps: 20,
            switchFlag: 0
          }, {
            qe: 8705,
            nmps: 24,
            nlps: 21,
            switchFlag: 0
          }, {
            qe: 7169,
            nmps: 25,
            nlps: 22,
            switchFlag: 0
          }, {
            qe: 6145,
            nmps: 26,
            nlps: 23,
            switchFlag: 0
          }, {
            qe: 5633,
            nmps: 27,
            nlps: 24,
            switchFlag: 0
          }, {
            qe: 5121,
            nmps: 28,
            nlps: 25,
            switchFlag: 0
          }, {
            qe: 4609,
            nmps: 29,
            nlps: 26,
            switchFlag: 0
          }, {
            qe: 4353,
            nmps: 30,
            nlps: 27,
            switchFlag: 0
          }, {
            qe: 2753,
            nmps: 31,
            nlps: 28,
            switchFlag: 0
          }, {
            qe: 2497,
            nmps: 32,
            nlps: 29,
            switchFlag: 0
          }, {
            qe: 2209,
            nmps: 33,
            nlps: 30,
            switchFlag: 0
          }, {
            qe: 1313,
            nmps: 34,
            nlps: 31,
            switchFlag: 0
          }, {
            qe: 1089,
            nmps: 35,
            nlps: 32,
            switchFlag: 0
          }, {
            qe: 673,
            nmps: 36,
            nlps: 33,
            switchFlag: 0
          }, {
            qe: 545,
            nmps: 37,
            nlps: 34,
            switchFlag: 0
          }, {
            qe: 321,
            nmps: 38,
            nlps: 35,
            switchFlag: 0
          }, {
            qe: 273,
            nmps: 39,
            nlps: 36,
            switchFlag: 0
          }, {
            qe: 133,
            nmps: 40,
            nlps: 37,
            switchFlag: 0
          }, {
            qe: 73,
            nmps: 41,
            nlps: 38,
            switchFlag: 0
          }, {
            qe: 37,
            nmps: 42,
            nlps: 39,
            switchFlag: 0
          }, {
            qe: 21,
            nmps: 43,
            nlps: 40,
            switchFlag: 0
          }, {
            qe: 9,
            nmps: 44,
            nlps: 41,
            switchFlag: 0
          }, {
            qe: 5,
            nmps: 45,
            nlps: 42,
            switchFlag: 0
          }, {
            qe: 1,
            nmps: 45,
            nlps: 43,
            switchFlag: 0
          }, {
            qe: 22017,
            nmps: 46,
            nlps: 46,
            switchFlag: 0
          }];
          class rt {
            constructor(lt, et, it) {
              this.data = lt, this.bp = et, this.dataEnd = it, this.chigh = lt[et], this.clow = 0, this.byteIn(), this.chigh = this.chigh << 7 & 65535 | this.clow >> 9 & 127, this.clow = this.clow << 7 & 65535, this.ct -= 7, this.a = 32768;
            }
            byteIn() {
              const lt = this.data;
              let et = this.bp;
              lt[et] === 255 ? lt[et + 1] > 143 ? (this.clow += 65280, this.ct = 8) : (et++, this.clow += lt[et] << 9, this.ct = 7, this.bp = et) : (et++, this.clow += et < this.dataEnd ? lt[et] << 8 : 65280, this.ct = 8, this.bp = et), this.clow > 65535 && (this.chigh += this.clow >> 16, this.clow &= 65535);
            }
            readBit(lt, et) {
              let it = lt[et] >> 1, ut = lt[et] & 1;
              const ft = ot[it], ht = ft.qe;
              let dt, gt = this.a - ht;
              if (this.chigh < ht)
                gt < ht ? (gt = ht, dt = ut, it = ft.nmps) : (gt = ht, dt = 1 ^ ut, ft.switchFlag === 1 && (ut = dt), it = ft.nlps);
              else {
                if (this.chigh -= ht, gt & 32768)
                  return this.a = gt, ut;
                gt < ht ? (dt = 1 ^ ut, ft.switchFlag === 1 && (ut = dt), it = ft.nlps) : (dt = ut, it = ft.nmps);
              }
              do
                this.ct === 0 && this.byteIn(), gt <<= 1, this.chigh = this.chigh << 1 & 65535 | this.clow >> 15 & 1, this.clow = this.clow << 1 & 65535, this.ct--;
              while (!(gt & 32768));
              return this.a = gt, lt[et] = it << 1 | ut, dt;
            }
          }
          at.ArithmeticDecoder = rt;
        },
        /* 177 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.JpegStream = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(169), st = ot(151), lt = ot(178), et = ot(145);
          class it extends rt.DecodeStream {
            constructor(ft, ht, dt) {
              let gt;
              for (; (gt = ft.getByte()) !== -1; )
                if (gt === 255) {
                  ft.skip(-1);
                  break;
                }
              super(ht), this.stream = ft, this.dict = ft.dict, this.maybeLength = ht, this.params = dt;
            }
            get bytes() {
              return (0, et.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
            }
            ensureBuffer(ft) {
            }
            readBlock() {
              if (this.eof)
                return;
              const ft = {
                decodeTransform: void 0,
                colorTransform: void 0
              }, ht = this.dict.getArray("D", "Decode");
              if ((this.forceRGBA || this.forceRGB) && Array.isArray(ht)) {
                const pt = this.dict.get("BPC", "BitsPerComponent") || 8, mt = ht.length, ct = new Int32Array(mt);
                let vt = !1;
                const At = (1 << pt) - 1;
                for (let xt = 0; xt < mt; xt += 2)
                  ct[xt] = (ht[xt + 1] - ht[xt]) * 256 | 0, ct[xt + 1] = ht[xt] * At | 0, (ct[xt] !== 256 || ct[xt + 1] !== 0) && (vt = !0);
                vt && (ft.decodeTransform = ct);
              }
              if (this.params instanceof st.Dict) {
                const pt = this.params.get("ColorTransform");
                Number.isInteger(pt) && (ft.colorTransform = pt);
              }
              const dt = new lt.JpegImage(ft);
              dt.parse(this.bytes);
              const gt = dt.getData({
                width: this.drawWidth,
                height: this.drawHeight,
                forceRGBA: this.forceRGBA,
                forceRGB: this.forceRGB,
                isSourcePDF: !0
              });
              this.buffer = gt, this.bufferLength = gt.length, this.eof = !0;
            }
          }
          at.JpegStream = it;
        },
        /* 178 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.JpegImage = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(140);
          var rt = ot(145), st = ot(179), lt = ot(150);
          class et extends rt.BaseException {
            constructor(Ct) {
              super(`JPEG error: ${Ct}`, "JpegError");
            }
          }
          class it extends rt.BaseException {
            constructor(Ct, It) {
              super(Ct, "DNLMarkerError"), this.scanLines = It;
            }
          }
          class ut extends rt.BaseException {
            constructor(Ct) {
              super(Ct, "EOIMarkerError");
            }
          }
          const ft = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]), ht = 4017, dt = 799, gt = 3406, pt = 2276, mt = 1567, ct = 3784, vt = 5793, At = 2896;
          function xt(wt, Ct) {
            let It = 0, yt, Rt, kt = 16;
            for (; kt > 0 && !wt[kt - 1]; )
              kt--;
            const jt = [{
              children: [],
              index: 0
            }];
            let Ht = jt[0], Ft;
            for (yt = 0; yt < kt; yt++) {
              for (Rt = 0; Rt < wt[yt]; Rt++) {
                for (Ht = jt.pop(), Ht.children[Ht.index] = Ct[It]; Ht.index > 0; )
                  Ht = jt.pop();
                for (Ht.index++, jt.push(Ht); jt.length <= yt; )
                  jt.push(Ft = {
                    children: [],
                    index: 0
                  }), Ht.children[Ht.index] = Ft.children, Ht = Ft;
                It++;
              }
              yt + 1 < kt && (jt.push(Ft = {
                children: [],
                index: 0
              }), Ht.children[Ht.index] = Ft.children, Ht = Ft);
            }
            return jt[0].children;
          }
          function bt(wt, Ct, It) {
            return 64 * ((wt.blocksPerLine + 1) * Ct + It);
          }
          function Et(wt, Ct, It, yt, Rt, kt, jt, Ht, Ft) {
            let _t = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : !1;
            const Nt = It.mcusPerLine, Mt = It.progressive, Lt = Ct;
            let $t = 0, Tt = 0;
            function Dt() {
              if (Tt > 0)
                return Tt--, $t >> Tt & 1;
              if ($t = wt[Ct++], $t === 255) {
                const gr = wt[Ct++];
                if (gr) {
                  if (gr === 220 && _t) {
                    Ct += 2;
                    const Ar = (0, lt.readUint16)(wt, Ct);
                    if (Ct += 2, Ar > 0 && Ar !== It.scanLines)
                      throw new it("Found DNL marker (0xFFDC) while parsing scan data", Ar);
                  } else if (gr === 217) {
                    if (_t) {
                      const Ar = tr * (It.precision === 8 ? 8 : 0);
                      if (Ar > 0 && Math.round(It.scanLines / Ar) >= 5)
                        throw new it("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", Ar);
                    }
                    throw new ut("Found EOI marker (0xFFD9) while parsing scan data");
                  }
                  throw new et(`unexpected marker ${($t << 8 | gr).toString(16)}`);
                }
              }
              return Tt = 7, $t >>> 7;
            }
            function Ut(gr) {
              let Ar = gr;
              for (; ; ) {
                switch (Ar = Ar[Dt()], typeof Ar) {
                  case "number":
                    return Ar;
                  case "object":
                    continue;
                }
                throw new et("invalid huffman sequence");
              }
            }
            function Vt(gr) {
              let Ar = 0;
              for (; gr > 0; )
                Ar = Ar << 1 | Dt(), gr--;
              return Ar;
            }
            function Qt(gr) {
              if (gr === 1)
                return Dt() === 1 ? 1 : -1;
              const Ar = Vt(gr);
              return Ar >= 1 << gr - 1 ? Ar : Ar + (-1 << gr) + 1;
            }
            function qt(gr, Ar) {
              const Sr = Ut(gr.huffmanTableDC), Br = Sr === 0 ? 0 : Qt(Sr);
              gr.blockData[Ar] = gr.pred += Br;
              let Ir = 1;
              for (; Ir < 64; ) {
                const hr = Ut(gr.huffmanTableAC), vr = hr & 15, xr = hr >> 4;
                if (vr === 0) {
                  if (xr < 15)
                    break;
                  Ir += 16;
                  continue;
                }
                Ir += xr;
                const Pr = ft[Ir];
                gr.blockData[Ar + Pr] = Qt(vr), Ir++;
              }
            }
            function Zt(gr, Ar) {
              const Sr = Ut(gr.huffmanTableDC), Br = Sr === 0 ? 0 : Qt(Sr) << Ft;
              gr.blockData[Ar] = gr.pred += Br;
            }
            function ar(gr, Ar) {
              gr.blockData[Ar] |= Dt() << Ft;
            }
            let Jt = 0;
            function rr(gr, Ar) {
              if (Jt > 0) {
                Jt--;
                return;
              }
              let Sr = kt;
              const Br = jt;
              for (; Sr <= Br; ) {
                const Ir = Ut(gr.huffmanTableAC), hr = Ir & 15, vr = Ir >> 4;
                if (hr === 0) {
                  if (vr < 15) {
                    Jt = Vt(vr) + (1 << vr) - 1;
                    break;
                  }
                  Sr += 16;
                  continue;
                }
                Sr += vr;
                const xr = ft[Sr];
                gr.blockData[Ar + xr] = Qt(hr) * (1 << Ft), Sr++;
              }
            }
            let Yt = 0, Kt;
            function nr(gr, Ar) {
              let Sr = kt;
              const Br = jt;
              let Ir = 0, hr, vr;
              for (; Sr <= Br; ) {
                const xr = Ar + ft[Sr], Pr = gr.blockData[xr] < 0 ? -1 : 1;
                switch (Yt) {
                  case 0:
                    if (vr = Ut(gr.huffmanTableAC), hr = vr & 15, Ir = vr >> 4, hr === 0)
                      Ir < 15 ? (Jt = Vt(Ir) + (1 << Ir), Yt = 4) : (Ir = 16, Yt = 1);
                    else {
                      if (hr !== 1)
                        throw new et("invalid ACn encoding");
                      Kt = Qt(hr), Yt = Ir ? 2 : 3;
                    }
                    continue;
                  case 1:
                  case 2:
                    gr.blockData[xr] ? gr.blockData[xr] += Pr * (Dt() << Ft) : (Ir--, Ir === 0 && (Yt = Yt === 2 ? 3 : 0));
                    break;
                  case 3:
                    gr.blockData[xr] ? gr.blockData[xr] += Pr * (Dt() << Ft) : (gr.blockData[xr] = Kt << Ft, Yt = 0);
                    break;
                  case 4:
                    gr.blockData[xr] && (gr.blockData[xr] += Pr * (Dt() << Ft));
                    break;
                }
                Sr++;
              }
              Yt === 4 && (Jt--, Jt === 0 && (Yt = 0));
            }
            let tr = 0;
            function ir(gr, Ar, Sr, Br, Ir) {
              const hr = Sr / Nt | 0, vr = Sr % Nt;
              tr = hr * gr.v + Br;
              const xr = vr * gr.h + Ir, Pr = bt(gr, tr, xr);
              Ar(gr, Pr);
            }
            function sr(gr, Ar, Sr) {
              tr = Sr / gr.blocksPerLine | 0;
              const Br = Sr % gr.blocksPerLine, Ir = bt(gr, tr, Br);
              Ar(gr, Ir);
            }
            const cr = yt.length;
            let or, Xt, Gt, Wt, er, lr;
            Mt ? kt === 0 ? lr = Ht === 0 ? Zt : ar : lr = Ht === 0 ? rr : nr : lr = qt;
            let ur = 0, pr;
            const yr = cr === 1 ? yt[0].blocksPerLine * yt[0].blocksPerColumn : Nt * It.mcusPerColumn;
            let Er, br;
            for (; ur <= yr; ) {
              const gr = Rt ? Math.min(yr - ur, Rt) : yr;
              if (gr > 0) {
                for (Xt = 0; Xt < cr; Xt++)
                  yt[Xt].pred = 0;
                if (Jt = 0, cr === 1)
                  for (or = yt[0], er = 0; er < gr; er++)
                    sr(or, lr, ur), ur++;
                else
                  for (er = 0; er < gr; er++) {
                    for (Xt = 0; Xt < cr; Xt++)
                      for (or = yt[Xt], Er = or.h, br = or.v, Gt = 0; Gt < br; Gt++)
                        for (Wt = 0; Wt < Er; Wt++)
                          ir(or, lr, ur, Gt, Wt);
                    ur++;
                  }
              }
              if (Tt = 0, pr = Ot(wt, Ct), !pr)
                break;
              if (pr.invalid) {
                const Ar = gr > 0 ? "unexpected" : "excessive";
                (0, rt.warn)(`decodeScan - ${Ar} MCU data, current marker is: ${pr.invalid}`), Ct = pr.offset;
              }
              if (pr.marker >= 65488 && pr.marker <= 65495)
                Ct += 2;
              else
                break;
            }
            return Ct - Lt;
          }
          function St(wt, Ct, It) {
            const yt = wt.quantizationTable, Rt = wt.blockData;
            let kt, jt, Ht, Ft, _t, Nt, Mt, Lt, $t, Tt, Dt, Ut, Vt, Qt, qt, Zt, ar;
            if (!yt)
              throw new et("missing required Quantization Table.");
            for (let Jt = 0; Jt < 64; Jt += 8) {
              if ($t = Rt[Ct + Jt], Tt = Rt[Ct + Jt + 1], Dt = Rt[Ct + Jt + 2], Ut = Rt[Ct + Jt + 3], Vt = Rt[Ct + Jt + 4], Qt = Rt[Ct + Jt + 5], qt = Rt[Ct + Jt + 6], Zt = Rt[Ct + Jt + 7], $t *= yt[Jt], !(Tt | Dt | Ut | Vt | Qt | qt | Zt)) {
                ar = vt * $t + 512 >> 10, It[Jt] = ar, It[Jt + 1] = ar, It[Jt + 2] = ar, It[Jt + 3] = ar, It[Jt + 4] = ar, It[Jt + 5] = ar, It[Jt + 6] = ar, It[Jt + 7] = ar;
                continue;
              }
              Tt *= yt[Jt + 1], Dt *= yt[Jt + 2], Ut *= yt[Jt + 3], Vt *= yt[Jt + 4], Qt *= yt[Jt + 5], qt *= yt[Jt + 6], Zt *= yt[Jt + 7], kt = vt * $t + 128 >> 8, jt = vt * Vt + 128 >> 8, Ht = Dt, Ft = qt, _t = At * (Tt - Zt) + 128 >> 8, Lt = At * (Tt + Zt) + 128 >> 8, Nt = Ut << 4, Mt = Qt << 4, kt = kt + jt + 1 >> 1, jt = kt - jt, ar = Ht * ct + Ft * mt + 128 >> 8, Ht = Ht * mt - Ft * ct + 128 >> 8, Ft = ar, _t = _t + Mt + 1 >> 1, Mt = _t - Mt, Lt = Lt + Nt + 1 >> 1, Nt = Lt - Nt, kt = kt + Ft + 1 >> 1, Ft = kt - Ft, jt = jt + Ht + 1 >> 1, Ht = jt - Ht, ar = _t * pt + Lt * gt + 2048 >> 12, _t = _t * gt - Lt * pt + 2048 >> 12, Lt = ar, ar = Nt * dt + Mt * ht + 2048 >> 12, Nt = Nt * ht - Mt * dt + 2048 >> 12, Mt = ar, It[Jt] = kt + Lt, It[Jt + 7] = kt - Lt, It[Jt + 1] = jt + Mt, It[Jt + 6] = jt - Mt, It[Jt + 2] = Ht + Nt, It[Jt + 5] = Ht - Nt, It[Jt + 3] = Ft + _t, It[Jt + 4] = Ft - _t;
            }
            for (let Jt = 0; Jt < 8; ++Jt) {
              if ($t = It[Jt], Tt = It[Jt + 8], Dt = It[Jt + 16], Ut = It[Jt + 24], Vt = It[Jt + 32], Qt = It[Jt + 40], qt = It[Jt + 48], Zt = It[Jt + 56], !(Tt | Dt | Ut | Vt | Qt | qt | Zt)) {
                ar = vt * $t + 8192 >> 14, ar < -2040 ? ar = 0 : ar >= 2024 ? ar = 255 : ar = ar + 2056 >> 4, Rt[Ct + Jt] = ar, Rt[Ct + Jt + 8] = ar, Rt[Ct + Jt + 16] = ar, Rt[Ct + Jt + 24] = ar, Rt[Ct + Jt + 32] = ar, Rt[Ct + Jt + 40] = ar, Rt[Ct + Jt + 48] = ar, Rt[Ct + Jt + 56] = ar;
                continue;
              }
              kt = vt * $t + 2048 >> 12, jt = vt * Vt + 2048 >> 12, Ht = Dt, Ft = qt, _t = At * (Tt - Zt) + 2048 >> 12, Lt = At * (Tt + Zt) + 2048 >> 12, Nt = Ut, Mt = Qt, kt = (kt + jt + 1 >> 1) + 4112, jt = kt - jt, ar = Ht * ct + Ft * mt + 2048 >> 12, Ht = Ht * mt - Ft * ct + 2048 >> 12, Ft = ar, _t = _t + Mt + 1 >> 1, Mt = _t - Mt, Lt = Lt + Nt + 1 >> 1, Nt = Lt - Nt, kt = kt + Ft + 1 >> 1, Ft = kt - Ft, jt = jt + Ht + 1 >> 1, Ht = jt - Ht, ar = _t * pt + Lt * gt + 2048 >> 12, _t = _t * gt - Lt * pt + 2048 >> 12, Lt = ar, ar = Nt * dt + Mt * ht + 2048 >> 12, Nt = Nt * ht - Mt * dt + 2048 >> 12, Mt = ar, $t = kt + Lt, Zt = kt - Lt, Tt = jt + Mt, qt = jt - Mt, Dt = Ht + Nt, Qt = Ht - Nt, Ut = Ft + _t, Vt = Ft - _t, $t < 16 ? $t = 0 : $t >= 4080 ? $t = 255 : $t >>= 4, Tt < 16 ? Tt = 0 : Tt >= 4080 ? Tt = 255 : Tt >>= 4, Dt < 16 ? Dt = 0 : Dt >= 4080 ? Dt = 255 : Dt >>= 4, Ut < 16 ? Ut = 0 : Ut >= 4080 ? Ut = 255 : Ut >>= 4, Vt < 16 ? Vt = 0 : Vt >= 4080 ? Vt = 255 : Vt >>= 4, Qt < 16 ? Qt = 0 : Qt >= 4080 ? Qt = 255 : Qt >>= 4, qt < 16 ? qt = 0 : qt >= 4080 ? qt = 255 : qt >>= 4, Zt < 16 ? Zt = 0 : Zt >= 4080 ? Zt = 255 : Zt >>= 4, Rt[Ct + Jt] = $t, Rt[Ct + Jt + 8] = Tt, Rt[Ct + Jt + 16] = Dt, Rt[Ct + Jt + 24] = Ut, Rt[Ct + Jt + 32] = Vt, Rt[Ct + Jt + 40] = Qt, Rt[Ct + Jt + 48] = qt, Rt[Ct + Jt + 56] = Zt;
            }
          }
          function Bt(wt, Ct) {
            const It = Ct.blocksPerLine, yt = Ct.blocksPerColumn, Rt = new Int16Array(64);
            for (let kt = 0; kt < yt; kt++)
              for (let jt = 0; jt < It; jt++) {
                const Ht = bt(Ct, kt, jt);
                St(Ct, Ht, Rt);
              }
            return Ct.blockData;
          }
          function Ot(wt, Ct) {
            let It = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ct;
            const yt = wt.length - 1;
            let Rt = It < Ct ? It : Ct;
            if (Ct >= yt)
              return null;
            const kt = (0, lt.readUint16)(wt, Ct);
            if (kt >= 65472 && kt <= 65534)
              return {
                invalid: null,
                marker: kt,
                offset: Ct
              };
            let jt = (0, lt.readUint16)(wt, Rt);
            for (; !(jt >= 65472 && jt <= 65534); ) {
              if (++Rt >= yt)
                return null;
              jt = (0, lt.readUint16)(wt, Rt);
            }
            return {
              invalid: kt.toString(16),
              marker: jt,
              offset: Rt
            };
          }
          class Pt {
            constructor() {
              let {
                decodeTransform: Ct = null,
                colorTransform: It = -1
              } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              this._decodeTransform = Ct, this._colorTransform = It;
            }
            parse(Ct) {
              let {
                dnlScanLines: It = null
              } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              function yt() {
                const Dt = (0, lt.readUint16)(Ct, kt);
                kt += 2;
                let Ut = kt + Dt - 2;
                const Vt = Ot(Ct, Ut, kt);
                Vt != null && Vt.invalid && ((0, rt.warn)("readDataBlock - incorrect length, current marker is: " + Vt.invalid), Ut = Vt.offset);
                const Qt = Ct.subarray(kt, Ut);
                return kt += Qt.length, Qt;
              }
              function Rt(Dt) {
                const Ut = Math.ceil(Dt.samplesPerLine / 8 / Dt.maxH), Vt = Math.ceil(Dt.scanLines / 8 / Dt.maxV);
                for (const Qt of Dt.components) {
                  const qt = Math.ceil(Math.ceil(Dt.samplesPerLine / 8) * Qt.h / Dt.maxH), Zt = Math.ceil(Math.ceil(Dt.scanLines / 8) * Qt.v / Dt.maxV), ar = Ut * Qt.h, rr = 64 * (Vt * Qt.v) * (ar + 1);
                  Qt.blockData = new Int16Array(rr), Qt.blocksPerLine = qt, Qt.blocksPerColumn = Zt;
                }
                Dt.mcusPerLine = Ut, Dt.mcusPerColumn = Vt;
              }
              let kt = 0, jt = null, Ht = null, Ft, _t, Nt = 0;
              const Mt = [], Lt = [], $t = [];
              let Tt = (0, lt.readUint16)(Ct, kt);
              if (kt += 2, Tt !== 65496)
                throw new et("SOI not found");
              Tt = (0, lt.readUint16)(Ct, kt), kt += 2;
              e:
                for (; Tt !== 65497; ) {
                  let Dt, Ut, Vt;
                  switch (Tt) {
                    case 65504:
                    case 65505:
                    case 65506:
                    case 65507:
                    case 65508:
                    case 65509:
                    case 65510:
                    case 65511:
                    case 65512:
                    case 65513:
                    case 65514:
                    case 65515:
                    case 65516:
                    case 65517:
                    case 65518:
                    case 65519:
                    case 65534:
                      const Qt = yt();
                      Tt === 65504 && Qt[0] === 74 && Qt[1] === 70 && Qt[2] === 73 && Qt[3] === 70 && Qt[4] === 0 && (jt = {
                        version: {
                          major: Qt[5],
                          minor: Qt[6]
                        },
                        densityUnits: Qt[7],
                        xDensity: Qt[8] << 8 | Qt[9],
                        yDensity: Qt[10] << 8 | Qt[11],
                        thumbWidth: Qt[12],
                        thumbHeight: Qt[13],
                        thumbData: Qt.subarray(14, 14 + 3 * Qt[12] * Qt[13])
                      }), Tt === 65518 && Qt[0] === 65 && Qt[1] === 100 && Qt[2] === 111 && Qt[3] === 98 && Qt[4] === 101 && (Ht = {
                        version: Qt[5] << 8 | Qt[6],
                        flags0: Qt[7] << 8 | Qt[8],
                        flags1: Qt[9] << 8 | Qt[10],
                        transformCode: Qt[11]
                      });
                      break;
                    case 65499:
                      const qt = (0, lt.readUint16)(Ct, kt);
                      kt += 2;
                      const Zt = qt + kt - 2;
                      let ar;
                      for (; kt < Zt; ) {
                        const Wt = Ct[kt++], er = new Uint16Array(64);
                        if (Wt >> 4)
                          if (Wt >> 4 === 1)
                            for (Ut = 0; Ut < 64; Ut++)
                              ar = ft[Ut], er[ar] = (0, lt.readUint16)(Ct, kt), kt += 2;
                          else
                            throw new et("DQT - invalid table spec");
                        else
                          for (Ut = 0; Ut < 64; Ut++)
                            ar = ft[Ut], er[ar] = Ct[kt++];
                        Mt[Wt & 15] = er;
                      }
                      break;
                    case 65472:
                    case 65473:
                    case 65474:
                      if (Ft)
                        throw new et("Only single frame JPEGs supported");
                      kt += 2, Ft = {}, Ft.extended = Tt === 65473, Ft.progressive = Tt === 65474, Ft.precision = Ct[kt++];
                      const Jt = (0, lt.readUint16)(Ct, kt);
                      kt += 2, Ft.scanLines = It || Jt, Ft.samplesPerLine = (0, lt.readUint16)(Ct, kt), kt += 2, Ft.components = [], Ft.componentIds = {};
                      const rr = Ct[kt++];
                      let Yt = 0, Kt = 0;
                      for (Dt = 0; Dt < rr; Dt++) {
                        const Wt = Ct[kt], er = Ct[kt + 1] >> 4, lr = Ct[kt + 1] & 15;
                        Yt < er && (Yt = er), Kt < lr && (Kt = lr);
                        const ur = Ct[kt + 2];
                        Vt = Ft.components.push({
                          h: er,
                          v: lr,
                          quantizationId: ur,
                          quantizationTable: null
                        }), Ft.componentIds[Wt] = Vt - 1, kt += 3;
                      }
                      Ft.maxH = Yt, Ft.maxV = Kt, Rt(Ft);
                      break;
                    case 65476:
                      const nr = (0, lt.readUint16)(Ct, kt);
                      for (kt += 2, Dt = 2; Dt < nr; ) {
                        const Wt = Ct[kt++], er = new Uint8Array(16);
                        let lr = 0;
                        for (Ut = 0; Ut < 16; Ut++, kt++)
                          lr += er[Ut] = Ct[kt];
                        const ur = new Uint8Array(lr);
                        for (Ut = 0; Ut < lr; Ut++, kt++)
                          ur[Ut] = Ct[kt];
                        Dt += 17 + lr, (Wt >> 4 ? Lt : $t)[Wt & 15] = xt(er, ur);
                      }
                      break;
                    case 65501:
                      kt += 2, _t = (0, lt.readUint16)(Ct, kt), kt += 2;
                      break;
                    case 65498:
                      const tr = ++Nt === 1 && !It;
                      kt += 2;
                      const ir = Ct[kt++], sr = [];
                      for (Dt = 0; Dt < ir; Dt++) {
                        const Wt = Ct[kt++], er = Ft.componentIds[Wt], lr = Ft.components[er];
                        lr.index = Wt;
                        const ur = Ct[kt++];
                        lr.huffmanTableDC = $t[ur >> 4], lr.huffmanTableAC = Lt[ur & 15], sr.push(lr);
                      }
                      const cr = Ct[kt++], or = Ct[kt++], Xt = Ct[kt++];
                      try {
                        const Wt = Et(Ct, kt, Ft, sr, _t, cr, or, Xt >> 4, Xt & 15, tr);
                        kt += Wt;
                      } catch (Wt) {
                        if (Wt instanceof it)
                          return (0, rt.warn)(`${Wt.message} -- attempting to re-parse the JPEG image.`), this.parse(Ct, {
                            dnlScanLines: Wt.scanLines
                          });
                        if (Wt instanceof ut) {
                          (0, rt.warn)(`${Wt.message} -- ignoring the rest of the image data.`);
                          break e;
                        }
                        throw Wt;
                      }
                      break;
                    case 65500:
                      kt += 4;
                      break;
                    case 65535:
                      Ct[kt] !== 255 && kt--;
                      break;
                    default:
                      const Gt = Ot(Ct, kt - 2, kt - 3);
                      if (Gt != null && Gt.invalid) {
                        (0, rt.warn)("JpegImage.parse - unexpected data, current marker is: " + Gt.invalid), kt = Gt.offset;
                        break;
                      }
                      if (!Gt || kt >= Ct.length - 1) {
                        (0, rt.warn)("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
                        break e;
                      }
                      throw new et("JpegImage.parse - unknown marker: " + Tt.toString(16));
                  }
                  Tt = (0, lt.readUint16)(Ct, kt), kt += 2;
                }
              this.width = Ft.samplesPerLine, this.height = Ft.scanLines, this.jfif = jt, this.adobe = Ht, this.components = [];
              for (const Dt of Ft.components) {
                const Ut = Mt[Dt.quantizationId];
                Ut && (Dt.quantizationTable = Ut), this.components.push({
                  index: Dt.index,
                  output: Bt(Ft, Dt),
                  scaleX: Dt.h / Ft.maxH,
                  scaleY: Dt.v / Ft.maxV,
                  blocksPerLine: Dt.blocksPerLine,
                  blocksPerColumn: Dt.blocksPerColumn
                });
              }
              this.numComponents = this.components.length;
            }
            _getLinearizedBlockData(Ct, It) {
              let yt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
              const Rt = this.width / Ct, kt = this.height / It;
              let jt, Ht, Ft, _t, Nt, Mt, Lt, $t, Tt, Dt, Ut = 0, Vt;
              const Qt = this.components.length, qt = Ct * It * Qt, Zt = new Uint8ClampedArray(qt), ar = new Uint32Array(Ct), Jt = 4294967288;
              let rr;
              for (Lt = 0; Lt < Qt; Lt++) {
                if (jt = this.components[Lt], Ht = jt.scaleX * Rt, Ft = jt.scaleY * kt, Ut = Lt, Vt = jt.output, _t = jt.blocksPerLine + 1 << 3, Ht !== rr) {
                  for (Nt = 0; Nt < Ct; Nt++)
                    $t = 0 | Nt * Ht, ar[Nt] = ($t & Jt) << 3 | $t & 7;
                  rr = Ht;
                }
                for (Mt = 0; Mt < It; Mt++)
                  for ($t = 0 | Mt * Ft, Dt = _t * ($t & Jt) | ($t & 7) << 3, Nt = 0; Nt < Ct; Nt++)
                    Zt[Ut] = Vt[Dt + ar[Nt]], Ut += Qt;
              }
              let Yt = this._decodeTransform;
              if (!yt && Qt === 4 && !Yt && (Yt = new Int32Array([-256, 255, -256, 255, -256, 255, -256, 255])), Yt)
                for (Lt = 0; Lt < qt; )
                  for ($t = 0, Tt = 0; $t < Qt; $t++, Lt++, Tt += 2)
                    Zt[Lt] = (Zt[Lt] * Yt[Tt] >> 8) + Yt[Tt + 1];
              return Zt;
            }
            get _isColorConversionNeeded() {
              return this.adobe ? !!this.adobe.transformCode : this.numComponents === 3 ? this._colorTransform === 0 ? !1 : !(this.components[0].index === 82 && this.components[1].index === 71 && this.components[2].index === 66) : this._colorTransform === 1;
            }
            _convertYccToRgb(Ct) {
              let It, yt, Rt;
              for (let kt = 0, jt = Ct.length; kt < jt; kt += 3)
                It = Ct[kt], yt = Ct[kt + 1], Rt = Ct[kt + 2], Ct[kt] = It - 179.456 + 1.402 * Rt, Ct[kt + 1] = It + 135.459 - 0.344 * yt - 0.714 * Rt, Ct[kt + 2] = It - 226.816 + 1.772 * yt;
              return Ct;
            }
            _convertYccToRgba(Ct, It) {
              for (let yt = 0, Rt = 0, kt = Ct.length; yt < kt; yt += 3, Rt += 4) {
                const jt = Ct[yt], Ht = Ct[yt + 1], Ft = Ct[yt + 2];
                It[Rt] = jt - 179.456 + 1.402 * Ft, It[Rt + 1] = jt + 135.459 - 0.344 * Ht - 0.714 * Ft, It[Rt + 2] = jt - 226.816 + 1.772 * Ht, It[Rt + 3] = 255;
              }
              return It;
            }
            _convertYcckToRgb(Ct) {
              let It, yt, Rt, kt, jt = 0;
              for (let Ht = 0, Ft = Ct.length; Ht < Ft; Ht += 4)
                It = Ct[Ht], yt = Ct[Ht + 1], Rt = Ct[Ht + 2], kt = Ct[Ht + 3], Ct[jt++] = -122.67195406894 + yt * (-660635669420364e-19 * yt + 437130475926232e-18 * Rt - 54080610064599e-18 * It + 48449797120281e-17 * kt - 0.154362151871126) + Rt * (-957964378445773e-18 * Rt + 817076911346625e-18 * It - 0.00477271405408747 * kt + 1.53380253221734) + It * (961250184130688e-18 * It - 0.00266257332283933 * kt + 0.48357088451265) + kt * (-336197177618394e-18 * kt + 0.484791561490776), Ct[jt++] = 107.268039397724 + yt * (219927104525741e-19 * yt - 640992018297945e-18 * Rt + 659397001245577e-18 * It + 426105652938837e-18 * kt - 0.176491792462875) + Rt * (-778269941513683e-18 * Rt + 0.00130872261408275 * It + 770482631801132e-18 * kt - 0.151051492775562) + It * (0.00126935368114843 * It - 0.00265090189010898 * kt + 0.25802910206845) + kt * (-318913117588328e-18 * kt - 0.213742400323665), Ct[jt++] = -20.810012546947 + yt * (-570115196973677e-18 * yt - 263409051004589e-19 * Rt + 0.0020741088115012 * It - 0.00288260236853442 * kt + 0.814272968359295) + Rt * (-153496057440975e-19 * Rt - 132689043961446e-18 * It + 560833691242812e-18 * kt - 0.195152027534049) + It * (0.00174418132927582 * It - 0.00255243321439347 * kt + 0.116935020465145) + kt * (-343531996510555e-18 * kt + 0.24165260232407);
              return Ct.subarray(0, jt);
            }
            _convertYcckToRgba(Ct) {
              for (let It = 0, yt = Ct.length; It < yt; It += 4) {
                const Rt = Ct[It], kt = Ct[It + 1], jt = Ct[It + 2], Ht = Ct[It + 3];
                Ct[It] = -122.67195406894 + kt * (-660635669420364e-19 * kt + 437130475926232e-18 * jt - 54080610064599e-18 * Rt + 48449797120281e-17 * Ht - 0.154362151871126) + jt * (-957964378445773e-18 * jt + 817076911346625e-18 * Rt - 0.00477271405408747 * Ht + 1.53380253221734) + Rt * (961250184130688e-18 * Rt - 0.00266257332283933 * Ht + 0.48357088451265) + Ht * (-336197177618394e-18 * Ht + 0.484791561490776), Ct[It + 1] = 107.268039397724 + kt * (219927104525741e-19 * kt - 640992018297945e-18 * jt + 659397001245577e-18 * Rt + 426105652938837e-18 * Ht - 0.176491792462875) + jt * (-778269941513683e-18 * jt + 0.00130872261408275 * Rt + 770482631801132e-18 * Ht - 0.151051492775562) + Rt * (0.00126935368114843 * Rt - 0.00265090189010898 * Ht + 0.25802910206845) + Ht * (-318913117588328e-18 * Ht - 0.213742400323665), Ct[It + 2] = -20.810012546947 + kt * (-570115196973677e-18 * kt - 263409051004589e-19 * jt + 0.0020741088115012 * Rt - 0.00288260236853442 * Ht + 0.814272968359295) + jt * (-153496057440975e-19 * jt - 132689043961446e-18 * Rt + 560833691242812e-18 * Ht - 0.195152027534049) + Rt * (0.00174418132927582 * Rt - 0.00255243321439347 * Ht + 0.116935020465145) + Ht * (-343531996510555e-18 * Ht + 0.24165260232407), Ct[It + 3] = 255;
              }
              return Ct;
            }
            _convertYcckToCmyk(Ct) {
              let It, yt, Rt;
              for (let kt = 0, jt = Ct.length; kt < jt; kt += 4)
                It = Ct[kt], yt = Ct[kt + 1], Rt = Ct[kt + 2], Ct[kt] = 434.456 - It - 1.402 * Rt, Ct[kt + 1] = 119.541 - It + 0.344 * yt + 0.714 * Rt, Ct[kt + 2] = 481.816 - It - 1.772 * yt;
              return Ct;
            }
            _convertCmykToRgb(Ct) {
              let It, yt, Rt, kt, jt = 0;
              for (let Ht = 0, Ft = Ct.length; Ht < Ft; Ht += 4)
                It = Ct[Ht], yt = Ct[Ht + 1], Rt = Ct[Ht + 2], kt = Ct[Ht + 3], Ct[jt++] = 255 + It * (-6747147073602441e-20 * It + 8379262121013727e-19 * yt + 2894718188643294e-19 * Rt + 0.003264231057537806 * kt - 1.1185611867203937) + yt * (26374107616089405e-21 * yt - 8626949158638572e-20 * Rt - 2748769067499491e-19 * kt - 0.02155688794978967) + Rt * (-3878099212869363e-20 * Rt - 3267808279485286e-19 * kt + 0.0686742238595345) - kt * (3361971776183937e-19 * kt + 0.7430659151342254), Ct[jt++] = 255 + It * (13596372813588848e-20 * It + 924537132573585e-18 * yt + 10567359618683593e-20 * Rt + 4791864687436512e-19 * kt - 0.3109689587515875) + yt * (-23545346108370344e-20 * yt + 2702845253534714e-19 * Rt + 0.0020200308977307156 * kt - 0.7488052167015494) + Rt * (6834815998235662e-20 * Rt + 15168452363460973e-20 * kt - 0.09751927774728933) - kt * (3189131175883281e-19 * kt + 0.7364883807733168), Ct[jt++] = 255 + It * (13598650411385307e-21 * It + 12423956175490851e-20 * yt + 4751985097583589e-19 * Rt - 36729317476630422e-22 * kt - 0.05562186980264034) + yt * (16141380598724676e-20 * yt + 9692239130725186e-19 * Rt + 7782692450036253e-19 * kt - 0.44015232367526463) + Rt * (5068882914068769e-22 * Rt + 0.0017778369011375071 * kt - 0.7591454649749609) - kt * (3435319965105553e-19 * kt + 0.7063770186160144);
              return Ct.subarray(0, jt);
            }
            _convertCmykToRgba(Ct) {
              for (let It = 0, yt = Ct.length; It < yt; It += 4) {
                const Rt = Ct[It], kt = Ct[It + 1], jt = Ct[It + 2], Ht = Ct[It + 3];
                Ct[It] = 255 + Rt * (-6747147073602441e-20 * Rt + 8379262121013727e-19 * kt + 2894718188643294e-19 * jt + 0.003264231057537806 * Ht - 1.1185611867203937) + kt * (26374107616089405e-21 * kt - 8626949158638572e-20 * jt - 2748769067499491e-19 * Ht - 0.02155688794978967) + jt * (-3878099212869363e-20 * jt - 3267808279485286e-19 * Ht + 0.0686742238595345) - Ht * (3361971776183937e-19 * Ht + 0.7430659151342254), Ct[It + 1] = 255 + Rt * (13596372813588848e-20 * Rt + 924537132573585e-18 * kt + 10567359618683593e-20 * jt + 4791864687436512e-19 * Ht - 0.3109689587515875) + kt * (-23545346108370344e-20 * kt + 2702845253534714e-19 * jt + 0.0020200308977307156 * Ht - 0.7488052167015494) + jt * (6834815998235662e-20 * jt + 15168452363460973e-20 * Ht - 0.09751927774728933) - Ht * (3189131175883281e-19 * Ht + 0.7364883807733168), Ct[It + 2] = 255 + Rt * (13598650411385307e-21 * Rt + 12423956175490851e-20 * kt + 4751985097583589e-19 * jt - 36729317476630422e-22 * Ht - 0.05562186980264034) + kt * (16141380598724676e-20 * kt + 9692239130725186e-19 * jt + 7782692450036253e-19 * Ht - 0.44015232367526463) + jt * (5068882914068769e-22 * jt + 0.0017778369011375071 * Ht - 0.7591454649749609) - Ht * (3435319965105553e-19 * Ht + 0.7063770186160144), Ct[It + 3] = 255;
              }
              return Ct;
            }
            getData(Ct) {
              let {
                width: It,
                height: yt,
                forceRGBA: Rt = !1,
                forceRGB: kt = !1,
                isSourcePDF: jt = !1
              } = Ct;
              if (this.numComponents > 4)
                throw new et("Unsupported color mode");
              const Ht = this._getLinearizedBlockData(It, yt, jt);
              if (this.numComponents === 1 && (Rt || kt)) {
                const Ft = Ht.length * (Rt ? 4 : 3), _t = new Uint8ClampedArray(Ft);
                let Nt = 0;
                if (Rt)
                  (0, st.grayToRGBA)(Ht, new Uint32Array(_t.buffer));
                else
                  for (const Mt of Ht)
                    _t[Nt++] = Mt, _t[Nt++] = Mt, _t[Nt++] = Mt;
                return _t;
              } else if (this.numComponents === 3 && this._isColorConversionNeeded) {
                if (Rt) {
                  const Ft = new Uint8ClampedArray(Ht.length / 3 * 4);
                  return this._convertYccToRgba(Ht, Ft);
                }
                return this._convertYccToRgb(Ht);
              } else if (this.numComponents === 4) {
                if (this._isColorConversionNeeded)
                  return Rt ? this._convertYcckToRgba(Ht) : kt ? this._convertYcckToRgb(Ht) : this._convertYcckToCmyk(Ht);
                if (Rt)
                  return this._convertCmykToRgba(Ht);
                if (kt)
                  return this._convertCmykToRgb(Ht);
              }
              return Ht;
            }
          }
          at.JpegImage = Pt;
        },
        /* 179 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.convertBlackAndWhiteToRGBA = lt, at.convertToRGBA = st, at.grayToRGBA = it, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(145);
          function st(ut) {
            switch (ut.kind) {
              case rt.ImageKind.GRAYSCALE_1BPP:
                return lt(ut);
              case rt.ImageKind.RGB_24BPP:
                return et(ut);
            }
            return null;
          }
          function lt(ut) {
            let {
              src: ft,
              srcPos: ht = 0,
              dest: dt,
              width: gt,
              height: pt,
              nonBlackColor: mt = 4294967295,
              inverseDecode: ct = !1
            } = ut;
            const vt = rt.FeatureTest.isLittleEndian ? 4278190080 : 255, [At, xt] = ct ? [mt, vt] : [vt, mt], bt = gt >> 3, Et = gt & 7, St = ft.length;
            dt = new Uint32Array(dt.buffer);
            let Bt = 0;
            for (let Ot = 0; Ot < pt; Ot++) {
              for (const wt = ht + bt; ht < wt; ht++) {
                const Ct = ht < St ? ft[ht] : 255;
                dt[Bt++] = Ct & 128 ? xt : At, dt[Bt++] = Ct & 64 ? xt : At, dt[Bt++] = Ct & 32 ? xt : At, dt[Bt++] = Ct & 16 ? xt : At, dt[Bt++] = Ct & 8 ? xt : At, dt[Bt++] = Ct & 4 ? xt : At, dt[Bt++] = Ct & 2 ? xt : At, dt[Bt++] = Ct & 1 ? xt : At;
              }
              if (Et === 0)
                continue;
              const Pt = ht < St ? ft[ht++] : 255;
              for (let wt = 0; wt < Et; wt++)
                dt[Bt++] = Pt & 1 << 7 - wt ? xt : At;
            }
            return {
              srcPos: ht,
              destPos: Bt
            };
          }
          function et(ut) {
            let {
              src: ft,
              srcPos: ht = 0,
              dest: dt,
              destPos: gt = 0,
              width: pt,
              height: mt
            } = ut, ct = 0;
            const vt = ft.length >> 2, At = new Uint32Array(ft.buffer, ht, vt);
            if (rt.FeatureTest.isLittleEndian) {
              for (; ct < vt - 2; ct += 3, gt += 4) {
                const xt = At[ct], bt = At[ct + 1], Et = At[ct + 2];
                dt[gt] = xt | 4278190080, dt[gt + 1] = xt >>> 24 | bt << 8 | 4278190080, dt[gt + 2] = bt >>> 16 | Et << 16 | 4278190080, dt[gt + 3] = Et >>> 8 | 4278190080;
              }
              for (let xt = ct * 4, bt = ft.length; xt < bt; xt += 3)
                dt[gt++] = ft[xt] | ft[xt + 1] << 8 | ft[xt + 2] << 16 | 4278190080;
            } else {
              for (; ct < vt - 2; ct += 3, gt += 4) {
                const xt = At[ct], bt = At[ct + 1], Et = At[ct + 2];
                dt[gt] = xt | 255, dt[gt + 1] = xt << 24 | bt >>> 8 | 255, dt[gt + 2] = bt << 16 | Et >>> 16 | 255, dt[gt + 3] = Et << 8 | 255;
              }
              for (let xt = ct * 4, bt = ft.length; xt < bt; xt += 3)
                dt[gt++] = ft[xt] << 24 | ft[xt + 1] << 16 | ft[xt + 2] << 8 | 255;
            }
            return {
              srcPos: ht,
              destPos: gt
            };
          }
          function it(ut, ft) {
            if (rt.FeatureTest.isLittleEndian)
              for (let ht = 0, dt = ut.length; ht < dt; ht++)
                ft[ht] = ut[ht] * 65793 | 4278190080;
            else
              for (let ht = 0, dt = ut.length; ht < dt; ht++)
                ft[ht] = ut[ht] * 16843008 | 255;
          }
        },
        /* 180 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.JpxStream = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(169), st = ot(181), lt = ot(145);
          class et extends rt.DecodeStream {
            constructor(ut, ft, ht) {
              super(ft), this.stream = ut, this.dict = ut.dict, this.maybeLength = ft, this.params = ht;
            }
            get bytes() {
              return (0, lt.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
            }
            ensureBuffer(ut) {
            }
            readBlock() {
              if (this.eof)
                return;
              const ut = new st.JpxImage();
              ut.parse(this.bytes);
              const ft = ut.width, ht = ut.height, dt = ut.componentsCount, gt = ut.tiles.length;
              if (gt === 1)
                this.buffer = ut.tiles[0].items;
              else {
                const pt = new Uint8ClampedArray(ft * ht * dt);
                for (let mt = 0; mt < gt; mt++) {
                  const ct = ut.tiles[mt], vt = ct.width, At = ct.height, xt = ct.left, bt = ct.top, Et = ct.items;
                  let St = 0, Bt = (ft * bt + xt) * dt;
                  const Ot = ft * dt, Pt = vt * dt;
                  for (let wt = 0; wt < At; wt++) {
                    const Ct = Et.subarray(St, St + Pt);
                    pt.set(Ct, Bt), St += Pt, Bt += Ot;
                  }
                }
                this.buffer = pt;
              }
              this.bufferLength = this.buffer.length, this.eof = !0;
            }
          }
          at.JpxStream = et;
        },
        /* 181 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.JpxImage = void 0, ot(140), ot(2), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(145), st = ot(150), lt = ot(176);
          class et extends rt.BaseException {
            constructor(Mt) {
              super(`JPX error: ${Mt}`, "JpxError");
            }
          }
          const it = {
            LL: 0,
            LH: 1,
            HL: 1,
            HH: 2
          };
          class ut {
            constructor() {
              this.failOnCorruptedImage = !1;
            }
            parse(Mt) {
              if ((0, st.readUint16)(Mt, 0) === 65359) {
                this.parseCodestream(Mt, 0, Mt.length);
                return;
              }
              const $t = Mt.length;
              let Tt = 0;
              for (; Tt < $t; ) {
                let Dt = 8, Ut = (0, st.readUint32)(Mt, Tt);
                const Vt = (0, st.readUint32)(Mt, Tt + 4);
                if (Tt += Dt, Ut === 1 && (Ut = (0, st.readUint32)(Mt, Tt) * 4294967296 + (0, st.readUint32)(Mt, Tt + 4), Tt += 8, Dt += 8), Ut === 0 && (Ut = $t - Tt + Dt), Ut < Dt)
                  throw new et("Invalid box field size");
                const Qt = Ut - Dt;
                let qt = !0;
                switch (Vt) {
                  case 1785737832:
                    qt = !1;
                    break;
                  case 1668246642:
                    const Zt = Mt[Tt];
                    if (Zt === 1) {
                      const Jt = (0, st.readUint32)(Mt, Tt + 3);
                      switch (Jt) {
                        case 16:
                        case 17:
                        case 18:
                          break;
                        default:
                          (0, rt.warn)("Unknown colorspace " + Jt);
                          break;
                      }
                    } else
                      Zt === 2 && (0, rt.info)("ICC profile not supported");
                    break;
                  case 1785737827:
                    this.parseCodestream(Mt, Tt, Tt + Qt);
                    break;
                  case 1783636e3:
                    (0, st.readUint32)(Mt, Tt) !== 218793738 && (0, rt.warn)("Invalid JP2 signature");
                    break;
                  case 1783634458:
                  case 1718909296:
                  case 1920099697:
                  case 1919251232:
                  case 1768449138:
                    break;
                  default:
                    const ar = String.fromCharCode(Vt >> 24 & 255, Vt >> 16 & 255, Vt >> 8 & 255, Vt & 255);
                    (0, rt.warn)(`Unsupported header type ${Vt} (${ar}).`);
                    break;
                }
                qt && (Tt += Qt);
              }
            }
            parseImageProperties(Mt) {
              let Lt = Mt.getByte();
              for (; Lt >= 0; ) {
                const $t = Lt;
                if (Lt = Mt.getByte(), ($t << 8 | Lt) === 65361) {
                  Mt.skip(4);
                  const Dt = Mt.getInt32() >>> 0, Ut = Mt.getInt32() >>> 0, Vt = Mt.getInt32() >>> 0, Qt = Mt.getInt32() >>> 0;
                  Mt.skip(16);
                  const qt = Mt.getUint16();
                  this.width = Dt - Vt, this.height = Ut - Qt, this.componentsCount = qt, this.bitsPerComponent = 8;
                  return;
                }
              }
              throw new et("No size marker found in JPX stream");
            }
            parseCodestream(Mt, Lt, $t) {
              const Tt = {};
              let Dt = !1;
              try {
                let Ut = Lt;
                for (; Ut + 1 < $t; ) {
                  const Vt = (0, st.readUint16)(Mt, Ut);
                  Ut += 2;
                  let Qt = 0, qt, Zt, ar, Jt, rr, Yt;
                  switch (Vt) {
                    case 65359:
                      Tt.mainHeader = !0;
                      break;
                    case 65497:
                      break;
                    case 65361:
                      Qt = (0, st.readUint16)(Mt, Ut);
                      const Kt = {};
                      Kt.Xsiz = (0, st.readUint32)(Mt, Ut + 4), Kt.Ysiz = (0, st.readUint32)(Mt, Ut + 8), Kt.XOsiz = (0, st.readUint32)(Mt, Ut + 12), Kt.YOsiz = (0, st.readUint32)(Mt, Ut + 16), Kt.XTsiz = (0, st.readUint32)(Mt, Ut + 20), Kt.YTsiz = (0, st.readUint32)(Mt, Ut + 24), Kt.XTOsiz = (0, st.readUint32)(Mt, Ut + 28), Kt.YTOsiz = (0, st.readUint32)(Mt, Ut + 32);
                      const nr = (0, st.readUint16)(Mt, Ut + 36);
                      Kt.Csiz = nr;
                      const tr = [];
                      qt = Ut + 38;
                      for (let er = 0; er < nr; er++) {
                        const lr = {
                          precision: (Mt[qt] & 127) + 1,
                          isSigned: !!(Mt[qt] & 128),
                          XRsiz: Mt[qt + 1],
                          YRsiz: Mt[qt + 2]
                        };
                        qt += 3, ft(lr, Kt), tr.push(lr);
                      }
                      Tt.SIZ = Kt, Tt.components = tr, ht(Tt, tr), Tt.QCC = [], Tt.COC = [];
                      break;
                    case 65372:
                      Qt = (0, st.readUint16)(Mt, Ut);
                      const ir = {};
                      switch (qt = Ut + 2, Zt = Mt[qt++], Zt & 31) {
                        case 0:
                          Jt = 8, rr = !0;
                          break;
                        case 1:
                          Jt = 16, rr = !1;
                          break;
                        case 2:
                          Jt = 16, rr = !0;
                          break;
                        default:
                          throw new Error("Invalid SQcd value " + Zt);
                      }
                      for (ir.noQuantization = Jt === 8, ir.scalarExpounded = rr, ir.guardBits = Zt >> 5, ar = []; qt < Qt + Ut; ) {
                        const er = {};
                        Jt === 8 ? (er.epsilon = Mt[qt++] >> 3, er.mu = 0) : (er.epsilon = Mt[qt] >> 3, er.mu = (Mt[qt] & 7) << 8 | Mt[qt + 1], qt += 2), ar.push(er);
                      }
                      ir.SPqcds = ar, Tt.mainHeader ? Tt.QCD = ir : (Tt.currentTile.QCD = ir, Tt.currentTile.QCC = []);
                      break;
                    case 65373:
                      Qt = (0, st.readUint16)(Mt, Ut);
                      const sr = {};
                      qt = Ut + 2;
                      let cr;
                      switch (Tt.SIZ.Csiz < 257 ? cr = Mt[qt++] : (cr = (0, st.readUint16)(Mt, qt), qt += 2), Zt = Mt[qt++], Zt & 31) {
                        case 0:
                          Jt = 8, rr = !0;
                          break;
                        case 1:
                          Jt = 16, rr = !1;
                          break;
                        case 2:
                          Jt = 16, rr = !0;
                          break;
                        default:
                          throw new Error("Invalid SQcd value " + Zt);
                      }
                      for (sr.noQuantization = Jt === 8, sr.scalarExpounded = rr, sr.guardBits = Zt >> 5, ar = []; qt < Qt + Ut; ) {
                        const er = {};
                        Jt === 8 ? (er.epsilon = Mt[qt++] >> 3, er.mu = 0) : (er.epsilon = Mt[qt] >> 3, er.mu = (Mt[qt] & 7) << 8 | Mt[qt + 1], qt += 2), ar.push(er);
                      }
                      sr.SPqcds = ar, Tt.mainHeader ? Tt.QCC[cr] = sr : Tt.currentTile.QCC[cr] = sr;
                      break;
                    case 65362:
                      Qt = (0, st.readUint16)(Mt, Ut);
                      const or = {};
                      qt = Ut + 2;
                      const Xt = Mt[qt++];
                      or.entropyCoderWithCustomPrecincts = !!(Xt & 1), or.sopMarkerUsed = !!(Xt & 2), or.ephMarkerUsed = !!(Xt & 4), or.progressionOrder = Mt[qt++], or.layersCount = (0, st.readUint16)(Mt, qt), qt += 2, or.multipleComponentTransform = Mt[qt++], or.decompositionLevelsCount = Mt[qt++], or.xcb = (Mt[qt++] & 15) + 2, or.ycb = (Mt[qt++] & 15) + 2;
                      const Gt = Mt[qt++];
                      if (or.selectiveArithmeticCodingBypass = !!(Gt & 1), or.resetContextProbabilities = !!(Gt & 2), or.terminationOnEachCodingPass = !!(Gt & 4), or.verticallyStripe = !!(Gt & 8), or.predictableTermination = !!(Gt & 16), or.segmentationSymbolUsed = !!(Gt & 32), or.reversibleTransformation = Mt[qt++], or.entropyCoderWithCustomPrecincts) {
                        const er = [];
                        for (; qt < Qt + Ut; ) {
                          const lr = Mt[qt++];
                          er.push({
                            PPx: lr & 15,
                            PPy: lr >> 4
                          });
                        }
                        or.precinctsSizes = er;
                      }
                      const Wt = [];
                      or.selectiveArithmeticCodingBypass && Wt.push("selectiveArithmeticCodingBypass"), or.terminationOnEachCodingPass && Wt.push("terminationOnEachCodingPass"), or.verticallyStripe && Wt.push("verticallyStripe"), or.predictableTermination && Wt.push("predictableTermination"), Wt.length > 0 && (Dt = !0, (0, rt.warn)(`JPX: Unsupported COD options (${Wt.join(", ")}).`)), Tt.mainHeader ? Tt.COD = or : (Tt.currentTile.COD = or, Tt.currentTile.COC = []);
                      break;
                    case 65424:
                      Qt = (0, st.readUint16)(Mt, Ut), Yt = {}, Yt.index = (0, st.readUint16)(Mt, Ut + 2), Yt.length = (0, st.readUint32)(Mt, Ut + 4), Yt.dataEnd = Yt.length + Ut - 2, Yt.partIndex = Mt[Ut + 8], Yt.partsCount = Mt[Ut + 9], Tt.mainHeader = !1, Yt.partIndex === 0 && (Yt.COD = Tt.COD, Yt.COC = Tt.COC.slice(0), Yt.QCD = Tt.QCD, Yt.QCC = Tt.QCC.slice(0)), Tt.currentTile = Yt;
                      break;
                    case 65427:
                      Yt = Tt.currentTile, Yt.partIndex === 0 && (It(Tt, Yt.index), Bt(Tt)), Qt = Yt.dataEnd - Ut, Ot(Tt, Mt, Ut, Qt);
                      break;
                    case 65363:
                      (0, rt.warn)("JPX: Codestream code 0xFF53 (COC) is not implemented.");
                    case 65365:
                    case 65367:
                    case 65368:
                    case 65380:
                      Qt = (0, st.readUint16)(Mt, Ut);
                      break;
                    default:
                      throw new Error("Unknown codestream code: " + Vt.toString(16));
                  }
                  Ut += Qt;
                }
              } catch (Ut) {
                if (Dt || this.failOnCorruptedImage)
                  throw new et(Ut.message);
                (0, rt.warn)(`JPX: Trying to recover from: "${Ut.message}".`);
              }
              this.tiles = Ct(Tt), this.width = Tt.SIZ.Xsiz - Tt.SIZ.XOsiz, this.height = Tt.SIZ.Ysiz - Tt.SIZ.YOsiz, this.componentsCount = Tt.SIZ.Csiz;
            }
          }
          at.JpxImage = ut;
          function ft(Nt, Mt) {
            Nt.x0 = Math.ceil(Mt.XOsiz / Nt.XRsiz), Nt.x1 = Math.ceil(Mt.Xsiz / Nt.XRsiz), Nt.y0 = Math.ceil(Mt.YOsiz / Nt.YRsiz), Nt.y1 = Math.ceil(Mt.Ysiz / Nt.YRsiz), Nt.width = Nt.x1 - Nt.x0, Nt.height = Nt.y1 - Nt.y0;
          }
          function ht(Nt, Mt) {
            const Lt = Nt.SIZ, $t = [];
            let Tt;
            const Dt = Math.ceil((Lt.Xsiz - Lt.XTOsiz) / Lt.XTsiz), Ut = Math.ceil((Lt.Ysiz - Lt.YTOsiz) / Lt.YTsiz);
            for (let Qt = 0; Qt < Ut; Qt++)
              for (let qt = 0; qt < Dt; qt++)
                Tt = {}, Tt.tx0 = Math.max(Lt.XTOsiz + qt * Lt.XTsiz, Lt.XOsiz), Tt.ty0 = Math.max(Lt.YTOsiz + Qt * Lt.YTsiz, Lt.YOsiz), Tt.tx1 = Math.min(Lt.XTOsiz + (qt + 1) * Lt.XTsiz, Lt.Xsiz), Tt.ty1 = Math.min(Lt.YTOsiz + (Qt + 1) * Lt.YTsiz, Lt.Ysiz), Tt.width = Tt.tx1 - Tt.tx0, Tt.height = Tt.ty1 - Tt.ty0, Tt.components = [], $t.push(Tt);
            Nt.tiles = $t;
            const Vt = Lt.Csiz;
            for (let Qt = 0, qt = Vt; Qt < qt; Qt++) {
              const Zt = Mt[Qt];
              for (let ar = 0, Jt = $t.length; ar < Jt; ar++) {
                const rr = {};
                Tt = $t[ar], rr.tcx0 = Math.ceil(Tt.tx0 / Zt.XRsiz), rr.tcy0 = Math.ceil(Tt.ty0 / Zt.YRsiz), rr.tcx1 = Math.ceil(Tt.tx1 / Zt.XRsiz), rr.tcy1 = Math.ceil(Tt.ty1 / Zt.YRsiz), rr.width = rr.tcx1 - rr.tcx0, rr.height = rr.tcy1 - rr.tcy0, Tt.components[Qt] = rr;
              }
            }
          }
          function dt(Nt, Mt, Lt) {
            const $t = Mt.codingStyleParameters, Tt = {};
            return $t.entropyCoderWithCustomPrecincts ? (Tt.PPx = $t.precinctsSizes[Lt].PPx, Tt.PPy = $t.precinctsSizes[Lt].PPy) : (Tt.PPx = 15, Tt.PPy = 15), Tt.xcb_ = Lt > 0 ? Math.min($t.xcb, Tt.PPx - 1) : Math.min($t.xcb, Tt.PPx), Tt.ycb_ = Lt > 0 ? Math.min($t.ycb, Tt.PPy - 1) : Math.min($t.ycb, Tt.PPy), Tt;
          }
          function gt(Nt, Mt, Lt) {
            const $t = 1 << Lt.PPx, Tt = 1 << Lt.PPy, Dt = Mt.resLevel === 0, Ut = 1 << Lt.PPx + (Dt ? 0 : -1), Vt = 1 << Lt.PPy + (Dt ? 0 : -1), Qt = Mt.trx1 > Mt.trx0 ? Math.ceil(Mt.trx1 / $t) - Math.floor(Mt.trx0 / $t) : 0, qt = Mt.try1 > Mt.try0 ? Math.ceil(Mt.try1 / Tt) - Math.floor(Mt.try0 / Tt) : 0, Zt = Qt * qt;
            Mt.precinctParameters = {
              precinctWidth: $t,
              precinctHeight: Tt,
              numprecinctswide: Qt,
              numprecinctshigh: qt,
              numprecincts: Zt,
              precinctWidthInSubband: Ut,
              precinctHeightInSubband: Vt
            };
          }
          function pt(Nt, Mt, Lt) {
            const $t = Lt.xcb_, Tt = Lt.ycb_, Dt = 1 << $t, Ut = 1 << Tt, Vt = Mt.tbx0 >> $t, Qt = Mt.tby0 >> Tt, qt = Mt.tbx1 + Dt - 1 >> $t, Zt = Mt.tby1 + Ut - 1 >> Tt, ar = Mt.resolution.precinctParameters, Jt = [], rr = [];
            let Yt, Kt, nr, tr;
            for (Kt = Qt; Kt < Zt; Kt++)
              for (Yt = Vt; Yt < qt; Yt++) {
                nr = {
                  cbx: Yt,
                  cby: Kt,
                  tbx0: Dt * Yt,
                  tby0: Ut * Kt,
                  tbx1: Dt * (Yt + 1),
                  tby1: Ut * (Kt + 1)
                }, nr.tbx0_ = Math.max(Mt.tbx0, nr.tbx0), nr.tby0_ = Math.max(Mt.tby0, nr.tby0), nr.tbx1_ = Math.min(Mt.tbx1, nr.tbx1), nr.tby1_ = Math.min(Mt.tby1, nr.tby1);
                const ir = Math.floor((nr.tbx0_ - Mt.tbx0) / ar.precinctWidthInSubband), sr = Math.floor((nr.tby0_ - Mt.tby0) / ar.precinctHeightInSubband);
                if (tr = ir + sr * ar.numprecinctswide, nr.precinctNumber = tr, nr.subbandType = Mt.type, nr.Lblock = 3, nr.tbx1_ <= nr.tbx0_ || nr.tby1_ <= nr.tby0_)
                  continue;
                Jt.push(nr);
                let cr = rr[tr];
                cr !== void 0 ? (Yt < cr.cbxMin ? cr.cbxMin = Yt : Yt > cr.cbxMax && (cr.cbxMax = Yt), Kt < cr.cbyMin ? cr.cbxMin = Kt : Kt > cr.cbyMax && (cr.cbyMax = Kt)) : rr[tr] = cr = {
                  cbxMin: Yt,
                  cbyMin: Kt,
                  cbxMax: Yt,
                  cbyMax: Kt
                }, nr.precinct = cr;
              }
            Mt.codeblockParameters = {
              codeblockWidth: $t,
              codeblockHeight: Tt,
              numcodeblockwide: qt - Vt + 1,
              numcodeblockhigh: Zt - Qt + 1
            }, Mt.codeblocks = Jt, Mt.precincts = rr;
          }
          function mt(Nt, Mt, Lt) {
            const $t = [], Tt = Nt.subbands;
            for (let Dt = 0, Ut = Tt.length; Dt < Ut; Dt++) {
              const Qt = Tt[Dt].codeblocks;
              for (let qt = 0, Zt = Qt.length; qt < Zt; qt++) {
                const ar = Qt[qt];
                ar.precinctNumber === Mt && $t.push(ar);
              }
            }
            return {
              layerNumber: Lt,
              codeblocks: $t
            };
          }
          function ct(Nt) {
            const Mt = Nt.SIZ, Lt = Nt.currentTile.index, $t = Nt.tiles[Lt], Tt = $t.codingStyleDefaultParameters.layersCount, Dt = Mt.Csiz;
            let Ut = 0;
            for (let ar = 0; ar < Dt; ar++)
              Ut = Math.max(Ut, $t.components[ar].codingStyleParameters.decompositionLevelsCount);
            let Vt = 0, Qt = 0, qt = 0, Zt = 0;
            this.nextPacket = function() {
              for (; Vt < Tt; Vt++) {
                for (; Qt <= Ut; Qt++) {
                  for (; qt < Dt; qt++) {
                    const Jt = $t.components[qt];
                    if (Qt > Jt.codingStyleParameters.decompositionLevelsCount)
                      continue;
                    const rr = Jt.resolutions[Qt], Yt = rr.precinctParameters.numprecincts;
                    for (; Zt < Yt; ) {
                      const Kt = mt(rr, Zt, Vt);
                      return Zt++, Kt;
                    }
                    Zt = 0;
                  }
                  qt = 0;
                }
                Qt = 0;
              }
              throw new et("Out of packets");
            };
          }
          function vt(Nt) {
            const Mt = Nt.SIZ, Lt = Nt.currentTile.index, $t = Nt.tiles[Lt], Tt = $t.codingStyleDefaultParameters.layersCount, Dt = Mt.Csiz;
            let Ut = 0;
            for (let ar = 0; ar < Dt; ar++)
              Ut = Math.max(Ut, $t.components[ar].codingStyleParameters.decompositionLevelsCount);
            let Vt = 0, Qt = 0, qt = 0, Zt = 0;
            this.nextPacket = function() {
              for (; Vt <= Ut; Vt++) {
                for (; Qt < Tt; Qt++) {
                  for (; qt < Dt; qt++) {
                    const Jt = $t.components[qt];
                    if (Vt > Jt.codingStyleParameters.decompositionLevelsCount)
                      continue;
                    const rr = Jt.resolutions[Vt], Yt = rr.precinctParameters.numprecincts;
                    for (; Zt < Yt; ) {
                      const Kt = mt(rr, Zt, Qt);
                      return Zt++, Kt;
                    }
                    Zt = 0;
                  }
                  qt = 0;
                }
                Qt = 0;
              }
              throw new et("Out of packets");
            };
          }
          function At(Nt) {
            const Mt = Nt.SIZ, Lt = Nt.currentTile.index, $t = Nt.tiles[Lt], Tt = $t.codingStyleDefaultParameters.layersCount, Dt = Mt.Csiz;
            let Ut, Vt, Qt, qt, Zt = 0;
            for (Qt = 0; Qt < Dt; Qt++) {
              const Jt = $t.components[Qt];
              Zt = Math.max(Zt, Jt.codingStyleParameters.decompositionLevelsCount);
            }
            const ar = new Int32Array(Zt + 1);
            for (Vt = 0; Vt <= Zt; ++Vt) {
              let Jt = 0;
              for (Qt = 0; Qt < Dt; ++Qt) {
                const rr = $t.components[Qt].resolutions;
                Vt < rr.length && (Jt = Math.max(Jt, rr[Vt].precinctParameters.numprecincts));
              }
              ar[Vt] = Jt;
            }
            Ut = 0, Vt = 0, Qt = 0, qt = 0, this.nextPacket = function() {
              for (; Vt <= Zt; Vt++) {
                for (; qt < ar[Vt]; qt++) {
                  for (; Qt < Dt; Qt++) {
                    const rr = $t.components[Qt];
                    if (Vt > rr.codingStyleParameters.decompositionLevelsCount)
                      continue;
                    const Yt = rr.resolutions[Vt], Kt = Yt.precinctParameters.numprecincts;
                    if (!(qt >= Kt)) {
                      for (; Ut < Tt; ) {
                        const nr = mt(Yt, qt, Ut);
                        return Ut++, nr;
                      }
                      Ut = 0;
                    }
                  }
                  Qt = 0;
                }
                qt = 0;
              }
              throw new et("Out of packets");
            };
          }
          function xt(Nt) {
            const Mt = Nt.SIZ, Lt = Nt.currentTile.index, $t = Nt.tiles[Lt], Tt = $t.codingStyleDefaultParameters.layersCount, Dt = Mt.Csiz, Ut = St($t), Vt = Ut;
            let Qt = 0, qt = 0, Zt = 0, ar = 0, Jt = 0;
            this.nextPacket = function() {
              for (; Jt < Vt.maxNumHigh; Jt++) {
                for (; ar < Vt.maxNumWide; ar++) {
                  for (; Zt < Dt; Zt++) {
                    const Yt = $t.components[Zt], Kt = Yt.codingStyleParameters.decompositionLevelsCount;
                    for (; qt <= Kt; qt++) {
                      const nr = Yt.resolutions[qt], tr = Ut.components[Zt].resolutions[qt], ir = Et(ar, Jt, tr, Vt, nr);
                      if (ir !== null) {
                        for (; Qt < Tt; ) {
                          const sr = mt(nr, ir, Qt);
                          return Qt++, sr;
                        }
                        Qt = 0;
                      }
                    }
                    qt = 0;
                  }
                  Zt = 0;
                }
                ar = 0;
              }
              throw new et("Out of packets");
            };
          }
          function bt(Nt) {
            const Mt = Nt.SIZ, Lt = Nt.currentTile.index, $t = Nt.tiles[Lt], Tt = $t.codingStyleDefaultParameters.layersCount, Dt = Mt.Csiz, Ut = St($t);
            let Vt = 0, Qt = 0, qt = 0, Zt = 0, ar = 0;
            this.nextPacket = function() {
              for (; qt < Dt; ++qt) {
                const rr = $t.components[qt], Yt = Ut.components[qt], Kt = rr.codingStyleParameters.decompositionLevelsCount;
                for (; ar < Yt.maxNumHigh; ar++) {
                  for (; Zt < Yt.maxNumWide; Zt++) {
                    for (; Qt <= Kt; Qt++) {
                      const nr = rr.resolutions[Qt], tr = Yt.resolutions[Qt], ir = Et(Zt, ar, tr, Yt, nr);
                      if (ir !== null) {
                        for (; Vt < Tt; ) {
                          const sr = mt(nr, ir, Vt);
                          return Vt++, sr;
                        }
                        Vt = 0;
                      }
                    }
                    Qt = 0;
                  }
                  Zt = 0;
                }
                ar = 0;
              }
              throw new et("Out of packets");
            };
          }
          function Et(Nt, Mt, Lt, $t, Tt) {
            const Dt = Nt * $t.minWidth, Ut = Mt * $t.minHeight;
            if (Dt % Lt.width !== 0 || Ut % Lt.height !== 0)
              return null;
            const Vt = Ut / Lt.width * Tt.precinctParameters.numprecinctswide;
            return Dt / Lt.height + Vt;
          }
          function St(Nt) {
            const Mt = Nt.components.length;
            let Lt = Number.MAX_VALUE, $t = Number.MAX_VALUE, Tt = 0, Dt = 0;
            const Ut = new Array(Mt);
            for (let Vt = 0; Vt < Mt; Vt++) {
              const Qt = Nt.components[Vt], qt = Qt.codingStyleParameters.decompositionLevelsCount, Zt = new Array(qt + 1);
              let ar = Number.MAX_VALUE, Jt = Number.MAX_VALUE, rr = 0, Yt = 0, Kt = 1;
              for (let nr = qt; nr >= 0; --nr) {
                const tr = Qt.resolutions[nr], ir = Kt * tr.precinctParameters.precinctWidth, sr = Kt * tr.precinctParameters.precinctHeight;
                ar = Math.min(ar, ir), Jt = Math.min(Jt, sr), rr = Math.max(rr, tr.precinctParameters.numprecinctswide), Yt = Math.max(Yt, tr.precinctParameters.numprecinctshigh), Zt[nr] = {
                  width: ir,
                  height: sr
                }, Kt <<= 1;
              }
              Lt = Math.min(Lt, ar), $t = Math.min($t, Jt), Tt = Math.max(Tt, rr), Dt = Math.max(Dt, Yt), Ut[Vt] = {
                resolutions: Zt,
                minWidth: ar,
                minHeight: Jt,
                maxNumWide: rr,
                maxNumHigh: Yt
              };
            }
            return {
              components: Ut,
              minWidth: Lt,
              minHeight: $t,
              maxNumWide: Tt,
              maxNumHigh: Dt
            };
          }
          function Bt(Nt) {
            const Mt = Nt.SIZ, Lt = Nt.currentTile.index, $t = Nt.tiles[Lt], Tt = Mt.Csiz;
            for (let Ut = 0; Ut < Tt; Ut++) {
              const Vt = $t.components[Ut], Qt = Vt.codingStyleParameters.decompositionLevelsCount, qt = [], Zt = [];
              for (let ar = 0; ar <= Qt; ar++) {
                const Jt = dt(Nt, Vt, ar), rr = {}, Yt = 1 << Qt - ar;
                rr.trx0 = Math.ceil(Vt.tcx0 / Yt), rr.try0 = Math.ceil(Vt.tcy0 / Yt), rr.trx1 = Math.ceil(Vt.tcx1 / Yt), rr.try1 = Math.ceil(Vt.tcy1 / Yt), rr.resLevel = ar, gt(Nt, rr, Jt), qt.push(rr);
                let Kt;
                if (ar === 0)
                  Kt = {}, Kt.type = "LL", Kt.tbx0 = Math.ceil(Vt.tcx0 / Yt), Kt.tby0 = Math.ceil(Vt.tcy0 / Yt), Kt.tbx1 = Math.ceil(Vt.tcx1 / Yt), Kt.tby1 = Math.ceil(Vt.tcy1 / Yt), Kt.resolution = rr, pt(Nt, Kt, Jt), Zt.push(Kt), rr.subbands = [Kt];
                else {
                  const nr = 1 << Qt - ar + 1, tr = [];
                  Kt = {}, Kt.type = "HL", Kt.tbx0 = Math.ceil(Vt.tcx0 / nr - 0.5), Kt.tby0 = Math.ceil(Vt.tcy0 / nr), Kt.tbx1 = Math.ceil(Vt.tcx1 / nr - 0.5), Kt.tby1 = Math.ceil(Vt.tcy1 / nr), Kt.resolution = rr, pt(Nt, Kt, Jt), Zt.push(Kt), tr.push(Kt), Kt = {}, Kt.type = "LH", Kt.tbx0 = Math.ceil(Vt.tcx0 / nr), Kt.tby0 = Math.ceil(Vt.tcy0 / nr - 0.5), Kt.tbx1 = Math.ceil(Vt.tcx1 / nr), Kt.tby1 = Math.ceil(Vt.tcy1 / nr - 0.5), Kt.resolution = rr, pt(Nt, Kt, Jt), Zt.push(Kt), tr.push(Kt), Kt = {}, Kt.type = "HH", Kt.tbx0 = Math.ceil(Vt.tcx0 / nr - 0.5), Kt.tby0 = Math.ceil(Vt.tcy0 / nr - 0.5), Kt.tbx1 = Math.ceil(Vt.tcx1 / nr - 0.5), Kt.tby1 = Math.ceil(Vt.tcy1 / nr - 0.5), Kt.resolution = rr, pt(Nt, Kt, Jt), Zt.push(Kt), tr.push(Kt), rr.subbands = tr;
                }
              }
              Vt.resolutions = qt, Vt.subbands = Zt;
            }
            const Dt = $t.codingStyleDefaultParameters.progressionOrder;
            switch (Dt) {
              case 0:
                $t.packetsIterator = new ct(Nt);
                break;
              case 1:
                $t.packetsIterator = new vt(Nt);
                break;
              case 2:
                $t.packetsIterator = new At(Nt);
                break;
              case 3:
                $t.packetsIterator = new xt(Nt);
                break;
              case 4:
                $t.packetsIterator = new bt(Nt);
                break;
              default:
                throw new et(`Unsupported progression order ${Dt}`);
            }
          }
          function Ot(Nt, Mt, Lt, $t) {
            let Tt = 0, Dt, Ut = 0, Vt = !1;
            function Qt(ir) {
              for (; Ut < ir; ) {
                const sr = Mt[Lt + Tt];
                Tt++, Vt ? (Dt = Dt << 7 | sr, Ut += 7, Vt = !1) : (Dt = Dt << 8 | sr, Ut += 8), sr === 255 && (Vt = !0);
              }
              return Ut -= ir, Dt >>> Ut & (1 << ir) - 1;
            }
            function qt(ir) {
              return Mt[Lt + Tt - 1] === 255 && Mt[Lt + Tt] === ir ? (Zt(1), !0) : Mt[Lt + Tt] === 255 && Mt[Lt + Tt + 1] === ir ? (Zt(2), !0) : !1;
            }
            function Zt(ir) {
              Tt += ir;
            }
            function ar() {
              Ut = 0, Vt && (Tt++, Vt = !1);
            }
            function Jt() {
              if (Qt(1) === 0)
                return 1;
              if (Qt(1) === 0)
                return 2;
              let ir = Qt(2);
              return ir < 3 ? ir + 3 : (ir = Qt(5), ir < 31 ? ir + 6 : (ir = Qt(7), ir + 37));
            }
            const rr = Nt.currentTile.index, Yt = Nt.tiles[rr], Kt = Nt.COD.sopMarkerUsed, nr = Nt.COD.ephMarkerUsed, tr = Yt.packetsIterator;
            for (; Tt < $t; ) {
              ar(), Kt && qt(145) && Zt(4);
              const ir = tr.nextPacket();
              if (!Qt(1))
                continue;
              const sr = ir.layerNumber, cr = [];
              let or;
              for (let Xt = 0, Gt = ir.codeblocks.length; Xt < Gt; Xt++) {
                or = ir.codeblocks[Xt];
                let Wt = or.precinct;
                const er = or.cbx - Wt.cbxMin, lr = or.cby - Wt.cbyMin;
                let ur = !1, pr = !1, yr, Er;
                if (or.included !== void 0)
                  ur = !!Qt(1);
                else {
                  Wt = or.precinct;
                  let Br;
                  if (Wt.inclusionTree !== void 0)
                    Br = Wt.inclusionTree;
                  else {
                    const Ir = Wt.cbxMax - Wt.cbxMin + 1, hr = Wt.cbyMax - Wt.cbyMin + 1;
                    Br = new Rt(Ir, hr, sr), Er = new yt(Ir, hr), Wt.inclusionTree = Br, Wt.zeroBitPlanesTree = Er;
                    for (let vr = 0; vr < sr; vr++)
                      if (Qt(1) !== 0)
                        throw new et("Invalid tag tree");
                  }
                  if (Br.reset(er, lr, sr))
                    for (; ; )
                      if (Qt(1)) {
                        if (yr = !Br.nextLevel(), yr) {
                          or.included = !0, ur = pr = !0;
                          break;
                        }
                      } else {
                        Br.incrementValue(sr);
                        break;
                      }
                }
                if (!ur)
                  continue;
                if (pr) {
                  for (Er = Wt.zeroBitPlanesTree, Er.reset(er, lr); ; )
                    if (Qt(1)) {
                      if (yr = !Er.nextLevel(), yr)
                        break;
                    } else
                      Er.incrementValue();
                  or.zeroBitPlanes = Er.value;
                }
                const br = Jt();
                for (; Qt(1); )
                  or.Lblock++;
                const gr = (0, st.log2)(br), Ar = (br < 1 << gr ? gr - 1 : gr) + or.Lblock, Sr = Qt(Ar);
                cr.push({
                  codeblock: or,
                  codingpasses: br,
                  dataLength: Sr
                });
              }
              for (ar(), nr && qt(146); cr.length > 0; ) {
                const Xt = cr.shift();
                or = Xt.codeblock, or.data === void 0 && (or.data = []), or.data.push({
                  data: Mt,
                  start: Lt + Tt,
                  end: Lt + Tt + Xt.dataLength,
                  codingpasses: Xt.codingpasses
                }), Tt += Xt.dataLength;
              }
            }
            return Tt;
          }
          function Pt(Nt, Mt, Lt, $t, Tt, Dt, Ut, Vt, Qt) {
            const qt = $t.tbx0, Zt = $t.tby0, ar = $t.tbx1 - $t.tbx0, Jt = $t.codeblocks, rr = $t.type.charAt(0) === "H" ? 1 : 0, Yt = $t.type.charAt(1) === "H" ? Mt : 0;
            for (let Kt = 0, nr = Jt.length; Kt < nr; ++Kt) {
              const tr = Jt[Kt], ir = tr.tbx1_ - tr.tbx0_, sr = tr.tby1_ - tr.tby0_;
              if (ir === 0 || sr === 0 || tr.data === void 0)
                continue;
              const cr = new kt(ir, sr, tr.subbandType, tr.zeroBitPlanes, Dt);
              let or = 2;
              const Xt = tr.data;
              let Gt = 0, Wt = 0, er, lr, ur;
              for (er = 0, lr = Xt.length; er < lr; er++)
                ur = Xt[er], Gt += ur.end - ur.start, Wt += ur.codingpasses;
              const pr = new Uint8Array(Gt);
              let yr = 0;
              for (er = 0, lr = Xt.length; er < lr; er++) {
                ur = Xt[er];
                const Pr = ur.data.subarray(ur.start, ur.end);
                pr.set(Pr, yr), yr += Pr.length;
              }
              const Er = new lt.ArithmeticDecoder(pr, 0, Gt);
              for (cr.setDecoder(Er), er = 0; er < Wt; er++) {
                switch (or) {
                  case 0:
                    cr.runSignificancePropagationPass();
                    break;
                  case 1:
                    cr.runMagnitudeRefinementPass();
                    break;
                  case 2:
                    cr.runCleanupPass(), Vt && cr.checkSegmentationSymbol();
                    break;
                }
                Qt && cr.reset(), or = (or + 1) % 3;
              }
              let br = tr.tbx0_ - qt + (tr.tby0_ - Zt) * ar;
              const gr = cr.coefficentsSign, Ar = cr.coefficentsMagnitude, Sr = cr.bitsDecoded, Br = Ut ? 0 : 0.5;
              let Ir, hr, vr;
              yr = 0;
              const xr = $t.type !== "LL";
              for (er = 0; er < sr; er++) {
                const Rr = 2 * (br / ar | 0) * (Mt - ar) + rr + Yt;
                for (Ir = 0; Ir < ir; Ir++) {
                  if (hr = Ar[yr], hr !== 0) {
                    hr = (hr + Br) * Tt, gr[yr] !== 0 && (hr = -hr), vr = Sr[yr];
                    const Dr = xr ? Rr + (br << 1) : br;
                    Nt[Dr] = Ut && vr >= Dt ? hr : hr * (1 << Dt - vr);
                  }
                  br++, yr++;
                }
                br += ar - ir;
              }
            }
          }
          function wt(Nt, Mt, Lt) {
            const $t = Mt.components[Lt], Tt = $t.codingStyleParameters, Dt = $t.quantizationParameters, Ut = Tt.decompositionLevelsCount, Vt = Dt.SPqcds, Qt = Dt.scalarExpounded, qt = Dt.guardBits, Zt = Tt.segmentationSymbolUsed, ar = Tt.resetContextProbabilities, Jt = Nt.components[Lt].precision, rr = Tt.reversibleTransformation, Yt = rr ? new Ft() : new Ht(), Kt = [];
            let nr = 0;
            for (let ir = 0; ir <= Ut; ir++) {
              const sr = $t.resolutions[ir], cr = sr.trx1 - sr.trx0, or = sr.try1 - sr.try0, Xt = new Float32Array(cr * or);
              for (let Gt = 0, Wt = sr.subbands.length; Gt < Wt; Gt++) {
                let er, lr;
                Qt ? (er = Vt[nr].mu, lr = Vt[nr].epsilon, nr++) : (er = Vt[0].mu, lr = Vt[0].epsilon + (ir > 0 ? 1 - ir : 0));
                const ur = sr.subbands[Gt], pr = it[ur.type], yr = rr ? 1 : 2 ** (Jt + pr - lr) * (1 + er / 2048), Er = qt + lr - 1;
                Pt(Xt, cr, or, ur, yr, Er, rr, Zt, ar);
              }
              Kt.push({
                width: cr,
                height: or,
                items: Xt
              });
            }
            const tr = Yt.calculate(Kt, $t.tcx0, $t.tcy0);
            return {
              left: $t.tcx0,
              top: $t.tcy0,
              width: tr.width,
              height: tr.height,
              items: tr.items
            };
          }
          function Ct(Nt) {
            const Mt = Nt.SIZ, Lt = Nt.components, $t = Mt.Csiz, Tt = [];
            for (let Dt = 0, Ut = Nt.tiles.length; Dt < Ut; Dt++) {
              const Vt = Nt.tiles[Dt], Qt = [];
              for (let cr = 0; cr < $t; cr++)
                Qt[cr] = wt(Nt, Vt, cr);
              const qt = Qt[0], Zt = new Uint8ClampedArray(qt.items.length * $t), ar = {
                left: qt.left,
                top: qt.top,
                width: qt.width,
                height: qt.height,
                items: Zt
              };
              let Jt, rr, Yt = 0, Kt, nr, tr, ir, sr;
              if (Vt.codingStyleDefaultParameters.multipleComponentTransform) {
                const cr = $t === 4, or = Qt[0].items, Xt = Qt[1].items, Gt = Qt[2].items, Wt = cr ? Qt[3].items : null;
                Jt = Lt[0].precision - 8, rr = (128 << Jt) + 0.5;
                const er = Vt.components[0], lr = $t - 3;
                if (nr = or.length, er.codingStyleParameters.reversibleTransformation)
                  for (Kt = 0; Kt < nr; Kt++, Yt += lr) {
                    tr = or[Kt] + rr, ir = Xt[Kt], sr = Gt[Kt];
                    const ur = tr - (sr + ir >> 2);
                    Zt[Yt++] = ur + sr >> Jt, Zt[Yt++] = ur >> Jt, Zt[Yt++] = ur + ir >> Jt;
                  }
                else
                  for (Kt = 0; Kt < nr; Kt++, Yt += lr)
                    tr = or[Kt] + rr, ir = Xt[Kt], sr = Gt[Kt], Zt[Yt++] = tr + 1.402 * sr >> Jt, Zt[Yt++] = tr - 0.34413 * ir - 0.71414 * sr >> Jt, Zt[Yt++] = tr + 1.772 * ir >> Jt;
                if (cr)
                  for (Kt = 0, Yt = 3; Kt < nr; Kt++, Yt += 4)
                    Zt[Yt] = Wt[Kt] + rr >> Jt;
              } else
                for (let cr = 0; cr < $t; cr++) {
                  const or = Qt[cr].items;
                  for (Jt = Lt[cr].precision - 8, rr = (128 << Jt) + 0.5, Yt = cr, Kt = 0, nr = or.length; Kt < nr; Kt++)
                    Zt[Yt] = or[Kt] + rr >> Jt, Yt += $t;
                }
              Tt.push(ar);
            }
            return Tt;
          }
          function It(Nt, Mt) {
            const $t = Nt.SIZ.Csiz, Tt = Nt.tiles[Mt];
            for (let Dt = 0; Dt < $t; Dt++) {
              const Ut = Tt.components[Dt], Vt = Nt.currentTile.QCC[Dt] !== void 0 ? Nt.currentTile.QCC[Dt] : Nt.currentTile.QCD;
              Ut.quantizationParameters = Vt;
              const Qt = Nt.currentTile.COC[Dt] !== void 0 ? Nt.currentTile.COC[Dt] : Nt.currentTile.COD;
              Ut.codingStyleParameters = Qt;
            }
            Tt.codingStyleDefaultParameters = Nt.currentTile.COD;
          }
          class yt {
            constructor(Mt, Lt) {
              const $t = (0, st.log2)(Math.max(Mt, Lt)) + 1;
              this.levels = [];
              for (let Tt = 0; Tt < $t; Tt++) {
                const Dt = {
                  width: Mt,
                  height: Lt,
                  items: []
                };
                this.levels.push(Dt), Mt = Math.ceil(Mt / 2), Lt = Math.ceil(Lt / 2);
              }
            }
            reset(Mt, Lt) {
              let $t = 0, Tt = 0, Dt;
              for (; $t < this.levels.length; ) {
                Dt = this.levels[$t];
                const Ut = Mt + Lt * Dt.width;
                if (Dt.items[Ut] !== void 0) {
                  Tt = Dt.items[Ut];
                  break;
                }
                Dt.index = Ut, Mt >>= 1, Lt >>= 1, $t++;
              }
              $t--, Dt = this.levels[$t], Dt.items[Dt.index] = Tt, this.currentLevel = $t, delete this.value;
            }
            incrementValue() {
              const Mt = this.levels[this.currentLevel];
              Mt.items[Mt.index]++;
            }
            nextLevel() {
              let Mt = this.currentLevel, Lt = this.levels[Mt];
              const $t = Lt.items[Lt.index];
              return Mt--, Mt < 0 ? (this.value = $t, !1) : (this.currentLevel = Mt, Lt = this.levels[Mt], Lt.items[Lt.index] = $t, !0);
            }
          }
          class Rt {
            constructor(Mt, Lt, $t) {
              const Tt = (0, st.log2)(Math.max(Mt, Lt)) + 1;
              this.levels = [];
              for (let Dt = 0; Dt < Tt; Dt++) {
                const Ut = new Uint8Array(Mt * Lt);
                for (let Qt = 0, qt = Ut.length; Qt < qt; Qt++)
                  Ut[Qt] = $t;
                const Vt = {
                  width: Mt,
                  height: Lt,
                  items: Ut
                };
                this.levels.push(Vt), Mt = Math.ceil(Mt / 2), Lt = Math.ceil(Lt / 2);
              }
            }
            reset(Mt, Lt, $t) {
              let Tt = 0;
              for (; Tt < this.levels.length; ) {
                const Dt = this.levels[Tt], Ut = Mt + Lt * Dt.width;
                Dt.index = Ut;
                const Vt = Dt.items[Ut];
                if (Vt === 255)
                  break;
                if (Vt > $t)
                  return this.currentLevel = Tt, this.propagateValues(), !1;
                Mt >>= 1, Lt >>= 1, Tt++;
              }
              return this.currentLevel = Tt - 1, !0;
            }
            incrementValue(Mt) {
              const Lt = this.levels[this.currentLevel];
              Lt.items[Lt.index] = Mt + 1, this.propagateValues();
            }
            propagateValues() {
              let Mt = this.currentLevel, Lt = this.levels[Mt];
              const $t = Lt.items[Lt.index];
              for (; --Mt >= 0; )
                Lt = this.levels[Mt], Lt.items[Lt.index] = $t;
            }
            nextLevel() {
              let Mt = this.currentLevel, Lt = this.levels[Mt];
              const $t = Lt.items[Lt.index];
              return Lt.items[Lt.index] = 255, Mt--, Mt < 0 ? !1 : (this.currentLevel = Mt, Lt = this.levels[Mt], Lt.items[Lt.index] = $t, !0);
            }
          }
          const _t = class _t {
            constructor(Mt, Lt, $t, Tt, Dt) {
              this.width = Mt, this.height = Lt;
              let Ut;
              $t === "HH" ? Ut = _t.HHContextLabel : $t === "HL" ? Ut = _t.HLContextLabel : Ut = _t.LLAndLHContextsLabel, this.contextLabelTable = Ut;
              const Vt = Mt * Lt;
              this.neighborsSignificance = new Uint8Array(Vt), this.coefficentsSign = new Uint8Array(Vt);
              let Qt;
              Dt > 14 ? Qt = new Uint32Array(Vt) : Dt > 6 ? Qt = new Uint16Array(Vt) : Qt = new Uint8Array(Vt), this.coefficentsMagnitude = Qt, this.processingFlags = new Uint8Array(Vt);
              const qt = new Uint8Array(Vt);
              if (Tt !== 0)
                for (let Zt = 0; Zt < Vt; Zt++)
                  qt[Zt] = Tt;
              this.bitsDecoded = qt, this.reset();
            }
            setDecoder(Mt) {
              this.decoder = Mt;
            }
            reset() {
              this.contexts = new Int8Array(19), this.contexts[0] = 8, this.contexts[_t.UNIFORM_CONTEXT] = 92, this.contexts[_t.RUNLENGTH_CONTEXT] = 6;
            }
            setNeighborsSignificance(Mt, Lt, $t) {
              const Tt = this.neighborsSignificance, Dt = this.width, Ut = this.height, Vt = Lt > 0, Qt = Lt + 1 < Dt;
              let qt;
              Mt > 0 && (qt = $t - Dt, Vt && (Tt[qt - 1] += 16), Qt && (Tt[qt + 1] += 16), Tt[qt] += 4), Mt + 1 < Ut && (qt = $t + Dt, Vt && (Tt[qt - 1] += 16), Qt && (Tt[qt + 1] += 16), Tt[qt] += 4), Vt && (Tt[$t - 1] += 1), Qt && (Tt[$t + 1] += 1), Tt[$t] |= 128;
            }
            runSignificancePropagationPass() {
              const Mt = this.decoder, Lt = this.width, $t = this.height, Tt = this.coefficentsMagnitude, Dt = this.coefficentsSign, Ut = this.neighborsSignificance, Vt = this.processingFlags, Qt = this.contexts, qt = this.contextLabelTable, Zt = this.bitsDecoded, ar = -2, Jt = 1, rr = 2;
              for (let Yt = 0; Yt < $t; Yt += 4)
                for (let Kt = 0; Kt < Lt; Kt++) {
                  let nr = Yt * Lt + Kt;
                  for (let tr = 0; tr < 4; tr++, nr += Lt) {
                    const ir = Yt + tr;
                    if (ir >= $t)
                      break;
                    if (Vt[nr] &= ar, Tt[nr] || !Ut[nr])
                      continue;
                    const sr = qt[Ut[nr]];
                    if (Mt.readBit(Qt, sr)) {
                      const or = this.decodeSignBit(ir, Kt, nr);
                      Dt[nr] = or, Tt[nr] = 1, this.setNeighborsSignificance(ir, Kt, nr), Vt[nr] |= rr;
                    }
                    Zt[nr]++, Vt[nr] |= Jt;
                  }
                }
            }
            decodeSignBit(Mt, Lt, $t) {
              const Tt = this.width, Dt = this.height, Ut = this.coefficentsMagnitude, Vt = this.coefficentsSign;
              let Qt, qt, Zt, ar, Jt, rr;
              ar = Lt > 0 && Ut[$t - 1] !== 0, Lt + 1 < Tt && Ut[$t + 1] !== 0 ? (Zt = Vt[$t + 1], ar ? (qt = Vt[$t - 1], Qt = 1 - Zt - qt) : Qt = 1 - Zt - Zt) : ar ? (qt = Vt[$t - 1], Qt = 1 - qt - qt) : Qt = 0;
              const Yt = 3 * Qt;
              return ar = Mt > 0 && Ut[$t - Tt] !== 0, Mt + 1 < Dt && Ut[$t + Tt] !== 0 ? (Zt = Vt[$t + Tt], ar ? (qt = Vt[$t - Tt], Qt = 1 - Zt - qt + Yt) : Qt = 1 - Zt - Zt + Yt) : ar ? (qt = Vt[$t - Tt], Qt = 1 - qt - qt + Yt) : Qt = Yt, Qt >= 0 ? (Jt = 9 + Qt, rr = this.decoder.readBit(this.contexts, Jt)) : (Jt = 9 - Qt, rr = this.decoder.readBit(this.contexts, Jt) ^ 1), rr;
            }
            runMagnitudeRefinementPass() {
              const Mt = this.decoder, Lt = this.width, $t = this.height, Tt = this.coefficentsMagnitude, Dt = this.neighborsSignificance, Ut = this.contexts, Vt = this.bitsDecoded, Qt = this.processingFlags, qt = 1, Zt = 2, ar = Lt * $t, Jt = Lt * 4;
              for (let rr = 0, Yt; rr < ar; rr = Yt) {
                Yt = Math.min(ar, rr + Jt);
                for (let Kt = 0; Kt < Lt; Kt++)
                  for (let nr = rr + Kt; nr < Yt; nr += Lt) {
                    if (!Tt[nr] || Qt[nr] & qt)
                      continue;
                    let tr = 16;
                    Qt[nr] & Zt && (Qt[nr] ^= Zt, tr = (Dt[nr] & 127) === 0 ? 15 : 14);
                    const ir = Mt.readBit(Ut, tr);
                    Tt[nr] = Tt[nr] << 1 | ir, Vt[nr]++, Qt[nr] |= qt;
                  }
              }
            }
            runCleanupPass() {
              const Mt = this.decoder, Lt = this.width, $t = this.height, Tt = this.neighborsSignificance, Dt = this.coefficentsMagnitude, Ut = this.coefficentsSign, Vt = this.contexts, Qt = this.contextLabelTable, qt = this.bitsDecoded, Zt = this.processingFlags, ar = 1, Jt = 2, rr = Lt, Yt = Lt * 2, Kt = Lt * 3;
              let nr;
              for (let tr = 0; tr < $t; tr = nr) {
                nr = Math.min(tr + 4, $t);
                const ir = tr * Lt, sr = tr + 3 < $t;
                for (let cr = 0; cr < Lt; cr++) {
                  const or = ir + cr, Xt = sr && Zt[or] === 0 && Zt[or + rr] === 0 && Zt[or + Yt] === 0 && Zt[or + Kt] === 0 && Tt[or] === 0 && Tt[or + rr] === 0 && Tt[or + Yt] === 0 && Tt[or + Kt] === 0;
                  let Gt = 0, Wt = or, er = tr, lr;
                  if (Xt) {
                    if (!Mt.readBit(Vt, _t.RUNLENGTH_CONTEXT)) {
                      qt[or]++, qt[or + rr]++, qt[or + Yt]++, qt[or + Kt]++;
                      continue;
                    }
                    Gt = Mt.readBit(Vt, _t.UNIFORM_CONTEXT) << 1 | Mt.readBit(Vt, _t.UNIFORM_CONTEXT), Gt !== 0 && (er = tr + Gt, Wt += Gt * Lt), lr = this.decodeSignBit(er, cr, Wt), Ut[Wt] = lr, Dt[Wt] = 1, this.setNeighborsSignificance(er, cr, Wt), Zt[Wt] |= Jt, Wt = or;
                    for (let pr = tr; pr <= er; pr++, Wt += Lt)
                      qt[Wt]++;
                    Gt++;
                  }
                  for (er = tr + Gt; er < nr; er++, Wt += Lt) {
                    if (Dt[Wt] || Zt[Wt] & ar)
                      continue;
                    const ur = Qt[Tt[Wt]];
                    Mt.readBit(Vt, ur) === 1 && (lr = this.decodeSignBit(er, cr, Wt), Ut[Wt] = lr, Dt[Wt] = 1, this.setNeighborsSignificance(er, cr, Wt), Zt[Wt] |= Jt), qt[Wt]++;
                  }
                }
              }
            }
            checkSegmentationSymbol() {
              const Mt = this.decoder, Lt = this.contexts;
              if ((Mt.readBit(Lt, _t.UNIFORM_CONTEXT) << 3 | Mt.readBit(Lt, _t.UNIFORM_CONTEXT) << 2 | Mt.readBit(Lt, _t.UNIFORM_CONTEXT) << 1 | Mt.readBit(Lt, _t.UNIFORM_CONTEXT)) !== 10)
                throw new et("Invalid segmentation symbol");
            }
          };
          Ln(_t, "UNIFORM_CONTEXT", 17), Ln(_t, "RUNLENGTH_CONTEXT", 18), Ln(_t, "LLAndLHContextsLabel", new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8])), Ln(_t, "HLContextLabel", new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8])), Ln(_t, "HHContextLabel", new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]));
          let kt = _t;
          class jt {
            constructor() {
              this.constructor === jt && (0, rt.unreachable)("Cannot initialize Transform.");
            }
            calculate(Mt, Lt, $t) {
              let Tt = Mt[0];
              for (let Dt = 1, Ut = Mt.length; Dt < Ut; Dt++)
                Tt = this.iterate(Tt, Mt[Dt], Lt, $t);
              return Tt;
            }
            extend(Mt, Lt, $t) {
              let Tt = Lt - 1, Dt = Lt + 1, Ut = Lt + $t - 2, Vt = Lt + $t;
              Mt[Tt--] = Mt[Dt++], Mt[Vt++] = Mt[Ut--], Mt[Tt--] = Mt[Dt++], Mt[Vt++] = Mt[Ut--], Mt[Tt--] = Mt[Dt++], Mt[Vt++] = Mt[Ut--], Mt[Tt] = Mt[Dt], Mt[Vt] = Mt[Ut];
            }
            filter(Mt, Lt, $t) {
              (0, rt.unreachable)("Abstract method `filter` called");
            }
            iterate(Mt, Lt, $t, Tt) {
              const Dt = Mt.width, Ut = Mt.height;
              let Vt = Mt.items;
              const Qt = Lt.width, qt = Lt.height, Zt = Lt.items;
              let ar, Jt, rr, Yt, Kt, nr;
              for (rr = 0, ar = 0; ar < Ut; ar++)
                for (Yt = ar * 2 * Qt, Jt = 0; Jt < Dt; Jt++, rr++, Yt += 2)
                  Zt[Yt] = Vt[rr];
              Vt = Mt.items = null;
              const tr = 4, ir = new Float32Array(Qt + 2 * tr);
              if (Qt === 1) {
                if ($t & 1)
                  for (nr = 0, rr = 0; nr < qt; nr++, rr += Qt)
                    Zt[rr] *= 0.5;
              } else
                for (nr = 0, rr = 0; nr < qt; nr++, rr += Qt)
                  ir.set(Zt.subarray(rr, rr + Qt), tr), this.extend(ir, tr, Qt), this.filter(ir, tr, Qt), Zt.set(ir.subarray(tr, tr + Qt), rr);
              let sr = 16;
              const cr = [];
              for (ar = 0; ar < sr; ar++)
                cr.push(new Float32Array(qt + 2 * tr));
              let or, Xt = 0;
              if (Mt = tr + qt, qt === 1) {
                if (Tt & 1)
                  for (Kt = 0; Kt < Qt; Kt++)
                    Zt[Kt] *= 0.5;
              } else
                for (Kt = 0; Kt < Qt; Kt++) {
                  if (Xt === 0) {
                    for (sr = Math.min(Qt - Kt, sr), rr = Kt, Yt = tr; Yt < Mt; rr += Qt, Yt++)
                      for (or = 0; or < sr; or++)
                        cr[or][Yt] = Zt[rr + or];
                    Xt = sr;
                  }
                  Xt--;
                  const Gt = cr[Xt];
                  if (this.extend(Gt, tr, qt), this.filter(Gt, tr, qt), Xt === 0)
                    for (rr = Kt - sr + 1, Yt = tr; Yt < Mt; rr += Qt, Yt++)
                      for (or = 0; or < sr; or++)
                        Zt[rr + or] = cr[or][Yt];
                }
              return {
                width: Qt,
                height: qt,
                items: Zt
              };
            }
          }
          class Ht extends jt {
            filter(Mt, Lt, $t) {
              const Tt = $t >> 1;
              Lt |= 0;
              let Dt, Ut, Vt, Qt;
              const qt = -1.586134342059924, Zt = -0.052980118572961, ar = 0.882911075530934, Jt = 0.443506852043971, rr = 1.230174104914001, Yt = 1 / rr;
              for (Dt = Lt - 3, Ut = Tt + 4; Ut--; Dt += 2)
                Mt[Dt] *= Yt;
              for (Dt = Lt - 2, Vt = Jt * Mt[Dt - 1], Ut = Tt + 3; Ut-- && (Qt = Jt * Mt[Dt + 1], Mt[Dt] = rr * Mt[Dt] - Vt - Qt, Ut--); Dt += 2)
                Dt += 2, Vt = Jt * Mt[Dt + 1], Mt[Dt] = rr * Mt[Dt] - Vt - Qt;
              for (Dt = Lt - 1, Vt = ar * Mt[Dt - 1], Ut = Tt + 2; Ut-- && (Qt = ar * Mt[Dt + 1], Mt[Dt] -= Vt + Qt, Ut--); Dt += 2)
                Dt += 2, Vt = ar * Mt[Dt + 1], Mt[Dt] -= Vt + Qt;
              for (Dt = Lt, Vt = Zt * Mt[Dt - 1], Ut = Tt + 1; Ut-- && (Qt = Zt * Mt[Dt + 1], Mt[Dt] -= Vt + Qt, Ut--); Dt += 2)
                Dt += 2, Vt = Zt * Mt[Dt + 1], Mt[Dt] -= Vt + Qt;
              if (Tt !== 0)
                for (Dt = Lt + 1, Vt = qt * Mt[Dt - 1], Ut = Tt; Ut-- && (Qt = qt * Mt[Dt + 1], Mt[Dt] -= Vt + Qt, Ut--); Dt += 2)
                  Dt += 2, Vt = qt * Mt[Dt + 1], Mt[Dt] -= Vt + Qt;
            }
          }
          class Ft extends jt {
            filter(Mt, Lt, $t) {
              const Tt = $t >> 1;
              Lt |= 0;
              let Dt, Ut;
              for (Dt = Lt, Ut = Tt + 1; Ut--; Dt += 2)
                Mt[Dt] -= Mt[Dt - 1] + Mt[Dt + 1] + 2 >> 2;
              for (Dt = Lt + 1, Ut = Tt; Ut--; Dt += 2)
                Mt[Dt] += Mt[Dt - 1] + Mt[Dt + 1] >> 1;
            }
          }
        },
        /* 182 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.LZWStream = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(169);
          class st extends rt.DecodeStream {
            constructor(et, it, ut) {
              super(it), this.str = et, this.dict = et.dict, this.cachedData = 0, this.bitsCached = 0;
              const ft = 4096, ht = {
                earlyChange: ut,
                codeLength: 9,
                nextCode: 258,
                dictionaryValues: new Uint8Array(ft),
                dictionaryLengths: new Uint16Array(ft),
                dictionaryPrevCodes: new Uint16Array(ft),
                currentSequence: new Uint8Array(ft),
                currentSequenceLength: 0
              };
              for (let dt = 0; dt < 256; ++dt)
                ht.dictionaryValues[dt] = dt, ht.dictionaryLengths[dt] = 1;
              this.lzwState = ht;
            }
            readBits(et) {
              let it = this.bitsCached, ut = this.cachedData;
              for (; it < et; ) {
                const ft = this.str.getByte();
                if (ft === -1)
                  return this.eof = !0, null;
                ut = ut << 8 | ft, it += 8;
              }
              return this.bitsCached = it -= et, this.cachedData = ut, this.lastCode = null, ut >>> it & (1 << et) - 1;
            }
            readBlock() {
              let ut = 1024, ft, ht, dt;
              const gt = this.lzwState;
              if (!gt)
                return;
              const pt = gt.earlyChange;
              let mt = gt.nextCode;
              const ct = gt.dictionaryValues, vt = gt.dictionaryLengths, At = gt.dictionaryPrevCodes;
              let xt = gt.codeLength, bt = gt.prevCode;
              const Et = gt.currentSequence;
              let St = gt.currentSequenceLength, Bt = 0, Ot = this.bufferLength, Pt = this.ensureBuffer(this.bufferLength + ut);
              for (ft = 0; ft < 512; ft++) {
                const wt = this.readBits(xt), Ct = St > 0;
                if (wt < 256)
                  Et[0] = wt, St = 1;
                else if (wt >= 258)
                  if (wt < mt)
                    for (St = vt[wt], ht = St - 1, dt = wt; ht >= 0; ht--)
                      Et[ht] = ct[dt], dt = At[dt];
                  else
                    Et[St++] = Et[0];
                else if (wt === 256) {
                  xt = 9, mt = 258, St = 0;
                  continue;
                } else {
                  this.eof = !0, delete this.lzwState;
                  break;
                }
                if (Ct && (At[mt] = bt, vt[mt] = vt[bt] + 1, ct[mt] = Et[0], mt++, xt = mt + pt & mt + pt - 1 ? xt : Math.min(Math.log(mt + pt) / 0.6931471805599453 + 1, 12) | 0), bt = wt, Bt += St, ut < Bt) {
                  do
                    ut += 512;
                  while (ut < Bt);
                  Pt = this.ensureBuffer(this.bufferLength + ut);
                }
                for (ht = 0; ht < St; ht++)
                  Pt[Ot++] = Et[ht];
              }
              gt.nextCode = mt, gt.codeLength = xt, gt.prevCode = bt, gt.currentSequenceLength = St, this.bufferLength = Ot;
            }
          }
          at.LZWStream = st;
        },
        /* 183 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.PredictorStream = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(169), st = ot(151), lt = ot(145);
          class et extends rt.DecodeStream {
            constructor(ut, ft, ht) {
              if (super(ft), !(ht instanceof st.Dict))
                return ut;
              const dt = this.predictor = ht.get("Predictor") || 1;
              if (dt <= 1)
                return ut;
              if (dt !== 2 && (dt < 10 || dt > 15))
                throw new lt.FormatError(`Unsupported predictor: ${dt}`);
              this.readBlock = dt === 2 ? this.readBlockTiff : this.readBlockPng, this.str = ut, this.dict = ut.dict;
              const gt = this.colors = ht.get("Colors") || 1, pt = this.bits = ht.get("BPC", "BitsPerComponent") || 8, mt = this.columns = ht.get("Columns") || 1;
              return this.pixBytes = gt * pt + 7 >> 3, this.rowBytes = mt * gt * pt + 7 >> 3, this;
            }
            readBlockTiff() {
              const ut = this.rowBytes, ft = this.bufferLength, ht = this.ensureBuffer(ft + ut), dt = this.bits, gt = this.colors, pt = this.str.getBytes(ut);
              if (this.eof = !pt.length, this.eof)
                return;
              let mt = 0, ct = 0, vt = 0, At = 0, xt = ft, bt;
              if (dt === 1 && gt === 1)
                for (bt = 0; bt < ut; ++bt) {
                  let Et = pt[bt] ^ mt;
                  Et ^= Et >> 1, Et ^= Et >> 2, Et ^= Et >> 4, mt = (Et & 1) << 7, ht[xt++] = Et;
                }
              else if (dt === 8) {
                for (bt = 0; bt < gt; ++bt)
                  ht[xt++] = pt[bt];
                for (; bt < ut; ++bt)
                  ht[xt] = ht[xt - gt] + pt[bt], xt++;
              } else if (dt === 16) {
                const Et = gt * 2;
                for (bt = 0; bt < Et; ++bt)
                  ht[xt++] = pt[bt];
                for (; bt < ut; bt += 2) {
                  const St = ((pt[bt] & 255) << 8) + (pt[bt + 1] & 255) + ((ht[xt - Et] & 255) << 8) + (ht[xt - Et + 1] & 255);
                  ht[xt++] = St >> 8 & 255, ht[xt++] = St & 255;
                }
              } else {
                const Et = new Uint8Array(gt + 1), St = (1 << dt) - 1;
                let Bt = 0, Ot = ft;
                const Pt = this.columns;
                for (bt = 0; bt < Pt; ++bt)
                  for (let wt = 0; wt < gt; ++wt)
                    vt < dt && (mt = mt << 8 | pt[Bt++] & 255, vt += 8), Et[wt] = Et[wt] + (mt >> vt - dt) & St, vt -= dt, ct = ct << dt | Et[wt], At += dt, At >= 8 && (ht[Ot++] = ct >> At - 8 & 255, At -= 8);
                At > 0 && (ht[Ot++] = (ct << 8 - At) + (mt & (1 << 8 - At) - 1));
              }
              this.bufferLength += ut;
            }
            readBlockPng() {
              const ut = this.rowBytes, ft = this.pixBytes, ht = this.str.getByte(), dt = this.str.getBytes(ut);
              if (this.eof = !dt.length, this.eof)
                return;
              const gt = this.bufferLength, pt = this.ensureBuffer(gt + ut);
              let mt = pt.subarray(gt - ut, gt);
              mt.length === 0 && (mt = new Uint8Array(ut));
              let ct, vt = gt, At, xt;
              switch (ht) {
                case 0:
                  for (ct = 0; ct < ut; ++ct)
                    pt[vt++] = dt[ct];
                  break;
                case 1:
                  for (ct = 0; ct < ft; ++ct)
                    pt[vt++] = dt[ct];
                  for (; ct < ut; ++ct)
                    pt[vt] = pt[vt - ft] + dt[ct] & 255, vt++;
                  break;
                case 2:
                  for (ct = 0; ct < ut; ++ct)
                    pt[vt++] = mt[ct] + dt[ct] & 255;
                  break;
                case 3:
                  for (ct = 0; ct < ft; ++ct)
                    pt[vt++] = (mt[ct] >> 1) + dt[ct];
                  for (; ct < ut; ++ct)
                    pt[vt] = (mt[ct] + pt[vt - ft] >> 1) + dt[ct] & 255, vt++;
                  break;
                case 4:
                  for (ct = 0; ct < ft; ++ct)
                    At = mt[ct], xt = dt[ct], pt[vt++] = At + xt;
                  for (; ct < ut; ++ct) {
                    At = mt[ct];
                    const bt = mt[ct - ft], Et = pt[vt - ft], St = Et + At - bt;
                    let Bt = St - Et;
                    Bt < 0 && (Bt = -Bt);
                    let Ot = St - At;
                    Ot < 0 && (Ot = -Ot);
                    let Pt = St - bt;
                    Pt < 0 && (Pt = -Pt), xt = dt[ct], Bt <= Ot && Bt <= Pt ? pt[vt++] = Et + xt : Ot <= Pt ? pt[vt++] = At + xt : pt[vt++] = bt + xt;
                  }
                  break;
                default:
                  throw new lt.FormatError(`Unsupported predictor: ${ht}`);
              }
              this.bufferLength += ut;
            }
          }
          at.PredictorStream = et;
        },
        /* 184 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.RunLengthStream = void 0;
          var rt = ot(169);
          class st extends rt.DecodeStream {
            constructor(et, it) {
              super(it), this.str = et, this.dict = et.dict;
            }
            readBlock() {
              const et = this.str.getBytes(2);
              if (!et || et.length < 2 || et[0] === 128) {
                this.eof = !0;
                return;
              }
              let it, ut = this.bufferLength, ft = et[0];
              if (ft < 128) {
                if (it = this.ensureBuffer(ut + ft + 1), it[ut++] = et[1], ft > 0) {
                  const ht = this.str.getBytes(ft);
                  it.set(ht, ut), ut += ft;
                }
              } else {
                ft = 257 - ft;
                const ht = et[1];
                it = this.ensureBuffer(ut + ft + 1);
                for (let dt = 0; dt < ft; dt++)
                  it[ut++] = ht;
              }
              this.bufferLength = ut;
            }
          }
          at.RunLengthStream = st;
        },
        /* 185 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Font = at.ErrorFont = void 0, ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138), ot(140), ot(158), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(145), st = ot(186), lt = ot(189), et = ot(191), it = ot(190), ut = ot(188), ft = ot(192), ht = ot(193), dt = ot(194), gt = ot(195), pt = ot(196), mt = ot(197), ct = ot(165), vt = ot(198), At = ot(150), xt = ot(155), bt = ot(199);
          const Et = [[57344, 63743], [1048576, 1114109]], St = 1e3, Bt = ["ascent", "bbox", "black", "bold", "charProcOperatorList", "composite", "cssFontInfo", "data", "defaultVMetrics", "defaultWidth", "descent", "fallbackName", "fontMatrix", "isInvalidPDFjsFont", "isType3Font", "italic", "loadedName", "mimetype", "missingFile", "name", "remeasure", "subtype", "systemFontInfo", "type", "vertical"], Ot = ["cMap", "defaultEncoding", "differences", "isMonospace", "isSerifFont", "isSymbolicFont", "seacMap", "toFontChar", "toUnicode", "vmetrics", "widths"];
          function Pt(or) {
            if (!or.fontMatrix || or.fontMatrix[0] === rt.FONT_IDENTITY_MATRIX[0])
              return;
            const Xt = 1e-3 / or.fontMatrix[0], Gt = or.widths;
            for (const Wt in Gt)
              Gt[Wt] *= Xt;
            or.defaultWidth *= Xt;
          }
          function wt(or, Xt, Gt) {
            if (or.isInternalFont || or.hasIncludedToUnicodeMap || or.hasEncoding || or.toUnicode instanceof ht.IdentityToUnicodeMap || !Xt || Gt.length === 0 || or.defaultEncoding === ut.WinAnsiEncoding)
              return;
            for (const ur of Gt)
              if (!qt(ur))
                return;
            const Wt = ut.WinAnsiEncoding, er = [], lr = (0, it.getGlyphsUnicode)();
            for (const ur in Wt) {
              const pr = Wt[ur];
              if (pr === "")
                continue;
              const yr = lr[pr];
              yr !== void 0 && (er[ur] = String.fromCharCode(yr));
            }
            er.length > 0 && or.toUnicode.amend(er);
          }
          function Ct(or, Xt) {
            if (or.isInternalFont || or.hasIncludedToUnicodeMap || Xt === or.defaultEncoding || or.toUnicode instanceof ht.IdentityToUnicodeMap)
              return;
            const Gt = [], Wt = (0, it.getGlyphsUnicode)();
            for (const er in Xt) {
              if (or.hasEncoding && (or.baseEncodingName || or.differences[er] !== void 0))
                continue;
              const lr = Xt[er], ur = (0, et.getUnicodeForGlyph)(lr, Wt);
              ur !== -1 && (Gt[er] = String.fromCharCode(ur));
            }
            Gt.length > 0 && or.toUnicode.amend(Gt);
          }
          function It(or) {
            if (!or.fallbackToUnicode || or.toUnicode instanceof ht.IdentityToUnicodeMap)
              return;
            const Xt = [];
            for (const Gt in or.fallbackToUnicode)
              or.toUnicode.has(Gt) || (Xt[Gt] = or.fallbackToUnicode[Gt]);
            Xt.length > 0 && or.toUnicode.amend(Xt);
          }
          class yt {
            constructor(Xt, Gt, Wt, er, lr, ur, pr, yr, Er) {
              this.originalCharCode = Xt, this.fontChar = Gt, this.unicode = Wt, this.accent = er, this.width = lr, this.vmetric = ur, this.operatorListId = pr, this.isSpace = yr, this.isInFont = Er;
            }
            get category() {
              return (0, rt.shadow)(this, "category", (0, et.getCharUnicodeCategory)(this.unicode), !0);
            }
          }
          function Rt(or, Xt) {
            return (or << 8) + Xt;
          }
          function kt(or, Xt, Gt) {
            or[Xt + 1] = Gt, or[Xt] = Gt >>> 8;
          }
          function jt(or, Xt) {
            const Gt = (or << 8) + Xt;
            return Gt & 32768 ? Gt - 65536 : Gt;
          }
          function Ht(or, Xt, Gt, Wt) {
            return (or << 24) + (Xt << 16) + (Gt << 8) + Wt;
          }
          function Ft(or) {
            return String.fromCharCode(or >> 8 & 255, or & 255);
          }
          function _t(or) {
            return or > 32767 ? or = 32767 : or < -32768 && (or = -32768), String.fromCharCode(or >> 8 & 255, or & 255);
          }
          function Nt(or) {
            const Xt = or.peekBytes(4);
            return (0, At.readUint32)(Xt, 0) === 65536 || (0, rt.bytesToString)(Xt) === "true";
          }
          function Mt(or) {
            const Xt = or.peekBytes(4);
            return (0, rt.bytesToString)(Xt) === "ttcf";
          }
          function Lt(or) {
            const Xt = or.peekBytes(4);
            return (0, rt.bytesToString)(Xt) === "OTTO";
          }
          function $t(or) {
            const Xt = or.peekBytes(2);
            return Xt[0] === 37 && Xt[1] === 33 || Xt[0] === 128 && Xt[1] === 1;
          }
          function Tt(or) {
            const Xt = or.peekBytes(4);
            return Xt[0] >= 1 && Xt[3] >= 1 && Xt[3] <= 4;
          }
          function Dt(or, Xt) {
            let {
              type: Gt,
              subtype: Wt,
              composite: er
            } = Xt, lr, ur;
            return Nt(or) || Mt(or) ? lr = er ? "CIDFontType2" : "TrueType" : Lt(or) ? lr = er ? "CIDFontType2" : "OpenType" : $t(or) ? er ? lr = "CIDFontType0" : lr = Gt === "MMType1" ? "MMType1" : "Type1" : Tt(or) ? er ? (lr = "CIDFontType0", ur = "CIDFontType0C") : (lr = Gt === "MMType1" ? "MMType1" : "Type1", ur = "Type1C") : ((0, rt.warn)("getFontFileType: Unable to detect correct font file Type/Subtype."), lr = Gt, ur = Wt), [lr, ur];
          }
          function Ut(or, Xt) {
            for (const Gt in Xt)
              or[+Gt] = Xt[Gt];
          }
          function Vt(or, Xt, Gt) {
            const Wt = [];
            let er;
            for (let lr = 0, ur = or.length; lr < ur; lr++)
              er = (0, et.getUnicodeForGlyph)(or[lr], Xt), er !== -1 && (Wt[lr] = er);
            for (const lr in Gt)
              er = (0, et.getUnicodeForGlyph)(Gt[lr], Xt), er !== -1 && (Wt[+lr] = er);
            return Wt;
          }
          function Qt(or) {
            return or.platform === 1 && or.encoding === 0 && or.language === 0;
          }
          function qt(or) {
            return or.platform === 3 && or.encoding === 1 && or.language === 1033;
          }
          function Zt(or, Xt) {
            let Gt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            switch (Xt.length) {
              case 1:
                return Xt.charCodeAt(0);
              case 2:
                return Xt.charCodeAt(0) << 8 | Xt.charCodeAt(1);
            }
            const Wt = `Unsupported CID string (charCode ${or}): "${Xt}".`;
            if (Gt)
              throw new rt.FormatError(Wt);
            return (0, rt.warn)(Wt), Xt;
          }
          function ar(or, Xt, Gt, Wt) {
            const er = /* @__PURE__ */ Object.create(null), lr = /* @__PURE__ */ new Map(), ur = [], pr = /* @__PURE__ */ new Set();
            let yr = 0, br = Et[yr][0], gr = Et[yr][1];
            const Ar = (Sr) => Et[0][0] <= Sr && Sr <= Et[0][1] || Et[1][0] <= Sr && Sr <= Et[1][1];
            for (let Sr in or) {
              Sr |= 0;
              let Br = or[Sr];
              if (!Xt(Br))
                continue;
              if (br > gr) {
                if (yr++, yr >= Et.length) {
                  (0, rt.warn)("Ran out of space in font private use area.");
                  break;
                }
                br = Et[yr][0], gr = Et[yr][1];
              }
              const Ir = br++;
              Br === 0 && (Br = Gt);
              let hr = Wt.get(Sr);
              typeof hr == "string" && (hr = hr.codePointAt(0)), hr && !Ar(hr) && !pr.has(Br) && (lr.set(hr, Br), pr.add(Br)), er[Ir] = Br, ur[Sr] = Ir;
            }
            return {
              toFontChar: ur,
              charCodeToGlyphId: er,
              toUnicodeExtraMap: lr,
              nextAvailableFontCharCode: br
            };
          }
          function Jt(or, Xt, Gt) {
            const Wt = [];
            for (const ur in or)
              or[ur] >= Gt || Wt.push({
                fontCharCode: ur | 0,
                glyphId: or[ur]
              });
            if (Xt)
              for (const [ur, pr] of Xt)
                pr >= Gt || Wt.push({
                  fontCharCode: ur,
                  glyphId: pr
                });
            Wt.length === 0 && Wt.push({
              fontCharCode: 0,
              glyphId: 0
            }), Wt.sort(function(pr, yr) {
              return pr.fontCharCode - yr.fontCharCode;
            });
            const er = [], lr = Wt.length;
            for (let ur = 0; ur < lr; ) {
              const pr = Wt[ur].fontCharCode, yr = [Wt[ur].glyphId];
              ++ur;
              let Er = pr;
              for (; ur < lr && Er + 1 === Wt[ur].fontCharCode && (yr.push(Wt[ur].glyphId), ++Er, ++ur, Er !== 65535); )
                ;
              er.push([pr, Er, yr]);
            }
            return er;
          }
          function rr(or, Xt, Gt) {
            const Wt = Jt(or, Xt, Gt), er = Wt.at(-1)[1] > 65535 ? 2 : 1;
            let lr = "\0\0" + Ft(er) + "\0\0" + (0, rt.string32)(4 + er * 8), ur, pr, yr, Er;
            for (ur = Wt.length - 1; ur >= 0 && !(Wt[ur][0] <= 65535); --ur)
              ;
            const br = ur + 1;
            Wt[ur][0] < 65535 && Wt[ur][1] === 65535 && (Wt[ur][1] = 65534);
            const gr = Wt[ur][1] < 65535 ? 1 : 0, Ar = br + gr, Sr = vt.OpenTypeFileBuilder.getSearchParams(Ar, 2);
            let Br = "", Ir = "", hr = "", vr = "", xr = "", Pr = 0, Rr, Dr, Gr, Or;
            for (ur = 0, pr = br; ur < pr; ur++) {
              Rr = Wt[ur], Dr = Rr[0], Gr = Rr[1], Br += Ft(Dr), Ir += Ft(Gr), Or = Rr[2];
              let fr = !0;
              for (yr = 1, Er = Or.length; yr < Er; ++yr)
                if (Or[yr] !== Or[yr - 1] + 1) {
                  fr = !1;
                  break;
                }
              if (fr) {
                const Cr = Or[0];
                hr += Ft(Cr - Dr & 65535), vr += Ft(0);
              } else {
                const Cr = (Ar - ur) * 2 + Pr * 2;
                for (Pr += Gr - Dr + 1, hr += Ft(0), vr += Ft(Cr), yr = 0, Er = Or.length; yr < Er; ++yr)
                  xr += Ft(Or[yr]);
              }
            }
            gr > 0 && (Ir += "ÿÿ", Br += "ÿÿ", hr += "\0", vr += "\0\0");
            const Hr = "\0\0" + Ft(2 * Ar) + Ft(Sr.range) + Ft(Sr.entry) + Ft(Sr.rangeShift) + Ir + "\0\0" + Br + hr + vr + xr;
            let jr = "", Tr = "";
            if (er > 1) {
              for (lr += `\0\0
` + (0, rt.string32)(4 + er * 8 + 4 + Hr.length), jr = "", ur = 0, pr = Wt.length; ur < pr; ur++) {
                Rr = Wt[ur], Dr = Rr[0], Or = Rr[2];
                let fr = Or[0];
                for (yr = 1, Er = Or.length; yr < Er; ++yr)
                  Or[yr] !== Or[yr - 1] + 1 && (Gr = Rr[0] + yr - 1, jr += (0, rt.string32)(Dr) + (0, rt.string32)(Gr) + (0, rt.string32)(fr), Dr = Gr + 1, fr = Or[yr]);
                jr += (0, rt.string32)(Dr) + (0, rt.string32)(Rr[1]) + (0, rt.string32)(fr);
              }
              Tr = "\0\f\0\0" + (0, rt.string32)(jr.length + 16) + "\0\0\0\0" + (0, rt.string32)(jr.length / 12);
            }
            return lr + "\0" + Ft(Hr.length + 4) + Hr + Tr + jr;
          }
          function Yt(or, Xt) {
            Xt.pos = (Xt.start || 0) + or.offset;
            const Gt = Xt.getUint16();
            Xt.skip(60);
            const Wt = Xt.getUint16();
            if (Gt < 4 && Wt & 768)
              return !1;
            const er = Xt.getUint16(), lr = Xt.getUint16();
            return er > lr || (Xt.skip(6), Xt.getUint16() === 0) ? !1 : (or.data[8] = or.data[9] = 0, !0);
          }
          function Kt(or, Xt, Gt) {
            Gt || (Gt = {
              unitsPerEm: 0,
              yMax: 0,
              yMin: 0,
              ascent: 0,
              descent: 0
            });
            let Wt = 0, er = 0, lr = 0, ur = 0, pr = null, yr = 0, Er = -1;
            if (Xt) {
              for (let vr in Xt)
                if (vr |= 0, (pr > vr || !pr) && (pr = vr), yr < vr && (yr = vr), Er = (0, et.getUnicodeRangeFor)(vr, Er), Er < 32)
                  Wt |= 1 << Er;
                else if (Er < 64)
                  er |= 1 << Er - 32;
                else if (Er < 96)
                  lr |= 1 << Er - 64;
                else if (Er < 123)
                  ur |= 1 << Er - 96;
                else
                  throw new rt.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
              yr > 65535 && (yr = 65535);
            } else
              pr = 0, yr = 255;
            const br = or.bbox || [0, 0, 0, 0], gr = Gt.unitsPerEm || 1 / (or.fontMatrix || rt.FONT_IDENTITY_MATRIX)[0], Ar = or.ascentScaled ? 1 : gr / St, Sr = Gt.ascent || Math.round(Ar * (or.ascent || br[3]));
            let Br = Gt.descent || Math.round(Ar * (or.descent || br[1]));
            Br > 0 && or.descent > 0 && br[1] < 0 && (Br = -Br);
            const Ir = Gt.yMax || Sr, hr = -Gt.yMin || -Br;
            return "\0$ô\0\0\0»\0\0\0»\0\0ß\x001\0\0\0\0" + String.fromCharCode(or.fixedPitch ? 9 : 0) + "\0\0\0\0\0\0" + (0, rt.string32)(Wt) + (0, rt.string32)(er) + (0, rt.string32)(lr) + (0, rt.string32)(ur) + "*21*" + Ft(or.italicAngle ? 1 : 0) + Ft(pr || or.firstChar) + Ft(yr || or.lastChar) + Ft(Sr) + Ft(Br) + "\0d" + Ft(Ir) + Ft(hr) + "\0\0\0\0\0\0\0\0" + Ft(or.xHeight) + Ft(or.capHeight) + Ft(0) + Ft(pr || or.firstChar) + "\0";
          }
          function nr(or) {
            const Xt = Math.floor(or.italicAngle * 65536);
            return "\0\0\0" + (0, rt.string32)(Xt) + "\0\0\0\0" + (0, rt.string32)(or.fixedPitch ? 1 : 0) + "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
          }
          function tr(or) {
            return or.replaceAll(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
          }
          function ir(or, Xt) {
            Xt || (Xt = [[], []]);
            const Gt = [Xt[0][0] || "Original licence", Xt[0][1] || or, Xt[0][2] || "Unknown", Xt[0][3] || "uniqueID", Xt[0][4] || or, Xt[0][5] || "Version 0.11", Xt[0][6] || tr(or), Xt[0][7] || "Unknown", Xt[0][8] || "Unknown", Xt[0][9] || "Unknown"], Wt = [];
            let er, lr, ur, pr, yr;
            for (er = 0, lr = Gt.length; er < lr; er++) {
              yr = Xt[1][er] || Gt[er];
              const hr = [];
              for (ur = 0, pr = yr.length; ur < pr; ur++)
                hr.push(Ft(yr.charCodeAt(ur)));
              Wt.push(hr.join(""));
            }
            const Er = [Gt, Wt], br = ["\0", "\0"], gr = ["\0\0", "\0"], Ar = ["\0\0", "	"], Sr = Gt.length * br.length;
            let Br = "\0\0" + Ft(Sr) + Ft(Sr * 12 + 6), Ir = 0;
            for (er = 0, lr = br.length; er < lr; er++) {
              const hr = Er[er];
              for (ur = 0, pr = hr.length; ur < pr; ur++) {
                yr = hr[ur];
                const vr = br[er] + gr[er] + Ar[er] + Ft(ur) + Ft(yr.length) + Ft(Ir);
                Br += vr, Ir += yr.length;
              }
            }
            return Br += Gt.join("") + Wt.join(""), Br;
          }
          class sr {
            constructor(Xt, Gt, Wt) {
              var Er;
              this.name = Xt, this.psName = null, this.mimetype = null, this.disableFontFace = !1, this.loadedName = Wt.loadedName, this.isType3Font = Wt.isType3Font, this.missingFile = !1, this.cssFontInfo = Wt.cssFontInfo, this._charsCache = /* @__PURE__ */ Object.create(null), this._glyphCache = /* @__PURE__ */ Object.create(null);
              let er = !!(Wt.flags & lt.FontFlags.Serif);
              if (!er && !Wt.isSimulatedFlags) {
                const br = Xt.replaceAll(/[,_]/g, "-").split("-")[0], gr = (0, ft.getSerifFonts)();
                for (const Ar of br.split("+"))
                  if (gr[Ar]) {
                    er = !0;
                    break;
                  }
              }
              this.isSerifFont = er, this.isSymbolicFont = !!(Wt.flags & lt.FontFlags.Symbolic), this.isMonospace = !!(Wt.flags & lt.FontFlags.FixedPitch);
              let {
                type: lr,
                subtype: ur
              } = Wt;
              this.type = lr, this.subtype = ur, this.systemFontInfo = Wt.systemFontInfo;
              const pr = Xt.match(/^InvalidPDFjsFont_(.*)_\d+$/);
              if (this.isInvalidPDFjsFont = !!pr, this.isInvalidPDFjsFont ? this.fallbackName = pr[1] : this.isMonospace ? this.fallbackName = "monospace" : this.isSerifFont ? this.fallbackName = "serif" : this.fallbackName = "sans-serif", (Er = this.systemFontInfo) != null && Er.guessFallback && (this.systemFontInfo.guessFallback = !1, this.systemFontInfo.css += `,${this.fallbackName}`), this.differences = Wt.differences, this.widths = Wt.widths, this.defaultWidth = Wt.defaultWidth, this.composite = Wt.composite, this.cMap = Wt.cMap, this.capHeight = Wt.capHeight / St, this.ascent = Wt.ascent / St, this.descent = Wt.descent / St, this.lineHeight = this.ascent - this.descent, this.fontMatrix = Wt.fontMatrix, this.bbox = Wt.bbox, this.defaultEncoding = Wt.defaultEncoding, this.toUnicode = Wt.toUnicode, this.toFontChar = [], Wt.type === "Type3") {
                for (let br = 0; br < 256; br++)
                  this.toFontChar[br] = this.differences[br] || Wt.defaultEncoding[br];
                return;
              }
              if (this.cidEncoding = Wt.cidEncoding || "", this.vertical = !!Wt.vertical, this.vertical && (this.vmetrics = Wt.vmetrics, this.defaultVMetrics = Wt.defaultVMetrics), !Gt || Gt.isEmpty) {
                Gt && (0, rt.warn)('Font file is empty in "' + Xt + '" (' + this.loadedName + ")"), this.fallbackToSystemFont(Wt);
                return;
              }
              [lr, ur] = Dt(Gt, Wt), (lr !== this.type || ur !== this.subtype) && (0, rt.info)(`Inconsistent font file Type/SubType, expected: ${this.type}/${this.subtype} but found: ${lr}/${ur}.`);
              let yr;
              try {
                switch (lr) {
                  case "MMType1":
                    (0, rt.info)("MMType1 font (" + Xt + "), falling back to Type1.");
                  case "Type1":
                  case "CIDFontType0":
                    this.mimetype = "font/opentype";
                    const br = ur === "Type1C" || ur === "CIDFontType0C" ? new dt.CFFFont(Gt, Wt) : new bt.Type1Font(Xt, Gt, Wt);
                    Pt(Wt), yr = this.convert(Xt, br, Wt);
                    break;
                  case "OpenType":
                  case "TrueType":
                  case "CIDFontType2":
                    this.mimetype = "font/opentype", yr = this.checkAndRepair(Xt, Gt, Wt), this.isOpenType && (Pt(Wt), lr = "OpenType");
                    break;
                  default:
                    throw new rt.FormatError(`Font ${lr} is not supported`);
                }
              } catch (br) {
                (0, rt.warn)(br), this.fallbackToSystemFont(Wt);
                return;
              }
              It(Wt), this.data = yr, this.type = lr, this.subtype = ur, this.fontMatrix = Wt.fontMatrix, this.widths = Wt.widths, this.defaultWidth = Wt.defaultWidth, this.toUnicode = Wt.toUnicode, this.seacMap = Wt.seacMap;
            }
            get renderer() {
              const Xt = gt.FontRendererFactory.create(this, lt.SEAC_ANALYSIS_ENABLED);
              return (0, rt.shadow)(this, "renderer", Xt);
            }
            exportData() {
              const Gt = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) ? [...Bt, ...Ot] : Bt, Wt = /* @__PURE__ */ Object.create(null);
              let er, lr;
              for (er of Gt)
                lr = this[er], lr !== void 0 && (Wt[er] = lr);
              return Wt;
            }
            fallbackToSystemFont(Xt) {
              this.missingFile = !0;
              const {
                name: Gt,
                type: Wt
              } = this;
              let er = (0, lt.normalizeFontName)(Gt);
              const lr = (0, ft.getStdFontMap)(), ur = (0, ft.getNonStdFontMap)(), pr = !!lr[er], yr = !!(ur[er] && lr[ur[er]]);
              er = lr[er] || ur[er] || er;
              const br = (0, pt.getFontBasicMetrics)()[er];
              br && (isNaN(this.ascent) && (this.ascent = br.ascent / St), isNaN(this.descent) && (this.descent = br.descent / St), isNaN(this.capHeight) && (this.capHeight = br.capHeight / St)), this.bold = /bold/gi.test(er), this.italic = /oblique|italic/gi.test(er), this.black = /Black/g.test(Gt);
              const gr = /Narrow/g.test(Gt);
              if (this.remeasure = (!pr || gr) && Object.keys(this.widths).length > 0, (pr || yr) && Wt === "CIDFontType2" && this.cidEncoding.startsWith("Identity-")) {
                const Ar = Xt.cidToGidMap, Sr = [];
                if (Ut(Sr, (0, ft.getGlyphMapForStandardFonts)()), /Arial-?Black/i.test(Gt) ? Ut(Sr, (0, ft.getSupplementalGlyphMapForArialBlack)()) : /Calibri/i.test(Gt) && Ut(Sr, (0, ft.getSupplementalGlyphMapForCalibri)()), Ar) {
                  for (const Br in Sr) {
                    const Ir = Sr[Br];
                    Ar[Ir] !== void 0 && (Sr[+Br] = Ar[Ir]);
                  }
                  Ar.length !== this.toUnicode.length && Xt.hasIncludedToUnicodeMap && this.toUnicode instanceof ht.IdentityToUnicodeMap && this.toUnicode.forEach(function(Br, Ir) {
                    const hr = Sr[Br];
                    Ar[hr] === void 0 && (Sr[+Br] = Ir);
                  });
                }
                this.toUnicode instanceof ht.IdentityToUnicodeMap || this.toUnicode.forEach(function(Br, Ir) {
                  Sr[+Br] = Ir;
                }), this.toFontChar = Sr, this.toUnicode = new ht.ToUnicodeMap(Sr);
              } else if (/Symbol/i.test(er))
                this.toFontChar = Vt(ut.SymbolSetEncoding, (0, it.getGlyphsUnicode)(), this.differences);
              else if (/Dingbats/i.test(er))
                this.toFontChar = Vt(ut.ZapfDingbatsEncoding, (0, it.getDingbatsGlyphsUnicode)(), this.differences);
              else if (pr) {
                const Ar = Vt(this.defaultEncoding, (0, it.getGlyphsUnicode)(), this.differences);
                Wt === "CIDFontType2" && !this.cidEncoding.startsWith("Identity-") && !(this.toUnicode instanceof ht.IdentityToUnicodeMap) && this.toUnicode.forEach(function(Sr, Br) {
                  Ar[+Sr] = Br;
                }), this.toFontChar = Ar;
              } else {
                const Ar = (0, it.getGlyphsUnicode)(), Sr = [];
                this.toUnicode.forEach((Br, Ir) => {
                  if (!this.composite) {
                    const hr = this.differences[Br] || this.defaultEncoding[Br], vr = (0, et.getUnicodeForGlyph)(hr, Ar);
                    vr !== -1 && (Ir = vr);
                  }
                  Sr[+Br] = Ir;
                }), this.composite && this.toUnicode instanceof ht.IdentityToUnicodeMap && /Tahoma|Verdana/i.test(Gt) && Ut(Sr, (0, ft.getGlyphMapForStandardFonts)()), this.toFontChar = Sr;
              }
              It(Xt), this.loadedName = er.split("-")[0];
            }
            checkAndRepair(Xt, Gt, Wt) {
              var an, Zr, un;
              const er = ["OS/2", "cmap", "head", "hhea", "hmtx", "maxp", "name", "post", "loca", "glyf", "fpgm", "prep", "cvt ", "CFF "];
              function lr(Xr, Kr) {
                const rn = /* @__PURE__ */ Object.create(null);
                rn["OS/2"] = null, rn.cmap = null, rn.head = null, rn.hhea = null, rn.hmtx = null, rn.maxp = null, rn.name = null, rn.post = null;
                for (let nn = 0; nn < Kr; nn++) {
                  const sn = ur(Xr);
                  er.includes(sn.tag) && sn.length !== 0 && (rn[sn.tag] = sn);
                }
                return rn;
              }
              function ur(Xr) {
                const Kr = Xr.getString(4), rn = Xr.getInt32() >>> 0, nn = Xr.getInt32() >>> 0, sn = Xr.getInt32() >>> 0, gn = Xr.pos;
                Xr.pos = Xr.start || 0, Xr.skip(nn);
                const en = Xr.getBytes(sn);
                return Xr.pos = gn, Kr === "head" && (en[8] = en[9] = en[10] = en[11] = 0, en[17] |= 32), {
                  tag: Kr,
                  checksum: rn,
                  length: sn,
                  offset: nn,
                  data: en
                };
              }
              function pr(Xr) {
                return {
                  version: Xr.getString(4),
                  numTables: Xr.getUint16(),
                  searchRange: Xr.getUint16(),
                  entrySelector: Xr.getUint16(),
                  rangeShift: Xr.getUint16()
                };
              }
              function yr(Xr) {
                const Kr = Xr.getString(4);
                (0, rt.assert)(Kr === "ttcf", "Must be a TrueType Collection font.");
                const rn = Xr.getUint16(), nn = Xr.getUint16(), sn = Xr.getInt32() >>> 0, gn = [];
                for (let Wr = 0; Wr < sn; Wr++)
                  gn.push(Xr.getInt32() >>> 0);
                const en = {
                  ttcTag: Kr,
                  majorVersion: rn,
                  minorVersion: nn,
                  numFonts: sn,
                  offsetTable: gn
                };
                switch (rn) {
                  case 1:
                    return en;
                  case 2:
                    return en.dsigTag = Xr.getInt32() >>> 0, en.dsigLength = Xr.getInt32() >>> 0, en.dsigOffset = Xr.getInt32() >>> 0, en;
                }
                throw new rt.FormatError(`Invalid TrueType Collection majorVersion: ${rn}.`);
              }
              function Er(Xr, Kr) {
                var en;
                const {
                  numFonts: rn,
                  offsetTable: nn
                } = yr(Xr), sn = Kr.split("+");
                let gn;
                for (let Wr = 0; Wr < rn; Wr++) {
                  Xr.pos = (Xr.start || 0) + nn[Wr];
                  const dn = pr(Xr), hn = lr(Xr, dn.numTables);
                  if (!hn.name)
                    throw new rt.FormatError('TrueType Collection font must contain a "name" table.');
                  const [En] = hr(hn.name);
                  for (let bn = 0, Cn = En.length; bn < Cn; bn++)
                    for (let wn = 0, vn = En[bn].length; wn < vn; wn++) {
                      const fn = (en = En[bn][wn]) == null ? void 0 : en.replaceAll(/\s/g, "");
                      if (fn) {
                        if (fn === Kr)
                          return {
                            header: dn,
                            tables: hn
                          };
                        if (!(sn.length < 2))
                          for (const on of sn)
                            fn === on && (gn = {
                              name: on,
                              header: dn,
                              tables: hn
                            });
                      }
                    }
                }
                if (gn)
                  return (0, rt.warn)(`TrueType Collection does not contain "${Kr}" font, falling back to "${gn.name}" font instead.`), {
                    header: gn.header,
                    tables: gn.tables
                  };
                throw new rt.FormatError(`TrueType Collection does not contain "${Kr}" font.`);
              }
              function br(Xr, Kr, rn, nn) {
                if (!Xr)
                  return (0, rt.warn)("No cmap table available."), {
                    platformId: -1,
                    encodingId: -1,
                    mappings: [],
                    hasShortCmap: !1
                  };
                let sn, gn = (Kr.start || 0) + Xr.offset;
                Kr.pos = gn, Kr.skip(2);
                const en = Kr.getUint16();
                let Wr, dn = !1;
                for (let vn = 0; vn < en; vn++) {
                  const fn = Kr.getUint16(), on = Kr.getUint16(), pn = Kr.getInt32() >>> 0;
                  let mn = !1;
                  if (!((Wr == null ? void 0 : Wr.platformId) === fn && (Wr == null ? void 0 : Wr.encodingId) === on)) {
                    if (fn === 0 && (on === 0 || on === 1 || on === 3))
                      mn = !0;
                    else if (fn === 1 && on === 0)
                      mn = !0;
                    else if (fn === 3 && on === 1 && (nn || !Wr))
                      mn = !0, rn || (dn = !0);
                    else if (rn && fn === 3 && on === 0) {
                      mn = !0;
                      let Pn = !0;
                      if (vn < en - 1) {
                        const An = Kr.peekBytes(2);
                        Rt(An[0], An[1]) < fn && (Pn = !1);
                      }
                      Pn && (dn = !0);
                    }
                    if (mn && (Wr = {
                      platformId: fn,
                      encodingId: on,
                      offset: pn
                    }), dn)
                      break;
                  }
                }
                if (Wr && (Kr.pos = gn + Wr.offset), !Wr || Kr.peekByte() === -1)
                  return (0, rt.warn)("Could not find a preferred cmap table."), {
                    platformId: -1,
                    encodingId: -1,
                    mappings: [],
                    hasShortCmap: !1
                  };
                const hn = Kr.getUint16();
                let En = !1;
                const bn = [];
                let Cn, wn;
                if (hn === 0) {
                  for (Kr.skip(4), Cn = 0; Cn < 256; Cn++) {
                    const vn = Kr.getByte();
                    vn && bn.push({
                      charCode: Cn,
                      glyphId: vn
                    });
                  }
                  En = !0;
                } else if (hn === 2) {
                  Kr.skip(4);
                  const vn = [];
                  let fn = 0;
                  for (let pn = 0; pn < 256; pn++) {
                    const mn = Kr.getUint16() >> 3;
                    vn.push(mn), fn = Math.max(mn, fn);
                  }
                  const on = [];
                  for (let pn = 0; pn <= fn; pn++)
                    on.push({
                      firstCode: Kr.getUint16(),
                      entryCount: Kr.getUint16(),
                      idDelta: jt(Kr.getByte(), Kr.getByte()),
                      idRangePos: Kr.pos + Kr.getUint16()
                    });
                  for (let pn = 0; pn < 256; pn++)
                    if (vn[pn] === 0)
                      Kr.pos = on[0].idRangePos + 2 * pn, wn = Kr.getUint16(), bn.push({
                        charCode: pn,
                        glyphId: wn
                      });
                    else {
                      const mn = on[vn[pn]];
                      for (Cn = 0; Cn < mn.entryCount; Cn++) {
                        const Pn = (pn << 8) + Cn + mn.firstCode;
                        Kr.pos = mn.idRangePos + 2 * Cn, wn = Kr.getUint16(), wn !== 0 && (wn = (wn + mn.idDelta) % 65536), bn.push({
                          charCode: Pn,
                          glyphId: wn
                        });
                      }
                    }
                } else if (hn === 4) {
                  Kr.skip(4);
                  const vn = Kr.getUint16() >> 1;
                  Kr.skip(6);
                  const fn = [];
                  let on;
                  for (on = 0; on < vn; on++)
                    fn.push({
                      end: Kr.getUint16()
                    });
                  for (Kr.skip(2), on = 0; on < vn; on++)
                    fn[on].start = Kr.getUint16();
                  for (on = 0; on < vn; on++)
                    fn[on].delta = Kr.getUint16();
                  let pn = 0, mn;
                  for (on = 0; on < vn; on++) {
                    sn = fn[on];
                    const An = Kr.getUint16();
                    if (!An) {
                      sn.offsetIndex = -1;
                      continue;
                    }
                    mn = (An >> 1) - (vn - on), sn.offsetIndex = mn, pn = Math.max(pn, mn + sn.end - sn.start + 1);
                  }
                  const Pn = [];
                  for (Cn = 0; Cn < pn; Cn++)
                    Pn.push(Kr.getUint16());
                  for (on = 0; on < vn; on++) {
                    sn = fn[on], gn = sn.start;
                    const An = sn.end, yn = sn.delta;
                    for (mn = sn.offsetIndex, Cn = gn; Cn <= An; Cn++)
                      Cn !== 65535 && (wn = mn < 0 ? Cn : Pn[mn + Cn - gn], wn = wn + yn & 65535, bn.push({
                        charCode: Cn,
                        glyphId: wn
                      }));
                  }
                } else if (hn === 6) {
                  Kr.skip(4);
                  const vn = Kr.getUint16(), fn = Kr.getUint16();
                  for (Cn = 0; Cn < fn; Cn++) {
                    wn = Kr.getUint16();
                    const on = vn + Cn;
                    bn.push({
                      charCode: on,
                      glyphId: wn
                    });
                  }
                } else if (hn === 12) {
                  Kr.skip(10);
                  const vn = Kr.getInt32() >>> 0;
                  for (Cn = 0; Cn < vn; Cn++) {
                    const fn = Kr.getInt32() >>> 0, on = Kr.getInt32() >>> 0;
                    let pn = Kr.getInt32() >>> 0;
                    for (let mn = fn; mn <= on; mn++)
                      bn.push({
                        charCode: mn,
                        glyphId: pn++
                      });
                  }
                } else
                  return (0, rt.warn)("cmap table has unsupported format: " + hn), {
                    platformId: -1,
                    encodingId: -1,
                    mappings: [],
                    hasShortCmap: !1
                  };
                bn.sort(function(vn, fn) {
                  return vn.charCode - fn.charCode;
                });
                for (let vn = 1; vn < bn.length; vn++)
                  bn[vn - 1].charCode === bn[vn].charCode && (bn.splice(vn, 1), vn--);
                return {
                  platformId: Wr.platformId,
                  encodingId: Wr.encodingId,
                  mappings: bn,
                  hasShortCmap: En
                };
              }
              function gr(Xr, Kr, rn, nn, sn, gn) {
                if (!Kr) {
                  rn && (rn.data = null);
                  return;
                }
                Xr.pos = (Xr.start || 0) + Kr.offset, Xr.pos += 4, Xr.pos += 2, Xr.pos += 2, Xr.pos += 2, Xr.pos += 2, Xr.pos += 2, Xr.pos += 2, Xr.pos += 2, Xr.pos += 2, Xr.pos += 2;
                const en = Xr.getUint16();
                Xr.pos += 8, Xr.pos += 2;
                let Wr = Xr.getUint16();
                en !== 0 && (Rt(nn.data[44], nn.data[45]) & 2 || (Kr.data[22] = 0, Kr.data[23] = 0)), Wr > sn && ((0, rt.info)(`The numOfMetrics (${Wr}) should not be greater than the numGlyphs (${sn}).`), Wr = sn, Kr.data[34] = (Wr & 65280) >> 8, Kr.data[35] = Wr & 255);
                const hn = sn - Wr - (rn.length - Wr * 4 >> 1);
                if (hn > 0) {
                  const En = new Uint8Array(rn.length + hn * 2);
                  En.set(rn.data), gn && (En[rn.length] = rn.data[2], En[rn.length + 1] = rn.data[3]), rn.data = En;
                }
              }
              function Ar(Xr, Kr, rn, nn, sn, gn) {
                const en = {
                  length: 0,
                  sizeOfInstructions: 0
                };
                if (Kr < 0 || Kr >= Xr.length || rn > Xr.length || rn - Kr <= 12)
                  return en;
                const Wr = Xr.subarray(Kr, rn), dn = jt(Wr[2], Wr[3]), hn = jt(Wr[4], Wr[5]), En = jt(Wr[6], Wr[7]), bn = jt(Wr[8], Wr[9]);
                dn > En && (kt(Wr, 2, En), kt(Wr, 6, dn)), hn > bn && (kt(Wr, 4, bn), kt(Wr, 8, hn));
                const Cn = jt(Wr[0], Wr[1]);
                if (Cn < 0)
                  return Cn < -1 || (nn.set(Wr, sn), en.length = Wr.length), en;
                let wn, vn = 10, fn = 0;
                for (wn = 0; wn < Cn; wn++)
                  fn = (Wr[vn] << 8 | Wr[vn + 1]) + 1, vn += 2;
                const on = vn, pn = Wr[vn] << 8 | Wr[vn + 1];
                en.sizeOfInstructions = pn, vn += 2 + pn;
                const mn = vn;
                let Pn = 0;
                for (wn = 0; wn < fn; wn++) {
                  const yn = Wr[vn++];
                  yn & 192 && (Wr[vn - 1] = yn & 63);
                  let Bn = 2;
                  yn & 2 ? Bn = 1 : yn & 16 && (Bn = 0);
                  let Fn = 2;
                  yn & 4 ? Fn = 1 : yn & 32 && (Fn = 0);
                  const zn = Bn + Fn;
                  if (Pn += zn, yn & 8) {
                    const Zn = Wr[vn++];
                    Zn === 0 && (Wr[vn - 1] ^= 8), wn += Zn, Pn += Zn * zn;
                  }
                }
                if (Pn === 0)
                  return en;
                let An = vn + Pn;
                return An > Wr.length ? en : !gn && pn > 0 ? (nn.set(Wr.subarray(0, on), sn), nn.set([0, 0], sn + on), nn.set(Wr.subarray(mn, An), sn + on + 2), An -= pn, Wr.length - An > 3 && (An = An + 3 & -4), en.length = An, en) : Wr.length - An > 3 ? (An = An + 3 & -4, nn.set(Wr.subarray(0, An), sn), en.length = An, en) : (nn.set(Wr, sn), en.length = Wr.length, en);
              }
              function Sr(Xr, Kr, rn) {
                const nn = Xr.data, sn = Ht(nn[0], nn[1], nn[2], nn[3]);
                sn >> 16 !== 1 && ((0, rt.info)("Attempting to fix invalid version in head table: " + sn), nn[0] = 0, nn[1] = 1, nn[2] = 0, nn[3] = 0);
                const gn = Rt(nn[50], nn[51]);
                if (gn < 0 || gn > 1) {
                  (0, rt.info)("Attempting to fix invalid indexToLocFormat in head table: " + gn);
                  const en = Kr + 1;
                  if (rn === en << 1)
                    nn[50] = 0, nn[51] = 0;
                  else if (rn === en << 2)
                    nn[50] = 0, nn[51] = 1;
                  else
                    throw new rt.FormatError("Could not fix indexToLocFormat: " + gn);
                }
              }
              function Br(Xr, Kr, rn, nn, sn, gn, en) {
                let Wr, dn, hn;
                nn ? (Wr = 4, dn = function(Bn, Fn) {
                  return Bn[Fn] << 24 | Bn[Fn + 1] << 16 | Bn[Fn + 2] << 8 | Bn[Fn + 3];
                }, hn = function(Bn, Fn, zn) {
                  Bn[Fn] = zn >>> 24 & 255, Bn[Fn + 1] = zn >> 16 & 255, Bn[Fn + 2] = zn >> 8 & 255, Bn[Fn + 3] = zn & 255;
                }) : (Wr = 2, dn = function(Bn, Fn) {
                  return Bn[Fn] << 9 | Bn[Fn + 1] << 1;
                }, hn = function(Bn, Fn, zn) {
                  Bn[Fn] = zn >> 9 & 255, Bn[Fn + 1] = zn >> 1 & 255;
                });
                const En = gn ? rn + 1 : rn, bn = Wr * (1 + En), Cn = new Uint8Array(bn);
                Cn.set(Xr.data.subarray(0, bn)), Xr.data = Cn;
                const wn = Kr.data, vn = wn.length, fn = new Uint8Array(vn);
                let on, pn;
                const mn = [];
                for (on = 0, pn = 0; on < rn + 1; on++, pn += Wr) {
                  let yn = dn(Cn, pn);
                  yn > vn && (yn = vn), mn.push({
                    index: on,
                    offset: yn,
                    endOffset: 0
                  });
                }
                for (mn.sort((yn, Bn) => yn.offset - Bn.offset), on = 0; on < rn; on++)
                  mn[on].endOffset = mn[on + 1].offset;
                for (mn.sort((yn, Bn) => yn.index - Bn.index), on = 0; on < rn; on++) {
                  const {
                    offset: yn,
                    endOffset: Bn
                  } = mn[on];
                  if (yn !== 0 || Bn !== 0)
                    break;
                  const Fn = mn[on + 1].offset;
                  if (Fn !== 0) {
                    mn[on].endOffset = Fn;
                    break;
                  }
                }
                const Pn = /* @__PURE__ */ Object.create(null);
                let An = 0;
                for (hn(Cn, 0, An), on = 0, pn = Wr; on < rn; on++, pn += Wr) {
                  const yn = Ar(wn, mn[on].offset, mn[on].endOffset, fn, An, sn), Bn = yn.length;
                  Bn === 0 && (Pn[on] = !0), yn.sizeOfInstructions > en && (en = yn.sizeOfInstructions), An += Bn, hn(Cn, pn, An);
                }
                if (An === 0) {
                  const yn = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
                  for (on = 0, pn = Wr; on < En; on++, pn += Wr)
                    hn(Cn, pn, yn.length);
                  Kr.data = yn;
                } else if (gn) {
                  const yn = dn(Cn, Wr);
                  fn.length > yn + An ? Kr.data = fn.subarray(0, yn + An) : (Kr.data = new Uint8Array(yn + An), Kr.data.set(fn.subarray(0, An))), Kr.data.set(fn.subarray(0, yn), An), hn(Xr.data, Cn.length - Wr, An + yn);
                } else
                  Kr.data = fn.subarray(0, An);
                return {
                  missingGlyphs: Pn,
                  maxSizeOfInstructions: en
                };
              }
              function Ir(Xr, Kr, rn) {
                const nn = (Gt.start || 0) + Xr.offset;
                Gt.pos = nn;
                const sn = Xr.length, gn = nn + sn, en = Gt.getInt32();
                Gt.skip(28);
                let Wr, dn = !0, hn;
                switch (en) {
                  case 65536:
                    Wr = lt.MacStandardGlyphOrdering;
                    break;
                  case 131072:
                    const En = Gt.getUint16();
                    if (En !== rn) {
                      dn = !1;
                      break;
                    }
                    const bn = [];
                    for (hn = 0; hn < En; ++hn) {
                      const vn = Gt.getUint16();
                      if (vn >= 32768) {
                        dn = !1;
                        break;
                      }
                      bn.push(vn);
                    }
                    if (!dn)
                      break;
                    const Cn = [], wn = [];
                    for (; Gt.pos < gn; ) {
                      const vn = Gt.getByte();
                      for (wn.length = vn, hn = 0; hn < vn; ++hn)
                        wn[hn] = String.fromCharCode(Gt.getByte());
                      Cn.push(wn.join(""));
                    }
                    for (Wr = [], hn = 0; hn < En; ++hn) {
                      const vn = bn[hn];
                      if (vn < 258) {
                        Wr.push(lt.MacStandardGlyphOrdering[vn]);
                        continue;
                      }
                      Wr.push(Cn[vn - 258]);
                    }
                    break;
                  case 196608:
                    break;
                  default:
                    (0, rt.warn)("Unknown/unsupported post table version " + en), dn = !1, Kr.defaultEncoding && (Wr = Kr.defaultEncoding);
                    break;
                }
                return Kr.glyphNames = Wr, dn;
              }
              function hr(Xr) {
                const Kr = (Gt.start || 0) + Xr.offset;
                Gt.pos = Kr;
                const rn = [[], []], nn = [], sn = Xr.length, gn = Kr + sn;
                if (Gt.getUint16() !== 0 || sn < 6)
                  return [rn, nn];
                const dn = Gt.getUint16(), hn = Gt.getUint16(), En = 12;
                let bn, Cn;
                for (bn = 0; bn < dn && Gt.pos + En <= gn; bn++) {
                  const wn = {
                    platform: Gt.getUint16(),
                    encoding: Gt.getUint16(),
                    language: Gt.getUint16(),
                    name: Gt.getUint16(),
                    length: Gt.getUint16(),
                    offset: Gt.getUint16()
                  };
                  (Qt(wn) || qt(wn)) && nn.push(wn);
                }
                for (bn = 0, Cn = nn.length; bn < Cn; bn++) {
                  const wn = nn[bn];
                  if (wn.length <= 0)
                    continue;
                  const vn = Kr + hn + wn.offset;
                  if (vn + wn.length > gn)
                    continue;
                  Gt.pos = vn;
                  const fn = wn.name;
                  if (wn.encoding) {
                    let on = "";
                    for (let pn = 0, mn = wn.length; pn < mn; pn += 2)
                      on += String.fromCharCode(Gt.getUint16());
                    rn[1][fn] = on;
                  } else
                    rn[0][fn] = Gt.getString(wn.length);
                }
                return [rn, nn];
              }
              const vr = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
              function xr(Xr, Kr) {
                let rn = Xr.data, nn = 0, sn, gn, en, Wr, dn, hn = 0, En = 0;
                const bn = [], Cn = [], wn = [];
                let vn = Kr.tooComplexToFollowFunctions, fn = !1, on = 0, pn = 0;
                for (let Pn = rn.length; nn < Pn; ) {
                  const An = rn[nn++];
                  if (An === 64)
                    if (gn = rn[nn++], fn || pn)
                      nn += gn;
                    else
                      for (sn = 0; sn < gn; sn++)
                        bn.push(rn[nn++]);
                  else if (An === 65)
                    if (gn = rn[nn++], fn || pn)
                      nn += gn * 2;
                    else
                      for (sn = 0; sn < gn; sn++)
                        en = rn[nn++], bn.push(en << 8 | rn[nn++]);
                  else if ((An & 248) === 176)
                    if (gn = An - 176 + 1, fn || pn)
                      nn += gn;
                    else
                      for (sn = 0; sn < gn; sn++)
                        bn.push(rn[nn++]);
                  else if ((An & 248) === 184)
                    if (gn = An - 184 + 1, fn || pn)
                      nn += gn * 2;
                    else
                      for (sn = 0; sn < gn; sn++)
                        en = rn[nn++], bn.push(en << 8 | rn[nn++]);
                  else if (An === 43 && !vn) {
                    if (!fn && !pn) {
                      if (Wr = bn.at(-1), isNaN(Wr))
                        (0, rt.info)("TT: CALL empty stack (or invalid entry).");
                      else if (Kr.functionsUsed[Wr] = !0, Wr in Kr.functionsStackDeltas) {
                        const yn = bn.length + Kr.functionsStackDeltas[Wr];
                        if (yn < 0) {
                          (0, rt.warn)("TT: CALL invalid functions stack delta."), Kr.hintsValid = !1;
                          return;
                        }
                        bn.length = yn;
                      } else if (Wr in Kr.functionsDefined && !wn.includes(Wr)) {
                        if (Cn.push({
                          data: rn,
                          i: nn,
                          stackTop: bn.length - 1
                        }), wn.push(Wr), dn = Kr.functionsDefined[Wr], !dn) {
                          (0, rt.warn)("TT: CALL non-existent function"), Kr.hintsValid = !1;
                          return;
                        }
                        rn = dn.data, nn = dn.i;
                      }
                    }
                  } else if (An === 44 && !vn)
                    (fn || pn) && ((0, rt.warn)("TT: nested FDEFs not allowed"), vn = !0), fn = !0, En = nn, Wr = bn.pop(), Kr.functionsDefined[Wr] = {
                      data: rn,
                      i: nn
                    };
                  else if (An === 45)
                    if (fn)
                      fn = !1, hn = nn;
                    else {
                      if (dn = Cn.pop(), !dn) {
                        (0, rt.warn)("TT: ENDF bad stack"), Kr.hintsValid = !1;
                        return;
                      }
                      Wr = wn.pop(), rn = dn.data, nn = dn.i, Kr.functionsStackDeltas[Wr] = bn.length - dn.stackTop;
                    }
                  else if (An === 137)
                    (fn || pn) && ((0, rt.warn)("TT: nested IDEFs not allowed"), vn = !0), fn = !0, En = nn;
                  else if (An === 88)
                    ++on;
                  else if (An === 27)
                    pn = on;
                  else if (An === 89)
                    pn === on && (pn = 0), --on;
                  else if (An === 28 && !fn && !pn) {
                    const yn = bn.at(-1);
                    yn > 0 && (nn += yn - 1);
                  }
                  if (!fn && !pn) {
                    let yn = 0;
                    for (An <= 142 ? yn = vr[An] : An >= 192 && An <= 223 ? yn = -1 : An >= 224 && (yn = -2), An >= 113 && An <= 117 && (gn = bn.pop(), isNaN(gn) || (yn = -gn * 2)); yn < 0 && bn.length > 0; )
                      bn.pop(), yn++;
                    for (; yn > 0; )
                      bn.push(NaN), yn--;
                  }
                }
                Kr.tooComplexToFollowFunctions = vn;
                const mn = [rn];
                nn > rn.length && mn.push(new Uint8Array(nn - rn.length)), En > hn && ((0, rt.warn)("TT: complementing a missing function tail"), mn.push(new Uint8Array([34, 45]))), Rr(Xr, mn);
              }
              function Pr(Xr, Kr) {
                if (!Xr.tooComplexToFollowFunctions) {
                  if (Xr.functionsDefined.length > Kr) {
                    (0, rt.warn)("TT: more functions defined than expected"), Xr.hintsValid = !1;
                    return;
                  }
                  for (let rn = 0, nn = Xr.functionsUsed.length; rn < nn; rn++) {
                    if (rn > Kr) {
                      (0, rt.warn)("TT: invalid function id: " + rn), Xr.hintsValid = !1;
                      return;
                    }
                    if (Xr.functionsUsed[rn] && !Xr.functionsDefined[rn]) {
                      (0, rt.warn)("TT: undefined function: " + rn), Xr.hintsValid = !1;
                      return;
                    }
                  }
                }
              }
              function Rr(Xr, Kr) {
                if (Kr.length > 1) {
                  let rn = 0, nn, sn;
                  for (nn = 0, sn = Kr.length; nn < sn; nn++)
                    rn += Kr[nn].length;
                  rn = rn + 3 & -4;
                  const gn = new Uint8Array(rn);
                  let en = 0;
                  for (nn = 0, sn = Kr.length; nn < sn; nn++)
                    gn.set(Kr[nn], en), en += Kr[nn].length;
                  Xr.data = gn, Xr.length = rn;
                }
              }
              function Dr(Xr, Kr, rn, nn) {
                const sn = {
                  functionsDefined: [],
                  functionsUsed: [],
                  functionsStackDeltas: [],
                  tooComplexToFollowFunctions: !1,
                  hintsValid: !0
                };
                if (Xr && xr(Xr, sn), Kr && xr(Kr, sn), Xr && Pr(sn, nn), rn && rn.length & 1) {
                  const gn = new Uint8Array(rn.length + 1);
                  gn.set(rn.data), rn.data = gn;
                }
                return sn.hintsValid;
              }
              Gt = new xt.Stream(new Uint8Array(Gt.getBytes()));
              let Gr, Or;
              if (Mt(Gt)) {
                const Xr = Er(Gt, this.name);
                Gr = Xr.header, Or = Xr.tables;
              } else
                Gr = pr(Gt), Or = lr(Gt, Gr.numTables);
              let Hr, jr;
              const Tr = !Or["CFF "];
              if (Tr) {
                if (!Or.loca)
                  throw new rt.FormatError('Required "loca" table is not found');
                Or.glyf || ((0, rt.warn)('Required "glyf" table is not found -- trying to recover.'), Or.glyf = {
                  tag: "glyf",
                  data: new Uint8Array(0)
                }), this.isOpenType = !1;
              } else {
                const Xr = Wt.composite && (((an = Wt.cidToGidMap) == null ? void 0 : an.length) > 0 || !(Wt.cMap instanceof ct.IdentityCMap));
                if (Gr.version === "OTTO" && !Xr || !Or.head || !Or.hhea || !Or.maxp || !Or.post)
                  return jr = new xt.Stream(Or["CFF "].data), Hr = new dt.CFFFont(jr, Wt), Pt(Wt), this.convert(Xt, Hr, Wt);
                delete Or.glyf, delete Or.loca, delete Or.fpgm, delete Or.prep, delete Or["cvt "], this.isOpenType = !0;
              }
              if (!Or.maxp)
                throw new rt.FormatError('Required "maxp" table is not found');
              Gt.pos = (Gt.start || 0) + Or.maxp.offset;
              const fr = Gt.getInt32(), Cr = Gt.getUint16();
              if (((Zr = Wt.scaleFactors) == null ? void 0 : Zr.length) === Cr && Tr) {
                const {
                  scaleFactors: Xr
                } = Wt, Kr = Rt(Or.head.data[50], Or.head.data[51]), rn = new mt.GlyfTable({
                  glyfTable: Or.glyf.data,
                  isGlyphLocationsLong: Kr,
                  locaTable: Or.loca.data,
                  numGlyphs: Cr
                });
                rn.scale(Xr);
                const {
                  glyf: nn,
                  loca: sn,
                  isLocationLong: gn
                } = rn.write();
                Or.glyf.data = nn, Or.loca.data = sn, gn !== !!Kr && (Or.head.data[50] = 0, Or.head.data[51] = gn ? 1 : 0);
                const en = Or.hmtx.data;
                for (let Wr = 0; Wr < Cr; Wr++) {
                  const dn = 4 * Wr, hn = Math.round(Xr[Wr] * Rt(en[dn], en[dn + 1]));
                  en[dn] = hn >> 8 & 255, en[dn + 1] = hn & 255;
                  const En = Math.round(Xr[Wr] * jt(en[dn + 2], en[dn + 3]));
                  kt(en, dn + 2, En);
                }
              }
              let $r = Cr + 1, wr = !0;
              $r > 65535 && (wr = !1, $r = Cr, (0, rt.warn)("Not enough space in glyfs to duplicate first glyph."));
              let Mr = 0, Fr = 0;
              fr >= 65536 && Or.maxp.length >= 22 && (Gt.pos += 8, Gt.getUint16() > 2 && (Or.maxp.data[14] = 0, Or.maxp.data[15] = 2), Gt.pos += 4, Mr = Gt.getUint16(), Gt.pos += 4, Fr = Gt.getUint16()), Or.maxp.data[4] = $r >> 8, Or.maxp.data[5] = $r & 255;
              const Qr = Dr(Or.fpgm, Or.prep, Or["cvt "], Mr);
              if (Qr || (delete Or.fpgm, delete Or.prep, delete Or["cvt "]), gr(Gt, Or.hhea, Or.hmtx, Or.head, $r, wr), !Or.head)
                throw new rt.FormatError('Required "head" table is not found');
              Sr(Or.head, Cr, Tr ? Or.loca.length : 0);
              let Yr = /* @__PURE__ */ Object.create(null);
              if (Tr) {
                const Xr = Rt(Or.head.data[50], Or.head.data[51]), Kr = Br(Or.loca, Or.glyf, Cr, Xr, Qr, wr, Fr);
                Yr = Kr.missingGlyphs, fr >= 65536 && Or.maxp.length >= 22 && (Or.maxp.data[26] = Kr.maxSizeOfInstructions >> 8, Or.maxp.data[27] = Kr.maxSizeOfInstructions & 255);
              }
              if (!Or.hhea)
                throw new rt.FormatError('Required "hhea" table is not found');
              Or.hhea.data[10] === 0 && Or.hhea.data[11] === 0 && (Or.hhea.data[10] = 255, Or.hhea.data[11] = 255);
              const kr = {
                unitsPerEm: Rt(Or.head.data[18], Or.head.data[19]),
                yMax: jt(Or.head.data[42], Or.head.data[43]),
                yMin: jt(Or.head.data[38], Or.head.data[39]),
                ascent: jt(Or.hhea.data[4], Or.hhea.data[5]),
                descent: jt(Or.hhea.data[6], Or.hhea.data[7]),
                lineGap: jt(Or.hhea.data[8], Or.hhea.data[9])
              };
              this.ascent = kr.ascent / kr.unitsPerEm, this.descent = kr.descent / kr.unitsPerEm, this.lineGap = kr.lineGap / kr.unitsPerEm, (un = this.cssFontInfo) != null && un.lineHeight ? (this.lineHeight = this.cssFontInfo.metrics.lineHeight, this.lineGap = this.cssFontInfo.metrics.lineGap) : this.lineHeight = this.ascent - this.descent + this.lineGap, Or.post && Ir(Or.post, Wt, Cr), Or.post = {
                tag: "post",
                data: nr(Wt)
              };
              const Nr = [];
              function Lr(Xr) {
                return !Yr[Xr];
              }
              if (Wt.composite) {
                const Xr = Wt.cidToGidMap || [], Kr = Xr.length === 0;
                Wt.cMap.forEach(function(rn, nn) {
                  if (typeof nn == "string" && (nn = Zt(rn, nn, !0)), nn > 65535)
                    throw new rt.FormatError("Max size of CID is 65,535");
                  let sn = -1;
                  Kr ? sn = nn : Xr[nn] !== void 0 && (sn = Xr[nn]), sn >= 0 && sn < Cr && Lr(sn) && (Nr[rn] = sn);
                });
              } else {
                const Xr = br(Or.cmap, Gt, this.isSymbolicFont, Wt.hasEncoding), Kr = Xr.platformId, rn = Xr.encodingId, nn = Xr.mappings;
                let sn = [], gn = !1;
                if (Wt.hasEncoding && (Wt.baseEncodingName === "MacRomanEncoding" || Wt.baseEncodingName === "WinAnsiEncoding") && (sn = (0, ut.getEncoding)(Wt.baseEncodingName)), Wt.hasEncoding && !this.isSymbolicFont && (Kr === 3 && rn === 1 || Kr === 1 && rn === 0)) {
                  const en = (0, it.getGlyphsUnicode)();
                  for (let Wr = 0; Wr < 256; Wr++) {
                    let dn;
                    if (this.differences[Wr] !== void 0 ? dn = this.differences[Wr] : sn.length && sn[Wr] !== "" ? dn = sn[Wr] : dn = ut.StandardEncoding[Wr], !dn)
                      continue;
                    const hn = (0, lt.recoverGlyphName)(dn, en);
                    let En;
                    if (Kr === 3 && rn === 1 ? En = en[hn] : Kr === 1 && rn === 0 && (En = ut.MacRomanEncoding.indexOf(hn)), En === void 0) {
                      if (!Wt.glyphNames && Wt.hasIncludedToUnicodeMap && !(this.toUnicode instanceof ht.IdentityToUnicodeMap)) {
                        const bn = this.toUnicode.get(Wr);
                        bn && (En = bn.codePointAt(0));
                      }
                      if (En === void 0)
                        continue;
                    }
                    for (const bn of nn)
                      if (bn.charCode === En) {
                        Nr[Wr] = bn.glyphId;
                        break;
                      }
                  }
                } else if (Kr === 0) {
                  for (const en of nn)
                    Nr[en.charCode] = en.glyphId;
                  gn = !0;
                } else
                  for (const en of nn) {
                    let Wr = en.charCode;
                    Kr === 3 && Wr >= 61440 && Wr <= 61695 && (Wr &= 255), Nr[Wr] = en.glyphId;
                  }
                if (Wt.glyphNames && (sn.length || this.differences.length))
                  for (let en = 0; en < 256; ++en) {
                    if (!gn && Nr[en] !== void 0)
                      continue;
                    const Wr = this.differences[en] || sn[en];
                    if (!Wr)
                      continue;
                    const dn = Wt.glyphNames.indexOf(Wr);
                    dn > 0 && Lr(dn) && (Nr[en] = dn);
                  }
              }
              Nr.length === 0 && (Nr[0] = 0);
              let zr = $r - 1;
              if (wr || (zr = 0), !Wt.cssFontInfo) {
                const Xr = ar(Nr, Lr, zr, this.toUnicode);
                this.toFontChar = Xr.toFontChar, Or.cmap = {
                  tag: "cmap",
                  data: rr(Xr.charCodeToGlyphId, Xr.toUnicodeExtraMap, $r)
                }, (!Or["OS/2"] || !Yt(Or["OS/2"], Gt)) && (Or["OS/2"] = {
                  tag: "OS/2",
                  data: Kt(Wt, Xr.charCodeToGlyphId, kr)
                });
              }
              if (!Tr)
                try {
                  jr = new xt.Stream(Or["CFF "].data), Hr = new st.CFFParser(jr, Wt, lt.SEAC_ANALYSIS_ENABLED).parse(), Hr.duplicateFirstGlyph();
                  const Kr = new st.CFFCompiler(Hr);
                  Or["CFF "].data = Kr.compile();
                } catch {
                  (0, rt.warn)("Failed to compile font " + Wt.loadedName);
                }
              if (!Or.name)
                Or.name = {
                  tag: "name",
                  data: ir(this.name)
                };
              else {
                const [Xr, Kr] = hr(Or.name);
                Or.name.data = ir(Xt, Xr), this.psName = Xr[0][6] || null, Wt.composite || wt(Wt, this.isSymbolicFont, Kr);
              }
              const Vr = new vt.OpenTypeFileBuilder(Gr.version);
              for (const Xr in Or)
                Vr.addTable(Xr, Or[Xr].data);
              return Vr.toArray();
            }
            convert(Xt, Gt, Wt) {
              Wt.fixedPitch = !1, Wt.builtInEncoding && Ct(Wt, Wt.builtInEncoding);
              let er = 1;
              Gt instanceof dt.CFFFont && (er = Gt.numGlyphs - 1);
              const lr = Gt.getGlyphMapping(Wt);
              let ur = null, pr = lr, yr = null;
              Wt.cssFontInfo || (ur = ar(lr, Gt.hasGlyphId.bind(Gt), er, this.toUnicode), this.toFontChar = ur.toFontChar, pr = ur.charCodeToGlyphId, yr = ur.toUnicodeExtraMap);
              const Er = Gt.numGlyphs;
              function br(Ir, hr) {
                let vr = null;
                for (const xr in Ir)
                  hr === Ir[xr] && (vr || (vr = [])).push(xr | 0);
                return vr;
              }
              function gr(Ir, hr) {
                for (const vr in Ir)
                  if (hr === Ir[vr])
                    return vr | 0;
                return ur.charCodeToGlyphId[ur.nextAvailableFontCharCode] = hr, ur.nextAvailableFontCharCode++;
              }
              const Ar = Gt.seacs;
              if (ur && lt.SEAC_ANALYSIS_ENABLED && (Ar != null && Ar.length)) {
                const Ir = Wt.fontMatrix || rt.FONT_IDENTITY_MATRIX, hr = Gt.getCharset(), vr = /* @__PURE__ */ Object.create(null);
                for (let xr in Ar) {
                  xr |= 0;
                  const Pr = Ar[xr], Rr = ut.StandardEncoding[Pr[2]], Dr = ut.StandardEncoding[Pr[3]], Gr = hr.indexOf(Rr), Or = hr.indexOf(Dr);
                  if (Gr < 0 || Or < 0)
                    continue;
                  const Hr = {
                    x: Pr[0] * Ir[0] + Pr[1] * Ir[2] + Ir[4],
                    y: Pr[0] * Ir[1] + Pr[1] * Ir[3] + Ir[5]
                  }, jr = br(lr, xr);
                  if (jr)
                    for (const Tr of jr) {
                      const fr = ur.charCodeToGlyphId, Cr = gr(fr, Gr), $r = gr(fr, Or);
                      vr[Tr] = {
                        baseFontCharCode: Cr,
                        accentFontCharCode: $r,
                        accentOffset: Hr
                      };
                    }
                }
                Wt.seacMap = vr;
              }
              const Sr = 1 / (Wt.fontMatrix || rt.FONT_IDENTITY_MATRIX)[0], Br = new vt.OpenTypeFileBuilder("OTTO");
              return Br.addTable("CFF ", Gt.data), Br.addTable("OS/2", Kt(Wt, pr)), Br.addTable("cmap", rr(pr, yr, Er)), Br.addTable("head", "\0\0\0\0\0\0\0\0\0\0_<õ\0\0" + _t(Sr) + "\0\0\0\0\v~'\0\0\0\0\v~'\0\0" + _t(Wt.descent) + "ÿ" + _t(Wt.ascent) + Ft(Wt.italicAngle ? 2 : 0) + "\0\0\0\0\0\0\0"), Br.addTable("hhea", "\0\0\0" + _t(Wt.ascent) + _t(Wt.descent) + "\0\0ÿÿ\0\0\0\0\0\0" + _t(Wt.capHeight) + _t(Math.tan(Wt.italicAngle) * Wt.xHeight) + "\0\0\0\0\0\0\0\0\0\0\0\0" + Ft(Er)), Br.addTable("hmtx", function() {
                const hr = Gt.charstrings, vr = Gt.cff ? Gt.cff.widths : null;
                let xr = "\0\0\0\0";
                for (let Pr = 1, Rr = Er; Pr < Rr; Pr++) {
                  let Dr = 0;
                  if (hr) {
                    const Gr = hr[Pr - 1];
                    Dr = "width" in Gr ? Gr.width : 0;
                  } else
                    vr && (Dr = Math.ceil(vr[Pr] || 0));
                  xr += Ft(Dr) + Ft(0);
                }
                return xr;
              }()), Br.addTable("maxp", "\0\0P\0" + Ft(Er)), Br.addTable("name", ir(Xt)), Br.addTable("post", nr(Wt)), Br.toArray();
            }
            get spaceWidth() {
              const Xt = ["space", "minus", "one", "i", "I"];
              let Gt;
              for (const Wt of Xt) {
                if (Wt in this.widths) {
                  Gt = this.widths[Wt];
                  break;
                }
                const lr = (0, it.getGlyphsUnicode)()[Wt];
                let ur = 0;
                if (this.composite && this.cMap.contains(lr) && (ur = this.cMap.lookup(lr), typeof ur == "string" && (ur = Zt(lr, ur))), !ur && this.toUnicode && (ur = this.toUnicode.charCodeOf(lr)), ur <= 0 && (ur = lr), Gt = this.widths[ur], Gt)
                  break;
              }
              return (0, rt.shadow)(this, "spaceWidth", Gt || this.defaultWidth);
            }
            _charToGlyph(Xt) {
              var Sr, Br, Ir;
              let Gt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, Wt = this._glyphCache[Xt];
              if ((Wt == null ? void 0 : Wt.isSpace) === Gt)
                return Wt;
              let er, lr, ur, pr = Xt;
              (Sr = this.cMap) != null && Sr.contains(Xt) && (pr = this.cMap.lookup(Xt), typeof pr == "string" && (pr = Zt(Xt, pr))), lr = this.widths[pr], typeof lr != "number" && (lr = this.defaultWidth);
              const yr = (Br = this.vmetrics) == null ? void 0 : Br[pr];
              let Er = this.toUnicode.get(Xt) || Xt;
              typeof Er == "number" && (Er = String.fromCharCode(Er));
              let br = this.toFontChar[Xt] !== void 0;
              if (er = this.toFontChar[Xt] || Xt, this.missingFile) {
                const hr = this.differences[Xt] || this.defaultEncoding[Xt];
                (hr === ".notdef" || hr === "") && this.type === "Type1" && (er = 32), er = (0, et.mapSpecialUnicodeValues)(er);
              }
              this.isType3Font && (ur = er);
              let gr = null;
              if ((Ir = this.seacMap) != null && Ir[Xt]) {
                br = !0;
                const hr = this.seacMap[Xt];
                er = hr.baseFontCharCode, gr = {
                  fontChar: String.fromCodePoint(hr.accentFontCharCode),
                  offset: hr.accentOffset
                };
              }
              let Ar = "";
              return typeof er == "number" && (er <= 1114111 ? Ar = String.fromCodePoint(er) : (0, rt.warn)(`charToGlyph - invalid fontCharCode: ${er}`)), Wt = new yt(Xt, Ar, Er, gr, lr, yr, ur, Gt, br), this._glyphCache[Xt] = Wt;
            }
            charsToGlyphs(Xt) {
              let Gt = this._charsCache[Xt];
              if (Gt)
                return Gt;
              if (Gt = [], this.cMap) {
                const Wt = /* @__PURE__ */ Object.create(null), er = Xt.length;
                let lr = 0;
                for (; lr < er; ) {
                  this.cMap.readCharCode(Xt, lr, Wt);
                  const {
                    charcode: ur,
                    length: pr
                  } = Wt;
                  lr += pr;
                  const yr = this._charToGlyph(ur, pr === 1 && Xt.charCodeAt(lr - 1) === 32);
                  Gt.push(yr);
                }
              } else
                for (let Wt = 0, er = Xt.length; Wt < er; ++Wt) {
                  const lr = Xt.charCodeAt(Wt), ur = this._charToGlyph(lr, lr === 32);
                  Gt.push(ur);
                }
              return this._charsCache[Xt] = Gt;
            }
            getCharPositions(Xt) {
              const Gt = [];
              if (this.cMap) {
                const Wt = /* @__PURE__ */ Object.create(null);
                let er = 0;
                for (; er < Xt.length; ) {
                  this.cMap.readCharCode(Xt, er, Wt);
                  const lr = Wt.length;
                  Gt.push([er, er + lr]), er += lr;
                }
              } else
                for (let Wt = 0, er = Xt.length; Wt < er; ++Wt)
                  Gt.push([Wt, Wt + 1]);
              return Gt;
            }
            get glyphCacheValues() {
              return Object.values(this._glyphCache);
            }
            encodeString(Xt) {
              const Gt = [], Wt = [], er = () => Gt.length % 2 === 1, lr = this.toUnicode instanceof ht.IdentityToUnicodeMap ? (ur) => this.toUnicode.charCodeOf(ur) : (ur) => this.toUnicode.charCodeOf(String.fromCodePoint(ur));
              for (let ur = 0, pr = Xt.length; ur < pr; ur++) {
                const yr = Xt.codePointAt(ur);
                if (yr > 55295 && (yr < 57344 || yr > 65533) && ur++, this.toUnicode) {
                  const Er = lr(yr);
                  if (Er !== -1) {
                    er() && (Gt.push(Wt.join("")), Wt.length = 0);
                    const br = this.cMap ? this.cMap.getCharCodeLength(Er) : 1;
                    for (let gr = br - 1; gr >= 0; gr--)
                      Wt.push(String.fromCharCode(Er >> 8 * gr & 255));
                    continue;
                  }
                }
                er() || (Gt.push(Wt.join("")), Wt.length = 0), Wt.push(String.fromCodePoint(yr));
              }
              return Gt.push(Wt.join("")), Gt;
            }
          }
          at.Font = sr;
          class cr {
            constructor(Xt) {
              this.error = Xt, this.loadedName = "g_font_error", this.missingFile = !0;
            }
            charsToGlyphs() {
              return [];
            }
            encodeString(Xt) {
              return [Xt];
            }
            exportData() {
              return {
                error: this.error
              };
            }
          }
          at.ErrorFont = cr;
        },
        /* 186 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.CFFTopDict = at.CFFStrings = at.CFFStandardStrings = at.CFFPrivateDict = at.CFFParser = at.CFFIndex = at.CFFHeader = at.CFFFDSelect = at.CFFCompiler = at.CFFCharset = at.CFF = void 0, ot(140), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(145), st = ot(187), lt = ot(188);
          const et = 10, it = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"];
          at.CFFStandardStrings = it;
          const ut = 391, ft = [null, {
            id: "hstem",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, null, {
            id: "vstem",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, {
            id: "vmoveto",
            min: 1,
            stackClearing: !0
          }, {
            id: "rlineto",
            min: 2,
            resetStack: !0
          }, {
            id: "hlineto",
            min: 1,
            resetStack: !0
          }, {
            id: "vlineto",
            min: 1,
            resetStack: !0
          }, {
            id: "rrcurveto",
            min: 6,
            resetStack: !0
          }, null, {
            id: "callsubr",
            min: 1,
            undefStack: !0
          }, {
            id: "return",
            min: 0,
            undefStack: !0
          }, null, null, {
            id: "endchar",
            min: 0,
            stackClearing: !0
          }, null, null, null, {
            id: "hstemhm",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, {
            id: "hintmask",
            min: 0,
            stackClearing: !0
          }, {
            id: "cntrmask",
            min: 0,
            stackClearing: !0
          }, {
            id: "rmoveto",
            min: 2,
            stackClearing: !0
          }, {
            id: "hmoveto",
            min: 1,
            stackClearing: !0
          }, {
            id: "vstemhm",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, {
            id: "rcurveline",
            min: 8,
            resetStack: !0
          }, {
            id: "rlinecurve",
            min: 8,
            resetStack: !0
          }, {
            id: "vvcurveto",
            min: 4,
            resetStack: !0
          }, {
            id: "hhcurveto",
            min: 4,
            resetStack: !0
          }, null, {
            id: "callgsubr",
            min: 1,
            undefStack: !0
          }, {
            id: "vhcurveto",
            min: 4,
            resetStack: !0
          }, {
            id: "hvcurveto",
            min: 4,
            resetStack: !0
          }], ht = [null, null, null, {
            id: "and",
            min: 2,
            stackDelta: -1
          }, {
            id: "or",
            min: 2,
            stackDelta: -1
          }, {
            id: "not",
            min: 1,
            stackDelta: 0
          }, null, null, null, {
            id: "abs",
            min: 1,
            stackDelta: 0
          }, {
            id: "add",
            min: 2,
            stackDelta: -1,
            stackFn(It, yt) {
              It[yt - 2] = It[yt - 2] + It[yt - 1];
            }
          }, {
            id: "sub",
            min: 2,
            stackDelta: -1,
            stackFn(It, yt) {
              It[yt - 2] = It[yt - 2] - It[yt - 1];
            }
          }, {
            id: "div",
            min: 2,
            stackDelta: -1,
            stackFn(It, yt) {
              It[yt - 2] = It[yt - 2] / It[yt - 1];
            }
          }, null, {
            id: "neg",
            min: 1,
            stackDelta: 0,
            stackFn(It, yt) {
              It[yt - 1] = -It[yt - 1];
            }
          }, {
            id: "eq",
            min: 2,
            stackDelta: -1
          }, null, null, {
            id: "drop",
            min: 1,
            stackDelta: -1
          }, null, {
            id: "put",
            min: 2,
            stackDelta: -2
          }, {
            id: "get",
            min: 1,
            stackDelta: 0
          }, {
            id: "ifelse",
            min: 4,
            stackDelta: -3
          }, {
            id: "random",
            min: 0,
            stackDelta: 1
          }, {
            id: "mul",
            min: 2,
            stackDelta: -1,
            stackFn(It, yt) {
              It[yt - 2] = It[yt - 2] * It[yt - 1];
            }
          }, null, {
            id: "sqrt",
            min: 1,
            stackDelta: 0
          }, {
            id: "dup",
            min: 1,
            stackDelta: 1
          }, {
            id: "exch",
            min: 2,
            stackDelta: 0
          }, {
            id: "index",
            min: 2,
            stackDelta: 0
          }, {
            id: "roll",
            min: 3,
            stackDelta: -2
          }, null, null, null, {
            id: "hflex",
            min: 7,
            resetStack: !0
          }, {
            id: "flex",
            min: 13,
            resetStack: !0
          }, {
            id: "hflex1",
            min: 9,
            resetStack: !0
          }, {
            id: "flex1",
            min: 11,
            resetStack: !0
          }];
          class dt {
            constructor(yt, Rt, kt) {
              this.bytes = yt.getBytes(), this.properties = Rt, this.seacAnalysisEnabled = !!kt;
            }
            parse() {
              const yt = this.properties, Rt = new gt();
              this.cff = Rt;
              const kt = this.parseHeader(), jt = this.parseIndex(kt.endPos), Ht = this.parseIndex(jt.endPos), Ft = this.parseIndex(Ht.endPos), _t = this.parseIndex(Ft.endPos), Nt = this.parseDict(Ht.obj.get(0)), Mt = this.createDict(xt, Nt, Rt.strings);
              Rt.header = kt.obj, Rt.names = this.parseNameIndex(jt.obj), Rt.strings = this.parseStringIndex(Ft.obj), Rt.topDict = Mt, Rt.globalSubrIndex = _t.obj, this.parsePrivateDict(Rt.topDict), Rt.isCIDFont = Mt.hasName("ROS");
              const Lt = Mt.getByName("CharStrings"), $t = this.parseIndex(Lt).obj, Tt = Mt.getByName("FontMatrix");
              Tt && (yt.fontMatrix = Tt);
              const Dt = Mt.getByName("FontBBox");
              Dt && (yt.ascent = Math.max(Dt[3], Dt[1]), yt.descent = Math.min(Dt[1], Dt[3]), yt.ascentScaled = !0);
              let Ut, Vt;
              if (Rt.isCIDFont) {
                const qt = this.parseIndex(Mt.getByName("FDArray")).obj;
                for (let Zt = 0, ar = qt.count; Zt < ar; ++Zt) {
                  const Jt = qt.get(Zt), rr = this.createDict(xt, this.parseDict(Jt), Rt.strings);
                  this.parsePrivateDict(rr), Rt.fdArray.push(rr);
                }
                Vt = null, Ut = this.parseCharsets(Mt.getByName("charset"), $t.count, Rt.strings, !0), Rt.fdSelect = this.parseFDSelect(Mt.getByName("FDSelect"), $t.count);
              } else
                Ut = this.parseCharsets(Mt.getByName("charset"), $t.count, Rt.strings, !1), Vt = this.parseEncoding(Mt.getByName("Encoding"), yt, Rt.strings, Ut.charset);
              Rt.charset = Ut, Rt.encoding = Vt;
              const Qt = this.parseCharStrings({
                charStrings: $t,
                localSubrIndex: Mt.privateDict.subrsIndex,
                globalSubrIndex: _t.obj,
                fdSelect: Rt.fdSelect,
                fdArray: Rt.fdArray,
                privateDict: Mt.privateDict
              });
              return Rt.charStrings = Qt.charStrings, Rt.seacs = Qt.seacs, Rt.widths = Qt.widths, Rt;
            }
            parseHeader() {
              let yt = this.bytes;
              const Rt = yt.length;
              let kt = 0;
              for (; kt < Rt && yt[kt] !== 1; )
                ++kt;
              if (kt >= Rt)
                throw new rt.FormatError("Invalid CFF header");
              kt !== 0 && ((0, rt.info)("cff data is shifted"), yt = yt.subarray(kt), this.bytes = yt);
              const jt = yt[0], Ht = yt[1], Ft = yt[2], _t = yt[3];
              return {
                obj: new pt(jt, Ht, Ft, _t),
                endPos: Ft
              };
            }
            parseDict(yt) {
              let Rt = 0;
              function kt() {
                let Nt = yt[Rt++];
                return Nt === 30 ? jt() : Nt === 28 ? (Nt = yt[Rt++], Nt = (Nt << 24 | yt[Rt++] << 16) >> 16, Nt) : Nt === 29 ? (Nt = yt[Rt++], Nt = Nt << 8 | yt[Rt++], Nt = Nt << 8 | yt[Rt++], Nt = Nt << 8 | yt[Rt++], Nt) : Nt >= 32 && Nt <= 246 ? Nt - 139 : Nt >= 247 && Nt <= 250 ? (Nt - 247) * 256 + yt[Rt++] + 108 : Nt >= 251 && Nt <= 254 ? -((Nt - 251) * 256) - yt[Rt++] - 108 : ((0, rt.warn)('CFFParser_parseDict: "' + Nt + '" is a reserved command.'), NaN);
              }
              function jt() {
                let Nt = "";
                const Lt = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"], $t = yt.length;
                for (; Rt < $t; ) {
                  const Tt = yt[Rt++], Dt = Tt >> 4, Ut = Tt & 15;
                  if (Dt === 15 || (Nt += Lt[Dt], Ut === 15))
                    break;
                  Nt += Lt[Ut];
                }
                return parseFloat(Nt);
              }
              let Ht = [];
              const Ft = [];
              Rt = 0;
              const _t = yt.length;
              for (; Rt < _t; ) {
                let Nt = yt[Rt];
                Nt <= 21 ? (Nt === 12 && (Nt = Nt << 8 | yt[++Rt]), Ft.push([Nt, Ht]), Ht = [], ++Rt) : Ht.push(kt());
              }
              return Ft;
            }
            parseIndex(yt) {
              const Rt = new ct(), kt = this.bytes, jt = kt[yt++] << 8 | kt[yt++], Ht = [];
              let Ft = yt, _t, Nt;
              if (jt !== 0) {
                const Mt = kt[yt++], Lt = yt + (jt + 1) * Mt - 1;
                for (_t = 0, Nt = jt + 1; _t < Nt; ++_t) {
                  let $t = 0;
                  for (let Tt = 0; Tt < Mt; ++Tt)
                    $t <<= 8, $t += kt[yt++];
                  Ht.push(Lt + $t);
                }
                Ft = Ht[jt];
              }
              for (_t = 0, Nt = Ht.length - 1; _t < Nt; ++_t) {
                const Mt = Ht[_t], Lt = Ht[_t + 1];
                Rt.add(kt.subarray(Mt, Lt));
              }
              return {
                obj: Rt,
                endPos: Ft
              };
            }
            parseNameIndex(yt) {
              const Rt = [];
              for (let kt = 0, jt = yt.count; kt < jt; ++kt) {
                const Ht = yt.get(kt);
                Rt.push((0, rt.bytesToString)(Ht));
              }
              return Rt;
            }
            parseStringIndex(yt) {
              const Rt = new mt();
              for (let kt = 0, jt = yt.count; kt < jt; ++kt) {
                const Ht = yt.get(kt);
                Rt.add((0, rt.bytesToString)(Ht));
              }
              return Rt;
            }
            createDict(yt, Rt, kt) {
              const jt = new yt(kt);
              for (const [Ht, Ft] of Rt)
                jt.setByKey(Ht, Ft);
              return jt;
            }
            parseCharString(yt, Rt, kt, jt) {
              if (!Rt || yt.callDepth > et)
                return !1;
              let Ht = yt.stackSize;
              const Ft = yt.stack;
              let _t = Rt.length;
              for (let Nt = 0; Nt < _t; ) {
                const Mt = Rt[Nt++];
                let Lt = null;
                if (Mt === 12) {
                  const $t = Rt[Nt++];
                  $t === 0 ? (Rt[Nt - 2] = 139, Rt[Nt - 1] = 22, Ht = 0) : Lt = ht[$t];
                } else if (Mt === 28)
                  Ft[Ht] = (Rt[Nt] << 24 | Rt[Nt + 1] << 16) >> 16, Nt += 2, Ht++;
                else if (Mt === 14) {
                  if (Ht >= 4 && (Ht -= 4, this.seacAnalysisEnabled))
                    return yt.seac = Ft.slice(Ht, Ht + 4), !1;
                  Lt = ft[Mt];
                } else if (Mt >= 32 && Mt <= 246)
                  Ft[Ht] = Mt - 139, Ht++;
                else if (Mt >= 247 && Mt <= 254)
                  Ft[Ht] = Mt < 251 ? (Mt - 247 << 8) + Rt[Nt] + 108 : -(Mt - 251 << 8) - Rt[Nt] - 108, Nt++, Ht++;
                else if (Mt === 255)
                  Ft[Ht] = (Rt[Nt] << 24 | Rt[Nt + 1] << 16 | Rt[Nt + 2] << 8 | Rt[Nt + 3]) / 65536, Nt += 4, Ht++;
                else if (Mt === 19 || Mt === 20) {
                  if (yt.hints += Ht >> 1, yt.hints === 0) {
                    Rt.copyWithin(Nt - 1, Nt, -1), Nt -= 1, _t -= 1;
                    continue;
                  }
                  Nt += yt.hints + 7 >> 3, Ht %= 2, Lt = ft[Mt];
                } else if (Mt === 10 || Mt === 29) {
                  const $t = Mt === 10 ? kt : jt;
                  if (!$t)
                    return Lt = ft[Mt], (0, rt.warn)("Missing subrsIndex for " + Lt.id), !1;
                  let Tt = 32768;
                  $t.count < 1240 ? Tt = 107 : $t.count < 33900 && (Tt = 1131);
                  const Dt = Ft[--Ht] + Tt;
                  if (Dt < 0 || Dt >= $t.count || isNaN(Dt))
                    return Lt = ft[Mt], (0, rt.warn)("Out of bounds subrIndex for " + Lt.id), !1;
                  if (yt.stackSize = Ht, yt.callDepth++, !this.parseCharString(yt, $t.get(Dt), kt, jt))
                    return !1;
                  yt.callDepth--, Ht = yt.stackSize;
                  continue;
                } else {
                  if (Mt === 11)
                    return yt.stackSize = Ht, !0;
                  if (Mt === 0 && Nt === Rt.length)
                    Rt[Nt - 1] = 14, Lt = ft[14];
                  else if (Mt === 9) {
                    Rt.copyWithin(Nt - 1, Nt, -1), Nt -= 1, _t -= 1;
                    continue;
                  } else
                    Lt = ft[Mt];
                }
                if (Lt) {
                  if (Lt.stem && (yt.hints += Ht >> 1, Mt === 3 || Mt === 23 ? yt.hasVStems = !0 : yt.hasVStems && (Mt === 1 || Mt === 18) && ((0, rt.warn)("CFF stem hints are in wrong order"), Rt[Nt - 1] = Mt === 1 ? 3 : 23)), "min" in Lt && !yt.undefStack && Ht < Lt.min)
                    return (0, rt.warn)("Not enough parameters for " + Lt.id + "; actual: " + Ht + ", expected: " + Lt.min), Ht === 0 ? (Rt[Nt - 1] = 14, !0) : !1;
                  yt.firstStackClearing && Lt.stackClearing && (yt.firstStackClearing = !1, Ht -= Lt.min, Ht >= 2 && Lt.stem ? Ht %= 2 : Ht > 1 && (0, rt.warn)("Found too many parameters for stack-clearing command"), Ht > 0 && (yt.width = Ft[Ht - 1])), "stackDelta" in Lt ? ("stackFn" in Lt && Lt.stackFn(Ft, Ht), Ht += Lt.stackDelta) : Lt.stackClearing ? Ht = 0 : Lt.resetStack ? (Ht = 0, yt.undefStack = !1) : Lt.undefStack && (Ht = 0, yt.undefStack = !0, yt.firstStackClearing = !1);
                }
              }
              return _t < Rt.length && Rt.fill(14, _t), yt.stackSize = Ht, !0;
            }
            parseCharStrings(yt) {
              let {
                charStrings: Rt,
                localSubrIndex: kt,
                globalSubrIndex: jt,
                fdSelect: Ht,
                fdArray: Ft,
                privateDict: _t
              } = yt;
              const Nt = [], Mt = [], Lt = Rt.count;
              for (let $t = 0; $t < Lt; $t++) {
                const Tt = Rt.get($t), Dt = {
                  callDepth: 0,
                  stackSize: 0,
                  stack: [],
                  undefStack: !0,
                  hints: 0,
                  firstStackClearing: !0,
                  seac: null,
                  width: null,
                  hasVStems: !1
                };
                let Ut = !0, Vt = null, Qt = _t;
                if (Ht && Ft.length) {
                  const qt = Ht.getFDIndex($t);
                  qt === -1 && ((0, rt.warn)("Glyph index is not in fd select."), Ut = !1), qt >= Ft.length && ((0, rt.warn)("Invalid fd index for glyph index."), Ut = !1), Ut && (Qt = Ft[qt].privateDict, Vt = Qt.subrsIndex);
                } else
                  kt && (Vt = kt);
                if (Ut && (Ut = this.parseCharString(Dt, Tt, Vt, jt)), Dt.width !== null) {
                  const qt = Qt.getByName("nominalWidthX");
                  Mt[$t] = qt + Dt.width;
                } else {
                  const qt = Qt.getByName("defaultWidthX");
                  Mt[$t] = qt;
                }
                Dt.seac !== null && (Nt[$t] = Dt.seac), Ut || Rt.set($t, new Uint8Array([14]));
              }
              return {
                charStrings: Rt,
                seacs: Nt,
                widths: Mt
              };
            }
            emptyPrivateDictionary(yt) {
              const Rt = this.createDict(Et, [], yt.strings);
              yt.setByKey(18, [0, 0]), yt.privateDict = Rt;
            }
            parsePrivateDict(yt) {
              if (!yt.hasName("Private")) {
                this.emptyPrivateDictionary(yt);
                return;
              }
              const Rt = yt.getByName("Private");
              if (!Array.isArray(Rt) || Rt.length !== 2) {
                yt.removeByName("Private");
                return;
              }
              const kt = Rt[0], jt = Rt[1];
              if (kt === 0 || jt >= this.bytes.length) {
                this.emptyPrivateDictionary(yt);
                return;
              }
              const Ht = jt + kt, Ft = this.bytes.subarray(jt, Ht), _t = this.parseDict(Ft), Nt = this.createDict(Et, _t, yt.strings);
              if (yt.privateDict = Nt, Nt.getByName("ExpansionFactor") === 0 && Nt.setByName("ExpansionFactor", 0.06), !Nt.getByName("Subrs"))
                return;
              const Mt = Nt.getByName("Subrs"), Lt = jt + Mt;
              if (Mt === 0 || Lt >= this.bytes.length) {
                this.emptyPrivateDictionary(yt);
                return;
              }
              const $t = this.parseIndex(Lt);
              Nt.subrsIndex = $t.obj;
            }
            parseCharsets(yt, Rt, kt, jt) {
              if (yt === 0)
                return new Bt(!0, St.ISO_ADOBE, st.ISOAdobeCharset);
              if (yt === 1)
                return new Bt(!0, St.EXPERT, st.ExpertCharset);
              if (yt === 2)
                return new Bt(!0, St.EXPERT_SUBSET, st.ExpertSubsetCharset);
              const Ht = this.bytes, Ft = yt, _t = Ht[yt++], Nt = [jt ? 0 : ".notdef"];
              let Mt, Lt, $t;
              switch (Rt -= 1, _t) {
                case 0:
                  for ($t = 0; $t < Rt; $t++)
                    Mt = Ht[yt++] << 8 | Ht[yt++], Nt.push(jt ? Mt : kt.get(Mt));
                  break;
                case 1:
                  for (; Nt.length <= Rt; )
                    for (Mt = Ht[yt++] << 8 | Ht[yt++], Lt = Ht[yt++], $t = 0; $t <= Lt; $t++)
                      Nt.push(jt ? Mt++ : kt.get(Mt++));
                  break;
                case 2:
                  for (; Nt.length <= Rt; )
                    for (Mt = Ht[yt++] << 8 | Ht[yt++], Lt = Ht[yt++] << 8 | Ht[yt++], $t = 0; $t <= Lt; $t++)
                      Nt.push(jt ? Mt++ : kt.get(Mt++));
                  break;
                default:
                  throw new rt.FormatError("Unknown charset format");
              }
              const Tt = yt, Dt = Ht.subarray(Ft, Tt);
              return new Bt(!1, _t, Nt, Dt);
            }
            parseEncoding(yt, Rt, kt, jt) {
              const Ht = /* @__PURE__ */ Object.create(null), Ft = this.bytes;
              let _t = !1, Nt, Mt, Lt, $t = null;
              function Tt() {
                const Dt = Ft[yt++];
                for (Mt = 0; Mt < Dt; Mt++) {
                  const Ut = Ft[yt++], Vt = (Ft[yt++] << 8) + (Ft[yt++] & 255);
                  Ht[Ut] = jt.indexOf(kt.get(Vt));
                }
              }
              if (yt === 0 || yt === 1) {
                _t = !0, Nt = yt;
                const Dt = yt ? lt.ExpertEncoding : lt.StandardEncoding;
                for (Mt = 0, Lt = jt.length; Mt < Lt; Mt++) {
                  const Ut = Dt.indexOf(jt[Mt]);
                  Ut !== -1 && (Ht[Ut] = Mt);
                }
              } else {
                const Dt = yt;
                switch (Nt = Ft[yt++], Nt & 127) {
                  case 0:
                    const Vt = Ft[yt++];
                    for (Mt = 1; Mt <= Vt; Mt++)
                      Ht[Ft[yt++]] = Mt;
                    break;
                  case 1:
                    const Qt = Ft[yt++];
                    let qt = 1;
                    for (Mt = 0; Mt < Qt; Mt++) {
                      const Zt = Ft[yt++], ar = Ft[yt++];
                      for (let Jt = Zt; Jt <= Zt + ar; Jt++)
                        Ht[Jt] = qt++;
                    }
                    break;
                  default:
                    throw new rt.FormatError(`Unknown encoding format: ${Nt} in CFF`);
                }
                const Ut = yt;
                Nt & 128 && (Ft[Dt] &= 127, Tt()), $t = Ft.subarray(Dt, Ut);
              }
              return Nt &= 127, new Ot(_t, Nt, Ht, $t);
            }
            parseFDSelect(yt, Rt) {
              const kt = this.bytes, jt = kt[yt++], Ht = [];
              let Ft;
              switch (jt) {
                case 0:
                  for (Ft = 0; Ft < Rt; ++Ft) {
                    const Nt = kt[yt++];
                    Ht.push(Nt);
                  }
                  break;
                case 3:
                  const _t = kt[yt++] << 8 | kt[yt++];
                  for (Ft = 0; Ft < _t; ++Ft) {
                    let Nt = kt[yt++] << 8 | kt[yt++];
                    Ft === 0 && Nt !== 0 && ((0, rt.warn)("parseFDSelect: The first range must have a first GID of 0 -- trying to recover."), Nt = 0);
                    const Mt = kt[yt++], Lt = kt[yt] << 8 | kt[yt + 1];
                    for (let $t = Nt; $t < Lt; ++$t)
                      Ht.push(Mt);
                  }
                  yt += 2;
                  break;
                default:
                  throw new rt.FormatError(`parseFDSelect: Unknown format "${jt}".`);
              }
              if (Ht.length !== Rt)
                throw new rt.FormatError("parseFDSelect: Invalid font data.");
              return new Pt(jt, Ht);
            }
          }
          at.CFFParser = dt;
          class gt {
            constructor() {
              this.header = null, this.names = [], this.topDict = null, this.strings = new mt(), this.globalSubrIndex = null, this.encoding = null, this.charset = null, this.charStrings = null, this.fdArray = [], this.fdSelect = null, this.isCIDFont = !1;
            }
            duplicateFirstGlyph() {
              if (this.charStrings.count >= 65535) {
                (0, rt.warn)("Not enough space in charstrings to duplicate first glyph.");
                return;
              }
              const yt = this.charStrings.get(0);
              this.charStrings.add(yt), this.isCIDFont && this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
            }
            hasGlyphId(yt) {
              return yt < 0 || yt >= this.charStrings.count ? !1 : this.charStrings.get(yt).length > 0;
            }
          }
          at.CFF = gt;
          class pt {
            constructor(yt, Rt, kt, jt) {
              this.major = yt, this.minor = Rt, this.hdrSize = kt, this.offSize = jt;
            }
          }
          at.CFFHeader = pt;
          class mt {
            constructor() {
              this.strings = [];
            }
            get(yt) {
              return yt >= 0 && yt <= ut - 1 ? it[yt] : yt - ut <= this.strings.length ? this.strings[yt - ut] : it[0];
            }
            getSID(yt) {
              let Rt = it.indexOf(yt);
              return Rt !== -1 ? Rt : (Rt = this.strings.indexOf(yt), Rt !== -1 ? Rt + ut : -1);
            }
            add(yt) {
              this.strings.push(yt);
            }
            get count() {
              return this.strings.length;
            }
          }
          at.CFFStrings = mt;
          class ct {
            constructor() {
              this.objects = [], this.length = 0;
            }
            add(yt) {
              this.length += yt.length, this.objects.push(yt);
            }
            set(yt, Rt) {
              this.length += Rt.length - this.objects[yt].length, this.objects[yt] = Rt;
            }
            get(yt) {
              return this.objects[yt];
            }
            get count() {
              return this.objects.length;
            }
          }
          at.CFFIndex = ct;
          class vt {
            constructor(yt, Rt) {
              this.keyToNameMap = yt.keyToNameMap, this.nameToKeyMap = yt.nameToKeyMap, this.defaults = yt.defaults, this.types = yt.types, this.opcodes = yt.opcodes, this.order = yt.order, this.strings = Rt, this.values = /* @__PURE__ */ Object.create(null);
            }
            setByKey(yt, Rt) {
              if (!(yt in this.keyToNameMap))
                return !1;
              if (Rt.length === 0)
                return !0;
              for (const jt of Rt)
                if (isNaN(jt))
                  return (0, rt.warn)(`Invalid CFFDict value: "${Rt}" for key "${yt}".`), !0;
              const kt = this.types[yt];
              return (kt === "num" || kt === "sid" || kt === "offset") && (Rt = Rt[0]), this.values[yt] = Rt, !0;
            }
            setByName(yt, Rt) {
              if (!(yt in this.nameToKeyMap))
                throw new rt.FormatError(`Invalid dictionary name "${yt}"`);
              this.values[this.nameToKeyMap[yt]] = Rt;
            }
            hasName(yt) {
              return this.nameToKeyMap[yt] in this.values;
            }
            getByName(yt) {
              if (!(yt in this.nameToKeyMap))
                throw new rt.FormatError(`Invalid dictionary name ${yt}"`);
              const Rt = this.nameToKeyMap[yt];
              return Rt in this.values ? this.values[Rt] : this.defaults[Rt];
            }
            removeByName(yt) {
              delete this.values[this.nameToKeyMap[yt]];
            }
            static createTables(yt) {
              const Rt = {
                keyToNameMap: {},
                nameToKeyMap: {},
                defaults: {},
                types: {},
                opcodes: {},
                order: []
              };
              for (const kt of yt) {
                const jt = Array.isArray(kt[0]) ? (kt[0][0] << 8) + kt[0][1] : kt[0];
                Rt.keyToNameMap[jt] = kt[1], Rt.nameToKeyMap[kt[1]] = jt, Rt.types[jt] = kt[2], Rt.defaults[jt] = kt[3], Rt.opcodes[jt] = Array.isArray(kt[0]) ? kt[0] : [kt[0]], Rt.order.push(jt);
              }
              return Rt;
            }
          }
          const At = [[[12, 30], "ROS", ["sid", "sid", "num"], null], [[12, 20], "SyntheticBase", "num", null], [0, "version", "sid", null], [1, "Notice", "sid", null], [[12, 0], "Copyright", "sid", null], [2, "FullName", "sid", null], [3, "FamilyName", "sid", null], [4, "Weight", "sid", null], [[12, 1], "isFixedPitch", "num", 0], [[12, 2], "ItalicAngle", "num", 0], [[12, 3], "UnderlinePosition", "num", -100], [[12, 4], "UnderlineThickness", "num", 50], [[12, 5], "PaintType", "num", 0], [[12, 6], "CharstringType", "num", 2], [[12, 7], "FontMatrix", ["num", "num", "num", "num", "num", "num"], [1e-3, 0, 0, 1e-3, 0, 0]], [13, "UniqueID", "num", null], [5, "FontBBox", ["num", "num", "num", "num"], [0, 0, 0, 0]], [[12, 8], "StrokeWidth", "num", 0], [14, "XUID", "array", null], [15, "charset", "offset", 0], [16, "Encoding", "offset", 0], [17, "CharStrings", "offset", 0], [18, "Private", ["offset", "offset"], null], [[12, 21], "PostScript", "sid", null], [[12, 22], "BaseFontName", "sid", null], [[12, 23], "BaseFontBlend", "delta", null], [[12, 31], "CIDFontVersion", "num", 0], [[12, 32], "CIDFontRevision", "num", 0], [[12, 33], "CIDFontType", "num", 0], [[12, 34], "CIDCount", "num", 8720], [[12, 35], "UIDBase", "num", null], [[12, 37], "FDSelect", "offset", null], [[12, 36], "FDArray", "offset", null], [[12, 38], "FontName", "sid", null]];
          class xt extends vt {
            static get tables() {
              return (0, rt.shadow)(this, "tables", this.createTables(At));
            }
            constructor(yt) {
              super(xt.tables, yt), this.privateDict = null;
            }
          }
          at.CFFTopDict = xt;
          const bt = [[6, "BlueValues", "delta", null], [7, "OtherBlues", "delta", null], [8, "FamilyBlues", "delta", null], [9, "FamilyOtherBlues", "delta", null], [[12, 9], "BlueScale", "num", 0.039625], [[12, 10], "BlueShift", "num", 7], [[12, 11], "BlueFuzz", "num", 1], [10, "StdHW", "num", null], [11, "StdVW", "num", null], [[12, 12], "StemSnapH", "delta", null], [[12, 13], "StemSnapV", "delta", null], [[12, 14], "ForceBold", "num", 0], [[12, 17], "LanguageGroup", "num", 0], [[12, 18], "ExpansionFactor", "num", 0.06], [[12, 19], "initialRandomSeed", "num", 0], [20, "defaultWidthX", "num", 0], [21, "nominalWidthX", "num", 0], [19, "Subrs", "offset", null]];
          class Et extends vt {
            static get tables() {
              return (0, rt.shadow)(this, "tables", this.createTables(bt));
            }
            constructor(yt) {
              super(Et.tables, yt), this.subrsIndex = null;
            }
          }
          at.CFFPrivateDict = Et;
          const St = {
            ISO_ADOBE: 0,
            EXPERT: 1,
            EXPERT_SUBSET: 2
          };
          class Bt {
            constructor(yt, Rt, kt, jt) {
              this.predefined = yt, this.format = Rt, this.charset = kt, this.raw = jt;
            }
          }
          at.CFFCharset = Bt;
          class Ot {
            constructor(yt, Rt, kt, jt) {
              this.predefined = yt, this.format = Rt, this.encoding = kt, this.raw = jt;
            }
          }
          class Pt {
            constructor(yt, Rt) {
              this.format = yt, this.fdSelect = Rt;
            }
            getFDIndex(yt) {
              return yt < 0 || yt >= this.fdSelect.length ? -1 : this.fdSelect[yt];
            }
          }
          at.CFFFDSelect = Pt;
          class wt {
            constructor() {
              this.offsets = /* @__PURE__ */ Object.create(null);
            }
            isTracking(yt) {
              return yt in this.offsets;
            }
            track(yt, Rt) {
              if (yt in this.offsets)
                throw new rt.FormatError(`Already tracking location of ${yt}`);
              this.offsets[yt] = Rt;
            }
            offset(yt) {
              for (const Rt in this.offsets)
                this.offsets[Rt] += yt;
            }
            setEntryLocation(yt, Rt, kt) {
              if (!(yt in this.offsets))
                throw new rt.FormatError(`Not tracking location of ${yt}`);
              const jt = kt.data, Ht = this.offsets[yt], Ft = 5;
              for (let _t = 0, Nt = Rt.length; _t < Nt; ++_t) {
                const Mt = _t * Ft + Ht, Lt = Mt + 1, $t = Mt + 2, Tt = Mt + 3, Dt = Mt + 4;
                if (jt[Mt] !== 29 || jt[Lt] !== 0 || jt[$t] !== 0 || jt[Tt] !== 0 || jt[Dt] !== 0)
                  throw new rt.FormatError("writing to an offset that is not empty");
                const Ut = Rt[_t];
                jt[Mt] = 29, jt[Lt] = Ut >> 24 & 255, jt[$t] = Ut >> 16 & 255, jt[Tt] = Ut >> 8 & 255, jt[Dt] = Ut & 255;
              }
            }
          }
          class Ct {
            constructor(yt) {
              this.cff = yt;
            }
            compile() {
              const yt = this.cff, Rt = {
                data: [],
                length: 0,
                add(Tt) {
                  try {
                    this.data.push(...Tt);
                  } catch {
                    this.data = this.data.concat(Tt);
                  }
                  this.length = this.data.length;
                }
              }, kt = this.compileHeader(yt.header);
              Rt.add(kt);
              const jt = this.compileNameIndex(yt.names);
              if (Rt.add(jt), yt.isCIDFont && yt.topDict.hasName("FontMatrix")) {
                const Tt = yt.topDict.getByName("FontMatrix");
                yt.topDict.removeByName("FontMatrix");
                for (const Dt of yt.fdArray) {
                  let Ut = Tt.slice(0);
                  Dt.hasName("FontMatrix") && (Ut = rt.Util.transform(Ut, Dt.getByName("FontMatrix"))), Dt.setByName("FontMatrix", Ut);
                }
              }
              const Ht = yt.topDict.getByName("XUID");
              (Ht == null ? void 0 : Ht.length) > 16 && yt.topDict.removeByName("XUID"), yt.topDict.setByName("charset", 0);
              let Ft = this.compileTopDicts([yt.topDict], Rt.length, yt.isCIDFont);
              Rt.add(Ft.output);
              const _t = Ft.trackers[0], Nt = this.compileStringIndex(yt.strings.strings);
              Rt.add(Nt);
              const Mt = this.compileIndex(yt.globalSubrIndex);
              if (Rt.add(Mt), yt.encoding && yt.topDict.hasName("Encoding"))
                if (yt.encoding.predefined)
                  _t.setEntryLocation("Encoding", [yt.encoding.format], Rt);
                else {
                  const Tt = this.compileEncoding(yt.encoding);
                  _t.setEntryLocation("Encoding", [Rt.length], Rt), Rt.add(Tt);
                }
              const Lt = this.compileCharset(yt.charset, yt.charStrings.count, yt.strings, yt.isCIDFont);
              _t.setEntryLocation("charset", [Rt.length], Rt), Rt.add(Lt);
              const $t = this.compileCharStrings(yt.charStrings);
              if (_t.setEntryLocation("CharStrings", [Rt.length], Rt), Rt.add($t), yt.isCIDFont) {
                _t.setEntryLocation("FDSelect", [Rt.length], Rt);
                const Tt = this.compileFDSelect(yt.fdSelect);
                Rt.add(Tt), Ft = this.compileTopDicts(yt.fdArray, Rt.length, !0), _t.setEntryLocation("FDArray", [Rt.length], Rt), Rt.add(Ft.output);
                const Dt = Ft.trackers;
                this.compilePrivateDicts(yt.fdArray, Dt, Rt);
              }
              return this.compilePrivateDicts([yt.topDict], [_t], Rt), Rt.add([0]), Rt.data;
            }
            encodeNumber(yt) {
              return Number.isInteger(yt) ? this.encodeInteger(yt) : this.encodeFloat(yt);
            }
            static get EncodeFloatRegExp() {
              return (0, rt.shadow)(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
            }
            encodeFloat(yt) {
              let Rt = yt.toString();
              const kt = Ct.EncodeFloatRegExp.exec(Rt);
              if (kt) {
                const Nt = parseFloat("1e" + ((kt[2] ? +kt[2] : 0) + kt[1].length));
                Rt = (Math.round(yt * Nt) / Nt).toString();
              }
              let jt = "", Ht, Ft;
              for (Ht = 0, Ft = Rt.length; Ht < Ft; ++Ht) {
                const Nt = Rt[Ht];
                Nt === "e" ? jt += Rt[++Ht] === "-" ? "c" : "b" : Nt === "." ? jt += "a" : Nt === "-" ? jt += "e" : jt += Nt;
              }
              jt += jt.length & 1 ? "f" : "ff";
              const _t = [30];
              for (Ht = 0, Ft = jt.length; Ht < Ft; Ht += 2)
                _t.push(parseInt(jt.substring(Ht, Ht + 2), 16));
              return _t;
            }
            encodeInteger(yt) {
              let Rt;
              return yt >= -107 && yt <= 107 ? Rt = [yt + 139] : yt >= 108 && yt <= 1131 ? (yt -= 108, Rt = [(yt >> 8) + 247, yt & 255]) : yt >= -1131 && yt <= -108 ? (yt = -yt - 108, Rt = [(yt >> 8) + 251, yt & 255]) : yt >= -32768 && yt <= 32767 ? Rt = [28, yt >> 8 & 255, yt & 255] : Rt = [29, yt >> 24 & 255, yt >> 16 & 255, yt >> 8 & 255, yt & 255], Rt;
            }
            compileHeader(yt) {
              return [yt.major, yt.minor, 4, yt.offSize];
            }
            compileNameIndex(yt) {
              const Rt = new ct();
              for (const kt of yt) {
                const jt = Math.min(kt.length, 127);
                let Ht = new Array(jt);
                for (let Ft = 0; Ft < jt; Ft++) {
                  let _t = kt[Ft];
                  (_t < "!" || _t > "~" || _t === "[" || _t === "]" || _t === "(" || _t === ")" || _t === "{" || _t === "}" || _t === "<" || _t === ">" || _t === "/" || _t === "%") && (_t = "_"), Ht[Ft] = _t;
                }
                Ht = Ht.join(""), Ht === "" && (Ht = "Bad_Font_Name"), Rt.add((0, rt.stringToBytes)(Ht));
              }
              return this.compileIndex(Rt);
            }
            compileTopDicts(yt, Rt, kt) {
              const jt = [];
              let Ht = new ct();
              for (const Ft of yt) {
                kt && (Ft.removeByName("CIDFontVersion"), Ft.removeByName("CIDFontRevision"), Ft.removeByName("CIDFontType"), Ft.removeByName("CIDCount"), Ft.removeByName("UIDBase"));
                const _t = new wt(), Nt = this.compileDict(Ft, _t);
                jt.push(_t), Ht.add(Nt), _t.offset(Rt);
              }
              return Ht = this.compileIndex(Ht, jt), {
                trackers: jt,
                output: Ht
              };
            }
            compilePrivateDicts(yt, Rt, kt) {
              for (let jt = 0, Ht = yt.length; jt < Ht; ++jt) {
                const Ft = yt[jt], _t = Ft.privateDict;
                if (!_t || !Ft.hasName("Private"))
                  throw new rt.FormatError("There must be a private dictionary.");
                const Nt = new wt(), Mt = this.compileDict(_t, Nt);
                let Lt = kt.length;
                if (Nt.offset(Lt), Mt.length || (Lt = 0), Rt[jt].setEntryLocation("Private", [Mt.length, Lt], kt), kt.add(Mt), _t.subrsIndex && _t.hasName("Subrs")) {
                  const $t = this.compileIndex(_t.subrsIndex);
                  Nt.setEntryLocation("Subrs", [Mt.length], kt), kt.add($t);
                }
              }
            }
            compileDict(yt, Rt) {
              const kt = [];
              for (const jt of yt.order) {
                if (!(jt in yt.values))
                  continue;
                let Ht = yt.values[jt], Ft = yt.types[jt];
                if (Array.isArray(Ft) || (Ft = [Ft]), Array.isArray(Ht) || (Ht = [Ht]), Ht.length !== 0) {
                  for (let _t = 0, Nt = Ft.length; _t < Nt; ++_t) {
                    const Mt = Ft[_t], Lt = Ht[_t];
                    switch (Mt) {
                      case "num":
                      case "sid":
                        kt.push(...this.encodeNumber(Lt));
                        break;
                      case "offset":
                        const $t = yt.keyToNameMap[jt];
                        Rt.isTracking($t) || Rt.track($t, kt.length), kt.push(29, 0, 0, 0, 0);
                        break;
                      case "array":
                      case "delta":
                        kt.push(...this.encodeNumber(Lt));
                        for (let Tt = 1, Dt = Ht.length; Tt < Dt; ++Tt)
                          kt.push(...this.encodeNumber(Ht[Tt]));
                        break;
                      default:
                        throw new rt.FormatError(`Unknown data type of ${Mt}`);
                    }
                  }
                  kt.push(...yt.opcodes[jt]);
                }
              }
              return kt;
            }
            compileStringIndex(yt) {
              const Rt = new ct();
              for (const kt of yt)
                Rt.add((0, rt.stringToBytes)(kt));
              return this.compileIndex(Rt);
            }
            compileCharStrings(yt) {
              const Rt = new ct();
              for (let kt = 0; kt < yt.count; kt++) {
                const jt = yt.get(kt);
                if (jt.length === 0) {
                  Rt.add(new Uint8Array([139, 14]));
                  continue;
                }
                Rt.add(jt);
              }
              return this.compileIndex(Rt);
            }
            compileCharset(yt, Rt, kt, jt) {
              let Ht;
              const Ft = Rt - 1;
              if (jt)
                Ht = new Uint8Array([2, 0, 0, Ft >> 8 & 255, Ft & 255]);
              else {
                const _t = 1 + Ft * 2;
                Ht = new Uint8Array(_t), Ht[0] = 0;
                let Nt = 0;
                const Mt = yt.charset.length;
                let Lt = !1;
                for (let $t = 1; $t < Ht.length; $t += 2) {
                  let Tt = 0;
                  if (Nt < Mt) {
                    const Dt = yt.charset[Nt++];
                    Tt = kt.getSID(Dt), Tt === -1 && (Tt = 0, Lt || (Lt = !0, (0, rt.warn)(`Couldn't find ${Dt} in CFF strings`)));
                  }
                  Ht[$t] = Tt >> 8 & 255, Ht[$t + 1] = Tt & 255;
                }
              }
              return this.compileTypedArray(Ht);
            }
            compileEncoding(yt) {
              return this.compileTypedArray(yt.raw);
            }
            compileFDSelect(yt) {
              const Rt = yt.format;
              let kt, jt;
              switch (Rt) {
                case 0:
                  for (kt = new Uint8Array(1 + yt.fdSelect.length), kt[0] = Rt, jt = 0; jt < yt.fdSelect.length; jt++)
                    kt[jt + 1] = yt.fdSelect[jt];
                  break;
                case 3:
                  const Ht = 0;
                  let Ft = yt.fdSelect[0];
                  const _t = [Rt, 0, 0, Ht >> 8 & 255, Ht & 255, Ft];
                  for (jt = 1; jt < yt.fdSelect.length; jt++) {
                    const Mt = yt.fdSelect[jt];
                    Mt !== Ft && (_t.push(jt >> 8 & 255, jt & 255, Mt), Ft = Mt);
                  }
                  const Nt = (_t.length - 3) / 3;
                  _t[1] = Nt >> 8 & 255, _t[2] = Nt & 255, _t.push(jt >> 8 & 255, jt & 255), kt = new Uint8Array(_t);
                  break;
              }
              return this.compileTypedArray(kt);
            }
            compileTypedArray(yt) {
              return Array.from(yt);
            }
            compileIndex(yt) {
              let Rt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
              const kt = yt.objects, jt = kt.length;
              if (jt === 0)
                return [0, 0];
              const Ht = [jt >> 8 & 255, jt & 255];
              let Ft = 1, _t;
              for (_t = 0; _t < jt; ++_t)
                Ft += kt[_t].length;
              let Nt;
              Ft < 256 ? Nt = 1 : Ft < 65536 ? Nt = 2 : Ft < 16777216 ? Nt = 3 : Nt = 4, Ht.push(Nt);
              let Mt = 1;
              for (_t = 0; _t < jt + 1; _t++)
                Nt === 1 ? Ht.push(Mt & 255) : Nt === 2 ? Ht.push(Mt >> 8 & 255, Mt & 255) : Nt === 3 ? Ht.push(Mt >> 16 & 255, Mt >> 8 & 255, Mt & 255) : Ht.push(Mt >>> 24 & 255, Mt >> 16 & 255, Mt >> 8 & 255, Mt & 255), kt[_t] && (Mt += kt[_t].length);
              for (_t = 0; _t < jt; _t++)
                Rt[_t] && Rt[_t].offset(Ht.length), Ht.push(...kt[_t]);
              return Ht;
            }
          }
          at.CFFCompiler = Ct;
        },
        /* 187 */
        /***/
        (nt, at) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.ISOAdobeCharset = at.ExpertSubsetCharset = at.ExpertCharset = void 0;
          const ot = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron"];
          at.ISOAdobeCharset = ot;
          const rt = [".notdef", "space", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
          at.ExpertCharset = rt;
          const st = [".notdef", "space", "dollaroldstyle", "dollarsuperior", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "hyphensuperior", "colonmonetary", "onefitted", "rupiah", "centoldstyle", "figuredash", "hypheninferior", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior"];
          at.ExpertSubsetCharset = st;
        },
        /* 188 */
        /***/
        (nt, at) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.ZapfDingbatsEncoding = at.WinAnsiEncoding = at.SymbolSetEncoding = at.StandardEncoding = at.MacRomanEncoding = at.ExpertEncoding = void 0, at.getEncoding = ft;
          const ot = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "", "", "", "isuperior", "", "", "lsuperior", "msuperior", "nsuperior", "osuperior", "", "", "rsuperior", "ssuperior", "tsuperior", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdownsmall", "centoldstyle", "Lslashsmall", "", "", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "", "Dotaccentsmall", "", "", "Macronsmall", "", "", "figuredash", "hypheninferior", "", "", "Ogoneksmall", "Ringsmall", "Cedillasmall", "", "", "", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
          at.ExpertEncoding = ot;
          const rt = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "centoldstyle", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "", "threequartersemdash", "", "questionsmall", "", "", "", "", "Ethsmall", "", "", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "", "", "", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hypheninferior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "asuperior", "centsuperior", "", "", "", "", "Aacutesmall", "Agravesmall", "Acircumflexsmall", "Adieresissmall", "Atildesmall", "Aringsmall", "Ccedillasmall", "Eacutesmall", "Egravesmall", "Ecircumflexsmall", "Edieresissmall", "Iacutesmall", "Igravesmall", "Icircumflexsmall", "Idieresissmall", "Ntildesmall", "Oacutesmall", "Ogravesmall", "Ocircumflexsmall", "Odieresissmall", "Otildesmall", "Uacutesmall", "Ugravesmall", "Ucircumflexsmall", "Udieresissmall", "", "eightsuperior", "fourinferior", "threeinferior", "sixinferior", "eightinferior", "seveninferior", "Scaronsmall", "", "centinferior", "twoinferior", "", "Dieresissmall", "", "Caronsmall", "osuperior", "fiveinferior", "", "commainferior", "periodinferior", "Yacutesmall", "", "dollarinferior", "", "", "Thornsmall", "", "nineinferior", "zeroinferior", "Zcaronsmall", "AEsmall", "Oslashsmall", "questiondownsmall", "oneinferior", "Lslashsmall", "", "", "", "", "", "", "Cedillasmall", "", "", "", "", "", "OEsmall", "figuredash", "hyphensuperior", "", "", "", "", "exclamdownsmall", "", "Ydieresissmall", "", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "ninesuperior", "zerosuperior", "", "esuperior", "rsuperior", "tsuperior", "", "", "isuperior", "ssuperior", "dsuperior", "", "", "", "", "", "lsuperior", "Ogoneksmall", "Brevesmall", "Macronsmall", "bsuperior", "nsuperior", "msuperior", "commasuperior", "periodsuperior", "Dotaccentsmall", "Ringsmall", "", "", "", ""], st = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "space", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron"];
          at.MacRomanEncoding = st;
          const lt = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "", "endash", "dagger", "daggerdbl", "periodcentered", "", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "", "questiondown", "", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "", "ring", "cedilla", "", "hungarumlaut", "ogonek", "caron", "emdash", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "AE", "", "ordfeminine", "", "", "", "", "Lslash", "Oslash", "OE", "ordmasculine", "", "", "", "", "", "ae", "", "", "", "dotlessi", "", "", "lslash", "oslash", "oe", "germandbls", "", "", "", ""];
          at.StandardEncoding = lt;
          const et = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "bullet", "Euro", "bullet", "quotesinglbase", "florin", "quotedblbase", "ellipsis", "dagger", "daggerdbl", "circumflex", "perthousand", "Scaron", "guilsinglleft", "OE", "bullet", "Zcaron", "bullet", "bullet", "quoteleft", "quoteright", "quotedblleft", "quotedblright", "bullet", "endash", "emdash", "tilde", "trademark", "scaron", "guilsinglright", "oe", "bullet", "zcaron", "Ydieresis", "space", "exclamdown", "cent", "sterling", "currency", "yen", "brokenbar", "section", "dieresis", "copyright", "ordfeminine", "guillemotleft", "logicalnot", "hyphen", "registered", "macron", "degree", "plusminus", "twosuperior", "threesuperior", "acute", "mu", "paragraph", "periodcentered", "cedilla", "onesuperior", "ordmasculine", "guillemotright", "onequarter", "onehalf", "threequarters", "questiondown", "Agrave", "Aacute", "Acircumflex", "Atilde", "Adieresis", "Aring", "AE", "Ccedilla", "Egrave", "Eacute", "Ecircumflex", "Edieresis", "Igrave", "Iacute", "Icircumflex", "Idieresis", "Eth", "Ntilde", "Ograve", "Oacute", "Ocircumflex", "Otilde", "Odieresis", "multiply", "Oslash", "Ugrave", "Uacute", "Ucircumflex", "Udieresis", "Yacute", "Thorn", "germandbls", "agrave", "aacute", "acircumflex", "atilde", "adieresis", "aring", "ae", "ccedilla", "egrave", "eacute", "ecircumflex", "edieresis", "igrave", "iacute", "icircumflex", "idieresis", "eth", "ntilde", "ograve", "oacute", "ocircumflex", "otilde", "odieresis", "divide", "oslash", "ugrave", "uacute", "ucircumflex", "udieresis", "yacute", "thorn", "ydieresis"];
          at.WinAnsiEncoding = et;
          const it = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "universal", "numbersign", "existential", "percent", "ampersand", "suchthat", "parenleft", "parenright", "asteriskmath", "plus", "comma", "minus", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "congruent", "Alpha", "Beta", "Chi", "Delta", "Epsilon", "Phi", "Gamma", "Eta", "Iota", "theta1", "Kappa", "Lambda", "Mu", "Nu", "Omicron", "Pi", "Theta", "Rho", "Sigma", "Tau", "Upsilon", "sigma1", "Omega", "Xi", "Psi", "Zeta", "bracketleft", "therefore", "bracketright", "perpendicular", "underscore", "radicalex", "alpha", "beta", "chi", "delta", "epsilon", "phi", "gamma", "eta", "iota", "phi1", "kappa", "lambda", "mu", "nu", "omicron", "pi", "theta", "rho", "sigma", "tau", "upsilon", "omega1", "omega", "xi", "psi", "zeta", "braceleft", "bar", "braceright", "similar", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Euro", "Upsilon1", "minute", "lessequal", "fraction", "infinity", "florin", "club", "diamond", "heart", "spade", "arrowboth", "arrowleft", "arrowup", "arrowright", "arrowdown", "degree", "plusminus", "second", "greaterequal", "multiply", "proportional", "partialdiff", "bullet", "divide", "notequal", "equivalence", "approxequal", "ellipsis", "arrowvertex", "arrowhorizex", "carriagereturn", "aleph", "Ifraktur", "Rfraktur", "weierstrass", "circlemultiply", "circleplus", "emptyset", "intersection", "union", "propersuperset", "reflexsuperset", "notsubset", "propersubset", "reflexsubset", "element", "notelement", "angle", "gradient", "registerserif", "copyrightserif", "trademarkserif", "product", "radical", "dotmath", "logicalnot", "logicaland", "logicalor", "arrowdblboth", "arrowdblleft", "arrowdblup", "arrowdblright", "arrowdbldown", "lozenge", "angleleft", "registersans", "copyrightsans", "trademarksans", "summation", "parenlefttp", "parenleftex", "parenleftbt", "bracketlefttp", "bracketleftex", "bracketleftbt", "bracelefttp", "braceleftmid", "braceleftbt", "braceex", "", "angleright", "integral", "integraltp", "integralex", "integralbt", "parenrighttp", "parenrightex", "parenrightbt", "bracketrighttp", "bracketrightex", "bracketrightbt", "bracerighttp", "bracerightmid", "bracerightbt", ""];
          at.SymbolSetEncoding = it;
          const ut = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "a1", "a2", "a202", "a3", "a4", "a5", "a119", "a118", "a117", "a11", "a12", "a13", "a14", "a15", "a16", "a105", "a17", "a18", "a19", "a20", "a21", "a22", "a23", "a24", "a25", "a26", "a27", "a28", "a6", "a7", "a8", "a9", "a10", "a29", "a30", "a31", "a32", "a33", "a34", "a35", "a36", "a37", "a38", "a39", "a40", "a41", "a42", "a43", "a44", "a45", "a46", "a47", "a48", "a49", "a50", "a51", "a52", "a53", "a54", "a55", "a56", "a57", "a58", "a59", "a60", "a61", "a62", "a63", "a64", "a65", "a66", "a67", "a68", "a69", "a70", "a71", "a72", "a73", "a74", "a203", "a75", "a204", "a76", "a77", "a78", "a79", "a81", "a82", "a83", "a84", "a97", "a98", "a99", "a100", "", "a89", "a90", "a93", "a94", "a91", "a92", "a205", "a85", "a206", "a86", "a87", "a88", "a95", "a96", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "a101", "a102", "a103", "a104", "a106", "a107", "a108", "a112", "a111", "a110", "a109", "a120", "a121", "a122", "a123", "a124", "a125", "a126", "a127", "a128", "a129", "a130", "a131", "a132", "a133", "a134", "a135", "a136", "a137", "a138", "a139", "a140", "a141", "a142", "a143", "a144", "a145", "a146", "a147", "a148", "a149", "a150", "a151", "a152", "a153", "a154", "a155", "a156", "a157", "a158", "a159", "a160", "a161", "a163", "a164", "a196", "a165", "a192", "a166", "a167", "a168", "a169", "a170", "a171", "a172", "a173", "a162", "a174", "a175", "a176", "a177", "a178", "a179", "a193", "a180", "a199", "a181", "a200", "a182", "", "a201", "a183", "a184", "a197", "a185", "a194", "a198", "a186", "a195", "a187", "a188", "a189", "a190", "a191", ""];
          at.ZapfDingbatsEncoding = ut;
          function ft(ht) {
            switch (ht) {
              case "WinAnsiEncoding":
                return et;
              case "StandardEncoding":
                return lt;
              case "MacRomanEncoding":
                return st;
              case "SymbolSetEncoding":
                return it;
              case "ZapfDingbatsEncoding":
                return ut;
              case "ExpertEncoding":
                return ot;
              case "MacExpertEncoding":
                return rt;
              default:
                return null;
            }
          }
        },
        /* 189 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.SEAC_ANALYSIS_ENABLED = at.MacStandardGlyphOrdering = at.FontFlags = void 0, at.normalizeFontName = gt, at.recoverGlyphName = ht, at.type1FontGlyphMapping = dt, ot(158);
          var rt = ot(188), st = ot(190), lt = ot(191), et = ot(145);
          const it = !0;
          at.SEAC_ANALYSIS_ENABLED = it;
          const ut = {
            FixedPitch: 1,
            Serif: 2,
            Symbolic: 4,
            Script: 8,
            Nonsymbolic: 32,
            Italic: 64,
            AllCap: 65536,
            SmallCap: 131072,
            ForceBold: 262144
          };
          at.FontFlags = ut;
          const ft = [".notdef", ".null", "nonmarkingreturn", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "nonbreakingspace", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "Lslash", "lslash", "Scaron", "scaron", "Zcaron", "zcaron", "brokenbar", "Eth", "eth", "Yacute", "yacute", "Thorn", "thorn", "minus", "multiply", "onesuperior", "twosuperior", "threesuperior", "onehalf", "onequarter", "threequarters", "franc", "Gbreve", "gbreve", "Idotaccent", "Scedilla", "scedilla", "Cacute", "cacute", "Ccaron", "ccaron", "dcroat"];
          at.MacStandardGlyphOrdering = ft;
          function ht(pt, mt) {
            if (mt[pt] !== void 0)
              return pt;
            const ct = (0, lt.getUnicodeForGlyph)(pt, mt);
            if (ct !== -1) {
              for (const vt in mt)
                if (mt[vt] === ct)
                  return vt;
            }
            return (0, et.info)("Unable to recover a standard glyph name for: " + pt), pt;
          }
          function dt(pt, mt, ct) {
            const vt = /* @__PURE__ */ Object.create(null);
            let At, xt, bt;
            const Et = !!(pt.flags & ut.Symbolic);
            if (pt.isInternalFont)
              for (bt = mt, xt = 0; xt < bt.length; xt++)
                At = ct.indexOf(bt[xt]), vt[xt] = At >= 0 ? At : 0;
            else if (pt.baseEncodingName)
              for (bt = (0, rt.getEncoding)(pt.baseEncodingName), xt = 0; xt < bt.length; xt++)
                At = ct.indexOf(bt[xt]), vt[xt] = At >= 0 ? At : 0;
            else if (Et)
              for (xt in mt)
                vt[xt] = mt[xt];
            else
              for (bt = rt.StandardEncoding, xt = 0; xt < bt.length; xt++)
                At = ct.indexOf(bt[xt]), vt[xt] = At >= 0 ? At : 0;
            const St = pt.differences;
            let Bt;
            if (St)
              for (xt in St) {
                const Ot = St[xt];
                if (At = ct.indexOf(Ot), At === -1) {
                  Bt || (Bt = (0, st.getGlyphsUnicode)());
                  const Pt = ht(Ot, Bt);
                  Pt !== Ot && (At = ct.indexOf(Pt));
                }
                vt[xt] = At >= 0 ? At : 0;
              }
            return vt;
          }
          function gt(pt) {
            return pt.replaceAll(/[,_]/g, "-").replaceAll(/\s/g, "");
          }
        },
        /* 190 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.getGlyphsUnicode = at.getDingbatsGlyphsUnicode = void 0;
          var rt = ot(150);
          const st = (0, rt.getLookupTableFactory)(function(et) {
            et.A = 65, et.AE = 198, et.AEacute = 508, et.AEmacron = 482, et.AEsmall = 63462, et.Aacute = 193, et.Aacutesmall = 63457, et.Abreve = 258, et.Abreveacute = 7854, et.Abrevecyrillic = 1232, et.Abrevedotbelow = 7862, et.Abrevegrave = 7856, et.Abrevehookabove = 7858, et.Abrevetilde = 7860, et.Acaron = 461, et.Acircle = 9398, et.Acircumflex = 194, et.Acircumflexacute = 7844, et.Acircumflexdotbelow = 7852, et.Acircumflexgrave = 7846, et.Acircumflexhookabove = 7848, et.Acircumflexsmall = 63458, et.Acircumflextilde = 7850, et.Acute = 63177, et.Acutesmall = 63412, et.Acyrillic = 1040, et.Adblgrave = 512, et.Adieresis = 196, et.Adieresiscyrillic = 1234, et.Adieresismacron = 478, et.Adieresissmall = 63460, et.Adotbelow = 7840, et.Adotmacron = 480, et.Agrave = 192, et.Agravesmall = 63456, et.Ahookabove = 7842, et.Aiecyrillic = 1236, et.Ainvertedbreve = 514, et.Alpha = 913, et.Alphatonos = 902, et.Amacron = 256, et.Amonospace = 65313, et.Aogonek = 260, et.Aring = 197, et.Aringacute = 506, et.Aringbelow = 7680, et.Aringsmall = 63461, et.Asmall = 63329, et.Atilde = 195, et.Atildesmall = 63459, et.Aybarmenian = 1329, et.B = 66, et.Bcircle = 9399, et.Bdotaccent = 7682, et.Bdotbelow = 7684, et.Becyrillic = 1041, et.Benarmenian = 1330, et.Beta = 914, et.Bhook = 385, et.Blinebelow = 7686, et.Bmonospace = 65314, et.Brevesmall = 63220, et.Bsmall = 63330, et.Btopbar = 386, et.C = 67, et.Caarmenian = 1342, et.Cacute = 262, et.Caron = 63178, et.Caronsmall = 63221, et.Ccaron = 268, et.Ccedilla = 199, et.Ccedillaacute = 7688, et.Ccedillasmall = 63463, et.Ccircle = 9400, et.Ccircumflex = 264, et.Cdot = 266, et.Cdotaccent = 266, et.Cedillasmall = 63416, et.Chaarmenian = 1353, et.Cheabkhasiancyrillic = 1212, et.Checyrillic = 1063, et.Chedescenderabkhasiancyrillic = 1214, et.Chedescendercyrillic = 1206, et.Chedieresiscyrillic = 1268, et.Cheharmenian = 1347, et.Chekhakassiancyrillic = 1227, et.Cheverticalstrokecyrillic = 1208, et.Chi = 935, et.Chook = 391, et.Circumflexsmall = 63222, et.Cmonospace = 65315, et.Coarmenian = 1361, et.Csmall = 63331, et.D = 68, et.DZ = 497, et.DZcaron = 452, et.Daarmenian = 1332, et.Dafrican = 393, et.Dcaron = 270, et.Dcedilla = 7696, et.Dcircle = 9401, et.Dcircumflexbelow = 7698, et.Dcroat = 272, et.Ddotaccent = 7690, et.Ddotbelow = 7692, et.Decyrillic = 1044, et.Deicoptic = 1006, et.Delta = 8710, et.Deltagreek = 916, et.Dhook = 394, et.Dieresis = 63179, et.DieresisAcute = 63180, et.DieresisGrave = 63181, et.Dieresissmall = 63400, et.Digammagreek = 988, et.Djecyrillic = 1026, et.Dlinebelow = 7694, et.Dmonospace = 65316, et.Dotaccentsmall = 63223, et.Dslash = 272, et.Dsmall = 63332, et.Dtopbar = 395, et.Dz = 498, et.Dzcaron = 453, et.Dzeabkhasiancyrillic = 1248, et.Dzecyrillic = 1029, et.Dzhecyrillic = 1039, et.E = 69, et.Eacute = 201, et.Eacutesmall = 63465, et.Ebreve = 276, et.Ecaron = 282, et.Ecedillabreve = 7708, et.Echarmenian = 1333, et.Ecircle = 9402, et.Ecircumflex = 202, et.Ecircumflexacute = 7870, et.Ecircumflexbelow = 7704, et.Ecircumflexdotbelow = 7878, et.Ecircumflexgrave = 7872, et.Ecircumflexhookabove = 7874, et.Ecircumflexsmall = 63466, et.Ecircumflextilde = 7876, et.Ecyrillic = 1028, et.Edblgrave = 516, et.Edieresis = 203, et.Edieresissmall = 63467, et.Edot = 278, et.Edotaccent = 278, et.Edotbelow = 7864, et.Efcyrillic = 1060, et.Egrave = 200, et.Egravesmall = 63464, et.Eharmenian = 1335, et.Ehookabove = 7866, et.Eightroman = 8551, et.Einvertedbreve = 518, et.Eiotifiedcyrillic = 1124, et.Elcyrillic = 1051, et.Elevenroman = 8554, et.Emacron = 274, et.Emacronacute = 7702, et.Emacrongrave = 7700, et.Emcyrillic = 1052, et.Emonospace = 65317, et.Encyrillic = 1053, et.Endescendercyrillic = 1186, et.Eng = 330, et.Enghecyrillic = 1188, et.Enhookcyrillic = 1223, et.Eogonek = 280, et.Eopen = 400, et.Epsilon = 917, et.Epsilontonos = 904, et.Ercyrillic = 1056, et.Ereversed = 398, et.Ereversedcyrillic = 1069, et.Escyrillic = 1057, et.Esdescendercyrillic = 1194, et.Esh = 425, et.Esmall = 63333, et.Eta = 919, et.Etarmenian = 1336, et.Etatonos = 905, et.Eth = 208, et.Ethsmall = 63472, et.Etilde = 7868, et.Etildebelow = 7706, et.Euro = 8364, et.Ezh = 439, et.Ezhcaron = 494, et.Ezhreversed = 440, et.F = 70, et.Fcircle = 9403, et.Fdotaccent = 7710, et.Feharmenian = 1366, et.Feicoptic = 996, et.Fhook = 401, et.Fitacyrillic = 1138, et.Fiveroman = 8548, et.Fmonospace = 65318, et.Fourroman = 8547, et.Fsmall = 63334, et.G = 71, et.GBsquare = 13191, et.Gacute = 500, et.Gamma = 915, et.Gammaafrican = 404, et.Gangiacoptic = 1002, et.Gbreve = 286, et.Gcaron = 486, et.Gcedilla = 290, et.Gcircle = 9404, et.Gcircumflex = 284, et.Gcommaaccent = 290, et.Gdot = 288, et.Gdotaccent = 288, et.Gecyrillic = 1043, et.Ghadarmenian = 1346, et.Ghemiddlehookcyrillic = 1172, et.Ghestrokecyrillic = 1170, et.Gheupturncyrillic = 1168, et.Ghook = 403, et.Gimarmenian = 1331, et.Gjecyrillic = 1027, et.Gmacron = 7712, et.Gmonospace = 65319, et.Grave = 63182, et.Gravesmall = 63328, et.Gsmall = 63335, et.Gsmallhook = 667, et.Gstroke = 484, et.H = 72, et.H18533 = 9679, et.H18543 = 9642, et.H18551 = 9643, et.H22073 = 9633, et.HPsquare = 13259, et.Haabkhasiancyrillic = 1192, et.Hadescendercyrillic = 1202, et.Hardsigncyrillic = 1066, et.Hbar = 294, et.Hbrevebelow = 7722, et.Hcedilla = 7720, et.Hcircle = 9405, et.Hcircumflex = 292, et.Hdieresis = 7718, et.Hdotaccent = 7714, et.Hdotbelow = 7716, et.Hmonospace = 65320, et.Hoarmenian = 1344, et.Horicoptic = 1e3, et.Hsmall = 63336, et.Hungarumlaut = 63183, et.Hungarumlautsmall = 63224, et.Hzsquare = 13200, et.I = 73, et.IAcyrillic = 1071, et.IJ = 306, et.IUcyrillic = 1070, et.Iacute = 205, et.Iacutesmall = 63469, et.Ibreve = 300, et.Icaron = 463, et.Icircle = 9406, et.Icircumflex = 206, et.Icircumflexsmall = 63470, et.Icyrillic = 1030, et.Idblgrave = 520, et.Idieresis = 207, et.Idieresisacute = 7726, et.Idieresiscyrillic = 1252, et.Idieresissmall = 63471, et.Idot = 304, et.Idotaccent = 304, et.Idotbelow = 7882, et.Iebrevecyrillic = 1238, et.Iecyrillic = 1045, et.Ifraktur = 8465, et.Igrave = 204, et.Igravesmall = 63468, et.Ihookabove = 7880, et.Iicyrillic = 1048, et.Iinvertedbreve = 522, et.Iishortcyrillic = 1049, et.Imacron = 298, et.Imacroncyrillic = 1250, et.Imonospace = 65321, et.Iniarmenian = 1339, et.Iocyrillic = 1025, et.Iogonek = 302, et.Iota = 921, et.Iotaafrican = 406, et.Iotadieresis = 938, et.Iotatonos = 906, et.Ismall = 63337, et.Istroke = 407, et.Itilde = 296, et.Itildebelow = 7724, et.Izhitsacyrillic = 1140, et.Izhitsadblgravecyrillic = 1142, et.J = 74, et.Jaarmenian = 1345, et.Jcircle = 9407, et.Jcircumflex = 308, et.Jecyrillic = 1032, et.Jheharmenian = 1355, et.Jmonospace = 65322, et.Jsmall = 63338, et.K = 75, et.KBsquare = 13189, et.KKsquare = 13261, et.Kabashkircyrillic = 1184, et.Kacute = 7728, et.Kacyrillic = 1050, et.Kadescendercyrillic = 1178, et.Kahookcyrillic = 1219, et.Kappa = 922, et.Kastrokecyrillic = 1182, et.Kaverticalstrokecyrillic = 1180, et.Kcaron = 488, et.Kcedilla = 310, et.Kcircle = 9408, et.Kcommaaccent = 310, et.Kdotbelow = 7730, et.Keharmenian = 1364, et.Kenarmenian = 1343, et.Khacyrillic = 1061, et.Kheicoptic = 998, et.Khook = 408, et.Kjecyrillic = 1036, et.Klinebelow = 7732, et.Kmonospace = 65323, et.Koppacyrillic = 1152, et.Koppagreek = 990, et.Ksicyrillic = 1134, et.Ksmall = 63339, et.L = 76, et.LJ = 455, et.LL = 63167, et.Lacute = 313, et.Lambda = 923, et.Lcaron = 317, et.Lcedilla = 315, et.Lcircle = 9409, et.Lcircumflexbelow = 7740, et.Lcommaaccent = 315, et.Ldot = 319, et.Ldotaccent = 319, et.Ldotbelow = 7734, et.Ldotbelowmacron = 7736, et.Liwnarmenian = 1340, et.Lj = 456, et.Ljecyrillic = 1033, et.Llinebelow = 7738, et.Lmonospace = 65324, et.Lslash = 321, et.Lslashsmall = 63225, et.Lsmall = 63340, et.M = 77, et.MBsquare = 13190, et.Macron = 63184, et.Macronsmall = 63407, et.Macute = 7742, et.Mcircle = 9410, et.Mdotaccent = 7744, et.Mdotbelow = 7746, et.Menarmenian = 1348, et.Mmonospace = 65325, et.Msmall = 63341, et.Mturned = 412, et.Mu = 924, et.N = 78, et.NJ = 458, et.Nacute = 323, et.Ncaron = 327, et.Ncedilla = 325, et.Ncircle = 9411, et.Ncircumflexbelow = 7754, et.Ncommaaccent = 325, et.Ndotaccent = 7748, et.Ndotbelow = 7750, et.Nhookleft = 413, et.Nineroman = 8552, et.Nj = 459, et.Njecyrillic = 1034, et.Nlinebelow = 7752, et.Nmonospace = 65326, et.Nowarmenian = 1350, et.Nsmall = 63342, et.Ntilde = 209, et.Ntildesmall = 63473, et.Nu = 925, et.O = 79, et.OE = 338, et.OEsmall = 63226, et.Oacute = 211, et.Oacutesmall = 63475, et.Obarredcyrillic = 1256, et.Obarreddieresiscyrillic = 1258, et.Obreve = 334, et.Ocaron = 465, et.Ocenteredtilde = 415, et.Ocircle = 9412, et.Ocircumflex = 212, et.Ocircumflexacute = 7888, et.Ocircumflexdotbelow = 7896, et.Ocircumflexgrave = 7890, et.Ocircumflexhookabove = 7892, et.Ocircumflexsmall = 63476, et.Ocircumflextilde = 7894, et.Ocyrillic = 1054, et.Odblacute = 336, et.Odblgrave = 524, et.Odieresis = 214, et.Odieresiscyrillic = 1254, et.Odieresissmall = 63478, et.Odotbelow = 7884, et.Ogoneksmall = 63227, et.Ograve = 210, et.Ogravesmall = 63474, et.Oharmenian = 1365, et.Ohm = 8486, et.Ohookabove = 7886, et.Ohorn = 416, et.Ohornacute = 7898, et.Ohorndotbelow = 7906, et.Ohorngrave = 7900, et.Ohornhookabove = 7902, et.Ohorntilde = 7904, et.Ohungarumlaut = 336, et.Oi = 418, et.Oinvertedbreve = 526, et.Omacron = 332, et.Omacronacute = 7762, et.Omacrongrave = 7760, et.Omega = 8486, et.Omegacyrillic = 1120, et.Omegagreek = 937, et.Omegaroundcyrillic = 1146, et.Omegatitlocyrillic = 1148, et.Omegatonos = 911, et.Omicron = 927, et.Omicrontonos = 908, et.Omonospace = 65327, et.Oneroman = 8544, et.Oogonek = 490, et.Oogonekmacron = 492, et.Oopen = 390, et.Oslash = 216, et.Oslashacute = 510, et.Oslashsmall = 63480, et.Osmall = 63343, et.Ostrokeacute = 510, et.Otcyrillic = 1150, et.Otilde = 213, et.Otildeacute = 7756, et.Otildedieresis = 7758, et.Otildesmall = 63477, et.P = 80, et.Pacute = 7764, et.Pcircle = 9413, et.Pdotaccent = 7766, et.Pecyrillic = 1055, et.Peharmenian = 1354, et.Pemiddlehookcyrillic = 1190, et.Phi = 934, et.Phook = 420, et.Pi = 928, et.Piwrarmenian = 1363, et.Pmonospace = 65328, et.Psi = 936, et.Psicyrillic = 1136, et.Psmall = 63344, et.Q = 81, et.Qcircle = 9414, et.Qmonospace = 65329, et.Qsmall = 63345, et.R = 82, et.Raarmenian = 1356, et.Racute = 340, et.Rcaron = 344, et.Rcedilla = 342, et.Rcircle = 9415, et.Rcommaaccent = 342, et.Rdblgrave = 528, et.Rdotaccent = 7768, et.Rdotbelow = 7770, et.Rdotbelowmacron = 7772, et.Reharmenian = 1360, et.Rfraktur = 8476, et.Rho = 929, et.Ringsmall = 63228, et.Rinvertedbreve = 530, et.Rlinebelow = 7774, et.Rmonospace = 65330, et.Rsmall = 63346, et.Rsmallinverted = 641, et.Rsmallinvertedsuperior = 694, et.S = 83, et.SF010000 = 9484, et.SF020000 = 9492, et.SF030000 = 9488, et.SF040000 = 9496, et.SF050000 = 9532, et.SF060000 = 9516, et.SF070000 = 9524, et.SF080000 = 9500, et.SF090000 = 9508, et.SF100000 = 9472, et.SF110000 = 9474, et.SF190000 = 9569, et.SF200000 = 9570, et.SF210000 = 9558, et.SF220000 = 9557, et.SF230000 = 9571, et.SF240000 = 9553, et.SF250000 = 9559, et.SF260000 = 9565, et.SF270000 = 9564, et.SF280000 = 9563, et.SF360000 = 9566, et.SF370000 = 9567, et.SF380000 = 9562, et.SF390000 = 9556, et.SF400000 = 9577, et.SF410000 = 9574, et.SF420000 = 9568, et.SF430000 = 9552, et.SF440000 = 9580, et.SF450000 = 9575, et.SF460000 = 9576, et.SF470000 = 9572, et.SF480000 = 9573, et.SF490000 = 9561, et.SF500000 = 9560, et.SF510000 = 9554, et.SF520000 = 9555, et.SF530000 = 9579, et.SF540000 = 9578, et.Sacute = 346, et.Sacutedotaccent = 7780, et.Sampigreek = 992, et.Scaron = 352, et.Scarondotaccent = 7782, et.Scaronsmall = 63229, et.Scedilla = 350, et.Schwa = 399, et.Schwacyrillic = 1240, et.Schwadieresiscyrillic = 1242, et.Scircle = 9416, et.Scircumflex = 348, et.Scommaaccent = 536, et.Sdotaccent = 7776, et.Sdotbelow = 7778, et.Sdotbelowdotaccent = 7784, et.Seharmenian = 1357, et.Sevenroman = 8550, et.Shaarmenian = 1351, et.Shacyrillic = 1064, et.Shchacyrillic = 1065, et.Sheicoptic = 994, et.Shhacyrillic = 1210, et.Shimacoptic = 1004, et.Sigma = 931, et.Sixroman = 8549, et.Smonospace = 65331, et.Softsigncyrillic = 1068, et.Ssmall = 63347, et.Stigmagreek = 986, et.T = 84, et.Tau = 932, et.Tbar = 358, et.Tcaron = 356, et.Tcedilla = 354, et.Tcircle = 9417, et.Tcircumflexbelow = 7792, et.Tcommaaccent = 354, et.Tdotaccent = 7786, et.Tdotbelow = 7788, et.Tecyrillic = 1058, et.Tedescendercyrillic = 1196, et.Tenroman = 8553, et.Tetsecyrillic = 1204, et.Theta = 920, et.Thook = 428, et.Thorn = 222, et.Thornsmall = 63486, et.Threeroman = 8546, et.Tildesmall = 63230, et.Tiwnarmenian = 1359, et.Tlinebelow = 7790, et.Tmonospace = 65332, et.Toarmenian = 1337, et.Tonefive = 444, et.Tonesix = 388, et.Tonetwo = 423, et.Tretroflexhook = 430, et.Tsecyrillic = 1062, et.Tshecyrillic = 1035, et.Tsmall = 63348, et.Twelveroman = 8555, et.Tworoman = 8545, et.U = 85, et.Uacute = 218, et.Uacutesmall = 63482, et.Ubreve = 364, et.Ucaron = 467, et.Ucircle = 9418, et.Ucircumflex = 219, et.Ucircumflexbelow = 7798, et.Ucircumflexsmall = 63483, et.Ucyrillic = 1059, et.Udblacute = 368, et.Udblgrave = 532, et.Udieresis = 220, et.Udieresisacute = 471, et.Udieresisbelow = 7794, et.Udieresiscaron = 473, et.Udieresiscyrillic = 1264, et.Udieresisgrave = 475, et.Udieresismacron = 469, et.Udieresissmall = 63484, et.Udotbelow = 7908, et.Ugrave = 217, et.Ugravesmall = 63481, et.Uhookabove = 7910, et.Uhorn = 431, et.Uhornacute = 7912, et.Uhorndotbelow = 7920, et.Uhorngrave = 7914, et.Uhornhookabove = 7916, et.Uhorntilde = 7918, et.Uhungarumlaut = 368, et.Uhungarumlautcyrillic = 1266, et.Uinvertedbreve = 534, et.Ukcyrillic = 1144, et.Umacron = 362, et.Umacroncyrillic = 1262, et.Umacrondieresis = 7802, et.Umonospace = 65333, et.Uogonek = 370, et.Upsilon = 933, et.Upsilon1 = 978, et.Upsilonacutehooksymbolgreek = 979, et.Upsilonafrican = 433, et.Upsilondieresis = 939, et.Upsilondieresishooksymbolgreek = 980, et.Upsilonhooksymbol = 978, et.Upsilontonos = 910, et.Uring = 366, et.Ushortcyrillic = 1038, et.Usmall = 63349, et.Ustraightcyrillic = 1198, et.Ustraightstrokecyrillic = 1200, et.Utilde = 360, et.Utildeacute = 7800, et.Utildebelow = 7796, et.V = 86, et.Vcircle = 9419, et.Vdotbelow = 7806, et.Vecyrillic = 1042, et.Vewarmenian = 1358, et.Vhook = 434, et.Vmonospace = 65334, et.Voarmenian = 1352, et.Vsmall = 63350, et.Vtilde = 7804, et.W = 87, et.Wacute = 7810, et.Wcircle = 9420, et.Wcircumflex = 372, et.Wdieresis = 7812, et.Wdotaccent = 7814, et.Wdotbelow = 7816, et.Wgrave = 7808, et.Wmonospace = 65335, et.Wsmall = 63351, et.X = 88, et.Xcircle = 9421, et.Xdieresis = 7820, et.Xdotaccent = 7818, et.Xeharmenian = 1341, et.Xi = 926, et.Xmonospace = 65336, et.Xsmall = 63352, et.Y = 89, et.Yacute = 221, et.Yacutesmall = 63485, et.Yatcyrillic = 1122, et.Ycircle = 9422, et.Ycircumflex = 374, et.Ydieresis = 376, et.Ydieresissmall = 63487, et.Ydotaccent = 7822, et.Ydotbelow = 7924, et.Yericyrillic = 1067, et.Yerudieresiscyrillic = 1272, et.Ygrave = 7922, et.Yhook = 435, et.Yhookabove = 7926, et.Yiarmenian = 1349, et.Yicyrillic = 1031, et.Yiwnarmenian = 1362, et.Ymonospace = 65337, et.Ysmall = 63353, et.Ytilde = 7928, et.Yusbigcyrillic = 1130, et.Yusbigiotifiedcyrillic = 1132, et.Yuslittlecyrillic = 1126, et.Yuslittleiotifiedcyrillic = 1128, et.Z = 90, et.Zaarmenian = 1334, et.Zacute = 377, et.Zcaron = 381, et.Zcaronsmall = 63231, et.Zcircle = 9423, et.Zcircumflex = 7824, et.Zdot = 379, et.Zdotaccent = 379, et.Zdotbelow = 7826, et.Zecyrillic = 1047, et.Zedescendercyrillic = 1176, et.Zedieresiscyrillic = 1246, et.Zeta = 918, et.Zhearmenian = 1338, et.Zhebrevecyrillic = 1217, et.Zhecyrillic = 1046, et.Zhedescendercyrillic = 1174, et.Zhedieresiscyrillic = 1244, et.Zlinebelow = 7828, et.Zmonospace = 65338, et.Zsmall = 63354, et.Zstroke = 437, et.a = 97, et.aabengali = 2438, et.aacute = 225, et.aadeva = 2310, et.aagujarati = 2694, et.aagurmukhi = 2566, et.aamatragurmukhi = 2622, et.aarusquare = 13059, et.aavowelsignbengali = 2494, et.aavowelsigndeva = 2366, et.aavowelsigngujarati = 2750, et.abbreviationmarkarmenian = 1375, et.abbreviationsigndeva = 2416, et.abengali = 2437, et.abopomofo = 12570, et.abreve = 259, et.abreveacute = 7855, et.abrevecyrillic = 1233, et.abrevedotbelow = 7863, et.abrevegrave = 7857, et.abrevehookabove = 7859, et.abrevetilde = 7861, et.acaron = 462, et.acircle = 9424, et.acircumflex = 226, et.acircumflexacute = 7845, et.acircumflexdotbelow = 7853, et.acircumflexgrave = 7847, et.acircumflexhookabove = 7849, et.acircumflextilde = 7851, et.acute = 180, et.acutebelowcmb = 791, et.acutecmb = 769, et.acutecomb = 769, et.acutedeva = 2388, et.acutelowmod = 719, et.acutetonecmb = 833, et.acyrillic = 1072, et.adblgrave = 513, et.addakgurmukhi = 2673, et.adeva = 2309, et.adieresis = 228, et.adieresiscyrillic = 1235, et.adieresismacron = 479, et.adotbelow = 7841, et.adotmacron = 481, et.ae = 230, et.aeacute = 509, et.aekorean = 12624, et.aemacron = 483, et.afii00208 = 8213, et.afii08941 = 8356, et.afii10017 = 1040, et.afii10018 = 1041, et.afii10019 = 1042, et.afii10020 = 1043, et.afii10021 = 1044, et.afii10022 = 1045, et.afii10023 = 1025, et.afii10024 = 1046, et.afii10025 = 1047, et.afii10026 = 1048, et.afii10027 = 1049, et.afii10028 = 1050, et.afii10029 = 1051, et.afii10030 = 1052, et.afii10031 = 1053, et.afii10032 = 1054, et.afii10033 = 1055, et.afii10034 = 1056, et.afii10035 = 1057, et.afii10036 = 1058, et.afii10037 = 1059, et.afii10038 = 1060, et.afii10039 = 1061, et.afii10040 = 1062, et.afii10041 = 1063, et.afii10042 = 1064, et.afii10043 = 1065, et.afii10044 = 1066, et.afii10045 = 1067, et.afii10046 = 1068, et.afii10047 = 1069, et.afii10048 = 1070, et.afii10049 = 1071, et.afii10050 = 1168, et.afii10051 = 1026, et.afii10052 = 1027, et.afii10053 = 1028, et.afii10054 = 1029, et.afii10055 = 1030, et.afii10056 = 1031, et.afii10057 = 1032, et.afii10058 = 1033, et.afii10059 = 1034, et.afii10060 = 1035, et.afii10061 = 1036, et.afii10062 = 1038, et.afii10063 = 63172, et.afii10064 = 63173, et.afii10065 = 1072, et.afii10066 = 1073, et.afii10067 = 1074, et.afii10068 = 1075, et.afii10069 = 1076, et.afii10070 = 1077, et.afii10071 = 1105, et.afii10072 = 1078, et.afii10073 = 1079, et.afii10074 = 1080, et.afii10075 = 1081, et.afii10076 = 1082, et.afii10077 = 1083, et.afii10078 = 1084, et.afii10079 = 1085, et.afii10080 = 1086, et.afii10081 = 1087, et.afii10082 = 1088, et.afii10083 = 1089, et.afii10084 = 1090, et.afii10085 = 1091, et.afii10086 = 1092, et.afii10087 = 1093, et.afii10088 = 1094, et.afii10089 = 1095, et.afii10090 = 1096, et.afii10091 = 1097, et.afii10092 = 1098, et.afii10093 = 1099, et.afii10094 = 1100, et.afii10095 = 1101, et.afii10096 = 1102, et.afii10097 = 1103, et.afii10098 = 1169, et.afii10099 = 1106, et.afii10100 = 1107, et.afii10101 = 1108, et.afii10102 = 1109, et.afii10103 = 1110, et.afii10104 = 1111, et.afii10105 = 1112, et.afii10106 = 1113, et.afii10107 = 1114, et.afii10108 = 1115, et.afii10109 = 1116, et.afii10110 = 1118, et.afii10145 = 1039, et.afii10146 = 1122, et.afii10147 = 1138, et.afii10148 = 1140, et.afii10192 = 63174, et.afii10193 = 1119, et.afii10194 = 1123, et.afii10195 = 1139, et.afii10196 = 1141, et.afii10831 = 63175, et.afii10832 = 63176, et.afii10846 = 1241, et.afii299 = 8206, et.afii300 = 8207, et.afii301 = 8205, et.afii57381 = 1642, et.afii57388 = 1548, et.afii57392 = 1632, et.afii57393 = 1633, et.afii57394 = 1634, et.afii57395 = 1635, et.afii57396 = 1636, et.afii57397 = 1637, et.afii57398 = 1638, et.afii57399 = 1639, et.afii57400 = 1640, et.afii57401 = 1641, et.afii57403 = 1563, et.afii57407 = 1567, et.afii57409 = 1569, et.afii57410 = 1570, et.afii57411 = 1571, et.afii57412 = 1572, et.afii57413 = 1573, et.afii57414 = 1574, et.afii57415 = 1575, et.afii57416 = 1576, et.afii57417 = 1577, et.afii57418 = 1578, et.afii57419 = 1579, et.afii57420 = 1580, et.afii57421 = 1581, et.afii57422 = 1582, et.afii57423 = 1583, et.afii57424 = 1584, et.afii57425 = 1585, et.afii57426 = 1586, et.afii57427 = 1587, et.afii57428 = 1588, et.afii57429 = 1589, et.afii57430 = 1590, et.afii57431 = 1591, et.afii57432 = 1592, et.afii57433 = 1593, et.afii57434 = 1594, et.afii57440 = 1600, et.afii57441 = 1601, et.afii57442 = 1602, et.afii57443 = 1603, et.afii57444 = 1604, et.afii57445 = 1605, et.afii57446 = 1606, et.afii57448 = 1608, et.afii57449 = 1609, et.afii57450 = 1610, et.afii57451 = 1611, et.afii57452 = 1612, et.afii57453 = 1613, et.afii57454 = 1614, et.afii57455 = 1615, et.afii57456 = 1616, et.afii57457 = 1617, et.afii57458 = 1618, et.afii57470 = 1607, et.afii57505 = 1700, et.afii57506 = 1662, et.afii57507 = 1670, et.afii57508 = 1688, et.afii57509 = 1711, et.afii57511 = 1657, et.afii57512 = 1672, et.afii57513 = 1681, et.afii57514 = 1722, et.afii57519 = 1746, et.afii57534 = 1749, et.afii57636 = 8362, et.afii57645 = 1470, et.afii57658 = 1475, et.afii57664 = 1488, et.afii57665 = 1489, et.afii57666 = 1490, et.afii57667 = 1491, et.afii57668 = 1492, et.afii57669 = 1493, et.afii57670 = 1494, et.afii57671 = 1495, et.afii57672 = 1496, et.afii57673 = 1497, et.afii57674 = 1498, et.afii57675 = 1499, et.afii57676 = 1500, et.afii57677 = 1501, et.afii57678 = 1502, et.afii57679 = 1503, et.afii57680 = 1504, et.afii57681 = 1505, et.afii57682 = 1506, et.afii57683 = 1507, et.afii57684 = 1508, et.afii57685 = 1509, et.afii57686 = 1510, et.afii57687 = 1511, et.afii57688 = 1512, et.afii57689 = 1513, et.afii57690 = 1514, et.afii57694 = 64298, et.afii57695 = 64299, et.afii57700 = 64331, et.afii57705 = 64287, et.afii57716 = 1520, et.afii57717 = 1521, et.afii57718 = 1522, et.afii57723 = 64309, et.afii57793 = 1460, et.afii57794 = 1461, et.afii57795 = 1462, et.afii57796 = 1467, et.afii57797 = 1464, et.afii57798 = 1463, et.afii57799 = 1456, et.afii57800 = 1458, et.afii57801 = 1457, et.afii57802 = 1459, et.afii57803 = 1474, et.afii57804 = 1473, et.afii57806 = 1465, et.afii57807 = 1468, et.afii57839 = 1469, et.afii57841 = 1471, et.afii57842 = 1472, et.afii57929 = 700, et.afii61248 = 8453, et.afii61289 = 8467, et.afii61352 = 8470, et.afii61573 = 8236, et.afii61574 = 8237, et.afii61575 = 8238, et.afii61664 = 8204, et.afii63167 = 1645, et.afii64937 = 701, et.agrave = 224, et.agujarati = 2693, et.agurmukhi = 2565, et.ahiragana = 12354, et.ahookabove = 7843, et.aibengali = 2448, et.aibopomofo = 12574, et.aideva = 2320, et.aiecyrillic = 1237, et.aigujarati = 2704, et.aigurmukhi = 2576, et.aimatragurmukhi = 2632, et.ainarabic = 1593, et.ainfinalarabic = 65226, et.aininitialarabic = 65227, et.ainmedialarabic = 65228, et.ainvertedbreve = 515, et.aivowelsignbengali = 2504, et.aivowelsigndeva = 2376, et.aivowelsigngujarati = 2760, et.akatakana = 12450, et.akatakanahalfwidth = 65393, et.akorean = 12623, et.alef = 1488, et.alefarabic = 1575, et.alefdageshhebrew = 64304, et.aleffinalarabic = 65166, et.alefhamzaabovearabic = 1571, et.alefhamzaabovefinalarabic = 65156, et.alefhamzabelowarabic = 1573, et.alefhamzabelowfinalarabic = 65160, et.alefhebrew = 1488, et.aleflamedhebrew = 64335, et.alefmaddaabovearabic = 1570, et.alefmaddaabovefinalarabic = 65154, et.alefmaksuraarabic = 1609, et.alefmaksurafinalarabic = 65264, et.alefmaksurainitialarabic = 65267, et.alefmaksuramedialarabic = 65268, et.alefpatahhebrew = 64302, et.alefqamatshebrew = 64303, et.aleph = 8501, et.allequal = 8780, et.alpha = 945, et.alphatonos = 940, et.amacron = 257, et.amonospace = 65345, et.ampersand = 38, et.ampersandmonospace = 65286, et.ampersandsmall = 63270, et.amsquare = 13250, et.anbopomofo = 12578, et.angbopomofo = 12580, et.angbracketleft = 12296, et.angbracketright = 12297, et.angkhankhuthai = 3674, et.angle = 8736, et.anglebracketleft = 12296, et.anglebracketleftvertical = 65087, et.anglebracketright = 12297, et.anglebracketrightvertical = 65088, et.angleleft = 9001, et.angleright = 9002, et.angstrom = 8491, et.anoteleia = 903, et.anudattadeva = 2386, et.anusvarabengali = 2434, et.anusvaradeva = 2306, et.anusvaragujarati = 2690, et.aogonek = 261, et.apaatosquare = 13056, et.aparen = 9372, et.apostrophearmenian = 1370, et.apostrophemod = 700, et.apple = 63743, et.approaches = 8784, et.approxequal = 8776, et.approxequalorimage = 8786, et.approximatelyequal = 8773, et.araeaekorean = 12686, et.araeakorean = 12685, et.arc = 8978, et.arighthalfring = 7834, et.aring = 229, et.aringacute = 507, et.aringbelow = 7681, et.arrowboth = 8596, et.arrowdashdown = 8675, et.arrowdashleft = 8672, et.arrowdashright = 8674, et.arrowdashup = 8673, et.arrowdblboth = 8660, et.arrowdbldown = 8659, et.arrowdblleft = 8656, et.arrowdblright = 8658, et.arrowdblup = 8657, et.arrowdown = 8595, et.arrowdownleft = 8601, et.arrowdownright = 8600, et.arrowdownwhite = 8681, et.arrowheaddownmod = 709, et.arrowheadleftmod = 706, et.arrowheadrightmod = 707, et.arrowheadupmod = 708, et.arrowhorizex = 63719, et.arrowleft = 8592, et.arrowleftdbl = 8656, et.arrowleftdblstroke = 8653, et.arrowleftoverright = 8646, et.arrowleftwhite = 8678, et.arrowright = 8594, et.arrowrightdblstroke = 8655, et.arrowrightheavy = 10142, et.arrowrightoverleft = 8644, et.arrowrightwhite = 8680, et.arrowtableft = 8676, et.arrowtabright = 8677, et.arrowup = 8593, et.arrowupdn = 8597, et.arrowupdnbse = 8616, et.arrowupdownbase = 8616, et.arrowupleft = 8598, et.arrowupleftofdown = 8645, et.arrowupright = 8599, et.arrowupwhite = 8679, et.arrowvertex = 63718, et.asciicircum = 94, et.asciicircummonospace = 65342, et.asciitilde = 126, et.asciitildemonospace = 65374, et.ascript = 593, et.ascriptturned = 594, et.asmallhiragana = 12353, et.asmallkatakana = 12449, et.asmallkatakanahalfwidth = 65383, et.asterisk = 42, et.asteriskaltonearabic = 1645, et.asteriskarabic = 1645, et.asteriskmath = 8727, et.asteriskmonospace = 65290, et.asterisksmall = 65121, et.asterism = 8258, et.asuperior = 63209, et.asymptoticallyequal = 8771, et.at = 64, et.atilde = 227, et.atmonospace = 65312, et.atsmall = 65131, et.aturned = 592, et.aubengali = 2452, et.aubopomofo = 12576, et.audeva = 2324, et.augujarati = 2708, et.augurmukhi = 2580, et.aulengthmarkbengali = 2519, et.aumatragurmukhi = 2636, et.auvowelsignbengali = 2508, et.auvowelsigndeva = 2380, et.auvowelsigngujarati = 2764, et.avagrahadeva = 2365, et.aybarmenian = 1377, et.ayin = 1506, et.ayinaltonehebrew = 64288, et.ayinhebrew = 1506, et.b = 98, et.babengali = 2476, et.backslash = 92, et.backslashmonospace = 65340, et.badeva = 2348, et.bagujarati = 2732, et.bagurmukhi = 2604, et.bahiragana = 12400, et.bahtthai = 3647, et.bakatakana = 12496, et.bar = 124, et.barmonospace = 65372, et.bbopomofo = 12549, et.bcircle = 9425, et.bdotaccent = 7683, et.bdotbelow = 7685, et.beamedsixteenthnotes = 9836, et.because = 8757, et.becyrillic = 1073, et.beharabic = 1576, et.behfinalarabic = 65168, et.behinitialarabic = 65169, et.behiragana = 12409, et.behmedialarabic = 65170, et.behmeeminitialarabic = 64671, et.behmeemisolatedarabic = 64520, et.behnoonfinalarabic = 64621, et.bekatakana = 12505, et.benarmenian = 1378, et.bet = 1489, et.beta = 946, et.betasymbolgreek = 976, et.betdagesh = 64305, et.betdageshhebrew = 64305, et.bethebrew = 1489, et.betrafehebrew = 64332, et.bhabengali = 2477, et.bhadeva = 2349, et.bhagujarati = 2733, et.bhagurmukhi = 2605, et.bhook = 595, et.bihiragana = 12403, et.bikatakana = 12499, et.bilabialclick = 664, et.bindigurmukhi = 2562, et.birusquare = 13105, et.blackcircle = 9679, et.blackdiamond = 9670, et.blackdownpointingtriangle = 9660, et.blackleftpointingpointer = 9668, et.blackleftpointingtriangle = 9664, et.blacklenticularbracketleft = 12304, et.blacklenticularbracketleftvertical = 65083, et.blacklenticularbracketright = 12305, et.blacklenticularbracketrightvertical = 65084, et.blacklowerlefttriangle = 9699, et.blacklowerrighttriangle = 9698, et.blackrectangle = 9644, et.blackrightpointingpointer = 9658, et.blackrightpointingtriangle = 9654, et.blacksmallsquare = 9642, et.blacksmilingface = 9787, et.blacksquare = 9632, et.blackstar = 9733, et.blackupperlefttriangle = 9700, et.blackupperrighttriangle = 9701, et.blackuppointingsmalltriangle = 9652, et.blackuppointingtriangle = 9650, et.blank = 9251, et.blinebelow = 7687, et.block = 9608, et.bmonospace = 65346, et.bobaimaithai = 3610, et.bohiragana = 12412, et.bokatakana = 12508, et.bparen = 9373, et.bqsquare = 13251, et.braceex = 63732, et.braceleft = 123, et.braceleftbt = 63731, et.braceleftmid = 63730, et.braceleftmonospace = 65371, et.braceleftsmall = 65115, et.bracelefttp = 63729, et.braceleftvertical = 65079, et.braceright = 125, et.bracerightbt = 63742, et.bracerightmid = 63741, et.bracerightmonospace = 65373, et.bracerightsmall = 65116, et.bracerighttp = 63740, et.bracerightvertical = 65080, et.bracketleft = 91, et.bracketleftbt = 63728, et.bracketleftex = 63727, et.bracketleftmonospace = 65339, et.bracketlefttp = 63726, et.bracketright = 93, et.bracketrightbt = 63739, et.bracketrightex = 63738, et.bracketrightmonospace = 65341, et.bracketrighttp = 63737, et.breve = 728, et.brevebelowcmb = 814, et.brevecmb = 774, et.breveinvertedbelowcmb = 815, et.breveinvertedcmb = 785, et.breveinverteddoublecmb = 865, et.bridgebelowcmb = 810, et.bridgeinvertedbelowcmb = 826, et.brokenbar = 166, et.bstroke = 384, et.bsuperior = 63210, et.btopbar = 387, et.buhiragana = 12406, et.bukatakana = 12502, et.bullet = 8226, et.bulletinverse = 9688, et.bulletoperator = 8729, et.bullseye = 9678, et.c = 99, et.caarmenian = 1390, et.cabengali = 2458, et.cacute = 263, et.cadeva = 2330, et.cagujarati = 2714, et.cagurmukhi = 2586, et.calsquare = 13192, et.candrabindubengali = 2433, et.candrabinducmb = 784, et.candrabindudeva = 2305, et.candrabindugujarati = 2689, et.capslock = 8682, et.careof = 8453, et.caron = 711, et.caronbelowcmb = 812, et.caroncmb = 780, et.carriagereturn = 8629, et.cbopomofo = 12568, et.ccaron = 269, et.ccedilla = 231, et.ccedillaacute = 7689, et.ccircle = 9426, et.ccircumflex = 265, et.ccurl = 597, et.cdot = 267, et.cdotaccent = 267, et.cdsquare = 13253, et.cedilla = 184, et.cedillacmb = 807, et.cent = 162, et.centigrade = 8451, et.centinferior = 63199, et.centmonospace = 65504, et.centoldstyle = 63394, et.centsuperior = 63200, et.chaarmenian = 1401, et.chabengali = 2459, et.chadeva = 2331, et.chagujarati = 2715, et.chagurmukhi = 2587, et.chbopomofo = 12564, et.cheabkhasiancyrillic = 1213, et.checkmark = 10003, et.checyrillic = 1095, et.chedescenderabkhasiancyrillic = 1215, et.chedescendercyrillic = 1207, et.chedieresiscyrillic = 1269, et.cheharmenian = 1395, et.chekhakassiancyrillic = 1228, et.cheverticalstrokecyrillic = 1209, et.chi = 967, et.chieuchacirclekorean = 12919, et.chieuchaparenkorean = 12823, et.chieuchcirclekorean = 12905, et.chieuchkorean = 12618, et.chieuchparenkorean = 12809, et.chochangthai = 3594, et.chochanthai = 3592, et.chochingthai = 3593, et.chochoethai = 3596, et.chook = 392, et.cieucacirclekorean = 12918, et.cieucaparenkorean = 12822, et.cieuccirclekorean = 12904, et.cieuckorean = 12616, et.cieucparenkorean = 12808, et.cieucuparenkorean = 12828, et.circle = 9675, et.circlecopyrt = 169, et.circlemultiply = 8855, et.circleot = 8857, et.circleplus = 8853, et.circlepostalmark = 12342, et.circlewithlefthalfblack = 9680, et.circlewithrighthalfblack = 9681, et.circumflex = 710, et.circumflexbelowcmb = 813, et.circumflexcmb = 770, et.clear = 8999, et.clickalveolar = 450, et.clickdental = 448, et.clicklateral = 449, et.clickretroflex = 451, et.club = 9827, et.clubsuitblack = 9827, et.clubsuitwhite = 9831, et.cmcubedsquare = 13220, et.cmonospace = 65347, et.cmsquaredsquare = 13216, et.coarmenian = 1409, et.colon = 58, et.colonmonetary = 8353, et.colonmonospace = 65306, et.colonsign = 8353, et.colonsmall = 65109, et.colontriangularhalfmod = 721, et.colontriangularmod = 720, et.comma = 44, et.commaabovecmb = 787, et.commaaboverightcmb = 789, et.commaaccent = 63171, et.commaarabic = 1548, et.commaarmenian = 1373, et.commainferior = 63201, et.commamonospace = 65292, et.commareversedabovecmb = 788, et.commareversedmod = 701, et.commasmall = 65104, et.commasuperior = 63202, et.commaturnedabovecmb = 786, et.commaturnedmod = 699, et.compass = 9788, et.congruent = 8773, et.contourintegral = 8750, et.control = 8963, et.controlACK = 6, et.controlBEL = 7, et.controlBS = 8, et.controlCAN = 24, et.controlCR = 13, et.controlDC1 = 17, et.controlDC2 = 18, et.controlDC3 = 19, et.controlDC4 = 20, et.controlDEL = 127, et.controlDLE = 16, et.controlEM = 25, et.controlENQ = 5, et.controlEOT = 4, et.controlESC = 27, et.controlETB = 23, et.controlETX = 3, et.controlFF = 12, et.controlFS = 28, et.controlGS = 29, et.controlHT = 9, et.controlLF = 10, et.controlNAK = 21, et.controlNULL = 0, et.controlRS = 30, et.controlSI = 15, et.controlSO = 14, et.controlSOT = 2, et.controlSTX = 1, et.controlSUB = 26, et.controlSYN = 22, et.controlUS = 31, et.controlVT = 11, et.copyright = 169, et.copyrightsans = 63721, et.copyrightserif = 63193, et.cornerbracketleft = 12300, et.cornerbracketlefthalfwidth = 65378, et.cornerbracketleftvertical = 65089, et.cornerbracketright = 12301, et.cornerbracketrighthalfwidth = 65379, et.cornerbracketrightvertical = 65090, et.corporationsquare = 13183, et.cosquare = 13255, et.coverkgsquare = 13254, et.cparen = 9374, et.cruzeiro = 8354, et.cstretched = 663, et.curlyand = 8911, et.curlyor = 8910, et.currency = 164, et.cyrBreve = 63185, et.cyrFlex = 63186, et.cyrbreve = 63188, et.cyrflex = 63189, et.d = 100, et.daarmenian = 1380, et.dabengali = 2470, et.dadarabic = 1590, et.dadeva = 2342, et.dadfinalarabic = 65214, et.dadinitialarabic = 65215, et.dadmedialarabic = 65216, et.dagesh = 1468, et.dageshhebrew = 1468, et.dagger = 8224, et.daggerdbl = 8225, et.dagujarati = 2726, et.dagurmukhi = 2598, et.dahiragana = 12384, et.dakatakana = 12480, et.dalarabic = 1583, et.dalet = 1491, et.daletdagesh = 64307, et.daletdageshhebrew = 64307, et.dalethebrew = 1491, et.dalfinalarabic = 65194, et.dammaarabic = 1615, et.dammalowarabic = 1615, et.dammatanaltonearabic = 1612, et.dammatanarabic = 1612, et.danda = 2404, et.dargahebrew = 1447, et.dargalefthebrew = 1447, et.dasiapneumatacyrilliccmb = 1157, et.dblGrave = 63187, et.dblanglebracketleft = 12298, et.dblanglebracketleftvertical = 65085, et.dblanglebracketright = 12299, et.dblanglebracketrightvertical = 65086, et.dblarchinvertedbelowcmb = 811, et.dblarrowleft = 8660, et.dblarrowright = 8658, et.dbldanda = 2405, et.dblgrave = 63190, et.dblgravecmb = 783, et.dblintegral = 8748, et.dbllowline = 8215, et.dbllowlinecmb = 819, et.dbloverlinecmb = 831, et.dblprimemod = 698, et.dblverticalbar = 8214, et.dblverticallineabovecmb = 782, et.dbopomofo = 12553, et.dbsquare = 13256, et.dcaron = 271, et.dcedilla = 7697, et.dcircle = 9427, et.dcircumflexbelow = 7699, et.dcroat = 273, et.ddabengali = 2465, et.ddadeva = 2337, et.ddagujarati = 2721, et.ddagurmukhi = 2593, et.ddalarabic = 1672, et.ddalfinalarabic = 64393, et.dddhadeva = 2396, et.ddhabengali = 2466, et.ddhadeva = 2338, et.ddhagujarati = 2722, et.ddhagurmukhi = 2594, et.ddotaccent = 7691, et.ddotbelow = 7693, et.decimalseparatorarabic = 1643, et.decimalseparatorpersian = 1643, et.decyrillic = 1076, et.degree = 176, et.dehihebrew = 1453, et.dehiragana = 12391, et.deicoptic = 1007, et.dekatakana = 12487, et.deleteleft = 9003, et.deleteright = 8998, et.delta = 948, et.deltaturned = 397, et.denominatorminusonenumeratorbengali = 2552, et.dezh = 676, et.dhabengali = 2471, et.dhadeva = 2343, et.dhagujarati = 2727, et.dhagurmukhi = 2599, et.dhook = 599, et.dialytikatonos = 901, et.dialytikatonoscmb = 836, et.diamond = 9830, et.diamondsuitwhite = 9826, et.dieresis = 168, et.dieresisacute = 63191, et.dieresisbelowcmb = 804, et.dieresiscmb = 776, et.dieresisgrave = 63192, et.dieresistonos = 901, et.dihiragana = 12386, et.dikatakana = 12482, et.dittomark = 12291, et.divide = 247, et.divides = 8739, et.divisionslash = 8725, et.djecyrillic = 1106, et.dkshade = 9619, et.dlinebelow = 7695, et.dlsquare = 13207, et.dmacron = 273, et.dmonospace = 65348, et.dnblock = 9604, et.dochadathai = 3598, et.dodekthai = 3604, et.dohiragana = 12393, et.dokatakana = 12489, et.dollar = 36, et.dollarinferior = 63203, et.dollarmonospace = 65284, et.dollaroldstyle = 63268, et.dollarsmall = 65129, et.dollarsuperior = 63204, et.dong = 8363, et.dorusquare = 13094, et.dotaccent = 729, et.dotaccentcmb = 775, et.dotbelowcmb = 803, et.dotbelowcomb = 803, et.dotkatakana = 12539, et.dotlessi = 305, et.dotlessj = 63166, et.dotlessjstrokehook = 644, et.dotmath = 8901, et.dottedcircle = 9676, et.doubleyodpatah = 64287, et.doubleyodpatahhebrew = 64287, et.downtackbelowcmb = 798, et.downtackmod = 725, et.dparen = 9375, et.dsuperior = 63211, et.dtail = 598, et.dtopbar = 396, et.duhiragana = 12389, et.dukatakana = 12485, et.dz = 499, et.dzaltone = 675, et.dzcaron = 454, et.dzcurl = 677, et.dzeabkhasiancyrillic = 1249, et.dzecyrillic = 1109, et.dzhecyrillic = 1119, et.e = 101, et.eacute = 233, et.earth = 9793, et.ebengali = 2447, et.ebopomofo = 12572, et.ebreve = 277, et.ecandradeva = 2317, et.ecandragujarati = 2701, et.ecandravowelsigndeva = 2373, et.ecandravowelsigngujarati = 2757, et.ecaron = 283, et.ecedillabreve = 7709, et.echarmenian = 1381, et.echyiwnarmenian = 1415, et.ecircle = 9428, et.ecircumflex = 234, et.ecircumflexacute = 7871, et.ecircumflexbelow = 7705, et.ecircumflexdotbelow = 7879, et.ecircumflexgrave = 7873, et.ecircumflexhookabove = 7875, et.ecircumflextilde = 7877, et.ecyrillic = 1108, et.edblgrave = 517, et.edeva = 2319, et.edieresis = 235, et.edot = 279, et.edotaccent = 279, et.edotbelow = 7865, et.eegurmukhi = 2575, et.eematragurmukhi = 2631, et.efcyrillic = 1092, et.egrave = 232, et.egujarati = 2703, et.eharmenian = 1383, et.ehbopomofo = 12573, et.ehiragana = 12360, et.ehookabove = 7867, et.eibopomofo = 12575, et.eight = 56, et.eightarabic = 1640, et.eightbengali = 2542, et.eightcircle = 9319, et.eightcircleinversesansserif = 10129, et.eightdeva = 2414, et.eighteencircle = 9329, et.eighteenparen = 9349, et.eighteenperiod = 9369, et.eightgujarati = 2798, et.eightgurmukhi = 2670, et.eighthackarabic = 1640, et.eighthangzhou = 12328, et.eighthnotebeamed = 9835, et.eightideographicparen = 12839, et.eightinferior = 8328, et.eightmonospace = 65304, et.eightoldstyle = 63288, et.eightparen = 9339, et.eightperiod = 9359, et.eightpersian = 1784, et.eightroman = 8567, et.eightsuperior = 8312, et.eightthai = 3672, et.einvertedbreve = 519, et.eiotifiedcyrillic = 1125, et.ekatakana = 12456, et.ekatakanahalfwidth = 65396, et.ekonkargurmukhi = 2676, et.ekorean = 12628, et.elcyrillic = 1083, et.element = 8712, et.elevencircle = 9322, et.elevenparen = 9342, et.elevenperiod = 9362, et.elevenroman = 8570, et.ellipsis = 8230, et.ellipsisvertical = 8942, et.emacron = 275, et.emacronacute = 7703, et.emacrongrave = 7701, et.emcyrillic = 1084, et.emdash = 8212, et.emdashvertical = 65073, et.emonospace = 65349, et.emphasismarkarmenian = 1371, et.emptyset = 8709, et.enbopomofo = 12579, et.encyrillic = 1085, et.endash = 8211, et.endashvertical = 65074, et.endescendercyrillic = 1187, et.eng = 331, et.engbopomofo = 12581, et.enghecyrillic = 1189, et.enhookcyrillic = 1224, et.enspace = 8194, et.eogonek = 281, et.eokorean = 12627, et.eopen = 603, et.eopenclosed = 666, et.eopenreversed = 604, et.eopenreversedclosed = 606, et.eopenreversedhook = 605, et.eparen = 9376, et.epsilon = 949, et.epsilontonos = 941, et.equal = 61, et.equalmonospace = 65309, et.equalsmall = 65126, et.equalsuperior = 8316, et.equivalence = 8801, et.erbopomofo = 12582, et.ercyrillic = 1088, et.ereversed = 600, et.ereversedcyrillic = 1101, et.escyrillic = 1089, et.esdescendercyrillic = 1195, et.esh = 643, et.eshcurl = 646, et.eshortdeva = 2318, et.eshortvowelsigndeva = 2374, et.eshreversedloop = 426, et.eshsquatreversed = 645, et.esmallhiragana = 12359, et.esmallkatakana = 12455, et.esmallkatakanahalfwidth = 65386, et.estimated = 8494, et.esuperior = 63212, et.eta = 951, et.etarmenian = 1384, et.etatonos = 942, et.eth = 240, et.etilde = 7869, et.etildebelow = 7707, et.etnahtafoukhhebrew = 1425, et.etnahtafoukhlefthebrew = 1425, et.etnahtahebrew = 1425, et.etnahtalefthebrew = 1425, et.eturned = 477, et.eukorean = 12641, et.euro = 8364, et.evowelsignbengali = 2503, et.evowelsigndeva = 2375, et.evowelsigngujarati = 2759, et.exclam = 33, et.exclamarmenian = 1372, et.exclamdbl = 8252, et.exclamdown = 161, et.exclamdownsmall = 63393, et.exclammonospace = 65281, et.exclamsmall = 63265, et.existential = 8707, et.ezh = 658, et.ezhcaron = 495, et.ezhcurl = 659, et.ezhreversed = 441, et.ezhtail = 442, et.f = 102, et.fadeva = 2398, et.fagurmukhi = 2654, et.fahrenheit = 8457, et.fathaarabic = 1614, et.fathalowarabic = 1614, et.fathatanarabic = 1611, et.fbopomofo = 12552, et.fcircle = 9429, et.fdotaccent = 7711, et.feharabic = 1601, et.feharmenian = 1414, et.fehfinalarabic = 65234, et.fehinitialarabic = 65235, et.fehmedialarabic = 65236, et.feicoptic = 997, et.female = 9792, et.ff = 64256, et.f_f = 64256, et.ffi = 64259, et.f_f_i = 64259, et.ffl = 64260, et.f_f_l = 64260, et.fi = 64257, et.f_i = 64257, et.fifteencircle = 9326, et.fifteenparen = 9346, et.fifteenperiod = 9366, et.figuredash = 8210, et.filledbox = 9632, et.filledrect = 9644, et.finalkaf = 1498, et.finalkafdagesh = 64314, et.finalkafdageshhebrew = 64314, et.finalkafhebrew = 1498, et.finalmem = 1501, et.finalmemhebrew = 1501, et.finalnun = 1503, et.finalnunhebrew = 1503, et.finalpe = 1507, et.finalpehebrew = 1507, et.finaltsadi = 1509, et.finaltsadihebrew = 1509, et.firsttonechinese = 713, et.fisheye = 9673, et.fitacyrillic = 1139, et.five = 53, et.fivearabic = 1637, et.fivebengali = 2539, et.fivecircle = 9316, et.fivecircleinversesansserif = 10126, et.fivedeva = 2411, et.fiveeighths = 8541, et.fivegujarati = 2795, et.fivegurmukhi = 2667, et.fivehackarabic = 1637, et.fivehangzhou = 12325, et.fiveideographicparen = 12836, et.fiveinferior = 8325, et.fivemonospace = 65301, et.fiveoldstyle = 63285, et.fiveparen = 9336, et.fiveperiod = 9356, et.fivepersian = 1781, et.fiveroman = 8564, et.fivesuperior = 8309, et.fivethai = 3669, et.fl = 64258, et.f_l = 64258, et.florin = 402, et.fmonospace = 65350, et.fmsquare = 13209, et.fofanthai = 3615, et.fofathai = 3613, et.fongmanthai = 3663, et.forall = 8704, et.four = 52, et.fourarabic = 1636, et.fourbengali = 2538, et.fourcircle = 9315, et.fourcircleinversesansserif = 10125, et.fourdeva = 2410, et.fourgujarati = 2794, et.fourgurmukhi = 2666, et.fourhackarabic = 1636, et.fourhangzhou = 12324, et.fourideographicparen = 12835, et.fourinferior = 8324, et.fourmonospace = 65300, et.fournumeratorbengali = 2551, et.fouroldstyle = 63284, et.fourparen = 9335, et.fourperiod = 9355, et.fourpersian = 1780, et.fourroman = 8563, et.foursuperior = 8308, et.fourteencircle = 9325, et.fourteenparen = 9345, et.fourteenperiod = 9365, et.fourthai = 3668, et.fourthtonechinese = 715, et.fparen = 9377, et.fraction = 8260, et.franc = 8355, et.g = 103, et.gabengali = 2455, et.gacute = 501, et.gadeva = 2327, et.gafarabic = 1711, et.gaffinalarabic = 64403, et.gafinitialarabic = 64404, et.gafmedialarabic = 64405, et.gagujarati = 2711, et.gagurmukhi = 2583, et.gahiragana = 12364, et.gakatakana = 12460, et.gamma = 947, et.gammalatinsmall = 611, et.gammasuperior = 736, et.gangiacoptic = 1003, et.gbopomofo = 12557, et.gbreve = 287, et.gcaron = 487, et.gcedilla = 291, et.gcircle = 9430, et.gcircumflex = 285, et.gcommaaccent = 291, et.gdot = 289, et.gdotaccent = 289, et.gecyrillic = 1075, et.gehiragana = 12370, et.gekatakana = 12466, et.geometricallyequal = 8785, et.gereshaccenthebrew = 1436, et.gereshhebrew = 1523, et.gereshmuqdamhebrew = 1437, et.germandbls = 223, et.gershayimaccenthebrew = 1438, et.gershayimhebrew = 1524, et.getamark = 12307, et.ghabengali = 2456, et.ghadarmenian = 1394, et.ghadeva = 2328, et.ghagujarati = 2712, et.ghagurmukhi = 2584, et.ghainarabic = 1594, et.ghainfinalarabic = 65230, et.ghaininitialarabic = 65231, et.ghainmedialarabic = 65232, et.ghemiddlehookcyrillic = 1173, et.ghestrokecyrillic = 1171, et.gheupturncyrillic = 1169, et.ghhadeva = 2394, et.ghhagurmukhi = 2650, et.ghook = 608, et.ghzsquare = 13203, et.gihiragana = 12366, et.gikatakana = 12462, et.gimarmenian = 1379, et.gimel = 1490, et.gimeldagesh = 64306, et.gimeldageshhebrew = 64306, et.gimelhebrew = 1490, et.gjecyrillic = 1107, et.glottalinvertedstroke = 446, et.glottalstop = 660, et.glottalstopinverted = 662, et.glottalstopmod = 704, et.glottalstopreversed = 661, et.glottalstopreversedmod = 705, et.glottalstopreversedsuperior = 740, et.glottalstopstroke = 673, et.glottalstopstrokereversed = 674, et.gmacron = 7713, et.gmonospace = 65351, et.gohiragana = 12372, et.gokatakana = 12468, et.gparen = 9378, et.gpasquare = 13228, et.gradient = 8711, et.grave = 96, et.gravebelowcmb = 790, et.gravecmb = 768, et.gravecomb = 768, et.gravedeva = 2387, et.gravelowmod = 718, et.gravemonospace = 65344, et.gravetonecmb = 832, et.greater = 62, et.greaterequal = 8805, et.greaterequalorless = 8923, et.greatermonospace = 65310, et.greaterorequivalent = 8819, et.greaterorless = 8823, et.greateroverequal = 8807, et.greatersmall = 65125, et.gscript = 609, et.gstroke = 485, et.guhiragana = 12368, et.guillemotleft = 171, et.guillemotright = 187, et.guilsinglleft = 8249, et.guilsinglright = 8250, et.gukatakana = 12464, et.guramusquare = 13080, et.gysquare = 13257, et.h = 104, et.haabkhasiancyrillic = 1193, et.haaltonearabic = 1729, et.habengali = 2489, et.hadescendercyrillic = 1203, et.hadeva = 2361, et.hagujarati = 2745, et.hagurmukhi = 2617, et.haharabic = 1581, et.hahfinalarabic = 65186, et.hahinitialarabic = 65187, et.hahiragana = 12399, et.hahmedialarabic = 65188, et.haitusquare = 13098, et.hakatakana = 12495, et.hakatakanahalfwidth = 65418, et.halantgurmukhi = 2637, et.hamzaarabic = 1569, et.hamzalowarabic = 1569, et.hangulfiller = 12644, et.hardsigncyrillic = 1098, et.harpoonleftbarbup = 8636, et.harpoonrightbarbup = 8640, et.hasquare = 13258, et.hatafpatah = 1458, et.hatafpatah16 = 1458, et.hatafpatah23 = 1458, et.hatafpatah2f = 1458, et.hatafpatahhebrew = 1458, et.hatafpatahnarrowhebrew = 1458, et.hatafpatahquarterhebrew = 1458, et.hatafpatahwidehebrew = 1458, et.hatafqamats = 1459, et.hatafqamats1b = 1459, et.hatafqamats28 = 1459, et.hatafqamats34 = 1459, et.hatafqamatshebrew = 1459, et.hatafqamatsnarrowhebrew = 1459, et.hatafqamatsquarterhebrew = 1459, et.hatafqamatswidehebrew = 1459, et.hatafsegol = 1457, et.hatafsegol17 = 1457, et.hatafsegol24 = 1457, et.hatafsegol30 = 1457, et.hatafsegolhebrew = 1457, et.hatafsegolnarrowhebrew = 1457, et.hatafsegolquarterhebrew = 1457, et.hatafsegolwidehebrew = 1457, et.hbar = 295, et.hbopomofo = 12559, et.hbrevebelow = 7723, et.hcedilla = 7721, et.hcircle = 9431, et.hcircumflex = 293, et.hdieresis = 7719, et.hdotaccent = 7715, et.hdotbelow = 7717, et.he = 1492, et.heart = 9829, et.heartsuitblack = 9829, et.heartsuitwhite = 9825, et.hedagesh = 64308, et.hedageshhebrew = 64308, et.hehaltonearabic = 1729, et.heharabic = 1607, et.hehebrew = 1492, et.hehfinalaltonearabic = 64423, et.hehfinalalttwoarabic = 65258, et.hehfinalarabic = 65258, et.hehhamzaabovefinalarabic = 64421, et.hehhamzaaboveisolatedarabic = 64420, et.hehinitialaltonearabic = 64424, et.hehinitialarabic = 65259, et.hehiragana = 12408, et.hehmedialaltonearabic = 64425, et.hehmedialarabic = 65260, et.heiseierasquare = 13179, et.hekatakana = 12504, et.hekatakanahalfwidth = 65421, et.hekutaarusquare = 13110, et.henghook = 615, et.herutusquare = 13113, et.het = 1495, et.hethebrew = 1495, et.hhook = 614, et.hhooksuperior = 689, et.hieuhacirclekorean = 12923, et.hieuhaparenkorean = 12827, et.hieuhcirclekorean = 12909, et.hieuhkorean = 12622, et.hieuhparenkorean = 12813, et.hihiragana = 12402, et.hikatakana = 12498, et.hikatakanahalfwidth = 65419, et.hiriq = 1460, et.hiriq14 = 1460, et.hiriq21 = 1460, et.hiriq2d = 1460, et.hiriqhebrew = 1460, et.hiriqnarrowhebrew = 1460, et.hiriqquarterhebrew = 1460, et.hiriqwidehebrew = 1460, et.hlinebelow = 7830, et.hmonospace = 65352, et.hoarmenian = 1392, et.hohipthai = 3627, et.hohiragana = 12411, et.hokatakana = 12507, et.hokatakanahalfwidth = 65422, et.holam = 1465, et.holam19 = 1465, et.holam26 = 1465, et.holam32 = 1465, et.holamhebrew = 1465, et.holamnarrowhebrew = 1465, et.holamquarterhebrew = 1465, et.holamwidehebrew = 1465, et.honokhukthai = 3630, et.hookabovecomb = 777, et.hookcmb = 777, et.hookpalatalizedbelowcmb = 801, et.hookretroflexbelowcmb = 802, et.hoonsquare = 13122, et.horicoptic = 1001, et.horizontalbar = 8213, et.horncmb = 795, et.hotsprings = 9832, et.house = 8962, et.hparen = 9379, et.hsuperior = 688, et.hturned = 613, et.huhiragana = 12405, et.huiitosquare = 13107, et.hukatakana = 12501, et.hukatakanahalfwidth = 65420, et.hungarumlaut = 733, et.hungarumlautcmb = 779, et.hv = 405, et.hyphen = 45, et.hypheninferior = 63205, et.hyphenmonospace = 65293, et.hyphensmall = 65123, et.hyphensuperior = 63206, et.hyphentwo = 8208, et.i = 105, et.iacute = 237, et.iacyrillic = 1103, et.ibengali = 2439, et.ibopomofo = 12583, et.ibreve = 301, et.icaron = 464, et.icircle = 9432, et.icircumflex = 238, et.icyrillic = 1110, et.idblgrave = 521, et.ideographearthcircle = 12943, et.ideographfirecircle = 12939, et.ideographicallianceparen = 12863, et.ideographiccallparen = 12858, et.ideographiccentrecircle = 12965, et.ideographicclose = 12294, et.ideographiccomma = 12289, et.ideographiccommaleft = 65380, et.ideographiccongratulationparen = 12855, et.ideographiccorrectcircle = 12963, et.ideographicearthparen = 12847, et.ideographicenterpriseparen = 12861, et.ideographicexcellentcircle = 12957, et.ideographicfestivalparen = 12864, et.ideographicfinancialcircle = 12950, et.ideographicfinancialparen = 12854, et.ideographicfireparen = 12843, et.ideographichaveparen = 12850, et.ideographichighcircle = 12964, et.ideographiciterationmark = 12293, et.ideographiclaborcircle = 12952, et.ideographiclaborparen = 12856, et.ideographicleftcircle = 12967, et.ideographiclowcircle = 12966, et.ideographicmedicinecircle = 12969, et.ideographicmetalparen = 12846, et.ideographicmoonparen = 12842, et.ideographicnameparen = 12852, et.ideographicperiod = 12290, et.ideographicprintcircle = 12958, et.ideographicreachparen = 12867, et.ideographicrepresentparen = 12857, et.ideographicresourceparen = 12862, et.ideographicrightcircle = 12968, et.ideographicsecretcircle = 12953, et.ideographicselfparen = 12866, et.ideographicsocietyparen = 12851, et.ideographicspace = 12288, et.ideographicspecialparen = 12853, et.ideographicstockparen = 12849, et.ideographicstudyparen = 12859, et.ideographicsunparen = 12848, et.ideographicsuperviseparen = 12860, et.ideographicwaterparen = 12844, et.ideographicwoodparen = 12845, et.ideographiczero = 12295, et.ideographmetalcircle = 12942, et.ideographmooncircle = 12938, et.ideographnamecircle = 12948, et.ideographsuncircle = 12944, et.ideographwatercircle = 12940, et.ideographwoodcircle = 12941, et.ideva = 2311, et.idieresis = 239, et.idieresisacute = 7727, et.idieresiscyrillic = 1253, et.idotbelow = 7883, et.iebrevecyrillic = 1239, et.iecyrillic = 1077, et.ieungacirclekorean = 12917, et.ieungaparenkorean = 12821, et.ieungcirclekorean = 12903, et.ieungkorean = 12615, et.ieungparenkorean = 12807, et.igrave = 236, et.igujarati = 2695, et.igurmukhi = 2567, et.ihiragana = 12356, et.ihookabove = 7881, et.iibengali = 2440, et.iicyrillic = 1080, et.iideva = 2312, et.iigujarati = 2696, et.iigurmukhi = 2568, et.iimatragurmukhi = 2624, et.iinvertedbreve = 523, et.iishortcyrillic = 1081, et.iivowelsignbengali = 2496, et.iivowelsigndeva = 2368, et.iivowelsigngujarati = 2752, et.ij = 307, et.ikatakana = 12452, et.ikatakanahalfwidth = 65394, et.ikorean = 12643, et.ilde = 732, et.iluyhebrew = 1452, et.imacron = 299, et.imacroncyrillic = 1251, et.imageorapproximatelyequal = 8787, et.imatragurmukhi = 2623, et.imonospace = 65353, et.increment = 8710, et.infinity = 8734, et.iniarmenian = 1387, et.integral = 8747, et.integralbottom = 8993, et.integralbt = 8993, et.integralex = 63733, et.integraltop = 8992, et.integraltp = 8992, et.intersection = 8745, et.intisquare = 13061, et.invbullet = 9688, et.invcircle = 9689, et.invsmileface = 9787, et.iocyrillic = 1105, et.iogonek = 303, et.iota = 953, et.iotadieresis = 970, et.iotadieresistonos = 912, et.iotalatin = 617, et.iotatonos = 943, et.iparen = 9380, et.irigurmukhi = 2674, et.ismallhiragana = 12355, et.ismallkatakana = 12451, et.ismallkatakanahalfwidth = 65384, et.issharbengali = 2554, et.istroke = 616, et.isuperior = 63213, et.iterationhiragana = 12445, et.iterationkatakana = 12541, et.itilde = 297, et.itildebelow = 7725, et.iubopomofo = 12585, et.iucyrillic = 1102, et.ivowelsignbengali = 2495, et.ivowelsigndeva = 2367, et.ivowelsigngujarati = 2751, et.izhitsacyrillic = 1141, et.izhitsadblgravecyrillic = 1143, et.j = 106, et.jaarmenian = 1393, et.jabengali = 2460, et.jadeva = 2332, et.jagujarati = 2716, et.jagurmukhi = 2588, et.jbopomofo = 12560, et.jcaron = 496, et.jcircle = 9433, et.jcircumflex = 309, et.jcrossedtail = 669, et.jdotlessstroke = 607, et.jecyrillic = 1112, et.jeemarabic = 1580, et.jeemfinalarabic = 65182, et.jeeminitialarabic = 65183, et.jeemmedialarabic = 65184, et.jeharabic = 1688, et.jehfinalarabic = 64395, et.jhabengali = 2461, et.jhadeva = 2333, et.jhagujarati = 2717, et.jhagurmukhi = 2589, et.jheharmenian = 1403, et.jis = 12292, et.jmonospace = 65354, et.jparen = 9381, et.jsuperior = 690, et.k = 107, et.kabashkircyrillic = 1185, et.kabengali = 2453, et.kacute = 7729, et.kacyrillic = 1082, et.kadescendercyrillic = 1179, et.kadeva = 2325, et.kaf = 1499, et.kafarabic = 1603, et.kafdagesh = 64315, et.kafdageshhebrew = 64315, et.kaffinalarabic = 65242, et.kafhebrew = 1499, et.kafinitialarabic = 65243, et.kafmedialarabic = 65244, et.kafrafehebrew = 64333, et.kagujarati = 2709, et.kagurmukhi = 2581, et.kahiragana = 12363, et.kahookcyrillic = 1220, et.kakatakana = 12459, et.kakatakanahalfwidth = 65398, et.kappa = 954, et.kappasymbolgreek = 1008, et.kapyeounmieumkorean = 12657, et.kapyeounphieuphkorean = 12676, et.kapyeounpieupkorean = 12664, et.kapyeounssangpieupkorean = 12665, et.karoriisquare = 13069, et.kashidaautoarabic = 1600, et.kashidaautonosidebearingarabic = 1600, et.kasmallkatakana = 12533, et.kasquare = 13188, et.kasraarabic = 1616, et.kasratanarabic = 1613, et.kastrokecyrillic = 1183, et.katahiraprolongmarkhalfwidth = 65392, et.kaverticalstrokecyrillic = 1181, et.kbopomofo = 12558, et.kcalsquare = 13193, et.kcaron = 489, et.kcedilla = 311, et.kcircle = 9434, et.kcommaaccent = 311, et.kdotbelow = 7731, et.keharmenian = 1412, et.kehiragana = 12369, et.kekatakana = 12465, et.kekatakanahalfwidth = 65401, et.kenarmenian = 1391, et.kesmallkatakana = 12534, et.kgreenlandic = 312, et.khabengali = 2454, et.khacyrillic = 1093, et.khadeva = 2326, et.khagujarati = 2710, et.khagurmukhi = 2582, et.khaharabic = 1582, et.khahfinalarabic = 65190, et.khahinitialarabic = 65191, et.khahmedialarabic = 65192, et.kheicoptic = 999, et.khhadeva = 2393, et.khhagurmukhi = 2649, et.khieukhacirclekorean = 12920, et.khieukhaparenkorean = 12824, et.khieukhcirclekorean = 12906, et.khieukhkorean = 12619, et.khieukhparenkorean = 12810, et.khokhaithai = 3586, et.khokhonthai = 3589, et.khokhuatthai = 3587, et.khokhwaithai = 3588, et.khomutthai = 3675, et.khook = 409, et.khorakhangthai = 3590, et.khzsquare = 13201, et.kihiragana = 12365, et.kikatakana = 12461, et.kikatakanahalfwidth = 65399, et.kiroguramusquare = 13077, et.kiromeetorusquare = 13078, et.kirosquare = 13076, et.kiyeokacirclekorean = 12910, et.kiyeokaparenkorean = 12814, et.kiyeokcirclekorean = 12896, et.kiyeokkorean = 12593, et.kiyeokparenkorean = 12800, et.kiyeoksioskorean = 12595, et.kjecyrillic = 1116, et.klinebelow = 7733, et.klsquare = 13208, et.kmcubedsquare = 13222, et.kmonospace = 65355, et.kmsquaredsquare = 13218, et.kohiragana = 12371, et.kohmsquare = 13248, et.kokaithai = 3585, et.kokatakana = 12467, et.kokatakanahalfwidth = 65402, et.kooposquare = 13086, et.koppacyrillic = 1153, et.koreanstandardsymbol = 12927, et.koroniscmb = 835, et.kparen = 9382, et.kpasquare = 13226, et.ksicyrillic = 1135, et.ktsquare = 13263, et.kturned = 670, et.kuhiragana = 12367, et.kukatakana = 12463, et.kukatakanahalfwidth = 65400, et.kvsquare = 13240, et.kwsquare = 13246, et.l = 108, et.labengali = 2482, et.lacute = 314, et.ladeva = 2354, et.lagujarati = 2738, et.lagurmukhi = 2610, et.lakkhangyaothai = 3653, et.lamaleffinalarabic = 65276, et.lamalefhamzaabovefinalarabic = 65272, et.lamalefhamzaaboveisolatedarabic = 65271, et.lamalefhamzabelowfinalarabic = 65274, et.lamalefhamzabelowisolatedarabic = 65273, et.lamalefisolatedarabic = 65275, et.lamalefmaddaabovefinalarabic = 65270, et.lamalefmaddaaboveisolatedarabic = 65269, et.lamarabic = 1604, et.lambda = 955, et.lambdastroke = 411, et.lamed = 1500, et.lameddagesh = 64316, et.lameddageshhebrew = 64316, et.lamedhebrew = 1500, et.lamfinalarabic = 65246, et.lamhahinitialarabic = 64714, et.laminitialarabic = 65247, et.lamjeeminitialarabic = 64713, et.lamkhahinitialarabic = 64715, et.lamlamhehisolatedarabic = 65010, et.lammedialarabic = 65248, et.lammeemhahinitialarabic = 64904, et.lammeeminitialarabic = 64716, et.largecircle = 9711, et.lbar = 410, et.lbelt = 620, et.lbopomofo = 12556, et.lcaron = 318, et.lcedilla = 316, et.lcircle = 9435, et.lcircumflexbelow = 7741, et.lcommaaccent = 316, et.ldot = 320, et.ldotaccent = 320, et.ldotbelow = 7735, et.ldotbelowmacron = 7737, et.leftangleabovecmb = 794, et.lefttackbelowcmb = 792, et.less = 60, et.lessequal = 8804, et.lessequalorgreater = 8922, et.lessmonospace = 65308, et.lessorequivalent = 8818, et.lessorgreater = 8822, et.lessoverequal = 8806, et.lesssmall = 65124, et.lezh = 622, et.lfblock = 9612, et.lhookretroflex = 621, et.lira = 8356, et.liwnarmenian = 1388, et.lj = 457, et.ljecyrillic = 1113, et.ll = 63168, et.lladeva = 2355, et.llagujarati = 2739, et.llinebelow = 7739, et.llladeva = 2356, et.llvocalicbengali = 2529, et.llvocalicdeva = 2401, et.llvocalicvowelsignbengali = 2531, et.llvocalicvowelsigndeva = 2403, et.lmiddletilde = 619, et.lmonospace = 65356, et.lmsquare = 13264, et.lochulathai = 3628, et.logicaland = 8743, et.logicalnot = 172, et.logicalnotreversed = 8976, et.logicalor = 8744, et.lolingthai = 3621, et.longs = 383, et.lowlinecenterline = 65102, et.lowlinecmb = 818, et.lowlinedashed = 65101, et.lozenge = 9674, et.lparen = 9383, et.lslash = 322, et.lsquare = 8467, et.lsuperior = 63214, et.ltshade = 9617, et.luthai = 3622, et.lvocalicbengali = 2444, et.lvocalicdeva = 2316, et.lvocalicvowelsignbengali = 2530, et.lvocalicvowelsigndeva = 2402, et.lxsquare = 13267, et.m = 109, et.mabengali = 2478, et.macron = 175, et.macronbelowcmb = 817, et.macroncmb = 772, et.macronlowmod = 717, et.macronmonospace = 65507, et.macute = 7743, et.madeva = 2350, et.magujarati = 2734, et.magurmukhi = 2606, et.mahapakhhebrew = 1444, et.mahapakhlefthebrew = 1444, et.mahiragana = 12414, et.maichattawalowleftthai = 63637, et.maichattawalowrightthai = 63636, et.maichattawathai = 3659, et.maichattawaupperleftthai = 63635, et.maieklowleftthai = 63628, et.maieklowrightthai = 63627, et.maiekthai = 3656, et.maiekupperleftthai = 63626, et.maihanakatleftthai = 63620, et.maihanakatthai = 3633, et.maitaikhuleftthai = 63625, et.maitaikhuthai = 3655, et.maitholowleftthai = 63631, et.maitholowrightthai = 63630, et.maithothai = 3657, et.maithoupperleftthai = 63629, et.maitrilowleftthai = 63634, et.maitrilowrightthai = 63633, et.maitrithai = 3658, et.maitriupperleftthai = 63632, et.maiyamokthai = 3654, et.makatakana = 12510, et.makatakanahalfwidth = 65423, et.male = 9794, et.mansyonsquare = 13127, et.maqafhebrew = 1470, et.mars = 9794, et.masoracirclehebrew = 1455, et.masquare = 13187, et.mbopomofo = 12551, et.mbsquare = 13268, et.mcircle = 9436, et.mcubedsquare = 13221, et.mdotaccent = 7745, et.mdotbelow = 7747, et.meemarabic = 1605, et.meemfinalarabic = 65250, et.meeminitialarabic = 65251, et.meemmedialarabic = 65252, et.meemmeeminitialarabic = 64721, et.meemmeemisolatedarabic = 64584, et.meetorusquare = 13133, et.mehiragana = 12417, et.meizierasquare = 13182, et.mekatakana = 12513, et.mekatakanahalfwidth = 65426, et.mem = 1502, et.memdagesh = 64318, et.memdageshhebrew = 64318, et.memhebrew = 1502, et.menarmenian = 1396, et.merkhahebrew = 1445, et.merkhakefulahebrew = 1446, et.merkhakefulalefthebrew = 1446, et.merkhalefthebrew = 1445, et.mhook = 625, et.mhzsquare = 13202, et.middledotkatakanahalfwidth = 65381, et.middot = 183, et.mieumacirclekorean = 12914, et.mieumaparenkorean = 12818, et.mieumcirclekorean = 12900, et.mieumkorean = 12609, et.mieumpansioskorean = 12656, et.mieumparenkorean = 12804, et.mieumpieupkorean = 12654, et.mieumsioskorean = 12655, et.mihiragana = 12415, et.mikatakana = 12511, et.mikatakanahalfwidth = 65424, et.minus = 8722, et.minusbelowcmb = 800, et.minuscircle = 8854, et.minusmod = 727, et.minusplus = 8723, et.minute = 8242, et.miribaarusquare = 13130, et.mirisquare = 13129, et.mlonglegturned = 624, et.mlsquare = 13206, et.mmcubedsquare = 13219, et.mmonospace = 65357, et.mmsquaredsquare = 13215, et.mohiragana = 12418, et.mohmsquare = 13249, et.mokatakana = 12514, et.mokatakanahalfwidth = 65427, et.molsquare = 13270, et.momathai = 3617, et.moverssquare = 13223, et.moverssquaredsquare = 13224, et.mparen = 9384, et.mpasquare = 13227, et.mssquare = 13235, et.msuperior = 63215, et.mturned = 623, et.mu = 181, et.mu1 = 181, et.muasquare = 13186, et.muchgreater = 8811, et.muchless = 8810, et.mufsquare = 13196, et.mugreek = 956, et.mugsquare = 13197, et.muhiragana = 12416, et.mukatakana = 12512, et.mukatakanahalfwidth = 65425, et.mulsquare = 13205, et.multiply = 215, et.mumsquare = 13211, et.munahhebrew = 1443, et.munahlefthebrew = 1443, et.musicalnote = 9834, et.musicalnotedbl = 9835, et.musicflatsign = 9837, et.musicsharpsign = 9839, et.mussquare = 13234, et.muvsquare = 13238, et.muwsquare = 13244, et.mvmegasquare = 13241, et.mvsquare = 13239, et.mwmegasquare = 13247, et.mwsquare = 13245, et.n = 110, et.nabengali = 2472, et.nabla = 8711, et.nacute = 324, et.nadeva = 2344, et.nagujarati = 2728, et.nagurmukhi = 2600, et.nahiragana = 12394, et.nakatakana = 12490, et.nakatakanahalfwidth = 65413, et.napostrophe = 329, et.nasquare = 13185, et.nbopomofo = 12555, et.nbspace = 160, et.ncaron = 328, et.ncedilla = 326, et.ncircle = 9437, et.ncircumflexbelow = 7755, et.ncommaaccent = 326, et.ndotaccent = 7749, et.ndotbelow = 7751, et.nehiragana = 12397, et.nekatakana = 12493, et.nekatakanahalfwidth = 65416, et.newsheqelsign = 8362, et.nfsquare = 13195, et.ngabengali = 2457, et.ngadeva = 2329, et.ngagujarati = 2713, et.ngagurmukhi = 2585, et.ngonguthai = 3591, et.nhiragana = 12435, et.nhookleft = 626, et.nhookretroflex = 627, et.nieunacirclekorean = 12911, et.nieunaparenkorean = 12815, et.nieuncieuckorean = 12597, et.nieuncirclekorean = 12897, et.nieunhieuhkorean = 12598, et.nieunkorean = 12596, et.nieunpansioskorean = 12648, et.nieunparenkorean = 12801, et.nieunsioskorean = 12647, et.nieuntikeutkorean = 12646, et.nihiragana = 12395, et.nikatakana = 12491, et.nikatakanahalfwidth = 65414, et.nikhahitleftthai = 63641, et.nikhahitthai = 3661, et.nine = 57, et.ninearabic = 1641, et.ninebengali = 2543, et.ninecircle = 9320, et.ninecircleinversesansserif = 10130, et.ninedeva = 2415, et.ninegujarati = 2799, et.ninegurmukhi = 2671, et.ninehackarabic = 1641, et.ninehangzhou = 12329, et.nineideographicparen = 12840, et.nineinferior = 8329, et.ninemonospace = 65305, et.nineoldstyle = 63289, et.nineparen = 9340, et.nineperiod = 9360, et.ninepersian = 1785, et.nineroman = 8568, et.ninesuperior = 8313, et.nineteencircle = 9330, et.nineteenparen = 9350, et.nineteenperiod = 9370, et.ninethai = 3673, et.nj = 460, et.njecyrillic = 1114, et.nkatakana = 12531, et.nkatakanahalfwidth = 65437, et.nlegrightlong = 414, et.nlinebelow = 7753, et.nmonospace = 65358, et.nmsquare = 13210, et.nnabengali = 2467, et.nnadeva = 2339, et.nnagujarati = 2723, et.nnagurmukhi = 2595, et.nnnadeva = 2345, et.nohiragana = 12398, et.nokatakana = 12494, et.nokatakanahalfwidth = 65417, et.nonbreakingspace = 160, et.nonenthai = 3603, et.nonuthai = 3609, et.noonarabic = 1606, et.noonfinalarabic = 65254, et.noonghunnaarabic = 1722, et.noonghunnafinalarabic = 64415, et.nooninitialarabic = 65255, et.noonjeeminitialarabic = 64722, et.noonjeemisolatedarabic = 64587, et.noonmedialarabic = 65256, et.noonmeeminitialarabic = 64725, et.noonmeemisolatedarabic = 64590, et.noonnoonfinalarabic = 64653, et.notcontains = 8716, et.notelement = 8713, et.notelementof = 8713, et.notequal = 8800, et.notgreater = 8815, et.notgreaternorequal = 8817, et.notgreaternorless = 8825, et.notidentical = 8802, et.notless = 8814, et.notlessnorequal = 8816, et.notparallel = 8742, et.notprecedes = 8832, et.notsubset = 8836, et.notsucceeds = 8833, et.notsuperset = 8837, et.nowarmenian = 1398, et.nparen = 9385, et.nssquare = 13233, et.nsuperior = 8319, et.ntilde = 241, et.nu = 957, et.nuhiragana = 12396, et.nukatakana = 12492, et.nukatakanahalfwidth = 65415, et.nuktabengali = 2492, et.nuktadeva = 2364, et.nuktagujarati = 2748, et.nuktagurmukhi = 2620, et.numbersign = 35, et.numbersignmonospace = 65283, et.numbersignsmall = 65119, et.numeralsigngreek = 884, et.numeralsignlowergreek = 885, et.numero = 8470, et.nun = 1504, et.nundagesh = 64320, et.nundageshhebrew = 64320, et.nunhebrew = 1504, et.nvsquare = 13237, et.nwsquare = 13243, et.nyabengali = 2462, et.nyadeva = 2334, et.nyagujarati = 2718, et.nyagurmukhi = 2590, et.o = 111, et.oacute = 243, et.oangthai = 3629, et.obarred = 629, et.obarredcyrillic = 1257, et.obarreddieresiscyrillic = 1259, et.obengali = 2451, et.obopomofo = 12571, et.obreve = 335, et.ocandradeva = 2321, et.ocandragujarati = 2705, et.ocandravowelsigndeva = 2377, et.ocandravowelsigngujarati = 2761, et.ocaron = 466, et.ocircle = 9438, et.ocircumflex = 244, et.ocircumflexacute = 7889, et.ocircumflexdotbelow = 7897, et.ocircumflexgrave = 7891, et.ocircumflexhookabove = 7893, et.ocircumflextilde = 7895, et.ocyrillic = 1086, et.odblacute = 337, et.odblgrave = 525, et.odeva = 2323, et.odieresis = 246, et.odieresiscyrillic = 1255, et.odotbelow = 7885, et.oe = 339, et.oekorean = 12634, et.ogonek = 731, et.ogonekcmb = 808, et.ograve = 242, et.ogujarati = 2707, et.oharmenian = 1413, et.ohiragana = 12362, et.ohookabove = 7887, et.ohorn = 417, et.ohornacute = 7899, et.ohorndotbelow = 7907, et.ohorngrave = 7901, et.ohornhookabove = 7903, et.ohorntilde = 7905, et.ohungarumlaut = 337, et.oi = 419, et.oinvertedbreve = 527, et.okatakana = 12458, et.okatakanahalfwidth = 65397, et.okorean = 12631, et.olehebrew = 1451, et.omacron = 333, et.omacronacute = 7763, et.omacrongrave = 7761, et.omdeva = 2384, et.omega = 969, et.omega1 = 982, et.omegacyrillic = 1121, et.omegalatinclosed = 631, et.omegaroundcyrillic = 1147, et.omegatitlocyrillic = 1149, et.omegatonos = 974, et.omgujarati = 2768, et.omicron = 959, et.omicrontonos = 972, et.omonospace = 65359, et.one = 49, et.onearabic = 1633, et.onebengali = 2535, et.onecircle = 9312, et.onecircleinversesansserif = 10122, et.onedeva = 2407, et.onedotenleader = 8228, et.oneeighth = 8539, et.onefitted = 63196, et.onegujarati = 2791, et.onegurmukhi = 2663, et.onehackarabic = 1633, et.onehalf = 189, et.onehangzhou = 12321, et.oneideographicparen = 12832, et.oneinferior = 8321, et.onemonospace = 65297, et.onenumeratorbengali = 2548, et.oneoldstyle = 63281, et.oneparen = 9332, et.oneperiod = 9352, et.onepersian = 1777, et.onequarter = 188, et.oneroman = 8560, et.onesuperior = 185, et.onethai = 3665, et.onethird = 8531, et.oogonek = 491, et.oogonekmacron = 493, et.oogurmukhi = 2579, et.oomatragurmukhi = 2635, et.oopen = 596, et.oparen = 9386, et.openbullet = 9702, et.option = 8997, et.ordfeminine = 170, et.ordmasculine = 186, et.orthogonal = 8735, et.oshortdeva = 2322, et.oshortvowelsigndeva = 2378, et.oslash = 248, et.oslashacute = 511, et.osmallhiragana = 12361, et.osmallkatakana = 12457, et.osmallkatakanahalfwidth = 65387, et.ostrokeacute = 511, et.osuperior = 63216, et.otcyrillic = 1151, et.otilde = 245, et.otildeacute = 7757, et.otildedieresis = 7759, et.oubopomofo = 12577, et.overline = 8254, et.overlinecenterline = 65098, et.overlinecmb = 773, et.overlinedashed = 65097, et.overlinedblwavy = 65100, et.overlinewavy = 65099, et.overscore = 175, et.ovowelsignbengali = 2507, et.ovowelsigndeva = 2379, et.ovowelsigngujarati = 2763, et.p = 112, et.paampssquare = 13184, et.paasentosquare = 13099, et.pabengali = 2474, et.pacute = 7765, et.padeva = 2346, et.pagedown = 8671, et.pageup = 8670, et.pagujarati = 2730, et.pagurmukhi = 2602, et.pahiragana = 12401, et.paiyannoithai = 3631, et.pakatakana = 12497, et.palatalizationcyrilliccmb = 1156, et.palochkacyrillic = 1216, et.pansioskorean = 12671, et.paragraph = 182, et.parallel = 8741, et.parenleft = 40, et.parenleftaltonearabic = 64830, et.parenleftbt = 63725, et.parenleftex = 63724, et.parenleftinferior = 8333, et.parenleftmonospace = 65288, et.parenleftsmall = 65113, et.parenleftsuperior = 8317, et.parenlefttp = 63723, et.parenleftvertical = 65077, et.parenright = 41, et.parenrightaltonearabic = 64831, et.parenrightbt = 63736, et.parenrightex = 63735, et.parenrightinferior = 8334, et.parenrightmonospace = 65289, et.parenrightsmall = 65114, et.parenrightsuperior = 8318, et.parenrighttp = 63734, et.parenrightvertical = 65078, et.partialdiff = 8706, et.paseqhebrew = 1472, et.pashtahebrew = 1433, et.pasquare = 13225, et.patah = 1463, et.patah11 = 1463, et.patah1d = 1463, et.patah2a = 1463, et.patahhebrew = 1463, et.patahnarrowhebrew = 1463, et.patahquarterhebrew = 1463, et.patahwidehebrew = 1463, et.pazerhebrew = 1441, et.pbopomofo = 12550, et.pcircle = 9439, et.pdotaccent = 7767, et.pe = 1508, et.pecyrillic = 1087, et.pedagesh = 64324, et.pedageshhebrew = 64324, et.peezisquare = 13115, et.pefinaldageshhebrew = 64323, et.peharabic = 1662, et.peharmenian = 1402, et.pehebrew = 1508, et.pehfinalarabic = 64343, et.pehinitialarabic = 64344, et.pehiragana = 12410, et.pehmedialarabic = 64345, et.pekatakana = 12506, et.pemiddlehookcyrillic = 1191, et.perafehebrew = 64334, et.percent = 37, et.percentarabic = 1642, et.percentmonospace = 65285, et.percentsmall = 65130, et.period = 46, et.periodarmenian = 1417, et.periodcentered = 183, et.periodhalfwidth = 65377, et.periodinferior = 63207, et.periodmonospace = 65294, et.periodsmall = 65106, et.periodsuperior = 63208, et.perispomenigreekcmb = 834, et.perpendicular = 8869, et.perthousand = 8240, et.peseta = 8359, et.pfsquare = 13194, et.phabengali = 2475, et.phadeva = 2347, et.phagujarati = 2731, et.phagurmukhi = 2603, et.phi = 966, et.phi1 = 981, et.phieuphacirclekorean = 12922, et.phieuphaparenkorean = 12826, et.phieuphcirclekorean = 12908, et.phieuphkorean = 12621, et.phieuphparenkorean = 12812, et.philatin = 632, et.phinthuthai = 3642, et.phisymbolgreek = 981, et.phook = 421, et.phophanthai = 3614, et.phophungthai = 3612, et.phosamphaothai = 3616, et.pi = 960, et.pieupacirclekorean = 12915, et.pieupaparenkorean = 12819, et.pieupcieuckorean = 12662, et.pieupcirclekorean = 12901, et.pieupkiyeokkorean = 12658, et.pieupkorean = 12610, et.pieupparenkorean = 12805, et.pieupsioskiyeokkorean = 12660, et.pieupsioskorean = 12612, et.pieupsiostikeutkorean = 12661, et.pieupthieuthkorean = 12663, et.pieuptikeutkorean = 12659, et.pihiragana = 12404, et.pikatakana = 12500, et.pisymbolgreek = 982, et.piwrarmenian = 1411, et.planckover2pi = 8463, et.planckover2pi1 = 8463, et.plus = 43, et.plusbelowcmb = 799, et.pluscircle = 8853, et.plusminus = 177, et.plusmod = 726, et.plusmonospace = 65291, et.plussmall = 65122, et.plussuperior = 8314, et.pmonospace = 65360, et.pmsquare = 13272, et.pohiragana = 12413, et.pointingindexdownwhite = 9759, et.pointingindexleftwhite = 9756, et.pointingindexrightwhite = 9758, et.pointingindexupwhite = 9757, et.pokatakana = 12509, et.poplathai = 3611, et.postalmark = 12306, et.postalmarkface = 12320, et.pparen = 9387, et.precedes = 8826, et.prescription = 8478, et.primemod = 697, et.primereversed = 8245, et.product = 8719, et.projective = 8965, et.prolongedkana = 12540, et.propellor = 8984, et.propersubset = 8834, et.propersuperset = 8835, et.proportion = 8759, et.proportional = 8733, et.psi = 968, et.psicyrillic = 1137, et.psilipneumatacyrilliccmb = 1158, et.pssquare = 13232, et.puhiragana = 12407, et.pukatakana = 12503, et.pvsquare = 13236, et.pwsquare = 13242, et.q = 113, et.qadeva = 2392, et.qadmahebrew = 1448, et.qafarabic = 1602, et.qaffinalarabic = 65238, et.qafinitialarabic = 65239, et.qafmedialarabic = 65240, et.qamats = 1464, et.qamats10 = 1464, et.qamats1a = 1464, et.qamats1c = 1464, et.qamats27 = 1464, et.qamats29 = 1464, et.qamats33 = 1464, et.qamatsde = 1464, et.qamatshebrew = 1464, et.qamatsnarrowhebrew = 1464, et.qamatsqatanhebrew = 1464, et.qamatsqatannarrowhebrew = 1464, et.qamatsqatanquarterhebrew = 1464, et.qamatsqatanwidehebrew = 1464, et.qamatsquarterhebrew = 1464, et.qamatswidehebrew = 1464, et.qarneyparahebrew = 1439, et.qbopomofo = 12561, et.qcircle = 9440, et.qhook = 672, et.qmonospace = 65361, et.qof = 1511, et.qofdagesh = 64327, et.qofdageshhebrew = 64327, et.qofhebrew = 1511, et.qparen = 9388, et.quarternote = 9833, et.qubuts = 1467, et.qubuts18 = 1467, et.qubuts25 = 1467, et.qubuts31 = 1467, et.qubutshebrew = 1467, et.qubutsnarrowhebrew = 1467, et.qubutsquarterhebrew = 1467, et.qubutswidehebrew = 1467, et.question = 63, et.questionarabic = 1567, et.questionarmenian = 1374, et.questiondown = 191, et.questiondownsmall = 63423, et.questiongreek = 894, et.questionmonospace = 65311, et.questionsmall = 63295, et.quotedbl = 34, et.quotedblbase = 8222, et.quotedblleft = 8220, et.quotedblmonospace = 65282, et.quotedblprime = 12318, et.quotedblprimereversed = 12317, et.quotedblright = 8221, et.quoteleft = 8216, et.quoteleftreversed = 8219, et.quotereversed = 8219, et.quoteright = 8217, et.quoterightn = 329, et.quotesinglbase = 8218, et.quotesingle = 39, et.quotesinglemonospace = 65287, et.r = 114, et.raarmenian = 1404, et.rabengali = 2480, et.racute = 341, et.radeva = 2352, et.radical = 8730, et.radicalex = 63717, et.radoverssquare = 13230, et.radoverssquaredsquare = 13231, et.radsquare = 13229, et.rafe = 1471, et.rafehebrew = 1471, et.ragujarati = 2736, et.ragurmukhi = 2608, et.rahiragana = 12425, et.rakatakana = 12521, et.rakatakanahalfwidth = 65431, et.ralowerdiagonalbengali = 2545, et.ramiddlediagonalbengali = 2544, et.ramshorn = 612, et.ratio = 8758, et.rbopomofo = 12566, et.rcaron = 345, et.rcedilla = 343, et.rcircle = 9441, et.rcommaaccent = 343, et.rdblgrave = 529, et.rdotaccent = 7769, et.rdotbelow = 7771, et.rdotbelowmacron = 7773, et.referencemark = 8251, et.reflexsubset = 8838, et.reflexsuperset = 8839, et.registered = 174, et.registersans = 63720, et.registerserif = 63194, et.reharabic = 1585, et.reharmenian = 1408, et.rehfinalarabic = 65198, et.rehiragana = 12428, et.rekatakana = 12524, et.rekatakanahalfwidth = 65434, et.resh = 1512, et.reshdageshhebrew = 64328, et.reshhebrew = 1512, et.reversedtilde = 8765, et.reviahebrew = 1431, et.reviamugrashhebrew = 1431, et.revlogicalnot = 8976, et.rfishhook = 638, et.rfishhookreversed = 639, et.rhabengali = 2525, et.rhadeva = 2397, et.rho = 961, et.rhook = 637, et.rhookturned = 635, et.rhookturnedsuperior = 693, et.rhosymbolgreek = 1009, et.rhotichookmod = 734, et.rieulacirclekorean = 12913, et.rieulaparenkorean = 12817, et.rieulcirclekorean = 12899, et.rieulhieuhkorean = 12608, et.rieulkiyeokkorean = 12602, et.rieulkiyeoksioskorean = 12649, et.rieulkorean = 12601, et.rieulmieumkorean = 12603, et.rieulpansioskorean = 12652, et.rieulparenkorean = 12803, et.rieulphieuphkorean = 12607, et.rieulpieupkorean = 12604, et.rieulpieupsioskorean = 12651, et.rieulsioskorean = 12605, et.rieulthieuthkorean = 12606, et.rieultikeutkorean = 12650, et.rieulyeorinhieuhkorean = 12653, et.rightangle = 8735, et.righttackbelowcmb = 793, et.righttriangle = 8895, et.rihiragana = 12426, et.rikatakana = 12522, et.rikatakanahalfwidth = 65432, et.ring = 730, et.ringbelowcmb = 805, et.ringcmb = 778, et.ringhalfleft = 703, et.ringhalfleftarmenian = 1369, et.ringhalfleftbelowcmb = 796, et.ringhalfleftcentered = 723, et.ringhalfright = 702, et.ringhalfrightbelowcmb = 825, et.ringhalfrightcentered = 722, et.rinvertedbreve = 531, et.rittorusquare = 13137, et.rlinebelow = 7775, et.rlongleg = 636, et.rlonglegturned = 634, et.rmonospace = 65362, et.rohiragana = 12429, et.rokatakana = 12525, et.rokatakanahalfwidth = 65435, et.roruathai = 3619, et.rparen = 9389, et.rrabengali = 2524, et.rradeva = 2353, et.rragurmukhi = 2652, et.rreharabic = 1681, et.rrehfinalarabic = 64397, et.rrvocalicbengali = 2528, et.rrvocalicdeva = 2400, et.rrvocalicgujarati = 2784, et.rrvocalicvowelsignbengali = 2500, et.rrvocalicvowelsigndeva = 2372, et.rrvocalicvowelsigngujarati = 2756, et.rsuperior = 63217, et.rtblock = 9616, et.rturned = 633, et.rturnedsuperior = 692, et.ruhiragana = 12427, et.rukatakana = 12523, et.rukatakanahalfwidth = 65433, et.rupeemarkbengali = 2546, et.rupeesignbengali = 2547, et.rupiah = 63197, et.ruthai = 3620, et.rvocalicbengali = 2443, et.rvocalicdeva = 2315, et.rvocalicgujarati = 2699, et.rvocalicvowelsignbengali = 2499, et.rvocalicvowelsigndeva = 2371, et.rvocalicvowelsigngujarati = 2755, et.s = 115, et.sabengali = 2488, et.sacute = 347, et.sacutedotaccent = 7781, et.sadarabic = 1589, et.sadeva = 2360, et.sadfinalarabic = 65210, et.sadinitialarabic = 65211, et.sadmedialarabic = 65212, et.sagujarati = 2744, et.sagurmukhi = 2616, et.sahiragana = 12373, et.sakatakana = 12469, et.sakatakanahalfwidth = 65403, et.sallallahoualayhewasallamarabic = 65018, et.samekh = 1505, et.samekhdagesh = 64321, et.samekhdageshhebrew = 64321, et.samekhhebrew = 1505, et.saraaathai = 3634, et.saraaethai = 3649, et.saraaimaimalaithai = 3652, et.saraaimaimuanthai = 3651, et.saraamthai = 3635, et.saraathai = 3632, et.saraethai = 3648, et.saraiileftthai = 63622, et.saraiithai = 3637, et.saraileftthai = 63621, et.saraithai = 3636, et.saraothai = 3650, et.saraueeleftthai = 63624, et.saraueethai = 3639, et.saraueleftthai = 63623, et.sarauethai = 3638, et.sarauthai = 3640, et.sarauuthai = 3641, et.sbopomofo = 12569, et.scaron = 353, et.scarondotaccent = 7783, et.scedilla = 351, et.schwa = 601, et.schwacyrillic = 1241, et.schwadieresiscyrillic = 1243, et.schwahook = 602, et.scircle = 9442, et.scircumflex = 349, et.scommaaccent = 537, et.sdotaccent = 7777, et.sdotbelow = 7779, et.sdotbelowdotaccent = 7785, et.seagullbelowcmb = 828, et.second = 8243, et.secondtonechinese = 714, et.section = 167, et.seenarabic = 1587, et.seenfinalarabic = 65202, et.seeninitialarabic = 65203, et.seenmedialarabic = 65204, et.segol = 1462, et.segol13 = 1462, et.segol1f = 1462, et.segol2c = 1462, et.segolhebrew = 1462, et.segolnarrowhebrew = 1462, et.segolquarterhebrew = 1462, et.segoltahebrew = 1426, et.segolwidehebrew = 1462, et.seharmenian = 1405, et.sehiragana = 12379, et.sekatakana = 12475, et.sekatakanahalfwidth = 65406, et.semicolon = 59, et.semicolonarabic = 1563, et.semicolonmonospace = 65307, et.semicolonsmall = 65108, et.semivoicedmarkkana = 12444, et.semivoicedmarkkanahalfwidth = 65439, et.sentisquare = 13090, et.sentosquare = 13091, et.seven = 55, et.sevenarabic = 1639, et.sevenbengali = 2541, et.sevencircle = 9318, et.sevencircleinversesansserif = 10128, et.sevendeva = 2413, et.seveneighths = 8542, et.sevengujarati = 2797, et.sevengurmukhi = 2669, et.sevenhackarabic = 1639, et.sevenhangzhou = 12327, et.sevenideographicparen = 12838, et.seveninferior = 8327, et.sevenmonospace = 65303, et.sevenoldstyle = 63287, et.sevenparen = 9338, et.sevenperiod = 9358, et.sevenpersian = 1783, et.sevenroman = 8566, et.sevensuperior = 8311, et.seventeencircle = 9328, et.seventeenparen = 9348, et.seventeenperiod = 9368, et.seventhai = 3671, et.sfthyphen = 173, et.shaarmenian = 1399, et.shabengali = 2486, et.shacyrillic = 1096, et.shaddaarabic = 1617, et.shaddadammaarabic = 64609, et.shaddadammatanarabic = 64606, et.shaddafathaarabic = 64608, et.shaddakasraarabic = 64610, et.shaddakasratanarabic = 64607, et.shade = 9618, et.shadedark = 9619, et.shadelight = 9617, et.shademedium = 9618, et.shadeva = 2358, et.shagujarati = 2742, et.shagurmukhi = 2614, et.shalshelethebrew = 1427, et.shbopomofo = 12565, et.shchacyrillic = 1097, et.sheenarabic = 1588, et.sheenfinalarabic = 65206, et.sheeninitialarabic = 65207, et.sheenmedialarabic = 65208, et.sheicoptic = 995, et.sheqel = 8362, et.sheqelhebrew = 8362, et.sheva = 1456, et.sheva115 = 1456, et.sheva15 = 1456, et.sheva22 = 1456, et.sheva2e = 1456, et.shevahebrew = 1456, et.shevanarrowhebrew = 1456, et.shevaquarterhebrew = 1456, et.shevawidehebrew = 1456, et.shhacyrillic = 1211, et.shimacoptic = 1005, et.shin = 1513, et.shindagesh = 64329, et.shindageshhebrew = 64329, et.shindageshshindot = 64300, et.shindageshshindothebrew = 64300, et.shindageshsindot = 64301, et.shindageshsindothebrew = 64301, et.shindothebrew = 1473, et.shinhebrew = 1513, et.shinshindot = 64298, et.shinshindothebrew = 64298, et.shinsindot = 64299, et.shinsindothebrew = 64299, et.shook = 642, et.sigma = 963, et.sigma1 = 962, et.sigmafinal = 962, et.sigmalunatesymbolgreek = 1010, et.sihiragana = 12375, et.sikatakana = 12471, et.sikatakanahalfwidth = 65404, et.siluqhebrew = 1469, et.siluqlefthebrew = 1469, et.similar = 8764, et.sindothebrew = 1474, et.siosacirclekorean = 12916, et.siosaparenkorean = 12820, et.sioscieuckorean = 12670, et.sioscirclekorean = 12902, et.sioskiyeokkorean = 12666, et.sioskorean = 12613, et.siosnieunkorean = 12667, et.siosparenkorean = 12806, et.siospieupkorean = 12669, et.siostikeutkorean = 12668, et.six = 54, et.sixarabic = 1638, et.sixbengali = 2540, et.sixcircle = 9317, et.sixcircleinversesansserif = 10127, et.sixdeva = 2412, et.sixgujarati = 2796, et.sixgurmukhi = 2668, et.sixhackarabic = 1638, et.sixhangzhou = 12326, et.sixideographicparen = 12837, et.sixinferior = 8326, et.sixmonospace = 65302, et.sixoldstyle = 63286, et.sixparen = 9337, et.sixperiod = 9357, et.sixpersian = 1782, et.sixroman = 8565, et.sixsuperior = 8310, et.sixteencircle = 9327, et.sixteencurrencydenominatorbengali = 2553, et.sixteenparen = 9347, et.sixteenperiod = 9367, et.sixthai = 3670, et.slash = 47, et.slashmonospace = 65295, et.slong = 383, et.slongdotaccent = 7835, et.smileface = 9786, et.smonospace = 65363, et.sofpasuqhebrew = 1475, et.softhyphen = 173, et.softsigncyrillic = 1100, et.sohiragana = 12381, et.sokatakana = 12477, et.sokatakanahalfwidth = 65407, et.soliduslongoverlaycmb = 824, et.solidusshortoverlaycmb = 823, et.sorusithai = 3625, et.sosalathai = 3624, et.sosothai = 3595, et.sosuathai = 3626, et.space = 32, et.spacehackarabic = 32, et.spade = 9824, et.spadesuitblack = 9824, et.spadesuitwhite = 9828, et.sparen = 9390, et.squarebelowcmb = 827, et.squarecc = 13252, et.squarecm = 13213, et.squarediagonalcrosshatchfill = 9641, et.squarehorizontalfill = 9636, et.squarekg = 13199, et.squarekm = 13214, et.squarekmcapital = 13262, et.squareln = 13265, et.squarelog = 13266, et.squaremg = 13198, et.squaremil = 13269, et.squaremm = 13212, et.squaremsquared = 13217, et.squareorthogonalcrosshatchfill = 9638, et.squareupperlefttolowerrightfill = 9639, et.squareupperrighttolowerleftfill = 9640, et.squareverticalfill = 9637, et.squarewhitewithsmallblack = 9635, et.srsquare = 13275, et.ssabengali = 2487, et.ssadeva = 2359, et.ssagujarati = 2743, et.ssangcieuckorean = 12617, et.ssanghieuhkorean = 12677, et.ssangieungkorean = 12672, et.ssangkiyeokkorean = 12594, et.ssangnieunkorean = 12645, et.ssangpieupkorean = 12611, et.ssangsioskorean = 12614, et.ssangtikeutkorean = 12600, et.ssuperior = 63218, et.sterling = 163, et.sterlingmonospace = 65505, et.strokelongoverlaycmb = 822, et.strokeshortoverlaycmb = 821, et.subset = 8834, et.subsetnotequal = 8842, et.subsetorequal = 8838, et.succeeds = 8827, et.suchthat = 8715, et.suhiragana = 12377, et.sukatakana = 12473, et.sukatakanahalfwidth = 65405, et.sukunarabic = 1618, et.summation = 8721, et.sun = 9788, et.superset = 8835, et.supersetnotequal = 8843, et.supersetorequal = 8839, et.svsquare = 13276, et.syouwaerasquare = 13180, et.t = 116, et.tabengali = 2468, et.tackdown = 8868, et.tackleft = 8867, et.tadeva = 2340, et.tagujarati = 2724, et.tagurmukhi = 2596, et.taharabic = 1591, et.tahfinalarabic = 65218, et.tahinitialarabic = 65219, et.tahiragana = 12383, et.tahmedialarabic = 65220, et.taisyouerasquare = 13181, et.takatakana = 12479, et.takatakanahalfwidth = 65408, et.tatweelarabic = 1600, et.tau = 964, et.tav = 1514, et.tavdages = 64330, et.tavdagesh = 64330, et.tavdageshhebrew = 64330, et.tavhebrew = 1514, et.tbar = 359, et.tbopomofo = 12554, et.tcaron = 357, et.tccurl = 680, et.tcedilla = 355, et.tcheharabic = 1670, et.tchehfinalarabic = 64379, et.tchehinitialarabic = 64380, et.tchehmedialarabic = 64381, et.tcircle = 9443, et.tcircumflexbelow = 7793, et.tcommaaccent = 355, et.tdieresis = 7831, et.tdotaccent = 7787, et.tdotbelow = 7789, et.tecyrillic = 1090, et.tedescendercyrillic = 1197, et.teharabic = 1578, et.tehfinalarabic = 65174, et.tehhahinitialarabic = 64674, et.tehhahisolatedarabic = 64524, et.tehinitialarabic = 65175, et.tehiragana = 12390, et.tehjeeminitialarabic = 64673, et.tehjeemisolatedarabic = 64523, et.tehmarbutaarabic = 1577, et.tehmarbutafinalarabic = 65172, et.tehmedialarabic = 65176, et.tehmeeminitialarabic = 64676, et.tehmeemisolatedarabic = 64526, et.tehnoonfinalarabic = 64627, et.tekatakana = 12486, et.tekatakanahalfwidth = 65411, et.telephone = 8481, et.telephoneblack = 9742, et.telishagedolahebrew = 1440, et.telishaqetanahebrew = 1449, et.tencircle = 9321, et.tenideographicparen = 12841, et.tenparen = 9341, et.tenperiod = 9361, et.tenroman = 8569, et.tesh = 679, et.tet = 1496, et.tetdagesh = 64312, et.tetdageshhebrew = 64312, et.tethebrew = 1496, et.tetsecyrillic = 1205, et.tevirhebrew = 1435, et.tevirlefthebrew = 1435, et.thabengali = 2469, et.thadeva = 2341, et.thagujarati = 2725, et.thagurmukhi = 2597, et.thalarabic = 1584, et.thalfinalarabic = 65196, et.thanthakhatlowleftthai = 63640, et.thanthakhatlowrightthai = 63639, et.thanthakhatthai = 3660, et.thanthakhatupperleftthai = 63638, et.theharabic = 1579, et.thehfinalarabic = 65178, et.thehinitialarabic = 65179, et.thehmedialarabic = 65180, et.thereexists = 8707, et.therefore = 8756, et.theta = 952, et.theta1 = 977, et.thetasymbolgreek = 977, et.thieuthacirclekorean = 12921, et.thieuthaparenkorean = 12825, et.thieuthcirclekorean = 12907, et.thieuthkorean = 12620, et.thieuthparenkorean = 12811, et.thirteencircle = 9324, et.thirteenparen = 9344, et.thirteenperiod = 9364, et.thonangmonthothai = 3601, et.thook = 429, et.thophuthaothai = 3602, et.thorn = 254, et.thothahanthai = 3607, et.thothanthai = 3600, et.thothongthai = 3608, et.thothungthai = 3606, et.thousandcyrillic = 1154, et.thousandsseparatorarabic = 1644, et.thousandsseparatorpersian = 1644, et.three = 51, et.threearabic = 1635, et.threebengali = 2537, et.threecircle = 9314, et.threecircleinversesansserif = 10124, et.threedeva = 2409, et.threeeighths = 8540, et.threegujarati = 2793, et.threegurmukhi = 2665, et.threehackarabic = 1635, et.threehangzhou = 12323, et.threeideographicparen = 12834, et.threeinferior = 8323, et.threemonospace = 65299, et.threenumeratorbengali = 2550, et.threeoldstyle = 63283, et.threeparen = 9334, et.threeperiod = 9354, et.threepersian = 1779, et.threequarters = 190, et.threequartersemdash = 63198, et.threeroman = 8562, et.threesuperior = 179, et.threethai = 3667, et.thzsquare = 13204, et.tihiragana = 12385, et.tikatakana = 12481, et.tikatakanahalfwidth = 65409, et.tikeutacirclekorean = 12912, et.tikeutaparenkorean = 12816, et.tikeutcirclekorean = 12898, et.tikeutkorean = 12599, et.tikeutparenkorean = 12802, et.tilde = 732, et.tildebelowcmb = 816, et.tildecmb = 771, et.tildecomb = 771, et.tildedoublecmb = 864, et.tildeoperator = 8764, et.tildeoverlaycmb = 820, et.tildeverticalcmb = 830, et.timescircle = 8855, et.tipehahebrew = 1430, et.tipehalefthebrew = 1430, et.tippigurmukhi = 2672, et.titlocyrilliccmb = 1155, et.tiwnarmenian = 1407, et.tlinebelow = 7791, et.tmonospace = 65364, et.toarmenian = 1385, et.tohiragana = 12392, et.tokatakana = 12488, et.tokatakanahalfwidth = 65412, et.tonebarextrahighmod = 741, et.tonebarextralowmod = 745, et.tonebarhighmod = 742, et.tonebarlowmod = 744, et.tonebarmidmod = 743, et.tonefive = 445, et.tonesix = 389, et.tonetwo = 424, et.tonos = 900, et.tonsquare = 13095, et.topatakthai = 3599, et.tortoiseshellbracketleft = 12308, et.tortoiseshellbracketleftsmall = 65117, et.tortoiseshellbracketleftvertical = 65081, et.tortoiseshellbracketright = 12309, et.tortoiseshellbracketrightsmall = 65118, et.tortoiseshellbracketrightvertical = 65082, et.totaothai = 3605, et.tpalatalhook = 427, et.tparen = 9391, et.trademark = 8482, et.trademarksans = 63722, et.trademarkserif = 63195, et.tretroflexhook = 648, et.triagdn = 9660, et.triaglf = 9668, et.triagrt = 9658, et.triagup = 9650, et.ts = 678, et.tsadi = 1510, et.tsadidagesh = 64326, et.tsadidageshhebrew = 64326, et.tsadihebrew = 1510, et.tsecyrillic = 1094, et.tsere = 1461, et.tsere12 = 1461, et.tsere1e = 1461, et.tsere2b = 1461, et.tserehebrew = 1461, et.tserenarrowhebrew = 1461, et.tserequarterhebrew = 1461, et.tserewidehebrew = 1461, et.tshecyrillic = 1115, et.tsuperior = 63219, et.ttabengali = 2463, et.ttadeva = 2335, et.ttagujarati = 2719, et.ttagurmukhi = 2591, et.tteharabic = 1657, et.ttehfinalarabic = 64359, et.ttehinitialarabic = 64360, et.ttehmedialarabic = 64361, et.tthabengali = 2464, et.tthadeva = 2336, et.tthagujarati = 2720, et.tthagurmukhi = 2592, et.tturned = 647, et.tuhiragana = 12388, et.tukatakana = 12484, et.tukatakanahalfwidth = 65410, et.tusmallhiragana = 12387, et.tusmallkatakana = 12483, et.tusmallkatakanahalfwidth = 65391, et.twelvecircle = 9323, et.twelveparen = 9343, et.twelveperiod = 9363, et.twelveroman = 8571, et.twentycircle = 9331, et.twentyhangzhou = 21316, et.twentyparen = 9351, et.twentyperiod = 9371, et.two = 50, et.twoarabic = 1634, et.twobengali = 2536, et.twocircle = 9313, et.twocircleinversesansserif = 10123, et.twodeva = 2408, et.twodotenleader = 8229, et.twodotleader = 8229, et.twodotleadervertical = 65072, et.twogujarati = 2792, et.twogurmukhi = 2664, et.twohackarabic = 1634, et.twohangzhou = 12322, et.twoideographicparen = 12833, et.twoinferior = 8322, et.twomonospace = 65298, et.twonumeratorbengali = 2549, et.twooldstyle = 63282, et.twoparen = 9333, et.twoperiod = 9353, et.twopersian = 1778, et.tworoman = 8561, et.twostroke = 443, et.twosuperior = 178, et.twothai = 3666, et.twothirds = 8532, et.u = 117, et.uacute = 250, et.ubar = 649, et.ubengali = 2441, et.ubopomofo = 12584, et.ubreve = 365, et.ucaron = 468, et.ucircle = 9444, et.ucircumflex = 251, et.ucircumflexbelow = 7799, et.ucyrillic = 1091, et.udattadeva = 2385, et.udblacute = 369, et.udblgrave = 533, et.udeva = 2313, et.udieresis = 252, et.udieresisacute = 472, et.udieresisbelow = 7795, et.udieresiscaron = 474, et.udieresiscyrillic = 1265, et.udieresisgrave = 476, et.udieresismacron = 470, et.udotbelow = 7909, et.ugrave = 249, et.ugujarati = 2697, et.ugurmukhi = 2569, et.uhiragana = 12358, et.uhookabove = 7911, et.uhorn = 432, et.uhornacute = 7913, et.uhorndotbelow = 7921, et.uhorngrave = 7915, et.uhornhookabove = 7917, et.uhorntilde = 7919, et.uhungarumlaut = 369, et.uhungarumlautcyrillic = 1267, et.uinvertedbreve = 535, et.ukatakana = 12454, et.ukatakanahalfwidth = 65395, et.ukcyrillic = 1145, et.ukorean = 12636, et.umacron = 363, et.umacroncyrillic = 1263, et.umacrondieresis = 7803, et.umatragurmukhi = 2625, et.umonospace = 65365, et.underscore = 95, et.underscoredbl = 8215, et.underscoremonospace = 65343, et.underscorevertical = 65075, et.underscorewavy = 65103, et.union = 8746, et.universal = 8704, et.uogonek = 371, et.uparen = 9392, et.upblock = 9600, et.upperdothebrew = 1476, et.upsilon = 965, et.upsilondieresis = 971, et.upsilondieresistonos = 944, et.upsilonlatin = 650, et.upsilontonos = 973, et.uptackbelowcmb = 797, et.uptackmod = 724, et.uragurmukhi = 2675, et.uring = 367, et.ushortcyrillic = 1118, et.usmallhiragana = 12357, et.usmallkatakana = 12453, et.usmallkatakanahalfwidth = 65385, et.ustraightcyrillic = 1199, et.ustraightstrokecyrillic = 1201, et.utilde = 361, et.utildeacute = 7801, et.utildebelow = 7797, et.uubengali = 2442, et.uudeva = 2314, et.uugujarati = 2698, et.uugurmukhi = 2570, et.uumatragurmukhi = 2626, et.uuvowelsignbengali = 2498, et.uuvowelsigndeva = 2370, et.uuvowelsigngujarati = 2754, et.uvowelsignbengali = 2497, et.uvowelsigndeva = 2369, et.uvowelsigngujarati = 2753, et.v = 118, et.vadeva = 2357, et.vagujarati = 2741, et.vagurmukhi = 2613, et.vakatakana = 12535, et.vav = 1493, et.vavdagesh = 64309, et.vavdagesh65 = 64309, et.vavdageshhebrew = 64309, et.vavhebrew = 1493, et.vavholam = 64331, et.vavholamhebrew = 64331, et.vavvavhebrew = 1520, et.vavyodhebrew = 1521, et.vcircle = 9445, et.vdotbelow = 7807, et.vecyrillic = 1074, et.veharabic = 1700, et.vehfinalarabic = 64363, et.vehinitialarabic = 64364, et.vehmedialarabic = 64365, et.vekatakana = 12537, et.venus = 9792, et.verticalbar = 124, et.verticallineabovecmb = 781, et.verticallinebelowcmb = 809, et.verticallinelowmod = 716, et.verticallinemod = 712, et.vewarmenian = 1406, et.vhook = 651, et.vikatakana = 12536, et.viramabengali = 2509, et.viramadeva = 2381, et.viramagujarati = 2765, et.visargabengali = 2435, et.visargadeva = 2307, et.visargagujarati = 2691, et.vmonospace = 65366, et.voarmenian = 1400, et.voicediterationhiragana = 12446, et.voicediterationkatakana = 12542, et.voicedmarkkana = 12443, et.voicedmarkkanahalfwidth = 65438, et.vokatakana = 12538, et.vparen = 9393, et.vtilde = 7805, et.vturned = 652, et.vuhiragana = 12436, et.vukatakana = 12532, et.w = 119, et.wacute = 7811, et.waekorean = 12633, et.wahiragana = 12431, et.wakatakana = 12527, et.wakatakanahalfwidth = 65436, et.wakorean = 12632, et.wasmallhiragana = 12430, et.wasmallkatakana = 12526, et.wattosquare = 13143, et.wavedash = 12316, et.wavyunderscorevertical = 65076, et.wawarabic = 1608, et.wawfinalarabic = 65262, et.wawhamzaabovearabic = 1572, et.wawhamzaabovefinalarabic = 65158, et.wbsquare = 13277, et.wcircle = 9446, et.wcircumflex = 373, et.wdieresis = 7813, et.wdotaccent = 7815, et.wdotbelow = 7817, et.wehiragana = 12433, et.weierstrass = 8472, et.wekatakana = 12529, et.wekorean = 12638, et.weokorean = 12637, et.wgrave = 7809, et.whitebullet = 9702, et.whitecircle = 9675, et.whitecircleinverse = 9689, et.whitecornerbracketleft = 12302, et.whitecornerbracketleftvertical = 65091, et.whitecornerbracketright = 12303, et.whitecornerbracketrightvertical = 65092, et.whitediamond = 9671, et.whitediamondcontainingblacksmalldiamond = 9672, et.whitedownpointingsmalltriangle = 9663, et.whitedownpointingtriangle = 9661, et.whiteleftpointingsmalltriangle = 9667, et.whiteleftpointingtriangle = 9665, et.whitelenticularbracketleft = 12310, et.whitelenticularbracketright = 12311, et.whiterightpointingsmalltriangle = 9657, et.whiterightpointingtriangle = 9655, et.whitesmallsquare = 9643, et.whitesmilingface = 9786, et.whitesquare = 9633, et.whitestar = 9734, et.whitetelephone = 9743, et.whitetortoiseshellbracketleft = 12312, et.whitetortoiseshellbracketright = 12313, et.whiteuppointingsmalltriangle = 9653, et.whiteuppointingtriangle = 9651, et.wihiragana = 12432, et.wikatakana = 12528, et.wikorean = 12639, et.wmonospace = 65367, et.wohiragana = 12434, et.wokatakana = 12530, et.wokatakanahalfwidth = 65382, et.won = 8361, et.wonmonospace = 65510, et.wowaenthai = 3623, et.wparen = 9394, et.wring = 7832, et.wsuperior = 695, et.wturned = 653, et.wynn = 447, et.x = 120, et.xabovecmb = 829, et.xbopomofo = 12562, et.xcircle = 9447, et.xdieresis = 7821, et.xdotaccent = 7819, et.xeharmenian = 1389, et.xi = 958, et.xmonospace = 65368, et.xparen = 9395, et.xsuperior = 739, et.y = 121, et.yaadosquare = 13134, et.yabengali = 2479, et.yacute = 253, et.yadeva = 2351, et.yaekorean = 12626, et.yagujarati = 2735, et.yagurmukhi = 2607, et.yahiragana = 12420, et.yakatakana = 12516, et.yakatakanahalfwidth = 65428, et.yakorean = 12625, et.yamakkanthai = 3662, et.yasmallhiragana = 12419, et.yasmallkatakana = 12515, et.yasmallkatakanahalfwidth = 65388, et.yatcyrillic = 1123, et.ycircle = 9448, et.ycircumflex = 375, et.ydieresis = 255, et.ydotaccent = 7823, et.ydotbelow = 7925, et.yeharabic = 1610, et.yehbarreearabic = 1746, et.yehbarreefinalarabic = 64431, et.yehfinalarabic = 65266, et.yehhamzaabovearabic = 1574, et.yehhamzaabovefinalarabic = 65162, et.yehhamzaaboveinitialarabic = 65163, et.yehhamzaabovemedialarabic = 65164, et.yehinitialarabic = 65267, et.yehmedialarabic = 65268, et.yehmeeminitialarabic = 64733, et.yehmeemisolatedarabic = 64600, et.yehnoonfinalarabic = 64660, et.yehthreedotsbelowarabic = 1745, et.yekorean = 12630, et.yen = 165, et.yenmonospace = 65509, et.yeokorean = 12629, et.yeorinhieuhkorean = 12678, et.yerahbenyomohebrew = 1450, et.yerahbenyomolefthebrew = 1450, et.yericyrillic = 1099, et.yerudieresiscyrillic = 1273, et.yesieungkorean = 12673, et.yesieungpansioskorean = 12675, et.yesieungsioskorean = 12674, et.yetivhebrew = 1434, et.ygrave = 7923, et.yhook = 436, et.yhookabove = 7927, et.yiarmenian = 1397, et.yicyrillic = 1111, et.yikorean = 12642, et.yinyang = 9775, et.yiwnarmenian = 1410, et.ymonospace = 65369, et.yod = 1497, et.yoddagesh = 64313, et.yoddageshhebrew = 64313, et.yodhebrew = 1497, et.yodyodhebrew = 1522, et.yodyodpatahhebrew = 64287, et.yohiragana = 12424, et.yoikorean = 12681, et.yokatakana = 12520, et.yokatakanahalfwidth = 65430, et.yokorean = 12635, et.yosmallhiragana = 12423, et.yosmallkatakana = 12519, et.yosmallkatakanahalfwidth = 65390, et.yotgreek = 1011, et.yoyaekorean = 12680, et.yoyakorean = 12679, et.yoyakthai = 3618, et.yoyingthai = 3597, et.yparen = 9396, et.ypogegrammeni = 890, et.ypogegrammenigreekcmb = 837, et.yr = 422, et.yring = 7833, et.ysuperior = 696, et.ytilde = 7929, et.yturned = 654, et.yuhiragana = 12422, et.yuikorean = 12684, et.yukatakana = 12518, et.yukatakanahalfwidth = 65429, et.yukorean = 12640, et.yusbigcyrillic = 1131, et.yusbigiotifiedcyrillic = 1133, et.yuslittlecyrillic = 1127, et.yuslittleiotifiedcyrillic = 1129, et.yusmallhiragana = 12421, et.yusmallkatakana = 12517, et.yusmallkatakanahalfwidth = 65389, et.yuyekorean = 12683, et.yuyeokorean = 12682, et.yyabengali = 2527, et.yyadeva = 2399, et.z = 122, et.zaarmenian = 1382, et.zacute = 378, et.zadeva = 2395, et.zagurmukhi = 2651, et.zaharabic = 1592, et.zahfinalarabic = 65222, et.zahinitialarabic = 65223, et.zahiragana = 12374, et.zahmedialarabic = 65224, et.zainarabic = 1586, et.zainfinalarabic = 65200, et.zakatakana = 12470, et.zaqefgadolhebrew = 1429, et.zaqefqatanhebrew = 1428, et.zarqahebrew = 1432, et.zayin = 1494, et.zayindagesh = 64310, et.zayindageshhebrew = 64310, et.zayinhebrew = 1494, et.zbopomofo = 12567, et.zcaron = 382, et.zcircle = 9449, et.zcircumflex = 7825, et.zcurl = 657, et.zdot = 380, et.zdotaccent = 380, et.zdotbelow = 7827, et.zecyrillic = 1079, et.zedescendercyrillic = 1177, et.zedieresiscyrillic = 1247, et.zehiragana = 12380, et.zekatakana = 12476, et.zero = 48, et.zeroarabic = 1632, et.zerobengali = 2534, et.zerodeva = 2406, et.zerogujarati = 2790, et.zerogurmukhi = 2662, et.zerohackarabic = 1632, et.zeroinferior = 8320, et.zeromonospace = 65296, et.zerooldstyle = 63280, et.zeropersian = 1776, et.zerosuperior = 8304, et.zerothai = 3664, et.zerowidthjoiner = 65279, et.zerowidthnonjoiner = 8204, et.zerowidthspace = 8203, et.zeta = 950, et.zhbopomofo = 12563, et.zhearmenian = 1386, et.zhebrevecyrillic = 1218, et.zhecyrillic = 1078, et.zhedescendercyrillic = 1175, et.zhedieresiscyrillic = 1245, et.zihiragana = 12376, et.zikatakana = 12472, et.zinorhebrew = 1454, et.zlinebelow = 7829, et.zmonospace = 65370, et.zohiragana = 12382, et.zokatakana = 12478, et.zparen = 9397, et.zretroflexhook = 656, et.zstroke = 438, et.zuhiragana = 12378, et.zukatakana = 12474, et[".notdef"] = 0, et.angbracketleftbig = 9001, et.angbracketleftBig = 9001, et.angbracketleftbigg = 9001, et.angbracketleftBigg = 9001, et.angbracketrightBig = 9002, et.angbracketrightbig = 9002, et.angbracketrightBigg = 9002, et.angbracketrightbigg = 9002, et.arrowhookleft = 8618, et.arrowhookright = 8617, et.arrowlefttophalf = 8636, et.arrowleftbothalf = 8637, et.arrownortheast = 8599, et.arrownorthwest = 8598, et.arrowrighttophalf = 8640, et.arrowrightbothalf = 8641, et.arrowsoutheast = 8600, et.arrowsouthwest = 8601, et.backslashbig = 8726, et.backslashBig = 8726, et.backslashBigg = 8726, et.backslashbigg = 8726, et.bardbl = 8214, et.bracehtipdownleft = 65079, et.bracehtipdownright = 65079, et.bracehtipupleft = 65080, et.bracehtipupright = 65080, et.braceleftBig = 123, et.braceleftbig = 123, et.braceleftbigg = 123, et.braceleftBigg = 123, et.bracerightBig = 125, et.bracerightbig = 125, et.bracerightbigg = 125, et.bracerightBigg = 125, et.bracketleftbig = 91, et.bracketleftBig = 91, et.bracketleftbigg = 91, et.bracketleftBigg = 91, et.bracketrightBig = 93, et.bracketrightbig = 93, et.bracketrightbigg = 93, et.bracketrightBigg = 93, et.ceilingleftbig = 8968, et.ceilingleftBig = 8968, et.ceilingleftBigg = 8968, et.ceilingleftbigg = 8968, et.ceilingrightbig = 8969, et.ceilingrightBig = 8969, et.ceilingrightbigg = 8969, et.ceilingrightBigg = 8969, et.circledotdisplay = 8857, et.circledottext = 8857, et.circlemultiplydisplay = 8855, et.circlemultiplytext = 8855, et.circleplusdisplay = 8853, et.circleplustext = 8853, et.contintegraldisplay = 8750, et.contintegraltext = 8750, et.coproductdisplay = 8720, et.coproducttext = 8720, et.floorleftBig = 8970, et.floorleftbig = 8970, et.floorleftbigg = 8970, et.floorleftBigg = 8970, et.floorrightbig = 8971, et.floorrightBig = 8971, et.floorrightBigg = 8971, et.floorrightbigg = 8971, et.hatwide = 770, et.hatwider = 770, et.hatwidest = 770, et.intercal = 7488, et.integraldisplay = 8747, et.integraltext = 8747, et.intersectiondisplay = 8898, et.intersectiontext = 8898, et.logicalanddisplay = 8743, et.logicalandtext = 8743, et.logicalordisplay = 8744, et.logicalortext = 8744, et.parenleftBig = 40, et.parenleftbig = 40, et.parenleftBigg = 40, et.parenleftbigg = 40, et.parenrightBig = 41, et.parenrightbig = 41, et.parenrightBigg = 41, et.parenrightbigg = 41, et.prime = 8242, et.productdisplay = 8719, et.producttext = 8719, et.radicalbig = 8730, et.radicalBig = 8730, et.radicalBigg = 8730, et.radicalbigg = 8730, et.radicalbt = 8730, et.radicaltp = 8730, et.radicalvertex = 8730, et.slashbig = 47, et.slashBig = 47, et.slashBigg = 47, et.slashbigg = 47, et.summationdisplay = 8721, et.summationtext = 8721, et.tildewide = 732, et.tildewider = 732, et.tildewidest = 732, et.uniondisplay = 8899, et.unionmultidisplay = 8846, et.unionmultitext = 8846, et.unionsqdisplay = 8852, et.unionsqtext = 8852, et.uniontext = 8899, et.vextenddouble = 8741, et.vextendsingle = 8739;
          });
          at.getGlyphsUnicode = st;
          const lt = (0, rt.getLookupTableFactory)(function(et) {
            et.space = 32, et.a1 = 9985, et.a2 = 9986, et.a202 = 9987, et.a3 = 9988, et.a4 = 9742, et.a5 = 9990, et.a119 = 9991, et.a118 = 9992, et.a117 = 9993, et.a11 = 9755, et.a12 = 9758, et.a13 = 9996, et.a14 = 9997, et.a15 = 9998, et.a16 = 9999, et.a105 = 1e4, et.a17 = 10001, et.a18 = 10002, et.a19 = 10003, et.a20 = 10004, et.a21 = 10005, et.a22 = 10006, et.a23 = 10007, et.a24 = 10008, et.a25 = 10009, et.a26 = 10010, et.a27 = 10011, et.a28 = 10012, et.a6 = 10013, et.a7 = 10014, et.a8 = 10015, et.a9 = 10016, et.a10 = 10017, et.a29 = 10018, et.a30 = 10019, et.a31 = 10020, et.a32 = 10021, et.a33 = 10022, et.a34 = 10023, et.a35 = 9733, et.a36 = 10025, et.a37 = 10026, et.a38 = 10027, et.a39 = 10028, et.a40 = 10029, et.a41 = 10030, et.a42 = 10031, et.a43 = 10032, et.a44 = 10033, et.a45 = 10034, et.a46 = 10035, et.a47 = 10036, et.a48 = 10037, et.a49 = 10038, et.a50 = 10039, et.a51 = 10040, et.a52 = 10041, et.a53 = 10042, et.a54 = 10043, et.a55 = 10044, et.a56 = 10045, et.a57 = 10046, et.a58 = 10047, et.a59 = 10048, et.a60 = 10049, et.a61 = 10050, et.a62 = 10051, et.a63 = 10052, et.a64 = 10053, et.a65 = 10054, et.a66 = 10055, et.a67 = 10056, et.a68 = 10057, et.a69 = 10058, et.a70 = 10059, et.a71 = 9679, et.a72 = 10061, et.a73 = 9632, et.a74 = 10063, et.a203 = 10064, et.a75 = 10065, et.a204 = 10066, et.a76 = 9650, et.a77 = 9660, et.a78 = 9670, et.a79 = 10070, et.a81 = 9687, et.a82 = 10072, et.a83 = 10073, et.a84 = 10074, et.a97 = 10075, et.a98 = 10076, et.a99 = 10077, et.a100 = 10078, et.a101 = 10081, et.a102 = 10082, et.a103 = 10083, et.a104 = 10084, et.a106 = 10085, et.a107 = 10086, et.a108 = 10087, et.a112 = 9827, et.a111 = 9830, et.a110 = 9829, et.a109 = 9824, et.a120 = 9312, et.a121 = 9313, et.a122 = 9314, et.a123 = 9315, et.a124 = 9316, et.a125 = 9317, et.a126 = 9318, et.a127 = 9319, et.a128 = 9320, et.a129 = 9321, et.a130 = 10102, et.a131 = 10103, et.a132 = 10104, et.a133 = 10105, et.a134 = 10106, et.a135 = 10107, et.a136 = 10108, et.a137 = 10109, et.a138 = 10110, et.a139 = 10111, et.a140 = 10112, et.a141 = 10113, et.a142 = 10114, et.a143 = 10115, et.a144 = 10116, et.a145 = 10117, et.a146 = 10118, et.a147 = 10119, et.a148 = 10120, et.a149 = 10121, et.a150 = 10122, et.a151 = 10123, et.a152 = 10124, et.a153 = 10125, et.a154 = 10126, et.a155 = 10127, et.a156 = 10128, et.a157 = 10129, et.a158 = 10130, et.a159 = 10131, et.a160 = 10132, et.a161 = 8594, et.a163 = 8596, et.a164 = 8597, et.a196 = 10136, et.a165 = 10137, et.a192 = 10138, et.a166 = 10139, et.a167 = 10140, et.a168 = 10141, et.a169 = 10142, et.a170 = 10143, et.a171 = 10144, et.a172 = 10145, et.a173 = 10146, et.a162 = 10147, et.a174 = 10148, et.a175 = 10149, et.a176 = 10150, et.a177 = 10151, et.a178 = 10152, et.a179 = 10153, et.a193 = 10154, et.a180 = 10155, et.a199 = 10156, et.a181 = 10157, et.a200 = 10158, et.a182 = 10159, et.a201 = 10161, et.a183 = 10162, et.a184 = 10163, et.a197 = 10164, et.a185 = 10165, et.a194 = 10166, et.a198 = 10167, et.a186 = 10168, et.a195 = 10169, et.a187 = 10170, et.a188 = 10171, et.a189 = 10172, et.a190 = 10173, et.a191 = 10174, et.a89 = 10088, et.a90 = 10089, et.a93 = 10090, et.a94 = 10091, et.a91 = 10092, et.a92 = 10093, et.a205 = 10094, et.a85 = 10095, et.a206 = 10096, et.a86 = 10097, et.a87 = 10098, et.a88 = 10099, et.a95 = 10100, et.a96 = 10101, et[".notdef"] = 0;
          });
          at.getDingbatsGlyphsUnicode = lt;
        },
        /* 191 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.clearUnicodeCaches = gt, at.getCharUnicodeCategory = dt, at.getUnicodeForGlyph = et, at.getUnicodeRangeFor = ut, at.mapSpecialUnicodeValues = lt;
          var rt = ot(150);
          const st = (0, rt.getLookupTableFactory)(function(pt) {
            pt[63721] = 169, pt[63193] = 169, pt[63720] = 174, pt[63194] = 174, pt[63722] = 8482, pt[63195] = 8482, pt[63729] = 9127, pt[63730] = 9128, pt[63731] = 9129, pt[63740] = 9131, pt[63741] = 9132, pt[63742] = 9133, pt[63726] = 9121, pt[63727] = 9122, pt[63728] = 9123, pt[63737] = 9124, pt[63738] = 9125, pt[63739] = 9126, pt[63723] = 9115, pt[63724] = 9116, pt[63725] = 9117, pt[63734] = 9118, pt[63735] = 9119, pt[63736] = 9120;
          });
          function lt(pt) {
            return pt >= 65520 && pt <= 65535 ? 0 : pt >= 62976 && pt <= 63743 ? st()[pt] || pt : pt === 173 ? 45 : pt;
          }
          function et(pt, mt) {
            let ct = mt[pt];
            if (ct !== void 0)
              return ct;
            if (!pt)
              return -1;
            if (pt[0] === "u") {
              const vt = pt.length;
              let At;
              if (vt === 7 && pt[1] === "n" && pt[2] === "i")
                At = pt.substring(3);
              else if (vt >= 5 && vt <= 7)
                At = pt.substring(1);
              else
                return -1;
              if (At === At.toUpperCase() && (ct = parseInt(At, 16), ct >= 0))
                return ct;
            }
            return -1;
          }
          const it = [[0, 127], [128, 255], [256, 383], [384, 591], [592, 687, 7424, 7551, 7552, 7615], [688, 767, 42752, 42783], [768, 879, 7616, 7679], [880, 1023], [11392, 11519], [1024, 1279, 1280, 1327, 11744, 11775, 42560, 42655], [1328, 1423], [1424, 1535], [42240, 42559], [1536, 1791, 1872, 1919], [1984, 2047], [2304, 2431], [2432, 2559], [2560, 2687], [2688, 2815], [2816, 2943], [2944, 3071], [3072, 3199], [3200, 3327], [3328, 3455], [3584, 3711], [3712, 3839], [4256, 4351, 11520, 11567], [6912, 7039], [4352, 4607], [7680, 7935, 11360, 11391, 42784, 43007], [7936, 8191], [8192, 8303, 11776, 11903], [8304, 8351], [8352, 8399], [8400, 8447], [8448, 8527], [8528, 8591], [8592, 8703, 10224, 10239, 10496, 10623, 11008, 11263], [8704, 8959, 10752, 11007, 10176, 10223, 10624, 10751], [8960, 9215], [9216, 9279], [9280, 9311], [9312, 9471], [9472, 9599], [9600, 9631], [9632, 9727], [9728, 9983], [9984, 10175], [12288, 12351], [12352, 12447], [12448, 12543, 12784, 12799], [12544, 12591, 12704, 12735], [12592, 12687], [43072, 43135], [12800, 13055], [13056, 13311], [44032, 55215], [55296, 57343], [67840, 67871], [19968, 40959, 11904, 12031, 12032, 12255, 12272, 12287, 13312, 19903, 131072, 173791, 12688, 12703], [57344, 63743], [12736, 12783, 63744, 64255, 194560, 195103], [64256, 64335], [64336, 65023], [65056, 65071], [65040, 65055], [65104, 65135], [65136, 65279], [65280, 65519], [65520, 65535], [3840, 4095], [1792, 1871], [1920, 1983], [3456, 3583], [4096, 4255], [4608, 4991, 4992, 5023, 11648, 11743], [5024, 5119], [5120, 5759], [5760, 5791], [5792, 5887], [6016, 6143], [6144, 6319], [10240, 10495], [40960, 42127], [5888, 5919, 5920, 5951, 5952, 5983, 5984, 6015], [66304, 66351], [66352, 66383], [66560, 66639], [118784, 119039, 119040, 119295, 119296, 119375], [119808, 120831], [1044480, 1048573], [65024, 65039, 917760, 917999], [917504, 917631], [6400, 6479], [6480, 6527], [6528, 6623], [6656, 6687], [11264, 11359], [11568, 11647], [19904, 19967], [43008, 43055], [65536, 65663, 65664, 65791, 65792, 65855], [65856, 65935], [66432, 66463], [66464, 66527], [66640, 66687], [66688, 66735], [67584, 67647], [68096, 68191], [119552, 119647], [73728, 74751, 74752, 74879], [119648, 119679], [7040, 7103], [7168, 7247], [7248, 7295], [43136, 43231], [43264, 43311], [43312, 43359], [43520, 43615], [65936, 65999], [66e3, 66047], [66208, 66271, 66176, 66207, 67872, 67903], [127024, 127135, 126976, 127023]];
          function ut(pt) {
            let mt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
            if (mt !== -1) {
              const ct = it[mt];
              for (let vt = 0, At = ct.length; vt < At; vt += 2)
                if (pt >= ct[vt] && pt <= ct[vt + 1])
                  return mt;
            }
            for (let ct = 0, vt = it.length; ct < vt; ct++) {
              const At = it[ct];
              for (let xt = 0, bt = At.length; xt < bt; xt += 2)
                if (pt >= At[xt] && pt <= At[xt + 1])
                  return ct;
            }
            return -1;
          }
          const ft = new RegExp("^(\\s)|(\\p{Mn})|(\\p{Cf})$", "u"), ht = /* @__PURE__ */ new Map();
          function dt(pt) {
            const mt = ht.get(pt);
            if (mt)
              return mt;
            const ct = pt.match(ft), vt = {
              isWhitespace: !!(ct != null && ct[1]),
              isZeroWidthDiacritic: !!(ct != null && ct[2]),
              isInvisibleFormatMark: !!(ct != null && ct[3])
            };
            return ht.set(pt, vt), vt;
          }
          function gt() {
            ht.clear();
          }
        },
        /* 192 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.getSerifFonts = at.getNonStdFontMap = at.getGlyphMapForStandardFonts = at.getFontNameToFileMap = void 0, at.getStandardFontName = pt, at.getSymbolsFonts = at.getSupplementalGlyphMapForCalibri = at.getSupplementalGlyphMapForArialBlack = at.getStdFontMap = void 0, at.isKnownFontName = mt;
          var rt = ot(150), st = ot(189);
          const lt = (0, rt.getLookupTableFactory)(function(ct) {
            ct["Times-Roman"] = "Times-Roman", ct.Helvetica = "Helvetica", ct.Courier = "Courier", ct.Symbol = "Symbol", ct["Times-Bold"] = "Times-Bold", ct["Helvetica-Bold"] = "Helvetica-Bold", ct["Courier-Bold"] = "Courier-Bold", ct.ZapfDingbats = "ZapfDingbats", ct["Times-Italic"] = "Times-Italic", ct["Helvetica-Oblique"] = "Helvetica-Oblique", ct["Courier-Oblique"] = "Courier-Oblique", ct["Times-BoldItalic"] = "Times-BoldItalic", ct["Helvetica-BoldOblique"] = "Helvetica-BoldOblique", ct["Courier-BoldOblique"] = "Courier-BoldOblique", ct.ArialNarrow = "Helvetica", ct["ArialNarrow-Bold"] = "Helvetica-Bold", ct["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique", ct["ArialNarrow-Italic"] = "Helvetica-Oblique", ct.ArialBlack = "Helvetica", ct["ArialBlack-Bold"] = "Helvetica-Bold", ct["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique", ct["ArialBlack-Italic"] = "Helvetica-Oblique", ct["Arial-Black"] = "Helvetica", ct["Arial-Black-Bold"] = "Helvetica-Bold", ct["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique", ct["Arial-Black-Italic"] = "Helvetica-Oblique", ct.Arial = "Helvetica", ct["Arial-Bold"] = "Helvetica-Bold", ct["Arial-BoldItalic"] = "Helvetica-BoldOblique", ct["Arial-Italic"] = "Helvetica-Oblique", ct.ArialMT = "Helvetica", ct["Arial-BoldItalicMT"] = "Helvetica-BoldOblique", ct["Arial-BoldMT"] = "Helvetica-Bold", ct["Arial-ItalicMT"] = "Helvetica-Oblique", ct["Arial-BoldItalicMT-BoldItalic"] = "Helvetica-BoldOblique", ct["Arial-BoldMT-Bold"] = "Helvetica-Bold", ct["Arial-ItalicMT-Italic"] = "Helvetica-Oblique", ct.ArialUnicodeMS = "Helvetica", ct["ArialUnicodeMS-Bold"] = "Helvetica-Bold", ct["ArialUnicodeMS-BoldItalic"] = "Helvetica-BoldOblique", ct["ArialUnicodeMS-Italic"] = "Helvetica-Oblique", ct["Courier-BoldItalic"] = "Courier-BoldOblique", ct["Courier-Italic"] = "Courier-Oblique", ct.CourierNew = "Courier", ct["CourierNew-Bold"] = "Courier-Bold", ct["CourierNew-BoldItalic"] = "Courier-BoldOblique", ct["CourierNew-Italic"] = "Courier-Oblique", ct["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique", ct["CourierNewPS-BoldMT"] = "Courier-Bold", ct["CourierNewPS-ItalicMT"] = "Courier-Oblique", ct.CourierNewPSMT = "Courier", ct["Helvetica-BoldItalic"] = "Helvetica-BoldOblique", ct["Helvetica-Italic"] = "Helvetica-Oblique", ct["Symbol-Bold"] = "Symbol", ct["Symbol-BoldItalic"] = "Symbol", ct["Symbol-Italic"] = "Symbol", ct.TimesNewRoman = "Times-Roman", ct["TimesNewRoman-Bold"] = "Times-Bold", ct["TimesNewRoman-BoldItalic"] = "Times-BoldItalic", ct["TimesNewRoman-Italic"] = "Times-Italic", ct.TimesNewRomanPS = "Times-Roman", ct["TimesNewRomanPS-Bold"] = "Times-Bold", ct["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic", ct["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic", ct["TimesNewRomanPS-BoldMT"] = "Times-Bold", ct["TimesNewRomanPS-Italic"] = "Times-Italic", ct["TimesNewRomanPS-ItalicMT"] = "Times-Italic", ct.TimesNewRomanPSMT = "Times-Roman", ct["TimesNewRomanPSMT-Bold"] = "Times-Bold", ct["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic", ct["TimesNewRomanPSMT-Italic"] = "Times-Italic";
          });
          at.getStdFontMap = lt;
          const et = (0, rt.getLookupTableFactory)(function(ct) {
            ct.Courier = "FoxitFixed.pfb", ct["Courier-Bold"] = "FoxitFixedBold.pfb", ct["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb", ct["Courier-Oblique"] = "FoxitFixedItalic.pfb", ct.Helvetica = "LiberationSans-Regular.ttf", ct["Helvetica-Bold"] = "LiberationSans-Bold.ttf", ct["Helvetica-BoldOblique"] = "LiberationSans-BoldItalic.ttf", ct["Helvetica-Oblique"] = "LiberationSans-Italic.ttf", ct["Times-Roman"] = "FoxitSerif.pfb", ct["Times-Bold"] = "FoxitSerifBold.pfb", ct["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb", ct["Times-Italic"] = "FoxitSerifItalic.pfb", ct.Symbol = "FoxitSymbol.pfb", ct.ZapfDingbats = "FoxitDingbats.pfb", ct["LiberationSans-Regular"] = "LiberationSans-Regular.ttf", ct["LiberationSans-Bold"] = "LiberationSans-Bold.ttf", ct["LiberationSans-Italic"] = "LiberationSans-Italic.ttf", ct["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
          });
          at.getFontNameToFileMap = et;
          const it = (0, rt.getLookupTableFactory)(function(ct) {
            ct.Calibri = "Helvetica", ct["Calibri-Bold"] = "Helvetica-Bold", ct["Calibri-BoldItalic"] = "Helvetica-BoldOblique", ct["Calibri-Italic"] = "Helvetica-Oblique", ct.CenturyGothic = "Helvetica", ct["CenturyGothic-Bold"] = "Helvetica-Bold", ct["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique", ct["CenturyGothic-Italic"] = "Helvetica-Oblique", ct.ComicSansMS = "Comic Sans MS", ct["ComicSansMS-Bold"] = "Comic Sans MS-Bold", ct["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic", ct["ComicSansMS-Italic"] = "Comic Sans MS-Italic", ct.Impact = "Helvetica", ct["ItcSymbol-Bold"] = "Helvetica-Bold", ct["ItcSymbol-BoldItalic"] = "Helvetica-BoldOblique", ct["ItcSymbol-Book"] = "Helvetica", ct["ItcSymbol-BookItalic"] = "Helvetica-Oblique", ct["ItcSymbol-Medium"] = "Helvetica", ct["ItcSymbol-MediumItalic"] = "Helvetica-Oblique", ct.LucidaConsole = "Courier", ct["LucidaConsole-Bold"] = "Courier-Bold", ct["LucidaConsole-BoldItalic"] = "Courier-BoldOblique", ct["LucidaConsole-Italic"] = "Courier-Oblique", ct["LucidaSans-Demi"] = "Helvetica-Bold", ct["MS-Gothic"] = "MS Gothic", ct["MS-Gothic-Bold"] = "MS Gothic-Bold", ct["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic", ct["MS-Gothic-Italic"] = "MS Gothic-Italic", ct["MS-Mincho"] = "MS Mincho", ct["MS-Mincho-Bold"] = "MS Mincho-Bold", ct["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic", ct["MS-Mincho-Italic"] = "MS Mincho-Italic", ct["MS-PGothic"] = "MS PGothic", ct["MS-PGothic-Bold"] = "MS PGothic-Bold", ct["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic", ct["MS-PGothic-Italic"] = "MS PGothic-Italic", ct["MS-PMincho"] = "MS PMincho", ct["MS-PMincho-Bold"] = "MS PMincho-Bold", ct["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic", ct["MS-PMincho-Italic"] = "MS PMincho-Italic", ct.NuptialScript = "Times-Italic", ct.SegoeUISymbol = "Helvetica";
          });
          at.getNonStdFontMap = it;
          const ut = (0, rt.getLookupTableFactory)(function(ct) {
            ct["Adobe Jenson"] = !0, ct["Adobe Text"] = !0, ct.Albertus = !0, ct.Aldus = !0, ct.Alexandria = !0, ct.Algerian = !0, ct["American Typewriter"] = !0, ct.Antiqua = !0, ct.Apex = !0, ct.Arno = !0, ct.Aster = !0, ct.Aurora = !0, ct.Baskerville = !0, ct.Bell = !0, ct.Bembo = !0, ct["Bembo Schoolbook"] = !0, ct.Benguiat = !0, ct["Berkeley Old Style"] = !0, ct["Bernhard Modern"] = !0, ct["Berthold City"] = !0, ct.Bodoni = !0, ct["Bauer Bodoni"] = !0, ct["Book Antiqua"] = !0, ct.Bookman = !0, ct["Bordeaux Roman"] = !0, ct["Californian FB"] = !0, ct.Calisto = !0, ct.Calvert = !0, ct.Capitals = !0, ct.Cambria = !0, ct.Cartier = !0, ct.Caslon = !0, ct.Catull = !0, ct.Centaur = !0, ct["Century Old Style"] = !0, ct["Century Schoolbook"] = !0, ct.Chaparral = !0, ct["Charis SIL"] = !0, ct.Cheltenham = !0, ct["Cholla Slab"] = !0, ct.Clarendon = !0, ct.Clearface = !0, ct.Cochin = !0, ct.Colonna = !0, ct["Computer Modern"] = !0, ct["Concrete Roman"] = !0, ct.Constantia = !0, ct["Cooper Black"] = !0, ct.Corona = !0, ct.Ecotype = !0, ct.Egyptienne = !0, ct.Elephant = !0, ct.Excelsior = !0, ct.Fairfield = !0, ct["FF Scala"] = !0, ct.Folkard = !0, ct.Footlight = !0, ct.FreeSerif = !0, ct["Friz Quadrata"] = !0, ct.Garamond = !0, ct.Gentium = !0, ct.Georgia = !0, ct.Gloucester = !0, ct["Goudy Old Style"] = !0, ct["Goudy Schoolbook"] = !0, ct["Goudy Pro Font"] = !0, ct.Granjon = !0, ct["Guardian Egyptian"] = !0, ct.Heather = !0, ct.Hercules = !0, ct["High Tower Text"] = !0, ct.Hiroshige = !0, ct["Hoefler Text"] = !0, ct["Humana Serif"] = !0, ct.Imprint = !0, ct["Ionic No. 5"] = !0, ct.Janson = !0, ct.Joanna = !0, ct.Korinna = !0, ct.Lexicon = !0, ct.LiberationSerif = !0, ct["Liberation Serif"] = !0, ct["Linux Libertine"] = !0, ct.Literaturnaya = !0, ct.Lucida = !0, ct["Lucida Bright"] = !0, ct.Melior = !0, ct.Memphis = !0, ct.Miller = !0, ct.Minion = !0, ct.Modern = !0, ct["Mona Lisa"] = !0, ct["Mrs Eaves"] = !0, ct["MS Serif"] = !0, ct["Museo Slab"] = !0, ct["New York"] = !0, ct["Nimbus Roman"] = !0, ct["NPS Rawlinson Roadway"] = !0, ct.NuptialScript = !0, ct.Palatino = !0, ct.Perpetua = !0, ct.Plantin = !0, ct["Plantin Schoolbook"] = !0, ct.Playbill = !0, ct["Poor Richard"] = !0, ct["Rawlinson Roadway"] = !0, ct.Renault = !0, ct.Requiem = !0, ct.Rockwell = !0, ct.Roman = !0, ct["Rotis Serif"] = !0, ct.Sabon = !0, ct.Scala = !0, ct.Seagull = !0, ct.Sistina = !0, ct.Souvenir = !0, ct.STIX = !0, ct["Stone Informal"] = !0, ct["Stone Serif"] = !0, ct.Sylfaen = !0, ct.Times = !0, ct.Trajan = !0, ct.Trinité = !0, ct["Trump Mediaeval"] = !0, ct.Utopia = !0, ct["Vale Type"] = !0, ct["Bitstream Vera"] = !0, ct["Vera Serif"] = !0, ct.Versailles = !0, ct.Wanted = !0, ct.Weiss = !0, ct["Wide Latin"] = !0, ct.Windsor = !0, ct.XITS = !0;
          });
          at.getSerifFonts = ut;
          const ft = (0, rt.getLookupTableFactory)(function(ct) {
            ct.Dingbats = !0, ct.Symbol = !0, ct.ZapfDingbats = !0, ct.Wingdings = !0, ct["Wingdings-Bold"] = !0, ct["Wingdings-Regular"] = !0;
          });
          at.getSymbolsFonts = ft;
          const ht = (0, rt.getLookupTableFactory)(function(ct) {
            ct[2] = 10, ct[3] = 32, ct[4] = 33, ct[5] = 34, ct[6] = 35, ct[7] = 36, ct[8] = 37, ct[9] = 38, ct[10] = 39, ct[11] = 40, ct[12] = 41, ct[13] = 42, ct[14] = 43, ct[15] = 44, ct[16] = 45, ct[17] = 46, ct[18] = 47, ct[19] = 48, ct[20] = 49, ct[21] = 50, ct[22] = 51, ct[23] = 52, ct[24] = 53, ct[25] = 54, ct[26] = 55, ct[27] = 56, ct[28] = 57, ct[29] = 58, ct[30] = 894, ct[31] = 60, ct[32] = 61, ct[33] = 62, ct[34] = 63, ct[35] = 64, ct[36] = 65, ct[37] = 66, ct[38] = 67, ct[39] = 68, ct[40] = 69, ct[41] = 70, ct[42] = 71, ct[43] = 72, ct[44] = 73, ct[45] = 74, ct[46] = 75, ct[47] = 76, ct[48] = 77, ct[49] = 78, ct[50] = 79, ct[51] = 80, ct[52] = 81, ct[53] = 82, ct[54] = 83, ct[55] = 84, ct[56] = 85, ct[57] = 86, ct[58] = 87, ct[59] = 88, ct[60] = 89, ct[61] = 90, ct[62] = 91, ct[63] = 92, ct[64] = 93, ct[65] = 94, ct[66] = 95, ct[67] = 96, ct[68] = 97, ct[69] = 98, ct[70] = 99, ct[71] = 100, ct[72] = 101, ct[73] = 102, ct[74] = 103, ct[75] = 104, ct[76] = 105, ct[77] = 106, ct[78] = 107, ct[79] = 108, ct[80] = 109, ct[81] = 110, ct[82] = 111, ct[83] = 112, ct[84] = 113, ct[85] = 114, ct[86] = 115, ct[87] = 116, ct[88] = 117, ct[89] = 118, ct[90] = 119, ct[91] = 120, ct[92] = 121, ct[93] = 122, ct[94] = 123, ct[95] = 124, ct[96] = 125, ct[97] = 126, ct[98] = 196, ct[99] = 197, ct[100] = 199, ct[101] = 201, ct[102] = 209, ct[103] = 214, ct[104] = 220, ct[105] = 225, ct[106] = 224, ct[107] = 226, ct[108] = 228, ct[109] = 227, ct[110] = 229, ct[111] = 231, ct[112] = 233, ct[113] = 232, ct[114] = 234, ct[115] = 235, ct[116] = 237, ct[117] = 236, ct[118] = 238, ct[119] = 239, ct[120] = 241, ct[121] = 243, ct[122] = 242, ct[123] = 244, ct[124] = 246, ct[125] = 245, ct[126] = 250, ct[127] = 249, ct[128] = 251, ct[129] = 252, ct[130] = 8224, ct[131] = 176, ct[132] = 162, ct[133] = 163, ct[134] = 167, ct[135] = 8226, ct[136] = 182, ct[137] = 223, ct[138] = 174, ct[139] = 169, ct[140] = 8482, ct[141] = 180, ct[142] = 168, ct[143] = 8800, ct[144] = 198, ct[145] = 216, ct[146] = 8734, ct[147] = 177, ct[148] = 8804, ct[149] = 8805, ct[150] = 165, ct[151] = 181, ct[152] = 8706, ct[153] = 8721, ct[154] = 8719, ct[156] = 8747, ct[157] = 170, ct[158] = 186, ct[159] = 8486, ct[160] = 230, ct[161] = 248, ct[162] = 191, ct[163] = 161, ct[164] = 172, ct[165] = 8730, ct[166] = 402, ct[167] = 8776, ct[168] = 8710, ct[169] = 171, ct[170] = 187, ct[171] = 8230, ct[179] = 8220, ct[180] = 8221, ct[181] = 8216, ct[182] = 8217, ct[200] = 193, ct[203] = 205, ct[207] = 211, ct[210] = 218, ct[223] = 711, ct[224] = 321, ct[225] = 322, ct[226] = 352, ct[227] = 353, ct[228] = 381, ct[229] = 382, ct[233] = 221, ct[234] = 253, ct[252] = 263, ct[253] = 268, ct[254] = 269, ct[258] = 258, ct[260] = 260, ct[261] = 261, ct[265] = 280, ct[266] = 281, ct[267] = 282, ct[268] = 283, ct[269] = 313, ct[275] = 323, ct[276] = 324, ct[278] = 328, ct[283] = 344, ct[284] = 345, ct[285] = 346, ct[286] = 347, ct[292] = 367, ct[295] = 377, ct[296] = 378, ct[298] = 380, ct[305] = 963, ct[306] = 964, ct[307] = 966, ct[308] = 8215, ct[309] = 8252, ct[310] = 8319, ct[311] = 8359, ct[312] = 8592, ct[313] = 8593, ct[337] = 9552, ct[493] = 1039, ct[494] = 1040, ct[672] = 1488, ct[673] = 1489, ct[674] = 1490, ct[675] = 1491, ct[676] = 1492, ct[677] = 1493, ct[678] = 1494, ct[679] = 1495, ct[680] = 1496, ct[681] = 1497, ct[682] = 1498, ct[683] = 1499, ct[684] = 1500, ct[685] = 1501, ct[686] = 1502, ct[687] = 1503, ct[688] = 1504, ct[689] = 1505, ct[690] = 1506, ct[691] = 1507, ct[692] = 1508, ct[693] = 1509, ct[694] = 1510, ct[695] = 1511, ct[696] = 1512, ct[697] = 1513, ct[698] = 1514, ct[705] = 1524, ct[706] = 8362, ct[710] = 64288, ct[711] = 64298, ct[759] = 1617, ct[761] = 1776, ct[763] = 1778, ct[775] = 1652, ct[777] = 1764, ct[778] = 1780, ct[779] = 1781, ct[780] = 1782, ct[782] = 771, ct[783] = 64726, ct[786] = 8363, ct[788] = 8532, ct[790] = 768, ct[791] = 769, ct[792] = 768, ct[795] = 803, ct[797] = 64336, ct[798] = 64337, ct[799] = 64342, ct[800] = 64343, ct[801] = 64344, ct[802] = 64345, ct[803] = 64362, ct[804] = 64363, ct[805] = 64364, ct[2424] = 7821, ct[2425] = 7822, ct[2426] = 7823, ct[2427] = 7824, ct[2428] = 7825, ct[2429] = 7826, ct[2430] = 7827, ct[2433] = 7682, ct[2678] = 8045, ct[2679] = 8046, ct[2830] = 1552, ct[2838] = 686, ct[2840] = 751, ct[2842] = 753, ct[2843] = 754, ct[2844] = 755, ct[2846] = 757, ct[2856] = 767, ct[2857] = 848, ct[2858] = 849, ct[2862] = 853, ct[2863] = 854, ct[2864] = 855, ct[2865] = 861, ct[2866] = 862, ct[2906] = 7460, ct[2908] = 7462, ct[2909] = 7463, ct[2910] = 7464, ct[2912] = 7466, ct[2913] = 7467, ct[2914] = 7468, ct[2916] = 7470, ct[2917] = 7471, ct[2918] = 7472, ct[2920] = 7474, ct[2921] = 7475, ct[2922] = 7476, ct[2924] = 7478, ct[2925] = 7479, ct[2926] = 7480, ct[2928] = 7482, ct[2929] = 7483, ct[2930] = 7484, ct[2932] = 7486, ct[2933] = 7487, ct[2934] = 7488, ct[2936] = 7490, ct[2937] = 7491, ct[2938] = 7492, ct[2940] = 7494, ct[2941] = 7495, ct[2942] = 7496, ct[2944] = 7498, ct[2946] = 7500, ct[2948] = 7502, ct[2950] = 7504, ct[2951] = 7505, ct[2952] = 7506, ct[2954] = 7508, ct[2955] = 7509, ct[2956] = 7510, ct[2958] = 7512, ct[2959] = 7513, ct[2960] = 7514, ct[2962] = 7516, ct[2963] = 7517, ct[2964] = 7518, ct[2966] = 7520, ct[2967] = 7521, ct[2968] = 7522, ct[2970] = 7524, ct[2971] = 7525, ct[2972] = 7526, ct[2974] = 7528, ct[2975] = 7529, ct[2976] = 7530, ct[2978] = 1537, ct[2979] = 1538, ct[2980] = 1539, ct[2982] = 1549, ct[2983] = 1551, ct[2984] = 1552, ct[2986] = 1554, ct[2987] = 1555, ct[2988] = 1556, ct[2990] = 1623, ct[2991] = 1624, ct[2995] = 1775, ct[2999] = 1791, ct[3002] = 64290, ct[3003] = 64291, ct[3004] = 64292, ct[3006] = 64294, ct[3007] = 64295, ct[3008] = 64296, ct[3011] = 1900, ct[3014] = 8223, ct[3015] = 8244, ct[3017] = 7532, ct[3018] = 7533, ct[3019] = 7534, ct[3075] = 7590, ct[3076] = 7591, ct[3079] = 7594, ct[3080] = 7595, ct[3083] = 7598, ct[3084] = 7599, ct[3087] = 7602, ct[3088] = 7603, ct[3091] = 7606, ct[3092] = 7607, ct[3095] = 7610, ct[3096] = 7611, ct[3099] = 7614, ct[3100] = 7615, ct[3103] = 7618, ct[3104] = 7619, ct[3107] = 8337, ct[3108] = 8338, ct[3116] = 1884, ct[3119] = 1885, ct[3120] = 1885, ct[3123] = 1886, ct[3124] = 1886, ct[3127] = 1887, ct[3128] = 1887, ct[3131] = 1888, ct[3132] = 1888, ct[3135] = 1889, ct[3136] = 1889, ct[3139] = 1890, ct[3140] = 1890, ct[3143] = 1891, ct[3144] = 1891, ct[3147] = 1892, ct[3148] = 1892, ct[3153] = 580, ct[3154] = 581, ct[3157] = 584, ct[3158] = 585, ct[3161] = 588, ct[3162] = 589, ct[3165] = 891, ct[3166] = 892, ct[3169] = 1274, ct[3170] = 1275, ct[3173] = 1278, ct[3174] = 1279, ct[3181] = 7622, ct[3182] = 7623, ct[3282] = 11799, ct[3316] = 578, ct[3379] = 42785, ct[3393] = 1159, ct[3416] = 8377;
          });
          at.getGlyphMapForStandardFonts = ht;
          const dt = (0, rt.getLookupTableFactory)(function(ct) {
            ct[227] = 322, ct[264] = 261, ct[291] = 346;
          });
          at.getSupplementalGlyphMapForArialBlack = dt;
          const gt = (0, rt.getLookupTableFactory)(function(ct) {
            ct[1] = 32, ct[4] = 65, ct[5] = 192, ct[6] = 193, ct[9] = 196, ct[17] = 66, ct[18] = 67, ct[21] = 268, ct[24] = 68, ct[28] = 69, ct[29] = 200, ct[30] = 201, ct[32] = 282, ct[38] = 70, ct[39] = 71, ct[44] = 72, ct[47] = 73, ct[48] = 204, ct[49] = 205, ct[58] = 74, ct[60] = 75, ct[62] = 76, ct[68] = 77, ct[69] = 78, ct[75] = 79, ct[76] = 210, ct[80] = 214, ct[87] = 80, ct[89] = 81, ct[90] = 82, ct[92] = 344, ct[94] = 83, ct[97] = 352, ct[100] = 84, ct[104] = 85, ct[109] = 220, ct[115] = 86, ct[116] = 87, ct[121] = 88, ct[122] = 89, ct[124] = 221, ct[127] = 90, ct[129] = 381, ct[258] = 97, ct[259] = 224, ct[260] = 225, ct[263] = 228, ct[268] = 261, ct[271] = 98, ct[272] = 99, ct[273] = 263, ct[275] = 269, ct[282] = 100, ct[286] = 101, ct[287] = 232, ct[288] = 233, ct[290] = 283, ct[295] = 281, ct[296] = 102, ct[336] = 103, ct[346] = 104, ct[349] = 105, ct[350] = 236, ct[351] = 237, ct[361] = 106, ct[364] = 107, ct[367] = 108, ct[371] = 322, ct[373] = 109, ct[374] = 110, ct[381] = 111, ct[382] = 242, ct[383] = 243, ct[386] = 246, ct[393] = 112, ct[395] = 113, ct[396] = 114, ct[398] = 345, ct[400] = 115, ct[401] = 347, ct[403] = 353, ct[410] = 116, ct[437] = 117, ct[442] = 252, ct[448] = 118, ct[449] = 119, ct[454] = 120, ct[455] = 121, ct[457] = 253, ct[460] = 122, ct[462] = 382, ct[463] = 380, ct[853] = 44, ct[855] = 58, ct[856] = 46, ct[876] = 47, ct[878] = 45, ct[882] = 45, ct[894] = 40, ct[895] = 41, ct[896] = 91, ct[897] = 93, ct[923] = 64, ct[1004] = 48, ct[1005] = 49, ct[1006] = 50, ct[1007] = 51, ct[1008] = 52, ct[1009] = 53, ct[1010] = 54, ct[1011] = 55, ct[1012] = 56, ct[1013] = 57, ct[1081] = 37, ct[1085] = 43, ct[1086] = 45;
          });
          at.getSupplementalGlyphMapForCalibri = gt;
          function pt(ct) {
            const vt = (0, st.normalizeFontName)(ct);
            return lt()[vt];
          }
          function mt(ct) {
            const vt = (0, st.normalizeFontName)(ct);
            return !!(lt()[vt] || it()[vt] || ut()[vt] || ft()[vt]);
          }
        },
        /* 193 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.ToUnicodeMap = at.IdentityToUnicodeMap = void 0;
          var rt = ot(145);
          class st {
            constructor() {
              let it = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
              this._map = it;
            }
            get length() {
              return this._map.length;
            }
            forEach(it) {
              for (const ut in this._map)
                it(ut, this._map[ut].charCodeAt(0));
            }
            has(it) {
              return this._map[it] !== void 0;
            }
            get(it) {
              return this._map[it];
            }
            charCodeOf(it) {
              const ut = this._map;
              if (ut.length <= 65536)
                return ut.indexOf(it);
              for (const ft in ut)
                if (ut[ft] === it)
                  return ft | 0;
              return -1;
            }
            amend(it) {
              for (const ut in it)
                this._map[ut] = it[ut];
            }
          }
          at.ToUnicodeMap = st;
          class lt {
            constructor(it, ut) {
              this.firstChar = it, this.lastChar = ut;
            }
            get length() {
              return this.lastChar + 1 - this.firstChar;
            }
            forEach(it) {
              for (let ut = this.firstChar, ft = this.lastChar; ut <= ft; ut++)
                it(ut, ut);
            }
            has(it) {
              return this.firstChar <= it && it <= this.lastChar;
            }
            get(it) {
              if (this.firstChar <= it && it <= this.lastChar)
                return String.fromCharCode(it);
            }
            charCodeOf(it) {
              return Number.isInteger(it) && it >= this.firstChar && it <= this.lastChar ? it : -1;
            }
            amend(it) {
              (0, rt.unreachable)("Should not call amend()");
            }
          }
          at.IdentityToUnicodeMap = lt;
        },
        /* 194 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.CFFFont = void 0;
          var rt = ot(186), st = ot(189), lt = ot(145);
          class et {
            constructor(ut, ft) {
              this.properties = ft;
              const ht = new rt.CFFParser(ut, ft, st.SEAC_ANALYSIS_ENABLED);
              this.cff = ht.parse(), this.cff.duplicateFirstGlyph();
              const dt = new rt.CFFCompiler(this.cff);
              this.seacs = this.cff.seacs;
              try {
                this.data = dt.compile();
              } catch {
                (0, lt.warn)("Failed to compile font " + ft.loadedName), this.data = ut;
              }
              this._createBuiltInEncoding();
            }
            get numGlyphs() {
              return this.cff.charStrings.count;
            }
            getCharset() {
              return this.cff.charset.charset;
            }
            getGlyphMapping() {
              const ut = this.cff, ft = this.properties, {
                cidToGidMap: ht,
                cMap: dt
              } = ft, gt = ut.charset.charset;
              let pt, mt;
              if (ft.composite) {
                let vt;
                if ((ht == null ? void 0 : ht.length) > 0) {
                  vt = /* @__PURE__ */ Object.create(null);
                  for (let xt = 0, bt = ht.length; xt < bt; xt++) {
                    const Et = ht[xt];
                    Et !== void 0 && (vt[Et] = xt);
                  }
                }
                pt = /* @__PURE__ */ Object.create(null);
                let At;
                if (ut.isCIDFont)
                  for (mt = 0; mt < gt.length; mt++) {
                    const xt = gt[mt];
                    At = dt.charCodeOf(xt), (vt == null ? void 0 : vt[At]) !== void 0 && (At = vt[At]), pt[At] = mt;
                  }
                else
                  for (mt = 0; mt < ut.charStrings.count; mt++)
                    At = dt.charCodeOf(mt), pt[At] = mt;
                return pt;
              }
              let ct = ut.encoding ? ut.encoding.encoding : null;
              return ft.isInternalFont && (ct = ft.defaultEncoding), pt = (0, st.type1FontGlyphMapping)(ft, ct, gt), pt;
            }
            hasGlyphId(ut) {
              return this.cff.hasGlyphId(ut);
            }
            _createBuiltInEncoding() {
              const {
                charset: ut,
                encoding: ft
              } = this.cff;
              if (!ut || !ft)
                return;
              const ht = ut.charset, dt = ft.encoding, gt = [];
              for (const pt in dt) {
                const mt = dt[pt];
                if (mt >= 0) {
                  const ct = ht[mt];
                  ct && (gt[pt] = ct);
                }
              }
              gt.length > 0 && (this.properties.builtInEncoding = gt);
            }
          }
          at.CFFFont = et;
        },
        /* 195 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.FontRendererFactory = void 0, ot(140), ot(158), ot(160), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(145), st = ot(186), lt = ot(190), et = ot(188), it = ot(155);
          function ut(wt, Ct) {
            return (wt[Ct] << 24 | wt[Ct + 1] << 16 | wt[Ct + 2] << 8 | wt[Ct + 3]) >>> 0;
          }
          function ft(wt, Ct) {
            return wt[Ct] << 8 | wt[Ct + 1];
          }
          function ht(wt, Ct) {
            return (wt[Ct] << 24 | wt[Ct + 1] << 16) >> 16;
          }
          function dt(wt, Ct) {
            return wt[Ct] << 24 >> 24;
          }
          function gt(wt, Ct) {
            return ht(wt, Ct) / 16384;
          }
          function pt(wt) {
            const Ct = wt.length;
            let It = 32768;
            return Ct < 1240 ? It = 107 : Ct < 33900 && (It = 1131), It;
          }
          function mt(wt, Ct, It) {
            const yt = ft(wt, Ct + 2) === 1 ? ut(wt, Ct + 8) : ut(wt, Ct + 16), Rt = ft(wt, Ct + yt);
            let kt, jt, Ht;
            if (Rt === 4) {
              ft(wt, Ct + yt + 2);
              const Ft = ft(wt, Ct + yt + 6) >> 1;
              for (jt = Ct + yt + 14, kt = [], Ht = 0; Ht < Ft; Ht++, jt += 2)
                kt[Ht] = {
                  end: ft(wt, jt)
                };
              for (jt += 2, Ht = 0; Ht < Ft; Ht++, jt += 2)
                kt[Ht].start = ft(wt, jt);
              for (Ht = 0; Ht < Ft; Ht++, jt += 2)
                kt[Ht].idDelta = ft(wt, jt);
              for (Ht = 0; Ht < Ft; Ht++, jt += 2) {
                let _t = ft(wt, jt);
                if (_t !== 0) {
                  kt[Ht].ids = [];
                  for (let Nt = 0, Mt = kt[Ht].end - kt[Ht].start + 1; Nt < Mt; Nt++)
                    kt[Ht].ids[Nt] = ft(wt, jt + _t), _t += 2;
                }
              }
              return kt;
            } else if (Rt === 12) {
              const Ft = ut(wt, Ct + yt + 12);
              for (jt = Ct + yt + 16, kt = [], Ht = 0; Ht < Ft; Ht++)
                Ct = ut(wt, jt), kt.push({
                  start: Ct,
                  end: ut(wt, jt + 4),
                  idDelta: ut(wt, jt + 8) - Ct
                }), jt += 12;
              return kt;
            }
            throw new rt.FormatError(`unsupported cmap: ${Rt}`);
          }
          function ct(wt, Ct, It, yt) {
            var Ht, Ft, _t;
            const Rt = {}, jt = new st.CFFParser(new it.Stream(wt, Ct, It - Ct), Rt, yt).parse();
            return {
              glyphs: jt.charStrings.objects,
              subrs: (Ft = (Ht = jt.topDict.privateDict) == null ? void 0 : Ht.subrsIndex) == null ? void 0 : Ft.objects,
              gsubrs: (_t = jt.globalSubrIndex) == null ? void 0 : _t.objects,
              isCFFCIDFont: jt.isCIDFont,
              fdSelect: jt.fdSelect,
              fdArray: jt.fdArray
            };
          }
          function vt(wt, Ct, It) {
            let yt, Rt;
            It ? (yt = 4, Rt = ut) : (yt = 2, Rt = (Ht, Ft) => 2 * ft(Ht, Ft));
            const kt = [];
            let jt = Rt(Ct, 0);
            for (let Ht = yt; Ht < Ct.length; Ht += yt) {
              const Ft = Rt(Ct, Ht);
              kt.push(wt.subarray(jt, Ft)), jt = Ft;
            }
            return kt;
          }
          function At(wt, Ct) {
            const It = Ct.codePointAt(0);
            let yt = 0, Rt = 0, kt = wt.length - 1;
            for (; Rt < kt; ) {
              const jt = Rt + kt + 1 >> 1;
              It < wt[jt].start ? kt = jt - 1 : Rt = jt;
            }
            return wt[Rt].start <= It && It <= wt[Rt].end && (yt = wt[Rt].idDelta + (wt[Rt].ids ? wt[Rt].ids[It - wt[Rt].start] : It) & 65535), {
              charCode: It,
              glyphId: yt
            };
          }
          function xt(wt, Ct, It) {
            function yt(Mt, Lt) {
              Ct.push({
                cmd: "moveTo",
                args: [Mt, Lt]
              });
            }
            function Rt(Mt, Lt) {
              Ct.push({
                cmd: "lineTo",
                args: [Mt, Lt]
              });
            }
            function kt(Mt, Lt, $t, Tt) {
              Ct.push({
                cmd: "quadraticCurveTo",
                args: [Mt, Lt, $t, Tt]
              });
            }
            let jt = 0;
            const Ht = ht(wt, jt);
            let Ft, _t = 0, Nt = 0;
            if (jt += 10, Ht < 0)
              do {
                Ft = ft(wt, jt);
                const Mt = ft(wt, jt + 2);
                jt += 4;
                let Lt, $t;
                Ft & 1 ? (Ft & 2 ? (Lt = ht(wt, jt), $t = ht(wt, jt + 2)) : (Lt = ft(wt, jt), $t = ft(wt, jt + 2)), jt += 4) : Ft & 2 ? (Lt = dt(wt, jt++), $t = dt(wt, jt++)) : (Lt = wt[jt++], $t = wt[jt++]), Ft & 2 ? (_t = Lt, Nt = $t) : (_t = 0, Nt = 0);
                let Tt = 1, Dt = 1, Ut = 0, Vt = 0;
                Ft & 8 ? (Tt = Dt = gt(wt, jt), jt += 2) : Ft & 64 ? (Tt = gt(wt, jt), Dt = gt(wt, jt + 2), jt += 4) : Ft & 128 && (Tt = gt(wt, jt), Ut = gt(wt, jt + 2), Vt = gt(wt, jt + 4), Dt = gt(wt, jt + 6), jt += 8);
                const Qt = It.glyphs[Mt];
                Qt && (Ct.push({
                  cmd: "save"
                }, {
                  cmd: "transform",
                  args: [Tt, Ut, Vt, Dt, _t, Nt]
                }), xt(Qt, Ct, It), Ct.push({
                  cmd: "restore"
                }));
              } while (Ft & 32);
            else {
              const Mt = [];
              let Lt, $t;
              for (Lt = 0; Lt < Ht; Lt++)
                Mt.push(ft(wt, jt)), jt += 2;
              const Tt = ft(wt, jt);
              jt += 2 + Tt;
              const Dt = Mt.at(-1) + 1, Ut = [];
              for (; Ut.length < Dt; ) {
                Ft = wt[jt++];
                let Qt = 1;
                for (Ft & 8 && (Qt += wt[jt++]); Qt-- > 0; )
                  Ut.push({
                    flags: Ft
                  });
              }
              for (Lt = 0; Lt < Dt; Lt++) {
                switch (Ut[Lt].flags & 18) {
                  case 0:
                    _t += ht(wt, jt), jt += 2;
                    break;
                  case 2:
                    _t -= wt[jt++];
                    break;
                  case 18:
                    _t += wt[jt++];
                    break;
                }
                Ut[Lt].x = _t;
              }
              for (Lt = 0; Lt < Dt; Lt++) {
                switch (Ut[Lt].flags & 36) {
                  case 0:
                    Nt += ht(wt, jt), jt += 2;
                    break;
                  case 4:
                    Nt -= wt[jt++];
                    break;
                  case 36:
                    Nt += wt[jt++];
                    break;
                }
                Ut[Lt].y = Nt;
              }
              let Vt = 0;
              for (jt = 0; jt < Ht; jt++) {
                const Qt = Mt[jt], qt = Ut.slice(Vt, Qt + 1);
                if (qt[0].flags & 1)
                  qt.push(qt[0]);
                else if (qt.at(-1).flags & 1)
                  qt.unshift(qt.at(-1));
                else {
                  const Zt = {
                    flags: 1,
                    x: (qt[0].x + qt.at(-1).x) / 2,
                    y: (qt[0].y + qt.at(-1).y) / 2
                  };
                  qt.unshift(Zt), qt.push(Zt);
                }
                for (yt(qt[0].x, qt[0].y), Lt = 1, $t = qt.length; Lt < $t; Lt++)
                  qt[Lt].flags & 1 ? Rt(qt[Lt].x, qt[Lt].y) : qt[Lt + 1].flags & 1 ? (kt(qt[Lt].x, qt[Lt].y, qt[Lt + 1].x, qt[Lt + 1].y), Lt++) : kt(qt[Lt].x, qt[Lt].y, (qt[Lt].x + qt[Lt + 1].x) / 2, (qt[Lt].y + qt[Lt + 1].y) / 2);
                Vt = Qt + 1;
              }
            }
          }
          function bt(wt, Ct, It, yt) {
            function Rt(Lt, $t) {
              Ct.push({
                cmd: "moveTo",
                args: [Lt, $t]
              });
            }
            function kt(Lt, $t) {
              Ct.push({
                cmd: "lineTo",
                args: [Lt, $t]
              });
            }
            function jt(Lt, $t, Tt, Dt, Ut, Vt) {
              Ct.push({
                cmd: "bezierCurveTo",
                args: [Lt, $t, Tt, Dt, Ut, Vt]
              });
            }
            const Ht = [];
            let Ft = 0, _t = 0, Nt = 0;
            function Mt(Lt) {
              var Tt;
              let $t = 0;
              for (; $t < Lt.length; ) {
                let Dt = !1, Ut = Lt[$t++], Vt, Qt, qt, Zt, ar, Jt, rr, Yt, Kt;
                switch (Ut) {
                  case 1:
                    Nt += Ht.length >> 1, Dt = !0;
                    break;
                  case 3:
                    Nt += Ht.length >> 1, Dt = !0;
                    break;
                  case 4:
                    _t += Ht.pop(), Rt(Ft, _t), Dt = !0;
                    break;
                  case 5:
                    for (; Ht.length > 0; )
                      Ft += Ht.shift(), _t += Ht.shift(), kt(Ft, _t);
                    break;
                  case 6:
                    for (; Ht.length > 0 && (Ft += Ht.shift(), kt(Ft, _t), Ht.length !== 0); )
                      _t += Ht.shift(), kt(Ft, _t);
                    break;
                  case 7:
                    for (; Ht.length > 0 && (_t += Ht.shift(), kt(Ft, _t), Ht.length !== 0); )
                      Ft += Ht.shift(), kt(Ft, _t);
                    break;
                  case 8:
                    for (; Ht.length > 0; )
                      Vt = Ft + Ht.shift(), qt = _t + Ht.shift(), Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt + Ht.shift(), _t = Zt + Ht.shift(), jt(Vt, qt, Qt, Zt, Ft, _t);
                    break;
                  case 10:
                    if (Yt = Ht.pop(), Kt = null, It.isCFFCIDFont) {
                      const nr = It.fdSelect.getFDIndex(yt);
                      if (nr >= 0 && nr < It.fdArray.length) {
                        const tr = It.fdArray[nr];
                        let ir;
                        (Tt = tr.privateDict) != null && Tt.subrsIndex && (ir = tr.privateDict.subrsIndex.objects), ir && (Yt += pt(ir), Kt = ir[Yt]);
                      } else
                        (0, rt.warn)("Invalid fd index for glyph index.");
                    } else
                      Kt = It.subrs[Yt + It.subrsBias];
                    Kt && Mt(Kt);
                    break;
                  case 11:
                    return;
                  case 12:
                    switch (Ut = Lt[$t++], Ut) {
                      case 34:
                        Vt = Ft + Ht.shift(), Qt = Vt + Ht.shift(), ar = _t + Ht.shift(), Ft = Qt + Ht.shift(), jt(Vt, _t, Qt, ar, Ft, ar), Vt = Ft + Ht.shift(), Qt = Vt + Ht.shift(), Ft = Qt + Ht.shift(), jt(Vt, ar, Qt, _t, Ft, _t);
                        break;
                      case 35:
                        Vt = Ft + Ht.shift(), qt = _t + Ht.shift(), Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt + Ht.shift(), _t = Zt + Ht.shift(), jt(Vt, qt, Qt, Zt, Ft, _t), Vt = Ft + Ht.shift(), qt = _t + Ht.shift(), Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt + Ht.shift(), _t = Zt + Ht.shift(), jt(Vt, qt, Qt, Zt, Ft, _t), Ht.pop();
                        break;
                      case 36:
                        Vt = Ft + Ht.shift(), ar = _t + Ht.shift(), Qt = Vt + Ht.shift(), Jt = ar + Ht.shift(), Ft = Qt + Ht.shift(), jt(Vt, ar, Qt, Jt, Ft, Jt), Vt = Ft + Ht.shift(), Qt = Vt + Ht.shift(), rr = Jt + Ht.shift(), Ft = Qt + Ht.shift(), jt(Vt, Jt, Qt, rr, Ft, _t);
                        break;
                      case 37:
                        const nr = Ft, tr = _t;
                        Vt = Ft + Ht.shift(), qt = _t + Ht.shift(), Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt + Ht.shift(), _t = Zt + Ht.shift(), jt(Vt, qt, Qt, Zt, Ft, _t), Vt = Ft + Ht.shift(), qt = _t + Ht.shift(), Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt, _t = Zt, Math.abs(Ft - nr) > Math.abs(_t - tr) ? Ft += Ht.shift() : _t += Ht.shift(), jt(Vt, qt, Qt, Zt, Ft, _t);
                        break;
                      default:
                        throw new rt.FormatError(`unknown operator: 12 ${Ut}`);
                    }
                    break;
                  case 14:
                    if (Ht.length >= 4) {
                      const nr = Ht.pop(), tr = Ht.pop();
                      _t = Ht.pop(), Ft = Ht.pop(), Ct.push({
                        cmd: "save"
                      }, {
                        cmd: "translate",
                        args: [Ft, _t]
                      });
                      let ir = At(It.cmap, String.fromCharCode(It.glyphNameMap[et.StandardEncoding[nr]]));
                      bt(It.glyphs[ir.glyphId], Ct, It, ir.glyphId), Ct.push({
                        cmd: "restore"
                      }), ir = At(It.cmap, String.fromCharCode(It.glyphNameMap[et.StandardEncoding[tr]])), bt(It.glyphs[ir.glyphId], Ct, It, ir.glyphId);
                    }
                    return;
                  case 18:
                    Nt += Ht.length >> 1, Dt = !0;
                    break;
                  case 19:
                    Nt += Ht.length >> 1, $t += Nt + 7 >> 3, Dt = !0;
                    break;
                  case 20:
                    Nt += Ht.length >> 1, $t += Nt + 7 >> 3, Dt = !0;
                    break;
                  case 21:
                    _t += Ht.pop(), Ft += Ht.pop(), Rt(Ft, _t), Dt = !0;
                    break;
                  case 22:
                    Ft += Ht.pop(), Rt(Ft, _t), Dt = !0;
                    break;
                  case 23:
                    Nt += Ht.length >> 1, Dt = !0;
                    break;
                  case 24:
                    for (; Ht.length > 2; )
                      Vt = Ft + Ht.shift(), qt = _t + Ht.shift(), Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt + Ht.shift(), _t = Zt + Ht.shift(), jt(Vt, qt, Qt, Zt, Ft, _t);
                    Ft += Ht.shift(), _t += Ht.shift(), kt(Ft, _t);
                    break;
                  case 25:
                    for (; Ht.length > 6; )
                      Ft += Ht.shift(), _t += Ht.shift(), kt(Ft, _t);
                    Vt = Ft + Ht.shift(), qt = _t + Ht.shift(), Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt + Ht.shift(), _t = Zt + Ht.shift(), jt(Vt, qt, Qt, Zt, Ft, _t);
                    break;
                  case 26:
                    for (Ht.length % 2 && (Ft += Ht.shift()); Ht.length > 0; )
                      Vt = Ft, qt = _t + Ht.shift(), Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt, _t = Zt + Ht.shift(), jt(Vt, qt, Qt, Zt, Ft, _t);
                    break;
                  case 27:
                    for (Ht.length % 2 && (_t += Ht.shift()); Ht.length > 0; )
                      Vt = Ft + Ht.shift(), qt = _t, Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt + Ht.shift(), _t = Zt, jt(Vt, qt, Qt, Zt, Ft, _t);
                    break;
                  case 28:
                    Ht.push((Lt[$t] << 24 | Lt[$t + 1] << 16) >> 16), $t += 2;
                    break;
                  case 29:
                    Yt = Ht.pop() + It.gsubrsBias, Kt = It.gsubrs[Yt], Kt && Mt(Kt);
                    break;
                  case 30:
                    for (; Ht.length > 0 && (Vt = Ft, qt = _t + Ht.shift(), Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt + Ht.shift(), _t = Zt + (Ht.length === 1 ? Ht.shift() : 0), jt(Vt, qt, Qt, Zt, Ft, _t), Ht.length !== 0); )
                      Vt = Ft + Ht.shift(), qt = _t, Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), _t = Zt + Ht.shift(), Ft = Qt + (Ht.length === 1 ? Ht.shift() : 0), jt(Vt, qt, Qt, Zt, Ft, _t);
                    break;
                  case 31:
                    for (; Ht.length > 0 && (Vt = Ft + Ht.shift(), qt = _t, Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), _t = Zt + Ht.shift(), Ft = Qt + (Ht.length === 1 ? Ht.shift() : 0), jt(Vt, qt, Qt, Zt, Ft, _t), Ht.length !== 0); )
                      Vt = Ft, qt = _t + Ht.shift(), Qt = Vt + Ht.shift(), Zt = qt + Ht.shift(), Ft = Qt + Ht.shift(), _t = Zt + (Ht.length === 1 ? Ht.shift() : 0), jt(Vt, qt, Qt, Zt, Ft, _t);
                    break;
                  default:
                    if (Ut < 32)
                      throw new rt.FormatError(`unknown operator: ${Ut}`);
                    Ut < 247 ? Ht.push(Ut - 139) : Ut < 251 ? Ht.push((Ut - 247) * 256 + Lt[$t++] + 108) : Ut < 255 ? Ht.push(-(Ut - 251) * 256 - Lt[$t++] - 108) : (Ht.push((Lt[$t] << 24 | Lt[$t + 1] << 16 | Lt[$t + 2] << 8 | Lt[$t + 3]) / 65536), $t += 4);
                    break;
                }
                Dt && (Ht.length = 0);
              }
            }
            Mt(wt);
          }
          const Et = [];
          class St {
            constructor(Ct) {
              this.constructor === St && (0, rt.unreachable)("Cannot initialize CompiledFont."), this.fontMatrix = Ct, this.compiledGlyphs = /* @__PURE__ */ Object.create(null), this.compiledCharCodeToGlyphId = /* @__PURE__ */ Object.create(null);
            }
            getPathJs(Ct) {
              const {
                charCode: It,
                glyphId: yt
              } = At(this.cmap, Ct);
              let Rt = this.compiledGlyphs[yt];
              if (!Rt)
                try {
                  Rt = this.compileGlyph(this.glyphs[yt], yt), this.compiledGlyphs[yt] = Rt;
                } catch (kt) {
                  throw this.compiledGlyphs[yt] = Et, this.compiledCharCodeToGlyphId[It] === void 0 && (this.compiledCharCodeToGlyphId[It] = yt), kt;
                }
              return this.compiledCharCodeToGlyphId[It] === void 0 && (this.compiledCharCodeToGlyphId[It] = yt), Rt;
            }
            compileGlyph(Ct, It) {
              if (!Ct || Ct.length === 0 || Ct[0] === 14)
                return Et;
              let yt = this.fontMatrix;
              if (this.isCFFCIDFont) {
                const kt = this.fdSelect.getFDIndex(It);
                kt >= 0 && kt < this.fdArray.length ? yt = this.fdArray[kt].getByName("FontMatrix") || rt.FONT_IDENTITY_MATRIX : (0, rt.warn)("Invalid fd index for glyph index.");
              }
              const Rt = [{
                cmd: "save"
              }, {
                cmd: "transform",
                args: yt.slice()
              }, {
                cmd: "scale",
                args: ["size", "-size"]
              }];
              return this.compileGlyphImpl(Ct, Rt, It), Rt.push({
                cmd: "restore"
              }), Rt;
            }
            compileGlyphImpl() {
              (0, rt.unreachable)("Children classes should implement this.");
            }
            hasBuiltPath(Ct) {
              const {
                charCode: It,
                glyphId: yt
              } = At(this.cmap, Ct);
              return this.compiledGlyphs[yt] !== void 0 && this.compiledCharCodeToGlyphId[It] !== void 0;
            }
          }
          class Bt extends St {
            constructor(Ct, It, yt) {
              super(yt || [488e-6, 0, 0, 488e-6, 0, 0]), this.glyphs = Ct, this.cmap = It;
            }
            compileGlyphImpl(Ct, It) {
              xt(Ct, It, this);
            }
          }
          class Ot extends St {
            constructor(Ct, It, yt, Rt) {
              super(yt || [1e-3, 0, 0, 1e-3, 0, 0]), this.glyphs = Ct.glyphs, this.gsubrs = Ct.gsubrs || [], this.subrs = Ct.subrs || [], this.cmap = It, this.glyphNameMap = Rt || (0, lt.getGlyphsUnicode)(), this.gsubrsBias = pt(this.gsubrs), this.subrsBias = pt(this.subrs), this.isCFFCIDFont = Ct.isCFFCIDFont, this.fdSelect = Ct.fdSelect, this.fdArray = Ct.fdArray;
            }
            compileGlyphImpl(Ct, It, yt) {
              bt(Ct, It, this, yt);
            }
          }
          class Pt {
            static create(Ct, It) {
              const yt = new Uint8Array(Ct.data);
              let Rt, kt, jt, Ht, Ft, _t;
              const Nt = ft(yt, 4);
              for (let Mt = 0, Lt = 12; Mt < Nt; Mt++, Lt += 16) {
                const $t = (0, rt.bytesToString)(yt.subarray(Lt, Lt + 4)), Tt = ut(yt, Lt + 8), Dt = ut(yt, Lt + 12);
                switch ($t) {
                  case "cmap":
                    Rt = mt(yt, Tt);
                    break;
                  case "glyf":
                    kt = yt.subarray(Tt, Tt + Dt);
                    break;
                  case "loca":
                    jt = yt.subarray(Tt, Tt + Dt);
                    break;
                  case "head":
                    _t = ft(yt, Tt + 18), Ft = ft(yt, Tt + 50);
                    break;
                  case "CFF ":
                    Ht = ct(yt, Tt, Tt + Dt, It);
                    break;
                }
              }
              if (kt) {
                const Mt = _t ? [1 / _t, 0, 0, 1 / _t, 0, 0] : Ct.fontMatrix;
                return new Bt(vt(kt, jt, Ft), Rt, Mt);
              }
              return new Ot(Ht, Rt, Ct.fontMatrix, Ct.glyphNameMap);
            }
          }
          at.FontRendererFactory = Pt;
        },
        /* 196 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.getMetrics = at.getFontBasicMetrics = void 0;
          var rt = ot(150);
          const st = (0, rt.getLookupTableFactory)(function(et) {
            et.Courier = 600, et["Courier-Bold"] = 600, et["Courier-BoldOblique"] = 600, et["Courier-Oblique"] = 600, et.Helvetica = (0, rt.getLookupTableFactory)(function(it) {
              it.space = 278, it.exclam = 278, it.quotedbl = 355, it.numbersign = 556, it.dollar = 556, it.percent = 889, it.ampersand = 667, it.quoteright = 222, it.parenleft = 333, it.parenright = 333, it.asterisk = 389, it.plus = 584, it.comma = 278, it.hyphen = 333, it.period = 278, it.slash = 278, it.zero = 556, it.one = 556, it.two = 556, it.three = 556, it.four = 556, it.five = 556, it.six = 556, it.seven = 556, it.eight = 556, it.nine = 556, it.colon = 278, it.semicolon = 278, it.less = 584, it.equal = 584, it.greater = 584, it.question = 556, it.at = 1015, it.A = 667, it.B = 667, it.C = 722, it.D = 722, it.E = 667, it.F = 611, it.G = 778, it.H = 722, it.I = 278, it.J = 500, it.K = 667, it.L = 556, it.M = 833, it.N = 722, it.O = 778, it.P = 667, it.Q = 778, it.R = 722, it.S = 667, it.T = 611, it.U = 722, it.V = 667, it.W = 944, it.X = 667, it.Y = 667, it.Z = 611, it.bracketleft = 278, it.backslash = 278, it.bracketright = 278, it.asciicircum = 469, it.underscore = 556, it.quoteleft = 222, it.a = 556, it.b = 556, it.c = 500, it.d = 556, it.e = 556, it.f = 278, it.g = 556, it.h = 556, it.i = 222, it.j = 222, it.k = 500, it.l = 222, it.m = 833, it.n = 556, it.o = 556, it.p = 556, it.q = 556, it.r = 333, it.s = 500, it.t = 278, it.u = 556, it.v = 500, it.w = 722, it.x = 500, it.y = 500, it.z = 500, it.braceleft = 334, it.bar = 260, it.braceright = 334, it.asciitilde = 584, it.exclamdown = 333, it.cent = 556, it.sterling = 556, it.fraction = 167, it.yen = 556, it.florin = 556, it.section = 556, it.currency = 556, it.quotesingle = 191, it.quotedblleft = 333, it.guillemotleft = 556, it.guilsinglleft = 333, it.guilsinglright = 333, it.fi = 500, it.fl = 500, it.endash = 556, it.dagger = 556, it.daggerdbl = 556, it.periodcentered = 278, it.paragraph = 537, it.bullet = 350, it.quotesinglbase = 222, it.quotedblbase = 333, it.quotedblright = 333, it.guillemotright = 556, it.ellipsis = 1e3, it.perthousand = 1e3, it.questiondown = 611, it.grave = 333, it.acute = 333, it.circumflex = 333, it.tilde = 333, it.macron = 333, it.breve = 333, it.dotaccent = 333, it.dieresis = 333, it.ring = 333, it.cedilla = 333, it.hungarumlaut = 333, it.ogonek = 333, it.caron = 333, it.emdash = 1e3, it.AE = 1e3, it.ordfeminine = 370, it.Lslash = 556, it.Oslash = 778, it.OE = 1e3, it.ordmasculine = 365, it.ae = 889, it.dotlessi = 278, it.lslash = 222, it.oslash = 611, it.oe = 944, it.germandbls = 611, it.Idieresis = 278, it.eacute = 556, it.abreve = 556, it.uhungarumlaut = 556, it.ecaron = 556, it.Ydieresis = 667, it.divide = 584, it.Yacute = 667, it.Acircumflex = 667, it.aacute = 556, it.Ucircumflex = 722, it.yacute = 500, it.scommaaccent = 500, it.ecircumflex = 556, it.Uring = 722, it.Udieresis = 722, it.aogonek = 556, it.Uacute = 722, it.uogonek = 556, it.Edieresis = 667, it.Dcroat = 722, it.commaaccent = 250, it.copyright = 737, it.Emacron = 667, it.ccaron = 500, it.aring = 556, it.Ncommaaccent = 722, it.lacute = 222, it.agrave = 556, it.Tcommaaccent = 611, it.Cacute = 722, it.atilde = 556, it.Edotaccent = 667, it.scaron = 500, it.scedilla = 500, it.iacute = 278, it.lozenge = 471, it.Rcaron = 722, it.Gcommaaccent = 778, it.ucircumflex = 556, it.acircumflex = 556, it.Amacron = 667, it.rcaron = 333, it.ccedilla = 500, it.Zdotaccent = 611, it.Thorn = 667, it.Omacron = 778, it.Racute = 722, it.Sacute = 667, it.dcaron = 643, it.Umacron = 722, it.uring = 556, it.threesuperior = 333, it.Ograve = 778, it.Agrave = 667, it.Abreve = 667, it.multiply = 584, it.uacute = 556, it.Tcaron = 611, it.partialdiff = 476, it.ydieresis = 500, it.Nacute = 722, it.icircumflex = 278, it.Ecircumflex = 667, it.adieresis = 556, it.edieresis = 556, it.cacute = 500, it.nacute = 556, it.umacron = 556, it.Ncaron = 722, it.Iacute = 278, it.plusminus = 584, it.brokenbar = 260, it.registered = 737, it.Gbreve = 778, it.Idotaccent = 278, it.summation = 600, it.Egrave = 667, it.racute = 333, it.omacron = 556, it.Zacute = 611, it.Zcaron = 611, it.greaterequal = 549, it.Eth = 722, it.Ccedilla = 722, it.lcommaaccent = 222, it.tcaron = 317, it.eogonek = 556, it.Uogonek = 722, it.Aacute = 667, it.Adieresis = 667, it.egrave = 556, it.zacute = 500, it.iogonek = 222, it.Oacute = 778, it.oacute = 556, it.amacron = 556, it.sacute = 500, it.idieresis = 278, it.Ocircumflex = 778, it.Ugrave = 722, it.Delta = 612, it.thorn = 556, it.twosuperior = 333, it.Odieresis = 778, it.mu = 556, it.igrave = 278, it.ohungarumlaut = 556, it.Eogonek = 667, it.dcroat = 556, it.threequarters = 834, it.Scedilla = 667, it.lcaron = 299, it.Kcommaaccent = 667, it.Lacute = 556, it.trademark = 1e3, it.edotaccent = 556, it.Igrave = 278, it.Imacron = 278, it.Lcaron = 556, it.onehalf = 834, it.lessequal = 549, it.ocircumflex = 556, it.ntilde = 556, it.Uhungarumlaut = 722, it.Eacute = 667, it.emacron = 556, it.gbreve = 556, it.onequarter = 834, it.Scaron = 667, it.Scommaaccent = 667, it.Ohungarumlaut = 778, it.degree = 400, it.ograve = 556, it.Ccaron = 722, it.ugrave = 556, it.radical = 453, it.Dcaron = 722, it.rcommaaccent = 333, it.Ntilde = 722, it.otilde = 556, it.Rcommaaccent = 722, it.Lcommaaccent = 556, it.Atilde = 667, it.Aogonek = 667, it.Aring = 667, it.Otilde = 778, it.zdotaccent = 500, it.Ecaron = 667, it.Iogonek = 278, it.kcommaaccent = 500, it.minus = 584, it.Icircumflex = 278, it.ncaron = 556, it.tcommaaccent = 278, it.logicalnot = 584, it.odieresis = 556, it.udieresis = 556, it.notequal = 549, it.gcommaaccent = 556, it.eth = 556, it.zcaron = 500, it.ncommaaccent = 556, it.onesuperior = 333, it.imacron = 278, it.Euro = 556;
            }), et["Helvetica-Bold"] = (0, rt.getLookupTableFactory)(function(it) {
              it.space = 278, it.exclam = 333, it.quotedbl = 474, it.numbersign = 556, it.dollar = 556, it.percent = 889, it.ampersand = 722, it.quoteright = 278, it.parenleft = 333, it.parenright = 333, it.asterisk = 389, it.plus = 584, it.comma = 278, it.hyphen = 333, it.period = 278, it.slash = 278, it.zero = 556, it.one = 556, it.two = 556, it.three = 556, it.four = 556, it.five = 556, it.six = 556, it.seven = 556, it.eight = 556, it.nine = 556, it.colon = 333, it.semicolon = 333, it.less = 584, it.equal = 584, it.greater = 584, it.question = 611, it.at = 975, it.A = 722, it.B = 722, it.C = 722, it.D = 722, it.E = 667, it.F = 611, it.G = 778, it.H = 722, it.I = 278, it.J = 556, it.K = 722, it.L = 611, it.M = 833, it.N = 722, it.O = 778, it.P = 667, it.Q = 778, it.R = 722, it.S = 667, it.T = 611, it.U = 722, it.V = 667, it.W = 944, it.X = 667, it.Y = 667, it.Z = 611, it.bracketleft = 333, it.backslash = 278, it.bracketright = 333, it.asciicircum = 584, it.underscore = 556, it.quoteleft = 278, it.a = 556, it.b = 611, it.c = 556, it.d = 611, it.e = 556, it.f = 333, it.g = 611, it.h = 611, it.i = 278, it.j = 278, it.k = 556, it.l = 278, it.m = 889, it.n = 611, it.o = 611, it.p = 611, it.q = 611, it.r = 389, it.s = 556, it.t = 333, it.u = 611, it.v = 556, it.w = 778, it.x = 556, it.y = 556, it.z = 500, it.braceleft = 389, it.bar = 280, it.braceright = 389, it.asciitilde = 584, it.exclamdown = 333, it.cent = 556, it.sterling = 556, it.fraction = 167, it.yen = 556, it.florin = 556, it.section = 556, it.currency = 556, it.quotesingle = 238, it.quotedblleft = 500, it.guillemotleft = 556, it.guilsinglleft = 333, it.guilsinglright = 333, it.fi = 611, it.fl = 611, it.endash = 556, it.dagger = 556, it.daggerdbl = 556, it.periodcentered = 278, it.paragraph = 556, it.bullet = 350, it.quotesinglbase = 278, it.quotedblbase = 500, it.quotedblright = 500, it.guillemotright = 556, it.ellipsis = 1e3, it.perthousand = 1e3, it.questiondown = 611, it.grave = 333, it.acute = 333, it.circumflex = 333, it.tilde = 333, it.macron = 333, it.breve = 333, it.dotaccent = 333, it.dieresis = 333, it.ring = 333, it.cedilla = 333, it.hungarumlaut = 333, it.ogonek = 333, it.caron = 333, it.emdash = 1e3, it.AE = 1e3, it.ordfeminine = 370, it.Lslash = 611, it.Oslash = 778, it.OE = 1e3, it.ordmasculine = 365, it.ae = 889, it.dotlessi = 278, it.lslash = 278, it.oslash = 611, it.oe = 944, it.germandbls = 611, it.Idieresis = 278, it.eacute = 556, it.abreve = 556, it.uhungarumlaut = 611, it.ecaron = 556, it.Ydieresis = 667, it.divide = 584, it.Yacute = 667, it.Acircumflex = 722, it.aacute = 556, it.Ucircumflex = 722, it.yacute = 556, it.scommaaccent = 556, it.ecircumflex = 556, it.Uring = 722, it.Udieresis = 722, it.aogonek = 556, it.Uacute = 722, it.uogonek = 611, it.Edieresis = 667, it.Dcroat = 722, it.commaaccent = 250, it.copyright = 737, it.Emacron = 667, it.ccaron = 556, it.aring = 556, it.Ncommaaccent = 722, it.lacute = 278, it.agrave = 556, it.Tcommaaccent = 611, it.Cacute = 722, it.atilde = 556, it.Edotaccent = 667, it.scaron = 556, it.scedilla = 556, it.iacute = 278, it.lozenge = 494, it.Rcaron = 722, it.Gcommaaccent = 778, it.ucircumflex = 611, it.acircumflex = 556, it.Amacron = 722, it.rcaron = 389, it.ccedilla = 556, it.Zdotaccent = 611, it.Thorn = 667, it.Omacron = 778, it.Racute = 722, it.Sacute = 667, it.dcaron = 743, it.Umacron = 722, it.uring = 611, it.threesuperior = 333, it.Ograve = 778, it.Agrave = 722, it.Abreve = 722, it.multiply = 584, it.uacute = 611, it.Tcaron = 611, it.partialdiff = 494, it.ydieresis = 556, it.Nacute = 722, it.icircumflex = 278, it.Ecircumflex = 667, it.adieresis = 556, it.edieresis = 556, it.cacute = 556, it.nacute = 611, it.umacron = 611, it.Ncaron = 722, it.Iacute = 278, it.plusminus = 584, it.brokenbar = 280, it.registered = 737, it.Gbreve = 778, it.Idotaccent = 278, it.summation = 600, it.Egrave = 667, it.racute = 389, it.omacron = 611, it.Zacute = 611, it.Zcaron = 611, it.greaterequal = 549, it.Eth = 722, it.Ccedilla = 722, it.lcommaaccent = 278, it.tcaron = 389, it.eogonek = 556, it.Uogonek = 722, it.Aacute = 722, it.Adieresis = 722, it.egrave = 556, it.zacute = 500, it.iogonek = 278, it.Oacute = 778, it.oacute = 611, it.amacron = 556, it.sacute = 556, it.idieresis = 278, it.Ocircumflex = 778, it.Ugrave = 722, it.Delta = 612, it.thorn = 611, it.twosuperior = 333, it.Odieresis = 778, it.mu = 611, it.igrave = 278, it.ohungarumlaut = 611, it.Eogonek = 667, it.dcroat = 611, it.threequarters = 834, it.Scedilla = 667, it.lcaron = 400, it.Kcommaaccent = 722, it.Lacute = 611, it.trademark = 1e3, it.edotaccent = 556, it.Igrave = 278, it.Imacron = 278, it.Lcaron = 611, it.onehalf = 834, it.lessequal = 549, it.ocircumflex = 611, it.ntilde = 611, it.Uhungarumlaut = 722, it.Eacute = 667, it.emacron = 556, it.gbreve = 611, it.onequarter = 834, it.Scaron = 667, it.Scommaaccent = 667, it.Ohungarumlaut = 778, it.degree = 400, it.ograve = 611, it.Ccaron = 722, it.ugrave = 611, it.radical = 549, it.Dcaron = 722, it.rcommaaccent = 389, it.Ntilde = 722, it.otilde = 611, it.Rcommaaccent = 722, it.Lcommaaccent = 611, it.Atilde = 722, it.Aogonek = 722, it.Aring = 722, it.Otilde = 778, it.zdotaccent = 500, it.Ecaron = 667, it.Iogonek = 278, it.kcommaaccent = 556, it.minus = 584, it.Icircumflex = 278, it.ncaron = 611, it.tcommaaccent = 333, it.logicalnot = 584, it.odieresis = 611, it.udieresis = 611, it.notequal = 549, it.gcommaaccent = 611, it.eth = 611, it.zcaron = 500, it.ncommaaccent = 611, it.onesuperior = 333, it.imacron = 278, it.Euro = 556;
            }), et["Helvetica-BoldOblique"] = (0, rt.getLookupTableFactory)(function(it) {
              it.space = 278, it.exclam = 333, it.quotedbl = 474, it.numbersign = 556, it.dollar = 556, it.percent = 889, it.ampersand = 722, it.quoteright = 278, it.parenleft = 333, it.parenright = 333, it.asterisk = 389, it.plus = 584, it.comma = 278, it.hyphen = 333, it.period = 278, it.slash = 278, it.zero = 556, it.one = 556, it.two = 556, it.three = 556, it.four = 556, it.five = 556, it.six = 556, it.seven = 556, it.eight = 556, it.nine = 556, it.colon = 333, it.semicolon = 333, it.less = 584, it.equal = 584, it.greater = 584, it.question = 611, it.at = 975, it.A = 722, it.B = 722, it.C = 722, it.D = 722, it.E = 667, it.F = 611, it.G = 778, it.H = 722, it.I = 278, it.J = 556, it.K = 722, it.L = 611, it.M = 833, it.N = 722, it.O = 778, it.P = 667, it.Q = 778, it.R = 722, it.S = 667, it.T = 611, it.U = 722, it.V = 667, it.W = 944, it.X = 667, it.Y = 667, it.Z = 611, it.bracketleft = 333, it.backslash = 278, it.bracketright = 333, it.asciicircum = 584, it.underscore = 556, it.quoteleft = 278, it.a = 556, it.b = 611, it.c = 556, it.d = 611, it.e = 556, it.f = 333, it.g = 611, it.h = 611, it.i = 278, it.j = 278, it.k = 556, it.l = 278, it.m = 889, it.n = 611, it.o = 611, it.p = 611, it.q = 611, it.r = 389, it.s = 556, it.t = 333, it.u = 611, it.v = 556, it.w = 778, it.x = 556, it.y = 556, it.z = 500, it.braceleft = 389, it.bar = 280, it.braceright = 389, it.asciitilde = 584, it.exclamdown = 333, it.cent = 556, it.sterling = 556, it.fraction = 167, it.yen = 556, it.florin = 556, it.section = 556, it.currency = 556, it.quotesingle = 238, it.quotedblleft = 500, it.guillemotleft = 556, it.guilsinglleft = 333, it.guilsinglright = 333, it.fi = 611, it.fl = 611, it.endash = 556, it.dagger = 556, it.daggerdbl = 556, it.periodcentered = 278, it.paragraph = 556, it.bullet = 350, it.quotesinglbase = 278, it.quotedblbase = 500, it.quotedblright = 500, it.guillemotright = 556, it.ellipsis = 1e3, it.perthousand = 1e3, it.questiondown = 611, it.grave = 333, it.acute = 333, it.circumflex = 333, it.tilde = 333, it.macron = 333, it.breve = 333, it.dotaccent = 333, it.dieresis = 333, it.ring = 333, it.cedilla = 333, it.hungarumlaut = 333, it.ogonek = 333, it.caron = 333, it.emdash = 1e3, it.AE = 1e3, it.ordfeminine = 370, it.Lslash = 611, it.Oslash = 778, it.OE = 1e3, it.ordmasculine = 365, it.ae = 889, it.dotlessi = 278, it.lslash = 278, it.oslash = 611, it.oe = 944, it.germandbls = 611, it.Idieresis = 278, it.eacute = 556, it.abreve = 556, it.uhungarumlaut = 611, it.ecaron = 556, it.Ydieresis = 667, it.divide = 584, it.Yacute = 667, it.Acircumflex = 722, it.aacute = 556, it.Ucircumflex = 722, it.yacute = 556, it.scommaaccent = 556, it.ecircumflex = 556, it.Uring = 722, it.Udieresis = 722, it.aogonek = 556, it.Uacute = 722, it.uogonek = 611, it.Edieresis = 667, it.Dcroat = 722, it.commaaccent = 250, it.copyright = 737, it.Emacron = 667, it.ccaron = 556, it.aring = 556, it.Ncommaaccent = 722, it.lacute = 278, it.agrave = 556, it.Tcommaaccent = 611, it.Cacute = 722, it.atilde = 556, it.Edotaccent = 667, it.scaron = 556, it.scedilla = 556, it.iacute = 278, it.lozenge = 494, it.Rcaron = 722, it.Gcommaaccent = 778, it.ucircumflex = 611, it.acircumflex = 556, it.Amacron = 722, it.rcaron = 389, it.ccedilla = 556, it.Zdotaccent = 611, it.Thorn = 667, it.Omacron = 778, it.Racute = 722, it.Sacute = 667, it.dcaron = 743, it.Umacron = 722, it.uring = 611, it.threesuperior = 333, it.Ograve = 778, it.Agrave = 722, it.Abreve = 722, it.multiply = 584, it.uacute = 611, it.Tcaron = 611, it.partialdiff = 494, it.ydieresis = 556, it.Nacute = 722, it.icircumflex = 278, it.Ecircumflex = 667, it.adieresis = 556, it.edieresis = 556, it.cacute = 556, it.nacute = 611, it.umacron = 611, it.Ncaron = 722, it.Iacute = 278, it.plusminus = 584, it.brokenbar = 280, it.registered = 737, it.Gbreve = 778, it.Idotaccent = 278, it.summation = 600, it.Egrave = 667, it.racute = 389, it.omacron = 611, it.Zacute = 611, it.Zcaron = 611, it.greaterequal = 549, it.Eth = 722, it.Ccedilla = 722, it.lcommaaccent = 278, it.tcaron = 389, it.eogonek = 556, it.Uogonek = 722, it.Aacute = 722, it.Adieresis = 722, it.egrave = 556, it.zacute = 500, it.iogonek = 278, it.Oacute = 778, it.oacute = 611, it.amacron = 556, it.sacute = 556, it.idieresis = 278, it.Ocircumflex = 778, it.Ugrave = 722, it.Delta = 612, it.thorn = 611, it.twosuperior = 333, it.Odieresis = 778, it.mu = 611, it.igrave = 278, it.ohungarumlaut = 611, it.Eogonek = 667, it.dcroat = 611, it.threequarters = 834, it.Scedilla = 667, it.lcaron = 400, it.Kcommaaccent = 722, it.Lacute = 611, it.trademark = 1e3, it.edotaccent = 556, it.Igrave = 278, it.Imacron = 278, it.Lcaron = 611, it.onehalf = 834, it.lessequal = 549, it.ocircumflex = 611, it.ntilde = 611, it.Uhungarumlaut = 722, it.Eacute = 667, it.emacron = 556, it.gbreve = 611, it.onequarter = 834, it.Scaron = 667, it.Scommaaccent = 667, it.Ohungarumlaut = 778, it.degree = 400, it.ograve = 611, it.Ccaron = 722, it.ugrave = 611, it.radical = 549, it.Dcaron = 722, it.rcommaaccent = 389, it.Ntilde = 722, it.otilde = 611, it.Rcommaaccent = 722, it.Lcommaaccent = 611, it.Atilde = 722, it.Aogonek = 722, it.Aring = 722, it.Otilde = 778, it.zdotaccent = 500, it.Ecaron = 667, it.Iogonek = 278, it.kcommaaccent = 556, it.minus = 584, it.Icircumflex = 278, it.ncaron = 611, it.tcommaaccent = 333, it.logicalnot = 584, it.odieresis = 611, it.udieresis = 611, it.notequal = 549, it.gcommaaccent = 611, it.eth = 611, it.zcaron = 500, it.ncommaaccent = 611, it.onesuperior = 333, it.imacron = 278, it.Euro = 556;
            }), et["Helvetica-Oblique"] = (0, rt.getLookupTableFactory)(function(it) {
              it.space = 278, it.exclam = 278, it.quotedbl = 355, it.numbersign = 556, it.dollar = 556, it.percent = 889, it.ampersand = 667, it.quoteright = 222, it.parenleft = 333, it.parenright = 333, it.asterisk = 389, it.plus = 584, it.comma = 278, it.hyphen = 333, it.period = 278, it.slash = 278, it.zero = 556, it.one = 556, it.two = 556, it.three = 556, it.four = 556, it.five = 556, it.six = 556, it.seven = 556, it.eight = 556, it.nine = 556, it.colon = 278, it.semicolon = 278, it.less = 584, it.equal = 584, it.greater = 584, it.question = 556, it.at = 1015, it.A = 667, it.B = 667, it.C = 722, it.D = 722, it.E = 667, it.F = 611, it.G = 778, it.H = 722, it.I = 278, it.J = 500, it.K = 667, it.L = 556, it.M = 833, it.N = 722, it.O = 778, it.P = 667, it.Q = 778, it.R = 722, it.S = 667, it.T = 611, it.U = 722, it.V = 667, it.W = 944, it.X = 667, it.Y = 667, it.Z = 611, it.bracketleft = 278, it.backslash = 278, it.bracketright = 278, it.asciicircum = 469, it.underscore = 556, it.quoteleft = 222, it.a = 556, it.b = 556, it.c = 500, it.d = 556, it.e = 556, it.f = 278, it.g = 556, it.h = 556, it.i = 222, it.j = 222, it.k = 500, it.l = 222, it.m = 833, it.n = 556, it.o = 556, it.p = 556, it.q = 556, it.r = 333, it.s = 500, it.t = 278, it.u = 556, it.v = 500, it.w = 722, it.x = 500, it.y = 500, it.z = 500, it.braceleft = 334, it.bar = 260, it.braceright = 334, it.asciitilde = 584, it.exclamdown = 333, it.cent = 556, it.sterling = 556, it.fraction = 167, it.yen = 556, it.florin = 556, it.section = 556, it.currency = 556, it.quotesingle = 191, it.quotedblleft = 333, it.guillemotleft = 556, it.guilsinglleft = 333, it.guilsinglright = 333, it.fi = 500, it.fl = 500, it.endash = 556, it.dagger = 556, it.daggerdbl = 556, it.periodcentered = 278, it.paragraph = 537, it.bullet = 350, it.quotesinglbase = 222, it.quotedblbase = 333, it.quotedblright = 333, it.guillemotright = 556, it.ellipsis = 1e3, it.perthousand = 1e3, it.questiondown = 611, it.grave = 333, it.acute = 333, it.circumflex = 333, it.tilde = 333, it.macron = 333, it.breve = 333, it.dotaccent = 333, it.dieresis = 333, it.ring = 333, it.cedilla = 333, it.hungarumlaut = 333, it.ogonek = 333, it.caron = 333, it.emdash = 1e3, it.AE = 1e3, it.ordfeminine = 370, it.Lslash = 556, it.Oslash = 778, it.OE = 1e3, it.ordmasculine = 365, it.ae = 889, it.dotlessi = 278, it.lslash = 222, it.oslash = 611, it.oe = 944, it.germandbls = 611, it.Idieresis = 278, it.eacute = 556, it.abreve = 556, it.uhungarumlaut = 556, it.ecaron = 556, it.Ydieresis = 667, it.divide = 584, it.Yacute = 667, it.Acircumflex = 667, it.aacute = 556, it.Ucircumflex = 722, it.yacute = 500, it.scommaaccent = 500, it.ecircumflex = 556, it.Uring = 722, it.Udieresis = 722, it.aogonek = 556, it.Uacute = 722, it.uogonek = 556, it.Edieresis = 667, it.Dcroat = 722, it.commaaccent = 250, it.copyright = 737, it.Emacron = 667, it.ccaron = 500, it.aring = 556, it.Ncommaaccent = 722, it.lacute = 222, it.agrave = 556, it.Tcommaaccent = 611, it.Cacute = 722, it.atilde = 556, it.Edotaccent = 667, it.scaron = 500, it.scedilla = 500, it.iacute = 278, it.lozenge = 471, it.Rcaron = 722, it.Gcommaaccent = 778, it.ucircumflex = 556, it.acircumflex = 556, it.Amacron = 667, it.rcaron = 333, it.ccedilla = 500, it.Zdotaccent = 611, it.Thorn = 667, it.Omacron = 778, it.Racute = 722, it.Sacute = 667, it.dcaron = 643, it.Umacron = 722, it.uring = 556, it.threesuperior = 333, it.Ograve = 778, it.Agrave = 667, it.Abreve = 667, it.multiply = 584, it.uacute = 556, it.Tcaron = 611, it.partialdiff = 476, it.ydieresis = 500, it.Nacute = 722, it.icircumflex = 278, it.Ecircumflex = 667, it.adieresis = 556, it.edieresis = 556, it.cacute = 500, it.nacute = 556, it.umacron = 556, it.Ncaron = 722, it.Iacute = 278, it.plusminus = 584, it.brokenbar = 260, it.registered = 737, it.Gbreve = 778, it.Idotaccent = 278, it.summation = 600, it.Egrave = 667, it.racute = 333, it.omacron = 556, it.Zacute = 611, it.Zcaron = 611, it.greaterequal = 549, it.Eth = 722, it.Ccedilla = 722, it.lcommaaccent = 222, it.tcaron = 317, it.eogonek = 556, it.Uogonek = 722, it.Aacute = 667, it.Adieresis = 667, it.egrave = 556, it.zacute = 500, it.iogonek = 222, it.Oacute = 778, it.oacute = 556, it.amacron = 556, it.sacute = 500, it.idieresis = 278, it.Ocircumflex = 778, it.Ugrave = 722, it.Delta = 612, it.thorn = 556, it.twosuperior = 333, it.Odieresis = 778, it.mu = 556, it.igrave = 278, it.ohungarumlaut = 556, it.Eogonek = 667, it.dcroat = 556, it.threequarters = 834, it.Scedilla = 667, it.lcaron = 299, it.Kcommaaccent = 667, it.Lacute = 556, it.trademark = 1e3, it.edotaccent = 556, it.Igrave = 278, it.Imacron = 278, it.Lcaron = 556, it.onehalf = 834, it.lessequal = 549, it.ocircumflex = 556, it.ntilde = 556, it.Uhungarumlaut = 722, it.Eacute = 667, it.emacron = 556, it.gbreve = 556, it.onequarter = 834, it.Scaron = 667, it.Scommaaccent = 667, it.Ohungarumlaut = 778, it.degree = 400, it.ograve = 556, it.Ccaron = 722, it.ugrave = 556, it.radical = 453, it.Dcaron = 722, it.rcommaaccent = 333, it.Ntilde = 722, it.otilde = 556, it.Rcommaaccent = 722, it.Lcommaaccent = 556, it.Atilde = 667, it.Aogonek = 667, it.Aring = 667, it.Otilde = 778, it.zdotaccent = 500, it.Ecaron = 667, it.Iogonek = 278, it.kcommaaccent = 500, it.minus = 584, it.Icircumflex = 278, it.ncaron = 556, it.tcommaaccent = 278, it.logicalnot = 584, it.odieresis = 556, it.udieresis = 556, it.notequal = 549, it.gcommaaccent = 556, it.eth = 556, it.zcaron = 500, it.ncommaaccent = 556, it.onesuperior = 333, it.imacron = 278, it.Euro = 556;
            }), et.Symbol = (0, rt.getLookupTableFactory)(function(it) {
              it.space = 250, it.exclam = 333, it.universal = 713, it.numbersign = 500, it.existential = 549, it.percent = 833, it.ampersand = 778, it.suchthat = 439, it.parenleft = 333, it.parenright = 333, it.asteriskmath = 500, it.plus = 549, it.comma = 250, it.minus = 549, it.period = 250, it.slash = 278, it.zero = 500, it.one = 500, it.two = 500, it.three = 500, it.four = 500, it.five = 500, it.six = 500, it.seven = 500, it.eight = 500, it.nine = 500, it.colon = 278, it.semicolon = 278, it.less = 549, it.equal = 549, it.greater = 549, it.question = 444, it.congruent = 549, it.Alpha = 722, it.Beta = 667, it.Chi = 722, it.Delta = 612, it.Epsilon = 611, it.Phi = 763, it.Gamma = 603, it.Eta = 722, it.Iota = 333, it.theta1 = 631, it.Kappa = 722, it.Lambda = 686, it.Mu = 889, it.Nu = 722, it.Omicron = 722, it.Pi = 768, it.Theta = 741, it.Rho = 556, it.Sigma = 592, it.Tau = 611, it.Upsilon = 690, it.sigma1 = 439, it.Omega = 768, it.Xi = 645, it.Psi = 795, it.Zeta = 611, it.bracketleft = 333, it.therefore = 863, it.bracketright = 333, it.perpendicular = 658, it.underscore = 500, it.radicalex = 500, it.alpha = 631, it.beta = 549, it.chi = 549, it.delta = 494, it.epsilon = 439, it.phi = 521, it.gamma = 411, it.eta = 603, it.iota = 329, it.phi1 = 603, it.kappa = 549, it.lambda = 549, it.mu = 576, it.nu = 521, it.omicron = 549, it.pi = 549, it.theta = 521, it.rho = 549, it.sigma = 603, it.tau = 439, it.upsilon = 576, it.omega1 = 713, it.omega = 686, it.xi = 493, it.psi = 686, it.zeta = 494, it.braceleft = 480, it.bar = 200, it.braceright = 480, it.similar = 549, it.Euro = 750, it.Upsilon1 = 620, it.minute = 247, it.lessequal = 549, it.fraction = 167, it.infinity = 713, it.florin = 500, it.club = 753, it.diamond = 753, it.heart = 753, it.spade = 753, it.arrowboth = 1042, it.arrowleft = 987, it.arrowup = 603, it.arrowright = 987, it.arrowdown = 603, it.degree = 400, it.plusminus = 549, it.second = 411, it.greaterequal = 549, it.multiply = 549, it.proportional = 713, it.partialdiff = 494, it.bullet = 460, it.divide = 549, it.notequal = 549, it.equivalence = 549, it.approxequal = 549, it.ellipsis = 1e3, it.arrowvertex = 603, it.arrowhorizex = 1e3, it.carriagereturn = 658, it.aleph = 823, it.Ifraktur = 686, it.Rfraktur = 795, it.weierstrass = 987, it.circlemultiply = 768, it.circleplus = 768, it.emptyset = 823, it.intersection = 768, it.union = 768, it.propersuperset = 713, it.reflexsuperset = 713, it.notsubset = 713, it.propersubset = 713, it.reflexsubset = 713, it.element = 713, it.notelement = 713, it.angle = 768, it.gradient = 713, it.registerserif = 790, it.copyrightserif = 790, it.trademarkserif = 890, it.product = 823, it.radical = 549, it.dotmath = 250, it.logicalnot = 713, it.logicaland = 603, it.logicalor = 603, it.arrowdblboth = 1042, it.arrowdblleft = 987, it.arrowdblup = 603, it.arrowdblright = 987, it.arrowdbldown = 603, it.lozenge = 494, it.angleleft = 329, it.registersans = 790, it.copyrightsans = 790, it.trademarksans = 786, it.summation = 713, it.parenlefttp = 384, it.parenleftex = 384, it.parenleftbt = 384, it.bracketlefttp = 384, it.bracketleftex = 384, it.bracketleftbt = 384, it.bracelefttp = 494, it.braceleftmid = 494, it.braceleftbt = 494, it.braceex = 494, it.angleright = 329, it.integral = 274, it.integraltp = 686, it.integralex = 686, it.integralbt = 686, it.parenrighttp = 384, it.parenrightex = 384, it.parenrightbt = 384, it.bracketrighttp = 384, it.bracketrightex = 384, it.bracketrightbt = 384, it.bracerighttp = 494, it.bracerightmid = 494, it.bracerightbt = 494, it.apple = 790;
            }), et["Times-Roman"] = (0, rt.getLookupTableFactory)(function(it) {
              it.space = 250, it.exclam = 333, it.quotedbl = 408, it.numbersign = 500, it.dollar = 500, it.percent = 833, it.ampersand = 778, it.quoteright = 333, it.parenleft = 333, it.parenright = 333, it.asterisk = 500, it.plus = 564, it.comma = 250, it.hyphen = 333, it.period = 250, it.slash = 278, it.zero = 500, it.one = 500, it.two = 500, it.three = 500, it.four = 500, it.five = 500, it.six = 500, it.seven = 500, it.eight = 500, it.nine = 500, it.colon = 278, it.semicolon = 278, it.less = 564, it.equal = 564, it.greater = 564, it.question = 444, it.at = 921, it.A = 722, it.B = 667, it.C = 667, it.D = 722, it.E = 611, it.F = 556, it.G = 722, it.H = 722, it.I = 333, it.J = 389, it.K = 722, it.L = 611, it.M = 889, it.N = 722, it.O = 722, it.P = 556, it.Q = 722, it.R = 667, it.S = 556, it.T = 611, it.U = 722, it.V = 722, it.W = 944, it.X = 722, it.Y = 722, it.Z = 611, it.bracketleft = 333, it.backslash = 278, it.bracketright = 333, it.asciicircum = 469, it.underscore = 500, it.quoteleft = 333, it.a = 444, it.b = 500, it.c = 444, it.d = 500, it.e = 444, it.f = 333, it.g = 500, it.h = 500, it.i = 278, it.j = 278, it.k = 500, it.l = 278, it.m = 778, it.n = 500, it.o = 500, it.p = 500, it.q = 500, it.r = 333, it.s = 389, it.t = 278, it.u = 500, it.v = 500, it.w = 722, it.x = 500, it.y = 500, it.z = 444, it.braceleft = 480, it.bar = 200, it.braceright = 480, it.asciitilde = 541, it.exclamdown = 333, it.cent = 500, it.sterling = 500, it.fraction = 167, it.yen = 500, it.florin = 500, it.section = 500, it.currency = 500, it.quotesingle = 180, it.quotedblleft = 444, it.guillemotleft = 500, it.guilsinglleft = 333, it.guilsinglright = 333, it.fi = 556, it.fl = 556, it.endash = 500, it.dagger = 500, it.daggerdbl = 500, it.periodcentered = 250, it.paragraph = 453, it.bullet = 350, it.quotesinglbase = 333, it.quotedblbase = 444, it.quotedblright = 444, it.guillemotright = 500, it.ellipsis = 1e3, it.perthousand = 1e3, it.questiondown = 444, it.grave = 333, it.acute = 333, it.circumflex = 333, it.tilde = 333, it.macron = 333, it.breve = 333, it.dotaccent = 333, it.dieresis = 333, it.ring = 333, it.cedilla = 333, it.hungarumlaut = 333, it.ogonek = 333, it.caron = 333, it.emdash = 1e3, it.AE = 889, it.ordfeminine = 276, it.Lslash = 611, it.Oslash = 722, it.OE = 889, it.ordmasculine = 310, it.ae = 667, it.dotlessi = 278, it.lslash = 278, it.oslash = 500, it.oe = 722, it.germandbls = 500, it.Idieresis = 333, it.eacute = 444, it.abreve = 444, it.uhungarumlaut = 500, it.ecaron = 444, it.Ydieresis = 722, it.divide = 564, it.Yacute = 722, it.Acircumflex = 722, it.aacute = 444, it.Ucircumflex = 722, it.yacute = 500, it.scommaaccent = 389, it.ecircumflex = 444, it.Uring = 722, it.Udieresis = 722, it.aogonek = 444, it.Uacute = 722, it.uogonek = 500, it.Edieresis = 611, it.Dcroat = 722, it.commaaccent = 250, it.copyright = 760, it.Emacron = 611, it.ccaron = 444, it.aring = 444, it.Ncommaaccent = 722, it.lacute = 278, it.agrave = 444, it.Tcommaaccent = 611, it.Cacute = 667, it.atilde = 444, it.Edotaccent = 611, it.scaron = 389, it.scedilla = 389, it.iacute = 278, it.lozenge = 471, it.Rcaron = 667, it.Gcommaaccent = 722, it.ucircumflex = 500, it.acircumflex = 444, it.Amacron = 722, it.rcaron = 333, it.ccedilla = 444, it.Zdotaccent = 611, it.Thorn = 556, it.Omacron = 722, it.Racute = 667, it.Sacute = 556, it.dcaron = 588, it.Umacron = 722, it.uring = 500, it.threesuperior = 300, it.Ograve = 722, it.Agrave = 722, it.Abreve = 722, it.multiply = 564, it.uacute = 500, it.Tcaron = 611, it.partialdiff = 476, it.ydieresis = 500, it.Nacute = 722, it.icircumflex = 278, it.Ecircumflex = 611, it.adieresis = 444, it.edieresis = 444, it.cacute = 444, it.nacute = 500, it.umacron = 500, it.Ncaron = 722, it.Iacute = 333, it.plusminus = 564, it.brokenbar = 200, it.registered = 760, it.Gbreve = 722, it.Idotaccent = 333, it.summation = 600, it.Egrave = 611, it.racute = 333, it.omacron = 500, it.Zacute = 611, it.Zcaron = 611, it.greaterequal = 549, it.Eth = 722, it.Ccedilla = 667, it.lcommaaccent = 278, it.tcaron = 326, it.eogonek = 444, it.Uogonek = 722, it.Aacute = 722, it.Adieresis = 722, it.egrave = 444, it.zacute = 444, it.iogonek = 278, it.Oacute = 722, it.oacute = 500, it.amacron = 444, it.sacute = 389, it.idieresis = 278, it.Ocircumflex = 722, it.Ugrave = 722, it.Delta = 612, it.thorn = 500, it.twosuperior = 300, it.Odieresis = 722, it.mu = 500, it.igrave = 278, it.ohungarumlaut = 500, it.Eogonek = 611, it.dcroat = 500, it.threequarters = 750, it.Scedilla = 556, it.lcaron = 344, it.Kcommaaccent = 722, it.Lacute = 611, it.trademark = 980, it.edotaccent = 444, it.Igrave = 333, it.Imacron = 333, it.Lcaron = 611, it.onehalf = 750, it.lessequal = 549, it.ocircumflex = 500, it.ntilde = 500, it.Uhungarumlaut = 722, it.Eacute = 611, it.emacron = 444, it.gbreve = 500, it.onequarter = 750, it.Scaron = 556, it.Scommaaccent = 556, it.Ohungarumlaut = 722, it.degree = 400, it.ograve = 500, it.Ccaron = 667, it.ugrave = 500, it.radical = 453, it.Dcaron = 722, it.rcommaaccent = 333, it.Ntilde = 722, it.otilde = 500, it.Rcommaaccent = 667, it.Lcommaaccent = 611, it.Atilde = 722, it.Aogonek = 722, it.Aring = 722, it.Otilde = 722, it.zdotaccent = 444, it.Ecaron = 611, it.Iogonek = 333, it.kcommaaccent = 500, it.minus = 564, it.Icircumflex = 333, it.ncaron = 500, it.tcommaaccent = 278, it.logicalnot = 564, it.odieresis = 500, it.udieresis = 500, it.notequal = 549, it.gcommaaccent = 500, it.eth = 500, it.zcaron = 444, it.ncommaaccent = 500, it.onesuperior = 300, it.imacron = 278, it.Euro = 500;
            }), et["Times-Bold"] = (0, rt.getLookupTableFactory)(function(it) {
              it.space = 250, it.exclam = 333, it.quotedbl = 555, it.numbersign = 500, it.dollar = 500, it.percent = 1e3, it.ampersand = 833, it.quoteright = 333, it.parenleft = 333, it.parenright = 333, it.asterisk = 500, it.plus = 570, it.comma = 250, it.hyphen = 333, it.period = 250, it.slash = 278, it.zero = 500, it.one = 500, it.two = 500, it.three = 500, it.four = 500, it.five = 500, it.six = 500, it.seven = 500, it.eight = 500, it.nine = 500, it.colon = 333, it.semicolon = 333, it.less = 570, it.equal = 570, it.greater = 570, it.question = 500, it.at = 930, it.A = 722, it.B = 667, it.C = 722, it.D = 722, it.E = 667, it.F = 611, it.G = 778, it.H = 778, it.I = 389, it.J = 500, it.K = 778, it.L = 667, it.M = 944, it.N = 722, it.O = 778, it.P = 611, it.Q = 778, it.R = 722, it.S = 556, it.T = 667, it.U = 722, it.V = 722, it.W = 1e3, it.X = 722, it.Y = 722, it.Z = 667, it.bracketleft = 333, it.backslash = 278, it.bracketright = 333, it.asciicircum = 581, it.underscore = 500, it.quoteleft = 333, it.a = 500, it.b = 556, it.c = 444, it.d = 556, it.e = 444, it.f = 333, it.g = 500, it.h = 556, it.i = 278, it.j = 333, it.k = 556, it.l = 278, it.m = 833, it.n = 556, it.o = 500, it.p = 556, it.q = 556, it.r = 444, it.s = 389, it.t = 333, it.u = 556, it.v = 500, it.w = 722, it.x = 500, it.y = 500, it.z = 444, it.braceleft = 394, it.bar = 220, it.braceright = 394, it.asciitilde = 520, it.exclamdown = 333, it.cent = 500, it.sterling = 500, it.fraction = 167, it.yen = 500, it.florin = 500, it.section = 500, it.currency = 500, it.quotesingle = 278, it.quotedblleft = 500, it.guillemotleft = 500, it.guilsinglleft = 333, it.guilsinglright = 333, it.fi = 556, it.fl = 556, it.endash = 500, it.dagger = 500, it.daggerdbl = 500, it.periodcentered = 250, it.paragraph = 540, it.bullet = 350, it.quotesinglbase = 333, it.quotedblbase = 500, it.quotedblright = 500, it.guillemotright = 500, it.ellipsis = 1e3, it.perthousand = 1e3, it.questiondown = 500, it.grave = 333, it.acute = 333, it.circumflex = 333, it.tilde = 333, it.macron = 333, it.breve = 333, it.dotaccent = 333, it.dieresis = 333, it.ring = 333, it.cedilla = 333, it.hungarumlaut = 333, it.ogonek = 333, it.caron = 333, it.emdash = 1e3, it.AE = 1e3, it.ordfeminine = 300, it.Lslash = 667, it.Oslash = 778, it.OE = 1e3, it.ordmasculine = 330, it.ae = 722, it.dotlessi = 278, it.lslash = 278, it.oslash = 500, it.oe = 722, it.germandbls = 556, it.Idieresis = 389, it.eacute = 444, it.abreve = 500, it.uhungarumlaut = 556, it.ecaron = 444, it.Ydieresis = 722, it.divide = 570, it.Yacute = 722, it.Acircumflex = 722, it.aacute = 500, it.Ucircumflex = 722, it.yacute = 500, it.scommaaccent = 389, it.ecircumflex = 444, it.Uring = 722, it.Udieresis = 722, it.aogonek = 500, it.Uacute = 722, it.uogonek = 556, it.Edieresis = 667, it.Dcroat = 722, it.commaaccent = 250, it.copyright = 747, it.Emacron = 667, it.ccaron = 444, it.aring = 500, it.Ncommaaccent = 722, it.lacute = 278, it.agrave = 500, it.Tcommaaccent = 667, it.Cacute = 722, it.atilde = 500, it.Edotaccent = 667, it.scaron = 389, it.scedilla = 389, it.iacute = 278, it.lozenge = 494, it.Rcaron = 722, it.Gcommaaccent = 778, it.ucircumflex = 556, it.acircumflex = 500, it.Amacron = 722, it.rcaron = 444, it.ccedilla = 444, it.Zdotaccent = 667, it.Thorn = 611, it.Omacron = 778, it.Racute = 722, it.Sacute = 556, it.dcaron = 672, it.Umacron = 722, it.uring = 556, it.threesuperior = 300, it.Ograve = 778, it.Agrave = 722, it.Abreve = 722, it.multiply = 570, it.uacute = 556, it.Tcaron = 667, it.partialdiff = 494, it.ydieresis = 500, it.Nacute = 722, it.icircumflex = 278, it.Ecircumflex = 667, it.adieresis = 500, it.edieresis = 444, it.cacute = 444, it.nacute = 556, it.umacron = 556, it.Ncaron = 722, it.Iacute = 389, it.plusminus = 570, it.brokenbar = 220, it.registered = 747, it.Gbreve = 778, it.Idotaccent = 389, it.summation = 600, it.Egrave = 667, it.racute = 444, it.omacron = 500, it.Zacute = 667, it.Zcaron = 667, it.greaterequal = 549, it.Eth = 722, it.Ccedilla = 722, it.lcommaaccent = 278, it.tcaron = 416, it.eogonek = 444, it.Uogonek = 722, it.Aacute = 722, it.Adieresis = 722, it.egrave = 444, it.zacute = 444, it.iogonek = 278, it.Oacute = 778, it.oacute = 500, it.amacron = 500, it.sacute = 389, it.idieresis = 278, it.Ocircumflex = 778, it.Ugrave = 722, it.Delta = 612, it.thorn = 556, it.twosuperior = 300, it.Odieresis = 778, it.mu = 556, it.igrave = 278, it.ohungarumlaut = 500, it.Eogonek = 667, it.dcroat = 556, it.threequarters = 750, it.Scedilla = 556, it.lcaron = 394, it.Kcommaaccent = 778, it.Lacute = 667, it.trademark = 1e3, it.edotaccent = 444, it.Igrave = 389, it.Imacron = 389, it.Lcaron = 667, it.onehalf = 750, it.lessequal = 549, it.ocircumflex = 500, it.ntilde = 556, it.Uhungarumlaut = 722, it.Eacute = 667, it.emacron = 444, it.gbreve = 500, it.onequarter = 750, it.Scaron = 556, it.Scommaaccent = 556, it.Ohungarumlaut = 778, it.degree = 400, it.ograve = 500, it.Ccaron = 722, it.ugrave = 556, it.radical = 549, it.Dcaron = 722, it.rcommaaccent = 444, it.Ntilde = 722, it.otilde = 500, it.Rcommaaccent = 722, it.Lcommaaccent = 667, it.Atilde = 722, it.Aogonek = 722, it.Aring = 722, it.Otilde = 778, it.zdotaccent = 444, it.Ecaron = 667, it.Iogonek = 389, it.kcommaaccent = 556, it.minus = 570, it.Icircumflex = 389, it.ncaron = 556, it.tcommaaccent = 333, it.logicalnot = 570, it.odieresis = 500, it.udieresis = 556, it.notequal = 549, it.gcommaaccent = 500, it.eth = 500, it.zcaron = 444, it.ncommaaccent = 556, it.onesuperior = 300, it.imacron = 278, it.Euro = 500;
            }), et["Times-BoldItalic"] = (0, rt.getLookupTableFactory)(function(it) {
              it.space = 250, it.exclam = 389, it.quotedbl = 555, it.numbersign = 500, it.dollar = 500, it.percent = 833, it.ampersand = 778, it.quoteright = 333, it.parenleft = 333, it.parenright = 333, it.asterisk = 500, it.plus = 570, it.comma = 250, it.hyphen = 333, it.period = 250, it.slash = 278, it.zero = 500, it.one = 500, it.two = 500, it.three = 500, it.four = 500, it.five = 500, it.six = 500, it.seven = 500, it.eight = 500, it.nine = 500, it.colon = 333, it.semicolon = 333, it.less = 570, it.equal = 570, it.greater = 570, it.question = 500, it.at = 832, it.A = 667, it.B = 667, it.C = 667, it.D = 722, it.E = 667, it.F = 667, it.G = 722, it.H = 778, it.I = 389, it.J = 500, it.K = 667, it.L = 611, it.M = 889, it.N = 722, it.O = 722, it.P = 611, it.Q = 722, it.R = 667, it.S = 556, it.T = 611, it.U = 722, it.V = 667, it.W = 889, it.X = 667, it.Y = 611, it.Z = 611, it.bracketleft = 333, it.backslash = 278, it.bracketright = 333, it.asciicircum = 570, it.underscore = 500, it.quoteleft = 333, it.a = 500, it.b = 500, it.c = 444, it.d = 500, it.e = 444, it.f = 333, it.g = 500, it.h = 556, it.i = 278, it.j = 278, it.k = 500, it.l = 278, it.m = 778, it.n = 556, it.o = 500, it.p = 500, it.q = 500, it.r = 389, it.s = 389, it.t = 278, it.u = 556, it.v = 444, it.w = 667, it.x = 500, it.y = 444, it.z = 389, it.braceleft = 348, it.bar = 220, it.braceright = 348, it.asciitilde = 570, it.exclamdown = 389, it.cent = 500, it.sterling = 500, it.fraction = 167, it.yen = 500, it.florin = 500, it.section = 500, it.currency = 500, it.quotesingle = 278, it.quotedblleft = 500, it.guillemotleft = 500, it.guilsinglleft = 333, it.guilsinglright = 333, it.fi = 556, it.fl = 556, it.endash = 500, it.dagger = 500, it.daggerdbl = 500, it.periodcentered = 250, it.paragraph = 500, it.bullet = 350, it.quotesinglbase = 333, it.quotedblbase = 500, it.quotedblright = 500, it.guillemotright = 500, it.ellipsis = 1e3, it.perthousand = 1e3, it.questiondown = 500, it.grave = 333, it.acute = 333, it.circumflex = 333, it.tilde = 333, it.macron = 333, it.breve = 333, it.dotaccent = 333, it.dieresis = 333, it.ring = 333, it.cedilla = 333, it.hungarumlaut = 333, it.ogonek = 333, it.caron = 333, it.emdash = 1e3, it.AE = 944, it.ordfeminine = 266, it.Lslash = 611, it.Oslash = 722, it.OE = 944, it.ordmasculine = 300, it.ae = 722, it.dotlessi = 278, it.lslash = 278, it.oslash = 500, it.oe = 722, it.germandbls = 500, it.Idieresis = 389, it.eacute = 444, it.abreve = 500, it.uhungarumlaut = 556, it.ecaron = 444, it.Ydieresis = 611, it.divide = 570, it.Yacute = 611, it.Acircumflex = 667, it.aacute = 500, it.Ucircumflex = 722, it.yacute = 444, it.scommaaccent = 389, it.ecircumflex = 444, it.Uring = 722, it.Udieresis = 722, it.aogonek = 500, it.Uacute = 722, it.uogonek = 556, it.Edieresis = 667, it.Dcroat = 722, it.commaaccent = 250, it.copyright = 747, it.Emacron = 667, it.ccaron = 444, it.aring = 500, it.Ncommaaccent = 722, it.lacute = 278, it.agrave = 500, it.Tcommaaccent = 611, it.Cacute = 667, it.atilde = 500, it.Edotaccent = 667, it.scaron = 389, it.scedilla = 389, it.iacute = 278, it.lozenge = 494, it.Rcaron = 667, it.Gcommaaccent = 722, it.ucircumflex = 556, it.acircumflex = 500, it.Amacron = 667, it.rcaron = 389, it.ccedilla = 444, it.Zdotaccent = 611, it.Thorn = 611, it.Omacron = 722, it.Racute = 667, it.Sacute = 556, it.dcaron = 608, it.Umacron = 722, it.uring = 556, it.threesuperior = 300, it.Ograve = 722, it.Agrave = 667, it.Abreve = 667, it.multiply = 570, it.uacute = 556, it.Tcaron = 611, it.partialdiff = 494, it.ydieresis = 444, it.Nacute = 722, it.icircumflex = 278, it.Ecircumflex = 667, it.adieresis = 500, it.edieresis = 444, it.cacute = 444, it.nacute = 556, it.umacron = 556, it.Ncaron = 722, it.Iacute = 389, it.plusminus = 570, it.brokenbar = 220, it.registered = 747, it.Gbreve = 722, it.Idotaccent = 389, it.summation = 600, it.Egrave = 667, it.racute = 389, it.omacron = 500, it.Zacute = 611, it.Zcaron = 611, it.greaterequal = 549, it.Eth = 722, it.Ccedilla = 667, it.lcommaaccent = 278, it.tcaron = 366, it.eogonek = 444, it.Uogonek = 722, it.Aacute = 667, it.Adieresis = 667, it.egrave = 444, it.zacute = 389, it.iogonek = 278, it.Oacute = 722, it.oacute = 500, it.amacron = 500, it.sacute = 389, it.idieresis = 278, it.Ocircumflex = 722, it.Ugrave = 722, it.Delta = 612, it.thorn = 500, it.twosuperior = 300, it.Odieresis = 722, it.mu = 576, it.igrave = 278, it.ohungarumlaut = 500, it.Eogonek = 667, it.dcroat = 500, it.threequarters = 750, it.Scedilla = 556, it.lcaron = 382, it.Kcommaaccent = 667, it.Lacute = 611, it.trademark = 1e3, it.edotaccent = 444, it.Igrave = 389, it.Imacron = 389, it.Lcaron = 611, it.onehalf = 750, it.lessequal = 549, it.ocircumflex = 500, it.ntilde = 556, it.Uhungarumlaut = 722, it.Eacute = 667, it.emacron = 444, it.gbreve = 500, it.onequarter = 750, it.Scaron = 556, it.Scommaaccent = 556, it.Ohungarumlaut = 722, it.degree = 400, it.ograve = 500, it.Ccaron = 667, it.ugrave = 556, it.radical = 549, it.Dcaron = 722, it.rcommaaccent = 389, it.Ntilde = 722, it.otilde = 500, it.Rcommaaccent = 667, it.Lcommaaccent = 611, it.Atilde = 667, it.Aogonek = 667, it.Aring = 667, it.Otilde = 722, it.zdotaccent = 389, it.Ecaron = 667, it.Iogonek = 389, it.kcommaaccent = 500, it.minus = 606, it.Icircumflex = 389, it.ncaron = 556, it.tcommaaccent = 278, it.logicalnot = 606, it.odieresis = 500, it.udieresis = 556, it.notequal = 549, it.gcommaaccent = 500, it.eth = 500, it.zcaron = 389, it.ncommaaccent = 556, it.onesuperior = 300, it.imacron = 278, it.Euro = 500;
            }), et["Times-Italic"] = (0, rt.getLookupTableFactory)(function(it) {
              it.space = 250, it.exclam = 333, it.quotedbl = 420, it.numbersign = 500, it.dollar = 500, it.percent = 833, it.ampersand = 778, it.quoteright = 333, it.parenleft = 333, it.parenright = 333, it.asterisk = 500, it.plus = 675, it.comma = 250, it.hyphen = 333, it.period = 250, it.slash = 278, it.zero = 500, it.one = 500, it.two = 500, it.three = 500, it.four = 500, it.five = 500, it.six = 500, it.seven = 500, it.eight = 500, it.nine = 500, it.colon = 333, it.semicolon = 333, it.less = 675, it.equal = 675, it.greater = 675, it.question = 500, it.at = 920, it.A = 611, it.B = 611, it.C = 667, it.D = 722, it.E = 611, it.F = 611, it.G = 722, it.H = 722, it.I = 333, it.J = 444, it.K = 667, it.L = 556, it.M = 833, it.N = 667, it.O = 722, it.P = 611, it.Q = 722, it.R = 611, it.S = 500, it.T = 556, it.U = 722, it.V = 611, it.W = 833, it.X = 611, it.Y = 556, it.Z = 556, it.bracketleft = 389, it.backslash = 278, it.bracketright = 389, it.asciicircum = 422, it.underscore = 500, it.quoteleft = 333, it.a = 500, it.b = 500, it.c = 444, it.d = 500, it.e = 444, it.f = 278, it.g = 500, it.h = 500, it.i = 278, it.j = 278, it.k = 444, it.l = 278, it.m = 722, it.n = 500, it.o = 500, it.p = 500, it.q = 500, it.r = 389, it.s = 389, it.t = 278, it.u = 500, it.v = 444, it.w = 667, it.x = 444, it.y = 444, it.z = 389, it.braceleft = 400, it.bar = 275, it.braceright = 400, it.asciitilde = 541, it.exclamdown = 389, it.cent = 500, it.sterling = 500, it.fraction = 167, it.yen = 500, it.florin = 500, it.section = 500, it.currency = 500, it.quotesingle = 214, it.quotedblleft = 556, it.guillemotleft = 500, it.guilsinglleft = 333, it.guilsinglright = 333, it.fi = 500, it.fl = 500, it.endash = 500, it.dagger = 500, it.daggerdbl = 500, it.periodcentered = 250, it.paragraph = 523, it.bullet = 350, it.quotesinglbase = 333, it.quotedblbase = 556, it.quotedblright = 556, it.guillemotright = 500, it.ellipsis = 889, it.perthousand = 1e3, it.questiondown = 500, it.grave = 333, it.acute = 333, it.circumflex = 333, it.tilde = 333, it.macron = 333, it.breve = 333, it.dotaccent = 333, it.dieresis = 333, it.ring = 333, it.cedilla = 333, it.hungarumlaut = 333, it.ogonek = 333, it.caron = 333, it.emdash = 889, it.AE = 889, it.ordfeminine = 276, it.Lslash = 556, it.Oslash = 722, it.OE = 944, it.ordmasculine = 310, it.ae = 667, it.dotlessi = 278, it.lslash = 278, it.oslash = 500, it.oe = 667, it.germandbls = 500, it.Idieresis = 333, it.eacute = 444, it.abreve = 500, it.uhungarumlaut = 500, it.ecaron = 444, it.Ydieresis = 556, it.divide = 675, it.Yacute = 556, it.Acircumflex = 611, it.aacute = 500, it.Ucircumflex = 722, it.yacute = 444, it.scommaaccent = 389, it.ecircumflex = 444, it.Uring = 722, it.Udieresis = 722, it.aogonek = 500, it.Uacute = 722, it.uogonek = 500, it.Edieresis = 611, it.Dcroat = 722, it.commaaccent = 250, it.copyright = 760, it.Emacron = 611, it.ccaron = 444, it.aring = 500, it.Ncommaaccent = 667, it.lacute = 278, it.agrave = 500, it.Tcommaaccent = 556, it.Cacute = 667, it.atilde = 500, it.Edotaccent = 611, it.scaron = 389, it.scedilla = 389, it.iacute = 278, it.lozenge = 471, it.Rcaron = 611, it.Gcommaaccent = 722, it.ucircumflex = 500, it.acircumflex = 500, it.Amacron = 611, it.rcaron = 389, it.ccedilla = 444, it.Zdotaccent = 556, it.Thorn = 611, it.Omacron = 722, it.Racute = 611, it.Sacute = 500, it.dcaron = 544, it.Umacron = 722, it.uring = 500, it.threesuperior = 300, it.Ograve = 722, it.Agrave = 611, it.Abreve = 611, it.multiply = 675, it.uacute = 500, it.Tcaron = 556, it.partialdiff = 476, it.ydieresis = 444, it.Nacute = 667, it.icircumflex = 278, it.Ecircumflex = 611, it.adieresis = 500, it.edieresis = 444, it.cacute = 444, it.nacute = 500, it.umacron = 500, it.Ncaron = 667, it.Iacute = 333, it.plusminus = 675, it.brokenbar = 275, it.registered = 760, it.Gbreve = 722, it.Idotaccent = 333, it.summation = 600, it.Egrave = 611, it.racute = 389, it.omacron = 500, it.Zacute = 556, it.Zcaron = 556, it.greaterequal = 549, it.Eth = 722, it.Ccedilla = 667, it.lcommaaccent = 278, it.tcaron = 300, it.eogonek = 444, it.Uogonek = 722, it.Aacute = 611, it.Adieresis = 611, it.egrave = 444, it.zacute = 389, it.iogonek = 278, it.Oacute = 722, it.oacute = 500, it.amacron = 500, it.sacute = 389, it.idieresis = 278, it.Ocircumflex = 722, it.Ugrave = 722, it.Delta = 612, it.thorn = 500, it.twosuperior = 300, it.Odieresis = 722, it.mu = 500, it.igrave = 278, it.ohungarumlaut = 500, it.Eogonek = 611, it.dcroat = 500, it.threequarters = 750, it.Scedilla = 500, it.lcaron = 300, it.Kcommaaccent = 667, it.Lacute = 556, it.trademark = 980, it.edotaccent = 444, it.Igrave = 333, it.Imacron = 333, it.Lcaron = 611, it.onehalf = 750, it.lessequal = 549, it.ocircumflex = 500, it.ntilde = 500, it.Uhungarumlaut = 722, it.Eacute = 611, it.emacron = 444, it.gbreve = 500, it.onequarter = 750, it.Scaron = 500, it.Scommaaccent = 500, it.Ohungarumlaut = 722, it.degree = 400, it.ograve = 500, it.Ccaron = 667, it.ugrave = 500, it.radical = 453, it.Dcaron = 722, it.rcommaaccent = 389, it.Ntilde = 667, it.otilde = 500, it.Rcommaaccent = 611, it.Lcommaaccent = 556, it.Atilde = 611, it.Aogonek = 611, it.Aring = 611, it.Otilde = 722, it.zdotaccent = 389, it.Ecaron = 611, it.Iogonek = 333, it.kcommaaccent = 444, it.minus = 675, it.Icircumflex = 333, it.ncaron = 500, it.tcommaaccent = 278, it.logicalnot = 675, it.odieresis = 500, it.udieresis = 500, it.notequal = 549, it.gcommaaccent = 500, it.eth = 500, it.zcaron = 389, it.ncommaaccent = 500, it.onesuperior = 300, it.imacron = 278, it.Euro = 500;
            }), et.ZapfDingbats = (0, rt.getLookupTableFactory)(function(it) {
              it.space = 278, it.a1 = 974, it.a2 = 961, it.a202 = 974, it.a3 = 980, it.a4 = 719, it.a5 = 789, it.a119 = 790, it.a118 = 791, it.a117 = 690, it.a11 = 960, it.a12 = 939, it.a13 = 549, it.a14 = 855, it.a15 = 911, it.a16 = 933, it.a105 = 911, it.a17 = 945, it.a18 = 974, it.a19 = 755, it.a20 = 846, it.a21 = 762, it.a22 = 761, it.a23 = 571, it.a24 = 677, it.a25 = 763, it.a26 = 760, it.a27 = 759, it.a28 = 754, it.a6 = 494, it.a7 = 552, it.a8 = 537, it.a9 = 577, it.a10 = 692, it.a29 = 786, it.a30 = 788, it.a31 = 788, it.a32 = 790, it.a33 = 793, it.a34 = 794, it.a35 = 816, it.a36 = 823, it.a37 = 789, it.a38 = 841, it.a39 = 823, it.a40 = 833, it.a41 = 816, it.a42 = 831, it.a43 = 923, it.a44 = 744, it.a45 = 723, it.a46 = 749, it.a47 = 790, it.a48 = 792, it.a49 = 695, it.a50 = 776, it.a51 = 768, it.a52 = 792, it.a53 = 759, it.a54 = 707, it.a55 = 708, it.a56 = 682, it.a57 = 701, it.a58 = 826, it.a59 = 815, it.a60 = 789, it.a61 = 789, it.a62 = 707, it.a63 = 687, it.a64 = 696, it.a65 = 689, it.a66 = 786, it.a67 = 787, it.a68 = 713, it.a69 = 791, it.a70 = 785, it.a71 = 791, it.a72 = 873, it.a73 = 761, it.a74 = 762, it.a203 = 762, it.a75 = 759, it.a204 = 759, it.a76 = 892, it.a77 = 892, it.a78 = 788, it.a79 = 784, it.a81 = 438, it.a82 = 138, it.a83 = 277, it.a84 = 415, it.a97 = 392, it.a98 = 392, it.a99 = 668, it.a100 = 668, it.a89 = 390, it.a90 = 390, it.a93 = 317, it.a94 = 317, it.a91 = 276, it.a92 = 276, it.a205 = 509, it.a85 = 509, it.a206 = 410, it.a86 = 410, it.a87 = 234, it.a88 = 234, it.a95 = 334, it.a96 = 334, it.a101 = 732, it.a102 = 544, it.a103 = 544, it.a104 = 910, it.a106 = 667, it.a107 = 760, it.a108 = 760, it.a112 = 776, it.a111 = 595, it.a110 = 694, it.a109 = 626, it.a120 = 788, it.a121 = 788, it.a122 = 788, it.a123 = 788, it.a124 = 788, it.a125 = 788, it.a126 = 788, it.a127 = 788, it.a128 = 788, it.a129 = 788, it.a130 = 788, it.a131 = 788, it.a132 = 788, it.a133 = 788, it.a134 = 788, it.a135 = 788, it.a136 = 788, it.a137 = 788, it.a138 = 788, it.a139 = 788, it.a140 = 788, it.a141 = 788, it.a142 = 788, it.a143 = 788, it.a144 = 788, it.a145 = 788, it.a146 = 788, it.a147 = 788, it.a148 = 788, it.a149 = 788, it.a150 = 788, it.a151 = 788, it.a152 = 788, it.a153 = 788, it.a154 = 788, it.a155 = 788, it.a156 = 788, it.a157 = 788, it.a158 = 788, it.a159 = 788, it.a160 = 894, it.a161 = 838, it.a163 = 1016, it.a164 = 458, it.a196 = 748, it.a165 = 924, it.a192 = 748, it.a166 = 918, it.a167 = 927, it.a168 = 928, it.a169 = 928, it.a170 = 834, it.a171 = 873, it.a172 = 828, it.a173 = 924, it.a162 = 924, it.a174 = 917, it.a175 = 930, it.a176 = 931, it.a177 = 463, it.a178 = 883, it.a179 = 836, it.a193 = 836, it.a180 = 867, it.a199 = 867, it.a181 = 696, it.a200 = 696, it.a182 = 874, it.a201 = 874, it.a183 = 760, it.a184 = 946, it.a197 = 771, it.a185 = 865, it.a194 = 771, it.a198 = 888, it.a186 = 967, it.a195 = 888, it.a187 = 831, it.a188 = 873, it.a189 = 927, it.a190 = 970, it.a191 = 918;
            });
          });
          at.getMetrics = st;
          const lt = (0, rt.getLookupTableFactory)(function(et) {
            et.Courier = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: -426
            }, et["Courier-Bold"] = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: 439
            }, et["Courier-Oblique"] = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: 426
            }, et["Courier-BoldOblique"] = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: 426
            }, et.Helvetica = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 523
            }, et["Helvetica-Bold"] = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 532
            }, et["Helvetica-Oblique"] = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 523
            }, et["Helvetica-BoldOblique"] = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 532
            }, et["Times-Roman"] = {
              ascent: 683,
              descent: -217,
              capHeight: 662,
              xHeight: 450
            }, et["Times-Bold"] = {
              ascent: 683,
              descent: -217,
              capHeight: 676,
              xHeight: 461
            }, et["Times-Italic"] = {
              ascent: 683,
              descent: -217,
              capHeight: 653,
              xHeight: 441
            }, et["Times-BoldItalic"] = {
              ascent: 683,
              descent: -217,
              capHeight: 669,
              xHeight: 462
            }, et.Symbol = {
              ascent: Math.NaN,
              descent: Math.NaN,
              capHeight: Math.NaN,
              xHeight: Math.NaN
            }, et.ZapfDingbats = {
              ascent: Math.NaN,
              descent: Math.NaN,
              capHeight: Math.NaN,
              xHeight: Math.NaN
            };
          });
          at.getFontBasicMetrics = lt;
        },
        /* 197 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.GlyfTable = void 0, ot(140), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(158);
          const rt = 1, st = 2, lt = 4, et = 8, it = 16, ut = 32, ft = 64, ht = 1, dt = 2, gt = 8, pt = 32, mt = 64, ct = 128, vt = 256;
          class At {
            constructor(Pt) {
              let {
                glyfTable: wt,
                isGlyphLocationsLong: Ct,
                locaTable: It,
                numGlyphs: yt
              } = Pt;
              this.glyphs = [];
              const Rt = new DataView(It.buffer, It.byteOffset, It.byteLength), kt = new DataView(wt.buffer, wt.byteOffset, wt.byteLength), jt = Ct ? 4 : 2;
              let Ht = Ct ? Rt.getUint32(0) : 2 * Rt.getUint16(0), Ft = 0;
              for (let _t = 0; _t < yt; _t++) {
                Ft += jt;
                const Nt = Ct ? Rt.getUint32(Ft) : 2 * Rt.getUint16(Ft);
                if (Nt === Ht) {
                  this.glyphs.push(new xt({}));
                  continue;
                }
                const Mt = xt.parse(Ht, kt);
                this.glyphs.push(Mt), Ht = Nt;
              }
            }
            getSize() {
              return this.glyphs.reduce((Pt, wt) => {
                const Ct = wt.getSize();
                return Pt + (Ct + 3 & -4);
              }, 0);
            }
            write() {
              const Pt = this.getSize(), wt = new DataView(new ArrayBuffer(Pt)), Ct = Pt > 131070, It = Ct ? 4 : 2, yt = new DataView(new ArrayBuffer((this.glyphs.length + 1) * It));
              Ct ? yt.setUint32(0, 0) : yt.setUint16(0, 0);
              let Rt = 0, kt = 0;
              for (const jt of this.glyphs)
                Rt += jt.write(Rt, wt), Rt = Rt + 3 & -4, kt += It, Ct ? yt.setUint32(kt, Rt) : yt.setUint16(kt, Rt >> 1);
              return {
                isLocationLong: Ct,
                loca: new Uint8Array(yt.buffer),
                glyf: new Uint8Array(wt.buffer)
              };
            }
            scale(Pt) {
              for (let wt = 0, Ct = this.glyphs.length; wt < Ct; wt++)
                this.glyphs[wt].scale(Pt[wt]);
            }
          }
          at.GlyfTable = At;
          class xt {
            constructor(Pt) {
              let {
                header: wt = null,
                simple: Ct = null,
                composites: It = null
              } = Pt;
              this.header = wt, this.simple = Ct, this.composites = It;
            }
            static parse(Pt, wt) {
              const [Ct, It] = bt.parse(Pt, wt);
              if (Pt += Ct, It.numberOfContours < 0) {
                const Rt = [];
                for (; ; ) {
                  const [kt, jt] = Bt.parse(Pt, wt);
                  if (Pt += kt, Rt.push(jt), !(jt.flags & pt))
                    break;
                }
                return new xt({
                  header: It,
                  composites: Rt
                });
              }
              const yt = St.parse(Pt, wt, It.numberOfContours);
              return new xt({
                header: It,
                simple: yt
              });
            }
            getSize() {
              if (!this.header)
                return 0;
              const Pt = this.simple ? this.simple.getSize() : this.composites.reduce((wt, Ct) => wt + Ct.getSize(), 0);
              return this.header.getSize() + Pt;
            }
            write(Pt, wt) {
              if (!this.header)
                return 0;
              const Ct = Pt;
              if (Pt += this.header.write(Pt, wt), this.simple)
                Pt += this.simple.write(Pt, wt);
              else
                for (const It of this.composites)
                  Pt += It.write(Pt, wt);
              return Pt - Ct;
            }
            scale(Pt) {
              if (!this.header)
                return;
              const wt = (this.header.xMin + this.header.xMax) / 2;
              if (this.header.scale(wt, Pt), this.simple)
                this.simple.scale(wt, Pt);
              else
                for (const Ct of this.composites)
                  Ct.scale(wt, Pt);
            }
          }
          class bt {
            constructor(Pt) {
              let {
                numberOfContours: wt,
                xMin: Ct,
                yMin: It,
                xMax: yt,
                yMax: Rt
              } = Pt;
              this.numberOfContours = wt, this.xMin = Ct, this.yMin = It, this.xMax = yt, this.yMax = Rt;
            }
            static parse(Pt, wt) {
              return [10, new bt({
                numberOfContours: wt.getInt16(Pt),
                xMin: wt.getInt16(Pt + 2),
                yMin: wt.getInt16(Pt + 4),
                xMax: wt.getInt16(Pt + 6),
                yMax: wt.getInt16(Pt + 8)
              })];
            }
            getSize() {
              return 10;
            }
            write(Pt, wt) {
              return wt.setInt16(Pt, this.numberOfContours), wt.setInt16(Pt + 2, this.xMin), wt.setInt16(Pt + 4, this.yMin), wt.setInt16(Pt + 6, this.xMax), wt.setInt16(Pt + 8, this.yMax), 10;
            }
            scale(Pt, wt) {
              this.xMin = Math.round(Pt + (this.xMin - Pt) * wt), this.xMax = Math.round(Pt + (this.xMax - Pt) * wt);
            }
          }
          class Et {
            constructor(Pt) {
              let {
                flags: wt,
                xCoordinates: Ct,
                yCoordinates: It
              } = Pt;
              this.xCoordinates = Ct, this.yCoordinates = It, this.flags = wt;
            }
          }
          class St {
            constructor(Pt) {
              let {
                contours: wt,
                instructions: Ct
              } = Pt;
              this.contours = wt, this.instructions = Ct;
            }
            static parse(Pt, wt, Ct) {
              const It = [];
              for (let Tt = 0; Tt < Ct; Tt++) {
                const Dt = wt.getUint16(Pt);
                Pt += 2, It.push(Dt);
              }
              const yt = It[Ct - 1] + 1, Rt = wt.getUint16(Pt);
              Pt += 2;
              const kt = new Uint8Array(wt).slice(Pt, Pt + Rt);
              Pt += Rt;
              const jt = [];
              for (let Tt = 0; Tt < yt; Pt++, Tt++) {
                let Dt = wt.getUint8(Pt);
                if (jt.push(Dt), Dt & et) {
                  const Ut = wt.getUint8(++Pt);
                  Dt ^= et;
                  for (let Vt = 0; Vt < Ut; Vt++)
                    jt.push(Dt);
                  Tt += Ut;
                }
              }
              const Ht = [];
              let Ft = [], _t = [], Nt = [];
              const Mt = [];
              let Lt = 0, $t = 0;
              for (let Tt = 0; Tt < yt; Tt++) {
                const Dt = jt[Tt];
                if (Dt & st) {
                  const Ut = wt.getUint8(Pt++);
                  $t += Dt & it ? Ut : -Ut, Ft.push($t);
                } else
                  Dt & it || ($t += wt.getInt16(Pt), Pt += 2), Ft.push($t);
                It[Lt] === Tt && (Lt++, Ht.push(Ft), Ft = []);
              }
              $t = 0, Lt = 0;
              for (let Tt = 0; Tt < yt; Tt++) {
                const Dt = jt[Tt];
                if (Dt & lt) {
                  const Ut = wt.getUint8(Pt++);
                  $t += Dt & ut ? Ut : -Ut, _t.push($t);
                } else
                  Dt & ut || ($t += wt.getInt16(Pt), Pt += 2), _t.push($t);
                Nt.push(Dt & rt | Dt & ft), It[Lt] === Tt && (Ft = Ht[Lt], Lt++, Mt.push(new Et({
                  flags: Nt,
                  xCoordinates: Ft,
                  yCoordinates: _t
                })), _t = [], Nt = []);
              }
              return new St({
                contours: Mt,
                instructions: kt
              });
            }
            getSize() {
              let Pt = this.contours.length * 2 + 2 + this.instructions.length, wt = 0, Ct = 0;
              for (const It of this.contours) {
                Pt += It.flags.length;
                for (let yt = 0, Rt = It.xCoordinates.length; yt < Rt; yt++) {
                  const kt = It.xCoordinates[yt], jt = It.yCoordinates[yt];
                  let Ht = Math.abs(kt - wt);
                  Ht > 255 ? Pt += 2 : Ht > 0 && (Pt += 1), wt = kt, Ht = Math.abs(jt - Ct), Ht > 255 ? Pt += 2 : Ht > 0 && (Pt += 1), Ct = jt;
                }
              }
              return Pt;
            }
            write(Pt, wt) {
              const Ct = Pt, It = [], yt = [], Rt = [];
              let kt = 0, jt = 0;
              for (const Ht of this.contours) {
                for (let Ft = 0, _t = Ht.xCoordinates.length; Ft < _t; Ft++) {
                  let Nt = Ht.flags[Ft];
                  const Mt = Ht.xCoordinates[Ft];
                  let Lt = Mt - kt;
                  if (Lt === 0)
                    Nt |= it, It.push(0);
                  else {
                    const Tt = Math.abs(Lt);
                    Tt <= 255 ? (Nt |= Lt >= 0 ? st | it : st, It.push(Tt)) : It.push(Lt);
                  }
                  kt = Mt;
                  const $t = Ht.yCoordinates[Ft];
                  if (Lt = $t - jt, Lt === 0)
                    Nt |= ut, yt.push(0);
                  else {
                    const Tt = Math.abs(Lt);
                    Tt <= 255 ? (Nt |= Lt >= 0 ? lt | ut : lt, yt.push(Tt)) : yt.push(Lt);
                  }
                  jt = $t, Rt.push(Nt);
                }
                wt.setUint16(Pt, It.length - 1), Pt += 2;
              }
              wt.setUint16(Pt, this.instructions.length), Pt += 2, this.instructions.length && (new Uint8Array(wt.buffer, 0, wt.buffer.byteLength).set(this.instructions, Pt), Pt += this.instructions.length);
              for (const Ht of Rt)
                wt.setUint8(Pt++, Ht);
              for (let Ht = 0, Ft = It.length; Ht < Ft; Ht++) {
                const _t = It[Ht], Nt = Rt[Ht];
                Nt & st ? wt.setUint8(Pt++, _t) : Nt & it || (wt.setInt16(Pt, _t), Pt += 2);
              }
              for (let Ht = 0, Ft = yt.length; Ht < Ft; Ht++) {
                const _t = yt[Ht], Nt = Rt[Ht];
                Nt & lt ? wt.setUint8(Pt++, _t) : Nt & ut || (wt.setInt16(Pt, _t), Pt += 2);
              }
              return Pt - Ct;
            }
            scale(Pt, wt) {
              for (const Ct of this.contours)
                if (Ct.xCoordinates.length !== 0)
                  for (let It = 0, yt = Ct.xCoordinates.length; It < yt; It++)
                    Ct.xCoordinates[It] = Math.round(Pt + (Ct.xCoordinates[It] - Pt) * wt);
            }
          }
          class Bt {
            constructor(Pt) {
              let {
                flags: wt,
                glyphIndex: Ct,
                argument1: It,
                argument2: yt,
                transf: Rt,
                instructions: kt
              } = Pt;
              this.flags = wt, this.glyphIndex = Ct, this.argument1 = It, this.argument2 = yt, this.transf = Rt, this.instructions = kt;
            }
            static parse(Pt, wt) {
              const Ct = Pt, It = [];
              let yt = wt.getUint16(Pt);
              const Rt = wt.getUint16(Pt + 2);
              Pt += 4;
              let kt, jt;
              yt & ht ? (yt & dt ? (kt = wt.getInt16(Pt), jt = wt.getInt16(Pt + 2)) : (kt = wt.getUint16(Pt), jt = wt.getUint16(Pt + 2)), Pt += 4, yt ^= ht) : (yt & dt ? (kt = wt.getInt8(Pt), jt = wt.getInt8(Pt + 1)) : (kt = wt.getUint8(Pt), jt = wt.getUint8(Pt + 1)), Pt += 2), yt & gt ? (It.push(wt.getUint16(Pt)), Pt += 2) : yt & mt ? (It.push(wt.getUint16(Pt), wt.getUint16(Pt + 2)), Pt += 4) : yt & ct && (It.push(wt.getUint16(Pt), wt.getUint16(Pt + 2), wt.getUint16(Pt + 4), wt.getUint16(Pt + 6)), Pt += 8);
              let Ht = null;
              if (yt & vt) {
                const Ft = wt.getUint16(Pt);
                Pt += 2, Ht = new Uint8Array(wt).slice(Pt, Pt + Ft), Pt += Ft;
              }
              return [Pt - Ct, new Bt({
                flags: yt,
                glyphIndex: Rt,
                argument1: kt,
                argument2: jt,
                transf: It,
                instructions: Ht
              })];
            }
            getSize() {
              let Pt = 4 + this.transf.length * 2;
              return this.flags & vt && (Pt += 2 + this.instructions.length), Pt += 2, this.flags & 2 ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (Pt += 2) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (Pt += 2), Pt;
            }
            write(Pt, wt) {
              const Ct = Pt;
              return this.flags & dt ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (this.flags |= ht) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (this.flags |= ht), wt.setUint16(Pt, this.flags), wt.setUint16(Pt + 2, this.glyphIndex), Pt += 4, this.flags & ht ? (this.flags & dt ? (wt.setInt16(Pt, this.argument1), wt.setInt16(Pt + 2, this.argument2)) : (wt.setUint16(Pt, this.argument1), wt.setUint16(Pt + 2, this.argument2)), Pt += 4) : (wt.setUint8(Pt, this.argument1), wt.setUint8(Pt + 1, this.argument2), Pt += 2), this.flags & vt && (wt.setUint16(Pt, this.instructions.length), Pt += 2, this.instructions.length && (new Uint8Array(wt.buffer, 0, wt.buffer.byteLength).set(this.instructions, Pt), Pt += this.instructions.length)), Pt - Ct;
            }
            scale(Pt, wt) {
            }
          }
        },
        /* 198 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.OpenTypeFileBuilder = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(140), ot(2);
          var rt = ot(150), st = ot(145);
          function lt(dt, gt, pt) {
            dt[gt] = pt >> 8 & 255, dt[gt + 1] = pt & 255;
          }
          function et(dt, gt, pt) {
            dt[gt] = pt >> 24 & 255, dt[gt + 1] = pt >> 16 & 255, dt[gt + 2] = pt >> 8 & 255, dt[gt + 3] = pt & 255;
          }
          function it(dt, gt, pt) {
            if (pt instanceof Uint8Array)
              dt.set(pt, gt);
            else if (typeof pt == "string")
              for (let mt = 0, ct = pt.length; mt < ct; mt++)
                dt[gt++] = pt.charCodeAt(mt) & 255;
            else
              for (const mt of pt)
                dt[gt++] = mt & 255;
          }
          const ut = 12, ft = 16;
          class ht {
            constructor(gt) {
              this.sfnt = gt, this.tables = /* @__PURE__ */ Object.create(null);
            }
            static getSearchParams(gt, pt) {
              let mt = 1, ct = 0;
              for (; (mt ^ gt) > mt; )
                mt <<= 1, ct++;
              const vt = mt * pt;
              return {
                range: vt,
                entry: ct,
                rangeShift: pt * gt - vt
              };
            }
            toArray() {
              let gt = this.sfnt;
              const pt = this.tables, mt = Object.keys(pt);
              mt.sort();
              const ct = mt.length;
              let vt, At, xt, bt, Et, St = ut + ct * ft;
              const Bt = [St];
              for (vt = 0; vt < ct; vt++) {
                bt = pt[mt[vt]];
                const wt = (bt.length + 3 & -4) >>> 0;
                St += wt, Bt.push(St);
              }
              const Ot = new Uint8Array(St);
              for (vt = 0; vt < ct; vt++)
                bt = pt[mt[vt]], it(Ot, Bt[vt], bt);
              gt === "true" && (gt = (0, st.string32)(65536)), Ot[0] = gt.charCodeAt(0) & 255, Ot[1] = gt.charCodeAt(1) & 255, Ot[2] = gt.charCodeAt(2) & 255, Ot[3] = gt.charCodeAt(3) & 255, lt(Ot, 4, ct);
              const Pt = ht.getSearchParams(ct, 16);
              for (lt(Ot, 6, Pt.range), lt(Ot, 8, Pt.entry), lt(Ot, 10, Pt.rangeShift), St = ut, vt = 0; vt < ct; vt++) {
                Et = mt[vt], Ot[St] = Et.charCodeAt(0) & 255, Ot[St + 1] = Et.charCodeAt(1) & 255, Ot[St + 2] = Et.charCodeAt(2) & 255, Ot[St + 3] = Et.charCodeAt(3) & 255;
                let wt = 0;
                for (At = Bt[vt], xt = Bt[vt + 1]; At < xt; At += 4) {
                  const Ct = (0, rt.readUint32)(Ot, At);
                  wt = wt + Ct >>> 0;
                }
                et(Ot, St + 4, wt), et(Ot, St + 8, Bt[vt]), et(Ot, St + 12, pt[Et].length), St += ft;
              }
              return Ot;
            }
            addTable(gt, pt) {
              if (gt in this.tables)
                throw new Error("Table " + gt + " already exists");
              this.tables[gt] = pt;
            }
          }
          at.OpenTypeFileBuilder = ht;
        },
        /* 199 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Type1Font = void 0, ot(140);
          var rt = ot(186), st = ot(145), lt = ot(189), et = ot(150), it = ot(155), ut = ot(200);
          function ft(pt, mt, ct) {
            const vt = pt.length, At = mt.length, xt = vt - At;
            let bt = ct, Et = !1;
            for (; bt < xt; ) {
              let St = 0;
              for (; St < At && pt[bt + St] === mt[St]; )
                St++;
              if (St >= At) {
                for (bt += St; bt < vt && (0, et.isWhiteSpace)(pt[bt]); )
                  bt++;
                Et = !0;
                break;
              }
              bt++;
            }
            return {
              found: Et,
              length: bt
            };
          }
          function ht(pt, mt) {
            const ct = [101, 101, 120, 101, 99], vt = pt.pos;
            let At, xt, bt;
            try {
              At = pt.getBytes(mt), xt = At.length;
            } catch {
            }
            if (xt === mt && (bt = ft(At, ct, mt - 2 * ct.length), bt.found && bt.length === mt))
              return {
                stream: new it.Stream(At),
                length: mt
              };
            (0, st.warn)('Invalid "Length1" property in Type1 font -- trying to recover.'), pt.pos = vt;
            const Et = 2048;
            let St;
            for (; ; ) {
              const Bt = pt.peekBytes(Et);
              if (bt = ft(Bt, ct, 0), bt.length === 0)
                break;
              if (pt.pos += bt.length, bt.found) {
                St = pt.pos - vt;
                break;
              }
            }
            return pt.pos = vt, St ? {
              stream: new it.Stream(pt.getBytes(St)),
              length: St
            } : ((0, st.warn)('Unable to recover "Length1" property in Type1 font -- using as is.'), {
              stream: new it.Stream(pt.getBytes(mt)),
              length: mt
            });
          }
          function dt(pt, mt) {
            const ct = pt.getBytes();
            if (ct.length === 0)
              throw new st.FormatError("getEexecBlock - no font program found.");
            return {
              stream: new it.Stream(ct),
              length: ct.length
            };
          }
          class gt {
            constructor(mt, ct, vt) {
              let xt = vt.length1;
              vt.length2;
              let bt = ct.peekBytes(6);
              const Et = bt[0] === 128 && bt[1] === 1;
              Et && (ct.skip(6), xt = bt[5] << 24 | bt[4] << 16 | bt[3] << 8 | bt[2]);
              const St = ht(ct, xt);
              new ut.Type1Parser(St.stream, !1, lt.SEAC_ANALYSIS_ENABLED).extractFontHeader(vt), Et && (bt = ct.getBytes(6), bt[5] << 24 | bt[4] << 16 | bt[3] << 8 | bt[2]);
              const Ot = dt(ct), wt = new ut.Type1Parser(Ot.stream, !0, lt.SEAC_ANALYSIS_ENABLED).extractFontProgram(vt);
              for (const Rt in wt.properties)
                vt[Rt] = wt.properties[Rt];
              const Ct = wt.charstrings, It = this.getType2Charstrings(Ct), yt = this.getType2Subrs(wt.subrs);
              this.charstrings = Ct, this.data = this.wrap(mt, It, this.charstrings, yt, vt), this.seacs = this.getSeacs(wt.charstrings);
            }
            get numGlyphs() {
              return this.charstrings.length + 1;
            }
            getCharset() {
              const mt = [".notdef"];
              for (const {
                glyphName: ct
              } of this.charstrings)
                mt.push(ct);
              return mt;
            }
            getGlyphMapping(mt) {
              const ct = this.charstrings;
              if (mt.composite) {
                const Et = /* @__PURE__ */ Object.create(null);
                for (let St = 0, Bt = ct.length; St < Bt; St++) {
                  const Ot = mt.cMap.charCodeOf(St);
                  Et[Ot] = St + 1;
                }
                return Et;
              }
              const vt = [".notdef"];
              let At, xt;
              for (xt = 0; xt < ct.length; xt++)
                vt.push(ct[xt].glyphName);
              const bt = mt.builtInEncoding;
              if (bt) {
                At = /* @__PURE__ */ Object.create(null);
                for (const Et in bt)
                  xt = vt.indexOf(bt[Et]), xt >= 0 && (At[Et] = xt);
              }
              return (0, lt.type1FontGlyphMapping)(mt, At, vt);
            }
            hasGlyphId(mt) {
              return mt < 0 || mt >= this.numGlyphs ? !1 : mt === 0 ? !0 : this.charstrings[mt - 1].charstring.length > 0;
            }
            getSeacs(mt) {
              const ct = [];
              for (let vt = 0, At = mt.length; vt < At; vt++) {
                const xt = mt[vt];
                xt.seac && (ct[vt + 1] = xt.seac);
              }
              return ct;
            }
            getType2Charstrings(mt) {
              const ct = [];
              for (const vt of mt)
                ct.push(vt.charstring);
              return ct;
            }
            getType2Subrs(mt) {
              let ct = 0;
              const vt = mt.length;
              vt < 1133 ? ct = 107 : vt < 33769 ? ct = 1131 : ct = 32768;
              const At = [];
              let xt;
              for (xt = 0; xt < ct; xt++)
                At.push([11]);
              for (xt = 0; xt < vt; xt++)
                At.push(mt[xt]);
              return At;
            }
            wrap(mt, ct, vt, At, xt) {
              const bt = new rt.CFF();
              bt.header = new rt.CFFHeader(1, 0, 4, 4), bt.names = [mt];
              const Et = new rt.CFFTopDict();
              Et.setByName("version", 391), Et.setByName("Notice", 392), Et.setByName("FullName", 393), Et.setByName("FamilyName", 394), Et.setByName("Weight", 395), Et.setByName("Encoding", null), Et.setByName("FontMatrix", xt.fontMatrix), Et.setByName("FontBBox", xt.bbox), Et.setByName("charset", null), Et.setByName("CharStrings", null), Et.setByName("Private", null), bt.topDict = Et;
              const St = new rt.CFFStrings();
              St.add("Version 0.11"), St.add("See original notice"), St.add(mt), St.add(mt), St.add("Medium"), bt.strings = St, bt.globalSubrIndex = new rt.CFFIndex();
              const Bt = ct.length, Ot = [".notdef"];
              let Pt, wt;
              for (Pt = 0; Pt < Bt; Pt++) {
                const jt = vt[Pt].glyphName;
                rt.CFFStandardStrings.indexOf(jt) === -1 && St.add(jt), Ot.push(jt);
              }
              bt.charset = new rt.CFFCharset(!1, 0, Ot);
              const Ct = new rt.CFFIndex();
              for (Ct.add([139, 14]), Pt = 0; Pt < Bt; Pt++)
                Ct.add(ct[Pt]);
              bt.charStrings = Ct;
              const It = new rt.CFFPrivateDict();
              It.setByName("Subrs", null);
              const yt = ["BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StemSnapH", "StemSnapV", "BlueShift", "BlueFuzz", "BlueScale", "LanguageGroup", "ExpansionFactor", "ForceBold", "StdHW", "StdVW"];
              for (Pt = 0, wt = yt.length; Pt < wt; Pt++) {
                const jt = yt[Pt];
                if (!(jt in xt.privateData))
                  continue;
                const Ht = xt.privateData[jt];
                if (Array.isArray(Ht))
                  for (let Ft = Ht.length - 1; Ft > 0; Ft--)
                    Ht[Ft] -= Ht[Ft - 1];
                It.setByName(jt, Ht);
              }
              bt.topDict.privateDict = It;
              const Rt = new rt.CFFIndex();
              for (Pt = 0, wt = At.length; Pt < wt; Pt++)
                Rt.add(At[Pt]);
              return It.subrsIndex = Rt, new rt.CFFCompiler(bt).compile();
            }
          }
          at.Type1Font = gt;
        },
        /* 200 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Type1Parser = void 0, ot(140), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(160);
          var rt = ot(188), st = ot(150), lt = ot(155), et = ot(145);
          const it = !1, ut = {
            hstem: [1],
            vstem: [3],
            vmoveto: [4],
            rlineto: [5],
            hlineto: [6],
            vlineto: [7],
            rrcurveto: [8],
            callsubr: [10],
            flex: [12, 35],
            drop: [12, 18],
            endchar: [14],
            rmoveto: [21],
            hmoveto: [22],
            vhcurveto: [30],
            hvcurveto: [31]
          };
          class ft {
            constructor() {
              this.width = 0, this.lsb = 0, this.flexing = !1, this.output = [], this.stack = [];
            }
            convert(xt, bt, Et) {
              const St = xt.length;
              let Bt = !1, Ot, Pt, wt;
              for (let Ct = 0; Ct < St; Ct++) {
                let It = xt[Ct];
                if (It < 32) {
                  switch (It === 12 && (It = (It << 8) + xt[++Ct]), It) {
                    case 1: {
                      this.stack = [];
                      break;
                    }
                    case 3: {
                      this.stack = [];
                      break;
                    }
                    case 4:
                      if (this.flexing) {
                        if (this.stack.length < 1) {
                          Bt = !0;
                          break;
                        }
                        const Ht = this.stack.pop();
                        this.stack.push(0, Ht);
                        break;
                      }
                      Bt = this.executeCommand(1, ut.vmoveto);
                      break;
                    case 5:
                      Bt = this.executeCommand(2, ut.rlineto);
                      break;
                    case 6:
                      Bt = this.executeCommand(1, ut.hlineto);
                      break;
                    case 7:
                      Bt = this.executeCommand(1, ut.vlineto);
                      break;
                    case 8:
                      Bt = this.executeCommand(6, ut.rrcurveto);
                      break;
                    case 9:
                      this.stack = [];
                      break;
                    case 10:
                      if (this.stack.length < 1) {
                        Bt = !0;
                        break;
                      }
                      if (wt = this.stack.pop(), !bt[wt]) {
                        Bt = !0;
                        break;
                      }
                      Bt = this.convert(bt[wt], bt, Et);
                      break;
                    case 11:
                      return Bt;
                    case 13:
                      if (this.stack.length < 2) {
                        Bt = !0;
                        break;
                      }
                      Ot = this.stack.pop(), Pt = this.stack.pop(), this.lsb = Pt, this.width = Ot, this.stack.push(Ot, Pt), Bt = this.executeCommand(2, ut.hmoveto);
                      break;
                    case 14:
                      this.output.push(ut.endchar[0]);
                      break;
                    case 21:
                      if (this.flexing)
                        break;
                      Bt = this.executeCommand(2, ut.rmoveto);
                      break;
                    case 22:
                      if (this.flexing) {
                        this.stack.push(0);
                        break;
                      }
                      Bt = this.executeCommand(1, ut.hmoveto);
                      break;
                    case 30:
                      Bt = this.executeCommand(4, ut.vhcurveto);
                      break;
                    case 31:
                      Bt = this.executeCommand(4, ut.hvcurveto);
                      break;
                    case 3072:
                      this.stack = [];
                      break;
                    case 3073: {
                      this.stack = [];
                      break;
                    }
                    case 3074: {
                      this.stack = [];
                      break;
                    }
                    case 3078:
                      if (Et) {
                        const Ht = this.stack.at(-5);
                        this.seac = this.stack.splice(-4, 4), this.seac[0] += this.lsb - Ht, Bt = this.executeCommand(0, ut.endchar);
                      } else
                        Bt = this.executeCommand(4, ut.endchar);
                      break;
                    case 3079:
                      if (this.stack.length < 4) {
                        Bt = !0;
                        break;
                      }
                      this.stack.pop(), Ot = this.stack.pop();
                      const yt = this.stack.pop();
                      Pt = this.stack.pop(), this.lsb = Pt, this.width = Ot, this.stack.push(Ot, Pt, yt), Bt = this.executeCommand(3, ut.rmoveto);
                      break;
                    case 3084:
                      if (this.stack.length < 2) {
                        Bt = !0;
                        break;
                      }
                      const Rt = this.stack.pop(), kt = this.stack.pop();
                      this.stack.push(kt / Rt);
                      break;
                    case 3088:
                      if (this.stack.length < 2) {
                        Bt = !0;
                        break;
                      }
                      wt = this.stack.pop();
                      const jt = this.stack.pop();
                      if (wt === 0 && jt === 3) {
                        const Ht = this.stack.splice(-17, 17);
                        this.stack.push(Ht[2] + Ht[0], Ht[3] + Ht[1], Ht[4], Ht[5], Ht[6], Ht[7], Ht[8], Ht[9], Ht[10], Ht[11], Ht[12], Ht[13], Ht[14]), Bt = this.executeCommand(13, ut.flex, !0), this.flexing = !1, this.stack.push(Ht[15], Ht[16]);
                      } else
                        wt === 1 && jt === 0 && (this.flexing = !0);
                      break;
                    case 3089:
                      break;
                    case 3105:
                      this.stack = [];
                      break;
                    default:
                      (0, et.warn)('Unknown type 1 charstring command of "' + It + '"');
                      break;
                  }
                  if (Bt)
                    break;
                  continue;
                } else
                  It <= 246 ? It -= 139 : It <= 250 ? It = (It - 247) * 256 + xt[++Ct] + 108 : It <= 254 ? It = -((It - 251) * 256) - xt[++Ct] - 108 : It = (xt[++Ct] & 255) << 24 | (xt[++Ct] & 255) << 16 | (xt[++Ct] & 255) << 8 | (xt[++Ct] & 255) << 0;
                this.stack.push(It);
              }
              return Bt;
            }
            executeCommand(xt, bt, Et) {
              const St = this.stack.length;
              if (xt > St)
                return !0;
              const Bt = St - xt;
              for (let Ot = Bt; Ot < St; Ot++) {
                let Pt = this.stack[Ot];
                Number.isInteger(Pt) ? this.output.push(28, Pt >> 8 & 255, Pt & 255) : (Pt = 65536 * Pt | 0, this.output.push(255, Pt >> 24 & 255, Pt >> 16 & 255, Pt >> 8 & 255, Pt & 255));
              }
              return this.output.push(...bt), Et ? this.stack.splice(Bt, xt) : this.stack.length = 0, !1;
            }
          }
          const ht = 55665, dt = 4330;
          function gt(At) {
            return At >= 48 && At <= 57 || At >= 65 && At <= 70 || At >= 97 && At <= 102;
          }
          function pt(At, xt, bt) {
            if (bt >= At.length)
              return new Uint8Array(0);
            const Et = 52845, St = 22719;
            let Bt = xt | 0, Ot, Pt;
            for (Ot = 0; Ot < bt; Ot++)
              Bt = (At[Ot] + Bt) * Et + St & 65535;
            const wt = At.length - bt, Ct = new Uint8Array(wt);
            for (Ot = bt, Pt = 0; Pt < wt; Ot++, Pt++) {
              const It = At[Ot];
              Ct[Pt] = It ^ Bt >> 8, Bt = (It + Bt) * Et + St & 65535;
            }
            return Ct;
          }
          function mt(At, xt, bt) {
            let Bt = xt | 0;
            const Ot = At.length, Pt = Ot >>> 1, wt = new Uint8Array(Pt);
            let Ct, It;
            for (Ct = 0, It = 0; Ct < Ot; Ct++) {
              const yt = At[Ct];
              if (!gt(yt))
                continue;
              Ct++;
              let Rt;
              for (; Ct < Ot && !gt(Rt = At[Ct]); )
                Ct++;
              if (Ct < Ot) {
                const kt = parseInt(String.fromCharCode(yt, Rt), 16);
                wt[It++] = kt ^ Bt >> 8, Bt = (kt + Bt) * 52845 + 22719 & 65535;
              }
            }
            return wt.slice(bt, It);
          }
          function ct(At) {
            return At === 47 || At === 91 || At === 93 || At === 123 || At === 125 || At === 40 || At === 41;
          }
          class vt {
            constructor(xt, bt, Et) {
              if (bt) {
                const St = xt.getBytes(), Bt = !((gt(St[0]) || (0, st.isWhiteSpace)(St[0])) && gt(St[1]) && gt(St[2]) && gt(St[3]) && gt(St[4]) && gt(St[5]) && gt(St[6]) && gt(St[7]));
                xt = new lt.Stream(Bt ? pt(St, ht, 4) : mt(St, ht, 4));
              }
              this.seacAnalysisEnabled = !!Et, this.stream = xt, this.nextChar();
            }
            readNumberArray() {
              this.getToken();
              const xt = [];
              for (; ; ) {
                const bt = this.getToken();
                if (bt === null || bt === "]" || bt === "}")
                  break;
                xt.push(parseFloat(bt || 0));
              }
              return xt;
            }
            readNumber() {
              const xt = this.getToken();
              return parseFloat(xt || 0);
            }
            readInt() {
              const xt = this.getToken();
              return parseInt(xt || 0, 10) | 0;
            }
            readBoolean() {
              return this.getToken() === "true" ? 1 : 0;
            }
            nextChar() {
              return this.currentChar = this.stream.getByte();
            }
            prevChar() {
              return this.stream.skip(-2), this.currentChar = this.stream.getByte();
            }
            getToken() {
              let xt = !1, bt = this.currentChar;
              for (; ; ) {
                if (bt === -1)
                  return null;
                if (xt)
                  (bt === 10 || bt === 13) && (xt = !1);
                else if (bt === 37)
                  xt = !0;
                else if (!(0, st.isWhiteSpace)(bt))
                  break;
                bt = this.nextChar();
              }
              if (ct(bt))
                return this.nextChar(), String.fromCharCode(bt);
              let Et = "";
              do
                Et += String.fromCharCode(bt), bt = this.nextChar();
              while (bt >= 0 && !(0, st.isWhiteSpace)(bt) && !ct(bt));
              return Et;
            }
            readCharStrings(xt, bt) {
              return bt === -1 ? xt : pt(xt, dt, bt);
            }
            extractFontProgram(xt) {
              const bt = this.stream, Et = [], St = [], Bt = /* @__PURE__ */ Object.create(null);
              Bt.lenIV = 4;
              const Ot = {
                subrs: [],
                charstrings: [],
                properties: {
                  privateData: Bt
                }
              };
              let Pt, wt, Ct, It;
              for (; (Pt = this.getToken()) !== null; )
                if (Pt === "/")
                  switch (Pt = this.getToken(), Pt) {
                    case "CharStrings":
                      for (this.getToken(), this.getToken(), this.getToken(), this.getToken(); Pt = this.getToken(), !(Pt === null || Pt === "end"); ) {
                        if (Pt !== "/")
                          continue;
                        const Rt = this.getToken();
                        wt = this.readInt(), this.getToken(), Ct = wt > 0 ? bt.getBytes(wt) : new Uint8Array(0), It = Ot.properties.privateData.lenIV;
                        const kt = this.readCharStrings(Ct, It);
                        this.nextChar(), Pt = this.getToken(), Pt === "noaccess" ? this.getToken() : Pt === "/" && this.prevChar(), St.push({
                          glyph: Rt,
                          encoded: kt
                        });
                      }
                      break;
                    case "Subrs":
                      for (this.readInt(), this.getToken(); this.getToken() === "dup"; ) {
                        const Rt = this.readInt();
                        wt = this.readInt(), this.getToken(), Ct = wt > 0 ? bt.getBytes(wt) : new Uint8Array(0), It = Ot.properties.privateData.lenIV;
                        const kt = this.readCharStrings(Ct, It);
                        this.nextChar(), Pt = this.getToken(), Pt === "noaccess" && this.getToken(), Et[Rt] = kt;
                      }
                      break;
                    case "BlueValues":
                    case "OtherBlues":
                    case "FamilyBlues":
                    case "FamilyOtherBlues":
                      const yt = this.readNumberArray();
                      yt.length > 0 && yt.length % 2 === 0 && it && (Ot.properties.privateData[Pt] = yt);
                      break;
                    case "StemSnapH":
                    case "StemSnapV":
                      Ot.properties.privateData[Pt] = this.readNumberArray();
                      break;
                    case "StdHW":
                    case "StdVW":
                      Ot.properties.privateData[Pt] = this.readNumberArray()[0];
                      break;
                    case "BlueShift":
                    case "lenIV":
                    case "BlueFuzz":
                    case "BlueScale":
                    case "LanguageGroup":
                      Ot.properties.privateData[Pt] = this.readNumber();
                      break;
                    case "ExpansionFactor":
                      Ot.properties.privateData[Pt] = this.readNumber() || 0.06;
                      break;
                    case "ForceBold":
                      Ot.properties.privateData[Pt] = this.readBoolean();
                      break;
                  }
              for (const {
                encoded: yt,
                glyph: Rt
              } of St) {
                const kt = new ft(), jt = kt.convert(yt, Et, this.seacAnalysisEnabled);
                let Ht = kt.output;
                jt && (Ht = [14]);
                const Ft = {
                  glyphName: Rt,
                  charstring: Ht,
                  width: kt.width,
                  lsb: kt.lsb,
                  seac: kt.seac
                };
                if (Rt === ".notdef" ? Ot.charstrings.unshift(Ft) : Ot.charstrings.push(Ft), xt.builtInEncoding) {
                  const _t = xt.builtInEncoding.indexOf(Rt);
                  _t > -1 && xt.widths[_t] === void 0 && _t >= xt.firstChar && _t <= xt.lastChar && (xt.widths[_t] = kt.width);
                }
              }
              return Ot;
            }
            extractFontHeader(xt) {
              let bt;
              for (; (bt = this.getToken()) !== null; )
                if (bt === "/")
                  switch (bt = this.getToken(), bt) {
                    case "FontMatrix":
                      const Et = this.readNumberArray();
                      xt.fontMatrix = Et;
                      break;
                    case "Encoding":
                      const St = this.getToken();
                      let Bt;
                      if (!/^\d+$/.test(St))
                        Bt = (0, rt.getEncoding)(St);
                      else {
                        Bt = [];
                        const Pt = parseInt(St, 10) | 0;
                        this.getToken();
                        for (let wt = 0; wt < Pt; wt++) {
                          for (bt = this.getToken(); bt !== "dup" && bt !== "def"; )
                            if (bt = this.getToken(), bt === null)
                              return;
                          if (bt === "def")
                            break;
                          const Ct = this.readInt();
                          this.getToken();
                          const It = this.getToken();
                          Bt[Ct] = It, this.getToken();
                        }
                      }
                      xt.builtInEncoding = Bt;
                      break;
                    case "FontBBox":
                      const Ot = this.readNumberArray();
                      xt.ascent = Math.max(Ot[3], Ot[1]), xt.descent = Math.min(Ot[1], Ot[3]), xt.ascentScaled = !0;
                      break;
                  }
            }
          }
          at.Type1Parser = vt;
        },
        /* 201 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Pattern = void 0, at.clearPatternCaches = ct, at.getTilingPatternIR = xt, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(140), ot(160);
          var rt = ot(145), st = ot(152), lt = ot(163), et = ot(150);
          const it = {
            FUNCTION_BASED: 1,
            AXIAL: 2,
            RADIAL: 3,
            FREE_FORM_MESH: 4,
            LATTICE_FORM_MESH: 5,
            COONS_PATCH_MESH: 6,
            TENSOR_PATCH_MESH: 7
          };
          class ut {
            constructor() {
              (0, rt.unreachable)("Cannot initialize Pattern.");
            }
            static parseShading(Bt, Ot, Pt, wt, Ct) {
              const It = Bt instanceof st.BaseStream ? Bt.dict : Bt, yt = It.get("ShadingType");
              try {
                switch (yt) {
                  case it.AXIAL:
                  case it.RADIAL:
                    return new ht(It, Ot, Pt, wt, Ct);
                  case it.FREE_FORM_MESH:
                  case it.LATTICE_FORM_MESH:
                  case it.COONS_PATCH_MESH:
                  case it.TENSOR_PATCH_MESH:
                    return new vt(Bt, Ot, Pt, wt, Ct);
                  default:
                    throw new rt.FormatError("Unsupported ShadingType: " + yt);
                }
              } catch (Rt) {
                if (Rt instanceof et.MissingDataException)
                  throw Rt;
                return (0, rt.warn)(Rt), new At();
              }
            }
          }
          at.Pattern = ut;
          const bt = class bt {
            constructor() {
              this.constructor === bt && (0, rt.unreachable)("Cannot initialize BaseShading.");
            }
            getIR() {
              (0, rt.unreachable)("Abstract method `getIR` called.");
            }
          };
          Ln(bt, "SMALL_NUMBER", 1e-6);
          let ft = bt;
          class ht extends ft {
            constructor(Bt, Ot, Pt, wt, Ct) {
              super(), this.coordsArr = Bt.getArray("Coords"), this.shadingType = Bt.get("ShadingType");
              const It = lt.ColorSpace.parse({
                cs: Bt.getRaw("CS") || Bt.getRaw("ColorSpace"),
                xref: Ot,
                resources: Pt,
                pdfFunctionFactory: wt,
                localColorSpaceCache: Ct
              }), yt = Bt.getArray("BBox");
              this.bbox = Array.isArray(yt) && yt.length === 4 ? rt.Util.normalizeRect(yt) : null;
              let Rt = 0, kt = 1;
              if (Bt.has("Domain")) {
                const sr = Bt.getArray("Domain");
                Rt = sr[0], kt = sr[1];
              }
              let jt = !1, Ht = !1;
              if (Bt.has("Extend")) {
                const sr = Bt.getArray("Extend");
                jt = sr[0], Ht = sr[1];
              }
              if (this.shadingType === it.RADIAL && (!jt || !Ht)) {
                const [sr, cr, or, Xt, Gt, Wt] = this.coordsArr, er = Math.hypot(sr - Xt, cr - Gt);
                or <= Wt + er && Wt <= or + er && (0, rt.warn)("Unsupported radial gradient.");
              }
              this.extendStart = jt, this.extendEnd = Ht;
              const Ft = Bt.getRaw("Function"), _t = wt.createFromArray(Ft), Nt = 840, Mt = (kt - Rt) / Nt, Lt = this.colorStops = [];
              if (Rt >= kt || Mt <= 0) {
                (0, rt.info)("Bad shading domain.");
                return;
              }
              const $t = new Float32Array(It.numComps), Tt = new Float32Array(1);
              let Dt, Ut = 0;
              Tt[0] = Rt, _t(Tt, 0, $t, 0);
              let Vt = It.getRgb($t, 0);
              const Qt = rt.Util.makeHexColor(Vt[0], Vt[1], Vt[2]);
              Lt.push([0, Qt]);
              let qt = 1;
              Tt[0] = Rt + Mt, _t(Tt, 0, $t, 0);
              let Zt = It.getRgb($t, 0), ar = Zt[0] - Vt[0] + 1, Jt = Zt[1] - Vt[1] + 1, rr = Zt[2] - Vt[2] + 1, Yt = Zt[0] - Vt[0] - 1, Kt = Zt[1] - Vt[1] - 1, nr = Zt[2] - Vt[2] - 1;
              for (let sr = 2; sr < Nt; sr++) {
                Tt[0] = Rt + sr * Mt, _t(Tt, 0, $t, 0), Dt = It.getRgb($t, 0);
                const cr = sr - Ut;
                if (ar = Math.min(ar, (Dt[0] - Vt[0] + 1) / cr), Jt = Math.min(Jt, (Dt[1] - Vt[1] + 1) / cr), rr = Math.min(rr, (Dt[2] - Vt[2] + 1) / cr), Yt = Math.max(Yt, (Dt[0] - Vt[0] - 1) / cr), Kt = Math.max(Kt, (Dt[1] - Vt[1] - 1) / cr), nr = Math.max(nr, (Dt[2] - Vt[2] - 1) / cr), !(Yt <= ar && Kt <= Jt && nr <= rr)) {
                  const Xt = rt.Util.makeHexColor(Zt[0], Zt[1], Zt[2]);
                  Lt.push([qt / Nt, Xt]), ar = Dt[0] - Zt[0] + 1, Jt = Dt[1] - Zt[1] + 1, rr = Dt[2] - Zt[2] + 1, Yt = Dt[0] - Zt[0] - 1, Kt = Dt[1] - Zt[1] - 1, nr = Dt[2] - Zt[2] - 1, Ut = qt, Vt = Zt;
                }
                qt = sr, Zt = Dt;
              }
              const tr = rt.Util.makeHexColor(Zt[0], Zt[1], Zt[2]);
              Lt.push([1, tr]);
              let ir = "transparent";
              Bt.has("Background") && (Dt = It.getRgb(Bt.get("Background"), 0), ir = rt.Util.makeHexColor(Dt[0], Dt[1], Dt[2])), jt || (Lt.unshift([0, ir]), Lt[1][0] += ft.SMALL_NUMBER), Ht || (Lt.at(-1)[0] -= ft.SMALL_NUMBER, Lt.push([1, ir])), this.colorStops = Lt;
            }
            getIR() {
              const Bt = this.coordsArr, Ot = this.shadingType;
              let Pt, wt, Ct, It, yt;
              return Ot === it.AXIAL ? (wt = [Bt[0], Bt[1]], Ct = [Bt[2], Bt[3]], It = null, yt = null, Pt = "axial") : Ot === it.RADIAL ? (wt = [Bt[0], Bt[1]], Ct = [Bt[3], Bt[4]], It = Bt[2], yt = Bt[5], Pt = "radial") : (0, rt.unreachable)(`getPattern type unknown: ${Ot}`), ["RadialAxial", Pt, this.bbox, this.colorStops, wt, Ct, It, yt];
            }
          }
          class dt {
            constructor(Bt, Ot) {
              this.stream = Bt, this.context = Ot, this.buffer = 0, this.bufferLength = 0;
              const Pt = Ot.numComps;
              this.tmpCompsBuf = new Float32Array(Pt);
              const wt = Ot.colorSpace.numComps;
              this.tmpCsCompsBuf = Ot.colorFn ? new Float32Array(wt) : this.tmpCompsBuf;
            }
            get hasData() {
              if (this.stream.end)
                return this.stream.pos < this.stream.end;
              if (this.bufferLength > 0)
                return !0;
              const Bt = this.stream.getByte();
              return Bt < 0 ? !1 : (this.buffer = Bt, this.bufferLength = 8, !0);
            }
            readBits(Bt) {
              let Ot = this.buffer, Pt = this.bufferLength;
              if (Bt === 32) {
                if (Pt === 0)
                  return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
                Ot = Ot << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
                const wt = this.stream.getByte();
                return this.buffer = wt & (1 << Pt) - 1, (Ot << 8 - Pt | (wt & 255) >> Pt) >>> 0;
              }
              if (Bt === 8 && Pt === 0)
                return this.stream.getByte();
              for (; Pt < Bt; )
                Ot = Ot << 8 | this.stream.getByte(), Pt += 8;
              return Pt -= Bt, this.bufferLength = Pt, this.buffer = Ot & (1 << Pt) - 1, Ot >> Pt;
            }
            align() {
              this.buffer = 0, this.bufferLength = 0;
            }
            readFlag() {
              return this.readBits(this.context.bitsPerFlag);
            }
            readCoordinate() {
              const Bt = this.context.bitsPerCoordinate, Ot = this.readBits(Bt), Pt = this.readBits(Bt), wt = this.context.decode, Ct = Bt < 32 ? 1 / ((1 << Bt) - 1) : 23283064365386963e-26;
              return [Ot * Ct * (wt[1] - wt[0]) + wt[0], Pt * Ct * (wt[3] - wt[2]) + wt[2]];
            }
            readComponents() {
              const Bt = this.context.numComps, Ot = this.context.bitsPerComponent, Pt = Ot < 32 ? 1 / ((1 << Ot) - 1) : 23283064365386963e-26, wt = this.context.decode, Ct = this.tmpCompsBuf;
              for (let yt = 0, Rt = 4; yt < Bt; yt++, Rt += 2) {
                const kt = this.readBits(Ot);
                Ct[yt] = kt * Pt * (wt[Rt + 1] - wt[Rt]) + wt[Rt];
              }
              const It = this.tmpCsCompsBuf;
              return this.context.colorFn && this.context.colorFn(Ct, 0, It, 0), this.context.colorSpace.getRgb(It, 0);
            }
          }
          let gt = /* @__PURE__ */ Object.create(null);
          function pt(St) {
            const Bt = [];
            for (let Ot = 0; Ot <= St; Ot++) {
              const Pt = Ot / St, wt = 1 - Pt;
              Bt.push(new Float32Array([wt ** 3, 3 * Pt * wt ** 2, 3 * Pt ** 2 * wt, Pt ** 3]));
            }
            return Bt;
          }
          function mt(St) {
            return gt[St] || (gt[St] = pt(St));
          }
          function ct() {
            gt = /* @__PURE__ */ Object.create(null);
          }
          const Et = class Et extends ft {
            constructor(Bt, Ot, Pt, wt, Ct) {
              if (super(), !(Bt instanceof st.BaseStream))
                throw new rt.FormatError("Mesh data is not a stream");
              const It = Bt.dict;
              this.shadingType = It.get("ShadingType");
              const yt = It.getArray("BBox");
              this.bbox = Array.isArray(yt) && yt.length === 4 ? rt.Util.normalizeRect(yt) : null;
              const Rt = lt.ColorSpace.parse({
                cs: It.getRaw("CS") || It.getRaw("ColorSpace"),
                xref: Ot,
                resources: Pt,
                pdfFunctionFactory: wt,
                localColorSpaceCache: Ct
              });
              this.background = It.has("Background") ? Rt.getRgb(It.get("Background"), 0) : null;
              const kt = It.getRaw("Function"), jt = kt ? wt.createFromArray(kt) : null;
              this.coords = [], this.colors = [], this.figures = [];
              const Ht = {
                bitsPerCoordinate: It.get("BitsPerCoordinate"),
                bitsPerComponent: It.get("BitsPerComponent"),
                bitsPerFlag: It.get("BitsPerFlag"),
                decode: It.getArray("Decode"),
                colorFn: jt,
                colorSpace: Rt,
                numComps: jt ? 1 : Rt.numComps
              }, Ft = new dt(Bt, Ht);
              let _t = !1;
              switch (this.shadingType) {
                case it.FREE_FORM_MESH:
                  this._decodeType4Shading(Ft);
                  break;
                case it.LATTICE_FORM_MESH:
                  const Nt = It.get("VerticesPerRow") | 0;
                  if (Nt < 2)
                    throw new rt.FormatError("Invalid VerticesPerRow");
                  this._decodeType5Shading(Ft, Nt);
                  break;
                case it.COONS_PATCH_MESH:
                  this._decodeType6Shading(Ft), _t = !0;
                  break;
                case it.TENSOR_PATCH_MESH:
                  this._decodeType7Shading(Ft), _t = !0;
                  break;
                default:
                  (0, rt.unreachable)("Unsupported mesh type.");
                  break;
              }
              if (_t) {
                this._updateBounds();
                for (let Nt = 0, Mt = this.figures.length; Nt < Mt; Nt++)
                  this._buildFigureFromPatch(Nt);
              }
              this._updateBounds(), this._packData();
            }
            _decodeType4Shading(Bt) {
              const Ot = this.coords, Pt = this.colors, wt = [];
              let Ct = 0;
              for (; Bt.hasData; ) {
                const It = Bt.readFlag(), yt = Bt.readCoordinate(), Rt = Bt.readComponents();
                if (Ct === 0) {
                  if (!(0 <= It && It <= 2))
                    throw new rt.FormatError("Unknown type4 flag");
                  switch (It) {
                    case 0:
                      Ct = 3;
                      break;
                    case 1:
                      wt.push(wt.at(-2), wt.at(-1)), Ct = 1;
                      break;
                    case 2:
                      wt.push(wt.at(-3), wt.at(-1)), Ct = 1;
                      break;
                  }
                }
                wt.push(Ot.length), Ot.push(yt), Pt.push(Rt), Ct--, Bt.align();
              }
              this.figures.push({
                type: "triangles",
                coords: new Int32Array(wt),
                colors: new Int32Array(wt)
              });
            }
            _decodeType5Shading(Bt, Ot) {
              const Pt = this.coords, wt = this.colors, Ct = [];
              for (; Bt.hasData; ) {
                const It = Bt.readCoordinate(), yt = Bt.readComponents();
                Ct.push(Pt.length), Pt.push(It), wt.push(yt);
              }
              this.figures.push({
                type: "lattice",
                coords: new Int32Array(Ct),
                colors: new Int32Array(Ct),
                verticesPerRow: Ot
              });
            }
            _decodeType6Shading(Bt) {
              const Ot = this.coords, Pt = this.colors, wt = new Int32Array(16), Ct = new Int32Array(4);
              for (; Bt.hasData; ) {
                const It = Bt.readFlag();
                if (!(0 <= It && It <= 3))
                  throw new rt.FormatError("Unknown type6 flag");
                const yt = Ot.length;
                for (let _t = 0, Nt = It !== 0 ? 8 : 12; _t < Nt; _t++)
                  Ot.push(Bt.readCoordinate());
                const Rt = Pt.length;
                for (let _t = 0, Nt = It !== 0 ? 2 : 4; _t < Nt; _t++)
                  Pt.push(Bt.readComponents());
                let kt, jt, Ht, Ft;
                switch (It) {
                  case 0:
                    wt[12] = yt + 3, wt[13] = yt + 4, wt[14] = yt + 5, wt[15] = yt + 6, wt[8] = yt + 2, wt[11] = yt + 7, wt[4] = yt + 1, wt[7] = yt + 8, wt[0] = yt, wt[1] = yt + 11, wt[2] = yt + 10, wt[3] = yt + 9, Ct[2] = Rt + 1, Ct[3] = Rt + 2, Ct[0] = Rt, Ct[1] = Rt + 3;
                    break;
                  case 1:
                    kt = wt[12], jt = wt[13], Ht = wt[14], Ft = wt[15], wt[12] = Ft, wt[13] = yt + 0, wt[14] = yt + 1, wt[15] = yt + 2, wt[8] = Ht, wt[11] = yt + 3, wt[4] = jt, wt[7] = yt + 4, wt[0] = kt, wt[1] = yt + 7, wt[2] = yt + 6, wt[3] = yt + 5, kt = Ct[2], jt = Ct[3], Ct[2] = jt, Ct[3] = Rt, Ct[0] = kt, Ct[1] = Rt + 1;
                    break;
                  case 2:
                    kt = wt[15], jt = wt[11], wt[12] = wt[3], wt[13] = yt + 0, wt[14] = yt + 1, wt[15] = yt + 2, wt[8] = wt[7], wt[11] = yt + 3, wt[4] = jt, wt[7] = yt + 4, wt[0] = kt, wt[1] = yt + 7, wt[2] = yt + 6, wt[3] = yt + 5, kt = Ct[3], Ct[2] = Ct[1], Ct[3] = Rt, Ct[0] = kt, Ct[1] = Rt + 1;
                    break;
                  case 3:
                    wt[12] = wt[0], wt[13] = yt + 0, wt[14] = yt + 1, wt[15] = yt + 2, wt[8] = wt[1], wt[11] = yt + 3, wt[4] = wt[2], wt[7] = yt + 4, wt[0] = wt[3], wt[1] = yt + 7, wt[2] = yt + 6, wt[3] = yt + 5, Ct[2] = Ct[0], Ct[3] = Rt, Ct[0] = Ct[1], Ct[1] = Rt + 1;
                    break;
                }
                wt[5] = Ot.length, Ot.push([(-4 * Ot[wt[0]][0] - Ot[wt[15]][0] + 6 * (Ot[wt[4]][0] + Ot[wt[1]][0]) - 2 * (Ot[wt[12]][0] + Ot[wt[3]][0]) + 3 * (Ot[wt[13]][0] + Ot[wt[7]][0])) / 9, (-4 * Ot[wt[0]][1] - Ot[wt[15]][1] + 6 * (Ot[wt[4]][1] + Ot[wt[1]][1]) - 2 * (Ot[wt[12]][1] + Ot[wt[3]][1]) + 3 * (Ot[wt[13]][1] + Ot[wt[7]][1])) / 9]), wt[6] = Ot.length, Ot.push([(-4 * Ot[wt[3]][0] - Ot[wt[12]][0] + 6 * (Ot[wt[2]][0] + Ot[wt[7]][0]) - 2 * (Ot[wt[0]][0] + Ot[wt[15]][0]) + 3 * (Ot[wt[4]][0] + Ot[wt[14]][0])) / 9, (-4 * Ot[wt[3]][1] - Ot[wt[12]][1] + 6 * (Ot[wt[2]][1] + Ot[wt[7]][1]) - 2 * (Ot[wt[0]][1] + Ot[wt[15]][1]) + 3 * (Ot[wt[4]][1] + Ot[wt[14]][1])) / 9]), wt[9] = Ot.length, Ot.push([(-4 * Ot[wt[12]][0] - Ot[wt[3]][0] + 6 * (Ot[wt[8]][0] + Ot[wt[13]][0]) - 2 * (Ot[wt[0]][0] + Ot[wt[15]][0]) + 3 * (Ot[wt[11]][0] + Ot[wt[1]][0])) / 9, (-4 * Ot[wt[12]][1] - Ot[wt[3]][1] + 6 * (Ot[wt[8]][1] + Ot[wt[13]][1]) - 2 * (Ot[wt[0]][1] + Ot[wt[15]][1]) + 3 * (Ot[wt[11]][1] + Ot[wt[1]][1])) / 9]), wt[10] = Ot.length, Ot.push([(-4 * Ot[wt[15]][0] - Ot[wt[0]][0] + 6 * (Ot[wt[11]][0] + Ot[wt[14]][0]) - 2 * (Ot[wt[12]][0] + Ot[wt[3]][0]) + 3 * (Ot[wt[2]][0] + Ot[wt[8]][0])) / 9, (-4 * Ot[wt[15]][1] - Ot[wt[0]][1] + 6 * (Ot[wt[11]][1] + Ot[wt[14]][1]) - 2 * (Ot[wt[12]][1] + Ot[wt[3]][1]) + 3 * (Ot[wt[2]][1] + Ot[wt[8]][1])) / 9]), this.figures.push({
                  type: "patch",
                  coords: new Int32Array(wt),
                  colors: new Int32Array(Ct)
                });
              }
            }
            _decodeType7Shading(Bt) {
              const Ot = this.coords, Pt = this.colors, wt = new Int32Array(16), Ct = new Int32Array(4);
              for (; Bt.hasData; ) {
                const It = Bt.readFlag();
                if (!(0 <= It && It <= 3))
                  throw new rt.FormatError("Unknown type7 flag");
                const yt = Ot.length;
                for (let _t = 0, Nt = It !== 0 ? 12 : 16; _t < Nt; _t++)
                  Ot.push(Bt.readCoordinate());
                const Rt = Pt.length;
                for (let _t = 0, Nt = It !== 0 ? 2 : 4; _t < Nt; _t++)
                  Pt.push(Bt.readComponents());
                let kt, jt, Ht, Ft;
                switch (It) {
                  case 0:
                    wt[12] = yt + 3, wt[13] = yt + 4, wt[14] = yt + 5, wt[15] = yt + 6, wt[8] = yt + 2, wt[9] = yt + 13, wt[10] = yt + 14, wt[11] = yt + 7, wt[4] = yt + 1, wt[5] = yt + 12, wt[6] = yt + 15, wt[7] = yt + 8, wt[0] = yt, wt[1] = yt + 11, wt[2] = yt + 10, wt[3] = yt + 9, Ct[2] = Rt + 1, Ct[3] = Rt + 2, Ct[0] = Rt, Ct[1] = Rt + 3;
                    break;
                  case 1:
                    kt = wt[12], jt = wt[13], Ht = wt[14], Ft = wt[15], wt[12] = Ft, wt[13] = yt + 0, wt[14] = yt + 1, wt[15] = yt + 2, wt[8] = Ht, wt[9] = yt + 9, wt[10] = yt + 10, wt[11] = yt + 3, wt[4] = jt, wt[5] = yt + 8, wt[6] = yt + 11, wt[7] = yt + 4, wt[0] = kt, wt[1] = yt + 7, wt[2] = yt + 6, wt[3] = yt + 5, kt = Ct[2], jt = Ct[3], Ct[2] = jt, Ct[3] = Rt, Ct[0] = kt, Ct[1] = Rt + 1;
                    break;
                  case 2:
                    kt = wt[15], jt = wt[11], wt[12] = wt[3], wt[13] = yt + 0, wt[14] = yt + 1, wt[15] = yt + 2, wt[8] = wt[7], wt[9] = yt + 9, wt[10] = yt + 10, wt[11] = yt + 3, wt[4] = jt, wt[5] = yt + 8, wt[6] = yt + 11, wt[7] = yt + 4, wt[0] = kt, wt[1] = yt + 7, wt[2] = yt + 6, wt[3] = yt + 5, kt = Ct[3], Ct[2] = Ct[1], Ct[3] = Rt, Ct[0] = kt, Ct[1] = Rt + 1;
                    break;
                  case 3:
                    wt[12] = wt[0], wt[13] = yt + 0, wt[14] = yt + 1, wt[15] = yt + 2, wt[8] = wt[1], wt[9] = yt + 9, wt[10] = yt + 10, wt[11] = yt + 3, wt[4] = wt[2], wt[5] = yt + 8, wt[6] = yt + 11, wt[7] = yt + 4, wt[0] = wt[3], wt[1] = yt + 7, wt[2] = yt + 6, wt[3] = yt + 5, Ct[2] = Ct[0], Ct[3] = Rt, Ct[0] = Ct[1], Ct[1] = Rt + 1;
                    break;
                }
                this.figures.push({
                  type: "patch",
                  coords: new Int32Array(wt),
                  colors: new Int32Array(Ct)
                });
              }
            }
            _buildFigureFromPatch(Bt) {
              const Ot = this.figures[Bt];
              (0, rt.assert)(Ot.type === "patch", "Unexpected patch mesh figure");
              const Pt = this.coords, wt = this.colors, Ct = Ot.coords, It = Ot.colors, yt = Math.min(Pt[Ct[0]][0], Pt[Ct[3]][0], Pt[Ct[12]][0], Pt[Ct[15]][0]), Rt = Math.min(Pt[Ct[0]][1], Pt[Ct[3]][1], Pt[Ct[12]][1], Pt[Ct[15]][1]), kt = Math.max(Pt[Ct[0]][0], Pt[Ct[3]][0], Pt[Ct[12]][0], Pt[Ct[15]][0]), jt = Math.max(Pt[Ct[0]][1], Pt[Ct[3]][1], Pt[Ct[12]][1], Pt[Ct[15]][1]);
              let Ht = Math.ceil((kt - yt) * Et.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
              Ht = Math.max(Et.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(Et.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, Ht));
              let Ft = Math.ceil((jt - Rt) * Et.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
              Ft = Math.max(Et.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(Et.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, Ft));
              const _t = Ht + 1, Nt = new Int32Array((Ft + 1) * _t), Mt = new Int32Array((Ft + 1) * _t);
              let Lt = 0;
              const $t = new Uint8Array(3), Tt = new Uint8Array(3), Dt = wt[It[0]], Ut = wt[It[1]], Vt = wt[It[2]], Qt = wt[It[3]], qt = mt(Ft), Zt = mt(Ht);
              for (let ar = 0; ar <= Ft; ar++) {
                $t[0] = (Dt[0] * (Ft - ar) + Vt[0] * ar) / Ft | 0, $t[1] = (Dt[1] * (Ft - ar) + Vt[1] * ar) / Ft | 0, $t[2] = (Dt[2] * (Ft - ar) + Vt[2] * ar) / Ft | 0, Tt[0] = (Ut[0] * (Ft - ar) + Qt[0] * ar) / Ft | 0, Tt[1] = (Ut[1] * (Ft - ar) + Qt[1] * ar) / Ft | 0, Tt[2] = (Ut[2] * (Ft - ar) + Qt[2] * ar) / Ft | 0;
                for (let Jt = 0; Jt <= Ht; Jt++, Lt++) {
                  if ((ar === 0 || ar === Ft) && (Jt === 0 || Jt === Ht))
                    continue;
                  let rr = 0, Yt = 0, Kt = 0;
                  for (let tr = 0; tr <= 3; tr++)
                    for (let ir = 0; ir <= 3; ir++, Kt++) {
                      const sr = qt[ar][tr] * Zt[Jt][ir];
                      rr += Pt[Ct[Kt]][0] * sr, Yt += Pt[Ct[Kt]][1] * sr;
                    }
                  Nt[Lt] = Pt.length, Pt.push([rr, Yt]), Mt[Lt] = wt.length;
                  const nr = new Uint8Array(3);
                  nr[0] = ($t[0] * (Ht - Jt) + Tt[0] * Jt) / Ht | 0, nr[1] = ($t[1] * (Ht - Jt) + Tt[1] * Jt) / Ht | 0, nr[2] = ($t[2] * (Ht - Jt) + Tt[2] * Jt) / Ht | 0, wt.push(nr);
                }
              }
              Nt[0] = Ct[0], Mt[0] = It[0], Nt[Ht] = Ct[3], Mt[Ht] = It[1], Nt[_t * Ft] = Ct[12], Mt[_t * Ft] = It[2], Nt[_t * Ft + Ht] = Ct[15], Mt[_t * Ft + Ht] = It[3], this.figures[Bt] = {
                type: "lattice",
                coords: Nt,
                colors: Mt,
                verticesPerRow: _t
              };
            }
            _updateBounds() {
              let Bt = this.coords[0][0], Ot = this.coords[0][1], Pt = Bt, wt = Ot;
              for (let Ct = 1, It = this.coords.length; Ct < It; Ct++) {
                const yt = this.coords[Ct][0], Rt = this.coords[Ct][1];
                Bt = Bt > yt ? yt : Bt, Ot = Ot > Rt ? Rt : Ot, Pt = Pt < yt ? yt : Pt, wt = wt < Rt ? Rt : wt;
              }
              this.bounds = [Bt, Ot, Pt, wt];
            }
            _packData() {
              let Bt, Ot, Pt, wt;
              const Ct = this.coords, It = new Float32Array(Ct.length * 2);
              for (Bt = 0, Pt = 0, Ot = Ct.length; Bt < Ot; Bt++) {
                const jt = Ct[Bt];
                It[Pt++] = jt[0], It[Pt++] = jt[1];
              }
              this.coords = It;
              const yt = this.colors, Rt = new Uint8Array(yt.length * 3);
              for (Bt = 0, Pt = 0, Ot = yt.length; Bt < Ot; Bt++) {
                const jt = yt[Bt];
                Rt[Pt++] = jt[0], Rt[Pt++] = jt[1], Rt[Pt++] = jt[2];
              }
              this.colors = Rt;
              const kt = this.figures;
              for (Bt = 0, Ot = kt.length; Bt < Ot; Bt++) {
                const jt = kt[Bt], Ht = jt.coords, Ft = jt.colors;
                for (Pt = 0, wt = Ht.length; Pt < wt; Pt++)
                  Ht[Pt] *= 2, Ft[Pt] *= 3;
              }
            }
            getIR() {
              return ["Mesh", this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.bbox, this.background];
            }
          };
          Ln(Et, "MIN_SPLIT_PATCH_CHUNKS_AMOUNT", 3), Ln(Et, "MAX_SPLIT_PATCH_CHUNKS_AMOUNT", 20), Ln(Et, "TRIANGLE_DENSITY", 20);
          let vt = Et;
          class At extends ft {
            getIR() {
              return ["Dummy"];
            }
          }
          function xt(St, Bt, Ot) {
            const Pt = Bt.getArray("Matrix"), wt = rt.Util.normalizeRect(Bt.getArray("BBox")), Ct = Bt.get("XStep"), It = Bt.get("YStep"), yt = Bt.get("PaintType"), Rt = Bt.get("TilingType");
            if (wt[2] - wt[0] === 0 || wt[3] - wt[1] === 0)
              throw new rt.FormatError(`Invalid getTilingPatternIR /BBox array: [${wt}].`);
            return ["TilingPattern", Ot, St, Pt, wt, Ct, It, yt, Rt];
          }
        },
        /* 202 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.getXfaFontDict = mt, at.getXfaFontName = gt, ot(140);
          var rt = ot(203), st = ot(151), lt = ot(204), et = ot(205), it = ot(206), ut = ot(207), ft = ot(150), ht = ot(189);
          const dt = (0, ft.getLookupTableFactory)(function(ct) {
            ct["MyriadPro-Regular"] = ct["PdfJS-Fallback-Regular"] = {
              name: "LiberationSans-Regular",
              factors: it.MyriadProRegularFactors,
              baseWidths: et.LiberationSansRegularWidths,
              baseMapping: et.LiberationSansRegularMapping,
              metrics: it.MyriadProRegularMetrics
            }, ct["MyriadPro-Bold"] = ct["PdfJS-Fallback-Bold"] = {
              name: "LiberationSans-Bold",
              factors: it.MyriadProBoldFactors,
              baseWidths: et.LiberationSansBoldWidths,
              baseMapping: et.LiberationSansBoldMapping,
              metrics: it.MyriadProBoldMetrics
            }, ct["MyriadPro-It"] = ct["MyriadPro-Italic"] = ct["PdfJS-Fallback-Italic"] = {
              name: "LiberationSans-Italic",
              factors: it.MyriadProItalicFactors,
              baseWidths: et.LiberationSansItalicWidths,
              baseMapping: et.LiberationSansItalicMapping,
              metrics: it.MyriadProItalicMetrics
            }, ct["MyriadPro-BoldIt"] = ct["MyriadPro-BoldItalic"] = ct["PdfJS-Fallback-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: it.MyriadProBoldItalicFactors,
              baseWidths: et.LiberationSansBoldItalicWidths,
              baseMapping: et.LiberationSansBoldItalicMapping,
              metrics: it.MyriadProBoldItalicMetrics
            }, ct.ArialMT = ct.Arial = ct["Arial-Regular"] = {
              name: "LiberationSans-Regular",
              baseWidths: et.LiberationSansRegularWidths,
              baseMapping: et.LiberationSansRegularMapping
            }, ct["Arial-BoldMT"] = ct["Arial-Bold"] = {
              name: "LiberationSans-Bold",
              baseWidths: et.LiberationSansBoldWidths,
              baseMapping: et.LiberationSansBoldMapping
            }, ct["Arial-ItalicMT"] = ct["Arial-Italic"] = {
              name: "LiberationSans-Italic",
              baseWidths: et.LiberationSansItalicWidths,
              baseMapping: et.LiberationSansItalicMapping
            }, ct["Arial-BoldItalicMT"] = ct["Arial-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              baseWidths: et.LiberationSansBoldItalicWidths,
              baseMapping: et.LiberationSansBoldItalicMapping
            }, ct["Calibri-Regular"] = {
              name: "LiberationSans-Regular",
              factors: rt.CalibriRegularFactors,
              baseWidths: et.LiberationSansRegularWidths,
              baseMapping: et.LiberationSansRegularMapping,
              metrics: rt.CalibriRegularMetrics
            }, ct["Calibri-Bold"] = {
              name: "LiberationSans-Bold",
              factors: rt.CalibriBoldFactors,
              baseWidths: et.LiberationSansBoldWidths,
              baseMapping: et.LiberationSansBoldMapping,
              metrics: rt.CalibriBoldMetrics
            }, ct["Calibri-Italic"] = {
              name: "LiberationSans-Italic",
              factors: rt.CalibriItalicFactors,
              baseWidths: et.LiberationSansItalicWidths,
              baseMapping: et.LiberationSansItalicMapping,
              metrics: rt.CalibriItalicMetrics
            }, ct["Calibri-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: rt.CalibriBoldItalicFactors,
              baseWidths: et.LiberationSansBoldItalicWidths,
              baseMapping: et.LiberationSansBoldItalicMapping,
              metrics: rt.CalibriBoldItalicMetrics
            }, ct["Segoeui-Regular"] = {
              name: "LiberationSans-Regular",
              factors: ut.SegoeuiRegularFactors,
              baseWidths: et.LiberationSansRegularWidths,
              baseMapping: et.LiberationSansRegularMapping,
              metrics: ut.SegoeuiRegularMetrics
            }, ct["Segoeui-Bold"] = {
              name: "LiberationSans-Bold",
              factors: ut.SegoeuiBoldFactors,
              baseWidths: et.LiberationSansBoldWidths,
              baseMapping: et.LiberationSansBoldMapping,
              metrics: ut.SegoeuiBoldMetrics
            }, ct["Segoeui-Italic"] = {
              name: "LiberationSans-Italic",
              factors: ut.SegoeuiItalicFactors,
              baseWidths: et.LiberationSansItalicWidths,
              baseMapping: et.LiberationSansItalicMapping,
              metrics: ut.SegoeuiItalicMetrics
            }, ct["Segoeui-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: ut.SegoeuiBoldItalicFactors,
              baseWidths: et.LiberationSansBoldItalicWidths,
              baseMapping: et.LiberationSansBoldItalicMapping,
              metrics: ut.SegoeuiBoldItalicMetrics
            }, ct["Helvetica-Regular"] = ct.Helvetica = {
              name: "LiberationSans-Regular",
              factors: lt.HelveticaRegularFactors,
              baseWidths: et.LiberationSansRegularWidths,
              baseMapping: et.LiberationSansRegularMapping,
              metrics: lt.HelveticaRegularMetrics
            }, ct["Helvetica-Bold"] = {
              name: "LiberationSans-Bold",
              factors: lt.HelveticaBoldFactors,
              baseWidths: et.LiberationSansBoldWidths,
              baseMapping: et.LiberationSansBoldMapping,
              metrics: lt.HelveticaBoldMetrics
            }, ct["Helvetica-Italic"] = {
              name: "LiberationSans-Italic",
              factors: lt.HelveticaItalicFactors,
              baseWidths: et.LiberationSansItalicWidths,
              baseMapping: et.LiberationSansItalicMapping,
              metrics: lt.HelveticaItalicMetrics
            }, ct["Helvetica-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: lt.HelveticaBoldItalicFactors,
              baseWidths: et.LiberationSansBoldItalicWidths,
              baseMapping: et.LiberationSansBoldItalicMapping,
              metrics: lt.HelveticaBoldItalicMetrics
            };
          });
          function gt(ct) {
            const vt = (0, ht.normalizeFontName)(ct);
            return dt()[vt];
          }
          function pt(ct) {
            const vt = gt(ct);
            if (!vt)
              return null;
            const {
              baseWidths: At,
              baseMapping: xt,
              factors: bt
            } = vt, Et = bt ? At.map((Pt, wt) => Pt * bt[wt]) : At;
            let St = -2, Bt;
            const Ot = [];
            for (const [Pt, wt] of xt.map((Ct, It) => [Ct, It]).sort((Ct, It) => {
              let [yt] = Ct, [Rt] = It;
              return yt - Rt;
            }))
              Pt !== -1 && (Pt === St + 1 ? (Bt.push(Et[wt]), St += 1) : (St = Pt, Bt = [Et[wt]], Ot.push(Pt, Bt)));
            return Ot;
          }
          function mt(ct) {
            const vt = pt(ct), At = new st.Dict(null);
            At.set("BaseFont", st.Name.get(ct)), At.set("Type", st.Name.get("Font")), At.set("Subtype", st.Name.get("CIDFontType2")), At.set("Encoding", st.Name.get("Identity-H")), At.set("CIDToGIDMap", st.Name.get("Identity")), At.set("W", vt), At.set("FirstChar", vt[0]), At.set("LastChar", vt.at(-2) + vt.at(-1).length - 1);
            const xt = new st.Dict(null);
            At.set("FontDescriptor", xt);
            const bt = new st.Dict(null);
            return bt.set("Ordering", "Identity"), bt.set("Registry", "Adobe"), bt.set("Supplement", 0), At.set("CIDSystemInfo", bt), At;
          }
        },
        /* 203 */
        /***/
        (nt, at) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.CalibriRegularMetrics = at.CalibriRegularFactors = at.CalibriItalicMetrics = at.CalibriItalicFactors = at.CalibriBoldMetrics = at.CalibriBoldItalicMetrics = at.CalibriBoldItalicFactors = at.CalibriBoldFactors = void 0;
          const ot = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.54657, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.73293, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.9121, 0.86943, 0.79795, 0.88198, 0.77958, 0.70864, 0.81055, 0.90399, 0.88653, 0.96017, 0.82577, 0.77892, 0.78257, 0.97507, 1.54657, 0.97507, 0.85284, 0.89552, 0.90176, 0.88762, 0.8785, 0.75241, 0.8785, 0.90518, 0.95015, 0.77618, 0.8785, 0.88401, 0.91916, 0.86304, 0.88401, 0.91488, 0.8785, 0.8801, 0.8785, 0.8785, 0.91343, 0.7173, 1.04106, 0.8785, 0.85075, 0.95794, 0.82616, 0.85162, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.12401, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.73293, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.9121, 0.86943, 0.86943, 0.86943, 0.86943, 0.86943, 0.85284, 0.87508, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.8715, 0.75241, 0.90518, 0.90518, 0.90518, 0.90518, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.8785, 0.8801, 0.8801, 0.8801, 0.8801, 0.8801, 0.90747, 0.89049, 0.8785, 0.8785, 0.8785, 0.8785, 0.85162, 0.8785, 0.85162, 0.83908, 0.88762, 0.83908, 0.88762, 0.83908, 0.88762, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.87289, 0.83016, 0.88506, 0.93125, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.81921, 0.77618, 0.81921, 0.77618, 0.81921, 0.77618, 1, 1, 0.87356, 0.8785, 0.91075, 0.89608, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76229, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.79468, 0.91926, 0.88175, 0.70823, 0.94903, 0.9121, 0.8785, 1, 1, 0.9121, 0.8785, 0.87802, 0.88656, 0.8785, 0.86943, 0.8801, 0.86943, 0.8801, 0.86943, 0.8801, 0.87402, 0.89291, 0.77958, 0.91343, 1, 1, 0.77958, 0.91343, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.96017, 0.95794, 0.77892, 0.85162, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.88762, 0.77539, 0.8715, 0.87508, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70674, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.06303, 0.83908, 0.80352, 0.57184, 0.6965, 0.56289, 0.82001, 0.56029, 0.81235, 1.02988, 0.83908, 0.7762, 0.68156, 0.80367, 0.73133, 0.78257, 0.87356, 0.86943, 0.95958, 0.75727, 0.89019, 1.04924, 0.9121, 0.7648, 0.86943, 0.87356, 0.79795, 0.78275, 0.81055, 0.77892, 0.9762, 0.82577, 0.99819, 0.84896, 0.95958, 0.77892, 0.96108, 1.01407, 0.89049, 1.02988, 0.94211, 0.96108, 0.8936, 0.84021, 0.87842, 0.96399, 0.79109, 0.89049, 1.00813, 1.02988, 0.86077, 0.87445, 0.92099, 0.84723, 0.86513, 0.8801, 0.75638, 0.85714, 0.78216, 0.79586, 0.87965, 0.94211, 0.97747, 0.78287, 0.97926, 0.84971, 1.02988, 0.94211, 0.8801, 0.94211, 0.84971, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90264, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90518, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90548, 1, 1, 1, 1, 1, 1, 0.96017, 0.95794, 0.96017, 0.95794, 0.96017, 0.95794, 0.77892, 0.85162, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.92794, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71143, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.93835, 0.83406, 0.91133, 0.84107, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90527, 1.81055, 0.90527, 1.81055, 1.31006, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.CalibriBoldFactors = ot;
          const rt = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          at.CalibriBoldMetrics = rt;
          const st = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.56239, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.71805, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.90872, 0.85938, 0.79795, 0.87068, 0.77958, 0.69766, 0.81055, 0.90399, 0.88653, 0.96068, 0.82577, 0.77892, 0.78257, 0.97507, 1.529, 0.97507, 0.85284, 0.89552, 0.90176, 0.94908, 0.86411, 0.74012, 0.86411, 0.88323, 0.95015, 0.86411, 0.86331, 0.88401, 0.91916, 0.86304, 0.88401, 0.9039, 0.86331, 0.86331, 0.86411, 0.86411, 0.90464, 0.70852, 1.04106, 0.86331, 0.84372, 0.95794, 0.82616, 0.84548, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.19129, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.71805, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.90872, 0.85938, 0.85938, 0.85938, 0.85938, 0.85938, 0.85284, 0.87068, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.85887, 0.74012, 0.88323, 0.88323, 0.88323, 0.88323, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.90747, 0.89049, 0.86331, 0.86331, 0.86331, 0.86331, 0.84548, 0.86411, 0.84548, 0.83908, 0.94908, 0.83908, 0.94908, 0.83908, 0.94908, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.87289, 0.79538, 0.88506, 0.92726, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.81921, 0.86411, 0.81921, 0.86411, 0.81921, 0.86411, 1, 1, 0.87356, 0.86331, 0.91075, 0.8777, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76467, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.77312, 0.91926, 0.88175, 0.70823, 0.94903, 0.90872, 0.86331, 1, 1, 0.90872, 0.86331, 0.86906, 0.88116, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.87402, 0.86549, 0.77958, 0.90464, 1, 1, 0.77958, 0.90464, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.96068, 0.95794, 0.77892, 0.84548, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.94908, 0.77539, 0.85887, 0.87068, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70088, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.48387, 0.83908, 0.80352, 0.57118, 0.6965, 0.56347, 0.79179, 0.55853, 0.80346, 1.02988, 0.83908, 0.7762, 0.67174, 0.86036, 0.73133, 0.78257, 0.87356, 0.86441, 0.95958, 0.75727, 0.89019, 1.04924, 0.90872, 0.74889, 0.85938, 0.87891, 0.79795, 0.7957, 0.81055, 0.77892, 0.97447, 0.82577, 0.97466, 0.87179, 0.95958, 0.77892, 0.94252, 0.95612, 0.8753, 1.02988, 0.92733, 0.94252, 0.87411, 0.84021, 0.8728, 0.95612, 0.74081, 0.8753, 1.02189, 1.02988, 0.84814, 0.87445, 0.91822, 0.84723, 0.85668, 0.86331, 0.81344, 0.87581, 0.76422, 0.82046, 0.96057, 0.92733, 0.99375, 0.78022, 0.95452, 0.86015, 1.02988, 0.92733, 0.86331, 0.92733, 0.86015, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90631, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88323, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85174, 1, 1, 1, 1, 1, 1, 0.96068, 0.95794, 0.96068, 0.95794, 0.96068, 0.95794, 0.77892, 0.84548, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.89807, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71094, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.92972, 0.83406, 0.91133, 0.83326, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90616, 1.81055, 0.90527, 1.81055, 1.3107, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.CalibriBoldItalicFactors = st;
          const lt = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          at.CalibriBoldItalicMetrics = lt;
          const et = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39543, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.72346, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89249, 0.84118, 0.77452, 0.85374, 0.75186, 0.67789, 0.79776, 0.88844, 0.85066, 0.94309, 0.77818, 0.7306, 0.76659, 1.10369, 1.38313, 1.10369, 1.06139, 0.89552, 0.8739, 0.9245, 0.9245, 0.83203, 0.9245, 0.85865, 1.09842, 0.9245, 0.9245, 1.03297, 1.07692, 0.90918, 1.03297, 0.94959, 0.9245, 0.92274, 0.9245, 0.9245, 1.02933, 0.77832, 1.20562, 0.9245, 0.8916, 0.98986, 0.86621, 0.89453, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.16359, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.72346, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89249, 0.84118, 0.84118, 0.84118, 0.84118, 0.84118, 0.85284, 0.84557, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.84843, 0.83203, 0.85865, 0.85865, 0.85865, 0.85865, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.9245, 0.92274, 0.92274, 0.92274, 0.92274, 0.92274, 0.90747, 0.86651, 0.9245, 0.9245, 0.9245, 0.9245, 0.89453, 0.9245, 0.89453, 0.8675, 0.9245, 0.8675, 0.9245, 0.8675, 0.9245, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.85193, 0.8875, 0.86477, 0.99034, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.81105, 0.9245, 0.81105, 0.9245, 0.81105, 0.9245, 1, 1, 0.86275, 0.9245, 0.90872, 0.93591, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77896, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.9375, 0.98156, 0.93407, 0.77261, 1.11429, 0.89249, 0.9245, 1, 1, 0.89249, 0.9245, 0.92534, 0.86698, 0.9245, 0.84118, 0.92274, 0.84118, 0.92274, 0.84118, 0.92274, 0.8667, 0.86291, 0.75186, 1.02933, 1, 1, 0.75186, 1.02933, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 1, 1, 0.79776, 0.97655, 0.79776, 1.23023, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.94309, 0.98986, 0.7306, 0.89453, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.9245, 0.76318, 0.84843, 0.84557, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67009, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.8675, 0.90861, 0.6192, 0.7363, 0.64824, 0.82411, 0.56321, 0.85696, 1.23516, 0.8675, 0.81552, 0.7286, 0.84134, 0.73206, 0.76659, 0.86275, 0.84369, 0.90685, 0.77892, 0.85871, 1.02638, 0.89249, 0.75828, 0.84118, 0.85984, 0.77452, 0.76466, 0.79776, 0.7306, 0.90782, 0.77818, 0.903, 0.87291, 0.90685, 0.7306, 0.99058, 1.03667, 0.94635, 1.23516, 0.9849, 0.99058, 0.92393, 0.8916, 0.942, 1.03667, 0.75026, 0.94635, 1.0297, 1.23516, 0.90918, 0.94048, 0.98217, 0.89746, 0.84153, 0.92274, 0.82507, 0.88832, 0.84438, 0.88178, 1.03525, 0.9849, 1.00225, 0.78086, 0.97248, 0.89404, 1.23516, 0.9849, 0.92274, 0.9849, 0.89404, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89693, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85865, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90933, 1, 1, 1, 1, 1, 1, 0.94309, 0.98986, 0.94309, 0.98986, 0.94309, 0.98986, 0.7306, 0.89453, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.68994, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.97858, 0.82616, 0.91133, 0.83437, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90572, 1.81055, 0.90749, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85284, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.CalibriItalicFactors = et;
          const it = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          at.CalibriItalicMetrics = it;
          const ut = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39016, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.73834, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89385, 0.85122, 0.77452, 0.86503, 0.75186, 0.68887, 0.79776, 0.88844, 0.85066, 0.94258, 0.77818, 0.7306, 0.76659, 1.10369, 1.39016, 1.10369, 1.06139, 0.89552, 0.8739, 0.86128, 0.94469, 0.8457, 0.94469, 0.89464, 1.09842, 0.84636, 0.94469, 1.03297, 1.07692, 0.90918, 1.03297, 0.95897, 0.94469, 0.9482, 0.94469, 0.94469, 1.04692, 0.78223, 1.20562, 0.94469, 0.90332, 0.98986, 0.86621, 0.90527, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.08707, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.73834, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89385, 0.85122, 0.85122, 0.85122, 0.85122, 0.85122, 0.85284, 0.85311, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.8693, 0.8457, 0.89464, 0.89464, 0.89464, 0.89464, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.94469, 0.9482, 0.9482, 0.9482, 0.9482, 0.9482, 0.90747, 0.86651, 0.94469, 0.94469, 0.94469, 0.94469, 0.90527, 0.94469, 0.90527, 0.8675, 0.86128, 0.8675, 0.86128, 0.8675, 0.86128, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.85193, 0.92454, 0.86477, 0.9921, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.81105, 0.84636, 0.81105, 0.84636, 0.81105, 0.84636, 1, 1, 0.86275, 0.94469, 0.90872, 0.95786, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77741, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.90452, 0.98156, 1.11842, 0.77261, 1.11429, 0.89385, 0.94469, 1, 1, 0.89385, 0.94469, 0.95877, 0.86901, 0.94469, 0.85122, 0.9482, 0.85122, 0.9482, 0.85122, 0.9482, 0.8667, 0.90016, 0.75186, 1.04692, 1, 1, 0.75186, 1.04692, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 1, 1, 0.79776, 0.92188, 0.79776, 1.23023, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.94258, 0.98986, 0.7306, 0.90527, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.86128, 0.76318, 0.8693, 0.85311, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67742, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.86686, 0.90861, 0.62267, 0.74359, 0.65649, 0.85498, 0.56963, 0.88254, 1.23516, 0.8675, 0.81552, 0.75443, 0.84503, 0.73206, 0.76659, 0.86275, 0.85122, 0.90685, 0.77892, 0.85746, 1.02638, 0.89385, 0.75657, 0.85122, 0.86275, 0.77452, 0.74171, 0.79776, 0.7306, 0.95165, 0.77818, 0.89772, 0.88831, 0.90685, 0.7306, 0.98142, 1.02191, 0.96576, 1.23516, 0.99018, 0.98142, 0.9236, 0.89258, 0.94035, 1.02191, 0.78848, 0.96576, 0.9561, 1.23516, 0.90918, 0.92578, 0.95424, 0.89746, 0.83969, 0.9482, 0.80113, 0.89442, 0.85208, 0.86155, 0.98022, 0.99018, 1.00452, 0.81209, 0.99247, 0.89181, 1.23516, 0.99018, 0.9482, 0.99018, 0.89181, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88844, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89464, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96766, 1, 1, 1, 1, 1, 1, 0.94258, 0.98986, 0.94258, 0.98986, 0.94258, 0.98986, 0.7306, 0.90527, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.69043, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.99331, 0.82616, 0.91133, 0.84286, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90527, 1.81055, 0.90527, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1.07185, 0.99413, 0.96334, 1.08065, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.CalibriRegularFactors = ut;
          const ft = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          at.CalibriRegularMetrics = ft;
        },
        /* 204 */
        /***/
        (nt, at) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.HelveticaRegularMetrics = at.HelveticaRegularFactors = at.HelveticaItalicMetrics = at.HelveticaItalicFactors = at.HelveticaBoldMetrics = at.HelveticaBoldItalicMetrics = at.HelveticaBoldItalicFactors = at.HelveticaBoldFactors = void 0;
          const ot = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.03374, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.00042, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.03828, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00034, 0.99977, 1, 0.99997, 1.00026, 1.00078, 1.00036, 0.99973, 1.00013, 1.0006, 0.99977, 0.99977, 0.99988, 0.85148, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 1.00069, 1.00022, 0.99977, 1.00001, 0.99984, 1.00026, 1.00001, 1.00024, 1.00001, 0.9999, 1, 1.0006, 1.00001, 1.00041, 0.99962, 1.00026, 1.0006, 0.99995, 1.00041, 0.99942, 0.99973, 0.99927, 1.00082, 0.99902, 1.00026, 1.00087, 1.0006, 1.00069, 0.99973, 0.99867, 0.99973, 0.9993, 1.00026, 1.00049, 1.00056, 1, 0.99988, 0.99935, 0.99995, 0.99954, 1.00055, 0.99945, 1.00032, 1.0006, 0.99995, 1.00026, 0.99995, 1.00032, 1.00001, 1.00008, 0.99971, 1.00019, 0.9994, 1.00001, 1.0006, 1.00044, 0.99973, 1.00023, 1.00047, 1, 0.99942, 0.99561, 0.99989, 1.00035, 0.99977, 1.00035, 0.99977, 1.00019, 0.99944, 1.00001, 1.00021, 0.99926, 1.00035, 1.00035, 0.99942, 1.00048, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.99989, 1.00057, 1.00001, 0.99936, 1.00052, 1.00012, 0.99996, 1.00043, 1, 1.00035, 0.9994, 0.99976, 1.00035, 0.99973, 1.00052, 1.00041, 1.00119, 1.00037, 0.99973, 1.00002, 0.99986, 1.00041, 1.00041, 0.99902, 0.9996, 1.00034, 0.99999, 1.00026, 0.99999, 1.00026, 0.99973, 1.00052, 0.99973, 1, 0.99973, 1.00041, 1.00075, 0.9994, 1.0003, 0.99999, 1, 1.00041, 0.99955, 1, 0.99915, 0.99973, 0.99973, 1.00026, 1.00119, 0.99955, 0.99973, 1.0006, 0.99911, 1.0006, 1.00026, 0.99972, 1.00026, 0.99902, 1.00041, 0.99973, 0.99999, 1, 1, 1.00038, 1.0005, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 1.00047, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.HelveticaBoldFactors = ot;
          const rt = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          at.HelveticaBoldMetrics = rt;
          const st = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.0044, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99971, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.01011, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99977, 1, 1, 1.00026, 0.99969, 0.99972, 0.99981, 0.9998, 1.0006, 0.99977, 0.99977, 1.00022, 0.91155, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 0.99966, 1.00022, 1.00032, 1.00001, 0.99944, 1.00026, 1.00001, 0.99968, 1.00001, 1.00047, 1, 1.0006, 1.00001, 0.99981, 1.00101, 1.00026, 1.0006, 0.99948, 0.99981, 1.00064, 0.99973, 0.99942, 1.00101, 1.00061, 1.00026, 1.00069, 1.0006, 1.00014, 0.99973, 1.01322, 0.99973, 1.00065, 1.00026, 1.00012, 0.99923, 1, 1.00064, 1.00076, 0.99948, 1.00055, 1.00063, 1.00007, 0.99943, 1.0006, 0.99948, 1.00026, 0.99948, 0.99943, 1.00001, 1.00001, 1.00029, 1.00038, 1.00035, 1.00001, 1.0006, 1.0006, 0.99973, 0.99978, 1.00001, 1.00057, 0.99989, 0.99967, 0.99964, 0.99967, 0.99977, 0.99999, 0.99977, 1.00038, 0.99977, 1.00001, 0.99973, 1.00066, 0.99967, 0.99967, 1.00041, 0.99998, 0.99999, 0.99977, 1.00022, 0.99967, 1.00001, 0.99977, 1.00026, 0.99964, 1.00031, 1.00001, 0.99999, 0.99999, 1, 1.00023, 1, 1, 0.99999, 1.00035, 1.00001, 0.99999, 0.99973, 0.99977, 0.99999, 1.00058, 0.99973, 0.99973, 0.99955, 0.9995, 1.00026, 1.00026, 1.00032, 0.99989, 1.00034, 0.99999, 1.00026, 1.00026, 1.00026, 0.99973, 0.45998, 0.99973, 1.00026, 0.99973, 1.00001, 0.99999, 0.99982, 0.99994, 0.99996, 1, 1.00042, 1.00044, 1.00029, 1.00023, 0.99973, 0.99973, 1.00026, 0.99949, 1.00002, 0.99973, 1.0006, 1.0006, 1.0006, 0.99975, 1.00026, 1.00026, 1.00032, 0.98685, 0.99973, 1.00026, 1, 1, 0.99966, 1.00044, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1, 0.99973, 0.99971, 0.99978, 1, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00098, 1, 1, 1, 1.00049, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.HelveticaBoldItalicFactors = st;
          const lt = {
            lineHeight: 1.35,
            lineGap: 0.2
          };
          at.HelveticaBoldItalicMetrics = lt;
          const et = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.0288, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 0.99946, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.06311, 0.99973, 1.00024, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00041, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.89547, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00001, 1, 1.00054, 0.99977, 1.00084, 1.00007, 0.99973, 1.00013, 0.99924, 1.00001, 1.00001, 0.99945, 0.91221, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00001, 0.99999, 0.99977, 0.99933, 1.00022, 1.00054, 1.00001, 1.00065, 1.00026, 1.00001, 1.0001, 1.00001, 1.00052, 1, 1.0006, 1.00001, 0.99945, 0.99897, 0.99968, 0.99924, 1.00036, 0.99945, 0.99949, 1, 1.0006, 0.99897, 0.99918, 0.99968, 0.99911, 0.99924, 1, 0.99962, 1.01487, 1, 1.0005, 0.99973, 1.00012, 1.00043, 1, 0.99995, 0.99994, 1.00036, 0.99947, 1.00019, 1.00063, 1.00025, 0.99924, 1.00036, 0.99973, 1.00036, 1.00025, 1.00001, 1.00001, 1.00027, 1.0001, 1.00068, 1.00001, 1.0006, 1.0006, 1, 1.00008, 0.99957, 0.99972, 0.9994, 0.99954, 0.99975, 1.00051, 1.00001, 1.00019, 1.00001, 1.0001, 0.99986, 1.00001, 1.00001, 1.00038, 0.99954, 0.99954, 0.9994, 1.00066, 0.99999, 0.99977, 1.00022, 1.00054, 1.00001, 0.99977, 1.00026, 0.99975, 1.0001, 1.00001, 0.99993, 0.9995, 0.99955, 1.00016, 0.99978, 0.99974, 1.00019, 1.00022, 0.99955, 1.00053, 0.99973, 1.00089, 1.00005, 0.99967, 1.00048, 0.99973, 1.00002, 1.00034, 0.99973, 0.99973, 0.99964, 1.00006, 1.00066, 0.99947, 0.99973, 0.98894, 0.99973, 1, 0.44898, 1, 0.99946, 1, 1.00039, 1.00082, 0.99991, 0.99991, 0.99985, 1.00022, 1.00023, 1.00061, 1.00006, 0.99966, 0.99973, 0.99973, 0.99973, 1.00019, 1.0008, 1, 0.99924, 0.99924, 0.99924, 0.99983, 1.00044, 0.99973, 0.99964, 0.98332, 1, 0.99973, 1, 1, 0.99962, 0.99895, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 1.00423, 0.99925, 0.99999, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00049, 1, 1.00245, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 1.00003, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.HelveticaItalicFactors = et;
          const it = {
            lineHeight: 1.35,
            lineGap: 0.2
          };
          at.HelveticaItalicMetrics = it;
          const ut = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.04596, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 1.00019, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.02572, 0.99973, 1.00005, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99999, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.84533, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99928, 1, 0.99977, 1.00013, 1.00055, 0.99947, 0.99945, 0.99941, 0.99924, 1.00001, 1.00001, 1.0004, 0.91621, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00005, 0.99999, 0.99977, 1.00015, 1.00022, 0.99977, 1.00001, 0.99973, 1.00026, 1.00001, 1.00019, 1.00001, 0.99946, 1, 1.0006, 1.00001, 0.99978, 1.00045, 0.99973, 0.99924, 1.00023, 0.99978, 0.99966, 1, 1.00065, 1.00045, 1.00019, 0.99973, 0.99973, 0.99924, 1, 1, 0.96499, 1, 1.00055, 0.99973, 1.00008, 1.00027, 1, 0.9997, 0.99995, 1.00023, 0.99933, 1.00019, 1.00015, 1.00031, 0.99924, 1.00023, 0.99973, 1.00023, 1.00031, 1.00001, 0.99928, 1.00029, 1.00092, 1.00035, 1.00001, 1.0006, 1.0006, 1, 0.99988, 0.99975, 1, 1.00082, 0.99561, 0.9996, 1.00035, 1.00001, 0.99962, 1.00001, 1.00092, 0.99964, 1.00001, 0.99963, 0.99999, 1.00035, 1.00035, 1.00082, 0.99962, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.9996, 0.99967, 1.00001, 1.00034, 1.00074, 1.00054, 1.00053, 1.00063, 0.99971, 0.99962, 1.00035, 0.99975, 0.99977, 0.99973, 1.00043, 0.99953, 1.0007, 0.99915, 0.99973, 1.00008, 0.99892, 1.00073, 1.00073, 1.00114, 0.99915, 1.00073, 0.99955, 0.99973, 1.00092, 0.99973, 1, 0.99998, 1, 1.0003, 1, 1.00043, 1.00001, 0.99969, 1.0003, 1, 1.00035, 1.00001, 0.9995, 1, 1.00092, 0.99973, 0.99973, 0.99973, 1.0007, 0.9995, 1, 0.99924, 1.0006, 0.99924, 0.99972, 1.00062, 0.99973, 1.00114, 1.00073, 1, 0.99955, 1, 1, 1.00047, 0.99968, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 0.99925, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.HelveticaRegularFactors = ut;
          const ft = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          at.HelveticaRegularMetrics = ft;
        },
        /* 205 */
        /***/
        (nt, at) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.LiberationSansRegularWidths = at.LiberationSansRegularMapping = at.LiberationSansItalicWidths = at.LiberationSansItalicMapping = at.LiberationSansBoldWidths = at.LiberationSansBoldMapping = at.LiberationSansBoldItalicWidths = at.LiberationSansBoldItalicMapping = void 0;
          const ot = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 719, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 785, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 385, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 465, 722, 333, 853, 906, 474, 825, 927, 838, 278, 722, 722, 601, 719, 667, 611, 722, 778, 278, 722, 667, 833, 722, 644, 778, 722, 667, 600, 611, 667, 821, 667, 809, 802, 278, 667, 615, 451, 611, 278, 582, 615, 610, 556, 606, 475, 460, 611, 541, 278, 558, 556, 612, 556, 445, 611, 766, 619, 520, 684, 446, 582, 715, 576, 753, 845, 278, 582, 611, 582, 845, 667, 669, 885, 567, 711, 667, 278, 276, 556, 1094, 1062, 875, 610, 722, 622, 719, 722, 719, 722, 567, 712, 667, 904, 626, 719, 719, 610, 702, 833, 722, 778, 719, 667, 722, 611, 622, 854, 667, 730, 703, 1005, 1019, 870, 979, 719, 711, 1031, 719, 556, 618, 615, 417, 635, 556, 709, 497, 615, 615, 500, 635, 740, 604, 611, 604, 611, 556, 490, 556, 875, 556, 615, 581, 833, 844, 729, 854, 615, 552, 854, 583, 556, 556, 611, 417, 552, 556, 278, 281, 278, 969, 906, 611, 500, 615, 556, 604, 778, 611, 487, 447, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1094, 556, 885, 489, 1115, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333];
          at.LiberationSansBoldWidths = ot;
          const rt = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          at.LiberationSansBoldMapping = rt;
          const st = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 740, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 782, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 396, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 722, 333, 854, 906, 473, 844, 930, 847, 278, 722, 722, 610, 671, 667, 611, 722, 778, 278, 722, 667, 833, 722, 657, 778, 718, 667, 590, 611, 667, 822, 667, 829, 781, 278, 667, 620, 479, 611, 278, 591, 620, 621, 556, 610, 479, 492, 611, 558, 278, 566, 556, 603, 556, 450, 611, 712, 605, 532, 664, 409, 591, 704, 578, 773, 834, 278, 591, 611, 591, 834, 667, 667, 886, 614, 719, 667, 278, 278, 556, 1094, 1042, 854, 622, 719, 677, 719, 722, 708, 722, 614, 722, 667, 927, 643, 719, 719, 615, 687, 833, 722, 778, 719, 667, 722, 611, 677, 781, 667, 729, 708, 979, 989, 854, 1e3, 708, 719, 1042, 729, 556, 619, 604, 534, 618, 556, 736, 510, 611, 611, 507, 622, 740, 604, 611, 611, 611, 556, 889, 556, 885, 556, 646, 583, 889, 935, 707, 854, 594, 552, 865, 589, 556, 556, 611, 469, 563, 556, 278, 278, 278, 969, 906, 611, 507, 619, 556, 611, 778, 611, 575, 467, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1104, 556, 885, 516, 1146, 1e3, 768, 600, 834, 834, 834, 834, 999, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333];
          at.LiberationSansBoldItalicWidths = st;
          const lt = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          at.LiberationSansBoldItalicMapping = lt;
          const et = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 625, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 733, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 281, 556, 400, 556, 222, 722, 556, 722, 556, 722, 556, 615, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 354, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 789, 846, 389, 794, 865, 775, 222, 667, 667, 570, 671, 667, 611, 722, 778, 278, 667, 667, 833, 722, 648, 778, 725, 667, 600, 611, 667, 837, 667, 831, 761, 278, 667, 570, 439, 555, 222, 550, 570, 571, 500, 556, 439, 463, 555, 542, 222, 500, 492, 548, 500, 447, 556, 670, 573, 486, 603, 374, 550, 652, 546, 728, 779, 222, 550, 556, 550, 779, 667, 667, 843, 544, 708, 667, 278, 278, 500, 1066, 982, 844, 589, 715, 639, 724, 667, 651, 667, 544, 704, 667, 917, 614, 715, 715, 589, 686, 833, 722, 778, 725, 667, 722, 611, 639, 795, 667, 727, 673, 920, 923, 805, 886, 651, 694, 1022, 682, 556, 562, 522, 493, 553, 556, 688, 465, 556, 556, 472, 564, 686, 550, 556, 556, 556, 500, 833, 500, 835, 500, 572, 518, 830, 851, 621, 736, 526, 492, 752, 534, 556, 556, 556, 378, 496, 500, 222, 222, 222, 910, 828, 556, 472, 565, 500, 556, 778, 556, 492, 339, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1083, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 998, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 584, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285];
          at.LiberationSansItalicWidths = et;
          const it = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          at.LiberationSansItalicMapping = it;
          const ut = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 615, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 735, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 292, 556, 334, 556, 222, 722, 556, 722, 556, 722, 556, 604, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 375, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 784, 838, 384, 774, 855, 752, 222, 667, 667, 551, 668, 667, 611, 722, 778, 278, 667, 668, 833, 722, 650, 778, 722, 667, 618, 611, 667, 798, 667, 835, 748, 278, 667, 578, 446, 556, 222, 547, 578, 575, 500, 557, 446, 441, 556, 556, 222, 500, 500, 576, 500, 448, 556, 690, 569, 482, 617, 395, 547, 648, 525, 713, 781, 222, 547, 556, 547, 781, 667, 667, 865, 542, 719, 667, 278, 278, 500, 1057, 1010, 854, 583, 722, 635, 719, 667, 656, 667, 542, 677, 667, 923, 604, 719, 719, 583, 656, 833, 722, 778, 719, 667, 722, 611, 635, 760, 667, 740, 667, 917, 938, 792, 885, 656, 719, 1010, 722, 556, 573, 531, 365, 583, 556, 669, 458, 559, 559, 438, 583, 688, 552, 556, 542, 556, 500, 458, 500, 823, 500, 573, 521, 802, 823, 625, 719, 521, 510, 750, 542, 556, 556, 556, 365, 510, 500, 222, 278, 222, 906, 812, 556, 438, 559, 500, 552, 778, 556, 489, 411, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1073, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285];
          at.LiberationSansRegularWidths = ut;
          const ft = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          at.LiberationSansRegularMapping = ft;
        },
        /* 206 */
        /***/
        (nt, at) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.MyriadProRegularMetrics = at.MyriadProRegularFactors = at.MyriadProItalicMetrics = at.MyriadProItalicFactors = at.MyriadProBoldMetrics = at.MyriadProBoldItalicMetrics = at.MyriadProBoldItalicFactors = at.MyriadProBoldFactors = void 0;
          const ot = [1.36898, 1, 1, 0.72706, 0.80479, 0.83734, 0.98894, 0.99793, 0.9897, 0.93884, 0.86209, 0.94292, 0.94292, 1.16661, 1.02058, 0.93582, 0.96694, 0.93582, 1.19137, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.72851, 0.78966, 0.90838, 0.83637, 0.82391, 0.96376, 0.80061, 0.86275, 0.8768, 0.95407, 1.0258, 0.73901, 0.85022, 0.83655, 1.0156, 0.95546, 0.92179, 0.87107, 0.92179, 0.82114, 0.8096, 0.89713, 0.94438, 0.95353, 0.94083, 0.91905, 0.90406, 0.9446, 0.94292, 1.18777, 0.94292, 1.02058, 0.89903, 0.90088, 0.94938, 0.97898, 0.81093, 0.97571, 0.94938, 1.024, 0.9577, 0.95933, 0.98621, 1.0474, 0.97455, 0.98981, 0.9672, 0.95933, 0.9446, 0.97898, 0.97407, 0.97646, 0.78036, 1.10208, 0.95442, 0.95298, 0.97579, 0.9332, 0.94039, 0.938, 0.80687, 1.01149, 0.80687, 1.02058, 0.80479, 0.99793, 0.99793, 0.99793, 0.99793, 1.01149, 1.00872, 0.90088, 0.91882, 1.0213, 0.8361, 1.02058, 0.62295, 0.54324, 0.89022, 1.08595, 1, 1, 0.90088, 1, 0.97455, 0.93582, 0.90088, 1, 1.05686, 0.8361, 0.99642, 0.99642, 0.99642, 0.72851, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.868, 0.82391, 0.80061, 0.80061, 0.80061, 0.80061, 1.0258, 1.0258, 1.0258, 1.0258, 0.97484, 0.95546, 0.92179, 0.92179, 0.92179, 0.92179, 0.92179, 1.02058, 0.92179, 0.94438, 0.94438, 0.94438, 0.94438, 0.90406, 0.86958, 0.98225, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.9031, 0.81093, 0.94938, 0.94938, 0.94938, 0.94938, 0.98621, 0.98621, 0.98621, 0.98621, 0.93969, 0.95933, 0.9446, 0.9446, 0.9446, 0.9446, 0.9446, 1.08595, 0.9446, 0.95442, 0.95442, 0.95442, 0.95442, 0.94039, 0.97898, 0.94039, 0.90838, 0.94938, 0.90838, 0.94938, 0.90838, 0.94938, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.96376, 0.84313, 0.97484, 0.97571, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.8768, 0.9577, 0.8768, 0.9577, 0.8768, 0.9577, 1, 1, 0.95407, 0.95933, 0.97069, 0.95933, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 0.887, 1.01591, 0.73901, 1.0474, 1, 1, 0.97455, 0.83655, 0.98981, 1, 1, 0.83655, 0.73977, 0.83655, 0.73903, 0.84638, 1.033, 0.95546, 0.95933, 1, 1, 0.95546, 0.95933, 0.8271, 0.95417, 0.95933, 0.92179, 0.9446, 0.92179, 0.9446, 0.92179, 0.9446, 0.936, 0.91964, 0.82114, 0.97646, 1, 1, 0.82114, 0.97646, 0.8096, 0.78036, 0.8096, 0.78036, 1, 1, 0.8096, 0.78036, 1, 1, 0.89713, 0.77452, 0.89713, 1.10208, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94083, 0.97579, 0.90406, 0.94039, 0.90406, 0.9446, 0.938, 0.9446, 0.938, 0.9446, 0.938, 1, 0.99793, 0.90838, 0.94938, 0.868, 0.9031, 0.92179, 0.9446, 1, 1, 0.89713, 1.10208, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90989, 0.9358, 0.91945, 0.83181, 0.75261, 0.87992, 0.82976, 0.96034, 0.83689, 0.97268, 1.0078, 0.90838, 0.83637, 0.8019, 0.90157, 0.80061, 0.9446, 0.95407, 0.92436, 1.0258, 0.85022, 0.97153, 1.0156, 0.95546, 0.89192, 0.92179, 0.92361, 0.87107, 0.96318, 0.89713, 0.93704, 0.95638, 0.91905, 0.91709, 0.92796, 1.0258, 0.93704, 0.94836, 1.0373, 0.95933, 1.0078, 0.95871, 0.94836, 0.96174, 0.92601, 0.9498, 0.98607, 0.95776, 0.95933, 1.05453, 1.0078, 0.98275, 0.9314, 0.95617, 0.91701, 1.05993, 0.9446, 0.78367, 0.9553, 1, 0.86832, 1.0128, 0.95871, 0.99394, 0.87548, 0.96361, 0.86774, 1.0078, 0.95871, 0.9446, 0.95871, 0.86774, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.94083, 0.97579, 0.94083, 0.97579, 0.94083, 0.97579, 0.90406, 0.94039, 0.96694, 1, 0.89903, 1, 1, 1, 0.93582, 0.93582, 0.93582, 1, 0.908, 0.908, 0.918, 0.94219, 0.94219, 0.96544, 1, 1.285, 1, 1, 0.81079, 0.81079, 1, 1, 0.74854, 1, 1, 1, 1, 0.99793, 1, 1, 1, 0.65, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.17173, 1, 0.80535, 0.76169, 1.02058, 1.0732, 1.05486, 1, 1, 1.30692, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.16161, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.MyriadProBoldFactors = ot;
          const rt = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          at.MyriadProBoldMetrics = rt;
          const st = [1.36898, 1, 1, 0.66227, 0.80779, 0.81625, 0.97276, 0.97276, 0.97733, 0.92222, 0.83266, 0.94292, 0.94292, 1.16148, 1.02058, 0.93582, 0.96694, 0.93582, 1.17337, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.71541, 0.76813, 0.85576, 0.80591, 0.80729, 0.94299, 0.77512, 0.83655, 0.86523, 0.92222, 0.98621, 0.71743, 0.81698, 0.79726, 0.98558, 0.92222, 0.90637, 0.83809, 0.90637, 0.80729, 0.76463, 0.86275, 0.90699, 0.91605, 0.9154, 0.85308, 0.85458, 0.90531, 0.94292, 1.21296, 0.94292, 1.02058, 0.89903, 1.18616, 0.99613, 0.91677, 0.78216, 0.91677, 0.90083, 0.98796, 0.9135, 0.92168, 0.95381, 0.98981, 0.95298, 0.95381, 0.93459, 0.92168, 0.91513, 0.92004, 0.91677, 0.95077, 0.748, 1.04502, 0.91677, 0.92061, 0.94236, 0.89544, 0.89364, 0.9, 0.80687, 0.8578, 0.80687, 1.02058, 0.80779, 0.97276, 0.97276, 0.97276, 0.97276, 0.8578, 0.99973, 1.18616, 0.91339, 1.08074, 0.82891, 1.02058, 0.55509, 0.71526, 0.89022, 1.08595, 1, 1, 1.18616, 1, 0.96736, 0.93582, 1.18616, 1, 1.04864, 0.82711, 0.99043, 0.99043, 0.99043, 0.71541, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.845, 0.80729, 0.77512, 0.77512, 0.77512, 0.77512, 0.98621, 0.98621, 0.98621, 0.98621, 0.95961, 0.92222, 0.90637, 0.90637, 0.90637, 0.90637, 0.90637, 1.02058, 0.90251, 0.90699, 0.90699, 0.90699, 0.90699, 0.85458, 0.83659, 0.94951, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.85811, 0.78216, 0.90083, 0.90083, 0.90083, 0.90083, 0.95381, 0.95381, 0.95381, 0.95381, 0.9135, 0.92168, 0.91513, 0.91513, 0.91513, 0.91513, 0.91513, 1.08595, 0.91677, 0.91677, 0.91677, 0.91677, 0.91677, 0.89364, 0.92332, 0.89364, 0.85576, 0.99613, 0.85576, 0.99613, 0.85576, 0.99613, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.94299, 0.76783, 0.95961, 0.91677, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.86523, 0.9135, 0.86523, 0.9135, 0.86523, 0.9135, 1, 1, 0.92222, 0.92168, 0.92222, 0.92168, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.86036, 0.97096, 0.71743, 0.98981, 1, 1, 0.95298, 0.79726, 0.95381, 1, 1, 0.79726, 0.6894, 0.79726, 0.74321, 0.81691, 1.0006, 0.92222, 0.92168, 1, 1, 0.92222, 0.92168, 0.79464, 0.92098, 0.92168, 0.90637, 0.91513, 0.90637, 0.91513, 0.90637, 0.91513, 0.909, 0.87514, 0.80729, 0.95077, 1, 1, 0.80729, 0.95077, 0.76463, 0.748, 0.76463, 0.748, 1, 1, 0.76463, 0.748, 1, 1, 0.86275, 0.72651, 0.86275, 1.04502, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.9154, 0.94236, 0.85458, 0.89364, 0.85458, 0.90531, 0.9, 0.90531, 0.9, 0.90531, 0.9, 1, 0.97276, 0.85576, 0.99613, 0.845, 0.85811, 0.90251, 0.91677, 1, 1, 0.86275, 1.04502, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.00899, 1.30628, 0.85576, 0.80178, 0.66862, 0.7927, 0.69323, 0.88127, 0.72459, 0.89711, 0.95381, 0.85576, 0.80591, 0.7805, 0.94729, 0.77512, 0.90531, 0.92222, 0.90637, 0.98621, 0.81698, 0.92655, 0.98558, 0.92222, 0.85359, 0.90637, 0.90976, 0.83809, 0.94523, 0.86275, 0.83509, 0.93157, 0.85308, 0.83392, 0.92346, 0.98621, 0.83509, 0.92886, 0.91324, 0.92168, 0.95381, 0.90646, 0.92886, 0.90557, 0.86847, 0.90276, 0.91324, 0.86842, 0.92168, 0.99531, 0.95381, 0.9224, 0.85408, 0.92699, 0.86847, 1.0051, 0.91513, 0.80487, 0.93481, 1, 0.88159, 1.05214, 0.90646, 0.97355, 0.81539, 0.89398, 0.85923, 0.95381, 0.90646, 0.91513, 0.90646, 0.85923, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9154, 0.94236, 0.9154, 0.94236, 0.9154, 0.94236, 0.85458, 0.89364, 0.96694, 1, 0.89903, 1, 1, 1, 0.91782, 0.91782, 0.91782, 1, 0.896, 0.896, 0.896, 0.9332, 0.9332, 0.95973, 1, 1.26, 1, 1, 0.80479, 0.80178, 1, 1, 0.85633, 1, 1, 1, 1, 0.97276, 1, 1, 1, 0.698, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.14542, 1, 0.79199, 0.78694, 1.02058, 1.03493, 1.05486, 1, 1, 1.23026, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.20006, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.MyriadProBoldItalicFactors = st;
          const lt = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          at.MyriadProBoldItalicMetrics = lt;
          const et = [1.36898, 1, 1, 0.65507, 0.84943, 0.85639, 0.88465, 0.88465, 0.86936, 0.88307, 0.86948, 0.85283, 0.85283, 1.06383, 1.02058, 0.75945, 0.9219, 0.75945, 1.17337, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.75945, 0.75945, 1.02058, 1.02058, 1.02058, 0.69046, 0.70926, 0.85158, 0.77812, 0.76852, 0.89591, 0.70466, 0.76125, 0.80094, 0.86822, 0.83864, 0.728, 0.77212, 0.79475, 0.93637, 0.87514, 0.8588, 0.76013, 0.8588, 0.72421, 0.69866, 0.77598, 0.85991, 0.80811, 0.87832, 0.78112, 0.77512, 0.8562, 1.0222, 1.18417, 1.0222, 1.27014, 0.89903, 1.15012, 0.93859, 0.94399, 0.846, 0.94399, 0.81453, 1.0186, 0.94219, 0.96017, 1.03075, 1.02175, 0.912, 1.03075, 0.96998, 0.96017, 0.93859, 0.94399, 0.94399, 0.95493, 0.746, 1.12658, 0.94578, 0.91, 0.979, 0.882, 0.882, 0.83, 0.85034, 0.83537, 0.85034, 1.02058, 0.70869, 0.88465, 0.88465, 0.88465, 0.88465, 0.83537, 0.90083, 1.15012, 0.9161, 0.94565, 0.73541, 1.02058, 0.53609, 0.69353, 0.79519, 1.08595, 1, 1, 1.15012, 1, 0.91974, 0.75945, 1.15012, 1, 0.9446, 0.73361, 0.9005, 0.9005, 0.9005, 0.62864, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.773, 0.76852, 0.70466, 0.70466, 0.70466, 0.70466, 0.83864, 0.83864, 0.83864, 0.83864, 0.90561, 0.87514, 0.8588, 0.8588, 0.8588, 0.8588, 0.8588, 1.02058, 0.85751, 0.85991, 0.85991, 0.85991, 0.85991, 0.77512, 0.76013, 0.88075, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.8075, 0.846, 0.81453, 0.81453, 0.81453, 0.81453, 0.82424, 0.82424, 0.82424, 0.82424, 0.9278, 0.96017, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 1.08595, 0.8562, 0.94578, 0.94578, 0.94578, 0.94578, 0.882, 0.94578, 0.882, 0.85158, 0.93859, 0.85158, 0.93859, 0.85158, 0.93859, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.89591, 0.8544, 0.90561, 0.94399, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.80094, 0.94219, 0.80094, 0.94219, 0.80094, 0.94219, 1, 1, 0.86822, 0.96017, 0.86822, 0.96017, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 1.03075, 0.83864, 0.82424, 0.81402, 1.02738, 0.728, 1.02175, 1, 1, 0.912, 0.79475, 1.03075, 1, 1, 0.79475, 0.83911, 0.79475, 0.66266, 0.80553, 1.06676, 0.87514, 0.96017, 1, 1, 0.87514, 0.96017, 0.86865, 0.87396, 0.96017, 0.8588, 0.93859, 0.8588, 0.93859, 0.8588, 0.93859, 0.867, 0.84759, 0.72421, 0.95493, 1, 1, 0.72421, 0.95493, 0.69866, 0.746, 0.69866, 0.746, 1, 1, 0.69866, 0.746, 1, 1, 0.77598, 0.88417, 0.77598, 1.12658, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.87832, 0.979, 0.77512, 0.882, 0.77512, 0.8562, 0.83, 0.8562, 0.83, 0.8562, 0.83, 1, 0.88465, 0.85158, 0.93859, 0.773, 0.8075, 0.85751, 0.8562, 1, 1, 0.77598, 1.12658, 1.15012, 1.15012, 1.15012, 1.15012, 1.15012, 1.15313, 1.15012, 1.15012, 1.15012, 1.08106, 1.03901, 0.85158, 0.77025, 0.62264, 0.7646, 0.65351, 0.86026, 0.69461, 0.89947, 1.03075, 0.85158, 0.77812, 0.76449, 0.88836, 0.70466, 0.8562, 0.86822, 0.8588, 0.83864, 0.77212, 0.85308, 0.93637, 0.87514, 0.82352, 0.8588, 0.85701, 0.76013, 0.89058, 0.77598, 0.8156, 0.82565, 0.78112, 0.77899, 0.89386, 0.83864, 0.8156, 0.9486, 0.92388, 0.96186, 1.03075, 0.91123, 0.9486, 0.93298, 0.878, 0.93942, 0.92388, 0.84596, 0.96186, 0.95119, 1.03075, 0.922, 0.88787, 0.95829, 0.88, 0.93559, 0.93859, 0.78815, 0.93758, 1, 0.89217, 1.03737, 0.91123, 0.93969, 0.77487, 0.85769, 0.86799, 1.03075, 0.91123, 0.93859, 0.91123, 0.86799, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87832, 0.979, 0.87832, 0.979, 0.87832, 0.979, 0.77512, 0.882, 0.9219, 1, 0.89903, 1, 1, 1, 0.87321, 0.87321, 0.87321, 1, 1.027, 1.027, 1.027, 0.86847, 0.86847, 0.79121, 1, 1.124, 1, 1, 0.73572, 0.73572, 1, 1, 0.85034, 1, 1, 1, 1, 0.88465, 1, 1, 1, 0.669, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04828, 1, 0.74948, 0.75187, 1.02058, 0.98391, 1.02119, 1, 1, 1.06233, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05233, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.MyriadProItalicFactors = et;
          const it = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          at.MyriadProItalicMetrics = it;
          const ut = [1.36898, 1, 1, 0.76305, 0.82784, 0.94935, 0.89364, 0.92241, 0.89073, 0.90706, 0.98472, 0.85283, 0.85283, 1.0664, 1.02058, 0.74505, 0.9219, 0.74505, 1.23456, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.74505, 0.74505, 1.02058, 1.02058, 1.02058, 0.73002, 0.72601, 0.91755, 0.8126, 0.80314, 0.92222, 0.73764, 0.79726, 0.83051, 0.90284, 0.86023, 0.74, 0.8126, 0.84869, 0.96518, 0.91115, 0.8858, 0.79761, 0.8858, 0.74498, 0.73914, 0.81363, 0.89591, 0.83659, 0.89633, 0.85608, 0.8111, 0.90531, 1.0222, 1.22736, 1.0222, 1.27014, 0.89903, 0.90088, 0.86667, 1.0231, 0.896, 1.01411, 0.90083, 1.05099, 1.00512, 0.99793, 1.05326, 1.09377, 0.938, 1.06226, 1.00119, 0.99793, 0.98714, 1.0231, 1.01231, 0.98196, 0.792, 1.19137, 0.99074, 0.962, 1.01915, 0.926, 0.942, 0.856, 0.85034, 0.92006, 0.85034, 1.02058, 0.69067, 0.92241, 0.92241, 0.92241, 0.92241, 0.92006, 0.9332, 0.90088, 0.91882, 0.93484, 0.75339, 1.02058, 0.56866, 0.54324, 0.79519, 1.08595, 1, 1, 0.90088, 1, 0.95325, 0.74505, 0.90088, 1, 0.97198, 0.75339, 0.91009, 0.91009, 0.91009, 0.66466, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.788, 0.80314, 0.73764, 0.73764, 0.73764, 0.73764, 0.86023, 0.86023, 0.86023, 0.86023, 0.92915, 0.91115, 0.8858, 0.8858, 0.8858, 0.8858, 0.8858, 1.02058, 0.8858, 0.89591, 0.89591, 0.89591, 0.89591, 0.8111, 0.79611, 0.89713, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86936, 0.896, 0.90083, 0.90083, 0.90083, 0.90083, 0.84224, 0.84224, 0.84224, 0.84224, 0.97276, 0.99793, 0.98714, 0.98714, 0.98714, 0.98714, 0.98714, 1.08595, 0.89876, 0.99074, 0.99074, 0.99074, 0.99074, 0.942, 1.0231, 0.942, 0.91755, 0.86667, 0.91755, 0.86667, 0.91755, 0.86667, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.92222, 0.93372, 0.92915, 1.01411, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.83051, 1.00512, 0.83051, 1.00512, 0.83051, 1.00512, 1, 1, 0.90284, 0.99793, 0.90976, 0.99793, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 1.05326, 0.86023, 0.84224, 0.82873, 1.07469, 0.74, 1.09377, 1, 1, 0.938, 0.84869, 1.06226, 1, 1, 0.84869, 0.83704, 0.84869, 0.81441, 0.85588, 1.08927, 0.91115, 0.99793, 1, 1, 0.91115, 0.99793, 0.91887, 0.90991, 0.99793, 0.8858, 0.98714, 0.8858, 0.98714, 0.8858, 0.98714, 0.894, 0.91434, 0.74498, 0.98196, 1, 1, 0.74498, 0.98196, 0.73914, 0.792, 0.73914, 0.792, 1, 1, 0.73914, 0.792, 1, 1, 0.81363, 0.904, 0.81363, 1.19137, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89633, 1.01915, 0.8111, 0.942, 0.8111, 0.90531, 0.856, 0.90531, 0.856, 0.90531, 0.856, 1, 0.92241, 0.91755, 0.86667, 0.788, 0.86936, 0.8858, 0.89876, 1, 1, 0.81363, 1.19137, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90388, 1.03901, 0.92138, 0.78105, 0.7154, 0.86169, 0.80513, 0.94007, 0.82528, 0.98612, 1.06226, 0.91755, 0.8126, 0.81884, 0.92819, 0.73764, 0.90531, 0.90284, 0.8858, 0.86023, 0.8126, 0.91172, 0.96518, 0.91115, 0.83089, 0.8858, 0.87791, 0.79761, 0.89297, 0.81363, 0.88157, 0.89992, 0.85608, 0.81992, 0.94307, 0.86023, 0.88157, 0.95308, 0.98699, 0.99793, 1.06226, 0.95817, 0.95308, 0.97358, 0.928, 0.98088, 0.98699, 0.92761, 0.99793, 0.96017, 1.06226, 0.986, 0.944, 0.95978, 0.938, 0.96705, 0.98714, 0.80442, 0.98972, 1, 0.89762, 1.04552, 0.95817, 0.99007, 0.87064, 0.91879, 0.88888, 1.06226, 0.95817, 0.98714, 0.95817, 0.88888, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89633, 1.01915, 0.89633, 1.01915, 0.89633, 1.01915, 0.8111, 0.942, 0.9219, 1, 0.89903, 1, 1, 1, 0.93173, 0.93173, 0.93173, 1, 1.06304, 1.06304, 1.06904, 0.89903, 0.89903, 0.80549, 1, 1.156, 1, 1, 0.76575, 0.76575, 1, 1, 0.72458, 1, 1, 1, 1, 0.92241, 1, 1, 1, 0.619, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.07257, 1, 0.74705, 0.71119, 1.02058, 1.024, 1.02119, 1, 1, 1.1536, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05638, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.MyriadProRegularFactors = ut;
          const ft = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          at.MyriadProRegularMetrics = ft;
        },
        /* 207 */
        /***/
        (nt, at) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.SegoeuiRegularMetrics = at.SegoeuiRegularFactors = at.SegoeuiItalicMetrics = at.SegoeuiItalicFactors = at.SegoeuiBoldMetrics = at.SegoeuiBoldItalicMetrics = at.SegoeuiBoldItalicFactors = at.SegoeuiBoldFactors = void 0;
          const ot = [1.76738, 1, 1, 0.99297, 0.9824, 1.04016, 1.06497, 1.03424, 0.97529, 1.17647, 1.23203, 1.1085, 1.1085, 1.16939, 1.2107, 0.9754, 1.21408, 0.9754, 1.59578, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 0.81378, 0.81378, 1.2107, 1.2107, 1.2107, 0.71703, 0.97847, 0.97363, 0.88776, 0.8641, 1.02096, 0.79795, 0.85132, 0.914, 1.06085, 1.1406, 0.8007, 0.89858, 0.83693, 1.14889, 1.09398, 0.97489, 0.92094, 0.97489, 0.90399, 0.84041, 0.95923, 1.00135, 1, 1.06467, 0.98243, 0.90996, 0.99361, 1.1085, 1.56942, 1.1085, 1.2107, 0.74627, 0.94282, 0.96752, 1.01519, 0.86304, 1.01359, 0.97278, 1.15103, 1.01359, 0.98561, 1.02285, 1.02285, 1.00527, 1.02285, 1.0302, 0.99041, 1.0008, 1.01519, 1.01359, 1.02258, 0.79104, 1.16862, 0.99041, 0.97454, 1.02511, 0.99298, 0.96752, 0.95801, 0.94856, 1.16579, 0.94856, 1.2107, 0.9824, 1.03424, 1.03424, 1, 1.03424, 1.16579, 0.8727, 1.3871, 1.18622, 1.10818, 1.04478, 1.2107, 1.18622, 0.75155, 0.94994, 1.28826, 1.21408, 1.21408, 0.91056, 1, 0.91572, 0.9754, 0.64663, 1.18328, 1.24866, 1.04478, 1.14169, 1.15749, 1.17389, 0.71703, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.93506, 0.8641, 0.79795, 0.79795, 0.79795, 0.79795, 1.1406, 1.1406, 1.1406, 1.1406, 1.02096, 1.09398, 0.97426, 0.97426, 0.97426, 0.97426, 0.97426, 1.2107, 0.97489, 1.00135, 1.00135, 1.00135, 1.00135, 0.90996, 0.92094, 1.02798, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.93136, 0.86304, 0.97278, 0.97278, 0.97278, 0.97278, 1.02285, 1.02285, 1.02285, 1.02285, 0.97122, 0.99041, 1, 1, 1, 1, 1, 1.28826, 1.0008, 0.99041, 0.99041, 0.99041, 0.99041, 0.96752, 1.01519, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 1.02096, 1.03057, 1.02096, 1.03517, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.914, 1.01359, 0.914, 1.01359, 0.914, 1.01359, 1, 1, 1.06085, 0.98561, 1.06085, 1.00879, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 0.97138, 1.08692, 0.8007, 1.02285, 1, 1, 1.00527, 0.83693, 1.02285, 1, 1, 0.83693, 0.9455, 0.83693, 0.90418, 0.83693, 1.13005, 1.09398, 0.99041, 1, 1, 1.09398, 0.99041, 0.96692, 1.09251, 0.99041, 0.97489, 1.0008, 0.97489, 1.0008, 0.97489, 1.0008, 0.93994, 0.97931, 0.90399, 1.02258, 1, 1, 0.90399, 1.02258, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 1, 1, 0.95923, 1.07034, 0.95923, 1.16862, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.06467, 1.02511, 0.90996, 0.96752, 0.90996, 0.99361, 0.95801, 0.99361, 0.95801, 0.99361, 0.95801, 1.07733, 1.03424, 0.97363, 0.96752, 0.93506, 0.93136, 0.97489, 1.0008, 1, 1, 0.95923, 1.16862, 1.15103, 1.15103, 1.01173, 1.03959, 0.75953, 0.81378, 0.79912, 1.15103, 1.21994, 0.95161, 0.87815, 1.01149, 0.81525, 0.7676, 0.98167, 1.01134, 1.02546, 0.84097, 1.03089, 1.18102, 0.97363, 0.88776, 0.85134, 0.97826, 0.79795, 0.99361, 1.06085, 0.97489, 1.1406, 0.89858, 1.0388, 1.14889, 1.09398, 0.86039, 0.97489, 1.0595, 0.92094, 0.94793, 0.95923, 0.90996, 0.99346, 0.98243, 1.02112, 0.95493, 1.1406, 0.90996, 1.03574, 1.02597, 1.0008, 1.18102, 1.06628, 1.03574, 1.0192, 1.01932, 1.00886, 0.97531, 1.0106, 1.0008, 1.13189, 1.18102, 1.02277, 0.98683, 1.0016, 0.99561, 1.07237, 1.0008, 0.90434, 0.99921, 0.93803, 0.8965, 1.23085, 1.06628, 1.04983, 0.96268, 1.0499, 0.98439, 1.18102, 1.06628, 1.0008, 1.06628, 0.98439, 0.79795, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09466, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.97278, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.02065, 1, 1, 1, 1, 1, 1, 1.06467, 1.02511, 1.06467, 1.02511, 1.06467, 1.02511, 0.90996, 0.96752, 1, 1.21408, 0.89903, 1, 1, 0.75155, 1.04394, 1.04394, 1.04394, 1.04394, 0.98633, 0.98633, 0.98633, 0.73047, 0.73047, 1.20642, 0.91211, 1.25635, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.12454, 0.93503, 1.03424, 1.19687, 1.03424, 1, 1, 1, 0.771, 1, 1, 1.15749, 1.15749, 1.15749, 1.10948, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.16897, 1, 0.96085, 0.90137, 1.2107, 1.18416, 1.13973, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21172, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18874, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.09193, 1.09193, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.SegoeuiBoldFactors = ot;
          const rt = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          at.SegoeuiBoldMetrics = rt;
          const st = [1.76738, 1, 1, 0.98946, 1.03959, 1.04016, 1.02809, 1.036, 0.97639, 1.10953, 1.23203, 1.11144, 1.11144, 1.16939, 1.21237, 0.9754, 1.21261, 0.9754, 1.59754, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 0.81378, 0.81378, 1.21237, 1.21237, 1.21237, 0.73541, 0.97847, 0.97363, 0.89723, 0.87897, 1.0426, 0.79429, 0.85292, 0.91149, 1.05815, 1.1406, 0.79631, 0.90128, 0.83853, 1.04396, 1.10615, 0.97552, 0.94436, 0.97552, 0.88641, 0.80527, 0.96083, 1.00135, 1, 1.06777, 0.9817, 0.91142, 0.99361, 1.11144, 1.57293, 1.11144, 1.21237, 0.74627, 1.31818, 1.06585, 0.97042, 0.83055, 0.97042, 0.93503, 1.1261, 0.97042, 0.97922, 1.14236, 0.94552, 1.01054, 1.14236, 1.02471, 0.97922, 0.94165, 0.97042, 0.97042, 1.0276, 0.78929, 1.1261, 0.97922, 0.95874, 1.02197, 0.98507, 0.96752, 0.97168, 0.95107, 1.16579, 0.95107, 1.21237, 1.03959, 1.036, 1.036, 1, 1.036, 1.16579, 0.87357, 1.31818, 1.18754, 1.26781, 1.05356, 1.21237, 1.18622, 0.79487, 0.94994, 1.29004, 1.24047, 1.24047, 1.31818, 1, 0.91484, 0.9754, 1.31818, 1.1349, 1.24866, 1.05356, 1.13934, 1.15574, 1.17389, 0.73541, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.94385, 0.87897, 0.79429, 0.79429, 0.79429, 0.79429, 1.1406, 1.1406, 1.1406, 1.1406, 1.0426, 1.10615, 0.97552, 0.97552, 0.97552, 0.97552, 0.97552, 1.21237, 0.97552, 1.00135, 1.00135, 1.00135, 1.00135, 0.91142, 0.94436, 0.98721, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 0.96705, 0.83055, 0.93503, 0.93503, 0.93503, 0.93503, 1.14236, 1.14236, 1.14236, 1.14236, 0.93125, 0.97922, 0.94165, 0.94165, 0.94165, 0.94165, 0.94165, 1.29004, 0.94165, 0.97922, 0.97922, 0.97922, 0.97922, 0.96752, 0.97042, 0.96752, 0.97363, 1.06585, 0.97363, 1.06585, 0.97363, 1.06585, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 1.0426, 1.0033, 1.0426, 0.97042, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.91149, 0.97042, 0.91149, 0.97042, 0.91149, 0.97042, 1, 1, 1.05815, 0.97922, 1.05815, 0.97922, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 0.97441, 1.04302, 0.79631, 1.01582, 1, 1, 1.01054, 0.83853, 1.14236, 1, 1, 0.83853, 1.09125, 0.83853, 0.90418, 0.83853, 1.19508, 1.10615, 0.97922, 1, 1, 1.10615, 0.97922, 1.01034, 1.10466, 0.97922, 0.97552, 0.94165, 0.97552, 0.94165, 0.97552, 0.94165, 0.91602, 0.91981, 0.88641, 1.0276, 1, 1, 0.88641, 1.0276, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 1, 1, 0.96083, 1.05403, 0.95923, 1.16862, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.06777, 1.02197, 0.91142, 0.96752, 0.91142, 0.99361, 0.97168, 0.99361, 0.97168, 0.99361, 0.97168, 1.23199, 1.036, 0.97363, 1.06585, 0.94385, 0.96705, 0.97552, 0.94165, 1, 1, 0.96083, 1.1261, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 0.95161, 1.27126, 1.00811, 0.83284, 0.77702, 0.99137, 0.95253, 1.0347, 0.86142, 1.07205, 1.14236, 0.97363, 0.89723, 0.86869, 1.09818, 0.79429, 0.99361, 1.05815, 0.97552, 1.1406, 0.90128, 1.06662, 1.04396, 1.10615, 0.84918, 0.97552, 1.04694, 0.94436, 0.98015, 0.96083, 0.91142, 1.00356, 0.9817, 1.01945, 0.98999, 1.1406, 0.91142, 1.04961, 0.9898, 1.00639, 1.14236, 1.07514, 1.04961, 0.99607, 1.02897, 1.008, 0.9898, 0.95134, 1.00639, 1.11121, 1.14236, 1.00518, 0.97981, 1.02186, 1, 1.08578, 0.94165, 0.99314, 0.98387, 0.93028, 0.93377, 1.35125, 1.07514, 1.10687, 0.93491, 1.04232, 1.00351, 1.14236, 1.07514, 0.94165, 1.07514, 1.00351, 0.79429, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09097, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.93503, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96609, 1, 1, 1, 1, 1, 1, 1.06777, 1.02197, 1.06777, 1.02197, 1.06777, 1.02197, 0.91142, 0.96752, 1, 1.21261, 0.89903, 1, 1, 0.75155, 1.04745, 1.04745, 1.04745, 1.04394, 0.98633, 0.98633, 0.98633, 0.72959, 0.72959, 1.20502, 0.91406, 1.26514, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.09125, 0.93327, 1.03336, 1.16541, 1.036, 1, 1, 1, 0.771, 1, 1, 1.15574, 1.15574, 1.15574, 1.15574, 0.86364, 0.94434, 0.86279, 0.94434, 0.86224, 1, 1, 1.16798, 1, 0.96085, 0.90068, 1.21237, 1.18416, 1.13904, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21339, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18775, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.13269, 1.13269, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.SegoeuiBoldItalicFactors = st;
          const lt = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          at.SegoeuiBoldItalicMetrics = lt;
          const et = [1.76738, 1, 1, 0.98946, 1.14763, 1.05365, 1.06234, 0.96927, 0.92586, 1.15373, 1.18414, 0.91349, 0.91349, 1.07403, 1.17308, 0.78383, 1.20088, 0.78383, 1.42531, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78383, 0.78383, 1.17308, 1.17308, 1.17308, 0.77349, 0.94565, 0.94729, 0.85944, 0.88506, 0.9858, 0.74817, 0.80016, 0.88449, 0.98039, 0.95782, 0.69238, 0.89898, 0.83231, 0.98183, 1.03989, 0.96924, 0.86237, 0.96924, 0.80595, 0.74524, 0.86091, 0.95402, 0.94143, 0.98448, 0.8858, 0.83089, 0.93285, 1.0949, 1.39016, 1.0949, 1.45994, 0.74627, 1.04839, 0.97454, 0.97454, 0.87207, 0.97454, 0.87533, 1.06151, 0.97454, 1.00176, 1.16484, 1.08132, 0.98047, 1.16484, 1.02989, 1.01054, 0.96225, 0.97454, 0.97454, 1.06598, 0.79004, 1.16344, 1.00351, 0.94629, 0.9973, 0.91016, 0.96777, 0.9043, 0.91082, 0.92481, 0.91082, 1.17308, 0.95748, 0.96927, 0.96927, 1, 0.96927, 0.92481, 0.80597, 1.04839, 1.23393, 1.1781, 0.9245, 1.17308, 1.20808, 0.63218, 0.94261, 1.24822, 1.09971, 1.09971, 1.04839, 1, 0.85273, 0.78032, 1.04839, 1.09971, 1.22326, 0.9245, 1.09836, 1.13525, 1.15222, 0.70424, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.85498, 0.88506, 0.74817, 0.74817, 0.74817, 0.74817, 0.95782, 0.95782, 0.95782, 0.95782, 0.9858, 1.03989, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.17308, 0.96924, 0.95402, 0.95402, 0.95402, 0.95402, 0.83089, 0.86237, 0.88409, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.92916, 0.87207, 0.87533, 0.87533, 0.87533, 0.87533, 0.93146, 0.93146, 0.93146, 0.93146, 0.93854, 1.01054, 0.96225, 0.96225, 0.96225, 0.96225, 0.96225, 1.24822, 0.8761, 1.00351, 1.00351, 1.00351, 1.00351, 0.96777, 0.97454, 0.96777, 0.94729, 0.97454, 0.94729, 0.97454, 0.94729, 0.97454, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.9858, 0.95391, 0.9858, 0.97454, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.88449, 0.97454, 0.88449, 0.97454, 0.88449, 0.97454, 1, 1, 0.98039, 1.00176, 0.98039, 1.00176, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 1.16484, 0.95782, 0.93146, 0.84421, 1.12761, 0.69238, 1.08132, 1, 1, 0.98047, 0.83231, 1.16484, 1, 1, 0.84723, 1.04861, 0.84723, 0.78755, 0.83231, 1.23736, 1.03989, 1.01054, 1, 1, 1.03989, 1.01054, 0.9857, 1.03849, 1.01054, 0.96924, 0.96225, 0.96924, 0.96225, 0.96924, 0.96225, 0.92383, 0.90171, 0.80595, 1.06598, 1, 1, 0.80595, 1.06598, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 1, 1, 0.86091, 1.02759, 0.85771, 1.16344, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.98448, 0.9973, 0.83089, 0.96777, 0.83089, 0.93285, 0.9043, 0.93285, 0.9043, 0.93285, 0.9043, 1.31868, 0.96927, 0.94729, 0.97454, 0.85498, 0.92916, 0.96924, 0.8761, 1, 1, 0.86091, 1.16344, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 0.81965, 0.81965, 0.94729, 0.78032, 0.71022, 0.90883, 0.84171, 0.99877, 0.77596, 1.05734, 1.2, 0.94729, 0.85944, 0.82791, 0.9607, 0.74817, 0.93285, 0.98039, 0.96924, 0.95782, 0.89898, 0.98316, 0.98183, 1.03989, 0.78614, 0.96924, 0.97642, 0.86237, 0.86075, 0.86091, 0.83089, 0.90082, 0.8858, 0.97296, 1.01284, 0.95782, 0.83089, 1.0976, 1.04, 1.03342, 1.2, 1.0675, 1.0976, 0.98205, 1.03809, 1.05097, 1.04, 0.95364, 1.03342, 1.05401, 1.2, 1.02148, 1.0119, 1.04724, 1.0127, 1.02732, 0.96225, 0.8965, 0.97783, 0.93574, 0.94818, 1.30679, 1.0675, 1.11826, 0.99821, 1.0557, 1.0326, 1.2, 1.0675, 0.96225, 1.0675, 1.0326, 0.74817, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03754, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87533, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.98705, 1, 1, 1, 1, 1, 1, 0.98448, 0.9973, 0.98448, 0.9973, 0.98448, 0.9973, 0.83089, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 0.94945, 0.94945, 0.94945, 0.94945, 1.12317, 1.12317, 1.12317, 0.67603, 0.67603, 1.15621, 0.73584, 1.21191, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87709, 0.96927, 1.01473, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.09836, 1.09836, 1.09836, 1.01522, 0.86321, 0.94434, 0.8649, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86438, 1.17308, 1.18416, 1.14589, 0.69825, 0.97622, 1.96791, 1.24822, 1.24822, 1.17308, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.17984, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10742, 1.10742, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.SegoeuiItalicFactors = et;
          const it = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          at.SegoeuiItalicMetrics = it;
          const ut = [1.76738, 1, 1, 0.98594, 1.02285, 1.10454, 1.06234, 0.96927, 0.92037, 1.19985, 1.2046, 0.90616, 0.90616, 1.07152, 1.1714, 0.78032, 1.20088, 0.78032, 1.40246, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78032, 0.78032, 1.1714, 1.1714, 1.1714, 0.80597, 0.94084, 0.96706, 0.85944, 0.85734, 0.97093, 0.75842, 0.79936, 0.88198, 0.9831, 0.95782, 0.71387, 0.86969, 0.84636, 1.07796, 1.03584, 0.96924, 0.83968, 0.96924, 0.82826, 0.79649, 0.85771, 0.95132, 0.93119, 0.98965, 0.88433, 0.8287, 0.93365, 1.08612, 1.3638, 1.08612, 1.45786, 0.74627, 0.80499, 0.91484, 1.05707, 0.92383, 1.05882, 0.9403, 1.12654, 1.05882, 1.01756, 1.09011, 1.09011, 0.99414, 1.09011, 1.034, 1.01756, 1.05356, 1.05707, 1.05882, 1.04399, 0.84863, 1.21968, 1.01756, 0.95801, 1.00068, 0.91797, 0.96777, 0.9043, 0.90351, 0.92105, 0.90351, 1.1714, 0.85337, 0.96927, 0.96927, 0.99912, 0.96927, 0.92105, 0.80597, 1.2434, 1.20808, 1.05937, 0.90957, 1.1714, 1.20808, 0.75155, 0.94261, 1.24644, 1.09971, 1.09971, 0.84751, 1, 0.85273, 0.78032, 0.61584, 1.05425, 1.17914, 0.90957, 1.08665, 1.11593, 1.14169, 0.73381, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.86035, 0.85734, 0.75842, 0.75842, 0.75842, 0.75842, 0.95782, 0.95782, 0.95782, 0.95782, 0.97093, 1.03584, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.1714, 0.96924, 0.95132, 0.95132, 0.95132, 0.95132, 0.8287, 0.83968, 0.89049, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.93575, 0.92383, 0.9403, 0.9403, 0.9403, 0.9403, 0.8717, 0.8717, 0.8717, 0.8717, 1.00527, 1.01756, 1.05356, 1.05356, 1.05356, 1.05356, 1.05356, 1.24644, 0.95923, 1.01756, 1.01756, 1.01756, 1.01756, 0.96777, 1.05707, 0.96777, 0.96706, 0.91484, 0.96706, 0.91484, 0.96706, 0.91484, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.97093, 1.0969, 0.97093, 1.05882, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.88198, 1.05882, 0.88198, 1.05882, 0.88198, 1.05882, 1, 1, 0.9831, 1.01756, 0.9831, 1.01756, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 1.09011, 0.95782, 0.8717, 0.84784, 1.11551, 0.71387, 1.09011, 1, 1, 0.99414, 0.84636, 1.09011, 1, 1, 0.84636, 1.0536, 0.84636, 0.94298, 0.84636, 1.23297, 1.03584, 1.01756, 1, 1, 1.03584, 1.01756, 1.00323, 1.03444, 1.01756, 0.96924, 1.05356, 0.96924, 1.05356, 0.96924, 1.05356, 0.93066, 0.98293, 0.82826, 1.04399, 1, 1, 0.82826, 1.04399, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 1, 1, 0.85771, 1.17318, 0.85771, 1.21968, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.98965, 1.00068, 0.8287, 0.96777, 0.8287, 0.93365, 0.9043, 0.93365, 0.9043, 0.93365, 0.9043, 1.08571, 0.96927, 0.96706, 0.91484, 0.86035, 0.93575, 0.96924, 0.95923, 1, 1, 0.85771, 1.21968, 1.11437, 1.11437, 0.93109, 0.91202, 0.60411, 0.84164, 0.55572, 1.01173, 0.97361, 0.81818, 0.81818, 0.96635, 0.78032, 0.72727, 0.92366, 0.98601, 1.03405, 0.77968, 1.09799, 1.2, 0.96706, 0.85944, 0.85638, 0.96491, 0.75842, 0.93365, 0.9831, 0.96924, 0.95782, 0.86969, 0.94152, 1.07796, 1.03584, 0.78437, 0.96924, 0.98715, 0.83968, 0.83491, 0.85771, 0.8287, 0.94492, 0.88433, 0.9287, 1.0098, 0.95782, 0.8287, 1.0625, 0.98248, 1.03424, 1.2, 1.01071, 1.0625, 0.95246, 1.03809, 1.04912, 0.98248, 1.00221, 1.03424, 1.05443, 1.2, 1.04785, 0.99609, 1.00169, 1.05176, 0.99346, 1.05356, 0.9087, 1.03004, 0.95542, 0.93117, 1.23362, 1.01071, 1.07831, 1.02512, 1.05205, 1.03502, 1.2, 1.01071, 1.05356, 1.01071, 1.03502, 0.75842, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03719, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9403, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04021, 1, 1, 1, 1, 1, 1, 0.98965, 1.00068, 0.98965, 1.00068, 0.98965, 1.00068, 0.8287, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 1.03077, 1.03077, 1.03077, 1.03077, 1.13196, 1.13196, 1.13196, 0.67428, 0.67428, 1.16039, 0.73291, 1.20996, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87796, 0.96927, 1.01518, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.10539, 1.10539, 1.11358, 1.06967, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86507, 1.1714, 1.18416, 1.14589, 0.69825, 0.97622, 1.9697, 1.24822, 1.24822, 1.17238, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18083, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10938, 1.10938, 1, 1, 1, 1.05425, 1.09971, 1.09971, 1.09971, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          at.SegoeuiRegularFactors = ut;
          const ft = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          at.SegoeuiRegularMetrics = ft;
        },
        /* 208 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.PostScriptEvaluator = at.PostScriptCompiler = at.PDFFunctionFactory = void 0, at.isPDFFunction = dt, ot(2), ot(140), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(160);
          var rt = ot(151), st = ot(145), lt = ot(209), et = ot(152), it = ot(210);
          class ut {
            constructor(Rt) {
              let {
                xref: kt,
                isEvalSupported: jt = !0
              } = Rt;
              this.xref = kt, this.isEvalSupported = jt !== !1;
            }
            create(Rt) {
              const kt = this.getCached(Rt);
              if (kt)
                return kt;
              const jt = ht.parse({
                xref: this.xref,
                isEvalSupported: this.isEvalSupported,
                fn: Rt instanceof rt.Ref ? this.xref.fetch(Rt) : Rt
              });
              return this._cache(Rt, jt), jt;
            }
            createFromArray(Rt) {
              const kt = this.getCached(Rt);
              if (kt)
                return kt;
              const jt = ht.parseArray({
                xref: this.xref,
                isEvalSupported: this.isEvalSupported,
                fnObj: Rt instanceof rt.Ref ? this.xref.fetch(Rt) : Rt
              });
              return this._cache(Rt, jt), jt;
            }
            getCached(Rt) {
              var jt;
              let kt;
              if (Rt instanceof rt.Ref ? kt = Rt : Rt instanceof rt.Dict ? kt = Rt.objId : Rt instanceof et.BaseStream && (kt = (jt = Rt.dict) == null ? void 0 : jt.objId), kt) {
                const Ht = this._localFunctionCache.getByRef(kt);
                if (Ht)
                  return Ht;
              }
              return null;
            }
            _cache(Rt, kt) {
              var Ht;
              if (!kt)
                throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
              let jt;
              Rt instanceof rt.Ref ? jt = Rt : Rt instanceof rt.Dict ? jt = Rt.objId : Rt instanceof et.BaseStream && (jt = (Ht = Rt.dict) == null ? void 0 : Ht.objId), jt && this._localFunctionCache.set(null, jt, kt);
            }
            get _localFunctionCache() {
              return (0, st.shadow)(this, "_localFunctionCache", new it.LocalFunctionCache());
            }
          }
          at.PDFFunctionFactory = ut;
          function ft(yt) {
            if (!Array.isArray(yt))
              return null;
            const Rt = yt.length;
            for (let kt = 0; kt < Rt; kt++)
              if (typeof yt[kt] != "number") {
                const jt = new Array(Rt);
                for (let Ht = 0; Ht < Rt; Ht++)
                  jt[Ht] = +yt[Ht];
                return jt;
              }
            return yt;
          }
          class ht {
            static getSampleArray(Rt, kt, jt, Ht) {
              let Ft, _t, Nt = 1;
              for (Ft = 0, _t = Rt.length; Ft < _t; Ft++)
                Nt *= Rt[Ft];
              Nt *= kt;
              const Mt = new Array(Nt);
              let Lt = 0, $t = 0;
              const Tt = 1 / (2 ** jt - 1), Dt = Ht.getBytes((Nt * jt + 7) / 8);
              let Ut = 0;
              for (Ft = 0; Ft < Nt; Ft++) {
                for (; Lt < jt; )
                  $t <<= 8, $t |= Dt[Ut++], Lt += 8;
                Lt -= jt, Mt[Ft] = ($t >> Lt) * Tt, $t &= (1 << Lt) - 1;
              }
              return Mt;
            }
            static parse(Rt) {
              let {
                xref: kt,
                isEvalSupported: jt,
                fn: Ht
              } = Rt;
              const Ft = Ht.dict || Ht;
              switch (Ft.get("FunctionType")) {
                case 0:
                  return this.constructSampled({
                    xref: kt,
                    isEvalSupported: jt,
                    fn: Ht,
                    dict: Ft
                  });
                case 1:
                  break;
                case 2:
                  return this.constructInterpolated({
                    xref: kt,
                    isEvalSupported: jt,
                    dict: Ft
                  });
                case 3:
                  return this.constructStiched({
                    xref: kt,
                    isEvalSupported: jt,
                    dict: Ft
                  });
                case 4:
                  return this.constructPostScript({
                    xref: kt,
                    isEvalSupported: jt,
                    fn: Ht,
                    dict: Ft
                  });
              }
              throw new st.FormatError("Unknown type of function");
            }
            static parseArray(Rt) {
              let {
                xref: kt,
                isEvalSupported: jt,
                fnObj: Ht
              } = Rt;
              if (!Array.isArray(Ht))
                return this.parse({
                  xref: kt,
                  isEvalSupported: jt,
                  fn: Ht
                });
              const Ft = [];
              for (const _t of Ht)
                Ft.push(this.parse({
                  xref: kt,
                  isEvalSupported: jt,
                  fn: kt.fetchIfRef(_t)
                }));
              return function(_t, Nt, Mt, Lt) {
                for (let $t = 0, Tt = Ft.length; $t < Tt; $t++)
                  Ft[$t](_t, Nt, Mt, Lt + $t);
              };
            }
            static constructSampled(Rt) {
              let {
                xref: kt,
                isEvalSupported: jt,
                fn: Ht,
                dict: Ft
              } = Rt;
              function _t(ar) {
                const Jt = ar.length, rr = [];
                let Yt = 0;
                for (let Kt = 0; Kt < Jt; Kt += 2)
                  rr[Yt++] = [ar[Kt], ar[Kt + 1]];
                return rr;
              }
              function Nt(ar, Jt, rr, Yt, Kt) {
                return Yt + (ar - Jt) * ((Kt - Yt) / (rr - Jt));
              }
              let Mt = ft(Ft.getArray("Domain")), Lt = ft(Ft.getArray("Range"));
              if (!Mt || !Lt)
                throw new st.FormatError("No domain or range");
              const $t = Mt.length / 2, Tt = Lt.length / 2;
              Mt = _t(Mt), Lt = _t(Lt);
              const Dt = ft(Ft.getArray("Size")), Ut = Ft.get("BitsPerSample"), Vt = Ft.get("Order") || 1;
              Vt !== 1 && (0, st.info)("No support for cubic spline interpolation: " + Vt);
              let Qt = ft(Ft.getArray("Encode"));
              if (Qt)
                Qt = _t(Qt);
              else {
                Qt = [];
                for (let ar = 0; ar < $t; ++ar)
                  Qt.push([0, Dt[ar] - 1]);
              }
              let qt = ft(Ft.getArray("Decode"));
              qt = qt ? _t(qt) : Lt;
              const Zt = this.getSampleArray(Dt, Tt, Ut, Ht);
              return function(Jt, rr, Yt, Kt) {
                const nr = 1 << $t, tr = new Float64Array(nr), ir = new Uint32Array(nr);
                let sr, cr;
                for (cr = 0; cr < nr; cr++)
                  tr[cr] = 1;
                let or = Tt, Xt = 1;
                for (sr = 0; sr < $t; ++sr) {
                  const Gt = Mt[sr][0], Wt = Mt[sr][1], er = Math.min(Math.max(Jt[rr + sr], Gt), Wt);
                  let lr = Nt(er, Gt, Wt, Qt[sr][0], Qt[sr][1]);
                  const ur = Dt[sr];
                  lr = Math.min(Math.max(lr, 0), ur - 1);
                  const pr = lr < ur - 1 ? Math.floor(lr) : lr - 1, yr = pr + 1 - lr, Er = lr - pr, br = pr * or, gr = br + or;
                  for (cr = 0; cr < nr; cr++)
                    cr & Xt ? (tr[cr] *= Er, ir[cr] += gr) : (tr[cr] *= yr, ir[cr] += br);
                  or *= ur, Xt <<= 1;
                }
                for (cr = 0; cr < Tt; ++cr) {
                  let Gt = 0;
                  for (sr = 0; sr < nr; sr++)
                    Gt += Zt[ir[sr] + cr] * tr[sr];
                  Gt = Nt(Gt, 0, 1, qt[cr][0], qt[cr][1]), Yt[Kt + cr] = Math.min(Math.max(Gt, Lt[cr][0]), Lt[cr][1]);
                }
              };
            }
            static constructInterpolated(Rt) {
              let {
                xref: kt,
                isEvalSupported: jt,
                dict: Ht
              } = Rt;
              const Ft = ft(Ht.getArray("C0")) || [0], _t = ft(Ht.getArray("C1")) || [1], Nt = Ht.get("N"), Mt = [];
              for (let $t = 0, Tt = Ft.length; $t < Tt; ++$t)
                Mt.push(_t[$t] - Ft[$t]);
              const Lt = Mt.length;
              return function(Tt, Dt, Ut, Vt) {
                const Qt = Nt === 1 ? Tt[Dt] : Tt[Dt] ** Nt;
                for (let qt = 0; qt < Lt; ++qt)
                  Ut[Vt + qt] = Ft[qt] + Qt * Mt[qt];
              };
            }
            static constructStiched(Rt) {
              let {
                xref: kt,
                isEvalSupported: jt,
                dict: Ht
              } = Rt;
              const Ft = ft(Ht.getArray("Domain"));
              if (!Ft)
                throw new st.FormatError("No domain");
              if (Ft.length / 2 !== 1)
                throw new st.FormatError("Bad domain for stiched function");
              const Nt = [];
              for (const Tt of Ht.get("Functions"))
                Nt.push(this.parse({
                  xref: kt,
                  isEvalSupported: jt,
                  fn: kt.fetchIfRef(Tt)
                }));
              const Mt = ft(Ht.getArray("Bounds")), Lt = ft(Ht.getArray("Encode")), $t = new Float32Array(1);
              return function(Dt, Ut, Vt, Qt) {
                const Zt = function(ir, sr, cr) {
                  return ir > cr ? ir = cr : ir < sr && (ir = sr), ir;
                }(Dt[Ut], Ft[0], Ft[1]), ar = Mt.length;
                let Jt;
                for (Jt = 0; Jt < ar && !(Zt < Mt[Jt]); ++Jt)
                  ;
                let rr = Ft[0];
                Jt > 0 && (rr = Mt[Jt - 1]);
                let Yt = Ft[1];
                Jt < Mt.length && (Yt = Mt[Jt]);
                const Kt = Lt[2 * Jt], nr = Lt[2 * Jt + 1];
                $t[0] = rr === Yt ? Kt : Kt + (Zt - rr) * (nr - Kt) / (Yt - rr), Nt[Jt]($t, 0, Vt, Qt);
              };
            }
            static constructPostScript(Rt) {
              let {
                xref: kt,
                isEvalSupported: jt,
                fn: Ht,
                dict: Ft
              } = Rt;
              const _t = ft(Ft.getArray("Domain")), Nt = ft(Ft.getArray("Range"));
              if (!_t)
                throw new st.FormatError("No domain.");
              if (!Nt)
                throw new st.FormatError("No range.");
              const Mt = new lt.PostScriptLexer(Ht), $t = new lt.PostScriptParser(Mt).parse();
              if (jt && st.FeatureTest.isEvalSupported) {
                const ar = new Ct().compile($t, _t, Nt);
                if (ar)
                  return new Function("src", "srcOffset", "dest", "destOffset", ar);
              }
              (0, st.info)("Unable to compile PS function");
              const Tt = Nt.length >> 1, Dt = _t.length >> 1, Ut = new pt($t), Vt = /* @__PURE__ */ Object.create(null);
              let qt = 2048 * 4;
              const Zt = new Float32Array(Dt);
              return function(Jt, rr, Yt, Kt) {
                let nr, tr, ir = "";
                const sr = Zt;
                for (nr = 0; nr < Dt; nr++)
                  tr = Jt[rr + nr], sr[nr] = tr, ir += tr + "_";
                const cr = Vt[ir];
                if (cr !== void 0) {
                  Yt.set(cr, Kt);
                  return;
                }
                const or = new Float32Array(Tt), Xt = Ut.execute(sr), Gt = Xt.length - Tt;
                for (nr = 0; nr < Tt; nr++) {
                  tr = Xt[Gt + nr];
                  let Wt = Nt[nr * 2];
                  tr < Wt ? tr = Wt : (Wt = Nt[nr * 2 + 1], tr > Wt && (tr = Wt)), or[nr] = tr;
                }
                qt > 0 && (qt--, Vt[ir] = or), Yt.set(or, Kt);
              };
            }
          }
          function dt(yt) {
            let Rt;
            if (yt instanceof rt.Dict)
              Rt = yt;
            else if (yt instanceof et.BaseStream)
              Rt = yt.dict;
            else
              return !1;
            return Rt.has("FunctionType");
          }
          const It = class It {
            constructor(Rt) {
              this.stack = Rt ? Array.from(Rt) : [];
            }
            push(Rt) {
              if (this.stack.length >= It.MAX_STACK_SIZE)
                throw new Error("PostScript function stack overflow.");
              this.stack.push(Rt);
            }
            pop() {
              if (this.stack.length <= 0)
                throw new Error("PostScript function stack underflow.");
              return this.stack.pop();
            }
            copy(Rt) {
              if (this.stack.length + Rt >= It.MAX_STACK_SIZE)
                throw new Error("PostScript function stack overflow.");
              const kt = this.stack;
              for (let jt = kt.length - Rt, Ht = Rt - 1; Ht >= 0; Ht--, jt++)
                kt.push(kt[jt]);
            }
            index(Rt) {
              this.push(this.stack[this.stack.length - Rt - 1]);
            }
            roll(Rt, kt) {
              const jt = this.stack, Ht = jt.length - Rt, Ft = jt.length - 1, _t = Ht + (kt - Math.floor(kt / Rt) * Rt);
              for (let Nt = Ht, Mt = Ft; Nt < Mt; Nt++, Mt--) {
                const Lt = jt[Nt];
                jt[Nt] = jt[Mt], jt[Mt] = Lt;
              }
              for (let Nt = Ht, Mt = _t - 1; Nt < Mt; Nt++, Mt--) {
                const Lt = jt[Nt];
                jt[Nt] = jt[Mt], jt[Mt] = Lt;
              }
              for (let Nt = _t, Mt = Ft; Nt < Mt; Nt++, Mt--) {
                const Lt = jt[Nt];
                jt[Nt] = jt[Mt], jt[Mt] = Lt;
              }
            }
          };
          Ln(It, "MAX_STACK_SIZE", 100);
          let gt = It;
          class pt {
            constructor(Rt) {
              this.operators = Rt;
            }
            execute(Rt) {
              const kt = new gt(Rt);
              let jt = 0;
              const Ht = this.operators, Ft = Ht.length;
              let _t, Nt, Mt;
              for (; jt < Ft; ) {
                if (_t = Ht[jt++], typeof _t == "number") {
                  kt.push(_t);
                  continue;
                }
                switch (_t) {
                  case "jz":
                    Mt = kt.pop(), Nt = kt.pop(), Nt || (jt = Mt);
                    break;
                  case "j":
                    Nt = kt.pop(), jt = Nt;
                    break;
                  case "abs":
                    Nt = kt.pop(), kt.push(Math.abs(Nt));
                    break;
                  case "add":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt + Mt);
                    break;
                  case "and":
                    Mt = kt.pop(), Nt = kt.pop(), typeof Nt == "boolean" && typeof Mt == "boolean" ? kt.push(Nt && Mt) : kt.push(Nt & Mt);
                    break;
                  case "atan":
                    Mt = kt.pop(), Nt = kt.pop(), Nt = Math.atan2(Nt, Mt) / Math.PI * 180, Nt < 0 && (Nt += 360), kt.push(Nt);
                    break;
                  case "bitshift":
                    Mt = kt.pop(), Nt = kt.pop(), Nt > 0 ? kt.push(Nt << Mt) : kt.push(Nt >> Mt);
                    break;
                  case "ceiling":
                    Nt = kt.pop(), kt.push(Math.ceil(Nt));
                    break;
                  case "copy":
                    Nt = kt.pop(), kt.copy(Nt);
                    break;
                  case "cos":
                    Nt = kt.pop(), kt.push(Math.cos(Nt % 360 / 180 * Math.PI));
                    break;
                  case "cvi":
                    Nt = kt.pop() | 0, kt.push(Nt);
                    break;
                  case "cvr":
                    break;
                  case "div":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt / Mt);
                    break;
                  case "dup":
                    kt.copy(1);
                    break;
                  case "eq":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt === Mt);
                    break;
                  case "exch":
                    kt.roll(2, 1);
                    break;
                  case "exp":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt ** Mt);
                    break;
                  case "false":
                    kt.push(!1);
                    break;
                  case "floor":
                    Nt = kt.pop(), kt.push(Math.floor(Nt));
                    break;
                  case "ge":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt >= Mt);
                    break;
                  case "gt":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt > Mt);
                    break;
                  case "idiv":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt / Mt | 0);
                    break;
                  case "index":
                    Nt = kt.pop(), kt.index(Nt);
                    break;
                  case "le":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt <= Mt);
                    break;
                  case "ln":
                    Nt = kt.pop(), kt.push(Math.log(Nt));
                    break;
                  case "log":
                    Nt = kt.pop(), kt.push(Math.log10(Nt));
                    break;
                  case "lt":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt < Mt);
                    break;
                  case "mod":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt % Mt);
                    break;
                  case "mul":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt * Mt);
                    break;
                  case "ne":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt !== Mt);
                    break;
                  case "neg":
                    Nt = kt.pop(), kt.push(-Nt);
                    break;
                  case "not":
                    Nt = kt.pop(), typeof Nt == "boolean" ? kt.push(!Nt) : kt.push(~Nt);
                    break;
                  case "or":
                    Mt = kt.pop(), Nt = kt.pop(), typeof Nt == "boolean" && typeof Mt == "boolean" ? kt.push(Nt || Mt) : kt.push(Nt | Mt);
                    break;
                  case "pop":
                    kt.pop();
                    break;
                  case "roll":
                    Mt = kt.pop(), Nt = kt.pop(), kt.roll(Nt, Mt);
                    break;
                  case "round":
                    Nt = kt.pop(), kt.push(Math.round(Nt));
                    break;
                  case "sin":
                    Nt = kt.pop(), kt.push(Math.sin(Nt % 360 / 180 * Math.PI));
                    break;
                  case "sqrt":
                    Nt = kt.pop(), kt.push(Math.sqrt(Nt));
                    break;
                  case "sub":
                    Mt = kt.pop(), Nt = kt.pop(), kt.push(Nt - Mt);
                    break;
                  case "true":
                    kt.push(!0);
                    break;
                  case "truncate":
                    Nt = kt.pop(), Nt = Nt < 0 ? Math.ceil(Nt) : Math.floor(Nt), kt.push(Nt);
                    break;
                  case "xor":
                    Mt = kt.pop(), Nt = kt.pop(), typeof Nt == "boolean" && typeof Mt == "boolean" ? kt.push(Nt !== Mt) : kt.push(Nt ^ Mt);
                    break;
                  default:
                    throw new st.FormatError(`Unknown operator ${_t}`);
                }
              }
              return kt.stack;
            }
          }
          at.PostScriptEvaluator = pt;
          class mt {
            constructor(Rt) {
              this.type = Rt;
            }
            visit(Rt) {
              (0, st.unreachable)("abstract method");
            }
          }
          class ct extends mt {
            constructor(Rt, kt, jt) {
              super("args"), this.index = Rt, this.min = kt, this.max = jt;
            }
            visit(Rt) {
              Rt.visitArgument(this);
            }
          }
          class vt extends mt {
            constructor(Rt) {
              super("literal"), this.number = Rt, this.min = Rt, this.max = Rt;
            }
            visit(Rt) {
              Rt.visitLiteral(this);
            }
          }
          class At extends mt {
            constructor(Rt, kt, jt, Ht, Ft) {
              super("binary"), this.op = Rt, this.arg1 = kt, this.arg2 = jt, this.min = Ht, this.max = Ft;
            }
            visit(Rt) {
              Rt.visitBinaryOperation(this);
            }
          }
          class xt extends mt {
            constructor(Rt, kt) {
              super("max"), this.arg = Rt, this.min = Rt.min, this.max = kt;
            }
            visit(Rt) {
              Rt.visitMin(this);
            }
          }
          class bt extends mt {
            constructor(Rt, kt, jt) {
              super("var"), this.index = Rt, this.min = kt, this.max = jt;
            }
            visit(Rt) {
              Rt.visitVariable(this);
            }
          }
          class Et extends mt {
            constructor(Rt, kt) {
              super("definition"), this.variable = Rt, this.arg = kt;
            }
            visit(Rt) {
              Rt.visitVariableDefinition(this);
            }
          }
          class St {
            constructor() {
              this.parts = [];
            }
            visitArgument(Rt) {
              this.parts.push("Math.max(", Rt.min, ", Math.min(", Rt.max, ", src[srcOffset + ", Rt.index, "]))");
            }
            visitVariable(Rt) {
              this.parts.push("v", Rt.index);
            }
            visitLiteral(Rt) {
              this.parts.push(Rt.number);
            }
            visitBinaryOperation(Rt) {
              this.parts.push("("), Rt.arg1.visit(this), this.parts.push(" ", Rt.op, " "), Rt.arg2.visit(this), this.parts.push(")");
            }
            visitVariableDefinition(Rt) {
              this.parts.push("var "), Rt.variable.visit(this), this.parts.push(" = "), Rt.arg.visit(this), this.parts.push(";");
            }
            visitMin(Rt) {
              this.parts.push("Math.min("), Rt.arg.visit(this), this.parts.push(", ", Rt.max, ")");
            }
            toString() {
              return this.parts.join("");
            }
          }
          function Bt(yt, Rt) {
            return Rt.type === "literal" && Rt.number === 0 ? yt : yt.type === "literal" && yt.number === 0 ? Rt : Rt.type === "literal" && yt.type === "literal" ? new vt(yt.number + Rt.number) : new At("+", yt, Rt, yt.min + Rt.min, yt.max + Rt.max);
          }
          function Ot(yt, Rt) {
            if (Rt.type === "literal") {
              if (Rt.number === 0)
                return new vt(0);
              if (Rt.number === 1)
                return yt;
              if (yt.type === "literal")
                return new vt(yt.number * Rt.number);
            }
            if (yt.type === "literal") {
              if (yt.number === 0)
                return new vt(0);
              if (yt.number === 1)
                return Rt;
            }
            const kt = Math.min(yt.min * Rt.min, yt.min * Rt.max, yt.max * Rt.min, yt.max * Rt.max), jt = Math.max(yt.min * Rt.min, yt.min * Rt.max, yt.max * Rt.min, yt.max * Rt.max);
            return new At("*", yt, Rt, kt, jt);
          }
          function Pt(yt, Rt) {
            if (Rt.type === "literal") {
              if (Rt.number === 0)
                return yt;
              if (yt.type === "literal")
                return new vt(yt.number - Rt.number);
            }
            return Rt.type === "binary" && Rt.op === "-" && yt.type === "literal" && yt.number === 1 && Rt.arg1.type === "literal" && Rt.arg1.number === 1 ? Rt.arg2 : new At("-", yt, Rt, yt.min - Rt.max, yt.max - Rt.min);
          }
          function wt(yt, Rt) {
            return yt.min >= Rt ? new vt(Rt) : yt.max <= Rt ? yt : new xt(yt, Rt);
          }
          class Ct {
            compile(Rt, kt, jt) {
              const Ht = [], Ft = [], _t = kt.length >> 1, Nt = jt.length >> 1;
              let Mt = 0, Lt, $t, Tt, Dt, Ut, Vt, Qt, qt;
              for (let ar = 0; ar < _t; ar++)
                Ht.push(new ct(ar, kt[ar * 2], kt[ar * 2 + 1]));
              for (let ar = 0, Jt = Rt.length; ar < Jt; ar++) {
                if (qt = Rt[ar], typeof qt == "number") {
                  Ht.push(new vt(qt));
                  continue;
                }
                switch (qt) {
                  case "add":
                    if (Ht.length < 2)
                      return null;
                    Dt = Ht.pop(), Tt = Ht.pop(), Ht.push(Bt(Tt, Dt));
                    break;
                  case "cvr":
                    if (Ht.length < 1)
                      return null;
                    break;
                  case "mul":
                    if (Ht.length < 2)
                      return null;
                    Dt = Ht.pop(), Tt = Ht.pop(), Ht.push(Ot(Tt, Dt));
                    break;
                  case "sub":
                    if (Ht.length < 2)
                      return null;
                    Dt = Ht.pop(), Tt = Ht.pop(), Ht.push(Pt(Tt, Dt));
                    break;
                  case "exch":
                    if (Ht.length < 2)
                      return null;
                    Ut = Ht.pop(), Vt = Ht.pop(), Ht.push(Ut, Vt);
                    break;
                  case "pop":
                    if (Ht.length < 1)
                      return null;
                    Ht.pop();
                    break;
                  case "index":
                    if (Ht.length < 1 || (Tt = Ht.pop(), Tt.type !== "literal") || (Lt = Tt.number, Lt < 0 || !Number.isInteger(Lt) || Ht.length < Lt))
                      return null;
                    if (Ut = Ht[Ht.length - Lt - 1], Ut.type === "literal" || Ut.type === "var") {
                      Ht.push(Ut);
                      break;
                    }
                    Qt = new bt(Mt++, Ut.min, Ut.max), Ht[Ht.length - Lt - 1] = Qt, Ht.push(Qt), Ft.push(new Et(Qt, Ut));
                    break;
                  case "dup":
                    if (Ht.length < 1)
                      return null;
                    if (typeof Rt[ar + 1] == "number" && Rt[ar + 2] === "gt" && Rt[ar + 3] === ar + 7 && Rt[ar + 4] === "jz" && Rt[ar + 5] === "pop" && Rt[ar + 6] === Rt[ar + 1]) {
                      Tt = Ht.pop(), Ht.push(wt(Tt, Rt[ar + 1])), ar += 6;
                      break;
                    }
                    if (Ut = Ht.at(-1), Ut.type === "literal" || Ut.type === "var") {
                      Ht.push(Ut);
                      break;
                    }
                    Qt = new bt(Mt++, Ut.min, Ut.max), Ht[Ht.length - 1] = Qt, Ht.push(Qt), Ft.push(new Et(Qt, Ut));
                    break;
                  case "roll":
                    if (Ht.length < 2 || (Dt = Ht.pop(), Tt = Ht.pop(), Dt.type !== "literal" || Tt.type !== "literal") || ($t = Dt.number, Lt = Tt.number, Lt <= 0 || !Number.isInteger(Lt) || !Number.isInteger($t) || Ht.length < Lt))
                      return null;
                    if ($t = ($t % Lt + Lt) % Lt, $t === 0)
                      break;
                    Ht.push(...Ht.splice(Ht.length - Lt, Lt - $t));
                    break;
                  default:
                    return null;
                }
              }
              if (Ht.length !== Nt)
                return null;
              const Zt = [];
              for (const ar of Ft) {
                const Jt = new St();
                ar.visit(Jt), Zt.push(Jt.toString());
              }
              for (let ar = 0, Jt = Ht.length; ar < Jt; ar++) {
                const rr = Ht[ar], Yt = new St();
                rr.visit(Yt);
                const Kt = jt[ar * 2], nr = jt[ar * 2 + 1], tr = [Yt.toString()];
                Kt > rr.min && (tr.unshift("Math.max(", Kt, ", "), tr.push(")")), nr < rr.max && (tr.unshift("Math.min(", nr, ", "), tr.push(")")), tr.unshift("dest[destOffset + ", ar, "] = "), tr.push(";"), Zt.push(tr.join(""));
              }
              return Zt.join(`
`);
            }
          }
          at.PostScriptCompiler = Ct;
        },
        /* 209 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.PostScriptParser = at.PostScriptLexer = void 0, ot(140);
          var rt = ot(145), st = ot(151), lt = ot(150);
          class et {
            constructor(dt) {
              this.lexer = dt, this.operators = [], this.token = null, this.prev = null;
            }
            nextToken() {
              this.prev = this.token, this.token = this.lexer.getToken();
            }
            accept(dt) {
              return this.token.type === dt ? (this.nextToken(), !0) : !1;
            }
            expect(dt) {
              if (this.accept(dt))
                return !0;
              throw new rt.FormatError(`Unexpected symbol: found ${this.token.type} expected ${dt}.`);
            }
            parse() {
              return this.nextToken(), this.expect(it.LBRACE), this.parseBlock(), this.expect(it.RBRACE), this.operators;
            }
            parseBlock() {
              for (; ; )
                if (this.accept(it.NUMBER))
                  this.operators.push(this.prev.value);
                else if (this.accept(it.OPERATOR))
                  this.operators.push(this.prev.value);
                else if (this.accept(it.LBRACE))
                  this.parseCondition();
                else
                  return;
            }
            parseCondition() {
              const dt = this.operators.length;
              if (this.operators.push(null, null), this.parseBlock(), this.expect(it.RBRACE), this.accept(it.IF))
                this.operators[dt] = this.operators.length, this.operators[dt + 1] = "jz";
              else if (this.accept(it.LBRACE)) {
                const gt = this.operators.length;
                this.operators.push(null, null);
                const pt = this.operators.length;
                this.parseBlock(), this.expect(it.RBRACE), this.expect(it.IFELSE), this.operators[gt] = this.operators.length, this.operators[gt + 1] = "j", this.operators[dt] = pt, this.operators[dt + 1] = "jz";
              } else
                throw new rt.FormatError("PS Function: error parsing conditional.");
            }
          }
          at.PostScriptParser = et;
          const it = {
            LBRACE: 0,
            RBRACE: 1,
            NUMBER: 2,
            OPERATOR: 3,
            IF: 4,
            IFELSE: 5
          };
          class ut {
            static get opCache() {
              return (0, rt.shadow)(this, "opCache", /* @__PURE__ */ Object.create(null));
            }
            constructor(dt, gt) {
              this.type = dt, this.value = gt;
            }
            static getOperator(dt) {
              var gt;
              return (gt = ut.opCache)[dt] || (gt[dt] = new ut(it.OPERATOR, dt));
            }
            static get LBRACE() {
              return (0, rt.shadow)(this, "LBRACE", new ut(it.LBRACE, "{"));
            }
            static get RBRACE() {
              return (0, rt.shadow)(this, "RBRACE", new ut(it.RBRACE, "}"));
            }
            static get IF() {
              return (0, rt.shadow)(this, "IF", new ut(it.IF, "IF"));
            }
            static get IFELSE() {
              return (0, rt.shadow)(this, "IFELSE", new ut(it.IFELSE, "IFELSE"));
            }
          }
          class ft {
            constructor(dt) {
              this.stream = dt, this.nextChar(), this.strBuf = [];
            }
            nextChar() {
              return this.currentChar = this.stream.getByte();
            }
            getToken() {
              let dt = !1, gt = this.currentChar;
              for (; ; ) {
                if (gt < 0)
                  return st.EOF;
                if (dt)
                  (gt === 10 || gt === 13) && (dt = !1);
                else if (gt === 37)
                  dt = !0;
                else if (!(0, lt.isWhiteSpace)(gt))
                  break;
                gt = this.nextChar();
              }
              switch (gt | 0) {
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 43:
                case 45:
                case 46:
                  return new ut(it.NUMBER, this.getNumber());
                case 123:
                  return this.nextChar(), ut.LBRACE;
                case 125:
                  return this.nextChar(), ut.RBRACE;
              }
              const pt = this.strBuf;
              for (pt.length = 0, pt[0] = String.fromCharCode(gt); (gt = this.nextChar()) >= 0 && (gt >= 65 && gt <= 90 || gt >= 97 && gt <= 122); )
                pt.push(String.fromCharCode(gt));
              const mt = pt.join("");
              switch (mt.toLowerCase()) {
                case "if":
                  return ut.IF;
                case "ifelse":
                  return ut.IFELSE;
                default:
                  return ut.getOperator(mt);
              }
            }
            getNumber() {
              let dt = this.currentChar;
              const gt = this.strBuf;
              for (gt.length = 0, gt[0] = String.fromCharCode(dt); (dt = this.nextChar()) >= 0 && (dt >= 48 && dt <= 57 || dt === 45 || dt === 46); )
                gt.push(String.fromCharCode(dt));
              const pt = parseFloat(gt.join(""));
              if (isNaN(pt))
                throw new rt.FormatError(`Invalid floating point number: ${pt}`);
              return pt;
            }
          }
          at.PostScriptLexer = ft;
        },
        /* 210 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.RegionalImageCache = at.LocalTilingPatternCache = at.LocalImageCache = at.LocalGStateCache = at.LocalFunctionCache = at.LocalColorSpaceCache = at.GlobalImageCache = void 0, ot(2), ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138);
          var rt = ot(145), st = ot(151);
          class lt {
            constructor(ct) {
              this.constructor === lt && (0, rt.unreachable)("Cannot initialize BaseLocalCache."), this._onlyRefs = (ct == null ? void 0 : ct.onlyRefs) === !0, this._onlyRefs || (this._nameRefMap = /* @__PURE__ */ new Map(), this._imageMap = /* @__PURE__ */ new Map()), this._imageCache = new st.RefSetCache();
            }
            getByName(ct) {
              this._onlyRefs && (0, rt.unreachable)("Should not call `getByName` method.");
              const vt = this._nameRefMap.get(ct);
              return vt ? this.getByRef(vt) : this._imageMap.get(ct) || null;
            }
            getByRef(ct) {
              return this._imageCache.get(ct) || null;
            }
            set(ct, vt, At) {
              (0, rt.unreachable)("Abstract method `set` called.");
            }
          }
          class et extends lt {
            set(ct) {
              let vt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, At = arguments.length > 2 ? arguments[2] : void 0;
              if (typeof ct != "string")
                throw new Error('LocalImageCache.set - expected "name" argument.');
              if (vt) {
                if (this._imageCache.has(vt))
                  return;
                this._nameRefMap.set(ct, vt), this._imageCache.put(vt, At);
                return;
              }
              this._imageMap.has(ct) || this._imageMap.set(ct, At);
            }
          }
          at.LocalImageCache = et;
          class it extends lt {
            set() {
              let ct = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, vt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, At = arguments.length > 2 ? arguments[2] : void 0;
              if (typeof ct != "string" && !vt)
                throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
              if (vt) {
                if (this._imageCache.has(vt))
                  return;
                ct !== null && this._nameRefMap.set(ct, vt), this._imageCache.put(vt, At);
                return;
              }
              this._imageMap.has(ct) || this._imageMap.set(ct, At);
            }
          }
          at.LocalColorSpaceCache = it;
          class ut extends lt {
            constructor(ct) {
              super({
                onlyRefs: !0
              });
            }
            set() {
              let ct = arguments.length > 1 ? arguments[1] : void 0, vt = arguments.length > 2 ? arguments[2] : void 0;
              if (!ct)
                throw new Error('LocalFunctionCache.set - expected "ref" argument.');
              this._imageCache.has(ct) || this._imageCache.put(ct, vt);
            }
          }
          at.LocalFunctionCache = ut;
          class ft extends lt {
            set(ct) {
              let vt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, At = arguments.length > 2 ? arguments[2] : void 0;
              if (typeof ct != "string")
                throw new Error('LocalGStateCache.set - expected "name" argument.');
              if (vt) {
                if (this._imageCache.has(vt))
                  return;
                this._nameRefMap.set(ct, vt), this._imageCache.put(vt, At);
                return;
              }
              this._imageMap.has(ct) || this._imageMap.set(ct, At);
            }
          }
          at.LocalGStateCache = ft;
          class ht extends lt {
            constructor(ct) {
              super({
                onlyRefs: !0
              });
            }
            set() {
              let ct = arguments.length > 1 ? arguments[1] : void 0, vt = arguments.length > 2 ? arguments[2] : void 0;
              if (!ct)
                throw new Error('LocalTilingPatternCache.set - expected "ref" argument.');
              this._imageCache.has(ct) || this._imageCache.put(ct, vt);
            }
          }
          at.LocalTilingPatternCache = ht;
          class dt extends lt {
            constructor(ct) {
              super({
                onlyRefs: !0
              });
            }
            set() {
              let ct = arguments.length > 1 ? arguments[1] : void 0, vt = arguments.length > 2 ? arguments[2] : void 0;
              if (!ct)
                throw new Error('RegionalImageCache.set - expected "ref" argument.');
              this._imageCache.has(ct) || this._imageCache.put(ct, vt);
            }
          }
          at.RegionalImageCache = dt;
          const pt = class pt {
            constructor() {
              this._refCache = new st.RefSetCache(), this._imageCache = new st.RefSetCache();
            }
            get _byteSize() {
              let ct = 0;
              for (const vt of this._imageCache)
                ct += vt.byteSize;
              return ct;
            }
            get _cacheLimitReached() {
              return !(this._imageCache.size < pt.MIN_IMAGES_TO_CACHE || this._byteSize < pt.MAX_BYTE_SIZE);
            }
            shouldCache(ct, vt) {
              let At = this._refCache.get(ct);
              return At || (At = /* @__PURE__ */ new Set(), this._refCache.put(ct, At)), At.add(vt), !(At.size < pt.NUM_PAGES_THRESHOLD || !this._imageCache.has(ct) && this._cacheLimitReached);
            }
            addByteSize(ct, vt) {
              const At = this._imageCache.get(ct);
              At && (At.byteSize || (At.byteSize = vt));
            }
            getData(ct, vt) {
              const At = this._refCache.get(ct);
              if (!At || At.size < pt.NUM_PAGES_THRESHOLD)
                return null;
              const xt = this._imageCache.get(ct);
              return xt ? (At.add(vt), xt) : null;
            }
            setData(ct, vt) {
              if (!this._refCache.has(ct))
                throw new Error('GlobalImageCache.setData - expected "shouldCache" to have been called.');
              if (!this._imageCache.has(ct)) {
                if (this._cacheLimitReached) {
                  (0, rt.warn)("GlobalImageCache.setData - cache limit reached.");
                  return;
                }
                this._imageCache.put(ct, vt);
              }
            }
            clear() {
              (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) || this._refCache.clear(), this._imageCache.clear();
            }
          };
          Ln(pt, "NUM_PAGES_THRESHOLD", 2), Ln(pt, "MIN_IMAGES_TO_CACHE", 10), Ln(pt, "MAX_BYTE_SIZE", 5 * rt.MAX_IMAGE_SIZE_TO_CACHE);
          let gt = pt;
          at.GlobalImageCache = gt;
        },
        /* 211 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.bidi = mt;
          var rt = ot(145);
          const st = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "ON", "ON", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "ON", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "ON", "ET", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "L", "ON", "ON", "BN", "ON", "ON", "ET", "ET", "EN", "EN", "ON", "L", "ON", "ON", "ON", "EN", "L", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L"], lt = ["AN", "AN", "AN", "AN", "AN", "AN", "ON", "ON", "AL", "ET", "ET", "AL", "CS", "AL", "ON", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "ON", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL"];
          function et(ct) {
            return (ct & 1) !== 0;
          }
          function it(ct) {
            return (ct & 1) === 0;
          }
          function ut(ct, vt, At) {
            let xt, bt;
            for (xt = vt, bt = ct.length; xt < bt; ++xt)
              if (ct[xt] !== At)
                return xt;
            return xt;
          }
          function ft(ct, vt, At, xt) {
            for (let bt = vt; bt < At; ++bt)
              ct[bt] = xt;
          }
          function ht(ct, vt, At) {
            for (let xt = vt, bt = At - 1; xt < bt; ++xt, --bt) {
              const Et = ct[xt];
              ct[xt] = ct[bt], ct[bt] = Et;
            }
          }
          function dt(ct, vt) {
            let At = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, xt = "ltr";
            return At ? xt = "ttb" : vt || (xt = "rtl"), {
              str: ct,
              dir: xt
            };
          }
          const gt = [], pt = [];
          function mt(ct) {
            let vt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, At = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, xt = !0;
            const bt = ct.length;
            if (bt === 0 || At)
              return dt(ct, xt, At);
            gt.length = bt, pt.length = bt;
            let Et = 0, St, Bt;
            for (St = 0; St < bt; ++St) {
              gt[St] = ct.charAt(St);
              const Ht = ct.charCodeAt(St);
              let Ft = "L";
              Ht <= 255 ? Ft = st[Ht] : 1424 <= Ht && Ht <= 1524 ? Ft = "R" : 1536 <= Ht && Ht <= 1791 ? (Ft = lt[Ht & 255], Ft || (0, rt.warn)("Bidi: invalid Unicode character " + Ht.toString(16))) : (1792 <= Ht && Ht <= 2220 || 64336 <= Ht && Ht <= 65023 || 65136 <= Ht && Ht <= 65279) && (Ft = "AL"), (Ft === "R" || Ft === "AL" || Ft === "AN") && Et++, pt[St] = Ft;
            }
            if (Et === 0)
              return xt = !0, dt(ct, xt);
            vt === -1 && (Et / bt < 0.3 && bt > 4 ? (xt = !0, vt = 0) : (xt = !1, vt = 1));
            const Ot = [];
            for (St = 0; St < bt; ++St)
              Ot[St] = vt;
            const Pt = et(vt) ? "R" : "L", wt = Pt, Ct = wt;
            let It = wt;
            for (St = 0; St < bt; ++St)
              pt[St] === "NSM" ? pt[St] = It : It = pt[St];
            It = wt;
            let yt;
            for (St = 0; St < bt; ++St)
              yt = pt[St], yt === "EN" ? pt[St] = It === "AL" ? "AN" : "EN" : (yt === "R" || yt === "L" || yt === "AL") && (It = yt);
            for (St = 0; St < bt; ++St)
              yt = pt[St], yt === "AL" && (pt[St] = "R");
            for (St = 1; St < bt - 1; ++St)
              pt[St] === "ES" && pt[St - 1] === "EN" && pt[St + 1] === "EN" && (pt[St] = "EN"), pt[St] === "CS" && (pt[St - 1] === "EN" || pt[St - 1] === "AN") && pt[St + 1] === pt[St - 1] && (pt[St] = pt[St - 1]);
            for (St = 0; St < bt; ++St)
              if (pt[St] === "EN") {
                for (let Ht = St - 1; Ht >= 0 && pt[Ht] === "ET"; --Ht)
                  pt[Ht] = "EN";
                for (let Ht = St + 1; Ht < bt && pt[Ht] === "ET"; ++Ht)
                  pt[Ht] = "EN";
              }
            for (St = 0; St < bt; ++St)
              yt = pt[St], (yt === "WS" || yt === "ES" || yt === "ET" || yt === "CS") && (pt[St] = "ON");
            for (It = wt, St = 0; St < bt; ++St)
              yt = pt[St], yt === "EN" ? pt[St] = It === "L" ? "L" : "EN" : (yt === "R" || yt === "L") && (It = yt);
            for (St = 0; St < bt; ++St)
              if (pt[St] === "ON") {
                const Ht = ut(pt, St + 1, "ON");
                let Ft = wt;
                St > 0 && (Ft = pt[St - 1]);
                let _t = Ct;
                Ht + 1 < bt && (_t = pt[Ht + 1]), Ft !== "L" && (Ft = "R"), _t !== "L" && (_t = "R"), Ft === _t && ft(pt, St, Ht, Ft), St = Ht - 1;
              }
            for (St = 0; St < bt; ++St)
              pt[St] === "ON" && (pt[St] = Pt);
            for (St = 0; St < bt; ++St)
              yt = pt[St], it(Ot[St]) ? yt === "R" ? Ot[St] += 1 : (yt === "AN" || yt === "EN") && (Ot[St] += 2) : (yt === "L" || yt === "AN" || yt === "EN") && (Ot[St] += 1);
            let Rt = -1, kt = 99, jt;
            for (St = 0, Bt = Ot.length; St < Bt; ++St)
              jt = Ot[St], Rt < jt && (Rt = jt), kt > jt && et(jt) && (kt = jt);
            for (jt = Rt; jt >= kt; --jt) {
              let Ht = -1;
              for (St = 0, Bt = Ot.length; St < Bt; ++St)
                Ot[St] < jt ? Ht >= 0 && (ht(gt, Ht, St), Ht = -1) : Ht < 0 && (Ht = St);
              Ht >= 0 && ht(gt, Ht, Ot.length);
            }
            for (St = 0, Bt = gt.length; St < Bt; ++St) {
              const Ht = gt[St];
              (Ht === "<" || Ht === ">") && (gt[St] = "");
            }
            return dt(gt.join(""), xt);
          }
        },
        /* 212 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.getFontSubstitution = pt, ot(140);
          var rt = ot(189), st = ot(150);
          const lt = {
            style: "normal",
            weight: "normal"
          }, et = {
            style: "normal",
            weight: "bold"
          }, it = {
            style: "italic",
            weight: "normal"
          }, ut = {
            style: "italic",
            weight: "bold"
          }, ft = /* @__PURE__ */ new Map([["Times-Roman", {
            local: ["Times New Roman", "Times-Roman", "Times", "Liberation Serif", "Nimbus Roman", "Nimbus Roman L", "Tinos", "Thorndale", "TeX Gyre Termes", "FreeSerif", "DejaVu Serif", "Bitstream Vera Serif", "Ubuntu"],
            style: lt,
            ultimate: "serif"
          }], ["Times-Bold", {
            alias: "Times-Roman",
            style: et,
            ultimate: "serif"
          }], ["Times-Italic", {
            alias: "Times-Roman",
            style: it,
            ultimate: "serif"
          }], ["Times-BoldItalic", {
            alias: "Times-Roman",
            style: ut,
            ultimate: "serif"
          }], ["Helvetica", {
            local: ["Helvetica", "Helvetica Neue", "Arial", "Arial Nova", "Liberation Sans", "Arimo", "Nimbus Sans", "Nimbus Sans L", "A030", "TeX Gyre Heros", "FreeSans", "DejaVu Sans", "Albany", "Bitstream Vera Sans", "Arial Unicode MS", "Microsoft Sans Serif", "Apple Symbols", "Cantarell"],
            path: "LiberationSans-Regular.ttf",
            style: lt,
            ultimate: "sans-serif"
          }], ["Helvetica-Bold", {
            alias: "Helvetica",
            path: "LiberationSans-Bold.ttf",
            style: et,
            ultimate: "sans-serif"
          }], ["Helvetica-Oblique", {
            alias: "Helvetica",
            path: "LiberationSans-Italic.ttf",
            style: it,
            ultimate: "sans-serif"
          }], ["Helvetica-BoldOblique", {
            alias: "Helvetica",
            path: "LiberationSans-BoldItalic.ttf",
            style: ut,
            ultimate: "sans-serif"
          }], ["Courier", {
            local: ["Courier", "Courier New", "Liberation Mono", "Nimbus Mono", "Nimbus Mono L", "Cousine", "Cumberland", "TeX Gyre Cursor", "FreeMono"],
            style: lt,
            ultimate: "monospace"
          }], ["Courier-Bold", {
            alias: "Courier",
            style: et,
            ultimate: "monospace"
          }], ["Courier-Oblique", {
            alias: "Courier",
            style: it,
            ultimate: "monospace"
          }], ["Courier-BoldOblique", {
            alias: "Courier",
            style: ut,
            ultimate: "monospace"
          }], ["ArialBlack", {
            local: ["Arial Black"],
            style: {
              style: "normal",
              weight: "900"
            },
            fallback: "Helvetica-Bold"
          }], ["ArialBlack-Bold", {
            alias: "ArialBlack"
          }], ["ArialBlack-Italic", {
            alias: "ArialBlack",
            style: {
              style: "italic",
              weight: "900"
            },
            fallback: "Helvetica-BoldOblique"
          }], ["ArialBlack-BoldItalic", {
            alias: "ArialBlack-Italic"
          }], ["ArialNarrow", {
            local: ["Arial Narrow", "Liberation Sans Narrow", "Helvetica Condensed", "Nimbus Sans Narrow", "TeX Gyre Heros Cn"],
            style: lt,
            fallback: "Helvetica"
          }], ["ArialNarrow-Bold", {
            alias: "ArialNarrow",
            style: et,
            fallback: "Helvetica-Bold"
          }], ["ArialNarrow-Italic", {
            alias: "ArialNarrow",
            style: it,
            fallback: "Helvetica-Oblique"
          }], ["ArialNarrow-BoldItalic", {
            alias: "ArialNarrow",
            style: ut,
            fallback: "Helvetica-BoldOblique"
          }], ["Calibri", {
            local: ["Calibri", "Carlito"],
            style: lt,
            fallback: "Helvetica"
          }], ["Calibri-Bold", {
            alias: "Calibri",
            style: et,
            fallback: "Helvetica-Bold"
          }], ["Calibri-Italic", {
            alias: "Calibri",
            style: it,
            fallback: "Helvetica-Oblique"
          }], ["Calibri-BoldItalic", {
            alias: "Calibri",
            style: ut,
            fallback: "Helvetica-BoldOblique"
          }], ["Wingdings", {
            local: ["Wingdings", "URW Dingbats"],
            style: lt
          }], ["Wingdings-Regular", {
            alias: "Wingdings"
          }], ["Wingdings-Bold", {
            alias: "Wingdings"
          }]]), ht = /* @__PURE__ */ new Map([["Arial-Black", "ArialBlack"]]);
          function dt(mt) {
            switch (mt) {
              case et:
                return "Bold";
              case it:
                return "Italic";
              case ut:
                return "Bold Italic";
              default:
                if ((mt == null ? void 0 : mt.weight) === "bold")
                  return "Bold";
                if ((mt == null ? void 0 : mt.style) === "italic")
                  return "Italic";
            }
            return "";
          }
          function gt(mt, ct, vt) {
            let {
              alias: At,
              local: xt,
              path: bt,
              fallback: Et,
              style: St,
              ultimate: Bt
            } = mt, Ot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, Pt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, wt = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
            const Ct = {
              style: null,
              ultimate: null
            };
            if (xt) {
              const It = wt ? ` ${wt}` : "";
              for (const yt of xt)
                ct.push(`local(${yt}${It})`);
            }
            if (At) {
              const It = ft.get(At), yt = wt || dt(St);
              Object.assign(Ct, gt(It, ct, vt, Ot && !Et, Pt && !bt, yt));
            }
            if (St && (Ct.style = St), Bt && (Ct.ultimate = Bt), Ot && Et) {
              const It = ft.get(Et), {
                ultimate: yt
              } = gt(It, ct, vt, Ot, Pt && !bt, wt);
              Ct.ultimate || (Ct.ultimate = yt);
            }
            return Pt && bt && vt && ct.push(`url(${vt}${bt})`), Ct;
          }
          function pt(mt, ct, vt, At, xt) {
            At = (0, rt.normalizeFontName)(At);
            const bt = At;
            let Et = mt.get(bt);
            if (Et)
              return Et;
            let St = ft.get(At);
            if (!St) {
              for (const [Rt, kt] of ht)
                if (At.startsWith(Rt)) {
                  At = `${kt}${At.substring(Rt.length)}`, St = ft.get(At);
                  break;
                }
            }
            let Bt = !1;
            St || (St = ft.get(xt), Bt = !0);
            const Ot = `${ct.getDocId()}_s${ct.createFontId()}`;
            if (!St) {
              if (!(0, st.validateFontName)(At))
                return mt.set(bt, null), null;
              const Rt = /bold/gi.test(At), kt = /oblique|italic/gi.test(At), jt = Rt && kt && ut || Rt && et || kt && it || lt;
              return Et = {
                css: Ot,
                guessFallback: !0,
                loadedName: Ot,
                baseFontName: At,
                src: `local(${At})`,
                style: jt
              }, mt.set(bt, Et), Et;
            }
            const Pt = [];
            Bt && (0, st.validateFontName)(At) && Pt.push(`local(${At})`);
            const {
              style: wt,
              ultimate: Ct
            } = gt(St, Pt, vt), It = Ct === null, yt = It ? "" : `,${Ct}`;
            return Et = {
              css: `${Ot}${yt}`,
              guessFallback: It,
              loadedName: Ot,
              baseFontName: At,
              src: Pt.join(","),
              style: wt
            }, mt.set(bt, Et), Et;
          }
        },
        /* 213 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.ImageResizer = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(2);
          var rt = ot(145);
          const st = 2048, lt = 65537, et = 128;
          class it {
            constructor(ft, ht) {
              this._imgData = ft, this._isMask = ht;
            }
            static needsToBeResized(ft, ht) {
              if (ft <= this._goodSquareLength && ht <= this._goodSquareLength)
                return !1;
              const {
                MAX_DIM: dt
              } = this;
              if (ft > dt || ht > dt)
                return !0;
              const gt = ft * ht;
              if (this._hasMaxArea)
                return gt > this.MAX_AREA;
              if (gt < this._goodSquareLength ** 2)
                return !1;
              if (this._areGoodDims(ft, ht))
                return this._goodSquareLength = Math.max(this._goodSquareLength, Math.floor(Math.sqrt(ft * ht))), !1;
              this._goodSquareLength = this._guessMax(this._goodSquareLength, dt, et, 0);
              const pt = this.MAX_AREA = this._goodSquareLength ** 2;
              return gt > pt;
            }
            static get MAX_DIM() {
              return (0, rt.shadow)(this, "MAX_DIM", this._guessMax(st, lt, 0, 1));
            }
            static get MAX_AREA() {
              return this._hasMaxArea = !0, (0, rt.shadow)(this, "MAX_AREA", this._guessMax(it._goodSquareLength, this.MAX_DIM, et, 0) ** 2);
            }
            static set MAX_AREA(ft) {
              ft >= 0 && (this._hasMaxArea = !0, (0, rt.shadow)(this, "MAX_AREA", ft));
            }
            static setMaxArea(ft) {
              this._hasMaxArea || (this.MAX_AREA = ft >> 2);
            }
            static _areGoodDims(ft, ht) {
              try {
                const dt = new OffscreenCanvas(ft, ht), gt = dt.getContext("2d");
                gt.fillRect(0, 0, 1, 1);
                const pt = gt.getImageData(0, 0, 1, 1).data[3];
                return dt.width = dt.height = 1, pt !== 0;
              } catch {
                return !1;
              }
            }
            static _guessMax(ft, ht, dt, gt) {
              for (; ft + dt + 1 < ht; ) {
                const pt = Math.floor((ft + ht) / 2), mt = gt || pt;
                this._areGoodDims(pt, mt) ? ft = pt : ht = pt;
              }
              return ft;
            }
            static async createImage(ft) {
              let ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
              return new it(ft, ht)._createImage();
            }
            async _createImage() {
              const ft = this._encodeBMP(), ht = new Blob([ft.buffer], {
                type: "image/bmp"
              }), dt = createImageBitmap(ht), {
                MAX_AREA: gt,
                MAX_DIM: pt
              } = it, {
                _imgData: mt
              } = this, {
                width: ct,
                height: vt
              } = mt, At = Math.max(ct / pt, vt / pt, Math.sqrt(ct * vt / gt)), xt = Math.max(At, 2), bt = Math.round(10 * (At + 1.25)) / 10 / xt, Et = Math.floor(Math.log2(bt)), St = new Array(Et + 2).fill(2);
              St[0] = xt, St.splice(-1, 1, bt / (1 << Et));
              let Bt = ct, Ot = vt, Pt = await dt;
              for (const wt of St) {
                const Ct = Bt, It = Ot;
                Bt = Math.floor(Bt / wt) - 1, Ot = Math.floor(Ot / wt) - 1;
                const yt = new OffscreenCanvas(Bt, Ot);
                yt.getContext("2d").drawImage(Pt, 0, 0, Ct, It, 0, 0, Bt, Ot), Pt = yt.transferToImageBitmap();
              }
              return mt.data = null, mt.bitmap = Pt, mt.width = Bt, mt.height = Ot, mt;
            }
            _encodeBMP() {
              const {
                width: ft,
                height: ht,
                kind: dt
              } = this._imgData;
              let gt = this._imgData.data, pt, mt = new Uint8Array(0), ct = mt, vt = 0;
              switch (dt) {
                case rt.ImageKind.GRAYSCALE_1BPP: {
                  pt = 1, mt = new Uint8Array(this._isMask ? [255, 255, 255, 255, 0, 0, 0, 0] : [0, 0, 0, 0, 255, 255, 255, 255]);
                  const Ot = ft + 7 >> 3, Pt = Ot + 3 & -4;
                  if (Ot !== Pt) {
                    const wt = new Uint8Array(Pt * ht);
                    let Ct = 0;
                    for (let It = 0, yt = ht * Ot; It < yt; It += Ot, Ct += Pt)
                      wt.set(gt.subarray(It, It + Ot), Ct);
                    gt = wt;
                  }
                  break;
                }
                case rt.ImageKind.RGB_24BPP: {
                  if (pt = 24, ft & 3) {
                    const Ot = 3 * ft, Pt = Ot + 3 & -4, wt = Pt - Ot, Ct = new Uint8Array(Pt * ht);
                    let It = 0;
                    for (let yt = 0, Rt = ht * Ot; yt < Rt; yt += Ot) {
                      const kt = gt.subarray(yt, yt + Ot);
                      for (let jt = 0; jt < Ot; jt += 3)
                        Ct[It++] = kt[jt + 2], Ct[It++] = kt[jt + 1], Ct[It++] = kt[jt];
                      It += wt;
                    }
                    gt = Ct;
                  } else
                    for (let Ot = 0, Pt = gt.length; Ot < Pt; Ot += 3) {
                      const wt = gt[Ot];
                      gt[Ot] = gt[Ot + 2], gt[Ot + 2] = wt;
                    }
                  break;
                }
                case rt.ImageKind.RGBA_32BPP:
                  pt = 32, vt = 3, ct = new Uint8Array(68);
                  const Bt = new DataView(ct.buffer);
                  rt.FeatureTest.isLittleEndian ? (Bt.setUint32(0, 255, !0), Bt.setUint32(4, 65280, !0), Bt.setUint32(8, 16711680, !0), Bt.setUint32(12, 4278190080, !0)) : (Bt.setUint32(0, 4278190080, !0), Bt.setUint32(4, 16711680, !0), Bt.setUint32(8, 65280, !0), Bt.setUint32(12, 255, !0));
                  break;
                default:
                  throw new Error("invalid format");
              }
              let At = 0;
              const xt = 40 + ct.length, bt = 14 + xt + mt.length + gt.length, Et = new Uint8Array(bt), St = new DataView(Et.buffer);
              return St.setUint16(At, 19778, !0), At += 2, St.setUint32(At, bt, !0), At += 4, St.setUint32(At, 0, !0), At += 4, St.setUint32(At, 14 + xt + mt.length, !0), At += 4, St.setUint32(At, xt, !0), At += 4, St.setInt32(At, ft, !0), At += 4, St.setInt32(At, -ht, !0), At += 4, St.setUint16(At, 1, !0), At += 2, St.setUint16(At, pt, !0), At += 2, St.setUint32(At, vt, !0), At += 4, St.setUint32(At, 0, !0), At += 4, St.setInt32(At, 0, !0), At += 4, St.setInt32(At, 0, !0), At += 4, St.setUint32(At, mt.length / 4, !0), At += 4, St.setUint32(At, 0, !0), At += 4, Et.set(ct, At), At += ct.length, Et.set(mt, At), At += mt.length, Et.set(gt, At), Et;
            }
          }
          at.ImageResizer = it, it._goodSquareLength = st;
        },
        /* 214 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.MurmurHash3_64 = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(2);
          var rt = ot(145);
          const st = 3285377520, lt = 4294901760, et = 65535;
          class it {
            constructor(ft) {
              this.h1 = ft ? ft & 4294967295 : st, this.h2 = ft ? ft & 4294967295 : st;
            }
            update(ft) {
              let ht, dt;
              if (typeof ft == "string") {
                ht = new Uint8Array(ft.length * 2), dt = 0;
                for (let Ot = 0, Pt = ft.length; Ot < Pt; Ot++) {
                  const wt = ft.charCodeAt(Ot);
                  wt <= 255 ? ht[dt++] = wt : (ht[dt++] = wt >>> 8, ht[dt++] = wt & 255);
                }
              } else if ((0, rt.isArrayBuffer)(ft))
                ht = ft.slice(), dt = ht.byteLength;
              else
                throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
              const gt = dt >> 2, pt = dt - gt * 4, mt = new Uint32Array(ht.buffer, 0, gt);
              let ct = 0, vt = 0, At = this.h1, xt = this.h2;
              const bt = 3432918353, Et = 461845907, St = bt & et, Bt = Et & et;
              for (let Ot = 0; Ot < gt; Ot++)
                Ot & 1 ? (ct = mt[Ot], ct = ct * bt & lt | ct * St & et, ct = ct << 15 | ct >>> 17, ct = ct * Et & lt | ct * Bt & et, At ^= ct, At = At << 13 | At >>> 19, At = At * 5 + 3864292196) : (vt = mt[Ot], vt = vt * bt & lt | vt * St & et, vt = vt << 15 | vt >>> 17, vt = vt * Et & lt | vt * Bt & et, xt ^= vt, xt = xt << 13 | xt >>> 19, xt = xt * 5 + 3864292196);
              switch (ct = 0, pt) {
                case 3:
                  ct ^= ht[gt * 4 + 2] << 16;
                case 2:
                  ct ^= ht[gt * 4 + 1] << 8;
                case 1:
                  ct ^= ht[gt * 4], ct = ct * bt & lt | ct * St & et, ct = ct << 15 | ct >>> 17, ct = ct * Et & lt | ct * Bt & et, gt & 1 ? At ^= ct : xt ^= ct;
              }
              this.h1 = At, this.h2 = xt;
            }
            hexdigest() {
              let ft = this.h1, ht = this.h2;
              return ft ^= ht >>> 1, ft = ft * 3981806797 & lt | ft * 36045 & et, ht = ht * 4283543511 & lt | ((ht << 16 | ft >>> 16) * 2950163797 & lt) >>> 16, ft ^= ht >>> 1, ft = ft * 444984403 & lt | ft * 60499 & et, ht = ht * 3301882366 & lt | ((ht << 16 | ft >>> 16) * 3120437893 & lt) >>> 16, ft ^= ht >>> 1, (ft >>> 0).toString(16).padStart(8, "0") + (ht >>> 0).toString(16).padStart(8, "0");
            }
          }
          at.MurmurHash3_64 = it;
        },
        /* 215 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.OperatorList = void 0, ot(2), ot(140), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138);
          var rt = ot(145);
          function st(ht, dt, gt, pt, mt) {
            let ct = ht;
            for (let vt = 0, At = dt.length - 1; vt < At; vt++) {
              const xt = dt[vt];
              ct = ct[xt] || (ct[xt] = []);
            }
            ct[dt.at(-1)] = {
              checkFn: gt,
              iterateFn: pt,
              processFn: mt
            };
          }
          const lt = [];
          st(lt, [rt.OPS.save, rt.OPS.transform, rt.OPS.paintInlineImageXObject, rt.OPS.restore], null, function(dt, gt) {
            const pt = dt.fnArray, mt = dt.iCurr - 3, ct = (gt - mt) % 4;
            switch (ct) {
              case 0:
                return pt[gt] === rt.OPS.save;
              case 1:
                return pt[gt] === rt.OPS.transform;
              case 2:
                return pt[gt] === rt.OPS.paintInlineImageXObject;
              case 3:
                return pt[gt] === rt.OPS.restore;
            }
            throw new Error(`iterateInlineImageGroup - invalid pos: ${ct}`);
          }, function(dt, gt) {
            const At = dt.fnArray, xt = dt.argsArray, bt = dt.iCurr, Et = bt - 3, St = bt - 2, Bt = bt - 1, Ot = Math.min(Math.floor((gt - Et) / 4), 200);
            if (Ot < 10)
              return gt - (gt - Et) % 4;
            let Pt = 0;
            const wt = [];
            let Ct = 0, It = 1, yt = 1;
            for (let _t = 0; _t < Ot; _t++) {
              const Nt = xt[St + (_t << 2)], Mt = xt[Bt + (_t << 2)][0];
              It + Mt.width > 1e3 && (Pt = Math.max(Pt, It), yt += Ct + 2, It = 0, Ct = 0), wt.push({
                transform: Nt,
                x: It,
                y: yt,
                w: Mt.width,
                h: Mt.height
              }), It += Mt.width + 2, Ct = Math.max(Ct, Mt.height);
            }
            const Rt = Math.max(Pt, It) + 1, kt = yt + Ct + 1, jt = new Uint8Array(Rt * kt * 4), Ht = Rt << 2;
            for (let _t = 0; _t < Ot; _t++) {
              const Nt = xt[Bt + (_t << 2)][0].data, Mt = wt[_t].w << 2;
              let Lt = 0, $t = wt[_t].x + wt[_t].y * Rt << 2;
              jt.set(Nt.subarray(0, Mt), $t - Ht);
              for (let Tt = 0, Dt = wt[_t].h; Tt < Dt; Tt++)
                jt.set(Nt.subarray(Lt, Lt + Mt), $t), Lt += Mt, $t += Ht;
              for (jt.set(Nt.subarray(Lt - Mt, Lt), $t); $t >= 0; )
                Nt[$t - 4] = Nt[$t], Nt[$t - 3] = Nt[$t + 1], Nt[$t - 2] = Nt[$t + 2], Nt[$t - 1] = Nt[$t + 3], Nt[$t + Mt] = Nt[$t + Mt - 4], Nt[$t + Mt + 1] = Nt[$t + Mt - 3], Nt[$t + Mt + 2] = Nt[$t + Mt - 2], Nt[$t + Mt + 3] = Nt[$t + Mt - 1], $t -= Ht;
            }
            const Ft = {
              width: Rt,
              height: kt
            };
            if (dt.isOffscreenCanvasSupported) {
              const _t = new OffscreenCanvas(Rt, kt);
              _t.getContext("2d").putImageData(new ImageData(new Uint8ClampedArray(jt.buffer), Rt, kt), 0, 0), Ft.bitmap = _t.transferToImageBitmap(), Ft.data = null;
            } else
              Ft.kind = rt.ImageKind.RGBA_32BPP, Ft.data = jt;
            return At.splice(Et, Ot * 4, rt.OPS.paintInlineImageXObjectGroup), xt.splice(Et, Ot * 4, [Ft, wt]), Et + 1;
          }), st(lt, [rt.OPS.save, rt.OPS.transform, rt.OPS.paintImageMaskXObject, rt.OPS.restore], null, function(dt, gt) {
            const pt = dt.fnArray, mt = dt.iCurr - 3, ct = (gt - mt) % 4;
            switch (ct) {
              case 0:
                return pt[gt] === rt.OPS.save;
              case 1:
                return pt[gt] === rt.OPS.transform;
              case 2:
                return pt[gt] === rt.OPS.paintImageMaskXObject;
              case 3:
                return pt[gt] === rt.OPS.restore;
            }
            throw new Error(`iterateImageMaskGroup - invalid pos: ${ct}`);
          }, function(dt, gt) {
            const vt = dt.fnArray, At = dt.argsArray, xt = dt.iCurr, bt = xt - 3, Et = xt - 2, St = xt - 1;
            let Bt = Math.floor((gt - bt) / 4);
            if (Bt < 10)
              return gt - (gt - bt) % 4;
            let Ot = !1, Pt, wt;
            const Ct = At[St][0], It = At[Et][0], yt = At[Et][1], Rt = At[Et][2], kt = At[Et][3];
            if (yt === Rt) {
              Ot = !0, Pt = Et + 4;
              let jt = St + 4;
              for (let Ht = 1; Ht < Bt; Ht++, Pt += 4, jt += 4)
                if (wt = At[Pt], At[jt][0] !== Ct || wt[0] !== It || wt[1] !== yt || wt[2] !== Rt || wt[3] !== kt) {
                  Ht < 10 ? Ot = !1 : Bt = Ht;
                  break;
                }
            }
            if (Ot) {
              Bt = Math.min(Bt, 1e3);
              const jt = new Float32Array(Bt * 2);
              Pt = Et;
              for (let Ht = 0; Ht < Bt; Ht++, Pt += 4)
                wt = At[Pt], jt[Ht << 1] = wt[4], jt[(Ht << 1) + 1] = wt[5];
              vt.splice(bt, Bt * 4, rt.OPS.paintImageMaskXObjectRepeat), At.splice(bt, Bt * 4, [Ct, It, yt, Rt, kt, jt]);
            } else {
              Bt = Math.min(Bt, 100);
              const jt = [];
              for (let Ht = 0; Ht < Bt; Ht++) {
                wt = At[Et + (Ht << 2)];
                const Ft = At[St + (Ht << 2)][0];
                jt.push({
                  data: Ft.data,
                  width: Ft.width,
                  height: Ft.height,
                  interpolate: Ft.interpolate,
                  count: Ft.count,
                  transform: wt
                });
              }
              vt.splice(bt, Bt * 4, rt.OPS.paintImageMaskXObjectGroup), At.splice(bt, Bt * 4, [jt]);
            }
            return bt + 1;
          }), st(lt, [rt.OPS.save, rt.OPS.transform, rt.OPS.paintImageXObject, rt.OPS.restore], function(ht) {
            const dt = ht.argsArray, gt = ht.iCurr - 2;
            return dt[gt][1] === 0 && dt[gt][2] === 0;
          }, function(dt, gt) {
            const pt = dt.fnArray, mt = dt.argsArray, ct = dt.iCurr - 3, vt = (gt - ct) % 4;
            switch (vt) {
              case 0:
                return pt[gt] === rt.OPS.save;
              case 1:
                if (pt[gt] !== rt.OPS.transform)
                  return !1;
                const At = dt.iCurr - 2, xt = mt[At][0], bt = mt[At][3];
                return !(mt[gt][0] !== xt || mt[gt][1] !== 0 || mt[gt][2] !== 0 || mt[gt][3] !== bt);
              case 2:
                if (pt[gt] !== rt.OPS.paintImageXObject)
                  return !1;
                const Et = dt.iCurr - 1, St = mt[Et][0];
                return mt[gt][0] === St;
              case 3:
                return pt[gt] === rt.OPS.restore;
            }
            throw new Error(`iterateImageGroup - invalid pos: ${vt}`);
          }, function(ht, dt) {
            const mt = ht.fnArray, ct = ht.argsArray, vt = ht.iCurr, At = vt - 3, xt = vt - 2, bt = vt - 1, Et = ct[bt][0], St = ct[xt][0], Bt = ct[xt][3], Ot = Math.min(Math.floor((dt - At) / 4), 1e3);
            if (Ot < 3)
              return dt - (dt - At) % 4;
            const Pt = new Float32Array(Ot * 2);
            let wt = xt;
            for (let It = 0; It < Ot; It++, wt += 4) {
              const yt = ct[wt];
              Pt[It << 1] = yt[4], Pt[(It << 1) + 1] = yt[5];
            }
            const Ct = [Et, St, Bt, Pt];
            return mt.splice(At, Ot * 4, rt.OPS.paintImageXObjectRepeat), ct.splice(At, Ot * 4, Ct), At + 1;
          }), st(lt, [rt.OPS.beginText, rt.OPS.setFont, rt.OPS.setTextMatrix, rt.OPS.showText, rt.OPS.endText], null, function(dt, gt) {
            const pt = dt.fnArray, mt = dt.argsArray, ct = dt.iCurr - 4, vt = (gt - ct) % 5;
            switch (vt) {
              case 0:
                return pt[gt] === rt.OPS.beginText;
              case 1:
                return pt[gt] === rt.OPS.setFont;
              case 2:
                return pt[gt] === rt.OPS.setTextMatrix;
              case 3:
                if (pt[gt] !== rt.OPS.showText)
                  return !1;
                const At = dt.iCurr - 3, xt = mt[At][0], bt = mt[At][1];
                return !(mt[gt][0] !== xt || mt[gt][1] !== bt);
              case 4:
                return pt[gt] === rt.OPS.endText;
            }
            throw new Error(`iterateShowTextGroup - invalid pos: ${vt}`);
          }, function(ht, dt) {
            const mt = ht.fnArray, ct = ht.argsArray, vt = ht.iCurr, At = vt - 4, xt = vt - 3, bt = vt - 2, Et = vt - 1, St = vt, Bt = ct[xt][0], Ot = ct[xt][1];
            let Pt = Math.min(Math.floor((dt - At) / 5), 1e3);
            if (Pt < 3)
              return dt - (dt - At) % 5;
            let wt = At;
            At >= 4 && mt[At - 4] === mt[xt] && mt[At - 3] === mt[bt] && mt[At - 2] === mt[Et] && mt[At - 1] === mt[St] && ct[At - 4][0] === Bt && ct[At - 4][1] === Ot && (Pt++, wt -= 5);
            let Ct = wt + 4;
            for (let It = 1; It < Pt; It++)
              mt.splice(Ct, 3), ct.splice(Ct, 3), Ct += 2;
            return Ct + 1;
          });
          class et {
            constructor(dt) {
              this.queue = dt;
            }
            _optimize() {
            }
            push(dt, gt) {
              this.queue.fnArray.push(dt), this.queue.argsArray.push(gt), this._optimize();
            }
            flush() {
            }
            reset() {
            }
          }
          class it extends et {
            constructor(dt) {
              super(dt), this.state = null, this.context = {
                iCurr: 0,
                fnArray: dt.fnArray,
                argsArray: dt.argsArray,
                isOffscreenCanvasSupported: !1
              }, this.match = null, this.lastProcessed = 0;
            }
            set isOffscreenCanvasSupported(dt) {
              this.context.isOffscreenCanvasSupported = dt;
            }
            _optimize() {
              const dt = this.queue.fnArray;
              let gt = this.lastProcessed, pt = dt.length, mt = this.state, ct = this.match;
              if (!mt && !ct && gt + 1 === pt && !lt[dt[gt]]) {
                this.lastProcessed = pt;
                return;
              }
              const vt = this.context;
              for (; gt < pt; ) {
                if (ct) {
                  if ((0, ct.iterateFn)(vt, gt)) {
                    gt++;
                    continue;
                  }
                  if (gt = (0, ct.processFn)(vt, gt + 1), pt = dt.length, ct = null, mt = null, gt >= pt)
                    break;
                }
                if (mt = (mt || lt)[dt[gt]], !mt || Array.isArray(mt)) {
                  gt++;
                  continue;
                }
                if (vt.iCurr = gt, gt++, mt.checkFn && !(0, mt.checkFn)(vt)) {
                  mt = null;
                  continue;
                }
                ct = mt, mt = null;
              }
              this.state = mt, this.match = ct, this.lastProcessed = gt;
            }
            flush() {
              for (; this.match; ) {
                const dt = this.queue.fnArray.length;
                this.lastProcessed = (0, this.match.processFn)(this.context, dt), this.match = null, this.state = null, this._optimize();
              }
            }
            reset() {
              this.state = null, this.match = null, this.lastProcessed = 0;
            }
          }
          const ft = class ft {
            constructor() {
              let dt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, gt = arguments.length > 1 ? arguments[1] : void 0;
              this._streamSink = gt, this.fnArray = [], this.argsArray = [], this.optimizer = gt && !(dt & rt.RenderingIntentFlag.OPLIST) ? new it(this) : new et(this), this.dependencies = /* @__PURE__ */ new Set(), this._totalLength = 0, this.weight = 0, this._resolved = gt ? null : Promise.resolve();
            }
            set isOffscreenCanvasSupported(dt) {
              this.optimizer.isOffscreenCanvasSupported = dt;
            }
            get length() {
              return this.argsArray.length;
            }
            get ready() {
              return this._resolved || this._streamSink.ready;
            }
            get totalLength() {
              return this._totalLength + this.length;
            }
            addOp(dt, gt) {
              this.optimizer.push(dt, gt), this.weight++, this._streamSink && (this.weight >= ft.CHUNK_SIZE ? this.flush() : this.weight >= ft.CHUNK_SIZE_ABOUT && (dt === rt.OPS.restore || dt === rt.OPS.endText) && this.flush());
            }
            addImageOps(dt, gt, pt) {
              pt !== void 0 && this.addOp(rt.OPS.beginMarkedContentProps, ["OC", pt]), this.addOp(dt, gt), pt !== void 0 && this.addOp(rt.OPS.endMarkedContent, []);
            }
            addDependency(dt) {
              this.dependencies.has(dt) || (this.dependencies.add(dt), this.addOp(rt.OPS.dependency, [dt]));
            }
            addDependencies(dt) {
              for (const gt of dt)
                this.addDependency(gt);
            }
            addOpList(dt) {
              if (!(dt instanceof ft)) {
                (0, rt.warn)('addOpList - ignoring invalid "opList" parameter.');
                return;
              }
              for (const gt of dt.dependencies)
                this.dependencies.add(gt);
              for (let gt = 0, pt = dt.length; gt < pt; gt++)
                this.addOp(dt.fnArray[gt], dt.argsArray[gt]);
            }
            getIR() {
              return {
                fnArray: this.fnArray,
                argsArray: this.argsArray,
                length: this.length
              };
            }
            get _transfers() {
              var ct;
              const dt = [], {
                fnArray: gt,
                argsArray: pt,
                length: mt
              } = this;
              for (let vt = 0; vt < mt; vt++)
                switch (gt[vt]) {
                  case rt.OPS.paintInlineImageXObject:
                  case rt.OPS.paintInlineImageXObjectGroup:
                  case rt.OPS.paintImageMaskXObject:
                    const At = pt[vt][0];
                    !At.cached && ((ct = At.data) == null ? void 0 : ct.buffer) instanceof ArrayBuffer && dt.push(At.data.buffer);
                    break;
                }
              return dt;
            }
            flush() {
              let dt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, gt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              this.optimizer.flush();
              const pt = this.length;
              this._totalLength += pt, this._streamSink.enqueue({
                fnArray: this.fnArray,
                argsArray: this.argsArray,
                lastChunk: dt,
                separateAnnots: gt,
                length: pt
              }, 1, this._transfers), this.dependencies.clear(), this.fnArray.length = 0, this.argsArray.length = 0, this.weight = 0, this.optimizer.reset();
            }
          };
          Ln(ft, "CHUNK_SIZE", 1e3), Ln(ft, "CHUNK_SIZE_ABOUT", ft.CHUNK_SIZE - 5);
          let ut = ft;
          at.OperatorList = ut;
        },
        /* 216 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.PDFImage = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(2);
          var rt = ot(145), st = ot(179), lt = ot(152), et = ot(163), it = ot(169), ut = ot(213), ft = ot(177), ht = ot(181), dt = ot(151);
          function gt(ct, vt, At, xt) {
            return ct = vt + ct * At, ct < 0 ? ct = 0 : ct > xt && (ct = xt), ct;
          }
          function pt(ct, vt, At, xt, bt, Et) {
            const St = bt * Et;
            let Bt;
            vt <= 8 ? Bt = new Uint8Array(St) : vt <= 16 ? Bt = new Uint16Array(St) : Bt = new Uint32Array(St);
            const Ot = At / bt, Pt = xt / Et;
            let wt, Ct, It, yt = 0, Rt;
            const kt = new Uint16Array(bt), jt = At;
            for (wt = 0; wt < bt; wt++)
              kt[wt] = Math.floor(wt * Ot);
            for (wt = 0; wt < Et; wt++)
              for (It = Math.floor(wt * Pt) * jt, Ct = 0; Ct < bt; Ct++)
                Rt = It + kt[Ct], Bt[yt++] = ct[Rt];
            return Bt;
          }
          class mt {
            constructor(vt) {
              var Ht;
              let {
                xref: At,
                res: xt,
                image: bt,
                isInline: Et = !1,
                smask: St = null,
                mask: Bt = null,
                isMask: Ot = !1,
                pdfFunctionFactory: Pt,
                localColorSpaceCache: wt
              } = vt;
              this.image = bt;
              const Ct = bt.dict, It = Ct.get("F", "Filter");
              let yt;
              if (It instanceof dt.Name)
                yt = It.name;
              else if (Array.isArray(It)) {
                const Ft = At.fetchIfRef(It[0]);
                Ft instanceof dt.Name && (yt = Ft.name);
              }
              switch (yt) {
                case "JPXDecode":
                  const Ft = new ht.JpxImage();
                  Ft.parseImageProperties(bt.stream), bt.stream.reset(), bt.width = Ft.width, bt.height = Ft.height, bt.bitsPerComponent = Ft.bitsPerComponent, bt.numComps = Ft.componentsCount;
                  break;
                case "JBIG2Decode":
                  bt.bitsPerComponent = 1, bt.numComps = 1;
                  break;
              }
              let Rt = Ct.get("W", "Width"), kt = Ct.get("H", "Height");
              if (Number.isInteger(bt.width) && bt.width > 0 && Number.isInteger(bt.height) && bt.height > 0 && (bt.width !== Rt || bt.height !== kt) && ((0, rt.warn)("PDFImage - using the Width/Height of the image data, rather than the image dictionary."), Rt = bt.width, kt = bt.height), Rt < 1 || kt < 1)
                throw new rt.FormatError(`Invalid image width: ${Rt} or height: ${kt}`);
              this.width = Rt, this.height = kt, this.interpolate = Ct.get("I", "Interpolate"), this.imageMask = Ct.get("IM", "ImageMask") || !1, this.matte = Ct.get("Matte") || !1;
              let jt = bt.bitsPerComponent;
              if (!jt && (jt = Ct.get("BPC", "BitsPerComponent"), !jt))
                if (this.imageMask)
                  jt = 1;
                else
                  throw new rt.FormatError(`Bits per component missing in image: ${this.imageMask}`);
              if (this.bpc = jt, !this.imageMask) {
                let Ft = Ct.getRaw("CS") || Ct.getRaw("ColorSpace");
                if (!Ft)
                  switch ((0, rt.info)("JPX images (which do not require color spaces)"), bt.numComps) {
                    case 1:
                      Ft = dt.Name.get("DeviceGray");
                      break;
                    case 3:
                      Ft = dt.Name.get("DeviceRGB");
                      break;
                    case 4:
                      Ft = dt.Name.get("DeviceCMYK");
                      break;
                    default:
                      throw new Error(`JPX images with ${bt.numComps} color components not supported.`);
                  }
                this.colorSpace = et.ColorSpace.parse({
                  cs: Ft,
                  xref: At,
                  resources: Et ? xt : null,
                  pdfFunctionFactory: Pt,
                  localColorSpaceCache: wt
                }), this.numComps = this.colorSpace.numComps;
              }
              if (this.decode = Ct.getArray("D", "Decode"), this.needsDecode = !1, this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, jt) || Ot && !et.ColorSpace.isDefaultDecode(this.decode, 1))) {
                this.needsDecode = !0;
                const Ft = (1 << jt) - 1;
                this.decodeCoefficients = [], this.decodeAddends = [];
                const _t = ((Ht = this.colorSpace) == null ? void 0 : Ht.name) === "Indexed";
                for (let Nt = 0, Mt = 0; Nt < this.decode.length; Nt += 2, ++Mt) {
                  const Lt = this.decode[Nt], $t = this.decode[Nt + 1];
                  this.decodeCoefficients[Mt] = _t ? ($t - Lt) / Ft : $t - Lt, this.decodeAddends[Mt] = _t ? Lt : Ft * Lt;
                }
              }
              St ? this.smask = new mt({
                xref: At,
                res: xt,
                image: St,
                isInline: Et,
                pdfFunctionFactory: Pt,
                localColorSpaceCache: wt
              }) : Bt && (Bt instanceof lt.BaseStream ? Bt.dict.get("IM", "ImageMask") ? this.mask = new mt({
                xref: At,
                res: xt,
                image: Bt,
                isInline: Et,
                isMask: !0,
                pdfFunctionFactory: Pt,
                localColorSpaceCache: wt
              }) : (0, rt.warn)("Ignoring /Mask in image without /ImageMask.") : this.mask = Bt);
            }
            static async buildImage(vt) {
              let {
                xref: At,
                res: xt,
                image: bt,
                isInline: Et = !1,
                pdfFunctionFactory: St,
                localColorSpaceCache: Bt
              } = vt;
              const Ot = bt;
              let Pt = null, wt = null;
              const Ct = bt.dict.get("SMask"), It = bt.dict.get("Mask");
              return Ct ? Ct instanceof lt.BaseStream ? Pt = Ct : (0, rt.warn)("Unsupported /SMask format.") : It && (It instanceof lt.BaseStream || Array.isArray(It) ? wt = It : (0, rt.warn)("Unsupported /Mask format.")), new mt({
                xref: At,
                res: xt,
                image: Ot,
                isInline: Et,
                smask: Pt,
                mask: wt,
                pdfFunctionFactory: St,
                localColorSpaceCache: Bt
              });
            }
            static createRawMask(vt) {
              let {
                imgArray: At,
                width: xt,
                height: bt,
                imageIsFromDecodeStream: Et,
                inverseDecode: St,
                interpolate: Bt
              } = vt;
              const Ot = (xt + 7 >> 3) * bt, Pt = At.byteLength, wt = Ot === Pt;
              let Ct, It;
              if (Et && (!St || wt) ? Ct = At : St ? (Ct = new Uint8Array(Ot), Ct.set(At), Ct.fill(255, Pt)) : Ct = new Uint8Array(At), St)
                for (It = 0; It < Pt; It++)
                  Ct[It] ^= 255;
              return {
                data: Ct,
                width: xt,
                height: bt,
                interpolate: Bt
              };
            }
            static async createMask(vt) {
              let {
                imgArray: At,
                width: xt,
                height: bt,
                imageIsFromDecodeStream: Et,
                inverseDecode: St,
                interpolate: Bt,
                isOffscreenCanvasSupported: Ot = !1
              } = vt;
              const Pt = xt === 1 && bt === 1 && St === (At.length === 0 || !!(At[0] & 128));
              if (Pt)
                return {
                  isSingleOpaquePixel: Pt
                };
              if (Ot) {
                if (ut.ImageResizer.needsToBeResized(xt, bt)) {
                  const Rt = new Uint8ClampedArray(xt * bt * 4);
                  return (0, st.convertBlackAndWhiteToRGBA)({
                    src: At,
                    dest: Rt,
                    width: xt,
                    height: bt,
                    nonBlackColor: 0,
                    inverseDecode: St
                  }), ut.ImageResizer.createImage({
                    kind: rt.ImageKind.RGBA_32BPP,
                    data: Rt,
                    width: xt,
                    height: bt,
                    interpolate: Bt
                  });
                }
                const wt = new OffscreenCanvas(xt, bt), Ct = wt.getContext("2d"), It = Ct.createImageData(xt, bt);
                (0, st.convertBlackAndWhiteToRGBA)({
                  src: At,
                  dest: It.data,
                  width: xt,
                  height: bt,
                  nonBlackColor: 0,
                  inverseDecode: St
                }), Ct.putImageData(It, 0, 0);
                const yt = wt.transferToImageBitmap();
                return {
                  data: null,
                  width: xt,
                  height: bt,
                  interpolate: Bt,
                  bitmap: yt
                };
              }
              return this.createRawMask({
                imgArray: At,
                width: xt,
                height: bt,
                inverseDecode: St,
                imageIsFromDecodeStream: Et,
                interpolate: Bt
              });
            }
            get drawWidth() {
              var vt, At;
              return Math.max(this.width, ((vt = this.smask) == null ? void 0 : vt.width) || 0, ((At = this.mask) == null ? void 0 : At.width) || 0);
            }
            get drawHeight() {
              var vt, At;
              return Math.max(this.height, ((vt = this.smask) == null ? void 0 : vt.height) || 0, ((At = this.mask) == null ? void 0 : At.height) || 0);
            }
            decodeBuffer(vt) {
              const At = this.bpc, xt = this.numComps, bt = this.decodeAddends, Et = this.decodeCoefficients, St = (1 << At) - 1;
              let Bt, Ot;
              if (At === 1) {
                for (Bt = 0, Ot = vt.length; Bt < Ot; Bt++)
                  vt[Bt] = +!vt[Bt];
                return;
              }
              let Pt = 0;
              for (Bt = 0, Ot = this.width * this.height; Bt < Ot; Bt++)
                for (let wt = 0; wt < xt; wt++)
                  vt[Pt] = gt(vt[Pt], bt[wt], Et[wt], St), Pt++;
            }
            getComponents(vt) {
              const At = this.bpc;
              if (At === 8)
                return vt;
              const xt = this.width, bt = this.height, Et = this.numComps, St = xt * bt * Et;
              let Bt = 0, Ot;
              At <= 8 ? Ot = new Uint8Array(St) : At <= 16 ? Ot = new Uint16Array(St) : Ot = new Uint32Array(St);
              const Pt = xt * Et, wt = (1 << At) - 1;
              let Ct = 0, It, yt;
              if (At === 1) {
                let Rt, kt, jt;
                for (let Ht = 0; Ht < bt; Ht++) {
                  for (kt = Ct + (Pt & -8), jt = Ct + Pt; Ct < kt; )
                    yt = vt[Bt++], Ot[Ct] = yt >> 7 & 1, Ot[Ct + 1] = yt >> 6 & 1, Ot[Ct + 2] = yt >> 5 & 1, Ot[Ct + 3] = yt >> 4 & 1, Ot[Ct + 4] = yt >> 3 & 1, Ot[Ct + 5] = yt >> 2 & 1, Ot[Ct + 6] = yt >> 1 & 1, Ot[Ct + 7] = yt & 1, Ct += 8;
                  if (Ct < jt)
                    for (yt = vt[Bt++], Rt = 128; Ct < jt; )
                      Ot[Ct++] = +!!(yt & Rt), Rt >>= 1;
                }
              } else {
                let Rt = 0;
                for (yt = 0, Ct = 0, It = St; Ct < It; ++Ct) {
                  for (Ct % Pt === 0 && (yt = 0, Rt = 0); Rt < At; )
                    yt = yt << 8 | vt[Bt++], Rt += 8;
                  const kt = Rt - At;
                  let jt = yt >> kt;
                  jt < 0 ? jt = 0 : jt > wt && (jt = wt), Ot[Ct] = jt, yt &= (1 << kt) - 1, Rt = kt;
                }
              }
              return Ot;
            }
            fillOpacity(vt, At, xt, bt, Et) {
              const St = this.smask, Bt = this.mask;
              let Ot, Pt, wt, Ct, It, yt;
              if (St)
                Pt = St.width, wt = St.height, Ot = new Uint8ClampedArray(Pt * wt), St.fillGrayBuffer(Ot), (Pt !== At || wt !== xt) && (Ot = pt(Ot, St.bpc, Pt, wt, At, xt));
              else if (Bt)
                if (Bt instanceof mt) {
                  for (Pt = Bt.width, wt = Bt.height, Ot = new Uint8ClampedArray(Pt * wt), Bt.numComps = 1, Bt.fillGrayBuffer(Ot), Ct = 0, It = Pt * wt; Ct < It; ++Ct)
                    Ot[Ct] = 255 - Ot[Ct];
                  (Pt !== At || wt !== xt) && (Ot = pt(Ot, Bt.bpc, Pt, wt, At, xt));
                } else if (Array.isArray(Bt)) {
                  Ot = new Uint8ClampedArray(At * xt);
                  const Rt = this.numComps;
                  for (Ct = 0, It = At * xt; Ct < It; ++Ct) {
                    let kt = 0;
                    const jt = Ct * Rt;
                    for (yt = 0; yt < Rt; ++yt) {
                      const Ht = Et[jt + yt], Ft = yt * 2;
                      if (Ht < Bt[Ft] || Ht > Bt[Ft + 1]) {
                        kt = 255;
                        break;
                      }
                    }
                    Ot[Ct] = kt;
                  }
                } else
                  throw new rt.FormatError("Unknown mask format.");
              if (Ot)
                for (Ct = 0, yt = 3, It = At * bt; Ct < It; ++Ct, yt += 4)
                  vt[yt] = Ot[Ct];
              else
                for (Ct = 0, yt = 3, It = At * bt; Ct < It; ++Ct, yt += 4)
                  vt[yt] = 255;
            }
            undoPreblend(vt, At, xt) {
              var wt;
              const bt = (wt = this.smask) == null ? void 0 : wt.matte;
              if (!bt)
                return;
              const Et = this.colorSpace.getRgb(bt, 0), St = Et[0], Bt = Et[1], Ot = Et[2], Pt = At * xt * 4;
              for (let Ct = 0; Ct < Pt; Ct += 4) {
                const It = vt[Ct + 3];
                if (It === 0) {
                  vt[Ct] = 255, vt[Ct + 1] = 255, vt[Ct + 2] = 255;
                  continue;
                }
                const yt = 255 / It;
                vt[Ct] = (vt[Ct] - St) * yt + St, vt[Ct + 1] = (vt[Ct + 1] - Bt) * yt + Bt, vt[Ct + 2] = (vt[Ct + 2] - Ot) * yt + Ot;
              }
            }
            async createImageData() {
              let vt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, At = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
              const xt = this.drawWidth, bt = this.drawHeight, Et = {
                width: xt,
                height: bt,
                interpolate: this.interpolate,
                kind: 0,
                data: null
              }, St = this.numComps, Bt = this.width, Ot = this.height, Pt = this.bpc, wt = Bt * St * Pt + 7 >> 3, Ct = At && ut.ImageResizer.needsToBeResized(xt, bt);
              if (!vt) {
                let Mt;
                if (this.colorSpace.name === "DeviceGray" && Pt === 1 ? Mt = rt.ImageKind.GRAYSCALE_1BPP : this.colorSpace.name === "DeviceRGB" && Pt === 8 && !this.needsDecode && (Mt = rt.ImageKind.RGB_24BPP), Mt && !this.smask && !this.mask && xt === Bt && bt === Ot) {
                  const Lt = this.getImageBytes(Ot * wt, {});
                  if (At)
                    return Ct ? ut.ImageResizer.createImage({
                      data: Lt,
                      kind: Mt,
                      width: xt,
                      height: bt,
                      interpolate: this.interpolate
                    }, this.needsDecode) : this.createBitmap(Mt, Bt, Ot, Lt);
                  if (Et.kind = Mt, Et.data = Lt, this.needsDecode) {
                    (0, rt.assert)(Mt === rt.ImageKind.GRAYSCALE_1BPP, "PDFImage.createImageData: The image must be grayscale.");
                    const $t = Et.data;
                    for (let Tt = 0, Dt = $t.length; Tt < Dt; Tt++)
                      $t[Tt] ^= 255;
                  }
                  return Et;
                }
                if (this.image instanceof ft.JpegStream && !this.smask && !this.mask && !this.needsDecode) {
                  let Lt = Ot * wt;
                  if (At && !Ct) {
                    let $t = !1;
                    switch (this.colorSpace.name) {
                      case "DeviceGray":
                        Lt *= 4, $t = !0;
                        break;
                      case "DeviceRGB":
                        Lt = Lt / 3 * 4, $t = !0;
                        break;
                      case "DeviceCMYK":
                        $t = !0;
                        break;
                    }
                    if ($t) {
                      const Tt = this.getImageBytes(Lt, {
                        drawWidth: xt,
                        drawHeight: bt,
                        forceRGBA: !0
                      });
                      return this.createBitmap(rt.ImageKind.RGBA_32BPP, xt, bt, Tt);
                    }
                  } else
                    switch (this.colorSpace.name) {
                      case "DeviceGray":
                        Lt *= 3;
                      case "DeviceRGB":
                      case "DeviceCMYK":
                        return Et.kind = rt.ImageKind.RGB_24BPP, Et.data = this.getImageBytes(Lt, {
                          drawWidth: xt,
                          drawHeight: bt,
                          forceRGB: !0
                        }), Ct ? ut.ImageResizer.createImage(Et) : Et;
                    }
                }
              }
              const It = this.getImageBytes(Ot * wt, {
                internal: !0
              }), yt = 0 | It.length / wt * bt / Ot, Rt = this.getComponents(It);
              let kt, jt, Ht, Ft, _t, Nt;
              if (At && !Ct && (Ht = new OffscreenCanvas(xt, bt), Ft = Ht.getContext("2d"), _t = Ft.createImageData(xt, bt), Nt = _t.data), Et.kind = rt.ImageKind.RGBA_32BPP, !vt && !this.smask && !this.mask ? (!At || Ct ? (Et.kind = rt.ImageKind.RGB_24BPP, Nt = new Uint8ClampedArray(xt * bt * 3), kt = 0) : (new Uint32Array(Nt.buffer).fill(rt.FeatureTest.isLittleEndian ? 4278190080 : 255), kt = 1), jt = !1) : ((!At || Ct) && (Nt = new Uint8ClampedArray(xt * bt * 4)), kt = 1, jt = !0, this.fillOpacity(Nt, xt, bt, yt, Rt)), this.needsDecode && this.decodeBuffer(Rt), this.colorSpace.fillRgb(Nt, Bt, Ot, xt, bt, yt, Pt, Rt, kt), jt && this.undoPreblend(Nt, xt, yt), At && !Ct) {
                Ft.putImageData(_t, 0, 0);
                const Mt = Ht.transferToImageBitmap();
                return {
                  data: null,
                  width: xt,
                  height: bt,
                  bitmap: Mt,
                  interpolate: this.interpolate
                };
              }
              return Et.data = Nt, Ct ? ut.ImageResizer.createImage(Et) : Et;
            }
            fillGrayBuffer(vt) {
              const At = this.numComps;
              if (At !== 1)
                throw new rt.FormatError(`Reading gray scale from a color image: ${At}`);
              const xt = this.width, bt = this.height, Et = this.bpc, St = xt * At * Et + 7 >> 3, Bt = this.getImageBytes(bt * St, {
                internal: !0
              }), Ot = this.getComponents(Bt);
              let Pt, wt;
              if (Et === 1) {
                if (wt = xt * bt, this.needsDecode)
                  for (Pt = 0; Pt < wt; ++Pt)
                    vt[Pt] = Ot[Pt] - 1 & 255;
                else
                  for (Pt = 0; Pt < wt; ++Pt)
                    vt[Pt] = -Ot[Pt] & 255;
                return;
              }
              this.needsDecode && this.decodeBuffer(Ot), wt = xt * bt;
              const Ct = 255 / ((1 << Et) - 1);
              for (Pt = 0; Pt < wt; ++Pt)
                vt[Pt] = Ct * Ot[Pt];
            }
            createBitmap(vt, At, xt, bt) {
              const Et = new OffscreenCanvas(At, xt), St = Et.getContext("2d");
              let Bt;
              vt === rt.ImageKind.RGBA_32BPP ? Bt = new ImageData(bt, At, xt) : (Bt = St.createImageData(At, xt), (0, st.convertToRGBA)({
                kind: vt,
                src: bt,
                dest: new Uint32Array(Bt.data.buffer),
                width: At,
                height: xt,
                inverseDecode: this.needsDecode
              })), St.putImageData(Bt, 0, 0);
              const Ot = Et.transferToImageBitmap();
              return {
                data: null,
                width: At,
                height: xt,
                bitmap: Ot,
                interpolate: this.interpolate
              };
            }
            getImageBytes(vt, At) {
              let {
                drawWidth: xt,
                drawHeight: bt,
                forceRGBA: Et = !1,
                forceRGB: St = !1,
                internal: Bt = !1
              } = At;
              this.image.reset(), this.image.drawWidth = xt || this.width, this.image.drawHeight = bt || this.height, this.image.forceRGBA = !!Et, this.image.forceRGB = !!St;
              const Ot = this.image.getBytes(vt);
              return Bt || this.image instanceof it.DecodeStream ? Ot : ((0, rt.assert)(Ot instanceof Uint8Array, 'PDFImage.getImageBytes: Unsupported "imageBytes" type.'), new Uint8Array(Ot));
            }
          }
          at.PDFImage = mt;
        },
        /* 217 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Catalog = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(140), ot(2);
          var rt = ot(150), st = ot(145), lt = ot(151), et = ot(218), it = ot(152), ut = ot(219), ft = ot(163), ht = ot(220), dt = ot(210), gt = ot(221), pt = ot(223);
          function mt(vt) {
            return vt instanceof lt.Dict && (vt = vt.get("D")), Array.isArray(vt) ? vt : null;
          }
          class ct {
            constructor(At, xt) {
              if (this.pdfManager = At, this.xref = xt, this._catDict = xt.getCatalogObj(), !(this._catDict instanceof lt.Dict))
                throw new st.FormatError("Catalog object is not a dictionary.");
              this.toplevelPagesDict, this._actualNumPages = null, this.fontCache = new lt.RefSetCache(), this.builtInCMapCache = /* @__PURE__ */ new Map(), this.standardFontDataCache = /* @__PURE__ */ new Map(), this.globalImageCache = new dt.GlobalImageCache(), this.pageKidsCountCache = new lt.RefSetCache(), this.pageIndexCache = new lt.RefSetCache(), this.nonBlendModesSet = new lt.RefSet(), this.systemFontCache = /* @__PURE__ */ new Map();
            }
            cloneDict() {
              return this._catDict.clone();
            }
            get version() {
              const At = this._catDict.get("Version");
              if (At instanceof lt.Name) {
                if (rt.PDF_VERSION_REGEXP.test(At.name))
                  return (0, st.shadow)(this, "version", At.name);
                (0, st.warn)(`Invalid PDF catalog version: ${At.name}`);
              }
              return (0, st.shadow)(this, "version", null);
            }
            get lang() {
              const At = this._catDict.get("Lang");
              return (0, st.shadow)(this, "lang", typeof At == "string" ? (0, st.stringToPDFString)(At) : null);
            }
            get needsRendering() {
              const At = this._catDict.get("NeedsRendering");
              return (0, st.shadow)(this, "needsRendering", typeof At == "boolean" ? At : !1);
            }
            get collection() {
              let At = null;
              try {
                const xt = this._catDict.get("Collection");
                xt instanceof lt.Dict && xt.size > 0 && (At = xt);
              } catch (xt) {
                if (xt instanceof rt.MissingDataException)
                  throw xt;
                (0, st.info)("Cannot fetch Collection entry; assuming no collection is present.");
              }
              return (0, st.shadow)(this, "collection", At);
            }
            get acroForm() {
              let At = null;
              try {
                const xt = this._catDict.get("AcroForm");
                xt instanceof lt.Dict && xt.size > 0 && (At = xt);
              } catch (xt) {
                if (xt instanceof rt.MissingDataException)
                  throw xt;
                (0, st.info)("Cannot fetch AcroForm entry; assuming no forms are present.");
              }
              return (0, st.shadow)(this, "acroForm", At);
            }
            get acroFormRef() {
              const At = this._catDict.getRaw("AcroForm");
              return (0, st.shadow)(this, "acroFormRef", At instanceof lt.Ref ? At : null);
            }
            get metadata() {
              var bt;
              const At = this._catDict.getRaw("Metadata");
              if (!(At instanceof lt.Ref))
                return (0, st.shadow)(this, "metadata", null);
              let xt = null;
              try {
                const Et = this.xref.fetch(At, !((bt = this.xref.encrypt) != null && bt.encryptMetadata));
                if (Et instanceof it.BaseStream && Et.dict instanceof lt.Dict) {
                  const St = Et.dict.get("Type"), Bt = Et.dict.get("Subtype");
                  if ((0, lt.isName)(St, "Metadata") && (0, lt.isName)(Bt, "XML")) {
                    const Ot = (0, st.stringToUTF8String)(Et.getString());
                    Ot && (xt = new gt.MetadataParser(Ot).serializable);
                  }
                }
              } catch (Et) {
                if (Et instanceof rt.MissingDataException)
                  throw Et;
                (0, st.info)(`Skipping invalid Metadata: "${Et}".`);
              }
              return (0, st.shadow)(this, "metadata", xt);
            }
            get markInfo() {
              let At = null;
              try {
                At = this._readMarkInfo();
              } catch (xt) {
                if (xt instanceof rt.MissingDataException)
                  throw xt;
                (0, st.warn)("Unable to read mark info.");
              }
              return (0, st.shadow)(this, "markInfo", At);
            }
            _readMarkInfo() {
              const At = this._catDict.get("MarkInfo");
              if (!(At instanceof lt.Dict))
                return null;
              const xt = {
                Marked: !1,
                UserProperties: !1,
                Suspects: !1
              };
              for (const bt in xt) {
                const Et = At.get(bt);
                typeof Et == "boolean" && (xt[bt] = Et);
              }
              return xt;
            }
            get structTreeRoot() {
              let At = null;
              try {
                At = this._readStructTreeRoot();
              } catch (xt) {
                if (xt instanceof rt.MissingDataException)
                  throw xt;
                (0, st.warn)("Unable read to structTreeRoot info.");
              }
              return (0, st.shadow)(this, "structTreeRoot", At);
            }
            _readStructTreeRoot() {
              const At = this._catDict.getRaw("StructTreeRoot"), xt = this.xref.fetchIfRef(At);
              if (!(xt instanceof lt.Dict))
                return null;
              const bt = new pt.StructTreeRoot(xt, At);
              return bt.init(), bt;
            }
            get toplevelPagesDict() {
              const At = this._catDict.get("Pages");
              if (!(At instanceof lt.Dict))
                throw new st.FormatError("Invalid top-level pages dictionary.");
              return (0, st.shadow)(this, "toplevelPagesDict", At);
            }
            get documentOutline() {
              let At = null;
              try {
                At = this._readDocumentOutline();
              } catch (xt) {
                if (xt instanceof rt.MissingDataException)
                  throw xt;
                (0, st.warn)("Unable to read document outline.");
              }
              return (0, st.shadow)(this, "documentOutline", At);
            }
            _readDocumentOutline() {
              let At = this._catDict.get("Outlines");
              if (!(At instanceof lt.Dict) || (At = At.getRaw("First"), !(At instanceof lt.Ref)))
                return null;
              const xt = {
                items: []
              }, bt = [{
                obj: At,
                parent: xt
              }], Et = new lt.RefSet();
              Et.put(At);
              const St = this.xref, Bt = new Uint8ClampedArray(3);
              for (; bt.length > 0; ) {
                const Ot = bt.shift(), Pt = St.fetchIfRef(Ot.obj);
                if (Pt === null)
                  continue;
                if (!Pt.has("Title"))
                  throw new st.FormatError("Invalid outline item encountered.");
                const wt = {
                  url: null,
                  dest: null,
                  action: null
                };
                ct.parseDestDictionary({
                  destDict: Pt,
                  resultObj: wt,
                  docBaseUrl: this.baseUrl,
                  docAttachments: this.attachments
                });
                const Ct = Pt.get("Title"), It = Pt.get("F") || 0, yt = Pt.getArray("C"), Rt = Pt.get("Count");
                let kt = Bt;
                Array.isArray(yt) && yt.length === 3 && (yt[0] !== 0 || yt[1] !== 0 || yt[2] !== 0) && (kt = ft.ColorSpace.singletons.rgb.getRgb(yt, 0));
                const jt = {
                  action: wt.action,
                  attachment: wt.attachment,
                  dest: wt.dest,
                  url: wt.url,
                  unsafeUrl: wt.unsafeUrl,
                  newWindow: wt.newWindow,
                  setOCGState: wt.setOCGState,
                  title: (0, st.stringToPDFString)(Ct),
                  color: kt,
                  count: Number.isInteger(Rt) ? Rt : void 0,
                  bold: !!(It & 2),
                  italic: !!(It & 1),
                  items: []
                };
                Ot.parent.items.push(jt), At = Pt.getRaw("First"), At instanceof lt.Ref && !Et.has(At) && (bt.push({
                  obj: At,
                  parent: jt
                }), Et.put(At)), At = Pt.getRaw("Next"), At instanceof lt.Ref && !Et.has(At) && (bt.push({
                  obj: At,
                  parent: Ot.parent
                }), Et.put(At));
              }
              return xt.items.length > 0 ? xt.items : null;
            }
            get permissions() {
              let At = null;
              try {
                At = this._readPermissions();
              } catch (xt) {
                if (xt instanceof rt.MissingDataException)
                  throw xt;
                (0, st.warn)("Unable to read permissions.");
              }
              return (0, st.shadow)(this, "permissions", At);
            }
            _readPermissions() {
              const At = this.xref.trailer.get("Encrypt");
              if (!(At instanceof lt.Dict))
                return null;
              let xt = At.get("P");
              if (typeof xt != "number")
                return null;
              xt += 4294967296;
              const bt = [];
              for (const Et in st.PermissionFlag) {
                const St = st.PermissionFlag[Et];
                xt & St && bt.push(St);
              }
              return bt;
            }
            get optionalContentConfig() {
              let At = null;
              try {
                const xt = this._catDict.get("OCProperties");
                if (!xt)
                  return (0, st.shadow)(this, "optionalContentConfig", null);
                const bt = xt.get("D");
                if (!bt)
                  return (0, st.shadow)(this, "optionalContentConfig", null);
                const Et = xt.get("OCGs");
                if (!Array.isArray(Et))
                  return (0, st.shadow)(this, "optionalContentConfig", null);
                const St = [], Bt = [];
                for (const Ot of Et) {
                  if (!(Ot instanceof lt.Ref))
                    continue;
                  Bt.push(Ot);
                  const Pt = this.xref.fetchIfRef(Ot);
                  St.push({
                    id: Ot.toString(),
                    name: typeof Pt.get("Name") == "string" ? (0, st.stringToPDFString)(Pt.get("Name")) : null,
                    intent: typeof Pt.get("Intent") == "string" ? (0, st.stringToPDFString)(Pt.get("Intent")) : null
                  });
                }
                At = this._readOptionalContentConfig(bt, Bt), At.groups = St;
              } catch (xt) {
                if (xt instanceof rt.MissingDataException)
                  throw xt;
                (0, st.warn)(`Unable to read optional content config: ${xt}`);
              }
              return (0, st.shadow)(this, "optionalContentConfig", At);
            }
            _readOptionalContentConfig(At, xt) {
              function bt(wt) {
                const Ct = [];
                if (Array.isArray(wt))
                  for (const It of wt)
                    It instanceof lt.Ref && xt.includes(It) && Ct.push(It.toString());
                return Ct;
              }
              function Et(wt) {
                let Ct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (!Array.isArray(wt))
                  return null;
                const It = [];
                for (const Rt of wt) {
                  if (Rt instanceof lt.Ref && xt.includes(Rt)) {
                    Ot.put(Rt), It.push(Rt.toString());
                    continue;
                  }
                  const kt = St(Rt, Ct);
                  kt && It.push(kt);
                }
                if (Ct > 0)
                  return It;
                const yt = [];
                for (const Rt of xt)
                  Ot.has(Rt) || yt.push(Rt.toString());
                return yt.length && It.push({
                  name: null,
                  order: yt
                }), It;
              }
              function St(wt, Ct) {
                if (++Ct > Pt)
                  return (0, st.warn)("parseNestedOrder - reached MAX_NESTED_LEVELS."), null;
                const It = Bt.fetchIfRef(wt);
                if (!Array.isArray(It))
                  return null;
                const yt = Bt.fetchIfRef(It[0]);
                if (typeof yt != "string")
                  return null;
                const Rt = Et(It.slice(1), Ct);
                return !Rt || !Rt.length ? null : {
                  name: (0, st.stringToPDFString)(yt),
                  order: Rt
                };
              }
              const Bt = this.xref, Ot = new lt.RefSet(), Pt = 10;
              return {
                name: typeof At.get("Name") == "string" ? (0, st.stringToPDFString)(At.get("Name")) : null,
                creator: typeof At.get("Creator") == "string" ? (0, st.stringToPDFString)(At.get("Creator")) : null,
                baseState: At.get("BaseState") instanceof lt.Name ? At.get("BaseState").name : null,
                on: bt(At.get("ON")),
                off: bt(At.get("OFF")),
                order: Et(At.get("Order")),
                groups: null
              };
            }
            setActualNumPages() {
              let At = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              this._actualNumPages = At;
            }
            get hasActualNumPages() {
              return this._actualNumPages !== null;
            }
            get _pagesCount() {
              const At = this.toplevelPagesDict.get("Count");
              if (!Number.isInteger(At))
                throw new st.FormatError("Page count in top-level pages dictionary is not an integer.");
              return (0, st.shadow)(this, "_pagesCount", At);
            }
            get numPages() {
              return this.hasActualNumPages ? this._actualNumPages : this._pagesCount;
            }
            get destinations() {
              const At = this._readDests(), xt = /* @__PURE__ */ Object.create(null);
              if (At instanceof et.NameTree)
                for (const [bt, Et] of At.getAll()) {
                  const St = mt(Et);
                  St && (xt[(0, st.stringToPDFString)(bt)] = St);
                }
              else
                At instanceof lt.Dict && At.forEach(function(bt, Et) {
                  const St = mt(Et);
                  St && (xt[bt] = St);
                });
              return (0, st.shadow)(this, "destinations", xt);
            }
            getDestination(At) {
              const xt = this._readDests();
              if (xt instanceof et.NameTree) {
                const bt = mt(xt.get(At));
                if (bt)
                  return bt;
                const Et = this.destinations[At];
                if (Et)
                  return (0, st.warn)(`Found "${At}" at an incorrect position in the NameTree.`), Et;
              } else if (xt instanceof lt.Dict) {
                const bt = mt(xt.get(At));
                if (bt)
                  return bt;
              }
              return null;
            }
            _readDests() {
              const At = this._catDict.get("Names");
              if (At != null && At.has("Dests"))
                return new et.NameTree(At.getRaw("Dests"), this.xref);
              if (this._catDict.has("Dests"))
                return this._catDict.get("Dests");
            }
            get pageLabels() {
              let At = null;
              try {
                At = this._readPageLabels();
              } catch (xt) {
                if (xt instanceof rt.MissingDataException)
                  throw xt;
                (0, st.warn)("Unable to read page labels.");
              }
              return (0, st.shadow)(this, "pageLabels", At);
            }
            _readPageLabels() {
              const At = this._catDict.getRaw("PageLabels");
              if (!At)
                return null;
              const xt = new Array(this.numPages);
              let bt = null, Et = "";
              const Bt = new et.NumberTree(At, this.xref).getAll();
              let Ot = "", Pt = 1;
              for (let wt = 0, Ct = this.numPages; wt < Ct; wt++) {
                const It = Bt.get(wt);
                if (It !== void 0) {
                  if (!(It instanceof lt.Dict))
                    throw new st.FormatError("PageLabel is not a dictionary.");
                  if (It.has("Type") && !(0, lt.isName)(It.get("Type"), "PageLabel"))
                    throw new st.FormatError("Invalid type in PageLabel dictionary.");
                  if (It.has("S")) {
                    const yt = It.get("S");
                    if (!(yt instanceof lt.Name))
                      throw new st.FormatError("Invalid style in PageLabel dictionary.");
                    bt = yt.name;
                  } else
                    bt = null;
                  if (It.has("P")) {
                    const yt = It.get("P");
                    if (typeof yt != "string")
                      throw new st.FormatError("Invalid prefix in PageLabel dictionary.");
                    Et = (0, st.stringToPDFString)(yt);
                  } else
                    Et = "";
                  if (It.has("St")) {
                    const yt = It.get("St");
                    if (!(Number.isInteger(yt) && yt >= 1))
                      throw new st.FormatError("Invalid start in PageLabel dictionary.");
                    Pt = yt;
                  } else
                    Pt = 1;
                }
                switch (bt) {
                  case "D":
                    Ot = Pt;
                    break;
                  case "R":
                  case "r":
                    Ot = (0, rt.toRomanNumerals)(Pt, bt === "r");
                    break;
                  case "A":
                  case "a":
                    const yt = 26, jt = bt === "a" ? 97 : 65, Ht = Pt - 1;
                    Ot = String.fromCharCode(jt + Ht % yt).repeat(Math.floor(Ht / yt) + 1);
                    break;
                  default:
                    if (bt)
                      throw new st.FormatError(`Invalid style "${bt}" in PageLabel dictionary.`);
                    Ot = "";
                }
                xt[wt] = Et + Ot, Pt++;
              }
              return xt;
            }
            get pageLayout() {
              const At = this._catDict.get("PageLayout");
              let xt = "";
              if (At instanceof lt.Name)
                switch (At.name) {
                  case "SinglePage":
                  case "OneColumn":
                  case "TwoColumnLeft":
                  case "TwoColumnRight":
                  case "TwoPageLeft":
                  case "TwoPageRight":
                    xt = At.name;
                }
              return (0, st.shadow)(this, "pageLayout", xt);
            }
            get pageMode() {
              const At = this._catDict.get("PageMode");
              let xt = "UseNone";
              if (At instanceof lt.Name)
                switch (At.name) {
                  case "UseNone":
                  case "UseOutlines":
                  case "UseThumbs":
                  case "FullScreen":
                  case "UseOC":
                  case "UseAttachments":
                    xt = At.name;
                }
              return (0, st.shadow)(this, "pageMode", xt);
            }
            get viewerPreferences() {
              const At = this._catDict.get("ViewerPreferences");
              if (!(At instanceof lt.Dict))
                return (0, st.shadow)(this, "viewerPreferences", null);
              let xt = null;
              for (const bt of At.getKeys()) {
                const Et = At.get(bt);
                let St;
                switch (bt) {
                  case "HideToolbar":
                  case "HideMenubar":
                  case "HideWindowUI":
                  case "FitWindow":
                  case "CenterWindow":
                  case "DisplayDocTitle":
                  case "PickTrayByPDFSize":
                    typeof Et == "boolean" && (St = Et);
                    break;
                  case "NonFullScreenPageMode":
                    if (Et instanceof lt.Name)
                      switch (Et.name) {
                        case "UseNone":
                        case "UseOutlines":
                        case "UseThumbs":
                        case "UseOC":
                          St = Et.name;
                          break;
                        default:
                          St = "UseNone";
                      }
                    break;
                  case "Direction":
                    if (Et instanceof lt.Name)
                      switch (Et.name) {
                        case "L2R":
                        case "R2L":
                          St = Et.name;
                          break;
                        default:
                          St = "L2R";
                      }
                    break;
                  case "ViewArea":
                  case "ViewClip":
                  case "PrintArea":
                  case "PrintClip":
                    if (Et instanceof lt.Name)
                      switch (Et.name) {
                        case "MediaBox":
                        case "CropBox":
                        case "BleedBox":
                        case "TrimBox":
                        case "ArtBox":
                          St = Et.name;
                          break;
                        default:
                          St = "CropBox";
                      }
                    break;
                  case "PrintScaling":
                    if (Et instanceof lt.Name)
                      switch (Et.name) {
                        case "None":
                        case "AppDefault":
                          St = Et.name;
                          break;
                        default:
                          St = "AppDefault";
                      }
                    break;
                  case "Duplex":
                    if (Et instanceof lt.Name)
                      switch (Et.name) {
                        case "Simplex":
                        case "DuplexFlipShortEdge":
                        case "DuplexFlipLongEdge":
                          St = Et.name;
                          break;
                        default:
                          St = "None";
                      }
                    break;
                  case "PrintPageRange":
                    Array.isArray(Et) && Et.length % 2 === 0 && Et.every((Ot, Pt, wt) => Number.isInteger(Ot) && Ot > 0 && (Pt === 0 || Ot >= wt[Pt - 1]) && Ot <= this.numPages) && (St = Et);
                    break;
                  case "NumCopies":
                    Number.isInteger(Et) && Et > 0 && (St = Et);
                    break;
                  default:
                    (0, st.warn)(`Ignoring non-standard key in ViewerPreferences: ${bt}.`);
                    continue;
                }
                if (St === void 0) {
                  (0, st.warn)(`Bad value, for key "${bt}", in ViewerPreferences: ${Et}.`);
                  continue;
                }
                xt || (xt = /* @__PURE__ */ Object.create(null)), xt[bt] = St;
              }
              return (0, st.shadow)(this, "viewerPreferences", xt);
            }
            get openAction() {
              const At = this._catDict.get("OpenAction"), xt = /* @__PURE__ */ Object.create(null);
              if (At instanceof lt.Dict) {
                const bt = new lt.Dict(this.xref);
                bt.set("A", At);
                const Et = {
                  url: null,
                  dest: null,
                  action: null
                };
                ct.parseDestDictionary({
                  destDict: bt,
                  resultObj: Et
                }), Array.isArray(Et.dest) ? xt.dest = Et.dest : Et.action && (xt.action = Et.action);
              } else
                Array.isArray(At) && (xt.dest = At);
              return (0, st.shadow)(this, "openAction", (0, st.objectSize)(xt) > 0 ? xt : null);
            }
            get attachments() {
              const At = this._catDict.get("Names");
              let xt = null;
              if (At instanceof lt.Dict && At.has("EmbeddedFiles")) {
                const bt = new et.NameTree(At.getRaw("EmbeddedFiles"), this.xref);
                for (const [Et, St] of bt.getAll()) {
                  const Bt = new ht.FileSpec(St, this.xref);
                  xt || (xt = /* @__PURE__ */ Object.create(null)), xt[(0, st.stringToPDFString)(Et)] = Bt.serializable;
                }
              }
              return (0, st.shadow)(this, "attachments", xt);
            }
            get xfaImages() {
              const At = this._catDict.get("Names");
              let xt = null;
              if (At instanceof lt.Dict && At.has("XFAImages")) {
                const bt = new et.NameTree(At.getRaw("XFAImages"), this.xref);
                for (const [Et, St] of bt.getAll())
                  xt || (xt = new lt.Dict(this.xref)), xt.set((0, st.stringToPDFString)(Et), St);
              }
              return (0, st.shadow)(this, "xfaImages", xt);
            }
            _collectJavaScript() {
              const At = this._catDict.get("Names");
              let xt = null;
              function bt(St, Bt) {
                if (!(Bt instanceof lt.Dict) || !(0, lt.isName)(Bt.get("S"), "JavaScript"))
                  return;
                let Ot = Bt.get("JS");
                if (Ot instanceof it.BaseStream)
                  Ot = Ot.getString();
                else if (typeof Ot != "string")
                  return;
                Ot = (0, st.stringToPDFString)(Ot).replaceAll("\0", ""), Ot && (xt || (xt = /* @__PURE__ */ new Map())).set(St, Ot);
              }
              if (At instanceof lt.Dict && At.has("JavaScript")) {
                const St = new et.NameTree(At.getRaw("JavaScript"), this.xref);
                for (const [Bt, Ot] of St.getAll())
                  bt((0, st.stringToPDFString)(Bt), Ot);
              }
              const Et = this._catDict.get("OpenAction");
              return Et && bt("OpenAction", Et), xt;
            }
            get jsActions() {
              const At = this._collectJavaScript();
              let xt = (0, rt.collectActions)(this.xref, this._catDict, st.DocumentActionEventType);
              if (At) {
                xt || (xt = /* @__PURE__ */ Object.create(null));
                for (const [bt, Et] of At)
                  bt in xt ? xt[bt].push(Et) : xt[bt] = [Et];
              }
              return (0, st.shadow)(this, "jsActions", xt);
            }
            async fontFallback(At, xt) {
              const bt = await Promise.all(this.fontCache);
              for (const Et of bt)
                if (Et.loadedName === At) {
                  Et.fallback(xt);
                  return;
                }
            }
            async cleanup() {
              let At = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              (0, ut.clearGlobalCaches)(), this.globalImageCache.clear(At), this.pageKidsCountCache.clear(), this.pageIndexCache.clear(), this.nonBlendModesSet.clear();
              const xt = await Promise.all(this.fontCache);
              for (const {
                dict: bt
              } of xt)
                delete bt.cacheKey;
              this.fontCache.clear(), this.builtInCMapCache.clear(), this.standardFontDataCache.clear(), this.systemFontCache.clear();
            }
            async getPageDict(At) {
              const xt = [this.toplevelPagesDict], bt = new lt.RefSet(), Et = this._catDict.getRaw("Pages");
              Et instanceof lt.Ref && bt.put(Et);
              const St = this.xref, Bt = this.pageKidsCountCache, Ot = this.pageIndexCache;
              let Pt = 0;
              for (; xt.length; ) {
                const wt = xt.pop();
                if (wt instanceof lt.Ref) {
                  const Rt = Bt.get(wt);
                  if (Rt >= 0 && Pt + Rt <= At) {
                    Pt += Rt;
                    continue;
                  }
                  if (bt.has(wt))
                    throw new st.FormatError("Pages tree contains circular reference.");
                  bt.put(wt);
                  const kt = await St.fetchAsync(wt);
                  if (kt instanceof lt.Dict) {
                    let jt = kt.getRaw("Type");
                    if (jt instanceof lt.Ref && (jt = await St.fetchAsync(jt)), (0, lt.isName)(jt, "Page") || !kt.has("Kids")) {
                      if (Bt.has(wt) || Bt.put(wt, 1), Ot.has(wt) || Ot.put(wt, Pt), Pt === At)
                        return [kt, wt];
                      Pt++;
                      continue;
                    }
                  }
                  xt.push(kt);
                  continue;
                }
                if (!(wt instanceof lt.Dict))
                  throw new st.FormatError("Page dictionary kid reference points to wrong type of object.");
                const {
                  objId: Ct
                } = wt;
                let It = wt.getRaw("Count");
                if (It instanceof lt.Ref && (It = await St.fetchAsync(It)), Number.isInteger(It) && It >= 0 && (Ct && !Bt.has(Ct) && Bt.put(Ct, It), Pt + It <= At)) {
                  Pt += It;
                  continue;
                }
                let yt = wt.getRaw("Kids");
                if (yt instanceof lt.Ref && (yt = await St.fetchAsync(yt)), !Array.isArray(yt)) {
                  let Rt = wt.getRaw("Type");
                  if (Rt instanceof lt.Ref && (Rt = await St.fetchAsync(Rt)), (0, lt.isName)(Rt, "Page") || !wt.has("Kids")) {
                    if (Pt === At)
                      return [wt, null];
                    Pt++;
                    continue;
                  }
                  throw new st.FormatError("Page dictionary kids object is not an array.");
                }
                for (let Rt = yt.length - 1; Rt >= 0; Rt--)
                  xt.push(yt[Rt]);
              }
              throw new Error(`Page index ${At} not found.`);
            }
            async getAllPageDicts() {
              let At = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              const {
                ignoreErrors: xt
              } = this.pdfManager.evaluatorOptions, bt = [{
                currentNode: this.toplevelPagesDict,
                posInKids: 0
              }], Et = new lt.RefSet(), St = this._catDict.getRaw("Pages");
              St instanceof lt.Ref && Et.put(St);
              const Bt = /* @__PURE__ */ new Map(), Ot = this.xref, Pt = this.pageIndexCache;
              let wt = 0;
              function Ct(yt, Rt) {
                Rt && !Pt.has(Rt) && Pt.put(Rt, wt), Bt.set(wt++, [yt, Rt]);
              }
              function It(yt) {
                if (yt instanceof rt.XRefEntryException && !At)
                  throw yt;
                At && xt && wt === 0 && ((0, st.warn)(`getAllPageDicts - Skipping invalid first page: "${yt}".`), yt = lt.Dict.empty), Bt.set(wt++, [yt, null]);
              }
              for (; bt.length > 0; ) {
                const yt = bt.at(-1), {
                  currentNode: Rt,
                  posInKids: kt
                } = yt;
                let jt = Rt.getRaw("Kids");
                if (jt instanceof lt.Ref)
                  try {
                    jt = await Ot.fetchAsync(jt);
                  } catch (Nt) {
                    It(Nt);
                    break;
                  }
                if (!Array.isArray(jt)) {
                  It(new st.FormatError("Page dictionary kids object is not an array."));
                  break;
                }
                if (kt >= jt.length) {
                  bt.pop();
                  continue;
                }
                const Ht = jt[kt];
                let Ft;
                if (Ht instanceof lt.Ref) {
                  if (Et.has(Ht)) {
                    It(new st.FormatError("Pages tree contains circular reference."));
                    break;
                  }
                  Et.put(Ht);
                  try {
                    Ft = await Ot.fetchAsync(Ht);
                  } catch (Nt) {
                    It(Nt);
                    break;
                  }
                } else
                  Ft = Ht;
                if (!(Ft instanceof lt.Dict)) {
                  It(new st.FormatError("Page dictionary kid reference points to wrong type of object."));
                  break;
                }
                let _t = Ft.getRaw("Type");
                if (_t instanceof lt.Ref)
                  try {
                    _t = await Ot.fetchAsync(_t);
                  } catch (Nt) {
                    It(Nt);
                    break;
                  }
                (0, lt.isName)(_t, "Page") || !Ft.has("Kids") ? Ct(Ft, Ht instanceof lt.Ref ? Ht : null) : bt.push({
                  currentNode: Ft,
                  posInKids: 0
                }), yt.posInKids++;
              }
              return Bt;
            }
            getPageIndex(At) {
              const xt = this.pageIndexCache.get(At);
              if (xt !== void 0)
                return Promise.resolve(xt);
              const bt = this.xref;
              function Et(Ot) {
                let Pt = 0, wt;
                return bt.fetchAsync(Ot).then(function(Ct) {
                  if ((0, lt.isRefsEqual)(Ot, At) && !(0, lt.isDict)(Ct, "Page") && !(Ct instanceof lt.Dict && !Ct.has("Type") && Ct.has("Contents")))
                    throw new st.FormatError("The reference does not point to a /Page dictionary.");
                  if (!Ct)
                    return null;
                  if (!(Ct instanceof lt.Dict))
                    throw new st.FormatError("Node must be a dictionary.");
                  return wt = Ct.getRaw("Parent"), Ct.getAsync("Parent");
                }).then(function(Ct) {
                  if (!Ct)
                    return null;
                  if (!(Ct instanceof lt.Dict))
                    throw new st.FormatError("Parent must be a dictionary.");
                  return Ct.getAsync("Kids");
                }).then(function(Ct) {
                  if (!Ct)
                    return null;
                  const It = [];
                  let yt = !1;
                  for (const Rt of Ct) {
                    if (!(Rt instanceof lt.Ref))
                      throw new st.FormatError("Kid must be a reference.");
                    if ((0, lt.isRefsEqual)(Rt, Ot)) {
                      yt = !0;
                      break;
                    }
                    It.push(bt.fetchAsync(Rt).then(function(kt) {
                      if (!(kt instanceof lt.Dict))
                        throw new st.FormatError("Kid node must be a dictionary.");
                      kt.has("Count") ? Pt += kt.get("Count") : Pt++;
                    }));
                  }
                  if (!yt)
                    throw new st.FormatError("Kid reference not found in parent's kids.");
                  return Promise.all(It).then(function() {
                    return [Pt, wt];
                  });
                });
              }
              let St = 0;
              const Bt = (Ot) => Et(Ot).then((Pt) => {
                if (!Pt)
                  return this.pageIndexCache.put(At, St), St;
                const [wt, Ct] = Pt;
                return St += wt, Bt(Ct);
              });
              return Bt(At);
            }
            get baseUrl() {
              const At = this._catDict.get("URI");
              if (At instanceof lt.Dict) {
                const xt = At.get("Base");
                if (typeof xt == "string") {
                  const bt = (0, st.createValidAbsoluteUrl)(xt, null, {
                    tryConvertEncoding: !0
                  });
                  if (bt)
                    return (0, st.shadow)(this, "baseUrl", bt.href);
                }
              }
              return (0, st.shadow)(this, "baseUrl", this.pdfManager.docBaseUrl);
            }
            static parseDestDictionary(At) {
              let {
                destDict: xt,
                resultObj: bt,
                docBaseUrl: Et = null,
                docAttachments: St = null
              } = At;
              if (!(xt instanceof lt.Dict)) {
                (0, st.warn)("parseDestDictionary: `destDict` must be a dictionary.");
                return;
              }
              let Bt = xt.get("A"), Ot, Pt;
              if (Bt instanceof lt.Dict || (xt.has("Dest") ? Bt = xt.get("Dest") : (Bt = xt.get("AA"), Bt instanceof lt.Dict && (Bt.has("D") ? Bt = Bt.get("D") : Bt.has("U") && (Bt = Bt.get("U"))))), Bt instanceof lt.Dict) {
                const wt = Bt.get("S");
                if (!(wt instanceof lt.Name)) {
                  (0, st.warn)("parseDestDictionary: Invalid type in Action dictionary.");
                  return;
                }
                const Ct = wt.name;
                switch (Ct) {
                  case "ResetForm":
                    const It = Bt.get("Flags"), yt = ((typeof It == "number" ? It : 0) & 1) === 0, Rt = [], kt = [];
                    for (const Qt of Bt.get("Fields") || [])
                      Qt instanceof lt.Ref ? kt.push(Qt.toString()) : typeof Qt == "string" && Rt.push((0, st.stringToPDFString)(Qt));
                    bt.resetForm = {
                      fields: Rt,
                      refs: kt,
                      include: yt
                    };
                    break;
                  case "URI":
                    Ot = Bt.get("URI"), Ot instanceof lt.Name && (Ot = "/" + Ot.name);
                    break;
                  case "GoTo":
                    Pt = Bt.get("D");
                    break;
                  case "Launch":
                  case "GoToR":
                    const jt = Bt.get("F");
                    jt instanceof lt.Dict ? Ot = jt.get("F") || null : typeof jt == "string" && (Ot = jt);
                    let Ht = Bt.get("D");
                    if (Ht && (Ht instanceof lt.Name && (Ht = Ht.name), typeof Ot == "string")) {
                      const Qt = Ot.split("#")[0];
                      typeof Ht == "string" ? Ot = Qt + "#" + Ht : Array.isArray(Ht) && (Ot = Qt + "#" + JSON.stringify(Ht));
                    }
                    const Ft = Bt.get("NewWindow");
                    typeof Ft == "boolean" && (bt.newWindow = Ft);
                    break;
                  case "GoToE":
                    const _t = Bt.get("T");
                    let Nt;
                    if (St && _t instanceof lt.Dict) {
                      const Qt = _t.get("R"), qt = _t.get("N");
                      (0, lt.isName)(Qt, "C") && typeof qt == "string" && (Nt = St[(0, st.stringToPDFString)(qt)]);
                    }
                    Nt ? bt.attachment = Nt : (0, st.warn)('parseDestDictionary - unimplemented "GoToE" action.');
                    break;
                  case "Named":
                    const Mt = Bt.get("N");
                    Mt instanceof lt.Name && (bt.action = Mt.name);
                    break;
                  case "SetOCGState":
                    const Lt = Bt.get("State"), $t = Bt.get("PreserveRB");
                    if (!Array.isArray(Lt) || Lt.length === 0)
                      break;
                    const Tt = [];
                    for (const Qt of Lt)
                      if (Qt instanceof lt.Name)
                        switch (Qt.name) {
                          case "ON":
                          case "OFF":
                          case "Toggle":
                            Tt.push(Qt.name);
                            break;
                        }
                      else
                        Qt instanceof lt.Ref && Tt.push(Qt.toString());
                    if (Tt.length !== Lt.length)
                      break;
                    bt.setOCGState = {
                      state: Tt,
                      preserveRB: typeof $t == "boolean" ? $t : !0
                    };
                    break;
                  case "JavaScript":
                    const Dt = Bt.get("JS");
                    let Ut;
                    Dt instanceof it.BaseStream ? Ut = Dt.getString() : typeof Dt == "string" && (Ut = Dt);
                    const Vt = Ut && (0, rt.recoverJsURL)((0, st.stringToPDFString)(Ut));
                    if (Vt) {
                      Ot = Vt.url, bt.newWindow = Vt.newWindow;
                      break;
                    }
                  default:
                    if (Ct === "JavaScript" || Ct === "SubmitForm")
                      break;
                    (0, st.warn)(`parseDestDictionary - unsupported action: "${Ct}".`);
                    break;
                }
              } else
                xt.has("Dest") && (Pt = xt.get("Dest"));
              if (typeof Ot == "string") {
                const wt = (0, st.createValidAbsoluteUrl)(Ot, Et, {
                  addDefaultProtocol: !0,
                  tryConvertEncoding: !0
                });
                wt && (bt.url = wt.href), bt.unsafeUrl = Ot;
              }
              Pt && (Pt instanceof lt.Name && (Pt = Pt.name), typeof Pt == "string" ? bt.dest = (0, st.stringToPDFString)(Pt) : Array.isArray(Pt) && (bt.dest = Pt));
            }
          }
          at.Catalog = ct;
        },
        /* 218 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.NumberTree = at.NameTree = void 0, ot(140);
          var rt = ot(151), st = ot(145);
          class lt {
            constructor(ft, ht, dt) {
              this.constructor === lt && (0, st.unreachable)("Cannot initialize NameOrNumberTree."), this.root = ft, this.xref = ht, this._type = dt;
            }
            getAll() {
              const ft = /* @__PURE__ */ new Map();
              if (!this.root)
                return ft;
              const ht = this.xref, dt = new rt.RefSet();
              dt.put(this.root);
              const gt = [this.root];
              for (; gt.length > 0; ) {
                const pt = ht.fetchIfRef(gt.shift());
                if (!(pt instanceof rt.Dict))
                  continue;
                if (pt.has("Kids")) {
                  const ct = pt.get("Kids");
                  if (!Array.isArray(ct))
                    continue;
                  for (const vt of ct) {
                    if (dt.has(vt))
                      throw new st.FormatError(`Duplicate entry in "${this._type}" tree.`);
                    gt.push(vt), dt.put(vt);
                  }
                  continue;
                }
                const mt = pt.get(this._type);
                if (Array.isArray(mt))
                  for (let ct = 0, vt = mt.length; ct < vt; ct += 2)
                    ft.set(ht.fetchIfRef(mt[ct]), ht.fetchIfRef(mt[ct + 1]));
              }
              return ft;
            }
            get(ft) {
              if (!this.root)
                return null;
              const ht = this.xref;
              let dt = ht.fetchIfRef(this.root), gt = 0;
              const pt = 10;
              for (; dt.has("Kids"); ) {
                if (++gt > pt)
                  return (0, st.warn)(`Search depth limit reached for "${this._type}" tree.`), null;
                const ct = dt.get("Kids");
                if (!Array.isArray(ct))
                  return null;
                let vt = 0, At = ct.length - 1;
                for (; vt <= At; ) {
                  const xt = vt + At >> 1, bt = ht.fetchIfRef(ct[xt]), Et = bt.get("Limits");
                  if (ft < ht.fetchIfRef(Et[0]))
                    At = xt - 1;
                  else if (ft > ht.fetchIfRef(Et[1]))
                    vt = xt + 1;
                  else {
                    dt = bt;
                    break;
                  }
                }
                if (vt > At)
                  return null;
              }
              const mt = dt.get(this._type);
              if (Array.isArray(mt)) {
                let ct = 0, vt = mt.length - 2;
                for (; ct <= vt; ) {
                  const At = ct + vt >> 1, xt = At + (At & 1), bt = ht.fetchIfRef(mt[xt]);
                  if (ft < bt)
                    vt = xt - 2;
                  else if (ft > bt)
                    ct = xt + 2;
                  else
                    return ht.fetchIfRef(mt[xt + 1]);
                }
              }
              return null;
            }
          }
          class et extends lt {
            constructor(ft, ht) {
              super(ft, ht, "Names");
            }
          }
          at.NameTree = et;
          class it extends lt {
            constructor(ft, ht) {
              super(ft, ht, "Nums");
            }
          }
          at.NumberTree = it;
        },
        /* 219 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.clearGlobalCaches = et;
          var rt = ot(201), st = ot(151), lt = ot(191);
          function et() {
            (0, rt.clearPatternCaches)(), (0, st.clearPrimitiveCaches)(), (0, lt.clearUnicodeCaches)();
          }
        },
        /* 220 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.FileSpec = void 0;
          var rt = ot(145), st = ot(152), lt = ot(151);
          function et(ut) {
            return ut.has("UF") ? ut.get("UF") : ut.has("F") ? ut.get("F") : ut.has("Unix") ? ut.get("Unix") : ut.has("Mac") ? ut.get("Mac") : ut.has("DOS") ? ut.get("DOS") : null;
          }
          class it {
            constructor(ft, ht) {
              ft instanceof lt.Dict && (this.xref = ht, this.root = ft, ft.has("FS") && (this.fs = ft.get("FS")), this.description = ft.has("Desc") ? (0, rt.stringToPDFString)(ft.get("Desc")) : "", ft.has("RF") && (0, rt.warn)("Related file specifications are not supported"), this.contentAvailable = !0, ft.has("EF") || (this.contentAvailable = !1, (0, rt.warn)("Non-embedded file specifications are not supported")));
            }
            get filename() {
              if (!this._filename && this.root) {
                const ft = et(this.root) || "unnamed";
                this._filename = (0, rt.stringToPDFString)(ft).replaceAll("\\\\", "\\").replaceAll("\\/", "/").replaceAll("\\", "/");
              }
              return this._filename;
            }
            get content() {
              if (!this.contentAvailable)
                return null;
              !this.contentRef && this.root && (this.contentRef = et(this.root.get("EF")));
              let ft = null;
              if (this.contentRef) {
                const ht = this.xref.fetchIfRef(this.contentRef);
                ht instanceof st.BaseStream ? ft = ht.getBytes() : (0, rt.warn)("Embedded file specification points to non-existing/invalid content");
              } else
                (0, rt.warn)("Embedded file specification does not have a content");
              return ft;
            }
            get serializable() {
              return {
                filename: this.filename,
                content: this.content
              };
            }
          }
          at.FileSpec = it;
        },
        /* 221 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.MetadataParser = void 0, ot(2), ot(140);
          var rt = ot(222);
          class st {
            constructor(et) {
              et = this._repair(et);
              const ut = new rt.SimpleXMLParser({
                lowerCaseName: !0
              }).parseFromString(et);
              this._metadataMap = /* @__PURE__ */ new Map(), this._data = et, ut && this._parse(ut);
            }
            _repair(et) {
              return et.replace(/^[^<]+/, "").replaceAll(/>\\376\\377([^<]+)/g, function(it, ut) {
                const ft = ut.replaceAll(/\\([0-3])([0-7])([0-7])/g, function(dt, gt, pt, mt) {
                  return String.fromCharCode(gt * 64 + pt * 8 + mt * 1);
                }).replaceAll(/&(amp|apos|gt|lt|quot);/g, function(dt, gt) {
                  switch (gt) {
                    case "amp":
                      return "&";
                    case "apos":
                      return "'";
                    case "gt":
                      return ">";
                    case "lt":
                      return "<";
                    case "quot":
                      return '"';
                  }
                  throw new Error(`_repair: ${gt} isn't defined.`);
                }), ht = [">"];
                for (let dt = 0, gt = ft.length; dt < gt; dt += 2) {
                  const pt = ft.charCodeAt(dt) * 256 + ft.charCodeAt(dt + 1);
                  pt >= 32 && pt < 127 && pt !== 60 && pt !== 62 && pt !== 38 ? ht.push(String.fromCharCode(pt)) : ht.push("&#x" + (65536 + pt).toString(16).substring(1) + ";");
                }
                return ht.join("");
              });
            }
            _getSequence(et) {
              const it = et.nodeName;
              return it !== "rdf:bag" && it !== "rdf:seq" && it !== "rdf:alt" ? null : et.childNodes.filter((ut) => ut.nodeName === "rdf:li");
            }
            _parseArray(et) {
              if (!et.hasChildNodes())
                return;
              const [it] = et.childNodes, ut = this._getSequence(it) || [];
              this._metadataMap.set(et.nodeName, ut.map((ft) => ft.textContent.trim()));
            }
            _parse(et) {
              let it = et.documentElement;
              if (it.nodeName !== "rdf:rdf")
                for (it = it.firstChild; it && it.nodeName !== "rdf:rdf"; )
                  it = it.nextSibling;
              if (!(!it || it.nodeName !== "rdf:rdf" || !it.hasChildNodes())) {
                for (const ut of it.childNodes)
                  if (ut.nodeName === "rdf:description")
                    for (const ft of ut.childNodes) {
                      const ht = ft.nodeName;
                      switch (ht) {
                        case "#text":
                          continue;
                        case "dc:creator":
                        case "dc:subject":
                          this._parseArray(ft);
                          continue;
                      }
                      this._metadataMap.set(ht, ft.textContent.trim());
                    }
              }
            }
            get serializable() {
              return {
                parsedData: this._metadataMap,
                rawData: this._data
              };
            }
          }
          at.MetadataParser = st;
        },
        /* 222 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.XMLParserErrorCode = at.XMLParserBase = at.SimpleXMLParser = at.SimpleDOMNode = void 0, ot(140);
          var rt = ot(150);
          const st = {
            NoError: 0,
            EndOfDocument: -1,
            UnterminatedCdat: -2,
            UnterminatedXmlDeclaration: -3,
            UnterminatedDoctypeDeclaration: -4,
            UnterminatedComment: -5,
            MalformedElement: -6,
            OutOfMemory: -7,
            UnterminatedAttributeValue: -8,
            UnterminatedElement: -9,
            ElementNeverBegun: -10
          };
          at.XMLParserErrorCode = st;
          function lt(ht, dt) {
            const gt = ht[dt];
            return gt === " " || gt === `
` || gt === "\r" || gt === "	";
          }
          function et(ht) {
            for (let dt = 0, gt = ht.length; dt < gt; dt++)
              if (!lt(ht, dt))
                return !1;
            return !0;
          }
          class it {
            _resolveEntities(dt) {
              return dt.replaceAll(/&([^;]+);/g, (gt, pt) => {
                if (pt.substring(0, 2) === "#x")
                  return String.fromCodePoint(parseInt(pt.substring(2), 16));
                if (pt.substring(0, 1) === "#")
                  return String.fromCodePoint(parseInt(pt.substring(1), 10));
                switch (pt) {
                  case "lt":
                    return "<";
                  case "gt":
                    return ">";
                  case "amp":
                    return "&";
                  case "quot":
                    return '"';
                  case "apos":
                    return "'";
                }
                return this.onResolveEntity(pt);
              });
            }
            _parseContent(dt, gt) {
              const pt = [];
              let mt = gt;
              function ct() {
                for (; mt < dt.length && lt(dt, mt); )
                  ++mt;
              }
              for (; mt < dt.length && !lt(dt, mt) && dt[mt] !== ">" && dt[mt] !== "/"; )
                ++mt;
              const vt = dt.substring(gt, mt);
              for (ct(); mt < dt.length && dt[mt] !== ">" && dt[mt] !== "/" && dt[mt] !== "?"; ) {
                ct();
                let At = "", xt = "";
                for (; mt < dt.length && !lt(dt, mt) && dt[mt] !== "="; )
                  At += dt[mt], ++mt;
                if (ct(), dt[mt] !== "=")
                  return null;
                ++mt, ct();
                const bt = dt[mt];
                if (bt !== '"' && bt !== "'")
                  return null;
                const Et = dt.indexOf(bt, ++mt);
                if (Et < 0)
                  return null;
                xt = dt.substring(mt, Et), pt.push({
                  name: At,
                  value: this._resolveEntities(xt)
                }), mt = Et + 1, ct();
              }
              return {
                name: vt,
                attributes: pt,
                parsed: mt - gt
              };
            }
            _parseProcessingInstruction(dt, gt) {
              let pt = gt;
              function mt() {
                for (; pt < dt.length && lt(dt, pt); )
                  ++pt;
              }
              for (; pt < dt.length && !lt(dt, pt) && dt[pt] !== ">" && dt[pt] !== "?" && dt[pt] !== "/"; )
                ++pt;
              const ct = dt.substring(gt, pt);
              mt();
              const vt = pt;
              for (; pt < dt.length && (dt[pt] !== "?" || dt[pt + 1] !== ">"); )
                ++pt;
              const At = dt.substring(vt, pt);
              return {
                name: ct,
                value: At,
                parsed: pt - gt
              };
            }
            parseXml(dt) {
              let gt = 0;
              for (; gt < dt.length; ) {
                const pt = dt[gt];
                let mt = gt;
                if (pt === "<") {
                  ++mt;
                  const ct = dt[mt];
                  let vt;
                  switch (ct) {
                    case "/":
                      if (++mt, vt = dt.indexOf(">", mt), vt < 0) {
                        this.onError(st.UnterminatedElement);
                        return;
                      }
                      this.onEndElement(dt.substring(mt, vt)), mt = vt + 1;
                      break;
                    case "?":
                      ++mt;
                      const At = this._parseProcessingInstruction(dt, mt);
                      if (dt.substring(mt + At.parsed, mt + At.parsed + 2) !== "?>") {
                        this.onError(st.UnterminatedXmlDeclaration);
                        return;
                      }
                      this.onPi(At.name, At.value), mt += At.parsed + 2;
                      break;
                    case "!":
                      if (dt.substring(mt + 1, mt + 3) === "--") {
                        if (vt = dt.indexOf("-->", mt + 3), vt < 0) {
                          this.onError(st.UnterminatedComment);
                          return;
                        }
                        this.onComment(dt.substring(mt + 3, vt)), mt = vt + 3;
                      } else if (dt.substring(mt + 1, mt + 8) === "[CDATA[") {
                        if (vt = dt.indexOf("]]>", mt + 8), vt < 0) {
                          this.onError(st.UnterminatedCdat);
                          return;
                        }
                        this.onCdata(dt.substring(mt + 8, vt)), mt = vt + 3;
                      } else if (dt.substring(mt + 1, mt + 8) === "DOCTYPE") {
                        const Et = dt.indexOf("[", mt + 8);
                        let St = !1;
                        if (vt = dt.indexOf(">", mt + 8), vt < 0) {
                          this.onError(st.UnterminatedDoctypeDeclaration);
                          return;
                        }
                        if (Et > 0 && vt > Et) {
                          if (vt = dt.indexOf("]>", mt + 8), vt < 0) {
                            this.onError(st.UnterminatedDoctypeDeclaration);
                            return;
                          }
                          St = !0;
                        }
                        const Bt = dt.substring(mt + 8, vt + (St ? 1 : 0));
                        this.onDoctype(Bt), mt = vt + (St ? 2 : 1);
                      } else {
                        this.onError(st.MalformedElement);
                        return;
                      }
                      break;
                    default:
                      const xt = this._parseContent(dt, mt);
                      if (xt === null) {
                        this.onError(st.MalformedElement);
                        return;
                      }
                      let bt = !1;
                      if (dt.substring(mt + xt.parsed, mt + xt.parsed + 2) === "/>")
                        bt = !0;
                      else if (dt.substring(mt + xt.parsed, mt + xt.parsed + 1) !== ">") {
                        this.onError(st.UnterminatedElement);
                        return;
                      }
                      this.onBeginElement(xt.name, xt.attributes, bt), mt += xt.parsed + (bt ? 2 : 1);
                      break;
                  }
                } else {
                  for (; mt < dt.length && dt[mt] !== "<"; )
                    mt++;
                  const ct = dt.substring(gt, mt);
                  this.onText(this._resolveEntities(ct));
                }
                gt = mt;
              }
            }
            onResolveEntity(dt) {
              return `&${dt};`;
            }
            onPi(dt, gt) {
            }
            onComment(dt) {
            }
            onCdata(dt) {
            }
            onDoctype(dt) {
            }
            onText(dt) {
            }
            onBeginElement(dt, gt, pt) {
            }
            onEndElement(dt) {
            }
            onError(dt) {
            }
          }
          at.XMLParserBase = it;
          class ut {
            constructor(dt, gt) {
              this.nodeName = dt, this.nodeValue = gt, Object.defineProperty(this, "parentNode", {
                value: null,
                writable: !0
              });
            }
            get firstChild() {
              var dt;
              return (dt = this.childNodes) == null ? void 0 : dt[0];
            }
            get nextSibling() {
              const dt = this.parentNode.childNodes;
              if (!dt)
                return;
              const gt = dt.indexOf(this);
              if (gt !== -1)
                return dt[gt + 1];
            }
            get textContent() {
              return this.childNodes ? this.childNodes.map(function(dt) {
                return dt.textContent;
              }).join("") : this.nodeValue || "";
            }
            get children() {
              return this.childNodes || [];
            }
            hasChildNodes() {
              var dt;
              return ((dt = this.childNodes) == null ? void 0 : dt.length) > 0;
            }
            searchNode(dt, gt) {
              var vt;
              if (gt >= dt.length)
                return this;
              const pt = dt[gt];
              if (pt.name.startsWith("#") && gt < dt.length - 1)
                return this.searchNode(dt, gt + 1);
              const mt = [];
              let ct = this;
              for (; ; ) {
                if (pt.name === ct.nodeName)
                  if (pt.pos === 0) {
                    const At = ct.searchNode(dt, gt + 1);
                    if (At !== null)
                      return At;
                  } else {
                    if (mt.length === 0)
                      return null;
                    {
                      const [At] = mt.pop();
                      let xt = 0;
                      for (const bt of At.childNodes)
                        if (pt.name === bt.nodeName) {
                          if (xt === pt.pos)
                            return bt.searchNode(dt, gt + 1);
                          xt++;
                        }
                      return ct.searchNode(dt, gt + 1);
                    }
                  }
                if (((vt = ct.childNodes) == null ? void 0 : vt.length) > 0)
                  mt.push([ct, 0]), ct = ct.childNodes[0];
                else {
                  if (mt.length === 0)
                    return null;
                  for (; mt.length !== 0; ) {
                    const [At, xt] = mt.pop(), bt = xt + 1;
                    if (bt < At.childNodes.length) {
                      mt.push([At, bt]), ct = At.childNodes[bt];
                      break;
                    }
                  }
                  if (mt.length === 0)
                    return null;
                }
              }
            }
            dump(dt) {
              if (this.nodeName === "#text") {
                dt.push((0, rt.encodeToXmlString)(this.nodeValue));
                return;
              }
              if (dt.push(`<${this.nodeName}`), this.attributes)
                for (const gt of this.attributes)
                  dt.push(` ${gt.name}="${(0, rt.encodeToXmlString)(gt.value)}"`);
              if (this.hasChildNodes()) {
                dt.push(">");
                for (const gt of this.childNodes)
                  gt.dump(dt);
                dt.push(`</${this.nodeName}>`);
              } else
                this.nodeValue ? dt.push(`>${(0, rt.encodeToXmlString)(this.nodeValue)}</${this.nodeName}>`) : dt.push("/>");
            }
          }
          at.SimpleDOMNode = ut;
          class ft extends it {
            constructor(dt) {
              let {
                hasAttributes: gt = !1,
                lowerCaseName: pt = !1
              } = dt;
              super(), this._currentFragment = null, this._stack = null, this._errorCode = st.NoError, this._hasAttributes = gt, this._lowerCaseName = pt;
            }
            parseFromString(dt) {
              if (this._currentFragment = [], this._stack = [], this._errorCode = st.NoError, this.parseXml(dt), this._errorCode !== st.NoError)
                return;
              const [gt] = this._currentFragment;
              if (gt)
                return {
                  documentElement: gt
                };
            }
            onText(dt) {
              if (et(dt))
                return;
              const gt = new ut("#text", dt);
              this._currentFragment.push(gt);
            }
            onCdata(dt) {
              const gt = new ut("#text", dt);
              this._currentFragment.push(gt);
            }
            onBeginElement(dt, gt, pt) {
              this._lowerCaseName && (dt = dt.toLowerCase());
              const mt = new ut(dt);
              mt.childNodes = [], this._hasAttributes && (mt.attributes = gt), this._currentFragment.push(mt), !pt && (this._stack.push(this._currentFragment), this._currentFragment = mt.childNodes);
            }
            onEndElement(dt) {
              this._currentFragment = this._stack.pop() || [];
              const gt = this._currentFragment.at(-1);
              if (!gt)
                return null;
              for (const pt of gt.childNodes)
                pt.parentNode = gt;
              return gt;
            }
            onError(dt) {
              this._errorCode = dt;
            }
          }
          at.SimpleXMLParser = ft;
        },
        /* 223 */
        /***/
        (nt, at, ot) => {
          var pt, yl, ct, Ts, At, El, bt, Cl;
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.StructTreeRoot = at.StructTreePage = void 0, ot(140);
          var rt = ot(145), st = ot(151), lt = ot(218), et = ot(224);
          const it = 40, ut = {
            PAGE_CONTENT: 1,
            STREAM_CONTENT: 2,
            OBJECT: 3,
            ANNOTATION: 4,
            ELEMENT: 5
          }, St = class St {
            constructor(Ot, Pt) {
              _r(this, pt);
              this.dict = Ot, this.ref = Pt instanceof st.Ref ? Pt : null, this.roleMap = /* @__PURE__ */ new Map(), this.structParentIds = null;
            }
            init() {
              this.readRoleMap();
            }
            addAnnotationIdToPage(Ot, Pt) {
              Ur(this, pt, yl).call(this, Ot, Pt, ut.ANNOTATION);
            }
            readRoleMap() {
              const Ot = this.dict.get("RoleMap");
              Ot instanceof st.Dict && Ot.forEach((Pt, wt) => {
                wt instanceof st.Name && this.roleMap.set(Pt, wt.name);
              });
            }
            static async canCreateStructureTree(Ot) {
              var Rt;
              let {
                catalogRef: Pt,
                pdfManager: wt,
                newAnnotationsByPage: Ct
              } = Ot;
              if (!(Pt instanceof st.Ref))
                return (0, rt.warn)("Cannot save the struct tree: no catalog reference."), !1;
              let It = 0, yt = !0;
              for (const [kt, jt] of Ct) {
                const {
                  ref: Ht
                } = await wt.getPage(kt);
                if (!(Ht instanceof st.Ref)) {
                  (0, rt.warn)(`Cannot save the struct tree: page ${kt} has no ref.`), yt = !0;
                  break;
                }
                for (const Ft of jt)
                  (Rt = Ft.accessibilityData) != null && Rt.type && (Ft.parentTreeId = It++, yt = !1);
              }
              if (yt) {
                for (const kt of Ct.values())
                  for (const jt of kt)
                    delete jt.parentTreeId;
                return !1;
              }
              return !0;
            }
            static async createStructureTree(Ot) {
              let {
                newAnnotationsByPage: Pt,
                xref: wt,
                catalogRef: Ct,
                pdfManager: It,
                newRefs: yt
              } = Ot;
              const Rt = It.catalog.cloneDict(), kt = wt.getNewTemporaryRef();
              Rt.set("StructTreeRoot", kt);
              const jt = [];
              await (0, et.writeObject)(Ct, Rt, jt, wt), yt.push({
                ref: Ct,
                data: jt.join("")
              });
              const Ht = new st.Dict(wt);
              Ht.set("Type", st.Name.get("StructTreeRoot"));
              const Ft = wt.getNewTemporaryRef();
              Ht.set("ParentTree", Ft);
              const _t = [];
              Ht.set("K", _t);
              const Nt = new st.Dict(wt), Mt = [];
              Nt.set("Nums", Mt);
              const Lt = await Ur(this, ct, Ts).call(this, {
                newAnnotationsByPage: Pt,
                structTreeRootRef: kt,
                kids: _t,
                nums: Mt,
                xref: wt,
                pdfManager: It,
                newRefs: yt,
                buffer: jt
              });
              Ht.set("ParentTreeNextKey", Lt), jt.length = 0, await (0, et.writeObject)(Ft, Nt, jt, wt), yt.push({
                ref: Ft,
                data: jt.join("")
              }), jt.length = 0, await (0, et.writeObject)(kt, Ht, jt, wt), yt.push({
                ref: kt,
                data: jt.join("")
              });
            }
            async canUpdateStructTree(Ot) {
              var jt, Ht;
              let {
                pdfManager: Pt,
                newAnnotationsByPage: wt
              } = Ot;
              if (!this.ref)
                return (0, rt.warn)("Cannot update the struct tree: no root reference."), !1;
              let Ct = this.dict.get("ParentTreeNextKey");
              if (!Number.isInteger(Ct) || Ct < 0)
                return (0, rt.warn)("Cannot update the struct tree: invalid next key."), !1;
              const It = this.dict.get("ParentTree");
              if (!(It instanceof st.Dict))
                return (0, rt.warn)("Cannot update the struct tree: ParentTree isn't a dict."), !1;
              const yt = It.get("Nums");
              if (!Array.isArray(yt))
                return (0, rt.warn)("Cannot update the struct tree: nums isn't an array."), !1;
              const {
                numPages: Rt
              } = Pt.catalog;
              for (const Ft of wt.keys()) {
                const {
                  pageDict: _t,
                  ref: Nt
                } = await Pt.getPage(Ft);
                if (!(Nt instanceof st.Ref))
                  return (0, rt.warn)(`Cannot save the struct tree: page ${Ft} has no ref.`), !1;
                const Mt = _t.get("StructParents");
                if (!Number.isInteger(Mt) || Mt < 0 || Mt >= Rt)
                  return (0, rt.warn)(`Cannot save the struct tree: page ${Ft} has no id.`), !1;
              }
              let kt = !0;
              for (const [Ft, _t] of wt) {
                const {
                  pageDict: Nt
                } = await Pt.getPage(Ft);
                Ur(jt = St, At, El).call(jt, {
                  elements: _t,
                  xref: this.dict.xref,
                  pageDict: Nt,
                  parentTree: It
                });
                for (const Mt of _t)
                  (Ht = Mt.accessibilityData) != null && Ht.type && (Mt.parentTreeId = Ct++, kt = !1);
              }
              if (kt) {
                for (const Ft of wt.values())
                  for (const _t of Ft)
                    delete _t.parentTreeId, delete _t.structTreeParent;
                return !1;
              }
              return !0;
            }
            async updateStructureTree(Ot) {
              var $t;
              let {
                newAnnotationsByPage: Pt,
                pdfManager: wt,
                newRefs: Ct
              } = Ot;
              const It = this.dict.xref, yt = this.dict.clone(), Rt = this.ref;
              let kt = yt.getRaw("ParentTree"), jt;
              kt instanceof st.Ref ? jt = It.fetch(kt) : (jt = kt, kt = It.getNewTemporaryRef(), yt.set("ParentTree", kt)), jt = jt.clone();
              let Ht = jt.getRaw("Nums"), Ft = null;
              Ht instanceof st.Ref && (Ft = Ht, Ht = It.fetch(Ft)), Ht = Ht.slice(), Ft || jt.set("Nums", Ht);
              let _t = yt.getRaw("K"), Nt = null;
              _t instanceof st.Ref ? (Nt = _t, _t = It.fetch(Nt)) : (Nt = It.getNewTemporaryRef(), yt.set("K", Nt)), _t = Array.isArray(_t) ? _t.slice() : [_t];
              const Mt = [], Lt = await Ur($t = St, ct, Ts).call($t, {
                newAnnotationsByPage: Pt,
                structTreeRootRef: Rt,
                kids: _t,
                nums: Ht,
                xref: It,
                pdfManager: wt,
                newRefs: Ct,
                buffer: Mt
              });
              yt.set("ParentTreeNextKey", Lt), Mt.length = 0, await (0, et.writeObject)(Nt, _t, Mt, It), Ct.push({
                ref: Nt,
                data: Mt.join("")
              }), Ft && (Mt.length = 0, await (0, et.writeObject)(Ft, Ht, Mt, It), Ct.push({
                ref: Ft,
                data: Mt.join("")
              })), Mt.length = 0, await (0, et.writeObject)(kt, jt, Mt, It), Ct.push({
                ref: kt,
                data: Mt.join("")
              }), Mt.length = 0, await (0, et.writeObject)(Rt, yt, Mt, It), Ct.push({
                ref: Rt,
                data: Mt.join("")
              });
            }
          };
          pt = new WeakSet(), yl = function(Ot, Pt, wt) {
            if (!(Ot instanceof st.Ref) || Pt < 0)
              return;
            this.structParentIds || (this.structParentIds = new st.RefSetCache());
            let Ct = this.structParentIds.get(Ot);
            Ct || (Ct = [], this.structParentIds.put(Ot, Ct)), Ct.push([Pt, wt]);
          }, ct = new WeakSet(), Ts = async function(Ot) {
            let {
              newAnnotationsByPage: Pt,
              structTreeRootRef: wt,
              kids: Ct,
              nums: It,
              xref: yt,
              pdfManager: Rt,
              newRefs: kt,
              buffer: jt
            } = Ot;
            const Ht = st.Name.get("OBJR");
            let Ft = -1 / 0;
            for (const [_t, Nt] of Pt) {
              const {
                ref: Mt
              } = await Rt.getPage(_t);
              for (const {
                accessibilityData: {
                  type: Lt,
                  title: $t,
                  lang: Tt,
                  alt: Dt,
                  expanded: Ut,
                  actualText: Vt
                },
                ref: Qt,
                parentTreeId: qt,
                structTreeParent: Zt
              } of Nt) {
                Ft = Math.max(Ft, qt);
                const ar = yt.getNewTemporaryRef(), Jt = new st.Dict(yt);
                Jt.set("S", st.Name.get(Lt)), $t && Jt.set("T", $t), Tt && Jt.set("Lang", Tt), Dt && Jt.set("Alt", Dt), Ut && Jt.set("E", Ut), Vt && Jt.set("ActualText", Vt), Zt ? await Ur(this, bt, Cl).call(this, {
                  structTreeParent: Zt,
                  tagDict: Jt,
                  newTagRef: ar,
                  fallbackRef: wt,
                  xref: yt,
                  newRefs: kt,
                  buffer: jt
                }) : Jt.set("P", wt);
                const rr = new st.Dict(yt);
                Jt.set("K", rr), rr.set("Type", Ht), rr.set("Pg", Mt), rr.set("Obj", Qt), jt.length = 0, await (0, et.writeObject)(ar, Jt, jt, yt), kt.push({
                  ref: ar,
                  data: jt.join("")
                }), It.push(qt, ar), Ct.push(ar);
              }
            }
            return Ft + 1;
          }, At = new WeakSet(), El = function(Ot) {
            let {
              elements: Pt,
              xref: wt,
              pageDict: Ct,
              parentTree: It
            } = Ot;
            const yt = /* @__PURE__ */ new Map();
            for (const Ft of Pt)
              if (Ft.structTreeParentId) {
                const _t = parseInt(Ft.structTreeParentId.split("_mc")[1], 10);
                yt.set(_t, Ft);
              }
            const Rt = Ct.get("StructParents"), jt = new lt.NumberTree(It, wt).get(Rt);
            if (!Array.isArray(jt))
              return;
            const Ht = (Ft, _t, Nt) => {
              const Mt = yt.get(Ft);
              if (Mt) {
                const Lt = _t.getRaw("P"), $t = wt.fetchIfRef(Lt);
                return Lt instanceof st.Ref && $t instanceof st.Dict && (Mt.structTreeParent = {
                  ref: Nt,
                  dict: _t
                }), !0;
              }
              return !1;
            };
            for (const Ft of jt) {
              if (!(Ft instanceof st.Ref))
                continue;
              const _t = wt.fetch(Ft), Nt = _t.get("K");
              if (Number.isInteger(Nt)) {
                Ht(Nt, _t, Ft);
                continue;
              }
              if (Array.isArray(Nt)) {
                for (let Mt of Nt)
                  if (Mt = wt.fetchIfRef(Mt), Number.isInteger(Mt) && Ht(Mt, _t, Ft))
                    break;
              }
            }
          }, bt = new WeakSet(), Cl = async function(Ot) {
            let {
              structTreeParent: {
                ref: Pt,
                dict: wt
              },
              tagDict: Ct,
              newTagRef: It,
              fallbackRef: yt,
              xref: Rt,
              newRefs: kt,
              buffer: jt
            } = Ot;
            const Ht = wt.getRaw("P");
            let Ft = Rt.fetchIfRef(Ht);
            Ct.set("P", Ht);
            let _t = !1, Nt, Mt = Ft.getRaw("K");
            if (Mt instanceof st.Ref ? Nt = Rt.fetch(Mt) : (Nt = Mt, Mt = Rt.getNewTemporaryRef(), Ft = Ft.clone(), Ft.set("K", Mt), _t = !0), Array.isArray(Nt)) {
              const Lt = Nt.indexOf(Pt);
              if (Lt >= 0)
                Nt = Nt.slice(), Nt.splice(Lt + 1, 0, It);
              else {
                (0, rt.warn)("Cannot update the struct tree: parent kid not found."), Ct.set("P", yt);
                return;
              }
            } else
              Nt instanceof st.Dict && (Nt = [Mt, It], Mt = Rt.getNewTemporaryRef(), Ft.set("K", Mt), _t = !0);
            jt.length = 0, await (0, et.writeObject)(Mt, Nt, jt, Rt), kt.push({
              ref: Mt,
              data: jt.join("")
            }), _t && (jt.length = 0, await (0, et.writeObject)(Ht, Ft, jt, Rt), kt.push({
              ref: Ht,
              data: jt.join("")
            }));
          }, _r(St, ct), _r(St, At), _r(St, bt);
          let ft = St;
          at.StructTreeRoot = ft;
          class ht {
            constructor(Ot, Pt) {
              this.tree = Ot, this.dict = Pt, this.kids = [], this.parseKids();
            }
            get role() {
              const Ot = this.dict.get("S"), Pt = Ot instanceof st.Name ? Ot.name : "", {
                root: wt
              } = this.tree;
              return wt.roleMap.has(Pt) ? wt.roleMap.get(Pt) : Pt;
            }
            parseKids() {
              let Ot = null;
              const Pt = this.dict.getRaw("Pg");
              Pt instanceof st.Ref && (Ot = Pt.toString());
              const wt = this.dict.get("K");
              if (Array.isArray(wt))
                for (const Ct of wt) {
                  const It = this.parseKid(Ot, Ct);
                  It && this.kids.push(It);
                }
              else {
                const Ct = this.parseKid(Ot, wt);
                Ct && this.kids.push(Ct);
              }
            }
            parseKid(Ot, Pt) {
              if (Number.isInteger(Pt))
                return this.tree.pageDict.objId !== Ot ? null : new dt({
                  type: ut.PAGE_CONTENT,
                  mcid: Pt,
                  pageObjId: Ot
                });
              let wt = null;
              if (Pt instanceof st.Ref ? wt = this.dict.xref.fetch(Pt) : Pt instanceof st.Dict && (wt = Pt), !wt)
                return null;
              const Ct = wt.getRaw("Pg");
              Ct instanceof st.Ref && (Ot = Ct.toString());
              const It = wt.get("Type") instanceof st.Name ? wt.get("Type").name : null;
              if (It === "MCR") {
                if (this.tree.pageDict.objId !== Ot)
                  return null;
                const yt = wt.getRaw("Stm");
                return new dt({
                  type: ut.STREAM_CONTENT,
                  refObjId: yt instanceof st.Ref ? yt.toString() : null,
                  pageObjId: Ot,
                  mcid: wt.get("MCID")
                });
              }
              if (It === "OBJR") {
                if (this.tree.pageDict.objId !== Ot)
                  return null;
                const yt = wt.getRaw("Obj");
                return new dt({
                  type: ut.OBJECT,
                  refObjId: yt instanceof st.Ref ? yt.toString() : null,
                  pageObjId: Ot
                });
              }
              return new dt({
                type: ut.ELEMENT,
                dict: wt
              });
            }
          }
          class dt {
            constructor(Ot) {
              let {
                type: Pt,
                dict: wt = null,
                mcid: Ct = null,
                pageObjId: It = null,
                refObjId: yt = null
              } = Ot;
              this.type = Pt, this.dict = wt, this.mcid = Ct, this.pageObjId = It, this.refObjId = yt, this.parentNode = null;
            }
          }
          class gt {
            constructor(Ot, Pt) {
              this.root = Ot, this.rootDict = Ot ? Ot.dict : null, this.pageDict = Pt, this.nodes = [];
            }
            parse(Ot) {
              var Rt, kt;
              if (!this.root || !this.rootDict)
                return;
              const Pt = this.rootDict.get("ParentTree");
              if (!Pt)
                return;
              const wt = this.pageDict.get("StructParents"), Ct = Ot instanceof st.Ref && ((Rt = this.root.structParentIds) == null ? void 0 : Rt.get(Ot));
              if (!Number.isInteger(wt) && !Ct)
                return;
              const It = /* @__PURE__ */ new Map(), yt = new lt.NumberTree(Pt, this.rootDict.xref);
              if (Number.isInteger(wt)) {
                const jt = yt.get(wt);
                if (Array.isArray(jt))
                  for (const Ht of jt)
                    Ht instanceof st.Ref && this.addNode(this.rootDict.xref.fetch(Ht), It);
              }
              if (Ct)
                for (const [jt, Ht] of Ct) {
                  const Ft = yt.get(jt);
                  if (Ft) {
                    const _t = this.addNode(this.rootDict.xref.fetchIfRef(Ft), It);
                    ((kt = _t == null ? void 0 : _t.kids) == null ? void 0 : kt.length) === 1 && _t.kids[0].type === ut.OBJECT && (_t.kids[0].type = Ht);
                  }
                }
            }
            addNode(Ot, Pt) {
              let wt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
              if (wt > it)
                return (0, rt.warn)("StructTree MAX_DEPTH reached."), null;
              if (Pt.has(Ot))
                return Pt.get(Ot);
              const Ct = new ht(this, Ot);
              Pt.set(Ot, Ct);
              const It = Ot.get("P");
              if (!It || (0, st.isName)(It.get("Type"), "StructTreeRoot"))
                return this.addTopLevelNode(Ot, Ct) || Pt.delete(Ot), Ct;
              const yt = this.addNode(It, Pt, wt + 1);
              if (!yt)
                return Ct;
              let Rt = !1;
              for (const kt of yt.kids)
                kt.type === ut.ELEMENT && kt.dict === Ot && (kt.parentNode = Ct, Rt = !0);
              return Rt || Pt.delete(Ot), Ct;
            }
            addTopLevelNode(Ot, Pt) {
              const wt = this.rootDict.get("K");
              if (!wt)
                return !1;
              if (wt instanceof st.Dict)
                return wt.objId !== Ot.objId ? !1 : (this.nodes[0] = Pt, !0);
              if (!Array.isArray(wt))
                return !0;
              let Ct = !1;
              for (let It = 0; It < wt.length; It++) {
                const yt = wt[It];
                (yt == null ? void 0 : yt.toString()) === Ot.objId && (this.nodes[It] = Pt, Ct = !0);
              }
              return Ct;
            }
            get serializable() {
              function Ot(wt, Ct) {
                let It = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                if (It > it) {
                  (0, rt.warn)("StructTree too deep to be fully serialized.");
                  return;
                }
                const yt = /* @__PURE__ */ Object.create(null);
                yt.role = wt.role, yt.children = [], Ct.children.push(yt);
                const Rt = wt.dict.get("Alt");
                typeof Rt == "string" && (yt.alt = (0, rt.stringToPDFString)(Rt));
                const kt = wt.dict.get("Lang");
                typeof kt == "string" && (yt.lang = (0, rt.stringToPDFString)(kt));
                for (const jt of wt.kids) {
                  const Ht = jt.type === ut.ELEMENT ? jt.parentNode : null;
                  if (Ht) {
                    Ot(Ht, yt, It + 1);
                    continue;
                  } else
                    jt.type === ut.PAGE_CONTENT || jt.type === ut.STREAM_CONTENT ? yt.children.push({
                      type: "content",
                      id: `p${jt.pageObjId}_mc${jt.mcid}`
                    }) : jt.type === ut.OBJECT ? yt.children.push({
                      type: "object",
                      id: jt.refObjId
                    }) : jt.type === ut.ANNOTATION && yt.children.push({
                      type: "annotation",
                      id: `${rt.AnnotationPrefix}${jt.refObjId}`
                    });
                }
              }
              const Pt = /* @__PURE__ */ Object.create(null);
              Pt.children = [], Pt.role = "Root";
              for (const wt of this.nodes)
                wt && Ot(wt, Pt);
              return Pt;
            }
          }
          at.StructTreePage = gt;
        },
        /* 224 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.incrementalUpdate = Et, at.writeDict = ht, at.writeObject = ft, ot(140), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115);
          var rt = ot(145), st = ot(151), lt = ot(150), et = ot(222), it = ot(152), ut = ot(225);
          async function ft(St, Bt, Ot, Pt) {
            let {
              encrypt: wt = null
            } = Pt;
            const Ct = wt == null ? void 0 : wt.createCipherTransform(St.num, St.gen);
            Ot.push(`${St.num} ${St.gen} obj
`), Bt instanceof st.Dict ? await ht(Bt, Ot, Ct) : Bt instanceof it.BaseStream ? await dt(Bt, Ot, Ct) : Array.isArray(Bt) && await gt(Bt, Ot, Ct), Ot.push(`
endobj
`);
          }
          async function ht(St, Bt, Ot) {
            Bt.push("<<");
            for (const Pt of St.getKeys())
              Bt.push(` /${(0, lt.escapePDFName)(Pt)} `), await pt(St.getRaw(Pt), Bt, Ot);
            Bt.push(">>");
          }
          async function dt(St, Bt, Ot) {
            let Pt = St.getString();
            const {
              dict: wt
            } = St, [Ct, It] = await Promise.all([wt.getAsync("Filter"), wt.getAsync("DecodeParms")]), yt = Array.isArray(Ct) ? await wt.xref.fetchIfRefAsync(Ct[0]) : Ct, Rt = (0, st.isName)(yt, "FlateDecode"), kt = 256;
            if (typeof CompressionStream < "u" && (Pt.length >= kt || Rt))
              try {
                const jt = (0, rt.stringToBytes)(Pt), Ht = new CompressionStream("deflate"), Ft = Ht.writable.getWriter();
                Ft.write(jt), Ft.close();
                const _t = await new Response(Ht.readable).arrayBuffer();
                Pt = (0, rt.bytesToString)(new Uint8Array(_t));
                let Nt, Mt;
                Ct ? Rt || (Nt = Array.isArray(Ct) ? [st.Name.get("FlateDecode"), ...Ct] : [st.Name.get("FlateDecode"), Ct], It && (Mt = Array.isArray(It) ? [null, ...It] : [null, It])) : Nt = st.Name.get("FlateDecode"), Nt && wt.set("Filter", Nt), Mt && wt.set("DecodeParms", Mt);
              } catch (jt) {
                (0, rt.info)(`writeStream - cannot compress data: "${jt}".`);
              }
            Ot && (Pt = Ot.encryptString(Pt)), wt.set("Length", Pt.length), await ht(wt, Bt, Ot), Bt.push(` stream
`, Pt, `
endstream`);
          }
          async function gt(St, Bt, Ot) {
            Bt.push("[");
            let Pt = !0;
            for (const wt of St)
              Pt ? Pt = !1 : Bt.push(" "), await pt(wt, Bt, Ot);
            Bt.push("]");
          }
          async function pt(St, Bt, Ot) {
            St instanceof st.Name ? Bt.push(`/${(0, lt.escapePDFName)(St.name)}`) : St instanceof st.Ref ? Bt.push(`${St.num} ${St.gen} R`) : Array.isArray(St) ? await gt(St, Bt, Ot) : typeof St == "string" ? (Ot && (St = Ot.encryptString(St)), Bt.push(`(${(0, lt.escapeString)(St)})`)) : typeof St == "number" ? Bt.push((0, lt.numberToString)(St)) : typeof St == "boolean" ? Bt.push(St.toString()) : St instanceof st.Dict ? await ht(St, Bt, Ot) : St instanceof it.BaseStream ? await dt(St, Bt, Ot) : St === null ? Bt.push("null") : (0, rt.warn)(`Unhandled value in writer: ${typeof St}, please file a bug.`);
          }
          function mt(St, Bt, Ot, Pt) {
            for (let wt = Bt + Ot - 1; wt > Ot - 1; wt--)
              Pt[wt] = St & 255, St >>= 8;
            return Ot + Bt;
          }
          function ct(St, Bt, Ot) {
            for (let Pt = 0, wt = St.length; Pt < wt; Pt++)
              Ot[Bt + Pt] = St.charCodeAt(Pt) & 255;
          }
          function vt(St, Bt) {
            const Ot = Math.floor(Date.now() / 1e3), Pt = Bt.filename || "", wt = [Ot.toString(), Pt, St.toString()];
            let Ct = wt.reduce((Rt, kt) => Rt + kt.length, 0);
            for (const Rt of Object.values(Bt.info))
              wt.push(Rt), Ct += Rt.length;
            const It = new Uint8Array(Ct);
            let yt = 0;
            for (const Rt of wt)
              ct(Rt, yt, It), yt += Rt.length;
            return (0, rt.bytesToString)((0, ut.calculateMD5)(It));
          }
          function At(St, Bt) {
            const Ot = new et.SimpleXMLParser({
              hasAttributes: !0
            }).parseFromString(St);
            for (const {
              xfa: wt
            } of Bt) {
              if (!wt)
                continue;
              const {
                path: Ct,
                value: It
              } = wt;
              if (!Ct)
                continue;
              const yt = (0, lt.parseXFAPath)(Ct);
              let Rt = Ot.documentElement.searchNode(yt, 0);
              !Rt && yt.length > 1 && (Rt = Ot.documentElement.searchNode([yt.at(-1)], 0)), Rt ? Rt.childNodes = Array.isArray(It) ? It.map((kt) => new et.SimpleDOMNode("value", kt)) : [new et.SimpleDOMNode("#text", It)] : (0, rt.warn)(`Node not found for path: ${Ct}`);
            }
            const Pt = [];
            return Ot.documentElement.dump(Pt), Pt.join("");
          }
          async function xt(St) {
            let {
              xref: Bt,
              acroForm: Ot,
              acroFormRef: Pt,
              hasXfa: wt,
              hasXfaDatasetsEntry: Ct,
              xfaDatasetsRef: It,
              needAppearances: yt,
              newRefs: Rt
            } = St;
            if (wt && !Ct && !It && (0, rt.warn)("XFA - Cannot save it"), !yt && (!wt || !It || Ct))
              return;
            const kt = Ot.clone();
            if (wt && !Ct) {
              const Ht = Ot.get("XFA").slice();
              Ht.splice(2, 0, "datasets"), Ht.splice(3, 0, It), kt.set("XFA", Ht);
            }
            yt && kt.set("NeedAppearances", !0);
            const jt = [];
            await ft(Pt, kt, jt, Bt), Rt.push({
              ref: Pt,
              data: jt.join("")
            });
          }
          function bt(St) {
            let {
              xfaData: Bt,
              xfaDatasetsRef: Ot,
              newRefs: Pt,
              xref: wt
            } = St;
            if (Bt === null) {
              const yt = wt.fetchIfRef(Ot);
              Bt = At(yt.getString(), Pt);
            }
            const Ct = wt.encrypt;
            Ct && (Bt = Ct.createCipherTransform(Ot.num, Ot.gen).encryptString(Bt));
            const It = `${Ot.num} ${Ot.gen} obj
<< /Type /EmbeddedFile /Length ${Bt.length}>>
stream
` + Bt + `
endstream
endobj
`;
            Pt.push({
              ref: Ot,
              data: It
            });
          }
          async function Et(St) {
            let {
              originalData: Bt,
              xrefInfo: Ot,
              newRefs: Pt,
              xref: wt = null,
              hasXfa: Ct = !1,
              xfaDatasetsRef: It = null,
              hasXfaDatasetsEntry: yt = !1,
              needAppearances: Rt,
              acroFormRef: kt = null,
              acroForm: jt = null,
              xfaData: Ht = null
            } = St;
            await xt({
              xref: wt,
              acroForm: jt,
              acroFormRef: kt,
              hasXfa: Ct,
              hasXfaDatasetsEntry: yt,
              xfaDatasetsRef: It,
              needAppearances: Rt,
              newRefs: Pt
            }), Ct && bt({
              xfaData: Ht,
              xfaDatasetsRef: It,
              newRefs: Pt,
              xref: wt
            });
            const Ft = new st.Dict(null), _t = Ot.newRef;
            let Nt, Mt;
            const Lt = Bt.at(-1);
            Lt === 10 || Lt === 13 ? (Nt = [], Mt = Bt.length) : (Nt = [`
`], Mt = Bt.length + 1), Ft.set("Size", _t.num + 1), Ft.set("Prev", Ot.startXRef), Ft.set("Type", st.Name.get("XRef")), Ot.rootRef !== null && Ft.set("Root", Ot.rootRef), Ot.infoRef !== null && Ft.set("Info", Ot.infoRef), Ot.encryptRef !== null && Ft.set("Encrypt", Ot.encryptRef), Pt.push({
              ref: _t,
              data: ""
            }), Pt = Pt.sort((Yt, Kt) => Yt.ref.num - Kt.ref.num);
            const $t = [[0, 1, 65535]], Tt = [0, 1];
            let Dt = 0;
            for (const {
              ref: Yt,
              data: Kt
            } of Pt)
              Dt = Math.max(Dt, Mt), $t.push([1, Mt, Math.min(Yt.gen, 65535)]), Mt += Kt.length, Tt.push(Yt.num, 1), Nt.push(Kt);
            if (Ft.set("Index", Tt), Array.isArray(Ot.fileIds) && Ot.fileIds.length > 0) {
              const Yt = vt(Mt, Ot);
              Ft.set("ID", [Ot.fileIds[0], Yt]);
            }
            const Vt = [1, Math.ceil(Math.log2(Dt) / 8), 2], qt = (Vt[0] + Vt[1] + Vt[2]) * $t.length;
            Ft.set("W", Vt), Ft.set("Length", qt), Nt.push(`${_t.num} ${_t.gen} obj
`), await ht(Ft, Nt, null), Nt.push(` stream
`);
            const Zt = Nt.reduce((Yt, Kt) => Yt + Kt.length, 0), ar = `
endstream
endobj
startxref
${Mt}
%%EOF
`, Jt = new Uint8Array(Bt.length + Zt + qt + ar.length);
            Jt.set(Bt);
            let rr = Bt.length;
            for (const Yt of Nt)
              ct(Yt, rr, Jt), rr += Yt.length;
            for (const [Yt, Kt, nr] of $t)
              rr = mt(Yt, Vt[0], rr, Jt), rr = mt(Kt, Vt[1], rr, Jt), rr = mt(nr, Vt[2], rr, Jt);
            return ct(ar, rr, Jt), Jt;
          }
        },
        /* 225 */
        /***/
        (nt, at, ot) => {
          var Et, St, wl, Ot, Ps, wt, Sl, It, rs, Rt, Rs;
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.calculateSHA256 = at.calculateMD5 = at.PDF20 = at.PDF17 = at.CipherTransformFactory = at.ARCFourCipher = at.AES256Cipher = at.AES128Cipher = void 0, at.calculateSHA384 = dt, at.calculateSHA512 = void 0, ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(140);
          var rt = ot(145), st = ot(151), lt = ot(226);
          class et {
            constructor(Ft) {
              this.a = 0, this.b = 0;
              const _t = new Uint8Array(256), Nt = Ft.length;
              for (let Mt = 0; Mt < 256; ++Mt)
                _t[Mt] = Mt;
              for (let Mt = 0, Lt = 0; Mt < 256; ++Mt) {
                const $t = _t[Mt];
                Lt = Lt + $t + Ft[Mt % Nt] & 255, _t[Mt] = _t[Lt], _t[Lt] = $t;
              }
              this.s = _t;
            }
            encryptBlock(Ft) {
              let _t = this.a, Nt = this.b;
              const Mt = this.s, Lt = Ft.length, $t = new Uint8Array(Lt);
              for (let Tt = 0; Tt < Lt; ++Tt) {
                _t = _t + 1 & 255;
                const Dt = Mt[_t];
                Nt = Nt + Dt & 255;
                const Ut = Mt[Nt];
                Mt[_t] = Ut, Mt[Nt] = Dt, $t[Tt] = Ft[Tt] ^ Mt[Dt + Ut & 255];
              }
              return this.a = _t, this.b = Nt, $t;
            }
            decryptBlock(Ft) {
              return this.encryptBlock(Ft);
            }
            encrypt(Ft) {
              return this.encryptBlock(Ft);
            }
          }
          at.ARCFourCipher = et;
          const it = function() {
            const Ft = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]), _t = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
            function Nt(Mt, Lt, $t) {
              let Tt = 1732584193, Dt = -271733879, Ut = -1732584194, Vt = 271733878;
              const Qt = $t + 72 & -64, qt = new Uint8Array(Qt);
              let Zt, ar;
              for (Zt = 0; Zt < $t; ++Zt)
                qt[Zt] = Mt[Lt++];
              qt[Zt++] = 128;
              const Jt = Qt - 8;
              for (; Zt < Jt; )
                qt[Zt++] = 0;
              qt[Zt++] = $t << 3 & 255, qt[Zt++] = $t >> 5 & 255, qt[Zt++] = $t >> 13 & 255, qt[Zt++] = $t >> 21 & 255, qt[Zt++] = $t >>> 29 & 255, qt[Zt++] = 0, qt[Zt++] = 0, qt[Zt++] = 0;
              const rr = new Int32Array(16);
              for (Zt = 0; Zt < Qt; ) {
                for (ar = 0; ar < 16; ++ar, Zt += 4)
                  rr[ar] = qt[Zt] | qt[Zt + 1] << 8 | qt[Zt + 2] << 16 | qt[Zt + 3] << 24;
                let Yt = Tt, Kt = Dt, nr = Ut, tr = Vt, ir, sr;
                for (ar = 0; ar < 64; ++ar) {
                  ar < 16 ? (ir = Kt & nr | ~Kt & tr, sr = ar) : ar < 32 ? (ir = tr & Kt | ~tr & nr, sr = 5 * ar + 1 & 15) : ar < 48 ? (ir = Kt ^ nr ^ tr, sr = 3 * ar + 5 & 15) : (ir = nr ^ (Kt | ~tr), sr = 7 * ar & 15);
                  const cr = tr, or = Yt + ir + _t[ar] + rr[sr] | 0, Xt = Ft[ar];
                  tr = nr, nr = Kt, Kt = Kt + (or << Xt | or >>> 32 - Xt) | 0, Yt = cr;
                }
                Tt = Tt + Yt | 0, Dt = Dt + Kt | 0, Ut = Ut + nr | 0, Vt = Vt + tr | 0;
              }
              return new Uint8Array([Tt & 255, Tt >> 8 & 255, Tt >> 16 & 255, Tt >>> 24 & 255, Dt & 255, Dt >> 8 & 255, Dt >> 16 & 255, Dt >>> 24 & 255, Ut & 255, Ut >> 8 & 255, Ut >> 16 & 255, Ut >>> 24 & 255, Vt & 255, Vt >> 8 & 255, Vt >> 16 & 255, Vt >>> 24 & 255]);
            }
            return Nt;
          }();
          at.calculateMD5 = it;
          class ut {
            constructor(Ft, _t) {
              this.high = Ft | 0, this.low = _t | 0;
            }
            and(Ft) {
              this.high &= Ft.high, this.low &= Ft.low;
            }
            xor(Ft) {
              this.high ^= Ft.high, this.low ^= Ft.low;
            }
            or(Ft) {
              this.high |= Ft.high, this.low |= Ft.low;
            }
            shiftRight(Ft) {
              Ft >= 32 ? (this.low = this.high >>> Ft - 32 | 0, this.high = 0) : (this.low = this.low >>> Ft | this.high << 32 - Ft, this.high = this.high >>> Ft | 0);
            }
            shiftLeft(Ft) {
              Ft >= 32 ? (this.high = this.low << Ft - 32, this.low = 0) : (this.high = this.high << Ft | this.low >>> 32 - Ft, this.low <<= Ft);
            }
            rotateRight(Ft) {
              let _t, Nt;
              Ft & 32 ? (Nt = this.low, _t = this.high) : (_t = this.low, Nt = this.high), Ft &= 31, this.low = _t >>> Ft | Nt << 32 - Ft, this.high = Nt >>> Ft | _t << 32 - Ft;
            }
            not() {
              this.high = ~this.high, this.low = ~this.low;
            }
            add(Ft) {
              const _t = (this.low >>> 0) + (Ft.low >>> 0);
              let Nt = (this.high >>> 0) + (Ft.high >>> 0);
              _t > 4294967295 && (Nt += 1), this.low = _t | 0, this.high = Nt | 0;
            }
            copyTo(Ft, _t) {
              Ft[_t] = this.high >>> 24 & 255, Ft[_t + 1] = this.high >> 16 & 255, Ft[_t + 2] = this.high >> 8 & 255, Ft[_t + 3] = this.high & 255, Ft[_t + 4] = this.low >>> 24 & 255, Ft[_t + 5] = this.low >> 16 & 255, Ft[_t + 6] = this.low >> 8 & 255, Ft[_t + 7] = this.low & 255;
            }
            assign(Ft) {
              this.high = Ft.high, this.low = Ft.low;
            }
          }
          const ft = /* @__PURE__ */ function() {
            function Ft(Vt, Qt) {
              return Vt >>> Qt | Vt << 32 - Qt;
            }
            function _t(Vt, Qt, qt) {
              return Vt & Qt ^ ~Vt & qt;
            }
            function Nt(Vt, Qt, qt) {
              return Vt & Qt ^ Vt & qt ^ Qt & qt;
            }
            function Mt(Vt) {
              return Ft(Vt, 2) ^ Ft(Vt, 13) ^ Ft(Vt, 22);
            }
            function Lt(Vt) {
              return Ft(Vt, 6) ^ Ft(Vt, 11) ^ Ft(Vt, 25);
            }
            function $t(Vt) {
              return Ft(Vt, 7) ^ Ft(Vt, 18) ^ Vt >>> 3;
            }
            function Tt(Vt) {
              return Ft(Vt, 17) ^ Ft(Vt, 19) ^ Vt >>> 10;
            }
            const Dt = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
            function Ut(Vt, Qt, qt) {
              let Zt = 1779033703, ar = 3144134277, Jt = 1013904242, rr = 2773480762, Yt = 1359893119, Kt = 2600822924, nr = 528734635, tr = 1541459225;
              const ir = Math.ceil((qt + 9) / 64) * 64, sr = new Uint8Array(ir);
              let cr, or;
              for (cr = 0; cr < qt; ++cr)
                sr[cr] = Vt[Qt++];
              sr[cr++] = 128;
              const Xt = ir - 8;
              for (; cr < Xt; )
                sr[cr++] = 0;
              sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = qt >>> 29 & 255, sr[cr++] = qt >> 21 & 255, sr[cr++] = qt >> 13 & 255, sr[cr++] = qt >> 5 & 255, sr[cr++] = qt << 3 & 255;
              const Gt = new Uint32Array(64);
              for (cr = 0; cr < ir; ) {
                for (or = 0; or < 16; ++or)
                  Gt[or] = sr[cr] << 24 | sr[cr + 1] << 16 | sr[cr + 2] << 8 | sr[cr + 3], cr += 4;
                for (or = 16; or < 64; ++or)
                  Gt[or] = Tt(Gt[or - 2]) + Gt[or - 7] + $t(Gt[or - 15]) + Gt[or - 16] | 0;
                let Wt = Zt, er = ar, lr = Jt, ur = rr, pr = Yt, yr = Kt, Er = nr, br = tr, gr, Ar;
                for (or = 0; or < 64; ++or)
                  gr = br + Lt(pr) + _t(pr, yr, Er) + Dt[or] + Gt[or], Ar = Mt(Wt) + Nt(Wt, er, lr), br = Er, Er = yr, yr = pr, pr = ur + gr | 0, ur = lr, lr = er, er = Wt, Wt = gr + Ar | 0;
                Zt = Zt + Wt | 0, ar = ar + er | 0, Jt = Jt + lr | 0, rr = rr + ur | 0, Yt = Yt + pr | 0, Kt = Kt + yr | 0, nr = nr + Er | 0, tr = tr + br | 0;
              }
              return new Uint8Array([Zt >> 24 & 255, Zt >> 16 & 255, Zt >> 8 & 255, Zt & 255, ar >> 24 & 255, ar >> 16 & 255, ar >> 8 & 255, ar & 255, Jt >> 24 & 255, Jt >> 16 & 255, Jt >> 8 & 255, Jt & 255, rr >> 24 & 255, rr >> 16 & 255, rr >> 8 & 255, rr & 255, Yt >> 24 & 255, Yt >> 16 & 255, Yt >> 8 & 255, Yt & 255, Kt >> 24 & 255, Kt >> 16 & 255, Kt >> 8 & 255, Kt & 255, nr >> 24 & 255, nr >> 16 & 255, nr >> 8 & 255, nr & 255, tr >> 24 & 255, tr >> 16 & 255, tr >> 8 & 255, tr & 255]);
            }
            return Ut;
          }();
          at.calculateSHA256 = ft;
          const ht = function() {
            function Ft(Ut, Vt, Qt, qt, Zt) {
              Ut.assign(Vt), Ut.and(Qt), Zt.assign(Vt), Zt.not(), Zt.and(qt), Ut.xor(Zt);
            }
            function _t(Ut, Vt, Qt, qt, Zt) {
              Ut.assign(Vt), Ut.and(Qt), Zt.assign(Vt), Zt.and(qt), Ut.xor(Zt), Zt.assign(Qt), Zt.and(qt), Ut.xor(Zt);
            }
            function Nt(Ut, Vt, Qt) {
              Ut.assign(Vt), Ut.rotateRight(28), Qt.assign(Vt), Qt.rotateRight(34), Ut.xor(Qt), Qt.assign(Vt), Qt.rotateRight(39), Ut.xor(Qt);
            }
            function Mt(Ut, Vt, Qt) {
              Ut.assign(Vt), Ut.rotateRight(14), Qt.assign(Vt), Qt.rotateRight(18), Ut.xor(Qt), Qt.assign(Vt), Qt.rotateRight(41), Ut.xor(Qt);
            }
            function Lt(Ut, Vt, Qt) {
              Ut.assign(Vt), Ut.rotateRight(1), Qt.assign(Vt), Qt.rotateRight(8), Ut.xor(Qt), Qt.assign(Vt), Qt.shiftRight(7), Ut.xor(Qt);
            }
            function $t(Ut, Vt, Qt) {
              Ut.assign(Vt), Ut.rotateRight(19), Qt.assign(Vt), Qt.rotateRight(61), Ut.xor(Qt), Qt.assign(Vt), Qt.shiftRight(6), Ut.xor(Qt);
            }
            const Tt = [new ut(1116352408, 3609767458), new ut(1899447441, 602891725), new ut(3049323471, 3964484399), new ut(3921009573, 2173295548), new ut(961987163, 4081628472), new ut(1508970993, 3053834265), new ut(2453635748, 2937671579), new ut(2870763221, 3664609560), new ut(3624381080, 2734883394), new ut(310598401, 1164996542), new ut(607225278, 1323610764), new ut(1426881987, 3590304994), new ut(1925078388, 4068182383), new ut(2162078206, 991336113), new ut(2614888103, 633803317), new ut(3248222580, 3479774868), new ut(3835390401, 2666613458), new ut(4022224774, 944711139), new ut(264347078, 2341262773), new ut(604807628, 2007800933), new ut(770255983, 1495990901), new ut(1249150122, 1856431235), new ut(1555081692, 3175218132), new ut(1996064986, 2198950837), new ut(2554220882, 3999719339), new ut(2821834349, 766784016), new ut(2952996808, 2566594879), new ut(3210313671, 3203337956), new ut(3336571891, 1034457026), new ut(3584528711, 2466948901), new ut(113926993, 3758326383), new ut(338241895, 168717936), new ut(666307205, 1188179964), new ut(773529912, 1546045734), new ut(1294757372, 1522805485), new ut(1396182291, 2643833823), new ut(1695183700, 2343527390), new ut(1986661051, 1014477480), new ut(2177026350, 1206759142), new ut(2456956037, 344077627), new ut(2730485921, 1290863460), new ut(2820302411, 3158454273), new ut(3259730800, 3505952657), new ut(3345764771, 106217008), new ut(3516065817, 3606008344), new ut(3600352804, 1432725776), new ut(4094571909, 1467031594), new ut(275423344, 851169720), new ut(430227734, 3100823752), new ut(506948616, 1363258195), new ut(659060556, 3750685593), new ut(883997877, 3785050280), new ut(958139571, 3318307427), new ut(1322822218, 3812723403), new ut(1537002063, 2003034995), new ut(1747873779, 3602036899), new ut(1955562222, 1575990012), new ut(2024104815, 1125592928), new ut(2227730452, 2716904306), new ut(2361852424, 442776044), new ut(2428436474, 593698344), new ut(2756734187, 3733110249), new ut(3204031479, 2999351573), new ut(3329325298, 3815920427), new ut(3391569614, 3928383900), new ut(3515267271, 566280711), new ut(3940187606, 3454069534), new ut(4118630271, 4000239992), new ut(116418474, 1914138554), new ut(174292421, 2731055270), new ut(289380356, 3203993006), new ut(460393269, 320620315), new ut(685471733, 587496836), new ut(852142971, 1086792851), new ut(1017036298, 365543100), new ut(1126000580, 2618297676), new ut(1288033470, 3409855158), new ut(1501505948, 4234509866), new ut(1607167915, 987167468), new ut(1816402316, 1246189591)];
            function Dt(Ut, Vt, Qt) {
              let qt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, Zt, ar, Jt, rr, Yt, Kt, nr, tr;
              qt ? (Zt = new ut(3418070365, 3238371032), ar = new ut(1654270250, 914150663), Jt = new ut(2438529370, 812702999), rr = new ut(355462360, 4144912697), Yt = new ut(1731405415, 4290775857), Kt = new ut(2394180231, 1750603025), nr = new ut(3675008525, 1694076839), tr = new ut(1203062813, 3204075428)) : (Zt = new ut(1779033703, 4089235720), ar = new ut(3144134277, 2227873595), Jt = new ut(1013904242, 4271175723), rr = new ut(2773480762, 1595750129), Yt = new ut(1359893119, 2917565137), Kt = new ut(2600822924, 725511199), nr = new ut(528734635, 4215389547), tr = new ut(1541459225, 327033209));
              const ir = Math.ceil((Qt + 17) / 128) * 128, sr = new Uint8Array(ir);
              let cr, or;
              for (cr = 0; cr < Qt; ++cr)
                sr[cr] = Ut[Vt++];
              sr[cr++] = 128;
              const Xt = ir - 16;
              for (; cr < Xt; )
                sr[cr++] = 0;
              sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = 0, sr[cr++] = Qt >>> 29 & 255, sr[cr++] = Qt >> 21 & 255, sr[cr++] = Qt >> 13 & 255, sr[cr++] = Qt >> 5 & 255, sr[cr++] = Qt << 3 & 255;
              const Gt = new Array(80);
              for (cr = 0; cr < 80; cr++)
                Gt[cr] = new ut(0, 0);
              let Wt = new ut(0, 0), er = new ut(0, 0), lr = new ut(0, 0), ur = new ut(0, 0), pr = new ut(0, 0), yr = new ut(0, 0), Er = new ut(0, 0), br = new ut(0, 0);
              const gr = new ut(0, 0), Ar = new ut(0, 0), Sr = new ut(0, 0), Br = new ut(0, 0);
              let Ir;
              for (cr = 0; cr < ir; ) {
                for (or = 0; or < 16; ++or)
                  Gt[or].high = sr[cr] << 24 | sr[cr + 1] << 16 | sr[cr + 2] << 8 | sr[cr + 3], Gt[or].low = sr[cr + 4] << 24 | sr[cr + 5] << 16 | sr[cr + 6] << 8 | sr[cr + 7], cr += 8;
                for (or = 16; or < 80; ++or)
                  Ir = Gt[or], $t(Ir, Gt[or - 2], Br), Ir.add(Gt[or - 7]), Lt(Sr, Gt[or - 15], Br), Ir.add(Sr), Ir.add(Gt[or - 16]);
                for (Wt.assign(Zt), er.assign(ar), lr.assign(Jt), ur.assign(rr), pr.assign(Yt), yr.assign(Kt), Er.assign(nr), br.assign(tr), or = 0; or < 80; ++or)
                  gr.assign(br), Mt(Sr, pr, Br), gr.add(Sr), Ft(Sr, pr, yr, Er, Br), gr.add(Sr), gr.add(Tt[or]), gr.add(Gt[or]), Nt(Ar, Wt, Br), _t(Sr, Wt, er, lr, Br), Ar.add(Sr), Ir = br, br = Er, Er = yr, yr = pr, ur.add(gr), pr = ur, ur = lr, lr = er, er = Wt, Ir.assign(gr), Ir.add(Ar), Wt = Ir;
                Zt.add(Wt), ar.add(er), Jt.add(lr), rr.add(ur), Yt.add(pr), Kt.add(yr), nr.add(Er), tr.add(br);
              }
              let hr;
              return qt ? (hr = new Uint8Array(48), Zt.copyTo(hr, 0), ar.copyTo(hr, 8), Jt.copyTo(hr, 16), rr.copyTo(hr, 24), Yt.copyTo(hr, 32), Kt.copyTo(hr, 40)) : (hr = new Uint8Array(64), Zt.copyTo(hr, 0), ar.copyTo(hr, 8), Jt.copyTo(hr, 16), rr.copyTo(hr, 24), Yt.copyTo(hr, 32), Kt.copyTo(hr, 40), nr.copyTo(hr, 48), tr.copyTo(hr, 56)), hr;
            }
            return Dt;
          }();
          at.calculateSHA512 = ht;
          function dt(Ht, Ft, _t) {
            return ht(Ht, Ft, _t, !0);
          }
          class gt {
            decryptBlock(Ft) {
              return Ft;
            }
            encrypt(Ft) {
              return Ft;
            }
          }
          class pt {
            constructor() {
              this.constructor === pt && (0, rt.unreachable)("Cannot initialize AESBaseCipher."), this._s = new Uint8Array([99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22]), this._inv_s = new Uint8Array([82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125]), this._mix = new Uint32Array([0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795]), this._mixCol = new Uint8Array(256);
              for (let Ft = 0; Ft < 256; Ft++)
                this._mixCol[Ft] = Ft < 128 ? Ft << 1 : Ft << 1 ^ 27;
              this.buffer = new Uint8Array(16), this.bufferPosition = 0;
            }
            _expandKey(Ft) {
              (0, rt.unreachable)("Cannot call `_expandKey` on the base class");
            }
            _decrypt(Ft, _t) {
              let Nt, Mt, Lt;
              const $t = new Uint8Array(16);
              $t.set(Ft);
              for (let Tt = 0, Dt = this._keySize; Tt < 16; ++Tt, ++Dt)
                $t[Tt] ^= _t[Dt];
              for (let Tt = this._cyclesOfRepetition - 1; Tt >= 1; --Tt) {
                Nt = $t[13], $t[13] = $t[9], $t[9] = $t[5], $t[5] = $t[1], $t[1] = Nt, Nt = $t[14], Mt = $t[10], $t[14] = $t[6], $t[10] = $t[2], $t[6] = Nt, $t[2] = Mt, Nt = $t[15], Mt = $t[11], Lt = $t[7], $t[15] = $t[3], $t[11] = Nt, $t[7] = Mt, $t[3] = Lt;
                for (let Dt = 0; Dt < 16; ++Dt)
                  $t[Dt] = this._inv_s[$t[Dt]];
                for (let Dt = 0, Ut = Tt * 16; Dt < 16; ++Dt, ++Ut)
                  $t[Dt] ^= _t[Ut];
                for (let Dt = 0; Dt < 16; Dt += 4) {
                  const Ut = this._mix[$t[Dt]], Vt = this._mix[$t[Dt + 1]], Qt = this._mix[$t[Dt + 2]], qt = this._mix[$t[Dt + 3]];
                  Nt = Ut ^ Vt >>> 8 ^ Vt << 24 ^ Qt >>> 16 ^ Qt << 16 ^ qt >>> 24 ^ qt << 8, $t[Dt] = Nt >>> 24 & 255, $t[Dt + 1] = Nt >> 16 & 255, $t[Dt + 2] = Nt >> 8 & 255, $t[Dt + 3] = Nt & 255;
                }
              }
              Nt = $t[13], $t[13] = $t[9], $t[9] = $t[5], $t[5] = $t[1], $t[1] = Nt, Nt = $t[14], Mt = $t[10], $t[14] = $t[6], $t[10] = $t[2], $t[6] = Nt, $t[2] = Mt, Nt = $t[15], Mt = $t[11], Lt = $t[7], $t[15] = $t[3], $t[11] = Nt, $t[7] = Mt, $t[3] = Lt;
              for (let Tt = 0; Tt < 16; ++Tt)
                $t[Tt] = this._inv_s[$t[Tt]], $t[Tt] ^= _t[Tt];
              return $t;
            }
            _encrypt(Ft, _t) {
              const Nt = this._s;
              let Mt, Lt, $t;
              const Tt = new Uint8Array(16);
              Tt.set(Ft);
              for (let Dt = 0; Dt < 16; ++Dt)
                Tt[Dt] ^= _t[Dt];
              for (let Dt = 1; Dt < this._cyclesOfRepetition; Dt++) {
                for (let Ut = 0; Ut < 16; ++Ut)
                  Tt[Ut] = Nt[Tt[Ut]];
                $t = Tt[1], Tt[1] = Tt[5], Tt[5] = Tt[9], Tt[9] = Tt[13], Tt[13] = $t, $t = Tt[2], Lt = Tt[6], Tt[2] = Tt[10], Tt[6] = Tt[14], Tt[10] = $t, Tt[14] = Lt, $t = Tt[3], Lt = Tt[7], Mt = Tt[11], Tt[3] = Tt[15], Tt[7] = $t, Tt[11] = Lt, Tt[15] = Mt;
                for (let Ut = 0; Ut < 16; Ut += 4) {
                  const Vt = Tt[Ut + 0], Qt = Tt[Ut + 1], qt = Tt[Ut + 2], Zt = Tt[Ut + 3];
                  Mt = Vt ^ Qt ^ qt ^ Zt, Tt[Ut + 0] ^= Mt ^ this._mixCol[Vt ^ Qt], Tt[Ut + 1] ^= Mt ^ this._mixCol[Qt ^ qt], Tt[Ut + 2] ^= Mt ^ this._mixCol[qt ^ Zt], Tt[Ut + 3] ^= Mt ^ this._mixCol[Zt ^ Vt];
                }
                for (let Ut = 0, Vt = Dt * 16; Ut < 16; ++Ut, ++Vt)
                  Tt[Ut] ^= _t[Vt];
              }
              for (let Dt = 0; Dt < 16; ++Dt)
                Tt[Dt] = Nt[Tt[Dt]];
              $t = Tt[1], Tt[1] = Tt[5], Tt[5] = Tt[9], Tt[9] = Tt[13], Tt[13] = $t, $t = Tt[2], Lt = Tt[6], Tt[2] = Tt[10], Tt[6] = Tt[14], Tt[10] = $t, Tt[14] = Lt, $t = Tt[3], Lt = Tt[7], Mt = Tt[11], Tt[3] = Tt[15], Tt[7] = $t, Tt[11] = Lt, Tt[15] = Mt;
              for (let Dt = 0, Ut = this._keySize; Dt < 16; ++Dt, ++Ut)
                Tt[Dt] ^= _t[Ut];
              return Tt;
            }
            _decryptBlock2(Ft, _t) {
              const Nt = Ft.length;
              let Mt = this.buffer, Lt = this.bufferPosition;
              const $t = [];
              let Tt = this.iv;
              for (let Vt = 0; Vt < Nt; ++Vt) {
                if (Mt[Lt] = Ft[Vt], ++Lt, Lt < 16)
                  continue;
                const Qt = this._decrypt(Mt, this._key);
                for (let qt = 0; qt < 16; ++qt)
                  Qt[qt] ^= Tt[qt];
                Tt = Mt, $t.push(Qt), Mt = new Uint8Array(16), Lt = 0;
              }
              if (this.buffer = Mt, this.bufferLength = Lt, this.iv = Tt, $t.length === 0)
                return new Uint8Array(0);
              let Dt = 16 * $t.length;
              if (_t) {
                const Vt = $t.at(-1);
                let Qt = Vt[15];
                if (Qt <= 16) {
                  for (let qt = 15, Zt = 16 - Qt; qt >= Zt; --qt)
                    if (Vt[qt] !== Qt) {
                      Qt = 0;
                      break;
                    }
                  Dt -= Qt, $t[$t.length - 1] = Vt.subarray(0, 16 - Qt);
                }
              }
              const Ut = new Uint8Array(Dt);
              for (let Vt = 0, Qt = 0, qt = $t.length; Vt < qt; ++Vt, Qt += 16)
                Ut.set($t[Vt], Qt);
              return Ut;
            }
            decryptBlock(Ft, _t) {
              let Nt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
              const Mt = Ft.length, Lt = this.buffer;
              let $t = this.bufferPosition;
              if (Nt)
                this.iv = Nt;
              else {
                for (let Tt = 0; $t < 16 && Tt < Mt; ++Tt, ++$t)
                  Lt[$t] = Ft[Tt];
                if ($t < 16)
                  return this.bufferLength = $t, new Uint8Array(0);
                this.iv = Lt, Ft = Ft.subarray(16);
              }
              return this.buffer = new Uint8Array(16), this.bufferLength = 0, this.decryptBlock = this._decryptBlock2, this.decryptBlock(Ft, _t);
            }
            encrypt(Ft, _t) {
              const Nt = Ft.length;
              let Mt = this.buffer, Lt = this.bufferPosition;
              const $t = [];
              _t || (_t = new Uint8Array(16));
              for (let Ut = 0; Ut < Nt; ++Ut) {
                if (Mt[Lt] = Ft[Ut], ++Lt, Lt < 16)
                  continue;
                for (let Qt = 0; Qt < 16; ++Qt)
                  Mt[Qt] ^= _t[Qt];
                const Vt = this._encrypt(Mt, this._key);
                _t = Vt, $t.push(Vt), Mt = new Uint8Array(16), Lt = 0;
              }
              if (this.buffer = Mt, this.bufferLength = Lt, this.iv = _t, $t.length === 0)
                return new Uint8Array(0);
              const Tt = 16 * $t.length, Dt = new Uint8Array(Tt);
              for (let Ut = 0, Vt = 0, Qt = $t.length; Ut < Qt; ++Ut, Vt += 16)
                Dt.set($t[Ut], Vt);
              return Dt;
            }
          }
          class mt extends pt {
            constructor(Ft) {
              super(), this._cyclesOfRepetition = 10, this._keySize = 160, this._rcon = new Uint8Array([141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141]), this._key = this._expandKey(Ft);
            }
            _expandKey(Ft) {
              const Nt = this._s, Mt = this._rcon, Lt = new Uint8Array(176);
              Lt.set(Ft);
              for (let $t = 16, Tt = 1; $t < 176; ++Tt) {
                let Dt = Lt[$t - 3], Ut = Lt[$t - 2], Vt = Lt[$t - 1], Qt = Lt[$t - 4];
                Dt = Nt[Dt], Ut = Nt[Ut], Vt = Nt[Vt], Qt = Nt[Qt], Dt ^= Mt[Tt];
                for (let qt = 0; qt < 4; ++qt)
                  Lt[$t] = Dt ^= Lt[$t - 16], $t++, Lt[$t] = Ut ^= Lt[$t - 16], $t++, Lt[$t] = Vt ^= Lt[$t - 16], $t++, Lt[$t] = Qt ^= Lt[$t - 16], $t++;
              }
              return Lt;
            }
          }
          at.AES128Cipher = mt;
          class ct extends pt {
            constructor(Ft) {
              super(), this._cyclesOfRepetition = 14, this._keySize = 224, this._key = this._expandKey(Ft);
            }
            _expandKey(Ft) {
              const Nt = this._s, Mt = new Uint8Array(240);
              Mt.set(Ft);
              let Lt = 1, $t, Tt, Dt, Ut;
              for (let Vt = 32, Qt = 1; Vt < 240; ++Qt) {
                Vt % 32 === 16 ? ($t = Nt[$t], Tt = Nt[Tt], Dt = Nt[Dt], Ut = Nt[Ut]) : Vt % 32 === 0 && ($t = Mt[Vt - 3], Tt = Mt[Vt - 2], Dt = Mt[Vt - 1], Ut = Mt[Vt - 4], $t = Nt[$t], Tt = Nt[Tt], Dt = Nt[Dt], Ut = Nt[Ut], $t ^= Lt, (Lt <<= 1) >= 256 && (Lt = (Lt ^ 27) & 255));
                for (let qt = 0; qt < 4; ++qt)
                  Mt[Vt] = $t ^= Mt[Vt - 32], Vt++, Mt[Vt] = Tt ^= Mt[Vt - 32], Vt++, Mt[Vt] = Dt ^= Mt[Vt - 32], Vt++, Mt[Vt] = Ut ^= Mt[Vt - 32], Vt++;
              }
              return Mt;
            }
          }
          at.AES256Cipher = ct;
          class vt {
            checkOwnerPassword(Ft, _t, Nt, Mt) {
              const Lt = new Uint8Array(Ft.length + 56);
              Lt.set(Ft, 0), Lt.set(_t, Ft.length), Lt.set(Nt, Ft.length + _t.length);
              const $t = ft(Lt, 0, Lt.length);
              return (0, rt.isArrayEqual)($t, Mt);
            }
            checkUserPassword(Ft, _t, Nt) {
              const Mt = new Uint8Array(Ft.length + 8);
              Mt.set(Ft, 0), Mt.set(_t, Ft.length);
              const Lt = ft(Mt, 0, Mt.length);
              return (0, rt.isArrayEqual)(Lt, Nt);
            }
            getOwnerKey(Ft, _t, Nt, Mt) {
              const Lt = new Uint8Array(Ft.length + 56);
              Lt.set(Ft, 0), Lt.set(_t, Ft.length), Lt.set(Nt, Ft.length + _t.length);
              const $t = ft(Lt, 0, Lt.length);
              return new ct($t).decryptBlock(Mt, !1, new Uint8Array(16));
            }
            getUserKey(Ft, _t, Nt) {
              const Mt = new Uint8Array(Ft.length + 8);
              Mt.set(Ft, 0), Mt.set(_t, Ft.length);
              const Lt = ft(Mt, 0, Mt.length);
              return new ct(Lt).decryptBlock(Nt, !1, new Uint8Array(16));
            }
          }
          at.PDF17 = vt;
          class At {
            _hash(Ft, _t, Nt) {
              let Mt = ft(_t, 0, _t.length).subarray(0, 32), Lt = [0], $t = 0;
              for (; $t < 64 || Lt.at(-1) > $t - 32; ) {
                const Tt = Ft.length + Mt.length + Nt.length, Dt = new Uint8Array(Tt);
                let Ut = 0;
                Dt.set(Ft, Ut), Ut += Ft.length, Dt.set(Mt, Ut), Ut += Mt.length, Dt.set(Nt, Ut);
                const Vt = new Uint8Array(Tt * 64);
                for (let Zt = 0, ar = 0; Zt < 64; Zt++, ar += Tt)
                  Vt.set(Dt, ar);
                Lt = new mt(Mt.subarray(0, 16)).encrypt(Vt, Mt.subarray(16, 32));
                const qt = Lt.slice(0, 16).reduce((Zt, ar) => Zt + ar, 0) % 3;
                qt === 0 ? Mt = ft(Lt, 0, Lt.length) : qt === 1 ? Mt = dt(Lt, 0, Lt.length) : qt === 2 && (Mt = ht(Lt, 0, Lt.length)), $t++;
              }
              return Mt.subarray(0, 32);
            }
            checkOwnerPassword(Ft, _t, Nt, Mt) {
              const Lt = new Uint8Array(Ft.length + 56);
              Lt.set(Ft, 0), Lt.set(_t, Ft.length), Lt.set(Nt, Ft.length + _t.length);
              const $t = this._hash(Ft, Lt, Nt);
              return (0, rt.isArrayEqual)($t, Mt);
            }
            checkUserPassword(Ft, _t, Nt) {
              const Mt = new Uint8Array(Ft.length + 8);
              Mt.set(Ft, 0), Mt.set(_t, Ft.length);
              const Lt = this._hash(Ft, Mt, []);
              return (0, rt.isArrayEqual)(Lt, Nt);
            }
            getOwnerKey(Ft, _t, Nt, Mt) {
              const Lt = new Uint8Array(Ft.length + 56);
              Lt.set(Ft, 0), Lt.set(_t, Ft.length), Lt.set(Nt, Ft.length + _t.length);
              const $t = this._hash(Ft, Lt, Nt);
              return new ct($t).decryptBlock(Mt, !1, new Uint8Array(16));
            }
            getUserKey(Ft, _t, Nt) {
              const Mt = new Uint8Array(Ft.length + 8);
              Mt.set(Ft, 0), Mt.set(_t, Ft.length);
              const Lt = this._hash(Ft, Mt, []);
              return new ct(Lt).decryptBlock(Nt, !1, new Uint8Array(16));
            }
          }
          at.PDF20 = At;
          class xt {
            constructor(Ft, _t) {
              this.StringCipherConstructor = Ft, this.StreamCipherConstructor = _t;
            }
            createStream(Ft, _t) {
              const Nt = new this.StreamCipherConstructor();
              return new lt.DecryptStream(Ft, _t, function(Lt, $t) {
                return Nt.decryptBlock(Lt, $t);
              });
            }
            decryptString(Ft) {
              const _t = new this.StringCipherConstructor();
              let Nt = (0, rt.stringToBytes)(Ft);
              return Nt = _t.decryptBlock(Nt, !0), (0, rt.bytesToString)(Nt);
            }
            encryptString(Ft) {
              const _t = new this.StringCipherConstructor();
              if (_t instanceof pt) {
                const Lt = 16 - Ft.length % 16;
                Ft += String.fromCharCode(Lt).repeat(Lt);
                const $t = new Uint8Array(16);
                if (typeof crypto < "u")
                  crypto.getRandomValues($t);
                else
                  for (let Ut = 0; Ut < 16; Ut++)
                    $t[Ut] = Math.floor(256 * Math.random());
                let Tt = (0, rt.stringToBytes)(Ft);
                Tt = _t.encrypt(Tt, $t);
                const Dt = new Uint8Array(16 + Tt.length);
                return Dt.set($t), Dt.set(Tt, 16), (0, rt.bytesToString)(Dt);
              }
              let Nt = (0, rt.stringToBytes)(Ft);
              return Nt = _t.encrypt(Nt), (0, rt.bytesToString)(Nt);
            }
          }
          const jt = class jt {
            constructor(Ft, _t, Nt) {
              _r(this, St);
              _r(this, Ot);
              _r(this, wt);
              _r(this, It);
              _r(this, Rt);
              const Mt = Ft.get("Filter");
              if (!(0, st.isName)(Mt, "Standard"))
                throw new rt.FormatError("unknown encryption method");
              this.filterName = Mt.name, this.dict = Ft;
              const Lt = Ft.get("V");
              if (!Number.isInteger(Lt) || Lt !== 1 && Lt !== 2 && Lt !== 4 && Lt !== 5)
                throw new rt.FormatError("unsupported encryption algorithm");
              this.algorithm = Lt;
              let $t = Ft.get("Length");
              if (!$t)
                if (Lt <= 3)
                  $t = 40;
                else {
                  const Yt = Ft.get("CF"), Kt = Ft.get("StmF");
                  if (Yt instanceof st.Dict && Kt instanceof st.Name) {
                    Yt.suppressEncryption = !0;
                    const nr = Yt.get(Kt.name);
                    $t = (nr == null ? void 0 : nr.get("Length")) || 128, $t < 40 && ($t <<= 3);
                  }
                }
              if (!Number.isInteger($t) || $t < 40 || $t % 8 !== 0)
                throw new rt.FormatError("invalid key length");
              const Tt = (0, rt.stringToBytes)(Ft.get("O")), Dt = (0, rt.stringToBytes)(Ft.get("U")), Ut = Tt.subarray(0, 32), Vt = Dt.subarray(0, 32), Qt = Ft.get("P"), qt = Ft.get("R"), Zt = (Lt === 4 || Lt === 5) && Ft.get("EncryptMetadata") !== !1;
              this.encryptMetadata = Zt;
              const ar = (0, rt.stringToBytes)(_t);
              let Jt;
              if (Nt) {
                if (qt === 6)
                  try {
                    Nt = (0, rt.utf8StringToString)(Nt);
                  } catch {
                    (0, rt.warn)("CipherTransformFactory: Unable to convert UTF8 encoded password.");
                  }
                Jt = (0, rt.stringToBytes)(Nt);
              }
              let rr;
              if (Lt !== 5)
                rr = Ur(this, Ot, Ps).call(this, ar, Jt, Ut, Vt, Qt, qt, $t, Zt);
              else {
                const Yt = Tt.subarray(32, 40), Kt = Tt.subarray(40, 48), nr = Dt.subarray(0, 48), tr = Dt.subarray(32, 40), ir = Dt.subarray(40, 48), sr = (0, rt.stringToBytes)(Ft.get("OE")), cr = (0, rt.stringToBytes)(Ft.get("UE")), or = (0, rt.stringToBytes)(Ft.get("Perms"));
                rr = Ur(this, St, wl).call(this, qt, Jt, Ut, Yt, Kt, nr, Vt, tr, ir, sr, cr, or);
              }
              if (!rr && !Nt)
                throw new rt.PasswordException("No password given", rt.PasswordResponses.NEED_PASSWORD);
              if (!rr && Nt) {
                const Yt = Ur(this, wt, Sl).call(this, Jt, Ut, qt, $t);
                rr = Ur(this, Ot, Ps).call(this, ar, Yt, Ut, Vt, Qt, qt, $t, Zt);
              }
              if (!rr)
                throw new rt.PasswordException("Incorrect Password", rt.PasswordResponses.INCORRECT_PASSWORD);
              if (this.encryptionKey = rr, Lt >= 4) {
                const Yt = Ft.get("CF");
                Yt instanceof st.Dict && (Yt.suppressEncryption = !0), this.cf = Yt, this.stmf = Ft.get("StmF") || st.Name.get("Identity"), this.strf = Ft.get("StrF") || st.Name.get("Identity"), this.eff = Ft.get("EFF") || this.stmf;
              }
            }
            createCipherTransform(Ft, _t) {
              if (this.algorithm === 4 || this.algorithm === 5)
                return new xt(Ur(this, Rt, Rs).call(this, this.cf, this.strf, Ft, _t, this.encryptionKey), Ur(this, Rt, Rs).call(this, this.cf, this.stmf, Ft, _t, this.encryptionKey));
              const Nt = Ur(this, It, rs).call(this, Ft, _t, this.encryptionKey, !1), Mt = function() {
                return new et(Nt);
              };
              return new xt(Mt, Mt);
            }
          };
          Et = new WeakMap(), St = new WeakSet(), wl = function(Ft, _t, Nt, Mt, Lt, $t, Tt, Dt, Ut, Vt, Qt, qt) {
            if (_t) {
              const ar = Math.min(127, _t.length);
              _t = _t.subarray(0, ar);
            } else
              _t = [];
            const Zt = Ft === 6 ? new At() : new vt();
            return Zt.checkUserPassword(_t, Dt, Tt) ? Zt.getUserKey(_t, Ut, Qt) : _t.length && Zt.checkOwnerPassword(_t, Mt, $t, Nt) ? Zt.getOwnerKey(_t, Lt, $t, Vt) : null;
          }, Ot = new WeakSet(), Ps = function(Ft, _t, Nt, Mt, Lt, $t, Tt, Dt) {
            const Ut = 40 + Nt.length + Ft.length, Vt = new Uint8Array(Ut);
            let Qt = 0, qt, Zt;
            if (_t)
              for (Zt = Math.min(32, _t.length); Qt < Zt; ++Qt)
                Vt[Qt] = _t[Qt];
            for (qt = 0; Qt < 32; )
              Vt[Qt++] = mr(jt, Et)[qt++];
            for (qt = 0, Zt = Nt.length; qt < Zt; ++qt)
              Vt[Qt++] = Nt[qt];
            for (Vt[Qt++] = Lt & 255, Vt[Qt++] = Lt >> 8 & 255, Vt[Qt++] = Lt >> 16 & 255, Vt[Qt++] = Lt >>> 24 & 255, qt = 0, Zt = Ft.length; qt < Zt; ++qt)
              Vt[Qt++] = Ft[qt];
            $t >= 4 && !Dt && (Vt[Qt++] = 255, Vt[Qt++] = 255, Vt[Qt++] = 255, Vt[Qt++] = 255);
            let ar = it(Vt, 0, Qt);
            const Jt = Tt >> 3;
            if ($t >= 3)
              for (qt = 0; qt < 50; ++qt)
                ar = it(ar, 0, Jt);
            const rr = ar.subarray(0, Jt);
            let Yt, Kt;
            if ($t >= 3) {
              for (Qt = 0; Qt < 32; ++Qt)
                Vt[Qt] = mr(jt, Et)[Qt];
              for (qt = 0, Zt = Ft.length; qt < Zt; ++qt)
                Vt[Qt++] = Ft[qt];
              Yt = new et(rr), Kt = Yt.encryptBlock(it(Vt, 0, Qt)), Zt = rr.length;
              const nr = new Uint8Array(Zt);
              for (qt = 1; qt <= 19; ++qt) {
                for (let tr = 0; tr < Zt; ++tr)
                  nr[tr] = rr[tr] ^ qt;
                Yt = new et(nr), Kt = Yt.encryptBlock(Kt);
              }
              for (qt = 0, Zt = Kt.length; qt < Zt; ++qt)
                if (Mt[qt] !== Kt[qt])
                  return null;
            } else
              for (Yt = new et(rr), Kt = Yt.encryptBlock(mr(jt, Et)), qt = 0, Zt = Kt.length; qt < Zt; ++qt)
                if (Mt[qt] !== Kt[qt])
                  return null;
            return rr;
          }, wt = new WeakSet(), Sl = function(Ft, _t, Nt, Mt) {
            const Lt = new Uint8Array(32);
            let $t = 0;
            const Tt = Math.min(32, Ft.length);
            for (; $t < Tt; ++$t)
              Lt[$t] = Ft[$t];
            let Dt = 0;
            for (; $t < 32; )
              Lt[$t++] = mr(jt, Et)[Dt++];
            let Ut = it(Lt, 0, $t);
            const Vt = Mt >> 3;
            if (Nt >= 3)
              for (Dt = 0; Dt < 50; ++Dt)
                Ut = it(Ut, 0, Ut.length);
            let Qt, qt;
            if (Nt >= 3) {
              qt = _t;
              const Zt = new Uint8Array(Vt);
              for (Dt = 19; Dt >= 0; Dt--) {
                for (let ar = 0; ar < Vt; ++ar)
                  Zt[ar] = Ut[ar] ^ Dt;
                Qt = new et(Zt), qt = Qt.encryptBlock(qt);
              }
            } else
              Qt = new et(Ut.subarray(0, Vt)), qt = Qt.encryptBlock(_t);
            return qt;
          }, It = new WeakSet(), rs = function(Ft, _t, Nt) {
            let Mt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
            const Lt = new Uint8Array(Nt.length + 9), $t = Nt.length;
            let Tt;
            for (Tt = 0; Tt < $t; ++Tt)
              Lt[Tt] = Nt[Tt];
            return Lt[Tt++] = Ft & 255, Lt[Tt++] = Ft >> 8 & 255, Lt[Tt++] = Ft >> 16 & 255, Lt[Tt++] = _t & 255, Lt[Tt++] = _t >> 8 & 255, Mt && (Lt[Tt++] = 115, Lt[Tt++] = 65, Lt[Tt++] = 108, Lt[Tt++] = 84), it(Lt, 0, Tt).subarray(0, Math.min(Nt.length + 5, 16));
          }, Rt = new WeakSet(), Rs = function(Ft, _t, Nt, Mt, Lt) {
            if (!(_t instanceof st.Name))
              throw new rt.FormatError("Invalid crypt filter name.");
            const $t = this, Tt = Ft.get(_t.name), Dt = Tt == null ? void 0 : Tt.get("CFM");
            if (!Dt || Dt.name === "None")
              return function() {
                return new gt();
              };
            if (Dt.name === "V2")
              return function() {
                var Ut;
                return new et(Ur(Ut = $t, It, rs).call(Ut, Nt, Mt, Lt, !1));
              };
            if (Dt.name === "AESV2")
              return function() {
                var Ut;
                return new mt(Ur(Ut = $t, It, rs).call(Ut, Nt, Mt, Lt, !0));
              };
            if (Dt.name === "AESV3")
              return function() {
                return new ct(Lt);
              };
            throw new rt.FormatError("Unknown crypto method");
          }, _r(jt, Et, new Uint8Array([40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8, 46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105, 122]));
          let bt = jt;
          at.CipherTransformFactory = bt;
        },
        /* 226 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.DecryptStream = void 0;
          var rt = ot(169);
          const st = 512;
          class lt extends rt.DecodeStream {
            constructor(it, ut, ft) {
              super(ut), this.str = it, this.dict = it.dict, this.decrypt = ft, this.nextChunk = null, this.initialized = !1;
            }
            readBlock() {
              var pt;
              let it;
              if (this.initialized ? it = this.nextChunk : (it = this.str.getBytes(st), this.initialized = !0), !it || it.length === 0) {
                this.eof = !0;
                return;
              }
              this.nextChunk = this.str.getBytes(st);
              const ut = ((pt = this.nextChunk) == null ? void 0 : pt.length) > 0, ft = this.decrypt;
              it = ft(it, !ut);
              const ht = this.bufferLength, dt = ht + it.length;
              this.ensureBuffer(dt).set(it, ht), this.bufferLength = dt;
            }
          }
          at.DecryptStream = lt;
        },
        /* 227 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.ObjectLoader = void 0, ot(140);
          var rt = ot(151), st = ot(152), lt = ot(150), et = ot(145);
          function it(ht) {
            return ht instanceof rt.Ref || ht instanceof rt.Dict || ht instanceof st.BaseStream || Array.isArray(ht);
          }
          function ut(ht, dt) {
            if (ht instanceof rt.Dict)
              ht = ht.getRawValues();
            else if (ht instanceof st.BaseStream)
              ht = ht.dict.getRawValues();
            else if (!Array.isArray(ht))
              return;
            for (const gt of ht)
              it(gt) && dt.push(gt);
          }
          class ft {
            constructor(dt, gt, pt) {
              this.dict = dt, this.keys = gt, this.xref = pt, this.refSet = null;
            }
            async load() {
              if (this.xref.stream.isDataLoaded)
                return;
              const {
                keys: dt,
                dict: gt
              } = this;
              this.refSet = new rt.RefSet();
              const pt = [];
              for (const mt of dt) {
                const ct = gt.getRaw(mt);
                ct !== void 0 && pt.push(ct);
              }
              return this._walk(pt);
            }
            async _walk(dt) {
              const gt = [], pt = [];
              for (; dt.length; ) {
                let mt = dt.pop();
                if (mt instanceof rt.Ref) {
                  if (this.refSet.has(mt))
                    continue;
                  try {
                    this.refSet.put(mt), mt = this.xref.fetch(mt);
                  } catch (ct) {
                    if (!(ct instanceof lt.MissingDataException)) {
                      (0, et.warn)(`ObjectLoader._walk - requesting all data: "${ct}".`), this.refSet = null;
                      const {
                        manager: vt
                      } = this.xref.stream;
                      return vt.requestAllChunks();
                    }
                    gt.push(mt), pt.push({
                      begin: ct.begin,
                      end: ct.end
                    });
                  }
                }
                if (mt instanceof st.BaseStream) {
                  const ct = mt.getBaseStreams();
                  if (ct) {
                    let vt = !1;
                    for (const At of ct)
                      At.isDataLoaded || (vt = !0, pt.push({
                        begin: At.start,
                        end: At.end
                      }));
                    vt && gt.push(mt);
                  }
                }
                ut(mt, dt);
              }
              if (pt.length) {
                await this.xref.stream.manager.requestRanges(pt);
                for (const mt of gt)
                  mt instanceof rt.Ref && this.refSet.remove(mt);
                return this._walk(gt);
              }
              this.refSet = null;
            }
          }
          at.ObjectLoader = ft;
        },
        /* 228 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.XFAFactory = void 0, ot(140);
          var rt = ot(229), st = ot(230), lt = ot(243), et = ot(239), it = ot(238), ut = ot(145), ft = ot(244), ht = ot(254);
          class dt {
            constructor(pt) {
              try {
                this.root = new ft.XFAParser().parse(dt._createDocument(pt));
                const mt = new st.Binder(this.root);
                this.form = mt.bind(), this.dataHandler = new lt.DataHandler(this.root, mt.getData()), this.form[rt.$globalData].template = this.form;
              } catch (mt) {
                (0, ut.warn)(`XFA - an error occurred during parsing and binding: ${mt}`);
              }
            }
            isValid() {
              return this.root && this.form;
            }
            _createPagesHelper() {
              const pt = this.form[rt.$toPages]();
              return new Promise((mt, ct) => {
                const vt = () => {
                  try {
                    const At = pt.next();
                    At.done ? mt(At.value) : setTimeout(vt, 0);
                  } catch (At) {
                    ct(At);
                  }
                };
                setTimeout(vt, 0);
              });
            }
            async _createPages() {
              try {
                this.pages = await this._createPagesHelper(), this.dims = this.pages.children.map((pt) => {
                  const {
                    width: mt,
                    height: ct
                  } = pt.attributes.style;
                  return [0, 0, parseInt(mt), parseInt(ct)];
                });
              } catch (pt) {
                (0, ut.warn)(`XFA - an error occurred during layout: ${pt}`);
              }
            }
            getBoundingBox(pt) {
              return this.dims[pt];
            }
            async getNumPages() {
              return this.pages || await this._createPages(), this.dims.length;
            }
            setImages(pt) {
              this.form[rt.$globalData].images = pt;
            }
            setFonts(pt) {
              this.form[rt.$globalData].fontFinder = new et.FontFinder(pt);
              const mt = [];
              for (let ct of this.form[rt.$globalData].usedTypefaces)
                ct = (0, it.stripQuotes)(ct), this.form[rt.$globalData].fontFinder.find(ct) || mt.push(ct);
              return mt.length > 0 ? mt : null;
            }
            appendFonts(pt, mt) {
              this.form[rt.$globalData].fontFinder.add(pt, mt);
            }
            async getPages() {
              this.pages || await this._createPages();
              const pt = this.pages;
              return this.pages = null, pt;
            }
            serializeData(pt) {
              return this.dataHandler.serialize(pt);
            }
            static _createDocument(pt) {
              return pt["/xdp:xdp"] ? Object.values(pt).join("") : pt["xdp:xdp"];
            }
            static getRichTextAsHtml(pt) {
              if (!pt || typeof pt != "string")
                return null;
              try {
                let mt = new ft.XFAParser(ht.XhtmlNamespace, !0).parse(pt);
                if (!["body", "xhtml"].includes(mt[rt.$nodeName])) {
                  const xt = ht.XhtmlNamespace.body({});
                  xt[rt.$appendChild](mt), mt = xt;
                }
                const ct = mt[rt.$toHTML]();
                if (!ct.success)
                  return null;
                const {
                  html: vt
                } = ct, {
                  attributes: At
                } = vt;
                return At && (At.class && (At.class = At.class.filter((xt) => !xt.startsWith("xfa"))), At.dir = "auto"), {
                  html: vt,
                  str: mt[rt.$text]()
                };
              } catch (mt) {
                (0, ut.warn)(`XFA - an error occurred during parsing of rich text: ${mt}`);
              }
              return null;
            }
          }
          at.XFAFactory = dt;
        },
        /* 229 */
        /***/
        (nt, at) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.$uid = at.$toStyle = at.$toString = at.$toPages = at.$toHTML = at.$text = at.$tabIndex = at.$setValue = at.$setSetAttributes = at.$setId = at.$searchNode = at.$root = at.$resolvePrototypes = at.$removeChild = at.$pushPara = at.$pushGlyphs = at.$popPara = at.$onText = at.$onChildCheck = at.$onChild = at.$nsAttributes = at.$nodeName = at.$namespaceId = at.$lastAttribute = at.$isUsable = at.$isTransparent = at.$isThereMoreWidth = at.$isSplittable = at.$isNsAgnostic = at.$isDescendent = at.$isDataValue = at.$isCDATAXml = at.$isBindable = at.$insertAt = at.$indexOf = at.$ids = at.$hasSettableValue = at.$globalData = at.$getTemplateRoot = at.$getSubformParent = at.$getRealChildrenByNameIt = at.$getParent = at.$getNextPage = at.$getExtra = at.$getDataValue = at.$getContainedChildren = at.$getChildrenByNameIt = at.$getChildrenByName = at.$getChildrenByClass = at.$getChildren = at.$getAvailableSpace = at.$getAttributes = at.$getAttributeIt = at.$flushHTML = at.$finalize = at.$extra = at.$dump = at.$data = at.$content = at.$consumed = at.$clone = at.$cleanup = at.$cleanPage = at.$clean = at.$childrenToHTML = at.$appendChild = at.$addHTML = at.$acceptWhitespace = void 0;
          const ot = Symbol();
          at.$acceptWhitespace = ot;
          const rt = Symbol();
          at.$addHTML = rt;
          const st = Symbol();
          at.$appendChild = st;
          const lt = Symbol();
          at.$childrenToHTML = lt;
          const et = Symbol();
          at.$clean = et;
          const it = Symbol();
          at.$cleanPage = it;
          const ut = Symbol();
          at.$cleanup = ut;
          const ft = Symbol();
          at.$clone = ft;
          const ht = Symbol();
          at.$consumed = ht;
          const dt = Symbol("content");
          at.$content = dt;
          const gt = Symbol("data");
          at.$data = gt;
          const pt = Symbol();
          at.$dump = pt;
          const mt = Symbol("extra");
          at.$extra = mt;
          const ct = Symbol();
          at.$finalize = ct;
          const vt = Symbol();
          at.$flushHTML = vt;
          const At = Symbol();
          at.$getAttributeIt = At;
          const xt = Symbol();
          at.$getAttributes = xt;
          const bt = Symbol();
          at.$getAvailableSpace = bt;
          const Et = Symbol();
          at.$getChildrenByClass = Et;
          const St = Symbol();
          at.$getChildrenByName = St;
          const Bt = Symbol();
          at.$getChildrenByNameIt = Bt;
          const Ot = Symbol();
          at.$getDataValue = Ot;
          const Pt = Symbol();
          at.$getExtra = Pt;
          const wt = Symbol();
          at.$getRealChildrenByNameIt = wt;
          const Ct = Symbol();
          at.$getChildren = Ct;
          const It = Symbol();
          at.$getContainedChildren = It;
          const yt = Symbol();
          at.$getNextPage = yt;
          const Rt = Symbol();
          at.$getSubformParent = Rt;
          const kt = Symbol();
          at.$getParent = kt;
          const jt = Symbol();
          at.$getTemplateRoot = jt;
          const Ht = Symbol();
          at.$globalData = Ht;
          const Ft = Symbol();
          at.$hasSettableValue = Ft;
          const _t = Symbol();
          at.$ids = _t;
          const Nt = Symbol();
          at.$indexOf = Nt;
          const Mt = Symbol();
          at.$insertAt = Mt;
          const Lt = Symbol();
          at.$isCDATAXml = Lt;
          const $t = Symbol();
          at.$isBindable = $t;
          const Tt = Symbol();
          at.$isDataValue = Tt;
          const Dt = Symbol();
          at.$isDescendent = Dt;
          const Ut = Symbol();
          at.$isNsAgnostic = Ut;
          const Vt = Symbol();
          at.$isSplittable = Vt;
          const Qt = Symbol();
          at.$isThereMoreWidth = Qt;
          const qt = Symbol();
          at.$isTransparent = qt;
          const Zt = Symbol();
          at.$isUsable = Zt;
          const ar = Symbol();
          at.$lastAttribute = ar;
          const Jt = Symbol("namespaceId");
          at.$namespaceId = Jt;
          const rr = Symbol("nodeName");
          at.$nodeName = rr;
          const Yt = Symbol();
          at.$nsAttributes = Yt;
          const Kt = Symbol();
          at.$onChild = Kt;
          const nr = Symbol();
          at.$onChildCheck = nr;
          const tr = Symbol();
          at.$onText = tr;
          const ir = Symbol();
          at.$pushGlyphs = ir;
          const sr = Symbol();
          at.$popPara = sr;
          const cr = Symbol();
          at.$pushPara = cr;
          const or = Symbol();
          at.$removeChild = or;
          const Xt = Symbol("root");
          at.$root = Xt;
          const Gt = Symbol();
          at.$resolvePrototypes = Gt;
          const Wt = Symbol();
          at.$searchNode = Wt;
          const er = Symbol();
          at.$setId = er;
          const lr = Symbol();
          at.$setSetAttributes = lr;
          const ur = Symbol();
          at.$setValue = ur;
          const pr = Symbol();
          at.$tabIndex = pr;
          const yr = Symbol();
          at.$text = yr;
          const Er = Symbol();
          at.$toPages = Er;
          const br = Symbol();
          at.$toHTML = br;
          const gr = Symbol();
          at.$toString = gr;
          const Ar = Symbol();
          at.$toStyle = Ar;
          const Sr = Symbol("uid");
          at.$uid = Sr;
        },
        /* 230 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Binder = void 0, ot(140);
          var rt = ot(229), st = ot(231), lt = ot(242), et = ot(241), it = ot(235), ut = ot(145);
          const ft = it.NamespaceIds.datasets.id;
          function ht(gt) {
            const pt = new st.Text({});
            return pt[rt.$content] = gt, pt;
          }
          class dt {
            constructor(pt) {
              var mt;
              this.root = pt, this.datasets = pt.datasets, this.data = ((mt = pt.datasets) == null ? void 0 : mt.data) || new et.XmlObject(it.NamespaceIds.datasets.id, "data"), this.emptyMerge = this.data[rt.$getChildren]().length === 0, this.root.form = this.form = pt.template[rt.$clone]();
            }
            _isConsumeData() {
              return !this.emptyMerge && this._mergeMode;
            }
            _isMatchTemplate() {
              return !this._isConsumeData();
            }
            bind() {
              return this._bindElement(this.form, this.data), this.form;
            }
            getData() {
              return this.data;
            }
            _bindValue(pt, mt, ct) {
              var vt, At;
              if (pt[rt.$data] = mt, pt[rt.$hasSettableValue]())
                if (mt[rt.$isDataValue]()) {
                  const xt = mt[rt.$getDataValue]();
                  pt[rt.$setValue](ht(xt));
                } else if (pt instanceof st.Field && ((At = (vt = pt.ui) == null ? void 0 : vt.choiceList) == null ? void 0 : At.open) === "multiSelect") {
                  const xt = mt[rt.$getChildren]().map((bt) => bt[rt.$content].trim()).join(`
`);
                  pt[rt.$setValue](ht(xt));
                } else
                  this._isConsumeData() && (0, ut.warn)("XFA - Nodes haven't the same type.");
              else
                !mt[rt.$isDataValue]() || this._isMatchTemplate() ? this._bindElement(pt, mt) : (0, ut.warn)("XFA - Nodes haven't the same type.");
            }
            _findDataByNameToConsume(pt, mt, ct, vt) {
              if (!pt)
                return null;
              let At, xt;
              for (let bt = 0; bt < 3; bt++) {
                for (At = ct[rt.$getRealChildrenByNameIt](pt, !1, !0); xt = At.next().value, !!xt; )
                  if (mt === xt[rt.$isDataValue]())
                    return xt;
                if (ct[rt.$namespaceId] === it.NamespaceIds.datasets.id && ct[rt.$nodeName] === "data")
                  break;
                ct = ct[rt.$getParent]();
              }
              return vt ? (At = this.data[rt.$getRealChildrenByNameIt](pt, !0, !1), xt = At.next().value, xt || (At = this.data[rt.$getAttributeIt](pt, !0), xt = At.next().value, xt != null && xt[rt.$isDataValue]()) ? xt : null) : null;
            }
            _setProperties(pt, mt) {
              if (pt.hasOwnProperty("setProperty"))
                for (const {
                  ref: ct,
                  target: vt,
                  connection: At
                } of pt.setProperty.children) {
                  if (At || !ct)
                    continue;
                  const xt = (0, lt.searchNode)(this.root, mt, ct, !1, !1);
                  if (!xt) {
                    (0, ut.warn)(`XFA - Invalid reference: ${ct}.`);
                    continue;
                  }
                  const [bt] = xt;
                  if (!bt[rt.$isDescendent](this.data)) {
                    (0, ut.warn)("XFA - Invalid node: must be a data node.");
                    continue;
                  }
                  const Et = (0, lt.searchNode)(this.root, pt, vt, !1, !1);
                  if (!Et) {
                    (0, ut.warn)(`XFA - Invalid target: ${vt}.`);
                    continue;
                  }
                  const [St] = Et;
                  if (!St[rt.$isDescendent](pt)) {
                    (0, ut.warn)("XFA - Invalid target: must be a property or subproperty.");
                    continue;
                  }
                  const Bt = St[rt.$getParent]();
                  if (St instanceof st.SetProperty || Bt instanceof st.SetProperty) {
                    (0, ut.warn)("XFA - Invalid target: cannot be a setProperty or one of its properties.");
                    continue;
                  }
                  if (St instanceof st.BindItems || Bt instanceof st.BindItems) {
                    (0, ut.warn)("XFA - Invalid target: cannot be a bindItems or one of its properties.");
                    continue;
                  }
                  const Ot = bt[rt.$text](), Pt = St[rt.$nodeName];
                  if (St instanceof et.XFAAttribute) {
                    const wt = /* @__PURE__ */ Object.create(null);
                    wt[Pt] = Ot;
                    const Ct = Reflect.construct(Object.getPrototypeOf(Bt).constructor, [wt]);
                    Bt[Pt] = Ct[Pt];
                    continue;
                  }
                  if (!St.hasOwnProperty(rt.$content)) {
                    (0, ut.warn)("XFA - Invalid node to use in setProperty");
                    continue;
                  }
                  St[rt.$data] = bt, St[rt.$content] = Ot, St[rt.$finalize]();
                }
            }
            _bindItems(pt, mt) {
              if (!pt.hasOwnProperty("items") || !pt.hasOwnProperty("bindItems") || pt.bindItems.isEmpty())
                return;
              for (const At of pt.items.children)
                pt[rt.$removeChild](At);
              pt.items.clear();
              const ct = new st.Items({}), vt = new st.Items({});
              pt[rt.$appendChild](ct), pt.items.push(ct), pt[rt.$appendChild](vt), pt.items.push(vt);
              for (const {
                ref: At,
                labelRef: xt,
                valueRef: bt,
                connection: Et
              } of pt.bindItems.children) {
                if (Et || !At)
                  continue;
                const St = (0, lt.searchNode)(this.root, mt, At, !1, !1);
                if (!St) {
                  (0, ut.warn)(`XFA - Invalid reference: ${At}.`);
                  continue;
                }
                for (const Bt of St) {
                  if (!Bt[rt.$isDescendent](this.datasets)) {
                    (0, ut.warn)(`XFA - Invalid ref (${At}): must be a datasets child.`);
                    continue;
                  }
                  const Ot = (0, lt.searchNode)(this.root, Bt, xt, !0, !1);
                  if (!Ot) {
                    (0, ut.warn)(`XFA - Invalid label: ${xt}.`);
                    continue;
                  }
                  const [Pt] = Ot;
                  if (!Pt[rt.$isDescendent](this.datasets)) {
                    (0, ut.warn)("XFA - Invalid label: must be a datasets child.");
                    continue;
                  }
                  const wt = (0, lt.searchNode)(this.root, Bt, bt, !0, !1);
                  if (!wt) {
                    (0, ut.warn)(`XFA - Invalid value: ${bt}.`);
                    continue;
                  }
                  const [Ct] = wt;
                  if (!Ct[rt.$isDescendent](this.datasets)) {
                    (0, ut.warn)("XFA - Invalid value: must be a datasets child.");
                    continue;
                  }
                  const It = ht(Pt[rt.$text]()), yt = ht(Ct[rt.$text]());
                  ct[rt.$appendChild](It), ct.text.push(It), vt[rt.$appendChild](yt), vt.text.push(yt);
                }
              }
            }
            _bindOccurrences(pt, mt, ct) {
              let vt;
              if (mt.length > 1 && (vt = pt[rt.$clone](), vt[rt.$removeChild](vt.occur), vt.occur = null), this._bindValue(pt, mt[0], ct), this._setProperties(pt, mt[0]), this._bindItems(pt, mt[0]), mt.length === 1)
                return;
              const At = pt[rt.$getParent](), xt = pt[rt.$nodeName], bt = At[rt.$indexOf](pt);
              for (let Et = 1, St = mt.length; Et < St; Et++) {
                const Bt = mt[Et], Ot = vt[rt.$clone]();
                At[xt].push(Ot), At[rt.$insertAt](bt + Et, Ot), this._bindValue(Ot, Bt, ct), this._setProperties(Ot, Bt), this._bindItems(Ot, Bt);
              }
            }
            _createOccurrences(pt) {
              if (!this.emptyMerge)
                return;
              const {
                occur: mt
              } = pt;
              if (!mt || mt.initial <= 1)
                return;
              const ct = pt[rt.$getParent](), vt = pt[rt.$nodeName];
              if (!(ct[vt] instanceof et.XFAObjectArray))
                return;
              let At;
              pt.name ? At = ct[vt].children.filter((Et) => Et.name === pt.name).length : At = ct[vt].children.length;
              const xt = ct[rt.$indexOf](pt) + 1, bt = mt.initial - At;
              if (bt) {
                const Et = pt[rt.$clone]();
                Et[rt.$removeChild](Et.occur), Et.occur = null, ct[vt].push(Et), ct[rt.$insertAt](xt, Et);
                for (let St = 1; St < bt; St++) {
                  const Bt = Et[rt.$clone]();
                  ct[vt].push(Bt), ct[rt.$insertAt](xt + St, Bt);
                }
              }
            }
            _getOccurInfo(pt) {
              const {
                name: mt,
                occur: ct
              } = pt;
              if (!ct || !mt)
                return [1, 1];
              const vt = ct.max === -1 ? 1 / 0 : ct.max;
              return [ct.min, vt];
            }
            _setAndBind(pt, mt) {
              this._setProperties(pt, mt), this._bindItems(pt, mt), this._bindElement(pt, mt);
            }
            _bindElement(pt, mt) {
              const ct = [];
              this._createOccurrences(pt);
              for (const vt of pt[rt.$getChildren]()) {
                if (vt[rt.$data])
                  continue;
                if (this._mergeMode === void 0 && vt[rt.$nodeName] === "subform") {
                  this._mergeMode = vt.mergeMode === "consumeData";
                  const Ot = mt[rt.$getChildren]();
                  if (Ot.length > 0)
                    this._bindOccurrences(vt, [Ot[0]], null);
                  else if (this.emptyMerge) {
                    const Pt = mt[rt.$namespaceId] === ft ? -1 : mt[rt.$namespaceId], wt = vt[rt.$data] = new et.XmlObject(Pt, vt.name || "root");
                    mt[rt.$appendChild](wt), this._bindElement(vt, wt);
                  }
                  continue;
                }
                if (!vt[rt.$isBindable]())
                  continue;
                let At = !1, xt = null, bt = null, Et = null;
                if (vt.bind) {
                  switch (vt.bind.match) {
                    case "none":
                      this._setAndBind(vt, mt);
                      continue;
                    case "global":
                      At = !0;
                      break;
                    case "dataRef":
                      if (!vt.bind.ref) {
                        (0, ut.warn)(`XFA - ref is empty in node ${vt[rt.$nodeName]}.`), this._setAndBind(vt, mt);
                        continue;
                      }
                      bt = vt.bind.ref;
                      break;
                  }
                  vt.bind.picture && (xt = vt.bind.picture[rt.$content]);
                }
                const [St, Bt] = this._getOccurInfo(vt);
                if (bt)
                  if (Et = (0, lt.searchNode)(this.root, mt, bt, !0, !1), Et === null) {
                    if (Et = (0, lt.createDataNode)(this.data, mt, bt), !Et)
                      continue;
                    this._isConsumeData() && (Et[rt.$consumed] = !0), this._setAndBind(vt, Et);
                    continue;
                  } else
                    this._isConsumeData() && (Et = Et.filter((Ot) => !Ot[rt.$consumed])), Et.length > Bt ? Et = Et.slice(0, Bt) : Et.length === 0 && (Et = null), Et && this._isConsumeData() && Et.forEach((Ot) => {
                      Ot[rt.$consumed] = !0;
                    });
                else {
                  if (!vt.name) {
                    this._setAndBind(vt, mt);
                    continue;
                  }
                  if (this._isConsumeData()) {
                    const Ot = [];
                    for (; Ot.length < Bt; ) {
                      const Pt = this._findDataByNameToConsume(vt.name, vt[rt.$hasSettableValue](), mt, At);
                      if (!Pt)
                        break;
                      Pt[rt.$consumed] = !0, Ot.push(Pt);
                    }
                    Et = Ot.length > 0 ? Ot : null;
                  } else {
                    if (Et = mt[rt.$getRealChildrenByNameIt](vt.name, !1, this.emptyMerge).next().value, !Et) {
                      if (St === 0) {
                        ct.push(vt);
                        continue;
                      }
                      const Ot = mt[rt.$namespaceId] === ft ? -1 : mt[rt.$namespaceId];
                      Et = vt[rt.$data] = new et.XmlObject(Ot, vt.name), this.emptyMerge && (Et[rt.$consumed] = !0), mt[rt.$appendChild](Et), this._setAndBind(vt, Et);
                      continue;
                    }
                    this.emptyMerge && (Et[rt.$consumed] = !0), Et = [Et];
                  }
                }
                Et ? this._bindOccurrences(vt, Et, xt) : St > 0 ? this._setAndBind(vt, mt) : ct.push(vt);
              }
              ct.forEach((vt) => vt[rt.$getParent]()[rt.$removeChild](vt));
            }
          }
          at.Binder = dt;
        },
        /* 231 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Value = at.Text = at.TemplateNamespace = at.Template = at.SetProperty = at.Items = at.Field = at.BindItems = void 0, ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138), ot(140), ot(232), ot(146), ot(148), ot(149);
          var rt = ot(229), st = ot(235), lt = ot(236), et = ot(237), it = ot(241), ut = ot(238), ft = ot(145), ht = ot(239), dt = ot(150), gt = ot(242);
          const pt = st.NamespaceIds.template.id, mt = "http://www.w3.org/2000/svg", ct = 2, vt = 3, At = 5e3, xt = /^H(\d+)$/, bt = /* @__PURE__ */ new Set(["image/gif", "image/jpeg", "image/jpg", "image/pjpeg", "image/png", "image/apng", "image/x-png", "image/bmp", "image/x-ms-bmp", "image/tiff", "image/tif", "application/octet-stream"]), Et = [[[66, 77], "image/bmp"], [[255, 216, 255], "image/jpeg"], [[73, 73, 42, 0], "image/tiff"], [[77, 77, 0, 42], "image/tiff"], [[71, 73, 70, 56, 57, 97], "image/gif"], [[137, 80, 78, 71, 13, 10, 26, 10], "image/png"]];
          function St(Jr) {
            if (!Jr || !Jr.border)
              return {
                w: 0,
                h: 0
              };
            const zt = Jr.border[rt.$getExtra]();
            return zt ? {
              w: zt.widths[0] + zt.widths[2] + zt.insets[0] + zt.insets[2],
              h: zt.widths[1] + zt.widths[3] + zt.insets[1] + zt.insets[3]
            } : {
              w: 0,
              h: 0
            };
          }
          function Bt(Jr) {
            return Jr.margin && (Jr.margin.topInset || Jr.margin.rightInset || Jr.margin.bottomInset || Jr.margin.leftInset);
          }
          function Ot(Jr, zt) {
            if (!Jr.value) {
              const dr = new Qn({});
              Jr[rt.$appendChild](dr), Jr.value = dr;
            }
            Jr.value[rt.$setValue](zt);
          }
          function* Pt(Jr) {
            for (const zt of Jr[rt.$getChildren]()) {
              if (zt instanceof eo) {
                yield* zt[rt.$getContainedChildren]();
                continue;
              }
              yield zt;
            }
          }
          function wt(Jr) {
            var zt;
            return ((zt = Jr.validate) == null ? void 0 : zt.nullTest) === "error";
          }
          function Ct(Jr) {
            for (; Jr; ) {
              if (!Jr.traversal) {
                Jr[rt.$tabIndex] = Jr[rt.$getParent]()[rt.$tabIndex];
                return;
              }
              if (Jr[rt.$tabIndex])
                return;
              let zt = null;
              for (const ln of Jr.traversal[rt.$getChildren]())
                if (ln.operation === "next") {
                  zt = ln;
                  break;
                }
              if (!zt || !zt.ref) {
                Jr[rt.$tabIndex] = Jr[rt.$getParent]()[rt.$tabIndex];
                return;
              }
              const dr = Jr[rt.$getTemplateRoot]();
              Jr[rt.$tabIndex] = ++dr[rt.$tabIndex];
              const qr = dr[rt.$searchNode](zt.ref, Jr);
              if (!qr)
                return;
              Jr = qr[0];
            }
          }
          function It(Jr, zt) {
            var qr;
            const dr = Jr.assist;
            if (dr) {
              const ln = dr[rt.$toHTML]();
              ln && (zt.title = ln);
              const xn = dr.role.match(xt);
              if (xn) {
                const Sn = "heading", $n = xn[1];
                zt.role = Sn, zt["aria-level"] = $n;
              }
            }
            if (Jr.layout === "table")
              zt.role = "table";
            else if (Jr.layout === "row")
              zt.role = "row";
            else {
              const ln = Jr[rt.$getParent]();
              ln.layout === "row" && (zt.role = ((qr = ln.assist) == null ? void 0 : qr.role) === "TH" ? "columnheader" : "cell");
            }
          }
          function yt(Jr) {
            if (!Jr.assist)
              return null;
            const zt = Jr.assist;
            return zt.speak && zt.speak[rt.$content] !== "" ? zt.speak[rt.$content] : zt.toolTip ? zt.toolTip[rt.$content] : null;
          }
          function Rt(Jr) {
            return ut.HTMLResult.success({
              name: "div",
              attributes: {
                class: ["xfaRich"],
                style: /* @__PURE__ */ Object.create(null)
              },
              children: [{
                name: "span",
                attributes: {
                  style: /* @__PURE__ */ Object.create(null)
                },
                value: Jr
              }]
            });
          }
          function kt(Jr) {
            const zt = Jr[rt.$getTemplateRoot]();
            zt[rt.$extra].firstUnsplittable === null && (zt[rt.$extra].firstUnsplittable = Jr, zt[rt.$extra].noLayoutFailure = !0);
          }
          function jt(Jr) {
            const zt = Jr[rt.$getTemplateRoot]();
            zt[rt.$extra].firstUnsplittable === Jr && (zt[rt.$extra].noLayoutFailure = !1);
          }
          function Ht(Jr) {
            if (Jr[rt.$extra] || (Jr[rt.$extra] = /* @__PURE__ */ Object.create(null), Jr.targetType === "auto"))
              return !1;
            const zt = Jr[rt.$getTemplateRoot]();
            let dr = null;
            if (Jr.target) {
              if (dr = zt[rt.$searchNode](Jr.target, Jr[rt.$getParent]()), !dr)
                return !1;
              dr = dr[0];
            }
            const {
              currentPageArea: qr,
              currentContentArea: ln
            } = zt[rt.$extra];
            if (Jr.targetType === "pageArea")
              return dr instanceof bn || (dr = null), Jr.startNew ? (Jr[rt.$extra].target = dr || qr, !0) : dr && dr !== qr ? (Jr[rt.$extra].target = dr, !0) : !1;
            dr instanceof Xt || (dr = null);
            const cn = dr && dr[rt.$getParent]();
            let xn, Sn = cn;
            if (Jr.startNew)
              if (dr) {
                const $n = cn.contentArea.children, On = $n.indexOf(ln), _n = $n.indexOf(dr);
                On !== -1 && On < _n && (Sn = null), xn = _n - 1;
              } else
                xn = qr.contentArea.children.indexOf(ln);
            else if (dr && dr !== ln)
              xn = cn.contentArea.children.indexOf(dr) - 1, Sn = cn === qr ? null : cn;
            else
              return !1;
            return Jr[rt.$extra].target = Sn, Jr[rt.$extra].index = xn, !0;
          }
          function Ft(Jr, zt, dr) {
            const qr = Jr[rt.$getTemplateRoot](), ln = qr[rt.$extra].noLayoutFailure, cn = zt[rt.$getSubformParent];
            zt[rt.$getSubformParent] = () => Jr, qr[rt.$extra].noLayoutFailure = !0;
            const xn = zt[rt.$toHTML](dr);
            Jr[rt.$addHTML](xn.html, xn.bbox), qr[rt.$extra].noLayoutFailure = ln, zt[rt.$getSubformParent] = cn;
          }
          class _t extends it.StringObject {
            constructor(zt) {
              super(pt, "appearanceFilter"), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class Nt extends it.XFAObject {
            constructor(zt) {
              super(pt, "arc", !0), this.circular = (0, ut.getInteger)({
                data: zt.circular,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.hand = (0, ut.getStringOption)(zt.hand, ["even", "left", "right"]), this.id = zt.id || "", this.startAngle = (0, ut.getFloat)({
                data: zt.startAngle,
                defaultValue: 0,
                validate: (dr) => !0
              }), this.sweepAngle = (0, ut.getFloat)({
                data: zt.sweepAngle,
                defaultValue: 360,
                validate: (dr) => !0
              }), this.use = zt.use || "", this.usehref = zt.usehref || "", this.edge = null, this.fill = null;
            }
            [rt.$toHTML]() {
              var $n;
              const zt = this.edge || new Ar({}), dr = zt[rt.$toStyle](), qr = /* @__PURE__ */ Object.create(null);
              (($n = this.fill) == null ? void 0 : $n.presence) === "visible" ? Object.assign(qr, this.fill[rt.$toStyle]()) : qr.fill = "transparent", qr.strokeWidth = (0, et.measureToString)(zt.presence === "visible" ? zt.thickness : 0), qr.stroke = dr.color;
              let ln;
              const cn = {
                xmlns: mt,
                style: {
                  width: "100%",
                  height: "100%",
                  overflow: "visible"
                }
              };
              if (this.sweepAngle === 360)
                ln = {
                  name: "ellipse",
                  attributes: {
                    xmlns: mt,
                    cx: "50%",
                    cy: "50%",
                    rx: "50%",
                    ry: "50%",
                    style: qr
                  }
                };
              else {
                const On = this.startAngle * Math.PI / 180, _n = this.sweepAngle * Math.PI / 180, Kn = this.sweepAngle > 180 ? 1 : 0, [Vn, Xn, _i, Dn] = [50 * (1 + Math.cos(On)), 50 * (1 - Math.sin(On)), 50 * (1 + Math.cos(On + _n)), 50 * (1 - Math.sin(On + _n))];
                ln = {
                  name: "path",
                  attributes: {
                    xmlns: mt,
                    d: `M ${Vn} ${Xn} A 50 50 0 ${Kn} 0 ${_i} ${Dn}`,
                    vectorEffect: "non-scaling-stroke",
                    style: qr
                  }
                }, Object.assign(cn, {
                  viewBox: "0 0 100 100",
                  preserveAspectRatio: "none"
                });
              }
              const xn = {
                name: "svg",
                children: [ln],
                attributes: cn
              }, Sn = this[rt.$getParent]()[rt.$getParent]();
              return Bt(Sn) ? ut.HTMLResult.success({
                name: "div",
                attributes: {
                  style: {
                    display: "inline",
                    width: "100%",
                    height: "100%"
                  }
                },
                children: [xn]
              }) : (xn.attributes.style.position = "absolute", ut.HTMLResult.success(xn));
            }
          }
          class Mt extends it.XFAObject {
            constructor(zt) {
              super(pt, "area", !0), this.colSpan = (0, ut.getInteger)({
                data: zt.colSpan,
                defaultValue: 1,
                validate: (dr) => dr >= 1 || dr === -1
              }), this.id = zt.id || "", this.name = zt.name || "", this.relevant = (0, ut.getRelevant)(zt.relevant), this.use = zt.use || "", this.usehref = zt.usehref || "", this.x = (0, ut.getMeasurement)(zt.x, "0pt"), this.y = (0, ut.getMeasurement)(zt.y, "0pt"), this.desc = null, this.extras = null, this.area = new it.XFAObjectArray(), this.draw = new it.XFAObjectArray(), this.exObject = new it.XFAObjectArray(), this.exclGroup = new it.XFAObjectArray(), this.field = new it.XFAObjectArray(), this.subform = new it.XFAObjectArray(), this.subformSet = new it.XFAObjectArray();
            }
            *[rt.$getContainedChildren]() {
              yield* Pt(this);
            }
            [rt.$isTransparent]() {
              return !0;
            }
            [rt.$isBindable]() {
              return !0;
            }
            [rt.$addHTML](zt, dr) {
              const [qr, ln, cn, xn] = dr;
              this[rt.$extra].width = Math.max(this[rt.$extra].width, qr + cn), this[rt.$extra].height = Math.max(this[rt.$extra].height, ln + xn), this[rt.$extra].children.push(zt);
            }
            [rt.$getAvailableSpace]() {
              return this[rt.$extra].availableSpace;
            }
            [rt.$toHTML](zt) {
              const dr = (0, et.toStyle)(this, "position"), qr = {
                style: dr,
                id: this[rt.$uid],
                class: ["xfaArea"]
              };
              (0, et.isPrintOnly)(this) && qr.class.push("xfaPrintOnly"), this.name && (qr.xfaName = this.name);
              const ln = [];
              this[rt.$extra] = {
                children: ln,
                width: 0,
                height: 0,
                availableSpace: zt
              };
              const cn = this[rt.$childrenToHTML]({
                filter: /* @__PURE__ */ new Set(["area", "draw", "field", "exclGroup", "subform", "subformSet"]),
                include: !0
              });
              if (!cn.success)
                return cn.isBreak() ? cn : (delete this[rt.$extra], ut.HTMLResult.FAILURE);
              dr.width = (0, et.measureToString)(this[rt.$extra].width), dr.height = (0, et.measureToString)(this[rt.$extra].height);
              const xn = {
                name: "div",
                attributes: qr,
                children: ln
              }, Sn = [this.x, this.y, this[rt.$extra].width, this[rt.$extra].height];
              return delete this[rt.$extra], ut.HTMLResult.success(xn, Sn);
            }
          }
          class Lt extends it.XFAObject {
            constructor(zt) {
              super(pt, "assist", !0), this.id = zt.id || "", this.role = zt.role || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.speak = null, this.toolTip = null;
            }
            [rt.$toHTML]() {
              var zt;
              return ((zt = this.toolTip) == null ? void 0 : zt[rt.$content]) || null;
            }
          }
          class $t extends it.XFAObject {
            constructor(zt) {
              super(pt, "barcode", !0), this.charEncoding = (0, ut.getKeyword)({
                data: zt.charEncoding ? zt.charEncoding.toLowerCase() : "",
                defaultValue: "",
                validate: (dr) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(dr) || dr.match(/iso-8859-\d{2}/)
              }), this.checksum = (0, ut.getStringOption)(zt.checksum, ["none", "1mod10", "1mod10_1mod11", "2mod10", "auto"]), this.dataColumnCount = (0, ut.getInteger)({
                data: zt.dataColumnCount,
                defaultValue: -1,
                validate: (dr) => dr >= 0
              }), this.dataLength = (0, ut.getInteger)({
                data: zt.dataLength,
                defaultValue: -1,
                validate: (dr) => dr >= 0
              }), this.dataPrep = (0, ut.getStringOption)(zt.dataPrep, ["none", "flateCompress"]), this.dataRowCount = (0, ut.getInteger)({
                data: zt.dataRowCount,
                defaultValue: -1,
                validate: (dr) => dr >= 0
              }), this.endChar = zt.endChar || "", this.errorCorrectionLevel = (0, ut.getInteger)({
                data: zt.errorCorrectionLevel,
                defaultValue: -1,
                validate: (dr) => dr >= 0 && dr <= 8
              }), this.id = zt.id || "", this.moduleHeight = (0, ut.getMeasurement)(zt.moduleHeight, "5mm"), this.moduleWidth = (0, ut.getMeasurement)(zt.moduleWidth, "0.25mm"), this.printCheckDigit = (0, ut.getInteger)({
                data: zt.printCheckDigit,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.rowColumnRatio = (0, ut.getRatio)(zt.rowColumnRatio), this.startChar = zt.startChar || "", this.textLocation = (0, ut.getStringOption)(zt.textLocation, ["below", "above", "aboveEmbedded", "belowEmbedded", "none"]), this.truncate = (0, ut.getInteger)({
                data: zt.truncate,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.type = (0, ut.getStringOption)(zt.type ? zt.type.toLowerCase() : "", ["aztec", "codabar", "code2of5industrial", "code2of5interleaved", "code2of5matrix", "code2of5standard", "code3of9", "code3of9extended", "code11", "code49", "code93", "code128", "code128a", "code128b", "code128c", "code128sscc", "datamatrix", "ean8", "ean8add2", "ean8add5", "ean13", "ean13add2", "ean13add5", "ean13pwcd", "fim", "logmars", "maxicode", "msi", "pdf417", "pdf417macro", "plessey", "postauscust2", "postauscust3", "postausreplypaid", "postausstandard", "postukrm4scc", "postusdpbc", "postusimb", "postusstandard", "postus5zip", "qrcode", "rfid", "rss14", "rss14expanded", "rss14limited", "rss14stacked", "rss14stackedomni", "rss14truncated", "telepen", "ucc128", "ucc128random", "ucc128sscc", "upca", "upcaadd2", "upcaadd5", "upcapwcd", "upce", "upceadd2", "upceadd5", "upcean2", "upcean5", "upsmaxicode"]), this.upsMode = (0, ut.getStringOption)(zt.upsMode, ["usCarrier", "internationalCarrier", "secureSymbol", "standardSymbol"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.wideNarrowRatio = (0, ut.getRatio)(zt.wideNarrowRatio), this.encrypt = null, this.extras = null;
            }
          }
          class Tt extends it.XFAObject {
            constructor(zt) {
              super(pt, "bind", !0), this.match = (0, ut.getStringOption)(zt.match, ["once", "dataRef", "global", "none"]), this.ref = zt.ref || "", this.picture = null;
            }
          }
          class Dt extends it.XFAObject {
            constructor(zt) {
              super(pt, "bindItems"), this.connection = zt.connection || "", this.labelRef = zt.labelRef || "", this.ref = zt.ref || "", this.valueRef = zt.valueRef || "";
            }
          }
          at.BindItems = Dt;
          class Ut extends it.XFAObject {
            constructor(zt) {
              super(pt, "bookend"), this.id = zt.id || "", this.leader = zt.leader || "", this.trailer = zt.trailer || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class Vt extends it.Option01 {
            constructor(zt) {
              super(pt, "boolean"), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$toHTML](zt) {
              return Rt(this[rt.$content] === 1 ? "1" : "0");
            }
          }
          class Qt extends it.XFAObject {
            constructor(zt) {
              super(pt, "border", !0), this.break = (0, ut.getStringOption)(zt.break, ["close", "open"]), this.hand = (0, ut.getStringOption)(zt.hand, ["even", "left", "right"]), this.id = zt.id || "", this.presence = (0, ut.getStringOption)(zt.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, ut.getRelevant)(zt.relevant), this.use = zt.use || "", this.usehref = zt.usehref || "", this.corner = new it.XFAObjectArray(4), this.edge = new it.XFAObjectArray(4), this.extras = null, this.fill = null, this.margin = null;
            }
            [rt.$getExtra]() {
              if (!this[rt.$extra]) {
                const zt = this.edge.children.slice();
                if (zt.length < 4) {
                  const ln = zt.at(-1) || new Ar({});
                  for (let cn = zt.length; cn < 4; cn++)
                    zt.push(ln);
                }
                const dr = zt.map((ln) => ln.thickness), qr = [0, 0, 0, 0];
                this.margin && (qr[0] = this.margin.topInset, qr[1] = this.margin.rightInset, qr[2] = this.margin.bottomInset, qr[3] = this.margin.leftInset), this[rt.$extra] = {
                  widths: dr,
                  insets: qr,
                  edges: zt
                };
              }
              return this[rt.$extra];
            }
            [rt.$toStyle]() {
              var ln;
              const {
                edges: zt
              } = this[rt.$getExtra](), dr = zt.map((cn) => {
                const xn = cn[rt.$toStyle]();
                return xn.color || (xn.color = "#000000"), xn;
              }), qr = /* @__PURE__ */ Object.create(null);
              if (this.margin && Object.assign(qr, this.margin[rt.$toStyle]()), ((ln = this.fill) == null ? void 0 : ln.presence) === "visible" && Object.assign(qr, this.fill[rt.$toStyle]()), this.corner.children.some((cn) => cn.radius !== 0)) {
                const cn = this.corner.children.map((xn) => xn[rt.$toStyle]());
                if (cn.length === 2 || cn.length === 3) {
                  const xn = cn.at(-1);
                  for (let Sn = cn.length; Sn < 4; Sn++)
                    cn.push(xn);
                }
                qr.borderRadius = cn.map((xn) => xn.radius).join(" ");
              }
              switch (this.presence) {
                case "invisible":
                case "hidden":
                  qr.borderStyle = "";
                  break;
                case "inactive":
                  qr.borderStyle = "none";
                  break;
                default:
                  qr.borderStyle = dr.map((cn) => cn.style).join(" ");
                  break;
              }
              return qr.borderWidth = dr.map((cn) => cn.width).join(" "), qr.borderColor = dr.map((cn) => cn.color).join(" "), qr;
            }
          }
          class qt extends it.XFAObject {
            constructor(zt) {
              super(pt, "break", !0), this.after = (0, ut.getStringOption)(zt.after, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]), this.afterTarget = zt.afterTarget || "", this.before = (0, ut.getStringOption)(zt.before, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]), this.beforeTarget = zt.beforeTarget || "", this.bookendLeader = zt.bookendLeader || "", this.bookendTrailer = zt.bookendTrailer || "", this.id = zt.id || "", this.overflowLeader = zt.overflowLeader || "", this.overflowTarget = zt.overflowTarget || "", this.overflowTrailer = zt.overflowTrailer || "", this.startNew = (0, ut.getInteger)({
                data: zt.startNew,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null;
            }
          }
          class Zt extends it.XFAObject {
            constructor(zt) {
              super(pt, "breakAfter", !0), this.id = zt.id || "", this.leader = zt.leader || "", this.startNew = (0, ut.getInteger)({
                data: zt.startNew,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.target = zt.target || "", this.targetType = (0, ut.getStringOption)(zt.targetType, ["auto", "contentArea", "pageArea"]), this.trailer = zt.trailer || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.script = null;
            }
          }
          class ar extends it.XFAObject {
            constructor(zt) {
              super(pt, "breakBefore", !0), this.id = zt.id || "", this.leader = zt.leader || "", this.startNew = (0, ut.getInteger)({
                data: zt.startNew,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.target = zt.target || "", this.targetType = (0, ut.getStringOption)(zt.targetType, ["auto", "contentArea", "pageArea"]), this.trailer = zt.trailer || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.script = null;
            }
            [rt.$toHTML](zt) {
              return this[rt.$extra] = {}, ut.HTMLResult.FAILURE;
            }
          }
          class Jt extends it.XFAObject {
            constructor(zt) {
              super(pt, "button", !0), this.highlight = (0, ut.getStringOption)(zt.highlight, ["inverted", "none", "outline", "push"]), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null;
            }
            [rt.$toHTML](zt) {
              const qr = this[rt.$getParent]()[rt.$getParent](), ln = {
                name: "button",
                attributes: {
                  id: this[rt.$uid],
                  class: ["xfaButton"],
                  style: {}
                },
                children: []
              };
              for (const cn of qr.event.children) {
                if (cn.activity !== "click" || !cn.script)
                  continue;
                const xn = (0, dt.recoverJsURL)(cn.script[rt.$content]);
                if (!xn)
                  continue;
                const Sn = (0, et.fixURL)(xn.url);
                Sn && ln.children.push({
                  name: "a",
                  attributes: {
                    id: "link" + this[rt.$uid],
                    href: Sn,
                    newWindow: xn.newWindow,
                    class: ["xfaLink"],
                    style: {}
                  },
                  children: []
                });
              }
              return ut.HTMLResult.success(ln);
            }
          }
          class rr extends it.XFAObject {
            constructor(zt) {
              super(pt, "calculate", !0), this.id = zt.id || "", this.override = (0, ut.getStringOption)(zt.override, ["disabled", "error", "ignore", "warning"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.message = null, this.script = null;
            }
          }
          class Yt extends it.XFAObject {
            constructor(zt) {
              super(pt, "caption", !0), this.id = zt.id || "", this.placement = (0, ut.getStringOption)(zt.placement, ["left", "bottom", "inline", "right", "top"]), this.presence = (0, ut.getStringOption)(zt.presence, ["visible", "hidden", "inactive", "invisible"]), this.reserve = Math.ceil((0, ut.getMeasurement)(zt.reserve)), this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.font = null, this.margin = null, this.para = null, this.value = null;
            }
            [rt.$setValue](zt) {
              Ot(this, zt);
            }
            [rt.$getExtra](zt) {
              if (!this[rt.$extra]) {
                let {
                  width: dr,
                  height: qr
                } = zt;
                switch (this.placement) {
                  case "left":
                  case "right":
                  case "inline":
                    dr = this.reserve <= 0 ? dr : this.reserve;
                    break;
                  case "top":
                  case "bottom":
                    qr = this.reserve <= 0 ? qr : this.reserve;
                    break;
                }
                this[rt.$extra] = (0, et.layoutNode)(this, {
                  width: dr,
                  height: qr
                });
              }
              return this[rt.$extra];
            }
            [rt.$toHTML](zt) {
              if (!this.value)
                return ut.HTMLResult.EMPTY;
              this[rt.$pushPara]();
              const dr = this.value[rt.$toHTML](zt).html;
              if (!dr)
                return this[rt.$popPara](), ut.HTMLResult.EMPTY;
              const qr = this.reserve;
              if (this.reserve <= 0) {
                const {
                  w: xn,
                  h: Sn
                } = this[rt.$getExtra](zt);
                switch (this.placement) {
                  case "left":
                  case "right":
                  case "inline":
                    this.reserve = xn;
                    break;
                  case "top":
                  case "bottom":
                    this.reserve = Sn;
                    break;
                }
              }
              const ln = [];
              typeof dr == "string" ? ln.push({
                name: "#text",
                value: dr
              }) : ln.push(dr);
              const cn = (0, et.toStyle)(this, "font", "margin", "visibility");
              switch (this.placement) {
                case "left":
                case "right":
                  this.reserve > 0 && (cn.width = (0, et.measureToString)(this.reserve));
                  break;
                case "top":
                case "bottom":
                  this.reserve > 0 && (cn.height = (0, et.measureToString)(this.reserve));
                  break;
              }
              return (0, et.setPara)(this, null, dr), this[rt.$popPara](), this.reserve = qr, ut.HTMLResult.success({
                name: "div",
                attributes: {
                  style: cn,
                  class: ["xfaCaption"]
                },
                children: ln
              });
            }
          }
          class Kt extends it.StringObject {
            constructor(zt) {
              super(pt, "certificate"), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class nr extends it.XFAObject {
            constructor(zt) {
              super(pt, "certificates", !0), this.credentialServerPolicy = (0, ut.getStringOption)(zt.credentialServerPolicy, ["optional", "required"]), this.id = zt.id || "", this.url = zt.url || "", this.urlPolicy = zt.urlPolicy || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.encryption = null, this.issuers = null, this.keyUsage = null, this.oids = null, this.signing = null, this.subjectDNs = null;
            }
          }
          class tr extends it.XFAObject {
            constructor(zt) {
              super(pt, "checkButton", !0), this.id = zt.id || "", this.mark = (0, ut.getStringOption)(zt.mark, ["default", "check", "circle", "cross", "diamond", "square", "star"]), this.shape = (0, ut.getStringOption)(zt.shape, ["square", "round"]), this.size = (0, ut.getMeasurement)(zt.size, "10pt"), this.use = zt.use || "", this.usehref = zt.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
            [rt.$toHTML](zt) {
              var oo, Jn, fo;
              const dr = (0, et.toStyle)("margin"), qr = (0, et.measureToString)(this.size);
              dr.width = dr.height = qr;
              let ln, cn, xn;
              const Sn = this[rt.$getParent]()[rt.$getParent](), $n = Sn.items.children.length && Sn.items.children[0][rt.$toHTML]().html || [], On = {
                on: ($n[0] !== void 0 ? $n[0] : "on").toString(),
                off: ($n[1] !== void 0 ? $n[1] : "off").toString()
              }, Kn = (((oo = Sn.value) == null ? void 0 : oo[rt.$text]()) || "off") === On.on || void 0, Vn = Sn[rt.$getSubformParent](), Xn = Sn[rt.$uid];
              let _i;
              Vn instanceof Or ? (xn = Vn[rt.$uid], ln = "radio", cn = "xfaRadio", _i = ((Jn = Vn[rt.$data]) == null ? void 0 : Jn[rt.$uid]) || Vn[rt.$uid]) : (ln = "checkbox", cn = "xfaCheckbox", _i = ((fo = Sn[rt.$data]) == null ? void 0 : fo[rt.$uid]) || Sn[rt.$uid]);
              const Dn = {
                name: "input",
                attributes: {
                  class: [cn],
                  style: dr,
                  fieldId: Xn,
                  dataId: _i,
                  type: ln,
                  checked: Kn,
                  xfaOn: On.on,
                  xfaOff: On.off,
                  "aria-label": yt(Sn),
                  "aria-required": !1
                }
              };
              return xn && (Dn.attributes.name = xn), wt(Sn) && (Dn.attributes["aria-required"] = !0, Dn.attributes.required = !0), ut.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [Dn]
              });
            }
          }
          class ir extends it.XFAObject {
            constructor(zt) {
              super(pt, "choiceList", !0), this.commitOn = (0, ut.getStringOption)(zt.commitOn, ["select", "exit"]), this.id = zt.id || "", this.open = (0, ut.getStringOption)(zt.open, ["userControl", "always", "multiSelect", "onEntry"]), this.textEntry = (0, ut.getInteger)({
                data: zt.textEntry,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.use = zt.use || "", this.usehref = zt.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
            [rt.$toHTML](zt) {
              var On, _n, Kn;
              const dr = (0, et.toStyle)(this, "border", "margin"), ln = this[rt.$getParent]()[rt.$getParent](), xn = {
                fontSize: `calc(${((On = ln.font) == null ? void 0 : On.size) || 10}px * var(--scale-factor))`
              }, Sn = [];
              if (ln.items.children.length > 0) {
                const Vn = ln.items;
                let Xn = 0, _i = 0;
                Vn.children.length === 2 && (Xn = Vn.children[0].save, _i = 1 - Xn);
                const Dn = Vn.children[Xn][rt.$toHTML]().html, oo = Vn.children[_i][rt.$toHTML]().html;
                let Jn = !1;
                const fo = ((_n = ln.value) == null ? void 0 : _n[rt.$text]()) || "";
                for (let io = 0, jn = Dn.length; io < jn; io++) {
                  const In = {
                    name: "option",
                    attributes: {
                      value: oo[io] || Dn[io],
                      style: xn
                    },
                    value: Dn[io]
                  };
                  oo[io] === fo && (In.attributes.selected = Jn = !0), Sn.push(In);
                }
                Jn || Sn.splice(0, 0, {
                  name: "option",
                  attributes: {
                    hidden: !0,
                    selected: !0
                  },
                  value: " "
                });
              }
              const $n = {
                class: ["xfaSelect"],
                fieldId: ln[rt.$uid],
                dataId: ((Kn = ln[rt.$data]) == null ? void 0 : Kn[rt.$uid]) || ln[rt.$uid],
                style: dr,
                "aria-label": yt(ln),
                "aria-required": !1
              };
              return wt(ln) && ($n["aria-required"] = !0, $n.required = !0), this.open === "multiSelect" && ($n.multiple = !0), ut.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [{
                  name: "select",
                  children: Sn,
                  attributes: $n
                }]
              });
            }
          }
          class sr extends it.XFAObject {
            constructor(zt) {
              super(pt, "color", !0), this.cSpace = (0, ut.getStringOption)(zt.cSpace, ["SRGB"]), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.value = zt.value ? (0, ut.getColor)(zt.value) : "", this.extras = null;
            }
            [rt.$hasSettableValue]() {
              return !1;
            }
            [rt.$toStyle]() {
              return this.value ? ft.Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
            }
          }
          class cr extends it.XFAObject {
            constructor(zt) {
              super(pt, "comb"), this.id = zt.id || "", this.numberOfCells = (0, ut.getInteger)({
                data: zt.numberOfCells,
                defaultValue: 0,
                validate: (dr) => dr >= 0
              }), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class or extends it.XFAObject {
            constructor(zt) {
              super(pt, "connect", !0), this.connection = zt.connection || "", this.id = zt.id || "", this.ref = zt.ref || "", this.usage = (0, ut.getStringOption)(zt.usage, ["exportAndImport", "exportOnly", "importOnly"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.picture = null;
            }
          }
          class Xt extends it.XFAObject {
            constructor(zt) {
              super(pt, "contentArea", !0), this.h = (0, ut.getMeasurement)(zt.h), this.id = zt.id || "", this.name = zt.name || "", this.relevant = (0, ut.getRelevant)(zt.relevant), this.use = zt.use || "", this.usehref = zt.usehref || "", this.w = (0, ut.getMeasurement)(zt.w), this.x = (0, ut.getMeasurement)(zt.x, "0pt"), this.y = (0, ut.getMeasurement)(zt.y, "0pt"), this.desc = null, this.extras = null;
            }
            [rt.$toHTML](zt) {
              const dr = (0, et.measureToString)(this.x), qr = (0, et.measureToString)(this.y), ln = {
                left: dr,
                top: qr,
                width: (0, et.measureToString)(this.w),
                height: (0, et.measureToString)(this.h)
              }, cn = ["xfaContentarea"];
              return (0, et.isPrintOnly)(this) && cn.push("xfaPrintOnly"), ut.HTMLResult.success({
                name: "div",
                children: [],
                attributes: {
                  style: ln,
                  class: cn,
                  id: this[rt.$uid]
                }
              });
            }
          }
          class Gt extends it.XFAObject {
            constructor(zt) {
              super(pt, "corner", !0), this.id = zt.id || "", this.inverted = (0, ut.getInteger)({
                data: zt.inverted,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.join = (0, ut.getStringOption)(zt.join, ["square", "round"]), this.presence = (0, ut.getStringOption)(zt.presence, ["visible", "hidden", "inactive", "invisible"]), this.radius = (0, ut.getMeasurement)(zt.radius), this.stroke = (0, ut.getStringOption)(zt.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]), this.thickness = (0, ut.getMeasurement)(zt.thickness, "0.5pt"), this.use = zt.use || "", this.usehref = zt.usehref || "", this.color = null, this.extras = null;
            }
            [rt.$toStyle]() {
              const zt = (0, et.toStyle)(this, "visibility");
              return zt.radius = (0, et.measureToString)(this.join === "square" ? 0 : this.radius), zt;
            }
          }
          class Wt extends it.ContentObject {
            constructor(zt) {
              super(pt, "date"), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$finalize]() {
              const zt = this[rt.$content].trim();
              this[rt.$content] = zt ? new Date(zt) : null;
            }
            [rt.$toHTML](zt) {
              return Rt(this[rt.$content] ? this[rt.$content].toString() : "");
            }
          }
          class er extends it.ContentObject {
            constructor(zt) {
              super(pt, "dateTime"), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$finalize]() {
              const zt = this[rt.$content].trim();
              this[rt.$content] = zt ? new Date(zt) : null;
            }
            [rt.$toHTML](zt) {
              return Rt(this[rt.$content] ? this[rt.$content].toString() : "");
            }
          }
          class lr extends it.XFAObject {
            constructor(zt) {
              super(pt, "dateTimeEdit", !0), this.hScrollPolicy = (0, ut.getStringOption)(zt.hScrollPolicy, ["auto", "off", "on"]), this.id = zt.id || "", this.picker = (0, ut.getStringOption)(zt.picker, ["host", "none"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.border = null, this.comb = null, this.extras = null, this.margin = null;
            }
            [rt.$toHTML](zt) {
              var cn;
              const dr = (0, et.toStyle)(this, "border", "font", "margin"), qr = this[rt.$getParent]()[rt.$getParent](), ln = {
                name: "input",
                attributes: {
                  type: "text",
                  fieldId: qr[rt.$uid],
                  dataId: ((cn = qr[rt.$data]) == null ? void 0 : cn[rt.$uid]) || qr[rt.$uid],
                  class: ["xfaTextfield"],
                  style: dr,
                  "aria-label": yt(qr),
                  "aria-required": !1
                }
              };
              return wt(qr) && (ln.attributes["aria-required"] = !0, ln.attributes.required = !0), ut.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [ln]
              });
            }
          }
          class ur extends it.ContentObject {
            constructor(zt) {
              super(pt, "decimal"), this.fracDigits = (0, ut.getInteger)({
                data: zt.fracDigits,
                defaultValue: 2,
                validate: (dr) => !0
              }), this.id = zt.id || "", this.leadDigits = (0, ut.getInteger)({
                data: zt.leadDigits,
                defaultValue: -1,
                validate: (dr) => !0
              }), this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$finalize]() {
              const zt = parseFloat(this[rt.$content].trim());
              this[rt.$content] = isNaN(zt) ? null : zt;
            }
            [rt.$toHTML](zt) {
              return Rt(this[rt.$content] !== null ? this[rt.$content].toString() : "");
            }
          }
          class pr extends it.XFAObject {
            constructor(zt) {
              super(pt, "defaultUi", !0), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null;
            }
          }
          class yr extends it.XFAObject {
            constructor(zt) {
              super(pt, "desc", !0), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.boolean = new it.XFAObjectArray(), this.date = new it.XFAObjectArray(), this.dateTime = new it.XFAObjectArray(), this.decimal = new it.XFAObjectArray(), this.exData = new it.XFAObjectArray(), this.float = new it.XFAObjectArray(), this.image = new it.XFAObjectArray(), this.integer = new it.XFAObjectArray(), this.text = new it.XFAObjectArray(), this.time = new it.XFAObjectArray();
            }
          }
          class Er extends it.OptionObject {
            constructor(zt) {
              super(pt, "digestMethod", ["", "SHA1", "SHA256", "SHA512", "RIPEMD160"]), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class br extends it.XFAObject {
            constructor(zt) {
              super(pt, "digestMethods", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.digestMethod = new it.XFAObjectArray();
            }
          }
          class gr extends it.XFAObject {
            constructor(zt) {
              super(pt, "draw", !0), this.anchorType = (0, ut.getStringOption)(zt.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, ut.getInteger)({
                data: zt.colSpan,
                defaultValue: 1,
                validate: (dr) => dr >= 1 || dr === -1
              }), this.h = zt.h ? (0, ut.getMeasurement)(zt.h) : "", this.hAlign = (0, ut.getStringOption)(zt.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = zt.id || "", this.locale = zt.locale || "", this.maxH = (0, ut.getMeasurement)(zt.maxH, "0pt"), this.maxW = (0, ut.getMeasurement)(zt.maxW, "0pt"), this.minH = (0, ut.getMeasurement)(zt.minH, "0pt"), this.minW = (0, ut.getMeasurement)(zt.minW, "0pt"), this.name = zt.name || "", this.presence = (0, ut.getStringOption)(zt.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, ut.getRelevant)(zt.relevant), this.rotate = (0, ut.getInteger)({
                data: zt.rotate,
                defaultValue: 0,
                validate: (dr) => dr % 90 === 0
              }), this.use = zt.use || "", this.usehref = zt.usehref || "", this.w = zt.w ? (0, ut.getMeasurement)(zt.w) : "", this.x = (0, ut.getMeasurement)(zt.x, "0pt"), this.y = (0, ut.getMeasurement)(zt.y, "0pt"), this.assist = null, this.border = null, this.caption = null, this.desc = null, this.extras = null, this.font = null, this.keep = null, this.margin = null, this.para = null, this.traversal = null, this.ui = null, this.value = null, this.setProperty = new it.XFAObjectArray();
            }
            [rt.$setValue](zt) {
              Ot(this, zt);
            }
            [rt.$toHTML](zt) {
              if (Ct(this), this.presence === "hidden" || this.presence === "inactive")
                return ut.HTMLResult.EMPTY;
              (0, et.fixDimensions)(this), this[rt.$pushPara]();
              const dr = this.w, qr = this.h, {
                w: ln,
                h: cn,
                isBroken: xn
              } = (0, et.layoutNode)(this, zt);
              if (ln && this.w === "") {
                if (xn && this[rt.$getSubformParent]()[rt.$isThereMoreWidth]())
                  return this[rt.$popPara](), ut.HTMLResult.FAILURE;
                this.w = ln;
              }
              if (cn && this.h === "" && (this.h = cn), kt(this), !(0, lt.checkDimensions)(this, zt))
                return this.w = dr, this.h = qr, this[rt.$popPara](), ut.HTMLResult.FAILURE;
              jt(this);
              const Sn = (0, et.toStyle)(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
              (0, et.setMinMaxDimensions)(this, Sn), Sn.margin && (Sn.padding = Sn.margin, delete Sn.margin);
              const $n = ["xfaDraw"];
              this.font && $n.push("xfaFont"), (0, et.isPrintOnly)(this) && $n.push("xfaPrintOnly");
              const On = {
                style: Sn,
                id: this[rt.$uid],
                class: $n
              };
              this.name && (On.xfaName = this.name);
              const _n = {
                name: "div",
                attributes: On,
                children: []
              };
              It(this, On);
              const Kn = (0, et.computeBbox)(this, _n, zt), Vn = this.value ? this.value[rt.$toHTML](zt).html : null;
              return Vn === null ? (this.w = dr, this.h = qr, this[rt.$popPara](), ut.HTMLResult.success((0, et.createWrapper)(this, _n), Kn)) : (_n.children.push(Vn), (0, et.setPara)(this, Sn, Vn), this.w = dr, this.h = qr, this[rt.$popPara](), ut.HTMLResult.success((0, et.createWrapper)(this, _n), Kn));
            }
          }
          class Ar extends it.XFAObject {
            constructor(zt) {
              super(pt, "edge", !0), this.cap = (0, ut.getStringOption)(zt.cap, ["square", "butt", "round"]), this.id = zt.id || "", this.presence = (0, ut.getStringOption)(zt.presence, ["visible", "hidden", "inactive", "invisible"]), this.stroke = (0, ut.getStringOption)(zt.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]), this.thickness = (0, ut.getMeasurement)(zt.thickness, "0.5pt"), this.use = zt.use || "", this.usehref = zt.usehref || "", this.color = null, this.extras = null;
            }
            [rt.$toStyle]() {
              const zt = (0, et.toStyle)(this, "visibility");
              if (Object.assign(zt, {
                linecap: this.cap,
                width: (0, et.measureToString)(this.thickness),
                color: this.color ? this.color[rt.$toStyle]() : "#000000",
                style: ""
              }), this.presence !== "visible")
                zt.style = "none";
              else
                switch (this.stroke) {
                  case "solid":
                    zt.style = "solid";
                    break;
                  case "dashDot":
                    zt.style = "dashed";
                    break;
                  case "dashDotDot":
                    zt.style = "dashed";
                    break;
                  case "dashed":
                    zt.style = "dashed";
                    break;
                  case "dotted":
                    zt.style = "dotted";
                    break;
                  case "embossed":
                    zt.style = "ridge";
                    break;
                  case "etched":
                    zt.style = "groove";
                    break;
                  case "lowered":
                    zt.style = "inset";
                    break;
                  case "raised":
                    zt.style = "outset";
                    break;
                }
              return zt;
            }
          }
          class Sr extends it.OptionObject {
            constructor(zt) {
              super(pt, "encoding", ["adbe.x509.rsa_sha1", "adbe.pkcs7.detached", "adbe.pkcs7.sha1"]), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class Br extends it.XFAObject {
            constructor(zt) {
              super(pt, "encodings", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.encoding = new it.XFAObjectArray();
            }
          }
          class Ir extends it.XFAObject {
            constructor(zt) {
              super(pt, "encrypt", !0), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.certificate = null;
            }
          }
          class hr extends it.XFAObject {
            constructor(zt) {
              super(pt, "encryptData", !0), this.id = zt.id || "", this.operation = (0, ut.getStringOption)(zt.operation, ["encrypt", "decrypt"]), this.target = zt.target || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.filter = null, this.manifest = null;
            }
          }
          class vr extends it.XFAObject {
            constructor(zt) {
              super(pt, "encryption", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.certificate = new it.XFAObjectArray();
            }
          }
          class xr extends it.OptionObject {
            constructor(zt) {
              super(pt, "encryptionMethod", ["", "AES256-CBC", "TRIPLEDES-CBC", "AES128-CBC", "AES192-CBC"]), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class Pr extends it.XFAObject {
            constructor(zt) {
              super(pt, "encryptionMethods", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.encryptionMethod = new it.XFAObjectArray();
            }
          }
          class Rr extends it.XFAObject {
            constructor(zt) {
              super(pt, "event", !0), this.activity = (0, ut.getStringOption)(zt.activity, ["click", "change", "docClose", "docReady", "enter", "exit", "full", "indexChange", "initialize", "mouseDown", "mouseEnter", "mouseExit", "mouseUp", "postExecute", "postOpen", "postPrint", "postSave", "postSign", "postSubmit", "preExecute", "preOpen", "prePrint", "preSave", "preSign", "preSubmit", "ready", "validationState"]), this.id = zt.id || "", this.listen = (0, ut.getStringOption)(zt.listen, ["refOnly", "refAndDescendents"]), this.name = zt.name || "", this.ref = zt.ref || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.encryptData = null, this.execute = null, this.script = null, this.signData = null, this.submit = null;
            }
          }
          class Dr extends it.ContentObject {
            constructor(zt) {
              super(pt, "exData"), this.contentType = zt.contentType || "", this.href = zt.href || "", this.id = zt.id || "", this.maxLength = (0, ut.getInteger)({
                data: zt.maxLength,
                defaultValue: -1,
                validate: (dr) => dr >= -1
              }), this.name = zt.name || "", this.rid = zt.rid || "", this.transferEncoding = (0, ut.getStringOption)(zt.transferEncoding, ["none", "base64", "package"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$isCDATAXml]() {
              return this.contentType === "text/html";
            }
            [rt.$onChild](zt) {
              return this.contentType === "text/html" && zt[rt.$namespaceId] === st.NamespaceIds.xhtml.id ? (this[rt.$content] = zt, !0) : this.contentType === "text/xml" ? (this[rt.$content] = zt, !0) : !1;
            }
            [rt.$toHTML](zt) {
              return this.contentType !== "text/html" || !this[rt.$content] ? ut.HTMLResult.EMPTY : this[rt.$content][rt.$toHTML](zt);
            }
          }
          class Gr extends it.XFAObject {
            constructor(zt) {
              super(pt, "exObject", !0), this.archive = zt.archive || "", this.classId = zt.classId || "", this.codeBase = zt.codeBase || "", this.codeType = zt.codeType || "", this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.boolean = new it.XFAObjectArray(), this.date = new it.XFAObjectArray(), this.dateTime = new it.XFAObjectArray(), this.decimal = new it.XFAObjectArray(), this.exData = new it.XFAObjectArray(), this.exObject = new it.XFAObjectArray(), this.float = new it.XFAObjectArray(), this.image = new it.XFAObjectArray(), this.integer = new it.XFAObjectArray(), this.text = new it.XFAObjectArray(), this.time = new it.XFAObjectArray();
            }
          }
          class Or extends it.XFAObject {
            constructor(zt) {
              super(pt, "exclGroup", !0), this.access = (0, ut.getStringOption)(zt.access, ["open", "nonInteractive", "protected", "readOnly"]), this.accessKey = zt.accessKey || "", this.anchorType = (0, ut.getStringOption)(zt.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, ut.getInteger)({
                data: zt.colSpan,
                defaultValue: 1,
                validate: (dr) => dr >= 1 || dr === -1
              }), this.h = zt.h ? (0, ut.getMeasurement)(zt.h) : "", this.hAlign = (0, ut.getStringOption)(zt.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = zt.id || "", this.layout = (0, ut.getStringOption)(zt.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]), this.maxH = (0, ut.getMeasurement)(zt.maxH, "0pt"), this.maxW = (0, ut.getMeasurement)(zt.maxW, "0pt"), this.minH = (0, ut.getMeasurement)(zt.minH, "0pt"), this.minW = (0, ut.getMeasurement)(zt.minW, "0pt"), this.name = zt.name || "", this.presence = (0, ut.getStringOption)(zt.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, ut.getRelevant)(zt.relevant), this.use = zt.use || "", this.usehref = zt.usehref || "", this.w = zt.w ? (0, ut.getMeasurement)(zt.w) : "", this.x = (0, ut.getMeasurement)(zt.x, "0pt"), this.y = (0, ut.getMeasurement)(zt.y, "0pt"), this.assist = null, this.bind = null, this.border = null, this.calculate = null, this.caption = null, this.desc = null, this.extras = null, this.margin = null, this.para = null, this.traversal = null, this.validate = null, this.connect = new it.XFAObjectArray(), this.event = new it.XFAObjectArray(), this.field = new it.XFAObjectArray(), this.setProperty = new it.XFAObjectArray();
            }
            [rt.$isBindable]() {
              return !0;
            }
            [rt.$hasSettableValue]() {
              return !0;
            }
            [rt.$setValue](zt) {
              for (const dr of this.field.children) {
                if (!dr.value) {
                  const qr = new Qn({});
                  dr[rt.$appendChild](qr), dr.value = qr;
                }
                dr.value[rt.$setValue](zt);
              }
            }
            [rt.$isThereMoreWidth]() {
              return this.layout.endsWith("-tb") && this[rt.$extra].attempt === 0 && this[rt.$extra].numberInLine > 0 || this[rt.$getParent]()[rt.$isThereMoreWidth]();
            }
            [rt.$isSplittable]() {
              var dr;
              const zt = this[rt.$getSubformParent]();
              return zt[rt.$isSplittable]() ? this[rt.$extra]._isSplittable !== void 0 ? this[rt.$extra]._isSplittable : this.layout === "position" || this.layout.includes("row") ? (this[rt.$extra]._isSplittable = !1, !1) : (dr = zt.layout) != null && dr.endsWith("-tb") && zt[rt.$extra].numberInLine !== 0 ? !1 : (this[rt.$extra]._isSplittable = !0, !0) : !1;
            }
            [rt.$flushHTML]() {
              return (0, lt.flushHTML)(this);
            }
            [rt.$addHTML](zt, dr) {
              (0, lt.addHTML)(this, zt, dr);
            }
            [rt.$getAvailableSpace]() {
              return (0, lt.getAvailableSpace)(this);
            }
            [rt.$toHTML](zt) {
              if (Ct(this), this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0)
                return ut.HTMLResult.EMPTY;
              (0, et.fixDimensions)(this);
              const dr = [], qr = {
                id: this[rt.$uid],
                class: []
              };
              (0, et.setAccess)(this, qr.class), this[rt.$extra] || (this[rt.$extra] = /* @__PURE__ */ Object.create(null)), Object.assign(this[rt.$extra], {
                children: dr,
                attributes: qr,
                attempt: 0,
                line: null,
                numberInLine: 0,
                availableSpace: {
                  width: Math.min(this.w || 1 / 0, zt.width),
                  height: Math.min(this.h || 1 / 0, zt.height)
                },
                width: 0,
                height: 0,
                prevHeight: 0,
                currentWidth: 0
              });
              const ln = this[rt.$isSplittable]();
              if (ln || kt(this), !(0, lt.checkDimensions)(this, zt))
                return ut.HTMLResult.FAILURE;
              const cn = /* @__PURE__ */ new Set(["field"]);
              if (this.layout.includes("row")) {
                const Jn = this[rt.$getSubformParent]().columnWidths;
                Array.isArray(Jn) && Jn.length > 0 && (this[rt.$extra].columnWidths = Jn, this[rt.$extra].currentColumn = 0);
              }
              const xn = (0, et.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), Sn = ["xfaExclgroup"], $n = (0, et.layoutClass)(this);
              $n && Sn.push($n), (0, et.isPrintOnly)(this) && Sn.push("xfaPrintOnly"), qr.style = xn, qr.class = Sn, this.name && (qr.xfaName = this.name), this[rt.$pushPara]();
              const On = this.layout === "lr-tb" || this.layout === "rl-tb", _n = On ? ct : 1;
              for (; this[rt.$extra].attempt < _n; this[rt.$extra].attempt++) {
                On && this[rt.$extra].attempt === ct - 1 && (this[rt.$extra].numberInLine = 0);
                const Jn = this[rt.$childrenToHTML]({
                  filter: cn,
                  include: !0
                });
                if (Jn.success)
                  break;
                if (Jn.isBreak())
                  return this[rt.$popPara](), Jn;
                if (On && this[rt.$extra].attempt === 0 && this[rt.$extra].numberInLine === 0 && !this[rt.$getTemplateRoot]()[rt.$extra].noLayoutFailure) {
                  this[rt.$extra].attempt = _n;
                  break;
                }
              }
              if (this[rt.$popPara](), ln || jt(this), this[rt.$extra].attempt === _n)
                return ln || delete this[rt.$extra], ut.HTMLResult.FAILURE;
              let Kn = 0, Vn = 0;
              this.margin && (Kn = this.margin.leftInset + this.margin.rightInset, Vn = this.margin.topInset + this.margin.bottomInset);
              const Xn = Math.max(this[rt.$extra].width + Kn, this.w || 0), _i = Math.max(this[rt.$extra].height + Vn, this.h || 0), Dn = [this.x, this.y, Xn, _i];
              this.w === "" && (xn.width = (0, et.measureToString)(Xn)), this.h === "" && (xn.height = (0, et.measureToString)(_i));
              const oo = {
                name: "div",
                attributes: qr,
                children: dr
              };
              return It(this, qr), delete this[rt.$extra], ut.HTMLResult.success((0, et.createWrapper)(this, oo), Dn);
            }
          }
          class Hr extends it.XFAObject {
            constructor(zt) {
              super(pt, "execute"), this.connection = zt.connection || "", this.executeType = (0, ut.getStringOption)(zt.executeType, ["import", "remerge"]), this.id = zt.id || "", this.runAt = (0, ut.getStringOption)(zt.runAt, ["client", "both", "server"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class jr extends it.XFAObject {
            constructor(zt) {
              super(pt, "extras", !0), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.boolean = new it.XFAObjectArray(), this.date = new it.XFAObjectArray(), this.dateTime = new it.XFAObjectArray(), this.decimal = new it.XFAObjectArray(), this.exData = new it.XFAObjectArray(), this.extras = new it.XFAObjectArray(), this.float = new it.XFAObjectArray(), this.image = new it.XFAObjectArray(), this.integer = new it.XFAObjectArray(), this.text = new it.XFAObjectArray(), this.time = new it.XFAObjectArray();
            }
          }
          class Tr extends it.XFAObject {
            constructor(zt) {
              super(pt, "field", !0), this.access = (0, ut.getStringOption)(zt.access, ["open", "nonInteractive", "protected", "readOnly"]), this.accessKey = zt.accessKey || "", this.anchorType = (0, ut.getStringOption)(zt.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, ut.getInteger)({
                data: zt.colSpan,
                defaultValue: 1,
                validate: (dr) => dr >= 1 || dr === -1
              }), this.h = zt.h ? (0, ut.getMeasurement)(zt.h) : "", this.hAlign = (0, ut.getStringOption)(zt.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = zt.id || "", this.locale = zt.locale || "", this.maxH = (0, ut.getMeasurement)(zt.maxH, "0pt"), this.maxW = (0, ut.getMeasurement)(zt.maxW, "0pt"), this.minH = (0, ut.getMeasurement)(zt.minH, "0pt"), this.minW = (0, ut.getMeasurement)(zt.minW, "0pt"), this.name = zt.name || "", this.presence = (0, ut.getStringOption)(zt.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, ut.getRelevant)(zt.relevant), this.rotate = (0, ut.getInteger)({
                data: zt.rotate,
                defaultValue: 0,
                validate: (dr) => dr % 90 === 0
              }), this.use = zt.use || "", this.usehref = zt.usehref || "", this.w = zt.w ? (0, ut.getMeasurement)(zt.w) : "", this.x = (0, ut.getMeasurement)(zt.x, "0pt"), this.y = (0, ut.getMeasurement)(zt.y, "0pt"), this.assist = null, this.bind = null, this.border = null, this.calculate = null, this.caption = null, this.desc = null, this.extras = null, this.font = null, this.format = null, this.items = new it.XFAObjectArray(2), this.keep = null, this.margin = null, this.para = null, this.traversal = null, this.ui = null, this.validate = null, this.value = null, this.bindItems = new it.XFAObjectArray(), this.connect = new it.XFAObjectArray(), this.event = new it.XFAObjectArray(), this.setProperty = new it.XFAObjectArray();
            }
            [rt.$isBindable]() {
              return !0;
            }
            [rt.$setValue](zt) {
              Ot(this, zt);
            }
            [rt.$toHTML](zt) {
              var Jn, fo, io;
              if (Ct(this), !this.ui) {
                this.ui = new Yn({}), this.ui[rt.$globalData] = this[rt.$globalData], this[rt.$appendChild](this.ui);
                let jn;
                switch (this.items.children.length) {
                  case 0:
                    jn = new uo({}), this.ui.textEdit = jn;
                    break;
                  case 1:
                    jn = new tr({}), this.ui.checkButton = jn;
                    break;
                  case 2:
                    jn = new ir({}), this.ui.choiceList = jn;
                    break;
                }
                this.ui[rt.$appendChild](jn);
              }
              if (!this.ui || this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0)
                return ut.HTMLResult.EMPTY;
              this.caption && delete this.caption[rt.$extra], this[rt.$pushPara]();
              const dr = this.caption ? this.caption[rt.$toHTML](zt).html : null, qr = this.w, ln = this.h;
              let cn = 0, xn = 0;
              this.margin && (cn = this.margin.leftInset + this.margin.rightInset, xn = this.margin.topInset + this.margin.bottomInset);
              let Sn = null;
              if (this.w === "" || this.h === "") {
                let jn = null, In = null, po = 0, ho = 0;
                if (this.ui.checkButton)
                  po = ho = this.ui.checkButton.size;
                else {
                  const {
                    w: So,
                    h: bo
                  } = (0, et.layoutNode)(this, zt);
                  So !== null ? (po = So, ho = bo) : ho = (0, ht.getMetrics)(this.font, !0).lineNoGap;
                }
                if (Sn = St(this.ui[rt.$getExtra]()), po += Sn.w, ho += Sn.h, this.caption) {
                  const {
                    w: So,
                    h: bo,
                    isBroken: no
                  } = this.caption[rt.$getExtra](zt);
                  if (no && this[rt.$getSubformParent]()[rt.$isThereMoreWidth]())
                    return this[rt.$popPara](), ut.HTMLResult.FAILURE;
                  switch (jn = So, In = bo, this.caption.placement) {
                    case "left":
                    case "right":
                    case "inline":
                      jn += po;
                      break;
                    case "top":
                    case "bottom":
                      In += ho;
                      break;
                  }
                } else
                  jn = po, In = ho;
                jn && this.w === "" && (jn += cn, this.w = Math.min(this.maxW <= 0 ? 1 / 0 : this.maxW, this.minW + 1 < jn ? jn : this.minW)), In && this.h === "" && (In += xn, this.h = Math.min(this.maxH <= 0 ? 1 / 0 : this.maxH, this.minH + 1 < In ? In : this.minH));
              }
              if (this[rt.$popPara](), (0, et.fixDimensions)(this), kt(this), !(0, lt.checkDimensions)(this, zt))
                return this.w = qr, this.h = ln, this[rt.$popPara](), ut.HTMLResult.FAILURE;
              jt(this);
              const $n = (0, et.toStyle)(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
              (0, et.setMinMaxDimensions)(this, $n);
              const On = ["xfaField"];
              this.font && On.push("xfaFont"), (0, et.isPrintOnly)(this) && On.push("xfaPrintOnly");
              const _n = {
                style: $n,
                id: this[rt.$uid],
                class: On
              };
              $n.margin && ($n.padding = $n.margin, delete $n.margin), (0, et.setAccess)(this, On), this.name && (_n.xfaName = this.name);
              const Kn = [], Vn = {
                name: "div",
                attributes: _n,
                children: Kn
              };
              It(this, _n);
              const Xn = this.border ? this.border[rt.$toStyle]() : null, _i = (0, et.computeBbox)(this, Vn, zt), Dn = this.ui[rt.$toHTML]().html;
              if (!Dn)
                return Object.assign($n, Xn), ut.HTMLResult.success((0, et.createWrapper)(this, Vn), _i);
              this[rt.$tabIndex] && ((Jn = Dn.children) != null && Jn[0] ? Dn.children[0].attributes.tabindex = this[rt.$tabIndex] : Dn.attributes.tabindex = this[rt.$tabIndex]), Dn.attributes.style || (Dn.attributes.style = /* @__PURE__ */ Object.create(null));
              let oo = null;
              if (this.ui.button ? (Dn.children.length === 1 && ([oo] = Dn.children.splice(0, 1)), Object.assign(Dn.attributes.style, Xn)) : Object.assign($n, Xn), Kn.push(Dn), this.value) {
                if (this.ui.imageEdit)
                  Dn.children.push(this.value[rt.$toHTML]().html);
                else if (!this.ui.button) {
                  let jn = "";
                  if (this.value.exData)
                    jn = this.value.exData[rt.$text]();
                  else if (this.value.text)
                    jn = this.value.text[rt.$getExtra]();
                  else {
                    const In = this.value[rt.$toHTML]().html;
                    In !== null && (jn = In.children[0].value);
                  }
                  this.ui.textEdit && ((fo = this.value.text) != null && fo.maxChars) && (Dn.children[0].attributes.maxLength = this.value.text.maxChars), jn && (this.ui.numericEdit && (jn = parseFloat(jn), jn = isNaN(jn) ? "" : jn.toString()), Dn.children[0].name === "textarea" ? Dn.children[0].attributes.textContent = jn : Dn.children[0].attributes.value = jn);
                }
              }
              if (!this.ui.imageEdit && ((io = Dn.children) != null && io[0]) && this.h) {
                Sn = Sn || St(this.ui[rt.$getExtra]());
                let jn = 0;
                if (this.caption && ["top", "bottom"].includes(this.caption.placement)) {
                  jn = this.caption.reserve, jn <= 0 && (jn = this.caption[rt.$getExtra](zt).h);
                  const In = this.h - jn - xn - Sn.h;
                  Dn.children[0].attributes.style.height = (0, et.measureToString)(In);
                } else
                  Dn.children[0].attributes.style.height = "100%";
              }
              if (oo && Dn.children.push(oo), !dr)
                return Dn.attributes.class && Dn.attributes.class.push("xfaLeft"), this.w = qr, this.h = ln, ut.HTMLResult.success((0, et.createWrapper)(this, Vn), _i);
              if (this.ui.button)
                return $n.padding && delete $n.padding, dr.name === "div" && (dr.name = "span"), Dn.children.push(dr), ut.HTMLResult.success(Vn, _i);
              switch (this.ui.checkButton && (dr.attributes.class[0] = "xfaCaptionForCheckButton"), Dn.attributes.class || (Dn.attributes.class = []), Dn.children.splice(0, 0, dr), this.caption.placement) {
                case "left":
                  Dn.attributes.class.push("xfaLeft");
                  break;
                case "right":
                  Dn.attributes.class.push("xfaRight");
                  break;
                case "top":
                  Dn.attributes.class.push("xfaTop");
                  break;
                case "bottom":
                  Dn.attributes.class.push("xfaBottom");
                  break;
                case "inline":
                  Dn.attributes.class.push("xfaLeft");
                  break;
              }
              return this.w = qr, this.h = ln, ut.HTMLResult.success((0, et.createWrapper)(this, Vn), _i);
            }
          }
          at.Field = Tr;
          class fr extends it.XFAObject {
            constructor(zt) {
              super(pt, "fill", !0), this.id = zt.id || "", this.presence = (0, ut.getStringOption)(zt.presence, ["visible", "hidden", "inactive", "invisible"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.color = null, this.extras = null, this.linear = null, this.pattern = null, this.radial = null, this.solid = null, this.stipple = null;
            }
            [rt.$toStyle]() {
              var Sn;
              const zt = this[rt.$getParent](), qr = zt[rt.$getParent]()[rt.$getParent](), ln = /* @__PURE__ */ Object.create(null);
              let cn = "color", xn = cn;
              zt instanceof Qt && (cn = "background-color", xn = "background", qr instanceof Yn && (ln.backgroundColor = "white")), (zt instanceof yn || zt instanceof Nt) && (cn = xn = "fill", ln.fill = "white");
              for (const $n of Object.getOwnPropertyNames(this)) {
                if ($n === "extras" || $n === "color")
                  continue;
                const On = this[$n];
                if (!(On instanceof it.XFAObject))
                  continue;
                const _n = On[rt.$toStyle](this.color);
                return _n && (ln[_n.startsWith("#") ? cn : xn] = _n), ln;
              }
              if ((Sn = this.color) != null && Sn.value) {
                const $n = this.color[rt.$toStyle]();
                ln[$n.startsWith("#") ? cn : xn] = $n;
              }
              return ln;
            }
          }
          class Cr extends it.XFAObject {
            constructor(zt) {
              super(pt, "filter", !0), this.addRevocationInfo = (0, ut.getStringOption)(zt.addRevocationInfo, ["", "required", "optional", "none"]), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.version = (0, ut.getInteger)({
                data: this.version,
                defaultValue: 5,
                validate: (dr) => dr >= 1 && dr <= 5
              }), this.appearanceFilter = null, this.certificates = null, this.digestMethods = null, this.encodings = null, this.encryptionMethods = null, this.handler = null, this.lockDocument = null, this.mdp = null, this.reasons = null, this.timeStamp = null;
            }
          }
          class $r extends it.ContentObject {
            constructor(zt) {
              super(pt, "float"), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$finalize]() {
              const zt = parseFloat(this[rt.$content].trim());
              this[rt.$content] = isNaN(zt) ? null : zt;
            }
            [rt.$toHTML](zt) {
              return Rt(this[rt.$content] !== null ? this[rt.$content].toString() : "");
            }
          }
          class wr extends it.XFAObject {
            constructor(zt) {
              super(pt, "font", !0), this.baselineShift = (0, ut.getMeasurement)(zt.baselineShift), this.fontHorizontalScale = (0, ut.getFloat)({
                data: zt.fontHorizontalScale,
                defaultValue: 100,
                validate: (dr) => dr >= 0
              }), this.fontVerticalScale = (0, ut.getFloat)({
                data: zt.fontVerticalScale,
                defaultValue: 100,
                validate: (dr) => dr >= 0
              }), this.id = zt.id || "", this.kerningMode = (0, ut.getStringOption)(zt.kerningMode, ["none", "pair"]), this.letterSpacing = (0, ut.getMeasurement)(zt.letterSpacing, "0"), this.lineThrough = (0, ut.getInteger)({
                data: zt.lineThrough,
                defaultValue: 0,
                validate: (dr) => dr === 1 || dr === 2
              }), this.lineThroughPeriod = (0, ut.getStringOption)(zt.lineThroughPeriod, ["all", "word"]), this.overline = (0, ut.getInteger)({
                data: zt.overline,
                defaultValue: 0,
                validate: (dr) => dr === 1 || dr === 2
              }), this.overlinePeriod = (0, ut.getStringOption)(zt.overlinePeriod, ["all", "word"]), this.posture = (0, ut.getStringOption)(zt.posture, ["normal", "italic"]), this.size = (0, ut.getMeasurement)(zt.size, "10pt"), this.typeface = zt.typeface || "Courier", this.underline = (0, ut.getInteger)({
                data: zt.underline,
                defaultValue: 0,
                validate: (dr) => dr === 1 || dr === 2
              }), this.underlinePeriod = (0, ut.getStringOption)(zt.underlinePeriod, ["all", "word"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.weight = (0, ut.getStringOption)(zt.weight, ["normal", "bold"]), this.extras = null, this.fill = null;
            }
            [rt.$clean](zt) {
              super[rt.$clean](zt), this[rt.$globalData].usedTypefaces.add(this.typeface);
            }
            [rt.$toStyle]() {
              const zt = (0, et.toStyle)(this, "fill"), dr = zt.color;
              return dr && (dr === "#000000" ? delete zt.color : dr.startsWith("#") || (zt.background = dr, zt.backgroundClip = "text", zt.color = "transparent")), this.baselineShift && (zt.verticalAlign = (0, et.measureToString)(this.baselineShift)), zt.fontKerning = this.kerningMode === "none" ? "none" : "normal", zt.letterSpacing = (0, et.measureToString)(this.letterSpacing), this.lineThrough !== 0 && (zt.textDecoration = "line-through", this.lineThrough === 2 && (zt.textDecorationStyle = "double")), this.overline !== 0 && (zt.textDecoration = "overline", this.overline === 2 && (zt.textDecorationStyle = "double")), zt.fontStyle = this.posture, zt.fontSize = (0, et.measureToString)(0.99 * this.size), (0, et.setFontFamily)(this, this, this[rt.$globalData].fontFinder, zt), this.underline !== 0 && (zt.textDecoration = "underline", this.underline === 2 && (zt.textDecorationStyle = "double")), zt.fontWeight = this.weight, zt;
            }
          }
          class Mr extends it.XFAObject {
            constructor(zt) {
              super(pt, "format", !0), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.picture = null;
            }
          }
          class Fr extends it.StringObject {
            constructor(zt) {
              super(pt, "handler"), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class Qr extends it.XFAObject {
            constructor(zt) {
              super(pt, "hyphenation"), this.excludeAllCaps = (0, ut.getInteger)({
                data: zt.excludeAllCaps,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.excludeInitialCap = (0, ut.getInteger)({
                data: zt.excludeInitialCap,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.hyphenate = (0, ut.getInteger)({
                data: zt.hyphenate,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.id = zt.id || "", this.pushCharacterCount = (0, ut.getInteger)({
                data: zt.pushCharacterCount,
                defaultValue: 3,
                validate: (dr) => dr >= 0
              }), this.remainCharacterCount = (0, ut.getInteger)({
                data: zt.remainCharacterCount,
                defaultValue: 3,
                validate: (dr) => dr >= 0
              }), this.use = zt.use || "", this.usehref = zt.usehref || "", this.wordCharacterCount = (0, ut.getInteger)({
                data: zt.wordCharacterCount,
                defaultValue: 7,
                validate: (dr) => dr >= 0
              });
            }
          }
          class Yr extends it.StringObject {
            constructor(zt) {
              super(pt, "image"), this.aspect = (0, ut.getStringOption)(zt.aspect, ["fit", "actual", "height", "none", "width"]), this.contentType = zt.contentType || "", this.href = zt.href || "", this.id = zt.id || "", this.name = zt.name || "", this.transferEncoding = (0, ut.getStringOption)(zt.transferEncoding, ["base64", "none", "package"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$toHTML]() {
              if (this.contentType && !bt.has(this.contentType.toLowerCase()))
                return ut.HTMLResult.EMPTY;
              let zt = this[rt.$globalData].images && this[rt.$globalData].images.get(this.href);
              if (!zt && (this.href || !this[rt.$content]) || (!zt && this.transferEncoding === "base64" && (zt = (0, ft.stringToBytes)(atob(this[rt.$content]))), !zt))
                return ut.HTMLResult.EMPTY;
              if (!this.contentType) {
                for (const [cn, xn] of Et)
                  if (zt.length > cn.length && cn.every((Sn, $n) => Sn === zt[$n])) {
                    this.contentType = xn;
                    break;
                  }
                if (!this.contentType)
                  return ut.HTMLResult.EMPTY;
              }
              const dr = new Blob([zt], {
                type: this.contentType
              });
              let qr;
              switch (this.aspect) {
                case "fit":
                case "actual":
                  break;
                case "height":
                  qr = {
                    height: "100%",
                    objectFit: "fill"
                  };
                  break;
                case "none":
                  qr = {
                    width: "100%",
                    height: "100%",
                    objectFit: "fill"
                  };
                  break;
                case "width":
                  qr = {
                    width: "100%",
                    objectFit: "fill"
                  };
                  break;
              }
              const ln = this[rt.$getParent]();
              return ut.HTMLResult.success({
                name: "img",
                attributes: {
                  class: ["xfaImage"],
                  style: qr,
                  src: URL.createObjectURL(dr),
                  alt: ln ? yt(ln[rt.$getParent]()) : null
                }
              });
            }
          }
          class kr extends it.XFAObject {
            constructor(zt) {
              super(pt, "imageEdit", !0), this.data = (0, ut.getStringOption)(zt.data, ["link", "embed"]), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
            [rt.$toHTML](zt) {
              return this.data === "embed" ? ut.HTMLResult.success({
                name: "div",
                children: [],
                attributes: {}
              }) : ut.HTMLResult.EMPTY;
            }
          }
          class Nr extends it.ContentObject {
            constructor(zt) {
              super(pt, "integer"), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$finalize]() {
              const zt = parseInt(this[rt.$content].trim(), 10);
              this[rt.$content] = isNaN(zt) ? null : zt;
            }
            [rt.$toHTML](zt) {
              return Rt(this[rt.$content] !== null ? this[rt.$content].toString() : "");
            }
          }
          class Lr extends it.XFAObject {
            constructor(zt) {
              super(pt, "issuers", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.certificate = new it.XFAObjectArray();
            }
          }
          class zr extends it.XFAObject {
            constructor(zt) {
              super(pt, "items", !0), this.id = zt.id || "", this.name = zt.name || "", this.presence = (0, ut.getStringOption)(zt.presence, ["visible", "hidden", "inactive", "invisible"]), this.ref = zt.ref || "", this.save = (0, ut.getInteger)({
                data: zt.save,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.use = zt.use || "", this.usehref = zt.usehref || "", this.boolean = new it.XFAObjectArray(), this.date = new it.XFAObjectArray(), this.dateTime = new it.XFAObjectArray(), this.decimal = new it.XFAObjectArray(), this.exData = new it.XFAObjectArray(), this.float = new it.XFAObjectArray(), this.image = new it.XFAObjectArray(), this.integer = new it.XFAObjectArray(), this.text = new it.XFAObjectArray(), this.time = new it.XFAObjectArray();
            }
            [rt.$toHTML]() {
              const zt = [];
              for (const dr of this[rt.$getChildren]())
                zt.push(dr[rt.$text]());
              return ut.HTMLResult.success(zt);
            }
          }
          at.Items = zr;
          class Vr extends it.XFAObject {
            constructor(zt) {
              super(pt, "keep", !0), this.id = zt.id || "";
              const dr = ["none", "contentArea", "pageArea"];
              this.intact = (0, ut.getStringOption)(zt.intact, dr), this.next = (0, ut.getStringOption)(zt.next, dr), this.previous = (0, ut.getStringOption)(zt.previous, dr), this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null;
            }
          }
          class an extends it.XFAObject {
            constructor(zt) {
              super(pt, "keyUsage");
              const dr = ["", "yes", "no"];
              this.crlSign = (0, ut.getStringOption)(zt.crlSign, dr), this.dataEncipherment = (0, ut.getStringOption)(zt.dataEncipherment, dr), this.decipherOnly = (0, ut.getStringOption)(zt.decipherOnly, dr), this.digitalSignature = (0, ut.getStringOption)(zt.digitalSignature, dr), this.encipherOnly = (0, ut.getStringOption)(zt.encipherOnly, dr), this.id = zt.id || "", this.keyAgreement = (0, ut.getStringOption)(zt.keyAgreement, dr), this.keyCertSign = (0, ut.getStringOption)(zt.keyCertSign, dr), this.keyEncipherment = (0, ut.getStringOption)(zt.keyEncipherment, dr), this.nonRepudiation = (0, ut.getStringOption)(zt.nonRepudiation, dr), this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class Zr extends it.XFAObject {
            constructor(zt) {
              super(pt, "line", !0), this.hand = (0, ut.getStringOption)(zt.hand, ["even", "left", "right"]), this.id = zt.id || "", this.slope = (0, ut.getStringOption)(zt.slope, ["\\", "/"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.edge = null;
            }
            [rt.$toHTML]() {
              const zt = this[rt.$getParent]()[rt.$getParent](), dr = this.edge || new Ar({}), qr = dr[rt.$toStyle](), ln = /* @__PURE__ */ Object.create(null), cn = dr.presence === "visible" ? dr.thickness : 0;
              ln.strokeWidth = (0, et.measureToString)(cn), ln.stroke = qr.color;
              let xn, Sn, $n, On, _n = "100%", Kn = "100%";
              zt.w <= cn ? ([xn, Sn, $n, On] = ["50%", 0, "50%", "100%"], _n = ln.strokeWidth) : zt.h <= cn ? ([xn, Sn, $n, On] = [0, "50%", "100%", "50%"], Kn = ln.strokeWidth) : this.slope === "\\" ? [xn, Sn, $n, On] = [0, 0, "100%", "100%"] : [xn, Sn, $n, On] = [0, "100%", "100%", 0];
              const Xn = {
                name: "svg",
                children: [{
                  name: "line",
                  attributes: {
                    xmlns: mt,
                    x1: xn,
                    y1: Sn,
                    x2: $n,
                    y2: On,
                    style: ln
                  }
                }],
                attributes: {
                  xmlns: mt,
                  width: _n,
                  height: Kn,
                  style: {
                    overflow: "visible"
                  }
                }
              };
              return Bt(zt) ? ut.HTMLResult.success({
                name: "div",
                attributes: {
                  style: {
                    display: "inline",
                    width: "100%",
                    height: "100%"
                  }
                },
                children: [Xn]
              }) : (Xn.attributes.style.position = "absolute", ut.HTMLResult.success(Xn));
            }
          }
          class un extends it.XFAObject {
            constructor(zt) {
              super(pt, "linear", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["toRight", "toBottom", "toLeft", "toTop"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.color = null, this.extras = null;
            }
            [rt.$toStyle](zt) {
              zt = zt ? zt[rt.$toStyle]() : "#FFFFFF";
              const dr = this.type.replace(/([RBLT])/, " $1").toLowerCase(), qr = this.color ? this.color[rt.$toStyle]() : "#000000";
              return `linear-gradient(${dr}, ${zt}, ${qr})`;
            }
          }
          class Xr extends it.ContentObject {
            constructor(zt) {
              super(pt, "lockDocument"), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$finalize]() {
              this[rt.$content] = (0, ut.getStringOption)(this[rt.$content], ["auto", "0", "1"]);
            }
          }
          class Kr extends it.XFAObject {
            constructor(zt) {
              super(pt, "manifest", !0), this.action = (0, ut.getStringOption)(zt.action, ["include", "all", "exclude"]), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.ref = new it.XFAObjectArray();
            }
          }
          class rn extends it.XFAObject {
            constructor(zt) {
              super(pt, "margin", !0), this.bottomInset = (0, ut.getMeasurement)(zt.bottomInset, "0"), this.id = zt.id || "", this.leftInset = (0, ut.getMeasurement)(zt.leftInset, "0"), this.rightInset = (0, ut.getMeasurement)(zt.rightInset, "0"), this.topInset = (0, ut.getMeasurement)(zt.topInset, "0"), this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null;
            }
            [rt.$toStyle]() {
              return {
                margin: (0, et.measureToString)(this.topInset) + " " + (0, et.measureToString)(this.rightInset) + " " + (0, et.measureToString)(this.bottomInset) + " " + (0, et.measureToString)(this.leftInset)
              };
            }
          }
          class nn extends it.XFAObject {
            constructor(zt) {
              super(pt, "mdp"), this.id = zt.id || "", this.permissions = (0, ut.getInteger)({
                data: zt.permissions,
                defaultValue: 2,
                validate: (dr) => dr === 1 || dr === 3
              }), this.signatureType = (0, ut.getStringOption)(zt.signatureType, ["filler", "author"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class sn extends it.XFAObject {
            constructor(zt) {
              super(pt, "medium"), this.id = zt.id || "", this.imagingBBox = (0, ut.getBBox)(zt.imagingBBox), this.long = (0, ut.getMeasurement)(zt.long), this.orientation = (0, ut.getStringOption)(zt.orientation, ["portrait", "landscape"]), this.short = (0, ut.getMeasurement)(zt.short), this.stock = zt.stock || "", this.trayIn = (0, ut.getStringOption)(zt.trayIn, ["auto", "delegate", "pageFront"]), this.trayOut = (0, ut.getStringOption)(zt.trayOut, ["auto", "delegate"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class gn extends it.XFAObject {
            constructor(zt) {
              super(pt, "message", !0), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.text = new it.XFAObjectArray();
            }
          }
          class en extends it.XFAObject {
            constructor(zt) {
              super(pt, "numericEdit", !0), this.hScrollPolicy = (0, ut.getStringOption)(zt.hScrollPolicy, ["auto", "off", "on"]), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.border = null, this.comb = null, this.extras = null, this.margin = null;
            }
            [rt.$toHTML](zt) {
              var cn;
              const dr = (0, et.toStyle)(this, "border", "font", "margin"), qr = this[rt.$getParent]()[rt.$getParent](), ln = {
                name: "input",
                attributes: {
                  type: "text",
                  fieldId: qr[rt.$uid],
                  dataId: ((cn = qr[rt.$data]) == null ? void 0 : cn[rt.$uid]) || qr[rt.$uid],
                  class: ["xfaTextfield"],
                  style: dr,
                  "aria-label": yt(qr),
                  "aria-required": !1
                }
              };
              return wt(qr) && (ln.attributes["aria-required"] = !0, ln.attributes.required = !0), ut.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [ln]
              });
            }
          }
          class Wr extends it.XFAObject {
            constructor(zt) {
              super(pt, "occur", !0), this.id = zt.id || "", this.initial = zt.initial !== "" ? (0, ut.getInteger)({
                data: zt.initial,
                defaultValue: "",
                validate: (dr) => !0
              }) : "", this.max = zt.max !== "" ? (0, ut.getInteger)({
                data: zt.max,
                defaultValue: 1,
                validate: (dr) => !0
              }) : "", this.min = zt.min !== "" ? (0, ut.getInteger)({
                data: zt.min,
                defaultValue: 1,
                validate: (dr) => !0
              }) : "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null;
            }
            [rt.$clean]() {
              const zt = this[rt.$getParent](), dr = this.min;
              this.min === "" && (this.min = zt instanceof bn || zt instanceof Cn ? 0 : 1), this.max === "" && (dr === "" ? this.max = zt instanceof bn || zt instanceof Cn ? -1 : 1 : this.max = this.min), this.max !== -1 && this.max < this.min && (this.max = this.min), this.initial === "" && (this.initial = zt instanceof lo ? 1 : this.min);
            }
          }
          class dn extends it.StringObject {
            constructor(zt) {
              super(pt, "oid"), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class hn extends it.XFAObject {
            constructor(zt) {
              super(pt, "oids", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.oid = new it.XFAObjectArray();
            }
          }
          class En extends it.XFAObject {
            constructor(zt) {
              super(pt, "overflow"), this.id = zt.id || "", this.leader = zt.leader || "", this.target = zt.target || "", this.trailer = zt.trailer || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$getExtra]() {
              if (!this[rt.$extra]) {
                const zt = this[rt.$getParent](), dr = this[rt.$getTemplateRoot](), qr = dr[rt.$searchNode](this.target, zt), ln = dr[rt.$searchNode](this.leader, zt), cn = dr[rt.$searchNode](this.trailer, zt);
                this[rt.$extra] = {
                  target: (qr == null ? void 0 : qr[0]) || null,
                  leader: (ln == null ? void 0 : ln[0]) || null,
                  trailer: (cn == null ? void 0 : cn[0]) || null,
                  addLeader: !1,
                  addTrailer: !1
                };
              }
              return this[rt.$extra];
            }
          }
          class bn extends it.XFAObject {
            constructor(zt) {
              super(pt, "pageArea", !0), this.blankOrNotBlank = (0, ut.getStringOption)(zt.blankOrNotBlank, ["any", "blank", "notBlank"]), this.id = zt.id || "", this.initialNumber = (0, ut.getInteger)({
                data: zt.initialNumber,
                defaultValue: 1,
                validate: (dr) => !0
              }), this.name = zt.name || "", this.numbered = (0, ut.getInteger)({
                data: zt.numbered,
                defaultValue: 1,
                validate: (dr) => !0
              }), this.oddOrEven = (0, ut.getStringOption)(zt.oddOrEven, ["any", "even", "odd"]), this.pagePosition = (0, ut.getStringOption)(zt.pagePosition, ["any", "first", "last", "only", "rest"]), this.relevant = (0, ut.getRelevant)(zt.relevant), this.use = zt.use || "", this.usehref = zt.usehref || "", this.desc = null, this.extras = null, this.medium = null, this.occur = null, this.area = new it.XFAObjectArray(), this.contentArea = new it.XFAObjectArray(), this.draw = new it.XFAObjectArray(), this.exclGroup = new it.XFAObjectArray(), this.field = new it.XFAObjectArray(), this.subform = new it.XFAObjectArray();
            }
            [rt.$isUsable]() {
              return this[rt.$extra] ? !this.occur || this.occur.max === -1 || this[rt.$extra].numberOfUse < this.occur.max : (this[rt.$extra] = {
                numberOfUse: 0
              }, !0);
            }
            [rt.$cleanPage]() {
              delete this[rt.$extra];
            }
            [rt.$getNextPage]() {
              this[rt.$extra] || (this[rt.$extra] = {
                numberOfUse: 0
              });
              const zt = this[rt.$getParent]();
              return zt.relation === "orderedOccurrence" && this[rt.$isUsable]() ? (this[rt.$extra].numberOfUse += 1, this) : zt[rt.$getNextPage]();
            }
            [rt.$getAvailableSpace]() {
              return this[rt.$extra].space || {
                width: 0,
                height: 0
              };
            }
            [rt.$toHTML]() {
              this[rt.$extra] || (this[rt.$extra] = {
                numberOfUse: 1
              });
              const zt = [];
              this[rt.$extra].children = zt;
              const dr = /* @__PURE__ */ Object.create(null);
              if (this.medium && this.medium.short && this.medium.long) {
                if (dr.width = (0, et.measureToString)(this.medium.short), dr.height = (0, et.measureToString)(this.medium.long), this[rt.$extra].space = {
                  width: this.medium.short,
                  height: this.medium.long
                }, this.medium.orientation === "landscape") {
                  const qr = dr.width;
                  dr.width = dr.height, dr.height = qr, this[rt.$extra].space = {
                    width: this.medium.long,
                    height: this.medium.short
                  };
                }
              } else
                (0, ft.warn)("XFA - No medium specified in pageArea: please file a bug.");
              return this[rt.$childrenToHTML]({
                filter: /* @__PURE__ */ new Set(["area", "draw", "field", "subform"]),
                include: !0
              }), this[rt.$childrenToHTML]({
                filter: /* @__PURE__ */ new Set(["contentArea"]),
                include: !0
              }), ut.HTMLResult.success({
                name: "div",
                children: zt,
                attributes: {
                  class: ["xfaPage"],
                  id: this[rt.$uid],
                  style: dr,
                  xfaName: this.name
                }
              });
            }
          }
          class Cn extends it.XFAObject {
            constructor(zt) {
              super(pt, "pageSet", !0), this.duplexImposition = (0, ut.getStringOption)(zt.duplexImposition, ["longEdge", "shortEdge"]), this.id = zt.id || "", this.name = zt.name || "", this.relation = (0, ut.getStringOption)(zt.relation, ["orderedOccurrence", "duplexPaginated", "simplexPaginated"]), this.relevant = (0, ut.getRelevant)(zt.relevant), this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.occur = null, this.pageArea = new it.XFAObjectArray(), this.pageSet = new it.XFAObjectArray();
            }
            [rt.$cleanPage]() {
              for (const zt of this.pageArea.children)
                zt[rt.$cleanPage]();
              for (const zt of this.pageSet.children)
                zt[rt.$cleanPage]();
            }
            [rt.$isUsable]() {
              return !this.occur || this.occur.max === -1 || this[rt.$extra].numberOfUse < this.occur.max;
            }
            [rt.$getNextPage]() {
              if (this[rt.$extra] || (this[rt.$extra] = {
                numberOfUse: 1,
                pageIndex: -1,
                pageSetIndex: -1
              }), this.relation === "orderedOccurrence") {
                if (this[rt.$extra].pageIndex + 1 < this.pageArea.children.length)
                  return this[rt.$extra].pageIndex += 1, this.pageArea.children[this[rt.$extra].pageIndex][rt.$getNextPage]();
                if (this[rt.$extra].pageSetIndex + 1 < this.pageSet.children.length)
                  return this[rt.$extra].pageSetIndex += 1, this.pageSet.children[this[rt.$extra].pageSetIndex][rt.$getNextPage]();
                if (this[rt.$isUsable]())
                  return this[rt.$extra].numberOfUse += 1, this[rt.$extra].pageIndex = -1, this[rt.$extra].pageSetIndex = -1, this[rt.$getNextPage]();
                const cn = this[rt.$getParent]();
                return cn instanceof Cn ? cn[rt.$getNextPage]() : (this[rt.$cleanPage](), this[rt.$getNextPage]());
              }
              const zt = this[rt.$getTemplateRoot]()[rt.$extra].pageNumber, dr = zt % 2 === 0 ? "even" : "odd", qr = zt === 0 ? "first" : "rest";
              let ln = this.pageArea.children.find((cn) => cn.oddOrEven === dr && cn.pagePosition === qr);
              return ln || (ln = this.pageArea.children.find((cn) => cn.oddOrEven === "any" && cn.pagePosition === qr), ln) || (ln = this.pageArea.children.find((cn) => cn.oddOrEven === "any" && cn.pagePosition === "any"), ln) ? ln : this.pageArea.children[0];
            }
          }
          class wn extends it.XFAObject {
            constructor(zt) {
              super(pt, "para", !0), this.hAlign = (0, ut.getStringOption)(zt.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = zt.id || "", this.lineHeight = zt.lineHeight ? (0, ut.getMeasurement)(zt.lineHeight, "0pt") : "", this.marginLeft = zt.marginLeft ? (0, ut.getMeasurement)(zt.marginLeft, "0pt") : "", this.marginRight = zt.marginRight ? (0, ut.getMeasurement)(zt.marginRight, "0pt") : "", this.orphans = (0, ut.getInteger)({
                data: zt.orphans,
                defaultValue: 0,
                validate: (dr) => dr >= 0
              }), this.preserve = zt.preserve || "", this.radixOffset = zt.radixOffset ? (0, ut.getMeasurement)(zt.radixOffset, "0pt") : "", this.spaceAbove = zt.spaceAbove ? (0, ut.getMeasurement)(zt.spaceAbove, "0pt") : "", this.spaceBelow = zt.spaceBelow ? (0, ut.getMeasurement)(zt.spaceBelow, "0pt") : "", this.tabDefault = zt.tabDefault ? (0, ut.getMeasurement)(this.tabDefault) : "", this.tabStops = (zt.tabStops || "").trim().split(/\s+/).map((dr, qr) => qr % 2 === 1 ? (0, ut.getMeasurement)(dr) : dr), this.textIndent = zt.textIndent ? (0, ut.getMeasurement)(zt.textIndent, "0pt") : "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.vAlign = (0, ut.getStringOption)(zt.vAlign, ["top", "bottom", "middle"]), this.widows = (0, ut.getInteger)({
                data: zt.widows,
                defaultValue: 0,
                validate: (dr) => dr >= 0
              }), this.hyphenation = null;
            }
            [rt.$toStyle]() {
              const zt = (0, et.toStyle)(this, "hAlign");
              return this.marginLeft !== "" && (zt.paddingLeft = (0, et.measureToString)(this.marginLeft)), this.marginRight !== "" && (zt.paddingight = (0, et.measureToString)(this.marginRight)), this.spaceAbove !== "" && (zt.paddingTop = (0, et.measureToString)(this.spaceAbove)), this.spaceBelow !== "" && (zt.paddingBottom = (0, et.measureToString)(this.spaceBelow)), this.textIndent !== "" && (zt.textIndent = (0, et.measureToString)(this.textIndent), (0, et.fixTextIndent)(zt)), this.lineHeight > 0 && (zt.lineHeight = (0, et.measureToString)(this.lineHeight)), this.tabDefault !== "" && (zt.tabSize = (0, et.measureToString)(this.tabDefault)), this.tabStops.length > 0, this.hyphenatation && Object.assign(zt, this.hyphenatation[rt.$toStyle]()), zt;
            }
          }
          class vn extends it.XFAObject {
            constructor(zt) {
              super(pt, "passwordEdit", !0), this.hScrollPolicy = (0, ut.getStringOption)(zt.hScrollPolicy, ["auto", "off", "on"]), this.id = zt.id || "", this.passwordChar = zt.passwordChar || "*", this.use = zt.use || "", this.usehref = zt.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
          }
          class fn extends it.XFAObject {
            constructor(zt) {
              super(pt, "pattern", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["crossHatch", "crossDiagonal", "diagonalLeft", "diagonalRight", "horizontal", "vertical"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.color = null, this.extras = null;
            }
            [rt.$toStyle](zt) {
              zt = zt ? zt[rt.$toStyle]() : "#FFFFFF";
              const dr = this.color ? this.color[rt.$toStyle]() : "#000000", qr = 5, ln = "repeating-linear-gradient", cn = `${zt},${zt} ${qr}px,${dr} ${qr}px,${dr} ${2 * qr}px`;
              switch (this.type) {
                case "crossHatch":
                  return `${ln}(to top,${cn}) ${ln}(to right,${cn})`;
                case "crossDiagonal":
                  return `${ln}(45deg,${cn}) ${ln}(-45deg,${cn})`;
                case "diagonalLeft":
                  return `${ln}(45deg,${cn})`;
                case "diagonalRight":
                  return `${ln}(-45deg,${cn})`;
                case "horizontal":
                  return `${ln}(to top,${cn})`;
                case "vertical":
                  return `${ln}(to right,${cn})`;
              }
              return "";
            }
          }
          class on extends it.StringObject {
            constructor(zt) {
              super(pt, "picture"), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class pn extends it.XFAObject {
            constructor(zt) {
              super(pt, "proto", !0), this.appearanceFilter = new it.XFAObjectArray(), this.arc = new it.XFAObjectArray(), this.area = new it.XFAObjectArray(), this.assist = new it.XFAObjectArray(), this.barcode = new it.XFAObjectArray(), this.bindItems = new it.XFAObjectArray(), this.bookend = new it.XFAObjectArray(), this.boolean = new it.XFAObjectArray(), this.border = new it.XFAObjectArray(), this.break = new it.XFAObjectArray(), this.breakAfter = new it.XFAObjectArray(), this.breakBefore = new it.XFAObjectArray(), this.button = new it.XFAObjectArray(), this.calculate = new it.XFAObjectArray(), this.caption = new it.XFAObjectArray(), this.certificate = new it.XFAObjectArray(), this.certificates = new it.XFAObjectArray(), this.checkButton = new it.XFAObjectArray(), this.choiceList = new it.XFAObjectArray(), this.color = new it.XFAObjectArray(), this.comb = new it.XFAObjectArray(), this.connect = new it.XFAObjectArray(), this.contentArea = new it.XFAObjectArray(), this.corner = new it.XFAObjectArray(), this.date = new it.XFAObjectArray(), this.dateTime = new it.XFAObjectArray(), this.dateTimeEdit = new it.XFAObjectArray(), this.decimal = new it.XFAObjectArray(), this.defaultUi = new it.XFAObjectArray(), this.desc = new it.XFAObjectArray(), this.digestMethod = new it.XFAObjectArray(), this.digestMethods = new it.XFAObjectArray(), this.draw = new it.XFAObjectArray(), this.edge = new it.XFAObjectArray(), this.encoding = new it.XFAObjectArray(), this.encodings = new it.XFAObjectArray(), this.encrypt = new it.XFAObjectArray(), this.encryptData = new it.XFAObjectArray(), this.encryption = new it.XFAObjectArray(), this.encryptionMethod = new it.XFAObjectArray(), this.encryptionMethods = new it.XFAObjectArray(), this.event = new it.XFAObjectArray(), this.exData = new it.XFAObjectArray(), this.exObject = new it.XFAObjectArray(), this.exclGroup = new it.XFAObjectArray(), this.execute = new it.XFAObjectArray(), this.extras = new it.XFAObjectArray(), this.field = new it.XFAObjectArray(), this.fill = new it.XFAObjectArray(), this.filter = new it.XFAObjectArray(), this.float = new it.XFAObjectArray(), this.font = new it.XFAObjectArray(), this.format = new it.XFAObjectArray(), this.handler = new it.XFAObjectArray(), this.hyphenation = new it.XFAObjectArray(), this.image = new it.XFAObjectArray(), this.imageEdit = new it.XFAObjectArray(), this.integer = new it.XFAObjectArray(), this.issuers = new it.XFAObjectArray(), this.items = new it.XFAObjectArray(), this.keep = new it.XFAObjectArray(), this.keyUsage = new it.XFAObjectArray(), this.line = new it.XFAObjectArray(), this.linear = new it.XFAObjectArray(), this.lockDocument = new it.XFAObjectArray(), this.manifest = new it.XFAObjectArray(), this.margin = new it.XFAObjectArray(), this.mdp = new it.XFAObjectArray(), this.medium = new it.XFAObjectArray(), this.message = new it.XFAObjectArray(), this.numericEdit = new it.XFAObjectArray(), this.occur = new it.XFAObjectArray(), this.oid = new it.XFAObjectArray(), this.oids = new it.XFAObjectArray(), this.overflow = new it.XFAObjectArray(), this.pageArea = new it.XFAObjectArray(), this.pageSet = new it.XFAObjectArray(), this.para = new it.XFAObjectArray(), this.passwordEdit = new it.XFAObjectArray(), this.pattern = new it.XFAObjectArray(), this.picture = new it.XFAObjectArray(), this.radial = new it.XFAObjectArray(), this.reason = new it.XFAObjectArray(), this.reasons = new it.XFAObjectArray(), this.rectangle = new it.XFAObjectArray(), this.ref = new it.XFAObjectArray(), this.script = new it.XFAObjectArray(), this.setProperty = new it.XFAObjectArray(), this.signData = new it.XFAObjectArray(), this.signature = new it.XFAObjectArray(), this.signing = new it.XFAObjectArray(), this.solid = new it.XFAObjectArray(), this.speak = new it.XFAObjectArray(), this.stipple = new it.XFAObjectArray(), this.subform = new it.XFAObjectArray(), this.subformSet = new it.XFAObjectArray(), this.subjectDN = new it.XFAObjectArray(), this.subjectDNs = new it.XFAObjectArray(), this.submit = new it.XFAObjectArray(), this.text = new it.XFAObjectArray(), this.textEdit = new it.XFAObjectArray(), this.time = new it.XFAObjectArray(), this.timeStamp = new it.XFAObjectArray(), this.toolTip = new it.XFAObjectArray(), this.traversal = new it.XFAObjectArray(), this.traverse = new it.XFAObjectArray(), this.ui = new it.XFAObjectArray(), this.validate = new it.XFAObjectArray(), this.value = new it.XFAObjectArray(), this.variables = new it.XFAObjectArray();
            }
          }
          class mn extends it.XFAObject {
            constructor(zt) {
              super(pt, "radial", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["toEdge", "toCenter"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.color = null, this.extras = null;
            }
            [rt.$toStyle](zt) {
              zt = zt ? zt[rt.$toStyle]() : "#FFFFFF";
              const dr = this.color ? this.color[rt.$toStyle]() : "#000000";
              return `radial-gradient(circle at center, ${this.type === "toEdge" ? `${zt},${dr}` : `${dr},${zt}`})`;
            }
          }
          class Pn extends it.StringObject {
            constructor(zt) {
              super(pt, "reason"), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class An extends it.XFAObject {
            constructor(zt) {
              super(pt, "reasons", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.reason = new it.XFAObjectArray();
            }
          }
          class yn extends it.XFAObject {
            constructor(zt) {
              super(pt, "rectangle", !0), this.hand = (0, ut.getStringOption)(zt.hand, ["even", "left", "right"]), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.corner = new it.XFAObjectArray(4), this.edge = new it.XFAObjectArray(4), this.fill = null;
            }
            [rt.$toHTML]() {
              var On;
              const zt = this.edge.children.length ? this.edge.children[0] : new Ar({}), dr = zt[rt.$toStyle](), qr = /* @__PURE__ */ Object.create(null);
              ((On = this.fill) == null ? void 0 : On.presence) === "visible" ? Object.assign(qr, this.fill[rt.$toStyle]()) : qr.fill = "transparent", qr.strokeWidth = (0, et.measureToString)(zt.presence === "visible" ? zt.thickness : 0), qr.stroke = dr.color;
              const cn = (this.corner.children.length ? this.corner.children[0] : new Gt({}))[rt.$toStyle](), Sn = {
                name: "svg",
                children: [{
                  name: "rect",
                  attributes: {
                    xmlns: mt,
                    width: "100%",
                    height: "100%",
                    x: 0,
                    y: 0,
                    rx: cn.radius,
                    ry: cn.radius,
                    style: qr
                  }
                }],
                attributes: {
                  xmlns: mt,
                  style: {
                    overflow: "visible"
                  },
                  width: "100%",
                  height: "100%"
                }
              }, $n = this[rt.$getParent]()[rt.$getParent]();
              return Bt($n) ? ut.HTMLResult.success({
                name: "div",
                attributes: {
                  style: {
                    display: "inline",
                    width: "100%",
                    height: "100%"
                  }
                },
                children: [Sn]
              }) : (Sn.attributes.style.position = "absolute", ut.HTMLResult.success(Sn));
            }
          }
          class Bn extends it.StringObject {
            constructor(zt) {
              super(pt, "ref"), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class Fn extends it.StringObject {
            constructor(zt) {
              super(pt, "script"), this.binding = zt.binding || "", this.contentType = zt.contentType || "", this.id = zt.id || "", this.name = zt.name || "", this.runAt = (0, ut.getStringOption)(zt.runAt, ["client", "both", "server"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class zn extends it.XFAObject {
            constructor(zt) {
              super(pt, "setProperty"), this.connection = zt.connection || "", this.ref = zt.ref || "", this.target = zt.target || "";
            }
          }
          at.SetProperty = zn;
          class Zn extends it.XFAObject {
            constructor(zt) {
              super(pt, "signData", !0), this.id = zt.id || "", this.operation = (0, ut.getStringOption)(zt.operation, ["sign", "clear", "verify"]), this.ref = zt.ref || "", this.target = zt.target || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.filter = null, this.manifest = null;
            }
          }
          class to extends it.XFAObject {
            constructor(zt) {
              super(pt, "signature", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["PDF1.3", "PDF1.6"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.border = null, this.extras = null, this.filter = null, this.manifest = null, this.margin = null;
            }
          }
          class Mn extends it.XFAObject {
            constructor(zt) {
              super(pt, "signing", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.certificate = new it.XFAObjectArray();
            }
          }
          class Nn extends it.XFAObject {
            constructor(zt) {
              super(pt, "solid", !0), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null;
            }
            [rt.$toStyle](zt) {
              return zt ? zt[rt.$toStyle]() : "#FFFFFF";
            }
          }
          class Wn extends it.StringObject {
            constructor(zt) {
              super(pt, "speak"), this.disable = (0, ut.getInteger)({
                data: zt.disable,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.id = zt.id || "", this.priority = (0, ut.getStringOption)(zt.priority, ["custom", "caption", "name", "toolTip"]), this.rid = zt.rid || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class ca extends it.XFAObject {
            constructor(zt) {
              super(pt, "stipple", !0), this.id = zt.id || "", this.rate = (0, ut.getInteger)({
                data: zt.rate,
                defaultValue: 50,
                validate: (dr) => dr >= 0 && dr <= 100
              }), this.use = zt.use || "", this.usehref = zt.usehref || "", this.color = null, this.extras = null;
            }
            [rt.$toStyle](zt) {
              const dr = this.rate / 100;
              return ft.Util.makeHexColor(Math.round(zt.value.r * (1 - dr) + this.value.r * dr), Math.round(zt.value.g * (1 - dr) + this.value.g * dr), Math.round(zt.value.b * (1 - dr) + this.value.b * dr));
            }
          }
          class qn extends it.XFAObject {
            constructor(zt) {
              super(pt, "subform", !0), this.access = (0, ut.getStringOption)(zt.access, ["open", "nonInteractive", "protected", "readOnly"]), this.allowMacro = (0, ut.getInteger)({
                data: zt.allowMacro,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.anchorType = (0, ut.getStringOption)(zt.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, ut.getInteger)({
                data: zt.colSpan,
                defaultValue: 1,
                validate: (dr) => dr >= 1 || dr === -1
              }), this.columnWidths = (zt.columnWidths || "").trim().split(/\s+/).map((dr) => dr === "-1" ? -1 : (0, ut.getMeasurement)(dr)), this.h = zt.h ? (0, ut.getMeasurement)(zt.h) : "", this.hAlign = (0, ut.getStringOption)(zt.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = zt.id || "", this.layout = (0, ut.getStringOption)(zt.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]), this.locale = zt.locale || "", this.maxH = (0, ut.getMeasurement)(zt.maxH, "0pt"), this.maxW = (0, ut.getMeasurement)(zt.maxW, "0pt"), this.mergeMode = (0, ut.getStringOption)(zt.mergeMode, ["consumeData", "matchTemplate"]), this.minH = (0, ut.getMeasurement)(zt.minH, "0pt"), this.minW = (0, ut.getMeasurement)(zt.minW, "0pt"), this.name = zt.name || "", this.presence = (0, ut.getStringOption)(zt.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, ut.getRelevant)(zt.relevant), this.restoreState = (0, ut.getStringOption)(zt.restoreState, ["manual", "auto"]), this.scope = (0, ut.getStringOption)(zt.scope, ["name", "none"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.w = zt.w ? (0, ut.getMeasurement)(zt.w) : "", this.x = (0, ut.getMeasurement)(zt.x, "0pt"), this.y = (0, ut.getMeasurement)(zt.y, "0pt"), this.assist = null, this.bind = null, this.bookend = null, this.border = null, this.break = null, this.calculate = null, this.desc = null, this.extras = null, this.keep = null, this.margin = null, this.occur = null, this.overflow = null, this.pageSet = null, this.para = null, this.traversal = null, this.validate = null, this.variables = null, this.area = new it.XFAObjectArray(), this.breakAfter = new it.XFAObjectArray(), this.breakBefore = new it.XFAObjectArray(), this.connect = new it.XFAObjectArray(), this.draw = new it.XFAObjectArray(), this.event = new it.XFAObjectArray(), this.exObject = new it.XFAObjectArray(), this.exclGroup = new it.XFAObjectArray(), this.field = new it.XFAObjectArray(), this.proto = new it.XFAObjectArray(), this.setProperty = new it.XFAObjectArray(), this.subform = new it.XFAObjectArray(), this.subformSet = new it.XFAObjectArray();
            }
            [rt.$getSubformParent]() {
              const zt = this[rt.$getParent]();
              return zt instanceof eo ? zt[rt.$getSubformParent]() : zt;
            }
            [rt.$isBindable]() {
              return !0;
            }
            [rt.$isThereMoreWidth]() {
              return this.layout.endsWith("-tb") && this[rt.$extra].attempt === 0 && this[rt.$extra].numberInLine > 0 || this[rt.$getParent]()[rt.$isThereMoreWidth]();
            }
            *[rt.$getContainedChildren]() {
              yield* Pt(this);
            }
            [rt.$flushHTML]() {
              return (0, lt.flushHTML)(this);
            }
            [rt.$addHTML](zt, dr) {
              (0, lt.addHTML)(this, zt, dr);
            }
            [rt.$getAvailableSpace]() {
              return (0, lt.getAvailableSpace)(this);
            }
            [rt.$isSplittable]() {
              var dr;
              const zt = this[rt.$getSubformParent]();
              return zt[rt.$isSplittable]() ? this[rt.$extra]._isSplittable !== void 0 ? this[rt.$extra]._isSplittable : this.layout === "position" || this.layout.includes("row") ? (this[rt.$extra]._isSplittable = !1, !1) : this.keep && this.keep.intact !== "none" ? (this[rt.$extra]._isSplittable = !1, !1) : (dr = zt.layout) != null && dr.endsWith("-tb") && zt[rt.$extra].numberInLine !== 0 ? !1 : (this[rt.$extra]._isSplittable = !0, !0) : !1;
            }
            [rt.$toHTML](zt) {
              var jn;
              if (Ct(this), this.break) {
                if (this.break.after !== "auto" || this.break.afterTarget !== "") {
                  const In = new Zt({
                    targetType: this.break.after,
                    target: this.break.afterTarget,
                    startNew: this.break.startNew.toString()
                  });
                  In[rt.$globalData] = this[rt.$globalData], this[rt.$appendChild](In), this.breakAfter.push(In);
                }
                if (this.break.before !== "auto" || this.break.beforeTarget !== "") {
                  const In = new ar({
                    targetType: this.break.before,
                    target: this.break.beforeTarget,
                    startNew: this.break.startNew.toString()
                  });
                  In[rt.$globalData] = this[rt.$globalData], this[rt.$appendChild](In), this.breakBefore.push(In);
                }
                if (this.break.overflowTarget !== "") {
                  const In = new En({
                    target: this.break.overflowTarget,
                    leader: this.break.overflowLeader,
                    trailer: this.break.overflowTrailer
                  });
                  In[rt.$globalData] = this[rt.$globalData], this[rt.$appendChild](In), this.overflow.push(In);
                }
                this[rt.$removeChild](this.break), this.break = null;
              }
              if (this.presence === "hidden" || this.presence === "inactive")
                return ut.HTMLResult.EMPTY;
              if ((this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) && (0, ft.warn)("XFA - Several breakBefore or breakAfter in subforms: please file a bug."), this.breakBefore.children.length >= 1) {
                const In = this.breakBefore.children[0];
                if (Ht(In))
                  return ut.HTMLResult.breakNode(In);
              }
              if ((jn = this[rt.$extra]) != null && jn.afterBreakAfter)
                return ut.HTMLResult.EMPTY;
              (0, et.fixDimensions)(this);
              const dr = [], qr = {
                id: this[rt.$uid],
                class: []
              };
              (0, et.setAccess)(this, qr.class), this[rt.$extra] || (this[rt.$extra] = /* @__PURE__ */ Object.create(null)), Object.assign(this[rt.$extra], {
                children: dr,
                line: null,
                attributes: qr,
                attempt: 0,
                numberInLine: 0,
                availableSpace: {
                  width: Math.min(this.w || 1 / 0, zt.width),
                  height: Math.min(this.h || 1 / 0, zt.height)
                },
                width: 0,
                height: 0,
                prevHeight: 0,
                currentWidth: 0
              });
              const ln = this[rt.$getTemplateRoot](), cn = ln[rt.$extra].noLayoutFailure, xn = this[rt.$isSplittable]();
              if (xn || kt(this), !(0, lt.checkDimensions)(this, zt))
                return ut.HTMLResult.FAILURE;
              const Sn = /* @__PURE__ */ new Set(["area", "draw", "exclGroup", "field", "subform", "subformSet"]);
              if (this.layout.includes("row")) {
                const In = this[rt.$getSubformParent]().columnWidths;
                Array.isArray(In) && In.length > 0 && (this[rt.$extra].columnWidths = In, this[rt.$extra].currentColumn = 0);
              }
              const $n = (0, et.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), On = ["xfaSubform"], _n = (0, et.layoutClass)(this);
              if (_n && On.push(_n), qr.style = $n, qr.class = On, this.name && (qr.xfaName = this.name), this.overflow) {
                const In = this.overflow[rt.$getExtra]();
                In.addLeader && (In.addLeader = !1, Ft(this, In.leader, zt));
              }
              this[rt.$pushPara]();
              const Kn = this.layout === "lr-tb" || this.layout === "rl-tb", Vn = Kn ? ct : 1;
              for (; this[rt.$extra].attempt < Vn; this[rt.$extra].attempt++) {
                Kn && this[rt.$extra].attempt === ct - 1 && (this[rt.$extra].numberInLine = 0);
                const In = this[rt.$childrenToHTML]({
                  filter: Sn,
                  include: !0
                });
                if (In.success)
                  break;
                if (In.isBreak())
                  return this[rt.$popPara](), In;
                if (Kn && this[rt.$extra].attempt === 0 && this[rt.$extra].numberInLine === 0 && !ln[rt.$extra].noLayoutFailure) {
                  this[rt.$extra].attempt = Vn;
                  break;
                }
              }
              if (this[rt.$popPara](), xn || jt(this), ln[rt.$extra].noLayoutFailure = cn, this[rt.$extra].attempt === Vn)
                return this.overflow && (this[rt.$getTemplateRoot]()[rt.$extra].overflowNode = this.overflow), xn || delete this[rt.$extra], ut.HTMLResult.FAILURE;
              if (this.overflow) {
                const In = this.overflow[rt.$getExtra]();
                In.addTrailer && (In.addTrailer = !1, Ft(this, In.trailer, zt));
              }
              let Xn = 0, _i = 0;
              this.margin && (Xn = this.margin.leftInset + this.margin.rightInset, _i = this.margin.topInset + this.margin.bottomInset);
              const Dn = Math.max(this[rt.$extra].width + Xn, this.w || 0), oo = Math.max(this[rt.$extra].height + _i, this.h || 0), Jn = [this.x, this.y, Dn, oo];
              if (this.w === "" && ($n.width = (0, et.measureToString)(Dn)), this.h === "" && ($n.height = (0, et.measureToString)(oo)), ($n.width === "0px" || $n.height === "0px") && dr.length === 0)
                return ut.HTMLResult.EMPTY;
              const fo = {
                name: "div",
                attributes: qr,
                children: dr
              };
              It(this, qr);
              const io = ut.HTMLResult.success((0, et.createWrapper)(this, fo), Jn);
              if (this.breakAfter.children.length >= 1) {
                const In = this.breakAfter.children[0];
                if (Ht(In))
                  return this[rt.$extra].afterBreakAfter = io, ut.HTMLResult.breakNode(In);
              }
              return delete this[rt.$extra], io;
            }
          }
          class eo extends it.XFAObject {
            constructor(zt) {
              super(pt, "subformSet", !0), this.id = zt.id || "", this.name = zt.name || "", this.relation = (0, ut.getStringOption)(zt.relation, ["ordered", "choice", "unordered"]), this.relevant = (0, ut.getRelevant)(zt.relevant), this.use = zt.use || "", this.usehref = zt.usehref || "", this.bookend = null, this.break = null, this.desc = null, this.extras = null, this.occur = null, this.overflow = null, this.breakAfter = new it.XFAObjectArray(), this.breakBefore = new it.XFAObjectArray(), this.subform = new it.XFAObjectArray(), this.subformSet = new it.XFAObjectArray();
            }
            *[rt.$getContainedChildren]() {
              yield* Pt(this);
            }
            [rt.$getSubformParent]() {
              let zt = this[rt.$getParent]();
              for (; !(zt instanceof qn); )
                zt = zt[rt.$getParent]();
              return zt;
            }
            [rt.$isBindable]() {
              return !0;
            }
          }
          class ro extends it.ContentObject {
            constructor(zt) {
              super(pt, "subjectDN"), this.delimiter = zt.delimiter || ",", this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$finalize]() {
              this[rt.$content] = new Map(this[rt.$content].split(this.delimiter).map((zt) => (zt = zt.split("=", 2), zt[0] = zt[0].trim(), zt)));
            }
          }
          class ao extends it.XFAObject {
            constructor(zt) {
              super(pt, "subjectDNs", !0), this.id = zt.id || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.subjectDN = new it.XFAObjectArray();
            }
          }
          class so extends it.XFAObject {
            constructor(zt) {
              super(pt, "submit", !0), this.embedPDF = (0, ut.getInteger)({
                data: zt.embedPDF,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.format = (0, ut.getStringOption)(zt.format, ["xdp", "formdata", "pdf", "urlencoded", "xfd", "xml"]), this.id = zt.id || "", this.target = zt.target || "", this.textEncoding = (0, ut.getKeyword)({
                data: zt.textEncoding ? zt.textEncoding.toLowerCase() : "",
                defaultValue: "",
                validate: (dr) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(dr) || dr.match(/iso-8859-\d{2}/)
              }), this.use = zt.use || "", this.usehref = zt.usehref || "", this.xdpContent = zt.xdpContent || "", this.encrypt = null, this.encryptData = new it.XFAObjectArray(), this.signData = new it.XFAObjectArray();
            }
          }
          class lo extends it.XFAObject {
            constructor(zt) {
              super(pt, "template", !0), this.baseProfile = (0, ut.getStringOption)(zt.baseProfile, ["full", "interactiveForms"]), this.extras = null, this.subform = new it.XFAObjectArray();
            }
            [rt.$finalize]() {
              this.subform.children.length === 0 && (0, ft.warn)("XFA - No subforms in template node."), this.subform.children.length >= 2 && (0, ft.warn)("XFA - Several subforms in template node: please file a bug."), this[rt.$tabIndex] = At;
            }
            [rt.$isSplittable]() {
              return !0;
            }
            [rt.$searchNode](zt, dr) {
              return zt.startsWith("#") ? [this[rt.$ids].get(zt.slice(1))] : (0, gt.searchNode)(this, dr, zt, !0, !0);
            }
            *[rt.$toPages]() {
              var _i, Dn, oo;
              if (!this.subform.children.length)
                return ut.HTMLResult.success({
                  name: "div",
                  children: []
                });
              this[rt.$extra] = {
                overflowNode: null,
                firstUnsplittable: null,
                currentContentArea: null,
                currentPageArea: null,
                noLayoutFailure: !1,
                pageNumber: 1,
                pagePosition: "first",
                oddOrEven: "odd",
                blankOrNotBlank: "nonBlank",
                paraStack: []
              };
              const zt = this.subform.children[0];
              zt.pageSet[rt.$cleanPage]();
              const dr = zt.pageSet.pageArea.children, qr = {
                name: "div",
                children: []
              };
              let ln = null, cn = null, xn = null;
              if (zt.breakBefore.children.length >= 1 ? (cn = zt.breakBefore.children[0], xn = cn.target) : zt.subform.children.length >= 1 && zt.subform.children[0].breakBefore.children.length >= 1 ? (cn = zt.subform.children[0].breakBefore.children[0], xn = cn.target) : (_i = zt.break) != null && _i.beforeTarget ? (cn = zt.break, xn = cn.beforeTarget) : zt.subform.children.length >= 1 && ((Dn = zt.subform.children[0].break) != null && Dn.beforeTarget) && (cn = zt.subform.children[0].break, xn = cn.beforeTarget), cn) {
                const Jn = this[rt.$searchNode](xn, cn[rt.$getParent]());
                Jn instanceof bn && (ln = Jn, cn[rt.$extra] = {});
              }
              ln || (ln = dr[0]), ln[rt.$extra] = {
                numberOfUse: 1
              };
              const Sn = ln[rt.$getParent]();
              Sn[rt.$extra] = {
                numberOfUse: 1,
                pageIndex: Sn.pageArea.children.indexOf(ln),
                pageSetIndex: 0
              };
              let $n, On = null, _n = null, Kn = !0, Vn = 0, Xn = 0;
              for (; ; ) {
                if (Kn)
                  Vn = 0;
                else if (qr.children.pop(), ++Vn === vt)
                  return (0, ft.warn)("XFA - Something goes wrong: please file a bug."), qr;
                $n = null, this[rt.$extra].currentPageArea = ln;
                const Jn = ln[rt.$toHTML]().html;
                qr.children.push(Jn), On && (this[rt.$extra].noLayoutFailure = !0, Jn.children.push(On[rt.$toHTML](ln[rt.$extra].space).html), On = null), _n && (this[rt.$extra].noLayoutFailure = !0, Jn.children.push(_n[rt.$toHTML](ln[rt.$extra].space).html), _n = null);
                const fo = ln.contentArea.children, io = Jn.children.filter((In) => In.attributes.class.includes("xfaContentarea"));
                Kn = !1, this[rt.$extra].firstUnsplittable = null, this[rt.$extra].noLayoutFailure = !1;
                const jn = (In) => {
                  var ho;
                  const po = zt[rt.$flushHTML]();
                  po && (Kn || (Kn = ((ho = po.children) == null ? void 0 : ho.length) > 0), io[In].children.push(po));
                };
                for (let In = Xn, po = fo.length; In < po; In++) {
                  const ho = this[rt.$extra].currentContentArea = fo[In], So = {
                    width: ho.w,
                    height: ho.h
                  };
                  Xn = 0, On && (io[In].children.push(On[rt.$toHTML](So).html), On = null), _n && (io[In].children.push(_n[rt.$toHTML](So).html), _n = null);
                  const bo = zt[rt.$toHTML](So);
                  if (bo.success)
                    return bo.html ? (Kn || (Kn = ((oo = bo.html.children) == null ? void 0 : oo.length) > 0), io[In].children.push(bo.html)) : !Kn && qr.children.length > 1 && qr.children.pop(), qr;
                  if (bo.isBreak()) {
                    const no = bo.breakNode;
                    if (jn(In), no.targetType === "auto")
                      continue;
                    no.leader && (On = this[rt.$searchNode](no.leader, no[rt.$getParent]()), On = On ? On[0] : null), no.trailer && (_n = this[rt.$searchNode](no.trailer, no[rt.$getParent]()), _n = _n ? _n[0] : null), no.targetType === "pageArea" ? ($n = no[rt.$extra].target, In = 1 / 0) : no[rt.$extra].target ? ($n = no[rt.$extra].target, Xn = no[rt.$extra].index + 1, In = 1 / 0) : In = no[rt.$extra].index;
                    continue;
                  }
                  if (this[rt.$extra].overflowNode) {
                    const no = this[rt.$extra].overflowNode;
                    this[rt.$extra].overflowNode = null;
                    const Oo = no[rt.$getExtra](), Po = Oo.target;
                    Oo.addLeader = Oo.leader !== null, Oo.addTrailer = Oo.trailer !== null, jn(In);
                    const Ho = In;
                    if (In = 1 / 0, Po instanceof bn)
                      $n = Po;
                    else if (Po instanceof Xt) {
                      const go = fo.indexOf(Po);
                      go !== -1 ? go > Ho ? In = go - 1 : Xn = go : ($n = Po[rt.$getParent](), Xn = $n.contentArea.children.indexOf(Po));
                    }
                    continue;
                  }
                  jn(In);
                }
                this[rt.$extra].pageNumber += 1, $n && ($n[rt.$isUsable]() ? $n[rt.$extra].numberOfUse += 1 : $n = null), ln = $n || ln[rt.$getNextPage](), yield null;
              }
            }
          }
          at.Template = lo;
          class Ao extends it.ContentObject {
            constructor(zt) {
              super(pt, "text"), this.id = zt.id || "", this.maxChars = (0, ut.getInteger)({
                data: zt.maxChars,
                defaultValue: 0,
                validate: (dr) => dr >= 0
              }), this.name = zt.name || "", this.rid = zt.rid || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$acceptWhitespace]() {
              return !0;
            }
            [rt.$onChild](zt) {
              return zt[rt.$namespaceId] === st.NamespaceIds.xhtml.id ? (this[rt.$content] = zt, !0) : ((0, ft.warn)(`XFA - Invalid content in Text: ${zt[rt.$nodeName]}.`), !1);
            }
            [rt.$onText](zt) {
              this[rt.$content] instanceof it.XFAObject || super[rt.$onText](zt);
            }
            [rt.$finalize]() {
              typeof this[rt.$content] == "string" && (this[rt.$content] = this[rt.$content].replaceAll(`\r
`, `
`));
            }
            [rt.$getExtra]() {
              return typeof this[rt.$content] == "string" ? this[rt.$content].split(/[\u2029\u2028\n]/).reduce((zt, dr) => (dr && zt.push(dr), zt), []).join(`
`) : this[rt.$content][rt.$text]();
            }
            [rt.$toHTML](zt) {
              if (typeof this[rt.$content] == "string") {
                const dr = Rt(this[rt.$content]).html;
                return this[rt.$content].includes("\u2029") ? (dr.name = "div", dr.children = [], this[rt.$content].split("\u2029").map((qr) => qr.split(/[\u2028\n]/).reduce((ln, cn) => (ln.push({
                  name: "span",
                  value: cn
                }, {
                  name: "br"
                }), ln), [])).forEach((qr) => {
                  dr.children.push({
                    name: "p",
                    children: qr
                  });
                })) : /[\u2028\n]/.test(this[rt.$content]) && (dr.name = "div", dr.children = [], this[rt.$content].split(/[\u2028\n]/).forEach((qr) => {
                  dr.children.push({
                    name: "span",
                    value: qr
                  }, {
                    name: "br"
                  });
                })), ut.HTMLResult.success(dr);
              }
              return this[rt.$content][rt.$toHTML](zt);
            }
          }
          at.Text = Ao;
          class uo extends it.XFAObject {
            constructor(zt) {
              super(pt, "textEdit", !0), this.allowRichText = (0, ut.getInteger)({
                data: zt.allowRichText,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.hScrollPolicy = (0, ut.getStringOption)(zt.hScrollPolicy, ["auto", "off", "on"]), this.id = zt.id || "", this.multiLine = (0, ut.getInteger)({
                data: zt.multiLine,
                defaultValue: "",
                validate: (dr) => dr === 0 || dr === 1
              }), this.use = zt.use || "", this.usehref = zt.usehref || "", this.vScrollPolicy = (0, ut.getStringOption)(zt.vScrollPolicy, ["auto", "off", "on"]), this.border = null, this.comb = null, this.extras = null, this.margin = null;
            }
            [rt.$toHTML](zt) {
              var cn, xn;
              const dr = (0, et.toStyle)(this, "border", "font", "margin");
              let qr;
              const ln = this[rt.$getParent]()[rt.$getParent]();
              return this.multiLine === "" && (this.multiLine = ln instanceof gr ? 1 : 0), this.multiLine === 1 ? qr = {
                name: "textarea",
                attributes: {
                  dataId: ((cn = ln[rt.$data]) == null ? void 0 : cn[rt.$uid]) || ln[rt.$uid],
                  fieldId: ln[rt.$uid],
                  class: ["xfaTextfield"],
                  style: dr,
                  "aria-label": yt(ln),
                  "aria-required": !1
                }
              } : qr = {
                name: "input",
                attributes: {
                  type: "text",
                  dataId: ((xn = ln[rt.$data]) == null ? void 0 : xn[rt.$uid]) || ln[rt.$uid],
                  fieldId: ln[rt.$uid],
                  class: ["xfaTextfield"],
                  style: dr,
                  "aria-label": yt(ln),
                  "aria-required": !1
                }
              }, wt(ln) && (qr.attributes["aria-required"] = !0, qr.attributes.required = !0), ut.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [qr]
              });
            }
          }
          class wo extends it.StringObject {
            constructor(zt) {
              super(pt, "time"), this.id = zt.id || "", this.name = zt.name || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
            [rt.$finalize]() {
              const zt = this[rt.$content].trim();
              this[rt.$content] = zt ? new Date(zt) : null;
            }
            [rt.$toHTML](zt) {
              return Rt(this[rt.$content] ? this[rt.$content].toString() : "");
            }
          }
          class $o extends it.XFAObject {
            constructor(zt) {
              super(pt, "timeStamp"), this.id = zt.id || "", this.server = zt.server || "", this.type = (0, ut.getStringOption)(zt.type, ["optional", "required"]), this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class yo extends it.StringObject {
            constructor(zt) {
              super(pt, "toolTip"), this.id = zt.id || "", this.rid = zt.rid || "", this.use = zt.use || "", this.usehref = zt.usehref || "";
            }
          }
          class Rn extends it.XFAObject {
            constructor(zt) {
              super(pt, "traversal", !0), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.traverse = new it.XFAObjectArray();
            }
          }
          class kn extends it.XFAObject {
            constructor(zt) {
              super(pt, "traverse", !0), this.id = zt.id || "", this.operation = (0, ut.getStringOption)(zt.operation, ["next", "back", "down", "first", "left", "right", "up"]), this.ref = zt.ref || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.script = null;
            }
            get name() {
              return this.operation;
            }
            [rt.$isTransparent]() {
              return !1;
            }
          }
          class Yn extends it.XFAObject {
            constructor(zt) {
              super(pt, "ui", !0), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.picture = null, this.barcode = null, this.button = null, this.checkButton = null, this.choiceList = null, this.dateTimeEdit = null, this.defaultUi = null, this.imageEdit = null, this.numericEdit = null, this.passwordEdit = null, this.signature = null, this.textEdit = null;
            }
            [rt.$getExtra]() {
              if (this[rt.$extra] === void 0) {
                for (const zt of Object.getOwnPropertyNames(this)) {
                  if (zt === "extras" || zt === "picture")
                    continue;
                  const dr = this[zt];
                  if (dr instanceof it.XFAObject)
                    return this[rt.$extra] = dr, dr;
                }
                this[rt.$extra] = null;
              }
              return this[rt.$extra];
            }
            [rt.$toHTML](zt) {
              const dr = this[rt.$getExtra]();
              return dr ? dr[rt.$toHTML](zt) : ut.HTMLResult.EMPTY;
            }
          }
          class _a extends it.XFAObject {
            constructor(zt) {
              super(pt, "validate", !0), this.formatTest = (0, ut.getStringOption)(zt.formatTest, ["warning", "disabled", "error"]), this.id = zt.id || "", this.nullTest = (0, ut.getStringOption)(zt.nullTest, ["disabled", "error", "warning"]), this.scriptTest = (0, ut.getStringOption)(zt.scriptTest, ["error", "disabled", "warning"]), this.use = zt.use || "", this.usehref = zt.usehref || "", this.extras = null, this.message = null, this.picture = null, this.script = null;
            }
          }
          class Qn extends it.XFAObject {
            constructor(zt) {
              super(pt, "value", !0), this.id = zt.id || "", this.override = (0, ut.getInteger)({
                data: zt.override,
                defaultValue: 0,
                validate: (dr) => dr === 1
              }), this.relevant = (0, ut.getRelevant)(zt.relevant), this.use = zt.use || "", this.usehref = zt.usehref || "", this.arc = null, this.boolean = null, this.date = null, this.dateTime = null, this.decimal = null, this.exData = null, this.float = null, this.image = null, this.integer = null, this.line = null, this.rectangle = null, this.text = null, this.time = null;
            }
            [rt.$setValue](zt) {
              var ln;
              const dr = this[rt.$getParent]();
              if (dr instanceof Tr && (ln = dr.ui) != null && ln.imageEdit) {
                this.image || (this.image = new Yr({}), this[rt.$appendChild](this.image)), this.image[rt.$content] = zt[rt.$content];
                return;
              }
              const qr = zt[rt.$nodeName];
              if (this[qr] !== null) {
                this[qr][rt.$content] = zt[rt.$content];
                return;
              }
              for (const cn of Object.getOwnPropertyNames(this)) {
                const xn = this[cn];
                xn instanceof it.XFAObject && (this[cn] = null, this[rt.$removeChild](xn));
              }
              this[zt[rt.$nodeName]] = zt, this[rt.$appendChild](zt);
            }
            [rt.$text]() {
              if (this.exData)
                return typeof this.exData[rt.$content] == "string" ? this.exData[rt.$content].trim() : this.exData[rt.$content][rt.$text]().trim();
              for (const zt of Object.getOwnPropertyNames(this)) {
                if (zt === "image")
                  continue;
                const dr = this[zt];
                if (dr instanceof it.XFAObject)
                  return (dr[rt.$content] || "").toString().trim();
              }
              return null;
            }
            [rt.$toHTML](zt) {
              for (const dr of Object.getOwnPropertyNames(this)) {
                const qr = this[dr];
                if (qr instanceof it.XFAObject)
                  return qr[rt.$toHTML](zt);
              }
              return ut.HTMLResult.EMPTY;
            }
          }
          at.Value = Qn;
          class Eo extends it.XFAObject {
            constructor(zt) {
              super(pt, "variables", !0), this.id = zt.id || "", this.use = zt.use || "", this.usehref = zt.usehref || "", this.boolean = new it.XFAObjectArray(), this.date = new it.XFAObjectArray(), this.dateTime = new it.XFAObjectArray(), this.decimal = new it.XFAObjectArray(), this.exData = new it.XFAObjectArray(), this.float = new it.XFAObjectArray(), this.image = new it.XFAObjectArray(), this.integer = new it.XFAObjectArray(), this.manifest = new it.XFAObjectArray(), this.script = new it.XFAObjectArray(), this.text = new it.XFAObjectArray(), this.time = new it.XFAObjectArray();
            }
            [rt.$isTransparent]() {
              return !0;
            }
          }
          class vo {
            static [st.$buildXFAObject](zt, dr) {
              if (vo.hasOwnProperty(zt)) {
                const qr = vo[zt](dr);
                return qr[rt.$setSetAttributes](dr), qr;
              }
            }
            static appearanceFilter(zt) {
              return new _t(zt);
            }
            static arc(zt) {
              return new Nt(zt);
            }
            static area(zt) {
              return new Mt(zt);
            }
            static assist(zt) {
              return new Lt(zt);
            }
            static barcode(zt) {
              return new $t(zt);
            }
            static bind(zt) {
              return new Tt(zt);
            }
            static bindItems(zt) {
              return new Dt(zt);
            }
            static bookend(zt) {
              return new Ut(zt);
            }
            static boolean(zt) {
              return new Vt(zt);
            }
            static border(zt) {
              return new Qt(zt);
            }
            static break(zt) {
              return new qt(zt);
            }
            static breakAfter(zt) {
              return new Zt(zt);
            }
            static breakBefore(zt) {
              return new ar(zt);
            }
            static button(zt) {
              return new Jt(zt);
            }
            static calculate(zt) {
              return new rr(zt);
            }
            static caption(zt) {
              return new Yt(zt);
            }
            static certificate(zt) {
              return new Kt(zt);
            }
            static certificates(zt) {
              return new nr(zt);
            }
            static checkButton(zt) {
              return new tr(zt);
            }
            static choiceList(zt) {
              return new ir(zt);
            }
            static color(zt) {
              return new sr(zt);
            }
            static comb(zt) {
              return new cr(zt);
            }
            static connect(zt) {
              return new or(zt);
            }
            static contentArea(zt) {
              return new Xt(zt);
            }
            static corner(zt) {
              return new Gt(zt);
            }
            static date(zt) {
              return new Wt(zt);
            }
            static dateTime(zt) {
              return new er(zt);
            }
            static dateTimeEdit(zt) {
              return new lr(zt);
            }
            static decimal(zt) {
              return new ur(zt);
            }
            static defaultUi(zt) {
              return new pr(zt);
            }
            static desc(zt) {
              return new yr(zt);
            }
            static digestMethod(zt) {
              return new Er(zt);
            }
            static digestMethods(zt) {
              return new br(zt);
            }
            static draw(zt) {
              return new gr(zt);
            }
            static edge(zt) {
              return new Ar(zt);
            }
            static encoding(zt) {
              return new Sr(zt);
            }
            static encodings(zt) {
              return new Br(zt);
            }
            static encrypt(zt) {
              return new Ir(zt);
            }
            static encryptData(zt) {
              return new hr(zt);
            }
            static encryption(zt) {
              return new vr(zt);
            }
            static encryptionMethod(zt) {
              return new xr(zt);
            }
            static encryptionMethods(zt) {
              return new Pr(zt);
            }
            static event(zt) {
              return new Rr(zt);
            }
            static exData(zt) {
              return new Dr(zt);
            }
            static exObject(zt) {
              return new Gr(zt);
            }
            static exclGroup(zt) {
              return new Or(zt);
            }
            static execute(zt) {
              return new Hr(zt);
            }
            static extras(zt) {
              return new jr(zt);
            }
            static field(zt) {
              return new Tr(zt);
            }
            static fill(zt) {
              return new fr(zt);
            }
            static filter(zt) {
              return new Cr(zt);
            }
            static float(zt) {
              return new $r(zt);
            }
            static font(zt) {
              return new wr(zt);
            }
            static format(zt) {
              return new Mr(zt);
            }
            static handler(zt) {
              return new Fr(zt);
            }
            static hyphenation(zt) {
              return new Qr(zt);
            }
            static image(zt) {
              return new Yr(zt);
            }
            static imageEdit(zt) {
              return new kr(zt);
            }
            static integer(zt) {
              return new Nr(zt);
            }
            static issuers(zt) {
              return new Lr(zt);
            }
            static items(zt) {
              return new zr(zt);
            }
            static keep(zt) {
              return new Vr(zt);
            }
            static keyUsage(zt) {
              return new an(zt);
            }
            static line(zt) {
              return new Zr(zt);
            }
            static linear(zt) {
              return new un(zt);
            }
            static lockDocument(zt) {
              return new Xr(zt);
            }
            static manifest(zt) {
              return new Kr(zt);
            }
            static margin(zt) {
              return new rn(zt);
            }
            static mdp(zt) {
              return new nn(zt);
            }
            static medium(zt) {
              return new sn(zt);
            }
            static message(zt) {
              return new gn(zt);
            }
            static numericEdit(zt) {
              return new en(zt);
            }
            static occur(zt) {
              return new Wr(zt);
            }
            static oid(zt) {
              return new dn(zt);
            }
            static oids(zt) {
              return new hn(zt);
            }
            static overflow(zt) {
              return new En(zt);
            }
            static pageArea(zt) {
              return new bn(zt);
            }
            static pageSet(zt) {
              return new Cn(zt);
            }
            static para(zt) {
              return new wn(zt);
            }
            static passwordEdit(zt) {
              return new vn(zt);
            }
            static pattern(zt) {
              return new fn(zt);
            }
            static picture(zt) {
              return new on(zt);
            }
            static proto(zt) {
              return new pn(zt);
            }
            static radial(zt) {
              return new mn(zt);
            }
            static reason(zt) {
              return new Pn(zt);
            }
            static reasons(zt) {
              return new An(zt);
            }
            static rectangle(zt) {
              return new yn(zt);
            }
            static ref(zt) {
              return new Bn(zt);
            }
            static script(zt) {
              return new Fn(zt);
            }
            static setProperty(zt) {
              return new zn(zt);
            }
            static signData(zt) {
              return new Zn(zt);
            }
            static signature(zt) {
              return new to(zt);
            }
            static signing(zt) {
              return new Mn(zt);
            }
            static solid(zt) {
              return new Nn(zt);
            }
            static speak(zt) {
              return new Wn(zt);
            }
            static stipple(zt) {
              return new ca(zt);
            }
            static subform(zt) {
              return new qn(zt);
            }
            static subformSet(zt) {
              return new eo(zt);
            }
            static subjectDN(zt) {
              return new ro(zt);
            }
            static subjectDNs(zt) {
              return new ao(zt);
            }
            static submit(zt) {
              return new so(zt);
            }
            static template(zt) {
              return new lo(zt);
            }
            static text(zt) {
              return new Ao(zt);
            }
            static textEdit(zt) {
              return new uo(zt);
            }
            static time(zt) {
              return new wo(zt);
            }
            static timeStamp(zt) {
              return new $o(zt);
            }
            static toolTip(zt) {
              return new yo(zt);
            }
            static traversal(zt) {
              return new Rn(zt);
            }
            static traverse(zt) {
              return new kn(zt);
            }
            static ui(zt) {
              return new Yn(zt);
            }
            static validate(zt) {
              return new _a(zt);
            }
            static value(zt) {
              return new Qn(zt);
            }
            static variables(zt) {
              return new Eo(zt);
            }
          }
          at.TemplateNamespace = vo;
        },
        /* 232 */
        /***/
        (nt, at, ot) => {
          var rt = ot(3), st = ot(4), lt = ot(24), et = ot(11), it = ot(45).f, ut = ot(39), ft = ot(233), ht = ot(75), dt = ot(76), gt = ot(234), pt = ot(82), mt = ot(6), ct = ot(36), vt = "DOMException", At = lt("Error"), xt = lt(vt), bt = function() {
            ft(this, Et);
            var Ht = arguments.length, Ft = dt(Ht < 1 ? void 0 : arguments[0]), _t = dt(Ht < 2 ? void 0 : arguments[1], "Error"), Nt = new xt(Ft, _t), Mt = At(Ft);
            return Mt.name = vt, it(Nt, "stack", et(1, pt(Mt.stack, 1))), ht(Nt, this, bt), Nt;
          }, Et = bt.prototype = xt.prototype, St = "stack" in At(vt), Bt = "stack" in new xt(1, 2), Ot = xt && mt && Object.getOwnPropertyDescriptor(st, vt), Pt = !!Ot && !(Ot.writable && Ot.configurable), wt = St && !Pt && !Bt;
          rt({
            global: !0,
            constructor: !0,
            forced: ct || wt
          }, { DOMException: wt ? bt : xt });
          var Ct = lt(vt), It = Ct.prototype;
          if (It.constructor !== Ct) {
            ct || it(It, "constructor", et(1, Ct));
            for (var yt in gt)
              if (ut(gt, yt)) {
                var Rt = gt[yt], kt = Rt.s;
                ut(Ct, kt) || it(Ct, kt, et(6, Rt.c));
              }
          }
        },
        /* 233 */
        /***/
        (nt, at, ot) => {
          var rt = ot(25), st = TypeError;
          nt.exports = function(lt, et) {
            if (rt(et, lt))
              return lt;
            throw st("Incorrect invocation");
          };
        },
        /* 234 */
        /***/
        (nt) => {
          nt.exports = {
            IndexSizeError: {
              s: "INDEX_SIZE_ERR",
              c: 1,
              m: 1
            },
            DOMStringSizeError: {
              s: "DOMSTRING_SIZE_ERR",
              c: 2,
              m: 0
            },
            HierarchyRequestError: {
              s: "HIERARCHY_REQUEST_ERR",
              c: 3,
              m: 1
            },
            WrongDocumentError: {
              s: "WRONG_DOCUMENT_ERR",
              c: 4,
              m: 1
            },
            InvalidCharacterError: {
              s: "INVALID_CHARACTER_ERR",
              c: 5,
              m: 1
            },
            NoDataAllowedError: {
              s: "NO_DATA_ALLOWED_ERR",
              c: 6,
              m: 0
            },
            NoModificationAllowedError: {
              s: "NO_MODIFICATION_ALLOWED_ERR",
              c: 7,
              m: 1
            },
            NotFoundError: {
              s: "NOT_FOUND_ERR",
              c: 8,
              m: 1
            },
            NotSupportedError: {
              s: "NOT_SUPPORTED_ERR",
              c: 9,
              m: 1
            },
            InUseAttributeError: {
              s: "INUSE_ATTRIBUTE_ERR",
              c: 10,
              m: 1
            },
            InvalidStateError: {
              s: "INVALID_STATE_ERR",
              c: 11,
              m: 1
            },
            SyntaxError: {
              s: "SYNTAX_ERR",
              c: 12,
              m: 1
            },
            InvalidModificationError: {
              s: "INVALID_MODIFICATION_ERR",
              c: 13,
              m: 1
            },
            NamespaceError: {
              s: "NAMESPACE_ERR",
              c: 14,
              m: 1
            },
            InvalidAccessError: {
              s: "INVALID_ACCESS_ERR",
              c: 15,
              m: 1
            },
            ValidationError: {
              s: "VALIDATION_ERR",
              c: 16,
              m: 0
            },
            TypeMismatchError: {
              s: "TYPE_MISMATCH_ERR",
              c: 17,
              m: 1
            },
            SecurityError: {
              s: "SECURITY_ERR",
              c: 18,
              m: 1
            },
            NetworkError: {
              s: "NETWORK_ERR",
              c: 19,
              m: 1
            },
            AbortError: {
              s: "ABORT_ERR",
              c: 20,
              m: 1
            },
            URLMismatchError: {
              s: "URL_MISMATCH_ERR",
              c: 21,
              m: 1
            },
            QuotaExceededError: {
              s: "QUOTA_EXCEEDED_ERR",
              c: 22,
              m: 1
            },
            TimeoutError: {
              s: "TIMEOUT_ERR",
              c: 23,
              m: 1
            },
            InvalidNodeTypeError: {
              s: "INVALID_NODE_TYPE_ERR",
              c: 24,
              m: 1
            },
            DataCloneError: {
              s: "DATA_CLONE_ERR",
              c: 25,
              m: 1
            }
          };
        },
        /* 235 */
        /***/
        (nt, at) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.NamespaceIds = at.$buildXFAObject = void 0;
          const ot = Symbol();
          at.$buildXFAObject = ot;
          const rt = {
            config: {
              id: 0,
              check: (st) => st.startsWith("http://www.xfa.org/schema/xci/")
            },
            connectionSet: {
              id: 1,
              check: (st) => st.startsWith("http://www.xfa.org/schema/xfa-connection-set/")
            },
            datasets: {
              id: 2,
              check: (st) => st.startsWith("http://www.xfa.org/schema/xfa-data/")
            },
            form: {
              id: 3,
              check: (st) => st.startsWith("http://www.xfa.org/schema/xfa-form/")
            },
            localeSet: {
              id: 4,
              check: (st) => st.startsWith("http://www.xfa.org/schema/xfa-locale-set/")
            },
            pdf: {
              id: 5,
              check: (st) => st === "http://ns.adobe.com/xdp/pdf/"
            },
            signature: {
              id: 6,
              check: (st) => st === "http://www.w3.org/2000/09/xmldsig#"
            },
            sourceSet: {
              id: 7,
              check: (st) => st.startsWith("http://www.xfa.org/schema/xfa-source-set/")
            },
            stylesheet: {
              id: 8,
              check: (st) => st === "http://www.w3.org/1999/XSL/Transform"
            },
            template: {
              id: 9,
              check: (st) => st.startsWith("http://www.xfa.org/schema/xfa-template/")
            },
            xdc: {
              id: 10,
              check: (st) => st.startsWith("http://www.xfa.org/schema/xdc/")
            },
            xdp: {
              id: 11,
              check: (st) => st === "http://ns.adobe.com/xdp/"
            },
            xfdf: {
              id: 12,
              check: (st) => st === "http://ns.adobe.com/xfdf/"
            },
            xhtml: {
              id: 13,
              check: (st) => st === "http://www.w3.org/1999/xhtml"
            },
            xmpmeta: {
              id: 14,
              check: (st) => st === "http://ns.adobe.com/xmpmeta/"
            }
          };
          at.NamespaceIds = rt;
        },
        /* 236 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.addHTML = it, at.checkDimensions = ht, at.flushHTML = et, at.getAvailableSpace = ut, ot(140);
          var rt = ot(229), st = ot(237);
          function lt(dt, gt) {
            return {
              name: "div",
              attributes: {
                class: [dt.layout === "lr-tb" ? "xfaLr" : "xfaRl"]
              },
              children: gt
            };
          }
          function et(dt) {
            if (!dt[rt.$extra])
              return null;
            const pt = {
              name: "div",
              attributes: dt[rt.$extra].attributes,
              children: dt[rt.$extra].children
            };
            if (dt[rt.$extra].failingNode) {
              const mt = dt[rt.$extra].failingNode[rt.$flushHTML]();
              mt && (dt.layout.endsWith("-tb") ? pt.children.push(lt(dt, [mt])) : pt.children.push(mt));
            }
            return pt.children.length === 0 ? null : pt;
          }
          function it(dt, gt, pt) {
            const mt = dt[rt.$extra], ct = mt.availableSpace, [vt, At, xt, bt] = pt;
            switch (dt.layout) {
              case "position": {
                mt.width = Math.max(mt.width, vt + xt), mt.height = Math.max(mt.height, At + bt), mt.children.push(gt);
                break;
              }
              case "lr-tb":
              case "rl-tb":
                (!mt.line || mt.attempt === 1) && (mt.line = lt(dt, []), mt.children.push(mt.line), mt.numberInLine = 0), mt.numberInLine += 1, mt.line.children.push(gt), mt.attempt === 0 ? (mt.currentWidth += xt, mt.height = Math.max(mt.height, mt.prevHeight + bt)) : (mt.currentWidth = xt, mt.prevHeight = mt.height, mt.height += bt, mt.attempt = 0), mt.width = Math.max(mt.width, mt.currentWidth);
                break;
              case "rl-row":
              case "row": {
                mt.children.push(gt), mt.width += xt, mt.height = Math.max(mt.height, bt);
                const Et = (0, st.measureToString)(mt.height);
                for (const St of mt.children)
                  St.attributes.style.height = Et;
                break;
              }
              case "table": {
                mt.width = Math.min(ct.width, Math.max(mt.width, xt)), mt.height += bt, mt.children.push(gt);
                break;
              }
              case "tb": {
                mt.width = Math.min(ct.width, Math.max(mt.width, xt)), mt.height += bt, mt.children.push(gt);
                break;
              }
            }
          }
          function ut(dt) {
            const gt = dt[rt.$extra].availableSpace, pt = dt.margin ? dt.margin.topInset + dt.margin.bottomInset : 0, mt = dt.margin ? dt.margin.leftInset + dt.margin.rightInset : 0;
            switch (dt.layout) {
              case "lr-tb":
              case "rl-tb":
                return dt[rt.$extra].attempt === 0 ? {
                  width: gt.width - mt - dt[rt.$extra].currentWidth,
                  height: gt.height - pt - dt[rt.$extra].prevHeight
                } : {
                  width: gt.width - mt,
                  height: gt.height - pt - dt[rt.$extra].height
                };
              case "rl-row":
              case "row":
                return {
                  width: dt[rt.$extra].columnWidths.slice(dt[rt.$extra].currentColumn).reduce((vt, At) => vt + At),
                  height: gt.height - mt
                };
              case "table":
              case "tb":
                return {
                  width: gt.width - mt,
                  height: gt.height - pt - dt[rt.$extra].height
                };
              case "position":
              default:
                return gt;
            }
          }
          function ft(dt) {
            let gt = dt.w === "" ? NaN : dt.w, pt = dt.h === "" ? NaN : dt.h, [mt, ct] = [0, 0];
            switch (dt.anchorType || "") {
              case "bottomCenter":
                [mt, ct] = [gt / 2, pt];
                break;
              case "bottomLeft":
                [mt, ct] = [0, pt];
                break;
              case "bottomRight":
                [mt, ct] = [gt, pt];
                break;
              case "middleCenter":
                [mt, ct] = [gt / 2, pt / 2];
                break;
              case "middleLeft":
                [mt, ct] = [0, pt / 2];
                break;
              case "middleRight":
                [mt, ct] = [gt, pt / 2];
                break;
              case "topCenter":
                [mt, ct] = [gt / 2, 0];
                break;
              case "topRight":
                [mt, ct] = [gt, 0];
                break;
            }
            let vt, At;
            switch (dt.rotate || 0) {
              case 0:
                [vt, At] = [-mt, -ct];
                break;
              case 90:
                [vt, At] = [-ct, mt], [gt, pt] = [pt, -gt];
                break;
              case 180:
                [vt, At] = [mt, ct], [gt, pt] = [-gt, -pt];
                break;
              case 270:
                [vt, At] = [ct, -mt], [gt, pt] = [-pt, gt];
                break;
            }
            return [dt.x + vt + Math.min(0, gt), dt.y + At + Math.min(0, pt), Math.abs(gt), Math.abs(pt)];
          }
          function ht(dt, gt) {
            var bt;
            if (dt[rt.$getTemplateRoot]()[rt.$extra].firstUnsplittable === null || dt.w === 0 || dt.h === 0)
              return !0;
            const pt = 2, mt = dt[rt.$getSubformParent](), ct = ((bt = mt[rt.$extra]) == null ? void 0 : bt.attempt) || 0, [, vt, At, xt] = ft(dt);
            switch (mt.layout) {
              case "lr-tb":
              case "rl-tb":
                return ct === 0 ? dt[rt.$getTemplateRoot]()[rt.$extra].noLayoutFailure ? dt.w !== "" ? Math.round(At - gt.width) <= pt : gt.width > pt : dt.h !== "" && Math.round(xt - gt.height) > pt ? !1 : dt.w !== "" ? Math.round(At - gt.width) <= pt ? !0 : mt[rt.$extra].numberInLine === 0 ? gt.height > pt : !1 : gt.width > pt : dt[rt.$getTemplateRoot]()[rt.$extra].noLayoutFailure ? !0 : dt.h !== "" && Math.round(xt - gt.height) > pt ? !1 : dt.w === "" || Math.round(At - gt.width) <= pt ? gt.height > pt : mt[rt.$isThereMoreWidth]() ? !1 : gt.height > pt;
              case "table":
              case "tb":
                return dt[rt.$getTemplateRoot]()[rt.$extra].noLayoutFailure ? !0 : dt.h !== "" && !dt[rt.$isSplittable]() ? Math.round(xt - gt.height) <= pt : dt.w === "" || Math.round(At - gt.width) <= pt ? gt.height > pt : mt[rt.$isThereMoreWidth]() ? !1 : gt.height > pt;
              case "position":
                if (dt[rt.$getTemplateRoot]()[rt.$extra].noLayoutFailure || dt.h === "" || Math.round(xt + vt - gt.height) <= pt)
                  return !0;
                const Et = dt[rt.$getTemplateRoot]()[rt.$extra].currentContentArea;
                return xt + vt > Et.h;
              case "rl-row":
              case "row":
                return dt[rt.$getTemplateRoot]()[rt.$extra].noLayoutFailure ? !0 : dt.h !== "" ? Math.round(xt - gt.height) <= pt : !0;
              default:
                return !0;
            }
          }
        },
        /* 237 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.computeBbox = mt, at.createWrapper = xt, at.fixDimensions = ct, at.fixTextIndent = bt, at.fixURL = wt, at.isPrintOnly = St, at.layoutClass = vt, at.layoutNode = pt, at.measureToString = ft, at.setAccess = Et, at.setFontFamily = Pt, at.setMinMaxDimensions = dt, at.setPara = Ot, at.toStyle = At, ot(140);
          var rt = ot(229), st = ot(145), lt = ot(238), et = ot(239), it = ot(240), ut = ot(241);
          function ft(Ct) {
            return typeof Ct == "string" ? "0px" : Number.isInteger(Ct) ? `${Ct}px` : `${Ct.toFixed(2)}px`;
          }
          const ht = {
            anchorType(Ct, It) {
              const yt = Ct[rt.$getSubformParent]();
              if (!(!yt || yt.layout && yt.layout !== "position"))
                switch ("transform" in It || (It.transform = ""), Ct.anchorType) {
                  case "bottomCenter":
                    It.transform += "translate(-50%, -100%)";
                    break;
                  case "bottomLeft":
                    It.transform += "translate(0,-100%)";
                    break;
                  case "bottomRight":
                    It.transform += "translate(-100%,-100%)";
                    break;
                  case "middleCenter":
                    It.transform += "translate(-50%,-50%)";
                    break;
                  case "middleLeft":
                    It.transform += "translate(0,-50%)";
                    break;
                  case "middleRight":
                    It.transform += "translate(-100%,-50%)";
                    break;
                  case "topCenter":
                    It.transform += "translate(-50%,0)";
                    break;
                  case "topRight":
                    It.transform += "translate(-100%,0)";
                    break;
                }
            },
            dimensions(Ct, It) {
              var jt;
              const yt = Ct[rt.$getSubformParent]();
              let Rt = Ct.w;
              const kt = Ct.h;
              if ((jt = yt.layout) != null && jt.includes("row")) {
                const Ht = yt[rt.$extra], Ft = Ct.colSpan;
                let _t;
                Ft === -1 ? (_t = Ht.columnWidths.slice(Ht.currentColumn).reduce((Nt, Mt) => Nt + Mt, 0), Ht.currentColumn = 0) : (_t = Ht.columnWidths.slice(Ht.currentColumn, Ht.currentColumn + Ft).reduce((Nt, Mt) => Nt + Mt, 0), Ht.currentColumn = (Ht.currentColumn + Ct.colSpan) % Ht.columnWidths.length), isNaN(_t) || (Rt = Ct.w = _t);
              }
              It.width = Rt !== "" ? ft(Rt) : "auto", It.height = kt !== "" ? ft(kt) : "auto";
            },
            position(Ct, It) {
              const yt = Ct[rt.$getSubformParent]();
              yt != null && yt.layout && yt.layout !== "position" || (It.position = "absolute", It.left = ft(Ct.x), It.top = ft(Ct.y));
            },
            rotate(Ct, It) {
              Ct.rotate && ("transform" in It || (It.transform = ""), It.transform += `rotate(-${Ct.rotate}deg)`, It.transformOrigin = "top left");
            },
            presence(Ct, It) {
              switch (Ct.presence) {
                case "invisible":
                  It.visibility = "hidden";
                  break;
                case "hidden":
                case "inactive":
                  It.display = "none";
                  break;
              }
            },
            hAlign(Ct, It) {
              if (Ct[rt.$nodeName] === "para")
                switch (Ct.hAlign) {
                  case "justifyAll":
                    It.textAlign = "justify-all";
                    break;
                  case "radix":
                    It.textAlign = "left";
                    break;
                  default:
                    It.textAlign = Ct.hAlign;
                }
              else
                switch (Ct.hAlign) {
                  case "left":
                    It.alignSelf = "start";
                    break;
                  case "center":
                    It.alignSelf = "center";
                    break;
                  case "right":
                    It.alignSelf = "end";
                    break;
                }
            },
            margin(Ct, It) {
              Ct.margin && (It.margin = Ct.margin[rt.$toStyle]().margin);
            }
          };
          function dt(Ct, It) {
            Ct[rt.$getSubformParent]().layout === "position" && (Ct.minW > 0 && (It.minWidth = ft(Ct.minW)), Ct.maxW > 0 && (It.maxWidth = ft(Ct.maxW)), Ct.minH > 0 && (It.minHeight = ft(Ct.minH)), Ct.maxH > 0 && (It.maxHeight = ft(Ct.maxH)));
          }
          function gt(Ct, It, yt, Rt, kt, jt) {
            const Ht = new it.TextMeasure(It, yt, Rt, kt);
            return typeof Ct == "string" ? Ht.addString(Ct) : Ct[rt.$pushGlyphs](Ht), Ht.compute(jt);
          }
          function pt(Ct, It) {
            let yt = null, Rt = null, kt = !1;
            if ((!Ct.w || !Ct.h) && Ct.value) {
              let jt = 0, Ht = 0;
              Ct.margin && (jt = Ct.margin.leftInset + Ct.margin.rightInset, Ht = Ct.margin.topInset + Ct.margin.bottomInset);
              let Ft = null, _t = null;
              Ct.para && (_t = /* @__PURE__ */ Object.create(null), Ft = Ct.para.lineHeight === "" ? null : Ct.para.lineHeight, _t.top = Ct.para.spaceAbove === "" ? 0 : Ct.para.spaceAbove, _t.bottom = Ct.para.spaceBelow === "" ? 0 : Ct.para.spaceBelow, _t.left = Ct.para.marginLeft === "" ? 0 : Ct.para.marginLeft, _t.right = Ct.para.marginRight === "" ? 0 : Ct.para.marginRight);
              let Nt = Ct.font;
              if (!Nt) {
                const $t = Ct[rt.$getTemplateRoot]();
                let Tt = Ct[rt.$getParent]();
                for (; Tt && Tt !== $t; ) {
                  if (Tt.font) {
                    Nt = Tt.font;
                    break;
                  }
                  Tt = Tt[rt.$getParent]();
                }
              }
              const Mt = (Ct.w || It.width) - jt, Lt = Ct[rt.$globalData].fontFinder;
              if (Ct.value.exData && Ct.value.exData[rt.$content] && Ct.value.exData.contentType === "text/html") {
                const $t = gt(Ct.value.exData[rt.$content], Nt, _t, Ft, Lt, Mt);
                Rt = $t.width, yt = $t.height, kt = $t.isBroken;
              } else {
                const $t = Ct.value[rt.$text]();
                if ($t) {
                  const Tt = gt($t, Nt, _t, Ft, Lt, Mt);
                  Rt = Tt.width, yt = Tt.height, kt = Tt.isBroken;
                }
              }
              Rt !== null && !Ct.w && (Rt += jt), yt !== null && !Ct.h && (yt += Ht);
            }
            return {
              w: Rt,
              h: yt,
              isBroken: kt
            };
          }
          function mt(Ct, It, yt) {
            let Rt;
            if (Ct.w !== "" && Ct.h !== "")
              Rt = [Ct.x, Ct.y, Ct.w, Ct.h];
            else {
              if (!yt)
                return null;
              let kt = Ct.w;
              if (kt === "") {
                if (Ct.maxW === 0) {
                  const Ht = Ct[rt.$getSubformParent]();
                  kt = Ht.layout === "position" && Ht.w !== "" ? 0 : Ct.minW;
                } else
                  kt = Math.min(Ct.maxW, yt.width);
                It.attributes.style.width = ft(kt);
              }
              let jt = Ct.h;
              if (jt === "") {
                if (Ct.maxH === 0) {
                  const Ht = Ct[rt.$getSubformParent]();
                  jt = Ht.layout === "position" && Ht.h !== "" ? 0 : Ct.minH;
                } else
                  jt = Math.min(Ct.maxH, yt.height);
                It.attributes.style.height = ft(jt);
              }
              Rt = [Ct.x, Ct.y, kt, jt];
            }
            return Rt;
          }
          function ct(Ct) {
            var yt;
            const It = Ct[rt.$getSubformParent]();
            if ((yt = It.layout) != null && yt.includes("row")) {
              const Rt = It[rt.$extra], kt = Ct.colSpan;
              let jt;
              kt === -1 ? jt = Rt.columnWidths.slice(Rt.currentColumn).reduce((Ht, Ft) => Ht + Ft, 0) : jt = Rt.columnWidths.slice(Rt.currentColumn, Rt.currentColumn + kt).reduce((Ht, Ft) => Ht + Ft, 0), isNaN(jt) || (Ct.w = jt);
            }
            It.layout && It.layout !== "position" && (Ct.x = Ct.y = 0), Ct.layout === "table" && Ct.w === "" && Array.isArray(Ct.columnWidths) && (Ct.w = Ct.columnWidths.reduce((Rt, kt) => Rt + kt, 0));
          }
          function vt(Ct) {
            switch (Ct.layout) {
              case "position":
                return "xfaPosition";
              case "lr-tb":
                return "xfaLrTb";
              case "rl-row":
                return "xfaRlRow";
              case "rl-tb":
                return "xfaRlTb";
              case "row":
                return "xfaRow";
              case "table":
                return "xfaTable";
              case "tb":
                return "xfaTb";
              default:
                return "xfaPosition";
            }
          }
          function At(Ct) {
            const It = /* @__PURE__ */ Object.create(null);
            for (var yt = arguments.length, Rt = new Array(yt > 1 ? yt - 1 : 0), kt = 1; kt < yt; kt++)
              Rt[kt - 1] = arguments[kt];
            for (const jt of Rt) {
              const Ht = Ct[jt];
              if (Ht !== null) {
                if (ht.hasOwnProperty(jt)) {
                  ht[jt](Ct, It);
                  continue;
                }
                if (Ht instanceof ut.XFAObject) {
                  const Ft = Ht[rt.$toStyle]();
                  Ft ? Object.assign(It, Ft) : (0, st.warn)(`(DEBUG) - XFA - style for ${jt} not implemented yet`);
                }
              }
            }
            return It;
          }
          function xt(Ct, It) {
            const {
              attributes: yt
            } = It, {
              style: Rt
            } = yt, kt = {
              name: "div",
              attributes: {
                class: ["xfaWrapper"],
                style: /* @__PURE__ */ Object.create(null)
              },
              children: []
            };
            if (yt.class.push("xfaWrapped"), Ct.border) {
              const {
                widths: jt,
                insets: Ht
              } = Ct.border[rt.$extra];
              let Ft, _t, Nt = Ht[0], Mt = Ht[3];
              const Lt = Ht[0] + Ht[2], $t = Ht[1] + Ht[3];
              switch (Ct.border.hand) {
                case "even":
                  Nt -= jt[0] / 2, Mt -= jt[3] / 2, Ft = `calc(100% + ${(jt[1] + jt[3]) / 2 - $t}px)`, _t = `calc(100% + ${(jt[0] + jt[2]) / 2 - Lt}px)`;
                  break;
                case "left":
                  Nt -= jt[0], Mt -= jt[3], Ft = `calc(100% + ${jt[1] + jt[3] - $t}px)`, _t = `calc(100% + ${jt[0] + jt[2] - Lt}px)`;
                  break;
                case "right":
                  Ft = $t ? `calc(100% - ${$t}px)` : "100%", _t = Lt ? `calc(100% - ${Lt}px)` : "100%";
                  break;
              }
              const Tt = ["xfaBorder"];
              St(Ct.border) && Tt.push("xfaPrintOnly");
              const Dt = {
                name: "div",
                attributes: {
                  class: Tt,
                  style: {
                    top: `${Nt}px`,
                    left: `${Mt}px`,
                    width: Ft,
                    height: _t
                  }
                },
                children: []
              };
              for (const Ut of ["border", "borderWidth", "borderColor", "borderRadius", "borderStyle"])
                Rt[Ut] !== void 0 && (Dt.attributes.style[Ut] = Rt[Ut], delete Rt[Ut]);
              kt.children.push(Dt, It);
            } else
              kt.children.push(It);
            for (const jt of ["background", "backgroundClip", "top", "left", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "transform", "transformOrigin", "visibility"])
              Rt[jt] !== void 0 && (kt.attributes.style[jt] = Rt[jt], delete Rt[jt]);
            return kt.attributes.style.position = Rt.position === "absolute" ? "absolute" : "relative", delete Rt.position, Rt.alignSelf && (kt.attributes.style.alignSelf = Rt.alignSelf, delete Rt.alignSelf), kt;
          }
          function bt(Ct) {
            const It = (0, lt.getMeasurement)(Ct.textIndent, "0px");
            if (It >= 0)
              return;
            const Rt = "padding" + ((Ct.textAlign === "right" ? "right" : "left") === "left" ? "Left" : "Right"), kt = (0, lt.getMeasurement)(Ct[Rt], "0px");
            Ct[Rt] = `${kt - It}px`;
          }
          function Et(Ct, It) {
            switch (Ct.access) {
              case "nonInteractive":
                It.push("xfaNonInteractive");
                break;
              case "readOnly":
                It.push("xfaReadOnly");
                break;
              case "protected":
                It.push("xfaDisabled");
                break;
            }
          }
          function St(Ct) {
            return Ct.relevant.length > 0 && !Ct.relevant[0].excluded && Ct.relevant[0].viewname === "print";
          }
          function Bt(Ct) {
            const It = Ct[rt.$getTemplateRoot]()[rt.$extra].paraStack;
            return It.length ? It.at(-1) : null;
          }
          function Ot(Ct, It, yt) {
            var Rt;
            if ((Rt = yt.attributes.class) != null && Rt.includes("xfaRich")) {
              It && (Ct.h === "" && (It.height = "auto"), Ct.w === "" && (It.width = "auto"));
              const kt = Bt(Ct);
              if (kt) {
                const jt = yt.attributes.style;
                switch (jt.display = "flex", jt.flexDirection = "column", kt.vAlign) {
                  case "top":
                    jt.justifyContent = "start";
                    break;
                  case "bottom":
                    jt.justifyContent = "end";
                    break;
                  case "middle":
                    jt.justifyContent = "center";
                    break;
                }
                const Ht = kt[rt.$toStyle]();
                for (const [Ft, _t] of Object.entries(Ht))
                  Ft in jt || (jt[Ft] = _t);
              }
            }
          }
          function Pt(Ct, It, yt, Rt) {
            if (!yt) {
              delete Rt.fontFamily;
              return;
            }
            const kt = (0, lt.stripQuotes)(Ct.typeface);
            Rt.fontFamily = `"${kt}"`;
            const jt = yt.find(kt);
            if (jt) {
              const {
                fontFamily: Ht
              } = jt.regular.cssFontInfo;
              Ht !== kt && (Rt.fontFamily = `"${Ht}"`);
              const Ft = Bt(It);
              if (Ft && Ft.lineHeight !== "" || Rt.lineHeight)
                return;
              const _t = (0, et.selectFont)(Ct, jt);
              _t && (Rt.lineHeight = Math.max(1.2, _t.lineHeight));
            }
          }
          function wt(Ct) {
            const It = (0, st.createValidAbsoluteUrl)(Ct, null, {
              addDefaultProtocol: !0,
              tryConvertEncoding: !0
            });
            return It ? It.href : null;
          }
        },
        /* 238 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.HTMLResult = void 0, at.getBBox = ct, at.getColor = mt, at.getFloat = ut, at.getInteger = it, at.getKeyword = ft, at.getMeasurement = dt, at.getRatio = gt, at.getRelevant = pt, at.getStringOption = ht, at.stripQuotes = et, ot(140);
          var rt = ot(145);
          const st = {
            pt: (At) => At,
            cm: (At) => At / 2.54 * 72,
            mm: (At) => At / (10 * 2.54) * 72,
            in: (At) => At * 72,
            px: (At) => At
          }, lt = /([+-]?\d+\.?\d*)(.*)/;
          function et(At) {
            return At.startsWith("'") || At.startsWith('"') ? At.slice(1, -1) : At;
          }
          function it(At) {
            let {
              data: xt,
              defaultValue: bt,
              validate: Et
            } = At;
            if (!xt)
              return bt;
            xt = xt.trim();
            const St = parseInt(xt, 10);
            return !isNaN(St) && Et(St) ? St : bt;
          }
          function ut(At) {
            let {
              data: xt,
              defaultValue: bt,
              validate: Et
            } = At;
            if (!xt)
              return bt;
            xt = xt.trim();
            const St = parseFloat(xt);
            return !isNaN(St) && Et(St) ? St : bt;
          }
          function ft(At) {
            let {
              data: xt,
              defaultValue: bt,
              validate: Et
            } = At;
            return xt ? (xt = xt.trim(), Et(xt) ? xt : bt) : bt;
          }
          function ht(At, xt) {
            return ft({
              data: At,
              defaultValue: xt[0],
              validate: (bt) => xt.includes(bt)
            });
          }
          function dt(At) {
            let xt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0";
            if (xt || (xt = "0"), !At)
              return dt(xt);
            const bt = At.trim().match(lt);
            if (!bt)
              return dt(xt);
            const [, Et, St] = bt, Bt = parseFloat(Et);
            if (isNaN(Bt))
              return dt(xt);
            if (Bt === 0)
              return 0;
            const Ot = st[St];
            return Ot ? Ot(Bt) : Bt;
          }
          function gt(At) {
            if (!At)
              return {
                num: 1,
                den: 1
              };
            const xt = At.trim().split(/\s*:\s*/).map((St) => parseFloat(St)).filter((St) => !isNaN(St));
            if (xt.length === 1 && xt.push(1), xt.length === 0)
              return {
                num: 1,
                den: 1
              };
            const [bt, Et] = xt;
            return {
              num: bt,
              den: Et
            };
          }
          function pt(At) {
            return At ? At.trim().split(/\s+/).map((xt) => ({
              excluded: xt[0] === "-",
              viewname: xt.substring(1)
            })) : [];
          }
          function mt(At) {
            let xt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [0, 0, 0], [bt, Et, St] = xt;
            if (!At)
              return {
                r: bt,
                g: Et,
                b: St
              };
            const Bt = At.trim().split(/\s*,\s*/).map((Ot) => Math.min(Math.max(0, parseInt(Ot.trim(), 10)), 255)).map((Ot) => isNaN(Ot) ? 0 : Ot);
            return Bt.length < 3 ? {
              r: bt,
              g: Et,
              b: St
            } : ([bt, Et, St] = Bt, {
              r: bt,
              g: Et,
              b: St
            });
          }
          function ct(At) {
            if (!At)
              return {
                x: -1,
                y: -1,
                width: -1,
                height: -1
              };
            const bt = At.trim().split(/\s*,\s*/).map((Pt) => dt(Pt, "-1"));
            if (bt.length < 4 || bt[2] < 0 || bt[3] < 0)
              return {
                x: -1,
                y: -1,
                width: -1,
                height: -1
              };
            const [Et, St, Bt, Ot] = bt;
            return {
              x: Et,
              y: St,
              width: Bt,
              height: Ot
            };
          }
          class vt {
            static get FAILURE() {
              return (0, rt.shadow)(this, "FAILURE", new vt(!1, null, null, null));
            }
            static get EMPTY() {
              return (0, rt.shadow)(this, "EMPTY", new vt(!0, null, null, null));
            }
            constructor(xt, bt, Et, St) {
              this.success = xt, this.html = bt, this.bbox = Et, this.breakNode = St;
            }
            isBreak() {
              return !!this.breakNode;
            }
            static breakNode(xt) {
              return new vt(!1, null, null, xt);
            }
            static success(xt) {
              let bt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return new vt(!0, xt, bt, null);
            }
          }
          at.HTMLResult = vt;
        },
        /* 239 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.FontFinder = void 0, at.getMetrics = ut, at.selectFont = it, ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138), ot(140);
          var rt = ot(229), st = ot(238), lt = ot(145);
          class et {
            constructor(ht) {
              this.fonts = /* @__PURE__ */ new Map(), this.cache = /* @__PURE__ */ new Map(), this.warned = /* @__PURE__ */ new Set(), this.defaultFont = null, this.add(ht);
            }
            add(ht) {
              let dt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              for (const pt of ht)
                this.addPdfFont(pt);
              for (const pt of this.fonts.values())
                pt.regular || (pt.regular = pt.italic || pt.bold || pt.bolditalic);
              if (!dt || dt.size === 0)
                return;
              const gt = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
              for (const pt of dt)
                this.fonts.set(pt, gt);
            }
            addPdfFont(ht) {
              var vt, At, xt;
              const dt = ht.cssFontInfo, gt = dt.fontFamily;
              let pt = this.fonts.get(gt);
              pt || (pt = /* @__PURE__ */ Object.create(null), this.fonts.set(gt, pt), this.defaultFont || (this.defaultFont = pt));
              let mt = "";
              const ct = parseFloat(dt.fontWeight);
              parseFloat(dt.italicAngle) !== 0 ? mt = ct >= 700 ? "bolditalic" : "italic" : ct >= 700 && (mt = "bold"), mt || ((ht.name.includes("Bold") || (vt = ht.psName) != null && vt.includes("Bold")) && (mt = "bold"), (ht.name.includes("Italic") || ht.name.endsWith("It") || (At = ht.psName) != null && At.includes("Italic") || (xt = ht.psName) != null && xt.endsWith("It")) && (mt += "italic")), mt || (mt = "regular"), pt[mt] = ht;
            }
            getDefault() {
              return this.defaultFont;
            }
            find(ht) {
              var vt, At;
              let dt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, gt = this.fonts.get(ht) || this.cache.get(ht);
              if (gt)
                return gt;
              const pt = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
              let mt = ht.replaceAll(pt, "");
              if (gt = this.fonts.get(mt), gt)
                return this.cache.set(ht, gt), gt;
              mt = mt.toLowerCase();
              const ct = [];
              for (const [xt, bt] of this.fonts.entries())
                xt.replaceAll(pt, "").toLowerCase().startsWith(mt) && ct.push(bt);
              if (ct.length === 0)
                for (const [, xt] of this.fonts.entries())
                  (vt = xt.regular.name) != null && vt.replaceAll(pt, "").toLowerCase().startsWith(mt) && ct.push(xt);
              if (ct.length === 0) {
                mt = mt.replaceAll(/psmt|mt/gi, "");
                for (const [xt, bt] of this.fonts.entries())
                  xt.replaceAll(pt, "").toLowerCase().startsWith(mt) && ct.push(bt);
              }
              if (ct.length === 0)
                for (const xt of this.fonts.values())
                  (At = xt.regular.name) != null && At.replaceAll(pt, "").toLowerCase().startsWith(mt) && ct.push(xt);
              return ct.length >= 1 ? (ct.length !== 1 && dt && (0, lt.warn)(`XFA - Too many choices to guess the correct font: ${ht}`), this.cache.set(ht, ct[0]), ct[0]) : (dt && !this.warned.has(ht) && (this.warned.add(ht), (0, lt.warn)(`XFA - Cannot find the font: ${ht}`)), null);
            }
          }
          at.FontFinder = et;
          function it(ft, ht) {
            return ft.posture === "italic" ? ft.weight === "bold" ? ht.bolditalic : ht.italic : ft.weight === "bold" ? ht.bold : ht.regular;
          }
          function ut(ft) {
            let ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, dt = null;
            if (ft) {
              const ct = (0, st.stripQuotes)(ft.typeface), vt = ft[rt.$globalData].fontFinder.find(ct);
              dt = it(ft, vt);
            }
            if (!dt)
              return {
                lineHeight: 12,
                lineGap: 2,
                lineNoGap: 10
              };
            const gt = ft.size || 10, pt = dt.lineHeight ? Math.max(ht ? 0 : 1.2, dt.lineHeight) : 1.2, mt = dt.lineGap === void 0 ? 0.2 : dt.lineGap;
            return {
              lineHeight: pt * gt,
              lineGap: mt * gt,
              lineNoGap: Math.max(1, pt - mt) * gt
            };
          }
        },
        /* 240 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.TextMeasure = void 0, ot(140);
          var rt = ot(239);
          const st = 1.02;
          class lt {
            constructor(ft, ht, dt, gt) {
              if (this.lineHeight = dt, this.paraMargin = ht || {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
              }, !ft) {
                [this.pdfFont, this.xfaFont] = this.defaultFont(gt);
                return;
              }
              this.xfaFont = {
                typeface: ft.typeface,
                posture: ft.posture,
                weight: ft.weight,
                size: ft.size,
                letterSpacing: ft.letterSpacing
              };
              const pt = gt.find(ft.typeface);
              if (!pt) {
                [this.pdfFont, this.xfaFont] = this.defaultFont(gt);
                return;
              }
              this.pdfFont = (0, rt.selectFont)(ft, pt), this.pdfFont || ([this.pdfFont, this.xfaFont] = this.defaultFont(gt));
            }
            defaultFont(ft) {
              const ht = ft.find("Helvetica", !1) || ft.find("Myriad Pro", !1) || ft.find("Arial", !1) || ft.getDefault();
              if (ht != null && ht.regular) {
                const gt = ht.regular, mt = {
                  typeface: gt.cssFontInfo.fontFamily,
                  posture: "normal",
                  weight: "normal",
                  size: 10,
                  letterSpacing: 0
                };
                return [gt, mt];
              }
              return [null, {
                typeface: "Courier",
                posture: "normal",
                weight: "normal",
                size: 10,
                letterSpacing: 0
              }];
            }
          }
          class et {
            constructor(ft, ht, dt, gt) {
              this.fontFinder = gt, this.stack = [new lt(ft, ht, dt, gt)];
            }
            pushData(ft, ht, dt) {
              const gt = this.stack.at(-1);
              for (const mt of ["typeface", "posture", "weight", "size", "letterSpacing"])
                ft[mt] || (ft[mt] = gt.xfaFont[mt]);
              for (const mt of ["top", "bottom", "left", "right"])
                isNaN(ht[mt]) && (ht[mt] = gt.paraMargin[mt]);
              const pt = new lt(ft, ht, dt || gt.lineHeight, this.fontFinder);
              pt.pdfFont || (pt.pdfFont = gt.pdfFont), this.stack.push(pt);
            }
            popFont() {
              this.stack.pop();
            }
            topFont() {
              return this.stack.at(-1);
            }
          }
          class it {
            constructor(ft, ht, dt, gt) {
              this.glyphs = [], this.fontSelector = new et(ft, ht, dt, gt), this.extraHeight = 0;
            }
            pushData(ft, ht, dt) {
              this.fontSelector.pushData(ft, ht, dt);
            }
            popFont(ft) {
              return this.fontSelector.popFont();
            }
            addPara() {
              const ft = this.fontSelector.topFont();
              this.extraHeight += ft.paraMargin.top + ft.paraMargin.bottom;
            }
            addString(ft) {
              if (!ft)
                return;
              const ht = this.fontSelector.topFont(), dt = ht.xfaFont.size;
              if (ht.pdfFont) {
                const gt = ht.xfaFont.letterSpacing, pt = ht.pdfFont, mt = pt.lineHeight || 1.2, ct = ht.lineHeight || Math.max(1.2, mt) * dt, vt = pt.lineGap === void 0 ? 0.2 : pt.lineGap, At = mt - vt, xt = Math.max(1, At) * dt, bt = dt / 1e3, Et = pt.defaultWidth || pt.charsToGlyphs(" ")[0].width;
                for (const St of ft.split(/[\u2029\n]/)) {
                  const Bt = pt.encodeString(St).join(""), Ot = pt.charsToGlyphs(Bt);
                  for (const Pt of Ot) {
                    const wt = Pt.width || Et;
                    this.glyphs.push([wt * bt + gt, ct, xt, Pt.unicode, !1]);
                  }
                  this.glyphs.push([0, 0, 0, `
`, !0]);
                }
                this.glyphs.pop();
                return;
              }
              for (const gt of ft.split(/[\u2029\n]/)) {
                for (const pt of gt.split(""))
                  this.glyphs.push([dt, 1.2 * dt, dt, pt, !1]);
                this.glyphs.push([0, 0, 0, `
`, !0]);
              }
              this.glyphs.pop();
            }
            compute(ft) {
              let ht = -1, dt = 0, gt = 0, pt = 0, mt = 0, ct = 0, vt = !1, At = !0;
              for (let xt = 0, bt = this.glyphs.length; xt < bt; xt++) {
                const [Et, St, Bt, Ot, Pt] = this.glyphs[xt], wt = Ot === " ", Ct = At ? Bt : St;
                if (Pt) {
                  gt = Math.max(gt, mt), mt = 0, pt += ct, ct = Ct, ht = -1, dt = 0, At = !1;
                  continue;
                }
                if (wt) {
                  mt + Et > ft ? (gt = Math.max(gt, mt), mt = 0, pt += ct, ct = Ct, ht = -1, dt = 0, vt = !0, At = !1) : (ct = Math.max(Ct, ct), dt = mt, mt += Et, ht = xt);
                  continue;
                }
                if (mt + Et > ft) {
                  pt += ct, ct = Ct, ht !== -1 ? (xt = ht, gt = Math.max(gt, dt), mt = 0, ht = -1, dt = 0) : (gt = Math.max(gt, mt), mt = Et), vt = !0, At = !1;
                  continue;
                }
                mt += Et, ct = Math.max(Ct, ct);
              }
              return gt = Math.max(gt, mt), pt += ct + this.extraHeight, {
                width: st * gt,
                height: pt,
                isBroken: vt
              };
            }
          }
          at.TextMeasure = it;
        },
        /* 241 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.XmlObject = at.XFAObjectArray = at.XFAObject = at.XFAAttribute = at.StringObject = at.OptionObject = at.Option10 = at.Option01 = at.IntegerObject = at.ContentObject = void 0, ot(140), ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138);
          var rt = ot(229), st = ot(238), lt = ot(145), et = ot(150), it = ot(235), ut = ot(242);
          const ft = Symbol(), ht = Symbol(), dt = Symbol(), gt = Symbol("_children"), pt = Symbol(), mt = Symbol(), ct = Symbol(), vt = Symbol(), At = Symbol(), xt = Symbol(), bt = Symbol(), Et = Symbol(), St = Symbol(), Bt = Symbol("parent"), Ot = Symbol(), Pt = Symbol(), wt = Symbol();
          let Ct = 0;
          const It = it.NamespaceIds.datasets.id;
          class yt {
            constructor(Tt, Dt) {
              let Ut = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
              this[rt.$namespaceId] = Tt, this[rt.$nodeName] = Dt, this[bt] = Ut, this[Bt] = null, this[gt] = [], this[rt.$uid] = `${Dt}${Ct++}`, this[rt.$globalData] = null;
            }
            get isXFAObject() {
              return !0;
            }
            get isXFAObjectArray() {
              return !1;
            }
            createNodes(Tt) {
              let Dt = this, Ut = null;
              for (const {
                name: Vt,
                index: Qt
              } of Tt) {
                for (let qt = 0, Zt = isFinite(Qt) ? Qt : 0; qt <= Zt; qt++) {
                  const ar = Dt[rt.$namespaceId] === It ? -1 : Dt[rt.$namespaceId];
                  Ut = new jt(ar, Vt), Dt[rt.$appendChild](Ut);
                }
                Dt = Ut;
              }
              return Ut;
            }
            [rt.$onChild](Tt) {
              if (!this[bt] || !this[rt.$onChildCheck](Tt))
                return !1;
              const Dt = Tt[rt.$nodeName], Ut = this[Dt];
              if (Ut instanceof Rt) {
                if (Ut.push(Tt))
                  return this[rt.$appendChild](Tt), !0;
              } else
                return Ut !== null && this[rt.$removeChild](Ut), this[Dt] = Tt, this[rt.$appendChild](Tt), !0;
              let Vt = "";
              return this.id ? Vt = ` (id: ${this.id})` : this.name && (Vt = ` (name: ${this.name} ${this.h.value})`), (0, lt.warn)(`XFA - node "${this[rt.$nodeName]}"${Vt} has already enough "${Dt}"!`), !1;
            }
            [rt.$onChildCheck](Tt) {
              return this.hasOwnProperty(Tt[rt.$nodeName]) && Tt[rt.$namespaceId] === this[rt.$namespaceId];
            }
            [rt.$isNsAgnostic]() {
              return !1;
            }
            [rt.$acceptWhitespace]() {
              return !1;
            }
            [rt.$isCDATAXml]() {
              return !1;
            }
            [rt.$isBindable]() {
              return !1;
            }
            [rt.$popPara]() {
              this.para && this[rt.$getTemplateRoot]()[rt.$extra].paraStack.pop();
            }
            [rt.$pushPara]() {
              this[rt.$getTemplateRoot]()[rt.$extra].paraStack.push(this.para);
            }
            [rt.$setId](Tt) {
              this.id && this[rt.$namespaceId] === it.NamespaceIds.template.id && Tt.set(this.id, this);
            }
            [rt.$getTemplateRoot]() {
              return this[rt.$globalData].template;
            }
            [rt.$isSplittable]() {
              return !1;
            }
            [rt.$isThereMoreWidth]() {
              return !1;
            }
            [rt.$appendChild](Tt) {
              Tt[Bt] = this, this[gt].push(Tt), !Tt[rt.$globalData] && this[rt.$globalData] && (Tt[rt.$globalData] = this[rt.$globalData]);
            }
            [rt.$removeChild](Tt) {
              const Dt = this[gt].indexOf(Tt);
              this[gt].splice(Dt, 1);
            }
            [rt.$hasSettableValue]() {
              return this.hasOwnProperty("value");
            }
            [rt.$setValue](Tt) {
            }
            [rt.$onText](Tt) {
            }
            [rt.$finalize]() {
            }
            [rt.$clean](Tt) {
              delete this[bt], this[rt.$cleanup] && (Tt.clean(this[rt.$cleanup]), delete this[rt.$cleanup]);
            }
            [rt.$indexOf](Tt) {
              return this[gt].indexOf(Tt);
            }
            [rt.$insertAt](Tt, Dt) {
              Dt[Bt] = this, this[gt].splice(Tt, 0, Dt), !Dt[rt.$globalData] && this[rt.$globalData] && (Dt[rt.$globalData] = this[rt.$globalData]);
            }
            [rt.$isTransparent]() {
              return !this.name;
            }
            [rt.$lastAttribute]() {
              return "";
            }
            [rt.$text]() {
              return this[gt].length === 0 ? this[rt.$content] : this[gt].map((Tt) => Tt[rt.$text]()).join("");
            }
            get [dt]() {
              const Tt = Object.getPrototypeOf(this);
              if (!Tt._attributes) {
                const Dt = Tt._attributes = /* @__PURE__ */ new Set();
                for (const Ut of Object.getOwnPropertyNames(this)) {
                  if (this[Ut] === null || this[Ut] instanceof yt || this[Ut] instanceof Rt)
                    break;
                  Dt.add(Ut);
                }
              }
              return (0, lt.shadow)(this, dt, Tt._attributes);
            }
            [rt.$isDescendent](Tt) {
              let Dt = this;
              for (; Dt; ) {
                if (Dt === Tt)
                  return !0;
                Dt = Dt[rt.$getParent]();
              }
              return !1;
            }
            [rt.$getParent]() {
              return this[Bt];
            }
            [rt.$getSubformParent]() {
              return this[rt.$getParent]();
            }
            [rt.$getChildren]() {
              let Tt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              return Tt ? this[Tt] : this[gt];
            }
            [rt.$dump]() {
              const Tt = /* @__PURE__ */ Object.create(null);
              this[rt.$content] && (Tt.$content = this[rt.$content]);
              for (const Dt of Object.getOwnPropertyNames(this)) {
                const Ut = this[Dt];
                Ut !== null && (Ut instanceof yt ? Tt[Dt] = Ut[rt.$dump]() : Ut instanceof Rt ? Ut.isEmpty() || (Tt[Dt] = Ut.dump()) : Tt[Dt] = Ut);
              }
              return Tt;
            }
            [rt.$toStyle]() {
              return null;
            }
            [rt.$toHTML]() {
              return st.HTMLResult.EMPTY;
            }
            *[rt.$getContainedChildren]() {
              for (const Tt of this[rt.$getChildren]())
                yield Tt;
            }
            *[vt](Tt, Dt) {
              for (const Ut of this[rt.$getContainedChildren]())
                if (!Tt || Dt === Tt.has(Ut[rt.$nodeName])) {
                  const Vt = this[rt.$getAvailableSpace](), Qt = Ut[rt.$toHTML](Vt);
                  Qt.success || (this[rt.$extra].failingNode = Ut), yield Qt;
                }
            }
            [rt.$flushHTML]() {
              return null;
            }
            [rt.$addHTML](Tt, Dt) {
              this[rt.$extra].children.push(Tt);
            }
            [rt.$getAvailableSpace]() {
            }
            [rt.$childrenToHTML](Tt) {
              let {
                filter: Dt = null,
                include: Ut = !0
              } = Tt;
              if (!this[rt.$extra].generator)
                this[rt.$extra].generator = this[vt](Dt, Ut);
              else {
                const Vt = this[rt.$getAvailableSpace](), Qt = this[rt.$extra].failingNode[rt.$toHTML](Vt);
                if (!Qt.success)
                  return Qt;
                Qt.html && this[rt.$addHTML](Qt.html, Qt.bbox), delete this[rt.$extra].failingNode;
              }
              for (; ; ) {
                const Vt = this[rt.$extra].generator.next();
                if (Vt.done)
                  break;
                const Qt = Vt.value;
                if (!Qt.success)
                  return Qt;
                Qt.html && this[rt.$addHTML](Qt.html, Qt.bbox);
              }
              return this[rt.$extra].generator = null, st.HTMLResult.EMPTY;
            }
            [rt.$setSetAttributes](Tt) {
              this[Pt] = new Set(Object.keys(Tt));
            }
            [xt](Tt) {
              const Dt = this[dt], Ut = this[Pt];
              return [...Tt].filter((Vt) => Dt.has(Vt) && !Ut.has(Vt));
            }
            [rt.$resolvePrototypes](Tt) {
              let Dt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new Set();
              for (const Ut of this[gt])
                Ut[Ot](Tt, Dt);
            }
            [Ot](Tt, Dt) {
              const Ut = this[At](Tt, Dt);
              Ut ? this[ft](Ut, Tt, Dt) : this[rt.$resolvePrototypes](Tt, Dt);
            }
            [At](Tt, Dt) {
              const {
                use: Ut,
                usehref: Vt
              } = this;
              if (!Ut && !Vt)
                return null;
              let Qt = null, qt = null, Zt = null, ar = Ut;
              if (Vt ? (ar = Vt, Vt.startsWith("#som(") && Vt.endsWith(")") ? qt = Vt.slice(5, -1) : Vt.startsWith(".#som(") && Vt.endsWith(")") ? qt = Vt.slice(6, -1) : Vt.startsWith("#") ? Zt = Vt.slice(1) : Vt.startsWith(".#") && (Zt = Vt.slice(2))) : Ut.startsWith("#") ? Zt = Ut.slice(1) : qt = Ut, this.use = this.usehref = "", Zt ? Qt = Tt.get(Zt) : (Qt = (0, ut.searchNode)(Tt.get(rt.$root), this, qt, !0, !1), Qt && (Qt = Qt[0])), !Qt)
                return (0, lt.warn)(`XFA - Invalid prototype reference: ${ar}.`), null;
              if (Qt[rt.$nodeName] !== this[rt.$nodeName])
                return (0, lt.warn)(`XFA - Incompatible prototype: ${Qt[rt.$nodeName]} !== ${this[rt.$nodeName]}.`), null;
              if (Dt.has(Qt))
                return (0, lt.warn)("XFA - Cycle detected in prototypes use."), null;
              Dt.add(Qt);
              const Jt = Qt[At](Tt, Dt);
              return Jt && Qt[ft](Jt, Tt, Dt), Qt[rt.$resolvePrototypes](Tt, Dt), Dt.delete(Qt), Qt;
            }
            [ft](Tt, Dt, Ut) {
              if (Ut.has(Tt)) {
                (0, lt.warn)("XFA - Cycle detected in prototypes use.");
                return;
              }
              !this[rt.$content] && Tt[rt.$content] && (this[rt.$content] = Tt[rt.$content]), new Set(Ut).add(Tt);
              for (const Qt of this[xt](Tt[Pt]))
                this[Qt] = Tt[Qt], this[Pt] && this[Pt].add(Qt);
              for (const Qt of Object.getOwnPropertyNames(this)) {
                if (this[dt].has(Qt))
                  continue;
                const qt = this[Qt], Zt = Tt[Qt];
                if (qt instanceof Rt) {
                  for (const ar of qt[gt])
                    ar[Ot](Dt, Ut);
                  for (let ar = qt[gt].length, Jt = Zt[gt].length; ar < Jt; ar++) {
                    const rr = Tt[gt][ar][rt.$clone]();
                    if (qt.push(rr))
                      rr[Bt] = this, this[gt].push(rr), rr[Ot](Dt, Ut);
                    else
                      break;
                  }
                  continue;
                }
                if (qt !== null) {
                  qt[rt.$resolvePrototypes](Dt, Ut), Zt && qt[ft](Zt, Dt, Ut);
                  continue;
                }
                if (Zt !== null) {
                  const ar = Zt[rt.$clone]();
                  ar[Bt] = this, this[Qt] = ar, this[gt].push(ar), ar[Ot](Dt, Ut);
                }
              }
            }
            static [pt](Tt) {
              return Array.isArray(Tt) ? Tt.map((Dt) => yt[pt](Dt)) : typeof Tt == "object" && Tt !== null ? Object.assign({}, Tt) : Tt;
            }
            [rt.$clone]() {
              const Tt = Object.create(Object.getPrototypeOf(this));
              for (const Dt of Object.getOwnPropertySymbols(this))
                try {
                  Tt[Dt] = this[Dt];
                } catch {
                  (0, lt.shadow)(Tt, Dt, this[Dt]);
                }
              Tt[rt.$uid] = `${Tt[rt.$nodeName]}${Ct++}`, Tt[gt] = [];
              for (const Dt of Object.getOwnPropertyNames(this)) {
                if (this[dt].has(Dt)) {
                  Tt[Dt] = yt[pt](this[Dt]);
                  continue;
                }
                const Ut = this[Dt];
                Tt[Dt] = Ut instanceof Rt ? new Rt(Ut[Et]) : null;
              }
              for (const Dt of this[gt]) {
                const Ut = Dt[rt.$nodeName], Vt = Dt[rt.$clone]();
                Tt[gt].push(Vt), Vt[Bt] = Tt, Tt[Ut] === null ? Tt[Ut] = Vt : Tt[Ut][gt].push(Vt);
              }
              return Tt;
            }
            [rt.$getChildren]() {
              let Tt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              return Tt ? this[gt].filter((Dt) => Dt[rt.$nodeName] === Tt) : this[gt];
            }
            [rt.$getChildrenByClass](Tt) {
              return this[Tt];
            }
            [rt.$getChildrenByName](Tt, Dt) {
              let Ut = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
              return Array.from(this[rt.$getChildrenByNameIt](Tt, Dt, Ut));
            }
            [rt.$getChildrenByNameIt](Tt, Dt) {
              var Ut = this;
              let Vt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
              return function* () {
                if (Tt === "parent") {
                  yield Ut[Bt];
                  return;
                }
                for (const Qt of Ut[gt])
                  Qt[rt.$nodeName] === Tt && (yield Qt), Qt.name === Tt && (yield Qt), (Dt || Qt[rt.$isTransparent]()) && (yield* Qt[rt.$getChildrenByNameIt](Tt, Dt, !1));
                Vt && Ut[dt].has(Tt) && (yield new kt(Ut, Tt, Ut[Tt]));
              }();
            }
          }
          at.XFAObject = yt;
          class Rt {
            constructor() {
              let Tt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1 / 0;
              this[Et] = Tt, this[gt] = [];
            }
            get isXFAObject() {
              return !1;
            }
            get isXFAObjectArray() {
              return !0;
            }
            push(Tt) {
              return this[gt].length <= this[Et] ? (this[gt].push(Tt), !0) : ((0, lt.warn)(`XFA - node "${Tt[rt.$nodeName]}" accepts no more than ${this[Et]} children`), !1);
            }
            isEmpty() {
              return this[gt].length === 0;
            }
            dump() {
              return this[gt].length === 1 ? this[gt][0][rt.$dump]() : this[gt].map((Tt) => Tt[rt.$dump]());
            }
            [rt.$clone]() {
              const Tt = new Rt(this[Et]);
              return Tt[gt] = this[gt].map((Dt) => Dt[rt.$clone]()), Tt;
            }
            get children() {
              return this[gt];
            }
            clear() {
              this[gt].length = 0;
            }
          }
          at.XFAObjectArray = Rt;
          class kt {
            constructor(Tt, Dt, Ut) {
              this[Bt] = Tt, this[rt.$nodeName] = Dt, this[rt.$content] = Ut, this[rt.$consumed] = !1, this[rt.$uid] = `attribute${Ct++}`;
            }
            [rt.$getParent]() {
              return this[Bt];
            }
            [rt.$isDataValue]() {
              return !0;
            }
            [rt.$getDataValue]() {
              return this[rt.$content].trim();
            }
            [rt.$setValue](Tt) {
              Tt = Tt.value || "", this[rt.$content] = Tt.toString();
            }
            [rt.$text]() {
              return this[rt.$content];
            }
            [rt.$isDescendent](Tt) {
              return this[Bt] === Tt || this[Bt][rt.$isDescendent](Tt);
            }
          }
          at.XFAAttribute = kt;
          class jt extends yt {
            constructor(Tt, Dt) {
              let Ut = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              if (super(Tt, Dt), this[rt.$content] = "", this[mt] = null, Dt !== "#text") {
                const Vt = /* @__PURE__ */ new Map();
                this[ht] = Vt;
                for (const [Qt, qt] of Object.entries(Ut))
                  Vt.set(Qt, new kt(this, Qt, qt));
                if (Ut.hasOwnProperty(rt.$nsAttributes)) {
                  const Qt = Ut[rt.$nsAttributes].xfa.dataNode;
                  Qt !== void 0 && (Qt === "dataGroup" ? this[mt] = !1 : Qt === "dataValue" && (this[mt] = !0));
                }
              }
              this[rt.$consumed] = !1;
            }
            [rt.$toString](Tt) {
              const Dt = this[rt.$nodeName];
              if (Dt === "#text") {
                Tt.push((0, et.encodeToXmlString)(this[rt.$content]));
                return;
              }
              const Ut = (0, lt.utf8StringToString)(Dt), Vt = this[rt.$namespaceId] === It ? "xfa:" : "";
              Tt.push(`<${Vt}${Ut}`);
              for (const [Qt, qt] of this[ht].entries()) {
                const Zt = (0, lt.utf8StringToString)(Qt);
                Tt.push(` ${Zt}="${(0, et.encodeToXmlString)(qt[rt.$content])}"`);
              }
              if (this[mt] !== null && (this[mt] ? Tt.push(' xfa:dataNode="dataValue"') : Tt.push(' xfa:dataNode="dataGroup"')), !this[rt.$content] && this[gt].length === 0) {
                Tt.push("/>");
                return;
              }
              if (Tt.push(">"), this[rt.$content])
                typeof this[rt.$content] == "string" ? Tt.push((0, et.encodeToXmlString)(this[rt.$content])) : this[rt.$content][rt.$toString](Tt);
              else
                for (const Qt of this[gt])
                  Qt[rt.$toString](Tt);
              Tt.push(`</${Vt}${Ut}>`);
            }
            [rt.$onChild](Tt) {
              if (this[rt.$content]) {
                const Dt = new jt(this[rt.$namespaceId], "#text");
                this[rt.$appendChild](Dt), Dt[rt.$content] = this[rt.$content], this[rt.$content] = "";
              }
              return this[rt.$appendChild](Tt), !0;
            }
            [rt.$onText](Tt) {
              this[rt.$content] += Tt;
            }
            [rt.$finalize]() {
              if (this[rt.$content] && this[gt].length > 0) {
                const Tt = new jt(this[rt.$namespaceId], "#text");
                this[rt.$appendChild](Tt), Tt[rt.$content] = this[rt.$content], delete this[rt.$content];
              }
            }
            [rt.$toHTML]() {
              return this[rt.$nodeName] === "#text" ? st.HTMLResult.success({
                name: "#text",
                value: this[rt.$content]
              }) : st.HTMLResult.EMPTY;
            }
            [rt.$getChildren]() {
              let Tt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              return Tt ? this[gt].filter((Dt) => Dt[rt.$nodeName] === Tt) : this[gt];
            }
            [rt.$getAttributes]() {
              return this[ht];
            }
            [rt.$getChildrenByClass](Tt) {
              const Dt = this[ht].get(Tt);
              return Dt !== void 0 ? Dt : this[rt.$getChildren](Tt);
            }
            *[rt.$getChildrenByNameIt](Tt, Dt) {
              const Ut = this[ht].get(Tt);
              Ut && (yield Ut);
              for (const Vt of this[gt])
                Vt[rt.$nodeName] === Tt && (yield Vt), Dt && (yield* Vt[rt.$getChildrenByNameIt](Tt, Dt));
            }
            *[rt.$getAttributeIt](Tt, Dt) {
              const Ut = this[ht].get(Tt);
              Ut && (!Dt || !Ut[rt.$consumed]) && (yield Ut);
              for (const Vt of this[gt])
                yield* Vt[rt.$getAttributeIt](Tt, Dt);
            }
            *[rt.$getRealChildrenByNameIt](Tt, Dt, Ut) {
              for (const Vt of this[gt])
                Vt[rt.$nodeName] === Tt && (!Ut || !Vt[rt.$consumed]) && (yield Vt), Dt && (yield* Vt[rt.$getRealChildrenByNameIt](Tt, Dt, Ut));
            }
            [rt.$isDataValue]() {
              return this[mt] === null ? this[gt].length === 0 || this[gt][0][rt.$namespaceId] === it.NamespaceIds.xhtml.id : this[mt];
            }
            [rt.$getDataValue]() {
              return this[mt] === null ? this[gt].length === 0 ? this[rt.$content].trim() : this[gt][0][rt.$namespaceId] === it.NamespaceIds.xhtml.id ? this[gt][0][rt.$text]().trim() : null : this[rt.$content].trim();
            }
            [rt.$setValue](Tt) {
              Tt = Tt.value || "", this[rt.$content] = Tt.toString();
            }
            [rt.$dump]() {
              let Tt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              const Dt = /* @__PURE__ */ Object.create(null);
              Tt && (Dt.$ns = this[rt.$namespaceId]), this[rt.$content] && (Dt.$content = this[rt.$content]), Dt.$name = this[rt.$nodeName], Dt.children = [];
              for (const Ut of this[gt])
                Dt.children.push(Ut[rt.$dump](Tt));
              Dt.attributes = /* @__PURE__ */ Object.create(null);
              for (const [Ut, Vt] of this[ht])
                Dt.attributes[Ut] = Vt[rt.$content];
              return Dt;
            }
          }
          at.XmlObject = jt;
          class Ht extends yt {
            constructor(Tt, Dt) {
              super(Tt, Dt), this[rt.$content] = "";
            }
            [rt.$onText](Tt) {
              this[rt.$content] += Tt;
            }
            [rt.$finalize]() {
            }
          }
          at.ContentObject = Ht;
          class Ft extends Ht {
            constructor(Tt, Dt, Ut) {
              super(Tt, Dt), this[St] = Ut;
            }
            [rt.$finalize]() {
              this[rt.$content] = (0, st.getKeyword)({
                data: this[rt.$content],
                defaultValue: this[St][0],
                validate: (Tt) => this[St].includes(Tt)
              });
            }
            [rt.$clean](Tt) {
              super[rt.$clean](Tt), delete this[St];
            }
          }
          at.OptionObject = Ft;
          class _t extends Ht {
            [rt.$finalize]() {
              this[rt.$content] = this[rt.$content].trim();
            }
          }
          at.StringObject = _t;
          class Nt extends Ht {
            constructor(Tt, Dt, Ut, Vt) {
              super(Tt, Dt), this[ct] = Ut, this[wt] = Vt;
            }
            [rt.$finalize]() {
              this[rt.$content] = (0, st.getInteger)({
                data: this[rt.$content],
                defaultValue: this[ct],
                validate: this[wt]
              });
            }
            [rt.$clean](Tt) {
              super[rt.$clean](Tt), delete this[ct], delete this[wt];
            }
          }
          at.IntegerObject = Nt;
          class Mt extends Nt {
            constructor(Tt, Dt) {
              super(Tt, Dt, 0, (Ut) => Ut === 1);
            }
          }
          at.Option01 = Mt;
          class Lt extends Nt {
            constructor(Tt, Dt) {
              super(Tt, Dt, 1, (Ut) => Ut === 0);
            }
          }
          at.Option10 = Lt;
        },
        /* 242 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.createDataNode = pt, at.searchNode = gt, ot(140);
          var rt = ot(229), st = ot(145);
          const lt = /^[^.[]+/, et = /^[^\]]+/, it = {
            dot: 0,
            dotDot: 1,
            dotHash: 2,
            dotBracket: 3,
            dotParen: 4
          }, ut = /* @__PURE__ */ new Map([["$data", (mt, ct) => mt.datasets ? mt.datasets.data : mt], ["$record", (mt, ct) => (mt.datasets ? mt.datasets.data : mt)[rt.$getChildren]()[0]], ["$template", (mt, ct) => mt.template], ["$connectionSet", (mt, ct) => mt.connectionSet], ["$form", (mt, ct) => mt.form], ["$layout", (mt, ct) => mt.layout], ["$host", (mt, ct) => mt.host], ["$dataWindow", (mt, ct) => mt.dataWindow], ["$event", (mt, ct) => mt.event], ["!", (mt, ct) => mt.datasets], ["$xfa", (mt, ct) => mt], ["xfa", (mt, ct) => mt], ["$", (mt, ct) => ct]]), ft = /* @__PURE__ */ new WeakMap();
          function ht(mt) {
            return mt = mt.trim(), mt === "*" ? 1 / 0 : parseInt(mt, 10) || 0;
          }
          function dt(mt, ct) {
            let vt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, At = mt.match(lt);
            if (!At)
              return null;
            let [xt] = At;
            const bt = [{
              name: xt,
              cacheName: "." + xt,
              index: 0,
              js: null,
              formCalc: null,
              operator: it.dot
            }];
            let Et = xt.length;
            for (; Et < mt.length; ) {
              const St = Et;
              if (mt.charAt(Et++) === "[") {
                if (At = mt.slice(Et).match(et), !At)
                  return (0, st.warn)("XFA - Invalid index in SOM expression"), null;
                bt.at(-1).index = ht(At[0]), Et += At[0].length + 1;
                continue;
              }
              let Ot;
              switch (mt.charAt(Et)) {
                case ".":
                  if (!ct)
                    return null;
                  Et++, Ot = it.dotDot;
                  break;
                case "#":
                  Et++, Ot = it.dotHash;
                  break;
                case "[":
                  if (vt)
                    return (0, st.warn)("XFA - SOM expression contains a FormCalc subexpression which is not supported for now."), null;
                  Ot = it.dotBracket;
                  break;
                case "(":
                  if (vt)
                    return (0, st.warn)("XFA - SOM expression contains a JavaScript subexpression which is not supported for now."), null;
                  Ot = it.dotParen;
                  break;
                default:
                  Ot = it.dot;
                  break;
              }
              if (At = mt.slice(Et).match(lt), !At)
                break;
              [xt] = At, Et += xt.length, bt.push({
                name: xt,
                cacheName: mt.slice(St, Et),
                operator: Ot,
                index: 0,
                js: null,
                formCalc: null
              });
            }
            return bt;
          }
          function gt(mt, ct, vt) {
            let At = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, xt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
            const bt = dt(vt, At);
            if (!bt)
              return null;
            const Et = ut.get(bt[0].name);
            let St = 0, Bt;
            Et ? (Bt = !0, mt = [Et(mt, ct)], St = 1) : (Bt = ct === null, mt = [ct || mt]);
            for (let Ot = bt.length; St < Ot; St++) {
              const {
                name: Pt,
                cacheName: wt,
                operator: Ct,
                index: It
              } = bt[St], yt = [];
              for (const Rt of mt) {
                if (!Rt.isXFAObject)
                  continue;
                let kt, jt;
                if (xt && (jt = ft.get(Rt), jt || (jt = /* @__PURE__ */ new Map(), ft.set(Rt, jt)), kt = jt.get(wt)), !kt) {
                  switch (Ct) {
                    case it.dot:
                      kt = Rt[rt.$getChildrenByName](Pt, !1);
                      break;
                    case it.dotDot:
                      kt = Rt[rt.$getChildrenByName](Pt, !0);
                      break;
                    case it.dotHash:
                      kt = Rt[rt.$getChildrenByClass](Pt), kt = kt.isXFAObjectArray ? kt.children : [kt];
                      break;
                  }
                  xt && jt.set(wt, kt);
                }
                kt.length > 0 && yt.push(kt);
              }
              if (yt.length === 0 && !Bt && St === 0) {
                if (ct = ct[rt.$getParent](), !ct)
                  return null;
                St = -1, mt = [ct];
                continue;
              }
              mt = isFinite(It) ? yt.filter((Rt) => It < Rt.length).map((Rt) => Rt[It]) : yt.flat();
            }
            return mt.length === 0 ? null : mt;
          }
          function pt(mt, ct, vt) {
            const At = dt(vt);
            if (!At || At.some((Et) => Et.operator === it.dotDot))
              return null;
            const xt = ut.get(At[0].name);
            let bt = 0;
            xt ? (mt = xt(mt, ct), bt = 1) : mt = ct || mt;
            for (let Et = At.length; bt < Et; bt++) {
              const {
                name: St,
                operator: Bt,
                index: Ot
              } = At[bt];
              if (!isFinite(Ot))
                return At[bt].index = 0, mt.createNodes(At.slice(bt));
              let Pt;
              switch (Bt) {
                case it.dot:
                  Pt = mt[rt.$getChildrenByName](St, !1);
                  break;
                case it.dotDot:
                  Pt = mt[rt.$getChildrenByName](St, !0);
                  break;
                case it.dotHash:
                  Pt = mt[rt.$getChildrenByClass](St), Pt = Pt.isXFAObjectArray ? Pt.children : [Pt];
                  break;
              }
              if (Pt.length === 0)
                return mt.createNodes(At.slice(bt));
              if (Ot < Pt.length) {
                const wt = Pt[Ot];
                if (!wt.isXFAObject)
                  return (0, st.warn)("XFA - Cannot create a node."), null;
                mt = wt;
              } else
                return At[bt].index = Ot - Pt.length, mt.createNodes(At.slice(bt));
            }
            return null;
          }
        },
        /* 243 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.DataHandler = void 0, ot(140);
          var rt = ot(229);
          class st {
            constructor(et, it) {
              this.data = it, this.dataset = et.datasets || null;
            }
            serialize(et) {
              const it = [[-1, this.data[rt.$getChildren]()]];
              for (; it.length > 0; ) {
                const ft = it.at(-1), [ht, dt] = ft;
                if (ht + 1 === dt.length) {
                  it.pop();
                  continue;
                }
                const gt = dt[++ft[0]], pt = et.get(gt[rt.$uid]);
                if (pt)
                  gt[rt.$setValue](pt);
                else {
                  const ct = gt[rt.$getAttributes]();
                  for (const vt of ct.values()) {
                    const At = et.get(vt[rt.$uid]);
                    if (At) {
                      vt[rt.$setValue](At);
                      break;
                    }
                  }
                }
                const mt = gt[rt.$getChildren]();
                mt.length > 0 && it.push([-1, mt]);
              }
              const ut = ['<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">'];
              if (this.dataset)
                for (const ft of this.dataset[rt.$getChildren]())
                  ft[rt.$nodeName] !== "data" && ft[rt.$toString](ut);
              return this.data[rt.$toString](ut), ut.push("</xfa:datasets>"), ut.join("");
            }
          }
          at.DataHandler = st;
        },
        /* 244 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.XFAParser = void 0, ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138), ot(140);
          var rt = ot(229), st = ot(222), lt = ot(245), et = ot(145);
          class it extends st.XMLParserBase {
            constructor() {
              let ft = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
              super(), this._builder = new lt.Builder(ft), this._stack = [], this._globalData = {
                usedTypefaces: /* @__PURE__ */ new Set()
              }, this._ids = /* @__PURE__ */ new Map(), this._current = this._builder.buildRoot(this._ids), this._errorCode = st.XMLParserErrorCode.NoError, this._whiteRegex = /^\s+$/, this._nbsps = /\xa0+/g, this._richText = ht;
            }
            parse(ft) {
              if (this.parseXml(ft), this._errorCode === st.XMLParserErrorCode.NoError)
                return this._current[rt.$finalize](), this._current.element;
            }
            onText(ft) {
              if (ft = ft.replace(this._nbsps, (ht) => ht.slice(1) + " "), this._richText || this._current[rt.$acceptWhitespace]()) {
                this._current[rt.$onText](ft, this._richText);
                return;
              }
              this._whiteRegex.test(ft) || this._current[rt.$onText](ft.trim());
            }
            onCdata(ft) {
              this._current[rt.$onText](ft);
            }
            _mkAttributes(ft, ht) {
              let dt = null, gt = null;
              const pt = /* @__PURE__ */ Object.create({});
              for (const {
                name: mt,
                value: ct
              } of ft)
                if (mt === "xmlns")
                  dt ? (0, et.warn)(`XFA - multiple namespace definition in <${ht}>`) : dt = ct;
                else if (mt.startsWith("xmlns:")) {
                  const vt = mt.substring(6);
                  gt || (gt = []), gt.push({
                    prefix: vt,
                    value: ct
                  });
                } else {
                  const vt = mt.indexOf(":");
                  if (vt === -1)
                    pt[mt] = ct;
                  else {
                    let At = pt[rt.$nsAttributes];
                    At || (At = pt[rt.$nsAttributes] = /* @__PURE__ */ Object.create(null));
                    const [xt, bt] = [mt.slice(0, vt), mt.slice(vt + 1)], Et = At[xt] || (At[xt] = /* @__PURE__ */ Object.create(null));
                    Et[bt] = ct;
                  }
                }
              return [dt, gt, pt];
            }
            _getNameAndPrefix(ft, ht) {
              const dt = ft.indexOf(":");
              return dt === -1 ? [ft, null] : [ft.substring(dt + 1), ht ? "" : ft.substring(0, dt)];
            }
            onBeginElement(ft, ht, dt) {
              const [gt, pt, mt] = this._mkAttributes(ht, ft), [ct, vt] = this._getNameAndPrefix(ft, this._builder.isNsAgnostic()), At = this._builder.build({
                nsPrefix: vt,
                name: ct,
                attributes: mt,
                namespace: gt,
                prefixes: pt
              });
              if (At[rt.$globalData] = this._globalData, dt) {
                At[rt.$finalize](), this._current[rt.$onChild](At) && At[rt.$setId](this._ids), At[rt.$clean](this._builder);
                return;
              }
              this._stack.push(this._current), this._current = At;
            }
            onEndElement(ft) {
              const ht = this._current;
              if (ht[rt.$isCDATAXml]() && typeof ht[rt.$content] == "string") {
                const dt = new it();
                dt._globalData = this._globalData;
                const gt = dt.parse(ht[rt.$content]);
                ht[rt.$content] = null, ht[rt.$onChild](gt);
              }
              ht[rt.$finalize](), this._current = this._stack.pop(), this._current[rt.$onChild](ht) && ht[rt.$setId](this._ids), ht[rt.$clean](this._builder);
            }
            onError(ft) {
              this._errorCode = ft;
            }
          }
          at.XFAParser = it;
        },
        /* 245 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.Builder = void 0, ot(140);
          var rt = ot(235), st = ot(229), lt = ot(246), et = ot(231), it = ot(255), ut = ot(145), ft = ot(241);
          class ht extends ft.XFAObject {
            constructor(mt) {
              super(-1, "root", /* @__PURE__ */ Object.create(null)), this.element = null, this[st.$ids] = mt;
            }
            [st.$onChild](mt) {
              return this.element = mt, !0;
            }
            [st.$finalize]() {
              super[st.$finalize](), this.element.template instanceof et.Template && (this[st.$ids].set(st.$root, this.element), this.element.template[st.$resolvePrototypes](this[st.$ids]), this.element.template[st.$ids] = this[st.$ids]);
            }
          }
          class dt extends ft.XFAObject {
            constructor() {
              super(-1, "", /* @__PURE__ */ Object.create(null));
            }
            [st.$onChild](mt) {
              return !1;
            }
          }
          class gt {
            constructor() {
              let mt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
              this._namespaceStack = [], this._nsAgnosticLevel = 0, this._namespacePrefixes = /* @__PURE__ */ new Map(), this._namespaces = /* @__PURE__ */ new Map(), this._nextNsId = Math.max(...Object.values(rt.NamespaceIds).map((ct) => {
                let {
                  id: vt
                } = ct;
                return vt;
              })), this._currentNamespace = mt || new it.UnknownNamespace(++this._nextNsId);
            }
            buildRoot(mt) {
              return new ht(mt);
            }
            build(mt) {
              let {
                nsPrefix: ct,
                name: vt,
                attributes: At,
                namespace: xt,
                prefixes: bt
              } = mt;
              const Et = xt !== null;
              if (Et && (this._namespaceStack.push(this._currentNamespace), this._currentNamespace = this._searchNamespace(xt)), bt && this._addNamespacePrefix(bt), At.hasOwnProperty(st.$nsAttributes)) {
                const Ot = lt.NamespaceSetUp.datasets, Pt = At[st.$nsAttributes];
                let wt = null;
                for (const [Ct, It] of Object.entries(Pt))
                  if (this._getNamespaceToUse(Ct) === Ot) {
                    wt = {
                      xfa: It
                    };
                    break;
                  }
                wt ? At[st.$nsAttributes] = wt : delete At[st.$nsAttributes];
              }
              const St = this._getNamespaceToUse(ct), Bt = (St == null ? void 0 : St[rt.$buildXFAObject](vt, At)) || new dt();
              return Bt[st.$isNsAgnostic]() && this._nsAgnosticLevel++, (Et || bt || Bt[st.$isNsAgnostic]()) && (Bt[st.$cleanup] = {
                hasNamespace: Et,
                prefixes: bt,
                nsAgnostic: Bt[st.$isNsAgnostic]()
              }), Bt;
            }
            isNsAgnostic() {
              return this._nsAgnosticLevel > 0;
            }
            _searchNamespace(mt) {
              let ct = this._namespaces.get(mt);
              if (ct)
                return ct;
              for (const [vt, {
                check: At
              }] of Object.entries(rt.NamespaceIds))
                if (At(mt)) {
                  if (ct = lt.NamespaceSetUp[vt], ct)
                    return this._namespaces.set(mt, ct), ct;
                  break;
                }
              return ct = new it.UnknownNamespace(++this._nextNsId), this._namespaces.set(mt, ct), ct;
            }
            _addNamespacePrefix(mt) {
              for (const {
                prefix: ct,
                value: vt
              } of mt) {
                const At = this._searchNamespace(vt);
                let xt = this._namespacePrefixes.get(ct);
                xt || (xt = [], this._namespacePrefixes.set(ct, xt)), xt.push(At);
              }
            }
            _getNamespaceToUse(mt) {
              if (!mt)
                return this._currentNamespace;
              const ct = this._namespacePrefixes.get(mt);
              return (ct == null ? void 0 : ct.length) > 0 ? ct.at(-1) : ((0, ut.warn)(`Unknown namespace prefix: ${mt}.`), null);
            }
            clean(mt) {
              const {
                hasNamespace: ct,
                prefixes: vt,
                nsAgnostic: At
              } = mt;
              ct && (this._currentNamespace = this._namespaceStack.pop()), vt && vt.forEach((xt) => {
                let {
                  prefix: bt
                } = xt;
                this._namespacePrefixes.get(bt).pop();
              }), At && this._nsAgnosticLevel--;
            }
          }
          at.Builder = gt;
        },
        /* 246 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.NamespaceSetUp = void 0;
          var rt = ot(247), st = ot(248), lt = ot(249), et = ot(250), it = ot(251), ut = ot(252), ft = ot(231), ht = ot(253), dt = ot(254);
          const gt = {
            config: rt.ConfigNamespace,
            connection: st.ConnectionSetNamespace,
            datasets: lt.DatasetsNamespace,
            localeSet: et.LocaleSetNamespace,
            signature: it.SignatureNamespace,
            stylesheet: ut.StylesheetNamespace,
            template: ft.TemplateNamespace,
            xdp: ht.XdpNamespace,
            xhtml: dt.XhtmlNamespace
          };
          at.NamespaceSetUp = gt;
        },
        /* 247 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.ConfigNamespace = void 0, ot(140);
          var rt = ot(235), st = ot(229), lt = ot(241), et = ot(238), it = ot(145);
          const ut = rt.NamespaceIds.config.id;
          class ft extends lt.XFAObject {
            constructor(dr) {
              super(ut, "acrobat", !0), this.acrobat7 = null, this.autoSave = null, this.common = null, this.validate = null, this.validateApprovalSignatures = null, this.submitUrl = new lt.XFAObjectArray();
            }
          }
          class ht extends lt.XFAObject {
            constructor(dr) {
              super(ut, "acrobat7", !0), this.dynamicRender = null;
            }
          }
          class dt extends lt.OptionObject {
            constructor(dr) {
              super(ut, "ADBE_JSConsole", ["delegate", "Enable", "Disable"]);
            }
          }
          class gt extends lt.OptionObject {
            constructor(dr) {
              super(ut, "ADBE_JSDebugger", ["delegate", "Enable", "Disable"]);
            }
          }
          class pt extends lt.Option01 {
            constructor(dr) {
              super(ut, "addSilentPrint");
            }
          }
          class mt extends lt.Option01 {
            constructor(dr) {
              super(ut, "addViewerPreferences");
            }
          }
          class ct extends lt.Option10 {
            constructor(dr) {
              super(ut, "adjustData");
            }
          }
          class vt extends lt.IntegerObject {
            constructor(dr) {
              super(ut, "adobeExtensionLevel", 0, (qr) => qr >= 1 && qr <= 8);
            }
          }
          class At extends lt.XFAObject {
            constructor(dr) {
              super(ut, "agent", !0), this.name = dr.name ? dr.name.trim() : "", this.common = new lt.XFAObjectArray();
            }
          }
          class xt extends lt.ContentObject {
            constructor(dr) {
              super(ut, "alwaysEmbed");
            }
          }
          class bt extends lt.StringObject {
            constructor(dr) {
              super(ut, "amd");
            }
          }
          class Et extends lt.XFAObject {
            constructor(dr) {
              super(ut, "area"), this.level = (0, et.getInteger)({
                data: dr.level,
                defaultValue: 0,
                validate: (qr) => qr >= 1 && qr <= 3
              }), this.name = (0, et.getStringOption)(dr.name, ["", "barcode", "coreinit", "deviceDriver", "font", "general", "layout", "merge", "script", "signature", "sourceSet", "templateCache"]);
            }
          }
          class St extends lt.OptionObject {
            constructor(dr) {
              super(ut, "attributes", ["preserve", "delegate", "ignore"]);
            }
          }
          class Bt extends lt.OptionObject {
            constructor(dr) {
              super(ut, "autoSave", ["disabled", "enabled"]);
            }
          }
          class Ot extends lt.StringObject {
            constructor(dr) {
              super(ut, "base");
            }
          }
          class Pt extends lt.XFAObject {
            constructor(dr) {
              super(ut, "batchOutput"), this.format = (0, et.getStringOption)(dr.format, ["none", "concat", "zip", "zipCompress"]);
            }
          }
          class wt extends lt.ContentObject {
            constructor(dr) {
              super(ut, "behaviorOverride");
            }
            [st.$finalize]() {
              this[st.$content] = new Map(this[st.$content].trim().split(/\s+/).filter((dr) => dr.includes(":")).map((dr) => dr.split(":", 2)));
            }
          }
          class Ct extends lt.XFAObject {
            constructor(dr) {
              super(ut, "cache", !0), this.templateCache = null;
            }
          }
          class It extends lt.Option01 {
            constructor(dr) {
              super(ut, "change");
            }
          }
          class yt extends lt.XFAObject {
            constructor(dr) {
              super(ut, "common", !0), this.data = null, this.locale = null, this.localeSet = null, this.messaging = null, this.suppressBanner = null, this.template = null, this.validationMessaging = null, this.versionControl = null, this.log = new lt.XFAObjectArray();
            }
          }
          class Rt extends lt.XFAObject {
            constructor(dr) {
              super(ut, "compress"), this.scope = (0, et.getStringOption)(dr.scope, ["imageOnly", "document"]);
            }
          }
          class kt extends lt.Option01 {
            constructor(dr) {
              super(ut, "compressLogicalStructure");
            }
          }
          class jt extends lt.Option10 {
            constructor(dr) {
              super(ut, "compressObjectStream");
            }
          }
          class Ht extends lt.XFAObject {
            constructor(dr) {
              super(ut, "compression", !0), this.compressLogicalStructure = null, this.compressObjectStream = null, this.level = null, this.type = null;
            }
          }
          class Ft extends lt.XFAObject {
            constructor(dr) {
              super(ut, "config", !0), this.acrobat = null, this.present = null, this.trace = null, this.agent = new lt.XFAObjectArray();
            }
          }
          class _t extends lt.OptionObject {
            constructor(dr) {
              super(ut, "conformance", ["A", "B"]);
            }
          }
          class Nt extends lt.Option01 {
            constructor(dr) {
              super(ut, "contentCopy");
            }
          }
          class Mt extends lt.IntegerObject {
            constructor(dr) {
              super(ut, "copies", 1, (qr) => qr >= 1);
            }
          }
          class Lt extends lt.StringObject {
            constructor(dr) {
              super(ut, "creator");
            }
          }
          class $t extends lt.IntegerObject {
            constructor(dr) {
              super(ut, "currentPage", 0, (qr) => qr >= 0);
            }
          }
          class Tt extends lt.XFAObject {
            constructor(dr) {
              super(ut, "data", !0), this.adjustData = null, this.attributes = null, this.incrementalLoad = null, this.outputXSL = null, this.range = null, this.record = null, this.startNode = null, this.uri = null, this.window = null, this.xsl = null, this.excludeNS = new lt.XFAObjectArray(), this.transform = new lt.XFAObjectArray();
            }
          }
          class Dt extends lt.XFAObject {
            constructor(dr) {
              super(ut, "debug", !0), this.uri = null;
            }
          }
          class Ut extends lt.ContentObject {
            constructor(dr) {
              super(ut, "defaultTypeface"), this.writingScript = (0, et.getStringOption)(dr.writingScript, ["*", "Arabic", "Cyrillic", "EastEuropeanRoman", "Greek", "Hebrew", "Japanese", "Korean", "Roman", "SimplifiedChinese", "Thai", "TraditionalChinese", "Vietnamese"]);
            }
          }
          class Vt extends lt.OptionObject {
            constructor(dr) {
              super(ut, "destination", ["pdf", "pcl", "ps", "webClient", "zpl"]);
            }
          }
          class Qt extends lt.Option01 {
            constructor(dr) {
              super(ut, "documentAssembly");
            }
          }
          class qt extends lt.XFAObject {
            constructor(dr) {
              super(ut, "driver", !0), this.name = dr.name ? dr.name.trim() : "", this.fontInfo = null, this.xdc = null;
            }
          }
          class Zt extends lt.OptionObject {
            constructor(dr) {
              super(ut, "duplexOption", ["simplex", "duplexFlipLongEdge", "duplexFlipShortEdge"]);
            }
          }
          class ar extends lt.OptionObject {
            constructor(dr) {
              super(ut, "dynamicRender", ["forbidden", "required"]);
            }
          }
          class Jt extends lt.Option01 {
            constructor(dr) {
              super(ut, "embed");
            }
          }
          class rr extends lt.Option01 {
            constructor(dr) {
              super(ut, "encrypt");
            }
          }
          class Yt extends lt.XFAObject {
            constructor(dr) {
              super(ut, "encryption", !0), this.encrypt = null, this.encryptionLevel = null, this.permissions = null;
            }
          }
          class Kt extends lt.OptionObject {
            constructor(dr) {
              super(ut, "encryptionLevel", ["40bit", "128bit"]);
            }
          }
          class nr extends lt.StringObject {
            constructor(dr) {
              super(ut, "enforce");
            }
          }
          class tr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "equate"), this.force = (0, et.getInteger)({
                data: dr.force,
                defaultValue: 1,
                validate: (qr) => qr === 0
              }), this.from = dr.from || "", this.to = dr.to || "";
            }
          }
          class ir extends lt.XFAObject {
            constructor(dr) {
              super(ut, "equateRange"), this.from = dr.from || "", this.to = dr.to || "", this._unicodeRange = dr.unicodeRange || "";
            }
            get unicodeRange() {
              const dr = [], qr = /U\+([0-9a-fA-F]+)/, ln = this._unicodeRange;
              for (let cn of ln.split(",").map((xn) => xn.trim()).filter((xn) => !!xn))
                cn = cn.split("-", 2).map((xn) => {
                  const Sn = xn.match(qr);
                  return Sn ? parseInt(Sn[1], 16) : 0;
                }), cn.length === 1 && cn.push(cn[0]), dr.push(cn);
              return (0, it.shadow)(this, "unicodeRange", dr);
            }
          }
          class sr extends lt.ContentObject {
            constructor(dr) {
              super(ut, "exclude");
            }
            [st.$finalize]() {
              this[st.$content] = this[st.$content].trim().split(/\s+/).filter((dr) => dr && ["calculate", "close", "enter", "exit", "initialize", "ready", "validate"].includes(dr));
            }
          }
          class cr extends lt.StringObject {
            constructor(dr) {
              super(ut, "excludeNS");
            }
          }
          class or extends lt.OptionObject {
            constructor(dr) {
              super(ut, "flipLabel", ["usePrinterSetting", "on", "off"]);
            }
          }
          class Xt extends lt.XFAObject {
            constructor(dr) {
              super(ut, "fontInfo", !0), this.embed = null, this.map = null, this.subsetBelow = null, this.alwaysEmbed = new lt.XFAObjectArray(), this.defaultTypeface = new lt.XFAObjectArray(), this.neverEmbed = new lt.XFAObjectArray();
            }
          }
          class Gt extends lt.Option01 {
            constructor(dr) {
              super(ut, "formFieldFilling");
            }
          }
          class Wt extends lt.StringObject {
            constructor(dr) {
              super(ut, "groupParent");
            }
          }
          class er extends lt.OptionObject {
            constructor(dr) {
              super(ut, "ifEmpty", ["dataValue", "dataGroup", "ignore", "remove"]);
            }
          }
          class lr extends lt.StringObject {
            constructor(dr) {
              super(ut, "includeXDPContent");
            }
          }
          class ur extends lt.OptionObject {
            constructor(dr) {
              super(ut, "incrementalLoad", ["none", "forwardOnly"]);
            }
          }
          class pr extends lt.Option01 {
            constructor(dr) {
              super(ut, "incrementalMerge");
            }
          }
          class yr extends lt.Option01 {
            constructor(dr) {
              super(ut, "interactive");
            }
          }
          class Er extends lt.OptionObject {
            constructor(dr) {
              super(ut, "jog", ["usePrinterSetting", "none", "pageSet"]);
            }
          }
          class br extends lt.XFAObject {
            constructor(dr) {
              super(ut, "labelPrinter", !0), this.name = (0, et.getStringOption)(dr.name, ["zpl", "dpl", "ipl", "tcpl"]), this.batchOutput = null, this.flipLabel = null, this.fontInfo = null, this.xdc = null;
            }
          }
          class gr extends lt.OptionObject {
            constructor(dr) {
              super(ut, "layout", ["paginate", "panel"]);
            }
          }
          class Ar extends lt.IntegerObject {
            constructor(dr) {
              super(ut, "level", 0, (qr) => qr > 0);
            }
          }
          class Sr extends lt.Option01 {
            constructor(dr) {
              super(ut, "linearized");
            }
          }
          class Br extends lt.StringObject {
            constructor(dr) {
              super(ut, "locale");
            }
          }
          class Ir extends lt.StringObject {
            constructor(dr) {
              super(ut, "localeSet");
            }
          }
          class hr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "log", !0), this.mode = null, this.threshold = null, this.to = null, this.uri = null;
            }
          }
          class vr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "map", !0), this.equate = new lt.XFAObjectArray(), this.equateRange = new lt.XFAObjectArray();
            }
          }
          class xr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "mediumInfo", !0), this.map = null;
            }
          }
          class Pr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "message", !0), this.msgId = null, this.severity = null;
            }
          }
          class Rr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "messaging", !0), this.message = new lt.XFAObjectArray();
            }
          }
          class Dr extends lt.OptionObject {
            constructor(dr) {
              super(ut, "mode", ["append", "overwrite"]);
            }
          }
          class Gr extends lt.Option01 {
            constructor(dr) {
              super(ut, "modifyAnnots");
            }
          }
          class Or extends lt.IntegerObject {
            constructor(dr) {
              super(ut, "msgId", 1, (qr) => qr >= 1);
            }
          }
          class Hr extends lt.StringObject {
            constructor(dr) {
              super(ut, "nameAttr");
            }
          }
          class jr extends lt.ContentObject {
            constructor(dr) {
              super(ut, "neverEmbed");
            }
          }
          class Tr extends lt.IntegerObject {
            constructor(dr) {
              super(ut, "numberOfCopies", null, (qr) => qr >= 2 && qr <= 5);
            }
          }
          class fr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "openAction", !0), this.destination = null;
            }
          }
          class Cr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "output", !0), this.to = null, this.type = null, this.uri = null;
            }
          }
          class $r extends lt.StringObject {
            constructor(dr) {
              super(ut, "outputBin");
            }
          }
          class wr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "outputXSL", !0), this.uri = null;
            }
          }
          class Mr extends lt.OptionObject {
            constructor(dr) {
              super(ut, "overprint", ["none", "both", "draw", "field"]);
            }
          }
          class Fr extends lt.StringObject {
            constructor(dr) {
              super(ut, "packets");
            }
            [st.$finalize]() {
              this[st.$content] !== "*" && (this[st.$content] = this[st.$content].trim().split(/\s+/).filter((dr) => ["config", "datasets", "template", "xfdf", "xslt"].includes(dr)));
            }
          }
          class Qr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "pageOffset"), this.x = (0, et.getInteger)({
                data: dr.x,
                defaultValue: "useXDCSetting",
                validate: (qr) => !0
              }), this.y = (0, et.getInteger)({
                data: dr.y,
                defaultValue: "useXDCSetting",
                validate: (qr) => !0
              });
            }
          }
          class Yr extends lt.StringObject {
            constructor(dr) {
              super(ut, "pageRange");
            }
            [st.$finalize]() {
              const dr = this[st.$content].trim().split(/\s+/).map((ln) => parseInt(ln, 10)), qr = [];
              for (let ln = 0, cn = dr.length; ln < cn; ln += 2)
                qr.push(dr.slice(ln, ln + 2));
              this[st.$content] = qr;
            }
          }
          class kr extends lt.OptionObject {
            constructor(dr) {
              super(ut, "pagination", ["simplex", "duplexShortEdge", "duplexLongEdge"]);
            }
          }
          class Nr extends lt.OptionObject {
            constructor(dr) {
              super(ut, "paginationOverride", ["none", "forceDuplex", "forceDuplexLongEdge", "forceDuplexShortEdge", "forceSimplex"]);
            }
          }
          class Lr extends lt.IntegerObject {
            constructor(dr) {
              super(ut, "part", 1, (qr) => !1);
            }
          }
          class zr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "pcl", !0), this.name = dr.name || "", this.batchOutput = null, this.fontInfo = null, this.jog = null, this.mediumInfo = null, this.outputBin = null, this.pageOffset = null, this.staple = null, this.xdc = null;
            }
          }
          class Vr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "pdf", !0), this.name = dr.name || "", this.adobeExtensionLevel = null, this.batchOutput = null, this.compression = null, this.creator = null, this.encryption = null, this.fontInfo = null, this.interactive = null, this.linearized = null, this.openAction = null, this.pdfa = null, this.producer = null, this.renderPolicy = null, this.scriptModel = null, this.silentPrint = null, this.submitFormat = null, this.tagged = null, this.version = null, this.viewerPreferences = null, this.xdc = null;
            }
          }
          class an extends lt.XFAObject {
            constructor(dr) {
              super(ut, "pdfa", !0), this.amd = null, this.conformance = null, this.includeXDPContent = null, this.part = null;
            }
          }
          class Zr extends lt.XFAObject {
            constructor(dr) {
              super(ut, "permissions", !0), this.accessibleContent = null, this.change = null, this.contentCopy = null, this.documentAssembly = null, this.formFieldFilling = null, this.modifyAnnots = null, this.plaintextMetadata = null, this.print = null, this.printHighQuality = null;
            }
          }
          class un extends lt.Option01 {
            constructor(dr) {
              super(ut, "pickTrayByPDFSize");
            }
          }
          class Xr extends lt.StringObject {
            constructor(dr) {
              super(ut, "picture");
            }
          }
          class Kr extends lt.Option01 {
            constructor(dr) {
              super(ut, "plaintextMetadata");
            }
          }
          class rn extends lt.OptionObject {
            constructor(dr) {
              super(ut, "presence", ["preserve", "dissolve", "dissolveStructure", "ignore", "remove"]);
            }
          }
          class nn extends lt.XFAObject {
            constructor(dr) {
              super(ut, "present", !0), this.behaviorOverride = null, this.cache = null, this.common = null, this.copies = null, this.destination = null, this.incrementalMerge = null, this.layout = null, this.output = null, this.overprint = null, this.pagination = null, this.paginationOverride = null, this.script = null, this.validate = null, this.xdp = null, this.driver = new lt.XFAObjectArray(), this.labelPrinter = new lt.XFAObjectArray(), this.pcl = new lt.XFAObjectArray(), this.pdf = new lt.XFAObjectArray(), this.ps = new lt.XFAObjectArray(), this.submitUrl = new lt.XFAObjectArray(), this.webClient = new lt.XFAObjectArray(), this.zpl = new lt.XFAObjectArray();
            }
          }
          class sn extends lt.Option01 {
            constructor(dr) {
              super(ut, "print");
            }
          }
          class gn extends lt.Option01 {
            constructor(dr) {
              super(ut, "printHighQuality");
            }
          }
          class en extends lt.OptionObject {
            constructor(dr) {
              super(ut, "printScaling", ["appdefault", "noScaling"]);
            }
          }
          class Wr extends lt.StringObject {
            constructor(dr) {
              super(ut, "printerName");
            }
          }
          class dn extends lt.StringObject {
            constructor(dr) {
              super(ut, "producer");
            }
          }
          class hn extends lt.XFAObject {
            constructor(dr) {
              super(ut, "ps", !0), this.name = dr.name || "", this.batchOutput = null, this.fontInfo = null, this.jog = null, this.mediumInfo = null, this.outputBin = null, this.staple = null, this.xdc = null;
            }
          }
          class En extends lt.ContentObject {
            constructor(dr) {
              super(ut, "range");
            }
            [st.$finalize]() {
              this[st.$content] = this[st.$content].trim().split(/\s*,\s*/, 2).map((dr) => dr.split("-").map((qr) => parseInt(qr.trim(), 10))).filter((dr) => dr.every((qr) => !isNaN(qr))).map((dr) => (dr.length === 1 && dr.push(dr[0]), dr));
            }
          }
          class bn extends lt.ContentObject {
            constructor(dr) {
              super(ut, "record");
            }
            [st.$finalize]() {
              this[st.$content] = this[st.$content].trim();
              const dr = parseInt(this[st.$content], 10);
              !isNaN(dr) && dr >= 0 && (this[st.$content] = dr);
            }
          }
          class Cn extends lt.ContentObject {
            constructor(dr) {
              super(ut, "relevant");
            }
            [st.$finalize]() {
              this[st.$content] = this[st.$content].trim().split(/\s+/);
            }
          }
          class wn extends lt.ContentObject {
            constructor(dr) {
              super(ut, "rename");
            }
            [st.$finalize]() {
              this[st.$content] = this[st.$content].trim(), (this[st.$content].toLowerCase().startsWith("xml") || new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u").test(this[st.$content])) && (0, it.warn)("XFA - Rename: invalid XFA name");
            }
          }
          class vn extends lt.OptionObject {
            constructor(dr) {
              super(ut, "renderPolicy", ["server", "client"]);
            }
          }
          class fn extends lt.OptionObject {
            constructor(dr) {
              super(ut, "runScripts", ["both", "client", "none", "server"]);
            }
          }
          class on extends lt.XFAObject {
            constructor(dr) {
              super(ut, "script", !0), this.currentPage = null, this.exclude = null, this.runScripts = null;
            }
          }
          class pn extends lt.OptionObject {
            constructor(dr) {
              super(ut, "scriptModel", ["XFA", "none"]);
            }
          }
          class mn extends lt.OptionObject {
            constructor(dr) {
              super(ut, "severity", ["ignore", "error", "information", "trace", "warning"]);
            }
          }
          class Pn extends lt.XFAObject {
            constructor(dr) {
              super(ut, "silentPrint", !0), this.addSilentPrint = null, this.printerName = null;
            }
          }
          class An extends lt.XFAObject {
            constructor(dr) {
              super(ut, "staple"), this.mode = (0, et.getStringOption)(dr.mode, ["usePrinterSetting", "on", "off"]);
            }
          }
          class yn extends lt.StringObject {
            constructor(dr) {
              super(ut, "startNode");
            }
          }
          class Bn extends lt.IntegerObject {
            constructor(dr) {
              super(ut, "startPage", 0, (qr) => !0);
            }
          }
          class Fn extends lt.OptionObject {
            constructor(dr) {
              super(ut, "submitFormat", ["html", "delegate", "fdf", "xml", "pdf"]);
            }
          }
          class zn extends lt.StringObject {
            constructor(dr) {
              super(ut, "submitUrl");
            }
          }
          class Zn extends lt.IntegerObject {
            constructor(dr) {
              super(ut, "subsetBelow", 100, (qr) => qr >= 0 && qr <= 100);
            }
          }
          class to extends lt.Option01 {
            constructor(dr) {
              super(ut, "suppressBanner");
            }
          }
          class Mn extends lt.Option01 {
            constructor(dr) {
              super(ut, "tagged");
            }
          }
          class Nn extends lt.XFAObject {
            constructor(dr) {
              super(ut, "template", !0), this.base = null, this.relevant = null, this.startPage = null, this.uri = null, this.xsl = null;
            }
          }
          class Wn extends lt.OptionObject {
            constructor(dr) {
              super(ut, "threshold", ["trace", "error", "information", "warning"]);
            }
          }
          class ca extends lt.OptionObject {
            constructor(dr) {
              super(ut, "to", ["null", "memory", "stderr", "stdout", "system", "uri"]);
            }
          }
          class qn extends lt.XFAObject {
            constructor(dr) {
              super(ut, "templateCache"), this.maxEntries = (0, et.getInteger)({
                data: dr.maxEntries,
                defaultValue: 5,
                validate: (qr) => qr >= 0
              });
            }
          }
          class eo extends lt.XFAObject {
            constructor(dr) {
              super(ut, "trace", !0), this.area = new lt.XFAObjectArray();
            }
          }
          class ro extends lt.XFAObject {
            constructor(dr) {
              super(ut, "transform", !0), this.groupParent = null, this.ifEmpty = null, this.nameAttr = null, this.picture = null, this.presence = null, this.rename = null, this.whitespace = null;
            }
          }
          class ao extends lt.OptionObject {
            constructor(dr) {
              super(ut, "type", ["none", "ascii85", "asciiHex", "ccittfax", "flate", "lzw", "runLength", "native", "xdp", "mergedXDP"]);
            }
          }
          class so extends lt.StringObject {
            constructor(dr) {
              super(ut, "uri");
            }
          }
          class lo extends lt.OptionObject {
            constructor(dr) {
              super(ut, "validate", ["preSubmit", "prePrint", "preExecute", "preSave"]);
            }
          }
          class Ao extends lt.ContentObject {
            constructor(dr) {
              super(ut, "validateApprovalSignatures");
            }
            [st.$finalize]() {
              this[st.$content] = this[st.$content].trim().split(/\s+/).filter((dr) => ["docReady", "postSign"].includes(dr));
            }
          }
          class uo extends lt.OptionObject {
            constructor(dr) {
              super(ut, "validationMessaging", ["allMessagesIndividually", "allMessagesTogether", "firstMessageOnly", "noMessages"]);
            }
          }
          class wo extends lt.OptionObject {
            constructor(dr) {
              super(ut, "version", ["1.7", "1.6", "1.5", "1.4", "1.3", "1.2"]);
            }
          }
          class $o extends lt.XFAObject {
            constructor(dr) {
              super(ut, "VersionControl"), this.outputBelow = (0, et.getStringOption)(dr.outputBelow, ["warn", "error", "update"]), this.sourceAbove = (0, et.getStringOption)(dr.sourceAbove, ["warn", "error"]), this.sourceBelow = (0, et.getStringOption)(dr.sourceBelow, ["update", "maintain"]);
            }
          }
          class yo extends lt.XFAObject {
            constructor(dr) {
              super(ut, "viewerPreferences", !0), this.ADBE_JSConsole = null, this.ADBE_JSDebugger = null, this.addViewerPreferences = null, this.duplexOption = null, this.enforce = null, this.numberOfCopies = null, this.pageRange = null, this.pickTrayByPDFSize = null, this.printScaling = null;
            }
          }
          class Rn extends lt.XFAObject {
            constructor(dr) {
              super(ut, "webClient", !0), this.name = dr.name ? dr.name.trim() : "", this.fontInfo = null, this.xdc = null;
            }
          }
          class kn extends lt.OptionObject {
            constructor(dr) {
              super(ut, "whitespace", ["preserve", "ltrim", "normalize", "rtrim", "trim"]);
            }
          }
          class Yn extends lt.ContentObject {
            constructor(dr) {
              super(ut, "window");
            }
            [st.$finalize]() {
              const dr = this[st.$content].trim().split(/\s*,\s*/, 2).map((qr) => parseInt(qr, 10));
              if (dr.some((qr) => isNaN(qr))) {
                this[st.$content] = [0, 0];
                return;
              }
              dr.length === 1 && dr.push(dr[0]), this[st.$content] = dr;
            }
          }
          class _a extends lt.XFAObject {
            constructor(dr) {
              super(ut, "xdc", !0), this.uri = new lt.XFAObjectArray(), this.xsl = new lt.XFAObjectArray();
            }
          }
          class Qn extends lt.XFAObject {
            constructor(dr) {
              super(ut, "xdp", !0), this.packets = null;
            }
          }
          class Eo extends lt.XFAObject {
            constructor(dr) {
              super(ut, "xsl", !0), this.debug = null, this.uri = null;
            }
          }
          class vo extends lt.XFAObject {
            constructor(dr) {
              super(ut, "zpl", !0), this.name = dr.name ? dr.name.trim() : "", this.batchOutput = null, this.flipLabel = null, this.fontInfo = null, this.xdc = null;
            }
          }
          class Jr {
            static [rt.$buildXFAObject](dr, qr) {
              if (Jr.hasOwnProperty(dr))
                return Jr[dr](qr);
            }
            static acrobat(dr) {
              return new ft(dr);
            }
            static acrobat7(dr) {
              return new ht(dr);
            }
            static ADBE_JSConsole(dr) {
              return new dt(dr);
            }
            static ADBE_JSDebugger(dr) {
              return new gt(dr);
            }
            static addSilentPrint(dr) {
              return new pt(dr);
            }
            static addViewerPreferences(dr) {
              return new mt(dr);
            }
            static adjustData(dr) {
              return new ct(dr);
            }
            static adobeExtensionLevel(dr) {
              return new vt(dr);
            }
            static agent(dr) {
              return new At(dr);
            }
            static alwaysEmbed(dr) {
              return new xt(dr);
            }
            static amd(dr) {
              return new bt(dr);
            }
            static area(dr) {
              return new Et(dr);
            }
            static attributes(dr) {
              return new St(dr);
            }
            static autoSave(dr) {
              return new Bt(dr);
            }
            static base(dr) {
              return new Ot(dr);
            }
            static batchOutput(dr) {
              return new Pt(dr);
            }
            static behaviorOverride(dr) {
              return new wt(dr);
            }
            static cache(dr) {
              return new Ct(dr);
            }
            static change(dr) {
              return new It(dr);
            }
            static common(dr) {
              return new yt(dr);
            }
            static compress(dr) {
              return new Rt(dr);
            }
            static compressLogicalStructure(dr) {
              return new kt(dr);
            }
            static compressObjectStream(dr) {
              return new jt(dr);
            }
            static compression(dr) {
              return new Ht(dr);
            }
            static config(dr) {
              return new Ft(dr);
            }
            static conformance(dr) {
              return new _t(dr);
            }
            static contentCopy(dr) {
              return new Nt(dr);
            }
            static copies(dr) {
              return new Mt(dr);
            }
            static creator(dr) {
              return new Lt(dr);
            }
            static currentPage(dr) {
              return new $t(dr);
            }
            static data(dr) {
              return new Tt(dr);
            }
            static debug(dr) {
              return new Dt(dr);
            }
            static defaultTypeface(dr) {
              return new Ut(dr);
            }
            static destination(dr) {
              return new Vt(dr);
            }
            static documentAssembly(dr) {
              return new Qt(dr);
            }
            static driver(dr) {
              return new qt(dr);
            }
            static duplexOption(dr) {
              return new Zt(dr);
            }
            static dynamicRender(dr) {
              return new ar(dr);
            }
            static embed(dr) {
              return new Jt(dr);
            }
            static encrypt(dr) {
              return new rr(dr);
            }
            static encryption(dr) {
              return new Yt(dr);
            }
            static encryptionLevel(dr) {
              return new Kt(dr);
            }
            static enforce(dr) {
              return new nr(dr);
            }
            static equate(dr) {
              return new tr(dr);
            }
            static equateRange(dr) {
              return new ir(dr);
            }
            static exclude(dr) {
              return new sr(dr);
            }
            static excludeNS(dr) {
              return new cr(dr);
            }
            static flipLabel(dr) {
              return new or(dr);
            }
            static fontInfo(dr) {
              return new Xt(dr);
            }
            static formFieldFilling(dr) {
              return new Gt(dr);
            }
            static groupParent(dr) {
              return new Wt(dr);
            }
            static ifEmpty(dr) {
              return new er(dr);
            }
            static includeXDPContent(dr) {
              return new lr(dr);
            }
            static incrementalLoad(dr) {
              return new ur(dr);
            }
            static incrementalMerge(dr) {
              return new pr(dr);
            }
            static interactive(dr) {
              return new yr(dr);
            }
            static jog(dr) {
              return new Er(dr);
            }
            static labelPrinter(dr) {
              return new br(dr);
            }
            static layout(dr) {
              return new gr(dr);
            }
            static level(dr) {
              return new Ar(dr);
            }
            static linearized(dr) {
              return new Sr(dr);
            }
            static locale(dr) {
              return new Br(dr);
            }
            static localeSet(dr) {
              return new Ir(dr);
            }
            static log(dr) {
              return new hr(dr);
            }
            static map(dr) {
              return new vr(dr);
            }
            static mediumInfo(dr) {
              return new xr(dr);
            }
            static message(dr) {
              return new Pr(dr);
            }
            static messaging(dr) {
              return new Rr(dr);
            }
            static mode(dr) {
              return new Dr(dr);
            }
            static modifyAnnots(dr) {
              return new Gr(dr);
            }
            static msgId(dr) {
              return new Or(dr);
            }
            static nameAttr(dr) {
              return new Hr(dr);
            }
            static neverEmbed(dr) {
              return new jr(dr);
            }
            static numberOfCopies(dr) {
              return new Tr(dr);
            }
            static openAction(dr) {
              return new fr(dr);
            }
            static output(dr) {
              return new Cr(dr);
            }
            static outputBin(dr) {
              return new $r(dr);
            }
            static outputXSL(dr) {
              return new wr(dr);
            }
            static overprint(dr) {
              return new Mr(dr);
            }
            static packets(dr) {
              return new Fr(dr);
            }
            static pageOffset(dr) {
              return new Qr(dr);
            }
            static pageRange(dr) {
              return new Yr(dr);
            }
            static pagination(dr) {
              return new kr(dr);
            }
            static paginationOverride(dr) {
              return new Nr(dr);
            }
            static part(dr) {
              return new Lr(dr);
            }
            static pcl(dr) {
              return new zr(dr);
            }
            static pdf(dr) {
              return new Vr(dr);
            }
            static pdfa(dr) {
              return new an(dr);
            }
            static permissions(dr) {
              return new Zr(dr);
            }
            static pickTrayByPDFSize(dr) {
              return new un(dr);
            }
            static picture(dr) {
              return new Xr(dr);
            }
            static plaintextMetadata(dr) {
              return new Kr(dr);
            }
            static presence(dr) {
              return new rn(dr);
            }
            static present(dr) {
              return new nn(dr);
            }
            static print(dr) {
              return new sn(dr);
            }
            static printHighQuality(dr) {
              return new gn(dr);
            }
            static printScaling(dr) {
              return new en(dr);
            }
            static printerName(dr) {
              return new Wr(dr);
            }
            static producer(dr) {
              return new dn(dr);
            }
            static ps(dr) {
              return new hn(dr);
            }
            static range(dr) {
              return new En(dr);
            }
            static record(dr) {
              return new bn(dr);
            }
            static relevant(dr) {
              return new Cn(dr);
            }
            static rename(dr) {
              return new wn(dr);
            }
            static renderPolicy(dr) {
              return new vn(dr);
            }
            static runScripts(dr) {
              return new fn(dr);
            }
            static script(dr) {
              return new on(dr);
            }
            static scriptModel(dr) {
              return new pn(dr);
            }
            static severity(dr) {
              return new mn(dr);
            }
            static silentPrint(dr) {
              return new Pn(dr);
            }
            static staple(dr) {
              return new An(dr);
            }
            static startNode(dr) {
              return new yn(dr);
            }
            static startPage(dr) {
              return new Bn(dr);
            }
            static submitFormat(dr) {
              return new Fn(dr);
            }
            static submitUrl(dr) {
              return new zn(dr);
            }
            static subsetBelow(dr) {
              return new Zn(dr);
            }
            static suppressBanner(dr) {
              return new to(dr);
            }
            static tagged(dr) {
              return new Mn(dr);
            }
            static template(dr) {
              return new Nn(dr);
            }
            static templateCache(dr) {
              return new qn(dr);
            }
            static threshold(dr) {
              return new Wn(dr);
            }
            static to(dr) {
              return new ca(dr);
            }
            static trace(dr) {
              return new eo(dr);
            }
            static transform(dr) {
              return new ro(dr);
            }
            static type(dr) {
              return new ao(dr);
            }
            static uri(dr) {
              return new so(dr);
            }
            static validate(dr) {
              return new lo(dr);
            }
            static validateApprovalSignatures(dr) {
              return new Ao(dr);
            }
            static validationMessaging(dr) {
              return new uo(dr);
            }
            static version(dr) {
              return new wo(dr);
            }
            static versionControl(dr) {
              return new $o(dr);
            }
            static viewerPreferences(dr) {
              return new yo(dr);
            }
            static webClient(dr) {
              return new Rn(dr);
            }
            static whitespace(dr) {
              return new kn(dr);
            }
            static window(dr) {
              return new Yn(dr);
            }
            static xdc(dr) {
              return new _a(dr);
            }
            static xdp(dr) {
              return new Qn(dr);
            }
            static xsl(dr) {
              return new Eo(dr);
            }
            static zpl(dr) {
              return new vo(dr);
            }
          }
          at.ConfigNamespace = Jr;
        },
        /* 248 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.ConnectionSetNamespace = void 0;
          var rt = ot(235), st = ot(241);
          const lt = rt.NamespaceIds.connectionSet.id;
          class et extends st.XFAObject {
            constructor(Et) {
              super(lt, "connectionSet", !0), this.wsdlConnection = new st.XFAObjectArray(), this.xmlConnection = new st.XFAObjectArray(), this.xsdConnection = new st.XFAObjectArray();
            }
          }
          class it extends st.XFAObject {
            constructor(Et) {
              super(lt, "effectiveInputPolicy"), this.id = Et.id || "", this.name = Et.name || "", this.use = Et.use || "", this.usehref = Et.usehref || "";
            }
          }
          class ut extends st.XFAObject {
            constructor(Et) {
              super(lt, "effectiveOutputPolicy"), this.id = Et.id || "", this.name = Et.name || "", this.use = Et.use || "", this.usehref = Et.usehref || "";
            }
          }
          class ft extends st.StringObject {
            constructor(Et) {
              super(lt, "operation"), this.id = Et.id || "", this.input = Et.input || "", this.name = Et.name || "", this.output = Et.output || "", this.use = Et.use || "", this.usehref = Et.usehref || "";
            }
          }
          class ht extends st.StringObject {
            constructor(Et) {
              super(lt, "rootElement"), this.id = Et.id || "", this.name = Et.name || "", this.use = Et.use || "", this.usehref = Et.usehref || "";
            }
          }
          class dt extends st.StringObject {
            constructor(Et) {
              super(lt, "soapAction"), this.id = Et.id || "", this.name = Et.name || "", this.use = Et.use || "", this.usehref = Et.usehref || "";
            }
          }
          class gt extends st.StringObject {
            constructor(Et) {
              super(lt, "soapAddress"), this.id = Et.id || "", this.name = Et.name || "", this.use = Et.use || "", this.usehref = Et.usehref || "";
            }
          }
          class pt extends st.StringObject {
            constructor(Et) {
              super(lt, "uri"), this.id = Et.id || "", this.name = Et.name || "", this.use = Et.use || "", this.usehref = Et.usehref || "";
            }
          }
          class mt extends st.StringObject {
            constructor(Et) {
              super(lt, "wsdlAddress"), this.id = Et.id || "", this.name = Et.name || "", this.use = Et.use || "", this.usehref = Et.usehref || "";
            }
          }
          class ct extends st.XFAObject {
            constructor(Et) {
              super(lt, "wsdlConnection", !0), this.dataDescription = Et.dataDescription || "", this.name = Et.name || "", this.effectiveInputPolicy = null, this.effectiveOutputPolicy = null, this.operation = null, this.soapAction = null, this.soapAddress = null, this.wsdlAddress = null;
            }
          }
          class vt extends st.XFAObject {
            constructor(Et) {
              super(lt, "xmlConnection", !0), this.dataDescription = Et.dataDescription || "", this.name = Et.name || "", this.uri = null;
            }
          }
          class At extends st.XFAObject {
            constructor(Et) {
              super(lt, "xsdConnection", !0), this.dataDescription = Et.dataDescription || "", this.name = Et.name || "", this.rootElement = null, this.uri = null;
            }
          }
          class xt {
            static [rt.$buildXFAObject](Et, St) {
              if (xt.hasOwnProperty(Et))
                return xt[Et](St);
            }
            static connectionSet(Et) {
              return new et(Et);
            }
            static effectiveInputPolicy(Et) {
              return new it(Et);
            }
            static effectiveOutputPolicy(Et) {
              return new ut(Et);
            }
            static operation(Et) {
              return new ft(Et);
            }
            static rootElement(Et) {
              return new ht(Et);
            }
            static soapAction(Et) {
              return new dt(Et);
            }
            static soapAddress(Et) {
              return new gt(Et);
            }
            static uri(Et) {
              return new pt(Et);
            }
            static wsdlAddress(Et) {
              return new mt(Et);
            }
            static wsdlConnection(Et) {
              return new ct(Et);
            }
            static xmlConnection(Et) {
              return new vt(Et);
            }
            static xsdConnection(Et) {
              return new At(Et);
            }
          }
          at.ConnectionSetNamespace = xt;
        },
        /* 249 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.DatasetsNamespace = void 0;
          var rt = ot(229), st = ot(235), lt = ot(241);
          const et = st.NamespaceIds.datasets.id;
          class it extends lt.XmlObject {
            constructor(dt) {
              super(et, "data", dt);
            }
            [rt.$isNsAgnostic]() {
              return !0;
            }
          }
          class ut extends lt.XFAObject {
            constructor(dt) {
              super(et, "datasets", !0), this.data = null, this.Signature = null;
            }
            [rt.$onChild](dt) {
              const gt = dt[rt.$nodeName];
              (gt === "data" && dt[rt.$namespaceId] === et || gt === "Signature" && dt[rt.$namespaceId] === st.NamespaceIds.signature.id) && (this[gt] = dt), this[rt.$appendChild](dt);
            }
          }
          class ft {
            static [st.$buildXFAObject](dt, gt) {
              if (ft.hasOwnProperty(dt))
                return ft[dt](gt);
            }
            static datasets(dt) {
              return new ut(dt);
            }
            static data(dt) {
              return new it(dt);
            }
          }
          at.DatasetsNamespace = ft;
        },
        /* 250 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.LocaleSetNamespace = void 0;
          var rt = ot(235), st = ot(241), lt = ot(238);
          const et = rt.NamespaceIds.localeSet.id;
          class it extends st.XFAObject {
            constructor(Ft) {
              super(et, "calendarSymbols", !0), this.name = "gregorian", this.dayNames = new st.XFAObjectArray(2), this.eraNames = null, this.meridiemNames = null, this.monthNames = new st.XFAObjectArray(2);
            }
          }
          class ut extends st.StringObject {
            constructor(Ft) {
              super(et, "currencySymbol"), this.name = (0, lt.getStringOption)(Ft.name, ["symbol", "isoname", "decimal"]);
            }
          }
          class ft extends st.XFAObject {
            constructor(Ft) {
              super(et, "currencySymbols", !0), this.currencySymbol = new st.XFAObjectArray(3);
            }
          }
          class ht extends st.StringObject {
            constructor(Ft) {
              super(et, "datePattern"), this.name = (0, lt.getStringOption)(Ft.name, ["full", "long", "med", "short"]);
            }
          }
          class dt extends st.XFAObject {
            constructor(Ft) {
              super(et, "datePatterns", !0), this.datePattern = new st.XFAObjectArray(4);
            }
          }
          class gt extends st.ContentObject {
            constructor(Ft) {
              super(et, "dateTimeSymbols");
            }
          }
          class pt extends st.StringObject {
            constructor(Ft) {
              super(et, "day");
            }
          }
          class mt extends st.XFAObject {
            constructor(Ft) {
              super(et, "dayNames", !0), this.abbr = (0, lt.getInteger)({
                data: Ft.abbr,
                defaultValue: 0,
                validate: (_t) => _t === 1
              }), this.day = new st.XFAObjectArray(7);
            }
          }
          class ct extends st.StringObject {
            constructor(Ft) {
              super(et, "era");
            }
          }
          class vt extends st.XFAObject {
            constructor(Ft) {
              super(et, "eraNames", !0), this.era = new st.XFAObjectArray(2);
            }
          }
          class At extends st.XFAObject {
            constructor(Ft) {
              super(et, "locale", !0), this.desc = Ft.desc || "", this.name = "isoname", this.calendarSymbols = null, this.currencySymbols = null, this.datePatterns = null, this.dateTimeSymbols = null, this.numberPatterns = null, this.numberSymbols = null, this.timePatterns = null, this.typeFaces = null;
            }
          }
          class xt extends st.XFAObject {
            constructor(Ft) {
              super(et, "localeSet", !0), this.locale = new st.XFAObjectArray();
            }
          }
          class bt extends st.StringObject {
            constructor(Ft) {
              super(et, "meridiem");
            }
          }
          class Et extends st.XFAObject {
            constructor(Ft) {
              super(et, "meridiemNames", !0), this.meridiem = new st.XFAObjectArray(2);
            }
          }
          class St extends st.StringObject {
            constructor(Ft) {
              super(et, "month");
            }
          }
          class Bt extends st.XFAObject {
            constructor(Ft) {
              super(et, "monthNames", !0), this.abbr = (0, lt.getInteger)({
                data: Ft.abbr,
                defaultValue: 0,
                validate: (_t) => _t === 1
              }), this.month = new st.XFAObjectArray(12);
            }
          }
          class Ot extends st.StringObject {
            constructor(Ft) {
              super(et, "numberPattern"), this.name = (0, lt.getStringOption)(Ft.name, ["full", "long", "med", "short"]);
            }
          }
          class Pt extends st.XFAObject {
            constructor(Ft) {
              super(et, "numberPatterns", !0), this.numberPattern = new st.XFAObjectArray(4);
            }
          }
          class wt extends st.StringObject {
            constructor(Ft) {
              super(et, "numberSymbol"), this.name = (0, lt.getStringOption)(Ft.name, ["decimal", "grouping", "percent", "minus", "zero"]);
            }
          }
          class Ct extends st.XFAObject {
            constructor(Ft) {
              super(et, "numberSymbols", !0), this.numberSymbol = new st.XFAObjectArray(5);
            }
          }
          class It extends st.StringObject {
            constructor(Ft) {
              super(et, "timePattern"), this.name = (0, lt.getStringOption)(Ft.name, ["full", "long", "med", "short"]);
            }
          }
          class yt extends st.XFAObject {
            constructor(Ft) {
              super(et, "timePatterns", !0), this.timePattern = new st.XFAObjectArray(4);
            }
          }
          class Rt extends st.XFAObject {
            constructor(Ft) {
              super(et, "typeFace", !0), this.name = Ft.name | "";
            }
          }
          class kt extends st.XFAObject {
            constructor(Ft) {
              super(et, "typeFaces", !0), this.typeFace = new st.XFAObjectArray();
            }
          }
          class jt {
            static [rt.$buildXFAObject](Ft, _t) {
              if (jt.hasOwnProperty(Ft))
                return jt[Ft](_t);
            }
            static calendarSymbols(Ft) {
              return new it(Ft);
            }
            static currencySymbol(Ft) {
              return new ut(Ft);
            }
            static currencySymbols(Ft) {
              return new ft(Ft);
            }
            static datePattern(Ft) {
              return new ht(Ft);
            }
            static datePatterns(Ft) {
              return new dt(Ft);
            }
            static dateTimeSymbols(Ft) {
              return new gt(Ft);
            }
            static day(Ft) {
              return new pt(Ft);
            }
            static dayNames(Ft) {
              return new mt(Ft);
            }
            static era(Ft) {
              return new ct(Ft);
            }
            static eraNames(Ft) {
              return new vt(Ft);
            }
            static locale(Ft) {
              return new At(Ft);
            }
            static localeSet(Ft) {
              return new xt(Ft);
            }
            static meridiem(Ft) {
              return new bt(Ft);
            }
            static meridiemNames(Ft) {
              return new Et(Ft);
            }
            static month(Ft) {
              return new St(Ft);
            }
            static monthNames(Ft) {
              return new Bt(Ft);
            }
            static numberPattern(Ft) {
              return new Ot(Ft);
            }
            static numberPatterns(Ft) {
              return new Pt(Ft);
            }
            static numberSymbol(Ft) {
              return new wt(Ft);
            }
            static numberSymbols(Ft) {
              return new Ct(Ft);
            }
            static timePattern(Ft) {
              return new It(Ft);
            }
            static timePatterns(Ft) {
              return new yt(Ft);
            }
            static typeFace(Ft) {
              return new Rt(Ft);
            }
            static typeFaces(Ft) {
              return new kt(Ft);
            }
          }
          at.LocaleSetNamespace = jt;
        },
        /* 251 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.SignatureNamespace = void 0;
          var rt = ot(235), st = ot(241);
          const lt = rt.NamespaceIds.signature.id;
          class et extends st.XFAObject {
            constructor(ft) {
              super(lt, "signature", !0);
            }
          }
          class it {
            static [rt.$buildXFAObject](ft, ht) {
              if (it.hasOwnProperty(ft))
                return it[ft](ht);
            }
            static signature(ft) {
              return new et(ft);
            }
          }
          at.SignatureNamespace = it;
        },
        /* 252 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.StylesheetNamespace = void 0;
          var rt = ot(235), st = ot(241);
          const lt = rt.NamespaceIds.stylesheet.id;
          class et extends st.XFAObject {
            constructor(ft) {
              super(lt, "stylesheet", !0);
            }
          }
          class it {
            static [rt.$buildXFAObject](ft, ht) {
              if (it.hasOwnProperty(ft))
                return it[ft](ht);
            }
            static stylesheet(ft) {
              return new et(ft);
            }
          }
          at.StylesheetNamespace = it;
        },
        /* 253 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.XdpNamespace = void 0;
          var rt = ot(235), st = ot(229), lt = ot(241);
          const et = rt.NamespaceIds.xdp.id;
          class it extends lt.XFAObject {
            constructor(ht) {
              super(et, "xdp", !0), this.uuid = ht.uuid || "", this.timeStamp = ht.timeStamp || "", this.config = null, this.connectionSet = null, this.datasets = null, this.localeSet = null, this.stylesheet = new lt.XFAObjectArray(), this.template = null;
            }
            [st.$onChildCheck](ht) {
              const dt = rt.NamespaceIds[ht[st.$nodeName]];
              return dt && ht[st.$namespaceId] === dt.id;
            }
          }
          class ut {
            static [rt.$buildXFAObject](ht, dt) {
              if (ut.hasOwnProperty(ht))
                return ut[ht](dt);
            }
            static xdp(ht) {
              return new it(ht);
            }
          }
          at.XdpNamespace = ut;
        },
        /* 254 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.XhtmlNamespace = void 0, ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138);
          var rt = ot(229), st = ot(235), lt = ot(237), et = ot(238), it = ot(241);
          const ut = st.NamespaceIds.xhtml.id, ft = Symbol(), ht = /* @__PURE__ */ new Set(["color", "font", "font-family", "font-size", "font-stretch", "font-style", "font-weight", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "letter-spacing", "line-height", "orphans", "page-break-after", "page-break-before", "page-break-inside", "tab-interval", "tab-stop", "text-align", "text-decoration", "text-indent", "vertical-align", "widows", "kerning-mode", "xfa-font-horizontal-scale", "xfa-font-vertical-scale", "xfa-spacerun", "xfa-tab-stops"]), dt = /* @__PURE__ */ new Map([["page-break-after", "breakAfter"], ["page-break-before", "breakBefore"], ["page-break-inside", "breakInside"], ["kerning-mode", (Ft) => Ft === "none" ? "none" : "normal"], ["xfa-font-horizontal-scale", (Ft) => `scaleX(${Math.max(0, Math.min(parseInt(Ft) / 100)).toFixed(2)})`], ["xfa-font-vertical-scale", (Ft) => `scaleY(${Math.max(0, Math.min(parseInt(Ft) / 100)).toFixed(2)})`], ["xfa-spacerun", ""], ["xfa-tab-stops", ""], ["font-size", (Ft, _t) => (Ft = _t.fontSize = (0, et.getMeasurement)(Ft), (0, lt.measureToString)(0.99 * Ft))], ["letter-spacing", (Ft) => (0, lt.measureToString)((0, et.getMeasurement)(Ft))], ["line-height", (Ft) => (0, lt.measureToString)((0, et.getMeasurement)(Ft))], ["margin", (Ft) => (0, lt.measureToString)((0, et.getMeasurement)(Ft))], ["margin-bottom", (Ft) => (0, lt.measureToString)((0, et.getMeasurement)(Ft))], ["margin-left", (Ft) => (0, lt.measureToString)((0, et.getMeasurement)(Ft))], ["margin-right", (Ft) => (0, lt.measureToString)((0, et.getMeasurement)(Ft))], ["margin-top", (Ft) => (0, lt.measureToString)((0, et.getMeasurement)(Ft))], ["text-indent", (Ft) => (0, lt.measureToString)((0, et.getMeasurement)(Ft))], ["font-family", (Ft) => Ft], ["vertical-align", (Ft) => (0, lt.measureToString)((0, et.getMeasurement)(Ft))]]), gt = /\s+/g, pt = /[\r\n]+/g, mt = /\r\n?/g;
          function ct(Ft, _t, Nt) {
            const Mt = /* @__PURE__ */ Object.create(null);
            if (!Ft)
              return Mt;
            const Lt = /* @__PURE__ */ Object.create(null);
            for (const [$t, Tt] of Ft.split(";").map((Dt) => Dt.split(":", 2))) {
              const Dt = dt.get($t);
              if (Dt === "")
                continue;
              let Ut = Tt;
              Dt && (Ut = typeof Dt == "string" ? Dt : Dt(Tt, Lt)), $t.endsWith("scale") ? Mt.transform = Mt.transform ? `${Mt[$t]} ${Ut}` : Ut : Mt[$t.replaceAll(/-([a-zA-Z])/g, (Vt, Qt) => Qt.toUpperCase())] = Ut;
            }
            if (Mt.fontFamily && (0, lt.setFontFamily)({
              typeface: Mt.fontFamily,
              weight: Mt.fontWeight || "normal",
              posture: Mt.fontStyle || "normal",
              size: Lt.fontSize || 0
            }, _t, _t[rt.$globalData].fontFinder, Mt), Nt && Mt.verticalAlign && Mt.verticalAlign !== "0px" && Mt.fontSize) {
              const Dt = (0, et.getMeasurement)(Mt.fontSize);
              Mt.fontSize = (0, lt.measureToString)(Dt * 0.583), Mt.verticalAlign = (0, lt.measureToString)(Math.sign((0, et.getMeasurement)(Mt.verticalAlign)) * Dt * 0.333);
            }
            return Nt && Mt.fontSize && (Mt.fontSize = `calc(${Mt.fontSize} * var(--scale-factor))`), (0, lt.fixTextIndent)(Mt), Mt;
          }
          function vt(Ft) {
            return Ft.style ? Ft.style.trim().split(/\s*;\s*/).filter((_t) => !!_t).map((_t) => _t.split(/\s*:\s*/, 2)).filter((_t) => {
              let [Nt, Mt] = _t;
              return Nt === "font-family" && Ft[rt.$globalData].usedTypefaces.add(Mt), ht.has(Nt);
            }).map((_t) => _t.join(":")).join(";") : "";
          }
          const At = /* @__PURE__ */ new Set(["body", "html"]);
          class xt extends it.XmlObject {
            constructor(_t, Nt) {
              super(ut, Nt), this[ft] = !1, this.style = _t.style || "";
            }
            [rt.$clean](_t) {
              super[rt.$clean](_t), this.style = vt(this);
            }
            [rt.$acceptWhitespace]() {
              return !At.has(this[rt.$nodeName]);
            }
            [rt.$onText](_t) {
              (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) ? this[ft] = !0 : (_t = _t.replaceAll(pt, ""), this.style.includes("xfa-spacerun:yes") || (_t = _t.replaceAll(gt, " "))), _t && (this[rt.$content] += _t);
            }
            [rt.$pushGlyphs](_t) {
              let Nt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
              const Mt = /* @__PURE__ */ Object.create(null), Lt = {
                top: NaN,
                bottom: NaN,
                left: NaN,
                right: NaN
              };
              let $t = null;
              for (const [Tt, Dt] of this.style.split(";").map((Ut) => Ut.split(":", 2)))
                switch (Tt) {
                  case "font-family":
                    Mt.typeface = (0, et.stripQuotes)(Dt);
                    break;
                  case "font-size":
                    Mt.size = (0, et.getMeasurement)(Dt);
                    break;
                  case "font-weight":
                    Mt.weight = Dt;
                    break;
                  case "font-style":
                    Mt.posture = Dt;
                    break;
                  case "letter-spacing":
                    Mt.letterSpacing = (0, et.getMeasurement)(Dt);
                    break;
                  case "margin":
                    const Ut = Dt.split(/ \t/).map((Vt) => (0, et.getMeasurement)(Vt));
                    switch (Ut.length) {
                      case 1:
                        Lt.top = Lt.bottom = Lt.left = Lt.right = Ut[0];
                        break;
                      case 2:
                        Lt.top = Lt.bottom = Ut[0], Lt.left = Lt.right = Ut[1];
                        break;
                      case 3:
                        Lt.top = Ut[0], Lt.bottom = Ut[2], Lt.left = Lt.right = Ut[1];
                        break;
                      case 4:
                        Lt.top = Ut[0], Lt.left = Ut[1], Lt.bottom = Ut[2], Lt.right = Ut[3];
                        break;
                    }
                    break;
                  case "margin-top":
                    Lt.top = (0, et.getMeasurement)(Dt);
                    break;
                  case "margin-bottom":
                    Lt.bottom = (0, et.getMeasurement)(Dt);
                    break;
                  case "margin-left":
                    Lt.left = (0, et.getMeasurement)(Dt);
                    break;
                  case "margin-right":
                    Lt.right = (0, et.getMeasurement)(Dt);
                    break;
                  case "line-height":
                    $t = (0, et.getMeasurement)(Dt);
                    break;
                }
              if (_t.pushData(Mt, Lt, $t), this[rt.$content])
                _t.addString(this[rt.$content]);
              else
                for (const Tt of this[rt.$getChildren]()) {
                  if (Tt[rt.$nodeName] === "#text") {
                    _t.addString(Tt[rt.$content]);
                    continue;
                  }
                  Tt[rt.$pushGlyphs](_t);
                }
              Nt && _t.popFont();
            }
            [rt.$toHTML](_t) {
              const Nt = [];
              if (this[rt.$extra] = {
                children: Nt
              }, this[rt.$childrenToHTML]({}), Nt.length === 0 && !this[rt.$content])
                return et.HTMLResult.EMPTY;
              let Mt;
              return this[ft] ? Mt = this[rt.$content] ? this[rt.$content].replaceAll(mt, `
`) : void 0 : Mt = this[rt.$content] || void 0, et.HTMLResult.success({
                name: this[rt.$nodeName],
                attributes: {
                  href: this.href,
                  style: ct(this.style, this, this[ft])
                },
                children: Nt,
                value: Mt
              });
            }
          }
          class bt extends xt {
            constructor(_t) {
              super(_t, "a"), this.href = (0, lt.fixURL)(_t.href) || "";
            }
          }
          class Et extends xt {
            constructor(_t) {
              super(_t, "b");
            }
            [rt.$pushGlyphs](_t) {
              _t.pushFont({
                weight: "bold"
              }), super[rt.$pushGlyphs](_t), _t.popFont();
            }
          }
          class St extends xt {
            constructor(_t) {
              super(_t, "body");
            }
            [rt.$toHTML](_t) {
              const Nt = super[rt.$toHTML](_t), {
                html: Mt
              } = Nt;
              return Mt ? (Mt.name = "div", Mt.attributes.class = ["xfaRich"], Nt) : et.HTMLResult.EMPTY;
            }
          }
          class Bt extends xt {
            constructor(_t) {
              super(_t, "br");
            }
            [rt.$text]() {
              return `
`;
            }
            [rt.$pushGlyphs](_t) {
              _t.addString(`
`);
            }
            [rt.$toHTML](_t) {
              return et.HTMLResult.success({
                name: "br"
              });
            }
          }
          class Ot extends xt {
            constructor(_t) {
              super(_t, "html");
            }
            [rt.$toHTML](_t) {
              var Mt;
              const Nt = [];
              if (this[rt.$extra] = {
                children: Nt
              }, this[rt.$childrenToHTML]({}), Nt.length === 0)
                return et.HTMLResult.success({
                  name: "div",
                  attributes: {
                    class: ["xfaRich"],
                    style: {}
                  },
                  value: this[rt.$content] || ""
                });
              if (Nt.length === 1) {
                const Lt = Nt[0];
                if ((Mt = Lt.attributes) != null && Mt.class.includes("xfaRich"))
                  return et.HTMLResult.success(Lt);
              }
              return et.HTMLResult.success({
                name: "div",
                attributes: {
                  class: ["xfaRich"],
                  style: {}
                },
                children: Nt
              });
            }
          }
          class Pt extends xt {
            constructor(_t) {
              super(_t, "i");
            }
            [rt.$pushGlyphs](_t) {
              _t.pushFont({
                posture: "italic"
              }), super[rt.$pushGlyphs](_t), _t.popFont();
            }
          }
          class wt extends xt {
            constructor(_t) {
              super(_t, "li");
            }
          }
          class Ct extends xt {
            constructor(_t) {
              super(_t, "ol");
            }
          }
          class It extends xt {
            constructor(_t) {
              super(_t, "p");
            }
            [rt.$pushGlyphs](_t) {
              super[rt.$pushGlyphs](_t, !1), _t.addString(`
`), _t.addPara(), _t.popFont();
            }
            [rt.$text]() {
              return this[rt.$getParent]()[rt.$getChildren]().at(-1) === this ? super[rt.$text]() : super[rt.$text]() + `
`;
            }
          }
          class yt extends xt {
            constructor(_t) {
              super(_t, "span");
            }
          }
          class Rt extends xt {
            constructor(_t) {
              super(_t, "sub");
            }
          }
          class kt extends xt {
            constructor(_t) {
              super(_t, "sup");
            }
          }
          class jt extends xt {
            constructor(_t) {
              super(_t, "ul");
            }
          }
          class Ht {
            static [st.$buildXFAObject](_t, Nt) {
              if (Ht.hasOwnProperty(_t))
                return Ht[_t](Nt);
            }
            static a(_t) {
              return new bt(_t);
            }
            static b(_t) {
              return new Et(_t);
            }
            static body(_t) {
              return new St(_t);
            }
            static br(_t) {
              return new Bt(_t);
            }
            static html(_t) {
              return new Ot(_t);
            }
            static i(_t) {
              return new Pt(_t);
            }
            static li(_t) {
              return new wt(_t);
            }
            static ol(_t) {
              return new Ct(_t);
            }
            static p(_t) {
              return new It(_t);
            }
            static span(_t) {
              return new yt(_t);
            }
            static sub(_t) {
              return new Rt(_t);
            }
            static sup(_t) {
              return new kt(_t);
            }
            static ul(_t) {
              return new jt(_t);
            }
          }
          at.XhtmlNamespace = Ht;
        },
        /* 255 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.UnknownNamespace = void 0;
          var rt = ot(235), st = ot(241);
          class lt {
            constructor(it) {
              this.namespaceId = it;
            }
            [rt.$buildXFAObject](it, ut) {
              return new st.XmlObject(this.namespaceId, it, ut);
            }
          }
          at.UnknownNamespace = lt;
        },
        /* 256 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.DatasetReader = void 0, ot(2);
          var rt = ot(145), st = ot(150), lt = ot(222);
          function et(ft) {
            try {
              return (0, rt.stringToUTF8String)(ft);
            } catch (ht) {
              return (0, rt.warn)(`UTF-8 decoding failed: "${ht}".`), ft;
            }
          }
          class it extends lt.SimpleXMLParser {
            constructor(ht) {
              super(ht), this.node = null;
            }
            onEndElement(ht) {
              const dt = super.onEndElement(ht);
              if (dt && ht === "xfa:datasets")
                throw this.node = dt, new Error("Aborting DatasetXMLParser.");
            }
          }
          class ut {
            constructor(ht) {
              if (ht.datasets)
                this.node = new lt.SimpleXMLParser({
                  hasAttributes: !0
                }).parseFromString(ht.datasets).documentElement;
              else {
                const dt = new it({
                  hasAttributes: !0
                });
                try {
                  dt.parseFromString(ht["xdp:xdp"]);
                } catch {
                }
                this.node = dt.node;
              }
            }
            getValue(ht) {
              if (!this.node || !ht)
                return "";
              const dt = this.node.searchNode((0, st.parseXFAPath)(ht), 0);
              if (!dt)
                return "";
              const gt = dt.firstChild;
              return (gt == null ? void 0 : gt.nodeName) === "value" ? dt.children.map((pt) => et(pt.textContent)) : et(dt.textContent);
            }
          }
          at.DatasetReader = ut;
        },
        /* 257 */
        /***/
        (nt, at, ot) => {
          var ht;
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.XRef = void 0, ot(116), ot(127), ot(129), ot(132), ot(134), ot(136), ot(138), ot(84), ot(93), ot(94), ot(97), ot(99), ot(101), ot(105), ot(108), ot(115), ot(140), ot(2);
          var rt = ot(145), st = ot(151), lt = ot(167), et = ot(150), it = ot(152), ut = ot(225);
          class ft {
            constructor(gt, pt) {
              _r(this, ht, null);
              this.stream = gt, this.pdfManager = pt, this.entries = [], this._xrefStms = /* @__PURE__ */ new Set(), this._cacheMap = /* @__PURE__ */ new Map(), this._pendingRefs = new st.RefSet(), this._newPersistentRefNum = null, this._newTemporaryRefNum = null;
            }
            getNewPersistentRef(gt) {
              this._newPersistentRefNum === null && (this._newPersistentRefNum = this.entries.length || 1);
              const pt = this._newPersistentRefNum++;
              return this._cacheMap.set(pt, gt), st.Ref.get(pt, 0);
            }
            getNewTemporaryRef() {
              return this._newTemporaryRefNum === null && (this._newTemporaryRefNum = this.entries.length || 1), st.Ref.get(this._newTemporaryRefNum++, 0);
            }
            resetNewTemporaryRef() {
              this._newTemporaryRefNum = null;
            }
            setStartXRef(gt) {
              this.startXRefQueue = [gt];
            }
            parse() {
              let gt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, pt;
              gt ? ((0, rt.warn)("Indexing all PDF objects"), pt = this.indexObjects()) : pt = this.readXRef(), pt.assignXref(this), this.trailer = pt;
              let mt;
              try {
                mt = pt.get("Encrypt");
              } catch (vt) {
                if (vt instanceof et.MissingDataException)
                  throw vt;
                (0, rt.warn)(`XRef.parse - Invalid "Encrypt" reference: "${vt}".`);
              }
              if (mt instanceof st.Dict) {
                const vt = pt.get("ID"), At = vt != null && vt.length ? vt[0] : "";
                mt.suppressEncryption = !0, this.encrypt = new ut.CipherTransformFactory(mt, At, this.pdfManager.password);
              }
              let ct;
              try {
                ct = pt.get("Root");
              } catch (vt) {
                if (vt instanceof et.MissingDataException)
                  throw vt;
                (0, rt.warn)(`XRef.parse - Invalid "Root" reference: "${vt}".`);
              }
              if (ct instanceof st.Dict)
                try {
                  if (ct.get("Pages") instanceof st.Dict) {
                    this.root = ct;
                    return;
                  }
                } catch (vt) {
                  if (vt instanceof et.MissingDataException)
                    throw vt;
                  (0, rt.warn)(`XRef.parse - Invalid "Pages" reference: "${vt}".`);
                }
              throw gt ? new rt.InvalidPDFException("Invalid Root reference.") : new et.XRefParseException();
            }
            processXRefTable(gt) {
              "tableState" in this || (this.tableState = {
                entryNum: 0,
                streamPos: gt.lexer.stream.pos,
                parserBuf1: gt.buf1,
                parserBuf2: gt.buf2
              });
              const pt = this.readXRefTable(gt);
              if (!(0, st.isCmd)(pt, "trailer"))
                throw new rt.FormatError("Invalid XRef table: could not find trailer dictionary");
              let mt = gt.getObj();
              if (!(mt instanceof st.Dict) && mt.dict && (mt = mt.dict), !(mt instanceof st.Dict))
                throw new rt.FormatError("Invalid XRef table: could not parse trailer dictionary");
              return delete this.tableState, mt;
            }
            readXRefTable(gt) {
              const pt = gt.lexer.stream, mt = this.tableState;
              pt.pos = mt.streamPos, gt.buf1 = mt.parserBuf1, gt.buf2 = mt.parserBuf2;
              let ct;
              for (; ; ) {
                if (!("firstEntryNum" in mt) || !("entryCount" in mt)) {
                  if ((0, st.isCmd)(ct = gt.getObj(), "trailer"))
                    break;
                  mt.firstEntryNum = ct, mt.entryCount = gt.getObj();
                }
                let vt = mt.firstEntryNum;
                const At = mt.entryCount;
                if (!Number.isInteger(vt) || !Number.isInteger(At))
                  throw new rt.FormatError("Invalid XRef table: wrong types in subsection header");
                for (let xt = mt.entryNum; xt < At; xt++) {
                  mt.streamPos = pt.pos, mt.entryNum = xt, mt.parserBuf1 = gt.buf1, mt.parserBuf2 = gt.buf2;
                  const bt = {};
                  bt.offset = gt.getObj(), bt.gen = gt.getObj();
                  const Et = gt.getObj();
                  if (Et instanceof st.Cmd)
                    switch (Et.cmd) {
                      case "f":
                        bt.free = !0;
                        break;
                      case "n":
                        bt.uncompressed = !0;
                        break;
                    }
                  if (!Number.isInteger(bt.offset) || !Number.isInteger(bt.gen) || !(bt.free || bt.uncompressed))
                    throw new rt.FormatError(`Invalid entry in XRef subsection: ${vt}, ${At}`);
                  xt === 0 && bt.free && vt === 1 && (vt = 0), this.entries[xt + vt] || (this.entries[xt + vt] = bt);
                }
                mt.entryNum = 0, mt.streamPos = pt.pos, mt.parserBuf1 = gt.buf1, mt.parserBuf2 = gt.buf2, delete mt.firstEntryNum, delete mt.entryCount;
              }
              if (this.entries[0] && !this.entries[0].free)
                throw new rt.FormatError("Invalid XRef table: unexpected first object");
              return ct;
            }
            processXRefStream(gt) {
              if (!("streamState" in this)) {
                const pt = gt.dict, mt = pt.get("W");
                let ct = pt.get("Index");
                ct || (ct = [0, pt.get("Size")]), this.streamState = {
                  entryRanges: ct,
                  byteWidths: mt,
                  entryNum: 0,
                  streamPos: gt.pos
                };
              }
              return this.readXRefStream(gt), delete this.streamState, gt.dict;
            }
            readXRefStream(gt) {
              const pt = this.streamState;
              gt.pos = pt.streamPos;
              const [mt, ct, vt] = pt.byteWidths, At = pt.entryRanges;
              for (; At.length > 0; ) {
                const [xt, bt] = At;
                if (!Number.isInteger(xt) || !Number.isInteger(bt))
                  throw new rt.FormatError(`Invalid XRef range fields: ${xt}, ${bt}`);
                if (!Number.isInteger(mt) || !Number.isInteger(ct) || !Number.isInteger(vt))
                  throw new rt.FormatError(`Invalid XRef entry fields length: ${xt}, ${bt}`);
                for (let Et = pt.entryNum; Et < bt; ++Et) {
                  pt.entryNum = Et, pt.streamPos = gt.pos;
                  let St = 0, Bt = 0, Ot = 0;
                  for (let wt = 0; wt < mt; ++wt) {
                    const Ct = gt.getByte();
                    if (Ct === -1)
                      throw new rt.FormatError("Invalid XRef byteWidths 'type'.");
                    St = St << 8 | Ct;
                  }
                  mt === 0 && (St = 1);
                  for (let wt = 0; wt < ct; ++wt) {
                    const Ct = gt.getByte();
                    if (Ct === -1)
                      throw new rt.FormatError("Invalid XRef byteWidths 'offset'.");
                    Bt = Bt << 8 | Ct;
                  }
                  for (let wt = 0; wt < vt; ++wt) {
                    const Ct = gt.getByte();
                    if (Ct === -1)
                      throw new rt.FormatError("Invalid XRef byteWidths 'generation'.");
                    Ot = Ot << 8 | Ct;
                  }
                  const Pt = {};
                  switch (Pt.offset = Bt, Pt.gen = Ot, St) {
                    case 0:
                      Pt.free = !0;
                      break;
                    case 1:
                      Pt.uncompressed = !0;
                      break;
                    case 2:
                      break;
                    default:
                      throw new rt.FormatError(`Invalid XRef entry type: ${St}`);
                  }
                  this.entries[xt + Et] || (this.entries[xt + Et] = Pt);
                }
                pt.entryNum = 0, pt.streamPos = gt.pos, At.splice(0, 2);
              }
            }
            indexObjects() {
              function xt(Lt, $t) {
                let Tt = "", Dt = Lt[$t];
                for (; Dt !== 10 && Dt !== 13 && Dt !== 60 && !(++$t >= Lt.length); )
                  Tt += String.fromCharCode(Dt), Dt = Lt[$t];
                return Tt;
              }
              function bt(Lt, $t, Tt) {
                const Dt = Tt.length, Ut = Lt.length;
                let Vt = 0;
                for (; $t < Ut; ) {
                  let Qt = 0;
                  for (; Qt < Dt && Lt[$t + Qt] === Tt[Qt]; )
                    ++Qt;
                  if (Qt >= Dt)
                    break;
                  $t++, Vt++;
                }
                return Vt;
              }
              const Et = /\b(endobj|\d+\s+\d+\s+obj|xref|trailer\s*<<)\b/g, St = /\b(startxref|\d+\s+\d+\s+obj)\b/g, Bt = /^(\d+)\s+(\d+)\s+obj\b/, Ot = new Uint8Array([116, 114, 97, 105, 108, 101, 114]), Pt = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]), wt = new Uint8Array([47, 88, 82, 101, 102]);
              this.entries.length = 0, this._cacheMap.clear();
              const Ct = this.stream;
              Ct.pos = 0;
              const It = Ct.getBytes(), yt = (0, rt.bytesToString)(It), Rt = It.length;
              let kt = Ct.start;
              const jt = [], Ht = [];
              for (; kt < Rt; ) {
                let Lt = It[kt];
                if (Lt === 9 || Lt === 10 || Lt === 13 || Lt === 32) {
                  ++kt;
                  continue;
                }
                if (Lt === 37) {
                  do {
                    if (++kt, kt >= Rt)
                      break;
                    Lt = It[kt];
                  } while (Lt !== 10 && Lt !== 13);
                  continue;
                }
                const $t = xt(It, kt);
                let Tt;
                if ($t.startsWith("xref") && ($t.length === 4 || /\s/.test($t[4])))
                  kt += bt(It, kt, Ot), jt.push(kt), kt += bt(It, kt, Pt);
                else if (Tt = Bt.exec($t)) {
                  const Dt = Tt[1] | 0, Ut = Tt[2] | 0, Vt = kt + $t.length;
                  let Qt, qt = !1;
                  if (!this.entries[Dt])
                    qt = !0;
                  else if (this.entries[Dt].gen === Ut)
                    try {
                      new lt.Parser({
                        lexer: new lt.Lexer(Ct.makeSubStream(Vt))
                      }).getObj(), qt = !0;
                    } catch (rr) {
                      rr instanceof et.ParserEOFException ? (0, rt.warn)(`indexObjects -- checking object (${$t}): "${rr}".`) : qt = !0;
                    }
                  qt && (this.entries[Dt] = {
                    offset: kt - Ct.start,
                    gen: Ut,
                    uncompressed: !0
                  }), Et.lastIndex = Vt;
                  const Zt = Et.exec(yt);
                  Zt ? (Qt = Et.lastIndex + 1 - kt, Zt[1] !== "endobj" && ((0, rt.warn)(`indexObjects: Found "${Zt[1]}" inside of another "obj", caused by missing "endobj" -- trying to recover.`), Qt -= Zt[1].length + 1)) : Qt = Rt - kt;
                  const ar = It.subarray(kt, kt + Qt), Jt = bt(ar, 0, wt);
                  Jt < Qt && ar[Jt + 5] < 64 && (Ht.push(kt - Ct.start), this._xrefStms.add(kt - Ct.start)), kt += Qt;
                } else if ($t.startsWith("trailer") && ($t.length === 7 || /\s/.test($t[7]))) {
                  jt.push(kt);
                  const Dt = kt + $t.length;
                  let Ut;
                  St.lastIndex = Dt;
                  const Vt = St.exec(yt);
                  Vt ? (Ut = St.lastIndex + 1 - kt, Vt[1] !== "startxref" && ((0, rt.warn)(`indexObjects: Found "${Vt[1]}" after "trailer", caused by missing "startxref" -- trying to recover.`), Ut -= Vt[1].length + 1)) : Ut = Rt - kt, kt += Ut;
                } else
                  kt += $t.length + 1;
              }
              for (const Lt of Ht)
                this.startXRefQueue.push(Lt), this.readXRef(!0);
              const Ft = [];
              let _t = !1;
              for (const Lt of jt) {
                Ct.pos = Lt;
                const $t = new lt.Parser({
                  lexer: new lt.Lexer(Ct),
                  xref: this,
                  allowStreams: !0,
                  recoveryMode: !0
                }), Tt = $t.getObj();
                if (!(0, st.isCmd)(Tt, "trailer"))
                  continue;
                const Dt = $t.getObj();
                Dt instanceof st.Dict && (Ft.push(Dt), Dt.has("Encrypt") && (_t = !0));
              }
              let Nt, Mt;
              for (const Lt of [...Ft, "genFallback", ...Ft]) {
                if (Lt === "genFallback") {
                  if (!Mt)
                    break;
                  this._generationFallback = !0;
                  continue;
                }
                let $t = !1;
                try {
                  const Tt = Lt.get("Root");
                  if (!(Tt instanceof st.Dict))
                    continue;
                  const Dt = Tt.get("Pages");
                  if (!(Dt instanceof st.Dict))
                    continue;
                  const Ut = Dt.get("Count");
                  Number.isInteger(Ut) && ($t = !0);
                } catch (Tt) {
                  Mt = Tt;
                  continue;
                }
                if ($t && (!_t || Lt.has("Encrypt")) && Lt.has("ID"))
                  return Lt;
                Nt = Lt;
              }
              if (Nt)
                return Nt;
              if (this.topDict)
                return this.topDict;
              throw new rt.InvalidPDFException("Invalid PDF structure.");
            }
            readXRef() {
              let gt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              const pt = this.stream, mt = /* @__PURE__ */ new Set();
              for (; this.startXRefQueue.length; ) {
                try {
                  const ct = this.startXRefQueue[0];
                  if (mt.has(ct)) {
                    (0, rt.warn)("readXRef - skipping XRef table since it was already parsed."), this.startXRefQueue.shift();
                    continue;
                  }
                  mt.add(ct), pt.pos = ct + pt.start;
                  const vt = new lt.Parser({
                    lexer: new lt.Lexer(pt),
                    xref: this,
                    allowStreams: !0
                  });
                  let At = vt.getObj(), xt;
                  if ((0, st.isCmd)(At, "xref"))
                    xt = this.processXRefTable(vt), this.topDict || (this.topDict = xt), At = xt.get("XRefStm"), Number.isInteger(At) && !this._xrefStms.has(At) && (this._xrefStms.add(At), this.startXRefQueue.push(At), mr(this, ht) ?? tn(this, ht, At));
                  else if (Number.isInteger(At)) {
                    if (!Number.isInteger(vt.getObj()) || !(0, st.isCmd)(vt.getObj(), "obj") || !((At = vt.getObj()) instanceof it.BaseStream))
                      throw new rt.FormatError("Invalid XRef stream");
                    if (xt = this.processXRefStream(At), this.topDict || (this.topDict = xt), !xt)
                      throw new rt.FormatError("Failed to read XRef stream");
                  } else
                    throw new rt.FormatError("Invalid XRef stream header");
                  At = xt.get("Prev"), Number.isInteger(At) ? this.startXRefQueue.push(At) : At instanceof st.Ref && this.startXRefQueue.push(At.num);
                } catch (ct) {
                  if (ct instanceof et.MissingDataException)
                    throw ct;
                  (0, rt.info)("(while reading XRef): " + ct);
                }
                this.startXRefQueue.shift();
              }
              if (this.topDict)
                return this.topDict;
              if (!gt)
                throw new et.XRefParseException();
            }
            get lastXRefStreamPos() {
              return mr(this, ht) ?? (this._xrefStms.size > 0 ? Math.max(...this._xrefStms) : null);
            }
            getEntry(gt) {
              const pt = this.entries[gt];
              return pt && !pt.free && pt.offset ? pt : null;
            }
            fetchIfRef(gt) {
              let pt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
              return gt instanceof st.Ref ? this.fetch(gt, pt) : gt;
            }
            fetch(gt) {
              let pt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
              if (!(gt instanceof st.Ref))
                throw new Error("ref object is not a reference");
              const mt = gt.num, ct = this._cacheMap.get(mt);
              if (ct !== void 0)
                return ct instanceof st.Dict && !ct.objId && (ct.objId = gt.toString()), ct;
              let vt = this.getEntry(mt);
              if (vt === null)
                return this._cacheMap.set(mt, vt), vt;
              if (this._pendingRefs.has(gt))
                return this._pendingRefs.remove(gt), (0, rt.warn)(`Ignoring circular reference: ${gt}.`), st.CIRCULAR_REF;
              this._pendingRefs.put(gt);
              try {
                vt = vt.uncompressed ? this.fetchUncompressed(gt, vt, pt) : this.fetchCompressed(gt, vt, pt), this._pendingRefs.remove(gt);
              } catch (At) {
                throw this._pendingRefs.remove(gt), At;
              }
              return vt instanceof st.Dict ? vt.objId = gt.toString() : vt instanceof it.BaseStream && (vt.dict.objId = gt.toString()), vt;
            }
            fetchUncompressed(gt, pt) {
              let mt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
              const ct = gt.gen;
              let vt = gt.num;
              if (pt.gen !== ct) {
                const Bt = `Inconsistent generation in XRef: ${gt}`;
                if (this._generationFallback && pt.gen < ct)
                  return (0, rt.warn)(Bt), this.fetchUncompressed(st.Ref.get(vt, pt.gen), pt, mt);
                throw new et.XRefEntryException(Bt);
              }
              const At = this.stream.makeSubStream(pt.offset + this.stream.start), xt = new lt.Parser({
                lexer: new lt.Lexer(At),
                xref: this,
                allowStreams: !0
              }), bt = xt.getObj(), Et = xt.getObj(), St = xt.getObj();
              if (bt !== vt || Et !== ct || !(St instanceof st.Cmd))
                throw new et.XRefEntryException(`Bad (uncompressed) XRef entry: ${gt}`);
              if (St.cmd !== "obj") {
                if (St.cmd.startsWith("obj") && (vt = parseInt(St.cmd.substring(3), 10), !Number.isNaN(vt)))
                  return vt;
                throw new et.XRefEntryException(`Bad (uncompressed) XRef entry: ${gt}`);
              }
              return pt = this.encrypt && !mt ? xt.getObj(this.encrypt.createCipherTransform(vt, ct)) : xt.getObj(), pt instanceof it.BaseStream || this._cacheMap.set(vt, pt), pt;
            }
            fetchCompressed(gt, pt) {
              const mt = pt.offset, ct = this.fetch(st.Ref.get(mt, 0));
              if (!(ct instanceof it.BaseStream))
                throw new rt.FormatError("bad ObjStm stream");
              const vt = ct.dict.get("First"), At = ct.dict.get("N");
              if (!Number.isInteger(vt) || !Number.isInteger(At))
                throw new rt.FormatError("invalid first and n parameters for ObjStm stream");
              let xt = new lt.Parser({
                lexer: new lt.Lexer(ct),
                xref: this,
                allowStreams: !0
              });
              const bt = new Array(At), Et = new Array(At);
              for (let Ot = 0; Ot < At; ++Ot) {
                const Pt = xt.getObj();
                if (!Number.isInteger(Pt))
                  throw new rt.FormatError(`invalid object number in the ObjStm stream: ${Pt}`);
                const wt = xt.getObj();
                if (!Number.isInteger(wt))
                  throw new rt.FormatError(`invalid object offset in the ObjStm stream: ${wt}`);
                bt[Ot] = Pt, Et[Ot] = wt;
              }
              const St = (ct.start || 0) + vt, Bt = new Array(At);
              for (let Ot = 0; Ot < At; ++Ot) {
                const Pt = Ot < At - 1 ? Et[Ot + 1] - Et[Ot] : void 0;
                if (Pt < 0)
                  throw new rt.FormatError("Invalid offset in the ObjStm stream.");
                xt = new lt.Parser({
                  lexer: new lt.Lexer(ct.makeSubStream(St + Et[Ot], Pt, ct.dict)),
                  xref: this,
                  allowStreams: !0
                });
                const wt = xt.getObj();
                if (Bt[Ot] = wt, wt instanceof it.BaseStream)
                  continue;
                const Ct = bt[Ot], It = this.entries[Ct];
                It && It.offset === mt && It.gen === Ot && this._cacheMap.set(Ct, wt);
              }
              if (pt = Bt[pt.gen], pt === void 0)
                throw new et.XRefEntryException(`Bad (compressed) XRef entry: ${gt}`);
              return pt;
            }
            async fetchIfRefAsync(gt, pt) {
              return gt instanceof st.Ref ? this.fetchAsync(gt, pt) : gt;
            }
            async fetchAsync(gt, pt) {
              try {
                return this.fetch(gt, pt);
              } catch (mt) {
                if (!(mt instanceof et.MissingDataException))
                  throw mt;
                return await this.pdfManager.requestRange(mt.begin, mt.end), this.fetchAsync(gt, pt);
              }
            }
            getCatalogObj() {
              return this.root;
            }
          }
          ht = new WeakMap(), at.XRef = ft;
        },
        /* 258 */
        /***/
        (nt, at, ot) => {
          var ut, $l, ht, Il, gt, ns;
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.MessageHandler = void 0, ot(2);
          var rt = ot(145);
          const st = {
            UNKNOWN: 0,
            DATA: 1,
            ERROR: 2
          }, lt = {
            UNKNOWN: 0,
            CANCEL: 1,
            CANCEL_COMPLETE: 2,
            CLOSE: 3,
            ENQUEUE: 4,
            ERROR: 5,
            PULL: 6,
            PULL_COMPLETE: 7,
            START_COMPLETE: 8
          };
          function et(mt) {
            switch (mt instanceof Error || typeof mt == "object" && mt !== null || (0, rt.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), mt.name) {
              case "AbortException":
                return new rt.AbortException(mt.message);
              case "MissingPDFException":
                return new rt.MissingPDFException(mt.message);
              case "PasswordException":
                return new rt.PasswordException(mt.message, mt.code);
              case "UnexpectedResponseException":
                return new rt.UnexpectedResponseException(mt.message, mt.status);
              case "UnknownErrorException":
                return new rt.UnknownErrorException(mt.message, mt.details);
              default:
                return new rt.UnknownErrorException(mt.message, mt.toString());
            }
          }
          class it {
            constructor(ct, vt, At) {
              _r(this, ut);
              _r(this, ht);
              _r(this, gt);
              this.sourceName = ct, this.targetName = vt, this.comObj = At, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (xt) => {
                const bt = xt.data;
                if (bt.targetName !== this.sourceName)
                  return;
                if (bt.stream) {
                  Ur(this, ht, Il).call(this, bt);
                  return;
                }
                if (bt.callback) {
                  const St = bt.callbackId, Bt = this.callbackCapabilities[St];
                  if (!Bt)
                    throw new Error(`Cannot resolve callback ${St}`);
                  if (delete this.callbackCapabilities[St], bt.callback === st.DATA)
                    Bt.resolve(bt.data);
                  else if (bt.callback === st.ERROR)
                    Bt.reject(et(bt.reason));
                  else
                    throw new Error("Unexpected callback case");
                  return;
                }
                const Et = this.actionHandler[bt.action];
                if (!Et)
                  throw new Error(`Unknown action from worker: ${bt.action}`);
                if (bt.callbackId) {
                  const St = this.sourceName, Bt = bt.sourceName;
                  new Promise(function(Ot) {
                    Ot(Et(bt.data));
                  }).then(function(Ot) {
                    At.postMessage({
                      sourceName: St,
                      targetName: Bt,
                      callback: st.DATA,
                      callbackId: bt.callbackId,
                      data: Ot
                    });
                  }, function(Ot) {
                    At.postMessage({
                      sourceName: St,
                      targetName: Bt,
                      callback: st.ERROR,
                      callbackId: bt.callbackId,
                      reason: et(Ot)
                    });
                  });
                  return;
                }
                if (bt.streamId) {
                  Ur(this, ut, $l).call(this, bt);
                  return;
                }
                Et(bt.data);
              }, At.addEventListener("message", this._onComObjOnMessage);
            }
            on(ct, vt) {
              const At = this.actionHandler;
              if (At[ct])
                throw new Error(`There is already an actionName called "${ct}"`);
              At[ct] = vt;
            }
            send(ct, vt, At) {
              this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: ct,
                data: vt
              }, At);
            }
            sendWithPromise(ct, vt, At) {
              const xt = this.callbackId++, bt = new rt.PromiseCapability();
              this.callbackCapabilities[xt] = bt;
              try {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: ct,
                  callbackId: xt,
                  data: vt
                }, At);
              } catch (Et) {
                bt.reject(Et);
              }
              return bt.promise;
            }
            sendWithStream(ct, vt, At, xt) {
              const bt = this.streamId++, Et = this.sourceName, St = this.targetName, Bt = this.comObj;
              return new ReadableStream({
                start: (Ot) => {
                  const Pt = new rt.PromiseCapability();
                  return this.streamControllers[bt] = {
                    controller: Ot,
                    startCall: Pt,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: !1
                  }, Bt.postMessage({
                    sourceName: Et,
                    targetName: St,
                    action: ct,
                    streamId: bt,
                    data: vt,
                    desiredSize: Ot.desiredSize
                  }, xt), Pt.promise;
                },
                pull: (Ot) => {
                  const Pt = new rt.PromiseCapability();
                  return this.streamControllers[bt].pullCall = Pt, Bt.postMessage({
                    sourceName: Et,
                    targetName: St,
                    stream: lt.PULL,
                    streamId: bt,
                    desiredSize: Ot.desiredSize
                  }), Pt.promise;
                },
                cancel: (Ot) => {
                  (0, rt.assert)(Ot instanceof Error, "cancel must have a valid reason");
                  const Pt = new rt.PromiseCapability();
                  return this.streamControllers[bt].cancelCall = Pt, this.streamControllers[bt].isClosed = !0, Bt.postMessage({
                    sourceName: Et,
                    targetName: St,
                    stream: lt.CANCEL,
                    streamId: bt,
                    reason: et(Ot)
                  }), Pt.promise;
                }
              }, At);
            }
            destroy() {
              this.comObj.removeEventListener("message", this._onComObjOnMessage);
            }
          }
          ut = new WeakSet(), $l = function(ct) {
            const vt = ct.streamId, At = this.sourceName, xt = ct.sourceName, bt = this.comObj, Et = this, St = this.actionHandler[ct.action], Bt = {
              enqueue(Ot) {
                let Pt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, wt = arguments.length > 2 ? arguments[2] : void 0;
                if (this.isCancelled)
                  return;
                const Ct = this.desiredSize;
                this.desiredSize -= Pt, Ct > 0 && this.desiredSize <= 0 && (this.sinkCapability = new rt.PromiseCapability(), this.ready = this.sinkCapability.promise), bt.postMessage({
                  sourceName: At,
                  targetName: xt,
                  stream: lt.ENQUEUE,
                  streamId: vt,
                  chunk: Ot
                }, wt);
              },
              close() {
                this.isCancelled || (this.isCancelled = !0, bt.postMessage({
                  sourceName: At,
                  targetName: xt,
                  stream: lt.CLOSE,
                  streamId: vt
                }), delete Et.streamSinks[vt]);
              },
              error(Ot) {
                (0, rt.assert)(Ot instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, bt.postMessage({
                  sourceName: At,
                  targetName: xt,
                  stream: lt.ERROR,
                  streamId: vt,
                  reason: et(Ot)
                }));
              },
              sinkCapability: new rt.PromiseCapability(),
              onPull: null,
              onCancel: null,
              isCancelled: !1,
              desiredSize: ct.desiredSize,
              ready: null
            };
            Bt.sinkCapability.resolve(), Bt.ready = Bt.sinkCapability.promise, this.streamSinks[vt] = Bt, new Promise(function(Ot) {
              Ot(St(ct.data, Bt));
            }).then(function() {
              bt.postMessage({
                sourceName: At,
                targetName: xt,
                stream: lt.START_COMPLETE,
                streamId: vt,
                success: !0
              });
            }, function(Ot) {
              bt.postMessage({
                sourceName: At,
                targetName: xt,
                stream: lt.START_COMPLETE,
                streamId: vt,
                reason: et(Ot)
              });
            });
          }, ht = new WeakSet(), Il = function(ct) {
            const vt = ct.streamId, At = this.sourceName, xt = ct.sourceName, bt = this.comObj, Et = this.streamControllers[vt], St = this.streamSinks[vt];
            switch (ct.stream) {
              case lt.START_COMPLETE:
                ct.success ? Et.startCall.resolve() : Et.startCall.reject(et(ct.reason));
                break;
              case lt.PULL_COMPLETE:
                ct.success ? Et.pullCall.resolve() : Et.pullCall.reject(et(ct.reason));
                break;
              case lt.PULL:
                if (!St) {
                  bt.postMessage({
                    sourceName: At,
                    targetName: xt,
                    stream: lt.PULL_COMPLETE,
                    streamId: vt,
                    success: !0
                  });
                  break;
                }
                St.desiredSize <= 0 && ct.desiredSize > 0 && St.sinkCapability.resolve(), St.desiredSize = ct.desiredSize, new Promise(function(Bt) {
                  var Ot;
                  Bt((Ot = St.onPull) == null ? void 0 : Ot.call(St));
                }).then(function() {
                  bt.postMessage({
                    sourceName: At,
                    targetName: xt,
                    stream: lt.PULL_COMPLETE,
                    streamId: vt,
                    success: !0
                  });
                }, function(Bt) {
                  bt.postMessage({
                    sourceName: At,
                    targetName: xt,
                    stream: lt.PULL_COMPLETE,
                    streamId: vt,
                    reason: et(Bt)
                  });
                });
                break;
              case lt.ENQUEUE:
                if ((0, rt.assert)(Et, "enqueue should have stream controller"), Et.isClosed)
                  break;
                Et.controller.enqueue(ct.chunk);
                break;
              case lt.CLOSE:
                if ((0, rt.assert)(Et, "close should have stream controller"), Et.isClosed)
                  break;
                Et.isClosed = !0, Et.controller.close(), Ur(this, gt, ns).call(this, Et, vt);
                break;
              case lt.ERROR:
                (0, rt.assert)(Et, "error should have stream controller"), Et.controller.error(et(ct.reason)), Ur(this, gt, ns).call(this, Et, vt);
                break;
              case lt.CANCEL_COMPLETE:
                ct.success ? Et.cancelCall.resolve() : Et.cancelCall.reject(et(ct.reason)), Ur(this, gt, ns).call(this, Et, vt);
                break;
              case lt.CANCEL:
                if (!St)
                  break;
                new Promise(function(Bt) {
                  var Ot;
                  Bt((Ot = St.onCancel) == null ? void 0 : Ot.call(St, et(ct.reason)));
                }).then(function() {
                  bt.postMessage({
                    sourceName: At,
                    targetName: xt,
                    stream: lt.CANCEL_COMPLETE,
                    streamId: vt,
                    success: !0
                  });
                }, function(Bt) {
                  bt.postMessage({
                    sourceName: At,
                    targetName: xt,
                    stream: lt.CANCEL_COMPLETE,
                    streamId: vt,
                    reason: et(Bt)
                  });
                }), St.sinkCapability.reject(et(ct.reason)), St.isCancelled = !0, delete this.streamSinks[vt];
                break;
              default:
                throw new Error("Unexpected stream case");
            }
          }, gt = new WeakSet(), ns = async function(ct, vt) {
            var At, xt, bt;
            await Promise.allSettled([(At = ct.startCall) == null ? void 0 : At.promise, (xt = ct.pullCall) == null ? void 0 : xt.promise, (bt = ct.cancelCall) == null ? void 0 : bt.promise]), delete this.streamControllers[vt];
          }, at.MessageHandler = it;
        },
        /* 259 */
        /***/
        (nt, at, ot) => {
          Object.defineProperty(at, "__esModule", {
            value: !0
          }), at.PDFWorkerStream = void 0, ot(140);
          var rt = ot(145);
          class st {
            constructor(ut) {
              this._msgHandler = ut, this._contentLength = null, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            getFullReader() {
              return (0, rt.assert)(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once."), this._fullRequestReader = new lt(this._msgHandler), this._fullRequestReader;
            }
            getRangeReader(ut, ft) {
              const ht = new et(ut, ft, this._msgHandler);
              return this._rangeRequestReaders.push(ht), ht;
            }
            cancelAllRequests(ut) {
              var ft;
              (ft = this._fullRequestReader) == null || ft.cancel(ut);
              for (const ht of this._rangeRequestReaders.slice(0))
                ht.cancel(ut);
            }
          }
          at.PDFWorkerStream = st;
          class lt {
            constructor(ut) {
              this._msgHandler = ut, this.onProgress = null, this._contentLength = null, this._isRangeSupported = !1, this._isStreamingSupported = !1;
              const ft = this._msgHandler.sendWithStream("GetReader");
              this._reader = ft.getReader(), this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then((ht) => {
                this._isStreamingSupported = ht.isStreamingSupported, this._isRangeSupported = ht.isRangeSupported, this._contentLength = ht.contentLength;
              });
            }
            get headersReady() {
              return this._headersReady;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            async read() {
              const {
                value: ut,
                done: ft
              } = await this._reader.read();
              return ft ? {
                value: void 0,
                done: !0
              } : {
                value: ut.buffer,
                done: !1
              };
            }
            cancel(ut) {
              this._reader.cancel(ut);
            }
          }
          class et {
            constructor(ut, ft, ht) {
              this._msgHandler = ht, this.onProgress = null;
              const dt = this._msgHandler.sendWithStream("GetRangeReader", {
                begin: ut,
                end: ft
              });
              this._reader = dt.getReader();
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              const {
                value: ut,
                done: ft
              } = await this._reader.read();
              return ft ? {
                value: void 0,
                done: !0
              } : {
                value: ut.buffer,
                done: !1
              };
            }
            cancel(ut) {
              this._reader.cancel(ut);
            }
          }
        }
        /******/
      ], _ = {};
      function _e(nt) {
        var at = _[nt];
        if (at !== void 0)
          return at.exports;
        var ot = _[nt] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return $[nt].call(ot.exports, ot, ot.exports, _e), ot.exports;
      }
      var tt = {};
      return (() => {
        var nt = tt;
        Object.defineProperty(nt, "__esModule", {
          value: !0
        }), Object.defineProperty(nt, "WorkerMessageHandler", {
          enumerable: !0,
          get: function() {
            return at.WorkerMessageHandler;
          }
        });
        var at = _e(1);
      })(), tt;
    })()
  ));
})(pdf_worker);
var pdf_workerExports = pdf_worker.exports;
(typeof window < "u" ? window : {}).pdfjsWorker = pdf_workerExports;
function commonjsRequire(a) {
  throw new Error('Could not dynamically require "' + a + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pdf$1 = { exports: {} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$6 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var path2dPolyfill_esm = {}, hasRequiredPath2dPolyfill_esm;
function requirePath2dPolyfill_esm() {
  if (hasRequiredPath2dPolyfill_esm)
    return path2dPolyfill_esm;
  hasRequiredPath2dPolyfill_esm = 1;
  function a(ut, ft, ht) {
    if (ht || arguments.length === 2)
      for (var dt = 0, gt = ft.length, pt; dt < gt; dt++)
        (pt || !(dt in ft)) && (pt || (pt = Array.prototype.slice.call(ft, 0, dt)), pt[dt] = ft[dt]);
    return ut.concat(pt || Array.prototype.slice.call(ft));
  }
  var s = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
  }, $ = /([astvzqmhlc])([^astvzqmhlc]*)/gi, _ = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
  function _e(ut) {
    var ft = ut.match(_);
    return ft ? ft.map(Number) : [];
  }
  function tt(ut) {
    var ft = [], ht = String(ut).trim();
    return ht[0] !== "M" && ht[0] !== "m" || ht.replace($, function(dt, gt, pt) {
      var mt = _e(pt), ct = gt.toLowerCase(), vt = gt;
      if (ct === "m" && mt.length > 2 && (ft.push(a([vt], mt.splice(0, 2), !0)), ct = "l", vt = vt === "m" ? "l" : "L"), mt.length < s[ct])
        return "";
      for (ft.push(a([vt], mt.splice(0, s[ct]), !0)); mt.length >= s[ct] && mt.length && s[ct]; )
        ft.push(a([vt], mt.splice(0, s[ct]), !0));
      return "";
    }), ft;
  }
  function nt(ut, ft) {
    var ht = ut.x * Math.cos(ft) - ut.y * Math.sin(ft), dt = ut.y * Math.cos(ft) + ut.x * Math.sin(ft);
    ut.x = ht, ut.y = dt;
  }
  function at(ut, ft, ht) {
    ut.x += ft, ut.y += ht;
  }
  function ot(ut, ft) {
    ut.x *= ft, ut.y *= ft;
  }
  var rt = (
    /** @class */
    function() {
      function ut(ft) {
        var ht;
        this.commands = [], ft && ft instanceof ut ? (ht = this.commands).push.apply(ht, ft.commands) : ft && (this.commands = tt(ft));
      }
      return ut.prototype.addPath = function(ft) {
        var ht;
        ft && ft instanceof ut && (ht = this.commands).push.apply(ht, ft.commands);
      }, ut.prototype.moveTo = function(ft, ht) {
        this.commands.push(["M", ft, ht]);
      }, ut.prototype.lineTo = function(ft, ht) {
        this.commands.push(["L", ft, ht]);
      }, ut.prototype.arc = function(ft, ht, dt, gt, pt, mt) {
        this.commands.push(["AC", ft, ht, dt, gt, pt, !!mt]);
      }, ut.prototype.arcTo = function(ft, ht, dt, gt, pt) {
        this.commands.push(["AT", ft, ht, dt, gt, pt]);
      }, ut.prototype.ellipse = function(ft, ht, dt, gt, pt, mt, ct, vt) {
        this.commands.push(["E", ft, ht, dt, gt, pt, mt, ct, !!vt]);
      }, ut.prototype.closePath = function() {
        this.commands.push(["Z"]);
      }, ut.prototype.bezierCurveTo = function(ft, ht, dt, gt, pt, mt) {
        this.commands.push(["C", ft, ht, dt, gt, pt, mt]);
      }, ut.prototype.quadraticCurveTo = function(ft, ht, dt, gt) {
        this.commands.push(["Q", ft, ht, dt, gt]);
      }, ut.prototype.rect = function(ft, ht, dt, gt) {
        this.commands.push(["R", ft, ht, dt, gt]);
      }, ut.prototype.roundRect = function(ft, ht, dt, gt, pt) {
        typeof pt > "u" ? this.commands.push(["RR", ft, ht, dt, gt, 0]) : this.commands.push(["RR", ft, ht, dt, gt, pt]);
      }, ut;
    }()
  );
  function st(ut, ft) {
    var ht = 0, dt = 0, gt, pt, mt, ct, vt, At, xt, bt, Et, St, Bt, Ot, Pt, wt, Ct, It, yt, Rt, kt, jt, Ht, Ft = null, _t = null, Nt = null, Mt = null, Lt = null, $t = null;
    ut.beginPath();
    for (var Tt = 0; Tt < ft.length; ++Tt) {
      Rt = ft[Tt][0], Rt !== "S" && Rt !== "s" && Rt !== "C" && Rt !== "c" && (Ft = null, _t = null), Rt !== "T" && Rt !== "t" && Rt !== "Q" && Rt !== "q" && (Nt = null, Mt = null);
      var Dt = void 0;
      switch (Rt) {
        case "m":
        case "M":
          Dt = ft[Tt], Rt === "m" ? (ht += Dt[1], dt += Dt[2]) : (ht = Dt[1], dt = Dt[2]), (Rt === "M" || !Lt) && (Lt = { x: ht, y: dt }), ut.moveTo(ht, dt);
          break;
        case "l":
          Dt = ft[Tt], ht += Dt[1], dt += Dt[2], ut.lineTo(ht, dt);
          break;
        case "L":
          Dt = ft[Tt], ht = Dt[1], dt = Dt[2], ut.lineTo(ht, dt);
          break;
        case "H":
          Dt = ft[Tt], ht = Dt[1], ut.lineTo(ht, dt);
          break;
        case "h":
          Dt = ft[Tt], ht += Dt[1], ut.lineTo(ht, dt);
          break;
        case "V":
          Dt = ft[Tt], dt = Dt[1], ut.lineTo(ht, dt);
          break;
        case "v":
          Dt = ft[Tt], dt += Dt[1], ut.lineTo(ht, dt);
          break;
        case "a":
        case "A":
          if (Dt = ft[Tt], $t === null)
            throw new Error("This should never happen");
          Rt === "a" ? (ht += Dt[6], dt += Dt[7]) : (ht = Dt[6], dt = Dt[7]), wt = Dt[1], Ct = Dt[2], xt = Dt[3] * Math.PI / 180, mt = !!Dt[4], ct = !!Dt[5], vt = { x: ht, y: dt }, At = {
            x: ($t.x - vt.x) / 2,
            y: ($t.y - vt.y) / 2
          }, nt(At, -xt), bt = At.x * At.x / (wt * wt) + At.y * At.y / (Ct * Ct), bt > 1 && (bt = Math.sqrt(bt), wt *= bt, Ct *= bt), kt = {
            x: wt * At.y / Ct,
            y: -(Ct * At.x) / wt
          }, Et = wt * wt * Ct * Ct, St = wt * wt * At.y * At.y + Ct * Ct * At.x * At.x, ct !== mt ? ot(kt, Math.sqrt((Et - St) / St) || 0) : ot(kt, -Math.sqrt((Et - St) / St) || 0), pt = Math.atan2((At.y - kt.y) / Ct, (At.x - kt.x) / wt), gt = Math.atan2(-(At.y + kt.y) / Ct, -(At.x + kt.x) / wt), nt(kt, xt), at(kt, (vt.x + $t.x) / 2, (vt.y + $t.y) / 2), ut.save(), ut.translate(kt.x, kt.y), ut.rotate(xt), ut.scale(wt, Ct), ut.arc(0, 0, 1, pt, gt, !ct), ut.restore();
          break;
        case "C":
          Dt = ft[Tt], Ft = Dt[3], _t = Dt[4], ht = Dt[5], dt = Dt[6], ut.bezierCurveTo(Dt[1], Dt[2], Ft, _t, ht, dt);
          break;
        case "c":
          Dt = ft[Tt], ut.bezierCurveTo(Dt[1] + ht, Dt[2] + dt, Dt[3] + ht, Dt[4] + dt, Dt[5] + ht, Dt[6] + dt), Ft = Dt[3] + ht, _t = Dt[4] + dt, ht += Dt[5], dt += Dt[6];
          break;
        case "S":
          Dt = ft[Tt], (Ft === null || _t === null) && (Ft = ht, _t = dt), ut.bezierCurveTo(2 * ht - Ft, 2 * dt - _t, Dt[1], Dt[2], Dt[3], Dt[4]), Ft = Dt[1], _t = Dt[2], ht = Dt[3], dt = Dt[4];
          break;
        case "s":
          Dt = ft[Tt], (Ft === null || _t === null) && (Ft = ht, _t = dt), ut.bezierCurveTo(2 * ht - Ft, 2 * dt - _t, Dt[1] + ht, Dt[2] + dt, Dt[3] + ht, Dt[4] + dt), Ft = Dt[1] + ht, _t = Dt[2] + dt, ht += Dt[3], dt += Dt[4];
          break;
        case "Q":
          Dt = ft[Tt], Nt = Dt[1], Mt = Dt[2], ht = Dt[3], dt = Dt[4], ut.quadraticCurveTo(Nt, Mt, ht, dt);
          break;
        case "q":
          Dt = ft[Tt], Nt = Dt[1] + ht, Mt = Dt[2] + dt, ht += Dt[3], dt += Dt[4], ut.quadraticCurveTo(Nt, Mt, ht, dt);
          break;
        case "T":
          Dt = ft[Tt], (Nt === null || Mt === null) && (Nt = ht, Mt = dt), Nt = 2 * ht - Nt, Mt = 2 * dt - Mt, ht = Dt[1], dt = Dt[2], ut.quadraticCurveTo(Nt, Mt, ht, dt);
          break;
        case "t":
          Dt = ft[Tt], (Nt === null || Mt === null) && (Nt = ht, Mt = dt), Nt = 2 * ht - Nt, Mt = 2 * dt - Mt, ht += Dt[1], dt += Dt[2], ut.quadraticCurveTo(Nt, Mt, ht, dt);
          break;
        case "z":
        case "Z":
          Lt && (ht = Lt.x, dt = Lt.y), Lt = null, ut.closePath();
          break;
        case "AC":
          Dt = ft[Tt], ht = Dt[1], dt = Dt[2], Pt = Dt[3], pt = Dt[4], gt = Dt[5], jt = Dt[6], ut.arc(ht, dt, Pt, pt, gt, jt);
          break;
        case "AT":
          Dt = ft[Tt], Bt = Dt[1], Ot = Dt[2], ht = Dt[3], dt = Dt[4], Pt = Dt[5], ut.arcTo(Bt, Ot, ht, dt, Pt);
          break;
        case "E":
          Dt = ft[Tt], ht = Dt[1], dt = Dt[2], wt = Dt[3], Ct = Dt[4], xt = Dt[5], pt = Dt[6], gt = Dt[7], jt = Dt[8], ut.save(), ut.translate(ht, dt), ut.rotate(xt), ut.scale(wt, Ct), ut.arc(0, 0, 1, pt, gt, jt), ut.restore();
          break;
        case "R":
          Dt = ft[Tt], ht = Dt[1], dt = Dt[2], It = Dt[3], yt = Dt[4], Lt = { x: ht, y: dt }, ut.rect(ht, dt, It, yt);
          break;
        case "RR":
          Dt = ft[Tt], ht = Dt[1], dt = Dt[2], It = Dt[3], yt = Dt[4], Ht = Dt[5], Lt = { x: ht, y: dt }, ut.roundRect(ht, dt, It, yt, Ht);
          break;
      }
      $t ? ($t.x = ht, $t.y = dt) : $t = { x: ht, y: dt };
    }
  }
  function lt(ut) {
    if (!(!ut || !ut.CanvasRenderingContext2D || ut.Path2D)) {
      var ft = ut.CanvasRenderingContext2D, ht = ft.prototype.fill, dt = ft.prototype.stroke, gt = ft.prototype.isPointInPath;
      ft.prototype.fill = function() {
        for (var mt = [], ct = 0; ct < arguments.length; ct++)
          mt[ct] = arguments[ct];
        if (mt[0] instanceof rt) {
          var vt = mt[0], At = mt[1] || "nonzero";
          st(this, vt.commands), ht.apply(this, [At]);
        } else {
          var At = mt[0] || "nonzero";
          return ht.apply(this, [At]);
        }
      }, ft.prototype.stroke = function(mt) {
        mt && st(this, mt.commands), dt.apply(this);
      }, ft.prototype.isPointInPath = function() {
        for (var mt = [], ct = 0; ct < arguments.length; ct++)
          mt[ct] = arguments[ct];
        if (mt[0] instanceof rt) {
          var vt = mt[0], At = mt[1], xt = mt[2], bt = mt[3] || "nonzero";
          return st(this, vt.commands), gt.apply(this, [At, xt, bt]);
        } else
          return gt.apply(this, mt);
      }, ut.Path2D = rt;
    }
  }
  function et(ut, ft, ht, dt, gt) {
    var pt = this;
    if (gt === void 0 && (gt = 0), typeof gt == "number" && (gt = [gt]), Array.isArray(gt)) {
      if (gt.length === 0 || gt.length > 4)
        throw new RangeError("Failed to execute 'roundRect' on '".concat(this.constructor.name, "': ").concat(gt.length, " radii provided. Between one and four radii are necessary."));
      gt.forEach(function(bt) {
        if (bt < 0)
          throw new RangeError("Failed to execute 'roundRect' on '".concat(pt.constructor.name, "': Radius value ").concat(bt, " is negative."));
      });
    } else
      return;
    if (gt.length === 1 && gt[0] === 0)
      return this.rect(ut, ft, ht, dt);
    var mt = Math.min(ht, dt) / 2, ct, vt, At, xt = ct = vt = At = Math.min(mt, gt[0]);
    gt.length === 2 && (ct = At = Math.min(mt, gt[1])), gt.length === 3 && (ct = At = Math.min(mt, gt[1]), vt = Math.min(mt, gt[2])), gt.length === 4 && (ct = Math.min(mt, gt[1]), vt = Math.min(mt, gt[2]), At = Math.min(mt, gt[3])), this.moveTo(ut, ft + dt - At), this.arcTo(ut, ft, ut + xt, ft, xt), this.arcTo(ut + ht, ft, ut + ht, ft + ct, ct), this.arcTo(ut + ht, ft + dt, ut + ht - vt, ft + dt, vt), this.arcTo(ut, ft + dt, ut, ft + dt - At, At), this.moveTo(ut, ft);
  }
  function it(ut) {
    if (!(!ut || !ut.CanvasRenderingContext2D)) {
      var ft = ut.CanvasRenderingContext2D, ht = ut.Path2D;
      ft && !ft.prototype.roundRect && (ft.prototype.roundRect = et), ht && !ht.prototype.roundRect && (ht.prototype.roundRect = et);
    }
  }
  return lt(window), it(window), path2dPolyfill_esm;
}
(function(module, exports) {
  (function(s, $) {
    module.exports = s.pdfjsLib = $();
  })(globalThis, () => (
    /******/
    (() => {
      var __webpack_modules__ = [
        ,
        /* 1 */
        /***/
        (a, s, $) => {
          var Er;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.VerbosityLevel = s.Util = s.UnknownErrorException = s.UnexpectedResponseException = s.TextRenderingMode = s.RenderingIntentFlag = s.PromiseCapability = s.PermissionFlag = s.PasswordResponses = s.PasswordException = s.PageActionEventType = s.OPS = s.MissingPDFException = s.MAX_IMAGE_SIZE_TO_CACHE = s.LINE_FACTOR = s.LINE_DESCENT_FACTOR = s.InvalidPDFException = s.ImageKind = s.IDENTITY_MATRIX = s.FormatError = s.FeatureTest = s.FONT_IDENTITY_MATRIX = s.DocumentActionEventType = s.CMapCompressionType = s.BaseException = s.BASELINE_FACTOR = s.AnnotationType = s.AnnotationReplyType = s.AnnotationPrefix = s.AnnotationMode = s.AnnotationFlag = s.AnnotationFieldFlag = s.AnnotationEditorType = s.AnnotationEditorPrefix = s.AnnotationEditorParamsType = s.AnnotationBorderStyleType = s.AnnotationActionEventType = s.AbortException = void 0, s.assert = kt, s.bytesToString = Vt, s.createValidAbsoluteUrl = Ht, s.getModificationDate = Gt, s.getUuid = pr, s.getVerbosityLevel = Ct, s.info = It, s.isArrayBuffer = or, s.isArrayEqual = Xt, s.isNodeJS = void 0, s.normalizeUnicode = ur, s.objectFromMap = ar, s.objectSize = Zt, s.setVerbosityLevel = wt, s.shadow = Ft, s.string32 = qt, s.stringToBytes = Qt, s.stringToPDFString = ir, s.stringToUTF8String = sr, s.unreachable = Rt, s.utf8StringToString = cr, s.warn = yt, $(2), $(84), $(86), $(87), $(89), $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123);
          const _ = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
          s.isNodeJS = _;
          const _e = [1, 0, 0, 1, 0, 0];
          s.IDENTITY_MATRIX = _e;
          const tt = [1e-3, 0, 0, 1e-3, 0, 0];
          s.FONT_IDENTITY_MATRIX = tt;
          const nt = 1e7;
          s.MAX_IMAGE_SIZE_TO_CACHE = nt;
          const at = 1.35;
          s.LINE_FACTOR = at;
          const ot = 0.35;
          s.LINE_DESCENT_FACTOR = ot;
          const rt = ot / at;
          s.BASELINE_FACTOR = rt;
          const st = {
            ANY: 1,
            DISPLAY: 2,
            PRINT: 4,
            SAVE: 8,
            ANNOTATIONS_FORMS: 16,
            ANNOTATIONS_STORAGE: 32,
            ANNOTATIONS_DISABLE: 64,
            OPLIST: 256
          };
          s.RenderingIntentFlag = st;
          const lt = {
            DISABLE: 0,
            ENABLE: 1,
            ENABLE_FORMS: 2,
            ENABLE_STORAGE: 3
          };
          s.AnnotationMode = lt;
          const et = "pdfjs_internal_editor_";
          s.AnnotationEditorPrefix = et;
          const it = {
            DISABLE: -1,
            NONE: 0,
            FREETEXT: 3,
            STAMP: 13,
            INK: 15
          };
          s.AnnotationEditorType = it;
          const ut = {
            RESIZE: 1,
            CREATE: 2,
            FREETEXT_SIZE: 11,
            FREETEXT_COLOR: 12,
            FREETEXT_OPACITY: 13,
            INK_COLOR: 21,
            INK_THICKNESS: 22,
            INK_OPACITY: 23
          };
          s.AnnotationEditorParamsType = ut;
          const ft = {
            PRINT: 4,
            MODIFY_CONTENTS: 8,
            COPY: 16,
            MODIFY_ANNOTATIONS: 32,
            FILL_INTERACTIVE_FORMS: 256,
            COPY_FOR_ACCESSIBILITY: 512,
            ASSEMBLE: 1024,
            PRINT_HIGH_QUALITY: 2048
          };
          s.PermissionFlag = ft;
          const ht = {
            FILL: 0,
            STROKE: 1,
            FILL_STROKE: 2,
            INVISIBLE: 3,
            FILL_ADD_TO_PATH: 4,
            STROKE_ADD_TO_PATH: 5,
            FILL_STROKE_ADD_TO_PATH: 6,
            ADD_TO_PATH: 7,
            FILL_STROKE_MASK: 3,
            ADD_TO_PATH_FLAG: 4
          };
          s.TextRenderingMode = ht;
          const dt = {
            GRAYSCALE_1BPP: 1,
            RGB_24BPP: 2,
            RGBA_32BPP: 3
          };
          s.ImageKind = dt;
          const gt = {
            TEXT: 1,
            LINK: 2,
            FREETEXT: 3,
            LINE: 4,
            SQUARE: 5,
            CIRCLE: 6,
            POLYGON: 7,
            POLYLINE: 8,
            HIGHLIGHT: 9,
            UNDERLINE: 10,
            SQUIGGLY: 11,
            STRIKEOUT: 12,
            STAMP: 13,
            CARET: 14,
            INK: 15,
            POPUP: 16,
            FILEATTACHMENT: 17,
            SOUND: 18,
            MOVIE: 19,
            WIDGET: 20,
            SCREEN: 21,
            PRINTERMARK: 22,
            TRAPNET: 23,
            WATERMARK: 24,
            THREED: 25,
            REDACT: 26
          };
          s.AnnotationType = gt;
          const pt = {
            GROUP: "Group",
            REPLY: "R"
          };
          s.AnnotationReplyType = pt;
          const mt = {
            INVISIBLE: 1,
            HIDDEN: 2,
            PRINT: 4,
            NOZOOM: 8,
            NOROTATE: 16,
            NOVIEW: 32,
            READONLY: 64,
            LOCKED: 128,
            TOGGLENOVIEW: 256,
            LOCKEDCONTENTS: 512
          };
          s.AnnotationFlag = mt;
          const ct = {
            READONLY: 1,
            REQUIRED: 2,
            NOEXPORT: 4,
            MULTILINE: 4096,
            PASSWORD: 8192,
            NOTOGGLETOOFF: 16384,
            RADIO: 32768,
            PUSHBUTTON: 65536,
            COMBO: 131072,
            EDIT: 262144,
            SORT: 524288,
            FILESELECT: 1048576,
            MULTISELECT: 2097152,
            DONOTSPELLCHECK: 4194304,
            DONOTSCROLL: 8388608,
            COMB: 16777216,
            RICHTEXT: 33554432,
            RADIOSINUNISON: 33554432,
            COMMITONSELCHANGE: 67108864
          };
          s.AnnotationFieldFlag = ct;
          const vt = {
            SOLID: 1,
            DASHED: 2,
            BEVELED: 3,
            INSET: 4,
            UNDERLINE: 5
          };
          s.AnnotationBorderStyleType = vt;
          const At = {
            E: "Mouse Enter",
            X: "Mouse Exit",
            D: "Mouse Down",
            U: "Mouse Up",
            Fo: "Focus",
            Bl: "Blur",
            PO: "PageOpen",
            PC: "PageClose",
            PV: "PageVisible",
            PI: "PageInvisible",
            K: "Keystroke",
            F: "Format",
            V: "Validate",
            C: "Calculate"
          };
          s.AnnotationActionEventType = At;
          const xt = {
            WC: "WillClose",
            WS: "WillSave",
            DS: "DidSave",
            WP: "WillPrint",
            DP: "DidPrint"
          };
          s.DocumentActionEventType = xt;
          const bt = {
            O: "PageOpen",
            C: "PageClose"
          };
          s.PageActionEventType = bt;
          const Et = {
            ERRORS: 0,
            WARNINGS: 1,
            INFOS: 5
          };
          s.VerbosityLevel = Et;
          const St = {
            NONE: 0,
            BINARY: 1
          };
          s.CMapCompressionType = St;
          const Bt = {
            dependency: 1,
            setLineWidth: 2,
            setLineCap: 3,
            setLineJoin: 4,
            setMiterLimit: 5,
            setDash: 6,
            setRenderingIntent: 7,
            setFlatness: 8,
            setGState: 9,
            save: 10,
            restore: 11,
            transform: 12,
            moveTo: 13,
            lineTo: 14,
            curveTo: 15,
            curveTo2: 16,
            curveTo3: 17,
            closePath: 18,
            rectangle: 19,
            stroke: 20,
            closeStroke: 21,
            fill: 22,
            eoFill: 23,
            fillStroke: 24,
            eoFillStroke: 25,
            closeFillStroke: 26,
            closeEOFillStroke: 27,
            endPath: 28,
            clip: 29,
            eoClip: 30,
            beginText: 31,
            endText: 32,
            setCharSpacing: 33,
            setWordSpacing: 34,
            setHScale: 35,
            setLeading: 36,
            setFont: 37,
            setTextRenderingMode: 38,
            setTextRise: 39,
            moveText: 40,
            setLeadingMoveText: 41,
            setTextMatrix: 42,
            nextLine: 43,
            showText: 44,
            showSpacedText: 45,
            nextLineShowText: 46,
            nextLineSetSpacingShowText: 47,
            setCharWidth: 48,
            setCharWidthAndBounds: 49,
            setStrokeColorSpace: 50,
            setFillColorSpace: 51,
            setStrokeColor: 52,
            setStrokeColorN: 53,
            setFillColor: 54,
            setFillColorN: 55,
            setStrokeGray: 56,
            setFillGray: 57,
            setStrokeRGBColor: 58,
            setFillRGBColor: 59,
            setStrokeCMYKColor: 60,
            setFillCMYKColor: 61,
            shadingFill: 62,
            beginInlineImage: 63,
            beginImageData: 64,
            endInlineImage: 65,
            paintXObject: 66,
            markPoint: 67,
            markPointProps: 68,
            beginMarkedContent: 69,
            beginMarkedContentProps: 70,
            endMarkedContent: 71,
            beginCompat: 72,
            endCompat: 73,
            paintFormXObjectBegin: 74,
            paintFormXObjectEnd: 75,
            beginGroup: 76,
            endGroup: 77,
            beginAnnotation: 80,
            endAnnotation: 81,
            paintImageMaskXObject: 83,
            paintImageMaskXObjectGroup: 84,
            paintImageXObject: 85,
            paintInlineImageXObject: 86,
            paintInlineImageXObjectGroup: 87,
            paintImageXObjectRepeat: 88,
            paintImageMaskXObjectRepeat: 89,
            paintSolidColorImageMask: 90,
            constructPath: 91
          };
          s.OPS = Bt;
          const Ot = {
            NEED_PASSWORD: 1,
            INCORRECT_PASSWORD: 2
          };
          s.PasswordResponses = Ot;
          let Pt = Et.WARNINGS;
          function wt(br) {
            Number.isInteger(br) && (Pt = br);
          }
          function Ct() {
            return Pt;
          }
          function It(br) {
            Pt >= Et.INFOS && console.log(`Info: ${br}`);
          }
          function yt(br) {
            Pt >= Et.WARNINGS && console.log(`Warning: ${br}`);
          }
          function Rt(br) {
            throw new Error(br);
          }
          function kt(br, gr) {
            br || Rt(gr);
          }
          function jt(br) {
            switch (br == null ? void 0 : br.protocol) {
              case "http:":
              case "https:":
              case "ftp:":
              case "mailto:":
              case "tel:":
                return !0;
              default:
                return !1;
            }
          }
          function Ht(br) {
            let gr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, Ar = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            if (!br)
              return null;
            try {
              if (Ar && typeof br == "string") {
                if (Ar.addDefaultProtocol && br.startsWith("www.")) {
                  const Br = br.match(/\./g);
                  (Br == null ? void 0 : Br.length) >= 2 && (br = `http://${br}`);
                }
                if (Ar.tryConvertEncoding)
                  try {
                    br = sr(br);
                  } catch {
                  }
              }
              const Sr = gr ? new URL(br, gr) : new URL(br);
              if (jt(Sr))
                return Sr;
            } catch {
            }
            return null;
          }
          function Ft(br, gr, Ar) {
            let Sr = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
            return Object.defineProperty(br, gr, {
              value: Ar,
              enumerable: !Sr,
              configurable: !0,
              writable: !1
            }), Ar;
          }
          const _t = function() {
            function gr(Ar, Sr) {
              this.constructor === gr && Rt("Cannot initialize BaseException."), this.message = Ar, this.name = Sr;
            }
            return gr.prototype = new Error(), gr.constructor = gr, gr;
          }();
          s.BaseException = _t;
          class Nt extends _t {
            constructor(gr, Ar) {
              super(gr, "PasswordException"), this.code = Ar;
            }
          }
          s.PasswordException = Nt;
          class Mt extends _t {
            constructor(gr, Ar) {
              super(gr, "UnknownErrorException"), this.details = Ar;
            }
          }
          s.UnknownErrorException = Mt;
          class Lt extends _t {
            constructor(gr) {
              super(gr, "InvalidPDFException");
            }
          }
          s.InvalidPDFException = Lt;
          class $t extends _t {
            constructor(gr) {
              super(gr, "MissingPDFException");
            }
          }
          s.MissingPDFException = $t;
          class Tt extends _t {
            constructor(gr, Ar) {
              super(gr, "UnexpectedResponseException"), this.status = Ar;
            }
          }
          s.UnexpectedResponseException = Tt;
          class Dt extends _t {
            constructor(gr) {
              super(gr, "FormatError");
            }
          }
          s.FormatError = Dt;
          class Ut extends _t {
            constructor(gr) {
              super(gr, "AbortException");
            }
          }
          s.AbortException = Ut;
          function Vt(br) {
            (typeof br != "object" || (br == null ? void 0 : br.length) === void 0) && Rt("Invalid argument for bytesToString");
            const gr = br.length, Ar = 8192;
            if (gr < Ar)
              return String.fromCharCode.apply(null, br);
            const Sr = [];
            for (let Br = 0; Br < gr; Br += Ar) {
              const Ir = Math.min(Br + Ar, gr), hr = br.subarray(Br, Ir);
              Sr.push(String.fromCharCode.apply(null, hr));
            }
            return Sr.join("");
          }
          function Qt(br) {
            typeof br != "string" && Rt("Invalid argument for stringToBytes");
            const gr = br.length, Ar = new Uint8Array(gr);
            for (let Sr = 0; Sr < gr; ++Sr)
              Ar[Sr] = br.charCodeAt(Sr) & 255;
            return Ar;
          }
          function qt(br) {
            return String.fromCharCode(br >> 24 & 255, br >> 16 & 255, br >> 8 & 255, br & 255);
          }
          function Zt(br) {
            return Object.keys(br).length;
          }
          function ar(br) {
            const gr = /* @__PURE__ */ Object.create(null);
            for (const [Ar, Sr] of br)
              gr[Ar] = Sr;
            return gr;
          }
          function Jt() {
            const br = new Uint8Array(4);
            return br[0] = 1, new Uint32Array(br.buffer, 0, 1)[0] === 1;
          }
          function rr() {
            try {
              return new Function(""), !0;
            } catch {
              return !1;
            }
          }
          class Yt {
            static get isLittleEndian() {
              return Ft(this, "isLittleEndian", Jt());
            }
            static get isEvalSupported() {
              return Ft(this, "isEvalSupported", rr());
            }
            static get isOffscreenCanvasSupported() {
              return Ft(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
            }
            static get platform() {
              return typeof navigator > "u" ? Ft(this, "platform", {
                isWin: !1,
                isMac: !1
              }) : Ft(this, "platform", {
                isWin: navigator.platform.includes("Win"),
                isMac: navigator.platform.includes("Mac")
              });
            }
            static get isCSSRoundSupported() {
              var gr, Ar;
              return Ft(this, "isCSSRoundSupported", (Ar = (gr = globalThis.CSS) == null ? void 0 : gr.supports) == null ? void 0 : Ar.call(gr, "width: round(1.5px, 1px)"));
            }
          }
          s.FeatureTest = Yt;
          const Kt = [...Array(256).keys()].map((br) => br.toString(16).padStart(2, "0"));
          class nr {
            static makeHexColor(gr, Ar, Sr) {
              return `#${Kt[gr]}${Kt[Ar]}${Kt[Sr]}`;
            }
            static scaleMinMax(gr, Ar) {
              let Sr;
              gr[0] ? (gr[0] < 0 && (Sr = Ar[0], Ar[0] = Ar[1], Ar[1] = Sr), Ar[0] *= gr[0], Ar[1] *= gr[0], gr[3] < 0 && (Sr = Ar[2], Ar[2] = Ar[3], Ar[3] = Sr), Ar[2] *= gr[3], Ar[3] *= gr[3]) : (Sr = Ar[0], Ar[0] = Ar[2], Ar[2] = Sr, Sr = Ar[1], Ar[1] = Ar[3], Ar[3] = Sr, gr[1] < 0 && (Sr = Ar[2], Ar[2] = Ar[3], Ar[3] = Sr), Ar[2] *= gr[1], Ar[3] *= gr[1], gr[2] < 0 && (Sr = Ar[0], Ar[0] = Ar[1], Ar[1] = Sr), Ar[0] *= gr[2], Ar[1] *= gr[2]), Ar[0] += gr[4], Ar[1] += gr[4], Ar[2] += gr[5], Ar[3] += gr[5];
            }
            static transform(gr, Ar) {
              return [gr[0] * Ar[0] + gr[2] * Ar[1], gr[1] * Ar[0] + gr[3] * Ar[1], gr[0] * Ar[2] + gr[2] * Ar[3], gr[1] * Ar[2] + gr[3] * Ar[3], gr[0] * Ar[4] + gr[2] * Ar[5] + gr[4], gr[1] * Ar[4] + gr[3] * Ar[5] + gr[5]];
            }
            static applyTransform(gr, Ar) {
              const Sr = gr[0] * Ar[0] + gr[1] * Ar[2] + Ar[4], Br = gr[0] * Ar[1] + gr[1] * Ar[3] + Ar[5];
              return [Sr, Br];
            }
            static applyInverseTransform(gr, Ar) {
              const Sr = Ar[0] * Ar[3] - Ar[1] * Ar[2], Br = (gr[0] * Ar[3] - gr[1] * Ar[2] + Ar[2] * Ar[5] - Ar[4] * Ar[3]) / Sr, Ir = (-gr[0] * Ar[1] + gr[1] * Ar[0] + Ar[4] * Ar[1] - Ar[5] * Ar[0]) / Sr;
              return [Br, Ir];
            }
            static getAxialAlignedBoundingBox(gr, Ar) {
              const Sr = this.applyTransform(gr, Ar), Br = this.applyTransform(gr.slice(2, 4), Ar), Ir = this.applyTransform([gr[0], gr[3]], Ar), hr = this.applyTransform([gr[2], gr[1]], Ar);
              return [Math.min(Sr[0], Br[0], Ir[0], hr[0]), Math.min(Sr[1], Br[1], Ir[1], hr[1]), Math.max(Sr[0], Br[0], Ir[0], hr[0]), Math.max(Sr[1], Br[1], Ir[1], hr[1])];
            }
            static inverseTransform(gr) {
              const Ar = gr[0] * gr[3] - gr[1] * gr[2];
              return [gr[3] / Ar, -gr[1] / Ar, -gr[2] / Ar, gr[0] / Ar, (gr[2] * gr[5] - gr[4] * gr[3]) / Ar, (gr[4] * gr[1] - gr[5] * gr[0]) / Ar];
            }
            static singularValueDecompose2dScale(gr) {
              const Ar = [gr[0], gr[2], gr[1], gr[3]], Sr = gr[0] * Ar[0] + gr[1] * Ar[2], Br = gr[0] * Ar[1] + gr[1] * Ar[3], Ir = gr[2] * Ar[0] + gr[3] * Ar[2], hr = gr[2] * Ar[1] + gr[3] * Ar[3], vr = (Sr + hr) / 2, xr = Math.sqrt((Sr + hr) ** 2 - 4 * (Sr * hr - Ir * Br)) / 2, Pr = vr + xr || 1, Rr = vr - xr || 1;
              return [Math.sqrt(Pr), Math.sqrt(Rr)];
            }
            static normalizeRect(gr) {
              const Ar = gr.slice(0);
              return gr[0] > gr[2] && (Ar[0] = gr[2], Ar[2] = gr[0]), gr[1] > gr[3] && (Ar[1] = gr[3], Ar[3] = gr[1]), Ar;
            }
            static intersect(gr, Ar) {
              const Sr = Math.max(Math.min(gr[0], gr[2]), Math.min(Ar[0], Ar[2])), Br = Math.min(Math.max(gr[0], gr[2]), Math.max(Ar[0], Ar[2]));
              if (Sr > Br)
                return null;
              const Ir = Math.max(Math.min(gr[1], gr[3]), Math.min(Ar[1], Ar[3])), hr = Math.min(Math.max(gr[1], gr[3]), Math.max(Ar[1], Ar[3]));
              return Ir > hr ? null : [Sr, Ir, Br, hr];
            }
            static bezierBoundingBox(gr, Ar, Sr, Br, Ir, hr, vr, xr) {
              const Pr = [], Rr = [[], []];
              let Dr, Gr, Or, Hr, jr, Tr, fr, Cr;
              for (let Fr = 0; Fr < 2; ++Fr) {
                if (Fr === 0 ? (Gr = 6 * gr - 12 * Sr + 6 * Ir, Dr = -3 * gr + 9 * Sr - 9 * Ir + 3 * vr, Or = 3 * Sr - 3 * gr) : (Gr = 6 * Ar - 12 * Br + 6 * hr, Dr = -3 * Ar + 9 * Br - 9 * hr + 3 * xr, Or = 3 * Br - 3 * Ar), Math.abs(Dr) < 1e-12) {
                  if (Math.abs(Gr) < 1e-12)
                    continue;
                  Hr = -Or / Gr, 0 < Hr && Hr < 1 && Pr.push(Hr);
                  continue;
                }
                fr = Gr * Gr - 4 * Or * Dr, Cr = Math.sqrt(fr), !(fr < 0) && (jr = (-Gr + Cr) / (2 * Dr), 0 < jr && jr < 1 && Pr.push(jr), Tr = (-Gr - Cr) / (2 * Dr), 0 < Tr && Tr < 1 && Pr.push(Tr));
              }
              let $r = Pr.length, wr;
              const Mr = $r;
              for (; $r--; )
                Hr = Pr[$r], wr = 1 - Hr, Rr[0][$r] = wr * wr * wr * gr + 3 * wr * wr * Hr * Sr + 3 * wr * Hr * Hr * Ir + Hr * Hr * Hr * vr, Rr[1][$r] = wr * wr * wr * Ar + 3 * wr * wr * Hr * Br + 3 * wr * Hr * Hr * hr + Hr * Hr * Hr * xr;
              return Rr[0][Mr] = gr, Rr[1][Mr] = Ar, Rr[0][Mr + 1] = vr, Rr[1][Mr + 1] = xr, Rr[0].length = Rr[1].length = Mr + 2, [Math.min(...Rr[0]), Math.min(...Rr[1]), Math.max(...Rr[0]), Math.max(...Rr[1])];
            }
          }
          s.Util = nr;
          const tr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
          function ir(br) {
            if (br[0] >= "ï") {
              let Ar;
              if (br[0] === "þ" && br[1] === "ÿ" ? Ar = "utf-16be" : br[0] === "ÿ" && br[1] === "þ" ? Ar = "utf-16le" : br[0] === "ï" && br[1] === "»" && br[2] === "¿" && (Ar = "utf-8"), Ar)
                try {
                  const Sr = new TextDecoder(Ar, {
                    fatal: !0
                  }), Br = Qt(br);
                  return Sr.decode(Br);
                } catch (Sr) {
                  yt(`stringToPDFString: "${Sr}".`);
                }
            }
            const gr = [];
            for (let Ar = 0, Sr = br.length; Ar < Sr; Ar++) {
              const Br = tr[br.charCodeAt(Ar)];
              gr.push(Br ? String.fromCharCode(Br) : br.charAt(Ar));
            }
            return gr.join("");
          }
          function sr(br) {
            return decodeURIComponent(escape(br));
          }
          function cr(br) {
            return unescape(encodeURIComponent(br));
          }
          function or(br) {
            return typeof br == "object" && (br == null ? void 0 : br.byteLength) !== void 0;
          }
          function Xt(br, gr) {
            if (br.length !== gr.length)
              return !1;
            for (let Ar = 0, Sr = br.length; Ar < Sr; Ar++)
              if (br[Ar] !== gr[Ar])
                return !1;
            return !0;
          }
          function Gt() {
            let br = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Date();
            return [br.getUTCFullYear().toString(), (br.getUTCMonth() + 1).toString().padStart(2, "0"), br.getUTCDate().toString().padStart(2, "0"), br.getUTCHours().toString().padStart(2, "0"), br.getUTCMinutes().toString().padStart(2, "0"), br.getUTCSeconds().toString().padStart(2, "0")].join("");
          }
          class Wt {
            constructor() {
              _r(this, Er, !1);
              this.promise = new Promise((gr, Ar) => {
                this.resolve = (Sr) => {
                  tn(this, Er, !0), gr(Sr);
                }, this.reject = (Sr) => {
                  tn(this, Er, !0), Ar(Sr);
                };
              });
            }
            get settled() {
              return mr(this, Er);
            }
          }
          Er = new WeakMap(), s.PromiseCapability = Wt;
          let er = null, lr = null;
          function ur(br) {
            return er || (er = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, lr = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), br.replaceAll(er, (gr, Ar, Sr) => Ar ? Ar.normalize("NFKC") : lr.get(Sr));
          }
          function pr() {
            if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.randomUUID) == "function")
              return crypto.randomUUID();
            const br = new Uint8Array(32);
            if (typeof crypto < "u" && typeof (crypto == null ? void 0 : crypto.getRandomValues) == "function")
              crypto.getRandomValues(br);
            else
              for (let gr = 0; gr < 32; gr++)
                br[gr] = Math.floor(Math.random() * 255);
            return Vt(br);
          }
          const yr = "pdfjs_internal_id_";
          s.AnnotationPrefix = yr;
        },
        /* 2 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(4), tt = $(69), nt = $(70), at = "WebAssembly", ot = _e[at], rt = Error("e", { cause: 7 }).cause !== 7, st = function(et, it) {
            var ut = {};
            ut[et] = nt(et, it, rt), _({
              global: !0,
              constructor: !0,
              arity: 1,
              forced: rt
            }, ut);
          }, lt = function(et, it) {
            if (ot && ot[et]) {
              var ut = {};
              ut[et] = nt(at + "." + et, it, rt), _({
                target: at,
                stat: !0,
                constructor: !0,
                arity: 1,
                forced: rt
              }, ut);
            }
          };
          st("Error", function(et) {
            return function(ut) {
              return tt(et, this, arguments);
            };
          }), st("EvalError", function(et) {
            return function(ut) {
              return tt(et, this, arguments);
            };
          }), st("RangeError", function(et) {
            return function(ut) {
              return tt(et, this, arguments);
            };
          }), st("ReferenceError", function(et) {
            return function(ut) {
              return tt(et, this, arguments);
            };
          }), st("SyntaxError", function(et) {
            return function(ut) {
              return tt(et, this, arguments);
            };
          }), st("TypeError", function(et) {
            return function(ut) {
              return tt(et, this, arguments);
            };
          }), st("URIError", function(et) {
            return function(ut) {
              return tt(et, this, arguments);
            };
          }), lt("CompileError", function(et) {
            return function(ut) {
              return tt(et, this, arguments);
            };
          }), lt("LinkError", function(et) {
            return function(ut) {
              return tt(et, this, arguments);
            };
          }), lt("RuntimeError", function(et) {
            return function(ut) {
              return tt(et, this, arguments);
            };
          });
        },
        /* 3 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(5).f, tt = $(44), nt = $(48), at = $(38), ot = $(56), rt = $(68);
          a.exports = function(st, lt) {
            var et = st.target, it = st.global, ut = st.stat, ft, ht, dt, gt, pt, mt;
            if (it ? ht = _ : ut ? ht = _[et] || at(et, {}) : ht = (_[et] || {}).prototype, ht)
              for (dt in lt) {
                if (pt = lt[dt], st.dontCallGetSet ? (mt = _e(ht, dt), gt = mt && mt.value) : gt = ht[dt], ft = rt(it ? dt : et + (ut ? "." : "#") + dt, st.forced), !ft && gt !== void 0) {
                  if (typeof pt == typeof gt)
                    continue;
                  ot(pt, gt);
                }
                (st.sham || gt && gt.sham) && tt(pt, "sham", !0), nt(ht, dt, pt, st);
              }
          };
        },
        /* 4 */
        /***/
        function(a) {
          var s = function($) {
            return $ && $.Math === Math && $;
          };
          a.exports = s(typeof globalThis == "object" && globalThis) || s(typeof window == "object" && window) || s(typeof self == "object" && self) || s(typeof commonjsGlobal == "object" && commonjsGlobal) || /* @__PURE__ */ function() {
            return this;
          }() || this || Function("return this")();
        },
        /* 5 */
        /***/
        (a, s, $) => {
          var _ = $(6), _e = $(8), tt = $(10), nt = $(11), at = $(12), ot = $(18), rt = $(39), st = $(42), lt = Object.getOwnPropertyDescriptor;
          s.f = _ ? lt : function(it, ut) {
            if (it = at(it), ut = ot(ut), st)
              try {
                return lt(it, ut);
              } catch {
              }
            if (rt(it, ut))
              return nt(!_e(tt.f, it, ut), it[ut]);
          };
        },
        /* 6 */
        /***/
        (a, s, $) => {
          var _ = $(7);
          a.exports = !_(function() {
            return Object.defineProperty({}, 1, {
              get: function() {
                return 7;
              }
            })[1] !== 7;
          });
        },
        /* 7 */
        /***/
        (a) => {
          a.exports = function(s) {
            try {
              return !!s();
            } catch {
              return !0;
            }
          };
        },
        /* 8 */
        /***/
        (a, s, $) => {
          var _ = $(9), _e = Function.prototype.call;
          a.exports = _ ? _e.bind(_e) : function() {
            return _e.apply(_e, arguments);
          };
        },
        /* 9 */
        /***/
        (a, s, $) => {
          var _ = $(7);
          a.exports = !_(function() {
            var _e = (function() {
            }).bind();
            return typeof _e != "function" || _e.hasOwnProperty("prototype");
          });
        },
        /* 10 */
        /***/
        (a, s) => {
          var $ = {}.propertyIsEnumerable, _ = Object.getOwnPropertyDescriptor, _e = _ && !$.call({ 1: 2 }, 1);
          s.f = _e ? function(nt) {
            var at = _(this, nt);
            return !!at && at.enumerable;
          } : $;
        },
        /* 11 */
        /***/
        (a) => {
          a.exports = function(s, $) {
            return {
              enumerable: !(s & 1),
              configurable: !(s & 2),
              writable: !(s & 4),
              value: $
            };
          };
        },
        /* 12 */
        /***/
        (a, s, $) => {
          var _ = $(13), _e = $(16);
          a.exports = function(tt) {
            return _(_e(tt));
          };
        },
        /* 13 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = $(7), tt = $(15), nt = Object, at = _("".split);
          a.exports = _e(function() {
            return !nt("z").propertyIsEnumerable(0);
          }) ? function(ot) {
            return tt(ot) === "String" ? at(ot, "") : nt(ot);
          } : nt;
        },
        /* 14 */
        /***/
        (a, s, $) => {
          var _ = $(9), _e = Function.prototype, tt = _e.call, nt = _ && _e.bind.bind(tt, tt);
          a.exports = _ ? nt : function(at) {
            return function() {
              return tt.apply(at, arguments);
            };
          };
        },
        /* 15 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = _({}.toString), tt = _("".slice);
          a.exports = function(nt) {
            return tt(_e(nt), 8, -1);
          };
        },
        /* 16 */
        /***/
        (a, s, $) => {
          var _ = $(17), _e = TypeError;
          a.exports = function(tt) {
            if (_(tt))
              throw _e("Can't call method on " + tt);
            return tt;
          };
        },
        /* 17 */
        /***/
        (a) => {
          a.exports = function(s) {
            return s == null;
          };
        },
        /* 18 */
        /***/
        (a, s, $) => {
          var _ = $(19), _e = $(23);
          a.exports = function(tt) {
            var nt = _(tt, "string");
            return _e(nt) ? nt : nt + "";
          };
        },
        /* 19 */
        /***/
        (a, s, $) => {
          var _ = $(8), _e = $(20), tt = $(23), nt = $(30), at = $(33), ot = $(34), rt = TypeError, st = ot("toPrimitive");
          a.exports = function(lt, et) {
            if (!_e(lt) || tt(lt))
              return lt;
            var it = nt(lt, st), ut;
            if (it) {
              if (et === void 0 && (et = "default"), ut = _(it, lt, et), !_e(ut) || tt(ut))
                return ut;
              throw rt("Can't convert object to primitive value");
            }
            return et === void 0 && (et = "number"), at(lt, et);
          };
        },
        /* 20 */
        /***/
        (a, s, $) => {
          var _ = $(21), _e = $(22), tt = _e.all;
          a.exports = _e.IS_HTMLDDA ? function(nt) {
            return typeof nt == "object" ? nt !== null : _(nt) || nt === tt;
          } : function(nt) {
            return typeof nt == "object" ? nt !== null : _(nt);
          };
        },
        /* 21 */
        /***/
        (a, s, $) => {
          var _ = $(22), _e = _.all;
          a.exports = _.IS_HTMLDDA ? function(tt) {
            return typeof tt == "function" || tt === _e;
          } : function(tt) {
            return typeof tt == "function";
          };
        },
        /* 22 */
        /***/
        (a) => {
          var s = typeof document == "object" && document.all, $ = typeof s > "u" && s !== void 0;
          a.exports = {
            all: s,
            IS_HTMLDDA: $
          };
        },
        /* 23 */
        /***/
        (a, s, $) => {
          var _ = $(24), _e = $(21), tt = $(25), nt = $(26), at = Object;
          a.exports = nt ? function(ot) {
            return typeof ot == "symbol";
          } : function(ot) {
            var rt = _("Symbol");
            return _e(rt) && tt(rt.prototype, at(ot));
          };
        },
        /* 24 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(21), tt = function(nt) {
            return _e(nt) ? nt : void 0;
          };
          a.exports = function(nt, at) {
            return arguments.length < 2 ? tt(_[nt]) : _[nt] && _[nt][at];
          };
        },
        /* 25 */
        /***/
        (a, s, $) => {
          var _ = $(14);
          a.exports = _({}.isPrototypeOf);
        },
        /* 26 */
        /***/
        (a, s, $) => {
          var _ = $(27);
          a.exports = _ && !Symbol.sham && typeof Symbol.iterator == "symbol";
        },
        /* 27 */
        /***/
        (a, s, $) => {
          var _ = $(28), _e = $(7), tt = $(4), nt = tt.String;
          a.exports = !!Object.getOwnPropertySymbols && !_e(function() {
            var at = Symbol("symbol detection");
            return !nt(at) || !(Object(at) instanceof Symbol) || !Symbol.sham && _ && _ < 41;
          });
        },
        /* 28 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(29), tt = _.process, nt = _.Deno, at = tt && tt.versions || nt && nt.version, ot = at && at.v8, rt, st;
          ot && (rt = ot.split("."), st = rt[0] > 0 && rt[0] < 4 ? 1 : +(rt[0] + rt[1])), !st && _e && (rt = _e.match(/Edge\/(\d+)/), (!rt || rt[1] >= 74) && (rt = _e.match(/Chrome\/(\d+)/), rt && (st = +rt[1]))), a.exports = st;
        },
        /* 29 */
        /***/
        (a) => {
          a.exports = typeof navigator < "u" && String(navigator.userAgent) || "";
        },
        /* 30 */
        /***/
        (a, s, $) => {
          var _ = $(31), _e = $(17);
          a.exports = function(tt, nt) {
            var at = tt[nt];
            return _e(at) ? void 0 : _(at);
          };
        },
        /* 31 */
        /***/
        (a, s, $) => {
          var _ = $(21), _e = $(32), tt = TypeError;
          a.exports = function(nt) {
            if (_(nt))
              return nt;
            throw tt(_e(nt) + " is not a function");
          };
        },
        /* 32 */
        /***/
        (a) => {
          var s = String;
          a.exports = function($) {
            try {
              return s($);
            } catch {
              return "Object";
            }
          };
        },
        /* 33 */
        /***/
        (a, s, $) => {
          var _ = $(8), _e = $(21), tt = $(20), nt = TypeError;
          a.exports = function(at, ot) {
            var rt, st;
            if (ot === "string" && _e(rt = at.toString) && !tt(st = _(rt, at)) || _e(rt = at.valueOf) && !tt(st = _(rt, at)) || ot !== "string" && _e(rt = at.toString) && !tt(st = _(rt, at)))
              return st;
            throw nt("Can't convert object to primitive value");
          };
        },
        /* 34 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(35), tt = $(39), nt = $(41), at = $(27), ot = $(26), rt = _.Symbol, st = _e("wks"), lt = ot ? rt.for || rt : rt && rt.withoutSetter || nt;
          a.exports = function(et) {
            return tt(st, et) || (st[et] = at && tt(rt, et) ? rt[et] : lt("Symbol." + et)), st[et];
          };
        },
        /* 35 */
        /***/
        (a, s, $) => {
          var _ = $(36), _e = $(37);
          (a.exports = function(tt, nt) {
            return _e[tt] || (_e[tt] = nt !== void 0 ? nt : {});
          })("versions", []).push({
            version: "3.32.2",
            mode: _ ? "pure" : "global",
            copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
            license: "https://github.com/zloirock/core-js/blob/v3.32.2/LICENSE",
            source: "https://github.com/zloirock/core-js"
          });
        },
        /* 36 */
        /***/
        (a) => {
          a.exports = !1;
        },
        /* 37 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(38), tt = "__core-js_shared__", nt = _[tt] || _e(tt, {});
          a.exports = nt;
        },
        /* 38 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = Object.defineProperty;
          a.exports = function(tt, nt) {
            try {
              _e(_, tt, {
                value: nt,
                configurable: !0,
                writable: !0
              });
            } catch {
              _[tt] = nt;
            }
            return nt;
          };
        },
        /* 39 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = $(40), tt = _({}.hasOwnProperty);
          a.exports = Object.hasOwn || function(at, ot) {
            return tt(_e(at), ot);
          };
        },
        /* 40 */
        /***/
        (a, s, $) => {
          var _ = $(16), _e = Object;
          a.exports = function(tt) {
            return _e(_(tt));
          };
        },
        /* 41 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = 0, tt = Math.random(), nt = _(1 .toString);
          a.exports = function(at) {
            return "Symbol(" + (at === void 0 ? "" : at) + ")_" + nt(++_e + tt, 36);
          };
        },
        /* 42 */
        /***/
        (a, s, $) => {
          var _ = $(6), _e = $(7), tt = $(43);
          a.exports = !_ && !_e(function() {
            return Object.defineProperty(tt("div"), "a", {
              get: function() {
                return 7;
              }
            }).a !== 7;
          });
        },
        /* 43 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(20), tt = _.document, nt = _e(tt) && _e(tt.createElement);
          a.exports = function(at) {
            return nt ? tt.createElement(at) : {};
          };
        },
        /* 44 */
        /***/
        (a, s, $) => {
          var _ = $(6), _e = $(45), tt = $(11);
          a.exports = _ ? function(nt, at, ot) {
            return _e.f(nt, at, tt(1, ot));
          } : function(nt, at, ot) {
            return nt[at] = ot, nt;
          };
        },
        /* 45 */
        /***/
        (a, s, $) => {
          var _ = $(6), _e = $(42), tt = $(46), nt = $(47), at = $(18), ot = TypeError, rt = Object.defineProperty, st = Object.getOwnPropertyDescriptor, lt = "enumerable", et = "configurable", it = "writable";
          s.f = _ ? tt ? function(ft, ht, dt) {
            if (nt(ft), ht = at(ht), nt(dt), typeof ft == "function" && ht === "prototype" && "value" in dt && it in dt && !dt[it]) {
              var gt = st(ft, ht);
              gt && gt[it] && (ft[ht] = dt.value, dt = {
                configurable: et in dt ? dt[et] : gt[et],
                enumerable: lt in dt ? dt[lt] : gt[lt],
                writable: !1
              });
            }
            return rt(ft, ht, dt);
          } : rt : function(ft, ht, dt) {
            if (nt(ft), ht = at(ht), nt(dt), _e)
              try {
                return rt(ft, ht, dt);
              } catch {
              }
            if ("get" in dt || "set" in dt)
              throw ot("Accessors not supported");
            return "value" in dt && (ft[ht] = dt.value), ft;
          };
        },
        /* 46 */
        /***/
        (a, s, $) => {
          var _ = $(6), _e = $(7);
          a.exports = _ && _e(function() {
            return Object.defineProperty(function() {
            }, "prototype", {
              value: 42,
              writable: !1
            }).prototype !== 42;
          });
        },
        /* 47 */
        /***/
        (a, s, $) => {
          var _ = $(20), _e = String, tt = TypeError;
          a.exports = function(nt) {
            if (_(nt))
              return nt;
            throw tt(_e(nt) + " is not an object");
          };
        },
        /* 48 */
        /***/
        (a, s, $) => {
          var _ = $(21), _e = $(45), tt = $(49), nt = $(38);
          a.exports = function(at, ot, rt, st) {
            st || (st = {});
            var lt = st.enumerable, et = st.name !== void 0 ? st.name : ot;
            if (_(rt) && tt(rt, et, st), st.global)
              lt ? at[ot] = rt : nt(ot, rt);
            else {
              try {
                st.unsafe ? at[ot] && (lt = !0) : delete at[ot];
              } catch {
              }
              lt ? at[ot] = rt : _e.f(at, ot, {
                value: rt,
                enumerable: !1,
                configurable: !st.nonConfigurable,
                writable: !st.nonWritable
              });
            }
            return at;
          };
        },
        /* 49 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = $(7), tt = $(21), nt = $(39), at = $(6), ot = $(50).CONFIGURABLE, rt = $(51), st = $(52), lt = st.enforce, et = st.get, it = String, ut = Object.defineProperty, ft = _("".slice), ht = _("".replace), dt = _([].join), gt = at && !_e(function() {
            return ut(function() {
            }, "length", { value: 8 }).length !== 8;
          }), pt = String(String).split("String"), mt = a.exports = function(ct, vt, At) {
            ft(it(vt), 0, 7) === "Symbol(" && (vt = "[" + ht(it(vt), /^Symbol\(([^)]*)\)/, "$1") + "]"), At && At.getter && (vt = "get " + vt), At && At.setter && (vt = "set " + vt), (!nt(ct, "name") || ot && ct.name !== vt) && (at ? ut(ct, "name", {
              value: vt,
              configurable: !0
            }) : ct.name = vt), gt && At && nt(At, "arity") && ct.length !== At.arity && ut(ct, "length", { value: At.arity });
            try {
              At && nt(At, "constructor") && At.constructor ? at && ut(ct, "prototype", { writable: !1 }) : ct.prototype && (ct.prototype = void 0);
            } catch {
            }
            var xt = lt(ct);
            return nt(xt, "source") || (xt.source = dt(pt, typeof vt == "string" ? vt : "")), ct;
          };
          Function.prototype.toString = mt(function() {
            return tt(this) && et(this).source || rt(this);
          }, "toString");
        },
        /* 50 */
        /***/
        (a, s, $) => {
          var _ = $(6), _e = $(39), tt = Function.prototype, nt = _ && Object.getOwnPropertyDescriptor, at = _e(tt, "name"), ot = at && (function() {
          }).name === "something", rt = at && (!_ || _ && nt(tt, "name").configurable);
          a.exports = {
            EXISTS: at,
            PROPER: ot,
            CONFIGURABLE: rt
          };
        },
        /* 51 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = $(21), tt = $(37), nt = _(Function.toString);
          _e(tt.inspectSource) || (tt.inspectSource = function(at) {
            return nt(at);
          }), a.exports = tt.inspectSource;
        },
        /* 52 */
        /***/
        (a, s, $) => {
          var _ = $(53), _e = $(4), tt = $(20), nt = $(44), at = $(39), ot = $(37), rt = $(54), st = $(55), lt = "Object already initialized", et = _e.TypeError, it = _e.WeakMap, ut, ft, ht, dt = function(ct) {
            return ht(ct) ? ft(ct) : ut(ct, {});
          }, gt = function(ct) {
            return function(vt) {
              var At;
              if (!tt(vt) || (At = ft(vt)).type !== ct)
                throw et("Incompatible receiver, " + ct + " required");
              return At;
            };
          };
          if (_ || ot.state) {
            var pt = ot.state || (ot.state = new it());
            pt.get = pt.get, pt.has = pt.has, pt.set = pt.set, ut = function(ct, vt) {
              if (pt.has(ct))
                throw et(lt);
              return vt.facade = ct, pt.set(ct, vt), vt;
            }, ft = function(ct) {
              return pt.get(ct) || {};
            }, ht = function(ct) {
              return pt.has(ct);
            };
          } else {
            var mt = rt("state");
            st[mt] = !0, ut = function(ct, vt) {
              if (at(ct, mt))
                throw et(lt);
              return vt.facade = ct, nt(ct, mt, vt), vt;
            }, ft = function(ct) {
              return at(ct, mt) ? ct[mt] : {};
            }, ht = function(ct) {
              return at(ct, mt);
            };
          }
          a.exports = {
            set: ut,
            get: ft,
            has: ht,
            enforce: dt,
            getterFor: gt
          };
        },
        /* 53 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(21), tt = _.WeakMap;
          a.exports = _e(tt) && /native code/.test(String(tt));
        },
        /* 54 */
        /***/
        (a, s, $) => {
          var _ = $(35), _e = $(41), tt = _("keys");
          a.exports = function(nt) {
            return tt[nt] || (tt[nt] = _e(nt));
          };
        },
        /* 55 */
        /***/
        (a) => {
          a.exports = {};
        },
        /* 56 */
        /***/
        (a, s, $) => {
          var _ = $(39), _e = $(57), tt = $(5), nt = $(45);
          a.exports = function(at, ot, rt) {
            for (var st = _e(ot), lt = nt.f, et = tt.f, it = 0; it < st.length; it++) {
              var ut = st[it];
              !_(at, ut) && !(rt && _(rt, ut)) && lt(at, ut, et(ot, ut));
            }
          };
        },
        /* 57 */
        /***/
        (a, s, $) => {
          var _ = $(24), _e = $(14), tt = $(58), nt = $(67), at = $(47), ot = _e([].concat);
          a.exports = _("Reflect", "ownKeys") || function(st) {
            var lt = tt.f(at(st)), et = nt.f;
            return et ? ot(lt, et(st)) : lt;
          };
        },
        /* 58 */
        /***/
        (a, s, $) => {
          var _ = $(59), _e = $(66), tt = _e.concat("length", "prototype");
          s.f = Object.getOwnPropertyNames || function(at) {
            return _(at, tt);
          };
        },
        /* 59 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = $(39), tt = $(12), nt = $(60).indexOf, at = $(55), ot = _([].push);
          a.exports = function(rt, st) {
            var lt = tt(rt), et = 0, it = [], ut;
            for (ut in lt)
              !_e(at, ut) && _e(lt, ut) && ot(it, ut);
            for (; st.length > et; )
              _e(lt, ut = st[et++]) && (~nt(it, ut) || ot(it, ut));
            return it;
          };
        },
        /* 60 */
        /***/
        (a, s, $) => {
          var _ = $(12), _e = $(61), tt = $(64), nt = function(at) {
            return function(ot, rt, st) {
              var lt = _(ot), et = tt(lt), it = _e(st, et), ut;
              if (at && rt !== rt) {
                for (; et > it; )
                  if (ut = lt[it++], ut !== ut)
                    return !0;
              } else
                for (; et > it; it++)
                  if ((at || it in lt) && lt[it] === rt)
                    return at || it || 0;
              return !at && -1;
            };
          };
          a.exports = {
            includes: nt(!0),
            indexOf: nt(!1)
          };
        },
        /* 61 */
        /***/
        (a, s, $) => {
          var _ = $(62), _e = Math.max, tt = Math.min;
          a.exports = function(nt, at) {
            var ot = _(nt);
            return ot < 0 ? _e(ot + at, 0) : tt(ot, at);
          };
        },
        /* 62 */
        /***/
        (a, s, $) => {
          var _ = $(63);
          a.exports = function(_e) {
            var tt = +_e;
            return tt !== tt || tt === 0 ? 0 : _(tt);
          };
        },
        /* 63 */
        /***/
        (a) => {
          var s = Math.ceil, $ = Math.floor;
          a.exports = Math.trunc || function(_e) {
            var tt = +_e;
            return (tt > 0 ? $ : s)(tt);
          };
        },
        /* 64 */
        /***/
        (a, s, $) => {
          var _ = $(65);
          a.exports = function(_e) {
            return _(_e.length);
          };
        },
        /* 65 */
        /***/
        (a, s, $) => {
          var _ = $(62), _e = Math.min;
          a.exports = function(tt) {
            return tt > 0 ? _e(_(tt), 9007199254740991) : 0;
          };
        },
        /* 66 */
        /***/
        (a) => {
          a.exports = [
            "constructor",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "toLocaleString",
            "toString",
            "valueOf"
          ];
        },
        /* 67 */
        /***/
        (a, s) => {
          s.f = Object.getOwnPropertySymbols;
        },
        /* 68 */
        /***/
        (a, s, $) => {
          var _ = $(7), _e = $(21), tt = /#|\.prototype\./, nt = function(lt, et) {
            var it = ot[at(lt)];
            return it === st ? !0 : it === rt ? !1 : _e(et) ? _(et) : !!et;
          }, at = nt.normalize = function(lt) {
            return String(lt).replace(tt, ".").toLowerCase();
          }, ot = nt.data = {}, rt = nt.NATIVE = "N", st = nt.POLYFILL = "P";
          a.exports = nt;
        },
        /* 69 */
        /***/
        (a, s, $) => {
          var _ = $(9), _e = Function.prototype, tt = _e.apply, nt = _e.call;
          a.exports = typeof Reflect == "object" && Reflect.apply || (_ ? nt.bind(tt) : function() {
            return nt.apply(tt, arguments);
          });
        },
        /* 70 */
        /***/
        (a, s, $) => {
          var _ = $(24), _e = $(39), tt = $(44), nt = $(25), at = $(71), ot = $(56), rt = $(74), st = $(75), lt = $(76), et = $(80), it = $(81), ut = $(6), ft = $(36);
          a.exports = function(ht, dt, gt, pt) {
            var mt = "stackTraceLimit", ct = pt ? 2 : 1, vt = ht.split("."), At = vt[vt.length - 1], xt = _.apply(null, vt);
            if (xt) {
              var bt = xt.prototype;
              if (!ft && _e(bt, "cause") && delete bt.cause, !gt)
                return xt;
              var Et = _("Error"), St = dt(function(Bt, Ot) {
                var Pt = lt(pt ? Ot : Bt, void 0), wt = pt ? new xt(Bt) : new xt();
                return Pt !== void 0 && tt(wt, "message", Pt), it(wt, St, wt.stack, 2), this && nt(bt, this) && st(wt, this, St), arguments.length > ct && et(wt, arguments[ct]), wt;
              });
              if (St.prototype = bt, At !== "Error" ? at ? at(St, Et) : ot(St, Et, { name: !0 }) : ut && mt in xt && (rt(St, xt, mt), rt(St, xt, "prepareStackTrace")), ot(St, xt), !ft)
                try {
                  bt.name !== At && tt(bt, "name", At), bt.constructor = St;
                } catch {
                }
              return St;
            }
          };
        },
        /* 71 */
        /***/
        (a, s, $) => {
          var _ = $(72), _e = $(47), tt = $(73);
          a.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
            var nt = !1, at = {}, ot;
            try {
              ot = _(Object.prototype, "__proto__", "set"), ot(at, []), nt = at instanceof Array;
            } catch {
            }
            return function(st, lt) {
              return _e(st), tt(lt), nt ? ot(st, lt) : st.__proto__ = lt, st;
            };
          }() : void 0);
        },
        /* 72 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = $(31);
          a.exports = function(tt, nt, at) {
            try {
              return _(_e(Object.getOwnPropertyDescriptor(tt, nt)[at]));
            } catch {
            }
          };
        },
        /* 73 */
        /***/
        (a, s, $) => {
          var _ = $(21), _e = String, tt = TypeError;
          a.exports = function(nt) {
            if (typeof nt == "object" || _(nt))
              return nt;
            throw tt("Can't set " + _e(nt) + " as a prototype");
          };
        },
        /* 74 */
        /***/
        (a, s, $) => {
          var _ = $(45).f;
          a.exports = function(_e, tt, nt) {
            nt in _e || _(_e, nt, {
              configurable: !0,
              get: function() {
                return tt[nt];
              },
              set: function(at) {
                tt[nt] = at;
              }
            });
          };
        },
        /* 75 */
        /***/
        (a, s, $) => {
          var _ = $(21), _e = $(20), tt = $(71);
          a.exports = function(nt, at, ot) {
            var rt, st;
            return tt && _(rt = at.constructor) && rt !== ot && _e(st = rt.prototype) && st !== ot.prototype && tt(nt, st), nt;
          };
        },
        /* 76 */
        /***/
        (a, s, $) => {
          var _ = $(77);
          a.exports = function(_e, tt) {
            return _e === void 0 ? arguments.length < 2 ? "" : tt : _(_e);
          };
        },
        /* 77 */
        /***/
        (a, s, $) => {
          var _ = $(78), _e = String;
          a.exports = function(tt) {
            if (_(tt) === "Symbol")
              throw TypeError("Cannot convert a Symbol value to a string");
            return _e(tt);
          };
        },
        /* 78 */
        /***/
        (a, s, $) => {
          var _ = $(79), _e = $(21), tt = $(15), nt = $(34), at = nt("toStringTag"), ot = Object, rt = tt(/* @__PURE__ */ function() {
            return arguments;
          }()) === "Arguments", st = function(lt, et) {
            try {
              return lt[et];
            } catch {
            }
          };
          a.exports = _ ? tt : function(lt) {
            var et, it, ut;
            return lt === void 0 ? "Undefined" : lt === null ? "Null" : typeof (it = st(et = ot(lt), at)) == "string" ? it : rt ? tt(et) : (ut = tt(et)) === "Object" && _e(et.callee) ? "Arguments" : ut;
          };
        },
        /* 79 */
        /***/
        (a, s, $) => {
          var _ = $(34), _e = _("toStringTag"), tt = {};
          tt[_e] = "z", a.exports = String(tt) === "[object z]";
        },
        /* 80 */
        /***/
        (a, s, $) => {
          var _ = $(20), _e = $(44);
          a.exports = function(tt, nt) {
            _(nt) && "cause" in nt && _e(tt, "cause", nt.cause);
          };
        },
        /* 81 */
        /***/
        (a, s, $) => {
          var _ = $(44), _e = $(82), tt = $(83), nt = Error.captureStackTrace;
          a.exports = function(at, ot, rt, st) {
            tt && (nt ? nt(at, ot) : _(at, "stack", _e(rt, st)));
          };
        },
        /* 82 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = Error, tt = _("".replace), nt = function(rt) {
            return String(_e(rt).stack);
          }("zxcasd"), at = /\n\s*at [^:]*:[^\n]*/, ot = at.test(nt);
          a.exports = function(rt, st) {
            if (ot && typeof rt == "string" && !_e.prepareStackTrace)
              for (; st--; )
                rt = tt(rt, at, "");
            return rt;
          };
        },
        /* 83 */
        /***/
        (a, s, $) => {
          var _ = $(7), _e = $(11);
          a.exports = !_(function() {
            var tt = Error("a");
            return "stack" in tt ? (Object.defineProperty(tt, "stack", _e(1, 7)), tt.stack !== 7) : !0;
          });
        },
        /* 84 */
        /***/
        (a, s, $) => {
          var _ = $(48), _e = $(14), tt = $(77), nt = $(85), at = URLSearchParams, ot = at.prototype, rt = _e(ot.append), st = _e(ot.delete), lt = _e(ot.forEach), et = _e([].push), it = new at("a=1&a=2&b=3");
          it.delete("a", 1), it.delete("b", void 0), it + "" != "a=2" && _(ot, "delete", function(ut) {
            var ft = arguments.length, ht = ft < 2 ? void 0 : arguments[1];
            if (ft && ht === void 0)
              return st(this, ut);
            var dt = [];
            lt(this, function(bt, Et) {
              et(dt, {
                key: Et,
                value: bt
              });
            }), nt(ft, 1);
            for (var gt = tt(ut), pt = tt(ht), mt = 0, ct = 0, vt = !1, At = dt.length, xt; mt < At; )
              xt = dt[mt++], vt || xt.key === gt ? (vt = !0, st(this, xt.key)) : ct++;
            for (; ct < At; )
              xt = dt[ct++], xt.key === gt && xt.value === pt || rt(this, xt.key, xt.value);
          }, {
            enumerable: !0,
            unsafe: !0
          });
        },
        /* 85 */
        /***/
        (a) => {
          var s = TypeError;
          a.exports = function($, _) {
            if ($ < _)
              throw s("Not enough arguments");
            return $;
          };
        },
        /* 86 */
        /***/
        (a, s, $) => {
          var _ = $(48), _e = $(14), tt = $(77), nt = $(85), at = URLSearchParams, ot = at.prototype, rt = _e(ot.getAll), st = _e(ot.has), lt = new at("a=1");
          (lt.has("a", 2) || !lt.has("a", void 0)) && _(ot, "has", function(it) {
            var ut = arguments.length, ft = ut < 2 ? void 0 : arguments[1];
            if (ut && ft === void 0)
              return st(this, it);
            var ht = rt(this, it);
            nt(ut, 1);
            for (var dt = tt(ft), gt = 0; gt < ht.length; )
              if (ht[gt++] === dt)
                return !0;
            return !1;
          }, {
            enumerable: !0,
            unsafe: !0
          });
        },
        /* 87 */
        /***/
        (a, s, $) => {
          var _ = $(6), _e = $(14), tt = $(88), nt = URLSearchParams.prototype, at = _e(nt.forEach);
          _ && !("size" in nt) && tt(nt, "size", {
            get: function() {
              var rt = 0;
              return at(this, function() {
                rt++;
              }), rt;
            },
            configurable: !0,
            enumerable: !0
          });
        },
        /* 88 */
        /***/
        (a, s, $) => {
          var _ = $(49), _e = $(45);
          a.exports = function(tt, nt, at) {
            return at.get && _(at.get, nt, { getter: !0 }), at.set && _(at.set, nt, { setter: !0 }), _e.f(tt, nt, at);
          };
        },
        /* 89 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(40), tt = $(64), nt = $(90), at = $(92), ot = $(7), rt = ot(function() {
            return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
          }), st = function() {
            try {
              Object.defineProperty([], "length", { writable: !1 }).push();
            } catch (et) {
              return et instanceof TypeError;
            }
          }, lt = rt || !st();
          _({
            target: "Array",
            proto: !0,
            arity: 1,
            forced: lt
          }, {
            push: function(it) {
              var ut = _e(this), ft = tt(ut), ht = arguments.length;
              at(ft + ht);
              for (var dt = 0; dt < ht; dt++)
                ut[ft] = arguments[dt], ft++;
              return nt(ut, ft), ft;
            }
          });
        },
        /* 90 */
        /***/
        (a, s, $) => {
          var _ = $(6), _e = $(91), tt = TypeError, nt = Object.getOwnPropertyDescriptor, at = _ && !function() {
            if (this !== void 0)
              return !0;
            try {
              Object.defineProperty([], "length", { writable: !1 }).length = 1;
            } catch (ot) {
              return ot instanceof TypeError;
            }
          }();
          a.exports = at ? function(ot, rt) {
            if (_e(ot) && !nt(ot, "length").writable)
              throw tt("Cannot set read only .length");
            return ot.length = rt;
          } : function(ot, rt) {
            return ot.length = rt;
          };
        },
        /* 91 */
        /***/
        (a, s, $) => {
          var _ = $(15);
          a.exports = Array.isArray || function(tt) {
            return _(tt) === "Array";
          };
        },
        /* 92 */
        /***/
        (a) => {
          var s = TypeError, $ = 9007199254740991;
          a.exports = function(_) {
            if (_ > $)
              throw s("Maximum allowed index exceeded");
            return _;
          };
        },
        /* 93 */
        /***/
        (a, s, $) => {
          var _ = $(94), _e = $(98).findLast, tt = _.aTypedArray, nt = _.exportTypedArrayMethod;
          nt("findLast", function(ot) {
            return _e(tt(this), ot, arguments.length > 1 ? arguments[1] : void 0);
          });
        },
        /* 94 */
        /***/
        (a, s, $) => {
          var _ = $(95), _e = $(6), tt = $(4), nt = $(21), at = $(20), ot = $(39), rt = $(78), st = $(32), lt = $(44), et = $(48), it = $(88), ut = $(25), ft = $(96), ht = $(71), dt = $(34), gt = $(41), pt = $(52), mt = pt.enforce, ct = pt.get, vt = tt.Int8Array, At = vt && vt.prototype, xt = tt.Uint8ClampedArray, bt = xt && xt.prototype, Et = vt && ft(vt), St = At && ft(At), Bt = Object.prototype, Ot = tt.TypeError, Pt = dt("toStringTag"), wt = gt("TYPED_ARRAY_TAG"), Ct = "TypedArrayConstructor", It = _ && !!ht && rt(tt.opera) !== "Opera", yt = !1, Rt, kt, jt, Ht = {
            Int8Array: 1,
            Uint8Array: 1,
            Uint8ClampedArray: 1,
            Int16Array: 2,
            Uint16Array: 2,
            Int32Array: 4,
            Uint32Array: 4,
            Float32Array: 4,
            Float64Array: 8
          }, Ft = {
            BigInt64Array: 8,
            BigUint64Array: 8
          }, _t = function(Vt) {
            if (!at(Vt))
              return !1;
            var Qt = rt(Vt);
            return Qt === "DataView" || ot(Ht, Qt) || ot(Ft, Qt);
          }, Nt = function(Ut) {
            var Vt = ft(Ut);
            if (at(Vt)) {
              var Qt = ct(Vt);
              return Qt && ot(Qt, Ct) ? Qt[Ct] : Nt(Vt);
            }
          }, Mt = function(Ut) {
            if (!at(Ut))
              return !1;
            var Vt = rt(Ut);
            return ot(Ht, Vt) || ot(Ft, Vt);
          }, Lt = function(Ut) {
            if (Mt(Ut))
              return Ut;
            throw Ot("Target is not a typed array");
          }, $t = function(Ut) {
            if (nt(Ut) && (!ht || ut(Et, Ut)))
              return Ut;
            throw Ot(st(Ut) + " is not a typed array constructor");
          }, Tt = function(Ut, Vt, Qt, qt) {
            if (_e) {
              if (Qt)
                for (var Zt in Ht) {
                  var ar = tt[Zt];
                  if (ar && ot(ar.prototype, Ut))
                    try {
                      delete ar.prototype[Ut];
                    } catch {
                      try {
                        ar.prototype[Ut] = Vt;
                      } catch {
                      }
                    }
                }
              (!St[Ut] || Qt) && et(St, Ut, Qt ? Vt : It && At[Ut] || Vt, qt);
            }
          }, Dt = function(Ut, Vt, Qt) {
            var qt, Zt;
            if (_e) {
              if (ht) {
                if (Qt) {
                  for (qt in Ht)
                    if (Zt = tt[qt], Zt && ot(Zt, Ut))
                      try {
                        delete Zt[Ut];
                      } catch {
                      }
                }
                if (!Et[Ut] || Qt)
                  try {
                    return et(Et, Ut, Qt ? Vt : It && Et[Ut] || Vt);
                  } catch {
                  }
                else
                  return;
              }
              for (qt in Ht)
                Zt = tt[qt], Zt && (!Zt[Ut] || Qt) && et(Zt, Ut, Vt);
            }
          };
          for (Rt in Ht)
            kt = tt[Rt], jt = kt && kt.prototype, jt ? mt(jt)[Ct] = kt : It = !1;
          for (Rt in Ft)
            kt = tt[Rt], jt = kt && kt.prototype, jt && (mt(jt)[Ct] = kt);
          if ((!It || !nt(Et) || Et === Function.prototype) && (Et = function() {
            throw Ot("Incorrect invocation");
          }, It))
            for (Rt in Ht)
              tt[Rt] && ht(tt[Rt], Et);
          if ((!It || !St || St === Bt) && (St = Et.prototype, It))
            for (Rt in Ht)
              tt[Rt] && ht(tt[Rt].prototype, St);
          if (It && ft(bt) !== St && ht(bt, St), _e && !ot(St, Pt)) {
            yt = !0, it(St, Pt, {
              configurable: !0,
              get: function() {
                return at(this) ? this[wt] : void 0;
              }
            });
            for (Rt in Ht)
              tt[Rt] && lt(tt[Rt], wt, Rt);
          }
          a.exports = {
            NATIVE_ARRAY_BUFFER_VIEWS: It,
            TYPED_ARRAY_TAG: yt && wt,
            aTypedArray: Lt,
            aTypedArrayConstructor: $t,
            exportTypedArrayMethod: Tt,
            exportTypedArrayStaticMethod: Dt,
            getTypedArrayConstructor: Nt,
            isView: _t,
            isTypedArray: Mt,
            TypedArray: Et,
            TypedArrayPrototype: St
          };
        },
        /* 95 */
        /***/
        (a) => {
          a.exports = typeof ArrayBuffer < "u" && typeof DataView < "u";
        },
        /* 96 */
        /***/
        (a, s, $) => {
          var _ = $(39), _e = $(21), tt = $(40), nt = $(54), at = $(97), ot = nt("IE_PROTO"), rt = Object, st = rt.prototype;
          a.exports = at ? rt.getPrototypeOf : function(lt) {
            var et = tt(lt);
            if (_(et, ot))
              return et[ot];
            var it = et.constructor;
            return _e(it) && et instanceof it ? it.prototype : et instanceof rt ? st : null;
          };
        },
        /* 97 */
        /***/
        (a, s, $) => {
          var _ = $(7);
          a.exports = !_(function() {
            function _e() {
            }
            return _e.prototype.constructor = null, Object.getPrototypeOf(new _e()) !== _e.prototype;
          });
        },
        /* 98 */
        /***/
        (a, s, $) => {
          var _ = $(99), _e = $(13), tt = $(40), nt = $(64), at = function(ot) {
            var rt = ot === 1;
            return function(st, lt, et) {
              for (var it = tt(st), ut = _e(it), ft = _(lt, et), ht = nt(ut), dt, gt; ht-- > 0; )
                if (dt = ut[ht], gt = ft(dt, ht, it), gt)
                  switch (ot) {
                    case 0:
                      return dt;
                    case 1:
                      return ht;
                  }
              return rt ? -1 : void 0;
            };
          };
          a.exports = {
            findLast: at(0),
            findLastIndex: at(1)
          };
        },
        /* 99 */
        /***/
        (a, s, $) => {
          var _ = $(100), _e = $(31), tt = $(9), nt = _(_.bind);
          a.exports = function(at, ot) {
            return _e(at), ot === void 0 ? at : tt ? nt(at, ot) : function() {
              return at.apply(ot, arguments);
            };
          };
        },
        /* 100 */
        /***/
        (a, s, $) => {
          var _ = $(15), _e = $(14);
          a.exports = function(tt) {
            if (_(tt) === "Function")
              return _e(tt);
          };
        },
        /* 101 */
        /***/
        (a, s, $) => {
          var _ = $(94), _e = $(98).findLastIndex, tt = _.aTypedArray, nt = _.exportTypedArrayMethod;
          nt("findLastIndex", function(ot) {
            return _e(tt(this), ot, arguments.length > 1 ? arguments[1] : void 0);
          });
        },
        /* 102 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(8), tt = $(94), nt = $(64), at = $(103), ot = $(40), rt = $(7), st = _.RangeError, lt = _.Int8Array, et = lt && lt.prototype, it = et && et.set, ut = tt.aTypedArray, ft = tt.exportTypedArrayMethod, ht = !rt(function() {
            var gt = new Uint8ClampedArray(2);
            return _e(it, gt, {
              length: 1,
              0: 3
            }, 1), gt[1] !== 3;
          }), dt = ht && tt.NATIVE_ARRAY_BUFFER_VIEWS && rt(function() {
            var gt = new lt(2);
            return gt.set(1), gt.set("2", 1), gt[0] !== 0 || gt[1] !== 2;
          });
          ft("set", function(pt) {
            ut(this);
            var mt = at(arguments.length > 1 ? arguments[1] : void 0, 1), ct = ot(pt);
            if (ht)
              return _e(it, this, ct, mt);
            var vt = this.length, At = nt(ct), xt = 0;
            if (At + mt > vt)
              throw st("Wrong length");
            for (; xt < At; )
              this[mt + xt] = ct[xt++];
          }, !ht || dt);
        },
        /* 103 */
        /***/
        (a, s, $) => {
          var _ = $(104), _e = RangeError;
          a.exports = function(tt, nt) {
            var at = _(tt);
            if (at % nt)
              throw _e("Wrong offset");
            return at;
          };
        },
        /* 104 */
        /***/
        (a, s, $) => {
          var _ = $(62), _e = RangeError;
          a.exports = function(tt) {
            var nt = _(tt);
            if (nt < 0)
              throw _e("The argument can't be less than 0");
            return nt;
          };
        },
        /* 105 */
        /***/
        (a, s, $) => {
          var _ = $(106), _e = $(94), tt = _e.aTypedArray, nt = _e.exportTypedArrayMethod, at = _e.getTypedArrayConstructor;
          nt("toReversed", function() {
            return _(tt(this), at(this));
          });
        },
        /* 106 */
        /***/
        (a, s, $) => {
          var _ = $(64);
          a.exports = function(_e, tt) {
            for (var nt = _(_e), at = new tt(nt), ot = 0; ot < nt; ot++)
              at[ot] = _e[nt - ot - 1];
            return at;
          };
        },
        /* 107 */
        /***/
        (a, s, $) => {
          var _ = $(94), _e = $(14), tt = $(31), nt = $(108), at = _.aTypedArray, ot = _.getTypedArrayConstructor, rt = _.exportTypedArrayMethod, st = _e(_.TypedArrayPrototype.sort);
          rt("toSorted", function(et) {
            et !== void 0 && tt(et);
            var it = at(this), ut = nt(ot(it), it);
            return st(ut, et);
          });
        },
        /* 108 */
        /***/
        (a, s, $) => {
          var _ = $(64);
          a.exports = function(_e, tt) {
            for (var nt = 0, at = _(tt), ot = new _e(at); at > nt; )
              ot[nt] = tt[nt++];
            return ot;
          };
        },
        /* 109 */
        /***/
        (a, s, $) => {
          var _ = $(110), _e = $(94), tt = $(111), nt = $(62), at = $(112), ot = _e.aTypedArray, rt = _e.getTypedArrayConstructor, st = _e.exportTypedArrayMethod, lt = !!function() {
            try {
              new Int8Array(1).with(2, {
                valueOf: function() {
                  throw 8;
                }
              });
            } catch (et) {
              return et === 8;
            }
          }();
          st("with", function(et, it) {
            var ut = ot(this), ft = nt(et), ht = tt(ut) ? at(it) : +it;
            return _(ut, rt(ut), ft, ht);
          }, !lt);
        },
        /* 110 */
        /***/
        (a, s, $) => {
          var _ = $(64), _e = $(62), tt = RangeError;
          a.exports = function(nt, at, ot, rt) {
            var st = _(nt), lt = _e(ot), et = lt < 0 ? st + lt : lt;
            if (et >= st || et < 0)
              throw tt("Incorrect index");
            for (var it = new at(st), ut = 0; ut < st; ut++)
              it[ut] = ut === et ? rt : nt[ut];
            return it;
          };
        },
        /* 111 */
        /***/
        (a, s, $) => {
          var _ = $(78);
          a.exports = function(_e) {
            var tt = _(_e);
            return tt === "BigInt64Array" || tt === "BigUint64Array";
          };
        },
        /* 112 */
        /***/
        (a, s, $) => {
          var _ = $(19), _e = TypeError;
          a.exports = function(tt) {
            var nt = _(tt, "number");
            if (typeof nt == "number")
              throw _e("Can't convert number to bigint");
            return BigInt(nt);
          };
        },
        /* 113 */
        /***/
        (a, s, $) => {
          var _ = $(6), _e = $(88), tt = $(114), nt = ArrayBuffer.prototype;
          _ && !("detached" in nt) && _e(nt, "detached", {
            configurable: !0,
            get: function() {
              return tt(this);
            }
          });
        },
        /* 114 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = $(115), tt = _(ArrayBuffer.prototype.slice);
          a.exports = function(nt) {
            if (_e(nt) !== 0)
              return !1;
            try {
              return tt(nt, 0, 0), !1;
            } catch {
              return !0;
            }
          };
        },
        /* 115 */
        /***/
        (a, s, $) => {
          var _ = $(72), _e = $(15), tt = TypeError;
          a.exports = _(ArrayBuffer.prototype, "byteLength", "get") || function(nt) {
            if (_e(nt) !== "ArrayBuffer")
              throw tt("ArrayBuffer expected");
            return nt.byteLength;
          };
        },
        /* 116 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(117);
          _e && _({
            target: "ArrayBuffer",
            proto: !0
          }, {
            transfer: function() {
              return _e(this, arguments.length ? arguments[0] : void 0, !0);
            }
          });
        },
        /* 117 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(14), tt = $(72), nt = $(118), at = $(114), ot = $(115), rt = $(119), st = _.TypeError, lt = _.structuredClone, et = _.ArrayBuffer, it = _.DataView, ut = Math.min, ft = et.prototype, ht = it.prototype, dt = _e(ft.slice), gt = tt(ft, "resizable", "get"), pt = tt(ft, "maxByteLength", "get"), mt = _e(ht.getInt8), ct = _e(ht.setInt8);
          a.exports = rt && function(vt, At, xt) {
            var bt = ot(vt), Et = At === void 0 ? bt : nt(At), St = !gt || !gt(vt);
            if (at(vt))
              throw st("ArrayBuffer is detached");
            var Bt = lt(vt, { transfer: [vt] });
            if (bt === Et && (xt || St))
              return Bt;
            if (bt >= Et && (!xt || St))
              return dt(Bt, 0, Et);
            for (var Ot = xt && !St && pt ? { maxByteLength: pt(Bt) } : void 0, Pt = new et(Et, Ot), wt = new it(Bt), Ct = new it(Pt), It = ut(Et, bt), yt = 0; yt < It; yt++)
              ct(Ct, yt, mt(wt, yt));
            return Pt;
          };
        },
        /* 118 */
        /***/
        (a, s, $) => {
          var _ = $(62), _e = $(65), tt = RangeError;
          a.exports = function(nt) {
            if (nt === void 0)
              return 0;
            var at = _(nt), ot = _e(at);
            if (at !== ot)
              throw tt("Wrong length or index");
            return ot;
          };
        },
        /* 119 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(7), tt = $(28), nt = $(120), at = $(121), ot = $(122), rt = _.structuredClone;
          a.exports = !!rt && !_e(function() {
            if (at && tt > 92 || ot && tt > 94 || nt && tt > 97)
              return !1;
            var st = new ArrayBuffer(8), lt = rt(st, { transfer: [st] });
            return st.byteLength !== 0 || lt.byteLength !== 8;
          });
        },
        /* 120 */
        /***/
        (a, s, $) => {
          var _ = $(121), _e = $(122);
          a.exports = !_ && !_e && typeof window == "object" && typeof document == "object";
        },
        /* 121 */
        /***/
        (a) => {
          a.exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";
        },
        /* 122 */
        /***/
        (a, s, $) => {
          var _ = $(4), _e = $(15);
          a.exports = _e(_.process) === "process";
        },
        /* 123 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(117);
          _e && _({
            target: "ArrayBuffer",
            proto: !0
          }, {
            transferToFixedLength: function() {
              return _e(this, arguments.length ? arguments[0] : void 0, !1);
            }
          });
        },
        /* 124 */
        /***/
        (__unused_webpack_module, exports, __w_pdfjs_require__) => {
          var a, $, _, _e, No, nt, as, ot, rt, st, lt, et, it, ut, ft, ht, is, gt, pt, Os, ct, vt;
          Object.defineProperty(exports, "__esModule", {
            value: !0
          }), exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0, Object.defineProperty(exports, "SVGGraphics", {
            enumerable: !0,
            get: function() {
              return _displaySvg.SVGGraphics;
            }
          }), exports.build = void 0, exports.getDocument = getDocument, exports.version = void 0, __w_pdfjs_require__(84), __w_pdfjs_require__(86), __w_pdfjs_require__(87), __w_pdfjs_require__(2), __w_pdfjs_require__(93), __w_pdfjs_require__(101), __w_pdfjs_require__(102), __w_pdfjs_require__(105), __w_pdfjs_require__(107), __w_pdfjs_require__(109), __w_pdfjs_require__(113), __w_pdfjs_require__(116), __w_pdfjs_require__(123), __w_pdfjs_require__(89), __w_pdfjs_require__(125), __w_pdfjs_require__(136), __w_pdfjs_require__(138), __w_pdfjs_require__(141), __w_pdfjs_require__(143), __w_pdfjs_require__(145), __w_pdfjs_require__(147), __w_pdfjs_require__(149), __w_pdfjs_require__(152);
          var _util = __w_pdfjs_require__(1), _annotation_storage = __w_pdfjs_require__(163), _display_utils = __w_pdfjs_require__(168), _font_loader = __w_pdfjs_require__(171), _displayNode_utils = __w_pdfjs_require__(172), _canvas = __w_pdfjs_require__(173), _worker_options = __w_pdfjs_require__(176), _message_handler = __w_pdfjs_require__(177), _metadata = __w_pdfjs_require__(178), _optional_content_config = __w_pdfjs_require__(179), _transport_stream = __w_pdfjs_require__(180), _displayFetch_stream = __w_pdfjs_require__(181), _displayNetwork = __w_pdfjs_require__(184), _displayNode_stream = __w_pdfjs_require__(185), _displaySvg = __w_pdfjs_require__(186), _xfa_text = __w_pdfjs_require__(194);
          const DEFAULT_RANGE_CHUNK_SIZE = 65536, RENDERING_CANCELLED_TIMEOUT = 100, DELAYED_CLEANUP_TIMEOUT = 5e3, DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
          exports.DefaultCanvasFactory = DefaultCanvasFactory;
          const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
          exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
          const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
          exports.DefaultFilterFactory = DefaultFilterFactory;
          const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
          exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
          function getDocument(xt) {
            if (typeof xt == "string" || xt instanceof URL ? xt = {
              url: xt
            } : (0, _util.isArrayBuffer)(xt) && (xt = {
              data: xt
            }), typeof xt != "object")
              throw new Error("Invalid parameter in getDocument, need parameter object.");
            if (!xt.url && !xt.data && !xt.range)
              throw new Error("Invalid parameter object: need either .data, .range or .url");
            const bt = new PDFDocumentLoadingTask(), {
              docId: Et
            } = bt, St = xt.url ? getUrlProp(xt.url) : null, Bt = xt.data ? getDataProp(xt.data) : null, Ot = xt.httpHeaders || null, Pt = xt.withCredentials === !0, wt = xt.password ?? null, Ct = xt.range instanceof PDFDataRangeTransport ? xt.range : null, It = Number.isInteger(xt.rangeChunkSize) && xt.rangeChunkSize > 0 ? xt.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
            let yt = xt.worker instanceof PDFWorker ? xt.worker : null;
            const Rt = xt.verbosity, kt = typeof xt.docBaseUrl == "string" && !(0, _display_utils.isDataScheme)(xt.docBaseUrl) ? xt.docBaseUrl : null, jt = typeof xt.cMapUrl == "string" ? xt.cMapUrl : null, Ht = xt.cMapPacked !== !1, Ft = xt.CMapReaderFactory || DefaultCMapReaderFactory, _t = typeof xt.standardFontDataUrl == "string" ? xt.standardFontDataUrl : null, Nt = xt.StandardFontDataFactory || DefaultStandardFontDataFactory, Mt = xt.stopAtErrors !== !0, Lt = Number.isInteger(xt.maxImageSize) && xt.maxImageSize > -1 ? xt.maxImageSize : -1, $t = xt.isEvalSupported !== !1, Tt = typeof xt.isOffscreenCanvasSupported == "boolean" ? xt.isOffscreenCanvasSupported : !_util.isNodeJS, Dt = Number.isInteger(xt.canvasMaxAreaInBytes) ? xt.canvasMaxAreaInBytes : -1, Ut = typeof xt.disableFontFace == "boolean" ? xt.disableFontFace : _util.isNodeJS, Vt = xt.fontExtraProperties === !0, Qt = xt.enableXfa === !0, qt = xt.ownerDocument || globalThis.document, Zt = xt.disableRange === !0, ar = xt.disableStream === !0, Jt = xt.disableAutoFetch === !0, rr = xt.pdfBug === !0, Yt = Ct ? Ct.length : xt.length ?? NaN, Kt = typeof xt.useSystemFonts == "boolean" ? xt.useSystemFonts : !_util.isNodeJS && !Ut, nr = typeof xt.useWorkerFetch == "boolean" ? xt.useWorkerFetch : Ft === _display_utils.DOMCMapReaderFactory && Nt === _display_utils.DOMStandardFontDataFactory && jt && _t && (0, _display_utils.isValidFetchUrl)(jt, document.baseURI) && (0, _display_utils.isValidFetchUrl)(_t, document.baseURI), tr = xt.canvasFactory || new DefaultCanvasFactory({
              ownerDocument: qt
            }), ir = xt.filterFactory || new DefaultFilterFactory({
              docId: Et,
              ownerDocument: qt
            }), sr = null;
            (0, _util.setVerbosityLevel)(Rt);
            const cr = {
              canvasFactory: tr,
              filterFactory: ir
            };
            if (nr || (cr.cMapReaderFactory = new Ft({
              baseUrl: jt,
              isCompressed: Ht
            }), cr.standardFontDataFactory = new Nt({
              baseUrl: _t
            })), !yt) {
              const Gt = {
                verbosity: Rt,
                port: _worker_options.GlobalWorkerOptions.workerPort
              };
              yt = Gt.port ? PDFWorker.fromPort(Gt) : new PDFWorker(Gt), bt._worker = yt;
            }
            const or = {
              docId: Et,
              apiVersion: "3.11.174",
              data: Bt,
              password: wt,
              disableAutoFetch: Jt,
              rangeChunkSize: It,
              length: Yt,
              docBaseUrl: kt,
              enableXfa: Qt,
              evaluatorOptions: {
                maxImageSize: Lt,
                disableFontFace: Ut,
                ignoreErrors: Mt,
                isEvalSupported: $t,
                isOffscreenCanvasSupported: Tt,
                canvasMaxAreaInBytes: Dt,
                fontExtraProperties: Vt,
                useSystemFonts: Kt,
                cMapUrl: nr ? jt : null,
                standardFontDataUrl: nr ? _t : null
              }
            }, Xt = {
              ignoreErrors: Mt,
              isEvalSupported: $t,
              disableFontFace: Ut,
              fontExtraProperties: Vt,
              enableXfa: Qt,
              ownerDocument: qt,
              disableAutoFetch: Jt,
              pdfBug: rr,
              styleElement: sr
            };
            return yt.promise.then(function() {
              if (bt.destroyed)
                throw new Error("Loading aborted");
              const Gt = _fetchDocument(yt, or), Wt = new Promise(function(er) {
                let lr;
                Ct ? lr = new _transport_stream.PDFDataTransportStream({
                  length: Yt,
                  initialData: Ct.initialData,
                  progressiveDone: Ct.progressiveDone,
                  contentDispositionFilename: Ct.contentDispositionFilename,
                  disableRange: Zt,
                  disableStream: ar
                }, Ct) : Bt || (lr = ((pr) => _util.isNodeJS ? new _displayNode_stream.PDFNodeStream(pr) : (0, _display_utils.isValidFetchUrl)(pr.url) ? new _displayFetch_stream.PDFFetchStream(pr) : new _displayNetwork.PDFNetworkStream(pr))({
                  url: St,
                  length: Yt,
                  httpHeaders: Ot,
                  withCredentials: Pt,
                  rangeChunkSize: It,
                  disableRange: Zt,
                  disableStream: ar
                })), er(lr);
              });
              return Promise.all([Gt, Wt]).then(function(er) {
                let [lr, ur] = er;
                if (bt.destroyed)
                  throw new Error("Loading aborted");
                const pr = new _message_handler.MessageHandler(Et, lr, yt.port), yr = new WorkerTransport(pr, bt, ur, Xt, cr);
                bt._transport = yr, pr.send("Ready", null);
              });
            }).catch(bt._capability.reject), bt;
          }
          async function _fetchDocument(xt, bt) {
            if (xt.destroyed)
              throw new Error("Worker was destroyed");
            const Et = await xt.messageHandler.sendWithPromise("GetDocRequest", bt, bt.data ? [bt.data.buffer] : null);
            if (xt.destroyed)
              throw new Error("Worker was destroyed");
            return Et;
          }
          function getUrlProp(xt) {
            if (xt instanceof URL)
              return xt.href;
            try {
              return new URL(xt, window.location).href;
            } catch {
              if (_util.isNodeJS && typeof xt == "string")
                return xt;
            }
            throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
          }
          function getDataProp(xt) {
            if (_util.isNodeJS && typeof Buffer < "u" && xt instanceof Buffer)
              throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
            if (xt instanceof Uint8Array && xt.byteLength === xt.buffer.byteLength)
              return xt;
            if (typeof xt == "string")
              return (0, _util.stringToBytes)(xt);
            if (typeof xt == "object" && !isNaN(xt == null ? void 0 : xt.length) || (0, _util.isArrayBuffer)(xt))
              return new Uint8Array(xt);
            throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
          }
          const s = class s {
            constructor() {
              this._capability = new _util.PromiseCapability(), this._transport = null, this._worker = null, this.docId = `d${Wo(s, a)._++}`, this.destroyed = !1, this.onPassword = null, this.onProgress = null;
            }
            get promise() {
              return this._capability.promise;
            }
            async destroy() {
              var bt, Et, St;
              this.destroyed = !0;
              try {
                (bt = this._worker) != null && bt.port && (this._worker._pendingDestroy = !0), await ((Et = this._transport) == null ? void 0 : Et.destroy());
              } catch (Bt) {
                throw (St = this._worker) != null && St.port && delete this._worker._pendingDestroy, Bt;
              }
              this._transport = null, this._worker && (this._worker.destroy(), this._worker = null);
            }
          };
          a = new WeakMap(), _r(s, a, 0);
          let PDFDocumentLoadingTask = s;
          exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
          class PDFDataRangeTransport {
            constructor(bt, Et) {
              let St = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Bt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
              this.length = bt, this.initialData = Et, this.progressiveDone = St, this.contentDispositionFilename = Bt, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._progressiveDoneListeners = [], this._readyCapability = new _util.PromiseCapability();
            }
            addRangeListener(bt) {
              this._rangeListeners.push(bt);
            }
            addProgressListener(bt) {
              this._progressListeners.push(bt);
            }
            addProgressiveReadListener(bt) {
              this._progressiveReadListeners.push(bt);
            }
            addProgressiveDoneListener(bt) {
              this._progressiveDoneListeners.push(bt);
            }
            onDataRange(bt, Et) {
              for (const St of this._rangeListeners)
                St(bt, Et);
            }
            onDataProgress(bt, Et) {
              this._readyCapability.promise.then(() => {
                for (const St of this._progressListeners)
                  St(bt, Et);
              });
            }
            onDataProgressiveRead(bt) {
              this._readyCapability.promise.then(() => {
                for (const Et of this._progressiveReadListeners)
                  Et(bt);
              });
            }
            onDataProgressiveDone() {
              this._readyCapability.promise.then(() => {
                for (const bt of this._progressiveDoneListeners)
                  bt();
              });
            }
            transportReady() {
              this._readyCapability.resolve();
            }
            requestDataRange(bt, Et) {
              (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
            }
            abort() {
            }
          }
          exports.PDFDataRangeTransport = PDFDataRangeTransport;
          class PDFDocumentProxy {
            constructor(bt, Et) {
              this._pdfInfo = bt, this._transport = Et, Object.defineProperty(this, "getJavaScript", {
                value: () => ((0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead."), this.getJSActions().then((St) => {
                  if (!St)
                    return St;
                  const Bt = [];
                  for (const Ot in St)
                    Bt.push(...St[Ot]);
                  return Bt;
                }))
              });
            }
            get annotationStorage() {
              return this._transport.annotationStorage;
            }
            get filterFactory() {
              return this._transport.filterFactory;
            }
            get numPages() {
              return this._pdfInfo.numPages;
            }
            get fingerprints() {
              return this._pdfInfo.fingerprints;
            }
            get isPureXfa() {
              return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
            }
            get allXfaHtml() {
              return this._transport._htmlForXfa;
            }
            getPage(bt) {
              return this._transport.getPage(bt);
            }
            getPageIndex(bt) {
              return this._transport.getPageIndex(bt);
            }
            getDestinations() {
              return this._transport.getDestinations();
            }
            getDestination(bt) {
              return this._transport.getDestination(bt);
            }
            getPageLabels() {
              return this._transport.getPageLabels();
            }
            getPageLayout() {
              return this._transport.getPageLayout();
            }
            getPageMode() {
              return this._transport.getPageMode();
            }
            getViewerPreferences() {
              return this._transport.getViewerPreferences();
            }
            getOpenAction() {
              return this._transport.getOpenAction();
            }
            getAttachments() {
              return this._transport.getAttachments();
            }
            getJSActions() {
              return this._transport.getDocJSActions();
            }
            getOutline() {
              return this._transport.getOutline();
            }
            getOptionalContentConfig() {
              return this._transport.getOptionalContentConfig();
            }
            getPermissions() {
              return this._transport.getPermissions();
            }
            getMetadata() {
              return this._transport.getMetadata();
            }
            getMarkInfo() {
              return this._transport.getMarkInfo();
            }
            getData() {
              return this._transport.getData();
            }
            saveDocument() {
              return this._transport.saveDocument();
            }
            getDownloadInfo() {
              return this._transport.downloadInfoCapability.promise;
            }
            cleanup() {
              let bt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              return this._transport.startCleanup(bt || this.isPureXfa);
            }
            destroy() {
              return this.loadingTask.destroy();
            }
            get loadingParams() {
              return this._transport.loadingParams;
            }
            get loadingTask() {
              return this._transport.loadingTask;
            }
            getFieldObjects() {
              return this._transport.getFieldObjects();
            }
            hasJSActions() {
              return this._transport.hasJSActions();
            }
            getCalculationOrderIds() {
              return this._transport.getCalculationOrderIds();
            }
          }
          exports.PDFDocumentProxy = PDFDocumentProxy;
          class PDFPageProxy {
            constructor(bt, Et, St) {
              _r(this, _e);
              _r(this, nt);
              _r(this, $, null);
              _r(this, _, !1);
              let Bt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
              this._pageIndex = bt, this._pageInfo = Et, this._transport = St, this._stats = Bt ? new _display_utils.StatTimer() : null, this._pdfBug = Bt, this.commonObjs = St.commonObjs, this.objs = new PDFObjects(), this._maybeCleanupAfterRender = !1, this._intentStates = /* @__PURE__ */ new Map(), this.destroyed = !1;
            }
            get pageNumber() {
              return this._pageIndex + 1;
            }
            get rotate() {
              return this._pageInfo.rotate;
            }
            get ref() {
              return this._pageInfo.ref;
            }
            get userUnit() {
              return this._pageInfo.userUnit;
            }
            get view() {
              return this._pageInfo.view;
            }
            getViewport() {
              let {
                scale: bt,
                rotation: Et = this.rotate,
                offsetX: St = 0,
                offsetY: Bt = 0,
                dontFlip: Ot = !1
              } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              return new _display_utils.PageViewport({
                viewBox: this.view,
                scale: bt,
                rotation: Et,
                offsetX: St,
                offsetY: Bt,
                dontFlip: Ot
              });
            }
            getAnnotations() {
              let {
                intent: bt = "display"
              } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              const Et = this._transport.getRenderingIntent(bt);
              return this._transport.getAnnotations(this._pageIndex, Et.renderingIntent);
            }
            getJSActions() {
              return this._transport.getPageJSActions(this._pageIndex);
            }
            get filterFactory() {
              return this._transport.filterFactory;
            }
            get isPureXfa() {
              return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
            }
            async getXfa() {
              var bt;
              return ((bt = this._transport._htmlForXfa) == null ? void 0 : bt.children[this._pageIndex]) || null;
            }
            render(bt) {
              var Mt, Lt;
              let {
                canvasContext: Et,
                viewport: St,
                intent: Bt = "display",
                annotationMode: Ot = _util.AnnotationMode.ENABLE,
                transform: Pt = null,
                background: wt = null,
                optionalContentConfigPromise: Ct = null,
                annotationCanvasMap: It = null,
                pageColors: yt = null,
                printAnnotationStorage: Rt = null
              } = bt;
              (Mt = this._stats) == null || Mt.time("Overall");
              const kt = this._transport.getRenderingIntent(Bt, Ot, Rt);
              tn(this, _, !1), Ur(this, nt, as).call(this), Ct || (Ct = this._transport.getOptionalContentConfig());
              let jt = this._intentStates.get(kt.cacheKey);
              jt || (jt = /* @__PURE__ */ Object.create(null), this._intentStates.set(kt.cacheKey, jt)), jt.streamReaderCancelTimeout && (clearTimeout(jt.streamReaderCancelTimeout), jt.streamReaderCancelTimeout = null);
              const Ht = !!(kt.renderingIntent & _util.RenderingIntentFlag.PRINT);
              jt.displayReadyCapability || (jt.displayReadyCapability = new _util.PromiseCapability(), jt.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: !1,
                separateAnnots: null
              }, (Lt = this._stats) == null || Lt.time("Page Request"), this._pumpOperatorList(kt));
              const Ft = ($t) => {
                var Tt, Dt;
                jt.renderTasks.delete(_t), (this._maybeCleanupAfterRender || Ht) && tn(this, _, !0), Ur(this, _e, No).call(this, !Ht), $t ? (_t.capability.reject($t), this._abortOperatorList({
                  intentState: jt,
                  reason: $t instanceof Error ? $t : new Error($t)
                })) : _t.capability.resolve(), (Tt = this._stats) == null || Tt.timeEnd("Rendering"), (Dt = this._stats) == null || Dt.timeEnd("Overall");
              }, _t = new InternalRenderTask({
                callback: Ft,
                params: {
                  canvasContext: Et,
                  viewport: St,
                  transform: Pt,
                  background: wt
                },
                objs: this.objs,
                commonObjs: this.commonObjs,
                annotationCanvasMap: It,
                operatorList: jt.operatorList,
                pageIndex: this._pageIndex,
                canvasFactory: this._transport.canvasFactory,
                filterFactory: this._transport.filterFactory,
                useRequestAnimationFrame: !Ht,
                pdfBug: this._pdfBug,
                pageColors: yt
              });
              (jt.renderTasks || (jt.renderTasks = /* @__PURE__ */ new Set())).add(_t);
              const Nt = _t.task;
              return Promise.all([jt.displayReadyCapability.promise, Ct]).then(($t) => {
                var Ut;
                let [Tt, Dt] = $t;
                if (this.destroyed) {
                  Ft();
                  return;
                }
                (Ut = this._stats) == null || Ut.time("Rendering"), _t.initializeGraphics({
                  transparency: Tt,
                  optionalContentConfig: Dt
                }), _t.operatorListChanged();
              }).catch(Ft), Nt;
            }
            getOperatorList() {
              var Ct;
              let {
                intent: bt = "display",
                annotationMode: Et = _util.AnnotationMode.ENABLE,
                printAnnotationStorage: St = null
              } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              function Bt() {
                Pt.operatorList.lastChunk && (Pt.opListReadCapability.resolve(Pt.operatorList), Pt.renderTasks.delete(wt));
              }
              const Ot = this._transport.getRenderingIntent(bt, Et, St, !0);
              let Pt = this._intentStates.get(Ot.cacheKey);
              Pt || (Pt = /* @__PURE__ */ Object.create(null), this._intentStates.set(Ot.cacheKey, Pt));
              let wt;
              return Pt.opListReadCapability || (wt = /* @__PURE__ */ Object.create(null), wt.operatorListChanged = Bt, Pt.opListReadCapability = new _util.PromiseCapability(), (Pt.renderTasks || (Pt.renderTasks = /* @__PURE__ */ new Set())).add(wt), Pt.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: !1,
                separateAnnots: null
              }, (Ct = this._stats) == null || Ct.time("Page Request"), this._pumpOperatorList(Ot)), Pt.opListReadCapability.promise;
            }
            streamTextContent() {
              let {
                includeMarkedContent: bt = !1,
                disableNormalization: Et = !1
              } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              const St = 100;
              return this._transport.messageHandler.sendWithStream("GetTextContent", {
                pageIndex: this._pageIndex,
                includeMarkedContent: bt === !0,
                disableNormalization: Et === !0
              }, {
                highWaterMark: St,
                size(Bt) {
                  return Bt.items.length;
                }
              });
            }
            getTextContent() {
              let bt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              if (this._transport._htmlForXfa)
                return this.getXfa().then((St) => _xfa_text.XfaText.textContent(St));
              const Et = this.streamTextContent(bt);
              return new Promise(function(St, Bt) {
                function Ot() {
                  Pt.read().then(function(Ct) {
                    let {
                      value: It,
                      done: yt
                    } = Ct;
                    if (yt) {
                      St(wt);
                      return;
                    }
                    Object.assign(wt.styles, It.styles), wt.items.push(...It.items), Ot();
                  }, Bt);
                }
                const Pt = Et.getReader(), wt = {
                  items: [],
                  styles: /* @__PURE__ */ Object.create(null)
                };
                Ot();
              });
            }
            getStructTree() {
              return this._transport.getStructTree(this._pageIndex);
            }
            _destroy() {
              this.destroyed = !0;
              const bt = [];
              for (const Et of this._intentStates.values())
                if (this._abortOperatorList({
                  intentState: Et,
                  reason: new Error("Page was destroyed."),
                  force: !0
                }), !Et.opListReadCapability)
                  for (const St of Et.renderTasks)
                    bt.push(St.completed), St.cancel();
              return this.objs.clear(), tn(this, _, !1), Ur(this, nt, as).call(this), Promise.all(bt);
            }
            cleanup() {
              let bt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              tn(this, _, !0);
              const Et = Ur(this, _e, No).call(this, !1);
              return bt && Et && this._stats && (this._stats = new _display_utils.StatTimer()), Et;
            }
            _startRenderPage(bt, Et) {
              var Bt, Ot;
              const St = this._intentStates.get(Et);
              St && ((Bt = this._stats) == null || Bt.timeEnd("Page Request"), (Ot = St.displayReadyCapability) == null || Ot.resolve(bt));
            }
            _renderPageChunk(bt, Et) {
              for (let St = 0, Bt = bt.length; St < Bt; St++)
                Et.operatorList.fnArray.push(bt.fnArray[St]), Et.operatorList.argsArray.push(bt.argsArray[St]);
              Et.operatorList.lastChunk = bt.lastChunk, Et.operatorList.separateAnnots = bt.separateAnnots;
              for (const St of Et.renderTasks)
                St.operatorListChanged();
              bt.lastChunk && Ur(this, _e, No).call(this, !0);
            }
            _pumpOperatorList(bt) {
              let {
                renderingIntent: Et,
                cacheKey: St,
                annotationStorageSerializable: Bt
              } = bt;
              const {
                map: Ot,
                transfers: Pt
              } = Bt, Ct = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                pageIndex: this._pageIndex,
                intent: Et,
                cacheKey: St,
                annotationStorage: Ot
              }, Pt).getReader(), It = this._intentStates.get(St);
              It.streamReader = Ct;
              const yt = () => {
                Ct.read().then((Rt) => {
                  let {
                    value: kt,
                    done: jt
                  } = Rt;
                  if (jt) {
                    It.streamReader = null;
                    return;
                  }
                  this._transport.destroyed || (this._renderPageChunk(kt, It), yt());
                }, (Rt) => {
                  if (It.streamReader = null, !this._transport.destroyed) {
                    if (It.operatorList) {
                      It.operatorList.lastChunk = !0;
                      for (const kt of It.renderTasks)
                        kt.operatorListChanged();
                      Ur(this, _e, No).call(this, !0);
                    }
                    if (It.displayReadyCapability)
                      It.displayReadyCapability.reject(Rt);
                    else if (It.opListReadCapability)
                      It.opListReadCapability.reject(Rt);
                    else
                      throw Rt;
                  }
                });
              };
              yt();
            }
            _abortOperatorList(bt) {
              let {
                intentState: Et,
                reason: St,
                force: Bt = !1
              } = bt;
              if (Et.streamReader) {
                if (Et.streamReaderCancelTimeout && (clearTimeout(Et.streamReaderCancelTimeout), Et.streamReaderCancelTimeout = null), !Bt) {
                  if (Et.renderTasks.size > 0)
                    return;
                  if (St instanceof _display_utils.RenderingCancelledException) {
                    let Ot = RENDERING_CANCELLED_TIMEOUT;
                    St.extraDelay > 0 && St.extraDelay < 1e3 && (Ot += St.extraDelay), Et.streamReaderCancelTimeout = setTimeout(() => {
                      Et.streamReaderCancelTimeout = null, this._abortOperatorList({
                        intentState: Et,
                        reason: St,
                        force: !0
                      });
                    }, Ot);
                    return;
                  }
                }
                if (Et.streamReader.cancel(new _util.AbortException(St.message)).catch(() => {
                }), Et.streamReader = null, !this._transport.destroyed) {
                  for (const [Ot, Pt] of this._intentStates)
                    if (Pt === Et) {
                      this._intentStates.delete(Ot);
                      break;
                    }
                  this.cleanup();
                }
              }
            }
            get stats() {
              return this._stats;
            }
          }
          $ = new WeakMap(), _ = new WeakMap(), _e = new WeakSet(), No = function() {
            let bt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
            if (Ur(this, nt, as).call(this), !mr(this, _) || this.destroyed)
              return !1;
            if (bt)
              return tn(this, $, setTimeout(() => {
                tn(this, $, null), Ur(this, _e, No).call(this, !1);
              }, DELAYED_CLEANUP_TIMEOUT)), !1;
            for (const {
              renderTasks: Et,
              operatorList: St
            } of this._intentStates.values())
              if (Et.size > 0 || !St.lastChunk)
                return !1;
            return this._intentStates.clear(), this.objs.clear(), tn(this, _, !1), !0;
          }, nt = new WeakSet(), as = function() {
            mr(this, $) && (clearTimeout(mr(this, $)), tn(this, $, null));
          }, exports.PDFPageProxy = PDFPageProxy;
          class LoopbackPort {
            constructor() {
              _r(this, ot, /* @__PURE__ */ new Set());
              _r(this, rt, Promise.resolve());
            }
            postMessage(bt, Et) {
              const St = {
                data: structuredClone(bt, null)
              };
              mr(this, rt).then(() => {
                for (const Bt of mr(this, ot))
                  Bt.call(this, St);
              });
            }
            addEventListener(bt, Et) {
              mr(this, ot).add(Et);
            }
            removeEventListener(bt, Et) {
              mr(this, ot).delete(Et);
            }
            terminate() {
              mr(this, ot).clear();
            }
          }
          ot = new WeakMap(), rt = new WeakMap(), exports.LoopbackPort = LoopbackPort;
          const PDFWorkerUtil = {
            isWorkerDisabled: !1,
            fallbackWorkerSrc: null,
            fakeWorkerId: 0
          };
          exports.PDFWorkerUtil = PDFWorkerUtil;
          {
            if (_util.isNodeJS && typeof commonjsRequire == "function")
              PDFWorkerUtil.isWorkerDisabled = !0, PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
            else if (typeof document == "object") {
              const xt = (st = document == null ? void 0 : document.currentScript) == null ? void 0 : st.src;
              xt && (PDFWorkerUtil.fallbackWorkerSrc = xt.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2"));
            }
            PDFWorkerUtil.isSameOrigin = function(xt, bt) {
              let Et;
              try {
                if (Et = new URL(xt), !Et.origin || Et.origin === "null")
                  return !1;
              } catch {
                return !1;
              }
              const St = new URL(bt, Et);
              return Et.origin === St.origin;
            }, PDFWorkerUtil.createCDNWrapper = function(xt) {
              const bt = `importScripts("${xt}");`;
              return URL.createObjectURL(new Blob([bt]));
            };
          }
          const _PDFWorker = class _PDFWorker {
            constructor() {
              var St;
              let {
                name: xt = null,
                port: bt = null,
                verbosity: Et = (0, _util.getVerbosityLevel)()
              } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              if (this.name = xt, this.destroyed = !1, this.verbosity = Et, this._readyCapability = new _util.PromiseCapability(), this._port = null, this._webWorker = null, this._messageHandler = null, bt) {
                if ((St = mr(_PDFWorker, lt)) != null && St.has(bt))
                  throw new Error("Cannot use more than one PDFWorker per port.");
                (mr(_PDFWorker, lt) || tn(_PDFWorker, lt, /* @__PURE__ */ new WeakMap())).set(bt, this), this._initializeFromPort(bt);
                return;
              }
              this._initialize();
            }
            get promise() {
              return this._readyCapability.promise;
            }
            get port() {
              return this._port;
            }
            get messageHandler() {
              return this._messageHandler;
            }
            _initializeFromPort(xt) {
              this._port = xt, this._messageHandler = new _message_handler.MessageHandler("main", "worker", xt), this._messageHandler.on("ready", function() {
              }), this._readyCapability.resolve(), this._messageHandler.send("configure", {
                verbosity: this.verbosity
              });
            }
            _initialize() {
              if (!PDFWorkerUtil.isWorkerDisabled && !_PDFWorker._mainThreadWorkerMessageHandler) {
                let {
                  workerSrc: xt
                } = _PDFWorker;
                try {
                  PDFWorkerUtil.isSameOrigin(window.location.href, xt) || (xt = PDFWorkerUtil.createCDNWrapper(new URL(xt, window.location).href));
                  const bt = new Worker(xt), Et = new _message_handler.MessageHandler("main", "worker", bt), St = () => {
                    bt.removeEventListener("error", Bt), Et.destroy(), bt.terminate(), this.destroyed ? this._readyCapability.reject(new Error("Worker was destroyed")) : this._setupFakeWorker();
                  }, Bt = () => {
                    this._webWorker || St();
                  };
                  bt.addEventListener("error", Bt), Et.on("test", (Pt) => {
                    if (bt.removeEventListener("error", Bt), this.destroyed) {
                      St();
                      return;
                    }
                    Pt ? (this._messageHandler = Et, this._port = bt, this._webWorker = bt, this._readyCapability.resolve(), Et.send("configure", {
                      verbosity: this.verbosity
                    })) : (this._setupFakeWorker(), Et.destroy(), bt.terminate());
                  }), Et.on("ready", (Pt) => {
                    if (bt.removeEventListener("error", Bt), this.destroyed) {
                      St();
                      return;
                    }
                    try {
                      Ot();
                    } catch {
                      this._setupFakeWorker();
                    }
                  });
                  const Ot = () => {
                    const Pt = new Uint8Array();
                    Et.send("test", Pt, [Pt.buffer]);
                  };
                  Ot();
                  return;
                } catch {
                  (0, _util.info)("The worker has been disabled.");
                }
              }
              this._setupFakeWorker();
            }
            _setupFakeWorker() {
              PDFWorkerUtil.isWorkerDisabled || ((0, _util.warn)("Setting up fake worker."), PDFWorkerUtil.isWorkerDisabled = !0), _PDFWorker._setupFakeWorkerGlobal.then((xt) => {
                if (this.destroyed) {
                  this._readyCapability.reject(new Error("Worker was destroyed"));
                  return;
                }
                const bt = new LoopbackPort();
                this._port = bt;
                const Et = `fake${PDFWorkerUtil.fakeWorkerId++}`, St = new _message_handler.MessageHandler(Et + "_worker", Et, bt);
                xt.setup(St, bt);
                const Bt = new _message_handler.MessageHandler(Et, Et + "_worker", bt);
                this._messageHandler = Bt, this._readyCapability.resolve(), Bt.send("configure", {
                  verbosity: this.verbosity
                });
              }).catch((xt) => {
                this._readyCapability.reject(new Error(`Setting up fake worker failed: "${xt.message}".`));
              });
            }
            destroy() {
              var xt;
              this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), (xt = mr(_PDFWorker, lt)) == null || xt.delete(this._port), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
            }
            static fromPort(xt) {
              var Et;
              if (!(xt != null && xt.port))
                throw new Error("PDFWorker.fromPort - invalid method signature.");
              const bt = (Et = mr(this, lt)) == null ? void 0 : Et.get(xt.port);
              if (bt) {
                if (bt._pendingDestroy)
                  throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                return bt;
              }
              return new _PDFWorker(xt);
            }
            static get workerSrc() {
              if (_worker_options.GlobalWorkerOptions.workerSrc)
                return _worker_options.GlobalWorkerOptions.workerSrc;
              if (PDFWorkerUtil.fallbackWorkerSrc !== null)
                return _util.isNodeJS || (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.'), PDFWorkerUtil.fallbackWorkerSrc;
              throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
            }
            static get _mainThreadWorkerMessageHandler() {
              var xt;
              try {
                return ((xt = globalThis.pdfjsWorker) == null ? void 0 : xt.WorkerMessageHandler) || null;
              } catch {
                return null;
              }
            }
            static get _setupFakeWorkerGlobal() {
              const loader = async () => {
                const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                if (mainWorkerMessageHandler)
                  return mainWorkerMessageHandler;
                if (_util.isNodeJS && typeof commonjsRequire == "function") {
                  const worker = eval("require")(this.workerSrc);
                  return worker.WorkerMessageHandler;
                }
                return await (0, _display_utils.loadScript)(this.workerSrc), window.pdfjsWorker.WorkerMessageHandler;
              };
              return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
            }
          };
          lt = new WeakMap(), _r(_PDFWorker, lt, void 0);
          let PDFWorker = _PDFWorker;
          exports.PDFWorker = PDFWorker;
          class WorkerTransport {
            constructor(bt, Et, St, Bt, Ot) {
              _r(this, ht);
              _r(this, et, /* @__PURE__ */ new Map());
              _r(this, it, /* @__PURE__ */ new Map());
              _r(this, ut, /* @__PURE__ */ new Map());
              _r(this, ft, null);
              this.messageHandler = bt, this.loadingTask = Et, this.commonObjs = new PDFObjects(), this.fontLoader = new _font_loader.FontLoader({
                ownerDocument: Bt.ownerDocument,
                styleElement: Bt.styleElement
              }), this._params = Bt, this.canvasFactory = Ot.canvasFactory, this.filterFactory = Ot.filterFactory, this.cMapReaderFactory = Ot.cMapReaderFactory, this.standardFontDataFactory = Ot.standardFontDataFactory, this.destroyed = !1, this.destroyCapability = null, this._networkStream = St, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = new _util.PromiseCapability(), this.setupMessageHandler();
            }
            get annotationStorage() {
              return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
            }
            getRenderingIntent(bt) {
              let Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _util.AnnotationMode.ENABLE, St = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, Bt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, Ot = _util.RenderingIntentFlag.DISPLAY, Pt = _annotation_storage.SerializableEmpty;
              switch (bt) {
                case "any":
                  Ot = _util.RenderingIntentFlag.ANY;
                  break;
                case "display":
                  break;
                case "print":
                  Ot = _util.RenderingIntentFlag.PRINT;
                  break;
                default:
                  (0, _util.warn)(`getRenderingIntent - invalid intent: ${bt}`);
              }
              switch (Et) {
                case _util.AnnotationMode.DISABLE:
                  Ot += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                  break;
                case _util.AnnotationMode.ENABLE:
                  break;
                case _util.AnnotationMode.ENABLE_FORMS:
                  Ot += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                  break;
                case _util.AnnotationMode.ENABLE_STORAGE:
                  Ot += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE, Pt = (Ot & _util.RenderingIntentFlag.PRINT && St instanceof _annotation_storage.PrintAnnotationStorage ? St : this.annotationStorage).serializable;
                  break;
                default:
                  (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${Et}`);
              }
              return Bt && (Ot += _util.RenderingIntentFlag.OPLIST), {
                renderingIntent: Ot,
                cacheKey: `${Ot}_${Pt.hash}`,
                annotationStorageSerializable: Pt
              };
            }
            destroy() {
              var St;
              if (this.destroyCapability)
                return this.destroyCapability.promise;
              this.destroyed = !0, this.destroyCapability = new _util.PromiseCapability(), (St = mr(this, ft)) == null || St.reject(new Error("Worker was destroyed during onPassword callback"));
              const bt = [];
              for (const Bt of mr(this, it).values())
                bt.push(Bt._destroy());
              mr(this, it).clear(), mr(this, ut).clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
              const Et = this.messageHandler.sendWithPromise("Terminate", null);
              return bt.push(Et), Promise.all(bt).then(() => {
                var Bt;
                this.commonObjs.clear(), this.fontLoader.clear(), mr(this, et).clear(), this.filterFactory.destroy(), (Bt = this._networkStream) == null || Bt.cancelAllRequests(new _util.AbortException("Worker was terminated.")), this.messageHandler && (this.messageHandler.destroy(), this.messageHandler = null), this.destroyCapability.resolve();
              }, this.destroyCapability.reject), this.destroyCapability.promise;
            }
            setupMessageHandler() {
              const {
                messageHandler: bt,
                loadingTask: Et
              } = this;
              bt.on("GetReader", (St, Bt) => {
                (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (Ot) => {
                  this._lastProgress = {
                    loaded: Ot.loaded,
                    total: Ot.total
                  };
                }, Bt.onPull = () => {
                  this._fullReader.read().then(function(Ot) {
                    let {
                      value: Pt,
                      done: wt
                    } = Ot;
                    if (wt) {
                      Bt.close();
                      return;
                    }
                    (0, _util.assert)(Pt instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer."), Bt.enqueue(new Uint8Array(Pt), 1, [Pt]);
                  }).catch((Ot) => {
                    Bt.error(Ot);
                  });
                }, Bt.onCancel = (Ot) => {
                  this._fullReader.cancel(Ot), Bt.ready.catch((Pt) => {
                    if (!this.destroyed)
                      throw Pt;
                  });
                };
              }), bt.on("ReaderHeadersReady", (St) => {
                const Bt = new _util.PromiseCapability(), Ot = this._fullReader;
                return Ot.headersReady.then(() => {
                  var Pt;
                  (!Ot.isStreamingSupported || !Ot.isRangeSupported) && (this._lastProgress && ((Pt = Et.onProgress) == null || Pt.call(Et, this._lastProgress)), Ot.onProgress = (wt) => {
                    var Ct;
                    (Ct = Et.onProgress) == null || Ct.call(Et, {
                      loaded: wt.loaded,
                      total: wt.total
                    });
                  }), Bt.resolve({
                    isStreamingSupported: Ot.isStreamingSupported,
                    isRangeSupported: Ot.isRangeSupported,
                    contentLength: Ot.contentLength
                  });
                }, Bt.reject), Bt.promise;
              }), bt.on("GetRangeReader", (St, Bt) => {
                (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                const Ot = this._networkStream.getRangeReader(St.begin, St.end);
                if (!Ot) {
                  Bt.close();
                  return;
                }
                Bt.onPull = () => {
                  Ot.read().then(function(Pt) {
                    let {
                      value: wt,
                      done: Ct
                    } = Pt;
                    if (Ct) {
                      Bt.close();
                      return;
                    }
                    (0, _util.assert)(wt instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer."), Bt.enqueue(new Uint8Array(wt), 1, [wt]);
                  }).catch((Pt) => {
                    Bt.error(Pt);
                  });
                }, Bt.onCancel = (Pt) => {
                  Ot.cancel(Pt), Bt.ready.catch((wt) => {
                    if (!this.destroyed)
                      throw wt;
                  });
                };
              }), bt.on("GetDoc", (St) => {
                let {
                  pdfInfo: Bt
                } = St;
                this._numPages = Bt.numPages, this._htmlForXfa = Bt.htmlForXfa, delete Bt.htmlForXfa, Et._capability.resolve(new PDFDocumentProxy(Bt, this));
              }), bt.on("DocException", function(St) {
                let Bt;
                switch (St.name) {
                  case "PasswordException":
                    Bt = new _util.PasswordException(St.message, St.code);
                    break;
                  case "InvalidPDFException":
                    Bt = new _util.InvalidPDFException(St.message);
                    break;
                  case "MissingPDFException":
                    Bt = new _util.MissingPDFException(St.message);
                    break;
                  case "UnexpectedResponseException":
                    Bt = new _util.UnexpectedResponseException(St.message, St.status);
                    break;
                  case "UnknownErrorException":
                    Bt = new _util.UnknownErrorException(St.message, St.details);
                    break;
                  default:
                    (0, _util.unreachable)("DocException - expected a valid Error.");
                }
                Et._capability.reject(Bt);
              }), bt.on("PasswordRequest", (St) => {
                if (tn(this, ft, new _util.PromiseCapability()), Et.onPassword) {
                  const Bt = (Ot) => {
                    Ot instanceof Error ? mr(this, ft).reject(Ot) : mr(this, ft).resolve({
                      password: Ot
                    });
                  };
                  try {
                    Et.onPassword(Bt, St.code);
                  } catch (Ot) {
                    mr(this, ft).reject(Ot);
                  }
                } else
                  mr(this, ft).reject(new _util.PasswordException(St.message, St.code));
                return mr(this, ft).promise;
              }), bt.on("DataLoaded", (St) => {
                var Bt;
                (Bt = Et.onProgress) == null || Bt.call(Et, {
                  loaded: St.length,
                  total: St.length
                }), this.downloadInfoCapability.resolve(St);
              }), bt.on("StartRenderPage", (St) => {
                if (this.destroyed)
                  return;
                mr(this, it).get(St.pageIndex)._startRenderPage(St.transparency, St.cacheKey);
              }), bt.on("commonobj", (St) => {
                var wt;
                let [Bt, Ot, Pt] = St;
                if (!this.destroyed && !this.commonObjs.has(Bt))
                  switch (Ot) {
                    case "Font":
                      const Ct = this._params;
                      if ("error" in Pt) {
                        const Rt = Pt.error;
                        (0, _util.warn)(`Error during font loading: ${Rt}`), this.commonObjs.resolve(Bt, Rt);
                        break;
                      }
                      const It = Ct.pdfBug && ((wt = globalThis.FontInspector) != null && wt.enabled) ? (Rt, kt) => globalThis.FontInspector.fontAdded(Rt, kt) : null, yt = new _font_loader.FontFaceObject(Pt, {
                        isEvalSupported: Ct.isEvalSupported,
                        disableFontFace: Ct.disableFontFace,
                        ignoreErrors: Ct.ignoreErrors,
                        inspectFont: It
                      });
                      this.fontLoader.bind(yt).catch((Rt) => bt.sendWithPromise("FontFallback", {
                        id: Bt
                      })).finally(() => {
                        !Ct.fontExtraProperties && yt.data && (yt.data = null), this.commonObjs.resolve(Bt, yt);
                      });
                      break;
                    case "FontPath":
                    case "Image":
                    case "Pattern":
                      this.commonObjs.resolve(Bt, Pt);
                      break;
                    default:
                      throw new Error(`Got unknown common object type ${Ot}`);
                  }
              }), bt.on("obj", (St) => {
                var It;
                let [Bt, Ot, Pt, wt] = St;
                if (this.destroyed)
                  return;
                const Ct = mr(this, it).get(Ot);
                if (!Ct.objs.has(Bt))
                  switch (Pt) {
                    case "Image":
                      if (Ct.objs.resolve(Bt, wt), wt) {
                        let yt;
                        if (wt.bitmap) {
                          const {
                            width: Rt,
                            height: kt
                          } = wt;
                          yt = Rt * kt * 4;
                        } else
                          yt = ((It = wt.data) == null ? void 0 : It.length) || 0;
                        yt > _util.MAX_IMAGE_SIZE_TO_CACHE && (Ct._maybeCleanupAfterRender = !0);
                      }
                      break;
                    case "Pattern":
                      Ct.objs.resolve(Bt, wt);
                      break;
                    default:
                      throw new Error(`Got unknown object type ${Pt}`);
                  }
              }), bt.on("DocProgress", (St) => {
                var Bt;
                this.destroyed || (Bt = Et.onProgress) == null || Bt.call(Et, {
                  loaded: St.loaded,
                  total: St.total
                });
              }), bt.on("FetchBuiltInCMap", (St) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.cMapReaderFactory ? this.cMapReaderFactory.fetch(St) : Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."))), bt.on("FetchStandardFontData", (St) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.standardFontDataFactory ? this.standardFontDataFactory.fetch(St) : Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.")));
            }
            getData() {
              return this.messageHandler.sendWithPromise("GetData", null);
            }
            saveDocument() {
              var St;
              this.annotationStorage.size <= 0 && (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
              const {
                map: bt,
                transfers: Et
              } = this.annotationStorage.serializable;
              return this.messageHandler.sendWithPromise("SaveDocument", {
                isPureXfa: !!this._htmlForXfa,
                numPages: this._numPages,
                annotationStorage: bt,
                filename: ((St = this._fullReader) == null ? void 0 : St.filename) ?? null
              }, Et).finally(() => {
                this.annotationStorage.resetModified();
              });
            }
            getPage(bt) {
              if (!Number.isInteger(bt) || bt <= 0 || bt > this._numPages)
                return Promise.reject(new Error("Invalid page request."));
              const Et = bt - 1, St = mr(this, ut).get(Et);
              if (St)
                return St;
              const Bt = this.messageHandler.sendWithPromise("GetPage", {
                pageIndex: Et
              }).then((Ot) => {
                if (this.destroyed)
                  throw new Error("Transport destroyed");
                const Pt = new PDFPageProxy(Et, Ot, this, this._params.pdfBug);
                return mr(this, it).set(Et, Pt), Pt;
              });
              return mr(this, ut).set(Et, Bt), Bt;
            }
            getPageIndex(bt) {
              return typeof bt != "object" || bt === null || !Number.isInteger(bt.num) || bt.num < 0 || !Number.isInteger(bt.gen) || bt.gen < 0 ? Promise.reject(new Error("Invalid pageIndex request.")) : this.messageHandler.sendWithPromise("GetPageIndex", {
                num: bt.num,
                gen: bt.gen
              });
            }
            getAnnotations(bt, Et) {
              return this.messageHandler.sendWithPromise("GetAnnotations", {
                pageIndex: bt,
                intent: Et
              });
            }
            getFieldObjects() {
              return Ur(this, ht, is).call(this, "GetFieldObjects");
            }
            hasJSActions() {
              return Ur(this, ht, is).call(this, "HasJSActions");
            }
            getCalculationOrderIds() {
              return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
            }
            getDestinations() {
              return this.messageHandler.sendWithPromise("GetDestinations", null);
            }
            getDestination(bt) {
              return typeof bt != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
                id: bt
              });
            }
            getPageLabels() {
              return this.messageHandler.sendWithPromise("GetPageLabels", null);
            }
            getPageLayout() {
              return this.messageHandler.sendWithPromise("GetPageLayout", null);
            }
            getPageMode() {
              return this.messageHandler.sendWithPromise("GetPageMode", null);
            }
            getViewerPreferences() {
              return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
            }
            getOpenAction() {
              return this.messageHandler.sendWithPromise("GetOpenAction", null);
            }
            getAttachments() {
              return this.messageHandler.sendWithPromise("GetAttachments", null);
            }
            getDocJSActions() {
              return Ur(this, ht, is).call(this, "GetDocJSActions");
            }
            getPageJSActions(bt) {
              return this.messageHandler.sendWithPromise("GetPageJSActions", {
                pageIndex: bt
              });
            }
            getStructTree(bt) {
              return this.messageHandler.sendWithPromise("GetStructTree", {
                pageIndex: bt
              });
            }
            getOutline() {
              return this.messageHandler.sendWithPromise("GetOutline", null);
            }
            getOptionalContentConfig() {
              return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((bt) => new _optional_content_config.OptionalContentConfig(bt));
            }
            getPermissions() {
              return this.messageHandler.sendWithPromise("GetPermissions", null);
            }
            getMetadata() {
              const bt = "GetMetadata", Et = mr(this, et).get(bt);
              if (Et)
                return Et;
              const St = this.messageHandler.sendWithPromise(bt, null).then((Bt) => {
                var Ot, Pt;
                return {
                  info: Bt[0],
                  metadata: Bt[1] ? new _metadata.Metadata(Bt[1]) : null,
                  contentDispositionFilename: ((Ot = this._fullReader) == null ? void 0 : Ot.filename) ?? null,
                  contentLength: ((Pt = this._fullReader) == null ? void 0 : Pt.contentLength) ?? null
                };
              });
              return mr(this, et).set(bt, St), St;
            }
            getMarkInfo() {
              return this.messageHandler.sendWithPromise("GetMarkInfo", null);
            }
            async startCleanup() {
              let bt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              if (!this.destroyed) {
                await this.messageHandler.sendWithPromise("Cleanup", null);
                for (const Et of mr(this, it).values())
                  if (!Et.cleanup())
                    throw new Error(`startCleanup: Page ${Et.pageNumber} is currently rendering.`);
                this.commonObjs.clear(), bt || this.fontLoader.clear(), mr(this, et).clear(), this.filterFactory.destroy(!0);
              }
            }
            get loadingParams() {
              const {
                disableAutoFetch: bt,
                enableXfa: Et
              } = this._params;
              return (0, _util.shadow)(this, "loadingParams", {
                disableAutoFetch: bt,
                enableXfa: Et
              });
            }
          }
          et = new WeakMap(), it = new WeakMap(), ut = new WeakMap(), ft = new WeakMap(), ht = new WeakSet(), is = function(bt) {
            let Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            const St = mr(this, et).get(bt);
            if (St)
              return St;
            const Bt = this.messageHandler.sendWithPromise(bt, Et);
            return mr(this, et).set(bt, Bt), Bt;
          };
          class PDFObjects {
            constructor() {
              _r(this, pt);
              _r(this, gt, /* @__PURE__ */ Object.create(null));
            }
            get(bt) {
              let Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              if (Et) {
                const Bt = Ur(this, pt, Os).call(this, bt);
                return Bt.capability.promise.then(() => Et(Bt.data)), null;
              }
              const St = mr(this, gt)[bt];
              if (!(St != null && St.capability.settled))
                throw new Error(`Requesting object that isn't resolved yet ${bt}.`);
              return St.data;
            }
            has(bt) {
              const Et = mr(this, gt)[bt];
              return (Et == null ? void 0 : Et.capability.settled) || !1;
            }
            resolve(bt) {
              let Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              const St = Ur(this, pt, Os).call(this, bt);
              St.data = Et, St.capability.resolve();
            }
            clear() {
              var bt;
              for (const Et in mr(this, gt)) {
                const {
                  data: St
                } = mr(this, gt)[Et];
                (bt = St == null ? void 0 : St.bitmap) == null || bt.close();
              }
              tn(this, gt, /* @__PURE__ */ Object.create(null));
            }
          }
          gt = new WeakMap(), pt = new WeakSet(), Os = function(bt) {
            var Et;
            return (Et = mr(this, gt))[bt] || (Et[bt] = {
              capability: new _util.PromiseCapability(),
              data: null
            });
          };
          class RenderTask {
            constructor(bt) {
              _r(this, ct, null);
              tn(this, ct, bt), this.onContinue = null;
            }
            get promise() {
              return mr(this, ct).capability.promise;
            }
            cancel() {
              let bt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
              mr(this, ct).cancel(null, bt);
            }
            get separateAnnots() {
              const {
                separateAnnots: bt
              } = mr(this, ct).operatorList;
              if (!bt)
                return !1;
              const {
                annotationCanvasMap: Et
              } = mr(this, ct);
              return bt.form || bt.canvas && (Et == null ? void 0 : Et.size) > 0;
            }
          }
          ct = new WeakMap(), exports.RenderTask = RenderTask;
          const At = class At {
            constructor(bt) {
              let {
                callback: Et,
                params: St,
                objs: Bt,
                commonObjs: Ot,
                annotationCanvasMap: Pt,
                operatorList: wt,
                pageIndex: Ct,
                canvasFactory: It,
                filterFactory: yt,
                useRequestAnimationFrame: Rt = !1,
                pdfBug: kt = !1,
                pageColors: jt = null
              } = bt;
              this.callback = Et, this.params = St, this.objs = Bt, this.commonObjs = Ot, this.annotationCanvasMap = Pt, this.operatorListIdx = null, this.operatorList = wt, this._pageIndex = Ct, this.canvasFactory = It, this.filterFactory = yt, this._pdfBug = kt, this.pageColors = jt, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = Rt === !0 && typeof window < "u", this.cancelled = !1, this.capability = new _util.PromiseCapability(), this.task = new RenderTask(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = St.canvasContext.canvas;
            }
            get completed() {
              return this.capability.promise.catch(function() {
              });
            }
            initializeGraphics(bt) {
              var Ct, It;
              let {
                transparency: Et = !1,
                optionalContentConfig: St
              } = bt;
              if (this.cancelled)
                return;
              if (this._canvas) {
                if (mr(At, vt).has(this._canvas))
                  throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                mr(At, vt).add(this._canvas);
              }
              this._pdfBug && ((Ct = globalThis.StepperManager) != null && Ct.enabled) && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
              const {
                canvasContext: Bt,
                viewport: Ot,
                transform: Pt,
                background: wt
              } = this.params;
              this.gfx = new _canvas.CanvasGraphics(Bt, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                optionalContentConfig: St
              }, this.annotationCanvasMap, this.pageColors), this.gfx.beginDrawing({
                transform: Pt,
                viewport: Ot,
                transparency: Et,
                background: wt
              }), this.operatorListIdx = 0, this.graphicsReady = !0, (It = this.graphicsReadyCallback) == null || It.call(this);
            }
            cancel() {
              var St;
              let bt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, Et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
              this.running = !1, this.cancelled = !0, (St = this.gfx) == null || St.endDrawing(), mr(At, vt).delete(this._canvas), this.callback(bt || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, Et));
            }
            operatorListChanged() {
              var bt;
              if (!this.graphicsReady) {
                this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                return;
              }
              (bt = this.stepper) == null || bt.updateOperatorList(this.operatorList), !this.running && this._continue();
            }
            _continue() {
              this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
            }
            _scheduleNext() {
              this._useRequestAnimationFrame ? window.requestAnimationFrame(() => {
                this._nextBound().catch(this._cancelBound);
              }) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
            }
            async _next() {
              this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), mr(At, vt).delete(this._canvas), this.callback())));
            }
          };
          vt = new WeakMap(), _r(At, vt, /* @__PURE__ */ new WeakSet());
          let InternalRenderTask = At;
          const version = "3.11.174";
          exports.version = version;
          const build = "ce8716743";
          exports.build = build;
        },
        /* 125 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(126), tt = $(135);
          _({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !tt("difference")
          }, { difference: _e });
        },
        /* 126 */
        /***/
        (a, s, $) => {
          var _ = $(127), _e = $(128), tt = $(129), nt = $(132), at = $(133), ot = $(130), rt = $(131), st = _e.has, lt = _e.remove;
          a.exports = function(it) {
            var ut = _(this), ft = at(it), ht = tt(ut);
            return nt(ut) <= ft.size ? ot(ut, function(dt) {
              ft.includes(dt) && lt(ht, dt);
            }) : rt(ft.getIterator(), function(dt) {
              st(ut, dt) && lt(ht, dt);
            }), ht;
          };
        },
        /* 127 */
        /***/
        (a, s, $) => {
          var _ = $(128).has;
          a.exports = function(_e) {
            return _(_e), _e;
          };
        },
        /* 128 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = Set.prototype;
          a.exports = {
            Set,
            add: _(_e.add),
            has: _(_e.has),
            remove: _(_e.delete),
            proto: _e
          };
        },
        /* 129 */
        /***/
        (a, s, $) => {
          var _ = $(128), _e = $(130), tt = _.Set, nt = _.add;
          a.exports = function(at) {
            var ot = new tt();
            return _e(at, function(rt) {
              nt(ot, rt);
            }), ot;
          };
        },
        /* 130 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = $(131), tt = $(128), nt = tt.Set, at = tt.proto, ot = _(at.forEach), rt = _(at.keys), st = rt(new nt()).next;
          a.exports = function(lt, et, it) {
            return it ? _e({
              iterator: rt(lt),
              next: st
            }, et) : ot(lt, et);
          };
        },
        /* 131 */
        /***/
        (a, s, $) => {
          var _ = $(8);
          a.exports = function(_e, tt, nt) {
            for (var at = nt ? _e : _e.iterator, ot = _e.next, rt, st; !(rt = _(ot, at)).done; )
              if (st = tt(rt.value), st !== void 0)
                return st;
          };
        },
        /* 132 */
        /***/
        (a, s, $) => {
          var _ = $(72), _e = $(128);
          a.exports = _(_e.proto, "size", "get") || function(tt) {
            return tt.size;
          };
        },
        /* 133 */
        /***/
        (a, s, $) => {
          var _ = $(31), _e = $(47), tt = $(8), nt = $(62), at = $(134), ot = "Invalid size", rt = RangeError, st = TypeError, lt = Math.max, et = function(it, ut, ft, ht) {
            this.set = it, this.size = ut, this.has = ft, this.keys = ht;
          };
          et.prototype = {
            getIterator: function() {
              return at(_e(tt(this.keys, this.set)));
            },
            includes: function(it) {
              return tt(this.has, this.set, it);
            }
          }, a.exports = function(it) {
            _e(it);
            var ut = +it.size;
            if (ut !== ut)
              throw st(ot);
            var ft = nt(ut);
            if (ft < 0)
              throw rt(ot);
            return new et(it, lt(ft, 0), _(it.has), _(it.keys));
          };
        },
        /* 134 */
        /***/
        (a) => {
          a.exports = function(s) {
            return {
              iterator: s,
              next: s.next,
              done: !1
            };
          };
        },
        /* 135 */
        /***/
        (a, s, $) => {
          var _ = $(24), _e = function(tt) {
            return {
              size: tt,
              has: function() {
                return !1;
              },
              keys: function() {
                return {
                  next: function() {
                    return { done: !0 };
                  }
                };
              }
            };
          };
          a.exports = function(tt) {
            var nt = _("Set");
            try {
              new nt()[tt](_e(0));
              try {
                return new nt()[tt](_e(-1)), !1;
              } catch {
                return !0;
              }
            } catch {
              return !1;
            }
          };
        },
        /* 136 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(7), tt = $(137), nt = $(135), at = !nt("intersection") || _e(function() {
            return Array.from((/* @__PURE__ */ new Set([
              1,
              2,
              3
            ])).intersection(/* @__PURE__ */ new Set([
              3,
              2
            ]))) !== "3,2";
          });
          _({
            target: "Set",
            proto: !0,
            real: !0,
            forced: at
          }, { intersection: tt });
        },
        /* 137 */
        /***/
        (a, s, $) => {
          var _ = $(127), _e = $(128), tt = $(132), nt = $(133), at = $(130), ot = $(131), rt = _e.Set, st = _e.add, lt = _e.has;
          a.exports = function(it) {
            var ut = _(this), ft = nt(it), ht = new rt();
            return tt(ut) > ft.size ? ot(ft.getIterator(), function(dt) {
              lt(ut, dt) && st(ht, dt);
            }) : at(ut, function(dt) {
              ft.includes(dt) && st(ht, dt);
            }), ht;
          };
        },
        /* 138 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(139), tt = $(135);
          _({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !tt("isDisjointFrom")
          }, { isDisjointFrom: _e });
        },
        /* 139 */
        /***/
        (a, s, $) => {
          var _ = $(127), _e = $(128).has, tt = $(132), nt = $(133), at = $(130), ot = $(131), rt = $(140);
          a.exports = function(lt) {
            var et = _(this), it = nt(lt);
            if (tt(et) <= it.size)
              return at(et, function(ft) {
                if (it.includes(ft))
                  return !1;
              }, !0) !== !1;
            var ut = it.getIterator();
            return ot(ut, function(ft) {
              if (_e(et, ft))
                return rt(ut, "normal", !1);
            }) !== !1;
          };
        },
        /* 140 */
        /***/
        (a, s, $) => {
          var _ = $(8), _e = $(47), tt = $(30);
          a.exports = function(nt, at, ot) {
            var rt, st;
            _e(nt);
            try {
              if (rt = tt(nt, "return"), !rt) {
                if (at === "throw")
                  throw ot;
                return ot;
              }
              rt = _(rt, nt);
            } catch (lt) {
              st = !0, rt = lt;
            }
            if (at === "throw")
              throw ot;
            if (st)
              throw rt;
            return _e(rt), ot;
          };
        },
        /* 141 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(142), tt = $(135);
          _({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !tt("isSubsetOf")
          }, { isSubsetOf: _e });
        },
        /* 142 */
        /***/
        (a, s, $) => {
          var _ = $(127), _e = $(132), tt = $(130), nt = $(133);
          a.exports = function(ot) {
            var rt = _(this), st = nt(ot);
            return _e(rt) > st.size ? !1 : tt(rt, function(lt) {
              if (!st.includes(lt))
                return !1;
            }, !0) !== !1;
          };
        },
        /* 143 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(144), tt = $(135);
          _({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !tt("isSupersetOf")
          }, { isSupersetOf: _e });
        },
        /* 144 */
        /***/
        (a, s, $) => {
          var _ = $(127), _e = $(128).has, tt = $(132), nt = $(133), at = $(131), ot = $(140);
          a.exports = function(st) {
            var lt = _(this), et = nt(st);
            if (tt(lt) < et.size)
              return !1;
            var it = et.getIterator();
            return at(it, function(ut) {
              if (!_e(lt, ut))
                return ot(it, "normal", !1);
            }) !== !1;
          };
        },
        /* 145 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(146), tt = $(135);
          _({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !tt("symmetricDifference")
          }, { symmetricDifference: _e });
        },
        /* 146 */
        /***/
        (a, s, $) => {
          var _ = $(127), _e = $(128), tt = $(129), nt = $(133), at = $(131), ot = _e.add, rt = _e.has, st = _e.remove;
          a.exports = function(et) {
            var it = _(this), ut = nt(et).getIterator(), ft = tt(it);
            return at(ut, function(ht) {
              rt(it, ht) ? st(ft, ht) : ot(ft, ht);
            }), ft;
          };
        },
        /* 147 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(148), tt = $(135);
          _({
            target: "Set",
            proto: !0,
            real: !0,
            forced: !tt("union")
          }, { union: _e });
        },
        /* 148 */
        /***/
        (a, s, $) => {
          var _ = $(127), _e = $(128).add, tt = $(129), nt = $(133), at = $(131);
          a.exports = function(rt) {
            var st = _(this), lt = nt(rt).getIterator(), et = tt(st);
            return at(lt, function(it) {
              _e(et, it);
            }), et;
          };
        },
        /* 149 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(4), tt = $(24), nt = $(11), at = $(45).f, ot = $(39), rt = $(150), st = $(75), lt = $(76), et = $(151), it = $(82), ut = $(6), ft = $(36), ht = "DOMException", dt = tt("Error"), gt = tt(ht), pt = function() {
            rt(this, mt);
            var Ct = arguments.length, It = lt(Ct < 1 ? void 0 : arguments[0]), yt = lt(Ct < 2 ? void 0 : arguments[1], "Error"), Rt = new gt(It, yt), kt = dt(It);
            return kt.name = ht, at(Rt, "stack", nt(1, it(kt.stack, 1))), st(Rt, this, pt), Rt;
          }, mt = pt.prototype = gt.prototype, ct = "stack" in dt(ht), vt = "stack" in new gt(1, 2), At = gt && ut && Object.getOwnPropertyDescriptor(_e, ht), xt = !!At && !(At.writable && At.configurable), bt = ct && !xt && !vt;
          _({
            global: !0,
            constructor: !0,
            forced: ft || bt
          }, { DOMException: bt ? pt : gt });
          var Et = tt(ht), St = Et.prototype;
          if (St.constructor !== Et) {
            ft || at(St, "constructor", nt(1, Et));
            for (var Bt in et)
              if (ot(et, Bt)) {
                var Ot = et[Bt], Pt = Ot.s;
                ot(Et, Pt) || at(Et, Pt, nt(6, Ot.c));
              }
          }
        },
        /* 150 */
        /***/
        (a, s, $) => {
          var _ = $(25), _e = TypeError;
          a.exports = function(tt, nt) {
            if (_(nt, tt))
              return tt;
            throw _e("Incorrect invocation");
          };
        },
        /* 151 */
        /***/
        (a) => {
          a.exports = {
            IndexSizeError: {
              s: "INDEX_SIZE_ERR",
              c: 1,
              m: 1
            },
            DOMStringSizeError: {
              s: "DOMSTRING_SIZE_ERR",
              c: 2,
              m: 0
            },
            HierarchyRequestError: {
              s: "HIERARCHY_REQUEST_ERR",
              c: 3,
              m: 1
            },
            WrongDocumentError: {
              s: "WRONG_DOCUMENT_ERR",
              c: 4,
              m: 1
            },
            InvalidCharacterError: {
              s: "INVALID_CHARACTER_ERR",
              c: 5,
              m: 1
            },
            NoDataAllowedError: {
              s: "NO_DATA_ALLOWED_ERR",
              c: 6,
              m: 0
            },
            NoModificationAllowedError: {
              s: "NO_MODIFICATION_ALLOWED_ERR",
              c: 7,
              m: 1
            },
            NotFoundError: {
              s: "NOT_FOUND_ERR",
              c: 8,
              m: 1
            },
            NotSupportedError: {
              s: "NOT_SUPPORTED_ERR",
              c: 9,
              m: 1
            },
            InUseAttributeError: {
              s: "INUSE_ATTRIBUTE_ERR",
              c: 10,
              m: 1
            },
            InvalidStateError: {
              s: "INVALID_STATE_ERR",
              c: 11,
              m: 1
            },
            SyntaxError: {
              s: "SYNTAX_ERR",
              c: 12,
              m: 1
            },
            InvalidModificationError: {
              s: "INVALID_MODIFICATION_ERR",
              c: 13,
              m: 1
            },
            NamespaceError: {
              s: "NAMESPACE_ERR",
              c: 14,
              m: 1
            },
            InvalidAccessError: {
              s: "INVALID_ACCESS_ERR",
              c: 15,
              m: 1
            },
            ValidationError: {
              s: "VALIDATION_ERR",
              c: 16,
              m: 0
            },
            TypeMismatchError: {
              s: "TYPE_MISMATCH_ERR",
              c: 17,
              m: 1
            },
            SecurityError: {
              s: "SECURITY_ERR",
              c: 18,
              m: 1
            },
            NetworkError: {
              s: "NETWORK_ERR",
              c: 19,
              m: 1
            },
            AbortError: {
              s: "ABORT_ERR",
              c: 20,
              m: 1
            },
            URLMismatchError: {
              s: "URL_MISMATCH_ERR",
              c: 21,
              m: 1
            },
            QuotaExceededError: {
              s: "QUOTA_EXCEEDED_ERR",
              c: 22,
              m: 1
            },
            TimeoutError: {
              s: "TIMEOUT_ERR",
              c: 23,
              m: 1
            },
            InvalidNodeTypeError: {
              s: "INVALID_NODE_TYPE_ERR",
              c: 24,
              m: 1
            },
            DataCloneError: {
              s: "DATA_CLONE_ERR",
              c: 25,
              m: 1
            }
          };
        },
        /* 152 */
        /***/
        (a, s, $) => {
          var _ = $(36), _e = $(3), tt = $(4), nt = $(24), at = $(14), ot = $(7), rt = $(41), st = $(21), lt = $(153), et = $(17), it = $(20), ut = $(23), ft = $(154), ht = $(47), dt = $(78), gt = $(39), pt = $(159), mt = $(44), ct = $(64), vt = $(85), At = $(160), xt = $(162), bt = $(128), Et = $(83), St = $(119), Bt = tt.Object, Ot = tt.Array, Pt = tt.Date, wt = tt.Error, Ct = tt.EvalError, It = tt.RangeError, yt = tt.ReferenceError, Rt = tt.SyntaxError, kt = tt.TypeError, jt = tt.URIError, Ht = tt.PerformanceMark, Ft = tt.WebAssembly, _t = Ft && Ft.CompileError || wt, Nt = Ft && Ft.LinkError || wt, Mt = Ft && Ft.RuntimeError || wt, Lt = nt("DOMException"), $t = xt.Map, Tt = xt.has, Dt = xt.get, Ut = xt.set, Vt = bt.Set, Qt = bt.add, qt = nt("Object", "keys"), Zt = at([].push), ar = at((!0).valueOf), Jt = at(1 .valueOf), rr = at("".valueOf), Yt = at(Pt.prototype.getTime), Kt = rt("structuredClone"), nr = "DataCloneError", tr = "Transferring", ir = function(Ir) {
            return !ot(function() {
              var hr = new tt.Set([7]), vr = Ir(hr), xr = Ir(Bt(7));
              return vr === hr || !vr.has(7) || typeof xr != "object" || +xr != 7;
            }) && Ir;
          }, sr = function(Ir, hr) {
            return !ot(function() {
              var vr = new hr(), xr = Ir({
                a: vr,
                b: vr
              });
              return !(xr && xr.a === xr.b && xr.a instanceof hr && xr.a.stack === vr.stack);
            });
          }, cr = function(Ir) {
            return !ot(function() {
              var hr = Ir(new tt.AggregateError([1], Kt, { cause: 3 }));
              return hr.name !== "AggregateError" || hr.errors[0] !== 1 || hr.message !== Kt || hr.cause !== 3;
            });
          }, or = tt.structuredClone, Xt = _ || !sr(or, wt) || !sr(or, Lt) || !cr(or), Gt = !or && ir(function(Ir) {
            return new Ht(Kt, { detail: Ir }).detail;
          }), Wt = ir(or) || Gt, er = function(Ir) {
            throw new Lt("Uncloneable type: " + Ir, nr);
          }, lr = function(Ir, hr) {
            throw new Lt((hr || "Cloning") + " of " + Ir + " cannot be properly polyfilled in this engine", nr);
          }, ur = function(Ir, hr) {
            return Wt || lr(hr), Wt(Ir);
          }, pr = function() {
            var Ir;
            try {
              Ir = new tt.DataTransfer();
            } catch {
              try {
                Ir = new tt.ClipboardEvent("").clipboardData;
              } catch {
              }
            }
            return Ir && Ir.items && Ir.files ? Ir : null;
          }, yr = function(Ir, hr, vr) {
            if (Tt(hr, Ir))
              return Dt(hr, Ir);
            var xr = vr || dt(Ir), Pr, Rr, Dr, Gr, Or, Hr;
            if (xr === "SharedArrayBuffer")
              Wt ? Pr = Wt(Ir) : Pr = Ir;
            else {
              var jr = tt.DataView;
              !jr && typeof Ir.slice != "function" && lr("ArrayBuffer");
              try {
                if (typeof Ir.slice == "function" && !Ir.resizable)
                  Pr = Ir.slice(0);
                else
                  for (Rr = Ir.byteLength, Dr = ("maxByteLength" in Ir) ? { maxByteLength: Ir.maxByteLength } : void 0, Pr = new ArrayBuffer(Rr, Dr), Gr = new jr(Ir), Or = new jr(Pr), Hr = 0; Hr < Rr; Hr++)
                    Or.setUint8(Hr, Gr.getUint8(Hr));
              } catch {
                throw new Lt("ArrayBuffer is detached", nr);
              }
            }
            return Ut(hr, Ir, Pr), Pr;
          }, Er = function(Ir, hr, vr, xr, Pr) {
            var Rr = tt[hr];
            return it(Rr) || lr(hr), new Rr(yr(Ir.buffer, Pr), vr, xr);
          }, br = function(Ir, hr, vr) {
            this.object = Ir, this.type = hr, this.metadata = vr;
          }, gr = function(Ir, hr, vr) {
            if (ut(Ir) && er("Symbol"), !it(Ir))
              return Ir;
            if (hr) {
              if (Tt(hr, Ir))
                return Dt(hr, Ir);
            } else
              hr = new $t();
            var xr = dt(Ir), Pr, Rr, Dr, Gr, Or, Hr, jr, Tr;
            switch (xr) {
              case "Array":
                Dr = Ot(ct(Ir));
                break;
              case "Object":
                Dr = {};
                break;
              case "Map":
                Dr = new $t();
                break;
              case "Set":
                Dr = new Vt();
                break;
              case "RegExp":
                Dr = new RegExp(Ir.source, At(Ir));
                break;
              case "Error":
                switch (Rr = Ir.name, Rr) {
                  case "AggregateError":
                    Dr = nt("AggregateError")([]);
                    break;
                  case "EvalError":
                    Dr = Ct();
                    break;
                  case "RangeError":
                    Dr = It();
                    break;
                  case "ReferenceError":
                    Dr = yt();
                    break;
                  case "SyntaxError":
                    Dr = Rt();
                    break;
                  case "TypeError":
                    Dr = kt();
                    break;
                  case "URIError":
                    Dr = jt();
                    break;
                  case "CompileError":
                    Dr = _t();
                    break;
                  case "LinkError":
                    Dr = Nt();
                    break;
                  case "RuntimeError":
                    Dr = Mt();
                    break;
                  default:
                    Dr = wt();
                }
                break;
              case "DOMException":
                Dr = new Lt(Ir.message, Ir.name);
                break;
              case "ArrayBuffer":
              case "SharedArrayBuffer":
                Dr = vr ? new br(Ir, xr) : yr(Ir, hr, xr);
                break;
              case "DataView":
              case "Int8Array":
              case "Uint8Array":
              case "Uint8ClampedArray":
              case "Int16Array":
              case "Uint16Array":
              case "Int32Array":
              case "Uint32Array":
              case "Float16Array":
              case "Float32Array":
              case "Float64Array":
              case "BigInt64Array":
              case "BigUint64Array":
                Hr = xr === "DataView" ? Ir.byteLength : Ir.length, Dr = vr ? new br(Ir, xr, {
                  offset: Ir.byteOffset,
                  length: Hr
                }) : Er(Ir, xr, Ir.byteOffset, Hr, hr);
                break;
              case "DOMQuad":
                try {
                  Dr = new DOMQuad(gr(Ir.p1, hr, vr), gr(Ir.p2, hr, vr), gr(Ir.p3, hr, vr), gr(Ir.p4, hr, vr));
                } catch {
                  Dr = ur(Ir, xr);
                }
                break;
              case "File":
                if (Wt)
                  try {
                    Dr = Wt(Ir), dt(Dr) !== xr && (Dr = void 0);
                  } catch {
                  }
                if (!Dr)
                  try {
                    Dr = new File([Ir], Ir.name, Ir);
                  } catch {
                  }
                Dr || lr(xr);
                break;
              case "FileList":
                if (Gr = pr(), Gr) {
                  for (Or = 0, Hr = ct(Ir); Or < Hr; Or++)
                    Gr.items.add(gr(Ir[Or], hr, vr));
                  Dr = Gr.files;
                } else
                  Dr = ur(Ir, xr);
                break;
              case "ImageData":
                try {
                  Dr = new ImageData(gr(Ir.data, hr, vr), Ir.width, Ir.height, { colorSpace: Ir.colorSpace });
                } catch {
                  Dr = ur(Ir, xr);
                }
                break;
              default:
                if (Wt)
                  Dr = Wt(Ir);
                else
                  switch (xr) {
                    case "BigInt":
                      Dr = Bt(Ir.valueOf());
                      break;
                    case "Boolean":
                      Dr = Bt(ar(Ir));
                      break;
                    case "Number":
                      Dr = Bt(Jt(Ir));
                      break;
                    case "String":
                      Dr = Bt(rr(Ir));
                      break;
                    case "Date":
                      Dr = new Pt(Yt(Ir));
                      break;
                    case "Blob":
                      try {
                        Dr = Ir.slice(0, Ir.size, Ir.type);
                      } catch {
                        lr(xr);
                      }
                      break;
                    case "DOMPoint":
                    case "DOMPointReadOnly":
                      Pr = tt[xr];
                      try {
                        Dr = Pr.fromPoint ? Pr.fromPoint(Ir) : new Pr(Ir.x, Ir.y, Ir.z, Ir.w);
                      } catch {
                        lr(xr);
                      }
                      break;
                    case "DOMRect":
                    case "DOMRectReadOnly":
                      Pr = tt[xr];
                      try {
                        Dr = Pr.fromRect ? Pr.fromRect(Ir) : new Pr(Ir.x, Ir.y, Ir.width, Ir.height);
                      } catch {
                        lr(xr);
                      }
                      break;
                    case "DOMMatrix":
                    case "DOMMatrixReadOnly":
                      Pr = tt[xr];
                      try {
                        Dr = Pr.fromMatrix ? Pr.fromMatrix(Ir) : new Pr(Ir);
                      } catch {
                        lr(xr);
                      }
                      break;
                    case "AudioData":
                    case "VideoFrame":
                      st(Ir.clone) || lr(xr);
                      try {
                        Dr = Ir.clone();
                      } catch {
                        er(xr);
                      }
                      break;
                    case "CropTarget":
                    case "CryptoKey":
                    case "FileSystemDirectoryHandle":
                    case "FileSystemFileHandle":
                    case "FileSystemHandle":
                    case "GPUCompilationInfo":
                    case "GPUCompilationMessage":
                    case "ImageBitmap":
                    case "RTCCertificate":
                    case "WebAssembly.Module":
                      lr(xr);
                    default:
                      er(xr);
                  }
            }
            switch (Ut(hr, Ir, Dr), xr) {
              case "Array":
              case "Object":
                for (jr = qt(Ir), Or = 0, Hr = ct(jr); Or < Hr; Or++)
                  Tr = jr[Or], pt(Dr, Tr, gr(Ir[Tr], hr, vr));
                break;
              case "Map":
                Ir.forEach(function(fr, Cr) {
                  Ut(Dr, gr(Cr, hr, vr), gr(fr, hr, vr));
                });
                break;
              case "Set":
                Ir.forEach(function(fr) {
                  Qt(Dr, gr(fr, hr, vr));
                });
                break;
              case "Error":
                mt(Dr, "message", gr(Ir.message, hr, vr)), gt(Ir, "cause") && mt(Dr, "cause", gr(Ir.cause, hr, vr)), Rr === "AggregateError" && (Dr.errors = gr(Ir.errors, hr, vr));
              case "DOMException":
                Et && mt(Dr, "stack", gr(Ir.stack, hr, vr));
            }
            return Dr;
          }, Ar = function(Ir, hr) {
            if (!it(Ir))
              return Ir;
            if (Tt(hr, Ir))
              return Dt(hr, Ir);
            var vr, xr, Pr, Rr, Dr, Gr, Or, Hr;
            if (Ir instanceof br)
              switch (vr = Ir.type, xr = Ir.object, vr) {
                case "ArrayBuffer":
                case "SharedArrayBuffer":
                  Hr = yr(xr, hr, vr);
                  break;
                case "DataView":
                case "Int8Array":
                case "Uint8Array":
                case "Uint8ClampedArray":
                case "Int16Array":
                case "Uint16Array":
                case "Int32Array":
                case "Uint32Array":
                case "Float16Array":
                case "Float32Array":
                case "Float64Array":
                case "BigInt64Array":
                case "BigUint64Array":
                  Pr = Ir.metadata, Hr = Er(xr, vr, Pr.offset, Pr.length, hr);
              }
            else
              switch (dt(Ir)) {
                case "Array":
                case "Object":
                  for (Gr = qt(Ir), Rr = 0, Dr = ct(Gr); Rr < Dr; Rr++)
                    Or = Gr[Rr], Ir[Or] = Ar(Ir[Or], hr);
                  break;
                case "Map":
                  Hr = new $t(), Ir.forEach(function(jr, Tr) {
                    Ut(Hr, Ar(Tr, hr), Ar(jr, hr));
                  });
                  break;
                case "Set":
                  Hr = new Vt(), Ir.forEach(function(jr) {
                    Qt(Hr, Ar(jr, hr));
                  });
                  break;
                case "Error":
                  Ir.message = Ar(Ir.message, hr), gt(Ir, "cause") && (Ir.cause = Ar(Ir.cause, hr)), Ir.name === "AggregateError" && (Ir.errors = Ar(Ir.errors, hr));
                case "DOMException":
                  Et && (Ir.stack = Ar(Ir.stack, hr));
              }
            return Ut(hr, Ir, Hr || Ir), Hr || Ir;
          }, Sr = function(Ir, hr) {
            if (!it(Ir))
              throw kt("Transfer option cannot be converted to a sequence");
            var vr = [];
            ft(Ir, function(fr) {
              Zt(vr, ht(fr));
            });
            for (var xr = 0, Pr = ct(vr), Rr = [], Dr, Gr, Or, Hr, jr, Tr; xr < Pr; ) {
              if (Dr = vr[xr++], Gr = dt(Dr), Gr === "ArrayBuffer") {
                Zt(Rr, Dr);
                continue;
              }
              if (Tt(hr, Dr))
                throw new Lt("Duplicate transferable", nr);
              if (St)
                Hr = or(Dr, { transfer: [Dr] });
              else
                switch (Gr) {
                  case "ImageBitmap":
                    Or = tt.OffscreenCanvas, lt(Or) || lr(Gr, tr);
                    try {
                      jr = new Or(Dr.width, Dr.height), Tr = jr.getContext("bitmaprenderer"), Tr.transferFromImageBitmap(Dr), Hr = jr.transferToImageBitmap();
                    } catch {
                    }
                    break;
                  case "AudioData":
                  case "VideoFrame":
                    (!st(Dr.clone) || !st(Dr.close)) && lr(Gr, tr);
                    try {
                      Hr = Dr.clone(), Dr.close();
                    } catch {
                    }
                    break;
                  case "MediaSourceHandle":
                  case "MessagePort":
                  case "OffscreenCanvas":
                  case "ReadableStream":
                  case "TransformStream":
                  case "WritableStream":
                    lr(Gr, tr);
                }
              if (Hr === void 0)
                throw new Lt("This object cannot be transferred: " + Gr, nr);
              Ut(hr, Dr, Hr);
            }
            return Rr;
          }, Br = function(Ir, hr) {
            for (var vr = 0, xr = ct(Ir), Pr, Rr; vr < xr; ) {
              if (Pr = Ir[vr++], Tt(hr, Pr))
                throw new Lt("Duplicate transferable", nr);
              St ? Rr = or(Pr, { transfer: [Pr] }) : (st(Pr.transfer) || lr("ArrayBuffer", tr), Rr = Pr.transfer()), Ut(hr, Pr, Rr);
            }
          };
          _e({
            global: !0,
            enumerable: !0,
            sham: !St,
            forced: Xt
          }, {
            structuredClone: function(hr) {
              var vr = vt(arguments.length, 1) > 1 && !et(arguments[1]) ? ht(arguments[1]) : void 0, xr = vr ? vr.transfer : void 0, Pr = !1, Rr, Dr;
              xr !== void 0 && (Rr = new $t(), Dr = Sr(xr, Rr), Pr = !!ct(Dr));
              var Gr = gr(hr, Rr, Pr);
              return Pr && (Rr = new $t(), Br(xr, Rr), Gr = Ar(Gr, Rr)), Gr;
            }
          });
        },
        /* 153 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = $(7), tt = $(21), nt = $(78), at = $(24), ot = $(51), rt = function() {
          }, st = [], lt = at("Reflect", "construct"), et = /^\s*(?:class|function)\b/, it = _(et.exec), ut = !et.exec(rt), ft = function(gt) {
            if (!tt(gt))
              return !1;
            try {
              return lt(rt, st, gt), !0;
            } catch {
              return !1;
            }
          }, ht = function(gt) {
            if (!tt(gt))
              return !1;
            switch (nt(gt)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return !1;
            }
            try {
              return ut || !!it(et, ot(gt));
            } catch {
              return !0;
            }
          };
          ht.sham = !0, a.exports = !lt || _e(function() {
            var dt;
            return ft(ft.call) || !ft(Object) || !ft(function() {
              dt = !0;
            }) || dt;
          }) ? ht : ft;
        },
        /* 154 */
        /***/
        (a, s, $) => {
          var _ = $(99), _e = $(8), tt = $(47), nt = $(32), at = $(155), ot = $(64), rt = $(25), st = $(157), lt = $(158), et = $(140), it = TypeError, ut = function(ht, dt) {
            this.stopped = ht, this.result = dt;
          }, ft = ut.prototype;
          a.exports = function(ht, dt, gt) {
            var pt = gt && gt.that, mt = !!(gt && gt.AS_ENTRIES), ct = !!(gt && gt.IS_RECORD), vt = !!(gt && gt.IS_ITERATOR), At = !!(gt && gt.INTERRUPTED), xt = _(dt, pt), bt, Et, St, Bt, Ot, Pt, wt, Ct = function(yt) {
              return bt && et(bt, "normal", yt), new ut(!0, yt);
            }, It = function(yt) {
              return mt ? (tt(yt), At ? xt(yt[0], yt[1], Ct) : xt(yt[0], yt[1])) : At ? xt(yt, Ct) : xt(yt);
            };
            if (ct)
              bt = ht.iterator;
            else if (vt)
              bt = ht;
            else {
              if (Et = lt(ht), !Et)
                throw it(nt(ht) + " is not iterable");
              if (at(Et)) {
                for (St = 0, Bt = ot(ht); Bt > St; St++)
                  if (Ot = It(ht[St]), Ot && rt(ft, Ot))
                    return Ot;
                return new ut(!1);
              }
              bt = st(ht, Et);
            }
            for (Pt = ct ? ht.next : bt.next; !(wt = _e(Pt, bt)).done; ) {
              try {
                Ot = It(wt.value);
              } catch (yt) {
                et(bt, "throw", yt);
              }
              if (typeof Ot == "object" && Ot && rt(ft, Ot))
                return Ot;
            }
            return new ut(!1);
          };
        },
        /* 155 */
        /***/
        (a, s, $) => {
          var _ = $(34), _e = $(156), tt = _("iterator"), nt = Array.prototype;
          a.exports = function(at) {
            return at !== void 0 && (_e.Array === at || nt[tt] === at);
          };
        },
        /* 156 */
        /***/
        (a) => {
          a.exports = {};
        },
        /* 157 */
        /***/
        (a, s, $) => {
          var _ = $(8), _e = $(31), tt = $(47), nt = $(32), at = $(158), ot = TypeError;
          a.exports = function(rt, st) {
            var lt = arguments.length < 2 ? at(rt) : st;
            if (_e(lt))
              return tt(_(lt, rt));
            throw ot(nt(rt) + " is not iterable");
          };
        },
        /* 158 */
        /***/
        (a, s, $) => {
          var _ = $(78), _e = $(30), tt = $(17), nt = $(156), at = $(34), ot = at("iterator");
          a.exports = function(rt) {
            if (!tt(rt))
              return _e(rt, ot) || _e(rt, "@@iterator") || nt[_(rt)];
          };
        },
        /* 159 */
        /***/
        (a, s, $) => {
          var _ = $(18), _e = $(45), tt = $(11);
          a.exports = function(nt, at, ot) {
            var rt = _(at);
            rt in nt ? _e.f(nt, rt, tt(0, ot)) : nt[rt] = ot;
          };
        },
        /* 160 */
        /***/
        (a, s, $) => {
          var _ = $(8), _e = $(39), tt = $(25), nt = $(161), at = RegExp.prototype;
          a.exports = function(ot) {
            var rt = ot.flags;
            return rt === void 0 && !("flags" in at) && !_e(ot, "flags") && tt(at, ot) ? _(nt, ot) : rt;
          };
        },
        /* 161 */
        /***/
        (a, s, $) => {
          var _ = $(47);
          a.exports = function() {
            var _e = _(this), tt = "";
            return _e.hasIndices && (tt += "d"), _e.global && (tt += "g"), _e.ignoreCase && (tt += "i"), _e.multiline && (tt += "m"), _e.dotAll && (tt += "s"), _e.unicode && (tt += "u"), _e.unicodeSets && (tt += "v"), _e.sticky && (tt += "y"), tt;
          };
        },
        /* 162 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = Map.prototype;
          a.exports = {
            Map,
            set: _(_e.set),
            get: _(_e.get),
            has: _(_e.has),
            remove: _(_e.delete),
            proto: _e
          };
        },
        /* 163 */
        /***/
        (a, s, $) => {
          var rt, st, lt, Tl, it;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.SerializableEmpty = s.PrintAnnotationStorage = s.AnnotationStorage = void 0, $(89), $(149), $(152);
          var _ = $(1), _e = $(164), tt = $(170);
          const nt = Object.freeze({
            map: null,
            hash: "",
            transfers: void 0
          });
          s.SerializableEmpty = nt;
          class at {
            constructor() {
              _r(this, lt);
              _r(this, rt, !1);
              _r(this, st, /* @__PURE__ */ new Map());
              this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
            }
            getValue(ft, ht) {
              const dt = mr(this, st).get(ft);
              return dt === void 0 ? ht : Object.assign(ht, dt);
            }
            getRawValue(ft) {
              return mr(this, st).get(ft);
            }
            remove(ft) {
              if (mr(this, st).delete(ft), mr(this, st).size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function") {
                for (const ht of mr(this, st).values())
                  if (ht instanceof _e.AnnotationEditor)
                    return;
                this.onAnnotationEditor(null);
              }
            }
            setValue(ft, ht) {
              const dt = mr(this, st).get(ft);
              let gt = !1;
              if (dt !== void 0)
                for (const [pt, mt] of Object.entries(ht))
                  dt[pt] !== mt && (gt = !0, dt[pt] = mt);
              else
                gt = !0, mr(this, st).set(ft, ht);
              gt && Ur(this, lt, Tl).call(this), ht instanceof _e.AnnotationEditor && typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(ht.constructor._type);
            }
            has(ft) {
              return mr(this, st).has(ft);
            }
            getAll() {
              return mr(this, st).size > 0 ? (0, _.objectFromMap)(mr(this, st)) : null;
            }
            setAll(ft) {
              for (const [ht, dt] of Object.entries(ft))
                this.setValue(ht, dt);
            }
            get size() {
              return mr(this, st).size;
            }
            resetModified() {
              mr(this, rt) && (tn(this, rt, !1), typeof this.onResetModified == "function" && this.onResetModified());
            }
            get print() {
              return new ot(this);
            }
            get serializable() {
              if (mr(this, st).size === 0)
                return nt;
              const ft = /* @__PURE__ */ new Map(), ht = new tt.MurmurHash3_64(), dt = [], gt = /* @__PURE__ */ Object.create(null);
              let pt = !1;
              for (const [mt, ct] of mr(this, st)) {
                const vt = ct instanceof _e.AnnotationEditor ? ct.serialize(!1, gt) : ct;
                vt && (ft.set(mt, vt), ht.update(`${mt}:${JSON.stringify(vt)}`), pt || (pt = !!vt.bitmap));
              }
              if (pt)
                for (const mt of ft.values())
                  mt.bitmap && dt.push(mt.bitmap);
              return ft.size > 0 ? {
                map: ft,
                hash: ht.hexdigest(),
                transfers: dt
              } : nt;
            }
          }
          rt = new WeakMap(), st = new WeakMap(), lt = new WeakSet(), Tl = function() {
            mr(this, rt) || (tn(this, rt, !0), typeof this.onSetModified == "function" && this.onSetModified());
          }, s.AnnotationStorage = at;
          class ot extends at {
            constructor(ht) {
              super();
              _r(this, it, void 0);
              const {
                map: dt,
                hash: gt,
                transfers: pt
              } = ht.serializable, mt = structuredClone(dt, null);
              tn(this, it, {
                map: mt,
                hash: gt,
                transfers: pt
              });
            }
            get print() {
              (0, _.unreachable)("Should not call PrintAnnotationStorage.print");
            }
            get serializable() {
              return mr(this, it);
            }
          }
          it = new WeakMap(), s.PrintAnnotationStorage = ot;
        },
        /* 164 */
        /***/
        (a, s, $) => {
          var ot, rt, st, lt, et, it, ut, ft, ht, dt, gt, pt, mt, ct, vt, Bs, xt, Ds, Et, Ms, Bt, ks, Pt, Pl, Ct, Rl, yt, Ol, kt, Fs, Ht, Bl;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.AnnotationEditor = void 0, $(89), $(2);
          var _ = $(165), _e = $(1), tt = $(168);
          const _t = class _t {
            constructor(Mt) {
              _r(this, vt);
              _r(this, xt);
              _r(this, Bt);
              _r(this, Pt);
              _r(this, Ct);
              _r(this, yt);
              _r(this, kt);
              _r(this, Ht);
              _r(this, ot, "");
              _r(this, rt, !1);
              _r(this, st, null);
              _r(this, lt, null);
              _r(this, et, null);
              _r(this, it, !1);
              _r(this, ut, null);
              _r(this, ft, this.focusin.bind(this));
              _r(this, ht, this.focusout.bind(this));
              _r(this, dt, !1);
              _r(this, gt, !1);
              _r(this, pt, !1);
              Ln(this, "_initialOptions", /* @__PURE__ */ Object.create(null));
              Ln(this, "_uiManager", null);
              Ln(this, "_focusEventsAllowed", !0);
              Ln(this, "_l10nPromise", null);
              _r(this, mt, !1);
              _r(this, ct, _t._zIndex++);
              this.constructor === _t && (0, _e.unreachable)("Cannot initialize AnnotationEditor."), this.parent = Mt.parent, this.id = Mt.id, this.width = this.height = null, this.pageIndex = Mt.parent.pageIndex, this.name = Mt.name, this.div = null, this._uiManager = Mt.uiManager, this.annotationElementId = null, this._willKeepAspectRatio = !1, this._initialOptions.isCentered = Mt.isCentered, this._structTreeParentId = null;
              const {
                rotation: Lt,
                rawDims: {
                  pageWidth: $t,
                  pageHeight: Tt,
                  pageX: Dt,
                  pageY: Ut
                }
              } = this.parent.viewport;
              this.rotation = Lt, this.pageRotation = (360 + Lt - this._uiManager.viewParameters.rotation) % 360, this.pageDimensions = [$t, Tt], this.pageTranslation = [Dt, Ut];
              const [Vt, Qt] = this.parentDimensions;
              this.x = Mt.x / Vt, this.y = Mt.y / Qt, this.isAttachedToDOM = !1, this.deleted = !1;
            }
            get editorType() {
              return Object.getPrototypeOf(this).constructor._type;
            }
            static get _defaultLineColor() {
              return (0, _e.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
            }
            static deleteAnnotationElement(Mt) {
              const Lt = new at({
                id: Mt.parent.getNextId(),
                parent: Mt.parent,
                uiManager: Mt._uiManager
              });
              Lt.annotationElementId = Mt.annotationElementId, Lt.deleted = !0, Lt._uiManager.addToAnnotationStorage(Lt);
            }
            static initialize(Mt) {
              let Lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              if (_t._l10nPromise || (_t._l10nPromise = new Map(["editor_alt_text_button_label", "editor_alt_text_edit_button_label", "editor_alt_text_decorative_tooltip"].map((Tt) => [Tt, Mt.get(Tt)]))), Lt != null && Lt.strings)
                for (const Tt of Lt.strings)
                  _t._l10nPromise.set(Tt, Mt.get(Tt));
              if (_t._borderLineWidth !== -1)
                return;
              const $t = getComputedStyle(document.documentElement);
              _t._borderLineWidth = parseFloat($t.getPropertyValue("--outline-width")) || 0;
            }
            static updateDefaultParams(Mt, Lt) {
            }
            static get defaultPropertiesToUpdate() {
              return [];
            }
            static isHandlingMimeForPasting(Mt) {
              return !1;
            }
            static paste(Mt, Lt) {
              (0, _e.unreachable)("Not implemented");
            }
            get propertiesToUpdate() {
              return [];
            }
            get _isDraggable() {
              return mr(this, mt);
            }
            set _isDraggable(Mt) {
              var Lt;
              tn(this, mt, Mt), (Lt = this.div) == null || Lt.classList.toggle("draggable", Mt);
            }
            center() {
              const [Mt, Lt] = this.pageDimensions;
              switch (this.parentRotation) {
                case 90:
                  this.x -= this.height * Lt / (Mt * 2), this.y += this.width * Mt / (Lt * 2);
                  break;
                case 180:
                  this.x += this.width / 2, this.y += this.height / 2;
                  break;
                case 270:
                  this.x += this.height * Lt / (Mt * 2), this.y -= this.width * Mt / (Lt * 2);
                  break;
                default:
                  this.x -= this.width / 2, this.y -= this.height / 2;
                  break;
              }
              this.fixAndSetPosition();
            }
            addCommands(Mt) {
              this._uiManager.addCommands(Mt);
            }
            get currentLayer() {
              return this._uiManager.currentLayer;
            }
            setInBackground() {
              this.div.style.zIndex = 0;
            }
            setInForeground() {
              this.div.style.zIndex = mr(this, ct);
            }
            setParent(Mt) {
              Mt !== null && (this.pageIndex = Mt.pageIndex, this.pageDimensions = Mt.pageDimensions), this.parent = Mt;
            }
            focusin(Mt) {
              this._focusEventsAllowed && (mr(this, dt) ? tn(this, dt, !1) : this.parent.setSelected(this));
            }
            focusout(Mt) {
              var $t;
              if (!this._focusEventsAllowed || !this.isAttachedToDOM)
                return;
              const Lt = Mt.relatedTarget;
              Lt != null && Lt.closest(`#${this.id}`) || (Mt.preventDefault(), ($t = this.parent) != null && $t.isMultipleSelection || this.commitOrRemove());
            }
            commitOrRemove() {
              this.isEmpty() ? this.remove() : this.commit();
            }
            commit() {
              this.addToAnnotationStorage();
            }
            addToAnnotationStorage() {
              this._uiManager.addToAnnotationStorage(this);
            }
            setAt(Mt, Lt, $t, Tt) {
              const [Dt, Ut] = this.parentDimensions;
              [$t, Tt] = this.screenToPageTranslation($t, Tt), this.x = (Mt + $t) / Dt, this.y = (Lt + Tt) / Ut, this.fixAndSetPosition();
            }
            translate(Mt, Lt) {
              Ur(this, vt, Bs).call(this, this.parentDimensions, Mt, Lt);
            }
            translateInPage(Mt, Lt) {
              Ur(this, vt, Bs).call(this, this.pageDimensions, Mt, Lt), this.div.scrollIntoView({
                block: "nearest"
              });
            }
            drag(Mt, Lt) {
              const [$t, Tt] = this.parentDimensions;
              if (this.x += Mt / $t, this.y += Lt / Tt, this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                const {
                  x: qt,
                  y: Zt
                } = this.div.getBoundingClientRect();
                this.parent.findNewParent(this, qt, Zt) && (this.x -= Math.floor(this.x), this.y -= Math.floor(this.y));
              }
              let {
                x: Dt,
                y: Ut
              } = this;
              const [Vt, Qt] = Ur(this, xt, Ds).call(this);
              Dt += Vt, Ut += Qt, this.div.style.left = `${(100 * Dt).toFixed(2)}%`, this.div.style.top = `${(100 * Ut).toFixed(2)}%`, this.div.scrollIntoView({
                block: "nearest"
              });
            }
            fixAndSetPosition() {
              const [Mt, Lt] = this.pageDimensions;
              let {
                x: $t,
                y: Tt,
                width: Dt,
                height: Ut
              } = this;
              switch (Dt *= Mt, Ut *= Lt, $t *= Mt, Tt *= Lt, this.rotation) {
                case 0:
                  $t = Math.max(0, Math.min(Mt - Dt, $t)), Tt = Math.max(0, Math.min(Lt - Ut, Tt));
                  break;
                case 90:
                  $t = Math.max(0, Math.min(Mt - Ut, $t)), Tt = Math.min(Lt, Math.max(Dt, Tt));
                  break;
                case 180:
                  $t = Math.min(Mt, Math.max(Dt, $t)), Tt = Math.min(Lt, Math.max(Ut, Tt));
                  break;
                case 270:
                  $t = Math.min(Mt, Math.max(Ut, $t)), Tt = Math.max(0, Math.min(Lt - Dt, Tt));
                  break;
              }
              this.x = $t /= Mt, this.y = Tt /= Lt;
              const [Vt, Qt] = Ur(this, xt, Ds).call(this);
              $t += Vt, Tt += Qt;
              const {
                style: qt
              } = this.div;
              qt.left = `${(100 * $t).toFixed(2)}%`, qt.top = `${(100 * Tt).toFixed(2)}%`, this.moveInDOM();
            }
            screenToPageTranslation(Mt, Lt) {
              var $t;
              return Ur($t = _t, Et, Ms).call($t, Mt, Lt, this.parentRotation);
            }
            pageTranslationToScreen(Mt, Lt) {
              var $t;
              return Ur($t = _t, Et, Ms).call($t, Mt, Lt, 360 - this.parentRotation);
            }
            get parentScale() {
              return this._uiManager.viewParameters.realScale;
            }
            get parentRotation() {
              return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
            }
            get parentDimensions() {
              const {
                parentScale: Mt,
                pageDimensions: [Lt, $t]
              } = this, Tt = Lt * Mt, Dt = $t * Mt;
              return _e.FeatureTest.isCSSRoundSupported ? [Math.round(Tt), Math.round(Dt)] : [Tt, Dt];
            }
            setDims(Mt, Lt) {
              var Dt;
              const [$t, Tt] = this.parentDimensions;
              this.div.style.width = `${(100 * Mt / $t).toFixed(2)}%`, mr(this, it) || (this.div.style.height = `${(100 * Lt / Tt).toFixed(2)}%`), (Dt = mr(this, st)) == null || Dt.classList.toggle("small", Mt < _t.SMALL_EDITOR_SIZE || Lt < _t.SMALL_EDITOR_SIZE);
            }
            fixDims() {
              const {
                style: Mt
              } = this.div, {
                height: Lt,
                width: $t
              } = Mt, Tt = $t.endsWith("%"), Dt = !mr(this, it) && Lt.endsWith("%");
              if (Tt && Dt)
                return;
              const [Ut, Vt] = this.parentDimensions;
              Tt || (Mt.width = `${(100 * parseFloat($t) / Ut).toFixed(2)}%`), !mr(this, it) && !Dt && (Mt.height = `${(100 * parseFloat(Lt) / Vt).toFixed(2)}%`);
            }
            getInitialTranslation() {
              return [0, 0];
            }
            async addAltTextButton() {
              if (mr(this, st))
                return;
              const Mt = tn(this, st, document.createElement("button"));
              Mt.className = "altText";
              const Lt = await _t._l10nPromise.get("editor_alt_text_button_label");
              Mt.textContent = Lt, Mt.setAttribute("aria-label", Lt), Mt.tabIndex = "0", Mt.addEventListener("contextmenu", tt.noContextMenu), Mt.addEventListener("pointerdown", ($t) => $t.stopPropagation()), Mt.addEventListener("click", ($t) => {
                $t.preventDefault(), this._uiManager.editAltText(this);
              }, {
                capture: !0
              }), Mt.addEventListener("keydown", ($t) => {
                $t.target === Mt && $t.key === "Enter" && ($t.preventDefault(), this._uiManager.editAltText(this));
              }), Ur(this, kt, Fs).call(this), this.div.append(Mt), _t.SMALL_EDITOR_SIZE || (_t.SMALL_EDITOR_SIZE = Math.min(128, Math.round(Mt.getBoundingClientRect().width * 1.4)));
            }
            getClientDimensions() {
              return this.div.getBoundingClientRect();
            }
            get altTextData() {
              return {
                altText: mr(this, ot),
                decorative: mr(this, rt)
              };
            }
            set altTextData(Mt) {
              let {
                altText: Lt,
                decorative: $t
              } = Mt;
              mr(this, ot) === Lt && mr(this, rt) === $t || (tn(this, ot, Lt), tn(this, rt, $t), Ur(this, kt, Fs).call(this));
            }
            render() {
              this.div = document.createElement("div"), this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), this.div.className = this.name, this.div.setAttribute("id", this.id), this.div.setAttribute("tabIndex", 0), this.setInForeground(), this.div.addEventListener("focusin", mr(this, ft)), this.div.addEventListener("focusout", mr(this, ht));
              const [Mt, Lt] = this.parentDimensions;
              this.parentRotation % 180 !== 0 && (this.div.style.maxWidth = `${(100 * Lt / Mt).toFixed(2)}%`, this.div.style.maxHeight = `${(100 * Mt / Lt).toFixed(2)}%`);
              const [$t, Tt] = this.getInitialTranslation();
              return this.translate($t, Tt), (0, _.bindEvents)(this, this.div, ["pointerdown"]), this.div;
            }
            pointerdown(Mt) {
              const {
                isMac: Lt
              } = _e.FeatureTest.platform;
              if (Mt.button !== 0 || Mt.ctrlKey && Lt) {
                Mt.preventDefault();
                return;
              }
              tn(this, dt, !0), Ur(this, Ht, Bl).call(this, Mt);
            }
            moveInDOM() {
              var Mt;
              (Mt = this.parent) == null || Mt.moveEditorInDOM(this);
            }
            _setParentAndPosition(Mt, Lt, $t) {
              Mt.changeParent(this), this.x = Lt, this.y = $t, this.fixAndSetPosition();
            }
            getRect(Mt, Lt) {
              const $t = this.parentScale, [Tt, Dt] = this.pageDimensions, [Ut, Vt] = this.pageTranslation, Qt = Mt / $t, qt = Lt / $t, Zt = this.x * Tt, ar = this.y * Dt, Jt = this.width * Tt, rr = this.height * Dt;
              switch (this.rotation) {
                case 0:
                  return [Zt + Qt + Ut, Dt - ar - qt - rr + Vt, Zt + Qt + Jt + Ut, Dt - ar - qt + Vt];
                case 90:
                  return [Zt + qt + Ut, Dt - ar + Qt + Vt, Zt + qt + rr + Ut, Dt - ar + Qt + Jt + Vt];
                case 180:
                  return [Zt - Qt - Jt + Ut, Dt - ar + qt + Vt, Zt - Qt + Ut, Dt - ar + qt + rr + Vt];
                case 270:
                  return [Zt - qt - rr + Ut, Dt - ar - Qt - Jt + Vt, Zt - qt + Ut, Dt - ar - Qt + Vt];
                default:
                  throw new Error("Invalid rotation");
              }
            }
            getRectInCurrentCoords(Mt, Lt) {
              const [$t, Tt, Dt, Ut] = Mt, Vt = Dt - $t, Qt = Ut - Tt;
              switch (this.rotation) {
                case 0:
                  return [$t, Lt - Ut, Vt, Qt];
                case 90:
                  return [$t, Lt - Tt, Qt, Vt];
                case 180:
                  return [Dt, Lt - Tt, Vt, Qt];
                case 270:
                  return [Dt, Lt - Ut, Qt, Vt];
                default:
                  throw new Error("Invalid rotation");
              }
            }
            onceAdded() {
            }
            isEmpty() {
              return !1;
            }
            enableEditMode() {
              tn(this, pt, !0);
            }
            disableEditMode() {
              tn(this, pt, !1);
            }
            isInEditMode() {
              return mr(this, pt);
            }
            shouldGetKeyboardEvents() {
              return !1;
            }
            needsToBeRebuilt() {
              return this.div && !this.isAttachedToDOM;
            }
            rebuild() {
              var Mt, Lt;
              (Mt = this.div) == null || Mt.addEventListener("focusin", mr(this, ft)), (Lt = this.div) == null || Lt.addEventListener("focusout", mr(this, ht));
            }
            serialize() {
              (0, _e.unreachable)("An editor must be serializable");
            }
            static deserialize(Mt, Lt, $t) {
              const Tt = new this.prototype.constructor({
                parent: Lt,
                id: Lt.getNextId(),
                uiManager: $t
              });
              Tt.rotation = Mt.rotation;
              const [Dt, Ut] = Tt.pageDimensions, [Vt, Qt, qt, Zt] = Tt.getRectInCurrentCoords(Mt.rect, Ut);
              return Tt.x = Vt / Dt, Tt.y = Qt / Ut, Tt.width = qt / Dt, Tt.height = Zt / Ut, Tt;
            }
            remove() {
              var Mt;
              this.div.removeEventListener("focusin", mr(this, ft)), this.div.removeEventListener("focusout", mr(this, ht)), this.isEmpty() || this.commit(), this.parent ? this.parent.remove(this) : this._uiManager.removeEditor(this), (Mt = mr(this, st)) == null || Mt.remove(), tn(this, st, null), tn(this, lt, null);
            }
            get isResizable() {
              return !1;
            }
            makeResizable() {
              this.isResizable && (Ur(this, Pt, Pl).call(this), mr(this, ut).classList.remove("hidden"));
            }
            select() {
              var Mt;
              this.makeResizable(), (Mt = this.div) == null || Mt.classList.add("selectedEditor");
            }
            unselect() {
              var Mt, Lt, $t;
              (Mt = mr(this, ut)) == null || Mt.classList.add("hidden"), (Lt = this.div) == null || Lt.classList.remove("selectedEditor"), ($t = this.div) != null && $t.contains(document.activeElement) && this._uiManager.currentLayer.div.focus();
            }
            updateParams(Mt, Lt) {
            }
            disableEditing() {
              mr(this, st) && (mr(this, st).hidden = !0);
            }
            enableEditing() {
              mr(this, st) && (mr(this, st).hidden = !1);
            }
            enterInEditMode() {
            }
            get contentDiv() {
              return this.div;
            }
            get isEditing() {
              return mr(this, gt);
            }
            set isEditing(Mt) {
              tn(this, gt, Mt), this.parent && (Mt ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null));
            }
            setAspectRatio(Mt, Lt) {
              tn(this, it, !0);
              const $t = Mt / Lt, {
                style: Tt
              } = this.div;
              Tt.aspectRatio = $t, Tt.height = "auto";
            }
            static get MIN_SIZE() {
              return 16;
            }
          };
          ot = new WeakMap(), rt = new WeakMap(), st = new WeakMap(), lt = new WeakMap(), et = new WeakMap(), it = new WeakMap(), ut = new WeakMap(), ft = new WeakMap(), ht = new WeakMap(), dt = new WeakMap(), gt = new WeakMap(), pt = new WeakMap(), mt = new WeakMap(), ct = new WeakMap(), vt = new WeakSet(), Bs = function(Mt, Lt, $t) {
            let [Tt, Dt] = Mt;
            [Lt, $t] = this.screenToPageTranslation(Lt, $t), this.x += Lt / Tt, this.y += $t / Dt, this.fixAndSetPosition();
          }, xt = new WeakSet(), Ds = function() {
            const [Mt, Lt] = this.parentDimensions, {
              _borderLineWidth: $t
            } = _t, Tt = $t / Mt, Dt = $t / Lt;
            switch (this.rotation) {
              case 90:
                return [-Tt, Dt];
              case 180:
                return [Tt, Dt];
              case 270:
                return [Tt, -Dt];
              default:
                return [-Tt, -Dt];
            }
          }, Et = new WeakSet(), Ms = function(Mt, Lt, $t) {
            switch ($t) {
              case 90:
                return [Lt, -Mt];
              case 180:
                return [-Mt, -Lt];
              case 270:
                return [-Lt, Mt];
              default:
                return [Mt, Lt];
            }
          }, Bt = new WeakSet(), ks = function(Mt) {
            switch (Mt) {
              case 90: {
                const [Lt, $t] = this.pageDimensions;
                return [0, -Lt / $t, $t / Lt, 0];
              }
              case 180:
                return [-1, 0, 0, -1];
              case 270: {
                const [Lt, $t] = this.pageDimensions;
                return [0, Lt / $t, -$t / Lt, 0];
              }
              default:
                return [1, 0, 0, 1];
            }
          }, Pt = new WeakSet(), Pl = function() {
            if (mr(this, ut))
              return;
            tn(this, ut, document.createElement("div")), mr(this, ut).classList.add("resizers");
            const Mt = ["topLeft", "topRight", "bottomRight", "bottomLeft"];
            this._willKeepAspectRatio || Mt.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
            for (const Lt of Mt) {
              const $t = document.createElement("div");
              mr(this, ut).append($t), $t.classList.add("resizer", Lt), $t.addEventListener("pointerdown", Ur(this, Ct, Rl).bind(this, Lt)), $t.addEventListener("contextmenu", tt.noContextMenu);
            }
            this.div.prepend(mr(this, ut));
          }, Ct = new WeakSet(), Rl = function(Mt, Lt) {
            Lt.preventDefault();
            const {
              isMac: $t
            } = _e.FeatureTest.platform;
            if (Lt.button !== 0 || Lt.ctrlKey && $t)
              return;
            const Tt = Ur(this, yt, Ol).bind(this, Mt), Dt = this._isDraggable;
            this._isDraggable = !1;
            const Ut = {
              passive: !0,
              capture: !0
            };
            window.addEventListener("pointermove", Tt, Ut);
            const Vt = this.x, Qt = this.y, qt = this.width, Zt = this.height, ar = this.parent.div.style.cursor, Jt = this.div.style.cursor;
            this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(Lt.target).cursor;
            const rr = () => {
              this._isDraggable = Dt, window.removeEventListener("pointerup", rr), window.removeEventListener("blur", rr), window.removeEventListener("pointermove", Tt, Ut), this.parent.div.style.cursor = ar, this.div.style.cursor = Jt;
              const Yt = this.x, Kt = this.y, nr = this.width, tr = this.height;
              Yt === Vt && Kt === Qt && nr === qt && tr === Zt || this.addCommands({
                cmd: () => {
                  this.width = nr, this.height = tr, this.x = Yt, this.y = Kt;
                  const [ir, sr] = this.parentDimensions;
                  this.setDims(ir * nr, sr * tr), this.fixAndSetPosition();
                },
                undo: () => {
                  this.width = qt, this.height = Zt, this.x = Vt, this.y = Qt;
                  const [ir, sr] = this.parentDimensions;
                  this.setDims(ir * qt, sr * Zt), this.fixAndSetPosition();
                },
                mustExec: !0
              });
            };
            window.addEventListener("pointerup", rr), window.addEventListener("blur", rr);
          }, yt = new WeakSet(), Ol = function(Mt, Lt) {
            const [$t, Tt] = this.parentDimensions, Dt = this.x, Ut = this.y, Vt = this.width, Qt = this.height, qt = _t.MIN_SIZE / $t, Zt = _t.MIN_SIZE / Tt, ar = (Ar) => Math.round(Ar * 1e4) / 1e4, Jt = Ur(this, Bt, ks).call(this, this.rotation), rr = (Ar, Sr) => [Jt[0] * Ar + Jt[2] * Sr, Jt[1] * Ar + Jt[3] * Sr], Yt = Ur(this, Bt, ks).call(this, 360 - this.rotation), Kt = (Ar, Sr) => [Yt[0] * Ar + Yt[2] * Sr, Yt[1] * Ar + Yt[3] * Sr];
            let nr, tr, ir = !1, sr = !1;
            switch (Mt) {
              case "topLeft":
                ir = !0, nr = (Ar, Sr) => [0, 0], tr = (Ar, Sr) => [Ar, Sr];
                break;
              case "topMiddle":
                nr = (Ar, Sr) => [Ar / 2, 0], tr = (Ar, Sr) => [Ar / 2, Sr];
                break;
              case "topRight":
                ir = !0, nr = (Ar, Sr) => [Ar, 0], tr = (Ar, Sr) => [0, Sr];
                break;
              case "middleRight":
                sr = !0, nr = (Ar, Sr) => [Ar, Sr / 2], tr = (Ar, Sr) => [0, Sr / 2];
                break;
              case "bottomRight":
                ir = !0, nr = (Ar, Sr) => [Ar, Sr], tr = (Ar, Sr) => [0, 0];
                break;
              case "bottomMiddle":
                nr = (Ar, Sr) => [Ar / 2, Sr], tr = (Ar, Sr) => [Ar / 2, 0];
                break;
              case "bottomLeft":
                ir = !0, nr = (Ar, Sr) => [0, Sr], tr = (Ar, Sr) => [Ar, 0];
                break;
              case "middleLeft":
                sr = !0, nr = (Ar, Sr) => [0, Sr / 2], tr = (Ar, Sr) => [Ar, Sr / 2];
                break;
            }
            const cr = nr(Vt, Qt), or = tr(Vt, Qt);
            let Xt = rr(...or);
            const Gt = ar(Dt + Xt[0]), Wt = ar(Ut + Xt[1]);
            let er = 1, lr = 1, [ur, pr] = this.screenToPageTranslation(Lt.movementX, Lt.movementY);
            if ([ur, pr] = Kt(ur / $t, pr / Tt), ir) {
              const Ar = Math.hypot(Vt, Qt);
              er = lr = Math.max(Math.min(Math.hypot(or[0] - cr[0] - ur, or[1] - cr[1] - pr) / Ar, 1 / Vt, 1 / Qt), qt / Vt, Zt / Qt);
            } else
              sr ? er = Math.max(qt, Math.min(1, Math.abs(or[0] - cr[0] - ur))) / Vt : lr = Math.max(Zt, Math.min(1, Math.abs(or[1] - cr[1] - pr))) / Qt;
            const yr = ar(Vt * er), Er = ar(Qt * lr);
            Xt = rr(...tr(yr, Er));
            const br = Gt - Xt[0], gr = Wt - Xt[1];
            this.width = yr, this.height = Er, this.x = br, this.y = gr, this.setDims($t * yr, Tt * Er), this.fixAndSetPosition();
          }, kt = new WeakSet(), Fs = async function() {
            var $t;
            const Mt = mr(this, st);
            if (!Mt)
              return;
            if (!mr(this, ot) && !mr(this, rt)) {
              Mt.classList.remove("done"), ($t = mr(this, lt)) == null || $t.remove();
              return;
            }
            _t._l10nPromise.get("editor_alt_text_edit_button_label").then((Tt) => {
              Mt.setAttribute("aria-label", Tt);
            });
            let Lt = mr(this, lt);
            if (!Lt) {
              tn(this, lt, Lt = document.createElement("span")), Lt.className = "tooltip", Lt.setAttribute("role", "tooltip");
              const Tt = Lt.id = `alt-text-tooltip-${this.id}`;
              Mt.setAttribute("aria-describedby", Tt);
              const Dt = 100;
              Mt.addEventListener("mouseenter", () => {
                tn(this, et, setTimeout(() => {
                  tn(this, et, null), mr(this, lt).classList.add("show"), this._uiManager._eventBus.dispatch("reporttelemetry", {
                    source: this,
                    details: {
                      type: "editing",
                      subtype: this.editorType,
                      data: {
                        action: "alt_text_tooltip"
                      }
                    }
                  });
                }, Dt));
              }), Mt.addEventListener("mouseleave", () => {
                var Ut;
                clearTimeout(mr(this, et)), tn(this, et, null), (Ut = mr(this, lt)) == null || Ut.classList.remove("show");
              });
            }
            Mt.classList.add("done"), Lt.innerText = mr(this, rt) ? await _t._l10nPromise.get("editor_alt_text_decorative_tooltip") : mr(this, ot), Lt.parentNode || Mt.append(Lt);
          }, Ht = new WeakSet(), Bl = function(Mt) {
            if (!this._isDraggable)
              return;
            const Lt = this._uiManager.isSelected(this);
            this._uiManager.setUpDragSession();
            let $t, Tt;
            Lt && ($t = {
              passive: !0,
              capture: !0
            }, Tt = (Ut) => {
              const [Vt, Qt] = this.screenToPageTranslation(Ut.movementX, Ut.movementY);
              this._uiManager.dragSelectedEditors(Vt, Qt);
            }, window.addEventListener("pointermove", Tt, $t));
            const Dt = () => {
              if (window.removeEventListener("pointerup", Dt), window.removeEventListener("blur", Dt), Lt && window.removeEventListener("pointermove", Tt, $t), tn(this, dt, !1), !this._uiManager.endDragSession()) {
                const {
                  isMac: Ut
                } = _e.FeatureTest.platform;
                Mt.ctrlKey && !Ut || Mt.shiftKey || Mt.metaKey && Ut ? this.parent.toggleSelected(this) : this.parent.setSelected(this);
              }
            };
            window.addEventListener("pointerup", Dt), window.addEventListener("blur", Dt);
          }, _r(_t, Et), Ln(_t, "_borderLineWidth", -1), Ln(_t, "_colorManager", new _.ColorManager()), Ln(_t, "_zIndex", 1), Ln(_t, "SMALL_EDITOR_SIZE", 0);
          let nt = _t;
          s.AnnotationEditor = nt;
          class at extends nt {
            constructor(Mt) {
              super(Mt), this.annotationElementId = Mt.annotationElementId, this.deleted = !0;
            }
            serialize() {
              return {
                id: this.annotationElementId,
                deleted: !0,
                pageIndex: this.pageIndex
              };
            }
          }
        },
        /* 165 */
        /***/
        (a, s, $) => {
          var it, ut, ft, ht, dt, Ns, mt, ct, vt, At, xt, Dl, St, Bt, Ot, Pt, wt, Ct, It, yt, Rt, kt, jt, Ht, Ft, _t, Nt, Mt, Lt, $t, Tt, Dt, Ut, Vt, Qt, qt, Zt, ar, Jt, rr, Yt, Kt, nr, tr, ir, sr, cr, Ml, Xt, Ls, Wt, _s, lr, os, pr, js, Er, Us, gr, xo, Sr, Go, Ir, kl, vr, Fl, Pr, Hs, Dr, Vo, Or, zs;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.KeyboardManager = s.CommandManager = s.ColorManager = s.AnnotationEditorUIManager = void 0, s.bindEvents = tt, s.opacityToHex = nt, $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123), $(2), $(89), $(125), $(136), $(138), $(141), $(143), $(145), $(147), $(166);
          var _ = $(1), _e = $(168);
          function tt(Tr, fr, Cr) {
            for (const $r of Cr)
              fr.addEventListener($r, Tr[$r].bind(Tr));
          }
          function nt(Tr) {
            return Math.round(Math.min(255, Math.max(1, 255 * Tr))).toString(16).padStart(2, "0");
          }
          class at {
            constructor() {
              _r(this, it, 0);
            }
            getId() {
              return `${_.AnnotationEditorPrefix}${Wo(this, it)._++}`;
            }
          }
          it = new WeakMap();
          const pt = class pt {
            constructor() {
              _r(this, dt);
              _r(this, ut, (0, _.getUuid)());
              _r(this, ft, 0);
              _r(this, ht, null);
            }
            static get _isSVGFittingCanvas() {
              const fr = 'data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>', $r = new OffscreenCanvas(1, 3).getContext("2d"), wr = new Image();
              wr.src = fr;
              const Mr = wr.decode().then(() => ($r.drawImage(wr, 0, 0, 1, 1, 0, 0, 1, 3), new Uint32Array($r.getImageData(0, 0, 1, 1).data.buffer)[0] === 0));
              return (0, _.shadow)(this, "_isSVGFittingCanvas", Mr);
            }
            async getFromFile(fr) {
              const {
                lastModified: Cr,
                name: $r,
                size: wr,
                type: Mr
              } = fr;
              return Ur(this, dt, Ns).call(this, `${Cr}_${$r}_${wr}_${Mr}`, fr);
            }
            async getFromUrl(fr) {
              return Ur(this, dt, Ns).call(this, fr, fr);
            }
            async getFromId(fr) {
              mr(this, ht) || tn(this, ht, /* @__PURE__ */ new Map());
              const Cr = mr(this, ht).get(fr);
              return Cr ? Cr.bitmap ? (Cr.refCounter += 1, Cr) : Cr.file ? this.getFromFile(Cr.file) : this.getFromUrl(Cr.url) : null;
            }
            getSvgUrl(fr) {
              const Cr = mr(this, ht).get(fr);
              return Cr != null && Cr.isSvg ? Cr.svgUrl : null;
            }
            deleteId(fr) {
              mr(this, ht) || tn(this, ht, /* @__PURE__ */ new Map());
              const Cr = mr(this, ht).get(fr);
              Cr && (Cr.refCounter -= 1, Cr.refCounter === 0 && (Cr.bitmap = null));
            }
            isValidId(fr) {
              return fr.startsWith(`image_${mr(this, ut)}_`);
            }
          };
          ut = new WeakMap(), ft = new WeakMap(), ht = new WeakMap(), dt = new WeakSet(), Ns = async function(fr, Cr) {
            mr(this, ht) || tn(this, ht, /* @__PURE__ */ new Map());
            let $r = mr(this, ht).get(fr);
            if ($r === null)
              return null;
            if ($r != null && $r.bitmap)
              return $r.refCounter += 1, $r;
            try {
              $r || ($r = {
                bitmap: null,
                id: `image_${mr(this, ut)}_${Wo(this, ft)._++}`,
                refCounter: 0,
                isSvg: !1
              });
              let wr;
              if (typeof Cr == "string") {
                $r.url = Cr;
                const Mr = await fetch(Cr);
                if (!Mr.ok)
                  throw new Error(Mr.statusText);
                wr = await Mr.blob();
              } else
                wr = $r.file = Cr;
              if (wr.type === "image/svg+xml") {
                const Mr = pt._isSVGFittingCanvas, Fr = new FileReader(), Qr = new Image(), Yr = new Promise((kr, Nr) => {
                  Qr.onload = () => {
                    $r.bitmap = Qr, $r.isSvg = !0, kr();
                  }, Fr.onload = async () => {
                    const Lr = $r.svgUrl = Fr.result;
                    Qr.src = await Mr ? `${Lr}#svgView(preserveAspectRatio(none))` : Lr;
                  }, Qr.onerror = Fr.onerror = Nr;
                });
                Fr.readAsDataURL(wr), await Yr;
              } else
                $r.bitmap = await createImageBitmap(wr);
              $r.refCounter = 1;
            } catch (wr) {
              console.error(wr), $r = null;
            }
            return mr(this, ht).set(fr, $r), $r && mr(this, ht).set($r.id, $r), $r;
          };
          let ot = pt;
          class rt {
            constructor() {
              _r(this, mt, []);
              _r(this, ct, !1);
              _r(this, vt, void 0);
              _r(this, At, -1);
              let fr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 128;
              tn(this, vt, fr);
            }
            add(fr) {
              let {
                cmd: Cr,
                undo: $r,
                mustExec: wr,
                type: Mr = NaN,
                overwriteIfSameType: Fr = !1,
                keepUndo: Qr = !1
              } = fr;
              if (wr && Cr(), mr(this, ct))
                return;
              const Yr = {
                cmd: Cr,
                undo: $r,
                type: Mr
              };
              if (mr(this, At) === -1) {
                mr(this, mt).length > 0 && (mr(this, mt).length = 0), tn(this, At, 0), mr(this, mt).push(Yr);
                return;
              }
              if (Fr && mr(this, mt)[mr(this, At)].type === Mr) {
                Qr && (Yr.undo = mr(this, mt)[mr(this, At)].undo), mr(this, mt)[mr(this, At)] = Yr;
                return;
              }
              const kr = mr(this, At) + 1;
              kr === mr(this, vt) ? mr(this, mt).splice(0, 1) : (tn(this, At, kr), kr < mr(this, mt).length && mr(this, mt).splice(kr)), mr(this, mt).push(Yr);
            }
            undo() {
              mr(this, At) !== -1 && (tn(this, ct, !0), mr(this, mt)[mr(this, At)].undo(), tn(this, ct, !1), tn(this, At, mr(this, At) - 1));
            }
            redo() {
              mr(this, At) < mr(this, mt).length - 1 && (tn(this, At, mr(this, At) + 1), tn(this, ct, !0), mr(this, mt)[mr(this, At)].cmd(), tn(this, ct, !1));
            }
            hasSomethingToUndo() {
              return mr(this, At) !== -1;
            }
            hasSomethingToRedo() {
              return mr(this, At) < mr(this, mt).length - 1;
            }
            destroy() {
              tn(this, mt, null);
            }
          }
          mt = new WeakMap(), ct = new WeakMap(), vt = new WeakMap(), At = new WeakMap(), s.CommandManager = rt;
          class st {
            constructor(fr) {
              _r(this, xt);
              this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
              const {
                isMac: Cr
              } = _.FeatureTest.platform;
              for (const [$r, wr, Mr = {}] of fr)
                for (const Fr of $r) {
                  const Qr = Fr.startsWith("mac+");
                  Cr && Qr ? (this.callbacks.set(Fr.slice(4), {
                    callback: wr,
                    options: Mr
                  }), this.allKeys.add(Fr.split("+").at(-1))) : !Cr && !Qr && (this.callbacks.set(Fr, {
                    callback: wr,
                    options: Mr
                  }), this.allKeys.add(Fr.split("+").at(-1)));
                }
            }
            exec(fr, Cr) {
              if (!this.allKeys.has(Cr.key))
                return;
              const $r = this.callbacks.get(Ur(this, xt, Dl).call(this, Cr));
              if (!$r)
                return;
              const {
                callback: wr,
                options: {
                  bubbles: Mr = !1,
                  args: Fr = [],
                  checker: Qr = null
                }
              } = $r;
              Qr && !Qr(fr, Cr) || (wr.bind(fr, ...Fr)(), Mr || (Cr.stopPropagation(), Cr.preventDefault()));
            }
          }
          xt = new WeakSet(), Dl = function(fr) {
            fr.altKey && this.buffer.push("alt"), fr.ctrlKey && this.buffer.push("ctrl"), fr.metaKey && this.buffer.push("meta"), fr.shiftKey && this.buffer.push("shift"), this.buffer.push(fr.key);
            const Cr = this.buffer.join("+");
            return this.buffer.length = 0, Cr;
          }, s.KeyboardManager = st;
          const Et = class Et {
            get _colors() {
              const fr = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
              return (0, _e.getColorValues)(fr), (0, _.shadow)(this, "_colors", fr);
            }
            convert(fr) {
              const Cr = (0, _e.getRGB)(fr);
              if (!window.matchMedia("(forced-colors: active)").matches)
                return Cr;
              for (const [$r, wr] of this._colors)
                if (wr.every((Mr, Fr) => Mr === Cr[Fr]))
                  return Et._colorsMapping.get($r);
              return Cr;
            }
            getHexCode(fr) {
              const Cr = this._colors.get(fr);
              return Cr ? _.Util.makeHexColor(...Cr) : fr;
            }
          };
          Ln(Et, "_colorsMapping", /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]));
          let lt = Et;
          s.ColorManager = lt;
          const jr = class jr {
            constructor(fr, Cr, $r, wr, Mr, Fr) {
              _r(this, cr);
              _r(this, Xt);
              _r(this, Wt);
              _r(this, lr);
              _r(this, pr);
              _r(this, Er);
              _r(this, gr);
              _r(this, Sr);
              _r(this, Ir);
              _r(this, vr);
              _r(this, Pr);
              _r(this, Dr);
              _r(this, Or);
              _r(this, St, null);
              _r(this, Bt, /* @__PURE__ */ new Map());
              _r(this, Ot, /* @__PURE__ */ new Map());
              _r(this, Pt, null);
              _r(this, wt, null);
              _r(this, Ct, new rt());
              _r(this, It, 0);
              _r(this, yt, /* @__PURE__ */ new Set());
              _r(this, Rt, null);
              _r(this, kt, null);
              _r(this, jt, /* @__PURE__ */ new Set());
              _r(this, Ht, null);
              _r(this, Ft, new at());
              _r(this, _t, !1);
              _r(this, Nt, !1);
              _r(this, Mt, null);
              _r(this, Lt, _.AnnotationEditorType.NONE);
              _r(this, $t, /* @__PURE__ */ new Set());
              _r(this, Tt, null);
              _r(this, Dt, this.blur.bind(this));
              _r(this, Ut, this.focus.bind(this));
              _r(this, Vt, this.copy.bind(this));
              _r(this, Qt, this.cut.bind(this));
              _r(this, qt, this.paste.bind(this));
              _r(this, Zt, this.keydown.bind(this));
              _r(this, ar, this.onEditingAction.bind(this));
              _r(this, Jt, this.onPageChanging.bind(this));
              _r(this, rr, this.onScaleChanging.bind(this));
              _r(this, Yt, this.onRotationChanging.bind(this));
              _r(this, Kt, {
                isEditing: !1,
                isEmpty: !0,
                hasSomethingToUndo: !1,
                hasSomethingToRedo: !1,
                hasSelectedEditor: !1
              });
              _r(this, nr, [0, 0]);
              _r(this, tr, null);
              _r(this, ir, null);
              _r(this, sr, null);
              tn(this, ir, fr), tn(this, sr, Cr), tn(this, Pt, $r), this._eventBus = wr, this._eventBus._on("editingaction", mr(this, ar)), this._eventBus._on("pagechanging", mr(this, Jt)), this._eventBus._on("scalechanging", mr(this, rr)), this._eventBus._on("rotationchanging", mr(this, Yt)), tn(this, wt, Mr.annotationStorage), tn(this, Ht, Mr.filterFactory), tn(this, Tt, Fr), this.viewParameters = {
                realScale: _e.PixelsPerInch.PDF_TO_CSS_UNITS,
                rotation: 0
              };
            }
            static get _keyboardManager() {
              const fr = jr.prototype, Cr = (Mr) => {
                const {
                  activeElement: Fr
                } = document;
                return Fr && mr(Mr, ir).contains(Fr) && Mr.hasSomethingToControl();
              }, $r = this.TRANSLATE_SMALL, wr = this.TRANSLATE_BIG;
              return (0, _.shadow)(this, "_keyboardManager", new st([[["ctrl+a", "mac+meta+a"], fr.selectAll], [["ctrl+z", "mac+meta+z"], fr.undo], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], fr.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], fr.delete], [["Escape", "mac+Escape"], fr.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], fr.translateSelectedEditors, {
                args: [-$r, 0],
                checker: Cr
              }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], fr.translateSelectedEditors, {
                args: [-wr, 0],
                checker: Cr
              }], [["ArrowRight", "mac+ArrowRight"], fr.translateSelectedEditors, {
                args: [$r, 0],
                checker: Cr
              }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], fr.translateSelectedEditors, {
                args: [wr, 0],
                checker: Cr
              }], [["ArrowUp", "mac+ArrowUp"], fr.translateSelectedEditors, {
                args: [0, -$r],
                checker: Cr
              }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], fr.translateSelectedEditors, {
                args: [0, -wr],
                checker: Cr
              }], [["ArrowDown", "mac+ArrowDown"], fr.translateSelectedEditors, {
                args: [0, $r],
                checker: Cr
              }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], fr.translateSelectedEditors, {
                args: [0, wr],
                checker: Cr
              }]]));
            }
            destroy() {
              Ur(this, lr, os).call(this), Ur(this, Xt, Ls).call(this), this._eventBus._off("editingaction", mr(this, ar)), this._eventBus._off("pagechanging", mr(this, Jt)), this._eventBus._off("scalechanging", mr(this, rr)), this._eventBus._off("rotationchanging", mr(this, Yt));
              for (const fr of mr(this, Ot).values())
                fr.destroy();
              mr(this, Ot).clear(), mr(this, Bt).clear(), mr(this, jt).clear(), tn(this, St, null), mr(this, $t).clear(), mr(this, Ct).destroy(), mr(this, Pt).destroy();
            }
            get hcmFilter() {
              return (0, _.shadow)(this, "hcmFilter", mr(this, Tt) ? mr(this, Ht).addHCMFilter(mr(this, Tt).foreground, mr(this, Tt).background) : "none");
            }
            get direction() {
              return (0, _.shadow)(this, "direction", getComputedStyle(mr(this, ir)).direction);
            }
            editAltText(fr) {
              var Cr;
              (Cr = mr(this, Pt)) == null || Cr.editAltText(this, fr);
            }
            onPageChanging(fr) {
              let {
                pageNumber: Cr
              } = fr;
              tn(this, It, Cr - 1);
            }
            focusMainContainer() {
              mr(this, ir).focus();
            }
            findParent(fr, Cr) {
              for (const $r of mr(this, Ot).values()) {
                const {
                  x: wr,
                  y: Mr,
                  width: Fr,
                  height: Qr
                } = $r.div.getBoundingClientRect();
                if (fr >= wr && fr <= wr + Fr && Cr >= Mr && Cr <= Mr + Qr)
                  return $r;
              }
              return null;
            }
            disableUserSelect() {
              let fr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              mr(this, sr).classList.toggle("noUserSelect", fr);
            }
            addShouldRescale(fr) {
              mr(this, jt).add(fr);
            }
            removeShouldRescale(fr) {
              mr(this, jt).delete(fr);
            }
            onScaleChanging(fr) {
              let {
                scale: Cr
              } = fr;
              this.commitOrRemove(), this.viewParameters.realScale = Cr * _e.PixelsPerInch.PDF_TO_CSS_UNITS;
              for (const $r of mr(this, jt))
                $r.onScaleChanging();
            }
            onRotationChanging(fr) {
              let {
                pagesRotation: Cr
              } = fr;
              this.commitOrRemove(), this.viewParameters.rotation = Cr;
            }
            addToAnnotationStorage(fr) {
              !fr.isEmpty() && mr(this, wt) && !mr(this, wt).has(fr.id) && mr(this, wt).setValue(fr.id, fr);
            }
            blur() {
              if (!this.hasSelection)
                return;
              const {
                activeElement: fr
              } = document;
              for (const Cr of mr(this, $t))
                if (Cr.div.contains(fr)) {
                  tn(this, Mt, [Cr, fr]), Cr._focusEventsAllowed = !1;
                  break;
                }
            }
            focus() {
              if (!mr(this, Mt))
                return;
              const [fr, Cr] = mr(this, Mt);
              tn(this, Mt, null), Cr.addEventListener("focusin", () => {
                fr._focusEventsAllowed = !0;
              }, {
                once: !0
              }), Cr.focus();
            }
            addEditListeners() {
              Ur(this, Wt, _s).call(this), Ur(this, pr, js).call(this);
            }
            removeEditListeners() {
              Ur(this, lr, os).call(this), Ur(this, Er, Us).call(this);
            }
            copy(fr) {
              var $r;
              if (fr.preventDefault(), ($r = mr(this, St)) == null || $r.commitOrRemove(), !this.hasSelection)
                return;
              const Cr = [];
              for (const wr of mr(this, $t)) {
                const Mr = wr.serialize(!0);
                Mr && Cr.push(Mr);
              }
              Cr.length !== 0 && fr.clipboardData.setData("application/pdfjs", JSON.stringify(Cr));
            }
            cut(fr) {
              this.copy(fr), this.delete();
            }
            paste(fr) {
              fr.preventDefault();
              const {
                clipboardData: Cr
              } = fr;
              for (const Mr of Cr.items)
                for (const Fr of mr(this, kt))
                  if (Fr.isHandlingMimeForPasting(Mr.type)) {
                    Fr.paste(Mr, this.currentLayer);
                    return;
                  }
              let $r = Cr.getData("application/pdfjs");
              if (!$r)
                return;
              try {
                $r = JSON.parse($r);
              } catch (Mr) {
                (0, _.warn)(`paste: "${Mr.message}".`);
                return;
              }
              if (!Array.isArray($r))
                return;
              this.unselectAll();
              const wr = this.currentLayer;
              try {
                const Mr = [];
                for (const Yr of $r) {
                  const kr = wr.deserialize(Yr);
                  if (!kr)
                    return;
                  Mr.push(kr);
                }
                const Fr = () => {
                  for (const Yr of Mr)
                    Ur(this, Pr, Hs).call(this, Yr);
                  Ur(this, Or, zs).call(this, Mr);
                }, Qr = () => {
                  for (const Yr of Mr)
                    Yr.remove();
                };
                this.addCommands({
                  cmd: Fr,
                  undo: Qr,
                  mustExec: !0
                });
              } catch (Mr) {
                (0, _.warn)(`paste: "${Mr.message}".`);
              }
            }
            keydown(fr) {
              var Cr;
              (Cr = this.getActive()) != null && Cr.shouldGetKeyboardEvents() || jr._keyboardManager.exec(this, fr);
            }
            onEditingAction(fr) {
              ["undo", "redo", "delete", "selectAll"].includes(fr.name) && this[fr.name]();
            }
            setEditingState(fr) {
              fr ? (Ur(this, cr, Ml).call(this), Ur(this, Wt, _s).call(this), Ur(this, pr, js).call(this), Ur(this, gr, xo).call(this, {
                isEditing: mr(this, Lt) !== _.AnnotationEditorType.NONE,
                isEmpty: Ur(this, Dr, Vo).call(this),
                hasSomethingToUndo: mr(this, Ct).hasSomethingToUndo(),
                hasSomethingToRedo: mr(this, Ct).hasSomethingToRedo(),
                hasSelectedEditor: !1
              })) : (Ur(this, Xt, Ls).call(this), Ur(this, lr, os).call(this), Ur(this, Er, Us).call(this), Ur(this, gr, xo).call(this, {
                isEditing: !1
              }), this.disableUserSelect(!1));
            }
            registerEditorTypes(fr) {
              if (!mr(this, kt)) {
                tn(this, kt, fr);
                for (const Cr of mr(this, kt))
                  Ur(this, Sr, Go).call(this, Cr.defaultPropertiesToUpdate);
              }
            }
            getId() {
              return mr(this, Ft).getId();
            }
            get currentLayer() {
              return mr(this, Ot).get(mr(this, It));
            }
            getLayer(fr) {
              return mr(this, Ot).get(fr);
            }
            get currentPageIndex() {
              return mr(this, It);
            }
            addLayer(fr) {
              mr(this, Ot).set(fr.pageIndex, fr), mr(this, _t) ? fr.enable() : fr.disable();
            }
            removeLayer(fr) {
              mr(this, Ot).delete(fr.pageIndex);
            }
            updateMode(fr) {
              let Cr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              if (mr(this, Lt) !== fr) {
                if (tn(this, Lt, fr), fr === _.AnnotationEditorType.NONE) {
                  this.setEditingState(!1), Ur(this, vr, Fl).call(this);
                  return;
                }
                this.setEditingState(!0), Ur(this, Ir, kl).call(this), this.unselectAll();
                for (const $r of mr(this, Ot).values())
                  $r.updateMode(fr);
                if (Cr) {
                  for (const $r of mr(this, Bt).values())
                    if ($r.annotationElementId === Cr) {
                      this.setSelected($r), $r.enterInEditMode();
                      break;
                    }
                }
              }
            }
            updateToolbar(fr) {
              fr !== mr(this, Lt) && this._eventBus.dispatch("switchannotationeditormode", {
                source: this,
                mode: fr
              });
            }
            updateParams(fr, Cr) {
              if (mr(this, kt)) {
                if (fr === _.AnnotationEditorParamsType.CREATE) {
                  this.currentLayer.addNewEditor(fr);
                  return;
                }
                for (const $r of mr(this, $t))
                  $r.updateParams(fr, Cr);
                for (const $r of mr(this, kt))
                  $r.updateDefaultParams(fr, Cr);
              }
            }
            enableWaiting() {
              let fr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              if (mr(this, Nt) !== fr) {
                tn(this, Nt, fr);
                for (const Cr of mr(this, Ot).values())
                  fr ? Cr.disableClick() : Cr.enableClick(), Cr.div.classList.toggle("waiting", fr);
              }
            }
            getEditors(fr) {
              const Cr = [];
              for (const $r of mr(this, Bt).values())
                $r.pageIndex === fr && Cr.push($r);
              return Cr;
            }
            getEditor(fr) {
              return mr(this, Bt).get(fr);
            }
            addEditor(fr) {
              mr(this, Bt).set(fr.id, fr);
            }
            removeEditor(fr) {
              var Cr;
              mr(this, Bt).delete(fr.id), this.unselect(fr), (!fr.annotationElementId || !mr(this, yt).has(fr.annotationElementId)) && ((Cr = mr(this, wt)) == null || Cr.remove(fr.id));
            }
            addDeletedAnnotationElement(fr) {
              mr(this, yt).add(fr.annotationElementId), fr.deleted = !0;
            }
            isDeletedAnnotationElement(fr) {
              return mr(this, yt).has(fr);
            }
            removeDeletedAnnotationElement(fr) {
              mr(this, yt).delete(fr.annotationElementId), fr.deleted = !1;
            }
            setActiveEditor(fr) {
              mr(this, St) !== fr && (tn(this, St, fr), fr && Ur(this, Sr, Go).call(this, fr.propertiesToUpdate));
            }
            toggleSelected(fr) {
              if (mr(this, $t).has(fr)) {
                mr(this, $t).delete(fr), fr.unselect(), Ur(this, gr, xo).call(this, {
                  hasSelectedEditor: this.hasSelection
                });
                return;
              }
              mr(this, $t).add(fr), fr.select(), Ur(this, Sr, Go).call(this, fr.propertiesToUpdate), Ur(this, gr, xo).call(this, {
                hasSelectedEditor: !0
              });
            }
            setSelected(fr) {
              for (const Cr of mr(this, $t))
                Cr !== fr && Cr.unselect();
              mr(this, $t).clear(), mr(this, $t).add(fr), fr.select(), Ur(this, Sr, Go).call(this, fr.propertiesToUpdate), Ur(this, gr, xo).call(this, {
                hasSelectedEditor: !0
              });
            }
            isSelected(fr) {
              return mr(this, $t).has(fr);
            }
            unselect(fr) {
              fr.unselect(), mr(this, $t).delete(fr), Ur(this, gr, xo).call(this, {
                hasSelectedEditor: this.hasSelection
              });
            }
            get hasSelection() {
              return mr(this, $t).size !== 0;
            }
            undo() {
              mr(this, Ct).undo(), Ur(this, gr, xo).call(this, {
                hasSomethingToUndo: mr(this, Ct).hasSomethingToUndo(),
                hasSomethingToRedo: !0,
                isEmpty: Ur(this, Dr, Vo).call(this)
              });
            }
            redo() {
              mr(this, Ct).redo(), Ur(this, gr, xo).call(this, {
                hasSomethingToUndo: !0,
                hasSomethingToRedo: mr(this, Ct).hasSomethingToRedo(),
                isEmpty: Ur(this, Dr, Vo).call(this)
              });
            }
            addCommands(fr) {
              mr(this, Ct).add(fr), Ur(this, gr, xo).call(this, {
                hasSomethingToUndo: !0,
                hasSomethingToRedo: !1,
                isEmpty: Ur(this, Dr, Vo).call(this)
              });
            }
            delete() {
              if (this.commitOrRemove(), !this.hasSelection)
                return;
              const fr = [...mr(this, $t)], Cr = () => {
                for (const wr of fr)
                  wr.remove();
              }, $r = () => {
                for (const wr of fr)
                  Ur(this, Pr, Hs).call(this, wr);
              };
              this.addCommands({
                cmd: Cr,
                undo: $r,
                mustExec: !0
              });
            }
            commitOrRemove() {
              var fr;
              (fr = mr(this, St)) == null || fr.commitOrRemove();
            }
            hasSomethingToControl() {
              return mr(this, St) || this.hasSelection;
            }
            selectAll() {
              for (const fr of mr(this, $t))
                fr.commit();
              Ur(this, Or, zs).call(this, mr(this, Bt).values());
            }
            unselectAll() {
              if (mr(this, St)) {
                mr(this, St).commitOrRemove();
                return;
              }
              if (this.hasSelection) {
                for (const fr of mr(this, $t))
                  fr.unselect();
                mr(this, $t).clear(), Ur(this, gr, xo).call(this, {
                  hasSelectedEditor: !1
                });
              }
            }
            translateSelectedEditors(fr, Cr) {
              if ((arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1) || this.commitOrRemove(), !this.hasSelection)
                return;
              mr(this, nr)[0] += fr, mr(this, nr)[1] += Cr;
              const [wr, Mr] = mr(this, nr), Fr = [...mr(this, $t)], Qr = 1e3;
              mr(this, tr) && clearTimeout(mr(this, tr)), tn(this, tr, setTimeout(() => {
                tn(this, tr, null), mr(this, nr)[0] = mr(this, nr)[1] = 0, this.addCommands({
                  cmd: () => {
                    for (const Yr of Fr)
                      mr(this, Bt).has(Yr.id) && Yr.translateInPage(wr, Mr);
                  },
                  undo: () => {
                    for (const Yr of Fr)
                      mr(this, Bt).has(Yr.id) && Yr.translateInPage(-wr, -Mr);
                  },
                  mustExec: !1
                });
              }, Qr));
              for (const Yr of Fr)
                Yr.translateInPage(fr, Cr);
            }
            setUpDragSession() {
              if (this.hasSelection) {
                this.disableUserSelect(!0), tn(this, Rt, /* @__PURE__ */ new Map());
                for (const fr of mr(this, $t))
                  mr(this, Rt).set(fr, {
                    savedX: fr.x,
                    savedY: fr.y,
                    savedPageIndex: fr.pageIndex,
                    newX: 0,
                    newY: 0,
                    newPageIndex: -1
                  });
              }
            }
            endDragSession() {
              if (!mr(this, Rt))
                return !1;
              this.disableUserSelect(!1);
              const fr = mr(this, Rt);
              tn(this, Rt, null);
              let Cr = !1;
              for (const [{
                x: wr,
                y: Mr,
                pageIndex: Fr
              }, Qr] of fr)
                Qr.newX = wr, Qr.newY = Mr, Qr.newPageIndex = Fr, Cr || (Cr = wr !== Qr.savedX || Mr !== Qr.savedY || Fr !== Qr.savedPageIndex);
              if (!Cr)
                return !1;
              const $r = (wr, Mr, Fr, Qr) => {
                if (mr(this, Bt).has(wr.id)) {
                  const Yr = mr(this, Ot).get(Qr);
                  Yr ? wr._setParentAndPosition(Yr, Mr, Fr) : (wr.pageIndex = Qr, wr.x = Mr, wr.y = Fr);
                }
              };
              return this.addCommands({
                cmd: () => {
                  for (const [wr, {
                    newX: Mr,
                    newY: Fr,
                    newPageIndex: Qr
                  }] of fr)
                    $r(wr, Mr, Fr, Qr);
                },
                undo: () => {
                  for (const [wr, {
                    savedX: Mr,
                    savedY: Fr,
                    savedPageIndex: Qr
                  }] of fr)
                    $r(wr, Mr, Fr, Qr);
                },
                mustExec: !0
              }), !0;
            }
            dragSelectedEditors(fr, Cr) {
              if (mr(this, Rt))
                for (const $r of mr(this, Rt).keys())
                  $r.drag(fr, Cr);
            }
            rebuild(fr) {
              if (fr.parent === null) {
                const Cr = this.getLayer(fr.pageIndex);
                Cr ? (Cr.changeParent(fr), Cr.addOrRebuild(fr)) : (this.addEditor(fr), this.addToAnnotationStorage(fr), fr.rebuild());
              } else
                fr.parent.addOrRebuild(fr);
            }
            isActive(fr) {
              return mr(this, St) === fr;
            }
            getActive() {
              return mr(this, St);
            }
            getMode() {
              return mr(this, Lt);
            }
            get imageManager() {
              return (0, _.shadow)(this, "imageManager", new ot());
            }
          };
          St = new WeakMap(), Bt = new WeakMap(), Ot = new WeakMap(), Pt = new WeakMap(), wt = new WeakMap(), Ct = new WeakMap(), It = new WeakMap(), yt = new WeakMap(), Rt = new WeakMap(), kt = new WeakMap(), jt = new WeakMap(), Ht = new WeakMap(), Ft = new WeakMap(), _t = new WeakMap(), Nt = new WeakMap(), Mt = new WeakMap(), Lt = new WeakMap(), $t = new WeakMap(), Tt = new WeakMap(), Dt = new WeakMap(), Ut = new WeakMap(), Vt = new WeakMap(), Qt = new WeakMap(), qt = new WeakMap(), Zt = new WeakMap(), ar = new WeakMap(), Jt = new WeakMap(), rr = new WeakMap(), Yt = new WeakMap(), Kt = new WeakMap(), nr = new WeakMap(), tr = new WeakMap(), ir = new WeakMap(), sr = new WeakMap(), cr = new WeakSet(), Ml = function() {
            window.addEventListener("focus", mr(this, Ut)), window.addEventListener("blur", mr(this, Dt));
          }, Xt = new WeakSet(), Ls = function() {
            window.removeEventListener("focus", mr(this, Ut)), window.removeEventListener("blur", mr(this, Dt));
          }, Wt = new WeakSet(), _s = function() {
            window.addEventListener("keydown", mr(this, Zt), {
              capture: !0
            });
          }, lr = new WeakSet(), os = function() {
            window.removeEventListener("keydown", mr(this, Zt), {
              capture: !0
            });
          }, pr = new WeakSet(), js = function() {
            document.addEventListener("copy", mr(this, Vt)), document.addEventListener("cut", mr(this, Qt)), document.addEventListener("paste", mr(this, qt));
          }, Er = new WeakSet(), Us = function() {
            document.removeEventListener("copy", mr(this, Vt)), document.removeEventListener("cut", mr(this, Qt)), document.removeEventListener("paste", mr(this, qt));
          }, gr = new WeakSet(), xo = function(fr) {
            Object.entries(fr).some(($r) => {
              let [wr, Mr] = $r;
              return mr(this, Kt)[wr] !== Mr;
            }) && this._eventBus.dispatch("annotationeditorstateschanged", {
              source: this,
              details: Object.assign(mr(this, Kt), fr)
            });
          }, Sr = new WeakSet(), Go = function(fr) {
            this._eventBus.dispatch("annotationeditorparamschanged", {
              source: this,
              details: fr
            });
          }, Ir = new WeakSet(), kl = function() {
            if (!mr(this, _t)) {
              tn(this, _t, !0);
              for (const fr of mr(this, Ot).values())
                fr.enable();
            }
          }, vr = new WeakSet(), Fl = function() {
            if (this.unselectAll(), mr(this, _t)) {
              tn(this, _t, !1);
              for (const fr of mr(this, Ot).values())
                fr.disable();
            }
          }, Pr = new WeakSet(), Hs = function(fr) {
            const Cr = mr(this, Ot).get(fr.pageIndex);
            Cr ? Cr.addOrRebuild(fr) : this.addEditor(fr);
          }, Dr = new WeakSet(), Vo = function() {
            if (mr(this, Bt).size === 0)
              return !0;
            if (mr(this, Bt).size === 1)
              for (const fr of mr(this, Bt).values())
                return fr.isEmpty();
            return !1;
          }, Or = new WeakSet(), zs = function(fr) {
            mr(this, $t).clear();
            for (const Cr of fr)
              Cr.isEmpty() || (mr(this, $t).add(Cr), Cr.select());
            Ur(this, gr, xo).call(this, {
              hasSelectedEditor: !0
            });
          }, Ln(jr, "TRANSLATE_SMALL", 1), Ln(jr, "TRANSLATE_BIG", 10);
          let et = jr;
          s.AnnotationEditorUIManager = et;
        },
        /* 166 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(6), tt = $(4), nt = $(24), at = $(14), ot = $(8), rt = $(21), st = $(20), lt = $(91), et = $(39), it = $(77), ut = $(64), ft = $(159), ht = $(7), dt = $(167), gt = $(27), pt = tt.JSON, mt = tt.Number, ct = tt.SyntaxError, vt = pt && pt.parse, At = nt("Object", "keys"), xt = Object.getOwnPropertyDescriptor, bt = at("".charAt), Et = at("".slice), St = at(/./.exec), Bt = at([].push), Ot = /^\d$/, Pt = /^[1-9]$/, wt = /^(?:-|\d)$/, Ct = /^[\t\n\r ]$/, It = 0, yt = 1, Rt = function(Mt, Lt) {
            Mt = it(Mt);
            var $t = new Ft(Mt, 0), Tt = $t.parse(), Dt = Tt.value, Ut = $t.skip(Ct, Tt.end);
            if (Ut < Mt.length)
              throw ct('Unexpected extra character: "' + bt(Mt, Ut) + '" after the parsed data at: ' + Ut);
            return rt(Lt) ? kt({ "": Dt }, "", Lt, Tt) : Dt;
          }, kt = function(Mt, Lt, $t, Tt) {
            var Dt = Mt[Lt], Ut = Tt && Dt === Tt.value, Vt = Ut && typeof Tt.source == "string" ? { source: Tt.source } : {}, Qt, qt, Zt, ar, Jt;
            if (st(Dt)) {
              var rr = lt(Dt), Yt = Ut ? Tt.nodes : rr ? [] : {};
              if (rr)
                for (Qt = Yt.length, Zt = ut(Dt), ar = 0; ar < Zt; ar++)
                  jt(Dt, ar, kt(Dt, "" + ar, $t, ar < Qt ? Yt[ar] : void 0));
              else
                for (qt = At(Dt), Zt = ut(qt), ar = 0; ar < Zt; ar++)
                  Jt = qt[ar], jt(Dt, Jt, kt(Dt, Jt, $t, et(Yt, Jt) ? Yt[Jt] : void 0));
            }
            return ot($t, Mt, Lt, Dt, Vt);
          }, jt = function(Mt, Lt, $t) {
            if (_e) {
              var Tt = xt(Mt, Lt);
              if (Tt && !Tt.configurable)
                return;
            }
            $t === void 0 ? delete Mt[Lt] : ft(Mt, Lt, $t);
          }, Ht = function(Mt, Lt, $t, Tt) {
            this.value = Mt, this.end = Lt, this.source = $t, this.nodes = Tt;
          }, Ft = function(Mt, Lt) {
            this.source = Mt, this.index = Lt;
          };
          Ft.prototype = {
            fork: function(Mt) {
              return new Ft(this.source, Mt);
            },
            parse: function() {
              var Mt = this.source, Lt = this.skip(Ct, this.index), $t = this.fork(Lt), Tt = bt(Mt, Lt);
              if (St(wt, Tt))
                return $t.number();
              switch (Tt) {
                case "{":
                  return $t.object();
                case "[":
                  return $t.array();
                case '"':
                  return $t.string();
                case "t":
                  return $t.keyword(!0);
                case "f":
                  return $t.keyword(!1);
                case "n":
                  return $t.keyword(null);
              }
              throw ct('Unexpected character: "' + Tt + '" at: ' + Lt);
            },
            node: function(Mt, Lt, $t, Tt, Dt) {
              return new Ht(Lt, Tt, Mt ? null : Et(this.source, $t, Tt), Dt);
            },
            object: function() {
              for (var Mt = this.source, Lt = this.index + 1, $t = !1, Tt = {}, Dt = {}; Lt < Mt.length; ) {
                if (Lt = this.until([
                  '"',
                  "}"
                ], Lt), bt(Mt, Lt) === "}" && !$t) {
                  Lt++;
                  break;
                }
                var Ut = this.fork(Lt).string(), Vt = Ut.value;
                Lt = Ut.end, Lt = this.until([":"], Lt) + 1, Lt = this.skip(Ct, Lt), Ut = this.fork(Lt).parse(), ft(Dt, Vt, Ut), ft(Tt, Vt, Ut.value), Lt = this.until([
                  ",",
                  "}"
                ], Ut.end);
                var Qt = bt(Mt, Lt);
                if (Qt === ",")
                  $t = !0, Lt++;
                else if (Qt === "}") {
                  Lt++;
                  break;
                }
              }
              return this.node(yt, Tt, this.index, Lt, Dt);
            },
            array: function() {
              for (var Mt = this.source, Lt = this.index + 1, $t = !1, Tt = [], Dt = []; Lt < Mt.length; ) {
                if (Lt = this.skip(Ct, Lt), bt(Mt, Lt) === "]" && !$t) {
                  Lt++;
                  break;
                }
                var Ut = this.fork(Lt).parse();
                if (Bt(Dt, Ut), Bt(Tt, Ut.value), Lt = this.until([
                  ",",
                  "]"
                ], Ut.end), bt(Mt, Lt) === ",")
                  $t = !0, Lt++;
                else if (bt(Mt, Lt) === "]") {
                  Lt++;
                  break;
                }
              }
              return this.node(yt, Tt, this.index, Lt, Dt);
            },
            string: function() {
              var Mt = this.index, Lt = dt(this.source, this.index + 1);
              return this.node(It, Lt.value, Mt, Lt.end);
            },
            number: function() {
              var Mt = this.source, Lt = this.index, $t = Lt;
              if (bt(Mt, $t) === "-" && $t++, bt(Mt, $t) === "0")
                $t++;
              else if (St(Pt, bt(Mt, $t)))
                $t = this.skip(Ot, ++$t);
              else
                throw ct("Failed to parse number at: " + $t);
              if (bt(Mt, $t) === "." && ($t = this.skip(Ot, ++$t)), bt(Mt, $t) === "e" || bt(Mt, $t) === "E") {
                $t++, (bt(Mt, $t) === "+" || bt(Mt, $t) === "-") && $t++;
                var Tt = $t;
                if ($t = this.skip(Ot, $t), Tt === $t)
                  throw ct("Failed to parse number's exponent value at: " + $t);
              }
              return this.node(It, mt(Et(Mt, Lt, $t)), Lt, $t);
            },
            keyword: function(Mt) {
              var Lt = "" + Mt, $t = this.index, Tt = $t + Lt.length;
              if (Et(this.source, $t, Tt) !== Lt)
                throw ct("Failed to parse value at: " + $t);
              return this.node(It, Mt, $t, Tt);
            },
            skip: function(Mt, Lt) {
              for (var $t = this.source; Lt < $t.length && St(Mt, bt($t, Lt)); Lt++)
                ;
              return Lt;
            },
            until: function(Mt, Lt) {
              Lt = this.skip(Ct, Lt);
              for (var $t = bt(this.source, Lt), Tt = 0; Tt < Mt.length; Tt++)
                if (Mt[Tt] === $t)
                  return Lt;
              throw ct('Unexpected character: "' + $t + '" at: ' + Lt);
            }
          };
          var _t = ht(function() {
            var Mt = "9007199254740993", Lt;
            return vt(Mt, function($t, Tt, Dt) {
              Lt = Dt.source;
            }), Lt !== Mt;
          }), Nt = gt && !ht(function() {
            return 1 / vt("-0 	") !== -1 / 0;
          });
          _({
            target: "JSON",
            stat: !0,
            forced: _t
          }, {
            parse: function(Lt, $t) {
              return Nt && !rt($t) ? vt(Lt) : Rt(Lt, $t);
            }
          });
        },
        /* 167 */
        /***/
        (a, s, $) => {
          var _ = $(14), _e = $(39), tt = SyntaxError, nt = parseInt, at = String.fromCharCode, ot = _("".charAt), rt = _("".slice), st = _(/./.exec), lt = {
            '\\"': '"',
            "\\\\": "\\",
            "\\/": "/",
            "\\b": "\b",
            "\\f": "\f",
            "\\n": `
`,
            "\\r": "\r",
            "\\t": "	"
          }, et = /^[\da-f]{4}$/i, it = /^[\u0000-\u001F]$/;
          a.exports = function(ut, ft) {
            for (var ht = !0, dt = ""; ft < ut.length; ) {
              var gt = ot(ut, ft);
              if (gt === "\\") {
                var pt = rt(ut, ft, ft + 2);
                if (_e(lt, pt))
                  dt += lt[pt], ft += 2;
                else if (pt === "\\u") {
                  ft += 2;
                  var mt = rt(ut, ft, ft + 4);
                  if (!st(et, mt))
                    throw tt("Bad Unicode escape at: " + ft);
                  dt += at(nt(mt, 16)), ft += 4;
                } else
                  throw tt('Unknown escape sequence: "' + pt + '"');
              } else if (gt === '"') {
                ht = !1, ft++;
                break;
              } else {
                if (st(it, gt))
                  throw tt("Bad control character in string literal at: " + ft);
                dt += gt, ft++;
              }
            }
            if (ht)
              throw tt("Unterminated string at: " + ft);
            return {
              value: dt,
              end: ft
            };
          };
        },
        /* 168 */
        /***/
        (a, s, $) => {
          var It, yt, Rt, kt, jt, Ht, Ft, _t, Nt, Mt, Lt, $t, Lo, Dt, _o, Vt, Ws, qt, ss, ar, ls, rr, Qo, Kt, Yo;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.StatTimer = s.RenderingCancelledException = s.PixelsPerInch = s.PageViewport = s.PDFDateString = s.DOMStandardFontDataFactory = s.DOMSVGFactory = s.DOMFilterFactory = s.DOMCanvasFactory = s.DOMCMapReaderFactory = void 0, s.deprecated = At, s.getColorValues = Bt, s.getCurrentTransform = Ot, s.getCurrentTransformInverse = Pt, s.getFilenameFromUrl = dt, s.getPdfFilenameFromUrl = gt, s.getRGB = St, s.getXfaPageViewport = Et, s.isDataScheme = ft, s.isPdfFile = ht, s.isValidFetchUrl = mt, s.loadScript = vt, s.noContextMenu = ct, s.setLayerDimensions = wt, $(2), $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123), $(89), $(84), $(86), $(87);
          var _ = $(169), _e = $(1);
          const tt = "http://www.w3.org/2000/svg", Ct = class Ct {
          };
          Ln(Ct, "CSS", 96), Ln(Ct, "PDF", 72), Ln(Ct, "PDF_TO_CSS_UNITS", Ct.CSS / Ct.PDF);
          let nt = Ct;
          s.PixelsPerInch = nt;
          class at extends _.BaseFilterFactory {
            constructor() {
              let {
                docId: sr,
                ownerDocument: cr = globalThis.document
              } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              super();
              _r(this, $t);
              _r(this, Dt);
              _r(this, Vt);
              _r(this, qt);
              _r(this, ar);
              _r(this, rr);
              _r(this, Kt);
              _r(this, It, void 0);
              _r(this, yt, void 0);
              _r(this, Rt, void 0);
              _r(this, kt, void 0);
              _r(this, jt, void 0);
              _r(this, Ht, void 0);
              _r(this, Ft, void 0);
              _r(this, _t, void 0);
              _r(this, Nt, void 0);
              _r(this, Mt, void 0);
              _r(this, Lt, 0);
              tn(this, Rt, sr), tn(this, kt, cr);
            }
            addFilter(sr) {
              if (!sr)
                return "none";
              let cr = mr(this, $t, Lo).get(sr);
              if (cr)
                return cr;
              let or, Xt, Gt, Wt;
              if (sr.length === 1) {
                const pr = sr[0], yr = new Array(256);
                for (let Er = 0; Er < 256; Er++)
                  yr[Er] = pr[Er] / 255;
                Wt = or = Xt = Gt = yr.join(",");
              } else {
                const [pr, yr, Er] = sr, br = new Array(256), gr = new Array(256), Ar = new Array(256);
                for (let Sr = 0; Sr < 256; Sr++)
                  br[Sr] = pr[Sr] / 255, gr[Sr] = yr[Sr] / 255, Ar[Sr] = Er[Sr] / 255;
                or = br.join(","), Xt = gr.join(","), Gt = Ar.join(","), Wt = `${or}${Xt}${Gt}`;
              }
              if (cr = mr(this, $t, Lo).get(Wt), cr)
                return mr(this, $t, Lo).set(sr, cr), cr;
              const er = `g_${mr(this, Rt)}_transfer_map_${Wo(this, Lt)._++}`, lr = `url(#${er})`;
              mr(this, $t, Lo).set(sr, lr), mr(this, $t, Lo).set(Wt, lr);
              const ur = Ur(this, qt, ss).call(this, er);
              return Ur(this, rr, Qo).call(this, or, Xt, Gt, ur), lr;
            }
            addHCMFilter(sr, cr) {
              var yr;
              const or = `${sr}-${cr}`;
              if (mr(this, Ht) === or)
                return mr(this, Ft);
              if (tn(this, Ht, or), tn(this, Ft, "none"), (yr = mr(this, jt)) == null || yr.remove(), !sr || !cr)
                return mr(this, Ft);
              const Xt = Ur(this, Kt, Yo).call(this, sr);
              sr = _e.Util.makeHexColor(...Xt);
              const Gt = Ur(this, Kt, Yo).call(this, cr);
              if (cr = _e.Util.makeHexColor(...Gt), mr(this, Dt, _o).style.color = "", sr === "#000000" && cr === "#ffffff" || sr === cr)
                return mr(this, Ft);
              const Wt = new Array(256);
              for (let Er = 0; Er <= 255; Er++) {
                const br = Er / 255;
                Wt[Er] = br <= 0.03928 ? br / 12.92 : ((br + 0.055) / 1.055) ** 2.4;
              }
              const er = Wt.join(","), lr = `g_${mr(this, Rt)}_hcm_filter`, ur = tn(this, _t, Ur(this, qt, ss).call(this, lr));
              Ur(this, rr, Qo).call(this, er, er, er, ur), Ur(this, Vt, Ws).call(this, ur);
              const pr = (Er, br) => {
                const gr = Xt[Er] / 255, Ar = Gt[Er] / 255, Sr = new Array(br + 1);
                for (let Br = 0; Br <= br; Br++)
                  Sr[Br] = gr + Br / br * (Ar - gr);
                return Sr.join(",");
              };
              return Ur(this, rr, Qo).call(this, pr(0, 5), pr(1, 5), pr(2, 5), ur), tn(this, Ft, `url(#${lr})`), mr(this, Ft);
            }
            addHighlightHCMFilter(sr, cr, or, Xt) {
              var Ar;
              const Gt = `${sr}-${cr}-${or}-${Xt}`;
              if (mr(this, Nt) === Gt)
                return mr(this, Mt);
              if (tn(this, Nt, Gt), tn(this, Mt, "none"), (Ar = mr(this, _t)) == null || Ar.remove(), !sr || !cr)
                return mr(this, Mt);
              const [Wt, er] = [sr, cr].map(Ur(this, Kt, Yo).bind(this));
              let lr = Math.round(0.2126 * Wt[0] + 0.7152 * Wt[1] + 0.0722 * Wt[2]), ur = Math.round(0.2126 * er[0] + 0.7152 * er[1] + 0.0722 * er[2]), [pr, yr] = [or, Xt].map(Ur(this, Kt, Yo).bind(this));
              ur < lr && ([lr, ur, pr, yr] = [ur, lr, yr, pr]), mr(this, Dt, _o).style.color = "";
              const Er = (Sr, Br, Ir) => {
                const hr = new Array(256), vr = (ur - lr) / Ir, xr = Sr / 255, Pr = (Br - Sr) / (255 * Ir);
                let Rr = 0;
                for (let Dr = 0; Dr <= Ir; Dr++) {
                  const Gr = Math.round(lr + Dr * vr), Or = xr + Dr * Pr;
                  for (let Hr = Rr; Hr <= Gr; Hr++)
                    hr[Hr] = Or;
                  Rr = Gr + 1;
                }
                for (let Dr = Rr; Dr < 256; Dr++)
                  hr[Dr] = hr[Rr - 1];
                return hr.join(",");
              }, br = `g_${mr(this, Rt)}_hcm_highlight_filter`, gr = tn(this, _t, Ur(this, qt, ss).call(this, br));
              return Ur(this, Vt, Ws).call(this, gr), Ur(this, rr, Qo).call(this, Er(pr[0], yr[0], 5), Er(pr[1], yr[1], 5), Er(pr[2], yr[2], 5), gr), tn(this, Mt, `url(#${br})`), mr(this, Mt);
            }
            destroy() {
              arguments.length > 0 && arguments[0] !== void 0 && arguments[0] && (mr(this, Ft) || mr(this, Mt)) || (mr(this, yt) && (mr(this, yt).parentNode.parentNode.remove(), tn(this, yt, null)), mr(this, It) && (mr(this, It).clear(), tn(this, It, null)), tn(this, Lt, 0));
            }
          }
          It = new WeakMap(), yt = new WeakMap(), Rt = new WeakMap(), kt = new WeakMap(), jt = new WeakMap(), Ht = new WeakMap(), Ft = new WeakMap(), _t = new WeakMap(), Nt = new WeakMap(), Mt = new WeakMap(), Lt = new WeakMap(), $t = new WeakSet(), Lo = function() {
            return mr(this, It) || tn(this, It, /* @__PURE__ */ new Map());
          }, Dt = new WeakSet(), _o = function() {
            if (!mr(this, yt)) {
              const sr = mr(this, kt).createElement("div"), {
                style: cr
              } = sr;
              cr.visibility = "hidden", cr.contain = "strict", cr.width = cr.height = 0, cr.position = "absolute", cr.top = cr.left = 0, cr.zIndex = -1;
              const or = mr(this, kt).createElementNS(tt, "svg");
              or.setAttribute("width", 0), or.setAttribute("height", 0), tn(this, yt, mr(this, kt).createElementNS(tt, "defs")), sr.append(or), or.append(mr(this, yt)), mr(this, kt).body.append(sr);
            }
            return mr(this, yt);
          }, Vt = new WeakSet(), Ws = function(sr) {
            const cr = mr(this, kt).createElementNS(tt, "feColorMatrix");
            cr.setAttribute("type", "matrix"), cr.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"), sr.append(cr);
          }, qt = new WeakSet(), ss = function(sr) {
            const cr = mr(this, kt).createElementNS(tt, "filter");
            return cr.setAttribute("color-interpolation-filters", "sRGB"), cr.setAttribute("id", sr), mr(this, Dt, _o).append(cr), cr;
          }, ar = new WeakSet(), ls = function(sr, cr, or) {
            const Xt = mr(this, kt).createElementNS(tt, cr);
            Xt.setAttribute("type", "discrete"), Xt.setAttribute("tableValues", or), sr.append(Xt);
          }, rr = new WeakSet(), Qo = function(sr, cr, or, Xt) {
            const Gt = mr(this, kt).createElementNS(tt, "feComponentTransfer");
            Xt.append(Gt), Ur(this, ar, ls).call(this, Gt, "feFuncR", sr), Ur(this, ar, ls).call(this, Gt, "feFuncG", cr), Ur(this, ar, ls).call(this, Gt, "feFuncB", or);
          }, Kt = new WeakSet(), Yo = function(sr) {
            return mr(this, Dt, _o).style.color = sr, St(getComputedStyle(mr(this, Dt, _o)).getPropertyValue("color"));
          }, s.DOMFilterFactory = at;
          class ot extends _.BaseCanvasFactory {
            constructor() {
              let {
                ownerDocument: ir = globalThis.document
              } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              super(), this._document = ir;
            }
            _createCanvas(ir, sr) {
              const cr = this._document.createElement("canvas");
              return cr.width = ir, cr.height = sr, cr;
            }
          }
          s.DOMCanvasFactory = ot;
          async function rt(tr) {
            let ir = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            if (mt(tr, document.baseURI)) {
              const sr = await fetch(tr);
              if (!sr.ok)
                throw new Error(sr.statusText);
              return ir ? new Uint8Array(await sr.arrayBuffer()) : (0, _e.stringToBytes)(await sr.text());
            }
            return new Promise((sr, cr) => {
              const or = new XMLHttpRequest();
              or.open("GET", tr, !0), ir && (or.responseType = "arraybuffer"), or.onreadystatechange = () => {
                if (or.readyState === XMLHttpRequest.DONE) {
                  if (or.status === 200 || or.status === 0) {
                    let Xt;
                    if (ir && or.response ? Xt = new Uint8Array(or.response) : !ir && or.responseText && (Xt = (0, _e.stringToBytes)(or.responseText)), Xt) {
                      sr(Xt);
                      return;
                    }
                  }
                  cr(new Error(or.statusText));
                }
              }, or.send(null);
            });
          }
          class st extends _.BaseCMapReaderFactory {
            _fetchData(ir, sr) {
              return rt(ir, this.isCompressed).then((cr) => ({
                cMapData: cr,
                compressionType: sr
              }));
            }
          }
          s.DOMCMapReaderFactory = st;
          class lt extends _.BaseStandardFontDataFactory {
            _fetchData(ir) {
              return rt(ir, !0);
            }
          }
          s.DOMStandardFontDataFactory = lt;
          class et extends _.BaseSVGFactory {
            _createSVG(ir) {
              return document.createElementNS(tt, ir);
            }
          }
          s.DOMSVGFactory = et;
          class it {
            constructor(ir) {
              let {
                viewBox: sr,
                scale: cr,
                rotation: or,
                offsetX: Xt = 0,
                offsetY: Gt = 0,
                dontFlip: Wt = !1
              } = ir;
              this.viewBox = sr, this.scale = cr, this.rotation = or, this.offsetX = Xt, this.offsetY = Gt;
              const er = (sr[2] + sr[0]) / 2, lr = (sr[3] + sr[1]) / 2;
              let ur, pr, yr, Er;
              switch (or %= 360, or < 0 && (or += 360), or) {
                case 180:
                  ur = -1, pr = 0, yr = 0, Er = 1;
                  break;
                case 90:
                  ur = 0, pr = 1, yr = 1, Er = 0;
                  break;
                case 270:
                  ur = 0, pr = -1, yr = -1, Er = 0;
                  break;
                case 0:
                  ur = 1, pr = 0, yr = 0, Er = -1;
                  break;
                default:
                  throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
              }
              Wt && (yr = -yr, Er = -Er);
              let br, gr, Ar, Sr;
              ur === 0 ? (br = Math.abs(lr - sr[1]) * cr + Xt, gr = Math.abs(er - sr[0]) * cr + Gt, Ar = (sr[3] - sr[1]) * cr, Sr = (sr[2] - sr[0]) * cr) : (br = Math.abs(er - sr[0]) * cr + Xt, gr = Math.abs(lr - sr[1]) * cr + Gt, Ar = (sr[2] - sr[0]) * cr, Sr = (sr[3] - sr[1]) * cr), this.transform = [ur * cr, pr * cr, yr * cr, Er * cr, br - ur * cr * er - yr * cr * lr, gr - pr * cr * er - Er * cr * lr], this.width = Ar, this.height = Sr;
            }
            get rawDims() {
              const {
                viewBox: ir
              } = this;
              return (0, _e.shadow)(this, "rawDims", {
                pageWidth: ir[2] - ir[0],
                pageHeight: ir[3] - ir[1],
                pageX: ir[0],
                pageY: ir[1]
              });
            }
            clone() {
              let {
                scale: ir = this.scale,
                rotation: sr = this.rotation,
                offsetX: cr = this.offsetX,
                offsetY: or = this.offsetY,
                dontFlip: Xt = !1
              } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              return new it({
                viewBox: this.viewBox.slice(),
                scale: ir,
                rotation: sr,
                offsetX: cr,
                offsetY: or,
                dontFlip: Xt
              });
            }
            convertToViewportPoint(ir, sr) {
              return _e.Util.applyTransform([ir, sr], this.transform);
            }
            convertToViewportRectangle(ir) {
              const sr = _e.Util.applyTransform([ir[0], ir[1]], this.transform), cr = _e.Util.applyTransform([ir[2], ir[3]], this.transform);
              return [sr[0], sr[1], cr[0], cr[1]];
            }
            convertToPdfPoint(ir, sr) {
              return _e.Util.applyInverseTransform([ir, sr], this.transform);
            }
          }
          s.PageViewport = it;
          class ut extends _e.BaseException {
            constructor(ir) {
              let sr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
              super(ir, "RenderingCancelledException"), this.extraDelay = sr;
            }
          }
          s.RenderingCancelledException = ut;
          function ft(tr) {
            const ir = tr.length;
            let sr = 0;
            for (; sr < ir && tr[sr].trim() === ""; )
              sr++;
            return tr.substring(sr, sr + 5).toLowerCase() === "data:";
          }
          function ht(tr) {
            return typeof tr == "string" && /\.pdf$/i.test(tr);
          }
          function dt(tr) {
            return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) || ([tr] = tr.split(/[#?]/, 1)), tr.substring(tr.lastIndexOf("/") + 1);
          }
          function gt(tr) {
            let ir = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "document.pdf";
            if (typeof tr != "string")
              return ir;
            if (ft(tr))
              return (0, _e.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), ir;
            const sr = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/, cr = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i, or = sr.exec(tr);
            let Xt = cr.exec(or[1]) || cr.exec(or[2]) || cr.exec(or[3]);
            if (Xt && (Xt = Xt[0], Xt.includes("%")))
              try {
                Xt = cr.exec(decodeURIComponent(Xt))[0];
              } catch {
              }
            return Xt || ir;
          }
          class pt {
            constructor() {
              Ln(this, "started", /* @__PURE__ */ Object.create(null));
              Ln(this, "times", []);
            }
            time(ir) {
              ir in this.started && (0, _e.warn)(`Timer is already running for ${ir}`), this.started[ir] = Date.now();
            }
            timeEnd(ir) {
              ir in this.started || (0, _e.warn)(`Timer has not been started for ${ir}`), this.times.push({
                name: ir,
                start: this.started[ir],
                end: Date.now()
              }), delete this.started[ir];
            }
            toString() {
              const ir = [];
              let sr = 0;
              for (const {
                name: cr
              } of this.times)
                sr = Math.max(cr.length, sr);
              for (const {
                name: cr,
                start: or,
                end: Xt
              } of this.times)
                ir.push(`${cr.padEnd(sr)} ${Xt - or}ms
`);
              return ir.join("");
            }
          }
          s.StatTimer = pt;
          function mt(tr, ir) {
            try {
              const {
                protocol: sr
              } = ir ? new URL(tr, ir) : new URL(tr);
              return sr === "http:" || sr === "https:";
            } catch {
              return !1;
            }
          }
          function ct(tr) {
            tr.preventDefault();
          }
          function vt(tr) {
            let ir = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            return new Promise((sr, cr) => {
              const or = document.createElement("script");
              or.src = tr, or.onload = function(Xt) {
                ir && or.remove(), sr(Xt);
              }, or.onerror = function() {
                cr(new Error(`Cannot load script at: ${or.src}`));
              }, (document.head || document.documentElement).append(or);
            });
          }
          function At(tr) {
            console.log("Deprecated API usage: " + tr);
          }
          let xt;
          class bt {
            static toDateObject(ir) {
              if (!ir || typeof ir != "string")
                return null;
              xt || (xt = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
              const sr = xt.exec(ir);
              if (!sr)
                return null;
              const cr = parseInt(sr[1], 10);
              let or = parseInt(sr[2], 10);
              or = or >= 1 && or <= 12 ? or - 1 : 0;
              let Xt = parseInt(sr[3], 10);
              Xt = Xt >= 1 && Xt <= 31 ? Xt : 1;
              let Gt = parseInt(sr[4], 10);
              Gt = Gt >= 0 && Gt <= 23 ? Gt : 0;
              let Wt = parseInt(sr[5], 10);
              Wt = Wt >= 0 && Wt <= 59 ? Wt : 0;
              let er = parseInt(sr[6], 10);
              er = er >= 0 && er <= 59 ? er : 0;
              const lr = sr[7] || "Z";
              let ur = parseInt(sr[8], 10);
              ur = ur >= 0 && ur <= 23 ? ur : 0;
              let pr = parseInt(sr[9], 10) || 0;
              return pr = pr >= 0 && pr <= 59 ? pr : 0, lr === "-" ? (Gt += ur, Wt += pr) : lr === "+" && (Gt -= ur, Wt -= pr), new Date(Date.UTC(cr, or, Xt, Gt, Wt, er));
            }
          }
          s.PDFDateString = bt;
          function Et(tr, ir) {
            let {
              scale: sr = 1,
              rotation: cr = 0
            } = ir;
            const {
              width: or,
              height: Xt
            } = tr.attributes.style, Gt = [0, 0, parseInt(or), parseInt(Xt)];
            return new it({
              viewBox: Gt,
              scale: sr,
              rotation: cr
            });
          }
          function St(tr) {
            if (tr.startsWith("#")) {
              const ir = parseInt(tr.slice(1), 16);
              return [(ir & 16711680) >> 16, (ir & 65280) >> 8, ir & 255];
            }
            return tr.startsWith("rgb(") ? tr.slice(4, -1).split(",").map((ir) => parseInt(ir)) : tr.startsWith("rgba(") ? tr.slice(5, -1).split(",").map((ir) => parseInt(ir)).slice(0, 3) : ((0, _e.warn)(`Not a valid color format: "${tr}"`), [0, 0, 0]);
          }
          function Bt(tr) {
            const ir = document.createElement("span");
            ir.style.visibility = "hidden", document.body.append(ir);
            for (const sr of tr.keys()) {
              ir.style.color = sr;
              const cr = window.getComputedStyle(ir).color;
              tr.set(sr, St(cr));
            }
            ir.remove();
          }
          function Ot(tr) {
            const {
              a: ir,
              b: sr,
              c: cr,
              d: or,
              e: Xt,
              f: Gt
            } = tr.getTransform();
            return [ir, sr, cr, or, Xt, Gt];
          }
          function Pt(tr) {
            const {
              a: ir,
              b: sr,
              c: cr,
              d: or,
              e: Xt,
              f: Gt
            } = tr.getTransform().invertSelf();
            return [ir, sr, cr, or, Xt, Gt];
          }
          function wt(tr, ir) {
            let sr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, cr = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
            if (ir instanceof it) {
              const {
                pageWidth: or,
                pageHeight: Xt
              } = ir.rawDims, {
                style: Gt
              } = tr, Wt = _e.FeatureTest.isCSSRoundSupported, er = `var(--scale-factor) * ${or}px`, lr = `var(--scale-factor) * ${Xt}px`, ur = Wt ? `round(${er}, 1px)` : `calc(${er})`, pr = Wt ? `round(${lr}, 1px)` : `calc(${lr})`;
              !sr || ir.rotation % 180 === 0 ? (Gt.width = ur, Gt.height = pr) : (Gt.width = pr, Gt.height = ur);
            }
            cr && tr.setAttribute("data-main-rotation", ir.rotation);
          }
        },
        /* 169 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.BaseStandardFontDataFactory = s.BaseSVGFactory = s.BaseFilterFactory = s.BaseCanvasFactory = s.BaseCMapReaderFactory = void 0, $(2);
          var _ = $(1);
          class _e {
            constructor() {
              this.constructor === _e && (0, _.unreachable)("Cannot initialize BaseFilterFactory.");
            }
            addFilter(st) {
              return "none";
            }
            addHCMFilter(st, lt) {
              return "none";
            }
            addHighlightHCMFilter(st, lt, et, it) {
              return "none";
            }
            destroy() {
            }
          }
          s.BaseFilterFactory = _e;
          class tt {
            constructor() {
              this.constructor === tt && (0, _.unreachable)("Cannot initialize BaseCanvasFactory.");
            }
            create(st, lt) {
              if (st <= 0 || lt <= 0)
                throw new Error("Invalid canvas size");
              const et = this._createCanvas(st, lt);
              return {
                canvas: et,
                context: et.getContext("2d")
              };
            }
            reset(st, lt, et) {
              if (!st.canvas)
                throw new Error("Canvas is not specified");
              if (lt <= 0 || et <= 0)
                throw new Error("Invalid canvas size");
              st.canvas.width = lt, st.canvas.height = et;
            }
            destroy(st) {
              if (!st.canvas)
                throw new Error("Canvas is not specified");
              st.canvas.width = 0, st.canvas.height = 0, st.canvas = null, st.context = null;
            }
            _createCanvas(st, lt) {
              (0, _.unreachable)("Abstract method `_createCanvas` called.");
            }
          }
          s.BaseCanvasFactory = tt;
          class nt {
            constructor(st) {
              let {
                baseUrl: lt = null,
                isCompressed: et = !0
              } = st;
              this.constructor === nt && (0, _.unreachable)("Cannot initialize BaseCMapReaderFactory."), this.baseUrl = lt, this.isCompressed = et;
            }
            async fetch(st) {
              let {
                name: lt
              } = st;
              if (!this.baseUrl)
                throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
              if (!lt)
                throw new Error("CMap name must be specified.");
              const et = this.baseUrl + lt + (this.isCompressed ? ".bcmap" : ""), it = this.isCompressed ? _.CMapCompressionType.BINARY : _.CMapCompressionType.NONE;
              return this._fetchData(et, it).catch((ut) => {
                throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${et}`);
              });
            }
            _fetchData(st, lt) {
              (0, _.unreachable)("Abstract method `_fetchData` called.");
            }
          }
          s.BaseCMapReaderFactory = nt;
          class at {
            constructor(st) {
              let {
                baseUrl: lt = null
              } = st;
              this.constructor === at && (0, _.unreachable)("Cannot initialize BaseStandardFontDataFactory."), this.baseUrl = lt;
            }
            async fetch(st) {
              let {
                filename: lt
              } = st;
              if (!this.baseUrl)
                throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
              if (!lt)
                throw new Error("Font filename must be specified.");
              const et = `${this.baseUrl}${lt}`;
              return this._fetchData(et).catch((it) => {
                throw new Error(`Unable to load font data at: ${et}`);
              });
            }
            _fetchData(st) {
              (0, _.unreachable)("Abstract method `_fetchData` called.");
            }
          }
          s.BaseStandardFontDataFactory = at;
          class ot {
            constructor() {
              this.constructor === ot && (0, _.unreachable)("Cannot initialize BaseSVGFactory.");
            }
            create(st, lt) {
              let et = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
              if (st <= 0 || lt <= 0)
                throw new Error("Invalid SVG dimensions");
              const it = this._createSVG("svg:svg");
              return it.setAttribute("version", "1.1"), et || (it.setAttribute("width", `${st}px`), it.setAttribute("height", `${lt}px`)), it.setAttribute("preserveAspectRatio", "none"), it.setAttribute("viewBox", `0 0 ${st} ${lt}`), it;
            }
            createElement(st) {
              if (typeof st != "string")
                throw new Error("Invalid SVG element type");
              return this._createSVG(st);
            }
            _createSVG(st) {
              (0, _.unreachable)("Abstract method `_createSVG` called.");
            }
          }
          s.BaseSVGFactory = ot;
        },
        /* 170 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.MurmurHash3_64 = void 0, $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123), $(2);
          var _ = $(1);
          const _e = 3285377520, tt = 4294901760, nt = 65535;
          class at {
            constructor(rt) {
              this.h1 = rt ? rt & 4294967295 : _e, this.h2 = rt ? rt & 4294967295 : _e;
            }
            update(rt) {
              let st, lt;
              if (typeof rt == "string") {
                st = new Uint8Array(rt.length * 2), lt = 0;
                for (let At = 0, xt = rt.length; At < xt; At++) {
                  const bt = rt.charCodeAt(At);
                  bt <= 255 ? st[lt++] = bt : (st[lt++] = bt >>> 8, st[lt++] = bt & 255);
                }
              } else if ((0, _.isArrayBuffer)(rt))
                st = rt.slice(), lt = st.byteLength;
              else
                throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
              const et = lt >> 2, it = lt - et * 4, ut = new Uint32Array(st.buffer, 0, et);
              let ft = 0, ht = 0, dt = this.h1, gt = this.h2;
              const pt = 3432918353, mt = 461845907, ct = pt & nt, vt = mt & nt;
              for (let At = 0; At < et; At++)
                At & 1 ? (ft = ut[At], ft = ft * pt & tt | ft * ct & nt, ft = ft << 15 | ft >>> 17, ft = ft * mt & tt | ft * vt & nt, dt ^= ft, dt = dt << 13 | dt >>> 19, dt = dt * 5 + 3864292196) : (ht = ut[At], ht = ht * pt & tt | ht * ct & nt, ht = ht << 15 | ht >>> 17, ht = ht * mt & tt | ht * vt & nt, gt ^= ht, gt = gt << 13 | gt >>> 19, gt = gt * 5 + 3864292196);
              switch (ft = 0, it) {
                case 3:
                  ft ^= st[et * 4 + 2] << 16;
                case 2:
                  ft ^= st[et * 4 + 1] << 8;
                case 1:
                  ft ^= st[et * 4], ft = ft * pt & tt | ft * ct & nt, ft = ft << 15 | ft >>> 17, ft = ft * mt & tt | ft * vt & nt, et & 1 ? dt ^= ft : gt ^= ft;
              }
              this.h1 = dt, this.h2 = gt;
            }
            hexdigest() {
              let rt = this.h1, st = this.h2;
              return rt ^= st >>> 1, rt = rt * 3981806797 & tt | rt * 36045 & nt, st = st * 4283543511 & tt | ((st << 16 | rt >>> 16) * 2950163797 & tt) >>> 16, rt ^= st >>> 1, rt = rt * 444984403 & tt | rt * 60499 & nt, st = st * 3301882366 & tt | ((st << 16 | rt >>> 16) * 3120437893 & tt) >>> 16, rt ^= st >>> 1, (rt >>> 0).toString(16).padStart(8, "0") + (st >>> 0).toString(16).padStart(8, "0");
            }
          }
          s.MurmurHash3_64 = at;
        },
        /* 171 */
        /***/
        (a, s, $) => {
          var nt;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.FontLoader = s.FontFaceObject = void 0, $(125), $(136), $(138), $(141), $(143), $(145), $(147), $(89), $(149);
          var _ = $(1);
          class _e {
            constructor(ot) {
              _r(this, nt, /* @__PURE__ */ new Set());
              let {
                ownerDocument: rt = globalThis.document,
                styleElement: st = null
              } = ot;
              this._document = rt, this.nativeFontFaces = /* @__PURE__ */ new Set(), this.styleElement = null, this.loadingRequests = [], this.loadTestFontId = 0;
            }
            addNativeFontFace(ot) {
              this.nativeFontFaces.add(ot), this._document.fonts.add(ot);
            }
            removeNativeFontFace(ot) {
              this.nativeFontFaces.delete(ot), this._document.fonts.delete(ot);
            }
            insertRule(ot) {
              this.styleElement || (this.styleElement = this._document.createElement("style"), this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement));
              const rt = this.styleElement.sheet;
              rt.insertRule(ot, rt.cssRules.length);
            }
            clear() {
              for (const ot of this.nativeFontFaces)
                this._document.fonts.delete(ot);
              this.nativeFontFaces.clear(), mr(this, nt).clear(), this.styleElement && (this.styleElement.remove(), this.styleElement = null);
            }
            async loadSystemFont(ot) {
              if (!(!ot || mr(this, nt).has(ot.loadedName))) {
                if ((0, _.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set."), this.isFontLoadingAPISupported) {
                  const {
                    loadedName: rt,
                    src: st,
                    style: lt
                  } = ot, et = new FontFace(rt, st, lt);
                  this.addNativeFontFace(et);
                  try {
                    await et.load(), mr(this, nt).add(rt);
                  } catch {
                    (0, _.warn)(`Cannot load system font: ${ot.baseFontName}, installing it could help to improve PDF rendering.`), this.removeNativeFontFace(et);
                  }
                  return;
                }
                (0, _.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
              }
            }
            async bind(ot) {
              if (ot.attached || ot.missingFile && !ot.systemFontInfo)
                return;
              if (ot.attached = !0, ot.systemFontInfo) {
                await this.loadSystemFont(ot.systemFontInfo);
                return;
              }
              if (this.isFontLoadingAPISupported) {
                const st = ot.createNativeFontFace();
                if (st) {
                  this.addNativeFontFace(st);
                  try {
                    await st.loaded;
                  } catch (lt) {
                    throw (0, _.warn)(`Failed to load font '${st.family}': '${lt}'.`), ot.disableFontFace = !0, lt;
                  }
                }
                return;
              }
              const rt = ot.createFontFaceRule();
              if (rt) {
                if (this.insertRule(rt), this.isSyncFontLoadingSupported)
                  return;
                await new Promise((st) => {
                  const lt = this._queueLoadingCallback(st);
                  this._prepareFontLoadEvent(ot, lt);
                });
              }
            }
            get isFontLoadingAPISupported() {
              var rt;
              const ot = !!((rt = this._document) != null && rt.fonts);
              return (0, _.shadow)(this, "isFontLoadingAPISupported", ot);
            }
            get isSyncFontLoadingSupported() {
              let ot = !1;
              return (_.isNodeJS || typeof navigator < "u" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) && (ot = !0), (0, _.shadow)(this, "isSyncFontLoadingSupported", ot);
            }
            _queueLoadingCallback(ot) {
              function rt() {
                for ((0, _.assert)(!lt.done, "completeRequest() cannot be called twice."), lt.done = !0; st.length > 0 && st[0].done; ) {
                  const et = st.shift();
                  setTimeout(et.callback, 0);
                }
              }
              const {
                loadingRequests: st
              } = this, lt = {
                done: !1,
                complete: rt,
                callback: ot
              };
              return st.push(lt), lt;
            }
            get _loadTestFont() {
              const ot = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
              return (0, _.shadow)(this, "_loadTestFont", ot);
            }
            _prepareFontLoadEvent(ot, rt) {
              function st(St, Bt) {
                return St.charCodeAt(Bt) << 24 | St.charCodeAt(Bt + 1) << 16 | St.charCodeAt(Bt + 2) << 8 | St.charCodeAt(Bt + 3) & 255;
              }
              function lt(St, Bt, Ot, Pt) {
                const wt = St.substring(0, Bt), Ct = St.substring(Bt + Ot);
                return wt + Pt + Ct;
              }
              let et, it;
              const ut = this._document.createElement("canvas");
              ut.width = 1, ut.height = 1;
              const ft = ut.getContext("2d");
              let ht = 0;
              function dt(St, Bt) {
                if (++ht > 30) {
                  (0, _.warn)("Load test font never loaded."), Bt();
                  return;
                }
                if (ft.font = "30px " + St, ft.fillText(".", 0, 20), ft.getImageData(0, 0, 1, 1).data[3] > 0) {
                  Bt();
                  return;
                }
                setTimeout(dt.bind(null, St, Bt));
              }
              const gt = `lt${Date.now()}${this.loadTestFontId++}`;
              let pt = this._loadTestFont;
              pt = lt(pt, 976, gt.length, gt);
              const ct = 16, vt = 1482184792;
              let At = st(pt, ct);
              for (et = 0, it = gt.length - 3; et < it; et += 4)
                At = At - vt + st(gt, et) | 0;
              et < gt.length && (At = At - vt + st(gt + "XXX", et) | 0), pt = lt(pt, ct, 4, (0, _.string32)(At));
              const xt = `url(data:font/opentype;base64,${btoa(pt)});`, bt = `@font-face {font-family:"${gt}";src:${xt}}`;
              this.insertRule(bt);
              const Et = this._document.createElement("div");
              Et.style.visibility = "hidden", Et.style.width = Et.style.height = "10px", Et.style.position = "absolute", Et.style.top = Et.style.left = "0px";
              for (const St of [ot.loadedName, gt]) {
                const Bt = this._document.createElement("span");
                Bt.textContent = "Hi", Bt.style.fontFamily = St, Et.append(Bt);
              }
              this._document.body.append(Et), dt(gt, () => {
                Et.remove(), rt.complete();
              });
            }
          }
          nt = new WeakMap(), s.FontLoader = _e;
          class tt {
            constructor(ot, rt) {
              let {
                isEvalSupported: st = !0,
                disableFontFace: lt = !1,
                ignoreErrors: et = !1,
                inspectFont: it = null
              } = rt;
              this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
              for (const ut in ot)
                this[ut] = ot[ut];
              this.isEvalSupported = st !== !1, this.disableFontFace = lt === !0, this.ignoreErrors = et === !0, this._inspectFont = it;
            }
            createNativeFontFace() {
              var rt;
              if (!this.data || this.disableFontFace)
                return null;
              let ot;
              if (!this.cssFontInfo)
                ot = new FontFace(this.loadedName, this.data, {});
              else {
                const st = {
                  weight: this.cssFontInfo.fontWeight
                };
                this.cssFontInfo.italicAngle && (st.style = `oblique ${this.cssFontInfo.italicAngle}deg`), ot = new FontFace(this.cssFontInfo.fontFamily, this.data, st);
              }
              return (rt = this._inspectFont) == null || rt.call(this, this), ot;
            }
            createFontFaceRule() {
              var lt;
              if (!this.data || this.disableFontFace)
                return null;
              const ot = (0, _.bytesToString)(this.data), rt = `url(data:${this.mimetype};base64,${btoa(ot)});`;
              let st;
              if (!this.cssFontInfo)
                st = `@font-face {font-family:"${this.loadedName}";src:${rt}}`;
              else {
                let et = `font-weight: ${this.cssFontInfo.fontWeight};`;
                this.cssFontInfo.italicAngle && (et += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), st = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${et}src:${rt}}`;
              }
              return (lt = this._inspectFont) == null || lt.call(this, this, rt), st;
            }
            getPathGenerator(ot, rt) {
              if (this.compiledGlyphs[rt] !== void 0)
                return this.compiledGlyphs[rt];
              let st;
              try {
                st = ot.get(this.loadedName + "_path_" + rt);
              } catch (lt) {
                if (!this.ignoreErrors)
                  throw lt;
                return (0, _.warn)(`getPathGenerator - ignoring character: "${lt}".`), this.compiledGlyphs[rt] = function(et, it) {
                };
              }
              if (this.isEvalSupported && _.FeatureTest.isEvalSupported) {
                const lt = [];
                for (const et of st) {
                  const it = et.args !== void 0 ? et.args.join(",") : "";
                  lt.push("c.", et.cmd, "(", it, `);
`);
                }
                return this.compiledGlyphs[rt] = new Function("c", "size", lt.join(""));
              }
              return this.compiledGlyphs[rt] = function(lt, et) {
                for (const it of st)
                  it.cmd === "scale" && (it.args = [et, -et]), lt[it.cmd].apply(lt, it.args);
              };
            }
          }
          s.FontFaceObject = tt;
        },
        /* 172 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.NodeStandardFontDataFactory = s.NodeFilterFactory = s.NodeCanvasFactory = s.NodeCMapReaderFactory = void 0, $(2), $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123);
          var _ = $(169), _e = $(1);
          (function() {
            if (!(globalThis.DOMMatrix || !_e.isNodeJS))
              try {
                globalThis.DOMMatrix = require$$6.DOMMatrix;
              } catch (lt) {
                (0, _e.warn)(`Cannot polyfill \`DOMMatrix\`, rendering may be broken: "${lt}".`);
              }
          })(), function() {
            if (!(globalThis.Path2D || !_e.isNodeJS))
              try {
                const {
                  CanvasRenderingContext2D: lt
                } = require$$6, {
                  polyfillPath2D: et
                } = requirePath2dPolyfill_esm();
                globalThis.CanvasRenderingContext2D = lt, et(globalThis);
              } catch (lt) {
                (0, _e.warn)(`Cannot polyfill \`Path2D\`, rendering may be broken: "${lt}".`);
              }
          }();
          const tt = function(st) {
            return new Promise((lt, et) => {
              require$$6.readFile(st, (ut, ft) => {
                if (ut || !ft) {
                  et(new Error(ut));
                  return;
                }
                lt(new Uint8Array(ft));
              });
            });
          };
          class nt extends _.BaseFilterFactory {
          }
          s.NodeFilterFactory = nt;
          class at extends _.BaseCanvasFactory {
            _createCanvas(lt, et) {
              return require$$6.createCanvas(lt, et);
            }
          }
          s.NodeCanvasFactory = at;
          class ot extends _.BaseCMapReaderFactory {
            _fetchData(lt, et) {
              return tt(lt).then((it) => ({
                cMapData: it,
                compressionType: et
              }));
            }
          }
          s.NodeCMapReaderFactory = ot;
          class rt extends _.BaseStandardFontDataFactory {
            _fetchData(lt) {
              return tt(lt);
            }
          }
          s.NodeStandardFontDataFactory = rt;
        },
        /* 173 */
        /***/
        (a, s, $) => {
          var yt, Gs, kt, Vs;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.CanvasGraphics = void 0, $(2), $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123), $(89);
          var _ = $(1), _e = $(168), tt = $(174), nt = $(175);
          const at = 16, ot = 100, rt = 4096, st = 15, lt = 10, et = 1e3, it = 16;
          function ut(Ft, _t) {
            if (Ft._removeMirroring)
              throw new Error("Context is already forwarding operations.");
            Ft.__originalSave = Ft.save, Ft.__originalRestore = Ft.restore, Ft.__originalRotate = Ft.rotate, Ft.__originalScale = Ft.scale, Ft.__originalTranslate = Ft.translate, Ft.__originalTransform = Ft.transform, Ft.__originalSetTransform = Ft.setTransform, Ft.__originalResetTransform = Ft.resetTransform, Ft.__originalClip = Ft.clip, Ft.__originalMoveTo = Ft.moveTo, Ft.__originalLineTo = Ft.lineTo, Ft.__originalBezierCurveTo = Ft.bezierCurveTo, Ft.__originalRect = Ft.rect, Ft.__originalClosePath = Ft.closePath, Ft.__originalBeginPath = Ft.beginPath, Ft._removeMirroring = () => {
              Ft.save = Ft.__originalSave, Ft.restore = Ft.__originalRestore, Ft.rotate = Ft.__originalRotate, Ft.scale = Ft.__originalScale, Ft.translate = Ft.__originalTranslate, Ft.transform = Ft.__originalTransform, Ft.setTransform = Ft.__originalSetTransform, Ft.resetTransform = Ft.__originalResetTransform, Ft.clip = Ft.__originalClip, Ft.moveTo = Ft.__originalMoveTo, Ft.lineTo = Ft.__originalLineTo, Ft.bezierCurveTo = Ft.__originalBezierCurveTo, Ft.rect = Ft.__originalRect, Ft.closePath = Ft.__originalClosePath, Ft.beginPath = Ft.__originalBeginPath, delete Ft._removeMirroring;
            }, Ft.save = function() {
              _t.save(), this.__originalSave();
            }, Ft.restore = function() {
              _t.restore(), this.__originalRestore();
            }, Ft.translate = function(Mt, Lt) {
              _t.translate(Mt, Lt), this.__originalTranslate(Mt, Lt);
            }, Ft.scale = function(Mt, Lt) {
              _t.scale(Mt, Lt), this.__originalScale(Mt, Lt);
            }, Ft.transform = function(Mt, Lt, $t, Tt, Dt, Ut) {
              _t.transform(Mt, Lt, $t, Tt, Dt, Ut), this.__originalTransform(Mt, Lt, $t, Tt, Dt, Ut);
            }, Ft.setTransform = function(Mt, Lt, $t, Tt, Dt, Ut) {
              _t.setTransform(Mt, Lt, $t, Tt, Dt, Ut), this.__originalSetTransform(Mt, Lt, $t, Tt, Dt, Ut);
            }, Ft.resetTransform = function() {
              _t.resetTransform(), this.__originalResetTransform();
            }, Ft.rotate = function(Mt) {
              _t.rotate(Mt), this.__originalRotate(Mt);
            }, Ft.clip = function(Mt) {
              _t.clip(Mt), this.__originalClip(Mt);
            }, Ft.moveTo = function(Nt, Mt) {
              _t.moveTo(Nt, Mt), this.__originalMoveTo(Nt, Mt);
            }, Ft.lineTo = function(Nt, Mt) {
              _t.lineTo(Nt, Mt), this.__originalLineTo(Nt, Mt);
            }, Ft.bezierCurveTo = function(Nt, Mt, Lt, $t, Tt, Dt) {
              _t.bezierCurveTo(Nt, Mt, Lt, $t, Tt, Dt), this.__originalBezierCurveTo(Nt, Mt, Lt, $t, Tt, Dt);
            }, Ft.rect = function(Nt, Mt, Lt, $t) {
              _t.rect(Nt, Mt, Lt, $t), this.__originalRect(Nt, Mt, Lt, $t);
            }, Ft.closePath = function() {
              _t.closePath(), this.__originalClosePath();
            }, Ft.beginPath = function() {
              _t.beginPath(), this.__originalBeginPath();
            };
          }
          class ft {
            constructor(_t) {
              this.canvasFactory = _t, this.cache = /* @__PURE__ */ Object.create(null);
            }
            getCanvas(_t, Nt, Mt) {
              let Lt;
              return this.cache[_t] !== void 0 ? (Lt = this.cache[_t], this.canvasFactory.reset(Lt, Nt, Mt)) : (Lt = this.canvasFactory.create(Nt, Mt), this.cache[_t] = Lt), Lt;
            }
            delete(_t) {
              delete this.cache[_t];
            }
            clear() {
              for (const _t in this.cache) {
                const Nt = this.cache[_t];
                this.canvasFactory.destroy(Nt), delete this.cache[_t];
              }
            }
          }
          function ht(Ft, _t, Nt, Mt, Lt, $t, Tt, Dt, Ut, Vt) {
            const [Qt, qt, Zt, ar, Jt, rr] = (0, _e.getCurrentTransform)(Ft);
            if (qt === 0 && Zt === 0) {
              const nr = Tt * Qt + Jt, tr = Math.round(nr), ir = Dt * ar + rr, sr = Math.round(ir), cr = (Tt + Ut) * Qt + Jt, or = Math.abs(Math.round(cr) - tr) || 1, Xt = (Dt + Vt) * ar + rr, Gt = Math.abs(Math.round(Xt) - sr) || 1;
              return Ft.setTransform(Math.sign(Qt), 0, 0, Math.sign(ar), tr, sr), Ft.drawImage(_t, Nt, Mt, Lt, $t, 0, 0, or, Gt), Ft.setTransform(Qt, qt, Zt, ar, Jt, rr), [or, Gt];
            }
            if (Qt === 0 && ar === 0) {
              const nr = Dt * Zt + Jt, tr = Math.round(nr), ir = Tt * qt + rr, sr = Math.round(ir), cr = (Dt + Vt) * Zt + Jt, or = Math.abs(Math.round(cr) - tr) || 1, Xt = (Tt + Ut) * qt + rr, Gt = Math.abs(Math.round(Xt) - sr) || 1;
              return Ft.setTransform(0, Math.sign(qt), Math.sign(Zt), 0, tr, sr), Ft.drawImage(_t, Nt, Mt, Lt, $t, 0, 0, Gt, or), Ft.setTransform(Qt, qt, Zt, ar, Jt, rr), [Gt, or];
            }
            Ft.drawImage(_t, Nt, Mt, Lt, $t, Tt, Dt, Ut, Vt);
            const Yt = Math.hypot(Qt, qt), Kt = Math.hypot(Zt, ar);
            return [Yt * Ut, Kt * Vt];
          }
          function dt(Ft) {
            const {
              width: _t,
              height: Nt
            } = Ft;
            if (_t > et || Nt > et)
              return null;
            const Mt = 1e3, Lt = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]), $t = _t + 1;
            let Tt = new Uint8Array($t * (Nt + 1)), Dt, Ut, Vt;
            const Qt = _t + 7 & -8;
            let qt = new Uint8Array(Qt * Nt), Zt = 0;
            for (const Kt of Ft.data) {
              let nr = 128;
              for (; nr > 0; )
                qt[Zt++] = Kt & nr ? 0 : 255, nr >>= 1;
            }
            let ar = 0;
            for (Zt = 0, qt[Zt] !== 0 && (Tt[0] = 1, ++ar), Ut = 1; Ut < _t; Ut++)
              qt[Zt] !== qt[Zt + 1] && (Tt[Ut] = qt[Zt] ? 2 : 1, ++ar), Zt++;
            for (qt[Zt] !== 0 && (Tt[Ut] = 2, ++ar), Dt = 1; Dt < Nt; Dt++) {
              Zt = Dt * Qt, Vt = Dt * $t, qt[Zt - Qt] !== qt[Zt] && (Tt[Vt] = qt[Zt] ? 1 : 8, ++ar);
              let Kt = (qt[Zt] ? 4 : 0) + (qt[Zt - Qt] ? 8 : 0);
              for (Ut = 1; Ut < _t; Ut++)
                Kt = (Kt >> 2) + (qt[Zt + 1] ? 4 : 0) + (qt[Zt - Qt + 1] ? 8 : 0), Lt[Kt] && (Tt[Vt + Ut] = Lt[Kt], ++ar), Zt++;
              if (qt[Zt - Qt] !== qt[Zt] && (Tt[Vt + Ut] = qt[Zt] ? 2 : 4, ++ar), ar > Mt)
                return null;
            }
            for (Zt = Qt * (Nt - 1), Vt = Dt * $t, qt[Zt] !== 0 && (Tt[Vt] = 8, ++ar), Ut = 1; Ut < _t; Ut++)
              qt[Zt] !== qt[Zt + 1] && (Tt[Vt + Ut] = qt[Zt] ? 4 : 8, ++ar), Zt++;
            if (qt[Zt] !== 0 && (Tt[Vt + Ut] = 4, ++ar), ar > Mt)
              return null;
            const Jt = new Int32Array([0, $t, -1, 0, -$t, 0, 0, 0, 1]), rr = new Path2D();
            for (Dt = 0; ar && Dt <= Nt; Dt++) {
              let Kt = Dt * $t;
              const nr = Kt + _t;
              for (; Kt < nr && !Tt[Kt]; )
                Kt++;
              if (Kt === nr)
                continue;
              rr.moveTo(Kt % $t, Dt);
              const tr = Kt;
              let ir = Tt[Kt];
              do {
                const sr = Jt[ir];
                do
                  Kt += sr;
                while (!Tt[Kt]);
                const cr = Tt[Kt];
                cr !== 5 && cr !== 10 ? (ir = cr, Tt[Kt] = 0) : (ir = cr & 51 * ir >> 4, Tt[Kt] &= ir >> 2 | ir << 2), rr.lineTo(Kt % $t, Kt / $t | 0), Tt[Kt] || --ar;
              } while (tr !== Kt);
              --Dt;
            }
            return qt = null, Tt = null, function(Kt) {
              Kt.save(), Kt.scale(1 / _t, -1 / Nt), Kt.translate(0, -Nt), Kt.fill(rr), Kt.beginPath(), Kt.restore();
            };
          }
          class gt {
            constructor(_t, Nt) {
              this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = _.IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = _.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = _.TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.transferMaps = "none", this.startNewPathAndClipBox([0, 0, _t, Nt]);
            }
            clone() {
              const _t = Object.create(this);
              return _t.clipBox = this.clipBox.slice(), _t;
            }
            setCurrentPoint(_t, Nt) {
              this.x = _t, this.y = Nt;
            }
            updatePathMinMax(_t, Nt, Mt) {
              [Nt, Mt] = _.Util.applyTransform([Nt, Mt], _t), this.minX = Math.min(this.minX, Nt), this.minY = Math.min(this.minY, Mt), this.maxX = Math.max(this.maxX, Nt), this.maxY = Math.max(this.maxY, Mt);
            }
            updateRectMinMax(_t, Nt) {
              const Mt = _.Util.applyTransform(Nt, _t), Lt = _.Util.applyTransform(Nt.slice(2), _t);
              this.minX = Math.min(this.minX, Mt[0], Lt[0]), this.minY = Math.min(this.minY, Mt[1], Lt[1]), this.maxX = Math.max(this.maxX, Mt[0], Lt[0]), this.maxY = Math.max(this.maxY, Mt[1], Lt[1]);
            }
            updateScalingPathMinMax(_t, Nt) {
              _.Util.scaleMinMax(_t, Nt), this.minX = Math.min(this.minX, Nt[0]), this.maxX = Math.max(this.maxX, Nt[1]), this.minY = Math.min(this.minY, Nt[2]), this.maxY = Math.max(this.maxY, Nt[3]);
            }
            updateCurvePathMinMax(_t, Nt, Mt, Lt, $t, Tt, Dt, Ut, Vt, Qt) {
              const qt = _.Util.bezierBoundingBox(Nt, Mt, Lt, $t, Tt, Dt, Ut, Vt);
              if (Qt) {
                Qt[0] = Math.min(Qt[0], qt[0], qt[2]), Qt[1] = Math.max(Qt[1], qt[0], qt[2]), Qt[2] = Math.min(Qt[2], qt[1], qt[3]), Qt[3] = Math.max(Qt[3], qt[1], qt[3]);
                return;
              }
              this.updateRectMinMax(_t, qt);
            }
            getPathBoundingBox() {
              let _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : tt.PathType.FILL, Nt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              const Mt = [this.minX, this.minY, this.maxX, this.maxY];
              if (_t === tt.PathType.STROKE) {
                Nt || (0, _.unreachable)("Stroke bounding box must include transform.");
                const Lt = _.Util.singularValueDecompose2dScale(Nt), $t = Lt[0] * this.lineWidth / 2, Tt = Lt[1] * this.lineWidth / 2;
                Mt[0] -= $t, Mt[1] -= Tt, Mt[2] += $t, Mt[3] += Tt;
              }
              return Mt;
            }
            updateClipFromPath() {
              const _t = _.Util.intersect(this.clipBox, this.getPathBoundingBox());
              this.startNewPathAndClipBox(_t || [0, 0, 0, 0]);
            }
            isEmptyClip() {
              return this.minX === 1 / 0;
            }
            startNewPathAndClipBox(_t) {
              this.clipBox = _t, this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = 0, this.maxY = 0;
            }
            getClippedPathBoundingBox() {
              let _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : tt.PathType.FILL, Nt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return _.Util.intersect(this.clipBox, this.getPathBoundingBox(_t, Nt));
            }
          }
          function pt(Ft, _t) {
            if (typeof ImageData < "u" && _t instanceof ImageData) {
              Ft.putImageData(_t, 0, 0);
              return;
            }
            const Nt = _t.height, Mt = _t.width, Lt = Nt % it, $t = (Nt - Lt) / it, Tt = Lt === 0 ? $t : $t + 1, Dt = Ft.createImageData(Mt, it);
            let Ut = 0, Vt;
            const Qt = _t.data, qt = Dt.data;
            let Zt, ar, Jt, rr;
            if (_t.kind === _.ImageKind.GRAYSCALE_1BPP) {
              const Yt = Qt.byteLength, Kt = new Uint32Array(qt.buffer, 0, qt.byteLength >> 2), nr = Kt.length, tr = Mt + 7 >> 3, ir = 4294967295, sr = _.FeatureTest.isLittleEndian ? 4278190080 : 255;
              for (Zt = 0; Zt < Tt; Zt++) {
                for (Jt = Zt < $t ? it : Lt, Vt = 0, ar = 0; ar < Jt; ar++) {
                  const cr = Yt - Ut;
                  let or = 0;
                  const Xt = cr > tr ? Mt : cr * 8 - 7, Gt = Xt & -8;
                  let Wt = 0, er = 0;
                  for (; or < Gt; or += 8)
                    er = Qt[Ut++], Kt[Vt++] = er & 128 ? ir : sr, Kt[Vt++] = er & 64 ? ir : sr, Kt[Vt++] = er & 32 ? ir : sr, Kt[Vt++] = er & 16 ? ir : sr, Kt[Vt++] = er & 8 ? ir : sr, Kt[Vt++] = er & 4 ? ir : sr, Kt[Vt++] = er & 2 ? ir : sr, Kt[Vt++] = er & 1 ? ir : sr;
                  for (; or < Xt; or++)
                    Wt === 0 && (er = Qt[Ut++], Wt = 128), Kt[Vt++] = er & Wt ? ir : sr, Wt >>= 1;
                }
                for (; Vt < nr; )
                  Kt[Vt++] = 0;
                Ft.putImageData(Dt, 0, Zt * it);
              }
            } else if (_t.kind === _.ImageKind.RGBA_32BPP) {
              for (ar = 0, rr = Mt * it * 4, Zt = 0; Zt < $t; Zt++)
                qt.set(Qt.subarray(Ut, Ut + rr)), Ut += rr, Ft.putImageData(Dt, 0, ar), ar += it;
              Zt < Tt && (rr = Mt * Lt * 4, qt.set(Qt.subarray(Ut, Ut + rr)), Ft.putImageData(Dt, 0, ar));
            } else if (_t.kind === _.ImageKind.RGB_24BPP)
              for (Jt = it, rr = Mt * Jt, Zt = 0; Zt < Tt; Zt++) {
                for (Zt >= $t && (Jt = Lt, rr = Mt * Jt), Vt = 0, ar = rr; ar--; )
                  qt[Vt++] = Qt[Ut++], qt[Vt++] = Qt[Ut++], qt[Vt++] = Qt[Ut++], qt[Vt++] = 255;
                Ft.putImageData(Dt, 0, Zt * it);
              }
            else
              throw new Error(`bad image kind: ${_t.kind}`);
          }
          function mt(Ft, _t) {
            if (_t.bitmap) {
              Ft.drawImage(_t.bitmap, 0, 0);
              return;
            }
            const Nt = _t.height, Mt = _t.width, Lt = Nt % it, $t = (Nt - Lt) / it, Tt = Lt === 0 ? $t : $t + 1, Dt = Ft.createImageData(Mt, it);
            let Ut = 0;
            const Vt = _t.data, Qt = Dt.data;
            for (let qt = 0; qt < Tt; qt++) {
              const Zt = qt < $t ? it : Lt;
              ({
                srcPos: Ut
              } = (0, nt.convertBlackAndWhiteToRGBA)({
                src: Vt,
                srcPos: Ut,
                dest: Qt,
                width: Mt,
                height: Zt,
                nonBlackColor: 0
              })), Ft.putImageData(Dt, 0, qt * it);
            }
          }
          function ct(Ft, _t) {
            const Nt = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
            for (const Mt of Nt)
              Ft[Mt] !== void 0 && (_t[Mt] = Ft[Mt]);
            Ft.setLineDash !== void 0 && (_t.setLineDash(Ft.getLineDash()), _t.lineDashOffset = Ft.lineDashOffset);
          }
          function vt(Ft) {
            if (Ft.strokeStyle = Ft.fillStyle = "#000000", Ft.fillRule = "nonzero", Ft.globalAlpha = 1, Ft.lineWidth = 1, Ft.lineCap = "butt", Ft.lineJoin = "miter", Ft.miterLimit = 10, Ft.globalCompositeOperation = "source-over", Ft.font = "10px sans-serif", Ft.setLineDash !== void 0 && (Ft.setLineDash([]), Ft.lineDashOffset = 0), !_.isNodeJS) {
              const {
                filter: _t
              } = Ft;
              _t !== "none" && _t !== "" && (Ft.filter = "none");
            }
          }
          function At(Ft, _t, Nt, Mt) {
            const Lt = Ft.length;
            for (let $t = 3; $t < Lt; $t += 4) {
              const Tt = Ft[$t];
              if (Tt === 0)
                Ft[$t - 3] = _t, Ft[$t - 2] = Nt, Ft[$t - 1] = Mt;
              else if (Tt < 255) {
                const Dt = 255 - Tt;
                Ft[$t - 3] = Ft[$t - 3] * Tt + _t * Dt >> 8, Ft[$t - 2] = Ft[$t - 2] * Tt + Nt * Dt >> 8, Ft[$t - 1] = Ft[$t - 1] * Tt + Mt * Dt >> 8;
              }
            }
          }
          function xt(Ft, _t, Nt) {
            const Mt = Ft.length, Lt = 1 / 255;
            for (let $t = 3; $t < Mt; $t += 4) {
              const Tt = Nt ? Nt[Ft[$t]] : Ft[$t];
              _t[$t] = _t[$t] * Tt * Lt | 0;
            }
          }
          function bt(Ft, _t, Nt) {
            const Mt = Ft.length;
            for (let Lt = 3; Lt < Mt; Lt += 4) {
              const $t = Ft[Lt - 3] * 77 + Ft[Lt - 2] * 152 + Ft[Lt - 1] * 28;
              _t[Lt] = Nt ? _t[Lt] * Nt[$t >> 8] >> 8 : _t[Lt] * $t >> 16;
            }
          }
          function Et(Ft, _t, Nt, Mt, Lt, $t, Tt, Dt, Ut, Vt, Qt) {
            const qt = !!$t, Zt = qt ? $t[0] : 0, ar = qt ? $t[1] : 0, Jt = qt ? $t[2] : 0, rr = Lt === "Luminosity" ? bt : xt, Kt = Math.min(Mt, Math.ceil(1048576 / Nt));
            for (let nr = 0; nr < Mt; nr += Kt) {
              const tr = Math.min(Kt, Mt - nr), ir = Ft.getImageData(Dt - Vt, nr + (Ut - Qt), Nt, tr), sr = _t.getImageData(Dt, nr + Ut, Nt, tr);
              qt && At(ir.data, Zt, ar, Jt), rr(ir.data, sr.data, Tt), _t.putImageData(sr, Dt, nr + Ut);
            }
          }
          function St(Ft, _t, Nt, Mt) {
            const Lt = Mt[0], $t = Mt[1], Tt = Mt[2] - Lt, Dt = Mt[3] - $t;
            Tt === 0 || Dt === 0 || (Et(_t.context, Nt, Tt, Dt, _t.subtype, _t.backdrop, _t.transferMap, Lt, $t, _t.offsetX, _t.offsetY), Ft.save(), Ft.globalAlpha = 1, Ft.globalCompositeOperation = "source-over", Ft.setTransform(1, 0, 0, 1, 0, 0), Ft.drawImage(Nt.canvas, 0, 0), Ft.restore());
          }
          function Bt(Ft, _t) {
            const Nt = _.Util.singularValueDecompose2dScale(Ft);
            Nt[0] = Math.fround(Nt[0]), Nt[1] = Math.fround(Nt[1]);
            const Mt = Math.fround((globalThis.devicePixelRatio || 1) * _e.PixelsPerInch.PDF_TO_CSS_UNITS);
            return _t !== void 0 ? _t : Nt[0] <= Mt || Nt[1] <= Mt;
          }
          const Ot = ["butt", "round", "square"], Pt = ["miter", "round", "bevel"], wt = {}, Ct = {}, Ht = class Ht {
            constructor(_t, Nt, Mt, Lt, $t, Tt, Dt, Ut) {
              _r(this, yt);
              _r(this, kt);
              let {
                optionalContentConfig: Vt,
                markedContentStack: Qt = null
              } = Tt;
              this.ctx = _t, this.current = new gt(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = Nt, this.objs = Mt, this.canvasFactory = Lt, this.filterFactory = $t, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = Qt || [], this.optionalContentConfig = Vt, this.cachedCanvases = new ft(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = Dt, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.pageColors = Ut, this._cachedScaleForStroking = [-1, 0], this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map();
            }
            getObject(_t) {
              let Nt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return typeof _t == "string" ? _t.startsWith("g_") ? this.commonObjs.get(_t) : this.objs.get(_t) : Nt;
            }
            beginDrawing(_t) {
              let {
                transform: Nt,
                viewport: Mt,
                transparency: Lt = !1,
                background: $t = null
              } = _t;
              const Tt = this.ctx.canvas.width, Dt = this.ctx.canvas.height, Ut = this.ctx.fillStyle;
              if (this.ctx.fillStyle = $t || "#ffffff", this.ctx.fillRect(0, 0, Tt, Dt), this.ctx.fillStyle = Ut, Lt) {
                const Vt = this.cachedCanvases.getCanvas("transparent", Tt, Dt);
                this.compositeCtx = this.ctx, this.transparentCanvas = Vt.canvas, this.ctx = Vt.context, this.ctx.save(), this.ctx.transform(...(0, _e.getCurrentTransform)(this.compositeCtx));
              }
              this.ctx.save(), vt(this.ctx), Nt && (this.ctx.transform(...Nt), this.outputScaleX = Nt[0], this.outputScaleY = Nt[0]), this.ctx.transform(...Mt.transform), this.viewportScale = Mt.scale, this.baseTransform = (0, _e.getCurrentTransform)(this.ctx);
            }
            executeOperatorList(_t, Nt, Mt, Lt) {
              const $t = _t.argsArray, Tt = _t.fnArray;
              let Dt = Nt || 0;
              const Ut = $t.length;
              if (Ut === Dt)
                return Dt;
              const Vt = Ut - Dt > lt && typeof Mt == "function", Qt = Vt ? Date.now() + st : 0;
              let qt = 0;
              const Zt = this.commonObjs, ar = this.objs;
              let Jt;
              for (; ; ) {
                if (Lt !== void 0 && Dt === Lt.nextBreakPoint)
                  return Lt.breakIt(Dt, Mt), Dt;
                if (Jt = Tt[Dt], Jt !== _.OPS.dependency)
                  this[Jt].apply(this, $t[Dt]);
                else
                  for (const rr of $t[Dt]) {
                    const Yt = rr.startsWith("g_") ? Zt : ar;
                    if (!Yt.has(rr))
                      return Yt.get(rr, Mt), Dt;
                  }
                if (Dt++, Dt === Ut)
                  return Dt;
                if (Vt && ++qt > lt) {
                  if (Date.now() > Qt)
                    return Mt(), Dt;
                  qt = 0;
                }
              }
            }
            endDrawing() {
              Ur(this, yt, Gs).call(this), this.cachedCanvases.clear(), this.cachedPatterns.clear();
              for (const _t of this._cachedBitmapsMap.values()) {
                for (const Nt of _t.values())
                  typeof HTMLCanvasElement < "u" && Nt instanceof HTMLCanvasElement && (Nt.width = Nt.height = 0);
                _t.clear();
              }
              this._cachedBitmapsMap.clear(), Ur(this, kt, Vs).call(this);
            }
            _scaleImage(_t, Nt) {
              const Mt = _t.width, Lt = _t.height;
              let $t = Math.max(Math.hypot(Nt[0], Nt[1]), 1), Tt = Math.max(Math.hypot(Nt[2], Nt[3]), 1), Dt = Mt, Ut = Lt, Vt = "prescale1", Qt, qt;
              for (; $t > 2 && Dt > 1 || Tt > 2 && Ut > 1; ) {
                let Zt = Dt, ar = Ut;
                $t > 2 && Dt > 1 && (Zt = Dt >= 16384 ? Math.floor(Dt / 2) - 1 || 1 : Math.ceil(Dt / 2), $t /= Dt / Zt), Tt > 2 && Ut > 1 && (ar = Ut >= 16384 ? Math.floor(Ut / 2) - 1 || 1 : Math.ceil(Ut) / 2, Tt /= Ut / ar), Qt = this.cachedCanvases.getCanvas(Vt, Zt, ar), qt = Qt.context, qt.clearRect(0, 0, Zt, ar), qt.drawImage(_t, 0, 0, Dt, Ut, 0, 0, Zt, ar), _t = Qt.canvas, Dt = Zt, Ut = ar, Vt = Vt === "prescale1" ? "prescale2" : "prescale1";
              }
              return {
                img: _t,
                paintWidth: Dt,
                paintHeight: Ut
              };
            }
            _createMaskCanvas(_t) {
              const Nt = this.ctx, {
                width: Mt,
                height: Lt
              } = _t, $t = this.current.fillColor, Tt = this.current.patternFill, Dt = (0, _e.getCurrentTransform)(Nt);
              let Ut, Vt, Qt, qt;
              if ((_t.bitmap || _t.data) && _t.count > 1) {
                const or = _t.bitmap || _t.data.buffer;
                Vt = JSON.stringify(Tt ? Dt : [Dt.slice(0, 4), $t]), Ut = this._cachedBitmapsMap.get(or), Ut || (Ut = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(or, Ut));
                const Xt = Ut.get(Vt);
                if (Xt && !Tt) {
                  const Gt = Math.round(Math.min(Dt[0], Dt[2]) + Dt[4]), Wt = Math.round(Math.min(Dt[1], Dt[3]) + Dt[5]);
                  return {
                    canvas: Xt,
                    offsetX: Gt,
                    offsetY: Wt
                  };
                }
                Qt = Xt;
              }
              Qt || (qt = this.cachedCanvases.getCanvas("maskCanvas", Mt, Lt), mt(qt.context, _t));
              let Zt = _.Util.transform(Dt, [1 / Mt, 0, 0, -1 / Lt, 0, 0]);
              Zt = _.Util.transform(Zt, [1, 0, 0, 1, 0, -Lt]);
              const ar = _.Util.applyTransform([0, 0], Zt), Jt = _.Util.applyTransform([Mt, Lt], Zt), rr = _.Util.normalizeRect([ar[0], ar[1], Jt[0], Jt[1]]), Yt = Math.round(rr[2] - rr[0]) || 1, Kt = Math.round(rr[3] - rr[1]) || 1, nr = this.cachedCanvases.getCanvas("fillCanvas", Yt, Kt), tr = nr.context, ir = Math.min(ar[0], Jt[0]), sr = Math.min(ar[1], Jt[1]);
              tr.translate(-ir, -sr), tr.transform(...Zt), Qt || (Qt = this._scaleImage(qt.canvas, (0, _e.getCurrentTransformInverse)(tr)), Qt = Qt.img, Ut && Tt && Ut.set(Vt, Qt)), tr.imageSmoothingEnabled = Bt((0, _e.getCurrentTransform)(tr), _t.interpolate), ht(tr, Qt, 0, 0, Qt.width, Qt.height, 0, 0, Mt, Lt), tr.globalCompositeOperation = "source-in";
              const cr = _.Util.transform((0, _e.getCurrentTransformInverse)(tr), [1, 0, 0, 1, -ir, -sr]);
              return tr.fillStyle = Tt ? $t.getPattern(Nt, this, cr, tt.PathType.FILL) : $t, tr.fillRect(0, 0, Mt, Lt), Ut && !Tt && (this.cachedCanvases.delete("fillCanvas"), Ut.set(Vt, nr.canvas)), {
                canvas: nr.canvas,
                offsetX: Math.round(ir),
                offsetY: Math.round(sr)
              };
            }
            setLineWidth(_t) {
              _t !== this.current.lineWidth && (this._cachedScaleForStroking[0] = -1), this.current.lineWidth = _t, this.ctx.lineWidth = _t;
            }
            setLineCap(_t) {
              this.ctx.lineCap = Ot[_t];
            }
            setLineJoin(_t) {
              this.ctx.lineJoin = Pt[_t];
            }
            setMiterLimit(_t) {
              this.ctx.miterLimit = _t;
            }
            setDash(_t, Nt) {
              const Mt = this.ctx;
              Mt.setLineDash !== void 0 && (Mt.setLineDash(_t), Mt.lineDashOffset = Nt);
            }
            setRenderingIntent(_t) {
            }
            setFlatness(_t) {
            }
            setGState(_t) {
              for (const [Nt, Mt] of _t)
                switch (Nt) {
                  case "LW":
                    this.setLineWidth(Mt);
                    break;
                  case "LC":
                    this.setLineCap(Mt);
                    break;
                  case "LJ":
                    this.setLineJoin(Mt);
                    break;
                  case "ML":
                    this.setMiterLimit(Mt);
                    break;
                  case "D":
                    this.setDash(Mt[0], Mt[1]);
                    break;
                  case "RI":
                    this.setRenderingIntent(Mt);
                    break;
                  case "FL":
                    this.setFlatness(Mt);
                    break;
                  case "Font":
                    this.setFont(Mt[0], Mt[1]);
                    break;
                  case "CA":
                    this.current.strokeAlpha = Mt;
                    break;
                  case "ca":
                    this.current.fillAlpha = Mt, this.ctx.globalAlpha = Mt;
                    break;
                  case "BM":
                    this.ctx.globalCompositeOperation = Mt;
                    break;
                  case "SMask":
                    this.current.activeSMask = Mt ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
                    break;
                  case "TR":
                    this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(Mt);
                    break;
                }
            }
            get inSMaskMode() {
              return !!this.suspendedCtx;
            }
            checkSMaskState() {
              const _t = this.inSMaskMode;
              this.current.activeSMask && !_t ? this.beginSMaskMode() : !this.current.activeSMask && _t && this.endSMaskMode();
            }
            beginSMaskMode() {
              if (this.inSMaskMode)
                throw new Error("beginSMaskMode called while already in smask mode");
              const _t = this.ctx.canvas.width, Nt = this.ctx.canvas.height, Mt = "smaskGroupAt" + this.groupLevel, Lt = this.cachedCanvases.getCanvas(Mt, _t, Nt);
              this.suspendedCtx = this.ctx, this.ctx = Lt.context;
              const $t = this.ctx;
              $t.setTransform(...(0, _e.getCurrentTransform)(this.suspendedCtx)), ct(this.suspendedCtx, $t), ut($t, this.suspendedCtx), this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
            }
            endSMaskMode() {
              if (!this.inSMaskMode)
                throw new Error("endSMaskMode called while not in smask mode");
              this.ctx._removeMirroring(), ct(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
            }
            compose(_t) {
              if (!this.current.activeSMask)
                return;
              _t ? (_t[0] = Math.floor(_t[0]), _t[1] = Math.floor(_t[1]), _t[2] = Math.ceil(_t[2]), _t[3] = Math.ceil(_t[3])) : _t = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
              const Nt = this.current.activeSMask, Mt = this.suspendedCtx;
              St(Mt, Nt, this.ctx, _t), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
            }
            save() {
              this.inSMaskMode ? (ct(this.ctx, this.suspendedCtx), this.suspendedCtx.save()) : this.ctx.save();
              const _t = this.current;
              this.stateStack.push(_t), this.current = _t.clone();
            }
            restore() {
              this.stateStack.length === 0 && this.inSMaskMode && this.endSMaskMode(), this.stateStack.length !== 0 && (this.current = this.stateStack.pop(), this.inSMaskMode ? (this.suspendedCtx.restore(), ct(this.suspendedCtx, this.ctx)) : this.ctx.restore(), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null);
            }
            transform(_t, Nt, Mt, Lt, $t, Tt) {
              this.ctx.transform(_t, Nt, Mt, Lt, $t, Tt), this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null;
            }
            constructPath(_t, Nt, Mt) {
              const Lt = this.ctx, $t = this.current;
              let Tt = $t.x, Dt = $t.y, Ut, Vt;
              const Qt = (0, _e.getCurrentTransform)(Lt), qt = Qt[0] === 0 && Qt[3] === 0 || Qt[1] === 0 && Qt[2] === 0, Zt = qt ? Mt.slice(0) : null;
              for (let ar = 0, Jt = 0, rr = _t.length; ar < rr; ar++)
                switch (_t[ar] | 0) {
                  case _.OPS.rectangle:
                    Tt = Nt[Jt++], Dt = Nt[Jt++];
                    const Yt = Nt[Jt++], Kt = Nt[Jt++], nr = Tt + Yt, tr = Dt + Kt;
                    Lt.moveTo(Tt, Dt), Yt === 0 || Kt === 0 ? Lt.lineTo(nr, tr) : (Lt.lineTo(nr, Dt), Lt.lineTo(nr, tr), Lt.lineTo(Tt, tr)), qt || $t.updateRectMinMax(Qt, [Tt, Dt, nr, tr]), Lt.closePath();
                    break;
                  case _.OPS.moveTo:
                    Tt = Nt[Jt++], Dt = Nt[Jt++], Lt.moveTo(Tt, Dt), qt || $t.updatePathMinMax(Qt, Tt, Dt);
                    break;
                  case _.OPS.lineTo:
                    Tt = Nt[Jt++], Dt = Nt[Jt++], Lt.lineTo(Tt, Dt), qt || $t.updatePathMinMax(Qt, Tt, Dt);
                    break;
                  case _.OPS.curveTo:
                    Ut = Tt, Vt = Dt, Tt = Nt[Jt + 4], Dt = Nt[Jt + 5], Lt.bezierCurveTo(Nt[Jt], Nt[Jt + 1], Nt[Jt + 2], Nt[Jt + 3], Tt, Dt), $t.updateCurvePathMinMax(Qt, Ut, Vt, Nt[Jt], Nt[Jt + 1], Nt[Jt + 2], Nt[Jt + 3], Tt, Dt, Zt), Jt += 6;
                    break;
                  case _.OPS.curveTo2:
                    Ut = Tt, Vt = Dt, Lt.bezierCurveTo(Tt, Dt, Nt[Jt], Nt[Jt + 1], Nt[Jt + 2], Nt[Jt + 3]), $t.updateCurvePathMinMax(Qt, Ut, Vt, Tt, Dt, Nt[Jt], Nt[Jt + 1], Nt[Jt + 2], Nt[Jt + 3], Zt), Tt = Nt[Jt + 2], Dt = Nt[Jt + 3], Jt += 4;
                    break;
                  case _.OPS.curveTo3:
                    Ut = Tt, Vt = Dt, Tt = Nt[Jt + 2], Dt = Nt[Jt + 3], Lt.bezierCurveTo(Nt[Jt], Nt[Jt + 1], Tt, Dt, Tt, Dt), $t.updateCurvePathMinMax(Qt, Ut, Vt, Nt[Jt], Nt[Jt + 1], Tt, Dt, Tt, Dt, Zt), Jt += 4;
                    break;
                  case _.OPS.closePath:
                    Lt.closePath();
                    break;
                }
              qt && $t.updateScalingPathMinMax(Qt, Zt), $t.setCurrentPoint(Tt, Dt);
            }
            closePath() {
              this.ctx.closePath();
            }
            stroke() {
              let _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
              const Nt = this.ctx, Mt = this.current.strokeColor;
              Nt.globalAlpha = this.current.strokeAlpha, this.contentVisible && (typeof Mt == "object" && (Mt != null && Mt.getPattern) ? (Nt.save(), Nt.strokeStyle = Mt.getPattern(Nt, this, (0, _e.getCurrentTransformInverse)(Nt), tt.PathType.STROKE), this.rescaleAndStroke(!1), Nt.restore()) : this.rescaleAndStroke(!0)), _t && this.consumePath(this.current.getClippedPathBoundingBox()), Nt.globalAlpha = this.current.fillAlpha;
            }
            closeStroke() {
              this.closePath(), this.stroke();
            }
            fill() {
              let _t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
              const Nt = this.ctx, Mt = this.current.fillColor, Lt = this.current.patternFill;
              let $t = !1;
              Lt && (Nt.save(), Nt.fillStyle = Mt.getPattern(Nt, this, (0, _e.getCurrentTransformInverse)(Nt), tt.PathType.FILL), $t = !0);
              const Tt = this.current.getClippedPathBoundingBox();
              this.contentVisible && Tt !== null && (this.pendingEOFill ? (Nt.fill("evenodd"), this.pendingEOFill = !1) : Nt.fill()), $t && Nt.restore(), _t && this.consumePath(Tt);
            }
            eoFill() {
              this.pendingEOFill = !0, this.fill();
            }
            fillStroke() {
              this.fill(!1), this.stroke(!1), this.consumePath();
            }
            eoFillStroke() {
              this.pendingEOFill = !0, this.fillStroke();
            }
            closeFillStroke() {
              this.closePath(), this.fillStroke();
            }
            closeEOFillStroke() {
              this.pendingEOFill = !0, this.closePath(), this.fillStroke();
            }
            endPath() {
              this.consumePath();
            }
            clip() {
              this.pendingClip = wt;
            }
            eoClip() {
              this.pendingClip = Ct;
            }
            beginText() {
              this.current.textMatrix = _.IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
            }
            endText() {
              const _t = this.pendingTextPaths, Nt = this.ctx;
              if (_t === void 0) {
                Nt.beginPath();
                return;
              }
              Nt.save(), Nt.beginPath();
              for (const Mt of _t)
                Nt.setTransform(...Mt.transform), Nt.translate(Mt.x, Mt.y), Mt.addToPath(Nt, Mt.fontSize);
              Nt.restore(), Nt.clip(), Nt.beginPath(), delete this.pendingTextPaths;
            }
            setCharSpacing(_t) {
              this.current.charSpacing = _t;
            }
            setWordSpacing(_t) {
              this.current.wordSpacing = _t;
            }
            setHScale(_t) {
              this.current.textHScale = _t / 100;
            }
            setLeading(_t) {
              this.current.leading = -_t;
            }
            setFont(_t, Nt) {
              var Qt;
              const Mt = this.commonObjs.get(_t), Lt = this.current;
              if (!Mt)
                throw new Error(`Can't find font for ${_t}`);
              if (Lt.fontMatrix = Mt.fontMatrix || _.FONT_IDENTITY_MATRIX, (Lt.fontMatrix[0] === 0 || Lt.fontMatrix[3] === 0) && (0, _.warn)("Invalid font matrix for font " + _t), Nt < 0 ? (Nt = -Nt, Lt.fontDirection = -1) : Lt.fontDirection = 1, this.current.font = Mt, this.current.fontSize = Nt, Mt.isType3Font)
                return;
              const $t = Mt.loadedName || "sans-serif", Tt = ((Qt = Mt.systemFontInfo) == null ? void 0 : Qt.css) || `"${$t}", ${Mt.fallbackName}`;
              let Dt = "normal";
              Mt.black ? Dt = "900" : Mt.bold && (Dt = "bold");
              const Ut = Mt.italic ? "italic" : "normal";
              let Vt = Nt;
              Nt < at ? Vt = at : Nt > ot && (Vt = ot), this.current.fontSizeScale = Nt / Vt, this.ctx.font = `${Ut} ${Dt} ${Vt}px ${Tt}`;
            }
            setTextRenderingMode(_t) {
              this.current.textRenderingMode = _t;
            }
            setTextRise(_t) {
              this.current.textRise = _t;
            }
            moveText(_t, Nt) {
              this.current.x = this.current.lineX += _t, this.current.y = this.current.lineY += Nt;
            }
            setLeadingMoveText(_t, Nt) {
              this.setLeading(-Nt), this.moveText(_t, Nt);
            }
            setTextMatrix(_t, Nt, Mt, Lt, $t, Tt) {
              this.current.textMatrix = [_t, Nt, Mt, Lt, $t, Tt], this.current.textMatrixScale = Math.hypot(_t, Nt), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
            }
            nextLine() {
              this.moveText(0, this.current.leading);
            }
            paintChar(_t, Nt, Mt, Lt) {
              const $t = this.ctx, Tt = this.current, Dt = Tt.font, Ut = Tt.textRenderingMode, Vt = Tt.fontSize / Tt.fontSizeScale, Qt = Ut & _.TextRenderingMode.FILL_STROKE_MASK, qt = !!(Ut & _.TextRenderingMode.ADD_TO_PATH_FLAG), Zt = Tt.patternFill && !Dt.missingFile;
              let ar;
              (Dt.disableFontFace || qt || Zt) && (ar = Dt.getPathGenerator(this.commonObjs, _t)), Dt.disableFontFace || Zt ? ($t.save(), $t.translate(Nt, Mt), $t.beginPath(), ar($t, Vt), Lt && $t.setTransform(...Lt), (Qt === _.TextRenderingMode.FILL || Qt === _.TextRenderingMode.FILL_STROKE) && $t.fill(), (Qt === _.TextRenderingMode.STROKE || Qt === _.TextRenderingMode.FILL_STROKE) && $t.stroke(), $t.restore()) : ((Qt === _.TextRenderingMode.FILL || Qt === _.TextRenderingMode.FILL_STROKE) && $t.fillText(_t, Nt, Mt), (Qt === _.TextRenderingMode.STROKE || Qt === _.TextRenderingMode.FILL_STROKE) && $t.strokeText(_t, Nt, Mt)), qt && (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
                transform: (0, _e.getCurrentTransform)($t),
                x: Nt,
                y: Mt,
                fontSize: Vt,
                addToPath: ar
              });
            }
            get isFontSubpixelAAEnabled() {
              const {
                context: _t
              } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
              _t.scale(1.5, 1), _t.fillText("I", 0, 10);
              const Nt = _t.getImageData(0, 0, 10, 10).data;
              let Mt = !1;
              for (let Lt = 3; Lt < Nt.length; Lt += 4)
                if (Nt[Lt] > 0 && Nt[Lt] < 255) {
                  Mt = !0;
                  break;
                }
              return (0, _.shadow)(this, "isFontSubpixelAAEnabled", Mt);
            }
            showText(_t) {
              const Nt = this.current, Mt = Nt.font;
              if (Mt.isType3Font)
                return this.showType3Text(_t);
              const Lt = Nt.fontSize;
              if (Lt === 0)
                return;
              const $t = this.ctx, Tt = Nt.fontSizeScale, Dt = Nt.charSpacing, Ut = Nt.wordSpacing, Vt = Nt.fontDirection, Qt = Nt.textHScale * Vt, qt = _t.length, Zt = Mt.vertical, ar = Zt ? 1 : -1, Jt = Mt.defaultVMetrics, rr = Lt * Nt.fontMatrix[0], Yt = Nt.textRenderingMode === _.TextRenderingMode.FILL && !Mt.disableFontFace && !Nt.patternFill;
              $t.save(), $t.transform(...Nt.textMatrix), $t.translate(Nt.x, Nt.y + Nt.textRise), Vt > 0 ? $t.scale(Qt, -1) : $t.scale(Qt, 1);
              let Kt;
              if (Nt.patternFill) {
                $t.save();
                const cr = Nt.fillColor.getPattern($t, this, (0, _e.getCurrentTransformInverse)($t), tt.PathType.FILL);
                Kt = (0, _e.getCurrentTransform)($t), $t.restore(), $t.fillStyle = cr;
              }
              let nr = Nt.lineWidth;
              const tr = Nt.textMatrixScale;
              if (tr === 0 || nr === 0) {
                const cr = Nt.textRenderingMode & _.TextRenderingMode.FILL_STROKE_MASK;
                (cr === _.TextRenderingMode.STROKE || cr === _.TextRenderingMode.FILL_STROKE) && (nr = this.getSinglePixelWidth());
              } else
                nr /= tr;
              if (Tt !== 1 && ($t.scale(Tt, Tt), nr /= Tt), $t.lineWidth = nr, Mt.isInvalidPDFjsFont) {
                const cr = [];
                let or = 0;
                for (const Xt of _t)
                  cr.push(Xt.unicode), or += Xt.width;
                $t.fillText(cr.join(""), 0, 0), Nt.x += or * rr * Qt, $t.restore(), this.compose();
                return;
              }
              let ir = 0, sr;
              for (sr = 0; sr < qt; ++sr) {
                const cr = _t[sr];
                if (typeof cr == "number") {
                  ir += ar * cr * Lt / 1e3;
                  continue;
                }
                let or = !1;
                const Xt = (cr.isSpace ? Ut : 0) + Dt, Gt = cr.fontChar, Wt = cr.accent;
                let er, lr, ur = cr.width;
                if (Zt) {
                  const yr = cr.vmetric || Jt, Er = -(cr.vmetric ? yr[1] : ur * 0.5) * rr, br = yr[2] * rr;
                  ur = yr ? -yr[0] : ur, er = Er / Tt, lr = (ir + br) / Tt;
                } else
                  er = ir / Tt, lr = 0;
                if (Mt.remeasure && ur > 0) {
                  const yr = $t.measureText(Gt).width * 1e3 / Lt * Tt;
                  if (ur < yr && this.isFontSubpixelAAEnabled) {
                    const Er = ur / yr;
                    or = !0, $t.save(), $t.scale(Er, 1), er /= Er;
                  } else
                    ur !== yr && (er += (ur - yr) / 2e3 * Lt / Tt);
                }
                if (this.contentVisible && (cr.isInFont || Mt.missingFile)) {
                  if (Yt && !Wt)
                    $t.fillText(Gt, er, lr);
                  else if (this.paintChar(Gt, er, lr, Kt), Wt) {
                    const yr = er + Lt * Wt.offset.x / Tt, Er = lr - Lt * Wt.offset.y / Tt;
                    this.paintChar(Wt.fontChar, yr, Er, Kt);
                  }
                }
                const pr = Zt ? ur * rr - Xt * Vt : ur * rr + Xt * Vt;
                ir += pr, or && $t.restore();
              }
              Zt ? Nt.y -= ir : Nt.x += ir * Qt, $t.restore(), this.compose();
            }
            showType3Text(_t) {
              const Nt = this.ctx, Mt = this.current, Lt = Mt.font, $t = Mt.fontSize, Tt = Mt.fontDirection, Dt = Lt.vertical ? 1 : -1, Ut = Mt.charSpacing, Vt = Mt.wordSpacing, Qt = Mt.textHScale * Tt, qt = Mt.fontMatrix || _.FONT_IDENTITY_MATRIX, Zt = _t.length, ar = Mt.textRenderingMode === _.TextRenderingMode.INVISIBLE;
              let Jt, rr, Yt, Kt;
              if (!(ar || $t === 0)) {
                for (this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null, Nt.save(), Nt.transform(...Mt.textMatrix), Nt.translate(Mt.x, Mt.y), Nt.scale(Qt, Tt), Jt = 0; Jt < Zt; ++Jt) {
                  if (rr = _t[Jt], typeof rr == "number") {
                    Kt = Dt * rr * $t / 1e3, this.ctx.translate(Kt, 0), Mt.x += Kt * Qt;
                    continue;
                  }
                  const nr = (rr.isSpace ? Vt : 0) + Ut, tr = Lt.charProcOperatorList[rr.operatorListId];
                  if (!tr) {
                    (0, _.warn)(`Type3 character "${rr.operatorListId}" is not available.`);
                    continue;
                  }
                  this.contentVisible && (this.processingType3 = rr, this.save(), Nt.scale($t, $t), Nt.transform(...qt), this.executeOperatorList(tr), this.restore()), Yt = _.Util.applyTransform([rr.width, 0], qt)[0] * $t + nr, Nt.translate(Yt, 0), Mt.x += Yt * Qt;
                }
                Nt.restore(), this.processingType3 = null;
              }
            }
            setCharWidth(_t, Nt) {
            }
            setCharWidthAndBounds(_t, Nt, Mt, Lt, $t, Tt) {
              this.ctx.rect(Mt, Lt, $t - Mt, Tt - Lt), this.ctx.clip(), this.endPath();
            }
            getColorN_Pattern(_t) {
              let Nt;
              if (_t[0] === "TilingPattern") {
                const Mt = _t[1], Lt = this.baseTransform || (0, _e.getCurrentTransform)(this.ctx), $t = {
                  createCanvasGraphics: (Tt) => new Ht(Tt, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                    optionalContentConfig: this.optionalContentConfig,
                    markedContentStack: this.markedContentStack
                  })
                };
                Nt = new tt.TilingPattern(_t, Mt, this.ctx, $t, Lt);
              } else
                Nt = this._getPattern(_t[1], _t[2]);
              return Nt;
            }
            setStrokeColorN() {
              this.current.strokeColor = this.getColorN_Pattern(arguments);
            }
            setFillColorN() {
              this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
            }
            setStrokeRGBColor(_t, Nt, Mt) {
              const Lt = _.Util.makeHexColor(_t, Nt, Mt);
              this.ctx.strokeStyle = Lt, this.current.strokeColor = Lt;
            }
            setFillRGBColor(_t, Nt, Mt) {
              const Lt = _.Util.makeHexColor(_t, Nt, Mt);
              this.ctx.fillStyle = Lt, this.current.fillColor = Lt, this.current.patternFill = !1;
            }
            _getPattern(_t) {
              let Nt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, Mt;
              return this.cachedPatterns.has(_t) ? Mt = this.cachedPatterns.get(_t) : (Mt = (0, tt.getShadingPattern)(this.getObject(_t)), this.cachedPatterns.set(_t, Mt)), Nt && (Mt.matrix = Nt), Mt;
            }
            shadingFill(_t) {
              if (!this.contentVisible)
                return;
              const Nt = this.ctx;
              this.save();
              const Mt = this._getPattern(_t);
              Nt.fillStyle = Mt.getPattern(Nt, this, (0, _e.getCurrentTransformInverse)(Nt), tt.PathType.SHADING);
              const Lt = (0, _e.getCurrentTransformInverse)(Nt);
              if (Lt) {
                const {
                  width: $t,
                  height: Tt
                } = Nt.canvas, [Dt, Ut, Vt, Qt] = _.Util.getAxialAlignedBoundingBox([0, 0, $t, Tt], Lt);
                this.ctx.fillRect(Dt, Ut, Vt - Dt, Qt - Ut);
              } else
                this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
              this.compose(this.current.getClippedPathBoundingBox()), this.restore();
            }
            beginInlineImage() {
              (0, _.unreachable)("Should not call beginInlineImage");
            }
            beginImageData() {
              (0, _.unreachable)("Should not call beginImageData");
            }
            paintFormXObjectBegin(_t, Nt) {
              if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), Array.isArray(_t) && _t.length === 6 && this.transform(..._t), this.baseTransform = (0, _e.getCurrentTransform)(this.ctx), Nt)) {
                const Mt = Nt[2] - Nt[0], Lt = Nt[3] - Nt[1];
                this.ctx.rect(Nt[0], Nt[1], Mt, Lt), this.current.updateRectMinMax((0, _e.getCurrentTransform)(this.ctx), Nt), this.clip(), this.endPath();
              }
            }
            paintFormXObjectEnd() {
              this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
            }
            beginGroup(_t) {
              if (!this.contentVisible)
                return;
              this.save(), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
              const Nt = this.ctx;
              _t.isolated || (0, _.info)("TODO: Support non-isolated groups."), _t.knockout && (0, _.warn)("Knockout groups not supported.");
              const Mt = (0, _e.getCurrentTransform)(Nt);
              if (_t.matrix && Nt.transform(..._t.matrix), !_t.bbox)
                throw new Error("Bounding box is required.");
              let Lt = _.Util.getAxialAlignedBoundingBox(_t.bbox, (0, _e.getCurrentTransform)(Nt));
              const $t = [0, 0, Nt.canvas.width, Nt.canvas.height];
              Lt = _.Util.intersect(Lt, $t) || [0, 0, 0, 0];
              const Tt = Math.floor(Lt[0]), Dt = Math.floor(Lt[1]);
              let Ut = Math.max(Math.ceil(Lt[2]) - Tt, 1), Vt = Math.max(Math.ceil(Lt[3]) - Dt, 1), Qt = 1, qt = 1;
              Ut > rt && (Qt = Ut / rt, Ut = rt), Vt > rt && (qt = Vt / rt, Vt = rt), this.current.startNewPathAndClipBox([0, 0, Ut, Vt]);
              let Zt = "groupAt" + this.groupLevel;
              _t.smask && (Zt += "_smask_" + this.smaskCounter++ % 2);
              const ar = this.cachedCanvases.getCanvas(Zt, Ut, Vt), Jt = ar.context;
              Jt.scale(1 / Qt, 1 / qt), Jt.translate(-Tt, -Dt), Jt.transform(...Mt), _t.smask ? this.smaskStack.push({
                canvas: ar.canvas,
                context: Jt,
                offsetX: Tt,
                offsetY: Dt,
                scaleX: Qt,
                scaleY: qt,
                subtype: _t.smask.subtype,
                backdrop: _t.smask.backdrop,
                transferMap: _t.smask.transferMap || null,
                startTransformInverse: null
              }) : (Nt.setTransform(1, 0, 0, 1, 0, 0), Nt.translate(Tt, Dt), Nt.scale(Qt, qt), Nt.save()), ct(Nt, Jt), this.ctx = Jt, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(Nt), this.groupLevel++;
            }
            endGroup(_t) {
              if (!this.contentVisible)
                return;
              this.groupLevel--;
              const Nt = this.ctx, Mt = this.groupStack.pop();
              if (this.ctx = Mt, this.ctx.imageSmoothingEnabled = !1, _t.smask)
                this.tempSMask = this.smaskStack.pop(), this.restore();
              else {
                this.ctx.restore();
                const Lt = (0, _e.getCurrentTransform)(this.ctx);
                this.restore(), this.ctx.save(), this.ctx.setTransform(...Lt);
                const $t = _.Util.getAxialAlignedBoundingBox([0, 0, Nt.canvas.width, Nt.canvas.height], Lt);
                this.ctx.drawImage(Nt.canvas, 0, 0), this.ctx.restore(), this.compose($t);
              }
            }
            beginAnnotation(_t, Nt, Mt, Lt, $t) {
              if (Ur(this, yt, Gs).call(this), vt(this.ctx), this.ctx.save(), this.save(), this.baseTransform && this.ctx.setTransform(...this.baseTransform), Array.isArray(Nt) && Nt.length === 4) {
                const Tt = Nt[2] - Nt[0], Dt = Nt[3] - Nt[1];
                if ($t && this.annotationCanvasMap) {
                  Mt = Mt.slice(), Mt[4] -= Nt[0], Mt[5] -= Nt[1], Nt = Nt.slice(), Nt[0] = Nt[1] = 0, Nt[2] = Tt, Nt[3] = Dt;
                  const [Ut, Vt] = _.Util.singularValueDecompose2dScale((0, _e.getCurrentTransform)(this.ctx)), {
                    viewportScale: Qt
                  } = this, qt = Math.ceil(Tt * this.outputScaleX * Qt), Zt = Math.ceil(Dt * this.outputScaleY * Qt);
                  this.annotationCanvas = this.canvasFactory.create(qt, Zt);
                  const {
                    canvas: ar,
                    context: Jt
                  } = this.annotationCanvas;
                  this.annotationCanvasMap.set(_t, ar), this.annotationCanvas.savedCtx = this.ctx, this.ctx = Jt, this.ctx.save(), this.ctx.setTransform(Ut, 0, 0, -Vt, 0, Dt * Vt), vt(this.ctx);
                } else
                  vt(this.ctx), this.ctx.rect(Nt[0], Nt[1], Tt, Dt), this.ctx.clip(), this.endPath();
              }
              this.current = new gt(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(...Mt), this.transform(...Lt);
            }
            endAnnotation() {
              this.annotationCanvas && (this.ctx.restore(), Ur(this, kt, Vs).call(this), this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
            }
            paintImageMaskXObject(_t) {
              if (!this.contentVisible)
                return;
              const Nt = _t.count;
              _t = this.getObject(_t.data, _t), _t.count = Nt;
              const Mt = this.ctx, Lt = this.processingType3;
              if (Lt && (Lt.compiled === void 0 && (Lt.compiled = dt(_t)), Lt.compiled)) {
                Lt.compiled(Mt);
                return;
              }
              const $t = this._createMaskCanvas(_t), Tt = $t.canvas;
              Mt.save(), Mt.setTransform(1, 0, 0, 1, 0, 0), Mt.drawImage(Tt, $t.offsetX, $t.offsetY), Mt.restore(), this.compose();
            }
            paintImageMaskXObjectRepeat(_t, Nt) {
              let Mt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, Lt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, $t = arguments.length > 4 ? arguments[4] : void 0, Tt = arguments.length > 5 ? arguments[5] : void 0;
              if (!this.contentVisible)
                return;
              _t = this.getObject(_t.data, _t);
              const Dt = this.ctx;
              Dt.save();
              const Ut = (0, _e.getCurrentTransform)(Dt);
              Dt.transform(Nt, Mt, Lt, $t, 0, 0);
              const Vt = this._createMaskCanvas(_t);
              Dt.setTransform(1, 0, 0, 1, Vt.offsetX - Ut[4], Vt.offsetY - Ut[5]);
              for (let Qt = 0, qt = Tt.length; Qt < qt; Qt += 2) {
                const Zt = _.Util.transform(Ut, [Nt, Mt, Lt, $t, Tt[Qt], Tt[Qt + 1]]), [ar, Jt] = _.Util.applyTransform([0, 0], Zt);
                Dt.drawImage(Vt.canvas, ar, Jt);
              }
              Dt.restore(), this.compose();
            }
            paintImageMaskXObjectGroup(_t) {
              if (!this.contentVisible)
                return;
              const Nt = this.ctx, Mt = this.current.fillColor, Lt = this.current.patternFill;
              for (const $t of _t) {
                const {
                  data: Tt,
                  width: Dt,
                  height: Ut,
                  transform: Vt
                } = $t, Qt = this.cachedCanvases.getCanvas("maskCanvas", Dt, Ut), qt = Qt.context;
                qt.save();
                const Zt = this.getObject(Tt, $t);
                mt(qt, Zt), qt.globalCompositeOperation = "source-in", qt.fillStyle = Lt ? Mt.getPattern(qt, this, (0, _e.getCurrentTransformInverse)(Nt), tt.PathType.FILL) : Mt, qt.fillRect(0, 0, Dt, Ut), qt.restore(), Nt.save(), Nt.transform(...Vt), Nt.scale(1, -1), ht(Nt, Qt.canvas, 0, 0, Dt, Ut, 0, -1, 1, 1), Nt.restore();
              }
              this.compose();
            }
            paintImageXObject(_t) {
              if (!this.contentVisible)
                return;
              const Nt = this.getObject(_t);
              if (!Nt) {
                (0, _.warn)("Dependent image isn't ready yet");
                return;
              }
              this.paintInlineImageXObject(Nt);
            }
            paintImageXObjectRepeat(_t, Nt, Mt, Lt) {
              if (!this.contentVisible)
                return;
              const $t = this.getObject(_t);
              if (!$t) {
                (0, _.warn)("Dependent image isn't ready yet");
                return;
              }
              const Tt = $t.width, Dt = $t.height, Ut = [];
              for (let Vt = 0, Qt = Lt.length; Vt < Qt; Vt += 2)
                Ut.push({
                  transform: [Nt, 0, 0, Mt, Lt[Vt], Lt[Vt + 1]],
                  x: 0,
                  y: 0,
                  w: Tt,
                  h: Dt
                });
              this.paintInlineImageXObjectGroup($t, Ut);
            }
            applyTransferMapsToCanvas(_t) {
              return this.current.transferMaps !== "none" && (_t.filter = this.current.transferMaps, _t.drawImage(_t.canvas, 0, 0), _t.filter = "none"), _t.canvas;
            }
            applyTransferMapsToBitmap(_t) {
              if (this.current.transferMaps === "none")
                return _t.bitmap;
              const {
                bitmap: Nt,
                width: Mt,
                height: Lt
              } = _t, $t = this.cachedCanvases.getCanvas("inlineImage", Mt, Lt), Tt = $t.context;
              return Tt.filter = this.current.transferMaps, Tt.drawImage(Nt, 0, 0), Tt.filter = "none", $t.canvas;
            }
            paintInlineImageXObject(_t) {
              if (!this.contentVisible)
                return;
              const Nt = _t.width, Mt = _t.height, Lt = this.ctx;
              if (this.save(), !_.isNodeJS) {
                const {
                  filter: Dt
                } = Lt;
                Dt !== "none" && Dt !== "" && (Lt.filter = "none");
              }
              Lt.scale(1 / Nt, -1 / Mt);
              let $t;
              if (_t.bitmap)
                $t = this.applyTransferMapsToBitmap(_t);
              else if (typeof HTMLElement == "function" && _t instanceof HTMLElement || !_t.data)
                $t = _t;
              else {
                const Ut = this.cachedCanvases.getCanvas("inlineImage", Nt, Mt).context;
                pt(Ut, _t), $t = this.applyTransferMapsToCanvas(Ut);
              }
              const Tt = this._scaleImage($t, (0, _e.getCurrentTransformInverse)(Lt));
              Lt.imageSmoothingEnabled = Bt((0, _e.getCurrentTransform)(Lt), _t.interpolate), ht(Lt, Tt.img, 0, 0, Tt.paintWidth, Tt.paintHeight, 0, -Mt, Nt, Mt), this.compose(), this.restore();
            }
            paintInlineImageXObjectGroup(_t, Nt) {
              if (!this.contentVisible)
                return;
              const Mt = this.ctx;
              let Lt;
              if (_t.bitmap)
                Lt = _t.bitmap;
              else {
                const $t = _t.width, Tt = _t.height, Ut = this.cachedCanvases.getCanvas("inlineImage", $t, Tt).context;
                pt(Ut, _t), Lt = this.applyTransferMapsToCanvas(Ut);
              }
              for (const $t of Nt)
                Mt.save(), Mt.transform(...$t.transform), Mt.scale(1, -1), ht(Mt, Lt, $t.x, $t.y, $t.w, $t.h, 0, -1, 1, 1), Mt.restore();
              this.compose();
            }
            paintSolidColorImageMask() {
              this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
            }
            markPoint(_t) {
            }
            markPointProps(_t, Nt) {
            }
            beginMarkedContent(_t) {
              this.markedContentStack.push({
                visible: !0
              });
            }
            beginMarkedContentProps(_t, Nt) {
              _t === "OC" ? this.markedContentStack.push({
                visible: this.optionalContentConfig.isVisible(Nt)
              }) : this.markedContentStack.push({
                visible: !0
              }), this.contentVisible = this.isContentVisible();
            }
            endMarkedContent() {
              this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
            }
            beginCompat() {
            }
            endCompat() {
            }
            consumePath(_t) {
              const Nt = this.current.isEmptyClip();
              this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(_t);
              const Mt = this.ctx;
              this.pendingClip && (Nt || (this.pendingClip === Ct ? Mt.clip("evenodd") : Mt.clip()), this.pendingClip = null), this.current.startNewPathAndClipBox(this.current.clipBox), Mt.beginPath();
            }
            getSinglePixelWidth() {
              if (!this._cachedGetSinglePixelWidth) {
                const _t = (0, _e.getCurrentTransform)(this.ctx);
                if (_t[1] === 0 && _t[2] === 0)
                  this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(_t[0]), Math.abs(_t[3]));
                else {
                  const Nt = Math.abs(_t[0] * _t[3] - _t[2] * _t[1]), Mt = Math.hypot(_t[0], _t[2]), Lt = Math.hypot(_t[1], _t[3]);
                  this._cachedGetSinglePixelWidth = Math.max(Mt, Lt) / Nt;
                }
              }
              return this._cachedGetSinglePixelWidth;
            }
            getScaleForStroking() {
              if (this._cachedScaleForStroking[0] === -1) {
                const {
                  lineWidth: _t
                } = this.current, {
                  a: Nt,
                  b: Mt,
                  c: Lt,
                  d: $t
                } = this.ctx.getTransform();
                let Tt, Dt;
                if (Mt === 0 && Lt === 0) {
                  const Ut = Math.abs(Nt), Vt = Math.abs($t);
                  if (Ut === Vt)
                    if (_t === 0)
                      Tt = Dt = 1 / Ut;
                    else {
                      const Qt = Ut * _t;
                      Tt = Dt = Qt < 1 ? 1 / Qt : 1;
                    }
                  else if (_t === 0)
                    Tt = 1 / Ut, Dt = 1 / Vt;
                  else {
                    const Qt = Ut * _t, qt = Vt * _t;
                    Tt = Qt < 1 ? 1 / Qt : 1, Dt = qt < 1 ? 1 / qt : 1;
                  }
                } else {
                  const Ut = Math.abs(Nt * $t - Mt * Lt), Vt = Math.hypot(Nt, Mt), Qt = Math.hypot(Lt, $t);
                  if (_t === 0)
                    Tt = Qt / Ut, Dt = Vt / Ut;
                  else {
                    const qt = _t * Ut;
                    Tt = Qt > qt ? Qt / qt : 1, Dt = Vt > qt ? Vt / qt : 1;
                  }
                }
                this._cachedScaleForStroking[0] = Tt, this._cachedScaleForStroking[1] = Dt;
              }
              return this._cachedScaleForStroking;
            }
            rescaleAndStroke(_t) {
              const {
                ctx: Nt
              } = this, {
                lineWidth: Mt
              } = this.current, [Lt, $t] = this.getScaleForStroking();
              if (Nt.lineWidth = Mt || 1, Lt === 1 && $t === 1) {
                Nt.stroke();
                return;
              }
              const Tt = Nt.getLineDash();
              if (_t && Nt.save(), Nt.scale(Lt, $t), Tt.length > 0) {
                const Dt = Math.max(Lt, $t);
                Nt.setLineDash(Tt.map((Ut) => Ut / Dt)), Nt.lineDashOffset /= Dt;
              }
              Nt.stroke(), _t && Nt.restore();
            }
            isContentVisible() {
              for (let _t = this.markedContentStack.length - 1; _t >= 0; _t--)
                if (!this.markedContentStack[_t].visible)
                  return !1;
              return !0;
            }
          };
          yt = new WeakSet(), Gs = function() {
            for (; this.stateStack.length || this.inSMaskMode; )
              this.restore();
            this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
          }, kt = new WeakSet(), Vs = function() {
            if (this.pageColors) {
              const _t = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
              if (_t !== "none") {
                const Nt = this.ctx.filter;
                this.ctx.filter = _t, this.ctx.drawImage(this.ctx.canvas, 0, 0), this.ctx.filter = Nt;
              }
            }
          };
          let It = Ht;
          s.CanvasGraphics = It;
          for (const Ft in _.OPS)
            It.prototype[Ft] !== void 0 && (It.prototype[_.OPS[Ft]] = It.prototype[Ft]);
        },
        /* 174 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.TilingPattern = s.PathType = void 0, s.getShadingPattern = it, $(2);
          var _ = $(1), _e = $(168);
          const tt = {
            FILL: "Fill",
            STROKE: "Stroke",
            SHADING: "Shading"
          };
          s.PathType = tt;
          function nt(dt, gt) {
            if (!gt)
              return;
            const pt = gt[2] - gt[0], mt = gt[3] - gt[1], ct = new Path2D();
            ct.rect(gt[0], gt[1], pt, mt), dt.clip(ct);
          }
          class at {
            constructor() {
              this.constructor === at && (0, _.unreachable)("Cannot initialize BaseShadingPattern.");
            }
            getPattern() {
              (0, _.unreachable)("Abstract method `getPattern` called.");
            }
          }
          class ot extends at {
            constructor(gt) {
              super(), this._type = gt[1], this._bbox = gt[2], this._colorStops = gt[3], this._p0 = gt[4], this._p1 = gt[5], this._r0 = gt[6], this._r1 = gt[7], this.matrix = null;
            }
            _createGradient(gt) {
              let pt;
              this._type === "axial" ? pt = gt.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (pt = gt.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
              for (const mt of this._colorStops)
                pt.addColorStop(mt[0], mt[1]);
              return pt;
            }
            getPattern(gt, pt, mt, ct) {
              let vt;
              if (ct === tt.STROKE || ct === tt.FILL) {
                const At = pt.current.getClippedPathBoundingBox(ct, (0, _e.getCurrentTransform)(gt)) || [0, 0, 0, 0], xt = Math.ceil(At[2] - At[0]) || 1, bt = Math.ceil(At[3] - At[1]) || 1, Et = pt.cachedCanvases.getCanvas("pattern", xt, bt, !0), St = Et.context;
                St.clearRect(0, 0, St.canvas.width, St.canvas.height), St.beginPath(), St.rect(0, 0, St.canvas.width, St.canvas.height), St.translate(-At[0], -At[1]), mt = _.Util.transform(mt, [1, 0, 0, 1, At[0], At[1]]), St.transform(...pt.baseTransform), this.matrix && St.transform(...this.matrix), nt(St, this._bbox), St.fillStyle = this._createGradient(St), St.fill(), vt = gt.createPattern(Et.canvas, "no-repeat");
                const Bt = new DOMMatrix(mt);
                vt.setTransform(Bt);
              } else
                nt(gt, this._bbox), vt = this._createGradient(gt);
              return vt;
            }
          }
          function rt(dt, gt, pt, mt, ct, vt, At, xt) {
            const bt = gt.coords, Et = gt.colors, St = dt.data, Bt = dt.width * 4;
            let Ot;
            bt[pt + 1] > bt[mt + 1] && (Ot = pt, pt = mt, mt = Ot, Ot = vt, vt = At, At = Ot), bt[mt + 1] > bt[ct + 1] && (Ot = mt, mt = ct, ct = Ot, Ot = At, At = xt, xt = Ot), bt[pt + 1] > bt[mt + 1] && (Ot = pt, pt = mt, mt = Ot, Ot = vt, vt = At, At = Ot);
            const Pt = (bt[pt] + gt.offsetX) * gt.scaleX, wt = (bt[pt + 1] + gt.offsetY) * gt.scaleY, Ct = (bt[mt] + gt.offsetX) * gt.scaleX, It = (bt[mt + 1] + gt.offsetY) * gt.scaleY, yt = (bt[ct] + gt.offsetX) * gt.scaleX, Rt = (bt[ct + 1] + gt.offsetY) * gt.scaleY;
            if (wt >= Rt)
              return;
            const kt = Et[vt], jt = Et[vt + 1], Ht = Et[vt + 2], Ft = Et[At], _t = Et[At + 1], Nt = Et[At + 2], Mt = Et[xt], Lt = Et[xt + 1], $t = Et[xt + 2], Tt = Math.round(wt), Dt = Math.round(Rt);
            let Ut, Vt, Qt, qt, Zt, ar, Jt, rr;
            for (let Yt = Tt; Yt <= Dt; Yt++) {
              if (Yt < It) {
                const sr = Yt < wt ? 0 : (wt - Yt) / (wt - It);
                Ut = Pt - (Pt - Ct) * sr, Vt = kt - (kt - Ft) * sr, Qt = jt - (jt - _t) * sr, qt = Ht - (Ht - Nt) * sr;
              } else {
                let sr;
                Yt > Rt ? sr = 1 : It === Rt ? sr = 0 : sr = (It - Yt) / (It - Rt), Ut = Ct - (Ct - yt) * sr, Vt = Ft - (Ft - Mt) * sr, Qt = _t - (_t - Lt) * sr, qt = Nt - (Nt - $t) * sr;
              }
              let Kt;
              Yt < wt ? Kt = 0 : Yt > Rt ? Kt = 1 : Kt = (wt - Yt) / (wt - Rt), Zt = Pt - (Pt - yt) * Kt, ar = kt - (kt - Mt) * Kt, Jt = jt - (jt - Lt) * Kt, rr = Ht - (Ht - $t) * Kt;
              const nr = Math.round(Math.min(Ut, Zt)), tr = Math.round(Math.max(Ut, Zt));
              let ir = Bt * Yt + nr * 4;
              for (let sr = nr; sr <= tr; sr++)
                Kt = (Ut - sr) / (Ut - Zt), Kt < 0 ? Kt = 0 : Kt > 1 && (Kt = 1), St[ir++] = Vt - (Vt - ar) * Kt | 0, St[ir++] = Qt - (Qt - Jt) * Kt | 0, St[ir++] = qt - (qt - rr) * Kt | 0, St[ir++] = 255;
            }
          }
          function st(dt, gt, pt) {
            const mt = gt.coords, ct = gt.colors;
            let vt, At;
            switch (gt.type) {
              case "lattice":
                const xt = gt.verticesPerRow, bt = Math.floor(mt.length / xt) - 1, Et = xt - 1;
                for (vt = 0; vt < bt; vt++) {
                  let St = vt * xt;
                  for (let Bt = 0; Bt < Et; Bt++, St++)
                    rt(dt, pt, mt[St], mt[St + 1], mt[St + xt], ct[St], ct[St + 1], ct[St + xt]), rt(dt, pt, mt[St + xt + 1], mt[St + 1], mt[St + xt], ct[St + xt + 1], ct[St + 1], ct[St + xt]);
                }
                break;
              case "triangles":
                for (vt = 0, At = mt.length; vt < At; vt += 3)
                  rt(dt, pt, mt[vt], mt[vt + 1], mt[vt + 2], ct[vt], ct[vt + 1], ct[vt + 2]);
                break;
              default:
                throw new Error("illegal figure");
            }
          }
          class lt extends at {
            constructor(gt) {
              super(), this._coords = gt[2], this._colors = gt[3], this._figures = gt[4], this._bounds = gt[5], this._bbox = gt[7], this._background = gt[8], this.matrix = null;
            }
            _createMeshCanvas(gt, pt, mt) {
              const xt = Math.floor(this._bounds[0]), bt = Math.floor(this._bounds[1]), Et = Math.ceil(this._bounds[2]) - xt, St = Math.ceil(this._bounds[3]) - bt, Bt = Math.min(Math.ceil(Math.abs(Et * gt[0] * 1.1)), 3e3), Ot = Math.min(Math.ceil(Math.abs(St * gt[1] * 1.1)), 3e3), Pt = Et / Bt, wt = St / Ot, Ct = {
                coords: this._coords,
                colors: this._colors,
                offsetX: -xt,
                offsetY: -bt,
                scaleX: 1 / Pt,
                scaleY: 1 / wt
              }, It = Bt + 2 * 2, yt = Ot + 2 * 2, Rt = mt.getCanvas("mesh", It, yt, !1), kt = Rt.context, jt = kt.createImageData(Bt, Ot);
              if (pt) {
                const Ft = jt.data;
                for (let _t = 0, Nt = Ft.length; _t < Nt; _t += 4)
                  Ft[_t] = pt[0], Ft[_t + 1] = pt[1], Ft[_t + 2] = pt[2], Ft[_t + 3] = 255;
              }
              for (const Ft of this._figures)
                st(jt, Ft, Ct);
              return kt.putImageData(jt, 2, 2), {
                canvas: Rt.canvas,
                offsetX: xt - 2 * Pt,
                offsetY: bt - 2 * wt,
                scaleX: Pt,
                scaleY: wt
              };
            }
            getPattern(gt, pt, mt, ct) {
              nt(gt, this._bbox);
              let vt;
              if (ct === tt.SHADING)
                vt = _.Util.singularValueDecompose2dScale((0, _e.getCurrentTransform)(gt));
              else if (vt = _.Util.singularValueDecompose2dScale(pt.baseTransform), this.matrix) {
                const xt = _.Util.singularValueDecompose2dScale(this.matrix);
                vt = [vt[0] * xt[0], vt[1] * xt[1]];
              }
              const At = this._createMeshCanvas(vt, ct === tt.SHADING ? null : this._background, pt.cachedCanvases);
              return ct !== tt.SHADING && (gt.setTransform(...pt.baseTransform), this.matrix && gt.transform(...this.matrix)), gt.translate(At.offsetX, At.offsetY), gt.scale(At.scaleX, At.scaleY), gt.createPattern(At.canvas, "no-repeat");
            }
          }
          class et extends at {
            getPattern() {
              return "hotpink";
            }
          }
          function it(dt) {
            switch (dt[0]) {
              case "RadialAxial":
                return new ot(dt);
              case "Mesh":
                return new lt(dt);
              case "Dummy":
                return new et();
            }
            throw new Error(`Unknown IR type: ${dt[0]}`);
          }
          const ut = {
            COLORED: 1,
            UNCOLORED: 2
          }, ht = class ht {
            constructor(gt, pt, mt, ct, vt) {
              this.operatorList = gt[2], this.matrix = gt[3] || [1, 0, 0, 1, 0, 0], this.bbox = gt[4], this.xstep = gt[5], this.ystep = gt[6], this.paintType = gt[7], this.tilingType = gt[8], this.color = pt, this.ctx = mt, this.canvasGraphicsFactory = ct, this.baseTransform = vt;
            }
            createPatternCanvas(gt) {
              const pt = this.operatorList, mt = this.bbox, ct = this.xstep, vt = this.ystep, At = this.paintType, xt = this.tilingType, bt = this.color, Et = this.canvasGraphicsFactory;
              (0, _.info)("TilingType: " + xt);
              const St = mt[0], Bt = mt[1], Ot = mt[2], Pt = mt[3], wt = _.Util.singularValueDecompose2dScale(this.matrix), Ct = _.Util.singularValueDecompose2dScale(this.baseTransform), It = [wt[0] * Ct[0], wt[1] * Ct[1]], yt = this.getSizeAndScale(ct, this.ctx.canvas.width, It[0]), Rt = this.getSizeAndScale(vt, this.ctx.canvas.height, It[1]), kt = gt.cachedCanvases.getCanvas("pattern", yt.size, Rt.size, !0), jt = kt.context, Ht = Et.createCanvasGraphics(jt);
              Ht.groupLevel = gt.groupLevel, this.setFillAndStrokeStyleToContext(Ht, At, bt);
              let Ft = St, _t = Bt, Nt = Ot, Mt = Pt;
              return St < 0 && (Ft = 0, Nt += Math.abs(St)), Bt < 0 && (_t = 0, Mt += Math.abs(Bt)), jt.translate(-(yt.scale * Ft), -(Rt.scale * _t)), Ht.transform(yt.scale, 0, 0, Rt.scale, 0, 0), jt.save(), this.clipBbox(Ht, Ft, _t, Nt, Mt), Ht.baseTransform = (0, _e.getCurrentTransform)(Ht.ctx), Ht.executeOperatorList(pt), Ht.endDrawing(), {
                canvas: kt.canvas,
                scaleX: yt.scale,
                scaleY: Rt.scale,
                offsetX: Ft,
                offsetY: _t
              };
            }
            getSizeAndScale(gt, pt, mt) {
              gt = Math.abs(gt);
              const ct = Math.max(ht.MAX_PATTERN_SIZE, pt);
              let vt = Math.ceil(gt * mt);
              return vt >= ct ? vt = ct : mt = vt / gt, {
                scale: mt,
                size: vt
              };
            }
            clipBbox(gt, pt, mt, ct, vt) {
              const At = ct - pt, xt = vt - mt;
              gt.ctx.rect(pt, mt, At, xt), gt.current.updateRectMinMax((0, _e.getCurrentTransform)(gt.ctx), [pt, mt, ct, vt]), gt.clip(), gt.endPath();
            }
            setFillAndStrokeStyleToContext(gt, pt, mt) {
              const ct = gt.ctx, vt = gt.current;
              switch (pt) {
                case ut.COLORED:
                  const At = this.ctx;
                  ct.fillStyle = At.fillStyle, ct.strokeStyle = At.strokeStyle, vt.fillColor = At.fillStyle, vt.strokeColor = At.strokeStyle;
                  break;
                case ut.UNCOLORED:
                  const xt = _.Util.makeHexColor(mt[0], mt[1], mt[2]);
                  ct.fillStyle = xt, ct.strokeStyle = xt, vt.fillColor = xt, vt.strokeColor = xt;
                  break;
                default:
                  throw new _.FormatError(`Unsupported paint type: ${pt}`);
              }
            }
            getPattern(gt, pt, mt, ct) {
              let vt = mt;
              ct !== tt.SHADING && (vt = _.Util.transform(vt, pt.baseTransform), this.matrix && (vt = _.Util.transform(vt, this.matrix)));
              const At = this.createPatternCanvas(pt);
              let xt = new DOMMatrix(vt);
              xt = xt.translate(At.offsetX, At.offsetY), xt = xt.scale(1 / At.scaleX, 1 / At.scaleY);
              const bt = gt.createPattern(At.canvas, "repeat");
              return bt.setTransform(xt), bt;
            }
          };
          Ln(ht, "MAX_PATTERN_SIZE", 3e3);
          let ft = ht;
          s.TilingPattern = ft;
        },
        /* 175 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.convertBlackAndWhiteToRGBA = tt, s.convertToRGBA = _e, s.grayToRGBA = at, $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123);
          var _ = $(1);
          function _e(ot) {
            switch (ot.kind) {
              case _.ImageKind.GRAYSCALE_1BPP:
                return tt(ot);
              case _.ImageKind.RGB_24BPP:
                return nt(ot);
            }
            return null;
          }
          function tt(ot) {
            let {
              src: rt,
              srcPos: st = 0,
              dest: lt,
              width: et,
              height: it,
              nonBlackColor: ut = 4294967295,
              inverseDecode: ft = !1
            } = ot;
            const ht = _.FeatureTest.isLittleEndian ? 4278190080 : 255, [dt, gt] = ft ? [ut, ht] : [ht, ut], pt = et >> 3, mt = et & 7, ct = rt.length;
            lt = new Uint32Array(lt.buffer);
            let vt = 0;
            for (let At = 0; At < it; At++) {
              for (const bt = st + pt; st < bt; st++) {
                const Et = st < ct ? rt[st] : 255;
                lt[vt++] = Et & 128 ? gt : dt, lt[vt++] = Et & 64 ? gt : dt, lt[vt++] = Et & 32 ? gt : dt, lt[vt++] = Et & 16 ? gt : dt, lt[vt++] = Et & 8 ? gt : dt, lt[vt++] = Et & 4 ? gt : dt, lt[vt++] = Et & 2 ? gt : dt, lt[vt++] = Et & 1 ? gt : dt;
              }
              if (mt === 0)
                continue;
              const xt = st < ct ? rt[st++] : 255;
              for (let bt = 0; bt < mt; bt++)
                lt[vt++] = xt & 1 << 7 - bt ? gt : dt;
            }
            return {
              srcPos: st,
              destPos: vt
            };
          }
          function nt(ot) {
            let {
              src: rt,
              srcPos: st = 0,
              dest: lt,
              destPos: et = 0,
              width: it,
              height: ut
            } = ot, ft = 0;
            const ht = rt.length >> 2, dt = new Uint32Array(rt.buffer, st, ht);
            if (_.FeatureTest.isLittleEndian) {
              for (; ft < ht - 2; ft += 3, et += 4) {
                const gt = dt[ft], pt = dt[ft + 1], mt = dt[ft + 2];
                lt[et] = gt | 4278190080, lt[et + 1] = gt >>> 24 | pt << 8 | 4278190080, lt[et + 2] = pt >>> 16 | mt << 16 | 4278190080, lt[et + 3] = mt >>> 8 | 4278190080;
              }
              for (let gt = ft * 4, pt = rt.length; gt < pt; gt += 3)
                lt[et++] = rt[gt] | rt[gt + 1] << 8 | rt[gt + 2] << 16 | 4278190080;
            } else {
              for (; ft < ht - 2; ft += 3, et += 4) {
                const gt = dt[ft], pt = dt[ft + 1], mt = dt[ft + 2];
                lt[et] = gt | 255, lt[et + 1] = gt << 24 | pt >>> 8 | 255, lt[et + 2] = pt << 16 | mt >>> 16 | 255, lt[et + 3] = mt << 8 | 255;
              }
              for (let gt = ft * 4, pt = rt.length; gt < pt; gt += 3)
                lt[et++] = rt[gt] << 24 | rt[gt + 1] << 16 | rt[gt + 2] << 8 | 255;
            }
            return {
              srcPos: st,
              destPos: et
            };
          }
          function at(ot, rt) {
            if (_.FeatureTest.isLittleEndian)
              for (let st = 0, lt = ot.length; st < lt; st++)
                rt[st] = ot[st] * 65793 | 4278190080;
            else
              for (let st = 0, lt = ot.length; st < lt; st++)
                rt[st] = ot[st] * 16843008 | 255;
          }
        },
        /* 176 */
        /***/
        (a, s) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.GlobalWorkerOptions = void 0;
          const $ = /* @__PURE__ */ Object.create(null);
          s.GlobalWorkerOptions = $, $.workerPort = null, $.workerSrc = "";
        },
        /* 177 */
        /***/
        (a, s, $) => {
          var ot, Nl, st, Ll, et, us;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.MessageHandler = void 0, $(2);
          var _ = $(1);
          const _e = {
            UNKNOWN: 0,
            DATA: 1,
            ERROR: 2
          }, tt = {
            UNKNOWN: 0,
            CANCEL: 1,
            CANCEL_COMPLETE: 2,
            CLOSE: 3,
            ENQUEUE: 4,
            ERROR: 5,
            PULL: 6,
            PULL_COMPLETE: 7,
            START_COMPLETE: 8
          };
          function nt(ut) {
            switch (ut instanceof Error || typeof ut == "object" && ut !== null || (0, _.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), ut.name) {
              case "AbortException":
                return new _.AbortException(ut.message);
              case "MissingPDFException":
                return new _.MissingPDFException(ut.message);
              case "PasswordException":
                return new _.PasswordException(ut.message, ut.code);
              case "UnexpectedResponseException":
                return new _.UnexpectedResponseException(ut.message, ut.status);
              case "UnknownErrorException":
                return new _.UnknownErrorException(ut.message, ut.details);
              default:
                return new _.UnknownErrorException(ut.message, ut.toString());
            }
          }
          class at {
            constructor(ft, ht, dt) {
              _r(this, ot);
              _r(this, st);
              _r(this, et);
              this.sourceName = ft, this.targetName = ht, this.comObj = dt, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (gt) => {
                const pt = gt.data;
                if (pt.targetName !== this.sourceName)
                  return;
                if (pt.stream) {
                  Ur(this, st, Ll).call(this, pt);
                  return;
                }
                if (pt.callback) {
                  const ct = pt.callbackId, vt = this.callbackCapabilities[ct];
                  if (!vt)
                    throw new Error(`Cannot resolve callback ${ct}`);
                  if (delete this.callbackCapabilities[ct], pt.callback === _e.DATA)
                    vt.resolve(pt.data);
                  else if (pt.callback === _e.ERROR)
                    vt.reject(nt(pt.reason));
                  else
                    throw new Error("Unexpected callback case");
                  return;
                }
                const mt = this.actionHandler[pt.action];
                if (!mt)
                  throw new Error(`Unknown action from worker: ${pt.action}`);
                if (pt.callbackId) {
                  const ct = this.sourceName, vt = pt.sourceName;
                  new Promise(function(At) {
                    At(mt(pt.data));
                  }).then(function(At) {
                    dt.postMessage({
                      sourceName: ct,
                      targetName: vt,
                      callback: _e.DATA,
                      callbackId: pt.callbackId,
                      data: At
                    });
                  }, function(At) {
                    dt.postMessage({
                      sourceName: ct,
                      targetName: vt,
                      callback: _e.ERROR,
                      callbackId: pt.callbackId,
                      reason: nt(At)
                    });
                  });
                  return;
                }
                if (pt.streamId) {
                  Ur(this, ot, Nl).call(this, pt);
                  return;
                }
                mt(pt.data);
              }, dt.addEventListener("message", this._onComObjOnMessage);
            }
            on(ft, ht) {
              const dt = this.actionHandler;
              if (dt[ft])
                throw new Error(`There is already an actionName called "${ft}"`);
              dt[ft] = ht;
            }
            send(ft, ht, dt) {
              this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: ft,
                data: ht
              }, dt);
            }
            sendWithPromise(ft, ht, dt) {
              const gt = this.callbackId++, pt = new _.PromiseCapability();
              this.callbackCapabilities[gt] = pt;
              try {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: ft,
                  callbackId: gt,
                  data: ht
                }, dt);
              } catch (mt) {
                pt.reject(mt);
              }
              return pt.promise;
            }
            sendWithStream(ft, ht, dt, gt) {
              const pt = this.streamId++, mt = this.sourceName, ct = this.targetName, vt = this.comObj;
              return new ReadableStream({
                start: (At) => {
                  const xt = new _.PromiseCapability();
                  return this.streamControllers[pt] = {
                    controller: At,
                    startCall: xt,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: !1
                  }, vt.postMessage({
                    sourceName: mt,
                    targetName: ct,
                    action: ft,
                    streamId: pt,
                    data: ht,
                    desiredSize: At.desiredSize
                  }, gt), xt.promise;
                },
                pull: (At) => {
                  const xt = new _.PromiseCapability();
                  return this.streamControllers[pt].pullCall = xt, vt.postMessage({
                    sourceName: mt,
                    targetName: ct,
                    stream: tt.PULL,
                    streamId: pt,
                    desiredSize: At.desiredSize
                  }), xt.promise;
                },
                cancel: (At) => {
                  (0, _.assert)(At instanceof Error, "cancel must have a valid reason");
                  const xt = new _.PromiseCapability();
                  return this.streamControllers[pt].cancelCall = xt, this.streamControllers[pt].isClosed = !0, vt.postMessage({
                    sourceName: mt,
                    targetName: ct,
                    stream: tt.CANCEL,
                    streamId: pt,
                    reason: nt(At)
                  }), xt.promise;
                }
              }, dt);
            }
            destroy() {
              this.comObj.removeEventListener("message", this._onComObjOnMessage);
            }
          }
          ot = new WeakSet(), Nl = function(ft) {
            const ht = ft.streamId, dt = this.sourceName, gt = ft.sourceName, pt = this.comObj, mt = this, ct = this.actionHandler[ft.action], vt = {
              enqueue(At) {
                let xt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, bt = arguments.length > 2 ? arguments[2] : void 0;
                if (this.isCancelled)
                  return;
                const Et = this.desiredSize;
                this.desiredSize -= xt, Et > 0 && this.desiredSize <= 0 && (this.sinkCapability = new _.PromiseCapability(), this.ready = this.sinkCapability.promise), pt.postMessage({
                  sourceName: dt,
                  targetName: gt,
                  stream: tt.ENQUEUE,
                  streamId: ht,
                  chunk: At
                }, bt);
              },
              close() {
                this.isCancelled || (this.isCancelled = !0, pt.postMessage({
                  sourceName: dt,
                  targetName: gt,
                  stream: tt.CLOSE,
                  streamId: ht
                }), delete mt.streamSinks[ht]);
              },
              error(At) {
                (0, _.assert)(At instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, pt.postMessage({
                  sourceName: dt,
                  targetName: gt,
                  stream: tt.ERROR,
                  streamId: ht,
                  reason: nt(At)
                }));
              },
              sinkCapability: new _.PromiseCapability(),
              onPull: null,
              onCancel: null,
              isCancelled: !1,
              desiredSize: ft.desiredSize,
              ready: null
            };
            vt.sinkCapability.resolve(), vt.ready = vt.sinkCapability.promise, this.streamSinks[ht] = vt, new Promise(function(At) {
              At(ct(ft.data, vt));
            }).then(function() {
              pt.postMessage({
                sourceName: dt,
                targetName: gt,
                stream: tt.START_COMPLETE,
                streamId: ht,
                success: !0
              });
            }, function(At) {
              pt.postMessage({
                sourceName: dt,
                targetName: gt,
                stream: tt.START_COMPLETE,
                streamId: ht,
                reason: nt(At)
              });
            });
          }, st = new WeakSet(), Ll = function(ft) {
            const ht = ft.streamId, dt = this.sourceName, gt = ft.sourceName, pt = this.comObj, mt = this.streamControllers[ht], ct = this.streamSinks[ht];
            switch (ft.stream) {
              case tt.START_COMPLETE:
                ft.success ? mt.startCall.resolve() : mt.startCall.reject(nt(ft.reason));
                break;
              case tt.PULL_COMPLETE:
                ft.success ? mt.pullCall.resolve() : mt.pullCall.reject(nt(ft.reason));
                break;
              case tt.PULL:
                if (!ct) {
                  pt.postMessage({
                    sourceName: dt,
                    targetName: gt,
                    stream: tt.PULL_COMPLETE,
                    streamId: ht,
                    success: !0
                  });
                  break;
                }
                ct.desiredSize <= 0 && ft.desiredSize > 0 && ct.sinkCapability.resolve(), ct.desiredSize = ft.desiredSize, new Promise(function(vt) {
                  var At;
                  vt((At = ct.onPull) == null ? void 0 : At.call(ct));
                }).then(function() {
                  pt.postMessage({
                    sourceName: dt,
                    targetName: gt,
                    stream: tt.PULL_COMPLETE,
                    streamId: ht,
                    success: !0
                  });
                }, function(vt) {
                  pt.postMessage({
                    sourceName: dt,
                    targetName: gt,
                    stream: tt.PULL_COMPLETE,
                    streamId: ht,
                    reason: nt(vt)
                  });
                });
                break;
              case tt.ENQUEUE:
                if ((0, _.assert)(mt, "enqueue should have stream controller"), mt.isClosed)
                  break;
                mt.controller.enqueue(ft.chunk);
                break;
              case tt.CLOSE:
                if ((0, _.assert)(mt, "close should have stream controller"), mt.isClosed)
                  break;
                mt.isClosed = !0, mt.controller.close(), Ur(this, et, us).call(this, mt, ht);
                break;
              case tt.ERROR:
                (0, _.assert)(mt, "error should have stream controller"), mt.controller.error(nt(ft.reason)), Ur(this, et, us).call(this, mt, ht);
                break;
              case tt.CANCEL_COMPLETE:
                ft.success ? mt.cancelCall.resolve() : mt.cancelCall.reject(nt(ft.reason)), Ur(this, et, us).call(this, mt, ht);
                break;
              case tt.CANCEL:
                if (!ct)
                  break;
                new Promise(function(vt) {
                  var At;
                  vt((At = ct.onCancel) == null ? void 0 : At.call(ct, nt(ft.reason)));
                }).then(function() {
                  pt.postMessage({
                    sourceName: dt,
                    targetName: gt,
                    stream: tt.CANCEL_COMPLETE,
                    streamId: ht,
                    success: !0
                  });
                }, function(vt) {
                  pt.postMessage({
                    sourceName: dt,
                    targetName: gt,
                    stream: tt.CANCEL_COMPLETE,
                    streamId: ht,
                    reason: nt(vt)
                  });
                }), ct.sinkCapability.reject(nt(ft.reason)), ct.isCancelled = !0, delete this.streamSinks[ht];
                break;
              default:
                throw new Error("Unexpected stream case");
            }
          }, et = new WeakSet(), us = async function(ft, ht) {
            var dt, gt, pt;
            await Promise.allSettled([(dt = ft.startCall) == null ? void 0 : dt.promise, (gt = ft.pullCall) == null ? void 0 : gt.promise, (pt = ft.cancelCall) == null ? void 0 : pt.promise]), delete this.streamControllers[ht];
          }, s.MessageHandler = at;
        },
        /* 178 */
        /***/
        (a, s, $) => {
          var tt, nt;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.Metadata = void 0;
          var _ = $(1);
          class _e {
            constructor(ot) {
              _r(this, tt, void 0);
              _r(this, nt, void 0);
              let {
                parsedData: rt,
                rawData: st
              } = ot;
              tn(this, tt, rt), tn(this, nt, st);
            }
            getRaw() {
              return mr(this, nt);
            }
            get(ot) {
              return mr(this, tt).get(ot) ?? null;
            }
            getAll() {
              return (0, _.objectFromMap)(mr(this, tt));
            }
            has(ot) {
              return mr(this, tt).has(ot);
            }
          }
          tt = new WeakMap(), nt = new WeakMap(), s.Metadata = _e;
        },
        /* 179 */
        /***/
        (a, s, $) => {
          var ot, rt, st, lt, et, it, Qs;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.OptionalContentConfig = void 0;
          var _ = $(1), _e = $(170);
          const tt = Symbol("INTERNAL");
          class nt {
            constructor(ht, dt) {
              _r(this, ot, !0);
              this.name = ht, this.intent = dt;
            }
            get visible() {
              return mr(this, ot);
            }
            _setVisible(ht, dt) {
              ht !== tt && (0, _.unreachable)("Internal method `_setVisible` called."), tn(this, ot, dt);
            }
          }
          ot = new WeakMap();
          class at {
            constructor(ht) {
              _r(this, it);
              _r(this, rt, null);
              _r(this, st, /* @__PURE__ */ new Map());
              _r(this, lt, null);
              _r(this, et, null);
              if (this.name = null, this.creator = null, ht !== null) {
                this.name = ht.name, this.creator = ht.creator, tn(this, et, ht.order);
                for (const dt of ht.groups)
                  mr(this, st).set(dt.id, new nt(dt.name, dt.intent));
                if (ht.baseState === "OFF")
                  for (const dt of mr(this, st).values())
                    dt._setVisible(tt, !1);
                for (const dt of ht.on)
                  mr(this, st).get(dt)._setVisible(tt, !0);
                for (const dt of ht.off)
                  mr(this, st).get(dt)._setVisible(tt, !1);
                tn(this, lt, this.getHash());
              }
            }
            isVisible(ht) {
              if (mr(this, st).size === 0)
                return !0;
              if (!ht)
                return (0, _.warn)("Optional content group not defined."), !0;
              if (ht.type === "OCG")
                return mr(this, st).has(ht.id) ? mr(this, st).get(ht.id).visible : ((0, _.warn)(`Optional content group not found: ${ht.id}`), !0);
              if (ht.type === "OCMD") {
                if (ht.expression)
                  return Ur(this, it, Qs).call(this, ht.expression);
                if (!ht.policy || ht.policy === "AnyOn") {
                  for (const dt of ht.ids) {
                    if (!mr(this, st).has(dt))
                      return (0, _.warn)(`Optional content group not found: ${dt}`), !0;
                    if (mr(this, st).get(dt).visible)
                      return !0;
                  }
                  return !1;
                } else if (ht.policy === "AllOn") {
                  for (const dt of ht.ids) {
                    if (!mr(this, st).has(dt))
                      return (0, _.warn)(`Optional content group not found: ${dt}`), !0;
                    if (!mr(this, st).get(dt).visible)
                      return !1;
                  }
                  return !0;
                } else if (ht.policy === "AnyOff") {
                  for (const dt of ht.ids) {
                    if (!mr(this, st).has(dt))
                      return (0, _.warn)(`Optional content group not found: ${dt}`), !0;
                    if (!mr(this, st).get(dt).visible)
                      return !0;
                  }
                  return !1;
                } else if (ht.policy === "AllOff") {
                  for (const dt of ht.ids) {
                    if (!mr(this, st).has(dt))
                      return (0, _.warn)(`Optional content group not found: ${dt}`), !0;
                    if (mr(this, st).get(dt).visible)
                      return !1;
                  }
                  return !0;
                }
                return (0, _.warn)(`Unknown optional content policy ${ht.policy}.`), !0;
              }
              return (0, _.warn)(`Unknown group type ${ht.type}.`), !0;
            }
            setVisibility(ht) {
              let dt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
              if (!mr(this, st).has(ht)) {
                (0, _.warn)(`Optional content group not found: ${ht}`);
                return;
              }
              mr(this, st).get(ht)._setVisible(tt, !!dt), tn(this, rt, null);
            }
            get hasInitialVisibility() {
              return mr(this, lt) === null || this.getHash() === mr(this, lt);
            }
            getOrder() {
              return mr(this, st).size ? mr(this, et) ? mr(this, et).slice() : [...mr(this, st).keys()] : null;
            }
            getGroups() {
              return mr(this, st).size > 0 ? (0, _.objectFromMap)(mr(this, st)) : null;
            }
            getGroup(ht) {
              return mr(this, st).get(ht) || null;
            }
            getHash() {
              if (mr(this, rt) !== null)
                return mr(this, rt);
              const ht = new _e.MurmurHash3_64();
              for (const [dt, gt] of mr(this, st))
                ht.update(`${dt}:${gt.visible}`);
              return tn(this, rt, ht.hexdigest());
            }
          }
          rt = new WeakMap(), st = new WeakMap(), lt = new WeakMap(), et = new WeakMap(), it = new WeakSet(), Qs = function(ht) {
            const dt = ht.length;
            if (dt < 2)
              return !0;
            const gt = ht[0];
            for (let pt = 1; pt < dt; pt++) {
              const mt = ht[pt];
              let ct;
              if (Array.isArray(mt))
                ct = Ur(this, it, Qs).call(this, mt);
              else if (mr(this, st).has(mt))
                ct = mr(this, st).get(mt).visible;
              else
                return (0, _.warn)(`Optional content group not found: ${mt}`), !0;
              switch (gt) {
                case "And":
                  if (!ct)
                    return !1;
                  break;
                case "Or":
                  if (ct)
                    return !0;
                  break;
                case "Not":
                  return !ct;
                default:
                  return !0;
              }
            }
            return gt === "And";
          }, s.OptionalContentConfig = at;
        },
        /* 180 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.PDFDataTransportStream = void 0, $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123), $(89);
          var _ = $(1), _e = $(168);
          class tt {
            constructor(rt, st) {
              let {
                length: lt,
                initialData: et,
                progressiveDone: it = !1,
                contentDispositionFilename: ut = null,
                disableRange: ft = !1,
                disableStream: ht = !1
              } = rt;
              if ((0, _.assert)(st, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.'), this._queuedChunks = [], this._progressiveDone = it, this._contentDispositionFilename = ut, (et == null ? void 0 : et.length) > 0) {
                const dt = et instanceof Uint8Array && et.byteLength === et.buffer.byteLength ? et.buffer : new Uint8Array(et).buffer;
                this._queuedChunks.push(dt);
              }
              this._pdfDataRangeTransport = st, this._isStreamingSupported = !ht, this._isRangeSupported = !ft, this._contentLength = lt, this._fullRequestReader = null, this._rangeReaders = [], this._pdfDataRangeTransport.addRangeListener((dt, gt) => {
                this._onReceiveData({
                  begin: dt,
                  chunk: gt
                });
              }), this._pdfDataRangeTransport.addProgressListener((dt, gt) => {
                this._onProgress({
                  loaded: dt,
                  total: gt
                });
              }), this._pdfDataRangeTransport.addProgressiveReadListener((dt) => {
                this._onReceiveData({
                  chunk: dt
                });
              }), this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                this._onProgressiveDone();
              }), this._pdfDataRangeTransport.transportReady();
            }
            _onReceiveData(rt) {
              let {
                begin: st,
                chunk: lt
              } = rt;
              const et = lt instanceof Uint8Array && lt.byteLength === lt.buffer.byteLength ? lt.buffer : new Uint8Array(lt).buffer;
              if (st === void 0)
                this._fullRequestReader ? this._fullRequestReader._enqueue(et) : this._queuedChunks.push(et);
              else {
                const it = this._rangeReaders.some(function(ut) {
                  return ut._begin !== st ? !1 : (ut._enqueue(et), !0);
                });
                (0, _.assert)(it, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
              }
            }
            get _progressiveDataLength() {
              var rt;
              return ((rt = this._fullRequestReader) == null ? void 0 : rt._loaded) ?? 0;
            }
            _onProgress(rt) {
              var st, lt, et, it;
              rt.total === void 0 ? (lt = (st = this._rangeReaders[0]) == null ? void 0 : st.onProgress) == null || lt.call(st, {
                loaded: rt.loaded
              }) : (it = (et = this._fullRequestReader) == null ? void 0 : et.onProgress) == null || it.call(et, {
                loaded: rt.loaded,
                total: rt.total
              });
            }
            _onProgressiveDone() {
              var rt;
              (rt = this._fullRequestReader) == null || rt.progressiveDone(), this._progressiveDone = !0;
            }
            _removeRangeReader(rt) {
              const st = this._rangeReaders.indexOf(rt);
              st >= 0 && this._rangeReaders.splice(st, 1);
            }
            getFullReader() {
              (0, _.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
              const rt = this._queuedChunks;
              return this._queuedChunks = null, new nt(this, rt, this._progressiveDone, this._contentDispositionFilename);
            }
            getRangeReader(rt, st) {
              if (st <= this._progressiveDataLength)
                return null;
              const lt = new at(this, rt, st);
              return this._pdfDataRangeTransport.requestDataRange(rt, st), this._rangeReaders.push(lt), lt;
            }
            cancelAllRequests(rt) {
              var st;
              (st = this._fullRequestReader) == null || st.cancel(rt);
              for (const lt of this._rangeReaders.slice(0))
                lt.cancel(rt);
              this._pdfDataRangeTransport.abort();
            }
          }
          s.PDFDataTransportStream = tt;
          class nt {
            constructor(rt, st) {
              let lt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, et = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
              this._stream = rt, this._done = lt || !1, this._filename = (0, _e.isPdfFile)(et) ? et : null, this._queuedChunks = st || [], this._loaded = 0;
              for (const it of this._queuedChunks)
                this._loaded += it.byteLength;
              this._requests = [], this._headersReady = Promise.resolve(), rt._fullRequestReader = this, this.onProgress = null;
            }
            _enqueue(rt) {
              this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
                value: rt,
                done: !1
              }) : this._queuedChunks.push(rt), this._loaded += rt.byteLength);
            }
            get headersReady() {
              return this._headersReady;
            }
            get filename() {
              return this._filename;
            }
            get isRangeSupported() {
              return this._stream._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._stream._isStreamingSupported;
            }
            get contentLength() {
              return this._stream._contentLength;
            }
            async read() {
              if (this._queuedChunks.length > 0)
                return {
                  value: this._queuedChunks.shift(),
                  done: !1
                };
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const rt = new _.PromiseCapability();
              return this._requests.push(rt), rt.promise;
            }
            cancel(rt) {
              this._done = !0;
              for (const st of this._requests)
                st.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0;
            }
            progressiveDone() {
              this._done || (this._done = !0);
            }
          }
          class at {
            constructor(rt, st, lt) {
              this._stream = rt, this._begin = st, this._end = lt, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
            }
            _enqueue(rt) {
              if (!this._done) {
                if (this._requests.length === 0)
                  this._queuedChunk = rt;
                else {
                  this._requests.shift().resolve({
                    value: rt,
                    done: !1
                  });
                  for (const lt of this._requests)
                    lt.resolve({
                      value: void 0,
                      done: !0
                    });
                  this._requests.length = 0;
                }
                this._done = !0, this._stream._removeRangeReader(this);
              }
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              if (this._queuedChunk) {
                const st = this._queuedChunk;
                return this._queuedChunk = null, {
                  value: st,
                  done: !1
                };
              }
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const rt = new _.PromiseCapability();
              return this._requests.push(rt), rt.promise;
            }
            cancel(rt) {
              this._done = !0;
              for (const st of this._requests)
                st.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._stream._removeRangeReader(this);
            }
          }
        },
        /* 181 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.PDFFetchStream = void 0, $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123), $(89);
          var _ = $(1), _e = $(182);
          function tt(lt, et, it) {
            return {
              method: "GET",
              headers: lt,
              signal: it.signal,
              mode: "cors",
              credentials: et ? "include" : "same-origin",
              redirect: "follow"
            };
          }
          function nt(lt) {
            const et = new Headers();
            for (const it in lt) {
              const ut = lt[it];
              ut !== void 0 && et.append(it, ut);
            }
            return et;
          }
          function at(lt) {
            return lt instanceof Uint8Array ? lt.buffer : lt instanceof ArrayBuffer ? lt : ((0, _.warn)(`getArrayBuffer - unexpected data format: ${lt}`), new Uint8Array(lt).buffer);
          }
          class ot {
            constructor(et) {
              this.source = et, this.isHttp = /^https?:/i.test(et.url), this.httpHeaders = this.isHttp && et.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            get _progressiveDataLength() {
              var et;
              return ((et = this._fullRequestReader) == null ? void 0 : et._loaded) ?? 0;
            }
            getFullReader() {
              return (0, _.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new rt(this), this._fullRequestReader;
            }
            getRangeReader(et, it) {
              if (it <= this._progressiveDataLength)
                return null;
              const ut = new st(this, et, it);
              return this._rangeRequestReaders.push(ut), ut;
            }
            cancelAllRequests(et) {
              var it;
              (it = this._fullRequestReader) == null || it.cancel(et);
              for (const ut of this._rangeRequestReaders.slice(0))
                ut.cancel(et);
            }
          }
          s.PDFFetchStream = ot;
          class rt {
            constructor(et) {
              this._stream = et, this._reader = null, this._loaded = 0, this._filename = null;
              const it = et.source;
              this._withCredentials = it.withCredentials || !1, this._contentLength = it.length, this._headersCapability = new _.PromiseCapability(), this._disableRange = it.disableRange || !1, this._rangeChunkSize = it.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !it.disableStream, this._isRangeSupported = !it.disableRange, this._headers = nt(this._stream.httpHeaders);
              const ut = it.url;
              fetch(ut, tt(this._headers, this._withCredentials, this._abortController)).then((ft) => {
                if (!(0, _e.validateResponseStatus)(ft.status))
                  throw (0, _e.createResponseStatusError)(ft.status, ut);
                this._reader = ft.body.getReader(), this._headersCapability.resolve();
                const ht = (pt) => ft.headers.get(pt), {
                  allowRangeRequests: dt,
                  suggestedLength: gt
                } = (0, _e.validateRangeRequestCapabilities)({
                  getResponseHeader: ht,
                  isHttp: this._stream.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                this._isRangeSupported = dt, this._contentLength = gt || this._contentLength, this._filename = (0, _e.extractFilenameFromHeader)(ht), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new _.AbortException("Streaming is disabled."));
              }).catch(this._headersCapability.reject), this.onProgress = null;
            }
            get headersReady() {
              return this._headersCapability.promise;
            }
            get filename() {
              return this._filename;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var ut;
              await this._headersCapability.promise;
              const {
                value: et,
                done: it
              } = await this._reader.read();
              return it ? {
                value: et,
                done: it
              } : (this._loaded += et.byteLength, (ut = this.onProgress) == null || ut.call(this, {
                loaded: this._loaded,
                total: this._contentLength
              }), {
                value: at(et),
                done: !1
              });
            }
            cancel(et) {
              var it;
              (it = this._reader) == null || it.cancel(et), this._abortController.abort();
            }
          }
          class st {
            constructor(et, it, ut) {
              this._stream = et, this._reader = null, this._loaded = 0;
              const ft = et.source;
              this._withCredentials = ft.withCredentials || !1, this._readCapability = new _.PromiseCapability(), this._isStreamingSupported = !ft.disableStream, this._abortController = new AbortController(), this._headers = nt(this._stream.httpHeaders), this._headers.append("Range", `bytes=${it}-${ut - 1}`);
              const ht = ft.url;
              fetch(ht, tt(this._headers, this._withCredentials, this._abortController)).then((dt) => {
                if (!(0, _e.validateResponseStatus)(dt.status))
                  throw (0, _e.createResponseStatusError)(dt.status, ht);
                this._readCapability.resolve(), this._reader = dt.body.getReader();
              }).catch(this._readCapability.reject), this.onProgress = null;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var ut;
              await this._readCapability.promise;
              const {
                value: et,
                done: it
              } = await this._reader.read();
              return it ? {
                value: et,
                done: it
              } : (this._loaded += et.byteLength, (ut = this.onProgress) == null || ut.call(this, {
                loaded: this._loaded
              }), {
                value: at(et),
                done: !1
              });
            }
            cancel(et) {
              var it;
              (it = this._reader) == null || it.cancel(et), this._abortController.abort();
            }
          }
        },
        /* 182 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.createResponseStatusError = ot, s.extractFilenameFromHeader = at, s.validateRangeRequestCapabilities = nt, s.validateResponseStatus = rt;
          var _ = $(1), _e = $(183), tt = $(168);
          function nt(st) {
            let {
              getResponseHeader: lt,
              isHttp: et,
              rangeChunkSize: it,
              disableRange: ut
            } = st;
            const ft = {
              allowRangeRequests: !1,
              suggestedLength: void 0
            }, ht = parseInt(lt("Content-Length"), 10);
            return !Number.isInteger(ht) || (ft.suggestedLength = ht, ht <= 2 * it) || ut || !et || lt("Accept-Ranges") !== "bytes" || (lt("Content-Encoding") || "identity") !== "identity" || (ft.allowRangeRequests = !0), ft;
          }
          function at(st) {
            const lt = st("Content-Disposition");
            if (lt) {
              let et = (0, _e.getFilenameFromContentDispositionHeader)(lt);
              if (et.includes("%"))
                try {
                  et = decodeURIComponent(et);
                } catch {
                }
              if ((0, tt.isPdfFile)(et))
                return et;
            }
            return null;
          }
          function ot(st, lt) {
            return st === 404 || st === 0 && lt.startsWith("file:") ? new _.MissingPDFException('Missing PDF "' + lt + '".') : new _.UnexpectedResponseException(`Unexpected server response (${st}) while retrieving PDF "${lt}".`, st);
          }
          function rt(st) {
            return st === 200 || st === 206;
          }
        },
        /* 183 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.getFilenameFromContentDispositionHeader = _e, $(89), $(149);
          var _ = $(1);
          function _e(tt) {
            let nt = !0, at = ot("filename\\*", "i").exec(tt);
            if (at) {
              at = at[1];
              let ft = et(at);
              return ft = unescape(ft), ft = it(ft), ft = ut(ft), st(ft);
            }
            if (at = lt(tt), at) {
              const ft = ut(at);
              return st(ft);
            }
            if (at = ot("filename", "i").exec(tt), at) {
              at = at[1];
              let ft = et(at);
              return ft = ut(ft), st(ft);
            }
            function ot(ft, ht) {
              return new RegExp("(?:^|;)\\s*" + ft + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', ht);
            }
            function rt(ft, ht) {
              if (ft) {
                if (!/^[\x00-\xFF]+$/.test(ht))
                  return ht;
                try {
                  const dt = new TextDecoder(ft, {
                    fatal: !0
                  }), gt = (0, _.stringToBytes)(ht);
                  ht = dt.decode(gt), nt = !1;
                } catch {
                }
              }
              return ht;
            }
            function st(ft) {
              return nt && /[\x80-\xff]/.test(ft) && (ft = rt("utf-8", ft), nt && (ft = rt("iso-8859-1", ft))), ft;
            }
            function lt(ft) {
              const ht = [];
              let dt;
              const gt = ot("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
              for (; (dt = gt.exec(ft)) !== null; ) {
                let [, mt, ct, vt] = dt;
                if (mt = parseInt(mt, 10), mt in ht) {
                  if (mt === 0)
                    break;
                  continue;
                }
                ht[mt] = [ct, vt];
              }
              const pt = [];
              for (let mt = 0; mt < ht.length && mt in ht; ++mt) {
                let [ct, vt] = ht[mt];
                vt = et(vt), ct && (vt = unescape(vt), mt === 0 && (vt = it(vt))), pt.push(vt);
              }
              return pt.join("");
            }
            function et(ft) {
              if (ft.startsWith('"')) {
                const ht = ft.slice(1).split('\\"');
                for (let dt = 0; dt < ht.length; ++dt) {
                  const gt = ht[dt].indexOf('"');
                  gt !== -1 && (ht[dt] = ht[dt].slice(0, gt), ht.length = dt + 1), ht[dt] = ht[dt].replaceAll(/\\(.)/g, "$1");
                }
                ft = ht.join('"');
              }
              return ft;
            }
            function it(ft) {
              const ht = ft.indexOf("'");
              if (ht === -1)
                return ft;
              const dt = ft.slice(0, ht), pt = ft.slice(ht + 1).replace(/^[^']*'/, "");
              return rt(dt, pt);
            }
            function ut(ft) {
              return !ft.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(ft) ? ft : ft.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(ht, dt, gt, pt) {
                if (gt === "q" || gt === "Q")
                  return pt = pt.replaceAll("_", " "), pt = pt.replaceAll(/=([0-9a-fA-F]{2})/g, function(mt, ct) {
                    return String.fromCharCode(parseInt(ct, 16));
                  }), rt(dt, pt);
                try {
                  pt = atob(pt);
                } catch {
                }
                return rt(dt, pt);
              });
            }
            return "";
          }
        },
        /* 184 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.PDFNetworkStream = void 0, $(89);
          var _ = $(1), _e = $(182);
          const tt = 200, nt = 206;
          function at(et) {
            const it = et.response;
            return typeof it != "string" ? it : (0, _.stringToBytes)(it).buffer;
          }
          class ot {
            constructor(it) {
              let ut = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              this.url = it, this.isHttp = /^https?:/i.test(it), this.httpHeaders = this.isHttp && ut.httpHeaders || /* @__PURE__ */ Object.create(null), this.withCredentials = ut.withCredentials || !1, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
            }
            requestRange(it, ut, ft) {
              const ht = {
                begin: it,
                end: ut
              };
              for (const dt in ft)
                ht[dt] = ft[dt];
              return this.request(ht);
            }
            requestFull(it) {
              return this.request(it);
            }
            request(it) {
              const ut = new XMLHttpRequest(), ft = this.currXhrId++, ht = this.pendingRequests[ft] = {
                xhr: ut
              };
              ut.open("GET", this.url), ut.withCredentials = this.withCredentials;
              for (const dt in this.httpHeaders) {
                const gt = this.httpHeaders[dt];
                gt !== void 0 && ut.setRequestHeader(dt, gt);
              }
              return this.isHttp && "begin" in it && "end" in it ? (ut.setRequestHeader("Range", `bytes=${it.begin}-${it.end - 1}`), ht.expectedStatus = nt) : ht.expectedStatus = tt, ut.responseType = "arraybuffer", it.onError && (ut.onerror = function(dt) {
                it.onError(ut.status);
              }), ut.onreadystatechange = this.onStateChange.bind(this, ft), ut.onprogress = this.onProgress.bind(this, ft), ht.onHeadersReceived = it.onHeadersReceived, ht.onDone = it.onDone, ht.onError = it.onError, ht.onProgress = it.onProgress, ut.send(null), ft;
            }
            onProgress(it, ut) {
              var ht;
              const ft = this.pendingRequests[it];
              ft && ((ht = ft.onProgress) == null || ht.call(ft, ut));
            }
            onStateChange(it, ut) {
              var mt, ct, vt;
              const ft = this.pendingRequests[it];
              if (!ft)
                return;
              const ht = ft.xhr;
              if (ht.readyState >= 2 && ft.onHeadersReceived && (ft.onHeadersReceived(), delete ft.onHeadersReceived), ht.readyState !== 4 || !(it in this.pendingRequests))
                return;
              if (delete this.pendingRequests[it], ht.status === 0 && this.isHttp) {
                (mt = ft.onError) == null || mt.call(ft, ht.status);
                return;
              }
              const dt = ht.status || tt;
              if (!(dt === tt && ft.expectedStatus === nt) && dt !== ft.expectedStatus) {
                (ct = ft.onError) == null || ct.call(ft, ht.status);
                return;
              }
              const pt = at(ht);
              if (dt === nt) {
                const At = ht.getResponseHeader("Content-Range"), xt = /bytes (\d+)-(\d+)\/(\d+)/.exec(At);
                ft.onDone({
                  begin: parseInt(xt[1], 10),
                  chunk: pt
                });
              } else
                pt ? ft.onDone({
                  begin: 0,
                  chunk: pt
                }) : (vt = ft.onError) == null || vt.call(ft, ht.status);
            }
            getRequestXhr(it) {
              return this.pendingRequests[it].xhr;
            }
            isPendingRequest(it) {
              return it in this.pendingRequests;
            }
            abortRequest(it) {
              const ut = this.pendingRequests[it].xhr;
              delete this.pendingRequests[it], ut.abort();
            }
          }
          class rt {
            constructor(it) {
              this._source = it, this._manager = new ot(it.url, {
                httpHeaders: it.httpHeaders,
                withCredentials: it.withCredentials
              }), this._rangeChunkSize = it.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            _onRangeRequestReaderClosed(it) {
              const ut = this._rangeRequestReaders.indexOf(it);
              ut >= 0 && this._rangeRequestReaders.splice(ut, 1);
            }
            getFullReader() {
              return (0, _.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new st(this._manager, this._source), this._fullRequestReader;
            }
            getRangeReader(it, ut) {
              const ft = new lt(this._manager, it, ut);
              return ft.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(ft), ft;
            }
            cancelAllRequests(it) {
              var ut;
              (ut = this._fullRequestReader) == null || ut.cancel(it);
              for (const ft of this._rangeRequestReaders.slice(0))
                ft.cancel(it);
            }
          }
          s.PDFNetworkStream = rt;
          class st {
            constructor(it, ut) {
              this._manager = it;
              const ft = {
                onHeadersReceived: this._onHeadersReceived.bind(this),
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._url = ut.url, this._fullRequestId = it.requestFull(ft), this._headersReceivedCapability = new _.PromiseCapability(), this._disableRange = ut.disableRange || !1, this._contentLength = ut.length, this._rangeChunkSize = ut.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
            }
            _onHeadersReceived() {
              const it = this._fullRequestId, ut = this._manager.getRequestXhr(it), ft = (gt) => ut.getResponseHeader(gt), {
                allowRangeRequests: ht,
                suggestedLength: dt
              } = (0, _e.validateRangeRequestCapabilities)({
                getResponseHeader: ft,
                isHttp: this._manager.isHttp,
                rangeChunkSize: this._rangeChunkSize,
                disableRange: this._disableRange
              });
              ht && (this._isRangeSupported = !0), this._contentLength = dt || this._contentLength, this._filename = (0, _e.extractFilenameFromHeader)(ft), this._isRangeSupported && this._manager.abortRequest(it), this._headersReceivedCapability.resolve();
            }
            _onDone(it) {
              if (it && (this._requests.length > 0 ? this._requests.shift().resolve({
                value: it.chunk,
                done: !1
              }) : this._cachedChunks.push(it.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
                for (const ut of this._requests)
                  ut.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0;
              }
            }
            _onError(it) {
              this._storedError = (0, _e.createResponseStatusError)(it, this._url), this._headersReceivedCapability.reject(this._storedError);
              for (const ut of this._requests)
                ut.reject(this._storedError);
              this._requests.length = 0, this._cachedChunks.length = 0;
            }
            _onProgress(it) {
              var ut;
              (ut = this.onProgress) == null || ut.call(this, {
                loaded: it.loaded,
                total: it.lengthComputable ? it.total : this._contentLength
              });
            }
            get filename() {
              return this._filename;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            get contentLength() {
              return this._contentLength;
            }
            get headersReady() {
              return this._headersReceivedCapability.promise;
            }
            async read() {
              if (this._storedError)
                throw this._storedError;
              if (this._cachedChunks.length > 0)
                return {
                  value: this._cachedChunks.shift(),
                  done: !1
                };
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const it = new _.PromiseCapability();
              return this._requests.push(it), it.promise;
            }
            cancel(it) {
              this._done = !0, this._headersReceivedCapability.reject(it);
              for (const ut of this._requests)
                ut.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
            }
          }
          class lt {
            constructor(it, ut, ft) {
              this._manager = it;
              const ht = {
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._url = it.url, this._requestId = it.requestRange(ut, ft, ht), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
            }
            _close() {
              var it;
              (it = this.onClosed) == null || it.call(this, this);
            }
            _onDone(it) {
              const ut = it.chunk;
              this._requests.length > 0 ? this._requests.shift().resolve({
                value: ut,
                done: !1
              }) : this._queuedChunk = ut, this._done = !0;
              for (const ft of this._requests)
                ft.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._close();
            }
            _onError(it) {
              this._storedError = (0, _e.createResponseStatusError)(it, this._url);
              for (const ut of this._requests)
                ut.reject(this._storedError);
              this._requests.length = 0, this._queuedChunk = null;
            }
            _onProgress(it) {
              var ut;
              this.isStreamingSupported || (ut = this.onProgress) == null || ut.call(this, {
                loaded: it.loaded
              });
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              if (this._storedError)
                throw this._storedError;
              if (this._queuedChunk !== null) {
                const ut = this._queuedChunk;
                return this._queuedChunk = null, {
                  value: ut,
                  done: !1
                };
              }
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const it = new _.PromiseCapability();
              return this._requests.push(it), it.promise;
            }
            cancel(it) {
              this._done = !0;
              for (const ut of this._requests)
                ut.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
            }
          }
        },
        /* 185 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.PDFNodeStream = void 0, $(89), $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123);
          var _ = $(1), _e = $(182);
          const tt = /^file:\/\/\/[a-zA-Z]:\//;
          function nt(ft) {
            const ht = require$$6, dt = ht.parse(ft);
            return dt.protocol === "file:" || dt.host ? dt : /^[a-z]:[/\\]/i.test(ft) ? ht.parse(`file:///${ft}`) : (dt.host || (dt.protocol = "file:"), dt);
          }
          class at {
            constructor(ht) {
              this.source = ht, this.url = nt(ht.url), this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:", this.isFsUrl = this.url.protocol === "file:", this.httpHeaders = this.isHttp && ht.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            get _progressiveDataLength() {
              var ht;
              return ((ht = this._fullRequestReader) == null ? void 0 : ht._loaded) ?? 0;
            }
            getFullReader() {
              return (0, _.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = this.isFsUrl ? new it(this) : new lt(this), this._fullRequestReader;
            }
            getRangeReader(ht, dt) {
              if (dt <= this._progressiveDataLength)
                return null;
              const gt = this.isFsUrl ? new ut(this, ht, dt) : new et(this, ht, dt);
              return this._rangeRequestReaders.push(gt), gt;
            }
            cancelAllRequests(ht) {
              var dt;
              (dt = this._fullRequestReader) == null || dt.cancel(ht);
              for (const gt of this._rangeRequestReaders.slice(0))
                gt.cancel(ht);
            }
          }
          s.PDFNodeStream = at;
          class ot {
            constructor(ht) {
              this._url = ht.url, this._done = !1, this._storedError = null, this.onProgress = null;
              const dt = ht.source;
              this._contentLength = dt.length, this._loaded = 0, this._filename = null, this._disableRange = dt.disableRange || !1, this._rangeChunkSize = dt.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !dt.disableStream, this._isRangeSupported = !dt.disableRange, this._readableStream = null, this._readCapability = new _.PromiseCapability(), this._headersCapability = new _.PromiseCapability();
            }
            get headersReady() {
              return this._headersCapability.promise;
            }
            get filename() {
              return this._filename;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var gt;
              if (await this._readCapability.promise, this._done)
                return {
                  value: void 0,
                  done: !0
                };
              if (this._storedError)
                throw this._storedError;
              const ht = this._readableStream.read();
              return ht === null ? (this._readCapability = new _.PromiseCapability(), this.read()) : (this._loaded += ht.length, (gt = this.onProgress) == null || gt.call(this, {
                loaded: this._loaded,
                total: this._contentLength
              }), {
                value: new Uint8Array(ht).buffer,
                done: !1
              });
            }
            cancel(ht) {
              if (!this._readableStream) {
                this._error(ht);
                return;
              }
              this._readableStream.destroy(ht);
            }
            _error(ht) {
              this._storedError = ht, this._readCapability.resolve();
            }
            _setReadableStream(ht) {
              this._readableStream = ht, ht.on("readable", () => {
                this._readCapability.resolve();
              }), ht.on("end", () => {
                ht.destroy(), this._done = !0, this._readCapability.resolve();
              }), ht.on("error", (dt) => {
                this._error(dt);
              }), !this._isStreamingSupported && this._isRangeSupported && this._error(new _.AbortException("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
            }
          }
          class rt {
            constructor(ht) {
              this._url = ht.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = new _.PromiseCapability();
              const dt = ht.source;
              this._isStreamingSupported = !dt.disableStream;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var gt;
              if (await this._readCapability.promise, this._done)
                return {
                  value: void 0,
                  done: !0
                };
              if (this._storedError)
                throw this._storedError;
              const ht = this._readableStream.read();
              return ht === null ? (this._readCapability = new _.PromiseCapability(), this.read()) : (this._loaded += ht.length, (gt = this.onProgress) == null || gt.call(this, {
                loaded: this._loaded
              }), {
                value: new Uint8Array(ht).buffer,
                done: !1
              });
            }
            cancel(ht) {
              if (!this._readableStream) {
                this._error(ht);
                return;
              }
              this._readableStream.destroy(ht);
            }
            _error(ht) {
              this._storedError = ht, this._readCapability.resolve();
            }
            _setReadableStream(ht) {
              this._readableStream = ht, ht.on("readable", () => {
                this._readCapability.resolve();
              }), ht.on("end", () => {
                ht.destroy(), this._done = !0, this._readCapability.resolve();
              }), ht.on("error", (dt) => {
                this._error(dt);
              }), this._storedError && this._readableStream.destroy(this._storedError);
            }
          }
          function st(ft, ht) {
            return {
              protocol: ft.protocol,
              auth: ft.auth,
              host: ft.hostname,
              port: ft.port,
              path: ft.path,
              method: "GET",
              headers: ht
            };
          }
          class lt extends ot {
            constructor(ht) {
              super(ht);
              const dt = (gt) => {
                if (gt.statusCode === 404) {
                  const vt = new _.MissingPDFException(`Missing PDF "${this._url}".`);
                  this._storedError = vt, this._headersCapability.reject(vt);
                  return;
                }
                this._headersCapability.resolve(), this._setReadableStream(gt);
                const pt = (vt) => this._readableStream.headers[vt.toLowerCase()], {
                  allowRangeRequests: mt,
                  suggestedLength: ct
                } = (0, _e.validateRangeRequestCapabilities)({
                  getResponseHeader: pt,
                  isHttp: ht.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                this._isRangeSupported = mt, this._contentLength = ct || this._contentLength, this._filename = (0, _e.extractFilenameFromHeader)(pt);
              };
              if (this._request = null, this._url.protocol === "http:") {
                const gt = require$$6;
                this._request = gt.request(st(this._url, ht.httpHeaders), dt);
              } else {
                const gt = require$$6;
                this._request = gt.request(st(this._url, ht.httpHeaders), dt);
              }
              this._request.on("error", (gt) => {
                this._storedError = gt, this._headersCapability.reject(gt);
              }), this._request.end();
            }
          }
          class et extends rt {
            constructor(ht, dt, gt) {
              super(ht), this._httpHeaders = {};
              for (const mt in ht.httpHeaders) {
                const ct = ht.httpHeaders[mt];
                ct !== void 0 && (this._httpHeaders[mt] = ct);
              }
              this._httpHeaders.Range = `bytes=${dt}-${gt - 1}`;
              const pt = (mt) => {
                if (mt.statusCode === 404) {
                  const ct = new _.MissingPDFException(`Missing PDF "${this._url}".`);
                  this._storedError = ct;
                  return;
                }
                this._setReadableStream(mt);
              };
              if (this._request = null, this._url.protocol === "http:") {
                const mt = require$$6;
                this._request = mt.request(st(this._url, this._httpHeaders), pt);
              } else {
                const mt = require$$6;
                this._request = mt.request(st(this._url, this._httpHeaders), pt);
              }
              this._request.on("error", (mt) => {
                this._storedError = mt;
              }), this._request.end();
            }
          }
          class it extends ot {
            constructor(ht) {
              super(ht);
              let dt = decodeURIComponent(this._url.path);
              tt.test(this._url.href) && (dt = dt.replace(/^\//, ""));
              const gt = require$$6;
              gt.lstat(dt, (pt, mt) => {
                if (pt) {
                  pt.code === "ENOENT" && (pt = new _.MissingPDFException(`Missing PDF "${dt}".`)), this._storedError = pt, this._headersCapability.reject(pt);
                  return;
                }
                this._contentLength = mt.size, this._setReadableStream(gt.createReadStream(dt)), this._headersCapability.resolve();
              });
            }
          }
          class ut extends rt {
            constructor(ht, dt, gt) {
              super(ht);
              let pt = decodeURIComponent(this._url.path);
              tt.test(this._url.href) && (pt = pt.replace(/^\//, ""));
              const mt = require$$6;
              this._setReadableStream(mt.createReadStream(pt, {
                start: dt,
                end: gt - 1
              }));
            }
          }
        },
        /* 186 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.SVGGraphics = void 0, $(84), $(86), $(87), $(93), $(101), $(102), $(105), $(107), $(109), $(113), $(116), $(123), $(2), $(89), $(187);
          var _ = $(168), _e = $(1);
          const tt = {
            fontStyle: "normal",
            fontWeight: "normal",
            fillColor: "#000000"
          }, nt = "http://www.w3.org/XML/1998/namespace", at = "http://www.w3.org/1999/xlink", ot = ["butt", "round", "square"], rt = ["miter", "round", "bevel"], st = function(mt) {
            let ct = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", vt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            if (URL.createObjectURL && typeof Blob < "u" && !vt)
              return URL.createObjectURL(new Blob([mt], {
                type: ct
              }));
            const At = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            let xt = `data:${ct};base64,`;
            for (let bt = 0, Et = mt.length; bt < Et; bt += 3) {
              const St = mt[bt] & 255, Bt = mt[bt + 1] & 255, Ot = mt[bt + 2] & 255, Pt = St >> 2, wt = (St & 3) << 4 | Bt >> 4, Ct = bt + 1 < Et ? (Bt & 15) << 2 | Ot >> 6 : 64, It = bt + 2 < Et ? Ot & 63 : 64;
              xt += At[Pt] + At[wt] + At[Ct] + At[It];
            }
            return xt;
          }, lt = function() {
            const mt = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), ct = 12, vt = new Int32Array(256);
            for (let Ot = 0; Ot < 256; Ot++) {
              let Pt = Ot;
              for (let wt = 0; wt < 8; wt++)
                Pt = Pt & 1 ? 3988292384 ^ Pt >> 1 & 2147483647 : Pt >> 1 & 2147483647;
              vt[Ot] = Pt;
            }
            function At(Ot, Pt, wt) {
              let Ct = -1;
              for (let It = Pt; It < wt; It++) {
                const yt = (Ct ^ Ot[It]) & 255, Rt = vt[yt];
                Ct = Ct >>> 8 ^ Rt;
              }
              return Ct ^ -1;
            }
            function xt(Ot, Pt, wt, Ct) {
              let It = Ct;
              const yt = Pt.length;
              wt[It] = yt >> 24 & 255, wt[It + 1] = yt >> 16 & 255, wt[It + 2] = yt >> 8 & 255, wt[It + 3] = yt & 255, It += 4, wt[It] = Ot.charCodeAt(0) & 255, wt[It + 1] = Ot.charCodeAt(1) & 255, wt[It + 2] = Ot.charCodeAt(2) & 255, wt[It + 3] = Ot.charCodeAt(3) & 255, It += 4, wt.set(Pt, It), It += Pt.length;
              const Rt = At(wt, Ct + 4, It);
              wt[It] = Rt >> 24 & 255, wt[It + 1] = Rt >> 16 & 255, wt[It + 2] = Rt >> 8 & 255, wt[It + 3] = Rt & 255;
            }
            function bt(Ot, Pt, wt) {
              let Ct = 1, It = 0;
              for (let yt = Pt; yt < wt; ++yt)
                Ct = (Ct + (Ot[yt] & 255)) % 65521, It = (It + Ct) % 65521;
              return It << 16 | Ct;
            }
            function Et(Ot) {
              if (!_e.isNodeJS)
                return St(Ot);
              try {
                const Pt = parseInt(process.versions.node) >= 8 ? Ot : Buffer.from(Ot), wt = require$$6.deflateSync(Pt, {
                  level: 9
                });
                return wt instanceof Uint8Array ? wt : new Uint8Array(wt);
              } catch (Pt) {
                (0, _e.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + Pt);
              }
              return St(Ot);
            }
            function St(Ot) {
              let Pt = Ot.length;
              const wt = 65535, Ct = Math.ceil(Pt / wt), It = new Uint8Array(2 + Pt + Ct * 5 + 4);
              let yt = 0;
              It[yt++] = 120, It[yt++] = 156;
              let Rt = 0;
              for (; Pt > wt; )
                It[yt++] = 0, It[yt++] = 255, It[yt++] = 255, It[yt++] = 0, It[yt++] = 0, It.set(Ot.subarray(Rt, Rt + wt), yt), yt += wt, Rt += wt, Pt -= wt;
              It[yt++] = 1, It[yt++] = Pt & 255, It[yt++] = Pt >> 8 & 255, It[yt++] = ~Pt & 65535 & 255, It[yt++] = (~Pt & 65535) >> 8 & 255, It.set(Ot.subarray(Rt), yt), yt += Ot.length - Rt;
              const kt = bt(Ot, 0, Ot.length);
              return It[yt++] = kt >> 24 & 255, It[yt++] = kt >> 16 & 255, It[yt++] = kt >> 8 & 255, It[yt++] = kt & 255, It;
            }
            function Bt(Ot, Pt, wt, Ct) {
              const It = Ot.width, yt = Ot.height;
              let Rt, kt, jt;
              const Ht = Ot.data;
              switch (Pt) {
                case _e.ImageKind.GRAYSCALE_1BPP:
                  kt = 0, Rt = 1, jt = It + 7 >> 3;
                  break;
                case _e.ImageKind.RGB_24BPP:
                  kt = 2, Rt = 8, jt = It * 3;
                  break;
                case _e.ImageKind.RGBA_32BPP:
                  kt = 6, Rt = 8, jt = It * 4;
                  break;
                default:
                  throw new Error("invalid format");
              }
              const Ft = new Uint8Array((1 + jt) * yt);
              let _t = 0, Nt = 0;
              for (let Ut = 0; Ut < yt; ++Ut)
                Ft[_t++] = 0, Ft.set(Ht.subarray(Nt, Nt + jt), _t), Nt += jt, _t += jt;
              if (Pt === _e.ImageKind.GRAYSCALE_1BPP && Ct) {
                _t = 0;
                for (let Ut = 0; Ut < yt; Ut++) {
                  _t++;
                  for (let Vt = 0; Vt < jt; Vt++)
                    Ft[_t++] ^= 255;
                }
              }
              const Mt = new Uint8Array([It >> 24 & 255, It >> 16 & 255, It >> 8 & 255, It & 255, yt >> 24 & 255, yt >> 16 & 255, yt >> 8 & 255, yt & 255, Rt, kt, 0, 0, 0]), Lt = Et(Ft), $t = mt.length + ct * 3 + Mt.length + Lt.length, Tt = new Uint8Array($t);
              let Dt = 0;
              return Tt.set(mt, Dt), Dt += mt.length, xt("IHDR", Mt, Tt, Dt), Dt += ct + Mt.length, xt("IDATA", Lt, Tt, Dt), Dt += ct + Lt.length, xt("IEND", new Uint8Array(0), Tt, Dt), st(Tt, "image/png", wt);
            }
            return function(Pt, wt, Ct) {
              const It = Pt.kind === void 0 ? _e.ImageKind.GRAYSCALE_1BPP : Pt.kind;
              return Bt(Pt, It, wt, Ct);
            };
          }();
          class et {
            constructor() {
              this.fontSizeScale = 1, this.fontWeight = tt.fontWeight, this.fontSize = 0, this.textMatrix = _e.IDENTITY_MATRIX, this.fontMatrix = _e.FONT_IDENTITY_MATRIX, this.leading = 0, this.textRenderingMode = _e.TextRenderingMode.FILL, this.textMatrixScale = 1, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRise = 0, this.fillColor = tt.fillColor, this.strokeColor = "#000000", this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.lineJoin = "", this.lineCap = "", this.miterLimit = 0, this.dashArray = [], this.dashPhase = 0, this.dependencies = [], this.activeClipUrl = null, this.clipGroup = null, this.maskId = "";
            }
            clone() {
              return Object.create(this);
            }
            setCurrentPoint(ct, vt) {
              this.x = ct, this.y = vt;
            }
          }
          function it(mt) {
            let ct = [];
            const vt = [];
            for (const At of mt) {
              if (At.fn === "save") {
                ct.push({
                  fnId: 92,
                  fn: "group",
                  items: []
                }), vt.push(ct), ct = ct.at(-1).items;
                continue;
              }
              At.fn === "restore" ? ct = vt.pop() : ct.push(At);
            }
            return ct;
          }
          function ut(mt) {
            if (Number.isInteger(mt))
              return mt.toString();
            const ct = mt.toFixed(10);
            let vt = ct.length - 1;
            if (ct[vt] !== "0")
              return ct;
            do
              vt--;
            while (ct[vt] === "0");
            return ct.substring(0, ct[vt] === "." ? vt : vt + 1);
          }
          function ft(mt) {
            if (mt[4] === 0 && mt[5] === 0) {
              if (mt[1] === 0 && mt[2] === 0)
                return mt[0] === 1 && mt[3] === 1 ? "" : `scale(${ut(mt[0])} ${ut(mt[3])})`;
              if (mt[0] === mt[3] && mt[1] === -mt[2]) {
                const ct = Math.acos(mt[0]) * 180 / Math.PI;
                return `rotate(${ut(ct)})`;
              }
            } else if (mt[0] === 1 && mt[1] === 0 && mt[2] === 0 && mt[3] === 1)
              return `translate(${ut(mt[4])} ${ut(mt[5])})`;
            return `matrix(${ut(mt[0])} ${ut(mt[1])} ${ut(mt[2])} ${ut(mt[3])} ${ut(mt[4])} ${ut(mt[5])})`;
          }
          let ht = 0, dt = 0, gt = 0;
          class pt {
            constructor(ct, vt) {
              let At = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
              (0, _.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future."), this.svgFactory = new _.DOMSVGFactory(), this.current = new et(), this.transformMatrix = _e.IDENTITY_MATRIX, this.transformStack = [], this.extraStack = [], this.commonObjs = ct, this.objs = vt, this.pendingClip = null, this.pendingEOFill = !1, this.embedFonts = !1, this.embeddedFonts = /* @__PURE__ */ Object.create(null), this.cssStyle = null, this.forceDataSchema = !!At, this._operatorIdMapping = [];
              for (const xt in _e.OPS)
                this._operatorIdMapping[_e.OPS[xt]] = xt;
            }
            getObject(ct) {
              let vt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              return typeof ct == "string" ? ct.startsWith("g_") ? this.commonObjs.get(ct) : this.objs.get(ct) : vt;
            }
            save() {
              this.transformStack.push(this.transformMatrix);
              const ct = this.current;
              this.extraStack.push(ct), this.current = ct.clone();
            }
            restore() {
              this.transformMatrix = this.transformStack.pop(), this.current = this.extraStack.pop(), this.pendingClip = null, this.tgrp = null;
            }
            group(ct) {
              this.save(), this.executeOpTree(ct), this.restore();
            }
            loadDependencies(ct) {
              const vt = ct.fnArray, At = ct.argsArray;
              for (let xt = 0, bt = vt.length; xt < bt; xt++)
                if (vt[xt] === _e.OPS.dependency)
                  for (const Et of At[xt]) {
                    const St = Et.startsWith("g_") ? this.commonObjs : this.objs, Bt = new Promise((Ot) => {
                      St.get(Et, Ot);
                    });
                    this.current.dependencies.push(Bt);
                  }
              return Promise.all(this.current.dependencies);
            }
            transform(ct, vt, At, xt, bt, Et) {
              const St = [ct, vt, At, xt, bt, Et];
              this.transformMatrix = _e.Util.transform(this.transformMatrix, St), this.tgrp = null;
            }
            getSVG(ct, vt) {
              this.viewport = vt;
              const At = this._initialize(vt);
              return this.loadDependencies(ct).then(() => (this.transformMatrix = _e.IDENTITY_MATRIX, this.executeOpTree(this.convertOpList(ct)), At));
            }
            convertOpList(ct) {
              const vt = this._operatorIdMapping, At = ct.argsArray, xt = ct.fnArray, bt = [];
              for (let Et = 0, St = xt.length; Et < St; Et++) {
                const Bt = xt[Et];
                bt.push({
                  fnId: Bt,
                  fn: vt[Bt],
                  args: At[Et]
                });
              }
              return it(bt);
            }
            executeOpTree(ct) {
              for (const vt of ct) {
                const At = vt.fn, xt = vt.fnId, bt = vt.args;
                switch (xt | 0) {
                  case _e.OPS.beginText:
                    this.beginText();
                    break;
                  case _e.OPS.dependency:
                    break;
                  case _e.OPS.setLeading:
                    this.setLeading(bt);
                    break;
                  case _e.OPS.setLeadingMoveText:
                    this.setLeadingMoveText(bt[0], bt[1]);
                    break;
                  case _e.OPS.setFont:
                    this.setFont(bt);
                    break;
                  case _e.OPS.showText:
                    this.showText(bt[0]);
                    break;
                  case _e.OPS.showSpacedText:
                    this.showText(bt[0]);
                    break;
                  case _e.OPS.endText:
                    this.endText();
                    break;
                  case _e.OPS.moveText:
                    this.moveText(bt[0], bt[1]);
                    break;
                  case _e.OPS.setCharSpacing:
                    this.setCharSpacing(bt[0]);
                    break;
                  case _e.OPS.setWordSpacing:
                    this.setWordSpacing(bt[0]);
                    break;
                  case _e.OPS.setHScale:
                    this.setHScale(bt[0]);
                    break;
                  case _e.OPS.setTextMatrix:
                    this.setTextMatrix(bt[0], bt[1], bt[2], bt[3], bt[4], bt[5]);
                    break;
                  case _e.OPS.setTextRise:
                    this.setTextRise(bt[0]);
                    break;
                  case _e.OPS.setTextRenderingMode:
                    this.setTextRenderingMode(bt[0]);
                    break;
                  case _e.OPS.setLineWidth:
                    this.setLineWidth(bt[0]);
                    break;
                  case _e.OPS.setLineJoin:
                    this.setLineJoin(bt[0]);
                    break;
                  case _e.OPS.setLineCap:
                    this.setLineCap(bt[0]);
                    break;
                  case _e.OPS.setMiterLimit:
                    this.setMiterLimit(bt[0]);
                    break;
                  case _e.OPS.setFillRGBColor:
                    this.setFillRGBColor(bt[0], bt[1], bt[2]);
                    break;
                  case _e.OPS.setStrokeRGBColor:
                    this.setStrokeRGBColor(bt[0], bt[1], bt[2]);
                    break;
                  case _e.OPS.setStrokeColorN:
                    this.setStrokeColorN(bt);
                    break;
                  case _e.OPS.setFillColorN:
                    this.setFillColorN(bt);
                    break;
                  case _e.OPS.shadingFill:
                    this.shadingFill(bt[0]);
                    break;
                  case _e.OPS.setDash:
                    this.setDash(bt[0], bt[1]);
                    break;
                  case _e.OPS.setRenderingIntent:
                    this.setRenderingIntent(bt[0]);
                    break;
                  case _e.OPS.setFlatness:
                    this.setFlatness(bt[0]);
                    break;
                  case _e.OPS.setGState:
                    this.setGState(bt[0]);
                    break;
                  case _e.OPS.fill:
                    this.fill();
                    break;
                  case _e.OPS.eoFill:
                    this.eoFill();
                    break;
                  case _e.OPS.stroke:
                    this.stroke();
                    break;
                  case _e.OPS.fillStroke:
                    this.fillStroke();
                    break;
                  case _e.OPS.eoFillStroke:
                    this.eoFillStroke();
                    break;
                  case _e.OPS.clip:
                    this.clip("nonzero");
                    break;
                  case _e.OPS.eoClip:
                    this.clip("evenodd");
                    break;
                  case _e.OPS.paintSolidColorImageMask:
                    this.paintSolidColorImageMask();
                    break;
                  case _e.OPS.paintImageXObject:
                    this.paintImageXObject(bt[0]);
                    break;
                  case _e.OPS.paintInlineImageXObject:
                    this.paintInlineImageXObject(bt[0]);
                    break;
                  case _e.OPS.paintImageMaskXObject:
                    this.paintImageMaskXObject(bt[0]);
                    break;
                  case _e.OPS.paintFormXObjectBegin:
                    this.paintFormXObjectBegin(bt[0], bt[1]);
                    break;
                  case _e.OPS.paintFormXObjectEnd:
                    this.paintFormXObjectEnd();
                    break;
                  case _e.OPS.closePath:
                    this.closePath();
                    break;
                  case _e.OPS.closeStroke:
                    this.closeStroke();
                    break;
                  case _e.OPS.closeFillStroke:
                    this.closeFillStroke();
                    break;
                  case _e.OPS.closeEOFillStroke:
                    this.closeEOFillStroke();
                    break;
                  case _e.OPS.nextLine:
                    this.nextLine();
                    break;
                  case _e.OPS.transform:
                    this.transform(bt[0], bt[1], bt[2], bt[3], bt[4], bt[5]);
                    break;
                  case _e.OPS.constructPath:
                    this.constructPath(bt[0], bt[1]);
                    break;
                  case _e.OPS.endPath:
                    this.endPath();
                    break;
                  case 92:
                    this.group(vt.items);
                    break;
                  default:
                    (0, _e.warn)(`Unimplemented operator ${At}`);
                    break;
                }
              }
            }
            setWordSpacing(ct) {
              this.current.wordSpacing = ct;
            }
            setCharSpacing(ct) {
              this.current.charSpacing = ct;
            }
            nextLine() {
              this.moveText(0, this.current.leading);
            }
            setTextMatrix(ct, vt, At, xt, bt, Et) {
              const St = this.current;
              St.textMatrix = St.lineMatrix = [ct, vt, At, xt, bt, Et], St.textMatrixScale = Math.hypot(ct, vt), St.x = St.lineX = 0, St.y = St.lineY = 0, St.xcoords = [], St.ycoords = [], St.tspan = this.svgFactory.createElement("svg:tspan"), St.tspan.setAttributeNS(null, "font-family", St.fontFamily), St.tspan.setAttributeNS(null, "font-size", `${ut(St.fontSize)}px`), St.tspan.setAttributeNS(null, "y", ut(-St.y)), St.txtElement = this.svgFactory.createElement("svg:text"), St.txtElement.append(St.tspan);
            }
            beginText() {
              const ct = this.current;
              ct.x = ct.lineX = 0, ct.y = ct.lineY = 0, ct.textMatrix = _e.IDENTITY_MATRIX, ct.lineMatrix = _e.IDENTITY_MATRIX, ct.textMatrixScale = 1, ct.tspan = this.svgFactory.createElement("svg:tspan"), ct.txtElement = this.svgFactory.createElement("svg:text"), ct.txtgrp = this.svgFactory.createElement("svg:g"), ct.xcoords = [], ct.ycoords = [];
            }
            moveText(ct, vt) {
              const At = this.current;
              At.x = At.lineX += ct, At.y = At.lineY += vt, At.xcoords = [], At.ycoords = [], At.tspan = this.svgFactory.createElement("svg:tspan"), At.tspan.setAttributeNS(null, "font-family", At.fontFamily), At.tspan.setAttributeNS(null, "font-size", `${ut(At.fontSize)}px`), At.tspan.setAttributeNS(null, "y", ut(-At.y));
            }
            showText(ct) {
              const vt = this.current, At = vt.font, xt = vt.fontSize;
              if (xt === 0)
                return;
              const bt = vt.fontSizeScale, Et = vt.charSpacing, St = vt.wordSpacing, Bt = vt.fontDirection, Ot = vt.textHScale * Bt, Pt = At.vertical, wt = Pt ? 1 : -1, Ct = At.defaultVMetrics, It = xt * vt.fontMatrix[0];
              let yt = 0;
              for (const jt of ct) {
                if (jt === null) {
                  yt += Bt * St;
                  continue;
                } else if (typeof jt == "number") {
                  yt += wt * jt * xt / 1e3;
                  continue;
                }
                const Ht = (jt.isSpace ? St : 0) + Et, Ft = jt.fontChar;
                let _t, Nt, Mt = jt.width;
                if (Pt) {
                  let $t;
                  const Tt = jt.vmetric || Ct;
                  $t = jt.vmetric ? Tt[1] : Mt * 0.5, $t = -$t * It;
                  const Dt = Tt[2] * It;
                  Mt = Tt ? -Tt[0] : Mt, _t = $t / bt, Nt = (yt + Dt) / bt;
                } else
                  _t = yt / bt, Nt = 0;
                (jt.isInFont || At.missingFile) && (vt.xcoords.push(vt.x + _t), Pt && vt.ycoords.push(-vt.y + Nt), vt.tspan.textContent += Ft);
                const Lt = Pt ? Mt * It - Ht * Bt : Mt * It + Ht * Bt;
                yt += Lt;
              }
              vt.tspan.setAttributeNS(null, "x", vt.xcoords.map(ut).join(" ")), Pt ? vt.tspan.setAttributeNS(null, "y", vt.ycoords.map(ut).join(" ")) : vt.tspan.setAttributeNS(null, "y", ut(-vt.y)), Pt ? vt.y -= yt : vt.x += yt * Ot, vt.tspan.setAttributeNS(null, "font-family", vt.fontFamily), vt.tspan.setAttributeNS(null, "font-size", `${ut(vt.fontSize)}px`), vt.fontStyle !== tt.fontStyle && vt.tspan.setAttributeNS(null, "font-style", vt.fontStyle), vt.fontWeight !== tt.fontWeight && vt.tspan.setAttributeNS(null, "font-weight", vt.fontWeight);
              const Rt = vt.textRenderingMode & _e.TextRenderingMode.FILL_STROKE_MASK;
              if (Rt === _e.TextRenderingMode.FILL || Rt === _e.TextRenderingMode.FILL_STROKE ? (vt.fillColor !== tt.fillColor && vt.tspan.setAttributeNS(null, "fill", vt.fillColor), vt.fillAlpha < 1 && vt.tspan.setAttributeNS(null, "fill-opacity", vt.fillAlpha)) : vt.textRenderingMode === _e.TextRenderingMode.ADD_TO_PATH ? vt.tspan.setAttributeNS(null, "fill", "transparent") : vt.tspan.setAttributeNS(null, "fill", "none"), Rt === _e.TextRenderingMode.STROKE || Rt === _e.TextRenderingMode.FILL_STROKE) {
                const jt = 1 / (vt.textMatrixScale || 1);
                this._setStrokeAttributes(vt.tspan, jt);
              }
              let kt = vt.textMatrix;
              vt.textRise !== 0 && (kt = kt.slice(), kt[5] += vt.textRise), vt.txtElement.setAttributeNS(null, "transform", `${ft(kt)} scale(${ut(Ot)}, -1)`), vt.txtElement.setAttributeNS(nt, "xml:space", "preserve"), vt.txtElement.append(vt.tspan), vt.txtgrp.append(vt.txtElement), this._ensureTransformGroup().append(vt.txtElement);
            }
            setLeadingMoveText(ct, vt) {
              this.setLeading(-vt), this.moveText(ct, vt);
            }
            addFontStyle(ct) {
              if (!ct.data)
                throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
              this.cssStyle || (this.cssStyle = this.svgFactory.createElement("svg:style"), this.cssStyle.setAttributeNS(null, "type", "text/css"), this.defs.append(this.cssStyle));
              const vt = st(ct.data, ct.mimetype, this.forceDataSchema);
              this.cssStyle.textContent += `@font-face { font-family: "${ct.loadedName}"; src: url(${vt}); }
`;
            }
            setFont(ct) {
              const vt = this.current, At = this.commonObjs.get(ct[0]);
              let xt = ct[1];
              vt.font = At, this.embedFonts && !At.missingFile && !this.embeddedFonts[At.loadedName] && (this.addFontStyle(At), this.embeddedFonts[At.loadedName] = At), vt.fontMatrix = At.fontMatrix || _e.FONT_IDENTITY_MATRIX;
              let bt = "normal";
              At.black ? bt = "900" : At.bold && (bt = "bold");
              const Et = At.italic ? "italic" : "normal";
              xt < 0 ? (xt = -xt, vt.fontDirection = -1) : vt.fontDirection = 1, vt.fontSize = xt, vt.fontFamily = At.loadedName, vt.fontWeight = bt, vt.fontStyle = Et, vt.tspan = this.svgFactory.createElement("svg:tspan"), vt.tspan.setAttributeNS(null, "y", ut(-vt.y)), vt.xcoords = [], vt.ycoords = [];
            }
            endText() {
              var vt;
              const ct = this.current;
              ct.textRenderingMode & _e.TextRenderingMode.ADD_TO_PATH_FLAG && ((vt = ct.txtElement) != null && vt.hasChildNodes()) && (ct.element = ct.txtElement, this.clip("nonzero"), this.endPath());
            }
            setLineWidth(ct) {
              ct > 0 && (this.current.lineWidth = ct);
            }
            setLineCap(ct) {
              this.current.lineCap = ot[ct];
            }
            setLineJoin(ct) {
              this.current.lineJoin = rt[ct];
            }
            setMiterLimit(ct) {
              this.current.miterLimit = ct;
            }
            setStrokeAlpha(ct) {
              this.current.strokeAlpha = ct;
            }
            setStrokeRGBColor(ct, vt, At) {
              this.current.strokeColor = _e.Util.makeHexColor(ct, vt, At);
            }
            setFillAlpha(ct) {
              this.current.fillAlpha = ct;
            }
            setFillRGBColor(ct, vt, At) {
              this.current.fillColor = _e.Util.makeHexColor(ct, vt, At), this.current.tspan = this.svgFactory.createElement("svg:tspan"), this.current.xcoords = [], this.current.ycoords = [];
            }
            setStrokeColorN(ct) {
              this.current.strokeColor = this._makeColorN_Pattern(ct);
            }
            setFillColorN(ct) {
              this.current.fillColor = this._makeColorN_Pattern(ct);
            }
            shadingFill(ct) {
              const {
                width: vt,
                height: At
              } = this.viewport, xt = _e.Util.inverseTransform(this.transformMatrix), [bt, Et, St, Bt] = _e.Util.getAxialAlignedBoundingBox([0, 0, vt, At], xt), Ot = this.svgFactory.createElement("svg:rect");
              Ot.setAttributeNS(null, "x", bt), Ot.setAttributeNS(null, "y", Et), Ot.setAttributeNS(null, "width", St - bt), Ot.setAttributeNS(null, "height", Bt - Et), Ot.setAttributeNS(null, "fill", this._makeShadingPattern(ct)), this.current.fillAlpha < 1 && Ot.setAttributeNS(null, "fill-opacity", this.current.fillAlpha), this._ensureTransformGroup().append(Ot);
            }
            _makeColorN_Pattern(ct) {
              return ct[0] === "TilingPattern" ? this._makeTilingPattern(ct) : this._makeShadingPattern(ct);
            }
            _makeTilingPattern(ct) {
              const vt = ct[1], At = ct[2], xt = ct[3] || _e.IDENTITY_MATRIX, [bt, Et, St, Bt] = ct[4], Ot = ct[5], Pt = ct[6], wt = ct[7], Ct = `shading${gt++}`, [It, yt, Rt, kt] = _e.Util.normalizeRect([..._e.Util.applyTransform([bt, Et], xt), ..._e.Util.applyTransform([St, Bt], xt)]), [jt, Ht] = _e.Util.singularValueDecompose2dScale(xt), Ft = Ot * jt, _t = Pt * Ht, Nt = this.svgFactory.createElement("svg:pattern");
              Nt.setAttributeNS(null, "id", Ct), Nt.setAttributeNS(null, "patternUnits", "userSpaceOnUse"), Nt.setAttributeNS(null, "width", Ft), Nt.setAttributeNS(null, "height", _t), Nt.setAttributeNS(null, "x", `${It}`), Nt.setAttributeNS(null, "y", `${yt}`);
              const Mt = this.svg, Lt = this.transformMatrix, $t = this.current.fillColor, Tt = this.current.strokeColor, Dt = this.svgFactory.create(Rt - It, kt - yt);
              if (this.svg = Dt, this.transformMatrix = xt, wt === 2) {
                const Ut = _e.Util.makeHexColor(...vt);
                this.current.fillColor = Ut, this.current.strokeColor = Ut;
              }
              return this.executeOpTree(this.convertOpList(At)), this.svg = Mt, this.transformMatrix = Lt, this.current.fillColor = $t, this.current.strokeColor = Tt, Nt.append(Dt.childNodes[0]), this.defs.append(Nt), `url(#${Ct})`;
            }
            _makeShadingPattern(ct) {
              switch (typeof ct == "string" && (ct = this.objs.get(ct)), ct[0]) {
                case "RadialAxial":
                  const vt = `shading${gt++}`, At = ct[3];
                  let xt;
                  switch (ct[1]) {
                    case "axial":
                      const bt = ct[4], Et = ct[5];
                      xt = this.svgFactory.createElement("svg:linearGradient"), xt.setAttributeNS(null, "id", vt), xt.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), xt.setAttributeNS(null, "x1", bt[0]), xt.setAttributeNS(null, "y1", bt[1]), xt.setAttributeNS(null, "x2", Et[0]), xt.setAttributeNS(null, "y2", Et[1]);
                      break;
                    case "radial":
                      const St = ct[4], Bt = ct[5], Ot = ct[6], Pt = ct[7];
                      xt = this.svgFactory.createElement("svg:radialGradient"), xt.setAttributeNS(null, "id", vt), xt.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), xt.setAttributeNS(null, "cx", Bt[0]), xt.setAttributeNS(null, "cy", Bt[1]), xt.setAttributeNS(null, "r", Pt), xt.setAttributeNS(null, "fx", St[0]), xt.setAttributeNS(null, "fy", St[1]), xt.setAttributeNS(null, "fr", Ot);
                      break;
                    default:
                      throw new Error(`Unknown RadialAxial type: ${ct[1]}`);
                  }
                  for (const bt of At) {
                    const Et = this.svgFactory.createElement("svg:stop");
                    Et.setAttributeNS(null, "offset", bt[0]), Et.setAttributeNS(null, "stop-color", bt[1]), xt.append(Et);
                  }
                  return this.defs.append(xt), `url(#${vt})`;
                case "Mesh":
                  return (0, _e.warn)("Unimplemented pattern Mesh"), null;
                case "Dummy":
                  return "hotpink";
                default:
                  throw new Error(`Unknown IR type: ${ct[0]}`);
              }
            }
            setDash(ct, vt) {
              this.current.dashArray = ct, this.current.dashPhase = vt;
            }
            constructPath(ct, vt) {
              const At = this.current;
              let xt = At.x, bt = At.y, Et = [], St = 0;
              for (const Bt of ct)
                switch (Bt | 0) {
                  case _e.OPS.rectangle:
                    xt = vt[St++], bt = vt[St++];
                    const Ot = vt[St++], Pt = vt[St++], wt = xt + Ot, Ct = bt + Pt;
                    Et.push("M", ut(xt), ut(bt), "L", ut(wt), ut(bt), "L", ut(wt), ut(Ct), "L", ut(xt), ut(Ct), "Z");
                    break;
                  case _e.OPS.moveTo:
                    xt = vt[St++], bt = vt[St++], Et.push("M", ut(xt), ut(bt));
                    break;
                  case _e.OPS.lineTo:
                    xt = vt[St++], bt = vt[St++], Et.push("L", ut(xt), ut(bt));
                    break;
                  case _e.OPS.curveTo:
                    xt = vt[St + 4], bt = vt[St + 5], Et.push("C", ut(vt[St]), ut(vt[St + 1]), ut(vt[St + 2]), ut(vt[St + 3]), ut(xt), ut(bt)), St += 6;
                    break;
                  case _e.OPS.curveTo2:
                    Et.push("C", ut(xt), ut(bt), ut(vt[St]), ut(vt[St + 1]), ut(vt[St + 2]), ut(vt[St + 3])), xt = vt[St + 2], bt = vt[St + 3], St += 4;
                    break;
                  case _e.OPS.curveTo3:
                    xt = vt[St + 2], bt = vt[St + 3], Et.push("C", ut(vt[St]), ut(vt[St + 1]), ut(xt), ut(bt), ut(xt), ut(bt)), St += 4;
                    break;
                  case _e.OPS.closePath:
                    Et.push("Z");
                    break;
                }
              Et = Et.join(" "), At.path && ct.length > 0 && ct[0] !== _e.OPS.rectangle && ct[0] !== _e.OPS.moveTo ? Et = At.path.getAttributeNS(null, "d") + Et : (At.path = this.svgFactory.createElement("svg:path"), this._ensureTransformGroup().append(At.path)), At.path.setAttributeNS(null, "d", Et), At.path.setAttributeNS(null, "fill", "none"), At.element = At.path, At.setCurrentPoint(xt, bt);
            }
            endPath() {
              const ct = this.current;
              if (ct.path = null, !this.pendingClip)
                return;
              if (!ct.element) {
                this.pendingClip = null;
                return;
              }
              const vt = `clippath${ht++}`, At = this.svgFactory.createElement("svg:clipPath");
              At.setAttributeNS(null, "id", vt), At.setAttributeNS(null, "transform", ft(this.transformMatrix));
              const xt = ct.element.cloneNode(!0);
              if (this.pendingClip === "evenodd" ? xt.setAttributeNS(null, "clip-rule", "evenodd") : xt.setAttributeNS(null, "clip-rule", "nonzero"), this.pendingClip = null, At.append(xt), this.defs.append(At), ct.activeClipUrl) {
                ct.clipGroup = null;
                for (const bt of this.extraStack)
                  bt.clipGroup = null;
                At.setAttributeNS(null, "clip-path", ct.activeClipUrl);
              }
              ct.activeClipUrl = `url(#${vt})`, this.tgrp = null;
            }
            clip(ct) {
              this.pendingClip = ct;
            }
            closePath() {
              const ct = this.current;
              if (ct.path) {
                const vt = `${ct.path.getAttributeNS(null, "d")}Z`;
                ct.path.setAttributeNS(null, "d", vt);
              }
            }
            setLeading(ct) {
              this.current.leading = -ct;
            }
            setTextRise(ct) {
              this.current.textRise = ct;
            }
            setTextRenderingMode(ct) {
              this.current.textRenderingMode = ct;
            }
            setHScale(ct) {
              this.current.textHScale = ct / 100;
            }
            setRenderingIntent(ct) {
            }
            setFlatness(ct) {
            }
            setGState(ct) {
              for (const [vt, At] of ct)
                switch (vt) {
                  case "LW":
                    this.setLineWidth(At);
                    break;
                  case "LC":
                    this.setLineCap(At);
                    break;
                  case "LJ":
                    this.setLineJoin(At);
                    break;
                  case "ML":
                    this.setMiterLimit(At);
                    break;
                  case "D":
                    this.setDash(At[0], At[1]);
                    break;
                  case "RI":
                    this.setRenderingIntent(At);
                    break;
                  case "FL":
                    this.setFlatness(At);
                    break;
                  case "Font":
                    this.setFont(At);
                    break;
                  case "CA":
                    this.setStrokeAlpha(At);
                    break;
                  case "ca":
                    this.setFillAlpha(At);
                    break;
                  default:
                    (0, _e.warn)(`Unimplemented graphic state operator ${vt}`);
                    break;
                }
            }
            fill() {
              const ct = this.current;
              ct.element && (ct.element.setAttributeNS(null, "fill", ct.fillColor), ct.element.setAttributeNS(null, "fill-opacity", ct.fillAlpha), this.endPath());
            }
            stroke() {
              const ct = this.current;
              ct.element && (this._setStrokeAttributes(ct.element), ct.element.setAttributeNS(null, "fill", "none"), this.endPath());
            }
            _setStrokeAttributes(ct) {
              let vt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
              const At = this.current;
              let xt = At.dashArray;
              vt !== 1 && xt.length > 0 && (xt = xt.map(function(bt) {
                return vt * bt;
              })), ct.setAttributeNS(null, "stroke", At.strokeColor), ct.setAttributeNS(null, "stroke-opacity", At.strokeAlpha), ct.setAttributeNS(null, "stroke-miterlimit", ut(At.miterLimit)), ct.setAttributeNS(null, "stroke-linecap", At.lineCap), ct.setAttributeNS(null, "stroke-linejoin", At.lineJoin), ct.setAttributeNS(null, "stroke-width", ut(vt * At.lineWidth) + "px"), ct.setAttributeNS(null, "stroke-dasharray", xt.map(ut).join(" ")), ct.setAttributeNS(null, "stroke-dashoffset", ut(vt * At.dashPhase) + "px");
            }
            eoFill() {
              var ct;
              (ct = this.current.element) == null || ct.setAttributeNS(null, "fill-rule", "evenodd"), this.fill();
            }
            fillStroke() {
              this.stroke(), this.fill();
            }
            eoFillStroke() {
              var ct;
              (ct = this.current.element) == null || ct.setAttributeNS(null, "fill-rule", "evenodd"), this.fillStroke();
            }
            closeStroke() {
              this.closePath(), this.stroke();
            }
            closeFillStroke() {
              this.closePath(), this.fillStroke();
            }
            closeEOFillStroke() {
              this.closePath(), this.eoFillStroke();
            }
            paintSolidColorImageMask() {
              const ct = this.svgFactory.createElement("svg:rect");
              ct.setAttributeNS(null, "x", "0"), ct.setAttributeNS(null, "y", "0"), ct.setAttributeNS(null, "width", "1px"), ct.setAttributeNS(null, "height", "1px"), ct.setAttributeNS(null, "fill", this.current.fillColor), this._ensureTransformGroup().append(ct);
            }
            paintImageXObject(ct) {
              const vt = this.getObject(ct);
              if (!vt) {
                (0, _e.warn)(`Dependent image with object ID ${ct} is not ready yet`);
                return;
              }
              this.paintInlineImageXObject(vt);
            }
            paintInlineImageXObject(ct, vt) {
              const At = ct.width, xt = ct.height, bt = lt(ct, this.forceDataSchema, !!vt), Et = this.svgFactory.createElement("svg:rect");
              Et.setAttributeNS(null, "x", "0"), Et.setAttributeNS(null, "y", "0"), Et.setAttributeNS(null, "width", ut(At)), Et.setAttributeNS(null, "height", ut(xt)), this.current.element = Et, this.clip("nonzero");
              const St = this.svgFactory.createElement("svg:image");
              St.setAttributeNS(at, "xlink:href", bt), St.setAttributeNS(null, "x", "0"), St.setAttributeNS(null, "y", ut(-xt)), St.setAttributeNS(null, "width", ut(At) + "px"), St.setAttributeNS(null, "height", ut(xt) + "px"), St.setAttributeNS(null, "transform", `scale(${ut(1 / At)} ${ut(-1 / xt)})`), vt ? vt.append(St) : this._ensureTransformGroup().append(St);
            }
            paintImageMaskXObject(ct) {
              const vt = this.getObject(ct.data, ct);
              if (vt.bitmap) {
                (0, _e.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                return;
              }
              const At = this.current, xt = vt.width, bt = vt.height, Et = At.fillColor;
              At.maskId = `mask${dt++}`;
              const St = this.svgFactory.createElement("svg:mask");
              St.setAttributeNS(null, "id", At.maskId);
              const Bt = this.svgFactory.createElement("svg:rect");
              Bt.setAttributeNS(null, "x", "0"), Bt.setAttributeNS(null, "y", "0"), Bt.setAttributeNS(null, "width", ut(xt)), Bt.setAttributeNS(null, "height", ut(bt)), Bt.setAttributeNS(null, "fill", Et), Bt.setAttributeNS(null, "mask", `url(#${At.maskId})`), this.defs.append(St), this._ensureTransformGroup().append(Bt), this.paintInlineImageXObject(vt, St);
            }
            paintFormXObjectBegin(ct, vt) {
              if (Array.isArray(ct) && ct.length === 6 && this.transform(ct[0], ct[1], ct[2], ct[3], ct[4], ct[5]), vt) {
                const At = vt[2] - vt[0], xt = vt[3] - vt[1], bt = this.svgFactory.createElement("svg:rect");
                bt.setAttributeNS(null, "x", vt[0]), bt.setAttributeNS(null, "y", vt[1]), bt.setAttributeNS(null, "width", ut(At)), bt.setAttributeNS(null, "height", ut(xt)), this.current.element = bt, this.clip("nonzero"), this.endPath();
              }
            }
            paintFormXObjectEnd() {
            }
            _initialize(ct) {
              const vt = this.svgFactory.create(ct.width, ct.height), At = this.svgFactory.createElement("svg:defs");
              vt.append(At), this.defs = At;
              const xt = this.svgFactory.createElement("svg:g");
              return xt.setAttributeNS(null, "transform", ft(ct.transform)), vt.append(xt), this.svg = xt, vt;
            }
            _ensureClipGroup() {
              if (!this.current.clipGroup) {
                const ct = this.svgFactory.createElement("svg:g");
                ct.setAttributeNS(null, "clip-path", this.current.activeClipUrl), this.svg.append(ct), this.current.clipGroup = ct;
              }
              return this.current.clipGroup;
            }
            _ensureTransformGroup() {
              return this.tgrp || (this.tgrp = this.svgFactory.createElement("svg:g"), this.tgrp.setAttributeNS(null, "transform", ft(this.transformMatrix)), this.current.activeClipUrl ? this._ensureClipGroup().append(this.tgrp) : this.svg.append(this.tgrp)), this.tgrp;
            }
          }
          s.SVGGraphics = pt;
        },
        /* 187 */
        /***/
        (a, s, $) => {
          var _ = $(3), _e = $(188), tt = $(193);
          _({
            target: "Array",
            proto: !0
          }, {
            group: function(at) {
              var ot = arguments.length > 1 ? arguments[1] : void 0;
              return _e(this, at, ot);
            }
          }), tt("group");
        },
        /* 188 */
        /***/
        (a, s, $) => {
          var _ = $(99), _e = $(14), tt = $(13), nt = $(40), at = $(18), ot = $(64), rt = $(189), st = $(108), lt = Array, et = _e([].push);
          a.exports = function(it, ut, ft, ht) {
            for (var dt = nt(it), gt = tt(dt), pt = _(ut, ft), mt = rt(null), ct = ot(gt), vt = 0, At, xt, bt; ct > vt; vt++)
              bt = gt[vt], xt = at(pt(bt, vt, dt)), xt in mt ? et(mt[xt], bt) : mt[xt] = [bt];
            if (ht && (At = ht(dt), At !== lt))
              for (xt in mt)
                mt[xt] = st(At, mt[xt]);
            return mt;
          };
        },
        /* 189 */
        /***/
        (a, s, $) => {
          var _ = $(47), _e = $(190), tt = $(66), nt = $(55), at = $(192), ot = $(43), rt = $(54), st = ">", lt = "<", et = "prototype", it = "script", ut = rt("IE_PROTO"), ft = function() {
          }, ht = function(ct) {
            return lt + it + st + ct + lt + "/" + it + st;
          }, dt = function(ct) {
            ct.write(ht("")), ct.close();
            var vt = ct.parentWindow.Object;
            return ct = null, vt;
          }, gt = function() {
            var ct = ot("iframe"), vt = "java" + it + ":", At;
            return ct.style.display = "none", at.appendChild(ct), ct.src = String(vt), At = ct.contentWindow.document, At.open(), At.write(ht("document.F=Object")), At.close(), At.F;
          }, pt, mt = function() {
            try {
              pt = new ActiveXObject("htmlfile");
            } catch {
            }
            mt = typeof document < "u" ? document.domain && pt ? dt(pt) : gt() : dt(pt);
            for (var ct = tt.length; ct--; )
              delete mt[et][tt[ct]];
            return mt();
          };
          nt[ut] = !0, a.exports = Object.create || function(vt, At) {
            var xt;
            return vt !== null ? (ft[et] = _(vt), xt = new ft(), ft[et] = null, xt[ut] = vt) : xt = mt(), At === void 0 ? xt : _e.f(xt, At);
          };
        },
        /* 190 */
        /***/
        (a, s, $) => {
          var _ = $(6), _e = $(46), tt = $(45), nt = $(47), at = $(12), ot = $(191);
          s.f = _ && !_e ? Object.defineProperties : function(st, lt) {
            nt(st);
            for (var et = at(lt), it = ot(lt), ut = it.length, ft = 0, ht; ut > ft; )
              tt.f(st, ht = it[ft++], et[ht]);
            return st;
          };
        },
        /* 191 */
        /***/
        (a, s, $) => {
          var _ = $(59), _e = $(66);
          a.exports = Object.keys || function(nt) {
            return _(nt, _e);
          };
        },
        /* 192 */
        /***/
        (a, s, $) => {
          var _ = $(24);
          a.exports = _("document", "documentElement");
        },
        /* 193 */
        /***/
        (a, s, $) => {
          var _ = $(34), _e = $(189), tt = $(45).f, nt = _("unscopables"), at = Array.prototype;
          at[nt] === void 0 && tt(at, nt, {
            configurable: !0,
            value: _e(null)
          }), a.exports = function(ot) {
            at[nt][ot] = !0;
          };
        },
        /* 194 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.XfaText = void 0, $(89);
          class _ {
            static textContent(tt) {
              const nt = [], at = {
                items: nt,
                styles: /* @__PURE__ */ Object.create(null)
              };
              function ot(rt) {
                var et;
                if (!rt)
                  return;
                let st = null;
                const lt = rt.name;
                if (lt === "#text")
                  st = rt.value;
                else if (_.shouldBuildText(lt))
                  (et = rt == null ? void 0 : rt.attributes) != null && et.textContent ? st = rt.attributes.textContent : rt.value && (st = rt.value);
                else
                  return;
                if (st !== null && nt.push({
                  str: st
                }), !!rt.children)
                  for (const it of rt.children)
                    ot(it);
              }
              return ot(tt), at;
            }
            static shouldBuildText(tt) {
              return !(tt === "textarea" || tt === "input" || tt === "option" || tt === "select");
            }
          }
          s.XfaText = _;
        },
        /* 195 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.TextLayerRenderTask = void 0, s.renderTextLayer = ft, s.updateTextLayer = ht, $(89), $(2);
          var _ = $(1), _e = $(168);
          const tt = 1e5, nt = 30, at = 0.8, ot = /* @__PURE__ */ new Map();
          function rt(dt, gt) {
            let pt;
            if (gt && _.FeatureTest.isOffscreenCanvasSupported)
              pt = new OffscreenCanvas(dt, dt).getContext("2d", {
                alpha: !1
              });
            else {
              const mt = document.createElement("canvas");
              mt.width = mt.height = dt, pt = mt.getContext("2d", {
                alpha: !1
              });
            }
            return pt;
          }
          function st(dt, gt) {
            const pt = ot.get(dt);
            if (pt)
              return pt;
            const mt = rt(nt, gt);
            mt.font = `${nt}px ${dt}`;
            const ct = mt.measureText("");
            let vt = ct.fontBoundingBoxAscent, At = Math.abs(ct.fontBoundingBoxDescent);
            if (vt) {
              const bt = vt / (vt + At);
              return ot.set(dt, bt), mt.canvas.width = mt.canvas.height = 0, bt;
            }
            mt.strokeStyle = "red", mt.clearRect(0, 0, nt, nt), mt.strokeText("g", 0, 0);
            let xt = mt.getImageData(0, 0, nt, nt).data;
            At = 0;
            for (let bt = xt.length - 1 - 3; bt >= 0; bt -= 4)
              if (xt[bt] > 0) {
                At = Math.ceil(bt / 4 / nt);
                break;
              }
            mt.clearRect(0, 0, nt, nt), mt.strokeText("A", 0, nt), xt = mt.getImageData(0, 0, nt, nt).data, vt = 0;
            for (let bt = 0, Et = xt.length; bt < Et; bt += 4)
              if (xt[bt] > 0) {
                vt = nt - Math.floor(bt / 4 / nt);
                break;
              }
            if (mt.canvas.width = mt.canvas.height = 0, vt) {
              const bt = vt / (vt + At);
              return ot.set(dt, bt), bt;
            }
            return ot.set(dt, at), at;
          }
          function lt(dt, gt, pt) {
            const mt = document.createElement("span"), ct = {
              angle: 0,
              canvasWidth: 0,
              hasText: gt.str !== "",
              hasEOL: gt.hasEOL,
              fontSize: 0
            };
            dt._textDivs.push(mt);
            const vt = _.Util.transform(dt._transform, gt.transform);
            let At = Math.atan2(vt[1], vt[0]);
            const xt = pt[gt.fontName];
            xt.vertical && (At += Math.PI / 2);
            const bt = Math.hypot(vt[2], vt[3]), Et = bt * st(xt.fontFamily, dt._isOffscreenCanvasSupported);
            let St, Bt;
            At === 0 ? (St = vt[4], Bt = vt[5] - Et) : (St = vt[4] + Et * Math.sin(At), Bt = vt[5] - Et * Math.cos(At));
            const Ot = "calc(var(--scale-factor)*", Pt = mt.style;
            dt._container === dt._rootContainer ? (Pt.left = `${(100 * St / dt._pageWidth).toFixed(2)}%`, Pt.top = `${(100 * Bt / dt._pageHeight).toFixed(2)}%`) : (Pt.left = `${Ot}${St.toFixed(2)}px)`, Pt.top = `${Ot}${Bt.toFixed(2)}px)`), Pt.fontSize = `${Ot}${bt.toFixed(2)}px)`, Pt.fontFamily = xt.fontFamily, ct.fontSize = bt, mt.setAttribute("role", "presentation"), mt.textContent = gt.str, mt.dir = gt.dir, dt._fontInspectorEnabled && (mt.dataset.fontName = gt.fontName), At !== 0 && (ct.angle = At * (180 / Math.PI));
            let wt = !1;
            if (gt.str.length > 1)
              wt = !0;
            else if (gt.str !== " " && gt.transform[0] !== gt.transform[3]) {
              const Ct = Math.abs(gt.transform[0]), It = Math.abs(gt.transform[3]);
              Ct !== It && Math.max(Ct, It) / Math.min(Ct, It) > 1.5 && (wt = !0);
            }
            wt && (ct.canvasWidth = xt.vertical ? gt.height : gt.width), dt._textDivProperties.set(mt, ct), dt._isReadableStream && dt._layoutText(mt);
          }
          function et(dt) {
            const {
              div: gt,
              scale: pt,
              properties: mt,
              ctx: ct,
              prevFontSize: vt,
              prevFontFamily: At
            } = dt, {
              style: xt
            } = gt;
            let bt = "";
            if (mt.canvasWidth !== 0 && mt.hasText) {
              const {
                fontFamily: Et
              } = xt, {
                canvasWidth: St,
                fontSize: Bt
              } = mt;
              (vt !== Bt || At !== Et) && (ct.font = `${Bt * pt}px ${Et}`, dt.prevFontSize = Bt, dt.prevFontFamily = Et);
              const {
                width: Ot
              } = ct.measureText(gt.textContent);
              Ot > 0 && (bt = `scaleX(${St * pt / Ot})`);
            }
            mt.angle !== 0 && (bt = `rotate(${mt.angle}deg) ${bt}`), bt.length > 0 && (xt.transform = bt);
          }
          function it(dt) {
            if (dt._canceled)
              return;
            const gt = dt._textDivs, pt = dt._capability;
            if (gt.length > tt) {
              pt.resolve();
              return;
            }
            if (!dt._isReadableStream)
              for (const ct of gt)
                dt._layoutText(ct);
            pt.resolve();
          }
          class ut {
            constructor(gt) {
              var Pt;
              let {
                textContentSource: pt,
                container: mt,
                viewport: ct,
                textDivs: vt,
                textDivProperties: At,
                textContentItemsStr: xt,
                isOffscreenCanvasSupported: bt
              } = gt;
              this._textContentSource = pt, this._isReadableStream = pt instanceof ReadableStream, this._container = this._rootContainer = mt, this._textDivs = vt || [], this._textContentItemsStr = xt || [], this._isOffscreenCanvasSupported = bt, this._fontInspectorEnabled = !!((Pt = globalThis.FontInspector) != null && Pt.enabled), this._reader = null, this._textDivProperties = At || /* @__PURE__ */ new WeakMap(), this._canceled = !1, this._capability = new _.PromiseCapability(), this._layoutTextParams = {
                prevFontSize: null,
                prevFontFamily: null,
                div: null,
                scale: ct.scale * (globalThis.devicePixelRatio || 1),
                properties: null,
                ctx: rt(0, bt)
              };
              const {
                pageWidth: Et,
                pageHeight: St,
                pageX: Bt,
                pageY: Ot
              } = ct.rawDims;
              this._transform = [1, 0, 0, -1, -Bt, Ot + St], this._pageWidth = Et, this._pageHeight = St, (0, _e.setLayerDimensions)(mt, ct), this._capability.promise.finally(() => {
                this._layoutTextParams = null;
              }).catch(() => {
              });
            }
            get promise() {
              return this._capability.promise;
            }
            cancel() {
              this._canceled = !0, this._reader && (this._reader.cancel(new _.AbortException("TextLayer task cancelled.")).catch(() => {
              }), this._reader = null), this._capability.reject(new _.AbortException("TextLayer task cancelled."));
            }
            _processItems(gt, pt) {
              for (const mt of gt) {
                if (mt.str === void 0) {
                  if (mt.type === "beginMarkedContentProps" || mt.type === "beginMarkedContent") {
                    const ct = this._container;
                    this._container = document.createElement("span"), this._container.classList.add("markedContent"), mt.id !== null && this._container.setAttribute("id", `${mt.id}`), ct.append(this._container);
                  } else
                    mt.type === "endMarkedContent" && (this._container = this._container.parentNode);
                  continue;
                }
                this._textContentItemsStr.push(mt.str), lt(this, mt, pt);
              }
            }
            _layoutText(gt) {
              const pt = this._layoutTextParams.properties = this._textDivProperties.get(gt);
              if (this._layoutTextParams.div = gt, et(this._layoutTextParams), pt.hasText && this._container.append(gt), pt.hasEOL) {
                const mt = document.createElement("br");
                mt.setAttribute("role", "presentation"), this._container.append(mt);
              }
            }
            _render() {
              const gt = new _.PromiseCapability();
              let pt = /* @__PURE__ */ Object.create(null);
              if (this._isReadableStream) {
                const mt = () => {
                  this._reader.read().then((ct) => {
                    let {
                      value: vt,
                      done: At
                    } = ct;
                    if (At) {
                      gt.resolve();
                      return;
                    }
                    Object.assign(pt, vt.styles), this._processItems(vt.items, pt), mt();
                  }, gt.reject);
                };
                this._reader = this._textContentSource.getReader(), mt();
              } else if (this._textContentSource) {
                const {
                  items: mt,
                  styles: ct
                } = this._textContentSource;
                this._processItems(mt, ct), gt.resolve();
              } else
                throw new Error('No "textContentSource" parameter specified.');
              gt.promise.then(() => {
                pt = null, it(this);
              }, this._capability.reject);
            }
          }
          s.TextLayerRenderTask = ut;
          function ft(dt) {
            !dt.textContentSource && (dt.textContent || dt.textContentStream) && ((0, _e.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead."), dt.textContentSource = dt.textContent || dt.textContentStream);
            const {
              container: gt,
              viewport: pt
            } = dt, mt = getComputedStyle(gt), ct = mt.getPropertyValue("visibility"), vt = parseFloat(mt.getPropertyValue("--scale-factor"));
            ct === "visible" && (!vt || Math.abs(vt - pt.scale) > 1e-5) && console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
            const At = new ut(dt);
            return At._render(), At;
          }
          function ht(dt) {
            let {
              container: gt,
              viewport: pt,
              textDivs: mt,
              textDivProperties: ct,
              isOffscreenCanvasSupported: vt,
              mustRotate: At = !0,
              mustRescale: xt = !0
            } = dt;
            if (At && (0, _e.setLayerDimensions)(gt, {
              rotation: pt.rotation
            }), xt) {
              const bt = rt(0, vt), St = {
                prevFontSize: null,
                prevFontFamily: null,
                div: null,
                scale: pt.scale * (globalThis.devicePixelRatio || 1),
                properties: null,
                ctx: bt
              };
              for (const Bt of mt)
                St.properties = ct.get(Bt), St.div = Bt, et(St);
            }
          }
        },
        /* 196 */
        /***/
        (a, s, $) => {
          var st, lt, et, it, ut, ft, ht, dt, gt, pt, mt, Ys, vt, ds, xt, Ks, Et, Xs;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.AnnotationEditorLayer = void 0, $(125), $(136), $(138), $(141), $(143), $(145), $(147);
          var _ = $(1), _e = $(164), tt = $(197), nt = $(202), at = $(168), ot = $(203);
          const Bt = class Bt {
            constructor(Pt) {
              _r(this, mt);
              _r(this, vt);
              _r(this, xt);
              _r(this, Et);
              _r(this, st, void 0);
              _r(this, lt, !1);
              _r(this, et, null);
              _r(this, it, this.pointerup.bind(this));
              _r(this, ut, this.pointerdown.bind(this));
              _r(this, ft, /* @__PURE__ */ new Map());
              _r(this, ht, !1);
              _r(this, dt, !1);
              _r(this, gt, !1);
              _r(this, pt, void 0);
              let {
                uiManager: wt,
                pageIndex: Ct,
                div: It,
                accessibilityManager: yt,
                annotationLayer: Rt,
                viewport: kt,
                l10n: jt
              } = Pt;
              const Ht = [tt.FreeTextEditor, nt.InkEditor, ot.StampEditor];
              if (!Bt._initialized) {
                Bt._initialized = !0;
                for (const Ft of Ht)
                  Ft.initialize(jt);
              }
              wt.registerEditorTypes(Ht), tn(this, pt, wt), this.pageIndex = Ct, this.div = It, tn(this, st, yt), tn(this, et, Rt), this.viewport = kt, mr(this, pt).addLayer(this);
            }
            get isEmpty() {
              return mr(this, ft).size === 0;
            }
            updateToolbar(Pt) {
              mr(this, pt).updateToolbar(Pt);
            }
            updateMode() {
              let Pt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : mr(this, pt).getMode();
              Ur(this, Et, Xs).call(this), Pt === _.AnnotationEditorType.INK ? (this.addInkEditorIfNeeded(!1), this.disableClick()) : this.enableClick(), Pt !== _.AnnotationEditorType.NONE && (this.div.classList.toggle("freeTextEditing", Pt === _.AnnotationEditorType.FREETEXT), this.div.classList.toggle("inkEditing", Pt === _.AnnotationEditorType.INK), this.div.classList.toggle("stampEditing", Pt === _.AnnotationEditorType.STAMP), this.div.hidden = !1);
            }
            addInkEditorIfNeeded(Pt) {
              if (!Pt && mr(this, pt).getMode() !== _.AnnotationEditorType.INK)
                return;
              if (!Pt) {
                for (const Ct of mr(this, ft).values())
                  if (Ct.isEmpty()) {
                    Ct.setInBackground();
                    return;
                  }
              }
              Ur(this, vt, ds).call(this, {
                offsetX: 0,
                offsetY: 0
              }, !1).setInBackground();
            }
            setEditingState(Pt) {
              mr(this, pt).setEditingState(Pt);
            }
            addCommands(Pt) {
              mr(this, pt).addCommands(Pt);
            }
            enable() {
              this.div.style.pointerEvents = "auto";
              const Pt = /* @__PURE__ */ new Set();
              for (const Ct of mr(this, ft).values())
                Ct.enableEditing(), Ct.annotationElementId && Pt.add(Ct.annotationElementId);
              if (!mr(this, et))
                return;
              const wt = mr(this, et).getEditableAnnotations();
              for (const Ct of wt) {
                if (Ct.hide(), mr(this, pt).isDeletedAnnotationElement(Ct.data.id) || Pt.has(Ct.data.id))
                  continue;
                const It = this.deserialize(Ct);
                It && (this.addOrRebuild(It), It.enableEditing());
              }
            }
            disable() {
              var wt;
              tn(this, gt, !0), this.div.style.pointerEvents = "none";
              const Pt = /* @__PURE__ */ new Set();
              for (const Ct of mr(this, ft).values()) {
                if (Ct.disableEditing(), !Ct.annotationElementId || Ct.serialize() !== null) {
                  Pt.add(Ct.annotationElementId);
                  continue;
                }
                (wt = this.getEditableAnnotation(Ct.annotationElementId)) == null || wt.show(), Ct.remove();
              }
              if (mr(this, et)) {
                const Ct = mr(this, et).getEditableAnnotations();
                for (const It of Ct) {
                  const {
                    id: yt
                  } = It.data;
                  Pt.has(yt) || mr(this, pt).isDeletedAnnotationElement(yt) || It.show();
                }
              }
              Ur(this, Et, Xs).call(this), this.isEmpty && (this.div.hidden = !0), tn(this, gt, !1);
            }
            getEditableAnnotation(Pt) {
              var wt;
              return ((wt = mr(this, et)) == null ? void 0 : wt.getEditableAnnotation(Pt)) || null;
            }
            setActiveEditor(Pt) {
              mr(this, pt).getActive() !== Pt && mr(this, pt).setActiveEditor(Pt);
            }
            enableClick() {
              this.div.addEventListener("pointerdown", mr(this, ut)), this.div.addEventListener("pointerup", mr(this, it));
            }
            disableClick() {
              this.div.removeEventListener("pointerdown", mr(this, ut)), this.div.removeEventListener("pointerup", mr(this, it));
            }
            attach(Pt) {
              mr(this, ft).set(Pt.id, Pt);
              const {
                annotationElementId: wt
              } = Pt;
              wt && mr(this, pt).isDeletedAnnotationElement(wt) && mr(this, pt).removeDeletedAnnotationElement(Pt);
            }
            detach(Pt) {
              var wt;
              mr(this, ft).delete(Pt.id), (wt = mr(this, st)) == null || wt.removePointerInTextLayer(Pt.contentDiv), !mr(this, gt) && Pt.annotationElementId && mr(this, pt).addDeletedAnnotationElement(Pt);
            }
            remove(Pt) {
              this.detach(Pt), mr(this, pt).removeEditor(Pt), Pt.div.contains(document.activeElement) && setTimeout(() => {
                mr(this, pt).focusMainContainer();
              }, 0), Pt.div.remove(), Pt.isAttachedToDOM = !1, mr(this, dt) || this.addInkEditorIfNeeded(!1);
            }
            changeParent(Pt) {
              var wt;
              Pt.parent !== this && (Pt.annotationElementId && (mr(this, pt).addDeletedAnnotationElement(Pt.annotationElementId), _e.AnnotationEditor.deleteAnnotationElement(Pt), Pt.annotationElementId = null), this.attach(Pt), (wt = Pt.parent) == null || wt.detach(Pt), Pt.setParent(this), Pt.div && Pt.isAttachedToDOM && (Pt.div.remove(), this.div.append(Pt.div)));
            }
            add(Pt) {
              if (this.changeParent(Pt), mr(this, pt).addEditor(Pt), this.attach(Pt), !Pt.isAttachedToDOM) {
                const wt = Pt.render();
                this.div.append(wt), Pt.isAttachedToDOM = !0;
              }
              Pt.fixAndSetPosition(), Pt.onceAdded(), mr(this, pt).addToAnnotationStorage(Pt);
            }
            moveEditorInDOM(Pt) {
              var Ct;
              if (!Pt.isAttachedToDOM)
                return;
              const {
                activeElement: wt
              } = document;
              Pt.div.contains(wt) && (Pt._focusEventsAllowed = !1, setTimeout(() => {
                Pt.div.contains(document.activeElement) ? Pt._focusEventsAllowed = !0 : (Pt.div.addEventListener("focusin", () => {
                  Pt._focusEventsAllowed = !0;
                }, {
                  once: !0
                }), wt.focus());
              }, 0)), Pt._structTreeParentId = (Ct = mr(this, st)) == null ? void 0 : Ct.moveElementInDOM(this.div, Pt.div, Pt.contentDiv, !0);
            }
            addOrRebuild(Pt) {
              Pt.needsToBeRebuilt() ? Pt.rebuild() : this.add(Pt);
            }
            addUndoableEditor(Pt) {
              const wt = () => Pt._uiManager.rebuild(Pt), Ct = () => {
                Pt.remove();
              };
              this.addCommands({
                cmd: wt,
                undo: Ct,
                mustExec: !1
              });
            }
            getNextId() {
              return mr(this, pt).getId();
            }
            pasteEditor(Pt, wt) {
              mr(this, pt).updateToolbar(Pt), mr(this, pt).updateMode(Pt);
              const {
                offsetX: Ct,
                offsetY: It
              } = Ur(this, xt, Ks).call(this), yt = this.getNextId(), Rt = Ur(this, mt, Ys).call(this, {
                parent: this,
                id: yt,
                x: Ct,
                y: It,
                uiManager: mr(this, pt),
                isCentered: !0,
                ...wt
              });
              Rt && this.add(Rt);
            }
            deserialize(Pt) {
              switch (Pt.annotationType ?? Pt.annotationEditorType) {
                case _.AnnotationEditorType.FREETEXT:
                  return tt.FreeTextEditor.deserialize(Pt, this, mr(this, pt));
                case _.AnnotationEditorType.INK:
                  return nt.InkEditor.deserialize(Pt, this, mr(this, pt));
                case _.AnnotationEditorType.STAMP:
                  return ot.StampEditor.deserialize(Pt, this, mr(this, pt));
              }
              return null;
            }
            addNewEditor() {
              Ur(this, vt, ds).call(this, Ur(this, xt, Ks).call(this), !0);
            }
            setSelected(Pt) {
              mr(this, pt).setSelected(Pt);
            }
            toggleSelected(Pt) {
              mr(this, pt).toggleSelected(Pt);
            }
            isSelected(Pt) {
              return mr(this, pt).isSelected(Pt);
            }
            unselect(Pt) {
              mr(this, pt).unselect(Pt);
            }
            pointerup(Pt) {
              const {
                isMac: wt
              } = _.FeatureTest.platform;
              if (!(Pt.button !== 0 || Pt.ctrlKey && wt) && Pt.target === this.div && mr(this, ht)) {
                if (tn(this, ht, !1), !mr(this, lt)) {
                  tn(this, lt, !0);
                  return;
                }
                if (mr(this, pt).getMode() === _.AnnotationEditorType.STAMP) {
                  mr(this, pt).unselectAll();
                  return;
                }
                Ur(this, vt, ds).call(this, Pt, !1);
              }
            }
            pointerdown(Pt) {
              if (mr(this, ht)) {
                tn(this, ht, !1);
                return;
              }
              const {
                isMac: wt
              } = _.FeatureTest.platform;
              if (Pt.button !== 0 || Pt.ctrlKey && wt || Pt.target !== this.div)
                return;
              tn(this, ht, !0);
              const Ct = mr(this, pt).getActive();
              tn(this, lt, !Ct || Ct.isEmpty());
            }
            findNewParent(Pt, wt, Ct) {
              const It = mr(this, pt).findParent(wt, Ct);
              return It === null || It === this ? !1 : (It.changeParent(Pt), !0);
            }
            destroy() {
              var Pt, wt;
              ((Pt = mr(this, pt).getActive()) == null ? void 0 : Pt.parent) === this && (mr(this, pt).commitOrRemove(), mr(this, pt).setActiveEditor(null));
              for (const Ct of mr(this, ft).values())
                (wt = mr(this, st)) == null || wt.removePointerInTextLayer(Ct.contentDiv), Ct.setParent(null), Ct.isAttachedToDOM = !1, Ct.div.remove();
              this.div = null, mr(this, ft).clear(), mr(this, pt).removeLayer(this);
            }
            render(Pt) {
              let {
                viewport: wt
              } = Pt;
              this.viewport = wt, (0, at.setLayerDimensions)(this.div, wt);
              for (const Ct of mr(this, pt).getEditors(this.pageIndex))
                this.add(Ct);
              this.updateMode();
            }
            update(Pt) {
              let {
                viewport: wt
              } = Pt;
              mr(this, pt).commitOrRemove(), this.viewport = wt, (0, at.setLayerDimensions)(this.div, {
                rotation: wt.rotation
              }), this.updateMode();
            }
            get pageDimensions() {
              const {
                pageWidth: Pt,
                pageHeight: wt
              } = this.viewport.rawDims;
              return [Pt, wt];
            }
          };
          st = new WeakMap(), lt = new WeakMap(), et = new WeakMap(), it = new WeakMap(), ut = new WeakMap(), ft = new WeakMap(), ht = new WeakMap(), dt = new WeakMap(), gt = new WeakMap(), pt = new WeakMap(), mt = new WeakSet(), Ys = function(Pt) {
            switch (mr(this, pt).getMode()) {
              case _.AnnotationEditorType.FREETEXT:
                return new tt.FreeTextEditor(Pt);
              case _.AnnotationEditorType.INK:
                return new nt.InkEditor(Pt);
              case _.AnnotationEditorType.STAMP:
                return new ot.StampEditor(Pt);
            }
            return null;
          }, vt = new WeakSet(), ds = function(Pt, wt) {
            const Ct = this.getNextId(), It = Ur(this, mt, Ys).call(this, {
              parent: this,
              id: Ct,
              x: Pt.offsetX,
              y: Pt.offsetY,
              uiManager: mr(this, pt),
              isCentered: wt
            });
            return It && this.add(It), It;
          }, xt = new WeakSet(), Ks = function() {
            const {
              x: Pt,
              y: wt,
              width: Ct,
              height: It
            } = this.div.getBoundingClientRect(), yt = Math.max(0, Pt), Rt = Math.max(0, wt), kt = Math.min(window.innerWidth, Pt + Ct), jt = Math.min(window.innerHeight, wt + It), Ht = (yt + kt) / 2 - Pt, Ft = (Rt + jt) / 2 - wt, [_t, Nt] = this.viewport.rotation % 180 === 0 ? [Ht, Ft] : [Ft, Ht];
            return {
              offsetX: _t,
              offsetY: Nt
            };
          }, Et = new WeakSet(), Xs = function() {
            tn(this, dt, !0);
            for (const Pt of mr(this, ft).values())
              Pt.isEmpty() && Pt.remove();
            tn(this, dt, !1);
          }, Ln(Bt, "_initialized", !1);
          let rt = Bt;
          s.AnnotationEditorLayer = rt;
        },
        /* 197 */
        /***/
        (a, s, $) => {
          var ot, rt, st, lt, et, it, ut, ft, ht, dt, _l, pt, jl, ct, Ul, At, Ko, bt, Zs, St, Hl, Ot, qs;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.FreeTextEditor = void 0, $(89);
          var _ = $(1), _e = $(165), tt = $(164), nt = $(198);
          const wt = class wt extends tt.AnnotationEditor {
            constructor(yt) {
              super({
                ...yt,
                name: "freeTextEditor"
              });
              _r(this, dt);
              _r(this, pt);
              _r(this, ct);
              _r(this, At);
              _r(this, bt);
              _r(this, St);
              _r(this, Ot);
              _r(this, ot, this.editorDivBlur.bind(this));
              _r(this, rt, this.editorDivFocus.bind(this));
              _r(this, st, this.editorDivInput.bind(this));
              _r(this, lt, this.editorDivKeydown.bind(this));
              _r(this, et, void 0);
              _r(this, it, "");
              _r(this, ut, `${this.id}-editor`);
              _r(this, ft, void 0);
              _r(this, ht, null);
              tn(this, et, yt.color || wt._defaultColor || tt.AnnotationEditor._defaultLineColor), tn(this, ft, yt.fontSize || wt._defaultFontSize);
            }
            static get _keyboardManager() {
              const yt = wt.prototype, Rt = (Ht) => Ht.isEmpty(), kt = _e.AnnotationEditorUIManager.TRANSLATE_SMALL, jt = _e.AnnotationEditorUIManager.TRANSLATE_BIG;
              return (0, _.shadow)(this, "_keyboardManager", new _e.KeyboardManager([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], yt.commitOrRemove, {
                bubbles: !0
              }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], yt.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], yt._translateEmpty, {
                args: [-kt, 0],
                checker: Rt
              }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], yt._translateEmpty, {
                args: [-jt, 0],
                checker: Rt
              }], [["ArrowRight", "mac+ArrowRight"], yt._translateEmpty, {
                args: [kt, 0],
                checker: Rt
              }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], yt._translateEmpty, {
                args: [jt, 0],
                checker: Rt
              }], [["ArrowUp", "mac+ArrowUp"], yt._translateEmpty, {
                args: [0, -kt],
                checker: Rt
              }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], yt._translateEmpty, {
                args: [0, -jt],
                checker: Rt
              }], [["ArrowDown", "mac+ArrowDown"], yt._translateEmpty, {
                args: [0, kt],
                checker: Rt
              }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], yt._translateEmpty, {
                args: [0, jt],
                checker: Rt
              }]]));
            }
            static initialize(yt) {
              tt.AnnotationEditor.initialize(yt, {
                strings: ["free_text2_default_content", "editor_free_text2_aria_label"]
              });
              const Rt = getComputedStyle(document.documentElement);
              this._internalPadding = parseFloat(Rt.getPropertyValue("--freetext-padding"));
            }
            static updateDefaultParams(yt, Rt) {
              switch (yt) {
                case _.AnnotationEditorParamsType.FREETEXT_SIZE:
                  wt._defaultFontSize = Rt;
                  break;
                case _.AnnotationEditorParamsType.FREETEXT_COLOR:
                  wt._defaultColor = Rt;
                  break;
              }
            }
            updateParams(yt, Rt) {
              switch (yt) {
                case _.AnnotationEditorParamsType.FREETEXT_SIZE:
                  Ur(this, dt, _l).call(this, Rt);
                  break;
                case _.AnnotationEditorParamsType.FREETEXT_COLOR:
                  Ur(this, pt, jl).call(this, Rt);
                  break;
              }
            }
            static get defaultPropertiesToUpdate() {
              return [[_.AnnotationEditorParamsType.FREETEXT_SIZE, wt._defaultFontSize], [_.AnnotationEditorParamsType.FREETEXT_COLOR, wt._defaultColor || tt.AnnotationEditor._defaultLineColor]];
            }
            get propertiesToUpdate() {
              return [[_.AnnotationEditorParamsType.FREETEXT_SIZE, mr(this, ft)], [_.AnnotationEditorParamsType.FREETEXT_COLOR, mr(this, et)]];
            }
            _translateEmpty(yt, Rt) {
              this._uiManager.translateSelectedEditors(yt, Rt, !0);
            }
            getInitialTranslation() {
              const yt = this.parentScale;
              return [-wt._internalPadding * yt, -(wt._internalPadding + mr(this, ft)) * yt];
            }
            rebuild() {
              this.parent && (super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this)));
            }
            enableEditMode() {
              this.isInEditMode() || (this.parent.setEditingState(!1), this.parent.updateToolbar(_.AnnotationEditorType.FREETEXT), super.enableEditMode(), this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this._isDraggable = !1, this.div.removeAttribute("aria-activedescendant"), this.editorDiv.addEventListener("keydown", mr(this, lt)), this.editorDiv.addEventListener("focus", mr(this, rt)), this.editorDiv.addEventListener("blur", mr(this, ot)), this.editorDiv.addEventListener("input", mr(this, st)));
            }
            disableEditMode() {
              this.isInEditMode() && (this.parent.setEditingState(!0), super.disableEditMode(), this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.setAttribute("aria-activedescendant", mr(this, ut)), this._isDraggable = !0, this.editorDiv.removeEventListener("keydown", mr(this, lt)), this.editorDiv.removeEventListener("focus", mr(this, rt)), this.editorDiv.removeEventListener("blur", mr(this, ot)), this.editorDiv.removeEventListener("input", mr(this, st)), this.div.focus({
                preventScroll: !0
              }), this.isEditing = !1, this.parent.div.classList.add("freeTextEditing"));
            }
            focusin(yt) {
              this._focusEventsAllowed && (super.focusin(yt), yt.target !== this.editorDiv && this.editorDiv.focus());
            }
            onceAdded() {
              var yt;
              if (this.width) {
                Ur(this, Ot, qs).call(this);
                return;
              }
              this.enableEditMode(), this.editorDiv.focus(), (yt = this._initialOptions) != null && yt.isCentered && this.center(), this._initialOptions = null;
            }
            isEmpty() {
              return !this.editorDiv || this.editorDiv.innerText.trim() === "";
            }
            remove() {
              this.isEditing = !1, this.parent && (this.parent.setEditingState(!0), this.parent.div.classList.add("freeTextEditing")), super.remove();
            }
            commit() {
              if (!this.isInEditMode())
                return;
              super.commit(), this.disableEditMode();
              const yt = mr(this, it), Rt = tn(this, it, Ur(this, ct, Ul).call(this).trimEnd());
              if (yt === Rt)
                return;
              const kt = (jt) => {
                if (tn(this, it, jt), !jt) {
                  this.remove();
                  return;
                }
                Ur(this, bt, Zs).call(this), this._uiManager.rebuild(this), Ur(this, At, Ko).call(this);
              };
              this.addCommands({
                cmd: () => {
                  kt(Rt);
                },
                undo: () => {
                  kt(yt);
                },
                mustExec: !1
              }), Ur(this, At, Ko).call(this);
            }
            shouldGetKeyboardEvents() {
              return this.isInEditMode();
            }
            enterInEditMode() {
              this.enableEditMode(), this.editorDiv.focus();
            }
            dblclick(yt) {
              this.enterInEditMode();
            }
            keydown(yt) {
              yt.target === this.div && yt.key === "Enter" && (this.enterInEditMode(), yt.preventDefault());
            }
            editorDivKeydown(yt) {
              wt._keyboardManager.exec(this, yt);
            }
            editorDivFocus(yt) {
              this.isEditing = !0;
            }
            editorDivBlur(yt) {
              this.isEditing = !1;
            }
            editorDivInput(yt) {
              this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
            }
            disableEditing() {
              this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
            }
            enableEditing() {
              this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
            }
            render() {
              if (this.div)
                return this.div;
              let yt, Rt;
              this.width && (yt = this.x, Rt = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", mr(this, ut)), this.enableEditing(), tt.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((jt) => {
                var Ht;
                return (Ht = this.editorDiv) == null ? void 0 : Ht.setAttribute("aria-label", jt);
              }), tt.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((jt) => {
                var Ht;
                return (Ht = this.editorDiv) == null ? void 0 : Ht.setAttribute("default-content", jt);
              }), this.editorDiv.contentEditable = !0;
              const {
                style: kt
              } = this.editorDiv;
              if (kt.fontSize = `calc(${mr(this, ft)}px * var(--scale-factor))`, kt.color = mr(this, et), this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), (0, _e.bindEvents)(this, this.div, ["dblclick", "keydown"]), this.width) {
                const [jt, Ht] = this.parentDimensions;
                if (this.annotationElementId) {
                  const {
                    position: Ft
                  } = mr(this, ht);
                  let [_t, Nt] = this.getInitialTranslation();
                  [_t, Nt] = this.pageTranslationToScreen(_t, Nt);
                  const [Mt, Lt] = this.pageDimensions, [$t, Tt] = this.pageTranslation;
                  let Dt, Ut;
                  switch (this.rotation) {
                    case 0:
                      Dt = yt + (Ft[0] - $t) / Mt, Ut = Rt + this.height - (Ft[1] - Tt) / Lt;
                      break;
                    case 90:
                      Dt = yt + (Ft[0] - $t) / Mt, Ut = Rt - (Ft[1] - Tt) / Lt, [_t, Nt] = [Nt, -_t];
                      break;
                    case 180:
                      Dt = yt - this.width + (Ft[0] - $t) / Mt, Ut = Rt - (Ft[1] - Tt) / Lt, [_t, Nt] = [-_t, -Nt];
                      break;
                    case 270:
                      Dt = yt + (Ft[0] - $t - this.height * Lt) / Mt, Ut = Rt + (Ft[1] - Tt - this.width * Mt) / Lt, [_t, Nt] = [-Nt, _t];
                      break;
                  }
                  this.setAt(Dt * jt, Ut * Ht, _t, Nt);
                } else
                  this.setAt(yt * jt, Rt * Ht, this.width * jt, this.height * Ht);
                Ur(this, bt, Zs).call(this), this._isDraggable = !0, this.editorDiv.contentEditable = !1;
              } else
                this._isDraggable = !1, this.editorDiv.contentEditable = !0;
              return this.div;
            }
            get contentDiv() {
              return this.editorDiv;
            }
            static deserialize(yt, Rt, kt) {
              let jt = null;
              if (yt instanceof nt.FreeTextAnnotationElement) {
                const {
                  data: {
                    defaultAppearanceData: {
                      fontSize: Ft,
                      fontColor: _t
                    },
                    rect: Nt,
                    rotation: Mt,
                    id: Lt
                  },
                  textContent: $t,
                  textPosition: Tt,
                  parent: {
                    page: {
                      pageNumber: Dt
                    }
                  }
                } = yt;
                if (!$t || $t.length === 0)
                  return null;
                jt = yt = {
                  annotationType: _.AnnotationEditorType.FREETEXT,
                  color: Array.from(_t),
                  fontSize: Ft,
                  value: $t.join(`
`),
                  position: Tt,
                  pageIndex: Dt - 1,
                  rect: Nt,
                  rotation: Mt,
                  id: Lt,
                  deleted: !1
                };
              }
              const Ht = super.deserialize(yt, Rt, kt);
              return tn(Ht, ft, yt.fontSize), tn(Ht, et, _.Util.makeHexColor(...yt.color)), tn(Ht, it, yt.value), Ht.annotationElementId = yt.id || null, tn(Ht, ht, jt), Ht;
            }
            serialize() {
              let yt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
              if (this.isEmpty())
                return null;
              if (this.deleted)
                return {
                  pageIndex: this.pageIndex,
                  id: this.annotationElementId,
                  deleted: !0
                };
              const Rt = wt._internalPadding * this.parentScale, kt = this.getRect(Rt, Rt), jt = tt.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : mr(this, et)), Ht = {
                annotationType: _.AnnotationEditorType.FREETEXT,
                color: jt,
                fontSize: mr(this, ft),
                value: mr(this, it),
                pageIndex: this.pageIndex,
                rect: kt,
                rotation: this.rotation,
                structTreeParentId: this._structTreeParentId
              };
              return yt ? Ht : this.annotationElementId && !Ur(this, St, Hl).call(this, Ht) ? null : (Ht.id = this.annotationElementId, Ht);
            }
          };
          ot = new WeakMap(), rt = new WeakMap(), st = new WeakMap(), lt = new WeakMap(), et = new WeakMap(), it = new WeakMap(), ut = new WeakMap(), ft = new WeakMap(), ht = new WeakMap(), dt = new WeakSet(), _l = function(yt) {
            const Rt = (jt) => {
              this.editorDiv.style.fontSize = `calc(${jt}px * var(--scale-factor))`, this.translate(0, -(jt - mr(this, ft)) * this.parentScale), tn(this, ft, jt), Ur(this, At, Ko).call(this);
            }, kt = mr(this, ft);
            this.addCommands({
              cmd: () => {
                Rt(yt);
              },
              undo: () => {
                Rt(kt);
              },
              mustExec: !0,
              type: _.AnnotationEditorParamsType.FREETEXT_SIZE,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, pt = new WeakSet(), jl = function(yt) {
            const Rt = mr(this, et);
            this.addCommands({
              cmd: () => {
                tn(this, et, this.editorDiv.style.color = yt);
              },
              undo: () => {
                tn(this, et, this.editorDiv.style.color = Rt);
              },
              mustExec: !0,
              type: _.AnnotationEditorParamsType.FREETEXT_COLOR,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, ct = new WeakSet(), Ul = function() {
            const yt = this.editorDiv.getElementsByTagName("div");
            if (yt.length === 0)
              return this.editorDiv.innerText;
            const Rt = [];
            for (const kt of yt)
              Rt.push(kt.innerText.replace(/\r\n?|\n/, ""));
            return Rt.join(`
`);
          }, At = new WeakSet(), Ko = function() {
            const [yt, Rt] = this.parentDimensions;
            let kt;
            if (this.isAttachedToDOM)
              kt = this.div.getBoundingClientRect();
            else {
              const {
                currentLayer: jt,
                div: Ht
              } = this, Ft = Ht.style.display;
              Ht.style.display = "hidden", jt.div.append(this.div), kt = Ht.getBoundingClientRect(), Ht.remove(), Ht.style.display = Ft;
            }
            this.rotation % 180 === this.parentRotation % 180 ? (this.width = kt.width / yt, this.height = kt.height / Rt) : (this.width = kt.height / yt, this.height = kt.width / Rt), this.fixAndSetPosition();
          }, bt = new WeakSet(), Zs = function() {
            if (this.editorDiv.replaceChildren(), !!mr(this, it))
              for (const yt of mr(this, it).split(`
`)) {
                const Rt = document.createElement("div");
                Rt.append(yt ? document.createTextNode(yt) : document.createElement("br")), this.editorDiv.append(Rt);
              }
          }, St = new WeakSet(), Hl = function(yt) {
            const {
              value: Rt,
              fontSize: kt,
              color: jt,
              rect: Ht,
              pageIndex: Ft
            } = mr(this, ht);
            return yt.value !== Rt || yt.fontSize !== kt || yt.rect.some((_t, Nt) => Math.abs(_t - Ht[Nt]) >= 1) || yt.color.some((_t, Nt) => _t !== jt[Nt]) || yt.pageIndex !== Ft;
          }, Ot = new WeakSet(), qs = function() {
            let yt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
            if (!this.annotationElementId)
              return;
            if (Ur(this, At, Ko).call(this), !yt && (this.width === 0 || this.height === 0)) {
              setTimeout(() => Ur(this, Ot, qs).call(this, !0), 0);
              return;
            }
            const Rt = wt._internalPadding * this.parentScale;
            mr(this, ht).rect = this.getRect(Rt, Rt);
          }, Ln(wt, "_freeTextDefaultContent", ""), Ln(wt, "_internalPadding", 0), Ln(wt, "_defaultColor", null), Ln(wt, "_defaultFontSize", 10), Ln(wt, "_type", "freetext");
          let at = wt;
          s.FreeTextEditor = at;
        },
        /* 198 */
        /***/
        (a, s, $) => {
          var Nt, Lt, Do, Tt, zl, Ut, Vt, Qt, qt, Zt, ar, Jt, rr, Yt, Kt, nr, tr, ir, sr, cr, or, Xt, Gt, Wl, er, fs, ur, Js, yr, el, br, gr, Ar, Sr, Br, Ir, hr, tl, xr, Pr, Rr, Dr, Gl, Or, rl;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.StampAnnotationElement = s.InkAnnotationElement = s.FreeTextAnnotationElement = s.AnnotationLayer = void 0, $(89), $(125), $(136), $(138), $(141), $(143), $(145), $(147);
          var _ = $(1), _e = $(168), tt = $(163), nt = $(199), at = $(200), ot = $(201);
          const rt = 1e3, st = 9, lt = /* @__PURE__ */ new WeakSet();
          function et(jr) {
            return {
              width: jr[2] - jr[0],
              height: jr[3] - jr[1]
            };
          }
          class it {
            static create(Tr) {
              switch (Tr.data.annotationType) {
                case _.AnnotationType.LINK:
                  return new ft(Tr);
                case _.AnnotationType.TEXT:
                  return new ht(Tr);
                case _.AnnotationType.WIDGET:
                  switch (Tr.data.fieldType) {
                    case "Tx":
                      return new gt(Tr);
                    case "Btn":
                      return Tr.data.radioButton ? new ct(Tr) : Tr.data.checkBox ? new mt(Tr) : new vt(Tr);
                    case "Ch":
                      return new At(Tr);
                    case "Sig":
                      return new pt(Tr);
                  }
                  return new dt(Tr);
                case _.AnnotationType.POPUP:
                  return new xt(Tr);
                case _.AnnotationType.FREETEXT:
                  return new Et(Tr);
                case _.AnnotationType.LINE:
                  return new St(Tr);
                case _.AnnotationType.SQUARE:
                  return new Bt(Tr);
                case _.AnnotationType.CIRCLE:
                  return new Ot(Tr);
                case _.AnnotationType.POLYLINE:
                  return new Pt(Tr);
                case _.AnnotationType.CARET:
                  return new Ct(Tr);
                case _.AnnotationType.INK:
                  return new It(Tr);
                case _.AnnotationType.POLYGON:
                  return new wt(Tr);
                case _.AnnotationType.HIGHLIGHT:
                  return new yt(Tr);
                case _.AnnotationType.UNDERLINE:
                  return new Rt(Tr);
                case _.AnnotationType.SQUIGGLY:
                  return new kt(Tr);
                case _.AnnotationType.STRIKEOUT:
                  return new jt(Tr);
                case _.AnnotationType.STAMP:
                  return new Ht(Tr);
                case _.AnnotationType.FILEATTACHMENT:
                  return new Ft(Tr);
                default:
                  return new ut(Tr);
              }
            }
          }
          const Mt = class Mt {
            constructor(Tr) {
              _r(this, Nt, !1);
              let {
                isRenderable: fr = !1,
                ignoreBorder: Cr = !1,
                createQuadrilaterals: $r = !1
              } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              this.isRenderable = fr, this.data = Tr.data, this.layer = Tr.layer, this.linkService = Tr.linkService, this.downloadManager = Tr.downloadManager, this.imageResourcesPath = Tr.imageResourcesPath, this.renderForms = Tr.renderForms, this.svgFactory = Tr.svgFactory, this.annotationStorage = Tr.annotationStorage, this.enableScripting = Tr.enableScripting, this.hasJSActions = Tr.hasJSActions, this._fieldObjects = Tr.fieldObjects, this.parent = Tr.parent, fr && (this.container = this._createContainer(Cr)), $r && this._createQuadrilaterals();
            }
            static _hasPopupData(Tr) {
              let {
                titleObj: fr,
                contentsObj: Cr,
                richText: $r
              } = Tr;
              return !!(fr != null && fr.str || Cr != null && Cr.str || $r != null && $r.str);
            }
            get hasPopupData() {
              return Mt._hasPopupData(this.data);
            }
            _createContainer(Tr) {
              const {
                data: fr,
                parent: {
                  page: Cr,
                  viewport: $r
                }
              } = this, wr = document.createElement("section");
              wr.setAttribute("data-annotation-id", fr.id), this instanceof dt || (wr.tabIndex = rt), wr.style.zIndex = this.parent.zIndex++, this.data.popupRef && wr.setAttribute("aria-haspopup", "dialog"), fr.noRotate && wr.classList.add("norotate");
              const {
                pageWidth: Mr,
                pageHeight: Fr,
                pageX: Qr,
                pageY: Yr
              } = $r.rawDims;
              if (!fr.rect || this instanceof xt) {
                const {
                  rotation: Vr
                } = fr;
                return !fr.hasOwnCanvas && Vr !== 0 && this.setRotation(Vr, wr), wr;
              }
              const {
                width: kr,
                height: Nr
              } = et(fr.rect), Lr = _.Util.normalizeRect([fr.rect[0], Cr.view[3] - fr.rect[1] + Cr.view[1], fr.rect[2], Cr.view[3] - fr.rect[3] + Cr.view[1]]);
              if (!Tr && fr.borderStyle.width > 0) {
                wr.style.borderWidth = `${fr.borderStyle.width}px`;
                const Vr = fr.borderStyle.horizontalCornerRadius, an = fr.borderStyle.verticalCornerRadius;
                if (Vr > 0 || an > 0) {
                  const un = `calc(${Vr}px * var(--scale-factor)) / calc(${an}px * var(--scale-factor))`;
                  wr.style.borderRadius = un;
                } else if (this instanceof ct) {
                  const un = `calc(${kr}px * var(--scale-factor)) / calc(${Nr}px * var(--scale-factor))`;
                  wr.style.borderRadius = un;
                }
                switch (fr.borderStyle.style) {
                  case _.AnnotationBorderStyleType.SOLID:
                    wr.style.borderStyle = "solid";
                    break;
                  case _.AnnotationBorderStyleType.DASHED:
                    wr.style.borderStyle = "dashed";
                    break;
                  case _.AnnotationBorderStyleType.BEVELED:
                    (0, _.warn)("Unimplemented border style: beveled");
                    break;
                  case _.AnnotationBorderStyleType.INSET:
                    (0, _.warn)("Unimplemented border style: inset");
                    break;
                  case _.AnnotationBorderStyleType.UNDERLINE:
                    wr.style.borderBottomStyle = "solid";
                    break;
                }
                const Zr = fr.borderColor || null;
                Zr ? (tn(this, Nt, !0), wr.style.borderColor = _.Util.makeHexColor(Zr[0] | 0, Zr[1] | 0, Zr[2] | 0)) : wr.style.borderWidth = 0;
              }
              wr.style.left = `${100 * (Lr[0] - Qr) / Mr}%`, wr.style.top = `${100 * (Lr[1] - Yr) / Fr}%`;
              const {
                rotation: zr
              } = fr;
              return fr.hasOwnCanvas || zr === 0 ? (wr.style.width = `${100 * kr / Mr}%`, wr.style.height = `${100 * Nr / Fr}%`) : this.setRotation(zr, wr), wr;
            }
            setRotation(Tr) {
              let fr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.container;
              if (!this.data.rect)
                return;
              const {
                pageWidth: Cr,
                pageHeight: $r
              } = this.parent.viewport.rawDims, {
                width: wr,
                height: Mr
              } = et(this.data.rect);
              let Fr, Qr;
              Tr % 180 === 0 ? (Fr = 100 * wr / Cr, Qr = 100 * Mr / $r) : (Fr = 100 * Mr / Cr, Qr = 100 * wr / $r), fr.style.width = `${Fr}%`, fr.style.height = `${Qr}%`, fr.setAttribute("data-main-rotation", (360 - Tr) % 360);
            }
            get _commonActions() {
              const Tr = (fr, Cr, $r) => {
                const wr = $r.detail[fr], Mr = wr[0], Fr = wr.slice(1);
                $r.target.style[Cr] = nt.ColorConverters[`${Mr}_HTML`](Fr), this.annotationStorage.setValue(this.data.id, {
                  [Cr]: nt.ColorConverters[`${Mr}_rgb`](Fr)
                });
              };
              return (0, _.shadow)(this, "_commonActions", {
                display: (fr) => {
                  const {
                    display: Cr
                  } = fr.detail, $r = Cr % 2 === 1;
                  this.container.style.visibility = $r ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                    noView: $r,
                    noPrint: Cr === 1 || Cr === 2
                  });
                },
                print: (fr) => {
                  this.annotationStorage.setValue(this.data.id, {
                    noPrint: !fr.detail.print
                  });
                },
                hidden: (fr) => {
                  const {
                    hidden: Cr
                  } = fr.detail;
                  this.container.style.visibility = Cr ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                    noPrint: Cr,
                    noView: Cr
                  });
                },
                focus: (fr) => {
                  setTimeout(() => fr.target.focus({
                    preventScroll: !1
                  }), 0);
                },
                userName: (fr) => {
                  fr.target.title = fr.detail.userName;
                },
                readonly: (fr) => {
                  fr.target.disabled = fr.detail.readonly;
                },
                required: (fr) => {
                  this._setRequired(fr.target, fr.detail.required);
                },
                bgColor: (fr) => {
                  Tr("bgColor", "backgroundColor", fr);
                },
                fillColor: (fr) => {
                  Tr("fillColor", "backgroundColor", fr);
                },
                fgColor: (fr) => {
                  Tr("fgColor", "color", fr);
                },
                textColor: (fr) => {
                  Tr("textColor", "color", fr);
                },
                borderColor: (fr) => {
                  Tr("borderColor", "borderColor", fr);
                },
                strokeColor: (fr) => {
                  Tr("strokeColor", "borderColor", fr);
                },
                rotation: (fr) => {
                  const Cr = fr.detail.rotation;
                  this.setRotation(Cr), this.annotationStorage.setValue(this.data.id, {
                    rotation: Cr
                  });
                }
              });
            }
            _dispatchEventFromSandbox(Tr, fr) {
              const Cr = this._commonActions;
              for (const $r of Object.keys(fr.detail)) {
                const wr = Tr[$r] || Cr[$r];
                wr == null || wr(fr);
              }
            }
            _setDefaultPropertiesFromJS(Tr) {
              if (!this.enableScripting)
                return;
              const fr = this.annotationStorage.getRawValue(this.data.id);
              if (!fr)
                return;
              const Cr = this._commonActions;
              for (const [$r, wr] of Object.entries(fr)) {
                const Mr = Cr[$r];
                if (Mr) {
                  const Fr = {
                    detail: {
                      [$r]: wr
                    },
                    target: Tr
                  };
                  Mr(Fr), delete fr[$r];
                }
              }
            }
            _createQuadrilaterals() {
              if (!this.container)
                return;
              const {
                quadPoints: Tr
              } = this.data;
              if (!Tr)
                return;
              const [fr, Cr, $r, wr] = this.data.rect;
              if (Tr.length === 1) {
                const [, {
                  x: an,
                  y: Zr
                }, {
                  x: un,
                  y: Xr
                }] = Tr[0];
                if ($r === an && wr === Zr && fr === un && Cr === Xr)
                  return;
              }
              const {
                style: Mr
              } = this.container;
              let Fr;
              if (mr(this, Nt)) {
                const {
                  borderColor: an,
                  borderWidth: Zr
                } = Mr;
                Mr.borderWidth = 0, Fr = ["url('data:image/svg+xml;utf8,", '<svg xmlns="http://www.w3.org/2000/svg"', ' preserveAspectRatio="none" viewBox="0 0 1 1">', `<g fill="transparent" stroke="${an}" stroke-width="${Zr}">`], this.container.classList.add("hasBorder");
              }
              const Qr = $r - fr, Yr = wr - Cr, {
                svgFactory: kr
              } = this, Nr = kr.createElement("svg");
              Nr.classList.add("quadrilateralsContainer"), Nr.setAttribute("width", 0), Nr.setAttribute("height", 0);
              const Lr = kr.createElement("defs");
              Nr.append(Lr);
              const zr = kr.createElement("clipPath"), Vr = `clippath_${this.data.id}`;
              zr.setAttribute("id", Vr), zr.setAttribute("clipPathUnits", "objectBoundingBox"), Lr.append(zr);
              for (const [, {
                x: an,
                y: Zr
              }, {
                x: un,
                y: Xr
              }] of Tr) {
                const Kr = kr.createElement("rect"), rn = (un - fr) / Qr, nn = (wr - Zr) / Yr, sn = (an - un) / Qr, gn = (Zr - Xr) / Yr;
                Kr.setAttribute("x", rn), Kr.setAttribute("y", nn), Kr.setAttribute("width", sn), Kr.setAttribute("height", gn), zr.append(Kr), Fr == null || Fr.push(`<rect vector-effect="non-scaling-stroke" x="${rn}" y="${nn}" width="${sn}" height="${gn}"/>`);
              }
              mr(this, Nt) && (Fr.push("</g></svg>')"), Mr.backgroundImage = Fr.join("")), this.container.append(Nr), this.container.style.clipPath = `url(#${Vr})`;
            }
            _createPopup() {
              const {
                container: Tr,
                data: fr
              } = this;
              Tr.setAttribute("aria-haspopup", "dialog");
              const Cr = new xt({
                data: {
                  color: fr.color,
                  titleObj: fr.titleObj,
                  modificationDate: fr.modificationDate,
                  contentsObj: fr.contentsObj,
                  richText: fr.richText,
                  parentRect: fr.rect,
                  borderStyle: 0,
                  id: `popup_${fr.id}`,
                  rotation: fr.rotation
                },
                parent: this.parent,
                elements: [this]
              });
              this.parent.div.append(Cr.render());
            }
            render() {
              (0, _.unreachable)("Abstract method `AnnotationElement.render` called");
            }
            _getElementsByName(Tr) {
              let fr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              const Cr = [];
              if (this._fieldObjects) {
                const $r = this._fieldObjects[Tr];
                if ($r)
                  for (const {
                    page: wr,
                    id: Mr,
                    exportValues: Fr
                  } of $r) {
                    if (wr === -1 || Mr === fr)
                      continue;
                    const Qr = typeof Fr == "string" ? Fr : null, Yr = document.querySelector(`[data-element-id="${Mr}"]`);
                    if (Yr && !lt.has(Yr)) {
                      (0, _.warn)(`_getElementsByName - element not allowed: ${Mr}`);
                      continue;
                    }
                    Cr.push({
                      id: Mr,
                      exportValue: Qr,
                      domElement: Yr
                    });
                  }
                return Cr;
              }
              for (const $r of document.getElementsByName(Tr)) {
                const {
                  exportValue: wr
                } = $r, Mr = $r.getAttribute("data-element-id");
                Mr !== fr && lt.has($r) && Cr.push({
                  id: Mr,
                  exportValue: wr,
                  domElement: $r
                });
              }
              return Cr;
            }
            show() {
              var Tr;
              this.container && (this.container.hidden = !1), (Tr = this.popup) == null || Tr.maybeShow();
            }
            hide() {
              var Tr;
              this.container && (this.container.hidden = !0), (Tr = this.popup) == null || Tr.forceHide();
            }
            getElementsToTriggerPopup() {
              return this.container;
            }
            addHighlightArea() {
              const Tr = this.getElementsToTriggerPopup();
              if (Array.isArray(Tr))
                for (const fr of Tr)
                  fr.classList.add("highlightArea");
              else
                Tr.classList.add("highlightArea");
            }
            _editOnDoubleClick() {
              const {
                annotationEditorType: Tr,
                data: {
                  id: fr
                }
              } = this;
              this.container.addEventListener("dblclick", () => {
                var Cr;
                (Cr = this.linkService.eventBus) == null || Cr.dispatch("switchannotationeditormode", {
                  source: this,
                  mode: Tr,
                  editId: fr
                });
              });
            }
          };
          Nt = new WeakMap();
          let ut = Mt;
          class ft extends ut {
            constructor(fr) {
              let Cr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              super(fr, {
                isRenderable: !0,
                ignoreBorder: !!(Cr != null && Cr.ignoreBorder),
                createQuadrilaterals: !0
              });
              _r(this, Lt);
              _r(this, Tt);
              this.isTooltipOnly = fr.data.isTooltipOnly;
            }
            render() {
              const {
                data: fr,
                linkService: Cr
              } = this, $r = document.createElement("a");
              $r.setAttribute("data-element-id", fr.id);
              let wr = !1;
              return fr.url ? (Cr.addLinkAttributes($r, fr.url, fr.newWindow), wr = !0) : fr.action ? (this._bindNamedAction($r, fr.action), wr = !0) : fr.attachment ? (this._bindAttachment($r, fr.attachment), wr = !0) : fr.setOCGState ? (Ur(this, Tt, zl).call(this, $r, fr.setOCGState), wr = !0) : fr.dest ? (this._bindLink($r, fr.dest), wr = !0) : (fr.actions && (fr.actions.Action || fr.actions["Mouse Up"] || fr.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction($r, fr), wr = !0), fr.resetForm ? (this._bindResetFormAction($r, fr.resetForm), wr = !0) : this.isTooltipOnly && !wr && (this._bindLink($r, ""), wr = !0)), this.container.classList.add("linkAnnotation"), wr && this.container.append($r), this.container;
            }
            _bindLink(fr, Cr) {
              fr.href = this.linkService.getDestinationHash(Cr), fr.onclick = () => (Cr && this.linkService.goToDestination(Cr), !1), (Cr || Cr === "") && Ur(this, Lt, Do).call(this);
            }
            _bindNamedAction(fr, Cr) {
              fr.href = this.linkService.getAnchorUrl(""), fr.onclick = () => (this.linkService.executeNamedAction(Cr), !1), Ur(this, Lt, Do).call(this);
            }
            _bindAttachment(fr, Cr) {
              fr.href = this.linkService.getAnchorUrl(""), fr.onclick = () => {
                var $r;
                return ($r = this.downloadManager) == null || $r.openOrDownloadData(this.container, Cr.content, Cr.filename), !1;
              }, Ur(this, Lt, Do).call(this);
            }
            _bindJSAction(fr, Cr) {
              fr.href = this.linkService.getAnchorUrl("");
              const $r = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
              for (const wr of Object.keys(Cr.actions)) {
                const Mr = $r.get(wr);
                Mr && (fr[Mr] = () => {
                  var Fr;
                  return (Fr = this.linkService.eventBus) == null || Fr.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: Cr.id,
                      name: wr
                    }
                  }), !1;
                });
              }
              fr.onclick || (fr.onclick = () => !1), Ur(this, Lt, Do).call(this);
            }
            _bindResetFormAction(fr, Cr) {
              const $r = fr.onclick;
              if ($r || (fr.href = this.linkService.getAnchorUrl("")), Ur(this, Lt, Do).call(this), !this._fieldObjects) {
                (0, _.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), $r || (fr.onclick = () => !1);
                return;
              }
              fr.onclick = () => {
                var Nr;
                $r == null || $r();
                const {
                  fields: wr,
                  refs: Mr,
                  include: Fr
                } = Cr, Qr = [];
                if (wr.length !== 0 || Mr.length !== 0) {
                  const Lr = new Set(Mr);
                  for (const zr of wr) {
                    const Vr = this._fieldObjects[zr] || [];
                    for (const {
                      id: an
                    } of Vr)
                      Lr.add(an);
                  }
                  for (const zr of Object.values(this._fieldObjects))
                    for (const Vr of zr)
                      Lr.has(Vr.id) === Fr && Qr.push(Vr);
                } else
                  for (const Lr of Object.values(this._fieldObjects))
                    Qr.push(...Lr);
                const Yr = this.annotationStorage, kr = [];
                for (const Lr of Qr) {
                  const {
                    id: zr
                  } = Lr;
                  switch (kr.push(zr), Lr.type) {
                    case "text": {
                      const an = Lr.defaultValue || "";
                      Yr.setValue(zr, {
                        value: an
                      });
                      break;
                    }
                    case "checkbox":
                    case "radiobutton": {
                      const an = Lr.defaultValue === Lr.exportValues;
                      Yr.setValue(zr, {
                        value: an
                      });
                      break;
                    }
                    case "combobox":
                    case "listbox": {
                      const an = Lr.defaultValue || "";
                      Yr.setValue(zr, {
                        value: an
                      });
                      break;
                    }
                    default:
                      continue;
                  }
                  const Vr = document.querySelector(`[data-element-id="${zr}"]`);
                  if (Vr) {
                    if (!lt.has(Vr)) {
                      (0, _.warn)(`_bindResetFormAction - element not allowed: ${zr}`);
                      continue;
                    }
                  } else
                    continue;
                  Vr.dispatchEvent(new Event("resetform"));
                }
                return this.enableScripting && ((Nr = this.linkService.eventBus) == null || Nr.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: "app",
                    ids: kr,
                    name: "ResetForm"
                  }
                })), !1;
              };
            }
          }
          Lt = new WeakSet(), Do = function() {
            this.container.setAttribute("data-internal-link", "");
          }, Tt = new WeakSet(), zl = function(fr, Cr) {
            fr.href = this.linkService.getAnchorUrl(""), fr.onclick = () => (this.linkService.executeSetOCGState(Cr), !1), Ur(this, Lt, Do).call(this);
          };
          class ht extends ut {
            constructor(Tr) {
              super(Tr, {
                isRenderable: !0
              });
            }
            render() {
              this.container.classList.add("textAnnotation");
              const Tr = document.createElement("img");
              return Tr.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", Tr.alt = "[{{type}} Annotation]", Tr.dataset.l10nId = "text_annotation_type", Tr.dataset.l10nArgs = JSON.stringify({
                type: this.data.name
              }), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.append(Tr), this.container;
            }
          }
          class dt extends ut {
            render() {
              return this.data.alternativeText && (this.container.title = this.data.alternativeText), this.container;
            }
            showElementAndHideCanvas(Tr) {
              var fr;
              this.data.hasOwnCanvas && (((fr = Tr.previousSibling) == null ? void 0 : fr.nodeName) === "CANVAS" && (Tr.previousSibling.hidden = !0), Tr.hidden = !1);
            }
            _getKeyModifier(Tr) {
              const {
                isWin: fr,
                isMac: Cr
              } = _.FeatureTest.platform;
              return fr && Tr.ctrlKey || Cr && Tr.metaKey;
            }
            _setEventListener(Tr, fr, Cr, $r, wr) {
              Cr.includes("mouse") ? Tr.addEventListener(Cr, (Mr) => {
                var Fr;
                (Fr = this.linkService.eventBus) == null || Fr.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: this.data.id,
                    name: $r,
                    value: wr(Mr),
                    shift: Mr.shiftKey,
                    modifier: this._getKeyModifier(Mr)
                  }
                });
              }) : Tr.addEventListener(Cr, (Mr) => {
                var Fr;
                if (Cr === "blur") {
                  if (!fr.focused || !Mr.relatedTarget)
                    return;
                  fr.focused = !1;
                } else if (Cr === "focus") {
                  if (fr.focused)
                    return;
                  fr.focused = !0;
                }
                wr && ((Fr = this.linkService.eventBus) == null || Fr.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: this.data.id,
                    name: $r,
                    value: wr(Mr)
                  }
                }));
              });
            }
            _setEventListeners(Tr, fr, Cr, $r) {
              var wr, Mr, Fr;
              for (const [Qr, Yr] of Cr)
                (Yr === "Action" || (wr = this.data.actions) != null && wr[Yr]) && ((Yr === "Focus" || Yr === "Blur") && (fr || (fr = {
                  focused: !1
                })), this._setEventListener(Tr, fr, Qr, Yr, $r), Yr === "Focus" && !((Mr = this.data.actions) != null && Mr.Blur) ? this._setEventListener(Tr, fr, "blur", "Blur", null) : Yr === "Blur" && !((Fr = this.data.actions) != null && Fr.Focus) && this._setEventListener(Tr, fr, "focus", "Focus", null));
            }
            _setBackgroundColor(Tr) {
              const fr = this.data.backgroundColor || null;
              Tr.style.backgroundColor = fr === null ? "transparent" : _.Util.makeHexColor(fr[0], fr[1], fr[2]);
            }
            _setTextStyle(Tr) {
              const fr = ["left", "center", "right"], {
                fontColor: Cr
              } = this.data.defaultAppearanceData, $r = this.data.defaultAppearanceData.fontSize || st, wr = Tr.style;
              let Mr;
              const Fr = 2, Qr = (Yr) => Math.round(10 * Yr) / 10;
              if (this.data.multiLine) {
                const Yr = Math.abs(this.data.rect[3] - this.data.rect[1] - Fr), kr = Math.round(Yr / (_.LINE_FACTOR * $r)) || 1, Nr = Yr / kr;
                Mr = Math.min($r, Qr(Nr / _.LINE_FACTOR));
              } else {
                const Yr = Math.abs(this.data.rect[3] - this.data.rect[1] - Fr);
                Mr = Math.min($r, Qr(Yr / _.LINE_FACTOR));
              }
              wr.fontSize = `calc(${Mr}px * var(--scale-factor))`, wr.color = _.Util.makeHexColor(Cr[0], Cr[1], Cr[2]), this.data.textAlignment !== null && (wr.textAlign = fr[this.data.textAlignment]);
            }
            _setRequired(Tr, fr) {
              fr ? Tr.setAttribute("required", !0) : Tr.removeAttribute("required"), Tr.setAttribute("aria-required", fr);
            }
          }
          class gt extends dt {
            constructor(Tr) {
              const fr = Tr.renderForms || !Tr.data.hasAppearance && !!Tr.data.fieldValue;
              super(Tr, {
                isRenderable: fr
              });
            }
            setPropertyOnSiblings(Tr, fr, Cr, $r) {
              const wr = this.annotationStorage;
              for (const Mr of this._getElementsByName(Tr.name, Tr.id))
                Mr.domElement && (Mr.domElement[fr] = Cr), wr.setValue(Mr.id, {
                  [$r]: Cr
                });
            }
            render() {
              var $r, wr;
              const Tr = this.annotationStorage, fr = this.data.id;
              this.container.classList.add("textWidgetAnnotation");
              let Cr = null;
              if (this.renderForms) {
                const Mr = Tr.getValue(fr, {
                  value: this.data.fieldValue
                });
                let Fr = Mr.value || "";
                const Qr = Tr.getValue(fr, {
                  charLimit: this.data.maxLen
                }).charLimit;
                Qr && Fr.length > Qr && (Fr = Fr.slice(0, Qr));
                let Yr = Mr.formattedValue || (($r = this.data.textContent) == null ? void 0 : $r.join(`
`)) || null;
                Yr && this.data.comb && (Yr = Yr.replaceAll(/\s+/g, ""));
                const kr = {
                  userValue: Fr,
                  formattedValue: Yr,
                  lastCommittedValue: null,
                  commitKey: 1,
                  focused: !1
                };
                this.data.multiLine ? (Cr = document.createElement("textarea"), Cr.textContent = Yr ?? Fr, this.data.doNotScroll && (Cr.style.overflowY = "hidden")) : (Cr = document.createElement("input"), Cr.type = "text", Cr.setAttribute("value", Yr ?? Fr), this.data.doNotScroll && (Cr.style.overflowX = "hidden")), this.data.hasOwnCanvas && (Cr.hidden = !0), lt.add(Cr), Cr.setAttribute("data-element-id", fr), Cr.disabled = this.data.readOnly, Cr.name = this.data.fieldName, Cr.tabIndex = rt, this._setRequired(Cr, this.data.required), Qr && (Cr.maxLength = Qr), Cr.addEventListener("input", (Lr) => {
                  Tr.setValue(fr, {
                    value: Lr.target.value
                  }), this.setPropertyOnSiblings(Cr, "value", Lr.target.value, "value"), kr.formattedValue = null;
                }), Cr.addEventListener("resetform", (Lr) => {
                  const zr = this.data.defaultFieldValue ?? "";
                  Cr.value = kr.userValue = zr, kr.formattedValue = null;
                });
                let Nr = (Lr) => {
                  const {
                    formattedValue: zr
                  } = kr;
                  zr != null && (Lr.target.value = zr), Lr.target.scrollLeft = 0;
                };
                if (this.enableScripting && this.hasJSActions) {
                  Cr.addEventListener("focus", (zr) => {
                    if (kr.focused)
                      return;
                    const {
                      target: Vr
                    } = zr;
                    kr.userValue && (Vr.value = kr.userValue), kr.lastCommittedValue = Vr.value, kr.commitKey = 1, kr.focused = !0;
                  }), Cr.addEventListener("updatefromsandbox", (zr) => {
                    this.showElementAndHideCanvas(zr.target);
                    const Vr = {
                      value(an) {
                        kr.userValue = an.detail.value ?? "", Tr.setValue(fr, {
                          value: kr.userValue.toString()
                        }), an.target.value = kr.userValue;
                      },
                      formattedValue(an) {
                        const {
                          formattedValue: Zr
                        } = an.detail;
                        kr.formattedValue = Zr, Zr != null && an.target !== document.activeElement && (an.target.value = Zr), Tr.setValue(fr, {
                          formattedValue: Zr
                        });
                      },
                      selRange(an) {
                        an.target.setSelectionRange(...an.detail.selRange);
                      },
                      charLimit: (an) => {
                        var Kr;
                        const {
                          charLimit: Zr
                        } = an.detail, {
                          target: un
                        } = an;
                        if (Zr === 0) {
                          un.removeAttribute("maxLength");
                          return;
                        }
                        un.setAttribute("maxLength", Zr);
                        let Xr = kr.userValue;
                        !Xr || Xr.length <= Zr || (Xr = Xr.slice(0, Zr), un.value = kr.userValue = Xr, Tr.setValue(fr, {
                          value: Xr
                        }), (Kr = this.linkService.eventBus) == null || Kr.dispatch("dispatcheventinsandbox", {
                          source: this,
                          detail: {
                            id: fr,
                            name: "Keystroke",
                            value: Xr,
                            willCommit: !0,
                            commitKey: 1,
                            selStart: un.selectionStart,
                            selEnd: un.selectionEnd
                          }
                        }));
                      }
                    };
                    this._dispatchEventFromSandbox(Vr, zr);
                  }), Cr.addEventListener("keydown", (zr) => {
                    var Zr;
                    kr.commitKey = 1;
                    let Vr = -1;
                    if (zr.key === "Escape" ? Vr = 0 : zr.key === "Enter" && !this.data.multiLine ? Vr = 2 : zr.key === "Tab" && (kr.commitKey = 3), Vr === -1)
                      return;
                    const {
                      value: an
                    } = zr.target;
                    kr.lastCommittedValue !== an && (kr.lastCommittedValue = an, kr.userValue = an, (Zr = this.linkService.eventBus) == null || Zr.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: fr,
                        name: "Keystroke",
                        value: an,
                        willCommit: !0,
                        commitKey: Vr,
                        selStart: zr.target.selectionStart,
                        selEnd: zr.target.selectionEnd
                      }
                    }));
                  });
                  const Lr = Nr;
                  Nr = null, Cr.addEventListener("blur", (zr) => {
                    var an;
                    if (!kr.focused || !zr.relatedTarget)
                      return;
                    kr.focused = !1;
                    const {
                      value: Vr
                    } = zr.target;
                    kr.userValue = Vr, kr.lastCommittedValue !== Vr && ((an = this.linkService.eventBus) == null || an.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: fr,
                        name: "Keystroke",
                        value: Vr,
                        willCommit: !0,
                        commitKey: kr.commitKey,
                        selStart: zr.target.selectionStart,
                        selEnd: zr.target.selectionEnd
                      }
                    })), Lr(zr);
                  }), (wr = this.data.actions) != null && wr.Keystroke && Cr.addEventListener("beforeinput", (zr) => {
                    var nn;
                    kr.lastCommittedValue = null;
                    const {
                      data: Vr,
                      target: an
                    } = zr, {
                      value: Zr,
                      selectionStart: un,
                      selectionEnd: Xr
                    } = an;
                    let Kr = un, rn = Xr;
                    switch (zr.inputType) {
                      case "deleteWordBackward": {
                        const sn = Zr.substring(0, un).match(/\w*[^\w]*$/);
                        sn && (Kr -= sn[0].length);
                        break;
                      }
                      case "deleteWordForward": {
                        const sn = Zr.substring(un).match(/^[^\w]*\w*/);
                        sn && (rn += sn[0].length);
                        break;
                      }
                      case "deleteContentBackward":
                        un === Xr && (Kr -= 1);
                        break;
                      case "deleteContentForward":
                        un === Xr && (rn += 1);
                        break;
                    }
                    zr.preventDefault(), (nn = this.linkService.eventBus) == null || nn.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: fr,
                        name: "Keystroke",
                        value: Zr,
                        change: Vr || "",
                        willCommit: !1,
                        selStart: Kr,
                        selEnd: rn
                      }
                    });
                  }), this._setEventListeners(Cr, kr, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (zr) => zr.target.value);
                }
                if (Nr && Cr.addEventListener("blur", Nr), this.data.comb) {
                  const zr = (this.data.rect[2] - this.data.rect[0]) / Qr;
                  Cr.classList.add("comb"), Cr.style.letterSpacing = `calc(${zr}px * var(--scale-factor) - 1ch)`;
                }
              } else
                Cr = document.createElement("div"), Cr.textContent = this.data.fieldValue, Cr.style.verticalAlign = "middle", Cr.style.display = "table-cell";
              return this._setTextStyle(Cr), this._setBackgroundColor(Cr), this._setDefaultPropertiesFromJS(Cr), this.container.append(Cr), this.container;
            }
          }
          class pt extends dt {
            constructor(Tr) {
              super(Tr, {
                isRenderable: !!Tr.data.hasOwnCanvas
              });
            }
          }
          class mt extends dt {
            constructor(Tr) {
              super(Tr, {
                isRenderable: Tr.renderForms
              });
            }
            render() {
              const Tr = this.annotationStorage, fr = this.data, Cr = fr.id;
              let $r = Tr.getValue(Cr, {
                value: fr.exportValue === fr.fieldValue
              }).value;
              typeof $r == "string" && ($r = $r !== "Off", Tr.setValue(Cr, {
                value: $r
              })), this.container.classList.add("buttonWidgetAnnotation", "checkBox");
              const wr = document.createElement("input");
              return lt.add(wr), wr.setAttribute("data-element-id", Cr), wr.disabled = fr.readOnly, this._setRequired(wr, this.data.required), wr.type = "checkbox", wr.name = fr.fieldName, $r && wr.setAttribute("checked", !0), wr.setAttribute("exportValue", fr.exportValue), wr.tabIndex = rt, wr.addEventListener("change", (Mr) => {
                const {
                  name: Fr,
                  checked: Qr
                } = Mr.target;
                for (const Yr of this._getElementsByName(Fr, Cr)) {
                  const kr = Qr && Yr.exportValue === fr.exportValue;
                  Yr.domElement && (Yr.domElement.checked = kr), Tr.setValue(Yr.id, {
                    value: kr
                  });
                }
                Tr.setValue(Cr, {
                  value: Qr
                });
              }), wr.addEventListener("resetform", (Mr) => {
                const Fr = fr.defaultFieldValue || "Off";
                Mr.target.checked = Fr === fr.exportValue;
              }), this.enableScripting && this.hasJSActions && (wr.addEventListener("updatefromsandbox", (Mr) => {
                const Fr = {
                  value(Qr) {
                    Qr.target.checked = Qr.detail.value !== "Off", Tr.setValue(Cr, {
                      value: Qr.target.checked
                    });
                  }
                };
                this._dispatchEventFromSandbox(Fr, Mr);
              }), this._setEventListeners(wr, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Mr) => Mr.target.checked)), this._setBackgroundColor(wr), this._setDefaultPropertiesFromJS(wr), this.container.append(wr), this.container;
            }
          }
          class ct extends dt {
            constructor(Tr) {
              super(Tr, {
                isRenderable: Tr.renderForms
              });
            }
            render() {
              this.container.classList.add("buttonWidgetAnnotation", "radioButton");
              const Tr = this.annotationStorage, fr = this.data, Cr = fr.id;
              let $r = Tr.getValue(Cr, {
                value: fr.fieldValue === fr.buttonValue
              }).value;
              typeof $r == "string" && ($r = $r !== fr.buttonValue, Tr.setValue(Cr, {
                value: $r
              }));
              const wr = document.createElement("input");
              if (lt.add(wr), wr.setAttribute("data-element-id", Cr), wr.disabled = fr.readOnly, this._setRequired(wr, this.data.required), wr.type = "radio", wr.name = fr.fieldName, $r && wr.setAttribute("checked", !0), wr.tabIndex = rt, wr.addEventListener("change", (Mr) => {
                const {
                  name: Fr,
                  checked: Qr
                } = Mr.target;
                for (const Yr of this._getElementsByName(Fr, Cr))
                  Tr.setValue(Yr.id, {
                    value: !1
                  });
                Tr.setValue(Cr, {
                  value: Qr
                });
              }), wr.addEventListener("resetform", (Mr) => {
                const Fr = fr.defaultFieldValue;
                Mr.target.checked = Fr != null && Fr === fr.buttonValue;
              }), this.enableScripting && this.hasJSActions) {
                const Mr = fr.buttonValue;
                wr.addEventListener("updatefromsandbox", (Fr) => {
                  const Qr = {
                    value: (Yr) => {
                      const kr = Mr === Yr.detail.value;
                      for (const Nr of this._getElementsByName(Yr.target.name)) {
                        const Lr = kr && Nr.id === Cr;
                        Nr.domElement && (Nr.domElement.checked = Lr), Tr.setValue(Nr.id, {
                          value: Lr
                        });
                      }
                    }
                  };
                  this._dispatchEventFromSandbox(Qr, Fr);
                }), this._setEventListeners(wr, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Fr) => Fr.target.checked);
              }
              return this._setBackgroundColor(wr), this._setDefaultPropertiesFromJS(wr), this.container.append(wr), this.container;
            }
          }
          class vt extends ft {
            constructor(Tr) {
              super(Tr, {
                ignoreBorder: Tr.data.hasAppearance
              });
            }
            render() {
              const Tr = super.render();
              Tr.classList.add("buttonWidgetAnnotation", "pushButton"), this.data.alternativeText && (Tr.title = this.data.alternativeText);
              const fr = Tr.lastChild;
              return this.enableScripting && this.hasJSActions && fr && (this._setDefaultPropertiesFromJS(fr), fr.addEventListener("updatefromsandbox", (Cr) => {
                this._dispatchEventFromSandbox({}, Cr);
              })), Tr;
            }
          }
          class At extends dt {
            constructor(Tr) {
              super(Tr, {
                isRenderable: Tr.renderForms
              });
            }
            render() {
              this.container.classList.add("choiceWidgetAnnotation");
              const Tr = this.annotationStorage, fr = this.data.id, Cr = Tr.getValue(fr, {
                value: this.data.fieldValue
              }), $r = document.createElement("select");
              lt.add($r), $r.setAttribute("data-element-id", fr), $r.disabled = this.data.readOnly, this._setRequired($r, this.data.required), $r.name = this.data.fieldName, $r.tabIndex = rt;
              let wr = this.data.combo && this.data.options.length > 0;
              this.data.combo || ($r.size = this.data.options.length, this.data.multiSelect && ($r.multiple = !0)), $r.addEventListener("resetform", (kr) => {
                const Nr = this.data.defaultFieldValue;
                for (const Lr of $r.options)
                  Lr.selected = Lr.value === Nr;
              });
              for (const kr of this.data.options) {
                const Nr = document.createElement("option");
                Nr.textContent = kr.displayValue, Nr.value = kr.exportValue, Cr.value.includes(kr.exportValue) && (Nr.setAttribute("selected", !0), wr = !1), $r.append(Nr);
              }
              let Mr = null;
              if (wr) {
                const kr = document.createElement("option");
                kr.value = " ", kr.setAttribute("hidden", !0), kr.setAttribute("selected", !0), $r.prepend(kr), Mr = () => {
                  kr.remove(), $r.removeEventListener("input", Mr), Mr = null;
                }, $r.addEventListener("input", Mr);
              }
              const Fr = (kr) => {
                const Nr = kr ? "value" : "textContent", {
                  options: Lr,
                  multiple: zr
                } = $r;
                return zr ? Array.prototype.filter.call(Lr, (Vr) => Vr.selected).map((Vr) => Vr[Nr]) : Lr.selectedIndex === -1 ? null : Lr[Lr.selectedIndex][Nr];
              };
              let Qr = Fr(!1);
              const Yr = (kr) => {
                const Nr = kr.target.options;
                return Array.prototype.map.call(Nr, (Lr) => ({
                  displayValue: Lr.textContent,
                  exportValue: Lr.value
                }));
              };
              return this.enableScripting && this.hasJSActions ? ($r.addEventListener("updatefromsandbox", (kr) => {
                const Nr = {
                  value(Lr) {
                    Mr == null || Mr();
                    const zr = Lr.detail.value, Vr = new Set(Array.isArray(zr) ? zr : [zr]);
                    for (const an of $r.options)
                      an.selected = Vr.has(an.value);
                    Tr.setValue(fr, {
                      value: Fr(!0)
                    }), Qr = Fr(!1);
                  },
                  multipleSelection(Lr) {
                    $r.multiple = !0;
                  },
                  remove(Lr) {
                    const zr = $r.options, Vr = Lr.detail.remove;
                    zr[Vr].selected = !1, $r.remove(Vr), zr.length > 0 && Array.prototype.findIndex.call(zr, (Zr) => Zr.selected) === -1 && (zr[0].selected = !0), Tr.setValue(fr, {
                      value: Fr(!0),
                      items: Yr(Lr)
                    }), Qr = Fr(!1);
                  },
                  clear(Lr) {
                    for (; $r.length !== 0; )
                      $r.remove(0);
                    Tr.setValue(fr, {
                      value: null,
                      items: []
                    }), Qr = Fr(!1);
                  },
                  insert(Lr) {
                    const {
                      index: zr,
                      displayValue: Vr,
                      exportValue: an
                    } = Lr.detail.insert, Zr = $r.children[zr], un = document.createElement("option");
                    un.textContent = Vr, un.value = an, Zr ? Zr.before(un) : $r.append(un), Tr.setValue(fr, {
                      value: Fr(!0),
                      items: Yr(Lr)
                    }), Qr = Fr(!1);
                  },
                  items(Lr) {
                    const {
                      items: zr
                    } = Lr.detail;
                    for (; $r.length !== 0; )
                      $r.remove(0);
                    for (const Vr of zr) {
                      const {
                        displayValue: an,
                        exportValue: Zr
                      } = Vr, un = document.createElement("option");
                      un.textContent = an, un.value = Zr, $r.append(un);
                    }
                    $r.options.length > 0 && ($r.options[0].selected = !0), Tr.setValue(fr, {
                      value: Fr(!0),
                      items: Yr(Lr)
                    }), Qr = Fr(!1);
                  },
                  indices(Lr) {
                    const zr = new Set(Lr.detail.indices);
                    for (const Vr of Lr.target.options)
                      Vr.selected = zr.has(Vr.index);
                    Tr.setValue(fr, {
                      value: Fr(!0)
                    }), Qr = Fr(!1);
                  },
                  editable(Lr) {
                    Lr.target.disabled = !Lr.detail.editable;
                  }
                };
                this._dispatchEventFromSandbox(Nr, kr);
              }), $r.addEventListener("input", (kr) => {
                var Lr;
                const Nr = Fr(!0);
                Tr.setValue(fr, {
                  value: Nr
                }), kr.preventDefault(), (Lr = this.linkService.eventBus) == null || Lr.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: fr,
                    name: "Keystroke",
                    value: Qr,
                    changeEx: Nr,
                    willCommit: !1,
                    commitKey: 1,
                    keyDown: !1
                  }
                });
              }), this._setEventListeners($r, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], (kr) => kr.target.value)) : $r.addEventListener("input", function(kr) {
                Tr.setValue(fr, {
                  value: Fr(!0)
                });
              }), this.data.combo && this._setTextStyle($r), this._setBackgroundColor($r), this._setDefaultPropertiesFromJS($r), this.container.append($r), this.container;
            }
          }
          class xt extends ut {
            constructor(Tr) {
              const {
                data: fr,
                elements: Cr
              } = Tr;
              super(Tr, {
                isRenderable: ut._hasPopupData(fr)
              }), this.elements = Cr;
            }
            render() {
              this.container.classList.add("popupAnnotation");
              const Tr = new bt({
                container: this.container,
                color: this.data.color,
                titleObj: this.data.titleObj,
                modificationDate: this.data.modificationDate,
                contentsObj: this.data.contentsObj,
                richText: this.data.richText,
                rect: this.data.rect,
                parentRect: this.data.parentRect || null,
                parent: this.parent,
                elements: this.elements,
                open: this.data.open
              }), fr = [];
              for (const Cr of this.elements)
                Cr.popup = Tr, fr.push(Cr.data.id), Cr.addHighlightArea();
              return this.container.setAttribute("aria-controls", fr.map((Cr) => `${_.AnnotationPrefix}${Cr}`).join(",")), this.container;
            }
          }
          class bt {
            constructor(Tr) {
              _r(this, Gt);
              _r(this, er);
              _r(this, ur);
              _r(this, yr);
              _r(this, Ut, null);
              _r(this, Vt, Ur(this, Gt, Wl).bind(this));
              _r(this, Qt, Ur(this, yr, el).bind(this));
              _r(this, qt, Ur(this, ur, Js).bind(this));
              _r(this, Zt, Ur(this, er, fs).bind(this));
              _r(this, ar, null);
              _r(this, Jt, null);
              _r(this, rr, null);
              _r(this, Yt, null);
              _r(this, Kt, null);
              _r(this, nr, null);
              _r(this, tr, !1);
              _r(this, ir, null);
              _r(this, sr, null);
              _r(this, cr, null);
              _r(this, or, null);
              _r(this, Xt, !1);
              var Vr;
              let {
                container: fr,
                color: Cr,
                elements: $r,
                titleObj: wr,
                modificationDate: Mr,
                contentsObj: Fr,
                richText: Qr,
                parent: Yr,
                rect: kr,
                parentRect: Nr,
                open: Lr
              } = Tr;
              tn(this, Jt, fr), tn(this, or, wr), tn(this, rr, Fr), tn(this, cr, Qr), tn(this, Kt, Yr), tn(this, ar, Cr), tn(this, sr, kr), tn(this, nr, Nr), tn(this, Yt, $r);
              const zr = _e.PDFDateString.toDateObject(Mr);
              zr && tn(this, Ut, Yr.l10n.get("annotation_date_string", {
                date: zr.toLocaleDateString(),
                time: zr.toLocaleTimeString()
              })), this.trigger = $r.flatMap((an) => an.getElementsToTriggerPopup());
              for (const an of this.trigger)
                an.addEventListener("click", mr(this, Zt)), an.addEventListener("mouseenter", mr(this, qt)), an.addEventListener("mouseleave", mr(this, Qt)), an.classList.add("popupTriggerArea");
              for (const an of $r)
                (Vr = an.container) == null || Vr.addEventListener("keydown", mr(this, Vt));
              mr(this, Jt).hidden = !0, Lr && Ur(this, er, fs).call(this);
            }
            render() {
              if (mr(this, ir))
                return;
              const {
                page: {
                  view: Tr
                },
                viewport: {
                  rawDims: {
                    pageWidth: fr,
                    pageHeight: Cr,
                    pageX: $r,
                    pageY: wr
                  }
                }
              } = mr(this, Kt), Mr = tn(this, ir, document.createElement("div"));
              if (Mr.className = "popup", mr(this, ar)) {
                const Kr = Mr.style.outlineColor = _.Util.makeHexColor(...mr(this, ar));
                CSS.supports("background-color", "color-mix(in srgb, red 30%, white)") ? Mr.style.backgroundColor = `color-mix(in srgb, ${Kr} 30%, white)` : Mr.style.backgroundColor = _.Util.makeHexColor(...mr(this, ar).map((nn) => Math.floor(0.7 * (255 - nn) + nn)));
              }
              const Fr = document.createElement("span");
              Fr.className = "header";
              const Qr = document.createElement("h1");
              if (Fr.append(Qr), {
                dir: Qr.dir,
                str: Qr.textContent
              } = mr(this, or), Mr.append(Fr), mr(this, Ut)) {
                const Kr = document.createElement("span");
                Kr.classList.add("popupDate"), mr(this, Ut).then((rn) => {
                  Kr.textContent = rn;
                }), Fr.append(Kr);
              }
              const Yr = mr(this, rr), kr = mr(this, cr);
              if (kr != null && kr.str && (!(Yr != null && Yr.str) || Yr.str === kr.str))
                ot.XfaLayer.render({
                  xfaHtml: kr.html,
                  intent: "richText",
                  div: Mr
                }), Mr.lastChild.classList.add("richText", "popupContent");
              else {
                const Kr = this._formatContents(Yr);
                Mr.append(Kr);
              }
              let Nr = !!mr(this, nr), Lr = Nr ? mr(this, nr) : mr(this, sr);
              for (const Kr of mr(this, Yt))
                if (!Lr || _.Util.intersect(Kr.data.rect, Lr) !== null) {
                  Lr = Kr.data.rect, Nr = !0;
                  break;
                }
              const zr = _.Util.normalizeRect([Lr[0], Tr[3] - Lr[1] + Tr[1], Lr[2], Tr[3] - Lr[3] + Tr[1]]), Vr = 5, an = Nr ? Lr[2] - Lr[0] + Vr : 0, Zr = zr[0] + an, un = zr[1], {
                style: Xr
              } = mr(this, Jt);
              Xr.left = `${100 * (Zr - $r) / fr}%`, Xr.top = `${100 * (un - wr) / Cr}%`, mr(this, Jt).append(Mr);
            }
            _formatContents(Tr) {
              let {
                str: fr,
                dir: Cr
              } = Tr;
              const $r = document.createElement("p");
              $r.classList.add("popupContent"), $r.dir = Cr;
              const wr = fr.split(/(?:\r\n?|\n)/);
              for (let Mr = 0, Fr = wr.length; Mr < Fr; ++Mr) {
                const Qr = wr[Mr];
                $r.append(document.createTextNode(Qr)), Mr < Fr - 1 && $r.append(document.createElement("br"));
              }
              return $r;
            }
            forceHide() {
              tn(this, Xt, this.isVisible), mr(this, Xt) && (mr(this, Jt).hidden = !0);
            }
            maybeShow() {
              mr(this, Xt) && (tn(this, Xt, !1), mr(this, Jt).hidden = !1);
            }
            get isVisible() {
              return mr(this, Jt).hidden === !1;
            }
          }
          Ut = new WeakMap(), Vt = new WeakMap(), Qt = new WeakMap(), qt = new WeakMap(), Zt = new WeakMap(), ar = new WeakMap(), Jt = new WeakMap(), rr = new WeakMap(), Yt = new WeakMap(), Kt = new WeakMap(), nr = new WeakMap(), tr = new WeakMap(), ir = new WeakMap(), sr = new WeakMap(), cr = new WeakMap(), or = new WeakMap(), Xt = new WeakMap(), Gt = new WeakSet(), Wl = function(Tr) {
            Tr.altKey || Tr.shiftKey || Tr.ctrlKey || Tr.metaKey || (Tr.key === "Enter" || Tr.key === "Escape" && mr(this, tr)) && Ur(this, er, fs).call(this);
          }, er = new WeakSet(), fs = function() {
            tn(this, tr, !mr(this, tr)), mr(this, tr) ? (Ur(this, ur, Js).call(this), mr(this, Jt).addEventListener("click", mr(this, Zt)), mr(this, Jt).addEventListener("keydown", mr(this, Vt))) : (Ur(this, yr, el).call(this), mr(this, Jt).removeEventListener("click", mr(this, Zt)), mr(this, Jt).removeEventListener("keydown", mr(this, Vt)));
          }, ur = new WeakSet(), Js = function() {
            mr(this, ir) || this.render(), this.isVisible ? mr(this, tr) && mr(this, Jt).classList.add("focused") : (mr(this, Jt).hidden = !1, mr(this, Jt).style.zIndex = parseInt(mr(this, Jt).style.zIndex) + 1e3);
          }, yr = new WeakSet(), el = function() {
            mr(this, Jt).classList.remove("focused"), !(mr(this, tr) || !this.isVisible) && (mr(this, Jt).hidden = !0, mr(this, Jt).style.zIndex = parseInt(mr(this, Jt).style.zIndex) - 1e3);
          };
          class Et extends ut {
            constructor(Tr) {
              super(Tr, {
                isRenderable: !0,
                ignoreBorder: !0
              }), this.textContent = Tr.data.textContent, this.textPosition = Tr.data.textPosition, this.annotationEditorType = _.AnnotationEditorType.FREETEXT;
            }
            render() {
              if (this.container.classList.add("freeTextAnnotation"), this.textContent) {
                const Tr = document.createElement("div");
                Tr.classList.add("annotationTextContent"), Tr.setAttribute("role", "comment");
                for (const fr of this.textContent) {
                  const Cr = document.createElement("span");
                  Cr.textContent = fr, Tr.append(Cr);
                }
                this.container.append(Tr);
              }
              return !this.data.popupRef && this.hasPopupData && this._createPopup(), this._editOnDoubleClick(), this.container;
            }
          }
          s.FreeTextAnnotationElement = Et;
          class St extends ut {
            constructor(fr) {
              super(fr, {
                isRenderable: !0,
                ignoreBorder: !0
              });
              _r(this, br, null);
            }
            render() {
              this.container.classList.add("lineAnnotation");
              const fr = this.data, {
                width: Cr,
                height: $r
              } = et(fr.rect), wr = this.svgFactory.create(Cr, $r, !0), Mr = tn(this, br, this.svgFactory.createElement("svg:line"));
              return Mr.setAttribute("x1", fr.rect[2] - fr.lineCoordinates[0]), Mr.setAttribute("y1", fr.rect[3] - fr.lineCoordinates[1]), Mr.setAttribute("x2", fr.rect[2] - fr.lineCoordinates[2]), Mr.setAttribute("y2", fr.rect[3] - fr.lineCoordinates[3]), Mr.setAttribute("stroke-width", fr.borderStyle.width || 1), Mr.setAttribute("stroke", "transparent"), Mr.setAttribute("fill", "transparent"), wr.append(Mr), this.container.append(wr), !fr.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
            getElementsToTriggerPopup() {
              return mr(this, br);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          br = new WeakMap();
          class Bt extends ut {
            constructor(fr) {
              super(fr, {
                isRenderable: !0,
                ignoreBorder: !0
              });
              _r(this, gr, null);
            }
            render() {
              this.container.classList.add("squareAnnotation");
              const fr = this.data, {
                width: Cr,
                height: $r
              } = et(fr.rect), wr = this.svgFactory.create(Cr, $r, !0), Mr = fr.borderStyle.width, Fr = tn(this, gr, this.svgFactory.createElement("svg:rect"));
              return Fr.setAttribute("x", Mr / 2), Fr.setAttribute("y", Mr / 2), Fr.setAttribute("width", Cr - Mr), Fr.setAttribute("height", $r - Mr), Fr.setAttribute("stroke-width", Mr || 1), Fr.setAttribute("stroke", "transparent"), Fr.setAttribute("fill", "transparent"), wr.append(Fr), this.container.append(wr), !fr.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
            getElementsToTriggerPopup() {
              return mr(this, gr);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          gr = new WeakMap();
          class Ot extends ut {
            constructor(fr) {
              super(fr, {
                isRenderable: !0,
                ignoreBorder: !0
              });
              _r(this, Ar, null);
            }
            render() {
              this.container.classList.add("circleAnnotation");
              const fr = this.data, {
                width: Cr,
                height: $r
              } = et(fr.rect), wr = this.svgFactory.create(Cr, $r, !0), Mr = fr.borderStyle.width, Fr = tn(this, Ar, this.svgFactory.createElement("svg:ellipse"));
              return Fr.setAttribute("cx", Cr / 2), Fr.setAttribute("cy", $r / 2), Fr.setAttribute("rx", Cr / 2 - Mr / 2), Fr.setAttribute("ry", $r / 2 - Mr / 2), Fr.setAttribute("stroke-width", Mr || 1), Fr.setAttribute("stroke", "transparent"), Fr.setAttribute("fill", "transparent"), wr.append(Fr), this.container.append(wr), !fr.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
            getElementsToTriggerPopup() {
              return mr(this, Ar);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          Ar = new WeakMap();
          class Pt extends ut {
            constructor(fr) {
              super(fr, {
                isRenderable: !0,
                ignoreBorder: !0
              });
              _r(this, Sr, null);
              this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
            }
            render() {
              this.container.classList.add(this.containerClassName);
              const fr = this.data, {
                width: Cr,
                height: $r
              } = et(fr.rect), wr = this.svgFactory.create(Cr, $r, !0);
              let Mr = [];
              for (const Qr of fr.vertices) {
                const Yr = Qr.x - fr.rect[0], kr = fr.rect[3] - Qr.y;
                Mr.push(Yr + "," + kr);
              }
              Mr = Mr.join(" ");
              const Fr = tn(this, Sr, this.svgFactory.createElement(this.svgElementName));
              return Fr.setAttribute("points", Mr), Fr.setAttribute("stroke-width", fr.borderStyle.width || 1), Fr.setAttribute("stroke", "transparent"), Fr.setAttribute("fill", "transparent"), wr.append(Fr), this.container.append(wr), !fr.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
            getElementsToTriggerPopup() {
              return mr(this, Sr);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          Sr = new WeakMap();
          class wt extends Pt {
            constructor(Tr) {
              super(Tr), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
            }
          }
          class Ct extends ut {
            constructor(Tr) {
              super(Tr, {
                isRenderable: !0,
                ignoreBorder: !0
              });
            }
            render() {
              return this.container.classList.add("caretAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
          }
          class It extends ut {
            constructor(fr) {
              super(fr, {
                isRenderable: !0,
                ignoreBorder: !0
              });
              _r(this, Br, []);
              this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline", this.annotationEditorType = _.AnnotationEditorType.INK;
            }
            render() {
              this.container.classList.add(this.containerClassName);
              const fr = this.data, {
                width: Cr,
                height: $r
              } = et(fr.rect), wr = this.svgFactory.create(Cr, $r, !0);
              for (const Mr of fr.inkLists) {
                let Fr = [];
                for (const Yr of Mr) {
                  const kr = Yr.x - fr.rect[0], Nr = fr.rect[3] - Yr.y;
                  Fr.push(`${kr},${Nr}`);
                }
                Fr = Fr.join(" ");
                const Qr = this.svgFactory.createElement(this.svgElementName);
                mr(this, Br).push(Qr), Qr.setAttribute("points", Fr), Qr.setAttribute("stroke-width", fr.borderStyle.width || 1), Qr.setAttribute("stroke", "transparent"), Qr.setAttribute("fill", "transparent"), !fr.popupRef && this.hasPopupData && this._createPopup(), wr.append(Qr);
              }
              return this.container.append(wr), this.container;
            }
            getElementsToTriggerPopup() {
              return mr(this, Br);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          Br = new WeakMap(), s.InkAnnotationElement = It;
          class yt extends ut {
            constructor(Tr) {
              super(Tr, {
                isRenderable: !0,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("highlightAnnotation"), this.container;
            }
          }
          class Rt extends ut {
            constructor(Tr) {
              super(Tr, {
                isRenderable: !0,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("underlineAnnotation"), this.container;
            }
          }
          class kt extends ut {
            constructor(Tr) {
              super(Tr, {
                isRenderable: !0,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("squigglyAnnotation"), this.container;
            }
          }
          class jt extends ut {
            constructor(Tr) {
              super(Tr, {
                isRenderable: !0,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container.classList.add("strikeoutAnnotation"), this.container;
            }
          }
          class Ht extends ut {
            constructor(Tr) {
              super(Tr, {
                isRenderable: !0,
                ignoreBorder: !0
              });
            }
            render() {
              return this.container.classList.add("stampAnnotation"), !this.data.popupRef && this.hasPopupData && this._createPopup(), this.container;
            }
          }
          s.StampAnnotationElement = Ht;
          class Ft extends ut {
            constructor(fr) {
              var wr;
              super(fr, {
                isRenderable: !0
              });
              _r(this, hr);
              _r(this, Ir, null);
              const {
                filename: Cr,
                content: $r
              } = this.data.file;
              this.filename = (0, _e.getFilenameFromUrl)(Cr, !0), this.content = $r, (wr = this.linkService.eventBus) == null || wr.dispatch("fileattachmentannotation", {
                source: this,
                filename: Cr,
                content: $r
              });
            }
            render() {
              this.container.classList.add("fileAttachmentAnnotation");
              const {
                container: fr,
                data: Cr
              } = this;
              let $r;
              Cr.hasAppearance || Cr.fillAlpha === 0 ? $r = document.createElement("div") : ($r = document.createElement("img"), $r.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(Cr.name) ? "paperclip" : "pushpin"}.svg`, Cr.fillAlpha && Cr.fillAlpha < 1 && ($r.style = `filter: opacity(${Math.round(Cr.fillAlpha * 100)}%);`)), $r.addEventListener("dblclick", Ur(this, hr, tl).bind(this)), tn(this, Ir, $r);
              const {
                isMac: wr
              } = _.FeatureTest.platform;
              return fr.addEventListener("keydown", (Mr) => {
                Mr.key === "Enter" && (wr ? Mr.metaKey : Mr.ctrlKey) && Ur(this, hr, tl).call(this);
              }), !Cr.popupRef && this.hasPopupData ? this._createPopup() : $r.classList.add("popupTriggerArea"), fr.append($r), fr;
            }
            getElementsToTriggerPopup() {
              return mr(this, Ir);
            }
            addHighlightArea() {
              this.container.classList.add("highlightArea");
            }
          }
          Ir = new WeakMap(), hr = new WeakSet(), tl = function() {
            var fr;
            (fr = this.downloadManager) == null || fr.openOrDownloadData(this.container, this.content, this.filename);
          };
          class _t {
            constructor(Tr) {
              _r(this, Dr);
              _r(this, Or);
              _r(this, xr, null);
              _r(this, Pr, null);
              _r(this, Rr, /* @__PURE__ */ new Map());
              let {
                div: fr,
                accessibilityManager: Cr,
                annotationCanvasMap: $r,
                l10n: wr,
                page: Mr,
                viewport: Fr
              } = Tr;
              this.div = fr, tn(this, xr, Cr), tn(this, Pr, $r), this.l10n = wr, this.page = Mr, this.viewport = Fr, this.zIndex = 0, this.l10n || (this.l10n = at.NullL10n);
            }
            async render(Tr) {
              const {
                annotations: fr
              } = Tr, Cr = this.div;
              (0, _e.setLayerDimensions)(Cr, this.viewport);
              const $r = /* @__PURE__ */ new Map(), wr = {
                data: null,
                layer: Cr,
                linkService: Tr.linkService,
                downloadManager: Tr.downloadManager,
                imageResourcesPath: Tr.imageResourcesPath || "",
                renderForms: Tr.renderForms !== !1,
                svgFactory: new _e.DOMSVGFactory(),
                annotationStorage: Tr.annotationStorage || new tt.AnnotationStorage(),
                enableScripting: Tr.enableScripting === !0,
                hasJSActions: Tr.hasJSActions,
                fieldObjects: Tr.fieldObjects,
                parent: this,
                elements: null
              };
              for (const Mr of fr) {
                if (Mr.noHTML)
                  continue;
                const Fr = Mr.annotationType === _.AnnotationType.POPUP;
                if (Fr) {
                  const kr = $r.get(Mr.id);
                  if (!kr)
                    continue;
                  wr.elements = kr;
                } else {
                  const {
                    width: kr,
                    height: Nr
                  } = et(Mr.rect);
                  if (kr <= 0 || Nr <= 0)
                    continue;
                }
                wr.data = Mr;
                const Qr = it.create(wr);
                if (!Qr.isRenderable)
                  continue;
                if (!Fr && Mr.popupRef) {
                  const kr = $r.get(Mr.popupRef);
                  kr ? kr.push(Qr) : $r.set(Mr.popupRef, [Qr]);
                }
                Qr.annotationEditorType > 0 && mr(this, Rr).set(Qr.data.id, Qr);
                const Yr = Qr.render();
                Mr.hidden && (Yr.style.visibility = "hidden"), Ur(this, Dr, Gl).call(this, Yr, Mr.id);
              }
              Ur(this, Or, rl).call(this), await this.l10n.translate(Cr);
            }
            update(Tr) {
              let {
                viewport: fr
              } = Tr;
              const Cr = this.div;
              this.viewport = fr, (0, _e.setLayerDimensions)(Cr, {
                rotation: fr.rotation
              }), Ur(this, Or, rl).call(this), Cr.hidden = !1;
            }
            getEditableAnnotations() {
              return Array.from(mr(this, Rr).values());
            }
            getEditableAnnotation(Tr) {
              return mr(this, Rr).get(Tr);
            }
          }
          xr = new WeakMap(), Pr = new WeakMap(), Rr = new WeakMap(), Dr = new WeakSet(), Gl = function(Tr, fr) {
            var $r;
            const Cr = Tr.firstChild || Tr;
            Cr.id = `${_.AnnotationPrefix}${fr}`, this.div.append(Tr), ($r = mr(this, xr)) == null || $r.moveElementInDOM(this.div, Tr, Cr, !1);
          }, Or = new WeakSet(), rl = function() {
            if (!mr(this, Pr))
              return;
            const Tr = this.div;
            for (const [fr, Cr] of mr(this, Pr)) {
              const $r = Tr.querySelector(`[data-annotation-id="${fr}"]`);
              if (!$r)
                continue;
              const {
                firstChild: wr
              } = $r;
              wr ? wr.nodeName === "CANVAS" ? wr.replaceWith(Cr) : wr.before(Cr) : $r.append(Cr);
            }
            mr(this, Pr).clear();
          }, s.AnnotationLayer = _t;
        },
        /* 199 */
        /***/
        (a, s) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.ColorConverters = void 0;
          function $(tt) {
            return Math.floor(Math.max(0, Math.min(1, tt)) * 255).toString(16).padStart(2, "0");
          }
          function _(tt) {
            return Math.max(0, Math.min(255, 255 * tt));
          }
          class _e {
            static CMYK_G(nt) {
              let [at, ot, rt, st] = nt;
              return ["G", 1 - Math.min(1, 0.3 * at + 0.59 * rt + 0.11 * ot + st)];
            }
            static G_CMYK(nt) {
              let [at] = nt;
              return ["CMYK", 0, 0, 0, 1 - at];
            }
            static G_RGB(nt) {
              let [at] = nt;
              return ["RGB", at, at, at];
            }
            static G_rgb(nt) {
              let [at] = nt;
              return at = _(at), [at, at, at];
            }
            static G_HTML(nt) {
              let [at] = nt;
              const ot = $(at);
              return `#${ot}${ot}${ot}`;
            }
            static RGB_G(nt) {
              let [at, ot, rt] = nt;
              return ["G", 0.3 * at + 0.59 * ot + 0.11 * rt];
            }
            static RGB_rgb(nt) {
              return nt.map(_);
            }
            static RGB_HTML(nt) {
              return `#${nt.map($).join("")}`;
            }
            static T_HTML() {
              return "#00000000";
            }
            static T_rgb() {
              return [null];
            }
            static CMYK_RGB(nt) {
              let [at, ot, rt, st] = nt;
              return ["RGB", 1 - Math.min(1, at + st), 1 - Math.min(1, rt + st), 1 - Math.min(1, ot + st)];
            }
            static CMYK_rgb(nt) {
              let [at, ot, rt, st] = nt;
              return [_(1 - Math.min(1, at + st)), _(1 - Math.min(1, rt + st)), _(1 - Math.min(1, ot + st))];
            }
            static CMYK_HTML(nt) {
              const at = this.CMYK_RGB(nt).slice(1);
              return this.RGB_HTML(at);
            }
            static RGB_CMYK(nt) {
              let [at, ot, rt] = nt;
              const st = 1 - at, lt = 1 - ot, et = 1 - rt, it = Math.min(st, lt, et);
              return ["CMYK", st, lt, et, it];
            }
          }
          s.ColorConverters = _e;
        },
        /* 200 */
        /***/
        (a, s) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.NullL10n = void 0, s.getL10nFallback = _;
          const $ = {
            of_pages: "of {{pagesCount}}",
            page_of_pages: "({{pageNumber}} of {{pagesCount}})",
            document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
            document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
            document_properties_date_string: "{{date}}, {{time}}",
            document_properties_page_size_unit_inches: "in",
            document_properties_page_size_unit_millimeters: "mm",
            document_properties_page_size_orientation_portrait: "portrait",
            document_properties_page_size_orientation_landscape: "landscape",
            document_properties_page_size_name_a3: "A3",
            document_properties_page_size_name_a4: "A4",
            document_properties_page_size_name_letter: "Letter",
            document_properties_page_size_name_legal: "Legal",
            document_properties_page_size_dimension_string: "{{width}} × {{height}} {{unit}} ({{orientation}})",
            document_properties_page_size_dimension_name_string: "{{width}} × {{height}} {{unit}} ({{name}}, {{orientation}})",
            document_properties_linearized_yes: "Yes",
            document_properties_linearized_no: "No",
            additional_layers: "Additional Layers",
            page_landmark: "Page {{page}}",
            thumb_page_title: "Page {{page}}",
            thumb_page_canvas: "Thumbnail of Page {{page}}",
            find_reached_top: "Reached top of document, continued from bottom",
            find_reached_bottom: "Reached end of document, continued from top",
            "find_match_count[one]": "{{current}} of {{total}} match",
            "find_match_count[other]": "{{current}} of {{total}} matches",
            "find_match_count_limit[one]": "More than {{limit}} match",
            "find_match_count_limit[other]": "More than {{limit}} matches",
            find_not_found: "Phrase not found",
            page_scale_width: "Page Width",
            page_scale_fit: "Page Fit",
            page_scale_auto: "Automatic Zoom",
            page_scale_actual: "Actual Size",
            page_scale_percent: "{{scale}}%",
            loading_error: "An error occurred while loading the PDF.",
            invalid_file_error: "Invalid or corrupted PDF file.",
            missing_file_error: "Missing PDF file.",
            unexpected_response_error: "Unexpected server response.",
            rendering_error: "An error occurred while rendering the page.",
            annotation_date_string: "{{date}}, {{time}}",
            printing_not_supported: "Warning: Printing is not fully supported by this browser.",
            printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
            web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
            free_text2_default_content: "Start typing…",
            editor_free_text2_aria_label: "Text Editor",
            editor_ink2_aria_label: "Draw Editor",
            editor_ink_canvas_aria_label: "User-created image",
            editor_alt_text_button_label: "Alt text",
            editor_alt_text_edit_button_label: "Edit alt text",
            editor_alt_text_decorative_tooltip: "Marked as decorative"
          };
          $.print_progress_percent = "{{progress}}%";
          function _(nt, at) {
            switch (nt) {
              case "find_match_count":
                nt = `find_match_count[${at.total === 1 ? "one" : "other"}]`;
                break;
              case "find_match_count_limit":
                nt = `find_match_count_limit[${at.limit === 1 ? "one" : "other"}]`;
                break;
            }
            return $[nt] || "";
          }
          function _e(nt, at) {
            return at ? nt.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (ot, rt) => rt in at ? at[rt] : "{{" + rt + "}}") : nt;
          }
          const tt = {
            async getLanguage() {
              return "en-us";
            },
            async getDirection() {
              return "ltr";
            },
            async get(nt) {
              let at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, ot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _(nt, at);
              return _e(ot, at);
            },
            async translate(nt) {
            }
          };
          s.NullL10n = tt;
        },
        /* 201 */
        /***/
        (a, s, $) => {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.XfaLayer = void 0, $(89);
          var _ = $(194);
          class _e {
            static setupStorage(nt, at, ot, rt, st) {
              const lt = rt.getValue(at, {
                value: null
              });
              switch (ot.name) {
                case "textarea":
                  if (lt.value !== null && (nt.textContent = lt.value), st === "print")
                    break;
                  nt.addEventListener("input", (et) => {
                    rt.setValue(at, {
                      value: et.target.value
                    });
                  });
                  break;
                case "input":
                  if (ot.attributes.type === "radio" || ot.attributes.type === "checkbox") {
                    if (lt.value === ot.attributes.xfaOn ? nt.setAttribute("checked", !0) : lt.value === ot.attributes.xfaOff && nt.removeAttribute("checked"), st === "print")
                      break;
                    nt.addEventListener("change", (et) => {
                      rt.setValue(at, {
                        value: et.target.checked ? et.target.getAttribute("xfaOn") : et.target.getAttribute("xfaOff")
                      });
                    });
                  } else {
                    if (lt.value !== null && nt.setAttribute("value", lt.value), st === "print")
                      break;
                    nt.addEventListener("input", (et) => {
                      rt.setValue(at, {
                        value: et.target.value
                      });
                    });
                  }
                  break;
                case "select":
                  if (lt.value !== null) {
                    nt.setAttribute("value", lt.value);
                    for (const et of ot.children)
                      et.attributes.value === lt.value ? et.attributes.selected = !0 : et.attributes.hasOwnProperty("selected") && delete et.attributes.selected;
                  }
                  nt.addEventListener("input", (et) => {
                    const it = et.target.options, ut = it.selectedIndex === -1 ? "" : it[it.selectedIndex].value;
                    rt.setValue(at, {
                      value: ut
                    });
                  });
                  break;
              }
            }
            static setAttributes(nt) {
              let {
                html: at,
                element: ot,
                storage: rt = null,
                intent: st,
                linkService: lt
              } = nt;
              const {
                attributes: et
              } = ot, it = at instanceof HTMLAnchorElement;
              et.type === "radio" && (et.name = `${et.name}-${st}`);
              for (const [ut, ft] of Object.entries(et))
                if (ft != null)
                  switch (ut) {
                    case "class":
                      ft.length && at.setAttribute(ut, ft.join(" "));
                      break;
                    case "dataId":
                      break;
                    case "id":
                      at.setAttribute("data-element-id", ft);
                      break;
                    case "style":
                      Object.assign(at.style, ft);
                      break;
                    case "textContent":
                      at.textContent = ft;
                      break;
                    default:
                      (!it || ut !== "href" && ut !== "newWindow") && at.setAttribute(ut, ft);
                  }
              it && lt.addLinkAttributes(at, et.href, et.newWindow), rt && et.dataId && this.setupStorage(at, et.dataId, ot, rt);
            }
            static render(nt) {
              var ft;
              const at = nt.annotationStorage, ot = nt.linkService, rt = nt.xfaHtml, st = nt.intent || "display", lt = document.createElement(rt.name);
              rt.attributes && this.setAttributes({
                html: lt,
                element: rt,
                intent: st,
                linkService: ot
              });
              const et = [[rt, -1, lt]], it = nt.div;
              if (it.append(lt), nt.viewport) {
                const ht = `matrix(${nt.viewport.transform.join(",")})`;
                it.style.transform = ht;
              }
              st !== "richText" && it.setAttribute("class", "xfaLayer xfaFont");
              const ut = [];
              for (; et.length > 0; ) {
                const [ht, dt, gt] = et.at(-1);
                if (dt + 1 === ht.children.length) {
                  et.pop();
                  continue;
                }
                const pt = ht.children[++et.at(-1)[1]];
                if (pt === null)
                  continue;
                const {
                  name: mt
                } = pt;
                if (mt === "#text") {
                  const vt = document.createTextNode(pt.value);
                  ut.push(vt), gt.append(vt);
                  continue;
                }
                const ct = (ft = pt == null ? void 0 : pt.attributes) != null && ft.xmlns ? document.createElementNS(pt.attributes.xmlns, mt) : document.createElement(mt);
                if (gt.append(ct), pt.attributes && this.setAttributes({
                  html: ct,
                  element: pt,
                  storage: at,
                  intent: st,
                  linkService: ot
                }), pt.children && pt.children.length > 0)
                  et.push([pt, -1, ct]);
                else if (pt.value) {
                  const vt = document.createTextNode(pt.value);
                  _.XfaText.shouldBuildText(mt) && ut.push(vt), ct.append(vt);
                }
              }
              for (const ht of it.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
                ht.setAttribute("readOnly", !0);
              return {
                textDivs: ut
              };
            }
            static update(nt) {
              const at = `matrix(${nt.viewport.transform.join(",")})`;
              nt.div.style.transform = at, nt.div.hidden = !1;
            }
          }
          s.XfaLayer = _e;
        },
        /* 202 */
        /***/
        (a, s, $) => {
          var rt, st, lt, et, it, ut, ft, ht, dt, gt, pt, mt, ct, vt, At, Vl, bt, Ql, St, Yl, Ot, Kl, wt, nl, It, Xl, Rt, al, jt, Zl, Ft, ql, Nt, Jl, Lt, _c, Tt, Xc, Ut, To, Qt, il, Zt, hs, Jt, ps, Yt, jo, nr, ol, ir, gs, cr, eu, Xt, sl, Wt, tu, lr, ru, pr, ll, Er, ms, gr, Uo;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.InkEditor = void 0, $(89), $(2);
          var _ = $(1), _e = $(164), tt = $(198), nt = $(168), at = $(165);
          const Sr = class Sr extends _e.AnnotationEditor {
            constructor(hr) {
              super({
                ...hr,
                name: "inkEditor"
              });
              _r(this, At);
              _r(this, bt);
              _r(this, St);
              _r(this, Ot);
              _r(this, wt);
              _r(this, It);
              _r(this, Rt);
              _r(this, jt);
              _r(this, Ft);
              _r(this, Nt);
              _r(this, Lt);
              _r(this, Tt);
              _r(this, Ut);
              _r(this, Qt);
              _r(this, Zt);
              _r(this, Jt);
              _r(this, Yt);
              _r(this, nr);
              _r(this, ir);
              _r(this, lr);
              _r(this, pr);
              _r(this, Er);
              _r(this, gr);
              _r(this, rt, 0);
              _r(this, st, 0);
              _r(this, lt, this.canvasPointermove.bind(this));
              _r(this, et, this.canvasPointerleave.bind(this));
              _r(this, it, this.canvasPointerup.bind(this));
              _r(this, ut, this.canvasPointerdown.bind(this));
              _r(this, ft, new Path2D());
              _r(this, ht, !1);
              _r(this, dt, !1);
              _r(this, gt, !1);
              _r(this, pt, null);
              _r(this, mt, 0);
              _r(this, ct, 0);
              _r(this, vt, null);
              this.color = hr.color || null, this.thickness = hr.thickness || null, this.opacity = hr.opacity || null, this.paths = [], this.bezierPath2D = [], this.allRawPaths = [], this.currentPath = [], this.scaleFactor = 1, this.translationX = this.translationY = 0, this.x = 0, this.y = 0, this._willKeepAspectRatio = !0;
            }
            static initialize(hr) {
              _e.AnnotationEditor.initialize(hr, {
                strings: ["editor_ink_canvas_aria_label", "editor_ink2_aria_label"]
              });
            }
            static updateDefaultParams(hr, vr) {
              switch (hr) {
                case _.AnnotationEditorParamsType.INK_THICKNESS:
                  Sr._defaultThickness = vr;
                  break;
                case _.AnnotationEditorParamsType.INK_COLOR:
                  Sr._defaultColor = vr;
                  break;
                case _.AnnotationEditorParamsType.INK_OPACITY:
                  Sr._defaultOpacity = vr / 100;
                  break;
              }
            }
            updateParams(hr, vr) {
              switch (hr) {
                case _.AnnotationEditorParamsType.INK_THICKNESS:
                  Ur(this, At, Vl).call(this, vr);
                  break;
                case _.AnnotationEditorParamsType.INK_COLOR:
                  Ur(this, bt, Ql).call(this, vr);
                  break;
                case _.AnnotationEditorParamsType.INK_OPACITY:
                  Ur(this, St, Yl).call(this, vr);
                  break;
              }
            }
            static get defaultPropertiesToUpdate() {
              return [[_.AnnotationEditorParamsType.INK_THICKNESS, Sr._defaultThickness], [_.AnnotationEditorParamsType.INK_COLOR, Sr._defaultColor || _e.AnnotationEditor._defaultLineColor], [_.AnnotationEditorParamsType.INK_OPACITY, Math.round(Sr._defaultOpacity * 100)]];
            }
            get propertiesToUpdate() {
              return [[_.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || Sr._defaultThickness], [_.AnnotationEditorParamsType.INK_COLOR, this.color || Sr._defaultColor || _e.AnnotationEditor._defaultLineColor], [_.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? Sr._defaultOpacity))]];
            }
            rebuild() {
              this.parent && (super.rebuild(), this.div !== null && (this.canvas || (Ur(this, Zt, hs).call(this), Ur(this, Jt, ps).call(this)), this.isAttachedToDOM || (this.parent.add(this), Ur(this, Yt, jo).call(this)), Ur(this, gr, Uo).call(this)));
            }
            remove() {
              this.canvas !== null && (this.isEmpty() || this.commit(), this.canvas.width = this.canvas.height = 0, this.canvas.remove(), this.canvas = null, mr(this, pt).disconnect(), tn(this, pt, null), super.remove());
            }
            setParent(hr) {
              !this.parent && hr ? this._uiManager.removeShouldRescale(this) : this.parent && hr === null && this._uiManager.addShouldRescale(this), super.setParent(hr);
            }
            onScaleChanging() {
              const [hr, vr] = this.parentDimensions, xr = this.width * hr, Pr = this.height * vr;
              this.setDimensions(xr, Pr);
            }
            enableEditMode() {
              mr(this, ht) || this.canvas === null || (super.enableEditMode(), this._isDraggable = !1, this.canvas.addEventListener("pointerdown", mr(this, ut)));
            }
            disableEditMode() {
              !this.isInEditMode() || this.canvas === null || (super.disableEditMode(), this._isDraggable = !this.isEmpty(), this.div.classList.remove("editing"), this.canvas.removeEventListener("pointerdown", mr(this, ut)));
            }
            onceAdded() {
              this._isDraggable = !this.isEmpty();
            }
            isEmpty() {
              return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
            }
            commit() {
              mr(this, ht) || (super.commit(), this.isEditing = !1, this.disableEditMode(), this.setInForeground(), tn(this, ht, !0), this.div.classList.add("disabled"), Ur(this, gr, Uo).call(this, !0), this.makeResizable(), this.parent.addInkEditorIfNeeded(!0), this.moveInDOM(), this.div.focus({
                preventScroll: !0
              }));
            }
            focusin(hr) {
              this._focusEventsAllowed && (super.focusin(hr), this.enableEditMode());
            }
            canvasPointerdown(hr) {
              hr.button !== 0 || !this.isInEditMode() || mr(this, ht) || (this.setInForeground(), hr.preventDefault(), hr.type !== "mouse" && this.div.focus(), Ur(this, It, Xl).call(this, hr.offsetX, hr.offsetY));
            }
            canvasPointermove(hr) {
              hr.preventDefault(), Ur(this, Rt, al).call(this, hr.offsetX, hr.offsetY);
            }
            canvasPointerup(hr) {
              hr.preventDefault(), Ur(this, Qt, il).call(this, hr);
            }
            canvasPointerleave(hr) {
              Ur(this, Qt, il).call(this, hr);
            }
            get isResizable() {
              return !this.isEmpty() && mr(this, ht);
            }
            render() {
              if (this.div)
                return this.div;
              let hr, vr;
              this.width && (hr = this.x, vr = this.y), super.render(), _e.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((Gr) => {
                var Or;
                return (Or = this.div) == null ? void 0 : Or.setAttribute("aria-label", Gr);
              });
              const [xr, Pr, Rr, Dr] = Ur(this, Ot, Kl).call(this);
              if (this.setAt(xr, Pr, 0, 0), this.setDims(Rr, Dr), Ur(this, Zt, hs).call(this), this.width) {
                const [Gr, Or] = this.parentDimensions;
                this.setAspectRatio(this.width * Gr, this.height * Or), this.setAt(hr * Gr, vr * Or, this.width * Gr, this.height * Or), tn(this, gt, !0), Ur(this, Yt, jo).call(this), this.setDims(this.width * Gr, this.height * Or), Ur(this, Ut, To).call(this), this.div.classList.add("disabled");
              } else
                this.div.classList.add("editing"), this.enableEditMode();
              return Ur(this, Jt, ps).call(this), this.div;
            }
            setDimensions(hr, vr) {
              const xr = Math.round(hr), Pr = Math.round(vr);
              if (mr(this, mt) === xr && mr(this, ct) === Pr)
                return;
              tn(this, mt, xr), tn(this, ct, Pr), this.canvas.style.visibility = "hidden";
              const [Rr, Dr] = this.parentDimensions;
              this.width = hr / Rr, this.height = vr / Dr, this.fixAndSetPosition(), mr(this, ht) && Ur(this, nr, ol).call(this, hr, vr), Ur(this, Yt, jo).call(this), Ur(this, Ut, To).call(this), this.canvas.style.visibility = "visible", this.fixDims();
            }
            static deserialize(hr, vr, xr) {
              var wr, Mr, Fr;
              if (hr instanceof tt.InkAnnotationElement)
                return null;
              const Pr = super.deserialize(hr, vr, xr);
              Pr.thickness = hr.thickness, Pr.color = _.Util.makeHexColor(...hr.color), Pr.opacity = hr.opacity;
              const [Rr, Dr] = Pr.pageDimensions, Gr = Pr.width * Rr, Or = Pr.height * Dr, Hr = Pr.parentScale, jr = hr.thickness / 2;
              tn(Pr, ht, !0), tn(Pr, mt, Math.round(Gr)), tn(Pr, ct, Math.round(Or));
              const {
                paths: Tr,
                rect: fr,
                rotation: Cr
              } = hr;
              for (let {
                bezier: Qr
              } of Tr) {
                Qr = Ur(wr = Sr, Wt, tu).call(wr, Qr, fr, Cr);
                const Yr = [];
                Pr.paths.push(Yr);
                let kr = Hr * (Qr[0] - jr), Nr = Hr * (Qr[1] - jr);
                for (let zr = 2, Vr = Qr.length; zr < Vr; zr += 6) {
                  const an = Hr * (Qr[zr] - jr), Zr = Hr * (Qr[zr + 1] - jr), un = Hr * (Qr[zr + 2] - jr), Xr = Hr * (Qr[zr + 3] - jr), Kr = Hr * (Qr[zr + 4] - jr), rn = Hr * (Qr[zr + 5] - jr);
                  Yr.push([[kr, Nr], [an, Zr], [un, Xr], [Kr, rn]]), kr = Kr, Nr = rn;
                }
                const Lr = Ur(this, cr, eu).call(this, Yr);
                Pr.bezierPath2D.push(Lr);
              }
              const $r = Ur(Mr = Pr, pr, ll).call(Mr);
              return tn(Pr, st, Math.max(_e.AnnotationEditor.MIN_SIZE, $r[2] - $r[0])), tn(Pr, rt, Math.max(_e.AnnotationEditor.MIN_SIZE, $r[3] - $r[1])), Ur(Fr = Pr, nr, ol).call(Fr, Gr, Or), Pr;
            }
            serialize() {
              if (this.isEmpty())
                return null;
              const hr = this.getRect(0, 0), vr = _e.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
              return {
                annotationType: _.AnnotationEditorType.INK,
                color: vr,
                thickness: this.thickness,
                opacity: this.opacity,
                paths: Ur(this, lr, ru).call(this, this.scaleFactor / this.parentScale, this.translationX, this.translationY, hr),
                pageIndex: this.pageIndex,
                rect: hr,
                rotation: this.rotation,
                structTreeParentId: this._structTreeParentId
              };
            }
          };
          rt = new WeakMap(), st = new WeakMap(), lt = new WeakMap(), et = new WeakMap(), it = new WeakMap(), ut = new WeakMap(), ft = new WeakMap(), ht = new WeakMap(), dt = new WeakMap(), gt = new WeakMap(), pt = new WeakMap(), mt = new WeakMap(), ct = new WeakMap(), vt = new WeakMap(), At = new WeakSet(), Vl = function(hr) {
            const vr = this.thickness;
            this.addCommands({
              cmd: () => {
                this.thickness = hr, Ur(this, gr, Uo).call(this);
              },
              undo: () => {
                this.thickness = vr, Ur(this, gr, Uo).call(this);
              },
              mustExec: !0,
              type: _.AnnotationEditorParamsType.INK_THICKNESS,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, bt = new WeakSet(), Ql = function(hr) {
            const vr = this.color;
            this.addCommands({
              cmd: () => {
                this.color = hr, Ur(this, Ut, To).call(this);
              },
              undo: () => {
                this.color = vr, Ur(this, Ut, To).call(this);
              },
              mustExec: !0,
              type: _.AnnotationEditorParamsType.INK_COLOR,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, St = new WeakSet(), Yl = function(hr) {
            hr /= 100;
            const vr = this.opacity;
            this.addCommands({
              cmd: () => {
                this.opacity = hr, Ur(this, Ut, To).call(this);
              },
              undo: () => {
                this.opacity = vr, Ur(this, Ut, To).call(this);
              },
              mustExec: !0,
              type: _.AnnotationEditorParamsType.INK_OPACITY,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, Ot = new WeakSet(), Kl = function() {
            const {
              parentRotation: hr,
              parentDimensions: [vr, xr]
            } = this;
            switch (hr) {
              case 90:
                return [0, xr, xr, vr];
              case 180:
                return [vr, xr, vr, xr];
              case 270:
                return [vr, 0, xr, vr];
              default:
                return [0, 0, vr, xr];
            }
          }, wt = new WeakSet(), nl = function() {
            const {
              ctx: hr,
              color: vr,
              opacity: xr,
              thickness: Pr,
              parentScale: Rr,
              scaleFactor: Dr
            } = this;
            hr.lineWidth = Pr * Rr / Dr, hr.lineCap = "round", hr.lineJoin = "round", hr.miterLimit = 10, hr.strokeStyle = `${vr}${(0, at.opacityToHex)(xr)}`;
          }, It = new WeakSet(), Xl = function(hr, vr) {
            this.canvas.addEventListener("contextmenu", nt.noContextMenu), this.canvas.addEventListener("pointerleave", mr(this, et)), this.canvas.addEventListener("pointermove", mr(this, lt)), this.canvas.addEventListener("pointerup", mr(this, it)), this.canvas.removeEventListener("pointerdown", mr(this, ut)), this.isEditing = !0, mr(this, gt) || (tn(this, gt, !0), Ur(this, Yt, jo).call(this), this.thickness || (this.thickness = Sr._defaultThickness), this.color || (this.color = Sr._defaultColor || _e.AnnotationEditor._defaultLineColor), this.opacity ?? (this.opacity = Sr._defaultOpacity)), this.currentPath.push([hr, vr]), tn(this, dt, !1), Ur(this, wt, nl).call(this), tn(this, vt, () => {
              Ur(this, Nt, Jl).call(this), mr(this, vt) && window.requestAnimationFrame(mr(this, vt));
            }), window.requestAnimationFrame(mr(this, vt));
          }, Rt = new WeakSet(), al = function(hr, vr) {
            const [xr, Pr] = this.currentPath.at(-1);
            if (this.currentPath.length > 1 && hr === xr && vr === Pr)
              return;
            const Rr = this.currentPath;
            let Dr = mr(this, ft);
            if (Rr.push([hr, vr]), tn(this, dt, !0), Rr.length <= 2) {
              Dr.moveTo(...Rr[0]), Dr.lineTo(hr, vr);
              return;
            }
            Rr.length === 3 && (tn(this, ft, Dr = new Path2D()), Dr.moveTo(...Rr[0])), Ur(this, Lt, _c).call(this, Dr, ...Rr.at(-3), ...Rr.at(-2), hr, vr);
          }, jt = new WeakSet(), Zl = function() {
            if (this.currentPath.length === 0)
              return;
            const hr = this.currentPath.at(-1);
            mr(this, ft).lineTo(...hr);
          }, Ft = new WeakSet(), ql = function(hr, vr) {
            tn(this, vt, null), hr = Math.min(Math.max(hr, 0), this.canvas.width), vr = Math.min(Math.max(vr, 0), this.canvas.height), Ur(this, Rt, al).call(this, hr, vr), Ur(this, jt, Zl).call(this);
            let xr;
            if (this.currentPath.length !== 1)
              xr = Ur(this, Tt, Xc).call(this);
            else {
              const Or = [hr, vr];
              xr = [[Or, Or.slice(), Or.slice(), Or]];
            }
            const Pr = mr(this, ft), Rr = this.currentPath;
            this.currentPath = [], tn(this, ft, new Path2D());
            const Dr = () => {
              this.allRawPaths.push(Rr), this.paths.push(xr), this.bezierPath2D.push(Pr), this.rebuild();
            }, Gr = () => {
              this.allRawPaths.pop(), this.paths.pop(), this.bezierPath2D.pop(), this.paths.length === 0 ? this.remove() : (this.canvas || (Ur(this, Zt, hs).call(this), Ur(this, Jt, ps).call(this)), Ur(this, gr, Uo).call(this));
            };
            this.addCommands({
              cmd: Dr,
              undo: Gr,
              mustExec: !0
            });
          }, Nt = new WeakSet(), Jl = function() {
            if (!mr(this, dt))
              return;
            tn(this, dt, !1);
            const hr = Math.ceil(this.thickness * this.parentScale), vr = this.currentPath.slice(-3), xr = vr.map((Dr) => Dr[0]), Pr = vr.map((Dr) => Dr[1]);
            Math.min(...xr) - hr, Math.max(...xr) + hr, Math.min(...Pr) - hr, Math.max(...Pr) + hr;
            const {
              ctx: Rr
            } = this;
            Rr.save(), Rr.clearRect(0, 0, this.canvas.width, this.canvas.height);
            for (const Dr of this.bezierPath2D)
              Rr.stroke(Dr);
            Rr.stroke(mr(this, ft)), Rr.restore();
          }, Lt = new WeakSet(), _c = function(hr, vr, xr, Pr, Rr, Dr, Gr) {
            const Or = (vr + Pr) / 2, Hr = (xr + Rr) / 2, jr = (Pr + Dr) / 2, Tr = (Rr + Gr) / 2;
            hr.bezierCurveTo(Or + 2 * (Pr - Or) / 3, Hr + 2 * (Rr - Hr) / 3, jr + 2 * (Pr - jr) / 3, Tr + 2 * (Rr - Tr) / 3, jr, Tr);
          }, Tt = new WeakSet(), Xc = function() {
            const hr = this.currentPath;
            if (hr.length <= 2)
              return [[hr[0], hr[0], hr.at(-1), hr.at(-1)]];
            const vr = [];
            let xr, [Pr, Rr] = hr[0];
            for (xr = 1; xr < hr.length - 2; xr++) {
              const [fr, Cr] = hr[xr], [$r, wr] = hr[xr + 1], Mr = (fr + $r) / 2, Fr = (Cr + wr) / 2, Qr = [Pr + 2 * (fr - Pr) / 3, Rr + 2 * (Cr - Rr) / 3], Yr = [Mr + 2 * (fr - Mr) / 3, Fr + 2 * (Cr - Fr) / 3];
              vr.push([[Pr, Rr], Qr, Yr, [Mr, Fr]]), [Pr, Rr] = [Mr, Fr];
            }
            const [Dr, Gr] = hr[xr], [Or, Hr] = hr[xr + 1], jr = [Pr + 2 * (Dr - Pr) / 3, Rr + 2 * (Gr - Rr) / 3], Tr = [Or + 2 * (Dr - Or) / 3, Hr + 2 * (Gr - Hr) / 3];
            return vr.push([[Pr, Rr], jr, Tr, [Or, Hr]]), vr;
          }, Ut = new WeakSet(), To = function() {
            if (this.isEmpty()) {
              Ur(this, ir, gs).call(this);
              return;
            }
            Ur(this, wt, nl).call(this);
            const {
              canvas: hr,
              ctx: vr
            } = this;
            vr.setTransform(1, 0, 0, 1, 0, 0), vr.clearRect(0, 0, hr.width, hr.height), Ur(this, ir, gs).call(this);
            for (const xr of this.bezierPath2D)
              vr.stroke(xr);
          }, Qt = new WeakSet(), il = function(hr) {
            this.canvas.removeEventListener("pointerleave", mr(this, et)), this.canvas.removeEventListener("pointermove", mr(this, lt)), this.canvas.removeEventListener("pointerup", mr(this, it)), this.canvas.addEventListener("pointerdown", mr(this, ut)), setTimeout(() => {
              this.canvas.removeEventListener("contextmenu", nt.noContextMenu);
            }, 10), Ur(this, Ft, ql).call(this, hr.offsetX, hr.offsetY), this.addToAnnotationStorage(), this.setInBackground();
          }, Zt = new WeakSet(), hs = function() {
            this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = 0, this.canvas.className = "inkEditorCanvas", _e.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((hr) => {
              var vr;
              return (vr = this.canvas) == null ? void 0 : vr.setAttribute("aria-label", hr);
            }), this.div.append(this.canvas), this.ctx = this.canvas.getContext("2d");
          }, Jt = new WeakSet(), ps = function() {
            tn(this, pt, new ResizeObserver((hr) => {
              const vr = hr[0].contentRect;
              vr.width && vr.height && this.setDimensions(vr.width, vr.height);
            })), mr(this, pt).observe(this.div);
          }, Yt = new WeakSet(), jo = function() {
            if (!mr(this, gt))
              return;
            const [hr, vr] = this.parentDimensions;
            this.canvas.width = Math.ceil(this.width * hr), this.canvas.height = Math.ceil(this.height * vr), Ur(this, ir, gs).call(this);
          }, nr = new WeakSet(), ol = function(hr, vr) {
            const xr = Ur(this, Er, ms).call(this), Pr = (hr - xr) / mr(this, st), Rr = (vr - xr) / mr(this, rt);
            this.scaleFactor = Math.min(Pr, Rr);
          }, ir = new WeakSet(), gs = function() {
            const hr = Ur(this, Er, ms).call(this) / 2;
            this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + hr, this.translationY * this.scaleFactor + hr);
          }, cr = new WeakSet(), eu = function(hr) {
            const vr = new Path2D();
            for (let xr = 0, Pr = hr.length; xr < Pr; xr++) {
              const [Rr, Dr, Gr, Or] = hr[xr];
              xr === 0 && vr.moveTo(...Rr), vr.bezierCurveTo(Dr[0], Dr[1], Gr[0], Gr[1], Or[0], Or[1]);
            }
            return vr;
          }, Xt = new WeakSet(), sl = function(hr, vr, xr) {
            const [Pr, Rr, Dr, Gr] = vr;
            switch (xr) {
              case 0:
                for (let Or = 0, Hr = hr.length; Or < Hr; Or += 2)
                  hr[Or] += Pr, hr[Or + 1] = Gr - hr[Or + 1];
                break;
              case 90:
                for (let Or = 0, Hr = hr.length; Or < Hr; Or += 2) {
                  const jr = hr[Or];
                  hr[Or] = hr[Or + 1] + Pr, hr[Or + 1] = jr + Rr;
                }
                break;
              case 180:
                for (let Or = 0, Hr = hr.length; Or < Hr; Or += 2)
                  hr[Or] = Dr - hr[Or], hr[Or + 1] += Rr;
                break;
              case 270:
                for (let Or = 0, Hr = hr.length; Or < Hr; Or += 2) {
                  const jr = hr[Or];
                  hr[Or] = Dr - hr[Or + 1], hr[Or + 1] = Gr - jr;
                }
                break;
              default:
                throw new Error("Invalid rotation");
            }
            return hr;
          }, Wt = new WeakSet(), tu = function(hr, vr, xr) {
            const [Pr, Rr, Dr, Gr] = vr;
            switch (xr) {
              case 0:
                for (let Or = 0, Hr = hr.length; Or < Hr; Or += 2)
                  hr[Or] -= Pr, hr[Or + 1] = Gr - hr[Or + 1];
                break;
              case 90:
                for (let Or = 0, Hr = hr.length; Or < Hr; Or += 2) {
                  const jr = hr[Or];
                  hr[Or] = hr[Or + 1] - Rr, hr[Or + 1] = jr - Pr;
                }
                break;
              case 180:
                for (let Or = 0, Hr = hr.length; Or < Hr; Or += 2)
                  hr[Or] = Dr - hr[Or], hr[Or + 1] -= Rr;
                break;
              case 270:
                for (let Or = 0, Hr = hr.length; Or < Hr; Or += 2) {
                  const jr = hr[Or];
                  hr[Or] = Gr - hr[Or + 1], hr[Or + 1] = Dr - jr;
                }
                break;
              default:
                throw new Error("Invalid rotation");
            }
            return hr;
          }, lr = new WeakSet(), ru = function(hr, vr, xr, Pr) {
            var Hr, jr;
            const Rr = [], Dr = this.thickness / 2, Gr = hr * vr + Dr, Or = hr * xr + Dr;
            for (const Tr of this.paths) {
              const fr = [], Cr = [];
              for (let $r = 0, wr = Tr.length; $r < wr; $r++) {
                const [Mr, Fr, Qr, Yr] = Tr[$r], kr = hr * Mr[0] + Gr, Nr = hr * Mr[1] + Or, Lr = hr * Fr[0] + Gr, zr = hr * Fr[1] + Or, Vr = hr * Qr[0] + Gr, an = hr * Qr[1] + Or, Zr = hr * Yr[0] + Gr, un = hr * Yr[1] + Or;
                $r === 0 && (fr.push(kr, Nr), Cr.push(kr, Nr)), fr.push(Lr, zr, Vr, an, Zr, un), Cr.push(Lr, zr), $r === wr - 1 && Cr.push(Zr, un);
              }
              Rr.push({
                bezier: Ur(Hr = Sr, Xt, sl).call(Hr, fr, Pr, this.rotation),
                points: Ur(jr = Sr, Xt, sl).call(jr, Cr, Pr, this.rotation)
              });
            }
            return Rr;
          }, pr = new WeakSet(), ll = function() {
            let hr = 1 / 0, vr = -1 / 0, xr = 1 / 0, Pr = -1 / 0;
            for (const Rr of this.paths)
              for (const [Dr, Gr, Or, Hr] of Rr) {
                const jr = _.Util.bezierBoundingBox(...Dr, ...Gr, ...Or, ...Hr);
                hr = Math.min(hr, jr[0]), xr = Math.min(xr, jr[1]), vr = Math.max(vr, jr[2]), Pr = Math.max(Pr, jr[3]);
              }
            return [hr, xr, vr, Pr];
          }, Er = new WeakSet(), ms = function() {
            return mr(this, ht) ? Math.ceil(this.thickness * this.parentScale) : 0;
          }, gr = new WeakSet(), Uo = function() {
            let hr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
            if (this.isEmpty())
              return;
            if (!mr(this, ht)) {
              Ur(this, Ut, To).call(this);
              return;
            }
            const vr = Ur(this, pr, ll).call(this), xr = Ur(this, Er, ms).call(this);
            tn(this, st, Math.max(_e.AnnotationEditor.MIN_SIZE, vr[2] - vr[0])), tn(this, rt, Math.max(_e.AnnotationEditor.MIN_SIZE, vr[3] - vr[1]));
            const Pr = Math.ceil(xr + mr(this, st) * this.scaleFactor), Rr = Math.ceil(xr + mr(this, rt) * this.scaleFactor), [Dr, Gr] = this.parentDimensions;
            this.width = Pr / Dr, this.height = Rr / Gr, this.setAspectRatio(Pr, Rr);
            const Or = this.translationX, Hr = this.translationY;
            this.translationX = -vr[0], this.translationY = -vr[1], Ur(this, Yt, jo).call(this), Ur(this, Ut, To).call(this), tn(this, mt, Pr), tn(this, ct, Rr), this.setDims(Pr, Rr);
            const jr = hr ? xr / this.scaleFactor / 2 : 0;
            this.translate(Or - this.translationX - jr, Hr - this.translationY - jr);
          }, _r(Sr, cr), _r(Sr, Xt), _r(Sr, Wt), Ln(Sr, "_defaultColor", null), Ln(Sr, "_defaultOpacity", 1), Ln(Sr, "_defaultThickness", 1), Ln(Sr, "_type", "ink");
          let ot = Sr;
          s.InkEditor = ot;
        },
        /* 203 */
        /***/
        (a, s, $) => {
          var ot, rt, st, lt, et, it, ut, ft, ht, dt, gt, Xo, mt, Zo, vt, As, xt, cl, Et, nu, Bt, au, Pt, ul, Ct, vs, yt, iu;
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.StampEditor = void 0, $(149), $(152);
          var _ = $(1), _e = $(164), tt = $(168), nt = $(198);
          const kt = class kt extends _e.AnnotationEditor {
            constructor(Ft) {
              super({
                ...Ft,
                name: "stampEditor"
              });
              _r(this, gt);
              _r(this, mt);
              _r(this, vt);
              _r(this, xt);
              _r(this, Et);
              _r(this, Bt);
              _r(this, Pt);
              _r(this, Ct);
              _r(this, yt);
              _r(this, ot, null);
              _r(this, rt, null);
              _r(this, st, null);
              _r(this, lt, null);
              _r(this, et, null);
              _r(this, it, null);
              _r(this, ut, null);
              _r(this, ft, null);
              _r(this, ht, !1);
              _r(this, dt, !1);
              tn(this, lt, Ft.bitmapUrl), tn(this, et, Ft.bitmapFile);
            }
            static initialize(Ft) {
              _e.AnnotationEditor.initialize(Ft);
            }
            static get supportedTypes() {
              const Ft = ["apng", "avif", "bmp", "gif", "jpeg", "png", "svg+xml", "webp", "x-icon"];
              return (0, _.shadow)(this, "supportedTypes", Ft.map((_t) => `image/${_t}`));
            }
            static get supportedTypesStr() {
              return (0, _.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
            }
            static isHandlingMimeForPasting(Ft) {
              return this.supportedTypes.includes(Ft);
            }
            static paste(Ft, _t) {
              _t.pasteEditor(_.AnnotationEditorType.STAMP, {
                bitmapFile: Ft.getAsFile()
              });
            }
            remove() {
              var Ft, _t;
              mr(this, rt) && (tn(this, ot, null), this._uiManager.imageManager.deleteId(mr(this, rt)), (Ft = mr(this, it)) == null || Ft.remove(), tn(this, it, null), (_t = mr(this, ut)) == null || _t.disconnect(), tn(this, ut, null)), super.remove();
            }
            rebuild() {
              if (!this.parent) {
                mr(this, rt) && Ur(this, vt, As).call(this);
                return;
              }
              super.rebuild(), this.div !== null && (mr(this, rt) && Ur(this, vt, As).call(this), this.isAttachedToDOM || this.parent.add(this));
            }
            onceAdded() {
              this._isDraggable = !0, this.div.focus();
            }
            isEmpty() {
              return !(mr(this, st) || mr(this, ot) || mr(this, lt) || mr(this, et));
            }
            get isResizable() {
              return !0;
            }
            render() {
              if (this.div)
                return this.div;
              let Ft, _t;
              if (this.width && (Ft = this.x, _t = this.y), super.render(), this.div.hidden = !0, mr(this, ot) ? Ur(this, xt, cl).call(this) : Ur(this, vt, As).call(this), this.width) {
                const [Nt, Mt] = this.parentDimensions;
                this.setAt(Ft * Nt, _t * Mt, this.width * Nt, this.height * Mt);
              }
              return this.div;
            }
            static deserialize(Ft, _t, Nt) {
              if (Ft instanceof nt.StampAnnotationElement)
                return null;
              const Mt = super.deserialize(Ft, _t, Nt), {
                rect: Lt,
                bitmapUrl: $t,
                bitmapId: Tt,
                isSvg: Dt,
                accessibilityData: Ut
              } = Ft;
              Tt && Nt.imageManager.isValidId(Tt) ? tn(Mt, rt, Tt) : tn(Mt, lt, $t), tn(Mt, ht, Dt);
              const [Vt, Qt] = Mt.pageDimensions;
              return Mt.width = (Lt[2] - Lt[0]) / Vt, Mt.height = (Lt[3] - Lt[1]) / Qt, Ut && (Mt.altTextData = Ut), Mt;
            }
            serialize() {
              let Ft = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, _t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
              if (this.isEmpty())
                return null;
              const Nt = {
                annotationType: _.AnnotationEditorType.STAMP,
                bitmapId: mr(this, rt),
                pageIndex: this.pageIndex,
                rect: this.getRect(0, 0),
                rotation: this.rotation,
                isSvg: mr(this, ht),
                structTreeParentId: this._structTreeParentId
              };
              if (Ft)
                return Nt.bitmapUrl = Ur(this, Ct, vs).call(this, !0), Nt.accessibilityData = this.altTextData, Nt;
              const {
                decorative: Mt,
                altText: Lt
              } = this.altTextData;
              if (!Mt && Lt && (Nt.accessibilityData = {
                type: "Figure",
                alt: Lt
              }), _t === null)
                return Nt;
              _t.stamps || (_t.stamps = /* @__PURE__ */ new Map());
              const $t = mr(this, ht) ? (Nt.rect[2] - Nt.rect[0]) * (Nt.rect[3] - Nt.rect[1]) : null;
              if (!_t.stamps.has(mr(this, rt)))
                _t.stamps.set(mr(this, rt), {
                  area: $t,
                  serialized: Nt
                }), Nt.bitmap = Ur(this, Ct, vs).call(this, !1);
              else if (mr(this, ht)) {
                const Tt = _t.stamps.get(mr(this, rt));
                $t > Tt.area && (Tt.area = $t, Tt.serialized.bitmap.close(), Tt.serialized.bitmap = Ur(this, Ct, vs).call(this, !1));
              }
              return Nt;
            }
          };
          ot = new WeakMap(), rt = new WeakMap(), st = new WeakMap(), lt = new WeakMap(), et = new WeakMap(), it = new WeakMap(), ut = new WeakMap(), ft = new WeakMap(), ht = new WeakMap(), dt = new WeakMap(), gt = new WeakSet(), Xo = function(Ft) {
            let _t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
            if (!Ft) {
              this.remove();
              return;
            }
            tn(this, ot, Ft.bitmap), _t || (tn(this, rt, Ft.id), tn(this, ht, Ft.isSvg)), Ur(this, xt, cl).call(this);
          }, mt = new WeakSet(), Zo = function() {
            tn(this, st, null), this._uiManager.enableWaiting(!1), mr(this, it) && this.div.focus();
          }, vt = new WeakSet(), As = function() {
            if (mr(this, rt)) {
              this._uiManager.enableWaiting(!0), this._uiManager.imageManager.getFromId(mr(this, rt)).then((_t) => Ur(this, gt, Xo).call(this, _t, !0)).finally(() => Ur(this, mt, Zo).call(this));
              return;
            }
            if (mr(this, lt)) {
              const _t = mr(this, lt);
              tn(this, lt, null), this._uiManager.enableWaiting(!0), tn(this, st, this._uiManager.imageManager.getFromUrl(_t).then((Nt) => Ur(this, gt, Xo).call(this, Nt)).finally(() => Ur(this, mt, Zo).call(this)));
              return;
            }
            if (mr(this, et)) {
              const _t = mr(this, et);
              tn(this, et, null), this._uiManager.enableWaiting(!0), tn(this, st, this._uiManager.imageManager.getFromFile(_t).then((Nt) => Ur(this, gt, Xo).call(this, Nt)).finally(() => Ur(this, mt, Zo).call(this)));
              return;
            }
            const Ft = document.createElement("input");
            Ft.type = "file", Ft.accept = kt.supportedTypesStr, tn(this, st, new Promise((_t) => {
              Ft.addEventListener("change", async () => {
                if (!Ft.files || Ft.files.length === 0)
                  this.remove();
                else {
                  this._uiManager.enableWaiting(!0);
                  const Nt = await this._uiManager.imageManager.getFromFile(Ft.files[0]);
                  Ur(this, gt, Xo).call(this, Nt);
                }
                _t();
              }), Ft.addEventListener("cancel", () => {
                this.remove(), _t();
              });
            }).finally(() => Ur(this, mt, Zo).call(this))), Ft.click();
          }, xt = new WeakSet(), cl = function() {
            const {
              div: Ft
            } = this;
            let {
              width: _t,
              height: Nt
            } = mr(this, ot);
            const [Mt, Lt] = this.pageDimensions, $t = 0.75;
            if (this.width)
              _t = this.width * Mt, Nt = this.height * Lt;
            else if (_t > $t * Mt || Nt > $t * Lt) {
              const Vt = Math.min($t * Mt / _t, $t * Lt / Nt);
              _t *= Vt, Nt *= Vt;
            }
            const [Tt, Dt] = this.parentDimensions;
            this.setDims(_t * Tt / Mt, Nt * Dt / Lt), this._uiManager.enableWaiting(!1);
            const Ut = tn(this, it, document.createElement("canvas"));
            Ft.append(Ut), Ft.hidden = !1, Ur(this, Pt, ul).call(this, _t, Nt), Ur(this, yt, iu).call(this), mr(this, dt) || (this.parent.addUndoableEditor(this), tn(this, dt, !0)), this._uiManager._eventBus.dispatch("reporttelemetry", {
              source: this,
              details: {
                type: "editing",
                subtype: this.editorType,
                data: {
                  action: "inserted_image"
                }
              }
            }), this.addAltTextButton();
          }, Et = new WeakSet(), nu = function(Ft, _t) {
            var $t;
            const [Nt, Mt] = this.parentDimensions;
            this.width = Ft / Nt, this.height = _t / Mt, this.setDims(Ft, _t), ($t = this._initialOptions) != null && $t.isCentered ? this.center() : this.fixAndSetPosition(), this._initialOptions = null, mr(this, ft) !== null && clearTimeout(mr(this, ft)), tn(this, ft, setTimeout(() => {
              tn(this, ft, null), Ur(this, Pt, ul).call(this, Ft, _t);
            }, 200));
          }, Bt = new WeakSet(), au = function(Ft, _t) {
            const {
              width: Nt,
              height: Mt
            } = mr(this, ot);
            let Lt = Nt, $t = Mt, Tt = mr(this, ot);
            for (; Lt > 2 * Ft || $t > 2 * _t; ) {
              const Dt = Lt, Ut = $t;
              Lt > 2 * Ft && (Lt = Lt >= 16384 ? Math.floor(Lt / 2) - 1 : Math.ceil(Lt / 2)), $t > 2 * _t && ($t = $t >= 16384 ? Math.floor($t / 2) - 1 : Math.ceil($t / 2));
              const Vt = new OffscreenCanvas(Lt, $t);
              Vt.getContext("2d").drawImage(Tt, 0, 0, Dt, Ut, 0, 0, Lt, $t), Tt = Vt.transferToImageBitmap();
            }
            return Tt;
          }, Pt = new WeakSet(), ul = function(Ft, _t) {
            Ft = Math.ceil(Ft), _t = Math.ceil(_t);
            const Nt = mr(this, it);
            if (!Nt || Nt.width === Ft && Nt.height === _t)
              return;
            Nt.width = Ft, Nt.height = _t;
            const Mt = mr(this, ht) ? mr(this, ot) : Ur(this, Bt, au).call(this, Ft, _t), Lt = Nt.getContext("2d");
            Lt.filter = this._uiManager.hcmFilter, Lt.drawImage(Mt, 0, 0, Mt.width, Mt.height, 0, 0, Ft, _t);
          }, Ct = new WeakSet(), vs = function(Ft) {
            if (Ft) {
              if (mr(this, ht)) {
                const Mt = this._uiManager.imageManager.getSvgUrl(mr(this, rt));
                if (Mt)
                  return Mt;
              }
              const _t = document.createElement("canvas");
              return {
                width: _t.width,
                height: _t.height
              } = mr(this, ot), _t.getContext("2d").drawImage(mr(this, ot), 0, 0), _t.toDataURL();
            }
            if (mr(this, ht)) {
              const [_t, Nt] = this.pageDimensions, Mt = Math.round(this.width * _t * tt.PixelsPerInch.PDF_TO_CSS_UNITS), Lt = Math.round(this.height * Nt * tt.PixelsPerInch.PDF_TO_CSS_UNITS), $t = new OffscreenCanvas(Mt, Lt);
              return $t.getContext("2d").drawImage(mr(this, ot), 0, 0, mr(this, ot).width, mr(this, ot).height, 0, 0, Mt, Lt), $t.transferToImageBitmap();
            }
            return structuredClone(mr(this, ot));
          }, yt = new WeakSet(), iu = function() {
            tn(this, ut, new ResizeObserver((Ft) => {
              const _t = Ft[0].contentRect;
              _t.width && _t.height && Ur(this, Et, nu).call(this, _t.width, _t.height);
            })), mr(this, ut).observe(this.div);
          }, Ln(kt, "_type", "stamp");
          let at = kt;
          s.StampEditor = at;
        }
        /******/
      ], __webpack_module_cache__ = {};
      function __w_pdfjs_require__(a) {
        var s = __webpack_module_cache__[a];
        if (s !== void 0)
          return s.exports;
        var $ = __webpack_module_cache__[a] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return __webpack_modules__[a].call($.exports, $, $.exports, __w_pdfjs_require__), $.exports;
      }
      var __webpack_exports__ = {};
      return (() => {
        var a = __webpack_exports__;
        Object.defineProperty(a, "__esModule", {
          value: !0
        }), Object.defineProperty(a, "AbortException", {
          enumerable: !0,
          get: function() {
            return s.AbortException;
          }
        }), Object.defineProperty(a, "AnnotationEditorLayer", {
          enumerable: !0,
          get: function() {
            return tt.AnnotationEditorLayer;
          }
        }), Object.defineProperty(a, "AnnotationEditorParamsType", {
          enumerable: !0,
          get: function() {
            return s.AnnotationEditorParamsType;
          }
        }), Object.defineProperty(a, "AnnotationEditorType", {
          enumerable: !0,
          get: function() {
            return s.AnnotationEditorType;
          }
        }), Object.defineProperty(a, "AnnotationEditorUIManager", {
          enumerable: !0,
          get: function() {
            return nt.AnnotationEditorUIManager;
          }
        }), Object.defineProperty(a, "AnnotationLayer", {
          enumerable: !0,
          get: function() {
            return at.AnnotationLayer;
          }
        }), Object.defineProperty(a, "AnnotationMode", {
          enumerable: !0,
          get: function() {
            return s.AnnotationMode;
          }
        }), Object.defineProperty(a, "CMapCompressionType", {
          enumerable: !0,
          get: function() {
            return s.CMapCompressionType;
          }
        }), Object.defineProperty(a, "DOMSVGFactory", {
          enumerable: !0,
          get: function() {
            return _.DOMSVGFactory;
          }
        }), Object.defineProperty(a, "FeatureTest", {
          enumerable: !0,
          get: function() {
            return s.FeatureTest;
          }
        }), Object.defineProperty(a, "GlobalWorkerOptions", {
          enumerable: !0,
          get: function() {
            return ot.GlobalWorkerOptions;
          }
        }), Object.defineProperty(a, "ImageKind", {
          enumerable: !0,
          get: function() {
            return s.ImageKind;
          }
        }), Object.defineProperty(a, "InvalidPDFException", {
          enumerable: !0,
          get: function() {
            return s.InvalidPDFException;
          }
        }), Object.defineProperty(a, "MissingPDFException", {
          enumerable: !0,
          get: function() {
            return s.MissingPDFException;
          }
        }), Object.defineProperty(a, "OPS", {
          enumerable: !0,
          get: function() {
            return s.OPS;
          }
        }), Object.defineProperty(a, "PDFDataRangeTransport", {
          enumerable: !0,
          get: function() {
            return $.PDFDataRangeTransport;
          }
        }), Object.defineProperty(a, "PDFDateString", {
          enumerable: !0,
          get: function() {
            return _.PDFDateString;
          }
        }), Object.defineProperty(a, "PDFWorker", {
          enumerable: !0,
          get: function() {
            return $.PDFWorker;
          }
        }), Object.defineProperty(a, "PasswordResponses", {
          enumerable: !0,
          get: function() {
            return s.PasswordResponses;
          }
        }), Object.defineProperty(a, "PermissionFlag", {
          enumerable: !0,
          get: function() {
            return s.PermissionFlag;
          }
        }), Object.defineProperty(a, "PixelsPerInch", {
          enumerable: !0,
          get: function() {
            return _.PixelsPerInch;
          }
        }), Object.defineProperty(a, "PromiseCapability", {
          enumerable: !0,
          get: function() {
            return s.PromiseCapability;
          }
        }), Object.defineProperty(a, "RenderingCancelledException", {
          enumerable: !0,
          get: function() {
            return _.RenderingCancelledException;
          }
        }), Object.defineProperty(a, "SVGGraphics", {
          enumerable: !0,
          get: function() {
            return $.SVGGraphics;
          }
        }), Object.defineProperty(a, "UnexpectedResponseException", {
          enumerable: !0,
          get: function() {
            return s.UnexpectedResponseException;
          }
        }), Object.defineProperty(a, "Util", {
          enumerable: !0,
          get: function() {
            return s.Util;
          }
        }), Object.defineProperty(a, "VerbosityLevel", {
          enumerable: !0,
          get: function() {
            return s.VerbosityLevel;
          }
        }), Object.defineProperty(a, "XfaLayer", {
          enumerable: !0,
          get: function() {
            return rt.XfaLayer;
          }
        }), Object.defineProperty(a, "build", {
          enumerable: !0,
          get: function() {
            return $.build;
          }
        }), Object.defineProperty(a, "createValidAbsoluteUrl", {
          enumerable: !0,
          get: function() {
            return s.createValidAbsoluteUrl;
          }
        }), Object.defineProperty(a, "getDocument", {
          enumerable: !0,
          get: function() {
            return $.getDocument;
          }
        }), Object.defineProperty(a, "getFilenameFromUrl", {
          enumerable: !0,
          get: function() {
            return _.getFilenameFromUrl;
          }
        }), Object.defineProperty(a, "getPdfFilenameFromUrl", {
          enumerable: !0,
          get: function() {
            return _.getPdfFilenameFromUrl;
          }
        }), Object.defineProperty(a, "getXfaPageViewport", {
          enumerable: !0,
          get: function() {
            return _.getXfaPageViewport;
          }
        }), Object.defineProperty(a, "isDataScheme", {
          enumerable: !0,
          get: function() {
            return _.isDataScheme;
          }
        }), Object.defineProperty(a, "isPdfFile", {
          enumerable: !0,
          get: function() {
            return _.isPdfFile;
          }
        }), Object.defineProperty(a, "loadScript", {
          enumerable: !0,
          get: function() {
            return _.loadScript;
          }
        }), Object.defineProperty(a, "noContextMenu", {
          enumerable: !0,
          get: function() {
            return _.noContextMenu;
          }
        }), Object.defineProperty(a, "normalizeUnicode", {
          enumerable: !0,
          get: function() {
            return s.normalizeUnicode;
          }
        }), Object.defineProperty(a, "renderTextLayer", {
          enumerable: !0,
          get: function() {
            return _e.renderTextLayer;
          }
        }), Object.defineProperty(a, "setLayerDimensions", {
          enumerable: !0,
          get: function() {
            return _.setLayerDimensions;
          }
        }), Object.defineProperty(a, "shadow", {
          enumerable: !0,
          get: function() {
            return s.shadow;
          }
        }), Object.defineProperty(a, "updateTextLayer", {
          enumerable: !0,
          get: function() {
            return _e.updateTextLayer;
          }
        }), Object.defineProperty(a, "version", {
          enumerable: !0,
          get: function() {
            return $.version;
          }
        });
        var s = __w_pdfjs_require__(1), $ = __w_pdfjs_require__(124), _ = __w_pdfjs_require__(168), _e = __w_pdfjs_require__(195), tt = __w_pdfjs_require__(196), nt = __w_pdfjs_require__(165), at = __w_pdfjs_require__(198), ot = __w_pdfjs_require__(176), rt = __w_pdfjs_require__(201);
      })(), __webpack_exports__;
    })()
  ));
})(pdf$1);
var pdfExports = pdf$1.exports;
const pdf = /* @__PURE__ */ getDefaultExportFromCjs(pdfExports), pdfJs = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: pdf
}, [pdfExports]), isff = typeof navigator < "u" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1;
function addEvent$1(a, s, $, _) {
  a.addEventListener ? a.addEventListener(s, $, _) : a.attachEvent && a.attachEvent("on".concat(s), () => {
    $(window.event);
  });
}
function getMods(a, s) {
  const $ = s.slice(0, s.length - 1);
  for (let _ = 0; _ < $.length; _++)
    $[_] = a[$[_].toLowerCase()];
  return $;
}
function getKeys$3(a) {
  typeof a != "string" && (a = ""), a = a.replace(/\s/g, "");
  const s = a.split(",");
  let $ = s.lastIndexOf("");
  for (; $ >= 0; )
    s[$ - 1] += ",", s.splice($, 1), $ = s.lastIndexOf("");
  return s;
}
function compareArray(a, s) {
  const $ = a.length >= s.length ? a : s, _ = a.length >= s.length ? s : a;
  let _e = !0;
  for (let tt = 0; tt < $.length; tt++)
    _.indexOf($[tt]) === -1 && (_e = !1);
  return _e;
}
const _keyMap = {
  backspace: 8,
  "⌫": 8,
  tab: 9,
  clear: 12,
  enter: 13,
  "↩": 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": isff ? 173 : 189,
  "=": isff ? 61 : 187,
  ";": isff ? 59 : 186,
  "'": 222,
  "[": 219,
  "]": 221,
  "\\": 220
}, _modifier = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  command: 91
}, modifierMap = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, _mods = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, _handlers = {};
for (let a = 1; a < 20; a++)
  _keyMap["f".concat(a)] = 111 + a;
let _downKeys = [], winListendFocus = !1, _scope = "all";
const elementHasBindEvent = [], code = (a) => _keyMap[a.toLowerCase()] || _modifier[a.toLowerCase()] || a.toUpperCase().charCodeAt(0), getKey$3 = (a) => Object.keys(_keyMap).find((s) => _keyMap[s] === a), getModifier = (a) => Object.keys(_modifier).find((s) => _modifier[s] === a);
function setScope(a) {
  _scope = a || "all";
}
function getScope() {
  return _scope || "all";
}
function getPressedKeyCodes() {
  return _downKeys.slice(0);
}
function getPressedKeyString() {
  return _downKeys.map((a) => getKey$3(a) || getModifier(a) || String.fromCharCode(a));
}
function getAllKeyCodes() {
  const a = [];
  return Object.keys(_handlers).forEach((s) => {
    _handlers[s].forEach(($) => {
      let {
        key: _,
        scope: _e,
        mods: tt,
        shortcut: nt
      } = $;
      a.push({
        scope: _e,
        shortcut: nt,
        mods: tt,
        keys: _.split("+").map((at) => code(at))
      });
    });
  }), a;
}
function filter$1(a) {
  const s = a.target || a.srcElement, {
    tagName: $
  } = s;
  let _ = !0;
  return (s.isContentEditable || ($ === "INPUT" || $ === "TEXTAREA" || $ === "SELECT") && !s.readOnly) && (_ = !1), _;
}
function isPressed(a) {
  return typeof a == "string" && (a = code(a)), _downKeys.indexOf(a) !== -1;
}
function deleteScope(a, s) {
  let $, _;
  a || (a = getScope());
  for (const _e in _handlers)
    if (Object.prototype.hasOwnProperty.call(_handlers, _e))
      for ($ = _handlers[_e], _ = 0; _ < $.length; )
        $[_].scope === a ? $.splice(_, 1) : _++;
  getScope() === a && setScope(s || "all");
}
function clearModifier(a) {
  let s = a.keyCode || a.which || a.charCode;
  const $ = _downKeys.indexOf(s);
  if ($ >= 0 && _downKeys.splice($, 1), a.key && a.key.toLowerCase() === "meta" && _downKeys.splice(0, _downKeys.length), (s === 93 || s === 224) && (s = 91), s in _mods) {
    _mods[s] = !1;
    for (const _ in _modifier)
      _modifier[_] === s && (hotkeys[_] = !1);
  }
}
function unbind(a) {
  if (typeof a > "u")
    Object.keys(_handlers).forEach((_e) => delete _handlers[_e]);
  else if (Array.isArray(a))
    a.forEach((_e) => {
      _e.key && eachUnbind(_e);
    });
  else if (typeof a == "object")
    a.key && eachUnbind(a);
  else if (typeof a == "string") {
    for (var s = arguments.length, $ = new Array(s > 1 ? s - 1 : 0), _ = 1; _ < s; _++)
      $[_ - 1] = arguments[_];
    let [_e, tt] = $;
    typeof _e == "function" && (tt = _e, _e = ""), eachUnbind({
      key: a,
      scope: _e,
      method: tt,
      splitKey: "+"
    });
  }
}
const eachUnbind = (a) => {
  let {
    key: s,
    scope: $,
    method: _,
    splitKey: _e = "+"
  } = a;
  getKeys$3(s).forEach((nt) => {
    const at = nt.split(_e), ot = at.length, rt = at[ot - 1], st = rt === "*" ? "*" : code(rt);
    if (!_handlers[st])
      return;
    $ || ($ = getScope());
    const lt = ot > 1 ? getMods(_modifier, at) : [];
    _handlers[st] = _handlers[st].filter((et) => !((_ ? et.method === _ : !0) && et.scope === $ && compareArray(et.mods, lt)));
  });
};
function eventHandler(a, s, $, _) {
  if (s.element !== _)
    return;
  let _e;
  if (s.scope === $ || s.scope === "all") {
    _e = s.mods.length > 0;
    for (const tt in _mods)
      Object.prototype.hasOwnProperty.call(_mods, tt) && (!_mods[tt] && s.mods.indexOf(+tt) > -1 || _mods[tt] && s.mods.indexOf(+tt) === -1) && (_e = !1);
    (s.mods.length === 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || _e || s.shortcut === "*") && (s.keys = [], s.keys = s.keys.concat(_downKeys), s.method(a, s) === !1 && (a.preventDefault ? a.preventDefault() : a.returnValue = !1, a.stopPropagation && a.stopPropagation(), a.cancelBubble && (a.cancelBubble = !0)));
  }
}
function dispatch(a, s) {
  const $ = _handlers["*"];
  let _ = a.keyCode || a.which || a.charCode;
  if (!hotkeys.filter.call(this, a))
    return;
  if ((_ === 93 || _ === 224) && (_ = 91), _downKeys.indexOf(_) === -1 && _ !== 229 && _downKeys.push(_), ["ctrlKey", "altKey", "shiftKey", "metaKey"].forEach((tt) => {
    const nt = modifierMap[tt];
    a[tt] && _downKeys.indexOf(nt) === -1 ? _downKeys.push(nt) : !a[tt] && _downKeys.indexOf(nt) > -1 ? _downKeys.splice(_downKeys.indexOf(nt), 1) : tt === "metaKey" && a[tt] && _downKeys.length === 3 && (a.ctrlKey || a.shiftKey || a.altKey || (_downKeys = _downKeys.slice(_downKeys.indexOf(nt))));
  }), _ in _mods) {
    _mods[_] = !0;
    for (const tt in _modifier)
      _modifier[tt] === _ && (hotkeys[tt] = !0);
    if (!$)
      return;
  }
  for (const tt in _mods)
    Object.prototype.hasOwnProperty.call(_mods, tt) && (_mods[tt] = a[modifierMap[tt]]);
  a.getModifierState && !(a.altKey && !a.ctrlKey) && a.getModifierState("AltGraph") && (_downKeys.indexOf(17) === -1 && _downKeys.push(17), _downKeys.indexOf(18) === -1 && _downKeys.push(18), _mods[17] = !0, _mods[18] = !0);
  const _e = getScope();
  if ($)
    for (let tt = 0; tt < $.length; tt++)
      $[tt].scope === _e && (a.type === "keydown" && $[tt].keydown || a.type === "keyup" && $[tt].keyup) && eventHandler(a, $[tt], _e, s);
  if (_ in _handlers) {
    for (let tt = 0; tt < _handlers[_].length; tt++)
      if ((a.type === "keydown" && _handlers[_][tt].keydown || a.type === "keyup" && _handlers[_][tt].keyup) && _handlers[_][tt].key) {
        const nt = _handlers[_][tt], {
          splitKey: at
        } = nt, ot = nt.key.split(at), rt = [];
        for (let st = 0; st < ot.length; st++)
          rt.push(code(ot[st]));
        rt.sort().join("") === _downKeys.sort().join("") && eventHandler(a, nt, _e, s);
      }
  }
}
function isElementBind(a) {
  return elementHasBindEvent.indexOf(a) > -1;
}
function hotkeys(a, s, $) {
  _downKeys = [];
  const _ = getKeys$3(a);
  let _e = [], tt = "all", nt = document, at = 0, ot = !1, rt = !0, st = "+", lt = !1, et = !1;
  for ($ === void 0 && typeof s == "function" && ($ = s), Object.prototype.toString.call(s) === "[object Object]" && (s.scope && (tt = s.scope), s.element && (nt = s.element), s.keyup && (ot = s.keyup), s.keydown !== void 0 && (rt = s.keydown), s.capture !== void 0 && (lt = s.capture), typeof s.splitKey == "string" && (st = s.splitKey), s.single === !0 && (et = !0)), typeof s == "string" && (tt = s), et && unbind(a, tt); at < _.length; at++)
    a = _[at].split(st), _e = [], a.length > 1 && (_e = getMods(_modifier, a)), a = a[a.length - 1], a = a === "*" ? "*" : code(a), a in _handlers || (_handlers[a] = []), _handlers[a].push({
      keyup: ot,
      keydown: rt,
      scope: tt,
      mods: _e,
      shortcut: _[at],
      method: $,
      key: _[at],
      splitKey: st,
      element: nt
    });
  typeof nt < "u" && !isElementBind(nt) && window && (elementHasBindEvent.push(nt), addEvent$1(nt, "keydown", (it) => {
    dispatch(it, nt);
  }, lt), winListendFocus || (winListendFocus = !0, addEvent$1(window, "focus", () => {
    _downKeys = [];
  }, lt)), addEvent$1(nt, "keyup", (it) => {
    dispatch(it, nt), clearModifier(it);
  }, lt));
}
function trigger(a) {
  let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
  Object.keys(_handlers).forEach(($) => {
    _handlers[$].filter((_e) => _e.scope === s && _e.shortcut === a).forEach((_e) => {
      _e && _e.method && _e.method();
    });
  });
}
const _api = {
  getPressedKeyString,
  setScope,
  getScope,
  deleteScope,
  getPressedKeyCodes,
  getAllKeyCodes,
  isPressed,
  filter: filter$1,
  trigger,
  unbind,
  keyMap: _keyMap,
  modifier: _modifier,
  modifierMap
};
for (const a in _api)
  Object.prototype.hasOwnProperty.call(_api, a) && (hotkeys[a] = _api[a]);
if (typeof window < "u") {
  const a = window.hotkeys;
  hotkeys.noConflict = (s) => (s && window.hotkeys === hotkeys && (window.hotkeys = a), hotkeys), window.hotkeys = hotkeys;
}
pdfExports.GlobalWorkerOptions.workerSrc = pdf_worker_entry;
const uuid$6 = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (a) => {
  const s = Math.random() * 16 | 0;
  return (a == "x" ? s : s & 3 | 8).toString(16);
}), set$2 = (a, s, $) => {
  s = Array.isArray(s) ? s : s.replace("[", ".").replace("]", "").split(".");
  let _ = a;
  s.forEach((_e, tt, nt) => {
    if (tt == s.length - 1)
      _[_e] = $;
    else {
      if (!_.hasOwnProperty(_e)) {
        const at = nt[tt + 1];
        _[_e] = String(Number(at)) === at ? [] : {};
      }
      _ = _[_e];
    }
  });
}, debounce$1 = (a, s = 20) => {
  let $ = null;
  return (..._e) => {
    $ && clearTimeout($), $ = setTimeout(() => a(..._e), s);
  };
}, shift = (a, s, $) => {
  $ && (s = -s);
  const _ = `${a}`.split("e");
  return +`${_[0]}e${_[1] ? Number(_[1]) + s : s}`;
}, round = (a, s) => shift(Math.round(shift(a, s, !1)), s, !0), flatten = (a) => [].concat(...a), up = "up", shiftUp = "shift+up", down = "down", shiftDown = "shift+down", left = "left", shiftLeft = "shift+left", right = "right", shiftRight = "shift+right", rmWin = "backspace", rmMac = "delete", esc = "esc", copyWin = "ctrl+c", copyMac = "command+c", pasteWin = "ctrl+v", pasteMac = "command+v", redoWin = "ctrl+y", redoMac = "shift+command+z", undoWin = "ctrl+z", undoMac = "command+z", saveWin = "ctrl+s", saveMac = "command+s", selectAllWin = "ctrl+a", selectAllMac = "command+a", keys$2 = [
  up,
  shiftUp,
  down,
  shiftDown,
  left,
  shiftLeft,
  right,
  shiftRight,
  rmMac,
  rmWin,
  esc,
  copyWin,
  copyMac,
  pasteWin,
  pasteMac,
  redoWin,
  redoMac,
  undoWin,
  undoMac,
  saveWin,
  saveMac,
  selectAllWin,
  selectAllMac
], initShortCuts = (a) => {
  hotkeys(keys$2.join(), (s, $) => {
    switch ($.shortcut) {
      case up:
      case shiftUp:
        s.preventDefault(), a.move("up", hotkeys.shift);
        break;
      case down:
      case shiftDown:
        s.preventDefault(), a.move("down", hotkeys.shift);
        break;
      case left:
      case shiftLeft:
        s.preventDefault(), a.move("left", hotkeys.shift);
        break;
      case right:
      case shiftRight:
        s.preventDefault(), a.move("right", hotkeys.shift);
        break;
      case rmWin:
      case rmMac:
        a.remove();
        break;
      case esc:
        a.esc();
        break;
      case copyWin:
      case copyMac:
        a.copy();
        break;
      case pasteWin:
      case pasteMac:
        a.paste();
        break;
      case redoWin:
      case redoMac:
        a.redo();
        break;
      case undoWin:
      case undoMac:
        a.undo();
        break;
      case saveWin:
      case saveMac:
        s.preventDefault(), a.save();
        break;
      case selectAllWin:
      case selectAllMac:
        s.preventDefault(), a.selectAll();
        break;
    }
  });
}, destroyShortCuts = () => {
  hotkeys.unbind(keys$2.join());
}, getPdfPageSizes = async (a) => {
  const s = URL.createObjectURL(a), $ = await pdfExports.getDocument({ url: s }).promise, _ = Promise.all(
    new Array($.numPages).fill("").map(async (_e, tt) => await $.getPage(tt + 1).then((nt) => {
      const { height: at, width: ot } = nt.getViewport({ scale: 1, rotation: 0 });
      return { height: pt2mm(at), width: pt2mm(ot) };
    }))
  );
  return URL.revokeObjectURL(s), _;
}, pdf2Images = async (a, s, $) => {
  const _ = URL.createObjectURL(a), _e = await pdfExports.getDocument({ url: _ }).promise, tt = Promise.all(
    new Array(_e.numPages).fill("").map(async (nt, at) => await _e.getPage(at + 1).then((ot) => {
      const rt = document.createElement("canvas");
      rt.width = s * 2;
      const st = rt.getContext("2d"), lt = rt.width / ot.getViewport({ scale: 1, rotation: 0 }).width, et = ot.getViewport({ scale: lt, rotation: 0 });
      return rt.height = et.height, ot.render({ canvasContext: st, viewport: et }).promise.then(() => rt.toDataURL(`image/${$}`));
    }))
  );
  return URL.revokeObjectURL(_), tt;
}, pdf2Pngs = (a, s) => pdf2Images(a, s, "png"), b64toBlob = (a) => {
  const s = b64toUint8Array(a), [, , $] = a.match(/(:)([a-z/]+)(;)/);
  return new Blob([s.buffer], { type: $ });
}, convertSchemasForUI = (a) => (a.schemas.forEach((s, $) => {
  s.forEach((_) => {
    _.id = uuid$6(), _.content = _.content || "";
  });
}), a.schemas), template2SchemasList = async (a) => {
  const s = cloneDeep$1(a), { basePdf: $, schemas: _ } = s, _e = convertSchemasForUI(s);
  let tt = [];
  if (isBlankPdf($))
    tt = _.map(() => ({
      width: $.width,
      height: $.height
    }));
  else {
    const ot = await getB64BasePdf($), rt = b64toBlob(ot);
    tt = await getPdfPageSizes(rt);
  }
  const nt = _e.length, at = tt.length;
  return (nt < at ? _e.concat(new Array(at - nt).fill(cloneDeep$1([]))) : _e.slice(0, tt.length)).map((ot, rt) => (Object.values(ot).forEach((st) => {
    const { width: lt, height: et } = tt[rt], it = st.position.x + st.width, ut = st.position.y + st.height;
    if (lt < it) {
      const ft = it - lt;
      st.position.x += ft;
    }
    if (et < ut) {
      const ft = ut - et;
      st.position.y += ft;
    }
  }), ot));
}, schemasList2template = (a, s) => ({
  schemas: cloneDeep$1(a).map(
    ($) => $.map((_) => (delete _.id, _))
  ),
  basePdf: s
}), getUniqueSchemaName = (a) => {
  const { copiedSchemaName: s, schema: $, stackUniqueSchemaNames: _ } = a, _e = $.map((rt) => rt.name).concat(_), tt = _e.reduce(
    (rt, st) => Object.assign(rt, { originalName: st, copiedNum: 0 }),
    {}
  ), nt = (rt) => rt.replace(/ copy$| copy [0-9]*$/, "");
  _e.filter((rt) => / copy$| copy [0-9]*$/.test(rt)).forEach((rt) => {
    const st = nt(rt), lt = rt.match(/[0-9]*$/), et = lt && lt[0] ? Number(lt[0]) : 1;
    (tt[st] ?? 0) < et && (tt[st] = et);
  });
  const at = nt(s);
  if (tt[at]) {
    const rt = tt[at], st = `${at} copy ${rt + 1}`;
    return _.push(st), st;
  }
  const ot = `${s} copy`;
  return _.push(ot), ot;
}, moveCommandToChangeSchemasArg = (a) => {
  const { command: s, activeSchemas: $, isShift: _, pageSize: _e } = a, tt = s === "up" || s === "down" ? "y" : "x", nt = _ ? 0.1 : 1, at = (ot) => {
    let rt = 0;
    const { position: st } = ot;
    switch (s) {
      case "up":
        rt = round(st.y - nt, 2);
        break;
      case "down":
        rt = round(st.y + nt, 2);
        break;
      case "left":
        rt = round(st.x - nt, 2);
        break;
      case "right":
        rt = round(st.x + nt, 2);
        break;
    }
    return rt > 0 ? rt : 0;
  };
  return $.map((ot) => {
    let rt = at(ot);
    const { width: st, height: lt } = ot;
    return tt === "x" ? rt = rt > _e.width - st ? round(_e.width - st, 2) : rt : rt = rt > _e.height - lt ? round(_e.height - lt, 2) : rt, { key: `position.${tt}`, value: rt, schemaId: ot.id };
  });
}, getPagesScrollTopByIndex = (a, s, $) => a.slice(0, s).reduce((_, _e) => _ + (_e.height * ZOOM + RULER_HEIGHT * $) * $, 0), getSidebarContentHeight = (a) => a - RULER_HEIGHT - RULER_HEIGHT / 2 - 30, handlePositionSizeChange = (a, s, $, _, _e) => {
  const tt = isBlankPdf(_) ? _.padding : [0, 0, 0, 0], [nt, at, ot, rt] = tt, { width: st, height: lt } = _e, et = (it, ut, ft) => Math.min(Math.max(Number(it), ut), ft);
  s === "position.x" ? a.position.x = et($, rt, st - a.width - at) : s === "position.y" ? a.position.y = et($, nt, lt - a.height - ot) : s === "width" ? a.width = et($, 0, st - a.position.x - at) : s === "height" && (a.height = et($, 0, lt - a.position.y - ot));
}, handleTypeChange = (a, s, $, _) => {
  var nt;
  if (s !== "type")
    return;
  const _e = ["id", "name", "type", "position", "required"];
  Object.keys(a).forEach((at) => {
    _e.includes(at) || delete a[at];
  });
  const tt = (nt = Object.values(_).find(
    (at) => (at == null ? void 0 : at.propPanel.defaultSchema.type) === $
  )) == null ? void 0 : nt.propPanel;
  Object.keys((tt == null ? void 0 : tt.defaultSchema) || {}).forEach((at) => {
    a.hasOwnProperty(at) || (a[at] = tt == null ? void 0 : tt.defaultSchema[at]);
  }), a.readOnly && (a.required = !1);
}, changeSchemas = (a) => {
  const { objs: s, schemas: $, basePdf: _, pluginsRegistry: _e, pageSize: tt, commitSchemas: nt } = a, at = s.reduce((ot, { key: rt, value: st, schemaId: lt }) => {
    const et = ot.find((it) => it.id === lt);
    return et && (set$2(et, rt, st), rt === "type" ? handleTypeChange(et, rt, st, _e) : ["position.x", "position.y", "width", "height"].includes(rt) && handlePositionSizeChange(et, rt, st, _, tt)), ot;
  }, cloneDeep$1($));
  nt(at);
}, DEFAULT_FONT_SIZE = 13, ALIGN_LEFT = "left", ALIGN_CENTER = "center", ALIGN_RIGHT = "right", DEFAULT_ALIGNMENT = ALIGN_LEFT, VERTICAL_ALIGN_TOP = "top", VERTICAL_ALIGN_MIDDLE = "middle", VERTICAL_ALIGN_BOTTOM = "bottom", DEFAULT_VERTICAL_ALIGNMENT = VERTICAL_ALIGN_TOP, DEFAULT_LINE_HEIGHT = 1, DEFAULT_CHARACTER_SPACING = 0, DEFAULT_FONT_COLOR = "#000000", PLACEHOLDER_FONT_COLOR = "#A0A0A0", DYNAMIC_FIT_VERTICAL = "vertical", DYNAMIC_FIT_HORIZONTAL = "horizontal", DEFAULT_DYNAMIC_FIT = DYNAMIC_FIT_VERTICAL, DEFAULT_DYNAMIC_MIN_FONT_SIZE = 4, DEFAULT_DYNAMIC_MAX_FONT_SIZE = 72, FONT_SIZE_ADJUSTMENT = 0.25, ENCODING_MAPPING = {
  utf16le: "utf-16le",
  ucs2: "utf-16le",
  utf16be: "utf-16be"
};
class DecodeStream {
  constructor(s) {
    this.buffer = s, this.view = new DataView(s.buffer, s.byteOffset, s.byteLength), this.pos = 0, this.length = this.buffer.length;
  }
  readString(s, $ = "ascii") {
    $ = ENCODING_MAPPING[$] || $;
    let _ = this.readBuffer(s);
    try {
      return new TextDecoder($).decode(_);
    } catch {
      return _;
    }
  }
  readBuffer(s) {
    return this.buffer.slice(this.pos, this.pos += s);
  }
  readUInt24BE() {
    return (this.readUInt16BE() << 8) + this.readUInt8();
  }
  readUInt24LE() {
    return this.readUInt16LE() + (this.readUInt8() << 16);
  }
  readInt24BE() {
    return (this.readInt16BE() << 8) + this.readUInt8();
  }
  readInt24LE() {
    return this.readUInt16LE() + (this.readInt8() << 16);
  }
}
DecodeStream.TYPES = {
  UInt8: 1,
  UInt16: 2,
  UInt24: 3,
  UInt32: 4,
  Int8: 1,
  Int16: 2,
  Int24: 3,
  Int32: 4,
  Float: 4,
  Double: 8
};
for (let a of Object.getOwnPropertyNames(DataView.prototype))
  if (a.slice(0, 3) === "get") {
    let s = a.slice(3).replace("Ui", "UI");
    s === "Float32" ? s = "Float" : s === "Float64" && (s = "Double");
    let $ = DecodeStream.TYPES[s];
    DecodeStream.prototype["read" + s + ($ === 1 ? "" : "BE")] = function() {
      const _ = this.view[a](this.pos, !1);
      return this.pos += $, _;
    }, $ !== 1 && (DecodeStream.prototype["read" + s + "LE"] = function() {
      const _ = this.view[a](this.pos, !0);
      return this.pos += $, _;
    });
  }
const textEncoder = new TextEncoder(), isBigEndian$1 = new Uint8Array(new Uint16Array([4660]).buffer)[0] == 18;
class EncodeStream {
  constructor(s) {
    this.buffer = s, this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), this.pos = 0;
  }
  writeBuffer(s) {
    this.buffer.set(s, this.pos), this.pos += s.length;
  }
  writeString(s, $ = "ascii") {
    let _;
    switch ($) {
      case "utf16le":
      case "utf16-le":
      case "ucs2":
        _ = stringToUtf16(s, isBigEndian$1);
        break;
      case "utf16be":
      case "utf16-be":
        _ = stringToUtf16(s, !isBigEndian$1);
        break;
      case "utf8":
        _ = textEncoder.encode(s);
        break;
      case "ascii":
        _ = stringToAscii(s);
        break;
      default:
        throw new Error(`Unsupported encoding: ${$}`);
    }
    this.writeBuffer(_);
  }
  writeUInt24BE(s) {
    this.buffer[this.pos++] = s >>> 16 & 255, this.buffer[this.pos++] = s >>> 8 & 255, this.buffer[this.pos++] = s & 255;
  }
  writeUInt24LE(s) {
    this.buffer[this.pos++] = s & 255, this.buffer[this.pos++] = s >>> 8 & 255, this.buffer[this.pos++] = s >>> 16 & 255;
  }
  writeInt24BE(s) {
    s >= 0 ? this.writeUInt24BE(s) : this.writeUInt24BE(s + 16777215 + 1);
  }
  writeInt24LE(s) {
    s >= 0 ? this.writeUInt24LE(s) : this.writeUInt24LE(s + 16777215 + 1);
  }
  fill(s, $) {
    if ($ < this.buffer.length)
      this.buffer.fill(s, this.pos, this.pos + $), this.pos += $;
    else {
      const _ = new Uint8Array($);
      _.fill(s), this.writeBuffer(_);
    }
  }
}
function stringToUtf16(a, s) {
  let $ = new Uint16Array(a.length);
  for (let _ = 0; _ < a.length; _++) {
    let _e = a.charCodeAt(_);
    s && (_e = _e >> 8 | (_e & 255) << 8), $[_] = _e;
  }
  return new Uint8Array($.buffer);
}
function stringToAscii(a) {
  let s = new Uint8Array(a.length);
  for (let $ = 0; $ < a.length; $++)
    s[$] = a.charCodeAt($);
  return s;
}
for (let a of Object.getOwnPropertyNames(DataView.prototype))
  if (a.slice(0, 3) === "set") {
    let s = a.slice(3).replace("Ui", "UI");
    s === "Float32" ? s = "Float" : s === "Float64" && (s = "Double");
    let $ = DecodeStream.TYPES[s];
    EncodeStream.prototype["write" + s + ($ === 1 ? "" : "BE")] = function(_) {
      this.view[a](this.pos, _, !1), this.pos += $;
    }, $ !== 1 && (EncodeStream.prototype["write" + s + "LE"] = function(_) {
      this.view[a](this.pos, _, !0), this.pos += $;
    });
  }
let Base$2 = class {
  fromBuffer(s) {
    let $ = new DecodeStream(s);
    return this.decode($);
  }
  toBuffer(s) {
    let $ = this.size(s), _ = new Uint8Array($), _e = new EncodeStream(_);
    return this.encode(_e, s), _;
  }
};
class NumberT extends Base$2 {
  constructor(s, $ = "BE") {
    super(), this.type = s, this.endian = $, this.fn = this.type, this.type[this.type.length - 1] !== "8" && (this.fn += this.endian);
  }
  size() {
    return DecodeStream.TYPES[this.type];
  }
  decode(s) {
    return s[`read${this.fn}`]();
  }
  encode(s, $) {
    return s[`write${this.fn}`]($);
  }
}
const uint8 = new NumberT("UInt8"), uint16be = new NumberT("UInt16", "BE"), uint16 = uint16be;
new NumberT("UInt16", "LE");
const uint24be = new NumberT("UInt24", "BE"), uint24 = uint24be;
new NumberT("UInt24", "LE");
const uint32be = new NumberT("UInt32", "BE"), uint32 = uint32be;
new NumberT("UInt32", "LE");
const int8 = new NumberT("Int8"), int16be = new NumberT("Int16", "BE"), int16 = int16be;
new NumberT("Int16", "LE");
new NumberT("Int24", "BE");
new NumberT("Int24", "LE");
const int32be = new NumberT("Int32", "BE"), int32 = int32be;
new NumberT("Int32", "LE");
new NumberT("Float", "BE");
new NumberT("Float", "LE");
new NumberT("Double", "BE");
new NumberT("Double", "LE");
class Fixed extends NumberT {
  constructor(s, $, _ = s >> 1) {
    super(`Int${s}`, $), this._point = 1 << _;
  }
  decode(s) {
    return super.decode(s) / this._point;
  }
  encode(s, $) {
    return super.encode(s, $ * this._point | 0);
  }
}
const fixed16be = new Fixed(16, "BE"), fixed16 = fixed16be;
new Fixed(16, "LE");
const fixed32be = new Fixed(32, "BE"), fixed32 = fixed32be;
new Fixed(32, "LE");
function resolveLength(a, s, $) {
  let _;
  if (typeof a == "number" ? _ = a : typeof a == "function" ? _ = a.call($, $) : $ && typeof a == "string" ? _ = $[a] : s && a instanceof NumberT && (_ = a.decode(s)), isNaN(_))
    throw new Error("Not a fixed size");
  return _;
}
class PropertyDescriptor {
  constructor(s = {}) {
    this.enumerable = !0, this.configurable = !0;
    for (let $ in s) {
      const _ = s[$];
      this[$] = _;
    }
  }
}
class ArrayT extends Base$2 {
  constructor(s, $, _ = "count") {
    super(), this.type = s, this.length = $, this.lengthType = _;
  }
  decode(s, $) {
    let _;
    const { pos: _e } = s, tt = [];
    let nt = $;
    if (this.length != null && (_ = resolveLength(this.length, s, $)), this.length instanceof NumberT && (Object.defineProperties(tt, {
      parent: { value: $ },
      _startOffset: { value: _e },
      _currentOffset: { value: 0, writable: !0 },
      _length: { value: _ }
    }), nt = tt), _ == null || this.lengthType === "bytes") {
      const at = _ != null ? s.pos + _ : $ != null && $._length ? $._startOffset + $._length : s.length;
      for (; s.pos < at; )
        tt.push(this.type.decode(s, nt));
    } else
      for (let at = 0, ot = _; at < ot; at++)
        tt.push(this.type.decode(s, nt));
    return tt;
  }
  size(s, $, _ = !0) {
    if (!s)
      return this.type.size(null, $) * resolveLength(this.length, null, $);
    let _e = 0;
    this.length instanceof NumberT && (_e += this.length.size(), $ = { parent: $, pointerSize: 0 });
    for (let tt of s)
      _e += this.type.size(tt, $);
    return $ && _ && this.length instanceof NumberT && (_e += $.pointerSize), _e;
  }
  encode(s, $, _) {
    let _e = _;
    this.length instanceof NumberT && (_e = {
      pointers: [],
      startOffset: s.pos,
      parent: _
    }, _e.pointerOffset = s.pos + this.size($, _e, !1), this.length.encode(s, $.length));
    for (let tt of $)
      this.type.encode(s, tt, _e);
    if (this.length instanceof NumberT) {
      let tt = 0;
      for (; tt < _e.pointers.length; ) {
        const nt = _e.pointers[tt++];
        nt.type.encode(s, nt.val, nt.parent);
      }
    }
  }
}
class LazyArray extends ArrayT {
  decode(s, $) {
    const { pos: _ } = s, _e = resolveLength(this.length, s, $);
    this.length instanceof NumberT && ($ = {
      parent: $,
      _startOffset: _,
      _currentOffset: 0,
      _length: _e
    });
    const tt = new LazyArrayValue(this.type, _e, s, $);
    return s.pos += _e * this.type.size(null, $), tt;
  }
  size(s, $) {
    return s instanceof LazyArrayValue && (s = s.toArray()), super.size(s, $);
  }
  encode(s, $, _) {
    return $ instanceof LazyArrayValue && ($ = $.toArray()), super.encode(s, $, _);
  }
}
class LazyArrayValue {
  constructor(s, $, _, _e) {
    this.type = s, this.length = $, this.stream = _, this.ctx = _e, this.base = this.stream.pos, this.items = [];
  }
  get(s) {
    if (!(s < 0 || s >= this.length)) {
      if (this.items[s] == null) {
        const { pos: $ } = this.stream;
        this.stream.pos = this.base + this.type.size(null, this.ctx) * s, this.items[s] = this.type.decode(this.stream, this.ctx), this.stream.pos = $;
      }
      return this.items[s];
    }
  }
  toArray() {
    const s = [];
    for (let $ = 0, _ = this.length; $ < _; $++)
      s.push(this.get($));
    return s;
  }
}
class Bitfield extends Base$2 {
  constructor(s, $ = []) {
    super(), this.type = s, this.flags = $;
  }
  decode(s) {
    const $ = this.type.decode(s), _ = {};
    for (let _e = 0; _e < this.flags.length; _e++) {
      const tt = this.flags[_e];
      tt != null && (_[tt] = !!($ & 1 << _e));
    }
    return _;
  }
  size() {
    return this.type.size();
  }
  encode(s, $) {
    let _ = 0;
    for (let _e = 0; _e < this.flags.length; _e++) {
      const tt = this.flags[_e];
      tt != null && $[tt] && (_ |= 1 << _e);
    }
    return this.type.encode(s, _);
  }
}
class BufferT extends Base$2 {
  constructor(s) {
    super(), this.length = s;
  }
  decode(s, $) {
    const _ = resolveLength(this.length, s, $);
    return s.readBuffer(_);
  }
  size(s, $) {
    if (!s)
      return resolveLength(this.length, null, $);
    let _ = s.length;
    return this.length instanceof NumberT && (_ += this.length.size()), _;
  }
  encode(s, $, _) {
    return this.length instanceof NumberT && this.length.encode(s, $.length), s.writeBuffer($);
  }
}
class Optional extends Base$2 {
  constructor(s, $ = !0) {
    super(), this.type = s, this.condition = $;
  }
  decode(s, $) {
    let { condition: _ } = this;
    if (typeof _ == "function" && (_ = _.call($, $)), _)
      return this.type.decode(s, $);
  }
  size(s, $) {
    let { condition: _ } = this;
    return typeof _ == "function" && (_ = _.call($, $)), _ ? this.type.size(s, $) : 0;
  }
  encode(s, $, _) {
    let { condition: _e } = this;
    if (typeof _e == "function" && (_e = _e.call(_, _)), _e)
      return this.type.encode(s, $, _);
  }
}
class Reserved extends Base$2 {
  constructor(s, $ = 1) {
    super(), this.type = s, this.count = $;
  }
  decode(s, $) {
    s.pos += this.size(null, $);
  }
  size(s, $) {
    const _ = resolveLength(this.count, null, $);
    return this.type.size() * _;
  }
  encode(s, $, _) {
    return s.fill(0, this.size($, _));
  }
}
class StringT extends Base$2 {
  constructor(s, $ = "ascii") {
    super(), this.length = s, this.encoding = $;
  }
  decode(s, $) {
    let _, _e;
    if (this.length != null)
      _ = resolveLength(this.length, s, $);
    else {
      let at;
      for ({ buffer: at, length: _, pos: _e } = s; _e < _ && at[_e] !== 0; )
        ++_e;
      _ = _e - s.pos;
    }
    let { encoding: tt } = this;
    typeof tt == "function" && (tt = tt.call($, $) || "ascii");
    const nt = s.readString(_, tt);
    return this.length == null && s.pos < s.length && s.pos++, nt;
  }
  size(s, $) {
    if (!s)
      return resolveLength(this.length, null, $);
    let { encoding: _ } = this;
    typeof _ == "function" && (_ = _.call($ != null ? $.val : void 0, $ != null ? $.val : void 0) || "ascii"), _ === "utf16be" && (_ = "utf16le");
    let _e = byteLength(s, _);
    return this.length instanceof NumberT && (_e += this.length.size()), this.length == null && _e++, _e;
  }
  encode(s, $, _) {
    let { encoding: _e } = this;
    if (typeof _e == "function" && (_e = _e.call(_ != null ? _.val : void 0, _ != null ? _.val : void 0) || "ascii"), this.length instanceof NumberT && this.length.encode(s, byteLength($, _e)), s.writeString($, _e), this.length == null)
      return s.writeUInt8(0);
  }
}
function byteLength(a, s) {
  switch (s) {
    case "ascii":
      return a.length;
    case "utf8":
      let $ = 0;
      for (let _ = 0; _ < a.length; _++) {
        let _e = a.charCodeAt(_);
        if (_e >= 55296 && _e <= 56319 && _ < a.length - 1) {
          let tt = a.charCodeAt(++_);
          (tt & 64512) === 56320 ? _e = ((_e & 1023) << 10) + (tt & 1023) + 65536 : _--;
        }
        _e & 4294967168 ? _e & 4294965248 ? _e & 4294901760 ? _e & 4292870144 || ($ += 4) : $ += 3 : $ += 2 : $++;
      }
      return $;
    case "utf16le":
    case "utf16-le":
    case "utf16be":
    case "utf16-be":
    case "ucs2":
      return a.length * 2;
    default:
      throw new Error("Unknown encoding " + s);
  }
}
class Struct extends Base$2 {
  constructor(s = {}) {
    super(), this.fields = s;
  }
  decode(s, $, _ = 0) {
    const _e = this._setup(s, $, _);
    return this._parseFields(s, _e, this.fields), this.process != null && this.process.call(_e, s), _e;
  }
  _setup(s, $, _) {
    const _e = {};
    return Object.defineProperties(_e, {
      parent: { value: $ },
      _startOffset: { value: s.pos },
      _currentOffset: { value: 0, writable: !0 },
      _length: { value: _ }
    }), _e;
  }
  _parseFields(s, $, _) {
    for (let tt in _) {
      var _e;
      const nt = _[tt];
      typeof nt == "function" ? _e = nt.call($, $) : _e = nt.decode(s, $), _e !== void 0 && (_e instanceof PropertyDescriptor ? Object.defineProperty($, tt, _e) : $[tt] = _e), $._currentOffset = s.pos - $._startOffset;
    }
  }
  size(s, $, _ = !0) {
    s == null && (s = {});
    const _e = {
      parent: $,
      val: s,
      pointerSize: 0
    };
    this.preEncode != null && this.preEncode.call(s);
    let tt = 0;
    for (let nt in this.fields) {
      const at = this.fields[nt];
      at.size != null && (tt += at.size(s[nt], _e));
    }
    return _ && (tt += _e.pointerSize), tt;
  }
  encode(s, $, _) {
    let _e;
    this.preEncode != null && this.preEncode.call($, s);
    const tt = {
      pointers: [],
      startOffset: s.pos,
      parent: _,
      val: $,
      pointerSize: 0
    };
    tt.pointerOffset = s.pos + this.size($, tt, !1);
    for (let at in this.fields)
      _e = this.fields[at], _e.encode != null && _e.encode(s, $[at], tt);
    let nt = 0;
    for (; nt < tt.pointers.length; ) {
      const at = tt.pointers[nt++];
      at.type.encode(s, at.val, at.parent);
    }
  }
}
const getPath$1 = (a, s) => s.reduce(($, _) => $ && $[_], a);
class VersionedStruct extends Struct {
  constructor(s, $ = {}) {
    super(), this.type = s, this.versions = $, typeof s == "string" && (this.versionPath = s.split("."));
  }
  decode(s, $, _ = 0) {
    const _e = this._setup(s, $, _);
    typeof this.type == "string" ? _e.version = getPath$1($, this.versionPath) : _e.version = this.type.decode(s), this.versions.header && this._parseFields(s, _e, this.versions.header);
    const tt = this.versions[_e.version];
    if (tt == null)
      throw new Error(`Unknown version ${_e.version}`);
    return tt instanceof VersionedStruct ? tt.decode(s, $) : (this._parseFields(s, _e, tt), this.process != null && this.process.call(_e, s), _e);
  }
  size(s, $, _ = !0) {
    let _e, tt;
    if (!s)
      throw new Error("Not a fixed size");
    this.preEncode != null && this.preEncode.call(s);
    const nt = {
      parent: $,
      val: s,
      pointerSize: 0
    };
    let at = 0;
    if (typeof this.type != "string" && (at += this.type.size(s.version, nt)), this.versions.header)
      for (_e in this.versions.header)
        tt = this.versions.header[_e], tt.size != null && (at += tt.size(s[_e], nt));
    const ot = this.versions[s.version];
    if (ot == null)
      throw new Error(`Unknown version ${s.version}`);
    for (_e in ot)
      tt = ot[_e], tt.size != null && (at += tt.size(s[_e], nt));
    return _ && (at += nt.pointerSize), at;
  }
  encode(s, $, _) {
    let _e, tt;
    this.preEncode != null && this.preEncode.call($, s);
    const nt = {
      pointers: [],
      startOffset: s.pos,
      parent: _,
      val: $,
      pointerSize: 0
    };
    if (nt.pointerOffset = s.pos + this.size($, nt, !1), typeof this.type != "string" && this.type.encode(s, $.version), this.versions.header)
      for (_e in this.versions.header)
        tt = this.versions.header[_e], tt.encode != null && tt.encode(s, $[_e], nt);
    const at = this.versions[$.version];
    for (_e in at)
      tt = at[_e], tt.encode != null && tt.encode(s, $[_e], nt);
    let ot = 0;
    for (; ot < nt.pointers.length; ) {
      const rt = nt.pointers[ot++];
      rt.type.encode(s, rt.val, rt.parent);
    }
  }
}
class Pointer extends Base$2 {
  constructor(s, $, _ = {}) {
    if (super(), this.offsetType = s, this.type = $, this.options = _, this.type === "void" && (this.type = null), this.options.type == null && (this.options.type = "local"), this.options.allowNull == null && (this.options.allowNull = !0), this.options.nullValue == null && (this.options.nullValue = 0), this.options.lazy == null && (this.options.lazy = !1), this.options.relativeTo) {
      if (typeof this.options.relativeTo != "function")
        throw new Error("relativeTo option must be a function");
      this.relativeToGetter = _.relativeTo;
    }
  }
  decode(s, $) {
    const _ = this.offsetType.decode(s, $);
    if (_ === this.options.nullValue && this.options.allowNull)
      return null;
    let _e;
    switch (this.options.type) {
      case "local":
        _e = $._startOffset;
        break;
      case "immediate":
        _e = s.pos - this.offsetType.size();
        break;
      case "parent":
        _e = $.parent._startOffset;
        break;
      default:
        for (var tt = $; tt.parent; )
          tt = tt.parent;
        _e = tt._startOffset || 0;
    }
    this.options.relativeTo && (_e += this.relativeToGetter($));
    const nt = _ + _e;
    if (this.type != null) {
      let at = null;
      const ot = () => {
        if (at != null)
          return at;
        const { pos: rt } = s;
        return s.pos = nt, at = this.type.decode(s, $), s.pos = rt, at;
      };
      return this.options.lazy ? new PropertyDescriptor({
        get: ot
      }) : ot();
    } else
      return nt;
  }
  size(s, $) {
    const _ = $;
    switch (this.options.type) {
      case "local":
      case "immediate":
        break;
      case "parent":
        $ = $.parent;
        break;
      default:
        for (; $.parent; )
          $ = $.parent;
    }
    let { type: _e } = this;
    if (_e == null) {
      if (!(s instanceof VoidPointer))
        throw new Error("Must be a VoidPointer");
      ({ type: _e } = s), s = s.value;
    }
    if (s && $) {
      let tt = _e.size(s, _);
      $.pointerSize += tt;
    }
    return this.offsetType.size();
  }
  encode(s, $, _) {
    let _e;
    const tt = _;
    if ($ == null) {
      this.offsetType.encode(s, this.options.nullValue);
      return;
    }
    switch (this.options.type) {
      case "local":
        _e = _.startOffset;
        break;
      case "immediate":
        _e = s.pos + this.offsetType.size($, tt);
        break;
      case "parent":
        _ = _.parent, _e = _.startOffset;
        break;
      default:
        for (_e = 0; _.parent; )
          _ = _.parent;
    }
    this.options.relativeTo && (_e += this.relativeToGetter(tt.val)), this.offsetType.encode(s, _.pointerOffset - _e);
    let { type: nt } = this;
    if (nt == null) {
      if (!($ instanceof VoidPointer))
        throw new Error("Must be a VoidPointer");
      ({ type: nt } = $), $ = $.value;
    }
    return _.pointers.push({
      type: nt,
      val: $,
      parent: tt
    }), _.pointerOffset += nt.size($, tt);
  }
}
class VoidPointer {
  constructor(s, $) {
    this.type = s, this.value = $;
  }
}
function _define_property(a, s, $) {
  return s in a ? Object.defineProperty(a, s, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = $, a;
}
function __decorate$3(a, s, $, _) {
  var _e = arguments.length, tt = _e < 3 ? s : _ === null ? _ = Object.getOwnPropertyDescriptor(s, $) : _, nt;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    tt = Reflect.decorate(a, s, $, _);
  else
    for (var at = a.length - 1; at >= 0; at--)
      (nt = a[at]) && (tt = (_e < 3 ? nt(tt) : _e > 3 ? nt(s, $, tt) : nt(s, $)) || tt);
  return _e > 3 && tt && Object.defineProperty(s, $, tt), tt;
}
typeof SuppressedError == "function" && SuppressedError;
var fastDeepEqual = function a(s, $) {
  if (s === $)
    return !0;
  if (s && $ && typeof s == "object" && typeof $ == "object") {
    if (s.constructor !== $.constructor)
      return !1;
    var _, _e, tt;
    if (Array.isArray(s)) {
      if (_ = s.length, _ != $.length)
        return !1;
      for (_e = _; _e-- !== 0; )
        if (!a(s[_e], $[_e]))
          return !1;
      return !0;
    }
    if (s.constructor === RegExp)
      return s.source === $.source && s.flags === $.flags;
    if (s.valueOf !== Object.prototype.valueOf)
      return s.valueOf() === $.valueOf();
    if (s.toString !== Object.prototype.toString)
      return s.toString() === $.toString();
    if (tt = Object.keys(s), _ = tt.length, _ !== Object.keys($).length)
      return !1;
    for (_e = _; _e-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call($, tt[_e]))
        return !1;
    for (_e = _; _e-- !== 0; ) {
      var nt = tt[_e];
      if (!a(s[nt], $[nt]))
        return !1;
    }
    return !0;
  }
  return s !== s && $ !== $;
};
const $6uUbQ$fastdeepequal = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqual);
var TINF_OK = 0, TINF_DATA_ERROR = -3;
function Tree$4() {
  this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
}
function Data(a, s) {
  this.source = a, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = s, this.destLen = 0, this.ltree = new Tree$4(), this.dtree = new Tree$4();
}
var sltree = new Tree$4(), sdtree = new Tree$4(), length_bits = new Uint8Array(30), length_base = new Uint16Array(30), dist_bits = new Uint8Array(30), dist_base = new Uint16Array(30), clcidx = new Uint8Array([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), code_tree = new Tree$4(), lengths = new Uint8Array(320);
function tinf_build_bits_base(a, s, $, _) {
  var _e, tt;
  for (_e = 0; _e < $; ++_e)
    a[_e] = 0;
  for (_e = 0; _e < 30 - $; ++_e)
    a[_e + $] = _e / $ | 0;
  for (tt = _, _e = 0; _e < 30; ++_e)
    s[_e] = tt, tt += 1 << a[_e];
}
function tinf_build_fixed_trees(a, s) {
  var $;
  for ($ = 0; $ < 7; ++$)
    a.table[$] = 0;
  for (a.table[7] = 24, a.table[8] = 152, a.table[9] = 112, $ = 0; $ < 24; ++$)
    a.trans[$] = 256 + $;
  for ($ = 0; $ < 144; ++$)
    a.trans[24 + $] = $;
  for ($ = 0; $ < 8; ++$)
    a.trans[168 + $] = 280 + $;
  for ($ = 0; $ < 112; ++$)
    a.trans[176 + $] = 144 + $;
  for ($ = 0; $ < 5; ++$)
    s.table[$] = 0;
  for (s.table[5] = 32, $ = 0; $ < 32; ++$)
    s.trans[$] = $;
}
var offs = new Uint16Array(16);
function tinf_build_tree(a, s, $, _) {
  var _e, tt;
  for (_e = 0; _e < 16; ++_e)
    a.table[_e] = 0;
  for (_e = 0; _e < _; ++_e)
    a.table[s[$ + _e]]++;
  for (a.table[0] = 0, tt = 0, _e = 0; _e < 16; ++_e)
    offs[_e] = tt, tt += a.table[_e];
  for (_e = 0; _e < _; ++_e)
    s[$ + _e] && (a.trans[offs[s[$ + _e]]++] = _e);
}
function tinf_getbit(a) {
  a.bitcount-- || (a.tag = a.source[a.sourceIndex++], a.bitcount = 7);
  var s = a.tag & 1;
  return a.tag >>>= 1, s;
}
function tinf_read_bits(a, s, $) {
  if (!s)
    return $;
  for (; a.bitcount < 24; )
    a.tag |= a.source[a.sourceIndex++] << a.bitcount, a.bitcount += 8;
  var _ = a.tag & 65535 >>> 16 - s;
  return a.tag >>>= s, a.bitcount -= s, _ + $;
}
function tinf_decode_symbol(a, s) {
  for (; a.bitcount < 24; )
    a.tag |= a.source[a.sourceIndex++] << a.bitcount, a.bitcount += 8;
  var $ = 0, _ = 0, _e = 0, tt = a.tag;
  do
    _ = 2 * _ + (tt & 1), tt >>>= 1, ++_e, $ += s.table[_e], _ -= s.table[_e];
  while (_ >= 0);
  return a.tag = tt, a.bitcount -= _e, s.trans[$ + _];
}
function tinf_decode_trees(a, s, $) {
  var _, _e, tt, nt, at, ot;
  for (_ = tinf_read_bits(a, 5, 257), _e = tinf_read_bits(a, 5, 1), tt = tinf_read_bits(a, 4, 4), nt = 0; nt < 19; ++nt)
    lengths[nt] = 0;
  for (nt = 0; nt < tt; ++nt) {
    var rt = tinf_read_bits(a, 3, 0);
    lengths[clcidx[nt]] = rt;
  }
  for (tinf_build_tree(code_tree, lengths, 0, 19), at = 0; at < _ + _e; ) {
    var st = tinf_decode_symbol(a, code_tree);
    switch (st) {
      case 16:
        var lt = lengths[at - 1];
        for (ot = tinf_read_bits(a, 2, 3); ot; --ot)
          lengths[at++] = lt;
        break;
      case 17:
        for (ot = tinf_read_bits(a, 3, 3); ot; --ot)
          lengths[at++] = 0;
        break;
      case 18:
        for (ot = tinf_read_bits(a, 7, 11); ot; --ot)
          lengths[at++] = 0;
        break;
      default:
        lengths[at++] = st;
        break;
    }
  }
  tinf_build_tree(s, lengths, 0, _), tinf_build_tree($, lengths, _, _e);
}
function tinf_inflate_block_data(a, s, $) {
  for (; ; ) {
    var _ = tinf_decode_symbol(a, s);
    if (_ === 256)
      return TINF_OK;
    if (_ < 256)
      a.dest[a.destLen++] = _;
    else {
      var _e, tt, nt, at;
      for (_ -= 257, _e = tinf_read_bits(a, length_bits[_], length_base[_]), tt = tinf_decode_symbol(a, $), nt = a.destLen - tinf_read_bits(a, dist_bits[tt], dist_base[tt]), at = nt; at < nt + _e; ++at)
        a.dest[a.destLen++] = a.dest[at];
    }
  }
}
function tinf_inflate_uncompressed_block(a) {
  for (var s, $, _; a.bitcount > 8; )
    a.sourceIndex--, a.bitcount -= 8;
  if (s = a.source[a.sourceIndex + 1], s = 256 * s + a.source[a.sourceIndex], $ = a.source[a.sourceIndex + 3], $ = 256 * $ + a.source[a.sourceIndex + 2], s !== (~$ & 65535))
    return TINF_DATA_ERROR;
  for (a.sourceIndex += 4, _ = s; _; --_)
    a.dest[a.destLen++] = a.source[a.sourceIndex++];
  return a.bitcount = 0, TINF_OK;
}
function tinf_uncompress(a, s) {
  var $ = new Data(a, s), _, _e, tt;
  do {
    switch (_ = tinf_getbit($), _e = tinf_read_bits($, 2, 0), _e) {
      case 0:
        tt = tinf_inflate_uncompressed_block($);
        break;
      case 1:
        tt = tinf_inflate_block_data($, sltree, sdtree);
        break;
      case 2:
        tinf_decode_trees($, $.ltree, $.dtree), tt = tinf_inflate_block_data($, $.ltree, $.dtree);
        break;
      default:
        tt = TINF_DATA_ERROR;
    }
    if (tt !== TINF_OK)
      throw new Error("Data error");
  } while (!_);
  return $.destLen < $.dest.length ? typeof $.dest.slice == "function" ? $.dest.slice(0, $.destLen) : $.dest.subarray(0, $.destLen) : $.dest;
}
tinf_build_fixed_trees(sltree, sdtree);
tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);
length_bits[28] = 0;
length_base[28] = 258;
var tinyInflate = tinf_uncompress;
const $6uUbQ$tinyinflate = /* @__PURE__ */ getDefaultExportFromCjs(tinyInflate), isBigEndian = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18, swap$2 = (a, s, $) => {
  let _ = a[s];
  a[s] = a[$], a[$] = _;
}, swap32 = (a) => {
  const s = a.length;
  for (let $ = 0; $ < s; $ += 4)
    swap$2(a, $, $ + 3), swap$2(a, $ + 1, $ + 2);
}, swap32LE$1 = (a) => {
  isBigEndian && swap32(a);
};
var swap_1 = {
  swap32LE: swap32LE$1
};
const inflate$5 = tinyInflate, { swap32LE } = swap_1, SHIFT_1 = 11, SHIFT_2 = 5, SHIFT_1_2 = SHIFT_1 - SHIFT_2, OMITTED_BMP_INDEX_1_LENGTH = 65536 >> SHIFT_1, INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2, INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1, INDEX_SHIFT = 2, DATA_BLOCK_LENGTH = 1 << SHIFT_2, DATA_MASK = DATA_BLOCK_LENGTH - 1, LSCP_INDEX_2_OFFSET = 65536 >> SHIFT_2, LSCP_INDEX_2_LENGTH = 1024 >> SHIFT_2, INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH, UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH, UTF8_2B_INDEX_2_LENGTH = 32, INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH, DATA_GRANULARITY = 1 << INDEX_SHIFT;
class UnicodeTrie {
  constructor(s) {
    const $ = typeof s.readUInt32BE == "function" && typeof s.slice == "function";
    if ($ || s instanceof Uint8Array) {
      let _;
      if ($)
        this.highStart = s.readUInt32LE(0), this.errorValue = s.readUInt32LE(4), _ = s.readUInt32LE(8), s = s.slice(12);
      else {
        const _e = new DataView(s.buffer);
        this.highStart = _e.getUint32(0, !0), this.errorValue = _e.getUint32(4, !0), _ = _e.getUint32(8, !0), s = s.subarray(12);
      }
      s = inflate$5(s, new Uint8Array(_)), s = inflate$5(s, new Uint8Array(_)), swap32LE(s), this.data = new Uint32Array(s.buffer);
    } else
      ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = s);
  }
  get(s) {
    let $;
    return s < 0 || s > 1114111 ? this.errorValue : s < 55296 || s > 56319 && s <= 65535 ? ($ = (this.data[s >> SHIFT_2] << INDEX_SHIFT) + (s & DATA_MASK), this.data[$]) : s <= 65535 ? ($ = (this.data[LSCP_INDEX_2_OFFSET + (s - 55296 >> SHIFT_2)] << INDEX_SHIFT) + (s & DATA_MASK), this.data[$]) : s < this.highStart ? ($ = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (s >> SHIFT_1)], $ = this.data[$ + (s >> SHIFT_2 & INDEX_2_MASK)], $ = ($ << INDEX_SHIFT) + (s & DATA_MASK), this.data[$]) : this.data[this.data.length - DATA_GRANULARITY];
  }
}
var unicodeTrie = UnicodeTrie;
const $6uUbQ$unicodetrie = /* @__PURE__ */ getDefaultExportFromCjs(unicodeTrie);
function $parcel$interopDefault$1(a) {
  return a && a.__esModule ? a.default : a;
}
var $f4087201da764553$exports = {};
$f4087201da764553$exports = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
const $747425b437e121da$var$trie = new $6uUbQ$unicodetrie(base64Js.toByteArray("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")), $747425b437e121da$var$log2 = Math.log2 || ((a) => Math.log(a) / Math.LN2), $747425b437e121da$var$bits = (a) => $747425b437e121da$var$log2(a) + 1 | 0, $747425b437e121da$var$CATEGORY_BITS = $747425b437e121da$var$bits((/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).categories.length - 1), $747425b437e121da$var$COMBINING_BITS = $747425b437e121da$var$bits((/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).combiningClasses.length - 1), $747425b437e121da$var$SCRIPT_BITS = $747425b437e121da$var$bits((/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).scripts.length - 1), $747425b437e121da$var$EAW_BITS = $747425b437e121da$var$bits((/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).eaw.length - 1), $747425b437e121da$var$NUMBER_BITS = 10, $747425b437e121da$var$CATEGORY_SHIFT = $747425b437e121da$var$COMBINING_BITS + $747425b437e121da$var$SCRIPT_BITS + $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS, $747425b437e121da$var$COMBINING_SHIFT = $747425b437e121da$var$SCRIPT_BITS + $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS, $747425b437e121da$var$SCRIPT_SHIFT = $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS, $747425b437e121da$var$CATEGORY_MASK = (1 << $747425b437e121da$var$CATEGORY_BITS) - 1, $747425b437e121da$var$COMBINING_MASK = (1 << $747425b437e121da$var$COMBINING_BITS) - 1, $747425b437e121da$var$SCRIPT_MASK = (1 << $747425b437e121da$var$SCRIPT_BITS) - 1;
function $747425b437e121da$export$410364bbb673ddbc(a) {
  const s = $747425b437e121da$var$trie.get(a);
  return (/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).categories[s >> $747425b437e121da$var$CATEGORY_SHIFT & $747425b437e121da$var$CATEGORY_MASK];
}
function $747425b437e121da$export$c03b919c6651ed55(a) {
  const s = $747425b437e121da$var$trie.get(a);
  return (/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).combiningClasses[s >> $747425b437e121da$var$COMBINING_SHIFT & $747425b437e121da$var$COMBINING_MASK];
}
function $747425b437e121da$export$941569448d136665(a) {
  const s = $747425b437e121da$var$trie.get(a);
  return (/* @__PURE__ */ $parcel$interopDefault$1($f4087201da764553$exports)).scripts[s >> $747425b437e121da$var$SCRIPT_SHIFT & $747425b437e121da$var$SCRIPT_MASK];
}
function $747425b437e121da$export$727d9dbc4fbb948f(a) {
  return $747425b437e121da$export$410364bbb673ddbc(a) === "Nd";
}
function $747425b437e121da$export$e33ad6871e762338(a) {
  const s = $747425b437e121da$export$410364bbb673ddbc(a);
  return s === "Mn" || s === "Me" || s === "Mc";
}
var INITIAL_STATE = 1, FAIL_STATE = 0;
class StateMachine {
  constructor(s) {
    this.stateTable = s.stateTable, this.accepting = s.accepting, this.tags = s.tags;
  }
  /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */
  match(s) {
    var $ = this;
    return {
      *[Symbol.iterator]() {
        for (var _ = INITIAL_STATE, _e = null, tt = null, nt = null, at = 0; at < s.length; at++) {
          var ot = s[at];
          nt = _, _ = $.stateTable[_][ot], _ === FAIL_STATE && (_e != null && tt != null && tt >= _e && (yield [_e, tt, $.tags[nt]]), _ = $.stateTable[INITIAL_STATE][ot], _e = null), _ !== FAIL_STATE && _e == null && (_e = at), $.accepting[_] && (tt = at), _ === FAIL_STATE && (_ = INITIAL_STATE);
        }
        _e != null && tt != null && tt >= _e && (yield [_e, tt, $.tags[_]]);
      }
    };
  }
  /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */
  apply(s, $) {
    for (var [_, _e, tt] of this.match(s))
      for (var nt of tt)
        typeof $[nt] == "function" && $[nt](_, _e, s.slice(_, _e + 1));
  }
}
var dfa = StateMachine;
const $6uUbQ$dfa = /* @__PURE__ */ getDefaultExportFromCjs(dfa);
var clone = { exports: {} };
(function(a) {
  var s = function() {
    function $(et, it) {
      return it != null && et instanceof it;
    }
    var _;
    try {
      _ = Map;
    } catch {
      _ = function() {
      };
    }
    var _e;
    try {
      _e = Set;
    } catch {
      _e = function() {
      };
    }
    var tt;
    try {
      tt = Promise;
    } catch {
      tt = function() {
      };
    }
    function nt(et, it, ut, ft, ht) {
      typeof it == "object" && (ut = it.depth, ft = it.prototype, ht = it.includeNonEnumerable, it = it.circular);
      var dt = [], gt = [], pt = typeof Buffer < "u";
      typeof it > "u" && (it = !0), typeof ut > "u" && (ut = 1 / 0);
      function mt(ct, vt) {
        if (ct === null)
          return null;
        if (vt === 0)
          return ct;
        var At, xt;
        if (typeof ct != "object")
          return ct;
        if ($(ct, _))
          At = new _();
        else if ($(ct, _e))
          At = new _e();
        else if ($(ct, tt))
          At = new tt(function(It, yt) {
            ct.then(function(Rt) {
              It(mt(Rt, vt - 1));
            }, function(Rt) {
              yt(mt(Rt, vt - 1));
            });
          });
        else if (nt.__isArray(ct))
          At = [];
        else if (nt.__isRegExp(ct))
          At = new RegExp(ct.source, lt(ct)), ct.lastIndex && (At.lastIndex = ct.lastIndex);
        else if (nt.__isDate(ct))
          At = new Date(ct.getTime());
        else {
          if (pt && Buffer.isBuffer(ct))
            return Buffer.allocUnsafe ? At = Buffer.allocUnsafe(ct.length) : At = new Buffer(ct.length), ct.copy(At), At;
          $(ct, Error) ? At = Object.create(ct) : typeof ft > "u" ? (xt = Object.getPrototypeOf(ct), At = Object.create(xt)) : (At = Object.create(ft), xt = ft);
        }
        if (it) {
          var bt = dt.indexOf(ct);
          if (bt != -1)
            return gt[bt];
          dt.push(ct), gt.push(At);
        }
        $(ct, _) && ct.forEach(function(It, yt) {
          var Rt = mt(yt, vt - 1), kt = mt(It, vt - 1);
          At.set(Rt, kt);
        }), $(ct, _e) && ct.forEach(function(It) {
          var yt = mt(It, vt - 1);
          At.add(yt);
        });
        for (var Et in ct) {
          var St;
          xt && (St = Object.getOwnPropertyDescriptor(xt, Et)), !(St && St.set == null) && (At[Et] = mt(ct[Et], vt - 1));
        }
        if (Object.getOwnPropertySymbols)
          for (var Bt = Object.getOwnPropertySymbols(ct), Et = 0; Et < Bt.length; Et++) {
            var Ot = Bt[Et], Pt = Object.getOwnPropertyDescriptor(ct, Ot);
            Pt && !Pt.enumerable && !ht || (At[Ot] = mt(ct[Ot], vt - 1), Pt.enumerable || Object.defineProperty(At, Ot, {
              enumerable: !1
            }));
          }
        if (ht)
          for (var wt = Object.getOwnPropertyNames(ct), Et = 0; Et < wt.length; Et++) {
            var Ct = wt[Et], Pt = Object.getOwnPropertyDescriptor(ct, Ct);
            Pt && Pt.enumerable || (At[Ct] = mt(ct[Ct], vt - 1), Object.defineProperty(At, Ct, {
              enumerable: !1
            }));
          }
        return At;
      }
      return mt(et, ut);
    }
    nt.clonePrototype = function(it) {
      if (it === null)
        return null;
      var ut = function() {
      };
      return ut.prototype = it, new ut();
    };
    function at(et) {
      return Object.prototype.toString.call(et);
    }
    nt.__objToStr = at;
    function ot(et) {
      return typeof et == "object" && at(et) === "[object Date]";
    }
    nt.__isDate = ot;
    function rt(et) {
      return typeof et == "object" && at(et) === "[object Array]";
    }
    nt.__isArray = rt;
    function st(et) {
      return typeof et == "object" && at(et) === "[object RegExp]";
    }
    nt.__isRegExp = st;
    function lt(et) {
      var it = "";
      return et.global && (it += "g"), et.ignoreCase && (it += "i"), et.multiline && (it += "m"), it;
    }
    return nt.__getRegExpFlags = lt, nt;
  }();
  a.exports && (a.exports = s);
})(clone);
var cloneExports = clone.exports;
const $6uUbQ$clone = /* @__PURE__ */ getDefaultExportFromCjs(cloneExports);
var decode$1 = {}, streams = {};
function BrotliInput(a) {
  this.buffer = a, this.pos = 0;
}
BrotliInput.prototype.read = function(a, s, $) {
  this.pos + $ > this.buffer.length && ($ = this.buffer.length - this.pos);
  for (var _ = 0; _ < $; _++)
    a[s + _] = this.buffer[this.pos + _];
  return this.pos += $, $;
};
streams.BrotliInput = BrotliInput;
function BrotliOutput(a) {
  this.buffer = a, this.pos = 0;
}
BrotliOutput.prototype.write = function(a, s) {
  if (this.pos + s > this.buffer.length)
    throw new Error("Output buffer is not large enough");
  return this.buffer.set(a.subarray(0, s), this.pos), this.pos += s, s;
};
streams.BrotliOutput = BrotliOutput;
var BROTLI_READ_SIZE = 4096, BROTLI_IBUF_SIZE = 2 * BROTLI_READ_SIZE + 32, BROTLI_IBUF_MASK = 2 * BROTLI_READ_SIZE - 1, kBitMask = new Uint32Array([
  0,
  1,
  3,
  7,
  15,
  31,
  63,
  127,
  255,
  511,
  1023,
  2047,
  4095,
  8191,
  16383,
  32767,
  65535,
  131071,
  262143,
  524287,
  1048575,
  2097151,
  4194303,
  8388607,
  16777215
]);
function BrotliBitReader(a) {
  this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE), this.input_ = a, this.reset();
}
BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;
BrotliBitReader.prototype.reset = function() {
  this.buf_ptr_ = 0, this.val_ = 0, this.pos_ = 0, this.bit_pos_ = 0, this.bit_end_pos_ = 0, this.eos_ = 0, this.readMoreInput();
  for (var a = 0; a < 4; a++)
    this.val_ |= this.buf_[this.pos_] << 8 * a, ++this.pos_;
  return this.bit_end_pos_ > 0;
};
BrotliBitReader.prototype.readMoreInput = function() {
  if (!(this.bit_end_pos_ > 256))
    if (this.eos_) {
      if (this.bit_pos_ > this.bit_end_pos_)
        throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
    } else {
      var a = this.buf_ptr_, s = this.input_.read(this.buf_, a, BROTLI_READ_SIZE);
      if (s < 0)
        throw new Error("Unexpected end of input");
      if (s < BROTLI_READ_SIZE) {
        this.eos_ = 1;
        for (var $ = 0; $ < 32; $++)
          this.buf_[a + s + $] = 0;
      }
      if (a === 0) {
        for (var $ = 0; $ < 32; $++)
          this.buf_[(BROTLI_READ_SIZE << 1) + $] = this.buf_[$];
        this.buf_ptr_ = BROTLI_READ_SIZE;
      } else
        this.buf_ptr_ = 0;
      this.bit_end_pos_ += s << 3;
    }
};
BrotliBitReader.prototype.fillBitWindow = function() {
  for (; this.bit_pos_ >= 8; )
    this.val_ >>>= 8, this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24, ++this.pos_, this.bit_pos_ = this.bit_pos_ - 8 >>> 0, this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
};
BrotliBitReader.prototype.readBits = function(a) {
  32 - this.bit_pos_ < a && this.fillBitWindow();
  var s = this.val_ >>> this.bit_pos_ & kBitMask[a];
  return this.bit_pos_ += a, s;
};
var bit_reader = BrotliBitReader, dictionary = {}, dictionaryBrowser = {}, dictionary_bin, hasRequiredDictionary_bin;
function requireDictionary_bin() {
  return hasRequiredDictionary_bin || (hasRequiredDictionary_bin = 1, dictionary_bin = "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"), dictionary_bin;
}
var hasRequiredDictionaryBrowser;
function requireDictionaryBrowser() {
  if (hasRequiredDictionaryBrowser)
    return dictionaryBrowser;
  hasRequiredDictionaryBrowser = 1;
  var a = base64Js;
  return dictionaryBrowser.init = function() {
    var s = requireDecode().BrotliDecompressBuffer, $ = a.toByteArray(requireDictionary_bin());
    return s($);
  }, dictionaryBrowser;
}
var hasRequiredDictionary;
function requireDictionary() {
  if (hasRequiredDictionary)
    return dictionary;
  hasRequiredDictionary = 1;
  var a = requireDictionaryBrowser();
  return dictionary.init = function() {
    dictionary.dictionary = a.init();
  }, dictionary.offsetsByLength = new Uint32Array([
    0,
    0,
    0,
    0,
    0,
    4096,
    9216,
    21504,
    35840,
    44032,
    53248,
    63488,
    74752,
    87040,
    93696,
    100864,
    104704,
    106752,
    108928,
    113536,
    115968,
    118528,
    119872,
    121280,
    122016
  ]), dictionary.sizeBitsByLength = new Uint8Array([
    0,
    0,
    0,
    0,
    10,
    10,
    11,
    11,
    10,
    10,
    10,
    10,
    10,
    9,
    9,
    8,
    7,
    7,
    8,
    7,
    7,
    6,
    6,
    5,
    5
  ]), dictionary.minDictionaryWordLength = 4, dictionary.maxDictionaryWordLength = 24, dictionary;
}
var huffman = {};
function HuffmanCode(a, s) {
  this.bits = a, this.value = s;
}
huffman.HuffmanCode = HuffmanCode;
var MAX_LENGTH = 15;
function GetNextKey(a, s) {
  for (var $ = 1 << s - 1; a & $; )
    $ >>= 1;
  return (a & $ - 1) + $;
}
function ReplicateValue(a, s, $, _, _e) {
  do
    _ -= $, a[s + _] = new HuffmanCode(_e.bits, _e.value);
  while (_ > 0);
}
function NextTableBitSize(a, s, $) {
  for (var _ = 1 << s - $; s < MAX_LENGTH && (_ -= a[s], !(_ <= 0)); )
    ++s, _ <<= 1;
  return s - $;
}
huffman.BrotliBuildHuffmanTable = function(a, s, $, _, _e) {
  var tt = s, nt, at, ot, rt, st, lt, et, it, ut, ft, ht, dt = new Int32Array(MAX_LENGTH + 1), gt = new Int32Array(MAX_LENGTH + 1);
  for (ht = new Int32Array(_e), ot = 0; ot < _e; ot++)
    dt[_[ot]]++;
  for (gt[1] = 0, at = 1; at < MAX_LENGTH; at++)
    gt[at + 1] = gt[at] + dt[at];
  for (ot = 0; ot < _e; ot++)
    _[ot] !== 0 && (ht[gt[_[ot]]++] = ot);
  if (it = $, ut = 1 << it, ft = ut, gt[MAX_LENGTH] === 1) {
    for (rt = 0; rt < ft; ++rt)
      a[s + rt] = new HuffmanCode(0, ht[0] & 65535);
    return ft;
  }
  for (rt = 0, ot = 0, at = 1, st = 2; at <= $; ++at, st <<= 1)
    for (; dt[at] > 0; --dt[at])
      nt = new HuffmanCode(at & 255, ht[ot++] & 65535), ReplicateValue(a, s + rt, st, ut, nt), rt = GetNextKey(rt, at);
  for (et = ft - 1, lt = -1, at = $ + 1, st = 2; at <= MAX_LENGTH; ++at, st <<= 1)
    for (; dt[at] > 0; --dt[at])
      (rt & et) !== lt && (s += ut, it = NextTableBitSize(dt, at, $), ut = 1 << it, ft += ut, lt = rt & et, a[tt + lt] = new HuffmanCode(it + $ & 255, s - tt - lt & 65535)), nt = new HuffmanCode(at - $ & 255, ht[ot++] & 65535), ReplicateValue(a, s + (rt >> $), st, ut, nt), rt = GetNextKey(rt, at);
  return ft;
};
var context = {};
context.lookup = new Uint8Array([
  /* CONTEXT_UTF8, last byte. */
  /* ASCII range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  4,
  4,
  0,
  0,
  4,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  8,
  12,
  16,
  12,
  12,
  20,
  12,
  16,
  24,
  28,
  12,
  12,
  32,
  12,
  36,
  12,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  44,
  32,
  32,
  24,
  40,
  28,
  12,
  12,
  48,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  52,
  52,
  48,
  52,
  52,
  52,
  52,
  52,
  24,
  12,
  28,
  12,
  12,
  12,
  56,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  60,
  60,
  56,
  60,
  60,
  60,
  60,
  60,
  24,
  12,
  28,
  12,
  0,
  /* UTF8 continuation byte range. */
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  /* UTF8 lead byte range. */
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  2,
  3,
  /* CONTEXT_UTF8 second last byte. */
  /* ASCII range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  1,
  1,
  1,
  1,
  1,
  1,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  1,
  1,
  1,
  1,
  0,
  /* UTF8 continuation byte range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  /* UTF8 lead byte range. */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  /* CONTEXT_SIGNED, second last byte. */
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  5,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  6,
  7,
  /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
  0,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  8,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  32,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  40,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  48,
  56,
  /* CONTEXT_LSB6, last byte. */
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  /* CONTEXT_MSB6, last byte. */
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  6,
  6,
  6,
  6,
  7,
  7,
  7,
  7,
  8,
  8,
  8,
  8,
  9,
  9,
  9,
  9,
  10,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  22,
  22,
  22,
  22,
  23,
  23,
  23,
  23,
  24,
  24,
  24,
  24,
  25,
  25,
  25,
  25,
  26,
  26,
  26,
  26,
  27,
  27,
  27,
  27,
  28,
  28,
  28,
  28,
  29,
  29,
  29,
  29,
  30,
  30,
  30,
  30,
  31,
  31,
  31,
  31,
  32,
  32,
  32,
  32,
  33,
  33,
  33,
  33,
  34,
  34,
  34,
  34,
  35,
  35,
  35,
  35,
  36,
  36,
  36,
  36,
  37,
  37,
  37,
  37,
  38,
  38,
  38,
  38,
  39,
  39,
  39,
  39,
  40,
  40,
  40,
  40,
  41,
  41,
  41,
  41,
  42,
  42,
  42,
  42,
  43,
  43,
  43,
  43,
  44,
  44,
  44,
  44,
  45,
  45,
  45,
  45,
  46,
  46,
  46,
  46,
  47,
  47,
  47,
  47,
  48,
  48,
  48,
  48,
  49,
  49,
  49,
  49,
  50,
  50,
  50,
  50,
  51,
  51,
  51,
  51,
  52,
  52,
  52,
  52,
  53,
  53,
  53,
  53,
  54,
  54,
  54,
  54,
  55,
  55,
  55,
  55,
  56,
  56,
  56,
  56,
  57,
  57,
  57,
  57,
  58,
  58,
  58,
  58,
  59,
  59,
  59,
  59,
  60,
  60,
  60,
  60,
  61,
  61,
  61,
  61,
  62,
  62,
  62,
  62,
  63,
  63,
  63,
  63,
  /* CONTEXT_{M,L}SB6, second last byte, */
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0
]);
context.lookupOffsets = new Uint16Array([
  /* CONTEXT_LSB6 */
  1024,
  1536,
  /* CONTEXT_MSB6 */
  1280,
  1536,
  /* CONTEXT_UTF8 */
  0,
  256,
  /* CONTEXT_SIGNED */
  768,
  512
]);
var prefix$2 = {};
function PrefixCodeRange(a, s) {
  this.offset = a, this.nbits = s;
}
prefix$2.kBlockLengthPrefixCode = [
  new PrefixCodeRange(1, 2),
  new PrefixCodeRange(5, 2),
  new PrefixCodeRange(9, 2),
  new PrefixCodeRange(13, 2),
  new PrefixCodeRange(17, 3),
  new PrefixCodeRange(25, 3),
  new PrefixCodeRange(33, 3),
  new PrefixCodeRange(41, 3),
  new PrefixCodeRange(49, 4),
  new PrefixCodeRange(65, 4),
  new PrefixCodeRange(81, 4),
  new PrefixCodeRange(97, 4),
  new PrefixCodeRange(113, 5),
  new PrefixCodeRange(145, 5),
  new PrefixCodeRange(177, 5),
  new PrefixCodeRange(209, 5),
  new PrefixCodeRange(241, 6),
  new PrefixCodeRange(305, 6),
  new PrefixCodeRange(369, 7),
  new PrefixCodeRange(497, 8),
  new PrefixCodeRange(753, 9),
  new PrefixCodeRange(1265, 10),
  new PrefixCodeRange(2289, 11),
  new PrefixCodeRange(4337, 12),
  new PrefixCodeRange(8433, 13),
  new PrefixCodeRange(16625, 24)
];
prefix$2.kInsertLengthPrefixCode = [
  new PrefixCodeRange(0, 0),
  new PrefixCodeRange(1, 0),
  new PrefixCodeRange(2, 0),
  new PrefixCodeRange(3, 0),
  new PrefixCodeRange(4, 0),
  new PrefixCodeRange(5, 0),
  new PrefixCodeRange(6, 1),
  new PrefixCodeRange(8, 1),
  new PrefixCodeRange(10, 2),
  new PrefixCodeRange(14, 2),
  new PrefixCodeRange(18, 3),
  new PrefixCodeRange(26, 3),
  new PrefixCodeRange(34, 4),
  new PrefixCodeRange(50, 4),
  new PrefixCodeRange(66, 5),
  new PrefixCodeRange(98, 5),
  new PrefixCodeRange(130, 6),
  new PrefixCodeRange(194, 7),
  new PrefixCodeRange(322, 8),
  new PrefixCodeRange(578, 9),
  new PrefixCodeRange(1090, 10),
  new PrefixCodeRange(2114, 12),
  new PrefixCodeRange(6210, 14),
  new PrefixCodeRange(22594, 24)
];
prefix$2.kCopyLengthPrefixCode = [
  new PrefixCodeRange(2, 0),
  new PrefixCodeRange(3, 0),
  new PrefixCodeRange(4, 0),
  new PrefixCodeRange(5, 0),
  new PrefixCodeRange(6, 0),
  new PrefixCodeRange(7, 0),
  new PrefixCodeRange(8, 0),
  new PrefixCodeRange(9, 0),
  new PrefixCodeRange(10, 1),
  new PrefixCodeRange(12, 1),
  new PrefixCodeRange(14, 2),
  new PrefixCodeRange(18, 2),
  new PrefixCodeRange(22, 3),
  new PrefixCodeRange(30, 3),
  new PrefixCodeRange(38, 4),
  new PrefixCodeRange(54, 4),
  new PrefixCodeRange(70, 5),
  new PrefixCodeRange(102, 5),
  new PrefixCodeRange(134, 6),
  new PrefixCodeRange(198, 7),
  new PrefixCodeRange(326, 8),
  new PrefixCodeRange(582, 9),
  new PrefixCodeRange(1094, 10),
  new PrefixCodeRange(2118, 24)
];
prefix$2.kInsertRangeLut = [
  0,
  0,
  8,
  8,
  0,
  16,
  8,
  16,
  16
];
prefix$2.kCopyRangeLut = [
  0,
  8,
  0,
  8,
  16,
  0,
  16,
  8,
  16
];
var transform = {}, hasRequiredTransform;
function requireTransform() {
  if (hasRequiredTransform)
    return transform;
  hasRequiredTransform = 1;
  var a = requireDictionary(), s = 0, $ = 1, _ = 2, _e = 3, tt = 4, nt = 5, at = 6, ot = 7, rt = 8, st = 9, lt = 10, et = 11, it = 12, ut = 13, ft = 14, ht = 15, dt = 16, gt = 17, pt = 18, mt = 20;
  function ct(xt, bt, Et) {
    this.prefix = new Uint8Array(xt.length), this.transform = bt, this.suffix = new Uint8Array(Et.length);
    for (var St = 0; St < xt.length; St++)
      this.prefix[St] = xt.charCodeAt(St);
    for (var St = 0; St < Et.length; St++)
      this.suffix[St] = Et.charCodeAt(St);
  }
  var vt = [
    new ct("", s, ""),
    new ct("", s, " "),
    new ct(" ", s, " "),
    new ct("", it, ""),
    new ct("", lt, " "),
    new ct("", s, " the "),
    new ct(" ", s, ""),
    new ct("s ", s, " "),
    new ct("", s, " of "),
    new ct("", lt, ""),
    new ct("", s, " and "),
    new ct("", ut, ""),
    new ct("", $, ""),
    new ct(", ", s, " "),
    new ct("", s, ", "),
    new ct(" ", lt, " "),
    new ct("", s, " in "),
    new ct("", s, " to "),
    new ct("e ", s, " "),
    new ct("", s, '"'),
    new ct("", s, "."),
    new ct("", s, '">'),
    new ct("", s, `
`),
    new ct("", _e, ""),
    new ct("", s, "]"),
    new ct("", s, " for "),
    new ct("", ft, ""),
    new ct("", _, ""),
    new ct("", s, " a "),
    new ct("", s, " that "),
    new ct(" ", lt, ""),
    new ct("", s, ". "),
    new ct(".", s, ""),
    new ct(" ", s, ", "),
    new ct("", ht, ""),
    new ct("", s, " with "),
    new ct("", s, "'"),
    new ct("", s, " from "),
    new ct("", s, " by "),
    new ct("", dt, ""),
    new ct("", gt, ""),
    new ct(" the ", s, ""),
    new ct("", tt, ""),
    new ct("", s, ". The "),
    new ct("", et, ""),
    new ct("", s, " on "),
    new ct("", s, " as "),
    new ct("", s, " is "),
    new ct("", ot, ""),
    new ct("", $, "ing "),
    new ct("", s, `
	`),
    new ct("", s, ":"),
    new ct(" ", s, ". "),
    new ct("", s, "ed "),
    new ct("", mt, ""),
    new ct("", pt, ""),
    new ct("", at, ""),
    new ct("", s, "("),
    new ct("", lt, ", "),
    new ct("", rt, ""),
    new ct("", s, " at "),
    new ct("", s, "ly "),
    new ct(" the ", s, " of "),
    new ct("", nt, ""),
    new ct("", st, ""),
    new ct(" ", lt, ", "),
    new ct("", lt, '"'),
    new ct(".", s, "("),
    new ct("", et, " "),
    new ct("", lt, '">'),
    new ct("", s, '="'),
    new ct(" ", s, "."),
    new ct(".com/", s, ""),
    new ct(" the ", s, " of the "),
    new ct("", lt, "'"),
    new ct("", s, ". This "),
    new ct("", s, ","),
    new ct(".", s, " "),
    new ct("", lt, "("),
    new ct("", lt, "."),
    new ct("", s, " not "),
    new ct(" ", s, '="'),
    new ct("", s, "er "),
    new ct(" ", et, " "),
    new ct("", s, "al "),
    new ct(" ", et, ""),
    new ct("", s, "='"),
    new ct("", et, '"'),
    new ct("", lt, ". "),
    new ct(" ", s, "("),
    new ct("", s, "ful "),
    new ct(" ", lt, ". "),
    new ct("", s, "ive "),
    new ct("", s, "less "),
    new ct("", et, "'"),
    new ct("", s, "est "),
    new ct(" ", lt, "."),
    new ct("", et, '">'),
    new ct(" ", s, "='"),
    new ct("", lt, ","),
    new ct("", s, "ize "),
    new ct("", et, "."),
    new ct("Â ", s, ""),
    new ct(" ", s, ","),
    new ct("", lt, '="'),
    new ct("", et, '="'),
    new ct("", s, "ous "),
    new ct("", et, ", "),
    new ct("", lt, "='"),
    new ct(" ", lt, ","),
    new ct(" ", et, '="'),
    new ct(" ", et, ", "),
    new ct("", et, ","),
    new ct("", et, "("),
    new ct("", et, ". "),
    new ct(" ", et, "."),
    new ct("", et, "='"),
    new ct(" ", et, ". "),
    new ct(" ", lt, '="'),
    new ct(" ", et, "='"),
    new ct(" ", lt, "='")
  ];
  transform.kTransforms = vt, transform.kNumTransforms = vt.length;
  function At(xt, bt) {
    return xt[bt] < 192 ? (xt[bt] >= 97 && xt[bt] <= 122 && (xt[bt] ^= 32), 1) : xt[bt] < 224 ? (xt[bt + 1] ^= 32, 2) : (xt[bt + 2] ^= 5, 3);
  }
  return transform.transformDictionaryWord = function(xt, bt, Et, St, Bt) {
    var Ot = vt[Bt].prefix, Pt = vt[Bt].suffix, wt = vt[Bt].transform, Ct = wt < it ? 0 : wt - (it - 1), It = 0, yt = bt, Rt;
    Ct > St && (Ct = St);
    for (var kt = 0; kt < Ot.length; )
      xt[bt++] = Ot[kt++];
    for (Et += Ct, St -= Ct, wt <= st && (St -= wt), It = 0; It < St; It++)
      xt[bt++] = a.dictionary[Et + It];
    if (Rt = bt - St, wt === lt)
      At(xt, Rt);
    else if (wt === et)
      for (; St > 0; ) {
        var jt = At(xt, Rt);
        Rt += jt, St -= jt;
      }
    for (var Ht = 0; Ht < Pt.length; )
      xt[bt++] = Pt[Ht++];
    return bt - yt;
  }, transform;
}
var hasRequiredDecode;
function requireDecode() {
  if (hasRequiredDecode)
    return decode$1;
  hasRequiredDecode = 1;
  var a = streams.BrotliInput, s = streams.BrotliOutput, $ = bit_reader, _ = requireDictionary(), _e = huffman.HuffmanCode, tt = huffman.BrotliBuildHuffmanTable, nt = context, at = prefix$2, ot = requireTransform(), rt = 8, st = 16, lt = 256, et = 704, it = 26, ut = 6, ft = 2, ht = 8, dt = 255, gt = 1080, pt = 18, mt = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
  ]), ct = 16, vt = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
  ]), At = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
  ]), xt = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
  ]);
  function bt($t) {
    var Tt;
    return $t.readBits(1) === 0 ? 16 : (Tt = $t.readBits(3), Tt > 0 ? 17 + Tt : (Tt = $t.readBits(3), Tt > 0 ? 8 + Tt : 17));
  }
  function Et($t) {
    if ($t.readBits(1)) {
      var Tt = $t.readBits(3);
      return Tt === 0 ? 1 : $t.readBits(Tt) + (1 << Tt);
    }
    return 0;
  }
  function St() {
    this.meta_block_length = 0, this.input_end = 0, this.is_uncompressed = 0, this.is_metadata = !1;
  }
  function Bt($t) {
    var Tt = new St(), Dt, Ut, Vt;
    if (Tt.input_end = $t.readBits(1), Tt.input_end && $t.readBits(1))
      return Tt;
    if (Dt = $t.readBits(2) + 4, Dt === 7) {
      if (Tt.is_metadata = !0, $t.readBits(1) !== 0)
        throw new Error("Invalid reserved bit");
      if (Ut = $t.readBits(2), Ut === 0)
        return Tt;
      for (Vt = 0; Vt < Ut; Vt++) {
        var Qt = $t.readBits(8);
        if (Vt + 1 === Ut && Ut > 1 && Qt === 0)
          throw new Error("Invalid size byte");
        Tt.meta_block_length |= Qt << Vt * 8;
      }
    } else
      for (Vt = 0; Vt < Dt; ++Vt) {
        var qt = $t.readBits(4);
        if (Vt + 1 === Dt && Dt > 4 && qt === 0)
          throw new Error("Invalid size nibble");
        Tt.meta_block_length |= qt << Vt * 4;
      }
    return ++Tt.meta_block_length, !Tt.input_end && !Tt.is_metadata && (Tt.is_uncompressed = $t.readBits(1)), Tt;
  }
  function Ot($t, Tt, Dt) {
    var Ut;
    return Dt.fillBitWindow(), Tt += Dt.val_ >>> Dt.bit_pos_ & dt, Ut = $t[Tt].bits - ht, Ut > 0 && (Dt.bit_pos_ += ht, Tt += $t[Tt].value, Tt += Dt.val_ >>> Dt.bit_pos_ & (1 << Ut) - 1), Dt.bit_pos_ += $t[Tt].bits, $t[Tt].value;
  }
  function Pt($t, Tt, Dt, Ut) {
    for (var Vt = 0, Qt = rt, qt = 0, Zt = 0, ar = 32768, Jt = [], rr = 0; rr < 32; rr++)
      Jt.push(new _e(0, 0));
    for (tt(Jt, 0, 5, $t, pt); Vt < Tt && ar > 0; ) {
      var Yt = 0, Kt;
      if (Ut.readMoreInput(), Ut.fillBitWindow(), Yt += Ut.val_ >>> Ut.bit_pos_ & 31, Ut.bit_pos_ += Jt[Yt].bits, Kt = Jt[Yt].value & 255, Kt < st)
        qt = 0, Dt[Vt++] = Kt, Kt !== 0 && (Qt = Kt, ar -= 32768 >> Kt);
      else {
        var nr = Kt - 14, tr, ir, sr = 0;
        if (Kt === st && (sr = Qt), Zt !== sr && (qt = 0, Zt = sr), tr = qt, qt > 0 && (qt -= 2, qt <<= nr), qt += Ut.readBits(nr) + 3, ir = qt - tr, Vt + ir > Tt)
          throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
        for (var cr = 0; cr < ir; cr++)
          Dt[Vt + cr] = Zt;
        Vt += ir, Zt !== 0 && (ar -= ir << 15 - Zt);
      }
    }
    if (ar !== 0)
      throw new Error("[ReadHuffmanCodeLengths] space = " + ar);
    for (; Vt < Tt; Vt++)
      Dt[Vt] = 0;
  }
  function wt($t, Tt, Dt, Ut) {
    var Vt = 0, Qt, qt = new Uint8Array($t);
    if (Ut.readMoreInput(), Qt = Ut.readBits(2), Qt === 1) {
      for (var Zt, ar = $t - 1, Jt = 0, rr = new Int32Array(4), Yt = Ut.readBits(2) + 1; ar; )
        ar >>= 1, ++Jt;
      for (Zt = 0; Zt < Yt; ++Zt)
        rr[Zt] = Ut.readBits(Jt) % $t, qt[rr[Zt]] = 2;
      switch (qt[rr[0]] = 1, Yt) {
        case 1:
          break;
        case 3:
          if (rr[0] === rr[1] || rr[0] === rr[2] || rr[1] === rr[2])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          break;
        case 2:
          if (rr[0] === rr[1])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          qt[rr[1]] = 1;
          break;
        case 4:
          if (rr[0] === rr[1] || rr[0] === rr[2] || rr[0] === rr[3] || rr[1] === rr[2] || rr[1] === rr[3] || rr[2] === rr[3])
            throw new Error("[ReadHuffmanCode] invalid symbols");
          Ut.readBits(1) ? (qt[rr[2]] = 3, qt[rr[3]] = 3) : qt[rr[0]] = 2;
          break;
      }
    } else {
      var Zt, Kt = new Uint8Array(pt), nr = 32, tr = 0, ir = [
        new _e(2, 0),
        new _e(2, 4),
        new _e(2, 3),
        new _e(3, 2),
        new _e(2, 0),
        new _e(2, 4),
        new _e(2, 3),
        new _e(4, 1),
        new _e(2, 0),
        new _e(2, 4),
        new _e(2, 3),
        new _e(3, 2),
        new _e(2, 0),
        new _e(2, 4),
        new _e(2, 3),
        new _e(4, 5)
      ];
      for (Zt = Qt; Zt < pt && nr > 0; ++Zt) {
        var sr = mt[Zt], cr = 0, or;
        Ut.fillBitWindow(), cr += Ut.val_ >>> Ut.bit_pos_ & 15, Ut.bit_pos_ += ir[cr].bits, or = ir[cr].value, Kt[sr] = or, or !== 0 && (nr -= 32 >> or, ++tr);
      }
      if (!(tr === 1 || nr === 0))
        throw new Error("[ReadHuffmanCode] invalid num_codes or space");
      Pt(Kt, $t, qt, Ut);
    }
    if (Vt = tt(Tt, Dt, ht, qt, $t), Vt === 0)
      throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return Vt;
  }
  function Ct($t, Tt, Dt) {
    var Ut, Vt;
    return Ut = Ot($t, Tt, Dt), Vt = at.kBlockLengthPrefixCode[Ut].nbits, at.kBlockLengthPrefixCode[Ut].offset + Dt.readBits(Vt);
  }
  function It($t, Tt, Dt) {
    var Ut;
    return $t < ct ? (Dt += vt[$t], Dt &= 3, Ut = Tt[Dt] + At[$t]) : Ut = $t - ct + 1, Ut;
  }
  function yt($t, Tt) {
    for (var Dt = $t[Tt], Ut = Tt; Ut; --Ut)
      $t[Ut] = $t[Ut - 1];
    $t[0] = Dt;
  }
  function Rt($t, Tt) {
    var Dt = new Uint8Array(256), Ut;
    for (Ut = 0; Ut < 256; ++Ut)
      Dt[Ut] = Ut;
    for (Ut = 0; Ut < Tt; ++Ut) {
      var Vt = $t[Ut];
      $t[Ut] = Dt[Vt], Vt && yt(Dt, Vt);
    }
  }
  function kt($t, Tt) {
    this.alphabet_size = $t, this.num_htrees = Tt, this.codes = new Array(Tt + Tt * xt[$t + 31 >>> 5]), this.htrees = new Uint32Array(Tt);
  }
  kt.prototype.decode = function($t) {
    var Tt, Dt, Ut = 0;
    for (Tt = 0; Tt < this.num_htrees; ++Tt)
      this.htrees[Tt] = Ut, Dt = wt(this.alphabet_size, this.codes, Ut, $t), Ut += Dt;
  };
  function jt($t, Tt) {
    var Dt = { num_htrees: null, context_map: null }, Ut, Vt = 0, Qt, qt;
    Tt.readMoreInput();
    var Zt = Dt.num_htrees = Et(Tt) + 1, ar = Dt.context_map = new Uint8Array($t);
    if (Zt <= 1)
      return Dt;
    for (Ut = Tt.readBits(1), Ut && (Vt = Tt.readBits(4) + 1), Qt = [], qt = 0; qt < gt; qt++)
      Qt[qt] = new _e(0, 0);
    for (wt(Zt + Vt, Qt, 0, Tt), qt = 0; qt < $t; ) {
      var Jt;
      if (Tt.readMoreInput(), Jt = Ot(Qt, 0, Tt), Jt === 0)
        ar[qt] = 0, ++qt;
      else if (Jt <= Vt)
        for (var rr = 1 + (1 << Jt) + Tt.readBits(Jt); --rr; ) {
          if (qt >= $t)
            throw new Error("[DecodeContextMap] i >= context_map_size");
          ar[qt] = 0, ++qt;
        }
      else
        ar[qt] = Jt - Vt, ++qt;
    }
    return Tt.readBits(1) && Rt(ar, $t), Dt;
  }
  function Ht($t, Tt, Dt, Ut, Vt, Qt, qt) {
    var Zt = Dt * 2, ar = Dt, Jt = Ot(Tt, Dt * gt, qt), rr;
    Jt === 0 ? rr = Vt[Zt + (Qt[ar] & 1)] : Jt === 1 ? rr = Vt[Zt + (Qt[ar] - 1 & 1)] + 1 : rr = Jt - 2, rr >= $t && (rr -= $t), Ut[Dt] = rr, Vt[Zt + (Qt[ar] & 1)] = rr, ++Qt[ar];
  }
  function Ft($t, Tt, Dt, Ut, Vt, Qt) {
    var qt = Vt + 1, Zt = Dt & Vt, ar = Qt.pos_ & $.IBUF_MASK, Jt;
    if (Tt < 8 || Qt.bit_pos_ + (Tt << 3) < Qt.bit_end_pos_) {
      for (; Tt-- > 0; )
        Qt.readMoreInput(), Ut[Zt++] = Qt.readBits(8), Zt === qt && ($t.write(Ut, qt), Zt = 0);
      return;
    }
    if (Qt.bit_end_pos_ < 32)
      throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
    for (; Qt.bit_pos_ < 32; )
      Ut[Zt] = Qt.val_ >>> Qt.bit_pos_, Qt.bit_pos_ += 8, ++Zt, --Tt;
    if (Jt = Qt.bit_end_pos_ - Qt.bit_pos_ >> 3, ar + Jt > $.IBUF_MASK) {
      for (var rr = $.IBUF_MASK + 1 - ar, Yt = 0; Yt < rr; Yt++)
        Ut[Zt + Yt] = Qt.buf_[ar + Yt];
      Jt -= rr, Zt += rr, Tt -= rr, ar = 0;
    }
    for (var Yt = 0; Yt < Jt; Yt++)
      Ut[Zt + Yt] = Qt.buf_[ar + Yt];
    if (Zt += Jt, Tt -= Jt, Zt >= qt) {
      $t.write(Ut, qt), Zt -= qt;
      for (var Yt = 0; Yt < Zt; Yt++)
        Ut[Yt] = Ut[qt + Yt];
    }
    for (; Zt + Tt >= qt; ) {
      if (Jt = qt - Zt, Qt.input_.read(Ut, Zt, Jt) < Jt)
        throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
      $t.write(Ut, qt), Tt -= Jt, Zt = 0;
    }
    if (Qt.input_.read(Ut, Zt, Tt) < Tt)
      throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
    Qt.reset();
  }
  function _t($t) {
    var Tt = $t.bit_pos_ + 7 & -8, Dt = $t.readBits(Tt - $t.bit_pos_);
    return Dt == 0;
  }
  function Nt($t) {
    var Tt = new a($t), Dt = new $(Tt);
    bt(Dt);
    var Ut = Bt(Dt);
    return Ut.meta_block_length;
  }
  decode$1.BrotliDecompressedSize = Nt;
  function Mt($t, Tt) {
    var Dt = new a($t);
    Tt == null && (Tt = Nt($t));
    var Ut = new Uint8Array(Tt), Vt = new s(Ut);
    return Lt(Dt, Vt), Vt.pos < Vt.buffer.length && (Vt.buffer = Vt.buffer.subarray(0, Vt.pos)), Vt.buffer;
  }
  decode$1.BrotliDecompressBuffer = Mt;
  function Lt($t, Tt) {
    var Dt, Ut = 0, Vt = 0, Qt = 0, qt, Zt = 0, ar, Jt, rr, Yt, Kt = [16, 15, 11, 4], nr = 0, tr = 0, ir = 0, sr = [new kt(0, 0), new kt(0, 0), new kt(0, 0)], cr, or, Xt, Gt = 128 + $.READ_SIZE;
    Xt = new $($t), Qt = bt(Xt), qt = (1 << Qt) - 16, ar = 1 << Qt, Jt = ar - 1, rr = new Uint8Array(ar + Gt + _.maxDictionaryWordLength), Yt = ar, cr = [], or = [];
    for (var Wt = 0; Wt < 3 * gt; Wt++)
      cr[Wt] = new _e(0, 0), or[Wt] = new _e(0, 0);
    for (; !Vt; ) {
      var er = 0, lr, ur = [1 << 28, 1 << 28, 1 << 28], pr = [0], yr = [1, 1, 1], Er = [0, 1, 0, 1, 0, 1], br = [0], gr, Ar, Sr, Br, Ir = null, hr = null, vr, xr = null, Pr, Rr = 0, Dr = null, Gr = 0, Or = 0, Hr = null, jr = 0, Tr = 0, fr = 0, Cr, $r;
      for (Dt = 0; Dt < 3; ++Dt)
        sr[Dt].codes = null, sr[Dt].htrees = null;
      Xt.readMoreInput();
      var wr = Bt(Xt);
      if (er = wr.meta_block_length, Ut + er > Tt.buffer.length) {
        var Mr = new Uint8Array(Ut + er);
        Mr.set(Tt.buffer), Tt.buffer = Mr;
      }
      if (Vt = wr.input_end, lr = wr.is_uncompressed, wr.is_metadata) {
        for (_t(Xt); er > 0; --er)
          Xt.readMoreInput(), Xt.readBits(8);
        continue;
      }
      if (er !== 0) {
        if (lr) {
          Xt.bit_pos_ = Xt.bit_pos_ + 7 & -8, Ft(
            Tt,
            er,
            Ut,
            rr,
            Jt,
            Xt
          ), Ut += er;
          continue;
        }
        for (Dt = 0; Dt < 3; ++Dt)
          yr[Dt] = Et(Xt) + 1, yr[Dt] >= 2 && (wt(yr[Dt] + 2, cr, Dt * gt, Xt), wt(it, or, Dt * gt, Xt), ur[Dt] = Ct(or, Dt * gt, Xt), br[Dt] = 1);
        for (Xt.readMoreInput(), gr = Xt.readBits(2), Ar = ct + (Xt.readBits(4) << gr), Sr = (1 << gr) - 1, Br = Ar + (48 << gr), hr = new Uint8Array(yr[0]), Dt = 0; Dt < yr[0]; ++Dt)
          Xt.readMoreInput(), hr[Dt] = Xt.readBits(2) << 1;
        var Fr = jt(yr[0] << ut, Xt);
        vr = Fr.num_htrees, Ir = Fr.context_map;
        var Qr = jt(yr[2] << ft, Xt);
        for (Pr = Qr.num_htrees, xr = Qr.context_map, sr[0] = new kt(lt, vr), sr[1] = new kt(et, yr[1]), sr[2] = new kt(Br, Pr), Dt = 0; Dt < 3; ++Dt)
          sr[Dt].decode(Xt);
        for (Dr = 0, Hr = 0, Cr = hr[pr[0]], Tr = nt.lookupOffsets[Cr], fr = nt.lookupOffsets[Cr + 1], $r = sr[1].htrees[0]; er > 0; ) {
          var Yr, kr, Nr, Lr, zr, Vr, an, Zr, un, Xr, Kr;
          for (Xt.readMoreInput(), ur[1] === 0 && (Ht(
            yr[1],
            cr,
            1,
            pr,
            Er,
            br,
            Xt
          ), ur[1] = Ct(or, gt, Xt), $r = sr[1].htrees[pr[1]]), --ur[1], Yr = Ot(sr[1].codes, $r, Xt), kr = Yr >> 6, kr >= 2 ? (kr -= 2, an = -1) : an = 0, Nr = at.kInsertRangeLut[kr] + (Yr >> 3 & 7), Lr = at.kCopyRangeLut[kr] + (Yr & 7), zr = at.kInsertLengthPrefixCode[Nr].offset + Xt.readBits(at.kInsertLengthPrefixCode[Nr].nbits), Vr = at.kCopyLengthPrefixCode[Lr].offset + Xt.readBits(at.kCopyLengthPrefixCode[Lr].nbits), tr = rr[Ut - 1 & Jt], ir = rr[Ut - 2 & Jt], Xr = 0; Xr < zr; ++Xr)
            Xt.readMoreInput(), ur[0] === 0 && (Ht(
              yr[0],
              cr,
              0,
              pr,
              Er,
              br,
              Xt
            ), ur[0] = Ct(or, 0, Xt), Rr = pr[0] << ut, Dr = Rr, Cr = hr[pr[0]], Tr = nt.lookupOffsets[Cr], fr = nt.lookupOffsets[Cr + 1]), un = nt.lookup[Tr + tr] | nt.lookup[fr + ir], Gr = Ir[Dr + un], --ur[0], ir = tr, tr = Ot(sr[0].codes, sr[0].htrees[Gr], Xt), rr[Ut & Jt] = tr, (Ut & Jt) === Jt && Tt.write(rr, ar), ++Ut;
          if (er -= zr, er <= 0)
            break;
          if (an < 0) {
            var un;
            if (Xt.readMoreInput(), ur[2] === 0 && (Ht(
              yr[2],
              cr,
              2,
              pr,
              Er,
              br,
              Xt
            ), ur[2] = Ct(or, 2 * gt, Xt), Or = pr[2] << ft, Hr = Or), --ur[2], un = (Vr > 4 ? 3 : Vr - 2) & 255, jr = xr[Hr + un], an = Ot(sr[2].codes, sr[2].htrees[jr], Xt), an >= Ar) {
              var rn, nn, sn;
              an -= Ar, nn = an & Sr, an >>= gr, rn = (an >> 1) + 1, sn = (2 + (an & 1) << rn) - 4, an = Ar + (sn + Xt.readBits(rn) << gr) + nn;
            }
          }
          if (Zr = It(an, Kt, nr), Zr < 0)
            throw new Error("[BrotliDecompress] invalid distance");
          if (Ut < qt && Zt !== qt ? Zt = Ut : Zt = qt, Kr = Ut & Jt, Zr > Zt)
            if (Vr >= _.minDictionaryWordLength && Vr <= _.maxDictionaryWordLength) {
              var sn = _.offsetsByLength[Vr], gn = Zr - Zt - 1, en = _.sizeBitsByLength[Vr], Wr = (1 << en) - 1, dn = gn & Wr, hn = gn >> en;
              if (sn += dn * Vr, hn < ot.kNumTransforms) {
                var En = ot.transformDictionaryWord(rr, Kr, sn, Vr, hn);
                if (Kr += En, Ut += En, er -= En, Kr >= Yt) {
                  Tt.write(rr, ar);
                  for (var bn = 0; bn < Kr - Yt; bn++)
                    rr[bn] = rr[Yt + bn];
                }
              } else
                throw new Error("Invalid backward reference. pos: " + Ut + " distance: " + Zr + " len: " + Vr + " bytes left: " + er);
            } else
              throw new Error("Invalid backward reference. pos: " + Ut + " distance: " + Zr + " len: " + Vr + " bytes left: " + er);
          else {
            if (an > 0 && (Kt[nr & 3] = Zr, ++nr), Vr > er)
              throw new Error("Invalid backward reference. pos: " + Ut + " distance: " + Zr + " len: " + Vr + " bytes left: " + er);
            for (Xr = 0; Xr < Vr; ++Xr)
              rr[Ut & Jt] = rr[Ut - Zr & Jt], (Ut & Jt) === Jt && Tt.write(rr, ar), ++Ut, --er;
          }
          tr = rr[Ut - 1 & Jt], ir = rr[Ut - 2 & Jt];
        }
        Ut &= 1073741823;
      }
    }
    Tt.write(rr, Ut & Jt);
  }
  return decode$1.BrotliDecompress = Lt, _.init(), decode$1;
}
var decompress = requireDecode().BrotliDecompressBuffer;
const $6uUbQ$brotlidecompressjs = /* @__PURE__ */ getDefaultExportFromCjs(decompress);
function $parcel$export(a, s, $, _) {
  Object.defineProperty(a, s, { get: $, set: _, enumerable: !0, configurable: !0 });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $d636bc798e7178db$exports = {};
$parcel$export($d636bc798e7178db$exports, "logErrors", () => $d636bc798e7178db$export$bd5c5d8b8dcafd78);
$parcel$export($d636bc798e7178db$exports, "registerFormat", () => $d636bc798e7178db$export$36b2f24e97d43be);
$parcel$export($d636bc798e7178db$exports, "create", () => $d636bc798e7178db$export$185802fd694ee1f5);
$parcel$export($d636bc798e7178db$exports, "defaultLanguage", () => $d636bc798e7178db$export$42940898df819940);
$parcel$export($d636bc798e7178db$exports, "setDefaultLanguage", () => $d636bc798e7178db$export$5157e7780d44cc36);
let $d636bc798e7178db$export$bd5c5d8b8dcafd78 = !1, $d636bc798e7178db$var$formats = [];
function $d636bc798e7178db$export$36b2f24e97d43be(a) {
  $d636bc798e7178db$var$formats.push(a);
}
function $d636bc798e7178db$export$185802fd694ee1f5(a, s) {
  for (let $ = 0; $ < $d636bc798e7178db$var$formats.length; $++) {
    let _ = $d636bc798e7178db$var$formats[$];
    if (_.probe(a)) {
      let _e = new _(new DecodeStream(a));
      return s ? _e.getFont(s) : _e;
    }
  }
  throw new Error("Unknown font format");
}
let $d636bc798e7178db$export$42940898df819940 = "en";
function $d636bc798e7178db$export$5157e7780d44cc36(a = "en") {
  $d636bc798e7178db$export$42940898df819940 = a;
}
function $e71565f2ce09cb6b$export$69a3209f1a06c04d(a, s, $) {
  if ($.get) {
    let _ = $.get;
    $.get = function() {
      let _e = _.call(this);
      return Object.defineProperty(this, s, {
        value: _e
      }), _e;
    };
  } else if (typeof $.value == "function") {
    let _ = $.value;
    return {
      get() {
        let _e = /* @__PURE__ */ new Map();
        function tt(...nt) {
          let at = nt.length > 0 ? nt[0] : "value";
          if (_e.has(at))
            return _e.get(at);
          let ot = _.apply(this, nt);
          return _e.set(at, ot), ot;
        }
        return Object.defineProperty(this, s, {
          value: tt
        }), tt;
      }
    };
  }
}
let $26a62205ad06574e$var$SubHeader = new Struct({
  firstCode: uint16,
  entryCount: uint16,
  idDelta: int16,
  idRangeOffset: uint16
}), $26a62205ad06574e$var$CmapGroup = new Struct({
  startCharCode: uint32,
  endCharCode: uint32,
  glyphID: uint32
}), $26a62205ad06574e$var$UnicodeValueRange = new Struct({
  startUnicodeValue: uint24,
  additionalCount: uint8
}), $26a62205ad06574e$var$UVSMapping = new Struct({
  unicodeValue: uint24,
  glyphID: uint16
}), $26a62205ad06574e$var$DefaultUVS = new ArrayT($26a62205ad06574e$var$UnicodeValueRange, uint32), $26a62205ad06574e$var$NonDefaultUVS = new ArrayT($26a62205ad06574e$var$UVSMapping, uint32), $26a62205ad06574e$var$VarSelectorRecord = new Struct({
  varSelector: uint24,
  defaultUVS: new Pointer(uint32, $26a62205ad06574e$var$DefaultUVS, {
    type: "parent"
  }),
  nonDefaultUVS: new Pointer(uint32, $26a62205ad06574e$var$NonDefaultUVS, {
    type: "parent"
  })
}), $26a62205ad06574e$var$CmapSubtable = new VersionedStruct(uint16, {
  0: {
    length: uint16,
    language: uint16,
    codeMap: new LazyArray(uint8, 256)
  },
  2: {
    length: uint16,
    language: uint16,
    subHeaderKeys: new ArrayT(uint16, 256),
    subHeaderCount: (a) => Math.max.apply(Math, a.subHeaderKeys),
    subHeaders: new LazyArray($26a62205ad06574e$var$SubHeader, "subHeaderCount"),
    glyphIndexArray: new LazyArray(uint16, "subHeaderCount")
  },
  4: {
    length: uint16,
    language: uint16,
    segCountX2: uint16,
    segCount: (a) => a.segCountX2 >> 1,
    searchRange: uint16,
    entrySelector: uint16,
    rangeShift: uint16,
    endCode: new LazyArray(uint16, "segCount"),
    reservedPad: new Reserved(uint16),
    startCode: new LazyArray(uint16, "segCount"),
    idDelta: new LazyArray(int16, "segCount"),
    idRangeOffset: new LazyArray(uint16, "segCount"),
    glyphIndexArray: new LazyArray(uint16, (a) => (a.length - a._currentOffset) / 2)
  },
  6: {
    length: uint16,
    language: uint16,
    firstCode: uint16,
    entryCount: uint16,
    glyphIndices: new LazyArray(uint16, "entryCount")
  },
  8: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint16,
    is32: new LazyArray(uint8, 8192),
    nGroups: uint32,
    groups: new LazyArray($26a62205ad06574e$var$CmapGroup, "nGroups")
  },
  10: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint32,
    firstCode: uint32,
    entryCount: uint32,
    glyphIndices: new LazyArray(uint16, "numChars")
  },
  12: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint32,
    nGroups: uint32,
    groups: new LazyArray($26a62205ad06574e$var$CmapGroup, "nGroups")
  },
  13: {
    reserved: new Reserved(uint16),
    length: uint32,
    language: uint32,
    nGroups: uint32,
    groups: new LazyArray($26a62205ad06574e$var$CmapGroup, "nGroups")
  },
  14: {
    length: uint32,
    numRecords: uint32,
    varSelectors: new LazyArray($26a62205ad06574e$var$VarSelectorRecord, "numRecords")
  }
}), $26a62205ad06574e$var$CmapEntry = new Struct({
  platformID: uint16,
  encodingID: uint16,
  table: new Pointer(uint32, $26a62205ad06574e$var$CmapSubtable, {
    type: "parent",
    lazy: !0
  })
});
var $26a62205ad06574e$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numSubtables: uint16,
  tables: new ArrayT($26a62205ad06574e$var$CmapEntry, "numSubtables")
}), $f2612a29f92ac062$export$2e2bcd8739ae039 = new Struct({
  version: int32,
  revision: int32,
  checkSumAdjustment: uint32,
  magicNumber: uint32,
  flags: uint16,
  unitsPerEm: uint16,
  created: new ArrayT(int32, 2),
  modified: new ArrayT(int32, 2),
  xMin: int16,
  yMin: int16,
  xMax: int16,
  yMax: int16,
  macStyle: new Bitfield(uint16, [
    "bold",
    "italic",
    "underline",
    "outline",
    "shadow",
    "condensed",
    "extended"
  ]),
  lowestRecPPEM: uint16,
  fontDirectionHint: int16,
  indexToLocFormat: int16,
  glyphDataFormat: int16
  // 0 for current format
}), $2c179dd593583073$export$2e2bcd8739ae039 = new Struct({
  version: int32,
  ascent: int16,
  descent: int16,
  lineGap: int16,
  advanceWidthMax: uint16,
  minLeftSideBearing: int16,
  minRightSideBearing: int16,
  xMaxExtent: int16,
  caretSlopeRise: int16,
  caretSlopeRun: int16,
  caretOffset: int16,
  reserved: new Reserved(int16, 4),
  metricDataFormat: int16,
  numberOfMetrics: uint16
  // Number of advance widths in 'hmtx' table
});
let $bdc9060542264b85$var$HmtxEntry = new Struct({
  advance: uint16,
  bearing: int16
});
var $bdc9060542264b85$export$2e2bcd8739ae039 = new Struct({
  metrics: new LazyArray($bdc9060542264b85$var$HmtxEntry, (a) => a.parent.hhea.numberOfMetrics),
  bearings: new LazyArray(int16, (a) => a.parent.maxp.numGlyphs - a.parent.hhea.numberOfMetrics)
}), $dbf51cb3d3fe409d$export$2e2bcd8739ae039 = new Struct({
  version: int32,
  numGlyphs: uint16,
  maxPoints: uint16,
  maxContours: uint16,
  maxComponentPoints: uint16,
  maxComponentContours: uint16,
  maxZones: uint16,
  maxTwilightPoints: uint16,
  maxStorage: uint16,
  maxFunctionDefs: uint16,
  maxInstructionDefs: uint16,
  maxStackElements: uint16,
  maxSizeOfInstructions: uint16,
  maxComponentElements: uint16,
  maxComponentDepth: uint16
  // Maximum levels of recursion; 1 for simple components
});
function $e449ad78d50845fe$export$badc544e0651b6b1(a, s, $ = 0) {
  return a === 1 && $e449ad78d50845fe$export$479e671907f486d1[$] ? $e449ad78d50845fe$export$479e671907f486d1[$] : $e449ad78d50845fe$export$6fef87b7618bdf0b[a][s];
}
const $e449ad78d50845fe$var$SINGLE_BYTE_ENCODINGS = /* @__PURE__ */ new Set([
  "x-mac-roman",
  "x-mac-cyrillic",
  "iso-8859-6",
  "iso-8859-8"
]), $e449ad78d50845fe$var$MAC_ENCODINGS = {
  "x-mac-croatian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ",
  "x-mac-gaelic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæøṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ",
  "x-mac-greek": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ­",
  "x-mac-icelandic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
  "x-mac-inuit": "ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł",
  "x-mac-ce": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",
  "x-mac-romanian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
  "x-mac-turkish": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ"
}, $e449ad78d50845fe$var$encodingCache = /* @__PURE__ */ new Map();
function $e449ad78d50845fe$export$1dceb3c14ed68bee(a) {
  let s = $e449ad78d50845fe$var$encodingCache.get(a);
  if (s)
    return s;
  let $ = $e449ad78d50845fe$var$MAC_ENCODINGS[a];
  if ($) {
    let _ = /* @__PURE__ */ new Map();
    for (let _e = 0; _e < $.length; _e++)
      _.set($.charCodeAt(_e), 128 + _e);
    return $e449ad78d50845fe$var$encodingCache.set(a, _), _;
  }
  if ($e449ad78d50845fe$var$SINGLE_BYTE_ENCODINGS.has(a)) {
    let _ = new TextDecoder(a), _e = new Uint8Array(128);
    for (let at = 0; at < 128; at++)
      _e[at] = 128 + at;
    let tt = /* @__PURE__ */ new Map(), nt = _.decode(_e);
    for (let at = 0; at < 128; at++)
      tt.set(nt.charCodeAt(at), 128 + at);
    return $e449ad78d50845fe$var$encodingCache.set(a, tt), tt;
  }
}
const $e449ad78d50845fe$export$6fef87b7618bdf0b = [
  // unicode
  [
    "utf16be",
    "utf16be",
    "utf16be",
    "utf16be",
    "utf16be",
    "utf16be"
  ],
  // macintosh
  // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
  // 0	Roman                 17	Malayalam
  // 1	Japanese	            18	Sinhalese
  // 2	Traditional Chinese	  19	Burmese
  // 3	Korean	              20	Khmer
  // 4	Arabic	              21	Thai
  // 5	Hebrew	              22	Laotian
  // 6	Greek	                23	Georgian
  // 7	Russian	              24	Armenian
  // 8	RSymbol	              25	Simplified Chinese
  // 9	Devanagari	          26	Tibetan
  // 10	Gurmukhi	            27	Mongolian
  // 11	Gujarati	            28	Geez
  // 12	Oriya	                29	Slavic
  // 13	Bengali	              30	Vietnamese
  // 14	Tamil	                31	Sindhi
  // 15	Telugu	              32	(Uninterpreted)
  // 16	Kannada
  [
    "x-mac-roman",
    "shift-jis",
    "big5",
    "euc-kr",
    "iso-8859-6",
    "iso-8859-8",
    "x-mac-greek",
    "x-mac-cyrillic",
    "x-mac-symbol",
    "x-mac-devanagari",
    "x-mac-gurmukhi",
    "x-mac-gujarati",
    "Oriya",
    "Bengali",
    "Tamil",
    "Telugu",
    "Kannada",
    "Malayalam",
    "Sinhalese",
    "Burmese",
    "Khmer",
    "iso-8859-11",
    "Laotian",
    "Georgian",
    "Armenian",
    "hz-gb-2312",
    "Tibetan",
    "Mongolian",
    "Geez",
    "x-mac-ce",
    "Vietnamese",
    "Sindhi"
  ],
  // ISO (deprecated)
  [
    "ascii"
  ],
  // windows
  // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
  [
    "symbol",
    "utf16be",
    "shift-jis",
    "gb18030",
    "big5",
    "x-cp20949",
    "johab",
    null,
    null,
    null,
    "utf16be"
  ]
], $e449ad78d50845fe$export$479e671907f486d1 = {
  15: "x-mac-icelandic",
  17: "x-mac-turkish",
  18: "x-mac-croatian",
  24: "x-mac-ce",
  25: "x-mac-ce",
  26: "x-mac-ce",
  27: "x-mac-ce",
  28: "x-mac-ce",
  30: "x-mac-icelandic",
  37: "x-mac-romanian",
  38: "x-mac-ce",
  39: "x-mac-ce",
  40: "x-mac-ce",
  143: "x-mac-inuit",
  146: "x-mac-gaelic"
}, $e449ad78d50845fe$export$2092376fd002e13 = [
  // unicode
  [],
  {
    0: "en",
    30: "fo",
    60: "ks",
    90: "rw",
    1: "fr",
    31: "fa",
    61: "ku",
    91: "rn",
    2: "de",
    32: "ru",
    62: "sd",
    92: "ny",
    3: "it",
    33: "zh",
    63: "bo",
    93: "mg",
    4: "nl",
    34: "nl-BE",
    64: "ne",
    94: "eo",
    5: "sv",
    35: "ga",
    65: "sa",
    128: "cy",
    6: "es",
    36: "sq",
    66: "mr",
    129: "eu",
    7: "da",
    37: "ro",
    67: "bn",
    130: "ca",
    8: "pt",
    38: "cz",
    68: "as",
    131: "la",
    9: "no",
    39: "sk",
    69: "gu",
    132: "qu",
    10: "he",
    40: "si",
    70: "pa",
    133: "gn",
    11: "ja",
    41: "yi",
    71: "or",
    134: "ay",
    12: "ar",
    42: "sr",
    72: "ml",
    135: "tt",
    13: "fi",
    43: "mk",
    73: "kn",
    136: "ug",
    14: "el",
    44: "bg",
    74: "ta",
    137: "dz",
    15: "is",
    45: "uk",
    75: "te",
    138: "jv",
    16: "mt",
    46: "be",
    76: "si",
    139: "su",
    17: "tr",
    47: "uz",
    77: "my",
    140: "gl",
    18: "hr",
    48: "kk",
    78: "km",
    141: "af",
    19: "zh-Hant",
    49: "az-Cyrl",
    79: "lo",
    142: "br",
    20: "ur",
    50: "az-Arab",
    80: "vi",
    143: "iu",
    21: "hi",
    51: "hy",
    81: "id",
    144: "gd",
    22: "th",
    52: "ka",
    82: "tl",
    145: "gv",
    23: "ko",
    53: "mo",
    83: "ms",
    146: "ga",
    24: "lt",
    54: "ky",
    84: "ms-Arab",
    147: "to",
    25: "pl",
    55: "tg",
    85: "am",
    148: "el-polyton",
    26: "hu",
    56: "tk",
    86: "ti",
    149: "kl",
    27: "es",
    57: "mn-CN",
    87: "om",
    150: "az",
    28: "lv",
    58: "mn",
    88: "so",
    151: "nn",
    29: "se",
    59: "ps",
    89: "sw"
  },
  // ISO (deprecated)
  [],
  {
    1078: "af",
    16393: "en-IN",
    1159: "rw",
    1074: "tn",
    1052: "sq",
    6153: "en-IE",
    1089: "sw",
    1115: "si",
    1156: "gsw",
    8201: "en-JM",
    1111: "kok",
    1051: "sk",
    1118: "am",
    17417: "en-MY",
    1042: "ko",
    1060: "sl",
    5121: "ar-DZ",
    5129: "en-NZ",
    1088: "ky",
    11274: "es-AR",
    15361: "ar-BH",
    13321: "en-PH",
    1108: "lo",
    16394: "es-BO",
    3073: "ar",
    18441: "en-SG",
    1062: "lv",
    13322: "es-CL",
    2049: "ar-IQ",
    7177: "en-ZA",
    1063: "lt",
    9226: "es-CO",
    11265: "ar-JO",
    11273: "en-TT",
    2094: "dsb",
    5130: "es-CR",
    13313: "ar-KW",
    2057: "en-GB",
    1134: "lb",
    7178: "es-DO",
    12289: "ar-LB",
    1033: "en",
    1071: "mk",
    12298: "es-EC",
    4097: "ar-LY",
    12297: "en-ZW",
    2110: "ms-BN",
    17418: "es-SV",
    6145: "ary",
    1061: "et",
    1086: "ms",
    4106: "es-GT",
    8193: "ar-OM",
    1080: "fo",
    1100: "ml",
    18442: "es-HN",
    16385: "ar-QA",
    1124: "fil",
    1082: "mt",
    2058: "es-MX",
    1025: "ar-SA",
    1035: "fi",
    1153: "mi",
    19466: "es-NI",
    10241: "ar-SY",
    2060: "fr-BE",
    1146: "arn",
    6154: "es-PA",
    7169: "aeb",
    3084: "fr-CA",
    1102: "mr",
    15370: "es-PY",
    14337: "ar-AE",
    1036: "fr",
    1148: "moh",
    10250: "es-PE",
    9217: "ar-YE",
    5132: "fr-LU",
    1104: "mn",
    20490: "es-PR",
    1067: "hy",
    6156: "fr-MC",
    2128: "mn-CN",
    3082: "es",
    1101: "as",
    4108: "fr-CH",
    1121: "ne",
    1034: "es",
    2092: "az-Cyrl",
    1122: "fy",
    1044: "nb",
    21514: "es-US",
    1068: "az",
    1110: "gl",
    2068: "nn",
    14346: "es-UY",
    1133: "ba",
    1079: "ka",
    1154: "oc",
    8202: "es-VE",
    1069: "eu",
    3079: "de-AT",
    1096: "or",
    2077: "sv-FI",
    1059: "be",
    1031: "de",
    1123: "ps",
    1053: "sv",
    2117: "bn",
    5127: "de-LI",
    1045: "pl",
    1114: "syr",
    1093: "bn-IN",
    4103: "de-LU",
    1046: "pt",
    1064: "tg",
    8218: "bs-Cyrl",
    2055: "de-CH",
    2070: "pt-PT",
    2143: "tzm",
    5146: "bs",
    1032: "el",
    1094: "pa",
    1097: "ta",
    1150: "br",
    1135: "kl",
    1131: "qu-BO",
    1092: "tt",
    1026: "bg",
    1095: "gu",
    2155: "qu-EC",
    1098: "te",
    1027: "ca",
    1128: "ha",
    3179: "qu",
    1054: "th",
    3076: "zh-HK",
    1037: "he",
    1048: "ro",
    1105: "bo",
    5124: "zh-MO",
    1081: "hi",
    1047: "rm",
    1055: "tr",
    2052: "zh",
    1038: "hu",
    1049: "ru",
    1090: "tk",
    4100: "zh-SG",
    1039: "is",
    9275: "smn",
    1152: "ug",
    1028: "zh-TW",
    1136: "ig",
    4155: "smj-NO",
    1058: "uk",
    1155: "co",
    1057: "id",
    5179: "smj",
    1070: "hsb",
    1050: "hr",
    1117: "iu",
    3131: "se-FI",
    1056: "ur",
    4122: "hr-BA",
    2141: "iu-Latn",
    1083: "se",
    2115: "uz-Cyrl",
    1029: "cs",
    2108: "ga",
    2107: "se-SE",
    1091: "uz",
    1030: "da",
    1076: "xh",
    8251: "sms",
    1066: "vi",
    1164: "prs",
    1077: "zu",
    6203: "sma-NO",
    1106: "cy",
    1125: "dv",
    1040: "it",
    7227: "sms",
    1160: "wo",
    2067: "nl-BE",
    2064: "it-CH",
    1103: "sa",
    1157: "sah",
    1043: "nl",
    1041: "ja",
    7194: "sr-Cyrl-BA",
    1144: "ii",
    3081: "en-AU",
    1099: "kn",
    3098: "sr",
    1130: "yo",
    10249: "en-BZ",
    1087: "kk",
    6170: "sr-Latn-BA",
    4105: "en-CA",
    1107: "km",
    2074: "sr-Latn",
    9225: "en-029",
    1158: "quc",
    1132: "nso"
  }
];
let $2bcf221753ec8e32$var$NameRecord = new Struct({
  platformID: uint16,
  encodingID: uint16,
  languageID: uint16,
  nameID: uint16,
  length: uint16,
  string: new Pointer(uint16, new StringT("length", (a) => $e449ad78d50845fe$export$badc544e0651b6b1(a.platformID, a.encodingID, a.languageID)), {
    type: "parent",
    relativeTo: (a) => a.parent.stringOffset,
    allowNull: !1
  })
}), $2bcf221753ec8e32$var$LangTagRecord = new Struct({
  length: uint16,
  tag: new Pointer(uint16, new StringT("length", "utf16be"), {
    type: "parent",
    relativeTo: (a) => a.stringOffset
  })
});
var $2bcf221753ec8e32$var$NameTable = new VersionedStruct(uint16, {
  0: {
    count: uint16,
    stringOffset: uint16,
    records: new ArrayT($2bcf221753ec8e32$var$NameRecord, "count")
  },
  1: {
    count: uint16,
    stringOffset: uint16,
    records: new ArrayT($2bcf221753ec8e32$var$NameRecord, "count"),
    langTagCount: uint16,
    langTags: new ArrayT($2bcf221753ec8e32$var$LangTagRecord, "langTagCount")
  }
}), $2bcf221753ec8e32$export$2e2bcd8739ae039 = $2bcf221753ec8e32$var$NameTable;
const $2bcf221753ec8e32$var$NAMES = [
  "copyright",
  "fontFamily",
  "fontSubfamily",
  "uniqueSubfamily",
  "fullName",
  "version",
  "postscriptName",
  "trademark",
  "manufacturer",
  "designer",
  "description",
  "vendorURL",
  "designerURL",
  "license",
  "licenseURL",
  null,
  "preferredFamily",
  "preferredSubfamily",
  "compatibleFull",
  "sampleText",
  "postscriptCIDFontName",
  "wwsFamilyName",
  "wwsSubfamilyName"
];
$2bcf221753ec8e32$var$NameTable.process = function(a) {
  var s = {};
  for (let $ of this.records) {
    let _ = $e449ad78d50845fe$export$2092376fd002e13[$.platformID][$.languageID];
    _ == null && this.langTags != null && $.languageID >= 32768 && (_ = this.langTags[$.languageID - 32768].tag), _ == null && (_ = $.platformID + "-" + $.languageID);
    let _e = $.nameID >= 256 ? "fontFeatures" : $2bcf221753ec8e32$var$NAMES[$.nameID] || $.nameID;
    s[_e] == null && (s[_e] = {});
    let tt = s[_e];
    $.nameID >= 256 && (tt = tt[$.nameID] || (tt[$.nameID] = {})), (typeof $.string == "string" || typeof tt[_] != "string") && (tt[_] = $.string);
  }
  this.records = s;
};
$2bcf221753ec8e32$var$NameTable.preEncode = function() {
  if (Array.isArray(this.records))
    return;
  this.version = 0;
  let a = [];
  for (let s in this.records) {
    let $ = this.records[s];
    s !== "fontFeatures" && (a.push({
      platformID: 3,
      encodingID: 1,
      languageID: 1033,
      nameID: $2bcf221753ec8e32$var$NAMES.indexOf(s),
      length: $.en.length * 2,
      string: $.en
    }), s === "postscriptName" && a.push({
      platformID: 1,
      encodingID: 0,
      languageID: 0,
      nameID: $2bcf221753ec8e32$var$NAMES.indexOf(s),
      length: $.en.length,
      string: $.en
    }));
  }
  this.records = a, this.count = a.length, this.stringOffset = $2bcf221753ec8e32$var$NameTable.size(this, null, !1);
};
var $84b272aa31b70606$var$OS2 = new VersionedStruct(uint16, {
  header: {
    xAvgCharWidth: int16,
    usWeightClass: uint16,
    usWidthClass: uint16,
    fsType: new Bitfield(uint16, [
      null,
      "noEmbedding",
      "viewOnly",
      "editable",
      null,
      null,
      null,
      null,
      "noSubsetting",
      "bitmapOnly"
    ]),
    ySubscriptXSize: int16,
    ySubscriptYSize: int16,
    ySubscriptXOffset: int16,
    ySubscriptYOffset: int16,
    ySuperscriptXSize: int16,
    ySuperscriptYSize: int16,
    ySuperscriptXOffset: int16,
    ySuperscriptYOffset: int16,
    yStrikeoutSize: int16,
    yStrikeoutPosition: int16,
    sFamilyClass: int16,
    panose: new ArrayT(uint8, 10),
    ulCharRange: new ArrayT(uint32, 4),
    vendorID: new StringT(4),
    fsSelection: new Bitfield(uint16, [
      "italic",
      "underscore",
      "negative",
      "outlined",
      "strikeout",
      "bold",
      "regular",
      "useTypoMetrics",
      "wws",
      "oblique"
    ]),
    usFirstCharIndex: uint16,
    usLastCharIndex: uint16
    // The maximum Unicode index in this font
  },
  // The Apple version of this table ends here, but the Microsoft one continues on...
  0: {},
  1: {
    typoAscender: int16,
    typoDescender: int16,
    typoLineGap: int16,
    winAscent: uint16,
    winDescent: uint16,
    codePageRange: new ArrayT(uint32, 2)
  },
  2: {
    // these should be common with version 1 somehow
    typoAscender: int16,
    typoDescender: int16,
    typoLineGap: int16,
    winAscent: uint16,
    winDescent: uint16,
    codePageRange: new ArrayT(uint32, 2),
    xHeight: int16,
    capHeight: int16,
    defaultChar: uint16,
    breakChar: uint16,
    maxContent: uint16
  },
  5: {
    typoAscender: int16,
    typoDescender: int16,
    typoLineGap: int16,
    winAscent: uint16,
    winDescent: uint16,
    codePageRange: new ArrayT(uint32, 2),
    xHeight: int16,
    capHeight: int16,
    defaultChar: uint16,
    breakChar: uint16,
    maxContent: uint16,
    usLowerOpticalPointSize: uint16,
    usUpperOpticalPointSize: uint16
  }
});
let $84b272aa31b70606$var$versions = $84b272aa31b70606$var$OS2.versions;
$84b272aa31b70606$var$versions[3] = $84b272aa31b70606$var$versions[4] = $84b272aa31b70606$var$versions[2];
var $84b272aa31b70606$export$2e2bcd8739ae039 = $84b272aa31b70606$var$OS2, $32d9e2eb9565d93c$export$2e2bcd8739ae039 = new VersionedStruct(fixed32, {
  header: {
    italicAngle: fixed32,
    underlinePosition: int16,
    underlineThickness: int16,
    isFixedPitch: uint32,
    minMemType42: uint32,
    maxMemType42: uint32,
    minMemType1: uint32,
    maxMemType1: uint32
    // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
  },
  1: {},
  2: {
    numberOfGlyphs: uint16,
    glyphNameIndex: new ArrayT(uint16, "numberOfGlyphs"),
    names: new ArrayT(new StringT(uint8))
  },
  2.5: {
    numberOfGlyphs: uint16,
    offsets: new ArrayT(uint8, "numberOfGlyphs")
  },
  3: {},
  4: {
    map: new ArrayT(uint32, (a) => a.parent.maxp.numGlyphs)
  }
}), $5202bd9d9ad8eaac$export$2e2bcd8739ae039 = new Struct({
  controlValues: new ArrayT(int16)
}), $5c0f37ca5ffb1850$export$2e2bcd8739ae039 = new Struct({
  instructions: new ArrayT(uint8)
});
let $2b2b260902b1c57e$var$loca = new VersionedStruct("head.indexToLocFormat", {
  0: {
    offsets: new ArrayT(uint16)
  },
  1: {
    offsets: new ArrayT(uint32)
  }
});
$2b2b260902b1c57e$var$loca.process = function() {
  if (this.version === 0 && !this._processed) {
    for (let a = 0; a < this.offsets.length; a++)
      this.offsets[a] <<= 1;
    this._processed = !0;
  }
};
$2b2b260902b1c57e$var$loca.preEncode = function() {
  if (this.version === 0 && this._processed !== !1) {
    for (let a = 0; a < this.offsets.length; a++)
      this.offsets[a] >>>= 1;
    this._processed = !1;
  }
};
var $2b2b260902b1c57e$export$2e2bcd8739ae039 = $2b2b260902b1c57e$var$loca, $7afb878c7bea4f66$export$2e2bcd8739ae039 = new Struct({
  controlValueProgram: new ArrayT(uint8)
}), $6c92b6371bce8bd9$export$2e2bcd8739ae039 = new ArrayT(new BufferT());
class $43e9821ef3717eec$export$2e2bcd8739ae039 {
  getCFFVersion(s) {
    for (; s && !s.hdrSize; )
      s = s.parent;
    return s ? s.version : -1;
  }
  decode(s, $) {
    let _e = this.getCFFVersion($) >= 2 ? s.readUInt32BE() : s.readUInt16BE();
    if (_e === 0)
      return [];
    let tt = s.readUInt8(), nt;
    if (tt === 1)
      nt = uint8;
    else if (tt === 2)
      nt = uint16;
    else if (tt === 3)
      nt = uint24;
    else if (tt === 4)
      nt = uint32;
    else
      throw new Error(`Bad offset size in CFFIndex: ${tt} ${s.pos}`);
    let at = [], ot = s.pos + (_e + 1) * tt - 1, rt = nt.decode(s);
    for (let st = 0; st < _e; st++) {
      let lt = nt.decode(s);
      if (this.type != null) {
        let et = s.pos;
        s.pos = ot + rt, $.length = lt - rt, at.push(this.type.decode(s, $)), s.pos = et;
      } else
        at.push({
          offset: ot + rt,
          length: lt - rt
        });
      rt = lt;
    }
    return s.pos = ot + rt, at;
  }
  size(s, $) {
    let _ = 2;
    if (s.length === 0)
      return _;
    let _e = this.type || new BufferT(), tt = 1;
    for (let at = 0; at < s.length; at++) {
      let ot = s[at];
      tt += _e.size(ot, $);
    }
    let nt;
    if (tt <= 255)
      nt = uint8;
    else if (tt <= 65535)
      nt = uint16;
    else if (tt <= 16777215)
      nt = uint24;
    else if (tt <= 4294967295)
      nt = uint32;
    else
      throw new Error("Bad offset in CFFIndex");
    return _ += 1 + nt.size() * (s.length + 1), _ += tt - 1, _;
  }
  encode(s, $, _) {
    if (s.writeUInt16BE($.length), $.length === 0)
      return;
    let _e = this.type || new BufferT(), tt = [], nt = 1;
    for (let ot of $) {
      let rt = _e.size(ot, _);
      tt.push(rt), nt += rt;
    }
    let at;
    if (nt <= 255)
      at = uint8;
    else if (nt <= 65535)
      at = uint16;
    else if (nt <= 16777215)
      at = uint24;
    else if (nt <= 4294967295)
      at = uint32;
    else
      throw new Error("Bad offset in CFFIndex");
    s.writeUInt8(at.size()), nt = 1, at.encode(s, nt);
    for (let ot of tt)
      nt += ot, at.encode(s, nt);
    for (let ot of $)
      _e.encode(s, ot, _);
  }
  constructor(s) {
    this.type = s;
  }
}
const $c2d28e92708f99da$var$FLOAT_EOF = 15, $c2d28e92708f99da$var$FLOAT_LOOKUP = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ".",
  "E",
  "E-",
  null,
  "-"
], $c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP = {
  ".": 10,
  E: 11,
  "E-": 12,
  "-": 14
};
class $c2d28e92708f99da$export$2e2bcd8739ae039 {
  static decode(s, $) {
    if (32 <= $ && $ <= 246)
      return $ - 139;
    if (247 <= $ && $ <= 250)
      return ($ - 247) * 256 + s.readUInt8() + 108;
    if (251 <= $ && $ <= 254)
      return -($ - 251) * 256 - s.readUInt8() - 108;
    if ($ === 28)
      return s.readInt16BE();
    if ($ === 29)
      return s.readInt32BE();
    if ($ === 30) {
      let _ = "";
      for (; ; ) {
        let _e = s.readUInt8(), tt = _e >> 4;
        if (tt === $c2d28e92708f99da$var$FLOAT_EOF)
          break;
        _ += $c2d28e92708f99da$var$FLOAT_LOOKUP[tt];
        let nt = _e & 15;
        if (nt === $c2d28e92708f99da$var$FLOAT_EOF)
          break;
        _ += $c2d28e92708f99da$var$FLOAT_LOOKUP[nt];
      }
      return parseFloat(_);
    }
    return null;
  }
  static size(s) {
    if (s.forceLarge && (s = 32768), (s | 0) !== s) {
      let $ = "" + s;
      return 1 + Math.ceil(($.length + 1) / 2);
    } else
      return -107 <= s && s <= 107 ? 1 : 108 <= s && s <= 1131 || -1131 <= s && s <= -108 ? 2 : -32768 <= s && s <= 32767 ? 3 : 5;
  }
  static encode(s, $) {
    let _ = Number($);
    if ($.forceLarge)
      return s.writeUInt8(29), s.writeInt32BE(_);
    if ((_ | 0) !== _) {
      s.writeUInt8(30);
      let tt = "" + _;
      for (let nt = 0; nt < tt.length; nt += 2) {
        let at = tt[nt], ot = $c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP[at] || +at;
        if (nt === tt.length - 1)
          var _e = $c2d28e92708f99da$var$FLOAT_EOF;
        else {
          let rt = tt[nt + 1];
          var _e = $c2d28e92708f99da$var$FLOAT_ENCODE_LOOKUP[rt] || +rt;
        }
        s.writeUInt8(ot << 4 | _e & 15);
      }
      if (_e !== $c2d28e92708f99da$var$FLOAT_EOF)
        return s.writeUInt8($c2d28e92708f99da$var$FLOAT_EOF << 4);
    } else
      return -107 <= _ && _ <= 107 ? s.writeUInt8(_ + 139) : 108 <= _ && _ <= 1131 ? (_ -= 108, s.writeUInt8((_ >> 8) + 247), s.writeUInt8(_ & 255)) : -1131 <= _ && _ <= -108 ? (_ = -_ - 108, s.writeUInt8((_ >> 8) + 251), s.writeUInt8(_ & 255)) : -32768 <= _ && _ <= 32767 ? (s.writeUInt8(28), s.writeInt16BE(_)) : (s.writeUInt8(29), s.writeInt32BE(_));
  }
}
class $61aa549f16d58b9b$export$2e2bcd8739ae039 {
  decodeOperands(s, $, _, _e) {
    if (Array.isArray(s))
      return _e.map((tt, nt) => this.decodeOperands(s[nt], $, _, [
        tt
      ]));
    if (s.decode != null)
      return s.decode($, _, _e);
    switch (s) {
      case "number":
      case "offset":
      case "sid":
        return _e[0];
      case "boolean":
        return !!_e[0];
      default:
        return _e;
    }
  }
  encodeOperands(s, $, _, _e) {
    return Array.isArray(s) ? _e.map((tt, nt) => this.encodeOperands(s[nt], $, _, tt)[0]) : s.encode != null ? s.encode($, _e, _) : typeof _e == "number" ? [
      _e
    ] : typeof _e == "boolean" ? [
      +_e
    ] : Array.isArray(_e) ? _e : [
      _e
    ];
  }
  decode(s, $) {
    let _ = s.pos + $.length, _e = {}, tt = [];
    Object.defineProperties(_e, {
      parent: {
        value: $
      },
      _startOffset: {
        value: s.pos
      }
    });
    for (let nt in this.fields) {
      let at = this.fields[nt];
      _e[at[1]] = at[3];
    }
    for (; s.pos < _; ) {
      let nt = s.readUInt8();
      if (nt < 28) {
        nt === 12 && (nt = nt << 8 | s.readUInt8());
        let at = this.fields[nt];
        if (!at)
          throw new Error(`Unknown operator ${nt}`);
        let ot = this.decodeOperands(at[2], s, _e, tt);
        ot != null && (ot instanceof PropertyDescriptor ? Object.defineProperty(_e, at[1], ot) : _e[at[1]] = ot), tt = [];
      } else
        tt.push($c2d28e92708f99da$export$2e2bcd8739ae039.decode(s, nt));
    }
    return _e;
  }
  size(s, $, _ = !0) {
    let _e = {
      parent: $,
      val: s,
      pointerSize: 0,
      startOffset: $.startOffset || 0
    }, tt = 0;
    for (let nt in this.fields) {
      let at = this.fields[nt], ot = s[at[1]];
      if (ot == null || $6uUbQ$fastdeepequal(ot, at[3]))
        continue;
      let rt = this.encodeOperands(at[2], null, _e, ot);
      for (let lt of rt)
        tt += $c2d28e92708f99da$export$2e2bcd8739ae039.size(lt);
      let st = Array.isArray(at[0]) ? at[0] : [
        at[0]
      ];
      tt += st.length;
    }
    return _ && (tt += _e.pointerSize), tt;
  }
  encode(s, $, _) {
    let _e = {
      pointers: [],
      startOffset: s.pos,
      parent: _,
      val: $,
      pointerSize: 0
    };
    _e.pointerOffset = s.pos + this.size($, _e, !1);
    for (let nt of this.ops) {
      let at = $[nt[1]];
      if (at == null || $6uUbQ$fastdeepequal(at, nt[3]))
        continue;
      let ot = this.encodeOperands(nt[2], s, _e, at);
      for (let st of ot)
        $c2d28e92708f99da$export$2e2bcd8739ae039.encode(s, st);
      let rt = Array.isArray(nt[0]) ? nt[0] : [
        nt[0]
      ];
      for (let st of rt)
        s.writeUInt8(st);
    }
    let tt = 0;
    for (; tt < _e.pointers.length; ) {
      let nt = _e.pointers[tt++];
      nt.type.encode(s, nt.val, nt.parent);
    }
  }
  constructor(s = []) {
    this.ops = s, this.fields = {};
    for (let $ of s) {
      let _ = Array.isArray($[0]) ? $[0][0] << 8 | $[0][1] : $[0];
      this.fields[_] = $;
    }
  }
}
class $0e34a43d05bde82c$export$2e2bcd8739ae039 extends Pointer {
  decode(s, $, _) {
    return this.offsetType = {
      decode: () => _[0]
    }, super.decode(s, $, _);
  }
  encode(s, $, _) {
    if (!s)
      return this.offsetType = {
        size: () => 0
      }, this.size($, _), [
        new $0e34a43d05bde82c$var$Ptr(0)
      ];
    let _e = null;
    return this.offsetType = {
      encode: (tt, nt) => _e = nt
    }, super.encode(s, $, _), [
      new $0e34a43d05bde82c$var$Ptr(_e)
    ];
  }
  constructor(s, $ = {}) {
    $.type == null && ($.type = "global"), super(null, s, $);
  }
}
class $0e34a43d05bde82c$var$Ptr {
  valueOf() {
    return this.val;
  }
  constructor(s) {
    this.val = s, this.forceLarge = !0;
  }
}
class $6d59db2e29cc77b3$var$CFFBlendOp {
  static decode(s, $, _) {
    let _e = _.pop();
    for (; _.length > _e; )
      _.pop();
  }
}
var $6d59db2e29cc77b3$export$2e2bcd8739ae039 = new $61aa549f16d58b9b$export$2e2bcd8739ae039([
  // key       name                    type                                          default
  [
    6,
    "BlueValues",
    "delta",
    null
  ],
  [
    7,
    "OtherBlues",
    "delta",
    null
  ],
  [
    8,
    "FamilyBlues",
    "delta",
    null
  ],
  [
    9,
    "FamilyOtherBlues",
    "delta",
    null
  ],
  [
    [
      12,
      9
    ],
    "BlueScale",
    "number",
    0.039625
  ],
  [
    [
      12,
      10
    ],
    "BlueShift",
    "number",
    7
  ],
  [
    [
      12,
      11
    ],
    "BlueFuzz",
    "number",
    1
  ],
  [
    10,
    "StdHW",
    "number",
    null
  ],
  [
    11,
    "StdVW",
    "number",
    null
  ],
  [
    [
      12,
      12
    ],
    "StemSnapH",
    "delta",
    null
  ],
  [
    [
      12,
      13
    ],
    "StemSnapV",
    "delta",
    null
  ],
  [
    [
      12,
      14
    ],
    "ForceBold",
    "boolean",
    !1
  ],
  [
    [
      12,
      17
    ],
    "LanguageGroup",
    "number",
    0
  ],
  [
    [
      12,
      18
    ],
    "ExpansionFactor",
    "number",
    0.06
  ],
  [
    [
      12,
      19
    ],
    "initialRandomSeed",
    "number",
    0
  ],
  [
    20,
    "defaultWidthX",
    "number",
    0
  ],
  [
    21,
    "nominalWidthX",
    "number",
    0
  ],
  [
    22,
    "vsindex",
    "number",
    0
  ],
  [
    23,
    "blend",
    $6d59db2e29cc77b3$var$CFFBlendOp,
    null
  ],
  [
    19,
    "Subrs",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039(new $43e9821ef3717eec$export$2e2bcd8739ae039(), {
      type: "local"
    }),
    null
  ]
]), $229224aec43783c5$export$2e2bcd8739ae039 = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall",
  "001.000",
  "001.001",
  "001.002",
  "001.003",
  "Black",
  "Bold",
  "Book",
  "Light",
  "Medium",
  "Regular",
  "Roman",
  "Semibold"
];
let $bc0433d9b7e41f5f$export$dee0027060fa13bd = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "",
  "questiondown",
  "",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "",
  "ring",
  "cedilla",
  "",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "AE",
  "",
  "ordfeminine",
  "",
  "",
  "",
  "",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "",
  "",
  "",
  "",
  "",
  "ae",
  "",
  "",
  "",
  "dotlessi",
  "",
  "",
  "lslash",
  "oslash",
  "oe",
  "germandbls"
], $bc0433d9b7e41f5f$export$4f58f497e14a53c3 = [
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "",
  "",
  "isuperior",
  "",
  "",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "",
  "",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "",
  "",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "",
  "Dotaccentsmall",
  "",
  "",
  "Macronsmall",
  "",
  "",
  "figuredash",
  "hypheninferior",
  "",
  "",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "",
  "",
  "",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "",
  "",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], $ef658f5c9a1488b2$export$c33b50336c234f16 = [
  ".notdef",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quoteright",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "quoteleft",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "exclamdown",
  "cent",
  "sterling",
  "fraction",
  "yen",
  "florin",
  "section",
  "currency",
  "quotesingle",
  "quotedblleft",
  "guillemotleft",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "endash",
  "dagger",
  "daggerdbl",
  "periodcentered",
  "paragraph",
  "bullet",
  "quotesinglbase",
  "quotedblbase",
  "quotedblright",
  "guillemotright",
  "ellipsis",
  "perthousand",
  "questiondown",
  "grave",
  "acute",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "dieresis",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "emdash",
  "AE",
  "ordfeminine",
  "Lslash",
  "Oslash",
  "OE",
  "ordmasculine",
  "ae",
  "dotlessi",
  "lslash",
  "oslash",
  "oe",
  "germandbls",
  "onesuperior",
  "logicalnot",
  "mu",
  "trademark",
  "Eth",
  "onehalf",
  "plusminus",
  "Thorn",
  "onequarter",
  "divide",
  "brokenbar",
  "degree",
  "thorn",
  "threequarters",
  "twosuperior",
  "registered",
  "minus",
  "eth",
  "multiply",
  "threesuperior",
  "copyright",
  "Aacute",
  "Acircumflex",
  "Adieresis",
  "Agrave",
  "Aring",
  "Atilde",
  "Ccedilla",
  "Eacute",
  "Ecircumflex",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Ntilde",
  "Oacute",
  "Ocircumflex",
  "Odieresis",
  "Ograve",
  "Otilde",
  "Scaron",
  "Uacute",
  "Ucircumflex",
  "Udieresis",
  "Ugrave",
  "Yacute",
  "Ydieresis",
  "Zcaron",
  "aacute",
  "acircumflex",
  "adieresis",
  "agrave",
  "aring",
  "atilde",
  "ccedilla",
  "eacute",
  "ecircumflex",
  "edieresis",
  "egrave",
  "iacute",
  "icircumflex",
  "idieresis",
  "igrave",
  "ntilde",
  "oacute",
  "ocircumflex",
  "odieresis",
  "ograve",
  "otilde",
  "scaron",
  "uacute",
  "ucircumflex",
  "udieresis",
  "ugrave",
  "yacute",
  "ydieresis",
  "zcaron"
], $ef658f5c9a1488b2$export$3ed0f9e1fee8d489 = [
  ".notdef",
  "space",
  "exclamsmall",
  "Hungarumlautsmall",
  "dollaroldstyle",
  "dollarsuperior",
  "ampersandsmall",
  "Acutesmall",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "questionsmall",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "Circumflexsmall",
  "hyphensuperior",
  "Gravesmall",
  "Asmall",
  "Bsmall",
  "Csmall",
  "Dsmall",
  "Esmall",
  "Fsmall",
  "Gsmall",
  "Hsmall",
  "Ismall",
  "Jsmall",
  "Ksmall",
  "Lsmall",
  "Msmall",
  "Nsmall",
  "Osmall",
  "Psmall",
  "Qsmall",
  "Rsmall",
  "Ssmall",
  "Tsmall",
  "Usmall",
  "Vsmall",
  "Wsmall",
  "Xsmall",
  "Ysmall",
  "Zsmall",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "Tildesmall",
  "exclamdownsmall",
  "centoldstyle",
  "Lslashsmall",
  "Scaronsmall",
  "Zcaronsmall",
  "Dieresissmall",
  "Brevesmall",
  "Caronsmall",
  "Dotaccentsmall",
  "Macronsmall",
  "figuredash",
  "hypheninferior",
  "Ogoneksmall",
  "Ringsmall",
  "Cedillasmall",
  "onequarter",
  "onehalf",
  "threequarters",
  "questiondownsmall",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior",
  "Agravesmall",
  "Aacutesmall",
  "Acircumflexsmall",
  "Atildesmall",
  "Adieresissmall",
  "Aringsmall",
  "AEsmall",
  "Ccedillasmall",
  "Egravesmall",
  "Eacutesmall",
  "Ecircumflexsmall",
  "Edieresissmall",
  "Igravesmall",
  "Iacutesmall",
  "Icircumflexsmall",
  "Idieresissmall",
  "Ethsmall",
  "Ntildesmall",
  "Ogravesmall",
  "Oacutesmall",
  "Ocircumflexsmall",
  "Otildesmall",
  "Odieresissmall",
  "OEsmall",
  "Oslashsmall",
  "Ugravesmall",
  "Uacutesmall",
  "Ucircumflexsmall",
  "Udieresissmall",
  "Yacutesmall",
  "Thornsmall",
  "Ydieresissmall"
], $ef658f5c9a1488b2$export$dc28be11139d4120 = [
  ".notdef",
  "space",
  "dollaroldstyle",
  "dollarsuperior",
  "parenleftsuperior",
  "parenrightsuperior",
  "twodotenleader",
  "onedotenleader",
  "comma",
  "hyphen",
  "period",
  "fraction",
  "zerooldstyle",
  "oneoldstyle",
  "twooldstyle",
  "threeoldstyle",
  "fouroldstyle",
  "fiveoldstyle",
  "sixoldstyle",
  "sevenoldstyle",
  "eightoldstyle",
  "nineoldstyle",
  "colon",
  "semicolon",
  "commasuperior",
  "threequartersemdash",
  "periodsuperior",
  "asuperior",
  "bsuperior",
  "centsuperior",
  "dsuperior",
  "esuperior",
  "isuperior",
  "lsuperior",
  "msuperior",
  "nsuperior",
  "osuperior",
  "rsuperior",
  "ssuperior",
  "tsuperior",
  "ff",
  "fi",
  "fl",
  "ffi",
  "ffl",
  "parenleftinferior",
  "parenrightinferior",
  "hyphensuperior",
  "colonmonetary",
  "onefitted",
  "rupiah",
  "centoldstyle",
  "figuredash",
  "hypheninferior",
  "onequarter",
  "onehalf",
  "threequarters",
  "oneeighth",
  "threeeighths",
  "fiveeighths",
  "seveneighths",
  "onethird",
  "twothirds",
  "zerosuperior",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "foursuperior",
  "fivesuperior",
  "sixsuperior",
  "sevensuperior",
  "eightsuperior",
  "ninesuperior",
  "zeroinferior",
  "oneinferior",
  "twoinferior",
  "threeinferior",
  "fourinferior",
  "fiveinferior",
  "sixinferior",
  "seveninferior",
  "eightinferior",
  "nineinferior",
  "centinferior",
  "dollarinferior",
  "periodinferior",
  "commainferior"
], $7cbbe4e24ef3cb75$var$LangSysTable = new Struct({
  reserved: new Reserved(uint16),
  reqFeatureIndex: uint16,
  featureCount: uint16,
  featureIndexes: new ArrayT(uint16, "featureCount")
}), $7cbbe4e24ef3cb75$var$LangSysRecord = new Struct({
  tag: new StringT(4),
  langSys: new Pointer(uint16, $7cbbe4e24ef3cb75$var$LangSysTable, {
    type: "parent"
  })
}), $7cbbe4e24ef3cb75$var$Script = new Struct({
  defaultLangSys: new Pointer(uint16, $7cbbe4e24ef3cb75$var$LangSysTable),
  count: uint16,
  langSysRecords: new ArrayT($7cbbe4e24ef3cb75$var$LangSysRecord, "count")
}), $7cbbe4e24ef3cb75$var$ScriptRecord = new Struct({
  tag: new StringT(4),
  script: new Pointer(uint16, $7cbbe4e24ef3cb75$var$Script, {
    type: "parent"
  })
}), $7cbbe4e24ef3cb75$export$3e15fc05ce864229 = new ArrayT($7cbbe4e24ef3cb75$var$ScriptRecord, uint16), $7cbbe4e24ef3cb75$var$FeatureParams = new Struct({
  version: uint16,
  nameID: uint16
}), $7cbbe4e24ef3cb75$export$6e91cf7616333d5 = new Struct({
  featureParams: new Pointer(uint16, $7cbbe4e24ef3cb75$var$FeatureParams),
  lookupCount: uint16,
  lookupListIndexes: new ArrayT(uint16, "lookupCount")
}), $7cbbe4e24ef3cb75$var$FeatureRecord = new Struct({
  tag: new StringT(4),
  feature: new Pointer(uint16, $7cbbe4e24ef3cb75$export$6e91cf7616333d5, {
    type: "parent"
  })
}), $7cbbe4e24ef3cb75$export$aa18130def4b6cb4 = new ArrayT($7cbbe4e24ef3cb75$var$FeatureRecord, uint16), $7cbbe4e24ef3cb75$var$LookupFlags = new Struct({
  markAttachmentType: uint8,
  flags: new Bitfield(uint8, [
    "rightToLeft",
    "ignoreBaseGlyphs",
    "ignoreLigatures",
    "ignoreMarks",
    "useMarkFilteringSet"
  ])
});
function $7cbbe4e24ef3cb75$export$df0008c6ff2da22a(a) {
  let s = new Struct({
    lookupType: uint16,
    flags: $7cbbe4e24ef3cb75$var$LookupFlags,
    subTableCount: uint16,
    subTables: new ArrayT(new Pointer(uint16, a), "subTableCount"),
    markFilteringSet: new Optional(uint16, ($) => $.flags.flags.useMarkFilteringSet)
  });
  return new LazyArray(new Pointer(uint16, s), uint16);
}
let $7cbbe4e24ef3cb75$var$RangeRecord = new Struct({
  start: uint16,
  end: uint16,
  startCoverageIndex: uint16
}), $7cbbe4e24ef3cb75$export$17608c3f81a6111 = new VersionedStruct(uint16, {
  1: {
    glyphCount: uint16,
    glyphs: new ArrayT(uint16, "glyphCount")
  },
  2: {
    rangeCount: uint16,
    rangeRecords: new ArrayT($7cbbe4e24ef3cb75$var$RangeRecord, "rangeCount")
  }
}), $7cbbe4e24ef3cb75$var$ClassRangeRecord = new Struct({
  start: uint16,
  end: uint16,
  class: uint16
}), $7cbbe4e24ef3cb75$export$843d551fbbafef71 = new VersionedStruct(uint16, {
  1: {
    startGlyph: uint16,
    glyphCount: uint16,
    classValueArray: new ArrayT(uint16, "glyphCount")
  },
  2: {
    classRangeCount: uint16,
    classRangeRecord: new ArrayT($7cbbe4e24ef3cb75$var$ClassRangeRecord, "classRangeCount")
  }
}), $7cbbe4e24ef3cb75$export$8215d14a63d9fb10 = new Struct({
  a: uint16,
  b: uint16,
  deltaFormat: uint16
}), $7cbbe4e24ef3cb75$var$LookupRecord = new Struct({
  sequenceIndex: uint16,
  lookupListIndex: uint16
}), $7cbbe4e24ef3cb75$var$Rule = new Struct({
  glyphCount: uint16,
  lookupCount: uint16,
  input: new ArrayT(uint16, (a) => a.glyphCount - 1),
  lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
}), $7cbbe4e24ef3cb75$var$RuleSet = new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$Rule), uint16), $7cbbe4e24ef3cb75$var$ClassRule = new Struct({
  glyphCount: uint16,
  lookupCount: uint16,
  classes: new ArrayT(uint16, (a) => a.glyphCount - 1),
  lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
}), $7cbbe4e24ef3cb75$var$ClassSet = new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ClassRule), uint16), $7cbbe4e24ef3cb75$export$841858b892ce1f4c = new VersionedStruct(uint16, {
  1: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    ruleSetCount: uint16,
    ruleSets: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$RuleSet), "ruleSetCount")
  },
  2: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    classDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    classSetCnt: uint16,
    classSet: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ClassSet), "classSetCnt")
  },
  3: {
    glyphCount: uint16,
    lookupCount: uint16,
    coverages: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "glyphCount"),
    lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
  }
}), $7cbbe4e24ef3cb75$var$ChainRule = new Struct({
  backtrackGlyphCount: uint16,
  backtrack: new ArrayT(uint16, "backtrackGlyphCount"),
  inputGlyphCount: uint16,
  input: new ArrayT(uint16, (a) => a.inputGlyphCount - 1),
  lookaheadGlyphCount: uint16,
  lookahead: new ArrayT(uint16, "lookaheadGlyphCount"),
  lookupCount: uint16,
  lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
}), $7cbbe4e24ef3cb75$var$ChainRuleSet = new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ChainRule), uint16), $7cbbe4e24ef3cb75$export$5e6d09e6861162f6 = new VersionedStruct(uint16, {
  1: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    chainCount: uint16,
    chainRuleSets: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ChainRuleSet), "chainCount")
  },
  2: {
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    backtrackClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    inputClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    lookaheadClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    chainCount: uint16,
    chainClassSet: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$var$ChainRuleSet), "chainCount")
  },
  3: {
    backtrackGlyphCount: uint16,
    backtrackCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "backtrackGlyphCount"),
    inputGlyphCount: uint16,
    inputCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "inputGlyphCount"),
    lookaheadGlyphCount: uint16,
    lookaheadCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "lookaheadGlyphCount"),
    lookupCount: uint16,
    lookupRecords: new ArrayT($7cbbe4e24ef3cb75$var$LookupRecord, "lookupCount")
  }
}), $1a47b0c45c1c22fe$var$F2DOT14 = new Fixed(16, "BE", 14), $1a47b0c45c1c22fe$var$RegionAxisCoordinates = new Struct({
  startCoord: $1a47b0c45c1c22fe$var$F2DOT14,
  peakCoord: $1a47b0c45c1c22fe$var$F2DOT14,
  endCoord: $1a47b0c45c1c22fe$var$F2DOT14
}), $1a47b0c45c1c22fe$var$VariationRegionList = new Struct({
  axisCount: uint16,
  regionCount: uint16,
  variationRegions: new ArrayT(new ArrayT($1a47b0c45c1c22fe$var$RegionAxisCoordinates, "axisCount"), "regionCount")
}), $1a47b0c45c1c22fe$var$DeltaSet = new Struct({
  shortDeltas: new ArrayT(int16, (a) => a.parent.shortDeltaCount),
  regionDeltas: new ArrayT(int8, (a) => a.parent.regionIndexCount - a.parent.shortDeltaCount),
  deltas: (a) => a.shortDeltas.concat(a.regionDeltas)
}), $1a47b0c45c1c22fe$var$ItemVariationData = new Struct({
  itemCount: uint16,
  shortDeltaCount: uint16,
  regionIndexCount: uint16,
  regionIndexes: new ArrayT(uint16, "regionIndexCount"),
  deltaSets: new ArrayT($1a47b0c45c1c22fe$var$DeltaSet, "itemCount")
}), $1a47b0c45c1c22fe$export$fe1b122a2710f241 = new Struct({
  format: uint16,
  variationRegionList: new Pointer(uint32, $1a47b0c45c1c22fe$var$VariationRegionList),
  variationDataCount: uint16,
  itemVariationData: new ArrayT(new Pointer(uint32, $1a47b0c45c1c22fe$var$ItemVariationData), "variationDataCount")
}), $1a47b0c45c1c22fe$var$ConditionTable = new VersionedStruct(uint16, {
  1: {
    axisIndex: uint16,
    axisIndex: uint16,
    filterRangeMinValue: $1a47b0c45c1c22fe$var$F2DOT14,
    filterRangeMaxValue: $1a47b0c45c1c22fe$var$F2DOT14
  }
}), $1a47b0c45c1c22fe$var$ConditionSet = new Struct({
  conditionCount: uint16,
  conditionTable: new ArrayT(new Pointer(uint32, $1a47b0c45c1c22fe$var$ConditionTable), "conditionCount")
}), $1a47b0c45c1c22fe$var$FeatureTableSubstitutionRecord = new Struct({
  featureIndex: uint16,
  alternateFeatureTable: new Pointer(uint32, $7cbbe4e24ef3cb75$export$6e91cf7616333d5, {
    type: "parent"
  })
}), $1a47b0c45c1c22fe$var$FeatureTableSubstitution = new Struct({
  version: fixed32,
  substitutionCount: uint16,
  substitutions: new ArrayT($1a47b0c45c1c22fe$var$FeatureTableSubstitutionRecord, "substitutionCount")
}), $1a47b0c45c1c22fe$var$FeatureVariationRecord = new Struct({
  conditionSet: new Pointer(uint32, $1a47b0c45c1c22fe$var$ConditionSet, {
    type: "parent"
  }),
  featureTableSubstitution: new Pointer(uint32, $1a47b0c45c1c22fe$var$FeatureTableSubstitution, {
    type: "parent"
  })
}), $1a47b0c45c1c22fe$export$441b70b7971dd419 = new Struct({
  majorVersion: uint16,
  minorVersion: uint16,
  featureVariationRecordCount: uint32,
  featureVariationRecords: new ArrayT($1a47b0c45c1c22fe$var$FeatureVariationRecord, "featureVariationRecordCount")
});
class $b84fd3dd9d8eddb2$var$PredefinedOp {
  decode(s, $, _) {
    return this.predefinedOps[_[0]] ? this.predefinedOps[_[0]] : this.type.decode(s, $, _);
  }
  size(s, $) {
    return this.type.size(s, $);
  }
  encode(s, $, _) {
    let _e = this.predefinedOps.indexOf($);
    return _e !== -1 ? _e : this.type.encode(s, $, _);
  }
  constructor(s, $) {
    this.predefinedOps = s, this.type = $;
  }
}
class $b84fd3dd9d8eddb2$var$CFFEncodingVersion extends NumberT {
  decode(s) {
    return uint8.decode(s) & 127;
  }
  constructor() {
    super("UInt8");
  }
}
let $b84fd3dd9d8eddb2$var$Range1 = new Struct({
  first: uint16,
  nLeft: uint8
}), $b84fd3dd9d8eddb2$var$Range2 = new Struct({
  first: uint16,
  nLeft: uint16
}), $b84fd3dd9d8eddb2$var$CFFCustomEncoding = new VersionedStruct(new $b84fd3dd9d8eddb2$var$CFFEncodingVersion(), {
  0: {
    nCodes: uint8,
    codes: new ArrayT(uint8, "nCodes")
  },
  1: {
    nRanges: uint8,
    ranges: new ArrayT($b84fd3dd9d8eddb2$var$Range1, "nRanges")
  }
}), $b84fd3dd9d8eddb2$var$CFFEncoding = new $b84fd3dd9d8eddb2$var$PredefinedOp([
  $bc0433d9b7e41f5f$export$dee0027060fa13bd,
  $bc0433d9b7e41f5f$export$4f58f497e14a53c3
], new $0e34a43d05bde82c$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$CFFCustomEncoding, {
  lazy: !0
}));
class $b84fd3dd9d8eddb2$var$RangeArray extends ArrayT {
  decode(s, $) {
    let _ = resolveLength(this.length, s, $), _e = 0, tt = [];
    for (; _e < _; ) {
      let nt = this.type.decode(s, $);
      nt.offset = _e, _e += nt.nLeft + 1, tt.push(nt);
    }
    return tt;
  }
}
let $b84fd3dd9d8eddb2$var$CFFCustomCharset = new VersionedStruct(uint8, {
  0: {
    glyphs: new ArrayT(uint16, (a) => a.parent.CharStrings.length - 1)
  },
  1: {
    ranges: new $b84fd3dd9d8eddb2$var$RangeArray($b84fd3dd9d8eddb2$var$Range1, (a) => a.parent.CharStrings.length - 1)
  },
  2: {
    ranges: new $b84fd3dd9d8eddb2$var$RangeArray($b84fd3dd9d8eddb2$var$Range2, (a) => a.parent.CharStrings.length - 1)
  }
}), $b84fd3dd9d8eddb2$var$CFFCharset = new $b84fd3dd9d8eddb2$var$PredefinedOp([
  $ef658f5c9a1488b2$export$c33b50336c234f16,
  $ef658f5c9a1488b2$export$3ed0f9e1fee8d489,
  $ef658f5c9a1488b2$export$dc28be11139d4120
], new $0e34a43d05bde82c$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$CFFCustomCharset, {
  lazy: !0
})), $b84fd3dd9d8eddb2$var$FDRange3 = new Struct({
  first: uint16,
  fd: uint8
}), $b84fd3dd9d8eddb2$var$FDRange4 = new Struct({
  first: uint32,
  fd: uint16
}), $b84fd3dd9d8eddb2$var$FDSelect = new VersionedStruct(uint8, {
  0: {
    fds: new ArrayT(uint8, (a) => a.parent.CharStrings.length)
  },
  3: {
    nRanges: uint16,
    ranges: new ArrayT($b84fd3dd9d8eddb2$var$FDRange3, "nRanges"),
    sentinel: uint16
  },
  4: {
    nRanges: uint32,
    ranges: new ArrayT($b84fd3dd9d8eddb2$var$FDRange4, "nRanges"),
    sentinel: uint32
  }
}), $b84fd3dd9d8eddb2$var$ptr = new $0e34a43d05bde82c$export$2e2bcd8739ae039($6d59db2e29cc77b3$export$2e2bcd8739ae039);
class $b84fd3dd9d8eddb2$var$CFFPrivateOp {
  decode(s, $, _) {
    return $.length = _[0], $b84fd3dd9d8eddb2$var$ptr.decode(s, $, [
      _[1]
    ]);
  }
  size(s, $) {
    return [
      $6d59db2e29cc77b3$export$2e2bcd8739ae039.size(s, $, !1),
      $b84fd3dd9d8eddb2$var$ptr.size(s, $)[0]
    ];
  }
  encode(s, $, _) {
    return [
      $6d59db2e29cc77b3$export$2e2bcd8739ae039.size($, _, !1),
      $b84fd3dd9d8eddb2$var$ptr.encode(s, $, _)[0]
    ];
  }
}
let $b84fd3dd9d8eddb2$var$FontDict = new $61aa549f16d58b9b$export$2e2bcd8739ae039([
  // key       name                   type(s)                                 default
  [
    18,
    "Private",
    new $b84fd3dd9d8eddb2$var$CFFPrivateOp(),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ]
]), $b84fd3dd9d8eddb2$var$CFFTopDict = new $61aa549f16d58b9b$export$2e2bcd8739ae039([
  // key       name                   type(s)                                 default
  [
    [
      12,
      30
    ],
    "ROS",
    [
      "sid",
      "sid",
      "number"
    ],
    null
  ],
  [
    0,
    "version",
    "sid",
    null
  ],
  [
    1,
    "Notice",
    "sid",
    null
  ],
  [
    [
      12,
      0
    ],
    "Copyright",
    "sid",
    null
  ],
  [
    2,
    "FullName",
    "sid",
    null
  ],
  [
    3,
    "FamilyName",
    "sid",
    null
  ],
  [
    4,
    "Weight",
    "sid",
    null
  ],
  [
    [
      12,
      1
    ],
    "isFixedPitch",
    "boolean",
    !1
  ],
  [
    [
      12,
      2
    ],
    "ItalicAngle",
    "number",
    0
  ],
  [
    [
      12,
      3
    ],
    "UnderlinePosition",
    "number",
    -100
  ],
  [
    [
      12,
      4
    ],
    "UnderlineThickness",
    "number",
    50
  ],
  [
    [
      12,
      5
    ],
    "PaintType",
    "number",
    0
  ],
  [
    [
      12,
      6
    ],
    "CharstringType",
    "number",
    2
  ],
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    13,
    "UniqueID",
    "number",
    null
  ],
  [
    5,
    "FontBBox",
    "array",
    [
      0,
      0,
      0,
      0
    ]
  ],
  [
    [
      12,
      8
    ],
    "StrokeWidth",
    "number",
    0
  ],
  [
    14,
    "XUID",
    "array",
    null
  ],
  [
    15,
    "charset",
    $b84fd3dd9d8eddb2$var$CFFCharset,
    $ef658f5c9a1488b2$export$c33b50336c234f16
  ],
  [
    16,
    "Encoding",
    $b84fd3dd9d8eddb2$var$CFFEncoding,
    $bc0433d9b7e41f5f$export$dee0027060fa13bd
  ],
  [
    17,
    "CharStrings",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039(new $43e9821ef3717eec$export$2e2bcd8739ae039()),
    null
  ],
  [
    18,
    "Private",
    new $b84fd3dd9d8eddb2$var$CFFPrivateOp(),
    null
  ],
  [
    [
      12,
      20
    ],
    "SyntheticBase",
    "number",
    null
  ],
  [
    [
      12,
      21
    ],
    "PostScript",
    "sid",
    null
  ],
  [
    [
      12,
      22
    ],
    "BaseFontName",
    "sid",
    null
  ],
  [
    [
      12,
      23
    ],
    "BaseFontBlend",
    "delta",
    null
  ],
  // CID font specific
  [
    [
      12,
      31
    ],
    "CIDFontVersion",
    "number",
    0
  ],
  [
    [
      12,
      32
    ],
    "CIDFontRevision",
    "number",
    0
  ],
  [
    [
      12,
      33
    ],
    "CIDFontType",
    "number",
    0
  ],
  [
    [
      12,
      34
    ],
    "CIDCount",
    "number",
    8720
  ],
  [
    [
      12,
      35
    ],
    "UIDBase",
    "number",
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$FDSelect),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039(new $43e9821ef3717eec$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$FontDict)),
    null
  ],
  [
    [
      12,
      38
    ],
    "FontName",
    "sid",
    null
  ]
]), $b84fd3dd9d8eddb2$var$VariationStore = new Struct({
  length: uint16,
  itemVariationStore: $1a47b0c45c1c22fe$export$fe1b122a2710f241
}), $b84fd3dd9d8eddb2$var$CFF2TopDict = new $61aa549f16d58b9b$export$2e2bcd8739ae039([
  [
    [
      12,
      7
    ],
    "FontMatrix",
    "array",
    [
      1e-3,
      0,
      0,
      1e-3,
      0,
      0
    ]
  ],
  [
    17,
    "CharStrings",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039(new $43e9821ef3717eec$export$2e2bcd8739ae039()),
    null
  ],
  [
    [
      12,
      37
    ],
    "FDSelect",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$FDSelect),
    null
  ],
  [
    [
      12,
      36
    ],
    "FDArray",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039(new $43e9821ef3717eec$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$FontDict)),
    null
  ],
  [
    24,
    "vstore",
    new $0e34a43d05bde82c$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$VariationStore),
    null
  ],
  [
    25,
    "maxstack",
    "number",
    193
  ]
]), $b84fd3dd9d8eddb2$var$CFFTop = new VersionedStruct(fixed16, {
  1: {
    hdrSize: uint8,
    offSize: uint8,
    nameIndex: new $43e9821ef3717eec$export$2e2bcd8739ae039(new StringT("length")),
    topDictIndex: new $43e9821ef3717eec$export$2e2bcd8739ae039($b84fd3dd9d8eddb2$var$CFFTopDict),
    stringIndex: new $43e9821ef3717eec$export$2e2bcd8739ae039(new StringT("length")),
    globalSubrIndex: new $43e9821ef3717eec$export$2e2bcd8739ae039()
  },
  2: {
    hdrSize: uint8,
    length: uint16,
    topDict: $b84fd3dd9d8eddb2$var$CFF2TopDict,
    globalSubrIndex: new $43e9821ef3717eec$export$2e2bcd8739ae039()
  }
});
var $b84fd3dd9d8eddb2$export$2e2bcd8739ae039 = $b84fd3dd9d8eddb2$var$CFFTop;
class $822ac0d589e4e237$var$CFFFont {
  static decode(s) {
    return new $822ac0d589e4e237$var$CFFFont(s);
  }
  decode() {
    this.stream.pos;
    let s = $b84fd3dd9d8eddb2$export$2e2bcd8739ae039.decode(this.stream);
    for (let $ in s) {
      let _ = s[$];
      this[$] = _;
    }
    if (this.version < 2) {
      if (this.topDictIndex.length !== 1)
        throw new Error("Only a single font is allowed in CFF");
      this.topDict = this.topDictIndex[0];
    }
    return this.isCIDFont = this.topDict.ROS != null, this;
  }
  string(s) {
    return this.version >= 2 ? null : s < $229224aec43783c5$export$2e2bcd8739ae039.length ? $229224aec43783c5$export$2e2bcd8739ae039[s] : this.stringIndex[s - $229224aec43783c5$export$2e2bcd8739ae039.length];
  }
  get postscriptName() {
    return this.version < 2 ? this.nameIndex[0] : null;
  }
  get fullName() {
    return this.string(this.topDict.FullName);
  }
  get familyName() {
    return this.string(this.topDict.FamilyName);
  }
  getCharString(s) {
    return this.stream.pos = this.topDict.CharStrings[s].offset, this.stream.readBuffer(this.topDict.CharStrings[s].length);
  }
  getGlyphName(s) {
    if (this.version >= 2 || this.isCIDFont)
      return null;
    let { charset: $ } = this.topDict;
    if (Array.isArray($))
      return $[s];
    if (s === 0)
      return ".notdef";
    switch (s -= 1, $.version) {
      case 0:
        return this.string($.glyphs[s]);
      case 1:
      case 2:
        for (let _ = 0; _ < $.ranges.length; _++) {
          let _e = $.ranges[_];
          if (_e.offset <= s && s <= _e.offset + _e.nLeft)
            return this.string(_e.first + (s - _e.offset));
        }
        break;
    }
    return null;
  }
  fdForGlyph(s) {
    if (!this.topDict.FDSelect)
      return null;
    switch (this.topDict.FDSelect.version) {
      case 0:
        return this.topDict.FDSelect.fds[s];
      case 3:
      case 4:
        let { ranges: $ } = this.topDict.FDSelect, _ = 0, _e = $.length - 1;
        for (; _ <= _e; ) {
          let tt = _ + _e >> 1;
          if (s < $[tt].first)
            _e = tt - 1;
          else if (tt < _e && s >= $[tt + 1].first)
            _ = tt + 1;
          else
            return $[tt].fd;
        }
      default:
        throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
    }
  }
  privateDictForGlyph(s) {
    if (this.topDict.FDSelect) {
      let $ = this.fdForGlyph(s);
      return this.topDict.FDArray[$] ? this.topDict.FDArray[$].Private : null;
    }
    return this.version < 2 ? this.topDict.Private : this.topDict.FDArray[0].Private;
  }
  constructor(s) {
    this.stream = s, this.decode();
  }
}
var $822ac0d589e4e237$export$2e2bcd8739ae039 = $822ac0d589e4e237$var$CFFFont;
let $2bbf2bc1ce37cd8f$var$VerticalOrigin = new Struct({
  glyphIndex: uint16,
  vertOriginY: int16
});
var $2bbf2bc1ce37cd8f$export$2e2bcd8739ae039 = new Struct({
  majorVersion: uint16,
  minorVersion: uint16,
  defaultVertOriginY: int16,
  numVertOriginYMetrics: uint16,
  metrics: new ArrayT($2bbf2bc1ce37cd8f$var$VerticalOrigin, "numVertOriginYMetrics")
});
let $0941618dc22a946d$export$16b227cb15d716a0 = new Struct({
  height: uint8,
  width: uint8,
  horiBearingX: int8,
  horiBearingY: int8,
  horiAdvance: uint8,
  vertBearingX: int8,
  vertBearingY: int8,
  vertAdvance: uint8
}), $0941618dc22a946d$export$62c53e75f69bfe12 = new Struct({
  height: uint8,
  width: uint8,
  bearingX: int8,
  bearingY: int8,
  advance: uint8
}), $0941618dc22a946d$var$EBDTComponent = new Struct({
  glyph: uint16,
  xOffset: int8,
  yOffset: int8
});
class $0941618dc22a946d$var$ByteAligned {
}
class $0941618dc22a946d$var$BitAligned {
}
new VersionedStruct("version", {
  1: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    data: $0941618dc22a946d$var$ByteAligned
  },
  2: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    data: $0941618dc22a946d$var$BitAligned
  },
  // format 3 is deprecated
  // format 4 is not supported by Microsoft
  5: {
    data: $0941618dc22a946d$var$BitAligned
  },
  6: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    data: $0941618dc22a946d$var$ByteAligned
  },
  7: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    data: $0941618dc22a946d$var$BitAligned
  },
  8: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    pad: new Reserved(uint8),
    numComponents: uint16,
    components: new ArrayT($0941618dc22a946d$var$EBDTComponent, "numComponents")
  },
  9: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    pad: new Reserved(uint8),
    numComponents: uint16,
    components: new ArrayT($0941618dc22a946d$var$EBDTComponent, "numComponents")
  },
  17: {
    metrics: $0941618dc22a946d$export$62c53e75f69bfe12,
    dataLen: uint32,
    data: new BufferT("dataLen")
  },
  18: {
    metrics: $0941618dc22a946d$export$16b227cb15d716a0,
    dataLen: uint32,
    data: new BufferT("dataLen")
  },
  19: {
    dataLen: uint32,
    data: new BufferT("dataLen")
  }
});
let $9911c4c7201c13de$var$SBitLineMetrics = new Struct({
  ascender: int8,
  descender: int8,
  widthMax: uint8,
  caretSlopeNumerator: int8,
  caretSlopeDenominator: int8,
  caretOffset: int8,
  minOriginSB: int8,
  minAdvanceSB: int8,
  maxBeforeBL: int8,
  minAfterBL: int8,
  pad: new Reserved(int8, 2)
}), $9911c4c7201c13de$var$CodeOffsetPair = new Struct({
  glyphCode: uint16,
  offset: uint16
}), $9911c4c7201c13de$var$IndexSubtable = new VersionedStruct(uint16, {
  header: {
    imageFormat: uint16,
    imageDataOffset: uint32
  },
  1: {
    offsetArray: new ArrayT(uint32, (a) => a.parent.lastGlyphIndex - a.parent.firstGlyphIndex + 1)
  },
  2: {
    imageSize: uint32,
    bigMetrics: $0941618dc22a946d$export$16b227cb15d716a0
  },
  3: {
    offsetArray: new ArrayT(uint16, (a) => a.parent.lastGlyphIndex - a.parent.firstGlyphIndex + 1)
  },
  4: {
    numGlyphs: uint32,
    glyphArray: new ArrayT($9911c4c7201c13de$var$CodeOffsetPair, (a) => a.numGlyphs + 1)
  },
  5: {
    imageSize: uint32,
    bigMetrics: $0941618dc22a946d$export$16b227cb15d716a0,
    numGlyphs: uint32,
    glyphCodeArray: new ArrayT(uint16, "numGlyphs")
  }
}), $9911c4c7201c13de$var$IndexSubtableArray = new Struct({
  firstGlyphIndex: uint16,
  lastGlyphIndex: uint16,
  subtable: new Pointer(uint32, $9911c4c7201c13de$var$IndexSubtable)
}), $9911c4c7201c13de$var$BitmapSizeTable = new Struct({
  indexSubTableArray: new Pointer(uint32, new ArrayT($9911c4c7201c13de$var$IndexSubtableArray, 1), {
    type: "parent"
  }),
  indexTablesSize: uint32,
  numberOfIndexSubTables: uint32,
  colorRef: uint32,
  hori: $9911c4c7201c13de$var$SBitLineMetrics,
  vert: $9911c4c7201c13de$var$SBitLineMetrics,
  startGlyphIndex: uint16,
  endGlyphIndex: uint16,
  ppemX: uint8,
  ppemY: uint8,
  bitDepth: uint8,
  flags: new Bitfield(uint8, [
    "horizontal",
    "vertical"
  ])
});
var $9911c4c7201c13de$export$2e2bcd8739ae039 = new Struct({
  version: uint32,
  numSizes: uint32,
  sizes: new ArrayT($9911c4c7201c13de$var$BitmapSizeTable, "numSizes")
});
let $abb847051efd51b1$var$ImageTable = new Struct({
  ppem: uint16,
  resolution: uint16,
  imageOffsets: new ArrayT(new Pointer(uint32, "void"), (a) => a.parent.parent.maxp.numGlyphs + 1)
});
var $abb847051efd51b1$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  flags: new Bitfield(uint16, [
    "renderOutlines"
  ]),
  numImgTables: uint32,
  imageTables: new ArrayT(new Pointer(uint32, $abb847051efd51b1$var$ImageTable), "numImgTables")
});
let $eb629188f3dfefdd$var$LayerRecord = new Struct({
  gid: uint16,
  paletteIndex: uint16
  // Index value to use in the appropriate palette. This value must
}), $eb629188f3dfefdd$var$BaseGlyphRecord = new Struct({
  gid: uint16,
  // and is not rendered for color.
  firstLayerIndex: uint16,
  // There will be numLayers consecutive entries for this base glyph.
  numLayers: uint16
});
var $eb629188f3dfefdd$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numBaseGlyphRecords: uint16,
  baseGlyphRecord: new Pointer(uint32, new ArrayT($eb629188f3dfefdd$var$BaseGlyphRecord, "numBaseGlyphRecords")),
  layerRecords: new Pointer(uint32, new ArrayT($eb629188f3dfefdd$var$LayerRecord, "numLayerRecords"), {
    lazy: !0
  }),
  numLayerRecords: uint16
});
let $08734b8e7dc64587$var$ColorRecord = new Struct({
  blue: uint8,
  green: uint8,
  red: uint8,
  alpha: uint8
});
var $08734b8e7dc64587$export$2e2bcd8739ae039 = new VersionedStruct(uint16, {
  header: {
    numPaletteEntries: uint16,
    numPalettes: uint16,
    numColorRecords: uint16,
    colorRecords: new Pointer(uint32, new ArrayT($08734b8e7dc64587$var$ColorRecord, "numColorRecords")),
    colorRecordIndices: new ArrayT(uint16, "numPalettes")
  },
  0: {},
  1: {
    offsetPaletteTypeArray: new Pointer(uint32, new ArrayT(uint32, "numPalettes")),
    offsetPaletteLabelArray: new Pointer(uint32, new ArrayT(uint16, "numPalettes")),
    offsetPaletteEntryLabelArray: new Pointer(uint32, new ArrayT(uint16, "numPaletteEntries"))
  }
});
let $497cef411d884e34$var$BaseCoord = new VersionedStruct(uint16, {
  1: {
    coordinate: int16
    // X or Y value, in design units
  },
  2: {
    coordinate: int16,
    referenceGlyph: uint16,
    baseCoordPoint: uint16
    // Index of contour point on the referenceGlyph
  },
  3: {
    coordinate: int16,
    deviceTable: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10)
    // Device table for X or Y value
  }
}), $497cef411d884e34$var$BaseValues = new Struct({
  defaultIndex: uint16,
  baseCoordCount: uint16,
  baseCoords: new ArrayT(new Pointer(uint16, $497cef411d884e34$var$BaseCoord), "baseCoordCount")
}), $497cef411d884e34$var$FeatMinMaxRecord = new Struct({
  tag: new StringT(4),
  minCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord, {
    type: "parent"
  }),
  maxCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord, {
    type: "parent"
  })
  // May be NULL
}), $497cef411d884e34$var$MinMax = new Struct({
  minCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord),
  maxCoord: new Pointer(uint16, $497cef411d884e34$var$BaseCoord),
  featMinMaxCount: uint16,
  featMinMaxRecords: new ArrayT($497cef411d884e34$var$FeatMinMaxRecord, "featMinMaxCount")
  // In alphabetical order
}), $497cef411d884e34$var$BaseLangSysRecord = new Struct({
  tag: new StringT(4),
  minMax: new Pointer(uint16, $497cef411d884e34$var$MinMax, {
    type: "parent"
  })
}), $497cef411d884e34$var$BaseScript = new Struct({
  baseValues: new Pointer(uint16, $497cef411d884e34$var$BaseValues),
  defaultMinMax: new Pointer(uint16, $497cef411d884e34$var$MinMax),
  baseLangSysCount: uint16,
  baseLangSysRecords: new ArrayT($497cef411d884e34$var$BaseLangSysRecord, "baseLangSysCount")
  // in alphabetical order by BaseLangSysTag
}), $497cef411d884e34$var$BaseScriptRecord = new Struct({
  tag: new StringT(4),
  script: new Pointer(uint16, $497cef411d884e34$var$BaseScript, {
    type: "parent"
  })
}), $497cef411d884e34$var$BaseScriptList = new ArrayT($497cef411d884e34$var$BaseScriptRecord, uint16), $497cef411d884e34$var$BaseTagList = new ArrayT(new StringT(4), uint16), $497cef411d884e34$var$Axis = new Struct({
  baseTagList: new Pointer(uint16, $497cef411d884e34$var$BaseTagList),
  baseScriptList: new Pointer(uint16, $497cef411d884e34$var$BaseScriptList)
});
var $497cef411d884e34$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    horizAxis: new Pointer(uint16, $497cef411d884e34$var$Axis),
    vertAxis: new Pointer(uint16, $497cef411d884e34$var$Axis)
    // May be NULL
  },
  65536: {},
  65537: {
    itemVariationStore: new Pointer(uint32, $1a47b0c45c1c22fe$export$fe1b122a2710f241)
  }
});
let $cf5f33c63ef209e6$var$AttachPoint = new ArrayT(uint16, uint16), $cf5f33c63ef209e6$var$AttachList = new Struct({
  coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
  glyphCount: uint16,
  attachPoints: new ArrayT(new Pointer(uint16, $cf5f33c63ef209e6$var$AttachPoint), "glyphCount")
}), $cf5f33c63ef209e6$var$CaretValue = new VersionedStruct(uint16, {
  1: {
    coordinate: int16
  },
  2: {
    caretValuePoint: uint16
  },
  3: {
    coordinate: int16,
    deviceTable: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10)
  }
}), $cf5f33c63ef209e6$var$LigGlyph = new ArrayT(new Pointer(uint16, $cf5f33c63ef209e6$var$CaretValue), uint16), $cf5f33c63ef209e6$var$LigCaretList = new Struct({
  coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
  ligGlyphCount: uint16,
  ligGlyphs: new ArrayT(new Pointer(uint16, $cf5f33c63ef209e6$var$LigGlyph), "ligGlyphCount")
}), $cf5f33c63ef209e6$var$MarkGlyphSetsDef = new Struct({
  markSetTableFormat: uint16,
  markSetCount: uint16,
  coverage: new ArrayT(new Pointer(uint32, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "markSetCount")
});
var $cf5f33c63ef209e6$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    glyphClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
    attachList: new Pointer(uint16, $cf5f33c63ef209e6$var$AttachList),
    ligCaretList: new Pointer(uint16, $cf5f33c63ef209e6$var$LigCaretList),
    markAttachClassDef: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71)
  },
  65536: {},
  65538: {
    markGlyphSetsDef: new Pointer(uint16, $cf5f33c63ef209e6$var$MarkGlyphSetsDef)
  },
  65539: {
    markGlyphSetsDef: new Pointer(uint16, $cf5f33c63ef209e6$var$MarkGlyphSetsDef),
    itemVariationStore: new Pointer(uint32, $1a47b0c45c1c22fe$export$fe1b122a2710f241)
  }
});
let $47e0e8ef515d9903$var$ValueFormat = new Bitfield(uint16, [
  "xPlacement",
  "yPlacement",
  "xAdvance",
  "yAdvance",
  "xPlaDevice",
  "yPlaDevice",
  "xAdvDevice",
  "yAdvDevice"
]), $47e0e8ef515d9903$var$types = {
  xPlacement: int16,
  yPlacement: int16,
  xAdvance: int16,
  yAdvance: int16,
  xPlaDevice: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
    type: "global",
    relativeTo: (a) => a.rel
  }),
  yPlaDevice: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
    type: "global",
    relativeTo: (a) => a.rel
  }),
  xAdvDevice: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
    type: "global",
    relativeTo: (a) => a.rel
  }),
  yAdvDevice: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10, {
    type: "global",
    relativeTo: (a) => a.rel
  })
};
class $47e0e8ef515d9903$var$ValueRecord {
  buildStruct(s) {
    let $ = s;
    for (; !$[this.key] && $.parent; )
      $ = $.parent;
    if (!$[this.key])
      return;
    let _ = {};
    _.rel = () => $._startOffset;
    let _e = $[this.key];
    for (let tt in _e)
      _e[tt] && (_[tt] = $47e0e8ef515d9903$var$types[tt]);
    return new Struct(_);
  }
  size(s, $) {
    return this.buildStruct($).size(s, $);
  }
  decode(s, $) {
    let _ = this.buildStruct($).decode(s, $);
    return delete _.rel, _;
  }
  constructor(s = "valueFormat") {
    this.key = s;
  }
}
let $47e0e8ef515d9903$var$PairValueRecord = new Struct({
  secondGlyph: uint16,
  value1: new $47e0e8ef515d9903$var$ValueRecord("valueFormat1"),
  value2: new $47e0e8ef515d9903$var$ValueRecord("valueFormat2")
}), $47e0e8ef515d9903$var$PairSet = new ArrayT($47e0e8ef515d9903$var$PairValueRecord, uint16), $47e0e8ef515d9903$var$Class2Record = new Struct({
  value1: new $47e0e8ef515d9903$var$ValueRecord("valueFormat1"),
  value2: new $47e0e8ef515d9903$var$ValueRecord("valueFormat2")
}), $47e0e8ef515d9903$var$Anchor = new VersionedStruct(uint16, {
  1: {
    xCoordinate: int16,
    yCoordinate: int16
  },
  2: {
    xCoordinate: int16,
    yCoordinate: int16,
    anchorPoint: uint16
  },
  3: {
    xCoordinate: int16,
    yCoordinate: int16,
    xDeviceTable: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10),
    yDeviceTable: new Pointer(uint16, $7cbbe4e24ef3cb75$export$8215d14a63d9fb10)
  }
}), $47e0e8ef515d9903$var$EntryExitRecord = new Struct({
  entryAnchor: new Pointer(uint16, $47e0e8ef515d9903$var$Anchor, {
    type: "parent"
  }),
  exitAnchor: new Pointer(uint16, $47e0e8ef515d9903$var$Anchor, {
    type: "parent"
  })
}), $47e0e8ef515d9903$var$MarkRecord = new Struct({
  class: uint16,
  markAnchor: new Pointer(uint16, $47e0e8ef515d9903$var$Anchor, {
    type: "parent"
  })
}), $47e0e8ef515d9903$var$MarkArray = new ArrayT($47e0e8ef515d9903$var$MarkRecord, uint16), $47e0e8ef515d9903$var$BaseRecord = new ArrayT(new Pointer(uint16, $47e0e8ef515d9903$var$Anchor), (a) => a.parent.classCount), $47e0e8ef515d9903$var$BaseArray = new ArrayT($47e0e8ef515d9903$var$BaseRecord, uint16), $47e0e8ef515d9903$var$ComponentRecord = new ArrayT(new Pointer(uint16, $47e0e8ef515d9903$var$Anchor), (a) => a.parent.parent.classCount), $47e0e8ef515d9903$var$LigatureAttach = new ArrayT($47e0e8ef515d9903$var$ComponentRecord, uint16), $47e0e8ef515d9903$var$LigatureArray = new ArrayT(new Pointer(uint16, $47e0e8ef515d9903$var$LigatureAttach), uint16), $47e0e8ef515d9903$export$73a8cfb19cd43a0f = new VersionedStruct("lookupType", {
  1: new VersionedStruct(uint16, {
    1: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      valueFormat: $47e0e8ef515d9903$var$ValueFormat,
      value: new $47e0e8ef515d9903$var$ValueRecord()
    },
    2: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      valueFormat: $47e0e8ef515d9903$var$ValueFormat,
      valueCount: uint16,
      values: new LazyArray(new $47e0e8ef515d9903$var$ValueRecord(), "valueCount")
    }
  }),
  2: new VersionedStruct(uint16, {
    1: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      valueFormat1: $47e0e8ef515d9903$var$ValueFormat,
      valueFormat2: $47e0e8ef515d9903$var$ValueFormat,
      pairSetCount: uint16,
      pairSets: new LazyArray(new Pointer(uint16, $47e0e8ef515d9903$var$PairSet), "pairSetCount")
    },
    2: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      valueFormat1: $47e0e8ef515d9903$var$ValueFormat,
      valueFormat2: $47e0e8ef515d9903$var$ValueFormat,
      classDef1: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
      classDef2: new Pointer(uint16, $7cbbe4e24ef3cb75$export$843d551fbbafef71),
      class1Count: uint16,
      class2Count: uint16,
      classRecords: new LazyArray(new LazyArray($47e0e8ef515d9903$var$Class2Record, "class2Count"), "class1Count")
    }
  }),
  3: {
    format: uint16,
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    entryExitCount: uint16,
    entryExitRecords: new ArrayT($47e0e8ef515d9903$var$EntryExitRecord, "entryExitCount")
  },
  4: {
    format: uint16,
    markCoverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    baseCoverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    classCount: uint16,
    markArray: new Pointer(uint16, $47e0e8ef515d9903$var$MarkArray),
    baseArray: new Pointer(uint16, $47e0e8ef515d9903$var$BaseArray)
  },
  5: {
    format: uint16,
    markCoverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    ligatureCoverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    classCount: uint16,
    markArray: new Pointer(uint16, $47e0e8ef515d9903$var$MarkArray),
    ligatureArray: new Pointer(uint16, $47e0e8ef515d9903$var$LigatureArray)
  },
  6: {
    format: uint16,
    mark1Coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    mark2Coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    classCount: uint16,
    mark1Array: new Pointer(uint16, $47e0e8ef515d9903$var$MarkArray),
    mark2Array: new Pointer(uint16, $47e0e8ef515d9903$var$BaseArray)
  },
  7: $7cbbe4e24ef3cb75$export$841858b892ce1f4c,
  8: $7cbbe4e24ef3cb75$export$5e6d09e6861162f6,
  9: {
    posFormat: uint16,
    lookupType: uint16,
    extension: new Pointer(uint32, null)
  }
});
$47e0e8ef515d9903$export$73a8cfb19cd43a0f.versions[9].extension.type = $47e0e8ef515d9903$export$73a8cfb19cd43a0f;
var $47e0e8ef515d9903$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    scriptList: new Pointer(uint16, $7cbbe4e24ef3cb75$export$3e15fc05ce864229),
    featureList: new Pointer(uint16, $7cbbe4e24ef3cb75$export$aa18130def4b6cb4),
    lookupList: new Pointer(uint16, new $7cbbe4e24ef3cb75$export$df0008c6ff2da22a($47e0e8ef515d9903$export$73a8cfb19cd43a0f))
  },
  65536: {},
  65537: {
    featureVariations: new Pointer(uint32, $1a47b0c45c1c22fe$export$441b70b7971dd419)
  }
});
let $d3f442064af66e06$var$Sequence = new ArrayT(uint16, uint16), $d3f442064af66e06$var$AlternateSet = $d3f442064af66e06$var$Sequence, $d3f442064af66e06$var$Ligature = new Struct({
  glyph: uint16,
  compCount: uint16,
  components: new ArrayT(uint16, (a) => a.compCount - 1)
}), $d3f442064af66e06$var$LigatureSet = new ArrayT(new Pointer(uint16, $d3f442064af66e06$var$Ligature), uint16), $d3f442064af66e06$var$GSUBLookup = new VersionedStruct("lookupType", {
  1: new VersionedStruct(uint16, {
    1: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      deltaGlyphID: int16
    },
    2: {
      coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
      glyphCount: uint16,
      substitute: new LazyArray(uint16, "glyphCount")
    }
  }),
  2: {
    substFormat: uint16,
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    count: uint16,
    sequences: new LazyArray(new Pointer(uint16, $d3f442064af66e06$var$Sequence), "count")
  },
  3: {
    substFormat: uint16,
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    count: uint16,
    alternateSet: new LazyArray(new Pointer(uint16, $d3f442064af66e06$var$AlternateSet), "count")
  },
  4: {
    substFormat: uint16,
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    count: uint16,
    ligatureSets: new LazyArray(new Pointer(uint16, $d3f442064af66e06$var$LigatureSet), "count")
  },
  5: $7cbbe4e24ef3cb75$export$841858b892ce1f4c,
  6: $7cbbe4e24ef3cb75$export$5e6d09e6861162f6,
  7: {
    substFormat: uint16,
    lookupType: uint16,
    extension: new Pointer(uint32, null)
  },
  8: {
    substFormat: uint16,
    coverage: new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111),
    backtrackCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "backtrackGlyphCount"),
    lookaheadGlyphCount: uint16,
    lookaheadCoverage: new ArrayT(new Pointer(uint16, $7cbbe4e24ef3cb75$export$17608c3f81a6111), "lookaheadGlyphCount"),
    glyphCount: uint16,
    substitutes: new ArrayT(uint16, "glyphCount")
  }
});
$d3f442064af66e06$var$GSUBLookup.versions[7].extension.type = $d3f442064af66e06$var$GSUBLookup;
var $d3f442064af66e06$export$2e2bcd8739ae039 = new VersionedStruct(uint32, {
  header: {
    scriptList: new Pointer(uint16, $7cbbe4e24ef3cb75$export$3e15fc05ce864229),
    featureList: new Pointer(uint16, $7cbbe4e24ef3cb75$export$aa18130def4b6cb4),
    lookupList: new Pointer(uint16, new $7cbbe4e24ef3cb75$export$df0008c6ff2da22a($d3f442064af66e06$var$GSUBLookup))
  },
  65536: {},
  65537: {
    featureVariations: new Pointer(uint32, $1a47b0c45c1c22fe$export$441b70b7971dd419)
  }
});
let $71cfb3c4767fbd0c$var$JstfGSUBModList = new ArrayT(uint16, uint16), $71cfb3c4767fbd0c$var$JstfPriority = new Struct({
  shrinkageEnableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageDisableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageEnableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageDisableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  shrinkageJstfMax: new Pointer(uint16, new $7cbbe4e24ef3cb75$export$df0008c6ff2da22a($47e0e8ef515d9903$export$73a8cfb19cd43a0f)),
  extensionEnableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionDisableGSUB: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionEnableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionDisableGPOS: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfGSUBModList),
  extensionJstfMax: new Pointer(uint16, new $7cbbe4e24ef3cb75$export$df0008c6ff2da22a($47e0e8ef515d9903$export$73a8cfb19cd43a0f))
}), $71cfb3c4767fbd0c$var$JstfLangSys = new ArrayT(new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfPriority), uint16), $71cfb3c4767fbd0c$var$JstfLangSysRecord = new Struct({
  tag: new StringT(4),
  jstfLangSys: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfLangSys)
}), $71cfb3c4767fbd0c$var$JstfScript = new Struct({
  extenderGlyphs: new Pointer(uint16, new ArrayT(uint16, uint16)),
  defaultLangSys: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfLangSys),
  langSysCount: uint16,
  langSysRecords: new ArrayT($71cfb3c4767fbd0c$var$JstfLangSysRecord, "langSysCount")
}), $71cfb3c4767fbd0c$var$JstfScriptRecord = new Struct({
  tag: new StringT(4),
  script: new Pointer(uint16, $71cfb3c4767fbd0c$var$JstfScript, {
    type: "parent"
  })
});
var $71cfb3c4767fbd0c$export$2e2bcd8739ae039 = new Struct({
  version: uint32,
  scriptCount: uint16,
  scriptList: new ArrayT($71cfb3c4767fbd0c$var$JstfScriptRecord, "scriptCount")
});
class $d059a6bd2d3b5b63$var$VariableSizeNumber {
  decode(s, $) {
    switch (this.size(0, $)) {
      case 1:
        return s.readUInt8();
      case 2:
        return s.readUInt16BE();
      case 3:
        return s.readUInt24BE();
      case 4:
        return s.readUInt32BE();
    }
  }
  size(s, $) {
    return resolveLength(this._size, null, $);
  }
  constructor(s) {
    this._size = s;
  }
}
let $d059a6bd2d3b5b63$var$MapDataEntry = new Struct({
  entry: new $d059a6bd2d3b5b63$var$VariableSizeNumber((a) => ((a.parent.entryFormat & 48) >> 4) + 1),
  outerIndex: (a) => a.entry >> (a.parent.entryFormat & 15) + 1,
  innerIndex: (a) => a.entry & (1 << (a.parent.entryFormat & 15) + 1) - 1
}), $d059a6bd2d3b5b63$var$DeltaSetIndexMap = new Struct({
  entryFormat: uint16,
  mapCount: uint16,
  mapData: new ArrayT($d059a6bd2d3b5b63$var$MapDataEntry, "mapCount")
});
var $d059a6bd2d3b5b63$export$2e2bcd8739ae039 = new Struct({
  majorVersion: uint16,
  minorVersion: uint16,
  itemVariationStore: new Pointer(uint32, $1a47b0c45c1c22fe$export$fe1b122a2710f241),
  advanceWidthMapping: new Pointer(uint32, $d059a6bd2d3b5b63$var$DeltaSetIndexMap),
  LSBMapping: new Pointer(uint32, $d059a6bd2d3b5b63$var$DeltaSetIndexMap),
  RSBMapping: new Pointer(uint32, $d059a6bd2d3b5b63$var$DeltaSetIndexMap)
});
let $dceeca3e1977ce30$var$Signature = new Struct({
  format: uint32,
  length: uint32,
  offset: uint32
}), $dceeca3e1977ce30$var$SignatureBlock = new Struct({
  reserved: new Reserved(uint16, 2),
  cbSignature: uint32,
  signature: new BufferT("cbSignature")
});
var $dceeca3e1977ce30$export$2e2bcd8739ae039 = new Struct({
  ulVersion: uint32,
  usNumSigs: uint16,
  usFlag: uint16,
  signatures: new ArrayT($dceeca3e1977ce30$var$Signature, "usNumSigs"),
  signatureBlocks: new ArrayT($dceeca3e1977ce30$var$SignatureBlock, "usNumSigs")
});
let $8acd740a9435aad0$var$GaspRange = new Struct({
  rangeMaxPPEM: uint16,
  rangeGaspBehavior: new Bitfield(uint16, [
    "grayscale",
    "gridfit",
    "symmetricSmoothing",
    "symmetricGridfit"
    // only in version 1, for ClearType
  ])
});
var $8acd740a9435aad0$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numRanges: uint16,
  gaspRanges: new ArrayT($8acd740a9435aad0$var$GaspRange, "numRanges")
  // Sorted by ppem
});
let $b5f380243c34d6a0$var$DeviceRecord = new Struct({
  pixelSize: uint8,
  maximumWidth: uint8,
  widths: new ArrayT(uint8, (a) => a.parent.parent.maxp.numGlyphs)
});
var $b5f380243c34d6a0$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numRecords: int16,
  sizeDeviceRecord: int32,
  records: new ArrayT($b5f380243c34d6a0$var$DeviceRecord, "numRecords")
});
let $ca2df1256966e313$var$KernPair = new Struct({
  left: uint16,
  right: uint16,
  value: int16
}), $ca2df1256966e313$var$ClassTable = new Struct({
  firstGlyph: uint16,
  nGlyphs: uint16,
  offsets: new ArrayT(uint16, "nGlyphs"),
  max: (a) => a.offsets.length && Math.max.apply(Math, a.offsets)
}), $ca2df1256966e313$var$Kern2Array = new Struct({
  off: (a) => a._startOffset - a.parent.parent._startOffset,
  len: (a) => ((a.parent.leftTable.max - a.off) / a.parent.rowWidth + 1) * (a.parent.rowWidth / 2),
  values: new LazyArray(int16, "len")
}), $ca2df1256966e313$var$KernSubtable = new VersionedStruct("format", {
  0: {
    nPairs: uint16,
    searchRange: uint16,
    entrySelector: uint16,
    rangeShift: uint16,
    pairs: new ArrayT($ca2df1256966e313$var$KernPair, "nPairs")
  },
  2: {
    rowWidth: uint16,
    leftTable: new Pointer(uint16, $ca2df1256966e313$var$ClassTable, {
      type: "parent"
    }),
    rightTable: new Pointer(uint16, $ca2df1256966e313$var$ClassTable, {
      type: "parent"
    }),
    array: new Pointer(uint16, $ca2df1256966e313$var$Kern2Array, {
      type: "parent"
    })
  },
  3: {
    glyphCount: uint16,
    kernValueCount: uint8,
    leftClassCount: uint8,
    rightClassCount: uint8,
    flags: uint8,
    kernValue: new ArrayT(int16, "kernValueCount"),
    leftClass: new ArrayT(uint8, "glyphCount"),
    rightClass: new ArrayT(uint8, "glyphCount"),
    kernIndex: new ArrayT(uint8, (a) => a.leftClassCount * a.rightClassCount)
  }
}), $ca2df1256966e313$var$KernTable = new VersionedStruct("version", {
  0: {
    subVersion: uint16,
    length: uint16,
    format: uint8,
    coverage: new Bitfield(uint8, [
      "horizontal",
      "minimum",
      "crossStream",
      "override"
      // If set to 1 the value in this table replaces the accumulated value
    ]),
    subtable: $ca2df1256966e313$var$KernSubtable,
    padding: new Reserved(uint8, (a) => a.length - a._currentOffset)
  },
  1: {
    length: uint32,
    coverage: new Bitfield(uint8, [
      null,
      null,
      null,
      null,
      null,
      "variation",
      "crossStream",
      "vertical"
      // Set if table has vertical kerning values
    ]),
    format: uint8,
    tupleIndex: uint16,
    subtable: $ca2df1256966e313$var$KernSubtable,
    padding: new Reserved(uint8, (a) => a.length - a._currentOffset)
  }
});
var $ca2df1256966e313$export$2e2bcd8739ae039 = new VersionedStruct(uint16, {
  0: {
    nTables: uint16,
    tables: new ArrayT($ca2df1256966e313$var$KernTable, "nTables")
  },
  1: {
    reserved: new Reserved(uint16),
    nTables: uint32,
    tables: new ArrayT($ca2df1256966e313$var$KernTable, "nTables")
  }
}), $7a9f92b0c46ebe33$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numGlyphs: uint16,
  yPels: new ArrayT(uint8, "numGlyphs")
}), $2b2ccc419d152631$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  fontNumber: uint32,
  pitch: uint16,
  xHeight: uint16,
  style: uint16,
  typeFamily: uint16,
  capHeight: uint16,
  symbolSet: uint16,
  typeface: new StringT(16),
  characterComplement: new StringT(8),
  fileName: new StringT(6),
  strokeWeight: new StringT(1),
  widthType: new StringT(1),
  serifStyle: uint8,
  reserved: new Reserved(uint8)
});
let $ca5b40b9bcda9c9b$var$Ratio = new Struct({
  bCharSet: uint8,
  xRatio: uint8,
  yStartRatio: uint8,
  yEndRatio: uint8
  // Ending y-Ratio value
}), $ca5b40b9bcda9c9b$var$vTable = new Struct({
  yPelHeight: uint16,
  yMax: int16,
  yMin: int16
  // Minimum value (in pels) for this yPelHeight
}), $ca5b40b9bcda9c9b$var$VdmxGroup = new Struct({
  recs: uint16,
  startsz: uint8,
  endsz: uint8,
  entries: new ArrayT($ca5b40b9bcda9c9b$var$vTable, "recs")
  // The VDMX records
});
var $ca5b40b9bcda9c9b$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  numRecs: uint16,
  numRatios: uint16,
  ratioRanges: new ArrayT($ca5b40b9bcda9c9b$var$Ratio, "numRatios"),
  offsets: new ArrayT(uint16, "numRatios"),
  groups: new ArrayT($ca5b40b9bcda9c9b$var$VdmxGroup, "numRecs")
  // The actual VDMX groupings
}), $69530a3c40755af0$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  ascent: int16,
  descent: int16,
  lineGap: int16,
  advanceHeightMax: int16,
  minTopSideBearing: int16,
  minBottomSideBearing: int16,
  yMaxExtent: int16,
  caretSlopeRise: int16,
  caretSlopeRun: int16,
  caretOffset: int16,
  reserved: new Reserved(int16, 4),
  metricDataFormat: int16,
  numberOfMetrics: uint16
  // Number of advance heights in the Vertical Metrics table
});
let $344073dd270f0e62$var$VmtxEntry = new Struct({
  advance: uint16,
  bearing: int16
  // The top sidebearing of the glyph
});
var $344073dd270f0e62$export$2e2bcd8739ae039 = new Struct({
  metrics: new LazyArray($344073dd270f0e62$var$VmtxEntry, (a) => a.parent.vhea.numberOfMetrics),
  bearings: new LazyArray(int16, (a) => a.parent.maxp.numGlyphs - a.parent.vhea.numberOfMetrics)
});
let $3793b781918cfced$var$shortFrac = new Fixed(16, "BE", 14), $3793b781918cfced$var$Correspondence = new Struct({
  fromCoord: $3793b781918cfced$var$shortFrac,
  toCoord: $3793b781918cfced$var$shortFrac
}), $3793b781918cfced$var$Segment = new Struct({
  pairCount: uint16,
  correspondence: new ArrayT($3793b781918cfced$var$Correspondence, "pairCount")
});
var $3793b781918cfced$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  axisCount: uint32,
  segment: new ArrayT($3793b781918cfced$var$Segment, "axisCount")
});
class $6cb7dd5f47d82580$var$UnboundedArrayAccessor {
  getItem(s) {
    if (this._items[s] == null) {
      let $ = this.stream.pos;
      this.stream.pos = this.base + this.type.size(null, this.parent) * s, this._items[s] = this.type.decode(this.stream, this.parent), this.stream.pos = $;
    }
    return this._items[s];
  }
  inspect() {
    return `[UnboundedArray ${this.type.constructor.name}]`;
  }
  constructor(s, $, _) {
    this.type = s, this.stream = $, this.parent = _, this.base = this.stream.pos, this._items = [];
  }
}
class $6cb7dd5f47d82580$export$c5af1eebc882e39a extends ArrayT {
  decode(s, $) {
    return new $6cb7dd5f47d82580$var$UnboundedArrayAccessor(this.type, s, $);
  }
  constructor(s) {
    super(s, 0);
  }
}
let $6cb7dd5f47d82580$export$8351f8c2ae2f103c = function(a = uint16) {
  class s {
    decode(at, ot) {
      return ot = ot.parent.parent, this.type.decode(at, ot);
    }
    size(at, ot) {
      return ot = ot.parent.parent, this.type.size(at, ot);
    }
    encode(at, ot, rt) {
      return rt = rt.parent.parent, this.type.encode(at, ot, rt);
    }
    constructor(at) {
      this.type = at;
    }
  }
  a = new s(a);
  let $ = new Struct({
    unitSize: uint16,
    nUnits: uint16,
    searchRange: uint16,
    entrySelector: uint16,
    rangeShift: uint16
  }), _ = new Struct({
    lastGlyph: uint16,
    firstGlyph: uint16,
    value: a
  }), _e = new Struct({
    lastGlyph: uint16,
    firstGlyph: uint16,
    values: new Pointer(uint16, new ArrayT(a, (nt) => nt.lastGlyph - nt.firstGlyph + 1), {
      type: "parent"
    })
  }), tt = new Struct({
    glyph: uint16,
    value: a
  });
  return new VersionedStruct(uint16, {
    0: {
      values: new $6cb7dd5f47d82580$export$c5af1eebc882e39a(a)
      // length == number of glyphs maybe?
    },
    2: {
      binarySearchHeader: $,
      segments: new ArrayT(_, (nt) => nt.binarySearchHeader.nUnits)
    },
    4: {
      binarySearchHeader: $,
      segments: new ArrayT(_e, (nt) => nt.binarySearchHeader.nUnits)
    },
    6: {
      binarySearchHeader: $,
      segments: new ArrayT(tt, (nt) => nt.binarySearchHeader.nUnits)
    },
    8: {
      firstGlyph: uint16,
      count: uint16,
      values: new ArrayT(a, "count")
    }
  });
};
function $6cb7dd5f47d82580$export$79f7d93d790934ba(a = {}, s = uint16) {
  let $ = Object.assign({
    newState: uint16,
    flags: uint16
  }, a), _ = new Struct($), _e = new $6cb7dd5f47d82580$export$c5af1eebc882e39a(new ArrayT(uint16, (nt) => nt.nClasses));
  return new Struct({
    nClasses: uint32,
    classTable: new Pointer(uint32, new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(s)),
    stateArray: new Pointer(uint32, _e),
    entryTable: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(_))
  });
}
function $6cb7dd5f47d82580$export$105027425199cc51(a = {}, s = uint16) {
  let $ = new Struct({
    version() {
      return 8;
    },
    firstGlyph: uint16,
    values: new ArrayT(uint8, uint16)
  }), _ = Object.assign({
    newStateOffset: uint16,
    // convert offset to stateArray index
    newState: (at) => (at.newStateOffset - (at.parent.stateArray.base - at.parent._startOffset)) / at.parent.nClasses,
    flags: uint16
  }, a), _e = new Struct(_), tt = new $6cb7dd5f47d82580$export$c5af1eebc882e39a(new ArrayT(uint8, (at) => at.nClasses));
  return new Struct({
    nClasses: uint16,
    classTable: new Pointer(uint16, $),
    stateArray: new Pointer(uint16, tt),
    entryTable: new Pointer(uint16, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(_e))
  });
}
let $6a3746e8c708f5a3$var$BslnSubtable = new VersionedStruct("format", {
  0: {
    deltas: new ArrayT(int16, 32)
  },
  1: {
    deltas: new ArrayT(int16, 32),
    mappingData: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(uint16)
  },
  2: {
    standardGlyph: uint16,
    controlPoints: new ArrayT(uint16, 32)
  },
  3: {
    standardGlyph: uint16,
    controlPoints: new ArrayT(uint16, 32),
    mappingData: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(uint16)
  }
});
var $6a3746e8c708f5a3$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  format: uint16,
  defaultBaseline: uint16,
  subtable: $6a3746e8c708f5a3$var$BslnSubtable
});
let $d0c76fac617b308a$var$Setting = new Struct({
  setting: uint16,
  nameIndex: int16,
  name: (a) => a.parent.parent.parent.name.records.fontFeatures[a.nameIndex]
}), $d0c76fac617b308a$var$FeatureName = new Struct({
  feature: uint16,
  nSettings: uint16,
  settingTable: new Pointer(uint32, new ArrayT($d0c76fac617b308a$var$Setting, "nSettings"), {
    type: "parent"
  }),
  featureFlags: new Bitfield(uint8, [
    null,
    null,
    null,
    null,
    null,
    null,
    "hasDefault",
    "exclusive"
  ]),
  defaultSetting: uint8,
  nameIndex: int16,
  name: (a) => a.parent.parent.name.records.fontFeatures[a.nameIndex]
});
var $d0c76fac617b308a$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  featureNameCount: uint16,
  reserved1: new Reserved(uint16),
  reserved2: new Reserved(uint32),
  featureNames: new ArrayT($d0c76fac617b308a$var$FeatureName, "featureNameCount")
});
let $e83fd065f00fcd01$var$Axis = new Struct({
  axisTag: new StringT(4),
  minValue: fixed32,
  defaultValue: fixed32,
  maxValue: fixed32,
  flags: uint16,
  nameID: uint16,
  name: (a) => a.parent.parent.name.records.fontFeatures[a.nameID]
}), $e83fd065f00fcd01$var$Instance = new Struct({
  nameID: uint16,
  name: (a) => a.parent.parent.name.records.fontFeatures[a.nameID],
  flags: uint16,
  coord: new ArrayT(fixed32, (a) => a.parent.axisCount),
  postscriptNameID: new Optional(uint16, (a) => a.parent.instanceSize - a._currentOffset > 0)
});
var $e83fd065f00fcd01$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  offsetToData: uint16,
  countSizePairs: uint16,
  axisCount: uint16,
  axisSize: uint16,
  instanceCount: uint16,
  instanceSize: uint16,
  axis: new ArrayT($e83fd065f00fcd01$var$Axis, "axisCount"),
  instance: new ArrayT($e83fd065f00fcd01$var$Instance, "instanceCount")
});
let $dbe33c8d3a7f131c$var$shortFrac = new Fixed(16, "BE", 14);
class $dbe33c8d3a7f131c$var$Offset {
  static decode(s, $) {
    return $.flags ? s.readUInt32BE() : s.readUInt16BE() * 2;
  }
}
let $dbe33c8d3a7f131c$var$gvar = new Struct({
  version: uint16,
  reserved: new Reserved(uint16),
  axisCount: uint16,
  globalCoordCount: uint16,
  globalCoords: new Pointer(uint32, new ArrayT(new ArrayT($dbe33c8d3a7f131c$var$shortFrac, "axisCount"), "globalCoordCount")),
  glyphCount: uint16,
  flags: uint16,
  offsetToData: uint32,
  offsets: new ArrayT(new Pointer($dbe33c8d3a7f131c$var$Offset, "void", {
    relativeTo: (a) => a.offsetToData,
    allowNull: !1
  }), (a) => a.glyphCount + 1)
});
var $dbe33c8d3a7f131c$export$2e2bcd8739ae039 = $dbe33c8d3a7f131c$var$gvar;
let $05b01887df96c4ee$var$ClassTable = new Struct({
  length: uint16,
  coverage: uint16,
  subFeatureFlags: uint32,
  stateTable: new $6cb7dd5f47d82580$export$105027425199cc51()
}), $05b01887df96c4ee$var$WidthDeltaRecord = new Struct({
  justClass: uint32,
  beforeGrowLimit: fixed32,
  beforeShrinkLimit: fixed32,
  afterGrowLimit: fixed32,
  afterShrinkLimit: fixed32,
  growFlags: uint16,
  shrinkFlags: uint16
}), $05b01887df96c4ee$var$WidthDeltaCluster = new ArrayT($05b01887df96c4ee$var$WidthDeltaRecord, uint32), $05b01887df96c4ee$var$ActionData = new VersionedStruct("actionType", {
  0: {
    lowerLimit: fixed32,
    upperLimit: fixed32,
    order: uint16,
    glyphs: new ArrayT(uint16, uint16)
  },
  1: {
    addGlyph: uint16
  },
  2: {
    substThreshold: fixed32,
    addGlyph: uint16,
    substGlyph: uint16
  },
  3: {},
  4: {
    variationAxis: uint32,
    minimumLimit: fixed32,
    noStretchValue: fixed32,
    maximumLimit: fixed32
  },
  5: {
    flags: uint16,
    glyph: uint16
  }
}), $05b01887df96c4ee$var$Action = new Struct({
  actionClass: uint16,
  actionType: uint16,
  actionLength: uint32,
  actionData: $05b01887df96c4ee$var$ActionData,
  padding: new Reserved(uint8, (a) => a.actionLength - a._currentOffset)
}), $05b01887df96c4ee$var$PostcompensationAction = new ArrayT($05b01887df96c4ee$var$Action, uint32), $05b01887df96c4ee$var$PostCompensationTable = new Struct({
  lookupTable: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(new Pointer(uint16, $05b01887df96c4ee$var$PostcompensationAction))
}), $05b01887df96c4ee$var$JustificationTable = new Struct({
  classTable: new Pointer(uint16, $05b01887df96c4ee$var$ClassTable, {
    type: "parent"
  }),
  wdcOffset: uint16,
  postCompensationTable: new Pointer(uint16, $05b01887df96c4ee$var$PostCompensationTable, {
    type: "parent"
  }),
  widthDeltaClusters: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c(new Pointer(uint16, $05b01887df96c4ee$var$WidthDeltaCluster, {
    type: "parent",
    relativeTo: (a) => a.wdcOffset
  }))
});
var $05b01887df96c4ee$export$2e2bcd8739ae039 = new Struct({
  version: uint32,
  format: uint16,
  horizontal: new Pointer(uint16, $05b01887df96c4ee$var$JustificationTable),
  vertical: new Pointer(uint16, $05b01887df96c4ee$var$JustificationTable)
});
let $03ee6ebd54db1053$var$LigatureData = {
  action: uint16
}, $03ee6ebd54db1053$var$ContextualData = {
  markIndex: uint16,
  currentIndex: uint16
}, $03ee6ebd54db1053$var$InsertionData = {
  currentInsertIndex: uint16,
  markedInsertIndex: uint16
}, $03ee6ebd54db1053$var$SubstitutionTable = new Struct({
  items: new $6cb7dd5f47d82580$export$c5af1eebc882e39a(new Pointer(uint32, new $6cb7dd5f47d82580$export$8351f8c2ae2f103c()))
}), $03ee6ebd54db1053$var$SubtableData = new VersionedStruct("type", {
  0: {
    stateTable: new $6cb7dd5f47d82580$export$79f7d93d790934ba()
  },
  1: {
    stateTable: new $6cb7dd5f47d82580$export$79f7d93d790934ba($03ee6ebd54db1053$var$ContextualData),
    substitutionTable: new Pointer(uint32, $03ee6ebd54db1053$var$SubstitutionTable)
  },
  2: {
    stateTable: new $6cb7dd5f47d82580$export$79f7d93d790934ba($03ee6ebd54db1053$var$LigatureData),
    ligatureActions: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(uint32)),
    components: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(uint16)),
    ligatureList: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(uint16))
  },
  4: {
    lookupTable: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c()
  },
  5: {
    stateTable: new $6cb7dd5f47d82580$export$79f7d93d790934ba($03ee6ebd54db1053$var$InsertionData),
    insertionActions: new Pointer(uint32, new $6cb7dd5f47d82580$export$c5af1eebc882e39a(uint16))
  }
}), $03ee6ebd54db1053$var$Subtable = new Struct({
  length: uint32,
  coverage: uint24,
  type: uint8,
  subFeatureFlags: uint32,
  table: $03ee6ebd54db1053$var$SubtableData,
  padding: new Reserved(uint8, (a) => a.length - a._currentOffset)
}), $03ee6ebd54db1053$var$FeatureEntry = new Struct({
  featureType: uint16,
  featureSetting: uint16,
  enableFlags: uint32,
  disableFlags: uint32
}), $03ee6ebd54db1053$var$MorxChain = new Struct({
  defaultFlags: uint32,
  chainLength: uint32,
  nFeatureEntries: uint32,
  nSubtables: uint32,
  features: new ArrayT($03ee6ebd54db1053$var$FeatureEntry, "nFeatureEntries"),
  subtables: new ArrayT($03ee6ebd54db1053$var$Subtable, "nSubtables")
});
var $03ee6ebd54db1053$export$2e2bcd8739ae039 = new Struct({
  version: uint16,
  unused: new Reserved(uint16),
  nChains: uint32,
  chains: new ArrayT($03ee6ebd54db1053$var$MorxChain, "nChains")
});
let $b7492a80b0d1a056$var$OpticalBounds = new Struct({
  left: int16,
  top: int16,
  right: int16,
  bottom: int16
});
var $b7492a80b0d1a056$export$2e2bcd8739ae039 = new Struct({
  version: fixed32,
  format: uint16,
  lookupTable: new $6cb7dd5f47d82580$export$8351f8c2ae2f103c($b7492a80b0d1a056$var$OpticalBounds)
});
let $c3395722bea751e2$var$tables = {};
var $c3395722bea751e2$export$2e2bcd8739ae039 = $c3395722bea751e2$var$tables;
$c3395722bea751e2$var$tables.cmap = $26a62205ad06574e$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.head = $f2612a29f92ac062$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.hhea = $2c179dd593583073$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.hmtx = $bdc9060542264b85$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.maxp = $dbf51cb3d3fe409d$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.name = $2bcf221753ec8e32$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables["OS/2"] = $84b272aa31b70606$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.post = $32d9e2eb9565d93c$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.fpgm = $5c0f37ca5ffb1850$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.loca = $2b2b260902b1c57e$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.prep = $7afb878c7bea4f66$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables["cvt "] = $5202bd9d9ad8eaac$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.glyf = $6c92b6371bce8bd9$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables["CFF "] = $822ac0d589e4e237$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.CFF2 = $822ac0d589e4e237$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.VORG = $2bbf2bc1ce37cd8f$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.EBLC = $9911c4c7201c13de$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.CBLC = $c3395722bea751e2$var$tables.EBLC;
$c3395722bea751e2$var$tables.sbix = $abb847051efd51b1$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.COLR = $eb629188f3dfefdd$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.CPAL = $08734b8e7dc64587$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.BASE = $497cef411d884e34$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.GDEF = $cf5f33c63ef209e6$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.GPOS = $47e0e8ef515d9903$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.GSUB = $d3f442064af66e06$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.JSTF = $71cfb3c4767fbd0c$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.HVAR = $d059a6bd2d3b5b63$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.DSIG = $dceeca3e1977ce30$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.gasp = $8acd740a9435aad0$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.hdmx = $b5f380243c34d6a0$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.kern = $ca2df1256966e313$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.LTSH = $7a9f92b0c46ebe33$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.PCLT = $2b2ccc419d152631$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.VDMX = $ca5b40b9bcda9c9b$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.vhea = $69530a3c40755af0$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.vmtx = $344073dd270f0e62$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.avar = $3793b781918cfced$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.bsln = $6a3746e8c708f5a3$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.feat = $d0c76fac617b308a$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.fvar = $e83fd065f00fcd01$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.gvar = $dbe33c8d3a7f131c$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.just = $05b01887df96c4ee$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.morx = $03ee6ebd54db1053$export$2e2bcd8739ae039;
$c3395722bea751e2$var$tables.opbd = $b7492a80b0d1a056$export$2e2bcd8739ae039;
let $816c07a04b6dba87$var$TableEntry = new Struct({
  tag: new StringT(4),
  checkSum: uint32,
  offset: new Pointer(uint32, "void", {
    type: "global"
  }),
  length: uint32
}), $816c07a04b6dba87$var$Directory = new Struct({
  tag: new StringT(4),
  numTables: uint16,
  searchRange: uint16,
  entrySelector: uint16,
  rangeShift: uint16,
  tables: new ArrayT($816c07a04b6dba87$var$TableEntry, "numTables")
});
$816c07a04b6dba87$var$Directory.process = function() {
  let a = {};
  for (let s of this.tables)
    a[s.tag] = s;
  this.tables = a;
};
$816c07a04b6dba87$var$Directory.preEncode = function() {
  if (!Array.isArray(this.tables)) {
    let $ = [];
    for (let _ in this.tables) {
      let _e = this.tables[_];
      _e && $.push({
        tag: _,
        checkSum: 0,
        offset: new VoidPointer($c3395722bea751e2$export$2e2bcd8739ae039[_], _e),
        length: $c3395722bea751e2$export$2e2bcd8739ae039[_].size(_e)
      });
    }
    this.tables = $;
  }
  this.tag = "true", this.numTables = this.tables.length;
  let a = Math.floor(Math.log(this.numTables) / Math.LN2), s = Math.pow(2, a);
  this.searchRange = s * 16, this.entrySelector = Math.log(s) / Math.LN2, this.rangeShift = this.numTables * 16 - this.searchRange;
};
var $816c07a04b6dba87$export$2e2bcd8739ae039 = $816c07a04b6dba87$var$Directory;
function $12727730ddfc8bfe$export$2e0ae67339d5f1ac(a, s) {
  let $ = 0, _ = a.length - 1;
  for (; $ <= _; ) {
    let _e = $ + _ >> 1, tt = s(a[_e]);
    if (tt < 0)
      _ = _e - 1;
    else if (tt > 0)
      $ = _e + 1;
    else
      return _e;
  }
  return -1;
}
function $12727730ddfc8bfe$export$d02631cccf789723(a, s) {
  let $ = [];
  for (; a < s; )
    $.push(a++);
  return $;
}
const $12727730ddfc8bfe$export$3d28c1996ced1f14 = new TextDecoder("ascii"), $12727730ddfc8bfe$var$CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $12727730ddfc8bfe$var$LOOKUP = new Uint8Array(256);
for (let a = 0; a < $12727730ddfc8bfe$var$CHARS.length; a++)
  $12727730ddfc8bfe$var$LOOKUP[$12727730ddfc8bfe$var$CHARS.charCodeAt(a)] = a;
function $12727730ddfc8bfe$export$94fdf11bafc8de6b(a) {
  let s = a.length * 0.75;
  a[a.length - 1] === "=" && (s--, a[a.length - 2] === "=" && s--);
  let $ = new Uint8Array(s), _ = 0;
  for (let _e = 0, tt = a.length; _e < tt; _e += 4) {
    let nt = $12727730ddfc8bfe$var$LOOKUP[a.charCodeAt(_e)], at = $12727730ddfc8bfe$var$LOOKUP[a.charCodeAt(_e + 1)], ot = $12727730ddfc8bfe$var$LOOKUP[a.charCodeAt(_e + 2)], rt = $12727730ddfc8bfe$var$LOOKUP[a.charCodeAt(_e + 3)];
    $[_++] = nt << 2 | at >> 4, $[_++] = (at & 15) << 4 | ot >> 2, $[_++] = (ot & 3) << 6 | rt & 63;
  }
  return $;
}
class $f08dd41ef10b694c$export$2e2bcd8739ae039 {
  findSubtable(s, $) {
    for (let [_, _e] of $)
      for (let tt of s.tables)
        if (tt.platformID === _ && tt.encodingID === _e)
          return tt.table;
    return null;
  }
  lookup(s, $) {
    if (this.encoding)
      s = this.encoding.get(s) || s;
    else if ($) {
      let _e = this.getVariationSelector(s, $);
      if (_e)
        return _e;
    }
    let _ = this.cmap;
    switch (_.version) {
      case 0:
        return _.codeMap.get(s) || 0;
      case 4: {
        let _e = 0, tt = _.segCount - 1;
        for (; _e <= tt; ) {
          let nt = _e + tt >> 1;
          if (s < _.startCode.get(nt))
            tt = nt - 1;
          else if (s > _.endCode.get(nt))
            _e = nt + 1;
          else {
            let at = _.idRangeOffset.get(nt), ot;
            if (at === 0)
              ot = s + _.idDelta.get(nt);
            else {
              let rt = at / 2 + (s - _.startCode.get(nt)) - (_.segCount - nt);
              ot = _.glyphIndexArray.get(rt) || 0, ot !== 0 && (ot += _.idDelta.get(nt));
            }
            return ot & 65535;
          }
        }
        return 0;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return _.glyphIndices.get(s - _.firstCode) || 0;
      case 12:
      case 13: {
        let _e = 0, tt = _.nGroups - 1;
        for (; _e <= tt; ) {
          let nt = _e + tt >> 1, at = _.groups.get(nt);
          if (s < at.startCharCode)
            tt = nt - 1;
          else if (s > at.endCharCode)
            _e = nt + 1;
          else
            return _.version === 12 ? at.glyphID + (s - at.startCharCode) : at.glyphID;
        }
        return 0;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${_.version}`);
    }
  }
  getVariationSelector(s, $) {
    if (!this.uvs)
      return 0;
    let _ = this.uvs.varSelectors.toArray(), _e = $12727730ddfc8bfe$export$2e0ae67339d5f1ac(_, (nt) => $ - nt.varSelector), tt = _[_e];
    return _e !== -1 && tt.defaultUVS && (_e = $12727730ddfc8bfe$export$2e0ae67339d5f1ac(tt.defaultUVS, (nt) => s < nt.startUnicodeValue ? -1 : s > nt.startUnicodeValue + nt.additionalCount ? 1 : 0)), _e !== -1 && tt.nonDefaultUVS && (_e = $12727730ddfc8bfe$export$2e0ae67339d5f1ac(tt.nonDefaultUVS, (nt) => s - nt.unicodeValue), _e !== -1) ? tt.nonDefaultUVS[_e].glyphID : 0;
  }
  getCharacterSet() {
    let s = this.cmap;
    switch (s.version) {
      case 0:
        return $12727730ddfc8bfe$export$d02631cccf789723(0, s.codeMap.length);
      case 4: {
        let $ = [], _ = s.endCode.toArray();
        for (let _e = 0; _e < _.length; _e++) {
          let tt = _[_e] + 1, nt = s.startCode.get(_e);
          $.push(...$12727730ddfc8bfe$export$d02631cccf789723(nt, tt));
        }
        return $;
      }
      case 8:
        throw new Error("TODO: cmap format 8");
      case 6:
      case 10:
        return $12727730ddfc8bfe$export$d02631cccf789723(s.firstCode, s.firstCode + s.glyphIndices.length);
      case 12:
      case 13: {
        let $ = [];
        for (let _ of s.groups.toArray())
          $.push(...$12727730ddfc8bfe$export$d02631cccf789723(_.startCharCode, _.endCharCode + 1));
        return $;
      }
      case 14:
        throw new Error("TODO: cmap format 14");
      default:
        throw new Error(`Unknown cmap format ${s.version}`);
    }
  }
  codePointsForGlyph(s) {
    let $ = this.cmap;
    switch ($.version) {
      case 0: {
        let _e = [];
        for (let tt = 0; tt < 256; tt++)
          $.codeMap.get(tt) === s && _e.push(tt);
        return _e;
      }
      case 4: {
        let _e = [];
        for (let tt = 0; tt < $.segCount; tt++) {
          let nt = $.endCode.get(tt), at = $.startCode.get(tt), ot = $.idRangeOffset.get(tt), rt = $.idDelta.get(tt);
          for (var _ = at; _ <= nt; _++) {
            let st = 0;
            if (ot === 0)
              st = _ + rt;
            else {
              let lt = ot / 2 + (_ - at) - ($.segCount - tt);
              st = $.glyphIndexArray.get(lt) || 0, st !== 0 && (st += rt);
            }
            st === s && _e.push(_);
          }
        }
        return _e;
      }
      case 12: {
        let _e = [];
        for (let tt of $.groups.toArray())
          s >= tt.glyphID && s <= tt.glyphID + (tt.endCharCode - tt.startCharCode) && _e.push(tt.startCharCode + (s - tt.glyphID));
        return _e;
      }
      case 13: {
        let _e = [];
        for (let tt of $.groups.toArray())
          s === tt.glyphID && _e.push(...$12727730ddfc8bfe$export$d02631cccf789723(tt.startCharCode, tt.endCharCode + 1));
        return _e;
      }
      default:
        throw new Error(`Unknown cmap format ${$.version}`);
    }
  }
  constructor(s) {
    if (this.encoding = null, this.cmap = this.findSubtable(s, [
      // 32-bit subtables
      [
        3,
        10
      ],
      [
        0,
        6
      ],
      [
        0,
        4
      ],
      // 16-bit subtables
      [
        3,
        1
      ],
      [
        0,
        3
      ],
      [
        0,
        2
      ],
      [
        0,
        1
      ],
      [
        0,
        0
      ]
    ]), !this.cmap)
      for (let $ of s.tables) {
        let _ = $e449ad78d50845fe$export$badc544e0651b6b1($.platformID, $.encodingID, $.table.language - 1), _e = $e449ad78d50845fe$export$1dceb3c14ed68bee(_);
        _e && (this.cmap = $.table, this.encoding = _e);
      }
    if (!this.cmap)
      throw new Error("Could not find a supported cmap table");
    this.uvs = this.findSubtable(s, [
      [
        0,
        5
      ]
    ]), this.uvs && this.uvs.version !== 14 && (this.uvs = null);
  }
}
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f08dd41ef10b694c$export$2e2bcd8739ae039.prototype, "getCharacterSet", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f08dd41ef10b694c$export$2e2bcd8739ae039.prototype, "codePointsForGlyph", null);
class $0bba3a9db57637f3$export$2e2bcd8739ae039 {
  process(s, $) {
    for (let _ = 0; _ < s.length - 1; _++) {
      let _e = s[_].id, tt = s[_ + 1].id;
      $[_].xAdvance += this.getKerning(_e, tt);
    }
  }
  getKerning(s, $) {
    let _ = 0;
    for (let _e of this.kern.tables) {
      if (_e.coverage.crossStream)
        continue;
      switch (_e.version) {
        case 0:
          if (!_e.coverage.horizontal)
            continue;
          break;
        case 1:
          if (_e.coverage.vertical || _e.coverage.variation)
            continue;
          break;
        default:
          throw new Error(`Unsupported kerning table version ${_e.version}`);
      }
      let tt = 0, nt = _e.subtable;
      switch (_e.format) {
        case 0:
          let at = $12727730ddfc8bfe$export$2e0ae67339d5f1ac(nt.pairs, function(lt) {
            return s - lt.left || $ - lt.right;
          });
          at >= 0 && (tt = nt.pairs[at].value);
          break;
        case 2:
          let ot = 0, rt = 0;
          s >= nt.leftTable.firstGlyph && s < nt.leftTable.firstGlyph + nt.leftTable.nGlyphs ? ot = nt.leftTable.offsets[s - nt.leftTable.firstGlyph] : ot = nt.array.off, $ >= nt.rightTable.firstGlyph && $ < nt.rightTable.firstGlyph + nt.rightTable.nGlyphs && (rt = nt.rightTable.offsets[$ - nt.rightTable.firstGlyph]);
          let st = (ot + rt - nt.array.off) / 2;
          tt = nt.array.values.get(st);
          break;
        case 3:
          if (s >= nt.glyphCount || $ >= nt.glyphCount)
            return 0;
          tt = nt.kernValue[nt.kernIndex[nt.leftClass[s] * nt.rightClassCount + nt.rightClass[$]]];
          break;
        default:
          throw new Error(`Unsupported kerning sub-table format ${_e.format}`);
      }
      _e.coverage.override ? _ = tt : _ += tt;
    }
    return _;
  }
  constructor(s) {
    this.kern = s.kern;
  }
}
class $0a4bdfeb6dfd6f5e$export$2e2bcd8739ae039 {
  positionGlyphs(s, $) {
    let _ = 0, _e = 0;
    for (let tt = 0; tt < s.length; tt++)
      s[tt].isMark ? _e = tt : (_ !== _e && this.positionCluster(s, $, _, _e), _ = _e = tt);
    return _ !== _e && this.positionCluster(s, $, _, _e), $;
  }
  positionCluster(s, $, _, _e) {
    let tt = s[_], nt = tt.cbox.copy();
    tt.codePoints.length > 1 && (nt.minX += (tt.codePoints.length - 1) * nt.width / tt.codePoints.length);
    let at = -$[_].xAdvance, ot = 0, rt = this.font.unitsPerEm / 16;
    for (let st = _ + 1; st <= _e; st++) {
      let lt = s[st], et = lt.cbox, it = $[st], ut = this.getCombiningClass(lt.codePoints[0]);
      if (ut !== "Not_Reordered") {
        switch (it.xOffset = it.yOffset = 0, ut) {
          case "Double_Above":
          case "Double_Below":
            it.xOffset += nt.minX - et.width / 2 - et.minX;
            break;
          case "Attached_Below_Left":
          case "Below_Left":
          case "Above_Left":
            it.xOffset += nt.minX - et.minX;
            break;
          case "Attached_Above_Right":
          case "Below_Right":
          case "Above_Right":
            it.xOffset += nt.maxX - et.width - et.minX;
            break;
          default:
            it.xOffset += nt.minX + (nt.width - et.width) / 2 - et.minX;
        }
        switch (ut) {
          case "Double_Below":
          case "Below_Left":
          case "Below":
          case "Below_Right":
          case "Attached_Below_Left":
          case "Attached_Below":
            (ut === "Attached_Below_Left" || ut === "Attached_Below") && (nt.minY += rt), it.yOffset = -nt.minY - et.maxY, nt.minY += et.height;
            break;
          case "Double_Above":
          case "Above_Left":
          case "Above":
          case "Above_Right":
          case "Attached_Above":
          case "Attached_Above_Right":
            (ut === "Attached_Above" || ut === "Attached_Above_Right") && (nt.maxY += rt), it.yOffset = nt.maxY - et.minY, nt.maxY += et.height;
            break;
        }
        it.xAdvance = it.yAdvance = 0, it.xOffset += at, it.yOffset += ot;
      } else
        at -= it.xAdvance, ot -= it.yAdvance;
    }
  }
  getCombiningClass(s) {
    let $ = $747425b437e121da$export$c03b919c6651ed55(s);
    if ((s & -256) === 3584) {
      if ($ === "Not_Reordered")
        switch (s) {
          case 3633:
          case 3636:
          case 3637:
          case 3638:
          case 3639:
          case 3655:
          case 3660:
          case 3645:
          case 3662:
            return "Above_Right";
          case 3761:
          case 3764:
          case 3765:
          case 3766:
          case 3767:
          case 3771:
          case 3788:
          case 3789:
            return "Above";
          case 3772:
            return "Below";
        }
      else if (s === 3642)
        return "Below_Right";
    }
    switch ($) {
      case "CCC10":
      case "CCC11":
      case "CCC12":
      case "CCC13":
      case "CCC14":
      case "CCC15":
      case "CCC16":
      case "CCC17":
      case "CCC18":
      case "CCC20":
      case "CCC22":
        return "Below";
      case "CCC23":
        return "Attached_Above";
      case "CCC24":
        return "Above_Right";
      case "CCC25":
      case "CCC19":
        return "Above_Left";
      case "CCC26":
        return "Above";
      case "CCC21":
        break;
      case "CCC27":
      case "CCC28":
      case "CCC30":
      case "CCC31":
      case "CCC33":
      case "CCC34":
      case "CCC35":
      case "CCC36":
        return "Above";
      case "CCC29":
      case "CCC32":
        return "Below";
      case "CCC103":
        return "Below_Right";
      case "CCC107":
        return "Above_Right";
      case "CCC118":
        return "Below";
      case "CCC122":
        return "Above";
      case "CCC129":
      case "CCC132":
        return "Below";
      case "CCC130":
        return "Above";
    }
    return $;
  }
  constructor(s) {
    this.font = s;
  }
}
class $f34600ab9d7f70d8$export$2e2bcd8739ae039 {
  /**
  * The width of the bounding box
  * @type {number}
  */
  get width() {
    return this.maxX - this.minX;
  }
  /**
  * The height of the bounding box
  * @type {number}
  */
  get height() {
    return this.maxY - this.minY;
  }
  addPoint(s, $) {
    Math.abs(s) !== 1 / 0 && (s < this.minX && (this.minX = s), s > this.maxX && (this.maxX = s)), Math.abs($) !== 1 / 0 && ($ < this.minY && (this.minY = $), $ > this.maxY && (this.maxY = $));
  }
  copy() {
    return new $f34600ab9d7f70d8$export$2e2bcd8739ae039(this.minX, this.minY, this.maxX, this.maxY);
  }
  constructor(s = 1 / 0, $ = 1 / 0, _ = -1 / 0, _e = -1 / 0) {
    this.minX = s, this.minY = $, this.maxX = _, this.maxY = _e;
  }
}
const $130d1a642ebcd2b7$var$UNICODE_SCRIPTS = {
  Caucasian_Albanian: "aghb",
  Arabic: "arab",
  Imperial_Aramaic: "armi",
  Armenian: "armn",
  Avestan: "avst",
  Balinese: "bali",
  Bamum: "bamu",
  Bassa_Vah: "bass",
  Batak: "batk",
  Bengali: [
    "bng2",
    "beng"
  ],
  Bopomofo: "bopo",
  Brahmi: "brah",
  Braille: "brai",
  Buginese: "bugi",
  Buhid: "buhd",
  Chakma: "cakm",
  Canadian_Aboriginal: "cans",
  Carian: "cari",
  Cham: "cham",
  Cherokee: "cher",
  Coptic: "copt",
  Cypriot: "cprt",
  Cyrillic: "cyrl",
  Devanagari: [
    "dev2",
    "deva"
  ],
  Deseret: "dsrt",
  Duployan: "dupl",
  Egyptian_Hieroglyphs: "egyp",
  Elbasan: "elba",
  Ethiopic: "ethi",
  Georgian: "geor",
  Glagolitic: "glag",
  Gothic: "goth",
  Grantha: "gran",
  Greek: "grek",
  Gujarati: [
    "gjr2",
    "gujr"
  ],
  Gurmukhi: [
    "gur2",
    "guru"
  ],
  Hangul: "hang",
  Han: "hani",
  Hanunoo: "hano",
  Hebrew: "hebr",
  Hiragana: "hira",
  Pahawh_Hmong: "hmng",
  Katakana_Or_Hiragana: "hrkt",
  Old_Italic: "ital",
  Javanese: "java",
  Kayah_Li: "kali",
  Katakana: "kana",
  Kharoshthi: "khar",
  Khmer: "khmr",
  Khojki: "khoj",
  Kannada: [
    "knd2",
    "knda"
  ],
  Kaithi: "kthi",
  Tai_Tham: "lana",
  Lao: "lao ",
  Latin: "latn",
  Lepcha: "lepc",
  Limbu: "limb",
  Linear_A: "lina",
  Linear_B: "linb",
  Lisu: "lisu",
  Lycian: "lyci",
  Lydian: "lydi",
  Mahajani: "mahj",
  Mandaic: "mand",
  Manichaean: "mani",
  Mende_Kikakui: "mend",
  Meroitic_Cursive: "merc",
  Meroitic_Hieroglyphs: "mero",
  Malayalam: [
    "mlm2",
    "mlym"
  ],
  Modi: "modi",
  Mongolian: "mong",
  Mro: "mroo",
  Meetei_Mayek: "mtei",
  Myanmar: [
    "mym2",
    "mymr"
  ],
  Old_North_Arabian: "narb",
  Nabataean: "nbat",
  Nko: "nko ",
  Ogham: "ogam",
  Ol_Chiki: "olck",
  Old_Turkic: "orkh",
  Oriya: [
    "ory2",
    "orya"
  ],
  Osmanya: "osma",
  Palmyrene: "palm",
  Pau_Cin_Hau: "pauc",
  Old_Permic: "perm",
  Phags_Pa: "phag",
  Inscriptional_Pahlavi: "phli",
  Psalter_Pahlavi: "phlp",
  Phoenician: "phnx",
  Miao: "plrd",
  Inscriptional_Parthian: "prti",
  Rejang: "rjng",
  Runic: "runr",
  Samaritan: "samr",
  Old_South_Arabian: "sarb",
  Saurashtra: "saur",
  Shavian: "shaw",
  Sharada: "shrd",
  Siddham: "sidd",
  Khudawadi: "sind",
  Sinhala: "sinh",
  Sora_Sompeng: "sora",
  Sundanese: "sund",
  Syloti_Nagri: "sylo",
  Syriac: "syrc",
  Tagbanwa: "tagb",
  Takri: "takr",
  Tai_Le: "tale",
  New_Tai_Lue: "talu",
  Tamil: [
    "tml2",
    "taml"
  ],
  Tai_Viet: "tavt",
  Telugu: [
    "tel2",
    "telu"
  ],
  Tifinagh: "tfng",
  Tagalog: "tglg",
  Thaana: "thaa",
  Thai: "thai",
  Tibetan: "tibt",
  Tirhuta: "tirh",
  Ugaritic: "ugar",
  Vai: "vai ",
  Warang_Citi: "wara",
  Old_Persian: "xpeo",
  Cuneiform: "xsux",
  Yi: "yi  ",
  Inherited: "zinh",
  Common: "zyyy",
  Unknown: "zzzz"
}, $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS = {};
for (let a in $130d1a642ebcd2b7$var$UNICODE_SCRIPTS) {
  let s = $130d1a642ebcd2b7$var$UNICODE_SCRIPTS[a];
  if (Array.isArray(s))
    for (let $ of s)
      $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[$] = a;
  else
    $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[s] = a;
}
function $130d1a642ebcd2b7$export$ce50e82f12a827a4(a) {
  return $130d1a642ebcd2b7$var$OPENTYPE_SCRIPTS[a];
}
function $130d1a642ebcd2b7$export$e5cb25e204fb8450(a) {
  let s = a.length, $ = 0;
  for (; $ < s; ) {
    let _ = a.charCodeAt($++);
    if (55296 <= _ && _ <= 56319 && $ < s) {
      let tt = a.charCodeAt($);
      56320 <= tt && tt <= 57343 && ($++, _ = ((_ & 1023) << 10) + (tt & 1023) + 65536);
    }
    let _e = $747425b437e121da$export$941569448d136665(_);
    if (_e !== "Common" && _e !== "Inherited" && _e !== "Unknown")
      return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS[_e];
  }
  return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS.Unknown;
}
function $130d1a642ebcd2b7$export$16fab0757cfc223d(a) {
  for (let s = 0; s < a.length; s++) {
    let $ = a[s], _ = $747425b437e121da$export$941569448d136665($);
    if (_ !== "Common" && _ !== "Inherited" && _ !== "Unknown")
      return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS[_];
  }
  return $130d1a642ebcd2b7$var$UNICODE_SCRIPTS.Unknown;
}
const $130d1a642ebcd2b7$var$RTL = {
  arab: !0,
  hebr: !0,
  syrc: !0,
  thaa: !0,
  cprt: !0,
  khar: !0,
  phnx: !0,
  "nko ": !0,
  lydi: !0,
  avst: !0,
  armi: !0,
  phli: !0,
  prti: !0,
  sarb: !0,
  orkh: !0,
  samr: !0,
  mand: !0,
  merc: !0,
  mero: !0,
  // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
  mani: !0,
  mend: !0,
  nbat: !0,
  narb: !0,
  palm: !0,
  phlp: !0
  // Psalter Pahlavi
};
function $130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(a) {
  return $130d1a642ebcd2b7$var$RTL[a] ? "rtl" : "ltr";
}
class $be07b3e97a42687a$export$2e2bcd8739ae039 {
  /**
  * The total advance width of the run.
  * @type {number}
  */
  get advanceWidth() {
    let s = 0;
    for (let $ of this.positions)
      s += $.xAdvance;
    return s;
  }
  /**
  * The total advance height of the run.
  * @type {number}
  */
  get advanceHeight() {
    let s = 0;
    for (let $ of this.positions)
      s += $.yAdvance;
    return s;
  }
  /**
  * The bounding box containing all glyphs in the run.
  * @type {BBox}
  */
  get bbox() {
    let s = new $f34600ab9d7f70d8$export$2e2bcd8739ae039(), $ = 0, _ = 0;
    for (let _e = 0; _e < this.glyphs.length; _e++) {
      let tt = this.glyphs[_e], nt = this.positions[_e], at = tt.bbox;
      s.addPoint(at.minX + $ + nt.xOffset, at.minY + _ + nt.yOffset), s.addPoint(at.maxX + $ + nt.xOffset, at.maxY + _ + nt.yOffset), $ += nt.xAdvance, _ += nt.yAdvance;
    }
    return s;
  }
  constructor(s, $, _, _e, tt) {
    if (this.glyphs = s, this.positions = null, this.script = _, this.language = _e || null, this.direction = tt || $130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(_), this.features = {}, Array.isArray($))
      for (let nt of $)
        this.features[nt] = !0;
    else
      typeof $ == "object" && (this.features = $);
  }
}
class $1ac75d9a55b67f01$export$2e2bcd8739ae039 {
  constructor(s = 0, $ = 0, _ = 0, _e = 0) {
    this.xAdvance = s, this.yAdvance = $, this.xOffset = _, this.yOffset = _e;
  }
}
const $3b6302b64eccc32c$var$features = {
  allTypographicFeatures: {
    code: 0,
    exclusive: !1,
    allTypeFeatures: 0
  },
  ligatures: {
    code: 1,
    exclusive: !1,
    requiredLigatures: 0,
    commonLigatures: 2,
    rareLigatures: 4,
    // logos: 6
    rebusPictures: 8,
    diphthongLigatures: 10,
    squaredLigatures: 12,
    abbrevSquaredLigatures: 14,
    symbolLigatures: 16,
    contextualLigatures: 18,
    historicalLigatures: 20
  },
  cursiveConnection: {
    code: 2,
    exclusive: !0,
    unconnected: 0,
    partiallyConnected: 1,
    cursive: 2
  },
  letterCase: {
    code: 3,
    exclusive: !0
  },
  // upperAndLowerCase: 0          # deprecated
  // allCaps: 1                    # deprecated
  // allLowerCase: 2               # deprecated
  // smallCaps: 3                  # deprecated
  // initialCaps: 4                # deprecated
  // initialCapsAndSmallCaps: 5    # deprecated
  verticalSubstitution: {
    code: 4,
    exclusive: !1,
    substituteVerticalForms: 0
  },
  linguisticRearrangement: {
    code: 5,
    exclusive: !1,
    linguisticRearrangement: 0
  },
  numberSpacing: {
    code: 6,
    exclusive: !0,
    monospacedNumbers: 0,
    proportionalNumbers: 1,
    thirdWidthNumbers: 2,
    quarterWidthNumbers: 3
  },
  smartSwash: {
    code: 8,
    exclusive: !1,
    wordInitialSwashes: 0,
    wordFinalSwashes: 2,
    // lineInitialSwashes: 4
    // lineFinalSwashes: 6
    nonFinalSwashes: 8
  },
  diacritics: {
    code: 9,
    exclusive: !0,
    showDiacritics: 0,
    hideDiacritics: 1,
    decomposeDiacritics: 2
  },
  verticalPosition: {
    code: 10,
    exclusive: !0,
    normalPosition: 0,
    superiors: 1,
    inferiors: 2,
    ordinals: 3,
    scientificInferiors: 4
  },
  fractions: {
    code: 11,
    exclusive: !0,
    noFractions: 0,
    verticalFractions: 1,
    diagonalFractions: 2
  },
  overlappingCharacters: {
    code: 13,
    exclusive: !1,
    preventOverlap: 0
  },
  typographicExtras: {
    code: 14,
    exclusive: !1,
    // hyphensToEmDash: 0
    // hyphenToEnDash: 2
    slashedZero: 4
  },
  // formInterrobang: 6
  // smartQuotes: 8
  // periodsToEllipsis: 10
  mathematicalExtras: {
    code: 15,
    exclusive: !1,
    // hyphenToMinus: 0
    // asteristoMultiply: 2
    // slashToDivide: 4
    // inequalityLigatures: 6
    // exponents: 8
    mathematicalGreek: 10
  },
  ornamentSets: {
    code: 16,
    exclusive: !0,
    noOrnaments: 0,
    dingbats: 1,
    piCharacters: 2,
    fleurons: 3,
    decorativeBorders: 4,
    internationalSymbols: 5,
    mathSymbols: 6
  },
  characterAlternatives: {
    code: 17,
    exclusive: !0,
    noAlternates: 0
  },
  // user defined options
  designComplexity: {
    code: 18,
    exclusive: !0,
    designLevel1: 0,
    designLevel2: 1,
    designLevel3: 2,
    designLevel4: 3,
    designLevel5: 4
  },
  styleOptions: {
    code: 19,
    exclusive: !0,
    noStyleOptions: 0,
    displayText: 1,
    engravedText: 2,
    illuminatedCaps: 3,
    titlingCaps: 4,
    tallCaps: 5
  },
  characterShape: {
    code: 20,
    exclusive: !0,
    traditionalCharacters: 0,
    simplifiedCharacters: 1,
    JIS1978Characters: 2,
    JIS1983Characters: 3,
    JIS1990Characters: 4,
    traditionalAltOne: 5,
    traditionalAltTwo: 6,
    traditionalAltThree: 7,
    traditionalAltFour: 8,
    traditionalAltFive: 9,
    expertCharacters: 10,
    JIS2004Characters: 11,
    hojoCharacters: 12,
    NLCCharacters: 13,
    traditionalNamesCharacters: 14
  },
  numberCase: {
    code: 21,
    exclusive: !0,
    lowerCaseNumbers: 0,
    upperCaseNumbers: 1
  },
  textSpacing: {
    code: 22,
    exclusive: !0,
    proportionalText: 0,
    monospacedText: 1,
    halfWidthText: 2,
    thirdWidthText: 3,
    quarterWidthText: 4,
    altProportionalText: 5,
    altHalfWidthText: 6
  },
  transliteration: {
    code: 23,
    exclusive: !0,
    noTransliteration: 0
  },
  // hanjaToHangul: 1
  // hiraganaToKatakana: 2
  // katakanaToHiragana: 3
  // kanaToRomanization: 4
  // romanizationToHiragana: 5
  // romanizationToKatakana: 6
  // hanjaToHangulAltOne: 7
  // hanjaToHangulAltTwo: 8
  // hanjaToHangulAltThree: 9
  annotation: {
    code: 24,
    exclusive: !0,
    noAnnotation: 0,
    boxAnnotation: 1,
    roundedBoxAnnotation: 2,
    circleAnnotation: 3,
    invertedCircleAnnotation: 4,
    parenthesisAnnotation: 5,
    periodAnnotation: 6,
    romanNumeralAnnotation: 7,
    diamondAnnotation: 8,
    invertedBoxAnnotation: 9,
    invertedRoundedBoxAnnotation: 10
  },
  kanaSpacing: {
    code: 25,
    exclusive: !0,
    fullWidthKana: 0,
    proportionalKana: 1
  },
  ideographicSpacing: {
    code: 26,
    exclusive: !0,
    fullWidthIdeographs: 0,
    proportionalIdeographs: 1,
    halfWidthIdeographs: 2
  },
  unicodeDecomposition: {
    code: 27,
    exclusive: !1,
    canonicalComposition: 0,
    compatibilityComposition: 2,
    transcodingComposition: 4
  },
  rubyKana: {
    code: 28,
    exclusive: !1,
    // noRubyKana: 0     # deprecated - use rubyKanaOff instead
    // rubyKana: 1     # deprecated - use rubyKanaOn instead
    rubyKana: 2
  },
  CJKSymbolAlternatives: {
    code: 29,
    exclusive: !0,
    noCJKSymbolAlternatives: 0,
    CJKSymbolAltOne: 1,
    CJKSymbolAltTwo: 2,
    CJKSymbolAltThree: 3,
    CJKSymbolAltFour: 4,
    CJKSymbolAltFive: 5
  },
  ideographicAlternatives: {
    code: 30,
    exclusive: !0,
    noIdeographicAlternatives: 0,
    ideographicAltOne: 1,
    ideographicAltTwo: 2,
    ideographicAltThree: 3,
    ideographicAltFour: 4,
    ideographicAltFive: 5
  },
  CJKVerticalRomanPlacement: {
    code: 31,
    exclusive: !0,
    CJKVerticalRomanCentered: 0,
    CJKVerticalRomanHBaseline: 1
  },
  italicCJKRoman: {
    code: 32,
    exclusive: !1,
    // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
    // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
    CJKItalicRoman: 2
  },
  caseSensitiveLayout: {
    code: 33,
    exclusive: !1,
    caseSensitiveLayout: 0,
    caseSensitiveSpacing: 2
  },
  alternateKana: {
    code: 34,
    exclusive: !1,
    alternateHorizKana: 0,
    alternateVertKana: 2
  },
  stylisticAlternatives: {
    code: 35,
    exclusive: !1,
    noStylisticAlternates: 0,
    stylisticAltOne: 2,
    stylisticAltTwo: 4,
    stylisticAltThree: 6,
    stylisticAltFour: 8,
    stylisticAltFive: 10,
    stylisticAltSix: 12,
    stylisticAltSeven: 14,
    stylisticAltEight: 16,
    stylisticAltNine: 18,
    stylisticAltTen: 20,
    stylisticAltEleven: 22,
    stylisticAltTwelve: 24,
    stylisticAltThirteen: 26,
    stylisticAltFourteen: 28,
    stylisticAltFifteen: 30,
    stylisticAltSixteen: 32,
    stylisticAltSeventeen: 34,
    stylisticAltEighteen: 36,
    stylisticAltNineteen: 38,
    stylisticAltTwenty: 40
  },
  contextualAlternates: {
    code: 36,
    exclusive: !1,
    contextualAlternates: 0,
    swashAlternates: 2,
    contextualSwashAlternates: 4
  },
  lowerCase: {
    code: 37,
    exclusive: !0,
    defaultLowerCase: 0,
    lowerCaseSmallCaps: 1,
    lowerCasePetiteCaps: 2
  },
  upperCase: {
    code: 38,
    exclusive: !0,
    defaultUpperCase: 0,
    upperCaseSmallCaps: 1,
    upperCasePetiteCaps: 2
  },
  languageTag: {
    code: 39,
    exclusive: !0
  },
  CJKRomanSpacing: {
    code: 103,
    exclusive: !0,
    halfWidthCJKRoman: 0,
    proportionalCJKRoman: 1,
    defaultCJKRoman: 2,
    fullWidthCJKRoman: 3
  }
}, $3b6302b64eccc32c$var$feature = (a, s) => [
  $3b6302b64eccc32c$var$features[a].code,
  $3b6302b64eccc32c$var$features[a][s]
], $3b6302b64eccc32c$var$OTMapping = {
  rlig: $3b6302b64eccc32c$var$feature("ligatures", "requiredLigatures"),
  clig: $3b6302b64eccc32c$var$feature("ligatures", "contextualLigatures"),
  dlig: $3b6302b64eccc32c$var$feature("ligatures", "rareLigatures"),
  hlig: $3b6302b64eccc32c$var$feature("ligatures", "historicalLigatures"),
  liga: $3b6302b64eccc32c$var$feature("ligatures", "commonLigatures"),
  hist: $3b6302b64eccc32c$var$feature("ligatures", "historicalLigatures"),
  smcp: $3b6302b64eccc32c$var$feature("lowerCase", "lowerCaseSmallCaps"),
  pcap: $3b6302b64eccc32c$var$feature("lowerCase", "lowerCasePetiteCaps"),
  frac: $3b6302b64eccc32c$var$feature("fractions", "diagonalFractions"),
  dnom: $3b6302b64eccc32c$var$feature("fractions", "diagonalFractions"),
  numr: $3b6302b64eccc32c$var$feature("fractions", "diagonalFractions"),
  afrc: $3b6302b64eccc32c$var$feature("fractions", "verticalFractions"),
  // aalt
  // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
  // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
  // unic, vatu, vhal, vjmo, vpal, vrt2
  // dist -> trak table?
  // kern, vkrn -> kern table
  // lfbd + opbd + rtbd -> opbd table?
  // mark, mkmk -> acnt table?
  // locl -> languageTag + ltag table
  case: $3b6302b64eccc32c$var$feature("caseSensitiveLayout", "caseSensitiveLayout"),
  ccmp: $3b6302b64eccc32c$var$feature("unicodeDecomposition", "canonicalComposition"),
  cpct: $3b6302b64eccc32c$var$feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  valt: $3b6302b64eccc32c$var$feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
  swsh: $3b6302b64eccc32c$var$feature("contextualAlternates", "swashAlternates"),
  cswh: $3b6302b64eccc32c$var$feature("contextualAlternates", "contextualSwashAlternates"),
  curs: $3b6302b64eccc32c$var$feature("cursiveConnection", "cursive"),
  c2pc: $3b6302b64eccc32c$var$feature("upperCase", "upperCasePetiteCaps"),
  c2sc: $3b6302b64eccc32c$var$feature("upperCase", "upperCaseSmallCaps"),
  init: $3b6302b64eccc32c$var$feature("smartSwash", "wordInitialSwashes"),
  fin2: $3b6302b64eccc32c$var$feature("smartSwash", "wordFinalSwashes"),
  medi: $3b6302b64eccc32c$var$feature("smartSwash", "nonFinalSwashes"),
  med2: $3b6302b64eccc32c$var$feature("smartSwash", "nonFinalSwashes"),
  fin3: $3b6302b64eccc32c$var$feature("smartSwash", "wordFinalSwashes"),
  fina: $3b6302b64eccc32c$var$feature("smartSwash", "wordFinalSwashes"),
  pkna: $3b6302b64eccc32c$var$feature("kanaSpacing", "proportionalKana"),
  half: $3b6302b64eccc32c$var$feature("textSpacing", "halfWidthText"),
  halt: $3b6302b64eccc32c$var$feature("textSpacing", "altHalfWidthText"),
  hkna: $3b6302b64eccc32c$var$feature("alternateKana", "alternateHorizKana"),
  vkna: $3b6302b64eccc32c$var$feature("alternateKana", "alternateVertKana"),
  // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
  ital: $3b6302b64eccc32c$var$feature("italicCJKRoman", "CJKItalicRoman"),
  lnum: $3b6302b64eccc32c$var$feature("numberCase", "upperCaseNumbers"),
  onum: $3b6302b64eccc32c$var$feature("numberCase", "lowerCaseNumbers"),
  mgrk: $3b6302b64eccc32c$var$feature("mathematicalExtras", "mathematicalGreek"),
  // nalt: not enough info. what type of annotation?
  // ornm: ditto, which ornament style?
  calt: $3b6302b64eccc32c$var$feature("contextualAlternates", "contextualAlternates"),
  vrt2: $3b6302b64eccc32c$var$feature("verticalSubstitution", "substituteVerticalForms"),
  vert: $3b6302b64eccc32c$var$feature("verticalSubstitution", "substituteVerticalForms"),
  tnum: $3b6302b64eccc32c$var$feature("numberSpacing", "monospacedNumbers"),
  pnum: $3b6302b64eccc32c$var$feature("numberSpacing", "proportionalNumbers"),
  sups: $3b6302b64eccc32c$var$feature("verticalPosition", "superiors"),
  subs: $3b6302b64eccc32c$var$feature("verticalPosition", "inferiors"),
  ordn: $3b6302b64eccc32c$var$feature("verticalPosition", "ordinals"),
  pwid: $3b6302b64eccc32c$var$feature("textSpacing", "proportionalText"),
  hwid: $3b6302b64eccc32c$var$feature("textSpacing", "halfWidthText"),
  qwid: $3b6302b64eccc32c$var$feature("textSpacing", "quarterWidthText"),
  twid: $3b6302b64eccc32c$var$feature("textSpacing", "thirdWidthText"),
  fwid: $3b6302b64eccc32c$var$feature("textSpacing", "proportionalText"),
  palt: $3b6302b64eccc32c$var$feature("textSpacing", "altProportionalText"),
  trad: $3b6302b64eccc32c$var$feature("characterShape", "traditionalCharacters"),
  smpl: $3b6302b64eccc32c$var$feature("characterShape", "simplifiedCharacters"),
  jp78: $3b6302b64eccc32c$var$feature("characterShape", "JIS1978Characters"),
  jp83: $3b6302b64eccc32c$var$feature("characterShape", "JIS1983Characters"),
  jp90: $3b6302b64eccc32c$var$feature("characterShape", "JIS1990Characters"),
  jp04: $3b6302b64eccc32c$var$feature("characterShape", "JIS2004Characters"),
  expt: $3b6302b64eccc32c$var$feature("characterShape", "expertCharacters"),
  hojo: $3b6302b64eccc32c$var$feature("characterShape", "hojoCharacters"),
  nlck: $3b6302b64eccc32c$var$feature("characterShape", "NLCCharacters"),
  tnam: $3b6302b64eccc32c$var$feature("characterShape", "traditionalNamesCharacters"),
  ruby: $3b6302b64eccc32c$var$feature("rubyKana", "rubyKana"),
  titl: $3b6302b64eccc32c$var$feature("styleOptions", "titlingCaps"),
  zero: $3b6302b64eccc32c$var$feature("typographicExtras", "slashedZero"),
  ss01: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltOne"),
  ss02: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTwo"),
  ss03: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltThree"),
  ss04: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFour"),
  ss05: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFive"),
  ss06: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSix"),
  ss07: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSeven"),
  ss08: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltEight"),
  ss09: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltNine"),
  ss10: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTen"),
  ss11: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltEleven"),
  ss12: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTwelve"),
  ss13: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltThirteen"),
  ss14: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFourteen"),
  ss15: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltFifteen"),
  ss16: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSixteen"),
  ss17: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltSeventeen"),
  ss18: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltEighteen"),
  ss19: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltNineteen"),
  ss20: $3b6302b64eccc32c$var$feature("stylisticAlternatives", "stylisticAltTwenty")
};
for (let a = 1; a <= 99; a++)
  $3b6302b64eccc32c$var$OTMapping[`cv${`00${a}`.slice(-2)}`] = [
    $3b6302b64eccc32c$var$features.characterAlternatives.code,
    a
  ];
let $3b6302b64eccc32c$var$AATMapping = {};
for (let a in $3b6302b64eccc32c$var$OTMapping) {
  let s = $3b6302b64eccc32c$var$OTMapping[a];
  $3b6302b64eccc32c$var$AATMapping[s[0]] == null && ($3b6302b64eccc32c$var$AATMapping[s[0]] = {}), $3b6302b64eccc32c$var$AATMapping[s[0]][s[1]] = a;
}
function $3b6302b64eccc32c$export$b813f7d2a1677c16(a) {
  let s = {};
  for (let $ in a) {
    let _;
    (_ = $3b6302b64eccc32c$var$OTMapping[$]) && (s[_[0]] == null && (s[_[0]] = {}), s[_[0]][_[1]] = a[$]);
  }
  return s;
}
function $3b6302b64eccc32c$var$mapFeatureStrings(a) {
  let [s, $] = a;
  if (isNaN(s))
    var _ = $3b6302b64eccc32c$var$features[s] && $3b6302b64eccc32c$var$features[s].code;
  else
    var _ = s;
  if (isNaN($))
    var _e = $3b6302b64eccc32c$var$features[s] && $3b6302b64eccc32c$var$features[s][$];
  else
    var _e = $;
  return [
    _,
    _e
  ];
}
function $3b6302b64eccc32c$export$bd6df347a4f391c4(a) {
  let s = {};
  if (Array.isArray(a))
    for (let $ = 0; $ < a.length; $++) {
      let _, _e = $3b6302b64eccc32c$var$mapFeatureStrings(a[$]);
      (_ = $3b6302b64eccc32c$var$AATMapping[_e[0]] && $3b6302b64eccc32c$var$AATMapping[_e[0]][_e[1]]) && (s[_] = !0);
    }
  else if (typeof a == "object")
    for (let $ in a) {
      let _ = a[$];
      for (let _e in _) {
        let tt, nt = $3b6302b64eccc32c$var$mapFeatureStrings([
          $,
          _e
        ]);
        _[_e] && (tt = $3b6302b64eccc32c$var$AATMapping[nt[0]] && $3b6302b64eccc32c$var$AATMapping[nt[0]][nt[1]]) && (s[tt] = !0);
      }
    }
  return Object.keys(s);
}
class $ff5ce077dae0f144$export$2e2bcd8739ae039 {
  lookup(s) {
    switch (this.table.version) {
      case 0:
        return this.table.values.getItem(s);
      case 2:
      case 4: {
        let _e = 0, tt = this.table.binarySearchHeader.nUnits - 1;
        for (; _e <= tt; ) {
          var $ = _e + tt >> 1, _ = this.table.segments[$];
          if (_.firstGlyph === 65535)
            return null;
          if (s < _.firstGlyph)
            tt = $ - 1;
          else if (s > _.lastGlyph)
            _e = $ + 1;
          else
            return this.table.version === 2 ? _.value : _.values[s - _.firstGlyph];
        }
        return null;
      }
      case 6: {
        let _e = 0, tt = this.table.binarySearchHeader.nUnits - 1;
        for (; _e <= tt; ) {
          var $ = _e + tt >> 1, _ = this.table.segments[$];
          if (_.glyph === 65535)
            return null;
          if (s < _.glyph)
            tt = $ - 1;
          else if (s > _.glyph)
            _e = $ + 1;
          else
            return _.value;
        }
        return null;
      }
      case 8:
        return this.table.values[s - this.table.firstGlyph];
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
  }
  glyphsForValue(s) {
    let $ = [];
    switch (this.table.version) {
      case 2:
      case 4:
        for (let _ of this.table.segments)
          if (this.table.version === 2 && _.value === s)
            $.push(...$12727730ddfc8bfe$export$d02631cccf789723(_.firstGlyph, _.lastGlyph + 1));
          else
            for (let _e = 0; _e < _.values.length; _e++)
              _.values[_e] === s && $.push(_.firstGlyph + _e);
        break;
      case 6:
        for (let _ of this.table.segments)
          _.value === s && $.push(_.glyph);
        break;
      case 8:
        for (let _ = 0; _ < this.table.values.length; _++)
          this.table.values[_] === s && $.push(this.table.firstGlyph + _);
        break;
      default:
        throw new Error(`Unknown lookup table format: ${this.table.version}`);
    }
    return $;
  }
  constructor(s) {
    this.table = s;
  }
}
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $ff5ce077dae0f144$export$2e2bcd8739ae039.prototype, "glyphsForValue", null);
const $50c7aac9316f2948$var$START_OF_TEXT_STATE = 0, $50c7aac9316f2948$var$END_OF_TEXT_CLASS = 0, $50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS = 1, $50c7aac9316f2948$var$DELETED_GLYPH_CLASS = 2, $50c7aac9316f2948$var$DONT_ADVANCE = 16384;
class $50c7aac9316f2948$export$2e2bcd8739ae039 {
  process(s, $, _) {
    let _e = $50c7aac9316f2948$var$START_OF_TEXT_STATE, tt = $ ? s.length - 1 : 0, nt = $ ? -1 : 1;
    for (; nt === 1 && tt <= s.length || nt === -1 && tt >= -1; ) {
      let at = null, ot = $50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS, rt = !0;
      tt === s.length || tt === -1 ? ot = $50c7aac9316f2948$var$END_OF_TEXT_CLASS : (at = s[tt], at.id === 65535 ? ot = $50c7aac9316f2948$var$DELETED_GLYPH_CLASS : (ot = this.lookupTable.lookup(at.id), ot == null && (ot = $50c7aac9316f2948$var$OUT_OF_BOUNDS_CLASS)));
      let lt = this.stateTable.stateArray.getItem(_e)[ot], et = this.stateTable.entryTable.getItem(lt);
      ot !== $50c7aac9316f2948$var$END_OF_TEXT_CLASS && ot !== $50c7aac9316f2948$var$DELETED_GLYPH_CLASS && (_(at, et, tt), rt = !(et.flags & $50c7aac9316f2948$var$DONT_ADVANCE)), _e = et.newState, rt && (tt += nt);
    }
    return s;
  }
  /**
  * Performs a depth-first traversal of the glyph strings
  * represented by the state machine.
  */
  traverse(s, $ = 0, _ = /* @__PURE__ */ new Set()) {
    if (_.has($))
      return;
    _.add($);
    let { nClasses: _e, stateArray: tt, entryTable: nt } = this.stateTable, at = tt.getItem($);
    for (let ot = 4; ot < _e; ot++) {
      let rt = at[ot], st = nt.getItem(rt);
      for (let lt of this.lookupTable.glyphsForValue(ot))
        s.enter && s.enter(lt, st), st.newState !== 0 && this.traverse(s, st.newState, _), s.exit && s.exit(lt, st);
    }
  }
  constructor(s) {
    this.stateTable = s, this.lookupTable = new $ff5ce077dae0f144$export$2e2bcd8739ae039(s.classTable);
  }
}
const $55f71433a605c87d$var$MARK_FIRST = 32768, $55f71433a605c87d$var$MARK_LAST = 8192, $55f71433a605c87d$var$VERB = 15, $55f71433a605c87d$var$SET_MARK = 32768, $55f71433a605c87d$var$SET_COMPONENT = 32768, $55f71433a605c87d$var$PERFORM_ACTION = 8192, $55f71433a605c87d$var$LAST_MASK = 2147483648, $55f71433a605c87d$var$STORE_MASK = 1073741824, $55f71433a605c87d$var$OFFSET_MASK = 1073741823, $55f71433a605c87d$var$REVERSE_DIRECTION = 4194304, $55f71433a605c87d$var$CURRENT_INSERT_BEFORE = 2048, $55f71433a605c87d$var$MARKED_INSERT_BEFORE = 1024, $55f71433a605c87d$var$CURRENT_INSERT_COUNT = 992, $55f71433a605c87d$var$MARKED_INSERT_COUNT = 31;
class $55f71433a605c87d$export$2e2bcd8739ae039 {
  // Processes an array of glyphs and applies the specified features
  // Features should be in the form of {featureType:{featureSetting:boolean}}
  process(s, $ = {}) {
    for (let _e of this.morx.chains) {
      let tt = _e.defaultFlags;
      for (let nt of _e.features) {
        let at;
        (at = $[nt.featureType]) && (at[nt.featureSetting] ? (tt &= nt.disableFlags, tt |= nt.enableFlags) : at[nt.featureSetting] === !1 && (tt |= ~nt.disableFlags, tt &= ~nt.enableFlags));
      }
      for (let nt of _e.subtables)
        nt.subFeatureFlags & tt && this.processSubtable(nt, s);
    }
    let _ = s.length - 1;
    for (; _ >= 0; )
      s[_].id === 65535 && s.splice(_, 1), _--;
    return s;
  }
  processSubtable(s, $) {
    if (this.subtable = s, this.glyphs = $, this.subtable.type === 4) {
      this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
      return;
    }
    this.ligatureStack = [], this.markedGlyph = null, this.firstGlyph = null, this.lastGlyph = null, this.markedIndex = null;
    let _ = this.getStateMachine(s), _e = this.getProcessor(), tt = !!(this.subtable.coverage & $55f71433a605c87d$var$REVERSE_DIRECTION);
    return _.process(this.glyphs, tt, _e);
  }
  getStateMachine(s) {
    return new $50c7aac9316f2948$export$2e2bcd8739ae039(s.table.stateTable);
  }
  getProcessor() {
    switch (this.subtable.type) {
      case 0:
        return this.processIndicRearragement;
      case 1:
        return this.processContextualSubstitution;
      case 2:
        return this.processLigature;
      case 4:
        return this.processNoncontextualSubstitutions;
      case 5:
        return this.processGlyphInsertion;
      default:
        throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
    }
  }
  processIndicRearragement(s, $, _) {
    $.flags & $55f71433a605c87d$var$MARK_FIRST && (this.firstGlyph = _), $.flags & $55f71433a605c87d$var$MARK_LAST && (this.lastGlyph = _), $55f71433a605c87d$var$reorderGlyphs(this.glyphs, $.flags & $55f71433a605c87d$var$VERB, this.firstGlyph, this.lastGlyph);
  }
  processContextualSubstitution(s, $, _) {
    let _e = this.subtable.table.substitutionTable.items;
    if ($.markIndex !== 65535) {
      let nt = _e.getItem($.markIndex), at = new $ff5ce077dae0f144$export$2e2bcd8739ae039(nt);
      s = this.glyphs[this.markedGlyph];
      var tt = at.lookup(s.id);
      tt && (this.glyphs[this.markedGlyph] = this.font.getGlyph(tt, s.codePoints));
    }
    if ($.currentIndex !== 65535) {
      let nt = _e.getItem($.currentIndex), at = new $ff5ce077dae0f144$export$2e2bcd8739ae039(nt);
      s = this.glyphs[_];
      var tt = at.lookup(s.id);
      tt && (this.glyphs[_] = this.font.getGlyph(tt, s.codePoints));
    }
    $.flags & $55f71433a605c87d$var$SET_MARK && (this.markedGlyph = _);
  }
  processLigature(s, $, _) {
    if ($.flags & $55f71433a605c87d$var$SET_COMPONENT && this.ligatureStack.push(_), $.flags & $55f71433a605c87d$var$PERFORM_ACTION) {
      let _e = this.subtable.table.ligatureActions, tt = this.subtable.table.components, nt = this.subtable.table.ligatureList, at = $.action, ot = !1, rt = 0, st = [], lt = [];
      for (; !ot; ) {
        let et = this.ligatureStack.pop();
        st.unshift(...this.glyphs[et].codePoints);
        let it = _e.getItem(at++);
        ot = !!(it & $55f71433a605c87d$var$LAST_MASK);
        let ut = !!(it & $55f71433a605c87d$var$STORE_MASK), ft = (it & $55f71433a605c87d$var$OFFSET_MASK) << 2 >> 2;
        ft += this.glyphs[et].id;
        let ht = tt.getItem(ft);
        if (rt += ht, ot || ut) {
          let dt = nt.getItem(rt);
          this.glyphs[et] = this.font.getGlyph(dt, st), lt.push(et), rt = 0, st = [];
        } else
          this.glyphs[et] = this.font.getGlyph(65535);
      }
      this.ligatureStack.push(...lt);
    }
  }
  processNoncontextualSubstitutions(s, $, _) {
    let _e = new $ff5ce077dae0f144$export$2e2bcd8739ae039(s.table.lookupTable);
    for (_ = 0; _ < $.length; _++) {
      let tt = $[_];
      if (tt.id !== 65535) {
        let nt = _e.lookup(tt.id);
        nt && ($[_] = this.font.getGlyph(nt, tt.codePoints));
      }
    }
  }
  _insertGlyphs(s, $, _, _e) {
    let tt = [];
    for (; _--; ) {
      let nt = this.subtable.table.insertionActions.getItem($++);
      tt.push(this.font.getGlyph(nt));
    }
    _e || s++, this.glyphs.splice(s, 0, ...tt);
  }
  processGlyphInsertion(s, $, _) {
    if ($.flags & $55f71433a605c87d$var$SET_MARK && (this.markedIndex = _), $.markedInsertIndex !== 65535) {
      let _e = ($.flags & $55f71433a605c87d$var$MARKED_INSERT_COUNT) >>> 5, tt = !!($.flags & $55f71433a605c87d$var$MARKED_INSERT_BEFORE);
      this._insertGlyphs(this.markedIndex, $.markedInsertIndex, _e, tt);
    }
    if ($.currentInsertIndex !== 65535) {
      let _e = ($.flags & $55f71433a605c87d$var$CURRENT_INSERT_COUNT) >>> 5, tt = !!($.flags & $55f71433a605c87d$var$CURRENT_INSERT_BEFORE);
      this._insertGlyphs(_, $.currentInsertIndex, _e, tt);
    }
  }
  getSupportedFeatures() {
    let s = [];
    for (let $ of this.morx.chains)
      for (let _ of $.features)
        s.push([
          _.featureType,
          _.featureSetting
        ]);
    return s;
  }
  generateInputs(s) {
    return this.inputCache || this.generateInputCache(), this.inputCache[s] || [];
  }
  generateInputCache() {
    this.inputCache = {};
    for (let s of this.morx.chains) {
      let $ = s.defaultFlags;
      for (let _ of s.subtables)
        _.subFeatureFlags & $ && this.generateInputsForSubtable(_);
    }
  }
  generateInputsForSubtable(s) {
    if (s.type !== 2)
      return;
    if (!!(s.coverage & $55f71433a605c87d$var$REVERSE_DIRECTION))
      throw new Error("Reverse subtable, not supported.");
    this.subtable = s, this.ligatureStack = [];
    let _ = this.getStateMachine(s), _e = this.getProcessor(), tt = [], nt = [];
    this.glyphs = [], _.traverse({
      enter: (at, ot) => {
        let rt = this.glyphs;
        nt.push({
          glyphs: rt.slice(),
          ligatureStack: this.ligatureStack.slice()
        });
        let st = this.font.getGlyph(at);
        tt.push(st), rt.push(tt[tt.length - 1]), _e(rt[rt.length - 1], ot, rt.length - 1);
        let lt = 0, et = 0;
        for (let it = 0; it < rt.length && lt <= 1; it++)
          rt[it].id !== 65535 && (lt++, et = rt[it].id);
        if (lt === 1) {
          let it = tt.map((ft) => ft.id), ut = this.inputCache[et];
          ut ? ut.push(it) : this.inputCache[et] = [
            it
          ];
        }
      },
      exit: () => {
        ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = nt.pop()), tt.pop();
      }
    });
  }
  constructor(s) {
    this.processIndicRearragement = this.processIndicRearragement.bind(this), this.processContextualSubstitution = this.processContextualSubstitution.bind(this), this.processLigature = this.processLigature.bind(this), this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this), this.processGlyphInsertion = this.processGlyphInsertion.bind(this), this.font = s, this.morx = s.morx, this.inputCache = null;
  }
}
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $55f71433a605c87d$export$2e2bcd8739ae039.prototype, "getStateMachine", null);
function $55f71433a605c87d$var$swap(a, s, $, _ = !1, _e = !1) {
  let tt = a.splice($[0] - ($[1] - 1), $[1]);
  _e && tt.reverse();
  let nt = a.splice(s[0], s[1], ...tt);
  return _ && nt.reverse(), a.splice($[0] - (s[1] - 1), 0, ...nt), a;
}
function $55f71433a605c87d$var$reorderGlyphs(a, s, $, _) {
  switch (s) {
    case 0:
      return a;
    case 1:
      return $55f71433a605c87d$var$swap(a, [
        $,
        1
      ], [
        _,
        0
      ]);
    case 2:
      return $55f71433a605c87d$var$swap(a, [
        $,
        0
      ], [
        _,
        1
      ]);
    case 3:
      return $55f71433a605c87d$var$swap(a, [
        $,
        1
      ], [
        _,
        1
      ]);
    case 4:
      return $55f71433a605c87d$var$swap(a, [
        $,
        2
      ], [
        _,
        0
      ]);
    case 5:
      return $55f71433a605c87d$var$swap(a, [
        $,
        2
      ], [
        _,
        0
      ], !0, !1);
    case 6:
      return $55f71433a605c87d$var$swap(a, [
        $,
        0
      ], [
        _,
        2
      ]);
    case 7:
      return $55f71433a605c87d$var$swap(a, [
        $,
        0
      ], [
        _,
        2
      ], !1, !0);
    case 8:
      return $55f71433a605c87d$var$swap(a, [
        $,
        1
      ], [
        _,
        2
      ]);
    case 9:
      return $55f71433a605c87d$var$swap(a, [
        $,
        1
      ], [
        _,
        2
      ], !1, !0);
    case 10:
      return $55f71433a605c87d$var$swap(a, [
        $,
        2
      ], [
        _,
        1
      ]);
    case 11:
      return $55f71433a605c87d$var$swap(a, [
        $,
        2
      ], [
        _,
        1
      ], !0, !1);
    case 12:
      return $55f71433a605c87d$var$swap(a, [
        $,
        2
      ], [
        _,
        2
      ]);
    case 13:
      return $55f71433a605c87d$var$swap(a, [
        $,
        2
      ], [
        _,
        2
      ], !0, !1);
    case 14:
      return $55f71433a605c87d$var$swap(a, [
        $,
        2
      ], [
        _,
        2
      ], !1, !0);
    case 15:
      return $55f71433a605c87d$var$swap(a, [
        $,
        2
      ], [
        _,
        2
      ], !0, !0);
    default:
      throw new Error(`Unknown verb: ${s}`);
  }
}
class $ba6dd74203be8728$export$2e2bcd8739ae039 {
  substitute(s) {
    s.direction === "rtl" && s.glyphs.reverse(), this.morxProcessor.process(s.glyphs, $3b6302b64eccc32c$export$b813f7d2a1677c16(s.features));
  }
  getAvailableFeatures(s, $) {
    return $3b6302b64eccc32c$export$bd6df347a4f391c4(this.morxProcessor.getSupportedFeatures());
  }
  stringsForGlyph(s) {
    let $ = this.morxProcessor.generateInputs(s), _ = /* @__PURE__ */ new Set();
    for (let _e of $)
      this._addStrings(_e, 0, _, "");
    return _;
  }
  _addStrings(s, $, _, _e) {
    let tt = this.font._cmapProcessor.codePointsForGlyph(s[$]);
    for (let nt of tt) {
      let at = _e + String.fromCodePoint(nt);
      $ < s.length - 1 ? this._addStrings(s, $ + 1, _, at) : _.add(at);
    }
  }
  constructor(s) {
    this.font = s, this.morxProcessor = new $55f71433a605c87d$export$2e2bcd8739ae039(s), this.fallbackPosition = !1;
  }
}
class $94d7a73bd2edfc9a$export$2e2bcd8739ae039 {
  /**
  * Adds the given features to the last stage.
  * Ignores features that have already been applied.
  */
  _addFeatures(s, $) {
    let _ = this.stages.length - 1, _e = this.stages[_];
    for (let tt of s)
      this.allFeatures[tt] == null && (_e.push(tt), this.allFeatures[tt] = _, $ && (this.globalFeatures[tt] = !0));
  }
  /**
  * Add features to the last stage
  */
  add(s, $ = !0) {
    if (this.stages.length === 0 && this.stages.push([]), typeof s == "string" && (s = [
      s
    ]), Array.isArray(s))
      this._addFeatures(s, $);
    else if (typeof s == "object")
      this._addFeatures(s.global || [], !0), this._addFeatures(s.local || [], !1);
    else
      throw new Error("Unsupported argument to ShapingPlan#add");
  }
  /**
  * Add a new stage
  */
  addStage(s, $) {
    typeof s == "function" ? this.stages.push(s, []) : (this.stages.push([]), this.add(s, $));
  }
  setFeatureOverrides(s) {
    if (Array.isArray(s))
      this.add(s);
    else if (typeof s == "object") {
      for (let $ in s)
        if (s[$])
          this.add($);
        else if (this.allFeatures[$] != null) {
          let _ = this.stages[this.allFeatures[$]];
          _.splice(_.indexOf($), 1), delete this.allFeatures[$], delete this.globalFeatures[$];
        }
    }
  }
  /**
  * Assigns the global features to the given glyphs
  */
  assignGlobalFeatures(s) {
    for (let $ of s)
      for (let _ in this.globalFeatures)
        $.features[_] = !0;
  }
  /**
  * Executes the planned stages using the given OTProcessor
  */
  process(s, $, _) {
    for (let _e of this.stages)
      typeof _e == "function" ? _ || _e(this.font, $, this) : _e.length > 0 && s.applyFeatures(_e, $, _);
  }
  constructor(s, $, _) {
    this.font = s, this.script = $, this.direction = _, this.stages = [], this.globalFeatures = {}, this.allFeatures = {};
  }
}
const $649970d87335b30f$var$VARIATION_FEATURES = [
  "rvrn"
], $649970d87335b30f$var$COMMON_FEATURES = [
  "ccmp",
  "locl",
  "rlig",
  "mark",
  "mkmk"
], $649970d87335b30f$var$FRACTIONAL_FEATURES = [
  "frac",
  "numr",
  "dnom"
], $649970d87335b30f$var$HORIZONTAL_FEATURES = [
  "calt",
  "clig",
  "liga",
  "rclt",
  "curs",
  "kern"
], $649970d87335b30f$var$DIRECTIONAL_FEATURES = {
  ltr: [
    "ltra",
    "ltrm"
  ],
  rtl: [
    "rtla",
    "rtlm"
  ]
};
class $649970d87335b30f$export$2e2bcd8739ae039 {
  static plan(s, $, _) {
    this.planPreprocessing(s), this.planFeatures(s), this.planPostprocessing(s, _), s.assignGlobalFeatures($), this.assignFeatures(s, $);
  }
  static planPreprocessing(s) {
    s.add({
      global: [
        ...$649970d87335b30f$var$VARIATION_FEATURES,
        ...$649970d87335b30f$var$DIRECTIONAL_FEATURES[s.direction]
      ],
      local: $649970d87335b30f$var$FRACTIONAL_FEATURES
    });
  }
  static planFeatures(s) {
  }
  static planPostprocessing(s, $) {
    s.add([
      ...$649970d87335b30f$var$COMMON_FEATURES,
      ...$649970d87335b30f$var$HORIZONTAL_FEATURES
    ]), s.setFeatureOverrides($);
  }
  static assignFeatures(s, $) {
    for (let _ = 0; _ < $.length; _++) {
      let _e = $[_];
      if (_e.codePoints[0] === 8260) {
        let tt = _, nt = _ + 1;
        for (; tt > 0 && $747425b437e121da$export$727d9dbc4fbb948f($[tt - 1].codePoints[0]); )
          $[tt - 1].features.numr = !0, $[tt - 1].features.frac = !0, tt--;
        for (; nt < $.length && $747425b437e121da$export$727d9dbc4fbb948f($[nt].codePoints[0]); )
          $[nt].features.dnom = !0, $[nt].features.frac = !0, nt++;
        _e.features.frac = !0, _ = nt - 1;
      }
    }
  }
}
_define_property($649970d87335b30f$export$2e2bcd8739ae039, "zeroMarkWidths", "AFTER_GPOS");
const $764eb544bbe1ccf0$var$trie = new $6uUbQ$unicodetrie($12727730ddfc8bfe$export$94fdf11bafc8de6b("ABABAAAAAACgMQAAAZUBav7t2CtPA0EUBeDZB00pin9AJZIEgyUEj0QhweDAgQOJxCBRBElQSBwSicLgkOAwnNKZ5GaY2c7uzj4o5yZfZrrbefbuIx2nSq3CGmzAWH/+K+UO7MIe7MMhHMMpnMMFXMIVXIt2t3CnP088iPqjqNN8e4Ij7Rle4LUH82rLm6i/92A+RERERERERERNmfz/89GDeRARERERzbN8ceps2Iwt9H0C9/AJ6yOlDkbTczcot5VSm8Pm1vcFWfb7+BKOLTuOd2UlTX4wGP85Eg953lWPFbnuN7PkjtLmalOWbNenkHOSa7T3KmR9MVTZ2zZkVj1kHa68MueVKH0R4zqQ44WEXLM8VjcWHP0PtKLfPzQnMtGn3W4QYf6qxFxceVI394r2xnV+1rih0fV1Vzf3fO1n3evL5J78ruvZ5ptX2Rwy92Tfb1wlEqut3U+sZ3HXOeJ7/zDrbyuP6+Zz0fqa6Nv3vhY7Yu1xWnGevmsvsUpTT/RYIe8waUH/rvHMWKFzLfN8L+rTfp645mfX7ftlnfDtYxN59w0=")), $764eb544bbe1ccf0$var$FEATURES = [
  "isol",
  "fina",
  "fin2",
  "fin3",
  "medi",
  "med2",
  "init"
], $764eb544bbe1ccf0$var$ShapingClasses = {
  Non_Joining: 0,
  Left_Joining: 1,
  Right_Joining: 2,
  Dual_Joining: 3,
  Join_Causing: 3,
  ALAPH: 4,
  "DALATH RISH": 5,
  Transparent: 6
}, $764eb544bbe1ccf0$var$ISOL = "isol", $764eb544bbe1ccf0$var$FINA = "fina", $764eb544bbe1ccf0$var$FIN2 = "fin2", $764eb544bbe1ccf0$var$FIN3 = "fin3", $764eb544bbe1ccf0$var$MEDI = "medi", $764eb544bbe1ccf0$var$MED2 = "med2", $764eb544bbe1ccf0$var$INIT = "init", $764eb544bbe1ccf0$var$NONE = null, $764eb544bbe1ccf0$var$STATE_TABLE = [
  //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
  // State 0: prev was U,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 1: prev was R or ISOL/ALAPH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$FIN2,
      5
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 2: prev was D/L in ISOL form,  willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      1
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      3
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      4
    ],
    [
      $764eb544bbe1ccf0$var$INIT,
      $764eb544bbe1ccf0$var$FINA,
      6
    ]
  ],
  // State 3: prev was D in FINA form,  willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      1
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      3
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      4
    ],
    [
      $764eb544bbe1ccf0$var$MEDI,
      $764eb544bbe1ccf0$var$FINA,
      6
    ]
  ],
  // State 4: prev was FINA ALAPH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$FIN2,
      5
    ],
    [
      $764eb544bbe1ccf0$var$MED2,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$FIN2,
      5
    ],
    [
      $764eb544bbe1ccf0$var$ISOL,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ],
  // State 6: prev was DALATH/RISH,  not willing to join.
  [
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$NONE,
      0
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      1
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      2
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$FIN3,
      5
    ],
    [
      $764eb544bbe1ccf0$var$NONE,
      $764eb544bbe1ccf0$var$ISOL,
      6
    ]
  ]
];
class $764eb544bbe1ccf0$export$2e2bcd8739ae039 extends $649970d87335b30f$export$2e2bcd8739ae039 {
  static planFeatures(s) {
    s.add([
      "ccmp",
      "locl"
    ]);
    for (let $ = 0; $ < $764eb544bbe1ccf0$var$FEATURES.length; $++) {
      let _ = $764eb544bbe1ccf0$var$FEATURES[$];
      s.addStage(_, !1);
    }
    s.addStage("mset");
  }
  static assignFeatures(s, $) {
    super.assignFeatures(s, $);
    let _ = -1, _e = 0, tt = [];
    for (let at = 0; at < $.length; at++) {
      let ot, rt;
      var nt = $[at];
      let st = $764eb544bbe1ccf0$var$getShapingClass(nt.codePoints[0]);
      if (st === $764eb544bbe1ccf0$var$ShapingClasses.Transparent) {
        tt[at] = $764eb544bbe1ccf0$var$NONE;
        continue;
      }
      [rt, ot, _e] = $764eb544bbe1ccf0$var$STATE_TABLE[_e][st], rt !== $764eb544bbe1ccf0$var$NONE && _ !== -1 && (tt[_] = rt), tt[at] = ot, _ = at;
    }
    for (let at = 0; at < $.length; at++) {
      let ot;
      var nt = $[at];
      (ot = tt[at]) && (nt.features[ot] = !0);
    }
  }
}
function $764eb544bbe1ccf0$var$getShapingClass(a) {
  let s = $764eb544bbe1ccf0$var$trie.get(a);
  if (s)
    return s - 1;
  let $ = $747425b437e121da$export$410364bbb673ddbc(a);
  return $ === "Mn" || $ === "Me" || $ === "Cf" ? $764eb544bbe1ccf0$var$ShapingClasses.Transparent : $764eb544bbe1ccf0$var$ShapingClasses.Non_Joining;
}
class $85d408632270248b$export$2e2bcd8739ae039 {
  reset(s = {}, $ = 0) {
    this.options = s, this.flags = s.flags || {}, this.markAttachmentType = s.markAttachmentType || 0, this.index = $;
  }
  get cur() {
    return this.glyphs[this.index] || null;
  }
  shouldIgnore(s) {
    return this.flags.ignoreMarks && s.isMark || this.flags.ignoreBaseGlyphs && s.isBase || this.flags.ignoreLigatures && s.isLigature || this.markAttachmentType && s.isMark && s.markAttachmentType !== this.markAttachmentType;
  }
  move(s) {
    for (this.index += s; 0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]); )
      this.index += s;
    return 0 > this.index || this.index >= this.glyphs.length ? null : this.glyphs[this.index];
  }
  next() {
    return this.move(1);
  }
  prev() {
    return this.move(-1);
  }
  peek(s = 1) {
    let $ = this.index, _ = this.increment(s);
    return this.index = $, _;
  }
  peekIndex(s = 1) {
    let $ = this.index;
    this.increment(s);
    let _ = this.index;
    return this.index = $, _;
  }
  increment(s = 1) {
    let $ = s < 0 ? -1 : 1;
    for (s = Math.abs(s); s--; )
      this.move($);
    return this.glyphs[this.index];
  }
  constructor(s, $) {
    this.glyphs = s, this.reset($);
  }
}
const $a83b9c36aaa94fd3$var$DEFAULT_SCRIPTS = [
  "DFLT",
  "dflt",
  "latn"
];
class $a83b9c36aaa94fd3$export$2e2bcd8739ae039 {
  findScript(s) {
    if (this.table.scriptList == null)
      return null;
    Array.isArray(s) || (s = [
      s
    ]);
    for (let $ of s)
      for (let _ of this.table.scriptList)
        if (_.tag === $)
          return _;
    return null;
  }
  selectScript(s, $, _) {
    let _e = !1, tt;
    if (!this.script || s !== this.scriptTag) {
      if (tt = this.findScript(s), tt || (tt = this.findScript($a83b9c36aaa94fd3$var$DEFAULT_SCRIPTS)), !tt)
        return this.scriptTag;
      this.scriptTag = tt.tag, this.script = tt.script, this.language = null, this.languageTag = null, _e = !0;
    }
    if ((!_ || _ !== this.direction) && (this.direction = _ || $130d1a642ebcd2b7$export$9fddb9d0dd7d8a54(s)), $ && $.length < 4 && ($ += " ".repeat(4 - $.length)), !$ || $ !== this.languageTag) {
      this.language = null;
      for (let nt of this.script.langSysRecords)
        if (nt.tag === $) {
          this.language = nt.langSys, this.languageTag = nt.tag;
          break;
        }
      this.language || (this.language = this.script.defaultLangSys, this.languageTag = null), _e = !0;
    }
    if (_e && (this.features = {}, this.language))
      for (let nt of this.language.featureIndexes) {
        let at = this.table.featureList[nt], ot = this.substituteFeatureForVariations(nt);
        this.features[at.tag] = ot || at.feature;
      }
    return this.scriptTag;
  }
  lookupsForFeatures(s = [], $) {
    let _ = [];
    for (let _e of s) {
      let tt = this.features[_e];
      if (tt)
        for (let nt of tt.lookupListIndexes)
          $ && $.indexOf(nt) !== -1 || _.push({
            feature: _e,
            index: nt,
            lookup: this.table.lookupList.get(nt)
          });
    }
    return _.sort((_e, tt) => _e.index - tt.index), _;
  }
  substituteFeatureForVariations(s) {
    if (this.variationsIndex === -1)
      return null;
    let _ = this.table.featureVariations.featureVariationRecords[this.variationsIndex].featureTableSubstitution.substitutions;
    for (let _e of _)
      if (_e.featureIndex === s)
        return _e.alternateFeatureTable;
    return null;
  }
  findVariationsIndex(s) {
    let $ = this.table.featureVariations;
    if (!$)
      return -1;
    let _ = $.featureVariationRecords;
    for (let _e = 0; _e < _.length; _e++) {
      let tt = _[_e].conditionSet.conditionTable;
      if (this.variationConditionsMatch(tt, s))
        return _e;
    }
    return -1;
  }
  variationConditionsMatch(s, $) {
    return s.every((_) => {
      let _e = _.axisIndex < $.length ? $[_.axisIndex] : 0;
      return _.filterRangeMinValue <= _e && _e <= _.filterRangeMaxValue;
    });
  }
  applyFeatures(s, $, _) {
    let _e = this.lookupsForFeatures(s);
    this.applyLookups(_e, $, _);
  }
  applyLookups(s, $, _) {
    this.glyphs = $, this.positions = _, this.glyphIterator = new $85d408632270248b$export$2e2bcd8739ae039($);
    for (let { feature: _e, lookup: tt } of s)
      for (this.currentFeature = _e, this.glyphIterator.reset(tt.flags); this.glyphIterator.index < $.length; ) {
        if (!(_e in this.glyphIterator.cur.features)) {
          this.glyphIterator.next();
          continue;
        }
        for (let nt of tt.subTables)
          if (this.applyLookup(tt.lookupType, nt))
            break;
        this.glyphIterator.next();
      }
  }
  applyLookup(s, $) {
    throw new Error("applyLookup must be implemented by subclasses");
  }
  applyLookupList(s) {
    let $ = this.glyphIterator.options, _ = this.glyphIterator.index;
    for (let _e of s) {
      this.glyphIterator.reset($, _), this.glyphIterator.increment(_e.sequenceIndex);
      let tt = this.table.lookupList.get(_e.lookupListIndex);
      this.glyphIterator.reset(tt.flags, this.glyphIterator.index);
      for (let nt of tt.subTables)
        if (this.applyLookup(tt.lookupType, nt))
          break;
    }
    return this.glyphIterator.reset($, _), !0;
  }
  coverageIndex(s, $) {
    switch ($ == null && ($ = this.glyphIterator.cur.id), s.version) {
      case 1:
        return s.glyphs.indexOf($);
      case 2:
        for (let _ of s.rangeRecords)
          if (_.start <= $ && $ <= _.end)
            return _.startCoverageIndex + $ - _.start;
        break;
    }
    return -1;
  }
  match(s, $, _, _e) {
    let tt = this.glyphIterator.index, nt = this.glyphIterator.increment(s), at = 0;
    for (; at < $.length && nt && _($[at], nt); )
      _e && _e.push(this.glyphIterator.index), at++, nt = this.glyphIterator.next();
    return this.glyphIterator.index = tt, at < $.length ? !1 : _e || !0;
  }
  sequenceMatches(s, $) {
    return this.match(s, $, (_, _e) => _ === _e.id);
  }
  sequenceMatchIndices(s, $) {
    return this.match(s, $, (_, _e) => this.currentFeature in _e.features ? _ === _e.id : !1, []);
  }
  coverageSequenceMatches(s, $) {
    return this.match(s, $, (_, _e) => this.coverageIndex(_, _e.id) >= 0);
  }
  getClassID(s, $) {
    switch ($.version) {
      case 1:
        let _ = s - $.startGlyph;
        if (_ >= 0 && _ < $.classValueArray.length)
          return $.classValueArray[_];
        break;
      case 2:
        for (let _e of $.classRangeRecord)
          if (_e.start <= s && s <= _e.end)
            return _e.class;
        break;
    }
    return 0;
  }
  classSequenceMatches(s, $, _) {
    return this.match(s, $, (_e, tt) => _e === this.getClassID(tt.id, _));
  }
  applyContext(s) {
    let $, _;
    switch (s.version) {
      case 1:
        if ($ = this.coverageIndex(s.coverage), $ === -1)
          return !1;
        _ = s.ruleSets[$];
        for (let _e of _)
          if (this.sequenceMatches(1, _e.input))
            return this.applyLookupList(_e.lookupRecords);
        break;
      case 2:
        if (this.coverageIndex(s.coverage) === -1 || ($ = this.getClassID(this.glyphIterator.cur.id, s.classDef), $ === -1))
          return !1;
        _ = s.classSet[$];
        for (let _e of _)
          if (this.classSequenceMatches(1, _e.classes, s.classDef))
            return this.applyLookupList(_e.lookupRecords);
        break;
      case 3:
        if (this.coverageSequenceMatches(0, s.coverages))
          return this.applyLookupList(s.lookupRecords);
        break;
    }
    return !1;
  }
  applyChainingContext(s) {
    let $;
    switch (s.version) {
      case 1:
        if ($ = this.coverageIndex(s.coverage), $ === -1)
          return !1;
        let _ = s.chainRuleSets[$];
        for (let tt of _)
          if (this.sequenceMatches(-tt.backtrack.length, tt.backtrack) && this.sequenceMatches(1, tt.input) && this.sequenceMatches(1 + tt.input.length, tt.lookahead))
            return this.applyLookupList(tt.lookupRecords);
        break;
      case 2:
        if (this.coverageIndex(s.coverage) === -1)
          return !1;
        $ = this.getClassID(this.glyphIterator.cur.id, s.inputClassDef);
        let _e = s.chainClassSet[$];
        if (!_e)
          return !1;
        for (let tt of _e)
          if (this.classSequenceMatches(-tt.backtrack.length, tt.backtrack, s.backtrackClassDef) && this.classSequenceMatches(1, tt.input, s.inputClassDef) && this.classSequenceMatches(1 + tt.input.length, tt.lookahead, s.lookaheadClassDef))
            return this.applyLookupList(tt.lookupRecords);
        break;
      case 3:
        if (this.coverageSequenceMatches(-s.backtrackGlyphCount, s.backtrackCoverage) && this.coverageSequenceMatches(0, s.inputCoverage) && this.coverageSequenceMatches(s.inputGlyphCount, s.lookaheadCoverage))
          return this.applyLookupList(s.lookupRecords);
        break;
    }
    return !1;
  }
  constructor(s, $) {
    this.font = s, this.table = $, this.script = null, this.scriptTag = null, this.language = null, this.languageTag = null, this.features = {}, this.lookups = {}, this.variationsIndex = s._variationProcessor ? this.findVariationsIndex(s._variationProcessor.normalizedCoords) : -1, this.selectScript(), this.glyphs = [], this.positions = [], this.ligatureID = 1, this.currentFeature = null;
  }
}
class $10e7b257e1a9a756$export$2e2bcd8739ae039 {
  get id() {
    return this._id;
  }
  set id(s) {
    this._id = s, this.substituted = !0;
    let $ = this._font.GDEF;
    if ($ && $.glyphClassDef) {
      let _ = $a83b9c36aaa94fd3$export$2e2bcd8739ae039.prototype.getClassID(s, $.glyphClassDef);
      this.isBase = _ === 1, this.isLigature = _ === 2, this.isMark = _ === 3, this.markAttachmentType = $.markAttachClassDef ? $a83b9c36aaa94fd3$export$2e2bcd8739ae039.prototype.getClassID(s, $.markAttachClassDef) : 0;
    } else
      this.isMark = this.codePoints.length > 0 && this.codePoints.every($747425b437e121da$export$e33ad6871e762338), this.isBase = !this.isMark, this.isLigature = this.codePoints.length > 1, this.markAttachmentType = 0;
  }
  copy() {
    return new $10e7b257e1a9a756$export$2e2bcd8739ae039(this._font, this.id, this.codePoints, this.features);
  }
  constructor(s, $, _ = [], _e) {
    if (this._font = s, this.codePoints = _, this.id = $, this.features = {}, Array.isArray(_e))
      for (let tt = 0; tt < _e.length; tt++) {
        let nt = _e[tt];
        this.features[nt] = !0;
      }
    else
      typeof _e == "object" && Object.assign(this.features, _e);
    this.ligatureID = null, this.ligatureComponent = null, this.isLigated = !1, this.cursiveAttachment = null, this.markAttachment = null, this.shaperInfo = null, this.substituted = !1, this.isMultiplied = !1;
  }
}
class $e1c6bbc8cb416f8c$export$2e2bcd8739ae039 extends $649970d87335b30f$export$2e2bcd8739ae039 {
  static planFeatures(s) {
    s.add([
      "ljmo",
      "vjmo",
      "tjmo"
    ], !1);
  }
  static assignFeatures(s, $) {
    let _ = 0, _e = 0;
    for (; _e < $.length; ) {
      let tt, at = $[_e].codePoints[0], ot = $e1c6bbc8cb416f8c$var$getType(at);
      switch ([tt, _] = $e1c6bbc8cb416f8c$var$STATE_TABLE[_][ot], tt) {
        case $e1c6bbc8cb416f8c$var$DECOMPOSE:
          s.font.hasGlyphForCodePoint(at) || (_e = $e1c6bbc8cb416f8c$var$decompose($, _e, s.font));
          break;
        case $e1c6bbc8cb416f8c$var$COMPOSE:
          _e = $e1c6bbc8cb416f8c$var$compose($, _e, s.font);
          break;
        case $e1c6bbc8cb416f8c$var$TONE_MARK:
          $e1c6bbc8cb416f8c$var$reorderToneMark($, _e, s.font);
          break;
        case $e1c6bbc8cb416f8c$var$INVALID:
          _e = $e1c6bbc8cb416f8c$var$insertDottedCircle($, _e, s.font);
          break;
      }
      _e++;
    }
  }
}
_define_property($e1c6bbc8cb416f8c$export$2e2bcd8739ae039, "zeroMarkWidths", "NONE");
const $e1c6bbc8cb416f8c$var$HANGUL_BASE = 44032, $e1c6bbc8cb416f8c$var$HANGUL_END = 55204, $e1c6bbc8cb416f8c$var$HANGUL_COUNT = $e1c6bbc8cb416f8c$var$HANGUL_END - $e1c6bbc8cb416f8c$var$HANGUL_BASE + 1, $e1c6bbc8cb416f8c$var$L_BASE = 4352, $e1c6bbc8cb416f8c$var$V_BASE = 4449, $e1c6bbc8cb416f8c$var$T_BASE = 4519, $e1c6bbc8cb416f8c$var$L_COUNT = 19, $e1c6bbc8cb416f8c$var$V_COUNT = 21, $e1c6bbc8cb416f8c$var$T_COUNT = 28, $e1c6bbc8cb416f8c$var$L_END = $e1c6bbc8cb416f8c$var$L_BASE + $e1c6bbc8cb416f8c$var$L_COUNT - 1, $e1c6bbc8cb416f8c$var$V_END = $e1c6bbc8cb416f8c$var$V_BASE + $e1c6bbc8cb416f8c$var$V_COUNT - 1, $e1c6bbc8cb416f8c$var$T_END = $e1c6bbc8cb416f8c$var$T_BASE + $e1c6bbc8cb416f8c$var$T_COUNT - 1, $e1c6bbc8cb416f8c$var$DOTTED_CIRCLE = 9676, $e1c6bbc8cb416f8c$var$isL = (a) => 4352 <= a && a <= 4447 || 43360 <= a && a <= 43388, $e1c6bbc8cb416f8c$var$isV = (a) => 4448 <= a && a <= 4519 || 55216 <= a && a <= 55238, $e1c6bbc8cb416f8c$var$isT = (a) => 4520 <= a && a <= 4607 || 55243 <= a && a <= 55291, $e1c6bbc8cb416f8c$var$isTone = (a) => 12334 <= a && a <= 12335, $e1c6bbc8cb416f8c$var$isLVT = (a) => $e1c6bbc8cb416f8c$var$HANGUL_BASE <= a && a <= $e1c6bbc8cb416f8c$var$HANGUL_END, $e1c6bbc8cb416f8c$var$isLV = (a) => a - $e1c6bbc8cb416f8c$var$HANGUL_BASE < $e1c6bbc8cb416f8c$var$HANGUL_COUNT && (a - $e1c6bbc8cb416f8c$var$HANGUL_BASE) % $e1c6bbc8cb416f8c$var$T_COUNT === 0, $e1c6bbc8cb416f8c$var$isCombiningL = (a) => $e1c6bbc8cb416f8c$var$L_BASE <= a && a <= $e1c6bbc8cb416f8c$var$L_END, $e1c6bbc8cb416f8c$var$isCombiningV = (a) => $e1c6bbc8cb416f8c$var$V_BASE <= a && a <= $e1c6bbc8cb416f8c$var$V_END, $e1c6bbc8cb416f8c$var$isCombiningT = (a) => 1 <= a && a <= $e1c6bbc8cb416f8c$var$T_END, $e1c6bbc8cb416f8c$var$X = 0, $e1c6bbc8cb416f8c$var$L = 1, $e1c6bbc8cb416f8c$var$V = 2, $e1c6bbc8cb416f8c$var$T = 3, $e1c6bbc8cb416f8c$var$LV = 4, $e1c6bbc8cb416f8c$var$LVT = 5, $e1c6bbc8cb416f8c$var$M = 6;
function $e1c6bbc8cb416f8c$var$getType(a) {
  return $e1c6bbc8cb416f8c$var$isL(a) ? $e1c6bbc8cb416f8c$var$L : $e1c6bbc8cb416f8c$var$isV(a) ? $e1c6bbc8cb416f8c$var$V : $e1c6bbc8cb416f8c$var$isT(a) ? $e1c6bbc8cb416f8c$var$T : $e1c6bbc8cb416f8c$var$isLV(a) ? $e1c6bbc8cb416f8c$var$LV : $e1c6bbc8cb416f8c$var$isLVT(a) ? $e1c6bbc8cb416f8c$var$LVT : $e1c6bbc8cb416f8c$var$isTone(a) ? $e1c6bbc8cb416f8c$var$M : $e1c6bbc8cb416f8c$var$X;
}
const $e1c6bbc8cb416f8c$var$NO_ACTION = 0, $e1c6bbc8cb416f8c$var$DECOMPOSE = 1, $e1c6bbc8cb416f8c$var$COMPOSE = 2, $e1c6bbc8cb416f8c$var$TONE_MARK = 4, $e1c6bbc8cb416f8c$var$INVALID = 5, $e1c6bbc8cb416f8c$var$STATE_TABLE = [
  //       X                 L                 V                T                  LV                LVT               M
  // State 0: start state
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$INVALID,
      0
    ]
  ],
  // State 1: <L>
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$COMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$INVALID,
      0
    ]
  ],
  // State 2: <L,V> or <LV>
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$COMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$TONE_MARK,
      0
    ]
  ],
  // State 3: <L,V,T> or <LVT>
  [
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      1
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$NO_ACTION,
      0
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      2
    ],
    [
      $e1c6bbc8cb416f8c$var$DECOMPOSE,
      3
    ],
    [
      $e1c6bbc8cb416f8c$var$TONE_MARK,
      0
    ]
  ]
];
function $e1c6bbc8cb416f8c$var$getGlyph(a, s, $) {
  return new $10e7b257e1a9a756$export$2e2bcd8739ae039(a, a.glyphForCodePoint(s).id, [
    s
  ], $);
}
function $e1c6bbc8cb416f8c$var$decompose(a, s, $) {
  let _ = a[s], tt = _.codePoints[0] - $e1c6bbc8cb416f8c$var$HANGUL_BASE, nt = $e1c6bbc8cb416f8c$var$T_BASE + tt % $e1c6bbc8cb416f8c$var$T_COUNT;
  tt = tt / $e1c6bbc8cb416f8c$var$T_COUNT | 0;
  let at = $e1c6bbc8cb416f8c$var$L_BASE + tt / $e1c6bbc8cb416f8c$var$V_COUNT | 0, ot = $e1c6bbc8cb416f8c$var$V_BASE + tt % $e1c6bbc8cb416f8c$var$V_COUNT;
  if (!$.hasGlyphForCodePoint(at) || !$.hasGlyphForCodePoint(ot) || nt !== $e1c6bbc8cb416f8c$var$T_BASE && !$.hasGlyphForCodePoint(nt))
    return s;
  let rt = $e1c6bbc8cb416f8c$var$getGlyph($, at, _.features);
  rt.features.ljmo = !0;
  let st = $e1c6bbc8cb416f8c$var$getGlyph($, ot, _.features);
  st.features.vjmo = !0;
  let lt = [
    rt,
    st
  ];
  if (nt > $e1c6bbc8cb416f8c$var$T_BASE) {
    let et = $e1c6bbc8cb416f8c$var$getGlyph($, nt, _.features);
    et.features.tjmo = !0, lt.push(et);
  }
  return a.splice(s, 1, ...lt), s + lt.length - 1;
}
function $e1c6bbc8cb416f8c$var$compose(a, s, $) {
  let _ = a[s], _e = a[s].codePoints[0], tt = $e1c6bbc8cb416f8c$var$getType(_e), nt = a[s - 1].codePoints[0], at = $e1c6bbc8cb416f8c$var$getType(nt), ot, rt, st, lt;
  if (at === $e1c6bbc8cb416f8c$var$LV && tt === $e1c6bbc8cb416f8c$var$T)
    ot = nt, lt = _;
  else {
    tt === $e1c6bbc8cb416f8c$var$V ? (rt = a[s - 1], st = _) : (rt = a[s - 2], st = a[s - 1], lt = _);
    let it = rt.codePoints[0], ut = st.codePoints[0];
    $e1c6bbc8cb416f8c$var$isCombiningL(it) && $e1c6bbc8cb416f8c$var$isCombiningV(ut) && (ot = $e1c6bbc8cb416f8c$var$HANGUL_BASE + ((it - $e1c6bbc8cb416f8c$var$L_BASE) * $e1c6bbc8cb416f8c$var$V_COUNT + (ut - $e1c6bbc8cb416f8c$var$V_BASE)) * $e1c6bbc8cb416f8c$var$T_COUNT);
  }
  let et = lt && lt.codePoints[0] || $e1c6bbc8cb416f8c$var$T_BASE;
  if (ot != null && (et === $e1c6bbc8cb416f8c$var$T_BASE || $e1c6bbc8cb416f8c$var$isCombiningT(et))) {
    let it = ot + (et - $e1c6bbc8cb416f8c$var$T_BASE);
    if ($.hasGlyphForCodePoint(it)) {
      let ut = at === $e1c6bbc8cb416f8c$var$V ? 3 : 2;
      return a.splice(s - ut + 1, ut, $e1c6bbc8cb416f8c$var$getGlyph($, it, _.features)), s - ut + 1;
    }
  }
  return rt && (rt.features.ljmo = !0), st && (st.features.vjmo = !0), lt && (lt.features.tjmo = !0), at === $e1c6bbc8cb416f8c$var$LV ? ($e1c6bbc8cb416f8c$var$decompose(a, s - 1, $), s + 1) : s;
}
function $e1c6bbc8cb416f8c$var$getLength(a) {
  switch ($e1c6bbc8cb416f8c$var$getType(a)) {
    case $e1c6bbc8cb416f8c$var$LV:
    case $e1c6bbc8cb416f8c$var$LVT:
      return 1;
    case $e1c6bbc8cb416f8c$var$V:
      return 2;
    case $e1c6bbc8cb416f8c$var$T:
      return 3;
  }
}
function $e1c6bbc8cb416f8c$var$reorderToneMark(a, s, $) {
  let _ = a[s], _e = a[s].codePoints[0];
  if ($.glyphForCodePoint(_e).advanceWidth === 0)
    return;
  let tt = a[s - 1].codePoints[0], nt = $e1c6bbc8cb416f8c$var$getLength(tt);
  return a.splice(s, 1), a.splice(s - nt, 0, _);
}
function $e1c6bbc8cb416f8c$var$insertDottedCircle(a, s, $) {
  let _ = a[s], _e = a[s].codePoints[0];
  if ($.hasGlyphForCodePoint($e1c6bbc8cb416f8c$var$DOTTED_CIRCLE)) {
    let tt = $e1c6bbc8cb416f8c$var$getGlyph($, $e1c6bbc8cb416f8c$var$DOTTED_CIRCLE, _.features), nt = $.glyphForCodePoint(_e).advanceWidth === 0 ? s : s + 1;
    a.splice(nt, 0, tt), s++;
  }
  return s;
}
var $4b0735ca6c692ea5$exports = {};
$4b0735ca6c692ea5$exports = JSON.parse('{"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],"accepting":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],"tags":[[],["broken_cluster"],["consonant_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],[],["broken_cluster"],["symbol_cluster"],[],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["symbol_cluster"],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],[],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],[],[],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],["consonant_syllable"],["vowel_syllable"],["standalone_cluster"]]}');
var $aa333a9607471296$exports = {};
$aa333a9607471296$exports = JSON.parse('{"categories":["O","IND","S","GB","B","FM","CGJ","VMAbv","VMPst","VAbv","VPst","CMBlw","VPre","VBlw","H","VMBlw","CMAbv","MBlw","CS","R","SUB","MPst","MPre","FAbv","FPst","FBlw","SMAbv","SMBlw","VMPre","ZWNJ","ZWJ","WJ","VS","N","HN","MAbv"],"decompositions":{"2507":[2503,2494],"2508":[2503,2519],"2888":[2887,2902],"2891":[2887,2878],"2892":[2887,2903],"3018":[3014,3006],"3019":[3015,3006],"3020":[3014,3031],"3144":[3142,3158],"3264":[3263,3285],"3271":[3270,3285],"3272":[3270,3286],"3274":[3270,3266],"3275":[3270,3266,3285],"3402":[3398,3390],"3403":[3399,3390],"3404":[3398,3415],"3546":[3545,3530],"3548":[3545,3535],"3549":[3545,3535,3530],"3550":[3545,3551],"3635":[3661,3634],"3763":[3789,3762],"3955":[3953,3954],"3957":[3953,3956],"3958":[4018,3968],"3959":[4018,3953,3968],"3960":[4019,3968],"3961":[4019,3953,3968],"3969":[3953,3968],"6971":[6970,6965],"6973":[6972,6965],"6976":[6974,6965],"6977":[6975,6965],"6979":[6978,6965],"69934":[69937,69927],"69935":[69938,69927],"70475":[70471,70462],"70476":[70471,70487],"70843":[70841,70842],"70844":[70841,70832],"70846":[70841,70845],"71098":[71096,71087],"71099":[71097,71087]},"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,23,0,0,2,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],"accepting":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],"tags":[[],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["symbol_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["virama_terminated_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["number_joiner_terminated_cluster"],["standard_cluster"],["standard_cluster"],["numeral_cluster"]]}');
const $90a9d3398ee54fe5$export$a513ea61a7bee91c = {
  X: 1,
  C: 2,
  V: 4,
  N: 8,
  H: 16,
  ZWNJ: 32,
  ZWJ: 64,
  M: 128,
  SM: 256,
  VD: 512,
  A: 1024,
  Placeholder: 2048,
  Dotted_Circle: 4096,
  RS: 8192,
  Coeng: 16384,
  Repha: 32768,
  Ra: 65536,
  CM: 131072,
  Symbol: 262144
  // Avagraha, etc that take marks (SM,A,VD).
}, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0 = {
  Start: 1,
  Ra_To_Become_Reph: 2,
  Pre_M: 4,
  Pre_C: 8,
  Base_C: 16,
  After_Main: 32,
  Above_C: 64,
  Before_Sub: 128,
  Below_C: 256,
  After_Sub: 512,
  Before_Post: 1024,
  Post_C: 2048,
  After_Post: 4096,
  Final_C: 8192,
  SMVD: 16384,
  End: 32768
}, $90a9d3398ee54fe5$export$8519deaa7de2b07 = $90a9d3398ee54fe5$export$a513ea61a7bee91c.C | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Ra | $90a9d3398ee54fe5$export$a513ea61a7bee91c.CM | $90a9d3398ee54fe5$export$a513ea61a7bee91c.V | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Placeholder | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Dotted_Circle, $90a9d3398ee54fe5$export$bbcd928767338e0d = $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ | $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWNJ, $90a9d3398ee54fe5$export$ca9599b2a300afc = $90a9d3398ee54fe5$export$a513ea61a7bee91c.H | $90a9d3398ee54fe5$export$a513ea61a7bee91c.Coeng, $90a9d3398ee54fe5$export$e99d119da76a0fc5 = {
  Default: {
    hasOldSpec: !1,
    virama: 0,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Devanagari: {
    hasOldSpec: !0,
    virama: 2381,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Bengali: {
    hasOldSpec: !0,
    virama: 2509,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gurmukhi: {
    hasOldSpec: !0,
    virama: 2637,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Sub,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Gujarati: {
    hasOldSpec: !0,
    virama: 2765,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Before_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Oriya: {
    hasOldSpec: !0,
    virama: 2893,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Tamil: {
    hasOldSpec: !0,
    virama: 3021,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
    rephMode: "Implicit",
    blwfMode: "Pre_And_Post"
  },
  Telugu: {
    hasOldSpec: !0,
    virama: 3149,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
    rephMode: "Explicit",
    blwfMode: "Post_Only"
  },
  Kannada: {
    hasOldSpec: !0,
    virama: 3277,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post,
    rephMode: "Implicit",
    blwfMode: "Post_Only"
  },
  Malayalam: {
    hasOldSpec: !0,
    virama: 3405,
    basePos: "Last",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main,
    rephMode: "Log_Repha",
    blwfMode: "Pre_And_Post"
  },
  // Handled by UniversalShaper
  // Sinhala: {
  //   hasOldSpec: false,
  //   virama: 0x0DCA,
  //   basePos: 'Last_Sinhala',
  //   rephPos: POSITIONS.After_Main,
  //   rephMode: 'Explicit',
  //   blwfMode: 'Pre_And_Post'
  // },
  Khmer: {
    hasOldSpec: !1,
    virama: 6098,
    basePos: "First",
    rephPos: $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph,
    rephMode: "Vis_Repha",
    blwfMode: "Pre_And_Post"
  }
}, $90a9d3398ee54fe5$export$f647c9cfdd77d95a = {
  // Khmer
  6078: [
    6081,
    6078
  ],
  6079: [
    6081,
    6079
  ],
  6080: [
    6081,
    6080
  ],
  6084: [
    6081,
    6084
  ],
  6085: [
    6081,
    6085
  ]
}, { decompositions: $7826f90f6f0cecc9$var$decompositions } = /* @__PURE__ */ $parcel$interopDefault($aa333a9607471296$exports), $7826f90f6f0cecc9$var$trie = new $6uUbQ$unicodetrie($12727730ddfc8bfe$export$94fdf11bafc8de6b("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")), $7826f90f6f0cecc9$var$stateMachine = new $6uUbQ$dfa(/* @__PURE__ */ $parcel$interopDefault($4b0735ca6c692ea5$exports));
class $7826f90f6f0cecc9$export$2e2bcd8739ae039 extends $649970d87335b30f$export$2e2bcd8739ae039 {
  static planFeatures(s) {
    s.addStage($7826f90f6f0cecc9$var$setupSyllables), s.addStage([
      "locl",
      "ccmp"
    ]), s.addStage($7826f90f6f0cecc9$var$initialReordering), s.addStage("nukt"), s.addStage("akhn"), s.addStage("rphf", !1), s.addStage("rkrf"), s.addStage("pref", !1), s.addStage("blwf", !1), s.addStage("abvf", !1), s.addStage("half", !1), s.addStage("pstf", !1), s.addStage("vatu"), s.addStage("cjct"), s.addStage("cfar", !1), s.addStage($7826f90f6f0cecc9$var$finalReordering), s.addStage({
      local: [
        "init"
      ],
      global: [
        "pres",
        "abvs",
        "blws",
        "psts",
        "haln",
        "dist",
        "abvm",
        "blwm",
        "calt",
        "clig"
      ]
    }), s.unicodeScript = $130d1a642ebcd2b7$export$ce50e82f12a827a4(s.script), s.indicConfig = $90a9d3398ee54fe5$export$e99d119da76a0fc5[s.unicodeScript] || $90a9d3398ee54fe5$export$e99d119da76a0fc5.Default, s.isOldSpec = s.indicConfig.hasOldSpec && s.script[s.script.length - 1] !== "2";
  }
  static assignFeatures(s, $) {
    for (let _ = $.length - 1; _ >= 0; _--) {
      let _e = $[_].codePoints[0], tt = $90a9d3398ee54fe5$export$f647c9cfdd77d95a[_e] || $7826f90f6f0cecc9$var$decompositions[_e];
      if (tt) {
        let nt = tt.map((at) => {
          let ot = s.font.glyphForCodePoint(at);
          return new $10e7b257e1a9a756$export$2e2bcd8739ae039(s.font, ot.id, [
            at
          ], $[_].features);
        });
        $.splice(_, 1, ...nt);
      }
    }
  }
}
_define_property($7826f90f6f0cecc9$export$2e2bcd8739ae039, "zeroMarkWidths", "NONE");
function $7826f90f6f0cecc9$var$indicCategory(a) {
  return $7826f90f6f0cecc9$var$trie.get(a.codePoints[0]) >> 8;
}
function $7826f90f6f0cecc9$var$indicPosition(a) {
  return 1 << ($7826f90f6f0cecc9$var$trie.get(a.codePoints[0]) & 255);
}
class $7826f90f6f0cecc9$var$IndicInfo {
  constructor(s, $, _, _e) {
    this.category = s, this.position = $, this.syllableType = _, this.syllable = _e;
  }
}
function $7826f90f6f0cecc9$var$setupSyllables(a, s) {
  let $ = 0, _ = 0;
  for (let [_e, tt, nt] of $7826f90f6f0cecc9$var$stateMachine.match(s.map($7826f90f6f0cecc9$var$indicCategory))) {
    if (_e > _) {
      ++$;
      for (let at = _; at < _e; at++)
        s[at].shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo($90a9d3398ee54fe5$export$a513ea61a7bee91c.X, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.End, "non_indic_cluster", $);
    }
    ++$;
    for (let at = _e; at <= tt; at++)
      s[at].shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo(1 << $7826f90f6f0cecc9$var$indicCategory(s[at]), $7826f90f6f0cecc9$var$indicPosition(s[at]), nt[0], $);
    _ = tt + 1;
  }
  if (_ < s.length) {
    ++$;
    for (let _e = _; _e < s.length; _e++)
      s[_e].shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo($90a9d3398ee54fe5$export$a513ea61a7bee91c.X, $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.End, "non_indic_cluster", $);
  }
}
function $7826f90f6f0cecc9$var$isConsonant(a) {
  return a.shaperInfo.category & $90a9d3398ee54fe5$export$8519deaa7de2b07;
}
function $7826f90f6f0cecc9$var$isJoiner(a) {
  return a.shaperInfo.category & $90a9d3398ee54fe5$export$bbcd928767338e0d;
}
function $7826f90f6f0cecc9$var$isHalantOrCoeng(a) {
  return a.shaperInfo.category & $90a9d3398ee54fe5$export$ca9599b2a300afc;
}
function $7826f90f6f0cecc9$var$wouldSubstitute(a, s) {
  for (let _ of a)
    _.features = {
      [s]: !0
    };
  return a[0]._font._layoutEngine.engine.GSUBProcessor.applyFeatures([
    s
  ], a), a.length === 1;
}
function $7826f90f6f0cecc9$var$consonantPosition(a, s, $) {
  let _ = [
    $,
    s,
    $
  ];
  return $7826f90f6f0cecc9$var$wouldSubstitute(_.slice(0, 2), "blwf") || $7826f90f6f0cecc9$var$wouldSubstitute(_.slice(1, 3), "blwf") ? $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C : $7826f90f6f0cecc9$var$wouldSubstitute(_.slice(0, 2), "pstf") || $7826f90f6f0cecc9$var$wouldSubstitute(_.slice(1, 3), "pstf") || $7826f90f6f0cecc9$var$wouldSubstitute(_.slice(0, 2), "pref") || $7826f90f6f0cecc9$var$wouldSubstitute(_.slice(1, 3), "pref") ? $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Post_C : $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C;
}
function $7826f90f6f0cecc9$var$initialReordering(a, s, $) {
  let _ = $.indicConfig, _e = a._layoutEngine.engine.GSUBProcessor.features, tt = a.glyphForCodePoint(9676).id, nt = a.glyphForCodePoint(_.virama).id;
  if (nt) {
    let at = new $10e7b257e1a9a756$export$2e2bcd8739ae039(a, nt, [
      _.virama
    ]);
    for (let ot = 0; ot < s.length; ot++)
      s[ot].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C && (s[ot].shaperInfo.position = $7826f90f6f0cecc9$var$consonantPosition(a, s[ot].copy(), at));
  }
  for (let at = 0, ot = $7826f90f6f0cecc9$var$nextSyllable(s, 0); at < s.length; at = ot, ot = $7826f90f6f0cecc9$var$nextSyllable(s, at)) {
    let { category: rt, syllableType: st } = s[at].shaperInfo;
    if (st === "symbol_cluster" || st === "non_indic_cluster")
      continue;
    if (st === "broken_cluster" && tt) {
      let pt = new $10e7b257e1a9a756$export$2e2bcd8739ae039(a, tt, [
        9676
      ]);
      pt.shaperInfo = new $7826f90f6f0cecc9$var$IndicInfo(1 << $7826f90f6f0cecc9$var$indicCategory(pt), $7826f90f6f0cecc9$var$indicPosition(pt), s[at].shaperInfo.syllableType, s[at].shaperInfo.syllable);
      let mt = at;
      for (; mt < ot && s[mt].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.Repha; )
        mt++;
      s.splice(mt++, 0, pt), ot++;
    }
    let lt = ot, et = at, it = !1;
    if (_.rephPos !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && _e.rphf && at + 3 <= ot && (_.rephMode === "Implicit" && !$7826f90f6f0cecc9$var$isJoiner(s[at + 2]) || _.rephMode === "Explicit" && s[at + 2].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ)) {
      let pt = [
        s[at].copy(),
        s[at + 1].copy(),
        s[at + 2].copy()
      ];
      if ($7826f90f6f0cecc9$var$wouldSubstitute(pt.slice(0, 2), "rphf") || _.rephMode === "Explicit" && $7826f90f6f0cecc9$var$wouldSubstitute(pt, "rphf")) {
        for (et += 2; et < ot && $7826f90f6f0cecc9$var$isJoiner(s[et]); )
          et++;
        lt = at, it = !0;
      }
    } else if (_.rephMode === "Log_Repha" && s[at].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.Repha) {
      for (et++; et < ot && $7826f90f6f0cecc9$var$isJoiner(s[et]); )
        et++;
      lt = at, it = !0;
    }
    switch (_.basePos) {
      case "Last": {
        let pt = ot, mt = !1;
        do {
          let ct = s[--pt].shaperInfo;
          if ($7826f90f6f0cecc9$var$isConsonant(s[pt])) {
            if (ct.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C && (ct.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Post_C || mt)) {
              lt = pt;
              break;
            }
            ct.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C && (mt = !0), lt = pt;
          } else if (at < pt && ct.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ && s[pt - 1].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.H)
            break;
        } while (pt > et);
        break;
      }
      case "First":
        lt = at;
        for (let pt = lt + 1; pt < ot; pt++)
          $7826f90f6f0cecc9$var$isConsonant(s[pt]) && (s[pt].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C);
    }
    it && lt === at && et - lt <= 2 && (it = !1);
    for (let pt = at; pt < lt; pt++) {
      let mt = s[pt].shaperInfo;
      mt.position = Math.min($90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_C, mt.position);
    }
    lt < ot && (s[lt].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C);
    for (let pt = lt + 1; pt < ot; pt++)
      if (s[pt].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.M) {
        for (let mt = pt + 1; mt < ot; mt++)
          if ($7826f90f6f0cecc9$var$isConsonant(s[mt])) {
            s[mt].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Final_C;
            break;
          }
        break;
      }
    if (it && (s[at].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph), $.isOldSpec) {
      let pt = $.unicodeScript !== "Malayalam";
      for (let mt = lt + 1; mt < ot; mt++)
        if (s[mt].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.H) {
          let ct;
          for (ct = ot - 1; ct > mt && !($7826f90f6f0cecc9$var$isConsonant(s[ct]) || pt && s[ct].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.H); ct--)
            ;
          if (s[ct].shaperInfo.category !== $90a9d3398ee54fe5$export$a513ea61a7bee91c.H && ct > mt) {
            let vt = s[mt];
            s.splice(mt, 0, ...s.splice(mt + 1, ct - mt)), s[ct] = vt;
          }
          break;
        }
    }
    let ut = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Start;
    for (let pt = at; pt < ot; pt++) {
      let mt = s[pt].shaperInfo;
      if (mt.category & ($90a9d3398ee54fe5$export$bbcd928767338e0d | $90a9d3398ee54fe5$export$a513ea61a7bee91c.N | $90a9d3398ee54fe5$export$a513ea61a7bee91c.RS | $90a9d3398ee54fe5$export$a513ea61a7bee91c.CM | $90a9d3398ee54fe5$export$ca9599b2a300afc & mt.category)) {
        if (mt.position = ut, mt.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.H && mt.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
          for (let ct = pt; ct > at; ct--)
            if (s[ct - 1].shaperInfo.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
              mt.position = s[ct - 1].shaperInfo.position;
              break;
            }
        }
      } else
        mt.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD && (ut = mt.position);
    }
    let ft = lt;
    for (let pt = lt + 1; pt < ot; pt++)
      if ($7826f90f6f0cecc9$var$isConsonant(s[pt])) {
        for (let mt = ft + 1; mt < pt; mt++)
          s[mt].shaperInfo.position < $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD && (s[mt].shaperInfo.position = s[pt].shaperInfo.position);
        ft = pt;
      } else
        s[pt].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.M && (ft = pt);
    let ht = s.slice(at, ot);
    ht.sort((pt, mt) => pt.shaperInfo.position - mt.shaperInfo.position), s.splice(at, ht.length, ...ht);
    for (let pt = at; pt < ot; pt++)
      if (s[pt].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C) {
        lt = pt;
        break;
      }
    for (let pt = at; pt < ot && s[pt].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph; pt++)
      s[pt].features.rphf = !0;
    let dt = !$.isOldSpec && _.blwfMode === "Pre_And_Post";
    for (let pt = at; pt < lt; pt++)
      s[pt].features.half = !0, dt && (s[pt].features.blwf = !0);
    for (let pt = lt + 1; pt < ot; pt++)
      s[pt].features.abvf = !0, s[pt].features.pstf = !0, s[pt].features.blwf = !0;
    if ($.isOldSpec && $.unicodeScript === "Devanagari")
      for (let pt = at; pt + 1 < lt; pt++)
        s[pt].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.Ra && s[pt + 1].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.H && (pt + 1 === lt || s[pt + 2].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ) && (s[pt].features.blwf = !0, s[pt + 1].features.blwf = !0);
    let gt = 2;
    if (_e.pref && lt + gt < ot)
      for (let pt = lt + 1; pt + gt - 1 < ot; pt++) {
        let mt = [
          s[pt].copy(),
          s[pt + 1].copy()
        ];
        if ($7826f90f6f0cecc9$var$wouldSubstitute(mt, "pref")) {
          for (let ct = 0; ct < gt; ct++)
            s[pt++].features.pref = !0;
          if (_e.cfar)
            for (; pt < ot; pt++)
              s[pt].features.cfar = !0;
          break;
        }
      }
    for (let pt = at + 1; pt < ot; pt++)
      if ($7826f90f6f0cecc9$var$isJoiner(s[pt])) {
        let mt = s[pt].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWNJ, ct = pt;
        do
          ct--, mt && delete s[ct].features.half;
        while (ct > at && !$7826f90f6f0cecc9$var$isConsonant(s[ct]));
      }
  }
}
function $7826f90f6f0cecc9$var$finalReordering(a, s, $) {
  let _ = $.indicConfig, _e = a._layoutEngine.engine.GSUBProcessor.features;
  for (let tt = 0, nt = $7826f90f6f0cecc9$var$nextSyllable(s, 0); tt < s.length; tt = nt, nt = $7826f90f6f0cecc9$var$nextSyllable(s, tt)) {
    let at = !!_e.pref, ot = tt;
    for (; ot < nt; ot++)
      if (s[ot].shaperInfo.position >= $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C) {
        if (at && ot + 1 < nt) {
          for (let rt = ot + 1; rt < nt; rt++)
            if (s[rt].features.pref) {
              if (!(s[rt].substituted && s[rt].isLigated && !s[rt].isMultiplied)) {
                for (ot = rt; ot < nt && $7826f90f6f0cecc9$var$isHalantOrCoeng(s[ot]); )
                  ot++;
                s[ot].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.BASE_C, at = !1;
              }
              break;
            }
        }
        if ($.unicodeScript === "Malayalam")
          for (let rt = ot + 1; rt < nt; rt++) {
            for (; rt < nt && $7826f90f6f0cecc9$var$isJoiner(s[rt]); )
              rt++;
            if (rt === nt || !$7826f90f6f0cecc9$var$isHalantOrCoeng(s[rt]))
              break;
            for (rt++; rt < nt && $7826f90f6f0cecc9$var$isJoiner(s[rt]); )
              rt++;
            rt < nt && $7826f90f6f0cecc9$var$isConsonant(s[rt]) && s[rt].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Below_C && (ot = rt, s[ot].shaperInfo.position = $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C);
          }
        tt < ot && s[ot].shaperInfo.position > $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Base_C && ot--;
        break;
      }
    if (ot === nt && tt < ot && s[ot - 1].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.ZWJ && ot--, ot < nt)
      for (; tt < ot && s[ot].shaperInfo.category & ($90a9d3398ee54fe5$export$a513ea61a7bee91c.N | $90a9d3398ee54fe5$export$ca9599b2a300afc); )
        ot--;
    if (tt + 1 < nt && tt < ot) {
      let rt = ot === nt ? ot - 2 : ot - 1;
      if ($.unicodeScript !== "Malayalam" && $.unicodeScript !== "Tamil") {
        for (; rt > tt && !(s[rt].shaperInfo.category & ($90a9d3398ee54fe5$export$a513ea61a7bee91c.M | $90a9d3398ee54fe5$export$ca9599b2a300afc)); )
          rt--;
        $7826f90f6f0cecc9$var$isHalantOrCoeng(s[rt]) && s[rt].shaperInfo.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M ? rt + 1 < nt && $7826f90f6f0cecc9$var$isJoiner(s[rt + 1]) && rt++ : rt = tt;
      }
      if (tt < rt && s[rt].shaperInfo.position !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
        for (let st = rt; st > tt; st--)
          if (s[st - 1].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M) {
            let lt = st - 1;
            lt < ot && ot <= rt && ot--;
            let et = s[lt];
            s.splice(lt, 0, ...s.splice(lt + 1, rt - lt)), s[rt] = et, rt--;
          }
      }
    }
    if (tt + 1 < nt && s[tt].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && s[tt].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.Repha !== (s[tt].isLigated && !s[tt].isMultiplied)) {
      let rt, st = _.rephPos, lt = !1;
      if (st !== $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post) {
        for (rt = tt + 1; rt < ot && !$7826f90f6f0cecc9$var$isHalantOrCoeng(s[rt]); )
          rt++;
        if (rt < ot && $7826f90f6f0cecc9$var$isHalantOrCoeng(s[rt]) && (rt + 1 < ot && $7826f90f6f0cecc9$var$isJoiner(s[rt + 1]) && rt++, lt = !0), !lt && st === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main) {
          for (rt = ot; rt + 1 < nt && s[rt + 1].shaperInfo.position <= $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Main; )
            rt++;
          lt = rt < nt;
        }
        if (!lt && st === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Sub) {
          for (rt = ot; rt + 1 < nt && !(s[rt + 1].shaperInfo.position & ($90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Post_C | $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.After_Post | $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD)); )
            rt++;
          lt = rt < nt;
        }
      }
      if (!lt) {
        for (rt = tt + 1; rt < ot && !$7826f90f6f0cecc9$var$isHalantOrCoeng(s[rt]); )
          rt++;
        rt < ot && $7826f90f6f0cecc9$var$isHalantOrCoeng(s[rt]) && (rt + 1 < ot && $7826f90f6f0cecc9$var$isJoiner(s[rt + 1]) && rt++, lt = !0);
      }
      if (!lt) {
        for (rt = nt - 1; rt > tt && s[rt].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.SMVD; )
          rt--;
        if ($7826f90f6f0cecc9$var$isHalantOrCoeng(s[rt]))
          for (let it = ot + 1; it < rt; it++)
            s[it].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.M && rt--;
      }
      let et = s[tt];
      s.splice(tt, 0, ...s.splice(tt + 1, rt - tt)), s[rt] = et, tt < ot && ot <= rt && ot--;
    }
    if (at && ot + 1 < nt) {
      for (let rt = ot + 1; rt < nt; rt++)
        if (s[rt].features.pref) {
          if (s[rt].isLigated && !s[rt].isMultiplied) {
            let st = ot;
            if ($.unicodeScript !== "Malayalam" && $.unicodeScript !== "Tamil") {
              for (; st > tt && !(s[st - 1].shaperInfo.category & ($90a9d3398ee54fe5$export$a513ea61a7bee91c.M | $90a9d3398ee54fe5$export$ca9599b2a300afc)); )
                st--;
              if (st > tt && s[st - 1].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.M) {
                let it = rt;
                for (let ut = ot + 1; ut < it; ut++)
                  if (s[ut].shaperInfo.category === $90a9d3398ee54fe5$export$a513ea61a7bee91c.M) {
                    st--;
                    break;
                  }
              }
            }
            st > tt && $7826f90f6f0cecc9$var$isHalantOrCoeng(s[st - 1]) && st < nt && $7826f90f6f0cecc9$var$isJoiner(s[st]) && st++;
            let lt = rt, et = s[lt];
            s.splice(st + 1, 0, ...s.splice(st, lt - st)), s[st] = et, st <= ot && ot < lt && ot++;
          }
          break;
        }
    }
    s[tt].shaperInfo.position === $90a9d3398ee54fe5$export$1a1f61c9c4dd9df0.Pre_M && (!tt || !/Cf|Mn/.test($747425b437e121da$export$410364bbb673ddbc(s[tt - 1].codePoints[0]))) && (s[tt].features.init = !0);
  }
}
function $7826f90f6f0cecc9$var$nextSyllable(a, s) {
  if (s >= a.length)
    return s;
  let $ = a[s].shaperInfo.syllable;
  for (; ++s < a.length && a[s].shaperInfo.syllable === $; )
    ;
  return s;
}
const { categories: $7ab494fe977143c6$var$categories, decompositions: $7ab494fe977143c6$var$decompositions } = /* @__PURE__ */ $parcel$interopDefault($aa333a9607471296$exports), $7ab494fe977143c6$var$trie = new $6uUbQ$unicodetrie($12727730ddfc8bfe$export$94fdf11bafc8de6b("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")), $7ab494fe977143c6$var$stateMachine = new $6uUbQ$dfa(/* @__PURE__ */ $parcel$interopDefault($aa333a9607471296$exports));
class $7ab494fe977143c6$export$2e2bcd8739ae039 extends $649970d87335b30f$export$2e2bcd8739ae039 {
  static planFeatures(s) {
    s.addStage($7ab494fe977143c6$var$setupSyllables), s.addStage([
      "locl",
      "ccmp",
      "nukt",
      "akhn"
    ]), s.addStage($7ab494fe977143c6$var$clearSubstitutionFlags), s.addStage([
      "rphf"
    ], !1), s.addStage($7ab494fe977143c6$var$recordRphf), s.addStage($7ab494fe977143c6$var$clearSubstitutionFlags), s.addStage([
      "pref"
    ]), s.addStage($7ab494fe977143c6$var$recordPref), s.addStage([
      "rkrf",
      "abvf",
      "blwf",
      "half",
      "pstf",
      "vatu",
      "cjct"
    ]), s.addStage($7ab494fe977143c6$var$reorder), s.addStage([
      "abvs",
      "blws",
      "pres",
      "psts",
      "dist",
      "abvm",
      "blwm"
    ]);
  }
  static assignFeatures(s, $) {
    for (let _ = $.length - 1; _ >= 0; _--) {
      let _e = $[_].codePoints[0];
      if ($7ab494fe977143c6$var$decompositions[_e]) {
        let tt = $7ab494fe977143c6$var$decompositions[_e].map((nt) => {
          let at = s.font.glyphForCodePoint(nt);
          return new $10e7b257e1a9a756$export$2e2bcd8739ae039(s.font, at.id, [
            nt
          ], $[_].features);
        });
        $.splice(_, 1, ...tt);
      }
    }
  }
}
_define_property($7ab494fe977143c6$export$2e2bcd8739ae039, "zeroMarkWidths", "BEFORE_GPOS");
function $7ab494fe977143c6$var$useCategory(a) {
  return $7ab494fe977143c6$var$trie.get(a.codePoints[0]);
}
class $7ab494fe977143c6$var$USEInfo {
  constructor(s, $, _) {
    this.category = s, this.syllableType = $, this.syllable = _;
  }
}
function $7ab494fe977143c6$var$setupSyllables(a, s) {
  let $ = 0;
  for (let [_, _e, tt] of $7ab494fe977143c6$var$stateMachine.match(s.map($7ab494fe977143c6$var$useCategory))) {
    ++$;
    for (let at = _; at <= _e; at++)
      s[at].shaperInfo = new $7ab494fe977143c6$var$USEInfo($7ab494fe977143c6$var$categories[$7ab494fe977143c6$var$useCategory(s[at])], tt[0], $);
    let nt = s[_].shaperInfo.category === "R" ? 1 : Math.min(3, _e - _);
    for (let at = _; at < _ + nt; at++)
      s[at].features.rphf = !0;
  }
}
function $7ab494fe977143c6$var$clearSubstitutionFlags(a, s) {
  for (let $ of s)
    $.substituted = !1;
}
function $7ab494fe977143c6$var$recordRphf(a, s) {
  for (let $ of s)
    $.substituted && $.features.rphf && ($.shaperInfo.category = "R");
}
function $7ab494fe977143c6$var$recordPref(a, s) {
  for (let $ of s)
    $.substituted && ($.shaperInfo.category = "VPre");
}
function $7ab494fe977143c6$var$reorder(a, s) {
  let $ = a.glyphForCodePoint(9676).id;
  for (let _ = 0, _e = $7ab494fe977143c6$var$nextSyllable(s, 0); _ < s.length; _ = _e, _e = $7ab494fe977143c6$var$nextSyllable(s, _)) {
    let tt, nt, at = s[_].shaperInfo, ot = at.syllableType;
    if (!(ot !== "virama_terminated_cluster" && ot !== "standard_cluster" && ot !== "broken_cluster")) {
      if (ot === "broken_cluster" && $) {
        let rt = new $10e7b257e1a9a756$export$2e2bcd8739ae039(a, $, [
          9676
        ]);
        for (rt.shaperInfo = at, tt = _; tt < _e && s[tt].shaperInfo.category === "R"; tt++)
          ;
        s.splice(++tt, 0, rt), _e++;
      }
      if (at.category === "R" && _e - _ > 1) {
        for (tt = _ + 1; tt < _e; tt++)
          if (at = s[tt].shaperInfo, $7ab494fe977143c6$var$isBase(at) || $7ab494fe977143c6$var$isHalant(s[tt])) {
            $7ab494fe977143c6$var$isHalant(s[tt]) && tt--, s.splice(_, 0, ...s.splice(_ + 1, tt - _), s[tt]);
            break;
          }
      }
      for (tt = _, nt = _e; tt < _e; tt++)
        at = s[tt].shaperInfo, $7ab494fe977143c6$var$isBase(at) || $7ab494fe977143c6$var$isHalant(s[tt]) ? nt = $7ab494fe977143c6$var$isHalant(s[tt]) ? tt + 1 : tt : (at.category === "VPre" || at.category === "VMPre") && nt < tt && s.splice(nt, 1, s[tt], ...s.splice(nt, tt - nt));
    }
  }
}
function $7ab494fe977143c6$var$nextSyllable(a, s) {
  if (s >= a.length)
    return s;
  let $ = a[s].shaperInfo.syllable;
  for (; ++s < a.length && a[s].shaperInfo.syllable === $; )
    ;
  return s;
}
function $7ab494fe977143c6$var$isHalant(a) {
  return a.shaperInfo.category === "H" && !a.isLigated;
}
function $7ab494fe977143c6$var$isBase(a) {
  return a.category === "B" || a.category === "GB";
}
const $102b6fe50f1d50b4$var$SHAPERS = {
  arab: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  mong: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  syrc: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  "nko ": $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  phag: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  mand: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  mani: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  phlp: $764eb544bbe1ccf0$export$2e2bcd8739ae039,
  hang: $e1c6bbc8cb416f8c$export$2e2bcd8739ae039,
  bng2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  beng: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  dev2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  deva: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  gjr2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  gujr: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  guru: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  gur2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  knda: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  knd2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  mlm2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  mlym: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  ory2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  orya: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  taml: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  tml2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  telu: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  tel2: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  khmr: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  bali: $7ab494fe977143c6$export$2e2bcd8739ae039,
  batk: $7ab494fe977143c6$export$2e2bcd8739ae039,
  brah: $7ab494fe977143c6$export$2e2bcd8739ae039,
  bugi: $7ab494fe977143c6$export$2e2bcd8739ae039,
  buhd: $7ab494fe977143c6$export$2e2bcd8739ae039,
  cakm: $7ab494fe977143c6$export$2e2bcd8739ae039,
  cham: $7ab494fe977143c6$export$2e2bcd8739ae039,
  dupl: $7ab494fe977143c6$export$2e2bcd8739ae039,
  egyp: $7ab494fe977143c6$export$2e2bcd8739ae039,
  gran: $7ab494fe977143c6$export$2e2bcd8739ae039,
  hano: $7ab494fe977143c6$export$2e2bcd8739ae039,
  java: $7ab494fe977143c6$export$2e2bcd8739ae039,
  kthi: $7ab494fe977143c6$export$2e2bcd8739ae039,
  kali: $7ab494fe977143c6$export$2e2bcd8739ae039,
  khar: $7ab494fe977143c6$export$2e2bcd8739ae039,
  khoj: $7ab494fe977143c6$export$2e2bcd8739ae039,
  sind: $7ab494fe977143c6$export$2e2bcd8739ae039,
  lepc: $7ab494fe977143c6$export$2e2bcd8739ae039,
  limb: $7ab494fe977143c6$export$2e2bcd8739ae039,
  mahj: $7ab494fe977143c6$export$2e2bcd8739ae039,
  // mand: UniversalShaper, // Mandaic
  // mani: UniversalShaper, // Manichaean
  mtei: $7ab494fe977143c6$export$2e2bcd8739ae039,
  modi: $7ab494fe977143c6$export$2e2bcd8739ae039,
  // mong: UniversalShaper, // Mongolian
  // 'nko ': UniversalShaper, // N’Ko
  hmng: $7ab494fe977143c6$export$2e2bcd8739ae039,
  // phag: UniversalShaper, // Phags-pa
  // phlp: UniversalShaper, // Psalter Pahlavi
  rjng: $7ab494fe977143c6$export$2e2bcd8739ae039,
  saur: $7ab494fe977143c6$export$2e2bcd8739ae039,
  shrd: $7ab494fe977143c6$export$2e2bcd8739ae039,
  sidd: $7ab494fe977143c6$export$2e2bcd8739ae039,
  sinh: $7826f90f6f0cecc9$export$2e2bcd8739ae039,
  sund: $7ab494fe977143c6$export$2e2bcd8739ae039,
  sylo: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tglg: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tagb: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tale: $7ab494fe977143c6$export$2e2bcd8739ae039,
  lana: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tavt: $7ab494fe977143c6$export$2e2bcd8739ae039,
  takr: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tibt: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tfng: $7ab494fe977143c6$export$2e2bcd8739ae039,
  tirh: $7ab494fe977143c6$export$2e2bcd8739ae039,
  latn: $649970d87335b30f$export$2e2bcd8739ae039,
  DFLT: $649970d87335b30f$export$2e2bcd8739ae039
};
function $102b6fe50f1d50b4$export$7877a478dd30fd3d(a) {
  Array.isArray(a) || (a = [
    a
  ]);
  for (let s of a) {
    let $ = $102b6fe50f1d50b4$var$SHAPERS[s];
    if ($)
      return $;
  }
  return $649970d87335b30f$export$2e2bcd8739ae039;
}
class $0a876c45f1f7c41c$export$2e2bcd8739ae039 extends $a83b9c36aaa94fd3$export$2e2bcd8739ae039 {
  applyLookup(s, $) {
    switch (s) {
      case 1: {
        let _e = this.coverageIndex($.coverage);
        if (_e === -1)
          return !1;
        let tt = this.glyphIterator.cur;
        switch ($.version) {
          case 1:
            tt.id = tt.id + $.deltaGlyphID & 65535;
            break;
          case 2:
            tt.id = $.substitute.get(_e);
            break;
        }
        return !0;
      }
      case 2: {
        let _e = this.coverageIndex($.coverage);
        if (_e !== -1) {
          let tt = $.sequences.get(_e);
          if (tt.length === 0)
            return this.glyphs.splice(this.glyphIterator.index, 1), !0;
          this.glyphIterator.cur.id = tt[0], this.glyphIterator.cur.ligatureComponent = 0;
          let nt = this.glyphIterator.cur.features, at = this.glyphIterator.cur, ot = tt.slice(1).map((rt, st) => {
            let lt = new $10e7b257e1a9a756$export$2e2bcd8739ae039(this.font, rt, void 0, nt);
            return lt.shaperInfo = at.shaperInfo, lt.isLigated = at.isLigated, lt.ligatureComponent = st + 1, lt.substituted = !0, lt.isMultiplied = !0, lt;
          });
          return this.glyphs.splice(this.glyphIterator.index + 1, 0, ...ot), !0;
        }
        return !1;
      }
      case 3: {
        let _e = this.coverageIndex($.coverage);
        if (_e !== -1) {
          let tt = 0;
          return this.glyphIterator.cur.id = $.alternateSet.get(_e)[tt], !0;
        }
        return !1;
      }
      case 4: {
        let _e = this.coverageIndex($.coverage);
        if (_e === -1)
          return !1;
        for (let tt of $.ligatureSets.get(_e)) {
          let nt = this.sequenceMatchIndices(1, tt.components);
          if (!nt)
            continue;
          let at = this.glyphIterator.cur, ot = at.codePoints.slice();
          for (let ft of nt)
            ot.push(...this.glyphs[ft].codePoints);
          let rt = new $10e7b257e1a9a756$export$2e2bcd8739ae039(this.font, tt.glyph, ot, at.features);
          rt.shaperInfo = at.shaperInfo, rt.isLigated = !0, rt.substituted = !0;
          let st = at.isMark;
          for (let ft = 0; ft < nt.length && st; ft++)
            st = this.glyphs[nt[ft]].isMark;
          rt.ligatureID = st ? null : this.ligatureID++;
          let lt = at.ligatureID, et = at.codePoints.length, it = et, ut = this.glyphIterator.index + 1;
          for (let ft of nt) {
            if (st)
              ut = ft;
            else
              for (; ut < ft; ) {
                var _ = it - et + Math.min(this.glyphs[ut].ligatureComponent || 1, et);
                this.glyphs[ut].ligatureID = rt.ligatureID, this.glyphs[ut].ligatureComponent = _, ut++;
              }
            lt = this.glyphs[ut].ligatureID, et = this.glyphs[ut].codePoints.length, it += et, ut++;
          }
          if (lt && !st)
            for (let ft = ut; ft < this.glyphs.length && this.glyphs[ft].ligatureID === lt; ft++) {
              var _ = it - et + Math.min(this.glyphs[ft].ligatureComponent || 1, et);
              this.glyphs[ft].ligatureComponent = _;
            }
          for (let ft = nt.length - 1; ft >= 0; ft--)
            this.glyphs.splice(nt[ft], 1);
          return this.glyphs[this.glyphIterator.index] = rt, !0;
        }
        return !1;
      }
      case 5:
        return this.applyContext($);
      case 6:
        return this.applyChainingContext($);
      case 7:
        return this.applyLookup($.lookupType, $.extension);
      default:
        throw new Error(`GSUB lookupType ${s} is not supported`);
    }
  }
}
class $c96c93587d49c14d$export$2e2bcd8739ae039 extends $a83b9c36aaa94fd3$export$2e2bcd8739ae039 {
  applyPositionValue(s, $) {
    let _ = this.positions[this.glyphIterator.peekIndex(s)];
    $.xAdvance != null && (_.xAdvance += $.xAdvance), $.yAdvance != null && (_.yAdvance += $.yAdvance), $.xPlacement != null && (_.xOffset += $.xPlacement), $.yPlacement != null && (_.yOffset += $.yPlacement);
    let _e = this.font._variationProcessor, tt = this.font.GDEF && this.font.GDEF.itemVariationStore;
    _e && tt && ($.xPlaDevice && (_.xOffset += _e.getDelta(tt, $.xPlaDevice.a, $.xPlaDevice.b)), $.yPlaDevice && (_.yOffset += _e.getDelta(tt, $.yPlaDevice.a, $.yPlaDevice.b)), $.xAdvDevice && (_.xAdvance += _e.getDelta(tt, $.xAdvDevice.a, $.xAdvDevice.b)), $.yAdvDevice && (_.yAdvance += _e.getDelta(tt, $.yAdvDevice.a, $.yAdvDevice.b)));
  }
  applyLookup(s, $) {
    switch (s) {
      case 1: {
        let _e = this.coverageIndex($.coverage);
        if (_e === -1)
          return !1;
        switch ($.version) {
          case 1:
            this.applyPositionValue(0, $.value);
            break;
          case 2:
            this.applyPositionValue(0, $.values.get(_e));
            break;
        }
        return !0;
      }
      case 2: {
        let _e = this.glyphIterator.peek();
        if (!_e)
          return !1;
        let tt = this.coverageIndex($.coverage);
        if (tt === -1)
          return !1;
        switch ($.version) {
          case 1:
            let nt = $.pairSets.get(tt);
            for (let rt of nt)
              if (rt.secondGlyph === _e.id)
                return this.applyPositionValue(0, rt.value1), this.applyPositionValue(1, rt.value2), !0;
            return !1;
          case 2:
            let at = this.getClassID(this.glyphIterator.cur.id, $.classDef1), ot = this.getClassID(_e.id, $.classDef2);
            if (at === -1 || ot === -1)
              return !1;
            var _ = $.classRecords.get(at).get(ot);
            return this.applyPositionValue(0, _.value1), this.applyPositionValue(1, _.value2), !0;
        }
      }
      case 3: {
        let _e = this.glyphIterator.peekIndex(), tt = this.glyphs[_e];
        if (!tt)
          return !1;
        let nt = $.entryExitRecords[this.coverageIndex($.coverage)];
        if (!nt || !nt.exitAnchor)
          return !1;
        let at = $.entryExitRecords[this.coverageIndex($.coverage, tt.id)];
        if (!at || !at.entryAnchor)
          return !1;
        let ot = this.getAnchor(at.entryAnchor), rt = this.getAnchor(nt.exitAnchor), st = this.positions[this.glyphIterator.index], lt = this.positions[_e], et;
        switch (this.direction) {
          case "ltr":
            st.xAdvance = rt.x + st.xOffset, et = ot.x + lt.xOffset, lt.xAdvance -= et, lt.xOffset -= et;
            break;
          case "rtl":
            et = rt.x + st.xOffset, st.xAdvance -= et, st.xOffset -= et, lt.xAdvance = ot.x + lt.xOffset;
            break;
        }
        return this.glyphIterator.flags.rightToLeft ? (this.glyphIterator.cur.cursiveAttachment = _e, st.yOffset = ot.y - rt.y) : (tt.cursiveAttachment = this.glyphIterator.index, st.yOffset = rt.y - ot.y), !0;
      }
      case 4: {
        let _e = this.coverageIndex($.markCoverage);
        if (_e === -1)
          return !1;
        let tt = this.glyphIterator.index;
        for (; --tt >= 0 && (this.glyphs[tt].isMark || this.glyphs[tt].ligatureComponent > 0); )
          ;
        if (tt < 0)
          return !1;
        let nt = this.coverageIndex($.baseCoverage, this.glyphs[tt].id);
        if (nt === -1)
          return !1;
        let at = $.markArray[_e], ot = $.baseArray[nt][at.class];
        return this.applyAnchor(at, ot, tt), !0;
      }
      case 5: {
        let _e = this.coverageIndex($.markCoverage);
        if (_e === -1)
          return !1;
        let tt = this.glyphIterator.index;
        for (; --tt >= 0 && this.glyphs[tt].isMark; )
          ;
        if (tt < 0)
          return !1;
        let nt = this.coverageIndex($.ligatureCoverage, this.glyphs[tt].id);
        if (nt === -1)
          return !1;
        let at = $.ligatureArray[nt], ot = this.glyphIterator.cur, rt = this.glyphs[tt], st = rt.ligatureID && rt.ligatureID === ot.ligatureID && ot.ligatureComponent > 0 ? Math.min(ot.ligatureComponent, rt.codePoints.length) - 1 : rt.codePoints.length - 1, lt = $.markArray[_e], et = at[st][lt.class];
        return this.applyAnchor(lt, et, tt), !0;
      }
      case 6: {
        let _e = this.coverageIndex($.mark1Coverage);
        if (_e === -1)
          return !1;
        let tt = this.glyphIterator.peekIndex(-1), nt = this.glyphs[tt];
        if (!nt || !nt.isMark)
          return !1;
        let at = this.glyphIterator.cur, ot = !1;
        if (at.ligatureID === nt.ligatureID ? at.ligatureID ? at.ligatureComponent === nt.ligatureComponent && (ot = !0) : ot = !0 : (at.ligatureID && !at.ligatureComponent || nt.ligatureID && !nt.ligatureComponent) && (ot = !0), !ot)
          return !1;
        let rt = this.coverageIndex($.mark2Coverage, nt.id);
        if (rt === -1)
          return !1;
        let st = $.mark1Array[_e], lt = $.mark2Array[rt][st.class];
        return this.applyAnchor(st, lt, tt), !0;
      }
      case 7:
        return this.applyContext($);
      case 8:
        return this.applyChainingContext($);
      case 9:
        return this.applyLookup($.lookupType, $.extension);
      default:
        throw new Error(`Unsupported GPOS table: ${s}`);
    }
  }
  applyAnchor(s, $, _) {
    let _e = this.getAnchor($), tt = this.getAnchor(s.markAnchor);
    this.positions[_];
    let nt = this.positions[this.glyphIterator.index];
    nt.xOffset = _e.x - tt.x, nt.yOffset = _e.y - tt.y, this.glyphIterator.cur.markAttachment = _;
  }
  getAnchor(s) {
    let $ = s.xCoordinate, _ = s.yCoordinate, _e = this.font._variationProcessor, tt = this.font.GDEF && this.font.GDEF.itemVariationStore;
    return _e && tt && (s.xDeviceTable && ($ += _e.getDelta(tt, s.xDeviceTable.a, s.xDeviceTable.b)), s.yDeviceTable && (_ += _e.getDelta(tt, s.yDeviceTable.a, s.yDeviceTable.b))), {
      x: $,
      y: _
    };
  }
  applyFeatures(s, $, _) {
    super.applyFeatures(s, $, _);
    for (var _e = 0; _e < this.glyphs.length; _e++)
      this.fixCursiveAttachment(_e);
    this.fixMarkAttachment();
  }
  fixCursiveAttachment(s) {
    let $ = this.glyphs[s];
    if ($.cursiveAttachment != null) {
      let _ = $.cursiveAttachment;
      $.cursiveAttachment = null, this.fixCursiveAttachment(_), this.positions[s].yOffset += this.positions[_].yOffset;
    }
  }
  fixMarkAttachment() {
    for (let s = 0; s < this.glyphs.length; s++) {
      let $ = this.glyphs[s];
      if ($.markAttachment != null) {
        let _ = $.markAttachment;
        if (this.positions[s].xOffset += this.positions[_].xOffset, this.positions[s].yOffset += this.positions[_].yOffset, this.direction === "ltr")
          for (let _e = _; _e < s; _e++)
            this.positions[s].xOffset -= this.positions[_e].xAdvance, this.positions[s].yOffset -= this.positions[_e].yAdvance;
        else
          for (let _e = _ + 1; _e < s + 1; _e++)
            this.positions[s].xOffset += this.positions[_e].xAdvance, this.positions[s].yOffset += this.positions[_e].yAdvance;
      }
    }
  }
}
class $a62492810de27e3d$export$2e2bcd8739ae039 {
  setup(s) {
    this.glyphInfos = s.glyphs.map((_) => new $10e7b257e1a9a756$export$2e2bcd8739ae039(this.font, _.id, [
      ..._.codePoints
    ]));
    let $ = null;
    this.GPOSProcessor && ($ = this.GPOSProcessor.selectScript(s.script, s.language, s.direction)), this.GSUBProcessor && ($ = this.GSUBProcessor.selectScript(s.script, s.language, s.direction)), this.shaper = $102b6fe50f1d50b4$export$7877a478dd30fd3d($), this.plan = new $94d7a73bd2edfc9a$export$2e2bcd8739ae039(this.font, $, s.direction), this.shaper.plan(this.plan, this.glyphInfos, s.features);
    for (let _ in this.plan.allFeatures)
      s.features[_] = !0;
  }
  substitute(s) {
    this.GSUBProcessor && (this.plan.process(this.GSUBProcessor, this.glyphInfos), s.glyphs = this.glyphInfos.map(($) => this.font.getGlyph($.id, $.codePoints)));
  }
  position(s) {
    return this.shaper.zeroMarkWidths === "BEFORE_GPOS" && this.zeroMarkAdvances(s.positions), this.GPOSProcessor && this.plan.process(this.GPOSProcessor, this.glyphInfos, s.positions), this.shaper.zeroMarkWidths === "AFTER_GPOS" && this.zeroMarkAdvances(s.positions), s.direction === "rtl" && (s.glyphs.reverse(), s.positions.reverse()), this.GPOSProcessor && this.GPOSProcessor.features;
  }
  zeroMarkAdvances(s) {
    for (let $ = 0; $ < this.glyphInfos.length; $++)
      this.glyphInfos[$].isMark && (s[$].xAdvance = 0, s[$].yAdvance = 0);
  }
  cleanup() {
    this.glyphInfos = null, this.plan = null, this.shaper = null;
  }
  getAvailableFeatures(s, $) {
    let _ = [];
    return this.GSUBProcessor && (this.GSUBProcessor.selectScript(s, $), _.push(...Object.keys(this.GSUBProcessor.features))), this.GPOSProcessor && (this.GPOSProcessor.selectScript(s, $), _.push(...Object.keys(this.GPOSProcessor.features))), _;
  }
  constructor(s) {
    this.font = s, this.glyphInfos = null, this.plan = null, this.GSUBProcessor = null, this.GPOSProcessor = null, this.fallbackPosition = !0, s.GSUB && (this.GSUBProcessor = new $0a876c45f1f7c41c$export$2e2bcd8739ae039(s, s.GSUB)), s.GPOS && (this.GPOSProcessor = new $c96c93587d49c14d$export$2e2bcd8739ae039(s, s.GPOS));
  }
}
class $4c0a7fa5df7a9ab1$export$2e2bcd8739ae039 {
  layout(s, $, _, _e, tt) {
    if (typeof $ == "string" && (tt = _e, _e = _, _ = $, $ = []), typeof s == "string") {
      _ == null && (_ = $130d1a642ebcd2b7$export$e5cb25e204fb8450(s));
      var nt = this.font.glyphsForString(s);
    } else {
      if (_ == null) {
        let rt = [];
        for (let st of s)
          rt.push(...st.codePoints);
        _ = $130d1a642ebcd2b7$export$16fab0757cfc223d(rt);
      }
      var nt = s;
    }
    let at = new $be07b3e97a42687a$export$2e2bcd8739ae039(nt, $, _, _e, tt);
    return nt.length === 0 ? (at.positions = [], at) : (this.engine && this.engine.setup && this.engine.setup(at), this.substitute(at), this.position(at), this.hideDefaultIgnorables(at.glyphs, at.positions), this.engine && this.engine.cleanup && this.engine.cleanup(), at);
  }
  substitute(s) {
    this.engine && this.engine.substitute && this.engine.substitute(s);
  }
  position(s) {
    s.positions = s.glyphs.map((_) => new $1ac75d9a55b67f01$export$2e2bcd8739ae039(_.advanceWidth));
    let $ = null;
    this.engine && this.engine.position && ($ = this.engine.position(s)), !$ && (!this.engine || this.engine.fallbackPosition) && (this.unicodeLayoutEngine || (this.unicodeLayoutEngine = new $0a4bdfeb6dfd6f5e$export$2e2bcd8739ae039(this.font)), this.unicodeLayoutEngine.positionGlyphs(s.glyphs, s.positions)), (!$ || !$.kern) && s.features.kern !== !1 && this.font.kern && (this.kernProcessor || (this.kernProcessor = new $0bba3a9db57637f3$export$2e2bcd8739ae039(this.font)), this.kernProcessor.process(s.glyphs, s.positions), s.features.kern = !0);
  }
  hideDefaultIgnorables(s, $) {
    let _ = this.font.glyphForCodePoint(32);
    for (let _e = 0; _e < s.length; _e++)
      this.isDefaultIgnorable(s[_e].codePoints[0]) && (s[_e] = _, $[_e].xAdvance = 0, $[_e].yAdvance = 0);
  }
  isDefaultIgnorable(s) {
    let $ = s >> 16;
    if ($ === 0)
      switch (s >> 8) {
        case 0:
          return s === 173;
        case 3:
          return s === 847;
        case 6:
          return s === 1564;
        case 23:
          return 6068 <= s && s <= 6069;
        case 24:
          return 6155 <= s && s <= 6158;
        case 32:
          return 8203 <= s && s <= 8207 || 8234 <= s && s <= 8238 || 8288 <= s && s <= 8303;
        case 254:
          return 65024 <= s && s <= 65039 || s === 65279;
        case 255:
          return 65520 <= s && s <= 65528;
        default:
          return !1;
      }
    else
      switch ($) {
        case 1:
          return 113824 <= s && s <= 113827 || 119155 <= s && s <= 119162;
        case 14:
          return 917504 <= s && s <= 921599;
        default:
          return !1;
      }
  }
  getAvailableFeatures(s, $) {
    let _ = [];
    return this.engine && _.push(...this.engine.getAvailableFeatures(s, $)), this.font.kern && _.indexOf("kern") === -1 && _.push("kern"), _;
  }
  stringsForGlyph(s) {
    let $ = /* @__PURE__ */ new Set(), _ = this.font._cmapProcessor.codePointsForGlyph(s);
    for (let _e of _)
      $.add(String.fromCodePoint(_e));
    if (this.engine && this.engine.stringsForGlyph)
      for (let _e of this.engine.stringsForGlyph(s))
        $.add(_e);
    return Array.from($);
  }
  constructor(s) {
    this.font = s, this.unicodeLayoutEngine = null, this.kernProcessor = null, this.font.morx ? this.engine = new $ba6dd74203be8728$export$2e2bcd8739ae039(this.font) : (this.font.GSUB || this.font.GPOS) && (this.engine = new $a62492810de27e3d$export$2e2bcd8739ae039(this.font));
  }
}
const $f43aec954cdfdf21$var$SVG_COMMANDS = {
  moveTo: "M",
  lineTo: "L",
  quadraticCurveTo: "Q",
  bezierCurveTo: "C",
  closePath: "Z"
};
class $f43aec954cdfdf21$export$2e2bcd8739ae039 {
  /**
  * Compiles the path to a JavaScript function that can be applied with
  * a graphics context in order to render the path.
  * @return {string}
  */
  toFunction() {
    return (s) => {
      this.commands.forEach(($) => s[$.command].apply(s, $.args));
    };
  }
  /**
  * Converts the path to an SVG path data string
  * @return {string}
  */
  toSVG() {
    return this.commands.map(($) => {
      let _ = $.args.map((_e) => Math.round(_e * 100) / 100);
      return `${$f43aec954cdfdf21$var$SVG_COMMANDS[$.command]}${_.join(" ")}`;
    }).join("");
  }
  /**
  * Gets the "control box" of a path.
  * This is like the bounding box, but it includes all points including
  * control points of bezier segments and is much faster to compute than
  * the real bounding box.
  * @type {BBox}
  */
  get cbox() {
    if (!this._cbox) {
      let s = new $f34600ab9d7f70d8$export$2e2bcd8739ae039();
      for (let $ of this.commands)
        for (let _ = 0; _ < $.args.length; _ += 2)
          s.addPoint($.args[_], $.args[_ + 1]);
      this._cbox = Object.freeze(s);
    }
    return this._cbox;
  }
  /**
  * Gets the exact bounding box of the path by evaluating curve segments.
  * Slower to compute than the control box, but more accurate.
  * @type {BBox}
  */
  get bbox() {
    if (this._bbox)
      return this._bbox;
    let s = new $f34600ab9d7f70d8$export$2e2bcd8739ae039(), $ = 0, _ = 0, _e = (gt) => Math.pow(1 - gt, 3) * it[dt] + 3 * Math.pow(1 - gt, 2) * gt * ut[dt] + 3 * (1 - gt) * Math.pow(gt, 2) * ft[dt] + Math.pow(gt, 3) * ht[dt];
    for (let gt of this.commands)
      switch (gt.command) {
        case "moveTo":
        case "lineTo":
          let [pt, mt] = gt.args;
          s.addPoint(pt, mt), $ = pt, _ = mt;
          break;
        case "quadraticCurveTo":
        case "bezierCurveTo":
          if (gt.command === "quadraticCurveTo")
            var [tt, nt, lt, et] = gt.args, at = $ + 2 / 3 * (tt - $), ot = _ + 2 / 3 * (nt - _), rt = lt + 2 / 3 * (tt - lt), st = et + 2 / 3 * (nt - et);
          else
            var [at, ot, rt, st, lt, et] = gt.args;
          s.addPoint(lt, et);
          for (var it = [
            $,
            _
          ], ut = [
            at,
            ot
          ], ft = [
            rt,
            st
          ], ht = [
            lt,
            et
          ], dt = 0; dt <= 1; dt++) {
            let ct = 6 * it[dt] - 12 * ut[dt] + 6 * ft[dt], vt = -3 * it[dt] + 9 * ut[dt] - 9 * ft[dt] + 3 * ht[dt];
            if (gt = 3 * ut[dt] - 3 * it[dt], vt === 0) {
              if (ct === 0)
                continue;
              let Et = -gt / ct;
              0 < Et && Et < 1 && (dt === 0 ? s.addPoint(_e(Et), s.maxY) : dt === 1 && s.addPoint(s.maxX, _e(Et)));
              continue;
            }
            let At = Math.pow(ct, 2) - 4 * gt * vt;
            if (At < 0)
              continue;
            let xt = (-ct + Math.sqrt(At)) / (2 * vt);
            0 < xt && xt < 1 && (dt === 0 ? s.addPoint(_e(xt), s.maxY) : dt === 1 && s.addPoint(s.maxX, _e(xt)));
            let bt = (-ct - Math.sqrt(At)) / (2 * vt);
            0 < bt && bt < 1 && (dt === 0 ? s.addPoint(_e(bt), s.maxY) : dt === 1 && s.addPoint(s.maxX, _e(bt)));
          }
          $ = lt, _ = et;
          break;
      }
    return this._bbox = Object.freeze(s);
  }
  /**
  * Applies a mapping function to each point in the path.
  * @param {function} fn
  * @return {Path}
  */
  mapPoints(s) {
    let $ = new $f43aec954cdfdf21$export$2e2bcd8739ae039();
    for (let _ of this.commands) {
      let _e = [];
      for (let tt = 0; tt < _.args.length; tt += 2) {
        let [nt, at] = s(_.args[tt], _.args[tt + 1]);
        _e.push(nt, at);
      }
      $[_.command](..._e);
    }
    return $;
  }
  /**
  * Transforms the path by the given matrix.
  */
  transform(s, $, _, _e, tt, nt) {
    return this.mapPoints((at, ot) => {
      const rt = s * at + _ * ot + tt, st = $ * at + _e * ot + nt;
      return [
        rt,
        st
      ];
    });
  }
  /**
  * Translates the path by the given offset.
  */
  translate(s, $) {
    return this.transform(1, 0, 0, 1, s, $);
  }
  /**
  * Rotates the path by the given angle (in radians).
  */
  rotate(s) {
    let $ = Math.cos(s), _ = Math.sin(s);
    return this.transform($, _, -_, $, 0, 0);
  }
  /**
  * Scales the path.
  */
  scale(s, $ = s) {
    return this.transform(s, 0, 0, $, 0, 0);
  }
  constructor() {
    this.commands = [], this._bbox = null, this._cbox = null;
  }
}
for (let a of [
  "moveTo",
  "lineTo",
  "quadraticCurveTo",
  "bezierCurveTo",
  "closePath"
])
  $f43aec954cdfdf21$export$2e2bcd8739ae039.prototype[a] = function(...s) {
    return this._bbox = this._cbox = null, this.commands.push({
      command: a,
      args: s
    }), this;
  };
var $7713b9b7b438dff8$export$2e2bcd8739ae039 = [
  ".notdef",
  ".null",
  "nonmarkingreturn",
  "space",
  "exclam",
  "quotedbl",
  "numbersign",
  "dollar",
  "percent",
  "ampersand",
  "quotesingle",
  "parenleft",
  "parenright",
  "asterisk",
  "plus",
  "comma",
  "hyphen",
  "period",
  "slash",
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "colon",
  "semicolon",
  "less",
  "equal",
  "greater",
  "question",
  "at",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "bracketleft",
  "backslash",
  "bracketright",
  "asciicircum",
  "underscore",
  "grave",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "braceleft",
  "bar",
  "braceright",
  "asciitilde",
  "Adieresis",
  "Aring",
  "Ccedilla",
  "Eacute",
  "Ntilde",
  "Odieresis",
  "Udieresis",
  "aacute",
  "agrave",
  "acircumflex",
  "adieresis",
  "atilde",
  "aring",
  "ccedilla",
  "eacute",
  "egrave",
  "ecircumflex",
  "edieresis",
  "iacute",
  "igrave",
  "icircumflex",
  "idieresis",
  "ntilde",
  "oacute",
  "ograve",
  "ocircumflex",
  "odieresis",
  "otilde",
  "uacute",
  "ugrave",
  "ucircumflex",
  "udieresis",
  "dagger",
  "degree",
  "cent",
  "sterling",
  "section",
  "bullet",
  "paragraph",
  "germandbls",
  "registered",
  "copyright",
  "trademark",
  "acute",
  "dieresis",
  "notequal",
  "AE",
  "Oslash",
  "infinity",
  "plusminus",
  "lessequal",
  "greaterequal",
  "yen",
  "mu",
  "partialdiff",
  "summation",
  "product",
  "pi",
  "integral",
  "ordfeminine",
  "ordmasculine",
  "Omega",
  "ae",
  "oslash",
  "questiondown",
  "exclamdown",
  "logicalnot",
  "radical",
  "florin",
  "approxequal",
  "Delta",
  "guillemotleft",
  "guillemotright",
  "ellipsis",
  "nonbreakingspace",
  "Agrave",
  "Atilde",
  "Otilde",
  "OE",
  "oe",
  "endash",
  "emdash",
  "quotedblleft",
  "quotedblright",
  "quoteleft",
  "quoteright",
  "divide",
  "lozenge",
  "ydieresis",
  "Ydieresis",
  "fraction",
  "currency",
  "guilsinglleft",
  "guilsinglright",
  "fi",
  "fl",
  "daggerdbl",
  "periodcentered",
  "quotesinglbase",
  "quotedblbase",
  "perthousand",
  "Acircumflex",
  "Ecircumflex",
  "Aacute",
  "Edieresis",
  "Egrave",
  "Iacute",
  "Icircumflex",
  "Idieresis",
  "Igrave",
  "Oacute",
  "Ocircumflex",
  "apple",
  "Ograve",
  "Uacute",
  "Ucircumflex",
  "Ugrave",
  "dotlessi",
  "circumflex",
  "tilde",
  "macron",
  "breve",
  "dotaccent",
  "ring",
  "cedilla",
  "hungarumlaut",
  "ogonek",
  "caron",
  "Lslash",
  "lslash",
  "Scaron",
  "scaron",
  "Zcaron",
  "zcaron",
  "brokenbar",
  "Eth",
  "eth",
  "Yacute",
  "yacute",
  "Thorn",
  "thorn",
  "minus",
  "multiply",
  "onesuperior",
  "twosuperior",
  "threesuperior",
  "onehalf",
  "onequarter",
  "threequarters",
  "franc",
  "Gbreve",
  "gbreve",
  "Idotaccent",
  "Scedilla",
  "scedilla",
  "Cacute",
  "cacute",
  "Ccaron",
  "ccaron",
  "dcroat"
];
class $f92906be28e61769$export$2e2bcd8739ae039 {
  _getPath() {
    return new $f43aec954cdfdf21$export$2e2bcd8739ae039();
  }
  _getCBox() {
    return this.path.cbox;
  }
  _getBBox() {
    return this.path.bbox;
  }
  _getTableMetrics(s) {
    if (this.id < s.metrics.length)
      return s.metrics.get(this.id);
    let $ = s.metrics.get(s.metrics.length - 1);
    return {
      advance: $ ? $.advance : 0,
      bearing: s.bearings.get(this.id - s.metrics.length) || 0
    };
  }
  _getMetrics(s) {
    if (this._metrics)
      return this._metrics;
    let { advance: $, bearing: _ } = this._getTableMetrics(this._font.hmtx);
    if (this._font.vmtx)
      var { advance: _e, bearing: tt } = this._getTableMetrics(this._font.vmtx);
    else {
      let nt;
      if ((typeof s > "u" || s === null) && ({ cbox: s } = this), (nt = this._font["OS/2"]) && nt.version > 0)
        var _e = Math.abs(nt.typoAscender - nt.typoDescender), tt = nt.typoAscender - s.maxY;
      else {
        let { hhea: at } = this._font;
        var _e = Math.abs(at.ascent - at.descent), tt = at.ascent - s.maxY;
      }
    }
    return this._font._variationProcessor && this._font.HVAR && ($ += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR)), this._metrics = {
      advanceWidth: $,
      advanceHeight: _e,
      leftBearing: _,
      topBearing: tt
    };
  }
  /**
  * The glyph’s control box.
  * This is often the same as the bounding box, but is faster to compute.
  * Because of the way bezier curves are defined, some of the control points
  * can be outside of the bounding box. Where `bbox` takes this into account,
  * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
  * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
  * for a more detailed description.
  *
  * @type {BBox}
  */
  get cbox() {
    return this._getCBox();
  }
  /**
  * The glyph’s bounding box, i.e. the rectangle that encloses the
  * glyph outline as tightly as possible.
  * @type {BBox}
  */
  get bbox() {
    return this._getBBox();
  }
  /**
  * A vector Path object representing the glyph outline.
  * @type {Path}
  */
  get path() {
    return this._getPath();
  }
  /**
  * Returns a path scaled to the given font size.
  * @param {number} size
  * @return {Path}
  */
  getScaledPath(s) {
    let $ = 1 / this._font.unitsPerEm * s;
    return this.path.scale($);
  }
  /**
  * The glyph's advance width.
  * @type {number}
  */
  get advanceWidth() {
    return this._getMetrics().advanceWidth;
  }
  /**
  * The glyph's advance height.
  * @type {number}
  */
  get advanceHeight() {
    return this._getMetrics().advanceHeight;
  }
  get ligatureCaretPositions() {
  }
  _getName() {
    let { post: s } = this._font;
    if (!s)
      return null;
    switch (s.version) {
      case 1:
        return $7713b9b7b438dff8$export$2e2bcd8739ae039[this.id];
      case 2:
        let $ = s.glyphNameIndex[this.id];
        return $ < $7713b9b7b438dff8$export$2e2bcd8739ae039.length ? $7713b9b7b438dff8$export$2e2bcd8739ae039[$] : s.names[$ - $7713b9b7b438dff8$export$2e2bcd8739ae039.length];
      case 2.5:
        return $7713b9b7b438dff8$export$2e2bcd8739ae039[this.id + s.offsets[this.id]];
      case 4:
        return String.fromCharCode(s.map[this.id]);
    }
  }
  /**
  * The glyph's name
  * @type {string}
  */
  get name() {
    return this._getName();
  }
  /**
  * Renders the glyph to the given graphics context, at the specified font size.
  * @param {CanvasRenderingContext2d} ctx
  * @param {number} size
  */
  render(s, $) {
    s.save();
    let _ = 1 / this._font.head.unitsPerEm * $;
    s.scale(_, _), this.path.toFunction()(s), s.fill(), s.restore();
  }
  constructor(s, $, _) {
    this.id = s, this.codePoints = $, this._font = _, this.isMark = this.codePoints.length > 0 && this.codePoints.every($747425b437e121da$export$e33ad6871e762338), this.isLigature = this.codePoints.length > 1;
  }
}
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "cbox", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "bbox", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "path", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "advanceWidth", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "advanceHeight", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $f92906be28e61769$export$2e2bcd8739ae039.prototype, "name", null);
let $69aac16029968692$var$GlyfHeader = new Struct({
  numberOfContours: int16,
  xMin: int16,
  yMin: int16,
  xMax: int16,
  yMax: int16
});
const $69aac16029968692$var$ON_CURVE = 1, $69aac16029968692$var$X_SHORT_VECTOR = 2, $69aac16029968692$var$Y_SHORT_VECTOR = 4, $69aac16029968692$var$REPEAT = 8, $69aac16029968692$var$SAME_X = 16, $69aac16029968692$var$SAME_Y = 32, $69aac16029968692$var$ARG_1_AND_2_ARE_WORDS = 1, $69aac16029968692$var$WE_HAVE_A_SCALE = 8, $69aac16029968692$var$MORE_COMPONENTS = 32, $69aac16029968692$var$WE_HAVE_AN_X_AND_Y_SCALE = 64, $69aac16029968692$var$WE_HAVE_A_TWO_BY_TWO = 128, $69aac16029968692$var$WE_HAVE_INSTRUCTIONS = 256;
class $69aac16029968692$export$baf26146a414f24a {
  copy() {
    return new $69aac16029968692$export$baf26146a414f24a(this.onCurve, this.endContour, this.x, this.y);
  }
  constructor(s, $, _ = 0, _e = 0) {
    this.onCurve = s, this.endContour = $, this.x = _, this.y = _e;
  }
}
class $69aac16029968692$var$Component {
  constructor(s, $, _) {
    this.glyphID = s, this.dx = $, this.dy = _, this.pos = 0, this.scaleX = this.scaleY = 1, this.scale01 = this.scale10 = 0;
  }
}
class $69aac16029968692$export$2e2bcd8739ae039 extends $f92906be28e61769$export$2e2bcd8739ae039 {
  // Parses just the glyph header and returns the bounding box
  _getCBox(s) {
    if (this._font._variationProcessor && !s)
      return this.path.cbox;
    let $ = this._font._getTableStream("glyf");
    $.pos += this._font.loca.offsets[this.id];
    let _ = $69aac16029968692$var$GlyfHeader.decode($), _e = new $f34600ab9d7f70d8$export$2e2bcd8739ae039(_.xMin, _.yMin, _.xMax, _.yMax);
    return Object.freeze(_e);
  }
  // Parses a single glyph coordinate
  _parseGlyphCoord(s, $, _, _e) {
    if (_) {
      var tt = s.readUInt8();
      _e || (tt = -tt), tt += $;
    } else if (_e)
      var tt = $;
    else
      var tt = $ + s.readInt16BE();
    return tt;
  }
  // Decodes the glyph data into points for simple glyphs,
  // or components for composite glyphs
  _decode() {
    let s = this._font.loca.offsets[this.id], $ = this._font.loca.offsets[this.id + 1];
    if (s === $)
      return null;
    let _ = this._font._getTableStream("glyf");
    _.pos += s;
    let _e = _.pos, tt = $69aac16029968692$var$GlyfHeader.decode(_);
    return tt.numberOfContours > 0 ? this._decodeSimple(tt, _) : tt.numberOfContours < 0 && this._decodeComposite(tt, _, _e), tt;
  }
  _decodeSimple(s, $) {
    s.points = [];
    let _ = new ArrayT(uint16, s.numberOfContours).decode($);
    s.instructions = new ArrayT(uint8, uint16).decode($);
    let _e = [], tt = _[_.length - 1] + 1;
    for (; _e.length < tt; ) {
      var nt = $.readUInt8();
      if (_e.push(nt), nt & $69aac16029968692$var$REPEAT) {
        let st = $.readUInt8();
        for (let lt = 0; lt < st; lt++)
          _e.push(nt);
      }
    }
    for (var at = 0; at < _e.length; at++) {
      var nt = _e[at];
      let lt = new $69aac16029968692$export$baf26146a414f24a(!!(nt & $69aac16029968692$var$ON_CURVE), _.indexOf(at) >= 0, 0, 0);
      s.points.push(lt);
    }
    let ot = 0;
    for (var at = 0; at < _e.length; at++) {
      var nt = _e[at];
      s.points[at].x = ot = this._parseGlyphCoord($, ot, nt & $69aac16029968692$var$X_SHORT_VECTOR, nt & $69aac16029968692$var$SAME_X);
    }
    let rt = 0;
    for (var at = 0; at < _e.length; at++) {
      var nt = _e[at];
      s.points[at].y = rt = this._parseGlyphCoord($, rt, nt & $69aac16029968692$var$Y_SHORT_VECTOR, nt & $69aac16029968692$var$SAME_Y);
    }
    if (this._font._variationProcessor) {
      let st = s.points.slice();
      st.push(...this._getPhantomPoints(s)), this._font._variationProcessor.transformPoints(this.id, st), s.phantomPoints = st.slice(-4);
    }
  }
  _decodeComposite(s, $, _ = 0) {
    s.components = [];
    let _e = !1, tt = $69aac16029968692$var$MORE_COMPONENTS;
    for (; tt & $69aac16029968692$var$MORE_COMPONENTS; ) {
      tt = $.readUInt16BE();
      let rt = $.pos - _, st = $.readUInt16BE();
      if (_e || (_e = (tt & $69aac16029968692$var$WE_HAVE_INSTRUCTIONS) !== 0), tt & $69aac16029968692$var$ARG_1_AND_2_ARE_WORDS)
        var nt = $.readInt16BE(), at = $.readInt16BE();
      else
        var nt = $.readInt8(), at = $.readInt8();
      var ot = new $69aac16029968692$var$Component(st, nt, at);
      ot.pos = rt, tt & $69aac16029968692$var$WE_HAVE_A_SCALE ? ot.scaleX = ot.scaleY = ($.readUInt8() << 24 | $.readUInt8() << 16) / 1073741824 : tt & $69aac16029968692$var$WE_HAVE_AN_X_AND_Y_SCALE ? (ot.scaleX = ($.readUInt8() << 24 | $.readUInt8() << 16) / 1073741824, ot.scaleY = ($.readUInt8() << 24 | $.readUInt8() << 16) / 1073741824) : tt & $69aac16029968692$var$WE_HAVE_A_TWO_BY_TWO && (ot.scaleX = ($.readUInt8() << 24 | $.readUInt8() << 16) / 1073741824, ot.scale01 = ($.readUInt8() << 24 | $.readUInt8() << 16) / 1073741824, ot.scale10 = ($.readUInt8() << 24 | $.readUInt8() << 16) / 1073741824, ot.scaleY = ($.readUInt8() << 24 | $.readUInt8() << 16) / 1073741824), s.components.push(ot);
    }
    if (this._font._variationProcessor) {
      let rt = [];
      for (let st = 0; st < s.components.length; st++) {
        var ot = s.components[st];
        rt.push(new $69aac16029968692$export$baf26146a414f24a(!0, !0, ot.dx, ot.dy));
      }
      rt.push(...this._getPhantomPoints(s)), this._font._variationProcessor.transformPoints(this.id, rt), s.phantomPoints = rt.splice(-4, 4);
      for (let st = 0; st < rt.length; st++) {
        let lt = rt[st];
        s.components[st].dx = lt.x, s.components[st].dy = lt.y;
      }
    }
    return _e;
  }
  _getPhantomPoints(s) {
    let $ = this._getCBox(!0);
    this._metrics == null && (this._metrics = $f92906be28e61769$export$2e2bcd8739ae039.prototype._getMetrics.call(this, $));
    let { advanceWidth: _, advanceHeight: _e, leftBearing: tt, topBearing: nt } = this._metrics;
    return [
      new $69aac16029968692$export$baf26146a414f24a(!1, !0, s.xMin - tt, 0),
      new $69aac16029968692$export$baf26146a414f24a(!1, !0, s.xMin - tt + _, 0),
      new $69aac16029968692$export$baf26146a414f24a(!1, !0, 0, s.yMax + nt),
      new $69aac16029968692$export$baf26146a414f24a(!1, !0, 0, s.yMax + nt + _e)
    ];
  }
  // Decodes font data, resolves composite glyphs, and returns an array of contours
  _getContours() {
    let s = this._decode();
    if (!s)
      return [];
    let $ = [];
    if (s.numberOfContours < 0)
      for (let nt of s.components) {
        let at = this._font.getGlyph(nt.glyphID)._getContours();
        for (let ot = 0; ot < at.length; ot++) {
          let rt = at[ot];
          for (let st = 0; st < rt.length; st++) {
            let lt = rt[st], et = lt.x * nt.scaleX + lt.y * nt.scale01 + nt.dx, it = lt.y * nt.scaleY + lt.x * nt.scale10 + nt.dy;
            $.push(new $69aac16029968692$export$baf26146a414f24a(lt.onCurve, lt.endContour, et, it));
          }
        }
      }
    else
      $ = s.points || [];
    s.phantomPoints && !this._font.directory.tables.HVAR && (this._metrics.advanceWidth = s.phantomPoints[1].x - s.phantomPoints[0].x, this._metrics.advanceHeight = s.phantomPoints[3].y - s.phantomPoints[2].y, this._metrics.leftBearing = s.xMin - s.phantomPoints[0].x, this._metrics.topBearing = s.phantomPoints[2].y - s.yMax);
    let _ = [], _e = [];
    for (let nt = 0; nt < $.length; nt++) {
      var tt = $[nt];
      _e.push(tt), tt.endContour && (_.push(_e), _e = []);
    }
    return _;
  }
  _getMetrics() {
    if (this._metrics)
      return this._metrics;
    let s = this._getCBox(!0);
    return super._getMetrics(s), this._font._variationProcessor && !this._font.HVAR && this.path, this._metrics;
  }
  // Converts contours to a Path object that can be rendered
  _getPath() {
    let s = this._getContours(), $ = new $f43aec954cdfdf21$export$2e2bcd8739ae039();
    for (let _e = 0; _e < s.length; _e++) {
      let tt = s[_e], nt = tt[0], at = tt[tt.length - 1], ot = 0;
      if (nt.onCurve) {
        var _ = null;
        ot = 1;
      } else {
        at.onCurve ? nt = at : nt = new $69aac16029968692$export$baf26146a414f24a(!1, !1, (nt.x + at.x) / 2, (nt.y + at.y) / 2);
        var _ = nt;
      }
      $.moveTo(nt.x, nt.y);
      for (let rt = ot; rt < tt.length; rt++) {
        let st = tt[rt], lt = rt === 0 ? nt : tt[rt - 1];
        if (lt.onCurve && st.onCurve)
          $.lineTo(st.x, st.y);
        else if (lt.onCurve && !st.onCurve)
          var _ = st;
        else if (!lt.onCurve && !st.onCurve) {
          let it = (lt.x + st.x) / 2, ut = (lt.y + st.y) / 2;
          $.quadraticCurveTo(lt.x, lt.y, it, ut);
          var _ = st;
        } else if (!lt.onCurve && st.onCurve) {
          $.quadraticCurveTo(_.x, _.y, st.x, st.y);
          var _ = null;
        } else
          throw new Error("Unknown TTF path state");
      }
      _ && $.quadraticCurveTo(_.x, _.y, nt.x, nt.y), $.closePath();
    }
    return $;
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "TTF");
  }
}
class $62cc5109c6101893$export$2e2bcd8739ae039 extends $f92906be28e61769$export$2e2bcd8739ae039 {
  _getName() {
    return this._font.CFF2 ? super._getName() : this._font["CFF "].getGlyphName(this.id);
  }
  bias(s) {
    return s.length < 1240 ? 107 : s.length < 33900 ? 1131 : 32768;
  }
  _getPath() {
    let s = this._font.CFF2 || this._font["CFF "], { stream: $ } = s, _ = s.topDict.CharStrings[this.id], _e = _.offset + _.length;
    $.pos = _.offset;
    let tt = new $f43aec954cdfdf21$export$2e2bcd8739ae039(), nt = [], at = [], ot = null, rt = 0, st = 0, lt = 0, et, it, ut = !1;
    this._usedGsubrs = et = {}, this._usedSubrs = it = {};
    let ft = s.globalSubrIndex || [], ht = this.bias(ft), dt = s.privateDictForGlyph(this.id) || {}, gt = dt.Subrs || [], pt = this.bias(gt), mt = s.topDict.vstore && s.topDict.vstore.itemVariationStore, ct = dt.vsindex, vt = this._font._variationProcessor;
    function At() {
      ot == null && (ot = nt.shift() + dt.nominalWidthX);
    }
    function xt() {
      return nt.length % 2 !== 0 && At(), rt += nt.length >> 1, nt.length = 0;
    }
    function bt(St, Bt) {
      ut && tt.closePath(), tt.moveTo(St, Bt), ut = !0;
    }
    let Et = function() {
      for (; $.pos < _e; ) {
        let Rt = $.readUInt8();
        if (Rt < 32) {
          let kt, jt, Ht;
          switch (Rt) {
            case 1:
            case 3:
            case 18:
            case 23:
              xt();
              break;
            case 4:
              nt.length > 1 && At(), lt += nt.shift(), bt(st, lt);
              break;
            case 5:
              for (; nt.length >= 2; )
                st += nt.shift(), lt += nt.shift(), tt.lineTo(st, lt);
              break;
            case 6:
            case 7:
              for (Ht = Rt === 6; nt.length >= 1; )
                Ht ? st += nt.shift() : lt += nt.shift(), tt.lineTo(st, lt), Ht = !Ht;
              break;
            case 8:
              for (; nt.length > 0; ) {
                var Ot = st + nt.shift(), Pt = lt + nt.shift(), wt = Ot + nt.shift(), Ct = Pt + nt.shift();
                st = wt + nt.shift(), lt = Ct + nt.shift(), tt.bezierCurveTo(Ot, Pt, wt, Ct, st, lt);
              }
              break;
            case 10:
              if (kt = nt.pop() + pt, jt = gt[kt], jt) {
                it[kt] = !0;
                var St = $.pos, Bt = _e;
                $.pos = jt.offset, _e = jt.offset + jt.length, Et(), $.pos = St, _e = Bt;
              }
              break;
            case 11:
              if (s.version >= 2)
                break;
              return;
            case 14:
              if (s.version >= 2)
                break;
              nt.length > 0 && At(), ut && (tt.closePath(), ut = !1);
              break;
            case 15:
              if (s.version < 2)
                throw new Error("vsindex operator not supported in CFF v1");
              ct = nt.pop();
              break;
            case 16: {
              if (s.version < 2)
                throw new Error("blend operator not supported in CFF v1");
              if (!vt)
                throw new Error("blend operator in non-variation font");
              let Ft = vt.getBlendVector(mt, ct), _t = nt.pop(), Nt = _t * Ft.length, Mt = nt.length - Nt, Lt = Mt - _t;
              for (let $t = 0; $t < _t; $t++) {
                let Tt = nt[Lt + $t];
                for (let Dt = 0; Dt < Ft.length; Dt++)
                  Tt += Ft[Dt] * nt[Mt++];
                nt[Lt + $t] = Tt;
              }
              for (; Nt--; )
                nt.pop();
              break;
            }
            case 19:
            case 20:
              xt(), $.pos += rt + 7 >> 3;
              break;
            case 21:
              nt.length > 2 && At(), st += nt.shift(), lt += nt.shift(), bt(st, lt);
              break;
            case 22:
              nt.length > 1 && At(), st += nt.shift(), bt(st, lt);
              break;
            case 24:
              for (; nt.length >= 8; ) {
                var Ot = st + nt.shift(), Pt = lt + nt.shift(), wt = Ot + nt.shift(), Ct = Pt + nt.shift();
                st = wt + nt.shift(), lt = Ct + nt.shift(), tt.bezierCurveTo(Ot, Pt, wt, Ct, st, lt);
              }
              st += nt.shift(), lt += nt.shift(), tt.lineTo(st, lt);
              break;
            case 25:
              for (; nt.length >= 8; )
                st += nt.shift(), lt += nt.shift(), tt.lineTo(st, lt);
              var Ot = st + nt.shift(), Pt = lt + nt.shift(), wt = Ot + nt.shift(), Ct = Pt + nt.shift();
              st = wt + nt.shift(), lt = Ct + nt.shift(), tt.bezierCurveTo(Ot, Pt, wt, Ct, st, lt);
              break;
            case 26:
              for (nt.length % 2 && (st += nt.shift()); nt.length >= 4; )
                Ot = st, Pt = lt + nt.shift(), wt = Ot + nt.shift(), Ct = Pt + nt.shift(), st = wt, lt = Ct + nt.shift(), tt.bezierCurveTo(Ot, Pt, wt, Ct, st, lt);
              break;
            case 27:
              for (nt.length % 2 && (lt += nt.shift()); nt.length >= 4; )
                Ot = st + nt.shift(), Pt = lt, wt = Ot + nt.shift(), Ct = Pt + nt.shift(), st = wt + nt.shift(), lt = Ct, tt.bezierCurveTo(Ot, Pt, wt, Ct, st, lt);
              break;
            case 28:
              nt.push($.readInt16BE());
              break;
            case 29:
              if (kt = nt.pop() + ht, jt = ft[kt], jt) {
                et[kt] = !0;
                var St = $.pos, Bt = _e;
                $.pos = jt.offset, _e = jt.offset + jt.length, Et(), $.pos = St, _e = Bt;
              }
              break;
            case 30:
            case 31:
              for (Ht = Rt === 31; nt.length >= 4; )
                Ht ? (Ot = st + nt.shift(), Pt = lt, wt = Ot + nt.shift(), Ct = Pt + nt.shift(), lt = Ct + nt.shift(), st = wt + (nt.length === 1 ? nt.shift() : 0)) : (Ot = st, Pt = lt + nt.shift(), wt = Ot + nt.shift(), Ct = Pt + nt.shift(), st = wt + nt.shift(), lt = Ct + (nt.length === 1 ? nt.shift() : 0)), tt.bezierCurveTo(Ot, Pt, wt, Ct, st, lt), Ht = !Ht;
              break;
            case 12:
              switch (Rt = $.readUInt8(), Rt) {
                case 3:
                  let Ft = nt.pop(), _t = nt.pop();
                  nt.push(Ft && _t ? 1 : 0);
                  break;
                case 4:
                  Ft = nt.pop(), _t = nt.pop(), nt.push(Ft || _t ? 1 : 0);
                  break;
                case 5:
                  Ft = nt.pop(), nt.push(Ft ? 0 : 1);
                  break;
                case 9:
                  Ft = nt.pop(), nt.push(Math.abs(Ft));
                  break;
                case 10:
                  Ft = nt.pop(), _t = nt.pop(), nt.push(Ft + _t);
                  break;
                case 11:
                  Ft = nt.pop(), _t = nt.pop(), nt.push(Ft - _t);
                  break;
                case 12:
                  Ft = nt.pop(), _t = nt.pop(), nt.push(Ft / _t);
                  break;
                case 14:
                  Ft = nt.pop(), nt.push(-Ft);
                  break;
                case 15:
                  Ft = nt.pop(), _t = nt.pop(), nt.push(Ft === _t ? 1 : 0);
                  break;
                case 18:
                  nt.pop();
                  break;
                case 20:
                  let Nt = nt.pop(), Mt = nt.pop();
                  at[Mt] = Nt;
                  break;
                case 21:
                  Mt = nt.pop(), nt.push(at[Mt] || 0);
                  break;
                case 22:
                  let Lt = nt.pop(), $t = nt.pop(), Tt = nt.pop(), Dt = nt.pop();
                  nt.push(Tt <= Dt ? Lt : $t);
                  break;
                case 23:
                  nt.push(Math.random());
                  break;
                case 24:
                  Ft = nt.pop(), _t = nt.pop(), nt.push(Ft * _t);
                  break;
                case 26:
                  Ft = nt.pop(), nt.push(Math.sqrt(Ft));
                  break;
                case 27:
                  Ft = nt.pop(), nt.push(Ft, Ft);
                  break;
                case 28:
                  Ft = nt.pop(), _t = nt.pop(), nt.push(_t, Ft);
                  break;
                case 29:
                  Mt = nt.pop(), Mt < 0 ? Mt = 0 : Mt > nt.length - 1 && (Mt = nt.length - 1), nt.push(nt[Mt]);
                  break;
                case 30:
                  let Ut = nt.pop(), Vt = nt.pop();
                  if (Vt >= 0)
                    for (; Vt > 0; ) {
                      var It = nt[Ut - 1];
                      for (let sr = Ut - 2; sr >= 0; sr--)
                        nt[sr + 1] = nt[sr];
                      nt[0] = It, Vt--;
                    }
                  else
                    for (; Vt < 0; ) {
                      var It = nt[0];
                      for (let cr = 0; cr <= Ut; cr++)
                        nt[cr] = nt[cr + 1];
                      nt[Ut - 1] = It, Vt++;
                    }
                  break;
                case 34:
                  Ot = st + nt.shift(), Pt = lt, wt = Ot + nt.shift(), Ct = Pt + nt.shift();
                  let Qt = wt + nt.shift(), qt = Ct, Zt = Qt + nt.shift(), ar = qt, Jt = Zt + nt.shift(), rr = ar, Yt = Jt + nt.shift(), Kt = rr;
                  st = Yt, lt = Kt, tt.bezierCurveTo(Ot, Pt, wt, Ct, Qt, qt), tt.bezierCurveTo(Zt, ar, Jt, rr, Yt, Kt);
                  break;
                case 35:
                  let nr = [];
                  for (let sr = 0; sr <= 5; sr++)
                    st += nt.shift(), lt += nt.shift(), nr.push(st, lt);
                  tt.bezierCurveTo(...nr.slice(0, 6)), tt.bezierCurveTo(...nr.slice(6)), nt.shift();
                  break;
                case 36:
                  Ot = st + nt.shift(), Pt = lt + nt.shift(), wt = Ot + nt.shift(), Ct = Pt + nt.shift(), Qt = wt + nt.shift(), qt = Ct, Zt = Qt + nt.shift(), ar = qt, Jt = Zt + nt.shift(), rr = ar + nt.shift(), Yt = Jt + nt.shift(), Kt = rr, st = Yt, lt = Kt, tt.bezierCurveTo(Ot, Pt, wt, Ct, Qt, qt), tt.bezierCurveTo(Zt, ar, Jt, rr, Yt, Kt);
                  break;
                case 37:
                  let tr = st, ir = lt;
                  nr = [];
                  for (let sr = 0; sr <= 4; sr++)
                    st += nt.shift(), lt += nt.shift(), nr.push(st, lt);
                  Math.abs(st - tr) > Math.abs(lt - ir) ? (st += nt.shift(), lt = ir) : (st = tr, lt += nt.shift()), nr.push(st, lt), tt.bezierCurveTo(...nr.slice(0, 6)), tt.bezierCurveTo(...nr.slice(6));
                  break;
                default:
                  throw new Error(`Unknown op: 12 ${Rt}`);
              }
              break;
            default:
              throw new Error(`Unknown op: ${Rt}`);
          }
        } else if (Rt < 247)
          nt.push(Rt - 139);
        else if (Rt < 251) {
          var yt = $.readUInt8();
          nt.push((Rt - 247) * 256 + yt + 108);
        } else if (Rt < 255) {
          var yt = $.readUInt8();
          nt.push(-(Rt - 251) * 256 - yt - 108);
        } else
          nt.push($.readInt32BE() / 65536);
      }
    };
    return Et(), ut && tt.closePath(), tt;
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "CFF");
  }
}
let $25d8f049c222084c$var$SBIXImage = new Struct({
  originX: uint16,
  originY: uint16,
  type: new StringT(4),
  data: new BufferT((a) => a.parent.buflen - a._currentOffset)
});
class $25d8f049c222084c$export$2e2bcd8739ae039 extends $69aac16029968692$export$2e2bcd8739ae039 {
  /**
  * Returns an object representing a glyph image at the given point size.
  * The object has a data property with a Buffer containing the actual image data,
  * along with the image type, and origin.
  *
  * @param {number} size
  * @return {object}
  */
  getImageForSize(s) {
    for (let nt = 0; nt < this._font.sbix.imageTables.length; nt++) {
      var $ = this._font.sbix.imageTables[nt];
      if ($.ppem >= s)
        break;
    }
    let _ = $.imageOffsets, _e = _[this.id], tt = _[this.id + 1];
    return _e === tt ? null : (this._font.stream.pos = _e, $25d8f049c222084c$var$SBIXImage.decode(this._font.stream, {
      buflen: tt - _e
    }));
  }
  render(s, $) {
    let _ = this.getImageForSize($);
    if (_ != null) {
      let _e = $ / this._font.unitsPerEm;
      s.image(_.data, {
        height: $,
        x: _.originX,
        y: (this.bbox.minY - _.originY) * _e
      });
    }
    this._font.sbix.flags.renderOutlines && super.render(s, $);
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "SBIX");
  }
}
class $0d411f0165859681$var$COLRLayer {
  constructor(s, $) {
    this.glyph = s, this.color = $;
  }
}
class $0d411f0165859681$export$2e2bcd8739ae039 extends $f92906be28e61769$export$2e2bcd8739ae039 {
  _getBBox() {
    let s = new $f34600ab9d7f70d8$export$2e2bcd8739ae039();
    for (let $ = 0; $ < this.layers.length; $++) {
      let _e = this.layers[$].glyph.bbox;
      s.addPoint(_e.minX, _e.minY), s.addPoint(_e.maxX, _e.maxY);
    }
    return s;
  }
  /**
  * Returns an array of objects containing the glyph and color for
  * each layer in the composite color glyph.
  * @type {object[]}
  */
  get layers() {
    let s = this._font.CPAL, $ = this._font.COLR, _ = 0, _e = $.baseGlyphRecord.length - 1;
    for (; _ <= _e; ) {
      let st = _ + _e >> 1;
      var tt = $.baseGlyphRecord[st];
      if (this.id < tt.gid)
        _e = st - 1;
      else if (this.id > tt.gid)
        _ = st + 1;
      else {
        var nt = tt;
        break;
      }
    }
    if (nt == null) {
      var at = this._font._getBaseGlyph(this.id), ot = {
        red: 0,
        green: 0,
        blue: 0,
        alpha: 255
      };
      return [
        new $0d411f0165859681$var$COLRLayer(at, ot)
      ];
    }
    let rt = [];
    for (let st = nt.firstLayerIndex; st < nt.firstLayerIndex + nt.numLayers; st++) {
      var tt = $.layerRecords[st], ot = s.colorRecords[tt.paletteIndex], at = this._font._getBaseGlyph(tt.gid);
      rt.push(new $0d411f0165859681$var$COLRLayer(at, ot));
    }
    return rt;
  }
  render(s, $) {
    for (let { glyph: _, color: _e } of this.layers)
      s.fillColor([
        _e.red,
        _e.green,
        _e.blue
      ], _e.alpha / 255 * 100), _.render(s, $);
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "COLR");
  }
}
const $0bb840cac04e911b$var$TUPLES_SHARE_POINT_NUMBERS = 32768, $0bb840cac04e911b$var$TUPLE_COUNT_MASK = 4095, $0bb840cac04e911b$var$EMBEDDED_TUPLE_COORD = 32768, $0bb840cac04e911b$var$INTERMEDIATE_TUPLE = 16384, $0bb840cac04e911b$var$PRIVATE_POINT_NUMBERS = 8192, $0bb840cac04e911b$var$TUPLE_INDEX_MASK = 4095, $0bb840cac04e911b$var$POINTS_ARE_WORDS = 128, $0bb840cac04e911b$var$POINT_RUN_COUNT_MASK = 127, $0bb840cac04e911b$var$DELTAS_ARE_ZERO = 128, $0bb840cac04e911b$var$DELTAS_ARE_WORDS = 64, $0bb840cac04e911b$var$DELTA_RUN_COUNT_MASK = 63;
class $0bb840cac04e911b$export$2e2bcd8739ae039 {
  normalizeCoords(s) {
    let $ = [];
    for (var _ = 0; _ < this.font.fvar.axis.length; _++) {
      let _e = this.font.fvar.axis[_];
      s[_] < _e.defaultValue ? $.push((s[_] - _e.defaultValue + Number.EPSILON) / (_e.defaultValue - _e.minValue + Number.EPSILON)) : $.push((s[_] - _e.defaultValue + Number.EPSILON) / (_e.maxValue - _e.defaultValue + Number.EPSILON));
    }
    if (this.font.avar)
      for (var _ = 0; _ < this.font.avar.segment.length; _++) {
        let tt = this.font.avar.segment[_];
        for (let nt = 0; nt < tt.correspondence.length; nt++) {
          let at = tt.correspondence[nt];
          if (nt >= 1 && $[_] < at.fromCoord) {
            let ot = tt.correspondence[nt - 1];
            $[_] = (($[_] - ot.fromCoord) * (at.toCoord - ot.toCoord) + Number.EPSILON) / (at.fromCoord - ot.fromCoord + Number.EPSILON) + ot.toCoord;
            break;
          }
        }
      }
    return $;
  }
  transformPoints(s, $) {
    if (!this.font.fvar || !this.font.gvar)
      return;
    let { gvar: _ } = this.font;
    if (s >= _.glyphCount)
      return;
    let _e = _.offsets[s];
    if (_e === _.offsets[s + 1])
      return;
    let { stream: tt } = this.font;
    if (tt.pos = _e, tt.pos >= tt.length)
      return;
    let nt = tt.readUInt16BE(), at = _e + tt.readUInt16BE();
    if (nt & $0bb840cac04e911b$var$TUPLES_SHARE_POINT_NUMBERS) {
      var ot = tt.pos;
      tt.pos = at;
      var rt = this.decodePoints();
      at = tt.pos, tt.pos = ot;
    }
    let st = $.map((ht) => ht.copy());
    nt &= $0bb840cac04e911b$var$TUPLE_COUNT_MASK;
    for (let ht = 0; ht < nt; ht++) {
      let dt = tt.readUInt16BE(), gt = tt.readUInt16BE();
      if (gt & $0bb840cac04e911b$var$EMBEDDED_TUPLE_COORD) {
        var lt = [];
        for (let xt = 0; xt < _.axisCount; xt++)
          lt.push(tt.readInt16BE() / 16384);
      } else {
        if ((gt & $0bb840cac04e911b$var$TUPLE_INDEX_MASK) >= _.globalCoordCount)
          throw new Error("Invalid gvar table");
        var lt = _.globalCoords[gt & $0bb840cac04e911b$var$TUPLE_INDEX_MASK];
      }
      if (gt & $0bb840cac04e911b$var$INTERMEDIATE_TUPLE) {
        var et = [];
        for (let xt = 0; xt < _.axisCount; xt++)
          et.push(tt.readInt16BE() / 16384);
        var it = [];
        for (let xt = 0; xt < _.axisCount; xt++)
          it.push(tt.readInt16BE() / 16384);
      }
      let pt = this.tupleFactor(gt, lt, et, it);
      if (pt === 0) {
        at += dt;
        continue;
      }
      var ot = tt.pos;
      if (tt.pos = at, gt & $0bb840cac04e911b$var$PRIVATE_POINT_NUMBERS)
        var ut = this.decodePoints();
      else
        var ut = rt;
      let ct = ut.length === 0 ? $.length : ut.length, vt = this.decodeDeltas(ct), At = this.decodeDeltas(ct);
      if (ut.length === 0)
        for (let xt = 0; xt < $.length; xt++) {
          var ft = $[xt];
          ft.x += Math.round(vt[xt] * pt), ft.y += Math.round(At[xt] * pt);
        }
      else {
        let xt = st.map((Et) => Et.copy()), bt = $.map(() => !1);
        for (let Et = 0; Et < ut.length; Et++) {
          let St = ut[Et];
          if (St < $.length) {
            let Bt = xt[St];
            bt[St] = !0, Bt.x += Math.round(vt[Et] * pt), Bt.y += Math.round(At[Et] * pt);
          }
        }
        this.interpolateMissingDeltas(xt, st, bt);
        for (let Et = 0; Et < $.length; Et++) {
          let St = xt[Et].x - st[Et].x, Bt = xt[Et].y - st[Et].y;
          $[Et].x += St, $[Et].y += Bt;
        }
      }
      at += dt, tt.pos = ot;
    }
  }
  decodePoints() {
    let s = this.font.stream, $ = s.readUInt8();
    $ & $0bb840cac04e911b$var$POINTS_ARE_WORDS && ($ = ($ & $0bb840cac04e911b$var$POINT_RUN_COUNT_MASK) << 8 | s.readUInt8());
    let _ = new Uint16Array($), _e = 0, tt = 0;
    for (; _e < $; ) {
      let nt = s.readUInt8(), at = (nt & $0bb840cac04e911b$var$POINT_RUN_COUNT_MASK) + 1, ot = nt & $0bb840cac04e911b$var$POINTS_ARE_WORDS ? s.readUInt16 : s.readUInt8;
      for (let rt = 0; rt < at && _e < $; rt++)
        tt += ot.call(s), _[_e++] = tt;
    }
    return _;
  }
  decodeDeltas(s) {
    let $ = this.font.stream, _ = 0, _e = new Int16Array(s);
    for (; _ < s; ) {
      let tt = $.readUInt8(), nt = (tt & $0bb840cac04e911b$var$DELTA_RUN_COUNT_MASK) + 1;
      if (tt & $0bb840cac04e911b$var$DELTAS_ARE_ZERO)
        _ += nt;
      else {
        let at = tt & $0bb840cac04e911b$var$DELTAS_ARE_WORDS ? $.readInt16BE : $.readInt8;
        for (let ot = 0; ot < nt && _ < s; ot++)
          _e[_++] = at.call($);
      }
    }
    return _e;
  }
  tupleFactor(s, $, _, _e) {
    let tt = this.normalizedCoords, { gvar: nt } = this.font, at = 1;
    for (let ot = 0; ot < nt.axisCount; ot++)
      if ($[ot] !== 0) {
        if (tt[ot] === 0)
          return 0;
        if (s & $0bb840cac04e911b$var$INTERMEDIATE_TUPLE) {
          if (tt[ot] < _[ot] || tt[ot] > _e[ot])
            return 0;
          tt[ot] < $[ot] ? at = at * (tt[ot] - _[ot] + Number.EPSILON) / ($[ot] - _[ot] + Number.EPSILON) : at = at * (_e[ot] - tt[ot] + Number.EPSILON) / (_e[ot] - $[ot] + Number.EPSILON);
        } else {
          if (tt[ot] < Math.min(0, $[ot]) || tt[ot] > Math.max(0, $[ot]))
            return 0;
          at = (at * tt[ot] + Number.EPSILON) / ($[ot] + Number.EPSILON);
        }
      }
    return at;
  }
  // Interpolates points without delta values.
  // Needed for the Ø and Q glyphs in Skia.
  // Algorithm from Freetype.
  interpolateMissingDeltas(s, $, _) {
    if (s.length === 0)
      return;
    let _e = 0;
    for (; _e < s.length; ) {
      let tt = _e, nt = _e, at = s[nt];
      for (; !at.endContour; )
        at = s[++nt];
      for (; _e <= nt && !_[_e]; )
        _e++;
      if (_e > nt)
        continue;
      let ot = _e, rt = _e;
      for (_e++; _e <= nt; )
        _[_e] && (this.deltaInterpolate(rt + 1, _e - 1, rt, _e, $, s), rt = _e), _e++;
      rt === ot ? this.deltaShift(tt, nt, rt, $, s) : (this.deltaInterpolate(rt + 1, nt, rt, ot, $, s), ot > 0 && this.deltaInterpolate(tt, ot - 1, rt, ot, $, s)), _e = nt + 1;
    }
  }
  deltaInterpolate(s, $, _, _e, tt, nt) {
    if (s > $)
      return;
    let at = [
      "x",
      "y"
    ];
    for (let rt = 0; rt < at.length; rt++) {
      let st = at[rt];
      if (tt[_][st] > tt[_e][st]) {
        var ot = _;
        _ = _e, _e = ot;
      }
      let lt = tt[_][st], et = tt[_e][st], it = nt[_][st], ut = nt[_e][st];
      if (lt !== et || it === ut) {
        let ft = lt === et ? 0 : (ut - it) / (et - lt);
        for (let ht = s; ht <= $; ht++) {
          let dt = tt[ht][st];
          dt <= lt ? dt += it - lt : dt >= et ? dt += ut - et : dt = it + (dt - lt) * ft, nt[ht][st] = dt;
        }
      }
    }
  }
  deltaShift(s, $, _, _e, tt) {
    let nt = tt[_].x - _e[_].x, at = tt[_].y - _e[_].y;
    if (!(nt === 0 && at === 0))
      for (let ot = s; ot <= $; ot++)
        ot !== _ && (tt[ot].x += nt, tt[ot].y += at);
  }
  getAdvanceAdjustment(s, $) {
    let _, _e;
    if ($.advanceWidthMapping) {
      let tt = s;
      tt >= $.advanceWidthMapping.mapCount && (tt = $.advanceWidthMapping.mapCount - 1), $.advanceWidthMapping.entryFormat, { outerIndex: _, innerIndex: _e } = $.advanceWidthMapping.mapData[tt];
    } else
      _ = 0, _e = s;
    return this.getDelta($.itemVariationStore, _, _e);
  }
  // See pseudo code from `Font Variations Overview'
  // in the OpenType specification.
  getDelta(s, $, _) {
    if ($ >= s.itemVariationData.length)
      return 0;
    let _e = s.itemVariationData[$];
    if (_ >= _e.deltaSets.length)
      return 0;
    let tt = _e.deltaSets[_], nt = this.getBlendVector(s, $), at = 0;
    for (let ot = 0; ot < _e.regionIndexCount; ot++)
      at += tt.deltas[ot] * nt[ot];
    return at;
  }
  getBlendVector(s, $) {
    let _ = s.itemVariationData[$];
    if (this.blendVectors.has(_))
      return this.blendVectors.get(_);
    let _e = this.normalizedCoords, tt = [];
    for (let nt = 0; nt < _.regionIndexCount; nt++) {
      let at = 1, ot = _.regionIndexes[nt], rt = s.variationRegionList.variationRegions[ot];
      for (let st = 0; st < rt.length; st++) {
        let lt = rt[st], et;
        lt.startCoord > lt.peakCoord || lt.peakCoord > lt.endCoord || lt.startCoord < 0 && lt.endCoord > 0 && lt.peakCoord !== 0 || lt.peakCoord === 0 ? et = 1 : _e[st] < lt.startCoord || _e[st] > lt.endCoord ? et = 0 : _e[st] === lt.peakCoord ? et = 1 : _e[st] < lt.peakCoord ? et = (_e[st] - lt.startCoord + Number.EPSILON) / (lt.peakCoord - lt.startCoord + Number.EPSILON) : et = (lt.endCoord - _e[st] + Number.EPSILON) / (lt.endCoord - lt.peakCoord + Number.EPSILON), at *= et;
      }
      tt[nt] = at;
    }
    return this.blendVectors.set(_, tt), tt;
  }
  constructor(s, $) {
    this.font = s, this.normalizedCoords = this.normalizeCoords($), this.blendVectors = /* @__PURE__ */ new Map();
  }
}
Promise.resolve();
class $5cc7476da92df375$export$2e2bcd8739ae039 {
  includeGlyph(s) {
    return typeof s == "object" && (s = s.id), this.mapping[s] == null && (this.glyphs.push(s), this.mapping[s] = this.glyphs.length - 1), this.mapping[s];
  }
  constructor(s) {
    this.font = s, this.glyphs = [], this.mapping = {}, this.includeGlyph(0);
  }
}
const $807e58506be70005$var$ON_CURVE = 1, $807e58506be70005$var$X_SHORT_VECTOR = 2, $807e58506be70005$var$Y_SHORT_VECTOR = 4, $807e58506be70005$var$REPEAT = 8, $807e58506be70005$var$SAME_X = 16, $807e58506be70005$var$SAME_Y = 32;
class $807e58506be70005$var$Point {
  static size(s) {
    return s >= 0 && s <= 255 ? 1 : 2;
  }
  static encode(s, $) {
    $ >= 0 && $ <= 255 ? s.writeUInt8($) : s.writeInt16BE($);
  }
}
let $807e58506be70005$var$Glyf = new Struct({
  numberOfContours: int16,
  xMin: int16,
  yMin: int16,
  xMax: int16,
  yMax: int16,
  endPtsOfContours: new ArrayT(uint16, "numberOfContours"),
  instructions: new ArrayT(uint8, uint16),
  flags: new ArrayT(uint8, 0),
  xPoints: new ArrayT($807e58506be70005$var$Point, 0),
  yPoints: new ArrayT($807e58506be70005$var$Point, 0)
});
class $807e58506be70005$export$2e2bcd8739ae039 {
  encodeSimple(s, $ = []) {
    let _ = [], _e = [], tt = [], nt = [], at = 0, ot = 0, rt = 0, st = 0, lt = 0;
    for (let dt = 0; dt < s.commands.length; dt++) {
      let gt = s.commands[dt];
      for (let pt = 0; pt < gt.args.length; pt += 2) {
        let mt = gt.args[pt], ct = gt.args[pt + 1], vt = 0;
        if (gt.command === "quadraticCurveTo" && pt === 2) {
          let At = s.commands[dt + 1];
          if (At && At.command === "quadraticCurveTo") {
            let xt = (ot + At.args[0]) / 2, bt = (rt + At.args[1]) / 2;
            if (mt === xt && ct === bt)
              continue;
          }
        }
        gt.command === "quadraticCurveTo" && pt === 0 || (vt |= $807e58506be70005$var$ON_CURVE), vt = this._encodePoint(mt, ot, _e, vt, $807e58506be70005$var$X_SHORT_VECTOR, $807e58506be70005$var$SAME_X), vt = this._encodePoint(ct, rt, tt, vt, $807e58506be70005$var$Y_SHORT_VECTOR, $807e58506be70005$var$SAME_Y), vt === st && at < 255 ? (nt[nt.length - 1] |= $807e58506be70005$var$REPEAT, at++) : (at > 0 && (nt.push(at), at = 0), nt.push(vt), st = vt), ot = mt, rt = ct, lt++;
      }
      gt.command === "closePath" && _.push(lt - 1);
    }
    s.commands.length > 1 && s.commands[s.commands.length - 1].command !== "closePath" && _.push(lt - 1);
    let et = s.bbox, it = {
      numberOfContours: _.length,
      xMin: et.minX,
      yMin: et.minY,
      xMax: et.maxX,
      yMax: et.maxY,
      endPtsOfContours: _,
      instructions: $,
      flags: nt,
      xPoints: _e,
      yPoints: tt
    }, ut = $807e58506be70005$var$Glyf.size(it), ft = 4 - ut % 4, ht = new EncodeStream(ut + ft);
    return $807e58506be70005$var$Glyf.encode(ht, it), ft !== 0 && ht.fill(0, ft), ht.buffer;
  }
  _encodePoint(s, $, _, _e, tt, nt) {
    let at = s - $;
    return s === $ ? _e |= nt : (-255 <= at && at <= 255 && (_e |= tt, at < 0 ? at = -at : _e |= nt), _.push(at)), _e;
  }
}
class $4abbb6a5dbdc441a$export$2e2bcd8739ae039 extends $5cc7476da92df375$export$2e2bcd8739ae039 {
  _addGlyph(s) {
    let $ = this.font.getGlyph(s), _ = $._decode(), _e = this.font.loca.offsets[s], tt = this.font.loca.offsets[s + 1], nt = this.font._getTableStream("glyf");
    nt.pos += _e;
    let at = nt.readBuffer(tt - _e);
    if (_ && _.numberOfContours < 0) {
      at = new Uint8Array(at);
      let ot = new DataView(at.buffer);
      for (let rt of _.components)
        s = this.includeGlyph(rt.glyphID), ot.setUint16(rt.pos, s);
    } else
      _ && this.font._variationProcessor && (at = this.glyphEncoder.encodeSimple($.path, _.instructions));
    return this.glyf.push(at), this.loca.offsets.push(this.offset), this.hmtx.metrics.push({
      advance: $.advanceWidth,
      bearing: $._getMetrics().leftBearing
    }), this.offset += at.length, this.glyf.length - 1;
  }
  encode() {
    this.glyf = [], this.offset = 0, this.loca = {
      offsets: [],
      version: this.font.loca.version
    }, this.hmtx = {
      metrics: [],
      bearings: []
    };
    let s = 0;
    for (; s < this.glyphs.length; )
      this._addGlyph(this.glyphs[s++]);
    let $ = $6uUbQ$clone(this.font.maxp);
    $.numGlyphs = this.glyf.length, this.loca.offsets.push(this.offset);
    let _ = $6uUbQ$clone(this.font.head);
    _.indexToLocFormat = this.loca.version;
    let _e = $6uUbQ$clone(this.font.hhea);
    return _e.numberOfMetrics = this.hmtx.metrics.length, $816c07a04b6dba87$export$2e2bcd8739ae039.toBuffer({
      tables: {
        head: _,
        hhea: _e,
        loca: this.loca,
        maxp: $,
        "cvt ": this.font["cvt "],
        prep: this.font.prep,
        glyf: this.glyf,
        hmtx: this.hmtx,
        fpgm: this.font.fpgm
      }
    });
  }
  constructor(s) {
    super(s), this.glyphEncoder = new $807e58506be70005$export$2e2bcd8739ae039();
  }
}
class $001d739428a71d5a$export$2e2bcd8739ae039 extends $5cc7476da92df375$export$2e2bcd8739ae039 {
  subsetCharstrings() {
    this.charstrings = [];
    let s = {};
    for (let $ of this.glyphs) {
      this.charstrings.push(this.cff.getCharString($));
      let _ = this.font.getGlyph($);
      _.path;
      for (let _e in _._usedGsubrs)
        s[_e] = !0;
    }
    this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, s);
  }
  subsetSubrs(s, $) {
    let _ = [];
    for (let _e = 0; _e < s.length; _e++) {
      let tt = s[_e];
      $[_e] ? (this.cff.stream.pos = tt.offset, _.push(this.cff.stream.readBuffer(tt.length))) : _.push(new Uint8Array([
        11
      ]));
    }
    return _;
  }
  subsetFontdict(s) {
    s.FDArray = [], s.FDSelect = {
      version: 0,
      fds: []
    };
    let $ = {}, _ = [], _e = {};
    for (let tt of this.glyphs) {
      let nt = this.cff.fdForGlyph(tt);
      if (nt == null)
        continue;
      $[nt] || (s.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[nt])), _.push({}), _e[nt] = s.FDArray.length - 1), $[nt] = !0, s.FDSelect.fds.push(_e[nt]);
      let at = this.font.getGlyph(tt);
      at.path;
      for (let ot in at._usedSubrs)
        _[_e[nt]][ot] = !0;
    }
    for (let tt = 0; tt < s.FDArray.length; tt++) {
      let nt = s.FDArray[tt];
      delete nt.FontName, nt.Private && nt.Private.Subrs && (nt.Private = Object.assign({}, nt.Private), nt.Private.Subrs = this.subsetSubrs(nt.Private.Subrs, _[tt]));
    }
  }
  createCIDFontdict(s) {
    let $ = {};
    for (let _e of this.glyphs) {
      let tt = this.font.getGlyph(_e);
      tt.path;
      for (let nt in tt._usedSubrs)
        $[nt] = !0;
    }
    let _ = Object.assign({}, this.cff.topDict.Private);
    return this.cff.topDict.Private && this.cff.topDict.Private.Subrs && (_.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, $)), s.FDArray = [
      {
        Private: _
      }
    ], s.FDSelect = {
      version: 3,
      nRanges: 1,
      ranges: [
        {
          first: 0,
          fd: 0
        }
      ],
      sentinel: this.charstrings.length
    };
  }
  addString(s) {
    return s ? (this.strings || (this.strings = []), this.strings.push(s), $229224aec43783c5$export$2e2bcd8739ae039.length + this.strings.length - 1) : null;
  }
  encode() {
    this.subsetCharstrings();
    let s = {
      version: this.charstrings.length > 255 ? 2 : 1,
      ranges: [
        {
          first: 1,
          nLeft: this.charstrings.length - 2
        }
      ]
    }, $ = Object.assign({}, this.cff.topDict);
    $.Private = null, $.charset = s, $.Encoding = null, $.CharStrings = this.charstrings;
    for (let _e of [
      "version",
      "Notice",
      "Copyright",
      "FullName",
      "FamilyName",
      "Weight",
      "PostScript",
      "BaseFontName",
      "FontName"
    ])
      $[_e] = this.addString(this.cff.string($[_e]));
    $.ROS = [
      this.addString("Adobe"),
      this.addString("Identity"),
      0
    ], $.CIDCount = this.charstrings.length, this.cff.isCIDFont ? this.subsetFontdict($) : this.createCIDFontdict($);
    let _ = {
      version: 1,
      hdrSize: this.cff.hdrSize,
      offSize: 4,
      header: this.cff.header,
      nameIndex: [
        this.cff.postscriptName
      ],
      topDictIndex: [
        $
      ],
      stringIndex: this.strings,
      globalSubrIndex: this.gsubrs
    };
    return $b84fd3dd9d8eddb2$export$2e2bcd8739ae039.toBuffer(_);
  }
  constructor(s) {
    if (super(s), this.cff = this.font["CFF "], !this.cff)
      throw new Error("Not a CFF Font");
  }
}
class $4c1709dee528ea76$export$2e2bcd8739ae039 {
  static probe(s) {
    let $ = $12727730ddfc8bfe$export$3d28c1996ced1f14.decode(s.slice(0, 4));
    return $ === "true" || $ === "OTTO" || $ === "\0\0\0";
  }
  setDefaultLanguage(s = null) {
    this.defaultLanguage = s;
  }
  _getTable(s) {
    if (!(s.tag in this._tables))
      try {
        this._tables[s.tag] = this._decodeTable(s);
      } catch {
      }
    return this._tables[s.tag];
  }
  _getTableStream(s) {
    let $ = this.directory.tables[s];
    return $ ? (this.stream.pos = $.offset, this.stream) : null;
  }
  _decodeDirectory() {
    return this.directory = $816c07a04b6dba87$export$2e2bcd8739ae039.decode(this.stream, {
      _startOffset: 0
    });
  }
  _decodeTable(s) {
    let $ = this.stream.pos, _ = this._getTableStream(s.tag), _e = $c3395722bea751e2$export$2e2bcd8739ae039[s.tag].decode(_, this, s.length);
    return this.stream.pos = $, _e;
  }
  /**
  * Gets a string from the font's `name` table
  * `lang` is a BCP-47 language code.
  * @return {string}
  */
  getName(s, $ = this.defaultLanguage || $d636bc798e7178db$export$42940898df819940) {
    let _ = this.name && this.name.records[s];
    return _ && (_[$] || _[this.defaultLanguage] || _[$d636bc798e7178db$export$42940898df819940] || _.en || _[Object.keys(_)[0]]) || null;
  }
  /**
  * The unique PostScript name for this font, e.g. "Helvetica-Bold"
  * @type {string}
  */
  get postscriptName() {
    return this.getName("postscriptName");
  }
  /**
  * The font's full name, e.g. "Helvetica Bold"
  * @type {string}
  */
  get fullName() {
    return this.getName("fullName");
  }
  /**
  * The font's family name, e.g. "Helvetica"
  * @type {string}
  */
  get familyName() {
    return this.getName("fontFamily");
  }
  /**
  * The font's sub-family, e.g. "Bold".
  * @type {string}
  */
  get subfamilyName() {
    return this.getName("fontSubfamily");
  }
  /**
  * The font's copyright information
  * @type {string}
  */
  get copyright() {
    return this.getName("copyright");
  }
  /**
  * The font's version number
  * @type {string}
  */
  get version() {
    return this.getName("version");
  }
  /**
  * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
  * @type {number}
  */
  get ascent() {
    return this.hhea.ascent;
  }
  /**
  * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
  * @type {number}
  */
  get descent() {
    return this.hhea.descent;
  }
  /**
  * The amount of space that should be included between lines
  * @type {number}
  */
  get lineGap() {
    return this.hhea.lineGap;
  }
  /**
  * The offset from the normal underline position that should be used
  * @type {number}
  */
  get underlinePosition() {
    return this.post.underlinePosition;
  }
  /**
  * The weight of the underline that should be used
  * @type {number}
  */
  get underlineThickness() {
    return this.post.underlineThickness;
  }
  /**
  * If this is an italic font, the angle the cursor should be drawn at to match the font design
  * @type {number}
  */
  get italicAngle() {
    return this.post.italicAngle;
  }
  /**
  * The height of capital letters above the baseline.
  * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
  * @type {number}
  */
  get capHeight() {
    let s = this["OS/2"];
    return s ? s.capHeight : this.ascent;
  }
  /**
  * The height of lower case letters in the font.
  * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
  * @type {number}
  */
  get xHeight() {
    let s = this["OS/2"];
    return s ? s.xHeight : 0;
  }
  /**
  * The number of glyphs in the font.
  * @type {number}
  */
  get numGlyphs() {
    return this.maxp.numGlyphs;
  }
  /**
  * The size of the font’s internal coordinate grid
  * @type {number}
  */
  get unitsPerEm() {
    return this.head.unitsPerEm;
  }
  /**
  * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
  * @type {BBox}
  */
  get bbox() {
    return Object.freeze(new $f34600ab9d7f70d8$export$2e2bcd8739ae039(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
  }
  get _cmapProcessor() {
    return new $f08dd41ef10b694c$export$2e2bcd8739ae039(this.cmap);
  }
  /**
  * An array of all of the unicode code points supported by the font.
  * @type {number[]}
  */
  get characterSet() {
    return this._cmapProcessor.getCharacterSet();
  }
  /**
  * Returns whether there is glyph in the font for the given unicode code point.
  *
  * @param {number} codePoint
  * @return {boolean}
  */
  hasGlyphForCodePoint(s) {
    return !!this._cmapProcessor.lookup(s);
  }
  /**
  * Maps a single unicode code point to a Glyph object.
  * Does not perform any advanced substitutions (there is no context to do so).
  *
  * @param {number} codePoint
  * @return {Glyph}
  */
  glyphForCodePoint(s) {
    return this.getGlyph(this._cmapProcessor.lookup(s), [
      s
    ]);
  }
  /**
  * Returns an array of Glyph objects for the given string.
  * This is only a one-to-one mapping from characters to glyphs.
  * For most uses, you should use font.layout (described below), which
  * provides a much more advanced mapping supporting AAT and OpenType shaping.
  *
  * @param {string} string
  * @return {Glyph[]}
  */
  glyphsForString(s) {
    let $ = [], _ = s.length, _e = 0, tt = -1, nt = -1;
    for (; _e <= _; ) {
      let at = 0, ot = 0;
      if (_e < _) {
        if (at = s.charCodeAt(_e++), 55296 <= at && at <= 56319 && _e < _) {
          let rt = s.charCodeAt(_e);
          56320 <= rt && rt <= 57343 && (_e++, at = ((at & 1023) << 10) + (rt & 1023) + 65536);
        }
        ot = 65024 <= at && at <= 65039 || 917760 <= at && at <= 917999 ? 1 : 0;
      } else
        _e++;
      nt === 0 && ot === 1 ? $.push(this.getGlyph(this._cmapProcessor.lookup(tt, at), [
        tt,
        at
      ])) : nt === 0 && ot === 0 && $.push(this.glyphForCodePoint(tt)), tt = at, nt = ot;
    }
    return $;
  }
  get _layoutEngine() {
    return new $4c0a7fa5df7a9ab1$export$2e2bcd8739ae039(this);
  }
  /**
  * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
  *
  * @param {string} string
  * @param {string[]} [userFeatures]
  * @param {string} [script]
  * @param {string} [language]
  * @param {string} [direction]
  * @return {GlyphRun}
  */
  layout(s, $, _, _e, tt) {
    return this._layoutEngine.layout(s, $, _, _e, tt);
  }
  /**
  * Returns an array of strings that map to the given glyph id.
  * @param {number} gid - glyph id
  */
  stringsForGlyph(s) {
    return this._layoutEngine.stringsForGlyph(s);
  }
  /**
  * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
  * (or mapped AAT tags) supported by the font.
  * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
  * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
  *
  * @type {string[]}
  */
  get availableFeatures() {
    return this._layoutEngine.getAvailableFeatures();
  }
  getAvailableFeatures(s, $) {
    return this._layoutEngine.getAvailableFeatures(s, $);
  }
  _getBaseGlyph(s, $ = []) {
    return this._glyphs[s] || (this.directory.tables.glyf ? this._glyphs[s] = new $69aac16029968692$export$2e2bcd8739ae039(s, $, this) : (this.directory.tables["CFF "] || this.directory.tables.CFF2) && (this._glyphs[s] = new $62cc5109c6101893$export$2e2bcd8739ae039(s, $, this))), this._glyphs[s] || null;
  }
  /**
  * Returns a glyph object for the given glyph id.
  * You can pass the array of code points this glyph represents for
  * your use later, and it will be stored in the glyph object.
  *
  * @param {number} glyph
  * @param {number[]} characters
  * @return {Glyph}
  */
  getGlyph(s, $ = []) {
    return this._glyphs[s] || (this.directory.tables.sbix ? this._glyphs[s] = new $25d8f049c222084c$export$2e2bcd8739ae039(s, $, this) : this.directory.tables.COLR && this.directory.tables.CPAL ? this._glyphs[s] = new $0d411f0165859681$export$2e2bcd8739ae039(s, $, this) : this._getBaseGlyph(s, $)), this._glyphs[s] || null;
  }
  /**
  * Returns a Subset for this font.
  * @return {Subset}
  */
  createSubset() {
    return this.directory.tables["CFF "] ? new $001d739428a71d5a$export$2e2bcd8739ae039(this) : new $4abbb6a5dbdc441a$export$2e2bcd8739ae039(this);
  }
  /**
  * Returns an object describing the available variation axes
  * that this font supports. Keys are setting tags, and values
  * contain the axis name, range, and default value.
  *
  * @type {object}
  */
  get variationAxes() {
    let s = {};
    if (!this.fvar)
      return s;
    for (let $ of this.fvar.axis)
      s[$.axisTag.trim()] = {
        name: $.name.en,
        min: $.minValue,
        default: $.defaultValue,
        max: $.maxValue
      };
    return s;
  }
  /**
  * Returns an object describing the named variation instances
  * that the font designer has specified. Keys are variation names
  * and values are the variation settings for this instance.
  *
  * @type {object}
  */
  get namedVariations() {
    let s = {};
    if (!this.fvar)
      return s;
    for (let $ of this.fvar.instance) {
      let _ = {};
      for (let _e = 0; _e < this.fvar.axis.length; _e++) {
        let tt = this.fvar.axis[_e];
        _[tt.axisTag.trim()] = $.coord[_e];
      }
      s[$.name.en] = _;
    }
    return s;
  }
  /**
  * Returns a new font with the given variation settings applied.
  * Settings can either be an instance name, or an object containing
  * variation tags as specified by the `variationAxes` property.
  *
  * @param {object} settings
  * @return {TTFFont}
  */
  getVariation(s) {
    if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2)))
      throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
    if (typeof s == "string" && (s = this.namedVariations[s]), typeof s != "object")
      throw new Error("Variation settings must be either a variation name or settings object.");
    let $ = this.fvar.axis.map((tt, nt) => {
      let at = tt.axisTag.trim();
      return at in s ? Math.max(tt.minValue, Math.min(tt.maxValue, s[at])) : tt.defaultValue;
    }), _ = new DecodeStream(this.stream.buffer);
    _.pos = this._directoryPos;
    let _e = new $4c1709dee528ea76$export$2e2bcd8739ae039(_, $);
    return _e._tables = this._tables, _e;
  }
  get _variationProcessor() {
    if (!this.fvar)
      return null;
    let s = this.variationCoords;
    return !s && !this.CFF2 ? null : (s || (s = this.fvar.axis.map(($) => $.defaultValue)), new $0bb840cac04e911b$export$2e2bcd8739ae039(this, s));
  }
  // Standardized format plugin API
  getFont(s) {
    return this.getVariation(s);
  }
  constructor(s, $ = null) {
    _define_property(this, "type", "TTF"), this.defaultLanguage = null, this.stream = s, this.variationCoords = $, this._directoryPos = this.stream.pos, this._tables = {}, this._glyphs = {}, this._decodeDirectory();
    for (let _ in this.directory.tables) {
      let _e = this.directory.tables[_];
      $c3395722bea751e2$export$2e2bcd8739ae039[_] && _e.length > 0 && Object.defineProperty(this, _, {
        get: this._getTable.bind(this, _e)
      });
    }
  }
}
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "bbox", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_cmapProcessor", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "characterSet", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_layoutEngine", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "variationAxes", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "namedVariations", null);
__decorate$3([
  $e71565f2ce09cb6b$export$69a3209f1a06c04d
], $4c1709dee528ea76$export$2e2bcd8739ae039.prototype, "_variationProcessor", null);
let $c1726355ecc5b889$var$WOFFDirectoryEntry = new Struct({
  tag: new StringT(4),
  offset: new Pointer(uint32, "void", {
    type: "global"
  }),
  compLength: uint32,
  length: uint32,
  origChecksum: uint32
}), $c1726355ecc5b889$var$WOFFDirectory = new Struct({
  tag: new StringT(4),
  flavor: uint32,
  length: uint32,
  numTables: uint16,
  reserved: new Reserved(uint16),
  totalSfntSize: uint32,
  majorVersion: uint16,
  minorVersion: uint16,
  metaOffset: uint32,
  metaLength: uint32,
  metaOrigLength: uint32,
  privOffset: uint32,
  privLength: uint32,
  tables: new ArrayT($c1726355ecc5b889$var$WOFFDirectoryEntry, "numTables")
});
$c1726355ecc5b889$var$WOFFDirectory.process = function() {
  let a = {};
  for (let s of this.tables)
    a[s.tag] = s;
  this.tables = a;
};
var $c1726355ecc5b889$export$2e2bcd8739ae039 = $c1726355ecc5b889$var$WOFFDirectory;
class $760785214b9fc52c$export$2e2bcd8739ae039 extends $4c1709dee528ea76$export$2e2bcd8739ae039 {
  static probe(s) {
    return $12727730ddfc8bfe$export$3d28c1996ced1f14.decode(s.slice(0, 4)) === "wOFF";
  }
  _decodeDirectory() {
    this.directory = $c1726355ecc5b889$export$2e2bcd8739ae039.decode(this.stream, {
      _startOffset: 0
    });
  }
  _getTableStream(s) {
    let $ = this.directory.tables[s];
    if ($)
      if (this.stream.pos = $.offset, $.compLength < $.length) {
        this.stream.pos += 2;
        let _ = new Uint8Array($.length), _e = $6uUbQ$tinyinflate(this.stream.readBuffer($.compLength - 2), _);
        return new DecodeStream(_e);
      } else
        return this.stream;
    return null;
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "WOFF");
  }
}
class $8046190c9f1ad19e$export$2e2bcd8739ae039 extends $69aac16029968692$export$2e2bcd8739ae039 {
  _decode() {
    return this._font._transformedGlyphs[this.id];
  }
  _getCBox() {
    return this.path.bbox;
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "WOFF2");
  }
}
const $c28ec7bbb3b8de3a$var$Base128 = {
  decode(a) {
    let s = 0, $ = [
      0,
      1,
      2,
      3,
      4
    ];
    for (let _ = 0; _ < $.length; _++) {
      let _e = a.readUInt8();
      if (s & 3758096384)
        throw new Error("Overflow");
      if (s = s << 7 | _e & 127, !(_e & 128))
        return s;
    }
    throw new Error("Bad base 128 number");
  }
};
let $c28ec7bbb3b8de3a$var$knownTags = [
  "cmap",
  "head",
  "hhea",
  "hmtx",
  "maxp",
  "name",
  "OS/2",
  "post",
  "cvt ",
  "fpgm",
  "glyf",
  "loca",
  "prep",
  "CFF ",
  "VORG",
  "EBDT",
  "EBLC",
  "gasp",
  "hdmx",
  "kern",
  "LTSH",
  "PCLT",
  "VDMX",
  "vhea",
  "vmtx",
  "BASE",
  "GDEF",
  "GPOS",
  "GSUB",
  "EBSC",
  "JSTF",
  "MATH",
  "CBDT",
  "CBLC",
  "COLR",
  "CPAL",
  "SVG ",
  "sbix",
  "acnt",
  "avar",
  "bdat",
  "bloc",
  "bsln",
  "cvar",
  "fdsc",
  "feat",
  "fmtx",
  "fvar",
  "gvar",
  "hsty",
  "just",
  "lcar",
  "mort",
  "morx",
  "opbd",
  "prop",
  "trak",
  "Zapf",
  "Silf",
  "Glat",
  "Gloc",
  "Feat",
  "Sill"
], $c28ec7bbb3b8de3a$var$WOFF2DirectoryEntry = new Struct({
  flags: uint8,
  customTag: new Optional(new StringT(4), (a) => (a.flags & 63) === 63),
  tag: (a) => a.customTag || $c28ec7bbb3b8de3a$var$knownTags[a.flags & 63],
  length: $c28ec7bbb3b8de3a$var$Base128,
  transformVersion: (a) => a.flags >>> 6 & 3,
  transformed: (a) => a.tag === "glyf" || a.tag === "loca" ? a.transformVersion === 0 : a.transformVersion !== 0,
  transformLength: new Optional($c28ec7bbb3b8de3a$var$Base128, (a) => a.transformed)
}), $c28ec7bbb3b8de3a$var$WOFF2Directory = new Struct({
  tag: new StringT(4),
  flavor: uint32,
  length: uint32,
  numTables: uint16,
  reserved: new Reserved(uint16),
  totalSfntSize: uint32,
  totalCompressedSize: uint32,
  majorVersion: uint16,
  minorVersion: uint16,
  metaOffset: uint32,
  metaLength: uint32,
  metaOrigLength: uint32,
  privOffset: uint32,
  privLength: uint32,
  tables: new ArrayT($c28ec7bbb3b8de3a$var$WOFF2DirectoryEntry, "numTables")
});
$c28ec7bbb3b8de3a$var$WOFF2Directory.process = function() {
  let a = {};
  for (let s = 0; s < this.tables.length; s++) {
    let $ = this.tables[s];
    a[$.tag] = $;
  }
  return this.tables = a;
};
var $c28ec7bbb3b8de3a$export$2e2bcd8739ae039 = $c28ec7bbb3b8de3a$var$WOFF2Directory;
class $21ee218f84ac7f32$export$2e2bcd8739ae039 extends $4c1709dee528ea76$export$2e2bcd8739ae039 {
  static probe(s) {
    return $12727730ddfc8bfe$export$3d28c1996ced1f14.decode(s.slice(0, 4)) === "wOF2";
  }
  _decodeDirectory() {
    this.directory = $c28ec7bbb3b8de3a$export$2e2bcd8739ae039.decode(this.stream), this._dataPos = this.stream.pos;
  }
  _decompress() {
    if (!this._decompressed) {
      this.stream.pos = this._dataPos;
      let s = this.stream.readBuffer(this.directory.totalCompressedSize), $ = 0;
      for (let _e in this.directory.tables) {
        let tt = this.directory.tables[_e];
        tt.offset = $, $ += tt.transformLength != null ? tt.transformLength : tt.length;
      }
      let _ = $6uUbQ$brotlidecompressjs(s, $);
      if (!_)
        throw new Error("Error decoding compressed data in WOFF2");
      this.stream = new DecodeStream(_), this._decompressed = !0;
    }
  }
  _decodeTable(s) {
    return this._decompress(), super._decodeTable(s);
  }
  // Override this method to get a glyph and return our
  // custom subclass if there is a glyf table.
  _getBaseGlyph(s, $ = []) {
    if (!this._glyphs[s])
      return this.directory.tables.glyf && this.directory.tables.glyf.transformed ? (this._transformedGlyphs || this._transformGlyfTable(), this._glyphs[s] = new $8046190c9f1ad19e$export$2e2bcd8739ae039(s, $, this)) : super._getBaseGlyph(s, $);
  }
  _transformGlyfTable() {
    this._decompress(), this.stream.pos = this.directory.tables.glyf.offset;
    let s = $21ee218f84ac7f32$var$GlyfTable.decode(this.stream), $ = [];
    for (let _e = 0; _e < s.numGlyphs; _e++) {
      let tt = {}, nt = s.nContours.readInt16BE();
      if (tt.numberOfContours = nt, nt > 0) {
        let at = [], ot = 0;
        for (let rt = 0; rt < nt; rt++) {
          let st = $21ee218f84ac7f32$var$read255UInt16(s.nPoints);
          ot += st, at.push(ot);
        }
        tt.points = $21ee218f84ac7f32$var$decodeTriplet(s.flags, s.glyphs, ot);
        for (let rt = 0; rt < nt; rt++)
          tt.points[at[rt] - 1].endContour = !0;
        var _ = $21ee218f84ac7f32$var$read255UInt16(s.glyphs);
      } else if (nt < 0 && $69aac16029968692$export$2e2bcd8739ae039.prototype._decodeComposite.call({
        _font: this
      }, tt, s.composites))
        var _ = $21ee218f84ac7f32$var$read255UInt16(s.glyphs);
      $.push(tt);
    }
    this._transformedGlyphs = $;
  }
  constructor(...s) {
    super(...s), _define_property(this, "type", "WOFF2");
  }
}
class $21ee218f84ac7f32$var$Substream {
  decode(s, $) {
    return new DecodeStream(this._buf.decode(s, $));
  }
  constructor(s) {
    this.length = s, this._buf = new BufferT(s);
  }
}
let $21ee218f84ac7f32$var$GlyfTable = new Struct({
  version: uint32,
  numGlyphs: uint16,
  indexFormat: uint16,
  nContourStreamSize: uint32,
  nPointsStreamSize: uint32,
  flagStreamSize: uint32,
  glyphStreamSize: uint32,
  compositeStreamSize: uint32,
  bboxStreamSize: uint32,
  instructionStreamSize: uint32,
  nContours: new $21ee218f84ac7f32$var$Substream("nContourStreamSize"),
  nPoints: new $21ee218f84ac7f32$var$Substream("nPointsStreamSize"),
  flags: new $21ee218f84ac7f32$var$Substream("flagStreamSize"),
  glyphs: new $21ee218f84ac7f32$var$Substream("glyphStreamSize"),
  composites: new $21ee218f84ac7f32$var$Substream("compositeStreamSize"),
  bboxes: new $21ee218f84ac7f32$var$Substream("bboxStreamSize"),
  instructions: new $21ee218f84ac7f32$var$Substream("instructionStreamSize")
});
const $21ee218f84ac7f32$var$WORD_CODE = 253, $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE2 = 254, $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE1 = 255, $21ee218f84ac7f32$var$LOWEST_U_CODE = 253;
function $21ee218f84ac7f32$var$read255UInt16(a) {
  let s = a.readUInt8();
  return s === $21ee218f84ac7f32$var$WORD_CODE ? a.readUInt16BE() : s === $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE1 ? a.readUInt8() + $21ee218f84ac7f32$var$LOWEST_U_CODE : s === $21ee218f84ac7f32$var$ONE_MORE_BYTE_CODE2 ? a.readUInt8() + $21ee218f84ac7f32$var$LOWEST_U_CODE * 2 : s;
}
function $21ee218f84ac7f32$var$withSign(a, s) {
  return a & 1 ? s : -s;
}
function $21ee218f84ac7f32$var$decodeTriplet(a, s, $) {
  let _, _e = _ = 0, tt = [];
  for (let ot = 0; ot < $; ot++) {
    let rt = 0, st = 0, lt = a.readUInt8(), et = !(lt >> 7);
    if (lt &= 127, lt < 10)
      rt = 0, st = $21ee218f84ac7f32$var$withSign(lt, ((lt & 14) << 7) + s.readUInt8());
    else if (lt < 20)
      rt = $21ee218f84ac7f32$var$withSign(lt, ((lt - 10 & 14) << 7) + s.readUInt8()), st = 0;
    else if (lt < 84) {
      var nt = lt - 20, at = s.readUInt8();
      rt = $21ee218f84ac7f32$var$withSign(lt, 1 + (nt & 48) + (at >> 4)), st = $21ee218f84ac7f32$var$withSign(lt >> 1, 1 + ((nt & 12) << 2) + (at & 15));
    } else if (lt < 120) {
      var nt = lt - 84;
      rt = $21ee218f84ac7f32$var$withSign(lt, 1 + (nt / 12 << 8) + s.readUInt8()), st = $21ee218f84ac7f32$var$withSign(lt >> 1, 1 + (nt % 12 >> 2 << 8) + s.readUInt8());
    } else if (lt < 124) {
      var at = s.readUInt8();
      let ut = s.readUInt8();
      rt = $21ee218f84ac7f32$var$withSign(lt, (at << 4) + (ut >> 4)), st = $21ee218f84ac7f32$var$withSign(lt >> 1, ((ut & 15) << 8) + s.readUInt8());
    } else
      rt = $21ee218f84ac7f32$var$withSign(lt, s.readUInt16BE()), st = $21ee218f84ac7f32$var$withSign(lt >> 1, s.readUInt16BE());
    _e += rt, _ += st, tt.push(new $69aac16029968692$export$baf26146a414f24a(et, !1, _e, _));
  }
  return tt;
}
let $cd5853a56c68fec7$var$TTCHeader = new VersionedStruct(uint32, {
  65536: {
    numFonts: uint32,
    offsets: new ArrayT(uint32, "numFonts")
  },
  131072: {
    numFonts: uint32,
    offsets: new ArrayT(uint32, "numFonts"),
    dsigTag: uint32,
    dsigLength: uint32,
    dsigOffset: uint32
  }
});
class $cd5853a56c68fec7$export$2e2bcd8739ae039 {
  static probe(s) {
    return $12727730ddfc8bfe$export$3d28c1996ced1f14.decode(s.slice(0, 4)) === "ttcf";
  }
  getFont(s) {
    for (let $ of this.header.offsets) {
      let _ = new DecodeStream(this.stream.buffer);
      _.pos = $;
      let _e = new $4c1709dee528ea76$export$2e2bcd8739ae039(_);
      if (_e.postscriptName === s || _e.postscriptName instanceof Uint8Array && s instanceof Uint8Array && _e.postscriptName.every((tt, nt) => s[nt] === tt))
        return _e;
    }
    return null;
  }
  get fonts() {
    let s = [];
    for (let $ of this.header.offsets) {
      let _ = new DecodeStream(this.stream.buffer);
      _.pos = $, s.push(new $4c1709dee528ea76$export$2e2bcd8739ae039(_));
    }
    return s;
  }
  constructor(s) {
    if (_define_property(this, "type", "TTC"), this.stream = s, s.readString(4) !== "ttcf")
      throw new Error("Not a TrueType collection");
    this.header = $cd5853a56c68fec7$var$TTCHeader.decode(s);
  }
}
let $05f49f930186144e$var$DFontName = new StringT(uint8);
new Struct({
  len: uint32,
  buf: new BufferT("len")
});
let $05f49f930186144e$var$Ref = new Struct({
  id: uint16,
  nameOffset: int16,
  attr: uint8,
  dataOffset: uint24,
  handle: uint32
}), $05f49f930186144e$var$Type = new Struct({
  name: new StringT(4),
  maxTypeIndex: uint16,
  refList: new Pointer(uint16, new ArrayT($05f49f930186144e$var$Ref, (a) => a.maxTypeIndex + 1), {
    type: "parent"
  })
}), $05f49f930186144e$var$TypeList = new Struct({
  length: uint16,
  types: new ArrayT($05f49f930186144e$var$Type, (a) => a.length + 1)
}), $05f49f930186144e$var$DFontMap = new Struct({
  reserved: new Reserved(uint8, 24),
  typeList: new Pointer(uint16, $05f49f930186144e$var$TypeList),
  nameListOffset: new Pointer(uint16, "void")
}), $05f49f930186144e$var$DFontHeader = new Struct({
  dataOffset: uint32,
  map: new Pointer(uint32, $05f49f930186144e$var$DFontMap),
  dataLength: uint32,
  mapLength: uint32
});
class $05f49f930186144e$export$2e2bcd8739ae039 {
  static probe(s) {
    let $ = new DecodeStream(s);
    try {
      var _ = $05f49f930186144e$var$DFontHeader.decode($);
    } catch {
      return !1;
    }
    for (let _e of _.map.typeList.types)
      if (_e.name === "sfnt")
        return !0;
    return !1;
  }
  getFont(s) {
    if (!this.sfnt)
      return null;
    for (let $ of this.sfnt.refList) {
      let _ = this.header.dataOffset + $.dataOffset + 4, _e = new DecodeStream(this.stream.buffer.slice(_)), tt = new $4c1709dee528ea76$export$2e2bcd8739ae039(_e);
      if (tt.postscriptName === s || tt.postscriptName instanceof Uint8Array && s instanceof Uint8Array && tt.postscriptName.every((nt, at) => s[at] === nt))
        return tt;
    }
    return null;
  }
  get fonts() {
    let s = [];
    for (let $ of this.sfnt.refList) {
      let _ = this.header.dataOffset + $.dataOffset + 4, _e = new DecodeStream(this.stream.buffer.slice(_));
      s.push(new $4c1709dee528ea76$export$2e2bcd8739ae039(_e));
    }
    return s;
  }
  constructor(s) {
    _define_property(this, "type", "DFont"), this.stream = s, this.header = $05f49f930186144e$var$DFontHeader.decode(this.stream);
    for (let $ of this.header.map.typeList.types) {
      for (let _ of $.refList)
        _.nameOffset >= 0 ? (this.stream.pos = _.nameOffset + this.header.map.nameListOffset, _.name = $05f49f930186144e$var$DFontName.decode(this.stream)) : _.name = null;
      $.name === "sfnt" && (this.sfnt = $);
    }
  }
}
$d636bc798e7178db$export$36b2f24e97d43be($4c1709dee528ea76$export$2e2bcd8739ae039);
$d636bc798e7178db$export$36b2f24e97d43be($760785214b9fc52c$export$2e2bcd8739ae039);
$d636bc798e7178db$export$36b2f24e97d43be($21ee218f84ac7f32$export$2e2bcd8739ae039);
$d636bc798e7178db$export$36b2f24e97d43be($cd5853a56c68fec7$export$2e2bcd8739ae039);
$d636bc798e7178db$export$36b2f24e97d43be($05f49f930186144e$export$2e2bcd8739ae039);
const getBrowserVerticalFontAdjustments = (a, s, $, _) => {
  const { ascent: _e, descent: tt, unitsPerEm: nt } = a, at = (_e - tt) / nt, ot = (at * s - s) / 2;
  if (_ === VERTICAL_ALIGN_TOP)
    return { topAdj: pt2px(ot), bottomAdj: 0 };
  let rt = 0;
  return $ < at && (rt = (at - $) * s / 2), { topAdj: 0, bottomAdj: pt2px(rt) };
}, getFontDescentInPt = (a, s) => {
  const { descent: $, unitsPerEm: _ } = a;
  return $ / _ * s;
}, heightOfFontAtSize = (a, s) => {
  const { ascent: $, descent: _, bbox: _e, unitsPerEm: tt } = a, nt = 1e3 / tt, at = ($ || _e.maxY) * nt, ot = (_ || _e.minY) * nt;
  let rt = at - ot;
  return rt -= Math.abs(_ * nt) || 0, rt / 1e3 * s;
}, calculateCharacterSpacing = (a, s) => (a.length - 1) * s, widthOfTextAtSize = (a, s, $, _) => {
  const { glyphs: _e } = s.layout(a), tt = 1e3 / s.unitsPerEm;
  return _e.reduce((at, ot) => at + ot.advanceWidth * tt, 0) * ($ / 1e3) + calculateCharacterSpacing(a, _);
}, getFallbackFont = (a) => {
  const s = getFallbackFontName(a);
  return a[s];
}, getCacheKey = (a) => `getFontKitFont-${a}`, getFontKitFont = async (a, s, $) => {
  const _ = a || getFallbackFontName(s), _e = getCacheKey(_);
  if ($.has(_e))
    return $.get(_e);
  let nt = (s[_] || getFallbackFont(s) || getDefaultFont()[DEFAULT_FONT_NAME]).data;
  typeof nt == "string" && (nt = nt.startsWith("http") ? await fetch(nt).then((ot) => ot.arrayBuffer()) : b64toUint8Array(nt));
  const at = $d636bc798e7178db$export$185802fd694ee1f5(nt instanceof buffer$1.Buffer ? nt : buffer$1.Buffer.from(nt));
  return $.set(_e, at), at;
}, isTextExceedingBoxWidth = (a, s) => {
  const { font: $, fontSize: _, characterSpacing: _e, boxWidthInPt: tt } = s;
  return widthOfTextAtSize(a, $, _, _e) > tt;
}, getOverPosition = (a, s) => {
  for (let $ = 0; $ <= a.length; $++)
    if (isTextExceedingBoxWidth(a.slice(0, $ + 1), s))
      return $;
  return null;
}, isLineBreakableChar = (a) => [" ", "-", "—", "–"].includes(a), getSplitPosition = (a, s) => {
  const $ = getOverPosition(a, s);
  if ($ === null)
    return a.length;
  if (a[$] === " ")
    return $;
  let _ = $ - 1;
  for (; _ >= 0; ) {
    if (isLineBreakableChar(a[_]))
      return _ + 1;
    _--;
  }
  return $;
}, getSplittedLines = (a, s) => {
  const $ = getSplitPosition(a, s), _ = a.substring(0, $).trimEnd(), _e = a.substring($).trimStart();
  return _e === a ? [a] : _e.length === 0 ? [_] : [_, ...getSplittedLines(_e, s)];
}, calculateDynamicFontSize = async ({ textSchema: a, font: s, value: $, startingFontSize: _, _cache: _e }) => {
  const { fontSize: tt, dynamicFontSize: nt, characterSpacing: at, width: ot, height: rt, lineHeight: st = DEFAULT_LINE_HEIGHT } = a, lt = _ || tt || DEFAULT_FONT_SIZE;
  if (!nt || nt.max < nt.min)
    return lt;
  const et = at ?? DEFAULT_CHARACTER_SPACING, it = await getFontKitFont(a.fontName, s, _e), ut = $.split(`
`);
  let ft = lt;
  ft < nt.min ? ft = nt.min : ft > nt.max && (ft = nt.max);
  const ht = nt.fit ?? DEFAULT_DYNAMIC_FIT, dt = (vt) => {
    let At = 0, xt = 0;
    const bt = mm2pt(ot), Et = heightOfFontAtSize(it, vt), St = pt2mm(Et * st), Bt = pt2mm(vt * st);
    return ut.forEach((Ot, Pt) => {
      if (getSplittedLines(Ot, {
        font: it,
        fontSize: vt,
        characterSpacing: et,
        boxWidthInPt: bt
      }).forEach((Ct, It) => {
        if (ht === DYNAMIC_FIT_VERTICAL) {
          const yt = widthOfTextAtSize(Ct, it, vt, et), Rt = pt2mm(yt);
          At = Math.max(At, Rt);
        }
        Pt + It === 0 ? xt += St : xt += Bt;
      }), ht === DYNAMIC_FIT_HORIZONTAL) {
        const Ct = widthOfTextAtSize(Ot, it, vt, et), It = pt2mm(Ct);
        At = Math.max(At, It);
      }
    }), { totalWidthInMm: At, totalHeightInMm: xt };
  }, gt = (vt, At) => ft >= nt.max ? !1 : ht === DYNAMIC_FIT_HORIZONTAL ? vt < ot : At < rt, pt = (vt, At) => ft <= nt.min || ft <= 0 ? !1 : vt > ot || At > rt;
  let { totalWidthInMm: mt, totalHeightInMm: ct } = dt(ft);
  for (; gt(mt, ct); ) {
    ft += FONT_SIZE_ADJUSTMENT;
    const { totalWidthInMm: vt, totalHeightInMm: At } = dt(ft);
    if (At < rt)
      mt = vt, ct = At;
    else {
      ft -= FONT_SIZE_ADJUSTMENT;
      break;
    }
  }
  for (; pt(mt, ct); )
    ft -= FONT_SIZE_ADJUSTMENT, { totalWidthInMm: mt, totalHeightInMm: ct } = dt(ft);
  return ft;
}, splitTextToSize = (a) => {
  const { value: s, characterSpacing: $, fontSize: _, fontKitFont: _e, boxWidthInPt: tt } = a, nt = {
    font: _e,
    fontSize: _,
    characterSpacing: $,
    boxWidthInPt: tt
  };
  let at = [];
  return s.split(/\r\n|\r|\n|\f|\u000B/g).forEach((ot) => {
    at = at.concat(getSplittedLines(ot, nt));
  }), at;
}, isFirefox = () => navigator.userAgent.toLowerCase().indexOf("firefox") > -1, chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", lookup$1 = new Uint8Array(256);
for (let a = 0; a < chars$1.length; a++)
  lookup$1[chars$1.charCodeAt(a)] = a;
const toCharCode = (a) => a.charCodeAt(0), toHexStringOfMinLength = (a, s) => padStart$1(a.toString(16), s, "0").toUpperCase(), toHexString = (a) => toHexStringOfMinLength(a, 2), charFromCode = (a) => String.fromCharCode(a), charFromHexCode = (a) => charFromCode(parseInt(a, 16)), padStart$1 = (a, s, $) => {
  let _ = "";
  for (let _e = 0, tt = s - a.length; _e < tt; _e++)
    _ += $;
  return _ + a;
}, copyStringIntoBuffer = (a, s, $) => {
  const _ = a.length;
  for (let _e = 0; _e < _; _e++)
    s[$++] = a.charCodeAt(_e);
  return _;
}, dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/, parseDate = (a) => {
  const s = a.match(dateRegex);
  if (!s)
    return;
  const [, $, _ = "01", _e = "01", tt = "00", nt = "00", at = "00", ot = "Z", rt = "00", st = "00"] = s, lt = ot === "Z" ? "Z" : `${ot}${rt}:${st}`;
  return /* @__PURE__ */ new Date(`${$}-${_}-${_e}T${tt}:${nt}:${at}${lt}`);
}, findLastMatch = (a, s) => {
  var $;
  let _ = 0, _e;
  for (; _ < a.length; ) {
    const tt = a.substring(_).match(s);
    if (!tt)
      return { match: _e, pos: _ };
    _e = tt, _ += (($ = tt.index) !== null && $ !== void 0 ? $ : 0) + tt[0].length;
  }
  return { match: _e, pos: _ };
}, last$1 = (a) => a[a.length - 1], arrayAsString = (a) => {
  let s = "";
  for (let $ = 0, _ = a.length; $ < _; $++)
    s += charFromCode(a[$]);
  return s;
}, reverseArray = (a) => {
  const s = a.length;
  for (let $ = 0, _ = Math.floor(s / 2); $ < _; $++) {
    const _e = $, tt = s - $ - 1, nt = a[$];
    a[_e] = a[tt], a[tt] = nt;
  }
  return a;
}, sum$1 = (a) => {
  let s = 0;
  for (let $ = 0, _ = a.length; $ < _; $++)
    s += a[$];
  return s;
}, utf16Encode = (a, s = !0) => {
  const $ = [];
  s && $.push(65279);
  for (let _ = 0, _e = a.length; _ < _e; ) {
    const tt = a.codePointAt(_);
    if (tt < 65536)
      $.push(tt), _ += 1;
    else if (tt < 1114112)
      $.push(highSurrogate(tt), lowSurrogate(tt)), _ += 2;
    else
      throw new Error(`Invalid code point: 0x${toHexString(tt)}`);
  }
  return new Uint16Array($);
}, highSurrogate = (a) => Math.floor((a - 65536) / 1024) + 55296, lowSurrogate = (a) => (a - 65536) % 1024 + 56320;
var ByteOrder;
(function(a) {
  a.BigEndian = "BigEndian", a.LittleEndian = "LittleEndian";
})(ByteOrder || (ByteOrder = {}));
const REPLACEMENT = "�".codePointAt(0), utf16Decode = (a, s = !0) => {
  if (a.length <= 1)
    return String.fromCodePoint(REPLACEMENT);
  const $ = s ? readBOM(a) : ByteOrder.BigEndian;
  let _ = s ? 2 : 0;
  const _e = [];
  for (; a.length - _ >= 2; ) {
    const tt = decodeValues(a[_++], a[_++], $);
    if (isHighSurrogate(tt))
      if (a.length - _ < 2)
        _e.push(REPLACEMENT);
      else {
        const nt = decodeValues(a[_++], a[_++], $);
        isLowSurrogate(nt) ? _e.push(tt, nt) : _e.push(REPLACEMENT);
      }
    else
      isLowSurrogate(tt) ? (_ += 2, _e.push(REPLACEMENT)) : _e.push(tt);
  }
  return _ < a.length && _e.push(REPLACEMENT), String.fromCodePoint(..._e);
}, isHighSurrogate = (a) => a >= 55296 && a <= 56319, isLowSurrogate = (a) => a >= 56320 && a <= 57343, decodeValues = (a, s, $) => {
  if ($ === ByteOrder.LittleEndian)
    return s << 8 | a;
  if ($ === ByteOrder.BigEndian)
    return a << 8 | s;
  throw new Error(`Invalid byteOrder: ${$}`);
}, readBOM = (a) => hasUtf16BigEndianBOM(a) ? ByteOrder.BigEndian : hasUtf16LittleEndianBOM(a) ? ByteOrder.LittleEndian : ByteOrder.BigEndian, hasUtf16BigEndianBOM = (a) => a[0] === 254 && a[1] === 255, hasUtf16LittleEndianBOM = (a) => a[0] === 255 && a[1] === 254, hasUtf16BOM = (a) => hasUtf16BigEndianBOM(a) || hasUtf16LittleEndianBOM(a), numberToString = (a) => {
  let s = String(a);
  if (Math.abs(a) < 1) {
    const $ = parseInt(a.toString().split("e-")[1]);
    if ($) {
      const _ = a < 0;
      _ && (a *= -1), a *= Math.pow(10, $ - 1), s = "0." + new Array($).join("0") + a.toString().substring(2), _ && (s = "-" + s);
    }
  } else {
    let $ = parseInt(a.toString().split("+")[1]);
    $ > 20 && ($ -= 20, a /= Math.pow(10, $), s = a.toString() + new Array($ + 1).join("0"));
  }
  return s;
}, sizeInBytes = (a) => Math.ceil(a.toString(2).length / 8), bytesFor = (a) => {
  const s = new Uint8Array(sizeInBytes(a));
  for (let $ = 1; $ <= s.length; $++)
    s[$ - 1] = a >> (s.length - $) * 8;
  return s;
};
var common = {};
(function(a) {
  var s = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
  function $(tt, nt) {
    return Object.prototype.hasOwnProperty.call(tt, nt);
  }
  a.assign = function(tt) {
    for (var nt = Array.prototype.slice.call(arguments, 1); nt.length; ) {
      var at = nt.shift();
      if (at) {
        if (typeof at != "object")
          throw new TypeError(at + "must be non-object");
        for (var ot in at)
          $(at, ot) && (tt[ot] = at[ot]);
      }
    }
    return tt;
  }, a.shrinkBuf = function(tt, nt) {
    return tt.length === nt ? tt : tt.subarray ? tt.subarray(0, nt) : (tt.length = nt, tt);
  };
  var _ = {
    arraySet: function(tt, nt, at, ot, rt) {
      if (nt.subarray && tt.subarray) {
        tt.set(nt.subarray(at, at + ot), rt);
        return;
      }
      for (var st = 0; st < ot; st++)
        tt[rt + st] = nt[at + st];
    },
    // Join array of chunks to single array.
    flattenChunks: function(tt) {
      var nt, at, ot, rt, st, lt;
      for (ot = 0, nt = 0, at = tt.length; nt < at; nt++)
        ot += tt[nt].length;
      for (lt = new Uint8Array(ot), rt = 0, nt = 0, at = tt.length; nt < at; nt++)
        st = tt[nt], lt.set(st, rt), rt += st.length;
      return lt;
    }
  }, _e = {
    arraySet: function(tt, nt, at, ot, rt) {
      for (var st = 0; st < ot; st++)
        tt[rt + st] = nt[at + st];
    },
    // Join array of chunks to single array.
    flattenChunks: function(tt) {
      return [].concat.apply([], tt);
    }
  };
  a.setTyped = function(tt) {
    tt ? (a.Buf8 = Uint8Array, a.Buf16 = Uint16Array, a.Buf32 = Int32Array, a.assign(a, _)) : (a.Buf8 = Array, a.Buf16 = Array, a.Buf32 = Array, a.assign(a, _e));
  }, a.setTyped(s);
})(common);
var deflate$4 = {}, deflate$3 = {}, trees$1 = {}, utils$8 = common, Z_FIXED$1 = 4, Z_BINARY = 0, Z_TEXT = 1, Z_UNKNOWN$1 = 2;
function zero$1(a) {
  for (var s = a.length; --s >= 0; )
    a[s] = 0;
}
var STORED_BLOCK = 0, STATIC_TREES = 1, DYN_TREES = 2, MIN_MATCH$1 = 3, MAX_MATCH$1 = 258, LENGTH_CODES$1 = 29, LITERALS$1 = 256, L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1, D_CODES$1 = 30, BL_CODES$1 = 19, HEAP_SIZE$1 = 2 * L_CODES$1 + 1, MAX_BITS$1 = 15, Buf_size = 16, MAX_BL_BITS = 7, END_BLOCK = 256, REP_3_6 = 16, REPZ_3_10 = 17, REPZ_11_138 = 18, extra_lbits = (
  /* extra bits for each length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
), extra_dbits = (
  /* extra bits for each distance code */
  [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
), extra_blbits = (
  /* extra bits for each bit length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
), bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], DIST_CODE_LEN = 512, static_ltree = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
var static_dtree = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
var _dist_code = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
var _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
var base_length = new Array(LENGTH_CODES$1);
zero$1(base_length);
var base_dist = new Array(D_CODES$1);
zero$1(base_dist);
function StaticTreeDesc(a, s, $, _, _e) {
  this.static_tree = a, this.extra_bits = s, this.extra_base = $, this.elems = _, this.max_length = _e, this.has_stree = a && a.length;
}
var static_l_desc, static_d_desc, static_bl_desc;
function TreeDesc(a, s) {
  this.dyn_tree = a, this.max_code = 0, this.stat_desc = s;
}
function d_code(a) {
  return a < 256 ? _dist_code[a] : _dist_code[256 + (a >>> 7)];
}
function put_short(a, s) {
  a.pending_buf[a.pending++] = s & 255, a.pending_buf[a.pending++] = s >>> 8 & 255;
}
function send_bits(a, s, $) {
  a.bi_valid > Buf_size - $ ? (a.bi_buf |= s << a.bi_valid & 65535, put_short(a, a.bi_buf), a.bi_buf = s >> Buf_size - a.bi_valid, a.bi_valid += $ - Buf_size) : (a.bi_buf |= s << a.bi_valid & 65535, a.bi_valid += $);
}
function send_code(a, s, $) {
  send_bits(
    a,
    $[s * 2],
    $[s * 2 + 1]
    /*.Len*/
  );
}
function bi_reverse(a, s) {
  var $ = 0;
  do
    $ |= a & 1, a >>>= 1, $ <<= 1;
  while (--s > 0);
  return $ >>> 1;
}
function bi_flush(a) {
  a.bi_valid === 16 ? (put_short(a, a.bi_buf), a.bi_buf = 0, a.bi_valid = 0) : a.bi_valid >= 8 && (a.pending_buf[a.pending++] = a.bi_buf & 255, a.bi_buf >>= 8, a.bi_valid -= 8);
}
function gen_bitlen(a, s) {
  var $ = s.dyn_tree, _ = s.max_code, _e = s.stat_desc.static_tree, tt = s.stat_desc.has_stree, nt = s.stat_desc.extra_bits, at = s.stat_desc.extra_base, ot = s.stat_desc.max_length, rt, st, lt, et, it, ut, ft = 0;
  for (et = 0; et <= MAX_BITS$1; et++)
    a.bl_count[et] = 0;
  for ($[a.heap[a.heap_max] * 2 + 1] = 0, rt = a.heap_max + 1; rt < HEAP_SIZE$1; rt++)
    st = a.heap[rt], et = $[$[st * 2 + 1] * 2 + 1] + 1, et > ot && (et = ot, ft++), $[st * 2 + 1] = et, !(st > _) && (a.bl_count[et]++, it = 0, st >= at && (it = nt[st - at]), ut = $[st * 2], a.opt_len += ut * (et + it), tt && (a.static_len += ut * (_e[st * 2 + 1] + it)));
  if (ft !== 0) {
    do {
      for (et = ot - 1; a.bl_count[et] === 0; )
        et--;
      a.bl_count[et]--, a.bl_count[et + 1] += 2, a.bl_count[ot]--, ft -= 2;
    } while (ft > 0);
    for (et = ot; et !== 0; et--)
      for (st = a.bl_count[et]; st !== 0; )
        lt = a.heap[--rt], !(lt > _) && ($[lt * 2 + 1] !== et && (a.opt_len += (et - $[lt * 2 + 1]) * $[lt * 2], $[lt * 2 + 1] = et), st--);
  }
}
function gen_codes(a, s, $) {
  var _ = new Array(MAX_BITS$1 + 1), _e = 0, tt, nt;
  for (tt = 1; tt <= MAX_BITS$1; tt++)
    _[tt] = _e = _e + $[tt - 1] << 1;
  for (nt = 0; nt <= s; nt++) {
    var at = a[nt * 2 + 1];
    at !== 0 && (a[nt * 2] = bi_reverse(_[at]++, at));
  }
}
function tr_static_init() {
  var a, s, $, _, _e, tt = new Array(MAX_BITS$1 + 1);
  for ($ = 0, _ = 0; _ < LENGTH_CODES$1 - 1; _++)
    for (base_length[_] = $, a = 0; a < 1 << extra_lbits[_]; a++)
      _length_code[$++] = _;
  for (_length_code[$ - 1] = _, _e = 0, _ = 0; _ < 16; _++)
    for (base_dist[_] = _e, a = 0; a < 1 << extra_dbits[_]; a++)
      _dist_code[_e++] = _;
  for (_e >>= 7; _ < D_CODES$1; _++)
    for (base_dist[_] = _e << 7, a = 0; a < 1 << extra_dbits[_] - 7; a++)
      _dist_code[256 + _e++] = _;
  for (s = 0; s <= MAX_BITS$1; s++)
    tt[s] = 0;
  for (a = 0; a <= 143; )
    static_ltree[a * 2 + 1] = 8, a++, tt[8]++;
  for (; a <= 255; )
    static_ltree[a * 2 + 1] = 9, a++, tt[9]++;
  for (; a <= 279; )
    static_ltree[a * 2 + 1] = 7, a++, tt[7]++;
  for (; a <= 287; )
    static_ltree[a * 2 + 1] = 8, a++, tt[8]++;
  for (gen_codes(static_ltree, L_CODES$1 + 1, tt), a = 0; a < D_CODES$1; a++)
    static_dtree[a * 2 + 1] = 5, static_dtree[a * 2] = bi_reverse(a, 5);
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1), static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1), static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
}
function init_block(a) {
  var s;
  for (s = 0; s < L_CODES$1; s++)
    a.dyn_ltree[s * 2] = 0;
  for (s = 0; s < D_CODES$1; s++)
    a.dyn_dtree[s * 2] = 0;
  for (s = 0; s < BL_CODES$1; s++)
    a.bl_tree[s * 2] = 0;
  a.dyn_ltree[END_BLOCK * 2] = 1, a.opt_len = a.static_len = 0, a.last_lit = a.matches = 0;
}
function bi_windup(a) {
  a.bi_valid > 8 ? put_short(a, a.bi_buf) : a.bi_valid > 0 && (a.pending_buf[a.pending++] = a.bi_buf), a.bi_buf = 0, a.bi_valid = 0;
}
function copy_block(a, s, $, _) {
  bi_windup(a), _ && (put_short(a, $), put_short(a, ~$)), utils$8.arraySet(a.pending_buf, a.window, s, $, a.pending), a.pending += $;
}
function smaller(a, s, $, _) {
  var _e = s * 2, tt = $ * 2;
  return a[_e] < a[tt] || a[_e] === a[tt] && _[s] <= _[$];
}
function pqdownheap(a, s, $) {
  for (var _ = a.heap[$], _e = $ << 1; _e <= a.heap_len && (_e < a.heap_len && smaller(s, a.heap[_e + 1], a.heap[_e], a.depth) && _e++, !smaller(s, _, a.heap[_e], a.depth)); )
    a.heap[$] = a.heap[_e], $ = _e, _e <<= 1;
  a.heap[$] = _;
}
function compress_block(a, s, $) {
  var _, _e, tt = 0, nt, at;
  if (a.last_lit !== 0)
    do
      _ = a.pending_buf[a.d_buf + tt * 2] << 8 | a.pending_buf[a.d_buf + tt * 2 + 1], _e = a.pending_buf[a.l_buf + tt], tt++, _ === 0 ? send_code(a, _e, s) : (nt = _length_code[_e], send_code(a, nt + LITERALS$1 + 1, s), at = extra_lbits[nt], at !== 0 && (_e -= base_length[nt], send_bits(a, _e, at)), _--, nt = d_code(_), send_code(a, nt, $), at = extra_dbits[nt], at !== 0 && (_ -= base_dist[nt], send_bits(a, _, at)));
    while (tt < a.last_lit);
  send_code(a, END_BLOCK, s);
}
function build_tree(a, s) {
  var $ = s.dyn_tree, _ = s.stat_desc.static_tree, _e = s.stat_desc.has_stree, tt = s.stat_desc.elems, nt, at, ot = -1, rt;
  for (a.heap_len = 0, a.heap_max = HEAP_SIZE$1, nt = 0; nt < tt; nt++)
    $[nt * 2] !== 0 ? (a.heap[++a.heap_len] = ot = nt, a.depth[nt] = 0) : $[nt * 2 + 1] = 0;
  for (; a.heap_len < 2; )
    rt = a.heap[++a.heap_len] = ot < 2 ? ++ot : 0, $[rt * 2] = 1, a.depth[rt] = 0, a.opt_len--, _e && (a.static_len -= _[rt * 2 + 1]);
  for (s.max_code = ot, nt = a.heap_len >> 1; nt >= 1; nt--)
    pqdownheap(a, $, nt);
  rt = tt;
  do
    nt = a.heap[
      1
      /*SMALLEST*/
    ], a.heap[
      1
      /*SMALLEST*/
    ] = a.heap[a.heap_len--], pqdownheap(
      a,
      $,
      1
      /*SMALLEST*/
    ), at = a.heap[
      1
      /*SMALLEST*/
    ], a.heap[--a.heap_max] = nt, a.heap[--a.heap_max] = at, $[rt * 2] = $[nt * 2] + $[at * 2], a.depth[rt] = (a.depth[nt] >= a.depth[at] ? a.depth[nt] : a.depth[at]) + 1, $[nt * 2 + 1] = $[at * 2 + 1] = rt, a.heap[
      1
      /*SMALLEST*/
    ] = rt++, pqdownheap(
      a,
      $,
      1
      /*SMALLEST*/
    );
  while (a.heap_len >= 2);
  a.heap[--a.heap_max] = a.heap[
    1
    /*SMALLEST*/
  ], gen_bitlen(a, s), gen_codes($, ot, a.bl_count);
}
function scan_tree(a, s, $) {
  var _, _e = -1, tt, nt = s[0 * 2 + 1], at = 0, ot = 7, rt = 4;
  for (nt === 0 && (ot = 138, rt = 3), s[($ + 1) * 2 + 1] = 65535, _ = 0; _ <= $; _++)
    tt = nt, nt = s[(_ + 1) * 2 + 1], !(++at < ot && tt === nt) && (at < rt ? a.bl_tree[tt * 2] += at : tt !== 0 ? (tt !== _e && a.bl_tree[tt * 2]++, a.bl_tree[REP_3_6 * 2]++) : at <= 10 ? a.bl_tree[REPZ_3_10 * 2]++ : a.bl_tree[REPZ_11_138 * 2]++, at = 0, _e = tt, nt === 0 ? (ot = 138, rt = 3) : tt === nt ? (ot = 6, rt = 3) : (ot = 7, rt = 4));
}
function send_tree(a, s, $) {
  var _, _e = -1, tt, nt = s[0 * 2 + 1], at = 0, ot = 7, rt = 4;
  for (nt === 0 && (ot = 138, rt = 3), _ = 0; _ <= $; _++)
    if (tt = nt, nt = s[(_ + 1) * 2 + 1], !(++at < ot && tt === nt)) {
      if (at < rt)
        do
          send_code(a, tt, a.bl_tree);
        while (--at !== 0);
      else
        tt !== 0 ? (tt !== _e && (send_code(a, tt, a.bl_tree), at--), send_code(a, REP_3_6, a.bl_tree), send_bits(a, at - 3, 2)) : at <= 10 ? (send_code(a, REPZ_3_10, a.bl_tree), send_bits(a, at - 3, 3)) : (send_code(a, REPZ_11_138, a.bl_tree), send_bits(a, at - 11, 7));
      at = 0, _e = tt, nt === 0 ? (ot = 138, rt = 3) : tt === nt ? (ot = 6, rt = 3) : (ot = 7, rt = 4);
    }
}
function build_bl_tree(a) {
  var s;
  for (scan_tree(a, a.dyn_ltree, a.l_desc.max_code), scan_tree(a, a.dyn_dtree, a.d_desc.max_code), build_tree(a, a.bl_desc), s = BL_CODES$1 - 1; s >= 3 && a.bl_tree[bl_order[s] * 2 + 1] === 0; s--)
    ;
  return a.opt_len += 3 * (s + 1) + 5 + 5 + 4, s;
}
function send_all_trees(a, s, $, _) {
  var _e;
  for (send_bits(a, s - 257, 5), send_bits(a, $ - 1, 5), send_bits(a, _ - 4, 4), _e = 0; _e < _; _e++)
    send_bits(a, a.bl_tree[bl_order[_e] * 2 + 1], 3);
  send_tree(a, a.dyn_ltree, s - 1), send_tree(a, a.dyn_dtree, $ - 1);
}
function detect_data_type(a) {
  var s = 4093624447, $;
  for ($ = 0; $ <= 31; $++, s >>>= 1)
    if (s & 1 && a.dyn_ltree[$ * 2] !== 0)
      return Z_BINARY;
  if (a.dyn_ltree[9 * 2] !== 0 || a.dyn_ltree[10 * 2] !== 0 || a.dyn_ltree[13 * 2] !== 0)
    return Z_TEXT;
  for ($ = 32; $ < LITERALS$1; $++)
    if (a.dyn_ltree[$ * 2] !== 0)
      return Z_TEXT;
  return Z_BINARY;
}
var static_init_done = !1;
function _tr_init(a) {
  static_init_done || (tr_static_init(), static_init_done = !0), a.l_desc = new TreeDesc(a.dyn_ltree, static_l_desc), a.d_desc = new TreeDesc(a.dyn_dtree, static_d_desc), a.bl_desc = new TreeDesc(a.bl_tree, static_bl_desc), a.bi_buf = 0, a.bi_valid = 0, init_block(a);
}
function _tr_stored_block(a, s, $, _) {
  send_bits(a, (STORED_BLOCK << 1) + (_ ? 1 : 0), 3), copy_block(a, s, $, !0);
}
function _tr_align(a) {
  send_bits(a, STATIC_TREES << 1, 3), send_code(a, END_BLOCK, static_ltree), bi_flush(a);
}
function _tr_flush_block(a, s, $, _) {
  var _e, tt, nt = 0;
  a.level > 0 ? (a.strm.data_type === Z_UNKNOWN$1 && (a.strm.data_type = detect_data_type(a)), build_tree(a, a.l_desc), build_tree(a, a.d_desc), nt = build_bl_tree(a), _e = a.opt_len + 3 + 7 >>> 3, tt = a.static_len + 3 + 7 >>> 3, tt <= _e && (_e = tt)) : _e = tt = $ + 5, $ + 4 <= _e && s !== -1 ? _tr_stored_block(a, s, $, _) : a.strategy === Z_FIXED$1 || tt === _e ? (send_bits(a, (STATIC_TREES << 1) + (_ ? 1 : 0), 3), compress_block(a, static_ltree, static_dtree)) : (send_bits(a, (DYN_TREES << 1) + (_ ? 1 : 0), 3), send_all_trees(a, a.l_desc.max_code + 1, a.d_desc.max_code + 1, nt + 1), compress_block(a, a.dyn_ltree, a.dyn_dtree)), init_block(a), _ && bi_windup(a);
}
function _tr_tally(a, s, $) {
  return a.pending_buf[a.d_buf + a.last_lit * 2] = s >>> 8 & 255, a.pending_buf[a.d_buf + a.last_lit * 2 + 1] = s & 255, a.pending_buf[a.l_buf + a.last_lit] = $ & 255, a.last_lit++, s === 0 ? a.dyn_ltree[$ * 2]++ : (a.matches++, s--, a.dyn_ltree[(_length_code[$] + LITERALS$1 + 1) * 2]++, a.dyn_dtree[d_code(s) * 2]++), a.last_lit === a.lit_bufsize - 1;
}
trees$1._tr_init = _tr_init;
trees$1._tr_stored_block = _tr_stored_block;
trees$1._tr_flush_block = _tr_flush_block;
trees$1._tr_tally = _tr_tally;
trees$1._tr_align = _tr_align;
function adler32$2(a, s, $, _) {
  for (var _e = a & 65535 | 0, tt = a >>> 16 & 65535 | 0, nt = 0; $ !== 0; ) {
    nt = $ > 2e3 ? 2e3 : $, $ -= nt;
    do
      _e = _e + s[_++] | 0, tt = tt + _e | 0;
    while (--nt);
    _e %= 65521, tt %= 65521;
  }
  return _e | tt << 16 | 0;
}
var adler32_1 = adler32$2;
function makeTable() {
  for (var a, s = [], $ = 0; $ < 256; $++) {
    a = $;
    for (var _ = 0; _ < 8; _++)
      a = a & 1 ? 3988292384 ^ a >>> 1 : a >>> 1;
    s[$] = a;
  }
  return s;
}
var crcTable = makeTable();
function crc32$2(a, s, $, _) {
  var _e = crcTable, tt = _ + $;
  a ^= -1;
  for (var nt = _; nt < tt; nt++)
    a = a >>> 8 ^ _e[(a ^ s[nt]) & 255];
  return a ^ -1;
}
var crc32_1 = crc32$2, messages$1 = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, utils$7 = common, trees = trees$1, adler32$1 = adler32_1, crc32$1 = crc32_1, msg$2 = messages$1, Z_NO_FLUSH$1 = 0, Z_PARTIAL_FLUSH = 1, Z_FULL_FLUSH = 3, Z_FINISH$2 = 4, Z_BLOCK$1 = 5, Z_OK$2 = 0, Z_STREAM_END$2 = 1, Z_STREAM_ERROR$1 = -2, Z_DATA_ERROR$1 = -3, Z_BUF_ERROR$1 = -5, Z_DEFAULT_COMPRESSION$1 = -1, Z_FILTERED = 1, Z_HUFFMAN_ONLY = 2, Z_RLE = 3, Z_FIXED = 4, Z_DEFAULT_STRATEGY$1 = 0, Z_UNKNOWN = 2, Z_DEFLATED$2 = 8, MAX_MEM_LEVEL = 9, MAX_WBITS$1 = 15, DEF_MEM_LEVEL = 8, LENGTH_CODES = 29, LITERALS = 256, L_CODES = LITERALS + 1 + LENGTH_CODES, D_CODES = 30, BL_CODES = 19, HEAP_SIZE = 2 * L_CODES + 1, MAX_BITS = 15, MIN_MATCH = 3, MAX_MATCH = 258, MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1, PRESET_DICT = 32, INIT_STATE = 42, EXTRA_STATE = 69, NAME_STATE = 73, COMMENT_STATE = 91, HCRC_STATE = 103, BUSY_STATE = 113, FINISH_STATE = 666, BS_NEED_MORE = 1, BS_BLOCK_DONE = 2, BS_FINISH_STARTED = 3, BS_FINISH_DONE = 4, OS_CODE = 3;
function err(a, s) {
  return a.msg = msg$2[s], s;
}
function rank(a) {
  return (a << 1) - (a > 4 ? 9 : 0);
}
function zero(a) {
  for (var s = a.length; --s >= 0; )
    a[s] = 0;
}
function flush_pending(a) {
  var s = a.state, $ = s.pending;
  $ > a.avail_out && ($ = a.avail_out), $ !== 0 && (utils$7.arraySet(a.output, s.pending_buf, s.pending_out, $, a.next_out), a.next_out += $, s.pending_out += $, a.total_out += $, a.avail_out -= $, s.pending -= $, s.pending === 0 && (s.pending_out = 0));
}
function flush_block_only(a, s) {
  trees._tr_flush_block(a, a.block_start >= 0 ? a.block_start : -1, a.strstart - a.block_start, s), a.block_start = a.strstart, flush_pending(a.strm);
}
function put_byte(a, s) {
  a.pending_buf[a.pending++] = s;
}
function putShortMSB(a, s) {
  a.pending_buf[a.pending++] = s >>> 8 & 255, a.pending_buf[a.pending++] = s & 255;
}
function read_buf(a, s, $, _) {
  var _e = a.avail_in;
  return _e > _ && (_e = _), _e === 0 ? 0 : (a.avail_in -= _e, utils$7.arraySet(s, a.input, a.next_in, _e, $), a.state.wrap === 1 ? a.adler = adler32$1(a.adler, s, _e, $) : a.state.wrap === 2 && (a.adler = crc32$1(a.adler, s, _e, $)), a.next_in += _e, a.total_in += _e, _e);
}
function longest_match(a, s) {
  var $ = a.max_chain_length, _ = a.strstart, _e, tt, nt = a.prev_length, at = a.nice_match, ot = a.strstart > a.w_size - MIN_LOOKAHEAD ? a.strstart - (a.w_size - MIN_LOOKAHEAD) : 0, rt = a.window, st = a.w_mask, lt = a.prev, et = a.strstart + MAX_MATCH, it = rt[_ + nt - 1], ut = rt[_ + nt];
  a.prev_length >= a.good_match && ($ >>= 2), at > a.lookahead && (at = a.lookahead);
  do
    if (_e = s, !(rt[_e + nt] !== ut || rt[_e + nt - 1] !== it || rt[_e] !== rt[_] || rt[++_e] !== rt[_ + 1])) {
      _ += 2, _e++;
      do
        ;
      while (rt[++_] === rt[++_e] && rt[++_] === rt[++_e] && rt[++_] === rt[++_e] && rt[++_] === rt[++_e] && rt[++_] === rt[++_e] && rt[++_] === rt[++_e] && rt[++_] === rt[++_e] && rt[++_] === rt[++_e] && _ < et);
      if (tt = MAX_MATCH - (et - _), _ = et - MAX_MATCH, tt > nt) {
        if (a.match_start = s, nt = tt, tt >= at)
          break;
        it = rt[_ + nt - 1], ut = rt[_ + nt];
      }
    }
  while ((s = lt[s & st]) > ot && --$ !== 0);
  return nt <= a.lookahead ? nt : a.lookahead;
}
function fill_window(a) {
  var s = a.w_size, $, _, _e, tt, nt;
  do {
    if (tt = a.window_size - a.lookahead - a.strstart, a.strstart >= s + (s - MIN_LOOKAHEAD)) {
      utils$7.arraySet(a.window, a.window, s, s, 0), a.match_start -= s, a.strstart -= s, a.block_start -= s, _ = a.hash_size, $ = _;
      do
        _e = a.head[--$], a.head[$] = _e >= s ? _e - s : 0;
      while (--_);
      _ = s, $ = _;
      do
        _e = a.prev[--$], a.prev[$] = _e >= s ? _e - s : 0;
      while (--_);
      tt += s;
    }
    if (a.strm.avail_in === 0)
      break;
    if (_ = read_buf(a.strm, a.window, a.strstart + a.lookahead, tt), a.lookahead += _, a.lookahead + a.insert >= MIN_MATCH)
      for (nt = a.strstart - a.insert, a.ins_h = a.window[nt], a.ins_h = (a.ins_h << a.hash_shift ^ a.window[nt + 1]) & a.hash_mask; a.insert && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[nt + MIN_MATCH - 1]) & a.hash_mask, a.prev[nt & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = nt, nt++, a.insert--, !(a.lookahead + a.insert < MIN_MATCH)); )
        ;
  } while (a.lookahead < MIN_LOOKAHEAD && a.strm.avail_in !== 0);
}
function deflate_stored(a, s) {
  var $ = 65535;
  for ($ > a.pending_buf_size - 5 && ($ = a.pending_buf_size - 5); ; ) {
    if (a.lookahead <= 1) {
      if (fill_window(a), a.lookahead === 0 && s === Z_NO_FLUSH$1)
        return BS_NEED_MORE;
      if (a.lookahead === 0)
        break;
    }
    a.strstart += a.lookahead, a.lookahead = 0;
    var _ = a.block_start + $;
    if ((a.strstart === 0 || a.strstart >= _) && (a.lookahead = a.strstart - _, a.strstart = _, flush_block_only(a, !1), a.strm.avail_out === 0) || a.strstart - a.block_start >= a.w_size - MIN_LOOKAHEAD && (flush_block_only(a, !1), a.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return a.insert = 0, s === Z_FINISH$2 ? (flush_block_only(a, !0), a.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : (a.strstart > a.block_start && (flush_block_only(a, !1), a.strm.avail_out === 0), BS_NEED_MORE);
}
function deflate_fast(a, s) {
  for (var $, _; ; ) {
    if (a.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(a), a.lookahead < MIN_LOOKAHEAD && s === Z_NO_FLUSH$1)
        return BS_NEED_MORE;
      if (a.lookahead === 0)
        break;
    }
    if ($ = 0, a.lookahead >= MIN_MATCH && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + MIN_MATCH - 1]) & a.hash_mask, $ = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart), $ !== 0 && a.strstart - $ <= a.w_size - MIN_LOOKAHEAD && (a.match_length = longest_match(a, $)), a.match_length >= MIN_MATCH)
      if (_ = trees._tr_tally(a, a.strstart - a.match_start, a.match_length - MIN_MATCH), a.lookahead -= a.match_length, a.match_length <= a.max_lazy_match && a.lookahead >= MIN_MATCH) {
        a.match_length--;
        do
          a.strstart++, a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + MIN_MATCH - 1]) & a.hash_mask, $ = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart;
        while (--a.match_length !== 0);
        a.strstart++;
      } else
        a.strstart += a.match_length, a.match_length = 0, a.ins_h = a.window[a.strstart], a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + 1]) & a.hash_mask;
    else
      _ = trees._tr_tally(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++;
    if (_ && (flush_block_only(a, !1), a.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return a.insert = a.strstart < MIN_MATCH - 1 ? a.strstart : MIN_MATCH - 1, s === Z_FINISH$2 ? (flush_block_only(a, !0), a.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : a.last_lit && (flush_block_only(a, !1), a.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}
function deflate_slow(a, s) {
  for (var $, _, _e; ; ) {
    if (a.lookahead < MIN_LOOKAHEAD) {
      if (fill_window(a), a.lookahead < MIN_LOOKAHEAD && s === Z_NO_FLUSH$1)
        return BS_NEED_MORE;
      if (a.lookahead === 0)
        break;
    }
    if ($ = 0, a.lookahead >= MIN_MATCH && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + MIN_MATCH - 1]) & a.hash_mask, $ = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart), a.prev_length = a.match_length, a.prev_match = a.match_start, a.match_length = MIN_MATCH - 1, $ !== 0 && a.prev_length < a.max_lazy_match && a.strstart - $ <= a.w_size - MIN_LOOKAHEAD && (a.match_length = longest_match(a, $), a.match_length <= 5 && (a.strategy === Z_FILTERED || a.match_length === MIN_MATCH && a.strstart - a.match_start > 4096) && (a.match_length = MIN_MATCH - 1)), a.prev_length >= MIN_MATCH && a.match_length <= a.prev_length) {
      _e = a.strstart + a.lookahead - MIN_MATCH, _ = trees._tr_tally(a, a.strstart - 1 - a.prev_match, a.prev_length - MIN_MATCH), a.lookahead -= a.prev_length - 1, a.prev_length -= 2;
      do
        ++a.strstart <= _e && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + MIN_MATCH - 1]) & a.hash_mask, $ = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart);
      while (--a.prev_length !== 0);
      if (a.match_available = 0, a.match_length = MIN_MATCH - 1, a.strstart++, _ && (flush_block_only(a, !1), a.strm.avail_out === 0))
        return BS_NEED_MORE;
    } else if (a.match_available) {
      if (_ = trees._tr_tally(a, 0, a.window[a.strstart - 1]), _ && flush_block_only(a, !1), a.strstart++, a.lookahead--, a.strm.avail_out === 0)
        return BS_NEED_MORE;
    } else
      a.match_available = 1, a.strstart++, a.lookahead--;
  }
  return a.match_available && (_ = trees._tr_tally(a, 0, a.window[a.strstart - 1]), a.match_available = 0), a.insert = a.strstart < MIN_MATCH - 1 ? a.strstart : MIN_MATCH - 1, s === Z_FINISH$2 ? (flush_block_only(a, !0), a.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : a.last_lit && (flush_block_only(a, !1), a.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}
function deflate_rle(a, s) {
  for (var $, _, _e, tt, nt = a.window; ; ) {
    if (a.lookahead <= MAX_MATCH) {
      if (fill_window(a), a.lookahead <= MAX_MATCH && s === Z_NO_FLUSH$1)
        return BS_NEED_MORE;
      if (a.lookahead === 0)
        break;
    }
    if (a.match_length = 0, a.lookahead >= MIN_MATCH && a.strstart > 0 && (_e = a.strstart - 1, _ = nt[_e], _ === nt[++_e] && _ === nt[++_e] && _ === nt[++_e])) {
      tt = a.strstart + MAX_MATCH;
      do
        ;
      while (_ === nt[++_e] && _ === nt[++_e] && _ === nt[++_e] && _ === nt[++_e] && _ === nt[++_e] && _ === nt[++_e] && _ === nt[++_e] && _ === nt[++_e] && _e < tt);
      a.match_length = MAX_MATCH - (tt - _e), a.match_length > a.lookahead && (a.match_length = a.lookahead);
    }
    if (a.match_length >= MIN_MATCH ? ($ = trees._tr_tally(a, 1, a.match_length - MIN_MATCH), a.lookahead -= a.match_length, a.strstart += a.match_length, a.match_length = 0) : ($ = trees._tr_tally(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++), $ && (flush_block_only(a, !1), a.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return a.insert = 0, s === Z_FINISH$2 ? (flush_block_only(a, !0), a.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : a.last_lit && (flush_block_only(a, !1), a.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}
function deflate_huff(a, s) {
  for (var $; ; ) {
    if (a.lookahead === 0 && (fill_window(a), a.lookahead === 0)) {
      if (s === Z_NO_FLUSH$1)
        return BS_NEED_MORE;
      break;
    }
    if (a.match_length = 0, $ = trees._tr_tally(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++, $ && (flush_block_only(a, !1), a.strm.avail_out === 0))
      return BS_NEED_MORE;
  }
  return a.insert = 0, s === Z_FINISH$2 ? (flush_block_only(a, !0), a.strm.avail_out === 0 ? BS_FINISH_STARTED : BS_FINISH_DONE) : a.last_lit && (flush_block_only(a, !1), a.strm.avail_out === 0) ? BS_NEED_MORE : BS_BLOCK_DONE;
}
function Config(a, s, $, _, _e) {
  this.good_length = a, this.max_lazy = s, this.nice_length = $, this.max_chain = _, this.func = _e;
}
var configuration_table;
configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),
  /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),
  /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),
  /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),
  /* 3 */
  new Config(4, 4, 16, 16, deflate_slow),
  /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),
  /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),
  /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),
  /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),
  /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)
  /* 9 max compression */
];
function lm_init(a) {
  a.window_size = 2 * a.w_size, zero(a.head), a.max_lazy_match = configuration_table[a.level].max_lazy, a.good_match = configuration_table[a.level].good_length, a.nice_match = configuration_table[a.level].nice_length, a.max_chain_length = configuration_table[a.level].max_chain, a.strstart = 0, a.block_start = 0, a.lookahead = 0, a.insert = 0, a.match_length = a.prev_length = MIN_MATCH - 1, a.match_available = 0, a.ins_h = 0;
}
function DeflateState() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Z_DEFLATED$2, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new utils$7.Buf16(HEAP_SIZE * 2), this.dyn_dtree = new utils$7.Buf16((2 * D_CODES + 1) * 2), this.bl_tree = new utils$7.Buf16((2 * BL_CODES + 1) * 2), zero(this.dyn_ltree), zero(this.dyn_dtree), zero(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new utils$7.Buf16(MAX_BITS + 1), this.heap = new utils$7.Buf16(2 * L_CODES + 1), zero(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new utils$7.Buf16(2 * L_CODES + 1), zero(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
function deflateResetKeep(a) {
  var s;
  return !a || !a.state ? err(a, Z_STREAM_ERROR$1) : (a.total_in = a.total_out = 0, a.data_type = Z_UNKNOWN, s = a.state, s.pending = 0, s.pending_out = 0, s.wrap < 0 && (s.wrap = -s.wrap), s.status = s.wrap ? INIT_STATE : BUSY_STATE, a.adler = s.wrap === 2 ? 0 : 1, s.last_flush = Z_NO_FLUSH$1, trees._tr_init(s), Z_OK$2);
}
function deflateReset(a) {
  var s = deflateResetKeep(a);
  return s === Z_OK$2 && lm_init(a.state), s;
}
function deflateSetHeader(a, s) {
  return !a || !a.state || a.state.wrap !== 2 ? Z_STREAM_ERROR$1 : (a.state.gzhead = s, Z_OK$2);
}
function deflateInit2(a, s, $, _, _e, tt) {
  if (!a)
    return Z_STREAM_ERROR$1;
  var nt = 1;
  if (s === Z_DEFAULT_COMPRESSION$1 && (s = 6), _ < 0 ? (nt = 0, _ = -_) : _ > 15 && (nt = 2, _ -= 16), _e < 1 || _e > MAX_MEM_LEVEL || $ !== Z_DEFLATED$2 || _ < 8 || _ > 15 || s < 0 || s > 9 || tt < 0 || tt > Z_FIXED)
    return err(a, Z_STREAM_ERROR$1);
  _ === 8 && (_ = 9);
  var at = new DeflateState();
  return a.state = at, at.strm = a, at.wrap = nt, at.gzhead = null, at.w_bits = _, at.w_size = 1 << at.w_bits, at.w_mask = at.w_size - 1, at.hash_bits = _e + 7, at.hash_size = 1 << at.hash_bits, at.hash_mask = at.hash_size - 1, at.hash_shift = ~~((at.hash_bits + MIN_MATCH - 1) / MIN_MATCH), at.window = new utils$7.Buf8(at.w_size * 2), at.head = new utils$7.Buf16(at.hash_size), at.prev = new utils$7.Buf16(at.w_size), at.lit_bufsize = 1 << _e + 6, at.pending_buf_size = at.lit_bufsize * 4, at.pending_buf = new utils$7.Buf8(at.pending_buf_size), at.d_buf = 1 * at.lit_bufsize, at.l_buf = 3 * at.lit_bufsize, at.level = s, at.strategy = tt, at.method = $, deflateReset(a);
}
function deflateInit(a, s) {
  return deflateInit2(a, s, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
}
function deflate$2(a, s) {
  var $, _, _e, tt;
  if (!a || !a.state || s > Z_BLOCK$1 || s < 0)
    return a ? err(a, Z_STREAM_ERROR$1) : Z_STREAM_ERROR$1;
  if (_ = a.state, !a.output || !a.input && a.avail_in !== 0 || _.status === FINISH_STATE && s !== Z_FINISH$2)
    return err(a, a.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$1);
  if (_.strm = a, $ = _.last_flush, _.last_flush = s, _.status === INIT_STATE)
    if (_.wrap === 2)
      a.adler = 0, put_byte(_, 31), put_byte(_, 139), put_byte(_, 8), _.gzhead ? (put_byte(
        _,
        (_.gzhead.text ? 1 : 0) + (_.gzhead.hcrc ? 2 : 0) + (_.gzhead.extra ? 4 : 0) + (_.gzhead.name ? 8 : 0) + (_.gzhead.comment ? 16 : 0)
      ), put_byte(_, _.gzhead.time & 255), put_byte(_, _.gzhead.time >> 8 & 255), put_byte(_, _.gzhead.time >> 16 & 255), put_byte(_, _.gzhead.time >> 24 & 255), put_byte(_, _.level === 9 ? 2 : _.strategy >= Z_HUFFMAN_ONLY || _.level < 2 ? 4 : 0), put_byte(_, _.gzhead.os & 255), _.gzhead.extra && _.gzhead.extra.length && (put_byte(_, _.gzhead.extra.length & 255), put_byte(_, _.gzhead.extra.length >> 8 & 255)), _.gzhead.hcrc && (a.adler = crc32$1(a.adler, _.pending_buf, _.pending, 0)), _.gzindex = 0, _.status = EXTRA_STATE) : (put_byte(_, 0), put_byte(_, 0), put_byte(_, 0), put_byte(_, 0), put_byte(_, 0), put_byte(_, _.level === 9 ? 2 : _.strategy >= Z_HUFFMAN_ONLY || _.level < 2 ? 4 : 0), put_byte(_, OS_CODE), _.status = BUSY_STATE);
    else {
      var nt = Z_DEFLATED$2 + (_.w_bits - 8 << 4) << 8, at = -1;
      _.strategy >= Z_HUFFMAN_ONLY || _.level < 2 ? at = 0 : _.level < 6 ? at = 1 : _.level === 6 ? at = 2 : at = 3, nt |= at << 6, _.strstart !== 0 && (nt |= PRESET_DICT), nt += 31 - nt % 31, _.status = BUSY_STATE, putShortMSB(_, nt), _.strstart !== 0 && (putShortMSB(_, a.adler >>> 16), putShortMSB(_, a.adler & 65535)), a.adler = 1;
    }
  if (_.status === EXTRA_STATE)
    if (_.gzhead.extra) {
      for (_e = _.pending; _.gzindex < (_.gzhead.extra.length & 65535) && !(_.pending === _.pending_buf_size && (_.gzhead.hcrc && _.pending > _e && (a.adler = crc32$1(a.adler, _.pending_buf, _.pending - _e, _e)), flush_pending(a), _e = _.pending, _.pending === _.pending_buf_size)); )
        put_byte(_, _.gzhead.extra[_.gzindex] & 255), _.gzindex++;
      _.gzhead.hcrc && _.pending > _e && (a.adler = crc32$1(a.adler, _.pending_buf, _.pending - _e, _e)), _.gzindex === _.gzhead.extra.length && (_.gzindex = 0, _.status = NAME_STATE);
    } else
      _.status = NAME_STATE;
  if (_.status === NAME_STATE)
    if (_.gzhead.name) {
      _e = _.pending;
      do {
        if (_.pending === _.pending_buf_size && (_.gzhead.hcrc && _.pending > _e && (a.adler = crc32$1(a.adler, _.pending_buf, _.pending - _e, _e)), flush_pending(a), _e = _.pending, _.pending === _.pending_buf_size)) {
          tt = 1;
          break;
        }
        _.gzindex < _.gzhead.name.length ? tt = _.gzhead.name.charCodeAt(_.gzindex++) & 255 : tt = 0, put_byte(_, tt);
      } while (tt !== 0);
      _.gzhead.hcrc && _.pending > _e && (a.adler = crc32$1(a.adler, _.pending_buf, _.pending - _e, _e)), tt === 0 && (_.gzindex = 0, _.status = COMMENT_STATE);
    } else
      _.status = COMMENT_STATE;
  if (_.status === COMMENT_STATE)
    if (_.gzhead.comment) {
      _e = _.pending;
      do {
        if (_.pending === _.pending_buf_size && (_.gzhead.hcrc && _.pending > _e && (a.adler = crc32$1(a.adler, _.pending_buf, _.pending - _e, _e)), flush_pending(a), _e = _.pending, _.pending === _.pending_buf_size)) {
          tt = 1;
          break;
        }
        _.gzindex < _.gzhead.comment.length ? tt = _.gzhead.comment.charCodeAt(_.gzindex++) & 255 : tt = 0, put_byte(_, tt);
      } while (tt !== 0);
      _.gzhead.hcrc && _.pending > _e && (a.adler = crc32$1(a.adler, _.pending_buf, _.pending - _e, _e)), tt === 0 && (_.status = HCRC_STATE);
    } else
      _.status = HCRC_STATE;
  if (_.status === HCRC_STATE && (_.gzhead.hcrc ? (_.pending + 2 > _.pending_buf_size && flush_pending(a), _.pending + 2 <= _.pending_buf_size && (put_byte(_, a.adler & 255), put_byte(_, a.adler >> 8 & 255), a.adler = 0, _.status = BUSY_STATE)) : _.status = BUSY_STATE), _.pending !== 0) {
    if (flush_pending(a), a.avail_out === 0)
      return _.last_flush = -1, Z_OK$2;
  } else if (a.avail_in === 0 && rank(s) <= rank($) && s !== Z_FINISH$2)
    return err(a, Z_BUF_ERROR$1);
  if (_.status === FINISH_STATE && a.avail_in !== 0)
    return err(a, Z_BUF_ERROR$1);
  if (a.avail_in !== 0 || _.lookahead !== 0 || s !== Z_NO_FLUSH$1 && _.status !== FINISH_STATE) {
    var ot = _.strategy === Z_HUFFMAN_ONLY ? deflate_huff(_, s) : _.strategy === Z_RLE ? deflate_rle(_, s) : configuration_table[_.level].func(_, s);
    if ((ot === BS_FINISH_STARTED || ot === BS_FINISH_DONE) && (_.status = FINISH_STATE), ot === BS_NEED_MORE || ot === BS_FINISH_STARTED)
      return a.avail_out === 0 && (_.last_flush = -1), Z_OK$2;
    if (ot === BS_BLOCK_DONE && (s === Z_PARTIAL_FLUSH ? trees._tr_align(_) : s !== Z_BLOCK$1 && (trees._tr_stored_block(_, 0, 0, !1), s === Z_FULL_FLUSH && (zero(_.head), _.lookahead === 0 && (_.strstart = 0, _.block_start = 0, _.insert = 0))), flush_pending(a), a.avail_out === 0))
      return _.last_flush = -1, Z_OK$2;
  }
  return s !== Z_FINISH$2 ? Z_OK$2 : _.wrap <= 0 ? Z_STREAM_END$2 : (_.wrap === 2 ? (put_byte(_, a.adler & 255), put_byte(_, a.adler >> 8 & 255), put_byte(_, a.adler >> 16 & 255), put_byte(_, a.adler >> 24 & 255), put_byte(_, a.total_in & 255), put_byte(_, a.total_in >> 8 & 255), put_byte(_, a.total_in >> 16 & 255), put_byte(_, a.total_in >> 24 & 255)) : (putShortMSB(_, a.adler >>> 16), putShortMSB(_, a.adler & 65535)), flush_pending(a), _.wrap > 0 && (_.wrap = -_.wrap), _.pending !== 0 ? Z_OK$2 : Z_STREAM_END$2);
}
function deflateEnd(a) {
  var s;
  return !a || !a.state ? Z_STREAM_ERROR$1 : (s = a.state.status, s !== INIT_STATE && s !== EXTRA_STATE && s !== NAME_STATE && s !== COMMENT_STATE && s !== HCRC_STATE && s !== BUSY_STATE && s !== FINISH_STATE ? err(a, Z_STREAM_ERROR$1) : (a.state = null, s === BUSY_STATE ? err(a, Z_DATA_ERROR$1) : Z_OK$2));
}
function deflateSetDictionary(a, s) {
  var $ = s.length, _, _e, tt, nt, at, ot, rt, st;
  if (!a || !a.state || (_ = a.state, nt = _.wrap, nt === 2 || nt === 1 && _.status !== INIT_STATE || _.lookahead))
    return Z_STREAM_ERROR$1;
  for (nt === 1 && (a.adler = adler32$1(a.adler, s, $, 0)), _.wrap = 0, $ >= _.w_size && (nt === 0 && (zero(_.head), _.strstart = 0, _.block_start = 0, _.insert = 0), st = new utils$7.Buf8(_.w_size), utils$7.arraySet(st, s, $ - _.w_size, _.w_size, 0), s = st, $ = _.w_size), at = a.avail_in, ot = a.next_in, rt = a.input, a.avail_in = $, a.next_in = 0, a.input = s, fill_window(_); _.lookahead >= MIN_MATCH; ) {
    _e = _.strstart, tt = _.lookahead - (MIN_MATCH - 1);
    do
      _.ins_h = (_.ins_h << _.hash_shift ^ _.window[_e + MIN_MATCH - 1]) & _.hash_mask, _.prev[_e & _.w_mask] = _.head[_.ins_h], _.head[_.ins_h] = _e, _e++;
    while (--tt);
    _.strstart = _e, _.lookahead = MIN_MATCH - 1, fill_window(_);
  }
  return _.strstart += _.lookahead, _.block_start = _.strstart, _.insert = _.lookahead, _.lookahead = 0, _.match_length = _.prev_length = MIN_MATCH - 1, _.match_available = 0, a.next_in = ot, a.input = rt, a.avail_in = at, _.wrap = nt, Z_OK$2;
}
deflate$3.deflateInit = deflateInit;
deflate$3.deflateInit2 = deflateInit2;
deflate$3.deflateReset = deflateReset;
deflate$3.deflateResetKeep = deflateResetKeep;
deflate$3.deflateSetHeader = deflateSetHeader;
deflate$3.deflate = deflate$2;
deflate$3.deflateEnd = deflateEnd;
deflate$3.deflateSetDictionary = deflateSetDictionary;
deflate$3.deflateInfo = "pako deflate (from Nodeca project)";
var strings$2 = {}, utils$6 = common, STR_APPLY_OK = !0, STR_APPLY_UIA_OK = !0;
try {
  String.fromCharCode.apply(null, [0]);
} catch (a) {
  STR_APPLY_OK = !1;
}
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch (a) {
  STR_APPLY_UIA_OK = !1;
}
var _utf8len = new utils$6.Buf8(256);
for (var q$3 = 0; q$3 < 256; q$3++)
  _utf8len[q$3] = q$3 >= 252 ? 6 : q$3 >= 248 ? 5 : q$3 >= 240 ? 4 : q$3 >= 224 ? 3 : q$3 >= 192 ? 2 : 1;
_utf8len[254] = _utf8len[254] = 1;
strings$2.string2buf = function(a) {
  var s, $, _, _e, tt, nt = a.length, at = 0;
  for (_e = 0; _e < nt; _e++)
    $ = a.charCodeAt(_e), ($ & 64512) === 55296 && _e + 1 < nt && (_ = a.charCodeAt(_e + 1), (_ & 64512) === 56320 && ($ = 65536 + ($ - 55296 << 10) + (_ - 56320), _e++)), at += $ < 128 ? 1 : $ < 2048 ? 2 : $ < 65536 ? 3 : 4;
  for (s = new utils$6.Buf8(at), tt = 0, _e = 0; tt < at; _e++)
    $ = a.charCodeAt(_e), ($ & 64512) === 55296 && _e + 1 < nt && (_ = a.charCodeAt(_e + 1), (_ & 64512) === 56320 && ($ = 65536 + ($ - 55296 << 10) + (_ - 56320), _e++)), $ < 128 ? s[tt++] = $ : $ < 2048 ? (s[tt++] = 192 | $ >>> 6, s[tt++] = 128 | $ & 63) : $ < 65536 ? (s[tt++] = 224 | $ >>> 12, s[tt++] = 128 | $ >>> 6 & 63, s[tt++] = 128 | $ & 63) : (s[tt++] = 240 | $ >>> 18, s[tt++] = 128 | $ >>> 12 & 63, s[tt++] = 128 | $ >>> 6 & 63, s[tt++] = 128 | $ & 63);
  return s;
};
function buf2binstring(a, s) {
  if (s < 65534 && (a.subarray && STR_APPLY_UIA_OK || !a.subarray && STR_APPLY_OK))
    return String.fromCharCode.apply(null, utils$6.shrinkBuf(a, s));
  for (var $ = "", _ = 0; _ < s; _++)
    $ += String.fromCharCode(a[_]);
  return $;
}
strings$2.buf2binstring = function(a) {
  return buf2binstring(a, a.length);
};
strings$2.binstring2buf = function(a) {
  for (var s = new utils$6.Buf8(a.length), $ = 0, _ = s.length; $ < _; $++)
    s[$] = a.charCodeAt($);
  return s;
};
strings$2.buf2string = function(a, s) {
  var $, _, _e, tt, nt = s || a.length, at = new Array(nt * 2);
  for (_ = 0, $ = 0; $ < nt; ) {
    if (_e = a[$++], _e < 128) {
      at[_++] = _e;
      continue;
    }
    if (tt = _utf8len[_e], tt > 4) {
      at[_++] = 65533, $ += tt - 1;
      continue;
    }
    for (_e &= tt === 2 ? 31 : tt === 3 ? 15 : 7; tt > 1 && $ < nt; )
      _e = _e << 6 | a[$++] & 63, tt--;
    if (tt > 1) {
      at[_++] = 65533;
      continue;
    }
    _e < 65536 ? at[_++] = _e : (_e -= 65536, at[_++] = 55296 | _e >> 10 & 1023, at[_++] = 56320 | _e & 1023);
  }
  return buf2binstring(at, _);
};
strings$2.utf8border = function(a, s) {
  var $;
  for (s = s || a.length, s > a.length && (s = a.length), $ = s - 1; $ >= 0 && (a[$] & 192) === 128; )
    $--;
  return $ < 0 || $ === 0 ? s : $ + _utf8len[a[$]] > s ? $ : s;
};
function ZStream$2() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var zstream = ZStream$2, zlib_deflate = deflate$3, utils$5 = common, strings$1 = strings$2, msg$1 = messages$1, ZStream$1 = zstream, toString$4 = Object.prototype.toString, Z_NO_FLUSH = 0, Z_FINISH$1 = 4, Z_OK$1 = 0, Z_STREAM_END$1 = 1, Z_SYNC_FLUSH = 2, Z_DEFAULT_COMPRESSION = -1, Z_DEFAULT_STRATEGY = 0, Z_DEFLATED$1 = 8;
function Deflate(a) {
  if (!(this instanceof Deflate))
    return new Deflate(a);
  this.options = utils$5.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ""
  }, a || {});
  var s = this.options;
  s.raw && s.windowBits > 0 ? s.windowBits = -s.windowBits : s.gzip && s.windowBits > 0 && s.windowBits < 16 && (s.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new ZStream$1(), this.strm.avail_out = 0;
  var $ = zlib_deflate.deflateInit2(
    this.strm,
    s.level,
    s.method,
    s.windowBits,
    s.memLevel,
    s.strategy
  );
  if ($ !== Z_OK$1)
    throw new Error(msg$1[$]);
  if (s.header && zlib_deflate.deflateSetHeader(this.strm, s.header), s.dictionary) {
    var _;
    if (typeof s.dictionary == "string" ? _ = strings$1.string2buf(s.dictionary) : toString$4.call(s.dictionary) === "[object ArrayBuffer]" ? _ = new Uint8Array(s.dictionary) : _ = s.dictionary, $ = zlib_deflate.deflateSetDictionary(this.strm, _), $ !== Z_OK$1)
      throw new Error(msg$1[$]);
    this._dict_set = !0;
  }
}
Deflate.prototype.push = function(a, s) {
  var $ = this.strm, _ = this.options.chunkSize, _e, tt;
  if (this.ended)
    return !1;
  tt = s === ~~s ? s : s === !0 ? Z_FINISH$1 : Z_NO_FLUSH, typeof a == "string" ? $.input = strings$1.string2buf(a) : toString$4.call(a) === "[object ArrayBuffer]" ? $.input = new Uint8Array(a) : $.input = a, $.next_in = 0, $.avail_in = $.input.length;
  do {
    if ($.avail_out === 0 && ($.output = new utils$5.Buf8(_), $.next_out = 0, $.avail_out = _), _e = zlib_deflate.deflate($, tt), _e !== Z_STREAM_END$1 && _e !== Z_OK$1)
      return this.onEnd(_e), this.ended = !0, !1;
    ($.avail_out === 0 || $.avail_in === 0 && (tt === Z_FINISH$1 || tt === Z_SYNC_FLUSH)) && (this.options.to === "string" ? this.onData(strings$1.buf2binstring(utils$5.shrinkBuf($.output, $.next_out))) : this.onData(utils$5.shrinkBuf($.output, $.next_out)));
  } while (($.avail_in > 0 || $.avail_out === 0) && _e !== Z_STREAM_END$1);
  return tt === Z_FINISH$1 ? (_e = zlib_deflate.deflateEnd(this.strm), this.onEnd(_e), this.ended = !0, _e === Z_OK$1) : (tt === Z_SYNC_FLUSH && (this.onEnd(Z_OK$1), $.avail_out = 0), !0);
};
Deflate.prototype.onData = function(a) {
  this.chunks.push(a);
};
Deflate.prototype.onEnd = function(a) {
  a === Z_OK$1 && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = utils$5.flattenChunks(this.chunks)), this.chunks = [], this.err = a, this.msg = this.strm.msg;
};
function deflate$1(a, s) {
  var $ = new Deflate(s);
  if ($.push(a, !0), $.err)
    throw $.msg || msg$1[$.err];
  return $.result;
}
function deflateRaw(a, s) {
  return s = s || {}, s.raw = !0, deflate$1(a, s);
}
function gzip(a, s) {
  return s = s || {}, s.gzip = !0, deflate$1(a, s);
}
deflate$4.Deflate = Deflate;
deflate$4.deflate = deflate$1;
deflate$4.deflateRaw = deflateRaw;
deflate$4.gzip = gzip;
var inflate$4 = {}, inflate$3 = {}, BAD$1 = 30, TYPE$1 = 12, inffast = function a(s, $) {
  var _, _e, tt, nt, at, ot, rt, st, lt, et, it, ut, ft, ht, dt, gt, pt, mt, ct, vt, At, xt, bt, Et, St;
  _ = s.state, _e = s.next_in, Et = s.input, tt = _e + (s.avail_in - 5), nt = s.next_out, St = s.output, at = nt - ($ - s.avail_out), ot = nt + (s.avail_out - 257), rt = _.dmax, st = _.wsize, lt = _.whave, et = _.wnext, it = _.window, ut = _.hold, ft = _.bits, ht = _.lencode, dt = _.distcode, gt = (1 << _.lenbits) - 1, pt = (1 << _.distbits) - 1;
  e:
    do {
      ft < 15 && (ut += Et[_e++] << ft, ft += 8, ut += Et[_e++] << ft, ft += 8), mt = ht[ut & gt];
      t:
        for (; ; ) {
          if (ct = mt >>> 24, ut >>>= ct, ft -= ct, ct = mt >>> 16 & 255, ct === 0)
            St[nt++] = mt & 65535;
          else if (ct & 16) {
            vt = mt & 65535, ct &= 15, ct && (ft < ct && (ut += Et[_e++] << ft, ft += 8), vt += ut & (1 << ct) - 1, ut >>>= ct, ft -= ct), ft < 15 && (ut += Et[_e++] << ft, ft += 8, ut += Et[_e++] << ft, ft += 8), mt = dt[ut & pt];
            r:
              for (; ; ) {
                if (ct = mt >>> 24, ut >>>= ct, ft -= ct, ct = mt >>> 16 & 255, ct & 16) {
                  if (At = mt & 65535, ct &= 15, ft < ct && (ut += Et[_e++] << ft, ft += 8, ft < ct && (ut += Et[_e++] << ft, ft += 8)), At += ut & (1 << ct) - 1, At > rt) {
                    s.msg = "invalid distance too far back", _.mode = BAD$1;
                    break e;
                  }
                  if (ut >>>= ct, ft -= ct, ct = nt - at, At > ct) {
                    if (ct = At - ct, ct > lt && _.sane) {
                      s.msg = "invalid distance too far back", _.mode = BAD$1;
                      break e;
                    }
                    if (xt = 0, bt = it, et === 0) {
                      if (xt += st - ct, ct < vt) {
                        vt -= ct;
                        do
                          St[nt++] = it[xt++];
                        while (--ct);
                        xt = nt - At, bt = St;
                      }
                    } else if (et < ct) {
                      if (xt += st + et - ct, ct -= et, ct < vt) {
                        vt -= ct;
                        do
                          St[nt++] = it[xt++];
                        while (--ct);
                        if (xt = 0, et < vt) {
                          ct = et, vt -= ct;
                          do
                            St[nt++] = it[xt++];
                          while (--ct);
                          xt = nt - At, bt = St;
                        }
                      }
                    } else if (xt += et - ct, ct < vt) {
                      vt -= ct;
                      do
                        St[nt++] = it[xt++];
                      while (--ct);
                      xt = nt - At, bt = St;
                    }
                    for (; vt > 2; )
                      St[nt++] = bt[xt++], St[nt++] = bt[xt++], St[nt++] = bt[xt++], vt -= 3;
                    vt && (St[nt++] = bt[xt++], vt > 1 && (St[nt++] = bt[xt++]));
                  } else {
                    xt = nt - At;
                    do
                      St[nt++] = St[xt++], St[nt++] = St[xt++], St[nt++] = St[xt++], vt -= 3;
                    while (vt > 2);
                    vt && (St[nt++] = St[xt++], vt > 1 && (St[nt++] = St[xt++]));
                  }
                } else if (ct & 64) {
                  s.msg = "invalid distance code", _.mode = BAD$1;
                  break e;
                } else {
                  mt = dt[(mt & 65535) + (ut & (1 << ct) - 1)];
                  continue r;
                }
                break;
              }
          } else if (ct & 64)
            if (ct & 32) {
              _.mode = TYPE$1;
              break e;
            } else {
              s.msg = "invalid literal/length code", _.mode = BAD$1;
              break e;
            }
          else {
            mt = ht[(mt & 65535) + (ut & (1 << ct) - 1)];
            continue t;
          }
          break;
        }
    } while (_e < tt && nt < ot);
  vt = ft >> 3, _e -= vt, ft -= vt << 3, ut &= (1 << ft) - 1, s.next_in = _e, s.next_out = nt, s.avail_in = _e < tt ? 5 + (tt - _e) : 5 - (_e - tt), s.avail_out = nt < ot ? 257 + (ot - nt) : 257 - (nt - ot), _.hold = ut, _.bits = ft;
}, utils$4 = common, MAXBITS = 15, ENOUGH_LENS$1 = 852, ENOUGH_DISTS$1 = 592, CODES$1 = 0, LENS$1 = 1, DISTS$1 = 2, lbase = [
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
], lext = [
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
], dbase = [
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
], dext = [
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
], inftrees = function a(s, $, _, _e, tt, nt, at, ot) {
  var rt = ot.bits, st = 0, lt = 0, et = 0, it = 0, ut = 0, ft = 0, ht = 0, dt = 0, gt = 0, pt = 0, mt, ct, vt, At, xt, bt = null, Et = 0, St, Bt = new utils$4.Buf16(MAXBITS + 1), Ot = new utils$4.Buf16(MAXBITS + 1), Pt = null, wt = 0, Ct, It, yt;
  for (st = 0; st <= MAXBITS; st++)
    Bt[st] = 0;
  for (lt = 0; lt < _e; lt++)
    Bt[$[_ + lt]]++;
  for (ut = rt, it = MAXBITS; it >= 1 && Bt[it] === 0; it--)
    ;
  if (ut > it && (ut = it), it === 0)
    return tt[nt++] = 1 << 24 | 64 << 16 | 0, tt[nt++] = 1 << 24 | 64 << 16 | 0, ot.bits = 1, 0;
  for (et = 1; et < it && Bt[et] === 0; et++)
    ;
  for (ut < et && (ut = et), dt = 1, st = 1; st <= MAXBITS; st++)
    if (dt <<= 1, dt -= Bt[st], dt < 0)
      return -1;
  if (dt > 0 && (s === CODES$1 || it !== 1))
    return -1;
  for (Ot[1] = 0, st = 1; st < MAXBITS; st++)
    Ot[st + 1] = Ot[st] + Bt[st];
  for (lt = 0; lt < _e; lt++)
    $[_ + lt] !== 0 && (at[Ot[$[_ + lt]]++] = lt);
  if (s === CODES$1 ? (bt = Pt = at, St = 19) : s === LENS$1 ? (bt = lbase, Et -= 257, Pt = lext, wt -= 257, St = 256) : (bt = dbase, Pt = dext, St = -1), pt = 0, lt = 0, st = et, xt = nt, ft = ut, ht = 0, vt = -1, gt = 1 << ut, At = gt - 1, s === LENS$1 && gt > ENOUGH_LENS$1 || s === DISTS$1 && gt > ENOUGH_DISTS$1)
    return 1;
  for (; ; ) {
    Ct = st - ht, at[lt] < St ? (It = 0, yt = at[lt]) : at[lt] > St ? (It = Pt[wt + at[lt]], yt = bt[Et + at[lt]]) : (It = 96, yt = 0), mt = 1 << st - ht, ct = 1 << ft, et = ct;
    do
      ct -= mt, tt[xt + (pt >> ht) + ct] = Ct << 24 | It << 16 | yt | 0;
    while (ct !== 0);
    for (mt = 1 << st - 1; pt & mt; )
      mt >>= 1;
    if (mt !== 0 ? (pt &= mt - 1, pt += mt) : pt = 0, lt++, --Bt[st] === 0) {
      if (st === it)
        break;
      st = $[_ + at[lt]];
    }
    if (st > ut && (pt & At) !== vt) {
      for (ht === 0 && (ht = ut), xt += et, ft = st - ht, dt = 1 << ft; ft + ht < it && (dt -= Bt[ft + ht], !(dt <= 0)); )
        ft++, dt <<= 1;
      if (gt += 1 << ft, s === LENS$1 && gt > ENOUGH_LENS$1 || s === DISTS$1 && gt > ENOUGH_DISTS$1)
        return 1;
      vt = pt & At, tt[vt] = ut << 24 | ft << 16 | xt - nt | 0;
    }
  }
  return pt !== 0 && (tt[xt + pt] = st - ht << 24 | 64 << 16 | 0), ot.bits = ut, 0;
}, utils$3 = common, adler32 = adler32_1, crc32 = crc32_1, inflate_fast = inffast, inflate_table = inftrees, CODES = 0, LENS = 1, DISTS = 2, Z_FINISH = 4, Z_BLOCK = 5, Z_TREES = 6, Z_OK = 0, Z_STREAM_END = 1, Z_NEED_DICT = 2, Z_STREAM_ERROR = -2, Z_DATA_ERROR = -3, Z_MEM_ERROR = -4, Z_BUF_ERROR = -5, Z_DEFLATED = 8, HEAD = 1, FLAGS = 2, TIME = 3, OS = 4, EXLEN = 5, EXTRA = 6, NAME$1 = 7, COMMENT$1 = 8, HCRC = 9, DICTID = 10, DICT = 11, TYPE = 12, TYPEDO = 13, STORED = 14, COPY_ = 15, COPY = 16, TABLE = 17, LENLENS = 18, CODELENS = 19, LEN_ = 20, LEN = 21, LENEXT = 22, DIST = 23, DISTEXT = 24, MATCH = 25, LIT = 26, CHECK = 27, LENGTH = 28, DONE = 29, BAD = 30, MEM = 31, SYNC = 32, ENOUGH_LENS = 852, ENOUGH_DISTS = 592, MAX_WBITS = 15, DEF_WBITS = MAX_WBITS;
function zswap32(a) {
  return (a >>> 24 & 255) + (a >>> 8 & 65280) + ((a & 65280) << 8) + ((a & 255) << 24);
}
function InflateState() {
  this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new utils$3.Buf16(320), this.work = new utils$3.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
function inflateResetKeep(a) {
  var s;
  return !a || !a.state ? Z_STREAM_ERROR : (s = a.state, a.total_in = a.total_out = s.total = 0, a.msg = "", s.wrap && (a.adler = s.wrap & 1), s.mode = HEAD, s.last = 0, s.havedict = 0, s.dmax = 32768, s.head = null, s.hold = 0, s.bits = 0, s.lencode = s.lendyn = new utils$3.Buf32(ENOUGH_LENS), s.distcode = s.distdyn = new utils$3.Buf32(ENOUGH_DISTS), s.sane = 1, s.back = -1, Z_OK);
}
function inflateReset(a) {
  var s;
  return !a || !a.state ? Z_STREAM_ERROR : (s = a.state, s.wsize = 0, s.whave = 0, s.wnext = 0, inflateResetKeep(a));
}
function inflateReset2(a, s) {
  var $, _;
  return !a || !a.state || (_ = a.state, s < 0 ? ($ = 0, s = -s) : ($ = (s >> 4) + 1, s < 48 && (s &= 15)), s && (s < 8 || s > 15)) ? Z_STREAM_ERROR : (_.window !== null && _.wbits !== s && (_.window = null), _.wrap = $, _.wbits = s, inflateReset(a));
}
function inflateInit2(a, s) {
  var $, _;
  return a ? (_ = new InflateState(), a.state = _, _.window = null, $ = inflateReset2(a, s), $ !== Z_OK && (a.state = null), $) : Z_STREAM_ERROR;
}
function inflateInit(a) {
  return inflateInit2(a, DEF_WBITS);
}
var virgin = !0, lenfix, distfix;
function fixedtables(a) {
  if (virgin) {
    var s;
    for (lenfix = new utils$3.Buf32(512), distfix = new utils$3.Buf32(32), s = 0; s < 144; )
      a.lens[s++] = 8;
    for (; s < 256; )
      a.lens[s++] = 9;
    for (; s < 280; )
      a.lens[s++] = 7;
    for (; s < 288; )
      a.lens[s++] = 8;
    for (inflate_table(LENS, a.lens, 0, 288, lenfix, 0, a.work, { bits: 9 }), s = 0; s < 32; )
      a.lens[s++] = 5;
    inflate_table(DISTS, a.lens, 0, 32, distfix, 0, a.work, { bits: 5 }), virgin = !1;
  }
  a.lencode = lenfix, a.lenbits = 9, a.distcode = distfix, a.distbits = 5;
}
function updatewindow(a, s, $, _) {
  var _e, tt = a.state;
  return tt.window === null && (tt.wsize = 1 << tt.wbits, tt.wnext = 0, tt.whave = 0, tt.window = new utils$3.Buf8(tt.wsize)), _ >= tt.wsize ? (utils$3.arraySet(tt.window, s, $ - tt.wsize, tt.wsize, 0), tt.wnext = 0, tt.whave = tt.wsize) : (_e = tt.wsize - tt.wnext, _e > _ && (_e = _), utils$3.arraySet(tt.window, s, $ - _, _e, tt.wnext), _ -= _e, _ ? (utils$3.arraySet(tt.window, s, $ - _, _, 0), tt.wnext = _, tt.whave = tt.wsize) : (tt.wnext += _e, tt.wnext === tt.wsize && (tt.wnext = 0), tt.whave < tt.wsize && (tt.whave += _e))), 0;
}
function inflate$2(a, s) {
  var $, _, _e, tt, nt, at, ot, rt, st, lt, et, it, ut, ft, ht = 0, dt, gt, pt, mt, ct, vt, At, xt, bt = new utils$3.Buf8(4), Et, St, Bt = (
    /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
  );
  if (!a || !a.state || !a.output || !a.input && a.avail_in !== 0)
    return Z_STREAM_ERROR;
  $ = a.state, $.mode === TYPE && ($.mode = TYPEDO), nt = a.next_out, _e = a.output, ot = a.avail_out, tt = a.next_in, _ = a.input, at = a.avail_in, rt = $.hold, st = $.bits, lt = at, et = ot, xt = Z_OK;
  e:
    for (; ; )
      switch ($.mode) {
        case HEAD:
          if ($.wrap === 0) {
            $.mode = TYPEDO;
            break;
          }
          for (; st < 16; ) {
            if (at === 0)
              break e;
            at--, rt += _[tt++] << st, st += 8;
          }
          if ($.wrap & 2 && rt === 35615) {
            $.check = 0, bt[0] = rt & 255, bt[1] = rt >>> 8 & 255, $.check = crc32($.check, bt, 2, 0), rt = 0, st = 0, $.mode = FLAGS;
            break;
          }
          if ($.flags = 0, $.head && ($.head.done = !1), !($.wrap & 1) || /* check if zlib header allowed */
          (((rt & 255) << 8) + (rt >> 8)) % 31) {
            a.msg = "incorrect header check", $.mode = BAD;
            break;
          }
          if ((rt & 15) !== Z_DEFLATED) {
            a.msg = "unknown compression method", $.mode = BAD;
            break;
          }
          if (rt >>>= 4, st -= 4, At = (rt & 15) + 8, $.wbits === 0)
            $.wbits = At;
          else if (At > $.wbits) {
            a.msg = "invalid window size", $.mode = BAD;
            break;
          }
          $.dmax = 1 << At, a.adler = $.check = 1, $.mode = rt & 512 ? DICTID : TYPE, rt = 0, st = 0;
          break;
        case FLAGS:
          for (; st < 16; ) {
            if (at === 0)
              break e;
            at--, rt += _[tt++] << st, st += 8;
          }
          if ($.flags = rt, ($.flags & 255) !== Z_DEFLATED) {
            a.msg = "unknown compression method", $.mode = BAD;
            break;
          }
          if ($.flags & 57344) {
            a.msg = "unknown header flags set", $.mode = BAD;
            break;
          }
          $.head && ($.head.text = rt >> 8 & 1), $.flags & 512 && (bt[0] = rt & 255, bt[1] = rt >>> 8 & 255, $.check = crc32($.check, bt, 2, 0)), rt = 0, st = 0, $.mode = TIME;
        case TIME:
          for (; st < 32; ) {
            if (at === 0)
              break e;
            at--, rt += _[tt++] << st, st += 8;
          }
          $.head && ($.head.time = rt), $.flags & 512 && (bt[0] = rt & 255, bt[1] = rt >>> 8 & 255, bt[2] = rt >>> 16 & 255, bt[3] = rt >>> 24 & 255, $.check = crc32($.check, bt, 4, 0)), rt = 0, st = 0, $.mode = OS;
        case OS:
          for (; st < 16; ) {
            if (at === 0)
              break e;
            at--, rt += _[tt++] << st, st += 8;
          }
          $.head && ($.head.xflags = rt & 255, $.head.os = rt >> 8), $.flags & 512 && (bt[0] = rt & 255, bt[1] = rt >>> 8 & 255, $.check = crc32($.check, bt, 2, 0)), rt = 0, st = 0, $.mode = EXLEN;
        case EXLEN:
          if ($.flags & 1024) {
            for (; st < 16; ) {
              if (at === 0)
                break e;
              at--, rt += _[tt++] << st, st += 8;
            }
            $.length = rt, $.head && ($.head.extra_len = rt), $.flags & 512 && (bt[0] = rt & 255, bt[1] = rt >>> 8 & 255, $.check = crc32($.check, bt, 2, 0)), rt = 0, st = 0;
          } else
            $.head && ($.head.extra = null);
          $.mode = EXTRA;
        case EXTRA:
          if ($.flags & 1024 && (it = $.length, it > at && (it = at), it && ($.head && (At = $.head.extra_len - $.length, $.head.extra || ($.head.extra = new Array($.head.extra_len)), utils$3.arraySet(
            $.head.extra,
            _,
            tt,
            // extra field is limited to 65536 bytes
            // - no need for additional size check
            it,
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            At
          )), $.flags & 512 && ($.check = crc32($.check, _, it, tt)), at -= it, tt += it, $.length -= it), $.length))
            break e;
          $.length = 0, $.mode = NAME$1;
        case NAME$1:
          if ($.flags & 2048) {
            if (at === 0)
              break e;
            it = 0;
            do
              At = _[tt + it++], $.head && At && $.length < 65536 && ($.head.name += String.fromCharCode(At));
            while (At && it < at);
            if ($.flags & 512 && ($.check = crc32($.check, _, it, tt)), at -= it, tt += it, At)
              break e;
          } else
            $.head && ($.head.name = null);
          $.length = 0, $.mode = COMMENT$1;
        case COMMENT$1:
          if ($.flags & 4096) {
            if (at === 0)
              break e;
            it = 0;
            do
              At = _[tt + it++], $.head && At && $.length < 65536 && ($.head.comment += String.fromCharCode(At));
            while (At && it < at);
            if ($.flags & 512 && ($.check = crc32($.check, _, it, tt)), at -= it, tt += it, At)
              break e;
          } else
            $.head && ($.head.comment = null);
          $.mode = HCRC;
        case HCRC:
          if ($.flags & 512) {
            for (; st < 16; ) {
              if (at === 0)
                break e;
              at--, rt += _[tt++] << st, st += 8;
            }
            if (rt !== ($.check & 65535)) {
              a.msg = "header crc mismatch", $.mode = BAD;
              break;
            }
            rt = 0, st = 0;
          }
          $.head && ($.head.hcrc = $.flags >> 9 & 1, $.head.done = !0), a.adler = $.check = 0, $.mode = TYPE;
          break;
        case DICTID:
          for (; st < 32; ) {
            if (at === 0)
              break e;
            at--, rt += _[tt++] << st, st += 8;
          }
          a.adler = $.check = zswap32(rt), rt = 0, st = 0, $.mode = DICT;
        case DICT:
          if ($.havedict === 0)
            return a.next_out = nt, a.avail_out = ot, a.next_in = tt, a.avail_in = at, $.hold = rt, $.bits = st, Z_NEED_DICT;
          a.adler = $.check = 1, $.mode = TYPE;
        case TYPE:
          if (s === Z_BLOCK || s === Z_TREES)
            break e;
        case TYPEDO:
          if ($.last) {
            rt >>>= st & 7, st -= st & 7, $.mode = CHECK;
            break;
          }
          for (; st < 3; ) {
            if (at === 0)
              break e;
            at--, rt += _[tt++] << st, st += 8;
          }
          switch ($.last = rt & 1, rt >>>= 1, st -= 1, rt & 3) {
            case 0:
              $.mode = STORED;
              break;
            case 1:
              if (fixedtables($), $.mode = LEN_, s === Z_TREES) {
                rt >>>= 2, st -= 2;
                break e;
              }
              break;
            case 2:
              $.mode = TABLE;
              break;
            case 3:
              a.msg = "invalid block type", $.mode = BAD;
          }
          rt >>>= 2, st -= 2;
          break;
        case STORED:
          for (rt >>>= st & 7, st -= st & 7; st < 32; ) {
            if (at === 0)
              break e;
            at--, rt += _[tt++] << st, st += 8;
          }
          if ((rt & 65535) !== (rt >>> 16 ^ 65535)) {
            a.msg = "invalid stored block lengths", $.mode = BAD;
            break;
          }
          if ($.length = rt & 65535, rt = 0, st = 0, $.mode = COPY_, s === Z_TREES)
            break e;
        case COPY_:
          $.mode = COPY;
        case COPY:
          if (it = $.length, it) {
            if (it > at && (it = at), it > ot && (it = ot), it === 0)
              break e;
            utils$3.arraySet(_e, _, tt, it, nt), at -= it, tt += it, ot -= it, nt += it, $.length -= it;
            break;
          }
          $.mode = TYPE;
          break;
        case TABLE:
          for (; st < 14; ) {
            if (at === 0)
              break e;
            at--, rt += _[tt++] << st, st += 8;
          }
          if ($.nlen = (rt & 31) + 257, rt >>>= 5, st -= 5, $.ndist = (rt & 31) + 1, rt >>>= 5, st -= 5, $.ncode = (rt & 15) + 4, rt >>>= 4, st -= 4, $.nlen > 286 || $.ndist > 30) {
            a.msg = "too many length or distance symbols", $.mode = BAD;
            break;
          }
          $.have = 0, $.mode = LENLENS;
        case LENLENS:
          for (; $.have < $.ncode; ) {
            for (; st < 3; ) {
              if (at === 0)
                break e;
              at--, rt += _[tt++] << st, st += 8;
            }
            $.lens[Bt[$.have++]] = rt & 7, rt >>>= 3, st -= 3;
          }
          for (; $.have < 19; )
            $.lens[Bt[$.have++]] = 0;
          if ($.lencode = $.lendyn, $.lenbits = 7, Et = { bits: $.lenbits }, xt = inflate_table(CODES, $.lens, 0, 19, $.lencode, 0, $.work, Et), $.lenbits = Et.bits, xt) {
            a.msg = "invalid code lengths set", $.mode = BAD;
            break;
          }
          $.have = 0, $.mode = CODELENS;
        case CODELENS:
          for (; $.have < $.nlen + $.ndist; ) {
            for (; ht = $.lencode[rt & (1 << $.lenbits) - 1], dt = ht >>> 24, gt = ht >>> 16 & 255, pt = ht & 65535, !(dt <= st); ) {
              if (at === 0)
                break e;
              at--, rt += _[tt++] << st, st += 8;
            }
            if (pt < 16)
              rt >>>= dt, st -= dt, $.lens[$.have++] = pt;
            else {
              if (pt === 16) {
                for (St = dt + 2; st < St; ) {
                  if (at === 0)
                    break e;
                  at--, rt += _[tt++] << st, st += 8;
                }
                if (rt >>>= dt, st -= dt, $.have === 0) {
                  a.msg = "invalid bit length repeat", $.mode = BAD;
                  break;
                }
                At = $.lens[$.have - 1], it = 3 + (rt & 3), rt >>>= 2, st -= 2;
              } else if (pt === 17) {
                for (St = dt + 3; st < St; ) {
                  if (at === 0)
                    break e;
                  at--, rt += _[tt++] << st, st += 8;
                }
                rt >>>= dt, st -= dt, At = 0, it = 3 + (rt & 7), rt >>>= 3, st -= 3;
              } else {
                for (St = dt + 7; st < St; ) {
                  if (at === 0)
                    break e;
                  at--, rt += _[tt++] << st, st += 8;
                }
                rt >>>= dt, st -= dt, At = 0, it = 11 + (rt & 127), rt >>>= 7, st -= 7;
              }
              if ($.have + it > $.nlen + $.ndist) {
                a.msg = "invalid bit length repeat", $.mode = BAD;
                break;
              }
              for (; it--; )
                $.lens[$.have++] = At;
            }
          }
          if ($.mode === BAD)
            break;
          if ($.lens[256] === 0) {
            a.msg = "invalid code -- missing end-of-block", $.mode = BAD;
            break;
          }
          if ($.lenbits = 9, Et = { bits: $.lenbits }, xt = inflate_table(LENS, $.lens, 0, $.nlen, $.lencode, 0, $.work, Et), $.lenbits = Et.bits, xt) {
            a.msg = "invalid literal/lengths set", $.mode = BAD;
            break;
          }
          if ($.distbits = 6, $.distcode = $.distdyn, Et = { bits: $.distbits }, xt = inflate_table(DISTS, $.lens, $.nlen, $.ndist, $.distcode, 0, $.work, Et), $.distbits = Et.bits, xt) {
            a.msg = "invalid distances set", $.mode = BAD;
            break;
          }
          if ($.mode = LEN_, s === Z_TREES)
            break e;
        case LEN_:
          $.mode = LEN;
        case LEN:
          if (at >= 6 && ot >= 258) {
            a.next_out = nt, a.avail_out = ot, a.next_in = tt, a.avail_in = at, $.hold = rt, $.bits = st, inflate_fast(a, et), nt = a.next_out, _e = a.output, ot = a.avail_out, tt = a.next_in, _ = a.input, at = a.avail_in, rt = $.hold, st = $.bits, $.mode === TYPE && ($.back = -1);
            break;
          }
          for ($.back = 0; ht = $.lencode[rt & (1 << $.lenbits) - 1], dt = ht >>> 24, gt = ht >>> 16 & 255, pt = ht & 65535, !(dt <= st); ) {
            if (at === 0)
              break e;
            at--, rt += _[tt++] << st, st += 8;
          }
          if (gt && !(gt & 240)) {
            for (mt = dt, ct = gt, vt = pt; ht = $.lencode[vt + ((rt & (1 << mt + ct) - 1) >> mt)], dt = ht >>> 24, gt = ht >>> 16 & 255, pt = ht & 65535, !(mt + dt <= st); ) {
              if (at === 0)
                break e;
              at--, rt += _[tt++] << st, st += 8;
            }
            rt >>>= mt, st -= mt, $.back += mt;
          }
          if (rt >>>= dt, st -= dt, $.back += dt, $.length = pt, gt === 0) {
            $.mode = LIT;
            break;
          }
          if (gt & 32) {
            $.back = -1, $.mode = TYPE;
            break;
          }
          if (gt & 64) {
            a.msg = "invalid literal/length code", $.mode = BAD;
            break;
          }
          $.extra = gt & 15, $.mode = LENEXT;
        case LENEXT:
          if ($.extra) {
            for (St = $.extra; st < St; ) {
              if (at === 0)
                break e;
              at--, rt += _[tt++] << st, st += 8;
            }
            $.length += rt & (1 << $.extra) - 1, rt >>>= $.extra, st -= $.extra, $.back += $.extra;
          }
          $.was = $.length, $.mode = DIST;
        case DIST:
          for (; ht = $.distcode[rt & (1 << $.distbits) - 1], dt = ht >>> 24, gt = ht >>> 16 & 255, pt = ht & 65535, !(dt <= st); ) {
            if (at === 0)
              break e;
            at--, rt += _[tt++] << st, st += 8;
          }
          if (!(gt & 240)) {
            for (mt = dt, ct = gt, vt = pt; ht = $.distcode[vt + ((rt & (1 << mt + ct) - 1) >> mt)], dt = ht >>> 24, gt = ht >>> 16 & 255, pt = ht & 65535, !(mt + dt <= st); ) {
              if (at === 0)
                break e;
              at--, rt += _[tt++] << st, st += 8;
            }
            rt >>>= mt, st -= mt, $.back += mt;
          }
          if (rt >>>= dt, st -= dt, $.back += dt, gt & 64) {
            a.msg = "invalid distance code", $.mode = BAD;
            break;
          }
          $.offset = pt, $.extra = gt & 15, $.mode = DISTEXT;
        case DISTEXT:
          if ($.extra) {
            for (St = $.extra; st < St; ) {
              if (at === 0)
                break e;
              at--, rt += _[tt++] << st, st += 8;
            }
            $.offset += rt & (1 << $.extra) - 1, rt >>>= $.extra, st -= $.extra, $.back += $.extra;
          }
          if ($.offset > $.dmax) {
            a.msg = "invalid distance too far back", $.mode = BAD;
            break;
          }
          $.mode = MATCH;
        case MATCH:
          if (ot === 0)
            break e;
          if (it = et - ot, $.offset > it) {
            if (it = $.offset - it, it > $.whave && $.sane) {
              a.msg = "invalid distance too far back", $.mode = BAD;
              break;
            }
            it > $.wnext ? (it -= $.wnext, ut = $.wsize - it) : ut = $.wnext - it, it > $.length && (it = $.length), ft = $.window;
          } else
            ft = _e, ut = nt - $.offset, it = $.length;
          it > ot && (it = ot), ot -= it, $.length -= it;
          do
            _e[nt++] = ft[ut++];
          while (--it);
          $.length === 0 && ($.mode = LEN);
          break;
        case LIT:
          if (ot === 0)
            break e;
          _e[nt++] = $.length, ot--, $.mode = LEN;
          break;
        case CHECK:
          if ($.wrap) {
            for (; st < 32; ) {
              if (at === 0)
                break e;
              at--, rt |= _[tt++] << st, st += 8;
            }
            if (et -= ot, a.total_out += et, $.total += et, et && (a.adler = $.check = /*UPDATE(state.check, put - _out, _out);*/
            $.flags ? crc32($.check, _e, et, nt - et) : adler32($.check, _e, et, nt - et)), et = ot, ($.flags ? rt : zswap32(rt)) !== $.check) {
              a.msg = "incorrect data check", $.mode = BAD;
              break;
            }
            rt = 0, st = 0;
          }
          $.mode = LENGTH;
        case LENGTH:
          if ($.wrap && $.flags) {
            for (; st < 32; ) {
              if (at === 0)
                break e;
              at--, rt += _[tt++] << st, st += 8;
            }
            if (rt !== ($.total & 4294967295)) {
              a.msg = "incorrect length check", $.mode = BAD;
              break;
            }
            rt = 0, st = 0;
          }
          $.mode = DONE;
        case DONE:
          xt = Z_STREAM_END;
          break e;
        case BAD:
          xt = Z_DATA_ERROR;
          break e;
        case MEM:
          return Z_MEM_ERROR;
        case SYNC:
        default:
          return Z_STREAM_ERROR;
      }
  return a.next_out = nt, a.avail_out = ot, a.next_in = tt, a.avail_in = at, $.hold = rt, $.bits = st, ($.wsize || et !== a.avail_out && $.mode < BAD && ($.mode < CHECK || s !== Z_FINISH)) && updatewindow(a, a.output, a.next_out, et - a.avail_out), lt -= a.avail_in, et -= a.avail_out, a.total_in += lt, a.total_out += et, $.total += et, $.wrap && et && (a.adler = $.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
  $.flags ? crc32($.check, _e, et, a.next_out - et) : adler32($.check, _e, et, a.next_out - et)), a.data_type = $.bits + ($.last ? 64 : 0) + ($.mode === TYPE ? 128 : 0) + ($.mode === LEN_ || $.mode === COPY_ ? 256 : 0), (lt === 0 && et === 0 || s === Z_FINISH) && xt === Z_OK && (xt = Z_BUF_ERROR), xt;
}
function inflateEnd(a) {
  if (!a || !a.state)
    return Z_STREAM_ERROR;
  var s = a.state;
  return s.window && (s.window = null), a.state = null, Z_OK;
}
function inflateGetHeader(a, s) {
  var $;
  return !a || !a.state || ($ = a.state, !($.wrap & 2)) ? Z_STREAM_ERROR : ($.head = s, s.done = !1, Z_OK);
}
function inflateSetDictionary(a, s) {
  var $ = s.length, _, _e, tt;
  return !a || !a.state || (_ = a.state, _.wrap !== 0 && _.mode !== DICT) ? Z_STREAM_ERROR : _.mode === DICT && (_e = 1, _e = adler32(_e, s, $, 0), _e !== _.check) ? Z_DATA_ERROR : (tt = updatewindow(a, s, $, $), tt ? (_.mode = MEM, Z_MEM_ERROR) : (_.havedict = 1, Z_OK));
}
inflate$3.inflateReset = inflateReset;
inflate$3.inflateReset2 = inflateReset2;
inflate$3.inflateResetKeep = inflateResetKeep;
inflate$3.inflateInit = inflateInit;
inflate$3.inflateInit2 = inflateInit2;
inflate$3.inflate = inflate$2;
inflate$3.inflateEnd = inflateEnd;
inflate$3.inflateGetHeader = inflateGetHeader;
inflate$3.inflateSetDictionary = inflateSetDictionary;
inflate$3.inflateInfo = "pako inflate (from Nodeca project)";
var constants$1 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
function GZheader$1() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var gzheader = GZheader$1, zlib_inflate = inflate$3, utils$2 = common, strings = strings$2, c$1 = constants$1, msg = messages$1, ZStream = zstream, GZheader = gzheader, toString$3 = Object.prototype.toString;
function Inflate(a) {
  if (!(this instanceof Inflate))
    return new Inflate(a);
  this.options = utils$2.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ""
  }, a || {});
  var s = this.options;
  s.raw && s.windowBits >= 0 && s.windowBits < 16 && (s.windowBits = -s.windowBits, s.windowBits === 0 && (s.windowBits = -15)), s.windowBits >= 0 && s.windowBits < 16 && !(a && a.windowBits) && (s.windowBits += 32), s.windowBits > 15 && s.windowBits < 48 && (s.windowBits & 15 || (s.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new ZStream(), this.strm.avail_out = 0;
  var $ = zlib_inflate.inflateInit2(
    this.strm,
    s.windowBits
  );
  if ($ !== c$1.Z_OK)
    throw new Error(msg[$]);
  if (this.header = new GZheader(), zlib_inflate.inflateGetHeader(this.strm, this.header), s.dictionary && (typeof s.dictionary == "string" ? s.dictionary = strings.string2buf(s.dictionary) : toString$3.call(s.dictionary) === "[object ArrayBuffer]" && (s.dictionary = new Uint8Array(s.dictionary)), s.raw && ($ = zlib_inflate.inflateSetDictionary(this.strm, s.dictionary), $ !== c$1.Z_OK)))
    throw new Error(msg[$]);
}
Inflate.prototype.push = function(a, s) {
  var $ = this.strm, _ = this.options.chunkSize, _e = this.options.dictionary, tt, nt, at, ot, rt, st = !1;
  if (this.ended)
    return !1;
  nt = s === ~~s ? s : s === !0 ? c$1.Z_FINISH : c$1.Z_NO_FLUSH, typeof a == "string" ? $.input = strings.binstring2buf(a) : toString$3.call(a) === "[object ArrayBuffer]" ? $.input = new Uint8Array(a) : $.input = a, $.next_in = 0, $.avail_in = $.input.length;
  do {
    if ($.avail_out === 0 && ($.output = new utils$2.Buf8(_), $.next_out = 0, $.avail_out = _), tt = zlib_inflate.inflate($, c$1.Z_NO_FLUSH), tt === c$1.Z_NEED_DICT && _e && (tt = zlib_inflate.inflateSetDictionary(this.strm, _e)), tt === c$1.Z_BUF_ERROR && st === !0 && (tt = c$1.Z_OK, st = !1), tt !== c$1.Z_STREAM_END && tt !== c$1.Z_OK)
      return this.onEnd(tt), this.ended = !0, !1;
    $.next_out && ($.avail_out === 0 || tt === c$1.Z_STREAM_END || $.avail_in === 0 && (nt === c$1.Z_FINISH || nt === c$1.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (at = strings.utf8border($.output, $.next_out), ot = $.next_out - at, rt = strings.buf2string($.output, at), $.next_out = ot, $.avail_out = _ - ot, ot && utils$2.arraySet($.output, $.output, at, ot, 0), this.onData(rt)) : this.onData(utils$2.shrinkBuf($.output, $.next_out))), $.avail_in === 0 && $.avail_out === 0 && (st = !0);
  } while (($.avail_in > 0 || $.avail_out === 0) && tt !== c$1.Z_STREAM_END);
  return tt === c$1.Z_STREAM_END && (nt = c$1.Z_FINISH), nt === c$1.Z_FINISH ? (tt = zlib_inflate.inflateEnd(this.strm), this.onEnd(tt), this.ended = !0, tt === c$1.Z_OK) : (nt === c$1.Z_SYNC_FLUSH && (this.onEnd(c$1.Z_OK), $.avail_out = 0), !0);
};
Inflate.prototype.onData = function(a) {
  this.chunks.push(a);
};
Inflate.prototype.onEnd = function(a) {
  a === c$1.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = utils$2.flattenChunks(this.chunks)), this.chunks = [], this.err = a, this.msg = this.strm.msg;
};
function inflate$1(a, s) {
  var $ = new Inflate(s);
  if ($.push(a, !0), $.err)
    throw $.msg || msg[$.err];
  return $.result;
}
function inflateRaw(a, s) {
  return s = s || {}, s.raw = !0, inflate$1(a, s);
}
inflate$4.Inflate = Inflate;
inflate$4.inflate = inflate$1;
inflate$4.inflateRaw = inflateRaw;
inflate$4.ungzip = inflate$1;
var assign$2 = common.assign, deflate = deflate$4, inflate = inflate$4, constants = constants$1, pako = {};
assign$2(pako, deflate, inflate, constants);
var pako_1 = pako;
const pako$1 = /* @__PURE__ */ getDefaultExportFromCjs(pako_1);
var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", lookup = new Uint8Array(256);
for (var i$1 = 0; i$1 < chars.length; i$1++)
  lookup[chars.charCodeAt(i$1)] = i$1;
var decodeFromBase64 = function(a) {
  var s = a.length * 0.75, $ = a.length, _, _e = 0, tt, nt, at, ot;
  a[a.length - 1] === "=" && (s--, a[a.length - 2] === "=" && s--);
  var rt = new Uint8Array(s);
  for (_ = 0; _ < $; _ += 4)
    tt = lookup[a.charCodeAt(_)], nt = lookup[a.charCodeAt(_ + 1)], at = lookup[a.charCodeAt(_ + 2)], ot = lookup[a.charCodeAt(_ + 3)], rt[_e++] = tt << 2 | nt >> 4, rt[_e++] = (nt & 15) << 4 | at >> 2, rt[_e++] = (at & 3) << 6 | ot & 63;
  return rt;
}, arrayToString = function(a) {
  for (var s = "", $ = 0; $ < a.length; $++)
    s += String.fromCharCode(a[$]);
  return s;
}, decompressJson = function(a) {
  return arrayToString(pako$1.inflate(decodeFromBase64(a)));
}, padStart = function(a, s, $) {
  for (var _ = "", _e = 0, tt = s - a.length; _e < tt; _e++)
    _ += $;
  return _ + a;
}, FontNames;
(function(a) {
  a.Courier = "Courier", a.CourierBold = "Courier-Bold", a.CourierOblique = "Courier-Oblique", a.CourierBoldOblique = "Courier-BoldOblique", a.Helvetica = "Helvetica", a.HelveticaBold = "Helvetica-Bold", a.HelveticaOblique = "Helvetica-Oblique", a.HelveticaBoldOblique = "Helvetica-BoldOblique", a.TimesRoman = "Times-Roman", a.TimesRomanBold = "Times-Bold", a.TimesRomanItalic = "Times-Italic", a.TimesRomanBoldItalic = "Times-BoldItalic", a.Symbol = "Symbol", a.ZapfDingbats = "ZapfDingbats";
})(FontNames || (FontNames = {}));
const AllEncodingsCompressed = "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";
var decompressedEncodings = decompressJson(AllEncodingsCompressed), allUnicodeMappings = JSON.parse(decompressedEncodings), Encoding = (
  /** @class */
  /* @__PURE__ */ function() {
    function a(s, $) {
      var _ = this;
      this.canEncodeUnicodeCodePoint = function(_e) {
        return _e in _.unicodeMappings;
      }, this.encodeUnicodeCodePoint = function(_e) {
        var tt = _.unicodeMappings[_e];
        if (!tt) {
          var nt = String.fromCharCode(_e), at = "0x" + padStart(_e.toString(16), 4, "0"), ot = _.name + ' cannot encode "' + nt + '" (' + at + ")";
          throw new Error(ot);
        }
        return { code: tt[0], name: tt[1] };
      }, this.name = s, this.supportedCodePoints = Object.keys($).map(Number).sort(function(_e, tt) {
        return _e - tt;
      }), this.unicodeMappings = $;
    }
    return a;
  }()
);
new Encoding("Symbol", allUnicodeMappings.symbol), new Encoding("ZapfDingbats", allUnicodeMappings.zapfdingbats), new Encoding("WinAnsi", allUnicodeMappings.win1252);
const values = (a) => Object.keys(a).map((s) => a[s]);
values(FontNames);
const backtick = (a) => `\`${a}\``, singleQuote = (a) => `'${a}'`, formatValue$1 = (a) => {
  const s = typeof a;
  return s === "string" ? singleQuote(a) : s === "undefined" ? backtick(a) : a;
}, createValueErrorMsg = (a, s, $) => {
  const _ = new Array($.length);
  for (let tt = 0, nt = $.length; tt < nt; tt++) {
    const at = $[tt];
    _[tt] = formatValue$1(at);
  }
  const _e = _.join(" or ");
  return `${backtick(s)} must be one of ${_e}, but was actually ${formatValue$1(a)}`;
}, assertIsOneOf = (a, s, $) => {
  Array.isArray($) || ($ = values($));
  for (let _ = 0, _e = $.length; _ < _e; _++)
    if (a === $[_])
      return;
  throw new TypeError(createValueErrorMsg(a, s, $));
}, getType = (a) => a === null ? "null" : a === void 0 ? "undefined" : typeof a == "string" ? "string" : isNaN(a) ? "NaN" : typeof a == "number" ? "number" : typeof a == "boolean" ? "boolean" : typeof a == "symbol" ? "symbol" : typeof a == "bigint" ? "bigint" : a.constructor && a.constructor.name ? a.constructor.name : a.name ? a.name : a.constructor ? String(a.constructor) : String(a), isType = (a, s) => s === "null" ? a === null : s === "undefined" ? a === void 0 : s === "string" ? typeof a == "string" : s === "number" ? typeof a == "number" && !isNaN(a) : s === "boolean" ? typeof a == "boolean" : s === "symbol" ? typeof a == "symbol" : s === "bigint" ? typeof a == "bigint" : s === Date ? a instanceof Date : s === Array ? a instanceof Array : s === Uint8Array ? a instanceof Uint8Array : s === ArrayBuffer ? a instanceof ArrayBuffer : s === Function ? a instanceof Function : a instanceof s[0], createTypeErrorMsg = (a, s, $) => {
  const _ = new Array($.length);
  for (let tt = 0, nt = $.length; tt < nt; tt++) {
    const at = $[tt];
    at === "null" && (_[tt] = backtick("null")), at === "undefined" && (_[tt] = backtick("undefined")), at === "string" ? _[tt] = backtick("string") : at === "number" ? _[tt] = backtick("number") : at === "boolean" ? _[tt] = backtick("boolean") : at === "symbol" ? _[tt] = backtick("symbol") : at === "bigint" ? _[tt] = backtick("bigint") : at === Array ? _[tt] = backtick("Array") : at === Uint8Array ? _[tt] = backtick("Uint8Array") : at === ArrayBuffer ? _[tt] = backtick("ArrayBuffer") : _[tt] = backtick(at[1]);
  }
  const _e = _.join(" or ");
  return `${backtick(s)} must be of type ${_e}, but was actually of type ${backtick(getType(a))}`;
}, assertIs = (a, s, $) => {
  for (let _ = 0, _e = $.length; _ < _e; _++)
    if (isType(a, $[_]))
      return;
  throw new TypeError(createTypeErrorMsg(a, s, $));
}, assertEachIs = (a, s, $) => {
  for (let _ = 0, _e = a.length; _ < _e; _++)
    assertIs(a[_], s, $);
}, assertRange = (a, s, $, _) => {
  if (assertIs(a, s, ["number"]), assertIs($, "min", ["number"]), assertIs(_, "max", ["number"]), _ = Math.max($, _), a < $ || a > _)
    throw new Error(`${backtick(s)} must be at least ${$} and at most ${_}, but was actually ${a}`);
}, assertInteger = (a, s) => {
  if (!Number.isInteger(a))
    throw new Error(`${backtick(s)} must be an integer, but was actually ${a}`);
}, pdfDocEncodingToUnicode = new Uint16Array(256);
for (let a = 0; a < 256; a++)
  pdfDocEncodingToUnicode[a] = a;
pdfDocEncodingToUnicode[22] = toCharCode("");
pdfDocEncodingToUnicode[24] = toCharCode("˘");
pdfDocEncodingToUnicode[25] = toCharCode("ˇ");
pdfDocEncodingToUnicode[26] = toCharCode("ˆ");
pdfDocEncodingToUnicode[27] = toCharCode("˙");
pdfDocEncodingToUnicode[28] = toCharCode("˝");
pdfDocEncodingToUnicode[29] = toCharCode("˛");
pdfDocEncodingToUnicode[30] = toCharCode("˚");
pdfDocEncodingToUnicode[31] = toCharCode("˜");
pdfDocEncodingToUnicode[127] = toCharCode("�");
pdfDocEncodingToUnicode[128] = toCharCode("•");
pdfDocEncodingToUnicode[129] = toCharCode("†");
pdfDocEncodingToUnicode[130] = toCharCode("‡");
pdfDocEncodingToUnicode[131] = toCharCode("…");
pdfDocEncodingToUnicode[132] = toCharCode("—");
pdfDocEncodingToUnicode[133] = toCharCode("–");
pdfDocEncodingToUnicode[134] = toCharCode("ƒ");
pdfDocEncodingToUnicode[135] = toCharCode("⁄");
pdfDocEncodingToUnicode[136] = toCharCode("‹");
pdfDocEncodingToUnicode[137] = toCharCode("›");
pdfDocEncodingToUnicode[138] = toCharCode("−");
pdfDocEncodingToUnicode[139] = toCharCode("‰");
pdfDocEncodingToUnicode[140] = toCharCode("„");
pdfDocEncodingToUnicode[141] = toCharCode("“");
pdfDocEncodingToUnicode[142] = toCharCode("”");
pdfDocEncodingToUnicode[143] = toCharCode("‘");
pdfDocEncodingToUnicode[144] = toCharCode("’");
pdfDocEncodingToUnicode[145] = toCharCode("‚");
pdfDocEncodingToUnicode[146] = toCharCode("™");
pdfDocEncodingToUnicode[147] = toCharCode("ﬁ");
pdfDocEncodingToUnicode[148] = toCharCode("ﬂ");
pdfDocEncodingToUnicode[149] = toCharCode("Ł");
pdfDocEncodingToUnicode[150] = toCharCode("Œ");
pdfDocEncodingToUnicode[151] = toCharCode("Š");
pdfDocEncodingToUnicode[152] = toCharCode("Ÿ");
pdfDocEncodingToUnicode[153] = toCharCode("Ž");
pdfDocEncodingToUnicode[154] = toCharCode("ı");
pdfDocEncodingToUnicode[155] = toCharCode("ł");
pdfDocEncodingToUnicode[156] = toCharCode("œ");
pdfDocEncodingToUnicode[157] = toCharCode("š");
pdfDocEncodingToUnicode[158] = toCharCode("ž");
pdfDocEncodingToUnicode[159] = toCharCode("�");
pdfDocEncodingToUnicode[160] = toCharCode("€");
pdfDocEncodingToUnicode[173] = toCharCode("�");
const pdfDocEncodingDecode = (a) => {
  const s = new Array(a.length);
  for (let $ = 0, _ = a.length; $ < _; $++)
    s[$] = pdfDocEncodingToUnicode[a[$]];
  return String.fromCodePoint(...s);
};
class Cache {
  constructor(s) {
    this.populate = s, this.value = void 0;
  }
  getValue() {
    return this.value;
  }
  access() {
    return this.value || (this.value = this.populate()), this.value;
  }
  invalidate() {
    this.value = void 0;
  }
}
Cache.populatedBy = (a) => new Cache(a);
class MethodNotImplementedError extends Error {
  constructor(s, $) {
    const _ = `Method ${s}.${$}() not implemented`;
    super(_);
  }
}
class PrivateConstructorError extends Error {
  constructor(s) {
    const $ = `Cannot construct ${s} - it has a private constructor`;
    super($);
  }
}
class PDFArrayIsNotRectangleError extends Error {
  constructor(s) {
    const $ = `Attempted to convert PDFArray with ${s} elements to rectangle, but must have exactly 4 elements.`;
    super($);
  }
}
class InvalidPDFDateStringError extends Error {
  constructor(s) {
    const $ = `Attempted to convert "${s}" to a date, but it does not match the PDF date string format.`;
    super($);
  }
}
class InvalidTargetIndexError extends Error {
  constructor(s, $) {
    const _ = `Invalid targetIndex specified: targetIndex=${s} must be less than Count=${$}`;
    super(_);
  }
}
class CorruptPageTreeError extends Error {
  constructor(s, $) {
    const _ = `Failed to ${$} at targetIndex=${s} due to corrupt page tree: It is likely that one or more 'Count' entries are invalid`;
    super(_);
  }
}
class IndexOutOfBoundsError extends Error {
  constructor(s, $, _) {
    const _e = `index should be at least ${$} and at most ${_}, but was actually ${s}`;
    super(_e);
  }
}
class InvalidAcroFieldValueError extends Error {
  constructor() {
    const s = "Attempted to set invalid field value";
    super(s);
  }
}
class MultiSelectValueError extends Error {
  constructor() {
    const s = "Attempted to select multiple values for single-select field";
    super(s);
  }
}
class MissingDAEntryError extends Error {
  constructor(s) {
    const $ = `No /DA (default appearance) entry found for field: ${s}`;
    super($);
  }
}
class MissingTfOperatorError extends Error {
  constructor(s) {
    const $ = `No Tf operator found for DA of field: ${s}`;
    super($);
  }
}
var CharCodes;
(function(a) {
  a[a.Null = 0] = "Null", a[a.Backspace = 8] = "Backspace", a[a.Tab = 9] = "Tab", a[a.Newline = 10] = "Newline", a[a.FormFeed = 12] = "FormFeed", a[a.CarriageReturn = 13] = "CarriageReturn", a[a.Space = 32] = "Space", a[a.ExclamationPoint = 33] = "ExclamationPoint", a[a.Hash = 35] = "Hash", a[a.Percent = 37] = "Percent", a[a.LeftParen = 40] = "LeftParen", a[a.RightParen = 41] = "RightParen", a[a.Plus = 43] = "Plus", a[a.Minus = 45] = "Minus", a[a.Dash = 45] = "Dash", a[a.Period = 46] = "Period", a[a.ForwardSlash = 47] = "ForwardSlash", a[a.Zero = 48] = "Zero", a[a.One = 49] = "One", a[a.Two = 50] = "Two", a[a.Three = 51] = "Three", a[a.Four = 52] = "Four", a[a.Five = 53] = "Five", a[a.Six = 54] = "Six", a[a.Seven = 55] = "Seven", a[a.Eight = 56] = "Eight", a[a.Nine = 57] = "Nine", a[a.LessThan = 60] = "LessThan", a[a.GreaterThan = 62] = "GreaterThan", a[a.A = 65] = "A", a[a.D = 68] = "D", a[a.E = 69] = "E", a[a.F = 70] = "F", a[a.O = 79] = "O", a[a.P = 80] = "P", a[a.R = 82] = "R", a[a.LeftSquareBracket = 91] = "LeftSquareBracket", a[a.BackSlash = 92] = "BackSlash", a[a.RightSquareBracket = 93] = "RightSquareBracket", a[a.a = 97] = "a", a[a.b = 98] = "b", a[a.d = 100] = "d", a[a.e = 101] = "e", a[a.f = 102] = "f", a[a.i = 105] = "i", a[a.j = 106] = "j", a[a.l = 108] = "l", a[a.m = 109] = "m", a[a.n = 110] = "n", a[a.o = 111] = "o", a[a.r = 114] = "r", a[a.s = 115] = "s", a[a.t = 116] = "t", a[a.u = 117] = "u", a[a.x = 120] = "x", a[a.LeftCurly = 123] = "LeftCurly", a[a.RightCurly = 125] = "RightCurly", a[a.Tilde = 126] = "Tilde";
})(CharCodes || (CharCodes = {}));
const CharCodes$1 = CharCodes;
class PDFObject {
  clone(s) {
    throw new MethodNotImplementedError(this.constructor.name, "clone");
  }
  toString() {
    throw new MethodNotImplementedError(this.constructor.name, "toString");
  }
  sizeInBytes() {
    throw new MethodNotImplementedError(this.constructor.name, "sizeInBytes");
  }
  copyBytesInto(s, $) {
    throw new MethodNotImplementedError(this.constructor.name, "copyBytesInto");
  }
}
class PDFNumber extends PDFObject {
  constructor(s) {
    super(), this.numberValue = s, this.stringValue = numberToString(s);
  }
  asNumber() {
    return this.numberValue;
  }
  /** @deprecated in favor of [[PDFNumber.asNumber]] */
  value() {
    return this.numberValue;
  }
  clone() {
    return PDFNumber.of(this.numberValue);
  }
  toString() {
    return this.stringValue;
  }
  sizeInBytes() {
    return this.stringValue.length;
  }
  copyBytesInto(s, $) {
    return $ += copyStringIntoBuffer(this.stringValue, s, $), this.stringValue.length;
  }
}
PDFNumber.of = (a) => new PDFNumber(a);
class PDFArray extends PDFObject {
  constructor(s) {
    super(), this.array = [], this.context = s;
  }
  size() {
    return this.array.length;
  }
  push(s) {
    this.array.push(s);
  }
  insert(s, $) {
    this.array.splice(s, 0, $);
  }
  indexOf(s) {
    const $ = this.array.indexOf(s);
    return $ === -1 ? void 0 : $;
  }
  remove(s) {
    this.array.splice(s, 1);
  }
  set(s, $) {
    this.array[s] = $;
  }
  get(s) {
    return this.array[s];
  }
  lookupMaybe(s, ...$) {
    return this.context.lookupMaybe(
      this.get(s),
      ...$
    );
  }
  lookup(s, ...$) {
    return this.context.lookup(
      this.get(s),
      ...$
    );
  }
  asRectangle() {
    if (this.size() !== 4)
      throw new PDFArrayIsNotRectangleError(this.size());
    const s = this.lookup(0, PDFNumber).asNumber(), $ = this.lookup(1, PDFNumber).asNumber(), _ = this.lookup(2, PDFNumber).asNumber(), _e = this.lookup(3, PDFNumber).asNumber(), tt = s, nt = $, at = _ - s, ot = _e - $;
    return { x: tt, y: nt, width: at, height: ot };
  }
  asArray() {
    return this.array.slice();
  }
  clone(s) {
    const $ = PDFArray.withContext(s || this.context);
    for (let _ = 0, _e = this.size(); _ < _e; _++)
      $.push(this.array[_]);
    return $;
  }
  toString() {
    let s = "[ ";
    for (let $ = 0, _ = this.size(); $ < _; $++)
      s += this.get($).toString(), s += " ";
    return s += "]", s;
  }
  sizeInBytes() {
    let s = 3;
    for (let $ = 0, _ = this.size(); $ < _; $++)
      s += this.get($).sizeInBytes() + 1;
    return s;
  }
  copyBytesInto(s, $) {
    const _ = $;
    s[$++] = CharCodes$1.LeftSquareBracket, s[$++] = CharCodes$1.Space;
    for (let _e = 0, tt = this.size(); _e < tt; _e++)
      $ += this.get(_e).copyBytesInto(s, $), s[$++] = CharCodes$1.Space;
    return s[$++] = CharCodes$1.RightSquareBracket, $ - _;
  }
  scalePDFNumbers(s, $) {
    for (let _ = 0, _e = this.size(); _ < _e; _++) {
      const tt = this.lookup(_);
      if (tt instanceof PDFNumber) {
        const nt = _ % 2 === 0 ? s : $;
        this.set(_, PDFNumber.of(tt.asNumber() * nt));
      }
    }
  }
}
PDFArray.withContext = (a) => new PDFArray(a);
const ENFORCER$2 = {};
class PDFBool extends PDFObject {
  constructor(s, $) {
    if (s !== ENFORCER$2)
      throw new PrivateConstructorError("PDFBool");
    super(), this.value = $;
  }
  asBoolean() {
    return this.value;
  }
  clone() {
    return this;
  }
  toString() {
    return String(this.value);
  }
  sizeInBytes() {
    return this.value ? 4 : 5;
  }
  copyBytesInto(s, $) {
    return this.value ? (s[$++] = CharCodes$1.t, s[$++] = CharCodes$1.r, s[$++] = CharCodes$1.u, s[$++] = CharCodes$1.e, 4) : (s[$++] = CharCodes$1.f, s[$++] = CharCodes$1.a, s[$++] = CharCodes$1.l, s[$++] = CharCodes$1.s, s[$++] = CharCodes$1.e, 5);
  }
}
PDFBool.True = new PDFBool(ENFORCER$2, !0);
PDFBool.False = new PDFBool(ENFORCER$2, !1);
const IsDelimiter = new Uint8Array(256);
IsDelimiter[CharCodes$1.LeftParen] = 1;
IsDelimiter[CharCodes$1.RightParen] = 1;
IsDelimiter[CharCodes$1.LessThan] = 1;
IsDelimiter[CharCodes$1.GreaterThan] = 1;
IsDelimiter[CharCodes$1.LeftSquareBracket] = 1;
IsDelimiter[CharCodes$1.RightSquareBracket] = 1;
IsDelimiter[CharCodes$1.LeftCurly] = 1;
IsDelimiter[CharCodes$1.RightCurly] = 1;
IsDelimiter[CharCodes$1.ForwardSlash] = 1;
IsDelimiter[CharCodes$1.Percent] = 1;
const IsWhitespace = new Uint8Array(256);
IsWhitespace[CharCodes$1.Null] = 1;
IsWhitespace[CharCodes$1.Tab] = 1;
IsWhitespace[CharCodes$1.Newline] = 1;
IsWhitespace[CharCodes$1.FormFeed] = 1;
IsWhitespace[CharCodes$1.CarriageReturn] = 1;
IsWhitespace[CharCodes$1.Space] = 1;
const IsIrregular = new Uint8Array(256);
for (let a = 0, s = 256; a < s; a++)
  IsIrregular[a] = IsWhitespace[a] || IsDelimiter[a] ? 1 : 0;
IsIrregular[CharCodes$1.Hash] = 1;
const decodeName = (a) => a.replace(/#([\dABCDEF]{2})/g, (s, $) => charFromHexCode($)), isRegularChar = (a) => a >= CharCodes$1.ExclamationPoint && a <= CharCodes$1.Tilde && !IsIrregular[a], ENFORCER$1 = {}, pool$1 = /* @__PURE__ */ new Map();
class PDFName extends PDFObject {
  constructor(s, $) {
    if (s !== ENFORCER$1)
      throw new PrivateConstructorError("PDFName");
    super();
    let _ = "/";
    for (let _e = 0, tt = $.length; _e < tt; _e++) {
      const nt = $[_e], at = toCharCode(nt);
      _ += isRegularChar(at) ? nt : `#${toHexString(at)}`;
    }
    this.encodedName = _;
  }
  asBytes() {
    const s = [];
    let $ = "", _ = !1;
    const _e = (tt) => {
      tt !== void 0 && s.push(tt), _ = !1;
    };
    for (let tt = 1, nt = this.encodedName.length; tt < nt; tt++) {
      const at = this.encodedName[tt], ot = toCharCode(at), rt = this.encodedName[tt + 1];
      _ ? ot >= CharCodes$1.Zero && ot <= CharCodes$1.Nine || ot >= CharCodes$1.a && ot <= CharCodes$1.f || ot >= CharCodes$1.A && ot <= CharCodes$1.F ? ($ += at, ($.length === 2 || !(rt >= "0" && rt <= "9" || rt >= "a" && rt <= "f" || rt >= "A" && rt <= "F")) && (_e(parseInt($, 16)), $ = "")) : _e(ot) : ot === CharCodes$1.Hash ? _ = !0 : _e(ot);
    }
    return new Uint8Array(s);
  }
  // TODO: This should probably use `utf8Decode()`
  // TODO: Polyfill Array.from?
  decodeText() {
    const s = this.asBytes();
    return String.fromCharCode(...Array.from(s));
  }
  asString() {
    return this.encodedName;
  }
  /** @deprecated in favor of [[PDFName.asString]] */
  value() {
    return this.encodedName;
  }
  clone() {
    return this;
  }
  toString() {
    return this.encodedName;
  }
  sizeInBytes() {
    return this.encodedName.length;
  }
  copyBytesInto(s, $) {
    return $ += copyStringIntoBuffer(this.encodedName, s, $), this.encodedName.length;
  }
}
PDFName.of = (a) => {
  const s = decodeName(a);
  let $ = pool$1.get(s);
  return $ || ($ = new PDFName(ENFORCER$1, s), pool$1.set(s, $)), $;
};
PDFName.Length = PDFName.of("Length");
PDFName.FlateDecode = PDFName.of("FlateDecode");
PDFName.Resources = PDFName.of("Resources");
PDFName.Font = PDFName.of("Font");
PDFName.XObject = PDFName.of("XObject");
PDFName.ExtGState = PDFName.of("ExtGState");
PDFName.Contents = PDFName.of("Contents");
PDFName.Type = PDFName.of("Type");
PDFName.Parent = PDFName.of("Parent");
PDFName.MediaBox = PDFName.of("MediaBox");
PDFName.Page = PDFName.of("Page");
PDFName.Annots = PDFName.of("Annots");
PDFName.TrimBox = PDFName.of("TrimBox");
PDFName.ArtBox = PDFName.of("ArtBox");
PDFName.BleedBox = PDFName.of("BleedBox");
PDFName.CropBox = PDFName.of("CropBox");
PDFName.Rotate = PDFName.of("Rotate");
PDFName.Title = PDFName.of("Title");
PDFName.Author = PDFName.of("Author");
PDFName.Subject = PDFName.of("Subject");
PDFName.Creator = PDFName.of("Creator");
PDFName.Keywords = PDFName.of("Keywords");
PDFName.Producer = PDFName.of("Producer");
PDFName.CreationDate = PDFName.of("CreationDate");
PDFName.ModDate = PDFName.of("ModDate");
class PDFNull extends PDFObject {
  asNull() {
    return null;
  }
  clone() {
    return this;
  }
  toString() {
    return "null";
  }
  sizeInBytes() {
    return 4;
  }
  copyBytesInto(s, $) {
    return s[$++] = CharCodes$1.n, s[$++] = CharCodes$1.u, s[$++] = CharCodes$1.l, s[$++] = CharCodes$1.l, 4;
  }
}
const PDFNull$1 = new PDFNull();
class PDFDict extends PDFObject {
  constructor(s, $) {
    super(), this.suppressEncryption = !1, this.dict = s, this.context = $;
  }
  keys() {
    return Array.from(this.dict.keys());
  }
  values() {
    return Array.from(this.dict.values());
  }
  entries() {
    return Array.from(this.dict.entries());
  }
  set(s, $) {
    this.dict.set(s, $);
  }
  get(s, $ = !1) {
    const _ = this.dict.get(s);
    if (!(_ === PDFNull$1 && !$))
      return _;
  }
  has(s) {
    const $ = this.dict.get(s);
    return $ !== void 0 && $ !== PDFNull$1;
  }
  lookupMaybe(s, ...$) {
    const _ = $.includes(PDFNull$1), _e = this.context.lookupMaybe(
      this.get(s, _),
      ...$
    );
    if (!(_e === PDFNull$1 && !_))
      return _e;
  }
  lookup(s, ...$) {
    const _ = $.includes(PDFNull$1), _e = this.context.lookup(
      this.get(s, _),
      ...$
    );
    if (!(_e === PDFNull$1 && !_))
      return _e;
  }
  delete(s) {
    return this.dict.delete(s);
  }
  asMap() {
    return new Map(this.dict);
  }
  /** Generate a random key that doesn't exist in current key set */
  uniqueKey(s = "") {
    const $ = this.keys();
    let _ = PDFName.of(this.context.addRandomSuffix(s, 10));
    for (; $.includes(_); )
      _ = PDFName.of(this.context.addRandomSuffix(s, 10));
    return _;
  }
  clone(s) {
    const $ = PDFDict.withContext(s || this.context), _ = this.entries();
    for (let _e = 0, tt = _.length; _e < tt; _e++) {
      const [nt, at] = _[_e];
      $.set(nt, at);
    }
    return $;
  }
  toString() {
    let s = `<<
`;
    const $ = this.entries();
    for (let _ = 0, _e = $.length; _ < _e; _++) {
      const [tt, nt] = $[_];
      s += tt.toString() + " " + nt.toString() + `
`;
    }
    return s += ">>", s;
  }
  sizeInBytes() {
    let s = 5;
    const $ = this.entries();
    for (let _ = 0, _e = $.length; _ < _e; _++) {
      const [tt, nt] = $[_];
      s += tt.sizeInBytes() + nt.sizeInBytes() + 2;
    }
    return s;
  }
  copyBytesInto(s, $) {
    const _ = $;
    s[$++] = CharCodes$1.LessThan, s[$++] = CharCodes$1.LessThan, s[$++] = CharCodes$1.Newline;
    const _e = this.entries();
    for (let tt = 0, nt = _e.length; tt < nt; tt++) {
      const [at, ot] = _e[tt];
      $ += at.copyBytesInto(s, $), s[$++] = CharCodes$1.Space, $ += ot.copyBytesInto(s, $), s[$++] = CharCodes$1.Newline;
    }
    return s[$++] = CharCodes$1.GreaterThan, s[$++] = CharCodes$1.GreaterThan, $ - _;
  }
}
PDFDict.withContext = (a) => new PDFDict(/* @__PURE__ */ new Map(), a);
PDFDict.fromMapWithContext = (a, s) => new PDFDict(a, s);
class PDFStream extends PDFObject {
  constructor(s) {
    super(), this.dict = s;
  }
  clone(s) {
    throw new MethodNotImplementedError(this.constructor.name, "clone");
  }
  getContentsString() {
    throw new MethodNotImplementedError(this.constructor.name, "getContentsString");
  }
  getContents() {
    throw new MethodNotImplementedError(this.constructor.name, "getContents");
  }
  getContentsSize() {
    throw new MethodNotImplementedError(this.constructor.name, "getContentsSize");
  }
  updateDict() {
    const s = this.getContentsSize();
    this.dict.set(PDFName.Length, PDFNumber.of(s));
  }
  sizeInBytes() {
    return this.updateDict(), this.dict.sizeInBytes() + this.getContentsSize() + 18;
  }
  toString() {
    this.updateDict();
    let s = this.dict.toString();
    return s += `
stream
`, s += this.getContentsString(), s += `
endstream`, s;
  }
  copyBytesInto(s, $) {
    this.updateDict();
    const _ = $;
    $ += this.dict.copyBytesInto(s, $), s[$++] = CharCodes$1.Newline, s[$++] = CharCodes$1.s, s[$++] = CharCodes$1.t, s[$++] = CharCodes$1.r, s[$++] = CharCodes$1.e, s[$++] = CharCodes$1.a, s[$++] = CharCodes$1.m, s[$++] = CharCodes$1.Newline;
    const _e = this.getContents();
    for (let tt = 0, nt = _e.length; tt < nt; tt++)
      s[$++] = _e[tt];
    return s[$++] = CharCodes$1.Newline, s[$++] = CharCodes$1.e, s[$++] = CharCodes$1.n, s[$++] = CharCodes$1.d, s[$++] = CharCodes$1.s, s[$++] = CharCodes$1.t, s[$++] = CharCodes$1.r, s[$++] = CharCodes$1.e, s[$++] = CharCodes$1.a, s[$++] = CharCodes$1.m, $ - _;
  }
}
class PDFRawStream extends PDFStream {
  constructor(s, $, _) {
    super(s), this.contents = $, this.transform = _;
  }
  asUint8Array() {
    return this.contents.slice();
  }
  clone(s) {
    return PDFRawStream.of(this.dict.clone(s), this.contents.slice());
  }
  getContentsString() {
    return arrayAsString(this.contents);
  }
  getContents() {
    return this.contents;
  }
  getContentsSize() {
    return this.contents.length;
  }
}
PDFRawStream.of = (a, s, $) => new PDFRawStream(a, s, $);
const ENFORCER = {}, pool = /* @__PURE__ */ new Map();
class PDFRef extends PDFObject {
  constructor(s, $, _) {
    if (s !== ENFORCER)
      throw new PrivateConstructorError("PDFRef");
    super(), this.objectNumber = $, this.generationNumber = _, this.tag = `${$} ${_} R`;
  }
  clone() {
    return this;
  }
  toString() {
    return this.tag;
  }
  sizeInBytes() {
    return this.tag.length;
  }
  copyBytesInto(s, $) {
    return $ += copyStringIntoBuffer(this.tag, s, $), this.tag.length;
  }
}
PDFRef.of = (a, s = 0) => {
  const $ = `${a} ${s} R`;
  let _ = pool.get($);
  return _ || (_ = new PDFRef(ENFORCER, a, s), pool.set($, _)), _;
};
var PDFOperatorNames;
(function(a) {
  a.NonStrokingColor = "sc", a.NonStrokingColorN = "scn", a.NonStrokingColorRgb = "rg", a.NonStrokingColorGray = "g", a.NonStrokingColorCmyk = "k", a.NonStrokingColorspace = "cs", a.StrokingColor = "SC", a.StrokingColorN = "SCN", a.StrokingColorRgb = "RG", a.StrokingColorGray = "G", a.StrokingColorCmyk = "K", a.StrokingColorspace = "CS", a.BeginMarkedContentSequence = "BDC", a.BeginMarkedContent = "BMC", a.EndMarkedContent = "EMC", a.MarkedContentPointWithProps = "DP", a.MarkedContentPoint = "MP", a.DrawObject = "Do", a.ConcatTransformationMatrix = "cm", a.PopGraphicsState = "Q", a.PushGraphicsState = "q", a.SetFlatness = "i", a.SetGraphicsStateParams = "gs", a.SetLineCapStyle = "J", a.SetLineDashPattern = "d", a.SetLineJoinStyle = "j", a.SetLineMiterLimit = "M", a.SetLineWidth = "w", a.SetTextMatrix = "Tm", a.SetRenderingIntent = "ri", a.AppendRectangle = "re", a.BeginInlineImage = "BI", a.BeginInlineImageData = "ID", a.EndInlineImage = "EI", a.ClipEvenOdd = "W*", a.ClipNonZero = "W", a.CloseAndStroke = "s", a.CloseFillEvenOddAndStroke = "b*", a.CloseFillNonZeroAndStroke = "b", a.ClosePath = "h", a.AppendBezierCurve = "c", a.CurveToReplicateFinalPoint = "y", a.CurveToReplicateInitialPoint = "v", a.EndPath = "n", a.FillEvenOddAndStroke = "B*", a.FillEvenOdd = "f*", a.FillNonZeroAndStroke = "B", a.FillNonZero = "f", a.LegacyFillNonZero = "F", a.LineTo = "l", a.MoveTo = "m", a.ShadingFill = "sh", a.StrokePath = "S", a.BeginText = "BT", a.EndText = "ET", a.MoveText = "Td", a.MoveTextSetLeading = "TD", a.NextLine = "T*", a.SetCharacterSpacing = "Tc", a.SetFontAndSize = "Tf", a.SetTextHorizontalScaling = "Tz", a.SetTextLineHeight = "TL", a.SetTextRenderingMode = "Tr", a.SetTextRise = "Ts", a.SetWordSpacing = "Tw", a.ShowText = "Tj", a.ShowTextAdjusted = "TJ", a.ShowTextLine = "'", a.ShowTextLineAndSpace = '"', a.Type3D0 = "d0", a.Type3D1 = "d1", a.BeginCompatibilitySection = "BX", a.EndCompatibilitySection = "EX";
})(PDFOperatorNames || (PDFOperatorNames = {}));
class PDFFlateStream extends PDFStream {
  constructor(s, $) {
    super(s), this.computeContents = () => {
      const _ = this.getUnencodedContents();
      return this.encode ? pako$1.deflate(_) : _;
    }, this.encode = $, $ && s.set(PDFName.of("Filter"), PDFName.of("FlateDecode")), this.contentsCache = Cache.populatedBy(this.computeContents);
  }
  getContents() {
    return this.contentsCache.access();
  }
  getContentsSize() {
    return this.contentsCache.access().length;
  }
  getUnencodedContents() {
    throw new MethodNotImplementedError(this.constructor.name, "getUnencodedContents");
  }
}
class PDFContentStream extends PDFFlateStream {
  constructor(s, $, _ = !0) {
    super(s, _), this.operators = $;
  }
  push(...s) {
    this.operators.push(...s);
  }
  clone(s) {
    const $ = new Array(this.operators.length);
    for (let tt = 0, nt = this.operators.length; tt < nt; tt++)
      $[tt] = this.operators[tt].clone(s);
    const { dict: _, encode: _e } = this;
    return PDFContentStream.of(_.clone(s), $, _e);
  }
  getContentsString() {
    let s = "";
    for (let $ = 0, _ = this.operators.length; $ < _; $++)
      s += `${this.operators[$]}
`;
    return s;
  }
  getUnencodedContents() {
    const s = new Uint8Array(this.getUnencodedContentsSize());
    let $ = 0;
    for (let _ = 0, _e = this.operators.length; _ < _e; _++)
      $ += this.operators[_].copyBytesInto(s, $), s[$++] = CharCodes$1.Newline;
    return s;
  }
  getUnencodedContentsSize() {
    let s = 0;
    for (let $ = 0, _ = this.operators.length; $ < _; $++)
      s += this.operators[$].sizeInBytes() + 1;
    return s;
  }
}
PDFContentStream.of = (a, s, $ = !0) => new PDFContentStream(a, s, $);
class PDFPageLeaf extends PDFDict {
  constructor(s, $, _ = !0) {
    super(s, $), this.normalized = !1, this.autoNormalizeCTM = _;
  }
  clone(s) {
    const $ = PDFPageLeaf.fromMapWithContext(/* @__PURE__ */ new Map(), s || this.context, this.autoNormalizeCTM), _ = this.entries();
    for (let _e = 0, tt = _.length; _e < tt; _e++) {
      const [nt, at] = _[_e];
      $.set(nt, at);
    }
    return $;
  }
  Parent() {
    return this.lookupMaybe(PDFName.Parent, PDFDict);
  }
  Contents() {
    return this.lookup(PDFName.of("Contents"));
  }
  Annots() {
    return this.lookupMaybe(PDFName.Annots, PDFArray);
  }
  BleedBox() {
    return this.lookupMaybe(PDFName.BleedBox, PDFArray);
  }
  TrimBox() {
    return this.lookupMaybe(PDFName.TrimBox, PDFArray);
  }
  ArtBox() {
    return this.lookupMaybe(PDFName.ArtBox, PDFArray);
  }
  Resources() {
    const s = this.getInheritableAttribute(PDFName.Resources);
    return this.context.lookupMaybe(s, PDFDict);
  }
  MediaBox() {
    const s = this.getInheritableAttribute(PDFName.MediaBox);
    return this.context.lookup(s, PDFArray);
  }
  CropBox() {
    const s = this.getInheritableAttribute(PDFName.CropBox);
    return this.context.lookupMaybe(s, PDFArray);
  }
  Rotate() {
    const s = this.getInheritableAttribute(PDFName.Rotate);
    return this.context.lookupMaybe(s, PDFNumber);
  }
  getInheritableAttribute(s) {
    let $;
    return this.ascend((_) => {
      $ || ($ = _.get(s));
    }), $;
  }
  setParent(s) {
    this.set(PDFName.Parent, s);
  }
  addContentStream(s) {
    const $ = this.normalizedEntries().Contents || this.context.obj([]);
    this.set(PDFName.Contents, $), $.push(s);
  }
  wrapContentStreams(s, $) {
    const _ = this.Contents();
    return _ instanceof PDFArray ? (_.insert(0, s), _.push($), !0) : !1;
  }
  addAnnot(s) {
    const { Annots: $ } = this.normalizedEntries();
    $.push(s);
  }
  removeAnnot(s) {
    const { Annots: $ } = this.normalizedEntries(), _ = $.indexOf(s);
    _ !== void 0 && $.remove(_);
  }
  setFontDictionary(s, $) {
    const { Font: _ } = this.normalizedEntries();
    _.set(s, $);
  }
  newFontDictionaryKey(s) {
    const { Font: $ } = this.normalizedEntries();
    return $.uniqueKey(s);
  }
  newFontDictionary(s, $) {
    const _ = this.newFontDictionaryKey(s);
    return this.setFontDictionary(_, $), _;
  }
  setXObject(s, $) {
    const { XObject: _ } = this.normalizedEntries();
    _.set(s, $);
  }
  newXObjectKey(s) {
    const { XObject: $ } = this.normalizedEntries();
    return $.uniqueKey(s);
  }
  newXObject(s, $) {
    const _ = this.newXObjectKey(s);
    return this.setXObject(_, $), _;
  }
  setExtGState(s, $) {
    const { ExtGState: _ } = this.normalizedEntries();
    _.set(s, $);
  }
  newExtGStateKey(s) {
    const { ExtGState: $ } = this.normalizedEntries();
    return $.uniqueKey(s);
  }
  newExtGState(s, $) {
    const _ = this.newExtGStateKey(s);
    return this.setExtGState(_, $), _;
  }
  ascend(s) {
    s(this);
    const $ = this.Parent();
    $ && $.ascend(s);
  }
  normalize() {
    if (this.normalized)
      return;
    const { context: s } = this, $ = this.get(PDFName.Contents);
    this.context.lookup($) instanceof PDFStream && this.set(PDFName.Contents, s.obj([$])), this.autoNormalizeCTM && this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
    const _e = this.getInheritableAttribute(PDFName.Resources), tt = s.lookupMaybe(_e, PDFDict) || s.obj({});
    this.set(PDFName.Resources, tt);
    const nt = tt.lookupMaybe(PDFName.Font, PDFDict) || s.obj({});
    tt.set(PDFName.Font, nt);
    const at = tt.lookupMaybe(PDFName.XObject, PDFDict) || s.obj({});
    tt.set(PDFName.XObject, at);
    const ot = tt.lookupMaybe(PDFName.ExtGState, PDFDict) || s.obj({});
    tt.set(PDFName.ExtGState, ot);
    const rt = this.Annots() || s.obj([]);
    this.set(PDFName.Annots, rt), this.normalized = !0;
  }
  normalizedEntries() {
    this.normalize();
    const s = this.Annots(), $ = this.Resources(), _ = this.Contents();
    return {
      Annots: s,
      Resources: $,
      Contents: _,
      Font: $.lookup(PDFName.Font, PDFDict),
      XObject: $.lookup(PDFName.XObject, PDFDict),
      ExtGState: $.lookup(PDFName.ExtGState, PDFDict)
    };
  }
}
PDFPageLeaf.InheritableEntries = [
  "Resources",
  "MediaBox",
  "CropBox",
  "Rotate"
];
PDFPageLeaf.withContextAndParent = (a, s) => {
  const $ = /* @__PURE__ */ new Map();
  return $.set(PDFName.Type, PDFName.Page), $.set(PDFName.Parent, s), $.set(PDFName.Resources, a.obj({})), $.set(PDFName.MediaBox, a.obj([0, 0, 612, 792])), new PDFPageLeaf($, a, !1);
};
PDFPageLeaf.fromMapWithContext = (a, s, $ = !0) => new PDFPageLeaf(a, s, $);
class PDFObjectStream extends PDFFlateStream {
  constructor(s, $, _ = !0) {
    super(s.obj({}), _), this.objects = $, this.offsets = this.computeObjectOffsets(), this.offsetsString = this.computeOffsetsString(), this.dict.set(PDFName.of("Type"), PDFName.of("ObjStm")), this.dict.set(PDFName.of("N"), PDFNumber.of(this.objects.length)), this.dict.set(PDFName.of("First"), PDFNumber.of(this.offsetsString.length));
  }
  getObjectsCount() {
    return this.objects.length;
  }
  clone(s) {
    return PDFObjectStream.withContextAndObjects(s || this.dict.context, this.objects.slice(), this.encode);
  }
  getContentsString() {
    let s = this.offsetsString;
    for (let $ = 0, _ = this.objects.length; $ < _; $++) {
      const [, _e] = this.objects[$];
      s += `${_e}
`;
    }
    return s;
  }
  getUnencodedContents() {
    const s = new Uint8Array(this.getUnencodedContentsSize());
    let $ = copyStringIntoBuffer(this.offsetsString, s, 0);
    for (let _ = 0, _e = this.objects.length; _ < _e; _++) {
      const [, tt] = this.objects[_];
      $ += tt.copyBytesInto(s, $), s[$++] = CharCodes$1.Newline;
    }
    return s;
  }
  getUnencodedContentsSize() {
    return this.offsetsString.length + last$1(this.offsets)[1] + last$1(this.objects)[1].sizeInBytes() + 1;
  }
  computeOffsetsString() {
    let s = "";
    for (let $ = 0, _ = this.offsets.length; $ < _; $++) {
      const [_e, tt] = this.offsets[$];
      s += `${_e} ${tt} `;
    }
    return s;
  }
  computeObjectOffsets() {
    let s = 0;
    const $ = new Array(this.objects.length);
    for (let _ = 0, _e = this.objects.length; _ < _e; _++) {
      const [tt, nt] = this.objects[_];
      $[_] = [tt.objectNumber, s], s += nt.sizeInBytes() + 1;
    }
    return $;
  }
}
PDFObjectStream.withContextAndObjects = (a, s, $ = !0) => new PDFObjectStream(a, s, $);
class PDFInvalidObject extends PDFObject {
  constructor(s) {
    super(), this.data = s;
  }
  clone() {
    return PDFInvalidObject.of(this.data.slice());
  }
  toString() {
    return `PDFInvalidObject(${this.data.length} bytes)`;
  }
  sizeInBytes() {
    return this.data.length;
  }
  copyBytesInto(s, $) {
    const _ = this.data.length;
    for (let _e = 0; _e < _; _e++)
      s[$++] = this.data[_e];
    return _;
  }
}
PDFInvalidObject.of = (a) => new PDFInvalidObject(a);
var EntryType;
(function(a) {
  a[a.Deleted = 0] = "Deleted", a[a.Uncompressed = 1] = "Uncompressed", a[a.Compressed = 2] = "Compressed";
})(EntryType || (EntryType = {}));
class PDFCrossRefStream extends PDFFlateStream {
  constructor(s, $, _ = !0) {
    super(s, _), this.computeIndex = () => {
      const _e = [];
      let tt = 0;
      for (let nt = 0, at = this.entries.length; nt < at; nt++) {
        const ot = this.entries[nt], rt = this.entries[nt - 1];
        nt === 0 ? _e.push(ot.ref.objectNumber) : ot.ref.objectNumber - rt.ref.objectNumber > 1 && (_e.push(tt), _e.push(ot.ref.objectNumber), tt = 0), tt += 1;
      }
      return _e.push(tt), _e;
    }, this.computeEntryTuples = () => {
      const _e = new Array(this.entries.length);
      for (let tt = 0, nt = this.entries.length; tt < nt; tt++) {
        const at = this.entries[tt];
        if (at.type === EntryType.Deleted) {
          const { type: ot, nextFreeObjectNumber: rt, ref: st } = at;
          _e[tt] = [ot, rt, st.generationNumber];
        }
        if (at.type === EntryType.Uncompressed) {
          const { type: ot, offset: rt, ref: st } = at;
          _e[tt] = [ot, rt, st.generationNumber];
        }
        if (at.type === EntryType.Compressed) {
          const { type: ot, objectStreamRef: rt, index: st } = at;
          _e[tt] = [ot, rt.objectNumber, st];
        }
      }
      return _e;
    }, this.computeMaxEntryByteWidths = () => {
      const _e = this.entryTuplesCache.access(), tt = [0, 0, 0];
      for (let nt = 0, at = _e.length; nt < at; nt++) {
        const [ot, rt, st] = _e[nt], lt = sizeInBytes(ot), et = sizeInBytes(rt), it = sizeInBytes(st);
        lt > tt[0] && (tt[0] = lt), et > tt[1] && (tt[1] = et), it > tt[2] && (tt[2] = it);
      }
      return tt;
    }, this.entries = $ || [], this.entryTuplesCache = Cache.populatedBy(this.computeEntryTuples), this.maxByteWidthsCache = Cache.populatedBy(this.computeMaxEntryByteWidths), this.indexCache = Cache.populatedBy(this.computeIndex), s.set(PDFName.of("Type"), PDFName.of("XRef"));
  }
  addDeletedEntry(s, $) {
    const _ = EntryType.Deleted;
    this.entries.push({ type: _, ref: s, nextFreeObjectNumber: $ }), this.entryTuplesCache.invalidate(), this.maxByteWidthsCache.invalidate(), this.indexCache.invalidate(), this.contentsCache.invalidate();
  }
  addUncompressedEntry(s, $) {
    const _ = EntryType.Uncompressed;
    this.entries.push({ type: _, ref: s, offset: $ }), this.entryTuplesCache.invalidate(), this.maxByteWidthsCache.invalidate(), this.indexCache.invalidate(), this.contentsCache.invalidate();
  }
  addCompressedEntry(s, $, _) {
    const _e = EntryType.Compressed;
    this.entries.push({ type: _e, ref: s, objectStreamRef: $, index: _ }), this.entryTuplesCache.invalidate(), this.maxByteWidthsCache.invalidate(), this.indexCache.invalidate(), this.contentsCache.invalidate();
  }
  clone(s) {
    const { dict: $, entries: _, encode: _e } = this;
    return PDFCrossRefStream.of($.clone(s), _.slice(), _e);
  }
  getContentsString() {
    const s = this.entryTuplesCache.access(), $ = this.maxByteWidthsCache.access();
    let _ = "";
    for (let _e = 0, tt = s.length; _e < tt; _e++) {
      const [nt, at, ot] = s[_e], rt = reverseArray(bytesFor(nt)), st = reverseArray(bytesFor(at)), lt = reverseArray(bytesFor(ot));
      for (let et = $[0] - 1; et >= 0; et--)
        _ += (rt[et] || 0).toString(2);
      for (let et = $[1] - 1; et >= 0; et--)
        _ += (st[et] || 0).toString(2);
      for (let et = $[2] - 1; et >= 0; et--)
        _ += (lt[et] || 0).toString(2);
    }
    return _;
  }
  getUnencodedContents() {
    const s = this.entryTuplesCache.access(), $ = this.maxByteWidthsCache.access(), _ = new Uint8Array(this.getUnencodedContentsSize());
    let _e = 0;
    for (let tt = 0, nt = s.length; tt < nt; tt++) {
      const [at, ot, rt] = s[tt], st = reverseArray(bytesFor(at)), lt = reverseArray(bytesFor(ot)), et = reverseArray(bytesFor(rt));
      for (let it = $[0] - 1; it >= 0; it--)
        _[_e++] = st[it] || 0;
      for (let it = $[1] - 1; it >= 0; it--)
        _[_e++] = lt[it] || 0;
      for (let it = $[2] - 1; it >= 0; it--)
        _[_e++] = et[it] || 0;
    }
    return _;
  }
  getUnencodedContentsSize() {
    const s = this.maxByteWidthsCache.access();
    return sum$1(s) * this.entries.length;
  }
  updateDict() {
    super.updateDict();
    const s = this.maxByteWidthsCache.access(), $ = this.indexCache.access(), { context: _ } = this.dict;
    this.dict.set(PDFName.of("W"), _.obj(s)), this.dict.set(PDFName.of("Index"), _.obj($));
  }
}
PDFCrossRefStream.create = (a, s = !0) => {
  const $ = new PDFCrossRefStream(a, [], s);
  return $.addDeletedEntry(PDFRef.of(0, 65535), 0), $;
};
PDFCrossRefStream.of = (a, s, $ = !0) => new PDFCrossRefStream(a, s, $);
class PDFHexString extends PDFObject {
  constructor(s) {
    super(), this.value = s;
  }
  asBytes() {
    const s = this.value + (this.value.length % 2 === 1 ? "0" : ""), $ = s.length, _ = new Uint8Array(s.length / 2);
    let _e = 0, tt = 0;
    for (; _e < $; ) {
      const nt = parseInt(s.substring(_e, _e + 2), 16);
      _[tt] = nt, _e += 2, tt += 1;
    }
    return _;
  }
  decodeText() {
    const s = this.asBytes();
    return hasUtf16BOM(s) ? utf16Decode(s) : pdfDocEncodingDecode(s);
  }
  decodeDate() {
    const s = this.decodeText(), $ = parseDate(s);
    if (!$)
      throw new InvalidPDFDateStringError(s);
    return $;
  }
  asString() {
    return this.value;
  }
  clone() {
    return PDFHexString.of(this.value);
  }
  toString() {
    return `<${this.value}>`;
  }
  sizeInBytes() {
    return this.value.length + 2;
  }
  copyBytesInto(s, $) {
    return s[$++] = CharCodes$1.LessThan, $ += copyStringIntoBuffer(this.value, s, $), s[$++] = CharCodes$1.GreaterThan, this.value.length + 2;
  }
}
PDFHexString.of = (a) => new PDFHexString(a);
PDFHexString.fromText = (a) => {
  const s = utf16Encode(a);
  let $ = "";
  for (let _ = 0, _e = s.length; _ < _e; _++)
    $ += toHexStringOfMinLength(s[_], 4);
  return new PDFHexString($);
};
class PDFString extends PDFObject {
  constructor(s) {
    super(), this.value = s;
  }
  asBytes() {
    const s = [];
    let $ = "", _ = !1;
    const _e = (tt) => {
      tt !== void 0 && s.push(tt), _ = !1;
    };
    for (let tt = 0, nt = this.value.length; tt < nt; tt++) {
      const at = this.value[tt], ot = toCharCode(at), rt = this.value[tt + 1];
      _ ? ot === CharCodes$1.Newline || ot === CharCodes$1.CarriageReturn ? _e() : ot === CharCodes$1.n ? _e(CharCodes$1.Newline) : ot === CharCodes$1.r ? _e(CharCodes$1.CarriageReturn) : ot === CharCodes$1.t ? _e(CharCodes$1.Tab) : ot === CharCodes$1.b ? _e(CharCodes$1.Backspace) : ot === CharCodes$1.f ? _e(CharCodes$1.FormFeed) : ot === CharCodes$1.LeftParen ? _e(CharCodes$1.LeftParen) : ot === CharCodes$1.RightParen ? _e(CharCodes$1.RightParen) : ot === CharCodes$1.Backspace ? _e(CharCodes$1.BackSlash) : ot >= CharCodes$1.Zero && ot <= CharCodes$1.Seven ? ($ += at, ($.length === 3 || !(rt >= "0" && rt <= "7")) && (_e(parseInt($, 8)), $ = "")) : _e(ot) : ot === CharCodes$1.BackSlash ? _ = !0 : _e(ot);
    }
    return new Uint8Array(s);
  }
  decodeText() {
    const s = this.asBytes();
    return hasUtf16BOM(s) ? utf16Decode(s) : pdfDocEncodingDecode(s);
  }
  decodeDate() {
    const s = this.decodeText(), $ = parseDate(s);
    if (!$)
      throw new InvalidPDFDateStringError(s);
    return $;
  }
  asString() {
    return this.value;
  }
  clone() {
    return PDFString.of(this.value);
  }
  toString() {
    return `(${this.value})`;
  }
  sizeInBytes() {
    return this.value.length + 2;
  }
  copyBytesInto(s, $) {
    return s[$++] = CharCodes$1.LeftParen, $ += copyStringIntoBuffer(this.value, s, $), s[$++] = CharCodes$1.RightParen, this.value.length + 2;
  }
}
PDFString.of = (a) => new PDFString(a);
PDFString.fromDate = (a) => {
  const s = padStart$1(String(a.getUTCFullYear()), 4, "0"), $ = padStart$1(String(a.getUTCMonth() + 1), 2, "0"), _ = padStart$1(String(a.getUTCDate()), 2, "0"), _e = padStart$1(String(a.getUTCHours()), 2, "0"), tt = padStart$1(String(a.getUTCMinutes()), 2, "0"), nt = padStart$1(String(a.getUTCSeconds()), 2, "0");
  return new PDFString(`D:${s}${$}${_}${_e}${tt}${nt}Z`);
};
var AFRelationship;
(function(a) {
  a.Source = "Source", a.Data = "Data", a.Alternative = "Alternative", a.Supplement = "Supplement", a.EncryptedPayload = "EncryptedPayload", a.FormData = "EncryptedPayload", a.Schema = "Schema", a.Unspecified = "Unspecified";
})(AFRelationship || (AFRelationship = {}));
var ColorSpace;
(function(a) {
  a.DeviceGray = "DeviceGray", a.DeviceRGB = "DeviceRGB", a.DeviceCMYK = "DeviceCMYK";
})(ColorSpace || (ColorSpace = {}));
ColorSpace.DeviceGray, ColorSpace.DeviceRGB, ColorSpace.DeviceCMYK;
var UPNG = {};
UPNG.toRGBA8 = function(a) {
  var s = a.width, $ = a.height;
  if (a.tabs.acTL == null)
    return [UPNG.toRGBA8.decodeImage(a.data, s, $, a).buffer];
  var _ = [];
  a.frames[0].data == null && (a.frames[0].data = a.data);
  for (var _e = s * $ * 4, tt = new Uint8Array(_e), nt = new Uint8Array(_e), at = new Uint8Array(_e), ot = 0; ot < a.frames.length; ot++) {
    var rt = a.frames[ot], st = rt.rect.x, lt = rt.rect.y, et = rt.rect.width, it = rt.rect.height, ut = UPNG.toRGBA8.decodeImage(rt.data, et, it, a);
    if (ot != 0)
      for (var ft = 0; ft < _e; ft++)
        at[ft] = tt[ft];
    if (rt.blend == 0 ? UPNG._copyTile(ut, et, it, tt, s, $, st, lt, 0) : rt.blend == 1 && UPNG._copyTile(ut, et, it, tt, s, $, st, lt, 1), _.push(tt.buffer.slice(0)), rt.dispose != 0) {
      if (rt.dispose == 1)
        UPNG._copyTile(nt, et, it, tt, s, $, st, lt, 0);
      else if (rt.dispose == 2)
        for (var ft = 0; ft < _e; ft++)
          tt[ft] = at[ft];
    }
  }
  return _;
};
UPNG.toRGBA8.decodeImage = function(a, s, $, _) {
  var _e = s * $, tt = UPNG.decode._getBPP(_), nt = Math.ceil(s * tt / 8), at = new Uint8Array(_e * 4), ot = new Uint32Array(at.buffer), rt = _.ctype, st = _.depth, lt = UPNG._bin.readUshort;
  if (rt == 6) {
    var et = _e << 2;
    if (st == 8)
      for (var it = 0; it < et; it += 4)
        at[it] = a[it], at[it + 1] = a[it + 1], at[it + 2] = a[it + 2], at[it + 3] = a[it + 3];
    if (st == 16)
      for (var it = 0; it < et; it++)
        at[it] = a[it << 1];
  } else if (rt == 2) {
    var ut = _.tabs.tRNS;
    if (ut == null) {
      if (st == 8)
        for (var it = 0; it < _e; it++) {
          var ft = it * 3;
          ot[it] = 255 << 24 | a[ft + 2] << 16 | a[ft + 1] << 8 | a[ft];
        }
      if (st == 16)
        for (var it = 0; it < _e; it++) {
          var ft = it * 6;
          ot[it] = 255 << 24 | a[ft + 4] << 16 | a[ft + 2] << 8 | a[ft];
        }
    } else {
      var ht = ut[0], dt = ut[1], gt = ut[2];
      if (st == 8)
        for (var it = 0; it < _e; it++) {
          var pt = it << 2, ft = it * 3;
          ot[it] = 255 << 24 | a[ft + 2] << 16 | a[ft + 1] << 8 | a[ft], a[ft] == ht && a[ft + 1] == dt && a[ft + 2] == gt && (at[pt + 3] = 0);
        }
      if (st == 16)
        for (var it = 0; it < _e; it++) {
          var pt = it << 2, ft = it * 6;
          ot[it] = 255 << 24 | a[ft + 4] << 16 | a[ft + 2] << 8 | a[ft], lt(a, ft) == ht && lt(a, ft + 2) == dt && lt(a, ft + 4) == gt && (at[pt + 3] = 0);
        }
    }
  } else if (rt == 3) {
    var mt = _.tabs.PLTE, ct = _.tabs.tRNS, vt = ct ? ct.length : 0;
    if (st == 1)
      for (var At = 0; At < $; At++)
        for (var xt = At * nt, bt = At * s, it = 0; it < s; it++) {
          var pt = bt + it << 2, Et = a[xt + (it >> 3)] >> 7 - ((it & 7) << 0) & 1, St = 3 * Et;
          at[pt] = mt[St], at[pt + 1] = mt[St + 1], at[pt + 2] = mt[St + 2], at[pt + 3] = Et < vt ? ct[Et] : 255;
        }
    if (st == 2)
      for (var At = 0; At < $; At++)
        for (var xt = At * nt, bt = At * s, it = 0; it < s; it++) {
          var pt = bt + it << 2, Et = a[xt + (it >> 2)] >> 6 - ((it & 3) << 1) & 3, St = 3 * Et;
          at[pt] = mt[St], at[pt + 1] = mt[St + 1], at[pt + 2] = mt[St + 2], at[pt + 3] = Et < vt ? ct[Et] : 255;
        }
    if (st == 4)
      for (var At = 0; At < $; At++)
        for (var xt = At * nt, bt = At * s, it = 0; it < s; it++) {
          var pt = bt + it << 2, Et = a[xt + (it >> 1)] >> 4 - ((it & 1) << 2) & 15, St = 3 * Et;
          at[pt] = mt[St], at[pt + 1] = mt[St + 1], at[pt + 2] = mt[St + 2], at[pt + 3] = Et < vt ? ct[Et] : 255;
        }
    if (st == 8)
      for (var it = 0; it < _e; it++) {
        var pt = it << 2, Et = a[it], St = 3 * Et;
        at[pt] = mt[St], at[pt + 1] = mt[St + 1], at[pt + 2] = mt[St + 2], at[pt + 3] = Et < vt ? ct[Et] : 255;
      }
  } else if (rt == 4) {
    if (st == 8)
      for (var it = 0; it < _e; it++) {
        var pt = it << 2, Bt = it << 1, Ot = a[Bt];
        at[pt] = Ot, at[pt + 1] = Ot, at[pt + 2] = Ot, at[pt + 3] = a[Bt + 1];
      }
    if (st == 16)
      for (var it = 0; it < _e; it++) {
        var pt = it << 2, Bt = it << 2, Ot = a[Bt];
        at[pt] = Ot, at[pt + 1] = Ot, at[pt + 2] = Ot, at[pt + 3] = a[Bt + 2];
      }
  } else if (rt == 0)
    for (var ht = _.tabs.tRNS ? _.tabs.tRNS : -1, At = 0; At < $; At++) {
      var Pt = At * nt, wt = At * s;
      if (st == 1)
        for (var Ct = 0; Ct < s; Ct++) {
          var Ot = 255 * (a[Pt + (Ct >>> 3)] >>> 7 - (Ct & 7) & 1), It = Ot == ht * 255 ? 0 : 255;
          ot[wt + Ct] = It << 24 | Ot << 16 | Ot << 8 | Ot;
        }
      else if (st == 2)
        for (var Ct = 0; Ct < s; Ct++) {
          var Ot = 85 * (a[Pt + (Ct >>> 2)] >>> 6 - ((Ct & 3) << 1) & 3), It = Ot == ht * 85 ? 0 : 255;
          ot[wt + Ct] = It << 24 | Ot << 16 | Ot << 8 | Ot;
        }
      else if (st == 4)
        for (var Ct = 0; Ct < s; Ct++) {
          var Ot = 17 * (a[Pt + (Ct >>> 1)] >>> 4 - ((Ct & 1) << 2) & 15), It = Ot == ht * 17 ? 0 : 255;
          ot[wt + Ct] = It << 24 | Ot << 16 | Ot << 8 | Ot;
        }
      else if (st == 8)
        for (var Ct = 0; Ct < s; Ct++) {
          var Ot = a[Pt + Ct], It = Ot == ht ? 0 : 255;
          ot[wt + Ct] = It << 24 | Ot << 16 | Ot << 8 | Ot;
        }
      else if (st == 16)
        for (var Ct = 0; Ct < s; Ct++) {
          var Ot = a[Pt + (Ct << 1)], It = lt(a, Pt + (Ct << it)) == ht ? 0 : 255;
          ot[wt + Ct] = It << 24 | Ot << 16 | Ot << 8 | Ot;
        }
    }
  return at;
};
UPNG.decode = function(a) {
  for (var s = new Uint8Array(a), $ = 8, _ = UPNG._bin, _e = _.readUshort, tt = _.readUint, nt = { tabs: {}, frames: [] }, at = new Uint8Array(s.length), ot = 0, rt, st = 0, lt = [137, 80, 78, 71, 13, 10, 26, 10], et = 0; et < 8; et++)
    if (s[et] != lt[et])
      throw "The input is not a PNG file!";
  for (; $ < s.length; ) {
    var it = _.readUint(s, $);
    $ += 4;
    var ut = _.readASCII(s, $, 4);
    if ($ += 4, ut == "IHDR")
      UPNG.decode._IHDR(s, $, nt);
    else if (ut == "IDAT") {
      for (var et = 0; et < it; et++)
        at[ot + et] = s[$ + et];
      ot += it;
    } else if (ut == "acTL")
      nt.tabs[ut] = { num_frames: tt(s, $), num_plays: tt(s, $ + 4) }, rt = new Uint8Array(s.length);
    else if (ut == "fcTL") {
      if (st != 0) {
        var ft = nt.frames[nt.frames.length - 1];
        ft.data = UPNG.decode._decompress(nt, rt.slice(0, st), ft.rect.width, ft.rect.height), st = 0;
      }
      var ht = { x: tt(s, $ + 12), y: tt(s, $ + 16), width: tt(s, $ + 4), height: tt(s, $ + 8) }, dt = _e(s, $ + 22);
      dt = _e(s, $ + 20) / (dt == 0 ? 100 : dt);
      var gt = { rect: ht, delay: Math.round(dt * 1e3), dispose: s[$ + 24], blend: s[$ + 25] };
      nt.frames.push(gt);
    } else if (ut == "fdAT") {
      for (var et = 0; et < it - 4; et++)
        rt[st + et] = s[$ + et + 4];
      st += it - 4;
    } else if (ut == "pHYs")
      nt.tabs[ut] = [_.readUint(s, $), _.readUint(s, $ + 4), s[$ + 8]];
    else if (ut == "cHRM") {
      nt.tabs[ut] = [];
      for (var et = 0; et < 8; et++)
        nt.tabs[ut].push(_.readUint(s, $ + et * 4));
    } else if (ut == "tEXt") {
      nt.tabs[ut] == null && (nt.tabs[ut] = {});
      var pt = _.nextZero(s, $), mt = _.readASCII(s, $, pt - $), ct = _.readASCII(s, pt + 1, $ + it - pt - 1);
      nt.tabs[ut][mt] = ct;
    } else if (ut == "iTXt") {
      nt.tabs[ut] == null && (nt.tabs[ut] = {});
      var pt = 0, vt = $;
      pt = _.nextZero(s, vt);
      var mt = _.readASCII(s, vt, pt - vt);
      vt = pt + 1, s[vt], s[vt + 1], vt += 2, pt = _.nextZero(s, vt), _.readASCII(s, vt, pt - vt), vt = pt + 1, pt = _.nextZero(s, vt), _.readUTF8(s, vt, pt - vt), vt = pt + 1;
      var ct = _.readUTF8(s, vt, it - (vt - $));
      nt.tabs[ut][mt] = ct;
    } else if (ut == "PLTE")
      nt.tabs[ut] = _.readBytes(s, $, it);
    else if (ut == "hIST") {
      var At = nt.tabs.PLTE.length / 3;
      nt.tabs[ut] = [];
      for (var et = 0; et < At; et++)
        nt.tabs[ut].push(_e(s, $ + et * 2));
    } else if (ut == "tRNS")
      nt.ctype == 3 ? nt.tabs[ut] = _.readBytes(s, $, it) : nt.ctype == 0 ? nt.tabs[ut] = _e(s, $) : nt.ctype == 2 && (nt.tabs[ut] = [_e(s, $), _e(s, $ + 2), _e(s, $ + 4)]);
    else if (ut == "gAMA")
      nt.tabs[ut] = _.readUint(s, $) / 1e5;
    else if (ut == "sRGB")
      nt.tabs[ut] = s[$];
    else if (ut == "bKGD")
      nt.ctype == 0 || nt.ctype == 4 ? nt.tabs[ut] = [_e(s, $)] : nt.ctype == 2 || nt.ctype == 6 ? nt.tabs[ut] = [_e(s, $), _e(s, $ + 2), _e(s, $ + 4)] : nt.ctype == 3 && (nt.tabs[ut] = s[$]);
    else if (ut == "IEND")
      break;
    $ += it, _.readUint(s, $), $ += 4;
  }
  if (st != 0) {
    var ft = nt.frames[nt.frames.length - 1];
    ft.data = UPNG.decode._decompress(nt, rt.slice(0, st), ft.rect.width, ft.rect.height), st = 0;
  }
  return nt.data = UPNG.decode._decompress(nt, at, nt.width, nt.height), delete nt.compress, delete nt.interlace, delete nt.filter, nt;
};
UPNG.decode._decompress = function(a, s, $, _) {
  var _e = UPNG.decode._getBPP(a), tt = Math.ceil($ * _e / 8), nt = new Uint8Array((tt + 1 + a.interlace) * _);
  return s = UPNG.decode._inflate(s, nt), a.interlace == 0 ? s = UPNG.decode._filterZero(s, a, 0, $, _) : a.interlace == 1 && (s = UPNG.decode._readInterlace(s, a)), s;
};
UPNG.decode._inflate = function(a, s) {
  var $ = UPNG.inflateRaw(new Uint8Array(a.buffer, 2, a.length - 6), s);
  return $;
};
UPNG.inflateRaw = function() {
  var a = {};
  return a.H = {}, a.H.N = function(s, $) {
    var _ = Uint8Array, _e = 0, tt = 0, nt = 0, at = 0, ot = 0, rt = 0, st = 0, lt = 0, et = 0, it, ut;
    if (s[0] == 3 && s[1] == 0)
      return $ || new _(0);
    var ft = a.H, ht = ft.b, dt = ft.e, gt = ft.R, pt = ft.n, mt = ft.A, ct = ft.Z, vt = ft.m, At = $ == null;
    for (At && ($ = new _(s.length >>> 2 << 3)); _e == 0; ) {
      if (_e = ht(s, et, 1), tt = ht(s, et + 1, 2), et += 3, tt == 0) {
        et & 7 && (et += 8 - (et & 7));
        var xt = (et >>> 3) + 4, bt = s[xt - 4] | s[xt - 3] << 8;
        At && ($ = a.H.W($, lt + bt)), $.set(new _(s.buffer, s.byteOffset + xt, bt), lt), et = xt + bt << 3, lt += bt;
        continue;
      }
      if (At && ($ = a.H.W($, lt + (1 << 17))), tt == 1 && (it = vt.J, ut = vt.h, rt = 511, st = 31), tt == 2) {
        nt = dt(s, et, 5) + 257, at = dt(s, et + 5, 5) + 1, ot = dt(s, et + 10, 4) + 4, et += 14;
        for (var Et = 1, St = 0; St < 38; St += 2)
          vt.Q[St] = 0, vt.Q[St + 1] = 0;
        for (var St = 0; St < ot; St++) {
          var Bt = dt(s, et + St * 3, 3);
          vt.Q[(vt.X[St] << 1) + 1] = Bt, Bt > Et && (Et = Bt);
        }
        et += 3 * ot, pt(vt.Q, Et), mt(vt.Q, Et, vt.u), it = vt.w, ut = vt.d, et = gt(vt.u, (1 << Et) - 1, nt + at, s, et, vt.v);
        var Ot = ft.V(vt.v, 0, nt, vt.C);
        rt = (1 << Ot) - 1;
        var Pt = ft.V(vt.v, nt, at, vt.D);
        st = (1 << Pt) - 1, pt(vt.C, Ot), mt(vt.C, Ot, it), pt(vt.D, Pt), mt(vt.D, Pt, ut);
      }
      for (; ; ) {
        var wt = it[ct(s, et) & rt];
        et += wt & 15;
        var Ct = wt >>> 4;
        if (!(Ct >>> 8))
          $[lt++] = Ct;
        else {
          if (Ct == 256)
            break;
          var It = lt + Ct - 254;
          if (Ct > 264) {
            var yt = vt.q[Ct - 257];
            It = lt + (yt >>> 3) + dt(s, et, yt & 7), et += yt & 7;
          }
          var Rt = ut[ct(s, et) & st];
          et += Rt & 15;
          var kt = Rt >>> 4, jt = vt.c[kt], Ht = (jt >>> 4) + ht(s, et, jt & 15);
          for (et += jt & 15; lt < It; )
            $[lt] = $[lt++ - Ht], $[lt] = $[lt++ - Ht], $[lt] = $[lt++ - Ht], $[lt] = $[lt++ - Ht];
          lt = It;
        }
      }
    }
    return $.length == lt ? $ : $.slice(0, lt);
  }, a.H.W = function(s, $) {
    var _ = s.length;
    if ($ <= _)
      return s;
    var _e = new Uint8Array(_ << 1);
    return _e.set(s, 0), _e;
  }, a.H.R = function(s, $, _, _e, tt, nt) {
    for (var at = a.H.e, ot = a.H.Z, rt = 0; rt < _; ) {
      var st = s[ot(_e, tt) & $];
      tt += st & 15;
      var lt = st >>> 4;
      if (lt <= 15)
        nt[rt] = lt, rt++;
      else {
        var et = 0, it = 0;
        lt == 16 ? (it = 3 + at(_e, tt, 2), tt += 2, et = nt[rt - 1]) : lt == 17 ? (it = 3 + at(_e, tt, 3), tt += 3) : lt == 18 && (it = 11 + at(_e, tt, 7), tt += 7);
        for (var ut = rt + it; rt < ut; )
          nt[rt] = et, rt++;
      }
    }
    return tt;
  }, a.H.V = function(s, $, _, _e) {
    for (var tt = 0, nt = 0, at = _e.length >>> 1; nt < _; ) {
      var ot = s[nt + $];
      _e[nt << 1] = 0, _e[(nt << 1) + 1] = ot, ot > tt && (tt = ot), nt++;
    }
    for (; nt < at; )
      _e[nt << 1] = 0, _e[(nt << 1) + 1] = 0, nt++;
    return tt;
  }, a.H.n = function(s, $) {
    for (var _ = a.H.m, _e = s.length, tt, nt, at, ot, rt, st = _.j, ot = 0; ot <= $; ot++)
      st[ot] = 0;
    for (ot = 1; ot < _e; ot += 2)
      st[s[ot]]++;
    var lt = _.K;
    for (tt = 0, st[0] = 0, nt = 1; nt <= $; nt++)
      tt = tt + st[nt - 1] << 1, lt[nt] = tt;
    for (at = 0; at < _e; at += 2)
      rt = s[at + 1], rt != 0 && (s[at] = lt[rt], lt[rt]++);
  }, a.H.A = function(s, $, _) {
    for (var _e = s.length, tt = a.H.m, nt = tt.r, at = 0; at < _e; at += 2)
      if (s[at + 1] != 0)
        for (var ot = at >> 1, rt = s[at + 1], st = ot << 4 | rt, lt = $ - rt, et = s[at] << lt, it = et + (1 << lt); et != it; ) {
          var ut = nt[et] >>> 15 - $;
          _[ut] = st, et++;
        }
  }, a.H.l = function(s, $) {
    for (var _ = a.H.m.r, _e = 15 - $, tt = 0; tt < s.length; tt += 2) {
      var nt = s[tt] << $ - s[tt + 1];
      s[tt] = _[nt] >>> _e;
    }
  }, a.H.M = function(s, $, _) {
    _ = _ << ($ & 7);
    var _e = $ >>> 3;
    s[_e] |= _, s[_e + 1] |= _ >>> 8;
  }, a.H.I = function(s, $, _) {
    _ = _ << ($ & 7);
    var _e = $ >>> 3;
    s[_e] |= _, s[_e + 1] |= _ >>> 8, s[_e + 2] |= _ >>> 16;
  }, a.H.e = function(s, $, _) {
    return (s[$ >>> 3] | s[($ >>> 3) + 1] << 8) >>> ($ & 7) & (1 << _) - 1;
  }, a.H.b = function(s, $, _) {
    return (s[$ >>> 3] | s[($ >>> 3) + 1] << 8 | s[($ >>> 3) + 2] << 16) >>> ($ & 7) & (1 << _) - 1;
  }, a.H.Z = function(s, $) {
    return (s[$ >>> 3] | s[($ >>> 3) + 1] << 8 | s[($ >>> 3) + 2] << 16) >>> ($ & 7);
  }, a.H.i = function(s, $) {
    return (s[$ >>> 3] | s[($ >>> 3) + 1] << 8 | s[($ >>> 3) + 2] << 16 | s[($ >>> 3) + 3] << 24) >>> ($ & 7);
  }, a.H.m = function() {
    var s = Uint16Array, $ = Uint32Array;
    return { K: new s(16), j: new s(16), X: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], S: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999], T: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0], q: new s(32), p: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535], z: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0], c: new $(32), J: new s(512), _: [], h: new s(32), $: [], w: new s(32768), C: [], v: [], d: new s(32768), D: [], u: new s(512), Q: [], r: new s(32768), s: new $(286), Y: new $(30), a: new $(19), t: new $(15e3), k: new s(65536), g: new s(32768) };
  }(), function() {
    for (var s = a.H.m, $ = 32768, _ = 0; _ < $; _++) {
      var _e = _;
      _e = (_e & 2863311530) >>> 1 | (_e & 1431655765) << 1, _e = (_e & 3435973836) >>> 2 | (_e & 858993459) << 2, _e = (_e & 4042322160) >>> 4 | (_e & 252645135) << 4, _e = (_e & 4278255360) >>> 8 | (_e & 16711935) << 8, s.r[_] = (_e >>> 16 | _e << 16) >>> 17;
    }
    function tt(nt, at, ot) {
      for (; at-- != 0; )
        nt.push(0, ot);
    }
    for (var _ = 0; _ < 32; _++)
      s.q[_] = s.S[_] << 3 | s.T[_], s.c[_] = s.p[_] << 4 | s.z[_];
    tt(s._, 144, 8), tt(s._, 112, 9), tt(s._, 24, 7), tt(s._, 8, 8), a.H.n(s._, 9), a.H.A(s._, 9, s.J), a.H.l(s._, 9), tt(s.$, 32, 5), a.H.n(s.$, 5), a.H.A(s.$, 5, s.h), a.H.l(s.$, 5), tt(s.Q, 19, 0), tt(s.C, 286, 0), tt(s.D, 30, 0), tt(s.v, 320, 0);
  }(), a.H.N;
}();
UPNG.decode._readInterlace = function(a, s) {
  for (var $ = s.width, _ = s.height, _e = UPNG.decode._getBPP(s), tt = _e >> 3, nt = Math.ceil($ * _e / 8), at = new Uint8Array(_ * nt), ot = 0, rt = [0, 0, 4, 0, 2, 0, 1], st = [0, 4, 0, 2, 0, 1, 0], lt = [8, 8, 8, 4, 4, 2, 2], et = [8, 8, 4, 4, 2, 2, 1], it = 0; it < 7; ) {
    for (var ut = lt[it], ft = et[it], ht = 0, dt = 0, gt = rt[it]; gt < _; )
      gt += ut, dt++;
    for (var pt = st[it]; pt < $; )
      pt += ft, ht++;
    var mt = Math.ceil(ht * _e / 8);
    UPNG.decode._filterZero(a, s, ot, ht, dt);
    for (var ct = 0, vt = rt[it]; vt < _; ) {
      for (var At = st[it], xt = ot + ct * mt << 3; At < $; ) {
        if (_e == 1) {
          var bt = a[xt >> 3];
          bt = bt >> 7 - (xt & 7) & 1, at[vt * nt + (At >> 3)] |= bt << 7 - ((At & 7) << 0);
        }
        if (_e == 2) {
          var bt = a[xt >> 3];
          bt = bt >> 6 - (xt & 7) & 3, at[vt * nt + (At >> 2)] |= bt << 6 - ((At & 3) << 1);
        }
        if (_e == 4) {
          var bt = a[xt >> 3];
          bt = bt >> 4 - (xt & 7) & 15, at[vt * nt + (At >> 1)] |= bt << 4 - ((At & 1) << 2);
        }
        if (_e >= 8)
          for (var Et = vt * nt + At * tt, St = 0; St < tt; St++)
            at[Et + St] = a[(xt >> 3) + St];
        xt += _e, At += ft;
      }
      ct++, vt += ut;
    }
    ht * dt != 0 && (ot += dt * (1 + mt)), it = it + 1;
  }
  return at;
};
UPNG.decode._getBPP = function(a) {
  var s = [1, null, 3, 1, 2, null, 4][a.ctype];
  return s * a.depth;
};
UPNG.decode._filterZero = function(a, s, $, _, _e) {
  var tt = UPNG.decode._getBPP(s), nt = Math.ceil(_ * tt / 8), at = UPNG.decode._paeth;
  tt = Math.ceil(tt / 8);
  var ot = 0, rt = 1, st = a[$], lt = 0;
  if (st > 1 && (a[$] = [0, 0, 1][st - 2]), st == 3)
    for (lt = tt; lt < nt; lt++)
      a[lt + 1] = a[lt + 1] + (a[lt + 1 - tt] >>> 1) & 255;
  for (var et = 0; et < _e; et++)
    if (ot = $ + et * nt, rt = ot + et + 1, st = a[rt - 1], lt = 0, st == 0)
      for (; lt < nt; lt++)
        a[ot + lt] = a[rt + lt];
    else if (st == 1) {
      for (; lt < tt; lt++)
        a[ot + lt] = a[rt + lt];
      for (; lt < nt; lt++)
        a[ot + lt] = a[rt + lt] + a[ot + lt - tt];
    } else if (st == 2)
      for (; lt < nt; lt++)
        a[ot + lt] = a[rt + lt] + a[ot + lt - nt];
    else if (st == 3) {
      for (; lt < tt; lt++)
        a[ot + lt] = a[rt + lt] + (a[ot + lt - nt] >>> 1);
      for (; lt < nt; lt++)
        a[ot + lt] = a[rt + lt] + (a[ot + lt - nt] + a[ot + lt - tt] >>> 1);
    } else {
      for (; lt < tt; lt++)
        a[ot + lt] = a[rt + lt] + at(0, a[ot + lt - nt], 0);
      for (; lt < nt; lt++)
        a[ot + lt] = a[rt + lt] + at(a[ot + lt - tt], a[ot + lt - nt], a[ot + lt - tt - nt]);
    }
  return a;
};
UPNG.decode._paeth = function(a, s, $) {
  var _ = a + s - $, _e = _ - a, tt = _ - s, nt = _ - $;
  return _e * _e <= tt * tt && _e * _e <= nt * nt ? a : tt * tt <= nt * nt ? s : $;
};
UPNG.decode._IHDR = function(a, s, $) {
  var _ = UPNG._bin;
  $.width = _.readUint(a, s), s += 4, $.height = _.readUint(a, s), s += 4, $.depth = a[s], s++, $.ctype = a[s], s++, $.compress = a[s], s++, $.filter = a[s], s++, $.interlace = a[s], s++;
};
UPNG._bin = {
  nextZero: function(a, s) {
    for (; a[s] != 0; )
      s++;
    return s;
  },
  readUshort: function(a, s) {
    return a[s] << 8 | a[s + 1];
  },
  writeUshort: function(a, s, $) {
    a[s] = $ >> 8 & 255, a[s + 1] = $ & 255;
  },
  readUint: function(a, s) {
    return a[s] * (256 * 256 * 256) + (a[s + 1] << 16 | a[s + 2] << 8 | a[s + 3]);
  },
  writeUint: function(a, s, $) {
    a[s] = $ >> 24 & 255, a[s + 1] = $ >> 16 & 255, a[s + 2] = $ >> 8 & 255, a[s + 3] = $ & 255;
  },
  readASCII: function(a, s, $) {
    for (var _ = "", _e = 0; _e < $; _e++)
      _ += String.fromCharCode(a[s + _e]);
    return _;
  },
  writeASCII: function(a, s, $) {
    for (var _ = 0; _ < $.length; _++)
      a[s + _] = $.charCodeAt(_);
  },
  readBytes: function(a, s, $) {
    for (var _ = [], _e = 0; _e < $; _e++)
      _.push(a[s + _e]);
    return _;
  },
  pad: function(a) {
    return a.length < 2 ? "0" + a : a;
  },
  readUTF8: function(a, s, $) {
    for (var _ = "", _e, tt = 0; tt < $; tt++)
      _ += "%" + UPNG._bin.pad(a[s + tt].toString(16));
    try {
      _e = decodeURIComponent(_);
    } catch {
      return UPNG._bin.readASCII(a, s, $);
    }
    return _e;
  }
};
UPNG._copyTile = function(a, s, $, _, _e, tt, nt, at, ot) {
  for (var rt = Math.min(s, _e), st = Math.min($, tt), lt = 0, et = 0, it = 0; it < st; it++)
    for (var ut = 0; ut < rt; ut++)
      if (nt >= 0 && at >= 0 ? (lt = it * s + ut << 2, et = (at + it) * _e + nt + ut << 2) : (lt = (-at + it) * s - nt + ut << 2, et = it * _e + ut << 2), ot == 0)
        _[et] = a[lt], _[et + 1] = a[lt + 1], _[et + 2] = a[lt + 2], _[et + 3] = a[lt + 3];
      else if (ot == 1) {
        var ft = a[lt + 3] * 0.00392156862745098, ht = a[lt] * ft, dt = a[lt + 1] * ft, gt = a[lt + 2] * ft, pt = _[et + 3] * (1 / 255), mt = _[et] * pt, ct = _[et + 1] * pt, vt = _[et + 2] * pt, At = 1 - ft, xt = ft + pt * At, bt = xt == 0 ? 0 : 1 / xt;
        _[et + 3] = 255 * xt, _[et + 0] = (ht + mt * At) * bt, _[et + 1] = (dt + ct * At) * bt, _[et + 2] = (gt + vt * At) * bt;
      } else if (ot == 2) {
        var ft = a[lt + 3], ht = a[lt], dt = a[lt + 1], gt = a[lt + 2], pt = _[et + 3], mt = _[et], ct = _[et + 1], vt = _[et + 2];
        ft == pt && ht == mt && dt == ct && gt == vt ? (_[et] = 0, _[et + 1] = 0, _[et + 2] = 0, _[et + 3] = 0) : (_[et] = ht, _[et + 1] = dt, _[et + 2] = gt, _[et + 3] = ft);
      } else if (ot == 3) {
        var ft = a[lt + 3], ht = a[lt], dt = a[lt + 1], gt = a[lt + 2], pt = _[et + 3], mt = _[et], ct = _[et + 1], vt = _[et + 2];
        if (ft == pt && ht == mt && dt == ct && gt == vt)
          continue;
        if (ft < 220 && pt > 20)
          return !1;
      }
  return !0;
};
UPNG.encode = function(a, s, $, _, _e, tt, nt) {
  _ == null && (_ = 0), nt == null && (nt = !1);
  var at = UPNG.encode.compress(a, s, $, _, [!1, !1, !1, 0, nt]);
  return UPNG.encode.compressPNG(at, -1), UPNG.encode._main(at, s, $, _e, tt);
};
UPNG.encodeLL = function(a, s, $, _, _e, tt, nt, at) {
  for (var ot = { ctype: 0 + (_ == 1 ? 0 : 2) + (_e == 0 ? 0 : 4), depth: tt, frames: [] }, rt = (_ + _e) * tt, st = rt * s, lt = 0; lt < a.length; lt++)
    ot.frames.push({ rect: { x: 0, y: 0, width: s, height: $ }, img: new Uint8Array(a[lt]), blend: 0, dispose: 1, bpp: Math.ceil(rt / 8), bpl: Math.ceil(st / 8) });
  UPNG.encode.compressPNG(ot, 0, !0);
  var et = UPNG.encode._main(ot, s, $, nt, at);
  return et;
};
UPNG.encode._main = function(a, s, $, _, _e) {
  _e == null && (_e = {});
  var tt = UPNG.crc.crc, nt = UPNG._bin.writeUint, at = UPNG._bin.writeUshort, ot = UPNG._bin.writeASCII, rt = 8, st = a.frames.length > 1, lt = !1, et = 33 + (st ? 20 : 0);
  if (_e.sRGB != null && (et += 13), _e.pHYs != null && (et += 21), a.ctype == 3) {
    for (var it = a.plte.length, ut = 0; ut < it; ut++)
      a.plte[ut] >>> 24 != 255 && (lt = !0);
    et += 8 + it * 3 + 4 + (lt ? 8 + it * 1 + 4 : 0);
  }
  for (var ft = 0; ft < a.frames.length; ft++) {
    var ht = a.frames[ft];
    st && (et += 38), et += ht.cimg.length + 12, ft != 0 && (et += 4);
  }
  et += 12;
  for (var dt = new Uint8Array(et), gt = [137, 80, 78, 71, 13, 10, 26, 10], ut = 0; ut < 8; ut++)
    dt[ut] = gt[ut];
  if (nt(dt, rt, 13), rt += 4, ot(dt, rt, "IHDR"), rt += 4, nt(dt, rt, s), rt += 4, nt(dt, rt, $), rt += 4, dt[rt] = a.depth, rt++, dt[rt] = a.ctype, rt++, dt[rt] = 0, rt++, dt[rt] = 0, rt++, dt[rt] = 0, rt++, nt(dt, rt, tt(dt, rt - 17, 17)), rt += 4, _e.sRGB != null && (nt(dt, rt, 1), rt += 4, ot(dt, rt, "sRGB"), rt += 4, dt[rt] = _e.sRGB, rt++, nt(dt, rt, tt(dt, rt - 5, 5)), rt += 4), _e.pHYs != null && (nt(dt, rt, 9), rt += 4, ot(dt, rt, "pHYs"), rt += 4, nt(dt, rt, _e.pHYs[0]), rt += 4, nt(dt, rt, _e.pHYs[1]), rt += 4, dt[rt] = _e.pHYs[2], rt++, nt(dt, rt, tt(dt, rt - 13, 13)), rt += 4), st && (nt(dt, rt, 8), rt += 4, ot(dt, rt, "acTL"), rt += 4, nt(dt, rt, a.frames.length), rt += 4, nt(dt, rt, _e.loop != null ? _e.loop : 0), rt += 4, nt(dt, rt, tt(dt, rt - 12, 12)), rt += 4), a.ctype == 3) {
    var it = a.plte.length;
    nt(dt, rt, it * 3), rt += 4, ot(dt, rt, "PLTE"), rt += 4;
    for (var ut = 0; ut < it; ut++) {
      var pt = ut * 3, mt = a.plte[ut], ct = mt & 255, vt = mt >>> 8 & 255, At = mt >>> 16 & 255;
      dt[rt + pt + 0] = ct, dt[rt + pt + 1] = vt, dt[rt + pt + 2] = At;
    }
    if (rt += it * 3, nt(dt, rt, tt(dt, rt - it * 3 - 4, it * 3 + 4)), rt += 4, lt) {
      nt(dt, rt, it), rt += 4, ot(dt, rt, "tRNS"), rt += 4;
      for (var ut = 0; ut < it; ut++)
        dt[rt + ut] = a.plte[ut] >>> 24 & 255;
      rt += it, nt(dt, rt, tt(dt, rt - it - 4, it + 4)), rt += 4;
    }
  }
  for (var xt = 0, ft = 0; ft < a.frames.length; ft++) {
    var ht = a.frames[ft];
    st && (nt(dt, rt, 26), rt += 4, ot(dt, rt, "fcTL"), rt += 4, nt(dt, rt, xt++), rt += 4, nt(dt, rt, ht.rect.width), rt += 4, nt(dt, rt, ht.rect.height), rt += 4, nt(dt, rt, ht.rect.x), rt += 4, nt(dt, rt, ht.rect.y), rt += 4, at(dt, rt, _[ft]), rt += 2, at(dt, rt, 1e3), rt += 2, dt[rt] = ht.dispose, rt++, dt[rt] = ht.blend, rt++, nt(dt, rt, tt(dt, rt - 30, 30)), rt += 4);
    var bt = ht.cimg, it = bt.length;
    nt(dt, rt, it + (ft == 0 ? 0 : 4)), rt += 4;
    var Et = rt;
    ot(dt, rt, ft == 0 ? "IDAT" : "fdAT"), rt += 4, ft != 0 && (nt(dt, rt, xt++), rt += 4), dt.set(bt, rt), rt += it, nt(dt, rt, tt(dt, Et, rt - Et)), rt += 4;
  }
  return nt(dt, rt, 0), rt += 4, ot(dt, rt, "IEND"), rt += 4, nt(dt, rt, tt(dt, rt - 4, 4)), rt += 4, dt.buffer;
};
UPNG.encode.compressPNG = function(a, s, $) {
  for (var _ = 0; _ < a.frames.length; _++) {
    var _e = a.frames[_];
    _e.rect.width;
    var tt = _e.rect.height, nt = new Uint8Array(tt * _e.bpl + tt);
    _e.cimg = UPNG.encode._filterZero(_e.img, tt, _e.bpp, _e.bpl, nt, s, $);
  }
};
UPNG.encode.compress = function(a, s, $, _, _e) {
  for (var tt = _e[0], nt = _e[1], at = _e[2], ot = _e[3], rt = _e[4], st = 6, lt = 8, et = 255, it = 0; it < a.length; it++)
    for (var ut = new Uint8Array(a[it]), ft = ut.length, ht = 0; ht < ft; ht += 4)
      et &= ut[ht + 3];
  var dt = et != 255, gt = UPNG.encode.framize(a, s, $, tt, nt, at), pt = {}, mt = [], ct = [];
  if (_ != 0) {
    for (var vt = [], ht = 0; ht < gt.length; ht++)
      vt.push(gt[ht].img.buffer);
    for (var At = UPNG.encode.concatRGBA(vt), xt = UPNG.quantize(At, _), bt = 0, Et = new Uint8Array(xt.abuf), ht = 0; ht < gt.length; ht++) {
      var St = gt[ht].img, Bt = St.length;
      ct.push(new Uint8Array(xt.inds.buffer, bt >> 2, Bt >> 2));
      for (var it = 0; it < Bt; it += 4)
        St[it] = Et[bt + it], St[it + 1] = Et[bt + it + 1], St[it + 2] = Et[bt + it + 2], St[it + 3] = Et[bt + it + 3];
      bt += Bt;
    }
    for (var ht = 0; ht < xt.plte.length; ht++)
      mt.push(xt.plte[ht].est.rgba);
  } else
    for (var it = 0; it < gt.length; it++) {
      var Ot = gt[it], Pt = new Uint32Array(Ot.img.buffer), wt = Ot.rect.width, ft = Pt.length, Ct = new Uint8Array(ft);
      ct.push(Ct);
      for (var ht = 0; ht < ft; ht++) {
        var It = Pt[ht];
        if (ht != 0 && It == Pt[ht - 1])
          Ct[ht] = Ct[ht - 1];
        else if (ht > wt && It == Pt[ht - wt])
          Ct[ht] = Ct[ht - wt];
        else {
          var yt = pt[It];
          if (yt == null && (pt[It] = yt = mt.length, mt.push(It), mt.length >= 300))
            break;
          Ct[ht] = yt;
        }
      }
    }
  var Rt = mt.length;
  Rt <= 256 && rt == !1 && (Rt <= 2 ? lt = 1 : Rt <= 4 ? lt = 2 : Rt <= 16 ? lt = 4 : lt = 8, lt = Math.max(lt, ot));
  for (var it = 0; it < gt.length; it++) {
    var Ot = gt[it];
    Ot.rect.x, Ot.rect.y;
    var wt = Ot.rect.width, kt = Ot.rect.height, jt = Ot.img;
    new Uint32Array(jt.buffer);
    var Ht = 4 * wt, Ft = 4;
    if (Rt <= 256 && rt == !1) {
      Ht = Math.ceil(lt * wt / 8);
      for (var _t = new Uint8Array(Ht * kt), Nt = ct[it], Mt = 0; Mt < kt; Mt++) {
        var ht = Mt * Ht, Lt = Mt * wt;
        if (lt == 8)
          for (var $t = 0; $t < wt; $t++)
            _t[ht + $t] = Nt[Lt + $t];
        else if (lt == 4)
          for (var $t = 0; $t < wt; $t++)
            _t[ht + ($t >> 1)] |= Nt[Lt + $t] << 4 - ($t & 1) * 4;
        else if (lt == 2)
          for (var $t = 0; $t < wt; $t++)
            _t[ht + ($t >> 2)] |= Nt[Lt + $t] << 6 - ($t & 3) * 2;
        else if (lt == 1)
          for (var $t = 0; $t < wt; $t++)
            _t[ht + ($t >> 3)] |= Nt[Lt + $t] << 7 - ($t & 7) * 1;
      }
      jt = _t, st = 3, Ft = 1;
    } else if (dt == !1 && gt.length == 1) {
      for (var _t = new Uint8Array(wt * kt * 3), Tt = wt * kt, ht = 0; ht < Tt; ht++) {
        var St = ht * 3, Dt = ht * 4;
        _t[St] = jt[Dt], _t[St + 1] = jt[Dt + 1], _t[St + 2] = jt[Dt + 2];
      }
      jt = _t, st = 2, Ft = 3, Ht = 3 * wt;
    }
    Ot.img = jt, Ot.bpl = Ht, Ot.bpp = Ft;
  }
  return { ctype: st, depth: lt, plte: mt, frames: gt };
};
UPNG.encode.framize = function(a, s, $, _, _e, tt) {
  for (var nt = [], at = 0; at < a.length; at++) {
    var ot = new Uint8Array(a[at]), rt = new Uint32Array(ot.buffer), st, lt = 0, et = 0, it = s, ut = $, ft = _ ? 1 : 0;
    if (at != 0) {
      for (var ht = tt || _ || at == 1 || nt[at - 2].dispose != 0 ? 1 : 2, dt = 0, gt = 1e9, pt = 0; pt < ht; pt++) {
        for (var Ot = new Uint8Array(a[at - 1 - pt]), mt = new Uint32Array(a[at - 1 - pt]), ct = s, vt = $, At = -1, xt = -1, bt = 0; bt < $; bt++)
          for (var Et = 0; Et < s; Et++) {
            var St = bt * s + Et;
            rt[St] != mt[St] && (Et < ct && (ct = Et), Et > At && (At = Et), bt < vt && (vt = bt), bt > xt && (xt = bt));
          }
        At == -1 && (ct = vt = At = xt = 0), _e && ((ct & 1) == 1 && ct--, (vt & 1) == 1 && vt--);
        var Bt = (At - ct + 1) * (xt - vt + 1);
        Bt < gt && (gt = Bt, dt = pt, lt = ct, et = vt, it = At - ct + 1, ut = xt - vt + 1);
      }
      var Ot = new Uint8Array(a[at - 1 - dt]);
      dt == 1 && (nt[at - 1].dispose = 2), st = new Uint8Array(it * ut * 4), UPNG._copyTile(Ot, s, $, st, it, ut, -lt, -et, 0), ft = UPNG._copyTile(ot, s, $, st, it, ut, -lt, -et, 3) ? 1 : 0, ft == 1 ? UPNG.encode._prepareDiff(ot, s, $, st, { x: lt, y: et, width: it, height: ut }) : UPNG._copyTile(ot, s, $, st, it, ut, -lt, -et, 0);
    } else
      st = ot.slice(0);
    nt.push({ rect: { x: lt, y: et, width: it, height: ut }, img: st, blend: ft, dispose: 0 });
  }
  if (_)
    for (var at = 0; at < nt.length; at++) {
      var Pt = nt[at];
      if (Pt.blend != 1) {
        var wt = Pt.rect, Ct = nt[at - 1].rect, It = Math.min(wt.x, Ct.x), yt = Math.min(wt.y, Ct.y), Rt = Math.max(wt.x + wt.width, Ct.x + Ct.width), kt = Math.max(wt.y + wt.height, Ct.y + Ct.height), jt = { x: It, y: yt, width: Rt - It, height: kt - yt };
        nt[at - 1].dispose = 1, at - 1 != 0 && UPNG.encode._updateFrame(a, s, $, nt, at - 1, jt, _e), UPNG.encode._updateFrame(a, s, $, nt, at, jt, _e);
      }
    }
  var Ht = 0;
  if (a.length != 1)
    for (var St = 0; St < nt.length; St++) {
      var Pt = nt[St];
      Ht += Pt.rect.width * Pt.rect.height;
    }
  return nt;
};
UPNG.encode._updateFrame = function(a, s, $, _, _e, tt, nt) {
  for (var at = Uint8Array, ot = Uint32Array, rt = new at(a[_e - 1]), st = new ot(a[_e - 1]), lt = _e + 1 < a.length ? new at(a[_e + 1]) : null, et = new at(a[_e]), it = new ot(et.buffer), ut = s, ft = $, ht = -1, dt = -1, gt = 0; gt < tt.height; gt++)
    for (var pt = 0; pt < tt.width; pt++) {
      var mt = tt.x + pt, ct = tt.y + gt, vt = ct * s + mt, At = it[vt];
      At == 0 || _[_e - 1].dispose == 0 && st[vt] == At && (lt == null || lt[vt * 4 + 3] != 0) || (mt < ut && (ut = mt), mt > ht && (ht = mt), ct < ft && (ft = ct), ct > dt && (dt = ct));
    }
  ht == -1 && (ut = ft = ht = dt = 0), nt && ((ut & 1) == 1 && ut--, (ft & 1) == 1 && ft--), tt = { x: ut, y: ft, width: ht - ut + 1, height: dt - ft + 1 };
  var xt = _[_e];
  xt.rect = tt, xt.blend = 1, xt.img = new Uint8Array(tt.width * tt.height * 4), _[_e - 1].dispose == 0 ? (UPNG._copyTile(rt, s, $, xt.img, tt.width, tt.height, -tt.x, -tt.y, 0), UPNG.encode._prepareDiff(et, s, $, xt.img, tt)) : UPNG._copyTile(et, s, $, xt.img, tt.width, tt.height, -tt.x, -tt.y, 0);
};
UPNG.encode._prepareDiff = function(a, s, $, _, _e) {
  UPNG._copyTile(a, s, $, _, _e.width, _e.height, -_e.x, -_e.y, 2);
};
UPNG.encode._filterZero = function(a, s, $, _, _e, tt, nt) {
  var at = [], ot = [0, 1, 2, 3, 4];
  tt != -1 ? ot = [tt] : (s * _ > 5e5 || $ == 1) && (ot = [0]);
  var rt;
  nt && (rt = { level: 0 });
  for (var st = nt && UZIP != null ? UZIP : pako$1, lt = 0; lt < ot.length; lt++) {
    for (var et = 0; et < s; et++)
      UPNG.encode._filterLine(_e, a, et, _, $, ot[lt]);
    at.push(st.deflate(_e, rt));
  }
  for (var it, ut = 1e9, lt = 0; lt < at.length; lt++)
    at[lt].length < ut && (it = lt, ut = at[lt].length);
  return at[it];
};
UPNG.encode._filterLine = function(a, s, $, _, _e, tt) {
  var nt = $ * _, at = nt + $, ot = UPNG.decode._paeth;
  if (a[at] = tt, at++, tt == 0)
    if (_ < 500)
      for (var rt = 0; rt < _; rt++)
        a[at + rt] = s[nt + rt];
    else
      a.set(new Uint8Array(s.buffer, nt, _), at);
  else if (tt == 1) {
    for (var rt = 0; rt < _e; rt++)
      a[at + rt] = s[nt + rt];
    for (var rt = _e; rt < _; rt++)
      a[at + rt] = s[nt + rt] - s[nt + rt - _e] + 256 & 255;
  } else if ($ == 0) {
    for (var rt = 0; rt < _e; rt++)
      a[at + rt] = s[nt + rt];
    if (tt == 2)
      for (var rt = _e; rt < _; rt++)
        a[at + rt] = s[nt + rt];
    if (tt == 3)
      for (var rt = _e; rt < _; rt++)
        a[at + rt] = s[nt + rt] - (s[nt + rt - _e] >> 1) + 256 & 255;
    if (tt == 4)
      for (var rt = _e; rt < _; rt++)
        a[at + rt] = s[nt + rt] - ot(s[nt + rt - _e], 0, 0) + 256 & 255;
  } else {
    if (tt == 2)
      for (var rt = 0; rt < _; rt++)
        a[at + rt] = s[nt + rt] + 256 - s[nt + rt - _] & 255;
    if (tt == 3) {
      for (var rt = 0; rt < _e; rt++)
        a[at + rt] = s[nt + rt] + 256 - (s[nt + rt - _] >> 1) & 255;
      for (var rt = _e; rt < _; rt++)
        a[at + rt] = s[nt + rt] + 256 - (s[nt + rt - _] + s[nt + rt - _e] >> 1) & 255;
    }
    if (tt == 4) {
      for (var rt = 0; rt < _e; rt++)
        a[at + rt] = s[nt + rt] + 256 - ot(0, s[nt + rt - _], 0) & 255;
      for (var rt = _e; rt < _; rt++)
        a[at + rt] = s[nt + rt] + 256 - ot(s[nt + rt - _e], s[nt + rt - _], s[nt + rt - _e - _]) & 255;
    }
  }
};
UPNG.crc = {
  table: function() {
    for (var a = new Uint32Array(256), s = 0; s < 256; s++) {
      for (var $ = s, _ = 0; _ < 8; _++)
        $ & 1 ? $ = 3988292384 ^ $ >>> 1 : $ = $ >>> 1;
      a[s] = $;
    }
    return a;
  }(),
  update: function(a, s, $, _) {
    for (var _e = 0; _e < _; _e++)
      a = UPNG.crc.table[(a ^ s[$ + _e]) & 255] ^ a >>> 8;
    return a;
  },
  crc: function(a, s, $) {
    return UPNG.crc.update(4294967295, a, s, $) ^ 4294967295;
  }
};
UPNG.quantize = function(a, s) {
  var $ = new Uint8Array(a), _ = $.slice(0), _e = new Uint32Array(_.buffer), tt = UPNG.quantize.getKDtree(_, s), nt = tt[0], at = tt[1];
  UPNG.quantize.planeDst;
  for (var ot = $, rt = _e, st = ot.length, lt = new Uint8Array($.length >> 2), et = 0; et < st; et += 4) {
    var it = ot[et] * 0.00392156862745098, ut = ot[et + 1] * (1 / 255), ft = ot[et + 2] * (1 / 255), ht = ot[et + 3] * (1 / 255), dt = UPNG.quantize.getNearest(nt, it, ut, ft, ht);
    lt[et >> 2] = dt.ind, rt[et >> 2] = dt.est.rgba;
  }
  return { abuf: _.buffer, inds: lt, plte: at };
};
UPNG.quantize.getKDtree = function(a, s, $) {
  $ == null && ($ = 1e-4);
  var _ = new Uint32Array(a.buffer), _e = { i0: 0, i1: a.length, bst: null, est: null, tdst: 0, left: null, right: null };
  _e.bst = UPNG.quantize.stats(a, _e.i0, _e.i1), _e.est = UPNG.quantize.estats(_e.bst);
  for (var tt = [_e]; tt.length < s; ) {
    for (var nt = 0, at = 0, ot = 0; ot < tt.length; ot++)
      tt[ot].est.L > nt && (nt = tt[ot].est.L, at = ot);
    if (nt < $)
      break;
    var rt = tt[at], st = UPNG.quantize.splitPixels(a, _, rt.i0, rt.i1, rt.est.e, rt.est.eMq255), lt = rt.i0 >= st || rt.i1 <= st;
    if (lt) {
      rt.est.L = 0;
      continue;
    }
    var et = { i0: rt.i0, i1: st, bst: null, est: null, tdst: 0, left: null, right: null };
    et.bst = UPNG.quantize.stats(a, et.i0, et.i1), et.est = UPNG.quantize.estats(et.bst);
    var it = { i0: st, i1: rt.i1, bst: null, est: null, tdst: 0, left: null, right: null };
    it.bst = { R: [], m: [], N: rt.bst.N - et.bst.N };
    for (var ot = 0; ot < 16; ot++)
      it.bst.R[ot] = rt.bst.R[ot] - et.bst.R[ot];
    for (var ot = 0; ot < 4; ot++)
      it.bst.m[ot] = rt.bst.m[ot] - et.bst.m[ot];
    it.est = UPNG.quantize.estats(it.bst), rt.left = et, rt.right = it, tt[at] = et, tt.push(it);
  }
  tt.sort(function(ut, ft) {
    return ft.bst.N - ut.bst.N;
  });
  for (var ot = 0; ot < tt.length; ot++)
    tt[ot].ind = ot;
  return [_e, tt];
};
UPNG.quantize.getNearest = function(a, s, $, _, _e) {
  if (a.left == null)
    return a.tdst = UPNG.quantize.dist(a.est.q, s, $, _, _e), a;
  var tt = UPNG.quantize.planeDst(a.est, s, $, _, _e), nt = a.left, at = a.right;
  tt > 0 && (nt = a.right, at = a.left);
  var ot = UPNG.quantize.getNearest(nt, s, $, _, _e);
  if (ot.tdst <= tt * tt)
    return ot;
  var rt = UPNG.quantize.getNearest(at, s, $, _, _e);
  return rt.tdst < ot.tdst ? rt : ot;
};
UPNG.quantize.planeDst = function(a, s, $, _, _e) {
  var tt = a.e;
  return tt[0] * s + tt[1] * $ + tt[2] * _ + tt[3] * _e - a.eMq;
};
UPNG.quantize.dist = function(a, s, $, _, _e) {
  var tt = s - a[0], nt = $ - a[1], at = _ - a[2], ot = _e - a[3];
  return tt * tt + nt * nt + at * at + ot * ot;
};
UPNG.quantize.splitPixels = function(a, s, $, _, _e, tt) {
  var nt = UPNG.quantize.vecDot;
  for (_ -= 4; $ < _; ) {
    for (; nt(a, $, _e) <= tt; )
      $ += 4;
    for (; nt(a, _, _e) > tt; )
      _ -= 4;
    if ($ >= _)
      break;
    var at = s[$ >> 2];
    s[$ >> 2] = s[_ >> 2], s[_ >> 2] = at, $ += 4, _ -= 4;
  }
  for (; nt(a, $, _e) > tt; )
    $ -= 4;
  return $ + 4;
};
UPNG.quantize.vecDot = function(a, s, $) {
  return a[s] * $[0] + a[s + 1] * $[1] + a[s + 2] * $[2] + a[s + 3] * $[3];
};
UPNG.quantize.stats = function(a, s, $) {
  for (var _ = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], _e = [0, 0, 0, 0], tt = $ - s >> 2, nt = s; nt < $; nt += 4) {
    var at = a[nt] * 0.00392156862745098, ot = a[nt + 1] * (1 / 255), rt = a[nt + 2] * (1 / 255), st = a[nt + 3] * (1 / 255);
    _e[0] += at, _e[1] += ot, _e[2] += rt, _e[3] += st, _[0] += at * at, _[1] += at * ot, _[2] += at * rt, _[3] += at * st, _[5] += ot * ot, _[6] += ot * rt, _[7] += ot * st, _[10] += rt * rt, _[11] += rt * st, _[15] += st * st;
  }
  return _[4] = _[1], _[8] = _[2], _[9] = _[6], _[12] = _[3], _[13] = _[7], _[14] = _[11], { R: _, m: _e, N: tt };
};
UPNG.quantize.estats = function(a) {
  var s = a.R, $ = a.m, _ = a.N, _e = $[0], tt = $[1], nt = $[2], at = $[3], ot = _ == 0 ? 0 : 1 / _, rt = [
    s[0] - _e * _e * ot,
    s[1] - _e * tt * ot,
    s[2] - _e * nt * ot,
    s[3] - _e * at * ot,
    s[4] - tt * _e * ot,
    s[5] - tt * tt * ot,
    s[6] - tt * nt * ot,
    s[7] - tt * at * ot,
    s[8] - nt * _e * ot,
    s[9] - nt * tt * ot,
    s[10] - nt * nt * ot,
    s[11] - nt * at * ot,
    s[12] - at * _e * ot,
    s[13] - at * tt * ot,
    s[14] - at * nt * ot,
    s[15] - at * at * ot
  ], st = rt, lt = UPNG.M4, et = [0.5, 0.5, 0.5, 0.5], it = 0, ut = 0;
  if (_ != 0)
    for (var ft = 0; ft < 10 && (et = lt.multVec(st, et), ut = Math.sqrt(lt.dot(et, et)), et = lt.sml(1 / ut, et), !(Math.abs(ut - it) < 1e-9)); ft++)
      it = ut;
  var ht = [_e * ot, tt * ot, nt * ot, at * ot], dt = lt.dot(lt.sml(255, ht), et);
  return {
    Cov: rt,
    q: ht,
    e: et,
    L: it,
    eMq255: dt,
    eMq: lt.dot(et, ht),
    rgba: (Math.round(255 * ht[3]) << 24 | Math.round(255 * ht[2]) << 16 | Math.round(255 * ht[1]) << 8 | Math.round(255 * ht[0]) << 0) >>> 0
  };
};
UPNG.M4 = {
  multVec: function(a, s) {
    return [
      a[0] * s[0] + a[1] * s[1] + a[2] * s[2] + a[3] * s[3],
      a[4] * s[0] + a[5] * s[1] + a[6] * s[2] + a[7] * s[3],
      a[8] * s[0] + a[9] * s[1] + a[10] * s[2] + a[11] * s[3],
      a[12] * s[0] + a[13] * s[1] + a[14] * s[2] + a[15] * s[3]
    ];
  },
  dot: function(a, s) {
    return a[0] * s[0] + a[1] * s[1] + a[2] * s[2] + a[3] * s[3];
  },
  sml: function(a, s) {
    return [a * s[0], a * s[1], a * s[2], a * s[3]];
  }
};
UPNG.encode.concatRGBA = function(a) {
  for (var s = 0, $ = 0; $ < a.length; $++)
    s += a[$].byteLength;
  for (var _ = new Uint8Array(s), _e = 0, $ = 0; $ < a.length; $++) {
    for (var tt = new Uint8Array(a[$]), nt = tt.length, at = 0; at < nt; at += 4) {
      var ot = tt[at], rt = tt[at + 1], st = tt[at + 2], lt = tt[at + 3];
      lt == 0 && (ot = rt = st = 0), _[_e + at] = ot, _[_e + at + 1] = rt, _[_e + at + 2] = st, _[_e + at + 3] = lt;
    }
    _e += nt;
  }
  return _.buffer;
};
var PngType;
(function(a) {
  a.Greyscale = "Greyscale", a.Truecolour = "Truecolour", a.IndexedColour = "IndexedColour", a.GreyscaleWithAlpha = "GreyscaleWithAlpha", a.TruecolourWithAlpha = "TruecolourWithAlpha";
})(PngType || (PngType = {}));
const asEnum = (a, s) => {
  if (a !== void 0)
    return s[a];
};
var NonFullScreenPageMode;
(function(a) {
  a.UseNone = "UseNone", a.UseOutlines = "UseOutlines", a.UseThumbs = "UseThumbs", a.UseOC = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(a) {
  a.L2R = "L2R", a.R2L = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(a) {
  a.None = "None", a.AppDefault = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(a) {
  a.Simplex = "Simplex", a.DuplexFlipShortEdge = "DuplexFlipShortEdge", a.DuplexFlipLongEdge = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
class ViewerPreferences {
  /** @ignore */
  constructor(s) {
    this.dict = s;
  }
  lookupBool(s) {
    const $ = this.dict.lookup(PDFName.of(s));
    if ($ instanceof PDFBool)
      return $;
  }
  lookupName(s) {
    const $ = this.dict.lookup(PDFName.of(s));
    if ($ instanceof PDFName)
      return $;
  }
  /** @ignore */
  HideToolbar() {
    return this.lookupBool("HideToolbar");
  }
  /** @ignore */
  HideMenubar() {
    return this.lookupBool("HideMenubar");
  }
  /** @ignore */
  HideWindowUI() {
    return this.lookupBool("HideWindowUI");
  }
  /** @ignore */
  FitWindow() {
    return this.lookupBool("FitWindow");
  }
  /** @ignore */
  CenterWindow() {
    return this.lookupBool("CenterWindow");
  }
  /** @ignore */
  DisplayDocTitle() {
    return this.lookupBool("DisplayDocTitle");
  }
  /** @ignore */
  NonFullScreenPageMode() {
    return this.lookupName("NonFullScreenPageMode");
  }
  /** @ignore */
  Direction() {
    return this.lookupName("Direction");
  }
  /** @ignore */
  PrintScaling() {
    return this.lookupName("PrintScaling");
  }
  /** @ignore */
  Duplex() {
    return this.lookupName("Duplex");
  }
  /** @ignore */
  PickTrayByPDFSize() {
    return this.lookupBool("PickTrayByPDFSize");
  }
  /** @ignore */
  PrintPageRange() {
    const s = this.dict.lookup(PDFName.of("PrintPageRange"));
    if (s instanceof PDFArray)
      return s;
  }
  /** @ignore */
  NumCopies() {
    const s = this.dict.lookup(PDFName.of("NumCopies"));
    if (s instanceof PDFNumber)
      return s;
  }
  /**
   * Returns `true` if PDF readers should hide the toolbar menus when displaying
   * this document.
   * @returns Whether or not toolbars should be hidden.
   */
  getHideToolbar() {
    var s, $;
    return ($ = (s = this.HideToolbar()) === null || s === void 0 ? void 0 : s.asBoolean()) !== null && $ !== void 0 ? $ : !1;
  }
  /**
   * Returns `true` if PDF readers should hide the menu bar when displaying this
   * document.
   * @returns Whether or not the menu bar should be hidden.
   */
  getHideMenubar() {
    var s, $;
    return ($ = (s = this.HideMenubar()) === null || s === void 0 ? void 0 : s.asBoolean()) !== null && $ !== void 0 ? $ : !1;
  }
  /**
   * Returns `true` if PDF readers should hide the user interface elements in
   * the document's window (such as scroll bars and navigation controls),
   * leaving only the document's contents displayed.
   * @returns Whether or not user interface elements should be hidden.
   */
  getHideWindowUI() {
    var s, $;
    return ($ = (s = this.HideWindowUI()) === null || s === void 0 ? void 0 : s.asBoolean()) !== null && $ !== void 0 ? $ : !1;
  }
  /**
   * Returns `true` if PDF readers should resize the document's window to fit
   * the size of the first displayed page.
   * @returns Whether or not the window should be resized to fit.
   */
  getFitWindow() {
    var s, $;
    return ($ = (s = this.FitWindow()) === null || s === void 0 ? void 0 : s.asBoolean()) !== null && $ !== void 0 ? $ : !1;
  }
  /**
   * Returns `true` if PDF readers should position the document's window in the
   * center of the screen.
   * @returns Whether or not to center the document window.
   */
  getCenterWindow() {
    var s, $;
    return ($ = (s = this.CenterWindow()) === null || s === void 0 ? void 0 : s.asBoolean()) !== null && $ !== void 0 ? $ : !1;
  }
  /**
   * Returns `true` if the window's title bar should display the document
   * `Title`, taken from the document metadata (see [[PDFDocument.getTitle]]).
   * Returns `false` if the title bar should instead display the filename of the
   * PDF file.
   * @returns Whether to display the document title.
   */
  getDisplayDocTitle() {
    var s, $;
    return ($ = (s = this.DisplayDocTitle()) === null || s === void 0 ? void 0 : s.asBoolean()) !== null && $ !== void 0 ? $ : !1;
  }
  /**
   * Returns the page mode, which tells the PDF reader how to display the
   * document after exiting full-screen mode.
   * @returns The page mode after exiting full-screen mode.
   */
  getNonFullScreenPageMode() {
    var s, $;
    const _ = (s = this.NonFullScreenPageMode()) === null || s === void 0 ? void 0 : s.decodeText();
    return ($ = asEnum(_, NonFullScreenPageMode)) !== null && $ !== void 0 ? $ : NonFullScreenPageMode.UseNone;
  }
  /**
   * Returns the predominant reading order for text.
   * @returns The text reading order.
   */
  getReadingDirection() {
    var s, $;
    const _ = (s = this.Direction()) === null || s === void 0 ? void 0 : s.decodeText();
    return ($ = asEnum(_, ReadingDirection)) !== null && $ !== void 0 ? $ : ReadingDirection.L2R;
  }
  /**
   * Returns the page scaling option that the PDF reader should select when the
   * print dialog is displayed.
   * @returns The page scaling option.
   */
  getPrintScaling() {
    var s, $;
    const _ = (s = this.PrintScaling()) === null || s === void 0 ? void 0 : s.decodeText();
    return ($ = asEnum(_, PrintScaling)) !== null && $ !== void 0 ? $ : PrintScaling.AppDefault;
  }
  /**
   * Returns the paper handling option that should be used when printing the
   * file from the print dialog.
   * @returns The paper handling option.
   */
  getDuplex() {
    var s;
    const $ = (s = this.Duplex()) === null || s === void 0 ? void 0 : s.decodeText();
    return asEnum($, Duplex);
  }
  /**
   * Returns `true` if the PDF page size should be used to select the input
   * paper tray.
   * @returns Whether or not the PDF page size should be used to select the
   *          input paper tray.
   */
  getPickTrayByPDFSize() {
    var s;
    return (s = this.PickTrayByPDFSize()) === null || s === void 0 ? void 0 : s.asBoolean();
  }
  /**
   * Returns an array of page number ranges, which are the values used to
   * initialize the print dialog box when the file is printed. Each range
   * specifies the first (`start`) and last (`end`) pages in a sub-range of
   * pages to be printed. The first page of the PDF file is denoted by 0.
   * For example:
   * ```js
   * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
   * const includesPage3 = viewerPrefs
   *   .getPrintRanges()
   *   .some(pr => pr.start =< 2 && pr.end >= 2)
   * if (includesPage3) console.log('printRange includes page 3')
   * ```
   * @returns An array of objects, each with the properties `start` and `end`,
   *          denoting page indices. If not, specified an empty array is
   *          returned.
   */
  getPrintPageRange() {
    const s = this.PrintPageRange();
    if (!s)
      return [];
    const $ = [];
    for (let _ = 0; _ < s.size(); _ += 2) {
      const _e = s.lookup(_, PDFNumber).asNumber(), tt = s.lookup(_ + 1, PDFNumber).asNumber();
      $.push({ start: _e, end: tt });
    }
    return $;
  }
  /**
   * Returns the number of copies to be printed when the print dialog is opened
   * for this document.
   * @returns The default number of copies to be printed.
   */
  getNumCopies() {
    var s, $;
    return ($ = (s = this.NumCopies()) === null || s === void 0 ? void 0 : s.asNumber()) !== null && $ !== void 0 ? $ : 1;
  }
  /**
   * Choose whether the PDF reader's toolbars should be hidden while the
   * document is active.
   * @param hideToolbar `true` if the toolbar should be hidden.
   */
  setHideToolbar(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("HideToolbar"), $);
  }
  /**
   * Choose whether the PDF reader's menu bar should be hidden while the
   * document is active.
   * @param hideMenubar `true` if the menu bar should be hidden.
   */
  setHideMenubar(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("HideMenubar"), $);
  }
  /**
   * Choose whether the PDF reader should hide user interface elements in the
   * document's window (such as scroll bars and navigation controls), leaving
   * only the document's contents displayed.
   * @param hideWindowUI `true` if the user interface elements should be hidden.
   */
  setHideWindowUI(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("HideWindowUI"), $);
  }
  /**
   * Choose whether the PDF reader should resize the document's window to fit
   * the size of the first displayed page.
   * @param fitWindow `true` if the window should be resized.
   */
  setFitWindow(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("FitWindow"), $);
  }
  /**
   * Choose whether the PDF reader should position the document's window in the
   * center of the screen.
   * @param centerWindow `true` if the window should be centered.
   */
  setCenterWindow(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("CenterWindow"), $);
  }
  /**
   * Choose whether the window's title bar should display the document `Title`
   * taken from the document metadata (see [[PDFDocument.setTitle]]). If
   * `false`, the title bar should instead display the PDF filename.
   * @param displayTitle `true` if the document title should be displayed.
   */
  setDisplayDocTitle(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("DisplayDocTitle"), $);
  }
  /**
   * Choose how the PDF reader should display the document upon exiting
   * full-screen mode. This entry is meaningful only if the value of the
   * `PageMode` entry in the document's [[PDFCatalog]] is `FullScreen`.
   *
   * For example:
   * ```js
   * import { PDFDocument, NonFullScreenPageMode, PDFName } from 'pdf-lib'
   *
   * const pdfDoc = await PDFDocument.create()
   *
   * // Set the PageMode
   * pdfDoc.catalog.set(PDFName.of('PageMode'),PDFName.of('FullScreen'))
   *
   * // Set what happens when full-screen is closed
   * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
   * viewerPrefs.setNonFullScreenPageMode(NonFullScreenPageMode.UseOutlines)
   * ```
   *
   * @param nonFullScreenPageMode How the document should be displayed upon
   *                              exiting full screen mode.
   */
  setNonFullScreenPageMode(s) {
    assertIsOneOf(s, "nonFullScreenPageMode", NonFullScreenPageMode);
    const $ = PDFName.of(s);
    this.dict.set(PDFName.of("NonFullScreenPageMode"), $);
  }
  /**
   * Choose the predominant reading order for text.
   *
   * This entry has no direct effect on the document's contents or page
   * numbering, but may be used to determine the relative positioning of pages
   * when displayed side by side or printed n-up.
   *
   * For example:
   * ```js
   * import { PDFDocument, ReadingDirection } from 'pdf-lib'
   *
   * const pdfDoc = await PDFDocument.create()
   * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
   * viewerPrefs.setReadingDirection(ReadingDirection.R2L)
   * ```
   *
   * @param readingDirection The reading order for text.
   */
  setReadingDirection(s) {
    assertIsOneOf(s, "readingDirection", ReadingDirection);
    const $ = PDFName.of(s);
    this.dict.set(PDFName.of("Direction"), $);
  }
  /**
   * Choose the page scaling option that should be selected when a print dialog
   * is displayed for this document.
   *
   * For example:
   * ```js
   * import { PDFDocument, PrintScaling } from 'pdf-lib'
   *
   * const pdfDoc = await PDFDocument.create()
   * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
   * viewerPrefs.setPrintScaling(PrintScaling.None)
   * ```
   *
   * @param printScaling The print scaling option.
   */
  setPrintScaling(s) {
    assertIsOneOf(s, "printScaling", PrintScaling);
    const $ = PDFName.of(s);
    this.dict.set(PDFName.of("PrintScaling"), $);
  }
  /**
   * Choose the paper handling option that should be selected by default in the
   * print dialog.
   *
   * For example:
   * ```js
   * import { PDFDocument, Duplex } from 'pdf-lib'
   *
   * const pdfDoc = await PDFDocument.create()
   * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
   * viewerPrefs.setDuplex(Duplex.DuplexFlipShortEdge)
   * ```
   *
   * @param duplex The double or single sided printing option.
   */
  setDuplex(s) {
    assertIsOneOf(s, "duplex", Duplex);
    const $ = PDFName.of(s);
    this.dict.set(PDFName.of("Duplex"), $);
  }
  /**
   * Choose whether the PDF document's page size should be used to select the
   * input paper tray when printing. This setting influences only the preset
   * values used to populate the print dialog presented by a PDF reader.
   *
   * If PickTrayByPDFSize is true, the check box in the print dialog associated
   * with input paper tray should be checked. This setting has no effect on
   * operating systems that do not provide the ability to pick the input tray
   * by size.
   *
   * @param pickTrayByPDFSize `true` if the document's page size should be used
   *                          to select the input paper tray.
   */
  setPickTrayByPDFSize(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("PickTrayByPDFSize"), $);
  }
  /**
   * Choose the page numbers used to initialize the print dialog box when the
   * file is printed. The first page of the PDF file is denoted by 0.
   *
   * For example:
   * ```js
   * import { PDFDocument } from 'pdf-lib'
   *
   * const pdfDoc = await PDFDocument.create()
   * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
   *
   * // We can set the default print range to only the first page
   * viewerPrefs.setPrintPageRange({ start: 0, end: 0 })
   *
   * // Or we can supply noncontiguous ranges (e.g. pages 1, 3, and 5-7)
   * viewerPrefs.setPrintPageRange([
   *   { start: 0, end: 0 },
   *   { start: 2, end: 2 },
   *   { start: 4, end: 6 },
   * ])
   * ```
   *
   * @param printPageRange An object or array of objects, each with the
   *                       properties `start` and `end`, denoting a range of
   *                       page indices.
   */
  setPrintPageRange(s) {
    Array.isArray(s) || (s = [s]);
    const $ = [];
    for (let _e = 0, tt = s.length; _e < tt; _e++)
      $.push(s[_e].start), $.push(s[_e].end);
    assertEachIs($, "printPageRange", ["number"]);
    const _ = this.dict.context.obj($);
    this.dict.set(PDFName.of("PrintPageRange"), _);
  }
  /**
   * Choose the default number of copies to be printed when the print dialog is
   * opened for this file.
   * @param numCopies The default number of copies.
   */
  setNumCopies(s) {
    assertRange(s, "numCopies", 1, Number.MAX_VALUE), assertInteger(s, "numCopies");
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("NumCopies"), $);
  }
}
ViewerPreferences.fromDict = (a) => new ViewerPreferences(a);
ViewerPreferences.create = (a) => {
  const s = a.obj({});
  return new ViewerPreferences(s);
};
const tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
class PDFAcroField {
  constructor(s, $) {
    this.dict = s, this.ref = $;
  }
  T() {
    return this.dict.lookupMaybe(PDFName.of("T"), PDFString, PDFHexString);
  }
  Ff() {
    const s = this.getInheritableAttribute(PDFName.of("Ff"));
    return this.dict.context.lookupMaybe(s, PDFNumber);
  }
  V() {
    const s = this.getInheritableAttribute(PDFName.of("V"));
    return this.dict.context.lookup(s);
  }
  Kids() {
    return this.dict.lookupMaybe(PDFName.of("Kids"), PDFArray);
  }
  // Parent(): PDFDict | undefined {
  //   return this.dict.lookupMaybe(PDFName.of('Parent'), PDFDict);
  // }
  DA() {
    const s = this.dict.lookup(PDFName.of("DA"));
    if (s instanceof PDFString || s instanceof PDFHexString)
      return s;
  }
  setKids(s) {
    this.dict.set(PDFName.of("Kids"), this.dict.context.obj(s));
  }
  getParent() {
    const s = this.dict.get(PDFName.of("Parent"));
    if (s instanceof PDFRef) {
      const $ = this.dict.lookup(PDFName.of("Parent"), PDFDict);
      return new PDFAcroField($, s);
    }
  }
  setParent(s) {
    s ? this.dict.set(PDFName.of("Parent"), s) : this.dict.delete(PDFName.of("Parent"));
  }
  getFullyQualifiedName() {
    const s = this.getParent();
    return s ? `${s.getFullyQualifiedName()}.${this.getPartialName()}` : this.getPartialName();
  }
  getPartialName() {
    var s;
    return (s = this.T()) === null || s === void 0 ? void 0 : s.decodeText();
  }
  setPartialName(s) {
    s ? this.dict.set(PDFName.of("T"), PDFHexString.fromText(s)) : this.dict.delete(PDFName.of("T"));
  }
  setDefaultAppearance(s) {
    this.dict.set(PDFName.of("DA"), PDFString.of(s));
  }
  getDefaultAppearance() {
    const s = this.DA();
    return s instanceof PDFHexString ? s.decodeText() : s == null ? void 0 : s.asString();
  }
  setFontSize(s) {
    var $;
    const _ = ($ = this.getFullyQualifiedName()) !== null && $ !== void 0 ? $ : "", _e = this.getDefaultAppearance();
    if (!_e)
      throw new MissingDAEntryError(_);
    const tt = findLastMatch(_e, tfRegex);
    if (!tt.match)
      throw new MissingTfOperatorError(_);
    const nt = _e.slice(0, tt.pos - tt.match[0].length), at = tt.pos <= _e.length ? _e.slice(tt.pos) : "", ot = tt.match[1], rt = `${nt} /${ot} ${s} Tf ${at}`;
    this.setDefaultAppearance(rt);
  }
  getFlags() {
    var s, $;
    return ($ = (s = this.Ff()) === null || s === void 0 ? void 0 : s.asNumber()) !== null && $ !== void 0 ? $ : 0;
  }
  setFlags(s) {
    this.dict.set(PDFName.of("Ff"), PDFNumber.of(s));
  }
  hasFlag(s) {
    return (this.getFlags() & s) !== 0;
  }
  setFlag(s) {
    const $ = this.getFlags();
    this.setFlags($ | s);
  }
  clearFlag(s) {
    const $ = this.getFlags();
    this.setFlags($ & ~s);
  }
  setFlagTo(s, $) {
    $ ? this.setFlag(s) : this.clearFlag(s);
  }
  getInheritableAttribute(s) {
    let $;
    return this.ascend((_) => {
      $ || ($ = _.dict.get(s));
    }), $;
  }
  ascend(s) {
    s(this);
    const $ = this.getParent();
    $ && $.ascend(s);
  }
}
class BorderStyle {
  constructor(s) {
    this.dict = s;
  }
  W() {
    const s = this.dict.lookup(PDFName.of("W"));
    if (s instanceof PDFNumber)
      return s;
  }
  getWidth() {
    var s, $;
    return ($ = (s = this.W()) === null || s === void 0 ? void 0 : s.asNumber()) !== null && $ !== void 0 ? $ : 1;
  }
  setWidth(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("W"), $);
  }
}
BorderStyle.fromDict = (a) => new BorderStyle(a);
class PDFAnnotation {
  constructor(s) {
    this.dict = s;
  }
  // This is technically required by the PDF spec
  Rect() {
    return this.dict.lookup(PDFName.of("Rect"), PDFArray);
  }
  AP() {
    return this.dict.lookupMaybe(PDFName.of("AP"), PDFDict);
  }
  F() {
    const s = this.dict.lookup(PDFName.of("F"));
    return this.dict.context.lookupMaybe(s, PDFNumber);
  }
  getRectangle() {
    var s;
    const $ = this.Rect();
    return (s = $ == null ? void 0 : $.asRectangle()) !== null && s !== void 0 ? s : { x: 0, y: 0, width: 0, height: 0 };
  }
  setRectangle(s) {
    const { x: $, y: _, width: _e, height: tt } = s, nt = this.dict.context.obj([$, _, $ + _e, _ + tt]);
    this.dict.set(PDFName.of("Rect"), nt);
  }
  getAppearanceState() {
    const s = this.dict.lookup(PDFName.of("AS"));
    if (s instanceof PDFName)
      return s;
  }
  setAppearanceState(s) {
    this.dict.set(PDFName.of("AS"), s);
  }
  setAppearances(s) {
    this.dict.set(PDFName.of("AP"), s);
  }
  ensureAP() {
    let s = this.AP();
    return s || (s = this.dict.context.obj({}), this.dict.set(PDFName.of("AP"), s)), s;
  }
  getNormalAppearance() {
    const $ = this.ensureAP().get(PDFName.of("N"));
    if ($ instanceof PDFRef || $ instanceof PDFDict)
      return $;
    throw new Error(`Unexpected N type: ${$ == null ? void 0 : $.constructor.name}`);
  }
  /** @param appearance A PDFDict or PDFStream (direct or ref) */
  setNormalAppearance(s) {
    this.ensureAP().set(PDFName.of("N"), s);
  }
  /** @param appearance A PDFDict or PDFStream (direct or ref) */
  setRolloverAppearance(s) {
    this.ensureAP().set(PDFName.of("R"), s);
  }
  /** @param appearance A PDFDict or PDFStream (direct or ref) */
  setDownAppearance(s) {
    this.ensureAP().set(PDFName.of("D"), s);
  }
  removeRolloverAppearance() {
    const s = this.AP();
    s == null || s.delete(PDFName.of("R"));
  }
  removeDownAppearance() {
    const s = this.AP();
    s == null || s.delete(PDFName.of("D"));
  }
  getAppearances() {
    const s = this.AP();
    if (!s)
      return;
    const $ = s.lookup(PDFName.of("N"), PDFDict, PDFStream), _ = s.lookupMaybe(PDFName.of("R"), PDFDict, PDFStream), _e = s.lookupMaybe(PDFName.of("D"), PDFDict, PDFStream);
    return { normal: $, rollover: _, down: _e };
  }
  getFlags() {
    var s, $;
    return ($ = (s = this.F()) === null || s === void 0 ? void 0 : s.asNumber()) !== null && $ !== void 0 ? $ : 0;
  }
  setFlags(s) {
    this.dict.set(PDFName.of("F"), PDFNumber.of(s));
  }
  hasFlag(s) {
    return (this.getFlags() & s) !== 0;
  }
  setFlag(s) {
    const $ = this.getFlags();
    this.setFlags($ | s);
  }
  clearFlag(s) {
    const $ = this.getFlags();
    this.setFlags($ & ~s);
  }
  setFlagTo(s, $) {
    $ ? this.setFlag(s) : this.clearFlag(s);
  }
}
PDFAnnotation.fromDict = (a) => new PDFAnnotation(a);
class AppearanceCharacteristics {
  constructor(s) {
    this.dict = s;
  }
  R() {
    const s = this.dict.lookup(PDFName.of("R"));
    if (s instanceof PDFNumber)
      return s;
  }
  BC() {
    const s = this.dict.lookup(PDFName.of("BC"));
    if (s instanceof PDFArray)
      return s;
  }
  BG() {
    const s = this.dict.lookup(PDFName.of("BG"));
    if (s instanceof PDFArray)
      return s;
  }
  CA() {
    const s = this.dict.lookup(PDFName.of("CA"));
    if (s instanceof PDFHexString || s instanceof PDFString)
      return s;
  }
  RC() {
    const s = this.dict.lookup(PDFName.of("RC"));
    if (s instanceof PDFHexString || s instanceof PDFString)
      return s;
  }
  AC() {
    const s = this.dict.lookup(PDFName.of("AC"));
    if (s instanceof PDFHexString || s instanceof PDFString)
      return s;
  }
  getRotation() {
    var s;
    return (s = this.R()) === null || s === void 0 ? void 0 : s.asNumber();
  }
  getBorderColor() {
    const s = this.BC();
    if (!s)
      return;
    const $ = [];
    for (let _ = 0, _e = s == null ? void 0 : s.size(); _ < _e; _++) {
      const tt = s.get(_);
      tt instanceof PDFNumber && $.push(tt.asNumber());
    }
    return $;
  }
  getBackgroundColor() {
    const s = this.BG();
    if (!s)
      return;
    const $ = [];
    for (let _ = 0, _e = s == null ? void 0 : s.size(); _ < _e; _++) {
      const tt = s.get(_);
      tt instanceof PDFNumber && $.push(tt.asNumber());
    }
    return $;
  }
  getCaptions() {
    const s = this.CA(), $ = this.RC(), _ = this.AC();
    return {
      normal: s == null ? void 0 : s.decodeText(),
      rollover: $ == null ? void 0 : $.decodeText(),
      down: _ == null ? void 0 : _.decodeText()
    };
  }
  setRotation(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("R"), $);
  }
  setBorderColor(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("BC"), $);
  }
  setBackgroundColor(s) {
    const $ = this.dict.context.obj(s);
    this.dict.set(PDFName.of("BG"), $);
  }
  setCaptions(s) {
    const $ = PDFHexString.fromText(s.normal);
    if (this.dict.set(PDFName.of("CA"), $), s.rollover) {
      const _ = PDFHexString.fromText(s.rollover);
      this.dict.set(PDFName.of("RC"), _);
    } else
      this.dict.delete(PDFName.of("RC"));
    if (s.down) {
      const _ = PDFHexString.fromText(s.down);
      this.dict.set(PDFName.of("AC"), _);
    } else
      this.dict.delete(PDFName.of("AC"));
  }
}
AppearanceCharacteristics.fromDict = (a) => new AppearanceCharacteristics(a);
class PDFWidgetAnnotation extends PDFAnnotation {
  MK() {
    const s = this.dict.lookup(PDFName.of("MK"));
    if (s instanceof PDFDict)
      return s;
  }
  BS() {
    const s = this.dict.lookup(PDFName.of("BS"));
    if (s instanceof PDFDict)
      return s;
  }
  DA() {
    const s = this.dict.lookup(PDFName.of("DA"));
    if (s instanceof PDFString || s instanceof PDFHexString)
      return s;
  }
  P() {
    const s = this.dict.get(PDFName.of("P"));
    if (s instanceof PDFRef)
      return s;
  }
  setP(s) {
    this.dict.set(PDFName.of("P"), s);
  }
  setDefaultAppearance(s) {
    this.dict.set(PDFName.of("DA"), PDFString.of(s));
  }
  getDefaultAppearance() {
    const s = this.DA();
    return s instanceof PDFHexString ? s.decodeText() : s == null ? void 0 : s.asString();
  }
  getAppearanceCharacteristics() {
    const s = this.MK();
    if (s)
      return AppearanceCharacteristics.fromDict(s);
  }
  getOrCreateAppearanceCharacteristics() {
    const s = this.MK();
    if (s)
      return AppearanceCharacteristics.fromDict(s);
    const $ = AppearanceCharacteristics.fromDict(this.dict.context.obj({}));
    return this.dict.set(PDFName.of("MK"), $.dict), $;
  }
  getBorderStyle() {
    const s = this.BS();
    if (s)
      return BorderStyle.fromDict(s);
  }
  getOrCreateBorderStyle() {
    const s = this.BS();
    if (s)
      return BorderStyle.fromDict(s);
    const $ = BorderStyle.fromDict(this.dict.context.obj({}));
    return this.dict.set(PDFName.of("BS"), $.dict), $;
  }
  getOnValue() {
    var s;
    const $ = (s = this.getAppearances()) === null || s === void 0 ? void 0 : s.normal;
    if ($ instanceof PDFDict) {
      const _ = $.keys();
      for (let _e = 0, tt = _.length; _e < tt; _e++) {
        const nt = _[_e];
        if (nt !== PDFName.of("Off"))
          return nt;
      }
    }
  }
}
PDFWidgetAnnotation.fromDict = (a) => new PDFWidgetAnnotation(a);
PDFWidgetAnnotation.create = (a, s) => {
  const $ = a.obj({
    Type: "Annot",
    Subtype: "Widget",
    Rect: [0, 0, 0, 0],
    Parent: s
  });
  return new PDFWidgetAnnotation($);
};
class PDFAcroTerminal extends PDFAcroField {
  FT() {
    const s = this.getInheritableAttribute(PDFName.of("FT"));
    return this.dict.context.lookup(s, PDFName);
  }
  getWidgets() {
    const s = this.Kids();
    if (!s)
      return [PDFWidgetAnnotation.fromDict(this.dict)];
    const $ = new Array(s.size());
    for (let _ = 0, _e = s.size(); _ < _e; _++) {
      const tt = s.lookup(_, PDFDict);
      $[_] = PDFWidgetAnnotation.fromDict(tt);
    }
    return $;
  }
  addWidget(s) {
    const { Kids: $ } = this.normalizedEntries();
    $.push(s);
  }
  removeWidget(s) {
    const $ = this.Kids();
    if ($) {
      if (s < 0 || s > $.size())
        throw new IndexOutOfBoundsError(s, 0, $.size());
      $.remove(s);
    } else {
      if (s !== 0)
        throw new IndexOutOfBoundsError(s, 0, 0);
      this.setKids([]);
    }
  }
  normalizedEntries() {
    let s = this.Kids();
    return s || (s = this.dict.context.obj([this.ref]), this.dict.set(PDFName.of("Kids"), s)), { Kids: s };
  }
}
PDFAcroTerminal.fromDict = (a, s) => new PDFAcroTerminal(a, s);
class PDFAcroButton extends PDFAcroTerminal {
  Opt() {
    return this.dict.lookupMaybe(PDFName.of("Opt"), PDFString, PDFHexString, PDFArray);
  }
  setOpt(s) {
    this.dict.set(PDFName.of("Opt"), this.dict.context.obj(s));
  }
  getExportValues() {
    const s = this.Opt();
    if (!s)
      return;
    if (s instanceof PDFString || s instanceof PDFHexString)
      return [s];
    const $ = [];
    for (let _ = 0, _e = s.size(); _ < _e; _++) {
      const tt = s.lookup(_);
      (tt instanceof PDFString || tt instanceof PDFHexString) && $.push(tt);
    }
    return $;
  }
  removeExportValue(s) {
    const $ = this.Opt();
    if ($)
      if ($ instanceof PDFString || $ instanceof PDFHexString) {
        if (s !== 0)
          throw new IndexOutOfBoundsError(s, 0, 0);
        this.setOpt([]);
      } else {
        if (s < 0 || s > $.size())
          throw new IndexOutOfBoundsError(s, 0, $.size());
        $.remove(s);
      }
  }
  // Enforce use use of /Opt even if it isn't strictly necessary
  normalizeExportValues() {
    var s, $, _, _e;
    const tt = (s = this.getExportValues()) !== null && s !== void 0 ? s : [], nt = [], at = this.getWidgets();
    for (let ot = 0, rt = at.length; ot < rt; ot++) {
      const st = at[ot], lt = ($ = tt[ot]) !== null && $ !== void 0 ? $ : PDFHexString.fromText((_e = (_ = st.getOnValue()) === null || _ === void 0 ? void 0 : _.decodeText()) !== null && _e !== void 0 ? _e : "");
      nt.push(lt);
    }
    this.setOpt(nt);
  }
  /**
   * Reuses existing opt if one exists with the same value (assuming
   * `useExistingIdx` is `true`). Returns index of existing (or new) opt.
   */
  addOpt(s, $) {
    var _;
    this.normalizeExportValues();
    const _e = s.decodeText();
    let tt;
    if ($) {
      const at = (_ = this.getExportValues()) !== null && _ !== void 0 ? _ : [];
      for (let ot = 0, rt = at.length; ot < rt; ot++)
        at[ot].decodeText() === _e && (tt = ot);
    }
    const nt = this.Opt();
    return nt.push(s), tt ?? nt.size() - 1;
  }
  addWidgetWithOpt(s, $, _) {
    const _e = this.addOpt($, _), tt = PDFName.of(String(_e));
    return this.addWidget(s), tt;
  }
}
class PDFAcroCheckBox extends PDFAcroButton {
  setValue(s) {
    var $;
    const _ = ($ = this.getOnValue()) !== null && $ !== void 0 ? $ : PDFName.of("Yes");
    if (s !== _ && s !== PDFName.of("Off"))
      throw new InvalidAcroFieldValueError();
    this.dict.set(PDFName.of("V"), s);
    const _e = this.getWidgets();
    for (let tt = 0, nt = _e.length; tt < nt; tt++) {
      const at = _e[tt], ot = at.getOnValue() === s ? s : PDFName.of("Off");
      at.setAppearanceState(ot);
    }
  }
  getValue() {
    const s = this.V();
    return s instanceof PDFName ? s : PDFName.of("Off");
  }
  getOnValue() {
    const [s] = this.getWidgets();
    return s == null ? void 0 : s.getOnValue();
  }
}
PDFAcroCheckBox.fromDict = (a, s) => new PDFAcroCheckBox(a, s);
PDFAcroCheckBox.create = (a) => {
  const s = a.obj({
    FT: "Btn",
    Kids: []
  }), $ = a.register(s);
  return new PDFAcroCheckBox(s, $);
};
const flag$1 = (a) => 1 << a;
var AcroFieldFlags;
(function(a) {
  a[a.ReadOnly = flag$1(0)] = "ReadOnly", a[a.Required = flag$1(1)] = "Required", a[a.NoExport = flag$1(2)] = "NoExport";
})(AcroFieldFlags || (AcroFieldFlags = {}));
var AcroButtonFlags;
(function(a) {
  a[a.NoToggleToOff = flag$1(14)] = "NoToggleToOff", a[a.Radio = flag$1(15)] = "Radio", a[a.PushButton = flag$1(16)] = "PushButton", a[a.RadiosInUnison = flag$1(25)] = "RadiosInUnison";
})(AcroButtonFlags || (AcroButtonFlags = {}));
var AcroTextFlags;
(function(a) {
  a[a.Multiline = flag$1(12)] = "Multiline", a[a.Password = flag$1(13)] = "Password", a[a.FileSelect = flag$1(20)] = "FileSelect", a[a.DoNotSpellCheck = flag$1(22)] = "DoNotSpellCheck", a[a.DoNotScroll = flag$1(23)] = "DoNotScroll", a[a.Comb = flag$1(24)] = "Comb", a[a.RichText = flag$1(25)] = "RichText";
})(AcroTextFlags || (AcroTextFlags = {}));
var AcroChoiceFlags;
(function(a) {
  a[a.Combo = flag$1(17)] = "Combo", a[a.Edit = flag$1(18)] = "Edit", a[a.Sort = flag$1(19)] = "Sort", a[a.MultiSelect = flag$1(21)] = "MultiSelect", a[a.DoNotSpellCheck = flag$1(22)] = "DoNotSpellCheck", a[a.CommitOnSelChange = flag$1(26)] = "CommitOnSelChange";
})(AcroChoiceFlags || (AcroChoiceFlags = {}));
class PDFAcroChoice extends PDFAcroTerminal {
  setValues(s) {
    if (this.hasFlag(AcroChoiceFlags.Combo) && !this.hasFlag(AcroChoiceFlags.Edit) && !this.valuesAreValid(s))
      throw new InvalidAcroFieldValueError();
    if (s.length === 0 && this.dict.delete(PDFName.of("V")), s.length === 1 && this.dict.set(PDFName.of("V"), s[0]), s.length > 1) {
      if (!this.hasFlag(AcroChoiceFlags.MultiSelect))
        throw new MultiSelectValueError();
      this.dict.set(PDFName.of("V"), this.dict.context.obj(s));
    }
    this.updateSelectedIndices(s);
  }
  valuesAreValid(s) {
    const $ = this.getOptions();
    for (let _ = 0, _e = s.length; _ < _e; _++) {
      const tt = s[_].decodeText();
      if (!$.find((nt) => tt === (nt.display || nt.value).decodeText()))
        return !1;
    }
    return !0;
  }
  updateSelectedIndices(s) {
    if (s.length > 1) {
      const $ = new Array(s.length), _ = this.getOptions();
      for (let _e = 0, tt = s.length; _e < tt; _e++) {
        const nt = s[_e].decodeText();
        $[_e] = _.findIndex((at) => nt === (at.display || at.value).decodeText());
      }
      this.dict.set(PDFName.of("I"), this.dict.context.obj($.sort()));
    } else
      this.dict.delete(PDFName.of("I"));
  }
  getValues() {
    const s = this.V();
    if (s instanceof PDFString || s instanceof PDFHexString)
      return [s];
    if (s instanceof PDFArray) {
      const $ = [];
      for (let _ = 0, _e = s.size(); _ < _e; _++) {
        const tt = s.lookup(_);
        (tt instanceof PDFString || tt instanceof PDFHexString) && $.push(tt);
      }
      return $;
    }
    return [];
  }
  Opt() {
    return this.dict.lookupMaybe(PDFName.of("Opt"), PDFString, PDFHexString, PDFArray);
  }
  setOptions(s) {
    const $ = new Array(s.length);
    for (let _ = 0, _e = s.length; _ < _e; _++) {
      const { value: tt, display: nt } = s[_];
      $[_] = this.dict.context.obj([tt, nt || tt]);
    }
    this.dict.set(PDFName.of("Opt"), this.dict.context.obj($));
  }
  getOptions() {
    const s = this.Opt();
    if (s instanceof PDFString || s instanceof PDFHexString)
      return [{ value: s, display: s }];
    if (s instanceof PDFArray) {
      const $ = [];
      for (let _ = 0, _e = s.size(); _ < _e; _++) {
        const tt = s.lookup(_);
        if ((tt instanceof PDFString || tt instanceof PDFHexString) && $.push({ value: tt, display: tt }), tt instanceof PDFArray && tt.size() > 0) {
          const nt = tt.lookup(0, PDFString, PDFHexString), at = tt.lookupMaybe(1, PDFString, PDFHexString);
          $.push({ value: nt, display: at || nt });
        }
      }
      return $;
    }
    return [];
  }
}
class PDFAcroComboBox extends PDFAcroChoice {
}
PDFAcroComboBox.fromDict = (a, s) => new PDFAcroComboBox(a, s);
PDFAcroComboBox.create = (a) => {
  const s = a.obj({
    FT: "Ch",
    Ff: AcroChoiceFlags.Combo,
    Kids: []
  }), $ = a.register(s);
  return new PDFAcroComboBox(s, $);
};
class PDFAcroNonTerminal extends PDFAcroField {
  addField(s) {
    const { Kids: $ } = this.normalizedEntries();
    $ == null || $.push(s);
  }
  normalizedEntries() {
    let s = this.Kids();
    return s || (s = this.dict.context.obj([]), this.dict.set(PDFName.of("Kids"), s)), { Kids: s };
  }
}
PDFAcroNonTerminal.fromDict = (a, s) => new PDFAcroNonTerminal(a, s);
PDFAcroNonTerminal.create = (a) => {
  const s = a.obj({}), $ = a.register(s);
  return new PDFAcroNonTerminal(s, $);
};
class PDFAcroSignature extends PDFAcroTerminal {
}
PDFAcroSignature.fromDict = (a, s) => new PDFAcroSignature(a, s);
class PDFAcroText extends PDFAcroTerminal {
  MaxLen() {
    const s = this.dict.lookup(PDFName.of("MaxLen"));
    if (s instanceof PDFNumber)
      return s;
  }
  Q() {
    const s = this.dict.lookup(PDFName.of("Q"));
    if (s instanceof PDFNumber)
      return s;
  }
  setMaxLength(s) {
    this.dict.set(PDFName.of("MaxLen"), PDFNumber.of(s));
  }
  removeMaxLength() {
    this.dict.delete(PDFName.of("MaxLen"));
  }
  getMaxLength() {
    var s;
    return (s = this.MaxLen()) === null || s === void 0 ? void 0 : s.asNumber();
  }
  setQuadding(s) {
    this.dict.set(PDFName.of("Q"), PDFNumber.of(s));
  }
  getQuadding() {
    var s;
    return (s = this.Q()) === null || s === void 0 ? void 0 : s.asNumber();
  }
  setValue(s) {
    this.dict.set(PDFName.of("V"), s);
  }
  removeValue() {
    this.dict.delete(PDFName.of("V"));
  }
  getValue() {
    const s = this.V();
    if (s instanceof PDFString || s instanceof PDFHexString)
      return s;
  }
}
PDFAcroText.fromDict = (a, s) => new PDFAcroText(a, s);
PDFAcroText.create = (a) => {
  const s = a.obj({
    FT: "Tx",
    Kids: []
  }), $ = a.register(s);
  return new PDFAcroText(s, $);
};
class PDFAcroPushButton extends PDFAcroButton {
}
PDFAcroPushButton.fromDict = (a, s) => new PDFAcroPushButton(a, s);
PDFAcroPushButton.create = (a) => {
  const s = a.obj({
    FT: "Btn",
    Ff: AcroButtonFlags.PushButton,
    Kids: []
  }), $ = a.register(s);
  return new PDFAcroPushButton(s, $);
};
class PDFAcroRadioButton extends PDFAcroButton {
  setValue(s) {
    if (!this.getOnValues().includes(s) && s !== PDFName.of("Off"))
      throw new InvalidAcroFieldValueError();
    this.dict.set(PDFName.of("V"), s);
    const _ = this.getWidgets();
    for (let _e = 0, tt = _.length; _e < tt; _e++) {
      const nt = _[_e], at = nt.getOnValue() === s ? s : PDFName.of("Off");
      nt.setAppearanceState(at);
    }
  }
  getValue() {
    const s = this.V();
    return s instanceof PDFName ? s : PDFName.of("Off");
  }
  getOnValues() {
    const s = this.getWidgets(), $ = [];
    for (let _ = 0, _e = s.length; _ < _e; _++) {
      const tt = s[_].getOnValue();
      tt && $.push(tt);
    }
    return $;
  }
}
PDFAcroRadioButton.fromDict = (a, s) => new PDFAcroRadioButton(a, s);
PDFAcroRadioButton.create = (a) => {
  const s = a.obj({
    FT: "Btn",
    Ff: AcroButtonFlags.Radio,
    Kids: []
  }), $ = a.register(s);
  return new PDFAcroRadioButton(s, $);
};
class PDFAcroListBox extends PDFAcroChoice {
}
PDFAcroListBox.fromDict = (a, s) => new PDFAcroListBox(a, s);
PDFAcroListBox.create = (a) => {
  const s = a.obj({
    FT: "Ch",
    Kids: []
  }), $ = a.register(s);
  return new PDFAcroListBox(s, $);
};
const createPDFAcroFields = (a) => {
  if (!a)
    return [];
  const s = [];
  for (let $ = 0, _ = a.size(); $ < _; $++) {
    const _e = a.get($), tt = a.lookup($);
    _e instanceof PDFRef && tt instanceof PDFDict && s.push([createPDFAcroField(tt, _e), _e]);
  }
  return s;
}, createPDFAcroField = (a, s) => isNonTerminalAcroField(a) ? PDFAcroNonTerminal.fromDict(a, s) : createPDFAcroTerminal(a, s), isNonTerminalAcroField = (a) => {
  const s = a.lookup(PDFName.of("Kids"));
  if (s instanceof PDFArray)
    for (let $ = 0, _ = s.size(); $ < _; $++) {
      const _e = s.lookup($);
      if (_e instanceof PDFDict && _e.has(PDFName.of("T")))
        return !0;
    }
  return !1;
}, createPDFAcroTerminal = (a, s) => {
  const $ = getInheritableAttribute(a, PDFName.of("FT")), _ = a.context.lookup($, PDFName);
  return _ === PDFName.of("Btn") ? createPDFAcroButton(a, s) : _ === PDFName.of("Ch") ? createPDFAcroChoice(a, s) : _ === PDFName.of("Tx") ? PDFAcroText.fromDict(a, s) : _ === PDFName.of("Sig") ? PDFAcroSignature.fromDict(a, s) : PDFAcroTerminal.fromDict(a, s);
}, createPDFAcroButton = (a, s) => {
  var $;
  const _ = getInheritableAttribute(a, PDFName.of("Ff")), _e = a.context.lookupMaybe(_, PDFNumber), tt = ($ = _e == null ? void 0 : _e.asNumber()) !== null && $ !== void 0 ? $ : 0;
  return flagIsSet(tt, AcroButtonFlags.PushButton) ? PDFAcroPushButton.fromDict(a, s) : flagIsSet(tt, AcroButtonFlags.Radio) ? PDFAcroRadioButton.fromDict(a, s) : PDFAcroCheckBox.fromDict(a, s);
}, createPDFAcroChoice = (a, s) => {
  var $;
  const _ = getInheritableAttribute(a, PDFName.of("Ff")), _e = a.context.lookupMaybe(_, PDFNumber), tt = ($ = _e == null ? void 0 : _e.asNumber()) !== null && $ !== void 0 ? $ : 0;
  return flagIsSet(tt, AcroChoiceFlags.Combo) ? PDFAcroComboBox.fromDict(a, s) : PDFAcroListBox.fromDict(a, s);
}, flagIsSet = (a, s) => (a & s) !== 0, getInheritableAttribute = (a, s) => {
  let $;
  return ascend(a, (_) => {
    $ || ($ = _.get(s));
  }), $;
}, ascend = (a, s) => {
  s(a);
  const $ = a.lookupMaybe(PDFName.of("Parent"), PDFDict);
  $ && ascend($, s);
};
class PDFAcroForm {
  constructor(s) {
    this.dict = s;
  }
  Fields() {
    const s = this.dict.lookup(PDFName.of("Fields"));
    if (s instanceof PDFArray)
      return s;
  }
  getFields() {
    const { Fields: s } = this.normalizedEntries(), $ = new Array(s.size());
    for (let _ = 0, _e = s.size(); _ < _e; _++) {
      const tt = s.get(_), nt = s.lookup(_, PDFDict);
      $[_] = [createPDFAcroField(nt, tt), tt];
    }
    return $;
  }
  getAllFields() {
    const s = [], $ = (_) => {
      if (_)
        for (let _e = 0, tt = _.length; _e < tt; _e++) {
          const nt = _[_e];
          s.push(nt);
          const [at] = nt;
          at instanceof PDFAcroNonTerminal && $(createPDFAcroFields(at.Kids()));
        }
    };
    return $(this.getFields()), s;
  }
  addField(s) {
    const { Fields: $ } = this.normalizedEntries();
    $ == null || $.push(s);
  }
  removeField(s) {
    const $ = s.getParent(), _ = $ === void 0 ? this.normalizedEntries().Fields : $.Kids(), _e = _ == null ? void 0 : _.indexOf(s.ref);
    if (_ === void 0 || _e === void 0)
      throw new Error(`Tried to remove inexistent field ${s.getFullyQualifiedName()}`);
    _.remove(_e), $ !== void 0 && _.size() === 0 && this.removeField($);
  }
  normalizedEntries() {
    let s = this.Fields();
    return s || (s = this.dict.context.obj([]), this.dict.set(PDFName.of("Fields"), s)), { Fields: s };
  }
}
PDFAcroForm.fromDict = (a) => new PDFAcroForm(a);
PDFAcroForm.create = (a) => {
  const s = a.obj({ Fields: [] });
  return new PDFAcroForm(s);
};
class PDFCatalog extends PDFDict {
  Pages() {
    return this.lookup(PDFName.of("Pages"), PDFDict);
  }
  AcroForm() {
    return this.lookupMaybe(PDFName.of("AcroForm"), PDFDict);
  }
  getAcroForm() {
    const s = this.AcroForm();
    if (s)
      return PDFAcroForm.fromDict(s);
  }
  getOrCreateAcroForm() {
    let s = this.getAcroForm();
    if (!s) {
      s = PDFAcroForm.create(this.context);
      const $ = this.context.register(s.dict);
      this.set(PDFName.of("AcroForm"), $);
    }
    return s;
  }
  ViewerPreferences() {
    return this.lookupMaybe(PDFName.of("ViewerPreferences"), PDFDict);
  }
  getViewerPreferences() {
    const s = this.ViewerPreferences();
    if (s)
      return ViewerPreferences.fromDict(s);
  }
  getOrCreateViewerPreferences() {
    let s = this.getViewerPreferences();
    if (!s) {
      s = ViewerPreferences.create(this.context);
      const $ = this.context.register(s.dict);
      this.set(PDFName.of("ViewerPreferences"), $);
    }
    return s;
  }
  /**
   * Inserts the given ref as a leaf node of this catalog's page tree at the
   * specified index (zero-based). Also increments the `Count` of each node in
   * the page tree hierarchy to accomodate the new page.
   *
   * Returns the ref of the PDFPageTree node into which `leafRef` was inserted.
   */
  insertLeafNode(s, $) {
    const _ = this.get(PDFName.of("Pages"));
    return this.Pages().insertLeafNode(s, $) || _;
  }
  removeLeafNode(s) {
    this.Pages().removeLeafNode(s);
  }
}
PDFCatalog.withContextAndPages = (a, s) => {
  const $ = /* @__PURE__ */ new Map();
  return $.set(PDFName.of("Type"), PDFName.of("Catalog")), $.set(PDFName.of("Pages"), s), new PDFCatalog($, a);
};
PDFCatalog.fromMapWithContext = (a, s) => new PDFCatalog(a, s);
class PDFPageTree extends PDFDict {
  Parent() {
    return this.lookup(PDFName.of("Parent"));
  }
  Kids() {
    return this.lookup(PDFName.of("Kids"), PDFArray);
  }
  Count() {
    return this.lookup(PDFName.of("Count"), PDFNumber);
  }
  pushTreeNode(s) {
    this.Kids().push(s);
  }
  pushLeafNode(s) {
    const $ = this.Kids();
    this.insertLeafKid($.size(), s);
  }
  /**
   * Inserts the given ref as a leaf node of this page tree at the specified
   * index (zero-based). Also increments the `Count` of each page tree in the
   * hierarchy to accomodate the new page.
   *
   * Returns the ref of the PDFPageTree node into which `leafRef` was inserted,
   * or `undefined` if it was inserted into the root node (the PDFPageTree upon
   * which the method was first called).
   */
  insertLeafNode(s, $) {
    const _ = this.Kids(), _e = this.Count().asNumber();
    if ($ > _e)
      throw new InvalidTargetIndexError($, _e);
    let tt = $;
    for (let nt = 0, at = _.size(); nt < at; nt++) {
      if (tt === 0) {
        this.insertLeafKid(nt, s);
        return;
      }
      const ot = _.get(nt), rt = this.context.lookup(ot);
      if (rt instanceof PDFPageTree) {
        if (rt.Count().asNumber() > tt)
          return rt.insertLeafNode(s, tt) || ot;
        tt -= rt.Count().asNumber();
      }
      rt instanceof PDFPageLeaf && (tt -= 1);
    }
    if (tt === 0) {
      this.insertLeafKid(_.size(), s);
      return;
    }
    throw new CorruptPageTreeError($, "insertLeafNode");
  }
  /**
   * Removes the leaf node at the specified index (zero-based) from this page
   * tree. Also decrements the `Count` of each page tree in the hierarchy to
   * account for the removed page.
   *
   * If `prune` is true, then intermediate tree nodes will be removed from the
   * tree if they contain 0 children after the leaf node is removed.
   */
  removeLeafNode(s, $ = !0) {
    const _ = this.Kids(), _e = this.Count().asNumber();
    if (s >= _e)
      throw new InvalidTargetIndexError(s, _e);
    let tt = s;
    for (let nt = 0, at = _.size(); nt < at; nt++) {
      const ot = _.get(nt), rt = this.context.lookup(ot);
      if (rt instanceof PDFPageTree)
        if (rt.Count().asNumber() > tt) {
          rt.removeLeafNode(tt, $), $ && rt.Kids().size() === 0 && _.remove(nt);
          return;
        } else
          tt -= rt.Count().asNumber();
      if (rt instanceof PDFPageLeaf)
        if (tt === 0) {
          this.removeKid(nt);
          return;
        } else
          tt -= 1;
    }
    throw new CorruptPageTreeError(s, "removeLeafNode");
  }
  ascend(s) {
    s(this);
    const $ = this.Parent();
    $ && $.ascend(s);
  }
  /** Performs a Post-Order traversal of this page tree */
  traverse(s) {
    const $ = this.Kids();
    for (let _ = 0, _e = $.size(); _ < _e; _++) {
      const tt = $.get(_), nt = this.context.lookup(tt);
      nt instanceof PDFPageTree && nt.traverse(s), s(nt, tt);
    }
  }
  insertLeafKid(s, $) {
    const _ = this.Kids();
    this.ascend((_e) => {
      const tt = _e.Count().asNumber() + 1;
      _e.set(PDFName.of("Count"), PDFNumber.of(tt));
    }), _.insert(s, $);
  }
  removeKid(s) {
    const $ = this.Kids();
    $.lookup(s) instanceof PDFPageLeaf && this.ascend((_e) => {
      const tt = _e.Count().asNumber() - 1;
      _e.set(PDFName.of("Count"), PDFNumber.of(tt));
    }), $.remove(s);
  }
}
PDFPageTree.withContext = (a, s) => {
  const $ = /* @__PURE__ */ new Map();
  return $.set(PDFName.of("Type"), PDFName.of("Pages")), $.set(PDFName.of("Kids"), a.obj([])), $.set(PDFName.of("Count"), a.obj(0)), s && $.set(PDFName.of("Parent"), s), new PDFPageTree($, a);
};
PDFPageTree.fromMapWithContext = (a, s) => new PDFPageTree(a, s);
const IsDigit = new Uint8Array(256);
IsDigit[CharCodes$1.Zero] = 1;
IsDigit[CharCodes$1.One] = 1;
IsDigit[CharCodes$1.Two] = 1;
IsDigit[CharCodes$1.Three] = 1;
IsDigit[CharCodes$1.Four] = 1;
IsDigit[CharCodes$1.Five] = 1;
IsDigit[CharCodes$1.Six] = 1;
IsDigit[CharCodes$1.Seven] = 1;
IsDigit[CharCodes$1.Eight] = 1;
IsDigit[CharCodes$1.Nine] = 1;
const IsNumericPrefix = new Uint8Array(256);
IsNumericPrefix[CharCodes$1.Period] = 1;
IsNumericPrefix[CharCodes$1.Plus] = 1;
IsNumericPrefix[CharCodes$1.Minus] = 1;
const IsNumeric = new Uint8Array(256);
for (let a = 0, s = 256; a < s; a++)
  IsNumeric[a] = IsDigit[a] || IsNumericPrefix[a] ? 1 : 0;
const { Space: Space$1, CarriageReturn, Newline } = CharCodes$1, stream = [
  CharCodes$1.s,
  CharCodes$1.t,
  CharCodes$1.r,
  CharCodes$1.e,
  CharCodes$1.a,
  CharCodes$1.m
], endstream = [
  CharCodes$1.e,
  CharCodes$1.n,
  CharCodes$1.d,
  CharCodes$1.s,
  CharCodes$1.t,
  CharCodes$1.r,
  CharCodes$1.e,
  CharCodes$1.a,
  CharCodes$1.m
];
CharCodes$1.Percent, CharCodes$1.P, CharCodes$1.D, CharCodes$1.F, CharCodes$1.Dash, CharCodes$1.Percent, CharCodes$1.Percent, CharCodes$1.E, CharCodes$1.O, CharCodes$1.F, CharCodes$1.o, CharCodes$1.b, CharCodes$1.j, CharCodes$1.e, CharCodes$1.n, CharCodes$1.d, CharCodes$1.o, CharCodes$1.b, CharCodes$1.j, CharCodes$1.x, CharCodes$1.r, CharCodes$1.e, CharCodes$1.f, CharCodes$1.t, CharCodes$1.r, CharCodes$1.a, CharCodes$1.i, CharCodes$1.l, CharCodes$1.e, CharCodes$1.r, CharCodes$1.s, CharCodes$1.t, CharCodes$1.a, CharCodes$1.r, CharCodes$1.t, CharCodes$1.x, CharCodes$1.r, CharCodes$1.e, CharCodes$1.f, CharCodes$1.t, CharCodes$1.r, CharCodes$1.u, CharCodes$1.e, CharCodes$1.f, CharCodes$1.a, CharCodes$1.l, CharCodes$1.s, CharCodes$1.e, CharCodes$1.n, CharCodes$1.u, CharCodes$1.l, CharCodes$1.l, [...stream], [...stream], [...stream], [...stream], [...endstream], [...endstream], [...endstream];
const flag = (a) => 1 << a;
var AnnotationFlags;
(function(a) {
  a[a.Invisible = flag(0)] = "Invisible", a[a.Hidden = flag(1)] = "Hidden", a[a.Print = flag(2)] = "Print", a[a.NoZoom = flag(3)] = "NoZoom", a[a.NoRotate = flag(4)] = "NoRotate", a[a.NoView = flag(5)] = "NoView", a[a.ReadOnly = flag(6)] = "ReadOnly", a[a.Locked = flag(7)] = "Locked", a[a.ToggleNoView = flag(8)] = "ToggleNoView", a[a.LockedContents = flag(9)] = "LockedContents";
})(AnnotationFlags || (AnnotationFlags = {}));
var RotationTypes;
(function(a) {
  a.Degrees = "degrees", a.Radians = "radians";
})(RotationTypes || (RotationTypes = {}));
const degrees = (a) => (assertIs(a, "degreeAngle", ["number"]), { type: RotationTypes.Degrees, angle: a }), degreesToRadians = (a) => a * Math.PI / 180;
var LineCapStyle;
(function(a) {
  a[a.Butt = 0] = "Butt", a[a.Round = 1] = "Round", a[a.Projecting = 2] = "Projecting";
})(LineCapStyle || (LineCapStyle = {}));
var LineJoinStyle;
(function(a) {
  a[a.Miter = 0] = "Miter", a[a.Round = 1] = "Round", a[a.Bevel = 2] = "Bevel";
})(LineJoinStyle || (LineJoinStyle = {}));
var FillRule;
(function(a) {
  a.NonZero = "f", a.EvenOdd = "f*";
})(FillRule || (FillRule = {}));
var TextRenderingMode;
(function(a) {
  a[a.Fill = 0] = "Fill", a[a.Outline = 1] = "Outline", a[a.FillAndOutline = 2] = "FillAndOutline", a[a.Invisible = 3] = "Invisible", a[a.FillAndClip = 4] = "FillAndClip", a[a.OutlineAndClip = 5] = "OutlineAndClip", a[a.FillAndOutlineAndClip = 6] = "FillAndOutlineAndClip", a[a.Clip = 7] = "Clip";
})(TextRenderingMode || (TextRenderingMode = {}));
var colorString$1 = { exports: {} }, colorName = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, simpleSwizzle = { exports: {} }, isArrayish$1 = function a(s) {
  return !s || typeof s == "string" ? !1 : s instanceof Array || Array.isArray(s) || s.length >= 0 && (s.splice instanceof Function || Object.getOwnPropertyDescriptor(s, s.length - 1) && s.constructor.name !== "String");
}, isArrayish = isArrayish$1, concat = Array.prototype.concat, slice$1 = Array.prototype.slice, swizzle$1 = simpleSwizzle.exports = function a(s) {
  for (var $ = [], _ = 0, _e = s.length; _ < _e; _++) {
    var tt = s[_];
    isArrayish(tt) ? $ = concat.call($, slice$1.call(tt)) : $.push(tt);
  }
  return $;
};
swizzle$1.wrap = function(a) {
  return function() {
    return a(swizzle$1(arguments));
  };
};
var simpleSwizzleExports = simpleSwizzle.exports, colorNames = colorName, swizzle = simpleSwizzleExports, hasOwnProperty$f = Object.hasOwnProperty, reverseNames = /* @__PURE__ */ Object.create(null);
for (var name in colorNames)
  hasOwnProperty$f.call(colorNames, name) && (reverseNames[colorNames[name]] = name);
var cs = colorString$1.exports = {
  to: {},
  get: {}
};
cs.get = function(a) {
  var s = a.substring(0, 3).toLowerCase(), $, _;
  switch (s) {
    case "hsl":
      $ = cs.get.hsl(a), _ = "hsl";
      break;
    case "hwb":
      $ = cs.get.hwb(a), _ = "hwb";
      break;
    default:
      $ = cs.get.rgb(a), _ = "rgb";
      break;
  }
  return $ ? { model: _, value: $ } : null;
};
cs.get.rgb = function(a) {
  if (!a)
    return null;
  var s = /^#([a-f0-9]{3,4})$/i, $ = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, _ = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, _e = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, tt = /^(\w+)$/, nt = [0, 0, 0, 1], at, ot, rt;
  if (at = a.match($)) {
    for (rt = at[2], at = at[1], ot = 0; ot < 3; ot++) {
      var st = ot * 2;
      nt[ot] = parseInt(at.slice(st, st + 2), 16);
    }
    rt && (nt[3] = parseInt(rt, 16) / 255);
  } else if (at = a.match(s)) {
    for (at = at[1], rt = at[3], ot = 0; ot < 3; ot++)
      nt[ot] = parseInt(at[ot] + at[ot], 16);
    rt && (nt[3] = parseInt(rt + rt, 16) / 255);
  } else if (at = a.match(_)) {
    for (ot = 0; ot < 3; ot++)
      nt[ot] = parseInt(at[ot + 1], 0);
    at[4] && (at[5] ? nt[3] = parseFloat(at[4]) * 0.01 : nt[3] = parseFloat(at[4]));
  } else if (at = a.match(_e)) {
    for (ot = 0; ot < 3; ot++)
      nt[ot] = Math.round(parseFloat(at[ot + 1]) * 2.55);
    at[4] && (at[5] ? nt[3] = parseFloat(at[4]) * 0.01 : nt[3] = parseFloat(at[4]));
  } else
    return (at = a.match(tt)) ? at[1] === "transparent" ? [0, 0, 0, 0] : hasOwnProperty$f.call(colorNames, at[1]) ? (nt = colorNames[at[1]], nt[3] = 1, nt) : null : null;
  for (ot = 0; ot < 3; ot++)
    nt[ot] = clamp(nt[ot], 0, 255);
  return nt[3] = clamp(nt[3], 0, 1), nt;
};
cs.get.hsl = function(a) {
  if (!a)
    return null;
  var s = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, $ = a.match(s);
  if ($) {
    var _ = parseFloat($[4]), _e = (parseFloat($[1]) % 360 + 360) % 360, tt = clamp(parseFloat($[2]), 0, 100), nt = clamp(parseFloat($[3]), 0, 100), at = clamp(isNaN(_) ? 1 : _, 0, 1);
    return [_e, tt, nt, at];
  }
  return null;
};
cs.get.hwb = function(a) {
  if (!a)
    return null;
  var s = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, $ = a.match(s);
  if ($) {
    var _ = parseFloat($[4]), _e = (parseFloat($[1]) % 360 + 360) % 360, tt = clamp(parseFloat($[2]), 0, 100), nt = clamp(parseFloat($[3]), 0, 100), at = clamp(isNaN(_) ? 1 : _, 0, 1);
    return [_e, tt, nt, at];
  }
  return null;
};
cs.to.hex = function() {
  var a = swizzle(arguments);
  return "#" + hexDouble(a[0]) + hexDouble(a[1]) + hexDouble(a[2]) + (a[3] < 1 ? hexDouble(Math.round(a[3] * 255)) : "");
};
cs.to.rgb = function() {
  var a = swizzle(arguments);
  return a.length < 4 || a[3] === 1 ? "rgb(" + Math.round(a[0]) + ", " + Math.round(a[1]) + ", " + Math.round(a[2]) + ")" : "rgba(" + Math.round(a[0]) + ", " + Math.round(a[1]) + ", " + Math.round(a[2]) + ", " + a[3] + ")";
};
cs.to.rgb.percent = function() {
  var a = swizzle(arguments), s = Math.round(a[0] / 255 * 100), $ = Math.round(a[1] / 255 * 100), _ = Math.round(a[2] / 255 * 100);
  return a.length < 4 || a[3] === 1 ? "rgb(" + s + "%, " + $ + "%, " + _ + "%)" : "rgba(" + s + "%, " + $ + "%, " + _ + "%, " + a[3] + ")";
};
cs.to.hsl = function() {
  var a = swizzle(arguments);
  return a.length < 4 || a[3] === 1 ? "hsl(" + a[0] + ", " + a[1] + "%, " + a[2] + "%)" : "hsla(" + a[0] + ", " + a[1] + "%, " + a[2] + "%, " + a[3] + ")";
};
cs.to.hwb = function() {
  var a = swizzle(arguments), s = "";
  return a.length >= 4 && a[3] !== 1 && (s = ", " + a[3]), "hwb(" + a[0] + ", " + a[1] + "%, " + a[2] + "%" + s + ")";
};
cs.to.keyword = function(a) {
  return reverseNames[a.slice(0, 3)];
};
function clamp(a, s, $) {
  return Math.min(Math.max(s, a), $);
}
function hexDouble(a) {
  var s = Math.round(a).toString(16).toUpperCase();
  return s.length < 2 ? "0" + s : s;
}
var colorStringExports = colorString$1.exports, ColorTypes;
(function(a) {
  a.Grayscale = "Grayscale", a.RGB = "RGB", a.CMYK = "CMYK";
})(ColorTypes || (ColorTypes = {}));
const rgb = (a, s, $) => (assertRange(a, "red", 0, 1), assertRange(s, "green", 0, 1), assertRange($, "blue", 0, 1), { type: ColorTypes.RGB, red: a, green: s, blue: $ }), cmyk = (a, s, $, _) => (assertRange(a, "cyan", 0, 1), assertRange(s, "magenta", 0, 1), assertRange($, "yellow", 0, 1), assertRange(_, "key", 0, 1), { type: ColorTypes.CMYK, cyan: a, magenta: s, yellow: $, key: _ });
var TextAlignment;
(function(a) {
  a[a.Left = 0] = "Left", a[a.Center = 1] = "Center", a[a.Right = 2] = "Right";
})(TextAlignment || (TextAlignment = {}));
var ImageAlignment;
(function(a) {
  a[a.Left = 0] = "Left", a[a.Center = 1] = "Center", a[a.Right = 2] = "Right";
})(ImageAlignment || (ImageAlignment = {}));
var StandardFonts;
(function(a) {
  a.Courier = "Courier", a.CourierBold = "Courier-Bold", a.CourierOblique = "Courier-Oblique", a.CourierBoldOblique = "Courier-BoldOblique", a.Helvetica = "Helvetica", a.HelveticaBold = "Helvetica-Bold", a.HelveticaOblique = "Helvetica-Oblique", a.HelveticaBoldOblique = "Helvetica-BoldOblique", a.TimesRoman = "Times-Roman", a.TimesRomanBold = "Times-Bold", a.TimesRomanItalic = "Times-Italic", a.TimesRomanBoldItalic = "Times-BoldItalic", a.Symbol = "Symbol", a.ZapfDingbats = "ZapfDingbats";
})(StandardFonts || (StandardFonts = {}));
var ParseSpeeds;
(function(a) {
  a[a.Fastest = 1 / 0] = "Fastest", a[a.Fast = 1500] = "Fast", a[a.Medium = 500] = "Medium", a[a.Slow = 100] = "Slow";
})(ParseSpeeds || (ParseSpeeds = {}));
var BlendMode;
(function(a) {
  a.Normal = "Normal", a.Multiply = "Multiply", a.Screen = "Screen", a.Overlay = "Overlay", a.Darken = "Darken", a.Lighten = "Lighten", a.ColorDodge = "ColorDodge", a.ColorBurn = "ColorBurn", a.HardLight = "HardLight", a.SoftLight = "SoftLight", a.Difference = "Difference", a.Exclusion = "Exclusion";
})(BlendMode || (BlendMode = {}));
var dist = {}, lib$2 = {}, namedReferences = {};
Object.defineProperty(namedReferences, "__esModule", { value: !0 });
namedReferences.bodyRegExps = { xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g, html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g, html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g };
namedReferences.namedReferences = { xml: { entities: { "&lt;": "<", "&gt;": ">", "&quot;": '"', "&apos;": "'", "&amp;": "&" }, characters: { "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&apos;", "&": "&amp;" } }, html4: { entities: { "&apos;": "'", "&nbsp": " ", "&nbsp;": " ", "&iexcl": "¡", "&iexcl;": "¡", "&cent": "¢", "&cent;": "¢", "&pound": "£", "&pound;": "£", "&curren": "¤", "&curren;": "¤", "&yen": "¥", "&yen;": "¥", "&brvbar": "¦", "&brvbar;": "¦", "&sect": "§", "&sect;": "§", "&uml": "¨", "&uml;": "¨", "&copy": "©", "&copy;": "©", "&ordf": "ª", "&ordf;": "ª", "&laquo": "«", "&laquo;": "«", "&not": "¬", "&not;": "¬", "&shy": "­", "&shy;": "­", "&reg": "®", "&reg;": "®", "&macr": "¯", "&macr;": "¯", "&deg": "°", "&deg;": "°", "&plusmn": "±", "&plusmn;": "±", "&sup2": "²", "&sup2;": "²", "&sup3": "³", "&sup3;": "³", "&acute": "´", "&acute;": "´", "&micro": "µ", "&micro;": "µ", "&para": "¶", "&para;": "¶", "&middot": "·", "&middot;": "·", "&cedil": "¸", "&cedil;": "¸", "&sup1": "¹", "&sup1;": "¹", "&ordm": "º", "&ordm;": "º", "&raquo": "»", "&raquo;": "»", "&frac14": "¼", "&frac14;": "¼", "&frac12": "½", "&frac12;": "½", "&frac34": "¾", "&frac34;": "¾", "&iquest": "¿", "&iquest;": "¿", "&Agrave": "À", "&Agrave;": "À", "&Aacute": "Á", "&Aacute;": "Á", "&Acirc": "Â", "&Acirc;": "Â", "&Atilde": "Ã", "&Atilde;": "Ã", "&Auml": "Ä", "&Auml;": "Ä", "&Aring": "Å", "&Aring;": "Å", "&AElig": "Æ", "&AElig;": "Æ", "&Ccedil": "Ç", "&Ccedil;": "Ç", "&Egrave": "È", "&Egrave;": "È", "&Eacute": "É", "&Eacute;": "É", "&Ecirc": "Ê", "&Ecirc;": "Ê", "&Euml": "Ë", "&Euml;": "Ë", "&Igrave": "Ì", "&Igrave;": "Ì", "&Iacute": "Í", "&Iacute;": "Í", "&Icirc": "Î", "&Icirc;": "Î", "&Iuml": "Ï", "&Iuml;": "Ï", "&ETH": "Ð", "&ETH;": "Ð", "&Ntilde": "Ñ", "&Ntilde;": "Ñ", "&Ograve": "Ò", "&Ograve;": "Ò", "&Oacute": "Ó", "&Oacute;": "Ó", "&Ocirc": "Ô", "&Ocirc;": "Ô", "&Otilde": "Õ", "&Otilde;": "Õ", "&Ouml": "Ö", "&Ouml;": "Ö", "&times": "×", "&times;": "×", "&Oslash": "Ø", "&Oslash;": "Ø", "&Ugrave": "Ù", "&Ugrave;": "Ù", "&Uacute": "Ú", "&Uacute;": "Ú", "&Ucirc": "Û", "&Ucirc;": "Û", "&Uuml": "Ü", "&Uuml;": "Ü", "&Yacute": "Ý", "&Yacute;": "Ý", "&THORN": "Þ", "&THORN;": "Þ", "&szlig": "ß", "&szlig;": "ß", "&agrave": "à", "&agrave;": "à", "&aacute": "á", "&aacute;": "á", "&acirc": "â", "&acirc;": "â", "&atilde": "ã", "&atilde;": "ã", "&auml": "ä", "&auml;": "ä", "&aring": "å", "&aring;": "å", "&aelig": "æ", "&aelig;": "æ", "&ccedil": "ç", "&ccedil;": "ç", "&egrave": "è", "&egrave;": "è", "&eacute": "é", "&eacute;": "é", "&ecirc": "ê", "&ecirc;": "ê", "&euml": "ë", "&euml;": "ë", "&igrave": "ì", "&igrave;": "ì", "&iacute": "í", "&iacute;": "í", "&icirc": "î", "&icirc;": "î", "&iuml": "ï", "&iuml;": "ï", "&eth": "ð", "&eth;": "ð", "&ntilde": "ñ", "&ntilde;": "ñ", "&ograve": "ò", "&ograve;": "ò", "&oacute": "ó", "&oacute;": "ó", "&ocirc": "ô", "&ocirc;": "ô", "&otilde": "õ", "&otilde;": "õ", "&ouml": "ö", "&ouml;": "ö", "&divide": "÷", "&divide;": "÷", "&oslash": "ø", "&oslash;": "ø", "&ugrave": "ù", "&ugrave;": "ù", "&uacute": "ú", "&uacute;": "ú", "&ucirc": "û", "&ucirc;": "û", "&uuml": "ü", "&uuml;": "ü", "&yacute": "ý", "&yacute;": "ý", "&thorn": "þ", "&thorn;": "þ", "&yuml": "ÿ", "&yuml;": "ÿ", "&quot": '"', "&quot;": '"', "&amp": "&", "&amp;": "&", "&lt": "<", "&lt;": "<", "&gt": ">", "&gt;": ">", "&OElig;": "Œ", "&oelig;": "œ", "&Scaron;": "Š", "&scaron;": "š", "&Yuml;": "Ÿ", "&circ;": "ˆ", "&tilde;": "˜", "&ensp;": " ", "&emsp;": " ", "&thinsp;": " ", "&zwnj;": "‌", "&zwj;": "‍", "&lrm;": "‎", "&rlm;": "‏", "&ndash;": "–", "&mdash;": "—", "&lsquo;": "‘", "&rsquo;": "’", "&sbquo;": "‚", "&ldquo;": "“", "&rdquo;": "”", "&bdquo;": "„", "&dagger;": "†", "&Dagger;": "‡", "&permil;": "‰", "&lsaquo;": "‹", "&rsaquo;": "›", "&euro;": "€", "&fnof;": "ƒ", "&Alpha;": "Α", "&Beta;": "Β", "&Gamma;": "Γ", "&Delta;": "Δ", "&Epsilon;": "Ε", "&Zeta;": "Ζ", "&Eta;": "Η", "&Theta;": "Θ", "&Iota;": "Ι", "&Kappa;": "Κ", "&Lambda;": "Λ", "&Mu;": "Μ", "&Nu;": "Ν", "&Xi;": "Ξ", "&Omicron;": "Ο", "&Pi;": "Π", "&Rho;": "Ρ", "&Sigma;": "Σ", "&Tau;": "Τ", "&Upsilon;": "Υ", "&Phi;": "Φ", "&Chi;": "Χ", "&Psi;": "Ψ", "&Omega;": "Ω", "&alpha;": "α", "&beta;": "β", "&gamma;": "γ", "&delta;": "δ", "&epsilon;": "ε", "&zeta;": "ζ", "&eta;": "η", "&theta;": "θ", "&iota;": "ι", "&kappa;": "κ", "&lambda;": "λ", "&mu;": "μ", "&nu;": "ν", "&xi;": "ξ", "&omicron;": "ο", "&pi;": "π", "&rho;": "ρ", "&sigmaf;": "ς", "&sigma;": "σ", "&tau;": "τ", "&upsilon;": "υ", "&phi;": "φ", "&chi;": "χ", "&psi;": "ψ", "&omega;": "ω", "&thetasym;": "ϑ", "&upsih;": "ϒ", "&piv;": "ϖ", "&bull;": "•", "&hellip;": "…", "&prime;": "′", "&Prime;": "″", "&oline;": "‾", "&frasl;": "⁄", "&weierp;": "℘", "&image;": "ℑ", "&real;": "ℜ", "&trade;": "™", "&alefsym;": "ℵ", "&larr;": "←", "&uarr;": "↑", "&rarr;": "→", "&darr;": "↓", "&harr;": "↔", "&crarr;": "↵", "&lArr;": "⇐", "&uArr;": "⇑", "&rArr;": "⇒", "&dArr;": "⇓", "&hArr;": "⇔", "&forall;": "∀", "&part;": "∂", "&exist;": "∃", "&empty;": "∅", "&nabla;": "∇", "&isin;": "∈", "&notin;": "∉", "&ni;": "∋", "&prod;": "∏", "&sum;": "∑", "&minus;": "−", "&lowast;": "∗", "&radic;": "√", "&prop;": "∝", "&infin;": "∞", "&ang;": "∠", "&and;": "∧", "&or;": "∨", "&cap;": "∩", "&cup;": "∪", "&int;": "∫", "&there4;": "∴", "&sim;": "∼", "&cong;": "≅", "&asymp;": "≈", "&ne;": "≠", "&equiv;": "≡", "&le;": "≤", "&ge;": "≥", "&sub;": "⊂", "&sup;": "⊃", "&nsub;": "⊄", "&sube;": "⊆", "&supe;": "⊇", "&oplus;": "⊕", "&otimes;": "⊗", "&perp;": "⊥", "&sdot;": "⋅", "&lceil;": "⌈", "&rceil;": "⌉", "&lfloor;": "⌊", "&rfloor;": "⌋", "&lang;": "〈", "&rang;": "〉", "&loz;": "◊", "&spades;": "♠", "&clubs;": "♣", "&hearts;": "♥", "&diams;": "♦" }, characters: { "'": "&apos;", " ": "&nbsp;", "¡": "&iexcl;", "¢": "&cent;", "£": "&pound;", "¤": "&curren;", "¥": "&yen;", "¦": "&brvbar;", "§": "&sect;", "¨": "&uml;", "©": "&copy;", ª: "&ordf;", "«": "&laquo;", "¬": "&not;", "­": "&shy;", "®": "&reg;", "¯": "&macr;", "°": "&deg;", "±": "&plusmn;", "²": "&sup2;", "³": "&sup3;", "´": "&acute;", µ: "&micro;", "¶": "&para;", "·": "&middot;", "¸": "&cedil;", "¹": "&sup1;", º: "&ordm;", "»": "&raquo;", "¼": "&frac14;", "½": "&frac12;", "¾": "&frac34;", "¿": "&iquest;", À: "&Agrave;", Á: "&Aacute;", Â: "&Acirc;", Ã: "&Atilde;", Ä: "&Auml;", Å: "&Aring;", Æ: "&AElig;", Ç: "&Ccedil;", È: "&Egrave;", É: "&Eacute;", Ê: "&Ecirc;", Ë: "&Euml;", Ì: "&Igrave;", Í: "&Iacute;", Î: "&Icirc;", Ï: "&Iuml;", Ð: "&ETH;", Ñ: "&Ntilde;", Ò: "&Ograve;", Ó: "&Oacute;", Ô: "&Ocirc;", Õ: "&Otilde;", Ö: "&Ouml;", "×": "&times;", Ø: "&Oslash;", Ù: "&Ugrave;", Ú: "&Uacute;", Û: "&Ucirc;", Ü: "&Uuml;", Ý: "&Yacute;", Þ: "&THORN;", ß: "&szlig;", à: "&agrave;", á: "&aacute;", â: "&acirc;", ã: "&atilde;", ä: "&auml;", å: "&aring;", æ: "&aelig;", ç: "&ccedil;", è: "&egrave;", é: "&eacute;", ê: "&ecirc;", ë: "&euml;", ì: "&igrave;", í: "&iacute;", î: "&icirc;", ï: "&iuml;", ð: "&eth;", ñ: "&ntilde;", ò: "&ograve;", ó: "&oacute;", ô: "&ocirc;", õ: "&otilde;", ö: "&ouml;", "÷": "&divide;", ø: "&oslash;", ù: "&ugrave;", ú: "&uacute;", û: "&ucirc;", ü: "&uuml;", ý: "&yacute;", þ: "&thorn;", ÿ: "&yuml;", '"': "&quot;", "&": "&amp;", "<": "&lt;", ">": "&gt;", Œ: "&OElig;", œ: "&oelig;", Š: "&Scaron;", š: "&scaron;", Ÿ: "&Yuml;", "ˆ": "&circ;", "˜": "&tilde;", " ": "&ensp;", " ": "&emsp;", " ": "&thinsp;", "‌": "&zwnj;", "‍": "&zwj;", "‎": "&lrm;", "‏": "&rlm;", "–": "&ndash;", "—": "&mdash;", "‘": "&lsquo;", "’": "&rsquo;", "‚": "&sbquo;", "“": "&ldquo;", "”": "&rdquo;", "„": "&bdquo;", "†": "&dagger;", "‡": "&Dagger;", "‰": "&permil;", "‹": "&lsaquo;", "›": "&rsaquo;", "€": "&euro;", ƒ: "&fnof;", Α: "&Alpha;", Β: "&Beta;", Γ: "&Gamma;", Δ: "&Delta;", Ε: "&Epsilon;", Ζ: "&Zeta;", Η: "&Eta;", Θ: "&Theta;", Ι: "&Iota;", Κ: "&Kappa;", Λ: "&Lambda;", Μ: "&Mu;", Ν: "&Nu;", Ξ: "&Xi;", Ο: "&Omicron;", Π: "&Pi;", Ρ: "&Rho;", Σ: "&Sigma;", Τ: "&Tau;", Υ: "&Upsilon;", Φ: "&Phi;", Χ: "&Chi;", Ψ: "&Psi;", Ω: "&Omega;", α: "&alpha;", β: "&beta;", γ: "&gamma;", δ: "&delta;", ε: "&epsilon;", ζ: "&zeta;", η: "&eta;", θ: "&theta;", ι: "&iota;", κ: "&kappa;", λ: "&lambda;", μ: "&mu;", ν: "&nu;", ξ: "&xi;", ο: "&omicron;", π: "&pi;", ρ: "&rho;", ς: "&sigmaf;", σ: "&sigma;", τ: "&tau;", υ: "&upsilon;", φ: "&phi;", χ: "&chi;", ψ: "&psi;", ω: "&omega;", ϑ: "&thetasym;", ϒ: "&upsih;", ϖ: "&piv;", "•": "&bull;", "…": "&hellip;", "′": "&prime;", "″": "&Prime;", "‾": "&oline;", "⁄": "&frasl;", "℘": "&weierp;", ℑ: "&image;", ℜ: "&real;", "™": "&trade;", ℵ: "&alefsym;", "←": "&larr;", "↑": "&uarr;", "→": "&rarr;", "↓": "&darr;", "↔": "&harr;", "↵": "&crarr;", "⇐": "&lArr;", "⇑": "&uArr;", "⇒": "&rArr;", "⇓": "&dArr;", "⇔": "&hArr;", "∀": "&forall;", "∂": "&part;", "∃": "&exist;", "∅": "&empty;", "∇": "&nabla;", "∈": "&isin;", "∉": "&notin;", "∋": "&ni;", "∏": "&prod;", "∑": "&sum;", "−": "&minus;", "∗": "&lowast;", "√": "&radic;", "∝": "&prop;", "∞": "&infin;", "∠": "&ang;", "∧": "&and;", "∨": "&or;", "∩": "&cap;", "∪": "&cup;", "∫": "&int;", "∴": "&there4;", "∼": "&sim;", "≅": "&cong;", "≈": "&asymp;", "≠": "&ne;", "≡": "&equiv;", "≤": "&le;", "≥": "&ge;", "⊂": "&sub;", "⊃": "&sup;", "⊄": "&nsub;", "⊆": "&sube;", "⊇": "&supe;", "⊕": "&oplus;", "⊗": "&otimes;", "⊥": "&perp;", "⋅": "&sdot;", "⌈": "&lceil;", "⌉": "&rceil;", "⌊": "&lfloor;", "⌋": "&rfloor;", "〈": "&lang;", "〉": "&rang;", "◊": "&loz;", "♠": "&spades;", "♣": "&clubs;", "♥": "&hearts;", "♦": "&diams;" } }, html5: { entities: { "&AElig": "Æ", "&AElig;": "Æ", "&AMP": "&", "&AMP;": "&", "&Aacute": "Á", "&Aacute;": "Á", "&Abreve;": "Ă", "&Acirc": "Â", "&Acirc;": "Â", "&Acy;": "А", "&Afr;": "𝔄", "&Agrave": "À", "&Agrave;": "À", "&Alpha;": "Α", "&Amacr;": "Ā", "&And;": "⩓", "&Aogon;": "Ą", "&Aopf;": "𝔸", "&ApplyFunction;": "⁡", "&Aring": "Å", "&Aring;": "Å", "&Ascr;": "𝒜", "&Assign;": "≔", "&Atilde": "Ã", "&Atilde;": "Ã", "&Auml": "Ä", "&Auml;": "Ä", "&Backslash;": "∖", "&Barv;": "⫧", "&Barwed;": "⌆", "&Bcy;": "Б", "&Because;": "∵", "&Bernoullis;": "ℬ", "&Beta;": "Β", "&Bfr;": "𝔅", "&Bopf;": "𝔹", "&Breve;": "˘", "&Bscr;": "ℬ", "&Bumpeq;": "≎", "&CHcy;": "Ч", "&COPY": "©", "&COPY;": "©", "&Cacute;": "Ć", "&Cap;": "⋒", "&CapitalDifferentialD;": "ⅅ", "&Cayleys;": "ℭ", "&Ccaron;": "Č", "&Ccedil": "Ç", "&Ccedil;": "Ç", "&Ccirc;": "Ĉ", "&Cconint;": "∰", "&Cdot;": "Ċ", "&Cedilla;": "¸", "&CenterDot;": "·", "&Cfr;": "ℭ", "&Chi;": "Χ", "&CircleDot;": "⊙", "&CircleMinus;": "⊖", "&CirclePlus;": "⊕", "&CircleTimes;": "⊗", "&ClockwiseContourIntegral;": "∲", "&CloseCurlyDoubleQuote;": "”", "&CloseCurlyQuote;": "’", "&Colon;": "∷", "&Colone;": "⩴", "&Congruent;": "≡", "&Conint;": "∯", "&ContourIntegral;": "∮", "&Copf;": "ℂ", "&Coproduct;": "∐", "&CounterClockwiseContourIntegral;": "∳", "&Cross;": "⨯", "&Cscr;": "𝒞", "&Cup;": "⋓", "&CupCap;": "≍", "&DD;": "ⅅ", "&DDotrahd;": "⤑", "&DJcy;": "Ђ", "&DScy;": "Ѕ", "&DZcy;": "Џ", "&Dagger;": "‡", "&Darr;": "↡", "&Dashv;": "⫤", "&Dcaron;": "Ď", "&Dcy;": "Д", "&Del;": "∇", "&Delta;": "Δ", "&Dfr;": "𝔇", "&DiacriticalAcute;": "´", "&DiacriticalDot;": "˙", "&DiacriticalDoubleAcute;": "˝", "&DiacriticalGrave;": "`", "&DiacriticalTilde;": "˜", "&Diamond;": "⋄", "&DifferentialD;": "ⅆ", "&Dopf;": "𝔻", "&Dot;": "¨", "&DotDot;": "⃜", "&DotEqual;": "≐", "&DoubleContourIntegral;": "∯", "&DoubleDot;": "¨", "&DoubleDownArrow;": "⇓", "&DoubleLeftArrow;": "⇐", "&DoubleLeftRightArrow;": "⇔", "&DoubleLeftTee;": "⫤", "&DoubleLongLeftArrow;": "⟸", "&DoubleLongLeftRightArrow;": "⟺", "&DoubleLongRightArrow;": "⟹", "&DoubleRightArrow;": "⇒", "&DoubleRightTee;": "⊨", "&DoubleUpArrow;": "⇑", "&DoubleUpDownArrow;": "⇕", "&DoubleVerticalBar;": "∥", "&DownArrow;": "↓", "&DownArrowBar;": "⤓", "&DownArrowUpArrow;": "⇵", "&DownBreve;": "̑", "&DownLeftRightVector;": "⥐", "&DownLeftTeeVector;": "⥞", "&DownLeftVector;": "↽", "&DownLeftVectorBar;": "⥖", "&DownRightTeeVector;": "⥟", "&DownRightVector;": "⇁", "&DownRightVectorBar;": "⥗", "&DownTee;": "⊤", "&DownTeeArrow;": "↧", "&Downarrow;": "⇓", "&Dscr;": "𝒟", "&Dstrok;": "Đ", "&ENG;": "Ŋ", "&ETH": "Ð", "&ETH;": "Ð", "&Eacute": "É", "&Eacute;": "É", "&Ecaron;": "Ě", "&Ecirc": "Ê", "&Ecirc;": "Ê", "&Ecy;": "Э", "&Edot;": "Ė", "&Efr;": "𝔈", "&Egrave": "È", "&Egrave;": "È", "&Element;": "∈", "&Emacr;": "Ē", "&EmptySmallSquare;": "◻", "&EmptyVerySmallSquare;": "▫", "&Eogon;": "Ę", "&Eopf;": "𝔼", "&Epsilon;": "Ε", "&Equal;": "⩵", "&EqualTilde;": "≂", "&Equilibrium;": "⇌", "&Escr;": "ℰ", "&Esim;": "⩳", "&Eta;": "Η", "&Euml": "Ë", "&Euml;": "Ë", "&Exists;": "∃", "&ExponentialE;": "ⅇ", "&Fcy;": "Ф", "&Ffr;": "𝔉", "&FilledSmallSquare;": "◼", "&FilledVerySmallSquare;": "▪", "&Fopf;": "𝔽", "&ForAll;": "∀", "&Fouriertrf;": "ℱ", "&Fscr;": "ℱ", "&GJcy;": "Ѓ", "&GT": ">", "&GT;": ">", "&Gamma;": "Γ", "&Gammad;": "Ϝ", "&Gbreve;": "Ğ", "&Gcedil;": "Ģ", "&Gcirc;": "Ĝ", "&Gcy;": "Г", "&Gdot;": "Ġ", "&Gfr;": "𝔊", "&Gg;": "⋙", "&Gopf;": "𝔾", "&GreaterEqual;": "≥", "&GreaterEqualLess;": "⋛", "&GreaterFullEqual;": "≧", "&GreaterGreater;": "⪢", "&GreaterLess;": "≷", "&GreaterSlantEqual;": "⩾", "&GreaterTilde;": "≳", "&Gscr;": "𝒢", "&Gt;": "≫", "&HARDcy;": "Ъ", "&Hacek;": "ˇ", "&Hat;": "^", "&Hcirc;": "Ĥ", "&Hfr;": "ℌ", "&HilbertSpace;": "ℋ", "&Hopf;": "ℍ", "&HorizontalLine;": "─", "&Hscr;": "ℋ", "&Hstrok;": "Ħ", "&HumpDownHump;": "≎", "&HumpEqual;": "≏", "&IEcy;": "Е", "&IJlig;": "Ĳ", "&IOcy;": "Ё", "&Iacute": "Í", "&Iacute;": "Í", "&Icirc": "Î", "&Icirc;": "Î", "&Icy;": "И", "&Idot;": "İ", "&Ifr;": "ℑ", "&Igrave": "Ì", "&Igrave;": "Ì", "&Im;": "ℑ", "&Imacr;": "Ī", "&ImaginaryI;": "ⅈ", "&Implies;": "⇒", "&Int;": "∬", "&Integral;": "∫", "&Intersection;": "⋂", "&InvisibleComma;": "⁣", "&InvisibleTimes;": "⁢", "&Iogon;": "Į", "&Iopf;": "𝕀", "&Iota;": "Ι", "&Iscr;": "ℐ", "&Itilde;": "Ĩ", "&Iukcy;": "І", "&Iuml": "Ï", "&Iuml;": "Ï", "&Jcirc;": "Ĵ", "&Jcy;": "Й", "&Jfr;": "𝔍", "&Jopf;": "𝕁", "&Jscr;": "𝒥", "&Jsercy;": "Ј", "&Jukcy;": "Є", "&KHcy;": "Х", "&KJcy;": "Ќ", "&Kappa;": "Κ", "&Kcedil;": "Ķ", "&Kcy;": "К", "&Kfr;": "𝔎", "&Kopf;": "𝕂", "&Kscr;": "𝒦", "&LJcy;": "Љ", "&LT": "<", "&LT;": "<", "&Lacute;": "Ĺ", "&Lambda;": "Λ", "&Lang;": "⟪", "&Laplacetrf;": "ℒ", "&Larr;": "↞", "&Lcaron;": "Ľ", "&Lcedil;": "Ļ", "&Lcy;": "Л", "&LeftAngleBracket;": "⟨", "&LeftArrow;": "←", "&LeftArrowBar;": "⇤", "&LeftArrowRightArrow;": "⇆", "&LeftCeiling;": "⌈", "&LeftDoubleBracket;": "⟦", "&LeftDownTeeVector;": "⥡", "&LeftDownVector;": "⇃", "&LeftDownVectorBar;": "⥙", "&LeftFloor;": "⌊", "&LeftRightArrow;": "↔", "&LeftRightVector;": "⥎", "&LeftTee;": "⊣", "&LeftTeeArrow;": "↤", "&LeftTeeVector;": "⥚", "&LeftTriangle;": "⊲", "&LeftTriangleBar;": "⧏", "&LeftTriangleEqual;": "⊴", "&LeftUpDownVector;": "⥑", "&LeftUpTeeVector;": "⥠", "&LeftUpVector;": "↿", "&LeftUpVectorBar;": "⥘", "&LeftVector;": "↼", "&LeftVectorBar;": "⥒", "&Leftarrow;": "⇐", "&Leftrightarrow;": "⇔", "&LessEqualGreater;": "⋚", "&LessFullEqual;": "≦", "&LessGreater;": "≶", "&LessLess;": "⪡", "&LessSlantEqual;": "⩽", "&LessTilde;": "≲", "&Lfr;": "𝔏", "&Ll;": "⋘", "&Lleftarrow;": "⇚", "&Lmidot;": "Ŀ", "&LongLeftArrow;": "⟵", "&LongLeftRightArrow;": "⟷", "&LongRightArrow;": "⟶", "&Longleftarrow;": "⟸", "&Longleftrightarrow;": "⟺", "&Longrightarrow;": "⟹", "&Lopf;": "𝕃", "&LowerLeftArrow;": "↙", "&LowerRightArrow;": "↘", "&Lscr;": "ℒ", "&Lsh;": "↰", "&Lstrok;": "Ł", "&Lt;": "≪", "&Map;": "⤅", "&Mcy;": "М", "&MediumSpace;": " ", "&Mellintrf;": "ℳ", "&Mfr;": "𝔐", "&MinusPlus;": "∓", "&Mopf;": "𝕄", "&Mscr;": "ℳ", "&Mu;": "Μ", "&NJcy;": "Њ", "&Nacute;": "Ń", "&Ncaron;": "Ň", "&Ncedil;": "Ņ", "&Ncy;": "Н", "&NegativeMediumSpace;": "​", "&NegativeThickSpace;": "​", "&NegativeThinSpace;": "​", "&NegativeVeryThinSpace;": "​", "&NestedGreaterGreater;": "≫", "&NestedLessLess;": "≪", "&NewLine;": `
`, "&Nfr;": "𝔑", "&NoBreak;": "⁠", "&NonBreakingSpace;": " ", "&Nopf;": "ℕ", "&Not;": "⫬", "&NotCongruent;": "≢", "&NotCupCap;": "≭", "&NotDoubleVerticalBar;": "∦", "&NotElement;": "∉", "&NotEqual;": "≠", "&NotEqualTilde;": "≂̸", "&NotExists;": "∄", "&NotGreater;": "≯", "&NotGreaterEqual;": "≱", "&NotGreaterFullEqual;": "≧̸", "&NotGreaterGreater;": "≫̸", "&NotGreaterLess;": "≹", "&NotGreaterSlantEqual;": "⩾̸", "&NotGreaterTilde;": "≵", "&NotHumpDownHump;": "≎̸", "&NotHumpEqual;": "≏̸", "&NotLeftTriangle;": "⋪", "&NotLeftTriangleBar;": "⧏̸", "&NotLeftTriangleEqual;": "⋬", "&NotLess;": "≮", "&NotLessEqual;": "≰", "&NotLessGreater;": "≸", "&NotLessLess;": "≪̸", "&NotLessSlantEqual;": "⩽̸", "&NotLessTilde;": "≴", "&NotNestedGreaterGreater;": "⪢̸", "&NotNestedLessLess;": "⪡̸", "&NotPrecedes;": "⊀", "&NotPrecedesEqual;": "⪯̸", "&NotPrecedesSlantEqual;": "⋠", "&NotReverseElement;": "∌", "&NotRightTriangle;": "⋫", "&NotRightTriangleBar;": "⧐̸", "&NotRightTriangleEqual;": "⋭", "&NotSquareSubset;": "⊏̸", "&NotSquareSubsetEqual;": "⋢", "&NotSquareSuperset;": "⊐̸", "&NotSquareSupersetEqual;": "⋣", "&NotSubset;": "⊂⃒", "&NotSubsetEqual;": "⊈", "&NotSucceeds;": "⊁", "&NotSucceedsEqual;": "⪰̸", "&NotSucceedsSlantEqual;": "⋡", "&NotSucceedsTilde;": "≿̸", "&NotSuperset;": "⊃⃒", "&NotSupersetEqual;": "⊉", "&NotTilde;": "≁", "&NotTildeEqual;": "≄", "&NotTildeFullEqual;": "≇", "&NotTildeTilde;": "≉", "&NotVerticalBar;": "∤", "&Nscr;": "𝒩", "&Ntilde": "Ñ", "&Ntilde;": "Ñ", "&Nu;": "Ν", "&OElig;": "Œ", "&Oacute": "Ó", "&Oacute;": "Ó", "&Ocirc": "Ô", "&Ocirc;": "Ô", "&Ocy;": "О", "&Odblac;": "Ő", "&Ofr;": "𝔒", "&Ograve": "Ò", "&Ograve;": "Ò", "&Omacr;": "Ō", "&Omega;": "Ω", "&Omicron;": "Ο", "&Oopf;": "𝕆", "&OpenCurlyDoubleQuote;": "“", "&OpenCurlyQuote;": "‘", "&Or;": "⩔", "&Oscr;": "𝒪", "&Oslash": "Ø", "&Oslash;": "Ø", "&Otilde": "Õ", "&Otilde;": "Õ", "&Otimes;": "⨷", "&Ouml": "Ö", "&Ouml;": "Ö", "&OverBar;": "‾", "&OverBrace;": "⏞", "&OverBracket;": "⎴", "&OverParenthesis;": "⏜", "&PartialD;": "∂", "&Pcy;": "П", "&Pfr;": "𝔓", "&Phi;": "Φ", "&Pi;": "Π", "&PlusMinus;": "±", "&Poincareplane;": "ℌ", "&Popf;": "ℙ", "&Pr;": "⪻", "&Precedes;": "≺", "&PrecedesEqual;": "⪯", "&PrecedesSlantEqual;": "≼", "&PrecedesTilde;": "≾", "&Prime;": "″", "&Product;": "∏", "&Proportion;": "∷", "&Proportional;": "∝", "&Pscr;": "𝒫", "&Psi;": "Ψ", "&QUOT": '"', "&QUOT;": '"', "&Qfr;": "𝔔", "&Qopf;": "ℚ", "&Qscr;": "𝒬", "&RBarr;": "⤐", "&REG": "®", "&REG;": "®", "&Racute;": "Ŕ", "&Rang;": "⟫", "&Rarr;": "↠", "&Rarrtl;": "⤖", "&Rcaron;": "Ř", "&Rcedil;": "Ŗ", "&Rcy;": "Р", "&Re;": "ℜ", "&ReverseElement;": "∋", "&ReverseEquilibrium;": "⇋", "&ReverseUpEquilibrium;": "⥯", "&Rfr;": "ℜ", "&Rho;": "Ρ", "&RightAngleBracket;": "⟩", "&RightArrow;": "→", "&RightArrowBar;": "⇥", "&RightArrowLeftArrow;": "⇄", "&RightCeiling;": "⌉", "&RightDoubleBracket;": "⟧", "&RightDownTeeVector;": "⥝", "&RightDownVector;": "⇂", "&RightDownVectorBar;": "⥕", "&RightFloor;": "⌋", "&RightTee;": "⊢", "&RightTeeArrow;": "↦", "&RightTeeVector;": "⥛", "&RightTriangle;": "⊳", "&RightTriangleBar;": "⧐", "&RightTriangleEqual;": "⊵", "&RightUpDownVector;": "⥏", "&RightUpTeeVector;": "⥜", "&RightUpVector;": "↾", "&RightUpVectorBar;": "⥔", "&RightVector;": "⇀", "&RightVectorBar;": "⥓", "&Rightarrow;": "⇒", "&Ropf;": "ℝ", "&RoundImplies;": "⥰", "&Rrightarrow;": "⇛", "&Rscr;": "ℛ", "&Rsh;": "↱", "&RuleDelayed;": "⧴", "&SHCHcy;": "Щ", "&SHcy;": "Ш", "&SOFTcy;": "Ь", "&Sacute;": "Ś", "&Sc;": "⪼", "&Scaron;": "Š", "&Scedil;": "Ş", "&Scirc;": "Ŝ", "&Scy;": "С", "&Sfr;": "𝔖", "&ShortDownArrow;": "↓", "&ShortLeftArrow;": "←", "&ShortRightArrow;": "→", "&ShortUpArrow;": "↑", "&Sigma;": "Σ", "&SmallCircle;": "∘", "&Sopf;": "𝕊", "&Sqrt;": "√", "&Square;": "□", "&SquareIntersection;": "⊓", "&SquareSubset;": "⊏", "&SquareSubsetEqual;": "⊑", "&SquareSuperset;": "⊐", "&SquareSupersetEqual;": "⊒", "&SquareUnion;": "⊔", "&Sscr;": "𝒮", "&Star;": "⋆", "&Sub;": "⋐", "&Subset;": "⋐", "&SubsetEqual;": "⊆", "&Succeeds;": "≻", "&SucceedsEqual;": "⪰", "&SucceedsSlantEqual;": "≽", "&SucceedsTilde;": "≿", "&SuchThat;": "∋", "&Sum;": "∑", "&Sup;": "⋑", "&Superset;": "⊃", "&SupersetEqual;": "⊇", "&Supset;": "⋑", "&THORN": "Þ", "&THORN;": "Þ", "&TRADE;": "™", "&TSHcy;": "Ћ", "&TScy;": "Ц", "&Tab;": "	", "&Tau;": "Τ", "&Tcaron;": "Ť", "&Tcedil;": "Ţ", "&Tcy;": "Т", "&Tfr;": "𝔗", "&Therefore;": "∴", "&Theta;": "Θ", "&ThickSpace;": "  ", "&ThinSpace;": " ", "&Tilde;": "∼", "&TildeEqual;": "≃", "&TildeFullEqual;": "≅", "&TildeTilde;": "≈", "&Topf;": "𝕋", "&TripleDot;": "⃛", "&Tscr;": "𝒯", "&Tstrok;": "Ŧ", "&Uacute": "Ú", "&Uacute;": "Ú", "&Uarr;": "↟", "&Uarrocir;": "⥉", "&Ubrcy;": "Ў", "&Ubreve;": "Ŭ", "&Ucirc": "Û", "&Ucirc;": "Û", "&Ucy;": "У", "&Udblac;": "Ű", "&Ufr;": "𝔘", "&Ugrave": "Ù", "&Ugrave;": "Ù", "&Umacr;": "Ū", "&UnderBar;": "_", "&UnderBrace;": "⏟", "&UnderBracket;": "⎵", "&UnderParenthesis;": "⏝", "&Union;": "⋃", "&UnionPlus;": "⊎", "&Uogon;": "Ų", "&Uopf;": "𝕌", "&UpArrow;": "↑", "&UpArrowBar;": "⤒", "&UpArrowDownArrow;": "⇅", "&UpDownArrow;": "↕", "&UpEquilibrium;": "⥮", "&UpTee;": "⊥", "&UpTeeArrow;": "↥", "&Uparrow;": "⇑", "&Updownarrow;": "⇕", "&UpperLeftArrow;": "↖", "&UpperRightArrow;": "↗", "&Upsi;": "ϒ", "&Upsilon;": "Υ", "&Uring;": "Ů", "&Uscr;": "𝒰", "&Utilde;": "Ũ", "&Uuml": "Ü", "&Uuml;": "Ü", "&VDash;": "⊫", "&Vbar;": "⫫", "&Vcy;": "В", "&Vdash;": "⊩", "&Vdashl;": "⫦", "&Vee;": "⋁", "&Verbar;": "‖", "&Vert;": "‖", "&VerticalBar;": "∣", "&VerticalLine;": "|", "&VerticalSeparator;": "❘", "&VerticalTilde;": "≀", "&VeryThinSpace;": " ", "&Vfr;": "𝔙", "&Vopf;": "𝕍", "&Vscr;": "𝒱", "&Vvdash;": "⊪", "&Wcirc;": "Ŵ", "&Wedge;": "⋀", "&Wfr;": "𝔚", "&Wopf;": "𝕎", "&Wscr;": "𝒲", "&Xfr;": "𝔛", "&Xi;": "Ξ", "&Xopf;": "𝕏", "&Xscr;": "𝒳", "&YAcy;": "Я", "&YIcy;": "Ї", "&YUcy;": "Ю", "&Yacute": "Ý", "&Yacute;": "Ý", "&Ycirc;": "Ŷ", "&Ycy;": "Ы", "&Yfr;": "𝔜", "&Yopf;": "𝕐", "&Yscr;": "𝒴", "&Yuml;": "Ÿ", "&ZHcy;": "Ж", "&Zacute;": "Ź", "&Zcaron;": "Ž", "&Zcy;": "З", "&Zdot;": "Ż", "&ZeroWidthSpace;": "​", "&Zeta;": "Ζ", "&Zfr;": "ℨ", "&Zopf;": "ℤ", "&Zscr;": "𝒵", "&aacute": "á", "&aacute;": "á", "&abreve;": "ă", "&ac;": "∾", "&acE;": "∾̳", "&acd;": "∿", "&acirc": "â", "&acirc;": "â", "&acute": "´", "&acute;": "´", "&acy;": "а", "&aelig": "æ", "&aelig;": "æ", "&af;": "⁡", "&afr;": "𝔞", "&agrave": "à", "&agrave;": "à", "&alefsym;": "ℵ", "&aleph;": "ℵ", "&alpha;": "α", "&amacr;": "ā", "&amalg;": "⨿", "&amp": "&", "&amp;": "&", "&and;": "∧", "&andand;": "⩕", "&andd;": "⩜", "&andslope;": "⩘", "&andv;": "⩚", "&ang;": "∠", "&ange;": "⦤", "&angle;": "∠", "&angmsd;": "∡", "&angmsdaa;": "⦨", "&angmsdab;": "⦩", "&angmsdac;": "⦪", "&angmsdad;": "⦫", "&angmsdae;": "⦬", "&angmsdaf;": "⦭", "&angmsdag;": "⦮", "&angmsdah;": "⦯", "&angrt;": "∟", "&angrtvb;": "⊾", "&angrtvbd;": "⦝", "&angsph;": "∢", "&angst;": "Å", "&angzarr;": "⍼", "&aogon;": "ą", "&aopf;": "𝕒", "&ap;": "≈", "&apE;": "⩰", "&apacir;": "⩯", "&ape;": "≊", "&apid;": "≋", "&apos;": "'", "&approx;": "≈", "&approxeq;": "≊", "&aring": "å", "&aring;": "å", "&ascr;": "𝒶", "&ast;": "*", "&asymp;": "≈", "&asympeq;": "≍", "&atilde": "ã", "&atilde;": "ã", "&auml": "ä", "&auml;": "ä", "&awconint;": "∳", "&awint;": "⨑", "&bNot;": "⫭", "&backcong;": "≌", "&backepsilon;": "϶", "&backprime;": "‵", "&backsim;": "∽", "&backsimeq;": "⋍", "&barvee;": "⊽", "&barwed;": "⌅", "&barwedge;": "⌅", "&bbrk;": "⎵", "&bbrktbrk;": "⎶", "&bcong;": "≌", "&bcy;": "б", "&bdquo;": "„", "&becaus;": "∵", "&because;": "∵", "&bemptyv;": "⦰", "&bepsi;": "϶", "&bernou;": "ℬ", "&beta;": "β", "&beth;": "ℶ", "&between;": "≬", "&bfr;": "𝔟", "&bigcap;": "⋂", "&bigcirc;": "◯", "&bigcup;": "⋃", "&bigodot;": "⨀", "&bigoplus;": "⨁", "&bigotimes;": "⨂", "&bigsqcup;": "⨆", "&bigstar;": "★", "&bigtriangledown;": "▽", "&bigtriangleup;": "△", "&biguplus;": "⨄", "&bigvee;": "⋁", "&bigwedge;": "⋀", "&bkarow;": "⤍", "&blacklozenge;": "⧫", "&blacksquare;": "▪", "&blacktriangle;": "▴", "&blacktriangledown;": "▾", "&blacktriangleleft;": "◂", "&blacktriangleright;": "▸", "&blank;": "␣", "&blk12;": "▒", "&blk14;": "░", "&blk34;": "▓", "&block;": "█", "&bne;": "=⃥", "&bnequiv;": "≡⃥", "&bnot;": "⌐", "&bopf;": "𝕓", "&bot;": "⊥", "&bottom;": "⊥", "&bowtie;": "⋈", "&boxDL;": "╗", "&boxDR;": "╔", "&boxDl;": "╖", "&boxDr;": "╓", "&boxH;": "═", "&boxHD;": "╦", "&boxHU;": "╩", "&boxHd;": "╤", "&boxHu;": "╧", "&boxUL;": "╝", "&boxUR;": "╚", "&boxUl;": "╜", "&boxUr;": "╙", "&boxV;": "║", "&boxVH;": "╬", "&boxVL;": "╣", "&boxVR;": "╠", "&boxVh;": "╫", "&boxVl;": "╢", "&boxVr;": "╟", "&boxbox;": "⧉", "&boxdL;": "╕", "&boxdR;": "╒", "&boxdl;": "┐", "&boxdr;": "┌", "&boxh;": "─", "&boxhD;": "╥", "&boxhU;": "╨", "&boxhd;": "┬", "&boxhu;": "┴", "&boxminus;": "⊟", "&boxplus;": "⊞", "&boxtimes;": "⊠", "&boxuL;": "╛", "&boxuR;": "╘", "&boxul;": "┘", "&boxur;": "└", "&boxv;": "│", "&boxvH;": "╪", "&boxvL;": "╡", "&boxvR;": "╞", "&boxvh;": "┼", "&boxvl;": "┤", "&boxvr;": "├", "&bprime;": "‵", "&breve;": "˘", "&brvbar": "¦", "&brvbar;": "¦", "&bscr;": "𝒷", "&bsemi;": "⁏", "&bsim;": "∽", "&bsime;": "⋍", "&bsol;": "\\", "&bsolb;": "⧅", "&bsolhsub;": "⟈", "&bull;": "•", "&bullet;": "•", "&bump;": "≎", "&bumpE;": "⪮", "&bumpe;": "≏", "&bumpeq;": "≏", "&cacute;": "ć", "&cap;": "∩", "&capand;": "⩄", "&capbrcup;": "⩉", "&capcap;": "⩋", "&capcup;": "⩇", "&capdot;": "⩀", "&caps;": "∩︀", "&caret;": "⁁", "&caron;": "ˇ", "&ccaps;": "⩍", "&ccaron;": "č", "&ccedil": "ç", "&ccedil;": "ç", "&ccirc;": "ĉ", "&ccups;": "⩌", "&ccupssm;": "⩐", "&cdot;": "ċ", "&cedil": "¸", "&cedil;": "¸", "&cemptyv;": "⦲", "&cent": "¢", "&cent;": "¢", "&centerdot;": "·", "&cfr;": "𝔠", "&chcy;": "ч", "&check;": "✓", "&checkmark;": "✓", "&chi;": "χ", "&cir;": "○", "&cirE;": "⧃", "&circ;": "ˆ", "&circeq;": "≗", "&circlearrowleft;": "↺", "&circlearrowright;": "↻", "&circledR;": "®", "&circledS;": "Ⓢ", "&circledast;": "⊛", "&circledcirc;": "⊚", "&circleddash;": "⊝", "&cire;": "≗", "&cirfnint;": "⨐", "&cirmid;": "⫯", "&cirscir;": "⧂", "&clubs;": "♣", "&clubsuit;": "♣", "&colon;": ":", "&colone;": "≔", "&coloneq;": "≔", "&comma;": ",", "&commat;": "@", "&comp;": "∁", "&compfn;": "∘", "&complement;": "∁", "&complexes;": "ℂ", "&cong;": "≅", "&congdot;": "⩭", "&conint;": "∮", "&copf;": "𝕔", "&coprod;": "∐", "&copy": "©", "&copy;": "©", "&copysr;": "℗", "&crarr;": "↵", "&cross;": "✗", "&cscr;": "𝒸", "&csub;": "⫏", "&csube;": "⫑", "&csup;": "⫐", "&csupe;": "⫒", "&ctdot;": "⋯", "&cudarrl;": "⤸", "&cudarrr;": "⤵", "&cuepr;": "⋞", "&cuesc;": "⋟", "&cularr;": "↶", "&cularrp;": "⤽", "&cup;": "∪", "&cupbrcap;": "⩈", "&cupcap;": "⩆", "&cupcup;": "⩊", "&cupdot;": "⊍", "&cupor;": "⩅", "&cups;": "∪︀", "&curarr;": "↷", "&curarrm;": "⤼", "&curlyeqprec;": "⋞", "&curlyeqsucc;": "⋟", "&curlyvee;": "⋎", "&curlywedge;": "⋏", "&curren": "¤", "&curren;": "¤", "&curvearrowleft;": "↶", "&curvearrowright;": "↷", "&cuvee;": "⋎", "&cuwed;": "⋏", "&cwconint;": "∲", "&cwint;": "∱", "&cylcty;": "⌭", "&dArr;": "⇓", "&dHar;": "⥥", "&dagger;": "†", "&daleth;": "ℸ", "&darr;": "↓", "&dash;": "‐", "&dashv;": "⊣", "&dbkarow;": "⤏", "&dblac;": "˝", "&dcaron;": "ď", "&dcy;": "д", "&dd;": "ⅆ", "&ddagger;": "‡", "&ddarr;": "⇊", "&ddotseq;": "⩷", "&deg": "°", "&deg;": "°", "&delta;": "δ", "&demptyv;": "⦱", "&dfisht;": "⥿", "&dfr;": "𝔡", "&dharl;": "⇃", "&dharr;": "⇂", "&diam;": "⋄", "&diamond;": "⋄", "&diamondsuit;": "♦", "&diams;": "♦", "&die;": "¨", "&digamma;": "ϝ", "&disin;": "⋲", "&div;": "÷", "&divide": "÷", "&divide;": "÷", "&divideontimes;": "⋇", "&divonx;": "⋇", "&djcy;": "ђ", "&dlcorn;": "⌞", "&dlcrop;": "⌍", "&dollar;": "$", "&dopf;": "𝕕", "&dot;": "˙", "&doteq;": "≐", "&doteqdot;": "≑", "&dotminus;": "∸", "&dotplus;": "∔", "&dotsquare;": "⊡", "&doublebarwedge;": "⌆", "&downarrow;": "↓", "&downdownarrows;": "⇊", "&downharpoonleft;": "⇃", "&downharpoonright;": "⇂", "&drbkarow;": "⤐", "&drcorn;": "⌟", "&drcrop;": "⌌", "&dscr;": "𝒹", "&dscy;": "ѕ", "&dsol;": "⧶", "&dstrok;": "đ", "&dtdot;": "⋱", "&dtri;": "▿", "&dtrif;": "▾", "&duarr;": "⇵", "&duhar;": "⥯", "&dwangle;": "⦦", "&dzcy;": "џ", "&dzigrarr;": "⟿", "&eDDot;": "⩷", "&eDot;": "≑", "&eacute": "é", "&eacute;": "é", "&easter;": "⩮", "&ecaron;": "ě", "&ecir;": "≖", "&ecirc": "ê", "&ecirc;": "ê", "&ecolon;": "≕", "&ecy;": "э", "&edot;": "ė", "&ee;": "ⅇ", "&efDot;": "≒", "&efr;": "𝔢", "&eg;": "⪚", "&egrave": "è", "&egrave;": "è", "&egs;": "⪖", "&egsdot;": "⪘", "&el;": "⪙", "&elinters;": "⏧", "&ell;": "ℓ", "&els;": "⪕", "&elsdot;": "⪗", "&emacr;": "ē", "&empty;": "∅", "&emptyset;": "∅", "&emptyv;": "∅", "&emsp13;": " ", "&emsp14;": " ", "&emsp;": " ", "&eng;": "ŋ", "&ensp;": " ", "&eogon;": "ę", "&eopf;": "𝕖", "&epar;": "⋕", "&eparsl;": "⧣", "&eplus;": "⩱", "&epsi;": "ε", "&epsilon;": "ε", "&epsiv;": "ϵ", "&eqcirc;": "≖", "&eqcolon;": "≕", "&eqsim;": "≂", "&eqslantgtr;": "⪖", "&eqslantless;": "⪕", "&equals;": "=", "&equest;": "≟", "&equiv;": "≡", "&equivDD;": "⩸", "&eqvparsl;": "⧥", "&erDot;": "≓", "&erarr;": "⥱", "&escr;": "ℯ", "&esdot;": "≐", "&esim;": "≂", "&eta;": "η", "&eth": "ð", "&eth;": "ð", "&euml": "ë", "&euml;": "ë", "&euro;": "€", "&excl;": "!", "&exist;": "∃", "&expectation;": "ℰ", "&exponentiale;": "ⅇ", "&fallingdotseq;": "≒", "&fcy;": "ф", "&female;": "♀", "&ffilig;": "ﬃ", "&fflig;": "ﬀ", "&ffllig;": "ﬄ", "&ffr;": "𝔣", "&filig;": "ﬁ", "&fjlig;": "fj", "&flat;": "♭", "&fllig;": "ﬂ", "&fltns;": "▱", "&fnof;": "ƒ", "&fopf;": "𝕗", "&forall;": "∀", "&fork;": "⋔", "&forkv;": "⫙", "&fpartint;": "⨍", "&frac12": "½", "&frac12;": "½", "&frac13;": "⅓", "&frac14": "¼", "&frac14;": "¼", "&frac15;": "⅕", "&frac16;": "⅙", "&frac18;": "⅛", "&frac23;": "⅔", "&frac25;": "⅖", "&frac34": "¾", "&frac34;": "¾", "&frac35;": "⅗", "&frac38;": "⅜", "&frac45;": "⅘", "&frac56;": "⅚", "&frac58;": "⅝", "&frac78;": "⅞", "&frasl;": "⁄", "&frown;": "⌢", "&fscr;": "𝒻", "&gE;": "≧", "&gEl;": "⪌", "&gacute;": "ǵ", "&gamma;": "γ", "&gammad;": "ϝ", "&gap;": "⪆", "&gbreve;": "ğ", "&gcirc;": "ĝ", "&gcy;": "г", "&gdot;": "ġ", "&ge;": "≥", "&gel;": "⋛", "&geq;": "≥", "&geqq;": "≧", "&geqslant;": "⩾", "&ges;": "⩾", "&gescc;": "⪩", "&gesdot;": "⪀", "&gesdoto;": "⪂", "&gesdotol;": "⪄", "&gesl;": "⋛︀", "&gesles;": "⪔", "&gfr;": "𝔤", "&gg;": "≫", "&ggg;": "⋙", "&gimel;": "ℷ", "&gjcy;": "ѓ", "&gl;": "≷", "&glE;": "⪒", "&gla;": "⪥", "&glj;": "⪤", "&gnE;": "≩", "&gnap;": "⪊", "&gnapprox;": "⪊", "&gne;": "⪈", "&gneq;": "⪈", "&gneqq;": "≩", "&gnsim;": "⋧", "&gopf;": "𝕘", "&grave;": "`", "&gscr;": "ℊ", "&gsim;": "≳", "&gsime;": "⪎", "&gsiml;": "⪐", "&gt": ">", "&gt;": ">", "&gtcc;": "⪧", "&gtcir;": "⩺", "&gtdot;": "⋗", "&gtlPar;": "⦕", "&gtquest;": "⩼", "&gtrapprox;": "⪆", "&gtrarr;": "⥸", "&gtrdot;": "⋗", "&gtreqless;": "⋛", "&gtreqqless;": "⪌", "&gtrless;": "≷", "&gtrsim;": "≳", "&gvertneqq;": "≩︀", "&gvnE;": "≩︀", "&hArr;": "⇔", "&hairsp;": " ", "&half;": "½", "&hamilt;": "ℋ", "&hardcy;": "ъ", "&harr;": "↔", "&harrcir;": "⥈", "&harrw;": "↭", "&hbar;": "ℏ", "&hcirc;": "ĥ", "&hearts;": "♥", "&heartsuit;": "♥", "&hellip;": "…", "&hercon;": "⊹", "&hfr;": "𝔥", "&hksearow;": "⤥", "&hkswarow;": "⤦", "&hoarr;": "⇿", "&homtht;": "∻", "&hookleftarrow;": "↩", "&hookrightarrow;": "↪", "&hopf;": "𝕙", "&horbar;": "―", "&hscr;": "𝒽", "&hslash;": "ℏ", "&hstrok;": "ħ", "&hybull;": "⁃", "&hyphen;": "‐", "&iacute": "í", "&iacute;": "í", "&ic;": "⁣", "&icirc": "î", "&icirc;": "î", "&icy;": "и", "&iecy;": "е", "&iexcl": "¡", "&iexcl;": "¡", "&iff;": "⇔", "&ifr;": "𝔦", "&igrave": "ì", "&igrave;": "ì", "&ii;": "ⅈ", "&iiiint;": "⨌", "&iiint;": "∭", "&iinfin;": "⧜", "&iiota;": "℩", "&ijlig;": "ĳ", "&imacr;": "ī", "&image;": "ℑ", "&imagline;": "ℐ", "&imagpart;": "ℑ", "&imath;": "ı", "&imof;": "⊷", "&imped;": "Ƶ", "&in;": "∈", "&incare;": "℅", "&infin;": "∞", "&infintie;": "⧝", "&inodot;": "ı", "&int;": "∫", "&intcal;": "⊺", "&integers;": "ℤ", "&intercal;": "⊺", "&intlarhk;": "⨗", "&intprod;": "⨼", "&iocy;": "ё", "&iogon;": "į", "&iopf;": "𝕚", "&iota;": "ι", "&iprod;": "⨼", "&iquest": "¿", "&iquest;": "¿", "&iscr;": "𝒾", "&isin;": "∈", "&isinE;": "⋹", "&isindot;": "⋵", "&isins;": "⋴", "&isinsv;": "⋳", "&isinv;": "∈", "&it;": "⁢", "&itilde;": "ĩ", "&iukcy;": "і", "&iuml": "ï", "&iuml;": "ï", "&jcirc;": "ĵ", "&jcy;": "й", "&jfr;": "𝔧", "&jmath;": "ȷ", "&jopf;": "𝕛", "&jscr;": "𝒿", "&jsercy;": "ј", "&jukcy;": "є", "&kappa;": "κ", "&kappav;": "ϰ", "&kcedil;": "ķ", "&kcy;": "к", "&kfr;": "𝔨", "&kgreen;": "ĸ", "&khcy;": "х", "&kjcy;": "ќ", "&kopf;": "𝕜", "&kscr;": "𝓀", "&lAarr;": "⇚", "&lArr;": "⇐", "&lAtail;": "⤛", "&lBarr;": "⤎", "&lE;": "≦", "&lEg;": "⪋", "&lHar;": "⥢", "&lacute;": "ĺ", "&laemptyv;": "⦴", "&lagran;": "ℒ", "&lambda;": "λ", "&lang;": "⟨", "&langd;": "⦑", "&langle;": "⟨", "&lap;": "⪅", "&laquo": "«", "&laquo;": "«", "&larr;": "←", "&larrb;": "⇤", "&larrbfs;": "⤟", "&larrfs;": "⤝", "&larrhk;": "↩", "&larrlp;": "↫", "&larrpl;": "⤹", "&larrsim;": "⥳", "&larrtl;": "↢", "&lat;": "⪫", "&latail;": "⤙", "&late;": "⪭", "&lates;": "⪭︀", "&lbarr;": "⤌", "&lbbrk;": "❲", "&lbrace;": "{", "&lbrack;": "[", "&lbrke;": "⦋", "&lbrksld;": "⦏", "&lbrkslu;": "⦍", "&lcaron;": "ľ", "&lcedil;": "ļ", "&lceil;": "⌈", "&lcub;": "{", "&lcy;": "л", "&ldca;": "⤶", "&ldquo;": "“", "&ldquor;": "„", "&ldrdhar;": "⥧", "&ldrushar;": "⥋", "&ldsh;": "↲", "&le;": "≤", "&leftarrow;": "←", "&leftarrowtail;": "↢", "&leftharpoondown;": "↽", "&leftharpoonup;": "↼", "&leftleftarrows;": "⇇", "&leftrightarrow;": "↔", "&leftrightarrows;": "⇆", "&leftrightharpoons;": "⇋", "&leftrightsquigarrow;": "↭", "&leftthreetimes;": "⋋", "&leg;": "⋚", "&leq;": "≤", "&leqq;": "≦", "&leqslant;": "⩽", "&les;": "⩽", "&lescc;": "⪨", "&lesdot;": "⩿", "&lesdoto;": "⪁", "&lesdotor;": "⪃", "&lesg;": "⋚︀", "&lesges;": "⪓", "&lessapprox;": "⪅", "&lessdot;": "⋖", "&lesseqgtr;": "⋚", "&lesseqqgtr;": "⪋", "&lessgtr;": "≶", "&lesssim;": "≲", "&lfisht;": "⥼", "&lfloor;": "⌊", "&lfr;": "𝔩", "&lg;": "≶", "&lgE;": "⪑", "&lhard;": "↽", "&lharu;": "↼", "&lharul;": "⥪", "&lhblk;": "▄", "&ljcy;": "љ", "&ll;": "≪", "&llarr;": "⇇", "&llcorner;": "⌞", "&llhard;": "⥫", "&lltri;": "◺", "&lmidot;": "ŀ", "&lmoust;": "⎰", "&lmoustache;": "⎰", "&lnE;": "≨", "&lnap;": "⪉", "&lnapprox;": "⪉", "&lne;": "⪇", "&lneq;": "⪇", "&lneqq;": "≨", "&lnsim;": "⋦", "&loang;": "⟬", "&loarr;": "⇽", "&lobrk;": "⟦", "&longleftarrow;": "⟵", "&longleftrightarrow;": "⟷", "&longmapsto;": "⟼", "&longrightarrow;": "⟶", "&looparrowleft;": "↫", "&looparrowright;": "↬", "&lopar;": "⦅", "&lopf;": "𝕝", "&loplus;": "⨭", "&lotimes;": "⨴", "&lowast;": "∗", "&lowbar;": "_", "&loz;": "◊", "&lozenge;": "◊", "&lozf;": "⧫", "&lpar;": "(", "&lparlt;": "⦓", "&lrarr;": "⇆", "&lrcorner;": "⌟", "&lrhar;": "⇋", "&lrhard;": "⥭", "&lrm;": "‎", "&lrtri;": "⊿", "&lsaquo;": "‹", "&lscr;": "𝓁", "&lsh;": "↰", "&lsim;": "≲", "&lsime;": "⪍", "&lsimg;": "⪏", "&lsqb;": "[", "&lsquo;": "‘", "&lsquor;": "‚", "&lstrok;": "ł", "&lt": "<", "&lt;": "<", "&ltcc;": "⪦", "&ltcir;": "⩹", "&ltdot;": "⋖", "&lthree;": "⋋", "&ltimes;": "⋉", "&ltlarr;": "⥶", "&ltquest;": "⩻", "&ltrPar;": "⦖", "&ltri;": "◃", "&ltrie;": "⊴", "&ltrif;": "◂", "&lurdshar;": "⥊", "&luruhar;": "⥦", "&lvertneqq;": "≨︀", "&lvnE;": "≨︀", "&mDDot;": "∺", "&macr": "¯", "&macr;": "¯", "&male;": "♂", "&malt;": "✠", "&maltese;": "✠", "&map;": "↦", "&mapsto;": "↦", "&mapstodown;": "↧", "&mapstoleft;": "↤", "&mapstoup;": "↥", "&marker;": "▮", "&mcomma;": "⨩", "&mcy;": "м", "&mdash;": "—", "&measuredangle;": "∡", "&mfr;": "𝔪", "&mho;": "℧", "&micro": "µ", "&micro;": "µ", "&mid;": "∣", "&midast;": "*", "&midcir;": "⫰", "&middot": "·", "&middot;": "·", "&minus;": "−", "&minusb;": "⊟", "&minusd;": "∸", "&minusdu;": "⨪", "&mlcp;": "⫛", "&mldr;": "…", "&mnplus;": "∓", "&models;": "⊧", "&mopf;": "𝕞", "&mp;": "∓", "&mscr;": "𝓂", "&mstpos;": "∾", "&mu;": "μ", "&multimap;": "⊸", "&mumap;": "⊸", "&nGg;": "⋙̸", "&nGt;": "≫⃒", "&nGtv;": "≫̸", "&nLeftarrow;": "⇍", "&nLeftrightarrow;": "⇎", "&nLl;": "⋘̸", "&nLt;": "≪⃒", "&nLtv;": "≪̸", "&nRightarrow;": "⇏", "&nVDash;": "⊯", "&nVdash;": "⊮", "&nabla;": "∇", "&nacute;": "ń", "&nang;": "∠⃒", "&nap;": "≉", "&napE;": "⩰̸", "&napid;": "≋̸", "&napos;": "ŉ", "&napprox;": "≉", "&natur;": "♮", "&natural;": "♮", "&naturals;": "ℕ", "&nbsp": " ", "&nbsp;": " ", "&nbump;": "≎̸", "&nbumpe;": "≏̸", "&ncap;": "⩃", "&ncaron;": "ň", "&ncedil;": "ņ", "&ncong;": "≇", "&ncongdot;": "⩭̸", "&ncup;": "⩂", "&ncy;": "н", "&ndash;": "–", "&ne;": "≠", "&neArr;": "⇗", "&nearhk;": "⤤", "&nearr;": "↗", "&nearrow;": "↗", "&nedot;": "≐̸", "&nequiv;": "≢", "&nesear;": "⤨", "&nesim;": "≂̸", "&nexist;": "∄", "&nexists;": "∄", "&nfr;": "𝔫", "&ngE;": "≧̸", "&nge;": "≱", "&ngeq;": "≱", "&ngeqq;": "≧̸", "&ngeqslant;": "⩾̸", "&nges;": "⩾̸", "&ngsim;": "≵", "&ngt;": "≯", "&ngtr;": "≯", "&nhArr;": "⇎", "&nharr;": "↮", "&nhpar;": "⫲", "&ni;": "∋", "&nis;": "⋼", "&nisd;": "⋺", "&niv;": "∋", "&njcy;": "њ", "&nlArr;": "⇍", "&nlE;": "≦̸", "&nlarr;": "↚", "&nldr;": "‥", "&nle;": "≰", "&nleftarrow;": "↚", "&nleftrightarrow;": "↮", "&nleq;": "≰", "&nleqq;": "≦̸", "&nleqslant;": "⩽̸", "&nles;": "⩽̸", "&nless;": "≮", "&nlsim;": "≴", "&nlt;": "≮", "&nltri;": "⋪", "&nltrie;": "⋬", "&nmid;": "∤", "&nopf;": "𝕟", "&not": "¬", "&not;": "¬", "&notin;": "∉", "&notinE;": "⋹̸", "&notindot;": "⋵̸", "&notinva;": "∉", "&notinvb;": "⋷", "&notinvc;": "⋶", "&notni;": "∌", "&notniva;": "∌", "&notnivb;": "⋾", "&notnivc;": "⋽", "&npar;": "∦", "&nparallel;": "∦", "&nparsl;": "⫽⃥", "&npart;": "∂̸", "&npolint;": "⨔", "&npr;": "⊀", "&nprcue;": "⋠", "&npre;": "⪯̸", "&nprec;": "⊀", "&npreceq;": "⪯̸", "&nrArr;": "⇏", "&nrarr;": "↛", "&nrarrc;": "⤳̸", "&nrarrw;": "↝̸", "&nrightarrow;": "↛", "&nrtri;": "⋫", "&nrtrie;": "⋭", "&nsc;": "⊁", "&nsccue;": "⋡", "&nsce;": "⪰̸", "&nscr;": "𝓃", "&nshortmid;": "∤", "&nshortparallel;": "∦", "&nsim;": "≁", "&nsime;": "≄", "&nsimeq;": "≄", "&nsmid;": "∤", "&nspar;": "∦", "&nsqsube;": "⋢", "&nsqsupe;": "⋣", "&nsub;": "⊄", "&nsubE;": "⫅̸", "&nsube;": "⊈", "&nsubset;": "⊂⃒", "&nsubseteq;": "⊈", "&nsubseteqq;": "⫅̸", "&nsucc;": "⊁", "&nsucceq;": "⪰̸", "&nsup;": "⊅", "&nsupE;": "⫆̸", "&nsupe;": "⊉", "&nsupset;": "⊃⃒", "&nsupseteq;": "⊉", "&nsupseteqq;": "⫆̸", "&ntgl;": "≹", "&ntilde": "ñ", "&ntilde;": "ñ", "&ntlg;": "≸", "&ntriangleleft;": "⋪", "&ntrianglelefteq;": "⋬", "&ntriangleright;": "⋫", "&ntrianglerighteq;": "⋭", "&nu;": "ν", "&num;": "#", "&numero;": "№", "&numsp;": " ", "&nvDash;": "⊭", "&nvHarr;": "⤄", "&nvap;": "≍⃒", "&nvdash;": "⊬", "&nvge;": "≥⃒", "&nvgt;": ">⃒", "&nvinfin;": "⧞", "&nvlArr;": "⤂", "&nvle;": "≤⃒", "&nvlt;": "<⃒", "&nvltrie;": "⊴⃒", "&nvrArr;": "⤃", "&nvrtrie;": "⊵⃒", "&nvsim;": "∼⃒", "&nwArr;": "⇖", "&nwarhk;": "⤣", "&nwarr;": "↖", "&nwarrow;": "↖", "&nwnear;": "⤧", "&oS;": "Ⓢ", "&oacute": "ó", "&oacute;": "ó", "&oast;": "⊛", "&ocir;": "⊚", "&ocirc": "ô", "&ocirc;": "ô", "&ocy;": "о", "&odash;": "⊝", "&odblac;": "ő", "&odiv;": "⨸", "&odot;": "⊙", "&odsold;": "⦼", "&oelig;": "œ", "&ofcir;": "⦿", "&ofr;": "𝔬", "&ogon;": "˛", "&ograve": "ò", "&ograve;": "ò", "&ogt;": "⧁", "&ohbar;": "⦵", "&ohm;": "Ω", "&oint;": "∮", "&olarr;": "↺", "&olcir;": "⦾", "&olcross;": "⦻", "&oline;": "‾", "&olt;": "⧀", "&omacr;": "ō", "&omega;": "ω", "&omicron;": "ο", "&omid;": "⦶", "&ominus;": "⊖", "&oopf;": "𝕠", "&opar;": "⦷", "&operp;": "⦹", "&oplus;": "⊕", "&or;": "∨", "&orarr;": "↻", "&ord;": "⩝", "&order;": "ℴ", "&orderof;": "ℴ", "&ordf": "ª", "&ordf;": "ª", "&ordm": "º", "&ordm;": "º", "&origof;": "⊶", "&oror;": "⩖", "&orslope;": "⩗", "&orv;": "⩛", "&oscr;": "ℴ", "&oslash": "ø", "&oslash;": "ø", "&osol;": "⊘", "&otilde": "õ", "&otilde;": "õ", "&otimes;": "⊗", "&otimesas;": "⨶", "&ouml": "ö", "&ouml;": "ö", "&ovbar;": "⌽", "&par;": "∥", "&para": "¶", "&para;": "¶", "&parallel;": "∥", "&parsim;": "⫳", "&parsl;": "⫽", "&part;": "∂", "&pcy;": "п", "&percnt;": "%", "&period;": ".", "&permil;": "‰", "&perp;": "⊥", "&pertenk;": "‱", "&pfr;": "𝔭", "&phi;": "φ", "&phiv;": "ϕ", "&phmmat;": "ℳ", "&phone;": "☎", "&pi;": "π", "&pitchfork;": "⋔", "&piv;": "ϖ", "&planck;": "ℏ", "&planckh;": "ℎ", "&plankv;": "ℏ", "&plus;": "+", "&plusacir;": "⨣", "&plusb;": "⊞", "&pluscir;": "⨢", "&plusdo;": "∔", "&plusdu;": "⨥", "&pluse;": "⩲", "&plusmn": "±", "&plusmn;": "±", "&plussim;": "⨦", "&plustwo;": "⨧", "&pm;": "±", "&pointint;": "⨕", "&popf;": "𝕡", "&pound": "£", "&pound;": "£", "&pr;": "≺", "&prE;": "⪳", "&prap;": "⪷", "&prcue;": "≼", "&pre;": "⪯", "&prec;": "≺", "&precapprox;": "⪷", "&preccurlyeq;": "≼", "&preceq;": "⪯", "&precnapprox;": "⪹", "&precneqq;": "⪵", "&precnsim;": "⋨", "&precsim;": "≾", "&prime;": "′", "&primes;": "ℙ", "&prnE;": "⪵", "&prnap;": "⪹", "&prnsim;": "⋨", "&prod;": "∏", "&profalar;": "⌮", "&profline;": "⌒", "&profsurf;": "⌓", "&prop;": "∝", "&propto;": "∝", "&prsim;": "≾", "&prurel;": "⊰", "&pscr;": "𝓅", "&psi;": "ψ", "&puncsp;": " ", "&qfr;": "𝔮", "&qint;": "⨌", "&qopf;": "𝕢", "&qprime;": "⁗", "&qscr;": "𝓆", "&quaternions;": "ℍ", "&quatint;": "⨖", "&quest;": "?", "&questeq;": "≟", "&quot": '"', "&quot;": '"', "&rAarr;": "⇛", "&rArr;": "⇒", "&rAtail;": "⤜", "&rBarr;": "⤏", "&rHar;": "⥤", "&race;": "∽̱", "&racute;": "ŕ", "&radic;": "√", "&raemptyv;": "⦳", "&rang;": "⟩", "&rangd;": "⦒", "&range;": "⦥", "&rangle;": "⟩", "&raquo": "»", "&raquo;": "»", "&rarr;": "→", "&rarrap;": "⥵", "&rarrb;": "⇥", "&rarrbfs;": "⤠", "&rarrc;": "⤳", "&rarrfs;": "⤞", "&rarrhk;": "↪", "&rarrlp;": "↬", "&rarrpl;": "⥅", "&rarrsim;": "⥴", "&rarrtl;": "↣", "&rarrw;": "↝", "&ratail;": "⤚", "&ratio;": "∶", "&rationals;": "ℚ", "&rbarr;": "⤍", "&rbbrk;": "❳", "&rbrace;": "}", "&rbrack;": "]", "&rbrke;": "⦌", "&rbrksld;": "⦎", "&rbrkslu;": "⦐", "&rcaron;": "ř", "&rcedil;": "ŗ", "&rceil;": "⌉", "&rcub;": "}", "&rcy;": "р", "&rdca;": "⤷", "&rdldhar;": "⥩", "&rdquo;": "”", "&rdquor;": "”", "&rdsh;": "↳", "&real;": "ℜ", "&realine;": "ℛ", "&realpart;": "ℜ", "&reals;": "ℝ", "&rect;": "▭", "&reg": "®", "&reg;": "®", "&rfisht;": "⥽", "&rfloor;": "⌋", "&rfr;": "𝔯", "&rhard;": "⇁", "&rharu;": "⇀", "&rharul;": "⥬", "&rho;": "ρ", "&rhov;": "ϱ", "&rightarrow;": "→", "&rightarrowtail;": "↣", "&rightharpoondown;": "⇁", "&rightharpoonup;": "⇀", "&rightleftarrows;": "⇄", "&rightleftharpoons;": "⇌", "&rightrightarrows;": "⇉", "&rightsquigarrow;": "↝", "&rightthreetimes;": "⋌", "&ring;": "˚", "&risingdotseq;": "≓", "&rlarr;": "⇄", "&rlhar;": "⇌", "&rlm;": "‏", "&rmoust;": "⎱", "&rmoustache;": "⎱", "&rnmid;": "⫮", "&roang;": "⟭", "&roarr;": "⇾", "&robrk;": "⟧", "&ropar;": "⦆", "&ropf;": "𝕣", "&roplus;": "⨮", "&rotimes;": "⨵", "&rpar;": ")", "&rpargt;": "⦔", "&rppolint;": "⨒", "&rrarr;": "⇉", "&rsaquo;": "›", "&rscr;": "𝓇", "&rsh;": "↱", "&rsqb;": "]", "&rsquo;": "’", "&rsquor;": "’", "&rthree;": "⋌", "&rtimes;": "⋊", "&rtri;": "▹", "&rtrie;": "⊵", "&rtrif;": "▸", "&rtriltri;": "⧎", "&ruluhar;": "⥨", "&rx;": "℞", "&sacute;": "ś", "&sbquo;": "‚", "&sc;": "≻", "&scE;": "⪴", "&scap;": "⪸", "&scaron;": "š", "&sccue;": "≽", "&sce;": "⪰", "&scedil;": "ş", "&scirc;": "ŝ", "&scnE;": "⪶", "&scnap;": "⪺", "&scnsim;": "⋩", "&scpolint;": "⨓", "&scsim;": "≿", "&scy;": "с", "&sdot;": "⋅", "&sdotb;": "⊡", "&sdote;": "⩦", "&seArr;": "⇘", "&searhk;": "⤥", "&searr;": "↘", "&searrow;": "↘", "&sect": "§", "&sect;": "§", "&semi;": ";", "&seswar;": "⤩", "&setminus;": "∖", "&setmn;": "∖", "&sext;": "✶", "&sfr;": "𝔰", "&sfrown;": "⌢", "&sharp;": "♯", "&shchcy;": "щ", "&shcy;": "ш", "&shortmid;": "∣", "&shortparallel;": "∥", "&shy": "­", "&shy;": "­", "&sigma;": "σ", "&sigmaf;": "ς", "&sigmav;": "ς", "&sim;": "∼", "&simdot;": "⩪", "&sime;": "≃", "&simeq;": "≃", "&simg;": "⪞", "&simgE;": "⪠", "&siml;": "⪝", "&simlE;": "⪟", "&simne;": "≆", "&simplus;": "⨤", "&simrarr;": "⥲", "&slarr;": "←", "&smallsetminus;": "∖", "&smashp;": "⨳", "&smeparsl;": "⧤", "&smid;": "∣", "&smile;": "⌣", "&smt;": "⪪", "&smte;": "⪬", "&smtes;": "⪬︀", "&softcy;": "ь", "&sol;": "/", "&solb;": "⧄", "&solbar;": "⌿", "&sopf;": "𝕤", "&spades;": "♠", "&spadesuit;": "♠", "&spar;": "∥", "&sqcap;": "⊓", "&sqcaps;": "⊓︀", "&sqcup;": "⊔", "&sqcups;": "⊔︀", "&sqsub;": "⊏", "&sqsube;": "⊑", "&sqsubset;": "⊏", "&sqsubseteq;": "⊑", "&sqsup;": "⊐", "&sqsupe;": "⊒", "&sqsupset;": "⊐", "&sqsupseteq;": "⊒", "&squ;": "□", "&square;": "□", "&squarf;": "▪", "&squf;": "▪", "&srarr;": "→", "&sscr;": "𝓈", "&ssetmn;": "∖", "&ssmile;": "⌣", "&sstarf;": "⋆", "&star;": "☆", "&starf;": "★", "&straightepsilon;": "ϵ", "&straightphi;": "ϕ", "&strns;": "¯", "&sub;": "⊂", "&subE;": "⫅", "&subdot;": "⪽", "&sube;": "⊆", "&subedot;": "⫃", "&submult;": "⫁", "&subnE;": "⫋", "&subne;": "⊊", "&subplus;": "⪿", "&subrarr;": "⥹", "&subset;": "⊂", "&subseteq;": "⊆", "&subseteqq;": "⫅", "&subsetneq;": "⊊", "&subsetneqq;": "⫋", "&subsim;": "⫇", "&subsub;": "⫕", "&subsup;": "⫓", "&succ;": "≻", "&succapprox;": "⪸", "&succcurlyeq;": "≽", "&succeq;": "⪰", "&succnapprox;": "⪺", "&succneqq;": "⪶", "&succnsim;": "⋩", "&succsim;": "≿", "&sum;": "∑", "&sung;": "♪", "&sup1": "¹", "&sup1;": "¹", "&sup2": "²", "&sup2;": "²", "&sup3": "³", "&sup3;": "³", "&sup;": "⊃", "&supE;": "⫆", "&supdot;": "⪾", "&supdsub;": "⫘", "&supe;": "⊇", "&supedot;": "⫄", "&suphsol;": "⟉", "&suphsub;": "⫗", "&suplarr;": "⥻", "&supmult;": "⫂", "&supnE;": "⫌", "&supne;": "⊋", "&supplus;": "⫀", "&supset;": "⊃", "&supseteq;": "⊇", "&supseteqq;": "⫆", "&supsetneq;": "⊋", "&supsetneqq;": "⫌", "&supsim;": "⫈", "&supsub;": "⫔", "&supsup;": "⫖", "&swArr;": "⇙", "&swarhk;": "⤦", "&swarr;": "↙", "&swarrow;": "↙", "&swnwar;": "⤪", "&szlig": "ß", "&szlig;": "ß", "&target;": "⌖", "&tau;": "τ", "&tbrk;": "⎴", "&tcaron;": "ť", "&tcedil;": "ţ", "&tcy;": "т", "&tdot;": "⃛", "&telrec;": "⌕", "&tfr;": "𝔱", "&there4;": "∴", "&therefore;": "∴", "&theta;": "θ", "&thetasym;": "ϑ", "&thetav;": "ϑ", "&thickapprox;": "≈", "&thicksim;": "∼", "&thinsp;": " ", "&thkap;": "≈", "&thksim;": "∼", "&thorn": "þ", "&thorn;": "þ", "&tilde;": "˜", "&times": "×", "&times;": "×", "&timesb;": "⊠", "&timesbar;": "⨱", "&timesd;": "⨰", "&tint;": "∭", "&toea;": "⤨", "&top;": "⊤", "&topbot;": "⌶", "&topcir;": "⫱", "&topf;": "𝕥", "&topfork;": "⫚", "&tosa;": "⤩", "&tprime;": "‴", "&trade;": "™", "&triangle;": "▵", "&triangledown;": "▿", "&triangleleft;": "◃", "&trianglelefteq;": "⊴", "&triangleq;": "≜", "&triangleright;": "▹", "&trianglerighteq;": "⊵", "&tridot;": "◬", "&trie;": "≜", "&triminus;": "⨺", "&triplus;": "⨹", "&trisb;": "⧍", "&tritime;": "⨻", "&trpezium;": "⏢", "&tscr;": "𝓉", "&tscy;": "ц", "&tshcy;": "ћ", "&tstrok;": "ŧ", "&twixt;": "≬", "&twoheadleftarrow;": "↞", "&twoheadrightarrow;": "↠", "&uArr;": "⇑", "&uHar;": "⥣", "&uacute": "ú", "&uacute;": "ú", "&uarr;": "↑", "&ubrcy;": "ў", "&ubreve;": "ŭ", "&ucirc": "û", "&ucirc;": "û", "&ucy;": "у", "&udarr;": "⇅", "&udblac;": "ű", "&udhar;": "⥮", "&ufisht;": "⥾", "&ufr;": "𝔲", "&ugrave": "ù", "&ugrave;": "ù", "&uharl;": "↿", "&uharr;": "↾", "&uhblk;": "▀", "&ulcorn;": "⌜", "&ulcorner;": "⌜", "&ulcrop;": "⌏", "&ultri;": "◸", "&umacr;": "ū", "&uml": "¨", "&uml;": "¨", "&uogon;": "ų", "&uopf;": "𝕦", "&uparrow;": "↑", "&updownarrow;": "↕", "&upharpoonleft;": "↿", "&upharpoonright;": "↾", "&uplus;": "⊎", "&upsi;": "υ", "&upsih;": "ϒ", "&upsilon;": "υ", "&upuparrows;": "⇈", "&urcorn;": "⌝", "&urcorner;": "⌝", "&urcrop;": "⌎", "&uring;": "ů", "&urtri;": "◹", "&uscr;": "𝓊", "&utdot;": "⋰", "&utilde;": "ũ", "&utri;": "▵", "&utrif;": "▴", "&uuarr;": "⇈", "&uuml": "ü", "&uuml;": "ü", "&uwangle;": "⦧", "&vArr;": "⇕", "&vBar;": "⫨", "&vBarv;": "⫩", "&vDash;": "⊨", "&vangrt;": "⦜", "&varepsilon;": "ϵ", "&varkappa;": "ϰ", "&varnothing;": "∅", "&varphi;": "ϕ", "&varpi;": "ϖ", "&varpropto;": "∝", "&varr;": "↕", "&varrho;": "ϱ", "&varsigma;": "ς", "&varsubsetneq;": "⊊︀", "&varsubsetneqq;": "⫋︀", "&varsupsetneq;": "⊋︀", "&varsupsetneqq;": "⫌︀", "&vartheta;": "ϑ", "&vartriangleleft;": "⊲", "&vartriangleright;": "⊳", "&vcy;": "в", "&vdash;": "⊢", "&vee;": "∨", "&veebar;": "⊻", "&veeeq;": "≚", "&vellip;": "⋮", "&verbar;": "|", "&vert;": "|", "&vfr;": "𝔳", "&vltri;": "⊲", "&vnsub;": "⊂⃒", "&vnsup;": "⊃⃒", "&vopf;": "𝕧", "&vprop;": "∝", "&vrtri;": "⊳", "&vscr;": "𝓋", "&vsubnE;": "⫋︀", "&vsubne;": "⊊︀", "&vsupnE;": "⫌︀", "&vsupne;": "⊋︀", "&vzigzag;": "⦚", "&wcirc;": "ŵ", "&wedbar;": "⩟", "&wedge;": "∧", "&wedgeq;": "≙", "&weierp;": "℘", "&wfr;": "𝔴", "&wopf;": "𝕨", "&wp;": "℘", "&wr;": "≀", "&wreath;": "≀", "&wscr;": "𝓌", "&xcap;": "⋂", "&xcirc;": "◯", "&xcup;": "⋃", "&xdtri;": "▽", "&xfr;": "𝔵", "&xhArr;": "⟺", "&xharr;": "⟷", "&xi;": "ξ", "&xlArr;": "⟸", "&xlarr;": "⟵", "&xmap;": "⟼", "&xnis;": "⋻", "&xodot;": "⨀", "&xopf;": "𝕩", "&xoplus;": "⨁", "&xotime;": "⨂", "&xrArr;": "⟹", "&xrarr;": "⟶", "&xscr;": "𝓍", "&xsqcup;": "⨆", "&xuplus;": "⨄", "&xutri;": "△", "&xvee;": "⋁", "&xwedge;": "⋀", "&yacute": "ý", "&yacute;": "ý", "&yacy;": "я", "&ycirc;": "ŷ", "&ycy;": "ы", "&yen": "¥", "&yen;": "¥", "&yfr;": "𝔶", "&yicy;": "ї", "&yopf;": "𝕪", "&yscr;": "𝓎", "&yucy;": "ю", "&yuml": "ÿ", "&yuml;": "ÿ", "&zacute;": "ź", "&zcaron;": "ž", "&zcy;": "з", "&zdot;": "ż", "&zeetrf;": "ℨ", "&zeta;": "ζ", "&zfr;": "𝔷", "&zhcy;": "ж", "&zigrarr;": "⇝", "&zopf;": "𝕫", "&zscr;": "𝓏", "&zwj;": "‍", "&zwnj;": "‌" }, characters: { Æ: "&AElig;", "&": "&amp;", Á: "&Aacute;", Ă: "&Abreve;", Â: "&Acirc;", А: "&Acy;", "𝔄": "&Afr;", À: "&Agrave;", Α: "&Alpha;", Ā: "&Amacr;", "⩓": "&And;", Ą: "&Aogon;", "𝔸": "&Aopf;", "⁡": "&af;", Å: "&angst;", "𝒜": "&Ascr;", "≔": "&coloneq;", Ã: "&Atilde;", Ä: "&Auml;", "∖": "&ssetmn;", "⫧": "&Barv;", "⌆": "&doublebarwedge;", Б: "&Bcy;", "∵": "&because;", ℬ: "&bernou;", Β: "&Beta;", "𝔅": "&Bfr;", "𝔹": "&Bopf;", "˘": "&breve;", "≎": "&bump;", Ч: "&CHcy;", "©": "&copy;", Ć: "&Cacute;", "⋒": "&Cap;", "ⅅ": "&DD;", ℭ: "&Cfr;", Č: "&Ccaron;", Ç: "&Ccedil;", Ĉ: "&Ccirc;", "∰": "&Cconint;", Ċ: "&Cdot;", "¸": "&cedil;", "·": "&middot;", Χ: "&Chi;", "⊙": "&odot;", "⊖": "&ominus;", "⊕": "&oplus;", "⊗": "&otimes;", "∲": "&cwconint;", "”": "&rdquor;", "’": "&rsquor;", "∷": "&Proportion;", "⩴": "&Colone;", "≡": "&equiv;", "∯": "&DoubleContourIntegral;", "∮": "&oint;", ℂ: "&complexes;", "∐": "&coprod;", "∳": "&awconint;", "⨯": "&Cross;", "𝒞": "&Cscr;", "⋓": "&Cup;", "≍": "&asympeq;", "⤑": "&DDotrahd;", Ђ: "&DJcy;", Ѕ: "&DScy;", Џ: "&DZcy;", "‡": "&ddagger;", "↡": "&Darr;", "⫤": "&DoubleLeftTee;", Ď: "&Dcaron;", Д: "&Dcy;", "∇": "&nabla;", Δ: "&Delta;", "𝔇": "&Dfr;", "´": "&acute;", "˙": "&dot;", "˝": "&dblac;", "`": "&grave;", "˜": "&tilde;", "⋄": "&diamond;", "ⅆ": "&dd;", "𝔻": "&Dopf;", "¨": "&uml;", "⃜": "&DotDot;", "≐": "&esdot;", "⇓": "&dArr;", "⇐": "&lArr;", "⇔": "&iff;", "⟸": "&xlArr;", "⟺": "&xhArr;", "⟹": "&xrArr;", "⇒": "&rArr;", "⊨": "&vDash;", "⇑": "&uArr;", "⇕": "&vArr;", "∥": "&spar;", "↓": "&downarrow;", "⤓": "&DownArrowBar;", "⇵": "&duarr;", "̑": "&DownBreve;", "⥐": "&DownLeftRightVector;", "⥞": "&DownLeftTeeVector;", "↽": "&lhard;", "⥖": "&DownLeftVectorBar;", "⥟": "&DownRightTeeVector;", "⇁": "&rightharpoondown;", "⥗": "&DownRightVectorBar;", "⊤": "&top;", "↧": "&mapstodown;", "𝒟": "&Dscr;", Đ: "&Dstrok;", Ŋ: "&ENG;", Ð: "&ETH;", É: "&Eacute;", Ě: "&Ecaron;", Ê: "&Ecirc;", Э: "&Ecy;", Ė: "&Edot;", "𝔈": "&Efr;", È: "&Egrave;", "∈": "&isinv;", Ē: "&Emacr;", "◻": "&EmptySmallSquare;", "▫": "&EmptyVerySmallSquare;", Ę: "&Eogon;", "𝔼": "&Eopf;", Ε: "&Epsilon;", "⩵": "&Equal;", "≂": "&esim;", "⇌": "&rlhar;", ℰ: "&expectation;", "⩳": "&Esim;", Η: "&Eta;", Ë: "&Euml;", "∃": "&exist;", "ⅇ": "&exponentiale;", Ф: "&Fcy;", "𝔉": "&Ffr;", "◼": "&FilledSmallSquare;", "▪": "&squf;", "𝔽": "&Fopf;", "∀": "&forall;", ℱ: "&Fscr;", Ѓ: "&GJcy;", ">": "&gt;", Γ: "&Gamma;", Ϝ: "&Gammad;", Ğ: "&Gbreve;", Ģ: "&Gcedil;", Ĝ: "&Gcirc;", Г: "&Gcy;", Ġ: "&Gdot;", "𝔊": "&Gfr;", "⋙": "&ggg;", "𝔾": "&Gopf;", "≥": "&geq;", "⋛": "&gtreqless;", "≧": "&geqq;", "⪢": "&GreaterGreater;", "≷": "&gtrless;", "⩾": "&ges;", "≳": "&gtrsim;", "𝒢": "&Gscr;", "≫": "&gg;", Ъ: "&HARDcy;", "ˇ": "&caron;", "^": "&Hat;", Ĥ: "&Hcirc;", ℌ: "&Poincareplane;", ℋ: "&hamilt;", ℍ: "&quaternions;", "─": "&boxh;", Ħ: "&Hstrok;", "≏": "&bumpeq;", Е: "&IEcy;", Ĳ: "&IJlig;", Ё: "&IOcy;", Í: "&Iacute;", Î: "&Icirc;", И: "&Icy;", İ: "&Idot;", ℑ: "&imagpart;", Ì: "&Igrave;", Ī: "&Imacr;", "ⅈ": "&ii;", "∬": "&Int;", "∫": "&int;", "⋂": "&xcap;", "⁣": "&ic;", "⁢": "&it;", Į: "&Iogon;", "𝕀": "&Iopf;", Ι: "&Iota;", ℐ: "&imagline;", Ĩ: "&Itilde;", І: "&Iukcy;", Ï: "&Iuml;", Ĵ: "&Jcirc;", Й: "&Jcy;", "𝔍": "&Jfr;", "𝕁": "&Jopf;", "𝒥": "&Jscr;", Ј: "&Jsercy;", Є: "&Jukcy;", Х: "&KHcy;", Ќ: "&KJcy;", Κ: "&Kappa;", Ķ: "&Kcedil;", К: "&Kcy;", "𝔎": "&Kfr;", "𝕂": "&Kopf;", "𝒦": "&Kscr;", Љ: "&LJcy;", "<": "&lt;", Ĺ: "&Lacute;", Λ: "&Lambda;", "⟪": "&Lang;", ℒ: "&lagran;", "↞": "&twoheadleftarrow;", Ľ: "&Lcaron;", Ļ: "&Lcedil;", Л: "&Lcy;", "⟨": "&langle;", "←": "&slarr;", "⇤": "&larrb;", "⇆": "&lrarr;", "⌈": "&lceil;", "⟦": "&lobrk;", "⥡": "&LeftDownTeeVector;", "⇃": "&downharpoonleft;", "⥙": "&LeftDownVectorBar;", "⌊": "&lfloor;", "↔": "&leftrightarrow;", "⥎": "&LeftRightVector;", "⊣": "&dashv;", "↤": "&mapstoleft;", "⥚": "&LeftTeeVector;", "⊲": "&vltri;", "⧏": "&LeftTriangleBar;", "⊴": "&trianglelefteq;", "⥑": "&LeftUpDownVector;", "⥠": "&LeftUpTeeVector;", "↿": "&upharpoonleft;", "⥘": "&LeftUpVectorBar;", "↼": "&lharu;", "⥒": "&LeftVectorBar;", "⋚": "&lesseqgtr;", "≦": "&leqq;", "≶": "&lg;", "⪡": "&LessLess;", "⩽": "&les;", "≲": "&lsim;", "𝔏": "&Lfr;", "⋘": "&Ll;", "⇚": "&lAarr;", Ŀ: "&Lmidot;", "⟵": "&xlarr;", "⟷": "&xharr;", "⟶": "&xrarr;", "𝕃": "&Lopf;", "↙": "&swarrow;", "↘": "&searrow;", "↰": "&lsh;", Ł: "&Lstrok;", "≪": "&ll;", "⤅": "&Map;", М: "&Mcy;", " ": "&MediumSpace;", ℳ: "&phmmat;", "𝔐": "&Mfr;", "∓": "&mp;", "𝕄": "&Mopf;", Μ: "&Mu;", Њ: "&NJcy;", Ń: "&Nacute;", Ň: "&Ncaron;", Ņ: "&Ncedil;", Н: "&Ncy;", "​": "&ZeroWidthSpace;", "\n": "&NewLine;", "𝔑": "&Nfr;", "⁠": "&NoBreak;", " ": "&nbsp;", ℕ: "&naturals;", "⫬": "&Not;", "≢": "&nequiv;", "≭": "&NotCupCap;", "∦": "&nspar;", "∉": "&notinva;", "≠": "&ne;", "≂̸": "&nesim;", "∄": "&nexists;", "≯": "&ngtr;", "≱": "&ngeq;", "≧̸": "&ngeqq;", "≫̸": "&nGtv;", "≹": "&ntgl;", "⩾̸": "&nges;", "≵": "&ngsim;", "≎̸": "&nbump;", "≏̸": "&nbumpe;", "⋪": "&ntriangleleft;", "⧏̸": "&NotLeftTriangleBar;", "⋬": "&ntrianglelefteq;", "≮": "&nlt;", "≰": "&nleq;", "≸": "&ntlg;", "≪̸": "&nLtv;", "⩽̸": "&nles;", "≴": "&nlsim;", "⪢̸": "&NotNestedGreaterGreater;", "⪡̸": "&NotNestedLessLess;", "⊀": "&nprec;", "⪯̸": "&npreceq;", "⋠": "&nprcue;", "∌": "&notniva;", "⋫": "&ntriangleright;", "⧐̸": "&NotRightTriangleBar;", "⋭": "&ntrianglerighteq;", "⊏̸": "&NotSquareSubset;", "⋢": "&nsqsube;", "⊐̸": "&NotSquareSuperset;", "⋣": "&nsqsupe;", "⊂⃒": "&vnsub;", "⊈": "&nsubseteq;", "⊁": "&nsucc;", "⪰̸": "&nsucceq;", "⋡": "&nsccue;", "≿̸": "&NotSucceedsTilde;", "⊃⃒": "&vnsup;", "⊉": "&nsupseteq;", "≁": "&nsim;", "≄": "&nsimeq;", "≇": "&ncong;", "≉": "&napprox;", "∤": "&nsmid;", "𝒩": "&Nscr;", Ñ: "&Ntilde;", Ν: "&Nu;", Œ: "&OElig;", Ó: "&Oacute;", Ô: "&Ocirc;", О: "&Ocy;", Ő: "&Odblac;", "𝔒": "&Ofr;", Ò: "&Ograve;", Ō: "&Omacr;", Ω: "&ohm;", Ο: "&Omicron;", "𝕆": "&Oopf;", "“": "&ldquo;", "‘": "&lsquo;", "⩔": "&Or;", "𝒪": "&Oscr;", Ø: "&Oslash;", Õ: "&Otilde;", "⨷": "&Otimes;", Ö: "&Ouml;", "‾": "&oline;", "⏞": "&OverBrace;", "⎴": "&tbrk;", "⏜": "&OverParenthesis;", "∂": "&part;", П: "&Pcy;", "𝔓": "&Pfr;", Φ: "&Phi;", Π: "&Pi;", "±": "&pm;", ℙ: "&primes;", "⪻": "&Pr;", "≺": "&prec;", "⪯": "&preceq;", "≼": "&preccurlyeq;", "≾": "&prsim;", "″": "&Prime;", "∏": "&prod;", "∝": "&vprop;", "𝒫": "&Pscr;", Ψ: "&Psi;", '"': "&quot;", "𝔔": "&Qfr;", ℚ: "&rationals;", "𝒬": "&Qscr;", "⤐": "&drbkarow;", "®": "&reg;", Ŕ: "&Racute;", "⟫": "&Rang;", "↠": "&twoheadrightarrow;", "⤖": "&Rarrtl;", Ř: "&Rcaron;", Ŗ: "&Rcedil;", Р: "&Rcy;", ℜ: "&realpart;", "∋": "&niv;", "⇋": "&lrhar;", "⥯": "&duhar;", Ρ: "&Rho;", "⟩": "&rangle;", "→": "&srarr;", "⇥": "&rarrb;", "⇄": "&rlarr;", "⌉": "&rceil;", "⟧": "&robrk;", "⥝": "&RightDownTeeVector;", "⇂": "&downharpoonright;", "⥕": "&RightDownVectorBar;", "⌋": "&rfloor;", "⊢": "&vdash;", "↦": "&mapsto;", "⥛": "&RightTeeVector;", "⊳": "&vrtri;", "⧐": "&RightTriangleBar;", "⊵": "&trianglerighteq;", "⥏": "&RightUpDownVector;", "⥜": "&RightUpTeeVector;", "↾": "&upharpoonright;", "⥔": "&RightUpVectorBar;", "⇀": "&rightharpoonup;", "⥓": "&RightVectorBar;", ℝ: "&reals;", "⥰": "&RoundImplies;", "⇛": "&rAarr;", ℛ: "&realine;", "↱": "&rsh;", "⧴": "&RuleDelayed;", Щ: "&SHCHcy;", Ш: "&SHcy;", Ь: "&SOFTcy;", Ś: "&Sacute;", "⪼": "&Sc;", Š: "&Scaron;", Ş: "&Scedil;", Ŝ: "&Scirc;", С: "&Scy;", "𝔖": "&Sfr;", "↑": "&uparrow;", Σ: "&Sigma;", "∘": "&compfn;", "𝕊": "&Sopf;", "√": "&radic;", "□": "&square;", "⊓": "&sqcap;", "⊏": "&sqsubset;", "⊑": "&sqsubseteq;", "⊐": "&sqsupset;", "⊒": "&sqsupseteq;", "⊔": "&sqcup;", "𝒮": "&Sscr;", "⋆": "&sstarf;", "⋐": "&Subset;", "⊆": "&subseteq;", "≻": "&succ;", "⪰": "&succeq;", "≽": "&succcurlyeq;", "≿": "&succsim;", "∑": "&sum;", "⋑": "&Supset;", "⊃": "&supset;", "⊇": "&supseteq;", Þ: "&THORN;", "™": "&trade;", Ћ: "&TSHcy;", Ц: "&TScy;", "	": "&Tab;", Τ: "&Tau;", Ť: "&Tcaron;", Ţ: "&Tcedil;", Т: "&Tcy;", "𝔗": "&Tfr;", "∴": "&therefore;", Θ: "&Theta;", "  ": "&ThickSpace;", " ": "&thinsp;", "∼": "&thksim;", "≃": "&simeq;", "≅": "&cong;", "≈": "&thkap;", "𝕋": "&Topf;", "⃛": "&tdot;", "𝒯": "&Tscr;", Ŧ: "&Tstrok;", Ú: "&Uacute;", "↟": "&Uarr;", "⥉": "&Uarrocir;", Ў: "&Ubrcy;", Ŭ: "&Ubreve;", Û: "&Ucirc;", У: "&Ucy;", Ű: "&Udblac;", "𝔘": "&Ufr;", Ù: "&Ugrave;", Ū: "&Umacr;", _: "&lowbar;", "⏟": "&UnderBrace;", "⎵": "&bbrk;", "⏝": "&UnderParenthesis;", "⋃": "&xcup;", "⊎": "&uplus;", Ų: "&Uogon;", "𝕌": "&Uopf;", "⤒": "&UpArrowBar;", "⇅": "&udarr;", "↕": "&varr;", "⥮": "&udhar;", "⊥": "&perp;", "↥": "&mapstoup;", "↖": "&nwarrow;", "↗": "&nearrow;", ϒ: "&upsih;", Υ: "&Upsilon;", Ů: "&Uring;", "𝒰": "&Uscr;", Ũ: "&Utilde;", Ü: "&Uuml;", "⊫": "&VDash;", "⫫": "&Vbar;", В: "&Vcy;", "⊩": "&Vdash;", "⫦": "&Vdashl;", "⋁": "&xvee;", "‖": "&Vert;", "∣": "&smid;", "|": "&vert;", "❘": "&VerticalSeparator;", "≀": "&wreath;", " ": "&hairsp;", "𝔙": "&Vfr;", "𝕍": "&Vopf;", "𝒱": "&Vscr;", "⊪": "&Vvdash;", Ŵ: "&Wcirc;", "⋀": "&xwedge;", "𝔚": "&Wfr;", "𝕎": "&Wopf;", "𝒲": "&Wscr;", "𝔛": "&Xfr;", Ξ: "&Xi;", "𝕏": "&Xopf;", "𝒳": "&Xscr;", Я: "&YAcy;", Ї: "&YIcy;", Ю: "&YUcy;", Ý: "&Yacute;", Ŷ: "&Ycirc;", Ы: "&Ycy;", "𝔜": "&Yfr;", "𝕐": "&Yopf;", "𝒴": "&Yscr;", Ÿ: "&Yuml;", Ж: "&ZHcy;", Ź: "&Zacute;", Ž: "&Zcaron;", З: "&Zcy;", Ż: "&Zdot;", Ζ: "&Zeta;", ℨ: "&zeetrf;", ℤ: "&integers;", "𝒵": "&Zscr;", á: "&aacute;", ă: "&abreve;", "∾": "&mstpos;", "∾̳": "&acE;", "∿": "&acd;", â: "&acirc;", а: "&acy;", æ: "&aelig;", "𝔞": "&afr;", à: "&agrave;", ℵ: "&aleph;", α: "&alpha;", ā: "&amacr;", "⨿": "&amalg;", "∧": "&wedge;", "⩕": "&andand;", "⩜": "&andd;", "⩘": "&andslope;", "⩚": "&andv;", "∠": "&angle;", "⦤": "&ange;", "∡": "&measuredangle;", "⦨": "&angmsdaa;", "⦩": "&angmsdab;", "⦪": "&angmsdac;", "⦫": "&angmsdad;", "⦬": "&angmsdae;", "⦭": "&angmsdaf;", "⦮": "&angmsdag;", "⦯": "&angmsdah;", "∟": "&angrt;", "⊾": "&angrtvb;", "⦝": "&angrtvbd;", "∢": "&angsph;", "⍼": "&angzarr;", ą: "&aogon;", "𝕒": "&aopf;", "⩰": "&apE;", "⩯": "&apacir;", "≊": "&approxeq;", "≋": "&apid;", "'": "&apos;", å: "&aring;", "𝒶": "&ascr;", "*": "&midast;", ã: "&atilde;", ä: "&auml;", "⨑": "&awint;", "⫭": "&bNot;", "≌": "&bcong;", "϶": "&bepsi;", "‵": "&bprime;", "∽": "&bsim;", "⋍": "&bsime;", "⊽": "&barvee;", "⌅": "&barwedge;", "⎶": "&bbrktbrk;", б: "&bcy;", "„": "&ldquor;", "⦰": "&bemptyv;", β: "&beta;", ℶ: "&beth;", "≬": "&twixt;", "𝔟": "&bfr;", "◯": "&xcirc;", "⨀": "&xodot;", "⨁": "&xoplus;", "⨂": "&xotime;", "⨆": "&xsqcup;", "★": "&starf;", "▽": "&xdtri;", "△": "&xutri;", "⨄": "&xuplus;", "⤍": "&rbarr;", "⧫": "&lozf;", "▴": "&utrif;", "▾": "&dtrif;", "◂": "&ltrif;", "▸": "&rtrif;", "␣": "&blank;", "▒": "&blk12;", "░": "&blk14;", "▓": "&blk34;", "█": "&block;", "=⃥": "&bne;", "≡⃥": "&bnequiv;", "⌐": "&bnot;", "𝕓": "&bopf;", "⋈": "&bowtie;", "╗": "&boxDL;", "╔": "&boxDR;", "╖": "&boxDl;", "╓": "&boxDr;", "═": "&boxH;", "╦": "&boxHD;", "╩": "&boxHU;", "╤": "&boxHd;", "╧": "&boxHu;", "╝": "&boxUL;", "╚": "&boxUR;", "╜": "&boxUl;", "╙": "&boxUr;", "║": "&boxV;", "╬": "&boxVH;", "╣": "&boxVL;", "╠": "&boxVR;", "╫": "&boxVh;", "╢": "&boxVl;", "╟": "&boxVr;", "⧉": "&boxbox;", "╕": "&boxdL;", "╒": "&boxdR;", "┐": "&boxdl;", "┌": "&boxdr;", "╥": "&boxhD;", "╨": "&boxhU;", "┬": "&boxhd;", "┴": "&boxhu;", "⊟": "&minusb;", "⊞": "&plusb;", "⊠": "&timesb;", "╛": "&boxuL;", "╘": "&boxuR;", "┘": "&boxul;", "└": "&boxur;", "│": "&boxv;", "╪": "&boxvH;", "╡": "&boxvL;", "╞": "&boxvR;", "┼": "&boxvh;", "┤": "&boxvl;", "├": "&boxvr;", "¦": "&brvbar;", "𝒷": "&bscr;", "⁏": "&bsemi;", "\\": "&bsol;", "⧅": "&bsolb;", "⟈": "&bsolhsub;", "•": "&bullet;", "⪮": "&bumpE;", ć: "&cacute;", "∩": "&cap;", "⩄": "&capand;", "⩉": "&capbrcup;", "⩋": "&capcap;", "⩇": "&capcup;", "⩀": "&capdot;", "∩︀": "&caps;", "⁁": "&caret;", "⩍": "&ccaps;", č: "&ccaron;", ç: "&ccedil;", ĉ: "&ccirc;", "⩌": "&ccups;", "⩐": "&ccupssm;", ċ: "&cdot;", "⦲": "&cemptyv;", "¢": "&cent;", "𝔠": "&cfr;", ч: "&chcy;", "✓": "&checkmark;", χ: "&chi;", "○": "&cir;", "⧃": "&cirE;", "ˆ": "&circ;", "≗": "&cire;", "↺": "&olarr;", "↻": "&orarr;", "Ⓢ": "&oS;", "⊛": "&oast;", "⊚": "&ocir;", "⊝": "&odash;", "⨐": "&cirfnint;", "⫯": "&cirmid;", "⧂": "&cirscir;", "♣": "&clubsuit;", ":": "&colon;", ",": "&comma;", "@": "&commat;", "∁": "&complement;", "⩭": "&congdot;", "𝕔": "&copf;", "℗": "&copysr;", "↵": "&crarr;", "✗": "&cross;", "𝒸": "&cscr;", "⫏": "&csub;", "⫑": "&csube;", "⫐": "&csup;", "⫒": "&csupe;", "⋯": "&ctdot;", "⤸": "&cudarrl;", "⤵": "&cudarrr;", "⋞": "&curlyeqprec;", "⋟": "&curlyeqsucc;", "↶": "&curvearrowleft;", "⤽": "&cularrp;", "∪": "&cup;", "⩈": "&cupbrcap;", "⩆": "&cupcap;", "⩊": "&cupcup;", "⊍": "&cupdot;", "⩅": "&cupor;", "∪︀": "&cups;", "↷": "&curvearrowright;", "⤼": "&curarrm;", "⋎": "&cuvee;", "⋏": "&cuwed;", "¤": "&curren;", "∱": "&cwint;", "⌭": "&cylcty;", "⥥": "&dHar;", "†": "&dagger;", ℸ: "&daleth;", "‐": "&hyphen;", "⤏": "&rBarr;", ď: "&dcaron;", д: "&dcy;", "⇊": "&downdownarrows;", "⩷": "&eDDot;", "°": "&deg;", δ: "&delta;", "⦱": "&demptyv;", "⥿": "&dfisht;", "𝔡": "&dfr;", "♦": "&diams;", ϝ: "&gammad;", "⋲": "&disin;", "÷": "&divide;", "⋇": "&divonx;", ђ: "&djcy;", "⌞": "&llcorner;", "⌍": "&dlcrop;", $: "&dollar;", "𝕕": "&dopf;", "≑": "&eDot;", "∸": "&minusd;", "∔": "&plusdo;", "⊡": "&sdotb;", "⌟": "&lrcorner;", "⌌": "&drcrop;", "𝒹": "&dscr;", ѕ: "&dscy;", "⧶": "&dsol;", đ: "&dstrok;", "⋱": "&dtdot;", "▿": "&triangledown;", "⦦": "&dwangle;", џ: "&dzcy;", "⟿": "&dzigrarr;", é: "&eacute;", "⩮": "&easter;", ě: "&ecaron;", "≖": "&eqcirc;", ê: "&ecirc;", "≕": "&eqcolon;", э: "&ecy;", ė: "&edot;", "≒": "&fallingdotseq;", "𝔢": "&efr;", "⪚": "&eg;", è: "&egrave;", "⪖": "&eqslantgtr;", "⪘": "&egsdot;", "⪙": "&el;", "⏧": "&elinters;", ℓ: "&ell;", "⪕": "&eqslantless;", "⪗": "&elsdot;", ē: "&emacr;", "∅": "&varnothing;", " ": "&emsp13;", " ": "&emsp14;", " ": "&emsp;", ŋ: "&eng;", " ": "&ensp;", ę: "&eogon;", "𝕖": "&eopf;", "⋕": "&epar;", "⧣": "&eparsl;", "⩱": "&eplus;", ε: "&epsilon;", "ϵ": "&varepsilon;", "=": "&equals;", "≟": "&questeq;", "⩸": "&equivDD;", "⧥": "&eqvparsl;", "≓": "&risingdotseq;", "⥱": "&erarr;", ℯ: "&escr;", η: "&eta;", ð: "&eth;", ë: "&euml;", "€": "&euro;", "!": "&excl;", ф: "&fcy;", "♀": "&female;", ﬃ: "&ffilig;", ﬀ: "&fflig;", ﬄ: "&ffllig;", "𝔣": "&ffr;", ﬁ: "&filig;", fj: "&fjlig;", "♭": "&flat;", ﬂ: "&fllig;", "▱": "&fltns;", ƒ: "&fnof;", "𝕗": "&fopf;", "⋔": "&pitchfork;", "⫙": "&forkv;", "⨍": "&fpartint;", "½": "&half;", "⅓": "&frac13;", "¼": "&frac14;", "⅕": "&frac15;", "⅙": "&frac16;", "⅛": "&frac18;", "⅔": "&frac23;", "⅖": "&frac25;", "¾": "&frac34;", "⅗": "&frac35;", "⅜": "&frac38;", "⅘": "&frac45;", "⅚": "&frac56;", "⅝": "&frac58;", "⅞": "&frac78;", "⁄": "&frasl;", "⌢": "&sfrown;", "𝒻": "&fscr;", "⪌": "&gtreqqless;", ǵ: "&gacute;", γ: "&gamma;", "⪆": "&gtrapprox;", ğ: "&gbreve;", ĝ: "&gcirc;", г: "&gcy;", ġ: "&gdot;", "⪩": "&gescc;", "⪀": "&gesdot;", "⪂": "&gesdoto;", "⪄": "&gesdotol;", "⋛︀": "&gesl;", "⪔": "&gesles;", "𝔤": "&gfr;", ℷ: "&gimel;", ѓ: "&gjcy;", "⪒": "&glE;", "⪥": "&gla;", "⪤": "&glj;", "≩": "&gneqq;", "⪊": "&gnapprox;", "⪈": "&gneq;", "⋧": "&gnsim;", "𝕘": "&gopf;", ℊ: "&gscr;", "⪎": "&gsime;", "⪐": "&gsiml;", "⪧": "&gtcc;", "⩺": "&gtcir;", "⋗": "&gtrdot;", "⦕": "&gtlPar;", "⩼": "&gtquest;", "⥸": "&gtrarr;", "≩︀": "&gvnE;", ъ: "&hardcy;", "⥈": "&harrcir;", "↭": "&leftrightsquigarrow;", ℏ: "&plankv;", ĥ: "&hcirc;", "♥": "&heartsuit;", "…": "&mldr;", "⊹": "&hercon;", "𝔥": "&hfr;", "⤥": "&searhk;", "⤦": "&swarhk;", "⇿": "&hoarr;", "∻": "&homtht;", "↩": "&larrhk;", "↪": "&rarrhk;", "𝕙": "&hopf;", "―": "&horbar;", "𝒽": "&hscr;", ħ: "&hstrok;", "⁃": "&hybull;", í: "&iacute;", î: "&icirc;", и: "&icy;", е: "&iecy;", "¡": "&iexcl;", "𝔦": "&ifr;", ì: "&igrave;", "⨌": "&qint;", "∭": "&tint;", "⧜": "&iinfin;", "℩": "&iiota;", ĳ: "&ijlig;", ī: "&imacr;", ı: "&inodot;", "⊷": "&imof;", Ƶ: "&imped;", "℅": "&incare;", "∞": "&infin;", "⧝": "&infintie;", "⊺": "&intercal;", "⨗": "&intlarhk;", "⨼": "&iprod;", ё: "&iocy;", į: "&iogon;", "𝕚": "&iopf;", ι: "&iota;", "¿": "&iquest;", "𝒾": "&iscr;", "⋹": "&isinE;", "⋵": "&isindot;", "⋴": "&isins;", "⋳": "&isinsv;", ĩ: "&itilde;", і: "&iukcy;", ï: "&iuml;", ĵ: "&jcirc;", й: "&jcy;", "𝔧": "&jfr;", "ȷ": "&jmath;", "𝕛": "&jopf;", "𝒿": "&jscr;", ј: "&jsercy;", є: "&jukcy;", κ: "&kappa;", ϰ: "&varkappa;", ķ: "&kcedil;", к: "&kcy;", "𝔨": "&kfr;", ĸ: "&kgreen;", х: "&khcy;", ќ: "&kjcy;", "𝕜": "&kopf;", "𝓀": "&kscr;", "⤛": "&lAtail;", "⤎": "&lBarr;", "⪋": "&lesseqqgtr;", "⥢": "&lHar;", ĺ: "&lacute;", "⦴": "&laemptyv;", λ: "&lambda;", "⦑": "&langd;", "⪅": "&lessapprox;", "«": "&laquo;", "⤟": "&larrbfs;", "⤝": "&larrfs;", "↫": "&looparrowleft;", "⤹": "&larrpl;", "⥳": "&larrsim;", "↢": "&leftarrowtail;", "⪫": "&lat;", "⤙": "&latail;", "⪭": "&late;", "⪭︀": "&lates;", "⤌": "&lbarr;", "❲": "&lbbrk;", "{": "&lcub;", "[": "&lsqb;", "⦋": "&lbrke;", "⦏": "&lbrksld;", "⦍": "&lbrkslu;", ľ: "&lcaron;", ļ: "&lcedil;", л: "&lcy;", "⤶": "&ldca;", "⥧": "&ldrdhar;", "⥋": "&ldrushar;", "↲": "&ldsh;", "≤": "&leq;", "⇇": "&llarr;", "⋋": "&lthree;", "⪨": "&lescc;", "⩿": "&lesdot;", "⪁": "&lesdoto;", "⪃": "&lesdotor;", "⋚︀": "&lesg;", "⪓": "&lesges;", "⋖": "&ltdot;", "⥼": "&lfisht;", "𝔩": "&lfr;", "⪑": "&lgE;", "⥪": "&lharul;", "▄": "&lhblk;", љ: "&ljcy;", "⥫": "&llhard;", "◺": "&lltri;", ŀ: "&lmidot;", "⎰": "&lmoustache;", "≨": "&lneqq;", "⪉": "&lnapprox;", "⪇": "&lneq;", "⋦": "&lnsim;", "⟬": "&loang;", "⇽": "&loarr;", "⟼": "&xmap;", "↬": "&rarrlp;", "⦅": "&lopar;", "𝕝": "&lopf;", "⨭": "&loplus;", "⨴": "&lotimes;", "∗": "&lowast;", "◊": "&lozenge;", "(": "&lpar;", "⦓": "&lparlt;", "⥭": "&lrhard;", "‎": "&lrm;", "⊿": "&lrtri;", "‹": "&lsaquo;", "𝓁": "&lscr;", "⪍": "&lsime;", "⪏": "&lsimg;", "‚": "&sbquo;", ł: "&lstrok;", "⪦": "&ltcc;", "⩹": "&ltcir;", "⋉": "&ltimes;", "⥶": "&ltlarr;", "⩻": "&ltquest;", "⦖": "&ltrPar;", "◃": "&triangleleft;", "⥊": "&lurdshar;", "⥦": "&luruhar;", "≨︀": "&lvnE;", "∺": "&mDDot;", "¯": "&strns;", "♂": "&male;", "✠": "&maltese;", "▮": "&marker;", "⨩": "&mcomma;", м: "&mcy;", "—": "&mdash;", "𝔪": "&mfr;", "℧": "&mho;", µ: "&micro;", "⫰": "&midcir;", "−": "&minus;", "⨪": "&minusdu;", "⫛": "&mlcp;", "⊧": "&models;", "𝕞": "&mopf;", "𝓂": "&mscr;", μ: "&mu;", "⊸": "&mumap;", "⋙̸": "&nGg;", "≫⃒": "&nGt;", "⇍": "&nlArr;", "⇎": "&nhArr;", "⋘̸": "&nLl;", "≪⃒": "&nLt;", "⇏": "&nrArr;", "⊯": "&nVDash;", "⊮": "&nVdash;", ń: "&nacute;", "∠⃒": "&nang;", "⩰̸": "&napE;", "≋̸": "&napid;", ŉ: "&napos;", "♮": "&natural;", "⩃": "&ncap;", ň: "&ncaron;", ņ: "&ncedil;", "⩭̸": "&ncongdot;", "⩂": "&ncup;", н: "&ncy;", "–": "&ndash;", "⇗": "&neArr;", "⤤": "&nearhk;", "≐̸": "&nedot;", "⤨": "&toea;", "𝔫": "&nfr;", "↮": "&nleftrightarrow;", "⫲": "&nhpar;", "⋼": "&nis;", "⋺": "&nisd;", њ: "&njcy;", "≦̸": "&nleqq;", "↚": "&nleftarrow;", "‥": "&nldr;", "𝕟": "&nopf;", "¬": "&not;", "⋹̸": "&notinE;", "⋵̸": "&notindot;", "⋷": "&notinvb;", "⋶": "&notinvc;", "⋾": "&notnivb;", "⋽": "&notnivc;", "⫽⃥": "&nparsl;", "∂̸": "&npart;", "⨔": "&npolint;", "↛": "&nrightarrow;", "⤳̸": "&nrarrc;", "↝̸": "&nrarrw;", "𝓃": "&nscr;", "⊄": "&nsub;", "⫅̸": "&nsubseteqq;", "⊅": "&nsup;", "⫆̸": "&nsupseteqq;", ñ: "&ntilde;", ν: "&nu;", "#": "&num;", "№": "&numero;", " ": "&numsp;", "⊭": "&nvDash;", "⤄": "&nvHarr;", "≍⃒": "&nvap;", "⊬": "&nvdash;", "≥⃒": "&nvge;", ">⃒": "&nvgt;", "⧞": "&nvinfin;", "⤂": "&nvlArr;", "≤⃒": "&nvle;", "<⃒": "&nvlt;", "⊴⃒": "&nvltrie;", "⤃": "&nvrArr;", "⊵⃒": "&nvrtrie;", "∼⃒": "&nvsim;", "⇖": "&nwArr;", "⤣": "&nwarhk;", "⤧": "&nwnear;", ó: "&oacute;", ô: "&ocirc;", о: "&ocy;", ő: "&odblac;", "⨸": "&odiv;", "⦼": "&odsold;", œ: "&oelig;", "⦿": "&ofcir;", "𝔬": "&ofr;", "˛": "&ogon;", ò: "&ograve;", "⧁": "&ogt;", "⦵": "&ohbar;", "⦾": "&olcir;", "⦻": "&olcross;", "⧀": "&olt;", ō: "&omacr;", ω: "&omega;", ο: "&omicron;", "⦶": "&omid;", "𝕠": "&oopf;", "⦷": "&opar;", "⦹": "&operp;", "∨": "&vee;", "⩝": "&ord;", ℴ: "&oscr;", ª: "&ordf;", º: "&ordm;", "⊶": "&origof;", "⩖": "&oror;", "⩗": "&orslope;", "⩛": "&orv;", ø: "&oslash;", "⊘": "&osol;", õ: "&otilde;", "⨶": "&otimesas;", ö: "&ouml;", "⌽": "&ovbar;", "¶": "&para;", "⫳": "&parsim;", "⫽": "&parsl;", п: "&pcy;", "%": "&percnt;", ".": "&period;", "‰": "&permil;", "‱": "&pertenk;", "𝔭": "&pfr;", φ: "&phi;", ϕ: "&varphi;", "☎": "&phone;", π: "&pi;", ϖ: "&varpi;", ℎ: "&planckh;", "+": "&plus;", "⨣": "&plusacir;", "⨢": "&pluscir;", "⨥": "&plusdu;", "⩲": "&pluse;", "⨦": "&plussim;", "⨧": "&plustwo;", "⨕": "&pointint;", "𝕡": "&popf;", "£": "&pound;", "⪳": "&prE;", "⪷": "&precapprox;", "⪹": "&prnap;", "⪵": "&prnE;", "⋨": "&prnsim;", "′": "&prime;", "⌮": "&profalar;", "⌒": "&profline;", "⌓": "&profsurf;", "⊰": "&prurel;", "𝓅": "&pscr;", ψ: "&psi;", " ": "&puncsp;", "𝔮": "&qfr;", "𝕢": "&qopf;", "⁗": "&qprime;", "𝓆": "&qscr;", "⨖": "&quatint;", "?": "&quest;", "⤜": "&rAtail;", "⥤": "&rHar;", "∽̱": "&race;", ŕ: "&racute;", "⦳": "&raemptyv;", "⦒": "&rangd;", "⦥": "&range;", "»": "&raquo;", "⥵": "&rarrap;", "⤠": "&rarrbfs;", "⤳": "&rarrc;", "⤞": "&rarrfs;", "⥅": "&rarrpl;", "⥴": "&rarrsim;", "↣": "&rightarrowtail;", "↝": "&rightsquigarrow;", "⤚": "&ratail;", "∶": "&ratio;", "❳": "&rbbrk;", "}": "&rcub;", "]": "&rsqb;", "⦌": "&rbrke;", "⦎": "&rbrksld;", "⦐": "&rbrkslu;", ř: "&rcaron;", ŗ: "&rcedil;", р: "&rcy;", "⤷": "&rdca;", "⥩": "&rdldhar;", "↳": "&rdsh;", "▭": "&rect;", "⥽": "&rfisht;", "𝔯": "&rfr;", "⥬": "&rharul;", ρ: "&rho;", ϱ: "&varrho;", "⇉": "&rrarr;", "⋌": "&rthree;", "˚": "&ring;", "‏": "&rlm;", "⎱": "&rmoustache;", "⫮": "&rnmid;", "⟭": "&roang;", "⇾": "&roarr;", "⦆": "&ropar;", "𝕣": "&ropf;", "⨮": "&roplus;", "⨵": "&rotimes;", ")": "&rpar;", "⦔": "&rpargt;", "⨒": "&rppolint;", "›": "&rsaquo;", "𝓇": "&rscr;", "⋊": "&rtimes;", "▹": "&triangleright;", "⧎": "&rtriltri;", "⥨": "&ruluhar;", "℞": "&rx;", ś: "&sacute;", "⪴": "&scE;", "⪸": "&succapprox;", š: "&scaron;", ş: "&scedil;", ŝ: "&scirc;", "⪶": "&succneqq;", "⪺": "&succnapprox;", "⋩": "&succnsim;", "⨓": "&scpolint;", с: "&scy;", "⋅": "&sdot;", "⩦": "&sdote;", "⇘": "&seArr;", "§": "&sect;", ";": "&semi;", "⤩": "&tosa;", "✶": "&sext;", "𝔰": "&sfr;", "♯": "&sharp;", щ: "&shchcy;", ш: "&shcy;", "­": "&shy;", σ: "&sigma;", ς: "&varsigma;", "⩪": "&simdot;", "⪞": "&simg;", "⪠": "&simgE;", "⪝": "&siml;", "⪟": "&simlE;", "≆": "&simne;", "⨤": "&simplus;", "⥲": "&simrarr;", "⨳": "&smashp;", "⧤": "&smeparsl;", "⌣": "&ssmile;", "⪪": "&smt;", "⪬": "&smte;", "⪬︀": "&smtes;", ь: "&softcy;", "/": "&sol;", "⧄": "&solb;", "⌿": "&solbar;", "𝕤": "&sopf;", "♠": "&spadesuit;", "⊓︀": "&sqcaps;", "⊔︀": "&sqcups;", "𝓈": "&sscr;", "☆": "&star;", "⊂": "&subset;", "⫅": "&subseteqq;", "⪽": "&subdot;", "⫃": "&subedot;", "⫁": "&submult;", "⫋": "&subsetneqq;", "⊊": "&subsetneq;", "⪿": "&subplus;", "⥹": "&subrarr;", "⫇": "&subsim;", "⫕": "&subsub;", "⫓": "&subsup;", "♪": "&sung;", "¹": "&sup1;", "²": "&sup2;", "³": "&sup3;", "⫆": "&supseteqq;", "⪾": "&supdot;", "⫘": "&supdsub;", "⫄": "&supedot;", "⟉": "&suphsol;", "⫗": "&suphsub;", "⥻": "&suplarr;", "⫂": "&supmult;", "⫌": "&supsetneqq;", "⊋": "&supsetneq;", "⫀": "&supplus;", "⫈": "&supsim;", "⫔": "&supsub;", "⫖": "&supsup;", "⇙": "&swArr;", "⤪": "&swnwar;", ß: "&szlig;", "⌖": "&target;", τ: "&tau;", ť: "&tcaron;", ţ: "&tcedil;", т: "&tcy;", "⌕": "&telrec;", "𝔱": "&tfr;", θ: "&theta;", ϑ: "&vartheta;", þ: "&thorn;", "×": "&times;", "⨱": "&timesbar;", "⨰": "&timesd;", "⌶": "&topbot;", "⫱": "&topcir;", "𝕥": "&topf;", "⫚": "&topfork;", "‴": "&tprime;", "▵": "&utri;", "≜": "&trie;", "◬": "&tridot;", "⨺": "&triminus;", "⨹": "&triplus;", "⧍": "&trisb;", "⨻": "&tritime;", "⏢": "&trpezium;", "𝓉": "&tscr;", ц: "&tscy;", ћ: "&tshcy;", ŧ: "&tstrok;", "⥣": "&uHar;", ú: "&uacute;", ў: "&ubrcy;", ŭ: "&ubreve;", û: "&ucirc;", у: "&ucy;", ű: "&udblac;", "⥾": "&ufisht;", "𝔲": "&ufr;", ù: "&ugrave;", "▀": "&uhblk;", "⌜": "&ulcorner;", "⌏": "&ulcrop;", "◸": "&ultri;", ū: "&umacr;", ų: "&uogon;", "𝕦": "&uopf;", υ: "&upsilon;", "⇈": "&uuarr;", "⌝": "&urcorner;", "⌎": "&urcrop;", ů: "&uring;", "◹": "&urtri;", "𝓊": "&uscr;", "⋰": "&utdot;", ũ: "&utilde;", ü: "&uuml;", "⦧": "&uwangle;", "⫨": "&vBar;", "⫩": "&vBarv;", "⦜": "&vangrt;", "⊊︀": "&vsubne;", "⫋︀": "&vsubnE;", "⊋︀": "&vsupne;", "⫌︀": "&vsupnE;", в: "&vcy;", "⊻": "&veebar;", "≚": "&veeeq;", "⋮": "&vellip;", "𝔳": "&vfr;", "𝕧": "&vopf;", "𝓋": "&vscr;", "⦚": "&vzigzag;", ŵ: "&wcirc;", "⩟": "&wedbar;", "≙": "&wedgeq;", "℘": "&wp;", "𝔴": "&wfr;", "𝕨": "&wopf;", "𝓌": "&wscr;", "𝔵": "&xfr;", ξ: "&xi;", "⋻": "&xnis;", "𝕩": "&xopf;", "𝓍": "&xscr;", ý: "&yacute;", я: "&yacy;", ŷ: "&ycirc;", ы: "&ycy;", "¥": "&yen;", "𝔶": "&yfr;", ї: "&yicy;", "𝕪": "&yopf;", "𝓎": "&yscr;", ю: "&yucy;", ÿ: "&yuml;", ź: "&zacute;", ž: "&zcaron;", з: "&zcy;", ż: "&zdot;", ζ: "&zeta;", "𝔷": "&zfr;", ж: "&zhcy;", "⇝": "&zigrarr;", "𝕫": "&zopf;", "𝓏": "&zscr;", "‍": "&zwj;", "‌": "&zwnj;" } } };
var numericUnicodeMap = {};
Object.defineProperty(numericUnicodeMap, "__esModule", { value: !0 });
numericUnicodeMap.numericUnicodeMap = { 0: 65533, 128: 8364, 130: 8218, 131: 402, 132: 8222, 133: 8230, 134: 8224, 135: 8225, 136: 710, 137: 8240, 138: 352, 139: 8249, 140: 338, 142: 381, 145: 8216, 146: 8217, 147: 8220, 148: 8221, 149: 8226, 150: 8211, 151: 8212, 152: 732, 153: 8482, 154: 353, 155: 8250, 156: 339, 158: 382, 159: 376 };
var surrogatePairs = {};
Object.defineProperty(surrogatePairs, "__esModule", { value: !0 });
surrogatePairs.fromCodePoint = String.fromCodePoint || function(a) {
  return String.fromCharCode(Math.floor((a - 65536) / 1024) + 55296, (a - 65536) % 1024 + 56320);
};
surrogatePairs.getCodePoint = String.prototype.codePointAt ? function(a, s) {
  return a.codePointAt(s);
} : function(a, s) {
  return (a.charCodeAt(s) - 55296) * 1024 + a.charCodeAt(s + 1) - 56320 + 65536;
};
surrogatePairs.highSurrogateFrom = 55296;
surrogatePairs.highSurrogateTo = 56319;
var __assign$9 = commonjsGlobal && commonjsGlobal.__assign || function() {
  return __assign$9 = Object.assign || function(a) {
    for (var s, $ = 1, _ = arguments.length; $ < _; $++) {
      s = arguments[$];
      for (var _e in s)
        Object.prototype.hasOwnProperty.call(s, _e) && (a[_e] = s[_e]);
    }
    return a;
  }, __assign$9.apply(this, arguments);
};
Object.defineProperty(lib$2, "__esModule", { value: !0 });
var named_references_1 = namedReferences, numeric_unicode_map_1 = numericUnicodeMap, surrogate_pairs_1 = surrogatePairs, allNamedReferences = __assign$9(__assign$9({}, named_references_1.namedReferences), { all: named_references_1.namedReferences.html5 }), encodeRegExps = {
  specialChars: /[<>'"&]/g,
  nonAscii: /[<>'"&\u0080-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
  nonAsciiPrintable: /[<>'"&\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
  nonAsciiPrintableOnly: /[\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
  extensive: /[\x01-\x0c\x0e-\x1f\x21-\x2c\x2e-\x2f\x3a-\x40\x5b-\x60\x7b-\x7d\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g
}, defaultEncodeOptions = {
  mode: "specialChars",
  level: "all",
  numeric: "decimal"
};
function encode(a, s) {
  var st = s === void 0 ? defaultEncodeOptions : s, lt = st.mode, $ = lt === void 0 ? "specialChars" : lt, _ = st.numeric, _e = _ === void 0 ? "decimal" : _, tt = st.level, nt = tt === void 0 ? "all" : tt;
  if (!a)
    return "";
  var at = encodeRegExps[$], ot = allNamedReferences[nt].characters, rt = _e === "hexadecimal";
  at.lastIndex = 0;
  var st = at.exec(a), lt;
  if (st) {
    lt = "";
    var _ = 0;
    do {
      _ !== st.index && (lt += a.substring(_, st.index));
      var tt = st[0], et = ot[tt];
      if (!et) {
        var it = tt.length > 1 ? surrogate_pairs_1.getCodePoint(tt, 0) : tt.charCodeAt(0);
        et = (rt ? "&#x" + it.toString(16) : "&#" + it) + ";";
      }
      lt += et, _ = st.index + tt.length;
    } while (st = at.exec(a));
    _ !== a.length && (lt += a.substring(_));
  } else
    lt = a;
  return lt;
}
lib$2.encode = encode;
var defaultDecodeOptions = {
  scope: "body",
  level: "all"
}, strict = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g, attribute = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g, baseDecodeRegExps = {
  xml: {
    strict,
    attribute,
    body: named_references_1.bodyRegExps.xml
  },
  html4: {
    strict,
    attribute,
    body: named_references_1.bodyRegExps.html4
  },
  html5: {
    strict,
    attribute,
    body: named_references_1.bodyRegExps.html5
  }
}, decodeRegExps = __assign$9(__assign$9({}, baseDecodeRegExps), { all: baseDecodeRegExps.html5 }), fromCharCode = String.fromCharCode, outOfBoundsChar = fromCharCode(65533), defaultDecodeEntityOptions = {
  level: "all"
};
function decodeEntity(a, s) {
  var _ = (s === void 0 ? defaultDecodeEntityOptions : s).level, $ = _ === void 0 ? "all" : _;
  if (!a)
    return "";
  var _ = a;
  a[a.length - 1];
  {
    var _e = allNamedReferences[$].entities[a];
    if (_e)
      _ = _e;
    else if (a[0] === "&" && a[1] === "#") {
      var tt = a[2], nt = tt == "x" || tt == "X" ? parseInt(a.substr(3), 16) : parseInt(a.substr(2));
      _ = nt >= 1114111 ? outOfBoundsChar : nt > 65535 ? surrogate_pairs_1.fromCodePoint(nt) : fromCharCode(numeric_unicode_map_1.numericUnicodeMap[nt] || nt);
    }
  }
  return _;
}
lib$2.decodeEntity = decodeEntity;
function decode(a, s) {
  var $ = s === void 0 ? defaultDecodeOptions : s, _ = $.level, _e = _ === void 0 ? "all" : _, tt = $.scope, nt = tt === void 0 ? _e === "xml" ? "strict" : "body" : tt;
  if (!a)
    return "";
  var at = decodeRegExps[_e][nt], ot = allNamedReferences[_e].entities, rt = nt === "attribute", st = nt === "strict";
  at.lastIndex = 0;
  var lt = at.exec(a), et;
  if (lt) {
    et = "";
    var it = 0;
    do {
      it !== lt.index && (et += a.substring(it, lt.index));
      var ut = lt[0], ft = ut, ht = ut[ut.length - 1];
      if (rt && ht === "=")
        ft = ut;
      else if (st && ht !== ";")
        ft = ut;
      else {
        var dt = ot[ut];
        if (dt)
          ft = dt;
        else if (ut[0] === "&" && ut[1] === "#") {
          var gt = ut[2], pt = gt == "x" || gt == "X" ? parseInt(ut.substr(3), 16) : parseInt(ut.substr(2));
          ft = pt >= 1114111 ? outOfBoundsChar : pt > 65535 ? surrogate_pairs_1.fromCodePoint(pt) : fromCharCode(numeric_unicode_map_1.numericUnicodeMap[pt] || pt);
        }
      }
      et += ft, it = lt.index + ut.length;
    } while (lt = at.exec(a));
    it !== a.length && (et += a.substring(it));
  } else
    et = a;
  return et;
}
lib$2.decode = decode;
(function(a) {
  var s = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
    var At = function(xt, bt) {
      return At = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(Et, St) {
        Et.__proto__ = St;
      } || function(Et, St) {
        for (var Bt in St)
          Object.prototype.hasOwnProperty.call(St, Bt) && (Et[Bt] = St[Bt]);
      }, At(xt, bt);
    };
    return function(xt, bt) {
      if (typeof bt != "function" && bt !== null)
        throw new TypeError("Class extends value " + String(bt) + " is not a constructor or null");
      At(xt, bt);
      function Et() {
        this.constructor = xt;
      }
      xt.prototype = bt === null ? Object.create(bt) : (Et.prototype = bt.prototype, new Et());
    };
  }();
  Object.defineProperty(a, "__esModule", { value: !0 }), a.isBlock = a.parse = a.Matcher = a.HTMLElement = a.CommentNode = a.TextNode = a.AbstractNode = a.NodeType = void 0;
  var $ = lib$2, _;
  (function(At) {
    At[At.ELEMENT_NODE = 1] = "ELEMENT_NODE", At[At.TEXT_NODE = 3] = "TEXT_NODE", At[At.COMMENT_NODE = 8] = "COMMENT_NODE";
  })(_ = a.NodeType || (a.NodeType = {}));
  var _e = (
    /** @class */
    function() {
      function At() {
        this.childNodes = [];
      }
      return Object.defineProperty(At.prototype, "text", {
        /**
         * Get unescaped text value of current node and its children.
         * @return {string} text content
         */
        get: function() {
          return (0, $.decode)(this.rawText);
        },
        enumerable: !1,
        configurable: !0
      }), At.prototype.remove = function() {
        return this.parentNode && this.parentNode.removeChild(this), this;
      }, At;
    }()
  );
  a.AbstractNode = _e;
  var tt = (
    /** @class */
    function(At) {
      s(xt, At);
      function xt(bt) {
        var Et = At.call(this) || this;
        return Et.nodeType = _.TEXT_NODE, Et.value = bt, Et;
      }
      return Object.defineProperty(xt.prototype, "rawText", {
        get: function() {
          return this.value;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(xt.prototype, "isWhitespace", {
        /**
         * Detect if the node contains only white space.
         * @return {bool}
         */
        get: function() {
          return /^(\s|&nbsp;)*$/.test(this.rawText);
        },
        enumerable: !1,
        configurable: !0
      }), xt.prototype.toString = function() {
        return this.rawText;
      }, xt;
    }(_e)
  );
  a.TextNode = tt;
  var nt = (
    /** @class */
    function(At) {
      s(xt, At);
      function xt(bt) {
        var Et = At.call(this) || this;
        return Et.nodeType = _.COMMENT_NODE, Et.value = bt, Et;
      }
      return Object.defineProperty(xt.prototype, "rawText", {
        get: function() {
          return this.value;
        },
        enumerable: !1,
        configurable: !0
      }), xt.prototype.toString = function() {
        return "<!--".concat(this.rawText, "-->");
      }, xt;
    }(_e)
  );
  a.CommentNode = nt;
  var at = {
    div: !0,
    p: !0,
    // ul: true,
    // ol: true,
    li: !0,
    // table: true,
    // tr: true,
    td: !0,
    section: !0,
    br: !0
  };
  function ot(At) {
    return At[At.length - 1];
  }
  var rt = (
    /** @class */
    function(At) {
      s(xt, At);
      function xt(bt, Et, St) {
        Et === void 0 && (Et = ""), St === void 0 && (St = null);
        var Bt = At.call(this) || this;
        Bt.tagName = bt, Bt.rawAttrs = Et, Bt.classNames = [], Bt.nodeType = _.ELEMENT_NODE, Bt.rawAttrs = Et, Bt.parentNode = St, Bt.childNodes = [];
        for (var Ot = {}, Pt = void 0; Pt = ut.exec(Et); )
          Ot[Pt[2]] = Pt[4] || Pt[5] || Pt[6];
        return Ot.id && (Bt.id = Ot.id), Ot.class && (Bt.classNames = Ot.class.split(/\s+/)), Bt;
      }
      return xt.prototype.removeChild = function(bt) {
        this.childNodes = this.childNodes.filter(function(Et) {
          return Et !== bt;
        }), bt instanceof xt && (bt.parentNode = null);
      }, xt.prototype.exchangeChild = function(bt, Et) {
        var St = this.childNodes.findIndex(function(Bt) {
          return Bt === bt;
        });
        St >= 0 && (this.childNodes[St] = Et, bt instanceof xt && (bt.parentNode = null));
      }, Object.defineProperty(xt.prototype, "rawText", {
        /**
         * Get escpaed (as-it) text value of current node and its children.
         * @return {string} text content
         */
        get: function() {
          for (var bt = "", Et = 0; Et < this.childNodes.length; Et++)
            bt += this.childNodes[Et].rawText;
          return bt;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(xt.prototype, "structuredText", {
        /**
         * Get structured Text (with '\n' etc.)
         * @return {string} structured text
         */
        get: function() {
          var bt = [], Et = [bt];
          function St(Bt) {
            if (Bt.nodeType === _.ELEMENT_NODE)
              at[Bt.tagName] ? (bt.length > 0 && Et.push(bt = []), Bt.childNodes.forEach(St), bt.length > 0 && Et.push(bt = [])) : Bt.childNodes.forEach(St);
            else if (Bt.nodeType === _.TEXT_NODE)
              if (Bt.isWhitespace)
                bt.prependWhitespace = !0;
              else {
                var Ot = Bt.text;
                bt.prependWhitespace && (Ot = " " + Ot, bt.prependWhitespace = !1), bt.push(Ot);
              }
          }
          return St(this), Et.map(function(Bt) {
            return Bt.join("").trim().replace(/\s{2,}/g, " ");
          }).join(`
`).replace(/\s+$/, "");
        },
        enumerable: !1,
        configurable: !0
      }), xt.prototype.toString = function() {
        var bt = this.tagName;
        if (bt) {
          var Et = /^(img|br|hr|area|base|input|doctype|link|meta)$/i.test(bt), St = this.rawAttrs ? " " + this.rawAttrs : "";
          return Et ? "<".concat(bt).concat(St, " />") : "<".concat(bt).concat(St, ">").concat(this.innerHTML, "</").concat(bt, ">");
        } else
          return this.innerHTML;
      }, Object.defineProperty(xt.prototype, "innerHTML", {
        /** Retrieves the content of this node as an HTML string */
        get: function() {
          return this.childNodes.map(function(bt) {
            return bt.toString();
          }).join("");
        },
        set: function(bt) {
          var Et = this, St = mt(bt);
          this.childNodes.forEach(function(Bt) {
            return Bt.remove();
          }), St.childNodes.forEach(function(Bt) {
            return Et.appendChild(Bt);
          });
        },
        enumerable: !1,
        configurable: !0
      }), xt.prototype.set_content = function(bt) {
        if (bt instanceof _e)
          bt = [bt];
        else if (typeof bt == "string") {
          var Et = mt(bt);
          bt = Et.childNodes.length ? Et.childNodes : [new tt(bt)];
        }
        this.childNodes = bt;
      }, Object.defineProperty(xt.prototype, "outerHTML", {
        /** Convert this node into its HTML representation. This is an alias to toString() method. */
        get: function() {
          return this.toString();
        },
        enumerable: !1,
        configurable: !0
      }), xt.prototype.trimRight = function(bt) {
        for (var Et = 0; Et < this.childNodes.length; Et++) {
          var St = this.childNodes[Et];
          if (St.nodeType === _.ELEMENT_NODE)
            St.trimRight(bt);
          else {
            var Bt = St.rawText.search(bt);
            Bt > -1 && (St.value = St.rawText.substr(0, Bt), this.childNodes.length = Et + 1);
          }
        }
        return this;
      }, Object.defineProperty(xt.prototype, "structure", {
        /**
         * Get DOM structure
         * @return {string} strucutre
         */
        get: function() {
          var bt = [], Et = 0;
          function St(Ot) {
            bt.push("  ".repeat(Et) + Ot);
          }
          function Bt(Ot) {
            var Pt = Ot.id ? "#" + Ot.id : "", wt = Ot.classNames.length ? "." + Ot.classNames.join(".") : "";
            St(Ot.tagName + Pt + wt), Et++;
            for (var Ct = 0; Ct < Ot.childNodes.length; Ct++) {
              var It = Ot.childNodes[Ct];
              It.nodeType === _.ELEMENT_NODE ? Bt(It) : It.nodeType === _.TEXT_NODE && (It.isWhitespace || St("#text"));
            }
            Et--;
          }
          return Bt(this), bt.join(`
`);
        },
        enumerable: !1,
        configurable: !0
      }), xt.prototype.removeWhitespace = function() {
        for (var bt = 0, Et = 0; Et < this.childNodes.length; Et++) {
          var St = this.childNodes[Et];
          if (St.nodeType === _.TEXT_NODE) {
            if (St.isWhitespace)
              continue;
            St.value = St.rawText.trim();
          } else
            St.nodeType === _.ELEMENT_NODE && St.removeWhitespace();
          this.childNodes[bt++] = St;
        }
        return this.childNodes.length = bt, this;
      }, xt.prototype.querySelectorAll = function(bt) {
        var Et = this, St;
        if (bt instanceof et)
          St = bt, St.reset();
        else {
          if (bt.includes(",")) {
            var Bt = bt.split(",");
            return Array.from(Bt.reduce(function(yt, Rt) {
              var kt = Et.querySelectorAll(Rt.trim());
              return kt.reduce(function(jt, Ht) {
                return jt.add(Ht);
              }, yt);
            }, /* @__PURE__ */ new Set()));
          }
          St = new et(bt);
        }
        for (var Ot = [], Pt = [], wt = 0; wt < this.childNodes.length; wt++)
          for (Pt.push([this.childNodes[wt], 0, !1]); Pt.length; ) {
            var Ct = ot(Pt), It = Ct[0];
            if (Ct[1] === 0) {
              if (It.nodeType !== _.ELEMENT_NODE) {
                Pt.pop();
                continue;
              }
              if ((Ct[2] = St.advance(It)) && St.matched) {
                Ot.push(It), St.rewind(), Pt.pop();
                continue;
              }
            }
            Ct[1] < It.childNodes.length ? Pt.push([It.childNodes[Ct[1]++], 0, !1]) : (Ct[2] && St.rewind(), Pt.pop());
          }
        return Ot;
      }, xt.prototype.querySelector = function(bt) {
        var Et;
        bt instanceof et ? (Et = bt, Et.reset()) : Et = new et(bt);
        for (var St = [], Bt = 0; Bt < this.childNodes.length; Bt++)
          for (St.push([this.childNodes[Bt], 0, !1]); St.length; ) {
            var Ot = ot(St), Pt = Ot[0];
            if (Ot[1] === 0) {
              if (Pt.nodeType !== _.ELEMENT_NODE) {
                St.pop();
                continue;
              }
              if ((Ot[2] = Et.advance(Pt)) && Et.matched)
                return Pt;
            }
            Ot[1] < Pt.childNodes.length ? St.push([Pt.childNodes[Ot[1]++], 0, !1]) : (Ot[2] && Et.rewind(), St.pop());
          }
        return null;
      }, xt.prototype.appendChild = function(bt) {
        return this.childNodes.push(bt), bt instanceof xt && (bt.parentNode = this), bt;
      }, xt.prototype.prependChild = function(bt) {
        return this.childNodes.unshift(bt), bt instanceof xt && (bt.parentNode = this), bt;
      }, Object.defineProperty(xt.prototype, "firstChild", {
        /**
         * Get first child node
         * @return {Node} first child node
         */
        get: function() {
          return this.childNodes[0];
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(xt.prototype, "lastChild", {
        /**
         * Get last child node
         * @return {Node} last child node
         */
        get: function() {
          return ot(this.childNodes);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(xt.prototype, "attributes", {
        /**
         * Get attributes
         * @return {Object} parsed and unescaped attributes
         */
        get: function() {
          if (this._attrs)
            return this._attrs;
          this._attrs = {};
          var bt = this.rawAttributes;
          for (var Et in bt)
            this._attrs[Et] = (0, $.decode)(bt[Et]);
          return this._attrs;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(xt.prototype, "rawAttributes", {
        /**
         * Get escaped (as-it) attributes
         * @return {Object} parsed attributes
         */
        get: function() {
          if (this._rawAttrs)
            return this._rawAttrs;
          var bt = {};
          if (this.rawAttrs)
            for (var Et = void 0; Et = ft.exec(this.rawAttrs); )
              bt[Et[1]] = Et[4] || Et[5] || Et[6] || "";
          return this._rawAttrs = bt, bt;
        },
        enumerable: !1,
        configurable: !0
      }), xt.prototype.setAttribute = function(bt, Et) {
        bt === "id" ? this.id = Et : bt === "class" && (this.classNames = Et.split(/\s+/));
        var St = this.attributes;
        Et === void 0 ? delete St[bt] : St[bt] = Et + "", this._rawAttrs && (Et === void 0 ? delete this._rawAttrs[bt] : this._rawAttrs[bt] = (0, $.encode)(Et + "")), this.rawAttrs = Object.keys(St).map(function(Bt) {
          return Bt + (St[Bt] === "" ? "" : '="' + (0, $.encode)(St[Bt]) + '"');
        }).join(" ");
      }, xt.prototype.removeAttribute = function(bt) {
        this.setAttribute(bt, void 0);
      }, xt.prototype.setAttributes = function(bt) {
        var Et = this;
        bt.id ? this.id = bt.id : bt.class && (this.classNames = bt.class.split(/\s+/)), this.attributes && (Object.keys(this.attributes).forEach(function(St) {
          return delete Et.attributes[St];
        }), Object.keys(bt).forEach(function(St) {
          return Et.attributes[St] = bt[St] + "";
        })), this.rawAttributes && (Object.keys(this.rawAttributes).forEach(function(St) {
          return delete Et.rawAttributes[St];
        }), Object.keys(bt).forEach(function(St) {
          return Et.rawAttributes[St] = (0, $.encode)(bt[St] + "");
        })), this.rawAttrs = Object.keys(bt).map(function(St) {
          return St + (bt[St] === "" ? "" : '="' + (0, $.encode)(bt[St] + "") + '"');
        }).join(" ");
      }, xt;
    }(_e)
  );
  a.HTMLElement = rt;
  var st = {}, lt = {
    f145: function(At, xt, bt, Et, St) {
      if (xt = xt || "", bt = bt || [], At.id != xt.substr(1))
        return !1;
      for (var Bt = bt, Ot = 0; Ot < Bt.length; Ot++)
        if (At.classNames.indexOf(Bt[Ot]) === -1)
          return !1;
      return !0;
    },
    f45: function(At, xt, bt, Et, St) {
      bt = bt || [];
      for (var Bt = bt, Ot = 0; Ot < Bt.length; Ot++)
        if (At.classNames.indexOf(Bt[Ot]) === -1)
          return !1;
      return !0;
    },
    f15: function(At, xt, bt, Et, St) {
      return xt = xt || "", At.id == xt.substr(1);
    },
    f1: function(At, xt, bt, Et, St) {
      if (xt = xt || "", At.id != xt.substr(1))
        return !1;
    },
    f5: function(At, xt, bt, Et, St) {
      return !0;
    },
    f245: function(At, xt, bt, Et, St) {
      Et = Et || "", St = St || "";
      var Bt = At.attributes;
      for (var Ot in Bt) {
        var Pt = Bt[Ot];
        if (Ot == Et && Pt == St)
          return !0;
      }
      return !1;
    },
    f25: function(At, xt, bt, Et, St) {
      Et = Et || "", St = St || "";
      var Bt = At.attributes;
      for (var Ot in Bt) {
        var Pt = Bt[Ot];
        if (Ot == Et && Pt == St)
          return !0;
      }
      return !1;
    },
    f2: function(At, xt, bt, Et, St) {
      Et = Et || "", St = St || "";
      var Bt = At.attributes;
      for (var Ot in Bt) {
        var Pt = Bt[Ot];
        if (Ot == Et && Pt == St)
          return !0;
      }
      return !1;
    },
    f345: function(At, xt, bt, Et, St) {
      if (xt = xt || "", bt = bt || [], At.tagName != xt)
        return !1;
      for (var Bt = bt, Ot = 0; Ot < Bt.length; Ot++)
        if (At.classNames.indexOf(Bt[Ot]) === -1)
          return !1;
      return !0;
    },
    f35: function(At, xt, bt, Et, St) {
      return xt = xt || "", At.tagName == xt;
    },
    f3: function(At, xt, bt, Et, St) {
      if (xt = xt || "", At.tagName != xt)
        return !1;
    }
  }, et = (
    /** @class */
    function() {
      function At(xt) {
        this.nextMatch = 0, lt.f5 = lt.f5, this.matchers = xt.split(" ").map(function(bt) {
          if (st[bt])
            return st[bt];
          var Et = bt.split("."), St = Et[0], Bt = Et.slice(1).sort(), Ot = '"use strict";', Pt = "f", wt = "", Ct = "";
          if (St && St != "*") {
            var It;
            if (St[0] == "#")
              Ot += "if (el.id != " + JSON.stringify(St.substr(1)) + ") return false;", Pt += "1";
            else if (It = St.match(/^\[\s*(\S+)\s*(=|!=)\s*((((["'])([^\6]*)\6))|(\S*?))\]\s*/)) {
              wt = It[1];
              var yt = It[2];
              if (yt !== "=" && yt !== "!=")
                throw new Error("Selector not supported, Expect [key${op}value].op must be =,!=");
              yt === "=" && (yt = "=="), Ct = It[7] || It[8], Ot += 'let attrs = el.attributes;for (let key in attrs){const val = attrs[key]; if (key == "'.concat(wt, '" && val == "').concat(Ct, '"){return true;}} return false;'), Pt += "2";
            } else
              Ot += "if (el.tagName != " + JSON.stringify(St) + ") return false;", Pt += "3";
          }
          Bt.length > 0 && (Ot += "for (let cls = " + JSON.stringify(Bt) + ", i = 0; i < cls.length; i++) if (el.classNames.indexOf(cls[i]) === -1) return false;", Pt += "4"), Ot += "return true;", Pt += "5";
          var Rt = {
            func: lt[Pt],
            tagName: St || "",
            classes: Bt || "",
            attr_key: wt || "",
            value: Ct || ""
          };
          return Ot = Ot || "", st[bt] = Rt;
        });
      }
      return At.prototype.advance = function(xt) {
        return this.nextMatch < this.matchers.length && this.matchers[this.nextMatch].func(xt, this.matchers[this.nextMatch].tagName, this.matchers[this.nextMatch].classes, this.matchers[this.nextMatch].attr_key, this.matchers[this.nextMatch].value) ? (this.nextMatch++, !0) : !1;
      }, At.prototype.rewind = function() {
        this.nextMatch--;
      }, Object.defineProperty(At.prototype, "matched", {
        /**
         * Trying to determine if match made.
         * @return {bool} true when the match is made
         */
        get: function() {
          return this.nextMatch == this.matchers.length;
        },
        enumerable: !1,
        configurable: !0
      }), At.prototype.reset = function() {
        this.nextMatch = 0;
      }, At.prototype.flushCache = function() {
        st = {};
      }, At;
    }()
  );
  a.Matcher = et;
  var it = /<!--[^]*?(?=-->)-->|<(\/?)([a-z][-.:0-9_a-z]*)((\s+[a-z][-.:0-9_a-z]*(\s*=\s*("[^"]*"|'([^']*')|([^\s\/>]+)))?)*)\s*(\/?)>/ig, ut = /(^|\s)(id|class)\s*=\s*("([^"]+)"|'([^']+)'|(\S+))/ig, ft = /([a-z][-.:0-9_a-z]*)(\s*=\s*("([^"]*)"|'([^']*)'|(\S+)))?/ig, ht = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    hr: !0,
    img: !0,
    input: !0,
    link: !0,
    meta: !0,
    source: !0
  }, dt = {
    li: { li: !0 },
    p: { p: !0, div: !0 },
    b: { div: !0 },
    td: { td: !0, th: !0 },
    th: { td: !0, th: !0 },
    h1: { h1: !0 },
    h2: { h2: !0 },
    h3: { h3: !0 },
    h4: { h4: !0 },
    h5: { h5: !0 },
    h6: { h6: !0 }
  }, gt = {
    li: { ul: !0, ol: !0 },
    a: { div: !0 },
    b: { div: !0 },
    i: { div: !0 },
    p: { div: !0 },
    td: { tr: !0, table: !0 },
    th: { tr: !0, table: !0 }
  }, pt = {
    script: !0,
    noscript: !0,
    style: !0,
    pre: !0
  };
  function mt(At, xt) {
    var bt = new rt(null), Et = bt, St = [bt], Bt = 0;
    xt = xt || {};
    for (var Ot; Ot = it.exec(At); ) {
      if (Bt + Ot[0].length < it.lastIndex) {
        var Pt = At.substring(Bt, it.lastIndex - Ot[0].length);
        Et.appendChild(new tt(Pt));
      }
      if (Bt = it.lastIndex, Ot[0][1] == "!") {
        if (xt.comment) {
          var Pt = At.substring(Bt - 3, Bt - Ot[0].length + 4);
          Et.appendChild(new nt(Pt));
        }
        continue;
      }
      if (xt.lowerCaseTagName && (Ot[2] = Ot[2].toLowerCase()), !Ot[1] && (!Ot[9] && dt[Et.tagName] && dt[Et.tagName][Ot[2]] && (St.pop(), Et = ot(St)), Et = Et.appendChild(new rt(Ot[2], Ot[3].trim())), St.push(Et), pt[Ot[2]])) {
        var wt = "</" + Ot[2] + ">", Ct = At.indexOf(wt, it.lastIndex);
        if (xt[Ot[2]]) {
          var Pt = void 0;
          Ct == -1 ? Pt = At.substr(it.lastIndex) : Pt = At.substring(it.lastIndex, Ct), Pt.length > 0 && Et.appendChild(new tt(Pt));
        }
        Ct == -1 ? Bt = it.lastIndex = At.length + 1 : (Bt = it.lastIndex = Ct + wt.length, Ot[1] = "true");
      }
      if (Ot[1] || Ot[9] || ht[Ot[2]])
        for (; ; )
          if (Et.tagName == Ot[2]) {
            St.pop(), Et = ot(St);
            break;
          } else {
            if (gt[Et.tagName] && gt[Et.tagName][Ot[2]]) {
              St.pop(), Et = ot(St);
              continue;
            }
            break;
          }
    }
    Bt < At.length && bt.appendChild(new tt(At.substring(Bt))), bt.valid = St.length === 1;
    for (var It = function() {
      var yt = St.pop(), Rt = ot(St);
      yt.parentNode && yt.parentNode instanceof rt && yt.parentNode.parentNode && (yt.parentNode === Rt && yt.tagName === Rt.tagName ? (Rt.removeChild(yt), yt.childNodes.forEach(function(kt) {
        Rt.parentNode.appendChild(kt);
      }), St.pop()) : (Rt.removeChild(yt), yt.childNodes.forEach(function(kt) {
        Rt.appendChild(kt);
      })));
    }; St.length > 1; )
      It();
    return bt;
  }
  a.parse = mt;
  var ct = [
    "html",
    "body",
    "address",
    "article",
    "aside",
    "blockquote",
    "canvas",
    "dd",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "header",
    "hr",
    "li",
    "main",
    "nav",
    "noscript",
    "ol",
    "p",
    "pre",
    "section",
    "tfoot",
    "table",
    "tbody",
    "ul",
    "video",
    "th",
    "td",
    "tr",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
  ];
  function vt(At) {
    return At.nodeType === _.ELEMENT_NODE && At.tagName && ct.includes(At.tagName.toLowerCase());
  }
  a.isBlock = vt;
})(dist);
LineCapStyle.Butt, LineCapStyle.Round, LineCapStyle.Projecting;
FillRule.EvenOdd, FillRule.NonZero;
LineJoinStyle.Bevel, LineJoinStyle.Miter, LineJoinStyle.Round;
let Cell$2 = class {
  constructor(s, $, _) {
    Object.defineProperty(this, "raw", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "text", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "styles", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "section", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "contentHeight", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "contentWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "wrappedWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "minReadableWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "minWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "width", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "height", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "x", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "y", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), this.styles = $, this.section = _, this.raw = s;
    const _e = /\r\n|\r|\n/g;
    this.text = s.split(_e);
  }
  getContentHeight() {
    const s = Array.isArray(this.text) ? this.text.length : 1, $ = pt2mm(this.styles.fontSize) * this.styles.lineHeight, _ = this.padding("top") + this.padding("bottom"), _e = s * $ + _;
    return Math.max(_e, this.styles.minCellHeight);
  }
  padding(s) {
    return this.styles.cellPadding[s];
  }
}, Column$2 = class {
  constructor(s) {
    Object.defineProperty(this, "index", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "wrappedWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "minReadableWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "minWidth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "width", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), this.index = s;
  }
  getMaxCustomCellWidth(s) {
    let $ = 0;
    for (const _ of s.allRows()) {
      const _e = _.cells[this.index];
      $ = Math.max($, _e.styles.cellWidth);
    }
    return $;
  }
}, Row$2 = class {
  constructor(s, $, _, _e) {
    Object.defineProperty(this, "raw", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "index", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "section", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cells", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "height", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), this.raw = s, this.index = $, this.section = _, this.cells = _e;
  }
  getMaxCellHeight(s) {
    return s.reduce(($, _) => {
      var _e;
      return Math.max($, ((_e = this.cells[_.index]) == null ? void 0 : _e.height) || 0);
    }, 0);
  }
  getMinimumRowHeight(s) {
    return s.reduce(($, _) => {
      const _e = this.cells[_.index];
      if (!_e)
        return 0;
      const nt = _e.padding("top") + _e.padding("bottom") + _e.styles.lineHeight;
      return nt > $ ? nt : $;
    }, 0);
  }
}, Table$3 = class ou {
  constructor(s, $) {
    Object.defineProperty(this, "settings", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "styles", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "columns", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "head", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.settings = s.settings, this.styles = s.styles, this.columns = $.columns, this.head = $.head, this.body = $.body;
  }
  static async create(s) {
    const { input: $, content: _, font: _e, _cache: tt } = s, nt = new ou($, _);
    return await calculateWidths({ table: nt, font: _e, _cache: tt }), nt;
  }
  getHeadHeight() {
    return this.head.reduce((s, $) => s + $.getMaxCellHeight(this.columns), 0);
  }
  getBodyHeight() {
    return this.body.reduce((s, $) => s + $.getMaxCellHeight(this.columns), 0);
  }
  allRows() {
    return this.head.concat(this.body);
  }
  getWidth() {
    return this.settings.tableWidth;
  }
  getHeight() {
    return (this.settings.showHead ? this.getHeadHeight() : 0) + this.getBodyHeight();
  }
};
async function calculateWidths(a) {
  const { table: s, font: $, _cache: _ } = a, _e = (ot) => getFontKitFont(ot, $, _);
  await calculate$1(s, _e);
  const tt = [];
  let nt = 0;
  s.columns.forEach((ot) => {
    const rt = ot.getMaxCustomCellWidth(s);
    rt ? ot.width = rt : (ot.width = ot.wrappedWidth, tt.push(ot)), nt += ot.width;
  });
  let at = s.getWidth() - nt;
  at && (at = resizeColumns(tt, at, (ot) => Math.max(ot.minReadableWidth, ot.minWidth))), at && (at = resizeColumns(tt, at, (ot) => ot.minWidth)), at = Math.abs(at), applyColSpans(s), await fitContent(s, _e), applyRowSpans(s);
}
function applyRowSpans(a) {
  const s = {};
  let $ = 1;
  const _ = a.allRows();
  for (let _e = 0; _e < _.length; _e++) {
    const tt = _[_e];
    for (const nt of a.columns) {
      const at = s[nt.index];
      if ($ > 1)
        $--, delete tt.cells[nt.index];
      else if (at)
        at.cell.height += tt.height, $ = 1, delete tt.cells[nt.index], at.left--, at.left <= 1 && delete s[nt.index];
      else {
        const ot = tt.cells[nt.index];
        if (!ot)
          continue;
        ot.height = tt.height;
      }
    }
  }
}
function applyColSpans(a) {
  const s = a.allRows();
  for (let $ = 0; $ < s.length; $++) {
    const _ = s[$];
    let _e = 0, tt = 0;
    for (let nt = 0; nt < a.columns.length; nt++) {
      const at = a.columns[nt];
      if (tt -= 1, tt > 1 && a.columns[nt + 1])
        _e += at.width, delete _.cells[at.index];
      else {
        const ot = _.cells[at.index];
        if (!ot)
          continue;
        tt = 1, _e = 0, ot.width = at.width + _e;
      }
    }
  }
}
async function fitContent(a, s) {
  const $ = { count: 0, height: 0 };
  for (const _ of a.allRows()) {
    for (const _e of a.columns) {
      const tt = _.cells[_e.index];
      if (!tt)
        continue;
      const nt = await s(tt.styles.fontName);
      tt.text = splitTextToSize({
        value: tt.raw,
        characterSpacing: tt.styles.characterSpacing,
        boxWidthInPt: mm2pt(tt.width),
        fontSize: tt.styles.fontSize,
        fontKitFont: nt
      }), tt.contentHeight = tt.getContentHeight();
      let at = tt.contentHeight;
      $ && $.count > 0 && $.height > at && (at = $.height), at > _.height && (_.height = at);
    }
    $.count--;
  }
}
function resizeColumns(a, s, $) {
  const _ = s, _e = a.reduce((tt, nt) => tt + nt.wrappedWidth, 0);
  for (let tt = 0; tt < a.length; tt++) {
    const nt = a[tt], at = nt.wrappedWidth / _e, ot = _ * at, rt = nt.width + ot, st = $(nt), lt = rt < st ? st : rt;
    s -= lt - nt.width, nt.width = lt;
  }
  if (s = Math.round(s * 1e10) / 1e10, s) {
    const tt = a.filter((nt) => s < 0 ? nt.width > $(nt) : !0);
    tt.length && (s = resizeColumns(tt, s, $));
  }
  return s;
}
async function calculate$1(a, s) {
  for (const $ of a.allRows())
    for (const _ of a.columns) {
      const _e = $.cells[_.index];
      if (!_e)
        continue;
      const tt = _e.padding("right") + _e.padding("left"), nt = await s(_e.styles.fontName);
      _e.contentWidth = getStringWidth(_e, nt) + tt;
      const at = getStringWidth(Object.assign(_e, { text: _e.text.join(" ").split(/\s+/) }), nt);
      _e.minReadableWidth = at + tt, _e.minWidth = _e.styles.cellWidth, _e.wrappedWidth = _e.styles.cellWidth;
    }
  for (const $ of a.allRows())
    for (const _ of a.columns) {
      const _e = $.cells[_.index];
      if (_e)
        _.wrappedWidth = Math.max(_.wrappedWidth, _e.wrappedWidth), _.minWidth = Math.max(_.minWidth, _e.minWidth), _.minReadableWidth = Math.max(_.minReadableWidth, _e.minReadableWidth);
      else {
        const tt = a.styles.columnStyles[_.index] || {}, nt = tt.cellWidth || tt.minCellWidth;
        nt && (_.minWidth = nt, _.wrappedWidth = nt);
      }
    }
}
function getStringWidth(a, s) {
  const $ = a.text, _ = Array.isArray($) ? $ : [$], _e = a.styles.fontSize, tt = a.styles.characterSpacing;
  return _.map((at) => widthOfTextAtSize(at, s, _e, tt)).reduce((at, ot) => Math.max(at, ot), 0);
}
function parseSection(a, s, $, _, _e) {
  const tt = {};
  return s.map((at, ot) => {
    let rt = 0;
    const st = {};
    let lt = 0, et = 0;
    for (const it of $)
      if (tt[it.index] == null || tt[it.index].left === 0)
        if (et === 0) {
          let ut;
          Array.isArray(at) ? ut = at[it.index - lt - rt] : ut = at[it.index];
          const ft = cellStyles(a, it, ot, _, _e), ht = new Cell$2(ut, ft, a);
          st[it.index] = ht, et = 0, tt[it.index] = {
            left: 0,
            times: et
          };
        } else
          et--, lt++;
      else
        tt[it.index].left--, et = tt[it.index].times, rt++;
    return new Row$2(at, ot, a, st);
  });
}
function parseContent4Table(a, s) {
  const $ = a.content, _ = $.columns.map((tt) => new Column$2(tt)), _e = a.styles;
  return {
    columns: _,
    head: parseSection("head", $.head, _, _e, s),
    body: parseSection("body", $.body, _, _e, s)
  };
}
function cellStyles(a, s, $, _, _e) {
  let tt;
  a === "head" ? tt = _.headStyles : a === "body" && (tt = _.bodyStyles);
  const nt = Object.assign({}, _.styles, tt), at = _.columnStyles[s.index] || _.columnStyles[s.index] || {}, ot = a === "body" && $ % 2 === 0 ? Object.assign({}, _.alternateRowStyles) : {};
  return Object.assign({
    fontName: _e,
    backgroundColor: "",
    textColor: "#000000",
    lineHeight: 1,
    characterSpacing: 0,
    alignment: "left",
    verticalAlignment: "middle",
    fontSize: 10,
    cellPadding: 5,
    lineColor: "#000000",
    lineWidth: 0,
    minCellHeight: 0,
    minCellWidth: 0
  }, nt, ot, at);
}
function mapCellStyle(a) {
  return {
    fontName: a.fontName,
    alignment: a.alignment,
    verticalAlignment: a.verticalAlignment,
    fontSize: a.fontSize,
    lineHeight: a.lineHeight,
    characterSpacing: a.characterSpacing,
    backgroundColor: a.backgroundColor,
    // ---
    textColor: a.fontColor,
    lineColor: a.borderColor,
    lineWidth: a.borderWidth,
    cellPadding: a.padding
  };
}
function getTableOptions(a, s) {
  const $ = a.headWidthPercentages.reduce((nt, at, ot) => ({ ...nt, [ot]: { cellWidth: a.width * (at / 100) } }), {}), _ = Object.entries(a.columnStyles.alignment || {}).reduce((nt, [at, ot]) => ({ ...nt, [at]: { alignment: ot } }), {}), _e = /* @__PURE__ */ new Set([
    ...Object.keys($).map(Number),
    ...Object.keys(_).map(Number)
  ]), tt = Array.from(_e).reduce((nt, at) => {
    const ot = $[at] || {}, rt = _[at] || {};
    return { ...nt, [at]: { ...ot, ...rt } };
  }, {});
  return {
    head: [a.head],
    body: s,
    showHead: a.showHead,
    startY: a.position.y,
    tableWidth: a.width,
    tableLineColor: a.tableStyles.borderColor,
    tableLineWidth: a.tableStyles.borderWidth,
    headStyles: mapCellStyle(a.headStyles),
    bodyStyles: mapCellStyle(a.bodyStyles),
    alternateRowStyles: { backgroundColor: a.bodyStyles.alternateBackgroundColor },
    columnStyles: tt,
    margin: { top: 0, right: 0, left: a.position.x, bottom: 0 }
  };
}
function parseStyles(a) {
  const s = {
    styles: {},
    headStyles: {},
    bodyStyles: {},
    alternateRowStyles: {},
    columnStyles: {}
  };
  for (const $ of Object.keys(s))
    if ($ === "columnStyles") {
      const _ = a[$];
      s.columnStyles = Object.assign({}, _);
    } else {
      const _e = [a].map((tt) => tt[$] || {});
      s[$] = Object.assign({}, _e[0], _e[1], _e[2]);
    }
  return s;
}
function parseContent4Input(a) {
  const s = a.head || [], $ = a.body || [];
  return { columns: (s[0] || $[0] || []).map((_e, tt) => tt), head: s, body: $ };
}
function parseInput(a, s) {
  const $ = getTableOptions(a, s), _ = parseStyles($), _e = {
    startY: $.startY,
    margin: $.margin,
    tableWidth: $.tableWidth,
    showHead: $.showHead,
    tableLineWidth: $.tableLineWidth ?? 0,
    tableLineColor: $.tableLineColor ?? ""
  };
  return { content: parseContent4Input($), styles: _, settings: _e };
}
function createSingleTable(a, s) {
  const { options: $, _cache: _, basePdf: _e } = s;
  isBlankPdf(_e) || console.warn(`[@pdfme/schema/table]When specifying a custom PDF for basePdf, you cannot use features such as page breaks or re-layout of other elements.To utilize these features, please define basePdf as follows:
{ width: number; height: number; padding: [number, number, number, number]; }`);
  const tt = cloneDeep$1(s.schema), { start: nt } = tt.__bodyRange || { start: 0 };
  if (nt % 2 === 1) {
    const lt = tt.bodyStyles.alternateBackgroundColor;
    tt.bodyStyles.alternateBackgroundColor = tt.bodyStyles.backgroundColor, tt.bodyStyles.backgroundColor = lt;
  }
  tt.showHead = tt.showHead === !1 ? !1 : !tt.__isSplit;
  const at = parseInput(tt, a), ot = $.font || getDefaultFont(), rt = getFallbackFontName(ot), st = parseContent4Table(at, rt);
  return Table$3.create({ input: at, content: st, font: ot, _cache: _ });
}
const DEFAULT_OPACITY = 1, HEX_COLOR_PATTERN = "^#(?:[A-Fa-f0-9]{6})$", getBody$1 = (a) => typeof a == "string" ? JSON.parse(a || "[]") : a || [], getBodyWithRange = (a, s) => {
  const $ = getBody$1(a);
  return s ? $.slice(s.start, s.end) : $;
}, getDynamicHeightsForTable$1 = async (a, s) => {
  var tt;
  if (s.schema.type !== "table")
    return Promise.resolve([s.schema.height]);
  const $ = s.schema, _ = ((tt = $.__bodyRange) == null ? void 0 : tt.start) === 0 ? getBody$1(a) : getBodyWithRange(a, $.__bodyRange);
  return (await createSingleTable(_, s)).allRows().map((nt) => nt.height);
}, convertForPdfLayoutProps = ({ schema: a, pageHeight: s, applyRotateTranslate: $ = !0 }) => {
  const { width: _, height: _e, position: tt, rotate: nt, opacity: at } = a, { x: ot, y: rt } = tt, st = nt ? -nt : 0, lt = mm2pt(_), et = mm2pt(_e);
  let it = mm2pt(ot), ut = s - mm2pt(rt) - et;
  if (st && $) {
    const ft = { x: it + lt / 2, y: s - mm2pt(rt) - et / 2 }, ht = rotatePoint({ x: it, y: ut }, ft, st);
    it = ht.x, ut = ht.y;
  }
  return {
    position: { x: it, y: ut },
    height: et,
    width: lt,
    rotate: degrees(st),
    opacity: at
  };
}, rotatePoint = (a, s, $) => {
  const _ = degreesToRadians($), _e = Math.cos(_) * (a.x - s.x) - Math.sin(_) * (a.y - s.y) + s.x, tt = Math.sin(_) * (a.x - s.x) + Math.cos(_) * (a.y - s.y) + s.y;
  return { x: _e, y: tt };
}, getDynamicHeightsForTable = getDynamicHeightsForTable$1, isEditable = (a, s) => a === "designer" || a === "form" && s.readOnly !== !0, hex2rgb = (a) => (a.slice(0, 1) === "#" && (a = a.slice(1)), a.length === 3 && (a = a.slice(0, 1) + a.slice(0, 1) + a.slice(1, 2) + a.slice(1, 2) + a.slice(2, 3) + a.slice(2, 3)), [a.slice(0, 2), a.slice(2, 4), a.slice(4, 6)].map((s) => parseInt(s, 16))), hex2RgbColor = (a) => {
  if (a) {
    if (!isHexValid(a))
      throw new Error(`Invalid hex color value ${a}`);
    const [$, _, _e] = hex2rgb(a);
    return rgb($ / 255, _ / 255, _e / 255);
  }
}, hex2CmykColor = (a) => {
  if (a) {
    if (!isHexValid(a))
      throw new Error(`Invalid hex color value ${a}`);
    a = a.replace("#", "");
    const $ = a.substring(0, 6), _ = a.substring(6, 8), _e = _ ? parseInt(_, 16) / 255 : 1;
    let tt = parseInt($.substring(0, 2), 16) / 255, nt = parseInt($.substring(2, 4), 16) / 255, at = parseInt($.substring(4, 6), 16) / 255;
    tt = tt * _e + (1 - _e), nt = nt * _e + (1 - _e), at = at * _e + (1 - _e);
    const ot = 1 - Math.max(tt, nt, at), rt = tt === 0 ? 0 : (1 - tt - ot) / (1 - ot), st = nt === 0 ? 0 : (1 - nt - ot) / (1 - ot), lt = at === 0 ? 0 : (1 - at - ot) / (1 - ot);
    return cmyk(rt, st, lt, ot);
  }
}, hex2PrintingColor = (a, s) => (s == null ? void 0 : s.toLocaleLowerCase()) == "cmyk" ? hex2CmykColor(a) : hex2RgbColor(a), embedAndGetFontObj = async (a) => {
  const { pdfDoc: s, font: $, _cache: _ } = a;
  if (_.has(s))
    return _.get(s);
  const _e = await Promise.all(Object.values($).map(async (nt) => {
    let at = nt.data;
    return typeof at == "string" && at.startsWith("http") && (at = await fetch(at).then((ot) => ot.arrayBuffer())), s.embedFont(at, {
      subset: typeof nt.subset > "u" ? !0 : nt.subset
    });
  })), tt = Object.keys($).reduce((nt, at, ot) => Object.assign(nt, { [at]: _e[ot] }), {});
  return _.set(s, tt), tt;
}, getFontProp = async ({ value: a, font: s, schema: $, colorType: _, _cache: _e }) => {
  const tt = $.dynamicFontSize ? await calculateDynamicFontSize({ textSchema: $, font: s, value: a, _cache: _e }) : $.fontSize ?? DEFAULT_FONT_SIZE, nt = hex2PrintingColor($.fontColor || DEFAULT_FONT_COLOR, _);
  return {
    alignment: $.alignment ?? DEFAULT_ALIGNMENT,
    verticalAlignment: $.verticalAlignment ?? DEFAULT_VERTICAL_ALIGNMENT,
    lineHeight: $.lineHeight ?? DEFAULT_LINE_HEIGHT,
    characterSpacing: $.characterSpacing ?? DEFAULT_CHARACTER_SPACING,
    fontSize: tt,
    color: nt
  };
}, pdfRender = async (a) => {
  const { value: s, pdfDoc: $, pdfLib: _, page: _e, options: tt, schema: nt, _cache: at } = a;
  if (!s)
    return;
  const { font: ot = getDefaultFont(), colorType: rt } = tt, [st, lt, et] = await Promise.all([
    embedAndGetFontObj({ pdfDoc: $, font: ot, _cache: at }),
    getFontKitFont(nt.fontName, ot, at),
    getFontProp({ value: s, font: ot, schema: nt, _cache: at, colorType: rt })
  ]), { fontSize: it, color: ut, alignment: ft, verticalAlignment: ht, lineHeight: dt, characterSpacing: gt } = et, pt = nt.fontName ? nt.fontName : getFallbackFontName(ot), mt = st && st[pt], ct = _e.getHeight(), { width: vt, height: At, rotate: xt, position: { x: bt, y: Et }, opacity: St } = convertForPdfLayoutProps({ schema: nt, pageHeight: ct, applyRotateTranslate: !1 });
  if (nt.backgroundColor) {
    const yt = hex2PrintingColor(nt.backgroundColor, rt);
    _e.drawRectangle({ x: bt, y: Et, width: vt, height: At, rotate: xt, color: yt });
  }
  _e.pushOperators(_.setCharacterSpacing(gt ?? DEFAULT_CHARACTER_SPACING));
  const Bt = heightOfFontAtSize(lt, it), Ot = getFontDescentInPt(lt, it), Pt = dt === 0 ? 0 : (dt - 1) * it / 2, wt = splitTextToSize({
    value: s,
    characterSpacing: gt,
    fontSize: it,
    fontKitFont: lt,
    boxWidthInPt: vt
  });
  let Ct = 0;
  if (ht === VERTICAL_ALIGN_TOP)
    Ct = Bt + Pt;
  else {
    const yt = dt * it * (wt.length - 1);
    ht === VERTICAL_ALIGN_BOTTOM ? Ct = At - yt + Ot - Pt : ht === VERTICAL_ALIGN_MIDDLE && (Ct = (At - yt - Bt + Ot) / 2 + Bt);
  }
  const It = { x: bt + vt / 2, y: ct - mm2pt(nt.position.y) - At / 2 };
  wt.forEach((yt, Rt) => {
    const kt = widthOfTextAtSize(yt, lt, it, gt), jt = heightOfFontAtSize(lt, it), Ht = dt * it * Rt;
    let Ft = bt;
    ft === "center" ? Ft += (vt - kt) / 2 : ft === "right" && (Ft += vt - kt);
    let _t = ct - mm2pt(nt.position.y) - Ct - Ht;
    if (nt.strikethrough && kt > 0) {
      const Nt = Ft + kt + 1, Mt = _t + jt / 3;
      _e.drawLine({
        start: rotatePoint({ x: Ft, y: Mt }, It, xt.angle),
        end: rotatePoint({ x: Nt, y: Mt }, It, xt.angle),
        thickness: 1 / 12 * it,
        color: ut,
        opacity: St
      });
    }
    if (nt.underline && kt > 0) {
      const Nt = Ft + kt + 1, Mt = _t - jt / 12;
      _e.drawLine({
        start: rotatePoint({ x: Ft, y: Mt }, It, xt.angle),
        end: rotatePoint({ x: Nt, y: Mt }, It, xt.angle),
        thickness: 1 / 12 * it,
        color: ut,
        opacity: St
      });
    }
    if (xt.angle !== 0) {
      const Nt = rotatePoint({ x: Ft, y: _t }, It, xt.angle);
      Ft = Nt.x, _t = Nt.y;
    }
    _e.drawText(yt, {
      x: Ft,
      y: _t,
      rotate: xt,
      size: it,
      color: ut,
      lineHeight: dt * it,
      font: mt,
      opacity: St
    });
  });
}, TextStrikethroughIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M6.85 7.08C6.85 4.37 9.45 3 12.24 3c1.64 0 3 .49 3.9 1.28c.77.65 1.46 1.73 1.46 3.24h-3.01c0-.31-.05-.59-.15-.85c-.29-.86-1.2-1.28-2.25-1.28c-1.86 0-2.34 1.02-2.34 1.7c0 .48.25.88.74 1.21c.38.25.77.48 1.41.7H7.39c-.21-.34-.54-.89-.54-1.92zM21 12v-2H3v2h9.62c1.15.45 1.96.75 1.96 1.97c0 1-.81 1.67-2.28 1.67c-1.54 0-2.93-.54-2.93-2.51H6.4c0 .55.08 1.13.24 1.58c.81 2.29 3.29 3.3 5.67 3.3c2.27 0 5.3-.89 5.3-4.05c0-.3-.01-1.16-.48-1.94H21V12z" fill="currentColor"></path></svg>', TextUnderlineIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z" fill="currentColor"></path></svg>', TextAlignLeftIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z" fill="currentColor"></path></svg>', TextAlignCenterIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z" fill="currentColor"></path></svg>', TextAlignRightIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z" fill="currentColor"></path></svg>', TextVerticalAlignTopIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M8 11h3v10h2V11h3l-4-4l-4 4zM4 3v2h16V3H4z" fill="currentColor"></path></svg>', TextVerticalAlignMiddleIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M8 19h3v4h2v-4h3l-4-4l-4 4zm8-14h-3V1h-2v4H8l4 4l4-4zM4 11v2h16v-2H4z" fill="currentColor"></path></svg>', TextVerticalAlignBottomIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M16 13h-3V3h-2v10H8l4 4l4-4zM4 19v2h16v-2H4z" fill="currentColor"></path></svg>';
var Formatter;
(function(a) {
  a.STRIKETHROUGH = "strikethrough", a.UNDERLINE = "underline", a.ALIGNMENT = "alignment", a.VERTICAL_ALIGNMENT = "verticalAlignment";
})(Formatter || (Formatter = {}));
function getExtraFormatterSchema(a) {
  const s = [
    { key: Formatter.STRIKETHROUGH, icon: TextStrikethroughIcon, type: "boolean" },
    { key: Formatter.UNDERLINE, icon: TextUnderlineIcon, type: "boolean" },
    { key: Formatter.ALIGNMENT, icon: TextAlignLeftIcon, type: "select", value: DEFAULT_ALIGNMENT },
    { key: Formatter.ALIGNMENT, icon: TextAlignCenterIcon, type: "select", value: ALIGN_CENTER },
    { key: Formatter.ALIGNMENT, icon: TextAlignRightIcon, type: "select", value: ALIGN_RIGHT },
    {
      key: Formatter.VERTICAL_ALIGNMENT,
      icon: TextVerticalAlignTopIcon,
      type: "select",
      value: DEFAULT_VERTICAL_ALIGNMENT
    },
    {
      key: Formatter.VERTICAL_ALIGNMENT,
      icon: TextVerticalAlignMiddleIcon,
      type: "select",
      value: VERTICAL_ALIGN_MIDDLE
    },
    {
      key: Formatter.VERTICAL_ALIGNMENT,
      icon: TextVerticalAlignBottomIcon,
      type: "select",
      value: VERTICAL_ALIGN_BOTTOM
    }
  ];
  return {
    title: a("schemas.text.format"),
    widget: "ButtonGroup",
    buttons: s,
    span: 17
  };
}
const UseDynamicFontSize = (a) => {
  const { rootElement: s, changeSchemas: $, activeSchema: _, i18n: _e } = a, tt = document.createElement("input");
  tt.type = "checkbox", tt.checked = !!(_ != null && _.dynamicFontSize), tt.onchange = (ot) => {
    const rt = ot.target.checked ? {
      min: DEFAULT_DYNAMIC_MIN_FONT_SIZE,
      max: DEFAULT_DYNAMIC_MAX_FONT_SIZE,
      fit: DEFAULT_DYNAMIC_FIT
    } : void 0;
    $([{ key: "dynamicFontSize", value: rt, schemaId: _.id }]);
  };
  const nt = document.createElement("label"), at = document.createElement("span");
  at.innerText = _e("schemas.text.dynamicFontSize") || "", at.style.cssText = "margin-left: 0.5rem", nt.style.cssText = "display: flex; width: 100%;", nt.appendChild(tt), nt.appendChild(at), s.appendChild(nt);
}, propPanel = {
  schema: ({ options: a, activeSchema: s, i18n: $ }) => {
    const _ = a.font || { [DEFAULT_FONT_NAME]: { data: "", fallback: !0 } }, _e = Object.keys(_), tt = getFallbackFontName(_), nt = !!(s != null && s.dynamicFontSize);
    return {
      fontName: {
        title: $("schemas.text.fontName"),
        type: "string",
        widget: "select",
        default: tt,
        props: { options: _e.map((ot) => ({ label: ot, value: ot })) },
        span: 12
      },
      fontSize: {
        title: $("schemas.text.size"),
        type: "number",
        widget: "inputNumber",
        span: 6,
        disabled: nt,
        props: { min: 0 }
      },
      characterSpacing: {
        title: $("schemas.text.spacing"),
        type: "number",
        widget: "inputNumber",
        span: 6,
        props: { min: 0 }
      },
      formatter: getExtraFormatterSchema($),
      lineHeight: {
        title: $("schemas.text.lineHeight"),
        type: "number",
        widget: "inputNumber",
        props: { step: 0.1, min: 0 },
        span: 7
      },
      useDynamicFontSize: { type: "boolean", widget: "UseDynamicFontSize", bind: !1, span: 16 },
      dynamicFontSize: {
        type: "object",
        widget: "card",
        column: 3,
        properties: {
          min: {
            title: $("schemas.text.min"),
            type: "number",
            widget: "inputNumber",
            hidden: !nt,
            props: { min: 0 }
          },
          max: {
            title: $("schemas.text.max"),
            type: "number",
            widget: "inputNumber",
            hidden: !nt,
            props: { min: 0 }
          },
          fit: {
            title: $("schemas.text.fit"),
            type: "string",
            widget: "select",
            hidden: !nt,
            props: {
              options: [
                { label: $("schemas.horizontal"), value: DYNAMIC_FIT_HORIZONTAL },
                { label: $("schemas.vertical"), value: DYNAMIC_FIT_VERTICAL }
              ]
            }
          }
        }
      },
      fontColor: {
        title: $("schemas.textColor"),
        type: "string",
        widget: "color",
        rules: [
          {
            pattern: HEX_COLOR_PATTERN,
            message: $("validation.hexColor")
          }
        ]
      },
      backgroundColor: {
        title: $("schemas.bgColor"),
        type: "string",
        widget: "color",
        rules: [
          {
            pattern: HEX_COLOR_PATTERN,
            message: $("validation.hexColor")
          }
        ]
      }
    };
  },
  widgets: { UseDynamicFontSize },
  defaultSchema: {
    name: "",
    type: "text",
    content: "Type Something...",
    position: { x: 0, y: 0 },
    width: 45,
    height: 10,
    // If the value of "rotate" is set to undefined or not set at all, rotation will be disabled in the UI.
    // Check this document: https://pdfme.com//docs/custom-schemas#learning-how-to-create-from-pdfmeschemas-code
    rotate: 0,
    alignment: DEFAULT_ALIGNMENT,
    verticalAlignment: DEFAULT_VERTICAL_ALIGNMENT,
    fontSize: DEFAULT_FONT_SIZE,
    lineHeight: DEFAULT_LINE_HEIGHT,
    characterSpacing: DEFAULT_CHARACTER_SPACING,
    dynamicFontSize: void 0,
    fontColor: DEFAULT_FONT_COLOR,
    fontName: void 0,
    backgroundColor: "",
    opacity: DEFAULT_OPACITY,
    strikethrough: !1,
    underline: !1
  }
}, replaceUnsupportedChars = (a, s) => {
  const $ = {}, _ = (tt) => {
    if (tt in $)
      return $[tt];
    const nt = s.hasGlyphForCodePoint(tt.codePointAt(0) || 0);
    return $[tt] = nt, nt;
  };
  return a.split(/(\r\n|\n|\r)/).map((tt) => /\r\n|\n|\r/.test(tt) ? tt : tt.split("").map((nt) => /\s/.test(nt) || nt.charCodeAt(0) < 32 || _(nt) ? nt : "〿").join("")).join("");
}, uiRender = async (a) => {
  const { value: s, schema: $, mode: _, onChange: _e, stopEditing: tt, tabIndex: nt, placeholder: at, options: ot, _cache: rt } = a, st = isEditable(_, $) && at && !s, lt = (ht) => {
    let dt = ht.innerText;
    return dt.endsWith(`
`) && (dt = dt.slice(0, -1)), dt;
  }, et = (ot == null ? void 0 : ot.font) || getDefaultFont(), [it, ut] = await Promise.all([
    getFontKitFont($.fontName, et, rt),
    buildStyledTextContainer(a, st ? at : s)
  ]), ft = replaceUnsupportedChars(s, it);
  if (!isEditable(_, $)) {
    ut.innerHTML = ft.split("").map((ht, dt) => `<span style="letter-spacing:${String(s).length === dt + 1 ? 0 : "inherit"};">${ht}</span>`).join("");
    return;
  }
  if (makeElementPlainTextContentEditable(ut), ut.tabIndex = nt || 0, ut.innerText = _ === "designer" ? s : ft, ut.addEventListener("blur", (ht) => {
    _e && _e({ key: "content", value: lt(ht.target) }), tt && tt();
  }), $.dynamicFontSize) {
    let ht;
    const dt = (ot == null ? void 0 : ot.font) || getDefaultFont(), gt = await getFontKitFont($.fontName, dt, rt);
    ut.addEventListener("keyup", () => {
      setTimeout(() => {
        (async () => {
          if (!ut.textContent)
            return;
          ht = await calculateDynamicFontSize({
            textSchema: $,
            font: dt,
            value: lt(ut),
            startingFontSize: ht,
            _cache: rt
          }), ut.style.fontSize = `${ht}pt`;
          const { topAdj: pt, bottomAdj: mt } = getBrowserVerticalFontAdjustments(gt, ht ?? $.fontSize ?? DEFAULT_FONT_SIZE, $.lineHeight ?? DEFAULT_LINE_HEIGHT, $.verticalAlignment ?? DEFAULT_VERTICAL_ALIGNMENT);
          ut.style.paddingTop = `${pt}px`, ut.style.marginBottom = `${mt}px`;
        })();
      }, 0);
    });
  }
  st && (ut.style.color = PLACEHOLDER_FONT_COLOR, ut.addEventListener("focus", () => {
    ut.innerText === at && (ut.innerText = "", ut.style.color = $.fontColor ?? DEFAULT_FONT_COLOR);
  })), _ === "designer" && setTimeout(() => {
    ut.focus();
    const ht = window.getSelection(), dt = document.createRange();
    ht && dt && (dt.selectNodeContents(ut), dt.collapse(!1), ht == null || ht.removeAllRanges(), ht == null || ht.addRange(dt));
  });
}, buildStyledTextContainer = async (a, s) => {
  const { schema: $, rootElement: _, mode: _e, options: tt, _cache: nt } = a, at = (tt == null ? void 0 : tt.font) || getDefaultFont();
  let ot;
  $.dynamicFontSize && s && (ot = await calculateDynamicFontSize({
    textSchema: $,
    font: at,
    value: s,
    startingFontSize: ot,
    _cache: nt
  }));
  const rt = await getFontKitFont($.fontName, at, nt), { topAdj: st, bottomAdj: lt } = getBrowserVerticalFontAdjustments(rt, ot ?? $.fontSize ?? DEFAULT_FONT_SIZE, $.lineHeight ?? DEFAULT_LINE_HEIGHT, $.verticalAlignment ?? DEFAULT_VERTICAL_ALIGNMENT), et = st.toString(), it = lt.toString(), ut = document.createElement("div"), ft = {
    padding: 0,
    resize: "none",
    backgroundColor: getBackgroundColor(s, $),
    border: "none",
    display: "flex",
    flexDirection: "column",
    justifyContent: mapVerticalAlignToFlex($.verticalAlignment),
    width: "100%",
    height: "100%",
    cursor: isEditable(_e, $) ? "text" : "default"
  };
  Object.assign(ut.style, ft), _.innerHTML = "", _.appendChild(ut);
  const ht = [];
  $.strikethrough && ht.push("line-through"), $.underline && ht.push("underline");
  const dt = {
    // Font formatting styles
    fontFamily: $.fontName ? `'${$.fontName}'` : "inherit",
    color: $.fontColor ? $.fontColor : DEFAULT_FONT_COLOR,
    fontSize: `${ot ?? $.fontSize ?? DEFAULT_FONT_SIZE}pt`,
    letterSpacing: `${$.characterSpacing ?? DEFAULT_CHARACTER_SPACING}pt`,
    lineHeight: `${$.lineHeight ?? DEFAULT_LINE_HEIGHT}em`,
    textAlign: $.alignment ?? DEFAULT_ALIGNMENT,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    // Block layout styles
    resize: "none",
    border: "none",
    outline: "none",
    marginBottom: `${it}px`,
    paddingTop: `${et}px`,
    backgroundColor: "transparent",
    textDecoration: ht.join(" ")
  }, gt = document.createElement("div");
  return gt.id = "text-" + String($.id), Object.assign(gt.style, dt), ut.appendChild(gt), gt;
}, makeElementPlainTextContentEditable = (a) => {
  if (!isFirefox()) {
    a.contentEditable = "plaintext-only";
    return;
  }
  a.contentEditable = "true", a.addEventListener("keydown", (s) => {
    s.key === "Enter" && !s.shiftKey && (s.preventDefault(), document.execCommand("insertLineBreak", !1, void 0));
  }), a.addEventListener("paste", (s) => {
    var _e;
    s.preventDefault();
    const $ = (_e = s.clipboardData) == null ? void 0 : _e.getData("text"), _ = window.getSelection();
    _ != null && _.rangeCount && (_.deleteFromDocument(), _.getRangeAt(0).insertNode(document.createTextNode($ || "")), _.collapseToEnd());
  });
}, mapVerticalAlignToFlex = (a) => {
  switch (a) {
    case VERTICAL_ALIGN_TOP:
      return "flex-start";
    case VERTICAL_ALIGN_MIDDLE:
      return "center";
    case VERTICAL_ALIGN_BOTTOM:
      return "flex-end";
  }
  return "flex-start";
}, getBackgroundColor = (a, s) => !a || !s.backgroundColor ? "transparent" : s.backgroundColor, textSchema = {
  pdf: pdfRender,
  ui: uiRender,
  propPanel,
  icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-text-cursor-input"><path d="M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1"/><path d="M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5"/><path d="M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1"/><path d="M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7"/><path d="M9 7v10"/></svg>'
}, text = textSchema, builtInPlugins = { Text: text };
class BaseUIClass {
  constructor(s) {
    this.lang = DEFAULT_LANG, this.font = getDefaultFont(), this.pluginsRegistry = builtInPlugins, this.options = {}, this.setSize = debounce$1(() => {
      if (!this.domContainer)
        throw Error(DESTROYED_ERR_MSG);
      this.size = {
        height: this.domContainer.clientHeight || window.innerHeight,
        width: this.domContainer.clientWidth || window.innerWidth
      }, this.render();
    }, 100), this.resizeObserver = new ResizeObserver(this.setSize), checkUIProps(s);
    const { domContainer: $, template: _, options: _e = {}, plugins: tt = {} } = s;
    this.domContainer = $, this.template = cloneDeep$1(_), this.options = _e, this.size = {
      height: this.domContainer.clientHeight || window.innerHeight,
      width: this.domContainer.clientWidth || window.innerWidth
    }, this.resizeObserver.observe(this.domContainer);
    const { lang: nt, font: at } = _e;
    nt && (this.lang = nt), at && (this.font = at), Object.values(tt).length > 0 && (this.pluginsRegistry = tt);
  }
  getLang() {
    return this.lang;
  }
  getFont() {
    return this.font;
  }
  getPluginsRegistry() {
    return this.pluginsRegistry;
  }
  getOptions() {
    return this.options;
  }
  getTemplate() {
    if (!this.domContainer)
      throw Error(DESTROYED_ERR_MSG);
    return this.template;
  }
  updateTemplate(s) {
    if (checkTemplate(s), !this.domContainer)
      throw Error(DESTROYED_ERR_MSG);
    this.template = cloneDeep$1(s), this.render();
  }
  updateOptions(s) {
    checkUIOptions(s);
    const { lang: $, font: _ } = s || {};
    $ && (this.lang = $), _ && (this.font = _), this.options = Object.assign(this.options, s), this.render();
  }
  destroy() {
    if (!this.domContainer)
      throw Error(DESTROYED_ERR_MSG);
    ReactDOM.unmountComponentAtNode(this.domContainer), this.resizeObserver.unobserve(this.domContainer), this.domContainer = null;
  }
}
class PreviewUI extends BaseUIClass {
  constructor(s) {
    super(s), checkPreviewProps(s), this.inputs = convertToStingObjectArray(cloneDeep$1(s.inputs));
  }
  getInputs() {
    if (!this.domContainer)
      throw Error(DESTROYED_ERR_MSG);
    return this.inputs;
  }
  setInputs(s) {
    if (!this.domContainer)
      throw Error(DESTROYED_ERR_MSG);
    checkInputs(s), this.inputs = convertToStingObjectArray(s), this.render();
  }
}
function convertToStingObjectArray(a) {
  return a.map((s) => {
    const $ = {};
    return Object.keys(s).forEach((_) => {
      const _e = s[_];
      Array.isArray(_e) ? $[_] = JSON.stringify(_e) : $[_] = _e;
    }), $;
  });
}
function useCombinedRefs() {
  for (var a = arguments.length, s = new Array(a), $ = 0; $ < a; $++)
    s[$] = arguments[$];
  return reactExports.useMemo(
    () => (_) => {
      s.forEach((_e) => _e(_));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    s
  );
}
const canUseDOM = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function isWindow$4(a) {
  const s = Object.prototype.toString.call(a);
  return s === "[object Window]" || // In Electron context the Window object serializes to [object global]
  s === "[object global]";
}
function isNode$1(a) {
  return "nodeType" in a;
}
function getWindow$1(a) {
  var s, $;
  return a ? isWindow$4(a) ? a : isNode$1(a) && (s = ($ = a.ownerDocument) == null ? void 0 : $.defaultView) != null ? s : window : window;
}
function isDocument(a) {
  const {
    Document: s
  } = getWindow$1(a);
  return a instanceof s;
}
function isHTMLElement(a) {
  return isWindow$4(a) ? !1 : a instanceof getWindow$1(a).HTMLElement;
}
function isSVGElement(a) {
  return a instanceof getWindow$1(a).SVGElement;
}
function getOwnerDocument(a) {
  return a ? isWindow$4(a) ? a.document : isNode$1(a) ? isDocument(a) ? a : isHTMLElement(a) || isSVGElement(a) ? a.ownerDocument : document : document : document;
}
const useIsomorphicLayoutEffect$1 = canUseDOM ? reactExports.useLayoutEffect : reactExports.useEffect;
function useEvent$1(a) {
  const s = reactExports.useRef(a);
  return useIsomorphicLayoutEffect$1(() => {
    s.current = a;
  }), reactExports.useCallback(function() {
    for (var $ = arguments.length, _ = new Array($), _e = 0; _e < $; _e++)
      _[_e] = arguments[_e];
    return s.current == null ? void 0 : s.current(..._);
  }, []);
}
function useInterval() {
  const a = reactExports.useRef(null), s = reactExports.useCallback((_, _e) => {
    a.current = setInterval(_, _e);
  }, []), $ = reactExports.useCallback(() => {
    a.current !== null && (clearInterval(a.current), a.current = null);
  }, []);
  return [s, $];
}
function useLatestValue(a, s) {
  s === void 0 && (s = [a]);
  const $ = reactExports.useRef(a);
  return useIsomorphicLayoutEffect$1(() => {
    $.current !== a && ($.current = a);
  }, s), $;
}
function useLazyMemo(a, s) {
  const $ = reactExports.useRef();
  return reactExports.useMemo(
    () => {
      const _ = a($.current);
      return $.current = _, _;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...s]
  );
}
function useNodeRef(a) {
  const s = useEvent$1(a), $ = reactExports.useRef(null), _ = reactExports.useCallback(
    (_e) => {
      _e !== $.current && (s == null || s(_e, $.current)), $.current = _e;
    },
    //eslint-disable-next-line
    []
  );
  return [$, _];
}
function usePrevious$1(a) {
  const s = reactExports.useRef();
  return reactExports.useEffect(() => {
    s.current = a;
  }, [a]), s.current;
}
let ids = {};
function useUniqueId(a, s) {
  return reactExports.useMemo(() => {
    if (s)
      return s;
    const $ = ids[a] == null ? 0 : ids[a] + 1;
    return ids[a] = $, a + "-" + $;
  }, [a, s]);
}
function createAdjustmentFn(a) {
  return function(s) {
    for (var $ = arguments.length, _ = new Array($ > 1 ? $ - 1 : 0), _e = 1; _e < $; _e++)
      _[_e - 1] = arguments[_e];
    return _.reduce((tt, nt) => {
      const at = Object.entries(nt);
      for (const [ot, rt] of at) {
        const st = tt[ot];
        st != null && (tt[ot] = st + a * rt);
      }
      return tt;
    }, {
      ...s
    });
  };
}
const add$1 = /* @__PURE__ */ createAdjustmentFn(1), subtract = /* @__PURE__ */ createAdjustmentFn(-1);
function hasViewportRelativeCoordinates(a) {
  return "clientX" in a && "clientY" in a;
}
function isKeyboardEvent(a) {
  if (!a)
    return !1;
  const {
    KeyboardEvent: s
  } = getWindow$1(a.target);
  return s && a instanceof s;
}
function isTouchEvent(a) {
  if (!a)
    return !1;
  const {
    TouchEvent: s
  } = getWindow$1(a.target);
  return s && a instanceof s;
}
function getEventCoordinates(a) {
  if (isTouchEvent(a)) {
    if (a.touches && a.touches.length) {
      const {
        clientX: s,
        clientY: $
      } = a.touches[0];
      return {
        x: s,
        y: $
      };
    } else if (a.changedTouches && a.changedTouches.length) {
      const {
        clientX: s,
        clientY: $
      } = a.changedTouches[0];
      return {
        x: s,
        y: $
      };
    }
  }
  return hasViewportRelativeCoordinates(a) ? {
    x: a.clientX,
    y: a.clientY
  } : null;
}
const CSS$1 = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(a) {
      if (!a)
        return;
      const {
        x: s,
        y: $
      } = a;
      return "translate3d(" + (s ? Math.round(s) : 0) + "px, " + ($ ? Math.round($) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(a) {
      if (!a)
        return;
      const {
        scaleX: s,
        scaleY: $
      } = a;
      return "scaleX(" + s + ") scaleY(" + $ + ")";
    }
  },
  Transform: {
    toString(a) {
      if (a)
        return [CSS$1.Translate.toString(a), CSS$1.Scale.toString(a)].join(" ");
    }
  },
  Transition: {
    toString(a) {
      let {
        property: s,
        duration: $,
        easing: _
      } = a;
      return s + " " + $ + "ms " + _;
    }
  }
}), SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function findFirstFocusableNode(a) {
  return a.matches(SELECTOR) ? a : a.querySelector(SELECTOR);
}
const hiddenStyles = {
  display: "none"
};
function HiddenText(a) {
  let {
    id: s,
    value: $
  } = a;
  return React$a.createElement("div", {
    id: s,
    style: hiddenStyles
  }, $);
}
function LiveRegion(a) {
  let {
    id: s,
    announcement: $,
    ariaLiveType: _ = "assertive"
  } = a;
  const _e = {
    position: "fixed",
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return React$a.createElement("div", {
    id: s,
    style: _e,
    role: "status",
    "aria-live": _,
    "aria-atomic": !0
  }, $);
}
function useAnnouncement() {
  const [a, s] = reactExports.useState("");
  return {
    announce: reactExports.useCallback((_) => {
      _ != null && s(_);
    }, []),
    announcement: a
  };
}
const DndMonitorContext = /* @__PURE__ */ reactExports.createContext(null);
function useDndMonitor(a) {
  const s = reactExports.useContext(DndMonitorContext);
  reactExports.useEffect(() => {
    if (!s)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return s(a);
  }, [a, s]);
}
function useDndMonitorProvider() {
  const [a] = reactExports.useState(() => /* @__PURE__ */ new Set()), s = reactExports.useCallback((_) => (a.add(_), () => a.delete(_)), [a]);
  return [reactExports.useCallback((_) => {
    let {
      type: _e,
      event: tt
    } = _;
    a.forEach((nt) => {
      var at;
      return (at = nt[_e]) == null ? void 0 : at.call(nt, tt);
    });
  }, [a]), s];
}
const defaultScreenReaderInstructions = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, defaultAnnouncements = {
  onDragStart(a) {
    let {
      active: s
    } = a;
    return "Picked up draggable item " + s.id + ".";
  },
  onDragOver(a) {
    let {
      active: s,
      over: $
    } = a;
    return $ ? "Draggable item " + s.id + " was moved over droppable area " + $.id + "." : "Draggable item " + s.id + " is no longer over a droppable area.";
  },
  onDragEnd(a) {
    let {
      active: s,
      over: $
    } = a;
    return $ ? "Draggable item " + s.id + " was dropped over droppable area " + $.id : "Draggable item " + s.id + " was dropped.";
  },
  onDragCancel(a) {
    let {
      active: s
    } = a;
    return "Dragging was cancelled. Draggable item " + s.id + " was dropped.";
  }
};
function Accessibility(a) {
  let {
    announcements: s = defaultAnnouncements,
    container: $,
    hiddenTextDescribedById: _,
    screenReaderInstructions: _e = defaultScreenReaderInstructions
  } = a;
  const {
    announce: tt,
    announcement: nt
  } = useAnnouncement(), at = useUniqueId("DndLiveRegion"), [ot, rt] = reactExports.useState(!1);
  if (reactExports.useEffect(() => {
    rt(!0);
  }, []), useDndMonitor(reactExports.useMemo(() => ({
    onDragStart(lt) {
      let {
        active: et
      } = lt;
      tt(s.onDragStart({
        active: et
      }));
    },
    onDragMove(lt) {
      let {
        active: et,
        over: it
      } = lt;
      s.onDragMove && tt(s.onDragMove({
        active: et,
        over: it
      }));
    },
    onDragOver(lt) {
      let {
        active: et,
        over: it
      } = lt;
      tt(s.onDragOver({
        active: et,
        over: it
      }));
    },
    onDragEnd(lt) {
      let {
        active: et,
        over: it
      } = lt;
      tt(s.onDragEnd({
        active: et,
        over: it
      }));
    },
    onDragCancel(lt) {
      let {
        active: et,
        over: it
      } = lt;
      tt(s.onDragCancel({
        active: et,
        over: it
      }));
    }
  }), [tt, s])), !ot)
    return null;
  const st = React$a.createElement(React$a.Fragment, null, React$a.createElement(HiddenText, {
    id: _,
    value: _e.draggable
  }), React$a.createElement(LiveRegion, {
    id: at,
    announcement: nt
  }));
  return $ ? reactDomExports.createPortal(st, $) : st;
}
var Action;
(function(a) {
  a.DragStart = "dragStart", a.DragMove = "dragMove", a.DragEnd = "dragEnd", a.DragCancel = "dragCancel", a.DragOver = "dragOver", a.RegisterDroppable = "registerDroppable", a.SetDroppableDisabled = "setDroppableDisabled", a.UnregisterDroppable = "unregisterDroppable";
})(Action || (Action = {}));
function noop$6() {
}
function useSensor(a, s) {
  return reactExports.useMemo(
    () => ({
      sensor: a,
      options: s ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a, s]
  );
}
function useSensors() {
  for (var a = arguments.length, s = new Array(a), $ = 0; $ < a; $++)
    s[$] = arguments[$];
  return reactExports.useMemo(
    () => [...s].filter((_) => _ != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...s]
  );
}
const defaultCoordinates = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function distanceBetween(a, s) {
  return Math.sqrt(Math.pow(a.x - s.x, 2) + Math.pow(a.y - s.y, 2));
}
function getRelativeTransformOrigin(a, s) {
  const $ = getEventCoordinates(a);
  if (!$)
    return "0 0";
  const _ = {
    x: ($.x - s.left) / s.width * 100,
    y: ($.y - s.top) / s.height * 100
  };
  return _.x + "% " + _.y + "%";
}
function sortCollisionsAsc(a, s) {
  let {
    data: {
      value: $
    }
  } = a, {
    data: {
      value: _
    }
  } = s;
  return $ - _;
}
function sortCollisionsDesc(a, s) {
  let {
    data: {
      value: $
    }
  } = a, {
    data: {
      value: _
    }
  } = s;
  return _ - $;
}
function cornersOfRectangle(a) {
  let {
    left: s,
    top: $,
    height: _,
    width: _e
  } = a;
  return [{
    x: s,
    y: $
  }, {
    x: s + _e,
    y: $
  }, {
    x: s,
    y: $ + _
  }, {
    x: s + _e,
    y: $ + _
  }];
}
function getFirstCollision(a, s) {
  if (!a || a.length === 0)
    return null;
  const [$] = a;
  return s ? $[s] : $;
}
const closestCorners = (a) => {
  let {
    collisionRect: s,
    droppableRects: $,
    droppableContainers: _
  } = a;
  const _e = cornersOfRectangle(s), tt = [];
  for (const nt of _) {
    const {
      id: at
    } = nt, ot = $.get(at);
    if (ot) {
      const rt = cornersOfRectangle(ot), st = _e.reduce((et, it, ut) => et + distanceBetween(rt[ut], it), 0), lt = Number((st / 4).toFixed(4));
      tt.push({
        id: at,
        data: {
          droppableContainer: nt,
          value: lt
        }
      });
    }
  }
  return tt.sort(sortCollisionsAsc);
};
function getIntersectionRatio(a, s) {
  const $ = Math.max(s.top, a.top), _ = Math.max(s.left, a.left), _e = Math.min(s.left + s.width, a.left + a.width), tt = Math.min(s.top + s.height, a.top + a.height), nt = _e - _, at = tt - $;
  if (_ < _e && $ < tt) {
    const ot = s.width * s.height, rt = a.width * a.height, st = nt * at, lt = st / (ot + rt - st);
    return Number(lt.toFixed(4));
  }
  return 0;
}
const rectIntersection = (a) => {
  let {
    collisionRect: s,
    droppableRects: $,
    droppableContainers: _
  } = a;
  const _e = [];
  for (const tt of _) {
    const {
      id: nt
    } = tt, at = $.get(nt);
    if (at) {
      const ot = getIntersectionRatio(at, s);
      ot > 0 && _e.push({
        id: nt,
        data: {
          droppableContainer: tt,
          value: ot
        }
      });
    }
  }
  return _e.sort(sortCollisionsDesc);
};
function adjustScale(a, s, $) {
  return {
    ...a,
    scaleX: s && $ ? s.width / $.width : 1,
    scaleY: s && $ ? s.height / $.height : 1
  };
}
function getRectDelta(a, s) {
  return a && s ? {
    x: a.left - s.left,
    y: a.top - s.top
  } : defaultCoordinates;
}
function createRectAdjustmentFn(a) {
  return function($) {
    for (var _ = arguments.length, _e = new Array(_ > 1 ? _ - 1 : 0), tt = 1; tt < _; tt++)
      _e[tt - 1] = arguments[tt];
    return _e.reduce((nt, at) => ({
      ...nt,
      top: nt.top + a * at.y,
      bottom: nt.bottom + a * at.y,
      left: nt.left + a * at.x,
      right: nt.right + a * at.x
    }), {
      ...$
    });
  };
}
const getAdjustedRect = /* @__PURE__ */ createRectAdjustmentFn(1);
function parseTransform(a) {
  if (a.startsWith("matrix3d(")) {
    const s = a.slice(9, -1).split(/, /);
    return {
      x: +s[12],
      y: +s[13],
      scaleX: +s[0],
      scaleY: +s[5]
    };
  } else if (a.startsWith("matrix(")) {
    const s = a.slice(7, -1).split(/, /);
    return {
      x: +s[4],
      y: +s[5],
      scaleX: +s[0],
      scaleY: +s[3]
    };
  }
  return null;
}
function inverseTransform(a, s, $) {
  const _ = parseTransform(s);
  if (!_)
    return a;
  const {
    scaleX: _e,
    scaleY: tt,
    x: nt,
    y: at
  } = _, ot = a.left - nt - (1 - _e) * parseFloat($), rt = a.top - at - (1 - tt) * parseFloat($.slice($.indexOf(" ") + 1)), st = _e ? a.width / _e : a.width, lt = tt ? a.height / tt : a.height;
  return {
    width: st,
    height: lt,
    top: rt,
    right: ot + st,
    bottom: rt + lt,
    left: ot
  };
}
const defaultOptions = {
  ignoreTransform: !1
};
function getClientRect$1(a, s) {
  s === void 0 && (s = defaultOptions);
  let $ = a.getBoundingClientRect();
  if (s.ignoreTransform) {
    const {
      transform: rt,
      transformOrigin: st
    } = getWindow$1(a).getComputedStyle(a);
    rt && ($ = inverseTransform($, rt, st));
  }
  const {
    top: _,
    left: _e,
    width: tt,
    height: nt,
    bottom: at,
    right: ot
  } = $;
  return {
    top: _,
    left: _e,
    width: tt,
    height: nt,
    bottom: at,
    right: ot
  };
}
function getTransformAgnosticClientRect(a) {
  return getClientRect$1(a, {
    ignoreTransform: !0
  });
}
function getWindowClientRect(a) {
  const s = a.innerWidth, $ = a.innerHeight;
  return {
    top: 0,
    left: 0,
    right: s,
    bottom: $,
    width: s,
    height: $
  };
}
function isFixed(a, s) {
  return s === void 0 && (s = getWindow$1(a).getComputedStyle(a)), s.position === "fixed";
}
function isScrollable(a, s) {
  s === void 0 && (s = getWindow$1(a).getComputedStyle(a));
  const $ = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((_e) => {
    const tt = s[_e];
    return typeof tt == "string" ? $.test(tt) : !1;
  });
}
function getScrollableAncestors(a, s) {
  const $ = [];
  function _(_e) {
    if (s != null && $.length >= s || !_e)
      return $;
    if (isDocument(_e) && _e.scrollingElement != null && !$.includes(_e.scrollingElement))
      return $.push(_e.scrollingElement), $;
    if (!isHTMLElement(_e) || isSVGElement(_e) || $.includes(_e))
      return $;
    const tt = getWindow$1(a).getComputedStyle(_e);
    return _e !== a && isScrollable(_e, tt) && $.push(_e), isFixed(_e, tt) ? $ : _(_e.parentNode);
  }
  return a ? _(a) : $;
}
function getFirstScrollableAncestor(a) {
  const [s] = getScrollableAncestors(a, 1);
  return s ?? null;
}
function getScrollableElement(a) {
  return !canUseDOM || !a ? null : isWindow$4(a) ? a : isNode$1(a) ? isDocument(a) || a === getOwnerDocument(a).scrollingElement ? window : isHTMLElement(a) ? a : null : null;
}
function getScrollXCoordinate(a) {
  return isWindow$4(a) ? a.scrollX : a.scrollLeft;
}
function getScrollYCoordinate(a) {
  return isWindow$4(a) ? a.scrollY : a.scrollTop;
}
function getScrollCoordinates(a) {
  return {
    x: getScrollXCoordinate(a),
    y: getScrollYCoordinate(a)
  };
}
var Direction;
(function(a) {
  a[a.Forward = 1] = "Forward", a[a.Backward = -1] = "Backward";
})(Direction || (Direction = {}));
function isDocumentScrollingElement(a) {
  return !canUseDOM || !a ? !1 : a === document.scrollingElement;
}
function getScrollPosition(a) {
  const s = {
    x: 0,
    y: 0
  }, $ = isDocumentScrollingElement(a) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: a.clientHeight,
    width: a.clientWidth
  }, _ = {
    x: a.scrollWidth - $.width,
    y: a.scrollHeight - $.height
  }, _e = a.scrollTop <= s.y, tt = a.scrollLeft <= s.x, nt = a.scrollTop >= _.y, at = a.scrollLeft >= _.x;
  return {
    isTop: _e,
    isLeft: tt,
    isBottom: nt,
    isRight: at,
    maxScroll: _,
    minScroll: s
  };
}
const defaultThreshold = {
  x: 0.2,
  y: 0.2
};
function getScrollDirectionAndSpeed(a, s, $, _, _e) {
  let {
    top: tt,
    left: nt,
    right: at,
    bottom: ot
  } = $;
  _ === void 0 && (_ = 10), _e === void 0 && (_e = defaultThreshold);
  const {
    isTop: rt,
    isBottom: st,
    isLeft: lt,
    isRight: et
  } = getScrollPosition(a), it = {
    x: 0,
    y: 0
  }, ut = {
    x: 0,
    y: 0
  }, ft = {
    height: s.height * _e.y,
    width: s.width * _e.x
  };
  return !rt && tt <= s.top + ft.height ? (it.y = Direction.Backward, ut.y = _ * Math.abs((s.top + ft.height - tt) / ft.height)) : !st && ot >= s.bottom - ft.height && (it.y = Direction.Forward, ut.y = _ * Math.abs((s.bottom - ft.height - ot) / ft.height)), !et && at >= s.right - ft.width ? (it.x = Direction.Forward, ut.x = _ * Math.abs((s.right - ft.width - at) / ft.width)) : !lt && nt <= s.left + ft.width && (it.x = Direction.Backward, ut.x = _ * Math.abs((s.left + ft.width - nt) / ft.width)), {
    direction: it,
    speed: ut
  };
}
function getScrollElementRect(a) {
  if (a === document.scrollingElement) {
    const {
      innerWidth: tt,
      innerHeight: nt
    } = window;
    return {
      top: 0,
      left: 0,
      right: tt,
      bottom: nt,
      width: tt,
      height: nt
    };
  }
  const {
    top: s,
    left: $,
    right: _,
    bottom: _e
  } = a.getBoundingClientRect();
  return {
    top: s,
    left: $,
    right: _,
    bottom: _e,
    width: a.clientWidth,
    height: a.clientHeight
  };
}
function getScrollOffsets(a) {
  return a.reduce((s, $) => add$1(s, getScrollCoordinates($)), defaultCoordinates);
}
function getScrollXOffset(a) {
  return a.reduce((s, $) => s + getScrollXCoordinate($), 0);
}
function getScrollYOffset(a) {
  return a.reduce((s, $) => s + getScrollYCoordinate($), 0);
}
function scrollIntoViewIfNeeded(a, s) {
  if (s === void 0 && (s = getClientRect$1), !a)
    return;
  const {
    top: $,
    left: _,
    bottom: _e,
    right: tt
  } = s(a);
  getFirstScrollableAncestor(a) && (_e <= 0 || tt <= 0 || $ >= window.innerHeight || _ >= window.innerWidth) && a.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const properties = [["x", ["left", "right"], getScrollXOffset], ["y", ["top", "bottom"], getScrollYOffset]];
class Rect {
  constructor(s, $) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const _ = getScrollableAncestors($), _e = getScrollOffsets(_);
    this.rect = {
      ...s
    }, this.width = s.width, this.height = s.height;
    for (const [tt, nt, at] of properties)
      for (const ot of nt)
        Object.defineProperty(this, ot, {
          get: () => {
            const rt = at(_), st = _e[tt] - rt;
            return this.rect[ot] + st;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class Listeners {
  constructor(s) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach(($) => {
        var _;
        return (_ = this.target) == null ? void 0 : _.removeEventListener(...$);
      });
    }, this.target = s;
  }
  add(s, $, _) {
    var _e;
    (_e = this.target) == null || _e.addEventListener(s, $, _), this.listeners.push([s, $, _]);
  }
}
function getEventListenerTarget(a) {
  const {
    EventTarget: s
  } = getWindow$1(a);
  return a instanceof s ? a : getOwnerDocument(a);
}
function hasExceededDistance(a, s) {
  const $ = Math.abs(a.x), _ = Math.abs(a.y);
  return typeof s == "number" ? Math.sqrt($ ** 2 + _ ** 2) > s : "x" in s && "y" in s ? $ > s.x && _ > s.y : "x" in s ? $ > s.x : "y" in s ? _ > s.y : !1;
}
var EventName;
(function(a) {
  a.Click = "click", a.DragStart = "dragstart", a.Keydown = "keydown", a.ContextMenu = "contextmenu", a.Resize = "resize", a.SelectionChange = "selectionchange", a.VisibilityChange = "visibilitychange";
})(EventName || (EventName = {}));
function preventDefault(a) {
  a.preventDefault();
}
function stopPropagation(a) {
  a.stopPropagation();
}
var KeyboardCode;
(function(a) {
  a.Space = "Space", a.Down = "ArrowDown", a.Right = "ArrowRight", a.Left = "ArrowLeft", a.Up = "ArrowUp", a.Esc = "Escape", a.Enter = "Enter";
})(KeyboardCode || (KeyboardCode = {}));
const defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter]
}, defaultKeyboardCoordinateGetter = (a, s) => {
  let {
    currentCoordinates: $
  } = s;
  switch (a.code) {
    case KeyboardCode.Right:
      return {
        ...$,
        x: $.x + 25
      };
    case KeyboardCode.Left:
      return {
        ...$,
        x: $.x - 25
      };
    case KeyboardCode.Down:
      return {
        ...$,
        y: $.y + 25
      };
    case KeyboardCode.Up:
      return {
        ...$,
        y: $.y - 25
      };
  }
};
class KeyboardSensor {
  constructor(s) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = s;
    const {
      event: {
        target: $
      }
    } = s;
    this.props = s, this.listeners = new Listeners(getOwnerDocument($)), this.windowListeners = new Listeners(getWindow$1($)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(EventName.Resize, this.handleCancel), this.windowListeners.add(EventName.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(EventName.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: s,
      onStart: $
    } = this.props, _ = s.node.current;
    _ && scrollIntoViewIfNeeded(_), $(defaultCoordinates);
  }
  handleKeyDown(s) {
    if (isKeyboardEvent(s)) {
      const {
        active: $,
        context: _,
        options: _e
      } = this.props, {
        keyboardCodes: tt = defaultKeyboardCodes,
        coordinateGetter: nt = defaultKeyboardCoordinateGetter,
        scrollBehavior: at = "smooth"
      } = _e, {
        code: ot
      } = s;
      if (tt.end.includes(ot)) {
        this.handleEnd(s);
        return;
      }
      if (tt.cancel.includes(ot)) {
        this.handleCancel(s);
        return;
      }
      const {
        collisionRect: rt
      } = _.current, st = rt ? {
        x: rt.left,
        y: rt.top
      } : defaultCoordinates;
      this.referenceCoordinates || (this.referenceCoordinates = st);
      const lt = nt(s, {
        active: $,
        context: _.current,
        currentCoordinates: st
      });
      if (lt) {
        const et = subtract(lt, st), it = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: ut
        } = _.current;
        for (const ft of ut) {
          const ht = s.code, {
            isTop: dt,
            isRight: gt,
            isLeft: pt,
            isBottom: mt,
            maxScroll: ct,
            minScroll: vt
          } = getScrollPosition(ft), At = getScrollElementRect(ft), xt = {
            x: Math.min(ht === KeyboardCode.Right ? At.right - At.width / 2 : At.right, Math.max(ht === KeyboardCode.Right ? At.left : At.left + At.width / 2, lt.x)),
            y: Math.min(ht === KeyboardCode.Down ? At.bottom - At.height / 2 : At.bottom, Math.max(ht === KeyboardCode.Down ? At.top : At.top + At.height / 2, lt.y))
          }, bt = ht === KeyboardCode.Right && !gt || ht === KeyboardCode.Left && !pt, Et = ht === KeyboardCode.Down && !mt || ht === KeyboardCode.Up && !dt;
          if (bt && xt.x !== lt.x) {
            const St = ft.scrollLeft + et.x, Bt = ht === KeyboardCode.Right && St <= ct.x || ht === KeyboardCode.Left && St >= vt.x;
            if (Bt && !et.y) {
              ft.scrollTo({
                left: St,
                behavior: at
              });
              return;
            }
            Bt ? it.x = ft.scrollLeft - St : it.x = ht === KeyboardCode.Right ? ft.scrollLeft - ct.x : ft.scrollLeft - vt.x, it.x && ft.scrollBy({
              left: -it.x,
              behavior: at
            });
            break;
          } else if (Et && xt.y !== lt.y) {
            const St = ft.scrollTop + et.y, Bt = ht === KeyboardCode.Down && St <= ct.y || ht === KeyboardCode.Up && St >= vt.y;
            if (Bt && !et.x) {
              ft.scrollTo({
                top: St,
                behavior: at
              });
              return;
            }
            Bt ? it.y = ft.scrollTop - St : it.y = ht === KeyboardCode.Down ? ft.scrollTop - ct.y : ft.scrollTop - vt.y, it.y && ft.scrollBy({
              top: -it.y,
              behavior: at
            });
            break;
          }
        }
        this.handleMove(s, add$1(subtract(lt, this.referenceCoordinates), it));
      }
    }
  }
  handleMove(s, $) {
    const {
      onMove: _
    } = this.props;
    s.preventDefault(), _($);
  }
  handleEnd(s) {
    const {
      onEnd: $
    } = this.props;
    s.preventDefault(), this.detach(), $();
  }
  handleCancel(s) {
    const {
      onCancel: $
    } = this.props;
    s.preventDefault(), this.detach(), $();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
KeyboardSensor.activators = [{
  eventName: "onKeyDown",
  handler: (a, s, $) => {
    let {
      keyboardCodes: _ = defaultKeyboardCodes,
      onActivation: _e
    } = s, {
      active: tt
    } = $;
    const {
      code: nt
    } = a.nativeEvent;
    if (_.start.includes(nt)) {
      const at = tt.activatorNode.current;
      return at && a.target !== at ? !1 : (a.preventDefault(), _e == null || _e({
        event: a.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function isDistanceConstraint(a) {
  return !!(a && "distance" in a);
}
function isDelayConstraint(a) {
  return !!(a && "delay" in a);
}
class AbstractPointerSensor {
  constructor(s, $, _) {
    var _e;
    _ === void 0 && (_ = getEventListenerTarget(s.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = s, this.events = $;
    const {
      event: tt
    } = s, {
      target: nt
    } = tt;
    this.props = s, this.events = $, this.document = getOwnerDocument(nt), this.documentListeners = new Listeners(this.document), this.listeners = new Listeners(_), this.windowListeners = new Listeners(getWindow$1(nt)), this.initialCoordinates = (_e = getEventCoordinates(tt)) != null ? _e : defaultCoordinates, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: s,
      props: {
        options: {
          activationConstraint: $,
          bypassActivationConstraint: _
        }
      }
    } = this;
    if (this.listeners.add(s.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(s.end.name, this.handleEnd), this.windowListeners.add(EventName.Resize, this.handleCancel), this.windowListeners.add(EventName.DragStart, preventDefault), this.windowListeners.add(EventName.VisibilityChange, this.handleCancel), this.windowListeners.add(EventName.ContextMenu, preventDefault), this.documentListeners.add(EventName.Keydown, this.handleKeydown), $) {
      if (_ != null && _({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (isDelayConstraint($)) {
        this.timeoutId = setTimeout(this.handleStart, $.delay);
        return;
      }
      if (isDistanceConstraint($))
        return;
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handleStart() {
    const {
      initialCoordinates: s
    } = this, {
      onStart: $
    } = this.props;
    s && (this.activated = !0, this.documentListeners.add(EventName.Click, stopPropagation, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection), $(s));
  }
  handleMove(s) {
    var $;
    const {
      activated: _,
      initialCoordinates: _e,
      props: tt
    } = this, {
      onMove: nt,
      options: {
        activationConstraint: at
      }
    } = tt;
    if (!_e)
      return;
    const ot = ($ = getEventCoordinates(s)) != null ? $ : defaultCoordinates, rt = subtract(_e, ot);
    if (!_ && at) {
      if (isDistanceConstraint(at)) {
        if (at.tolerance != null && hasExceededDistance(rt, at.tolerance))
          return this.handleCancel();
        if (hasExceededDistance(rt, at.distance))
          return this.handleStart();
      }
      return isDelayConstraint(at) && hasExceededDistance(rt, at.tolerance) ? this.handleCancel() : void 0;
    }
    s.cancelable && s.preventDefault(), nt(ot);
  }
  handleEnd() {
    const {
      onEnd: s
    } = this.props;
    this.detach(), s();
  }
  handleCancel() {
    const {
      onCancel: s
    } = this.props;
    this.detach(), s();
  }
  handleKeydown(s) {
    s.code === KeyboardCode.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var s;
    (s = this.document.getSelection()) == null || s.removeAllRanges();
  }
}
const events = {
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class PointerSensor extends AbstractPointerSensor {
  constructor(s) {
    const {
      event: $
    } = s, _ = getOwnerDocument($.target);
    super(s, events, _);
  }
}
PointerSensor.activators = [{
  eventName: "onPointerDown",
  handler: (a, s) => {
    let {
      nativeEvent: $
    } = a, {
      onActivation: _
    } = s;
    return !$.isPrimary || $.button !== 0 ? !1 : (_ == null || _({
      event: $
    }), !0);
  }
}];
const events$1 = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var MouseButton;
(function(a) {
  a[a.RightClick = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
class MouseSensor extends AbstractPointerSensor {
  constructor(s) {
    super(s, events$1, getOwnerDocument(s.event.target));
  }
}
MouseSensor.activators = [{
  eventName: "onMouseDown",
  handler: (a, s) => {
    let {
      nativeEvent: $
    } = a, {
      onActivation: _
    } = s;
    return $.button === MouseButton.RightClick ? !1 : (_ == null || _({
      event: $
    }), !0);
  }
}];
const events$2 = {
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class TouchSensor extends AbstractPointerSensor {
  constructor(s) {
    super(s, events$2);
  }
  static setup() {
    return window.addEventListener(events$2.move.name, s, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(events$2.move.name, s);
    };
    function s() {
    }
  }
}
TouchSensor.activators = [{
  eventName: "onTouchStart",
  handler: (a, s) => {
    let {
      nativeEvent: $
    } = a, {
      onActivation: _
    } = s;
    const {
      touches: _e
    } = $;
    return _e.length > 1 ? !1 : (_ == null || _({
      event: $
    }), !0);
  }
}];
var AutoScrollActivator;
(function(a) {
  a[a.Pointer = 0] = "Pointer", a[a.DraggableRect = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(a) {
  a[a.TreeOrder = 0] = "TreeOrder", a[a.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(a) {
  let {
    acceleration: s,
    activator: $ = AutoScrollActivator.Pointer,
    canScroll: _,
    draggingRect: _e,
    enabled: tt,
    interval: nt = 5,
    order: at = TraversalOrder.TreeOrder,
    pointerCoordinates: ot,
    scrollableAncestors: rt,
    scrollableAncestorRects: st,
    delta: lt,
    threshold: et
  } = a;
  const it = useScrollIntent({
    delta: lt,
    disabled: !tt
  }), [ut, ft] = useInterval(), ht = reactExports.useRef({
    x: 0,
    y: 0
  }), dt = reactExports.useRef({
    x: 0,
    y: 0
  }), gt = reactExports.useMemo(() => {
    switch ($) {
      case AutoScrollActivator.Pointer:
        return ot ? {
          top: ot.y,
          bottom: ot.y,
          left: ot.x,
          right: ot.x
        } : null;
      case AutoScrollActivator.DraggableRect:
        return _e;
    }
  }, [$, _e, ot]), pt = reactExports.useRef(null), mt = reactExports.useCallback(() => {
    const vt = pt.current;
    if (!vt)
      return;
    const At = ht.current.x * dt.current.x, xt = ht.current.y * dt.current.y;
    vt.scrollBy(At, xt);
  }, []), ct = reactExports.useMemo(() => at === TraversalOrder.TreeOrder ? [...rt].reverse() : rt, [at, rt]);
  reactExports.useEffect(
    () => {
      if (!tt || !rt.length || !gt) {
        ft();
        return;
      }
      for (const vt of ct) {
        if ((_ == null ? void 0 : _(vt)) === !1)
          continue;
        const At = rt.indexOf(vt), xt = st[At];
        if (!xt)
          continue;
        const {
          direction: bt,
          speed: Et
        } = getScrollDirectionAndSpeed(vt, xt, gt, s, et);
        for (const St of ["x", "y"])
          it[St][bt[St]] || (Et[St] = 0, bt[St] = 0);
        if (Et.x > 0 || Et.y > 0) {
          ft(), pt.current = vt, ut(mt, nt), ht.current = Et, dt.current = bt;
          return;
        }
      }
      ht.current = {
        x: 0,
        y: 0
      }, dt.current = {
        x: 0,
        y: 0
      }, ft();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      s,
      mt,
      _,
      ft,
      tt,
      nt,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(gt),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(it),
      ut,
      rt,
      ct,
      st,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(et)
    ]
  );
}
const defaultScrollIntent = {
  x: {
    [Direction.Backward]: !1,
    [Direction.Forward]: !1
  },
  y: {
    [Direction.Backward]: !1,
    [Direction.Forward]: !1
  }
};
function useScrollIntent(a) {
  let {
    delta: s,
    disabled: $
  } = a;
  const _ = usePrevious$1(s);
  return useLazyMemo((_e) => {
    if ($ || !_ || !_e)
      return defaultScrollIntent;
    const tt = {
      x: Math.sign(s.x - _.x),
      y: Math.sign(s.y - _.y)
    };
    return {
      x: {
        [Direction.Backward]: _e.x[Direction.Backward] || tt.x === -1,
        [Direction.Forward]: _e.x[Direction.Forward] || tt.x === 1
      },
      y: {
        [Direction.Backward]: _e.y[Direction.Backward] || tt.y === -1,
        [Direction.Forward]: _e.y[Direction.Forward] || tt.y === 1
      }
    };
  }, [$, s, _]);
}
function useCachedNode(a, s) {
  const $ = s !== null ? a.get(s) : void 0, _ = $ ? $.node.current : null;
  return useLazyMemo((_e) => {
    var tt;
    return s === null ? null : (tt = _ ?? _e) != null ? tt : null;
  }, [_, s]);
}
function useCombineActivators(a, s) {
  return reactExports.useMemo(() => a.reduce(($, _) => {
    const {
      sensor: _e
    } = _, tt = _e.activators.map((nt) => ({
      eventName: nt.eventName,
      handler: s(nt.handler, _)
    }));
    return [...$, ...tt];
  }, []), [a, s]);
}
var MeasuringStrategy;
(function(a) {
  a[a.Always = 0] = "Always", a[a.BeforeDragging = 1] = "BeforeDragging", a[a.WhileDragging = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(a) {
  a.Optimized = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
const defaultValue = /* @__PURE__ */ new Map();
function useDroppableMeasuring(a, s) {
  let {
    dragging: $,
    dependencies: _,
    config: _e
  } = s;
  const [tt, nt] = reactExports.useState(null), {
    frequency: at,
    measure: ot,
    strategy: rt
  } = _e, st = reactExports.useRef(a), lt = ht(), et = useLatestValue(lt), it = reactExports.useCallback(function(dt) {
    dt === void 0 && (dt = []), !et.current && nt((gt) => gt === null ? dt : gt.concat(dt.filter((pt) => !gt.includes(pt))));
  }, [et]), ut = reactExports.useRef(null), ft = useLazyMemo((dt) => {
    if (lt && !$)
      return defaultValue;
    if (!dt || dt === defaultValue || st.current !== a || tt != null) {
      const gt = /* @__PURE__ */ new Map();
      for (let pt of a) {
        if (!pt)
          continue;
        if (tt && tt.length > 0 && !tt.includes(pt.id) && pt.rect.current) {
          gt.set(pt.id, pt.rect.current);
          continue;
        }
        const mt = pt.node.current, ct = mt ? new Rect(ot(mt), mt) : null;
        pt.rect.current = ct, ct && gt.set(pt.id, ct);
      }
      return gt;
    }
    return dt;
  }, [a, tt, $, lt, ot]);
  return reactExports.useEffect(() => {
    st.current = a;
  }, [a]), reactExports.useEffect(
    () => {
      lt || it();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [$, lt]
  ), reactExports.useEffect(
    () => {
      tt && tt.length > 0 && nt(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(tt)]
  ), reactExports.useEffect(
    () => {
      lt || typeof at != "number" || ut.current !== null || (ut.current = setTimeout(() => {
        it(), ut.current = null;
      }, at));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [at, lt, it, ..._]
  ), {
    droppableRects: ft,
    measureDroppableContainers: it,
    measuringScheduled: tt != null
  };
  function ht() {
    switch (rt) {
      case MeasuringStrategy.Always:
        return !1;
      case MeasuringStrategy.BeforeDragging:
        return $;
      default:
        return !$;
    }
  }
}
function useInitialValue(a, s) {
  return useLazyMemo(($) => a ? $ || (typeof s == "function" ? s(a) : a) : null, [s, a]);
}
function useInitialRect(a, s) {
  return useInitialValue(a, s);
}
function useMutationObserver(a) {
  let {
    callback: s,
    disabled: $
  } = a;
  const _ = useEvent$1(s), _e = reactExports.useMemo(() => {
    if ($ || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: tt
    } = window;
    return new tt(_);
  }, [_, $]);
  return reactExports.useEffect(() => () => _e == null ? void 0 : _e.disconnect(), [_e]), _e;
}
function useResizeObserver(a) {
  let {
    callback: s,
    disabled: $
  } = a;
  const _ = useEvent$1(s), _e = reactExports.useMemo(
    () => {
      if ($ || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: tt
      } = window;
      return new tt(_);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [$]
  );
  return reactExports.useEffect(() => () => _e == null ? void 0 : _e.disconnect(), [_e]), _e;
}
function defaultMeasure(a) {
  return new Rect(getClientRect$1(a), a);
}
function useRect(a, s, $) {
  s === void 0 && (s = defaultMeasure);
  const [_, _e] = reactExports.useReducer(at, null), tt = useMutationObserver({
    callback(ot) {
      if (a)
        for (const rt of ot) {
          const {
            type: st,
            target: lt
          } = rt;
          if (st === "childList" && lt instanceof HTMLElement && lt.contains(a)) {
            _e();
            break;
          }
        }
    }
  }), nt = useResizeObserver({
    callback: _e
  });
  return useIsomorphicLayoutEffect$1(() => {
    _e(), a ? (nt == null || nt.observe(a), tt == null || tt.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (nt == null || nt.disconnect(), tt == null || tt.disconnect());
  }, [a]), _;
  function at(ot) {
    if (!a)
      return null;
    if (a.isConnected === !1) {
      var rt;
      return (rt = ot ?? $) != null ? rt : null;
    }
    const st = s(a);
    return JSON.stringify(ot) === JSON.stringify(st) ? ot : st;
  }
}
function useRectDelta(a) {
  const s = useInitialValue(a);
  return getRectDelta(a, s);
}
const defaultValue$1 = [];
function useScrollableAncestors(a) {
  const s = reactExports.useRef(a), $ = useLazyMemo((_) => a ? _ && _ !== defaultValue$1 && a && s.current && a.parentNode === s.current.parentNode ? _ : getScrollableAncestors(a) : defaultValue$1, [a]);
  return reactExports.useEffect(() => {
    s.current = a;
  }, [a]), $;
}
function useScrollOffsets(a) {
  const [s, $] = reactExports.useState(null), _ = reactExports.useRef(a), _e = reactExports.useCallback((tt) => {
    const nt = getScrollableElement(tt.target);
    nt && $((at) => at ? (at.set(nt, getScrollCoordinates(nt)), new Map(at)) : null);
  }, []);
  return reactExports.useEffect(() => {
    const tt = _.current;
    if (a !== tt) {
      nt(tt);
      const at = a.map((ot) => {
        const rt = getScrollableElement(ot);
        return rt ? (rt.addEventListener("scroll", _e, {
          passive: !0
        }), [rt, getScrollCoordinates(rt)]) : null;
      }).filter((ot) => ot != null);
      $(at.length ? new Map(at) : null), _.current = a;
    }
    return () => {
      nt(a), nt(tt);
    };
    function nt(at) {
      at.forEach((ot) => {
        const rt = getScrollableElement(ot);
        rt == null || rt.removeEventListener("scroll", _e);
      });
    }
  }, [_e, a]), reactExports.useMemo(() => a.length ? s ? Array.from(s.values()).reduce((tt, nt) => add$1(tt, nt), defaultCoordinates) : getScrollOffsets(a) : defaultCoordinates, [a, s]);
}
function useScrollOffsetsDelta(a, s) {
  s === void 0 && (s = []);
  const $ = reactExports.useRef(null);
  return reactExports.useEffect(
    () => {
      $.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    s
  ), reactExports.useEffect(() => {
    const _ = a !== defaultCoordinates;
    _ && !$.current && ($.current = a), !_ && $.current && ($.current = null);
  }, [a]), $.current ? subtract(a, $.current) : defaultCoordinates;
}
function useSensorSetup(a) {
  reactExports.useEffect(
    () => {
      if (!canUseDOM)
        return;
      const s = a.map(($) => {
        let {
          sensor: _
        } = $;
        return _.setup == null ? void 0 : _.setup();
      });
      return () => {
        for (const $ of s)
          $ == null || $();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    a.map((s) => {
      let {
        sensor: $
      } = s;
      return $;
    })
  );
}
function useSyntheticListeners(a, s) {
  return reactExports.useMemo(() => a.reduce(($, _) => {
    let {
      eventName: _e,
      handler: tt
    } = _;
    return $[_e] = (nt) => {
      tt(nt, s);
    }, $;
  }, {}), [a, s]);
}
function useWindowRect(a) {
  return reactExports.useMemo(() => a ? getWindowClientRect(a) : null, [a]);
}
const defaultValue$2 = [];
function useRects(a, s) {
  s === void 0 && (s = getClientRect$1);
  const [$] = a, _ = useWindowRect($ ? getWindow$1($) : null), [_e, tt] = reactExports.useReducer(at, defaultValue$2), nt = useResizeObserver({
    callback: tt
  });
  return a.length > 0 && _e === defaultValue$2 && tt(), useIsomorphicLayoutEffect$1(() => {
    a.length ? a.forEach((ot) => nt == null ? void 0 : nt.observe(ot)) : (nt == null || nt.disconnect(), tt());
  }, [a]), _e;
  function at() {
    return a.length ? a.map((ot) => isDocumentScrollingElement(ot) ? _ : new Rect(s(ot), ot)) : defaultValue$2;
  }
}
function getMeasurableNode(a) {
  if (!a)
    return null;
  if (a.children.length > 1)
    return a;
  const s = a.children[0];
  return isHTMLElement(s) ? s : a;
}
function useDragOverlayMeasuring(a) {
  let {
    measure: s
  } = a;
  const [$, _] = reactExports.useState(null), _e = reactExports.useCallback((rt) => {
    for (const {
      target: st
    } of rt)
      if (isHTMLElement(st)) {
        _((lt) => {
          const et = s(st);
          return lt ? {
            ...lt,
            width: et.width,
            height: et.height
          } : et;
        });
        break;
      }
  }, [s]), tt = useResizeObserver({
    callback: _e
  }), nt = reactExports.useCallback((rt) => {
    const st = getMeasurableNode(rt);
    tt == null || tt.disconnect(), st && (tt == null || tt.observe(st)), _(st ? s(st) : null);
  }, [s, tt]), [at, ot] = useNodeRef(nt);
  return reactExports.useMemo(() => ({
    nodeRef: at,
    rect: $,
    setRef: ot
  }), [$, at, ot]);
}
const defaultSensors = [{
  sensor: PointerSensor,
  options: {}
}, {
  sensor: KeyboardSensor,
  options: {}
}], defaultData = {
  current: {}
}, defaultMeasuringConfiguration = {
  draggable: {
    measure: getTransformAgnosticClientRect
  },
  droppable: {
    measure: getTransformAgnosticClientRect,
    strategy: MeasuringStrategy.WhileDragging,
    frequency: MeasuringFrequency.Optimized
  },
  dragOverlay: {
    measure: getClientRect$1
  }
};
class DroppableContainersMap extends Map {
  get(s) {
    var $;
    return s != null && ($ = super.get(s)) != null ? $ : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((s) => {
      let {
        disabled: $
      } = s;
      return !$;
    });
  }
  getNodeFor(s) {
    var $, _;
    return ($ = (_ = this.get(s)) == null ? void 0 : _.node.current) != null ? $ : void 0;
  }
}
const defaultPublicContext = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new DroppableContainersMap(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: noop$6
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: defaultMeasuringConfiguration,
  measureDroppableContainers: noop$6,
  windowRect: null,
  measuringScheduled: !1
}, defaultInternalContext = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: noop$6,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: noop$6
}, InternalContext = /* @__PURE__ */ reactExports.createContext(defaultInternalContext), PublicContext = /* @__PURE__ */ reactExports.createContext(defaultPublicContext);
function getInitialState() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new DroppableContainersMap()
    }
  };
}
function reducer(a, s) {
  switch (s.type) {
    case Action.DragStart:
      return {
        ...a,
        draggable: {
          ...a.draggable,
          initialCoordinates: s.initialCoordinates,
          active: s.active
        }
      };
    case Action.DragMove:
      return a.draggable.active ? {
        ...a,
        draggable: {
          ...a.draggable,
          translate: {
            x: s.coordinates.x - a.draggable.initialCoordinates.x,
            y: s.coordinates.y - a.draggable.initialCoordinates.y
          }
        }
      } : a;
    case Action.DragEnd:
    case Action.DragCancel:
      return {
        ...a,
        draggable: {
          ...a.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Action.RegisterDroppable: {
      const {
        element: $
      } = s, {
        id: _
      } = $, _e = new DroppableContainersMap(a.droppable.containers);
      return _e.set(_, $), {
        ...a,
        droppable: {
          ...a.droppable,
          containers: _e
        }
      };
    }
    case Action.SetDroppableDisabled: {
      const {
        id: $,
        key: _,
        disabled: _e
      } = s, tt = a.droppable.containers.get($);
      if (!tt || _ !== tt.key)
        return a;
      const nt = new DroppableContainersMap(a.droppable.containers);
      return nt.set($, {
        ...tt,
        disabled: _e
      }), {
        ...a,
        droppable: {
          ...a.droppable,
          containers: nt
        }
      };
    }
    case Action.UnregisterDroppable: {
      const {
        id: $,
        key: _
      } = s, _e = a.droppable.containers.get($);
      if (!_e || _ !== _e.key)
        return a;
      const tt = new DroppableContainersMap(a.droppable.containers);
      return tt.delete($), {
        ...a,
        droppable: {
          ...a.droppable,
          containers: tt
        }
      };
    }
    default:
      return a;
  }
}
function RestoreFocus(a) {
  let {
    disabled: s
  } = a;
  const {
    active: $,
    activatorEvent: _,
    draggableNodes: _e
  } = reactExports.useContext(InternalContext), tt = usePrevious$1(_), nt = usePrevious$1($ == null ? void 0 : $.id);
  return reactExports.useEffect(() => {
    if (!s && !_ && tt && nt != null) {
      if (!isKeyboardEvent(tt) || document.activeElement === tt.target)
        return;
      const at = _e.get(nt);
      if (!at)
        return;
      const {
        activatorNode: ot,
        node: rt
      } = at;
      if (!ot.current && !rt.current)
        return;
      requestAnimationFrame(() => {
        for (const st of [ot.current, rt.current]) {
          if (!st)
            continue;
          const lt = findFirstFocusableNode(st);
          if (lt) {
            lt.focus();
            break;
          }
        }
      });
    }
  }, [_, s, _e, nt, tt]), null;
}
function applyModifiers(a, s) {
  let {
    transform: $,
    ..._
  } = s;
  return a != null && a.length ? a.reduce((_e, tt) => tt({
    transform: _e,
    ..._
  }), $) : $;
}
function useMeasuringConfiguration(a) {
  return reactExports.useMemo(
    () => ({
      draggable: {
        ...defaultMeasuringConfiguration.draggable,
        ...a == null ? void 0 : a.draggable
      },
      droppable: {
        ...defaultMeasuringConfiguration.droppable,
        ...a == null ? void 0 : a.droppable
      },
      dragOverlay: {
        ...defaultMeasuringConfiguration.dragOverlay,
        ...a == null ? void 0 : a.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a == null ? void 0 : a.draggable, a == null ? void 0 : a.droppable, a == null ? void 0 : a.dragOverlay]
  );
}
function useLayoutShiftScrollCompensation(a) {
  let {
    activeNode: s,
    measure: $,
    initialRect: _,
    config: _e = !0
  } = a;
  const tt = reactExports.useRef(!1), {
    x: nt,
    y: at
  } = typeof _e == "boolean" ? {
    x: _e,
    y: _e
  } : _e;
  useIsomorphicLayoutEffect$1(() => {
    if (!nt && !at || !s) {
      tt.current = !1;
      return;
    }
    if (tt.current || !_)
      return;
    const rt = s == null ? void 0 : s.node.current;
    if (!rt || rt.isConnected === !1)
      return;
    const st = $(rt), lt = getRectDelta(st, _);
    if (nt || (lt.x = 0), at || (lt.y = 0), tt.current = !0, Math.abs(lt.x) > 0 || Math.abs(lt.y) > 0) {
      const et = getFirstScrollableAncestor(rt);
      et && et.scrollBy({
        top: lt.y,
        left: lt.x
      });
    }
  }, [s, nt, at, _, $]);
}
const ActiveDraggableContext = /* @__PURE__ */ reactExports.createContext({
  ...defaultCoordinates,
  scaleX: 1,
  scaleY: 1
});
var Status;
(function(a) {
  a[a.Uninitialized = 0] = "Uninitialized", a[a.Initializing = 1] = "Initializing", a[a.Initialized = 2] = "Initialized";
})(Status || (Status = {}));
const DndContext = /* @__PURE__ */ reactExports.memo(function a(s) {
  var $, _, _e, tt;
  let {
    id: nt,
    accessibility: at,
    autoScroll: ot = !0,
    children: rt,
    sensors: st = defaultSensors,
    collisionDetection: lt = rectIntersection,
    measuring: et,
    modifiers: it,
    ...ut
  } = s;
  const ft = reactExports.useReducer(reducer, void 0, getInitialState), [ht, dt] = ft, [gt, pt] = useDndMonitorProvider(), [mt, ct] = reactExports.useState(Status.Uninitialized), vt = mt === Status.Initialized, {
    draggable: {
      active: At,
      nodes: xt,
      translate: bt
    },
    droppable: {
      containers: Et
    }
  } = ht, St = At ? xt.get(At) : null, Bt = reactExports.useRef({
    initial: null,
    translated: null
  }), Ot = reactExports.useMemo(() => {
    var Ir;
    return At != null ? {
      id: At,
      // It's possible for the active node to unmount while dragging
      data: (Ir = St == null ? void 0 : St.data) != null ? Ir : defaultData,
      rect: Bt
    } : null;
  }, [At, St]), Pt = reactExports.useRef(null), [wt, Ct] = reactExports.useState(null), [It, yt] = reactExports.useState(null), Rt = useLatestValue(ut, Object.values(ut)), kt = useUniqueId("DndDescribedBy", nt), jt = reactExports.useMemo(() => Et.getEnabled(), [Et]), Ht = useMeasuringConfiguration(et), {
    droppableRects: Ft,
    measureDroppableContainers: _t,
    measuringScheduled: Nt
  } = useDroppableMeasuring(jt, {
    dragging: vt,
    dependencies: [bt.x, bt.y],
    config: Ht.droppable
  }), Mt = useCachedNode(xt, At), Lt = reactExports.useMemo(() => It ? getEventCoordinates(It) : null, [It]), $t = Br(), Tt = useInitialRect(Mt, Ht.draggable.measure);
  useLayoutShiftScrollCompensation({
    activeNode: At ? xt.get(At) : null,
    config: $t.layoutShiftCompensation,
    initialRect: Tt,
    measure: Ht.draggable.measure
  });
  const Dt = useRect(Mt, Ht.draggable.measure, Tt), Ut = useRect(Mt ? Mt.parentElement : null), Vt = reactExports.useRef({
    activatorEvent: null,
    active: null,
    activeNode: Mt,
    collisionRect: null,
    collisions: null,
    droppableRects: Ft,
    draggableNodes: xt,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: Et,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), Qt = Et.getNodeFor(($ = Vt.current.over) == null ? void 0 : $.id), qt = useDragOverlayMeasuring({
    measure: Ht.dragOverlay.measure
  }), Zt = (_ = qt.nodeRef.current) != null ? _ : Mt, ar = vt ? (_e = qt.rect) != null ? _e : Dt : null, Jt = !!(qt.nodeRef.current && qt.rect), rr = useRectDelta(Jt ? null : Dt), Yt = useWindowRect(Zt ? getWindow$1(Zt) : null), Kt = useScrollableAncestors(vt ? Qt ?? Mt : null), nr = useRects(Kt), tr = applyModifiers(it, {
    transform: {
      x: bt.x - rr.x,
      y: bt.y - rr.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: It,
    active: Ot,
    activeNodeRect: Dt,
    containerNodeRect: Ut,
    draggingNodeRect: ar,
    over: Vt.current.over,
    overlayNodeRect: qt.rect,
    scrollableAncestors: Kt,
    scrollableAncestorRects: nr,
    windowRect: Yt
  }), ir = Lt ? add$1(Lt, bt) : null, sr = useScrollOffsets(Kt), cr = useScrollOffsetsDelta(sr), or = useScrollOffsetsDelta(sr, [Dt]), Xt = add$1(tr, cr), Gt = ar ? getAdjustedRect(ar, tr) : null, Wt = Ot && Gt ? lt({
    active: Ot,
    collisionRect: Gt,
    droppableRects: Ft,
    droppableContainers: jt,
    pointerCoordinates: ir
  }) : null, er = getFirstCollision(Wt, "id"), [lr, ur] = reactExports.useState(null), pr = Jt ? tr : add$1(tr, or), yr = adjustScale(pr, (tt = lr == null ? void 0 : lr.rect) != null ? tt : null, Dt), Er = reactExports.useCallback(
    (Ir, hr) => {
      let {
        sensor: vr,
        options: xr
      } = hr;
      if (Pt.current == null)
        return;
      const Pr = xt.get(Pt.current);
      if (!Pr)
        return;
      const Rr = Ir.nativeEvent, Dr = new vr({
        active: Pt.current,
        activeNode: Pr,
        event: Rr,
        options: xr,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: Vt,
        onStart(Or) {
          const Hr = Pt.current;
          if (Hr == null)
            return;
          const jr = xt.get(Hr);
          if (!jr)
            return;
          const {
            onDragStart: Tr
          } = Rt.current, fr = {
            active: {
              id: Hr,
              data: jr.data,
              rect: Bt
            }
          };
          reactDomExports.unstable_batchedUpdates(() => {
            Tr == null || Tr(fr), ct(Status.Initializing), dt({
              type: Action.DragStart,
              initialCoordinates: Or,
              active: Hr
            }), gt({
              type: "onDragStart",
              event: fr
            });
          });
        },
        onMove(Or) {
          dt({
            type: Action.DragMove,
            coordinates: Or
          });
        },
        onEnd: Gr(Action.DragEnd),
        onCancel: Gr(Action.DragCancel)
      });
      reactDomExports.unstable_batchedUpdates(() => {
        Ct(Dr), yt(Ir.nativeEvent);
      });
      function Gr(Or) {
        return async function() {
          const {
            active: jr,
            collisions: Tr,
            over: fr,
            scrollAdjustedTranslate: Cr
          } = Vt.current;
          let $r = null;
          if (jr && Cr) {
            const {
              cancelDrop: wr
            } = Rt.current;
            $r = {
              activatorEvent: Rr,
              active: jr,
              collisions: Tr,
              delta: Cr,
              over: fr
            }, Or === Action.DragEnd && typeof wr == "function" && await Promise.resolve(wr($r)) && (Or = Action.DragCancel);
          }
          Pt.current = null, reactDomExports.unstable_batchedUpdates(() => {
            dt({
              type: Or
            }), ct(Status.Uninitialized), ur(null), Ct(null), yt(null);
            const wr = Or === Action.DragEnd ? "onDragEnd" : "onDragCancel";
            if ($r) {
              const Mr = Rt.current[wr];
              Mr == null || Mr($r), gt({
                type: wr,
                event: $r
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [xt]
  ), br = reactExports.useCallback((Ir, hr) => (vr, xr) => {
    const Pr = vr.nativeEvent, Rr = xt.get(xr);
    if (
      // Another sensor is already instantiating
      Pt.current !== null || // No active draggable
      !Rr || // Event has already been captured
      Pr.dndKit || Pr.defaultPrevented
    )
      return;
    const Dr = {
      active: Rr
    };
    Ir(vr, hr.options, Dr) === !0 && (Pr.dndKit = {
      capturedBy: hr.sensor
    }, Pt.current = xr, Er(vr, hr));
  }, [xt, Er]), gr = useCombineActivators(st, br);
  useSensorSetup(st), useIsomorphicLayoutEffect$1(() => {
    Dt && mt === Status.Initializing && ct(Status.Initialized);
  }, [Dt, mt]), reactExports.useEffect(
    () => {
      const {
        onDragMove: Ir
      } = Rt.current, {
        active: hr,
        activatorEvent: vr,
        collisions: xr,
        over: Pr
      } = Vt.current;
      if (!hr || !vr)
        return;
      const Rr = {
        active: hr,
        activatorEvent: vr,
        collisions: xr,
        delta: {
          x: Xt.x,
          y: Xt.y
        },
        over: Pr
      };
      reactDomExports.unstable_batchedUpdates(() => {
        Ir == null || Ir(Rr), gt({
          type: "onDragMove",
          event: Rr
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Xt.x, Xt.y]
  ), reactExports.useEffect(
    () => {
      const {
        active: Ir,
        activatorEvent: hr,
        collisions: vr,
        droppableContainers: xr,
        scrollAdjustedTranslate: Pr
      } = Vt.current;
      if (!Ir || Pt.current == null || !hr || !Pr)
        return;
      const {
        onDragOver: Rr
      } = Rt.current, Dr = xr.get(er), Gr = Dr && Dr.rect.current ? {
        id: Dr.id,
        rect: Dr.rect.current,
        data: Dr.data,
        disabled: Dr.disabled
      } : null, Or = {
        active: Ir,
        activatorEvent: hr,
        collisions: vr,
        delta: {
          x: Pr.x,
          y: Pr.y
        },
        over: Gr
      };
      reactDomExports.unstable_batchedUpdates(() => {
        ur(Gr), Rr == null || Rr(Or), gt({
          type: "onDragOver",
          event: Or
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [er]
  ), useIsomorphicLayoutEffect$1(() => {
    Vt.current = {
      activatorEvent: It,
      active: Ot,
      activeNode: Mt,
      collisionRect: Gt,
      collisions: Wt,
      droppableRects: Ft,
      draggableNodes: xt,
      draggingNode: Zt,
      draggingNodeRect: ar,
      droppableContainers: Et,
      over: lr,
      scrollableAncestors: Kt,
      scrollAdjustedTranslate: Xt
    }, Bt.current = {
      initial: ar,
      translated: Gt
    };
  }, [Ot, Mt, Wt, Gt, xt, Zt, ar, Ft, Et, lr, Kt, Xt]), useAutoScroller({
    ...$t,
    delta: bt,
    draggingRect: Gt,
    pointerCoordinates: ir,
    scrollableAncestors: Kt,
    scrollableAncestorRects: nr
  });
  const Ar = reactExports.useMemo(() => ({
    active: Ot,
    activeNode: Mt,
    activeNodeRect: Dt,
    activatorEvent: It,
    collisions: Wt,
    containerNodeRect: Ut,
    dragOverlay: qt,
    draggableNodes: xt,
    droppableContainers: Et,
    droppableRects: Ft,
    over: lr,
    measureDroppableContainers: _t,
    scrollableAncestors: Kt,
    scrollableAncestorRects: nr,
    measuringConfiguration: Ht,
    measuringScheduled: Nt,
    windowRect: Yt
  }), [Ot, Mt, Dt, It, Wt, Ut, qt, xt, Et, Ft, lr, _t, Kt, nr, Ht, Nt, Yt]), Sr = reactExports.useMemo(() => ({
    activatorEvent: It,
    activators: gr,
    active: Ot,
    activeNodeRect: Dt,
    ariaDescribedById: {
      draggable: kt
    },
    dispatch: dt,
    draggableNodes: xt,
    over: lr,
    measureDroppableContainers: _t
  }), [It, gr, Ot, Dt, dt, kt, xt, lr, _t]);
  return React$a.createElement(DndMonitorContext.Provider, {
    value: pt
  }, React$a.createElement(InternalContext.Provider, {
    value: Sr
  }, React$a.createElement(PublicContext.Provider, {
    value: Ar
  }, React$a.createElement(ActiveDraggableContext.Provider, {
    value: yr
  }, rt)), React$a.createElement(RestoreFocus, {
    disabled: (at == null ? void 0 : at.restoreFocus) === !1
  })), React$a.createElement(Accessibility, {
    ...at,
    hiddenTextDescribedById: kt
  }));
  function Br() {
    const Ir = (wt == null ? void 0 : wt.autoScrollEnabled) === !1, hr = typeof ot == "object" ? ot.enabled === !1 : ot === !1, vr = vt && !Ir && !hr;
    return typeof ot == "object" ? {
      ...ot,
      enabled: vr
    } : {
      enabled: vr
    };
  }
}), NullContext = /* @__PURE__ */ reactExports.createContext(null), defaultRole = "button", ID_PREFIX$1 = "Droppable";
function useDraggable(a) {
  let {
    id: s,
    data: $,
    disabled: _ = !1,
    attributes: _e
  } = a;
  const tt = useUniqueId(ID_PREFIX$1), {
    activators: nt,
    activatorEvent: at,
    active: ot,
    activeNodeRect: rt,
    ariaDescribedById: st,
    draggableNodes: lt,
    over: et
  } = reactExports.useContext(InternalContext), {
    role: it = defaultRole,
    roleDescription: ut = "draggable",
    tabIndex: ft = 0
  } = _e ?? {}, ht = (ot == null ? void 0 : ot.id) === s, dt = reactExports.useContext(ht ? ActiveDraggableContext : NullContext), [gt, pt] = useNodeRef(), [mt, ct] = useNodeRef(), vt = useSyntheticListeners(nt, s), At = useLatestValue($);
  useIsomorphicLayoutEffect$1(
    () => (lt.set(s, {
      id: s,
      key: tt,
      node: gt,
      activatorNode: mt,
      data: At
    }), () => {
      const bt = lt.get(s);
      bt && bt.key === tt && lt.delete(s);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [lt, s]
  );
  const xt = reactExports.useMemo(() => ({
    role: it,
    tabIndex: ft,
    "aria-disabled": _,
    "aria-pressed": ht && it === defaultRole ? !0 : void 0,
    "aria-roledescription": ut,
    "aria-describedby": st.draggable
  }), [_, it, ft, ht, ut, st.draggable]);
  return {
    active: ot,
    activatorEvent: at,
    activeNodeRect: rt,
    attributes: xt,
    isDragging: ht,
    listeners: _ ? void 0 : vt,
    node: gt,
    over: et,
    setNodeRef: pt,
    setActivatorNodeRef: ct,
    transform: dt
  };
}
function useDndContext() {
  return reactExports.useContext(PublicContext);
}
const ID_PREFIX$1$1 = "Droppable", defaultResizeObserverConfig = {
  timeout: 25
};
function useDroppable(a) {
  let {
    data: s,
    disabled: $ = !1,
    id: _,
    resizeObserverConfig: _e
  } = a;
  const tt = useUniqueId(ID_PREFIX$1$1), {
    active: nt,
    dispatch: at,
    over: ot,
    measureDroppableContainers: rt
  } = reactExports.useContext(InternalContext), st = reactExports.useRef({
    disabled: $
  }), lt = reactExports.useRef(!1), et = reactExports.useRef(null), it = reactExports.useRef(null), {
    disabled: ut,
    updateMeasurementsFor: ft,
    timeout: ht
  } = {
    ...defaultResizeObserverConfig,
    ..._e
  }, dt = useLatestValue(ft ?? _), gt = reactExports.useCallback(
    () => {
      if (!lt.current) {
        lt.current = !0;
        return;
      }
      it.current != null && clearTimeout(it.current), it.current = setTimeout(() => {
        rt(Array.isArray(dt.current) ? dt.current : [dt.current]), it.current = null;
      }, ht);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [ht]
  ), pt = useResizeObserver({
    callback: gt,
    disabled: ut || !nt
  }), mt = reactExports.useCallback((xt, bt) => {
    pt && (bt && (pt.unobserve(bt), lt.current = !1), xt && pt.observe(xt));
  }, [pt]), [ct, vt] = useNodeRef(mt), At = useLatestValue(s);
  return reactExports.useEffect(() => {
    !pt || !ct.current || (pt.disconnect(), lt.current = !1, pt.observe(ct.current));
  }, [ct, pt]), useIsomorphicLayoutEffect$1(
    () => (at({
      type: Action.RegisterDroppable,
      element: {
        id: _,
        key: tt,
        disabled: $,
        node: ct,
        rect: et,
        data: At
      }
    }), () => at({
      type: Action.UnregisterDroppable,
      key: tt,
      id: _
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [_]
  ), reactExports.useEffect(() => {
    $ !== st.current.disabled && (at({
      type: Action.SetDroppableDisabled,
      id: _,
      key: tt,
      disabled: $
    }), st.current.disabled = $);
  }, [_, tt, $, at]), {
    active: nt,
    rect: et,
    isOver: (ot == null ? void 0 : ot.id) === _,
    node: ct,
    over: ot,
    setNodeRef: vt
  };
}
function AnimationManager(a) {
  let {
    animation: s,
    children: $
  } = a;
  const [_, _e] = reactExports.useState(null), [tt, nt] = reactExports.useState(null), at = usePrevious$1($);
  return !$ && !_ && at && _e(at), useIsomorphicLayoutEffect$1(() => {
    if (!tt)
      return;
    const ot = _ == null ? void 0 : _.key, rt = _ == null ? void 0 : _.props.id;
    if (ot == null || rt == null) {
      _e(null);
      return;
    }
    Promise.resolve(s(rt, tt)).then(() => {
      _e(null);
    });
  }, [s, _, tt]), React$a.createElement(React$a.Fragment, null, $, _ ? reactExports.cloneElement(_, {
    ref: nt
  }) : null);
}
const defaultTransform = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function NullifiedContextProvider(a) {
  let {
    children: s
  } = a;
  return React$a.createElement(InternalContext.Provider, {
    value: defaultInternalContext
  }, React$a.createElement(ActiveDraggableContext.Provider, {
    value: defaultTransform
  }, s));
}
const baseStyles = {
  position: "fixed",
  touchAction: "none"
}, defaultTransition$1 = (a) => isKeyboardEvent(a) ? "transform 250ms ease" : void 0, PositionedOverlay = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  let {
    as: $,
    activatorEvent: _,
    adjustScale: _e,
    children: tt,
    className: nt,
    rect: at,
    style: ot,
    transform: rt,
    transition: st = defaultTransition$1
  } = a;
  if (!at)
    return null;
  const lt = _e ? rt : {
    ...rt,
    scaleX: 1,
    scaleY: 1
  }, et = {
    ...baseStyles,
    width: at.width,
    height: at.height,
    top: at.top,
    left: at.left,
    transform: CSS$1.Transform.toString(lt),
    transformOrigin: _e && _ ? getRelativeTransformOrigin(_, at) : void 0,
    transition: typeof st == "function" ? st(_) : st,
    ...ot
  };
  return React$a.createElement($, {
    className: nt,
    style: et,
    ref: s
  }, tt);
}), defaultDropAnimationSideEffects = (a) => (s) => {
  let {
    active: $,
    dragOverlay: _
  } = s;
  const _e = {}, {
    styles: tt,
    className: nt
  } = a;
  if (tt != null && tt.active)
    for (const [at, ot] of Object.entries(tt.active))
      ot !== void 0 && (_e[at] = $.node.style.getPropertyValue(at), $.node.style.setProperty(at, ot));
  if (tt != null && tt.dragOverlay)
    for (const [at, ot] of Object.entries(tt.dragOverlay))
      ot !== void 0 && _.node.style.setProperty(at, ot);
  return nt != null && nt.active && $.node.classList.add(nt.active), nt != null && nt.dragOverlay && _.node.classList.add(nt.dragOverlay), function() {
    for (const [ot, rt] of Object.entries(_e))
      $.node.style.setProperty(ot, rt);
    nt != null && nt.active && $.node.classList.remove(nt.active);
  };
}, defaultKeyframeResolver = (a) => {
  let {
    transform: {
      initial: s,
      final: $
    }
  } = a;
  return [{
    transform: CSS$1.Transform.toString(s)
  }, {
    transform: CSS$1.Transform.toString($)
  }];
}, defaultDropAnimationConfiguration = {
  duration: 250,
  easing: "ease",
  keyframes: defaultKeyframeResolver,
  sideEffects: /* @__PURE__ */ defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function useDropAnimation(a) {
  let {
    config: s,
    draggableNodes: $,
    droppableContainers: _,
    measuringConfiguration: _e
  } = a;
  return useEvent$1((tt, nt) => {
    if (s === null)
      return;
    const at = $.get(tt);
    if (!at)
      return;
    const ot = at.node.current;
    if (!ot)
      return;
    const rt = getMeasurableNode(nt);
    if (!rt)
      return;
    const {
      transform: st
    } = getWindow$1(nt).getComputedStyle(nt), lt = parseTransform(st);
    if (!lt)
      return;
    const et = typeof s == "function" ? s : createDefaultDropAnimation(s);
    return scrollIntoViewIfNeeded(ot, _e.draggable.measure), et({
      active: {
        id: tt,
        data: at.data,
        node: ot,
        rect: _e.draggable.measure(ot)
      },
      draggableNodes: $,
      dragOverlay: {
        node: nt,
        rect: _e.dragOverlay.measure(rt)
      },
      droppableContainers: _,
      measuringConfiguration: _e,
      transform: lt
    });
  });
}
function createDefaultDropAnimation(a) {
  const {
    duration: s,
    easing: $,
    sideEffects: _,
    keyframes: _e
  } = {
    ...defaultDropAnimationConfiguration,
    ...a
  };
  return (tt) => {
    let {
      active: nt,
      dragOverlay: at,
      transform: ot,
      ...rt
    } = tt;
    if (!s)
      return;
    const st = {
      x: at.rect.left - nt.rect.left,
      y: at.rect.top - nt.rect.top
    }, lt = {
      scaleX: ot.scaleX !== 1 ? nt.rect.width * ot.scaleX / at.rect.width : 1,
      scaleY: ot.scaleY !== 1 ? nt.rect.height * ot.scaleY / at.rect.height : 1
    }, et = {
      x: ot.x - st.x,
      y: ot.y - st.y,
      ...lt
    }, it = _e({
      ...rt,
      active: nt,
      dragOverlay: at,
      transform: {
        initial: ot,
        final: et
      }
    }), [ut] = it, ft = it[it.length - 1];
    if (JSON.stringify(ut) === JSON.stringify(ft))
      return;
    const ht = _ == null ? void 0 : _({
      active: nt,
      dragOverlay: at,
      ...rt
    }), dt = at.node.animate(it, {
      duration: s,
      easing: $,
      fill: "forwards"
    });
    return new Promise((gt) => {
      dt.onfinish = () => {
        ht == null || ht(), gt();
      };
    });
  };
}
let key$1 = 0;
function useKey(a) {
  return reactExports.useMemo(() => {
    if (a != null)
      return key$1++, key$1;
  }, [a]);
}
const DragOverlay = /* @__PURE__ */ React$a.memo((a) => {
  let {
    adjustScale: s = !1,
    children: $,
    dropAnimation: _,
    style: _e,
    transition: tt,
    modifiers: nt,
    wrapperElement: at = "div",
    className: ot,
    zIndex: rt = 999
  } = a;
  const {
    activatorEvent: st,
    active: lt,
    activeNodeRect: et,
    containerNodeRect: it,
    draggableNodes: ut,
    droppableContainers: ft,
    dragOverlay: ht,
    over: dt,
    measuringConfiguration: gt,
    scrollableAncestors: pt,
    scrollableAncestorRects: mt,
    windowRect: ct
  } = useDndContext(), vt = reactExports.useContext(ActiveDraggableContext), At = useKey(lt == null ? void 0 : lt.id), xt = applyModifiers(nt, {
    activatorEvent: st,
    active: lt,
    activeNodeRect: et,
    containerNodeRect: it,
    draggingNodeRect: ht.rect,
    over: dt,
    overlayNodeRect: ht.rect,
    scrollableAncestors: pt,
    scrollableAncestorRects: mt,
    transform: vt,
    windowRect: ct
  }), bt = useInitialValue(et), Et = useDropAnimation({
    config: _,
    draggableNodes: ut,
    droppableContainers: ft,
    measuringConfiguration: gt
  }), St = bt ? ht.setRef : void 0;
  return React$a.createElement(NullifiedContextProvider, null, React$a.createElement(AnimationManager, {
    animation: Et
  }, lt && At ? React$a.createElement(PositionedOverlay, {
    key: At,
    id: lt.id,
    ref: St,
    as: at,
    activatorEvent: st,
    adjustScale: s,
    className: ot,
    transition: tt,
    rect: bt,
    style: {
      zIndex: rt,
      ..._e
    },
    transform: xt
  }, $) : null));
});
var classnames$1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(a) {
  (function() {
    var s = {}.hasOwnProperty;
    function $() {
      for (var _ = [], _e = 0; _e < arguments.length; _e++) {
        var tt = arguments[_e];
        if (tt) {
          var nt = typeof tt;
          if (nt === "string" || nt === "number")
            _.push(tt);
          else if (Array.isArray(tt)) {
            if (tt.length) {
              var at = $.apply(null, tt);
              at && _.push(at);
            }
          } else if (nt === "object") {
            if (tt.toString !== Object.prototype.toString && !tt.toString.toString().includes("[native code]")) {
              _.push(tt.toString());
              continue;
            }
            for (var ot in tt)
              s.call(tt, ot) && tt[ot] && _.push(ot);
          }
        }
      }
      return _.join(" ");
    }
    a.exports ? ($.default = $, a.exports = $) : window.classNames = $;
  })();
})(classnames$1);
var classnamesExports = classnames$1.exports;
const classnames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(a) {
    for (var s = 1; s < arguments.length; s++) {
      var $ = arguments[s];
      for (var _ in $)
        Object.prototype.hasOwnProperty.call($, _) && (a[_] = $[_]);
    }
    return a;
  }, _extends$2.apply(this, arguments);
}
var reactIs = { exports: {} }, reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e$3 = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h$3 = Symbol.for("react.context"), k$2 = Symbol.for("react.server_context"), l$2 = Symbol.for("react.forward_ref"), m$1 = Symbol.for("react.suspense"), n$3 = Symbol.for("react.suspense_list"), p$2 = Symbol.for("react.memo"), q$2 = Symbol.for("react.lazy"), t$3 = Symbol.for("react.offscreen"), u$2;
u$2 = Symbol.for("react.module.reference");
function v$1(a) {
  if (typeof a == "object" && a !== null) {
    var s = a.$$typeof;
    switch (s) {
      case b:
        switch (a = a.type, a) {
          case d:
          case f:
          case e$3:
          case m$1:
          case n$3:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$2:
              case h$3:
              case l$2:
              case q$2:
              case p$2:
              case g:
                return a;
              default:
                return s;
            }
        }
      case c:
        return s;
    }
  }
}
reactIs_production_min.ContextConsumer = h$3;
reactIs_production_min.ContextProvider = g;
reactIs_production_min.Element = b;
reactIs_production_min.ForwardRef = l$2;
reactIs_production_min.Fragment = d;
reactIs_production_min.Lazy = q$2;
reactIs_production_min.Memo = p$2;
reactIs_production_min.Portal = c;
reactIs_production_min.Profiler = f;
reactIs_production_min.StrictMode = e$3;
reactIs_production_min.Suspense = m$1;
reactIs_production_min.SuspenseList = n$3;
reactIs_production_min.isAsyncMode = function() {
  return !1;
};
reactIs_production_min.isConcurrentMode = function() {
  return !1;
};
reactIs_production_min.isContextConsumer = function(a) {
  return v$1(a) === h$3;
};
reactIs_production_min.isContextProvider = function(a) {
  return v$1(a) === g;
};
reactIs_production_min.isElement = function(a) {
  return typeof a == "object" && a !== null && a.$$typeof === b;
};
reactIs_production_min.isForwardRef = function(a) {
  return v$1(a) === l$2;
};
reactIs_production_min.isFragment = function(a) {
  return v$1(a) === d;
};
reactIs_production_min.isLazy = function(a) {
  return v$1(a) === q$2;
};
reactIs_production_min.isMemo = function(a) {
  return v$1(a) === p$2;
};
reactIs_production_min.isPortal = function(a) {
  return v$1(a) === c;
};
reactIs_production_min.isProfiler = function(a) {
  return v$1(a) === f;
};
reactIs_production_min.isStrictMode = function(a) {
  return v$1(a) === e$3;
};
reactIs_production_min.isSuspense = function(a) {
  return v$1(a) === m$1;
};
reactIs_production_min.isSuspenseList = function(a) {
  return v$1(a) === n$3;
};
reactIs_production_min.isValidElementType = function(a) {
  return typeof a == "string" || typeof a == "function" || a === d || a === f || a === e$3 || a === m$1 || a === n$3 || a === t$3 || typeof a == "object" && a !== null && (a.$$typeof === q$2 || a.$$typeof === p$2 || a.$$typeof === g || a.$$typeof === h$3 || a.$$typeof === l$2 || a.$$typeof === u$2 || a.getModuleId !== void 0);
};
reactIs_production_min.typeOf = v$1;
reactIs.exports = reactIs_production_min;
var reactIsExports = reactIs.exports;
function toArray$9(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, $ = [];
  return React$a.Children.forEach(a, function(_) {
    _ == null && !s.keepEmpty || (Array.isArray(_) ? $ = $.concat(toArray$9(_)) : reactIsExports.isFragment(_) && _.props ? $ = $.concat(toArray$9(_.props.children, s)) : $.push(_));
  }), $;
}
var warned = {}, preMessage = function a(s) {
};
function warning$3(a, s) {
}
function note(a, s) {
}
function resetWarned() {
  warned = {};
}
function call(a, s, $) {
  !s && !warned[$] && (a(!1, $), warned[$] = !0);
}
function warningOnce(a, s) {
  call(warning$3, a, s);
}
function noteOnce(a, s) {
  call(note, a, s);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
function _typeof$q(a) {
  "@babel/helpers - typeof";
  return _typeof$q = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$q(a);
}
function toPrimitive$4(a, s) {
  if (_typeof$q(a) != "object" || !a)
    return a;
  var $ = a[Symbol.toPrimitive];
  if ($ !== void 0) {
    var _ = $.call(a, s || "default");
    if (_typeof$q(_) != "object")
      return _;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function toPropertyKey$1(a) {
  var s = toPrimitive$4(a, "string");
  return _typeof$q(s) == "symbol" ? s : String(s);
}
function _defineProperty$c(a, s, $) {
  return s = toPropertyKey$1(s), s in a ? Object.defineProperty(a, s, {
    value: $,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[s] = $, a;
}
function ownKeys$3(a, s) {
  var $ = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var _ = Object.getOwnPropertySymbols(a);
    s && (_ = _.filter(function(_e) {
      return Object.getOwnPropertyDescriptor(a, _e).enumerable;
    })), $.push.apply($, _);
  }
  return $;
}
function _objectSpread2$a(a) {
  for (var s = 1; s < arguments.length; s++) {
    var $ = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$3(Object($), !0).forEach(function(_) {
      _defineProperty$c(a, _, $[_]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors($)) : ownKeys$3(Object($)).forEach(function(_) {
      Object.defineProperty(a, _, Object.getOwnPropertyDescriptor($, _));
    });
  }
  return a;
}
function isDOM(a) {
  return a instanceof HTMLElement || a instanceof SVGElement;
}
function findDOMNode(a) {
  return isDOM(a) ? a : a instanceof React$a.Component ? ReactDOM.findDOMNode(a) : null;
}
function useMemo(a, s, $) {
  var _ = reactExports.useRef({});
  return (!("value" in _.current) || $(_.current.condition, s)) && (_.current.value = a(), _.current.condition = s), _.current.value;
}
function fillRef(a, s) {
  typeof a == "function" ? a(s) : _typeof$q(a) === "object" && a && "current" in a && (a.current = s);
}
function composeRef() {
  for (var a = arguments.length, s = new Array(a), $ = 0; $ < a; $++)
    s[$] = arguments[$];
  var _ = s.filter(function(_e) {
    return _e;
  });
  return _.length <= 1 ? _[0] : function(_e) {
    s.forEach(function(tt) {
      fillRef(tt, _e);
    });
  };
}
function useComposeRef() {
  for (var a = arguments.length, s = new Array(a), $ = 0; $ < a; $++)
    s[$] = arguments[$];
  return useMemo(function() {
    return composeRef.apply(void 0, s);
  }, s, function(_, _e) {
    return _.length !== _e.length || _.every(function(tt, nt) {
      return tt !== _e[nt];
    });
  });
}
function supportRef(a) {
  var s, $, _ = reactIsExports.isMemo(a) ? a.type.type : a.type;
  return !(typeof _ == "function" && !((s = _.prototype) !== null && s !== void 0 && s.render) || typeof a == "function" && !(($ = a.prototype) !== null && $ !== void 0 && $.render));
}
function supportNodeRef(a) {
  return !/* @__PURE__ */ reactExports.isValidElement(a) || reactIsExports.isFragment(a) ? !1 : supportRef(a);
}
var CollectionContext = /* @__PURE__ */ reactExports.createContext(null);
function Collection$1(a) {
  var s = a.children, $ = a.onBatchResize, _ = reactExports.useRef(0), _e = reactExports.useRef([]), tt = reactExports.useContext(CollectionContext), nt = reactExports.useCallback(function(at, ot, rt) {
    _.current += 1;
    var st = _.current;
    _e.current.push({
      size: at,
      element: ot,
      data: rt
    }), Promise.resolve().then(function() {
      st === _.current && ($ == null || $(_e.current), _e.current = []);
    }), tt == null || tt(at, ot, rt);
  }, [$, tt]);
  return /* @__PURE__ */ reactExports.createElement(CollectionContext.Provider, {
    value: nt
  }, s);
}
var MapShim = function() {
  if (typeof Map < "u")
    return Map;
  function a(s, $) {
    var _ = -1;
    return s.some(function(_e, tt) {
      return _e[0] === $ ? (_ = tt, !0) : !1;
    }), _;
  }
  return (
    /** @class */
    function() {
      function s() {
        this.__entries__ = [];
      }
      return Object.defineProperty(s.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), s.prototype.get = function($) {
        var _ = a(this.__entries__, $), _e = this.__entries__[_];
        return _e && _e[1];
      }, s.prototype.set = function($, _) {
        var _e = a(this.__entries__, $);
        ~_e ? this.__entries__[_e][1] = _ : this.__entries__.push([$, _]);
      }, s.prototype.delete = function($) {
        var _ = this.__entries__, _e = a(_, $);
        ~_e && _.splice(_e, 1);
      }, s.prototype.has = function($) {
        return !!~a(this.__entries__, $);
      }, s.prototype.clear = function() {
        this.__entries__.splice(0);
      }, s.prototype.forEach = function($, _) {
        _ === void 0 && (_ = null);
        for (var _e = 0, tt = this.__entries__; _e < tt.length; _e++) {
          var nt = tt[_e];
          $.call(_, nt[1], nt[0]);
        }
      }, s;
    }()
  );
}(), isBrowser = typeof window < "u" && typeof document < "u" && window.document === document, global$1$1 = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), requestAnimationFrame$1 = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1$1) : function(a) {
    return setTimeout(function() {
      return a(Date.now());
    }, 1e3 / 60);
  };
}(), trailingTimeout = 2;
function throttle$2(a, s) {
  var $ = !1, _ = !1, _e = 0;
  function tt() {
    $ && ($ = !1, a()), _ && at();
  }
  function nt() {
    requestAnimationFrame$1(tt);
  }
  function at() {
    var ot = Date.now();
    if ($) {
      if (ot - _e < trailingTimeout)
        return;
      _ = !0;
    } else
      $ = !0, _ = !1, setTimeout(nt, s);
    _e = ot;
  }
  return at;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver < "u", ResizeObserverController = (
  /** @class */
  function() {
    function a() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle$2(this.refresh.bind(this), REFRESH_DELAY);
    }
    return a.prototype.addObserver = function(s) {
      ~this.observers_.indexOf(s) || this.observers_.push(s), this.connected_ || this.connect_();
    }, a.prototype.removeObserver = function(s) {
      var $ = this.observers_, _ = $.indexOf(s);
      ~_ && $.splice(_, 1), !$.length && this.connected_ && this.disconnect_();
    }, a.prototype.refresh = function() {
      var s = this.updateObservers_();
      s && this.refresh();
    }, a.prototype.updateObservers_ = function() {
      var s = this.observers_.filter(function($) {
        return $.gatherActive(), $.hasActive();
      });
      return s.forEach(function($) {
        return $.broadcastActive();
      }), s.length > 0;
    }, a.prototype.connect_ = function() {
      !isBrowser || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, a.prototype.disconnect_ = function() {
      !isBrowser || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, a.prototype.onTransitionEnd_ = function(s) {
      var $ = s.propertyName, _ = $ === void 0 ? "" : $, _e = transitionKeys.some(function(tt) {
        return !!~_.indexOf(tt);
      });
      _e && this.refresh();
    }, a.getInstance = function() {
      return this.instance_ || (this.instance_ = new a()), this.instance_;
    }, a.instance_ = null, a;
  }()
), defineConfigurable = function(a, s) {
  for (var $ = 0, _ = Object.keys(s); $ < _.length; $++) {
    var _e = _[$];
    Object.defineProperty(a, _e, {
      value: s[_e],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return a;
}, getWindowOf = function(a) {
  var s = a && a.ownerDocument && a.ownerDocument.defaultView;
  return s || global$1$1;
}, emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(a) {
  return parseFloat(a) || 0;
}
function getBordersSize(a) {
  for (var s = [], $ = 1; $ < arguments.length; $++)
    s[$ - 1] = arguments[$];
  return s.reduce(function(_, _e) {
    var tt = a["border-" + _e + "-width"];
    return _ + toFloat(tt);
  }, 0);
}
function getPaddings(a) {
  for (var s = ["top", "right", "bottom", "left"], $ = {}, _ = 0, _e = s; _ < _e.length; _++) {
    var tt = _e[_], nt = a["padding-" + tt];
    $[tt] = toFloat(nt);
  }
  return $;
}
function getSVGContentRect(a) {
  var s = a.getBBox();
  return createRectInit(0, 0, s.width, s.height);
}
function getHTMLElementContentRect(a) {
  var s = a.clientWidth, $ = a.clientHeight;
  if (!s && !$)
    return emptyRect;
  var _ = getWindowOf(a).getComputedStyle(a), _e = getPaddings(_), tt = _e.left + _e.right, nt = _e.top + _e.bottom, at = toFloat(_.width), ot = toFloat(_.height);
  if (_.boxSizing === "border-box" && (Math.round(at + tt) !== s && (at -= getBordersSize(_, "left", "right") + tt), Math.round(ot + nt) !== $ && (ot -= getBordersSize(_, "top", "bottom") + nt)), !isDocumentElement(a)) {
    var rt = Math.round(at + tt) - s, st = Math.round(ot + nt) - $;
    Math.abs(rt) !== 1 && (at -= rt), Math.abs(st) !== 1 && (ot -= st);
  }
  return createRectInit(_e.left, _e.top, at, ot);
}
var isSVGGraphicsElement = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(a) {
    return a instanceof getWindowOf(a).SVGGraphicsElement;
  } : function(a) {
    return a instanceof getWindowOf(a).SVGElement && typeof a.getBBox == "function";
  };
}();
function isDocumentElement(a) {
  return a === getWindowOf(a).document.documentElement;
}
function getContentRect(a) {
  return isBrowser ? isSVGGraphicsElement(a) ? getSVGContentRect(a) : getHTMLElementContentRect(a) : emptyRect;
}
function createReadOnlyRect(a) {
  var s = a.x, $ = a.y, _ = a.width, _e = a.height, tt = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, nt = Object.create(tt.prototype);
  return defineConfigurable(nt, {
    x: s,
    y: $,
    width: _,
    height: _e,
    top: $,
    right: s + _,
    bottom: _e + $,
    left: s
  }), nt;
}
function createRectInit(a, s, $, _) {
  return { x: a, y: s, width: $, height: _ };
}
var ResizeObservation = (
  /** @class */
  function() {
    function a(s) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = s;
    }
    return a.prototype.isActive = function() {
      var s = getContentRect(this.target);
      return this.contentRect_ = s, s.width !== this.broadcastWidth || s.height !== this.broadcastHeight;
    }, a.prototype.broadcastRect = function() {
      var s = this.contentRect_;
      return this.broadcastWidth = s.width, this.broadcastHeight = s.height, s;
    }, a;
  }()
), ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ function() {
    function a(s, $) {
      var _ = createReadOnlyRect($);
      defineConfigurable(this, { target: s, contentRect: _ });
    }
    return a;
  }()
), ResizeObserverSPI = (
  /** @class */
  function() {
    function a(s, $, _) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof s != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = s, this.controller_ = $, this.callbackCtx_ = _;
    }
    return a.prototype.observe = function(s) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(s instanceof getWindowOf(s).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var $ = this.observations_;
        $.has(s) || ($.set(s, new ResizeObservation(s)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, a.prototype.unobserve = function(s) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(s instanceof getWindowOf(s).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var $ = this.observations_;
        $.has(s) && ($.delete(s), $.size || this.controller_.removeObserver(this));
      }
    }, a.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, a.prototype.gatherActive = function() {
      var s = this;
      this.clearActive(), this.observations_.forEach(function($) {
        $.isActive() && s.activeObservations_.push($);
      });
    }, a.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var s = this.callbackCtx_, $ = this.activeObservations_.map(function(_) {
          return new ResizeObserverEntry(_.target, _.broadcastRect());
        });
        this.callback_.call(s, $, s), this.clearActive();
      }
    }, a.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, a.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, a;
  }()
), observers = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ function() {
    function a(s) {
      if (!(this instanceof a))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var $ = ResizeObserverController.getInstance(), _ = new ResizeObserverSPI(s, $, this);
      observers.set(this, _);
    }
    return a;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(a) {
  ResizeObserver$2.prototype[a] = function() {
    var s;
    return (s = observers.get(this))[a].apply(s, arguments);
  };
});
var index$4 = function() {
  return typeof global$1$1.ResizeObserver < "u" ? global$1$1.ResizeObserver : ResizeObserver$2;
}(), elementListeners = /* @__PURE__ */ new Map();
function onResize(a) {
  a.forEach(function(s) {
    var $, _ = s.target;
    ($ = elementListeners.get(_)) === null || $ === void 0 || $.forEach(function(_e) {
      return _e(_);
    });
  });
}
var resizeObserver = new index$4(onResize);
function observe(a, s) {
  elementListeners.has(a) || (elementListeners.set(a, /* @__PURE__ */ new Set()), resizeObserver.observe(a)), elementListeners.get(a).add(s);
}
function unobserve(a, s) {
  elementListeners.has(a) && (elementListeners.get(a).delete(s), elementListeners.get(a).size || (resizeObserver.unobserve(a), elementListeners.delete(a)));
}
function _classCallCheck(a, s) {
  if (!(a instanceof s))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(a, s) {
  for (var $ = 0; $ < s.length; $++) {
    var _ = s[$];
    _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(a, toPropertyKey$1(_.key), _);
  }
}
function _createClass(a, s, $) {
  return s && _defineProperties(a.prototype, s), $ && _defineProperties(a, $), Object.defineProperty(a, "prototype", {
    writable: !1
  }), a;
}
function _setPrototypeOf$2(a, s) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(_, _e) {
    return _.__proto__ = _e, _;
  }, _setPrototypeOf$2(a, s);
}
function _inherits(a, s) {
  if (typeof s != "function" && s !== null)
    throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(s && s.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(a, "prototype", {
    writable: !1
  }), s && _setPrototypeOf$2(a, s);
}
function _getPrototypeOf$1(a) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function($) {
    return $.__proto__ || Object.getPrototypeOf($);
  }, _getPrototypeOf$1(a);
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _assertThisInitialized(a) {
  if (a === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function _possibleConstructorReturn(a, s) {
  if (s && (_typeof$q(s) === "object" || typeof s == "function"))
    return s;
  if (s !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(a);
}
function _createSuper(a) {
  var s = _isNativeReflectConstruct$1();
  return function() {
    var _ = _getPrototypeOf$1(a), _e;
    if (s) {
      var tt = _getPrototypeOf$1(this).constructor;
      _e = Reflect.construct(_, arguments, tt);
    } else
      _e = _.apply(this, arguments);
    return _possibleConstructorReturn(this, _e);
  };
}
var DomWrapper$1 = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $() {
    return _classCallCheck(this, $), s.apply(this, arguments);
  }
  return _createClass($, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), $;
}(reactExports.Component);
function SingleObserver(a, s) {
  var $ = a.children, _ = a.disabled, _e = reactExports.useRef(null), tt = reactExports.useRef(null), nt = reactExports.useContext(CollectionContext), at = typeof $ == "function", ot = at ? $(_e) : $, rt = reactExports.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), st = !at && /* @__PURE__ */ reactExports.isValidElement(ot) && supportRef(ot), lt = st ? ot.ref : null, et = useComposeRef(lt, _e), it = function() {
    var dt;
    return findDOMNode(_e.current) || // Support `nativeElement` format
    (_e.current && _typeof$q(_e.current) === "object" ? findDOMNode((dt = _e.current) === null || dt === void 0 ? void 0 : dt.nativeElement) : null) || findDOMNode(tt.current);
  };
  reactExports.useImperativeHandle(s, function() {
    return it();
  });
  var ut = reactExports.useRef(a);
  ut.current = a;
  var ft = reactExports.useCallback(function(ht) {
    var dt = ut.current, gt = dt.onResize, pt = dt.data, mt = ht.getBoundingClientRect(), ct = mt.width, vt = mt.height, At = ht.offsetWidth, xt = ht.offsetHeight, bt = Math.floor(ct), Et = Math.floor(vt);
    if (rt.current.width !== bt || rt.current.height !== Et || rt.current.offsetWidth !== At || rt.current.offsetHeight !== xt) {
      var St = {
        width: bt,
        height: Et,
        offsetWidth: At,
        offsetHeight: xt
      };
      rt.current = St;
      var Bt = At === Math.round(ct) ? ct : At, Ot = xt === Math.round(vt) ? vt : xt, Pt = _objectSpread2$a(_objectSpread2$a({}, St), {}, {
        offsetWidth: Bt,
        offsetHeight: Ot
      });
      nt == null || nt(Pt, ht, pt), gt && Promise.resolve().then(function() {
        gt(Pt, ht);
      });
    }
  }, []);
  return reactExports.useEffect(function() {
    var ht = it();
    return ht && !_ && observe(ht, ft), function() {
      return unobserve(ht, ft);
    };
  }, [_e.current, _]), /* @__PURE__ */ reactExports.createElement(DomWrapper$1, {
    ref: tt
  }, st ? /* @__PURE__ */ reactExports.cloneElement(ot, {
    ref: et
  }) : ot);
}
var RefSingleObserver = /* @__PURE__ */ reactExports.forwardRef(SingleObserver), INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(a, s) {
  var $ = a.children, _ = typeof $ == "function" ? [$] : toArray$9($);
  return _.map(function(_e, tt) {
    var nt = (_e == null ? void 0 : _e.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(tt);
    return /* @__PURE__ */ reactExports.createElement(RefSingleObserver, _extends$2({}, a, {
      key: nt,
      ref: tt === 0 ? s : void 0
    }), _e);
  });
}
var RefResizeObserver = /* @__PURE__ */ reactExports.forwardRef(ResizeObserver$1);
RefResizeObserver.Collection = Collection$1;
function omit(a, s) {
  var $ = _objectSpread2$a({}, a);
  return Array.isArray(s) && s.forEach(function(_) {
    delete $[_];
  }), $;
}
function _arrayLikeToArray$l(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _arrayWithoutHoles$d(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$l(a);
}
function _iterableToArray$d(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _unsupportedIterableToArray$l(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$l(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$l(a, s);
  }
}
function _nonIterableSpread$d() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toConsumableArray$d(a) {
  return _arrayWithoutHoles$d(a) || _iterableToArray$d(a) || _unsupportedIterableToArray$l(a) || _nonIterableSpread$d();
}
var raf = function a(s) {
  return +setTimeout(s, 16);
}, caf = function a(s) {
  return clearTimeout(s);
};
typeof window < "u" && "requestAnimationFrame" in window && (raf = function(s) {
  return window.requestAnimationFrame(s);
}, caf = function(s) {
  return window.cancelAnimationFrame(s);
});
var rafUUID = 0, rafIds = /* @__PURE__ */ new Map();
function cleanup(a) {
  rafIds.delete(a);
}
var wrapperRaf = function a(s) {
  var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var _ = rafUUID;
  function _e(tt) {
    if (tt === 0)
      cleanup(_), s();
    else {
      var nt = raf(function() {
        _e(tt - 1);
      });
      rafIds.set(_, nt);
    }
  }
  return _e($), _;
};
wrapperRaf.cancel = function(a) {
  var s = rafIds.get(a);
  return cleanup(a), caf(s);
};
function _arrayWithHoles$f(a) {
  if (Array.isArray(a))
    return a;
}
function _iterableToArrayLimit$e(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _nonIterableRest$f() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray$e(a, s) {
  return _arrayWithHoles$f(a) || _iterableToArrayLimit$e(a, s) || _unsupportedIterableToArray$l(a, s) || _nonIterableRest$f();
}
function murmur2(a) {
  for (var s = 0, $, _ = 0, _e = a.length; _e >= 4; ++_, _e -= 4)
    $ = a.charCodeAt(_) & 255 | (a.charCodeAt(++_) & 255) << 8 | (a.charCodeAt(++_) & 255) << 16 | (a.charCodeAt(++_) & 255) << 24, $ = /* Math.imul(k, m): */
    ($ & 65535) * 1540483477 + (($ >>> 16) * 59797 << 16), $ ^= /* k >>> r: */
    $ >>> 24, s = /* Math.imul(k, m): */
    ($ & 65535) * 1540483477 + (($ >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (s & 65535) * 1540483477 + ((s >>> 16) * 59797 << 16);
  switch (_e) {
    case 3:
      s ^= (a.charCodeAt(_ + 2) & 255) << 16;
    case 2:
      s ^= (a.charCodeAt(_ + 1) & 255) << 8;
    case 1:
      s ^= a.charCodeAt(_) & 255, s = /* Math.imul(h, m): */
      (s & 65535) * 1540483477 + ((s >>> 16) * 59797 << 16);
  }
  return s ^= s >>> 13, s = /* Math.imul(h, m): */
  (s & 65535) * 1540483477 + ((s >>> 16) * 59797 << 16), ((s ^ s >>> 15) >>> 0).toString(36);
}
function canUseDom$1() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function contains$3(a, s) {
  if (!a)
    return !1;
  if (a.contains)
    return a.contains(s);
  for (var $ = s; $; ) {
    if ($ === a)
      return !0;
    $ = $.parentNode;
  }
  return !1;
}
var APPEND_ORDER = "data-rc-order", APPEND_PRIORITY = "data-rc-priority", MARK_KEY = "rc-util-key", containerCache = /* @__PURE__ */ new Map();
function getMark() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = a.mark;
  return s ? s.startsWith("data-") ? s : "data-".concat(s) : MARK_KEY;
}
function getContainer(a) {
  if (a.attachTo)
    return a.attachTo;
  var s = document.querySelector("head");
  return s || document.body;
}
function getOrder(a) {
  return a === "queue" ? "prependQueue" : a ? "prepend" : "append";
}
function findStyles(a) {
  return Array.from((containerCache.get(a) || a).children).filter(function(s) {
    return s.tagName === "STYLE";
  });
}
function injectCSS(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!canUseDom$1())
    return null;
  var $ = s.csp, _ = s.prepend, _e = s.priority, tt = _e === void 0 ? 0 : _e, nt = getOrder(_), at = nt === "prependQueue", ot = document.createElement("style");
  ot.setAttribute(APPEND_ORDER, nt), at && tt && ot.setAttribute(APPEND_PRIORITY, "".concat(tt)), $ != null && $.nonce && (ot.nonce = $ == null ? void 0 : $.nonce), ot.innerHTML = a;
  var rt = getContainer(s), st = rt.firstChild;
  if (_) {
    if (at) {
      var lt = findStyles(rt).filter(function(et) {
        if (!["prepend", "prependQueue"].includes(et.getAttribute(APPEND_ORDER)))
          return !1;
        var it = Number(et.getAttribute(APPEND_PRIORITY) || 0);
        return tt >= it;
      });
      if (lt.length)
        return rt.insertBefore(ot, lt[lt.length - 1].nextSibling), ot;
    }
    rt.insertBefore(ot, st);
  } else
    rt.appendChild(ot);
  return ot;
}
function findExistNode(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, $ = getContainer(s);
  return findStyles($).find(function(_) {
    return _.getAttribute(getMark(s)) === a;
  });
}
function removeCSS(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, $ = findExistNode(a, s);
  if ($) {
    var _ = getContainer(s);
    _.removeChild($);
  }
}
function syncRealContainer(a, s) {
  var $ = containerCache.get(a);
  if (!$ || !contains$3(document, $)) {
    var _ = injectCSS("", s), _e = _.parentNode;
    containerCache.set(a, _e), a.removeChild(_);
  }
}
function updateCSS(a, s) {
  var $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ = getContainer($);
  syncRealContainer(_, $);
  var _e = findExistNode(s, $);
  if (_e) {
    var tt, nt;
    if ((tt = $.csp) !== null && tt !== void 0 && tt.nonce && _e.nonce !== ((nt = $.csp) === null || nt === void 0 ? void 0 : nt.nonce)) {
      var at;
      _e.nonce = (at = $.csp) === null || at === void 0 ? void 0 : at.nonce;
    }
    return _e.innerHTML !== a && (_e.innerHTML = a), _e;
  }
  var ot = injectCSS(a, $);
  return ot.setAttribute(getMark($), s), ot;
}
function _objectWithoutPropertiesLoose$1(a, s) {
  if (a == null)
    return {};
  var $ = {}, _ = Object.keys(a), _e, tt;
  for (tt = 0; tt < _.length; tt++)
    _e = _[tt], !(s.indexOf(_e) >= 0) && ($[_e] = a[_e]);
  return $;
}
function _objectWithoutProperties$1(a, s) {
  if (a == null)
    return {};
  var $ = _objectWithoutPropertiesLoose$1(a, s), _, _e;
  if (Object.getOwnPropertySymbols) {
    var tt = Object.getOwnPropertySymbols(a);
    for (_e = 0; _e < tt.length; _e++)
      _ = tt[_e], !(s.indexOf(_) >= 0) && Object.prototype.propertyIsEnumerable.call(a, _) && ($[_] = a[_]);
  }
  return $;
}
function isEqual$1(a, s) {
  var $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, _ = /* @__PURE__ */ new Set();
  function _e(tt, nt) {
    var at = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, ot = _.has(tt);
    if (warningOnce(!ot, "Warning: There may be circular references"), ot)
      return !1;
    if (tt === nt)
      return !0;
    if ($ && at > 1)
      return !1;
    _.add(tt);
    var rt = at + 1;
    if (Array.isArray(tt)) {
      if (!Array.isArray(nt) || tt.length !== nt.length)
        return !1;
      for (var st = 0; st < tt.length; st++)
        if (!_e(tt[st], nt[st], rt))
          return !1;
      return !0;
    }
    if (tt && nt && _typeof$q(tt) === "object" && _typeof$q(nt) === "object") {
      var lt = Object.keys(tt);
      return lt.length !== Object.keys(nt).length ? !1 : lt.every(function(et) {
        return _e(tt[et], nt[et], rt);
      });
    }
    return !1;
  }
  return _e(a, s);
}
var SPLIT$1 = "%", Entity = /* @__PURE__ */ function() {
  function a(s) {
    _classCallCheck(this, a), _defineProperty$c(this, "instanceId", void 0), _defineProperty$c(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = s;
  }
  return _createClass(a, [{
    key: "get",
    value: function($) {
      return this.cache.get($.join(SPLIT$1)) || null;
    }
  }, {
    key: "update",
    value: function($, _) {
      var _e = $.join(SPLIT$1), tt = this.cache.get(_e), nt = _(tt);
      nt === null ? this.cache.delete(_e) : this.cache.set(_e, nt);
    }
  }]), a;
}(), ATTR_TOKEN = "data-token-hash", ATTR_MARK = "data-css-hash", CSS_IN_JS_INSTANCE = "__cssinjs_instance__";
function createCache() {
  var a = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var s = document.body.querySelectorAll("style[".concat(ATTR_MARK, "]")) || [], $ = document.head.firstChild;
    Array.from(s).forEach(function(_e) {
      _e[CSS_IN_JS_INSTANCE] = _e[CSS_IN_JS_INSTANCE] || a, _e[CSS_IN_JS_INSTANCE] === a && document.head.insertBefore(_e, $);
    });
    var _ = {};
    Array.from(document.querySelectorAll("style[".concat(ATTR_MARK, "]"))).forEach(function(_e) {
      var tt = _e.getAttribute(ATTR_MARK);
      if (_[tt]) {
        if (_e[CSS_IN_JS_INSTANCE] === a) {
          var nt;
          (nt = _e.parentNode) === null || nt === void 0 || nt.removeChild(_e);
        }
      } else
        _[tt] = !0;
    });
  }
  return new Entity(a);
}
var StyleContext = /* @__PURE__ */ reactExports.createContext({
  hashPriority: "low",
  cache: createCache(),
  defaultCache: !0
});
function sameDerivativeOption(a, s) {
  if (a.length !== s.length)
    return !1;
  for (var $ = 0; $ < a.length; $++)
    if (a[$] !== s[$])
      return !1;
  return !0;
}
var ThemeCache = /* @__PURE__ */ function() {
  function a() {
    _classCallCheck(this, a), _defineProperty$c(this, "cache", void 0), _defineProperty$c(this, "keys", void 0), _defineProperty$c(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return _createClass(a, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function($) {
      var _, _e, tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, nt = {
        map: this.cache
      };
      return $.forEach(function(at) {
        if (!nt)
          nt = void 0;
        else {
          var ot;
          nt = (ot = nt) === null || ot === void 0 || (ot = ot.map) === null || ot === void 0 ? void 0 : ot.get(at);
        }
      }), (_ = nt) !== null && _ !== void 0 && _.value && tt && (nt.value[1] = this.cacheCallTimes++), (_e = nt) === null || _e === void 0 ? void 0 : _e.value;
    }
  }, {
    key: "get",
    value: function($) {
      var _;
      return (_ = this.internalGet($, !0)) === null || _ === void 0 ? void 0 : _[0];
    }
  }, {
    key: "has",
    value: function($) {
      return !!this.internalGet($);
    }
  }, {
    key: "set",
    value: function($, _) {
      var _e = this;
      if (!this.has($)) {
        if (this.size() + 1 > a.MAX_CACHE_SIZE + a.MAX_CACHE_OFFSET) {
          var tt = this.keys.reduce(function(rt, st) {
            var lt = _slicedToArray$e(rt, 2), et = lt[1];
            return _e.internalGet(st)[1] < et ? [st, _e.internalGet(st)[1]] : rt;
          }, [this.keys[0], this.cacheCallTimes]), nt = _slicedToArray$e(tt, 1), at = nt[0];
          this.delete(at);
        }
        this.keys.push($);
      }
      var ot = this.cache;
      $.forEach(function(rt, st) {
        if (st === $.length - 1)
          ot.set(rt, {
            value: [_, _e.cacheCallTimes++]
          });
        else {
          var lt = ot.get(rt);
          lt ? lt.map || (lt.map = /* @__PURE__ */ new Map()) : ot.set(rt, {
            map: /* @__PURE__ */ new Map()
          }), ot = ot.get(rt).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function($, _) {
      var _e = $.get(_[0]);
      if (_.length === 1) {
        var tt;
        return _e.map ? $.set(_[0], {
          map: _e.map
        }) : $.delete(_[0]), (tt = _e.value) === null || tt === void 0 ? void 0 : tt[0];
      }
      var nt = this.deleteByPath(_e.map, _.slice(1));
      return (!_e.map || _e.map.size === 0) && !_e.value && $.delete(_[0]), nt;
    }
  }, {
    key: "delete",
    value: function($) {
      if (this.has($))
        return this.keys = this.keys.filter(function(_) {
          return !sameDerivativeOption(_, $);
        }), this.deleteByPath(this.cache, $);
    }
  }]), a;
}();
_defineProperty$c(ThemeCache, "MAX_CACHE_SIZE", 20);
_defineProperty$c(ThemeCache, "MAX_CACHE_OFFSET", 5);
var uuid$5 = 0, Theme = /* @__PURE__ */ function() {
  function a(s) {
    _classCallCheck(this, a), _defineProperty$c(this, "derivatives", void 0), _defineProperty$c(this, "id", void 0), this.derivatives = Array.isArray(s) ? s : [s], this.id = uuid$5, s.length === 0 && (s.length > 0, void 0), uuid$5 += 1;
  }
  return _createClass(a, [{
    key: "getDerivativeToken",
    value: function($) {
      return this.derivatives.reduce(function(_, _e) {
        return _e($, _);
      }, void 0);
    }
  }]), a;
}(), cacheThemes = new ThemeCache();
function createTheme(a) {
  var s = Array.isArray(a) ? a : [a];
  return cacheThemes.has(s) || cacheThemes.set(s, new Theme(s)), cacheThemes.get(s);
}
var resultCache = /* @__PURE__ */ new WeakMap(), RESULT_VALUE = {};
function memoResult(a, s) {
  for (var $ = resultCache, _ = 0; _ < s.length; _ += 1) {
    var _e = s[_];
    $.has(_e) || $.set(_e, /* @__PURE__ */ new WeakMap()), $ = $.get(_e);
  }
  return $.has(RESULT_VALUE) || $.set(RESULT_VALUE, a()), $.get(RESULT_VALUE);
}
var flattenTokenCache = /* @__PURE__ */ new WeakMap();
function flattenToken(a) {
  var s = flattenTokenCache.get(a) || "";
  return s || (Object.keys(a).forEach(function($) {
    var _ = a[$];
    s += $, _ instanceof Theme ? s += _.id : _ && _typeof$q(_) === "object" ? s += flattenToken(_) : s += _;
  }), flattenTokenCache.set(a, s)), s;
}
function token2key(a, s) {
  return murmur2("".concat(s, "_").concat(flattenToken(a)));
}
var randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, ""), checkContent = "_bAmBoO_";
function supportSelector(a, s, $) {
  if (canUseDom$1()) {
    var _, _e;
    updateCSS(a, randomSelectorKey);
    var tt = document.createElement("div");
    tt.style.position = "fixed", tt.style.left = "0", tt.style.top = "0", s == null || s(tt), document.body.appendChild(tt);
    var nt = $ ? $(tt) : (_ = getComputedStyle(tt).content) === null || _ === void 0 ? void 0 : _.includes(checkContent);
    return (_e = tt.parentNode) === null || _e === void 0 || _e.removeChild(tt), removeCSS(randomSelectorKey), nt;
  }
  return !1;
}
var canLayer = void 0;
function supportLayer() {
  return canLayer === void 0 && (canLayer = supportSelector("@layer ".concat(randomSelectorKey, " { .").concat(randomSelectorKey, ' { content: "').concat(checkContent, '"!important; } }'), function(a) {
    a.className = randomSelectorKey;
  })), canLayer;
}
var isClientSide = canUseDom$1();
function unit$1(a) {
  return typeof a == "number" ? "".concat(a, "px") : a;
}
function toStyleStr(a, s, $) {
  var _, _e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, tt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (tt)
    return a;
  var nt = _objectSpread2$a(_objectSpread2$a({}, _e), {}, (_ = {}, _defineProperty$c(_, ATTR_TOKEN, s), _defineProperty$c(_, ATTR_MARK, $), _)), at = Object.keys(nt).map(function(ot) {
    var rt = nt[ot];
    return rt ? "".concat(ot, '="').concat(rt, '"') : null;
  }).filter(function(ot) {
    return ot;
  }).join(" ");
  return "<style ".concat(at, ">").concat(a, "</style>");
}
var token2CSSVar = function a(s) {
  var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat($ ? "".concat($, "-") : "").concat(s).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, serializeCSSVar = function a(s, $, _) {
  return Object.keys(s).length ? ".".concat($).concat(_ != null && _.scope ? ".".concat(_.scope) : "", "{").concat(Object.entries(s).map(function(_e) {
    var tt = _slicedToArray$e(_e, 2), nt = tt[0], at = tt[1];
    return "".concat(nt, ":").concat(at, ";");
  }).join(""), "}") : "";
}, transformToken = function a(s, $, _) {
  var _e = {}, tt = {};
  return Object.entries(s).forEach(function(nt) {
    var at, ot, rt = _slicedToArray$e(nt, 2), st = rt[0], lt = rt[1];
    if (_ != null && (at = _.preserve) !== null && at !== void 0 && at[st])
      tt[st] = lt;
    else if ((typeof lt == "string" || typeof lt == "number") && !(_ != null && (ot = _.ignore) !== null && ot !== void 0 && ot[st])) {
      var et, it = token2CSSVar(st, _ == null ? void 0 : _.prefix);
      _e[it] = typeof lt == "number" && !(_ != null && (et = _.unitless) !== null && et !== void 0 && et[st]) ? "".concat(lt, "px") : String(lt), tt[st] = "var(".concat(it, ")");
    }
  }), [tt, serializeCSSVar(_e, $, {
    scope: _ == null ? void 0 : _.scope
  })];
}, useInternalLayoutEffect = canUseDom$1() ? reactExports.useLayoutEffect : reactExports.useEffect, useLayoutEffect$1 = function a(s, $) {
  var _ = reactExports.useRef(!0);
  useInternalLayoutEffect(function() {
    return s(_.current);
  }, $), useInternalLayoutEffect(function() {
    return _.current = !1, function() {
      _.current = !0;
    };
  }, []);
}, useLayoutUpdateEffect = function a(s, $) {
  useLayoutEffect$1(function(_) {
    if (!_)
      return s();
  }, $);
}, fullClone$3 = _objectSpread2$a({}, React$b), useInsertionEffect$1 = fullClone$3.useInsertionEffect, useInsertionEffectPolyfill = function a(s, $, _) {
  reactExports.useMemo(s, _), useLayoutEffect$1(function() {
    return $(!0);
  }, _);
}, useCompatibleInsertionEffect = useInsertionEffect$1 ? function(a, s, $) {
  return useInsertionEffect$1(function() {
    return a(), s();
  }, $);
} : useInsertionEffectPolyfill, fullClone$2 = _objectSpread2$a({}, React$b), useInsertionEffect = fullClone$2.useInsertionEffect, useCleanupRegister = function a(s) {
  var $ = [], _ = !1;
  function _e(tt) {
    _ || $.push(tt);
  }
  return reactExports.useEffect(function() {
    return _ = !1, function() {
      _ = !0, $.length && $.forEach(function(tt) {
        return tt();
      });
    };
  }, s), _e;
}, useRun = function a() {
  return function(s) {
    s();
  };
}, useEffectCleanupRegister = typeof useInsertionEffect < "u" ? useCleanupRegister : useRun;
function useGlobalCache(a, s, $, _, _e) {
  var tt = reactExports.useContext(StyleContext), nt = tt.cache, at = [a].concat(_toConsumableArray$d(s)), ot = at.join("_"), rt = useEffectCleanupRegister([ot]), st = function(ut) {
    nt.update(at, function(ft) {
      var ht = ft || [void 0, void 0], dt = _slicedToArray$e(ht, 2), gt = dt[0], pt = gt === void 0 ? 0 : gt, mt = dt[1], ct = mt, vt = ct || $(), At = [pt, vt];
      return ut ? ut(At) : At;
    });
  };
  reactExports.useMemo(
    function() {
      st();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [ot]
    /* eslint-enable */
  );
  var lt = nt.get(at), et = lt[1];
  return useCompatibleInsertionEffect(function() {
    _e == null || _e(et);
  }, function(it) {
    return st(function(ut) {
      var ft = _slicedToArray$e(ut, 2), ht = ft[0], dt = ft[1];
      return it && ht === 0 && (_e == null || _e(et)), [ht + 1, dt];
    }), function() {
      nt.update(at, function(ut) {
        var ft = ut || [], ht = _slicedToArray$e(ft, 2), dt = ht[0], gt = dt === void 0 ? 0 : dt, pt = ht[1], mt = gt - 1;
        return mt === 0 ? (rt(function() {
          (it || !nt.get(at)) && (_ == null || _(pt, !1));
        }), null) : [gt - 1, pt];
      });
    };
  }, [ot]), et;
}
var EMPTY_OVERRIDE = {}, hashPrefix = "css", tokenKeys = /* @__PURE__ */ new Map();
function recordCleanToken(a) {
  tokenKeys.set(a, (tokenKeys.get(a) || 0) + 1);
}
function removeStyleTags(a, s) {
  if (typeof document < "u") {
    var $ = document.querySelectorAll("style[".concat(ATTR_TOKEN, '="').concat(a, '"]'));
    $.forEach(function(_) {
      if (_[CSS_IN_JS_INSTANCE] === s) {
        var _e;
        (_e = _.parentNode) === null || _e === void 0 || _e.removeChild(_);
      }
    });
  }
}
var TOKEN_THRESHOLD = 0;
function cleanTokenStyle(a, s) {
  tokenKeys.set(a, (tokenKeys.get(a) || 0) - 1);
  var $ = Array.from(tokenKeys.keys()), _ = $.filter(function(_e) {
    var tt = tokenKeys.get(_e) || 0;
    return tt <= 0;
  });
  $.length - _.length > TOKEN_THRESHOLD && _.forEach(function(_e) {
    removeStyleTags(_e, s), tokenKeys.delete(_e);
  });
}
var getComputedToken$1 = function a(s, $, _, _e) {
  var tt = _.getDerivativeToken(s), nt = _objectSpread2$a(_objectSpread2$a({}, tt), $);
  return _e && (nt = _e(nt)), nt;
}, TOKEN_PREFIX = "token";
function useCacheToken(a, s) {
  var $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ = reactExports.useContext(StyleContext), _e = _.cache.instanceId, tt = _.container, nt = $.salt, at = nt === void 0 ? "" : nt, ot = $.override, rt = ot === void 0 ? EMPTY_OVERRIDE : ot, st = $.formatToken, lt = $.getComputedToken, et = $.cssVar, it = memoResult(function() {
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray$d(s)));
  }, s), ut = flattenToken(it), ft = flattenToken(rt), ht = et ? flattenToken(et) : "", dt = useGlobalCache(TOKEN_PREFIX, [at, a.id, ut, ft, ht], function() {
    var gt, pt = lt ? lt(it, rt, a) : getComputedToken$1(it, rt, a, st), mt = _objectSpread2$a({}, pt), ct = "";
    if (et) {
      var vt = transformToken(pt, et.key, {
        prefix: et.prefix,
        ignore: et.ignore,
        unitless: et.unitless,
        preserve: et.preserve
      }), At = _slicedToArray$e(vt, 2);
      pt = At[0], ct = At[1];
    }
    var xt = token2key(pt, at);
    pt._tokenKey = xt, mt._tokenKey = token2key(mt, at);
    var bt = (gt = et == null ? void 0 : et.key) !== null && gt !== void 0 ? gt : xt;
    pt._themeKey = bt, recordCleanToken(bt);
    var Et = "".concat(hashPrefix, "-").concat(murmur2(xt));
    return pt._hashId = Et, [pt, Et, mt, ct, (et == null ? void 0 : et.key) || ""];
  }, function(gt) {
    cleanTokenStyle(gt[0]._themeKey, _e);
  }, function(gt) {
    var pt = _slicedToArray$e(gt, 4), mt = pt[0], ct = pt[3];
    if (et && ct) {
      var vt = updateCSS(ct, murmur2("css-variables-".concat(mt._themeKey)), {
        mark: ATTR_MARK,
        prepend: "queue",
        attachTo: tt,
        priority: -999
      });
      vt[CSS_IN_JS_INSTANCE] = _e, vt.setAttribute(ATTR_TOKEN, mt._themeKey);
    }
  });
  return dt;
}
var extract$2 = function a(s, $, _) {
  var _e = _slicedToArray$e(s, 5), tt = _e[2], nt = _e[3], at = _e[4], ot = _ || {}, rt = ot.plain;
  if (!nt)
    return null;
  var st = tt._tokenKey, lt = -999, et = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(lt)
  }, it = toStyleStr(nt, at, st, et, rt);
  return [lt, st, it];
}, unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs = Math.abs, from = String.fromCharCode;
function trim(a) {
  return a.trim();
}
function replace(a, s, $) {
  return a.replace(s, $);
}
function indexof(a, s) {
  return a.indexOf(s);
}
function charat(a, s) {
  return a.charCodeAt(s) | 0;
}
function substr(a, s, $) {
  return a.slice(s, $);
}
function strlen(a) {
  return a.length;
}
function sizeof(a) {
  return a.length;
}
function append(a, s) {
  return s.push(a), a;
}
var line = 1, column = 1, length = 0, position = 0, character = 0, characters = "";
function node(a, s, $, _, _e, tt, nt, at) {
  return { value: a, root: s, parent: $, type: _, props: _e, children: tt, line, column, length: nt, return: "", siblings: at };
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(a, s) {
  return substr(characters, a, s);
}
function token(a) {
  switch (a) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(a) {
  return line = column = 1, length = strlen(characters = a), position = 0, [];
}
function dealloc(a) {
  return characters = "", a;
}
function delimit(a) {
  return trim(slice(position - 1, delimiter(a === 91 ? a + 2 : a === 40 ? a + 1 : a)));
}
function whitespace$1(a) {
  for (; (character = peek()) && character < 33; )
    next();
  return token(a) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(a, s) {
  for (; --s && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(a, caret() + (s < 6 && peek() == 32 && next() == 32));
}
function delimiter(a) {
  for (; next(); )
    switch (character) {
      case a:
        return position;
      case 34:
      case 39:
        a !== 34 && a !== 39 && delimiter(character);
        break;
      case 40:
        a === 41 && delimiter(a);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(a, s) {
  for (; next() && a + character !== 57; )
    if (a + character === 84 && peek() === 47)
      break;
  return "/*" + slice(s, position - 1) + "*" + from(a === 47 ? a : next());
}
function identifier(a) {
  for (; !token(peek()); )
    next();
  return slice(a, position);
}
function compile(a) {
  return dealloc(parse$1("", null, null, null, [""], a = alloc(a), 0, [0], a));
}
function parse$1(a, s, $, _, _e, tt, nt, at, ot) {
  for (var rt = 0, st = 0, lt = nt, et = 0, it = 0, ut = 0, ft = 1, ht = 1, dt = 1, gt = 0, pt = "", mt = _e, ct = tt, vt = _, At = pt; ht; )
    switch (ut = gt, gt = next()) {
      case 40:
        if (ut != 108 && charat(At, lt - 1) == 58) {
          indexof(At += replace(delimit(gt), "&", "&\f"), "&\f") != -1 && (dt = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        At += delimit(gt);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        At += whitespace$1(ut);
        break;
      case 92:
        At += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), s, $, ot), ot);
            break;
          default:
            At += "/";
        }
        break;
      case 123 * ft:
        at[rt++] = strlen(At) * dt;
      case 125 * ft:
      case 59:
      case 0:
        switch (gt) {
          case 0:
          case 125:
            ht = 0;
          case 59 + st:
            dt == -1 && (At = replace(At, /\f/g, "")), it > 0 && strlen(At) - lt && append(it > 32 ? declaration(At + ";", _, $, lt - 1, ot) : declaration(replace(At, " ", "") + ";", _, $, lt - 2, ot), ot);
            break;
          case 59:
            At += ";";
          default:
            if (append(vt = ruleset(At, s, $, rt, st, _e, at, pt, mt = [], ct = [], lt, tt), tt), gt === 123)
              if (st === 0)
                parse$1(At, s, vt, vt, mt, tt, lt, at, ct);
              else
                switch (et === 99 && charat(At, 3) === 110 ? 100 : et) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$1(a, vt, vt, _ && append(ruleset(a, vt, vt, 0, 0, _e, at, pt, _e, mt = [], lt, ct), ct), _e, ct, lt, at, _ ? mt : ct);
                    break;
                  default:
                    parse$1(At, vt, vt, vt, [""], ct, 0, at, ct);
                }
        }
        rt = st = it = 0, ft = dt = 1, pt = At = "", lt = nt;
        break;
      case 58:
        lt = 1 + strlen(At), it = ut;
      default:
        if (ft < 1) {
          if (gt == 123)
            --ft;
          else if (gt == 125 && ft++ == 0 && prev() == 125)
            continue;
        }
        switch (At += from(gt), gt * ft) {
          case 38:
            dt = st > 0 ? 1 : (At += "\f", -1);
            break;
          case 44:
            at[rt++] = (strlen(At) - 1) * dt, dt = 1;
            break;
          case 64:
            peek() === 45 && (At += delimit(next())), et = peek(), st = lt = strlen(pt = At += identifier(caret())), gt++;
            break;
          case 45:
            ut === 45 && strlen(At) == 2 && (ft = 0);
        }
    }
  return tt;
}
function ruleset(a, s, $, _, _e, tt, nt, at, ot, rt, st, lt) {
  for (var et = _e - 1, it = _e === 0 ? tt : [""], ut = sizeof(it), ft = 0, ht = 0, dt = 0; ft < _; ++ft)
    for (var gt = 0, pt = substr(a, et + 1, et = abs(ht = nt[ft])), mt = a; gt < ut; ++gt)
      (mt = trim(ht > 0 ? it[gt] + " " + pt : replace(pt, /&\f/g, it[gt]))) && (ot[dt++] = mt);
  return node(a, s, $, _e === 0 ? RULESET : at, ot, rt, st, lt);
}
function comment(a, s, $, _) {
  return node(a, s, $, COMMENT, from(char()), substr(a, 2, -2), 0, _);
}
function declaration(a, s, $, _, _e) {
  return node(a, s, $, DECLARATION, substr(a, 0, _), substr(a, _ + 1, -1), _, _e);
}
function serialize(a, s) {
  for (var $ = "", _ = 0; _ < a.length; _++)
    $ += s(a[_], _, a, s) || "";
  return $;
}
function stringify$2(a, s, $, _) {
  switch (a.type) {
    case LAYER:
      if (a.children.length)
        break;
    case IMPORT:
    case DECLARATION:
      return a.return = a.return || a.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return a.return = a.value + "{" + serialize(a.children, _) + "}";
    case RULESET:
      if (!strlen(a.value = a.props.join(",")))
        return "";
  }
  return strlen($ = serialize(a.children, _)) ? a.return = a.value + "{" + $ + "}" : "";
}
var ATTR_CACHE_MAP = "data-ant-cssinjs-cache-path", CSS_FILE_STYLE = "_FILE_STYLE__", cachePathMap, fromCSSFile = !0;
function prepare() {
  if (!cachePathMap && (cachePathMap = {}, canUseDom$1())) {
    var a = document.createElement("div");
    a.className = ATTR_CACHE_MAP, a.style.position = "fixed", a.style.visibility = "hidden", a.style.top = "-9999px", document.body.appendChild(a);
    var s = getComputedStyle(a).content || "";
    s = s.replace(/^"/, "").replace(/"$/, ""), s.split(";").forEach(function(_e) {
      var tt = _e.split(":"), nt = _slicedToArray$e(tt, 2), at = nt[0], ot = nt[1];
      cachePathMap[at] = ot;
    });
    var $ = document.querySelector("style[".concat(ATTR_CACHE_MAP, "]"));
    if ($) {
      var _;
      fromCSSFile = !1, (_ = $.parentNode) === null || _ === void 0 || _.removeChild($);
    }
    document.body.removeChild(a);
  }
}
function existPath(a) {
  return prepare(), !!cachePathMap[a];
}
function getStyleAndHash(a) {
  var s = cachePathMap[a], $ = null;
  if (s && canUseDom$1())
    if (fromCSSFile)
      $ = CSS_FILE_STYLE;
    else {
      var _ = document.querySelector("style[".concat(ATTR_MARK, '="').concat(cachePathMap[a], '"]'));
      _ ? $ = _.innerHTML : delete cachePathMap[a];
    }
  return [$, s];
}
var SKIP_CHECK = "_skip_check_", MULTI_VALUE = "_multi_value_";
function normalizeStyle(a) {
  var s = serialize(compile(a), stringify$2);
  return s.replace(/\{%%%\:[^;];}/g, ";");
}
function isCompoundCSSProperty(a) {
  return _typeof$q(a) === "object" && a && (SKIP_CHECK in a || MULTI_VALUE in a);
}
function injectSelectorHash(a, s, $) {
  if (!s)
    return a;
  var _ = ".".concat(s), _e = $ === "low" ? ":where(".concat(_, ")") : _, tt = a.split(",").map(function(nt) {
    var at, ot = nt.trim().split(/\s+/), rt = ot[0] || "", st = ((at = rt.match(/^\w+/)) === null || at === void 0 ? void 0 : at[0]) || "";
    return rt = "".concat(st).concat(_e).concat(rt.slice(st.length)), [rt].concat(_toConsumableArray$d(ot.slice(1))).join(" ");
  });
  return tt.join(",");
}
var parseStyle = function a(s) {
  var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, _e = _.root, tt = _.injectHash, nt = _.parentSelectors, at = $.hashId, ot = $.layer;
  $.path;
  var rt = $.hashPriority, st = $.transformers, lt = st === void 0 ? [] : st;
  $.linters;
  var et = "", it = {};
  function ut(pt) {
    var mt = pt.getName(at);
    if (!it[mt]) {
      var ct = a(pt.style, $, {
        root: !1,
        parentSelectors: nt
      }), vt = _slicedToArray$e(ct, 1), At = vt[0];
      it[mt] = "@keyframes ".concat(pt.getName(at)).concat(At);
    }
  }
  function ft(pt) {
    var mt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return pt.forEach(function(ct) {
      Array.isArray(ct) ? ft(ct, mt) : ct && mt.push(ct);
    }), mt;
  }
  var ht = ft(Array.isArray(s) ? s : [s]);
  if (ht.forEach(function(pt) {
    var mt = typeof pt == "string" && !_e ? {} : pt;
    if (typeof mt == "string")
      et += "".concat(mt, `
`);
    else if (mt._keyframe)
      ut(mt);
    else {
      var ct = lt.reduce(function(vt, At) {
        var xt;
        return (At == null || (xt = At.visit) === null || xt === void 0 ? void 0 : xt.call(At, vt)) || vt;
      }, mt);
      Object.keys(ct).forEach(function(vt) {
        var At = ct[vt];
        if (_typeof$q(At) === "object" && At && (vt !== "animationName" || !At._keyframe) && !isCompoundCSSProperty(At)) {
          var xt = !1, bt = vt.trim(), Et = !1;
          (_e || tt) && at ? bt.startsWith("@") ? xt = !0 : bt = injectSelectorHash(vt, at, rt) : _e && !at && (bt === "&" || bt === "") && (bt = "", Et = !0);
          var St = a(At, $, {
            root: Et,
            injectHash: xt,
            parentSelectors: [].concat(_toConsumableArray$d(nt), [bt])
          }), Bt = _slicedToArray$e(St, 2), Ot = Bt[0], Pt = Bt[1];
          it = _objectSpread2$a(_objectSpread2$a({}, it), Pt), et += "".concat(bt).concat(Ot);
        } else {
          let It = function(yt, Rt) {
            var kt = yt.replace(/[A-Z]/g, function(Ht) {
              return "-".concat(Ht.toLowerCase());
            }), jt = Rt;
            !unitlessKeys[yt] && typeof jt == "number" && jt !== 0 && (jt = "".concat(jt, "px")), yt === "animationName" && Rt !== null && Rt !== void 0 && Rt._keyframe && (ut(Rt), jt = Rt.getName(at)), et += "".concat(kt, ":").concat(jt, ";");
          };
          var wt, Ct = (wt = At == null ? void 0 : At.value) !== null && wt !== void 0 ? wt : At;
          _typeof$q(At) === "object" && At !== null && At !== void 0 && At[MULTI_VALUE] && Array.isArray(Ct) ? Ct.forEach(function(yt) {
            It(vt, yt);
          }) : It(vt, Ct);
        }
      });
    }
  }), !_e)
    et = "{".concat(et, "}");
  else if (ot && supportLayer()) {
    var dt = ot.split(","), gt = dt[dt.length - 1].trim();
    et = "@layer ".concat(gt, " {").concat(et, "}"), dt.length > 1 && (et = "@layer ".concat(ot, "{%%%:%}").concat(et));
  }
  return [et, it];
};
function uniqueHash(a, s) {
  return murmur2("".concat(a.join("%")).concat(s));
}
function Empty$4() {
  return null;
}
var STYLE_PREFIX = "style";
function useStyleRegister(a, s) {
  var $ = a.token, _ = a.path, _e = a.hashId, tt = a.layer, nt = a.nonce, at = a.clientOnly, ot = a.order, rt = ot === void 0 ? 0 : ot, st = reactExports.useContext(StyleContext), lt = st.autoClear;
  st.mock;
  var et = st.defaultCache, it = st.hashPriority, ut = st.container, ft = st.ssrInline, ht = st.transformers, dt = st.linters, gt = st.cache, pt = $._tokenKey, mt = [pt].concat(_toConsumableArray$d(_)), ct = isClientSide, vt = useGlobalCache(
    STYLE_PREFIX,
    mt,
    // Create cache if needed
    function() {
      var St = mt.join("|");
      if (existPath(St)) {
        var Bt = getStyleAndHash(St), Ot = _slicedToArray$e(Bt, 2), Pt = Ot[0], wt = Ot[1];
        if (Pt)
          return [Pt, pt, wt, {}, at, rt];
      }
      var Ct = s(), It = parseStyle(Ct, {
        hashId: _e,
        hashPriority: it,
        layer: tt,
        path: _.join("-"),
        transformers: ht,
        linters: dt
      }), yt = _slicedToArray$e(It, 2), Rt = yt[0], kt = yt[1], jt = normalizeStyle(Rt), Ht = uniqueHash(mt, jt);
      return [jt, pt, Ht, kt, at, rt];
    },
    // Remove cache if no need
    function(St, Bt) {
      var Ot = _slicedToArray$e(St, 3), Pt = Ot[2];
      (Bt || lt) && isClientSide && removeCSS(Pt, {
        mark: ATTR_MARK
      });
    },
    // Effect: Inject style here
    function(St) {
      var Bt = _slicedToArray$e(St, 4), Ot = Bt[0];
      Bt[1];
      var Pt = Bt[2], wt = Bt[3];
      if (ct && Ot !== CSS_FILE_STYLE) {
        var Ct = {
          mark: ATTR_MARK,
          prepend: "queue",
          attachTo: ut,
          priority: rt
        }, It = typeof nt == "function" ? nt() : nt;
        It && (Ct.csp = {
          nonce: It
        });
        var yt = updateCSS(Ot, Pt, Ct);
        yt[CSS_IN_JS_INSTANCE] = gt.instanceId, yt.setAttribute(ATTR_TOKEN, pt), Object.keys(wt).forEach(function(Rt) {
          updateCSS(normalizeStyle(wt[Rt]), "_effect-".concat(Rt), Ct);
        });
      }
    }
  ), At = _slicedToArray$e(vt, 3), xt = At[0], bt = At[1], Et = At[2];
  return function(St) {
    var Bt;
    if (!ft || ct || !et)
      Bt = /* @__PURE__ */ reactExports.createElement(Empty$4, null);
    else {
      var Ot;
      Bt = /* @__PURE__ */ reactExports.createElement("style", _extends$2({}, (Ot = {}, _defineProperty$c(Ot, ATTR_TOKEN, bt), _defineProperty$c(Ot, ATTR_MARK, Et), Ot), {
        dangerouslySetInnerHTML: {
          __html: xt
        }
      }));
    }
    return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, Bt, St);
  };
}
var extract$1 = function a(s, $, _) {
  var _e = _slicedToArray$e(s, 6), tt = _e[0], nt = _e[1], at = _e[2], ot = _e[3], rt = _e[4], st = _e[5], lt = _ || {}, et = lt.plain;
  if (rt)
    return null;
  var it = tt, ut = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(st)
  };
  return it = toStyleStr(tt, nt, at, ut, et), ot && Object.keys(ot).forEach(function(ft) {
    if (!$[ft]) {
      $[ft] = !0;
      var ht = normalizeStyle(ot[ft]);
      it += toStyleStr(ht, nt, "_effect-".concat(ft), ut, et);
    }
  }), [st, at, it];
}, CSS_VAR_PREFIX = "cssVar", useCSSVarRegister = function a(s, $) {
  var _ = s.key, _e = s.prefix, tt = s.unitless, nt = s.ignore, at = s.token, ot = s.scope, rt = ot === void 0 ? "" : ot, st = reactExports.useContext(StyleContext), lt = st.cache.instanceId, et = st.container, it = at._tokenKey, ut = [].concat(_toConsumableArray$d(s.path), [_, rt, it]), ft = useGlobalCache(CSS_VAR_PREFIX, ut, function() {
    var ht = $(), dt = transformToken(ht, _, {
      prefix: _e,
      unitless: tt,
      ignore: nt,
      scope: rt
    }), gt = _slicedToArray$e(dt, 2), pt = gt[0], mt = gt[1], ct = uniqueHash(ut, mt);
    return [pt, mt, ct, _];
  }, function(ht) {
    var dt = _slicedToArray$e(ht, 3), gt = dt[2];
    isClientSide && removeCSS(gt, {
      mark: ATTR_MARK
    });
  }, function(ht) {
    var dt = _slicedToArray$e(ht, 3), gt = dt[1], pt = dt[2];
    if (gt) {
      var mt = updateCSS(gt, pt, {
        mark: ATTR_MARK,
        prepend: "queue",
        attachTo: et,
        priority: -999
      });
      mt[CSS_IN_JS_INSTANCE] = lt, mt.setAttribute(ATTR_TOKEN, _);
    }
  });
  return ft;
}, extract = function a(s, $, _) {
  var _e = _slicedToArray$e(s, 4), tt = _e[1], nt = _e[2], at = _e[3], ot = _ || {}, rt = ot.plain;
  if (!tt)
    return null;
  var st = -999, lt = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(st)
  }, et = toStyleStr(tt, at, nt, lt, rt);
  return [st, nt, et];
}, _ExtractStyleFns;
_ExtractStyleFns = {}, _defineProperty$c(_ExtractStyleFns, STYLE_PREFIX, extract$1), _defineProperty$c(_ExtractStyleFns, TOKEN_PREFIX, extract$2), _defineProperty$c(_ExtractStyleFns, CSS_VAR_PREFIX, extract);
var Keyframe = /* @__PURE__ */ function() {
  function a(s, $) {
    _classCallCheck(this, a), _defineProperty$c(this, "name", void 0), _defineProperty$c(this, "style", void 0), _defineProperty$c(this, "_keyframe", !0), this.name = s, this.style = $;
  }
  return _createClass(a, [{
    key: "getName",
    value: function() {
      var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return $ ? "".concat($, "-").concat(this.name) : this.name;
    }
  }]), a;
}();
function noSplit(a) {
  return a.notSplit = !0, a;
}
noSplit(["borderTop", "borderBottom"]), noSplit(["borderTop"]), noSplit(["borderBottom"]), noSplit(["borderLeft", "borderRight"]), noSplit(["borderLeft"]), noSplit(["borderRight"]);
var IconContext = /* @__PURE__ */ reactExports.createContext({});
const Context$4 = IconContext;
function _toArray$1(a) {
  return _arrayWithHoles$f(a) || _iterableToArray$d(a) || _unsupportedIterableToArray$l(a) || _nonIterableRest$f();
}
function get$1(a, s) {
  for (var $ = a, _ = 0; _ < s.length; _ += 1) {
    if ($ == null)
      return;
    $ = $[s[_]];
  }
  return $;
}
function internalSet(a, s, $, _) {
  if (!s.length)
    return $;
  var _e = _toArray$1(s), tt = _e[0], nt = _e.slice(1), at;
  return !a && typeof tt == "number" ? at = [] : Array.isArray(a) ? at = _toConsumableArray$d(a) : at = _objectSpread2$a({}, a), _ && $ === void 0 && nt.length === 1 ? delete at[tt][nt[0]] : at[tt] = internalSet(at[tt], nt, $, _), at;
}
function set$1(a, s, $) {
  var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return s.length && _ && $ === void 0 && !get$1(a, s.slice(0, -1)) ? a : internalSet(a, s, $, _);
}
function isObject$8(a) {
  return _typeof$q(a) === "object" && a !== null && Object.getPrototypeOf(a) === Object.prototype;
}
function createEmpty(a) {
  return Array.isArray(a) ? [] : {};
}
var keys$1 = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function merge$1() {
  for (var a = arguments.length, s = new Array(a), $ = 0; $ < a; $++)
    s[$] = arguments[$];
  var _ = createEmpty(s[0]);
  return s.forEach(function(_e) {
    function tt(nt, at) {
      var ot = new Set(at), rt = get$1(_e, nt), st = Array.isArray(rt);
      if (st || isObject$8(rt)) {
        if (!ot.has(rt)) {
          ot.add(rt);
          var lt = get$1(_, nt);
          st ? _ = set$1(_, nt, []) : (!lt || _typeof$q(lt) !== "object") && (_ = set$1(_, nt, createEmpty(rt))), keys$1(rt).forEach(function(et) {
            tt([].concat(_toConsumableArray$d(nt), [et]), ot);
          });
        }
      } else
        _ = set$1(_, nt, rt);
    }
    tt([]);
  }), _;
}
function noop$5() {
}
const WarningContext = /* @__PURE__ */ reactExports.createContext({}), devUseWarning = () => {
  const a = () => {
  };
  return a.deprecated = noop$5, a;
}, ValidateMessagesContext = /* @__PURE__ */ reactExports.createContext(void 0);
var locale$c = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, locale$b = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
const locale$a = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, TimePicker$2 = locale$a, locale$9 = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, locale$b),
  timePickerLocale: Object.assign({}, TimePicker$2)
}, enUS$1 = locale$9, typeTemplate$4 = "${label} is not a valid ${type}", localeValues$2 = {
  locale: "en",
  Pagination: locale$c,
  DatePicker: enUS$1,
  TimePicker: TimePicker$2,
  Calendar: enUS$1,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  PageHeader: {
    back: "Back"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: typeTemplate$4,
        method: typeTemplate$4,
        array: typeTemplate$4,
        object: typeTemplate$4,
        number: typeTemplate$4,
        date: typeTemplate$4,
        boolean: typeTemplate$4,
        integer: typeTemplate$4,
        float: typeTemplate$4,
        regexp: typeTemplate$4,
        email: typeTemplate$4,
        url: typeTemplate$4,
        hex: typeTemplate$4
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh"
  },
  ColorPicker: {
    presetEmpty: "Empty"
  }
}, defaultLocale = localeValues$2;
Object.assign({}, defaultLocale.Modal);
let localeList = [];
const generateLocale = () => localeList.reduce((a, s) => Object.assign(Object.assign({}, a), s), defaultLocale.Modal);
function changeConfirmLocale(a) {
  if (a) {
    const s = Object.assign({}, a);
    return localeList.push(s), generateLocale(), () => {
      localeList = localeList.filter(($) => $ !== s), generateLocale();
    };
  }
  Object.assign({}, defaultLocale.Modal);
}
const LocaleContext = /* @__PURE__ */ reactExports.createContext(void 0), LocaleContext$1 = LocaleContext, useLocale = (a, s) => {
  const $ = reactExports.useContext(LocaleContext$1), _ = reactExports.useMemo(() => {
    var tt;
    const nt = s || defaultLocale[a], at = (tt = $ == null ? void 0 : $[a]) !== null && tt !== void 0 ? tt : {};
    return Object.assign(Object.assign({}, typeof nt == "function" ? nt() : nt), at || {});
  }, [a, s, $]), _e = reactExports.useMemo(() => {
    const tt = $ == null ? void 0 : $.locale;
    return $ != null && $.exist && !tt ? defaultLocale.locale : tt;
  }, [$]);
  return [_, _e];
}, useLocale$1 = useLocale, ANT_MARK = "internalMark", LocaleProvider = (a) => {
  const {
    locale: s = {},
    children: $,
    _ANT_MARK__: _
  } = a;
  reactExports.useEffect(() => changeConfirmLocale(s && s.Modal), [s]);
  const _e = reactExports.useMemo(() => Object.assign(Object.assign({}, s), {
    exist: !0
  }), [s]);
  return /* @__PURE__ */ reactExports.createElement(LocaleContext$1.Provider, {
    value: _e
  }, $);
}, LocaleProvider$1 = LocaleProvider;
function bound01(a, s) {
  isOnePointZero(a) && (a = "100%");
  var $ = isPercentage(a);
  return a = s === 360 ? a : Math.min(s, Math.max(0, parseFloat(a))), $ && (a = parseInt(String(a * s), 10) / 100), Math.abs(a - s) < 1e-6 ? 1 : (s === 360 ? a = (a < 0 ? a % s + s : a % s) / parseFloat(String(s)) : a = a % s / parseFloat(String(s)), a);
}
function clamp01(a) {
  return Math.min(1, Math.max(0, a));
}
function isOnePointZero(a) {
  return typeof a == "string" && a.indexOf(".") !== -1 && parseFloat(a) === 1;
}
function isPercentage(a) {
  return typeof a == "string" && a.indexOf("%") !== -1;
}
function boundAlpha(a) {
  return a = parseFloat(a), (isNaN(a) || a < 0 || a > 1) && (a = 1), a;
}
function convertToPercentage(a) {
  return a <= 1 ? "".concat(Number(a) * 100, "%") : a;
}
function pad2(a) {
  return a.length === 1 ? "0" + a : String(a);
}
function rgbToRgb(a, s, $) {
  return {
    r: bound01(a, 255) * 255,
    g: bound01(s, 255) * 255,
    b: bound01($, 255) * 255
  };
}
function rgbToHsl(a, s, $) {
  a = bound01(a, 255), s = bound01(s, 255), $ = bound01($, 255);
  var _ = Math.max(a, s, $), _e = Math.min(a, s, $), tt = 0, nt = 0, at = (_ + _e) / 2;
  if (_ === _e)
    nt = 0, tt = 0;
  else {
    var ot = _ - _e;
    switch (nt = at > 0.5 ? ot / (2 - _ - _e) : ot / (_ + _e), _) {
      case a:
        tt = (s - $) / ot + (s < $ ? 6 : 0);
        break;
      case s:
        tt = ($ - a) / ot + 2;
        break;
      case $:
        tt = (a - s) / ot + 4;
        break;
    }
    tt /= 6;
  }
  return { h: tt, s: nt, l: at };
}
function hue2rgb(a, s, $) {
  return $ < 0 && ($ += 1), $ > 1 && ($ -= 1), $ < 1 / 6 ? a + (s - a) * (6 * $) : $ < 1 / 2 ? s : $ < 2 / 3 ? a + (s - a) * (2 / 3 - $) * 6 : a;
}
function hslToRgb(a, s, $) {
  var _, _e, tt;
  if (a = bound01(a, 360), s = bound01(s, 100), $ = bound01($, 100), s === 0)
    _e = $, tt = $, _ = $;
  else {
    var nt = $ < 0.5 ? $ * (1 + s) : $ + s - $ * s, at = 2 * $ - nt;
    _ = hue2rgb(at, nt, a + 1 / 3), _e = hue2rgb(at, nt, a), tt = hue2rgb(at, nt, a - 1 / 3);
  }
  return { r: _ * 255, g: _e * 255, b: tt * 255 };
}
function rgbToHsv(a, s, $) {
  a = bound01(a, 255), s = bound01(s, 255), $ = bound01($, 255);
  var _ = Math.max(a, s, $), _e = Math.min(a, s, $), tt = 0, nt = _, at = _ - _e, ot = _ === 0 ? 0 : at / _;
  if (_ === _e)
    tt = 0;
  else {
    switch (_) {
      case a:
        tt = (s - $) / at + (s < $ ? 6 : 0);
        break;
      case s:
        tt = ($ - a) / at + 2;
        break;
      case $:
        tt = (a - s) / at + 4;
        break;
    }
    tt /= 6;
  }
  return { h: tt, s: ot, v: nt };
}
function hsvToRgb(a, s, $) {
  a = bound01(a, 360) * 6, s = bound01(s, 100), $ = bound01($, 100);
  var _ = Math.floor(a), _e = a - _, tt = $ * (1 - s), nt = $ * (1 - _e * s), at = $ * (1 - (1 - _e) * s), ot = _ % 6, rt = [$, nt, tt, tt, at, $][ot], st = [at, $, $, nt, tt, tt][ot], lt = [tt, tt, at, $, $, nt][ot];
  return { r: rt * 255, g: st * 255, b: lt * 255 };
}
function rgbToHex(a, s, $, _) {
  var _e = [
    pad2(Math.round(a).toString(16)),
    pad2(Math.round(s).toString(16)),
    pad2(Math.round($).toString(16))
  ];
  return _ && _e[0].startsWith(_e[0].charAt(1)) && _e[1].startsWith(_e[1].charAt(1)) && _e[2].startsWith(_e[2].charAt(1)) ? _e[0].charAt(0) + _e[1].charAt(0) + _e[2].charAt(0) : _e.join("");
}
function rgbaToHex(a, s, $, _, _e) {
  var tt = [
    pad2(Math.round(a).toString(16)),
    pad2(Math.round(s).toString(16)),
    pad2(Math.round($).toString(16)),
    pad2(convertDecimalToHex(_))
  ];
  return _e && tt[0].startsWith(tt[0].charAt(1)) && tt[1].startsWith(tt[1].charAt(1)) && tt[2].startsWith(tt[2].charAt(1)) && tt[3].startsWith(tt[3].charAt(1)) ? tt[0].charAt(0) + tt[1].charAt(0) + tt[2].charAt(0) + tt[3].charAt(0) : tt.join("");
}
function convertDecimalToHex(a) {
  return Math.round(parseFloat(a) * 255).toString(16);
}
function convertHexToDecimal(a) {
  return parseIntFromHex(a) / 255;
}
function parseIntFromHex(a) {
  return parseInt(a, 16);
}
function numberInputToObject(a) {
  return {
    r: a >> 16,
    g: (a & 65280) >> 8,
    b: a & 255
  };
}
var names = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function inputToRGB(a) {
  var s = { r: 0, g: 0, b: 0 }, $ = 1, _ = null, _e = null, tt = null, nt = !1, at = !1;
  return typeof a == "string" && (a = stringInputToObject(a)), typeof a == "object" && (isValidCSSUnit(a.r) && isValidCSSUnit(a.g) && isValidCSSUnit(a.b) ? (s = rgbToRgb(a.r, a.g, a.b), nt = !0, at = String(a.r).substr(-1) === "%" ? "prgb" : "rgb") : isValidCSSUnit(a.h) && isValidCSSUnit(a.s) && isValidCSSUnit(a.v) ? (_ = convertToPercentage(a.s), _e = convertToPercentage(a.v), s = hsvToRgb(a.h, _, _e), nt = !0, at = "hsv") : isValidCSSUnit(a.h) && isValidCSSUnit(a.s) && isValidCSSUnit(a.l) && (_ = convertToPercentage(a.s), tt = convertToPercentage(a.l), s = hslToRgb(a.h, _, tt), nt = !0, at = "hsl"), Object.prototype.hasOwnProperty.call(a, "a") && ($ = a.a)), $ = boundAlpha($), {
    ok: nt,
    format: a.format || at,
    r: Math.min(255, Math.max(s.r, 0)),
    g: Math.min(255, Math.max(s.g, 0)),
    b: Math.min(255, Math.max(s.b, 0)),
    a: $
  };
}
var CSS_INTEGER = "[-\\+]?\\d+%?", CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?", CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")"), PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?"), PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?"), matchers = {
  CSS_UNIT: new RegExp(CSS_UNIT),
  rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
  rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
  hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
  hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
  hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
  hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function stringInputToObject(a) {
  if (a = a.trim().toLowerCase(), a.length === 0)
    return !1;
  var s = !1;
  if (names[a])
    a = names[a], s = !0;
  else if (a === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var $ = matchers.rgb.exec(a);
  return $ ? { r: $[1], g: $[2], b: $[3] } : ($ = matchers.rgba.exec(a), $ ? { r: $[1], g: $[2], b: $[3], a: $[4] } : ($ = matchers.hsl.exec(a), $ ? { h: $[1], s: $[2], l: $[3] } : ($ = matchers.hsla.exec(a), $ ? { h: $[1], s: $[2], l: $[3], a: $[4] } : ($ = matchers.hsv.exec(a), $ ? { h: $[1], s: $[2], v: $[3] } : ($ = matchers.hsva.exec(a), $ ? { h: $[1], s: $[2], v: $[3], a: $[4] } : ($ = matchers.hex8.exec(a), $ ? {
    r: parseIntFromHex($[1]),
    g: parseIntFromHex($[2]),
    b: parseIntFromHex($[3]),
    a: convertHexToDecimal($[4]),
    format: s ? "name" : "hex8"
  } : ($ = matchers.hex6.exec(a), $ ? {
    r: parseIntFromHex($[1]),
    g: parseIntFromHex($[2]),
    b: parseIntFromHex($[3]),
    format: s ? "name" : "hex"
  } : ($ = matchers.hex4.exec(a), $ ? {
    r: parseIntFromHex($[1] + $[1]),
    g: parseIntFromHex($[2] + $[2]),
    b: parseIntFromHex($[3] + $[3]),
    a: convertHexToDecimal($[4] + $[4]),
    format: s ? "name" : "hex8"
  } : ($ = matchers.hex3.exec(a), $ ? {
    r: parseIntFromHex($[1] + $[1]),
    g: parseIntFromHex($[2] + $[2]),
    b: parseIntFromHex($[3] + $[3]),
    format: s ? "name" : "hex"
  } : !1)))))))));
}
function isValidCSSUnit(a) {
  return !!matchers.CSS_UNIT.exec(String(a));
}
var TinyColor = (
  /** @class */
  function() {
    function a(s, $) {
      s === void 0 && (s = ""), $ === void 0 && ($ = {});
      var _;
      if (s instanceof a)
        return s;
      typeof s == "number" && (s = numberInputToObject(s)), this.originalInput = s;
      var _e = inputToRGB(s);
      this.originalInput = s, this.r = _e.r, this.g = _e.g, this.b = _e.b, this.a = _e.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (_ = $.format) !== null && _ !== void 0 ? _ : _e.format, this.gradientType = $.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = _e.ok;
    }
    return a.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, a.prototype.isLight = function() {
      return !this.isDark();
    }, a.prototype.getBrightness = function() {
      var s = this.toRgb();
      return (s.r * 299 + s.g * 587 + s.b * 114) / 1e3;
    }, a.prototype.getLuminance = function() {
      var s = this.toRgb(), $, _, _e, tt = s.r / 255, nt = s.g / 255, at = s.b / 255;
      return tt <= 0.03928 ? $ = tt / 12.92 : $ = Math.pow((tt + 0.055) / 1.055, 2.4), nt <= 0.03928 ? _ = nt / 12.92 : _ = Math.pow((nt + 0.055) / 1.055, 2.4), at <= 0.03928 ? _e = at / 12.92 : _e = Math.pow((at + 0.055) / 1.055, 2.4), 0.2126 * $ + 0.7152 * _ + 0.0722 * _e;
    }, a.prototype.getAlpha = function() {
      return this.a;
    }, a.prototype.setAlpha = function(s) {
      return this.a = boundAlpha(s), this.roundA = Math.round(100 * this.a) / 100, this;
    }, a.prototype.isMonochrome = function() {
      var s = this.toHsl().s;
      return s === 0;
    }, a.prototype.toHsv = function() {
      var s = rgbToHsv(this.r, this.g, this.b);
      return { h: s.h * 360, s: s.s, v: s.v, a: this.a };
    }, a.prototype.toHsvString = function() {
      var s = rgbToHsv(this.r, this.g, this.b), $ = Math.round(s.h * 360), _ = Math.round(s.s * 100), _e = Math.round(s.v * 100);
      return this.a === 1 ? "hsv(".concat($, ", ").concat(_, "%, ").concat(_e, "%)") : "hsva(".concat($, ", ").concat(_, "%, ").concat(_e, "%, ").concat(this.roundA, ")");
    }, a.prototype.toHsl = function() {
      var s = rgbToHsl(this.r, this.g, this.b);
      return { h: s.h * 360, s: s.s, l: s.l, a: this.a };
    }, a.prototype.toHslString = function() {
      var s = rgbToHsl(this.r, this.g, this.b), $ = Math.round(s.h * 360), _ = Math.round(s.s * 100), _e = Math.round(s.l * 100);
      return this.a === 1 ? "hsl(".concat($, ", ").concat(_, "%, ").concat(_e, "%)") : "hsla(".concat($, ", ").concat(_, "%, ").concat(_e, "%, ").concat(this.roundA, ")");
    }, a.prototype.toHex = function(s) {
      return s === void 0 && (s = !1), rgbToHex(this.r, this.g, this.b, s);
    }, a.prototype.toHexString = function(s) {
      return s === void 0 && (s = !1), "#" + this.toHex(s);
    }, a.prototype.toHex8 = function(s) {
      return s === void 0 && (s = !1), rgbaToHex(this.r, this.g, this.b, this.a, s);
    }, a.prototype.toHex8String = function(s) {
      return s === void 0 && (s = !1), "#" + this.toHex8(s);
    }, a.prototype.toHexShortString = function(s) {
      return s === void 0 && (s = !1), this.a === 1 ? this.toHexString(s) : this.toHex8String(s);
    }, a.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, a.prototype.toRgbString = function() {
      var s = Math.round(this.r), $ = Math.round(this.g), _ = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(s, ", ").concat($, ", ").concat(_, ")") : "rgba(".concat(s, ", ").concat($, ", ").concat(_, ", ").concat(this.roundA, ")");
    }, a.prototype.toPercentageRgb = function() {
      var s = function($) {
        return "".concat(Math.round(bound01($, 255) * 100), "%");
      };
      return {
        r: s(this.r),
        g: s(this.g),
        b: s(this.b),
        a: this.a
      };
    }, a.prototype.toPercentageRgbString = function() {
      var s = function($) {
        return Math.round(bound01($, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(s(this.r), "%, ").concat(s(this.g), "%, ").concat(s(this.b), "%)") : "rgba(".concat(s(this.r), "%, ").concat(s(this.g), "%, ").concat(s(this.b), "%, ").concat(this.roundA, ")");
    }, a.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var s = "#" + rgbToHex(this.r, this.g, this.b, !1), $ = 0, _ = Object.entries(names); $ < _.length; $++) {
        var _e = _[$], tt = _e[0], nt = _e[1];
        if (s === nt)
          return tt;
      }
      return !1;
    }, a.prototype.toString = function(s) {
      var $ = !!s;
      s = s ?? this.format;
      var _ = !1, _e = this.a < 1 && this.a >= 0, tt = !$ && _e && (s.startsWith("hex") || s === "name");
      return tt ? s === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (s === "rgb" && (_ = this.toRgbString()), s === "prgb" && (_ = this.toPercentageRgbString()), (s === "hex" || s === "hex6") && (_ = this.toHexString()), s === "hex3" && (_ = this.toHexString(!0)), s === "hex4" && (_ = this.toHex8String(!0)), s === "hex8" && (_ = this.toHex8String()), s === "name" && (_ = this.toName()), s === "hsl" && (_ = this.toHslString()), s === "hsv" && (_ = this.toHsvString()), _ || this.toHexString());
    }, a.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, a.prototype.clone = function() {
      return new a(this.toString());
    }, a.prototype.lighten = function(s) {
      s === void 0 && (s = 10);
      var $ = this.toHsl();
      return $.l += s / 100, $.l = clamp01($.l), new a($);
    }, a.prototype.brighten = function(s) {
      s === void 0 && (s = 10);
      var $ = this.toRgb();
      return $.r = Math.max(0, Math.min(255, $.r - Math.round(255 * -(s / 100)))), $.g = Math.max(0, Math.min(255, $.g - Math.round(255 * -(s / 100)))), $.b = Math.max(0, Math.min(255, $.b - Math.round(255 * -(s / 100)))), new a($);
    }, a.prototype.darken = function(s) {
      s === void 0 && (s = 10);
      var $ = this.toHsl();
      return $.l -= s / 100, $.l = clamp01($.l), new a($);
    }, a.prototype.tint = function(s) {
      return s === void 0 && (s = 10), this.mix("white", s);
    }, a.prototype.shade = function(s) {
      return s === void 0 && (s = 10), this.mix("black", s);
    }, a.prototype.desaturate = function(s) {
      s === void 0 && (s = 10);
      var $ = this.toHsl();
      return $.s -= s / 100, $.s = clamp01($.s), new a($);
    }, a.prototype.saturate = function(s) {
      s === void 0 && (s = 10);
      var $ = this.toHsl();
      return $.s += s / 100, $.s = clamp01($.s), new a($);
    }, a.prototype.greyscale = function() {
      return this.desaturate(100);
    }, a.prototype.spin = function(s) {
      var $ = this.toHsl(), _ = ($.h + s) % 360;
      return $.h = _ < 0 ? 360 + _ : _, new a($);
    }, a.prototype.mix = function(s, $) {
      $ === void 0 && ($ = 50);
      var _ = this.toRgb(), _e = new a(s).toRgb(), tt = $ / 100, nt = {
        r: (_e.r - _.r) * tt + _.r,
        g: (_e.g - _.g) * tt + _.g,
        b: (_e.b - _.b) * tt + _.b,
        a: (_e.a - _.a) * tt + _.a
      };
      return new a(nt);
    }, a.prototype.analogous = function(s, $) {
      s === void 0 && (s = 6), $ === void 0 && ($ = 30);
      var _ = this.toHsl(), _e = 360 / $, tt = [this];
      for (_.h = (_.h - (_e * s >> 1) + 720) % 360; --s; )
        _.h = (_.h + _e) % 360, tt.push(new a(_));
      return tt;
    }, a.prototype.complement = function() {
      var s = this.toHsl();
      return s.h = (s.h + 180) % 360, new a(s);
    }, a.prototype.monochromatic = function(s) {
      s === void 0 && (s = 6);
      for (var $ = this.toHsv(), _ = $.h, _e = $.s, tt = $.v, nt = [], at = 1 / s; s--; )
        nt.push(new a({ h: _, s: _e, v: tt })), tt = (tt + at) % 1;
      return nt;
    }, a.prototype.splitcomplement = function() {
      var s = this.toHsl(), $ = s.h;
      return [
        this,
        new a({ h: ($ + 72) % 360, s: s.s, l: s.l }),
        new a({ h: ($ + 216) % 360, s: s.s, l: s.l })
      ];
    }, a.prototype.onBackground = function(s) {
      var $ = this.toRgb(), _ = new a(s).toRgb(), _e = $.a + _.a * (1 - $.a);
      return new a({
        r: ($.r * $.a + _.r * _.a * (1 - $.a)) / _e,
        g: ($.g * $.a + _.g * _.a * (1 - $.a)) / _e,
        b: ($.b * $.a + _.b * _.a * (1 - $.a)) / _e,
        a: _e
      });
    }, a.prototype.triad = function() {
      return this.polyad(3);
    }, a.prototype.tetrad = function() {
      return this.polyad(4);
    }, a.prototype.polyad = function(s) {
      for (var $ = this.toHsl(), _ = $.h, _e = [this], tt = 360 / s, nt = 1; nt < s; nt++)
        _e.push(new a({ h: (_ + nt * tt) % 360, s: $.s, l: $.l }));
      return _e;
    }, a.prototype.equals = function(s) {
      return this.toRgbString() === new a(s).toRgbString();
    }, a;
  }()
), hueStep$1 = 2, saturationStep$1 = 0.16, saturationStep2$1 = 0.05, brightnessStep1$1 = 0.05, brightnessStep2$1 = 0.15, lightColorCount$1 = 5, darkColorCount$1 = 4, darkColorMap$1 = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function toHsv$1(a) {
  var s = a.r, $ = a.g, _ = a.b, _e = rgbToHsv(s, $, _);
  return {
    h: _e.h * 360,
    s: _e.s,
    v: _e.v
  };
}
function toHex$1(a) {
  var s = a.r, $ = a.g, _ = a.b;
  return "#".concat(rgbToHex(s, $, _, !1));
}
function mix$2(a, s, $) {
  var _ = $ / 100, _e = {
    r: (s.r - a.r) * _ + a.r,
    g: (s.g - a.g) * _ + a.g,
    b: (s.b - a.b) * _ + a.b
  };
  return _e;
}
function getHue$1(a, s, $) {
  var _;
  return Math.round(a.h) >= 60 && Math.round(a.h) <= 240 ? _ = $ ? Math.round(a.h) - hueStep$1 * s : Math.round(a.h) + hueStep$1 * s : _ = $ ? Math.round(a.h) + hueStep$1 * s : Math.round(a.h) - hueStep$1 * s, _ < 0 ? _ += 360 : _ >= 360 && (_ -= 360), _;
}
function getSaturation$1(a, s, $) {
  if (a.h === 0 && a.s === 0)
    return a.s;
  var _;
  return $ ? _ = a.s - saturationStep$1 * s : s === darkColorCount$1 ? _ = a.s + saturationStep$1 : _ = a.s + saturationStep2$1 * s, _ > 1 && (_ = 1), $ && s === lightColorCount$1 && _ > 0.1 && (_ = 0.1), _ < 0.06 && (_ = 0.06), Number(_.toFixed(2));
}
function getValue$4(a, s, $) {
  var _;
  return $ ? _ = a.v + brightnessStep1$1 * s : _ = a.v - brightnessStep2$1 * s, _ > 1 && (_ = 1), Number(_.toFixed(2));
}
function generate$2(a) {
  for (var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, $ = [], _ = inputToRGB(a), _e = lightColorCount$1; _e > 0; _e -= 1) {
    var tt = toHsv$1(_), nt = toHex$1(inputToRGB({
      h: getHue$1(tt, _e, !0),
      s: getSaturation$1(tt, _e, !0),
      v: getValue$4(tt, _e, !0)
    }));
    $.push(nt);
  }
  $.push(toHex$1(_));
  for (var at = 1; at <= darkColorCount$1; at += 1) {
    var ot = toHsv$1(_), rt = toHex$1(inputToRGB({
      h: getHue$1(ot, at),
      s: getSaturation$1(ot, at),
      v: getValue$4(ot, at)
    }));
    $.push(rt);
  }
  return s.theme === "dark" ? darkColorMap$1.map(function(st) {
    var lt = st.index, et = st.opacity, it = toHex$1(mix$2(inputToRGB(s.backgroundColor || "#141414"), inputToRGB($[lt]), et * 100));
    return it;
  }) : $;
}
var presetPrimaryColors$1 = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, presetPalettes$1 = {}, presetDarkPalettes$1 = {};
Object.keys(presetPrimaryColors$1).forEach(function(a) {
  presetPalettes$1[a] = generate$2(presetPrimaryColors$1[a]), presetPalettes$1[a].primary = presetPalettes$1[a][5], presetDarkPalettes$1[a] = generate$2(presetPrimaryColors$1[a], {
    theme: "dark",
    backgroundColor: "#141414"
  }), presetDarkPalettes$1[a].primary = presetDarkPalettes$1[a][5];
});
var gold$1 = presetPalettes$1.gold, blue$1 = presetPalettes$1.blue;
const genControlHeight = (a) => {
  const {
    controlHeight: s
  } = a;
  return {
    controlHeightSM: s * 0.75,
    controlHeightXS: s * 0.5,
    controlHeightLG: s * 1.25
  };
}, genControlHeight$1 = genControlHeight;
function genSizeMapToken$1(a) {
  const {
    sizeUnit: s,
    sizeStep: $
  } = a;
  return {
    sizeXXL: s * ($ + 8),
    // 48
    sizeXL: s * ($ + 4),
    // 32
    sizeLG: s * ($ + 2),
    // 24
    sizeMD: s * ($ + 1),
    // 20
    sizeMS: s * $,
    // 16
    size: s * $,
    // 16
    sizeSM: s * ($ - 1),
    // 12
    sizeXS: s * ($ - 2),
    // 8
    sizeXXS: s * ($ - 3)
    // 4
  };
}
const defaultPresetColors = {
  blue: "#1677ff",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  pink: "#eb2f96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, seedToken = Object.assign(Object.assign({}, defaultPresetColors), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
});
function genColorMapToken(a, s) {
  let {
    generateColorPalettes: $,
    generateNeutralColorPalettes: _
  } = s;
  const {
    colorSuccess: _e,
    colorWarning: tt,
    colorError: nt,
    colorInfo: at,
    colorPrimary: ot,
    colorBgBase: rt,
    colorTextBase: st
  } = a, lt = $(ot), et = $(_e), it = $(tt), ut = $(nt), ft = $(at), ht = _(rt, st), dt = a.colorLink || a.colorInfo, gt = $(dt);
  return Object.assign(Object.assign({}, ht), {
    colorPrimaryBg: lt[1],
    colorPrimaryBgHover: lt[2],
    colorPrimaryBorder: lt[3],
    colorPrimaryBorderHover: lt[4],
    colorPrimaryHover: lt[5],
    colorPrimary: lt[6],
    colorPrimaryActive: lt[7],
    colorPrimaryTextHover: lt[8],
    colorPrimaryText: lt[9],
    colorPrimaryTextActive: lt[10],
    colorSuccessBg: et[1],
    colorSuccessBgHover: et[2],
    colorSuccessBorder: et[3],
    colorSuccessBorderHover: et[4],
    colorSuccessHover: et[4],
    colorSuccess: et[6],
    colorSuccessActive: et[7],
    colorSuccessTextHover: et[8],
    colorSuccessText: et[9],
    colorSuccessTextActive: et[10],
    colorErrorBg: ut[1],
    colorErrorBgHover: ut[2],
    colorErrorBorder: ut[3],
    colorErrorBorderHover: ut[4],
    colorErrorHover: ut[5],
    colorError: ut[6],
    colorErrorActive: ut[7],
    colorErrorTextHover: ut[8],
    colorErrorText: ut[9],
    colorErrorTextActive: ut[10],
    colorWarningBg: it[1],
    colorWarningBgHover: it[2],
    colorWarningBorder: it[3],
    colorWarningBorderHover: it[4],
    colorWarningHover: it[4],
    colorWarning: it[6],
    colorWarningActive: it[7],
    colorWarningTextHover: it[8],
    colorWarningText: it[9],
    colorWarningTextActive: it[10],
    colorInfoBg: ft[1],
    colorInfoBgHover: ft[2],
    colorInfoBorder: ft[3],
    colorInfoBorderHover: ft[4],
    colorInfoHover: ft[4],
    colorInfo: ft[6],
    colorInfoActive: ft[7],
    colorInfoTextHover: ft[8],
    colorInfoText: ft[9],
    colorInfoTextActive: ft[10],
    colorLinkHover: gt[4],
    colorLink: gt[6],
    colorLinkActive: gt[7],
    colorBgMask: new TinyColor("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const genRadius = (a) => {
  let s = a, $ = a, _ = a, _e = a;
  return a < 6 && a >= 5 ? s = a + 1 : a < 16 && a >= 6 ? s = a + 2 : a >= 16 && (s = 16), a < 7 && a >= 5 ? $ = 4 : a < 8 && a >= 7 ? $ = 5 : a < 14 && a >= 8 ? $ = 6 : a < 16 && a >= 14 ? $ = 7 : a >= 16 && ($ = 8), a < 6 && a >= 2 ? _ = 1 : a >= 6 && (_ = 2), a > 4 && a < 8 ? _e = 4 : a >= 8 && (_e = 6), {
    borderRadius: a,
    borderRadiusXS: _,
    borderRadiusSM: $,
    borderRadiusLG: s,
    borderRadiusOuter: _e
  };
}, genRadius$1 = genRadius;
function genCommonMapToken(a) {
  const {
    motionUnit: s,
    motionBase: $,
    borderRadius: _,
    lineWidth: _e
  } = a;
  return Object.assign({
    // motion
    motionDurationFast: `${($ + s).toFixed(1)}s`,
    motionDurationMid: `${($ + s * 2).toFixed(1)}s`,
    motionDurationSlow: `${($ + s * 3).toFixed(1)}s`,
    // line
    lineWidthBold: _e + 1
  }, genRadius$1(_));
}
const getAlphaColor$2 = (a, s) => new TinyColor(a).setAlpha(s).toRgbString(), getSolidColor$1 = (a, s) => new TinyColor(a).darken(s).toHexString(), generateColorPalettes$1 = (a) => {
  const s = generate$2(a);
  return {
    1: s[0],
    2: s[1],
    3: s[2],
    4: s[3],
    5: s[4],
    6: s[5],
    7: s[6],
    8: s[4],
    9: s[5],
    10: s[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, generateNeutralColorPalettes$1 = (a, s) => {
  const $ = a || "#fff", _ = s || "#000";
  return {
    colorBgBase: $,
    colorTextBase: _,
    colorText: getAlphaColor$2(_, 0.88),
    colorTextSecondary: getAlphaColor$2(_, 0.65),
    colorTextTertiary: getAlphaColor$2(_, 0.45),
    colorTextQuaternary: getAlphaColor$2(_, 0.25),
    colorFill: getAlphaColor$2(_, 0.15),
    colorFillSecondary: getAlphaColor$2(_, 0.06),
    colorFillTertiary: getAlphaColor$2(_, 0.04),
    colorFillQuaternary: getAlphaColor$2(_, 0.02),
    colorBgLayout: getSolidColor$1($, 4),
    colorBgContainer: getSolidColor$1($, 0),
    colorBgElevated: getSolidColor$1($, 0),
    colorBgSpotlight: getAlphaColor$2(_, 0.85),
    colorBgBlur: "transparent",
    colorBorder: getSolidColor$1($, 15),
    colorBorderSecondary: getSolidColor$1($, 6)
  };
};
function getFontSizes(a) {
  const s = new Array(10).fill(null).map(($, _) => {
    const _e = _ - 1, tt = a * Math.pow(2.71828, _e / 5), nt = _ > 1 ? Math.floor(tt) : Math.ceil(tt);
    return Math.floor(nt / 2) * 2;
  });
  return s[1] = a, s.map(($) => {
    const _ = $ + 8;
    return {
      size: $,
      lineHeight: _ / $
    };
  });
}
const genFontMapToken = (a) => {
  const s = getFontSizes(a), $ = s.map((st) => st.size), _ = s.map((st) => st.lineHeight), _e = $[1], tt = $[0], nt = $[2], at = _[1], ot = _[0], rt = _[2];
  return {
    fontSizeSM: tt,
    fontSize: _e,
    fontSizeLG: nt,
    fontSizeXL: $[3],
    fontSizeHeading1: $[6],
    fontSizeHeading2: $[5],
    fontSizeHeading3: $[4],
    fontSizeHeading4: $[3],
    fontSizeHeading5: $[2],
    lineHeight: at,
    lineHeightLG: rt,
    lineHeightSM: ot,
    fontHeight: Math.round(at * _e),
    fontHeightLG: Math.round(rt * nt),
    fontHeightSM: Math.round(ot * tt),
    lineHeightHeading1: _[6],
    lineHeightHeading2: _[5],
    lineHeightHeading3: _[4],
    lineHeightHeading4: _[3],
    lineHeightHeading5: _[2]
  };
}, genFontMapToken$1 = genFontMapToken;
function derivative$2(a) {
  const s = Object.keys(defaultPresetColors).map(($) => {
    const _ = generate$2(a[$]);
    return new Array(10).fill(1).reduce((_e, tt, nt) => (_e[`${$}-${nt + 1}`] = _[nt], _e[`${$}${nt + 1}`] = _[nt], _e), {});
  }).reduce(($, _) => ($ = Object.assign(Object.assign({}, $), _), $), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, a), s), genColorMapToken(a, {
    generateColorPalettes: generateColorPalettes$1,
    generateNeutralColorPalettes: generateNeutralColorPalettes$1
  })), genFontMapToken$1(a.fontSize)), genSizeMapToken$1(a)), genControlHeight$1(a)), genCommonMapToken(a));
}
const defaultTheme$1 = createTheme(derivative$2), defaultConfig = {
  token: seedToken,
  override: {
    override: seedToken
  },
  hashed: !0
}, DesignTokenContext = /* @__PURE__ */ React$a.createContext(defaultConfig), defaultIconPrefixCls = "anticon", defaultGetPrefixCls = (a, s) => s || (a ? `ant-${a}` : "ant"), ConfigContext$1 = /* @__PURE__ */ reactExports.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls,
  iconPrefixCls: defaultIconPrefixCls
}), dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function getStyle$2(a, s) {
  const $ = {}, _ = (nt, at) => {
    let ot = nt.clone();
    return ot = (at == null ? void 0 : at(ot)) || ot, ot.toRgbString();
  }, _e = (nt, at) => {
    const ot = new TinyColor(nt), rt = generate$2(ot.toRgbString());
    $[`${at}-color`] = _(ot), $[`${at}-color-disabled`] = rt[1], $[`${at}-color-hover`] = rt[4], $[`${at}-color-active`] = rt[6], $[`${at}-color-outline`] = ot.clone().setAlpha(0.2).toRgbString(), $[`${at}-color-deprecated-bg`] = rt[0], $[`${at}-color-deprecated-border`] = rt[2];
  };
  if (s.primaryColor) {
    _e(s.primaryColor, "primary");
    const nt = new TinyColor(s.primaryColor), at = generate$2(nt.toRgbString());
    at.forEach((rt, st) => {
      $[`primary-${st + 1}`] = rt;
    }), $["primary-color-deprecated-l-35"] = _(nt, (rt) => rt.lighten(35)), $["primary-color-deprecated-l-20"] = _(nt, (rt) => rt.lighten(20)), $["primary-color-deprecated-t-20"] = _(nt, (rt) => rt.tint(20)), $["primary-color-deprecated-t-50"] = _(nt, (rt) => rt.tint(50)), $["primary-color-deprecated-f-12"] = _(nt, (rt) => rt.setAlpha(rt.getAlpha() * 0.12));
    const ot = new TinyColor(at[0]);
    $["primary-color-active-deprecated-f-30"] = _(ot, (rt) => rt.setAlpha(rt.getAlpha() * 0.3)), $["primary-color-active-deprecated-d-02"] = _(ot, (rt) => rt.darken(2));
  }
  return s.successColor && _e(s.successColor, "success"), s.warningColor && _e(s.warningColor, "warning"), s.errorColor && _e(s.errorColor, "error"), s.infoColor && _e(s.infoColor, "info"), `
  :root {
    ${Object.keys($).map((nt) => `--${a}-${nt}: ${$[nt]};`).join(`
`)}
  }
  `.trim();
}
function registerTheme(a, s) {
  const $ = getStyle$2(a, s);
  canUseDom$1() && updateCSS($, `${dynamicStyleMark}-dynamic-theme`);
}
const DisabledContext = /* @__PURE__ */ reactExports.createContext(!1), DisabledContextProvider = (a) => {
  let {
    children: s,
    disabled: $
  } = a;
  const _ = reactExports.useContext(DisabledContext);
  return /* @__PURE__ */ reactExports.createElement(DisabledContext.Provider, {
    value: $ ?? _
  }, s);
}, DisabledContext$1 = DisabledContext, SizeContext = /* @__PURE__ */ reactExports.createContext(void 0), SizeContextProvider = (a) => {
  let {
    children: s,
    size: $
  } = a;
  const _ = reactExports.useContext(SizeContext);
  return /* @__PURE__ */ reactExports.createElement(SizeContext.Provider, {
    value: $ || _
  }, s);
}, SizeContext$1 = SizeContext;
function useConfig() {
  const a = reactExports.useContext(DisabledContext$1), s = reactExports.useContext(SizeContext$1);
  return {
    componentDisabled: a,
    componentSize: s
  };
}
const PresetColors = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], version$1 = "5.12.5";
function isStableColor(a) {
  return a >= 0 && a <= 255;
}
function getAlphaColor$1(a, s) {
  const {
    r: $,
    g: _,
    b: _e,
    a: tt
  } = new TinyColor(a).toRgb();
  if (tt < 1)
    return a;
  const {
    r: nt,
    g: at,
    b: ot
  } = new TinyColor(s).toRgb();
  for (let rt = 0.01; rt <= 1; rt += 0.01) {
    const st = Math.round(($ - nt * (1 - rt)) / rt), lt = Math.round((_ - at * (1 - rt)) / rt), et = Math.round((_e - ot * (1 - rt)) / rt);
    if (isStableColor(st) && isStableColor(lt) && isStableColor(et))
      return new TinyColor({
        r: st,
        g: lt,
        b: et,
        a: Math.round(rt * 100) / 100
      }).toRgbString();
  }
  return new TinyColor({
    r: $,
    g: _,
    b: _e,
    a: 1
  }).toRgbString();
}
var __rest$13 = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function formatToken(a) {
  const {
    override: s
  } = a, $ = __rest$13(a, ["override"]), _ = Object.assign({}, s);
  Object.keys(seedToken).forEach((et) => {
    delete _[et];
  });
  const _e = Object.assign(Object.assign({}, $), _), tt = 480, nt = 576, at = 768, ot = 992, rt = 1200, st = 1600;
  if (_e.motion === !1) {
    const et = "0s";
    _e.motionDurationFast = et, _e.motionDurationMid = et, _e.motionDurationSlow = et;
  }
  return Object.assign(Object.assign(Object.assign({}, _e), {
    // ============== Background ============== //
    colorFillContent: _e.colorFillSecondary,
    colorFillContentHover: _e.colorFill,
    colorFillAlter: _e.colorFillQuaternary,
    colorBgContainerDisabled: _e.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: _e.colorBgContainer,
    colorSplit: getAlphaColor$1(_e.colorBorderSecondary, _e.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: _e.colorTextQuaternary,
    colorTextDisabled: _e.colorTextQuaternary,
    colorTextHeading: _e.colorText,
    colorTextLabel: _e.colorTextSecondary,
    colorTextDescription: _e.colorTextTertiary,
    colorTextLightSolid: _e.colorWhite,
    colorHighlight: _e.colorError,
    colorBgTextHover: _e.colorFillSecondary,
    colorBgTextActive: _e.colorFill,
    colorIcon: _e.colorTextTertiary,
    colorIconHover: _e.colorText,
    colorErrorOutline: getAlphaColor$1(_e.colorErrorBg, _e.colorBgContainer),
    colorWarningOutline: getAlphaColor$1(_e.colorWarningBg, _e.colorBgContainer),
    // Font
    fontSizeIcon: _e.fontSizeSM,
    // Line
    lineWidthFocus: _e.lineWidth * 4,
    // Control
    lineWidth: _e.lineWidth,
    controlOutlineWidth: _e.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: _e.controlHeight / 2,
    controlItemBgHover: _e.colorFillTertiary,
    controlItemBgActive: _e.colorPrimaryBg,
    controlItemBgActiveHover: _e.colorPrimaryBgHover,
    controlItemBgActiveDisabled: _e.colorFill,
    controlTmpOutline: _e.colorFillQuaternary,
    controlOutline: getAlphaColor$1(_e.colorPrimaryBg, _e.colorBgContainer),
    lineType: _e.lineType,
    borderRadius: _e.borderRadius,
    borderRadiusXS: _e.borderRadiusXS,
    borderRadiusSM: _e.borderRadiusSM,
    borderRadiusLG: _e.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: _e.sizeXXS,
    paddingXS: _e.sizeXS,
    paddingSM: _e.sizeSM,
    padding: _e.size,
    paddingMD: _e.sizeMD,
    paddingLG: _e.sizeLG,
    paddingXL: _e.sizeXL,
    paddingContentHorizontalLG: _e.sizeLG,
    paddingContentVerticalLG: _e.sizeMS,
    paddingContentHorizontal: _e.sizeMS,
    paddingContentVertical: _e.sizeSM,
    paddingContentHorizontalSM: _e.size,
    paddingContentVerticalSM: _e.sizeXS,
    marginXXS: _e.sizeXXS,
    marginXS: _e.sizeXS,
    marginSM: _e.sizeSM,
    margin: _e.size,
    marginMD: _e.sizeMD,
    marginLG: _e.sizeLG,
    marginXL: _e.sizeXL,
    marginXXL: _e.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: tt,
    screenXSMin: tt,
    screenXSMax: nt - 1,
    screenSM: nt,
    screenSMMin: nt,
    screenSMMax: at - 1,
    screenMD: at,
    screenMDMin: at,
    screenMDMax: ot - 1,
    screenLG: ot,
    screenLGMin: ot,
    screenLGMax: rt - 1,
    screenXL: rt,
    screenXLMin: rt,
    screenXLMax: st - 1,
    screenXXL: st,
    screenXXLMin: st,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new TinyColor("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new TinyColor("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new TinyColor("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), _);
}
var __rest$12 = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const unitless = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0
}, ignore = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, preserve = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, getComputedToken = (a, s, $) => {
  const _ = $.getDerivativeToken(a), {
    override: _e
  } = s, tt = __rest$12(s, ["override"]);
  let nt = Object.assign(Object.assign({}, _), {
    override: _e
  });
  return nt = formatToken(nt), tt && Object.entries(tt).forEach((at) => {
    let [ot, rt] = at;
    const {
      theme: st
    } = rt, lt = __rest$12(rt, ["theme"]);
    let et = lt;
    st && (et = getComputedToken(Object.assign(Object.assign({}, nt), lt), {
      override: lt
    }, st)), nt[ot] = et;
  }), nt;
};
function useToken$1() {
  const {
    token: a,
    hashed: s,
    theme: $,
    override: _,
    cssVar: _e
  } = React$a.useContext(DesignTokenContext), tt = `${version$1}-${s || ""}`, nt = $ || defaultTheme$1, [at, ot, rt] = useCacheToken(nt, [seedToken, a], {
    salt: tt,
    override: _,
    getComputedToken,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken,
    cssVar: _e && {
      prefix: _e.prefix,
      key: _e.key,
      unitless,
      ignore,
      preserve
    }
  });
  return [nt, rt, s ? ot : "", at, _e];
}
function useEvent(a) {
  var s = reactExports.useRef();
  s.current = a;
  var $ = reactExports.useCallback(function() {
    for (var _, _e = arguments.length, tt = new Array(_e), nt = 0; nt < _e; nt++)
      tt[nt] = arguments[nt];
    return (_ = s.current) === null || _ === void 0 ? void 0 : _.call.apply(_, [s].concat(tt));
  }, []);
  return $;
}
function useSafeState(a) {
  var s = reactExports.useRef(!1), $ = reactExports.useState(a), _ = _slicedToArray$e($, 2), _e = _[0], tt = _[1];
  reactExports.useEffect(function() {
    return s.current = !1, function() {
      s.current = !0;
    };
  }, []);
  function nt(at, ot) {
    ot && s.current || tt(at);
  }
  return [_e, nt];
}
function hasValue$1(a) {
  return a !== void 0;
}
function useMergedState(a, s) {
  var $ = s || {}, _ = $.defaultValue, _e = $.value, tt = $.onChange, nt = $.postState, at = useSafeState(function() {
    return hasValue$1(_e) ? _e : hasValue$1(_) ? typeof _ == "function" ? _() : _ : typeof a == "function" ? a() : a;
  }), ot = _slicedToArray$e(at, 2), rt = ot[0], st = ot[1], lt = _e !== void 0 ? _e : rt, et = nt ? nt(lt) : lt, it = useEvent(tt), ut = useSafeState([lt]), ft = _slicedToArray$e(ut, 2), ht = ft[0], dt = ft[1];
  useLayoutUpdateEffect(function() {
    var pt = ht[0];
    rt !== pt && it(rt, pt);
  }, [ht]), useLayoutUpdateEffect(function() {
    hasValue$1(_e) || st(_e);
  }, [_e]);
  var gt = useEvent(function(pt, mt) {
    st(pt, mt), dt([lt], mt);
  });
  return [et, gt];
}
const operationUnit = (a) => ({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: a.colorLink,
  textDecoration: "none",
  outline: "none",
  cursor: "pointer",
  transition: `color ${a.motionDurationSlow}`,
  "&:focus, &:hover": {
    color: a.colorLinkHover
  },
  "&:active": {
    color: a.colorLinkActive
  }
}), textEllipsis = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, resetComponent = function(a) {
  let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: a.colorText,
    fontSize: a.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: a.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: s ? "inherit" : a.fontFamily
  };
}, resetIcon = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), clearFix = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), genLinkStyle = (a) => ({
  a: {
    color: a.colorLink,
    textDecoration: a.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${a.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: a.colorLinkHover
    },
    "&:active": {
      color: a.colorLinkActive
    },
    "&:active,\n  &:hover": {
      textDecoration: a.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: a.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: a.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), genCommonStyle = (a, s) => {
  const {
    fontFamily: $,
    fontSize: _
  } = a, _e = `[class^="${s}"], [class*=" ${s}"]`;
  return {
    [_e]: {
      fontFamily: $,
      fontSize: _,
      boxSizing: "border-box",
      "&::before, &::after": {
        boxSizing: "border-box"
      },
      [_e]: {
        boxSizing: "border-box",
        "&::before, &::after": {
          boxSizing: "border-box"
        }
      }
    }
  };
}, genFocusOutline = (a) => ({
  outline: `${unit$1(a.lineWidthFocus)} solid ${a.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
}), genFocusStyle = (a) => ({
  "&:focus-visible": Object.assign({}, genFocusOutline(a))
});
let AbstractCalculator = /* @__PURE__ */ _createClass(function a() {
  _classCallCheck(this, a);
});
const AbstractCalculator$1 = AbstractCalculator;
let NumCalculator = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $(_) {
    var _e;
    return _classCallCheck(this, $), _e = s.call(this), _e.result = 0, _ instanceof $ ? _e.result = _.result : typeof _ == "number" && (_e.result = _), _e;
  }
  return _createClass($, [{
    key: "add",
    value: function(_e) {
      return _e instanceof $ ? this.result += _e.result : typeof _e == "number" && (this.result += _e), this;
    }
  }, {
    key: "sub",
    value: function(_e) {
      return _e instanceof $ ? this.result -= _e.result : typeof _e == "number" && (this.result -= _e), this;
    }
  }, {
    key: "mul",
    value: function(_e) {
      return _e instanceof $ ? this.result *= _e.result : typeof _e == "number" && (this.result *= _e), this;
    }
  }, {
    key: "div",
    value: function(_e) {
      return _e instanceof $ ? this.result /= _e.result : typeof _e == "number" && (this.result /= _e), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), $;
}(AbstractCalculator$1);
const CALC_UNIT = "CALC_UNIT";
function unit(a) {
  return typeof a == "number" ? `${a}${CALC_UNIT}` : a;
}
let CSSCalculator = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $(_) {
    var _e;
    return _classCallCheck(this, $), _e = s.call(this), _e.result = "", _ instanceof $ ? _e.result = `(${_.result})` : typeof _ == "number" ? _e.result = unit(_) : typeof _ == "string" && (_e.result = _), _e;
  }
  return _createClass($, [{
    key: "add",
    value: function(_e) {
      return _e instanceof $ ? this.result = `${this.result} + ${_e.getResult()}` : (typeof _e == "number" || typeof _e == "string") && (this.result = `${this.result} + ${unit(_e)}`), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(_e) {
      return _e instanceof $ ? this.result = `${this.result} - ${_e.getResult()}` : (typeof _e == "number" || typeof _e == "string") && (this.result = `${this.result} - ${unit(_e)}`), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(_e) {
      return this.lowPriority && (this.result = `(${this.result})`), _e instanceof $ ? this.result = `${this.result} * ${_e.getResult(!0)}` : (typeof _e == "number" || typeof _e == "string") && (this.result = `${this.result} * ${_e}`), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(_e) {
      return this.lowPriority && (this.result = `(${this.result})`), _e instanceof $ ? this.result = `${this.result} / ${_e.getResult(!0)}` : (typeof _e == "number" || typeof _e == "string") && (this.result = `${this.result} / ${_e}`), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(_e) {
      return this.lowPriority || _e ? `(${this.result})` : this.result;
    }
  }, {
    key: "equal",
    value: function(_e) {
      const {
        unit: tt = !0
      } = _e || {}, nt = new RegExp(`${CALC_UNIT}`, "g");
      return this.result = this.result.replace(nt, tt ? "px" : ""), typeof this.lowPriority < "u" ? `calc(${this.result})` : this.result;
    }
  }]), $;
}(AbstractCalculator$1);
const genCalc = (a) => {
  const s = a === "css" ? CSSCalculator : NumCalculator;
  return ($) => new s($);
}, genCalc$1 = genCalc;
function genMaxMin(a) {
  return a === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var s = arguments.length, $ = new Array(s), _ = 0; _ < s; _++)
        $[_] = arguments[_];
      return `max(${$.map((_e) => unit$1(_e)).join(",")})`;
    },
    min: function() {
      for (var s = arguments.length, $ = new Array(s), _ = 0; _ < s; _++)
        $[_] = arguments[_];
      return `min(${$.map((_e) => unit$1(_e)).join(",")})`;
    }
  };
}
const enableStatistic = typeof CSSINJS_STATISTIC < "u";
let recording = !0;
function merge() {
  for (var a = arguments.length, s = new Array(a), $ = 0; $ < a; $++)
    s[$] = arguments[$];
  if (!enableStatistic)
    return Object.assign.apply(Object, [{}].concat(s));
  recording = !1;
  const _ = {};
  return s.forEach((_e) => {
    Object.keys(_e).forEach((nt) => {
      Object.defineProperty(_, nt, {
        configurable: !0,
        enumerable: !0,
        get: () => _e[nt]
      });
    });
  }), recording = !0, _;
}
const statistic = {};
function noop$4() {
}
function statisticToken(a) {
  let s, $ = a, _ = noop$4;
  return enableStatistic && typeof Proxy < "u" && (s = /* @__PURE__ */ new Set(), $ = new Proxy(a, {
    get(_e, tt) {
      return recording && s.add(tt), _e[tt];
    }
  }), _ = (_e, tt) => {
    var nt;
    statistic[_e] = {
      global: Array.from(s),
      component: Object.assign(Object.assign({}, (nt = statistic[_e]) === null || nt === void 0 ? void 0 : nt.component), tt)
    };
  }), {
    token: $,
    keys: s,
    flush: _
  };
}
const useResetIconStyle = (a, s) => {
  const [$, _] = useToken$1();
  return useStyleRegister({
    theme: $,
    token: _,
    hashId: "",
    path: ["ant-design-icons", a],
    nonce: () => s == null ? void 0 : s.nonce
  }, () => [{
    [`.${a}`]: Object.assign(Object.assign({}, resetIcon()), {
      [`.${a} .${a}-icon`]: {
        display: "block"
      }
    })
  }]);
}, useStyle$y = useResetIconStyle, getDefaultComponentToken = (a, s, $) => {
  var _;
  return typeof $ == "function" ? $(merge(s, (_ = s[a]) !== null && _ !== void 0 ? _ : {})) : $ ?? {};
}, getComponentToken = (a, s, $, _) => {
  const _e = Object.assign({}, s[a]);
  if (_ != null && _.deprecatedTokens) {
    const {
      deprecatedTokens: nt
    } = _;
    nt.forEach((at) => {
      let [ot, rt] = at;
      var st;
      (_e != null && _e[ot] || _e != null && _e[rt]) && ((st = _e[rt]) !== null && st !== void 0 || (_e[rt] = _e == null ? void 0 : _e[ot]));
    });
  }
  let tt = Object.assign(Object.assign({}, $), _e);
  return _ != null && _.format && (tt = _.format(tt)), Object.keys(tt).forEach((nt) => {
    tt[nt] === s[nt] && delete tt[nt];
  }), tt;
}, getCompVarPrefix = (a, s) => `${[s, a.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-")}`;
function genComponentStyleHook(a, s, $) {
  let _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  const _e = Array.isArray(a) ? a : [a, a], [tt] = _e, nt = _e.join("-");
  return (at) => {
    const [ot, rt, st, lt, et] = useToken$1(), {
      getPrefixCls: it,
      iconPrefixCls: ut,
      csp: ft
    } = reactExports.useContext(ConfigContext$1), ht = it(), dt = et ? "css" : "js", gt = genCalc$1(dt), {
      max: pt,
      min: mt
    } = genMaxMin(dt), ct = {
      theme: ot,
      token: lt,
      hashId: st,
      nonce: () => ft == null ? void 0 : ft.nonce,
      clientOnly: _.clientOnly,
      // antd is always at top of styles
      order: _.order || -999
    };
    return useStyleRegister(Object.assign(Object.assign({}, ct), {
      clientOnly: !1,
      path: ["Shared", ht]
    }), () => [{
      // Link
      "&": genLinkStyle(lt)
    }]), useStyle$y(ut, ft), [useStyleRegister(Object.assign(Object.assign({}, ct), {
      path: [nt, at, ut]
    }), () => {
      if (_.injectStyle === !1)
        return [];
      const {
        token: At,
        flush: xt
      } = statisticToken(lt), bt = getDefaultComponentToken(tt, rt, $), Et = `.${at}`, St = getComponentToken(tt, rt, bt, {
        deprecatedTokens: _.deprecatedTokens,
        format: _.format
      });
      et && Object.keys(bt).forEach((Pt) => {
        bt[Pt] = `var(${token2CSSVar(Pt, getCompVarPrefix(tt, et.prefix))})`;
      });
      const Bt = merge(At, {
        componentCls: Et,
        prefixCls: at,
        iconCls: `.${ut}`,
        antCls: `.${ht}`,
        calc: gt,
        max: pt,
        min: mt
      }, et ? bt : St), Ot = s(Bt, {
        hashId: st,
        prefixCls: at,
        rootPrefixCls: ht,
        iconPrefixCls: ut
      });
      return xt(tt, St), [_.resetStyle === !1 ? null : genCommonStyle(Bt, at), Ot];
    }), st];
  };
}
const genSubStyleComponent = (a, s, $, _) => {
  const _e = genComponentStyleHook(a, s, $, Object.assign({
    resetStyle: !1,
    // Sub Style should default after root one
    order: -998
  }, _));
  return (nt) => {
    let {
      prefixCls: at
    } = nt;
    return _e(at), null;
  };
}, genCSSVarRegister = (a, s, $) => {
  function _(rt) {
    return `${a}${rt.slice(0, 1).toUpperCase()}${rt.slice(1)}`;
  }
  const {
    unitless: _e = {},
    injectStyle: tt = !0
  } = $ ?? {}, nt = {
    [_("zIndexPopup")]: !0
  };
  Object.keys(_e).forEach((rt) => {
    nt[_(rt)] = _e[rt];
  });
  const at = (rt) => {
    let {
      rootCls: st,
      cssVar: lt
    } = rt;
    const [, et] = useToken$1();
    return useCSSVarRegister({
      path: [a],
      prefix: lt.prefix,
      key: lt == null ? void 0 : lt.key,
      unitless: Object.assign(Object.assign({}, unitless), nt),
      ignore,
      token: et,
      scope: st
    }, () => {
      const it = getDefaultComponentToken(a, et, s), ut = getComponentToken(a, et, it, {
        format: $ == null ? void 0 : $.format,
        deprecatedTokens: $ == null ? void 0 : $.deprecatedTokens
      });
      return Object.keys(it).forEach((ft) => {
        ut[_(ft)] = ut[ft], delete ut[ft];
      }), ut;
    }), null;
  };
  return (rt) => {
    const [, , , , st] = useToken$1();
    return [(lt) => tt && st ? /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(at, {
      rootCls: rt,
      cssVar: st,
      component: a
    }), lt) : lt, st == null ? void 0 : st.key];
  };
}, genStyleHooks = (a, s, $, _) => {
  const _e = genComponentStyleHook(a, s, $, _), tt = genCSSVarRegister(Array.isArray(a) ? a[0] : a, $, _);
  return function(nt) {
    let at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : nt;
    const [, ot] = _e(nt), [rt, st] = tt(at);
    return [rt, ot, st];
  };
};
function genPresetColor(a, s) {
  return PresetColors.reduce(($, _) => {
    const _e = a[`${_}1`], tt = a[`${_}3`], nt = a[`${_}6`], at = a[`${_}7`];
    return Object.assign(Object.assign({}, $), s(_, {
      lightColor: _e,
      lightBorderColor: tt,
      darkColor: nt,
      textColor: at
    }));
  }, {});
}
const fullClone$1 = Object.assign({}, React$b), {
  useId: useId$3
} = fullClone$1, useEmptyId = () => "", useThemeKey = typeof useId$3 > "u" ? useEmptyId : useId$3, useThemeKey$1 = useThemeKey;
function useTheme(a, s) {
  devUseWarning();
  const $ = a || {}, _ = $.inherit === !1 || !s ? defaultConfig : s, _e = useThemeKey$1();
  return useMemo(() => {
    var tt, nt;
    if (!a)
      return s;
    const at = Object.assign({}, _.components);
    Object.keys(a.components || {}).forEach((st) => {
      at[st] = Object.assign(Object.assign({}, at[st]), a.components[st]);
    });
    const ot = `css-var-${_e.replace(/:/g, "")}`, rt = ((tt = $.cssVar) !== null && tt !== void 0 ? tt : _.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: "ant"
    }, typeof _.cssVar == "object" ? _.cssVar : {}), typeof $.cssVar == "object" ? $.cssVar : {}), {
      key: typeof $.cssVar == "object" && ((nt = $.cssVar) === null || nt === void 0 ? void 0 : nt.key) || ot
    });
    return Object.assign(Object.assign(Object.assign({}, _), $), {
      token: Object.assign(Object.assign({}, _.token), $.token),
      components: at,
      cssVar: rt
    });
  }, [$, _], (tt, nt) => tt.some((at, ot) => {
    const rt = nt[ot];
    return !isEqual$1(at, rt, !0);
  }));
}
var _excluded$Z = ["children"], Context$3 = /* @__PURE__ */ reactExports.createContext({});
function MotionProvider(a) {
  var s = a.children, $ = _objectWithoutProperties$1(a, _excluded$Z);
  return /* @__PURE__ */ reactExports.createElement(Context$3.Provider, {
    value: $
  }, s);
}
var DomWrapper = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $() {
    return _classCallCheck(this, $), s.apply(this, arguments);
  }
  return _createClass($, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), $;
}(reactExports.Component), STATUS_NONE = "none", STATUS_APPEAR = "appear", STATUS_ENTER = "enter", STATUS_LEAVE = "leave", STEP_NONE = "none", STEP_PREPARE = "prepare", STEP_START = "start", STEP_ACTIVE = "active", STEP_ACTIVATED = "end", STEP_PREPARED = "prepared";
function makePrefixMap(a, s) {
  var $ = {};
  return $[a.toLowerCase()] = s.toLowerCase(), $["Webkit".concat(a)] = "webkit".concat(s), $["Moz".concat(a)] = "moz".concat(s), $["ms".concat(a)] = "MS".concat(s), $["O".concat(a)] = "o".concat(s.toLowerCase()), $;
}
function getVendorPrefixes(a, s) {
  var $ = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  return a && ("AnimationEvent" in s || delete $.animationend.animation, "TransitionEvent" in s || delete $.transitionend.transition), $;
}
var vendorPrefixes = getVendorPrefixes(canUseDom$1(), typeof window < "u" ? window : {}), style = {};
if (canUseDom$1()) {
  var _document$createEleme = document.createElement("div");
  style = _document$createEleme.style;
}
var prefixedEventNames = {};
function getVendorPrefixedEventName(a) {
  if (prefixedEventNames[a])
    return prefixedEventNames[a];
  var s = vendorPrefixes[a];
  if (s)
    for (var $ = Object.keys(s), _ = $.length, _e = 0; _e < _; _e += 1) {
      var tt = $[_e];
      if (Object.prototype.hasOwnProperty.call(s, tt) && tt in style)
        return prefixedEventNames[a] = s[tt], prefixedEventNames[a];
    }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend"), internalTransitionEndName = getVendorPrefixedEventName("transitionend"), supportTransition = !!(internalAnimationEndName && internalTransitionEndName), animationEndName = internalAnimationEndName || "animationend", transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName$2(a, s) {
  if (!a)
    return null;
  if (_typeof$q(a) === "object") {
    var $ = s.replace(/-\w/g, function(_) {
      return _[1].toUpperCase();
    });
    return a[$];
  }
  return "".concat(a, "-").concat(s);
}
const useDomMotionEvents = function(a) {
  var s = reactExports.useRef(), $ = reactExports.useRef(a);
  $.current = a;
  var _ = reactExports.useCallback(function(nt) {
    $.current(nt);
  }, []);
  function _e(nt) {
    nt && (nt.removeEventListener(transitionEndName, _), nt.removeEventListener(animationEndName, _));
  }
  function tt(nt) {
    s.current && s.current !== nt && _e(s.current), nt && nt !== s.current && (nt.addEventListener(transitionEndName, _), nt.addEventListener(animationEndName, _), s.current = nt);
  }
  return reactExports.useEffect(function() {
    return function() {
      _e(s.current);
    };
  }, []), [tt, _e];
};
var useIsomorphicLayoutEffect = canUseDom$1() ? reactExports.useLayoutEffect : reactExports.useEffect;
const useNextFrame = function() {
  var a = reactExports.useRef(null);
  function s() {
    wrapperRaf.cancel(a.current);
  }
  function $(_) {
    var _e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    s();
    var tt = wrapperRaf(function() {
      _e <= 1 ? _({
        isCanceled: function() {
          return tt !== a.current;
        }
      }) : $(_, _e - 1);
    });
    a.current = tt;
  }
  return reactExports.useEffect(function() {
    return function() {
      s();
    };
  }, []), [$, s];
};
var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED], SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED], SkipStep = !1, DoStep = !0;
function isActive(a) {
  return a === STEP_ACTIVE || a === STEP_ACTIVATED;
}
const useStepQueue = function(a, s, $) {
  var _ = useSafeState(STEP_NONE), _e = _slicedToArray$e(_, 2), tt = _e[0], nt = _e[1], at = useNextFrame(), ot = _slicedToArray$e(at, 2), rt = ot[0], st = ot[1];
  function lt() {
    nt(STEP_PREPARE, !0);
  }
  var et = s ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  return useIsomorphicLayoutEffect(function() {
    if (tt !== STEP_NONE && tt !== STEP_ACTIVATED) {
      var it = et.indexOf(tt), ut = et[it + 1], ft = $(tt);
      ft === SkipStep ? nt(ut, !0) : ut && rt(function(ht) {
        function dt() {
          ht.isCanceled() || nt(ut, !0);
        }
        ft === !0 ? dt() : Promise.resolve(ft).then(dt);
      });
    }
  }, [a, tt]), reactExports.useEffect(function() {
    return function() {
      st();
    };
  }, []), [lt, tt];
};
function useStatus$1(a, s, $, _) {
  var _e = _.motionEnter, tt = _e === void 0 ? !0 : _e, nt = _.motionAppear, at = nt === void 0 ? !0 : nt, ot = _.motionLeave, rt = ot === void 0 ? !0 : ot, st = _.motionDeadline, lt = _.motionLeaveImmediately, et = _.onAppearPrepare, it = _.onEnterPrepare, ut = _.onLeavePrepare, ft = _.onAppearStart, ht = _.onEnterStart, dt = _.onLeaveStart, gt = _.onAppearActive, pt = _.onEnterActive, mt = _.onLeaveActive, ct = _.onAppearEnd, vt = _.onEnterEnd, At = _.onLeaveEnd, xt = _.onVisibleChanged, bt = useSafeState(), Et = _slicedToArray$e(bt, 2), St = Et[0], Bt = Et[1], Ot = useSafeState(STATUS_NONE), Pt = _slicedToArray$e(Ot, 2), wt = Pt[0], Ct = Pt[1], It = useSafeState(null), yt = _slicedToArray$e(It, 2), Rt = yt[0], kt = yt[1], jt = reactExports.useRef(!1), Ht = reactExports.useRef(null);
  function Ft() {
    return $();
  }
  var _t = reactExports.useRef(!1);
  function Nt() {
    Ct(STATUS_NONE, !0), kt(null, !0);
  }
  function Mt(Yt) {
    var Kt = Ft();
    if (!(Yt && !Yt.deadline && Yt.target !== Kt)) {
      var nr = _t.current, tr;
      wt === STATUS_APPEAR && nr ? tr = ct == null ? void 0 : ct(Kt, Yt) : wt === STATUS_ENTER && nr ? tr = vt == null ? void 0 : vt(Kt, Yt) : wt === STATUS_LEAVE && nr && (tr = At == null ? void 0 : At(Kt, Yt)), wt !== STATUS_NONE && nr && tr !== !1 && Nt();
    }
  }
  var Lt = useDomMotionEvents(Mt), $t = _slicedToArray$e(Lt, 1), Tt = $t[0], Dt = function(Kt) {
    var nr, tr, ir;
    switch (Kt) {
      case STATUS_APPEAR:
        return nr = {}, _defineProperty$c(nr, STEP_PREPARE, et), _defineProperty$c(nr, STEP_START, ft), _defineProperty$c(nr, STEP_ACTIVE, gt), nr;
      case STATUS_ENTER:
        return tr = {}, _defineProperty$c(tr, STEP_PREPARE, it), _defineProperty$c(tr, STEP_START, ht), _defineProperty$c(tr, STEP_ACTIVE, pt), tr;
      case STATUS_LEAVE:
        return ir = {}, _defineProperty$c(ir, STEP_PREPARE, ut), _defineProperty$c(ir, STEP_START, dt), _defineProperty$c(ir, STEP_ACTIVE, mt), ir;
      default:
        return {};
    }
  }, Ut = reactExports.useMemo(function() {
    return Dt(wt);
  }, [wt]), Vt = useStepQueue(wt, !a, function(Yt) {
    if (Yt === STEP_PREPARE) {
      var Kt = Ut[STEP_PREPARE];
      return Kt ? Kt(Ft()) : SkipStep;
    }
    if (Zt in Ut) {
      var nr;
      kt(((nr = Ut[Zt]) === null || nr === void 0 ? void 0 : nr.call(Ut, Ft(), null)) || null);
    }
    return Zt === STEP_ACTIVE && (Tt(Ft()), st > 0 && (clearTimeout(Ht.current), Ht.current = setTimeout(function() {
      Mt({
        deadline: !0
      });
    }, st))), Zt === STEP_PREPARED && Nt(), DoStep;
  }), Qt = _slicedToArray$e(Vt, 2), qt = Qt[0], Zt = Qt[1], ar = isActive(Zt);
  _t.current = ar, useIsomorphicLayoutEffect(function() {
    Bt(s);
    var Yt = jt.current;
    jt.current = !0;
    var Kt;
    !Yt && s && at && (Kt = STATUS_APPEAR), Yt && s && tt && (Kt = STATUS_ENTER), (Yt && !s && rt || !Yt && lt && !s && rt) && (Kt = STATUS_LEAVE);
    var nr = Dt(Kt);
    Kt && (a || nr[STEP_PREPARE]) ? (Ct(Kt), qt()) : Ct(STATUS_NONE);
  }, [s]), reactExports.useEffect(function() {
    // Cancel appear
    (wt === STATUS_APPEAR && !at || // Cancel enter
    wt === STATUS_ENTER && !tt || // Cancel leave
    wt === STATUS_LEAVE && !rt) && Ct(STATUS_NONE);
  }, [at, tt, rt]), reactExports.useEffect(function() {
    return function() {
      jt.current = !1, clearTimeout(Ht.current);
    };
  }, []);
  var Jt = reactExports.useRef(!1);
  reactExports.useEffect(function() {
    St && (Jt.current = !0), St !== void 0 && wt === STATUS_NONE && ((Jt.current || St) && (xt == null || xt(St)), Jt.current = !0);
  }, [St, wt]);
  var rr = Rt;
  return Ut[STEP_PREPARE] && Zt === STEP_START && (rr = _objectSpread2$a({
    transition: "none"
  }, rr)), [wt, Zt, rr, St ?? s];
}
function genCSSMotion(a) {
  var s = a;
  _typeof$q(a) === "object" && (s = a.transitionSupport);
  function $(_e, tt) {
    return !!(_e.motionName && s && tt !== !1);
  }
  var _ = /* @__PURE__ */ reactExports.forwardRef(function(_e, tt) {
    var nt = _e.visible, at = nt === void 0 ? !0 : nt, ot = _e.removeOnLeave, rt = ot === void 0 ? !0 : ot, st = _e.forceRender, lt = _e.children, et = _e.motionName, it = _e.leavedClassName, ut = _e.eventProps, ft = reactExports.useContext(Context$3), ht = ft.motion, dt = $(_e, ht), gt = reactExports.useRef(), pt = reactExports.useRef();
    function mt() {
      try {
        return gt.current instanceof HTMLElement ? gt.current : findDOMNode(pt.current);
      } catch {
        return null;
      }
    }
    var ct = useStatus$1(dt, at, mt, _e), vt = _slicedToArray$e(ct, 4), At = vt[0], xt = vt[1], bt = vt[2], Et = vt[3], St = reactExports.useRef(Et);
    Et && (St.current = !0);
    var Bt = reactExports.useCallback(function(kt) {
      gt.current = kt, fillRef(tt, kt);
    }, [tt]), Ot, Pt = _objectSpread2$a(_objectSpread2$a({}, ut), {}, {
      visible: at
    });
    if (!lt)
      Ot = null;
    else if (At === STATUS_NONE)
      Et ? Ot = lt(_objectSpread2$a({}, Pt), Bt) : !rt && St.current && it ? Ot = lt(_objectSpread2$a(_objectSpread2$a({}, Pt), {}, {
        className: it
      }), Bt) : st || !rt && !it ? Ot = lt(_objectSpread2$a(_objectSpread2$a({}, Pt), {}, {
        style: {
          display: "none"
        }
      }), Bt) : Ot = null;
    else {
      var wt, Ct;
      xt === STEP_PREPARE ? Ct = "prepare" : isActive(xt) ? Ct = "active" : xt === STEP_START && (Ct = "start");
      var It = getTransitionName$2(et, "".concat(At, "-").concat(Ct));
      Ot = lt(_objectSpread2$a(_objectSpread2$a({}, Pt), {}, {
        className: classnames(getTransitionName$2(et, At), (wt = {}, _defineProperty$c(wt, It, It && Ct), _defineProperty$c(wt, et, typeof et == "string"), wt)),
        style: bt
      }), Bt);
    }
    if (/* @__PURE__ */ reactExports.isValidElement(Ot) && supportRef(Ot)) {
      var yt = Ot, Rt = yt.ref;
      Rt || (Ot = /* @__PURE__ */ reactExports.cloneElement(Ot, {
        ref: Bt
      }));
    }
    return /* @__PURE__ */ reactExports.createElement(DomWrapper, {
      ref: pt
    }, Ot);
  });
  return _.displayName = "CSSMotion", _;
}
const CSSMotion = genCSSMotion(supportTransition);
var STATUS_ADD = "add", STATUS_KEEP = "keep", STATUS_REMOVE = "remove", STATUS_REMOVED = "removed";
function wrapKeyToObject(a) {
  var s;
  return a && _typeof$q(a) === "object" && "key" in a ? s = a : s = {
    key: a
  }, _objectSpread2$a(_objectSpread2$a({}, s), {}, {
    key: String(s.key)
  });
}
function parseKeys() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return a.map(wrapKeyToObject);
}
function diffKeys() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], $ = [], _ = 0, _e = s.length, tt = parseKeys(a), nt = parseKeys(s);
  tt.forEach(function(rt) {
    for (var st = !1, lt = _; lt < _e; lt += 1) {
      var et = nt[lt];
      if (et.key === rt.key) {
        _ < lt && ($ = $.concat(nt.slice(_, lt).map(function(it) {
          return _objectSpread2$a(_objectSpread2$a({}, it), {}, {
            status: STATUS_ADD
          });
        })), _ = lt), $.push(_objectSpread2$a(_objectSpread2$a({}, et), {}, {
          status: STATUS_KEEP
        })), _ += 1, st = !0;
        break;
      }
    }
    st || $.push(_objectSpread2$a(_objectSpread2$a({}, rt), {}, {
      status: STATUS_REMOVE
    }));
  }), _ < _e && ($ = $.concat(nt.slice(_).map(function(rt) {
    return _objectSpread2$a(_objectSpread2$a({}, rt), {}, {
      status: STATUS_ADD
    });
  })));
  var at = {};
  $.forEach(function(rt) {
    var st = rt.key;
    at[st] = (at[st] || 0) + 1;
  });
  var ot = Object.keys(at).filter(function(rt) {
    return at[rt] > 1;
  });
  return ot.forEach(function(rt) {
    $ = $.filter(function(st) {
      var lt = st.key, et = st.status;
      return lt !== rt || et !== STATUS_REMOVE;
    }), $.forEach(function(st) {
      st.key === rt && (st.status = STATUS_KEEP);
    });
  }), $;
}
var _excluded$Y = ["component", "children", "onVisibleChanged", "onAllRemoved"], _excluded2$c = ["status"], MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion, $ = /* @__PURE__ */ function(_) {
    _inherits(tt, _);
    var _e = _createSuper(tt);
    function tt() {
      var nt;
      _classCallCheck(this, tt);
      for (var at = arguments.length, ot = new Array(at), rt = 0; rt < at; rt++)
        ot[rt] = arguments[rt];
      return nt = _e.call.apply(_e, [this].concat(ot)), _defineProperty$c(_assertThisInitialized(nt), "state", {
        keyEntities: []
      }), _defineProperty$c(_assertThisInitialized(nt), "removeKey", function(st) {
        var lt = nt.state.keyEntities, et = lt.map(function(it) {
          return it.key !== st ? it : _objectSpread2$a(_objectSpread2$a({}, it), {}, {
            status: STATUS_REMOVED
          });
        });
        return nt.setState({
          keyEntities: et
        }), et.filter(function(it) {
          var ut = it.status;
          return ut !== STATUS_REMOVED;
        }).length;
      }), nt;
    }
    return _createClass(tt, [{
      key: "render",
      value: function() {
        var at = this, ot = this.state.keyEntities, rt = this.props, st = rt.component, lt = rt.children, et = rt.onVisibleChanged, it = rt.onAllRemoved, ut = _objectWithoutProperties$1(rt, _excluded$Y), ft = st || reactExports.Fragment, ht = {};
        return MOTION_PROP_NAMES.forEach(function(dt) {
          ht[dt] = ut[dt], delete ut[dt];
        }), delete ut.keys, /* @__PURE__ */ reactExports.createElement(ft, ut, ot.map(function(dt, gt) {
          var pt = dt.status, mt = _objectWithoutProperties$1(dt, _excluded2$c), ct = pt === STATUS_ADD || pt === STATUS_KEEP;
          return /* @__PURE__ */ reactExports.createElement(s, _extends$2({}, ht, {
            key: mt.key,
            visible: ct,
            eventProps: mt,
            onVisibleChanged: function(At) {
              if (et == null || et(At, {
                key: mt.key
              }), !At) {
                var xt = at.removeKey(mt.key);
                xt === 0 && it && it();
              }
            }
          }), function(vt, At) {
            return lt(_objectSpread2$a(_objectSpread2$a({}, vt), {}, {
              index: gt
            }), At);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(at, ot) {
        var rt = at.keys, st = ot.keyEntities, lt = parseKeys(rt), et = diffKeys(st, lt);
        return {
          keyEntities: et.filter(function(it) {
            var ut = st.find(function(ft) {
              var ht = ft.key;
              return it.key === ht;
            });
            return !(ut && ut.status === STATUS_REMOVED && it.status === STATUS_REMOVE);
          })
        };
      }
    }]), tt;
  }(reactExports.Component);
  return _defineProperty$c($, "defaultProps", {
    component: "div"
  }), $;
}
const CSSMotionList = genCSSMotionList(supportTransition);
function MotionWrapper(a) {
  const {
    children: s
  } = a, [, $] = useToken$1(), {
    motion: _
  } = $, _e = reactExports.useRef(!1);
  return _e.current = _e.current || _ === !1, _e.current ? /* @__PURE__ */ reactExports.createElement(MotionProvider, {
    motion: _
  }, s) : s;
}
const PropWarning = () => null;
var __rest$11 = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const PASSED_PROPS = ["getTargetContainer", "getPopupContainer", "renderEmpty", "pageHeader", "input", "pagination", "form", "select", "button"], defaultPrefixCls = "ant";
let globalPrefixCls, globalIconPrefixCls, globalTheme;
function getGlobalPrefixCls() {
  return globalPrefixCls || defaultPrefixCls;
}
function getGlobalIconPrefixCls() {
  return globalIconPrefixCls || defaultIconPrefixCls;
}
function isLegacyTheme(a) {
  return Object.keys(a).some((s) => s.endsWith("Color"));
}
const setGlobalConfig = (a) => {
  let {
    prefixCls: s,
    iconPrefixCls: $,
    theme: _
  } = a;
  s !== void 0 && (globalPrefixCls = s), $ !== void 0 && (globalIconPrefixCls = $), _ && (isLegacyTheme(_) ? registerTheme(getGlobalPrefixCls(), _) : globalTheme = _);
}, globalConfig = () => ({
  getPrefixCls: (a, s) => s || (a ? `${getGlobalPrefixCls()}-${a}` : getGlobalPrefixCls()),
  getIconPrefixCls: getGlobalIconPrefixCls,
  getRootPrefixCls: () => globalPrefixCls || getGlobalPrefixCls(),
  getTheme: () => globalTheme
}), ProviderChildren = (a) => {
  const {
    children: s,
    csp: $,
    autoInsertSpaceInButton: _,
    alert: _e,
    anchor: tt,
    form: nt,
    locale: at,
    componentSize: ot,
    direction: rt,
    space: st,
    virtual: lt,
    dropdownMatchSelectWidth: et,
    popupMatchSelectWidth: it,
    popupOverflow: ut,
    legacyLocale: ft,
    parentContext: ht,
    iconPrefixCls: dt,
    theme: gt,
    componentDisabled: pt,
    segmented: mt,
    statistic: ct,
    spin: vt,
    calendar: At,
    carousel: xt,
    cascader: bt,
    collapse: Et,
    typography: St,
    checkbox: Bt,
    descriptions: Ot,
    divider: Pt,
    drawer: wt,
    skeleton: Ct,
    steps: It,
    image: yt,
    layout: Rt,
    list: kt,
    mentions: jt,
    modal: Ht,
    progress: Ft,
    result: _t,
    slider: Nt,
    breadcrumb: Mt,
    menu: Lt,
    pagination: $t,
    input: Tt,
    empty: Dt,
    badge: Ut,
    radio: Vt,
    rate: Qt,
    switch: qt,
    transfer: Zt,
    avatar: ar,
    message: Jt,
    tag: rr,
    table: Yt,
    card: Kt,
    tabs: nr,
    timeline: tr,
    timePicker: ir,
    upload: sr,
    notification: cr,
    tree: or,
    colorPicker: Xt,
    datePicker: Gt,
    rangePicker: Wt,
    flex: er,
    wave: lr,
    dropdown: ur,
    warning: pr
  } = a, yr = reactExports.useCallback((Pr, Rr) => {
    const {
      prefixCls: Dr
    } = a;
    if (Rr)
      return Rr;
    const Gr = Dr || ht.getPrefixCls("");
    return Pr ? `${Gr}-${Pr}` : Gr;
  }, [ht.getPrefixCls, a.prefixCls]), Er = dt || ht.iconPrefixCls || defaultIconPrefixCls, br = $ || ht.csp;
  useStyle$y(Er, br);
  const gr = useTheme(gt, ht.theme), Ar = {
    csp: br,
    autoInsertSpaceInButton: _,
    alert: _e,
    anchor: tt,
    locale: at || ft,
    direction: rt,
    space: st,
    virtual: lt,
    popupMatchSelectWidth: it ?? et,
    popupOverflow: ut,
    getPrefixCls: yr,
    iconPrefixCls: Er,
    theme: gr,
    segmented: mt,
    statistic: ct,
    spin: vt,
    calendar: At,
    carousel: xt,
    cascader: bt,
    collapse: Et,
    typography: St,
    checkbox: Bt,
    descriptions: Ot,
    divider: Pt,
    drawer: wt,
    skeleton: Ct,
    steps: It,
    image: yt,
    input: Tt,
    layout: Rt,
    list: kt,
    mentions: jt,
    modal: Ht,
    progress: Ft,
    result: _t,
    slider: Nt,
    breadcrumb: Mt,
    menu: Lt,
    pagination: $t,
    empty: Dt,
    badge: Ut,
    radio: Vt,
    rate: Qt,
    switch: qt,
    transfer: Zt,
    avatar: ar,
    message: Jt,
    tag: rr,
    table: Yt,
    card: Kt,
    tabs: nr,
    timeline: tr,
    timePicker: ir,
    upload: sr,
    notification: cr,
    tree: or,
    colorPicker: Xt,
    datePicker: Gt,
    rangePicker: Wt,
    flex: er,
    wave: lr,
    dropdown: ur,
    warning: pr
  }, Sr = Object.assign({}, ht);
  Object.keys(Ar).forEach((Pr) => {
    Ar[Pr] !== void 0 && (Sr[Pr] = Ar[Pr]);
  }), PASSED_PROPS.forEach((Pr) => {
    const Rr = a[Pr];
    Rr && (Sr[Pr] = Rr);
  });
  const Br = useMemo(() => Sr, Sr, (Pr, Rr) => {
    const Dr = Object.keys(Pr), Gr = Object.keys(Rr);
    return Dr.length !== Gr.length || Dr.some((Or) => Pr[Or] !== Rr[Or]);
  }), Ir = reactExports.useMemo(() => ({
    prefixCls: Er,
    csp: br
  }), [Er, br]);
  let hr = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(PropWarning, {
    dropdownMatchSelectWidth: et
  }), s);
  const vr = reactExports.useMemo(() => {
    var Pr, Rr, Dr, Gr;
    return merge$1(((Pr = defaultLocale.Form) === null || Pr === void 0 ? void 0 : Pr.defaultValidateMessages) || {}, ((Dr = (Rr = Br.locale) === null || Rr === void 0 ? void 0 : Rr.Form) === null || Dr === void 0 ? void 0 : Dr.defaultValidateMessages) || {}, ((Gr = Br.form) === null || Gr === void 0 ? void 0 : Gr.validateMessages) || {}, (nt == null ? void 0 : nt.validateMessages) || {});
  }, [Br, nt == null ? void 0 : nt.validateMessages]);
  Object.keys(vr).length > 0 && (hr = /* @__PURE__ */ reactExports.createElement(ValidateMessagesContext.Provider, {
    value: vr
  }, hr)), at && (hr = /* @__PURE__ */ reactExports.createElement(LocaleProvider$1, {
    locale: at,
    _ANT_MARK__: ANT_MARK
  }, hr)), (Er || br) && (hr = /* @__PURE__ */ reactExports.createElement(Context$4.Provider, {
    value: Ir
  }, hr)), ot && (hr = /* @__PURE__ */ reactExports.createElement(SizeContextProvider, {
    size: ot
  }, hr)), hr = /* @__PURE__ */ reactExports.createElement(MotionWrapper, null, hr);
  const xr = reactExports.useMemo(() => {
    const Pr = gr || {}, {
      algorithm: Rr,
      token: Dr,
      components: Gr,
      cssVar: Or
    } = Pr, Hr = __rest$11(Pr, ["algorithm", "token", "components", "cssVar"]), jr = Rr && (!Array.isArray(Rr) || Rr.length > 0) ? createTheme(Rr) : defaultTheme$1, Tr = {};
    Object.entries(Gr || {}).forEach((Cr) => {
      let [$r, wr] = Cr;
      const Mr = Object.assign({}, wr);
      "algorithm" in Mr && (Mr.algorithm === !0 ? Mr.theme = jr : (Array.isArray(Mr.algorithm) || typeof Mr.algorithm == "function") && (Mr.theme = createTheme(Mr.algorithm)), delete Mr.algorithm), Tr[$r] = Mr;
    });
    const fr = Object.assign(Object.assign({}, seedToken), Dr);
    return Object.assign(Object.assign({}, Hr), {
      theme: jr,
      token: fr,
      components: Tr,
      override: Object.assign({
        override: fr
      }, Tr),
      cssVar: Or
    });
  }, [gr]);
  return gt && (hr = /* @__PURE__ */ reactExports.createElement(DesignTokenContext.Provider, {
    value: xr
  }, hr)), Br.warning && (hr = /* @__PURE__ */ reactExports.createElement(WarningContext.Provider, {
    value: Br.warning
  }, hr)), pt !== void 0 && (hr = /* @__PURE__ */ reactExports.createElement(DisabledContextProvider, {
    disabled: pt
  }, hr)), /* @__PURE__ */ reactExports.createElement(ConfigContext$1.Provider, {
    value: Br
  }, hr);
}, ConfigProvider = (a) => {
  const s = reactExports.useContext(ConfigContext$1), $ = reactExports.useContext(LocaleContext$1);
  return /* @__PURE__ */ reactExports.createElement(ProviderChildren, Object.assign({
    parentContext: s,
    legacyLocale: $
  }, a));
};
ConfigProvider.ConfigContext = ConfigContext$1;
ConfigProvider.SizeContext = SizeContext$1;
ConfigProvider.config = setGlobalConfig;
ConfigProvider.useConfig = useConfig;
Object.defineProperty(ConfigProvider, "SizeContext", {
  get: () => SizeContext$1
});
const ThemeConfigProvider = ConfigProvider;
var CheckCircleFilled$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
const CheckCircleFilledSvg = CheckCircleFilled$2;
function getRoot(a) {
  var s;
  return a == null || (s = a.getRootNode) === null || s === void 0 ? void 0 : s.call(a);
}
function inShadow(a) {
  return getRoot(a) instanceof ShadowRoot;
}
function getShadowRoot$1(a) {
  return inShadow(a) ? getRoot(a) : null;
}
function camelCase(a) {
  return a.replace(/-(.)/g, function(s, $) {
    return $.toUpperCase();
  });
}
function warning$2(a, s) {
  warningOnce(a, "[@ant-design/icons] ".concat(s));
}
function isIconDefinition(a) {
  return _typeof$q(a) === "object" && typeof a.name == "string" && typeof a.theme == "string" && (_typeof$q(a.icon) === "object" || typeof a.icon == "function");
}
function normalizeAttrs() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(a).reduce(function(s, $) {
    var _ = a[$];
    switch ($) {
      case "class":
        s.className = _, delete s.class;
        break;
      default:
        delete s[$], s[camelCase($)] = _;
    }
    return s;
  }, {});
}
function generate$1(a, s, $) {
  return $ ? /* @__PURE__ */ React$a.createElement(a.tag, _objectSpread2$a(_objectSpread2$a({
    key: s
  }, normalizeAttrs(a.attrs)), $), (a.children || []).map(function(_, _e) {
    return generate$1(_, "".concat(s, "-").concat(a.tag, "-").concat(_e));
  })) : /* @__PURE__ */ React$a.createElement(a.tag, _objectSpread2$a({
    key: s
  }, normalizeAttrs(a.attrs)), (a.children || []).map(function(_, _e) {
    return generate$1(_, "".concat(s, "-").concat(a.tag, "-").concat(_e));
  }));
}
function getSecondaryColor(a) {
  return generate$2(a)[0];
}
function normalizeTwoToneColors(a) {
  return a ? Array.isArray(a) ? a : [a] : [];
}
var iconStyles = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, useInsertStyles = function a(s) {
  var $ = reactExports.useContext(Context$4), _ = $.csp, _e = $.prefixCls, tt = iconStyles;
  _e && (tt = tt.replace(/anticon/g, _e)), reactExports.useEffect(function() {
    var nt = s.current, at = getShadowRoot$1(nt);
    updateCSS(tt, "@ant-design-icons", {
      prepend: !0,
      csp: _,
      attachTo: at
    });
  }, []);
}, _excluded$X = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], twoToneColorPalette = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function setTwoToneColors(a) {
  var s = a.primaryColor, $ = a.secondaryColor;
  twoToneColorPalette.primaryColor = s, twoToneColorPalette.secondaryColor = $ || getSecondaryColor(s), twoToneColorPalette.calculated = !!$;
}
function getTwoToneColors() {
  return _objectSpread2$a({}, twoToneColorPalette);
}
var IconBase$1 = function a(s) {
  var $ = s.icon, _ = s.className, _e = s.onClick, tt = s.style, nt = s.primaryColor, at = s.secondaryColor, ot = _objectWithoutProperties$1(s, _excluded$X), rt = reactExports.useRef(), st = twoToneColorPalette;
  if (nt && (st = {
    primaryColor: nt,
    secondaryColor: at || getSecondaryColor(nt)
  }), useInsertStyles(rt), warning$2(isIconDefinition($), "icon should be icon definiton, but got ".concat($)), !isIconDefinition($))
    return null;
  var lt = $;
  return lt && typeof lt.icon == "function" && (lt = _objectSpread2$a(_objectSpread2$a({}, lt), {}, {
    icon: lt.icon(st.primaryColor, st.secondaryColor)
  })), generate$1(lt.icon, "svg-".concat(lt.name), _objectSpread2$a(_objectSpread2$a({
    className: _,
    onClick: _e,
    style: tt,
    "data-icon": lt.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, ot), {}, {
    ref: rt
  }));
};
IconBase$1.displayName = "IconReact";
IconBase$1.getTwoToneColors = getTwoToneColors;
IconBase$1.setTwoToneColors = setTwoToneColors;
const ReactIcon = IconBase$1;
function setTwoToneColor(a) {
  var s = normalizeTwoToneColors(a), $ = _slicedToArray$e(s, 2), _ = $[0], _e = $[1];
  return ReactIcon.setTwoToneColors({
    primaryColor: _,
    secondaryColor: _e
  });
}
function getTwoToneColor() {
  var a = ReactIcon.getTwoToneColors();
  return a.calculated ? [a.primaryColor, a.secondaryColor] : a.primaryColor;
}
var _excluded$W = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
setTwoToneColor(blue$1.primary);
var Icon$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _ = a.className, _e = a.icon, tt = a.spin, nt = a.rotate, at = a.tabIndex, ot = a.onClick, rt = a.twoToneColor, st = _objectWithoutProperties$1(a, _excluded$W), lt = reactExports.useContext(Context$4), et = lt.prefixCls, it = et === void 0 ? "anticon" : et, ut = lt.rootClassName, ft = classnames(ut, it, ($ = {}, _defineProperty$c($, "".concat(it, "-").concat(_e.name), !!_e.name), _defineProperty$c($, "".concat(it, "-spin"), !!tt || _e.name === "loading"), $), _), ht = at;
  ht === void 0 && ot && (ht = -1);
  var dt = nt ? {
    msTransform: "rotate(".concat(nt, "deg)"),
    transform: "rotate(".concat(nt, "deg)")
  } : void 0, gt = normalizeTwoToneColors(rt), pt = _slicedToArray$e(gt, 2), mt = pt[0], ct = pt[1];
  return /* @__PURE__ */ reactExports.createElement("span", _extends$2({
    role: "img",
    "aria-label": _e.name
  }, st, {
    ref: s,
    tabIndex: ht,
    onClick: ot,
    className: ft
  }), /* @__PURE__ */ reactExports.createElement(ReactIcon, {
    icon: _e,
    primaryColor: mt,
    secondaryColor: ct,
    style: dt
  }));
});
Icon$2.displayName = "AntdIcon";
Icon$2.getTwoToneColor = getTwoToneColor;
Icon$2.setTwoToneColor = setTwoToneColor;
const AntdIcon$1 = Icon$2;
var CheckCircleFilled = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: CheckCircleFilledSvg
  }));
};
const CheckCircleFilled$1 = /* @__PURE__ */ reactExports.forwardRef(CheckCircleFilled);
var CloseCircleFilled$2 = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
const CloseCircleFilledSvg = CloseCircleFilled$2;
var CloseCircleFilled = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: CloseCircleFilledSvg
  }));
};
const CloseCircleFilled$1 = /* @__PURE__ */ reactExports.forwardRef(CloseCircleFilled);
var CloseOutlined$5 = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
const CloseOutlinedSvg = CloseOutlined$5;
var CloseOutlined$3 = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: CloseOutlinedSvg
  }));
};
const CloseOutlined$4 = /* @__PURE__ */ reactExports.forwardRef(CloseOutlined$3);
var ExclamationCircleFilled$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
const ExclamationCircleFilledSvg = ExclamationCircleFilled$2;
var ExclamationCircleFilled = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: ExclamationCircleFilledSvg
  }));
};
const ExclamationCircleFilled$1 = /* @__PURE__ */ reactExports.forwardRef(ExclamationCircleFilled);
var InfoCircleFilled$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
const InfoCircleFilledSvg = InfoCircleFilled$2;
var InfoCircleFilled = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: InfoCircleFilledSvg
  }));
};
const InfoCircleFilled$1 = /* @__PURE__ */ reactExports.forwardRef(InfoCircleFilled);
var attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/), ariaPrefix = "aria-", dataPrefix = "data-";
function match(a, s) {
  return a.indexOf(s) === 0;
}
function pickAttrs(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, $;
  s === !1 ? $ = {
    aria: !0,
    data: !0,
    attr: !0
  } : s === !0 ? $ = {
    aria: !0
  } : $ = _objectSpread2$a({}, s);
  var _ = {};
  return Object.keys(a).forEach(function(_e) {
    // Aria
    ($.aria && (_e === "role" || match(_e, ariaPrefix)) || // Data
    $.data && match(_e, dataPrefix) || // Attr
    $.attr && propList.includes(_e)) && (_[_e] = a[_e]);
  }), _;
}
const {
  isValidElement
} = React$b;
function isFragment(a) {
  return a && isValidElement(a) && a.type === reactExports.Fragment;
}
function replaceElement(a, s, $) {
  return isValidElement(a) ? /* @__PURE__ */ reactExports.cloneElement(a, typeof $ == "function" ? $(a.props || {}) : $) : s;
}
function cloneElement(a, s) {
  return replaceElement(a, a, s);
}
const t$2 = (a) => typeof a == "object" && a != null && a.nodeType === 1, e$2 = (a, s) => (!s || a !== "hidden") && a !== "visible" && a !== "clip", n$2 = (a, s) => {
  if (a.clientHeight < a.scrollHeight || a.clientWidth < a.scrollWidth) {
    const $ = getComputedStyle(a, null);
    return e$2($.overflowY, s) || e$2($.overflowX, s) || ((_) => {
      const _e = ((tt) => {
        if (!tt.ownerDocument || !tt.ownerDocument.defaultView)
          return null;
        try {
          return tt.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(_);
      return !!_e && (_e.clientHeight < _.scrollHeight || _e.clientWidth < _.scrollWidth);
    })(a);
  }
  return !1;
}, o$1 = (a, s, $, _, _e, tt, nt, at) => tt < a && nt > s || tt > a && nt < s ? 0 : tt <= a && at <= $ || nt >= s && at >= $ ? tt - a - _ : nt > s && at < $ || tt < a && at > $ ? nt - s + _e : 0, l$1 = (a) => {
  const s = a.parentElement;
  return s ?? (a.getRootNode().host || null);
}, r$2 = (a, s) => {
  var $, _, _e, tt;
  if (typeof document > "u")
    return [];
  const { scrollMode: nt, block: at, inline: ot, boundary: rt, skipOverflowHiddenElements: st } = s, lt = typeof rt == "function" ? rt : (Ct) => Ct !== rt;
  if (!t$2(a))
    throw new TypeError("Invalid target");
  const et = document.scrollingElement || document.documentElement, it = [];
  let ut = a;
  for (; t$2(ut) && lt(ut); ) {
    if (ut = l$1(ut), ut === et) {
      it.push(ut);
      break;
    }
    ut != null && ut === document.body && n$2(ut) && !n$2(document.documentElement) || ut != null && n$2(ut, st) && it.push(ut);
  }
  const ft = (_ = ($ = window.visualViewport) == null ? void 0 : $.width) != null ? _ : innerWidth, ht = (tt = (_e = window.visualViewport) == null ? void 0 : _e.height) != null ? tt : innerHeight, { scrollX: dt, scrollY: gt } = window, { height: pt, width: mt, top: ct, right: vt, bottom: At, left: xt } = a.getBoundingClientRect(), { top: bt, right: Et, bottom: St, left: Bt } = ((Ct) => {
    const It = window.getComputedStyle(Ct);
    return { top: parseFloat(It.scrollMarginTop) || 0, right: parseFloat(It.scrollMarginRight) || 0, bottom: parseFloat(It.scrollMarginBottom) || 0, left: parseFloat(It.scrollMarginLeft) || 0 };
  })(a);
  let Ot = at === "start" || at === "nearest" ? ct - bt : at === "end" ? At + St : ct + pt / 2 - bt + St, Pt = ot === "center" ? xt + mt / 2 - Bt + Et : ot === "end" ? vt + Et : xt - Bt;
  const wt = [];
  for (let Ct = 0; Ct < it.length; Ct++) {
    const It = it[Ct], { height: yt, width: Rt, top: kt, right: jt, bottom: Ht, left: Ft } = It.getBoundingClientRect();
    if (nt === "if-needed" && ct >= 0 && xt >= 0 && At <= ht && vt <= ft && ct >= kt && At <= Ht && xt >= Ft && vt <= jt)
      return wt;
    const _t = getComputedStyle(It), Nt = parseInt(_t.borderLeftWidth, 10), Mt = parseInt(_t.borderTopWidth, 10), Lt = parseInt(_t.borderRightWidth, 10), $t = parseInt(_t.borderBottomWidth, 10);
    let Tt = 0, Dt = 0;
    const Ut = "offsetWidth" in It ? It.offsetWidth - It.clientWidth - Nt - Lt : 0, Vt = "offsetHeight" in It ? It.offsetHeight - It.clientHeight - Mt - $t : 0, Qt = "offsetWidth" in It ? It.offsetWidth === 0 ? 0 : Rt / It.offsetWidth : 0, qt = "offsetHeight" in It ? It.offsetHeight === 0 ? 0 : yt / It.offsetHeight : 0;
    if (et === It)
      Tt = at === "start" ? Ot : at === "end" ? Ot - ht : at === "nearest" ? o$1(gt, gt + ht, ht, Mt, $t, gt + Ot, gt + Ot + pt, pt) : Ot - ht / 2, Dt = ot === "start" ? Pt : ot === "center" ? Pt - ft / 2 : ot === "end" ? Pt - ft : o$1(dt, dt + ft, ft, Nt, Lt, dt + Pt, dt + Pt + mt, mt), Tt = Math.max(0, Tt + gt), Dt = Math.max(0, Dt + dt);
    else {
      Tt = at === "start" ? Ot - kt - Mt : at === "end" ? Ot - Ht + $t + Vt : at === "nearest" ? o$1(kt, Ht, yt, Mt, $t + Vt, Ot, Ot + pt, pt) : Ot - (kt + yt / 2) + Vt / 2, Dt = ot === "start" ? Pt - Ft - Nt : ot === "center" ? Pt - (Ft + Rt / 2) + Ut / 2 : ot === "end" ? Pt - jt + Lt + Ut : o$1(Ft, jt, Rt, Nt, Lt + Ut, Pt, Pt + mt, mt);
      const { scrollLeft: Zt, scrollTop: ar } = It;
      Tt = qt === 0 ? 0 : Math.max(0, Math.min(ar + Tt / qt, It.scrollHeight - yt / qt + Vt)), Dt = Qt === 0 ? 0 : Math.max(0, Math.min(Zt + Dt / Qt, It.scrollWidth - Rt / Qt + Ut)), Ot += ar - Tt, Pt += Zt - Dt;
    }
    wt.push({ el: It, top: Tt, left: Dt });
  }
  return wt;
}, o = (a) => a === !1 ? { block: "end", inline: "nearest" } : ((s) => s === Object(s) && Object.keys(s).length !== 0)(a) ? a : { block: "start", inline: "nearest" };
function e$1(a, s) {
  if (!a.isConnected || !((_e) => {
    let tt = _e;
    for (; tt && tt.parentNode; ) {
      if (tt.parentNode === document)
        return !0;
      tt = tt.parentNode instanceof ShadowRoot ? tt.parentNode.host : tt.parentNode;
    }
    return !1;
  })(a))
    return;
  const $ = ((_e) => {
    const tt = window.getComputedStyle(_e);
    return { top: parseFloat(tt.scrollMarginTop) || 0, right: parseFloat(tt.scrollMarginRight) || 0, bottom: parseFloat(tt.scrollMarginBottom) || 0, left: parseFloat(tt.scrollMarginLeft) || 0 };
  })(a);
  if (((_e) => typeof _e == "object" && typeof _e.behavior == "function")(s))
    return s.behavior(r$2(a, s));
  const _ = typeof s == "boolean" || s == null ? void 0 : s.behavior;
  for (const { el: _e, top: tt, left: nt } of r$2(a, o(s))) {
    const at = tt - $.top + $.bottom, ot = nt - $.left + $.right;
    _e.scroll({ top: at, left: ot, behavior: _ });
  }
}
function isWindow$3(a) {
  return a != null && a === a.window;
}
function getScroll$3(a, s) {
  var $, _;
  if (typeof window > "u")
    return 0;
  const _e = s ? "scrollTop" : "scrollLeft";
  let tt = 0;
  return isWindow$3(a) ? tt = a[s ? "pageYOffset" : "pageXOffset"] : a instanceof Document ? tt = a.documentElement[_e] : (a instanceof HTMLElement || a) && (tt = a[_e]), a && !isWindow$3(a) && typeof tt != "number" && (tt = (_ = (($ = a.ownerDocument) !== null && $ !== void 0 ? $ : a).documentElement) === null || _ === void 0 ? void 0 : _[_e]), tt;
}
function easeInOutCubic(a, s, $, _) {
  const _e = $ - s;
  return a /= _ / 2, a < 1 ? _e / 2 * a * a * a + s : _e / 2 * ((a -= 2) * a * a + 2) + s;
}
function scrollTo$1(a) {
  let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    getContainer: $ = () => window,
    callback: _,
    duration: _e = 450
  } = s, tt = $(), nt = getScroll$3(tt, !0), at = Date.now(), ot = () => {
    const st = Date.now() - at, lt = easeInOutCubic(st > _e ? _e : st, nt, a, _e);
    isWindow$3(tt) ? tt.scrollTo(window.pageXOffset, lt) : tt instanceof Document || tt.constructor.name === "HTMLDocument" ? tt.documentElement.scrollTop = lt : tt.scrollTop = lt, st < _e ? wrapperRaf(ot) : typeof _ == "function" && _();
  };
  wrapperRaf(ot);
}
const useCSSVarCls = (a) => {
  const [, , , , s] = useToken$1();
  return s ? `${a}-css-var` : "";
}, useCSSVarCls$1 = useCSSVarCls;
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function a(s) {
    var $ = s.keyCode;
    if (s.altKey && !s.ctrlKey || s.metaKey || // Function keys don't generate text
    $ >= KeyCode.F1 && $ <= KeyCode.F12)
      return !1;
    switch ($) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function a(s) {
    if (s >= KeyCode.ZERO && s <= KeyCode.NINE || s >= KeyCode.NUM_ZERO && s <= KeyCode.NUM_MULTIPLY || s >= KeyCode.A && s <= KeyCode.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && s === 0)
      return !0;
    switch (s) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, Notify = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = a.style, _e = a.className, tt = a.duration, nt = tt === void 0 ? 4.5 : tt, at = a.eventKey, ot = a.content, rt = a.closable, st = a.closeIcon, lt = st === void 0 ? "x" : st, et = a.props, it = a.onClick, ut = a.onNoticeClose, ft = a.times, ht = a.hovering, dt = reactExports.useState(!1), gt = _slicedToArray$e(dt, 2), pt = gt[0], mt = gt[1], ct = ht || pt, vt = function() {
    ut(at);
  }, At = function(Et) {
    (Et.key === "Enter" || Et.code === "Enter" || Et.keyCode === KeyCode.ENTER) && vt();
  };
  reactExports.useEffect(function() {
    if (!ct && nt > 0) {
      var bt = setTimeout(function() {
        vt();
      }, nt * 1e3);
      return function() {
        clearTimeout(bt);
      };
    }
  }, [nt, ct, ft]);
  var xt = "".concat($, "-notice");
  return /* @__PURE__ */ reactExports.createElement("div", _extends$2({}, et, {
    ref: s,
    className: classnames(xt, _e, _defineProperty$c({}, "".concat(xt, "-closable"), rt)),
    style: _,
    onMouseEnter: function(Et) {
      var St;
      mt(!0), et == null || (St = et.onMouseEnter) === null || St === void 0 || St.call(et, Et);
    },
    onMouseLeave: function(Et) {
      var St;
      mt(!1), et == null || (St = et.onMouseLeave) === null || St === void 0 || St.call(et, Et);
    },
    onClick: it
  }), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(xt, "-content")
  }, ot), rt && /* @__PURE__ */ reactExports.createElement("a", {
    tabIndex: 0,
    className: "".concat(xt, "-close"),
    onKeyDown: At,
    onClick: function(Et) {
      Et.preventDefault(), Et.stopPropagation(), vt();
    }
  }, lt));
}), NotificationContext = /* @__PURE__ */ React$a.createContext({}), NotificationProvider = function a(s) {
  var $ = s.children, _ = s.classNames;
  return /* @__PURE__ */ React$a.createElement(NotificationContext.Provider, {
    value: {
      classNames: _
    }
  }, $);
}, DEFAULT_OFFSET$1 = 8, DEFAULT_THRESHOLD = 3, DEFAULT_GAP = 16, useStack = function a(s) {
  var $ = {
    offset: DEFAULT_OFFSET$1,
    threshold: DEFAULT_THRESHOLD,
    gap: DEFAULT_GAP
  };
  if (s && _typeof$q(s) === "object") {
    var _, _e, tt;
    $.offset = (_ = s.offset) !== null && _ !== void 0 ? _ : DEFAULT_OFFSET$1, $.threshold = (_e = s.threshold) !== null && _e !== void 0 ? _e : DEFAULT_THRESHOLD, $.gap = (tt = s.gap) !== null && tt !== void 0 ? tt : DEFAULT_GAP;
  }
  return [!!s, $];
}, _excluded$V = ["className", "style", "classNames", "styles"], NoticeList = function a(s) {
  var $, _ = s.configList, _e = s.placement, tt = s.prefixCls, nt = s.className, at = s.style, ot = s.motion, rt = s.onAllNoticeRemoved, st = s.onNoticeClose, lt = s.stack, et = reactExports.useContext(NotificationContext), it = et.classNames, ut = reactExports.useRef({}), ft = reactExports.useState(null), ht = _slicedToArray$e(ft, 2), dt = ht[0], gt = ht[1], pt = reactExports.useState([]), mt = _slicedToArray$e(pt, 2), ct = mt[0], vt = mt[1], At = _.map(function(It) {
    return {
      config: It,
      key: String(It.key)
    };
  }), xt = useStack(lt), bt = _slicedToArray$e(xt, 2), Et = bt[0], St = bt[1], Bt = St.offset, Ot = St.threshold, Pt = St.gap, wt = Et && (ct.length > 0 || At.length <= Ot), Ct = typeof ot == "function" ? ot(_e) : ot;
  return reactExports.useEffect(function() {
    Et && ct.length > 1 && vt(function(It) {
      return It.filter(function(yt) {
        return At.some(function(Rt) {
          var kt = Rt.key;
          return yt === kt;
        });
      });
    });
  }, [ct, At, Et]), reactExports.useEffect(function() {
    var It;
    if (Et && ut.current[(It = At[At.length - 1]) === null || It === void 0 ? void 0 : It.key]) {
      var yt;
      gt(ut.current[(yt = At[At.length - 1]) === null || yt === void 0 ? void 0 : yt.key]);
    }
  }, [At, Et]), /* @__PURE__ */ React$a.createElement(CSSMotionList, _extends$2({
    key: _e,
    className: classnames(tt, "".concat(tt, "-").concat(_e), it == null ? void 0 : it.list, nt, ($ = {}, _defineProperty$c($, "".concat(tt, "-stack"), !!Et), _defineProperty$c($, "".concat(tt, "-stack-expanded"), wt), $)),
    style: at,
    keys: At,
    motionAppear: !0
  }, Ct, {
    onAllRemoved: function() {
      rt(_e);
    }
  }), function(It, yt) {
    var Rt = It.config, kt = It.className, jt = It.style, Ht = It.index, Ft = Rt, _t = Ft.key, Nt = Ft.times, Mt = String(_t), Lt = Rt, $t = Lt.className, Tt = Lt.style, Dt = Lt.classNames, Ut = Lt.styles, Vt = _objectWithoutProperties$1(Lt, _excluded$V), Qt = At.findIndex(function(cr) {
      return cr.key === Mt;
    }), qt = {};
    if (Et) {
      var Zt = At.length - 1 - (Qt > -1 ? Qt : Ht - 1), ar = _e === "top" || _e === "bottom" ? "-50%" : "0";
      if (Zt > 0) {
        var Jt, rr, Yt;
        qt.height = wt ? (Jt = ut.current[Mt]) === null || Jt === void 0 ? void 0 : Jt.offsetHeight : dt == null ? void 0 : dt.offsetHeight;
        for (var Kt = 0, nr = 0; nr < Zt; nr++) {
          var tr;
          Kt += ((tr = ut.current[At[At.length - 1 - nr].key]) === null || tr === void 0 ? void 0 : tr.offsetHeight) + Pt;
        }
        var ir = (wt ? Kt : Zt * Bt) * (_e.startsWith("top") ? 1 : -1), sr = !wt && dt !== null && dt !== void 0 && dt.offsetWidth && (rr = ut.current[Mt]) !== null && rr !== void 0 && rr.offsetWidth ? ((dt == null ? void 0 : dt.offsetWidth) - Bt * 2 * (Zt < 3 ? Zt : 3)) / ((Yt = ut.current[Mt]) === null || Yt === void 0 ? void 0 : Yt.offsetWidth) : 1;
        qt.transform = "translate3d(".concat(ar, ", ").concat(ir, "px, 0) scaleX(").concat(sr, ")");
      } else
        qt.transform = "translate3d(".concat(ar, ", 0, 0)");
    }
    return /* @__PURE__ */ React$a.createElement("div", {
      ref: yt,
      className: classnames("".concat(tt, "-notice-wrapper"), kt, Dt == null ? void 0 : Dt.wrapper),
      style: _objectSpread2$a(_objectSpread2$a(_objectSpread2$a({}, jt), qt), Ut == null ? void 0 : Ut.wrapper),
      onMouseEnter: function() {
        return vt(function(or) {
          return or.includes(Mt) ? or : [].concat(_toConsumableArray$d(or), [Mt]);
        });
      },
      onMouseLeave: function() {
        return vt(function(or) {
          return or.filter(function(Xt) {
            return Xt !== Mt;
          });
        });
      }
    }, /* @__PURE__ */ React$a.createElement(Notify, _extends$2({}, Vt, {
      ref: function(or) {
        Qt > -1 ? ut.current[Mt] = or : delete ut.current[Mt];
      },
      prefixCls: tt,
      classNames: Dt,
      styles: Ut,
      className: classnames($t, it == null ? void 0 : it.notice),
      style: Tt,
      times: Nt,
      key: _t,
      eventKey: _t,
      onNoticeClose: st,
      hovering: Et && ct.length > 0
    })));
  });
}, Notifications = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = $ === void 0 ? "rc-notification" : $, _e = a.container, tt = a.motion, nt = a.maxCount, at = a.className, ot = a.style, rt = a.onAllRemoved, st = a.stack, lt = a.renderNotifications, et = reactExports.useState([]), it = _slicedToArray$e(et, 2), ut = it[0], ft = it[1], ht = function(bt) {
    var Et, St = ut.find(function(Bt) {
      return Bt.key === bt;
    });
    St == null || (Et = St.onClose) === null || Et === void 0 || Et.call(St), ft(function(Bt) {
      return Bt.filter(function(Ot) {
        return Ot.key !== bt;
      });
    });
  };
  reactExports.useImperativeHandle(s, function() {
    return {
      open: function(bt) {
        ft(function(Et) {
          var St = _toConsumableArray$d(Et), Bt = St.findIndex(function(wt) {
            return wt.key === bt.key;
          }), Ot = _objectSpread2$a({}, bt);
          if (Bt >= 0) {
            var Pt;
            Ot.times = (((Pt = Et[Bt]) === null || Pt === void 0 ? void 0 : Pt.times) || 0) + 1, St[Bt] = Ot;
          } else
            Ot.times = 0, St.push(Ot);
          return nt > 0 && St.length > nt && (St = St.slice(-nt)), St;
        });
      },
      close: function(bt) {
        ht(bt);
      },
      destroy: function() {
        ft([]);
      }
    };
  });
  var dt = reactExports.useState({}), gt = _slicedToArray$e(dt, 2), pt = gt[0], mt = gt[1];
  reactExports.useEffect(function() {
    var xt = {};
    ut.forEach(function(bt) {
      var Et = bt.placement, St = Et === void 0 ? "topRight" : Et;
      St && (xt[St] = xt[St] || [], xt[St].push(bt));
    }), Object.keys(pt).forEach(function(bt) {
      xt[bt] = xt[bt] || [];
    }), mt(xt);
  }, [ut]);
  var ct = function(bt) {
    mt(function(Et) {
      var St = _objectSpread2$a({}, Et), Bt = St[bt] || [];
      return Bt.length || delete St[bt], St;
    });
  }, vt = reactExports.useRef(!1);
  if (reactExports.useEffect(function() {
    Object.keys(pt).length > 0 ? vt.current = !0 : vt.current && (rt == null || rt(), vt.current = !1);
  }, [pt]), !_e)
    return null;
  var At = Object.keys(pt);
  return /* @__PURE__ */ reactDomExports.createPortal(/* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, At.map(function(xt) {
    var bt = pt[xt], Et = /* @__PURE__ */ reactExports.createElement(NoticeList, {
      key: xt,
      configList: bt,
      placement: xt,
      prefixCls: _,
      className: at == null ? void 0 : at(xt),
      style: ot == null ? void 0 : ot(xt),
      motion: tt,
      onNoticeClose: ht,
      onAllNoticeRemoved: ct,
      stack: st
    });
    return lt ? lt(Et, {
      prefixCls: _,
      key: xt
    }) : Et;
  })), _e);
}), _excluded$U = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"], defaultGetContainer$1 = function a() {
  return document.body;
}, uniqueKey = 0;
function mergeConfig() {
  for (var a = {}, s = arguments.length, $ = new Array(s), _ = 0; _ < s; _++)
    $[_] = arguments[_];
  return $.forEach(function(_e) {
    _e && Object.keys(_e).forEach(function(tt) {
      var nt = _e[tt];
      nt !== void 0 && (a[tt] = nt);
    });
  }), a;
}
function useNotification() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = a.getContainer, $ = s === void 0 ? defaultGetContainer$1 : s, _ = a.motion, _e = a.prefixCls, tt = a.maxCount, nt = a.className, at = a.style, ot = a.onAllRemoved, rt = a.stack, st = a.renderNotifications, lt = _objectWithoutProperties$1(a, _excluded$U), et = reactExports.useState(), it = _slicedToArray$e(et, 2), ut = it[0], ft = it[1], ht = reactExports.useRef(), dt = /* @__PURE__ */ reactExports.createElement(Notifications, {
    container: ut,
    ref: ht,
    prefixCls: _e,
    motion: _,
    maxCount: tt,
    className: nt,
    style: at,
    onAllRemoved: ot,
    stack: rt,
    renderNotifications: st
  }), gt = reactExports.useState([]), pt = _slicedToArray$e(gt, 2), mt = pt[0], ct = pt[1], vt = reactExports.useMemo(function() {
    return {
      open: function(xt) {
        var bt = mergeConfig(lt, xt);
        (bt.key === null || bt.key === void 0) && (bt.key = "rc-notification-".concat(uniqueKey), uniqueKey += 1), ct(function(Et) {
          return [].concat(_toConsumableArray$d(Et), [{
            type: "open",
            config: bt
          }]);
        });
      },
      close: function(xt) {
        ct(function(bt) {
          return [].concat(_toConsumableArray$d(bt), [{
            type: "close",
            key: xt
          }]);
        });
      },
      destroy: function() {
        ct(function(xt) {
          return [].concat(_toConsumableArray$d(xt), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  return reactExports.useEffect(function() {
    ft($());
  }), reactExports.useEffect(function() {
    ht.current && mt.length && (mt.forEach(function(At) {
      switch (At.type) {
        case "open":
          ht.current.open(At.config);
          break;
        case "close":
          ht.current.close(At.key);
          break;
        case "destroy":
          ht.current.destroy();
          break;
      }
    }), ct(function(At) {
      return At.filter(function(xt) {
        return !mt.includes(xt);
      });
    }));
  }, [mt]), [vt, dt];
}
var LoadingOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const LoadingOutlinedSvg = LoadingOutlined$2;
var LoadingOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: LoadingOutlinedSvg
  }));
};
const LoadingOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(LoadingOutlined), zIndexContext = /* @__PURE__ */ React$a.createContext(void 0), zIndexContext$1 = zIndexContext, CONTAINER_OFFSET = 100, CONTAINER_OFFSET_MAX_COUNT = 10, CONTAINER_MAX_OFFSET = CONTAINER_OFFSET * CONTAINER_OFFSET_MAX_COUNT, containerBaseZIndexOffset = {
  Modal: CONTAINER_OFFSET,
  Drawer: CONTAINER_OFFSET,
  Popover: CONTAINER_OFFSET,
  Popconfirm: CONTAINER_OFFSET,
  Tooltip: CONTAINER_OFFSET,
  Tour: CONTAINER_OFFSET
}, consumerBaseZIndexOffset = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function isContainerType(a) {
  return a in containerBaseZIndexOffset;
}
function useZIndex(a, s) {
  const [, $] = useToken$1(), _ = React$a.useContext(zIndexContext$1), _e = isContainerType(a);
  if (s !== void 0)
    return [s, s];
  let tt = _ ?? 0;
  return _e ? (tt += // Use preset token zIndex by default but not stack when has parent container
  (_ ? 0 : $.zIndexPopupBase) + // Container offset
  containerBaseZIndexOffset[a], tt = Math.min(tt, $.zIndexPopupBase + CONTAINER_MAX_OFFSET)) : tt += consumerBaseZIndexOffset[a], [_ === void 0 ? s : tt, tt];
}
const genMessageStyle = (a) => {
  const {
    componentCls: s,
    iconCls: $,
    boxShadow: _,
    colorText: _e,
    colorSuccess: tt,
    colorError: nt,
    colorWarning: at,
    colorInfo: ot,
    fontSizeLG: rt,
    motionEaseInOutCirc: st,
    motionDurationSlow: lt,
    marginXS: et,
    paddingXS: it,
    borderRadiusLG: ut,
    zIndexPopup: ft,
    // Custom token
    contentPadding: ht,
    contentBg: dt
  } = a, gt = `${s}-notice`, pt = new Keyframe("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: it,
      transform: "translateY(0)",
      opacity: 1
    }
  }), mt = new Keyframe("MessageMoveOut", {
    "0%": {
      maxHeight: a.height,
      padding: it,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  }), ct = {
    padding: it,
    textAlign: "center",
    [`${s}-custom-content > ${$}`]: {
      verticalAlign: "text-bottom",
      marginInlineEnd: et,
      // affected by ltr or rtl
      fontSize: rt
    },
    [`${gt}-content`]: {
      display: "inline-block",
      padding: ht,
      background: dt,
      borderRadius: ut,
      boxShadow: _,
      pointerEvents: "all"
    },
    [`${s}-success > ${$}`]: {
      color: tt
    },
    [`${s}-error > ${$}`]: {
      color: nt
    },
    [`${s}-warning > ${$}`]: {
      color: at
    },
    [`${s}-info > ${$},
      ${s}-loading > ${$}`]: {
      color: ot
    }
  };
  return [
    // ============================ Holder ============================
    {
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        color: _e,
        position: "fixed",
        top: et,
        width: "100%",
        pointerEvents: "none",
        zIndex: ft,
        [`${s}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${s}-move-up-appear,
        ${s}-move-up-enter
      `]: {
          animationName: pt,
          animationDuration: lt,
          animationPlayState: "paused",
          animationTimingFunction: st
        },
        [`
        ${s}-move-up-appear${s}-move-up-appear-active,
        ${s}-move-up-enter${s}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${s}-move-up-leave`]: {
          animationName: mt,
          animationDuration: lt,
          animationPlayState: "paused",
          animationTimingFunction: st
        },
        [`${s}-move-up-leave${s}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [s]: {
        [`${gt}-wrapper`]: Object.assign({}, ct)
      }
    },
    // ============================= Pure =============================
    {
      [`${s}-notice-pure-panel`]: Object.assign(Object.assign({}, ct), {
        padding: 0,
        textAlign: "start"
      })
    }
  ];
}, prepareComponentToken$u = (a) => ({
  zIndexPopup: a.zIndexPopupBase + CONTAINER_MAX_OFFSET + 10,
  contentBg: a.colorBgElevated,
  contentPadding: `${(a.controlHeightLG - a.fontSize * a.lineHeight) / 2}px ${a.paddingSM}px`
}), useStyle$x = genStyleHooks("Message", (a) => {
  const s = merge(a, {
    height: 150
  });
  return [genMessageStyle(s)];
}, prepareComponentToken$u);
var __rest$10 = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const TypeIcon = {
  info: /* @__PURE__ */ reactExports.createElement(InfoCircleFilled$1, null),
  success: /* @__PURE__ */ reactExports.createElement(CheckCircleFilled$1, null),
  error: /* @__PURE__ */ reactExports.createElement(CloseCircleFilled$1, null),
  warning: /* @__PURE__ */ reactExports.createElement(ExclamationCircleFilled$1, null),
  loading: /* @__PURE__ */ reactExports.createElement(LoadingOutlined$1, null)
}, PureContent = (a) => {
  let {
    prefixCls: s,
    type: $,
    icon: _,
    children: _e
  } = a;
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${s}-custom-content`, `${s}-${$}`)
  }, _ || TypeIcon[$], /* @__PURE__ */ reactExports.createElement("span", null, _e));
}, PurePanel$9 = (a) => {
  const {
    prefixCls: s,
    className: $,
    type: _,
    icon: _e,
    content: tt
  } = a, nt = __rest$10(a, ["prefixCls", "className", "type", "icon", "content"]), {
    getPrefixCls: at
  } = reactExports.useContext(ConfigContext$1), ot = s || at("message"), rt = useCSSVarCls$1(ot), [st, lt, et] = useStyle$x(ot, rt);
  return st(/* @__PURE__ */ reactExports.createElement(Notify, Object.assign({}, nt, {
    prefixCls: ot,
    className: classnames($, lt, `${ot}-notice-pure-panel`, et, rt),
    eventKey: "pure",
    duration: null,
    content: /* @__PURE__ */ reactExports.createElement(PureContent, {
      prefixCls: ot,
      type: _,
      icon: _e
    }, tt)
  })));
}, PurePanel$a = PurePanel$9;
function getMotion$2(a, s) {
  return {
    motionName: s ?? `${a}-move-up`
  };
}
function wrapPromiseFn(a) {
  let s;
  const $ = new Promise((_e) => {
    s = a(() => {
      _e(!0);
    });
  }), _ = () => {
    s == null || s();
  };
  return _.then = (_e, tt) => $.then(_e, tt), _.promise = $, _;
}
var __rest$$ = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const DEFAULT_OFFSET = 8, DEFAULT_DURATION = 3, Wrapper$1 = (a) => {
  let {
    children: s,
    prefixCls: $
  } = a;
  const _ = useCSSVarCls$1($), [_e, tt, nt] = useStyle$x($, _);
  return _e(/* @__PURE__ */ reactExports.createElement(NotificationProvider, {
    classNames: {
      list: classnames(tt, nt, _)
    }
  }, s));
}, renderNotifications = (a, s) => {
  let {
    prefixCls: $,
    key: _
  } = s;
  return /* @__PURE__ */ reactExports.createElement(Wrapper$1, {
    prefixCls: $,
    key: _
  }, a);
}, Holder = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    top: $,
    prefixCls: _,
    getContainer: _e,
    maxCount: tt,
    duration: nt = DEFAULT_DURATION,
    rtl: at,
    transitionName: ot,
    onAllRemoved: rt
  } = a, {
    getPrefixCls: st,
    getPopupContainer: lt,
    message: et
  } = reactExports.useContext(ConfigContext$1), it = _ || st("message"), ut = () => ({
    left: "50%",
    transform: "translateX(-50%)",
    top: $ ?? DEFAULT_OFFSET
  }), ft = () => classnames({
    [`${it}-rtl`]: at
  }), ht = () => getMotion$2(it, ot), dt = /* @__PURE__ */ reactExports.createElement("span", {
    className: `${it}-close-x`
  }, /* @__PURE__ */ reactExports.createElement(CloseOutlined$4, {
    className: `${it}-close-icon`
  })), [gt, pt] = useNotification({
    prefixCls: it,
    style: ut,
    className: ft,
    motion: ht,
    closable: !1,
    closeIcon: dt,
    duration: nt,
    getContainer: () => (_e == null ? void 0 : _e()) || (lt == null ? void 0 : lt()) || document.body,
    maxCount: tt,
    onAllRemoved: rt,
    renderNotifications
  });
  return reactExports.useImperativeHandle(s, () => Object.assign(Object.assign({}, gt), {
    prefixCls: it,
    message: et
  })), pt;
});
let keyIndex = 0;
function useInternalMessage(a) {
  const s = reactExports.useRef(null);
  return devUseWarning(), [reactExports.useMemo(() => {
    const _ = (ot) => {
      var rt;
      (rt = s.current) === null || rt === void 0 || rt.close(ot);
    }, _e = (ot) => {
      if (!s.current) {
        const vt = () => {
        };
        return vt.then = () => {
        }, vt;
      }
      const {
        open: rt,
        prefixCls: st,
        message: lt
      } = s.current, et = `${st}-notice`, {
        content: it,
        icon: ut,
        type: ft,
        key: ht,
        className: dt,
        style: gt,
        onClose: pt
      } = ot, mt = __rest$$(ot, ["content", "icon", "type", "key", "className", "style", "onClose"]);
      let ct = ht;
      return ct == null && (keyIndex += 1, ct = `antd-message-${keyIndex}`), wrapPromiseFn((vt) => (rt(Object.assign(Object.assign({}, mt), {
        key: ct,
        content: /* @__PURE__ */ reactExports.createElement(PureContent, {
          prefixCls: st,
          type: ft,
          icon: ut
        }, it),
        placement: "top",
        className: classnames(ft && `${et}-${ft}`, dt, lt == null ? void 0 : lt.className),
        style: Object.assign(Object.assign({}, lt == null ? void 0 : lt.style), gt),
        onClose: () => {
          pt == null || pt(), vt();
        }
      })), () => {
        _(ct);
      }));
    }, nt = {
      open: _e,
      destroy: (ot) => {
        var rt;
        ot !== void 0 ? _(ot) : (rt = s.current) === null || rt === void 0 || rt.destroy();
      }
    };
    return ["info", "success", "warning", "error", "loading"].forEach((ot) => {
      const rt = (st, lt, et) => {
        let it;
        st && typeof st == "object" && "content" in st ? it = st : it = {
          content: st
        };
        let ut, ft;
        typeof lt == "function" ? ft = lt : (ut = lt, ft = et);
        const ht = Object.assign(Object.assign({
          onClose: ft,
          duration: ut
        }, it), {
          type: ot
        });
        return _e(ht);
      };
      nt[ot] = rt;
    }), nt;
  }, []), /* @__PURE__ */ reactExports.createElement(Holder, Object.assign({
    key: "message-holder"
  }, a, {
    ref: s
  }))];
}
function useMessage(a) {
  return useInternalMessage(a);
}
function _regeneratorRuntime$3() {
  _regeneratorRuntime$3 = function() {
    return s;
  };
  var a, s = {}, $ = Object.prototype, _ = $.hasOwnProperty, _e = Object.defineProperty || function(Ct, It, yt) {
    Ct[It] = yt.value;
  }, tt = typeof Symbol == "function" ? Symbol : {}, nt = tt.iterator || "@@iterator", at = tt.asyncIterator || "@@asyncIterator", ot = tt.toStringTag || "@@toStringTag";
  function rt(Ct, It, yt) {
    return Object.defineProperty(Ct, It, {
      value: yt,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), Ct[It];
  }
  try {
    rt({}, "");
  } catch {
    rt = function(yt, Rt, kt) {
      return yt[Rt] = kt;
    };
  }
  function st(Ct, It, yt, Rt) {
    var kt = It && It.prototype instanceof dt ? It : dt, jt = Object.create(kt.prototype), Ht = new Pt(Rt || []);
    return _e(jt, "_invoke", {
      value: Et(Ct, yt, Ht)
    }), jt;
  }
  function lt(Ct, It, yt) {
    try {
      return {
        type: "normal",
        arg: Ct.call(It, yt)
      };
    } catch (Rt) {
      return {
        type: "throw",
        arg: Rt
      };
    }
  }
  s.wrap = st;
  var et = "suspendedStart", it = "suspendedYield", ut = "executing", ft = "completed", ht = {};
  function dt() {
  }
  function gt() {
  }
  function pt() {
  }
  var mt = {};
  rt(mt, nt, function() {
    return this;
  });
  var ct = Object.getPrototypeOf, vt = ct && ct(ct(wt([])));
  vt && vt !== $ && _.call(vt, nt) && (mt = vt);
  var At = pt.prototype = dt.prototype = Object.create(mt);
  function xt(Ct) {
    ["next", "throw", "return"].forEach(function(It) {
      rt(Ct, It, function(yt) {
        return this._invoke(It, yt);
      });
    });
  }
  function bt(Ct, It) {
    function yt(kt, jt, Ht, Ft) {
      var _t = lt(Ct[kt], Ct, jt);
      if (_t.type !== "throw") {
        var Nt = _t.arg, Mt = Nt.value;
        return Mt && _typeof$q(Mt) == "object" && _.call(Mt, "__await") ? It.resolve(Mt.__await).then(function(Lt) {
          yt("next", Lt, Ht, Ft);
        }, function(Lt) {
          yt("throw", Lt, Ht, Ft);
        }) : It.resolve(Mt).then(function(Lt) {
          Nt.value = Lt, Ht(Nt);
        }, function(Lt) {
          return yt("throw", Lt, Ht, Ft);
        });
      }
      Ft(_t.arg);
    }
    var Rt;
    _e(this, "_invoke", {
      value: function(jt, Ht) {
        function Ft() {
          return new It(function(_t, Nt) {
            yt(jt, Ht, _t, Nt);
          });
        }
        return Rt = Rt ? Rt.then(Ft, Ft) : Ft();
      }
    });
  }
  function Et(Ct, It, yt) {
    var Rt = et;
    return function(kt, jt) {
      if (Rt === ut)
        throw new Error("Generator is already running");
      if (Rt === ft) {
        if (kt === "throw")
          throw jt;
        return {
          value: a,
          done: !0
        };
      }
      for (yt.method = kt, yt.arg = jt; ; ) {
        var Ht = yt.delegate;
        if (Ht) {
          var Ft = St(Ht, yt);
          if (Ft) {
            if (Ft === ht)
              continue;
            return Ft;
          }
        }
        if (yt.method === "next")
          yt.sent = yt._sent = yt.arg;
        else if (yt.method === "throw") {
          if (Rt === et)
            throw Rt = ft, yt.arg;
          yt.dispatchException(yt.arg);
        } else
          yt.method === "return" && yt.abrupt("return", yt.arg);
        Rt = ut;
        var _t = lt(Ct, It, yt);
        if (_t.type === "normal") {
          if (Rt = yt.done ? ft : it, _t.arg === ht)
            continue;
          return {
            value: _t.arg,
            done: yt.done
          };
        }
        _t.type === "throw" && (Rt = ft, yt.method = "throw", yt.arg = _t.arg);
      }
    };
  }
  function St(Ct, It) {
    var yt = It.method, Rt = Ct.iterator[yt];
    if (Rt === a)
      return It.delegate = null, yt === "throw" && Ct.iterator.return && (It.method = "return", It.arg = a, St(Ct, It), It.method === "throw") || yt !== "return" && (It.method = "throw", It.arg = new TypeError("The iterator does not provide a '" + yt + "' method")), ht;
    var kt = lt(Rt, Ct.iterator, It.arg);
    if (kt.type === "throw")
      return It.method = "throw", It.arg = kt.arg, It.delegate = null, ht;
    var jt = kt.arg;
    return jt ? jt.done ? (It[Ct.resultName] = jt.value, It.next = Ct.nextLoc, It.method !== "return" && (It.method = "next", It.arg = a), It.delegate = null, ht) : jt : (It.method = "throw", It.arg = new TypeError("iterator result is not an object"), It.delegate = null, ht);
  }
  function Bt(Ct) {
    var It = {
      tryLoc: Ct[0]
    };
    1 in Ct && (It.catchLoc = Ct[1]), 2 in Ct && (It.finallyLoc = Ct[2], It.afterLoc = Ct[3]), this.tryEntries.push(It);
  }
  function Ot(Ct) {
    var It = Ct.completion || {};
    It.type = "normal", delete It.arg, Ct.completion = It;
  }
  function Pt(Ct) {
    this.tryEntries = [{
      tryLoc: "root"
    }], Ct.forEach(Bt, this), this.reset(!0);
  }
  function wt(Ct) {
    if (Ct || Ct === "") {
      var It = Ct[nt];
      if (It)
        return It.call(Ct);
      if (typeof Ct.next == "function")
        return Ct;
      if (!isNaN(Ct.length)) {
        var yt = -1, Rt = function kt() {
          for (; ++yt < Ct.length; )
            if (_.call(Ct, yt))
              return kt.value = Ct[yt], kt.done = !1, kt;
          return kt.value = a, kt.done = !0, kt;
        };
        return Rt.next = Rt;
      }
    }
    throw new TypeError(_typeof$q(Ct) + " is not iterable");
  }
  return gt.prototype = pt, _e(At, "constructor", {
    value: pt,
    configurable: !0
  }), _e(pt, "constructor", {
    value: gt,
    configurable: !0
  }), gt.displayName = rt(pt, ot, "GeneratorFunction"), s.isGeneratorFunction = function(Ct) {
    var It = typeof Ct == "function" && Ct.constructor;
    return !!It && (It === gt || (It.displayName || It.name) === "GeneratorFunction");
  }, s.mark = function(Ct) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(Ct, pt) : (Ct.__proto__ = pt, rt(Ct, ot, "GeneratorFunction")), Ct.prototype = Object.create(At), Ct;
  }, s.awrap = function(Ct) {
    return {
      __await: Ct
    };
  }, xt(bt.prototype), rt(bt.prototype, at, function() {
    return this;
  }), s.AsyncIterator = bt, s.async = function(Ct, It, yt, Rt, kt) {
    kt === void 0 && (kt = Promise);
    var jt = new bt(st(Ct, It, yt, Rt), kt);
    return s.isGeneratorFunction(It) ? jt : jt.next().then(function(Ht) {
      return Ht.done ? Ht.value : jt.next();
    });
  }, xt(At), rt(At, ot, "Generator"), rt(At, nt, function() {
    return this;
  }), rt(At, "toString", function() {
    return "[object Generator]";
  }), s.keys = function(Ct) {
    var It = Object(Ct), yt = [];
    for (var Rt in It)
      yt.push(Rt);
    return yt.reverse(), function kt() {
      for (; yt.length; ) {
        var jt = yt.pop();
        if (jt in It)
          return kt.value = jt, kt.done = !1, kt;
      }
      return kt.done = !0, kt;
    };
  }, s.values = wt, Pt.prototype = {
    constructor: Pt,
    reset: function(It) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = a, this.done = !1, this.delegate = null, this.method = "next", this.arg = a, this.tryEntries.forEach(Ot), !It)
        for (var yt in this)
          yt.charAt(0) === "t" && _.call(this, yt) && !isNaN(+yt.slice(1)) && (this[yt] = a);
    },
    stop: function() {
      this.done = !0;
      var It = this.tryEntries[0].completion;
      if (It.type === "throw")
        throw It.arg;
      return this.rval;
    },
    dispatchException: function(It) {
      if (this.done)
        throw It;
      var yt = this;
      function Rt(Nt, Mt) {
        return Ht.type = "throw", Ht.arg = It, yt.next = Nt, Mt && (yt.method = "next", yt.arg = a), !!Mt;
      }
      for (var kt = this.tryEntries.length - 1; kt >= 0; --kt) {
        var jt = this.tryEntries[kt], Ht = jt.completion;
        if (jt.tryLoc === "root")
          return Rt("end");
        if (jt.tryLoc <= this.prev) {
          var Ft = _.call(jt, "catchLoc"), _t = _.call(jt, "finallyLoc");
          if (Ft && _t) {
            if (this.prev < jt.catchLoc)
              return Rt(jt.catchLoc, !0);
            if (this.prev < jt.finallyLoc)
              return Rt(jt.finallyLoc);
          } else if (Ft) {
            if (this.prev < jt.catchLoc)
              return Rt(jt.catchLoc, !0);
          } else {
            if (!_t)
              throw new Error("try statement without catch or finally");
            if (this.prev < jt.finallyLoc)
              return Rt(jt.finallyLoc);
          }
        }
      }
    },
    abrupt: function(It, yt) {
      for (var Rt = this.tryEntries.length - 1; Rt >= 0; --Rt) {
        var kt = this.tryEntries[Rt];
        if (kt.tryLoc <= this.prev && _.call(kt, "finallyLoc") && this.prev < kt.finallyLoc) {
          var jt = kt;
          break;
        }
      }
      jt && (It === "break" || It === "continue") && jt.tryLoc <= yt && yt <= jt.finallyLoc && (jt = null);
      var Ht = jt ? jt.completion : {};
      return Ht.type = It, Ht.arg = yt, jt ? (this.method = "next", this.next = jt.finallyLoc, ht) : this.complete(Ht);
    },
    complete: function(It, yt) {
      if (It.type === "throw")
        throw It.arg;
      return It.type === "break" || It.type === "continue" ? this.next = It.arg : It.type === "return" ? (this.rval = this.arg = It.arg, this.method = "return", this.next = "end") : It.type === "normal" && yt && (this.next = yt), ht;
    },
    finish: function(It) {
      for (var yt = this.tryEntries.length - 1; yt >= 0; --yt) {
        var Rt = this.tryEntries[yt];
        if (Rt.finallyLoc === It)
          return this.complete(Rt.completion, Rt.afterLoc), Ot(Rt), ht;
      }
    },
    catch: function(It) {
      for (var yt = this.tryEntries.length - 1; yt >= 0; --yt) {
        var Rt = this.tryEntries[yt];
        if (Rt.tryLoc === It) {
          var kt = Rt.completion;
          if (kt.type === "throw") {
            var jt = kt.arg;
            Ot(Rt);
          }
          return jt;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(It, yt, Rt) {
      return this.delegate = {
        iterator: wt(It),
        resultName: yt,
        nextLoc: Rt
      }, this.method === "next" && (this.arg = a), ht;
    }
  }, s;
}
function asyncGeneratorStep(a, s, $, _, _e, tt, nt) {
  try {
    var at = a[tt](nt), ot = at.value;
  } catch (rt) {
    $(rt);
    return;
  }
  at.done ? s(ot) : Promise.resolve(ot).then(_, _e);
}
function _asyncToGenerator(a) {
  return function() {
    var s = this, $ = arguments;
    return new Promise(function(_, _e) {
      var tt = a.apply(s, $);
      function nt(ot) {
        asyncGeneratorStep(tt, _, _e, nt, at, "next", ot);
      }
      function at(ot) {
        asyncGeneratorStep(tt, _, _e, nt, at, "throw", ot);
      }
      nt(void 0);
    });
  };
}
var fullClone = _objectSpread2$a({}, ReactDOM$1), version = fullClone.version, reactRender = fullClone.render, unmountComponentAtNode = fullClone.unmountComponentAtNode, createRoot;
try {
  var mainVersion = Number((version || "").split(".")[0]);
  mainVersion >= 18 && (createRoot = fullClone.createRoot);
} catch (a) {
}
function toggleWarning(a) {
  var s = fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  s && _typeof$q(s) === "object" && (s.usingClientEntryPoint = a);
}
var MARK = "__rc_react_root__";
function modernRender(a, s) {
  toggleWarning(!0);
  var $ = s[MARK] || createRoot(s);
  toggleWarning(!1), $.render(a), s[MARK] = $;
}
function legacyRender(a, s) {
  reactRender(a, s);
}
function render(a, s) {
  if (createRoot) {
    modernRender(a, s);
    return;
  }
  legacyRender(a, s);
}
function modernUnmount(a) {
  return _modernUnmount.apply(this, arguments);
}
function _modernUnmount() {
  return _modernUnmount = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function a(s) {
    return _regeneratorRuntime$3().wrap(function(_) {
      for (; ; )
        switch (_.prev = _.next) {
          case 0:
            return _.abrupt("return", Promise.resolve().then(function() {
              var _e;
              (_e = s[MARK]) === null || _e === void 0 || _e.unmount(), delete s[MARK];
            }));
          case 1:
          case "end":
            return _.stop();
        }
    }, a);
  })), _modernUnmount.apply(this, arguments);
}
function legacyUnmount(a) {
  unmountComponentAtNode(a);
}
function unmount(a) {
  return _unmount.apply(this, arguments);
}
function _unmount() {
  return _unmount = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function a(s) {
    return _regeneratorRuntime$3().wrap(function(_) {
      for (; ; )
        switch (_.prev = _.next) {
          case 0:
            if (createRoot === void 0) {
              _.next = 2;
              break;
            }
            return _.abrupt("return", modernUnmount(s));
          case 2:
            legacyUnmount(s);
          case 3:
          case "end":
            return _.stop();
        }
    }, a);
  })), _unmount.apply(this, arguments);
}
const getCollapsedHeight = () => ({
  height: 0,
  opacity: 0
}), getRealHeight = (a) => {
  const {
    scrollHeight: s
  } = a;
  return {
    height: s,
    opacity: 1
  };
}, getCurrentHeight = (a) => ({
  height: a ? a.offsetHeight : 0
}), skipOpacityTransition = (a, s) => (s == null ? void 0 : s.deadline) === !0 || s.propertyName === "height", initCollapseMotion = function() {
  return {
    motionName: `${arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant"}-motion-collapse`,
    onAppearStart: getCollapsedHeight,
    onEnterStart: getCollapsedHeight,
    onAppearActive: getRealHeight,
    onEnterActive: getRealHeight,
    onLeaveStart: getCurrentHeight,
    onLeaveActive: getCollapsedHeight,
    onAppearEnd: skipOpacityTransition,
    onEnterEnd: skipOpacityTransition,
    onLeaveEnd: skipOpacityTransition,
    motionDeadline: 500
  };
}, getTransitionName$1 = (a, s, $) => $ !== void 0 ? $ : `${a}-${s}`, initCollapseMotion$1 = initCollapseMotion, isVisible = function(a) {
  if (!a)
    return !1;
  if (a instanceof Element) {
    if (a.offsetParent)
      return !0;
    if (a.getBBox) {
      var s = a.getBBox(), $ = s.width, _ = s.height;
      if ($ || _)
        return !0;
    }
    if (a.getBoundingClientRect) {
      var _e = a.getBoundingClientRect(), tt = _e.width, nt = _e.height;
      if (tt || nt)
        return !0;
    }
  }
  return !1;
}, genWaveStyle = (a) => {
  const {
    componentCls: s,
    colorPrimary: $
  } = a;
  return {
    [s]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${$})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${a.motionEaseOutCirc}`, `opacity 2s ${a.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow 0.3s ${a.motionEaseInOut}`, `opacity 0.35s ${a.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, useStyle$w = genComponentStyleHook("Wave", (a) => [genWaveStyle(a)]);
function isNotGrey(a) {
  const s = (a || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  return s && s[1] && s[2] && s[3] ? !(s[1] === s[2] && s[2] === s[3]) : !0;
}
function isValidWaveColor(a) {
  return a && a !== "#fff" && a !== "#ffffff" && a !== "rgb(255, 255, 255)" && a !== "rgba(255, 255, 255, 1)" && isNotGrey(a) && !/rgba\((?:\d*, ){3}0\)/.test(a) && // any transparent rgba color
  a !== "transparent";
}
function getTargetWaveColor(a) {
  const {
    borderTopColor: s,
    borderColor: $,
    backgroundColor: _
  } = getComputedStyle(a);
  return isValidWaveColor(s) ? s : isValidWaveColor($) ? $ : isValidWaveColor(_) ? _ : null;
}
const TARGET_CLS = "ant-wave-target";
function validateNum(a) {
  return Number.isNaN(a) ? 0 : a;
}
const WaveEffect = (a) => {
  const {
    className: s,
    target: $,
    component: _
  } = a, _e = reactExports.useRef(null), [tt, nt] = reactExports.useState(null), [at, ot] = reactExports.useState([]), [rt, st] = reactExports.useState(0), [lt, et] = reactExports.useState(0), [it, ut] = reactExports.useState(0), [ft, ht] = reactExports.useState(0), [dt, gt] = reactExports.useState(!1), pt = {
    left: rt,
    top: lt,
    width: it,
    height: ft,
    borderRadius: at.map((vt) => `${vt}px`).join(" ")
  };
  tt && (pt["--wave-color"] = tt);
  function mt() {
    const vt = getComputedStyle($);
    nt(getTargetWaveColor($));
    const At = vt.position === "static", {
      borderLeftWidth: xt,
      borderTopWidth: bt
    } = vt;
    st(At ? $.offsetLeft : validateNum(-parseFloat(xt))), et(At ? $.offsetTop : validateNum(-parseFloat(bt))), ut($.offsetWidth), ht($.offsetHeight);
    const {
      borderTopLeftRadius: Et,
      borderTopRightRadius: St,
      borderBottomLeftRadius: Bt,
      borderBottomRightRadius: Ot
    } = vt;
    ot([Et, St, Ot, Bt].map((Pt) => validateNum(parseFloat(Pt))));
  }
  if (reactExports.useEffect(() => {
    if ($) {
      const vt = wrapperRaf(() => {
        mt(), gt(!0);
      });
      let At;
      return typeof ResizeObserver < "u" && (At = new ResizeObserver(mt), At.observe($)), () => {
        wrapperRaf.cancel(vt), At == null || At.disconnect();
      };
    }
  }, []), !dt)
    return null;
  const ct = (_ === "Checkbox" || _ === "Radio") && ($ == null ? void 0 : $.classList.contains(TARGET_CLS));
  return /* @__PURE__ */ reactExports.createElement(CSSMotion, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (vt, At) => {
      var xt;
      if (At.deadline || At.propertyName === "opacity") {
        const bt = (xt = _e.current) === null || xt === void 0 ? void 0 : xt.parentElement;
        unmount(bt).then(() => {
          bt == null || bt.remove();
        });
      }
      return !1;
    }
  }, (vt) => {
    let {
      className: At
    } = vt;
    return /* @__PURE__ */ reactExports.createElement("div", {
      ref: _e,
      className: classnames(s, {
        "wave-quick": ct
      }, At),
      style: pt
    });
  });
}, showWaveEffect = (a, s) => {
  var $;
  const {
    component: _
  } = s;
  if (_ === "Checkbox" && !(!(($ = a.querySelector("input")) === null || $ === void 0) && $.checked))
    return;
  const _e = document.createElement("div");
  _e.style.position = "absolute", _e.style.left = "0px", _e.style.top = "0px", a == null || a.insertBefore(_e, a == null ? void 0 : a.firstChild), render(/* @__PURE__ */ reactExports.createElement(WaveEffect, Object.assign({}, s, {
    target: a
  })), _e);
}, showWaveEffect$1 = showWaveEffect;
function useWave(a, s, $) {
  const {
    wave: _
  } = reactExports.useContext(ConfigContext$1), [, _e, tt] = useToken$1(), nt = useEvent((rt) => {
    const st = a.current;
    if (_ != null && _.disabled || !st)
      return;
    const lt = st.querySelector(`.${TARGET_CLS}`) || st, {
      showEffect: et
    } = _ || {};
    (et || showWaveEffect$1)(lt, {
      className: s,
      token: _e,
      component: $,
      event: rt,
      hashId: tt
    });
  }), at = reactExports.useRef();
  return (rt) => {
    wrapperRaf.cancel(at.current), at.current = wrapperRaf(() => {
      nt(rt);
    });
  };
}
const Wave = (a) => {
  const {
    children: s,
    disabled: $,
    component: _
  } = a, {
    getPrefixCls: _e
  } = reactExports.useContext(ConfigContext$1), tt = reactExports.useRef(null), nt = _e("wave"), [, at] = useStyle$w(nt), ot = useWave(tt, classnames(nt, at), _);
  if (React$a.useEffect(() => {
    const st = tt.current;
    if (!st || st.nodeType !== 1 || $)
      return;
    const lt = (et) => {
      !isVisible(et.target) || // No need wave
      !st.getAttribute || st.getAttribute("disabled") || st.disabled || st.className.includes("disabled") || st.className.includes("-leave") || ot(et);
    };
    return st.addEventListener("click", lt, !0), () => {
      st.removeEventListener("click", lt, !0);
    };
  }, [$]), !/* @__PURE__ */ React$a.isValidElement(s))
    return s ?? null;
  const rt = supportRef(s) ? composeRef(s.ref, tt) : tt;
  return cloneElement(s, {
    ref: rt
  });
}, Wave$1 = Wave, useSize = (a) => {
  const s = React$a.useContext(SizeContext$1);
  return React$a.useMemo(() => a ? typeof a == "string" ? a ?? s : a instanceof Function ? a(s) : s : s, [a, s]);
}, useSize$1 = useSize, genSpaceCompactStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
}, genSpaceCompactStyle$1 = genSpaceCompactStyle, genSpaceStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${s}-item:empty`]: {
        display: "none"
      }
    }
  };
}, genSpaceGapStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: {
      "&-gap-row-small": {
        rowGap: a.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: a.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: a.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: a.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: a.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: a.spaceGapLargeSize
      }
    }
  };
}, useStyle$v = genStyleHooks("Space", (a) => {
  const s = merge(a, {
    spaceGapSmallSize: a.paddingXS,
    spaceGapMiddleSize: a.padding,
    spaceGapLargeSize: a.paddingLG
  });
  return [genSpaceStyle(s), genSpaceGapStyle(s), genSpaceCompactStyle$1(s)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var __rest$_ = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const SpaceCompactItemContext = /* @__PURE__ */ reactExports.createContext(null), useCompactItemContext = (a, s) => {
  const $ = reactExports.useContext(SpaceCompactItemContext), _ = reactExports.useMemo(() => {
    if (!$)
      return "";
    const {
      compactDirection: _e,
      isFirstItem: tt,
      isLastItem: nt
    } = $, at = _e === "vertical" ? "-vertical-" : "-";
    return classnames(`${a}-compact${at}item`, {
      [`${a}-compact${at}first-item`]: tt,
      [`${a}-compact${at}last-item`]: nt,
      [`${a}-compact${at}item-rtl`]: s === "rtl"
    });
  }, [a, s, $]);
  return {
    compactSize: $ == null ? void 0 : $.compactSize,
    compactDirection: $ == null ? void 0 : $.compactDirection,
    compactItemClassnames: _
  };
}, NoCompactStyle = (a) => {
  let {
    children: s
  } = a;
  return /* @__PURE__ */ reactExports.createElement(SpaceCompactItemContext.Provider, {
    value: null
  }, s);
}, CompactItem = (a) => {
  var {
    children: s
  } = a, $ = __rest$_(a, ["children"]);
  return /* @__PURE__ */ reactExports.createElement(SpaceCompactItemContext.Provider, {
    value: $
  }, s);
}, Compact = (a) => {
  const {
    getPrefixCls: s,
    direction: $
  } = reactExports.useContext(ConfigContext$1), {
    size: _,
    direction: _e,
    block: tt,
    prefixCls: nt,
    className: at,
    rootClassName: ot,
    children: rt
  } = a, st = __rest$_(a, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), lt = useSize$1((pt) => _ ?? pt), et = s("space-compact", nt), [it, ut] = useStyle$v(et), ft = classnames(et, ut, {
    [`${et}-rtl`]: $ === "rtl",
    [`${et}-block`]: tt,
    [`${et}-vertical`]: _e === "vertical"
  }, at, ot), ht = reactExports.useContext(SpaceCompactItemContext), dt = toArray$9(rt), gt = reactExports.useMemo(() => dt.map((pt, mt) => {
    const ct = pt && pt.key || `${et}-item-${mt}`;
    return /* @__PURE__ */ reactExports.createElement(CompactItem, {
      key: ct,
      compactSize: lt,
      compactDirection: _e,
      isFirstItem: mt === 0 && (!ht || (ht == null ? void 0 : ht.isFirstItem)),
      isLastItem: mt === dt.length - 1 && (!ht || (ht == null ? void 0 : ht.isLastItem))
    }, pt);
  }), [_, dt, ht]);
  return dt.length === 0 ? null : it(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    className: ft
  }, st), gt));
};
var __rest$Z = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const GroupSizeContext = /* @__PURE__ */ reactExports.createContext(void 0), ButtonGroup = (a) => {
  const {
    getPrefixCls: s,
    direction: $
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: _,
    size: _e,
    className: tt
  } = a, nt = __rest$Z(a, ["prefixCls", "size", "className"]), at = s("btn-group", _), [, , ot] = useToken$1();
  let rt = "";
  switch (_e) {
    case "large":
      rt = "lg";
      break;
    case "small":
      rt = "sm";
      break;
  }
  const st = classnames(at, {
    [`${at}-${rt}`]: rt,
    [`${at}-rtl`]: $ === "rtl"
  }, tt, ot);
  return /* @__PURE__ */ reactExports.createElement(GroupSizeContext.Provider, {
    value: _e
  }, /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, nt, {
    className: st
  })));
}, Group$5 = ButtonGroup, rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/, isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function convertLegacyProps(a) {
  return a === "danger" ? {
    danger: !0
  } : {
    type: a
  };
}
function isString$1(a) {
  return typeof a == "string";
}
function isUnBorderedButtonType(a) {
  return a === "text" || a === "link";
}
function splitCNCharsBySpace(a, s) {
  if (a == null)
    return;
  const $ = s ? " " : "";
  return typeof a != "string" && typeof a != "number" && isString$1(a.type) && isTwoCNChar(a.props.children) ? cloneElement(a, {
    children: a.props.children.split("").join($)
  }) : isString$1(a) ? isTwoCNChar(a) ? /* @__PURE__ */ React$a.createElement("span", null, a.split("").join($)) : /* @__PURE__ */ React$a.createElement("span", null, a) : isFragment(a) ? /* @__PURE__ */ React$a.createElement("span", null, a) : a;
}
function spaceChildren(a, s) {
  let $ = !1;
  const _ = [];
  return React$a.Children.forEach(a, (_e) => {
    const tt = typeof _e, nt = tt === "string" || tt === "number";
    if ($ && nt) {
      const at = _.length - 1, ot = _[at];
      _[at] = `${ot}${_e}`;
    } else
      _.push(_e);
    $ = nt;
  }), React$a.Children.map(_, (_e) => splitCNCharsBySpace(_e, s));
}
const IconWrapper = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    className: $,
    style: _,
    children: _e,
    prefixCls: tt
  } = a, nt = classnames(`${tt}-icon`, $);
  return /* @__PURE__ */ React$a.createElement("span", {
    ref: s,
    className: nt,
    style: _
  }, _e);
}), IconWrapper$1 = IconWrapper, InnerLoadingIcon = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  let {
    prefixCls: $,
    className: _,
    style: _e,
    iconClassName: tt
  } = a;
  const nt = classnames(`${$}-loading-icon`, _);
  return /* @__PURE__ */ React$a.createElement(IconWrapper$1, {
    prefixCls: $,
    className: nt,
    style: _e,
    ref: s
  }, /* @__PURE__ */ React$a.createElement(LoadingOutlined$1, {
    className: tt
  }));
}), getCollapsedWidth = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), getRealWidth = (a) => ({
  width: a.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), LoadingIcon = (a) => {
  const {
    prefixCls: s,
    loading: $,
    existIcon: _,
    className: _e,
    style: tt
  } = a, nt = !!$;
  return _ ? /* @__PURE__ */ React$a.createElement(InnerLoadingIcon, {
    prefixCls: s,
    className: _e,
    style: tt
  }) : /* @__PURE__ */ React$a.createElement(CSSMotion, {
    visible: nt,
    // We do not really use this motionName
    motionName: `${s}-loading-icon-motion`,
    motionLeave: nt,
    removeOnLeave: !0,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, (at, ot) => {
    let {
      className: rt,
      style: st
    } = at;
    return /* @__PURE__ */ React$a.createElement(InnerLoadingIcon, {
      prefixCls: s,
      className: _e,
      style: Object.assign(Object.assign({}, tt), st),
      ref: ot,
      iconClassName: rt
    });
  });
}, LoadingIcon$1 = LoadingIcon, genButtonBorderStyle = (a, s) => ({
  // Border
  [`> span, > ${a}`]: {
    "&:not(:last-child)": {
      [`&, & > ${a}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: s
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${a}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: s
        }
      }
    }
  }
}), genGroupStyle$1 = (a) => {
  const {
    componentCls: s,
    fontSize: $,
    lineWidth: _,
    groupBorderColor: _e,
    colorErrorHover: tt
  } = a;
  return {
    [`${s}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${s}`]: {
          "&:not(:last-child)": {
            [`&, & > ${s}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: a.calc(_).mul(-1).equal(),
            [`&, & > ${s}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [s]: {
          position: "relative",
          zIndex: 1,
          "&:hover,\n          &:focus,\n          &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${s}-icon-only`]: {
          fontSize: $
        }
      },
      // Border Color
      genButtonBorderStyle(`${s}-primary`, _e),
      genButtonBorderStyle(`${s}-danger`, tt)
    ]
  };
}, genGroupStyle$2 = genGroupStyle$1, genSharedButtonStyle = (a) => {
  const {
    componentCls: s,
    iconCls: $,
    fontWeight: _
  } = a;
  return {
    [s]: {
      outline: "none",
      position: "relative",
      display: "inline-block",
      fontWeight: _,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${unit$1(a.lineWidth)} ${a.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${a.motionDurationMid} ${a.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      lineHeight: a.lineHeight,
      color: a.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      "> span": {
        display: "inline-block"
      },
      [`${s}-icon`]: {
        lineHeight: 0
      },
      // Leave a space between icon and text.
      [`> ${$} + span, > span + ${$}`]: {
        marginInlineStart: a.marginXS
      },
      [`&:not(${s}-icon-only) > ${s}-icon`]: {
        [`&${s}-loading-icon, &:not(:last-child)`]: {
          marginInlineEnd: a.marginXS
        }
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Object.assign({}, genFocusStyle(a)),
      [`&${s}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${s}-two-chinese-chars > *:not(${$})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      // make `btn-icon-only` not too narrow
      [`&-icon-only${s}-compact-item`]: {
        flex: "none"
      }
    }
  };
}, genHoverActiveButtonStyle = (a, s, $) => ({
  [`&:not(:disabled):not(${a}-disabled)`]: {
    "&:hover": s,
    "&:active": $
  }
}), genCircleButtonStyle = (a) => ({
  minWidth: a.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), genRoundButtonStyle = (a) => ({
  borderRadius: a.controlHeight,
  paddingInlineStart: a.calc(a.controlHeight).div(2).equal(),
  paddingInlineEnd: a.calc(a.controlHeight).div(2).equal()
}), genDisabledStyle$1 = (a) => ({
  cursor: "not-allowed",
  borderColor: a.borderColorDisabled,
  color: a.colorTextDisabled,
  background: a.colorBgContainerDisabled,
  boxShadow: "none"
}), genGhostButtonStyle = (a, s, $, _, _e, tt, nt, at) => ({
  [`&${a}-background-ghost`]: Object.assign(Object.assign({
    color: $ || void 0,
    background: s,
    borderColor: _ || void 0,
    boxShadow: "none"
  }, genHoverActiveButtonStyle(a, Object.assign({
    background: s
  }, nt), Object.assign({
    background: s
  }, at))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: _e || void 0,
      borderColor: tt || void 0
    }
  })
}), genSolidDisabledButtonStyle = (a) => ({
  [`&:disabled, &${a.componentCls}-disabled`]: Object.assign({}, genDisabledStyle$1(a))
}), genSolidButtonStyle = (a) => Object.assign({}, genSolidDisabledButtonStyle(a)), genPureDisabledButtonStyle = (a) => ({
  [`&:disabled, &${a.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: a.colorTextDisabled
  }
}), genDefaultButtonStyle = (a) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genSolidButtonStyle(a)), {
  background: a.defaultBg,
  borderColor: a.defaultBorderColor,
  color: a.defaultColor,
  boxShadow: a.defaultShadow
}), genHoverActiveButtonStyle(a.componentCls, {
  color: a.colorPrimaryHover,
  borderColor: a.colorPrimaryHover
}, {
  color: a.colorPrimaryActive,
  borderColor: a.colorPrimaryActive
})), genGhostButtonStyle(a.componentCls, a.ghostBg, a.defaultGhostColor, a.defaultGhostBorderColor, a.colorTextDisabled, a.colorBorder)), {
  [`&${a.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    color: a.colorError,
    borderColor: a.colorError
  }, genHoverActiveButtonStyle(a.componentCls, {
    color: a.colorErrorHover,
    borderColor: a.colorErrorBorderHover
  }, {
    color: a.colorErrorActive,
    borderColor: a.colorErrorActive
  })), genGhostButtonStyle(a.componentCls, a.ghostBg, a.colorError, a.colorError, a.colorTextDisabled, a.colorBorder)), genSolidDisabledButtonStyle(a))
}), genPrimaryButtonStyle = (a) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genSolidButtonStyle(a)), {
  color: a.primaryColor,
  background: a.colorPrimary,
  boxShadow: a.primaryShadow
}), genHoverActiveButtonStyle(a.componentCls, {
  color: a.colorTextLightSolid,
  background: a.colorPrimaryHover
}, {
  color: a.colorTextLightSolid,
  background: a.colorPrimaryActive
})), genGhostButtonStyle(a.componentCls, a.ghostBg, a.colorPrimary, a.colorPrimary, a.colorTextDisabled, a.colorBorder, {
  color: a.colorPrimaryHover,
  borderColor: a.colorPrimaryHover
}, {
  color: a.colorPrimaryActive,
  borderColor: a.colorPrimaryActive
})), {
  [`&${a.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    background: a.colorError,
    boxShadow: a.dangerShadow,
    color: a.dangerColor
  }, genHoverActiveButtonStyle(a.componentCls, {
    background: a.colorErrorHover
  }, {
    background: a.colorErrorActive
  })), genGhostButtonStyle(a.componentCls, a.ghostBg, a.colorError, a.colorError, a.colorTextDisabled, a.colorBorder, {
    color: a.colorErrorHover,
    borderColor: a.colorErrorHover
  }, {
    color: a.colorErrorActive,
    borderColor: a.colorErrorActive
  })), genSolidDisabledButtonStyle(a))
}), genDashedButtonStyle = (a) => Object.assign(Object.assign({}, genDefaultButtonStyle(a)), {
  borderStyle: "dashed"
}), genLinkButtonStyle = (a) => Object.assign(Object.assign(Object.assign({
  color: a.colorLink
}, genHoverActiveButtonStyle(a.componentCls, {
  color: a.colorLinkHover,
  background: a.linkHoverBg
}, {
  color: a.colorLinkActive
})), genPureDisabledButtonStyle(a)), {
  [`&${a.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: a.colorError
  }, genHoverActiveButtonStyle(a.componentCls, {
    color: a.colorErrorHover
  }, {
    color: a.colorErrorActive
  })), genPureDisabledButtonStyle(a))
}), genTextButtonStyle = (a) => Object.assign(Object.assign(Object.assign({}, genHoverActiveButtonStyle(a.componentCls, {
  color: a.colorText,
  background: a.textHoverBg
}, {
  color: a.colorText,
  background: a.colorBgTextActive
})), genPureDisabledButtonStyle(a)), {
  [`&${a.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: a.colorError
  }, genPureDisabledButtonStyle(a)), genHoverActiveButtonStyle(a.componentCls, {
    color: a.colorErrorHover,
    background: a.colorErrorBg
  }, {
    color: a.colorErrorHover,
    background: a.colorErrorBg
  }))
}), genTypeButtonStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-default`]: genDefaultButtonStyle(a),
    [`${s}-primary`]: genPrimaryButtonStyle(a),
    [`${s}-dashed`]: genDashedButtonStyle(a),
    [`${s}-link`]: genLinkButtonStyle(a),
    [`${s}-text`]: genTextButtonStyle(a),
    [`${s}-ghost`]: genGhostButtonStyle(a.componentCls, a.ghostBg, a.colorBgContainer, a.colorBgContainer, a.colorTextDisabled, a.colorBorder)
  };
}, genSizeButtonStyle = function(a) {
  let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: $,
    controlHeight: _,
    fontSize: _e,
    borderRadius: tt,
    buttonPaddingHorizontal: nt,
    iconCls: at,
    buttonPaddingVertical: ot
  } = a, rt = `${$}-icon-only`;
  return [
    // Size
    {
      [`${$}${s}`]: {
        fontSize: _e,
        height: _,
        padding: `${unit$1(ot)} ${unit$1(nt)}`,
        borderRadius: tt,
        [`&${rt}`]: {
          width: _,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
          [`&${$}-round`]: {
            width: "auto"
          },
          [at]: {
            fontSize: a.buttonIconOnlyFontSize
          }
        },
        // Loading
        [`&${$}-loading`]: {
          opacity: a.opacityLoading,
          cursor: "default"
        },
        [`${$}-loading-icon`]: {
          transition: `width ${a.motionDurationSlow} ${a.motionEaseInOut}, opacity ${a.motionDurationSlow} ${a.motionEaseInOut}`
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${$}${$}-circle${s}`]: genCircleButtonStyle(a)
    },
    {
      [`${$}${$}-round${s}`]: genRoundButtonStyle(a)
    }
  ];
}, genSizeBaseButtonStyle = (a) => genSizeButtonStyle(merge(a, {
  fontSize: a.contentFontSize
})), genSizeSmallButtonStyle = (a) => {
  const s = merge(a, {
    controlHeight: a.controlHeightSM,
    fontSize: a.contentFontSizeSM,
    padding: a.paddingXS,
    buttonPaddingHorizontal: a.paddingInlineSM,
    buttonPaddingVertical: a.paddingBlockSM,
    borderRadius: a.borderRadiusSM,
    buttonIconOnlyFontSize: a.onlyIconSizeSM
  });
  return genSizeButtonStyle(s, `${a.componentCls}-sm`);
}, genSizeLargeButtonStyle = (a) => {
  const s = merge(a, {
    controlHeight: a.controlHeightLG,
    fontSize: a.contentFontSizeLG,
    buttonPaddingHorizontal: a.paddingInlineLG,
    buttonPaddingVertical: a.paddingBlockLG,
    borderRadius: a.borderRadiusLG,
    buttonIconOnlyFontSize: a.onlyIconSizeLG
  });
  return genSizeButtonStyle(s, `${a.componentCls}-lg`);
}, genBlockButtonStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: {
      [`&${s}-block`]: {
        width: "100%"
      }
    }
  };
}, prepareToken$3 = (a) => {
  const {
    paddingInline: s,
    onlyIconSize: $,
    paddingBlock: _
  } = a;
  return merge(a, {
    buttonPaddingHorizontal: s,
    buttonPaddingVertical: _,
    buttonIconOnlyFontSize: $
  });
}, prepareComponentToken$t = (a) => {
  const s = a.fontSize, $ = a.fontSize, _ = a.fontSizeLG;
  return {
    fontWeight: 400,
    defaultShadow: `0 ${a.controlOutlineWidth}px 0 ${a.controlTmpOutline}`,
    primaryShadow: `0 ${a.controlOutlineWidth}px 0 ${a.controlOutline}`,
    dangerShadow: `0 ${a.controlOutlineWidth}px 0 ${a.colorErrorOutline}`,
    primaryColor: a.colorTextLightSolid,
    dangerColor: a.colorTextLightSolid,
    borderColorDisabled: a.colorBorder,
    defaultGhostColor: a.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: a.colorBgContainer,
    paddingInline: a.paddingContentHorizontal - a.lineWidth,
    paddingInlineLG: a.paddingContentHorizontal - a.lineWidth,
    paddingInlineSM: 8 - a.lineWidth,
    paddingBlock: Math.max((a.controlHeight - s * a.lineHeight) / 2 - a.lineWidth, 0),
    paddingBlockSM: Math.max((a.controlHeightSM - $ * a.lineHeight) / 2 - a.lineWidth, 0),
    paddingBlockLG: Math.max((a.controlHeightLG - _ * a.lineHeight) / 2 - a.lineWidth, 0),
    onlyIconSize: a.fontSizeLG,
    onlyIconSizeSM: a.fontSizeLG - 2,
    onlyIconSizeLG: a.fontSizeLG + 2,
    groupBorderColor: a.colorPrimaryHover,
    linkHoverBg: "transparent",
    textHoverBg: a.colorBgTextHover,
    defaultColor: a.colorText,
    defaultBg: a.colorBgContainer,
    defaultBorderColor: a.colorBorder,
    defaultBorderColorDisabled: a.colorBorder,
    contentFontSize: s,
    contentFontSizeSM: $,
    contentFontSizeLG: _
  };
}, useStyle$u = genStyleHooks("Button", (a) => {
  const s = prepareToken$3(a);
  return [
    // Shared
    genSharedButtonStyle(s),
    // Size
    genSizeSmallButtonStyle(s),
    genSizeBaseButtonStyle(s),
    genSizeLargeButtonStyle(s),
    // Block
    genBlockButtonStyle(s),
    // Group (type, ghost, danger, loading)
    genTypeButtonStyle(s),
    // Button Group
    genGroupStyle$2(s)
  ];
}, prepareComponentToken$t, {
  unitless: {
    fontWeight: !0
  }
});
function compactItemBorder(a, s, $) {
  const {
    focusElCls: _,
    focus: _e,
    borderElCls: tt
  } = $, nt = tt ? "> *" : "", at = ["hover", _e ? "focus" : null, "active"].filter(Boolean).map((ot) => `&:${ot} ${nt}`).join(",");
  return {
    [`&-item:not(${s}-last-item)`]: {
      marginInlineEnd: a.calc(a.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [at]: {
        zIndex: 2
      }
    }, _ ? {
      [`&${_}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${nt}`]: {
        zIndex: 0
      }
    })
  };
}
function compactItemBorderRadius(a, s, $) {
  const {
    borderElCls: _
  } = $, _e = _ ? `> ${_}` : "";
  return {
    [`&-item:not(${s}-first-item):not(${s}-last-item) ${_e}`]: {
      borderRadius: 0
    },
    [`&-item:not(${s}-last-item)${s}-first-item`]: {
      [`& ${_e}, &${a}-sm ${_e}, &${a}-lg ${_e}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${s}-first-item)${s}-last-item`]: {
      [`& ${_e}, &${a}-sm ${_e}, &${a}-lg ${_e}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function genCompactItemStyle(a) {
  let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: $
  } = a, _ = `${$}-compact`;
  return {
    [_]: Object.assign(Object.assign({}, compactItemBorder(a, _, s)), compactItemBorderRadius($, _, s))
  };
}
function compactItemVerticalBorder(a, s) {
  return {
    // border collapse
    [`&-item:not(${s}-last-item)`]: {
      marginBottom: a.calc(a.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function compactItemBorderVerticalRadius(a, s) {
  return {
    [`&-item:not(${s}-first-item):not(${s}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${s}-first-item:not(${s}-last-item)`]: {
      [`&, &${a}-sm, &${a}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${s}-last-item:not(${s}-first-item)`]: {
      [`&, &${a}-sm, &${a}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function genCompactItemVerticalStyle(a) {
  const s = `${a.componentCls}-compact-vertical`;
  return {
    [s]: Object.assign(Object.assign({}, compactItemVerticalBorder(a, s)), compactItemBorderVerticalRadius(a.componentCls, s))
  };
}
const genButtonCompactStyle = (a) => {
  const {
    componentCls: s,
    calc: $
  } = a;
  return {
    [s]: {
      // Special styles for Primary Button
      [`&-compact-item${s}-primary`]: {
        [`&:not([disabled]) + ${s}-compact-item${s}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: $(a.lineWidth).mul(-1).equal(),
            insetInlineStart: $(a.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: a.lineWidth,
            height: `calc(100% + ${unit$1(a.lineWidth)} * 2)`,
            backgroundColor: a.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${s}-primary`]: {
          [`&:not([disabled]) + ${s}-compact-vertical-item${s}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: $(a.lineWidth).mul(-1).equal(),
              insetInlineStart: $(a.lineWidth).mul(-1).equal(),
              display: "inline-block",
              width: `calc(100% + ${unit$1(a.lineWidth)} * 2)`,
              height: a.lineWidth,
              backgroundColor: a.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
}, CompactCmp = genSubStyleComponent(["Button", "compact"], (a) => {
  const s = prepareToken$3(a);
  return [
    // Space Compact
    genCompactItemStyle(s),
    genCompactItemVerticalStyle(s),
    genButtonCompactStyle(s)
  ];
}, prepareComponentToken$t);
var __rest$Y = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function getLoadingConfig(a) {
  if (typeof a == "object" && a) {
    let s = a == null ? void 0 : a.delay;
    return s = !Number.isNaN(s) && typeof s == "number" ? s : 0, {
      loading: s <= 0,
      delay: s
    };
  }
  return {
    loading: !!a,
    delay: 0
  };
}
const InternalButton = (a, s) => {
  var $, _;
  const {
    loading: _e = !1,
    prefixCls: tt,
    type: nt = "default",
    danger: at,
    shape: ot = "default",
    size: rt,
    styles: st,
    disabled: lt,
    className: et,
    rootClassName: it,
    children: ut,
    icon: ft,
    ghost: ht = !1,
    block: dt = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: gt = "button",
    classNames: pt,
    style: mt = {}
  } = a, ct = __rest$Y(a, ["loading", "prefixCls", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "ghost", "block", "htmlType", "classNames", "style"]), {
    getPrefixCls: vt,
    autoInsertSpaceInButton: At,
    direction: xt,
    button: bt
  } = reactExports.useContext(ConfigContext$1), Et = vt("btn", tt), [St, Bt, Ot] = useStyle$u(Et), Pt = reactExports.useContext(DisabledContext$1), wt = lt ?? Pt, Ct = reactExports.useContext(GroupSizeContext), It = reactExports.useMemo(() => getLoadingConfig(_e), [_e]), [yt, Rt] = reactExports.useState(It.loading), [kt, jt] = reactExports.useState(!1), Ft = composeRef(s, /* @__PURE__ */ reactExports.createRef()), _t = reactExports.Children.count(ut) === 1 && !ft && !isUnBorderedButtonType(nt);
  reactExports.useEffect(() => {
    let nr = null;
    It.delay > 0 ? nr = setTimeout(() => {
      nr = null, Rt(!0);
    }, It.delay) : Rt(It.loading);
    function tr() {
      nr && (clearTimeout(nr), nr = null);
    }
    return tr;
  }, [It]), reactExports.useEffect(() => {
    if (!Ft || !Ft.current || At === !1)
      return;
    const nr = Ft.current.textContent;
    _t && isTwoCNChar(nr) ? kt || jt(!0) : kt && jt(!1);
  }, [Ft]);
  const Nt = (nr) => {
    const {
      onClick: tr
    } = a;
    if (yt || wt) {
      nr.preventDefault();
      return;
    }
    tr == null || tr(nr);
  }, Mt = At !== !1, {
    compactSize: Lt,
    compactItemClassnames: $t
  } = useCompactItemContext(Et, xt), Tt = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, Dt = useSize$1((nr) => {
    var tr, ir;
    return (ir = (tr = rt ?? Lt) !== null && tr !== void 0 ? tr : Ct) !== null && ir !== void 0 ? ir : nr;
  }), Ut = Dt && Tt[Dt] || "", Vt = yt ? "loading" : ft, Qt = omit(ct, ["navigate"]), qt = classnames(Et, Bt, Ot, {
    [`${Et}-${ot}`]: ot !== "default" && ot,
    [`${Et}-${nt}`]: nt,
    [`${Et}-${Ut}`]: Ut,
    [`${Et}-icon-only`]: !ut && ut !== 0 && !!Vt,
    [`${Et}-background-ghost`]: ht && !isUnBorderedButtonType(nt),
    [`${Et}-loading`]: yt,
    [`${Et}-two-chinese-chars`]: kt && Mt && !yt,
    [`${Et}-block`]: dt,
    [`${Et}-dangerous`]: !!at,
    [`${Et}-rtl`]: xt === "rtl"
  }, $t, et, it, bt == null ? void 0 : bt.className), Zt = Object.assign(Object.assign({}, bt == null ? void 0 : bt.style), mt), ar = classnames(pt == null ? void 0 : pt.icon, ($ = bt == null ? void 0 : bt.classNames) === null || $ === void 0 ? void 0 : $.icon), Jt = Object.assign(Object.assign({}, (st == null ? void 0 : st.icon) || {}), ((_ = bt == null ? void 0 : bt.styles) === null || _ === void 0 ? void 0 : _.icon) || {}), rr = ft && !yt ? /* @__PURE__ */ React$a.createElement(IconWrapper$1, {
    prefixCls: Et,
    className: ar,
    style: Jt
  }, ft) : /* @__PURE__ */ React$a.createElement(LoadingIcon$1, {
    existIcon: !!ft,
    prefixCls: Et,
    loading: !!yt
  }), Yt = ut || ut === 0 ? spaceChildren(ut, _t && Mt) : null;
  if (Qt.href !== void 0)
    return St(/* @__PURE__ */ React$a.createElement("a", Object.assign({}, Qt, {
      className: classnames(qt, {
        [`${Et}-disabled`]: wt
      }),
      href: wt ? void 0 : Qt.href,
      style: Zt,
      onClick: Nt,
      ref: Ft,
      tabIndex: wt ? -1 : 0
    }), rr, Yt));
  let Kt = /* @__PURE__ */ React$a.createElement("button", Object.assign({}, ct, {
    type: gt,
    className: qt,
    style: Zt,
    onClick: Nt,
    disabled: wt,
    ref: Ft
  }), rr, Yt, $t && /* @__PURE__ */ React$a.createElement(CompactCmp, {
    key: "compact",
    prefixCls: Et
  }));
  return isUnBorderedButtonType(nt) || (Kt = /* @__PURE__ */ React$a.createElement(Wave$1, {
    component: "Button",
    disabled: !!yt
  }, Kt)), St(Kt);
}, Button$1 = /* @__PURE__ */ reactExports.forwardRef(InternalButton);
Button$1.Group = Group$5;
Button$1.__ANT_BUTTON = !0;
const Button$2 = Button$1;
function isThenable(a) {
  return !!(a && a.then);
}
const ActionButton = (a) => {
  const {
    type: s,
    children: $,
    prefixCls: _,
    buttonProps: _e,
    close: tt,
    autoFocus: nt,
    emitEvent: at,
    isSilent: ot,
    quitOnNullishReturnValue: rt,
    actionFn: st
  } = a, lt = reactExports.useRef(!1), et = reactExports.useRef(null), [it, ut] = useSafeState(!1), ft = function() {
    tt == null || tt.apply(void 0, arguments);
  };
  reactExports.useEffect(() => {
    let gt = null;
    return nt && (gt = setTimeout(() => {
      var pt;
      (pt = et.current) === null || pt === void 0 || pt.focus();
    })), () => {
      gt && clearTimeout(gt);
    };
  }, []);
  const ht = (gt) => {
    isThenable(gt) && (ut(!0), gt.then(function() {
      ut(!1, !0), ft.apply(void 0, arguments), lt.current = !1;
    }, (pt) => {
      if (ut(!1, !0), lt.current = !1, !(ot != null && ot()))
        return Promise.reject(pt);
    }));
  }, dt = (gt) => {
    if (lt.current)
      return;
    if (lt.current = !0, !st) {
      ft();
      return;
    }
    let pt;
    if (at) {
      if (pt = st(gt), rt && !isThenable(pt)) {
        lt.current = !1, ft(gt);
        return;
      }
    } else if (st.length)
      pt = st(tt), lt.current = !1;
    else if (pt = st(), !pt) {
      ft();
      return;
    }
    ht(pt);
  };
  return /* @__PURE__ */ reactExports.createElement(Button$2, Object.assign({}, convertLegacyProps(s), {
    onClick: dt,
    loading: it,
    prefixCls: _
  }, _e, {
    ref: et
  }), $);
}, ActionButton$1 = ActionButton;
var OrderContext = /* @__PURE__ */ reactExports.createContext(null), EMPTY_LIST$4 = [];
function useDom(a, s) {
  var $ = reactExports.useState(function() {
    if (!canUseDom$1())
      return null;
    var ut = document.createElement("div");
    return ut;
  }), _ = _slicedToArray$e($, 1), _e = _[0], tt = reactExports.useRef(!1), nt = reactExports.useContext(OrderContext), at = reactExports.useState(EMPTY_LIST$4), ot = _slicedToArray$e(at, 2), rt = ot[0], st = ot[1], lt = nt || (tt.current ? void 0 : function(ut) {
    st(function(ft) {
      var ht = [ut].concat(_toConsumableArray$d(ft));
      return ht;
    });
  });
  function et() {
    _e.parentElement || document.body.appendChild(_e), tt.current = !0;
  }
  function it() {
    var ut;
    (ut = _e.parentElement) === null || ut === void 0 || ut.removeChild(_e), tt.current = !1;
  }
  return useLayoutEffect$1(function() {
    return a ? nt ? nt(et) : et() : it(), it;
  }, [a]), useLayoutEffect$1(function() {
    rt.length && (rt.forEach(function(ut) {
      return ut();
    }), st(EMPTY_LIST$4));
  }, [rt]), [_e, lt];
}
var cached;
function getScrollBarSize(a) {
  if (typeof document > "u")
    return 0;
  if (a || cached === void 0) {
    var s = document.createElement("div");
    s.style.width = "100%", s.style.height = "200px";
    var $ = document.createElement("div"), _ = $.style;
    _.position = "absolute", _.top = "0", _.left = "0", _.pointerEvents = "none", _.visibility = "hidden", _.width = "200px", _.height = "150px", _.overflow = "hidden", $.appendChild(s), document.body.appendChild($);
    var _e = s.offsetWidth;
    $.style.overflow = "scroll";
    var tt = s.offsetWidth;
    _e === tt && (tt = $.clientWidth), document.body.removeChild($), cached = _e - tt;
  }
  return cached;
}
function ensureSize(a) {
  var s = a.match(/^(.*)px$/), $ = Number(s == null ? void 0 : s[1]);
  return Number.isNaN($) ? getScrollBarSize() : $;
}
function getTargetScrollBarSize(a) {
  if (typeof document > "u" || !a || !(a instanceof Element))
    return {
      width: 0,
      height: 0
    };
  var s = getComputedStyle(a, "::-webkit-scrollbar"), $ = s.width, _ = s.height;
  return {
    width: ensureSize($),
    height: ensureSize(_)
  };
}
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var UNIQUE_ID = "rc-util-locker-".concat(Date.now()), uuid$4 = 0;
function useScrollLocker(a) {
  var s = !!a, $ = reactExports.useState(function() {
    return uuid$4 += 1, "".concat(UNIQUE_ID, "_").concat(uuid$4);
  }), _ = _slicedToArray$e($, 1), _e = _[0];
  useLayoutEffect$1(function() {
    if (s) {
      var tt = getTargetScrollBarSize(document.body).width, nt = isBodyOverflowing();
      updateCSS(`
html body {
  overflow-y: hidden;
  `.concat(nt ? "width: calc(100% - ".concat(tt, "px);") : "", `
}`), _e);
    } else
      removeCSS(_e);
    return function() {
      removeCSS(_e);
    };
  }, [s, _e]);
}
var inline = !1;
function inlineMock(a) {
  return typeof a == "boolean" && (inline = a), inline;
}
var getPortalContainer = function a(s) {
  return s === !1 ? !1 : !canUseDom$1() || !s ? null : typeof s == "string" ? document.querySelector(s) : typeof s == "function" ? s() : s;
}, Portal = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.open, _ = a.autoLock, _e = a.getContainer;
  a.debug;
  var tt = a.autoDestroy, nt = tt === void 0 ? !0 : tt, at = a.children, ot = reactExports.useState($), rt = _slicedToArray$e(ot, 2), st = rt[0], lt = rt[1], et = st || $;
  reactExports.useEffect(function() {
    (nt || $) && lt($);
  }, [$, nt]);
  var it = reactExports.useState(function() {
    return getPortalContainer(_e);
  }), ut = _slicedToArray$e(it, 2), ft = ut[0], ht = ut[1];
  reactExports.useEffect(function() {
    var St = getPortalContainer(_e);
    ht(St ?? null);
  });
  var dt = useDom(et && !ft), gt = _slicedToArray$e(dt, 2), pt = gt[0], mt = gt[1], ct = ft ?? pt;
  useScrollLocker(_ && $ && canUseDom$1() && (ct === pt || ct === document.body));
  var vt = null;
  if (at && supportRef(at) && s) {
    var At = at;
    vt = At.ref;
  }
  var xt = useComposeRef(vt, s);
  if (!et || !canUseDom$1() || ft === void 0)
    return null;
  var bt = ct === !1 || inlineMock(), Et = at;
  return s && (Et = /* @__PURE__ */ reactExports.cloneElement(at, {
    ref: xt
  })), /* @__PURE__ */ reactExports.createElement(OrderContext.Provider, {
    value: mt
  }, bt ? Et : /* @__PURE__ */ reactDomExports.createPortal(Et, ct));
}), RefContext$1 = /* @__PURE__ */ reactExports.createContext({});
function getUseId() {
  var a = _objectSpread2$a({}, React$b);
  return a.useId;
}
var uuid$3 = 0, useOriginId = getUseId();
const useId$2 = useOriginId ? (
  // Use React `useId`
  function a(s) {
    var $ = useOriginId();
    return s || $;
  }
) : (
  // Use compatible of `useId`
  function a(s) {
    var $ = reactExports.useState("ssr-id"), _ = _slicedToArray$e($, 2), _e = _[0], tt = _[1];
    return reactExports.useEffect(function() {
      var nt = uuid$3;
      uuid$3 += 1, tt("rc_unique_".concat(nt));
    }, []), s || _e;
  }
);
function getMotionName(a, s, $) {
  var _ = s;
  return !_ && $ && (_ = "".concat(a, "-").concat($)), _;
}
function getScroll$2(a, s) {
  var $ = a["page".concat(s ? "Y" : "X", "Offset")], _ = "scroll".concat(s ? "Top" : "Left");
  if (typeof $ != "number") {
    var _e = a.document;
    $ = _e.documentElement[_], typeof $ != "number" && ($ = _e.body[_]);
  }
  return $;
}
function offset$1(a) {
  var s = a.getBoundingClientRect(), $ = {
    left: s.left,
    top: s.top
  }, _ = a.ownerDocument, _e = _.defaultView || _.parentWindow;
  return $.left += getScroll$2(_e), $.top += getScroll$2(_e, !0), $;
}
const MemoChildren = /* @__PURE__ */ reactExports.memo(function(a) {
  var s = a.children;
  return s;
}, function(a, s) {
  var $ = s.shouldUpdate;
  return !$;
});
var sentinelStyle$1 = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
}, Panel$3 = /* @__PURE__ */ React$a.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = a.className, _e = a.style, tt = a.title, nt = a.ariaId, at = a.footer, ot = a.closable, rt = a.closeIcon, st = a.onClose, lt = a.children, et = a.bodyStyle, it = a.bodyProps, ut = a.modalRender, ft = a.onMouseDown, ht = a.onMouseUp, dt = a.holderRef, gt = a.visible, pt = a.forceRender, mt = a.width, ct = a.height, vt = a.classNames, At = a.styles, xt = React$a.useContext(RefContext$1), bt = xt.panel, Et = useComposeRef(dt, bt), St = reactExports.useRef(), Bt = reactExports.useRef();
  React$a.useImperativeHandle(s, function() {
    return {
      focus: function() {
        var Rt;
        (Rt = St.current) === null || Rt === void 0 || Rt.focus();
      },
      changeActive: function(Rt) {
        var kt = document, jt = kt.activeElement;
        Rt && jt === Bt.current ? St.current.focus() : !Rt && jt === St.current && Bt.current.focus();
      }
    };
  });
  var Ot = {};
  mt !== void 0 && (Ot.width = mt), ct !== void 0 && (Ot.height = ct);
  var Pt;
  at && (Pt = /* @__PURE__ */ React$a.createElement("div", {
    className: classnames("".concat($, "-footer"), vt == null ? void 0 : vt.footer),
    style: _objectSpread2$a({}, At == null ? void 0 : At.footer)
  }, at));
  var wt;
  tt && (wt = /* @__PURE__ */ React$a.createElement("div", {
    className: classnames("".concat($, "-header"), vt == null ? void 0 : vt.header),
    style: _objectSpread2$a({}, At == null ? void 0 : At.header)
  }, /* @__PURE__ */ React$a.createElement("div", {
    className: "".concat($, "-title"),
    id: nt
  }, tt)));
  var Ct;
  ot && (Ct = /* @__PURE__ */ React$a.createElement("button", {
    type: "button",
    onClick: st,
    "aria-label": "Close",
    className: "".concat($, "-close")
  }, rt || /* @__PURE__ */ React$a.createElement("span", {
    className: "".concat($, "-close-x")
  })));
  var It = /* @__PURE__ */ React$a.createElement("div", {
    className: classnames("".concat($, "-content"), vt == null ? void 0 : vt.content),
    style: At == null ? void 0 : At.content
  }, Ct, wt, /* @__PURE__ */ React$a.createElement("div", _extends$2({
    className: classnames("".concat($, "-body"), vt == null ? void 0 : vt.body),
    style: _objectSpread2$a(_objectSpread2$a({}, et), At == null ? void 0 : At.body)
  }, it), lt), Pt);
  return /* @__PURE__ */ React$a.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": tt ? nt : null,
    "aria-modal": "true",
    ref: Et,
    style: _objectSpread2$a(_objectSpread2$a({}, _e), Ot),
    className: classnames($, _),
    onMouseDown: ft,
    onMouseUp: ht
  }, /* @__PURE__ */ React$a.createElement("div", {
    tabIndex: 0,
    ref: St,
    style: sentinelStyle$1,
    "aria-hidden": "true"
  }), /* @__PURE__ */ React$a.createElement(MemoChildren, {
    shouldUpdate: gt || pt
  }, ut ? ut(It) : It), /* @__PURE__ */ React$a.createElement("div", {
    tabIndex: 0,
    ref: Bt,
    style: sentinelStyle$1,
    "aria-hidden": "true"
  }));
}), Content = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = a.title, _e = a.style, tt = a.className, nt = a.visible, at = a.forceRender, ot = a.destroyOnClose, rt = a.motionName, st = a.ariaId, lt = a.onVisibleChanged, et = a.mousePosition, it = reactExports.useRef(), ut = reactExports.useState(), ft = _slicedToArray$e(ut, 2), ht = ft[0], dt = ft[1], gt = {};
  ht && (gt.transformOrigin = ht);
  function pt() {
    var mt = offset$1(it.current);
    dt(et ? "".concat(et.x - mt.left, "px ").concat(et.y - mt.top, "px") : "");
  }
  return /* @__PURE__ */ reactExports.createElement(CSSMotion, {
    visible: nt,
    onVisibleChanged: lt,
    onAppearPrepare: pt,
    onEnterPrepare: pt,
    forceRender: at,
    motionName: rt,
    removeOnLeave: ot,
    ref: it
  }, function(mt, ct) {
    var vt = mt.className, At = mt.style;
    return /* @__PURE__ */ reactExports.createElement(Panel$3, _extends$2({}, a, {
      ref: s,
      title: _,
      ariaId: st,
      prefixCls: $,
      holderRef: ct,
      style: _objectSpread2$a(_objectSpread2$a(_objectSpread2$a({}, At), _e), gt),
      className: classnames(tt, vt)
    }));
  });
});
Content.displayName = "Content";
function Mask$3(a) {
  var s = a.prefixCls, $ = a.style, _ = a.visible, _e = a.maskProps, tt = a.motionName, nt = a.className;
  return /* @__PURE__ */ reactExports.createElement(CSSMotion, {
    key: "mask",
    visible: _,
    motionName: tt,
    leavedClassName: "".concat(s, "-mask-hidden")
  }, function(at, ot) {
    var rt = at.className, st = at.style;
    return /* @__PURE__ */ reactExports.createElement("div", _extends$2({
      ref: ot,
      style: _objectSpread2$a(_objectSpread2$a({}, st), $),
      className: classnames("".concat(s, "-mask"), rt, nt)
    }, _e));
  });
}
function Dialog(a) {
  var s = a.prefixCls, $ = s === void 0 ? "rc-dialog" : s, _ = a.zIndex, _e = a.visible, tt = _e === void 0 ? !1 : _e, nt = a.keyboard, at = nt === void 0 ? !0 : nt, ot = a.focusTriggerAfterClose, rt = ot === void 0 ? !0 : ot, st = a.wrapStyle, lt = a.wrapClassName, et = a.wrapProps, it = a.onClose, ut = a.afterOpenChange, ft = a.afterClose, ht = a.transitionName, dt = a.animation, gt = a.closable, pt = gt === void 0 ? !0 : gt, mt = a.mask, ct = mt === void 0 ? !0 : mt, vt = a.maskTransitionName, At = a.maskAnimation, xt = a.maskClosable, bt = xt === void 0 ? !0 : xt, Et = a.maskStyle, St = a.maskProps, Bt = a.rootClassName, Ot = a.classNames, Pt = a.styles, wt = reactExports.useRef(), Ct = reactExports.useRef(), It = reactExports.useRef(), yt = reactExports.useState(tt), Rt = _slicedToArray$e(yt, 2), kt = Rt[0], jt = Rt[1], Ht = useId$2();
  function Ft() {
    contains$3(Ct.current, document.activeElement) || (wt.current = document.activeElement);
  }
  function _t() {
    if (!contains$3(Ct.current, document.activeElement)) {
      var Qt;
      (Qt = It.current) === null || Qt === void 0 || Qt.focus();
    }
  }
  function Nt(Qt) {
    if (Qt)
      _t();
    else {
      if (jt(!1), ct && wt.current && rt) {
        try {
          wt.current.focus({
            preventScroll: !0
          });
        } catch {
        }
        wt.current = null;
      }
      kt && (ft == null || ft());
    }
    ut == null || ut(Qt);
  }
  function Mt(Qt) {
    it == null || it(Qt);
  }
  var Lt = reactExports.useRef(!1), $t = reactExports.useRef(), Tt = function() {
    clearTimeout($t.current), Lt.current = !0;
  }, Dt = function() {
    $t.current = setTimeout(function() {
      Lt.current = !1;
    });
  }, Ut = null;
  bt && (Ut = function(qt) {
    Lt.current ? Lt.current = !1 : Ct.current === qt.target && Mt(qt);
  });
  function Vt(Qt) {
    if (at && Qt.keyCode === KeyCode.ESC) {
      Qt.stopPropagation(), Mt(Qt);
      return;
    }
    tt && Qt.keyCode === KeyCode.TAB && It.current.changeActive(!Qt.shiftKey);
  }
  return reactExports.useEffect(function() {
    tt && (jt(!0), Ft());
  }, [tt]), reactExports.useEffect(function() {
    return function() {
      clearTimeout($t.current);
    };
  }, []), /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    className: classnames("".concat($, "-root"), Bt)
  }, pickAttrs(a, {
    data: !0
  })), /* @__PURE__ */ reactExports.createElement(Mask$3, {
    prefixCls: $,
    visible: ct && tt,
    motionName: getMotionName($, vt, At),
    style: _objectSpread2$a(_objectSpread2$a({
      zIndex: _
    }, Et), Pt == null ? void 0 : Pt.mask),
    maskProps: St,
    className: Ot == null ? void 0 : Ot.mask
  }), /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    tabIndex: -1,
    onKeyDown: Vt,
    className: classnames("".concat($, "-wrap"), lt, Ot == null ? void 0 : Ot.wrapper),
    ref: Ct,
    onClick: Ut,
    style: _objectSpread2$a(_objectSpread2$a(_objectSpread2$a({
      zIndex: _
    }, st), Pt == null ? void 0 : Pt.wrapper), {}, {
      display: kt ? null : "none"
    })
  }, et), /* @__PURE__ */ reactExports.createElement(Content, _extends$2({}, a, {
    onMouseDown: Tt,
    onMouseUp: Dt,
    ref: It,
    closable: pt,
    ariaId: Ht,
    prefixCls: $,
    visible: tt && kt,
    onClose: Mt,
    onVisibleChanged: Nt,
    motionName: getMotionName($, ht, dt)
  }))));
}
var DialogWrap = function a(s) {
  var $ = s.visible, _ = s.getContainer, _e = s.forceRender, tt = s.destroyOnClose, nt = tt === void 0 ? !1 : tt, at = s.afterClose, ot = s.panelRef, rt = reactExports.useState($), st = _slicedToArray$e(rt, 2), lt = st[0], et = st[1], it = reactExports.useMemo(function() {
    return {
      panel: ot
    };
  }, [ot]);
  return reactExports.useEffect(function() {
    $ && et(!0);
  }, [$]), !_e && nt && !lt ? null : /* @__PURE__ */ reactExports.createElement(RefContext$1.Provider, {
    value: it
  }, /* @__PURE__ */ reactExports.createElement(Portal, {
    open: $ || _e || lt,
    autoDestroy: !1,
    getContainer: _,
    autoLock: $ || lt
  }, /* @__PURE__ */ reactExports.createElement(Dialog, _extends$2({}, s, {
    destroyOnClose: nt,
    afterClose: function() {
      at == null || at(), et(!1);
    }
  }))));
};
DialogWrap.displayName = "Dialog";
function useInnerClosable(a, s, $) {
  return typeof a == "boolean" ? a : s === void 0 ? !!$ : s !== !1 && s !== null;
}
function useClosable(a, s, $) {
  let _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : /* @__PURE__ */ React$a.createElement(CloseOutlined$4, null), _e = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (!useInnerClosable(a, s, _e))
    return [!1, null];
  const nt = typeof s == "boolean" || s === void 0 || s === null ? _ : s;
  return [!0, $ ? $(nt) : nt];
}
var isStyleNameSupport = function a(s) {
  if (canUseDom$1() && window.document.documentElement) {
    var $ = Array.isArray(s) ? s : [s], _ = window.document.documentElement;
    return $.some(function(_e) {
      return _e in _.style;
    });
  }
  return !1;
}, isStyleValueSupport = function a(s, $) {
  if (!isStyleNameSupport(s))
    return !1;
  var _ = document.createElement("div"), _e = _.style[s];
  return _.style[s] = $, _.style[s] !== _e;
};
function isStyleSupport(a, s) {
  return !Array.isArray(a) && s !== void 0 ? isStyleValueSupport(a, s) : isStyleNameSupport(a);
}
var HOOK_MARK = "RC_FORM_INTERNAL_HOOKS", warningFunc = function a() {
  warningOnce(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, Context$2 = /* @__PURE__ */ reactExports.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldWarning: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldValue: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function a() {
    return warningFunc(), {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      destroyForm: warningFunc,
      setCallbacks: warningFunc,
      registerWatch: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc,
      getInitialValue: warningFunc
    };
  }
}), ListContext = /* @__PURE__ */ reactExports.createContext(null);
function toArray$8(a) {
  return a == null ? [] : Array.isArray(a) ? a : [a];
}
function isFormInstance(a) {
  return a && !!a._init;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(a) {
    for (var s = 1; s < arguments.length; s++) {
      var $ = arguments[s];
      for (var _ in $)
        Object.prototype.hasOwnProperty.call($, _) && (a[_] = $[_]);
    }
    return a;
  }, _extends$1.apply(this, arguments);
}
function _inheritsLoose(a, s) {
  a.prototype = Object.create(s.prototype), a.prototype.constructor = a, _setPrototypeOf$1(a, s);
}
function _getPrototypeOf(a) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function($) {
    return $.__proto__ || Object.getPrototypeOf($);
  }, _getPrototypeOf(a);
}
function _setPrototypeOf$1(a, s) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(_, _e) {
    return _.__proto__ = _e, _;
  }, _setPrototypeOf$1(a, s);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _construct(a, s, $) {
  return _isNativeReflectConstruct() ? _construct = Reflect.construct.bind() : _construct = function(_e, tt, nt) {
    var at = [null];
    at.push.apply(at, tt);
    var ot = Function.bind.apply(_e, at), rt = new ot();
    return nt && _setPrototypeOf$1(rt, nt.prototype), rt;
  }, _construct.apply(null, arguments);
}
function _isNativeFunction(a) {
  return Function.toString.call(a).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(a) {
  var s = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function(_) {
    if (_ === null || !_isNativeFunction(_))
      return _;
    if (typeof _ != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof s < "u") {
      if (s.has(_))
        return s.get(_);
      s.set(_, _e);
    }
    function _e() {
      return _construct(_, arguments, _getPrototypeOf(this).constructor);
    }
    return _e.prototype = Object.create(_.prototype, {
      constructor: {
        value: _e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf$1(_e, _);
  }, _wrapNativeSuper(a);
}
var formatRegExp = /%[sdj%]/g, warning$1 = function a() {
};
typeof process < "u" && process.env;
function convertFieldsError(a) {
  if (!a || !a.length)
    return null;
  var s = {};
  return a.forEach(function($) {
    var _ = $.field;
    s[_] = s[_] || [], s[_].push($);
  }), s;
}
function format$1(a) {
  for (var s = arguments.length, $ = new Array(s > 1 ? s - 1 : 0), _ = 1; _ < s; _++)
    $[_ - 1] = arguments[_];
  var _e = 0, tt = $.length;
  if (typeof a == "function")
    return a.apply(null, $);
  if (typeof a == "string") {
    var nt = a.replace(formatRegExp, function(at) {
      if (at === "%%")
        return "%";
      if (_e >= tt)
        return at;
      switch (at) {
        case "%s":
          return String($[_e++]);
        case "%d":
          return Number($[_e++]);
        case "%j":
          try {
            return JSON.stringify($[_e++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return at;
      }
    });
    return nt;
  }
  return a;
}
function isNativeStringType(a) {
  return a === "string" || a === "url" || a === "hex" || a === "email" || a === "date" || a === "pattern";
}
function isEmptyValue(a, s) {
  return !!(a == null || s === "array" && Array.isArray(a) && !a.length || isNativeStringType(s) && typeof a == "string" && !a);
}
function asyncParallelArray(a, s, $) {
  var _ = [], _e = 0, tt = a.length;
  function nt(at) {
    _.push.apply(_, at || []), _e++, _e === tt && $(_);
  }
  a.forEach(function(at) {
    s(at, nt);
  });
}
function asyncSerialArray(a, s, $) {
  var _ = 0, _e = a.length;
  function tt(nt) {
    if (nt && nt.length) {
      $(nt);
      return;
    }
    var at = _;
    _ = _ + 1, at < _e ? s(a[at], tt) : $([]);
  }
  tt([]);
}
function flattenObjArr(a) {
  var s = [];
  return Object.keys(a).forEach(function($) {
    s.push.apply(s, a[$] || []);
  }), s;
}
var AsyncValidationError = /* @__PURE__ */ function(a) {
  _inheritsLoose(s, a);
  function s($, _) {
    var _e;
    return _e = a.call(this, "Async Validation Error") || this, _e.errors = $, _e.fields = _, _e;
  }
  return s;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function asyncMap(a, s, $, _, _e) {
  if (s.first) {
    var tt = new Promise(function(et, it) {
      var ut = function(dt) {
        return _(dt), dt.length ? it(new AsyncValidationError(dt, convertFieldsError(dt))) : et(_e);
      }, ft = flattenObjArr(a);
      asyncSerialArray(ft, $, ut);
    });
    return tt.catch(function(et) {
      return et;
    }), tt;
  }
  var nt = s.firstFields === !0 ? Object.keys(a) : s.firstFields || [], at = Object.keys(a), ot = at.length, rt = 0, st = [], lt = new Promise(function(et, it) {
    var ut = function(ht) {
      if (st.push.apply(st, ht), rt++, rt === ot)
        return _(st), st.length ? it(new AsyncValidationError(st, convertFieldsError(st))) : et(_e);
    };
    at.length || (_(st), et(_e)), at.forEach(function(ft) {
      var ht = a[ft];
      nt.indexOf(ft) !== -1 ? asyncSerialArray(ht, $, ut) : asyncParallelArray(ht, $, ut);
    });
  });
  return lt.catch(function(et) {
    return et;
  }), lt;
}
function isErrorObj(a) {
  return !!(a && a.message !== void 0);
}
function getValue$3(a, s) {
  for (var $ = a, _ = 0; _ < s.length; _++) {
    if ($ == null)
      return $;
    $ = $[s[_]];
  }
  return $;
}
function complementError(a, s) {
  return function($) {
    var _;
    return a.fullFields ? _ = getValue$3(s, a.fullFields) : _ = s[$.field || a.fullField], isErrorObj($) ? ($.field = $.field || a.fullField, $.fieldValue = _, $) : {
      message: typeof $ == "function" ? $() : $,
      fieldValue: _,
      field: $.field || a.fullField
    };
  };
}
function deepMerge$1(a, s) {
  if (s) {
    for (var $ in s)
      if (s.hasOwnProperty($)) {
        var _ = s[$];
        typeof _ == "object" && typeof a[$] == "object" ? a[$] = _extends$1({}, a[$], _) : a[$] = _;
      }
  }
  return a;
}
var required$1 = function a(s, $, _, _e, tt, nt) {
  s.required && (!_.hasOwnProperty(s.field) || isEmptyValue($, nt || s.type)) && _e.push(format$1(tt.messages.required, s.fullField));
}, whitespace = function a(s, $, _, _e, tt) {
  (/^\s+$/.test($) || $ === "") && _e.push(format$1(tt.messages.whitespace, s.fullField));
}, urlReg, getUrlRegex = function() {
  if (urlReg)
    return urlReg;
  var a = "[a-fA-F\\d:]", s = function(mt) {
    return mt && mt.includeBoundaries ? "(?:(?<=\\s|^)(?=" + a + ")|(?<=" + a + ")(?=\\s|$))" : "";
  }, $ = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", _ = "[a-fA-F\\d]{1,4}", _e = (`
(?:
(?:` + _ + ":){7}(?:" + _ + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + _ + ":){6}(?:" + $ + "|:" + _ + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + _ + ":){5}(?::" + $ + "|(?::" + _ + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + _ + ":){4}(?:(?::" + _ + "){0,1}:" + $ + "|(?::" + _ + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + _ + ":){3}(?:(?::" + _ + "){0,2}:" + $ + "|(?::" + _ + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + _ + ":){2}(?:(?::" + _ + "){0,3}:" + $ + "|(?::" + _ + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + _ + ":){1}(?:(?::" + _ + "){0,4}:" + $ + "|(?::" + _ + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + _ + "){0,5}:" + $ + "|(?::" + _ + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), tt = new RegExp("(?:^" + $ + "$)|(?:^" + _e + "$)"), nt = new RegExp("^" + $ + "$"), at = new RegExp("^" + _e + "$"), ot = function(mt) {
    return mt && mt.exact ? tt : new RegExp("(?:" + s(mt) + $ + s(mt) + ")|(?:" + s(mt) + _e + s(mt) + ")", "g");
  };
  ot.v4 = function(pt) {
    return pt && pt.exact ? nt : new RegExp("" + s(pt) + $ + s(pt), "g");
  }, ot.v6 = function(pt) {
    return pt && pt.exact ? at : new RegExp("" + s(pt) + _e + s(pt), "g");
  };
  var rt = "(?:(?:[a-z]+:)?//)", st = "(?:\\S+(?::\\S*)?@)?", lt = ot.v4().source, et = ot.v6().source, it = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", ut = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", ft = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", ht = "(?::\\d{2,5})?", dt = '(?:[/?#][^\\s"]*)?', gt = "(?:" + rt + "|www\\.)" + st + "(?:localhost|" + lt + "|" + et + "|" + it + ut + ft + ")" + ht + dt;
  return urlReg = new RegExp("(?:^" + gt + "$)", "i"), urlReg;
}, pattern$2 = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, types = {
  integer: function a(s) {
    return types.number(s) && parseInt(s, 10) === s;
  },
  float: function a(s) {
    return types.number(s) && !types.integer(s);
  },
  array: function a(s) {
    return Array.isArray(s);
  },
  regexp: function a(s) {
    if (s instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(s);
    } catch {
      return !1;
    }
  },
  date: function a(s) {
    return typeof s.getTime == "function" && typeof s.getMonth == "function" && typeof s.getYear == "function" && !isNaN(s.getTime());
  },
  number: function a(s) {
    return isNaN(s) ? !1 : typeof s == "number";
  },
  object: function a(s) {
    return typeof s == "object" && !types.array(s);
  },
  method: function a(s) {
    return typeof s == "function";
  },
  email: function a(s) {
    return typeof s == "string" && s.length <= 320 && !!s.match(pattern$2.email);
  },
  url: function a(s) {
    return typeof s == "string" && s.length <= 2048 && !!s.match(getUrlRegex());
  },
  hex: function a(s) {
    return typeof s == "string" && !!s.match(pattern$2.hex);
  }
}, type$1 = function a(s, $, _, _e, tt) {
  if (s.required && $ === void 0) {
    required$1(s, $, _, _e, tt);
    return;
  }
  var nt = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], at = s.type;
  nt.indexOf(at) > -1 ? types[at]($) || _e.push(format$1(tt.messages.types[at], s.fullField, s.type)) : at && typeof $ !== s.type && _e.push(format$1(tt.messages.types[at], s.fullField, s.type));
}, range = function a(s, $, _, _e, tt) {
  var nt = typeof s.len == "number", at = typeof s.min == "number", ot = typeof s.max == "number", rt = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, st = $, lt = null, et = typeof $ == "number", it = typeof $ == "string", ut = Array.isArray($);
  if (et ? lt = "number" : it ? lt = "string" : ut && (lt = "array"), !lt)
    return !1;
  ut && (st = $.length), it && (st = $.replace(rt, "_").length), nt ? st !== s.len && _e.push(format$1(tt.messages[lt].len, s.fullField, s.len)) : at && !ot && st < s.min ? _e.push(format$1(tt.messages[lt].min, s.fullField, s.min)) : ot && !at && st > s.max ? _e.push(format$1(tt.messages[lt].max, s.fullField, s.max)) : at && ot && (st < s.min || st > s.max) && _e.push(format$1(tt.messages[lt].range, s.fullField, s.min, s.max));
}, ENUM$1 = "enum", enumerable$1 = function a(s, $, _, _e, tt) {
  s[ENUM$1] = Array.isArray(s[ENUM$1]) ? s[ENUM$1] : [], s[ENUM$1].indexOf($) === -1 && _e.push(format$1(tt.messages[ENUM$1], s.fullField, s[ENUM$1].join(", ")));
}, pattern$1 = function a(s, $, _, _e, tt) {
  if (s.pattern) {
    if (s.pattern instanceof RegExp)
      s.pattern.lastIndex = 0, s.pattern.test($) || _e.push(format$1(tt.messages.pattern.mismatch, s.fullField, $, s.pattern));
    else if (typeof s.pattern == "string") {
      var nt = new RegExp(s.pattern);
      nt.test($) || _e.push(format$1(tt.messages.pattern.mismatch, s.fullField, $, s.pattern));
    }
  }
}, rules = {
  required: required$1,
  whitespace,
  type: type$1,
  range,
  enum: enumerable$1,
  pattern: pattern$1
}, string = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($, "string") && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt, "string"), isEmptyValue($, "string") || (rules.type(s, $, _e, nt, tt), rules.range(s, $, _e, nt, tt), rules.pattern(s, $, _e, nt, tt), s.whitespace === !0 && rules.whitespace(s, $, _e, nt, tt));
  }
  _(nt);
}, method2 = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($) && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt), $ !== void 0 && rules.type(s, $, _e, nt, tt);
  }
  _(nt);
}, number2 = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if ($ === "" && ($ = void 0), isEmptyValue($) && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt), $ !== void 0 && (rules.type(s, $, _e, nt, tt), rules.range(s, $, _e, nt, tt));
  }
  _(nt);
}, _boolean = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($) && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt), $ !== void 0 && rules.type(s, $, _e, nt, tt);
  }
  _(nt);
}, regexp2 = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($) && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt), isEmptyValue($) || rules.type(s, $, _e, nt, tt);
  }
  _(nt);
}, integer2 = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($) && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt), $ !== void 0 && (rules.type(s, $, _e, nt, tt), rules.range(s, $, _e, nt, tt));
  }
  _(nt);
}, floatFn = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($) && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt), $ !== void 0 && (rules.type(s, $, _e, nt, tt), rules.range(s, $, _e, nt, tt));
  }
  _(nt);
}, array2 = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if ($ == null && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt, "array"), $ != null && (rules.type(s, $, _e, nt, tt), rules.range(s, $, _e, nt, tt));
  }
  _(nt);
}, object2 = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($) && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt), $ !== void 0 && rules.type(s, $, _e, nt, tt);
  }
  _(nt);
}, ENUM = "enum", enumerable2 = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($) && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt), $ !== void 0 && rules[ENUM](s, $, _e, nt, tt);
  }
  _(nt);
}, pattern2 = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($, "string") && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt), isEmptyValue($, "string") || rules.pattern(s, $, _e, nt, tt);
  }
  _(nt);
}, date2 = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($, "date") && !s.required)
      return _();
    if (rules.required(s, $, _e, nt, tt), !isEmptyValue($, "date")) {
      var ot;
      $ instanceof Date ? ot = $ : ot = new Date($), rules.type(s, ot, _e, nt, tt), ot && rules.range(s, ot.getTime(), _e, nt, tt);
    }
  }
  _(nt);
}, required2 = function a(s, $, _, _e, tt) {
  var nt = [], at = Array.isArray($) ? "array" : typeof $;
  rules.required(s, $, _e, nt, tt, at), _(nt);
}, type2 = function a(s, $, _, _e, tt) {
  var nt = s.type, at = [], ot = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (ot) {
    if (isEmptyValue($, nt) && !s.required)
      return _();
    rules.required(s, $, _e, at, tt, nt), isEmptyValue($, nt) || rules.type(s, $, _e, at, tt);
  }
  _(at);
}, any = function a(s, $, _, _e, tt) {
  var nt = [], at = s.required || !s.required && _e.hasOwnProperty(s.field);
  if (at) {
    if (isEmptyValue($) && !s.required)
      return _();
    rules.required(s, $, _e, nt, tt);
  }
  _(nt);
}, validators = {
  string,
  method: method2,
  number: number2,
  boolean: _boolean,
  regexp: regexp2,
  integer: integer2,
  float: floatFn,
  array: array2,
  object: object2,
  enum: enumerable2,
  pattern: pattern2,
  date: date2,
  url: type2,
  hex: type2,
  email: type2,
  required: required2,
  any
};
function newMessages() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var s = JSON.parse(JSON.stringify(this));
      return s.clone = this.clone, s;
    }
  };
}
var messages = newMessages(), Schema = /* @__PURE__ */ function() {
  function a($) {
    this.rules = null, this._messages = messages, this.define($);
  }
  var s = a.prototype;
  return s.define = function(_) {
    var _e = this;
    if (!_)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof _ != "object" || Array.isArray(_))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(_).forEach(function(tt) {
      var nt = _[tt];
      _e.rules[tt] = Array.isArray(nt) ? nt : [nt];
    });
  }, s.messages = function(_) {
    return _ && (this._messages = deepMerge$1(newMessages(), _)), this._messages;
  }, s.validate = function(_, _e, tt) {
    var nt = this;
    _e === void 0 && (_e = {}), tt === void 0 && (tt = function() {
    });
    var at = _, ot = _e, rt = tt;
    if (typeof ot == "function" && (rt = ot, ot = {}), !this.rules || Object.keys(this.rules).length === 0)
      return rt && rt(null, at), Promise.resolve(at);
    function st(ft) {
      var ht = [], dt = {};
      function gt(mt) {
        if (Array.isArray(mt)) {
          var ct;
          ht = (ct = ht).concat.apply(ct, mt);
        } else
          ht.push(mt);
      }
      for (var pt = 0; pt < ft.length; pt++)
        gt(ft[pt]);
      ht.length ? (dt = convertFieldsError(ht), rt(ht, dt)) : rt(null, at);
    }
    if (ot.messages) {
      var lt = this.messages();
      lt === messages && (lt = newMessages()), deepMerge$1(lt, ot.messages), ot.messages = lt;
    } else
      ot.messages = this.messages();
    var et = {}, it = ot.keys || Object.keys(this.rules);
    it.forEach(function(ft) {
      var ht = nt.rules[ft], dt = at[ft];
      ht.forEach(function(gt) {
        var pt = gt;
        typeof pt.transform == "function" && (at === _ && (at = _extends$1({}, at)), dt = at[ft] = pt.transform(dt)), typeof pt == "function" ? pt = {
          validator: pt
        } : pt = _extends$1({}, pt), pt.validator = nt.getValidationMethod(pt), pt.validator && (pt.field = ft, pt.fullField = pt.fullField || ft, pt.type = nt.getType(pt), et[ft] = et[ft] || [], et[ft].push({
          rule: pt,
          value: dt,
          source: at,
          field: ft
        }));
      });
    });
    var ut = {};
    return asyncMap(et, ot, function(ft, ht) {
      var dt = ft.rule, gt = (dt.type === "object" || dt.type === "array") && (typeof dt.fields == "object" || typeof dt.defaultField == "object");
      gt = gt && (dt.required || !dt.required && ft.value), dt.field = ft.field;
      function pt(vt, At) {
        return _extends$1({}, At, {
          fullField: dt.fullField + "." + vt,
          fullFields: dt.fullFields ? [].concat(dt.fullFields, [vt]) : [vt]
        });
      }
      function mt(vt) {
        vt === void 0 && (vt = []);
        var At = Array.isArray(vt) ? vt : [vt];
        !ot.suppressWarning && At.length && a.warning("async-validator:", At), At.length && dt.message !== void 0 && (At = [].concat(dt.message));
        var xt = At.map(complementError(dt, at));
        if (ot.first && xt.length)
          return ut[dt.field] = 1, ht(xt);
        if (!gt)
          ht(xt);
        else {
          if (dt.required && !ft.value)
            return dt.message !== void 0 ? xt = [].concat(dt.message).map(complementError(dt, at)) : ot.error && (xt = [ot.error(dt, format$1(ot.messages.required, dt.field))]), ht(xt);
          var bt = {};
          dt.defaultField && Object.keys(ft.value).map(function(Bt) {
            bt[Bt] = dt.defaultField;
          }), bt = _extends$1({}, bt, ft.rule.fields);
          var Et = {};
          Object.keys(bt).forEach(function(Bt) {
            var Ot = bt[Bt], Pt = Array.isArray(Ot) ? Ot : [Ot];
            Et[Bt] = Pt.map(pt.bind(null, Bt));
          });
          var St = new a(Et);
          St.messages(ot.messages), ft.rule.options && (ft.rule.options.messages = ot.messages, ft.rule.options.error = ot.error), St.validate(ft.value, ft.rule.options || ot, function(Bt) {
            var Ot = [];
            xt && xt.length && Ot.push.apply(Ot, xt), Bt && Bt.length && Ot.push.apply(Ot, Bt), ht(Ot.length ? Ot : null);
          });
        }
      }
      var ct;
      if (dt.asyncValidator)
        ct = dt.asyncValidator(dt, ft.value, mt, ft.source, ot);
      else if (dt.validator) {
        try {
          ct = dt.validator(dt, ft.value, mt, ft.source, ot);
        } catch (vt) {
          console.error == null || console.error(vt), ot.suppressValidatorError || setTimeout(function() {
            throw vt;
          }, 0), mt(vt.message);
        }
        ct === !0 ? mt() : ct === !1 ? mt(typeof dt.message == "function" ? dt.message(dt.fullField || dt.field) : dt.message || (dt.fullField || dt.field) + " fails") : ct instanceof Array ? mt(ct) : ct instanceof Error && mt(ct.message);
      }
      ct && ct.then && ct.then(function() {
        return mt();
      }, function(vt) {
        return mt(vt);
      });
    }, function(ft) {
      st(ft);
    }, at);
  }, s.getType = function(_) {
    if (_.type === void 0 && _.pattern instanceof RegExp && (_.type = "pattern"), typeof _.validator != "function" && _.type && !validators.hasOwnProperty(_.type))
      throw new Error(format$1("Unknown rule type %s", _.type));
    return _.type || "string";
  }, s.getValidationMethod = function(_) {
    if (typeof _.validator == "function")
      return _.validator;
    var _e = Object.keys(_), tt = _e.indexOf("message");
    return tt !== -1 && _e.splice(tt, 1), _e.length === 1 && _e[0] === "required" ? validators.required : validators[this.getType(_)] || void 0;
  }, a;
}();
Schema.register = function a(s, $) {
  if (typeof $ != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  validators[s] = $;
};
Schema.warning = warning$1;
Schema.messages = messages;
Schema.validators = validators;
var typeTemplate$3 = "'${name}' is not a valid ${type}", defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate$3,
    method: typeTemplate$3,
    array: typeTemplate$3,
    object: typeTemplate$3,
    number: typeTemplate$3,
    date: typeTemplate$3,
    boolean: typeTemplate$3,
    integer: typeTemplate$3,
    float: typeTemplate$3,
    regexp: typeTemplate$3,
    email: typeTemplate$3,
    url: typeTemplate$3,
    hex: typeTemplate$3
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, AsyncValidator = Schema;
function replaceMessage(a, s) {
  return a.replace(/\$\{\w+\}/g, function($) {
    var _ = $.slice(2, -1);
    return s[_];
  });
}
var CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
function validateRule(a, s, $, _, _e) {
  return _validateRule.apply(this, arguments);
}
function _validateRule() {
  return _validateRule = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function a(s, $, _, _e, tt) {
    var nt, at, ot, rt, st, lt, et, it, ut;
    return _regeneratorRuntime$3().wrap(function(ht) {
      for (; ; )
        switch (ht.prev = ht.next) {
          case 0:
            return nt = _objectSpread2$a({}, _), delete nt.ruleIndex, AsyncValidator.warning = function() {
            }, nt.validator && (at = nt.validator, nt.validator = function() {
              try {
                return at.apply(void 0, arguments);
              } catch (dt) {
                return console.error(dt), Promise.reject(CODE_LOGIC_ERROR);
              }
            }), ot = null, nt && nt.type === "array" && nt.defaultField && (ot = nt.defaultField, delete nt.defaultField), rt = new AsyncValidator(_defineProperty$c({}, s, [nt])), st = merge$1(defaultValidateMessages, _e.validateMessages), rt.messages(st), lt = [], ht.prev = 10, ht.next = 13, Promise.resolve(rt.validate(_defineProperty$c({}, s, $), _objectSpread2$a({}, _e)));
          case 13:
            ht.next = 18;
            break;
          case 15:
            ht.prev = 15, ht.t0 = ht.catch(10), ht.t0.errors && (lt = ht.t0.errors.map(function(dt, gt) {
              var pt = dt.message, mt = pt === CODE_LOGIC_ERROR ? st.default : pt;
              return /* @__PURE__ */ reactExports.isValidElement(mt) ? (
                // Wrap ReactNode with `key`
                reactExports.cloneElement(mt, {
                  key: "error_".concat(gt)
                })
              ) : mt;
            }));
          case 18:
            if (!(!lt.length && ot)) {
              ht.next = 23;
              break;
            }
            return ht.next = 21, Promise.all($.map(function(dt, gt) {
              return validateRule("".concat(s, ".").concat(gt), dt, ot, _e, tt);
            }));
          case 21:
            return et = ht.sent, ht.abrupt("return", et.reduce(function(dt, gt) {
              return [].concat(_toConsumableArray$d(dt), _toConsumableArray$d(gt));
            }, []));
          case 23:
            return it = _objectSpread2$a(_objectSpread2$a({}, _), {}, {
              name: s,
              enum: (_.enum || []).join(", ")
            }, tt), ut = lt.map(function(dt) {
              return typeof dt == "string" ? replaceMessage(dt, it) : dt;
            }), ht.abrupt("return", ut);
          case 26:
          case "end":
            return ht.stop();
        }
    }, a, null, [[10, 15]]);
  })), _validateRule.apply(this, arguments);
}
function validateRules(a, s, $, _, _e, tt) {
  var nt = a.join("."), at = $.map(function(st, lt) {
    var et = st.validator, it = _objectSpread2$a(_objectSpread2$a({}, st), {}, {
      ruleIndex: lt
    });
    return et && (it.validator = function(ut, ft, ht) {
      var dt = !1, gt = function() {
        for (var ct = arguments.length, vt = new Array(ct), At = 0; At < ct; At++)
          vt[At] = arguments[At];
        Promise.resolve().then(function() {
          warningOnce(!dt, "Your validator function has already return a promise. `callback` will be ignored."), dt || ht.apply(void 0, vt);
        });
      }, pt = et(ut, ft, gt);
      dt = pt && typeof pt.then == "function" && typeof pt.catch == "function", warningOnce(dt, "`callback` is deprecated. Please return a promise instead."), dt && pt.then(function() {
        ht();
      }).catch(function(mt) {
        ht(mt || " ");
      });
    }), it;
  }).sort(function(st, lt) {
    var et = st.warningOnly, it = st.ruleIndex, ut = lt.warningOnly, ft = lt.ruleIndex;
    return !!et == !!ut ? it - ft : et ? 1 : -1;
  }), ot;
  if (_e === !0)
    ot = new Promise(/* @__PURE__ */ function() {
      var st = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function lt(et, it) {
        var ut, ft, ht;
        return _regeneratorRuntime$3().wrap(function(gt) {
          for (; ; )
            switch (gt.prev = gt.next) {
              case 0:
                ut = 0;
              case 1:
                if (!(ut < at.length)) {
                  gt.next = 12;
                  break;
                }
                return ft = at[ut], gt.next = 5, validateRule(nt, s, ft, _, tt);
              case 5:
                if (ht = gt.sent, !ht.length) {
                  gt.next = 9;
                  break;
                }
                return it([{
                  errors: ht,
                  rule: ft
                }]), gt.abrupt("return");
              case 9:
                ut += 1, gt.next = 1;
                break;
              case 12:
                et([]);
              case 13:
              case "end":
                return gt.stop();
            }
        }, lt);
      }));
      return function(lt, et) {
        return st.apply(this, arguments);
      };
    }());
  else {
    var rt = at.map(function(st) {
      return validateRule(nt, s, st, _, tt).then(function(lt) {
        return {
          errors: lt,
          rule: st
        };
      });
    });
    ot = (_e ? finishOnFirstFailed(rt) : finishOnAllFailed(rt)).then(function(st) {
      return Promise.reject(st);
    });
  }
  return ot.catch(function(st) {
    return st;
  }), ot;
}
function finishOnAllFailed(a) {
  return _finishOnAllFailed.apply(this, arguments);
}
function _finishOnAllFailed() {
  return _finishOnAllFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function a(s) {
    return _regeneratorRuntime$3().wrap(function(_) {
      for (; ; )
        switch (_.prev = _.next) {
          case 0:
            return _.abrupt("return", Promise.all(s).then(function(_e) {
              var tt, nt = (tt = []).concat.apply(tt, _toConsumableArray$d(_e));
              return nt;
            }));
          case 1:
          case "end":
            return _.stop();
        }
    }, a);
  })), _finishOnAllFailed.apply(this, arguments);
}
function finishOnFirstFailed(a) {
  return _finishOnFirstFailed.apply(this, arguments);
}
function _finishOnFirstFailed() {
  return _finishOnFirstFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function a(s) {
    var $;
    return _regeneratorRuntime$3().wrap(function(_e) {
      for (; ; )
        switch (_e.prev = _e.next) {
          case 0:
            return $ = 0, _e.abrupt("return", new Promise(function(tt) {
              s.forEach(function(nt) {
                nt.then(function(at) {
                  at.errors.length && tt([at]), $ += 1, $ === s.length && tt([]);
                });
              });
            }));
          case 2:
          case "end":
            return _e.stop();
        }
    }, a);
  })), _finishOnFirstFailed.apply(this, arguments);
}
function getNamePath(a) {
  return toArray$8(a);
}
function cloneByNamePathList(a, s) {
  var $ = {};
  return s.forEach(function(_) {
    var _e = get$1(a, _);
    $ = set$1($, _, _e);
  }), $;
}
function containsNamePath(a, s) {
  var $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return a && a.some(function(_) {
    return matchNamePath(s, _, $);
  });
}
function matchNamePath(a, s) {
  var $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !a || !s || !$ && a.length !== s.length ? !1 : s.every(function(_, _e) {
    return a[_e] === _;
  });
}
function isSimilar(a, s) {
  if (a === s)
    return !0;
  if (!a && s || a && !s || !a || !s || _typeof$q(a) !== "object" || _typeof$q(s) !== "object")
    return !1;
  var $ = Object.keys(a), _ = Object.keys(s), _e = new Set([].concat($, _));
  return _toConsumableArray$d(_e).every(function(tt) {
    var nt = a[tt], at = s[tt];
    return typeof nt == "function" && typeof at == "function" ? !0 : nt === at;
  });
}
function defaultGetValueFromEvent(a) {
  var s = arguments.length <= 1 ? void 0 : arguments[1];
  return s && s.target && _typeof$q(s.target) === "object" && a in s.target ? s.target[a] : s;
}
function move(a, s, $) {
  var _ = a.length;
  if (s < 0 || s >= _ || $ < 0 || $ >= _)
    return a;
  var _e = a[s], tt = s - $;
  return tt > 0 ? [].concat(_toConsumableArray$d(a.slice(0, $)), [_e], _toConsumableArray$d(a.slice($, s)), _toConsumableArray$d(a.slice(s + 1, _))) : tt < 0 ? [].concat(_toConsumableArray$d(a.slice(0, s)), _toConsumableArray$d(a.slice(s + 1, $ + 1)), [_e], _toConsumableArray$d(a.slice($ + 1, _))) : a;
}
var _excluded$T = ["name"], EMPTY_ERRORS = [];
function requireUpdate(a, s, $, _, _e, tt) {
  return typeof a == "function" ? a(s, $, "source" in tt ? {
    source: tt.source
  } : {}) : _ !== _e;
}
var Field = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $(_) {
    var _e;
    if (_classCallCheck(this, $), _e = s.call(this, _), _defineProperty$c(_assertThisInitialized(_e), "state", {
      resetCount: 0
    }), _defineProperty$c(_assertThisInitialized(_e), "cancelRegisterFunc", null), _defineProperty$c(_assertThisInitialized(_e), "mounted", !1), _defineProperty$c(_assertThisInitialized(_e), "touched", !1), _defineProperty$c(_assertThisInitialized(_e), "dirty", !1), _defineProperty$c(_assertThisInitialized(_e), "validatePromise", void 0), _defineProperty$c(_assertThisInitialized(_e), "prevValidating", void 0), _defineProperty$c(_assertThisInitialized(_e), "errors", EMPTY_ERRORS), _defineProperty$c(_assertThisInitialized(_e), "warnings", EMPTY_ERRORS), _defineProperty$c(_assertThisInitialized(_e), "cancelRegister", function() {
      var ot = _e.props, rt = ot.preserve, st = ot.isListField, lt = ot.name;
      _e.cancelRegisterFunc && _e.cancelRegisterFunc(st, rt, getNamePath(lt)), _e.cancelRegisterFunc = null;
    }), _defineProperty$c(_assertThisInitialized(_e), "getNamePath", function() {
      var ot = _e.props, rt = ot.name, st = ot.fieldContext, lt = st.prefixName, et = lt === void 0 ? [] : lt;
      return rt !== void 0 ? [].concat(_toConsumableArray$d(et), _toConsumableArray$d(rt)) : [];
    }), _defineProperty$c(_assertThisInitialized(_e), "getRules", function() {
      var ot = _e.props, rt = ot.rules, st = rt === void 0 ? [] : rt, lt = ot.fieldContext;
      return st.map(function(et) {
        return typeof et == "function" ? et(lt) : et;
      });
    }), _defineProperty$c(_assertThisInitialized(_e), "refresh", function() {
      _e.mounted && _e.setState(function(ot) {
        var rt = ot.resetCount;
        return {
          resetCount: rt + 1
        };
      });
    }), _defineProperty$c(_assertThisInitialized(_e), "metaCache", null), _defineProperty$c(_assertThisInitialized(_e), "triggerMetaEvent", function(ot) {
      var rt = _e.props.onMetaChange;
      if (rt) {
        var st = _objectSpread2$a(_objectSpread2$a({}, _e.getMeta()), {}, {
          destroy: ot
        });
        isEqual$1(_e.metaCache, st) || rt(st), _e.metaCache = st;
      } else
        _e.metaCache = null;
    }), _defineProperty$c(_assertThisInitialized(_e), "onStoreChange", function(ot, rt, st) {
      var lt = _e.props, et = lt.shouldUpdate, it = lt.dependencies, ut = it === void 0 ? [] : it, ft = lt.onReset, ht = st.store, dt = _e.getNamePath(), gt = _e.getValue(ot), pt = _e.getValue(ht), mt = rt && containsNamePath(rt, dt);
      switch (st.type === "valueUpdate" && st.source === "external" && gt !== pt && (_e.touched = !0, _e.dirty = !0, _e.validatePromise = null, _e.errors = EMPTY_ERRORS, _e.warnings = EMPTY_ERRORS, _e.triggerMetaEvent()), st.type) {
        case "reset":
          if (!rt || mt) {
            _e.touched = !1, _e.dirty = !1, _e.validatePromise = void 0, _e.errors = EMPTY_ERRORS, _e.warnings = EMPTY_ERRORS, _e.triggerMetaEvent(), ft == null || ft(), _e.refresh();
            return;
          }
          break;
        case "remove": {
          if (et) {
            _e.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var ct = st.data;
          if (mt) {
            "touched" in ct && (_e.touched = ct.touched), "validating" in ct && !("originRCField" in ct) && (_e.validatePromise = ct.validating ? Promise.resolve([]) : null), "errors" in ct && (_e.errors = ct.errors || EMPTY_ERRORS), "warnings" in ct && (_e.warnings = ct.warnings || EMPTY_ERRORS), _e.dirty = !0, _e.triggerMetaEvent(), _e.reRender();
            return;
          } else if ("value" in ct && containsNamePath(rt, dt, !0)) {
            _e.reRender();
            return;
          }
          if (et && !dt.length && requireUpdate(et, ot, ht, gt, pt, st)) {
            _e.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var vt = ut.map(getNamePath);
          if (vt.some(function(At) {
            return containsNamePath(st.relatedFields, At);
          })) {
            _e.reRender();
            return;
          }
          break;
        }
        default:
          if (mt || (!ut.length || dt.length || et) && requireUpdate(et, ot, ht, gt, pt, st)) {
            _e.reRender();
            return;
          }
          break;
      }
      et === !0 && _e.reRender();
    }), _defineProperty$c(_assertThisInitialized(_e), "validateRules", function(ot) {
      var rt = _e.getNamePath(), st = _e.getValue(), lt = ot || {}, et = lt.triggerName, it = lt.validateOnly, ut = it === void 0 ? !1 : it, ft = Promise.resolve().then(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function ht() {
        var dt, gt, pt, mt, ct, vt, At;
        return _regeneratorRuntime$3().wrap(function(bt) {
          for (; ; )
            switch (bt.prev = bt.next) {
              case 0:
                if (_e.mounted) {
                  bt.next = 2;
                  break;
                }
                return bt.abrupt("return", []);
              case 2:
                if (dt = _e.props, gt = dt.validateFirst, pt = gt === void 0 ? !1 : gt, mt = dt.messageVariables, ct = dt.validateDebounce, vt = _e.getRules(), et && (vt = vt.filter(function(Et) {
                  return Et;
                }).filter(function(Et) {
                  var St = Et.validateTrigger;
                  if (!St)
                    return !0;
                  var Bt = toArray$8(St);
                  return Bt.includes(et);
                })), !(ct && et)) {
                  bt.next = 10;
                  break;
                }
                return bt.next = 8, new Promise(function(Et) {
                  setTimeout(Et, ct);
                });
              case 8:
                if (_e.validatePromise === ft) {
                  bt.next = 10;
                  break;
                }
                return bt.abrupt("return", []);
              case 10:
                return At = validateRules(rt, st, vt, ot, pt, mt), At.catch(function(Et) {
                  return Et;
                }).then(function() {
                  var Et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EMPTY_ERRORS;
                  if (_e.validatePromise === ft) {
                    var St;
                    _e.validatePromise = null;
                    var Bt = [], Ot = [];
                    (St = Et.forEach) === null || St === void 0 || St.call(Et, function(Pt) {
                      var wt = Pt.rule.warningOnly, Ct = Pt.errors, It = Ct === void 0 ? EMPTY_ERRORS : Ct;
                      wt ? Ot.push.apply(Ot, _toConsumableArray$d(It)) : Bt.push.apply(Bt, _toConsumableArray$d(It));
                    }), _e.errors = Bt, _e.warnings = Ot, _e.triggerMetaEvent(), _e.reRender();
                  }
                }), bt.abrupt("return", At);
              case 13:
              case "end":
                return bt.stop();
            }
        }, ht);
      })));
      return ut || (_e.validatePromise = ft, _e.dirty = !0, _e.errors = EMPTY_ERRORS, _e.warnings = EMPTY_ERRORS, _e.triggerMetaEvent(), _e.reRender()), ft;
    }), _defineProperty$c(_assertThisInitialized(_e), "isFieldValidating", function() {
      return !!_e.validatePromise;
    }), _defineProperty$c(_assertThisInitialized(_e), "isFieldTouched", function() {
      return _e.touched;
    }), _defineProperty$c(_assertThisInitialized(_e), "isFieldDirty", function() {
      if (_e.dirty || _e.props.initialValue !== void 0)
        return !0;
      var ot = _e.props.fieldContext, rt = ot.getInternalHooks(HOOK_MARK), st = rt.getInitialValue;
      return st(_e.getNamePath()) !== void 0;
    }), _defineProperty$c(_assertThisInitialized(_e), "getErrors", function() {
      return _e.errors;
    }), _defineProperty$c(_assertThisInitialized(_e), "getWarnings", function() {
      return _e.warnings;
    }), _defineProperty$c(_assertThisInitialized(_e), "isListField", function() {
      return _e.props.isListField;
    }), _defineProperty$c(_assertThisInitialized(_e), "isList", function() {
      return _e.props.isList;
    }), _defineProperty$c(_assertThisInitialized(_e), "isPreserve", function() {
      return _e.props.preserve;
    }), _defineProperty$c(_assertThisInitialized(_e), "getMeta", function() {
      _e.prevValidating = _e.isFieldValidating();
      var ot = {
        touched: _e.isFieldTouched(),
        validating: _e.prevValidating,
        errors: _e.errors,
        warnings: _e.warnings,
        name: _e.getNamePath(),
        validated: _e.validatePromise === null
      };
      return ot;
    }), _defineProperty$c(_assertThisInitialized(_e), "getOnlyChild", function(ot) {
      if (typeof ot == "function") {
        var rt = _e.getMeta();
        return _objectSpread2$a(_objectSpread2$a({}, _e.getOnlyChild(ot(_e.getControlled(), rt, _e.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var st = toArray$9(ot);
      return st.length !== 1 || !/* @__PURE__ */ reactExports.isValidElement(st[0]) ? {
        child: st,
        isFunction: !1
      } : {
        child: st[0],
        isFunction: !1
      };
    }), _defineProperty$c(_assertThisInitialized(_e), "getValue", function(ot) {
      var rt = _e.props.fieldContext.getFieldsValue, st = _e.getNamePath();
      return get$1(ot || rt(!0), st);
    }), _defineProperty$c(_assertThisInitialized(_e), "getControlled", function() {
      var ot = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, rt = _e.props, st = rt.trigger, lt = rt.validateTrigger, et = rt.getValueFromEvent, it = rt.normalize, ut = rt.valuePropName, ft = rt.getValueProps, ht = rt.fieldContext, dt = lt !== void 0 ? lt : ht.validateTrigger, gt = _e.getNamePath(), pt = ht.getInternalHooks, mt = ht.getFieldsValue, ct = pt(HOOK_MARK), vt = ct.dispatch, At = _e.getValue(), xt = ft || function(Bt) {
        return _defineProperty$c({}, ut, Bt);
      }, bt = ot[st], Et = _objectSpread2$a(_objectSpread2$a({}, ot), xt(At));
      Et[st] = function() {
        _e.touched = !0, _e.dirty = !0, _e.triggerMetaEvent();
        for (var Bt, Ot = arguments.length, Pt = new Array(Ot), wt = 0; wt < Ot; wt++)
          Pt[wt] = arguments[wt];
        et ? Bt = et.apply(void 0, Pt) : Bt = defaultGetValueFromEvent.apply(void 0, [ut].concat(Pt)), it && (Bt = it(Bt, At, mt(!0))), vt({
          type: "updateValue",
          namePath: gt,
          value: Bt
        }), bt && bt.apply(void 0, Pt);
      };
      var St = toArray$8(dt || []);
      return St.forEach(function(Bt) {
        var Ot = Et[Bt];
        Et[Bt] = function() {
          Ot && Ot.apply(void 0, arguments);
          var Pt = _e.props.rules;
          Pt && Pt.length && vt({
            type: "validateField",
            namePath: gt,
            triggerName: Bt
          });
        };
      }), Et;
    }), _.fieldContext) {
      var tt = _.fieldContext.getInternalHooks, nt = tt(HOOK_MARK), at = nt.initEntityValue;
      at(_assertThisInitialized(_e));
    }
    return _e;
  }
  return _createClass($, [{
    key: "componentDidMount",
    value: function() {
      var _e = this.props, tt = _e.shouldUpdate, nt = _e.fieldContext;
      if (this.mounted = !0, nt) {
        var at = nt.getInternalHooks, ot = at(HOOK_MARK), rt = ot.registerField;
        this.cancelRegisterFunc = rt(this);
      }
      tt === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var _e = this.state.resetCount, tt = this.props.children, nt = this.getOnlyChild(tt), at = nt.child, ot = nt.isFunction, rt;
      return ot ? rt = at : /* @__PURE__ */ reactExports.isValidElement(at) ? rt = /* @__PURE__ */ reactExports.cloneElement(at, this.getControlled(at.props)) : (warningOnce(!at, "`children` of Field is not validate ReactElement."), rt = at), /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, {
        key: _e
      }, rt);
    }
  }]), $;
}(reactExports.Component);
_defineProperty$c(Field, "contextType", Context$2);
_defineProperty$c(Field, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function WrapperField(a) {
  var s = a.name, $ = _objectWithoutProperties$1(a, _excluded$T), _ = reactExports.useContext(Context$2), _e = reactExports.useContext(ListContext), tt = s !== void 0 ? getNamePath(s) : void 0, nt = "keep";
  return $.isListField || (nt = "_".concat((tt || []).join("_"))), /* @__PURE__ */ reactExports.createElement(Field, _extends$2({
    key: nt,
    name: tt,
    isListField: !!_e
  }, $, {
    fieldContext: _
  }));
}
function List$2(a) {
  var s = a.name, $ = a.initialValue, _ = a.children, _e = a.rules, tt = a.validateTrigger, nt = a.isListField, at = reactExports.useContext(Context$2), ot = reactExports.useContext(ListContext), rt = reactExports.useRef({
    keys: [],
    id: 0
  }), st = rt.current, lt = reactExports.useMemo(function() {
    var ft = getNamePath(at.prefixName) || [];
    return [].concat(_toConsumableArray$d(ft), _toConsumableArray$d(getNamePath(s)));
  }, [at.prefixName, s]), et = reactExports.useMemo(function() {
    return _objectSpread2$a(_objectSpread2$a({}, at), {}, {
      prefixName: lt
    });
  }, [at, lt]), it = reactExports.useMemo(function() {
    return {
      getKey: function(ht) {
        var dt = lt.length, gt = ht[dt];
        return [st.keys[gt], ht.slice(dt + 1)];
      }
    };
  }, [lt]);
  if (typeof _ != "function")
    return warningOnce(!1, "Form.List only accepts function as children."), null;
  var ut = function(ht, dt, gt) {
    var pt = gt.source;
    return pt === "internal" ? !1 : ht !== dt;
  };
  return /* @__PURE__ */ reactExports.createElement(ListContext.Provider, {
    value: it
  }, /* @__PURE__ */ reactExports.createElement(Context$2.Provider, {
    value: et
  }, /* @__PURE__ */ reactExports.createElement(WrapperField, {
    name: [],
    shouldUpdate: ut,
    rules: _e,
    validateTrigger: tt,
    initialValue: $,
    isList: !0,
    isListField: nt ?? !!ot
  }, function(ft, ht) {
    var dt = ft.value, gt = dt === void 0 ? [] : dt, pt = ft.onChange, mt = at.getFieldValue, ct = function() {
      var bt = mt(lt || []);
      return bt || [];
    }, vt = {
      add: function(bt, Et) {
        var St = ct();
        Et >= 0 && Et <= St.length ? (st.keys = [].concat(_toConsumableArray$d(st.keys.slice(0, Et)), [st.id], _toConsumableArray$d(st.keys.slice(Et))), pt([].concat(_toConsumableArray$d(St.slice(0, Et)), [bt], _toConsumableArray$d(St.slice(Et))))) : (st.keys = [].concat(_toConsumableArray$d(st.keys), [st.id]), pt([].concat(_toConsumableArray$d(St), [bt]))), st.id += 1;
      },
      remove: function(bt) {
        var Et = ct(), St = new Set(Array.isArray(bt) ? bt : [bt]);
        St.size <= 0 || (st.keys = st.keys.filter(function(Bt, Ot) {
          return !St.has(Ot);
        }), pt(Et.filter(function(Bt, Ot) {
          return !St.has(Ot);
        })));
      },
      move: function(bt, Et) {
        if (bt !== Et) {
          var St = ct();
          bt < 0 || bt >= St.length || Et < 0 || Et >= St.length || (st.keys = move(st.keys, bt, Et), pt(move(St, bt, Et)));
        }
      }
    }, At = gt || [];
    return Array.isArray(At) || (At = []), _(At.map(function(xt, bt) {
      var Et = st.keys[bt];
      return Et === void 0 && (st.keys[bt] = st.id, Et = st.keys[bt], st.id += 1), {
        name: bt,
        key: Et,
        isListField: !0
      };
    }), vt, ht);
  })));
}
function allPromiseFinish(a) {
  var s = !1, $ = a.length, _ = [];
  return a.length ? new Promise(function(_e, tt) {
    a.forEach(function(nt, at) {
      nt.catch(function(ot) {
        return s = !0, ot;
      }).then(function(ot) {
        $ -= 1, _[at] = ot, !($ > 0) && (s && tt(_), _e(_));
      });
    });
  }) : Promise.resolve([]);
}
var SPLIT = "__@field_split__";
function normalize(a) {
  return a.map(function(s) {
    return "".concat(_typeof$q(s), ":").concat(s);
  }).join(SPLIT);
}
var NameMap = /* @__PURE__ */ function() {
  function a() {
    _classCallCheck(this, a), _defineProperty$c(this, "kvs", /* @__PURE__ */ new Map());
  }
  return _createClass(a, [{
    key: "set",
    value: function($, _) {
      this.kvs.set(normalize($), _);
    }
  }, {
    key: "get",
    value: function($) {
      return this.kvs.get(normalize($));
    }
  }, {
    key: "update",
    value: function($, _) {
      var _e = this.get($), tt = _(_e);
      tt ? this.set($, tt) : this.delete($);
    }
  }, {
    key: "delete",
    value: function($) {
      this.kvs.delete(normalize($));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function($) {
      return _toConsumableArray$d(this.kvs.entries()).map(function(_) {
        var _e = _slicedToArray$e(_, 2), tt = _e[0], nt = _e[1], at = tt.split(SPLIT);
        return $({
          key: at.map(function(ot) {
            var rt = ot.match(/^([^:]*):(.*)$/), st = _slicedToArray$e(rt, 3), lt = st[1], et = st[2];
            return lt === "number" ? Number(et) : et;
          }),
          value: nt
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var $ = {};
      return this.map(function(_) {
        var _e = _.key, tt = _.value;
        return $[_e.join(".")] = tt, null;
      }), $;
    }
  }]), a;
}(), _excluded$S = ["name"], FormStore = /* @__PURE__ */ _createClass(function a(s) {
  var $ = this;
  _classCallCheck(this, a), _defineProperty$c(this, "formHooked", !1), _defineProperty$c(this, "forceRootUpdate", void 0), _defineProperty$c(this, "subscribable", !0), _defineProperty$c(this, "store", {}), _defineProperty$c(this, "fieldEntities", []), _defineProperty$c(this, "initialValues", {}), _defineProperty$c(this, "callbacks", {}), _defineProperty$c(this, "validateMessages", null), _defineProperty$c(this, "preserve", null), _defineProperty$c(this, "lastValidatePromise", null), _defineProperty$c(this, "getForm", function() {
    return {
      getFieldValue: $.getFieldValue,
      getFieldsValue: $.getFieldsValue,
      getFieldError: $.getFieldError,
      getFieldWarning: $.getFieldWarning,
      getFieldsError: $.getFieldsError,
      isFieldsTouched: $.isFieldsTouched,
      isFieldTouched: $.isFieldTouched,
      isFieldValidating: $.isFieldValidating,
      isFieldsValidating: $.isFieldsValidating,
      resetFields: $.resetFields,
      setFields: $.setFields,
      setFieldValue: $.setFieldValue,
      setFieldsValue: $.setFieldsValue,
      validateFields: $.validateFields,
      submit: $.submit,
      _init: !0,
      getInternalHooks: $.getInternalHooks
    };
  }), _defineProperty$c(this, "getInternalHooks", function(_) {
    return _ === HOOK_MARK ? ($.formHooked = !0, {
      dispatch: $.dispatch,
      initEntityValue: $.initEntityValue,
      registerField: $.registerField,
      useSubscribe: $.useSubscribe,
      setInitialValues: $.setInitialValues,
      destroyForm: $.destroyForm,
      setCallbacks: $.setCallbacks,
      setValidateMessages: $.setValidateMessages,
      getFields: $.getFields,
      setPreserve: $.setPreserve,
      getInitialValue: $.getInitialValue,
      registerWatch: $.registerWatch
    }) : (warningOnce(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), _defineProperty$c(this, "useSubscribe", function(_) {
    $.subscribable = _;
  }), _defineProperty$c(this, "prevWithoutPreserves", null), _defineProperty$c(this, "setInitialValues", function(_, _e) {
    if ($.initialValues = _ || {}, _e) {
      var tt, nt = merge$1(_, $.store);
      (tt = $.prevWithoutPreserves) === null || tt === void 0 || tt.map(function(at) {
        var ot = at.key;
        nt = set$1(nt, ot, get$1(_, ot));
      }), $.prevWithoutPreserves = null, $.updateStore(nt);
    }
  }), _defineProperty$c(this, "destroyForm", function() {
    var _ = new NameMap();
    $.getFieldEntities(!0).forEach(function(_e) {
      $.isMergedPreserve(_e.isPreserve()) || _.set(_e.getNamePath(), !0);
    }), $.prevWithoutPreserves = _;
  }), _defineProperty$c(this, "getInitialValue", function(_) {
    var _e = get$1($.initialValues, _);
    return _.length ? merge$1(_e) : _e;
  }), _defineProperty$c(this, "setCallbacks", function(_) {
    $.callbacks = _;
  }), _defineProperty$c(this, "setValidateMessages", function(_) {
    $.validateMessages = _;
  }), _defineProperty$c(this, "setPreserve", function(_) {
    $.preserve = _;
  }), _defineProperty$c(this, "watchList", []), _defineProperty$c(this, "registerWatch", function(_) {
    return $.watchList.push(_), function() {
      $.watchList = $.watchList.filter(function(_e) {
        return _e !== _;
      });
    };
  }), _defineProperty$c(this, "notifyWatch", function() {
    var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if ($.watchList.length) {
      var _e = $.getFieldsValue(), tt = $.getFieldsValue(!0);
      $.watchList.forEach(function(nt) {
        nt(_e, tt, _);
      });
    }
  }), _defineProperty$c(this, "timeoutId", null), _defineProperty$c(this, "warningUnhooked", function() {
  }), _defineProperty$c(this, "updateStore", function(_) {
    $.store = _;
  }), _defineProperty$c(this, "getFieldEntities", function() {
    var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return _ ? $.fieldEntities.filter(function(_e) {
      return _e.getNamePath().length;
    }) : $.fieldEntities;
  }), _defineProperty$c(this, "getFieldsMap", function() {
    var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, _e = new NameMap();
    return $.getFieldEntities(_).forEach(function(tt) {
      var nt = tt.getNamePath();
      _e.set(nt, tt);
    }), _e;
  }), _defineProperty$c(this, "getFieldEntitiesForNamePathList", function(_) {
    if (!_)
      return $.getFieldEntities(!0);
    var _e = $.getFieldsMap(!0);
    return _.map(function(tt) {
      var nt = getNamePath(tt);
      return _e.get(nt) || {
        INVALIDATE_NAME_PATH: getNamePath(tt)
      };
    });
  }), _defineProperty$c(this, "getFieldsValue", function(_, _e) {
    $.warningUnhooked();
    var tt, nt, at;
    if (_ === !0 || Array.isArray(_) ? (tt = _, nt = _e) : _ && _typeof$q(_) === "object" && (at = _.strict, nt = _.filter), tt === !0 && !nt)
      return $.store;
    var ot = $.getFieldEntitiesForNamePathList(Array.isArray(tt) ? tt : null), rt = [];
    return ot.forEach(function(st) {
      var lt, et, it = "INVALIDATE_NAME_PATH" in st ? st.INVALIDATE_NAME_PATH : st.getNamePath();
      if (at) {
        var ut, ft;
        if ((ut = (ft = st).isList) !== null && ut !== void 0 && ut.call(ft))
          return;
      } else if (!tt && (lt = (et = st).isListField) !== null && lt !== void 0 && lt.call(et))
        return;
      if (!nt)
        rt.push(it);
      else {
        var ht = "getMeta" in st ? st.getMeta() : null;
        nt(ht) && rt.push(it);
      }
    }), cloneByNamePathList($.store, rt.map(getNamePath));
  }), _defineProperty$c(this, "getFieldValue", function(_) {
    $.warningUnhooked();
    var _e = getNamePath(_);
    return get$1($.store, _e);
  }), _defineProperty$c(this, "getFieldsError", function(_) {
    $.warningUnhooked();
    var _e = $.getFieldEntitiesForNamePathList(_);
    return _e.map(function(tt, nt) {
      return tt && !("INVALIDATE_NAME_PATH" in tt) ? {
        name: tt.getNamePath(),
        errors: tt.getErrors(),
        warnings: tt.getWarnings()
      } : {
        name: getNamePath(_[nt]),
        errors: [],
        warnings: []
      };
    });
  }), _defineProperty$c(this, "getFieldError", function(_) {
    $.warningUnhooked();
    var _e = getNamePath(_), tt = $.getFieldsError([_e])[0];
    return tt.errors;
  }), _defineProperty$c(this, "getFieldWarning", function(_) {
    $.warningUnhooked();
    var _e = getNamePath(_), tt = $.getFieldsError([_e])[0];
    return tt.warnings;
  }), _defineProperty$c(this, "isFieldsTouched", function() {
    $.warningUnhooked();
    for (var _ = arguments.length, _e = new Array(_), tt = 0; tt < _; tt++)
      _e[tt] = arguments[tt];
    var nt = _e[0], at = _e[1], ot, rt = !1;
    _e.length === 0 ? ot = null : _e.length === 1 ? Array.isArray(nt) ? (ot = nt.map(getNamePath), rt = !1) : (ot = null, rt = nt) : (ot = nt.map(getNamePath), rt = at);
    var st = $.getFieldEntities(!0), lt = function(ht) {
      return ht.isFieldTouched();
    };
    if (!ot)
      return rt ? st.every(lt) : st.some(lt);
    var et = new NameMap();
    ot.forEach(function(ft) {
      et.set(ft, []);
    }), st.forEach(function(ft) {
      var ht = ft.getNamePath();
      ot.forEach(function(dt) {
        dt.every(function(gt, pt) {
          return ht[pt] === gt;
        }) && et.update(dt, function(gt) {
          return [].concat(_toConsumableArray$d(gt), [ft]);
        });
      });
    });
    var it = function(ht) {
      return ht.some(lt);
    }, ut = et.map(function(ft) {
      var ht = ft.value;
      return ht;
    });
    return rt ? ut.every(it) : ut.some(it);
  }), _defineProperty$c(this, "isFieldTouched", function(_) {
    return $.warningUnhooked(), $.isFieldsTouched([_]);
  }), _defineProperty$c(this, "isFieldsValidating", function(_) {
    $.warningUnhooked();
    var _e = $.getFieldEntities();
    if (!_)
      return _e.some(function(nt) {
        return nt.isFieldValidating();
      });
    var tt = _.map(getNamePath);
    return _e.some(function(nt) {
      var at = nt.getNamePath();
      return containsNamePath(tt, at) && nt.isFieldValidating();
    });
  }), _defineProperty$c(this, "isFieldValidating", function(_) {
    return $.warningUnhooked(), $.isFieldsValidating([_]);
  }), _defineProperty$c(this, "resetWithFieldInitialValue", function() {
    var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _e = new NameMap(), tt = $.getFieldEntities(!0);
    tt.forEach(function(ot) {
      var rt = ot.props.initialValue, st = ot.getNamePath();
      if (rt !== void 0) {
        var lt = _e.get(st) || /* @__PURE__ */ new Set();
        lt.add({
          entity: ot,
          value: rt
        }), _e.set(st, lt);
      }
    });
    var nt = function(rt) {
      rt.forEach(function(st) {
        var lt = st.props.initialValue;
        if (lt !== void 0) {
          var et = st.getNamePath(), it = $.getInitialValue(et);
          if (it !== void 0)
            warningOnce(!1, "Form already set 'initialValues' with path '".concat(et.join("."), "'. Field can not overwrite it."));
          else {
            var ut = _e.get(et);
            if (ut && ut.size > 1)
              warningOnce(!1, "Multiple Field with path '".concat(et.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (ut) {
              var ft = $.getFieldValue(et), ht = st.isListField();
              !ht && (!_.skipExist || ft === void 0) && $.updateStore(set$1($.store, et, _toConsumableArray$d(ut)[0].value));
            }
          }
        }
      });
    }, at;
    _.entities ? at = _.entities : _.namePathList ? (at = [], _.namePathList.forEach(function(ot) {
      var rt = _e.get(ot);
      if (rt) {
        var st;
        (st = at).push.apply(st, _toConsumableArray$d(_toConsumableArray$d(rt).map(function(lt) {
          return lt.entity;
        })));
      }
    })) : at = tt, nt(at);
  }), _defineProperty$c(this, "resetFields", function(_) {
    $.warningUnhooked();
    var _e = $.store;
    if (!_) {
      $.updateStore(merge$1($.initialValues)), $.resetWithFieldInitialValue(), $.notifyObservers(_e, null, {
        type: "reset"
      }), $.notifyWatch();
      return;
    }
    var tt = _.map(getNamePath);
    tt.forEach(function(nt) {
      var at = $.getInitialValue(nt);
      $.updateStore(set$1($.store, nt, at));
    }), $.resetWithFieldInitialValue({
      namePathList: tt
    }), $.notifyObservers(_e, tt, {
      type: "reset"
    }), $.notifyWatch(tt);
  }), _defineProperty$c(this, "setFields", function(_) {
    $.warningUnhooked();
    var _e = $.store, tt = [];
    _.forEach(function(nt) {
      var at = nt.name, ot = _objectWithoutProperties$1(nt, _excluded$S), rt = getNamePath(at);
      tt.push(rt), "value" in ot && $.updateStore(set$1($.store, rt, ot.value)), $.notifyObservers(_e, [rt], {
        type: "setField",
        data: nt
      });
    }), $.notifyWatch(tt);
  }), _defineProperty$c(this, "getFields", function() {
    var _ = $.getFieldEntities(!0), _e = _.map(function(tt) {
      var nt = tt.getNamePath(), at = tt.getMeta(), ot = _objectSpread2$a(_objectSpread2$a({}, at), {}, {
        name: nt,
        value: $.getFieldValue(nt)
      });
      return Object.defineProperty(ot, "originRCField", {
        value: !0
      }), ot;
    });
    return _e;
  }), _defineProperty$c(this, "initEntityValue", function(_) {
    var _e = _.props.initialValue;
    if (_e !== void 0) {
      var tt = _.getNamePath(), nt = get$1($.store, tt);
      nt === void 0 && $.updateStore(set$1($.store, tt, _e));
    }
  }), _defineProperty$c(this, "isMergedPreserve", function(_) {
    var _e = _ !== void 0 ? _ : $.preserve;
    return _e ?? !0;
  }), _defineProperty$c(this, "registerField", function(_) {
    $.fieldEntities.push(_);
    var _e = _.getNamePath();
    if ($.notifyWatch([_e]), _.props.initialValue !== void 0) {
      var tt = $.store;
      $.resetWithFieldInitialValue({
        entities: [_],
        skipExist: !0
      }), $.notifyObservers(tt, [_.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(nt, at) {
      var ot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if ($.fieldEntities = $.fieldEntities.filter(function(lt) {
        return lt !== _;
      }), !$.isMergedPreserve(at) && (!nt || ot.length > 1)) {
        var rt = nt ? void 0 : $.getInitialValue(_e);
        if (_e.length && $.getFieldValue(_e) !== rt && $.fieldEntities.every(function(lt) {
          return (
            // Only reset when no namePath exist
            !matchNamePath(lt.getNamePath(), _e)
          );
        })) {
          var st = $.store;
          $.updateStore(set$1(st, _e, rt, !0)), $.notifyObservers(st, [_e], {
            type: "remove"
          }), $.triggerDependenciesUpdate(st, _e);
        }
      }
      $.notifyWatch([_e]);
    };
  }), _defineProperty$c(this, "dispatch", function(_) {
    switch (_.type) {
      case "updateValue": {
        var _e = _.namePath, tt = _.value;
        $.updateValue(_e, tt);
        break;
      }
      case "validateField": {
        var nt = _.namePath, at = _.triggerName;
        $.validateFields([nt], {
          triggerName: at
        });
        break;
      }
    }
  }), _defineProperty$c(this, "notifyObservers", function(_, _e, tt) {
    if ($.subscribable) {
      var nt = _objectSpread2$a(_objectSpread2$a({}, tt), {}, {
        store: $.getFieldsValue(!0)
      });
      $.getFieldEntities().forEach(function(at) {
        var ot = at.onStoreChange;
        ot(_, _e, nt);
      });
    } else
      $.forceRootUpdate();
  }), _defineProperty$c(this, "triggerDependenciesUpdate", function(_, _e) {
    var tt = $.getDependencyChildrenFields(_e);
    return tt.length && $.validateFields(tt), $.notifyObservers(_, tt, {
      type: "dependenciesUpdate",
      relatedFields: [_e].concat(_toConsumableArray$d(tt))
    }), tt;
  }), _defineProperty$c(this, "updateValue", function(_, _e) {
    var tt = getNamePath(_), nt = $.store;
    $.updateStore(set$1($.store, tt, _e)), $.notifyObservers(nt, [tt], {
      type: "valueUpdate",
      source: "internal"
    }), $.notifyWatch([tt]);
    var at = $.triggerDependenciesUpdate(nt, tt), ot = $.callbacks.onValuesChange;
    if (ot) {
      var rt = cloneByNamePathList($.store, [tt]);
      ot(rt, $.getFieldsValue());
    }
    $.triggerOnFieldsChange([tt].concat(_toConsumableArray$d(at)));
  }), _defineProperty$c(this, "setFieldsValue", function(_) {
    $.warningUnhooked();
    var _e = $.store;
    if (_) {
      var tt = merge$1($.store, _);
      $.updateStore(tt);
    }
    $.notifyObservers(_e, null, {
      type: "valueUpdate",
      source: "external"
    }), $.notifyWatch();
  }), _defineProperty$c(this, "setFieldValue", function(_, _e) {
    $.setFields([{
      name: _,
      value: _e
    }]);
  }), _defineProperty$c(this, "getDependencyChildrenFields", function(_) {
    var _e = /* @__PURE__ */ new Set(), tt = [], nt = new NameMap();
    $.getFieldEntities().forEach(function(ot) {
      var rt = ot.props.dependencies;
      (rt || []).forEach(function(st) {
        var lt = getNamePath(st);
        nt.update(lt, function() {
          var et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return et.add(ot), et;
        });
      });
    });
    var at = function ot(rt) {
      var st = nt.get(rt) || /* @__PURE__ */ new Set();
      st.forEach(function(lt) {
        if (!_e.has(lt)) {
          _e.add(lt);
          var et = lt.getNamePath();
          lt.isFieldDirty() && et.length && (tt.push(et), ot(et));
        }
      });
    };
    return at(_), tt;
  }), _defineProperty$c(this, "triggerOnFieldsChange", function(_, _e) {
    var tt = $.callbacks.onFieldsChange;
    if (tt) {
      var nt = $.getFields();
      if (_e) {
        var at = new NameMap();
        _e.forEach(function(rt) {
          var st = rt.name, lt = rt.errors;
          at.set(st, lt);
        }), nt.forEach(function(rt) {
          rt.errors = at.get(rt.name) || rt.errors;
        });
      }
      var ot = nt.filter(function(rt) {
        var st = rt.name;
        return containsNamePath(_, st);
      });
      ot.length && tt(ot, nt);
    }
  }), _defineProperty$c(this, "validateFields", function(_, _e) {
    $.warningUnhooked();
    var tt, nt;
    Array.isArray(_) || typeof _ == "string" || typeof _e == "string" ? (tt = _, nt = _e) : nt = _;
    var at = !!tt, ot = at ? tt.map(getNamePath) : [], rt = [], st = String(Date.now()), lt = /* @__PURE__ */ new Set(), et = nt || {}, it = et.recursive, ut = et.dirty;
    $.getFieldEntities(!0).forEach(function(gt) {
      if (at || ot.push(gt.getNamePath()), !(!gt.props.rules || !gt.props.rules.length) && !(ut && !gt.isFieldDirty())) {
        var pt = gt.getNamePath();
        if (lt.add(pt.join(st)), !at || containsNamePath(ot, pt, it)) {
          var mt = gt.validateRules(_objectSpread2$a({
            validateMessages: _objectSpread2$a(_objectSpread2$a({}, defaultValidateMessages), $.validateMessages)
          }, nt));
          rt.push(mt.then(function() {
            return {
              name: pt,
              errors: [],
              warnings: []
            };
          }).catch(function(ct) {
            var vt, At = [], xt = [];
            return (vt = ct.forEach) === null || vt === void 0 || vt.call(ct, function(bt) {
              var Et = bt.rule.warningOnly, St = bt.errors;
              Et ? xt.push.apply(xt, _toConsumableArray$d(St)) : At.push.apply(At, _toConsumableArray$d(St));
            }), At.length ? Promise.reject({
              name: pt,
              errors: At,
              warnings: xt
            }) : {
              name: pt,
              errors: At,
              warnings: xt
            };
          }));
        }
      }
    });
    var ft = allPromiseFinish(rt);
    $.lastValidatePromise = ft, ft.catch(function(gt) {
      return gt;
    }).then(function(gt) {
      var pt = gt.map(function(mt) {
        var ct = mt.name;
        return ct;
      });
      $.notifyObservers($.store, pt, {
        type: "validateFinish"
      }), $.triggerOnFieldsChange(pt, gt);
    });
    var ht = ft.then(function() {
      return $.lastValidatePromise === ft ? Promise.resolve($.getFieldsValue(ot)) : Promise.reject([]);
    }).catch(function(gt) {
      var pt = gt.filter(function(mt) {
        return mt && mt.errors.length;
      });
      return Promise.reject({
        values: $.getFieldsValue(ot),
        errorFields: pt,
        outOfDate: $.lastValidatePromise !== ft
      });
    });
    ht.catch(function(gt) {
      return gt;
    });
    var dt = ot.filter(function(gt) {
      return lt.has(gt.join(st));
    });
    return $.triggerOnFieldsChange(dt), ht;
  }), _defineProperty$c(this, "submit", function() {
    $.warningUnhooked(), $.validateFields().then(function(_) {
      var _e = $.callbacks.onFinish;
      if (_e)
        try {
          _e(_);
        } catch (tt) {
          console.error(tt);
        }
    }).catch(function(_) {
      var _e = $.callbacks.onFinishFailed;
      _e && _e(_);
    });
  }), this.forceRootUpdate = s;
});
function useForm$2(a) {
  var s = reactExports.useRef(), $ = reactExports.useState({}), _ = _slicedToArray$e($, 2), _e = _[1];
  if (!s.current)
    if (a)
      s.current = a;
    else {
      var tt = function() {
        _e({});
      }, nt = new FormStore(tt);
      s.current = nt.getForm();
    }
  return [s.current];
}
var FormContext$1 = /* @__PURE__ */ reactExports.createContext({
  triggerFormChange: function a() {
  },
  triggerFormFinish: function a() {
  },
  registerForm: function a() {
  },
  unregisterForm: function a() {
  }
}), FormProvider$1 = function a(s) {
  var $ = s.validateMessages, _ = s.onFormChange, _e = s.onFormFinish, tt = s.children, nt = reactExports.useContext(FormContext$1), at = reactExports.useRef({});
  return /* @__PURE__ */ reactExports.createElement(FormContext$1.Provider, {
    value: _objectSpread2$a(_objectSpread2$a({}, nt), {}, {
      validateMessages: _objectSpread2$a(_objectSpread2$a({}, nt.validateMessages), $),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(rt, st) {
        _ && _(rt, {
          changedFields: st,
          forms: at.current
        }), nt.triggerFormChange(rt, st);
      },
      triggerFormFinish: function(rt, st) {
        _e && _e(rt, {
          values: st,
          forms: at.current
        }), nt.triggerFormFinish(rt, st);
      },
      registerForm: function(rt, st) {
        rt && (at.current = _objectSpread2$a(_objectSpread2$a({}, at.current), {}, _defineProperty$c({}, rt, st))), nt.registerForm(rt, st);
      },
      unregisterForm: function(rt) {
        var st = _objectSpread2$a({}, at.current);
        delete st[rt], at.current = st, nt.unregisterForm(rt);
      }
    })
  }, tt);
}, _excluded$R = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"], Form$5 = function a(s, $) {
  var _ = s.name, _e = s.initialValues, tt = s.fields, nt = s.form, at = s.preserve, ot = s.children, rt = s.component, st = rt === void 0 ? "form" : rt, lt = s.validateMessages, et = s.validateTrigger, it = et === void 0 ? "onChange" : et, ut = s.onValuesChange, ft = s.onFieldsChange, ht = s.onFinish, dt = s.onFinishFailed, gt = _objectWithoutProperties$1(s, _excluded$R), pt = reactExports.useContext(FormContext$1), mt = useForm$2(nt), ct = _slicedToArray$e(mt, 1), vt = ct[0], At = vt.getInternalHooks(HOOK_MARK), xt = At.useSubscribe, bt = At.setInitialValues, Et = At.setCallbacks, St = At.setValidateMessages, Bt = At.setPreserve, Ot = At.destroyForm;
  reactExports.useImperativeHandle($, function() {
    return vt;
  }), reactExports.useEffect(function() {
    return pt.registerForm(_, vt), function() {
      pt.unregisterForm(_);
    };
  }, [pt, vt, _]), St(_objectSpread2$a(_objectSpread2$a({}, pt.validateMessages), lt)), Et({
    onValuesChange: ut,
    onFieldsChange: function(Ht) {
      if (pt.triggerFormChange(_, Ht), ft) {
        for (var Ft = arguments.length, _t = new Array(Ft > 1 ? Ft - 1 : 0), Nt = 1; Nt < Ft; Nt++)
          _t[Nt - 1] = arguments[Nt];
        ft.apply(void 0, [Ht].concat(_t));
      }
    },
    onFinish: function(Ht) {
      pt.triggerFormFinish(_, Ht), ht && ht(Ht);
    },
    onFinishFailed: dt
  }), Bt(at);
  var Pt = reactExports.useRef(null);
  bt(_e, !Pt.current), Pt.current || (Pt.current = !0), reactExports.useEffect(
    function() {
      return Ot;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var wt, Ct = typeof ot == "function";
  if (Ct) {
    var It = vt.getFieldsValue(!0);
    wt = ot(It, vt);
  } else
    wt = ot;
  xt(!Ct);
  var yt = reactExports.useRef();
  reactExports.useEffect(function() {
    isSimilar(yt.current || [], tt || []) || vt.setFields(tt || []), yt.current = tt;
  }, [tt, vt]);
  var Rt = reactExports.useMemo(function() {
    return _objectSpread2$a(_objectSpread2$a({}, vt), {}, {
      validateTrigger: it
    });
  }, [vt, it]), kt = /* @__PURE__ */ reactExports.createElement(ListContext.Provider, {
    value: null
  }, /* @__PURE__ */ reactExports.createElement(Context$2.Provider, {
    value: Rt
  }, wt));
  return st === !1 ? kt : /* @__PURE__ */ reactExports.createElement(st, _extends$2({}, gt, {
    onSubmit: function(Ht) {
      Ht.preventDefault(), Ht.stopPropagation(), vt.submit();
    },
    onReset: function(Ht) {
      var Ft;
      Ht.preventDefault(), vt.resetFields(), (Ft = gt.onReset) === null || Ft === void 0 || Ft.call(gt, Ht);
    }
  }), kt);
};
function stringify$1(a) {
  try {
    return JSON.stringify(a);
  } catch {
    return Math.random();
  }
}
function useWatch$1() {
  for (var a = arguments.length, s = new Array(a), $ = 0; $ < a; $++)
    s[$] = arguments[$];
  var _ = s[0], _e = s[1], tt = _e === void 0 ? {} : _e, nt = isFormInstance(tt) ? {
    form: tt
  } : tt, at = nt.form, ot = reactExports.useState(), rt = _slicedToArray$e(ot, 2), st = rt[0], lt = rt[1], et = reactExports.useMemo(function() {
    return stringify$1(st);
  }, [st]), it = reactExports.useRef(et);
  it.current = et;
  var ut = reactExports.useContext(Context$2), ft = at || ut, ht = ft && ft._init, dt = getNamePath(_), gt = reactExports.useRef(dt);
  return gt.current = dt, reactExports.useEffect(
    function() {
      if (ht) {
        var pt = ft.getFieldsValue, mt = ft.getInternalHooks, ct = mt(HOOK_MARK), vt = ct.registerWatch, At = function(St, Bt) {
          var Ot = nt.preserve ? Bt : St;
          return typeof _ == "function" ? _(Ot) : get$1(Ot, gt.current);
        }, xt = vt(function(Et, St) {
          var Bt = At(Et, St), Ot = stringify$1(Bt);
          it.current !== Ot && (it.current = Ot, lt(Bt));
        }), bt = At(pt(), pt(!0));
        return st !== bt && lt(bt), xt;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ht]
  ), st;
}
var InternalForm$2 = /* @__PURE__ */ reactExports.forwardRef(Form$5), RefForm = InternalForm$2;
RefForm.FormProvider = FormProvider$1;
RefForm.Field = WrapperField;
RefForm.List = List$2;
RefForm.useForm = useForm$2;
RefForm.useWatch = useWatch$1;
const FormContext = /* @__PURE__ */ reactExports.createContext({
  labelAlign: "right",
  vertical: !1,
  itemRef: () => {
  }
}), NoStyleItemContext = /* @__PURE__ */ reactExports.createContext(null), FormProvider = (a) => {
  const s = omit(a, ["prefixCls"]);
  return /* @__PURE__ */ reactExports.createElement(FormProvider$1, Object.assign({}, s));
}, FormItemPrefixContext = /* @__PURE__ */ reactExports.createContext({
  prefixCls: ""
}), FormItemInputContext = /* @__PURE__ */ reactExports.createContext({}), NoFormStyle = (a) => {
  let {
    children: s,
    status: $,
    override: _
  } = a;
  const _e = reactExports.useContext(FormItemInputContext), tt = reactExports.useMemo(() => {
    const nt = Object.assign({}, _e);
    return _ && delete nt.isFormItemInput, $ && (delete nt.status, delete nt.hasFeedback, delete nt.feedbackIcon), nt;
  }, [$, _, _e]);
  return /* @__PURE__ */ reactExports.createElement(FormItemInputContext.Provider, {
    value: tt
  }, s);
};
function voidFunc() {
}
const WatermarkContext = /* @__PURE__ */ reactExports.createContext({
  add: voidFunc,
  remove: voidFunc
});
function usePanelRef(a) {
  const s = reactExports.useContext(WatermarkContext), $ = reactExports.useRef();
  return useEvent((_e) => {
    if (_e) {
      const tt = a ? _e.querySelector(a) : _e;
      s.add(tt), $.current = tt;
    } else
      s.remove($.current);
  });
}
const initMotionCommon = (a) => ({
  animationDuration: a,
  animationFillMode: "both"
}), initMotionCommonLeave = (a) => ({
  animationDuration: a,
  animationFillMode: "both"
}), initMotion = function(a, s, $, _) {
  const tt = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${tt}${a}-enter,
      ${tt}${a}-appear
    `]: Object.assign(Object.assign({}, initMotionCommon(_)), {
      animationPlayState: "paused"
    }),
    [`${tt}${a}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave(_)), {
      animationPlayState: "paused"
    }),
    [`
      ${tt}${a}-enter${a}-enter-active,
      ${tt}${a}-appear${a}-appear-active
    `]: {
      animationName: s,
      animationPlayState: "running"
    },
    [`${tt}${a}-leave${a}-leave-active`]: {
      animationName: $,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, fadeIn = new Keyframe("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), fadeOut = new Keyframe("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), initFadeMotion = function(a) {
  let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const {
    antCls: $
  } = a, _ = `${$}-fade`, _e = s ? "&" : "";
  return [initMotion(_, fadeIn, fadeOut, a.motionDurationMid, s), {
    [`
        ${_e}${_}-enter,
        ${_e}${_}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${_e}${_}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
}, moveDownIn = new Keyframe("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), moveDownOut = new Keyframe("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), moveLeftIn = new Keyframe("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), moveLeftOut = new Keyframe("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), moveRightIn = new Keyframe("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), moveRightOut = new Keyframe("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), moveUpIn = new Keyframe("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), moveUpOut = new Keyframe("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), moveMotion = {
  "move-up": {
    inKeyframes: moveUpIn,
    outKeyframes: moveUpOut
  },
  "move-down": {
    inKeyframes: moveDownIn,
    outKeyframes: moveDownOut
  },
  "move-left": {
    inKeyframes: moveLeftIn,
    outKeyframes: moveLeftOut
  },
  "move-right": {
    inKeyframes: moveRightIn,
    outKeyframes: moveRightOut
  }
}, initMoveMotion = (a, s) => {
  const {
    antCls: $
  } = a, _ = `${$}-${s}`, {
    inKeyframes: _e,
    outKeyframes: tt
  } = moveMotion[s];
  return [initMotion(_, _e, tt, a.motionDurationMid), {
    [`
        ${_}-enter,
        ${_}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: a.motionEaseOutCirc
    },
    [`${_}-leave`]: {
      animationTimingFunction: a.motionEaseInOutCirc
    }
  }];
}, slideUpIn = new Keyframe("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), slideUpOut = new Keyframe("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), slideDownIn = new Keyframe("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), slideDownOut = new Keyframe("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), slideLeftIn = new Keyframe("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), slideLeftOut = new Keyframe("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), slideRightIn = new Keyframe("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), slideRightOut = new Keyframe("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), slideMotion = {
  "slide-up": {
    inKeyframes: slideUpIn,
    outKeyframes: slideUpOut
  },
  "slide-down": {
    inKeyframes: slideDownIn,
    outKeyframes: slideDownOut
  },
  "slide-left": {
    inKeyframes: slideLeftIn,
    outKeyframes: slideLeftOut
  },
  "slide-right": {
    inKeyframes: slideRightIn,
    outKeyframes: slideRightOut
  }
}, initSlideMotion = (a, s) => {
  const {
    antCls: $
  } = a, _ = `${$}-${s}`, {
    inKeyframes: _e,
    outKeyframes: tt
  } = slideMotion[s];
  return [initMotion(_, _e, tt, a.motionDurationMid), {
    [`
      ${_}-enter,
      ${_}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: a.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${_}-leave`]: {
      animationTimingFunction: a.motionEaseInQuint
    }
  }];
}, zoomIn = new Keyframe("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), zoomOut = new Keyframe("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), zoomBigIn = new Keyframe("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), zoomBigOut = new Keyframe("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), zoomUpIn = new Keyframe("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), zoomUpOut = new Keyframe("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), zoomLeftIn = new Keyframe("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), zoomLeftOut = new Keyframe("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), zoomRightIn = new Keyframe("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), zoomRightOut = new Keyframe("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), zoomDownIn = new Keyframe("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), zoomDownOut = new Keyframe("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), zoomMotion = {
  zoom: {
    inKeyframes: zoomIn,
    outKeyframes: zoomOut
  },
  "zoom-big": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-big-fast": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-left": {
    inKeyframes: zoomLeftIn,
    outKeyframes: zoomLeftOut
  },
  "zoom-right": {
    inKeyframes: zoomRightIn,
    outKeyframes: zoomRightOut
  },
  "zoom-up": {
    inKeyframes: zoomUpIn,
    outKeyframes: zoomUpOut
  },
  "zoom-down": {
    inKeyframes: zoomDownIn,
    outKeyframes: zoomDownOut
  }
}, initZoomMotion = (a, s) => {
  const {
    antCls: $
  } = a, _ = `${$}-${s}`, {
    inKeyframes: _e,
    outKeyframes: tt
  } = zoomMotion[s];
  return [initMotion(_, _e, tt, s === "zoom-big-fast" ? a.motionDurationFast : a.motionDurationMid), {
    [`
        ${_}-enter,
        ${_}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: a.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${_}-leave`]: {
      animationTimingFunction: a.motionEaseInOutCirc
    }
  }];
}, genCollapseMotion = (a) => ({
  [a.componentCls]: {
    // For common/openAnimation
    [`${a.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${a.motionDurationMid} ${a.motionEaseInOut},
        opacity ${a.motionDurationMid} ${a.motionEaseInOut} !important`
      }
    },
    [`${a.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${a.motionDurationMid} ${a.motionEaseInOut},
        opacity ${a.motionDurationMid} ${a.motionEaseInOut} !important`
    }
  }
}), genCollapseMotion$1 = genCollapseMotion;
function box(a) {
  return {
    position: a,
    inset: 0
  };
}
const genModalMaskStyle = (a) => {
  const {
    componentCls: s,
    antCls: $
  } = a;
  return [{
    [`${s}-root`]: {
      [`${s}${$}-zoom-enter, ${s}${$}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: a.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${s}${$}-zoom-leave ${s}-content`]: {
        pointerEvents: "none"
      },
      [`${s}-mask`]: Object.assign(Object.assign({}, box("fixed")), {
        zIndex: a.zIndexPopupBase,
        height: "100%",
        backgroundColor: a.colorBgMask,
        pointerEvents: "none",
        [`${s}-hidden`]: {
          display: "none"
        }
      }),
      [`${s}-wrap`]: Object.assign(Object.assign({}, box("fixed")), {
        zIndex: a.zIndexPopupBase,
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch",
        // Note: Firefox not support `:has` yet
        [`&:has(${s}${$}-zoom-enter), &:has(${s}${$}-zoom-appear)`]: {
          pointerEvents: "none"
        }
      })
    }
  }, {
    [`${s}-root`]: initFadeMotion(a)
  }];
}, genModalStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return [
    // ======================== Root =========================
    {
      [`${s}-root`]: {
        [`${s}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${s}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [s]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${a.screenSMMax}px)`]: {
          [s]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${unit$1(a.marginXS)} auto`
          },
          [`${s}-centered`]: {
            [s]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${unit$1(a.calc(a.margin).mul(2).equal())})`,
        margin: "0 auto",
        paddingBottom: a.paddingLG,
        [`${s}-title`]: {
          margin: 0,
          color: a.titleColor,
          fontWeight: a.fontWeightStrong,
          fontSize: a.titleFontSize,
          lineHeight: a.titleLineHeight,
          wordWrap: "break-word"
        },
        [`${s}-content`]: {
          position: "relative",
          backgroundColor: a.contentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: a.borderRadiusLG,
          boxShadow: a.boxShadow,
          pointerEvents: "auto",
          padding: a.contentPadding
        },
        [`${s}-close`]: Object.assign({
          position: "absolute",
          top: a.calc(a.modalHeaderHeight).sub(a.modalCloseBtnSize).div(2).equal(),
          insetInlineEnd: a.calc(a.modalHeaderHeight).sub(a.modalCloseBtnSize).div(2).equal(),
          zIndex: a.calc(a.zIndexPopupBase).add(10).equal(),
          padding: 0,
          color: a.modalCloseIconColor,
          fontWeight: a.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: a.borderRadiusSM,
          width: a.modalCloseBtnSize,
          height: a.modalCloseBtnSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${a.motionDurationMid}, background-color ${a.motionDurationMid}`,
          "&-x": {
            display: "flex",
            fontSize: a.fontSizeLG,
            fontStyle: "normal",
            lineHeight: `${unit$1(a.modalCloseBtnSize)}`,
            justifyContent: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:hover": {
            color: a.modalIconHoverColor,
            backgroundColor: a.closeBtnHoverBg,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: a.closeBtnActiveBg
          }
        }, genFocusStyle(a)),
        [`${s}-header`]: {
          color: a.colorText,
          background: a.headerBg,
          borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0`,
          marginBottom: a.headerMarginBottom,
          padding: a.headerPadding,
          borderBottom: a.headerBorderBottom
        },
        [`${s}-body`]: {
          fontSize: a.fontSize,
          lineHeight: a.lineHeight,
          wordWrap: "break-word",
          padding: a.bodyPadding
        },
        [`${s}-footer`]: {
          textAlign: "end",
          background: a.footerBg,
          marginTop: a.footerMarginTop,
          padding: a.footerPadding,
          borderTop: a.footerBorderTop,
          borderRadius: a.footerBorderRadius,
          [`${a.antCls}-btn + ${a.antCls}-btn:not(${a.antCls}-dropdown-trigger)`]: {
            marginBottom: 0,
            marginInlineStart: a.marginXS
          }
        },
        [`${s}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${s}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${s}-content,
          ${s}-body,
          ${s}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${s}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
}, genRTLStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-root`]: {
      [`${s}-wrap-rtl`]: {
        direction: "rtl",
        [`${s}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
}, prepareToken$2 = (a) => {
  const s = a.padding, $ = a.fontSizeHeading5, _ = a.lineHeightHeading5;
  return merge(a, {
    modalHeaderHeight: a.calc(a.calc(_).mul($).equal()).add(a.calc(s).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: a.colorSplit,
    modalFooterBorderStyle: a.lineType,
    modalFooterBorderWidth: a.lineWidth,
    modalIconHoverColor: a.colorIconHover,
    modalCloseIconColor: a.colorIcon,
    modalCloseBtnSize: a.fontHeight,
    modalConfirmIconSize: a.fontHeight,
    modalTitleHeight: a.calc(a.titleFontSize).mul(a.titleLineHeight).equal()
  });
}, prepareComponentToken$s = (a) => ({
  footerBg: "transparent",
  headerBg: a.colorBgElevated,
  titleLineHeight: a.lineHeightHeading5,
  titleFontSize: a.fontSizeHeading5,
  contentBg: a.colorBgElevated,
  titleColor: a.colorTextHeading,
  // internal
  closeBtnHoverBg: a.wireframe ? "transparent" : a.colorFillContent,
  closeBtnActiveBg: a.wireframe ? "transparent" : a.colorFillContentHover,
  contentPadding: a.wireframe ? 0 : `${unit$1(a.paddingMD)} ${unit$1(a.paddingContentHorizontalLG)}`,
  headerPadding: a.wireframe ? `${unit$1(a.padding)} ${unit$1(a.paddingLG)}` : 0,
  headerBorderBottom: a.wireframe ? `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorSplit}` : "none",
  headerMarginBottom: a.wireframe ? 0 : a.marginXS,
  bodyPadding: a.wireframe ? a.paddingLG : 0,
  footerPadding: a.wireframe ? `${unit$1(a.paddingXS)} ${unit$1(a.padding)}` : 0,
  footerBorderTop: a.wireframe ? `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorSplit}` : "none",
  footerBorderRadius: a.wireframe ? `0 0 ${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)}` : 0,
  footerMarginTop: a.wireframe ? 0 : a.marginSM,
  confirmBodyPadding: a.wireframe ? `${unit$1(a.padding * 2)} ${unit$1(a.padding * 2)} ${unit$1(a.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: a.wireframe ? a.margin : a.marginSM,
  confirmBtnsMarginTop: a.wireframe ? a.marginLG : a.marginSM
});
genStyleHooks("Modal", (a) => {
  const s = prepareToken$2(a);
  return [genModalStyle(s), genRTLStyle(s), genModalMaskStyle(s), initZoomMotion(s, "zoom")];
}, prepareComponentToken$s, {
  unitless: {
    titleLineHeight: !0
  }
});
function withPureRenderTheme(a) {
  return (s) => /* @__PURE__ */ reactExports.createElement(ThemeConfigProvider, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ reactExports.createElement(a, Object.assign({}, s)));
}
const genPurePanel = (a, s, $, _) => withPureRenderTheme((tt) => {
  const {
    prefixCls: nt,
    style: at
  } = tt, ot = reactExports.useRef(null), [rt, st] = reactExports.useState(0), [lt, et] = reactExports.useState(0), [it, ut] = useMergedState(!1, {
    value: tt.open
  }), {
    getPrefixCls: ft
  } = reactExports.useContext(ConfigContext$1), ht = ft(s || "select", nt);
  reactExports.useEffect(() => {
    if (ut(!0), typeof ResizeObserver < "u") {
      const pt = new ResizeObserver((ct) => {
        const vt = ct[0].target;
        st(vt.offsetHeight + 8), et(vt.offsetWidth);
      }), mt = setInterval(() => {
        var ct;
        const vt = $ ? `.${$(ht)}` : `.${ht}-dropdown`, At = (ct = ot.current) === null || ct === void 0 ? void 0 : ct.querySelector(vt);
        At && (clearInterval(mt), pt.observe(At));
      }, 10);
      return () => {
        clearInterval(mt), pt.disconnect();
      };
    }
  }, []);
  let dt = Object.assign(Object.assign({}, tt), {
    style: Object.assign(Object.assign({}, at), {
      margin: 0
    }),
    open: it,
    visible: it,
    getPopupContainer: () => ot.current
  });
  _ && (dt = _(dt));
  const gt = {
    paddingBottom: rt,
    position: "relative",
    minWidth: lt
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    ref: ot,
    style: gt
  }, /* @__PURE__ */ reactExports.createElement(a, Object.assign({}, dt)));
}), genPurePanel$1 = genPurePanel, isMobile$1 = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var a = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a == null ? void 0 : a.substr(0, 4));
};
var TransBtn = function a(s) {
  var $ = s.className, _ = s.customizeIcon, _e = s.customizeIconProps, tt = s.onMouseDown, nt = s.onClick, at = s.children, ot;
  return typeof _ == "function" ? ot = _(_e) : ot = _, /* @__PURE__ */ reactExports.createElement("span", {
    className: $,
    onMouseDown: function(st) {
      st.preventDefault(), tt && tt(st);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: nt,
    "aria-hidden": !0
  }, ot !== void 0 ? ot : /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames($.split(/\s+/).map(function(rt) {
      return "".concat(rt, "-icon");
    }))
  }, at));
};
function useAllowClear(a, s, $, _, _e) {
  var tt = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, nt = arguments.length > 6 ? arguments[6] : void 0, at = arguments.length > 7 ? arguments[7] : void 0, ot = React$a.useMemo(function() {
    if (_typeof$q(_) === "object")
      return _.clearIcon;
    if (_e)
      return _e;
  }, [_, _e]), rt = React$a.useMemo(function() {
    return !!(!tt && _ && ($.length || nt) && !(at === "combobox" && nt === ""));
  }, [_, tt, $.length, nt, at]);
  return {
    allowClear: rt,
    clearIcon: /* @__PURE__ */ React$a.createElement(TransBtn, {
      className: "".concat(a, "-clear"),
      onMouseDown: s,
      customizeIcon: ot
    }, "×")
  };
}
var BaseSelectContext = /* @__PURE__ */ reactExports.createContext(null);
function useBaseProps() {
  return reactExports.useContext(BaseSelectContext);
}
function useDelayReset() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, s = reactExports.useState(!1), $ = _slicedToArray$e(s, 2), _ = $[0], _e = $[1], tt = reactExports.useRef(null), nt = function() {
    window.clearTimeout(tt.current);
  };
  reactExports.useEffect(function() {
    return nt;
  }, []);
  var at = function(rt, st) {
    nt(), tt.current = window.setTimeout(function() {
      _e(rt), st && st();
    }, a);
  };
  return [_, at, nt];
}
function useLock() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, s = reactExports.useRef(null), $ = reactExports.useRef(null);
  reactExports.useEffect(function() {
    return function() {
      window.clearTimeout($.current);
    };
  }, []);
  function _(_e) {
    (_e || s.current === null) && (s.current = _e), window.clearTimeout($.current), $.current = window.setTimeout(function() {
      s.current = null;
    }, a);
  }
  return [function() {
    return s.current;
  }, _];
}
function useSelectTriggerControl(a, s, $, _) {
  var _e = reactExports.useRef(null);
  _e.current = {
    open: s,
    triggerOpen: $,
    customizedTrigger: _
  }, reactExports.useEffect(function() {
    function tt(nt) {
      var at;
      if (!((at = _e.current) !== null && at !== void 0 && at.customizedTrigger)) {
        var ot = nt.target;
        ot.shadowRoot && nt.composed && (ot = nt.composedPath()[0] || ot), _e.current.open && a().filter(function(rt) {
          return rt;
        }).every(function(rt) {
          return !rt.contains(ot) && rt !== ot;
        }) && _e.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", tt), function() {
      return window.removeEventListener("mousedown", tt);
    };
  }, []);
}
var _excluded$Q = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], UNDEFINED$1 = void 0;
function InternalItem(a, s) {
  var $ = a.prefixCls, _ = a.invalidate, _e = a.item, tt = a.renderItem, nt = a.responsive, at = a.responsiveDisabled, ot = a.registerSize, rt = a.itemKey, st = a.className, lt = a.style, et = a.children, it = a.display, ut = a.order, ft = a.component, ht = ft === void 0 ? "div" : ft, dt = _objectWithoutProperties$1(a, _excluded$Q), gt = nt && !it;
  function pt(xt) {
    ot(rt, xt);
  }
  reactExports.useEffect(function() {
    return function() {
      pt(null);
    };
  }, []);
  var mt = tt && _e !== UNDEFINED$1 ? tt(_e) : et, ct;
  _ || (ct = {
    opacity: gt ? 0 : 1,
    height: gt ? 0 : UNDEFINED$1,
    overflowY: gt ? "hidden" : UNDEFINED$1,
    order: nt ? ut : UNDEFINED$1,
    pointerEvents: gt ? "none" : UNDEFINED$1,
    position: gt ? "absolute" : UNDEFINED$1
  });
  var vt = {};
  gt && (vt["aria-hidden"] = !0);
  var At = /* @__PURE__ */ reactExports.createElement(ht, _extends$2({
    className: classnames(!_ && $, st),
    style: _objectSpread2$a(_objectSpread2$a({}, ct), lt)
  }, vt, dt, {
    ref: s
  }), mt);
  return nt && (At = /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: function(bt) {
      var Et = bt.offsetWidth;
      pt(Et);
    },
    disabled: at
  }, At)), At;
}
var Item$7 = /* @__PURE__ */ reactExports.forwardRef(InternalItem);
Item$7.displayName = "Item";
function channelUpdate(a) {
  if (typeof MessageChannel > "u")
    wrapperRaf(a);
  else {
    var s = new MessageChannel();
    s.port1.onmessage = function() {
      return a();
    }, s.port2.postMessage(void 0);
  }
}
function useBatcher() {
  var a = reactExports.useRef(null), s = function(_) {
    a.current || (a.current = [], channelUpdate(function() {
      reactDomExports.unstable_batchedUpdates(function() {
        a.current.forEach(function(_e) {
          _e();
        }), a.current = null;
      });
    })), a.current.push(_);
  };
  return s;
}
function useEffectState(a, s) {
  var $ = reactExports.useState(s), _ = _slicedToArray$e($, 2), _e = _[0], tt = _[1], nt = useEvent(function(at) {
    a(function() {
      tt(at);
    });
  });
  return [_e, nt];
}
var OverflowContext = /* @__PURE__ */ React$a.createContext(null), _excluded$P = ["component"], _excluded2$b = ["className"], _excluded3$1 = ["className"], InternalRawItem = function a(s, $) {
  var _ = reactExports.useContext(OverflowContext);
  if (!_) {
    var _e = s.component, tt = _e === void 0 ? "div" : _e, nt = _objectWithoutProperties$1(s, _excluded$P);
    return /* @__PURE__ */ reactExports.createElement(tt, _extends$2({}, nt, {
      ref: $
    }));
  }
  var at = _.className, ot = _objectWithoutProperties$1(_, _excluded2$b), rt = s.className, st = _objectWithoutProperties$1(s, _excluded3$1);
  return /* @__PURE__ */ reactExports.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ reactExports.createElement(Item$7, _extends$2({
    ref: $,
    className: classnames(at, rt)
  }, ot, st)));
}, RawItem = /* @__PURE__ */ reactExports.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$O = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], RESPONSIVE = "responsive", INVALIDATE = "invalidate";
function defaultRenderRest(a) {
  return "+ ".concat(a.length, " ...");
}
function Overflow(a, s) {
  var $ = a.prefixCls, _ = $ === void 0 ? "rc-overflow" : $, _e = a.data, tt = _e === void 0 ? [] : _e, nt = a.renderItem, at = a.renderRawItem, ot = a.itemKey, rt = a.itemWidth, st = rt === void 0 ? 10 : rt, lt = a.ssr, et = a.style, it = a.className, ut = a.maxCount, ft = a.renderRest, ht = a.renderRawRest, dt = a.suffix, gt = a.component, pt = gt === void 0 ? "div" : gt, mt = a.itemComponent, ct = a.onVisibleChange, vt = _objectWithoutProperties$1(a, _excluded$O), At = lt === "full", xt = useBatcher(), bt = useEffectState(xt, null), Et = _slicedToArray$e(bt, 2), St = Et[0], Bt = Et[1], Ot = St || 0, Pt = useEffectState(xt, /* @__PURE__ */ new Map()), wt = _slicedToArray$e(Pt, 2), Ct = wt[0], It = wt[1], yt = useEffectState(xt, 0), Rt = _slicedToArray$e(yt, 2), kt = Rt[0], jt = Rt[1], Ht = useEffectState(xt, 0), Ft = _slicedToArray$e(Ht, 2), _t = Ft[0], Nt = Ft[1], Mt = useEffectState(xt, 0), Lt = _slicedToArray$e(Mt, 2), $t = Lt[0], Tt = Lt[1], Dt = reactExports.useState(null), Ut = _slicedToArray$e(Dt, 2), Vt = Ut[0], Qt = Ut[1], qt = reactExports.useState(null), Zt = _slicedToArray$e(qt, 2), ar = Zt[0], Jt = Zt[1], rr = reactExports.useMemo(function() {
    return ar === null && At ? Number.MAX_SAFE_INTEGER : ar || 0;
  }, [ar, St]), Yt = reactExports.useState(!1), Kt = _slicedToArray$e(Yt, 2), nr = Kt[0], tr = Kt[1], ir = "".concat(_, "-item"), sr = Math.max(kt, _t), cr = ut === RESPONSIVE, or = tt.length && cr, Xt = ut === INVALIDATE, Gt = or || typeof ut == "number" && tt.length > ut, Wt = reactExports.useMemo(function() {
    var Dr = tt;
    return or ? St === null && At ? Dr = tt : Dr = tt.slice(0, Math.min(tt.length, Ot / st)) : typeof ut == "number" && (Dr = tt.slice(0, ut)), Dr;
  }, [tt, st, St, ut, or]), er = reactExports.useMemo(function() {
    return or ? tt.slice(rr + 1) : tt.slice(Wt.length);
  }, [tt, Wt, or, rr]), lr = reactExports.useCallback(function(Dr, Gr) {
    var Or;
    return typeof ot == "function" ? ot(Dr) : (Or = ot && (Dr == null ? void 0 : Dr[ot])) !== null && Or !== void 0 ? Or : Gr;
  }, [ot]), ur = reactExports.useCallback(nt || function(Dr) {
    return Dr;
  }, [nt]);
  function pr(Dr, Gr, Or) {
    ar === Dr && (Gr === void 0 || Gr === Vt) || (Jt(Dr), Or || (tr(Dr < tt.length - 1), ct == null || ct(Dr)), Gr !== void 0 && Qt(Gr));
  }
  function yr(Dr, Gr) {
    Bt(Gr.clientWidth);
  }
  function Er(Dr, Gr) {
    It(function(Or) {
      var Hr = new Map(Or);
      return Gr === null ? Hr.delete(Dr) : Hr.set(Dr, Gr), Hr;
    });
  }
  function br(Dr, Gr) {
    Nt(Gr), jt(_t);
  }
  function gr(Dr, Gr) {
    Tt(Gr);
  }
  function Ar(Dr) {
    return Ct.get(lr(Wt[Dr], Dr));
  }
  useLayoutEffect$1(function() {
    if (Ot && typeof sr == "number" && Wt) {
      var Dr = $t, Gr = Wt.length, Or = Gr - 1;
      if (!Gr) {
        pr(0, null);
        return;
      }
      for (var Hr = 0; Hr < Gr; Hr += 1) {
        var jr = Ar(Hr);
        if (At && (jr = jr || 0), jr === void 0) {
          pr(Hr - 1, void 0, !0);
          break;
        }
        if (Dr += jr, // Only one means `totalWidth` is the final width
        Or === 0 && Dr <= Ot || // Last two width will be the final width
        Hr === Or - 1 && Dr + Ar(Or) <= Ot) {
          pr(Or, null);
          break;
        } else if (Dr + sr > Ot) {
          pr(Hr - 1, Dr - jr - $t + _t);
          break;
        }
      }
      dt && Ar(0) + $t > Ot && Qt(null);
    }
  }, [Ot, Ct, _t, $t, lr, Wt]);
  var Sr = nr && !!er.length, Br = {};
  Vt !== null && or && (Br = {
    position: "absolute",
    left: Vt,
    top: 0
  });
  var Ir = {
    prefixCls: ir,
    responsive: or,
    component: mt,
    invalidate: Xt
  }, hr = at ? function(Dr, Gr) {
    var Or = lr(Dr, Gr);
    return /* @__PURE__ */ reactExports.createElement(OverflowContext.Provider, {
      key: Or,
      value: _objectSpread2$a(_objectSpread2$a({}, Ir), {}, {
        order: Gr,
        item: Dr,
        itemKey: Or,
        registerSize: Er,
        display: Gr <= rr
      })
    }, at(Dr, Gr));
  } : function(Dr, Gr) {
    var Or = lr(Dr, Gr);
    return /* @__PURE__ */ reactExports.createElement(Item$7, _extends$2({}, Ir, {
      order: Gr,
      key: Or,
      item: Dr,
      renderItem: ur,
      itemKey: Or,
      registerSize: Er,
      display: Gr <= rr
    }));
  }, vr, xr = {
    order: Sr ? rr : Number.MAX_SAFE_INTEGER,
    className: "".concat(ir, "-rest"),
    registerSize: br,
    display: Sr
  };
  if (ht)
    ht && (vr = /* @__PURE__ */ reactExports.createElement(OverflowContext.Provider, {
      value: _objectSpread2$a(_objectSpread2$a({}, Ir), xr)
    }, ht(er)));
  else {
    var Pr = ft || defaultRenderRest;
    vr = /* @__PURE__ */ reactExports.createElement(Item$7, _extends$2({}, Ir, xr), typeof Pr == "function" ? Pr(er) : Pr);
  }
  var Rr = /* @__PURE__ */ reactExports.createElement(pt, _extends$2({
    className: classnames(!Xt && _, it),
    style: et,
    ref: s
  }, vt), Wt.map(hr), Gt ? vr : null, dt && /* @__PURE__ */ reactExports.createElement(Item$7, _extends$2({}, Ir, {
    responsive: cr,
    responsiveDisabled: !or,
    order: rr,
    className: "".concat(ir, "-suffix"),
    registerSize: gr,
    display: !0,
    style: Br
  }), dt));
  return cr && (Rr = /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: yr,
    disabled: !or
  }, Rr)), Rr;
}
var ForwardOverflow = /* @__PURE__ */ reactExports.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
var Input$4 = function a(s, $) {
  var _, _e = s.prefixCls, tt = s.id, nt = s.inputElement, at = s.disabled, ot = s.tabIndex, rt = s.autoFocus, st = s.autoComplete, lt = s.editable, et = s.activeDescendantId, it = s.value, ut = s.maxLength, ft = s.onKeyDown, ht = s.onMouseDown, dt = s.onChange, gt = s.onPaste, pt = s.onCompositionStart, mt = s.onCompositionEnd, ct = s.open, vt = s.attrs, At = nt || /* @__PURE__ */ reactExports.createElement("input", null), xt = At, bt = xt.ref, Et = xt.props, St = Et.onKeyDown, Bt = Et.onChange, Ot = Et.onMouseDown, Pt = Et.onCompositionStart, wt = Et.onCompositionEnd, Ct = Et.style;
  return "maxLength" in At.props, At = /* @__PURE__ */ reactExports.cloneElement(At, _objectSpread2$a(_objectSpread2$a(_objectSpread2$a({
    type: "search"
  }, Et), {}, {
    // Override over origin props
    id: tt,
    ref: composeRef($, bt),
    disabled: at,
    tabIndex: ot,
    autoComplete: st || "off",
    autoFocus: rt,
    className: classnames("".concat(_e, "-selection-search-input"), (_ = At) === null || _ === void 0 || (_ = _.props) === null || _ === void 0 ? void 0 : _.className),
    role: "combobox",
    "aria-expanded": ct || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(tt, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(tt, "_list"),
    "aria-activedescendant": ct ? et : void 0
  }, vt), {}, {
    value: lt ? it : "",
    maxLength: ut,
    readOnly: !lt,
    unselectable: lt ? null : "on",
    style: _objectSpread2$a(_objectSpread2$a({}, Ct), {}, {
      opacity: lt ? null : 0
    }),
    onKeyDown: function(yt) {
      ft(yt), St && St(yt);
    },
    onMouseDown: function(yt) {
      ht(yt), Ot && Ot(yt);
    },
    onChange: function(yt) {
      dt(yt), Bt && Bt(yt);
    },
    onCompositionStart: function(yt) {
      pt(yt), Pt && Pt(yt);
    },
    onCompositionEnd: function(yt) {
      mt(yt), wt && wt(yt);
    },
    onPaste: gt
  })), At;
}, RefInput = /* @__PURE__ */ reactExports.forwardRef(Input$4);
RefInput.displayName = "Input";
function toArray$7(a) {
  return Array.isArray(a) ? a : a !== void 0 ? [a] : [];
}
var isClient = typeof window < "u" && window.document && window.document.documentElement, isBrowserClient$2 = isClient;
function hasValue(a) {
  return a != null;
}
function isComboNoValue(a) {
  return !a && a !== 0;
}
function isTitleType$1(a) {
  return ["string", "number"].includes(_typeof$q(a));
}
function getTitle(a) {
  var s = void 0;
  return a && (isTitleType$1(a.title) ? s = a.title.toString() : isTitleType$1(a.label) && (s = a.label.toString())), s;
}
function useLayoutEffect(a, s) {
  isBrowserClient$2 ? reactExports.useLayoutEffect(a, s) : reactExports.useEffect(a, s);
}
function itemKey$1(a) {
  var s;
  return (s = a.key) !== null && s !== void 0 ? s : a.value;
}
var onPreventMouseDown = function a(s) {
  s.preventDefault(), s.stopPropagation();
}, SelectSelector = function a(s) {
  var $ = s.id, _ = s.prefixCls, _e = s.values, tt = s.open, nt = s.searchValue, at = s.autoClearSearchValue, ot = s.inputRef, rt = s.placeholder, st = s.disabled, lt = s.mode, et = s.showSearch, it = s.autoFocus, ut = s.autoComplete, ft = s.activeDescendantId, ht = s.tabIndex, dt = s.removeIcon, gt = s.maxTagCount, pt = s.maxTagTextLength, mt = s.maxTagPlaceholder, ct = mt === void 0 ? function(Qt) {
    return "+ ".concat(Qt.length, " ...");
  } : mt, vt = s.tagRender, At = s.onToggleOpen, xt = s.onRemove, bt = s.onInputChange, Et = s.onInputPaste, St = s.onInputKeyDown, Bt = s.onInputMouseDown, Ot = s.onInputCompositionStart, Pt = s.onInputCompositionEnd, wt = reactExports.useRef(null), Ct = reactExports.useState(0), It = _slicedToArray$e(Ct, 2), yt = It[0], Rt = It[1], kt = reactExports.useState(!1), jt = _slicedToArray$e(kt, 2), Ht = jt[0], Ft = jt[1], _t = "".concat(_, "-selection"), Nt = tt || lt === "multiple" && at === !1 || lt === "tags" ? nt : "", Mt = lt === "tags" || lt === "multiple" && at === !1 || et && (tt || Ht);
  useLayoutEffect(function() {
    Rt(wt.current.scrollWidth);
  }, [Nt]);
  function Lt(Qt, qt, Zt, ar, Jt) {
    return /* @__PURE__ */ reactExports.createElement("span", {
      className: classnames("".concat(_t, "-item"), _defineProperty$c({}, "".concat(_t, "-item-disabled"), Zt)),
      title: getTitle(Qt)
    }, /* @__PURE__ */ reactExports.createElement("span", {
      className: "".concat(_t, "-item-content")
    }, qt), ar && /* @__PURE__ */ reactExports.createElement(TransBtn, {
      className: "".concat(_t, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: Jt,
      customizeIcon: dt
    }, "×"));
  }
  function $t(Qt, qt, Zt, ar, Jt) {
    var rr = function(Kt) {
      onPreventMouseDown(Kt), At(!tt);
    };
    return /* @__PURE__ */ reactExports.createElement("span", {
      onMouseDown: rr
    }, vt({
      label: qt,
      value: Qt,
      disabled: Zt,
      closable: ar,
      onClose: Jt
    }));
  }
  function Tt(Qt) {
    var qt = Qt.disabled, Zt = Qt.label, ar = Qt.value, Jt = !st && !qt, rr = Zt;
    if (typeof pt == "number" && (typeof Zt == "string" || typeof Zt == "number")) {
      var Yt = String(rr);
      Yt.length > pt && (rr = "".concat(Yt.slice(0, pt), "..."));
    }
    var Kt = function(tr) {
      tr && tr.stopPropagation(), xt(Qt);
    };
    return typeof vt == "function" ? $t(ar, rr, qt, Jt, Kt) : Lt(Qt, rr, qt, Jt, Kt);
  }
  function Dt(Qt) {
    var qt = typeof ct == "function" ? ct(Qt) : ct;
    return Lt({
      title: qt
    }, qt, !1);
  }
  var Ut = /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(_t, "-search"),
    style: {
      width: yt
    },
    onFocus: function() {
      Ft(!0);
    },
    onBlur: function() {
      Ft(!1);
    }
  }, /* @__PURE__ */ reactExports.createElement(RefInput, {
    ref: ot,
    open: tt,
    prefixCls: _,
    id: $,
    inputElement: null,
    disabled: st,
    autoFocus: it,
    autoComplete: ut,
    editable: Mt,
    activeDescendantId: ft,
    value: Nt,
    onKeyDown: St,
    onMouseDown: Bt,
    onChange: bt,
    onPaste: Et,
    onCompositionStart: Ot,
    onCompositionEnd: Pt,
    tabIndex: ht,
    attrs: pickAttrs(s, !0)
  }), /* @__PURE__ */ reactExports.createElement("span", {
    ref: wt,
    className: "".concat(_t, "-search-mirror"),
    "aria-hidden": !0
  }, Nt, " ")), Vt = /* @__PURE__ */ reactExports.createElement(ForwardOverflow, {
    prefixCls: "".concat(_t, "-overflow"),
    data: _e,
    renderItem: Tt,
    renderRest: Dt,
    suffix: Ut,
    itemKey: itemKey$1,
    maxCount: gt
  });
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, Vt, !_e.length && !Nt && /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(_t, "-placeholder")
  }, rt));
}, SingleSelector = function a(s) {
  var $ = s.inputElement, _ = s.prefixCls, _e = s.id, tt = s.inputRef, nt = s.disabled, at = s.autoFocus, ot = s.autoComplete, rt = s.activeDescendantId, st = s.mode, lt = s.open, et = s.values, it = s.placeholder, ut = s.tabIndex, ft = s.showSearch, ht = s.searchValue, dt = s.activeValue, gt = s.maxLength, pt = s.onInputKeyDown, mt = s.onInputMouseDown, ct = s.onInputChange, vt = s.onInputPaste, At = s.onInputCompositionStart, xt = s.onInputCompositionEnd, bt = s.title, Et = reactExports.useState(!1), St = _slicedToArray$e(Et, 2), Bt = St[0], Ot = St[1], Pt = st === "combobox", wt = Pt || ft, Ct = et[0], It = ht || "";
  Pt && dt && !Bt && (It = dt), reactExports.useEffect(function() {
    Pt && Ot(!1);
  }, [Pt, dt]);
  var yt = st !== "combobox" && !lt && !ft ? !1 : !!It, Rt = bt === void 0 ? getTitle(Ct) : bt, kt = function() {
    if (Ct)
      return null;
    var Ht = yt ? {
      visibility: "hidden"
    } : void 0;
    return /* @__PURE__ */ reactExports.createElement("span", {
      className: "".concat(_, "-selection-placeholder"),
      style: Ht
    }, it);
  };
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(_, "-selection-search")
  }, /* @__PURE__ */ reactExports.createElement(RefInput, {
    ref: tt,
    prefixCls: _,
    id: _e,
    open: lt,
    inputElement: $,
    disabled: nt,
    autoFocus: at,
    autoComplete: ot,
    editable: wt,
    activeDescendantId: rt,
    value: It,
    onKeyDown: pt,
    onMouseDown: mt,
    onChange: function(Ht) {
      Ot(!0), ct(Ht);
    },
    onPaste: vt,
    onCompositionStart: At,
    onCompositionEnd: xt,
    tabIndex: ut,
    attrs: pickAttrs(s, !0),
    maxLength: Pt ? gt : void 0
  })), !Pt && Ct ? /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(_, "-selection-item"),
    title: Rt,
    style: yt ? {
      visibility: "hidden"
    } : void 0
  }, Ct.label) : null, kt());
};
function isValidateOpenKey(a) {
  return ![
    // System function button
    KeyCode.ESC,
    KeyCode.SHIFT,
    KeyCode.BACKSPACE,
    KeyCode.TAB,
    KeyCode.WIN_KEY,
    KeyCode.ALT,
    KeyCode.META,
    KeyCode.WIN_KEY_RIGHT,
    KeyCode.CTRL,
    KeyCode.SEMICOLON,
    KeyCode.EQUALS,
    KeyCode.CAPS_LOCK,
    KeyCode.CONTEXT_MENU,
    // F1-F12
    KeyCode.F1,
    KeyCode.F2,
    KeyCode.F3,
    KeyCode.F4,
    KeyCode.F5,
    KeyCode.F6,
    KeyCode.F7,
    KeyCode.F8,
    KeyCode.F9,
    KeyCode.F10,
    KeyCode.F11,
    KeyCode.F12
  ].includes(a);
}
var Selector = function a(s, $) {
  var _ = reactExports.useRef(null), _e = reactExports.useRef(!1), tt = s.prefixCls, nt = s.open, at = s.mode, ot = s.showSearch, rt = s.tokenWithEnter, st = s.autoClearSearchValue, lt = s.onSearch, et = s.onSearchSubmit, it = s.onToggleOpen, ut = s.onInputKeyDown, ft = s.domRef;
  reactExports.useImperativeHandle($, function() {
    return {
      focus: function() {
        _.current.focus();
      },
      blur: function() {
        _.current.blur();
      }
    };
  });
  var ht = useLock(0), dt = _slicedToArray$e(ht, 2), gt = dt[0], pt = dt[1], mt = function(It) {
    var yt = It.which;
    (yt === KeyCode.UP || yt === KeyCode.DOWN) && It.preventDefault(), ut && ut(It), yt === KeyCode.ENTER && at === "tags" && !_e.current && !nt && (et == null || et(It.target.value)), isValidateOpenKey(yt) && it(!0);
  }, ct = function() {
    pt(!0);
  }, vt = reactExports.useRef(null), At = function(It) {
    lt(It, !0, _e.current) !== !1 && it(!0);
  }, xt = function() {
    _e.current = !0;
  }, bt = function(It) {
    _e.current = !1, at !== "combobox" && At(It.target.value);
  }, Et = function(It) {
    var yt = It.target.value;
    if (rt && vt.current && /[\r\n]/.test(vt.current)) {
      var Rt = vt.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      yt = yt.replace(Rt, vt.current);
    }
    vt.current = null, At(yt);
  }, St = function(It) {
    var yt = It.clipboardData, Rt = yt.getData("text");
    vt.current = Rt;
  }, Bt = function(It) {
    var yt = It.target;
    if (yt !== _.current) {
      var Rt = document.body.style.msTouchAction !== void 0;
      Rt ? setTimeout(function() {
        _.current.focus();
      }) : _.current.focus();
    }
  }, Ot = function(It) {
    var yt = gt();
    It.target !== _.current && !yt && at !== "combobox" && It.preventDefault(), (at !== "combobox" && (!ot || !yt) || !nt) && (nt && st !== !1 && lt("", !0, !1), it());
  }, Pt = {
    inputRef: _,
    onInputKeyDown: mt,
    onInputMouseDown: ct,
    onInputChange: Et,
    onInputPaste: St,
    onInputCompositionStart: xt,
    onInputCompositionEnd: bt
  }, wt = at === "multiple" || at === "tags" ? /* @__PURE__ */ reactExports.createElement(SelectSelector, _extends$2({}, s, Pt)) : /* @__PURE__ */ reactExports.createElement(SingleSelector, _extends$2({}, s, Pt));
  return /* @__PURE__ */ reactExports.createElement("div", {
    ref: ft,
    className: "".concat(tt, "-selector"),
    onClick: Bt,
    onMouseDown: Ot
  }, wt);
}, ForwardSelector = /* @__PURE__ */ reactExports.forwardRef(Selector);
ForwardSelector.displayName = "Selector";
function Arrow(a) {
  var s = a.prefixCls, $ = a.align, _ = a.arrow, _e = a.arrowPos, tt = _ || {}, nt = tt.className, at = tt.content, ot = _e.x, rt = ot === void 0 ? 0 : ot, st = _e.y, lt = st === void 0 ? 0 : st, et = reactExports.useRef();
  if (!$ || !$.points)
    return null;
  var it = {
    position: "absolute"
  };
  if ($.autoArrow !== !1) {
    var ut = $.points[0], ft = $.points[1], ht = ut[0], dt = ut[1], gt = ft[0], pt = ft[1];
    ht === gt || !["t", "b"].includes(ht) ? it.top = lt : ht === "t" ? it.top = 0 : it.bottom = 0, dt === pt || !["l", "r"].includes(dt) ? it.left = rt : dt === "l" ? it.left = 0 : it.right = 0;
  }
  return /* @__PURE__ */ reactExports.createElement("div", {
    ref: et,
    className: classnames("".concat(s, "-arrow"), nt),
    style: it
  }, at);
}
function Mask$2(a) {
  var s = a.prefixCls, $ = a.open, _ = a.zIndex, _e = a.mask, tt = a.motion;
  return _e ? /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$2({}, tt, {
    motionAppear: !0,
    visible: $,
    removeOnLeave: !0
  }), function(nt) {
    var at = nt.className;
    return /* @__PURE__ */ reactExports.createElement("div", {
      style: {
        zIndex: _
      },
      className: classnames("".concat(s, "-mask"), at)
    });
  }) : null;
}
var PopupContent = /* @__PURE__ */ reactExports.memo(function(a) {
  var s = a.children;
  return s;
}, function(a, s) {
  return s.cache;
}), Popup$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.popup, _ = a.className, _e = a.prefixCls, tt = a.style, nt = a.target, at = a.onVisibleChanged, ot = a.open, rt = a.keepDom, st = a.fresh, lt = a.onClick, et = a.mask, it = a.arrow, ut = a.arrowPos, ft = a.align, ht = a.motion, dt = a.maskMotion, gt = a.forceRender, pt = a.getPopupContainer, mt = a.autoDestroy, ct = a.portal, vt = a.zIndex, At = a.onMouseEnter, xt = a.onMouseLeave, bt = a.onPointerEnter, Et = a.ready, St = a.offsetX, Bt = a.offsetY, Ot = a.offsetR, Pt = a.offsetB, wt = a.onAlign, Ct = a.onPrepare, It = a.stretch, yt = a.targetWidth, Rt = a.targetHeight, kt = typeof $ == "function" ? $() : $, jt = ot || rt, Ht = (pt == null ? void 0 : pt.length) > 0, Ft = reactExports.useState(!pt || !Ht), _t = _slicedToArray$e(Ft, 2), Nt = _t[0], Mt = _t[1];
  if (useLayoutEffect$1(function() {
    !Nt && Ht && nt && Mt(!0);
  }, [Nt, Ht, nt]), !Nt)
    return null;
  var Lt = "auto", $t = {
    left: "-1000vw",
    top: "-1000vh",
    right: Lt,
    bottom: Lt
  };
  if (Et || !ot) {
    var Tt, Dt = ft.points, Ut = ft.dynamicInset || ((Tt = ft._experimental) === null || Tt === void 0 ? void 0 : Tt.dynamicInset), Vt = Ut && Dt[0][1] === "r", Qt = Ut && Dt[0][0] === "b";
    Vt ? ($t.right = Ot, $t.left = Lt) : ($t.left = St, $t.right = Lt), Qt ? ($t.bottom = Pt, $t.top = Lt) : ($t.top = Bt, $t.bottom = Lt);
  }
  var qt = {};
  return It && (It.includes("height") && Rt ? qt.height = Rt : It.includes("minHeight") && Rt && (qt.minHeight = Rt), It.includes("width") && yt ? qt.width = yt : It.includes("minWidth") && yt && (qt.minWidth = yt)), ot || (qt.pointerEvents = "none"), /* @__PURE__ */ reactExports.createElement(ct, {
    open: gt || jt,
    getContainer: pt && function() {
      return pt(nt);
    },
    autoDestroy: mt
  }, /* @__PURE__ */ reactExports.createElement(Mask$2, {
    prefixCls: _e,
    open: ot,
    zIndex: vt,
    mask: et,
    motion: dt
  }), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: wt,
    disabled: !ot
  }, function(Zt) {
    return /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$2({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: gt,
      leavedClassName: "".concat(_e, "-hidden")
    }, ht, {
      onAppearPrepare: Ct,
      onEnterPrepare: Ct,
      visible: ot,
      onVisibleChanged: function(Jt) {
        var rr;
        ht == null || (rr = ht.onVisibleChanged) === null || rr === void 0 || rr.call(ht, Jt), at(Jt);
      }
    }), function(ar, Jt) {
      var rr = ar.className, Yt = ar.style, Kt = classnames(_e, rr, _);
      return /* @__PURE__ */ reactExports.createElement("div", {
        ref: composeRef(Zt, s, Jt),
        className: Kt,
        style: _objectSpread2$a(_objectSpread2$a(_objectSpread2$a(_objectSpread2$a({
          "--arrow-x": "".concat(ut.x || 0, "px"),
          "--arrow-y": "".concat(ut.y || 0, "px")
        }, $t), qt), Yt), {}, {
          boxSizing: "border-box",
          zIndex: vt
        }, tt),
        onMouseEnter: At,
        onMouseLeave: xt,
        onPointerEnter: bt,
        onClick: lt
      }, it && /* @__PURE__ */ reactExports.createElement(Arrow, {
        prefixCls: _e,
        arrow: it,
        arrowPos: ut,
        align: ft
      }), /* @__PURE__ */ reactExports.createElement(PopupContent, {
        cache: !ot && !st
      }, kt));
    });
  }));
}), TriggerWrapper = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.children, _ = a.getTriggerDOMNode, _e = supportRef($), tt = reactExports.useCallback(function(at) {
    fillRef(s, _ ? _(at) : at);
  }, [_]), nt = useComposeRef(tt, $.ref);
  return _e ? /* @__PURE__ */ reactExports.cloneElement($, {
    ref: nt
  }) : $;
}), TriggerContext = /* @__PURE__ */ reactExports.createContext(null);
function toArray$6(a) {
  return a ? Array.isArray(a) ? a : [a] : [];
}
function useAction(a, s, $, _) {
  return reactExports.useMemo(function() {
    var _e = toArray$6($ ?? s), tt = toArray$6(_ ?? s), nt = new Set(_e), at = new Set(tt);
    return a && (nt.has("hover") && (nt.delete("hover"), nt.add("click")), at.has("hover") && (at.delete("hover"), at.add("click"))), [nt, at];
  }, [a, s, $, _]);
}
function isPointsEq$1() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], $ = arguments.length > 2 ? arguments[2] : void 0;
  return $ ? a[0] === s[0] : a[0] === s[0] && a[1] === s[1];
}
function getAlignPopupClassName(a, s, $, _) {
  for (var _e = $.points, tt = Object.keys(a), nt = 0; nt < tt.length; nt += 1) {
    var at, ot = tt[nt];
    if (isPointsEq$1((at = a[ot]) === null || at === void 0 ? void 0 : at.points, _e, _))
      return "".concat(s, "-placement-").concat(ot);
  }
  return "";
}
function getMotion$1(a, s, $, _) {
  return s || ($ ? {
    motionName: "".concat(a, "-").concat($)
  } : _ ? {
    motionName: _
  } : null);
}
function getWin(a) {
  return a.ownerDocument.defaultView;
}
function collectScroller(a) {
  for (var s = [], $ = a == null ? void 0 : a.parentElement, _ = ["hidden", "scroll", "clip", "auto"]; $; ) {
    var _e = getWin($).getComputedStyle($), tt = _e.overflowX, nt = _e.overflowY, at = _e.overflow;
    [tt, nt, at].some(function(ot) {
      return _.includes(ot);
    }) && s.push($), $ = $.parentElement;
  }
  return s;
}
function toNum(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(a) ? s : a;
}
function getPxValue(a) {
  return toNum(parseFloat(a), 0);
}
function getVisibleArea(a, s) {
  var $ = _objectSpread2$a({}, a);
  return (s || []).forEach(function(_) {
    if (!(_ instanceof HTMLBodyElement || _ instanceof HTMLHtmlElement)) {
      var _e = getWin(_).getComputedStyle(_), tt = _e.overflow, nt = _e.overflowClipMargin, at = _e.borderTopWidth, ot = _e.borderBottomWidth, rt = _e.borderLeftWidth, st = _e.borderRightWidth, lt = _.getBoundingClientRect(), et = _.offsetHeight, it = _.clientHeight, ut = _.offsetWidth, ft = _.clientWidth, ht = getPxValue(at), dt = getPxValue(ot), gt = getPxValue(rt), pt = getPxValue(st), mt = toNum(Math.round(lt.width / ut * 1e3) / 1e3), ct = toNum(Math.round(lt.height / et * 1e3) / 1e3), vt = (ut - ft - gt - pt) * mt, At = (et - it - ht - dt) * ct, xt = ht * ct, bt = dt * ct, Et = gt * mt, St = pt * mt, Bt = 0, Ot = 0;
      if (tt === "clip") {
        var Pt = getPxValue(nt);
        Bt = Pt * mt, Ot = Pt * ct;
      }
      var wt = lt.x + Et - Bt, Ct = lt.y + xt - Ot, It = wt + lt.width + 2 * Bt - Et - St - vt, yt = Ct + lt.height + 2 * Ot - xt - bt - At;
      $.left = Math.max($.left, wt), $.top = Math.max($.top, Ct), $.right = Math.min($.right, It), $.bottom = Math.min($.bottom, yt);
    }
  }), $;
}
function getUnitOffset(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, $ = "".concat(s), _ = $.match(/^(.*)\%$/);
  return _ ? a * (parseFloat(_[1]) / 100) : parseFloat($);
}
function getNumberOffset(a, s) {
  var $ = s || [], _ = _slicedToArray$e($, 2), _e = _[0], tt = _[1];
  return [getUnitOffset(a.width, _e), getUnitOffset(a.height, tt)];
}
function splitPoints() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [a[0], a[1]];
}
function getAlignPoint(a, s) {
  var $ = s[0], _ = s[1], _e, tt;
  return $ === "t" ? tt = a.y : $ === "b" ? tt = a.y + a.height : tt = a.y + a.height / 2, _ === "l" ? _e = a.x : _ === "r" ? _e = a.x + a.width : _e = a.x + a.width / 2, {
    x: _e,
    y: tt
  };
}
function reversePoints(a, s) {
  var $ = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return a.map(function(_, _e) {
    return _e === s ? $[_] || "c" : _;
  }).join("");
}
function useAlign(a, s, $, _, _e, tt, nt) {
  var at = reactExports.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: _e[_] || {}
  }), ot = _slicedToArray$e(at, 2), rt = ot[0], st = ot[1], lt = reactExports.useRef(0), et = reactExports.useMemo(function() {
    return s ? collectScroller(s) : [];
  }, [s]), it = reactExports.useRef({}), ut = function() {
    it.current = {};
  };
  a || ut();
  var ft = useEvent(function() {
    if (s && $ && a) {
      let Wn = function(qn, eo) {
        var ro = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Kt, ao = kt.x + qn, so = kt.y + eo, lo = ao + Tt, Ao = so + $t, uo = Math.max(ao, ro.left), wo = Math.max(so, ro.top), $o = Math.min(lo, ro.right), yo = Math.min(Ao, ro.bottom);
        return Math.max(0, ($o - uo) * (yo - wo));
      }, ca = function() {
        Fr = kt.y + Pr, Qr = Fr + $t, Yr = kt.x + xr, kr = Yr + Tt;
      };
      var gt, pt, mt = s, ct = mt.ownerDocument, vt = getWin(mt), At = vt.getComputedStyle(mt), xt = At.width, bt = At.height, Et = At.position, St = mt.style.left, Bt = mt.style.top, Ot = mt.style.right, Pt = mt.style.bottom, wt = mt.style.overflow, Ct = _objectSpread2$a(_objectSpread2$a({}, _e[_]), tt), It = ct.createElement("div");
      (gt = mt.parentElement) === null || gt === void 0 || gt.appendChild(It), It.style.left = "".concat(mt.offsetLeft, "px"), It.style.top = "".concat(mt.offsetTop, "px"), It.style.position = Et, It.style.height = "".concat(mt.offsetHeight, "px"), It.style.width = "".concat(mt.offsetWidth, "px"), mt.style.left = "0", mt.style.top = "0", mt.style.right = "auto", mt.style.bottom = "auto", mt.style.overflow = "hidden";
      var yt;
      if (Array.isArray($))
        yt = {
          x: $[0],
          y: $[1],
          width: 0,
          height: 0
        };
      else {
        var Rt = $.getBoundingClientRect();
        yt = {
          x: Rt.x,
          y: Rt.y,
          width: Rt.width,
          height: Rt.height
        };
      }
      var kt = mt.getBoundingClientRect(), jt = ct.documentElement, Ht = jt.clientWidth, Ft = jt.clientHeight, _t = jt.scrollWidth, Nt = jt.scrollHeight, Mt = jt.scrollTop, Lt = jt.scrollLeft, $t = kt.height, Tt = kt.width, Dt = yt.height, Ut = yt.width, Vt = {
        left: 0,
        top: 0,
        right: Ht,
        bottom: Ft
      }, Qt = {
        left: -Lt,
        top: -Mt,
        right: _t - Lt,
        bottom: Nt - Mt
      }, qt = Ct.htmlRegion, Zt = "visible", ar = "visibleFirst";
      qt !== "scroll" && qt !== ar && (qt = Zt);
      var Jt = qt === ar, rr = getVisibleArea(Qt, et), Yt = getVisibleArea(Vt, et), Kt = qt === Zt ? Yt : rr, nr = Jt ? Yt : Kt;
      mt.style.left = "auto", mt.style.top = "auto", mt.style.right = "0", mt.style.bottom = "0";
      var tr = mt.getBoundingClientRect();
      mt.style.left = St, mt.style.top = Bt, mt.style.right = Ot, mt.style.bottom = Pt, mt.style.overflow = wt, (pt = mt.parentElement) === null || pt === void 0 || pt.removeChild(It);
      var ir = toNum(Math.round(Tt / parseFloat(xt) * 1e3) / 1e3), sr = toNum(Math.round($t / parseFloat(bt) * 1e3) / 1e3);
      if (ir === 0 || sr === 0 || isDOM($) && !isVisible($))
        return;
      var cr = Ct.offset, or = Ct.targetOffset, Xt = getNumberOffset(kt, cr), Gt = _slicedToArray$e(Xt, 2), Wt = Gt[0], er = Gt[1], lr = getNumberOffset(yt, or), ur = _slicedToArray$e(lr, 2), pr = ur[0], yr = ur[1];
      yt.x -= pr, yt.y -= yr;
      var Er = Ct.points || [], br = _slicedToArray$e(Er, 2), gr = br[0], Ar = br[1], Sr = splitPoints(Ar), Br = splitPoints(gr), Ir = getAlignPoint(yt, Sr), hr = getAlignPoint(kt, Br), vr = _objectSpread2$a({}, Ct), xr = Ir.x - hr.x + Wt, Pr = Ir.y - hr.y + er, Rr = Wn(xr, Pr), Dr = Wn(xr, Pr, Yt), Gr = getAlignPoint(yt, ["t", "l"]), Or = getAlignPoint(kt, ["t", "l"]), Hr = getAlignPoint(yt, ["b", "r"]), jr = getAlignPoint(kt, ["b", "r"]), Tr = Ct.overflow || {}, fr = Tr.adjustX, Cr = Tr.adjustY, $r = Tr.shiftX, wr = Tr.shiftY, Mr = function(eo) {
        return typeof eo == "boolean" ? eo : eo >= 0;
      }, Fr, Qr, Yr, kr;
      ca();
      var Nr = Mr(Cr), Lr = Br[0] === Sr[0];
      if (Nr && Br[0] === "t" && (Qr > nr.bottom || it.current.bt)) {
        var zr = Pr;
        Lr ? zr -= $t - Dt : zr = Gr.y - jr.y - er;
        var Vr = Wn(xr, zr), an = Wn(xr, zr, Yt);
        // Of course use larger one
        Vr > Rr || Vr === Rr && (!Jt || // Choose recommend one
        an >= Dr) ? (it.current.bt = !0, Pr = zr, er = -er, vr.points = [reversePoints(Br, 0), reversePoints(Sr, 0)]) : it.current.bt = !1;
      }
      if (Nr && Br[0] === "b" && (Fr < nr.top || it.current.tb)) {
        var Zr = Pr;
        Lr ? Zr += $t - Dt : Zr = Hr.y - Or.y - er;
        var un = Wn(xr, Zr), Xr = Wn(xr, Zr, Yt);
        // Of course use larger one
        un > Rr || un === Rr && (!Jt || // Choose recommend one
        Xr >= Dr) ? (it.current.tb = !0, Pr = Zr, er = -er, vr.points = [reversePoints(Br, 0), reversePoints(Sr, 0)]) : it.current.tb = !1;
      }
      var Kr = Mr(fr), rn = Br[1] === Sr[1];
      if (Kr && Br[1] === "l" && (kr > nr.right || it.current.rl)) {
        var nn = xr;
        rn ? nn -= Tt - Ut : nn = Gr.x - jr.x - Wt;
        var sn = Wn(nn, Pr), gn = Wn(nn, Pr, Yt);
        // Of course use larger one
        sn > Rr || sn === Rr && (!Jt || // Choose recommend one
        gn >= Dr) ? (it.current.rl = !0, xr = nn, Wt = -Wt, vr.points = [reversePoints(Br, 1), reversePoints(Sr, 1)]) : it.current.rl = !1;
      }
      if (Kr && Br[1] === "r" && (Yr < nr.left || it.current.lr)) {
        var en = xr;
        rn ? en += Tt - Ut : en = Hr.x - Or.x - Wt;
        var Wr = Wn(en, Pr), dn = Wn(en, Pr, Yt);
        // Of course use larger one
        Wr > Rr || Wr === Rr && (!Jt || // Choose recommend one
        dn >= Dr) ? (it.current.lr = !0, xr = en, Wt = -Wt, vr.points = [reversePoints(Br, 1), reversePoints(Sr, 1)]) : it.current.lr = !1;
      }
      ca();
      var hn = $r === !0 ? 0 : $r;
      typeof hn == "number" && (Yr < Yt.left && (xr -= Yr - Yt.left - Wt, yt.x + Ut < Yt.left + hn && (xr += yt.x - Yt.left + Ut - hn)), kr > Yt.right && (xr -= kr - Yt.right - Wt, yt.x > Yt.right - hn && (xr += yt.x - Yt.right + hn)));
      var En = wr === !0 ? 0 : wr;
      typeof En == "number" && (Fr < Yt.top && (Pr -= Fr - Yt.top - er, yt.y + Dt < Yt.top + En && (Pr += yt.y - Yt.top + Dt - En)), Qr > Yt.bottom && (Pr -= Qr - Yt.bottom - er, yt.y > Yt.bottom - En && (Pr += yt.y - Yt.bottom + En)));
      var bn = kt.x + xr, Cn = bn + Tt, wn = kt.y + Pr, vn = wn + $t, fn = yt.x, on = fn + Ut, pn = yt.y, mn = pn + Dt, Pn = Math.max(bn, fn), An = Math.min(Cn, on), yn = (Pn + An) / 2, Bn = yn - bn, Fn = Math.max(wn, pn), zn = Math.min(vn, mn), Zn = (Fn + zn) / 2, to = Zn - wn;
      nt == null || nt(s, vr);
      var Mn = tr.right - kt.x - (xr + kt.width), Nn = tr.bottom - kt.y - (Pr + kt.height);
      st({
        ready: !0,
        offsetX: xr / ir,
        offsetY: Pr / sr,
        offsetR: Mn / ir,
        offsetB: Nn / sr,
        arrowX: Bn / ir,
        arrowY: to / sr,
        scaleX: ir,
        scaleY: sr,
        align: vr
      });
    }
  }), ht = function() {
    lt.current += 1;
    var pt = lt.current;
    Promise.resolve().then(function() {
      lt.current === pt && ft();
    });
  }, dt = function() {
    st(function(pt) {
      return _objectSpread2$a(_objectSpread2$a({}, pt), {}, {
        ready: !1
      });
    });
  };
  return useLayoutEffect$1(dt, [_]), useLayoutEffect$1(function() {
    a || dt();
  }, [a]), [rt.ready, rt.offsetX, rt.offsetY, rt.offsetR, rt.offsetB, rt.arrowX, rt.arrowY, rt.scaleX, rt.scaleY, rt.align, ht];
}
function useWatch(a, s, $, _, _e) {
  useLayoutEffect$1(function() {
    if (a && s && $) {
      let lt = function() {
        _(), _e();
      };
      var tt = s, nt = $, at = collectScroller(tt), ot = collectScroller(nt), rt = getWin(nt), st = new Set([rt].concat(_toConsumableArray$d(at), _toConsumableArray$d(ot)));
      return st.forEach(function(et) {
        et.addEventListener("scroll", lt, {
          passive: !0
        });
      }), rt.addEventListener("resize", lt, {
        passive: !0
      }), _(), function() {
        st.forEach(function(et) {
          et.removeEventListener("scroll", lt), rt.removeEventListener("resize", lt);
        });
      };
    }
  }, [a, s, $]);
}
function useWinClick(a, s, $, _, _e, tt, nt, at) {
  var ot = reactExports.useRef(a), rt = reactExports.useRef(!1);
  ot.current !== a && (rt.current = !0, ot.current = a), reactExports.useEffect(function() {
    var st = wrapperRaf(function() {
      rt.current = !1;
    });
    return function() {
      wrapperRaf.cancel(st);
    };
  }, [a]), reactExports.useEffect(function() {
    if (s && _ && (!_e || tt)) {
      var st = function() {
        var vt = !1, At = function(Et) {
          var St = Et.target;
          vt = nt(St);
        }, xt = function(Et) {
          var St = Et.target;
          !rt.current && ot.current && !vt && !nt(St) && at(!1);
        };
        return [At, xt];
      }, lt = st(), et = _slicedToArray$e(lt, 2), it = et[0], ut = et[1], ft = st(), ht = _slicedToArray$e(ft, 2), dt = ht[0], gt = ht[1], pt = getWin(_);
      pt.addEventListener("mousedown", it, !0), pt.addEventListener("click", ut, !0), pt.addEventListener("contextmenu", ut, !0);
      var mt = getShadowRoot$1($);
      return mt && (mt.addEventListener("mousedown", dt, !0), mt.addEventListener("click", gt, !0), mt.addEventListener("contextmenu", gt, !0)), function() {
        pt.removeEventListener("mousedown", it, !0), pt.removeEventListener("click", ut, !0), pt.removeEventListener("contextmenu", ut, !0), mt && (mt.removeEventListener("mousedown", dt, !0), mt.removeEventListener("click", gt, !0), mt.removeEventListener("contextmenu", gt, !0));
      };
    }
  }, [s, $, _, _e, tt]);
}
var _excluded$N = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function generateTrigger() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Portal, s = /* @__PURE__ */ reactExports.forwardRef(function($, _) {
    var _e = $.prefixCls, tt = _e === void 0 ? "rc-trigger-popup" : _e, nt = $.children, at = $.action, ot = at === void 0 ? "hover" : at, rt = $.showAction, st = $.hideAction, lt = $.popupVisible, et = $.defaultPopupVisible, it = $.onPopupVisibleChange, ut = $.afterPopupVisibleChange, ft = $.mouseEnterDelay, ht = $.mouseLeaveDelay, dt = ht === void 0 ? 0.1 : ht, gt = $.focusDelay, pt = $.blurDelay, mt = $.mask, ct = $.maskClosable, vt = ct === void 0 ? !0 : ct, At = $.getPopupContainer, xt = $.forceRender, bt = $.autoDestroy, Et = $.destroyPopupOnHide, St = $.popup, Bt = $.popupClassName, Ot = $.popupStyle, Pt = $.popupPlacement, wt = $.builtinPlacements, Ct = wt === void 0 ? {} : wt, It = $.popupAlign, yt = $.zIndex, Rt = $.stretch, kt = $.getPopupClassNameFromAlign, jt = $.fresh, Ht = $.alignPoint, Ft = $.onPopupClick, _t = $.onPopupAlign, Nt = $.arrow, Mt = $.popupMotion, Lt = $.maskMotion, $t = $.popupTransitionName, Tt = $.popupAnimation, Dt = $.maskTransitionName, Ut = $.maskAnimation, Vt = $.className, Qt = $.getTriggerDOMNode, qt = _objectWithoutProperties$1($, _excluded$N), Zt = bt || Et || !1, ar = reactExports.useState(!1), Jt = _slicedToArray$e(ar, 2), rr = Jt[0], Yt = Jt[1];
    useLayoutEffect$1(function() {
      Yt(isMobile$1());
    }, []);
    var Kt = reactExports.useRef({}), nr = reactExports.useContext(TriggerContext), tr = reactExports.useMemo(function() {
      return {
        registerSubPopup: function(kn, Yn) {
          Kt.current[kn] = Yn, nr == null || nr.registerSubPopup(kn, Yn);
        }
      };
    }, [nr]), ir = useId$2(), sr = reactExports.useState(null), cr = _slicedToArray$e(sr, 2), or = cr[0], Xt = cr[1], Gt = useEvent(function(Rn) {
      isDOM(Rn) && or !== Rn && Xt(Rn), nr == null || nr.registerSubPopup(ir, Rn);
    }), Wt = reactExports.useState(null), er = _slicedToArray$e(Wt, 2), lr = er[0], ur = er[1], pr = reactExports.useRef(null), yr = useEvent(function(Rn) {
      isDOM(Rn) && lr !== Rn && (ur(Rn), pr.current = Rn);
    }), Er = reactExports.Children.only(nt), br = (Er == null ? void 0 : Er.props) || {}, gr = {}, Ar = useEvent(function(Rn) {
      var kn, Yn, _a = lr;
      return (_a == null ? void 0 : _a.contains(Rn)) || ((kn = getShadowRoot$1(_a)) === null || kn === void 0 ? void 0 : kn.host) === Rn || Rn === _a || (or == null ? void 0 : or.contains(Rn)) || ((Yn = getShadowRoot$1(or)) === null || Yn === void 0 ? void 0 : Yn.host) === Rn || Rn === or || Object.values(Kt.current).some(function(Qn) {
        return (Qn == null ? void 0 : Qn.contains(Rn)) || Rn === Qn;
      });
    }), Sr = getMotion$1(tt, Mt, Tt, $t), Br = getMotion$1(tt, Lt, Ut, Dt), Ir = reactExports.useState(et || !1), hr = _slicedToArray$e(Ir, 2), vr = hr[0], xr = hr[1], Pr = lt ?? vr, Rr = useEvent(function(Rn) {
      lt === void 0 && xr(Rn);
    });
    useLayoutEffect$1(function() {
      xr(lt || !1);
    }, [lt]);
    var Dr = reactExports.useRef(Pr);
    Dr.current = Pr;
    var Gr = reactExports.useRef([]);
    Gr.current = [];
    var Or = useEvent(function(Rn) {
      var kn;
      Rr(Rn), ((kn = Gr.current[Gr.current.length - 1]) !== null && kn !== void 0 ? kn : Pr) !== Rn && (Gr.current.push(Rn), it == null || it(Rn));
    }), Hr = reactExports.useRef(), jr = function() {
      clearTimeout(Hr.current);
    }, Tr = function(kn) {
      var Yn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      jr(), Yn === 0 ? Or(kn) : Hr.current = setTimeout(function() {
        Or(kn);
      }, Yn * 1e3);
    };
    reactExports.useEffect(function() {
      return jr;
    }, []);
    var fr = reactExports.useState(!1), Cr = _slicedToArray$e(fr, 2), $r = Cr[0], wr = Cr[1];
    useLayoutEffect$1(function(Rn) {
      (!Rn || Pr) && wr(!0);
    }, [Pr]);
    var Mr = reactExports.useState(null), Fr = _slicedToArray$e(Mr, 2), Qr = Fr[0], Yr = Fr[1], kr = reactExports.useState([0, 0]), Nr = _slicedToArray$e(kr, 2), Lr = Nr[0], zr = Nr[1], Vr = function(kn) {
      zr([kn.clientX, kn.clientY]);
    }, an = useAlign(Pr, or, Ht ? Lr : lr, Pt, Ct, It, _t), Zr = _slicedToArray$e(an, 11), un = Zr[0], Xr = Zr[1], Kr = Zr[2], rn = Zr[3], nn = Zr[4], sn = Zr[5], gn = Zr[6], en = Zr[7], Wr = Zr[8], dn = Zr[9], hn = Zr[10], En = useAction(rr, ot, rt, st), bn = _slicedToArray$e(En, 2), Cn = bn[0], wn = bn[1], vn = Cn.has("click"), fn = wn.has("click") || wn.has("contextMenu"), on = useEvent(function() {
      $r || hn();
    }), pn = function() {
      Dr.current && Ht && fn && Tr(!1);
    };
    useWatch(Pr, lr, or, on, pn), useLayoutEffect$1(function() {
      on();
    }, [Lr, Pt]), useLayoutEffect$1(function() {
      Pr && !(Ct != null && Ct[Pt]) && on();
    }, [JSON.stringify(It)]);
    var mn = reactExports.useMemo(function() {
      var Rn = getAlignPopupClassName(Ct, tt, dn, Ht);
      return classnames(Rn, kt == null ? void 0 : kt(dn));
    }, [dn, kt, Ct, tt, Ht]);
    reactExports.useImperativeHandle(_, function() {
      return {
        nativeElement: pr.current,
        forceAlign: on
      };
    });
    var Pn = reactExports.useState(0), An = _slicedToArray$e(Pn, 2), yn = An[0], Bn = An[1], Fn = reactExports.useState(0), zn = _slicedToArray$e(Fn, 2), Zn = zn[0], to = zn[1], Mn = function() {
      if (Rt && lr) {
        var kn = lr.getBoundingClientRect();
        Bn(kn.width), to(kn.height);
      }
    }, Nn = function() {
      Mn(), on();
    }, Wn = function(kn) {
      wr(!1), hn(), ut == null || ut(kn);
    }, ca = function() {
      return new Promise(function(kn) {
        Mn(), Yr(function() {
          return kn;
        });
      });
    };
    useLayoutEffect$1(function() {
      Qr && (hn(), Qr(), Yr(null));
    }, [Qr]);
    function qn(Rn, kn, Yn, _a) {
      gr[Rn] = function(Qn) {
        var Eo;
        _a == null || _a(Qn), Tr(kn, Yn);
        for (var vo = arguments.length, Jr = new Array(vo > 1 ? vo - 1 : 0), zt = 1; zt < vo; zt++)
          Jr[zt - 1] = arguments[zt];
        (Eo = br[Rn]) === null || Eo === void 0 || Eo.call.apply(Eo, [br, Qn].concat(Jr));
      };
    }
    (vn || fn) && (gr.onClick = function(Rn) {
      var kn;
      Dr.current && fn ? Tr(!1) : !Dr.current && vn && (Vr(Rn), Tr(!0));
      for (var Yn = arguments.length, _a = new Array(Yn > 1 ? Yn - 1 : 0), Qn = 1; Qn < Yn; Qn++)
        _a[Qn - 1] = arguments[Qn];
      (kn = br.onClick) === null || kn === void 0 || kn.call.apply(kn, [br, Rn].concat(_a));
    }), useWinClick(Pr, fn, lr, or, mt, vt, Ar, Tr);
    var eo = Cn.has("hover"), ro = wn.has("hover"), ao, so;
    eo && (qn("onMouseEnter", !0, ft, function(Rn) {
      Vr(Rn);
    }), qn("onPointerEnter", !0, ft, function(Rn) {
      Vr(Rn);
    }), ao = function() {
      (Pr || $r) && Tr(!0, ft);
    }, Ht && (gr.onMouseMove = function(Rn) {
      var kn;
      (kn = br.onMouseMove) === null || kn === void 0 || kn.call(br, Rn);
    })), ro && (qn("onMouseLeave", !1, dt), qn("onPointerLeave", !1, dt), so = function() {
      Tr(!1, dt);
    }), Cn.has("focus") && qn("onFocus", !0, gt), wn.has("focus") && qn("onBlur", !1, pt), Cn.has("contextMenu") && (gr.onContextMenu = function(Rn) {
      var kn;
      Dr.current && wn.has("contextMenu") ? Tr(!1) : (Vr(Rn), Tr(!0)), Rn.preventDefault();
      for (var Yn = arguments.length, _a = new Array(Yn > 1 ? Yn - 1 : 0), Qn = 1; Qn < Yn; Qn++)
        _a[Qn - 1] = arguments[Qn];
      (kn = br.onContextMenu) === null || kn === void 0 || kn.call.apply(kn, [br, Rn].concat(_a));
    }), Vt && (gr.className = classnames(br.className, Vt));
    var lo = _objectSpread2$a(_objectSpread2$a({}, br), gr), Ao = {}, uo = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    uo.forEach(function(Rn) {
      qt[Rn] && (Ao[Rn] = function() {
        for (var kn, Yn = arguments.length, _a = new Array(Yn), Qn = 0; Qn < Yn; Qn++)
          _a[Qn] = arguments[Qn];
        (kn = lo[Rn]) === null || kn === void 0 || kn.call.apply(kn, [lo].concat(_a)), qt[Rn].apply(qt, _a);
      });
    });
    var wo = /* @__PURE__ */ reactExports.cloneElement(Er, _objectSpread2$a(_objectSpread2$a({}, lo), Ao)), $o = {
      x: sn,
      y: gn
    }, yo = Nt ? _objectSpread2$a({}, Nt !== !0 ? Nt : {}) : null;
    return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
      disabled: !Pr,
      ref: yr,
      onResize: Nn
    }, /* @__PURE__ */ reactExports.createElement(TriggerWrapper, {
      getTriggerDOMNode: Qt
    }, wo)), /* @__PURE__ */ reactExports.createElement(TriggerContext.Provider, {
      value: tr
    }, /* @__PURE__ */ reactExports.createElement(Popup$2, {
      portal: a,
      ref: Gt,
      prefixCls: tt,
      popup: St,
      className: classnames(Bt, mn),
      style: Ot,
      target: lr,
      onMouseEnter: ao,
      onMouseLeave: so,
      onPointerEnter: ao,
      zIndex: yt,
      open: Pr,
      keepDom: $r,
      fresh: jt,
      onClick: Ft,
      mask: mt,
      motion: Sr,
      maskMotion: Br,
      onVisibleChanged: Wn,
      onPrepare: ca,
      forceRender: xt,
      autoDestroy: Zt,
      getPopupContainer: At,
      align: dn,
      arrow: yo,
      arrowPos: $o,
      ready: un,
      offsetX: Xr,
      offsetY: Kr,
      offsetR: rn,
      offsetB: nn,
      onAlign: on,
      stretch: Rt,
      targetWidth: yn / en,
      targetHeight: Zn / Wr
    })));
  });
  return s;
}
const Trigger$1 = generateTrigger(Portal);
var _excluded$M = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], getBuiltInPlacements$1 = function a(s) {
  var $ = s === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: $,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: $,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: $,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: $,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, SelectTrigger = function a(s, $) {
  var _ = s.prefixCls;
  s.disabled;
  var _e = s.visible, tt = s.children, nt = s.popupElement, at = s.animation, ot = s.transitionName, rt = s.dropdownStyle, st = s.dropdownClassName, lt = s.direction, et = lt === void 0 ? "ltr" : lt, it = s.placement, ut = s.builtinPlacements, ft = s.dropdownMatchSelectWidth, ht = s.dropdownRender, dt = s.dropdownAlign, gt = s.getPopupContainer, pt = s.empty, mt = s.getTriggerDOMNode, ct = s.onPopupVisibleChange, vt = s.onPopupMouseEnter, At = _objectWithoutProperties$1(s, _excluded$M), xt = "".concat(_, "-dropdown"), bt = nt;
  ht && (bt = ht(nt));
  var Et = reactExports.useMemo(function() {
    return ut || getBuiltInPlacements$1(ft);
  }, [ut, ft]), St = at ? "".concat(xt, "-").concat(at) : ot, Bt = typeof ft == "number", Ot = reactExports.useMemo(function() {
    return Bt ? null : ft === !1 ? "minWidth" : "width";
  }, [ft, Bt]), Pt = rt;
  Bt && (Pt = _objectSpread2$a(_objectSpread2$a({}, Pt), {}, {
    width: ft
  }));
  var wt = reactExports.useRef(null);
  return reactExports.useImperativeHandle($, function() {
    return {
      getPopupElement: function() {
        return wt.current;
      }
    };
  }), /* @__PURE__ */ reactExports.createElement(Trigger$1, _extends$2({}, At, {
    showAction: ct ? ["click"] : [],
    hideAction: ct ? ["click"] : [],
    popupPlacement: it || (et === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: Et,
    prefixCls: xt,
    popupTransitionName: St,
    popup: /* @__PURE__ */ reactExports.createElement("div", {
      ref: wt,
      onMouseEnter: vt
    }, bt),
    stretch: Ot,
    popupAlign: dt,
    popupVisible: _e,
    getPopupContainer: gt,
    popupClassName: classnames(st, _defineProperty$c({}, "".concat(xt, "-empty"), pt)),
    popupStyle: Pt,
    getTriggerDOMNode: mt,
    onPopupVisibleChange: ct
  }), tt);
}, RefSelectTrigger = /* @__PURE__ */ reactExports.forwardRef(SelectTrigger);
RefSelectTrigger.displayName = "SelectTrigger";
function getKey$2(a, s) {
  var $ = a.key, _;
  return "value" in a && (_ = a.value), $ ?? (_ !== void 0 ? _ : "rc-index-key-".concat(s));
}
function fillFieldNames$2(a, s) {
  var $ = a || {}, _ = $.label, _e = $.value, tt = $.options, nt = $.groupLabel, at = _ || (s ? "children" : "label");
  return {
    label: at,
    value: _e || "value",
    options: tt || "options",
    groupLabel: nt || at
  };
}
function flattenOptions(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, $ = s.fieldNames, _ = s.childrenAsData, _e = [], tt = fillFieldNames$2($, !1), nt = tt.label, at = tt.value, ot = tt.options, rt = tt.groupLabel;
  function st(lt, et) {
    lt.forEach(function(it) {
      if (et || !(ot in it)) {
        var ut = it[at];
        _e.push({
          key: getKey$2(it, _e.length),
          groupOption: et,
          data: it,
          label: it[nt],
          value: ut
        });
      } else {
        var ft = it[rt];
        ft === void 0 && _ && (ft = it.label), _e.push({
          key: getKey$2(it, _e.length),
          group: !0,
          data: it,
          label: ft
        }), st(it[ot], !0);
      }
    });
  }
  return st(a, !1), _e;
}
function injectPropsWithOption(a) {
  var s = _objectSpread2$a({}, a);
  return "props" in s || Object.defineProperty(s, "props", {
    get: function() {
      return warningOnce(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), s;
    }
  }), s;
}
function getSeparatedContent(a, s) {
  if (!s || !s.length)
    return null;
  var $ = !1;
  function _(tt, nt) {
    var at = _toArray$1(nt), ot = at[0], rt = at.slice(1);
    if (!ot)
      return [tt];
    var st = tt.split(ot);
    return $ = $ || st.length > 1, st.reduce(function(lt, et) {
      return [].concat(_toConsumableArray$d(lt), _toConsumableArray$d(_(et, rt)));
    }, []).filter(function(lt) {
      return lt;
    });
  }
  var _e = _(a, s);
  return $ ? _e : null;
}
var _excluded$L = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], DEFAULT_OMIT_PROPS = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"];
function isMultiple(a) {
  return a === "tags" || a === "multiple";
}
var BaseSelect = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _, _e = a.id, tt = a.prefixCls, nt = a.className, at = a.showSearch, ot = a.tagRender, rt = a.direction, st = a.omitDomProps, lt = a.displayValues, et = a.onDisplayValuesChange, it = a.emptyOptions, ut = a.notFoundContent, ft = ut === void 0 ? "Not Found" : ut, ht = a.onClear, dt = a.mode, gt = a.disabled, pt = a.loading, mt = a.getInputElement, ct = a.getRawInputElement, vt = a.open, At = a.defaultOpen, xt = a.onDropdownVisibleChange, bt = a.activeValue, Et = a.onActiveValueChange, St = a.activeDescendantId, Bt = a.searchValue, Ot = a.autoClearSearchValue, Pt = a.onSearch, wt = a.onSearchSplit, Ct = a.tokenSeparators, It = a.allowClear, yt = a.suffixIcon, Rt = a.clearIcon, kt = a.OptionList, jt = a.animation, Ht = a.transitionName, Ft = a.dropdownStyle, _t = a.dropdownClassName, Nt = a.dropdownMatchSelectWidth, Mt = a.dropdownRender, Lt = a.dropdownAlign, $t = a.placement, Tt = a.builtinPlacements, Dt = a.getPopupContainer, Ut = a.showAction, Vt = Ut === void 0 ? [] : Ut, Qt = a.onFocus, qt = a.onBlur, Zt = a.onKeyUp, ar = a.onKeyDown, Jt = a.onMouseDown, rr = _objectWithoutProperties$1(a, _excluded$L), Yt = isMultiple(dt), Kt = (at !== void 0 ? at : Yt) || dt === "combobox", nr = _objectSpread2$a({}, rr);
  DEFAULT_OMIT_PROPS.forEach(function(fn) {
    delete nr[fn];
  }), st == null || st.forEach(function(fn) {
    delete nr[fn];
  });
  var tr = reactExports.useState(!1), ir = _slicedToArray$e(tr, 2), sr = ir[0], cr = ir[1];
  reactExports.useEffect(function() {
    cr(isMobile$1());
  }, []);
  var or = reactExports.useRef(null), Xt = reactExports.useRef(null), Gt = reactExports.useRef(null), Wt = reactExports.useRef(null), er = reactExports.useRef(null), lr = reactExports.useRef(!1), ur = useDelayReset(), pr = _slicedToArray$e(ur, 3), yr = pr[0], Er = pr[1], br = pr[2];
  reactExports.useImperativeHandle(s, function() {
    var fn, on;
    return {
      focus: (fn = Wt.current) === null || fn === void 0 ? void 0 : fn.focus,
      blur: (on = Wt.current) === null || on === void 0 ? void 0 : on.blur,
      scrollTo: function(mn) {
        var Pn;
        return (Pn = er.current) === null || Pn === void 0 ? void 0 : Pn.scrollTo(mn);
      }
    };
  });
  var gr = reactExports.useMemo(function() {
    var fn;
    if (dt !== "combobox")
      return Bt;
    var on = (fn = lt[0]) === null || fn === void 0 ? void 0 : fn.value;
    return typeof on == "string" || typeof on == "number" ? String(on) : "";
  }, [Bt, dt, lt]), Ar = dt === "combobox" && typeof mt == "function" && mt() || null, Sr = typeof ct == "function" && ct(), Br = useComposeRef(Xt, Sr == null || ($ = Sr.props) === null || $ === void 0 ? void 0 : $.ref), Ir = reactExports.useState(!1), hr = _slicedToArray$e(Ir, 2), vr = hr[0], xr = hr[1];
  useLayoutEffect$1(function() {
    xr(!0);
  }, []);
  var Pr = useMergedState(!1, {
    defaultValue: At,
    value: vt
  }), Rr = _slicedToArray$e(Pr, 2), Dr = Rr[0], Gr = Rr[1], Or = vr ? Dr : !1, Hr = !ft && it;
  (gt || Hr && Or && dt === "combobox") && (Or = !1);
  var jr = Hr ? !1 : Or, Tr = reactExports.useCallback(function(fn) {
    var on = fn !== void 0 ? fn : !Or;
    gt || (Gr(on), Or !== on && (xt == null || xt(on)));
  }, [gt, Or, Gr, xt]), fr = reactExports.useMemo(function() {
    return (Ct || []).some(function(fn) {
      return [`
`, `\r
`].includes(fn);
    });
  }, [Ct]), Cr = function(on, pn, mn) {
    var Pn = !0, An = on;
    Et == null || Et(null);
    var yn = mn ? null : getSeparatedContent(on, Ct);
    return dt !== "combobox" && yn && (An = "", wt == null || wt(yn), Tr(!1), Pn = !1), Pt && gr !== An && Pt(An, {
      source: pn ? "typing" : "effect"
    }), Pn;
  }, $r = function(on) {
    !on || !on.trim() || Pt(on, {
      source: "submit"
    });
  };
  reactExports.useEffect(function() {
    !Or && !Yt && dt !== "combobox" && Cr("", !1, !1);
  }, [Or]), reactExports.useEffect(function() {
    Dr && gt && Gr(!1), gt && !lr.current && Er(!1);
  }, [gt]);
  var wr = useLock(), Mr = _slicedToArray$e(wr, 2), Fr = Mr[0], Qr = Mr[1], Yr = function(on) {
    var pn = Fr(), mn = on.which;
    if (mn === KeyCode.ENTER && (dt !== "combobox" && on.preventDefault(), Or || Tr(!0)), Qr(!!gr), mn === KeyCode.BACKSPACE && !pn && Yt && !gr && lt.length) {
      for (var Pn = _toConsumableArray$d(lt), An = null, yn = Pn.length - 1; yn >= 0; yn -= 1) {
        var Bn = Pn[yn];
        if (!Bn.disabled) {
          Pn.splice(yn, 1), An = Bn;
          break;
        }
      }
      An && et(Pn, {
        type: "remove",
        values: [An]
      });
    }
    for (var Fn = arguments.length, zn = new Array(Fn > 1 ? Fn - 1 : 0), Zn = 1; Zn < Fn; Zn++)
      zn[Zn - 1] = arguments[Zn];
    if (Or && er.current) {
      var to;
      (to = er.current).onKeyDown.apply(to, [on].concat(zn));
    }
    ar == null || ar.apply(void 0, [on].concat(zn));
  }, kr = function(on) {
    for (var pn = arguments.length, mn = new Array(pn > 1 ? pn - 1 : 0), Pn = 1; Pn < pn; Pn++)
      mn[Pn - 1] = arguments[Pn];
    if (Or && er.current) {
      var An;
      (An = er.current).onKeyUp.apply(An, [on].concat(mn));
    }
    Zt == null || Zt.apply(void 0, [on].concat(mn));
  }, Nr = function(on) {
    var pn = lt.filter(function(mn) {
      return mn !== on;
    });
    et(pn, {
      type: "remove",
      values: [on]
    });
  }, Lr = reactExports.useRef(!1), zr = function() {
    Er(!0), gt || (Qt && !Lr.current && Qt.apply(void 0, arguments), Vt.includes("focus") && Tr(!0)), Lr.current = !0;
  }, Vr = function() {
    lr.current = !0, Er(!1, function() {
      Lr.current = !1, lr.current = !1, Tr(!1);
    }), !gt && (gr && (dt === "tags" ? Pt(gr, {
      source: "submit"
    }) : dt === "multiple" && Pt("", {
      source: "blur"
    })), qt && qt.apply(void 0, arguments));
  }, an = [];
  reactExports.useEffect(function() {
    return function() {
      an.forEach(function(fn) {
        return clearTimeout(fn);
      }), an.splice(0, an.length);
    };
  }, []);
  var Zr = function(on) {
    var pn, mn = on.target, Pn = (pn = Gt.current) === null || pn === void 0 ? void 0 : pn.getPopupElement();
    if (Pn && Pn.contains(mn)) {
      var An = setTimeout(function() {
        var zn = an.indexOf(An);
        if (zn !== -1 && an.splice(zn, 1), br(), !sr && !Pn.contains(document.activeElement)) {
          var Zn;
          (Zn = Wt.current) === null || Zn === void 0 || Zn.focus();
        }
      });
      an.push(An);
    }
    for (var yn = arguments.length, Bn = new Array(yn > 1 ? yn - 1 : 0), Fn = 1; Fn < yn; Fn++)
      Bn[Fn - 1] = arguments[Fn];
    Jt == null || Jt.apply(void 0, [on].concat(Bn));
  }, un = reactExports.useState({}), Xr = _slicedToArray$e(un, 2), Kr = Xr[1];
  function rn() {
    Kr({});
  }
  var nn;
  Sr && (nn = function(on) {
    Tr(on);
  }), useSelectTriggerControl(function() {
    var fn;
    return [or.current, (fn = Gt.current) === null || fn === void 0 ? void 0 : fn.getPopupElement()];
  }, jr, Tr, !!Sr);
  var sn = reactExports.useMemo(function() {
    return _objectSpread2$a(_objectSpread2$a({}, a), {}, {
      notFoundContent: ft,
      open: Or,
      triggerOpen: jr,
      id: _e,
      showSearch: Kt,
      multiple: Yt,
      toggleOpen: Tr
    });
  }, [a, ft, jr, Or, _e, Kt, Yt, Tr]), gn = !!yt || pt, en;
  gn && (en = /* @__PURE__ */ reactExports.createElement(TransBtn, {
    className: classnames("".concat(tt, "-arrow"), _defineProperty$c({}, "".concat(tt, "-arrow-loading"), pt)),
    customizeIcon: yt,
    customizeIconProps: {
      loading: pt,
      searchValue: gr,
      open: Or,
      focused: yr,
      showSearch: Kt
    }
  }));
  var Wr = function() {
    var on;
    ht == null || ht(), (on = Wt.current) === null || on === void 0 || on.focus(), et([], {
      type: "clear",
      values: lt
    }), Cr("", !1, !1);
  }, dn = useAllowClear(tt, Wr, lt, It, Rt, gt, gr, dt), hn = dn.allowClear, En = dn.clearIcon, bn = /* @__PURE__ */ reactExports.createElement(kt, {
    ref: er
  }), Cn = classnames(tt, nt, (_ = {}, _defineProperty$c(_, "".concat(tt, "-focused"), yr), _defineProperty$c(_, "".concat(tt, "-multiple"), Yt), _defineProperty$c(_, "".concat(tt, "-single"), !Yt), _defineProperty$c(_, "".concat(tt, "-allow-clear"), It), _defineProperty$c(_, "".concat(tt, "-show-arrow"), gn), _defineProperty$c(_, "".concat(tt, "-disabled"), gt), _defineProperty$c(_, "".concat(tt, "-loading"), pt), _defineProperty$c(_, "".concat(tt, "-open"), Or), _defineProperty$c(_, "".concat(tt, "-customize-input"), Ar), _defineProperty$c(_, "".concat(tt, "-show-search"), Kt), _)), wn = /* @__PURE__ */ reactExports.createElement(RefSelectTrigger, {
    ref: Gt,
    disabled: gt,
    prefixCls: tt,
    visible: jr,
    popupElement: bn,
    animation: jt,
    transitionName: Ht,
    dropdownStyle: Ft,
    dropdownClassName: _t,
    direction: rt,
    dropdownMatchSelectWidth: Nt,
    dropdownRender: Mt,
    dropdownAlign: Lt,
    placement: $t,
    builtinPlacements: Tt,
    getPopupContainer: Dt,
    empty: it,
    getTriggerDOMNode: function() {
      return Xt.current;
    },
    onPopupVisibleChange: nn,
    onPopupMouseEnter: rn
  }, Sr ? /* @__PURE__ */ reactExports.cloneElement(Sr, {
    ref: Br
  }) : /* @__PURE__ */ reactExports.createElement(ForwardSelector, _extends$2({}, a, {
    domRef: Xt,
    prefixCls: tt,
    inputElement: Ar,
    ref: Wt,
    id: _e,
    showSearch: Kt,
    autoClearSearchValue: Ot,
    mode: dt,
    activeDescendantId: St,
    tagRender: ot,
    values: lt,
    open: Or,
    onToggleOpen: Tr,
    activeValue: bt,
    searchValue: gr,
    onSearch: Cr,
    onSearchSubmit: $r,
    onRemove: Nr,
    tokenWithEnter: fr
  }))), vn;
  return Sr ? vn = wn : vn = /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    className: Cn
  }, nr, {
    ref: or,
    onMouseDown: Zr,
    onKeyDown: Yr,
    onKeyUp: kr,
    onFocus: zr,
    onBlur: Vr
  }), yr && !Or && /* @__PURE__ */ reactExports.createElement("span", {
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    },
    "aria-live": "polite"
  }, "".concat(lt.map(function(fn) {
    var on = fn.label, pn = fn.value;
    return ["number", "string"].includes(_typeof$q(on)) ? on : pn;
  }).join(", "))), wn, en, hn && En), /* @__PURE__ */ reactExports.createElement(BaseSelectContext.Provider, {
    value: sn
  }, vn);
}), OptGroup = function a() {
  return null;
};
OptGroup.isSelectOptGroup = !0;
var Option = function a() {
  return null;
};
Option.isSelectOption = !0;
var Filler = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.height, _ = a.offsetY, _e = a.offsetX, tt = a.children, nt = a.prefixCls, at = a.onInnerResize, ot = a.innerProps, rt = a.rtl, st = a.extra, lt = {}, et = {
    display: "flex",
    flexDirection: "column"
  };
  if (_ !== void 0) {
    var it;
    lt = {
      height: $,
      position: "relative",
      overflow: "hidden"
    }, et = _objectSpread2$a(_objectSpread2$a({}, et), {}, (it = {
      transform: "translateY(".concat(_, "px)")
    }, _defineProperty$c(it, rt ? "marginRight" : "marginLeft", -_e), _defineProperty$c(it, "position", "absolute"), _defineProperty$c(it, "left", 0), _defineProperty$c(it, "right", 0), _defineProperty$c(it, "top", 0), it));
  }
  return /* @__PURE__ */ reactExports.createElement("div", {
    style: lt
  }, /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: function(ft) {
      var ht = ft.offsetHeight;
      ht && at && at();
    }
  }, /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    style: et,
    className: classnames(_defineProperty$c({}, "".concat(nt, "-holder-inner"), nt)),
    ref: s
  }, ot), tt, st)));
});
Filler.displayName = "Filler";
function getPageXY(a, s) {
  var $ = "touches" in a ? a.touches[0] : a;
  return $[s ? "pageX" : "pageY"];
}
var ScrollBar = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _ = a.prefixCls, _e = a.rtl, tt = a.scrollOffset, nt = a.scrollRange, at = a.onStartMove, ot = a.onStopMove, rt = a.onScroll, st = a.horizontal, lt = a.spinSize, et = a.containerSize, it = a.style, ut = a.thumbStyle, ft = reactExports.useState(!1), ht = _slicedToArray$e(ft, 2), dt = ht[0], gt = ht[1], pt = reactExports.useState(null), mt = _slicedToArray$e(pt, 2), ct = mt[0], vt = mt[1], At = reactExports.useState(null), xt = _slicedToArray$e(At, 2), bt = xt[0], Et = xt[1], St = !_e, Bt = reactExports.useRef(), Ot = reactExports.useRef(), Pt = reactExports.useState(!1), wt = _slicedToArray$e(Pt, 2), Ct = wt[0], It = wt[1], yt = reactExports.useRef(), Rt = function() {
    clearTimeout(yt.current), It(!0), yt.current = setTimeout(function() {
      It(!1);
    }, 3e3);
  }, kt = nt - et || 0, jt = et - lt || 0, Ht = kt > 0, Ft = reactExports.useMemo(function() {
    if (tt === 0 || kt === 0)
      return 0;
    var Vt = tt / kt;
    return Vt * jt;
  }, [tt, kt, jt]), _t = function(Qt) {
    Qt.stopPropagation(), Qt.preventDefault();
  }, Nt = reactExports.useRef({
    top: Ft,
    dragging: dt,
    pageY: ct,
    startTop: bt
  });
  Nt.current = {
    top: Ft,
    dragging: dt,
    pageY: ct,
    startTop: bt
  };
  var Mt = function(Qt) {
    gt(!0), vt(getPageXY(Qt, st)), Et(Nt.current.top), at(), Qt.stopPropagation(), Qt.preventDefault();
  };
  reactExports.useEffect(function() {
    var Vt = function(ar) {
      ar.preventDefault();
    }, Qt = Bt.current, qt = Ot.current;
    return Qt.addEventListener("touchstart", Vt), qt.addEventListener("touchstart", Mt), function() {
      Qt.removeEventListener("touchstart", Vt), qt.removeEventListener("touchstart", Mt);
    };
  }, []);
  var Lt = reactExports.useRef();
  Lt.current = kt;
  var $t = reactExports.useRef();
  $t.current = jt, reactExports.useEffect(function() {
    if (dt) {
      var Vt, Qt = function(ar) {
        var Jt = Nt.current, rr = Jt.dragging, Yt = Jt.pageY, Kt = Jt.startTop;
        if (wrapperRaf.cancel(Vt), rr) {
          var nr = getPageXY(ar, st) - Yt, tr = Kt;
          !St && st ? tr -= nr : tr += nr;
          var ir = Lt.current, sr = $t.current, cr = sr ? tr / sr : 0, or = Math.ceil(cr * ir);
          or = Math.max(or, 0), or = Math.min(or, ir), Vt = wrapperRaf(function() {
            rt(or, st);
          });
        }
      }, qt = function() {
        gt(!1), ot();
      };
      return window.addEventListener("mousemove", Qt), window.addEventListener("touchmove", Qt), window.addEventListener("mouseup", qt), window.addEventListener("touchend", qt), function() {
        window.removeEventListener("mousemove", Qt), window.removeEventListener("touchmove", Qt), window.removeEventListener("mouseup", qt), window.removeEventListener("touchend", qt), wrapperRaf.cancel(Vt);
      };
    }
  }, [dt]), reactExports.useEffect(function() {
    Rt();
  }, [tt]), reactExports.useImperativeHandle(s, function() {
    return {
      delayHidden: Rt
    };
  });
  var Tt = "".concat(_, "-scrollbar"), Dt = {
    position: "absolute",
    visibility: Ct && Ht ? null : "hidden"
  }, Ut = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return st ? (Dt.height = 8, Dt.left = 0, Dt.right = 0, Dt.bottom = 0, Ut.height = "100%", Ut.width = lt, St ? Ut.left = Ft : Ut.right = Ft) : (Dt.width = 8, Dt.top = 0, Dt.bottom = 0, St ? Dt.right = 0 : Dt.left = 0, Ut.width = "100%", Ut.height = lt, Ut.top = Ft), /* @__PURE__ */ reactExports.createElement("div", {
    ref: Bt,
    className: classnames(Tt, ($ = {}, _defineProperty$c($, "".concat(Tt, "-horizontal"), st), _defineProperty$c($, "".concat(Tt, "-vertical"), !st), _defineProperty$c($, "".concat(Tt, "-visible"), Ct), $)),
    style: _objectSpread2$a(_objectSpread2$a({}, Dt), it),
    onMouseDown: _t,
    onMouseMove: Rt
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: Ot,
    className: classnames("".concat(Tt, "-thumb"), _defineProperty$c({}, "".concat(Tt, "-thumb-moving"), dt)),
    style: _objectSpread2$a(_objectSpread2$a({}, Ut), ut),
    onMouseDown: Mt
  }));
});
function Item$6(a) {
  var s = a.children, $ = a.setRef, _ = reactExports.useCallback(function(_e) {
    $(_e);
  }, []);
  return /* @__PURE__ */ reactExports.cloneElement(s, {
    ref: _
  });
}
function useChildren$1(a, s, $, _, _e, tt, nt) {
  var at = nt.getKey;
  return a.slice(s, $ + 1).map(function(ot, rt) {
    var st = s + rt, lt = tt(ot, st, {
      style: {
        width: _
      }
    }), et = at(ot);
    return /* @__PURE__ */ reactExports.createElement(Item$6, {
      key: et,
      setRef: function(ut) {
        return _e(ot, ut);
      }
    }, lt);
  });
}
var CacheMap = /* @__PURE__ */ function() {
  function a() {
    _classCallCheck(this, a), this.maps = void 0, this.id = 0, this.maps = /* @__PURE__ */ Object.create(null);
  }
  return _createClass(a, [{
    key: "set",
    value: function($, _) {
      this.maps[$] = _, this.id += 1;
    }
  }, {
    key: "get",
    value: function($) {
      return this.maps[$];
    }
  }]), a;
}();
function useHeights(a, s, $) {
  var _ = reactExports.useState(0), _e = _slicedToArray$e(_, 2), tt = _e[0], nt = _e[1], at = reactExports.useRef(/* @__PURE__ */ new Map()), ot = reactExports.useRef(new CacheMap()), rt = reactExports.useRef();
  function st() {
    wrapperRaf.cancel(rt.current);
  }
  function lt() {
    var it = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    st();
    var ut = function() {
      at.current.forEach(function(ht, dt) {
        if (ht && ht.offsetParent) {
          var gt = findDOMNode(ht), pt = gt.offsetHeight;
          ot.current.get(dt) !== pt && ot.current.set(dt, gt.offsetHeight);
        }
      }), nt(function(ht) {
        return ht + 1;
      });
    };
    it ? ut() : rt.current = wrapperRaf(ut);
  }
  function et(it, ut) {
    var ft = a(it), ht = at.current.get(ft);
    ut ? (at.current.set(ft, ut), lt()) : at.current.delete(ft), !ht != !ut && (ut ? s == null || s(it) : $ == null || $(it));
  }
  return reactExports.useEffect(function() {
    return st;
  }, []), [et, lt, ot.current, tt];
}
var MAX_TIMES = 10;
function useScrollTo(a, s, $, _, _e, tt, nt, at) {
  var ot = reactExports.useRef(), rt = reactExports.useState(null), st = _slicedToArray$e(rt, 2), lt = st[0], et = st[1];
  return useLayoutEffect$1(function() {
    if (lt && lt.times < MAX_TIMES) {
      if (!a.current) {
        et(function(Rt) {
          return _objectSpread2$a({}, Rt);
        });
        return;
      }
      tt();
      var it = lt.targetAlign, ut = lt.originAlign, ft = lt.index, ht = lt.offset, dt = a.current.clientHeight, gt = !1, pt = it, mt = null;
      if (dt) {
        for (var ct = it || ut, vt = 0, At = 0, xt = 0, bt = Math.min(s.length - 1, ft), Et = 0; Et <= bt; Et += 1) {
          var St = _e(s[Et]);
          At = vt;
          var Bt = $.get(St);
          xt = At + (Bt === void 0 ? _ : Bt), vt = xt;
        }
        for (var Ot = ct === "top" ? ht : dt - ht, Pt = bt; Pt >= 0; Pt -= 1) {
          var wt = _e(s[Pt]), Ct = $.get(wt);
          if (Ct === void 0) {
            gt = !0;
            break;
          }
          if (Ot -= Ct, Ot <= 0)
            break;
        }
        switch (ct) {
          case "top":
            mt = At - ht;
            break;
          case "bottom":
            mt = xt - dt + ht;
            break;
          default: {
            var It = a.current.scrollTop, yt = It + dt;
            At < It ? pt = "top" : xt > yt && (pt = "bottom");
          }
        }
        mt !== null && nt(mt), mt !== lt.lastTop && (gt = !0);
      }
      gt && et(_objectSpread2$a(_objectSpread2$a({}, lt), {}, {
        times: lt.times + 1,
        targetAlign: pt,
        lastTop: mt
      }));
    }
  }, [lt, a.current]), function(it) {
    if (it == null) {
      at();
      return;
    }
    if (wrapperRaf.cancel(ot.current), typeof it == "number")
      nt(it);
    else if (it && _typeof$q(it) === "object") {
      var ut, ft = it.align;
      "index" in it ? ut = it.index : ut = s.findIndex(function(gt) {
        return _e(gt) === it.key;
      });
      var ht = it.offset, dt = ht === void 0 ? 0 : ht;
      et({
        times: 0,
        index: ut,
        offset: dt,
        originAlign: ft
      });
    }
  };
}
function findListDiffIndex(a, s, $) {
  var _ = a.length, _e = s.length, tt, nt;
  if (_ === 0 && _e === 0)
    return null;
  _ < _e ? (tt = a, nt = s) : (tt = s, nt = a);
  var at = {
    __EMPTY_ITEM__: !0
  };
  function ot(ut) {
    return ut !== void 0 ? $(ut) : at;
  }
  for (var rt = null, st = Math.abs(_ - _e) !== 1, lt = 0; lt < nt.length; lt += 1) {
    var et = ot(tt[lt]), it = ot(nt[lt]);
    if (et !== it) {
      rt = lt, st = st || et !== ot(nt[lt + 1]);
      break;
    }
  }
  return rt === null ? null : {
    index: rt,
    multiple: st
  };
}
function useDiffItem(a, s, $) {
  var _ = reactExports.useState(a), _e = _slicedToArray$e(_, 2), tt = _e[0], nt = _e[1], at = reactExports.useState(null), ot = _slicedToArray$e(at, 2), rt = ot[0], st = ot[1];
  return reactExports.useEffect(function() {
    var lt = findListDiffIndex(tt || [], a || [], s);
    (lt == null ? void 0 : lt.index) !== void 0 && ($ == null || $(lt.index), st(a[lt.index])), nt(a);
  }, [a]), [rt];
}
var isFF = (typeof navigator > "u" ? "undefined" : _typeof$q(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const useOriginScroll = function(a, s) {
  var $ = reactExports.useRef(!1), _ = reactExports.useRef(null);
  function _e() {
    clearTimeout(_.current), $.current = !0, _.current = setTimeout(function() {
      $.current = !1;
    }, 50);
  }
  var tt = reactExports.useRef({
    top: a,
    bottom: s
  });
  return tt.current.top = a, tt.current.bottom = s, function(nt) {
    var at = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, ot = (
      // Pass origin wheel when on the top
      nt < 0 && tt.current.top || // Pass origin wheel when on the bottom
      nt > 0 && tt.current.bottom
    );
    return at && ot ? (clearTimeout(_.current), $.current = !1) : (!ot || $.current) && _e(), !$.current && ot;
  };
};
function useFrameWheel(a, s, $, _, _e) {
  var tt = reactExports.useRef(0), nt = reactExports.useRef(null), at = reactExports.useRef(null), ot = reactExports.useRef(!1), rt = useOriginScroll(s, $);
  function st(ht, dt) {
    wrapperRaf.cancel(nt.current), tt.current += dt, at.current = dt, !rt(dt) && (isFF || ht.preventDefault(), nt.current = wrapperRaf(function() {
      var gt = ot.current ? 10 : 1;
      _e(tt.current * gt), tt.current = 0;
    }));
  }
  function lt(ht, dt) {
    _e(dt, !0), isFF || ht.preventDefault();
  }
  var et = reactExports.useRef(null), it = reactExports.useRef(null);
  function ut(ht) {
    if (a) {
      wrapperRaf.cancel(it.current), it.current = wrapperRaf(function() {
        et.current = null;
      }, 2);
      var dt = ht.deltaX, gt = ht.deltaY, pt = ht.shiftKey, mt = dt, ct = gt;
      (et.current === "sx" || !et.current && pt && gt && !dt) && (mt = gt, ct = 0, et.current = "sx");
      var vt = Math.abs(mt), At = Math.abs(ct);
      et.current === null && (et.current = _ && vt > At ? "x" : "y"), et.current === "y" ? st(ht, ct) : lt(ht, mt);
    }
  }
  function ft(ht) {
    a && (ot.current = ht.detail === at.current);
  }
  return [ut, ft];
}
var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(a, s, $) {
  var _ = reactExports.useRef(!1), _e = reactExports.useRef(0), tt = reactExports.useRef(null), nt = reactExports.useRef(null), at, ot = function(et) {
    if (_.current) {
      var it = Math.ceil(et.touches[0].pageY), ut = _e.current - it;
      _e.current = it, $(ut) && et.preventDefault(), clearInterval(nt.current), nt.current = setInterval(function() {
        ut *= SMOOTH_PTG, (!$(ut, !0) || Math.abs(ut) <= 0.1) && clearInterval(nt.current);
      }, 16);
    }
  }, rt = function() {
    _.current = !1, at();
  }, st = function(et) {
    at(), et.touches.length === 1 && !_.current && (_.current = !0, _e.current = Math.ceil(et.touches[0].pageY), tt.current = et.target, tt.current.addEventListener("touchmove", ot), tt.current.addEventListener("touchend", rt));
  };
  at = function() {
    tt.current && (tt.current.removeEventListener("touchmove", ot), tt.current.removeEventListener("touchend", rt));
  }, useLayoutEffect$1(function() {
    return a && s.current.addEventListener("touchstart", st), function() {
      var lt;
      (lt = s.current) === null || lt === void 0 || lt.removeEventListener("touchstart", st), at(), clearInterval(nt.current);
    };
  }, [a]);
}
var MIN_SIZE = 20;
function getSpinSize() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, $ = a / s * 100;
  return isNaN($) && ($ = 0), $ = Math.max($, MIN_SIZE), $ = Math.min($, a / 2), Math.floor($);
}
function useGetSize(a, s, $, _) {
  var _e = reactExports.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [a, $.id, _]), tt = _slicedToArray$e(_e, 2), nt = tt[0], at = tt[1], ot = function(st) {
    var lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : st, et = nt.get(st), it = nt.get(lt);
    if (et === void 0 || it === void 0)
      for (var ut = a.length, ft = at.length; ft < ut; ft += 1) {
        var ht, dt = a[ft], gt = s(dt);
        nt.set(gt, ft);
        var pt = (ht = $.get(gt)) !== null && ht !== void 0 ? ht : _;
        if (at[ft] = (at[ft - 1] || 0) + pt, gt === st && (et = ft), gt === lt && (it = ft), et !== void 0 && it !== void 0)
          break;
      }
    return {
      top: at[et - 1] || 0,
      bottom: at[it]
    };
  };
  return ot;
}
var _excluded$K = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"], EMPTY_DATA$1 = [], ScrollStyle = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function RawList(a, s) {
  var $ = a.prefixCls, _ = $ === void 0 ? "rc-virtual-list" : $, _e = a.className, tt = a.height, nt = a.itemHeight, at = a.fullHeight, ot = at === void 0 ? !0 : at, rt = a.style, st = a.data, lt = a.children, et = a.itemKey, it = a.virtual, ut = a.direction, ft = a.scrollWidth, ht = a.component, dt = ht === void 0 ? "div" : ht, gt = a.onScroll, pt = a.onVirtualScroll, mt = a.onVisibleChange, ct = a.innerProps, vt = a.extraRender, At = a.styles, xt = _objectWithoutProperties$1(a, _excluded$K), bt = !!(it !== !1 && tt && nt), Et = bt && st && (nt * st.length > tt || !!ft), St = ut === "rtl", Bt = classnames(_, _defineProperty$c({}, "".concat(_, "-rtl"), St), _e), Ot = st || EMPTY_DATA$1, Pt = reactExports.useRef(), wt = reactExports.useRef(), Ct = reactExports.useState(0), It = _slicedToArray$e(Ct, 2), yt = It[0], Rt = It[1], kt = reactExports.useState(0), jt = _slicedToArray$e(kt, 2), Ht = jt[0], Ft = jt[1], _t = reactExports.useState(!1), Nt = _slicedToArray$e(_t, 2), Mt = Nt[0], Lt = Nt[1], $t = function() {
    Lt(!0);
  }, Tt = function() {
    Lt(!1);
  }, Dt = reactExports.useCallback(function(Nr) {
    return typeof et == "function" ? et(Nr) : Nr == null ? void 0 : Nr[et];
  }, [et]), Ut = {
    getKey: Dt
  };
  function Vt(Nr) {
    Rt(function(Lr) {
      var zr;
      typeof Nr == "function" ? zr = Nr(Lr) : zr = Nr;
      var Vr = Br(zr);
      return Pt.current.scrollTop = Vr, Vr;
    });
  }
  var Qt = reactExports.useRef({
    start: 0,
    end: Ot.length
  }), qt = reactExports.useRef(), Zt = useDiffItem(Ot, Dt), ar = _slicedToArray$e(Zt, 1), Jt = ar[0];
  qt.current = Jt;
  var rr = useHeights(Dt, null, null), Yt = _slicedToArray$e(rr, 4), Kt = Yt[0], nr = Yt[1], tr = Yt[2], ir = Yt[3], sr = reactExports.useMemo(function() {
    if (!bt)
      return {
        scrollHeight: void 0,
        start: 0,
        end: Ot.length - 1,
        offset: void 0
      };
    if (!Et) {
      var Nr;
      return {
        scrollHeight: ((Nr = wt.current) === null || Nr === void 0 ? void 0 : Nr.offsetHeight) || 0,
        start: 0,
        end: Ot.length - 1,
        offset: void 0
      };
    }
    for (var Lr = 0, zr, Vr, an, Zr = Ot.length, un = 0; un < Zr; un += 1) {
      var Xr = Ot[un], Kr = Dt(Xr), rn = tr.get(Kr), nn = Lr + (rn === void 0 ? nt : rn);
      nn >= yt && zr === void 0 && (zr = un, Vr = Lr), nn > yt + tt && an === void 0 && (an = un), Lr = nn;
    }
    return zr === void 0 && (zr = 0, Vr = 0, an = Math.ceil(tt / nt)), an === void 0 && (an = Ot.length - 1), an = Math.min(an + 1, Ot.length - 1), {
      scrollHeight: Lr,
      start: zr,
      end: an,
      offset: Vr
    };
  }, [Et, bt, yt, Ot, ir, tt]), cr = sr.scrollHeight, or = sr.start, Xt = sr.end, Gt = sr.offset;
  Qt.current.start = or, Qt.current.end = Xt;
  var Wt = reactExports.useState({
    width: 0,
    height: tt
  }), er = _slicedToArray$e(Wt, 2), lr = er[0], ur = er[1], pr = function(Lr) {
    ur({
      width: Lr.width || Lr.offsetWidth,
      height: Lr.height || Lr.offsetHeight
    });
  }, yr = reactExports.useRef(), Er = reactExports.useRef(), br = reactExports.useMemo(function() {
    return getSpinSize(lr.width, ft);
  }, [lr.width, ft]), gr = reactExports.useMemo(function() {
    return getSpinSize(lr.height, cr);
  }, [lr.height, cr]), Ar = cr - tt, Sr = reactExports.useRef(Ar);
  Sr.current = Ar;
  function Br(Nr) {
    var Lr = Nr;
    return Number.isNaN(Sr.current) || (Lr = Math.min(Lr, Sr.current)), Lr = Math.max(Lr, 0), Lr;
  }
  var Ir = yt <= 0, hr = yt >= Ar, vr = useOriginScroll(Ir, hr), xr = function() {
    return {
      x: St ? -Ht : Ht,
      y: yt
    };
  }, Pr = reactExports.useRef(xr()), Rr = useEvent(function() {
    if (pt) {
      var Nr = xr();
      (Pr.current.x !== Nr.x || Pr.current.y !== Nr.y) && (pt(Nr), Pr.current = Nr);
    }
  });
  function Dr(Nr, Lr) {
    var zr = Nr;
    Lr ? (reactDomExports.flushSync(function() {
      Ft(zr);
    }), Rr()) : Vt(zr);
  }
  function Gr(Nr) {
    var Lr = Nr.currentTarget.scrollTop;
    Lr !== yt && Vt(Lr), gt == null || gt(Nr), Rr();
  }
  var Or = function(Lr) {
    var zr = Lr, Vr = ft - lr.width;
    return zr = Math.max(zr, 0), zr = Math.min(zr, Vr), zr;
  }, Hr = useEvent(function(Nr, Lr) {
    Lr ? (reactDomExports.flushSync(function() {
      Ft(function(zr) {
        var Vr = zr + (St ? -Nr : Nr);
        return Or(Vr);
      });
    }), Rr()) : Vt(function(zr) {
      var Vr = zr + Nr;
      return Vr;
    });
  }), jr = useFrameWheel(bt, Ir, hr, !!ft, Hr), Tr = _slicedToArray$e(jr, 2), fr = Tr[0], Cr = Tr[1];
  useMobileTouchMove(bt, Pt, function(Nr, Lr) {
    return vr(Nr, Lr) ? !1 : (fr({
      preventDefault: function() {
      },
      deltaY: Nr
    }), !0);
  }), useLayoutEffect$1(function() {
    function Nr(zr) {
      bt && zr.preventDefault();
    }
    var Lr = Pt.current;
    return Lr.addEventListener("wheel", fr), Lr.addEventListener("DOMMouseScroll", Cr), Lr.addEventListener("MozMousePixelScroll", Nr), function() {
      Lr.removeEventListener("wheel", fr), Lr.removeEventListener("DOMMouseScroll", Cr), Lr.removeEventListener("MozMousePixelScroll", Nr);
    };
  }, [bt]), useLayoutEffect$1(function() {
    ft && Ft(function(Nr) {
      return Or(Nr);
    });
  }, [lr.width, ft]);
  var $r = function() {
    var Lr, zr;
    (Lr = yr.current) === null || Lr === void 0 || Lr.delayHidden(), (zr = Er.current) === null || zr === void 0 || zr.delayHidden();
  }, wr = useScrollTo(Pt, Ot, tr, nt, Dt, function() {
    return nr(!0);
  }, Vt, $r);
  reactExports.useImperativeHandle(s, function() {
    return {
      getScrollInfo: xr,
      scrollTo: function(Lr) {
        function zr(Vr) {
          return Vr && _typeof$q(Vr) === "object" && ("left" in Vr || "top" in Vr);
        }
        zr(Lr) ? (Lr.left !== void 0 && Ft(Or(Lr.left)), wr(Lr.top)) : wr(Lr);
      }
    };
  }), useLayoutEffect$1(function() {
    if (mt) {
      var Nr = Ot.slice(or, Xt + 1);
      mt(Nr, Ot);
    }
  }, [or, Xt, Ot]);
  var Mr = useGetSize(Ot, Dt, tr, nt), Fr = vt == null ? void 0 : vt({
    start: or,
    end: Xt,
    virtual: Et,
    offsetX: Ht,
    offsetY: Gt,
    rtl: St,
    getSize: Mr
  }), Qr = useChildren$1(Ot, or, Xt, ft, Kt, lt, Ut), Yr = null;
  tt && (Yr = _objectSpread2$a(_defineProperty$c({}, ot ? "height" : "maxHeight", tt), ScrollStyle), bt && (Yr.overflowY = "hidden", ft && (Yr.overflowX = "hidden"), Mt && (Yr.pointerEvents = "none")));
  var kr = {};
  return St && (kr.dir = "rtl"), /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    style: _objectSpread2$a(_objectSpread2$a({}, rt), {}, {
      position: "relative"
    }),
    className: Bt
  }, kr, xt), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: pr
  }, /* @__PURE__ */ reactExports.createElement(dt, {
    className: "".concat(_, "-holder"),
    style: Yr,
    ref: Pt,
    onScroll: Gr,
    onMouseEnter: $r
  }, /* @__PURE__ */ reactExports.createElement(Filler, {
    prefixCls: _,
    height: cr,
    offsetX: Ht,
    offsetY: Gt,
    scrollWidth: ft,
    onInnerResize: nr,
    ref: wt,
    innerProps: ct,
    rtl: St,
    extra: Fr
  }, Qr))), Et && cr > tt && /* @__PURE__ */ reactExports.createElement(ScrollBar, {
    ref: yr,
    prefixCls: _,
    scrollOffset: yt,
    scrollRange: cr,
    rtl: St,
    onScroll: Dr,
    onStartMove: $t,
    onStopMove: Tt,
    spinSize: gr,
    containerSize: lr.height,
    style: At == null ? void 0 : At.verticalScrollBar,
    thumbStyle: At == null ? void 0 : At.verticalScrollBarThumb
  }), Et && ft && /* @__PURE__ */ reactExports.createElement(ScrollBar, {
    ref: Er,
    prefixCls: _,
    scrollOffset: Ht,
    scrollRange: ft,
    rtl: St,
    onScroll: Dr,
    onStartMove: $t,
    onStopMove: Tt,
    spinSize: br,
    containerSize: lr.width,
    horizontal: !0,
    style: At == null ? void 0 : At.horizontalScrollBar,
    thumbStyle: At == null ? void 0 : At.horizontalScrollBarThumb
  }));
}
var List$1 = /* @__PURE__ */ reactExports.forwardRef(RawList);
List$1.displayName = "List";
var SelectContext = /* @__PURE__ */ reactExports.createContext(null);
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var _excluded$J = ["disabled", "title", "children", "style", "className"];
function isTitleType(a) {
  return typeof a == "string" || typeof a == "number";
}
var OptionList$1 = function a(s, $) {
  var _ = useBaseProps(), _e = _.prefixCls, tt = _.id, nt = _.open, at = _.multiple, ot = _.mode, rt = _.searchValue, st = _.toggleOpen, lt = _.notFoundContent, et = _.onPopupScroll, it = reactExports.useContext(SelectContext), ut = it.flattenOptions, ft = it.onActiveValue, ht = it.defaultActiveFirstOption, dt = it.onSelect, gt = it.menuItemSelectedIcon, pt = it.rawValues, mt = it.fieldNames, ct = it.virtual, vt = it.direction, At = it.listHeight, xt = it.listItemHeight, bt = it.optionRender, Et = "".concat(_e, "-item"), St = useMemo(function() {
    return ut;
  }, [nt, ut], function($t, Tt) {
    return Tt[0] && $t[1] !== Tt[1];
  }), Bt = reactExports.useRef(null), Ot = function(Tt) {
    Tt.preventDefault();
  }, Pt = function(Tt) {
    Bt.current && Bt.current.scrollTo(typeof Tt == "number" ? {
      index: Tt
    } : Tt);
  }, wt = function(Tt) {
    for (var Dt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, Ut = St.length, Vt = 0; Vt < Ut; Vt += 1) {
      var Qt = (Tt + Vt * Dt + Ut) % Ut, qt = St[Qt], Zt = qt.group, ar = qt.data;
      if (!Zt && !ar.disabled)
        return Qt;
    }
    return -1;
  }, Ct = reactExports.useState(function() {
    return wt(0);
  }), It = _slicedToArray$e(Ct, 2), yt = It[0], Rt = It[1], kt = function(Tt) {
    var Dt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    Rt(Tt);
    var Ut = {
      source: Dt ? "keyboard" : "mouse"
    }, Vt = St[Tt];
    if (!Vt) {
      ft(null, -1, Ut);
      return;
    }
    ft(Vt.value, Tt, Ut);
  };
  reactExports.useEffect(function() {
    kt(ht !== !1 ? wt(0) : -1);
  }, [St.length, rt]);
  var jt = reactExports.useCallback(function($t) {
    return pt.has($t) && ot !== "combobox";
  }, [ot, _toConsumableArray$d(pt).toString(), pt.size]);
  reactExports.useEffect(function() {
    var $t = setTimeout(function() {
      if (!at && nt && pt.size === 1) {
        var Dt = Array.from(pt)[0], Ut = St.findIndex(function(Vt) {
          var Qt = Vt.data;
          return Qt.value === Dt;
        });
        Ut !== -1 && (kt(Ut), Pt(Ut));
      }
    });
    if (nt) {
      var Tt;
      (Tt = Bt.current) === null || Tt === void 0 || Tt.scrollTo(void 0);
    }
    return function() {
      return clearTimeout($t);
    };
  }, [nt, rt]);
  var Ht = function(Tt) {
    Tt !== void 0 && dt(Tt, {
      selected: !pt.has(Tt)
    }), at || st(!1);
  };
  if (reactExports.useImperativeHandle($, function() {
    return {
      onKeyDown: function(Tt) {
        var Dt = Tt.which, Ut = Tt.ctrlKey;
        switch (Dt) {
          case KeyCode.N:
          case KeyCode.P:
          case KeyCode.UP:
          case KeyCode.DOWN: {
            var Vt = 0;
            if (Dt === KeyCode.UP ? Vt = -1 : Dt === KeyCode.DOWN ? Vt = 1 : isPlatformMac() && Ut && (Dt === KeyCode.N ? Vt = 1 : Dt === KeyCode.P && (Vt = -1)), Vt !== 0) {
              var Qt = wt(yt + Vt, Vt);
              Pt(Qt), kt(Qt, !0);
            }
            break;
          }
          case KeyCode.ENTER: {
            var qt = St[yt];
            qt && !qt.data.disabled ? Ht(qt.value) : Ht(void 0), nt && Tt.preventDefault();
            break;
          }
          case KeyCode.ESC:
            st(!1), nt && Tt.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(Tt) {
        Pt(Tt);
      }
    };
  }), St.length === 0)
    return /* @__PURE__ */ reactExports.createElement("div", {
      role: "listbox",
      id: "".concat(tt, "_list"),
      className: "".concat(Et, "-empty"),
      onMouseDown: Ot
    }, lt);
  var Ft = Object.keys(mt).map(function($t) {
    return mt[$t];
  }), _t = function(Tt) {
    return Tt.label;
  };
  function Nt($t, Tt) {
    var Dt = $t.group;
    return {
      role: Dt ? "presentation" : "option",
      id: "".concat(tt, "_list_").concat(Tt)
    };
  }
  var Mt = function(Tt) {
    var Dt = St[Tt];
    if (!Dt)
      return null;
    var Ut = Dt.data || {}, Vt = Ut.value, Qt = Dt.group, qt = pickAttrs(Ut, !0), Zt = _t(Dt);
    return Dt ? /* @__PURE__ */ reactExports.createElement("div", _extends$2({
      "aria-label": typeof Zt == "string" && !Qt ? Zt : null
    }, qt, {
      key: Tt
    }, Nt(Dt, Tt), {
      "aria-selected": jt(Vt)
    }), Vt) : null;
  }, Lt = {
    role: "listbox",
    id: "".concat(tt, "_list")
  };
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, ct && /* @__PURE__ */ reactExports.createElement("div", _extends$2({}, Lt, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), Mt(yt - 1), Mt(yt), Mt(yt + 1)), /* @__PURE__ */ reactExports.createElement(List$1, {
    itemKey: "key",
    ref: Bt,
    data: St,
    height: At,
    itemHeight: xt,
    fullHeight: !1,
    onMouseDown: Ot,
    onScroll: et,
    virtual: ct,
    direction: vt,
    innerProps: ct ? null : Lt
  }, function($t, Tt) {
    var Dt, Ut = $t.group, Vt = $t.groupOption, Qt = $t.data, qt = $t.label, Zt = $t.value, ar = Qt.key;
    if (Ut) {
      var Jt, rr = (Jt = Qt.title) !== null && Jt !== void 0 ? Jt : isTitleType(qt) ? qt.toString() : void 0;
      return /* @__PURE__ */ reactExports.createElement("div", {
        className: classnames(Et, "".concat(Et, "-group")),
        title: rr
      }, qt !== void 0 ? qt : ar);
    }
    var Yt = Qt.disabled, Kt = Qt.title;
    Qt.children;
    var nr = Qt.style, tr = Qt.className, ir = _objectWithoutProperties$1(Qt, _excluded$J), sr = omit(ir, Ft), cr = jt(Zt), or = "".concat(Et, "-option"), Xt = classnames(Et, or, tr, (Dt = {}, _defineProperty$c(Dt, "".concat(or, "-grouped"), Vt), _defineProperty$c(Dt, "".concat(or, "-active"), yt === Tt && !Yt), _defineProperty$c(Dt, "".concat(or, "-disabled"), Yt), _defineProperty$c(Dt, "".concat(or, "-selected"), cr), Dt)), Gt = _t($t), Wt = !gt || typeof gt == "function" || cr, er = typeof Gt == "number" ? Gt : Gt || Zt, lr = isTitleType(er) ? er.toString() : void 0;
    return Kt !== void 0 && (lr = Kt), /* @__PURE__ */ reactExports.createElement("div", _extends$2({}, pickAttrs(sr), ct ? {} : Nt($t, Tt), {
      "aria-selected": cr,
      className: Xt,
      title: lr,
      onMouseMove: function() {
        yt === Tt || Yt || kt(Tt);
      },
      onClick: function() {
        Yt || Ht(Zt);
      },
      style: nr
    }), /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(or, "-content")
    }, typeof bt == "function" ? bt($t, {
      index: Tt
    }) : er), /* @__PURE__ */ reactExports.isValidElement(gt) || cr, Wt && /* @__PURE__ */ reactExports.createElement(TransBtn, {
      className: "".concat(Et, "-option-state"),
      customizeIcon: gt,
      customizeIconProps: {
        value: Zt,
        disabled: Yt,
        isSelected: cr
      }
    }, cr ? "✓" : null));
  }));
}, RefOptionList$1 = /* @__PURE__ */ reactExports.forwardRef(OptionList$1);
RefOptionList$1.displayName = "OptionList";
const useCache$1 = function(a, s) {
  var $ = reactExports.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), _ = reactExports.useMemo(function() {
    var tt = $.current, nt = tt.values, at = tt.options, ot = a.map(function(lt) {
      if (lt.label === void 0) {
        var et;
        return _objectSpread2$a(_objectSpread2$a({}, lt), {}, {
          label: (et = nt.get(lt.value)) === null || et === void 0 ? void 0 : et.label
        });
      }
      return lt;
    }), rt = /* @__PURE__ */ new Map(), st = /* @__PURE__ */ new Map();
    return ot.forEach(function(lt) {
      rt.set(lt.value, lt), st.set(lt.value, s.get(lt.value) || at.get(lt.value));
    }), $.current.values = rt, $.current.options = st, ot;
  }, [a, s]), _e = reactExports.useCallback(function(tt) {
    return s.get(tt) || $.current.options.get(tt);
  }, [s]);
  return [_, _e];
};
function includes(a, s) {
  return toArray$7(a).join("").toUpperCase().includes(s);
}
const useFilterOptions = function(a, s, $, _, _e) {
  return reactExports.useMemo(function() {
    if (!$ || _ === !1)
      return a;
    var tt = s.options, nt = s.label, at = s.value, ot = [], rt = typeof _ == "function", st = $.toUpperCase(), lt = rt ? _ : function(it, ut) {
      return _e ? includes(ut[_e], st) : ut[tt] ? includes(ut[nt !== "children" ? nt : "label"], st) : includes(ut[at], st);
    }, et = rt ? function(it) {
      return injectPropsWithOption(it);
    } : function(it) {
      return it;
    };
    return a.forEach(function(it) {
      if (it[tt]) {
        var ut = lt($, et(it));
        if (ut)
          ot.push(it);
        else {
          var ft = it[tt].filter(function(ht) {
            return lt($, et(ht));
          });
          ft.length && ot.push(_objectSpread2$a(_objectSpread2$a({}, it), {}, _defineProperty$c({}, tt, ft)));
        }
        return;
      }
      lt($, et(it)) && ot.push(it);
    }), ot;
  }, [a, _, _e, $, s]);
};
var uuid$2 = 0, isBrowserClient$1 = canUseDom$1();
function getUUID$1() {
  var a;
  return isBrowserClient$1 ? (a = uuid$2, uuid$2 += 1) : a = "TEST_OR_SSR", a;
}
function useId$1(a) {
  var s = reactExports.useState(), $ = _slicedToArray$e(s, 2), _ = $[0], _e = $[1];
  return reactExports.useEffect(function() {
    _e("rc_select_".concat(getUUID$1()));
  }, []), a || _;
}
var _excluded$I = ["children", "value"], _excluded2$a = ["children"];
function convertNodeToOption(a) {
  var s = a, $ = s.key, _ = s.props, _e = _.children, tt = _.value, nt = _objectWithoutProperties$1(_, _excluded$I);
  return _objectSpread2$a({
    key: $,
    value: tt !== void 0 ? tt : $,
    children: _e
  }, nt);
}
function convertChildrenToData$1(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return toArray$9(a).map(function($, _) {
    if (!/* @__PURE__ */ reactExports.isValidElement($) || !$.type)
      return null;
    var _e = $, tt = _e.type.isSelectOptGroup, nt = _e.key, at = _e.props, ot = at.children, rt = _objectWithoutProperties$1(at, _excluded2$a);
    return s || !tt ? convertNodeToOption($) : _objectSpread2$a(_objectSpread2$a({
      key: "__RC_SELECT_GRP__".concat(nt === null ? _ : nt, "__"),
      label: nt
    }, rt), {}, {
      options: convertChildrenToData$1(ot)
    });
  }).filter(function($) {
    return $;
  });
}
function useOptions(a, s, $, _, _e) {
  return reactExports.useMemo(function() {
    var tt = a, nt = !a;
    nt && (tt = convertChildrenToData$1(s));
    var at = /* @__PURE__ */ new Map(), ot = /* @__PURE__ */ new Map(), rt = function(et, it, ut) {
      ut && typeof ut == "string" && et.set(it[ut], it);
    };
    function st(lt) {
      for (var et = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, it = 0; it < lt.length; it += 1) {
        var ut = lt[it];
        !ut[$.options] || et ? (at.set(ut[$.value], ut), rt(ot, ut, $.label), rt(ot, ut, _), rt(ot, ut, _e)) : st(ut[$.options], !0);
      }
    }
    return st(tt), {
      options: tt,
      valueOptions: at,
      labelOptions: ot
    };
  }, [a, s, $, _, _e]);
}
function useRefFunc$1(a) {
  var s = reactExports.useRef();
  s.current = a;
  var $ = reactExports.useCallback(function() {
    return s.current.apply(s, arguments);
  }, []);
  return $;
}
var _excluded$H = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "value", "defaultValue", "labelInValue", "onChange"], OMIT_DOM_PROPS = ["inputValue"];
function isRawValue$1(a) {
  return !a || _typeof$q(a) !== "object";
}
var Select$1 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.id, _ = a.mode, _e = a.prefixCls, tt = _e === void 0 ? "rc-select" : _e, nt = a.backfill, at = a.fieldNames, ot = a.inputValue, rt = a.searchValue, st = a.onSearch, lt = a.autoClearSearchValue, et = lt === void 0 ? !0 : lt, it = a.onSelect, ut = a.onDeselect, ft = a.dropdownMatchSelectWidth, ht = ft === void 0 ? !0 : ft, dt = a.filterOption, gt = a.filterSort, pt = a.optionFilterProp, mt = a.optionLabelProp, ct = a.options, vt = a.optionRender, At = a.children, xt = a.defaultActiveFirstOption, bt = a.menuItemSelectedIcon, Et = a.virtual, St = a.direction, Bt = a.listHeight, Ot = Bt === void 0 ? 200 : Bt, Pt = a.listItemHeight, wt = Pt === void 0 ? 20 : Pt, Ct = a.value, It = a.defaultValue, yt = a.labelInValue, Rt = a.onChange, kt = _objectWithoutProperties$1(a, _excluded$H), jt = useId$1($), Ht = isMultiple(_), Ft = !!(!ct && At), _t = reactExports.useMemo(function() {
    return dt === void 0 && _ === "combobox" ? !1 : dt;
  }, [dt, _]), Nt = reactExports.useMemo(
    function() {
      return fillFieldNames$2(at, Ft);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(at),
      Ft
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), Mt = useMergedState("", {
    value: rt !== void 0 ? rt : ot,
    postState: function(Hr) {
      return Hr || "";
    }
  }), Lt = _slicedToArray$e(Mt, 2), $t = Lt[0], Tt = Lt[1], Dt = useOptions(ct, At, Nt, pt, mt), Ut = Dt.valueOptions, Vt = Dt.labelOptions, Qt = Dt.options, qt = reactExports.useCallback(function(Or) {
    var Hr = toArray$7(Or);
    return Hr.map(function(jr) {
      var Tr, fr, Cr, $r, wr;
      if (isRawValue$1(jr))
        Tr = jr;
      else {
        var Mr;
        Cr = jr.key, fr = jr.label, Tr = (Mr = jr.value) !== null && Mr !== void 0 ? Mr : Cr;
      }
      var Fr = Ut.get(Tr);
      if (Fr) {
        var Qr;
        fr === void 0 && (fr = Fr == null ? void 0 : Fr[mt || Nt.label]), Cr === void 0 && (Cr = (Qr = Fr == null ? void 0 : Fr.key) !== null && Qr !== void 0 ? Qr : Tr), $r = Fr == null ? void 0 : Fr.disabled, wr = Fr == null ? void 0 : Fr.title;
      }
      return {
        label: fr,
        value: Tr,
        key: Cr,
        disabled: $r,
        title: wr
      };
    });
  }, [Nt, mt, Ut]), Zt = useMergedState(It, {
    value: Ct
  }), ar = _slicedToArray$e(Zt, 2), Jt = ar[0], rr = ar[1], Yt = reactExports.useMemo(function() {
    var Or, Hr = qt(Jt);
    return _ === "combobox" && isComboNoValue((Or = Hr[0]) === null || Or === void 0 ? void 0 : Or.value) ? [] : Hr;
  }, [Jt, qt, _]), Kt = useCache$1(Yt, Ut), nr = _slicedToArray$e(Kt, 2), tr = nr[0], ir = nr[1], sr = reactExports.useMemo(function() {
    if (!_ && tr.length === 1) {
      var Or = tr[0];
      if (Or.value === null && (Or.label === null || Or.label === void 0))
        return [];
    }
    return tr.map(function(Hr) {
      var jr;
      return _objectSpread2$a(_objectSpread2$a({}, Hr), {}, {
        label: (jr = Hr.label) !== null && jr !== void 0 ? jr : Hr.value
      });
    });
  }, [_, tr]), cr = reactExports.useMemo(function() {
    return new Set(tr.map(function(Or) {
      return Or.value;
    }));
  }, [tr]);
  reactExports.useEffect(function() {
    if (_ === "combobox") {
      var Or, Hr = (Or = tr[0]) === null || Or === void 0 ? void 0 : Or.value;
      Tt(hasValue(Hr) ? String(Hr) : "");
    }
  }, [tr]);
  var or = useRefFunc$1(function(Or, Hr) {
    var jr, Tr = Hr ?? Or;
    return jr = {}, _defineProperty$c(jr, Nt.value, Or), _defineProperty$c(jr, Nt.label, Tr), jr;
  }), Xt = reactExports.useMemo(function() {
    if (_ !== "tags")
      return Qt;
    var Or = _toConsumableArray$d(Qt), Hr = function(Tr) {
      return Ut.has(Tr);
    };
    return _toConsumableArray$d(tr).sort(function(jr, Tr) {
      return jr.value < Tr.value ? -1 : 1;
    }).forEach(function(jr) {
      var Tr = jr.value;
      Hr(Tr) || Or.push(or(Tr, jr.label));
    }), Or;
  }, [or, Qt, Ut, tr, _]), Gt = useFilterOptions(Xt, Nt, $t, _t, pt), Wt = reactExports.useMemo(function() {
    return _ !== "tags" || !$t || Gt.some(function(Or) {
      return Or[pt || "value"] === $t;
    }) || Gt.some(function(Or) {
      return Or[Nt.value] === $t;
    }) ? Gt : [or($t)].concat(_toConsumableArray$d(Gt));
  }, [or, pt, _, Gt, $t, Nt]), er = reactExports.useMemo(function() {
    return gt ? _toConsumableArray$d(Wt).sort(function(Or, Hr) {
      return gt(Or, Hr);
    }) : Wt;
  }, [Wt, gt]), lr = reactExports.useMemo(function() {
    return flattenOptions(er, {
      fieldNames: Nt,
      childrenAsData: Ft
    });
  }, [er, Nt, Ft]), ur = function(Hr) {
    var jr = qt(Hr);
    if (rr(jr), Rt && // Trigger event only when value changed
    (jr.length !== tr.length || jr.some(function(Cr, $r) {
      var wr;
      return ((wr = tr[$r]) === null || wr === void 0 ? void 0 : wr.value) !== (Cr == null ? void 0 : Cr.value);
    }))) {
      var Tr = yt ? jr : jr.map(function(Cr) {
        return Cr.value;
      }), fr = jr.map(function(Cr) {
        return injectPropsWithOption(ir(Cr.value));
      });
      Rt(
        // Value
        Ht ? Tr : Tr[0],
        // Option
        Ht ? fr : fr[0]
      );
    }
  }, pr = reactExports.useState(null), yr = _slicedToArray$e(pr, 2), Er = yr[0], br = yr[1], gr = reactExports.useState(0), Ar = _slicedToArray$e(gr, 2), Sr = Ar[0], Br = Ar[1], Ir = xt !== void 0 ? xt : _ !== "combobox", hr = reactExports.useCallback(function(Or, Hr) {
    var jr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, Tr = jr.source, fr = Tr === void 0 ? "keyboard" : Tr;
    Br(Hr), nt && _ === "combobox" && Or !== null && fr === "keyboard" && br(String(Or));
  }, [nt, _]), vr = function(Hr, jr, Tr) {
    var fr = function() {
      var Lr, zr = ir(Hr);
      return [yt ? {
        label: zr == null ? void 0 : zr[Nt.label],
        value: Hr,
        key: (Lr = zr == null ? void 0 : zr.key) !== null && Lr !== void 0 ? Lr : Hr
      } : Hr, injectPropsWithOption(zr)];
    };
    if (jr && it) {
      var Cr = fr(), $r = _slicedToArray$e(Cr, 2), wr = $r[0], Mr = $r[1];
      it(wr, Mr);
    } else if (!jr && ut && Tr !== "clear") {
      var Fr = fr(), Qr = _slicedToArray$e(Fr, 2), Yr = Qr[0], kr = Qr[1];
      ut(Yr, kr);
    }
  }, xr = useRefFunc$1(function(Or, Hr) {
    var jr, Tr = Ht ? Hr.selected : !0;
    Tr ? jr = Ht ? [].concat(_toConsumableArray$d(tr), [Or]) : [Or] : jr = tr.filter(function(fr) {
      return fr.value !== Or;
    }), ur(jr), vr(Or, Tr), _ === "combobox" ? br("") : (!isMultiple || et) && (Tt(""), br(""));
  }), Pr = function(Hr, jr) {
    ur(Hr);
    var Tr = jr.type, fr = jr.values;
    (Tr === "remove" || Tr === "clear") && fr.forEach(function(Cr) {
      vr(Cr.value, !1, Tr);
    });
  }, Rr = function(Hr, jr) {
    if (Tt(Hr), br(null), jr.source === "submit") {
      var Tr = (Hr || "").trim();
      if (Tr) {
        var fr = Array.from(new Set([].concat(_toConsumableArray$d(cr), [Tr])));
        ur(fr), vr(Tr, !0), Tt("");
      }
      return;
    }
    jr.source !== "blur" && (_ === "combobox" && ur(Hr), st == null || st(Hr));
  }, Dr = function(Hr) {
    var jr = Hr;
    _ !== "tags" && (jr = Hr.map(function(fr) {
      var Cr = Vt.get(fr);
      return Cr == null ? void 0 : Cr.value;
    }).filter(function(fr) {
      return fr !== void 0;
    }));
    var Tr = Array.from(new Set([].concat(_toConsumableArray$d(cr), _toConsumableArray$d(jr))));
    ur(Tr), Tr.forEach(function(fr) {
      vr(fr, !0);
    });
  }, Gr = reactExports.useMemo(function() {
    var Or = Et !== !1 && ht !== !1;
    return _objectSpread2$a(_objectSpread2$a({}, Dt), {}, {
      flattenOptions: lr,
      onActiveValue: hr,
      defaultActiveFirstOption: Ir,
      onSelect: xr,
      menuItemSelectedIcon: bt,
      rawValues: cr,
      fieldNames: Nt,
      virtual: Or,
      direction: St,
      listHeight: Ot,
      listItemHeight: wt,
      childrenAsData: Ft,
      optionRender: vt
    });
  }, [Dt, lr, hr, Ir, xr, bt, cr, Nt, Et, ht, Ot, wt, Ft, vt]);
  return /* @__PURE__ */ reactExports.createElement(SelectContext.Provider, {
    value: Gr
  }, /* @__PURE__ */ reactExports.createElement(BaseSelect, _extends$2({}, kt, {
    // >>> MISC
    id: jt,
    prefixCls: tt,
    ref: s,
    omitDomProps: OMIT_DOM_PROPS,
    mode: _,
    displayValues: sr,
    onDisplayValuesChange: Pr,
    direction: St,
    searchValue: $t,
    onSearch: Rr,
    autoClearSearchValue: et,
    onSearchSplit: Dr,
    dropdownMatchSelectWidth: ht,
    OptionList: RefOptionList$1,
    emptyOptions: !lr.length,
    activeValue: Er,
    activeDescendantId: "".concat(jt, "_list_").concat(Sr)
  })));
}), TypedSelect = Select$1;
TypedSelect.Option = Option;
TypedSelect.OptGroup = OptGroup;
function getStatusClassNames(a, s, $) {
  return classnames({
    [`${a}-status-success`]: s === "success",
    [`${a}-status-warning`]: s === "warning",
    [`${a}-status-error`]: s === "error",
    [`${a}-status-validating`]: s === "validating",
    [`${a}-has-feedback`]: $
  });
}
const getMergedStatus = (a, s) => s || a, Empty$3 = () => {
  const [, a] = useToken$1(), $ = new TinyColor(a.colorBgBase).toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ reactExports.createElement("svg", {
    style: $,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ reactExports.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ reactExports.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ reactExports.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ reactExports.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ reactExports.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
}, DefaultEmptyImg = Empty$3, Simple = () => {
  const [, a] = useToken$1(), {
    colorFill: s,
    colorFillTertiary: $,
    colorFillQuaternary: _,
    colorBgContainer: _e
  } = a, {
    borderColor: tt,
    shadowColor: nt,
    contentColor: at
  } = reactExports.useMemo(() => ({
    borderColor: new TinyColor(s).onBackground(_e).toHexShortString(),
    shadowColor: new TinyColor($).onBackground(_e).toHexShortString(),
    contentColor: new TinyColor(_).onBackground(_e).toHexShortString()
  }), [s, $, _, _e]);
  return /* @__PURE__ */ reactExports.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ reactExports.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ reactExports.createElement("ellipse", {
    fill: nt,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ reactExports.createElement("g", {
    fillRule: "nonzero",
    stroke: tt
  }, /* @__PURE__ */ reactExports.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ reactExports.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: at
  }))));
}, SimpleEmptyImg = Simple, genSharedEmptyStyle = (a) => {
  const {
    componentCls: s,
    margin: $,
    marginXS: _,
    marginXL: _e,
    fontSize: tt,
    lineHeight: nt
  } = a;
  return {
    [s]: {
      marginInline: _,
      fontSize: tt,
      lineHeight: nt,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${s}-image`]: {
        height: a.emptyImgHeight,
        marginBottom: _,
        opacity: a.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${s}-description`]: {
        color: a.colorText
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${s}-footer`]: {
        marginTop: $
      },
      "&-normal": {
        marginBlock: _e,
        color: a.colorTextDisabled,
        [`${s}-description`]: {
          color: a.colorTextDisabled
        },
        [`${s}-image`]: {
          height: a.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: _,
        color: a.colorTextDisabled,
        [`${s}-image`]: {
          height: a.emptyImgHeightSM
        }
      }
    }
  };
}, useStyle$t = genStyleHooks("Empty", (a) => {
  const {
    componentCls: s,
    controlHeightLG: $,
    calc: _
  } = a, _e = merge(a, {
    emptyImgCls: `${s}-img`,
    emptyImgHeight: _($).mul(2.5).equal(),
    emptyImgHeightMD: $,
    emptyImgHeightSM: _($).mul(0.875).equal()
  });
  return [genSharedEmptyStyle(_e)];
});
var __rest$X = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const defaultEmptyImg = /* @__PURE__ */ reactExports.createElement(DefaultEmptyImg, null), simpleEmptyImg = /* @__PURE__ */ reactExports.createElement(SimpleEmptyImg, null), Empty$1 = (a) => {
  var {
    className: s,
    rootClassName: $,
    prefixCls: _,
    image: _e = defaultEmptyImg,
    description: tt,
    children: nt,
    imageStyle: at,
    style: ot
  } = a, rt = __rest$X(a, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style"]);
  const {
    getPrefixCls: st,
    direction: lt,
    empty: et
  } = reactExports.useContext(ConfigContext$1), it = st("empty", _), [ut, ft, ht] = useStyle$t(it), [dt] = useLocale$1("Empty"), gt = typeof tt < "u" ? tt : dt == null ? void 0 : dt.description, pt = typeof gt == "string" ? gt : "empty";
  let mt = null;
  return typeof _e == "string" ? mt = /* @__PURE__ */ reactExports.createElement("img", {
    alt: pt,
    src: _e
  }) : mt = _e, ut(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    className: classnames(ft, ht, it, et == null ? void 0 : et.className, {
      [`${it}-normal`]: _e === simpleEmptyImg,
      [`${it}-rtl`]: lt === "rtl"
    }, s, $),
    style: Object.assign(Object.assign({}, et == null ? void 0 : et.style), ot)
  }, rt), /* @__PURE__ */ reactExports.createElement("div", {
    className: `${it}-image`,
    style: at
  }, mt), gt && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${it}-description`
  }, gt), nt && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${it}-footer`
  }, nt)));
};
Empty$1.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty$1.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
const Empty$2 = Empty$1, DefaultRenderEmpty = (a) => {
  const {
    componentName: s
  } = a, {
    getPrefixCls: $
  } = reactExports.useContext(ConfigContext$1), _ = $("empty");
  switch (s) {
    case "Table":
    case "List":
      return /* @__PURE__ */ React$a.createElement(Empty$2, {
        image: Empty$2.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ React$a.createElement(Empty$2, {
        image: Empty$2.PRESENTED_IMAGE_SIMPLE,
        className: `${_}-small`
      });
    default:
      return /* @__PURE__ */ React$a.createElement(Empty$2, null);
  }
}, DefaultRenderEmpty$1 = DefaultRenderEmpty, genItemStyle = (a) => {
  const {
    optionHeight: s,
    optionFontSize: $,
    optionLineHeight: _,
    optionPadding: _e
  } = a;
  return {
    position: "relative",
    display: "block",
    minHeight: s,
    padding: _e,
    color: a.colorText,
    fontWeight: "normal",
    fontSize: $,
    lineHeight: _,
    boxSizing: "border-box"
  };
}, genSingleStyle$1 = (a) => {
  const {
    antCls: s,
    componentCls: $
  } = a, _ = `${$}-item`, _e = `&${s}-slide-up-enter${s}-slide-up-enter-active`, tt = `&${s}-slide-up-appear${s}-slide-up-appear-active`, nt = `&${s}-slide-up-leave${s}-slide-up-leave-active`, at = `${$}-dropdown-placement-`;
  return [
    {
      [`${$}-dropdown`]: Object.assign(Object.assign({}, resetComponent(a)), {
        position: "absolute",
        top: -9999,
        zIndex: a.zIndexPopup,
        boxSizing: "border-box",
        padding: a.paddingXXS,
        overflow: "hidden",
        fontSize: a.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: a.colorBgElevated,
        borderRadius: a.borderRadiusLG,
        outline: "none",
        boxShadow: a.boxShadowSecondary,
        [`
          ${_e}${at}bottomLeft,
          ${tt}${at}bottomLeft
        `]: {
          animationName: slideUpIn
        },
        [`
          ${_e}${at}topLeft,
          ${tt}${at}topLeft,
          ${_e}${at}topRight,
          ${tt}${at}topRight
        `]: {
          animationName: slideDownIn
        },
        [`${nt}${at}bottomLeft`]: {
          animationName: slideUpOut
        },
        [`
          ${nt}${at}topLeft,
          ${nt}${at}topRight
        `]: {
          animationName: slideDownOut
        },
        "&-hidden": {
          display: "none"
        },
        [`${_}`]: Object.assign(Object.assign({}, genItemStyle(a)), {
          cursor: "pointer",
          transition: `background ${a.motionDurationSlow} ease`,
          borderRadius: a.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: a.colorTextDescription,
            fontSize: a.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, textEllipsis),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${_}-option-disabled)`]: {
              backgroundColor: a.optionActiveBg
            },
            [`&-selected:not(${_}-option-disabled)`]: {
              color: a.optionSelectedColor,
              fontWeight: a.optionSelectedFontWeight,
              backgroundColor: a.optionSelectedBg,
              [`${_}-option-state`]: {
                color: a.colorPrimary
              }
            },
            "&-disabled": {
              [`&${_}-option-selected`]: {
                backgroundColor: a.colorBgContainerDisabled
              },
              color: a.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: a.calc(a.controlPaddingHorizontal).mul(2).equal()
            }
          }
        }),
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    initSlideMotion(a, "slide-up"),
    initSlideMotion(a, "slide-down"),
    initMoveMotion(a, "move-up"),
    initMoveMotion(a, "move-down")
  ];
}, genDropdownStyle$1 = genSingleStyle$1, FIXED_ITEM_MARGIN = 2, getSelectItemStyle = (a) => {
  const {
    multipleSelectItemHeight: s,
    selectHeight: $,
    lineWidth: _
  } = a;
  return a.calc($).sub(s).div(2).sub(_).equal();
};
function genSizeStyle$4(a, s) {
  const {
    componentCls: $,
    iconCls: _
  } = a, _e = `${$}-selection-overflow`, tt = a.multipleSelectItemHeight, nt = getSelectItemStyle(a), at = s ? `${$}-${s}` : "";
  return {
    [`${$}-multiple${at}`]: {
      fontSize: a.fontSize,
      /**
       * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
       * may update to redesign with its align logic.
       */
      // =========================== Overflow ===========================
      [_e]: {
        position: "relative",
        display: "flex",
        flex: "auto",
        flexWrap: "wrap",
        maxWidth: "100%",
        "&-item": {
          flex: "none",
          alignSelf: "center",
          maxWidth: "100%",
          display: "inline-flex"
        }
      },
      // ========================= Selector =========================
      [`${$}-selector`]: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: a.calc(FIXED_ITEM_MARGIN).mul(2).equal(),
        paddingBlock: a.calc(nt).sub(FIXED_ITEM_MARGIN).equal(),
        borderRadius: a.borderRadius,
        [`${$}-show-search&`]: {
          cursor: "text"
        },
        [`${$}-disabled&`]: {
          background: a.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${unit$1(FIXED_ITEM_MARGIN)} 0`,
          lineHeight: unit$1(tt),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      [`
        &${$}-show-arrow ${$}-selector,
        &${$}-allow-clear ${$}-selector
      `]: {
        paddingInlineEnd: a.calc(a.fontSizeIcon).add(a.controlPaddingHorizontal).equal()
      },
      // ======================== Selections ========================
      [`${$}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        height: tt,
        marginTop: FIXED_ITEM_MARGIN,
        marginBottom: FIXED_ITEM_MARGIN,
        lineHeight: unit$1(a.calc(tt).sub(a.calc(a.lineWidth).mul(2)).equal()),
        background: a.multipleItemBg,
        border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.multipleItemBorderColor}`,
        borderRadius: a.borderRadiusSM,
        cursor: "default",
        transition: `font-size ${a.motionDurationSlow}, line-height ${a.motionDurationSlow}, height ${a.motionDurationSlow}`,
        marginInlineEnd: a.calc(FIXED_ITEM_MARGIN).mul(2).equal(),
        paddingInlineStart: a.paddingXS,
        paddingInlineEnd: a.calc(a.paddingXS).div(2).equal(),
        [`${$}-disabled&`]: {
          color: a.multipleItemColorDisabled,
          borderColor: a.multipleItemBorderColorDisabled,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: a.calc(a.paddingXS).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, resetIcon()), {
          display: "inline-flex",
          alignItems: "center",
          color: a.colorIcon,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${_}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: a.colorIconHover
          }
        })
      },
      // ========================== Input ==========================
      [`${_e}-item + ${_e}-item`]: {
        [`${$}-selection-search`]: {
          marginInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      [`${_e}-item-suffix`]: {
        height: "100%"
      },
      [`${$}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: a.calc(a.inputPaddingHorizontalBase).sub(nt).equal(),
        "\n          &-input,\n          &-mirror\n        ": {
          height: tt,
          fontFamily: a.fontFamily,
          lineHeight: unit$1(tt),
          transition: `all ${a.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${$}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: a.inputPaddingHorizontalBase,
        insetInlineEnd: a.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${a.motionDurationSlow}`
      }
    }
  };
}
const genMultipleStyle = (a) => {
  const {
    componentCls: s
  } = a, $ = merge(a, {
    selectHeight: a.controlHeightSM,
    multipleSelectItemHeight: a.controlHeightXS,
    borderRadius: a.borderRadiusSM,
    borderRadiusSM: a.borderRadiusXS
  }), _ = merge(a, {
    fontSize: a.fontSizeLG,
    selectHeight: a.controlHeightLG,
    multipleSelectItemHeight: a.multipleItemHeightLG,
    borderRadius: a.borderRadiusLG,
    borderRadiusSM: a.borderRadius
  });
  return [
    genSizeStyle$4(a),
    // ======================== Small ========================
    genSizeStyle$4($, "sm"),
    // Padding
    {
      [`${s}-multiple${s}-sm`]: {
        [`${s}-selection-placeholder`]: {
          insetInline: a.calc(a.controlPaddingHorizontalSM).sub(a.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${s}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    genSizeStyle$4(_, "lg")
  ];
}, genMultipleStyle$1 = genMultipleStyle;
function genSizeStyle$3(a, s) {
  const {
    componentCls: $,
    inputPaddingHorizontalBase: _,
    borderRadius: _e
  } = a, tt = a.calc(a.controlHeight).sub(a.calc(a.lineWidth).mul(2)).equal(), nt = s ? `${$}-${s}` : "";
  return {
    [`${$}-single${nt}`]: {
      fontSize: a.fontSize,
      height: a.controlHeight,
      // ========================= Selector =========================
      [`${$}-selector`]: Object.assign(Object.assign({}, resetComponent(a, !0)), {
        display: "flex",
        borderRadius: _e,
        [`${$}-selection-search`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: _,
          insetInlineEnd: _,
          bottom: 0,
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${$}-selection-item,
          ${$}-selection-placeholder
        `]: {
          padding: 0,
          lineHeight: unit$1(tt),
          transition: `all ${a.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${$}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${$}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${$}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${$}-show-arrow ${$}-selection-item,
        &${$}-show-arrow ${$}-selection-placeholder
      `]: {
        paddingInlineEnd: a.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${$}-open ${$}-selection-item`]: {
        color: a.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${$}-customize-input)`]: {
        [`${$}-selector`]: {
          width: "100%",
          height: "100%",
          padding: `0 ${unit$1(_)}`,
          [`${$}-selection-search-input`]: {
            height: tt
          },
          "&:after": {
            lineHeight: unit$1(tt)
          }
        }
      },
      [`&${$}-customize-input`]: {
        [`${$}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${$}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${$}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${unit$1(_)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function genSingleStyle(a) {
  const {
    componentCls: s
  } = a, $ = a.calc(a.controlPaddingHorizontalSM).sub(a.lineWidth).equal();
  return [
    genSizeStyle$3(a),
    // ======================== Small ========================
    // Shared
    genSizeStyle$3(merge(a, {
      controlHeight: a.controlHeightSM,
      borderRadius: a.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${s}-single${s}-sm`]: {
        [`&:not(${s}-customize-input)`]: {
          [`${s}-selection-search`]: {
            insetInlineStart: $,
            insetInlineEnd: $
          },
          [`${s}-selector`]: {
            padding: `0 ${unit$1($)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${s}-show-arrow ${s}-selection-search`]: {
            insetInlineEnd: a.calc($).add(a.calc(a.fontSize).mul(1.5)).equal()
          },
          [`
            &${s}-show-arrow ${s}-selection-item,
            &${s}-show-arrow ${s}-selection-placeholder
          `]: {
            paddingInlineEnd: a.calc(a.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    genSizeStyle$3(merge(a, {
      controlHeight: a.singleItemHeightLG,
      fontSize: a.fontSizeLG,
      borderRadius: a.borderRadiusLG
    }), "lg")
  ];
}
const genSelectorStyle = (a) => {
  const {
    componentCls: s,
    selectorBg: $
  } = a;
  return {
    position: "relative",
    backgroundColor: $,
    border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
    transition: `all ${a.motionDurationMid} ${a.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${s}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${s}-disabled&`]: {
      color: a.colorTextDisabled,
      background: a.colorBgContainerDisabled,
      cursor: "not-allowed",
      [`${s}-multiple&`]: {
        background: a.multipleSelectorBgDisabled
      },
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, genStatusStyle$3 = function(a, s) {
  let $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  const {
    componentCls: _,
    borderHoverColor: _e,
    antCls: tt,
    borderActiveColor: nt,
    outlineColor: at,
    controlOutlineWidth: ot
  } = s, rt = $ ? {
    [`${_}-selector`]: {
      borderColor: nt
    }
  } : {};
  return {
    [a]: {
      [`&:not(${_}-disabled):not(${_}-customize-input):not(${tt}-pagination-size-changer)`]: Object.assign(Object.assign({}, rt), {
        [`&:hover ${_}-selector`]: {
          borderColor: _e
        },
        [`${_}-focused& ${_}-selector`]: {
          borderColor: nt,
          boxShadow: `0 0 0 ${unit$1(ot)} ${at}`,
          outline: 0
        }
      })
    }
  };
}, getSearchInputWithoutBorderStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        "-webkit-appearance": "none"
      }
    }
  };
}, genBaseStyle$b = (a) => {
  const {
    antCls: s,
    componentCls: $,
    inputPaddingHorizontalBase: _,
    iconCls: _e
  } = a;
  return {
    [$]: Object.assign(Object.assign({}, resetComponent(a)), {
      position: "relative",
      display: "inline-block",
      cursor: "pointer",
      [`&:not(${$}-customize-input) ${$}-selector`]: Object.assign(Object.assign({}, genSelectorStyle(a)), getSearchInputWithoutBorderStyle(a)),
      // [`&:not(&-disabled):hover ${selectCls}-selector`]: {
      //   ...genHoverStyle(token),
      // },
      // ======================== Selection ========================
      [`${$}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, textEllipsis), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${s}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${$}-selection-placeholder`]: Object.assign(Object.assign({}, textEllipsis), {
        flex: 1,
        color: a.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${$}-arrow`]: Object.assign(Object.assign({}, resetIcon()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: _,
        height: a.fontSizeIcon,
        marginTop: a.calc(a.fontSizeIcon).mul(-1).div(2).equal(),
        color: a.colorTextQuaternary,
        fontSize: a.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        [_e]: {
          verticalAlign: "top",
          transition: `transform ${a.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${$}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${$}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Clear ==========================
      [`${$}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: _,
        zIndex: 1,
        display: "inline-block",
        width: a.fontSizeIcon,
        height: a.fontSizeIcon,
        marginTop: a.calc(a.fontSizeIcon).mul(-1).div(2).equal(),
        color: a.colorTextQuaternary,
        fontSize: a.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        background: a.clearBg,
        cursor: "pointer",
        opacity: 0,
        transition: `color ${a.motionDurationMid} ease, opacity ${a.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: a.colorTextTertiary
        }
      },
      "&:hover": {
        [`${$}-clear`]: {
          opacity: 1
        }
      }
    }),
    // ========================= Feedback ==========================
    [`${$}-has-feedback`]: {
      [`${$}-clear`]: {
        insetInlineEnd: a.calc(_).add(a.fontSize).add(a.paddingXS).equal()
      }
    }
  };
}, genSelectStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return [
    {
      [s]: {
        // ==================== BorderLess ====================
        [`&-borderless ${s}-selector`]: {
          backgroundColor: "transparent !important",
          borderColor: "transparent !important",
          boxShadow: "none !important"
        },
        // ==================== In Form ====================
        [`&${s}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    genBaseStyle$b(a),
    // Single
    genSingleStyle(a),
    // Multiple
    genMultipleStyle$1(a),
    // Dropdown
    genDropdownStyle$1(a),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${s}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==                     Status                      ==
    // =====================================================
    genStatusStyle$3(s, merge(a, {
      borderHoverColor: a.colorPrimaryHover,
      borderActiveColor: a.colorPrimary,
      outlineColor: a.controlOutline
    })),
    genStatusStyle$3(`${s}-status-error`, merge(a, {
      borderHoverColor: a.colorErrorHover,
      borderActiveColor: a.colorError,
      outlineColor: a.colorErrorOutline
    }), !0),
    genStatusStyle$3(`${s}-status-warning`, merge(a, {
      borderHoverColor: a.colorWarningHover,
      borderActiveColor: a.colorWarning,
      outlineColor: a.colorWarningOutline
    }), !0),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(a, {
      borderElCls: `${s}-selector`,
      focusElCls: `${s}-focused`
    })
  ];
}, prepareComponentToken$r = (a) => {
  const {
    fontSize: s,
    lineHeight: $,
    controlHeight: _,
    controlPaddingHorizontal: _e,
    zIndexPopupBase: tt,
    colorText: nt,
    fontWeightStrong: at,
    controlItemBgActive: ot,
    controlItemBgHover: rt,
    colorBgContainer: st,
    colorFillSecondary: lt,
    controlHeightLG: et,
    controlHeightSM: it,
    colorBgContainerDisabled: ut,
    colorTextDisabled: ft
  } = a;
  return {
    zIndexPopup: tt + 50,
    optionSelectedColor: nt,
    optionSelectedFontWeight: at,
    optionSelectedBg: ot,
    optionActiveBg: rt,
    optionPadding: `${(_ - s * $) / 2}px ${_e}px`,
    optionFontSize: s,
    optionLineHeight: $,
    optionHeight: _,
    selectorBg: st,
    clearBg: st,
    singleItemHeightLG: et,
    multipleItemBg: lt,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: it,
    multipleItemHeightLG: _,
    multipleSelectorBgDisabled: ut,
    multipleItemColorDisabled: ft,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(a.fontSize * 1.25)
  };
}, useSelectStyle = genStyleHooks("Select", (a, s) => {
  let {
    rootPrefixCls: $
  } = s;
  const _ = merge(a, {
    rootPrefixCls: $,
    inputPaddingHorizontalBase: a.calc(a.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: a.multipleItemHeight,
    selectHeight: a.controlHeight
  });
  return [genSelectStyle(_)];
}, prepareComponentToken$r, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
}), getBuiltInPlacements = (a) => {
  const $ = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: a === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, $), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, $), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, $), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, $), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function useBuiltinPlacements(a, s) {
  return a || getBuiltInPlacements(s);
}
var CheckOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
const CheckOutlinedSvg = CheckOutlined$2;
var CheckOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: CheckOutlinedSvg
  }));
};
const CheckOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(CheckOutlined);
var DownOutlined$5 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
const DownOutlinedSvg = DownOutlined$5;
var DownOutlined$3 = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: DownOutlinedSvg
  }));
};
const DownOutlined$4 = /* @__PURE__ */ reactExports.forwardRef(DownOutlined$3);
var SearchOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" };
const SearchOutlinedSvg = SearchOutlined$2;
var SearchOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: SearchOutlinedSvg
  }));
};
const SearchOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(SearchOutlined);
function useIcons(a) {
  let {
    suffixIcon: s,
    clearIcon: $,
    menuItemSelectedIcon: _,
    removeIcon: _e,
    loading: tt,
    multiple: nt,
    hasFeedback: at,
    prefixCls: ot,
    showSuffixIcon: rt,
    feedbackIcon: st,
    showArrow: lt,
    componentName: et
  } = a;
  const it = $ ?? /* @__PURE__ */ reactExports.createElement(CloseCircleFilled$1, null), ut = (gt) => s === null && !at && !lt ? null : /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, rt !== !1 && gt, at && st);
  let ft = null;
  if (s !== void 0)
    ft = ut(s);
  else if (tt)
    ft = ut(/* @__PURE__ */ reactExports.createElement(LoadingOutlined$1, {
      spin: !0
    }));
  else {
    const gt = `${ot}-suffix`;
    ft = (pt) => {
      let {
        open: mt,
        showSearch: ct
      } = pt;
      return ut(mt && ct ? /* @__PURE__ */ reactExports.createElement(SearchOutlined$1, {
        className: gt
      }) : /* @__PURE__ */ reactExports.createElement(DownOutlined$4, {
        className: gt
      }));
    };
  }
  let ht = null;
  _ !== void 0 ? ht = _ : nt ? ht = /* @__PURE__ */ reactExports.createElement(CheckOutlined$1, null) : ht = null;
  let dt = null;
  return _e !== void 0 ? dt = _e : dt = /* @__PURE__ */ reactExports.createElement(CloseOutlined$4, null), {
    clearIcon: it,
    suffixIcon: ft,
    itemIcon: ht,
    removeIcon: dt
  };
}
function useShowArrow(a, s) {
  return s !== void 0 ? s : a !== null;
}
var __rest$W = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE", InternalSelect = (a, s) => {
  var $, _, {
    prefixCls: _e,
    bordered: tt = !0,
    className: nt,
    rootClassName: at,
    getPopupContainer: ot,
    popupClassName: rt,
    dropdownClassName: st,
    listHeight: lt = 256,
    placement: et,
    listItemHeight: it = 24,
    size: ut,
    disabled: ft,
    notFoundContent: ht,
    status: dt,
    builtinPlacements: gt,
    dropdownMatchSelectWidth: pt,
    popupMatchSelectWidth: mt,
    direction: ct,
    style: vt,
    allowClear: At
  } = a, xt = __rest$W(a, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear"]);
  const {
    getPopupContainer: bt,
    getPrefixCls: Et,
    renderEmpty: St,
    direction: Bt,
    virtual: Ot,
    popupMatchSelectWidth: Pt,
    popupOverflow: wt,
    select: Ct
  } = reactExports.useContext(ConfigContext$1), It = Et("select", _e), yt = Et(), Rt = ct ?? Bt, {
    compactSize: kt,
    compactItemClassnames: jt
  } = useCompactItemContext(It, Rt), Ht = useCSSVarCls$1(It), [Ft, _t, Nt] = useSelectStyle(It, Ht), Mt = reactExports.useMemo(() => {
    const {
      mode: er
    } = xt;
    if (er !== "combobox")
      return er === SECRET_COMBOBOX_MODE_DO_NOT_USE ? "combobox" : er;
  }, [xt.mode]), Lt = Mt === "multiple" || Mt === "tags", $t = useShowArrow(xt.suffixIcon, xt.showArrow), Tt = ($ = mt ?? pt) !== null && $ !== void 0 ? $ : Pt, {
    status: Dt,
    hasFeedback: Ut,
    isFormItemInput: Vt,
    feedbackIcon: Qt
  } = reactExports.useContext(FormItemInputContext), qt = getMergedStatus(Dt, dt);
  let Zt;
  ht !== void 0 ? Zt = ht : Mt === "combobox" ? Zt = null : Zt = (St == null ? void 0 : St("Select")) || /* @__PURE__ */ reactExports.createElement(DefaultRenderEmpty$1, {
    componentName: "Select"
  });
  const {
    suffixIcon: ar,
    itemIcon: Jt,
    removeIcon: rr,
    clearIcon: Yt
  } = useIcons(Object.assign(Object.assign({}, xt), {
    multiple: Lt,
    hasFeedback: Ut,
    feedbackIcon: Qt,
    showSuffixIcon: $t,
    prefixCls: It,
    showArrow: xt.showArrow,
    componentName: "Select"
  })), Kt = At === !0 ? {
    clearIcon: Yt
  } : At, nr = omit(xt, ["suffixIcon", "itemIcon"]), tr = classnames(rt || st, {
    [`${It}-dropdown-${Rt}`]: Rt === "rtl"
  }, at, Nt, Ht, _t), ir = useSize$1((er) => {
    var lr;
    return (lr = ut ?? kt) !== null && lr !== void 0 ? lr : er;
  }), sr = reactExports.useContext(DisabledContext$1), cr = ft ?? sr, or = classnames({
    [`${It}-lg`]: ir === "large",
    [`${It}-sm`]: ir === "small",
    [`${It}-rtl`]: Rt === "rtl",
    [`${It}-borderless`]: !tt,
    [`${It}-in-form-item`]: Vt
  }, getStatusClassNames(It, qt, Ut), jt, Ct == null ? void 0 : Ct.className, nt, at, Nt, Ht, _t), Xt = reactExports.useMemo(() => et !== void 0 ? et : Rt === "rtl" ? "bottomRight" : "bottomLeft", [et, Rt]), Gt = useBuiltinPlacements(gt, wt), [Wt] = useZIndex("SelectLike", (_ = xt.dropdownStyle) === null || _ === void 0 ? void 0 : _.zIndex);
  return Ft(/* @__PURE__ */ reactExports.createElement(TypedSelect, Object.assign({
    ref: s,
    virtual: Ot,
    showSearch: Ct == null ? void 0 : Ct.showSearch
  }, nr, {
    style: Object.assign(Object.assign({}, Ct == null ? void 0 : Ct.style), vt),
    dropdownMatchSelectWidth: Tt,
    builtinPlacements: Gt,
    transitionName: getTransitionName$1(yt, "slide-up", xt.transitionName),
    listHeight: lt,
    listItemHeight: it,
    mode: Mt,
    prefixCls: It,
    placement: Xt,
    direction: Rt,
    suffixIcon: ar,
    menuItemSelectedIcon: Jt,
    removeIcon: rr,
    allowClear: Kt,
    notFoundContent: Zt,
    className: or,
    getPopupContainer: ot || bt,
    dropdownClassName: tr,
    disabled: cr,
    dropdownStyle: Object.assign(Object.assign({}, xt == null ? void 0 : xt.dropdownStyle), {
      zIndex: Wt
    })
  })));
}, Select = /* @__PURE__ */ reactExports.forwardRef(InternalSelect), PurePanel$8 = genPurePanel$1(Select);
Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;
Select.Option = Option;
Select.OptGroup = OptGroup;
Select._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$8;
const _Select = Select, responsiveArray = ["xxl", "xl", "lg", "md", "sm", "xs"], getResponsiveMap = (a) => ({
  xs: `(max-width: ${a.screenXSMax}px)`,
  sm: `(min-width: ${a.screenSM}px)`,
  md: `(min-width: ${a.screenMD}px)`,
  lg: `(min-width: ${a.screenLG}px)`,
  xl: `(min-width: ${a.screenXL}px)`,
  xxl: `(min-width: ${a.screenXXL}px)`
}), validateBreakpoints = (a) => {
  const s = a, $ = [].concat(responsiveArray).reverse();
  return $.forEach((_, _e) => {
    const tt = _.toUpperCase(), nt = `screen${tt}Min`, at = `screen${tt}`;
    if (!(s[nt] <= s[at]))
      throw new Error(`${nt}<=${at} fails : !(${s[nt]}<=${s[at]})`);
    if (_e < $.length - 1) {
      const ot = `screen${tt}Max`;
      if (!(s[at] <= s[ot]))
        throw new Error(`${at}<=${ot} fails : !(${s[at]}<=${s[ot]})`);
      const st = `screen${$[_e + 1].toUpperCase()}Min`;
      if (!(s[ot] <= s[st]))
        throw new Error(`${ot}<=${st} fails : !(${s[ot]}<=${s[st]})`);
    }
  }), a;
};
function useResponsiveObserver() {
  const [, a] = useToken$1(), s = getResponsiveMap(validateBreakpoints(a));
  return React$a.useMemo(() => {
    const $ = /* @__PURE__ */ new Map();
    let _ = -1, _e = {};
    return {
      matchHandlers: {},
      dispatch(tt) {
        return _e = tt, $.forEach((nt) => nt(_e)), $.size >= 1;
      },
      subscribe(tt) {
        return $.size || this.register(), _ += 1, $.set(_, tt), tt(_e), _;
      },
      unsubscribe(tt) {
        $.delete(tt), $.size || this.unregister();
      },
      unregister() {
        Object.keys(s).forEach((tt) => {
          const nt = s[tt], at = this.matchHandlers[nt];
          at == null || at.mql.removeListener(at == null ? void 0 : at.listener);
        }), $.clear();
      },
      register() {
        Object.keys(s).forEach((tt) => {
          const nt = s[tt], at = (rt) => {
            let {
              matches: st
            } = rt;
            this.dispatch(Object.assign(Object.assign({}, _e), {
              [tt]: st
            }));
          }, ot = window.matchMedia(nt);
          ot.addListener(at), this.matchHandlers[nt] = {
            mql: ot,
            listener: at
          }, at(ot);
        });
      },
      responsiveMap: s
    };
  }, [a]);
}
function useForceUpdate() {
  const [, a] = reactExports.useReducer((s) => s + 1, 0);
  return a;
}
function useBreakpoint() {
  let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  const s = reactExports.useRef({}), $ = useForceUpdate(), _ = useResponsiveObserver();
  return useLayoutEffect$1(() => {
    const _e = _.subscribe((tt) => {
      s.current = tt, a && $();
    });
    return () => _.unsubscribe(_e);
  }, []), s.current;
}
const getRenderPropValue = (a) => a ? typeof a == "function" ? a() : a : null;
function Popup$1(a) {
  var s = a.children, $ = a.prefixCls, _ = a.id, _e = a.overlayInnerStyle, tt = a.className, nt = a.style;
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat($, "-content"), tt),
    style: nt
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat($, "-inner"),
    id: _,
    role: "tooltip",
    style: _e
  }, typeof s == "function" ? s() : s));
}
var autoAdjustOverflowTopBottom = {
  shiftX: 64,
  adjustY: 1
}, autoAdjustOverflowLeftRight = {
  adjustX: 1,
  shiftY: !0
}, targetOffset$1 = [0, 0], placements$3 = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset$1
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset$1
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset$1
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset$1
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset$1
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset$1
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset: targetOffset$1
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset$1
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset$1
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset: targetOffset$1
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset: targetOffset$1
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset: targetOffset$1
  }
}, _excluded$G = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], Tooltip$1 = function a(s, $) {
  var _ = s.overlayClassName, _e = s.trigger, tt = _e === void 0 ? ["hover"] : _e, nt = s.mouseEnterDelay, at = nt === void 0 ? 0 : nt, ot = s.mouseLeaveDelay, rt = ot === void 0 ? 0.1 : ot, st = s.overlayStyle, lt = s.prefixCls, et = lt === void 0 ? "rc-tooltip" : lt, it = s.children, ut = s.onVisibleChange, ft = s.afterVisibleChange, ht = s.transitionName, dt = s.animation, gt = s.motion, pt = s.placement, mt = pt === void 0 ? "right" : pt, ct = s.align, vt = ct === void 0 ? {} : ct, At = s.destroyTooltipOnHide, xt = At === void 0 ? !1 : At, bt = s.defaultVisible, Et = s.getTooltipContainer, St = s.overlayInnerStyle;
  s.arrowContent;
  var Bt = s.overlay, Ot = s.id, Pt = s.showArrow, wt = Pt === void 0 ? !0 : Pt, Ct = _objectWithoutProperties$1(s, _excluded$G), It = reactExports.useRef(null);
  reactExports.useImperativeHandle($, function() {
    return It.current;
  });
  var yt = _objectSpread2$a({}, Ct);
  "visible" in s && (yt.popupVisible = s.visible);
  var Rt = function() {
    return /* @__PURE__ */ reactExports.createElement(Popup$1, {
      key: "content",
      prefixCls: et,
      id: Ot,
      overlayInnerStyle: St
    }, Bt);
  };
  return /* @__PURE__ */ reactExports.createElement(Trigger$1, _extends$2({
    popupClassName: _,
    prefixCls: et,
    popup: Rt,
    action: tt,
    builtinPlacements: placements$3,
    popupPlacement: mt,
    ref: It,
    popupAlign: vt,
    getPopupContainer: Et,
    onPopupVisibleChange: ut,
    afterPopupVisibleChange: ft,
    popupTransitionName: ht,
    popupAnimation: dt,
    popupMotion: gt,
    defaultPopupVisible: bt,
    autoDestroy: xt,
    mouseLeaveDelay: rt,
    popupStyle: st,
    mouseEnterDelay: at,
    arrow: wt
  }, yt), it);
};
const Tooltip$2 = /* @__PURE__ */ reactExports.forwardRef(Tooltip$1);
function getArrowToken(a) {
  const {
    sizePopupArrow: s,
    borderRadiusXS: $,
    borderRadiusOuter: _
  } = a, _e = s / 2, tt = 0, nt = _e, at = _ * 1 / Math.sqrt(2), ot = _e - _ * (1 - 1 / Math.sqrt(2)), rt = _e - $ * (1 / Math.sqrt(2)), st = _ * (Math.sqrt(2) - 1) + $ * (1 / Math.sqrt(2)), lt = 2 * _e - rt, et = st, it = 2 * _e - at, ut = ot, ft = 2 * _e - tt, ht = nt, dt = _e * Math.sqrt(2) + _ * (Math.sqrt(2) - 2), gt = _ * (Math.sqrt(2) - 1), pt = `polygon(${gt}px 100%, 50% ${gt}px, ${2 * _e - gt}px 100%, ${gt}px 100%)`, mt = `path('M ${tt} ${nt} A ${_} ${_} 0 0 0 ${at} ${ot} L ${rt} ${st} A ${$} ${$} 0 0 1 ${lt} ${et} L ${it} ${ut} A ${_} ${_} 0 0 0 ${ft} ${ht} Z')`;
  return {
    arrowShadowWidth: dt,
    arrowPath: mt,
    arrowPolygon: pt
  };
}
const genRoundedArrow = (a, s, $) => {
  const {
    sizePopupArrow: _,
    arrowPolygon: _e,
    arrowPath: tt,
    arrowShadowWidth: nt,
    borderRadiusXS: at,
    calc: ot
  } = a;
  return {
    pointerEvents: "none",
    width: _,
    height: _,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: _,
      height: ot(_).div(2).equal(),
      background: s,
      clipPath: {
        _multi_value_: !0,
        value: [_e, tt]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: nt,
      height: nt,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${unit$1(at)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: $,
      zIndex: 0,
      background: "transparent"
    }
  };
}, MAX_VERTICAL_CONTENT_RADIUS = 8;
function getArrowOffsetToken(a) {
  const {
    contentRadius: s,
    limitVerticalRadius: $
  } = a, _ = s > 12 ? s + 2 : 12;
  return {
    arrowOffsetHorizontal: _,
    arrowOffsetVertical: $ ? MAX_VERTICAL_CONTENT_RADIUS : _
  };
}
function isInject(a, s) {
  return a ? s : {};
}
function getArrowStyle(a, s, $) {
  const {
    componentCls: _,
    boxShadowPopoverArrow: _e,
    arrowOffsetVertical: tt,
    arrowOffsetHorizontal: nt
  } = a, {
    arrowDistance: at = 0,
    arrowPlacement: ot = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = $ || {};
  return {
    [_]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${_}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, genRoundedArrow(a, s, _e)), {
        "&:before": {
          background: s
        }
      })]
    }, isInject(!!ot.top, {
      [[`&-placement-top ${_}-arrow`, `&-placement-topLeft ${_}-arrow`, `&-placement-topRight ${_}-arrow`].join(",")]: {
        bottom: at,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top ${_}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      [`&-placement-topLeft ${_}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: nt
        }
      },
      [`&-placement-topRight ${_}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: nt
        }
      }
    })), isInject(!!ot.bottom, {
      [[`&-placement-bottom ${_}-arrow`, `&-placement-bottomLeft ${_}-arrow`, `&-placement-bottomRight ${_}-arrow`].join(",")]: {
        top: at,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom ${_}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      [`&-placement-bottomLeft ${_}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: nt
        }
      },
      [`&-placement-bottomRight ${_}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: nt
        }
      }
    })), isInject(!!ot.left, {
      [[`&-placement-left ${_}-arrow`, `&-placement-leftTop ${_}-arrow`, `&-placement-leftBottom ${_}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: at
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left ${_}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop ${_}-arrow`]: {
        top: tt
      },
      [`&-placement-leftBottom ${_}-arrow`]: {
        bottom: tt
      }
    })), isInject(!!ot.right, {
      [[`&-placement-right ${_}-arrow`, `&-placement-rightTop ${_}-arrow`, `&-placement-rightBottom ${_}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: at
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right ${_}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop ${_}-arrow`]: {
        top: tt
      },
      [`&-placement-rightBottom ${_}-arrow`]: {
        bottom: tt
      }
    }))
  };
}
function getOverflowOptions(a, s, $, _) {
  if (_ === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const _e = _ && typeof _ == "object" ? _ : {}, tt = {};
  switch (a) {
    case "top":
    case "bottom":
      tt.shiftX = s.arrowOffsetHorizontal * 2 + $, tt.shiftY = !0, tt.adjustY = !0;
      break;
    case "left":
    case "right":
      tt.shiftY = s.arrowOffsetVertical * 2 + $, tt.shiftX = !0, tt.adjustX = !0;
      break;
  }
  const nt = Object.assign(Object.assign({}, tt), _e);
  return nt.shiftX || (nt.adjustX = !0), nt.shiftY || (nt.adjustY = !0), nt;
}
const PlacementAlignMap = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, ArrowCenterPlacementAlignMap = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, DisableAutoArrowList = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function getPlacements(a) {
  const {
    arrowWidth: s,
    autoAdjustOverflow: $,
    arrowPointAtCenter: _,
    offset: _e,
    borderRadius: tt,
    visibleFirst: nt
  } = a, at = s / 2, ot = {};
  return Object.keys(PlacementAlignMap).forEach((rt) => {
    const st = _ && ArrowCenterPlacementAlignMap[rt] || PlacementAlignMap[rt], lt = Object.assign(Object.assign({}, st), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (ot[rt] = lt, DisableAutoArrowList.has(rt) && (lt.autoArrow = !1), rt) {
      case "top":
      case "topLeft":
      case "topRight":
        lt.offset[1] = -at - _e;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        lt.offset[1] = at + _e;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        lt.offset[0] = -at - _e;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        lt.offset[0] = at + _e;
        break;
    }
    const et = getArrowOffsetToken({
      contentRadius: tt,
      limitVerticalRadius: !0
    });
    if (_)
      switch (rt) {
        case "topLeft":
        case "bottomLeft":
          lt.offset[0] = -et.arrowOffsetHorizontal - at;
          break;
        case "topRight":
        case "bottomRight":
          lt.offset[0] = et.arrowOffsetHorizontal + at;
          break;
        case "leftTop":
        case "rightTop":
          lt.offset[1] = -et.arrowOffsetHorizontal - at;
          break;
        case "leftBottom":
        case "rightBottom":
          lt.offset[1] = et.arrowOffsetHorizontal + at;
          break;
      }
    lt.overflow = getOverflowOptions(rt, et, s, $), nt && (lt.htmlRegion = "visibleFirst");
  }), ot;
}
const genTooltipStyle = (a) => {
  const {
    componentCls: s,
    // ant-tooltip
    tooltipMaxWidth: $,
    tooltipColor: _,
    tooltipBg: _e,
    tooltipBorderRadius: tt,
    zIndexPopup: nt,
    controlHeight: at,
    boxShadowSecondary: ot,
    paddingSM: rt,
    paddingXS: st
  } = a;
  return [
    {
      [s]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
        position: "absolute",
        zIndex: nt,
        display: "block",
        width: "max-content",
        maxWidth: $,
        visibility: "visible",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": _e,
        // Wrapper for the tooltip content
        [`${s}-inner`]: {
          minWidth: at,
          minHeight: at,
          padding: `${unit$1(a.calc(rt).div(2).equal())} ${unit$1(st)}`,
          color: _,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: _e,
          borderRadius: tt,
          boxShadow: ot,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${s}-inner`]: {
            borderRadius: a.min(tt, MAX_VERTICAL_CONTENT_RADIUS)
          }
        },
        [`${s}-content`]: {
          position: "relative"
        }
      }), genPresetColor(a, (lt, et) => {
        let {
          darkColor: it
        } = et;
        return {
          [`&${s}-${lt}`]: {
            [`${s}-inner`]: {
              backgroundColor: it
            },
            [`${s}-arrow`]: {
              "--antd-arrow-background-color": it
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    getArrowStyle(a, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${s}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: a.sizePopupArrow
      }
    }
  ];
}, prepareComponentToken$q = (a) => Object.assign(Object.assign({
  zIndexPopup: a.zIndexPopupBase + 70
}, getArrowOffsetToken({
  contentRadius: a.borderRadius,
  limitVerticalRadius: !0
})), getArrowToken(merge(a, {
  borderRadiusOuter: Math.min(a.borderRadiusOuter, 4)
}))), useStyle$s = function(a) {
  let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return genStyleHooks("Tooltip", (_) => {
    const {
      borderRadius: _e,
      colorTextLightSolid: tt,
      colorBgSpotlight: nt
    } = _, at = merge(_, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: tt,
      tooltipBorderRadius: _e,
      tooltipBg: nt
    });
    return [genTooltipStyle(at), initZoomMotion(_, "zoom-big-fast")];
  }, prepareComponentToken$q, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: s
  })(a);
}, inverseColors = PresetColors.map((a) => `${a}-inverse`);
function isPresetColor(a) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(_toConsumableArray$d(inverseColors), _toConsumableArray$d(PresetColors)).includes(a) : PresetColors.includes(a);
}
function parseColor(a, s) {
  const $ = isPresetColor(s), _ = classnames({
    [`${a}-${s}`]: s && $
  }), _e = {}, tt = {};
  return s && !$ && (_e.background = s, tt["--antd-arrow-background-color"] = s), {
    className: _,
    overlayStyle: _e,
    arrowStyle: tt
  };
}
const PurePanel$6 = (a) => {
  const {
    prefixCls: s,
    className: $,
    placement: _ = "top",
    title: _e,
    color: tt,
    overlayInnerStyle: nt
  } = a, {
    getPrefixCls: at
  } = reactExports.useContext(ConfigContext$1), ot = at("tooltip", s), [rt, st, lt] = useStyle$s(ot), et = parseColor(ot, tt), it = et.arrowStyle, ut = Object.assign(Object.assign({}, nt), et.overlayStyle), ft = classnames(st, lt, ot, `${ot}-pure`, `${ot}-placement-${_}`, $, et.className);
  return rt(/* @__PURE__ */ reactExports.createElement("div", {
    className: ft,
    style: it
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${ot}-arrow`
  }), /* @__PURE__ */ reactExports.createElement(Popup$1, Object.assign({}, a, {
    className: st,
    prefixCls: ot,
    overlayInnerStyle: ut
  }), _e)));
}, PurePanel$7 = PurePanel$6;
var __rest$V = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Tooltip = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var $, _;
  const {
    prefixCls: _e,
    openClassName: tt,
    getTooltipContainer: nt,
    overlayClassName: at,
    color: ot,
    overlayInnerStyle: rt,
    children: st,
    afterOpenChange: lt,
    afterVisibleChange: et,
    destroyTooltipOnHide: it,
    arrow: ut = !0,
    title: ft,
    overlay: ht,
    builtinPlacements: dt,
    arrowPointAtCenter: gt = !1,
    autoAdjustOverflow: pt = !0
  } = a, mt = !!ut, [, ct] = useToken$1(), {
    getPopupContainer: vt,
    getPrefixCls: At,
    direction: xt
  } = reactExports.useContext(ConfigContext$1), bt = devUseWarning(), Et = reactExports.useRef(null), St = () => {
    var ir;
    (ir = Et.current) === null || ir === void 0 || ir.forceAlign();
  };
  reactExports.useImperativeHandle(s, () => ({
    forceAlign: St,
    forcePopupAlign: () => {
      bt.deprecated(!1, "forcePopupAlign", "forceAlign"), St();
    }
  }));
  const [Bt, Ot] = useMergedState(!1, {
    value: ($ = a.open) !== null && $ !== void 0 ? $ : a.visible,
    defaultValue: (_ = a.defaultOpen) !== null && _ !== void 0 ? _ : a.defaultVisible
  }), Pt = !ft && !ht && ft !== 0, wt = (ir) => {
    var sr, cr;
    Ot(Pt ? !1 : ir), Pt || ((sr = a.onOpenChange) === null || sr === void 0 || sr.call(a, ir), (cr = a.onVisibleChange) === null || cr === void 0 || cr.call(a, ir));
  }, Ct = reactExports.useMemo(() => {
    var ir, sr;
    let cr = gt;
    return typeof ut == "object" && (cr = (sr = (ir = ut.pointAtCenter) !== null && ir !== void 0 ? ir : ut.arrowPointAtCenter) !== null && sr !== void 0 ? sr : gt), dt || getPlacements({
      arrowPointAtCenter: cr,
      autoAdjustOverflow: pt,
      arrowWidth: mt ? ct.sizePopupArrow : 0,
      borderRadius: ct.borderRadius,
      offset: ct.marginXXS,
      visibleFirst: !0
    });
  }, [gt, ut, dt, ct]), It = reactExports.useMemo(() => ft === 0 ? ft : ht || ft || "", [ht, ft]), yt = /* @__PURE__ */ reactExports.createElement(NoCompactStyle, null, typeof It == "function" ? It() : It), {
    getPopupContainer: Rt,
    placement: kt = "top",
    mouseEnterDelay: jt = 0.1,
    mouseLeaveDelay: Ht = 0.1,
    overlayStyle: Ft,
    rootClassName: _t
  } = a, Nt = __rest$V(a, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]), Mt = At("tooltip", _e), Lt = At(), $t = a["data-popover-inject"];
  let Tt = Bt;
  !("open" in a) && !("visible" in a) && Pt && (Tt = !1);
  const Dt = isValidElement(st) && !isFragment(st) ? st : /* @__PURE__ */ reactExports.createElement("span", null, st), Ut = Dt.props, Vt = !Ut.className || typeof Ut.className == "string" ? classnames(Ut.className, tt || `${Mt}-open`) : Ut.className, [Qt, qt, Zt] = useStyle$s(Mt, !$t), ar = parseColor(Mt, ot), Jt = ar.arrowStyle, rr = Object.assign(Object.assign({}, rt), ar.overlayStyle), Yt = classnames(at, {
    [`${Mt}-rtl`]: xt === "rtl"
  }, ar.className, _t, qt, Zt), [Kt, nr] = useZIndex("Tooltip", Nt.zIndex), tr = /* @__PURE__ */ reactExports.createElement(Tooltip$2, Object.assign({}, Nt, {
    zIndex: Kt,
    showArrow: mt,
    placement: kt,
    mouseEnterDelay: jt,
    mouseLeaveDelay: Ht,
    prefixCls: Mt,
    overlayClassName: Yt,
    overlayStyle: Object.assign(Object.assign({}, Jt), Ft),
    getTooltipContainer: Rt || nt || vt,
    ref: Et,
    builtinPlacements: Ct,
    overlay: yt,
    visible: Tt,
    onVisibleChange: wt,
    afterVisibleChange: lt ?? et,
    overlayInnerStyle: rr,
    arrowContent: /* @__PURE__ */ reactExports.createElement("span", {
      className: `${Mt}-arrow-content`
    }),
    motion: {
      motionName: getTransitionName$1(Lt, "zoom-big-fast", a.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!it
  }), Tt ? cloneElement(Dt, {
    className: Vt
  }) : Dt);
  return Qt(/* @__PURE__ */ reactExports.createElement(zIndexContext$1.Provider, {
    value: nr
  }, tr));
});
Tooltip._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$7;
const _Tooltip = Tooltip, genBaseStyle$a = (a) => {
  const {
    componentCls: s,
    popoverColor: $,
    titleMinWidth: _,
    fontWeightStrong: _e,
    innerPadding: tt,
    boxShadowSecondary: nt,
    colorTextHeading: at,
    borderRadiusLG: ot,
    zIndexPopup: rt,
    titleMarginBottom: st,
    colorBgElevated: lt,
    popoverBg: et,
    titleBorderBottom: it,
    innerContentPadding: ut,
    titlePadding: ft
  } = a;
  return [
    {
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: !0,
          value: 0
        },
        zIndex: rt,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "--antd-arrow-background-color": lt,
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${s}-content`]: {
          position: "relative"
        },
        [`${s}-inner`]: {
          backgroundColor: et,
          backgroundClip: "padding-box",
          borderRadius: ot,
          boxShadow: nt,
          padding: tt
        },
        [`${s}-title`]: {
          minWidth: _,
          marginBottom: st,
          color: at,
          fontWeight: _e,
          borderBottom: it,
          padding: ft
        },
        [`${s}-inner-content`]: {
          color: $,
          padding: ut
        }
      })
    },
    // Arrow Style
    getArrowStyle(a, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${s}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: a.sizePopupArrow,
        display: "inline-block",
        [`${s}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
}, genColorStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: PresetColors.map(($) => {
      const _ = a[`${$}6`];
      return {
        [`&${s}-${$}`]: {
          "--antd-arrow-background-color": _,
          [`${s}-inner`]: {
            backgroundColor: _
          },
          [`${s}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
}, prepareComponentToken$p = (a) => {
  const {
    lineWidth: s,
    controlHeight: $,
    fontHeight: _,
    padding: _e,
    wireframe: tt,
    zIndexPopupBase: nt,
    borderRadiusLG: at,
    marginXS: ot,
    lineType: rt,
    colorSplit: st,
    paddingSM: lt
  } = a, et = $ - _, it = et / 2, ut = et / 2 - s, ft = _e;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: nt + 30
  }, getArrowToken(a)), getArrowOffsetToken({
    contentRadius: at,
    limitVerticalRadius: !0
  })), {
    // internal
    innerPadding: tt ? 0 : 12,
    titleMarginBottom: tt ? 0 : ot,
    titlePadding: tt ? `${it}px ${ft}px ${ut}px` : 0,
    titleBorderBottom: tt ? `${s}px ${rt} ${st}` : "none",
    innerContentPadding: tt ? `${lt}px ${ft}px` : 0
  });
}, useStyle$r = genStyleHooks("Popover", (a) => {
  const {
    colorBgElevated: s,
    colorText: $
  } = a, _ = merge(a, {
    popoverBg: s,
    popoverColor: $
  });
  return [genBaseStyle$a(_), genColorStyle(_), initZoomMotion(_, "zoom-big")];
}, prepareComponentToken$p, {
  resetStyle: !1,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});
var __rest$U = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const getOverlay = (a, s, $) => {
  if (!(!s && !$))
    return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, s && /* @__PURE__ */ reactExports.createElement("div", {
      className: `${a}-title`
    }, getRenderPropValue(s)), /* @__PURE__ */ reactExports.createElement("div", {
      className: `${a}-inner-content`
    }, getRenderPropValue($)));
}, RawPurePanel = (a) => {
  const {
    hashId: s,
    prefixCls: $,
    className: _,
    style: _e,
    placement: tt = "top",
    title: nt,
    content: at,
    children: ot
  } = a;
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(s, $, `${$}-pure`, `${$}-placement-${tt}`, _),
    style: _e
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${$}-arrow`
  }), /* @__PURE__ */ reactExports.createElement(Popup$1, Object.assign({}, a, {
    className: s,
    prefixCls: $
  }), ot || getOverlay($, nt, at)));
}, PurePanel$5 = (a) => {
  const {
    prefixCls: s,
    className: $
  } = a, _ = __rest$U(a, ["prefixCls", "className"]), {
    getPrefixCls: _e
  } = reactExports.useContext(ConfigContext$1), tt = _e("popover", s), [nt, at, ot] = useStyle$r(tt);
  return nt(/* @__PURE__ */ reactExports.createElement(RawPurePanel, Object.assign({}, _, {
    prefixCls: tt,
    hashId: at,
    className: classnames($, ot)
  })));
}, PopoverPurePanel = PurePanel$5;
var __rest$T = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Overlay$2 = (a) => {
  let {
    title: s,
    content: $,
    prefixCls: _
  } = a;
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, s && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${_}-title`
  }, getRenderPropValue(s)), /* @__PURE__ */ reactExports.createElement("div", {
    className: `${_}-inner-content`
  }, getRenderPropValue($)));
}, Popover = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: $,
    title: _,
    content: _e,
    overlayClassName: tt,
    placement: nt = "top",
    trigger: at = "hover",
    mouseEnterDelay: ot = 0.1,
    mouseLeaveDelay: rt = 0.1,
    overlayStyle: st = {}
  } = a, lt = __rest$T(a, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle"]), {
    getPrefixCls: et
  } = reactExports.useContext(ConfigContext$1), it = et("popover", $), [ut, ft, ht] = useStyle$r(it), dt = et(), gt = classnames(tt, ft, ht);
  return ut(/* @__PURE__ */ reactExports.createElement(_Tooltip, Object.assign({
    placement: nt,
    trigger: at,
    mouseEnterDelay: ot,
    mouseLeaveDelay: rt,
    overlayStyle: st
  }, lt, {
    prefixCls: it,
    overlayClassName: gt,
    ref: s,
    overlay: _ || _e ? /* @__PURE__ */ reactExports.createElement(Overlay$2, {
      prefixCls: it,
      title: _,
      content: _e
    }) : null,
    transitionName: getTransitionName$1(dt, "zoom-big", lt.transitionName),
    "data-popover-inject": !0
  })));
});
Popover._InternalPanelDoNotUseOrYouWillBeFired = PopoverPurePanel;
const _Popover = Popover;
var RightOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" };
const RightOutlinedSvg = RightOutlined$2;
var RightOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: RightOutlinedSvg
  }));
};
const RightOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(RightOutlined);
var ESC$1 = KeyCode.ESC, TAB = KeyCode.TAB;
function useAccessibility$1(a) {
  var s = a.visible, $ = a.triggerRef, _ = a.onVisibleChange, _e = a.autoFocus, tt = a.overlayRef, nt = reactExports.useRef(!1), at = function() {
    if (s) {
      var lt, et;
      (lt = $.current) === null || lt === void 0 || (et = lt.focus) === null || et === void 0 || et.call(lt), _ == null || _(!1);
    }
  }, ot = function() {
    var lt;
    return (lt = tt.current) !== null && lt !== void 0 && lt.focus ? (tt.current.focus(), nt.current = !0, !0) : !1;
  }, rt = function(lt) {
    switch (lt.keyCode) {
      case ESC$1:
        at();
        break;
      case TAB: {
        var et = !1;
        nt.current || (et = ot()), et ? lt.preventDefault() : at();
        break;
      }
    }
  };
  reactExports.useEffect(function() {
    return s ? (window.addEventListener("keydown", rt), _e && wrapperRaf(ot, 3), function() {
      window.removeEventListener("keydown", rt), nt.current = !1;
    }) : function() {
      nt.current = !1;
    };
  }, [s]);
}
var Overlay$1 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.overlay, _ = a.arrow, _e = a.prefixCls, tt = reactExports.useMemo(function() {
    var at;
    return typeof $ == "function" ? at = $() : at = $, at;
  }, [$]), nt = composeRef(s, tt == null ? void 0 : tt.ref);
  return /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, _ && /* @__PURE__ */ React$a.createElement("div", {
    className: "".concat(_e, "-arrow")
  }), /* @__PURE__ */ React$a.cloneElement(tt, {
    ref: supportRef(tt) ? nt : void 0
  }));
}), autoAdjustOverflow$1 = {
  adjustX: 1,
  adjustY: 1
}, targetOffset = [0, 0], placements$2 = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  }
}, _excluded$F = ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger", "autoFocus", "overlay", "children", "onVisibleChange"];
function Dropdown$3(a, s) {
  var $, _ = a.arrow, _e = _ === void 0 ? !1 : _, tt = a.prefixCls, nt = tt === void 0 ? "rc-dropdown" : tt, at = a.transitionName, ot = a.animation, rt = a.align, st = a.placement, lt = st === void 0 ? "bottomLeft" : st, et = a.placements, it = et === void 0 ? placements$2 : et, ut = a.getPopupContainer, ft = a.showAction, ht = a.hideAction, dt = a.overlayClassName, gt = a.overlayStyle, pt = a.visible, mt = a.trigger, ct = mt === void 0 ? ["hover"] : mt, vt = a.autoFocus, At = a.overlay, xt = a.children, bt = a.onVisibleChange, Et = _objectWithoutProperties$1(a, _excluded$F), St = React$a.useState(), Bt = _slicedToArray$e(St, 2), Ot = Bt[0], Pt = Bt[1], wt = "visible" in a ? pt : Ot, Ct = React$a.useRef(null), It = React$a.useRef(null), yt = React$a.useRef(null);
  React$a.useImperativeHandle(s, function() {
    return Ct.current;
  });
  var Rt = function($t) {
    Pt($t), bt == null || bt($t);
  };
  useAccessibility$1({
    visible: wt,
    triggerRef: yt,
    onVisibleChange: Rt,
    autoFocus: vt,
    overlayRef: It
  });
  var kt = function($t) {
    var Tt = a.onOverlayClick;
    Pt(!1), Tt && Tt($t);
  }, jt = function() {
    return /* @__PURE__ */ React$a.createElement(Overlay$1, {
      ref: It,
      overlay: At,
      prefixCls: nt,
      arrow: _e
    });
  }, Ht = function() {
    return typeof At == "function" ? jt : jt();
  }, Ft = function() {
    var $t = a.minOverlayWidthMatchTrigger, Tt = a.alignPoint;
    return "minOverlayWidthMatchTrigger" in a ? $t : !Tt;
  }, _t = function() {
    var $t = a.openClassName;
    return $t !== void 0 ? $t : "".concat(nt, "-open");
  }, Nt = /* @__PURE__ */ React$a.cloneElement(xt, {
    className: classnames(($ = xt.props) === null || $ === void 0 ? void 0 : $.className, wt && _t()),
    ref: supportRef(xt) ? composeRef(yt, xt.ref) : void 0
  }), Mt = ht;
  return !Mt && ct.indexOf("contextMenu") !== -1 && (Mt = ["click"]), /* @__PURE__ */ React$a.createElement(Trigger$1, _extends$2({
    builtinPlacements: it
  }, Et, {
    prefixCls: nt,
    ref: Ct,
    popupClassName: classnames(dt, _defineProperty$c({}, "".concat(nt, "-show-arrow"), _e)),
    popupStyle: gt,
    action: ct,
    showAction: ft,
    hideAction: Mt,
    popupPlacement: lt,
    popupAlign: rt,
    popupTransitionName: at,
    popupAnimation: ot,
    popupVisible: wt,
    stretch: Ft() ? "minWidth" : "",
    popup: Ht(),
    onPopupVisibleChange: Rt,
    onPopupClick: kt,
    getPopupContainer: ut
  }), Nt);
}
const Dropdown$4 = /* @__PURE__ */ React$a.forwardRef(Dropdown$3);
var IdContext = /* @__PURE__ */ reactExports.createContext(null);
function getMenuId(a, s) {
  return a === void 0 ? null : "".concat(a, "-").concat(s);
}
function useMenuId(a) {
  var s = reactExports.useContext(IdContext);
  return getMenuId(s, a);
}
var _excluded$E = ["children", "locked"], MenuContext$2 = /* @__PURE__ */ reactExports.createContext(null);
function mergeProps(a, s) {
  var $ = _objectSpread2$a({}, a);
  return Object.keys(s).forEach(function(_) {
    var _e = s[_];
    _e !== void 0 && ($[_] = _e);
  }), $;
}
function InheritableContextProvider(a) {
  var s = a.children, $ = a.locked, _ = _objectWithoutProperties$1(a, _excluded$E), _e = reactExports.useContext(MenuContext$2), tt = useMemo(function() {
    return mergeProps(_e, _);
  }, [_e, _], function(nt, at) {
    return !$ && (nt[0] !== at[0] || !isEqual$1(nt[1], at[1], !0));
  });
  return /* @__PURE__ */ reactExports.createElement(MenuContext$2.Provider, {
    value: tt
  }, s);
}
var EmptyList = [], PathRegisterContext = /* @__PURE__ */ reactExports.createContext(null);
function useMeasure() {
  return reactExports.useContext(PathRegisterContext);
}
var PathTrackerContext = /* @__PURE__ */ reactExports.createContext(EmptyList);
function useFullPath(a) {
  var s = reactExports.useContext(PathTrackerContext);
  return reactExports.useMemo(function() {
    return a !== void 0 ? [].concat(_toConsumableArray$d(s), [a]) : s;
  }, [s, a]);
}
var PathUserContext = /* @__PURE__ */ reactExports.createContext(null), PrivateContext = /* @__PURE__ */ reactExports.createContext({});
function focusable(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (isVisible(a)) {
    var $ = a.nodeName.toLowerCase(), _ = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes($) || // Editable element
      a.isContentEditable || // Anchor with href element
      $ === "a" && !!a.getAttribute("href")
    ), _e = a.getAttribute("tabindex"), tt = Number(_e), nt = null;
    return _e && !Number.isNaN(tt) ? nt = tt : _ && nt === null && (nt = 0), _ && a.disabled && (nt = null), nt !== null && (nt >= 0 || s && nt < 0);
  }
  return !1;
}
function getFocusNodeList(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, $ = _toConsumableArray$d(a.querySelectorAll("*")).filter(function(_) {
    return focusable(_, s);
  });
  return focusable(a, s) && $.unshift(a), $;
}
var LEFT$1 = KeyCode.LEFT, RIGHT = KeyCode.RIGHT, UP = KeyCode.UP, DOWN = KeyCode.DOWN, ENTER = KeyCode.ENTER, ESC = KeyCode.ESC, HOME = KeyCode.HOME, END = KeyCode.END, ArrowKeys = [UP, DOWN, LEFT$1, RIGHT];
function getOffset$3(a, s, $, _) {
  var _e, tt, nt, at, ot = "prev", rt = "next", st = "children", lt = "parent";
  if (a === "inline" && _ === ENTER)
    return {
      inlineTrigger: !0
    };
  var et = (_e = {}, _defineProperty$c(_e, UP, ot), _defineProperty$c(_e, DOWN, rt), _e), it = (tt = {}, _defineProperty$c(tt, LEFT$1, $ ? rt : ot), _defineProperty$c(tt, RIGHT, $ ? ot : rt), _defineProperty$c(tt, DOWN, st), _defineProperty$c(tt, ENTER, st), tt), ut = (nt = {}, _defineProperty$c(nt, UP, ot), _defineProperty$c(nt, DOWN, rt), _defineProperty$c(nt, ENTER, st), _defineProperty$c(nt, ESC, lt), _defineProperty$c(nt, LEFT$1, $ ? st : lt), _defineProperty$c(nt, RIGHT, $ ? lt : st), nt), ft = {
    inline: et,
    horizontal: it,
    vertical: ut,
    inlineSub: et,
    horizontalSub: ut,
    verticalSub: ut
  }, ht = (at = ft["".concat(a).concat(s ? "" : "Sub")]) === null || at === void 0 ? void 0 : at[_];
  switch (ht) {
    case ot:
      return {
        offset: -1,
        sibling: !0
      };
    case rt:
      return {
        offset: 1,
        sibling: !0
      };
    case lt:
      return {
        offset: -1,
        sibling: !1
      };
    case st:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function findContainerUL(a) {
  for (var s = a; s; ) {
    if (s.getAttribute("data-menu-list"))
      return s;
    s = s.parentElement;
  }
  return null;
}
function getFocusElement(a, s) {
  for (var $ = a || document.activeElement; $; ) {
    if (s.has($))
      return $;
    $ = $.parentElement;
  }
  return null;
}
function getFocusableElements(a, s) {
  var $ = getFocusNodeList(a, !0);
  return $.filter(function(_) {
    return s.has(_);
  });
}
function getNextFocusElement(a, s, $) {
  var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!a)
    return null;
  var _e = getFocusableElements(a, s), tt = _e.length, nt = _e.findIndex(function(at) {
    return $ === at;
  });
  return _ < 0 ? nt === -1 ? nt = tt - 1 : nt -= 1 : _ > 0 && (nt += 1), nt = (nt + tt) % tt, _e[nt];
}
var refreshElements = function a(s, $) {
  var _ = /* @__PURE__ */ new Set(), _e = /* @__PURE__ */ new Map(), tt = /* @__PURE__ */ new Map();
  return s.forEach(function(nt) {
    var at = document.querySelector("[data-menu-id='".concat(getMenuId($, nt), "']"));
    at && (_.add(at), tt.set(at, nt), _e.set(nt, at));
  }), {
    elements: _,
    key2element: _e,
    element2key: tt
  };
};
function useAccessibility(a, s, $, _, _e, tt, nt, at, ot, rt) {
  var st = reactExports.useRef(), lt = reactExports.useRef();
  lt.current = s;
  var et = function() {
    wrapperRaf.cancel(st.current);
  };
  return reactExports.useEffect(function() {
    return function() {
      et();
    };
  }, []), function(it) {
    var ut = it.which;
    if ([].concat(ArrowKeys, [ENTER, ESC, HOME, END]).includes(ut)) {
      var ft = tt(), ht = refreshElements(ft, _), dt = ht, gt = dt.elements, pt = dt.key2element, mt = dt.element2key, ct = pt.get(s), vt = getFocusElement(ct, gt), At = mt.get(vt), xt = getOffset$3(a, nt(At, !0).length === 1, $, ut);
      if (!xt && ut !== HOME && ut !== END)
        return;
      (ArrowKeys.includes(ut) || [HOME, END].includes(ut)) && it.preventDefault();
      var bt = function(It) {
        if (It) {
          var yt = It, Rt = It.querySelector("a");
          Rt != null && Rt.getAttribute("href") && (yt = Rt);
          var kt = mt.get(It);
          at(kt), et(), st.current = wrapperRaf(function() {
            lt.current === kt && yt.focus();
          });
        }
      };
      if ([HOME, END].includes(ut) || xt.sibling || !vt) {
        var Et;
        !vt || a === "inline" ? Et = _e.current : Et = findContainerUL(vt);
        var St, Bt = getFocusableElements(Et, gt);
        ut === HOME ? St = Bt[0] : ut === END ? St = Bt[Bt.length - 1] : St = getNextFocusElement(Et, gt, vt, xt.offset), bt(St);
      } else if (xt.inlineTrigger)
        ot(At);
      else if (xt.offset > 0)
        ot(At, !0), et(), st.current = wrapperRaf(function() {
          ht = refreshElements(ft, _);
          var Ct = vt.getAttribute("aria-controls"), It = document.getElementById(Ct), yt = getNextFocusElement(It, ht.elements);
          bt(yt);
        }, 5);
      else if (xt.offset < 0) {
        var Ot = nt(At, !0), Pt = Ot[Ot.length - 2], wt = pt.get(Pt);
        ot(Pt, !1), bt(wt);
      }
    }
    rt == null || rt(it);
  };
}
function nextSlice(a) {
  Promise.resolve().then(a);
}
var PATH_SPLIT = "__RC_UTIL_PATH_SPLIT__", getPathStr = function a(s) {
  return s.join(PATH_SPLIT);
}, getPathKeys = function a(s) {
  return s.split(PATH_SPLIT);
}, OVERFLOW_KEY = "rc-menu-more";
function useKeyRecords() {
  var a = reactExports.useState({}), s = _slicedToArray$e(a, 2), $ = s[1], _ = reactExports.useRef(/* @__PURE__ */ new Map()), _e = reactExports.useRef(/* @__PURE__ */ new Map()), tt = reactExports.useState([]), nt = _slicedToArray$e(tt, 2), at = nt[0], ot = nt[1], rt = reactExports.useRef(0), st = reactExports.useRef(!1), lt = function() {
    st.current || $({});
  }, et = reactExports.useCallback(function(pt, mt) {
    var ct = getPathStr(mt);
    _e.current.set(ct, pt), _.current.set(pt, ct), rt.current += 1;
    var vt = rt.current;
    nextSlice(function() {
      vt === rt.current && lt();
    });
  }, []), it = reactExports.useCallback(function(pt, mt) {
    var ct = getPathStr(mt);
    _e.current.delete(ct), _.current.delete(pt);
  }, []), ut = reactExports.useCallback(function(pt) {
    ot(pt);
  }, []), ft = reactExports.useCallback(function(pt, mt) {
    var ct = _.current.get(pt) || "", vt = getPathKeys(ct);
    return mt && at.includes(vt[0]) && vt.unshift(OVERFLOW_KEY), vt;
  }, [at]), ht = reactExports.useCallback(function(pt, mt) {
    return pt.some(function(ct) {
      var vt = ft(ct, !0);
      return vt.includes(mt);
    });
  }, [ft]), dt = function() {
    var mt = _toConsumableArray$d(_.current.keys());
    return at.length && mt.push(OVERFLOW_KEY), mt;
  }, gt = reactExports.useCallback(function(pt) {
    var mt = "".concat(_.current.get(pt)).concat(PATH_SPLIT), ct = /* @__PURE__ */ new Set();
    return _toConsumableArray$d(_e.current.keys()).forEach(function(vt) {
      vt.startsWith(mt) && ct.add(_e.current.get(vt));
    }), ct;
  }, []);
  return reactExports.useEffect(function() {
    return function() {
      st.current = !0;
    };
  }, []), {
    // Register
    registerPath: et,
    unregisterPath: it,
    refreshOverflowKeys: ut,
    // Util
    isSubPathKey: ht,
    getKeyPath: ft,
    getKeys: dt,
    getSubPathKeys: gt
  };
}
function useMemoCallback(a) {
  var s = reactExports.useRef(a);
  s.current = a;
  var $ = reactExports.useCallback(function() {
    for (var _, _e = arguments.length, tt = new Array(_e), nt = 0; nt < _e; nt++)
      tt[nt] = arguments[nt];
    return (_ = s.current) === null || _ === void 0 ? void 0 : _.call.apply(_, [s].concat(tt));
  }, []);
  return a ? $ : void 0;
}
var uniquePrefix = Math.random().toFixed(5).toString().slice(2), internalId = 0;
function useUUID(a) {
  var s = useMergedState(a, {
    value: a
  }), $ = _slicedToArray$e(s, 2), _ = $[0], _e = $[1];
  return reactExports.useEffect(function() {
    internalId += 1;
    var tt = "".concat(uniquePrefix, "-").concat(internalId);
    _e("rc-menu-uuid-".concat(tt));
  }, []), _;
}
function useActive(a, s, $, _) {
  var _e = reactExports.useContext(MenuContext$2), tt = _e.activeKey, nt = _e.onActive, at = _e.onInactive, ot = {
    active: tt === a
  };
  return s || (ot.onMouseEnter = function(rt) {
    $ == null || $({
      key: a,
      domEvent: rt
    }), nt(a);
  }, ot.onMouseLeave = function(rt) {
    _ == null || _({
      key: a,
      domEvent: rt
    }), at(a);
  }), ot;
}
function useDirectionStyle(a) {
  var s = reactExports.useContext(MenuContext$2), $ = s.mode, _ = s.rtl, _e = s.inlineIndent;
  if ($ !== "inline")
    return null;
  var tt = a;
  return _ ? {
    paddingRight: tt * _e
  } : {
    paddingLeft: tt * _e
  };
}
function Icon$1(a) {
  var s = a.icon, $ = a.props, _ = a.children, _e;
  return s === null || s === !1 ? null : (typeof s == "function" ? _e = /* @__PURE__ */ reactExports.createElement(s, _objectSpread2$a({}, $)) : typeof s != "boolean" && (_e = s), _e || _ || null);
}
var _excluded$D = ["item"];
function warnItemProp(a) {
  var s = a.item, $ = _objectWithoutProperties$1(a, _excluded$D);
  return Object.defineProperty($, "item", {
    get: function() {
      return warningOnce(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), s;
    }
  }), $;
}
var _excluded$C = ["title", "attribute", "elementRef"], _excluded2$9 = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], _excluded3 = ["active"], LegacyMenuItem = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $() {
    return _classCallCheck(this, $), s.apply(this, arguments);
  }
  return _createClass($, [{
    key: "render",
    value: function() {
      var _e = this.props, tt = _e.title, nt = _e.attribute, at = _e.elementRef, ot = _objectWithoutProperties$1(_e, _excluded$C), rt = omit(ot, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return warningOnce(!nt, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ reactExports.createElement(ForwardOverflow.Item, _extends$2({}, nt, {
        title: typeof tt == "string" ? tt : void 0
      }, rt, {
        ref: at
      }));
    }
  }]), $;
}(reactExports.Component), InternalMenuItem = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _ = a.style, _e = a.className, tt = a.eventKey;
  a.warnKey;
  var nt = a.disabled, at = a.itemIcon, ot = a.children, rt = a.role, st = a.onMouseEnter, lt = a.onMouseLeave, et = a.onClick, it = a.onKeyDown, ut = a.onFocus, ft = _objectWithoutProperties$1(a, _excluded2$9), ht = useMenuId(tt), dt = reactExports.useContext(MenuContext$2), gt = dt.prefixCls, pt = dt.onItemClick, mt = dt.disabled, ct = dt.overflowDisabled, vt = dt.itemIcon, At = dt.selectedKeys, xt = dt.onActive, bt = reactExports.useContext(PrivateContext), Et = bt._internalRenderMenuItem, St = "".concat(gt, "-item"), Bt = reactExports.useRef(), Ot = reactExports.useRef(), Pt = mt || nt, wt = useComposeRef(s, Ot), Ct = useFullPath(tt), It = function(Dt) {
    return {
      key: tt,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: _toConsumableArray$d(Ct).reverse(),
      item: Bt.current,
      domEvent: Dt
    };
  }, yt = at || vt, Rt = useActive(tt, Pt, st, lt), kt = Rt.active, jt = _objectWithoutProperties$1(Rt, _excluded3), Ht = At.includes(tt), Ft = useDirectionStyle(Ct.length), _t = function(Dt) {
    if (!Pt) {
      var Ut = It(Dt);
      et == null || et(warnItemProp(Ut)), pt(Ut);
    }
  }, Nt = function(Dt) {
    if (it == null || it(Dt), Dt.which === KeyCode.ENTER) {
      var Ut = It(Dt);
      et == null || et(warnItemProp(Ut)), pt(Ut);
    }
  }, Mt = function(Dt) {
    xt(tt), ut == null || ut(Dt);
  }, Lt = {};
  a.role === "option" && (Lt["aria-selected"] = Ht);
  var $t = /* @__PURE__ */ reactExports.createElement(LegacyMenuItem, _extends$2({
    ref: Bt,
    elementRef: wt,
    role: rt === null ? "none" : rt || "menuitem",
    tabIndex: nt ? null : -1,
    "data-menu-id": ct && ht ? null : ht
  }, ft, jt, Lt, {
    component: "li",
    "aria-disabled": nt,
    style: _objectSpread2$a(_objectSpread2$a({}, Ft), _),
    className: classnames(St, ($ = {}, _defineProperty$c($, "".concat(St, "-active"), kt), _defineProperty$c($, "".concat(St, "-selected"), Ht), _defineProperty$c($, "".concat(St, "-disabled"), Pt), $), _e),
    onClick: _t,
    onKeyDown: Nt,
    onFocus: Mt
  }), ot, /* @__PURE__ */ reactExports.createElement(Icon$1, {
    props: _objectSpread2$a(_objectSpread2$a({}, a), {}, {
      isSelected: Ht
    }),
    icon: yt
  }));
  return Et && ($t = Et($t, a, {
    selected: Ht
  })), $t;
});
function MenuItem$1(a, s) {
  var $ = a.eventKey, _ = useMeasure(), _e = useFullPath($);
  return reactExports.useEffect(function() {
    if (_)
      return _.registerPath($, _e), function() {
        _.unregisterPath($, _e);
      };
  }, [_e]), _ ? null : /* @__PURE__ */ reactExports.createElement(InternalMenuItem, _extends$2({}, a, {
    ref: s
  }));
}
const MenuItem$2 = /* @__PURE__ */ reactExports.forwardRef(MenuItem$1);
var _excluded$B = ["className", "children"], InternalSubMenuList = function a(s, $) {
  var _ = s.className, _e = s.children, tt = _objectWithoutProperties$1(s, _excluded$B), nt = reactExports.useContext(MenuContext$2), at = nt.prefixCls, ot = nt.mode, rt = nt.rtl;
  return /* @__PURE__ */ reactExports.createElement("ul", _extends$2({
    className: classnames(at, rt && "".concat(at, "-rtl"), "".concat(at, "-sub"), "".concat(at, "-").concat(ot === "inline" ? "inline" : "vertical"), _),
    role: "menu"
  }, tt, {
    "data-menu-list": !0,
    ref: $
  }), _e);
}, SubMenuList = /* @__PURE__ */ reactExports.forwardRef(InternalSubMenuList);
SubMenuList.displayName = "SubMenuList";
function parseChildren(a, s) {
  return toArray$9(a).map(function($, _) {
    if (/* @__PURE__ */ reactExports.isValidElement($)) {
      var _e, tt, nt = $.key, at = (_e = (tt = $.props) === null || tt === void 0 ? void 0 : tt.eventKey) !== null && _e !== void 0 ? _e : nt, ot = at == null;
      ot && (at = "tmp_key-".concat([].concat(_toConsumableArray$d(s), [_]).join("-")));
      var rt = {
        key: at,
        eventKey: at
      };
      return /* @__PURE__ */ reactExports.cloneElement($, rt);
    }
    return $;
  });
}
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
}, placements$1 = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow
  }
}, placementsRtl = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow
  }
};
function getMotion(a, s, $) {
  if (s)
    return s;
  if ($)
    return $[a] || $.other;
}
var popupPlacementMap = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function PopupTrigger(a) {
  var s = a.prefixCls, $ = a.visible, _ = a.children, _e = a.popup, tt = a.popupStyle, nt = a.popupClassName, at = a.popupOffset, ot = a.disabled, rt = a.mode, st = a.onVisibleChange, lt = reactExports.useContext(MenuContext$2), et = lt.getPopupContainer, it = lt.rtl, ut = lt.subMenuOpenDelay, ft = lt.subMenuCloseDelay, ht = lt.builtinPlacements, dt = lt.triggerSubMenuAction, gt = lt.forceSubMenuRender, pt = lt.rootClassName, mt = lt.motion, ct = lt.defaultMotions, vt = reactExports.useState(!1), At = _slicedToArray$e(vt, 2), xt = At[0], bt = At[1], Et = _objectSpread2$a(it ? _objectSpread2$a({}, placementsRtl) : _objectSpread2$a({}, placements$1), ht), St = popupPlacementMap[rt], Bt = getMotion(rt, mt, ct), Ot = reactExports.useRef(Bt);
  rt !== "inline" && (Ot.current = Bt);
  var Pt = _objectSpread2$a(_objectSpread2$a({}, Ot.current), {}, {
    leavedClassName: "".concat(s, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), wt = reactExports.useRef();
  return reactExports.useEffect(function() {
    return wt.current = wrapperRaf(function() {
      bt($);
    }), function() {
      wrapperRaf.cancel(wt.current);
    };
  }, [$]), /* @__PURE__ */ reactExports.createElement(Trigger$1, {
    prefixCls: s,
    popupClassName: classnames("".concat(s, "-popup"), _defineProperty$c({}, "".concat(s, "-rtl"), it), nt, pt),
    stretch: rt === "horizontal" ? "minWidth" : null,
    getPopupContainer: et,
    builtinPlacements: Et,
    popupPlacement: St,
    popupVisible: xt,
    popup: _e,
    popupStyle: tt,
    popupAlign: at && {
      offset: at
    },
    action: ot ? [] : [dt],
    mouseEnterDelay: ut,
    mouseLeaveDelay: ft,
    onPopupVisibleChange: st,
    forceRender: gt,
    popupMotion: Pt,
    fresh: !0
  }, _);
}
function InlineSubMenuList(a) {
  var s = a.id, $ = a.open, _ = a.keyPath, _e = a.children, tt = "inline", nt = reactExports.useContext(MenuContext$2), at = nt.prefixCls, ot = nt.forceSubMenuRender, rt = nt.motion, st = nt.defaultMotions, lt = nt.mode, et = reactExports.useRef(!1);
  et.current = lt === tt;
  var it = reactExports.useState(!et.current), ut = _slicedToArray$e(it, 2), ft = ut[0], ht = ut[1], dt = et.current ? $ : !1;
  reactExports.useEffect(function() {
    et.current && ht(!1);
  }, [lt]);
  var gt = _objectSpread2$a({}, getMotion(tt, rt, st));
  _.length > 1 && (gt.motionAppear = !1);
  var pt = gt.onVisibleChanged;
  return gt.onVisibleChanged = function(mt) {
    return !et.current && !mt && ht(!0), pt == null ? void 0 : pt(mt);
  }, ft ? null : /* @__PURE__ */ reactExports.createElement(InheritableContextProvider, {
    mode: tt,
    locked: !et.current
  }, /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$2({
    visible: dt
  }, gt, {
    forceRender: ot,
    removeOnLeave: !1,
    leavedClassName: "".concat(at, "-hidden")
  }), function(mt) {
    var ct = mt.className, vt = mt.style;
    return /* @__PURE__ */ reactExports.createElement(SubMenuList, {
      id: s,
      className: ct,
      style: vt
    }, _e);
  }));
}
var _excluded$A = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], _excluded2$8 = ["active"], InternalSubMenu = function a(s) {
  var $, _ = s.style, _e = s.className, tt = s.title, nt = s.eventKey;
  s.warnKey;
  var at = s.disabled, ot = s.internalPopupClose, rt = s.children, st = s.itemIcon, lt = s.expandIcon, et = s.popupClassName, it = s.popupOffset, ut = s.popupStyle, ft = s.onClick, ht = s.onMouseEnter, dt = s.onMouseLeave, gt = s.onTitleClick, pt = s.onTitleMouseEnter, mt = s.onTitleMouseLeave, ct = _objectWithoutProperties$1(s, _excluded$A), vt = useMenuId(nt), At = reactExports.useContext(MenuContext$2), xt = At.prefixCls, bt = At.mode, Et = At.openKeys, St = At.disabled, Bt = At.overflowDisabled, Ot = At.activeKey, Pt = At.selectedKeys, wt = At.itemIcon, Ct = At.expandIcon, It = At.onItemClick, yt = At.onOpenChange, Rt = At.onActive, kt = reactExports.useContext(PrivateContext), jt = kt._internalRenderSubMenuItem, Ht = reactExports.useContext(PathUserContext), Ft = Ht.isSubPathKey, _t = useFullPath(), Nt = "".concat(xt, "-submenu"), Mt = St || at, Lt = reactExports.useRef(), $t = reactExports.useRef(), Tt = st ?? wt, Dt = lt ?? Ct, Ut = Et.includes(nt), Vt = !Bt && Ut, Qt = Ft(Pt, nt), qt = useActive(nt, Mt, pt, mt), Zt = qt.active, ar = _objectWithoutProperties$1(qt, _excluded2$8), Jt = reactExports.useState(!1), rr = _slicedToArray$e(Jt, 2), Yt = rr[0], Kt = rr[1], nr = function(br) {
    Mt || Kt(br);
  }, tr = function(br) {
    nr(!0), ht == null || ht({
      key: nt,
      domEvent: br
    });
  }, ir = function(br) {
    nr(!1), dt == null || dt({
      key: nt,
      domEvent: br
    });
  }, sr = reactExports.useMemo(function() {
    return Zt || (bt !== "inline" ? Yt || Ft([Ot], nt) : !1);
  }, [bt, Zt, Ot, Yt, nt, Ft]), cr = useDirectionStyle(_t.length), or = function(br) {
    Mt || (gt == null || gt({
      key: nt,
      domEvent: br
    }), bt === "inline" && yt(nt, !Ut));
  }, Xt = useMemoCallback(function(Er) {
    ft == null || ft(warnItemProp(Er)), It(Er);
  }), Gt = function(br) {
    bt !== "inline" && yt(nt, br);
  }, Wt = function() {
    Rt(nt);
  }, er = vt && "".concat(vt, "-popup"), lr = /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    role: "menuitem",
    style: cr,
    className: "".concat(Nt, "-title"),
    tabIndex: Mt ? null : -1,
    ref: Lt,
    title: typeof tt == "string" ? tt : null,
    "data-menu-id": Bt && vt ? null : vt,
    "aria-expanded": Vt,
    "aria-haspopup": !0,
    "aria-controls": er,
    "aria-disabled": Mt,
    onClick: or,
    onFocus: Wt
  }, ar), tt, /* @__PURE__ */ reactExports.createElement(Icon$1, {
    icon: bt !== "horizontal" ? Dt : void 0,
    props: _objectSpread2$a(_objectSpread2$a({}, s), {}, {
      isOpen: Vt,
      // [Legacy] Not sure why need this mark
      isSubMenu: !0
    })
  }, /* @__PURE__ */ reactExports.createElement("i", {
    className: "".concat(Nt, "-arrow")
  }))), ur = reactExports.useRef(bt);
  if (bt !== "inline" && _t.length > 1 ? ur.current = "vertical" : ur.current = bt, !Bt) {
    var pr = ur.current;
    lr = /* @__PURE__ */ reactExports.createElement(PopupTrigger, {
      mode: pr,
      prefixCls: Nt,
      visible: !ot && Vt && bt !== "inline",
      popupClassName: et,
      popupOffset: it,
      popupStyle: ut,
      popup: /* @__PURE__ */ reactExports.createElement(
        InheritableContextProvider,
        {
          mode: pr === "horizontal" ? "vertical" : pr
        },
        /* @__PURE__ */ reactExports.createElement(SubMenuList, {
          id: er,
          ref: $t
        }, rt)
      ),
      disabled: Mt,
      onVisibleChange: Gt
    }, lr);
  }
  var yr = /* @__PURE__ */ reactExports.createElement(ForwardOverflow.Item, _extends$2({
    role: "none"
  }, ct, {
    component: "li",
    style: _,
    className: classnames(Nt, "".concat(Nt, "-").concat(bt), _e, ($ = {}, _defineProperty$c($, "".concat(Nt, "-open"), Vt), _defineProperty$c($, "".concat(Nt, "-active"), sr), _defineProperty$c($, "".concat(Nt, "-selected"), Qt), _defineProperty$c($, "".concat(Nt, "-disabled"), Mt), $)),
    onMouseEnter: tr,
    onMouseLeave: ir
  }), lr, !Bt && /* @__PURE__ */ reactExports.createElement(InlineSubMenuList, {
    id: er,
    open: Vt,
    keyPath: _t
  }, rt));
  return jt && (yr = jt(yr, s, {
    selected: Qt,
    active: sr,
    open: Vt,
    disabled: Mt
  })), /* @__PURE__ */ reactExports.createElement(InheritableContextProvider, {
    onItemClick: Xt,
    mode: bt === "horizontal" ? "vertical" : bt,
    itemIcon: Tt,
    expandIcon: Dt
  }, yr);
};
function SubMenu$2(a) {
  var s = a.eventKey, $ = a.children, _ = useFullPath(s), _e = parseChildren($, _), tt = useMeasure();
  reactExports.useEffect(function() {
    if (tt)
      return tt.registerPath(s, _), function() {
        tt.unregisterPath(s, _);
      };
  }, [_]);
  var nt;
  return tt ? nt = _e : nt = /* @__PURE__ */ reactExports.createElement(InternalSubMenu, a, _e), /* @__PURE__ */ reactExports.createElement(PathTrackerContext.Provider, {
    value: _
  }, nt);
}
var _excluded$z = ["className", "title", "eventKey", "children"], _excluded2$7 = ["children"], InternalMenuItemGroup = function a(s) {
  var $ = s.className, _ = s.title;
  s.eventKey;
  var _e = s.children, tt = _objectWithoutProperties$1(s, _excluded$z), nt = reactExports.useContext(MenuContext$2), at = nt.prefixCls, ot = "".concat(at, "-item-group");
  return /* @__PURE__ */ reactExports.createElement("li", _extends$2({
    role: "presentation"
  }, tt, {
    onClick: function(st) {
      return st.stopPropagation();
    },
    className: classnames(ot, $)
  }), /* @__PURE__ */ reactExports.createElement("div", {
    role: "presentation",
    className: "".concat(ot, "-title"),
    title: typeof _ == "string" ? _ : void 0
  }, _), /* @__PURE__ */ reactExports.createElement("ul", {
    role: "group",
    className: "".concat(ot, "-list")
  }, _e));
};
function MenuItemGroup(a) {
  var s = a.children, $ = _objectWithoutProperties$1(a, _excluded2$7), _ = useFullPath($.eventKey), _e = parseChildren(s, _), tt = useMeasure();
  return tt ? _e : /* @__PURE__ */ reactExports.createElement(InternalMenuItemGroup, omit($, ["warnKey"]), _e);
}
function Divider$2(a) {
  var s = a.className, $ = a.style, _ = reactExports.useContext(MenuContext$2), _e = _.prefixCls, tt = useMeasure();
  return tt ? null : /* @__PURE__ */ reactExports.createElement("li", {
    role: "separator",
    className: classnames("".concat(_e, "-item-divider"), s),
    style: $
  });
}
var _excluded$y = ["label", "children", "key", "type"];
function convertItemsToNodes$2(a) {
  return (a || []).map(function(s, $) {
    if (s && _typeof$q(s) === "object") {
      var _ = s, _e = _.label, tt = _.children, nt = _.key, at = _.type, ot = _objectWithoutProperties$1(_, _excluded$y), rt = nt ?? "tmp-".concat($);
      return tt || at === "group" ? at === "group" ? /* @__PURE__ */ reactExports.createElement(MenuItemGroup, _extends$2({
        key: rt
      }, ot, {
        title: _e
      }), convertItemsToNodes$2(tt)) : /* @__PURE__ */ reactExports.createElement(SubMenu$2, _extends$2({
        key: rt
      }, ot, {
        title: _e
      }), convertItemsToNodes$2(tt)) : at === "divider" ? /* @__PURE__ */ reactExports.createElement(Divider$2, _extends$2({
        key: rt
      }, ot)) : /* @__PURE__ */ reactExports.createElement(MenuItem$2, _extends$2({
        key: rt
      }, ot), _e);
    }
    return null;
  }).filter(function(s) {
    return s;
  });
}
function parseItems(a, s, $) {
  var _ = a;
  return s && (_ = convertItemsToNodes$2(s)), parseChildren(_, $);
}
var _excluded$x = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem"], EMPTY_LIST$3 = [], Menu$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _, _e = a, tt = _e.prefixCls, nt = tt === void 0 ? "rc-menu" : tt, at = _e.rootClassName, ot = _e.style, rt = _e.className, st = _e.tabIndex, lt = st === void 0 ? 0 : st, et = _e.items, it = _e.children, ut = _e.direction, ft = _e.id, ht = _e.mode, dt = ht === void 0 ? "vertical" : ht, gt = _e.inlineCollapsed, pt = _e.disabled, mt = _e.disabledOverflow, ct = _e.subMenuOpenDelay, vt = ct === void 0 ? 0.1 : ct, At = _e.subMenuCloseDelay, xt = At === void 0 ? 0.1 : At, bt = _e.forceSubMenuRender, Et = _e.defaultOpenKeys, St = _e.openKeys, Bt = _e.activeKey, Ot = _e.defaultActiveFirst, Pt = _e.selectable, wt = Pt === void 0 ? !0 : Pt, Ct = _e.multiple, It = Ct === void 0 ? !1 : Ct, yt = _e.defaultSelectedKeys, Rt = _e.selectedKeys, kt = _e.onSelect, jt = _e.onDeselect, Ht = _e.inlineIndent, Ft = Ht === void 0 ? 24 : Ht, _t = _e.motion, Nt = _e.defaultMotions, Mt = _e.triggerSubMenuAction, Lt = Mt === void 0 ? "hover" : Mt, $t = _e.builtinPlacements, Tt = _e.itemIcon, Dt = _e.expandIcon, Ut = _e.overflowedIndicator, Vt = Ut === void 0 ? "..." : Ut, Qt = _e.overflowedIndicatorPopupClassName, qt = _e.getPopupContainer, Zt = _e.onClick, ar = _e.onOpenChange, Jt = _e.onKeyDown;
  _e.openAnimation, _e.openTransitionName;
  var rr = _e._internalRenderMenuItem, Yt = _e._internalRenderSubMenuItem, Kt = _objectWithoutProperties$1(_e, _excluded$x), nr = reactExports.useMemo(function() {
    return parseItems(it, et, EMPTY_LIST$3);
  }, [it, et]), tr = reactExports.useState(!1), ir = _slicedToArray$e(tr, 2), sr = ir[0], cr = ir[1], or = reactExports.useRef(), Xt = useUUID(ft), Gt = ut === "rtl", Wt = useMergedState(Et, {
    value: St,
    postState: function(pn) {
      return pn || EMPTY_LIST$3;
    }
  }), er = _slicedToArray$e(Wt, 2), lr = er[0], ur = er[1], pr = function(pn) {
    var mn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function Pn() {
      ur(pn), ar == null || ar(pn);
    }
    mn ? reactDomExports.flushSync(Pn) : Pn();
  }, yr = reactExports.useState(lr), Er = _slicedToArray$e(yr, 2), br = Er[0], gr = Er[1], Ar = reactExports.useRef(!1), Sr = reactExports.useMemo(function() {
    return (dt === "inline" || dt === "vertical") && gt ? ["vertical", gt] : [dt, !1];
  }, [dt, gt]), Br = _slicedToArray$e(Sr, 2), Ir = Br[0], hr = Br[1], vr = Ir === "inline", xr = reactExports.useState(Ir), Pr = _slicedToArray$e(xr, 2), Rr = Pr[0], Dr = Pr[1], Gr = reactExports.useState(hr), Or = _slicedToArray$e(Gr, 2), Hr = Or[0], jr = Or[1];
  reactExports.useEffect(function() {
    Dr(Ir), jr(hr), Ar.current && (vr ? ur(br) : pr(EMPTY_LIST$3));
  }, [Ir, hr]);
  var Tr = reactExports.useState(0), fr = _slicedToArray$e(Tr, 2), Cr = fr[0], $r = fr[1], wr = Cr >= nr.length - 1 || Rr !== "horizontal" || mt;
  reactExports.useEffect(function() {
    vr && gr(lr);
  }, [lr]), reactExports.useEffect(function() {
    return Ar.current = !0, function() {
      Ar.current = !1;
    };
  }, []);
  var Mr = useKeyRecords(), Fr = Mr.registerPath, Qr = Mr.unregisterPath, Yr = Mr.refreshOverflowKeys, kr = Mr.isSubPathKey, Nr = Mr.getKeyPath, Lr = Mr.getKeys, zr = Mr.getSubPathKeys, Vr = reactExports.useMemo(function() {
    return {
      registerPath: Fr,
      unregisterPath: Qr
    };
  }, [Fr, Qr]), an = reactExports.useMemo(function() {
    return {
      isSubPathKey: kr
    };
  }, [kr]);
  reactExports.useEffect(function() {
    Yr(wr ? EMPTY_LIST$3 : nr.slice(Cr + 1).map(function(on) {
      return on.key;
    }));
  }, [Cr, wr]);
  var Zr = useMergedState(Bt || Ot && (($ = nr[0]) === null || $ === void 0 ? void 0 : $.key), {
    value: Bt
  }), un = _slicedToArray$e(Zr, 2), Xr = un[0], Kr = un[1], rn = useMemoCallback(function(on) {
    Kr(on);
  }), nn = useMemoCallback(function() {
    Kr(void 0);
  });
  reactExports.useImperativeHandle(s, function() {
    return {
      list: or.current,
      focus: function(pn) {
        var mn, Pn = Lr(), An = refreshElements(Pn, Xt), yn = An.elements, Bn = An.key2element, Fn = An.element2key, zn = getFocusableElements(or.current, yn), Zn = Xr ?? (zn[0] ? Fn.get(zn[0]) : (mn = nr.find(function(Nn) {
          return !Nn.props.disabled;
        })) === null || mn === void 0 ? void 0 : mn.key), to = Bn.get(Zn);
        if (Zn && to) {
          var Mn;
          to == null || (Mn = to.focus) === null || Mn === void 0 || Mn.call(to, pn);
        }
      }
    };
  });
  var sn = useMergedState(yt || [], {
    value: Rt,
    // Legacy convert key to array
    postState: function(pn) {
      return Array.isArray(pn) ? pn : pn == null ? EMPTY_LIST$3 : [pn];
    }
  }), gn = _slicedToArray$e(sn, 2), en = gn[0], Wr = gn[1], dn = function(pn) {
    if (wt) {
      var mn = pn.key, Pn = en.includes(mn), An;
      It ? Pn ? An = en.filter(function(Bn) {
        return Bn !== mn;
      }) : An = [].concat(_toConsumableArray$d(en), [mn]) : An = [mn], Wr(An);
      var yn = _objectSpread2$a(_objectSpread2$a({}, pn), {}, {
        selectedKeys: An
      });
      Pn ? jt == null || jt(yn) : kt == null || kt(yn);
    }
    !It && lr.length && Rr !== "inline" && pr(EMPTY_LIST$3);
  }, hn = useMemoCallback(function(on) {
    Zt == null || Zt(warnItemProp(on)), dn(on);
  }), En = useMemoCallback(function(on, pn) {
    var mn = lr.filter(function(An) {
      return An !== on;
    });
    if (pn)
      mn.push(on);
    else if (Rr !== "inline") {
      var Pn = zr(on);
      mn = mn.filter(function(An) {
        return !Pn.has(An);
      });
    }
    isEqual$1(lr, mn, !0) || pr(mn, !0);
  }), bn = function(pn, mn) {
    var Pn = mn ?? !lr.includes(pn);
    En(pn, Pn);
  }, Cn = useAccessibility(Rr, Xr, Gt, Xt, or, Lr, Nr, Kr, bn, Jt);
  reactExports.useEffect(function() {
    cr(!0);
  }, []);
  var wn = reactExports.useMemo(function() {
    return {
      _internalRenderMenuItem: rr,
      _internalRenderSubMenuItem: Yt
    };
  }, [rr, Yt]), vn = Rr !== "horizontal" || mt ? nr : (
    // Need wrap for overflow dropdown that do not response for open
    nr.map(function(on, pn) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ reactExports.createElement(InheritableContextProvider, {
          key: on.key,
          overflowDisabled: pn > Cr
        }, on)
      );
    })
  ), fn = /* @__PURE__ */ reactExports.createElement(ForwardOverflow, _extends$2({
    id: ft,
    ref: or,
    prefixCls: "".concat(nt, "-overflow"),
    component: "ul",
    itemComponent: MenuItem$2,
    className: classnames(nt, "".concat(nt, "-root"), "".concat(nt, "-").concat(Rr), rt, (_ = {}, _defineProperty$c(_, "".concat(nt, "-inline-collapsed"), Hr), _defineProperty$c(_, "".concat(nt, "-rtl"), Gt), _), at),
    dir: ut,
    style: ot,
    role: "menu",
    tabIndex: lt,
    data: vn,
    renderRawItem: function(pn) {
      return pn;
    },
    renderRawRest: function(pn) {
      var mn = pn.length, Pn = mn ? nr.slice(-mn) : null;
      return /* @__PURE__ */ reactExports.createElement(SubMenu$2, {
        eventKey: OVERFLOW_KEY,
        title: Vt,
        disabled: wr,
        internalPopupClose: mn === 0,
        popupClassName: Qt
      }, Pn);
    },
    maxCount: Rr !== "horizontal" || mt ? ForwardOverflow.INVALIDATE : ForwardOverflow.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(pn) {
      $r(pn);
    },
    onKeyDown: Cn
  }, Kt));
  return /* @__PURE__ */ reactExports.createElement(PrivateContext.Provider, {
    value: wn
  }, /* @__PURE__ */ reactExports.createElement(IdContext.Provider, {
    value: Xt
  }, /* @__PURE__ */ reactExports.createElement(InheritableContextProvider, {
    prefixCls: nt,
    rootClassName: at,
    mode: Rr,
    openKeys: lr,
    rtl: Gt,
    disabled: pt,
    motion: sr ? _t : null,
    defaultMotions: sr ? Nt : null,
    activeKey: Xr,
    onActive: rn,
    onInactive: nn,
    selectedKeys: en,
    inlineIndent: Ft,
    subMenuOpenDelay: vt,
    subMenuCloseDelay: xt,
    forceSubMenuRender: bt,
    builtinPlacements: $t,
    triggerSubMenuAction: Lt,
    getPopupContainer: qt,
    itemIcon: Tt,
    expandIcon: Dt,
    onItemClick: hn,
    onOpenChange: En
  }, /* @__PURE__ */ reactExports.createElement(PathUserContext.Provider, {
    value: an
  }, fn), /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ reactExports.createElement(PathRegisterContext.Provider, {
    value: Vr
  }, nr)))));
}), ExportMenu = Menu$2;
ExportMenu.Item = MenuItem$2;
ExportMenu.SubMenu = SubMenu$2;
ExportMenu.ItemGroup = MenuItemGroup;
ExportMenu.Divider = Divider$2;
var LeftOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" };
const LeftOutlinedSvg = LeftOutlined$2;
var LeftOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: LeftOutlinedSvg
  }));
};
const LeftOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(LeftOutlined), SiderContext = /* @__PURE__ */ reactExports.createContext({});
var __rest$S = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const MenuDivider = (a) => {
  const {
    prefixCls: s,
    className: $,
    dashed: _
  } = a, _e = __rest$S(a, ["prefixCls", "className", "dashed"]), {
    getPrefixCls: tt
  } = reactExports.useContext(ConfigContext$1), nt = tt("menu", s), at = classnames({
    [`${nt}-item-divider-dashed`]: !!_
  }, $);
  return /* @__PURE__ */ reactExports.createElement(Divider$2, Object.assign({
    className: at
  }, _e));
}, MenuDivider$1 = MenuDivider, MenuContext = /* @__PURE__ */ reactExports.createContext({
  prefixCls: "",
  firstLevel: !0,
  inlineCollapsed: !1
}), MenuContext$1 = MenuContext, MenuItem = (a) => {
  var s;
  const {
    className: $,
    children: _,
    icon: _e,
    title: tt,
    danger: nt
  } = a, {
    prefixCls: at,
    firstLevel: ot,
    direction: rt,
    disableMenuItemTitleTooltip: st,
    inlineCollapsed: lt
  } = reactExports.useContext(MenuContext$1), et = (gt) => {
    const pt = /* @__PURE__ */ reactExports.createElement("span", {
      className: `${at}-title-content`
    }, _);
    return (!_e || isValidElement(_) && _.type === "span") && _ && gt && ot && typeof _ == "string" ? /* @__PURE__ */ reactExports.createElement("div", {
      className: `${at}-inline-collapsed-noicon`
    }, _.charAt(0)) : pt;
  }, {
    siderCollapsed: it
  } = reactExports.useContext(SiderContext);
  let ut = tt;
  typeof tt > "u" ? ut = ot ? _ : "" : tt === !1 && (ut = "");
  const ft = {
    title: ut
  };
  !it && !lt && (ft.title = null, ft.open = !1);
  const ht = toArray$9(_).length;
  let dt = /* @__PURE__ */ reactExports.createElement(MenuItem$2, Object.assign({}, omit(a, ["title", "icon", "danger"]), {
    className: classnames({
      [`${at}-item-danger`]: nt,
      [`${at}-item-only-child`]: (_e ? ht + 1 : ht) === 1
    }, $),
    title: typeof tt == "string" ? tt : void 0
  }), cloneElement(_e, {
    className: classnames(isValidElement(_e) ? (s = _e.props) === null || s === void 0 ? void 0 : s.className : "", `${at}-item-icon`)
  }), et(lt));
  return st || (dt = /* @__PURE__ */ reactExports.createElement(_Tooltip, Object.assign({}, ft, {
    placement: rt === "rtl" ? "left" : "right",
    overlayClassName: `${at}-inline-collapsed-tooltip`
  }), dt)), dt;
}, Item$5 = MenuItem, SubMenu = (a) => {
  var s;
  const {
    popupClassName: $,
    icon: _,
    title: _e,
    theme: tt
  } = a, nt = reactExports.useContext(MenuContext$1), {
    prefixCls: at,
    inlineCollapsed: ot,
    theme: rt
  } = nt, st = useFullPath();
  let lt;
  if (!_)
    lt = ot && !st.length && _e && typeof _e == "string" ? /* @__PURE__ */ reactExports.createElement("div", {
      className: `${at}-inline-collapsed-noicon`
    }, _e.charAt(0)) : /* @__PURE__ */ reactExports.createElement("span", {
      className: `${at}-title-content`
    }, _e);
  else {
    const ut = isValidElement(_e) && _e.type === "span";
    lt = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, cloneElement(_, {
      className: classnames(isValidElement(_) ? (s = _.props) === null || s === void 0 ? void 0 : s.className : "", `${at}-item-icon`)
    }), ut ? _e : /* @__PURE__ */ reactExports.createElement("span", {
      className: `${at}-title-content`
    }, _e));
  }
  const et = reactExports.useMemo(() => Object.assign(Object.assign({}, nt), {
    firstLevel: !1
  }), [nt]), [it] = useZIndex("Menu");
  return /* @__PURE__ */ reactExports.createElement(MenuContext$1.Provider, {
    value: et
  }, /* @__PURE__ */ reactExports.createElement(SubMenu$2, Object.assign({}, omit(a, ["icon"]), {
    title: lt,
    popupClassName: classnames(at, $, `${at}-${tt || rt}`),
    popupStyle: {
      zIndex: it
    }
  })));
}, SubMenu$1 = SubMenu;
var EllipsisOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" };
const EllipsisOutlinedSvg = EllipsisOutlined$2;
var EllipsisOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: EllipsisOutlinedSvg
  }));
};
const EllipsisOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(EllipsisOutlined);
var __rest$R = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function convertItemsToNodes$1(a) {
  return (a || []).map((s, $) => {
    if (s && typeof s == "object") {
      const _ = s, {
        label: _e,
        children: tt,
        key: nt,
        type: at
      } = _, ot = __rest$R(_, ["label", "children", "key", "type"]), rt = nt ?? `tmp-${$}`;
      return tt || at === "group" ? at === "group" ? /* @__PURE__ */ reactExports.createElement(MenuItemGroup, Object.assign({
        key: rt
      }, ot, {
        title: _e
      }), convertItemsToNodes$1(tt)) : /* @__PURE__ */ reactExports.createElement(SubMenu$1, Object.assign({
        key: rt
      }, ot, {
        title: _e
      }), convertItemsToNodes$1(tt)) : at === "divider" ? /* @__PURE__ */ reactExports.createElement(MenuDivider$1, Object.assign({
        key: rt
      }, ot)) : /* @__PURE__ */ reactExports.createElement(Item$5, Object.assign({
        key: rt
      }, ot), _e);
    }
    return null;
  }).filter((s) => s);
}
function useItems$1(a) {
  return reactExports.useMemo(() => a && convertItemsToNodes$1(a), [a]);
}
var __rest$Q = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const OverrideContext = /* @__PURE__ */ reactExports.createContext(null), OverrideProvider = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    children: $
  } = a, _ = __rest$Q(a, ["children"]), _e = reactExports.useContext(OverrideContext), tt = reactExports.useMemo(() => Object.assign(Object.assign({}, _e), _), [
    _e,
    _.prefixCls,
    // restProps.expandIcon, Not mark as deps since this is a ReactNode
    _.mode,
    _.selectable,
    _.rootClassName
    // restProps.validator, Not mark as deps since this is a function
  ]), nt = supportNodeRef($), at = useComposeRef(s, nt ? $.ref : null);
  return /* @__PURE__ */ reactExports.createElement(OverrideContext.Provider, {
    value: tt
  }, /* @__PURE__ */ reactExports.createElement(NoCompactStyle, null, nt ? /* @__PURE__ */ reactExports.cloneElement($, {
    ref: at
  }) : $));
}), getHorizontalStyle = (a) => {
  const {
    componentCls: s,
    motionDurationSlow: $,
    horizontalLineHeight: _,
    colorSplit: _e,
    lineWidth: tt,
    lineType: nt,
    itemPaddingInline: at
  } = a;
  return {
    [`${s}-horizontal`]: {
      lineHeight: _,
      border: 0,
      borderBottom: `${unit$1(tt)} ${nt} ${_e}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${s}-item, ${s}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: at
      },
      [`> ${s}-item:hover,
        > ${s}-item-active,
        > ${s}-submenu ${s}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${s}-item, ${s}-submenu-title`]: {
        transition: [`border-color ${$}`, `background ${$}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${s}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
}, getHorizontalStyle$1 = getHorizontalStyle, getRTLStyle = (a) => {
  let {
    componentCls: s,
    menuArrowOffset: $,
    calc: _
  } = a;
  return {
    [`${s}-rtl`]: {
      direction: "rtl"
    },
    [`${s}-submenu-rtl`]: {
      transformOrigin: "100% 0"
    },
    // Vertical Arrow
    [`${s}-rtl${s}-vertical,
    ${s}-submenu-rtl ${s}-vertical`]: {
      [`${s}-submenu-arrow`]: {
        "&::before": {
          transform: `rotate(-45deg) translateY(${unit$1(_($).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(45deg) translateY(${unit$1($)})`
        }
      }
    }
  };
}, getRTLStyle$1 = getRTLStyle, accessibilityFocus = (a) => Object.assign({}, genFocusOutline(a)), getThemeStyle = (a, s) => {
  const {
    componentCls: $,
    itemColor: _,
    itemSelectedColor: _e,
    groupTitleColor: tt,
    itemBg: nt,
    subMenuItemBg: at,
    itemSelectedBg: ot,
    activeBarHeight: rt,
    activeBarWidth: st,
    activeBarBorderWidth: lt,
    motionDurationSlow: et,
    motionEaseInOut: it,
    motionEaseOut: ut,
    itemPaddingInline: ft,
    motionDurationMid: ht,
    itemHoverColor: dt,
    lineType: gt,
    colorSplit: pt,
    // Disabled
    itemDisabledColor: mt,
    // Danger
    dangerItemColor: ct,
    dangerItemHoverColor: vt,
    dangerItemSelectedColor: At,
    dangerItemActiveBg: xt,
    dangerItemSelectedBg: bt,
    itemHoverBg: Et,
    itemActiveBg: St,
    menuSubMenuBg: Bt,
    // Horizontal
    horizontalItemSelectedColor: Ot,
    horizontalItemSelectedBg: Pt,
    horizontalItemBorderRadius: wt,
    horizontalItemHoverBg: Ct,
    popupBg: It
  } = a;
  return {
    [`${$}-${s}, ${$}-${s} > ${$}`]: {
      color: _,
      background: nt,
      [`&${$}-root:focus-visible`]: Object.assign({}, accessibilityFocus(a)),
      // ======================== Item ========================
      [`${$}-item-group-title`]: {
        color: tt
      },
      [`${$}-submenu-selected`]: {
        [`> ${$}-submenu-title`]: {
          color: _e
        }
      },
      // Disabled
      [`${$}-item-disabled, ${$}-submenu-disabled`]: {
        color: `${mt} !important`
      },
      // Hover
      [`${$}-item:not(${$}-item-selected):not(${$}-submenu-selected)`]: {
        [`&:hover, > ${$}-submenu-title:hover`]: {
          color: dt
        }
      },
      [`&:not(${$}-horizontal)`]: {
        [`${$}-item:not(${$}-item-selected)`]: {
          "&:hover": {
            backgroundColor: Et
          },
          "&:active": {
            backgroundColor: St
          }
        },
        [`${$}-submenu-title`]: {
          "&:hover": {
            backgroundColor: Et
          },
          "&:active": {
            backgroundColor: St
          }
        }
      },
      // Danger - only Item has
      [`${$}-item-danger`]: {
        color: ct,
        [`&${$}-item:hover`]: {
          [`&:not(${$}-item-selected):not(${$}-submenu-selected)`]: {
            color: vt
          }
        },
        [`&${$}-item:active`]: {
          background: xt
        }
      },
      [`${$}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${$}-item-selected`]: {
        color: _e,
        // Danger
        [`&${$}-item-danger`]: {
          color: At
        },
        "a, a:hover": {
          color: "inherit"
        }
      },
      [`& ${$}-item-selected`]: {
        backgroundColor: ot,
        // Danger
        [`&${$}-item-danger`]: {
          backgroundColor: bt
        }
      },
      [`${$}-item, ${$}-submenu-title`]: {
        [`&:not(${$}-item-disabled):focus-visible`]: Object.assign({}, accessibilityFocus(a))
      },
      [`&${$}-submenu > ${$}`]: {
        backgroundColor: Bt
      },
      [`&${$}-popup > ${$}`]: {
        backgroundColor: It
      },
      // ====================== Horizontal ======================
      [`&${$}-horizontal`]: Object.assign(Object.assign({}, s === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${$}-item, > ${$}-submenu`]: {
          top: lt,
          marginTop: a.calc(lt).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: wt,
          "&::after": {
            position: "absolute",
            insetInline: ft,
            bottom: 0,
            borderBottom: `${unit$1(rt)} solid transparent`,
            transition: `border-color ${et} ${it}`,
            content: '""'
          },
          "&:hover, &-active, &-open": {
            background: Ct,
            "&::after": {
              borderBottomWidth: rt,
              borderBottomColor: Ot
            }
          },
          "&-selected": {
            color: Ot,
            backgroundColor: Pt,
            "&:hover": {
              backgroundColor: Pt
            },
            "&::after": {
              borderBottomWidth: rt,
              borderBottomColor: Ot
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${$}-root`]: {
        [`&${$}-inline, &${$}-vertical`]: {
          borderInlineEnd: `${unit$1(lt)} ${gt} ${pt}`
        }
      },
      // ======================== Inline ========================
      [`&${$}-inline`]: {
        // Sub
        [`${$}-sub${$}-inline`]: {
          background: at
        },
        [`${$}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${unit$1(st)} solid ${_e}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${ht} ${ut}`, `opacity ${ht} ${ut}`].join(","),
            content: '""'
          },
          // Danger
          [`&${$}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: At
            }
          }
        },
        [`${$}-selected, ${$}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${ht} ${it}`, `opacity ${ht} ${it}`].join(",")
          }
        }
      }
    }
  };
}, getThemeStyle$1 = getThemeStyle, getVerticalInlineStyle = (a) => {
  const {
    componentCls: s,
    itemHeight: $,
    itemMarginInline: _,
    padding: _e,
    menuArrowSize: tt,
    marginXS: nt,
    itemMarginBlock: at,
    itemWidth: ot
  } = a, rt = a.calc(tt).add(_e).add(nt).equal();
  return {
    [`${s}-item`]: {
      position: "relative",
      overflow: "hidden"
    },
    [`${s}-item, ${s}-submenu-title`]: {
      height: $,
      lineHeight: unit$1($),
      paddingInline: _e,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: _,
      marginBlock: at,
      width: ot
    },
    [`> ${s}-item,
            > ${s}-submenu > ${s}-submenu-title`]: {
      height: $,
      lineHeight: unit$1($)
    },
    [`${s}-item-group-list ${s}-submenu-title,
            ${s}-submenu-title`]: {
      paddingInlineEnd: rt
    }
  };
}, getVerticalStyle = (a) => {
  const {
    componentCls: s,
    iconCls: $,
    itemHeight: _,
    colorTextLightSolid: _e,
    dropdownWidth: tt,
    controlHeightLG: nt,
    motionDurationMid: at,
    motionEaseOut: ot,
    paddingXL: rt,
    itemMarginInline: st,
    fontSizeLG: lt,
    motionDurationSlow: et,
    paddingXS: it,
    boxShadowSecondary: ut,
    collapsedWidth: ft,
    collapsedIconSize: ht
  } = a, dt = {
    height: _,
    lineHeight: unit$1(_),
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [s]: {
        "&-inline, &-vertical": Object.assign({
          [`&${s}-root`]: {
            boxShadow: "none"
          }
        }, getVerticalInlineStyle(a))
      },
      [`${s}-submenu-popup`]: {
        [`${s}-vertical`]: Object.assign(Object.assign({}, getVerticalInlineStyle(a)), {
          boxShadow: ut
        })
      }
    },
    // Vertical only
    {
      [`${s}-submenu-popup ${s}-vertical${s}-sub`]: {
        minWidth: tt,
        maxHeight: `calc(100vh - ${unit$1(a.calc(nt).mul(2.5).equal())})`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${s}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${s}-root`]: {
          [`${s}-item, ${s}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${et}`, `background ${et}`, `padding ${at} ${ot}`].join(","),
            [`> ${s}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${s}-sub${s}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${s}-submenu > ${s}-submenu-title`]: dt,
          [`& ${s}-item-group-title`]: {
            paddingInlineStart: rt
          }
        },
        // >>>>> Item
        [`${s}-item`]: dt
      }
    },
    // Inline Collapse Only
    {
      [`${s}-inline-collapsed`]: {
        width: ft,
        [`&${s}-root`]: {
          [`${s}-item, ${s}-submenu ${s}-submenu-title`]: {
            [`> ${s}-inline-collapsed-noicon`]: {
              fontSize: lt,
              textAlign: "center"
            }
          }
        },
        [`> ${s}-item,
          > ${s}-item-group > ${s}-item-group-list > ${s}-item,
          > ${s}-item-group > ${s}-item-group-list > ${s}-submenu > ${s}-submenu-title,
          > ${s}-submenu > ${s}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${unit$1(a.calc(lt).div(2).equal())} - ${unit$1(st)})`,
          textOverflow: "clip",
          [`
            ${s}-submenu-arrow,
            ${s}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${s}-item-icon, ${$}`]: {
            margin: 0,
            fontSize: ht,
            lineHeight: unit$1(_),
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${s}-item-icon, ${$}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${s}-item-icon, ${$}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: _e
          }
        },
        [`${s}-item-group-title`]: Object.assign(Object.assign({}, textEllipsis), {
          paddingInline: it
        })
      }
    }
  ];
}, getVerticalStyle$1 = getVerticalStyle, genMenuItemStyle = (a) => {
  const {
    componentCls: s,
    motionDurationSlow: $,
    motionDurationMid: _,
    motionEaseInOut: _e,
    motionEaseOut: tt,
    iconCls: nt,
    iconSize: at,
    iconMarginInlineEnd: ot
  } = a;
  return {
    // >>>>> Item
    [`${s}-item, ${s}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${$}`, `background ${$}`, `padding ${$} ${_e}`].join(","),
      [`${s}-item-icon, ${nt}`]: {
        minWidth: at,
        fontSize: at,
        transition: [`font-size ${_} ${tt}`, `margin ${$} ${_e}`, `color ${$}`].join(","),
        "+ span": {
          marginInlineStart: ot,
          opacity: 1,
          transition: [`opacity ${$} ${_e}`, `margin ${$}`, `color ${$}`].join(",")
        }
      },
      [`${s}-item-icon`]: Object.assign({}, resetIcon()),
      [`&${s}-item-only-child`]: {
        [`> ${nt}, > ${s}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${s}-item-disabled, ${s}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important"
      },
      [`> ${s}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
}, genSubMenuArrowStyle = (a) => {
  const {
    componentCls: s,
    motionDurationSlow: $,
    motionEaseInOut: _,
    borderRadius: _e,
    menuArrowSize: tt,
    menuArrowOffset: nt
  } = a;
  return {
    [`${s}-submenu`]: {
      "&-expand-icon, &-arrow": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: a.margin,
        width: tt,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${$} ${_}, opacity ${$}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: a.calc(tt).mul(0.6).equal(),
          height: a.calc(tt).mul(0.15).equal(),
          backgroundColor: "currentcolor",
          borderRadius: _e,
          transition: [`background ${$} ${_}`, `transform ${$} ${_}`, `top ${$} ${_}`, `color ${$} ${_}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(${unit$1(a.calc(nt).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${unit$1(nt)})`
        }
      }
    }
  };
}, getBaseStyle = (a) => {
  const {
    antCls: s,
    componentCls: $,
    fontSize: _,
    motionDurationSlow: _e,
    motionDurationMid: tt,
    motionEaseInOut: nt,
    paddingXS: at,
    padding: ot,
    colorSplit: rt,
    lineWidth: st,
    zIndexPopup: lt,
    borderRadiusLG: et,
    subMenuItemBorderRadius: it,
    menuArrowSize: ut,
    menuArrowOffset: ft,
    lineType: ht,
    menuPanelMaskInset: dt,
    groupTitleLineHeight: gt,
    groupTitleFontSize: pt
  } = a;
  return [
    // Misc
    {
      "": {
        [`${$}`]: Object.assign(Object.assign({}, clearFix()), {
          // Hidden
          "&-hidden": {
            display: "none"
          }
        })
      },
      [`${$}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [$]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), clearFix()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize: _,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        // Magic cubic here but smooth transition
        transition: `width ${_e} cubic-bezier(0.2, 0, 0, 1) 0s`,
        "ul, ol": {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        "&-overflow": {
          display: "flex",
          [`${$}-item`]: {
            flex: "none"
          }
        },
        [`${$}-item, ${$}-submenu, ${$}-submenu-title`]: {
          borderRadius: a.itemBorderRadius
        },
        [`${$}-item-group-title`]: {
          padding: `${unit$1(at)} ${unit$1(ot)}`,
          fontSize: pt,
          lineHeight: gt,
          transition: `all ${_e}`
        },
        [`&-horizontal ${$}-submenu`]: {
          transition: [`border-color ${_e} ${nt}`, `background ${_e} ${nt}`].join(",")
        },
        [`${$}-submenu, ${$}-submenu-inline`]: {
          transition: [`border-color ${_e} ${nt}`, `background ${_e} ${nt}`, `padding ${tt} ${nt}`].join(",")
        },
        [`${$}-submenu ${$}-sub`]: {
          cursor: "initial",
          transition: [`background ${_e} ${nt}`, `padding ${_e} ${nt}`].join(",")
        },
        [`${$}-title-content`]: {
          transition: `color ${_e}`,
          // https://github.com/ant-design/ant-design/issues/41143
          [`> ${s}-typography-ellipsis-single-line`]: {
            display: "inline",
            verticalAlign: "unset"
          }
        },
        [`${$}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${$}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: rt,
          borderStyle: ht,
          borderWidth: 0,
          borderTopWidth: st,
          marginBlock: st,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), genMenuItemStyle(a)), {
        [`${$}-item-group`]: {
          [`${$}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${$}-item, ${$}-submenu-title`]: {
              paddingInline: `${unit$1(a.calc(_).mul(2).equal())} ${unit$1(ot)}`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: lt,
            borderRadius: et,
            boxShadow: "none",
            transformOrigin: "0 0",
            [`&${$}-submenu`]: {
              background: "transparent"
            },
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: `${unit$1(dt)} 0 0`,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            }
          },
          // https://github.com/ant-design/ant-design/issues/13955
          "&-placement-rightTop::before": {
            top: 0,
            insetInlineStart: dt
          },
          "\n          &-placement-leftTop,\n          &-placement-bottomRight,\n          ": {
            transformOrigin: "100% 0"
          },
          "\n          &-placement-leftBottom,\n          &-placement-topRight,\n          ": {
            transformOrigin: "100% 100%"
          },
          "\n          &-placement-rightBottom,\n          &-placement-topLeft,\n          ": {
            transformOrigin: "0 100%"
          },
          "\n          &-placement-bottomLeft,\n          &-placement-rightTop,\n          ": {
            transformOrigin: "0 0"
          },
          "\n          &-placement-leftTop,\n          &-placement-leftBottom\n          ": {
            paddingInlineEnd: a.paddingXS
          },
          "\n          &-placement-rightTop,\n          &-placement-rightBottom\n          ": {
            paddingInlineStart: a.paddingXS
          },
          "\n          &-placement-topRight,\n          &-placement-topLeft\n          ": {
            paddingBottom: a.paddingXS
          },
          "\n          &-placement-bottomRight,\n          &-placement-bottomLeft\n          ": {
            paddingTop: a.paddingXS
          },
          [`> ${$}`]: Object.assign(Object.assign(Object.assign({
            borderRadius: et
          }, genMenuItemStyle(a)), genSubMenuArrowStyle(a)), {
            [`${$}-item, ${$}-submenu > ${$}-submenu-title`]: {
              borderRadius: it
            },
            [`${$}-submenu-title::after`]: {
              transition: `transform ${_e} ${nt}`
            }
          })
        }
      }), genSubMenuArrowStyle(a)), {
        [`&-inline-collapsed ${$}-submenu-arrow,
        &-inline ${$}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${unit$1(ft)})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(${unit$1(a.calc(ft).mul(-1).equal())})`
          }
        },
        [`${$}-submenu-open${$}-submenu-inline > ${$}-submenu-title > ${$}-submenu-arrow`]: {
          // ↑
          transform: `translateY(${unit$1(a.calc(ut).mul(0.2).mul(-1).equal())})`,
          "&::after": {
            transform: `rotate(-45deg) translateX(${unit$1(a.calc(ft).mul(-1).equal())})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${unit$1(ft)})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${s}-layout-header`]: {
        [$]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
}, prepareComponentToken$o = (a) => {
  const {
    colorPrimary: s,
    colorError: $,
    colorTextDisabled: _,
    colorErrorBg: _e,
    colorText: tt,
    colorTextDescription: nt,
    colorBgContainer: at,
    colorFillAlter: ot,
    colorFillContent: rt,
    lineWidth: st,
    lineWidthBold: lt,
    controlItemBgActive: et,
    colorBgTextHover: it,
    controlHeightLG: ut,
    lineHeight: ft,
    colorBgElevated: ht,
    marginXXS: dt,
    padding: gt,
    fontSize: pt,
    controlHeightSM: mt,
    fontSizeLG: ct,
    colorTextLightSolid: vt,
    colorErrorHover: At
  } = a, xt = new TinyColor(vt).setAlpha(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: a.zIndexPopupBase + 50,
    radiusItem: a.borderRadiusLG,
    itemBorderRadius: a.borderRadiusLG,
    radiusSubMenuItem: a.borderRadiusSM,
    subMenuItemBorderRadius: a.borderRadiusSM,
    colorItemText: tt,
    itemColor: tt,
    colorItemTextHover: tt,
    itemHoverColor: tt,
    colorItemTextHoverHorizontal: s,
    horizontalItemHoverColor: s,
    colorGroupTitle: nt,
    groupTitleColor: nt,
    colorItemTextSelected: s,
    itemSelectedColor: s,
    colorItemTextSelectedHorizontal: s,
    horizontalItemSelectedColor: s,
    colorItemBg: at,
    itemBg: at,
    colorItemBgHover: it,
    itemHoverBg: it,
    colorItemBgActive: rt,
    itemActiveBg: et,
    colorSubItemBg: ot,
    subMenuItemBg: ot,
    colorItemBgSelected: et,
    itemSelectedBg: et,
    colorItemBgSelectedHorizontal: "transparent",
    horizontalItemSelectedBg: "transparent",
    colorActiveBarWidth: 0,
    activeBarWidth: 0,
    colorActiveBarHeight: lt,
    activeBarHeight: lt,
    colorActiveBarBorderSize: st,
    activeBarBorderWidth: st,
    // Disabled
    colorItemTextDisabled: _,
    itemDisabledColor: _,
    // Danger
    colorDangerItemText: $,
    dangerItemColor: $,
    colorDangerItemTextHover: $,
    dangerItemHoverColor: $,
    colorDangerItemTextSelected: $,
    dangerItemSelectedColor: $,
    colorDangerItemBgActive: _e,
    dangerItemActiveBg: _e,
    colorDangerItemBgSelected: _e,
    dangerItemSelectedBg: _e,
    itemMarginInline: a.marginXXS,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: "transparent",
    itemHeight: ut,
    groupTitleLineHeight: ft,
    collapsedWidth: ut * 2,
    popupBg: ht,
    itemMarginBlock: dt,
    itemPaddingInline: gt,
    horizontalLineHeight: `${ut * 1.15}px`,
    iconSize: pt,
    iconMarginInlineEnd: mt - pt,
    collapsedIconSize: ct,
    groupTitleFontSize: pt,
    // Disabled
    darkItemDisabledColor: new TinyColor(vt).setAlpha(0.25).toRgbString(),
    // Dark
    darkItemColor: xt,
    darkDangerItemColor: $,
    darkItemBg: "#001529",
    darkPopupBg: "#001529",
    darkSubMenuItemBg: "#000c17",
    darkItemSelectedColor: vt,
    darkItemSelectedBg: s,
    darkDangerItemSelectedBg: $,
    darkItemHoverBg: "transparent",
    darkGroupTitleColor: xt,
    darkItemHoverColor: vt,
    darkDangerItemHoverColor: At,
    darkDangerItemSelectedColor: vt,
    darkDangerItemActiveBg: $,
    // internal
    itemWidth: ""
  };
}, formatComponentToken$1 = (a) => Object.assign(Object.assign({}, a), {
  itemWidth: a.activeBarWidth ? `calc(100% + ${a.activeBarBorderWidth}px)` : `calc(100% - ${a.itemMarginInline * 2}px)`
}), useStyle$q = function(a) {
  let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : a, $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return genStyleHooks("Menu", (_e) => {
    const {
      colorBgElevated: tt,
      colorPrimary: nt,
      colorTextLightSolid: at,
      controlHeightLG: ot,
      fontSize: rt,
      darkItemColor: st,
      darkDangerItemColor: lt,
      darkItemBg: et,
      darkSubMenuItemBg: it,
      darkItemSelectedColor: ut,
      darkItemSelectedBg: ft,
      darkDangerItemSelectedBg: ht,
      darkItemHoverBg: dt,
      darkGroupTitleColor: gt,
      darkItemHoverColor: pt,
      darkItemDisabledColor: mt,
      darkDangerItemHoverColor: ct,
      darkDangerItemSelectedColor: vt,
      darkDangerItemActiveBg: At
    } = _e, xt = _e.calc(rt).div(7).mul(5).equal(), bt = merge(_e, {
      menuArrowSize: xt,
      menuHorizontalHeight: _e.calc(ot).mul(1.15).equal(),
      menuArrowOffset: _e.calc(xt).mul(0.25).equal(),
      menuPanelMaskInset: -7,
      // Still a hardcode here since it's offset by rc-align
      menuSubMenuBg: tt,
      calc: _e.calc
    }), Et = merge(bt, {
      itemColor: st,
      itemHoverColor: pt,
      groupTitleColor: gt,
      itemSelectedColor: ut,
      itemBg: et,
      popupBg: et,
      subMenuItemBg: it,
      itemActiveBg: "transparent",
      itemSelectedBg: ft,
      activeBarHeight: 0,
      activeBarBorderWidth: 0,
      itemHoverBg: dt,
      // Disabled
      itemDisabledColor: mt,
      // Danger
      dangerItemColor: lt,
      dangerItemHoverColor: ct,
      dangerItemSelectedColor: vt,
      dangerItemActiveBg: At,
      dangerItemSelectedBg: ht,
      menuSubMenuBg: it,
      // Horizontal
      horizontalItemSelectedColor: at,
      horizontalItemSelectedBg: nt
    });
    return [
      // Basic
      getBaseStyle(bt),
      // Horizontal
      getHorizontalStyle$1(bt),
      // Hard code for some light style
      // Vertical
      getVerticalStyle$1(bt),
      // Hard code for some light style
      // Theme
      getThemeStyle$1(bt, "light"),
      getThemeStyle$1(Et, "dark"),
      // RTL
      getRTLStyle$1(bt),
      // Motion
      genCollapseMotion$1(bt),
      initSlideMotion(bt, "slide-up"),
      initSlideMotion(bt, "slide-down"),
      initZoomMotion(bt, "zoom-big")
    ];
  }, prepareComponentToken$o, {
    deprecatedTokens: [["colorGroupTitle", "groupTitleColor"], ["radiusItem", "itemBorderRadius"], ["radiusSubMenuItem", "subMenuItemBorderRadius"], ["colorItemText", "itemColor"], ["colorItemTextHover", "itemHoverColor"], ["colorItemTextHoverHorizontal", "horizontalItemHoverColor"], ["colorItemTextSelected", "itemSelectedColor"], ["colorItemTextSelectedHorizontal", "horizontalItemSelectedColor"], ["colorItemTextDisabled", "itemDisabledColor"], ["colorDangerItemText", "dangerItemColor"], ["colorDangerItemTextHover", "dangerItemHoverColor"], ["colorDangerItemTextSelected", "dangerItemSelectedColor"], ["colorDangerItemBgActive", "dangerItemActiveBg"], ["colorDangerItemBgSelected", "dangerItemSelectedBg"], ["colorItemBg", "itemBg"], ["colorItemBgHover", "itemHoverBg"], ["colorSubItemBg", "subMenuItemBg"], ["colorItemBgActive", "itemActiveBg"], ["colorItemBgSelectedHorizontal", "horizontalItemSelectedBg"], ["colorActiveBarWidth", "activeBarWidth"], ["colorActiveBarHeight", "activeBarHeight"], ["colorActiveBarBorderSize", "activeBarBorderWidth"], ["colorItemBgSelected", "itemSelectedBg"]],
    format: formatComponentToken$1,
    // Dropdown will handle menu style self. We do not need to handle this.
    injectStyle: $,
    unitless: {
      groupTitleLineHeight: !0
    }
  })(a, s);
};
var __rest$P = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const InternalMenu = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var $, _;
  const _e = reactExports.useContext(OverrideContext), tt = _e || {}, {
    getPrefixCls: nt,
    getPopupContainer: at,
    direction: ot,
    menu: rt
  } = reactExports.useContext(ConfigContext$1), st = nt(), {
    prefixCls: lt,
    className: et,
    style: it,
    theme: ut = "light",
    expandIcon: ft,
    _internalDisableMenuItemTitleTooltip: ht,
    inlineCollapsed: dt,
    siderCollapsed: gt,
    items: pt,
    children: mt,
    rootClassName: ct,
    mode: vt,
    selectable: At,
    onClick: xt,
    overflowedIndicatorPopupClassName: bt
  } = a, Et = __rest$P(a, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "items", "children", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]), St = omit(Et, ["collapsedWidth"]), Bt = useItems$1(pt) || mt;
  ($ = tt.validator) === null || $ === void 0 || $.call(tt, {
    mode: vt
  });
  const Ot = useEvent(function() {
    var Mt;
    xt == null || xt.apply(void 0, arguments), (Mt = tt.onClick) === null || Mt === void 0 || Mt.call(tt);
  }), Pt = tt.mode || vt, wt = At ?? tt.selectable, Ct = reactExports.useMemo(() => gt !== void 0 ? gt : dt, [dt, gt]), It = {
    horizontal: {
      motionName: `${st}-slide-up`
    },
    inline: initCollapseMotion$1(st),
    other: {
      motionName: `${st}-zoom-big`
    }
  }, yt = nt("menu", lt || tt.prefixCls), Rt = useCSSVarCls$1(yt), [kt, jt, Ht] = useStyle$q(yt, Rt, !_e), Ft = classnames(`${yt}-${ut}`, rt == null ? void 0 : rt.className, et);
  let _t;
  if (typeof ft == "function")
    _t = ft;
  else if (ft === null || ft === !1)
    _t = null;
  else if (tt.expandIcon === null || tt.expandIcon === !1)
    _t = null;
  else {
    const Mt = ft ?? tt.expandIcon;
    _t = cloneElement(Mt, {
      className: classnames(`${yt}-submenu-expand-icon`, isValidElement(Mt) ? (_ = Mt.props) === null || _ === void 0 ? void 0 : _.className : "")
    });
  }
  const Nt = reactExports.useMemo(() => ({
    prefixCls: yt,
    inlineCollapsed: Ct || !1,
    direction: ot,
    firstLevel: !0,
    theme: ut,
    mode: Pt,
    disableMenuItemTitleTooltip: ht
  }), [yt, Ct, ot, ht, ut]);
  return kt(/* @__PURE__ */ reactExports.createElement(OverrideContext.Provider, {
    value: null
  }, /* @__PURE__ */ reactExports.createElement(MenuContext$1.Provider, {
    value: Nt
  }, /* @__PURE__ */ reactExports.createElement(ExportMenu, Object.assign({
    getPopupContainer: at,
    overflowedIndicator: /* @__PURE__ */ reactExports.createElement(EllipsisOutlined$1, null),
    overflowedIndicatorPopupClassName: classnames(yt, `${yt}-${ut}`, bt),
    mode: Pt,
    selectable: wt,
    onClick: Ot
  }, St, {
    inlineCollapsed: Ct,
    style: Object.assign(Object.assign({}, rt == null ? void 0 : rt.style), it),
    className: Ft,
    prefixCls: yt,
    direction: ot,
    defaultMotions: It,
    expandIcon: _t,
    ref: s,
    rootClassName: classnames(ct, jt, tt.rootClassName, Ht, Rt)
  }), Bt))));
}), InternalMenu$1 = InternalMenu, Menu = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const $ = reactExports.useRef(null), _ = reactExports.useContext(SiderContext);
  return reactExports.useImperativeHandle(s, () => ({
    menu: $.current,
    focus: (_e) => {
      var tt;
      (tt = $.current) === null || tt === void 0 || tt.focus(_e);
    }
  })), /* @__PURE__ */ reactExports.createElement(InternalMenu$1, Object.assign({
    ref: $
  }, a, _));
});
Menu.Item = Item$5;
Menu.SubMenu = SubMenu$1;
Menu.Divider = MenuDivider$1;
Menu.ItemGroup = MenuItemGroup;
const Menu$1 = Menu, genStatusStyle$1 = (a) => {
  const {
    componentCls: s,
    menuCls: $,
    colorError: _,
    colorTextLightSolid: _e
  } = a, tt = `${$}-item`;
  return {
    [`${s}, ${s}-menu-submenu`]: {
      [`${$} ${tt}`]: {
        [`&${tt}-danger:not(${tt}-disabled)`]: {
          color: _,
          "&:hover": {
            color: _e,
            backgroundColor: _
          }
        }
      }
    }
  };
}, genStatusStyle$2 = genStatusStyle$1, genBaseStyle$9 = (a) => {
  const {
    componentCls: s,
    menuCls: $,
    zIndexPopup: _,
    dropdownArrowDistance: _e,
    sizePopupArrow: tt,
    antCls: nt,
    iconCls: at,
    motionDurationMid: ot,
    paddingBlock: rt,
    fontSize: st,
    dropdownEdgeChildPadding: lt,
    colorTextDisabled: et,
    fontSizeIcon: it,
    controlPaddingHorizontal: ut,
    colorBgElevated: ft
  } = a;
  return [
    {
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        position: "absolute",
        top: -9999,
        left: {
          _skip_check_: !0,
          value: -9999
        },
        zIndex: _,
        display: "block",
        // A placeholder out of dropdown visible range to avoid close when user moving
        "&::before": {
          position: "absolute",
          insetBlock: a.calc(tt).div(2).sub(_e).equal(),
          // insetInlineStart: -7, // FIXME: Seems not work for hidden element
          zIndex: -9999,
          opacity: 1e-4,
          content: '""'
        },
        [`&-trigger${nt}-btn`]: {
          [`& > ${at}-down, & > ${nt}-btn-icon > ${at}-down`]: {
            fontSize: it
          }
        },
        [`${s}-wrap`]: {
          position: "relative",
          [`${nt}-btn > ${at}-down`]: {
            fontSize: it
          },
          [`${at}-down::before`]: {
            transition: `transform ${ot}`
          }
        },
        [`${s}-wrap-open`]: {
          [`${at}-down::before`]: {
            transform: "rotate(180deg)"
          }
        },
        "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ": {
          display: "none"
        },
        // =============================================================
        // ==                         Motion                          ==
        // =============================================================
        // When position is not enough for dropdown, the placement will revert.
        // We will handle this with revert motion name.
        [`&${nt}-slide-down-enter${nt}-slide-down-enter-active${s}-placement-bottomLeft,
          &${nt}-slide-down-appear${nt}-slide-down-appear-active${s}-placement-bottomLeft,
          &${nt}-slide-down-enter${nt}-slide-down-enter-active${s}-placement-bottom,
          &${nt}-slide-down-appear${nt}-slide-down-appear-active${s}-placement-bottom,
          &${nt}-slide-down-enter${nt}-slide-down-enter-active${s}-placement-bottomRight,
          &${nt}-slide-down-appear${nt}-slide-down-appear-active${s}-placement-bottomRight`]: {
          animationName: slideUpIn
        },
        [`&${nt}-slide-up-enter${nt}-slide-up-enter-active${s}-placement-topLeft,
          &${nt}-slide-up-appear${nt}-slide-up-appear-active${s}-placement-topLeft,
          &${nt}-slide-up-enter${nt}-slide-up-enter-active${s}-placement-top,
          &${nt}-slide-up-appear${nt}-slide-up-appear-active${s}-placement-top,
          &${nt}-slide-up-enter${nt}-slide-up-enter-active${s}-placement-topRight,
          &${nt}-slide-up-appear${nt}-slide-up-appear-active${s}-placement-topRight`]: {
          animationName: slideDownIn
        },
        [`&${nt}-slide-down-leave${nt}-slide-down-leave-active${s}-placement-bottomLeft,
          &${nt}-slide-down-leave${nt}-slide-down-leave-active${s}-placement-bottom,
          &${nt}-slide-down-leave${nt}-slide-down-leave-active${s}-placement-bottomRight`]: {
          animationName: slideUpOut
        },
        [`&${nt}-slide-up-leave${nt}-slide-up-leave-active${s}-placement-topLeft,
          &${nt}-slide-up-leave${nt}-slide-up-leave-active${s}-placement-top,
          &${nt}-slide-up-leave${nt}-slide-up-leave-active${s}-placement-topRight`]: {
          animationName: slideDownOut
        }
      })
    },
    // =============================================================
    // ==                        Arrow style                      ==
    // =============================================================
    getArrowStyle(a, ft, {
      arrowPlacement: {
        top: !0,
        bottom: !0
      }
    }),
    {
      // =============================================================
      // ==                          Menu                           ==
      // =============================================================
      [`${s} ${$}`]: {
        position: "relative",
        margin: 0
      },
      [`${$}-submenu-popup`]: {
        position: "absolute",
        zIndex: _,
        background: "transparent",
        boxShadow: "none",
        transformOrigin: "0 0",
        "ul, li": {
          listStyle: "none",
          margin: 0
        }
      },
      [`${s}, ${s}-menu-submenu`]: {
        [$]: Object.assign(Object.assign({
          padding: lt,
          listStyleType: "none",
          backgroundColor: ft,
          backgroundClip: "padding-box",
          borderRadius: a.borderRadiusLG,
          outline: "none",
          boxShadow: a.boxShadowSecondary
        }, genFocusStyle(a)), {
          [`${$}-item-group-title`]: {
            padding: `${unit$1(rt)} ${unit$1(ut)}`,
            color: a.colorTextDescription,
            transition: `all ${ot}`
          },
          // ======================= Item Content =======================
          [`${$}-item`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          },
          [`${$}-item-icon`]: {
            minWidth: st,
            marginInlineEnd: a.marginXS,
            fontSize: a.fontSizeSM
          },
          [`${$}-title-content`]: {
            flex: "auto",
            "> a": {
              color: "inherit",
              transition: `all ${ot}`,
              "&:hover": {
                color: "inherit"
              },
              "&::after": {
                position: "absolute",
                inset: 0,
                content: '""'
              }
            }
          },
          // =========================== Item ===========================
          [`${$}-item, ${$}-submenu-title`]: Object.assign(Object.assign({
            clear: "both",
            margin: 0,
            padding: `${unit$1(rt)} ${unit$1(ut)}`,
            color: a.colorText,
            fontWeight: "normal",
            fontSize: st,
            lineHeight: a.lineHeight,
            cursor: "pointer",
            transition: `all ${ot}`,
            borderRadius: a.borderRadiusSM,
            "&:hover, &-active": {
              backgroundColor: a.controlItemBgHover
            }
          }, genFocusStyle(a)), {
            "&-selected": {
              color: a.colorPrimary,
              backgroundColor: a.controlItemBgActive,
              "&:hover, &-active": {
                backgroundColor: a.controlItemBgActiveHover
              }
            },
            "&-disabled": {
              color: et,
              cursor: "not-allowed",
              "&:hover": {
                color: et,
                backgroundColor: ft,
                cursor: "not-allowed"
              },
              a: {
                pointerEvents: "none"
              }
            },
            "&-divider": {
              height: 1,
              // By design
              margin: `${unit$1(a.marginXXS)} 0`,
              overflow: "hidden",
              lineHeight: 0,
              backgroundColor: a.colorSplit
            },
            [`${s}-menu-submenu-expand-icon`]: {
              position: "absolute",
              insetInlineEnd: a.paddingXS,
              [`${s}-menu-submenu-arrow-icon`]: {
                marginInlineEnd: "0 !important",
                color: a.colorTextDescription,
                fontSize: it,
                fontStyle: "normal"
              }
            }
          }),
          [`${$}-item-group-list`]: {
            margin: `0 ${unit$1(a.marginXS)}`,
            padding: 0,
            listStyle: "none"
          },
          [`${$}-submenu-title`]: {
            paddingInlineEnd: a.calc(ut).add(a.fontSizeSM).equal()
          },
          [`${$}-submenu-vertical`]: {
            position: "relative"
          },
          [`${$}-submenu${$}-submenu-disabled ${s}-menu-submenu-title`]: {
            [`&, ${s}-menu-submenu-arrow-icon`]: {
              color: et,
              backgroundColor: ft,
              cursor: "not-allowed"
            }
          },
          // https://github.com/ant-design/ant-design/issues/19264
          [`${$}-submenu-selected ${s}-menu-submenu-title`]: {
            color: a.colorPrimary
          }
        })
      }
    },
    // Follow code may reuse in other components
    [initSlideMotion(a, "slide-up"), initSlideMotion(a, "slide-down"), initMoveMotion(a, "move-up"), initMoveMotion(a, "move-down"), initZoomMotion(a, "zoom-big")]
  ];
}, prepareComponentToken$n = (a) => Object.assign(Object.assign({
  zIndexPopup: a.zIndexPopupBase + 50,
  paddingBlock: (a.controlHeight - a.fontSize * a.lineHeight) / 2
}, getArrowOffsetToken({
  contentRadius: a.borderRadiusLG,
  limitVerticalRadius: !0
})), getArrowToken(a)), useStyle$p = genStyleHooks("Dropdown", (a) => {
  const {
    marginXXS: s,
    sizePopupArrow: $,
    paddingXXS: _,
    componentCls: _e
  } = a, tt = merge(a, {
    menuCls: `${_e}-menu`,
    dropdownArrowDistance: a.calc($).div(2).add(s).equal(),
    dropdownEdgeChildPadding: _
  });
  return [genBaseStyle$9(tt), genStatusStyle$2(tt)];
}, prepareComponentToken$n), Dropdown$2 = (a) => {
  const {
    menu: s,
    arrow: $,
    prefixCls: _,
    children: _e,
    trigger: tt,
    disabled: nt,
    dropdownRender: at,
    getPopupContainer: ot,
    overlayClassName: rt,
    rootClassName: st,
    overlayStyle: lt,
    open: et,
    onOpenChange: it,
    // Deprecated
    visible: ut,
    onVisibleChange: ft,
    mouseEnterDelay: ht = 0.15,
    mouseLeaveDelay: dt = 0.1,
    autoAdjustOverflow: gt = !0,
    placement: pt = "",
    overlay: mt,
    transitionName: ct
  } = a, {
    getPopupContainer: vt,
    getPrefixCls: At,
    direction: xt,
    dropdown: bt
  } = reactExports.useContext(ConfigContext$1);
  devUseWarning();
  const Et = reactExports.useMemo(() => {
    const Vt = At();
    return ct !== void 0 ? ct : pt.includes("top") ? `${Vt}-slide-down` : `${Vt}-slide-up`;
  }, [At, pt, ct]), St = reactExports.useMemo(() => pt ? pt.includes("Center") ? pt.slice(0, pt.indexOf("Center")) : pt : xt === "rtl" ? "bottomRight" : "bottomLeft", [pt, xt]), Bt = At("dropdown", _), Ot = useCSSVarCls$1(Bt), [Pt, wt, Ct] = useStyle$p(Bt, Ot), [, It] = useToken$1(), yt = reactExports.Children.only(_e), Rt = cloneElement(yt, {
    className: classnames(`${Bt}-trigger`, {
      [`${Bt}-rtl`]: xt === "rtl"
    }, yt.props.className),
    disabled: nt
  }), kt = nt ? [] : tt;
  let jt;
  kt && kt.includes("contextMenu") && (jt = !0);
  const [Ht, Ft] = useMergedState(!1, {
    value: et ?? ut
  }), _t = useEvent((Vt) => {
    it == null || it(Vt, {
      source: "trigger"
    }), ft == null || ft(Vt), Ft(Vt);
  }), Nt = classnames(rt, st, wt, Ct, Ot, bt == null ? void 0 : bt.className, {
    [`${Bt}-rtl`]: xt === "rtl"
  }), Mt = getPlacements({
    arrowPointAtCenter: typeof $ == "object" && $.pointAtCenter,
    autoAdjustOverflow: gt,
    offset: It.marginXXS,
    arrowWidth: $ ? It.sizePopupArrow : 0,
    borderRadius: It.borderRadius
  }), Lt = reactExports.useCallback(() => {
    s != null && s.selectable && (s != null && s.multiple) || (it == null || it(!1, {
      source: "menu"
    }), Ft(!1));
  }, [s == null ? void 0 : s.selectable, s == null ? void 0 : s.multiple]), $t = () => {
    let Vt;
    return s != null && s.items ? Vt = /* @__PURE__ */ reactExports.createElement(Menu$1, Object.assign({}, s)) : typeof mt == "function" ? Vt = mt() : Vt = mt, at && (Vt = at(Vt)), Vt = reactExports.Children.only(typeof Vt == "string" ? /* @__PURE__ */ reactExports.createElement("span", null, Vt) : Vt), /* @__PURE__ */ reactExports.createElement(OverrideProvider, {
      prefixCls: `${Bt}-menu`,
      rootClassName: Ct,
      expandIcon: /* @__PURE__ */ reactExports.createElement("span", {
        className: `${Bt}-menu-submenu-arrow`
      }, /* @__PURE__ */ reactExports.createElement(RightOutlined$1, {
        className: `${Bt}-menu-submenu-arrow-icon`
      })),
      mode: "vertical",
      selectable: !1,
      onClick: Lt,
      validator: (Qt) => {
      }
    }, Vt);
  }, [Tt, Dt] = useZIndex("Dropdown", lt == null ? void 0 : lt.zIndex);
  let Ut = /* @__PURE__ */ reactExports.createElement(Dropdown$4, Object.assign({
    alignPoint: jt
  }, omit(a, ["rootClassName"]), {
    mouseEnterDelay: ht,
    mouseLeaveDelay: dt,
    visible: Ht,
    builtinPlacements: Mt,
    arrow: !!$,
    overlayClassName: Nt,
    prefixCls: Bt,
    getPopupContainer: ot || vt,
    transitionName: Et,
    trigger: kt,
    overlay: $t,
    placement: St,
    onVisibleChange: _t,
    overlayStyle: Object.assign(Object.assign(Object.assign({}, bt == null ? void 0 : bt.style), lt), {
      zIndex: Tt
    })
  }), Rt);
  return Tt && (Ut = /* @__PURE__ */ reactExports.createElement(zIndexContext$1.Provider, {
    value: Dt
  }, Ut)), Pt(Ut);
};
function postPureProps(a) {
  return Object.assign(Object.assign({}, a), {
    align: {
      overflow: {
        adjustX: !1,
        adjustY: !1
      }
    }
  });
}
const PurePanel$4 = genPurePanel$1(Dropdown$2, "dropdown", (a) => a, postPureProps), WrapPurePanel = (a) => /* @__PURE__ */ reactExports.createElement(PurePanel$4, Object.assign({}, a), /* @__PURE__ */ reactExports.createElement("span", null));
Dropdown$2._InternalPanelDoNotUseOrYouWillBeFired = WrapPurePanel;
const InternalDropdown = Dropdown$2;
var dayjs_min = { exports: {} };
(function(a, s) {
  (function($, _) {
    a.exports = _();
  })(commonjsGlobal, function() {
    var $ = 1e3, _ = 6e4, _e = 36e5, tt = "millisecond", nt = "second", at = "minute", ot = "hour", rt = "day", st = "week", lt = "month", et = "quarter", it = "year", ut = "date", ft = "Invalid Date", ht = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, dt = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, gt = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(Pt) {
      var wt = ["th", "st", "nd", "rd"], Ct = Pt % 100;
      return "[" + Pt + (wt[(Ct - 20) % 10] || wt[Ct] || wt[0]) + "]";
    } }, pt = function(Pt, wt, Ct) {
      var It = String(Pt);
      return !It || It.length >= wt ? Pt : "" + Array(wt + 1 - It.length).join(Ct) + Pt;
    }, mt = { s: pt, z: function(Pt) {
      var wt = -Pt.utcOffset(), Ct = Math.abs(wt), It = Math.floor(Ct / 60), yt = Ct % 60;
      return (wt <= 0 ? "+" : "-") + pt(It, 2, "0") + ":" + pt(yt, 2, "0");
    }, m: function Pt(wt, Ct) {
      if (wt.date() < Ct.date())
        return -Pt(Ct, wt);
      var It = 12 * (Ct.year() - wt.year()) + (Ct.month() - wt.month()), yt = wt.clone().add(It, lt), Rt = Ct - yt < 0, kt = wt.clone().add(It + (Rt ? -1 : 1), lt);
      return +(-(It + (Ct - yt) / (Rt ? yt - kt : kt - yt)) || 0);
    }, a: function(Pt) {
      return Pt < 0 ? Math.ceil(Pt) || 0 : Math.floor(Pt);
    }, p: function(Pt) {
      return { M: lt, y: it, w: st, d: rt, D: ut, h: ot, m: at, s: nt, ms: tt, Q: et }[Pt] || String(Pt || "").toLowerCase().replace(/s$/, "");
    }, u: function(Pt) {
      return Pt === void 0;
    } }, ct = "en", vt = {};
    vt[ct] = gt;
    var At = "$isDayjsObject", xt = function(Pt) {
      return Pt instanceof Bt || !(!Pt || !Pt[At]);
    }, bt = function Pt(wt, Ct, It) {
      var yt;
      if (!wt)
        return ct;
      if (typeof wt == "string") {
        var Rt = wt.toLowerCase();
        vt[Rt] && (yt = Rt), Ct && (vt[Rt] = Ct, yt = Rt);
        var kt = wt.split("-");
        if (!yt && kt.length > 1)
          return Pt(kt[0]);
      } else {
        var jt = wt.name;
        vt[jt] = wt, yt = jt;
      }
      return !It && yt && (ct = yt), yt || !It && ct;
    }, Et = function(Pt, wt) {
      if (xt(Pt))
        return Pt.clone();
      var Ct = typeof wt == "object" ? wt : {};
      return Ct.date = Pt, Ct.args = arguments, new Bt(Ct);
    }, St = mt;
    St.l = bt, St.i = xt, St.w = function(Pt, wt) {
      return Et(Pt, { locale: wt.$L, utc: wt.$u, x: wt.$x, $offset: wt.$offset });
    };
    var Bt = function() {
      function Pt(Ct) {
        this.$L = bt(Ct.locale, null, !0), this.parse(Ct), this.$x = this.$x || Ct.x || {}, this[At] = !0;
      }
      var wt = Pt.prototype;
      return wt.parse = function(Ct) {
        this.$d = function(It) {
          var yt = It.date, Rt = It.utc;
          if (yt === null)
            return /* @__PURE__ */ new Date(NaN);
          if (St.u(yt))
            return /* @__PURE__ */ new Date();
          if (yt instanceof Date)
            return new Date(yt);
          if (typeof yt == "string" && !/Z$/i.test(yt)) {
            var kt = yt.match(ht);
            if (kt) {
              var jt = kt[2] - 1 || 0, Ht = (kt[7] || "0").substring(0, 3);
              return Rt ? new Date(Date.UTC(kt[1], jt, kt[3] || 1, kt[4] || 0, kt[5] || 0, kt[6] || 0, Ht)) : new Date(kt[1], jt, kt[3] || 1, kt[4] || 0, kt[5] || 0, kt[6] || 0, Ht);
            }
          }
          return new Date(yt);
        }(Ct), this.init();
      }, wt.init = function() {
        var Ct = this.$d;
        this.$y = Ct.getFullYear(), this.$M = Ct.getMonth(), this.$D = Ct.getDate(), this.$W = Ct.getDay(), this.$H = Ct.getHours(), this.$m = Ct.getMinutes(), this.$s = Ct.getSeconds(), this.$ms = Ct.getMilliseconds();
      }, wt.$utils = function() {
        return St;
      }, wt.isValid = function() {
        return this.$d.toString() !== ft;
      }, wt.isSame = function(Ct, It) {
        var yt = Et(Ct);
        return this.startOf(It) <= yt && yt <= this.endOf(It);
      }, wt.isAfter = function(Ct, It) {
        return Et(Ct) < this.startOf(It);
      }, wt.isBefore = function(Ct, It) {
        return this.endOf(It) < Et(Ct);
      }, wt.$g = function(Ct, It, yt) {
        return St.u(Ct) ? this[It] : this.set(yt, Ct);
      }, wt.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, wt.valueOf = function() {
        return this.$d.getTime();
      }, wt.startOf = function(Ct, It) {
        var yt = this, Rt = !!St.u(It) || It, kt = St.p(Ct), jt = function(Tt, Dt) {
          var Ut = St.w(yt.$u ? Date.UTC(yt.$y, Dt, Tt) : new Date(yt.$y, Dt, Tt), yt);
          return Rt ? Ut : Ut.endOf(rt);
        }, Ht = function(Tt, Dt) {
          return St.w(yt.toDate()[Tt].apply(yt.toDate("s"), (Rt ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Dt)), yt);
        }, Ft = this.$W, _t = this.$M, Nt = this.$D, Mt = "set" + (this.$u ? "UTC" : "");
        switch (kt) {
          case it:
            return Rt ? jt(1, 0) : jt(31, 11);
          case lt:
            return Rt ? jt(1, _t) : jt(0, _t + 1);
          case st:
            var Lt = this.$locale().weekStart || 0, $t = (Ft < Lt ? Ft + 7 : Ft) - Lt;
            return jt(Rt ? Nt - $t : Nt + (6 - $t), _t);
          case rt:
          case ut:
            return Ht(Mt + "Hours", 0);
          case ot:
            return Ht(Mt + "Minutes", 1);
          case at:
            return Ht(Mt + "Seconds", 2);
          case nt:
            return Ht(Mt + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, wt.endOf = function(Ct) {
        return this.startOf(Ct, !1);
      }, wt.$set = function(Ct, It) {
        var yt, Rt = St.p(Ct), kt = "set" + (this.$u ? "UTC" : ""), jt = (yt = {}, yt[rt] = kt + "Date", yt[ut] = kt + "Date", yt[lt] = kt + "Month", yt[it] = kt + "FullYear", yt[ot] = kt + "Hours", yt[at] = kt + "Minutes", yt[nt] = kt + "Seconds", yt[tt] = kt + "Milliseconds", yt)[Rt], Ht = Rt === rt ? this.$D + (It - this.$W) : It;
        if (Rt === lt || Rt === it) {
          var Ft = this.clone().set(ut, 1);
          Ft.$d[jt](Ht), Ft.init(), this.$d = Ft.set(ut, Math.min(this.$D, Ft.daysInMonth())).$d;
        } else
          jt && this.$d[jt](Ht);
        return this.init(), this;
      }, wt.set = function(Ct, It) {
        return this.clone().$set(Ct, It);
      }, wt.get = function(Ct) {
        return this[St.p(Ct)]();
      }, wt.add = function(Ct, It) {
        var yt, Rt = this;
        Ct = Number(Ct);
        var kt = St.p(It), jt = function(_t) {
          var Nt = Et(Rt);
          return St.w(Nt.date(Nt.date() + Math.round(_t * Ct)), Rt);
        };
        if (kt === lt)
          return this.set(lt, this.$M + Ct);
        if (kt === it)
          return this.set(it, this.$y + Ct);
        if (kt === rt)
          return jt(1);
        if (kt === st)
          return jt(7);
        var Ht = (yt = {}, yt[at] = _, yt[ot] = _e, yt[nt] = $, yt)[kt] || 1, Ft = this.$d.getTime() + Ct * Ht;
        return St.w(Ft, this);
      }, wt.subtract = function(Ct, It) {
        return this.add(-1 * Ct, It);
      }, wt.format = function(Ct) {
        var It = this, yt = this.$locale();
        if (!this.isValid())
          return yt.invalidDate || ft;
        var Rt = Ct || "YYYY-MM-DDTHH:mm:ssZ", kt = St.z(this), jt = this.$H, Ht = this.$m, Ft = this.$M, _t = yt.weekdays, Nt = yt.months, Mt = yt.meridiem, Lt = function(Dt, Ut, Vt, Qt) {
          return Dt && (Dt[Ut] || Dt(It, Rt)) || Vt[Ut].slice(0, Qt);
        }, $t = function(Dt) {
          return St.s(jt % 12 || 12, Dt, "0");
        }, Tt = Mt || function(Dt, Ut, Vt) {
          var Qt = Dt < 12 ? "AM" : "PM";
          return Vt ? Qt.toLowerCase() : Qt;
        };
        return Rt.replace(dt, function(Dt, Ut) {
          return Ut || function(Vt) {
            switch (Vt) {
              case "YY":
                return String(It.$y).slice(-2);
              case "YYYY":
                return St.s(It.$y, 4, "0");
              case "M":
                return Ft + 1;
              case "MM":
                return St.s(Ft + 1, 2, "0");
              case "MMM":
                return Lt(yt.monthsShort, Ft, Nt, 3);
              case "MMMM":
                return Lt(Nt, Ft);
              case "D":
                return It.$D;
              case "DD":
                return St.s(It.$D, 2, "0");
              case "d":
                return String(It.$W);
              case "dd":
                return Lt(yt.weekdaysMin, It.$W, _t, 2);
              case "ddd":
                return Lt(yt.weekdaysShort, It.$W, _t, 3);
              case "dddd":
                return _t[It.$W];
              case "H":
                return String(jt);
              case "HH":
                return St.s(jt, 2, "0");
              case "h":
                return $t(1);
              case "hh":
                return $t(2);
              case "a":
                return Tt(jt, Ht, !0);
              case "A":
                return Tt(jt, Ht, !1);
              case "m":
                return String(Ht);
              case "mm":
                return St.s(Ht, 2, "0");
              case "s":
                return String(It.$s);
              case "ss":
                return St.s(It.$s, 2, "0");
              case "SSS":
                return St.s(It.$ms, 3, "0");
              case "Z":
                return kt;
            }
            return null;
          }(Dt) || kt.replace(":", "");
        });
      }, wt.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, wt.diff = function(Ct, It, yt) {
        var Rt, kt = this, jt = St.p(It), Ht = Et(Ct), Ft = (Ht.utcOffset() - this.utcOffset()) * _, _t = this - Ht, Nt = function() {
          return St.m(kt, Ht);
        };
        switch (jt) {
          case it:
            Rt = Nt() / 12;
            break;
          case lt:
            Rt = Nt();
            break;
          case et:
            Rt = Nt() / 3;
            break;
          case st:
            Rt = (_t - Ft) / 6048e5;
            break;
          case rt:
            Rt = (_t - Ft) / 864e5;
            break;
          case ot:
            Rt = _t / _e;
            break;
          case at:
            Rt = _t / _;
            break;
          case nt:
            Rt = _t / $;
            break;
          default:
            Rt = _t;
        }
        return yt ? Rt : St.a(Rt);
      }, wt.daysInMonth = function() {
        return this.endOf(lt).$D;
      }, wt.$locale = function() {
        return vt[this.$L];
      }, wt.locale = function(Ct, It) {
        if (!Ct)
          return this.$L;
        var yt = this.clone(), Rt = bt(Ct, It, !0);
        return Rt && (yt.$L = Rt), yt;
      }, wt.clone = function() {
        return St.w(this.$d, this);
      }, wt.toDate = function() {
        return new Date(this.valueOf());
      }, wt.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, wt.toISOString = function() {
        return this.$d.toISOString();
      }, wt.toString = function() {
        return this.$d.toUTCString();
      }, Pt;
    }(), Ot = Bt.prototype;
    return Et.prototype = Ot, [["$ms", tt], ["$s", nt], ["$m", at], ["$H", ot], ["$W", rt], ["$M", lt], ["$y", it], ["$D", ut]].forEach(function(Pt) {
      Ot[Pt[1]] = function(wt) {
        return this.$g(wt, Pt[0], Pt[1]);
      };
    }), Et.extend = function(Pt, wt) {
      return Pt.$i || (Pt(wt, Bt, Et), Pt.$i = !0), Et;
    }, Et.locale = bt, Et.isDayjs = xt, Et.unix = function(Pt) {
      return Et(1e3 * Pt);
    }, Et.en = vt[ct], Et.Ls = vt, Et.p = {}, Et;
  });
})(dayjs_min);
var dayjs_minExports = dayjs_min.exports;
const dayjs = /* @__PURE__ */ getDefaultExportFromCjs(dayjs_minExports);
var weekday$1 = { exports: {} };
(function(a, s) {
  (function($, _) {
    a.exports = _();
  })(commonjsGlobal, function() {
    return function($, _) {
      _.prototype.weekday = function(_e) {
        var tt = this.$locale().weekStart || 0, nt = this.$W, at = (nt < tt ? nt + 7 : nt) - tt;
        return this.$utils().u(_e) ? at : this.subtract(at, "day").add(_e, "day");
      };
    };
  });
})(weekday$1);
var weekdayExports = weekday$1.exports;
const weekday = /* @__PURE__ */ getDefaultExportFromCjs(weekdayExports);
var localeData$1 = { exports: {} };
(function(a, s) {
  (function($, _) {
    a.exports = _();
  })(commonjsGlobal, function() {
    return function($, _, _e) {
      var tt = _.prototype, nt = function(lt) {
        return lt && (lt.indexOf ? lt : lt.s);
      }, at = function(lt, et, it, ut, ft) {
        var ht = lt.name ? lt : lt.$locale(), dt = nt(ht[et]), gt = nt(ht[it]), pt = dt || gt.map(function(ct) {
          return ct.slice(0, ut);
        });
        if (!ft)
          return pt;
        var mt = ht.weekStart;
        return pt.map(function(ct, vt) {
          return pt[(vt + (mt || 0)) % 7];
        });
      }, ot = function() {
        return _e.Ls[_e.locale()];
      }, rt = function(lt, et) {
        return lt.formats[et] || function(it) {
          return it.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(ut, ft, ht) {
            return ft || ht.slice(1);
          });
        }(lt.formats[et.toUpperCase()]);
      }, st = function() {
        var lt = this;
        return { months: function(et) {
          return et ? et.format("MMMM") : at(lt, "months");
        }, monthsShort: function(et) {
          return et ? et.format("MMM") : at(lt, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return lt.$locale().weekStart || 0;
        }, weekdays: function(et) {
          return et ? et.format("dddd") : at(lt, "weekdays");
        }, weekdaysMin: function(et) {
          return et ? et.format("dd") : at(lt, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(et) {
          return et ? et.format("ddd") : at(lt, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(et) {
          return rt(lt.$locale(), et);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      tt.localeData = function() {
        return st.bind(this)();
      }, _e.localeData = function() {
        var lt = ot();
        return { firstDayOfWeek: function() {
          return lt.weekStart || 0;
        }, weekdays: function() {
          return _e.weekdays();
        }, weekdaysShort: function() {
          return _e.weekdaysShort();
        }, weekdaysMin: function() {
          return _e.weekdaysMin();
        }, months: function() {
          return _e.months();
        }, monthsShort: function() {
          return _e.monthsShort();
        }, longDateFormat: function(et) {
          return rt(lt, et);
        }, meridiem: lt.meridiem, ordinal: lt.ordinal };
      }, _e.months = function() {
        return at(ot(), "months");
      }, _e.monthsShort = function() {
        return at(ot(), "monthsShort", "months", 3);
      }, _e.weekdays = function(lt) {
        return at(ot(), "weekdays", null, null, lt);
      }, _e.weekdaysShort = function(lt) {
        return at(ot(), "weekdaysShort", "weekdays", 3, lt);
      }, _e.weekdaysMin = function(lt) {
        return at(ot(), "weekdaysMin", "weekdays", 2, lt);
      };
    };
  });
})(localeData$1);
var localeDataExports = localeData$1.exports;
const localeData = /* @__PURE__ */ getDefaultExportFromCjs(localeDataExports);
var weekOfYear$1 = { exports: {} };
(function(a, s) {
  (function($, _) {
    a.exports = _();
  })(commonjsGlobal, function() {
    var $ = "week", _ = "year";
    return function(_e, tt, nt) {
      var at = tt.prototype;
      at.week = function(ot) {
        if (ot === void 0 && (ot = null), ot !== null)
          return this.add(7 * (ot - this.week()), "day");
        var rt = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var st = nt(this).startOf(_).add(1, _).date(rt), lt = nt(this).endOf($);
          if (st.isBefore(lt))
            return 1;
        }
        var et = nt(this).startOf(_).date(rt).startOf($).subtract(1, "millisecond"), it = this.diff(et, $, !0);
        return it < 0 ? nt(this).startOf("week").week() : Math.ceil(it);
      }, at.weeks = function(ot) {
        return ot === void 0 && (ot = null), this.week(ot);
      };
    };
  });
})(weekOfYear$1);
var weekOfYearExports = weekOfYear$1.exports;
const weekOfYear = /* @__PURE__ */ getDefaultExportFromCjs(weekOfYearExports);
var weekYear$1 = { exports: {} };
(function(a, s) {
  (function($, _) {
    a.exports = _();
  })(commonjsGlobal, function() {
    return function($, _) {
      _.prototype.weekYear = function() {
        var _e = this.month(), tt = this.week(), nt = this.year();
        return tt === 1 && _e === 11 ? nt + 1 : _e === 0 && tt >= 52 ? nt - 1 : nt;
      };
    };
  });
})(weekYear$1);
var weekYearExports = weekYear$1.exports;
const weekYear = /* @__PURE__ */ getDefaultExportFromCjs(weekYearExports);
var advancedFormat$1 = { exports: {} };
(function(a, s) {
  (function($, _) {
    a.exports = _();
  })(commonjsGlobal, function() {
    return function($, _) {
      var _e = _.prototype, tt = _e.format;
      _e.format = function(nt) {
        var at = this, ot = this.$locale();
        if (!this.isValid())
          return tt.bind(this)(nt);
        var rt = this.$utils(), st = (nt || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(lt) {
          switch (lt) {
            case "Q":
              return Math.ceil((at.$M + 1) / 3);
            case "Do":
              return ot.ordinal(at.$D);
            case "gggg":
              return at.weekYear();
            case "GGGG":
              return at.isoWeekYear();
            case "wo":
              return ot.ordinal(at.week(), "W");
            case "w":
            case "ww":
              return rt.s(at.week(), lt === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return rt.s(at.isoWeek(), lt === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return rt.s(String(at.$H === 0 ? 24 : at.$H), lt === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(at.$d.getTime() / 1e3);
            case "x":
              return at.$d.getTime();
            case "z":
              return "[" + at.offsetName() + "]";
            case "zzz":
              return "[" + at.offsetName("long") + "]";
            default:
              return lt;
          }
        });
        return tt.bind(this)(st);
      };
    };
  });
})(advancedFormat$1);
var advancedFormatExports = advancedFormat$1.exports;
const advancedFormat = /* @__PURE__ */ getDefaultExportFromCjs(advancedFormatExports);
var customParseFormat$1 = { exports: {} };
(function(a, s) {
  (function($, _) {
    a.exports = _();
  })(commonjsGlobal, function() {
    var $ = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, _ = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, _e = /\d\d/, tt = /\d\d?/, nt = /\d*[^-_:/,()\s\d]+/, at = {}, ot = function(ft) {
      return (ft = +ft) + (ft > 68 ? 1900 : 2e3);
    }, rt = function(ft) {
      return function(ht) {
        this[ft] = +ht;
      };
    }, st = [/[+-]\d\d:?(\d\d)?|Z/, function(ft) {
      (this.zone || (this.zone = {})).offset = function(ht) {
        if (!ht || ht === "Z")
          return 0;
        var dt = ht.match(/([+-]|\d\d)/g), gt = 60 * dt[1] + (+dt[2] || 0);
        return gt === 0 ? 0 : dt[0] === "+" ? -gt : gt;
      }(ft);
    }], lt = function(ft) {
      var ht = at[ft];
      return ht && (ht.indexOf ? ht : ht.s.concat(ht.f));
    }, et = function(ft, ht) {
      var dt, gt = at.meridiem;
      if (gt) {
        for (var pt = 1; pt <= 24; pt += 1)
          if (ft.indexOf(gt(pt, 0, ht)) > -1) {
            dt = pt > 12;
            break;
          }
      } else
        dt = ft === (ht ? "pm" : "PM");
      return dt;
    }, it = { A: [nt, function(ft) {
      this.afternoon = et(ft, !1);
    }], a: [nt, function(ft) {
      this.afternoon = et(ft, !0);
    }], S: [/\d/, function(ft) {
      this.milliseconds = 100 * +ft;
    }], SS: [_e, function(ft) {
      this.milliseconds = 10 * +ft;
    }], SSS: [/\d{3}/, function(ft) {
      this.milliseconds = +ft;
    }], s: [tt, rt("seconds")], ss: [tt, rt("seconds")], m: [tt, rt("minutes")], mm: [tt, rt("minutes")], H: [tt, rt("hours")], h: [tt, rt("hours")], HH: [tt, rt("hours")], hh: [tt, rt("hours")], D: [tt, rt("day")], DD: [_e, rt("day")], Do: [nt, function(ft) {
      var ht = at.ordinal, dt = ft.match(/\d+/);
      if (this.day = dt[0], ht)
        for (var gt = 1; gt <= 31; gt += 1)
          ht(gt).replace(/\[|\]/g, "") === ft && (this.day = gt);
    }], M: [tt, rt("month")], MM: [_e, rt("month")], MMM: [nt, function(ft) {
      var ht = lt("months"), dt = (lt("monthsShort") || ht.map(function(gt) {
        return gt.slice(0, 3);
      })).indexOf(ft) + 1;
      if (dt < 1)
        throw new Error();
      this.month = dt % 12 || dt;
    }], MMMM: [nt, function(ft) {
      var ht = lt("months").indexOf(ft) + 1;
      if (ht < 1)
        throw new Error();
      this.month = ht % 12 || ht;
    }], Y: [/[+-]?\d+/, rt("year")], YY: [_e, function(ft) {
      this.year = ot(ft);
    }], YYYY: [/\d{4}/, rt("year")], Z: st, ZZ: st };
    function ut(ft) {
      var ht, dt;
      ht = ft, dt = at && at.formats;
      for (var gt = (ft = ht.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(bt, Et, St) {
        var Bt = St && St.toUpperCase();
        return Et || dt[St] || $[St] || dt[Bt].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(Ot, Pt, wt) {
          return Pt || wt.slice(1);
        });
      })).match(_), pt = gt.length, mt = 0; mt < pt; mt += 1) {
        var ct = gt[mt], vt = it[ct], At = vt && vt[0], xt = vt && vt[1];
        gt[mt] = xt ? { regex: At, parser: xt } : ct.replace(/^\[|\]$/g, "");
      }
      return function(bt) {
        for (var Et = {}, St = 0, Bt = 0; St < pt; St += 1) {
          var Ot = gt[St];
          if (typeof Ot == "string")
            Bt += Ot.length;
          else {
            var Pt = Ot.regex, wt = Ot.parser, Ct = bt.slice(Bt), It = Pt.exec(Ct)[0];
            wt.call(Et, It), bt = bt.replace(It, "");
          }
        }
        return function(yt) {
          var Rt = yt.afternoon;
          if (Rt !== void 0) {
            var kt = yt.hours;
            Rt ? kt < 12 && (yt.hours += 12) : kt === 12 && (yt.hours = 0), delete yt.afternoon;
          }
        }(Et), Et;
      };
    }
    return function(ft, ht, dt) {
      dt.p.customParseFormat = !0, ft && ft.parseTwoDigitYear && (ot = ft.parseTwoDigitYear);
      var gt = ht.prototype, pt = gt.parse;
      gt.parse = function(mt) {
        var ct = mt.date, vt = mt.utc, At = mt.args;
        this.$u = vt;
        var xt = At[1];
        if (typeof xt == "string") {
          var bt = At[2] === !0, Et = At[3] === !0, St = bt || Et, Bt = At[2];
          Et && (Bt = At[2]), at = this.$locale(), !bt && Bt && (at = dt.Ls[Bt]), this.$d = function(Ct, It, yt) {
            try {
              if (["x", "X"].indexOf(It) > -1)
                return new Date((It === "X" ? 1e3 : 1) * Ct);
              var Rt = ut(It)(Ct), kt = Rt.year, jt = Rt.month, Ht = Rt.day, Ft = Rt.hours, _t = Rt.minutes, Nt = Rt.seconds, Mt = Rt.milliseconds, Lt = Rt.zone, $t = /* @__PURE__ */ new Date(), Tt = Ht || (kt || jt ? 1 : $t.getDate()), Dt = kt || $t.getFullYear(), Ut = 0;
              kt && !jt || (Ut = jt > 0 ? jt - 1 : $t.getMonth());
              var Vt = Ft || 0, Qt = _t || 0, qt = Nt || 0, Zt = Mt || 0;
              return Lt ? new Date(Date.UTC(Dt, Ut, Tt, Vt, Qt, qt, Zt + 60 * Lt.offset * 1e3)) : yt ? new Date(Date.UTC(Dt, Ut, Tt, Vt, Qt, qt, Zt)) : new Date(Dt, Ut, Tt, Vt, Qt, qt, Zt);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(ct, xt, vt), this.init(), Bt && Bt !== !0 && (this.$L = this.locale(Bt).$L), St && ct != this.format(xt) && (this.$d = /* @__PURE__ */ new Date("")), at = {};
        } else if (xt instanceof Array)
          for (var Ot = xt.length, Pt = 1; Pt <= Ot; Pt += 1) {
            At[1] = xt[Pt - 1];
            var wt = dt.apply(this, At);
            if (wt.isValid()) {
              this.$d = wt.$d, this.$L = wt.$L, this.init();
              break;
            }
            Pt === Ot && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          pt.call(this, mt);
      };
    };
  });
})(customParseFormat$1);
var customParseFormatExports = customParseFormat$1.exports;
const customParseFormat = /* @__PURE__ */ getDefaultExportFromCjs(customParseFormatExports);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(function(a, s) {
  var $ = s.prototype, _ = $.format;
  $.format = function(tt) {
    var nt = (tt || "").replace("Wo", "wo");
    return _.bind(this)(nt);
  };
});
var localeMap = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: "bn-bd",
  by_BY: "be",
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: "en-gb",
  en_US: "en",
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: "fr",
  // todo: dayjs has no fr_BE locale, use fr at present
  fr_CA: "fr-ca",
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: "hy-am",
  // id_ID:
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: "ku",
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: "nl-be",
  // nl_NL:
  // pl_PL:
  pt_BR: "pt-br",
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: "zh-cn",
  zh_HK: "zh-hk",
  zh_TW: "zh-tw"
}, parseLocale = function a(s) {
  var $ = localeMap[s];
  return $ || s.split("_")[0];
}, parseNoMatchNotice = function a() {
  noteOnce(!1, "Not match any format. Please help to fire a issue about this.");
}, generateConfig = {
  // get
  getNow: function a() {
    return dayjs();
  },
  getFixedDate: function a(s) {
    return dayjs(s, ["YYYY-M-DD", "YYYY-MM-DD"]);
  },
  getEndDate: function a(s) {
    return s.endOf("month");
  },
  getWeekDay: function a(s) {
    var $ = s.locale("en");
    return $.weekday() + $.localeData().firstDayOfWeek();
  },
  getYear: function a(s) {
    return s.year();
  },
  getMonth: function a(s) {
    return s.month();
  },
  getDate: function a(s) {
    return s.date();
  },
  getHour: function a(s) {
    return s.hour();
  },
  getMinute: function a(s) {
    return s.minute();
  },
  getSecond: function a(s) {
    return s.second();
  },
  // set
  addYear: function a(s, $) {
    return s.add($, "year");
  },
  addMonth: function a(s, $) {
    return s.add($, "month");
  },
  addDate: function a(s, $) {
    return s.add($, "day");
  },
  setYear: function a(s, $) {
    return s.year($);
  },
  setMonth: function a(s, $) {
    return s.month($);
  },
  setDate: function a(s, $) {
    return s.date($);
  },
  setHour: function a(s, $) {
    return s.hour($);
  },
  setMinute: function a(s, $) {
    return s.minute($);
  },
  setSecond: function a(s, $) {
    return s.second($);
  },
  // Compare
  isAfter: function a(s, $) {
    return s.isAfter($);
  },
  isValidate: function a(s) {
    return s.isValid();
  },
  locale: {
    getWeekFirstDay: function a(s) {
      return dayjs().locale(parseLocale(s)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function a(s, $) {
      return $.locale(parseLocale(s)).weekday(0);
    },
    getWeek: function a(s, $) {
      return $.locale(parseLocale(s)).week();
    },
    getShortWeekDays: function a(s) {
      return dayjs().locale(parseLocale(s)).localeData().weekdaysMin();
    },
    getShortMonths: function a(s) {
      return dayjs().locale(parseLocale(s)).localeData().monthsShort();
    },
    format: function a(s, $, _) {
      return $.locale(parseLocale(s)).format(_);
    },
    parse: function a(s, $, _) {
      for (var _e = parseLocale(s), tt = 0; tt < _.length; tt += 1) {
        var nt = _[tt], at = $;
        if (nt.includes("wo") || nt.includes("Wo")) {
          for (var ot = at.split("-")[0], rt = at.split("-")[1], st = dayjs(ot, "YYYY").startOf("year").locale(_e), lt = 0; lt <= 52; lt += 1) {
            var et = st.add(lt, "week");
            if (et.format("Wo") === rt)
              return et;
          }
          return parseNoMatchNotice(), null;
        }
        var it = dayjs(at, nt, !0).locale(_e);
        if (it.isValid())
          return it;
      }
      return $ && parseNoMatchNotice(), null;
    }
  }
}, DECADE_UNIT_DIFF = 10, DECADE_DISTANCE_COUNT = DECADE_UNIT_DIFF * 10, WEEK_DAY_COUNT = 7;
function isNullEqual(a, s) {
  if (!a && !s)
    return !0;
  if (!a || !s)
    return !1;
}
function isSameDecade(a, s, $) {
  var _ = isNullEqual(s, $);
  if (typeof _ == "boolean")
    return _;
  var _e = Math.floor(a.getYear(s) / 10), tt = Math.floor(a.getYear($) / 10);
  return _e === tt;
}
function isSameYear(a, s, $) {
  var _ = isNullEqual(s, $);
  return typeof _ == "boolean" ? _ : a.getYear(s) === a.getYear($);
}
function getQuarter(a, s) {
  var $ = Math.floor(a.getMonth(s) / 3);
  return $ + 1;
}
function isSameQuarter(a, s, $) {
  var _ = isNullEqual(s, $);
  return typeof _ == "boolean" ? _ : isSameYear(a, s, $) && getQuarter(a, s) === getQuarter(a, $);
}
function isSameMonth(a, s, $) {
  var _ = isNullEqual(s, $);
  return typeof _ == "boolean" ? _ : isSameYear(a, s, $) && a.getMonth(s) === a.getMonth($);
}
function isSameDate(a, s, $) {
  var _ = isNullEqual(s, $);
  return typeof _ == "boolean" ? _ : a.getYear(s) === a.getYear($) && a.getMonth(s) === a.getMonth($) && a.getDate(s) === a.getDate($);
}
function isSameTime(a, s, $) {
  var _ = isNullEqual(s, $);
  return typeof _ == "boolean" ? _ : a.getHour(s) === a.getHour($) && a.getMinute(s) === a.getMinute($) && a.getSecond(s) === a.getSecond($);
}
function isSameWeek(a, s, $, _) {
  var _e = isNullEqual($, _);
  return typeof _e == "boolean" ? _e : isSameYear(a, $, _) && a.locale.getWeek(s, $) === a.locale.getWeek(s, _);
}
function isEqual(a, s, $) {
  return isSameDate(a, s, $) && isSameTime(a, s, $);
}
function isInRange(a, s, $, _) {
  return !s || !$ || !_ ? !1 : !isSameDate(a, s, _) && !isSameDate(a, $, _) && a.isAfter(_, s) && a.isAfter($, _);
}
function getWeekStartDate(a, s, $) {
  var _ = s.locale.getWeekFirstDay(a), _e = s.setDate($, 1), tt = s.getWeekDay(_e), nt = s.addDate(_e, _ - tt);
  return s.getMonth(nt) === s.getMonth($) && s.getDate(nt) > 1 && (nt = s.addDate(nt, -7)), nt;
}
function getClosingViewDate(a, s, $) {
  var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  switch (s) {
    case "year":
      return $.addYear(a, _ * 10);
    case "quarter":
    case "month":
      return $.addYear(a, _);
    default:
      return $.addMonth(a, _);
  }
}
function formatValue(a, s) {
  var $ = s.generateConfig, _ = s.locale, _e = s.format;
  return typeof _e == "function" ? _e(a) : $.locale.format(_.locale, a, _e);
}
function parseValue(a, s) {
  var $ = s.generateConfig, _ = s.locale, _e = s.formatList;
  return !a || typeof _e[0] == "function" ? null : $.locale.parse(_.locale, a, _e);
}
function getCellDateDisabled(a) {
  var s = a.cellDate, $ = a.mode, _ = a.disabledDate, _e = a.generateConfig;
  if (!_)
    return !1;
  var tt = function(ut, ft, ht) {
    for (var dt = ft; dt <= ht; ) {
      var gt = void 0;
      switch (ut) {
        case "date": {
          if (gt = _e.setDate(s, dt), !_(gt))
            return !1;
          break;
        }
        case "month": {
          if (gt = _e.setMonth(s, dt), !getCellDateDisabled({
            cellDate: gt,
            mode: "month",
            generateConfig: _e,
            disabledDate: _
          }))
            return !1;
          break;
        }
        case "year": {
          if (gt = _e.setYear(s, dt), !getCellDateDisabled({
            cellDate: gt,
            mode: "year",
            generateConfig: _e,
            disabledDate: _
          }))
            return !1;
          break;
        }
      }
      dt += 1;
    }
    return !0;
  };
  switch ($) {
    case "date":
    case "week":
      return _(s);
    case "month": {
      var nt = 1, at = _e.getDate(_e.getEndDate(s));
      return tt("date", nt, at);
    }
    case "quarter": {
      var ot = Math.floor(_e.getMonth(s) / 3) * 3, rt = ot + 2;
      return tt("month", ot, rt);
    }
    case "year":
      return tt("month", 0, 11);
    case "decade": {
      var st = _e.getYear(s), lt = Math.floor(st / DECADE_UNIT_DIFF) * DECADE_UNIT_DIFF, et = lt + DECADE_UNIT_DIFF - 1;
      return tt("year", lt, et);
    }
  }
}
function useValueTexts(a, s) {
  var $ = s.formatList, _ = s.generateConfig, _e = s.locale, tt = useMemo(function() {
    if (!a)
      return [[""], ""];
    for (var rt = "", st = [], lt = 0; lt < $.length; lt += 1) {
      var et = $[lt], it = formatValue(a, {
        generateConfig: _,
        locale: _e,
        format: et
      });
      st.push(it), lt === 0 && (rt = it);
    }
    return [st, rt];
  }, [a, $, _e], function(rt, st) {
    return (
      // Not Same Date
      !isEqual(_, rt[0], st[0]) || // Not Same format
      !isEqual$1(rt[1], st[1], !0) || // Not Same locale
      !isEqual$1(rt[2], st[2], !0)
    );
  }), nt = _slicedToArray$e(tt, 2), at = nt[0], ot = nt[1];
  return reactExports.useMemo(function() {
    return [at, ot];
  }, [at.join(""), ot]);
}
function useHoverValue(a, s) {
  var $ = s.formatList, _ = s.generateConfig, _e = s.locale, tt = reactExports.useState(null), nt = _slicedToArray$e(tt, 2), at = nt[0], ot = nt[1], rt = reactExports.useRef(null);
  function st(ht) {
    var dt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (cancelAnimationFrame(rt.current), dt) {
      ot(ht);
      return;
    }
    rt.current = requestAnimationFrame(function() {
      ot(ht);
    });
  }
  var lt = useValueTexts(at, {
    formatList: $,
    generateConfig: _,
    locale: _e
  }), et = _slicedToArray$e(lt, 2), it = et[1];
  function ut(ht) {
    st(ht);
  }
  function ft() {
    var ht = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    st(null, ht);
  }
  return reactExports.useEffect(function() {
    ft(!0);
  }, [a]), reactExports.useEffect(function() {
    return function() {
      return cancelAnimationFrame(rt.current);
    };
  }, []), [it, ut, ft];
}
var scrollIds = /* @__PURE__ */ new Map();
function waitElementReady(a, s) {
  var $;
  function _() {
    isVisible(a) ? s() : $ = wrapperRaf(function() {
      _();
    });
  }
  return _(), function() {
    wrapperRaf.cancel($);
  };
}
function scrollTo(a, s, $) {
  if (scrollIds.get(a) && cancelAnimationFrame(scrollIds.get(a)), $ <= 0) {
    scrollIds.set(a, requestAnimationFrame(function() {
      a.scrollTop = s;
    }));
    return;
  }
  var _ = s - a.scrollTop, _e = _ / $ * 10;
  scrollIds.set(a, requestAnimationFrame(function() {
    a.scrollTop += _e, a.scrollTop !== s && scrollTo(a, s, $ - 10);
  }));
}
function createKeyDownHandler(a, s) {
  var $ = s.onLeftRight, _ = s.onCtrlLeftRight, _e = s.onUpDown, tt = s.onPageUpDown, nt = s.onEnter, at = a.which, ot = a.ctrlKey, rt = a.metaKey;
  switch (at) {
    case KeyCode.LEFT:
      if (ot || rt) {
        if (_)
          return _(-1), !0;
      } else if ($)
        return $(-1), !0;
      break;
    case KeyCode.RIGHT:
      if (ot || rt) {
        if (_)
          return _(1), !0;
      } else if ($)
        return $(1), !0;
      break;
    case KeyCode.UP:
      if (_e)
        return _e(-1), !0;
      break;
    case KeyCode.DOWN:
      if (_e)
        return _e(1), !0;
      break;
    case KeyCode.PAGE_UP:
      if (tt)
        return tt(-1), !0;
      break;
    case KeyCode.PAGE_DOWN:
      if (tt)
        return tt(1), !0;
      break;
    case KeyCode.ENTER:
      if (nt)
        return nt(), !0;
      break;
  }
  return !1;
}
function getDefaultFormat(a, s, $, _) {
  var _e = a;
  if (!_e)
    switch (s) {
      case "time":
        _e = _ ? "hh:mm:ss a" : "HH:mm:ss";
        break;
      case "week":
        _e = "gggg-wo";
        break;
      case "month":
        _e = "YYYY-MM";
        break;
      case "quarter":
        _e = "YYYY-[Q]Q";
        break;
      case "year":
        _e = "YYYY";
        break;
      default:
        _e = $ ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
    }
  return _e;
}
function getInputSize(a, s, $) {
  var _ = a === "time" ? 8 : 10, _e = typeof s == "function" ? s($.getNow()).length : s.length;
  return Math.max(_, _e) + 2;
}
var globalClickFunc = null, clickCallbacks = /* @__PURE__ */ new Set();
function addGlobalMouseDownEvent(a) {
  return !globalClickFunc && typeof window < "u" && window.addEventListener && (globalClickFunc = function($) {
    _toConsumableArray$d(clickCallbacks).forEach(function(_) {
      _($);
    });
  }, window.addEventListener("mousedown", globalClickFunc)), clickCallbacks.add(a), function() {
    clickCallbacks.delete(a), clickCallbacks.size === 0 && (window.removeEventListener("mousedown", globalClickFunc), globalClickFunc = null);
  };
}
function getTargetFromEvent(a) {
  var s = a.target;
  if (a.composed && s.shadowRoot) {
    var $;
    return (($ = a.composedPath) === null || $ === void 0 ? void 0 : $.call(a)[0]) || s;
  }
  return s;
}
var getYearNextMode = function a(s) {
  return s === "month" || s === "date" ? "year" : s;
}, getMonthNextMode = function a(s) {
  return s === "date" ? "month" : s;
}, getQuarterNextMode = function a(s) {
  return s === "month" || s === "date" ? "quarter" : s;
}, getWeekNextMode = function a(s) {
  return s === "date" ? "week" : s;
}, PickerModeMap = {
  year: getYearNextMode,
  month: getMonthNextMode,
  quarter: getQuarterNextMode,
  week: getWeekNextMode,
  time: null,
  date: null
};
function elementsContains(a, s) {
  return a.some(function($) {
    return $ && $.contains(s);
  });
}
function usePickerInput(a) {
  var s = a.open, $ = a.value, _ = a.isClickOutside, _e = a.triggerOpen, tt = a.forwardKeyDown, nt = a.onKeyDown, at = a.blurToCancel, ot = a.changeOnBlur, rt = a.onSubmit, st = a.onCancel, lt = a.onFocus, et = a.onBlur, it = reactExports.useState(!1), ut = _slicedToArray$e(it, 2), ft = ut[0], ht = ut[1], dt = reactExports.useState(!1), gt = _slicedToArray$e(dt, 2), pt = gt[0], mt = gt[1], ct = reactExports.useRef(!1), vt = reactExports.useRef(!1), At = reactExports.useRef(!1), xt = {
    onMouseDown: function() {
      ht(!0), _e(!0);
    },
    onKeyDown: function(Et) {
      var St = function() {
        At.current = !0;
      };
      if (nt(Et, St), !At.current) {
        switch (Et.which) {
          case KeyCode.ENTER: {
            s ? rt() !== !1 && ht(!0) : _e(!0), Et.preventDefault();
            return;
          }
          case KeyCode.TAB: {
            ft && s && !Et.shiftKey ? (ht(!1), Et.preventDefault()) : !ft && s && !tt(Et) && Et.shiftKey && (ht(!0), Et.preventDefault());
            return;
          }
          case KeyCode.ESC: {
            ht(!0), st();
            return;
          }
        }
        !s && ![KeyCode.SHIFT].includes(Et.which) ? _e(!0) : ft || tt(Et);
      }
    },
    onFocus: function(Et) {
      ht(!0), mt(!0), lt && lt(Et);
    },
    onBlur: function(Et) {
      if (ct.current || !_(document.activeElement)) {
        ct.current = !1;
        return;
      }
      at ? setTimeout(function() {
        for (var St = document, Bt = St.activeElement; Bt && Bt.shadowRoot; )
          Bt = Bt.shadowRoot.activeElement;
        _(Bt) && st();
      }, 0) : s && (_e(!1), vt.current && rt()), mt(!1), et == null || et(Et);
    }
  };
  return reactExports.useEffect(function() {
    vt.current = !1;
  }, [s]), reactExports.useEffect(function() {
    vt.current = !0;
  }, [$]), reactExports.useEffect(function() {
    return addGlobalMouseDownEvent(function(bt) {
      var Et = getTargetFromEvent(bt), St = _(Et);
      s && (St ? !ot && !at && (!pt || St) && _e(!1) : (ct.current = !0, wrapperRaf(function() {
        ct.current = !1;
      })));
    });
  }), [xt, {
    focused: pt,
    typing: ft
  }];
}
function usePresets(a, s) {
  return reactExports.useMemo(function() {
    return a || (s ? (warningOnce(!1, "`ranges` is deprecated. Please use `presets` instead."), Object.entries(s).map(function($) {
      var _ = _slicedToArray$e($, 2), _e = _[0], tt = _[1];
      return {
        label: _e,
        value: tt
      };
    })) : []);
  }, [a, s]);
}
function useTextValueMapping(a) {
  var s = a.valueTexts, $ = a.onTextChange, _ = reactExports.useState(""), _e = _slicedToArray$e(_, 2), tt = _e[0], nt = _e[1], at = reactExports.useRef([]);
  at.current = s;
  function ot(st) {
    nt(st), $(st);
  }
  function rt() {
    nt(at.current[0]);
  }
  return useLayoutEffect$1(function() {
    s.every(function(st) {
      return st !== tt;
    }) && rt();
  }, [s.join("||")]), [tt, ot, rt];
}
var PanelContext = /* @__PURE__ */ reactExports.createContext({});
function useCellRender$1(a) {
  var s = a.cellRender, $ = a.monthCellRender, _ = a.dateRender, _e = React$a.useMemo(function() {
    if (s)
      return s;
    if (!(!$ && !_))
      return function(tt, nt) {
        var at = tt;
        return _ && nt.type === "date" ? _(at, nt.today) : $ && nt.type === "month" ? $(at, nt.locale) : nt.originNode;
      };
  }, [s, $, _]);
  return _e;
}
function leftPad(a, s) {
  for (var $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0", _ = String(a); _.length < s; )
    _ = "".concat($).concat(a);
  return _;
}
var tuple = function a() {
  for (var s = arguments.length, $ = new Array(s), _ = 0; _ < s; _++)
    $[_] = arguments[_];
  return $;
};
function toArray$5(a) {
  return a == null ? [] : Array.isArray(a) ? a : [a];
}
function getValue$2(a, s) {
  return a ? a[s] : null;
}
function updateValues(a, s, $) {
  var _ = [getValue$2(a, 0), getValue$2(a, 1)];
  return _[$] = typeof s == "function" ? s(_[$]) : s, !_[0] && !_[1] ? null : _;
}
function executeValue(a) {
  return typeof a == "function" ? a() : a;
}
function useCellClassName(a) {
  var s = a.cellPrefixCls, $ = a.generateConfig, _ = a.rangedValue, _e = a.hoverRangedValue, tt = a.isInView, nt = a.isSameCell, at = a.offsetCell, ot = a.today, rt = a.value;
  function st(lt) {
    var et, it = at(lt, -1), ut = at(lt, 1), ft = getValue$2(_, 0), ht = getValue$2(_, 1), dt = getValue$2(_e, 0), gt = getValue$2(_e, 1), pt = isInRange($, dt, gt, lt);
    function mt(Et) {
      return nt(ft, Et);
    }
    function ct(Et) {
      return nt(ht, Et);
    }
    var vt = nt(dt, lt), At = nt(gt, lt), xt = (pt || At) && (!tt(it) || ct(it)), bt = (pt || vt) && (!tt(ut) || mt(ut));
    return et = {}, _defineProperty$c(et, "".concat(s, "-in-view"), tt(lt)), _defineProperty$c(et, "".concat(s, "-in-range"), isInRange($, ft, ht, lt)), _defineProperty$c(et, "".concat(s, "-range-start"), mt(lt)), _defineProperty$c(et, "".concat(s, "-range-end"), ct(lt)), _defineProperty$c(et, "".concat(s, "-range-start-single"), mt(lt) && !ht), _defineProperty$c(et, "".concat(s, "-range-end-single"), ct(lt) && !ft), _defineProperty$c(et, "".concat(s, "-range-start-near-hover"), mt(lt) && (nt(it, dt) || isInRange($, dt, gt, it))), _defineProperty$c(et, "".concat(s, "-range-end-near-hover"), ct(lt) && (nt(ut, gt) || isInRange($, dt, gt, ut))), _defineProperty$c(et, "".concat(s, "-range-hover"), pt), _defineProperty$c(et, "".concat(s, "-range-hover-start"), vt), _defineProperty$c(et, "".concat(s, "-range-hover-end"), At), _defineProperty$c(et, "".concat(s, "-range-hover-edge-start"), xt), _defineProperty$c(et, "".concat(s, "-range-hover-edge-end"), bt), _defineProperty$c(et, "".concat(s, "-range-hover-edge-start-near-range"), xt && nt(it, ht)), _defineProperty$c(et, "".concat(s, "-range-hover-edge-end-near-range"), bt && nt(ut, ft)), _defineProperty$c(et, "".concat(s, "-today"), nt(ot, lt)), _defineProperty$c(et, "".concat(s, "-selected"), nt(rt, lt)), et;
  }
  return st;
}
var RangeContext = /* @__PURE__ */ reactExports.createContext({});
function setTime(a, s, $, _, _e) {
  var tt = a.setHour(s, $);
  return tt = a.setMinute(tt, _), tt = a.setSecond(tt, _e), tt;
}
function setDateTime(a, s, $) {
  if (!$)
    return s;
  var _ = s;
  return _ = a.setHour(_, a.getHour($)), _ = a.setMinute(_, a.getMinute($)), _ = a.setSecond(_, a.getSecond($)), _;
}
function getLowerBoundTime(a, s, $, _, _e, tt) {
  var nt = Math.floor(a / _) * _;
  if (nt < a)
    return [nt, 60 - _e, 60 - tt];
  var at = Math.floor(s / _e) * _e;
  if (at < s)
    return [nt, at, 60 - tt];
  var ot = Math.floor($ / tt) * tt;
  return [nt, at, ot];
}
function getLastDay(a, s) {
  var $ = a.getYear(s), _ = a.getMonth(s) + 1, _e = a.getEndDate(a.getFixedDate("".concat($, "-").concat(_, "-01"))), tt = a.getDate(_e), nt = _ < 10 ? "0".concat(_) : "".concat(_);
  return "".concat($, "-").concat(nt, "-").concat(tt);
}
function PanelBody(a) {
  for (var s = a.prefixCls, $ = a.disabledDate, _ = a.onSelect, _e = a.picker, tt = a.rowNum, nt = a.colNum, at = a.prefixColumn, ot = a.rowClassName, rt = a.baseDate, st = a.getCellClassName, lt = a.getCellText, et = a.getCellNode, it = a.getCellDate, ut = a.generateConfig, ft = a.titleCell, ht = a.headerCells, dt = reactExports.useContext(PanelContext), gt = dt.onDateMouseEnter, pt = dt.onDateMouseLeave, mt = dt.mode, ct = "".concat(s, "-cell"), vt = [], At = 0; At < tt; At += 1) {
    for (var xt = [], bt = void 0, Et = function() {
      var Ot, Pt = At * nt + St, wt = it(rt, Pt), Ct = getCellDateDisabled({
        cellDate: wt,
        mode: mt,
        disabledDate: $,
        generateConfig: ut
      });
      St === 0 && (bt = wt, at && xt.push(at(bt)));
      var It = ft && ft(wt), yt = /* @__PURE__ */ reactExports.createElement("div", {
        className: "".concat(ct, "-inner")
      }, lt(wt));
      xt.push(/* @__PURE__ */ reactExports.createElement("td", {
        key: St,
        title: It,
        className: classnames(ct, _objectSpread2$a((Ot = {}, _defineProperty$c(Ot, "".concat(ct, "-disabled"), Ct), _defineProperty$c(Ot, "".concat(ct, "-start"), lt(wt) === 1 || _e === "year" && Number(It) % 10 === 0), _defineProperty$c(Ot, "".concat(ct, "-end"), It === getLastDay(ut, wt) || _e === "year" && Number(It) % 10 === 9), Ot), st(wt))),
        onClick: function() {
          Ct || _(wt);
        },
        onMouseEnter: function() {
          !Ct && gt && gt(wt);
        },
        onMouseLeave: function() {
          !Ct && pt && pt(wt);
        }
      }, et ? et(wt, yt) : yt));
    }, St = 0; St < nt; St += 1)
      Et();
    vt.push(/* @__PURE__ */ reactExports.createElement("tr", {
      key: At,
      className: ot && ot(bt)
    }, xt));
  }
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(s, "-body")
  }, /* @__PURE__ */ reactExports.createElement("table", {
    className: "".concat(s, "-content")
  }, ht && /* @__PURE__ */ reactExports.createElement("thead", null, /* @__PURE__ */ reactExports.createElement("tr", null, ht)), /* @__PURE__ */ reactExports.createElement("tbody", null, vt)));
}
function DateBody(a) {
  var s = a.prefixCls, $ = a.generateConfig, _ = a.prefixColumn, _e = a.locale, tt = a.rowCount, nt = a.viewDate, at = a.value, ot = a.cellRender, rt = a.isSameCell, st = reactExports.useContext(RangeContext), lt = st.rangedValue, et = st.hoverRangedValue, it = getWeekStartDate(_e.locale, $, nt), ut = "".concat(s, "-cell"), ft = $.locale.getWeekFirstDay(_e.locale), ht = $.getNow(), dt = [], gt = _e.shortWeekDays || ($.locale.getShortWeekDays ? $.locale.getShortWeekDays(_e.locale) : []);
  _ && dt.push(/* @__PURE__ */ reactExports.createElement("th", {
    key: "empty",
    "aria-label": "empty cell"
  }));
  for (var pt = 0; pt < WEEK_DAY_COUNT; pt += 1)
    dt.push(/* @__PURE__ */ reactExports.createElement("th", {
      key: pt
    }, gt[(pt + ft) % WEEK_DAY_COUNT]));
  var mt = useCellClassName({
    cellPrefixCls: ut,
    today: ht,
    value: at,
    generateConfig: $,
    rangedValue: _ ? null : lt,
    hoverRangedValue: _ ? null : et,
    isSameCell: rt || function(vt, At) {
      return isSameDate($, vt, At);
    },
    isInView: function(At) {
      return isSameMonth($, At, nt);
    },
    offsetCell: function(At, xt) {
      return $.addDate(At, xt);
    }
  }), ct = ot ? function(vt, At) {
    return ot(vt, {
      originNode: At,
      today: ht,
      type: "date",
      locale: _e
    });
  } : void 0;
  return /* @__PURE__ */ reactExports.createElement(PanelBody, _extends$2({}, a, {
    rowNum: tt,
    colNum: WEEK_DAY_COUNT,
    baseDate: it,
    getCellNode: ct,
    getCellText: $.getDate,
    getCellClassName: mt,
    getCellDate: $.addDate,
    titleCell: function(At) {
      return formatValue(At, {
        locale: _e,
        format: "YYYY-MM-DD",
        generateConfig: $
      });
    },
    headerCells: dt
  }));
}
var HIDDEN_STYLE$2 = {
  visibility: "hidden"
};
function Header$2(a) {
  var s = a.prefixCls, $ = a.prevIcon, _ = $ === void 0 ? "‹" : $, _e = a.nextIcon, tt = _e === void 0 ? "›" : _e, nt = a.superPrevIcon, at = nt === void 0 ? "«" : nt, ot = a.superNextIcon, rt = ot === void 0 ? "»" : ot, st = a.onSuperPrev, lt = a.onSuperNext, et = a.onPrev, it = a.onNext, ut = a.children, ft = reactExports.useContext(PanelContext), ht = ft.hideNextBtn, dt = ft.hidePrevBtn;
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: s
  }, st && /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    onClick: st,
    tabIndex: -1,
    className: "".concat(s, "-super-prev-btn"),
    style: dt ? HIDDEN_STYLE$2 : {}
  }, at), et && /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    onClick: et,
    tabIndex: -1,
    className: "".concat(s, "-prev-btn"),
    style: dt ? HIDDEN_STYLE$2 : {}
  }, _), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(s, "-view")
  }, ut), it && /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    onClick: it,
    tabIndex: -1,
    className: "".concat(s, "-next-btn"),
    style: ht ? HIDDEN_STYLE$2 : {}
  }, tt), lt && /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    onClick: lt,
    tabIndex: -1,
    className: "".concat(s, "-super-next-btn"),
    style: ht ? HIDDEN_STYLE$2 : {}
  }, rt));
}
function DateHeader(a) {
  var s = a.prefixCls, $ = a.generateConfig, _ = a.locale, _e = a.viewDate, tt = a.onNextMonth, nt = a.onPrevMonth, at = a.onNextYear, ot = a.onPrevYear, rt = a.onYearClick, st = a.onMonthClick, lt = reactExports.useContext(PanelContext), et = lt.hideHeader;
  if (et)
    return null;
  var it = "".concat(s, "-header"), ut = _.shortMonths || ($.locale.getShortMonths ? $.locale.getShortMonths(_.locale) : []), ft = $.getMonth(_e), ht = /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    key: "year",
    onClick: rt,
    tabIndex: -1,
    className: "".concat(s, "-year-btn")
  }, formatValue(_e, {
    locale: _,
    format: _.yearFormat,
    generateConfig: $
  })), dt = /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    key: "month",
    onClick: st,
    tabIndex: -1,
    className: "".concat(s, "-month-btn")
  }, _.monthFormat ? formatValue(_e, {
    locale: _,
    format: _.monthFormat,
    generateConfig: $
  }) : ut[ft]), gt = _.monthBeforeYear ? [dt, ht] : [ht, dt];
  return /* @__PURE__ */ reactExports.createElement(Header$2, _extends$2({}, a, {
    prefixCls: it,
    onSuperPrev: ot,
    onPrev: nt,
    onNext: tt,
    onSuperNext: at
  }), gt);
}
var DATE_ROW_COUNT = 6;
function DatePanel(a) {
  var s = a.prefixCls, $ = a.panelName, _ = $ === void 0 ? "date" : $, _e = a.keyboardConfig, tt = a.active, nt = a.operationRef, at = a.generateConfig, ot = a.value, rt = a.viewDate, st = a.onViewDateChange, lt = a.onPanelChange, et = a.onSelect, it = "".concat(s, "-").concat(_, "-panel");
  nt.current = {
    onKeyDown: function(dt) {
      return createKeyDownHandler(dt, _objectSpread2$a({
        onLeftRight: function(pt) {
          et(at.addDate(ot || rt, pt), "key");
        },
        onCtrlLeftRight: function(pt) {
          et(at.addYear(ot || rt, pt), "key");
        },
        onUpDown: function(pt) {
          et(at.addDate(ot || rt, pt * WEEK_DAY_COUNT), "key");
        },
        onPageUpDown: function(pt) {
          et(at.addMonth(ot || rt, pt), "key");
        }
      }, _e));
    }
  };
  var ut = function(dt) {
    var gt = at.addYear(rt, dt);
    st(gt), lt(null, gt);
  }, ft = function(dt) {
    var gt = at.addMonth(rt, dt);
    st(gt), lt(null, gt);
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(it, _defineProperty$c({}, "".concat(it, "-active"), tt))
  }, /* @__PURE__ */ reactExports.createElement(DateHeader, _extends$2({}, a, {
    prefixCls: s,
    value: ot,
    viewDate: rt,
    onPrevYear: function() {
      ut(-1);
    },
    onNextYear: function() {
      ut(1);
    },
    onPrevMonth: function() {
      ft(-1);
    },
    onNextMonth: function() {
      ft(1);
    },
    onMonthClick: function() {
      lt("month", rt);
    },
    onYearClick: function() {
      lt("year", rt);
    }
  })), /* @__PURE__ */ reactExports.createElement(DateBody, _extends$2({}, a, {
    onSelect: function(dt) {
      return et(dt, "mouse");
    },
    prefixCls: s,
    value: ot,
    viewDate: rt,
    rowCount: DATE_ROW_COUNT
  })));
}
function useTimeSelection(a) {
  var s = a.value, $ = a.generateConfig, _ = a.disabledMinutes, _e = a.disabledSeconds, tt = a.minutes, nt = a.seconds, at = a.use12Hours, ot = function(st, lt, et, it) {
    var ut = $.getNow(), ft = s || ut, ht = !at || !st ? lt : lt + 12, dt = lt < 0 ? $.getHour(ut) : ht, gt = et < 0 ? $.getMinute(ut) : et, pt = it < 0 ? $.getSecond(ut) : it, mt = _ && _(dt);
    if (mt != null && mt.includes(gt)) {
      var ct = tt.find(function(xt) {
        return !mt.includes(xt.value);
      });
      if (ct)
        gt = ct.value;
      else
        return null;
    }
    var vt = _e && _e(dt, gt);
    if (vt != null && vt.includes(pt)) {
      var At = nt.find(function(xt) {
        return !vt.includes(xt.value);
      });
      if (At)
        pt = At.value;
      else
        return null;
    }
    return ft = setTime($, ft, dt, gt, pt), ft;
  };
  return ot;
}
function TimeUnitColumn(a) {
  var s = a.prefixCls, $ = a.units, _ = a.onSelect, _e = a.value, tt = a.active, nt = a.hideDisabledOptions, at = a.info, ot = a.type, rt = "".concat(s, "-cell"), st = reactExports.useContext(PanelContext), lt = st.open, et = reactExports.useRef(null), it = reactExports.useRef(/* @__PURE__ */ new Map()), ut = reactExports.useRef();
  return reactExports.useLayoutEffect(function() {
    var ft = it.current.get(_e);
    ft && lt !== !1 && scrollTo(et.current, ft.offsetTop, 120);
  }, [_e]), reactExports.useLayoutEffect(function() {
    if (lt) {
      var ft = it.current.get(_e);
      ft && (ut.current = waitElementReady(ft, function() {
        scrollTo(et.current, ft.offsetTop, 0);
      }));
    }
    return function() {
      var ht;
      (ht = ut.current) === null || ht === void 0 || ht.call(ut);
    };
  }, [lt]), /* @__PURE__ */ reactExports.createElement("ul", {
    className: classnames("".concat(s, "-column"), _defineProperty$c({}, "".concat(s, "-column-active"), tt)),
    ref: et,
    style: {
      position: "relative"
    }
  }, $.map(function(ft) {
    var ht;
    return nt && ft.disabled ? null : /* @__PURE__ */ reactExports.createElement("li", {
      key: ft.value,
      ref: function(gt) {
        it.current.set(ft.value, gt);
      },
      className: classnames(rt, (ht = {}, _defineProperty$c(ht, "".concat(rt, "-disabled"), ft.disabled), _defineProperty$c(ht, "".concat(rt, "-selected"), _e === ft.value), ht)),
      onClick: function() {
        ft.disabled || _(ft.value);
      }
    }, at.cellRender ? at.cellRender(ft.value, {
      today: at.today,
      locale: at.locale,
      originNode: /* @__PURE__ */ reactExports.createElement("div", {
        className: "".concat(rt, "-inner")
      }, ft.label),
      type: "time",
      subType: ot
    }) : /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(rt, "-inner")
    }, ft.label));
  }));
}
function shouldUnitsUpdate(a, s) {
  if (a.length !== s.length)
    return !0;
  for (var $ = 0; $ < a.length; $ += 1)
    if (a[$].disabled !== s[$].disabled)
      return !0;
  return !1;
}
function generateUnits(a, s, $, _) {
  for (var _e = [], tt = $ >= 1 ? $ | 0 : 1, nt = a; nt <= s; nt += tt)
    _e.push({
      label: leftPad(nt, 2),
      value: nt,
      disabled: (_ || []).includes(nt)
    });
  return _e;
}
function TimeBody(a) {
  var s = a.generateConfig, $ = a.prefixCls, _ = a.operationRef, _e = a.activeColumnIndex, tt = a.value, nt = a.showHour, at = a.showMinute, ot = a.showSecond, rt = a.use12Hours, st = a.hourStep, lt = st === void 0 ? 1 : st, et = a.minuteStep, it = et === void 0 ? 1 : et, ut = a.secondStep, ft = ut === void 0 ? 1 : ut, ht = a.disabledHours, dt = a.disabledMinutes, gt = a.disabledSeconds, pt = a.disabledTime, mt = a.hideDisabledOptions, ct = a.onSelect, vt = a.cellRender, At = a.locale, xt = [], bt = "".concat($, "-content"), Et = "".concat($, "-time-panel"), St, Bt = tt ? s.getHour(tt) : -1, Ot = Bt, Pt = tt ? s.getMinute(tt) : -1, wt = tt ? s.getSecond(tt) : -1, Ct = s.getNow(), It = reactExports.useMemo(function() {
    if (pt) {
      var qt = pt(Ct);
      return [qt.disabledHours, qt.disabledMinutes, qt.disabledSeconds];
    }
    return [ht, dt, gt];
  }, [ht, dt, gt, pt, Ct]), yt = _slicedToArray$e(It, 3), Rt = yt[0], kt = yt[1], jt = yt[2], Ht = generateUnits(0, 23, lt, Rt && Rt()), Ft = useMemo(function() {
    return Ht;
  }, Ht, shouldUnitsUpdate);
  rt && (St = Ot >= 12, Ot %= 12);
  var _t = reactExports.useMemo(function() {
    if (!rt)
      return [!1, !1];
    var qt = [!0, !0];
    return Ft.forEach(function(Zt) {
      var ar = Zt.disabled, Jt = Zt.value;
      ar || (Jt >= 12 ? qt[1] = !1 : qt[0] = !1);
    }), qt;
  }, [rt, Ft]), Nt = _slicedToArray$e(_t, 2), Mt = Nt[0], Lt = Nt[1], $t = reactExports.useMemo(function() {
    return rt ? Ft.filter(St ? function(qt) {
      return qt.value >= 12;
    } : function(qt) {
      return qt.value < 12;
    }).map(function(qt) {
      var Zt = qt.value % 12, ar = Zt === 0 ? "12" : leftPad(Zt, 2);
      return _objectSpread2$a(_objectSpread2$a({}, qt), {}, {
        label: ar,
        value: Zt
      });
    }) : Ft;
  }, [rt, St, Ft]), Tt = generateUnits(0, 59, it, kt && kt(Bt)), Dt = generateUnits(0, 59, ft, jt && jt(Bt, Pt)), Ut = useTimeSelection({
    value: tt,
    generateConfig: s,
    disabledMinutes: kt,
    disabledSeconds: jt,
    minutes: Tt,
    seconds: Dt,
    use12Hours: rt
  });
  _.current = {
    onUpDown: function(Zt) {
      var ar = xt[_e];
      if (ar)
        for (var Jt = ar.units.findIndex(function(nr) {
          return nr.value === ar.value;
        }), rr = ar.units.length, Yt = 1; Yt < rr; Yt += 1) {
          var Kt = ar.units[(Jt + Zt * Yt + rr) % rr];
          if (Kt.disabled !== !0) {
            ar.onSelect(Kt.value);
            break;
          }
        }
    }
  };
  function Vt(qt, Zt, ar, Jt, rr) {
    qt !== !1 && xt.push({
      node: /* @__PURE__ */ reactExports.cloneElement(Zt, {
        prefixCls: Et,
        value: ar,
        active: _e === xt.length,
        onSelect: rr,
        units: Jt,
        hideDisabledOptions: mt
      }),
      onSelect: rr,
      value: ar,
      units: Jt
    });
  }
  Vt(nt, /* @__PURE__ */ reactExports.createElement(TimeUnitColumn, {
    key: "hour",
    type: "hour",
    info: {
      today: Ct,
      locale: At,
      cellRender: vt
    }
  }), Ot, $t, function(qt) {
    ct(Ut(St, qt, Pt, wt), "mouse");
  }), Vt(at, /* @__PURE__ */ reactExports.createElement(TimeUnitColumn, {
    key: "minute",
    type: "minute",
    info: {
      today: Ct,
      locale: At,
      cellRender: vt
    }
  }), Pt, Tt, function(qt) {
    ct(Ut(St, Ot, qt, wt), "mouse");
  }), Vt(ot, /* @__PURE__ */ reactExports.createElement(TimeUnitColumn, {
    key: "second",
    type: "second",
    info: {
      today: Ct,
      locale: At,
      cellRender: vt
    }
  }), wt, Dt, function(qt) {
    ct(Ut(St, Ot, Pt, qt), "mouse");
  });
  var Qt = -1;
  return typeof St == "boolean" && (Qt = St ? 1 : 0), Vt(rt === !0, /* @__PURE__ */ reactExports.createElement(TimeUnitColumn, {
    key: "meridiem",
    type: "meridiem",
    info: {
      today: Ct,
      locale: At,
      cellRender: vt
    }
  }), Qt, [{
    label: "AM",
    value: 0,
    disabled: Mt
  }, {
    label: "PM",
    value: 1,
    disabled: Lt
  }], function(qt) {
    ct(Ut(!!qt, Ot, Pt, wt), "mouse");
  }), /* @__PURE__ */ reactExports.createElement("div", {
    className: bt
  }, xt.map(function(qt) {
    var Zt = qt.node;
    return Zt;
  }));
}
function TimeHeader(a) {
  var s = reactExports.useContext(PanelContext), $ = s.hideHeader;
  if ($)
    return null;
  var _ = a.prefixCls, _e = a.generateConfig, tt = a.locale, nt = a.value, at = a.format, ot = "".concat(_, "-header");
  return /* @__PURE__ */ reactExports.createElement(Header$2, {
    prefixCls: ot
  }, nt ? formatValue(nt, {
    locale: tt,
    format: at,
    generateConfig: _e
  }) : " ");
}
var countBoolean = function a(s) {
  return s.filter(function($) {
    return $ !== !1;
  }).length;
};
function TimePanel(a) {
  var s = a.generateConfig, $ = a.format, _ = $ === void 0 ? "HH:mm:ss" : $, _e = a.prefixCls, tt = a.active, nt = a.operationRef, at = a.showHour, ot = a.showMinute, rt = a.showSecond, st = a.use12Hours, lt = st === void 0 ? !1 : st, et = a.onSelect, it = a.value, ut = "".concat(_e, "-time-panel"), ft = reactExports.useRef(), ht = reactExports.useState(-1), dt = _slicedToArray$e(ht, 2), gt = dt[0], pt = dt[1], mt = countBoolean([at, ot, rt, lt]);
  return nt.current = {
    onKeyDown: function(vt) {
      return createKeyDownHandler(vt, {
        onLeftRight: function(xt) {
          pt((gt + xt + mt) % mt);
        },
        onUpDown: function(xt) {
          gt === -1 ? pt(0) : ft.current && ft.current.onUpDown(xt);
        },
        onEnter: function() {
          et(it || s.getNow(), "key"), pt(-1);
        }
      });
    },
    onBlur: function() {
      pt(-1);
    }
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(ut, _defineProperty$c({}, "".concat(ut, "-active"), tt))
  }, /* @__PURE__ */ reactExports.createElement(TimeHeader, _extends$2({}, a, {
    format: _,
    prefixCls: _e
  })), /* @__PURE__ */ reactExports.createElement(TimeBody, _extends$2({}, a, {
    prefixCls: _e,
    activeColumnIndex: gt,
    operationRef: ft
  })));
}
var ACTIVE_PANEL = tuple("date", "time"), findValidTime = function a(s, $, _) {
  var _e = new Set($);
  if (_e.has(s)) {
    for (var tt = 0; tt <= _; tt++)
      if (!_e.has(tt) && tt >= s)
        return tt;
  }
  return s;
};
function DatetimePanel(a) {
  var s = a.prefixCls, $ = a.operationRef, _ = a.generateConfig, _e = a.value, tt = a.defaultValue, nt = a.disabledTime, at = a.showTime, ot = a.onSelect, rt = a.cellRender, st = "".concat(s, "-datetime-panel"), lt = reactExports.useState(null), et = _slicedToArray$e(lt, 2), it = et[0], ut = et[1], ft = reactExports.useRef({}), ht = reactExports.useRef({}), dt = _typeof$q(at) === "object" ? _objectSpread2$a({}, at) : {};
  function gt(vt) {
    var At = ACTIVE_PANEL.indexOf(it) + vt, xt = ACTIVE_PANEL[At] || null;
    return xt;
  }
  var pt = function(At) {
    ht.current.onBlur && ht.current.onBlur(At), ut(null);
  };
  $.current = {
    onKeyDown: function(At) {
      if (At.which === KeyCode.TAB) {
        var xt = gt(At.shiftKey ? -1 : 1);
        return ut(xt), xt && At.preventDefault(), !0;
      }
      if (it) {
        var bt = it === "date" ? ft : ht;
        return bt.current && bt.current.onKeyDown && bt.current.onKeyDown(At), !0;
      }
      return [KeyCode.LEFT, KeyCode.RIGHT, KeyCode.UP, KeyCode.DOWN].includes(At.which) ? (ut("date"), !0) : !1;
    },
    onBlur: pt,
    onClose: pt
  };
  var mt = function(At, xt) {
    var bt = At;
    if (xt === "date") {
      var Et, St, Bt, Ot = (nt == null ? void 0 : nt(_e || dt.defaultValue)) || {}, Pt = findValidTime(_.getHour(bt), ((Et = Ot.disabledHours) === null || Et === void 0 ? void 0 : Et.call(Ot)) || [-1], 23), wt = findValidTime(_.getMinute(bt), ((St = Ot.disabledMinutes) === null || St === void 0 ? void 0 : St.call(Ot, Pt)) || [-1], 59), Ct = findValidTime(_.getSecond(bt), ((Bt = Ot.disabledSeconds) === null || Bt === void 0 ? void 0 : Bt.call(Ot, Pt, wt)) || [-1], 59);
      bt = _.setHour(bt, Pt), bt = _.setMinute(bt, wt), bt = _.setSecond(bt, Ct);
    } else
      xt === "time" && !_e && tt && (bt = _.setYear(bt, _.getYear(tt)), bt = _.setMonth(bt, _.getMonth(tt)), bt = _.setDate(bt, _.getDate(tt)));
    ot && ot(bt, "mouse");
  }, ct = nt ? nt(_e || null) : {};
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(st, _defineProperty$c({}, "".concat(st, "-active"), it))
  }, /* @__PURE__ */ reactExports.createElement(DatePanel, _extends$2({}, a, {
    cellRender: rt,
    operationRef: ft,
    active: it === "date",
    onSelect: function(At) {
      mt(setDateTime(_, At, !_e && _typeof$q(at) === "object" ? at.defaultValue : null), "date");
    }
  })), /* @__PURE__ */ reactExports.createElement(TimePanel, _extends$2({}, a, {
    cellRender: rt ? function(vt, At) {
      return rt(vt, _objectSpread2$a(_objectSpread2$a({}, At), {}, {
        type: "time"
      }));
    } : void 0,
    format: void 0
  }, dt, ct, {
    disabledTime: null,
    defaultValue: void 0,
    operationRef: ht,
    active: it === "time",
    onSelect: function(At) {
      mt(At, "time");
    }
  })));
}
function DecadeHeader(a) {
  var s = a.prefixCls, $ = a.generateConfig, _ = a.viewDate, _e = a.onPrevDecades, tt = a.onNextDecades, nt = reactExports.useContext(PanelContext), at = nt.hideHeader;
  if (at)
    return null;
  var ot = "".concat(s, "-header"), rt = $.getYear(_), st = Math.floor(rt / DECADE_DISTANCE_COUNT) * DECADE_DISTANCE_COUNT, lt = st + DECADE_DISTANCE_COUNT - 1;
  return /* @__PURE__ */ reactExports.createElement(Header$2, _extends$2({}, a, {
    prefixCls: ot,
    onSuperPrev: _e,
    onSuperNext: tt
  }), st, "-", lt);
}
var DECADE_COL_COUNT = 3, DECADE_ROW_COUNT = 4;
function DecadeBody(a) {
  var s = DECADE_UNIT_DIFF - 1, $ = a.prefixCls, _ = a.viewDate, _e = a.generateConfig, tt = a.cellRender, nt = a.locale, at = "".concat($, "-cell"), ot = _e.getYear(_), rt = Math.floor(ot / DECADE_UNIT_DIFF) * DECADE_UNIT_DIFF, st = Math.floor(ot / DECADE_DISTANCE_COUNT) * DECADE_DISTANCE_COUNT, lt = st + DECADE_DISTANCE_COUNT - 1, et = _e.setYear(_, st - Math.ceil((DECADE_COL_COUNT * DECADE_ROW_COUNT * DECADE_UNIT_DIFF - DECADE_DISTANCE_COUNT) / 2)), it = function(ht) {
    var dt, gt = _e.getYear(ht), pt = gt + s;
    return dt = {}, _defineProperty$c(dt, "".concat(at, "-in-view"), st <= gt && pt <= lt), _defineProperty$c(dt, "".concat(at, "-selected"), gt === rt), dt;
  }, ut = tt ? function(ft, ht) {
    return tt(ft, {
      originNode: ht,
      today: _e.getNow(),
      type: "decade",
      locale: nt
    });
  } : void 0;
  return /* @__PURE__ */ reactExports.createElement(PanelBody, _extends$2({}, a, {
    rowNum: DECADE_ROW_COUNT,
    colNum: DECADE_COL_COUNT,
    baseDate: et,
    getCellNode: ut,
    getCellText: function(ht) {
      var dt = _e.getYear(ht);
      return "".concat(dt, "-").concat(dt + s);
    },
    getCellClassName: it,
    getCellDate: function(ht, dt) {
      return _e.addYear(ht, dt * DECADE_UNIT_DIFF);
    }
  }));
}
function DecadePanel(a) {
  var s = a.prefixCls, $ = a.onViewDateChange, _ = a.generateConfig, _e = a.viewDate, tt = a.operationRef, nt = a.onSelect, at = a.onPanelChange, ot = "".concat(s, "-decade-panel");
  tt.current = {
    onKeyDown: function(et) {
      return createKeyDownHandler(et, {
        onLeftRight: function(ut) {
          nt(_.addYear(_e, ut * DECADE_UNIT_DIFF), "key");
        },
        onCtrlLeftRight: function(ut) {
          nt(_.addYear(_e, ut * DECADE_DISTANCE_COUNT), "key");
        },
        onUpDown: function(ut) {
          nt(_.addYear(_e, ut * DECADE_UNIT_DIFF * DECADE_COL_COUNT), "key");
        },
        onEnter: function() {
          at("year", _e);
        }
      });
    }
  };
  var rt = function(et) {
    var it = _.addYear(_e, et * DECADE_DISTANCE_COUNT);
    $(it), at(null, it);
  }, st = function(et) {
    nt(et, "mouse"), at("year", et);
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: ot
  }, /* @__PURE__ */ reactExports.createElement(DecadeHeader, _extends$2({}, a, {
    prefixCls: s,
    onPrevDecades: function() {
      rt(-1);
    },
    onNextDecades: function() {
      rt(1);
    }
  })), /* @__PURE__ */ reactExports.createElement(DecadeBody, _extends$2({}, a, {
    prefixCls: s,
    onSelect: st
  })));
}
function MonthHeader(a) {
  var s = a.prefixCls, $ = a.generateConfig, _ = a.locale, _e = a.viewDate, tt = a.onNextYear, nt = a.onPrevYear, at = a.onYearClick, ot = reactExports.useContext(PanelContext), rt = ot.hideHeader;
  if (rt)
    return null;
  var st = "".concat(s, "-header");
  return /* @__PURE__ */ reactExports.createElement(Header$2, _extends$2({}, a, {
    prefixCls: st,
    onSuperPrev: nt,
    onSuperNext: tt
  }), /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    onClick: at,
    className: "".concat(s, "-year-btn")
  }, formatValue(_e, {
    locale: _,
    format: _.yearFormat,
    generateConfig: $
  })));
}
var MONTH_COL_COUNT = 3, MONTH_ROW_COUNT = 4;
function MonthBody(a) {
  var s = a.prefixCls, $ = a.locale, _ = a.value, _e = a.viewDate, tt = a.generateConfig, nt = a.cellRender, at = reactExports.useContext(RangeContext), ot = at.rangedValue, rt = at.hoverRangedValue, st = "".concat(s, "-cell"), lt = useCellClassName({
    cellPrefixCls: st,
    value: _,
    generateConfig: tt,
    rangedValue: ot,
    hoverRangedValue: rt,
    isSameCell: function(ht, dt) {
      return isSameMonth(tt, ht, dt);
    },
    isInView: function() {
      return !0;
    },
    offsetCell: function(ht, dt) {
      return tt.addMonth(ht, dt);
    }
  }), et = $.shortMonths || (tt.locale.getShortMonths ? tt.locale.getShortMonths($.locale) : []), it = tt.setMonth(_e, 0), ut = nt ? function(ft, ht) {
    return nt(ft, {
      originNode: ht,
      locale: $,
      today: tt.getNow(),
      type: "month"
    });
  } : void 0;
  return /* @__PURE__ */ reactExports.createElement(PanelBody, _extends$2({}, a, {
    rowNum: MONTH_ROW_COUNT,
    colNum: MONTH_COL_COUNT,
    baseDate: it,
    getCellNode: ut,
    getCellText: function(ht) {
      return $.monthFormat ? formatValue(ht, {
        locale: $,
        format: $.monthFormat,
        generateConfig: tt
      }) : et[tt.getMonth(ht)];
    },
    getCellClassName: lt,
    getCellDate: tt.addMonth,
    titleCell: function(ht) {
      return formatValue(ht, {
        locale: $,
        format: "YYYY-MM",
        generateConfig: tt
      });
    }
  }));
}
function MonthPanel(a) {
  var s = a.prefixCls, $ = a.operationRef, _ = a.onViewDateChange, _e = a.generateConfig, tt = a.value, nt = a.viewDate, at = a.onPanelChange, ot = a.onSelect, rt = "".concat(s, "-month-panel");
  $.current = {
    onKeyDown: function(et) {
      return createKeyDownHandler(et, {
        onLeftRight: function(ut) {
          ot(_e.addMonth(tt || nt, ut), "key");
        },
        onCtrlLeftRight: function(ut) {
          ot(_e.addYear(tt || nt, ut), "key");
        },
        onUpDown: function(ut) {
          ot(_e.addMonth(tt || nt, ut * MONTH_COL_COUNT), "key");
        },
        onEnter: function() {
          at("date", tt || nt);
        }
      });
    }
  };
  var st = function(et) {
    var it = _e.addYear(nt, et);
    _(it), at(null, it);
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: rt
  }, /* @__PURE__ */ reactExports.createElement(MonthHeader, _extends$2({}, a, {
    prefixCls: s,
    onPrevYear: function() {
      st(-1);
    },
    onNextYear: function() {
      st(1);
    },
    onYearClick: function() {
      at("year", nt);
    }
  })), /* @__PURE__ */ reactExports.createElement(MonthBody, _extends$2({}, a, {
    prefixCls: s,
    onSelect: function(et) {
      ot(et, "mouse"), at("date", et);
    }
  })));
}
function QuarterHeader(a) {
  var s = a.prefixCls, $ = a.generateConfig, _ = a.locale, _e = a.viewDate, tt = a.onNextYear, nt = a.onPrevYear, at = a.onYearClick, ot = reactExports.useContext(PanelContext), rt = ot.hideHeader;
  if (rt)
    return null;
  var st = "".concat(s, "-header");
  return /* @__PURE__ */ reactExports.createElement(Header$2, _extends$2({}, a, {
    prefixCls: st,
    onSuperPrev: nt,
    onSuperNext: tt
  }), /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    onClick: at,
    className: "".concat(s, "-year-btn")
  }, formatValue(_e, {
    locale: _,
    format: _.yearFormat,
    generateConfig: $
  })));
}
var QUARTER_COL_COUNT = 4, QUARTER_ROW_COUNT = 1;
function QuarterBody(a) {
  var s = a.prefixCls, $ = a.locale, _ = a.value, _e = a.viewDate, tt = a.generateConfig, nt = a.cellRender, at = reactExports.useContext(RangeContext), ot = at.rangedValue, rt = at.hoverRangedValue, st = "".concat(s, "-cell"), lt = useCellClassName({
    cellPrefixCls: st,
    value: _,
    generateConfig: tt,
    rangedValue: ot,
    hoverRangedValue: rt,
    isSameCell: function(ft, ht) {
      return isSameQuarter(tt, ft, ht);
    },
    isInView: function() {
      return !0;
    },
    offsetCell: function(ft, ht) {
      return tt.addMonth(ft, ht * 3);
    }
  }), et = tt.setDate(tt.setMonth(_e, 0), 1), it = nt ? function(ut, ft) {
    return nt(ut, {
      originNode: ft,
      locale: $,
      today: tt.getNow(),
      type: "quarter"
    });
  } : void 0;
  return /* @__PURE__ */ reactExports.createElement(PanelBody, _extends$2({}, a, {
    rowNum: QUARTER_ROW_COUNT,
    colNum: QUARTER_COL_COUNT,
    baseDate: et,
    getCellNode: it,
    getCellText: function(ft) {
      return formatValue(ft, {
        locale: $,
        format: $.quarterFormat || "[Q]Q",
        generateConfig: tt
      });
    },
    getCellClassName: lt,
    getCellDate: function(ft, ht) {
      return tt.addMonth(ft, ht * 3);
    },
    titleCell: function(ft) {
      return formatValue(ft, {
        locale: $,
        format: "YYYY-[Q]Q",
        generateConfig: tt
      });
    }
  }));
}
function QuarterPanel(a) {
  var s = a.prefixCls, $ = a.operationRef, _ = a.onViewDateChange, _e = a.generateConfig, tt = a.value, nt = a.viewDate, at = a.onPanelChange, ot = a.onSelect, rt = "".concat(s, "-quarter-panel");
  $.current = {
    onKeyDown: function(et) {
      return createKeyDownHandler(et, {
        onLeftRight: function(ut) {
          ot(_e.addMonth(tt || nt, ut * 3), "key");
        },
        onCtrlLeftRight: function(ut) {
          ot(_e.addYear(tt || nt, ut), "key");
        },
        onUpDown: function(ut) {
          ot(_e.addYear(tt || nt, ut), "key");
        }
      });
    }
  };
  var st = function(et) {
    var it = _e.addYear(nt, et);
    _(it), at(null, it);
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: rt
  }, /* @__PURE__ */ reactExports.createElement(QuarterHeader, _extends$2({}, a, {
    prefixCls: s,
    onPrevYear: function() {
      st(-1);
    },
    onNextYear: function() {
      st(1);
    },
    onYearClick: function() {
      at("year", nt);
    }
  })), /* @__PURE__ */ reactExports.createElement(QuarterBody, _extends$2({}, a, {
    prefixCls: s,
    onSelect: function(et) {
      ot(et, "mouse");
    }
  })));
}
function WeekPanel(a) {
  var s = a.prefixCls, $ = a.generateConfig, _ = a.locale, _e = a.value, tt = a.disabledDate, nt = a.onSelect, at = reactExports.useContext(RangeContext), ot = at.rangedValue, rt = at.hoverRangedValue, st = reactExports.useContext(PanelContext), lt = st.onDateMouseEnter, et = st.onDateMouseLeave, it = (rt == null ? void 0 : rt[0]) || (ot == null ? void 0 : ot[0]), ut = (rt == null ? void 0 : rt[1]) || (ot == null ? void 0 : ot[1]), ft = "".concat(s, "-cell"), ht = function(mt) {
    var ct = getCellDateDisabled({
      cellDate: mt,
      mode: "week",
      disabledDate: tt,
      generateConfig: $
    });
    return /* @__PURE__ */ reactExports.createElement("td", {
      key: "week",
      className: classnames(ft, "".concat(ft, "-week")),
      onClick: function() {
        ct || nt(mt, "mouse");
      },
      onMouseEnter: function() {
        !ct && lt && lt(mt);
      },
      onMouseLeave: function() {
        !ct && et && et(mt);
      }
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(ft, "-inner")
    }, $.locale.getWeek(_.locale, mt)));
  }, dt = "".concat(s, "-week-panel-row"), gt = function(mt) {
    var ct, vt = isSameWeek($, _.locale, it, mt), At = isSameWeek($, _.locale, ut, mt);
    return classnames(dt, (ct = {}, _defineProperty$c(ct, "".concat(dt, "-selected"), !ot && isSameWeek($, _.locale, _e, mt)), _defineProperty$c(ct, "".concat(dt, "-range-start"), vt), _defineProperty$c(ct, "".concat(dt, "-range-end"), At), _defineProperty$c(ct, "".concat(dt, "-range-hover"), !vt && !At && isInRange($, it, ut, mt)), ct));
  };
  return /* @__PURE__ */ reactExports.createElement(DatePanel, _extends$2({}, a, {
    panelName: "week",
    prefixColumn: ht,
    rowClassName: gt,
    keyboardConfig: {
      onLeftRight: null
    },
    isSameCell: function() {
      return !1;
    }
  }));
}
var YEAR_DECADE_COUNT = 10;
function YearHeader(a) {
  var s = a.prefixCls, $ = a.generateConfig, _ = a.viewDate, _e = a.onPrevDecade, tt = a.onNextDecade, nt = a.onDecadeClick, at = reactExports.useContext(PanelContext), ot = at.hideHeader;
  if (ot)
    return null;
  var rt = "".concat(s, "-header"), st = $.getYear(_), lt = Math.floor(st / YEAR_DECADE_COUNT) * YEAR_DECADE_COUNT, et = lt + YEAR_DECADE_COUNT - 1;
  return /* @__PURE__ */ reactExports.createElement(Header$2, _extends$2({}, a, {
    prefixCls: rt,
    onSuperPrev: _e,
    onSuperNext: tt
  }), /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    onClick: nt,
    className: "".concat(s, "-decade-btn")
  }, lt, "-", et));
}
var YEAR_COL_COUNT = 3, YEAR_ROW_COUNT = 4;
function YearBody(a) {
  var s = a.prefixCls, $ = a.value, _ = a.viewDate, _e = a.locale, tt = a.generateConfig, nt = a.cellRender, at = reactExports.useContext(RangeContext), ot = at.rangedValue, rt = at.hoverRangedValue, st = "".concat(s, "-cell"), lt = tt.getYear(_), et = Math.floor(lt / YEAR_DECADE_COUNT) * YEAR_DECADE_COUNT, it = et + YEAR_DECADE_COUNT - 1, ut = tt.setYear(_, et - Math.ceil((YEAR_COL_COUNT * YEAR_ROW_COUNT - YEAR_DECADE_COUNT) / 2)), ft = tt.getNow(), ht = function(mt) {
    var ct = tt.getYear(mt);
    return et <= ct && ct <= it;
  }, dt = useCellClassName({
    cellPrefixCls: st,
    value: $,
    generateConfig: tt,
    rangedValue: ot,
    hoverRangedValue: rt,
    isSameCell: function(mt, ct) {
      return isSameYear(tt, mt, ct);
    },
    isInView: ht,
    offsetCell: function(mt, ct) {
      return tt.addYear(mt, ct);
    }
  }), gt = nt ? function(pt, mt) {
    return nt(pt, {
      originNode: mt,
      today: ft,
      type: "year",
      locale: _e
    });
  } : void 0;
  return /* @__PURE__ */ reactExports.createElement(PanelBody, _extends$2({}, a, {
    rowNum: YEAR_ROW_COUNT,
    colNum: YEAR_COL_COUNT,
    baseDate: ut,
    getCellNode: gt,
    getCellText: tt.getYear,
    getCellClassName: dt,
    getCellDate: tt.addYear,
    titleCell: function(mt) {
      return formatValue(mt, {
        locale: _e,
        format: "YYYY",
        generateConfig: tt
      });
    }
  }));
}
function YearPanel(a) {
  var s = a.prefixCls, $ = a.operationRef, _ = a.onViewDateChange, _e = a.generateConfig, tt = a.value, nt = a.viewDate, at = a.sourceMode, ot = a.onSelect, rt = a.onPanelChange, st = "".concat(s, "-year-panel");
  $.current = {
    onKeyDown: function(it) {
      return createKeyDownHandler(it, {
        onLeftRight: function(ft) {
          ot(_e.addYear(tt || nt, ft), "key");
        },
        onCtrlLeftRight: function(ft) {
          ot(_e.addYear(tt || nt, ft * YEAR_DECADE_COUNT), "key");
        },
        onUpDown: function(ft) {
          ot(_e.addYear(tt || nt, ft * YEAR_COL_COUNT), "key");
        },
        onEnter: function() {
          rt(at === "date" ? "date" : "month", tt || nt);
        }
      });
    }
  };
  var lt = function(it) {
    var ut = _e.addYear(nt, it * 10);
    _(ut), rt(null, ut);
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: st
  }, /* @__PURE__ */ reactExports.createElement(YearHeader, _extends$2({}, a, {
    prefixCls: s,
    onPrevDecade: function() {
      lt(-1);
    },
    onNextDecade: function() {
      lt(1);
    },
    onDecadeClick: function() {
      rt("decade", nt);
    }
  })), /* @__PURE__ */ reactExports.createElement(YearBody, _extends$2({}, a, {
    prefixCls: s,
    onSelect: function(it) {
      rt(at === "date" ? "date" : "month", it), ot(it, "mouse");
    }
  })));
}
function getExtraFooter(a, s, $) {
  return $ ? /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(a, "-footer-extra")
  }, $(s)) : null;
}
function getRanges(a) {
  var s = a.prefixCls, $ = a.components, _ = $ === void 0 ? {} : $, _e = a.needConfirmButton, tt = a.onNow, nt = a.onOk, at = a.okDisabled, ot = a.showNow, rt = a.locale, st, lt;
  if (_e) {
    var et = _.button || "button";
    tt && ot !== !1 && (st = /* @__PURE__ */ reactExports.createElement("li", {
      className: "".concat(s, "-now")
    }, /* @__PURE__ */ reactExports.createElement("a", {
      className: "".concat(s, "-now-btn"),
      onClick: tt
    }, rt.now))), lt = _e && /* @__PURE__ */ reactExports.createElement("li", {
      className: "".concat(s, "-ok")
    }, /* @__PURE__ */ reactExports.createElement(et, {
      disabled: at,
      onClick: nt
    }, rt.ok));
  }
  return !st && !lt ? null : /* @__PURE__ */ reactExports.createElement("ul", {
    className: "".concat(s, "-ranges")
  }, st, lt);
}
var CALENDAR_PANEL_MODE = ["date", "month"];
function PickerPanel(a) {
  var s, $ = a, _ = $.prefixCls, _e = _ === void 0 ? "rc-picker" : _, tt = $.className, nt = $.style, at = $.locale, ot = $.generateConfig, rt = $.value, st = $.defaultValue, lt = $.pickerValue, et = $.defaultPickerValue, it = $.disabledDate, ut = $.mode, ft = $.picker, ht = ft === void 0 ? "date" : ft, dt = $.tabIndex, gt = dt === void 0 ? 0 : dt, pt = $.showNow, mt = $.showTime, ct = $.showToday, vt = $.renderExtraFooter, At = $.hideHeader, xt = $.onSelect, bt = $.onChange, Et = $.onPanelChange, St = $.onMouseDown, Bt = $.onPickerValueChange, Ot = $.onOk, Pt = $.components, wt = $.direction, Ct = $.hourStep, It = Ct === void 0 ? 1 : Ct, yt = $.minuteStep, Rt = yt === void 0 ? 1 : yt, kt = $.secondStep, jt = kt === void 0 ? 1 : kt, Ht = $.dateRender, Ft = $.monthCellRender, _t = $.cellRender, Nt = ht === "date" && !!mt || ht === "time", Mt = 24 % It === 0, Lt = 60 % Rt === 0, $t = 60 % jt === 0, Tt = reactExports.useContext(PanelContext), Dt = Tt.operationRef, Ut = Tt.onSelect, Vt = Tt.hideRanges, Qt = Tt.defaultOpenValue, qt = reactExports.useContext(RangeContext), Zt = qt.inRange, ar = qt.panelPosition, Jt = qt.rangedValue, rr = qt.hoverRangedValue, Yt = reactExports.useRef({}), Kt = reactExports.useRef(!0), nr = useMergedState(null, {
    value: rt,
    defaultValue: st,
    postState: function($r) {
      return !$r && Qt && ht === "time" ? Qt : $r;
    }
  }), tr = _slicedToArray$e(nr, 2), ir = tr[0], sr = tr[1], cr = useMergedState(null, {
    value: lt,
    defaultValue: et || ir,
    postState: function($r) {
      var wr = ot.getNow();
      if (!$r)
        return wr;
      if (!ir && mt) {
        var Mr = _typeof$q(mt) === "object" ? mt.defaultValue : st;
        return setDateTime(ot, Array.isArray($r) ? $r[0] : $r, Mr || wr);
      }
      return Array.isArray($r) ? $r[0] : $r;
    }
  }), or = _slicedToArray$e(cr, 2), Xt = or[0], Gt = or[1], Wt = function($r) {
    Gt($r), Bt && Bt($r);
  }, er = function($r) {
    var wr = PickerModeMap[ht];
    return wr ? wr($r) : $r;
  }, lr = useMergedState(function() {
    return ht === "time" ? "time" : er("date");
  }, {
    value: ut
  }), ur = _slicedToArray$e(lr, 2), pr = ur[0], yr = ur[1];
  reactExports.useEffect(function() {
    yr(ht);
  }, [ht]);
  var Er = reactExports.useState(function() {
    return pr;
  }), br = _slicedToArray$e(Er, 2), gr = br[0], Ar = br[1], Sr = function($r, wr) {
    var Mr = er($r || pr);
    Ar(pr), yr(Mr), Et && (pr !== Mr || isEqual(ot, Xt, Xt)) && Et(wr, Mr);
  }, Br = function($r, wr) {
    var Mr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    (pr === ht || Mr) && (sr($r), xt && xt($r), Ut && Ut($r, wr), bt && !isEqual(ot, $r, ir) && !(it != null && it($r)) && bt($r));
  }, Ir = function($r) {
    if (CALENDAR_PANEL_MODE.includes(pr)) {
      var wr, Mr, Fr = pr === "date";
      switch ($r === KeyCode.PAGE_UP || $r === KeyCode.PAGE_DOWN ? Mr = Fr ? ot.addMonth : ot.addYear : Mr = Fr ? ot.addDate : ot.addMonth, $r) {
        case KeyCode.LEFT:
        case KeyCode.PAGE_UP:
          wr = Mr(Xt, -1);
          break;
        case KeyCode.RIGHT:
        case KeyCode.PAGE_DOWN:
          wr = Mr(Xt, 1);
          break;
        case KeyCode.UP:
        case KeyCode.DOWN:
          wr = Mr(Xt, Number("".concat($r === KeyCode.UP ? "-" : "").concat(Fr ? WEEK_DAY_COUNT : MONTH_COL_COUNT)));
          break;
      }
      if (wr)
        return !(it != null && it(wr));
    }
    return !0;
  }, hr = function($r) {
    if (Yt.current && Yt.current.onKeyDown) {
      var wr = !0, Mr = $r.which;
      if ([KeyCode.LEFT, KeyCode.RIGHT, KeyCode.UP, KeyCode.DOWN, KeyCode.PAGE_UP, KeyCode.PAGE_DOWN, KeyCode.ENTER].includes(Mr) && ($r.preventDefault(), Mr !== KeyCode.ENTER && gt === 0 && (wr = Ir(Mr))), wr)
        return Yt.current.onKeyDown($r);
    }
    return warningOnce(!1, "Panel not correct handle keyDown event. Please help to fire issue about this."), !1;
  }, vr = function($r) {
    Yt.current && Yt.current.onBlur && Yt.current.onBlur($r);
  };
  Dt && ar !== "right" && (Dt.current = {
    onKeyDown: hr,
    onClose: function() {
      Yt.current && Yt.current.onClose && Yt.current.onClose();
    }
  }), reactExports.useEffect(function() {
    rt && !Kt.current && Gt(rt);
  }, [rt]), reactExports.useEffect(function() {
    Kt.current = !1;
  }, []);
  var xr, Pr = useCellRender$1({
    cellRender: _t,
    monthCellRender: Ft,
    dateRender: Ht
  }), Rr = _objectSpread2$a(_objectSpread2$a({}, a), {}, {
    cellRender: Pr,
    operationRef: Yt,
    prefixCls: _e,
    viewDate: Xt,
    value: ir,
    onViewDateChange: Wt,
    sourceMode: gr,
    onPanelChange: Sr,
    disabledDate: it
  });
  switch (delete Rr.onChange, delete Rr.onSelect, pr) {
    case "decade":
      xr = /* @__PURE__ */ reactExports.createElement(DecadePanel, _extends$2({}, Rr, {
        onSelect: function($r, wr) {
          Wt($r), Br($r, wr);
        }
      }));
      break;
    case "year":
      xr = /* @__PURE__ */ reactExports.createElement(YearPanel, _extends$2({}, Rr, {
        onSelect: function($r, wr) {
          Wt($r), Br($r, wr);
        }
      }));
      break;
    case "month":
      xr = /* @__PURE__ */ reactExports.createElement(MonthPanel, _extends$2({}, Rr, {
        onSelect: function($r, wr) {
          Wt($r), Br($r, wr);
        }
      }));
      break;
    case "quarter":
      xr = /* @__PURE__ */ reactExports.createElement(QuarterPanel, _extends$2({}, Rr, {
        onSelect: function($r, wr) {
          Wt($r), Br($r, wr);
        }
      }));
      break;
    case "week":
      xr = /* @__PURE__ */ reactExports.createElement(WeekPanel, _extends$2({}, Rr, {
        onSelect: function($r, wr) {
          Wt($r), Br($r, wr);
        }
      }));
      break;
    case "time":
      delete Rr.showTime, xr = /* @__PURE__ */ reactExports.createElement(TimePanel, _extends$2({}, Rr, _typeof$q(mt) === "object" ? mt : null, {
        onSelect: function($r, wr) {
          Wt($r), Br($r, wr);
        }
      }));
      break;
    default:
      mt ? xr = /* @__PURE__ */ reactExports.createElement(DatetimePanel, _extends$2({}, Rr, {
        onSelect: function($r, wr) {
          Wt($r), Br($r, wr);
        }
      })) : xr = /* @__PURE__ */ reactExports.createElement(DatePanel, _extends$2({}, Rr, {
        onSelect: function($r, wr) {
          Wt($r), Br($r, wr);
        }
      }));
  }
  var Dr, Gr, Or = function() {
    var $r = ot.getNow(), wr = getLowerBoundTime(ot.getHour($r), ot.getMinute($r), ot.getSecond($r), Mt ? It : 1, Lt ? Rt : 1, $t ? jt : 1), Mr = setTime(
      ot,
      $r,
      wr[0],
      // hour
      wr[1],
      // minute
      wr[2]
      // second
    );
    Br(Mr, "submit");
  };
  Vt || (Dr = getExtraFooter(_e, pr, vt), mt && pr !== "date" ? Gr = null : Gr = getRanges({
    prefixCls: _e,
    components: Pt,
    needConfirmButton: Nt,
    okDisabled: !ir || it && it(ir),
    locale: at,
    showNow: pt,
    onNow: Nt && Or,
    onOk: function() {
      ir && (Br(ir, "submit", !0), Ot && Ot(ir));
    }
  }));
  var Hr;
  if (ct && pr === "date" && ht === "date" && !mt) {
    var jr = ot.getNow(), Tr = "".concat(_e, "-today-btn"), fr = it && it(jr);
    Hr = /* @__PURE__ */ reactExports.createElement("a", {
      className: classnames(Tr, fr && "".concat(Tr, "-disabled")),
      "aria-disabled": fr,
      onClick: function() {
        fr || Br(jr, "mouse", !0);
      }
    }, at.today);
  }
  return /* @__PURE__ */ reactExports.createElement(PanelContext.Provider, {
    value: _objectSpread2$a(_objectSpread2$a({}, Tt), {}, {
      mode: pr,
      hideHeader: "hideHeader" in a ? At : Tt.hideHeader,
      hidePrevBtn: Zt && ar === "right",
      hideNextBtn: Zt && ar === "left"
    })
  }, /* @__PURE__ */ reactExports.createElement("div", {
    tabIndex: gt,
    className: classnames("".concat(_e, "-panel"), tt, (s = {}, _defineProperty$c(s, "".concat(_e, "-panel-has-range"), Jt && Jt[0] && Jt[1]), _defineProperty$c(s, "".concat(_e, "-panel-has-range-hover"), rr && rr[0] && rr[1]), _defineProperty$c(s, "".concat(_e, "-panel-rtl"), wt === "rtl"), s)),
    style: nt,
    onKeyDown: hr,
    onBlur: vr,
    onMouseDown: St
  }, xr, Dr || Gr || Hr ? /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(_e, "-footer")
  }, Dr, Gr, Hr) : null));
}
var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, -4],
    overflow: {
      adjustX: 0,
      adjustY: 1
    }
  }
};
function PickerTrigger(a) {
  var s, $ = a.prefixCls, _ = a.popupElement, _e = a.popupStyle, tt = a.visible, nt = a.dropdownClassName, at = a.dropdownAlign, ot = a.transitionName, rt = a.getPopupContainer, st = a.children, lt = a.range, et = a.popupPlacement, it = a.direction, ut = "".concat($, "-dropdown"), ft = function() {
    return et !== void 0 ? et : it === "rtl" ? "bottomRight" : "bottomLeft";
  };
  return /* @__PURE__ */ reactExports.createElement(Trigger$1, {
    showAction: [],
    hideAction: [],
    popupPlacement: ft(),
    builtinPlacements: BUILT_IN_PLACEMENTS,
    prefixCls: ut,
    popupTransitionName: ot,
    popup: _,
    popupAlign: at,
    popupVisible: tt,
    popupClassName: classnames(nt, (s = {}, _defineProperty$c(s, "".concat(ut, "-range"), lt), _defineProperty$c(s, "".concat(ut, "-rtl"), it === "rtl"), s)),
    popupStyle: _e,
    getPopupContainer: rt
  }, st);
}
function PresetPanel(a) {
  var s = a.prefixCls, $ = a.presets, _ = a.onClick, _e = a.onHover;
  return $.length ? /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(s, "-presets")
  }, /* @__PURE__ */ reactExports.createElement("ul", null, $.map(function(tt, nt) {
    var at = tt.label, ot = tt.value;
    return /* @__PURE__ */ reactExports.createElement("li", {
      key: nt,
      onClick: function() {
        return _ == null ? void 0 : _(executeValue(ot));
      },
      onMouseEnter: function() {
        return _e == null ? void 0 : _e(executeValue(ot));
      },
      onMouseLeave: function() {
        return _e == null ? void 0 : _e(null);
      }
    }, at);
  }))) : null;
}
function getClearIcon(a, s, $) {
  var _ = _typeof$q(s) === "object" ? s.clearIcon : $;
  return _ || /* @__PURE__ */ React$a.createElement("span", {
    className: "".concat(a, "-clear-btn")
  });
}
function InnerPicker(a) {
  var s, $ = a, _ = $.prefixCls, _e = _ === void 0 ? "rc-picker" : _, tt = $.id, nt = $.name, at = $.tabIndex, ot = $.style, rt = $.className, st = $.dropdownClassName, lt = $.dropdownAlign, et = $.popupStyle, it = $.transitionName, ut = $.generateConfig, ft = $.locale, ht = $.inputReadOnly, dt = $.allowClear, gt = $.autoFocus, pt = $.showTime, mt = $.picker, ct = mt === void 0 ? "date" : mt, vt = $.format, At = $.use12Hours, xt = $.value, bt = $.defaultValue, Et = $.presets, St = $.open, Bt = $.defaultOpen, Ot = $.defaultOpenValue, Pt = $.suffixIcon, wt = $.clearIcon, Ct = $.disabled, It = $.disabledDate, yt = $.placeholder, Rt = $.getPopupContainer, kt = $.pickerRef, jt = $.panelRender, Ht = $.onChange, Ft = $.onOpenChange, _t = $.onFocus, Nt = $.onBlur, Mt = $.onMouseDown, Lt = $.onMouseUp, $t = $.onMouseEnter, Tt = $.onMouseLeave, Dt = $.onContextMenu, Ut = $.onClick, Vt = $.onKeyDown, Qt = $.onSelect, qt = $.direction, Zt = $.autoComplete, ar = Zt === void 0 ? "off" : Zt, Jt = $.inputRender, rr = $.changeOnBlur, Yt = reactExports.useRef(null), Kt = ct === "date" && !!pt || ct === "time", nr = usePresets(Et), tr = toArray$5(getDefaultFormat(vt, ct, pt, At)), ir = reactExports.useRef(null), sr = reactExports.useRef(null), cr = reactExports.useRef(null), or = useMergedState(null, {
    value: xt,
    defaultValue: bt
  }), Xt = _slicedToArray$e(or, 2), Gt = Xt[0], Wt = Xt[1], er = reactExports.useState(Gt), lr = _slicedToArray$e(er, 2), ur = lr[0], pr = lr[1], yr = reactExports.useRef(null), Er = useMergedState(!1, {
    value: St,
    defaultValue: Bt,
    postState: function(Wr) {
      return Ct ? !1 : Wr;
    },
    onChange: function(Wr) {
      Ft && Ft(Wr), !Wr && yr.current && yr.current.onClose && yr.current.onClose();
    }
  }), br = _slicedToArray$e(Er, 2), gr = br[0], Ar = br[1], Sr = useValueTexts(ur, {
    formatList: tr,
    generateConfig: ut,
    locale: ft
  }), Br = _slicedToArray$e(Sr, 2), Ir = Br[0], hr = Br[1], vr = useTextValueMapping({
    valueTexts: Ir,
    onTextChange: function(Wr) {
      var dn = parseValue(Wr, {
        locale: ft,
        formatList: tr,
        generateConfig: ut
      });
      dn && (!It || !It(dn)) && pr(dn);
    }
  }), xr = _slicedToArray$e(vr, 3), Pr = xr[0], Rr = xr[1], Dr = xr[2], Gr = function(Wr) {
    pr(Wr), Wt(Wr), Ht && !isEqual(ut, Gt, Wr) && Ht(Wr, Wr ? formatValue(Wr, {
      generateConfig: ut,
      locale: ft,
      format: tr[0]
    }) : "");
  }, Or = function(Wr) {
    Ct && Wr || Ar(Wr);
  }, Hr = function(Wr) {
    return gr && yr.current && yr.current.onKeyDown ? yr.current.onKeyDown(Wr) : (warningOnce(!1, "Picker not correct forward KeyDown operation. Please help to fire issue about this."), !1);
  }, jr = function() {
    for (var Wr = arguments.length, dn = new Array(Wr), hn = 0; hn < Wr; hn++)
      dn[hn] = arguments[hn];
    Ut == null || Ut.apply(void 0, dn), Yt.current && (Yt.current.focus(), Or(!0));
  }, Tr = function(Wr) {
    rr && Gr(ur), Nt == null || Nt(Wr);
  }, fr = usePickerInput({
    blurToCancel: Kt,
    changeOnBlur: rr,
    open: gr,
    value: Pr,
    triggerOpen: Or,
    forwardKeyDown: Hr,
    isClickOutside: function(Wr) {
      return !elementsContains([ir.current, sr.current, cr.current], Wr);
    },
    onSubmit: function() {
      return (
        // When user typing disabledDate with keyboard and enter, this value will be empty
        !ur || // Normal disabled check
        It && It(ur) ? !1 : (Gr(ur), Or(!1), Dr(), !0)
      );
    },
    onCancel: function() {
      Or(!1), pr(Gt), Dr();
    },
    onKeyDown: function(Wr, dn) {
      Vt == null || Vt(Wr, dn);
    },
    onFocus: _t,
    onBlur: Tr
  }), Cr = _slicedToArray$e(fr, 2), $r = Cr[0], wr = Cr[1], Mr = wr.focused, Fr = wr.typing;
  reactExports.useEffect(function() {
    gr || (pr(Gt), !Ir.length || Ir[0] === "" ? Rr("") : hr !== Pr && Dr());
  }, [gr, Ir]), reactExports.useEffect(function() {
    gr || Dr();
  }, [ct]), reactExports.useEffect(function() {
    pr(Gt);
  }, [Gt]), kt && (kt.current = {
    focus: function() {
      var Wr;
      (Wr = Yt.current) === null || Wr === void 0 || Wr.focus();
    },
    blur: function() {
      var Wr;
      (Wr = Yt.current) === null || Wr === void 0 || Wr.blur();
    }
  });
  var Qr = useHoverValue(Pr, {
    formatList: tr,
    generateConfig: ut,
    locale: ft
  }), Yr = _slicedToArray$e(Qr, 3), kr = Yr[0], Nr = Yr[1], Lr = Yr[2], zr = _objectSpread2$a(_objectSpread2$a({}, a), {}, {
    className: void 0,
    style: void 0,
    pickerValue: void 0,
    onPickerValueChange: void 0,
    onChange: null
  }), Vr = /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(_e, "-panel-layout")
  }, /* @__PURE__ */ reactExports.createElement(PresetPanel, {
    prefixCls: _e,
    presets: nr,
    onClick: function(Wr) {
      Gr(Wr), Or(!1);
    }
  }), /* @__PURE__ */ reactExports.createElement(PickerPanel, _extends$2({}, zr, {
    generateConfig: ut,
    className: classnames(_defineProperty$c({}, "".concat(_e, "-panel-focused"), !Fr)),
    value: ur,
    locale: ft,
    tabIndex: -1,
    onSelect: function(Wr) {
      Qt == null || Qt(Wr), pr(Wr);
    },
    direction: qt,
    onPanelChange: function(Wr, dn) {
      var hn = a.onPanelChange;
      Lr(!0), hn == null || hn(Wr, dn);
    }
  })));
  jt && (Vr = jt(Vr));
  var an = /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(_e, "-panel-container"),
    ref: ir,
    onMouseDown: function(Wr) {
      Wr.preventDefault();
    }
  }, Vr), Zr;
  Pt && (Zr = /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(_e, "-suffix"),
    onMouseDown: function(Wr) {
      Wr.preventDefault();
    }
  }, Pt));
  var un = getClearIcon(_e, dt, wt), Xr = /* @__PURE__ */ reactExports.createElement("span", {
    onMouseDown: function(Wr) {
      Wr.preventDefault(), Wr.stopPropagation();
    },
    onMouseUp: function(Wr) {
      Wr.preventDefault(), Wr.stopPropagation(), Gr(null), Or(!1);
    },
    className: "".concat(_e, "-clear"),
    role: "button"
  }, un), Kr = !!dt && Gt && !Ct, rn = _objectSpread2$a(_objectSpread2$a(_objectSpread2$a({
    id: tt,
    tabIndex: at,
    disabled: Ct,
    readOnly: ht || typeof tr[0] == "function" || !Fr,
    value: kr || Pr,
    onChange: function(Wr) {
      Rr(Wr.target.value);
    },
    autoFocus: gt,
    placeholder: yt,
    ref: Yt,
    title: Pr
  }, $r), {}, {
    size: getInputSize(ct, tr[0], ut),
    name: nt
  }, pickAttrs(a, {
    aria: !0,
    data: !0
  })), {}, {
    autoComplete: ar
  }), nn = Jt ? Jt(rn) : /* @__PURE__ */ reactExports.createElement("input", rn), sn = function(Wr, dn) {
    (dn === "submit" || dn !== "key" && !Kt) && (Gr(Wr), Or(!1));
  }, gn = qt === "rtl" ? "bottomRight" : "bottomLeft";
  return /* @__PURE__ */ reactExports.createElement(PanelContext.Provider, {
    value: {
      operationRef: yr,
      hideHeader: ct === "time",
      onSelect: sn,
      open: gr,
      defaultOpenValue: Ot,
      onDateMouseEnter: Nr,
      onDateMouseLeave: Lr
    }
  }, /* @__PURE__ */ reactExports.createElement(PickerTrigger, {
    visible: gr,
    popupElement: an,
    popupStyle: et,
    prefixCls: _e,
    dropdownClassName: st,
    dropdownAlign: lt,
    getPopupContainer: Rt,
    transitionName: it,
    popupPlacement: gn,
    direction: qt
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: cr,
    className: classnames(_e, rt, (s = {}, _defineProperty$c(s, "".concat(_e, "-disabled"), Ct), _defineProperty$c(s, "".concat(_e, "-focused"), Mr), _defineProperty$c(s, "".concat(_e, "-rtl"), qt === "rtl"), s)),
    style: ot,
    onMouseDown: Mt,
    onMouseUp: Lt,
    onMouseEnter: $t,
    onMouseLeave: Tt,
    onContextMenu: Dt,
    onClick: jr
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(_e, "-input"), _defineProperty$c({}, "".concat(_e, "-input-placeholder"), !!kr)),
    ref: sr
  }, nn, Zr, Kr && Xr))));
}
var Picker = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $() {
    var _;
    _classCallCheck(this, $);
    for (var _e = arguments.length, tt = new Array(_e), nt = 0; nt < _e; nt++)
      tt[nt] = arguments[nt];
    return _ = s.call.apply(s, [this].concat(tt)), _defineProperty$c(_assertThisInitialized(_), "pickerRef", /* @__PURE__ */ reactExports.createRef()), _defineProperty$c(_assertThisInitialized(_), "focus", function() {
      _.pickerRef.current && _.pickerRef.current.focus();
    }), _defineProperty$c(_assertThisInitialized(_), "blur", function() {
      _.pickerRef.current && _.pickerRef.current.blur();
    }), _;
  }
  return _createClass($, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ reactExports.createElement(InnerPicker, _extends$2({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]), $;
}(reactExports.Component);
function useRangeDisabled(a, s) {
  var $ = a.picker, _ = a.locale, _e = a.selectedValue, tt = a.disabledDate, nt = a.disabled, at = a.generateConfig, ot = getValue$2(_e, 0), rt = getValue$2(_e, 1);
  function st(ft) {
    return at.locale.getWeekFirstDate(_.locale, ft);
  }
  function lt(ft) {
    var ht = at.getYear(ft), dt = at.getMonth(ft);
    return ht * 100 + dt;
  }
  function et(ft) {
    var ht = at.getYear(ft), dt = getQuarter(at, ft);
    return ht * 10 + dt;
  }
  var it = reactExports.useCallback(function(ft) {
    if (nt[0] || tt && tt(ft))
      return !0;
    if (nt[1] && rt)
      return !isSameDate(at, ft, rt) && at.isAfter(ft, rt);
    if (!s && rt)
      switch ($) {
        case "quarter":
          return et(ft) > et(rt);
        case "month":
          return lt(ft) > lt(rt);
        case "week":
          return st(ft) > st(rt);
        default:
          return !isSameDate(at, ft, rt) && at.isAfter(ft, rt);
      }
    return !1;
  }, [tt, nt[1], rt, s]), ut = reactExports.useCallback(function(ft) {
    if (nt[1] || tt && tt(ft))
      return !0;
    if (nt[0] && ot)
      return !isSameDate(at, ft, rt) && at.isAfter(ot, ft);
    if (!s && ot)
      switch ($) {
        case "quarter":
          return et(ft) < et(ot);
        case "month":
          return lt(ft) < lt(ot);
        case "week":
          return st(ft) < st(ot);
        default:
          return !isSameDate(at, ft, ot) && at.isAfter(ot, ft);
      }
    return !1;
  }, [tt, nt[0], ot, s]);
  return [it, ut];
}
function useRangeOpen(a, s, $, _, _e, tt, nt, at, ot, rt, st) {
  var lt = reactExports.useState(!1), et = _slicedToArray$e(lt, 2), it = et[0], ut = et[1], ft = useMergedState(a || !1, {
    value: s
  }), ht = _slicedToArray$e(ft, 2), dt = ht[0], gt = ht[1], pt = useMergedState(a || !1, {
    value: s,
    onChange: function(yt) {
      st == null || st(yt);
    }
  }), mt = _slicedToArray$e(pt, 2), ct = mt[0], vt = mt[1], At = useMergedState(0, {
    value: $
  }), xt = _slicedToArray$e(At, 2), bt = xt[0], Et = xt[1], St = reactExports.useState(null), Bt = _slicedToArray$e(St, 2), Ot = Bt[0], Pt = Bt[1];
  reactExports.useEffect(function() {
    ct && ut(!0);
  }, [ct]);
  var wt = function(yt) {
    return yt === 0 ? 1 : 0;
  }, Ct = useEvent(function(It, yt, Rt) {
    if (yt === !1)
      vt(It);
    else if (It) {
      Et(yt), vt(It);
      var kt = wt(yt);
      !ct || // Also set next index if next is empty
      ![at, ot][kt] ? Pt(kt) : (ut(!1), Ot !== null && Pt(null));
    } else if (Rt === "confirm" || Rt === "blur" && _) {
      var jt = dt && !_e ? wt(yt) : Ot;
      jt !== null && (ut(!1), Et(jt)), Pt(null), jt !== null && !rt[jt] ? wrapperRaf(function() {
        var Ht, Ft = [tt, nt][jt];
        (Ht = Ft.current) === null || Ht === void 0 || Ht.focus();
      }) : vt(!1);
    } else
      vt(!1), gt(!1);
  });
  return [ct, bt, it, Ct];
}
function getStartEndDistance(a, s, $, _) {
  var _e = getClosingViewDate(a, $, _, 1);
  function tt(nt) {
    return nt(a, s) ? "same" : nt(_e, s) ? "closing" : "far";
  }
  switch ($) {
    case "year":
      return tt(function(nt, at) {
        return isSameDecade(_, nt, at);
      });
    case "quarter":
    case "month":
      return tt(function(nt, at) {
        return isSameYear(_, nt, at);
      });
    default:
      return tt(function(nt, at) {
        return isSameMonth(_, nt, at);
      });
  }
}
function getRangeViewDate(a, s, $, _) {
  var _e = getValue$2(a, 0), tt = getValue$2(a, 1);
  if (s === 0)
    return _e;
  if (_e && tt) {
    var nt = getStartEndDistance(_e, tt, $, _);
    switch (nt) {
      case "same":
        return _e;
      case "closing":
        return _e;
      default:
        return getClosingViewDate(tt, $, _, -1);
    }
  }
  return _e;
}
function useRangeViewDates(a) {
  var s = a.values, $ = a.picker, _ = a.defaultDates, _e = a.generateConfig, tt = reactExports.useState(function() {
    return [getValue$2(_, 0), getValue$2(_, 1)];
  }), nt = _slicedToArray$e(tt, 2), at = nt[0], ot = nt[1], rt = reactExports.useState(null), st = _slicedToArray$e(rt, 2), lt = st[0], et = st[1], it = getValue$2(s, 0), ut = getValue$2(s, 1);
  function ft(dt) {
    return at[dt] ? at[dt] : getValue$2(lt, dt) || getRangeViewDate(s, dt, $, _e) || it || ut || _e.getNow();
  }
  function ht(dt, gt) {
    if (dt) {
      var pt = updateValues(lt, dt, gt);
      ot(
        // Should always be an array
        updateValues(at, null, gt) || [null, null]
      );
      var mt = (gt + 1) % 2;
      getValue$2(s, mt) || (pt = updateValues(pt, dt, mt)), et(pt);
    } else
      (it || ut) && et(null);
  }
  return [ft, ht];
}
function reorderValues(a, s) {
  return a && a[0] && a[1] && s.isAfter(a[0], a[1]) ? [a[1], a[0]] : a;
}
function canValueTrigger(a, s, $, _) {
  return !!(a || _ && _[s] || $[(s + 1) % 2]);
}
function InnerRangePicker(a) {
  var s, $, _, _e = a, tt = _e.prefixCls, nt = tt === void 0 ? "rc-picker" : tt, at = _e.id, ot = _e.style, rt = _e.className, st = _e.popupStyle, lt = _e.dropdownClassName, et = _e.transitionName, it = _e.dropdownAlign, ut = _e.getPopupContainer, ft = _e.generateConfig, ht = _e.locale, dt = _e.placeholder, gt = _e.autoFocus, pt = _e.disabled, mt = _e.format, ct = _e.picker, vt = ct === void 0 ? "date" : ct, At = _e.showTime, xt = _e.use12Hours, bt = _e.separator, Et = bt === void 0 ? "~" : bt, St = _e.value, Bt = _e.defaultValue, Ot = _e.defaultPickerValue, Pt = _e.open, wt = _e.defaultOpen, Ct = _e.disabledDate, It = _e.disabledTime, yt = _e.dateRender, Rt = _e.monthCellRender, kt = _e.cellRender, jt = _e.panelRender, Ht = _e.presets, Ft = _e.ranges, _t = _e.allowEmpty, Nt = _e.allowClear, Mt = _e.suffixIcon, Lt = _e.clearIcon, $t = _e.pickerRef, Tt = _e.inputReadOnly, Dt = _e.mode, Ut = _e.renderExtraFooter, Vt = _e.onChange, Qt = _e.onOpenChange, qt = _e.onPanelChange, Zt = _e.onCalendarChange, ar = _e.onFocus, Jt = _e.onBlur, rr = _e.onMouseDown, Yt = _e.onMouseUp, Kt = _e.onMouseEnter, nr = _e.onMouseLeave, tr = _e.onClick, ir = _e.onOk, sr = _e.onKeyDown, cr = _e.components, or = _e.order, Xt = _e.direction, Gt = _e.activePickerIndex, Wt = _e.autoComplete, er = Wt === void 0 ? "off" : Wt, lr = _e.changeOnBlur, ur = vt === "date" && !!At || vt === "time", pr = reactExports.useRef(null), yr = reactExports.useRef(null), Er = reactExports.useRef(null), br = reactExports.useRef(null), gr = reactExports.useRef(null), Ar = reactExports.useRef(null), Sr = reactExports.useRef(null), Br = reactExports.useRef(null), Ir = toArray$5(getDefaultFormat(mt, vt, At, xt)), hr = function(Tn, Un) {
    return Tn && Tn[Un] ? formatValue(Tn[Un], {
      generateConfig: ft,
      locale: ht,
      format: Ir[0]
    }) : "";
  }, vr = reactExports.useRef(null), xr = reactExports.useMemo(function() {
    return Array.isArray(pt) ? pt : [pt || !1, pt || !1];
  }, [pt]), Pr = useMergedState(null, {
    value: St,
    defaultValue: Bt,
    postState: function(Tn) {
      return vt === "time" && !or ? Tn : reorderValues(Tn, ft);
    }
  }), Rr = _slicedToArray$e(Pr, 2), Dr = Rr[0], Gr = Rr[1], Or = useRangeViewDates({
    values: Dr,
    picker: vt,
    defaultDates: Ot,
    generateConfig: ft
  }), Hr = _slicedToArray$e(Or, 2), jr = Hr[0], Tr = Hr[1], fr = useMergedState(Dr, {
    postState: function(Tn) {
      var Un = Tn;
      if (xr[0] && xr[1])
        return Un;
      for (var Hn = 0; Hn < 2; Hn += 1)
        xr[Hn] && !Un && !getValue$2(Un, Hn) && !getValue$2(_t, Hn) && (Un = updateValues(Un, ft.getNow(), Hn));
      return Un;
    }
  }), Cr = _slicedToArray$e(fr, 2), $r = Cr[0], wr = Cr[1], Mr = useMergedState([vt, vt], {
    value: Dt
  }), Fr = _slicedToArray$e(Mr, 2), Qr = Fr[0], Yr = Fr[1];
  reactExports.useEffect(function() {
    Yr([vt, vt]);
  }, [vt]);
  var kr = function(Tn, Un) {
    Yr(Tn), qt && qt(Un, Tn);
  }, Nr = useRangeOpen(wt, Pt, Gt, lr, ur, Ar, Sr, getValue$2($r, 0), getValue$2($r, 1), xr, Qt), Lr = _slicedToArray$e(Nr, 4), zr = Lr[0], Vr = Lr[1], an = Lr[2], Zr = Lr[3], un = zr && Vr === 0, Xr = zr && Vr === 1, Kr = useRangeDisabled({
    picker: vt,
    selectedValue: $r,
    locale: ht,
    disabled: xr,
    disabledDate: Ct,
    generateConfig: ft
  }, !zr || an), rn = _slicedToArray$e(Kr, 2), nn = rn[0], sn = rn[1], gn = reactExports.useState(0), en = _slicedToArray$e(gn, 2), Wr = en[0], dn = en[1];
  reactExports.useEffect(function() {
    !zr && pr.current && dn(pr.current.offsetWidth);
  }, [zr]);
  function hn(Gn) {
    Zr(!0, Gn, "open"), wrapperRaf(function() {
      var Tn, Un = [Ar, Sr][Gn];
      (Tn = Un.current) === null || Tn === void 0 || Tn.focus();
    }, 0);
  }
  function En(Gn, Tn, Un) {
    var Hn = Gn, ga = getValue$2(Hn, 0), co = getValue$2(Hn, 1);
    ga && co && ft.isAfter(ga, co) && (// WeekPicker only compare week
    vt === "week" && !isSameWeek(ft, ht.locale, ga, co) || // QuotaPicker only compare week
    vt === "quarter" && !isSameQuarter(ft, ga, co) || // Other non-TimePicker compare date
    vt !== "week" && vt !== "quarter" && vt !== "time" && !isSameDate(ft, ga, co) ? Tn === 0 ? (Hn = [ga, null], co = null) : (ga = null, Hn = [null, co]) : (vt !== "time" || or !== !1) && (Hn = reorderValues(Hn, ft))), wr(Hn);
    var Co = hr(Hn, 0), Io = hr(Hn, 1);
    if (Zt) {
      var Ro = {
        range: Tn === 0 ? "start" : "end"
      };
      Zt(Hn, [Co, Io], Ro);
    }
    if (!Un) {
      var zo = canValueTrigger(ga, 0, xr, _t), Bo = canValueTrigger(co, 1, xr, _t), mo = Hn === null || zo && Bo;
      mo && (Gr(Hn), Vt && (!isEqual(ft, getValue$2(Dr, 0), ga) || !isEqual(ft, getValue$2(Dr, 1), co)) && Vt(Hn, [Co, Io]));
    }
  }
  var bn = function(Tn) {
    return zr && vr.current && vr.current.onKeyDown ? vr.current.onKeyDown(Tn) : (warningOnce(!1, "Picker not correct forward KeyDown operation. Please help to fire issue about this."), !1);
  }, Cn = {
    formatList: Ir,
    generateConfig: ft,
    locale: ht
  }, wn = useValueTexts(getValue$2($r, 0), Cn), vn = _slicedToArray$e(wn, 2), fn = vn[0], on = vn[1], pn = useValueTexts(getValue$2($r, 1), Cn), mn = _slicedToArray$e(pn, 2), Pn = mn[0], An = mn[1], yn = function(Tn, Un) {
    var Hn = parseValue(Tn, {
      locale: ht,
      formatList: Ir,
      generateConfig: ft
    }), ga = Un === 0 ? nn : sn;
    Hn && !ga(Hn) && (wr(updateValues($r, Hn, Un)), Tr(Hn, Un));
  }, Bn = useTextValueMapping({
    valueTexts: fn,
    onTextChange: function(Tn) {
      return yn(Tn, 0);
    }
  }), Fn = _slicedToArray$e(Bn, 3), zn = Fn[0], Zn = Fn[1], to = Fn[2], Mn = useTextValueMapping({
    valueTexts: Pn,
    onTextChange: function(Tn) {
      return yn(Tn, 1);
    }
  }), Nn = _slicedToArray$e(Mn, 3), Wn = Nn[0], ca = Nn[1], qn = Nn[2], eo = reactExports.useState(null), ro = _slicedToArray$e(eo, 2), ao = ro[0], so = ro[1], lo = reactExports.useState(null), Ao = _slicedToArray$e(lo, 2), uo = Ao[0], wo = Ao[1], $o = useHoverValue(zn, {
    formatList: Ir,
    generateConfig: ft,
    locale: ht
  }), yo = _slicedToArray$e($o, 3), Rn = yo[0], kn = yo[1], Yn = yo[2], _a = useHoverValue(Wn, {
    formatList: Ir,
    generateConfig: ft,
    locale: ht
  }), Qn = _slicedToArray$e(_a, 3), Eo = Qn[0], vo = Qn[1], Jr = Qn[2], zt = function(Tn) {
    wo(updateValues($r, Tn, Vr)), Vr === 0 ? kn(Tn) : vo(Tn);
  }, dr = function() {
    wo(updateValues($r, null, Vr)), Vr === 0 ? Yn() : Jr();
  }, qr = reactExports.useState(zr), ln = _slicedToArray$e(qr, 2), cn = ln[0], xn = ln[1];
  reactExports.useEffect(function() {
    xn(zr);
  }, [zr]);
  var Sn = function(Tn) {
    if (cn) {
      if (ur) {
        var Un = Vr ? 0 : 1, Hn = getValue$2($r, Un);
        Hn && En($r, Un, !0);
      } else if (lr) {
        var ga = getValue$2($r, Vr);
        ga && En($r, Vr);
      }
    }
    return Jt == null ? void 0 : Jt(Tn);
  }, $n = function(Tn, Un) {
    return {
      blurToCancel: !lr && ur,
      changeOnBlur: lr,
      forwardKeyDown: bn,
      onBlur: Sn,
      isClickOutside: function(ga) {
        var co = [Er.current, br.current, pr.current];
        return !elementsContains([].concat(_toConsumableArray$d(ur ? [co[Vr]] : co), [yr.current]), ga);
      },
      onFocus: function(ga) {
        ar && ar(ga);
      },
      triggerOpen: function(ga) {
        ga ? Zr(ga, Tn, "open") : Zr(
          ga,
          // Close directly if no selected value provided
          getValue$2($r, Tn) ? Tn : !1,
          "blur"
        );
      },
      onSubmit: function() {
        if (
          // When user typing disabledDate with keyboard and enter, this value will be empty
          !$r || // Normal disabled check
          Ct && Ct($r[Tn])
        )
          return !1;
        En($r, Tn), Un(), Zr(!1, Vr, "confirm");
      },
      onCancel: function() {
        Zr(!1, Tn, "cancel"), wr(Dr), Un();
      }
    };
  }, On = {
    onKeyDown: function(Tn, Un) {
      sr == null || sr(Tn, Un);
    }
  }, _n = usePickerInput(_objectSpread2$a(_objectSpread2$a({}, $n(0, to)), {}, {
    open: un,
    value: zn
  }, On)), Kn = _slicedToArray$e(_n, 2), Vn = Kn[0], Xn = Kn[1], _i = Xn.focused, Dn = Xn.typing, oo = usePickerInput(_objectSpread2$a(_objectSpread2$a({}, $n(1, qn)), {}, {
    open: Xr,
    value: Wn
  }, On)), Jn = _slicedToArray$e(oo, 2), fo = Jn[0], io = Jn[1], jn = io.focused, In = io.typing, po = function(Tn) {
    tr && tr(Tn), !zr && !Ar.current.contains(Tn.target) && !Sr.current.contains(Tn.target) && (xr[0] ? xr[1] || hn(1) : hn(0));
  }, ho = function(Tn) {
    rr && rr(Tn), zr && (_i || jn) && !Ar.current.contains(Tn.target) && !Sr.current.contains(Tn.target) && Tn.preventDefault();
  }, So = Dr && Dr[0] ? formatValue(Dr[0], {
    locale: ht,
    format: "YYYYMMDDHHmmss",
    generateConfig: ft
  }) : "", bo = Dr && Dr[1] ? formatValue(Dr[1], {
    locale: ht,
    format: "YYYYMMDDHHmmss",
    generateConfig: ft
  }) : "";
  reactExports.useEffect(function() {
    zr || (wr(Dr), !fn.length || fn[0] === "" ? Zn("") : on !== zn && to(), !Pn.length || Pn[0] === "" ? ca("") : An !== Wn && qn());
  }, [zr, fn, Pn]), reactExports.useEffect(function() {
    wr(Dr);
  }, [So, bo]);
  var no = useCellRender$1({
    cellRender: kt,
    monthCellRender: Rt,
    dateRender: yt
  }), Oo = reactExports.useMemo(function() {
    if (no)
      return function(Gn, Tn) {
        return no(Gn, _objectSpread2$a(_objectSpread2$a({}, Tn), {}, {
          range: Vr ? "end" : "start"
        }));
      };
  }, [Vr, no]);
  $t && ($t.current = {
    focus: function() {
      Ar.current && Ar.current.focus();
    },
    blur: function() {
      Ar.current && Ar.current.blur(), Sr.current && Sr.current.blur();
    }
  });
  var Po = usePresets(Ht, Ft);
  function Ho() {
    var Gn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, Tn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Un = null;
    zr && uo && uo[0] && uo[1] && ft.isAfter(uo[1], uo[0]) && (Un = uo);
    var Hn = At;
    if (At && _typeof$q(At) === "object" && At.defaultValue) {
      var ga = At.defaultValue;
      Hn = _objectSpread2$a(_objectSpread2$a({}, At), {}, {
        defaultValue: getValue$2(ga, Vr) || void 0
      });
    }
    return /* @__PURE__ */ reactExports.createElement(RangeContext.Provider, {
      value: {
        inRange: !0,
        panelPosition: Gn,
        rangedValue: ao || $r,
        hoverRangedValue: Un
      }
    }, /* @__PURE__ */ reactExports.createElement(PickerPanel, _extends$2({}, a, Tn, {
      cellRender: Oo,
      showTime: Hn,
      mode: Qr[Vr],
      generateConfig: ft,
      style: void 0,
      direction: Xt,
      disabledDate: Vr === 0 ? nn : sn,
      disabledTime: function(Co) {
        return It ? It(Co, Vr === 0 ? "start" : "end") : !1;
      },
      className: classnames(_defineProperty$c({}, "".concat(nt, "-panel-focused"), Vr === 0 ? !Dn : !In)),
      value: getValue$2($r, Vr),
      locale: ht,
      tabIndex: -1,
      onPanelChange: function(Co, Io) {
        Vr === 0 && Yn(!0), Vr === 1 && Jr(!0), kr(updateValues(Qr, Io, Vr), updateValues($r, Co, Vr));
        var Ro = Co;
        Gn === "right" && Qr[Vr] === Io && (Ro = getClosingViewDate(Ro, Io, ft, -1)), Tr(Ro, Vr);
      },
      onOk: null,
      onSelect: void 0,
      onChange: void 0,
      defaultValue: Vr === 0 ? getValue$2($r, 1) : getValue$2($r, 0)
      // defaultPickerValue={undefined}
    })));
  }
  var go = 0, dl = 0;
  if (Vr && Er.current && gr.current && yr.current && Br.current) {
    go = Er.current.offsetWidth + gr.current.offsetWidth;
    var su = Br.current.offsetLeft > go ? Br.current.offsetLeft - go : Br.current.offsetLeft, fl = yr.current.offsetWidth, hl = Br.current.offsetWidth;
    fl && hl && go > fl - hl - (Xt === "rtl" ? 0 : su) && (dl = go);
  }
  var lu = Xt === "rtl" ? {
    right: go
  } : {
    left: go
  };
  function cu() {
    var Gn, Tn = getExtraFooter(nt, Qr[Vr], Ut), Un = getRanges({
      prefixCls: nt,
      components: cr,
      needConfirmButton: ur,
      okDisabled: !getValue$2($r, Vr) || Ct && Ct($r[Vr]),
      locale: ht,
      // rangeList,
      onOk: function() {
        var mo = getValue$2($r, Vr);
        mo && (En($r, Vr), ir == null || ir($r), Zr(!1, Vr, "confirm"));
      }
    });
    if (vt !== "time" && !At) {
      var Hn = jr(Vr), ga = getClosingViewDate(Hn, vt, ft), co = Qr[Vr], Co = co === vt, Io = Ho(Co ? "left" : !1, {
        pickerValue: Hn,
        onPickerValueChange: function(mo) {
          Tr(mo, Vr);
        }
      }), Ro = Ho("right", {
        pickerValue: ga,
        onPickerValueChange: function(mo) {
          Tr(getClosingViewDate(mo, vt, ft, -1), Vr);
        }
      });
      Xt === "rtl" ? Gn = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, Ro, Co && Io) : Gn = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, Io, Co && Ro);
    } else
      Gn = Ho();
    var zo = /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(nt, "-panel-layout")
    }, /* @__PURE__ */ reactExports.createElement(PresetPanel, {
      prefixCls: nt,
      presets: Po,
      onClick: function(mo) {
        En(mo, null), Zr(!1, Vr, "preset");
      },
      onHover: function(mo) {
        so(mo);
      }
    }), /* @__PURE__ */ reactExports.createElement("div", null, /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(nt, "-panels")
    }, Gn), (Tn || Un) && /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(nt, "-footer")
    }, Tn, Un)));
    return jt && (zo = jt(zo)), /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(nt, "-panel-container"),
      style: {
        marginLeft: dl
      },
      ref: yr,
      onMouseDown: function(mo) {
        mo.preventDefault();
      }
    }, zo);
  }
  var uu = /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(nt, "-range-wrapper"), "".concat(nt, "-").concat(vt, "-range-wrapper")),
    style: {
      minWidth: Wr
    }
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: Br,
    className: "".concat(nt, "-range-arrow"),
    style: lu
  }), cu()), pl;
  Mt && (pl = /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(nt, "-suffix"),
    onMouseDown: function(Tn) {
      Tn.preventDefault();
    }
  }, Mt));
  var du = getClearIcon(nt, Nt, Lt), fu = /* @__PURE__ */ reactExports.createElement("span", {
    onMouseDown: function(Tn) {
      Tn.preventDefault(), Tn.stopPropagation();
    },
    onMouseUp: function(Tn) {
      Tn.preventDefault(), Tn.stopPropagation();
      var Un = Dr;
      xr[0] || (Un = updateValues(Un, null, 0)), xr[1] || (Un = updateValues(Un, null, 1)), En(Un, null), Zr(!1, Vr, "clear");
    },
    className: "".concat(nt, "-clear"),
    role: "button"
  }, du), hu = Nt && (getValue$2(Dr, 0) && !xr[0] || getValue$2(Dr, 1) && !xr[1]), gl = {
    size: getInputSize(vt, Ir[0], ft)
  }, bs = 0, xs = 0;
  Er.current && br.current && gr.current && (Vr === 0 ? xs = Er.current.offsetWidth : (bs = go, xs = br.current.offsetWidth));
  var pu = Xt === "rtl" ? {
    right: bs
  } : {
    left: bs
  }, gu = function(Tn, Un) {
    var Hn = updateValues($r, Tn, Vr);
    if (Un === "submit" || Un !== "key" && !ur) {
      En(Hn, Vr), Vr === 0 ? Yn() : Jr();
      var ga = Vr === 0 ? 1 : 0;
      xr[ga] ? Zr(!1, !1, "confirm") : Zr(!1, Vr, "confirm");
    } else
      wr(Hn);
  };
  return /* @__PURE__ */ reactExports.createElement(PanelContext.Provider, {
    value: {
      operationRef: vr,
      hideHeader: vt === "time",
      onDateMouseEnter: zt,
      onDateMouseLeave: dr,
      hideRanges: !0,
      onSelect: gu,
      open: zr
    }
  }, /* @__PURE__ */ reactExports.createElement(PickerTrigger, {
    visible: zr,
    popupElement: uu,
    popupStyle: st,
    prefixCls: nt,
    dropdownClassName: lt,
    dropdownAlign: it,
    getPopupContainer: ut,
    transitionName: et,
    range: !0,
    direction: Xt
  }, /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    ref: pr,
    className: classnames(nt, "".concat(nt, "-range"), rt, (s = {}, _defineProperty$c(s, "".concat(nt, "-disabled"), xr[0] && xr[1]), _defineProperty$c(s, "".concat(nt, "-focused"), Vr === 0 ? _i : jn), _defineProperty$c(s, "".concat(nt, "-rtl"), Xt === "rtl"), s)),
    style: ot,
    onClick: po,
    onMouseEnter: Kt,
    onMouseLeave: nr,
    onMouseDown: ho,
    onMouseUp: Yt
  }, pickAttrs(a, {
    aria: !0,
    data: !0
  })), /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(nt, "-input"), ($ = {}, _defineProperty$c($, "".concat(nt, "-input-active"), Vr === 0), _defineProperty$c($, "".concat(nt, "-input-placeholder"), !!Rn), $)),
    ref: Er
  }, /* @__PURE__ */ reactExports.createElement("input", _extends$2({
    id: at,
    disabled: xr[0],
    readOnly: Tt || typeof Ir[0] == "function" || !Dn,
    value: Rn || zn,
    onChange: function(Tn) {
      Zn(Tn.target.value);
    },
    autoFocus: gt,
    placeholder: getValue$2(dt, 0) || "",
    ref: Ar
  }, Vn, gl, {
    autoComplete: er
  }))), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(nt, "-range-separator"),
    ref: gr
  }, Et), /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(nt, "-input"), (_ = {}, _defineProperty$c(_, "".concat(nt, "-input-active"), Vr === 1), _defineProperty$c(_, "".concat(nt, "-input-placeholder"), !!Eo), _)),
    ref: br
  }, /* @__PURE__ */ reactExports.createElement("input", _extends$2({
    disabled: xr[1],
    readOnly: Tt || typeof Ir[0] == "function" || !In,
    value: Eo || Wn,
    onChange: function(Tn) {
      ca(Tn.target.value);
    },
    placeholder: getValue$2(dt, 1) || "",
    ref: Sr
  }, fo, gl, {
    autoComplete: er
  }))), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(nt, "-active-bar"),
    style: _objectSpread2$a(_objectSpread2$a({}, pu), {}, {
      width: xs,
      position: "absolute"
    })
  }), pl, hu && fu)));
}
var RangePicker$2 = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $() {
    var _;
    _classCallCheck(this, $);
    for (var _e = arguments.length, tt = new Array(_e), nt = 0; nt < _e; nt++)
      tt[nt] = arguments[nt];
    return _ = s.call.apply(s, [this].concat(tt)), _defineProperty$c(_assertThisInitialized(_), "pickerRef", /* @__PURE__ */ reactExports.createRef()), _defineProperty$c(_assertThisInitialized(_), "focus", function() {
      _.pickerRef.current && _.pickerRef.current.focus();
    }), _defineProperty$c(_assertThisInitialized(_), "blur", function() {
      _.pickerRef.current && _.pickerRef.current.blur();
    }), _;
  }
  return _createClass($, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ reactExports.createElement(InnerRangePicker, _extends$2({}, this.props, {
        pickerRef: this.pickerRef
      }));
    }
  }]), $;
}(reactExports.Component);
const RadioGroupContext = /* @__PURE__ */ reactExports.createContext(null), RadioGroupContextProvider = RadioGroupContext.Provider, RadioOptionTypeContext = /* @__PURE__ */ reactExports.createContext(null), RadioOptionTypeContextProvider = RadioOptionTypeContext.Provider;
var _excluded$w = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"], Checkbox$3 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _ = a.prefixCls, _e = _ === void 0 ? "rc-checkbox" : _, tt = a.className, nt = a.style, at = a.checked, ot = a.disabled, rt = a.defaultChecked, st = rt === void 0 ? !1 : rt, lt = a.type, et = lt === void 0 ? "checkbox" : lt, it = a.title, ut = a.onChange, ft = _objectWithoutProperties$1(a, _excluded$w), ht = reactExports.useRef(null), dt = useMergedState(st, {
    value: at
  }), gt = _slicedToArray$e(dt, 2), pt = gt[0], mt = gt[1];
  reactExports.useImperativeHandle(s, function() {
    return {
      focus: function() {
        var xt;
        (xt = ht.current) === null || xt === void 0 || xt.focus();
      },
      blur: function() {
        var xt;
        (xt = ht.current) === null || xt === void 0 || xt.blur();
      },
      input: ht.current
    };
  });
  var ct = classnames(_e, tt, ($ = {}, _defineProperty$c($, "".concat(_e, "-checked"), pt), _defineProperty$c($, "".concat(_e, "-disabled"), ot), $)), vt = function(xt) {
    ot || ("checked" in a || mt(xt.target.checked), ut == null || ut({
      target: _objectSpread2$a(_objectSpread2$a({}, a), {}, {
        type: et,
        checked: xt.target.checked
      }),
      stopPropagation: function() {
        xt.stopPropagation();
      },
      preventDefault: function() {
        xt.preventDefault();
      },
      nativeEvent: xt.nativeEvent
    }));
  };
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: ct,
    title: it,
    style: nt
  }, /* @__PURE__ */ reactExports.createElement("input", _extends$2({}, ft, {
    className: "".concat(_e, "-input"),
    ref: ht,
    onChange: vt,
    disabled: ot,
    checked: !!pt,
    type: et
  })), /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(_e, "-inner")
  }));
});
const getGroupRadioStyle = (a) => {
  const {
    componentCls: s,
    antCls: $
  } = a, _ = `${s}-group`;
  return {
    [_]: Object.assign(Object.assign({}, resetComponent(a)), {
      display: "inline-block",
      fontSize: 0,
      // RTL
      [`&${_}-rtl`]: {
        direction: "rtl"
      },
      [`${$}-badge ${$}-badge-count`]: {
        zIndex: 1
      },
      [`> ${$}-badge:not(:first-child) > ${$}-button-wrapper`]: {
        borderInlineStart: "none"
      }
    })
  };
}, getRadioBasicStyle = (a) => {
  const {
    componentCls: s,
    wrapperMarginInlineEnd: $,
    colorPrimary: _,
    radioSize: _e,
    motionDurationSlow: tt,
    motionDurationMid: nt,
    motionEaseInOutCirc: at,
    colorBgContainer: ot,
    colorBorder: rt,
    lineWidth: st,
    colorBgContainerDisabled: lt,
    colorTextDisabled: et,
    paddingXS: it,
    dotColorDisabled: ut,
    lineType: ft,
    radioColor: ht,
    radioBgColor: dt,
    calc: gt
  } = a, pt = `${s}-inner`, mt = 4, ct = gt(_e).sub(gt(mt).mul(2)), vt = gt(1).mul(_e).equal();
  return {
    [`${s}-wrapper`]: Object.assign(Object.assign({}, resetComponent(a)), {
      display: "inline-flex",
      alignItems: "baseline",
      marginInlineStart: 0,
      marginInlineEnd: $,
      cursor: "pointer",
      // RTL
      [`&${s}-wrapper-rtl`]: {
        direction: "rtl"
      },
      "&-disabled": {
        cursor: "not-allowed",
        color: a.colorTextDisabled
      },
      "&::after": {
        display: "inline-block",
        width: 0,
        overflow: "hidden",
        content: '"\\a0"'
      },
      // hashId 在 wrapper 上，只能铺平
      [`${s}-checked::after`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%",
        border: `${unit$1(st)} ${ft} ${_}`,
        borderRadius: "50%",
        visibility: "hidden",
        content: '""'
      },
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        position: "relative",
        display: "inline-block",
        outline: "none",
        cursor: "pointer",
        alignSelf: "center",
        borderRadius: "50%"
      }),
      [`${s}-wrapper:hover &,
        &:hover ${pt}`]: {
        borderColor: _
      },
      [`${s}-input:focus-visible + ${pt}`]: Object.assign({}, genFocusOutline(a)),
      [`${s}:hover::after, ${s}-wrapper:hover &::after`]: {
        visibility: "visible"
      },
      [`${s}-inner`]: {
        "&::after": {
          boxSizing: "border-box",
          position: "absolute",
          insetBlockStart: "50%",
          insetInlineStart: "50%",
          display: "block",
          width: vt,
          height: vt,
          marginBlockStart: gt(1).mul(_e).div(-2).equal(),
          marginInlineStart: gt(1).mul(_e).div(-2).equal(),
          backgroundColor: ht,
          borderBlockStart: 0,
          borderInlineStart: 0,
          borderRadius: vt,
          transform: "scale(0)",
          opacity: 0,
          transition: `all ${tt} ${at}`,
          content: '""'
        },
        boxSizing: "border-box",
        position: "relative",
        insetBlockStart: 0,
        insetInlineStart: 0,
        display: "block",
        width: vt,
        height: vt,
        backgroundColor: ot,
        borderColor: rt,
        borderStyle: "solid",
        borderWidth: st,
        borderRadius: "50%",
        transition: `all ${nt}`
      },
      [`${s}-input`]: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        cursor: "pointer",
        opacity: 0
      },
      // 选中状态
      [`${s}-checked`]: {
        [pt]: {
          borderColor: _,
          backgroundColor: dt,
          "&::after": {
            transform: `scale(${a.calc(a.dotSize).div(_e).equal()})`,
            opacity: 1,
            transition: `all ${tt} ${at}`
          }
        }
      },
      [`${s}-disabled`]: {
        cursor: "not-allowed",
        [pt]: {
          backgroundColor: lt,
          borderColor: rt,
          cursor: "not-allowed",
          "&::after": {
            backgroundColor: ut
          }
        },
        [`${s}-input`]: {
          cursor: "not-allowed"
        },
        [`${s}-disabled + span`]: {
          color: et,
          cursor: "not-allowed"
        },
        [`&${s}-checked`]: {
          [pt]: {
            "&::after": {
              transform: `scale(${gt(ct).div(_e).equal({
                unit: !1
              })})`
            }
          }
        }
      },
      [`span${s} + *`]: {
        paddingInlineStart: it,
        paddingInlineEnd: it
      }
    })
  };
}, getRadioButtonStyle = (a) => {
  const {
    buttonColor: s,
    controlHeight: $,
    componentCls: _,
    lineWidth: _e,
    lineType: tt,
    colorBorder: nt,
    motionDurationSlow: at,
    motionDurationMid: ot,
    buttonPaddingInline: rt,
    fontSize: st,
    buttonBg: lt,
    fontSizeLG: et,
    controlHeightLG: it,
    controlHeightSM: ut,
    paddingXS: ft,
    borderRadius: ht,
    borderRadiusSM: dt,
    borderRadiusLG: gt,
    buttonCheckedBg: pt,
    buttonSolidCheckedColor: mt,
    colorTextDisabled: ct,
    colorBgContainerDisabled: vt,
    buttonCheckedBgDisabled: At,
    buttonCheckedColorDisabled: xt,
    colorPrimary: bt,
    colorPrimaryHover: Et,
    colorPrimaryActive: St,
    buttonSolidCheckedBg: Bt,
    buttonSolidCheckedHoverBg: Ot,
    buttonSolidCheckedActiveBg: Pt,
    calc: wt
  } = a;
  return {
    [`${_}-button-wrapper`]: {
      position: "relative",
      display: "inline-block",
      height: $,
      margin: 0,
      paddingInline: rt,
      paddingBlock: 0,
      color: s,
      fontSize: st,
      lineHeight: unit$1(wt($).sub(wt(_e).mul(2)).equal()),
      background: lt,
      border: `${unit$1(_e)} ${tt} ${nt}`,
      // strange align fix for chrome but works
      // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
      borderBlockStartWidth: wt(_e).add(0.02).equal(),
      borderInlineStartWidth: 0,
      borderInlineEndWidth: _e,
      cursor: "pointer",
      transition: [`color ${ot}`, `background ${ot}`, `box-shadow ${ot}`].join(","),
      a: {
        color: s
      },
      [`> ${_}-button`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        zIndex: -1,
        width: "100%",
        height: "100%"
      },
      "&:not(:first-child)": {
        "&::before": {
          position: "absolute",
          insetBlockStart: wt(_e).mul(-1).equal(),
          insetInlineStart: wt(_e).mul(-1).equal(),
          display: "block",
          boxSizing: "content-box",
          width: 1,
          height: "100%",
          paddingBlock: _e,
          paddingInline: 0,
          backgroundColor: nt,
          transition: `background-color ${at}`,
          content: '""'
        }
      },
      "&:first-child": {
        borderInlineStart: `${unit$1(_e)} ${tt} ${nt}`,
        borderStartStartRadius: ht,
        borderEndStartRadius: ht
      },
      "&:last-child": {
        borderStartEndRadius: ht,
        borderEndEndRadius: ht
      },
      "&:first-child:last-child": {
        borderRadius: ht
      },
      [`${_}-group-large &`]: {
        height: it,
        fontSize: et,
        lineHeight: unit$1(wt(it).sub(wt(_e).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: gt,
          borderEndStartRadius: gt
        },
        "&:last-child": {
          borderStartEndRadius: gt,
          borderEndEndRadius: gt
        }
      },
      [`${_}-group-small &`]: {
        height: ut,
        paddingInline: wt(ft).sub(_e).equal(),
        paddingBlock: 0,
        lineHeight: unit$1(wt(ut).sub(wt(_e).mul(2)).equal()),
        "&:first-child": {
          borderStartStartRadius: dt,
          borderEndStartRadius: dt
        },
        "&:last-child": {
          borderStartEndRadius: dt,
          borderEndEndRadius: dt
        }
      },
      "&:hover": {
        position: "relative",
        color: bt
      },
      "&:has(:focus-visible)": Object.assign({}, genFocusOutline(a)),
      [`${_}-inner, input[type='checkbox'], input[type='radio']`]: {
        width: 0,
        height: 0,
        opacity: 0,
        pointerEvents: "none"
      },
      [`&-checked:not(${_}-button-wrapper-disabled)`]: {
        zIndex: 1,
        color: bt,
        background: pt,
        borderColor: bt,
        "&::before": {
          backgroundColor: bt
        },
        "&:first-child": {
          borderColor: bt
        },
        "&:hover": {
          color: Et,
          borderColor: Et,
          "&::before": {
            backgroundColor: Et
          }
        },
        "&:active": {
          color: St,
          borderColor: St,
          "&::before": {
            backgroundColor: St
          }
        }
      },
      [`${_}-group-solid &-checked:not(${_}-button-wrapper-disabled)`]: {
        color: mt,
        background: Bt,
        borderColor: Bt,
        "&:hover": {
          color: mt,
          background: Ot,
          borderColor: Ot
        },
        "&:active": {
          color: mt,
          background: Pt,
          borderColor: Pt
        }
      },
      "&-disabled": {
        color: ct,
        backgroundColor: vt,
        borderColor: nt,
        cursor: "not-allowed",
        "&:first-child, &:hover": {
          color: ct,
          backgroundColor: vt,
          borderColor: nt
        }
      },
      [`&-disabled${_}-button-wrapper-checked`]: {
        color: xt,
        backgroundColor: At,
        borderColor: nt,
        boxShadow: "none"
      }
    }
  };
}, prepareComponentToken$m = (a) => {
  const {
    wireframe: s,
    padding: $,
    marginXS: _,
    lineWidth: _e,
    fontSizeLG: tt,
    colorText: nt,
    colorBgContainer: at,
    colorTextDisabled: ot,
    controlItemBgActiveDisabled: rt,
    colorTextLightSolid: st,
    colorPrimary: lt,
    colorPrimaryHover: et,
    colorPrimaryActive: it,
    colorWhite: ut
  } = a, ft = 4, ht = tt, dt = s ? ht - ft * 2 : ht - (ft + _e) * 2;
  return {
    // Radio
    radioSize: ht,
    dotSize: dt,
    dotColorDisabled: ot,
    // Radio buttons
    buttonSolidCheckedColor: st,
    buttonSolidCheckedBg: lt,
    buttonSolidCheckedHoverBg: et,
    buttonSolidCheckedActiveBg: it,
    buttonBg: at,
    buttonCheckedBg: at,
    buttonColor: nt,
    buttonCheckedBgDisabled: rt,
    buttonCheckedColorDisabled: ot,
    buttonPaddingInline: $ - _e,
    wrapperMarginInlineEnd: _,
    // internal
    radioColor: s ? lt : ut,
    radioBgColor: s ? at : lt
  };
}, useStyle$o = genStyleHooks("Radio", (a) => {
  const {
    controlOutline: s,
    controlOutlineWidth: $
  } = a, _ = `0 0 0 ${unit$1($)} ${s}`, tt = merge(a, {
    radioFocusShadow: _,
    radioButtonFocusShadow: _
  });
  return [getGroupRadioStyle(tt), getRadioBasicStyle(tt), getRadioButtonStyle(tt)];
}, prepareComponentToken$m, {
  unitless: {
    radioSize: !0,
    dotSize: !0
  }
});
var __rest$O = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const InternalRadio = (a, s) => {
  var $, _;
  const _e = reactExports.useContext(RadioGroupContext), tt = reactExports.useContext(RadioOptionTypeContext), {
    getPrefixCls: nt,
    direction: at,
    radio: ot
  } = reactExports.useContext(ConfigContext$1), rt = reactExports.useRef(null), st = composeRef(s, rt), {
    isFormItemInput: lt
  } = reactExports.useContext(FormItemInputContext), et = (Ot) => {
    var Pt, wt;
    (Pt = a.onChange) === null || Pt === void 0 || Pt.call(a, Ot), (wt = _e == null ? void 0 : _e.onChange) === null || wt === void 0 || wt.call(_e, Ot);
  }, {
    prefixCls: it,
    className: ut,
    rootClassName: ft,
    children: ht,
    style: dt
  } = a, gt = __rest$O(a, ["prefixCls", "className", "rootClassName", "children", "style"]), pt = nt("radio", it), mt = ((_e == null ? void 0 : _e.optionType) || tt) === "button", ct = mt ? `${pt}-button` : pt, vt = useCSSVarCls$1(pt), [At, xt, bt] = useStyle$o(pt, vt), Et = Object.assign({}, gt), St = reactExports.useContext(DisabledContext$1);
  _e && (Et.name = _e.name, Et.onChange = et, Et.checked = a.value === _e.value, Et.disabled = ($ = Et.disabled) !== null && $ !== void 0 ? $ : _e.disabled), Et.disabled = (_ = Et.disabled) !== null && _ !== void 0 ? _ : St;
  const Bt = classnames(`${ct}-wrapper`, {
    [`${ct}-wrapper-checked`]: Et.checked,
    [`${ct}-wrapper-disabled`]: Et.disabled,
    [`${ct}-wrapper-rtl`]: at === "rtl",
    [`${ct}-wrapper-in-form-item`]: lt
  }, ot == null ? void 0 : ot.className, ut, ft, xt, bt, vt);
  return At(/* @__PURE__ */ reactExports.createElement(Wave$1, {
    component: "Radio",
    disabled: Et.disabled
  }, /* @__PURE__ */ reactExports.createElement("label", {
    className: Bt,
    style: Object.assign(Object.assign({}, ot == null ? void 0 : ot.style), dt),
    onMouseEnter: a.onMouseEnter,
    onMouseLeave: a.onMouseLeave
  }, /* @__PURE__ */ reactExports.createElement(Checkbox$3, Object.assign({}, Et, {
    className: classnames(Et.className, !mt && TARGET_CLS),
    type: "radio",
    prefixCls: ct,
    ref: st
  })), ht !== void 0 ? /* @__PURE__ */ reactExports.createElement("span", null, ht) : null)));
}, Radio$2 = /* @__PURE__ */ reactExports.forwardRef(InternalRadio), InternalRadio$1 = Radio$2, RadioGroup = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    getPrefixCls: $,
    direction: _
  } = reactExports.useContext(ConfigContext$1), [_e, tt] = useMergedState(a.defaultValue, {
    value: a.value
  }), nt = (Pt) => {
    const wt = _e, Ct = Pt.target.value;
    "value" in a || tt(Ct);
    const {
      onChange: It
    } = a;
    It && Ct !== wt && It(Pt);
  }, {
    prefixCls: at,
    className: ot,
    rootClassName: rt,
    options: st,
    buttonStyle: lt = "outline",
    disabled: et,
    children: it,
    size: ut,
    style: ft,
    id: ht,
    onMouseEnter: dt,
    onMouseLeave: gt,
    onFocus: pt,
    onBlur: mt
  } = a, ct = $("radio", at), vt = `${ct}-group`, At = useCSSVarCls$1(ct), [xt, bt, Et] = useStyle$o(ct, At);
  let St = it;
  st && st.length > 0 && (St = st.map((Pt) => typeof Pt == "string" || typeof Pt == "number" ? /* @__PURE__ */ reactExports.createElement(InternalRadio$1, {
    key: Pt.toString(),
    prefixCls: ct,
    disabled: et,
    value: Pt,
    checked: _e === Pt
  }, Pt) : /* @__PURE__ */ reactExports.createElement(InternalRadio$1, {
    key: `radio-group-value-options-${Pt.value}`,
    prefixCls: ct,
    disabled: Pt.disabled || et,
    value: Pt.value,
    checked: _e === Pt.value,
    title: Pt.title,
    style: Pt.style,
    id: Pt.id,
    required: Pt.required
  }, Pt.label)));
  const Bt = useSize$1(ut), Ot = classnames(vt, `${vt}-${lt}`, {
    [`${vt}-${Bt}`]: Bt,
    [`${vt}-rtl`]: _ === "rtl"
  }, ot, rt, bt, Et, At);
  return xt(/* @__PURE__ */ reactExports.createElement("div", Object.assign({}, pickAttrs(a, {
    aria: !0,
    data: !0
  }), {
    className: Ot,
    style: ft,
    onMouseEnter: dt,
    onMouseLeave: gt,
    onFocus: pt,
    onBlur: mt,
    id: ht,
    ref: s
  }), /* @__PURE__ */ reactExports.createElement(RadioGroupContextProvider, {
    value: {
      onChange: nt,
      value: _e,
      disabled: a.disabled,
      name: a.name,
      optionType: a.optionType
    }
  }, St)));
}), Group$4 = /* @__PURE__ */ reactExports.memo(RadioGroup);
var __rest$N = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const RadioButton = (a, s) => {
  const {
    getPrefixCls: $
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: _
  } = a, _e = __rest$N(a, ["prefixCls"]), tt = $("radio", _);
  return /* @__PURE__ */ reactExports.createElement(RadioOptionTypeContextProvider, {
    value: "button"
  }, /* @__PURE__ */ reactExports.createElement(InternalRadio$1, Object.assign({
    prefixCls: tt
  }, _e, {
    type: "radio",
    ref: s
  })));
}, Button = /* @__PURE__ */ reactExports.forwardRef(RadioButton), Radio$1 = InternalRadio$1;
Radio$1.Button = Button;
Radio$1.Group = Group$4;
Radio$1.__ANT_RADIO = !0;
const _Radio = Radio$1, genPlaceholderStyle = (a) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: a,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), genHoverStyle = (a) => ({
  borderColor: a.hoverBorderColor,
  backgroundColor: a.hoverBg
}), genActiveStyle = (a) => ({
  borderColor: a.activeBorderColor,
  boxShadow: a.activeShadow,
  outline: 0,
  backgroundColor: a.activeBg
}), genDisabledStyle = (a) => ({
  color: a.colorTextDisabled,
  backgroundColor: a.colorBgContainerDisabled,
  borderColor: a.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "&:hover:not([disabled])": Object.assign({}, genHoverStyle(merge(a, {
    hoverBorderColor: a.colorBorder,
    hoverBg: a.colorBgContainerDisabled
  })))
}), genInputLargeStyle = (a) => {
  const {
    paddingBlockLG: s,
    fontSizeLG: $,
    lineHeightLG: _,
    borderRadiusLG: _e,
    paddingInlineLG: tt
  } = a;
  return {
    padding: `${unit$1(s)} ${unit$1(tt)}`,
    fontSize: $,
    lineHeight: _,
    borderRadius: _e
  };
}, genInputSmallStyle = (a) => ({
  padding: `${unit$1(a.paddingBlockSM)} ${unit$1(a.paddingInlineSM)}`,
  borderRadius: a.borderRadiusSM
}), genStatusStyle = (a, s) => {
  const {
    componentCls: $,
    colorError: _,
    colorWarning: _e,
    errorActiveShadow: tt,
    warningActiveShadow: nt,
    colorErrorBorderHover: at,
    colorWarningBorderHover: ot
  } = a;
  return {
    [`&-status-error:not(${s}-disabled):not(${s}-borderless)${s}`]: {
      borderColor: _,
      "&:hover": {
        borderColor: at
      },
      "&:focus, &:focus-within": Object.assign({}, genActiveStyle(merge(a, {
        activeBorderColor: _,
        activeShadow: tt
      }))),
      [`${$}-prefix, ${$}-suffix`]: {
        color: _
      }
    },
    [`&-status-warning:not(${s}-disabled):not(${s}-borderless)${s}`]: {
      borderColor: _e,
      "&:hover": {
        borderColor: ot
      },
      "&:focus, &:focus-within": Object.assign({}, genActiveStyle(merge(a, {
        activeBorderColor: _e,
        activeShadow: nt
      }))),
      [`${$}-prefix, ${$}-suffix`]: {
        color: _e
      }
    }
  };
}, genBasicInputStyle = (a) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${unit$1(a.paddingBlock)} ${unit$1(a.paddingInline)}`,
  color: a.colorText,
  fontSize: a.fontSize,
  lineHeight: a.lineHeight,
  backgroundColor: a.colorBgContainer,
  backgroundImage: "none",
  borderWidth: a.lineWidth,
  borderStyle: a.lineType,
  borderColor: a.colorBorder,
  borderRadius: a.borderRadius,
  transition: `all ${a.motionDurationMid}`
}, genPlaceholderStyle(a.colorTextPlaceholder)), {
  "&:hover": Object.assign({}, genHoverStyle(a)),
  "&:focus, &:focus-within": Object.assign({}, genActiveStyle(a)),
  "&-disabled, &[disabled]": Object.assign({}, genDisabledStyle(a)),
  "&-borderless": {
    "&, &:hover, &:focus, &-focused, &-disabled, &[disabled]": {
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none"
    }
  },
  // Reset height for `textarea`s
  "textarea&": {
    maxWidth: "100%",
    // prevent textarea resize from coming out of its container
    height: "auto",
    minHeight: a.controlHeight,
    lineHeight: a.lineHeight,
    verticalAlign: "bottom",
    transition: `all ${a.motionDurationSlow}, height 0s`,
    resize: "vertical"
  },
  // Size
  "&-lg": Object.assign({}, genInputLargeStyle(a)),
  "&-sm": Object.assign({}, genInputSmallStyle(a)),
  // RTL
  "&-rtl": {
    direction: "rtl"
  },
  "&-textarea-rtl": {
    direction: "rtl"
  }
}), genInputGroupStyle = (a) => {
  const {
    componentCls: s,
    antCls: $
  } = a;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: a.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${s}, &-lg > ${s}-group-addon`]: Object.assign({}, genInputLargeStyle(a)),
    [`&-sm ${s}, &-sm > ${s}-group-addon`]: Object.assign({}, genInputSmallStyle(a)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${$}-select-single ${$}-select-selector`]: {
      height: a.controlHeightLG
    },
    [`&-sm ${$}-select-single ${$}-select-selector`]: {
      height: a.controlHeightSM
    },
    [`> ${s}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${s}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${unit$1(a.paddingInline)}`,
        color: a.colorText,
        fontWeight: "normal",
        fontSize: a.fontSize,
        textAlign: "center",
        backgroundColor: a.addonBg,
        border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
        borderRadius: a.borderRadius,
        transition: `all ${a.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${$}-select`]: {
          margin: `${unit$1(a.calc(a.paddingBlock).add(1).mul(-1).equal())} ${unit$1(a.calc(a.paddingInline).mul(-1).equal())}`,
          [`&${$}-select-single:not(${$}-select-customize-input):not(${$}-pagination-size-changer)`]: {
            [`${$}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${unit$1(a.lineWidth)} ${a.lineType} transparent`,
              boxShadow: "none"
            }
          },
          "&-open, &-focused": {
            [`${$}-select-selector`]: {
              color: a.colorPrimary
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${$}-cascader-picker`]: {
          margin: `-9px ${unit$1(a.calc(a.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${$}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    },
    [`${s}`]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${s}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${s}:first-child, ${s}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${$}-select ${$}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${s}-affix-wrapper`]: {
      [`&:not(:first-child) ${s}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${s}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${s}:last-child, ${s}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${$}-select ${$}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${s}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${s}-search &`]: {
          borderStartStartRadius: a.borderRadius,
          borderEndStartRadius: a.borderRadius
        }
      },
      [`&:not(:first-child), ${s}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${s}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, clearFix()), {
      [`${s}-group-addon, ${s}-group-wrap, > ${s}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: a.lineWidth,
          "&:hover": {
            zIndex: 1
          },
          "&:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-block",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${s}-affix-wrapper,
        & > ${s}-number-affix-wrapper,
        & > ${$}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: a.calc(a.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: a.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [`${s}`]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${$}-select > ${$}-select-selector,
      & > ${$}-select-auto-complete ${s},
      & > ${$}-cascader-picker ${s},
      & > ${s}-group-wrapper ${s}`]: {
        borderInlineEndWidth: a.lineWidth,
        borderRadius: 0,
        "&:hover": {
          zIndex: 1
        },
        "&:focus": {
          zIndex: 1
        }
      },
      [`& > ${$}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${$}-select > ${$}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${$}-select:first-child > ${$}-select-selector,
      & > ${$}-select-auto-complete:first-child ${s},
      & > ${$}-cascader-picker:first-child ${s}`]: {
        borderStartStartRadius: a.borderRadius,
        borderEndStartRadius: a.borderRadius
      },
      [`& > *:last-child,
      & > ${$}-select:last-child > ${$}-select-selector,
      & > ${$}-cascader-picker:last-child ${s},
      & > ${$}-cascader-picker-focused:last-child ${s}`]: {
        borderInlineEndWidth: a.lineWidth,
        borderStartEndRadius: a.borderRadius,
        borderEndEndRadius: a.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${$}-select-auto-complete ${s}`]: {
        verticalAlign: "top"
      },
      [`${s}-group-wrapper + ${s}-group-wrapper`]: {
        marginInlineStart: a.calc(a.lineWidth).mul(-1).equal(),
        [`${s}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${s}-group-wrapper:not(:last-child)`]: {
        [`&${s}-search > ${s}-group`]: {
          [`& > ${s}-group-addon > ${s}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${s}`]: {
            borderStartStartRadius: a.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: a.borderRadius
          }
        }
      }
    })
  };
}, genInputStyle = (a) => {
  const {
    componentCls: s,
    controlHeightSM: $,
    lineWidth: _,
    calc: _e
  } = a, tt = 16, nt = _e($).sub(_e(_).mul(2)).sub(tt).div(2).equal();
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genBasicInputStyle(a)), genStatusStyle(a, s)), {
      '&[type="color"]': {
        height: a.controlHeight,
        [`&${s}-lg`]: {
          height: a.controlHeightLG
        },
        [`&${s}-sm`]: {
          height: $,
          paddingTop: nt,
          paddingBottom: nt
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        "-webkit-appearance": "none"
      }
    })
  };
}, genAllowClearStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    // ========================= Input =========================
    [`${s}-clear-icon`]: {
      margin: 0,
      color: a.colorTextQuaternary,
      fontSize: a.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${a.motionDurationSlow}`,
      "&:hover": {
        color: a.colorTextTertiary
      },
      "&:active": {
        color: a.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${unit$1(a.inputAffixPadding)}`
      }
    }
  };
}, genAffixStyle = (a) => {
  const {
    componentCls: s,
    inputAffixPadding: $,
    colorTextDescription: _,
    motionDurationSlow: _e,
    colorIcon: tt,
    colorIconHover: nt,
    iconCls: at
  } = a;
  return {
    [`${s}-affix-wrapper`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(a)), {
      display: "inline-flex",
      [`&:not(${s}-affix-wrapper-disabled):hover`]: {
        zIndex: 1,
        [`${s}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      "&-disabled": {
        [`${s}[disabled]`]: {
          background: "transparent"
        }
      },
      [`> input${s}`]: {
        padding: 0,
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${s}`]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: a.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: _
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: a.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: $
        },
        "&-suffix": {
          marginInlineStart: $
        }
      }
    }), genAllowClearStyle(a)), {
      // password
      [`${at}${s}-password-icon`]: {
        color: tt,
        cursor: "pointer",
        transition: `all ${_e}`,
        "&:hover": {
          color: nt
        }
      }
    }), genStatusStyle(a, `${s}-affix-wrapper`))
  };
}, genGroupStyle = (a) => {
  const {
    componentCls: s,
    colorError: $,
    colorWarning: _,
    borderRadiusLG: _e,
    borderRadiusSM: tt
  } = a;
  return {
    [`${s}-group`]: Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genInputGroupStyle(a)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": {
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design/issues/6403
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${s}-group-addon`]: {
            borderRadius: _e,
            fontSize: a.fontSizeLG
          }
        },
        "&-sm": {
          [`${s}-group-addon`]: {
            borderRadius: tt
          }
        },
        // Status
        "&-status-error": {
          [`${s}-group-addon`]: {
            color: $,
            borderColor: $
          }
        },
        "&-status-warning": {
          [`${s}-group-addon`]: {
            color: _,
            borderColor: _
          }
        },
        "&-disabled": {
          [`${s}-group-addon`]: Object.assign({}, genDisabledStyle(a))
        },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${s}-compact-first-item):not(${s}-compact-last-item)${s}-compact-item`]: {
          [`${s}, ${s}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${s}-compact-last-item)${s}-compact-first-item`]: {
          [`${s}, ${s}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${s}-compact-first-item)${s}-compact-last-item`]: {
          [`${s}, ${s}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        }
      }
    })
  };
}, genSearchInputStyle = (a) => {
  const {
    componentCls: s,
    antCls: $
  } = a, _ = `${s}-search`;
  return {
    [_]: {
      [`${s}`]: {
        "&:hover, &:focus": {
          borderColor: a.colorPrimaryHover,
          [`+ ${s}-group-addon ${_}-button:not(${$}-btn-primary)`]: {
            borderInlineStartColor: a.colorPrimaryHover
          }
        }
      },
      [`${s}-affix-wrapper`]: {
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
      [`${s}-lg`]: {
        lineHeight: a.calc(a.lineHeightLG).sub(2e-4).equal({
          unit: !1
        })
      },
      [`> ${s}-group`]: {
        [`> ${s}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${_}-button`]: {
            paddingTop: 0,
            paddingBottom: 0,
            borderStartStartRadius: 0,
            borderStartEndRadius: a.borderRadius,
            borderEndEndRadius: a.borderRadius,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${_}-button:not(${$}-btn-primary)`]: {
            color: a.colorTextDescription,
            "&:hover": {
              color: a.colorPrimaryHover
            },
            "&:active": {
              color: a.colorPrimaryActive
            },
            [`&${$}-btn-loading::before`]: {
              insetInlineStart: 0,
              insetInlineEnd: 0,
              insetBlockStart: 0,
              insetBlockEnd: 0
            }
          }
        }
      },
      [`${_}-button`]: {
        height: a.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`&-large ${_}-button`]: {
        height: a.controlHeightLG
      },
      [`&-small ${_}-button`]: {
        height: a.controlHeightSM
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${s}-compact-item`]: {
        [`&:not(${s}-compact-last-item)`]: {
          [`${s}-group-addon`]: {
            [`${s}-search-button`]: {
              marginInlineEnd: a.calc(a.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${s}-compact-first-item)`]: {
          [`${s},${s}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${s}-group-addon ${s}-search-button,
        > ${s},
        ${s}-affix-wrapper`]: {
          "&:hover,&:focus,&:active": {
            zIndex: 2
          }
        },
        [`> ${s}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, genTextAreaStyle = (a) => {
  const {
    componentCls: s,
    paddingLG: $
  } = a, _ = `${s}-textarea`;
  return {
    [_]: {
      position: "relative",
      "&-show-count": {
        // https://github.com/ant-design/ant-design/issues/33049
        [`> ${s}`]: {
          height: "100%"
        },
        [`${s}-data-count`]: {
          position: "absolute",
          bottom: a.calc(a.fontSize).mul(a.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: a.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      "&-allow-clear": {
        [`> ${s}`]: {
          paddingInlineEnd: $
        }
      },
      [`&-affix-wrapper${_}-has-feedback`]: {
        [`${s}`]: {
          paddingInlineEnd: $
        }
      },
      [`&-affix-wrapper${s}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${s}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${s}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${s}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: a.paddingXS,
            insetBlockStart: a.paddingXS
          },
          // Feedback Icon
          [`${_}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: a.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      }
    }
  };
}, genRangeStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-out-of-range`]: {
      [`&, & input, & textarea, ${s}-show-count-suffix, ${s}-data-count`]: {
        color: a.colorError
      }
    }
  };
};
function initInputToken(a) {
  return merge(a, {
    inputAffixPadding: a.paddingXXS
  });
}
const initComponentToken$1 = (a) => {
  const {
    controlHeight: s,
    fontSize: $,
    lineHeight: _,
    lineWidth: _e,
    controlHeightSM: tt,
    controlHeightLG: nt,
    fontSizeLG: at,
    lineHeightLG: ot,
    paddingSM: rt,
    controlPaddingHorizontalSM: st,
    controlPaddingHorizontal: lt,
    colorFillAlter: et,
    colorPrimaryHover: it,
    colorPrimary: ut,
    controlOutlineWidth: ft,
    controlOutline: ht,
    colorErrorOutline: dt,
    colorWarningOutline: gt
  } = a;
  return {
    paddingBlock: Math.max(Math.round((s - $ * _) / 2 * 10) / 10 - _e, 0),
    paddingBlockSM: Math.max(Math.round((tt - $ * _) / 2 * 10) / 10 - _e, 0),
    paddingBlockLG: Math.ceil((nt - at * ot) / 2 * 10) / 10 - _e,
    paddingInline: rt - _e,
    paddingInlineSM: st - _e,
    paddingInlineLG: lt - _e,
    addonBg: et,
    activeBorderColor: ut,
    hoverBorderColor: it,
    activeShadow: `0 0 0 ${ft}px ${ht}`,
    errorActiveShadow: `0 0 0 ${ft}px ${dt}`,
    warningActiveShadow: `0 0 0 ${ft}px ${gt}`,
    hoverBg: "",
    activeBg: ""
  };
}, useStyle$n = genStyleHooks("Input", (a) => {
  const s = merge(a, initInputToken(a));
  return [
    genInputStyle(s),
    genTextAreaStyle(s),
    genAffixStyle(s),
    genGroupStyle(s),
    genSearchInputStyle(s),
    genRangeStyle(s),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(s)
  ];
}, initComponentToken$1), genPikerPadding = (a, s, $, _) => {
  const _e = a.calc($).add(2).equal(), tt = a.max(a.calc(s).sub(_e).div(2).equal(), 0), nt = a.max(a.calc(s).sub(_e).sub(tt).equal(), 0);
  return {
    padding: `${unit$1(tt)} ${unit$1(_)} ${unit$1(nt)}`
  };
}, genPickerCellInnerStyle = (a) => {
  const {
    componentCls: s,
    pickerCellCls: $,
    pickerCellInnerCls: _,
    cellHeight: _e,
    motionDurationSlow: tt,
    borderRadiusSM: nt,
    motionDurationMid: at,
    cellHoverBg: ot,
    lineWidth: rt,
    lineType: st,
    colorPrimary: lt,
    cellActiveWithRangeBg: et,
    colorTextLightSolid: it,
    controlHeightSM: ut,
    cellRangeBorderColor: ft,
    pickerCellBorderGap: ht,
    cellHoverWithRangeBg: dt,
    cellWidth: gt,
    colorTextDisabled: pt,
    cellBgDisabled: mt
  } = a;
  return {
    "&::before": {
      position: "absolute",
      top: "50%",
      insetInlineStart: 0,
      insetInlineEnd: 0,
      zIndex: 1,
      height: _e,
      transform: "translateY(-50%)",
      transition: `all ${tt}`,
      content: '""'
    },
    // >>> Default
    [_]: {
      position: "relative",
      zIndex: 2,
      display: "inline-block",
      minWidth: _e,
      height: _e,
      lineHeight: unit$1(_e),
      borderRadius: nt,
      transition: `background ${at}, border ${at}`
    },
    "&-range-hover-start, &-range-hover-end": {
      [_]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    // >>> Hover
    [`&:hover:not(${$}-in-view),
    &:hover:not(${$}-selected):not(${$}-range-start):not(${$}-range-end):not(${$}-range-hover-start):not(${$}-range-hover-end)`]: {
      [_]: {
        background: ot
      }
    },
    // >>> Today
    [`&-in-view${$}-today ${_}`]: {
      "&::before": {
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        zIndex: 1,
        border: `${unit$1(rt)} ${st} ${lt}`,
        borderRadius: nt,
        content: '""'
      }
    },
    // >>> In Range
    [`&-in-view${$}-in-range`]: {
      position: "relative",
      "&::before": {
        background: et
      }
    },
    // >>> Selected
    [`&-in-view${$}-selected ${_},
      &-in-view${$}-range-start ${_},
      &-in-view${$}-range-end ${_}`]: {
      color: it,
      background: lt
    },
    [`&-in-view${$}-range-start:not(${$}-range-start-single),
      &-in-view${$}-range-end:not(${$}-range-end-single)`]: {
      "&::before": {
        background: et
      }
    },
    [`&-in-view${$}-range-start::before`]: {
      insetInlineStart: "50%"
    },
    [`&-in-view${$}-range-end::before`]: {
      insetInlineEnd: "50%"
    },
    // >>> Range Hover
    [`&-in-view${$}-range-hover-start:not(${$}-in-range):not(${$}-range-start):not(${$}-range-end),
      &-in-view${$}-range-hover-end:not(${$}-in-range):not(${$}-range-start):not(${$}-range-end),
      &-in-view${$}-range-hover-start${$}-range-start-single,
      &-in-view${$}-range-hover-start${$}-range-start${$}-range-end${$}-range-end-near-hover,
      &-in-view${$}-range-hover-end${$}-range-start${$}-range-end${$}-range-start-near-hover,
      &-in-view${$}-range-hover-end${$}-range-end-single,
      &-in-view${$}-range-hover:not(${$}-in-range)`]: {
      "&::after": {
        position: "absolute",
        top: "50%",
        zIndex: 0,
        height: ut,
        borderTop: `${unit$1(rt)} dashed ${ft}`,
        borderBottom: `${unit$1(rt)} dashed ${ft}`,
        transform: "translateY(-50%)",
        transition: `all ${tt}`,
        content: '""'
      }
    },
    // Add space for stash
    "&-range-hover-start::after,\n      &-range-hover-end::after,\n      &-range-hover::after": {
      insetInlineEnd: 0,
      insetInlineStart: ht
    },
    // Hover with in range
    [`&-in-view${$}-in-range${$}-range-hover::before,
      &-in-view${$}-in-range${$}-range-hover-start::before,
      &-in-view${$}-in-range${$}-range-hover-end::before,
      &-in-view${$}-range-start${$}-range-hover::before,
      &-in-view${$}-range-end${$}-range-hover::before,
      &-in-view${$}-range-start:not(${$}-range-start-single)${$}-range-hover-start::before,
      &-in-view${$}-range-end:not(${$}-range-end-single)${$}-range-hover-end::before,
      ${s}-panel
      > :not(${s}-date-panel)
      &-in-view${$}-in-range${$}-range-hover-start::before,
      ${s}-panel
      > :not(${s}-date-panel)
      &-in-view${$}-in-range${$}-range-hover-end::before`]: {
      background: dt
    },
    // range start border-radius
    [`&-in-view${$}-range-start:not(${$}-range-start-single):not(${$}-range-end) ${_}`]: {
      borderStartStartRadius: nt,
      borderEndStartRadius: nt,
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    // range end border-radius
    [`&-in-view${$}-range-end:not(${$}-range-end-single):not(${$}-range-start) ${_}`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      borderStartEndRadius: nt,
      borderEndEndRadius: nt
    },
    [`&-range-hover${$}-range-end::after`]: {
      insetInlineStart: "50%"
    },
    // Edge start
    [`tr > &-in-view${$}-range-hover:first-child::after,
      tr > &-in-view${$}-range-hover-end:first-child::after,
      &-in-view${$}-start${$}-range-hover-edge-start${$}-range-hover-edge-start-near-range::after,
      &-in-view${$}-range-hover-edge-start:not(${$}-range-hover-edge-start-near-range)::after,
      &-in-view${$}-range-hover-start::after`]: {
      insetInlineStart: a.calc(gt).sub(_e).div(2).equal(),
      borderInlineStart: `${unit$1(rt)} dashed ${ft}`,
      borderStartStartRadius: nt,
      borderEndStartRadius: nt
    },
    // Edge end
    [`tr > &-in-view${$}-range-hover:last-child::after,
      tr > &-in-view${$}-range-hover-start:last-child::after,
      &-in-view${$}-end${$}-range-hover-edge-end${$}-range-hover-edge-end-near-range::after,
      &-in-view${$}-range-hover-edge-end:not(${$}-range-hover-edge-end-near-range)::after,
      &-in-view${$}-range-hover-end::after`]: {
      insetInlineEnd: a.calc(gt).sub(_e).div(2).equal(),
      borderInlineEnd: `${unit$1(rt)} dashed ${ft}`,
      borderStartEndRadius: nt,
      borderEndEndRadius: nt
    },
    // >>> Disabled
    "&-disabled": {
      color: pt,
      pointerEvents: "none",
      [_]: {
        background: "transparent"
      },
      "&::before": {
        background: mt
      }
    },
    [`&-disabled${$}-today ${_}::before`]: {
      borderColor: pt
    }
  };
}, genPanelStyle = (a) => {
  const {
    componentCls: s,
    pickerCellCls: $,
    pickerCellInnerCls: _,
    pickerYearMonthCellWidth: _e,
    pickerControlIconSize: tt,
    cellWidth: nt,
    paddingSM: at,
    paddingXS: ot,
    paddingXXS: rt,
    colorBgContainer: st,
    lineWidth: lt,
    lineType: et,
    borderRadiusLG: it,
    colorPrimary: ut,
    colorTextHeading: ft,
    colorSplit: ht,
    pickerControlIconBorderWidth: dt,
    colorIcon: gt,
    textHeight: pt,
    motionDurationMid: mt,
    colorIconHover: ct,
    fontWeightStrong: vt,
    cellHeight: At,
    pickerCellPaddingVertical: xt,
    colorTextDisabled: bt,
    colorText: Et,
    fontSize: St,
    cellHoverWithRangeBg: Bt,
    motionDurationSlow: Ot,
    withoutTimeCellHeight: Pt,
    pickerQuarterPanelContentHeight: wt,
    colorLink: Ct,
    colorLinkActive: It,
    colorLinkHover: yt,
    cellRangeBorderColor: Rt,
    borderRadiusSM: kt,
    colorTextLightSolid: jt,
    cellHoverBg: Ht,
    timeColumnHeight: Ft,
    timeColumnWidth: _t,
    timeCellHeight: Nt,
    controlItemBgActive: Mt,
    marginXXS: Lt,
    pickerDatePanelPaddingHorizontal: $t,
    pickerControlIconMargin: Tt
  } = a, Dt = a.calc(nt).mul(7).add(a.calc($t).mul(2)).equal(), Ut = a.calc(Dt).sub(a.calc(ot).mul(2)).div(3).sub(a.pickerYearMonthCellWidth).sub(at).equal(), Vt = a.calc(Dt).sub(a.calc(ot).mul(2)).div(4).sub(a.pickerYearMonthCellWidth).equal();
  return {
    [s]: {
      "&-panel": {
        display: "inline-flex",
        flexDirection: "column",
        textAlign: "center",
        background: st,
        border: `${unit$1(lt)} ${et} ${ht}`,
        borderRadius: it,
        outline: "none",
        "&-focused": {
          borderColor: ut
        },
        "&-rtl": {
          direction: "rtl",
          [`${s}-prev-icon,
              ${s}-super-prev-icon`]: {
            transform: "rotate(45deg)"
          },
          [`${s}-next-icon,
              ${s}-super-next-icon`]: {
            transform: "rotate(-135deg)"
          }
        }
      },
      // ========================================================
      // =                     Shared Panel                     =
      // ========================================================
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel,\n        &-week-panel,\n        &-date-panel,\n        &-time-panel": {
        display: "flex",
        flexDirection: "column",
        width: Dt
      },
      // ======================= Header =======================
      "&-header": {
        display: "flex",
        padding: `0 ${unit$1(ot)}`,
        color: ft,
        borderBottom: `${unit$1(lt)} ${et} ${ht}`,
        "> *": {
          flex: "none"
        },
        button: {
          padding: 0,
          color: gt,
          lineHeight: unit$1(pt),
          background: "transparent",
          border: 0,
          cursor: "pointer",
          transition: `color ${mt}`,
          fontSize: "inherit"
        },
        "> button": {
          minWidth: "1.6em",
          fontSize: St,
          "&:hover": {
            color: ct
          }
        },
        "&-view": {
          flex: "auto",
          fontWeight: vt,
          lineHeight: unit$1(pt),
          button: {
            color: "inherit",
            fontWeight: "inherit",
            verticalAlign: "top",
            "&:not(:first-child)": {
              marginInlineStart: ot
            },
            "&:hover": {
              color: ut
            }
          }
        }
      },
      // Arrow button
      "&-prev-icon,\n        &-next-icon,\n        &-super-prev-icon,\n        &-super-next-icon": {
        position: "relative",
        display: "inline-block",
        width: tt,
        height: tt,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          display: "inline-block",
          width: tt,
          height: tt,
          border: "0 solid currentcolor",
          borderBlockStartWidth: dt,
          borderBlockEndWidth: 0,
          borderInlineStartWidth: dt,
          borderInlineEndWidth: 0,
          content: '""'
        }
      },
      "&-super-prev-icon,\n        &-super-next-icon": {
        "&::after": {
          position: "absolute",
          top: Tt,
          insetInlineStart: Tt,
          display: "inline-block",
          width: tt,
          height: tt,
          border: "0 solid currentcolor",
          borderBlockStartWidth: dt,
          borderBlockEndWidth: 0,
          borderInlineStartWidth: dt,
          borderInlineEndWidth: 0,
          content: '""'
        }
      },
      "&-prev-icon,\n        &-super-prev-icon": {
        transform: "rotate(-45deg)"
      },
      "&-next-icon,\n        &-super-next-icon": {
        transform: "rotate(135deg)"
      },
      // ======================== Body ========================
      "&-content": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        "th, td": {
          position: "relative",
          minWidth: At,
          fontWeight: "normal"
        },
        th: {
          height: a.calc(At).add(a.calc(xt).mul(2)).equal(),
          color: Et,
          verticalAlign: "middle"
        }
      },
      "&-cell": Object.assign({
        padding: `${unit$1(xt)} 0`,
        color: bt,
        cursor: "pointer",
        // In view
        "&-in-view": {
          color: Et
        }
      }, genPickerCellInnerStyle(a)),
      // DatePanel only
      [`&-date-panel ${s}-cell-in-view${s}-cell-in-range${s}-cell-range-hover-start ${_},
        &-date-panel ${s}-cell-in-view${s}-cell-in-range${s}-cell-range-hover-end ${_}`]: {
        "&::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: -1,
          background: Bt,
          transition: `all ${Ot}`,
          content: '""'
        }
      },
      [`&-date-panel
        ${s}-cell-in-view${s}-cell-in-range${s}-cell-range-hover-start
        ${_}::after`]: {
        insetInlineEnd: a.calc(nt).sub(At).mul(-1).div(2).equal(),
        insetInlineStart: 0
      },
      [`&-date-panel ${s}-cell-in-view${s}-cell-in-range${s}-cell-range-hover-end ${_}::after`]: {
        insetInlineEnd: 0,
        insetInlineStart: a.calc(nt).sub(At).mul(-1).div(2).equal()
      },
      // Hover with range start & end
      [`&-range-hover${s}-range-start::after`]: {
        insetInlineEnd: "50%"
      },
      "&-decade-panel,\n        &-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${s}-content`]: {
          height: a.calc(Pt).mul(4).equal()
        },
        [_]: {
          padding: `0 ${unit$1(ot)}`
        }
      },
      "&-quarter-panel": {
        [`${s}-content`]: {
          height: wt
        },
        // Quarter Panel Special Style
        [`${s}-cell-range-hover-start::after`]: {
          insetInlineStart: Vt,
          borderInlineStart: `${unit$1(lt)} dashed ${Rt}`,
          [`${s}-panel-rtl &`]: {
            insetInlineEnd: Vt,
            borderInlineEnd: `${unit$1(lt)} dashed ${Rt}`
          }
        },
        [`${s}-cell-range-hover-end::after`]: {
          insetInlineEnd: Vt,
          borderInlineEnd: `${unit$1(lt)} dashed ${Rt}`,
          [`${s}-panel-rtl &`]: {
            insetInlineStart: Vt,
            borderInlineStart: `${unit$1(lt)} dashed ${Rt}`
          }
        }
      },
      // ======================== Footer ========================
      [`&-panel ${s}-footer`]: {
        borderTop: `${unit$1(lt)} ${et} ${ht}`
      },
      "&-footer": {
        width: "min-content",
        minWidth: "100%",
        lineHeight: unit$1(a.calc(pt).sub(a.calc(lt).mul(2)).equal()),
        textAlign: "center",
        "&-extra": {
          padding: `0 ${unit$1(at)}`,
          lineHeight: unit$1(a.calc(pt).sub(a.calc(lt).mul(2)).equal()),
          textAlign: "start",
          "&:not(:last-child)": {
            borderBottom: `${unit$1(lt)} ${et} ${ht}`
          }
        }
      },
      "&-now": {
        textAlign: "start"
      },
      "&-today-btn": {
        color: Ct,
        "&:hover": {
          color: yt
        },
        "&:active": {
          color: It
        },
        [`&${s}-today-btn-disabled`]: {
          color: bt,
          cursor: "not-allowed"
        }
      },
      // ========================================================
      // =                       Special                        =
      // ========================================================
      // ===================== Decade Panel =====================
      "&-decade-panel": {
        [_]: {
          padding: `0 ${unit$1(a.calc(ot).div(2).equal())}`
        },
        [`${s}-cell::before`]: {
          display: "none"
        }
      },
      // ============= Year & Quarter & Month Panel =============
      "&-year-panel,\n        &-quarter-panel,\n        &-month-panel": {
        [`${s}-body`]: {
          padding: `0 ${unit$1(ot)}`
        },
        [_]: {
          width: _e
        },
        [`${s}-cell-range-hover-start::after`]: {
          borderStartStartRadius: kt,
          borderEndStartRadius: kt,
          borderStartEndRadius: 0,
          borderEndEndRadius: 0,
          [`${s}-panel-rtl &`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            borderStartEndRadius: kt,
            borderEndEndRadius: kt
          }
        },
        [`${s}-cell-range-hover-end::after`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0,
          borderStartEndRadius: kt,
          borderEndEndRadius: kt,
          [`${s}-panel-rtl &`]: {
            borderStartStartRadius: kt,
            borderEndStartRadius: kt,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        }
      },
      "&-year-panel,\n        &-month-panel": {
        [`${s}-cell-range-hover-start::after`]: {
          insetInlineStart: Ut,
          borderInlineStart: `${unit$1(lt)} dashed ${Rt}`,
          [`${s}-panel-rtl &`]: {
            insetInlineEnd: Ut,
            borderInlineEnd: `${unit$1(lt)} dashed ${Rt}`
          }
        },
        [`${s}-cell-range-hover-end::after`]: {
          insetInlineEnd: Ut,
          borderInlineEnd: `${unit$1(lt)} dashed ${Rt}`,
          [`${s}-panel-rtl &`]: {
            insetInlineStart: Ut,
            borderInlineStart: `${unit$1(lt)} dashed ${Rt}`
          }
        }
      },
      // ====================== Week Panel ======================
      "&-week-panel": {
        [`${s}-body`]: {
          padding: `${unit$1(ot)} ${unit$1(at)}`
        },
        // Clear cell style
        [`${s}-cell`]: {
          [`&:hover ${_},
            &-selected ${_},
            ${_}`]: {
            background: "transparent !important"
          }
        },
        "&-row": {
          td: {
            "&:before": {
              transition: `background ${mt}`
            },
            "&:first-child:before": {
              borderStartStartRadius: kt,
              borderEndStartRadius: kt
            },
            "&:last-child:before": {
              borderStartEndRadius: kt,
              borderEndEndRadius: kt
            }
          },
          "&:hover td": {
            "&:before": {
              background: Ht
            }
          },
          "&-range-start td,\n            &-range-end td,\n            &-selected td": {
            // Rise priority to override hover style
            [`&${$}`]: {
              "&:before": {
                background: ut
              },
              [`&${s}-cell-week`]: {
                color: new TinyColor(jt).setAlpha(0.5).toHexString()
              },
              [_]: {
                color: jt
              }
            }
          },
          "&-range-hover td:before": {
            background: Mt
          }
        }
      },
      // ====================== Date Panel ======================
      "&-date-panel": {
        [`${s}-body`]: {
          padding: `${unit$1(ot)} ${unit$1($t)}`
        },
        [`${s}-content`]: {
          width: a.calc(nt).mul(7).equal(),
          th: {
            width: nt,
            boxSizing: "border-box",
            padding: 0
          }
        }
      },
      // ==================== Datetime Panel ====================
      "&-datetime-panel": {
        display: "flex",
        [`${s}-time-panel`]: {
          borderInlineStart: `${unit$1(lt)} ${et} ${ht}`
        },
        [`${s}-date-panel,
          ${s}-time-panel`]: {
          transition: `opacity ${Ot}`
        },
        // Keyboard
        "&-active": {
          [`${s}-date-panel,
            ${s}-time-panel`]: {
            opacity: 0.3,
            "&-active": {
              opacity: 1
            }
          }
        }
      },
      // ====================== Time Panel ======================
      "&-time-panel": {
        width: "auto",
        minWidth: "auto",
        direction: "ltr",
        [`${s}-content`]: {
          display: "flex",
          flex: "auto",
          height: Ft
        },
        "&-column": {
          flex: "1 0 auto",
          width: _t,
          margin: `${unit$1(rt)} 0`,
          padding: 0,
          overflowY: "hidden",
          textAlign: "start",
          listStyle: "none",
          transition: `background ${mt}`,
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: 8,
            backgroundColor: "transparent"
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: a.colorTextTertiary,
            borderRadius: 4
          },
          // For Firefox
          "&": {
            scrollbarWidth: "thin",
            scrollbarColor: `${a.colorTextTertiary} transparent`
          },
          "&::after": {
            display: "block",
            height: a.calc(Ft).sub(Nt).equal(),
            content: '""'
          },
          "&:not(:first-child)": {
            borderInlineStart: `${unit$1(lt)} ${et} ${ht}`
          },
          "&-active": {
            background: new TinyColor(Mt).setAlpha(0.2).toHexString()
          },
          "&:hover": {
            overflowY: "auto"
          },
          "> li": {
            margin: 0,
            padding: 0,
            [`&${s}-time-panel-cell`]: {
              marginInline: Lt,
              [`${s}-time-panel-cell-inner`]: {
                display: "block",
                width: a.calc(_t).sub(a.calc(Lt).mul(2)).equal(),
                height: Nt,
                margin: 0,
                paddingBlock: 0,
                paddingInlineEnd: 0,
                paddingInlineStart: a.calc(_t).sub(Nt).div(2).equal(),
                color: Et,
                lineHeight: unit$1(Nt),
                borderRadius: kt,
                cursor: "pointer",
                transition: `background ${mt}`,
                "&:hover": {
                  background: Ht
                }
              },
              "&-selected": {
                [`${s}-time-panel-cell-inner`]: {
                  background: Mt
                }
              },
              "&-disabled": {
                [`${s}-time-panel-cell-inner`]: {
                  color: bt,
                  background: "transparent",
                  cursor: "not-allowed"
                }
              }
            }
          }
        }
      },
      // https://github.com/ant-design/ant-design/issues/39227
      [`&-datetime-panel ${s}-time-panel-column:after`]: {
        height: a.calc(Ft).sub(Nt).add(a.calc(rt).mul(2)).equal()
      }
    }
  };
}, genPickerStatusStyle = (a) => {
  const {
    componentCls: s,
    colorBgContainer: $,
    colorError: _,
    errorActiveShadow: _e,
    colorWarning: tt,
    warningActiveShadow: nt,
    colorErrorHover: at,
    colorWarningHover: ot
  } = a;
  return {
    [`${s}:not(${s}-disabled):not([disabled])`]: {
      [`&${s}-status-error`]: {
        backgroundColor: $,
        borderColor: _,
        "&:hover": {
          borderColor: at
        },
        [`&${s}-focused, &:focus`]: Object.assign({}, genActiveStyle(merge(a, {
          activeBorderColor: _,
          activeShadow: _e
        }))),
        [`${s}-active-bar`]: {
          background: _
        }
      },
      [`&${s}-status-warning`]: {
        backgroundColor: $,
        borderColor: tt,
        "&:hover": {
          borderColor: ot
        },
        [`&${s}-focused, &:focus`]: Object.assign({}, genActiveStyle(merge(a, {
          activeBorderColor: tt,
          activeShadow: nt
        }))),
        [`${s}-active-bar`]: {
          background: tt
        }
      }
    }
  };
}, genPickerStyle = (a) => {
  const {
    componentCls: s,
    antCls: $,
    controlHeight: _,
    paddingInline: _e,
    colorBgContainer: tt,
    lineWidth: nt,
    lineType: at,
    colorBorder: ot,
    borderRadius: rt,
    motionDurationMid: st,
    colorBgContainerDisabled: lt,
    colorTextDisabled: et,
    colorTextPlaceholder: it,
    controlHeightLG: ut,
    fontSizeLG: ft,
    controlHeightSM: ht,
    paddingInlineSM: dt,
    paddingXS: gt,
    marginXS: pt,
    colorTextDescription: mt,
    lineWidthBold: ct,
    colorPrimary: vt,
    motionDurationSlow: At,
    zIndexPopup: xt,
    paddingXXS: bt,
    paddingSM: Et,
    textHeight: St,
    cellActiveWithRangeBg: Bt,
    colorPrimaryBorder: Ot,
    sizePopupArrow: Pt,
    colorBgElevated: wt,
    borderRadiusLG: Ct,
    boxShadowSecondary: It,
    borderRadiusSM: yt,
    colorSplit: Rt,
    cellHoverBg: kt,
    presetsWidth: jt,
    presetsMaxWidth: Ht,
    boxShadowPopoverArrow: Ft,
    colorTextQuaternary: _t,
    fontHeight: Nt,
    fontHeightLG: Mt,
    lineHeightLG: Lt
  } = a;
  return [
    {
      [s]: Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genPikerPadding(a, _, Nt, _e)), {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        background: tt,
        lineHeight: 1,
        border: `${unit$1(nt)} ${at} ${ot}`,
        borderRadius: rt,
        transition: `border ${st}, box-shadow ${st}`,
        "&:hover": Object.assign({}, genHoverStyle(a)),
        [`&-focused${s}`]: Object.assign({}, genActiveStyle(a)),
        [`&${s}-disabled`]: {
          background: lt,
          borderColor: ot,
          cursor: "not-allowed",
          [`${s}-suffix`]: {
            color: _t
          }
        },
        [`&${s}-borderless`]: {
          backgroundColor: "transparent !important",
          borderColor: "transparent !important",
          boxShadow: "none !important"
        },
        // ======================== Input =========================
        [`${s}-input`]: {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          width: "100%",
          "> input": Object.assign(Object.assign({}, genBasicInputStyle(a)), {
            flex: "auto",
            // Fix Firefox flex not correct:
            // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
            minWidth: 1,
            height: "auto",
            padding: 0,
            background: "transparent",
            border: 0,
            borderRadius: 0,
            fontFamily: "inherit",
            "&:focus": {
              boxShadow: "none"
            },
            "&[disabled]": {
              background: "transparent"
            }
          }),
          "&:hover": {
            [`${s}-clear`]: {
              opacity: 1
            }
          },
          "&-placeholder": {
            "> input": {
              color: it
            }
          }
        },
        // Size
        "&-large": Object.assign(Object.assign({}, genPikerPadding(a, ut, Mt, _e)), {
          [`${s}-input > input`]: {
            fontSize: ft,
            lineHeight: Lt
          }
        }),
        "&-small": Object.assign({}, genPikerPadding(a, ht, Nt, dt)),
        [`${s}-suffix`]: {
          display: "flex",
          flex: "none",
          alignSelf: "center",
          marginInlineStart: a.calc(gt).div(2).equal(),
          color: et,
          lineHeight: 1,
          pointerEvents: "none",
          "> *": {
            verticalAlign: "top",
            "&:not(:last-child)": {
              marginInlineEnd: pt
            }
          }
        },
        [`${s}-clear`]: {
          position: "absolute",
          top: "50%",
          insetInlineEnd: 0,
          color: et,
          lineHeight: 1,
          background: tt,
          transform: "translateY(-50%)",
          cursor: "pointer",
          opacity: 0,
          transition: `opacity ${st}, color ${st}`,
          "> *": {
            verticalAlign: "top"
          },
          "&:hover": {
            color: mt
          }
        },
        [`${s}-separator`]: {
          position: "relative",
          display: "inline-block",
          width: "1em",
          height: ft,
          color: et,
          fontSize: ft,
          verticalAlign: "top",
          cursor: "default",
          [`${s}-focused &`]: {
            color: mt
          },
          [`${s}-range-separator &`]: {
            [`${s}-disabled &`]: {
              cursor: "not-allowed"
            }
          }
        },
        // ======================== Range =========================
        "&-range": {
          position: "relative",
          display: "inline-flex",
          // Clear
          [`${s}-clear`]: {
            insetInlineEnd: _e
          },
          "&:hover": {
            [`${s}-clear`]: {
              opacity: 1
            }
          },
          // Active bar
          [`${s}-active-bar`]: {
            bottom: a.calc(nt).mul(-1).equal(),
            height: ct,
            marginInlineStart: _e,
            background: vt,
            opacity: 0,
            transition: `all ${At} ease-out`,
            pointerEvents: "none"
          },
          [`&${s}-focused`]: {
            [`${s}-active-bar`]: {
              opacity: 1
            }
          },
          [`${s}-range-separator`]: {
            alignItems: "center",
            padding: `0 ${unit$1(gt)}`,
            lineHeight: 1
          },
          [`&${s}-small`]: {
            [`${s}-clear`]: {
              insetInlineEnd: dt
            },
            [`${s}-active-bar`]: {
              marginInlineStart: dt
            }
          }
        },
        // ======================= Dropdown =======================
        "&-dropdown": Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genPanelStyle(a)), {
          position: "absolute",
          // Fix incorrect position of picker popup
          // https://github.com/ant-design/ant-design/issues/35590
          top: -9999,
          left: {
            _skip_check_: !0,
            value: -9999
          },
          zIndex: xt,
          [`&${s}-dropdown-hidden`]: {
            display: "none"
          },
          [`&${s}-dropdown-placement-bottomLeft`]: {
            [`${s}-range-arrow`]: {
              top: 0,
              display: "block",
              transform: "translateY(-100%)"
            }
          },
          [`&${s}-dropdown-placement-topLeft`]: {
            [`${s}-range-arrow`]: {
              bottom: 0,
              display: "block",
              transform: "translateY(100%) rotate(180deg)"
            }
          },
          [`&${$}-slide-up-enter${$}-slide-up-enter-active${s}-dropdown-placement-topLeft,
          &${$}-slide-up-enter${$}-slide-up-enter-active${s}-dropdown-placement-topRight,
          &${$}-slide-up-appear${$}-slide-up-appear-active${s}-dropdown-placement-topLeft,
          &${$}-slide-up-appear${$}-slide-up-appear-active${s}-dropdown-placement-topRight`]: {
            animationName: slideDownIn
          },
          [`&${$}-slide-up-enter${$}-slide-up-enter-active${s}-dropdown-placement-bottomLeft,
          &${$}-slide-up-enter${$}-slide-up-enter-active${s}-dropdown-placement-bottomRight,
          &${$}-slide-up-appear${$}-slide-up-appear-active${s}-dropdown-placement-bottomLeft,
          &${$}-slide-up-appear${$}-slide-up-appear-active${s}-dropdown-placement-bottomRight`]: {
            animationName: slideUpIn
          },
          [`&${$}-slide-up-leave${$}-slide-up-leave-active${s}-dropdown-placement-topLeft,
          &${$}-slide-up-leave${$}-slide-up-leave-active${s}-dropdown-placement-topRight`]: {
            animationName: slideDownOut
          },
          [`&${$}-slide-up-leave${$}-slide-up-leave-active${s}-dropdown-placement-bottomLeft,
          &${$}-slide-up-leave${$}-slide-up-leave-active${s}-dropdown-placement-bottomRight`]: {
            animationName: slideUpOut
          },
          // Time picker with additional style
          [`${s}-panel > ${s}-time-panel`]: {
            paddingTop: bt
          },
          // ======================== Ranges ========================
          [`${s}-ranges`]: {
            marginBottom: 0,
            padding: `${unit$1(bt)} ${unit$1(Et)}`,
            overflow: "hidden",
            lineHeight: unit$1(a.calc(St).sub(a.calc(nt).mul(2)).sub(a.calc(gt).div(2)).equal()),
            textAlign: "start",
            listStyle: "none",
            display: "flex",
            justifyContent: "space-between",
            "> li": {
              display: "inline-block"
            },
            // https://github.com/ant-design/ant-design/issues/23687
            [`${s}-preset > ${$}-tag-blue`]: {
              color: vt,
              background: Bt,
              borderColor: Ot,
              cursor: "pointer"
            },
            [`${s}-ok`]: {
              marginInlineStart: "auto"
            }
          },
          [`${s}-range-wrapper`]: {
            display: "flex",
            position: "relative"
          },
          [`${s}-range-arrow`]: Object.assign({
            position: "absolute",
            zIndex: 1,
            display: "none",
            marginInlineStart: a.calc(_e).mul(1.5).equal(),
            transition: `left ${At} ease-out`
          }, genRoundedArrow(a, wt, Ft)),
          [`${s}-panel-container`]: {
            overflow: "hidden",
            verticalAlign: "top",
            background: wt,
            borderRadius: Ct,
            boxShadow: It,
            transition: `margin ${At}`,
            // ======================== Layout ========================
            [`${s}-panel-layout`]: {
              display: "flex",
              flexWrap: "nowrap",
              alignItems: "stretch"
            },
            // ======================== Preset ========================
            [`${s}-presets`]: {
              display: "flex",
              flexDirection: "column",
              minWidth: jt,
              maxWidth: Ht,
              ul: {
                height: 0,
                flex: "auto",
                listStyle: "none",
                overflow: "auto",
                margin: 0,
                padding: gt,
                borderInlineEnd: `${unit$1(nt)} ${at} ${Rt}`,
                li: Object.assign(Object.assign({}, textEllipsis), {
                  borderRadius: yt,
                  paddingInline: gt,
                  paddingBlock: a.calc(ht).sub(Nt).div(2).equal(),
                  cursor: "pointer",
                  transition: `all ${At}`,
                  "+ li": {
                    marginTop: pt
                  },
                  "&:hover": {
                    background: kt
                  }
                })
              }
            },
            // ======================== Panels ========================
            [`${s}-panels`]: {
              display: "inline-flex",
              flexWrap: "nowrap",
              direction: "ltr",
              [`${s}-panel`]: {
                borderWidth: `0 0 ${unit$1(nt)}`
              },
              "&:last-child": {
                [`${s}-panel`]: {
                  borderWidth: 0
                }
              }
            },
            [`${s}-panel`]: {
              verticalAlign: "top",
              background: "transparent",
              borderRadius: 0,
              borderWidth: 0,
              [`${s}-content,
            table`]: {
                textAlign: "center"
              },
              "&-focused": {
                borderColor: ot
              }
            }
          }
        }),
        "&-dropdown-range": {
          padding: `${unit$1(a.calc(Pt).mul(2).div(3).equal())} 0`,
          "&-hidden": {
            display: "none"
          }
        },
        "&-rtl": {
          direction: "rtl",
          [`${s}-separator`]: {
            transform: "rotate(180deg)"
          },
          [`${s}-footer`]: {
            "&-extra": {
              direction: "rtl"
            }
          }
        }
      })
    },
    // Follow code may reuse in other components
    initSlideMotion(a, "slide-up"),
    initSlideMotion(a, "slide-down"),
    initMoveMotion(a, "move-up"),
    initMoveMotion(a, "move-down")
  ];
}, initPickerPanelToken = (a) => {
  const {
    componentCls: s,
    controlHeightLG: $,
    paddingXXS: _,
    padding: _e
  } = a;
  return {
    pickerCellCls: `${s}-cell`,
    pickerCellInnerCls: `${s}-cell-inner`,
    pickerYearMonthCellWidth: a.calc($).mul(1.5).equal(),
    pickerQuarterPanelContentHeight: a.calc($).mul(1.4).equal(),
    pickerCellPaddingVertical: a.calc(_).add(a.calc(_).div(2)).equal(),
    pickerCellBorderGap: 2,
    // Magic for gap between cells
    pickerControlIconSize: 7,
    pickerControlIconMargin: 4,
    pickerControlIconBorderWidth: 1.5,
    pickerDatePanelPaddingHorizontal: a.calc(_e).add(a.calc(_).div(2)).equal()
    // 18 in normal
  };
}, initPanelComponentToken = (a) => ({
  cellHoverBg: a.controlItemBgHover,
  cellActiveWithRangeBg: a.controlItemBgActive,
  cellHoverWithRangeBg: new TinyColor(a.colorPrimary).lighten(35).toHexString(),
  cellRangeBorderColor: new TinyColor(a.colorPrimary).lighten(20).toHexString(),
  cellBgDisabled: a.colorBgContainerDisabled,
  timeColumnWidth: a.controlHeightLG * 1.4,
  timeColumnHeight: 28 * 8,
  timeCellHeight: 28,
  cellWidth: a.controlHeightSM * 1.5,
  cellHeight: a.controlHeightSM,
  textHeight: a.controlHeightLG,
  withoutTimeCellHeight: a.controlHeightLG * 1.65
}), prepareComponentToken$l = (a) => Object.assign(Object.assign(Object.assign(Object.assign({}, initComponentToken$1(a)), initPanelComponentToken(a)), getArrowToken(a)), {
  presetsWidth: 120,
  presetsMaxWidth: 200,
  zIndexPopup: a.zIndexPopupBase + 50
}), useStyle$m = genStyleHooks("DatePicker", (a) => {
  const s = merge(initInputToken(a), initPickerPanelToken(a));
  return [
    genPickerStyle(s),
    genPickerStatusStyle(s),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(a, {
      focusElCls: `${a.componentCls}-focused`
    })
  ];
}, prepareComponentToken$l), Element$1 = (a) => {
  const {
    prefixCls: s,
    className: $,
    style: _,
    size: _e,
    shape: tt
  } = a, nt = classnames({
    [`${s}-lg`]: _e === "large",
    [`${s}-sm`]: _e === "small"
  }), at = classnames({
    [`${s}-circle`]: tt === "circle",
    [`${s}-square`]: tt === "square",
    [`${s}-round`]: tt === "round"
  }), ot = reactExports.useMemo(() => typeof _e == "number" ? {
    width: _e,
    height: _e,
    lineHeight: `${_e}px`
  } : {}, [_e]);
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(s, nt, at, $),
    style: Object.assign(Object.assign({}, ot), _)
  });
}, Element$2 = Element$1, skeletonClsLoading = new Keyframe("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), genSkeletonElementCommonSize = (a) => ({
  height: a,
  lineHeight: unit$1(a)
}), genSkeletonElementAvatarSize = (a) => Object.assign({
  width: a
}, genSkeletonElementCommonSize(a)), genSkeletonColor = (a) => ({
  background: a.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: skeletonClsLoading,
  animationDuration: a.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), genSkeletonElementInputSize = (a, s) => Object.assign({
  width: s(a).mul(5).equal(),
  minWidth: s(a).mul(5).equal()
}, genSkeletonElementCommonSize(a)), genSkeletonElementAvatar = (a) => {
  const {
    skeletonAvatarCls: s,
    gradientFromColor: $,
    controlHeight: _,
    controlHeightLG: _e,
    controlHeightSM: tt
  } = a;
  return {
    [`${s}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: $
    }, genSkeletonElementAvatarSize(_)),
    [`${s}${s}-circle`]: {
      borderRadius: "50%"
    },
    [`${s}${s}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(_e)),
    [`${s}${s}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(tt))
  };
}, genSkeletonElementInput = (a) => {
  const {
    controlHeight: s,
    borderRadiusSM: $,
    skeletonInputCls: _,
    controlHeightLG: _e,
    controlHeightSM: tt,
    gradientFromColor: nt,
    calc: at
  } = a;
  return {
    [`${_}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: nt,
      borderRadius: $
    }, genSkeletonElementInputSize(s, at)),
    [`${_}-lg`]: Object.assign({}, genSkeletonElementInputSize(_e, at)),
    [`${_}-sm`]: Object.assign({}, genSkeletonElementInputSize(tt, at))
  };
}, genSkeletonElementImageSize = (a) => Object.assign({
  width: a
}, genSkeletonElementCommonSize(a)), genSkeletonElementImage = (a) => {
  const {
    skeletonImageCls: s,
    imageSizeBase: $,
    gradientFromColor: _,
    borderRadiusSM: _e,
    calc: tt
  } = a;
  return {
    [`${s}`]: Object.assign(Object.assign({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "top",
      background: _,
      borderRadius: _e
    }, genSkeletonElementImageSize(tt($).mul(2).equal())), {
      [`${s}-path`]: {
        fill: "#bfbfbf"
      },
      [`${s}-svg`]: Object.assign(Object.assign({}, genSkeletonElementImageSize($)), {
        maxWidth: tt($).mul(4).equal(),
        maxHeight: tt($).mul(4).equal()
      }),
      [`${s}-svg${s}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${s}${s}-circle`]: {
      borderRadius: "50%"
    }
  };
}, genSkeletonElementButtonShape = (a, s, $) => {
  const {
    skeletonButtonCls: _
  } = a;
  return {
    [`${$}${_}-circle`]: {
      width: s,
      minWidth: s,
      borderRadius: "50%"
    },
    [`${$}${_}-round`]: {
      borderRadius: s
    }
  };
}, genSkeletonElementButtonSize = (a, s) => Object.assign({
  width: s(a).mul(2).equal(),
  minWidth: s(a).mul(2).equal()
}, genSkeletonElementCommonSize(a)), genSkeletonElementButton = (a) => {
  const {
    borderRadiusSM: s,
    skeletonButtonCls: $,
    controlHeight: _,
    controlHeightLG: _e,
    controlHeightSM: tt,
    gradientFromColor: nt,
    calc: at
  } = a;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [`${$}`]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: nt,
      borderRadius: s,
      width: at(_).mul(2).equal(),
      minWidth: at(_).mul(2).equal()
    }, genSkeletonElementButtonSize(_, at))
  }, genSkeletonElementButtonShape(a, _, $)), {
    [`${$}-lg`]: Object.assign({}, genSkeletonElementButtonSize(_e, at))
  }), genSkeletonElementButtonShape(a, _e, `${$}-lg`)), {
    [`${$}-sm`]: Object.assign({}, genSkeletonElementButtonSize(tt, at))
  }), genSkeletonElementButtonShape(a, tt, `${$}-sm`));
}, genBaseStyle$8 = (a) => {
  const {
    componentCls: s,
    skeletonAvatarCls: $,
    skeletonTitleCls: _,
    skeletonParagraphCls: _e,
    skeletonButtonCls: tt,
    skeletonInputCls: nt,
    skeletonImageCls: at,
    controlHeight: ot,
    controlHeightLG: rt,
    controlHeightSM: st,
    gradientFromColor: lt,
    padding: et,
    marginSM: it,
    borderRadius: ut,
    titleHeight: ft,
    blockRadius: ht,
    paragraphLiHeight: dt,
    controlHeightXS: gt,
    paragraphMarginTop: pt
  } = a;
  return {
    [`${s}`]: {
      display: "table",
      width: "100%",
      [`${s}-header`]: {
        display: "table-cell",
        paddingInlineEnd: et,
        verticalAlign: "top",
        // Avatar
        [`${$}`]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: lt
        }, genSkeletonElementAvatarSize(ot)),
        [`${$}-circle`]: {
          borderRadius: "50%"
        },
        [`${$}-lg`]: Object.assign({}, genSkeletonElementAvatarSize(rt)),
        [`${$}-sm`]: Object.assign({}, genSkeletonElementAvatarSize(st))
      },
      [`${s}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [`${_}`]: {
          width: "100%",
          height: ft,
          background: lt,
          borderRadius: ht,
          [`+ ${_e}`]: {
            marginBlockStart: st
          }
        },
        // paragraph
        [`${_e}`]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: dt,
            listStyle: "none",
            background: lt,
            borderRadius: ht,
            "+ li": {
              marginBlockStart: gt
            }
          }
        },
        [`${_e}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${s}-content`]: {
        [`${_}, ${_e} > li`]: {
          borderRadius: ut
        }
      }
    },
    [`${s}-with-avatar ${s}-content`]: {
      // Title
      [`${_}`]: {
        marginBlockStart: it,
        [`+ ${_e}`]: {
          marginBlockStart: pt
        }
      }
    },
    // Skeleton element
    [`${s}${s}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, genSkeletonElementButton(a)), genSkeletonElementAvatar(a)), genSkeletonElementInput(a)), genSkeletonElementImage(a)),
    // Skeleton Block Button, Input
    [`${s}${s}-block`]: {
      width: "100%",
      [`${tt}`]: {
        width: "100%"
      },
      [`${nt}`]: {
        width: "100%"
      }
    },
    // With active animation
    [`${s}${s}-active`]: {
      [`
        ${_},
        ${_e} > li,
        ${$},
        ${tt},
        ${nt},
        ${at}
      `]: Object.assign({}, genSkeletonColor(a))
    }
  };
}, prepareComponentToken$k = (a) => {
  const {
    colorFillContent: s,
    colorFill: $
  } = a, _ = s, _e = $;
  return {
    color: _,
    colorGradientEnd: _e,
    gradientFromColor: _,
    gradientToColor: _e,
    titleHeight: a.controlHeight / 2,
    blockRadius: a.borderRadiusSM,
    paragraphMarginTop: a.marginLG + a.marginXXS,
    paragraphLiHeight: a.controlHeight / 2
  };
}, useStyle$l = genStyleHooks("Skeleton", (a) => {
  const {
    componentCls: s,
    calc: $
  } = a, _ = merge(a, {
    skeletonAvatarCls: `${s}-avatar`,
    skeletonTitleCls: `${s}-title`,
    skeletonParagraphCls: `${s}-paragraph`,
    skeletonButtonCls: `${s}-button`,
    skeletonInputCls: `${s}-input`,
    skeletonImageCls: `${s}-image`,
    imageSizeBase: $(a.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${a.gradientFromColor} 25%, ${a.gradientToColor} 37%, ${a.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [genBaseStyle$8(_)];
}, prepareComponentToken$k, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), SkeletonAvatar = (a) => {
  const {
    prefixCls: s,
    className: $,
    rootClassName: _,
    active: _e,
    shape: tt = "circle",
    size: nt = "default"
  } = a, {
    getPrefixCls: at
  } = reactExports.useContext(ConfigContext$1), ot = at("skeleton", s), [rt, st, lt] = useStyle$l(ot), et = omit(a, ["prefixCls", "className"]), it = classnames(ot, `${ot}-element`, {
    [`${ot}-active`]: _e
  }, $, _, st, lt);
  return rt(/* @__PURE__ */ reactExports.createElement("div", {
    className: it
  }, /* @__PURE__ */ reactExports.createElement(Element$2, Object.assign({
    prefixCls: `${ot}-avatar`,
    shape: tt,
    size: nt
  }, et))));
}, SkeletonAvatar$1 = SkeletonAvatar, SkeletonButton = (a) => {
  const {
    prefixCls: s,
    className: $,
    rootClassName: _,
    active: _e,
    block: tt = !1,
    size: nt = "default"
  } = a, {
    getPrefixCls: at
  } = reactExports.useContext(ConfigContext$1), ot = at("skeleton", s), [rt, st, lt] = useStyle$l(ot), et = omit(a, ["prefixCls"]), it = classnames(ot, `${ot}-element`, {
    [`${ot}-active`]: _e,
    [`${ot}-block`]: tt
  }, $, _, st, lt);
  return rt(/* @__PURE__ */ reactExports.createElement("div", {
    className: it
  }, /* @__PURE__ */ reactExports.createElement(Element$2, Object.assign({
    prefixCls: `${ot}-button`,
    size: nt
  }, et))));
}, SkeletonButton$1 = SkeletonButton, path = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", SkeletonImage = (a) => {
  const {
    prefixCls: s,
    className: $,
    rootClassName: _,
    style: _e,
    active: tt
  } = a, {
    getPrefixCls: nt
  } = reactExports.useContext(ConfigContext$1), at = nt("skeleton", s), [ot, rt, st] = useStyle$l(at), lt = classnames(at, `${at}-element`, {
    [`${at}-active`]: tt
  }, $, _, rt, st);
  return ot(/* @__PURE__ */ reactExports.createElement("div", {
    className: lt
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${at}-image`, $),
    style: _e
  }, /* @__PURE__ */ reactExports.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${at}-image-svg`
  }, /* @__PURE__ */ reactExports.createElement("path", {
    d: path,
    className: `${at}-image-path`
  })))));
}, SkeletonImage$1 = SkeletonImage, SkeletonInput = (a) => {
  const {
    prefixCls: s,
    className: $,
    rootClassName: _,
    active: _e,
    block: tt,
    size: nt = "default"
  } = a, {
    getPrefixCls: at
  } = reactExports.useContext(ConfigContext$1), ot = at("skeleton", s), [rt, st, lt] = useStyle$l(ot), et = omit(a, ["prefixCls"]), it = classnames(ot, `${ot}-element`, {
    [`${ot}-active`]: _e,
    [`${ot}-block`]: tt
  }, $, _, st, lt);
  return rt(/* @__PURE__ */ reactExports.createElement("div", {
    className: it
  }, /* @__PURE__ */ reactExports.createElement(Element$2, Object.assign({
    prefixCls: `${ot}-input`,
    size: nt
  }, et))));
}, SkeletonInput$1 = SkeletonInput;
var DotChartOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "dot-chart", theme: "outlined" };
const DotChartOutlinedSvg = DotChartOutlined$2;
var DotChartOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: DotChartOutlinedSvg
  }));
};
const DotChartOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(DotChartOutlined), SkeletonNode = (a) => {
  const {
    prefixCls: s,
    className: $,
    rootClassName: _,
    style: _e,
    active: tt,
    children: nt
  } = a, {
    getPrefixCls: at
  } = reactExports.useContext(ConfigContext$1), ot = at("skeleton", s), [rt, st, lt] = useStyle$l(ot), et = classnames(ot, `${ot}-element`, {
    [`${ot}-active`]: tt
  }, st, $, _, lt), it = nt ?? /* @__PURE__ */ reactExports.createElement(DotChartOutlined$1, null);
  return rt(/* @__PURE__ */ reactExports.createElement("div", {
    className: et
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${ot}-image`, $),
    style: _e
  }, it)));
}, SkeletonNode$1 = SkeletonNode, Paragraph$2 = (a) => {
  const s = (at) => {
    const {
      width: ot,
      rows: rt = 2
    } = a;
    if (Array.isArray(ot))
      return ot[at];
    if (rt - 1 === at)
      return ot;
  }, {
    prefixCls: $,
    className: _,
    style: _e,
    rows: tt
  } = a, nt = _toConsumableArray$d(Array(tt)).map((at, ot) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ reactExports.createElement("li", {
      key: ot,
      style: {
        width: s(ot)
      }
    })
  ));
  return /* @__PURE__ */ reactExports.createElement("ul", {
    className: classnames($, _),
    style: _e
  }, nt);
}, Paragraph$3 = Paragraph$2, Title$2 = (a) => {
  let {
    prefixCls: s,
    className: $,
    width: _,
    style: _e
  } = a;
  return /* @__PURE__ */ reactExports.createElement("h3", {
    className: classnames(s, $),
    style: Object.assign({
      width: _
    }, _e)
  });
}, Title$3 = Title$2;
function getComponentProps(a) {
  return a && typeof a == "object" ? a : {};
}
function getAvatarBasicProps(a, s) {
  return a && !s ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function getTitleBasicProps(a, s) {
  return !a && s ? {
    width: "38%"
  } : a && s ? {
    width: "50%"
  } : {};
}
function getParagraphBasicProps(a, s) {
  const $ = {};
  return (!a || !s) && ($.width = "61%"), !a && s ? $.rows = 3 : $.rows = 2, $;
}
const Skeleton = (a) => {
  const {
    prefixCls: s,
    loading: $,
    className: _,
    rootClassName: _e,
    style: tt,
    children: nt,
    avatar: at = !1,
    title: ot = !0,
    paragraph: rt = !0,
    active: st,
    round: lt
  } = a, {
    getPrefixCls: et,
    direction: it,
    skeleton: ut
  } = reactExports.useContext(ConfigContext$1), ft = et("skeleton", s), [ht, dt, gt] = useStyle$l(ft);
  if ($ || !("loading" in a)) {
    const pt = !!at, mt = !!ot, ct = !!rt;
    let vt;
    if (pt) {
      const bt = Object.assign(Object.assign({
        prefixCls: `${ft}-avatar`
      }, getAvatarBasicProps(mt, ct)), getComponentProps(at));
      vt = /* @__PURE__ */ reactExports.createElement("div", {
        className: `${ft}-header`
      }, /* @__PURE__ */ reactExports.createElement(Element$2, Object.assign({}, bt)));
    }
    let At;
    if (mt || ct) {
      let bt;
      if (mt) {
        const St = Object.assign(Object.assign({
          prefixCls: `${ft}-title`
        }, getTitleBasicProps(pt, ct)), getComponentProps(ot));
        bt = /* @__PURE__ */ reactExports.createElement(Title$3, Object.assign({}, St));
      }
      let Et;
      if (ct) {
        const St = Object.assign(Object.assign({
          prefixCls: `${ft}-paragraph`
        }, getParagraphBasicProps(pt, mt)), getComponentProps(rt));
        Et = /* @__PURE__ */ reactExports.createElement(Paragraph$3, Object.assign({}, St));
      }
      At = /* @__PURE__ */ reactExports.createElement("div", {
        className: `${ft}-content`
      }, bt, Et);
    }
    const xt = classnames(ft, {
      [`${ft}-with-avatar`]: pt,
      [`${ft}-active`]: st,
      [`${ft}-rtl`]: it === "rtl",
      [`${ft}-round`]: lt
    }, ut == null ? void 0 : ut.className, _, _e, dt, gt);
    return ht(/* @__PURE__ */ reactExports.createElement("div", {
      className: xt,
      style: Object.assign(Object.assign({}, ut == null ? void 0 : ut.style), tt)
    }, vt, At));
  }
  return typeof nt < "u" ? nt : null;
};
Skeleton.Button = SkeletonButton$1;
Skeleton.Avatar = SkeletonAvatar$1;
Skeleton.Input = SkeletonInput$1;
Skeleton.Image = SkeletonImage$1;
Skeleton.Node = SkeletonNode$1;
const Skeleton$1 = Skeleton;
var PlusOutlined$5 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" };
const PlusOutlinedSvg = PlusOutlined$5;
var PlusOutlined$3 = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: PlusOutlinedSvg
  }));
};
const PlusOutlined$4 = /* @__PURE__ */ reactExports.forwardRef(PlusOutlined$3);
function useAnimateConfig$1() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    inkBar: !0,
    tabPane: !1
  }, s;
  return a === !1 ? s = {
    inkBar: !1,
    tabPane: !1
  } : a === !0 ? s = {
    inkBar: !0,
    tabPane: !1
  } : s = _objectSpread2$a({
    inkBar: !0
  }, _typeof$q(a) === "object" ? a : {}), s.tabPaneMotion && s.tabPane === void 0 && (s.tabPane = !0), !s.tabPaneMotion && s.tabPane && (s.tabPane = !1), s;
}
const TabContext = /* @__PURE__ */ reactExports.createContext(null);
var useIndicator = function a(s) {
  var $ = s.activeTabOffset, _ = s.horizontal, _e = s.rtl, tt = s.indicatorSize, nt = reactExports.useState(), at = _slicedToArray$e(nt, 2), ot = at[0], rt = at[1], st = reactExports.useRef(), lt = function(ut) {
    return typeof tt == "function" ? tt(ut) : typeof tt == "number" ? tt : ut;
  };
  function et() {
    wrapperRaf.cancel(st.current);
  }
  return reactExports.useEffect(function() {
    var it = {};
    return $ && (_ ? (_e ? (it.right = $.right + $.width / 2, it.transform = "translateX(50%)") : (it.left = $.left + $.width / 2, it.transform = "translateX(-50%)"), it.width = lt($.width)) : (it.top = $.top + $.height / 2, it.transform = "translateY(-50%)", it.height = lt($.height))), et(), st.current = wrapperRaf(function() {
      rt(it);
    }), et;
  }, [$, _, _e, tt]), {
    style: ot
  };
}, DEFAULT_SIZE$1 = {
  width: 0,
  height: 0,
  left: 0,
  top: 0
};
function useOffsets(a, s, $) {
  return reactExports.useMemo(function() {
    for (var _, _e = /* @__PURE__ */ new Map(), tt = s.get((_ = a[0]) === null || _ === void 0 ? void 0 : _.key) || DEFAULT_SIZE$1, nt = tt.left + tt.width, at = 0; at < a.length; at += 1) {
      var ot = a[at].key, rt = s.get(ot);
      if (!rt) {
        var st;
        rt = s.get((st = a[at - 1]) === null || st === void 0 ? void 0 : st.key) || DEFAULT_SIZE$1;
      }
      var lt = _e.get(ot) || _objectSpread2$a({}, rt);
      lt.right = nt - lt.left - lt.width, _e.set(ot, lt);
    }
    return _e;
  }, [a.map(function(_) {
    return _.key;
  }).join("_"), s, $]);
}
function useSyncState$1(a, s) {
  var $ = reactExports.useRef(a), _ = reactExports.useState({}), _e = _slicedToArray$e(_, 2), tt = _e[1];
  function nt(at) {
    var ot = typeof at == "function" ? at($.current) : at;
    ot !== $.current && s(ot, $.current), $.current = ot, tt({});
  }
  return [$.current, nt];
}
var MIN_SWIPE_DISTANCE = 0.1, STOP_SWIPE_DISTANCE = 0.01, REFRESH_INTERVAL = 20, SPEED_OFF_MULTIPLE = Math.pow(0.995, REFRESH_INTERVAL);
function useTouchMove(a, s) {
  var $ = reactExports.useState(), _ = _slicedToArray$e($, 2), _e = _[0], tt = _[1], nt = reactExports.useState(0), at = _slicedToArray$e(nt, 2), ot = at[0], rt = at[1], st = reactExports.useState(0), lt = _slicedToArray$e(st, 2), et = lt[0], it = lt[1], ut = reactExports.useState(), ft = _slicedToArray$e(ut, 2), ht = ft[0], dt = ft[1], gt = reactExports.useRef();
  function pt(bt) {
    var Et = bt.touches[0], St = Et.screenX, Bt = Et.screenY;
    tt({
      x: St,
      y: Bt
    }), window.clearInterval(gt.current);
  }
  function mt(bt) {
    if (_e) {
      bt.preventDefault();
      var Et = bt.touches[0], St = Et.screenX, Bt = Et.screenY;
      tt({
        x: St,
        y: Bt
      });
      var Ot = St - _e.x, Pt = Bt - _e.y;
      s(Ot, Pt);
      var wt = Date.now();
      rt(wt), it(wt - ot), dt({
        x: Ot,
        y: Pt
      });
    }
  }
  function ct() {
    if (_e && (tt(null), dt(null), ht)) {
      var bt = ht.x / et, Et = ht.y / et, St = Math.abs(bt), Bt = Math.abs(Et);
      if (Math.max(St, Bt) < MIN_SWIPE_DISTANCE)
        return;
      var Ot = bt, Pt = Et;
      gt.current = window.setInterval(function() {
        if (Math.abs(Ot) < STOP_SWIPE_DISTANCE && Math.abs(Pt) < STOP_SWIPE_DISTANCE) {
          window.clearInterval(gt.current);
          return;
        }
        Ot *= SPEED_OFF_MULTIPLE, Pt *= SPEED_OFF_MULTIPLE, s(Ot * REFRESH_INTERVAL, Pt * REFRESH_INTERVAL);
      }, REFRESH_INTERVAL);
    }
  }
  var vt = reactExports.useRef();
  function At(bt) {
    var Et = bt.deltaX, St = bt.deltaY, Bt = 0, Ot = Math.abs(Et), Pt = Math.abs(St);
    Ot === Pt ? Bt = vt.current === "x" ? Et : St : Ot > Pt ? (Bt = Et, vt.current = "x") : (Bt = St, vt.current = "y"), s(-Bt, -Bt) && bt.preventDefault();
  }
  var xt = reactExports.useRef(null);
  xt.current = {
    onTouchStart: pt,
    onTouchMove: mt,
    onTouchEnd: ct,
    onWheel: At
  }, reactExports.useEffect(function() {
    function bt(Ot) {
      xt.current.onTouchStart(Ot);
    }
    function Et(Ot) {
      xt.current.onTouchMove(Ot);
    }
    function St(Ot) {
      xt.current.onTouchEnd(Ot);
    }
    function Bt(Ot) {
      xt.current.onWheel(Ot);
    }
    return document.addEventListener("touchmove", Et, {
      passive: !1
    }), document.addEventListener("touchend", St, {
      passive: !1
    }), a.current.addEventListener("touchstart", bt, {
      passive: !1
    }), a.current.addEventListener("wheel", Bt), function() {
      document.removeEventListener("touchmove", Et), document.removeEventListener("touchend", St);
    };
  }, []);
}
function useUpdate(a) {
  var s = reactExports.useState(0), $ = _slicedToArray$e(s, 2), _ = $[0], _e = $[1], tt = reactExports.useRef(0), nt = reactExports.useRef();
  return nt.current = a, useLayoutUpdateEffect(function() {
    var at;
    (at = nt.current) === null || at === void 0 || at.call(nt);
  }, [_]), function() {
    tt.current === _ && (tt.current += 1, _e(tt.current));
  };
}
function useUpdateState(a) {
  var s = reactExports.useRef([]), $ = reactExports.useState({}), _ = _slicedToArray$e($, 2), _e = _[1], tt = reactExports.useRef(typeof a == "function" ? a() : a), nt = useUpdate(function() {
    var ot = tt.current;
    s.current.forEach(function(rt) {
      ot = rt(ot);
    }), s.current = [], tt.current = ot, _e({});
  });
  function at(ot) {
    s.current.push(ot), nt();
  }
  return [tt.current, at];
}
var DEFAULT_SIZE = {
  width: 0,
  height: 0,
  left: 0,
  top: 0,
  right: 0
};
function useVisibleRange(a, s, $, _, _e, tt, nt) {
  var at = nt.tabs, ot = nt.tabPosition, rt = nt.rtl, st, lt, et;
  return ["top", "bottom"].includes(ot) ? (st = "width", lt = rt ? "right" : "left", et = Math.abs($)) : (st = "height", lt = "top", et = -$), reactExports.useMemo(function() {
    if (!at.length)
      return [0, 0];
    for (var it = at.length, ut = it, ft = 0; ft < it; ft += 1) {
      var ht = a.get(at[ft].key) || DEFAULT_SIZE;
      if (ht[lt] + ht[st] > et + s) {
        ut = ft - 1;
        break;
      }
    }
    for (var dt = 0, gt = it - 1; gt >= 0; gt -= 1) {
      var pt = a.get(at[gt].key) || DEFAULT_SIZE;
      if (pt[lt] < et) {
        dt = gt + 1;
        break;
      }
    }
    return dt >= ut ? [0, 0] : [dt, ut];
  }, [a, s, _, _e, tt, et, ot, at.map(function(it) {
    return it.key;
  }).join("_"), rt]);
}
function stringify(a) {
  var s;
  return a instanceof Map ? (s = {}, a.forEach(function($, _) {
    s[_] = $;
  })) : s = a, JSON.stringify(s);
}
var RC_TABS_DOUBLE_QUOTE = "TABS_DQ";
function genDataNodeKey(a) {
  return String(a).replace(/"/g, RC_TABS_DOUBLE_QUOTE);
}
function getRemovable(a, s, $, _) {
  return (
    // Only editable tabs can be removed
    !(!$ || // Tabs cannot be removed when disabled
    _ || // closable is false
    a === !1 || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    a === void 0 && (s === !1 || s === null))
  );
}
var AddButton = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = a.editable, _e = a.locale, tt = a.style;
  return !_ || _.showAdd === !1 ? null : /* @__PURE__ */ reactExports.createElement("button", {
    ref: s,
    type: "button",
    className: "".concat($, "-nav-add"),
    style: tt,
    "aria-label": (_e == null ? void 0 : _e.addAriaLabel) || "Add tab",
    onClick: function(at) {
      _.onEdit("add", {
        event: at
      });
    }
  }, _.addIcon || "+");
}), ExtraContent = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.position, _ = a.prefixCls, _e = a.extra;
  if (!_e)
    return null;
  var tt, nt = {};
  return _typeof$q(_e) === "object" && !/* @__PURE__ */ reactExports.isValidElement(_e) ? nt = _e : nt.right = _e, $ === "right" && (tt = nt.right), $ === "left" && (tt = nt.left), tt ? /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(_, "-extra-content"),
    ref: s
  }, tt) : null;
}), OperationNode = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = a.id, _e = a.tabs, tt = a.locale, nt = a.mobile, at = a.moreIcon, ot = at === void 0 ? "More" : at, rt = a.moreTransitionName, st = a.style, lt = a.className, et = a.editable, it = a.tabBarGutter, ut = a.rtl, ft = a.removeAriaLabel, ht = a.onTabClick, dt = a.getPopupContainer, gt = a.popupClassName, pt = reactExports.useState(!1), mt = _slicedToArray$e(pt, 2), ct = mt[0], vt = mt[1], At = reactExports.useState(null), xt = _slicedToArray$e(At, 2), bt = xt[0], Et = xt[1], St = "".concat(_, "-more-popup"), Bt = "".concat($, "-dropdown"), Ot = bt !== null ? "".concat(St, "-").concat(bt) : null, Pt = tt == null ? void 0 : tt.dropdownAriaLabel;
  function wt(Ht, Ft) {
    Ht.preventDefault(), Ht.stopPropagation(), et.onEdit("remove", {
      key: Ft,
      event: Ht
    });
  }
  var Ct = /* @__PURE__ */ reactExports.createElement(ExportMenu, {
    onClick: function(Ft) {
      var _t = Ft.key, Nt = Ft.domEvent;
      ht(_t, Nt), vt(!1);
    },
    prefixCls: "".concat(Bt, "-menu"),
    id: St,
    tabIndex: -1,
    role: "listbox",
    "aria-activedescendant": Ot,
    selectedKeys: [bt],
    "aria-label": Pt !== void 0 ? Pt : "expanded dropdown"
  }, _e.map(function(Ht) {
    var Ft = Ht.closable, _t = Ht.disabled, Nt = Ht.closeIcon, Mt = Ht.key, Lt = Ht.label, $t = getRemovable(Ft, Nt, et, _t);
    return /* @__PURE__ */ reactExports.createElement(MenuItem$2, {
      key: Mt,
      id: "".concat(St, "-").concat(Mt),
      role: "option",
      "aria-controls": _ && "".concat(_, "-panel-").concat(Mt),
      disabled: _t
    }, /* @__PURE__ */ reactExports.createElement("span", null, Lt), $t && /* @__PURE__ */ reactExports.createElement("button", {
      type: "button",
      "aria-label": ft || "remove",
      tabIndex: 0,
      className: "".concat(Bt, "-menu-item-remove"),
      onClick: function(Dt) {
        Dt.stopPropagation(), wt(Dt, Mt);
      }
    }, Nt || et.removeIcon || "×"));
  }));
  function It(Ht) {
    for (var Ft = _e.filter(function($t) {
      return !$t.disabled;
    }), _t = Ft.findIndex(function($t) {
      return $t.key === bt;
    }) || 0, Nt = Ft.length, Mt = 0; Mt < Nt; Mt += 1) {
      _t = (_t + Ht + Nt) % Nt;
      var Lt = Ft[_t];
      if (!Lt.disabled) {
        Et(Lt.key);
        return;
      }
    }
  }
  function yt(Ht) {
    var Ft = Ht.which;
    if (!ct) {
      [KeyCode.DOWN, KeyCode.SPACE, KeyCode.ENTER].includes(Ft) && (vt(!0), Ht.preventDefault());
      return;
    }
    switch (Ft) {
      case KeyCode.UP:
        It(-1), Ht.preventDefault();
        break;
      case KeyCode.DOWN:
        It(1), Ht.preventDefault();
        break;
      case KeyCode.ESC:
        vt(!1);
        break;
      case KeyCode.SPACE:
      case KeyCode.ENTER:
        bt !== null && ht(bt, Ht);
        break;
    }
  }
  reactExports.useEffect(function() {
    var Ht = document.getElementById(Ot);
    Ht && Ht.scrollIntoView && Ht.scrollIntoView(!1);
  }, [bt]), reactExports.useEffect(function() {
    ct || Et(null);
  }, [ct]);
  var Rt = _defineProperty$c({}, ut ? "marginRight" : "marginLeft", it);
  _e.length || (Rt.visibility = "hidden", Rt.order = 1);
  var kt = classnames(_defineProperty$c({}, "".concat(Bt, "-rtl"), ut)), jt = nt ? null : /* @__PURE__ */ reactExports.createElement(Dropdown$4, {
    prefixCls: Bt,
    overlay: Ct,
    trigger: ["hover"],
    visible: _e.length ? ct : !1,
    transitionName: rt,
    onVisibleChange: vt,
    overlayClassName: classnames(kt, gt),
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    getPopupContainer: dt
  }, /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    className: "".concat($, "-nav-more"),
    style: Rt,
    tabIndex: -1,
    "aria-hidden": "true",
    "aria-haspopup": "listbox",
    "aria-controls": St,
    id: "".concat(_, "-more"),
    "aria-expanded": ct,
    onKeyDown: yt
  }, ot));
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat($, "-nav-operations"), lt),
    style: st,
    ref: s
  }, jt, /* @__PURE__ */ reactExports.createElement(AddButton, {
    prefixCls: $,
    locale: tt,
    editable: et
  }));
});
const OperationNode$1 = /* @__PURE__ */ reactExports.memo(OperationNode, function(a, s) {
  return (
    // https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    s.tabMoving
  );
});
var TabNode = function a(s) {
  var $, _ = s.prefixCls, _e = s.id, tt = s.active, nt = s.tab, at = nt.key, ot = nt.label, rt = nt.disabled, st = nt.closeIcon, lt = nt.icon, et = s.closable, it = s.renderWrapper, ut = s.removeAriaLabel, ft = s.editable, ht = s.onClick, dt = s.onFocus, gt = s.style, pt = "".concat(_, "-tab"), mt = getRemovable(et, st, ft, rt);
  function ct(bt) {
    rt || ht(bt);
  }
  function vt(bt) {
    bt.preventDefault(), bt.stopPropagation(), ft.onEdit("remove", {
      key: at,
      event: bt
    });
  }
  var At = reactExports.useMemo(function() {
    return lt && typeof ot == "string" ? /* @__PURE__ */ reactExports.createElement("span", null, ot) : ot;
  }, [ot, lt]), xt = /* @__PURE__ */ reactExports.createElement("div", {
    key: at,
    "data-node-key": genDataNodeKey(at),
    className: classnames(pt, ($ = {}, _defineProperty$c($, "".concat(pt, "-with-remove"), mt), _defineProperty$c($, "".concat(pt, "-active"), tt), _defineProperty$c($, "".concat(pt, "-disabled"), rt), $)),
    style: gt,
    onClick: ct
  }, /* @__PURE__ */ reactExports.createElement("div", {
    role: "tab",
    "aria-selected": tt,
    id: _e && "".concat(_e, "-tab-").concat(at),
    className: "".concat(pt, "-btn"),
    "aria-controls": _e && "".concat(_e, "-panel-").concat(at),
    "aria-disabled": rt,
    tabIndex: rt ? null : 0,
    onClick: function(Et) {
      Et.stopPropagation(), ct(Et);
    },
    onKeyDown: function(Et) {
      [KeyCode.SPACE, KeyCode.ENTER].includes(Et.which) && (Et.preventDefault(), ct(Et));
    },
    onFocus: dt
  }, lt && /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(pt, "-icon")
  }, lt), ot && At), mt && /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    "aria-label": ut || "remove",
    tabIndex: 0,
    className: "".concat(pt, "-remove"),
    onClick: function(Et) {
      Et.stopPropagation(), vt(Et);
    }
  }, st || ft.removeIcon || "×"));
  return it ? it(xt) : xt;
}, getTabSize = function a(s, $) {
  var _ = s.offsetWidth, _e = s.offsetHeight, tt = s.offsetTop, nt = s.offsetLeft, at = s.getBoundingClientRect(), ot = at.width, rt = at.height, st = at.x, lt = at.y;
  return Math.abs(ot - _) < 1 ? [ot, rt, st - $.x, lt - $.y] : [_, _e, nt, tt];
}, getSize$2 = function a(s) {
  var $ = s.current || {}, _ = $.offsetWidth, _e = _ === void 0 ? 0 : _, tt = $.offsetHeight, nt = tt === void 0 ? 0 : tt;
  if (s.current) {
    var at = s.current.getBoundingClientRect(), ot = at.width, rt = at.height;
    if (Math.abs(ot - _e) < 1)
      return [ot, rt];
  }
  return [_e, nt];
}, getUnitValue = function a(s, $) {
  return s[$ ? 0 : 1];
}, TabNavList = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _ = a.className, _e = a.style, tt = a.id, nt = a.animated, at = a.activeKey, ot = a.rtl, rt = a.extra, st = a.editable, lt = a.locale, et = a.tabPosition, it = a.tabBarGutter, ut = a.children, ft = a.onTabClick, ht = a.onTabScroll, dt = a.indicatorSize, gt = reactExports.useContext(TabContext), pt = gt.prefixCls, mt = gt.tabs, ct = reactExports.useRef(null), vt = reactExports.useRef(null), At = reactExports.useRef(null), xt = reactExports.useRef(null), bt = reactExports.useRef(null), Et = reactExports.useRef(null), St = reactExports.useRef(null), Bt = et === "top" || et === "bottom", Ot = useSyncState$1(0, function(Yr, kr) {
    Bt && ht && ht({
      direction: Yr > kr ? "left" : "right"
    });
  }), Pt = _slicedToArray$e(Ot, 2), wt = Pt[0], Ct = Pt[1], It = useSyncState$1(0, function(Yr, kr) {
    !Bt && ht && ht({
      direction: Yr > kr ? "top" : "bottom"
    });
  }), yt = _slicedToArray$e(It, 2), Rt = yt[0], kt = yt[1], jt = reactExports.useState([0, 0]), Ht = _slicedToArray$e(jt, 2), Ft = Ht[0], _t = Ht[1], Nt = reactExports.useState([0, 0]), Mt = _slicedToArray$e(Nt, 2), Lt = Mt[0], $t = Mt[1], Tt = reactExports.useState([0, 0]), Dt = _slicedToArray$e(Tt, 2), Ut = Dt[0], Vt = Dt[1], Qt = reactExports.useState([0, 0]), qt = _slicedToArray$e(Qt, 2), Zt = qt[0], ar = qt[1], Jt = useUpdateState(/* @__PURE__ */ new Map()), rr = _slicedToArray$e(Jt, 2), Yt = rr[0], Kt = rr[1], nr = useOffsets(mt, Yt, Lt[0]), tr = getUnitValue(Ft, Bt), ir = getUnitValue(Lt, Bt), sr = getUnitValue(Ut, Bt), cr = getUnitValue(Zt, Bt), or = tr < ir + sr, Xt = or ? tr - cr : tr - sr, Gt = "".concat(pt, "-nav-operations-hidden"), Wt = 0, er = 0;
  Bt && ot ? (Wt = 0, er = Math.max(0, ir - Xt)) : (Wt = Math.min(0, Xt - ir), er = 0);
  function lr(Yr) {
    return Yr < Wt ? Wt : Yr > er ? er : Yr;
  }
  var ur = reactExports.useRef(null), pr = reactExports.useState(), yr = _slicedToArray$e(pr, 2), Er = yr[0], br = yr[1];
  function gr() {
    br(Date.now());
  }
  function Ar() {
    ur.current && clearTimeout(ur.current);
  }
  useTouchMove(xt, function(Yr, kr) {
    function Nr(Lr, zr) {
      Lr(function(Vr) {
        var an = lr(Vr + zr);
        return an;
      });
    }
    return or ? (Bt ? Nr(Ct, Yr) : Nr(kt, kr), Ar(), gr(), !0) : !1;
  }), reactExports.useEffect(function() {
    return Ar(), Er && (ur.current = setTimeout(function() {
      br(0);
    }, 100)), Ar;
  }, [Er]);
  var Sr = useVisibleRange(
    nr,
    // Container
    Xt,
    // Transform
    Bt ? wt : Rt,
    // Tabs
    ir,
    // Add
    sr,
    // Operation
    cr,
    _objectSpread2$a(_objectSpread2$a({}, a), {}, {
      tabs: mt
    })
  ), Br = _slicedToArray$e(Sr, 2), Ir = Br[0], hr = Br[1], vr = useEvent(function() {
    var Yr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : at, kr = nr.get(Yr) || {
      width: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0
    };
    if (Bt) {
      var Nr = wt;
      ot ? kr.right < wt ? Nr = kr.right : kr.right + kr.width > wt + Xt && (Nr = kr.right + kr.width - Xt) : kr.left < -wt ? Nr = -kr.left : kr.left + kr.width > -wt + Xt && (Nr = -(kr.left + kr.width - Xt)), kt(0), Ct(lr(Nr));
    } else {
      var Lr = Rt;
      kr.top < -Rt ? Lr = -kr.top : kr.top + kr.height > -Rt + Xt && (Lr = -(kr.top + kr.height - Xt)), Ct(0), kt(lr(Lr));
    }
  }), xr = {};
  et === "top" || et === "bottom" ? xr[ot ? "marginRight" : "marginLeft"] = it : xr.marginTop = it;
  var Pr = mt.map(function(Yr, kr) {
    var Nr = Yr.key;
    return /* @__PURE__ */ reactExports.createElement(TabNode, {
      id: tt,
      prefixCls: pt,
      key: Nr,
      tab: Yr,
      style: kr === 0 ? void 0 : xr,
      closable: Yr.closable,
      editable: st,
      active: Nr === at,
      renderWrapper: ut,
      removeAriaLabel: lt == null ? void 0 : lt.removeAriaLabel,
      onClick: function(zr) {
        ft(Nr, zr);
      },
      onFocus: function() {
        vr(Nr), gr(), xt.current && (ot || (xt.current.scrollLeft = 0), xt.current.scrollTop = 0);
      }
    });
  }), Rr = function() {
    return Kt(function() {
      var kr, Nr = /* @__PURE__ */ new Map(), Lr = (kr = bt.current) === null || kr === void 0 ? void 0 : kr.getBoundingClientRect();
      return mt.forEach(function(zr) {
        var Vr, an = zr.key, Zr = (Vr = bt.current) === null || Vr === void 0 ? void 0 : Vr.querySelector('[data-node-key="'.concat(genDataNodeKey(an), '"]'));
        if (Zr) {
          var un = getTabSize(Zr, Lr), Xr = _slicedToArray$e(un, 4), Kr = Xr[0], rn = Xr[1], nn = Xr[2], sn = Xr[3];
          Nr.set(an, {
            width: Kr,
            height: rn,
            left: nn,
            top: sn
          });
        }
      }), Nr;
    });
  };
  reactExports.useEffect(function() {
    Rr();
  }, [mt.map(function(Yr) {
    return Yr.key;
  }).join("_")]);
  var Dr = useUpdate(function() {
    var Yr = getSize$2(ct), kr = getSize$2(vt), Nr = getSize$2(At);
    _t([Yr[0] - kr[0] - Nr[0], Yr[1] - kr[1] - Nr[1]]);
    var Lr = getSize$2(St);
    Vt(Lr);
    var zr = getSize$2(Et);
    ar(zr);
    var Vr = getSize$2(bt);
    $t([Vr[0] - Lr[0], Vr[1] - Lr[1]]), Rr();
  }), Gr = mt.slice(0, Ir), Or = mt.slice(hr + 1), Hr = [].concat(_toConsumableArray$d(Gr), _toConsumableArray$d(Or)), jr = nr.get(at), Tr = useIndicator({
    activeTabOffset: jr,
    horizontal: Bt,
    rtl: ot,
    indicatorSize: dt
  }), fr = Tr.style;
  reactExports.useEffect(function() {
    vr();
  }, [at, Wt, er, stringify(jr), stringify(nr), Bt]), reactExports.useEffect(function() {
    Dr();
  }, [ot]);
  var Cr = !!Hr.length, $r = "".concat(pt, "-nav-wrap"), wr, Mr, Fr, Qr;
  return Bt ? ot ? (Mr = wt > 0, wr = wt !== er) : (wr = wt < 0, Mr = wt !== Wt) : (Fr = Rt < 0, Qr = Rt !== Wt), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Dr
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: useComposeRef(s, ct),
    role: "tablist",
    className: classnames("".concat(pt, "-nav"), _),
    style: _e,
    onKeyDown: function() {
      gr();
    }
  }, /* @__PURE__ */ reactExports.createElement(ExtraContent, {
    ref: vt,
    position: "left",
    extra: rt,
    prefixCls: pt
  }), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Dr
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames($r, ($ = {}, _defineProperty$c($, "".concat($r, "-ping-left"), wr), _defineProperty$c($, "".concat($r, "-ping-right"), Mr), _defineProperty$c($, "".concat($r, "-ping-top"), Fr), _defineProperty$c($, "".concat($r, "-ping-bottom"), Qr), $)),
    ref: xt
  }, /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Dr
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: bt,
    className: "".concat(pt, "-nav-list"),
    style: {
      transform: "translate(".concat(wt, "px, ").concat(Rt, "px)"),
      transition: Er ? "none" : void 0
    }
  }, Pr, /* @__PURE__ */ reactExports.createElement(AddButton, {
    ref: St,
    prefixCls: pt,
    locale: lt,
    editable: st,
    style: _objectSpread2$a(_objectSpread2$a({}, Pr.length === 0 ? void 0 : xr), {}, {
      visibility: Cr ? "hidden" : null
    })
  }), /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(pt, "-ink-bar"), _defineProperty$c({}, "".concat(pt, "-ink-bar-animated"), nt.inkBar)),
    style: fr
  }))))), /* @__PURE__ */ reactExports.createElement(OperationNode$1, _extends$2({}, a, {
    removeAriaLabel: lt == null ? void 0 : lt.removeAriaLabel,
    ref: Et,
    prefixCls: pt,
    tabs: Hr,
    className: !Cr && Gt,
    tabMoving: !!Er
  })), /* @__PURE__ */ reactExports.createElement(ExtraContent, {
    ref: At,
    position: "right",
    extra: rt,
    prefixCls: pt
  })));
}), TabPane$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = a.className, _e = a.style, tt = a.id, nt = a.active, at = a.tabKey, ot = a.children;
  return /* @__PURE__ */ reactExports.createElement("div", {
    id: tt && "".concat(tt, "-panel-").concat(at),
    role: "tabpanel",
    tabIndex: nt ? 0 : -1,
    "aria-labelledby": tt && "".concat(tt, "-tab-").concat(at),
    "aria-hidden": !nt,
    style: _e,
    className: classnames($, nt && "".concat($, "-active"), _),
    ref: s
  }, ot);
}), _excluded$v = ["renderTabBar"], _excluded2$6 = ["label", "key"], TabNavListWrapper = function a(s) {
  var $ = s.renderTabBar, _ = _objectWithoutProperties$1(s, _excluded$v), _e = reactExports.useContext(TabContext), tt = _e.tabs;
  if ($) {
    var nt = _objectSpread2$a(_objectSpread2$a({}, _), {}, {
      // Legacy support. We do not use this actually
      panes: tt.map(function(at) {
        var ot = at.label, rt = at.key, st = _objectWithoutProperties$1(at, _excluded2$6);
        return /* @__PURE__ */ reactExports.createElement(TabPane$2, _extends$2({
          tab: ot,
          key: rt,
          tabKey: rt
        }, st));
      })
    });
    return $(nt, TabNavList);
  }
  return /* @__PURE__ */ reactExports.createElement(TabNavList, _);
}, _excluded$u = ["key", "forceRender", "style", "className", "destroyInactiveTabPane"], TabPanelList = function a(s) {
  var $ = s.id, _ = s.activeKey, _e = s.animated, tt = s.tabPosition, nt = s.destroyInactiveTabPane, at = reactExports.useContext(TabContext), ot = at.prefixCls, rt = at.tabs, st = _e.tabPane, lt = "".concat(ot, "-tabpane");
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(ot, "-content-holder"))
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(ot, "-content"), "".concat(ot, "-content-").concat(tt), _defineProperty$c({}, "".concat(ot, "-content-animated"), st))
  }, rt.map(function(et) {
    var it = et.key, ut = et.forceRender, ft = et.style, ht = et.className, dt = et.destroyInactiveTabPane, gt = _objectWithoutProperties$1(et, _excluded$u), pt = it === _;
    return /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$2({
      key: it,
      visible: pt,
      forceRender: ut,
      removeOnLeave: !!(nt || dt),
      leavedClassName: "".concat(lt, "-hidden")
    }, _e.tabPaneMotion), function(mt, ct) {
      var vt = mt.style, At = mt.className;
      return /* @__PURE__ */ reactExports.createElement(TabPane$2, _extends$2({}, gt, {
        prefixCls: lt,
        id: $,
        tabKey: it,
        animated: st,
        active: pt,
        style: _objectSpread2$a(_objectSpread2$a({}, ft), vt),
        className: classnames(ht, At),
        ref: ct
      }));
    });
  })));
}, _excluded$t = ["id", "prefixCls", "className", "items", "direction", "activeKey", "defaultActiveKey", "editable", "animated", "tabPosition", "tabBarGutter", "tabBarStyle", "tabBarExtraContent", "locale", "moreIcon", "moreTransitionName", "destroyInactiveTabPane", "renderTabBar", "onChange", "onTabClick", "onTabScroll", "getPopupContainer", "popupClassName", "indicatorSize"], uuid$1 = 0, Tabs$1 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _ = a.id, _e = a.prefixCls, tt = _e === void 0 ? "rc-tabs" : _e, nt = a.className, at = a.items, ot = a.direction, rt = a.activeKey, st = a.defaultActiveKey, lt = a.editable, et = a.animated, it = a.tabPosition, ut = it === void 0 ? "top" : it, ft = a.tabBarGutter, ht = a.tabBarStyle, dt = a.tabBarExtraContent, gt = a.locale, pt = a.moreIcon, mt = a.moreTransitionName, ct = a.destroyInactiveTabPane, vt = a.renderTabBar, At = a.onChange, xt = a.onTabClick, bt = a.onTabScroll, Et = a.getPopupContainer, St = a.popupClassName, Bt = a.indicatorSize, Ot = _objectWithoutProperties$1(a, _excluded$t), Pt = reactExports.useMemo(function() {
    return (at || []).filter(function(ar) {
      return ar && _typeof$q(ar) === "object" && "key" in ar;
    });
  }, [at]), wt = ot === "rtl", Ct = useAnimateConfig$1(et), It = reactExports.useState(!1), yt = _slicedToArray$e(It, 2), Rt = yt[0], kt = yt[1];
  reactExports.useEffect(function() {
    kt(isMobile$1());
  }, []);
  var jt = useMergedState(function() {
    var ar;
    return (ar = Pt[0]) === null || ar === void 0 ? void 0 : ar.key;
  }, {
    value: rt,
    defaultValue: st
  }), Ht = _slicedToArray$e(jt, 2), Ft = Ht[0], _t = Ht[1], Nt = reactExports.useState(function() {
    return Pt.findIndex(function(ar) {
      return ar.key === Ft;
    });
  }), Mt = _slicedToArray$e(Nt, 2), Lt = Mt[0], $t = Mt[1];
  reactExports.useEffect(function() {
    var ar = Pt.findIndex(function(rr) {
      return rr.key === Ft;
    });
    if (ar === -1) {
      var Jt;
      ar = Math.max(0, Math.min(Lt, Pt.length - 1)), _t((Jt = Pt[ar]) === null || Jt === void 0 ? void 0 : Jt.key);
    }
    $t(ar);
  }, [Pt.map(function(ar) {
    return ar.key;
  }).join("_"), Ft, Lt]);
  var Tt = useMergedState(null, {
    value: _
  }), Dt = _slicedToArray$e(Tt, 2), Ut = Dt[0], Vt = Dt[1];
  reactExports.useEffect(function() {
    _ || (Vt("rc-tabs-".concat(uuid$1)), uuid$1 += 1);
  }, []);
  function Qt(ar, Jt) {
    xt == null || xt(ar, Jt);
    var rr = ar !== Ft;
    _t(ar), rr && (At == null || At(ar));
  }
  var qt = {
    id: Ut,
    activeKey: Ft,
    animated: Ct,
    tabPosition: ut,
    rtl: wt,
    mobile: Rt
  }, Zt = _objectSpread2$a(_objectSpread2$a({}, qt), {}, {
    editable: lt,
    locale: gt,
    moreIcon: pt,
    moreTransitionName: mt,
    tabBarGutter: ft,
    onTabClick: Qt,
    onTabScroll: bt,
    extra: dt,
    style: ht,
    panes: null,
    getPopupContainer: Et,
    popupClassName: St,
    indicatorSize: Bt
  });
  return /* @__PURE__ */ reactExports.createElement(TabContext.Provider, {
    value: {
      tabs: Pt,
      prefixCls: tt
    }
  }, /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    ref: s,
    id: _,
    className: classnames(tt, "".concat(tt, "-").concat(ut), ($ = {}, _defineProperty$c($, "".concat(tt, "-mobile"), Rt), _defineProperty$c($, "".concat(tt, "-editable"), lt), _defineProperty$c($, "".concat(tt, "-rtl"), wt), $), nt)
  }, Ot), /* @__PURE__ */ reactExports.createElement(TabNavListWrapper, _extends$2({}, Zt, {
    renderTabBar: vt
  })), /* @__PURE__ */ reactExports.createElement(TabPanelList, _extends$2({
    destroyInactiveTabPane: ct
  }, qt, {
    animated: Ct
  }))));
});
const motion = {
  motionAppear: !1,
  motionEnter: !0,
  motionLeave: !0
};
function useAnimateConfig(a) {
  let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    inkBar: !0,
    tabPane: !1
  }, $;
  return s === !1 ? $ = {
    inkBar: !1,
    tabPane: !1
  } : s === !0 ? $ = {
    inkBar: !0,
    tabPane: !0
  } : $ = Object.assign({
    inkBar: !0
  }, typeof s == "object" ? s : {}), $.tabPane && ($.tabPaneMotion = Object.assign(Object.assign({}, motion), {
    motionName: getTransitionName$1(a, "switch")
  })), $;
}
var __rest$M = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function filter(a) {
  return a.filter((s) => s);
}
function useLegacyItems(a, s) {
  if (a)
    return a;
  const $ = toArray$9(s).map((_) => {
    if (/* @__PURE__ */ reactExports.isValidElement(_)) {
      const {
        key: _e,
        props: tt
      } = _, nt = tt || {}, {
        tab: at
      } = nt, ot = __rest$M(nt, ["tab"]);
      return Object.assign(Object.assign({
        key: String(_e)
      }, ot), {
        label: at
      });
    }
    return null;
  });
  return filter($);
}
const genMotionStyle$4 = (a) => {
  const {
    componentCls: s,
    motionDurationSlow: $
  } = a;
  return [
    {
      [s]: {
        [`${s}-switch`]: {
          "&-appear, &-enter": {
            transition: "none",
            "&-start": {
              opacity: 0
            },
            "&-active": {
              opacity: 1,
              transition: `opacity ${$}`
            }
          },
          "&-leave": {
            position: "absolute",
            transition: "none",
            inset: 0,
            "&-start": {
              opacity: 1
            },
            "&-active": {
              opacity: 0,
              transition: `opacity ${$}`
            }
          }
        }
      }
    },
    // Follow code may reuse in other components
    [initSlideMotion(a, "slide-up"), initSlideMotion(a, "slide-down")]
  ];
}, genMotionStyle$5 = genMotionStyle$4, genCardStyle$1 = (a) => {
  const {
    componentCls: s,
    tabsCardPadding: $,
    cardBg: _,
    cardGutter: _e,
    colorBorderSecondary: tt,
    itemSelectedColor: nt
  } = a;
  return {
    [`${s}-card`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        [`${s}-tab`]: {
          margin: 0,
          padding: $,
          background: _,
          border: `${unit$1(a.lineWidth)} ${a.lineType} ${tt}`,
          transition: `all ${a.motionDurationSlow} ${a.motionEaseInOut}`
        },
        [`${s}-tab-active`]: {
          color: nt,
          background: a.colorBgContainer
        },
        [`${s}-ink-bar`]: {
          visibility: "hidden"
        }
      },
      // ========================== Top & Bottom ==========================
      [`&${s}-top, &${s}-bottom`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab + ${s}-tab`]: {
            marginLeft: {
              _skip_check_: !0,
              value: unit$1(_e)
            }
          }
        }
      },
      [`&${s}-top`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab`]: {
            borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0`
          },
          [`${s}-tab-active`]: {
            borderBottomColor: a.colorBgContainer
          }
        }
      },
      [`&${s}-bottom`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab`]: {
            borderRadius: `0 0 ${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)}`
          },
          [`${s}-tab-active`]: {
            borderTopColor: a.colorBgContainer
          }
        }
      },
      // ========================== Left & Right ==========================
      [`&${s}-left, &${s}-right`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab + ${s}-tab`]: {
            marginTop: unit$1(_e)
          }
        }
      },
      [`&${s}-left`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${unit$1(a.borderRadiusLG)} 0 0 ${unit$1(a.borderRadiusLG)}`
            }
          },
          [`${s}-tab-active`]: {
            borderRightColor: {
              _skip_check_: !0,
              value: a.colorBgContainer
            }
          }
        }
      },
      [`&${s}-right`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0`
            }
          },
          [`${s}-tab-active`]: {
            borderLeftColor: {
              _skip_check_: !0,
              value: a.colorBgContainer
            }
          }
        }
      }
    }
  };
}, genDropdownStyle = (a) => {
  const {
    componentCls: s,
    itemHoverColor: $,
    dropdownEdgeChildVerticalPadding: _
  } = a;
  return {
    [`${s}-dropdown`]: Object.assign(Object.assign({}, resetComponent(a)), {
      position: "absolute",
      top: -9999,
      left: {
        _skip_check_: !0,
        value: -9999
      },
      zIndex: a.zIndexPopup,
      display: "block",
      "&-hidden": {
        display: "none"
      },
      [`${s}-dropdown-menu`]: {
        maxHeight: a.tabsDropdownHeight,
        margin: 0,
        padding: `${unit$1(_)} 0`,
        overflowX: "hidden",
        overflowY: "auto",
        textAlign: {
          _skip_check_: !0,
          value: "left"
        },
        listStyleType: "none",
        backgroundColor: a.colorBgContainer,
        backgroundClip: "padding-box",
        borderRadius: a.borderRadiusLG,
        outline: "none",
        boxShadow: a.boxShadowSecondary,
        "&-item": Object.assign(Object.assign({}, textEllipsis), {
          display: "flex",
          alignItems: "center",
          minWidth: a.tabsDropdownWidth,
          margin: 0,
          padding: `${unit$1(a.paddingXXS)} ${unit$1(a.paddingSM)}`,
          color: a.colorText,
          fontWeight: "normal",
          fontSize: a.fontSize,
          lineHeight: a.lineHeight,
          cursor: "pointer",
          transition: `all ${a.motionDurationSlow}`,
          "> span": {
            flex: 1,
            whiteSpace: "nowrap"
          },
          "&-remove": {
            flex: "none",
            marginLeft: {
              _skip_check_: !0,
              value: a.marginSM
            },
            color: a.colorTextDescription,
            fontSize: a.fontSizeSM,
            background: "transparent",
            border: 0,
            cursor: "pointer",
            "&:hover": {
              color: $
            }
          },
          "&:hover": {
            background: a.controlItemBgHover
          },
          "&-disabled": {
            "&, &:hover": {
              color: a.colorTextDisabled,
              background: "transparent",
              cursor: "not-allowed"
            }
          }
        })
      }
    })
  };
}, genPositionStyle = (a) => {
  const {
    componentCls: s,
    margin: $,
    colorBorderSecondary: _,
    horizontalMargin: _e,
    verticalItemPadding: tt,
    verticalItemMargin: nt,
    calc: at
  } = a;
  return {
    // ========================== Top & Bottom ==========================
    [`${s}-top, ${s}-bottom`]: {
      flexDirection: "column",
      [`> ${s}-nav, > div > ${s}-nav`]: {
        margin: _e,
        "&::before": {
          position: "absolute",
          right: {
            _skip_check_: !0,
            value: 0
          },
          left: {
            _skip_check_: !0,
            value: 0
          },
          borderBottom: `${unit$1(a.lineWidth)} ${a.lineType} ${_}`,
          content: "''"
        },
        [`${s}-ink-bar`]: {
          height: a.lineWidthBold,
          "&-animated": {
            transition: `width ${a.motionDurationSlow}, left ${a.motionDurationSlow},
            right ${a.motionDurationSlow}`
          }
        },
        [`${s}-nav-wrap`]: {
          "&::before, &::after": {
            top: 0,
            bottom: 0,
            width: a.controlHeight
          },
          "&::before": {
            left: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: a.boxShadowTabsOverflowLeft
          },
          "&::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            boxShadow: a.boxShadowTabsOverflowRight
          },
          [`&${s}-nav-wrap-ping-left::before`]: {
            opacity: 1
          },
          [`&${s}-nav-wrap-ping-right::after`]: {
            opacity: 1
          }
        }
      }
    },
    [`${s}-top`]: {
      [`> ${s}-nav,
        > div > ${s}-nav`]: {
        "&::before": {
          bottom: 0
        },
        [`${s}-ink-bar`]: {
          bottom: 0
        }
      }
    },
    [`${s}-bottom`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        order: 1,
        marginTop: $,
        marginBottom: 0,
        "&::before": {
          top: 0
        },
        [`${s}-ink-bar`]: {
          top: 0
        }
      },
      [`> ${s}-content-holder, > div > ${s}-content-holder`]: {
        order: 0
      }
    },
    // ========================== Left & Right ==========================
    [`${s}-left, ${s}-right`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        flexDirection: "column",
        minWidth: at(a.controlHeight).mul(1.25).equal(),
        // >>>>>>>>>>> Tab
        [`${s}-tab`]: {
          padding: tt,
          textAlign: "center"
        },
        [`${s}-tab + ${s}-tab`]: {
          margin: nt
        },
        // >>>>>>>>>>> Nav
        [`${s}-nav-wrap`]: {
          flexDirection: "column",
          "&::before, &::after": {
            right: {
              _skip_check_: !0,
              value: 0
            },
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: a.controlHeight
          },
          "&::before": {
            top: 0,
            boxShadow: a.boxShadowTabsOverflowTop
          },
          "&::after": {
            bottom: 0,
            boxShadow: a.boxShadowTabsOverflowBottom
          },
          [`&${s}-nav-wrap-ping-top::before`]: {
            opacity: 1
          },
          [`&${s}-nav-wrap-ping-bottom::after`]: {
            opacity: 1
          }
        },
        // >>>>>>>>>>> Ink Bar
        [`${s}-ink-bar`]: {
          width: a.lineWidthBold,
          "&-animated": {
            transition: `height ${a.motionDurationSlow}, top ${a.motionDurationSlow}`
          }
        },
        [`${s}-nav-list, ${s}-nav-operations`]: {
          flex: "1 0 auto",
          // fix safari scroll problem
          flexDirection: "column"
        }
      }
    },
    [`${s}-left`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        [`${s}-ink-bar`]: {
          right: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${s}-content-holder, > div > ${s}-content-holder`]: {
        marginLeft: {
          _skip_check_: !0,
          value: unit$1(at(a.lineWidth).mul(-1).equal())
        },
        borderLeft: {
          _skip_check_: !0,
          value: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`
        },
        [`> ${s}-content > ${s}-tabpane`]: {
          paddingLeft: {
            _skip_check_: !0,
            value: a.paddingLG
          }
        }
      }
    },
    [`${s}-right`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        order: 1,
        [`${s}-ink-bar`]: {
          left: {
            _skip_check_: !0,
            value: 0
          }
        }
      },
      [`> ${s}-content-holder, > div > ${s}-content-holder`]: {
        order: 0,
        marginRight: {
          _skip_check_: !0,
          value: at(a.lineWidth).mul(-1).equal()
        },
        borderRight: {
          _skip_check_: !0,
          value: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`
        },
        [`> ${s}-content > ${s}-tabpane`]: {
          paddingRight: {
            _skip_check_: !0,
            value: a.paddingLG
          }
        }
      }
    }
  };
}, genSizeStyle$2 = (a) => {
  const {
    componentCls: s,
    cardPaddingSM: $,
    cardPaddingLG: _,
    horizontalItemPaddingSM: _e,
    horizontalItemPaddingLG: tt
  } = a;
  return {
    [s]: {
      "&-small": {
        [`> ${s}-nav`]: {
          [`${s}-tab`]: {
            padding: _e,
            fontSize: a.titleFontSizeSM
          }
        }
      },
      "&-large": {
        [`> ${s}-nav`]: {
          [`${s}-tab`]: {
            padding: tt,
            fontSize: a.titleFontSizeLG
          }
        }
      }
    },
    [`${s}-card`]: {
      [`&${s}-small`]: {
        [`> ${s}-nav`]: {
          [`${s}-tab`]: {
            padding: $
          }
        },
        [`&${s}-bottom`]: {
          [`> ${s}-nav ${s}-tab`]: {
            borderRadius: `0 0 ${unit$1(a.borderRadius)} ${unit$1(a.borderRadius)}`
          }
        },
        [`&${s}-top`]: {
          [`> ${s}-nav ${s}-tab`]: {
            borderRadius: `${unit$1(a.borderRadius)} ${unit$1(a.borderRadius)} 0 0`
          }
        },
        [`&${s}-right`]: {
          [`> ${s}-nav ${s}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `0 ${unit$1(a.borderRadius)} ${unit$1(a.borderRadius)} 0`
            }
          }
        },
        [`&${s}-left`]: {
          [`> ${s}-nav ${s}-tab`]: {
            borderRadius: {
              _skip_check_: !0,
              value: `${unit$1(a.borderRadius)} 0 0 ${unit$1(a.borderRadius)}`
            }
          }
        }
      },
      [`&${s}-large`]: {
        [`> ${s}-nav`]: {
          [`${s}-tab`]: {
            padding: _
          }
        }
      }
    }
  };
}, genTabStyle = (a) => {
  const {
    componentCls: s,
    itemActiveColor: $,
    itemHoverColor: _,
    iconCls: _e,
    tabsHorizontalItemMargin: tt,
    horizontalItemPadding: nt,
    itemSelectedColor: at,
    itemColor: ot
  } = a, rt = `${s}-tab`;
  return {
    [rt]: {
      position: "relative",
      WebkitTouchCallout: "none",
      WebkitTapHighlightColor: "transparent",
      display: "inline-flex",
      alignItems: "center",
      padding: nt,
      fontSize: a.titleFontSize,
      background: "transparent",
      border: 0,
      outline: "none",
      cursor: "pointer",
      color: ot,
      "&-btn, &-remove": Object.assign({
        "&:focus:not(:focus-visible), &:active": {
          color: $
        }
      }, genFocusStyle(a)),
      "&-btn": {
        outline: "none",
        transition: "all 0.3s",
        [`${rt}-icon:not(:last-child)`]: {
          marginInlineEnd: a.marginSM
        }
      },
      "&-remove": {
        flex: "none",
        marginRight: {
          _skip_check_: !0,
          value: a.calc(a.marginXXS).mul(-1).equal()
        },
        marginLeft: {
          _skip_check_: !0,
          value: a.marginXS
        },
        color: a.colorTextDescription,
        fontSize: a.fontSizeSM,
        background: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        transition: `all ${a.motionDurationSlow}`,
        "&:hover": {
          color: a.colorTextHeading
        }
      },
      "&:hover": {
        color: _
      },
      [`&${rt}-active ${rt}-btn`]: {
        color: at,
        textShadow: a.tabsActiveTextShadow
      },
      [`&${rt}-disabled`]: {
        color: a.colorTextDisabled,
        cursor: "not-allowed"
      },
      [`&${rt}-disabled ${rt}-btn, &${rt}-disabled ${s}-remove`]: {
        "&:focus, &:active": {
          color: a.colorTextDisabled
        }
      },
      [`& ${rt}-remove ${_e}`]: {
        margin: 0
      },
      [`${_e}:not(:last-child)`]: {
        marginRight: {
          _skip_check_: !0,
          value: a.marginSM
        }
      }
    },
    [`${rt} + ${rt}`]: {
      margin: {
        _skip_check_: !0,
        value: tt
      }
    }
  };
}, genRtlStyle$3 = (a) => {
  const {
    componentCls: s,
    tabsHorizontalItemMarginRTL: $,
    iconCls: _,
    cardGutter: _e,
    calc: tt
  } = a;
  return {
    [`${s}-rtl`]: {
      direction: "rtl",
      [`${s}-nav`]: {
        [`${s}-tab`]: {
          margin: {
            _skip_check_: !0,
            value: $
          },
          [`${s}-tab:last-of-type`]: {
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          },
          [_]: {
            marginRight: {
              _skip_check_: !0,
              value: 0
            },
            marginLeft: {
              _skip_check_: !0,
              value: unit$1(a.marginSM)
            }
          },
          [`${s}-tab-remove`]: {
            marginRight: {
              _skip_check_: !0,
              value: unit$1(a.marginXS)
            },
            marginLeft: {
              _skip_check_: !0,
              value: unit$1(tt(a.marginXXS).mul(-1).equal())
            },
            [_]: {
              margin: 0
            }
          }
        }
      },
      [`&${s}-left`]: {
        [`> ${s}-nav`]: {
          order: 1
        },
        [`> ${s}-content-holder`]: {
          order: 0
        }
      },
      [`&${s}-right`]: {
        [`> ${s}-nav`]: {
          order: 0
        },
        [`> ${s}-content-holder`]: {
          order: 1
        }
      },
      // ====================== Card ======================
      [`&${s}-card${s}-top, &${s}-card${s}-bottom`]: {
        [`> ${s}-nav, > div > ${s}-nav`]: {
          [`${s}-tab + ${s}-tab`]: {
            marginRight: {
              _skip_check_: !0,
              value: _e
            },
            marginLeft: {
              _skip_check_: !0,
              value: 0
            }
          }
        }
      }
    },
    [`${s}-dropdown-rtl`]: {
      direction: "rtl"
    },
    [`${s}-menu-item`]: {
      [`${s}-dropdown-rtl`]: {
        textAlign: {
          _skip_check_: !0,
          value: "right"
        }
      }
    }
  };
}, genTabsStyle = (a) => {
  const {
    componentCls: s,
    tabsCardPadding: $,
    cardHeight: _,
    cardGutter: _e,
    itemHoverColor: tt,
    itemActiveColor: nt,
    colorBorderSecondary: at
  } = a;
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
      display: "flex",
      // ========================== Navigation ==========================
      [`> ${s}-nav, > div > ${s}-nav`]: {
        position: "relative",
        display: "flex",
        flex: "none",
        alignItems: "center",
        [`${s}-nav-wrap`]: {
          position: "relative",
          display: "flex",
          flex: "auto",
          alignSelf: "stretch",
          overflow: "hidden",
          whiteSpace: "nowrap",
          transform: "translate(0)",
          // Fix chrome render bug
          // >>>>> Ping shadow
          "&::before, &::after": {
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            transition: `opacity ${a.motionDurationSlow}`,
            content: "''",
            pointerEvents: "none"
          }
        },
        [`${s}-nav-list`]: {
          position: "relative",
          display: "flex",
          transition: `opacity ${a.motionDurationSlow}`
        },
        // >>>>>>>> Operations
        [`${s}-nav-operations`]: {
          display: "flex",
          alignSelf: "stretch"
        },
        [`${s}-nav-operations-hidden`]: {
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        },
        [`${s}-nav-more`]: {
          position: "relative",
          padding: $,
          background: "transparent",
          border: 0,
          color: a.colorText,
          "&::after": {
            position: "absolute",
            right: {
              _skip_check_: !0,
              value: 0
            },
            bottom: 0,
            left: {
              _skip_check_: !0,
              value: 0
            },
            height: a.calc(a.controlHeightLG).div(8).equal(),
            transform: "translateY(100%)",
            content: "''"
          }
        },
        [`${s}-nav-add`]: Object.assign({
          minWidth: _,
          minHeight: _,
          marginLeft: {
            _skip_check_: !0,
            value: _e
          },
          padding: `0 ${unit$1(a.paddingXS)}`,
          background: "transparent",
          border: `${unit$1(a.lineWidth)} ${a.lineType} ${at}`,
          borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0`,
          outline: "none",
          cursor: "pointer",
          color: a.colorText,
          transition: `all ${a.motionDurationSlow} ${a.motionEaseInOut}`,
          "&:hover": {
            color: tt
          },
          "&:active, &:focus:not(:focus-visible)": {
            color: nt
          }
        }, genFocusStyle(a))
      },
      [`${s}-extra-content`]: {
        flex: "none"
      },
      // ============================ InkBar ============================
      [`${s}-ink-bar`]: {
        position: "absolute",
        background: a.inkBarColor,
        pointerEvents: "none"
      }
    }), genTabStyle(a)), {
      // =========================== TabPanes ===========================
      [`${s}-content`]: {
        position: "relative",
        width: "100%"
      },
      [`${s}-content-holder`]: {
        flex: "auto",
        minWidth: 0,
        minHeight: 0
      },
      [`${s}-tabpane`]: {
        outline: "none",
        "&-hidden": {
          display: "none"
        }
      }
    }),
    [`${s}-centered`]: {
      [`> ${s}-nav, > div > ${s}-nav`]: {
        [`${s}-nav-wrap`]: {
          [`&:not([class*='${s}-nav-wrap-ping'])`]: {
            justifyContent: "center"
          }
        }
      }
    }
  };
}, prepareComponentToken$j = (a) => {
  const s = a.controlHeightLG;
  return {
    zIndexPopup: a.zIndexPopupBase + 50,
    cardBg: a.colorFillAlter,
    cardHeight: s,
    // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
    cardPadding: `${(s - Math.round(a.fontSize * a.lineHeight)) / 2 - a.lineWidth}px ${a.padding}px`,
    cardPaddingSM: `${a.paddingXXS * 1.5}px ${a.padding}px`,
    cardPaddingLG: `${a.paddingXS}px ${a.padding}px ${a.paddingXXS * 1.5}px`,
    titleFontSize: a.fontSize,
    titleFontSizeLG: a.fontSizeLG,
    titleFontSizeSM: a.fontSize,
    inkBarColor: a.colorPrimary,
    horizontalMargin: `0 0 ${a.margin}px 0`,
    horizontalItemGutter: 32,
    // Fixed Value
    // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
    horizontalItemMargin: "",
    horizontalItemMarginRTL: "",
    horizontalItemPadding: `${a.paddingSM}px 0`,
    horizontalItemPaddingSM: `${a.paddingXS}px 0`,
    horizontalItemPaddingLG: `${a.padding}px 0`,
    verticalItemPadding: `${a.paddingXS}px ${a.paddingLG}px`,
    verticalItemMargin: `${a.margin}px 0 0 0`,
    itemColor: a.colorText,
    itemSelectedColor: a.colorPrimary,
    itemHoverColor: a.colorPrimaryHover,
    itemActiveColor: a.colorPrimaryActive,
    cardGutter: a.marginXXS / 2
  };
}, useStyle$k = genStyleHooks("Tabs", (a) => {
  const s = merge(a, {
    // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
    tabsCardPadding: a.cardPadding,
    dropdownEdgeChildVerticalPadding: a.paddingXXS,
    tabsActiveTextShadow: "0 0 0.25px currentcolor",
    tabsDropdownHeight: 200,
    tabsDropdownWidth: 120,
    tabsHorizontalItemMargin: `0 0 0 ${unit$1(a.horizontalItemGutter)}`,
    tabsHorizontalItemMarginRTL: `0 0 0 ${unit$1(a.horizontalItemGutter)}`
  });
  return [genSizeStyle$2(s), genRtlStyle$3(s), genPositionStyle(s), genDropdownStyle(s), genCardStyle$1(s), genTabsStyle(s), genMotionStyle$5(s)];
}, prepareComponentToken$j), TabPane = () => null, TabPane$1 = TabPane;
var __rest$L = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Tabs = (a) => {
  const {
    type: s,
    className: $,
    rootClassName: _,
    size: _e,
    onEdit: tt,
    hideAdd: nt,
    centered: at,
    addIcon: ot,
    popupClassName: rt,
    children: st,
    items: lt,
    animated: et,
    style: it,
    indicatorSize: ut
  } = a, ft = __rest$L(a, ["type", "className", "rootClassName", "size", "onEdit", "hideAdd", "centered", "addIcon", "popupClassName", "children", "items", "animated", "style", "indicatorSize"]), {
    prefixCls: ht,
    moreIcon: dt = /* @__PURE__ */ reactExports.createElement(EllipsisOutlined$1, null)
  } = ft, {
    direction: gt,
    tabs: pt,
    getPrefixCls: mt,
    getPopupContainer: ct
  } = reactExports.useContext(ConfigContext$1), vt = mt("tabs", ht), At = useCSSVarCls$1(vt), [xt, bt, Et] = useStyle$k(vt, At);
  let St;
  s === "editable-card" && (St = {
    onEdit: (It, yt) => {
      let {
        key: Rt,
        event: kt
      } = yt;
      tt == null || tt(It === "add" ? kt : Rt, It);
    },
    removeIcon: /* @__PURE__ */ reactExports.createElement(CloseOutlined$4, null),
    addIcon: ot || /* @__PURE__ */ reactExports.createElement(PlusOutlined$4, null),
    showAdd: nt !== !0
  });
  const Bt = mt(), Ot = useLegacyItems(lt, st), Pt = useAnimateConfig(vt, et), wt = useSize$1(_e), Ct = Object.assign(Object.assign({}, pt == null ? void 0 : pt.style), it);
  return xt(/* @__PURE__ */ reactExports.createElement(Tabs$1, Object.assign({
    direction: gt,
    getPopupContainer: ct,
    moreTransitionName: `${Bt}-slide-up`
  }, ft, {
    items: Ot,
    className: classnames({
      [`${vt}-${wt}`]: wt,
      [`${vt}-card`]: ["card", "editable-card"].includes(s),
      [`${vt}-editable-card`]: s === "editable-card",
      [`${vt}-centered`]: at
    }, pt == null ? void 0 : pt.className, $, _, bt, Et, At),
    popupClassName: classnames(rt, bt, Et, At),
    style: Ct,
    editable: St,
    moreIcon: dt,
    prefixCls: vt,
    animated: Pt,
    indicatorSize: ut ?? (pt == null ? void 0 : pt.indicatorSize)
  })));
};
Tabs.TabPane = TabPane$1;
const _Tabs = Tabs;
var __rest$K = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Grid$1 = (a) => {
  var {
    prefixCls: s,
    className: $,
    hoverable: _ = !0
  } = a, _e = __rest$K(a, ["prefixCls", "className", "hoverable"]);
  const {
    getPrefixCls: tt
  } = reactExports.useContext(ConfigContext$1), nt = tt("card", s), at = classnames(`${nt}-grid`, $, {
    [`${nt}-grid-hoverable`]: _
  });
  return /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, _e, {
    className: at
  }));
}, Grid$2 = Grid$1, genCardHeadStyle = (a) => {
  const {
    antCls: s,
    componentCls: $,
    headerHeight: _,
    cardPaddingBase: _e,
    tabsMarginBottom: tt
  } = a;
  return Object.assign(Object.assign({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    minHeight: _,
    marginBottom: -1,
    padding: `0 ${unit$1(_e)}`,
    color: a.colorTextHeading,
    fontWeight: a.fontWeightStrong,
    fontSize: a.headerFontSize,
    background: a.headerBg,
    borderBottom: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorderSecondary}`,
    borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0`
  }, clearFix()), {
    "&-wrapper": {
      width: "100%",
      display: "flex",
      alignItems: "center"
    },
    "&-title": Object.assign(Object.assign({
      display: "inline-block",
      flex: 1
    }, textEllipsis), {
      [`
          > ${$}-typography,
          > ${$}-typography-edit-content
        `]: {
        insetInlineStart: 0,
        marginTop: 0,
        marginBottom: 0
      }
    }),
    [`${s}-tabs-top`]: {
      clear: "both",
      marginBottom: tt,
      color: a.colorText,
      fontWeight: "normal",
      fontSize: a.fontSize,
      "&-bar": {
        borderBottom: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorderSecondary}`
      }
    }
  });
}, genCardGridStyle = (a) => {
  const {
    cardPaddingBase: s,
    colorBorderSecondary: $,
    cardShadow: _,
    lineWidth: _e
  } = a;
  return {
    width: "33.33%",
    padding: s,
    border: 0,
    borderRadius: 0,
    boxShadow: `
      ${unit$1(_e)} 0 0 0 ${$},
      0 ${unit$1(_e)} 0 0 ${$},
      ${unit$1(_e)} ${unit$1(_e)} 0 0 ${$},
      ${unit$1(_e)} 0 0 0 ${$} inset,
      0 ${unit$1(_e)} 0 0 ${$} inset;
    `,
    transition: `all ${a.motionDurationMid}`,
    "&-hoverable:hover": {
      position: "relative",
      zIndex: 1,
      boxShadow: _
    }
  };
}, genCardActionsStyle = (a) => {
  const {
    componentCls: s,
    iconCls: $,
    actionsLiMargin: _,
    cardActionsIconSize: _e,
    colorBorderSecondary: tt,
    actionsBg: nt
  } = a;
  return Object.assign(Object.assign({
    margin: 0,
    padding: 0,
    listStyle: "none",
    background: nt,
    borderTop: `${unit$1(a.lineWidth)} ${a.lineType} ${tt}`,
    display: "flex",
    borderRadius: `0 0 ${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)}`
  }, clearFix()), {
    "& > li": {
      margin: _,
      color: a.colorTextDescription,
      textAlign: "center",
      "> span": {
        position: "relative",
        display: "block",
        minWidth: a.calc(a.cardActionsIconSize).mul(2).equal(),
        fontSize: a.fontSize,
        lineHeight: a.lineHeight,
        cursor: "pointer",
        "&:hover": {
          color: a.colorPrimary,
          transition: `color ${a.motionDurationMid}`
        },
        [`a:not(${s}-btn), > ${$}`]: {
          display: "inline-block",
          width: "100%",
          color: a.colorTextDescription,
          lineHeight: unit$1(a.fontHeight),
          transition: `color ${a.motionDurationMid}`,
          "&:hover": {
            color: a.colorPrimary
          }
        },
        [`> ${$}`]: {
          fontSize: _e,
          lineHeight: unit$1(a.calc(_e).mul(a.lineHeight).equal())
        }
      },
      "&:not(:last-child)": {
        borderInlineEnd: `${unit$1(a.lineWidth)} ${a.lineType} ${tt}`
      }
    }
  });
}, genCardMetaStyle = (a) => Object.assign(Object.assign({
  margin: `${unit$1(a.calc(a.marginXXS).mul(-1).equal())} 0`,
  display: "flex"
}, clearFix()), {
  "&-avatar": {
    paddingInlineEnd: a.padding
  },
  "&-detail": {
    overflow: "hidden",
    flex: 1,
    "> div:not(:last-child)": {
      marginBottom: a.marginXS
    }
  },
  "&-title": Object.assign({
    color: a.colorTextHeading,
    fontWeight: a.fontWeightStrong,
    fontSize: a.fontSizeLG
  }, textEllipsis),
  "&-description": {
    color: a.colorTextDescription
  }
}), genCardTypeInnerStyle = (a) => {
  const {
    componentCls: s,
    cardPaddingBase: $,
    colorFillAlter: _
  } = a;
  return {
    [`${s}-head`]: {
      padding: `0 ${unit$1($)}`,
      background: _,
      "&-title": {
        fontSize: a.fontSize
      }
    },
    [`${s}-body`]: {
      padding: `${unit$1(a.padding)} ${unit$1($)}`
    }
  };
}, genCardLoadingStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    overflow: "hidden",
    [`${s}-body`]: {
      userSelect: "none"
    }
  };
}, genCardStyle = (a) => {
  const {
    antCls: s,
    componentCls: $,
    cardShadow: _,
    cardHeadPadding: _e,
    colorBorderSecondary: tt,
    boxShadowTertiary: nt,
    cardPaddingBase: at,
    extraColor: ot
  } = a;
  return {
    [$]: Object.assign(Object.assign({}, resetComponent(a)), {
      position: "relative",
      background: a.colorBgContainer,
      borderRadius: a.borderRadiusLG,
      [`&:not(${$}-bordered)`]: {
        boxShadow: nt
      },
      [`${$}-head`]: genCardHeadStyle(a),
      [`${$}-extra`]: {
        // https://stackoverflow.com/a/22429853/3040605
        marginInlineStart: "auto",
        color: ot,
        fontWeight: "normal",
        fontSize: a.fontSize
      },
      [`${$}-body`]: Object.assign({
        padding: at,
        borderRadius: ` 0 0 ${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)}`
      }, clearFix()),
      [`${$}-grid`]: genCardGridStyle(a),
      [`${$}-cover`]: {
        "> *": {
          display: "block",
          width: "100%"
        },
        [`img, img + ${s}-image-mask`]: {
          borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0`
        }
      },
      [`${$}-actions`]: genCardActionsStyle(a),
      [`${$}-meta`]: genCardMetaStyle(a)
    }),
    [`${$}-bordered`]: {
      border: `${unit$1(a.lineWidth)} ${a.lineType} ${tt}`,
      [`${$}-cover`]: {
        marginTop: -1,
        marginInlineStart: -1,
        marginInlineEnd: -1
      }
    },
    [`${$}-hoverable`]: {
      cursor: "pointer",
      transition: `box-shadow ${a.motionDurationMid}, border-color ${a.motionDurationMid}`,
      "&:hover": {
        borderColor: "transparent",
        boxShadow: _
      }
    },
    [`${$}-contain-grid`]: {
      borderRadius: `${unit$1(a.borderRadiusLG)} ${unit$1(a.borderRadiusLG)} 0 0 `,
      [`${$}-body`]: {
        display: "flex",
        flexWrap: "wrap"
      },
      [`&:not(${$}-loading) ${$}-body`]: {
        marginBlockStart: a.calc(a.lineWidth).mul(-1).equal(),
        marginInlineStart: a.calc(a.lineWidth).mul(-1).equal(),
        padding: 0
      }
    },
    [`${$}-contain-tabs`]: {
      [`> ${$}-head`]: {
        minHeight: 0,
        [`${$}-head-title, ${$}-extra`]: {
          paddingTop: _e
        }
      }
    },
    [`${$}-type-inner`]: genCardTypeInnerStyle(a),
    [`${$}-loading`]: genCardLoadingStyle(a),
    [`${$}-rtl`]: {
      direction: "rtl"
    }
  };
}, genCardSizeStyle = (a) => {
  const {
    componentCls: s,
    cardPaddingSM: $,
    headerHeightSM: _,
    headerFontSizeSM: _e
  } = a;
  return {
    [`${s}-small`]: {
      [`> ${s}-head`]: {
        minHeight: _,
        padding: `0 ${unit$1($)}`,
        fontSize: _e,
        [`> ${s}-head-wrapper`]: {
          [`> ${s}-extra`]: {
            fontSize: a.fontSize
          }
        }
      },
      [`> ${s}-body`]: {
        padding: $
      }
    },
    [`${s}-small${s}-contain-tabs`]: {
      [`> ${s}-head`]: {
        [`${s}-head-title, ${s}-extra`]: {
          paddingTop: 0,
          display: "flex",
          alignItems: "center"
        }
      }
    }
  };
}, prepareComponentToken$i = (a) => ({
  headerBg: "transparent",
  headerFontSize: a.fontSizeLG,
  headerFontSizeSM: a.fontSize,
  headerHeight: a.fontSizeLG * a.lineHeightLG + a.padding * 2,
  headerHeightSM: a.fontSize * a.lineHeight + a.paddingXS * 2,
  actionsBg: a.colorBgContainer,
  actionsLiMargin: `${a.paddingSM}px 0`,
  tabsMarginBottom: -a.padding - a.lineWidth,
  extraColor: a.colorText
}), useStyle$j = genStyleHooks("Card", (a) => {
  const s = merge(a, {
    cardShadow: a.boxShadowCard,
    cardHeadPadding: a.padding,
    cardPaddingBase: a.paddingLG,
    cardActionsIconSize: a.fontSize,
    cardPaddingSM: 12
    // Fixed padding.
  });
  return [
    // Style
    genCardStyle(s),
    // Size
    genCardSizeStyle(s)
  ];
}, prepareComponentToken$i);
var __rest$J = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const ActionNode = (a) => {
  const {
    prefixCls: s,
    actions: $ = []
  } = a;
  return /* @__PURE__ */ reactExports.createElement("ul", {
    className: `${s}-actions`
  }, $.map((_, _e) => {
    const tt = `action-${_e}`;
    return /* @__PURE__ */ reactExports.createElement("li", {
      style: {
        width: `${100 / $.length}%`
      },
      key: tt
    }, /* @__PURE__ */ reactExports.createElement("span", null, _));
  }));
}, Card$1 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: $,
    className: _,
    rootClassName: _e,
    style: tt,
    extra: nt,
    headStyle: at = {},
    bodyStyle: ot = {},
    title: rt,
    loading: st,
    bordered: lt = !0,
    size: et,
    type: it,
    cover: ut,
    actions: ft,
    tabList: ht,
    children: dt,
    activeTabKey: gt,
    defaultActiveTabKey: pt,
    tabBarExtraContent: mt,
    hoverable: ct,
    tabProps: vt = {}
  } = a, At = __rest$J(a, ["prefixCls", "className", "rootClassName", "style", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent", "hoverable", "tabProps"]), {
    getPrefixCls: xt,
    direction: bt,
    card: Et
  } = reactExports.useContext(ConfigContext$1), St = (Dt) => {
    var Ut;
    (Ut = a.onTabChange) === null || Ut === void 0 || Ut.call(a, Dt);
  }, Bt = reactExports.useMemo(() => {
    let Dt = !1;
    return reactExports.Children.forEach(dt, (Ut) => {
      Ut && Ut.type && Ut.type === Grid$2 && (Dt = !0);
    }), Dt;
  }, [dt]), Ot = xt("card", $), [Pt, wt, Ct] = useStyle$j(Ot), It = /* @__PURE__ */ reactExports.createElement(Skeleton$1, {
    loading: !0,
    active: !0,
    paragraph: {
      rows: 4
    },
    title: !1
  }, dt), yt = gt !== void 0, Rt = Object.assign(Object.assign({}, vt), {
    [yt ? "activeKey" : "defaultActiveKey"]: yt ? gt : pt,
    tabBarExtraContent: mt
  });
  let kt;
  const jt = useSize$1(et), Ht = !jt || jt === "default" ? "large" : jt, Ft = ht ? /* @__PURE__ */ reactExports.createElement(_Tabs, Object.assign({
    size: Ht
  }, Rt, {
    className: `${Ot}-head-tabs`,
    onChange: St,
    items: ht.map((Dt) => {
      var {
        tab: Ut
      } = Dt, Vt = __rest$J(Dt, ["tab"]);
      return Object.assign({
        label: Ut
      }, Vt);
    })
  })) : null;
  (rt || nt || Ft) && (kt = /* @__PURE__ */ reactExports.createElement("div", {
    className: `${Ot}-head`,
    style: at
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${Ot}-head-wrapper`
  }, rt && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${Ot}-head-title`
  }, rt), nt && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${Ot}-extra`
  }, nt)), Ft));
  const _t = ut ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${Ot}-cover`
  }, ut) : null, Nt = /* @__PURE__ */ reactExports.createElement("div", {
    className: `${Ot}-body`,
    style: ot
  }, st ? It : dt), Mt = ft && ft.length ? /* @__PURE__ */ reactExports.createElement(ActionNode, {
    prefixCls: Ot,
    actions: ft
  }) : null, Lt = omit(At, ["onTabChange"]), $t = classnames(Ot, Et == null ? void 0 : Et.className, {
    [`${Ot}-loading`]: st,
    [`${Ot}-bordered`]: lt,
    [`${Ot}-hoverable`]: ct,
    [`${Ot}-contain-grid`]: Bt,
    [`${Ot}-contain-tabs`]: ht && ht.length,
    [`${Ot}-${jt}`]: jt,
    [`${Ot}-type-${it}`]: !!it,
    [`${Ot}-rtl`]: bt === "rtl"
  }, _, _e, wt, Ct), Tt = Object.assign(Object.assign({}, Et == null ? void 0 : Et.style), tt);
  return Pt(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    ref: s
  }, Lt, {
    className: $t,
    style: Tt
  }), kt, _t, Nt, Mt));
}), InternalCard = Card$1;
var __rest$I = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Meta = (a) => {
  const {
    prefixCls: s,
    className: $,
    avatar: _,
    title: _e,
    description: tt
  } = a, nt = __rest$I(a, ["prefixCls", "className", "avatar", "title", "description"]), {
    getPrefixCls: at
  } = reactExports.useContext(ConfigContext$1), ot = at("card", s), rt = classnames(`${ot}-meta`, $), st = _ ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${ot}-meta-avatar`
  }, _) : null, lt = _e ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${ot}-meta-title`
  }, _e) : null, et = tt ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${ot}-meta-description`
  }, tt) : null, it = lt || et ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${ot}-meta-detail`
  }, lt, et) : null;
  return /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, nt, {
    className: rt
  }), st, it);
}, Meta$1 = Meta, Card = InternalCard;
Card.Grid = Grid$2;
Card.Meta = Meta$1;
const _Card = Card;
function throttle$1(a, s, $) {
  var _ = $ || {}, _e = _.noTrailing, tt = _e === void 0 ? !1 : _e, nt = _.noLeading, at = nt === void 0 ? !1 : nt, ot = _.debounceMode, rt = ot === void 0 ? void 0 : ot, st, lt = !1, et = 0;
  function it() {
    st && clearTimeout(st);
  }
  function ut(ht) {
    var dt = ht || {}, gt = dt.upcomingOnly, pt = gt === void 0 ? !1 : gt;
    it(), lt = !pt;
  }
  function ft() {
    for (var ht = arguments.length, dt = new Array(ht), gt = 0; gt < ht; gt++)
      dt[gt] = arguments[gt];
    var pt = this, mt = Date.now() - et;
    if (lt)
      return;
    function ct() {
      et = Date.now(), s.apply(pt, dt);
    }
    function vt() {
      st = void 0;
    }
    !at && rt && !st && ct(), it(), rt === void 0 && mt > a ? at ? (et = Date.now(), tt || (st = setTimeout(rt ? vt : ct, a))) : ct() : tt !== !0 && (st = setTimeout(rt ? vt : ct, rt === void 0 ? a - mt : a));
  }
  return ft.cancel = ut, ft;
}
function debounce(a, s, $) {
  var _ = $ || {}, _e = _.atBegin, tt = _e === void 0 ? !1 : _e;
  return throttle$1(a, s, {
    debounceMode: tt !== !1
  });
}
function getEntity(a, s) {
  return a[s];
}
var _excluded$s = ["children"];
function getPosition$2(a, s) {
  return "".concat(a, "-").concat(s);
}
function isTreeNode(a) {
  return a && a.type && a.type.isTreeNode;
}
function getKey$1(a, s) {
  return a ?? s;
}
function fillFieldNames$1(a) {
  var s = a || {}, $ = s.title, _ = s._title, _e = s.key, tt = s.children, nt = $ || "title";
  return {
    title: nt,
    _title: _ || [nt],
    key: _e || "key",
    children: tt || "children"
  };
}
function convertTreeToData(a) {
  function s($) {
    var _ = toArray$9($);
    return _.map(function(_e) {
      if (!isTreeNode(_e))
        return warningOnce(!_e, "Tree/TreeNode can only accept TreeNode as children."), null;
      var tt = _e.key, nt = _e.props, at = nt.children, ot = _objectWithoutProperties$1(nt, _excluded$s), rt = _objectSpread2$a({
        key: tt
      }, ot), st = s(at);
      return st.length && (rt.children = st), rt;
    }).filter(function(_e) {
      return _e;
    });
  }
  return s(a);
}
function flattenTreeData(a, s, $) {
  var _ = fillFieldNames$1($), _e = _._title, tt = _.key, nt = _.children, at = new Set(s === !0 ? [] : s), ot = [];
  function rt(st) {
    var lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return st.map(function(et, it) {
      for (var ut = getPosition$2(lt ? lt.pos : "0", it), ft = getKey$1(et[tt], ut), ht, dt = 0; dt < _e.length; dt += 1) {
        var gt = _e[dt];
        if (et[gt] !== void 0) {
          ht = et[gt];
          break;
        }
      }
      var pt = _objectSpread2$a(_objectSpread2$a({}, omit(et, [].concat(_toConsumableArray$d(_e), [tt, nt]))), {}, {
        title: ht,
        key: ft,
        parent: lt,
        pos: ut,
        children: null,
        data: et,
        isStart: [].concat(_toConsumableArray$d(lt ? lt.isStart : []), [it === 0]),
        isEnd: [].concat(_toConsumableArray$d(lt ? lt.isEnd : []), [it === st.length - 1])
      });
      return ot.push(pt), s === !0 || at.has(ft) ? pt.children = rt(et[nt] || [], pt) : pt.children = [], pt;
    });
  }
  return rt(a), ot;
}
function traverseDataNodes(a, s, $) {
  var _ = {};
  _typeof$q($) === "object" ? _ = $ : _ = {
    externalGetKey: $
  }, _ = _ || {};
  var _e = _, tt = _e.childrenPropName, nt = _e.externalGetKey, at = _e.fieldNames, ot = fillFieldNames$1(at), rt = ot.key, st = ot.children, lt = tt || st, et;
  nt ? typeof nt == "string" ? et = function(ft) {
    return ft[nt];
  } : typeof nt == "function" && (et = function(ft) {
    return nt(ft);
  }) : et = function(ft, ht) {
    return getKey$1(ft[rt], ht);
  };
  function it(ut, ft, ht, dt) {
    var gt = ut ? ut[lt] : a, pt = ut ? getPosition$2(ht.pos, ft) : "0", mt = ut ? [].concat(_toConsumableArray$d(dt), [ut]) : [];
    if (ut) {
      var ct = et(ut, pt), vt = {
        node: ut,
        index: ft,
        pos: pt,
        key: ct,
        parentPos: ht.node ? ht.pos : null,
        level: ht.level + 1,
        nodes: mt
      };
      s(vt);
    }
    gt && gt.forEach(function(At, xt) {
      it(At, xt, {
        node: ut,
        pos: pt,
        level: ht ? ht.level + 1 : -1
      }, mt);
    });
  }
  it(null);
}
function convertDataToEntities(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, $ = s.initWrapper, _ = s.processEntity, _e = s.onProcessFinished, tt = s.externalGetKey, nt = s.childrenPropName, at = s.fieldNames, ot = arguments.length > 2 ? arguments[2] : void 0, rt = tt || ot, st = {}, lt = {}, et = {
    posEntities: st,
    keyEntities: lt
  };
  return $ && (et = $(et) || et), traverseDataNodes(a, function(it) {
    var ut = it.node, ft = it.index, ht = it.pos, dt = it.key, gt = it.parentPos, pt = it.level, mt = it.nodes, ct = {
      node: ut,
      nodes: mt,
      index: ft,
      key: dt,
      pos: ht,
      level: pt
    }, vt = getKey$1(dt, ht);
    st[ht] = ct, lt[vt] = ct, ct.parent = st[gt], ct.parent && (ct.parent.children = ct.parent.children || [], ct.parent.children.push(ct)), _ && _(ct, et);
  }, {
    externalGetKey: rt,
    childrenPropName: nt,
    fieldNames: at
  }), _e && _e(et), et;
}
function getTreeNodeProps(a, s) {
  var $ = s.expandedKeys, _ = s.selectedKeys, _e = s.loadedKeys, tt = s.loadingKeys, nt = s.checkedKeys, at = s.halfCheckedKeys, ot = s.dragOverNodeKey, rt = s.dropPosition, st = s.keyEntities, lt = getEntity(st, a), et = {
    eventKey: a,
    expanded: $.indexOf(a) !== -1,
    selected: _.indexOf(a) !== -1,
    loaded: _e.indexOf(a) !== -1,
    loading: tt.indexOf(a) !== -1,
    checked: nt.indexOf(a) !== -1,
    halfChecked: at.indexOf(a) !== -1,
    pos: String(lt ? lt.pos : ""),
    // [Legacy] Drag props
    // Since the interaction of drag is changed, the semantic of the props are
    // not accuracy, I think it should be finally removed
    dragOver: ot === a && rt === 0,
    dragOverGapTop: ot === a && rt === -1,
    dragOverGapBottom: ot === a && rt === 1
  };
  return et;
}
function convertNodePropsToEventData(a) {
  var s = a.data, $ = a.expanded, _ = a.selected, _e = a.checked, tt = a.loaded, nt = a.loading, at = a.halfChecked, ot = a.dragOver, rt = a.dragOverGapTop, st = a.dragOverGapBottom, lt = a.pos, et = a.active, it = a.eventKey, ut = _objectSpread2$a(_objectSpread2$a({}, s), {}, {
    expanded: $,
    selected: _,
    checked: _e,
    loaded: tt,
    loading: nt,
    halfChecked: at,
    dragOver: ot,
    dragOverGapTop: rt,
    dragOverGapBottom: st,
    pos: lt,
    active: et,
    key: it
  });
  return "props" in ut || Object.defineProperty(ut, "props", {
    get: function() {
      return warningOnce(!1, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`."), a;
    }
  }), ut;
}
function removeFromCheckedKeys(a, s) {
  var $ = /* @__PURE__ */ new Set();
  return a.forEach(function(_) {
    s.has(_) || $.add(_);
  }), $;
}
function isCheckDisabled$1(a) {
  var s = a || {}, $ = s.disabled, _ = s.disableCheckbox, _e = s.checkable;
  return !!($ || _) || _e === !1;
}
function fillConductCheck(a, s, $, _) {
  for (var _e = new Set(a), tt = /* @__PURE__ */ new Set(), nt = 0; nt <= $; nt += 1) {
    var at = s.get(nt) || /* @__PURE__ */ new Set();
    at.forEach(function(lt) {
      var et = lt.key, it = lt.node, ut = lt.children, ft = ut === void 0 ? [] : ut;
      _e.has(et) && !_(it) && ft.filter(function(ht) {
        return !_(ht.node);
      }).forEach(function(ht) {
        _e.add(ht.key);
      });
    });
  }
  for (var ot = /* @__PURE__ */ new Set(), rt = $; rt >= 0; rt -= 1) {
    var st = s.get(rt) || /* @__PURE__ */ new Set();
    st.forEach(function(lt) {
      var et = lt.parent, it = lt.node;
      if (!(_(it) || !lt.parent || ot.has(lt.parent.key))) {
        if (_(lt.parent.node)) {
          ot.add(et.key);
          return;
        }
        var ut = !0, ft = !1;
        (et.children || []).filter(function(ht) {
          return !_(ht.node);
        }).forEach(function(ht) {
          var dt = ht.key, gt = _e.has(dt);
          ut && !gt && (ut = !1), !ft && (gt || tt.has(dt)) && (ft = !0);
        }), ut && _e.add(et.key), ft && tt.add(et.key), ot.add(et.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(_e),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(tt, _e))
  };
}
function cleanConductCheck(a, s, $, _, _e) {
  for (var tt = new Set(a), nt = new Set(s), at = 0; at <= _; at += 1) {
    var ot = $.get(at) || /* @__PURE__ */ new Set();
    ot.forEach(function(et) {
      var it = et.key, ut = et.node, ft = et.children, ht = ft === void 0 ? [] : ft;
      !tt.has(it) && !nt.has(it) && !_e(ut) && ht.filter(function(dt) {
        return !_e(dt.node);
      }).forEach(function(dt) {
        tt.delete(dt.key);
      });
    });
  }
  nt = /* @__PURE__ */ new Set();
  for (var rt = /* @__PURE__ */ new Set(), st = _; st >= 0; st -= 1) {
    var lt = $.get(st) || /* @__PURE__ */ new Set();
    lt.forEach(function(et) {
      var it = et.parent, ut = et.node;
      if (!(_e(ut) || !et.parent || rt.has(et.parent.key))) {
        if (_e(et.parent.node)) {
          rt.add(it.key);
          return;
        }
        var ft = !0, ht = !1;
        (it.children || []).filter(function(dt) {
          return !_e(dt.node);
        }).forEach(function(dt) {
          var gt = dt.key, pt = tt.has(gt);
          ft && !pt && (ft = !1), !ht && (pt || nt.has(gt)) && (ht = !0);
        }), ft || tt.delete(it.key), ht && nt.add(it.key), rt.add(it.key);
      }
    });
  }
  return {
    checkedKeys: Array.from(tt),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(nt, tt))
  };
}
function conductCheck(a, s, $, _) {
  var _e = [], tt;
  _ ? tt = _ : tt = isCheckDisabled$1;
  var nt = new Set(a.filter(function(st) {
    var lt = !!getEntity($, st);
    return lt || _e.push(st), lt;
  })), at = /* @__PURE__ */ new Map(), ot = 0;
  Object.keys($).forEach(function(st) {
    var lt = $[st], et = lt.level, it = at.get(et);
    it || (it = /* @__PURE__ */ new Set(), at.set(et, it)), it.add(lt), ot = Math.max(ot, et);
  }), warningOnce(!_e.length, "Tree missing follow keys: ".concat(_e.slice(0, 100).map(function(st) {
    return "'".concat(st, "'");
  }).join(", ")));
  var rt;
  return s === !0 ? rt = fillConductCheck(nt, at, ot, tt) : rt = cleanConductCheck(nt, s.halfCheckedKeys, at, ot, tt), rt;
}
const genCheckboxStyle = (a) => {
  const {
    checkboxCls: s
  } = a, $ = `${s}-wrapper`;
  return [
    // ===================== Basic =====================
    {
      // Group
      [`${s}-group`]: Object.assign(Object.assign({}, resetComponent(a)), {
        display: "inline-flex",
        flexWrap: "wrap",
        columnGap: a.marginXS,
        // Group > Grid
        [`> ${a.antCls}-row`]: {
          flex: 1
        }
      }),
      // Wrapper
      [$]: Object.assign(Object.assign({}, resetComponent(a)), {
        display: "inline-flex",
        alignItems: "baseline",
        cursor: "pointer",
        // Fix checkbox & radio in flex align #30260
        "&:after": {
          display: "inline-block",
          width: 0,
          overflow: "hidden",
          content: "'\\a0'"
        },
        // Checkbox near checkbox
        [`& + ${$}`]: {
          marginInlineStart: 0
        },
        [`&${$}-in-form-item`]: {
          'input[type="checkbox"]': {
            width: 14,
            // FIXME: magic
            height: 14
            // FIXME: magic
          }
        }
      }),
      // Wrapper > Checkbox
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        position: "relative",
        whiteSpace: "nowrap",
        lineHeight: 1,
        cursor: "pointer",
        borderRadius: a.borderRadiusSM,
        // To make alignment right when `controlHeight` is changed
        // Ref: https://github.com/ant-design/ant-design/issues/41564
        alignSelf: "center",
        // Wrapper > Checkbox > input
        [`${s}-input`]: {
          position: "absolute",
          // Since baseline align will get additional space offset,
          // we need to move input to top to make it align with text.
          // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
          inset: 0,
          zIndex: 1,
          cursor: "pointer",
          opacity: 0,
          margin: 0,
          [`&:focus-visible + ${s}-inner`]: Object.assign({}, genFocusOutline(a))
        },
        // Wrapper > Checkbox > inner
        [`${s}-inner`]: {
          boxSizing: "border-box",
          display: "block",
          width: a.checkboxSize,
          height: a.checkboxSize,
          direction: "ltr",
          backgroundColor: a.colorBgContainer,
          border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
          borderRadius: a.borderRadiusSM,
          borderCollapse: "separate",
          transition: `all ${a.motionDurationSlow}`,
          "&:after": {
            boxSizing: "border-box",
            position: "absolute",
            top: "50%",
            insetInlineStart: "25%",
            display: "table",
            width: a.calc(a.checkboxSize).div(14).mul(5).equal(),
            height: a.calc(a.checkboxSize).div(14).mul(8).equal(),
            border: `${unit$1(a.lineWidthBold)} solid ${a.colorWhite}`,
            borderTop: 0,
            borderInlineStart: 0,
            transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
            opacity: 0,
            content: '""',
            transition: `all ${a.motionDurationFast} ${a.motionEaseInBack}, opacity ${a.motionDurationFast}`
          }
        },
        // Wrapper > Checkbox + Text
        "& + span": {
          paddingInlineStart: a.paddingXS,
          paddingInlineEnd: a.paddingXS
        }
      })
    },
    // ===================== Hover =====================
    {
      // Wrapper & Wrapper > Checkbox
      [`
        ${$}:not(${$}-disabled),
        ${s}:not(${s}-disabled)
      `]: {
        [`&:hover ${s}-inner`]: {
          borderColor: a.colorPrimary
        }
      },
      [`${$}:not(${$}-disabled)`]: {
        [`&:hover ${s}-checked:not(${s}-disabled) ${s}-inner`]: {
          backgroundColor: a.colorPrimaryHover,
          borderColor: "transparent"
        },
        [`&:hover ${s}-checked:not(${s}-disabled):after`]: {
          borderColor: a.colorPrimaryHover
        }
      }
    },
    // ==================== Checked ====================
    {
      // Wrapper > Checkbox
      [`${s}-checked`]: {
        [`${s}-inner`]: {
          backgroundColor: a.colorPrimary,
          borderColor: a.colorPrimary,
          "&:after": {
            opacity: 1,
            transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
            transition: `all ${a.motionDurationMid} ${a.motionEaseOutBack} ${a.motionDurationFast}`
          }
        }
      },
      [`
        ${$}-checked:not(${$}-disabled),
        ${s}-checked:not(${s}-disabled)
      `]: {
        [`&:hover ${s}-inner`]: {
          backgroundColor: a.colorPrimaryHover,
          borderColor: "transparent"
        }
      }
    },
    // ================= Indeterminate =================
    {
      [s]: {
        "&-indeterminate": {
          // Wrapper > Checkbox > inner
          [`${s}-inner`]: {
            backgroundColor: a.colorBgContainer,
            borderColor: a.colorBorder,
            "&:after": {
              top: "50%",
              insetInlineStart: "50%",
              width: a.calc(a.fontSizeLG).div(2).equal(),
              height: a.calc(a.fontSizeLG).div(2).equal(),
              backgroundColor: a.colorPrimary,
              border: 0,
              transform: "translate(-50%, -50%) scale(1)",
              opacity: 1,
              content: '""'
            }
          }
        }
      }
    },
    // ==================== Disable ====================
    {
      // Wrapper
      [`${$}-disabled`]: {
        cursor: "not-allowed"
      },
      // Wrapper > Checkbox
      [`${s}-disabled`]: {
        // Wrapper > Checkbox > input
        [`&, ${s}-input`]: {
          cursor: "not-allowed",
          // Disabled for native input to enable Tooltip event handler
          // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
          pointerEvents: "none"
        },
        // Wrapper > Checkbox > inner
        [`${s}-inner`]: {
          background: a.colorBgContainerDisabled,
          borderColor: a.colorBorder,
          "&:after": {
            borderColor: a.colorTextDisabled
          }
        },
        "&:after": {
          display: "none"
        },
        "& + span": {
          color: a.colorTextDisabled
        },
        [`&${s}-indeterminate ${s}-inner::after`]: {
          background: a.colorTextDisabled
        }
      }
    }
  ];
};
function getStyle$1(a, s) {
  const $ = merge(s, {
    checkboxCls: `.${a}`,
    checkboxSize: s.controlInteractiveSize
  });
  return [genCheckboxStyle($)];
}
const useStyle$i = genStyleHooks("Checkbox", (a, s) => {
  let {
    prefixCls: $
  } = s;
  return [getStyle$1($, a)];
}), GroupContext = /* @__PURE__ */ React$a.createContext(null), GroupContext$1 = GroupContext;
var __rest$H = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const InternalCheckbox = (a, s) => {
  var $;
  const {
    prefixCls: _,
    className: _e,
    rootClassName: tt,
    children: nt,
    indeterminate: at = !1,
    style: ot,
    onMouseEnter: rt,
    onMouseLeave: st,
    skipGroup: lt = !1,
    disabled: et
  } = a, it = __rest$H(a, ["prefixCls", "className", "rootClassName", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]), {
    getPrefixCls: ut,
    direction: ft,
    checkbox: ht
  } = reactExports.useContext(ConfigContext$1), dt = reactExports.useContext(GroupContext$1), {
    isFormItemInput: gt
  } = reactExports.useContext(FormItemInputContext), pt = reactExports.useContext(DisabledContext$1), mt = ($ = (dt == null ? void 0 : dt.disabled) || et) !== null && $ !== void 0 ? $ : pt, ct = reactExports.useRef(it.value);
  reactExports.useEffect(() => {
    dt == null || dt.registerValue(it.value);
  }, []), reactExports.useEffect(() => {
    if (!lt)
      return it.value !== ct.current && (dt == null || dt.cancelValue(ct.current), dt == null || dt.registerValue(it.value), ct.current = it.value), () => dt == null ? void 0 : dt.cancelValue(it.value);
  }, [it.value]);
  const vt = ut("checkbox", _), At = useCSSVarCls$1(vt), [xt, bt, Et] = useStyle$i(vt, At), St = Object.assign({}, it);
  dt && !lt && (St.onChange = function() {
    it.onChange && it.onChange.apply(it, arguments), dt.toggleOption && dt.toggleOption({
      label: nt,
      value: it.value
    });
  }, St.name = dt.name, St.checked = dt.value.includes(it.value));
  const Bt = classnames(`${vt}-wrapper`, {
    [`${vt}-rtl`]: ft === "rtl",
    [`${vt}-wrapper-checked`]: St.checked,
    [`${vt}-wrapper-disabled`]: mt,
    [`${vt}-wrapper-in-form-item`]: gt
  }, ht == null ? void 0 : ht.className, _e, tt, Et, At, bt), Ot = classnames({
    [`${vt}-indeterminate`]: at
  }, TARGET_CLS, bt), Pt = at ? "mixed" : void 0;
  return xt(/* @__PURE__ */ reactExports.createElement(Wave$1, {
    component: "Checkbox",
    disabled: mt
  }, /* @__PURE__ */ reactExports.createElement("label", {
    className: Bt,
    style: Object.assign(Object.assign({}, ht == null ? void 0 : ht.style), ot),
    onMouseEnter: rt,
    onMouseLeave: st
  }, /* @__PURE__ */ reactExports.createElement(Checkbox$3, Object.assign({
    "aria-checked": Pt
  }, St, {
    prefixCls: vt,
    className: Ot,
    disabled: mt,
    ref: s
  })), nt !== void 0 && /* @__PURE__ */ reactExports.createElement("span", null, nt))));
}, Checkbox$2 = /* @__PURE__ */ reactExports.forwardRef(InternalCheckbox), InternalCheckbox$1 = Checkbox$2;
var __rest$G = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const InternalGroup = (a, s) => {
  const {
    defaultValue: $,
    children: _,
    options: _e = [],
    prefixCls: tt,
    className: nt,
    rootClassName: at,
    style: ot,
    onChange: rt
  } = a, st = __rest$G(a, ["defaultValue", "children", "options", "prefixCls", "className", "rootClassName", "style", "onChange"]), {
    getPrefixCls: lt,
    direction: et
  } = reactExports.useContext(ConfigContext$1), [it, ut] = reactExports.useState(st.value || $ || []), [ft, ht] = reactExports.useState([]);
  reactExports.useEffect(() => {
    "value" in st && ut(st.value || []);
  }, [st.value]);
  const dt = reactExports.useMemo(() => _e.map((wt) => typeof wt == "string" || typeof wt == "number" ? {
    label: wt,
    value: wt
  } : wt), [_e]), gt = (wt) => {
    ht((Ct) => Ct.filter((It) => It !== wt));
  }, pt = (wt) => {
    ht((Ct) => [].concat(_toConsumableArray$d(Ct), [wt]));
  }, mt = (wt) => {
    const Ct = it.indexOf(wt.value), It = _toConsumableArray$d(it);
    Ct === -1 ? It.push(wt.value) : It.splice(Ct, 1), "value" in st || ut(It), rt == null || rt(It.filter((yt) => ft.includes(yt)).sort((yt, Rt) => {
      const kt = dt.findIndex((Ht) => Ht.value === yt), jt = dt.findIndex((Ht) => Ht.value === Rt);
      return kt - jt;
    }));
  }, ct = lt("checkbox", tt), vt = `${ct}-group`, At = useCSSVarCls$1(ct), [xt, bt, Et] = useStyle$i(ct, At), St = omit(st, ["value", "disabled"]), Bt = _e.length ? dt.map((wt) => /* @__PURE__ */ reactExports.createElement(InternalCheckbox$1, {
    prefixCls: ct,
    key: wt.value.toString(),
    disabled: "disabled" in wt ? wt.disabled : st.disabled,
    value: wt.value,
    checked: it.includes(wt.value),
    onChange: wt.onChange,
    className: `${vt}-item`,
    style: wt.style,
    title: wt.title,
    id: wt.id,
    required: wt.required
  }, wt.label)) : _, Ot = {
    toggleOption: mt,
    value: it,
    disabled: st.disabled,
    name: st.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue: pt,
    cancelValue: gt
  }, Pt = classnames(vt, {
    [`${vt}-rtl`]: et === "rtl"
  }, nt, at, Et, At, bt);
  return xt(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    className: Pt,
    style: ot
  }, St, {
    ref: s
  }), /* @__PURE__ */ reactExports.createElement(GroupContext$1.Provider, {
    value: Ot
  }, Bt)));
}, CheckboxGroup = /* @__PURE__ */ reactExports.forwardRef(InternalGroup), Group$3 = /* @__PURE__ */ reactExports.memo(CheckboxGroup), Checkbox$1 = InternalCheckbox$1;
Checkbox$1.Group = Group$3;
Checkbox$1.__ANT_CHECKBOX = !0;
const _Checkbox = Checkbox$1, RowContext = /* @__PURE__ */ reactExports.createContext({}), RowContext$1 = RowContext, genGridRowStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    // Grid system
    [s]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around": {
        justifyContent: "space-around"
      },
      "&-space-evenly": {
        justifyContent: "space-evenly"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
}, genGridColStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    // Grid system
    [s]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
}, genLoopGridColumnsStyle = (a, s) => {
  const {
    componentCls: $,
    gridColumns: _
  } = a, _e = {};
  for (let tt = _; tt >= 0; tt--)
    tt === 0 ? (_e[`${$}${s}-${tt}`] = {
      display: "none"
    }, _e[`${$}-push-${tt}`] = {
      insetInlineStart: "auto"
    }, _e[`${$}-pull-${tt}`] = {
      insetInlineEnd: "auto"
    }, _e[`${$}${s}-push-${tt}`] = {
      insetInlineStart: "auto"
    }, _e[`${$}${s}-pull-${tt}`] = {
      insetInlineEnd: "auto"
    }, _e[`${$}${s}-offset-${tt}`] = {
      marginInlineStart: 0
    }, _e[`${$}${s}-order-${tt}`] = {
      order: 0
    }) : (_e[`${$}${s}-${tt}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        "--ant-display": "block",
        // Fallback to display if variable not support
        display: "block"
      },
      {
        display: "var(--ant-display)",
        flex: `0 0 ${tt / _ * 100}%`,
        maxWidth: `${tt / _ * 100}%`
      }
    ], _e[`${$}${s}-push-${tt}`] = {
      insetInlineStart: `${tt / _ * 100}%`
    }, _e[`${$}${s}-pull-${tt}`] = {
      insetInlineEnd: `${tt / _ * 100}%`
    }, _e[`${$}${s}-offset-${tt}`] = {
      marginInlineStart: `${tt / _ * 100}%`
    }, _e[`${$}${s}-order-${tt}`] = {
      order: tt
    });
  return _e;
}, genGridStyle = (a, s) => genLoopGridColumnsStyle(a, s), genGridMediaStyle = (a, s, $) => ({
  [`@media (min-width: ${unit$1(s)})`]: Object.assign({}, genGridStyle(a, $))
}), prepareRowComponentToken = () => ({}), prepareColComponentToken = () => ({}), useRowStyle = genStyleHooks("Grid", genGridRowStyle, prepareRowComponentToken), useColStyle = genStyleHooks("Grid", (a) => {
  const s = merge(a, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  }), $ = {
    "-sm": s.screenSMMin,
    "-md": s.screenMDMin,
    "-lg": s.screenLGMin,
    "-xl": s.screenXLMin,
    "-xxl": s.screenXXLMin
  };
  return [genGridColStyle(s), genGridStyle(s, ""), genGridStyle(s, "-xs"), Object.keys($).map((_) => genGridMediaStyle(s, $[_], _)).reduce((_, _e) => Object.assign(Object.assign({}, _), _e), {})];
}, prepareColComponentToken);
var __rest$F = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function parseFlex(a) {
  return typeof a == "number" ? `${a} ${a} auto` : /^\d+(\.\d+)?(px|em|rem|%)$/.test(a) ? `0 0 ${a}` : a;
}
const sizes = ["xs", "sm", "md", "lg", "xl", "xxl"], Col = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    getPrefixCls: $,
    direction: _
  } = reactExports.useContext(ConfigContext$1), {
    gutter: _e,
    wrap: tt
  } = reactExports.useContext(RowContext$1), {
    prefixCls: nt,
    span: at,
    order: ot,
    offset: rt,
    push: st,
    pull: lt,
    className: et,
    children: it,
    flex: ut,
    style: ft
  } = a, ht = __rest$F(a, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]), dt = $("col", nt), [gt, pt, mt] = useColStyle(dt);
  let ct = {};
  sizes.forEach((xt) => {
    let bt = {};
    const Et = a[xt];
    typeof Et == "number" ? bt.span = Et : typeof Et == "object" && (bt = Et || {}), delete ht[xt], ct = Object.assign(Object.assign({}, ct), {
      [`${dt}-${xt}-${bt.span}`]: bt.span !== void 0,
      [`${dt}-${xt}-order-${bt.order}`]: bt.order || bt.order === 0,
      [`${dt}-${xt}-offset-${bt.offset}`]: bt.offset || bt.offset === 0,
      [`${dt}-${xt}-push-${bt.push}`]: bt.push || bt.push === 0,
      [`${dt}-${xt}-pull-${bt.pull}`]: bt.pull || bt.pull === 0,
      [`${dt}-${xt}-flex-${bt.flex}`]: bt.flex || bt.flex === "auto",
      [`${dt}-rtl`]: _ === "rtl"
    });
  });
  const vt = classnames(dt, {
    [`${dt}-${at}`]: at !== void 0,
    [`${dt}-order-${ot}`]: ot,
    [`${dt}-offset-${rt}`]: rt,
    [`${dt}-push-${st}`]: st,
    [`${dt}-pull-${lt}`]: lt
  }, et, ct, pt, mt), At = {};
  if (_e && _e[0] > 0) {
    const xt = _e[0] / 2;
    At.paddingLeft = xt, At.paddingRight = xt;
  }
  return ut && (At.flex = parseFlex(ut), tt === !1 && !At.minWidth && (At.minWidth = 0)), gt(/* @__PURE__ */ reactExports.createElement("div", Object.assign({}, ht, {
    style: Object.assign(Object.assign({}, At), ft),
    className: vt,
    ref: s
  }), it));
}), Col$1 = Col;
var __rest$E = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function useMergePropByScreen(a, s) {
  const [$, _] = reactExports.useState(typeof a == "string" ? a : ""), _e = () => {
    if (typeof a == "string" && _(a), typeof a == "object")
      for (let tt = 0; tt < responsiveArray.length; tt++) {
        const nt = responsiveArray[tt];
        if (!s[nt])
          continue;
        const at = a[nt];
        if (at !== void 0) {
          _(at);
          return;
        }
      }
  };
  return reactExports.useEffect(() => {
    _e();
  }, [JSON.stringify(a), s]), $;
}
const Row = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: $,
    justify: _,
    align: _e,
    className: tt,
    style: nt,
    children: at,
    gutter: ot = 0,
    wrap: rt
  } = a, st = __rest$E(a, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]), {
    getPrefixCls: lt,
    direction: et
  } = reactExports.useContext(ConfigContext$1), [it, ut] = reactExports.useState({
    xs: !0,
    sm: !0,
    md: !0,
    lg: !0,
    xl: !0,
    xxl: !0
  }), [ft, ht] = reactExports.useState({
    xs: !1,
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1,
    xxl: !1
  }), dt = useMergePropByScreen(_e, ft), gt = useMergePropByScreen(_, ft), pt = reactExports.useRef(ot), mt = useResponsiveObserver();
  reactExports.useEffect(() => {
    const It = mt.subscribe((yt) => {
      ht(yt);
      const Rt = pt.current || 0;
      (!Array.isArray(Rt) && typeof Rt == "object" || Array.isArray(Rt) && (typeof Rt[0] == "object" || typeof Rt[1] == "object")) && ut(yt);
    });
    return () => mt.unsubscribe(It);
  }, []);
  const ct = () => {
    const It = [void 0, void 0];
    return (Array.isArray(ot) ? ot : [ot, void 0]).forEach((Rt, kt) => {
      if (typeof Rt == "object")
        for (let jt = 0; jt < responsiveArray.length; jt++) {
          const Ht = responsiveArray[jt];
          if (it[Ht] && Rt[Ht] !== void 0) {
            It[kt] = Rt[Ht];
            break;
          }
        }
      else
        It[kt] = Rt;
    }), It;
  }, vt = lt("row", $), [At, xt, bt] = useRowStyle(vt), Et = ct(), St = classnames(vt, {
    [`${vt}-no-wrap`]: rt === !1,
    [`${vt}-${gt}`]: gt,
    [`${vt}-${dt}`]: dt,
    [`${vt}-rtl`]: et === "rtl"
  }, tt, xt, bt), Bt = {}, Ot = Et[0] != null && Et[0] > 0 ? Et[0] / -2 : void 0;
  Ot && (Bt.marginLeft = Ot, Bt.marginRight = Ot), [, Bt.rowGap] = Et;
  const [Pt, wt] = Et, Ct = reactExports.useMemo(() => ({
    gutter: [Pt, wt],
    wrap: rt
  }), [Pt, wt, rt]);
  return At(/* @__PURE__ */ reactExports.createElement(RowContext$1.Provider, {
    value: Ct
  }, /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, st, {
    className: St,
    style: Object.assign(Object.assign({}, Bt), nt),
    ref: s
  }), at)));
}), Row$1 = Row;
var PanelContent = /* @__PURE__ */ React$a.forwardRef(function(a, s) {
  var $, _ = a.prefixCls, _e = a.forceRender, tt = a.className, nt = a.style, at = a.children, ot = a.isActive, rt = a.role, st = React$a.useState(ot || _e), lt = _slicedToArray$e(st, 2), et = lt[0], it = lt[1];
  return React$a.useEffect(function() {
    (_e || ot) && it(!0);
  }, [_e, ot]), et ? /* @__PURE__ */ React$a.createElement("div", {
    ref: s,
    className: classnames("".concat(_, "-content"), ($ = {}, _defineProperty$c($, "".concat(_, "-content-active"), ot), _defineProperty$c($, "".concat(_, "-content-inactive"), !ot), $), tt),
    style: nt,
    role: rt
  }, /* @__PURE__ */ React$a.createElement("div", {
    className: "".concat(_, "-content-box")
  }, at)) : null;
});
PanelContent.displayName = "PanelContent";
var _excluded$r = ["showArrow", "headerClass", "isActive", "onItemClick", "forceRender", "className", "prefixCls", "collapsible", "accordion", "panelKey", "extra", "header", "expandIcon", "openMotion", "destroyInactivePanel", "children"], CollapsePanel$2 = /* @__PURE__ */ React$a.forwardRef(function(a, s) {
  var $, _, _e = a.showArrow, tt = _e === void 0 ? !0 : _e, nt = a.headerClass, at = a.isActive, ot = a.onItemClick, rt = a.forceRender, st = a.className, lt = a.prefixCls, et = a.collapsible, it = a.accordion, ut = a.panelKey, ft = a.extra, ht = a.header, dt = a.expandIcon, gt = a.openMotion, pt = a.destroyInactivePanel, mt = a.children, ct = _objectWithoutProperties$1(a, _excluded$r), vt = et === "disabled", At = et === "header", xt = et === "icon", bt = ft != null && typeof ft != "boolean", Et = function() {
    ot == null || ot(ut);
  }, St = function(It) {
    (It.key === "Enter" || It.keyCode === KeyCode.ENTER || It.which === KeyCode.ENTER) && Et();
  }, Bt = typeof dt == "function" ? dt(a) : /* @__PURE__ */ React$a.createElement("i", {
    className: "arrow"
  });
  Bt && (Bt = /* @__PURE__ */ React$a.createElement("div", {
    className: "".concat(lt, "-expand-icon"),
    onClick: ["header", "icon"].includes(et) ? Et : void 0
  }, Bt));
  var Ot = classnames(($ = {}, _defineProperty$c($, "".concat(lt, "-item"), !0), _defineProperty$c($, "".concat(lt, "-item-active"), at), _defineProperty$c($, "".concat(lt, "-item-disabled"), vt), $), st), Pt = classnames(nt, (_ = {}, _defineProperty$c(_, "".concat(lt, "-header"), !0), _defineProperty$c(_, "".concat(lt, "-header-collapsible-only"), At), _defineProperty$c(_, "".concat(lt, "-icon-collapsible-only"), xt), _)), wt = {
    className: Pt,
    "aria-expanded": at,
    "aria-disabled": vt,
    onKeyDown: St
  };
  return !At && !xt && (wt.onClick = Et, wt.role = it ? "tab" : "button", wt.tabIndex = vt ? -1 : 0), /* @__PURE__ */ React$a.createElement("div", _extends$2({}, ct, {
    ref: s,
    className: Ot
  }), /* @__PURE__ */ React$a.createElement("div", wt, tt && Bt, /* @__PURE__ */ React$a.createElement("span", {
    className: "".concat(lt, "-header-text"),
    onClick: et === "header" ? Et : void 0
  }, ht), bt && /* @__PURE__ */ React$a.createElement("div", {
    className: "".concat(lt, "-extra")
  }, ft)), /* @__PURE__ */ React$a.createElement(CSSMotion, _extends$2({
    visible: at,
    leavedClassName: "".concat(lt, "-content-hidden")
  }, gt, {
    forceRender: rt,
    removeOnLeave: pt
  }), function(Ct, It) {
    var yt = Ct.className, Rt = Ct.style;
    return /* @__PURE__ */ React$a.createElement(PanelContent, {
      ref: It,
      prefixCls: lt,
      className: yt,
      style: Rt,
      isActive: at,
      forceRender: rt,
      role: it ? "tabpanel" : void 0
    }, mt);
  }));
}), _excluded$q = ["children", "label", "key", "collapsible", "onItemClick", "destroyInactivePanel"], convertItemsToNodes = function a(s, $) {
  var _ = $.prefixCls, _e = $.accordion, tt = $.collapsible, nt = $.destroyInactivePanel, at = $.onItemClick, ot = $.activeKey, rt = $.openMotion, st = $.expandIcon;
  return s.map(function(lt, et) {
    var it = lt.children, ut = lt.label, ft = lt.key, ht = lt.collapsible, dt = lt.onItemClick, gt = lt.destroyInactivePanel, pt = _objectWithoutProperties$1(lt, _excluded$q), mt = String(ft ?? et), ct = ht ?? tt, vt = gt ?? nt, At = function(Et) {
      ct !== "disabled" && (at(Et), dt == null || dt(Et));
    }, xt = !1;
    return _e ? xt = ot[0] === mt : xt = ot.indexOf(mt) > -1, /* @__PURE__ */ React$a.createElement(CollapsePanel$2, _extends$2({}, pt, {
      prefixCls: _,
      key: mt,
      panelKey: mt,
      isActive: xt,
      accordion: _e,
      openMotion: rt,
      expandIcon: st,
      header: ut,
      collapsible: ct,
      onItemClick: At,
      destroyInactivePanel: vt
    }), it);
  });
}, getNewChild = function a(s, $, _) {
  if (!s)
    return null;
  var _e = _.prefixCls, tt = _.accordion, nt = _.collapsible, at = _.destroyInactivePanel, ot = _.onItemClick, rt = _.activeKey, st = _.openMotion, lt = _.expandIcon, et = s.key || String($), it = s.props, ut = it.header, ft = it.headerClass, ht = it.destroyInactivePanel, dt = it.collapsible, gt = it.onItemClick, pt = !1;
  tt ? pt = rt[0] === et : pt = rt.indexOf(et) > -1;
  var mt = dt ?? nt, ct = function(xt) {
    mt !== "disabled" && (ot(xt), gt == null || gt(xt));
  }, vt = {
    key: et,
    panelKey: et,
    header: ut,
    headerClass: ft,
    isActive: pt,
    prefixCls: _e,
    destroyInactivePanel: ht ?? at,
    openMotion: st,
    accordion: tt,
    children: s.props.children,
    onItemClick: ct,
    expandIcon: lt,
    collapsible: mt
  };
  return typeof s.type == "string" ? s : (Object.keys(vt).forEach(function(At) {
    typeof vt[At] > "u" && delete vt[At];
  }), /* @__PURE__ */ React$a.cloneElement(s, vt));
};
function useItems(a, s, $) {
  return Array.isArray(a) ? convertItemsToNodes(a, $) : toArray$9(s).map(function(_, _e) {
    return getNewChild(_, _e, $);
  });
}
function getActiveKeysArray(a) {
  var s = a;
  if (!Array.isArray(s)) {
    var $ = _typeof$q(s);
    s = $ === "number" || $ === "string" ? [s] : [];
  }
  return s.map(function(_) {
    return String(_);
  });
}
var Collapse$2 = /* @__PURE__ */ React$a.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = $ === void 0 ? "rc-collapse" : $, _e = a.destroyInactivePanel, tt = _e === void 0 ? !1 : _e, nt = a.style, at = a.accordion, ot = a.className, rt = a.children, st = a.collapsible, lt = a.openMotion, et = a.expandIcon, it = a.activeKey, ut = a.defaultActiveKey, ft = a.onChange, ht = a.items, dt = classnames(_, ot), gt = useMergedState([], {
    value: it,
    onChange: function(bt) {
      return ft == null ? void 0 : ft(bt);
    },
    defaultValue: ut,
    postState: getActiveKeysArray
  }), pt = _slicedToArray$e(gt, 2), mt = pt[0], ct = pt[1], vt = function(bt) {
    return ct(function() {
      if (at)
        return mt[0] === bt ? [] : [bt];
      var Et = mt.indexOf(bt), St = Et > -1;
      return St ? mt.filter(function(Bt) {
        return Bt !== bt;
      }) : [].concat(_toConsumableArray$d(mt), [bt]);
    });
  };
  warningOnce(!rt, "[rc-collapse] `children` will be removed in next major version. Please use `items` instead.");
  var At = useItems(ht, rt, {
    prefixCls: _,
    accordion: at,
    openMotion: lt,
    expandIcon: et,
    collapsible: st,
    destroyInactivePanel: tt,
    onItemClick: vt,
    activeKey: mt
  });
  return /* @__PURE__ */ React$a.createElement("div", {
    ref: s,
    className: dt,
    style: nt,
    role: at ? "tablist" : void 0
  }, At);
});
const Collapse$3 = Object.assign(Collapse$2, {
  /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */
  Panel: CollapsePanel$2
});
Collapse$3.Panel;
const CollapsePanel = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    getPrefixCls: $
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: _,
    className: _e,
    showArrow: tt = !0
  } = a, nt = $("collapse", _), at = classnames({
    [`${nt}-no-arrow`]: !tt
  }, _e);
  return /* @__PURE__ */ reactExports.createElement(Collapse$3.Panel, Object.assign({
    ref: s
  }, a, {
    prefixCls: nt,
    className: at
  }));
}), CollapsePanel$1 = CollapsePanel, genBaseStyle$7 = (a) => {
  const {
    componentCls: s,
    contentBg: $,
    padding: _,
    headerBg: _e,
    headerPadding: tt,
    collapseHeaderPaddingSM: nt,
    collapseHeaderPaddingLG: at,
    collapsePanelBorderRadius: ot,
    lineWidth: rt,
    lineType: st,
    colorBorder: lt,
    colorText: et,
    colorTextHeading: it,
    colorTextDisabled: ut,
    fontSizeLG: ft,
    lineHeight: ht,
    lineHeightLG: dt,
    marginSM: gt,
    paddingSM: pt,
    paddingLG: mt,
    paddingXS: ct,
    motionDurationSlow: vt,
    fontSizeIcon: At,
    contentPadding: xt,
    fontHeight: bt,
    fontHeightLG: Et
  } = a, St = `${unit$1(rt)} ${st} ${lt}`;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      backgroundColor: _e,
      border: St,
      borderBottom: 0,
      borderRadius: ot,
      "&-rtl": {
        direction: "rtl"
      },
      [`& > ${s}-item`]: {
        borderBottom: St,
        "&:last-child": {
          [`
            &,
            & > ${s}-header`]: {
            borderRadius: `0 0 ${unit$1(ot)} ${unit$1(ot)}`
          }
        },
        [`> ${s}-header`]: {
          position: "relative",
          // Compatible with old version of antd, should remove in next version
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "flex-start",
          padding: tt,
          color: it,
          lineHeight: ht,
          cursor: "pointer",
          transition: `all ${vt}, visibility 0s`,
          [`> ${s}-header-text`]: {
            flex: "auto"
          },
          "&:focus": {
            outline: "none"
          },
          // >>>>> Arrow
          [`${s}-expand-icon`]: {
            height: bt,
            display: "flex",
            alignItems: "center",
            paddingInlineEnd: gt
          },
          [`${s}-arrow`]: Object.assign(Object.assign({}, resetIcon()), {
            fontSize: At,
            svg: {
              transition: `transform ${vt}`
            }
          }),
          // >>>>> Text
          [`${s}-header-text`]: {
            marginInlineEnd: "auto"
          }
        },
        [`${s}-icon-collapsible-only`]: {
          cursor: "unset",
          [`${s}-expand-icon`]: {
            cursor: "pointer"
          }
        }
      },
      [`${s}-content`]: {
        color: et,
        backgroundColor: $,
        borderTop: St,
        [`& > ${s}-content-box`]: {
          padding: xt
        },
        "&-hidden": {
          display: "none"
        }
      },
      "&-small": {
        [`> ${s}-item`]: {
          [`> ${s}-header`]: {
            padding: nt,
            paddingInlineStart: ct,
            [`> ${s}-expand-icon`]: {
              // Arrow offset
              marginInlineStart: a.calc(pt).sub(ct).equal()
            }
          },
          [`> ${s}-content > ${s}-content-box`]: {
            padding: pt
          }
        }
      },
      "&-large": {
        [`> ${s}-item`]: {
          fontSize: ft,
          lineHeight: dt,
          [`> ${s}-header`]: {
            padding: at,
            paddingInlineStart: _,
            [`> ${s}-expand-icon`]: {
              height: Et,
              // Arrow offset
              marginInlineStart: a.calc(mt).sub(_).equal()
            }
          },
          [`> ${s}-content > ${s}-content-box`]: {
            padding: mt
          }
        }
      },
      [`${s}-item:last-child`]: {
        [`> ${s}-content`]: {
          borderRadius: `0 0 ${unit$1(ot)} ${unit$1(ot)}`
        }
      },
      [`& ${s}-item-disabled > ${s}-header`]: {
        "\n          &,\n          & > .arrow\n        ": {
          color: ut,
          cursor: "not-allowed"
        }
      },
      // ========================== Icon Position ==========================
      [`&${s}-icon-position-end`]: {
        [`& > ${s}-item`]: {
          [`> ${s}-header`]: {
            [`${s}-expand-icon`]: {
              order: 1,
              paddingInlineEnd: 0,
              paddingInlineStart: gt
            }
          }
        }
      }
    })
  };
}, genArrowStyle = (a) => {
  const {
    componentCls: s
  } = a, $ = `> ${s}-item > ${s}-header ${s}-arrow svg`;
  return {
    [`${s}-rtl`]: {
      [$]: {
        transform: "rotate(180deg)"
      }
    }
  };
}, genBorderlessStyle = (a) => {
  const {
    componentCls: s,
    headerBg: $,
    paddingXXS: _,
    colorBorder: _e
  } = a;
  return {
    [`${s}-borderless`]: {
      backgroundColor: $,
      border: 0,
      [`> ${s}-item`]: {
        borderBottom: `1px solid ${_e}`
      },
      [`
        > ${s}-item:last-child,
        > ${s}-item:last-child ${s}-header
      `]: {
        borderRadius: 0
      },
      [`> ${s}-item:last-child`]: {
        borderBottom: 0
      },
      [`> ${s}-item > ${s}-content`]: {
        backgroundColor: "transparent",
        borderTop: 0
      },
      [`> ${s}-item > ${s}-content > ${s}-content-box`]: {
        paddingTop: _
      }
    }
  };
}, genGhostStyle = (a) => {
  const {
    componentCls: s,
    paddingSM: $
  } = a;
  return {
    [`${s}-ghost`]: {
      backgroundColor: "transparent",
      border: 0,
      [`> ${s}-item`]: {
        borderBottom: 0,
        [`> ${s}-content`]: {
          backgroundColor: "transparent",
          border: 0,
          [`> ${s}-content-box`]: {
            paddingBlock: $
          }
        }
      }
    }
  };
}, prepareComponentToken$h = (a) => ({
  headerPadding: `${a.paddingSM}px ${a.padding}px`,
  headerBg: a.colorFillAlter,
  contentPadding: `${a.padding}px 16px`,
  // Fixed Value
  contentBg: a.colorBgContainer
}), useStyle$h = genStyleHooks("Collapse", (a) => {
  const s = merge(a, {
    collapseHeaderPaddingSM: `${unit$1(a.paddingXS)} ${unit$1(a.paddingSM)}`,
    collapseHeaderPaddingLG: `${unit$1(a.padding)} ${unit$1(a.paddingLG)}`,
    collapsePanelBorderRadius: a.borderRadiusLG
  });
  return [genBaseStyle$7(s), genBorderlessStyle(s), genGhostStyle(s), genArrowStyle(s), genCollapseMotion$1(s)];
}, prepareComponentToken$h), Collapse = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    getPrefixCls: $,
    direction: _,
    collapse: _e
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: tt,
    className: nt,
    rootClassName: at,
    style: ot,
    bordered: rt = !0,
    ghost: st,
    size: lt,
    expandIconPosition: et = "start",
    children: it,
    expandIcon: ut
  } = a, ft = useSize$1((Et) => {
    var St;
    return (St = lt ?? Et) !== null && St !== void 0 ? St : "middle";
  }), ht = $("collapse", tt), dt = $(), [gt, pt, mt] = useStyle$h(ht), ct = reactExports.useMemo(() => et === "left" ? "start" : et === "right" ? "end" : et, [et]), vt = function() {
    let Et = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const St = ut ? ut(Et) : /* @__PURE__ */ reactExports.createElement(RightOutlined$1, {
      rotate: Et.isActive ? 90 : void 0
    });
    return cloneElement(St, () => ({
      className: classnames(St.props.className, `${ht}-arrow`)
    }));
  }, At = classnames(`${ht}-icon-position-${ct}`, {
    [`${ht}-borderless`]: !rt,
    [`${ht}-rtl`]: _ === "rtl",
    [`${ht}-ghost`]: !!st,
    [`${ht}-${ft}`]: ft !== "middle"
  }, _e == null ? void 0 : _e.className, nt, at, pt, mt), xt = Object.assign(Object.assign({}, initCollapseMotion$1(dt)), {
    motionAppear: !1,
    leavedClassName: `${ht}-content-hidden`
  }), bt = reactExports.useMemo(() => it ? toArray$9(it).map((Et, St) => {
    var Bt, Ot;
    if (!((Bt = Et.props) === null || Bt === void 0) && Bt.disabled) {
      const Pt = (Ot = Et.key) !== null && Ot !== void 0 ? Ot : String(St), {
        disabled: wt,
        collapsible: Ct
      } = Et.props, It = Object.assign(Object.assign({}, omit(Et.props, ["disabled"])), {
        key: Pt,
        collapsible: Ct ?? (wt ? "disabled" : void 0)
      });
      return cloneElement(Et, It);
    }
    return Et;
  }) : null, [it]);
  return gt(/* @__PURE__ */ reactExports.createElement(Collapse$3, Object.assign({
    ref: s,
    openMotion: xt
  }, omit(a, ["rootClassName"]), {
    expandIcon: vt,
    prefixCls: ht,
    className: At,
    style: Object.assign(Object.assign({}, _e == null ? void 0 : _e.style), ot)
  }), bt));
}), Collapse$1 = Object.assign(Collapse, {
  Panel: CollapsePanel$1
}), genSharedDividerStyle = (a) => {
  const {
    componentCls: s,
    sizePaddingEdgeHorizontal: $,
    colorSplit: _,
    lineWidth: _e,
    textPaddingInline: tt,
    orientationMargin: nt,
    verticalMarginInline: at
  } = a;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      borderBlockStart: `${unit$1(_e)} solid ${_}`,
      // vertical
      "&-vertical": {
        position: "relative",
        top: "-0.06em",
        display: "inline-block",
        height: "0.9em",
        marginInline: at,
        marginBlock: 0,
        verticalAlign: "middle",
        borderTop: 0,
        borderInlineStart: `${unit$1(_e)} solid ${_}`
      },
      "&-horizontal": {
        display: "flex",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        // Fix https://github.com/ant-design/ant-design/issues/10914
        margin: `${unit$1(a.dividerHorizontalGutterMargin)} 0`
      },
      [`&-horizontal${s}-with-text`]: {
        display: "flex",
        alignItems: "center",
        margin: `${unit$1(a.dividerHorizontalWithTextGutterMargin)} 0`,
        color: a.colorTextHeading,
        fontWeight: 500,
        fontSize: a.fontSizeLG,
        whiteSpace: "nowrap",
        textAlign: "center",
        borderBlockStart: `0 ${_}`,
        "&::before, &::after": {
          position: "relative",
          width: "50%",
          borderBlockStart: `${unit$1(_e)} solid transparent`,
          // Chrome not accept `inherit` in `border-top`
          borderBlockStartColor: "inherit",
          borderBlockEnd: 0,
          transform: "translateY(50%)",
          content: "''"
        }
      },
      [`&-horizontal${s}-with-text-left`]: {
        "&::before": {
          width: `calc(${nt} * 100%)`
        },
        "&::after": {
          width: `calc(100% - ${nt} * 100%)`
        }
      },
      [`&-horizontal${s}-with-text-right`]: {
        "&::before": {
          width: `calc(100% - ${nt} * 100%)`
        },
        "&::after": {
          width: `calc(${nt} * 100%)`
        }
      },
      [`${s}-inner-text`]: {
        display: "inline-block",
        paddingBlock: 0,
        paddingInline: tt
      },
      "&-dashed": {
        background: "none",
        borderColor: _,
        borderStyle: "dashed",
        borderWidth: `${unit$1(_e)} 0 0`
      },
      [`&-horizontal${s}-with-text${s}-dashed`]: {
        "&::before, &::after": {
          borderStyle: "dashed none none"
        }
      },
      [`&-vertical${s}-dashed`]: {
        borderInlineStartWidth: _e,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      [`&-plain${s}-with-text`]: {
        color: a.colorText,
        fontWeight: "normal",
        fontSize: a.fontSize
      },
      [`&-horizontal${s}-with-text-left${s}-no-default-orientation-margin-left`]: {
        "&::before": {
          width: 0
        },
        "&::after": {
          width: "100%"
        },
        [`${s}-inner-text`]: {
          paddingInlineStart: $
        }
      },
      [`&-horizontal${s}-with-text-right${s}-no-default-orientation-margin-right`]: {
        "&::before": {
          width: "100%"
        },
        "&::after": {
          width: 0
        },
        [`${s}-inner-text`]: {
          paddingInlineEnd: $
        }
      }
    })
  };
}, prepareComponentToken$g = (a) => ({
  textPaddingInline: "1em",
  orientationMargin: 0.05,
  verticalMarginInline: a.marginXS
}), useStyle$g = genStyleHooks("Divider", (a) => {
  const s = merge(a, {
    dividerHorizontalWithTextGutterMargin: a.margin,
    dividerHorizontalGutterMargin: a.marginLG,
    sizePaddingEdgeHorizontal: 0
  });
  return [genSharedDividerStyle(s)];
}, prepareComponentToken$g, {
  unitless: {
    orientationMargin: !0
  }
});
var __rest$D = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Divider = (a) => {
  const {
    getPrefixCls: s,
    direction: $,
    divider: _
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: _e,
    type: tt = "horizontal",
    orientation: nt = "center",
    orientationMargin: at,
    className: ot,
    rootClassName: rt,
    children: st,
    dashed: lt,
    plain: et,
    style: it
  } = a, ut = __rest$D(a, ["prefixCls", "type", "orientation", "orientationMargin", "className", "rootClassName", "children", "dashed", "plain", "style"]), ft = s("divider", _e), [ht, dt, gt] = useStyle$g(ft), pt = nt.length > 0 ? `-${nt}` : nt, mt = !!st, ct = nt === "left" && at != null, vt = nt === "right" && at != null, At = classnames(ft, _ == null ? void 0 : _.className, dt, gt, `${ft}-${tt}`, {
    [`${ft}-with-text`]: mt,
    [`${ft}-with-text${pt}`]: mt,
    [`${ft}-dashed`]: !!lt,
    [`${ft}-plain`]: !!et,
    [`${ft}-rtl`]: $ === "rtl",
    [`${ft}-no-default-orientation-margin-left`]: ct,
    [`${ft}-no-default-orientation-margin-right`]: vt
  }, ot, rt), xt = reactExports.useMemo(() => typeof at == "number" ? at : /^\d+$/.test(at) ? Number(at) : at, [at]), bt = Object.assign(Object.assign({}, ct && {
    marginLeft: xt
  }), vt && {
    marginRight: xt
  });
  return ht(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    className: At,
    style: Object.assign(Object.assign({}, _ == null ? void 0 : _.style), it)
  }, ut, {
    role: "separator"
  }), st && tt !== "vertical" && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${ft}-inner-text`,
    style: bt
  }, st)));
}, Divider$1 = Divider;
var UpOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, name: "up", theme: "outlined" };
const UpOutlinedSvg = UpOutlined$2;
var UpOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: UpOutlinedSvg
  }));
};
const UpOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(UpOutlined);
function supportBigInt() {
  return typeof BigInt == "function";
}
function isEmpty(a) {
  return !a && a !== 0 && !Number.isNaN(a) || !String(a).trim();
}
function trimNumber(a) {
  var s = a.trim(), $ = s.startsWith("-");
  $ && (s = s.slice(1)), s = s.replace(/(\.\d*[^0])0*$/, "$1").replace(/\.0*$/, "").replace(/^0+/, ""), s.startsWith(".") && (s = "0".concat(s));
  var _ = s || "0", _e = _.split("."), tt = _e[0] || "0", nt = _e[1] || "0";
  tt === "0" && nt === "0" && ($ = !1);
  var at = $ ? "-" : "";
  return {
    negative: $,
    negativeStr: at,
    trimStr: _,
    integerStr: tt,
    decimalStr: nt,
    fullStr: "".concat(at).concat(_)
  };
}
function isE(a) {
  var s = String(a);
  return !Number.isNaN(Number(s)) && s.includes("e");
}
function getNumberPrecision(a) {
  var s = String(a);
  if (isE(a)) {
    var $ = Number(s.slice(s.indexOf("e-") + 2)), _ = s.match(/\.(\d+)/);
    return _ != null && _[1] && ($ += _[1].length), $;
  }
  return s.includes(".") && validateNumber(s) ? s.length - s.indexOf(".") - 1 : 0;
}
function num2str(a) {
  var s = String(a);
  if (isE(a)) {
    if (a > Number.MAX_SAFE_INTEGER)
      return String(supportBigInt() ? BigInt(a).toString() : Number.MAX_SAFE_INTEGER);
    if (a < Number.MIN_SAFE_INTEGER)
      return String(supportBigInt() ? BigInt(a).toString() : Number.MIN_SAFE_INTEGER);
    s = a.toFixed(getNumberPrecision(s));
  }
  return trimNumber(s).fullStr;
}
function validateNumber(a) {
  return typeof a == "number" ? !Number.isNaN(a) : a ? (
    // Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(a) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(a) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(a)
  ) : !1;
}
var BigIntDecimal = /* @__PURE__ */ function() {
  function a(s) {
    if (_classCallCheck(this, a), _defineProperty$c(this, "origin", ""), _defineProperty$c(this, "negative", void 0), _defineProperty$c(this, "integer", void 0), _defineProperty$c(this, "decimal", void 0), _defineProperty$c(this, "decimalLen", void 0), _defineProperty$c(this, "empty", void 0), _defineProperty$c(this, "nan", void 0), isEmpty(s)) {
      this.empty = !0;
      return;
    }
    if (this.origin = String(s), s === "-" || Number.isNaN(s)) {
      this.nan = !0;
      return;
    }
    var $ = s;
    if (isE($) && ($ = Number($)), $ = typeof $ == "string" ? $ : num2str($), validateNumber($)) {
      var _ = trimNumber($);
      this.negative = _.negative;
      var _e = _.trimStr.split(".");
      this.integer = BigInt(_e[0]);
      var tt = _e[1] || "0";
      this.decimal = BigInt(tt), this.decimalLen = tt.length;
    } else
      this.nan = !0;
  }
  return _createClass(a, [{
    key: "getMark",
    value: function() {
      return this.negative ? "-" : "";
    }
  }, {
    key: "getIntegerStr",
    value: function() {
      return this.integer.toString();
    }
    /**
     * @private get decimal string
     */
  }, {
    key: "getDecimalStr",
    value: function() {
      return this.decimal.toString().padStart(this.decimalLen, "0");
    }
    /**
     * @private Align BigIntDecimal with same decimal length. e.g. 12.3 + 5 = 1230000
     * This is used for add function only.
     */
  }, {
    key: "alignDecimal",
    value: function($) {
      var _ = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd($, "0"));
      return BigInt(_);
    }
  }, {
    key: "negate",
    value: function() {
      var $ = new a(this.toString());
      return $.negative = !$.negative, $;
    }
  }, {
    key: "cal",
    value: function($, _, _e) {
      var tt = Math.max(this.getDecimalStr().length, $.getDecimalStr().length), nt = this.alignDecimal(tt), at = $.alignDecimal(tt), ot = _(nt, at).toString(), rt = _e(tt), st = trimNumber(ot), lt = st.negativeStr, et = st.trimStr, it = "".concat(lt).concat(et.padStart(rt + 1, "0"));
      return new a("".concat(it.slice(0, -rt), ".").concat(it.slice(-rt)));
    }
  }, {
    key: "add",
    value: function($) {
      if (this.isInvalidate())
        return new a($);
      var _ = new a($);
      return _.isInvalidate() ? this : this.cal(_, function(_e, tt) {
        return _e + tt;
      }, function(_e) {
        return _e;
      });
    }
  }, {
    key: "multi",
    value: function($) {
      var _ = new a($);
      return this.isInvalidate() || _.isInvalidate() ? new a(NaN) : this.cal(_, function(_e, tt) {
        return _e * tt;
      }, function(_e) {
        return _e * 2;
      });
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function($) {
      return this.toString() === ($ == null ? void 0 : $.toString());
    }
  }, {
    key: "lessEquals",
    value: function($) {
      return this.add($.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.isNaN() ? NaN : Number(this.toString());
    }
  }, {
    key: "toString",
    value: function() {
      var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return $ ? this.isInvalidate() ? "" : trimNumber("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr : this.origin;
    }
  }]), a;
}(), NumberDecimal = /* @__PURE__ */ function() {
  function a(s) {
    if (_classCallCheck(this, a), _defineProperty$c(this, "origin", ""), _defineProperty$c(this, "number", void 0), _defineProperty$c(this, "empty", void 0), isEmpty(s)) {
      this.empty = !0;
      return;
    }
    this.origin = String(s), this.number = Number(s);
  }
  return _createClass(a, [{
    key: "negate",
    value: function() {
      return new a(-this.toNumber());
    }
  }, {
    key: "add",
    value: function($) {
      if (this.isInvalidate())
        return new a($);
      var _ = Number($);
      if (Number.isNaN(_))
        return this;
      var _e = this.number + _;
      if (_e > Number.MAX_SAFE_INTEGER)
        return new a(Number.MAX_SAFE_INTEGER);
      if (_e < Number.MIN_SAFE_INTEGER)
        return new a(Number.MIN_SAFE_INTEGER);
      var tt = Math.max(getNumberPrecision(this.number), getNumberPrecision(_));
      return new a(_e.toFixed(tt));
    }
  }, {
    key: "multi",
    value: function($) {
      var _ = Number($);
      if (this.isInvalidate() || Number.isNaN(_))
        return new a(NaN);
      var _e = this.number * _;
      if (_e > Number.MAX_SAFE_INTEGER)
        return new a(Number.MAX_SAFE_INTEGER);
      if (_e < Number.MIN_SAFE_INTEGER)
        return new a(Number.MIN_SAFE_INTEGER);
      var tt = Math.max(getNumberPrecision(this.number), getNumberPrecision(_));
      return new a(_e.toFixed(tt));
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function($) {
      return this.toNumber() === ($ == null ? void 0 : $.toNumber());
    }
  }, {
    key: "lessEquals",
    value: function($) {
      return this.add($.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function() {
      var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return $ ? this.isInvalidate() ? "" : num2str(this.number) : this.origin;
    }
  }]), a;
}();
function getMiniDecimal(a) {
  return supportBigInt() ? new BigIntDecimal(a) : new NumberDecimal(a);
}
function toFixed(a, s, $) {
  var _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (a === "")
    return "";
  var _e = trimNumber(a), tt = _e.negativeStr, nt = _e.integerStr, at = _e.decimalStr, ot = "".concat(s).concat(at), rt = "".concat(tt).concat(nt);
  if ($ >= 0) {
    var st = Number(at[$]);
    if (st >= 5 && !_) {
      var lt = getMiniDecimal(a).add("".concat(tt, "0.").concat("0".repeat($)).concat(10 - st));
      return toFixed(lt.toString(), s, $, _);
    }
    return $ === 0 ? rt : "".concat(rt).concat(s).concat(at.padEnd($, "0").slice(0, $));
  }
  return ot === ".0" ? rt : "".concat(rt).concat(ot);
}
function hasAddon(a) {
  return !!(a.addonBefore || a.addonAfter);
}
function hasPrefixSuffix$1(a) {
  return !!(a.prefix || a.suffix || a.allowClear);
}
function resolveOnChange(a, s, $, _) {
  if ($) {
    var _e = s;
    if (s.type === "click") {
      var tt = a.cloneNode(!0);
      _e = Object.create(s, {
        target: {
          value: tt
        },
        currentTarget: {
          value: tt
        }
      }), tt.value = "", $(_e);
      return;
    }
    if (_ !== void 0) {
      var nt = a.cloneNode(!0);
      _e = Object.create(s, {
        target: {
          value: nt
        },
        currentTarget: {
          value: nt
        }
      }), nt.type !== "file" && (nt.value = _), $(_e);
      return;
    }
    $(_e);
  }
}
function triggerFocus$1(a, s) {
  if (a) {
    a.focus(s);
    var $ = s || {}, _ = $.cursor;
    if (_) {
      var _e = a.value.length;
      switch (_) {
        case "start":
          a.setSelectionRange(0, 0);
          break;
        case "end":
          a.setSelectionRange(_e, _e);
          break;
        default:
          a.setSelectionRange(0, _e);
      }
    }
  }
}
var BaseInput = function a(s) {
  var $, _, _e = s.inputElement, tt = s.prefixCls, nt = s.prefix, at = s.suffix, ot = s.addonBefore, rt = s.addonAfter, st = s.className, lt = s.style, et = s.disabled, it = s.readOnly, ut = s.focused, ft = s.triggerFocus, ht = s.allowClear, dt = s.value, gt = s.handleReset, pt = s.hidden, mt = s.classes, ct = s.classNames, vt = s.dataAttrs, At = s.styles, xt = s.components, bt = (xt == null ? void 0 : xt.affixWrapper) || "span", Et = (xt == null ? void 0 : xt.groupWrapper) || "span", St = (xt == null ? void 0 : xt.wrapper) || "span", Bt = (xt == null ? void 0 : xt.groupAddon) || "span", Ot = reactExports.useRef(null), Pt = function(Mt) {
    var Lt;
    (Lt = Ot.current) !== null && Lt !== void 0 && Lt.contains(Mt.target) && (ft == null || ft());
  }, wt = function() {
    var Mt;
    if (!ht)
      return null;
    var Lt = !et && !it && dt, $t = "".concat(tt, "-clear-icon"), Tt = _typeof$q(ht) === "object" && ht !== null && ht !== void 0 && ht.clearIcon ? ht.clearIcon : "✖";
    return /* @__PURE__ */ React$a.createElement("span", {
      onClick: gt,
      onMouseDown: function(Ut) {
        return Ut.preventDefault();
      },
      className: classnames($t, (Mt = {}, _defineProperty$c(Mt, "".concat($t, "-hidden"), !Lt), _defineProperty$c(Mt, "".concat($t, "-has-suffix"), !!at), Mt)),
      role: "button",
      tabIndex: -1
    }, Tt);
  }, Ct = /* @__PURE__ */ reactExports.cloneElement(_e, {
    value: dt,
    hidden: pt,
    className: classnames(($ = _e.props) === null || $ === void 0 ? void 0 : $.className, !hasPrefixSuffix$1(s) && !hasAddon(s) && st) || null,
    style: _objectSpread2$a(_objectSpread2$a({}, (_ = _e.props) === null || _ === void 0 ? void 0 : _.style), !hasPrefixSuffix$1(s) && !hasAddon(s) ? lt : {})
  });
  if (hasPrefixSuffix$1(s)) {
    var It, yt = "".concat(tt, "-affix-wrapper"), Rt = classnames(yt, (It = {}, _defineProperty$c(It, "".concat(yt, "-disabled"), et), _defineProperty$c(It, "".concat(yt, "-focused"), ut), _defineProperty$c(It, "".concat(yt, "-readonly"), it), _defineProperty$c(It, "".concat(yt, "-input-with-clear-btn"), at && ht && dt), It), !hasAddon(s) && st, mt == null ? void 0 : mt.affixWrapper, ct == null ? void 0 : ct.affixWrapper), kt = (at || ht) && /* @__PURE__ */ React$a.createElement("span", {
      className: classnames("".concat(tt, "-suffix"), ct == null ? void 0 : ct.suffix),
      style: At == null ? void 0 : At.suffix
    }, wt(), at);
    Ct = /* @__PURE__ */ React$a.createElement(bt, _extends$2({
      className: Rt,
      style: _objectSpread2$a(_objectSpread2$a({}, hasAddon(s) ? void 0 : lt), At == null ? void 0 : At.affixWrapper),
      hidden: !hasAddon(s) && pt,
      onClick: Pt
    }, vt == null ? void 0 : vt.affixWrapper, {
      ref: Ot
    }), nt && /* @__PURE__ */ React$a.createElement("span", {
      className: classnames("".concat(tt, "-prefix"), ct == null ? void 0 : ct.prefix),
      style: At == null ? void 0 : At.prefix
    }, nt), /* @__PURE__ */ reactExports.cloneElement(_e, {
      value: dt,
      hidden: null
    }), kt);
  }
  if (hasAddon(s)) {
    var jt = "".concat(tt, "-group"), Ht = "".concat(jt, "-addon"), Ft = classnames("".concat(tt, "-wrapper"), jt, mt == null ? void 0 : mt.wrapper), _t = classnames("".concat(tt, "-group-wrapper"), st, mt == null ? void 0 : mt.group);
    return /* @__PURE__ */ React$a.createElement(Et, {
      className: _t,
      style: lt,
      hidden: pt
    }, /* @__PURE__ */ React$a.createElement(St, {
      className: Ft
    }, ot && /* @__PURE__ */ React$a.createElement(Bt, {
      className: Ht
    }, ot), /* @__PURE__ */ reactExports.cloneElement(Ct, {
      hidden: null
    }), rt && /* @__PURE__ */ React$a.createElement(Bt, {
      className: Ht
    }, rt)));
  }
  return Ct;
}, _excluded$p = ["show"];
function useCount(a, s) {
  return reactExports.useMemo(function() {
    var $ = {};
    s && ($.show = _typeof$q(s) === "object" && s.formatter ? s.formatter : !!s), $ = _objectSpread2$a(_objectSpread2$a({}, $), a);
    var _ = $, _e = _.show, tt = _objectWithoutProperties$1(_, _excluded$p);
    return _objectSpread2$a(_objectSpread2$a({}, tt), {}, {
      show: !!_e,
      showFormatter: typeof _e == "function" ? _e : void 0,
      strategy: tt.strategy || function(nt) {
        return nt.length;
      }
    });
  }, [a, s]);
}
var _excluded$o = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], Input$3 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.autoComplete, _ = a.onChange, _e = a.onFocus, tt = a.onBlur, nt = a.onPressEnter, at = a.onKeyDown, ot = a.prefixCls, rt = ot === void 0 ? "rc-input" : ot, st = a.disabled, lt = a.htmlSize, et = a.className, it = a.maxLength, ut = a.suffix, ft = a.showCount, ht = a.count, dt = a.type, gt = dt === void 0 ? "text" : dt, pt = a.classes, mt = a.classNames, ct = a.styles, vt = a.onCompositionStart, At = a.onCompositionEnd, xt = _objectWithoutProperties$1(a, _excluded$o), bt = reactExports.useState(!1), Et = _slicedToArray$e(bt, 2), St = Et[0], Bt = Et[1], Ot = React$a.useRef(!1), Pt = reactExports.useRef(null), wt = function(Kt) {
    Pt.current && triggerFocus$1(Pt.current, Kt);
  }, Ct = useMergedState(a.defaultValue, {
    value: a.value
  }), It = _slicedToArray$e(Ct, 2), yt = It[0], Rt = It[1], kt = yt == null ? "" : String(yt), jt = React$a.useState(null), Ht = _slicedToArray$e(jt, 2), Ft = Ht[0], _t = Ht[1], Nt = useCount(ht, ft), Mt = Nt.max || it, Lt = Nt.strategy(kt), $t = !!Mt && Lt > Mt;
  reactExports.useImperativeHandle(s, function() {
    return {
      focus: wt,
      blur: function() {
        var Kt;
        (Kt = Pt.current) === null || Kt === void 0 || Kt.blur();
      },
      setSelectionRange: function(Kt, nr, tr) {
        var ir;
        (ir = Pt.current) === null || ir === void 0 || ir.setSelectionRange(Kt, nr, tr);
      },
      select: function() {
        var Kt;
        (Kt = Pt.current) === null || Kt === void 0 || Kt.select();
      },
      input: Pt.current
    };
  }), reactExports.useEffect(function() {
    Bt(function(Yt) {
      return Yt && st ? !1 : Yt;
    });
  }, [st]);
  var Tt = function(Kt, nr) {
    var tr = nr;
    if (!Ot.current && Nt.exceedFormatter && Nt.max && Nt.strategy(nr) > Nt.max && (tr = Nt.exceedFormatter(nr, {
      max: Nt.max
    }), nr !== tr)) {
      var ir, sr;
      _t([((ir = Pt.current) === null || ir === void 0 ? void 0 : ir.selectionStart) || 0, ((sr = Pt.current) === null || sr === void 0 ? void 0 : sr.selectionEnd) || 0]);
    }
    Rt(tr), Pt.current && resolveOnChange(Pt.current, Kt, _, tr);
  };
  React$a.useEffect(function() {
    if (Ft) {
      var Yt;
      (Yt = Pt.current) === null || Yt === void 0 || Yt.setSelectionRange.apply(Yt, _toConsumableArray$d(Ft));
    }
  }, [Ft]);
  var Dt = function(Kt) {
    Tt(Kt, Kt.target.value);
  }, Ut = function(Kt) {
    Ot.current = !1, Tt(Kt, Kt.currentTarget.value), At == null || At(Kt);
  }, Vt = function(Kt) {
    nt && Kt.key === "Enter" && nt(Kt), at == null || at(Kt);
  }, Qt = function(Kt) {
    Bt(!0), _e == null || _e(Kt);
  }, qt = function(Kt) {
    Bt(!1), tt == null || tt(Kt);
  }, Zt = function(Kt) {
    Rt(""), wt(), Pt.current && resolveOnChange(Pt.current, Kt, _);
  }, ar = $t && "".concat(rt, "-out-of-range"), Jt = function() {
    var Kt = omit(a, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames"
    ]);
    return /* @__PURE__ */ React$a.createElement("input", _extends$2({
      autoComplete: $
    }, Kt, {
      onChange: Dt,
      onFocus: Qt,
      onBlur: qt,
      onKeyDown: Vt,
      className: classnames(rt, _defineProperty$c({}, "".concat(rt, "-disabled"), st), mt == null ? void 0 : mt.input),
      style: ct == null ? void 0 : ct.input,
      ref: Pt,
      size: lt,
      type: gt,
      onCompositionStart: function(tr) {
        Ot.current = !0, vt == null || vt(tr);
      },
      onCompositionEnd: Ut
    }));
  }, rr = function() {
    var Kt = Number(Mt) > 0;
    if (ut || Nt.show) {
      var nr = Nt.showFormatter ? Nt.showFormatter({
        value: kt,
        count: Lt,
        maxLength: Mt
      }) : "".concat(Lt).concat(Kt ? " / ".concat(Mt) : "");
      return /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, Nt.show && /* @__PURE__ */ React$a.createElement("span", {
        className: classnames("".concat(rt, "-show-count-suffix"), _defineProperty$c({}, "".concat(rt, "-show-count-has-suffix"), !!ut), mt == null ? void 0 : mt.count),
        style: _objectSpread2$a({}, ct == null ? void 0 : ct.count)
      }, nr), ut);
    }
    return null;
  };
  return /* @__PURE__ */ React$a.createElement(BaseInput, _extends$2({}, xt, {
    prefixCls: rt,
    className: classnames(et, ar),
    inputElement: Jt(),
    handleReset: Zt,
    value: kt,
    focused: St,
    triggerFocus: wt,
    suffix: rr(),
    disabled: st,
    classes: pt,
    classNames: mt,
    styles: ct
  }));
});
function useCursor(a, s) {
  var $ = reactExports.useRef(null);
  function _() {
    try {
      var tt = a.selectionStart, nt = a.selectionEnd, at = a.value, ot = at.substring(0, tt), rt = at.substring(nt);
      $.current = {
        start: tt,
        end: nt,
        value: at,
        beforeTxt: ot,
        afterTxt: rt
      };
    } catch {
    }
  }
  function _e() {
    if (a && $.current && s)
      try {
        var tt = a.value, nt = $.current, at = nt.beforeTxt, ot = nt.afterTxt, rt = nt.start, st = tt.length;
        if (tt.endsWith(ot))
          st = tt.length - $.current.afterTxt.length;
        else if (tt.startsWith(at))
          st = at.length;
        else {
          var lt = at[rt - 1], et = tt.indexOf(lt, rt - 1);
          et !== -1 && (st = et + 1);
        }
        a.setSelectionRange(st, st);
      } catch (it) {
        warningOnce(!1, "Something warning of cursor restore. Please fire issue about this: ".concat(it.message));
      }
  }
  return [_, _e];
}
var useMobile = function a() {
  var s = reactExports.useState(!1), $ = _slicedToArray$e(s, 2), _ = $[0], _e = $[1];
  return useLayoutEffect$1(function() {
    _e(isMobile$1());
  }, []), _;
}, STEP_INTERVAL = 200, STEP_DELAY = 600;
function StepHandler(a) {
  var s = a.prefixCls, $ = a.upNode, _ = a.downNode, _e = a.upDisabled, tt = a.downDisabled, nt = a.onStep, at = reactExports.useRef(), ot = reactExports.useRef([]), rt = reactExports.useRef();
  rt.current = nt;
  var st = function() {
    clearTimeout(at.current);
  }, lt = function(pt, mt) {
    pt.preventDefault(), st(), rt.current(mt);
    function ct() {
      rt.current(mt), at.current = setTimeout(ct, STEP_INTERVAL);
    }
    at.current = setTimeout(ct, STEP_DELAY);
  };
  reactExports.useEffect(function() {
    return function() {
      st(), ot.current.forEach(function(gt) {
        return wrapperRaf.cancel(gt);
      });
    };
  }, []);
  var et = useMobile();
  if (et)
    return null;
  var it = "".concat(s, "-handler"), ut = classnames(it, "".concat(it, "-up"), _defineProperty$c({}, "".concat(it, "-up-disabled"), _e)), ft = classnames(it, "".concat(it, "-down"), _defineProperty$c({}, "".concat(it, "-down-disabled"), tt)), ht = function() {
    return ot.current.push(wrapperRaf(st));
  }, dt = {
    unselectable: "on",
    role: "button",
    onMouseUp: ht,
    onMouseLeave: ht
  };
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(it, "-wrap")
  }, /* @__PURE__ */ reactExports.createElement("span", _extends$2({}, dt, {
    onMouseDown: function(pt) {
      lt(pt, !0);
    },
    "aria-label": "Increase Value",
    "aria-disabled": _e,
    className: ut
  }), $ || /* @__PURE__ */ reactExports.createElement("span", {
    unselectable: "on",
    className: "".concat(s, "-handler-up-inner")
  })), /* @__PURE__ */ reactExports.createElement("span", _extends$2({}, dt, {
    onMouseDown: function(pt) {
      lt(pt, !1);
    },
    "aria-label": "Decrease Value",
    "aria-disabled": tt,
    className: ft
  }), _ || /* @__PURE__ */ reactExports.createElement("span", {
    unselectable: "on",
    className: "".concat(s, "-handler-down-inner")
  })));
}
function getDecupleSteps(a) {
  var s = typeof a == "number" ? num2str(a) : trimNumber(a).fullStr, $ = s.includes(".");
  return $ ? trimNumber(s.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr : a + "0";
}
const useFrame = function() {
  var a = reactExports.useRef(0), s = function() {
    wrapperRaf.cancel(a.current);
  };
  return reactExports.useEffect(function() {
    return s;
  }, []), function($) {
    s(), a.current = wrapperRaf(function() {
      $();
    });
  };
};
var _excluded$n = ["prefixCls", "className", "style", "min", "max", "step", "defaultValue", "value", "disabled", "readOnly", "upHandler", "downHandler", "keyboard", "controls", "classNames", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep", "changeOnBlur"], _excluded2$5 = ["disabled", "style", "prefixCls", "value", "prefix", "suffix", "addonBefore", "addonAfter", "classes", "className", "classNames"], getDecimalValue = function a(s, $) {
  return s || $.isEmpty() ? $.toString() : $.toNumber();
}, getDecimalIfValidate = function a(s) {
  var $ = getMiniDecimal(s);
  return $.isInvalidate() ? null : $;
}, InternalInputNumber = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _ = a.prefixCls, _e = _ === void 0 ? "rc-input-number" : _, tt = a.className, nt = a.style, at = a.min, ot = a.max, rt = a.step, st = rt === void 0 ? 1 : rt, lt = a.defaultValue, et = a.value, it = a.disabled, ut = a.readOnly, ft = a.upHandler, ht = a.downHandler, dt = a.keyboard, gt = a.controls, pt = gt === void 0 ? !0 : gt, mt = a.classNames, ct = a.stringMode, vt = a.parser, At = a.formatter, xt = a.precision, bt = a.decimalSeparator, Et = a.onChange, St = a.onInput, Bt = a.onPressEnter, Ot = a.onStep, Pt = a.changeOnBlur, wt = Pt === void 0 ? !0 : Pt, Ct = _objectWithoutProperties$1(a, _excluded$n), It = "".concat(_e, "-input"), yt = reactExports.useRef(null), Rt = reactExports.useState(!1), kt = _slicedToArray$e(Rt, 2), jt = kt[0], Ht = kt[1], Ft = reactExports.useRef(!1), _t = reactExports.useRef(!1), Nt = reactExports.useRef(!1), Mt = reactExports.useState(function() {
    return getMiniDecimal(et ?? lt);
  }), Lt = _slicedToArray$e(Mt, 2), $t = Lt[0], Tt = Lt[1];
  function Dt(hr) {
    et === void 0 && Tt(hr);
  }
  var Ut = reactExports.useCallback(function(hr, vr) {
    if (!vr)
      return xt >= 0 ? xt : Math.max(getNumberPrecision(hr), getNumberPrecision(st));
  }, [xt, st]), Vt = reactExports.useCallback(function(hr) {
    var vr = String(hr);
    if (vt)
      return vt(vr);
    var xr = vr;
    return bt && (xr = xr.replace(bt, ".")), xr.replace(/[^\w.-]+/g, "");
  }, [vt, bt]), Qt = reactExports.useRef(""), qt = reactExports.useCallback(function(hr, vr) {
    if (At)
      return At(hr, {
        userTyping: vr,
        input: String(Qt.current)
      });
    var xr = typeof hr == "number" ? num2str(hr) : hr;
    if (!vr) {
      var Pr = Ut(xr, vr);
      if (validateNumber(xr) && (bt || Pr >= 0)) {
        var Rr = bt || ".";
        xr = toFixed(xr, Rr, Pr);
      }
    }
    return xr;
  }, [At, Ut, bt]), Zt = reactExports.useState(function() {
    var hr = lt ?? et;
    return $t.isInvalidate() && ["string", "number"].includes(_typeof$q(hr)) ? Number.isNaN(hr) ? "" : hr : qt($t.toString(), !1);
  }), ar = _slicedToArray$e(Zt, 2), Jt = ar[0], rr = ar[1];
  Qt.current = Jt;
  function Yt(hr, vr) {
    rr(qt(
      // Invalidate number is sometime passed by external control, we should let it go
      // Otherwise is controlled by internal interactive logic which check by userTyping
      // You can ref 'show limited value when input is not focused' test for more info.
      hr.isInvalidate() ? hr.toString(!1) : hr.toString(!vr),
      vr
    ));
  }
  var Kt = reactExports.useMemo(function() {
    return getDecimalIfValidate(ot);
  }, [ot, xt]), nr = reactExports.useMemo(function() {
    return getDecimalIfValidate(at);
  }, [at, xt]), tr = reactExports.useMemo(function() {
    return !Kt || !$t || $t.isInvalidate() ? !1 : Kt.lessEquals($t);
  }, [Kt, $t]), ir = reactExports.useMemo(function() {
    return !nr || !$t || $t.isInvalidate() ? !1 : $t.lessEquals(nr);
  }, [nr, $t]), sr = useCursor(yt.current, jt), cr = _slicedToArray$e(sr, 2), or = cr[0], Xt = cr[1], Gt = function(vr) {
    return Kt && !vr.lessEquals(Kt) ? Kt : nr && !nr.lessEquals(vr) ? nr : null;
  }, Wt = function(vr) {
    return !Gt(vr);
  }, er = function(vr, xr) {
    var Pr = vr, Rr = Wt(Pr) || Pr.isEmpty();
    if (!Pr.isEmpty() && !xr && (Pr = Gt(Pr) || Pr, Rr = !0), !ut && !it && Rr) {
      var Dr = Pr.toString(), Gr = Ut(Dr, xr);
      return Gr >= 0 && (Pr = getMiniDecimal(toFixed(Dr, ".", Gr)), Wt(Pr) || (Pr = getMiniDecimal(toFixed(Dr, ".", Gr, !0)))), Pr.equals($t) || (Dt(Pr), Et == null || Et(Pr.isEmpty() ? null : getDecimalValue(ct, Pr)), et === void 0 && Yt(Pr, xr)), Pr;
    }
    return $t;
  }, lr = useFrame(), ur = function hr(vr) {
    if (or(), Qt.current = vr, rr(vr), !_t.current) {
      var xr = Vt(vr), Pr = getMiniDecimal(xr);
      Pr.isNaN() || er(Pr, !0);
    }
    St == null || St(vr), lr(function() {
      var Rr = vr;
      vt || (Rr = vr.replace(/。/g, ".")), Rr !== vr && hr(Rr);
    });
  }, pr = function() {
    _t.current = !0;
  }, yr = function() {
    _t.current = !1, ur(yt.current.value);
  }, Er = function(vr) {
    ur(vr.target.value);
  }, br = function(vr) {
    var xr;
    if (!(vr && tr || !vr && ir)) {
      Ft.current = !1;
      var Pr = getMiniDecimal(Nt.current ? getDecupleSteps(st) : st);
      vr || (Pr = Pr.negate());
      var Rr = ($t || getMiniDecimal(0)).add(Pr.toString()), Dr = er(Rr, !1);
      Ot == null || Ot(getDecimalValue(ct, Dr), {
        offset: Nt.current ? getDecupleSteps(st) : st,
        type: vr ? "up" : "down"
      }), (xr = yt.current) === null || xr === void 0 || xr.focus();
    }
  }, gr = function(vr) {
    var xr = getMiniDecimal(Vt(Jt)), Pr = xr;
    xr.isNaN() ? Pr = er($t, vr) : Pr = er(xr, vr), et !== void 0 ? Yt($t, !1) : Pr.isNaN() || Yt(Pr, !1);
  }, Ar = function() {
    Ft.current = !0;
  }, Sr = function(vr) {
    var xr = vr.key, Pr = vr.shiftKey;
    Ft.current = !0, Nt.current = Pr, xr === "Enter" && (_t.current || (Ft.current = !1), gr(!1), Bt == null || Bt(vr)), dt !== !1 && !_t.current && ["Up", "ArrowUp", "Down", "ArrowDown"].includes(xr) && (br(xr === "Up" || xr === "ArrowUp"), vr.preventDefault());
  }, Br = function() {
    Ft.current = !1, Nt.current = !1;
  }, Ir = function() {
    wt && gr(!1), Ht(!1), Ft.current = !1;
  };
  return useLayoutUpdateEffect(function() {
    $t.isInvalidate() || Yt($t, !1);
  }, [xt, At]), useLayoutUpdateEffect(function() {
    var hr = getMiniDecimal(et);
    Tt(hr);
    var vr = getMiniDecimal(Vt(Jt));
    (!hr.equals(vr) || !Ft.current || At) && Yt(hr, Ft.current);
  }, [et]), useLayoutUpdateEffect(function() {
    At && Xt();
  }, [Jt]), /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(_e, mt == null ? void 0 : mt.input, tt, ($ = {}, _defineProperty$c($, "".concat(_e, "-focused"), jt), _defineProperty$c($, "".concat(_e, "-disabled"), it), _defineProperty$c($, "".concat(_e, "-readonly"), ut), _defineProperty$c($, "".concat(_e, "-not-a-number"), $t.isNaN()), _defineProperty$c($, "".concat(_e, "-out-of-range"), !$t.isInvalidate() && !Wt($t)), $)),
    style: nt,
    onFocus: function() {
      Ht(!0);
    },
    onBlur: Ir,
    onKeyDown: Sr,
    onKeyUp: Br,
    onCompositionStart: pr,
    onCompositionEnd: yr,
    onBeforeInput: Ar
  }, pt && /* @__PURE__ */ reactExports.createElement(StepHandler, {
    prefixCls: _e,
    upNode: ft,
    downNode: ht,
    upDisabled: tr,
    downDisabled: ir,
    onStep: br
  }), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(It, "-wrap")
  }, /* @__PURE__ */ reactExports.createElement("input", _extends$2({
    autoComplete: "off",
    role: "spinbutton",
    "aria-valuemin": at,
    "aria-valuemax": ot,
    "aria-valuenow": $t.isInvalidate() ? null : $t.toString(),
    step: st
  }, Ct, {
    ref: composeRef(yt, s),
    className: It,
    value: Jt,
    onChange: Er,
    disabled: it,
    readOnly: ut
  }))));
}), InputNumber$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.disabled, _ = a.style, _e = a.prefixCls, tt = a.value, nt = a.prefix, at = a.suffix, ot = a.addonBefore, rt = a.addonAfter, st = a.classes, lt = a.className, et = a.classNames, it = _objectWithoutProperties$1(a, _excluded2$5), ut = reactExports.useRef(null), ft = function(dt) {
    ut.current && triggerFocus$1(ut.current, dt);
  };
  return /* @__PURE__ */ reactExports.createElement(BaseInput, {
    inputElement: /* @__PURE__ */ reactExports.createElement(InternalInputNumber, _extends$2({
      prefixCls: _e,
      disabled: $,
      classNames: et,
      ref: composeRef(ut, s)
    }, it)),
    className: lt,
    triggerFocus: ft,
    prefixCls: _e,
    value: tt,
    disabled: $,
    style: _,
    prefix: nt,
    suffix: at,
    addonAfter: rt,
    addonBefore: ot,
    classes: st,
    classNames: et,
    components: {
      affixWrapper: "div",
      groupWrapper: "div",
      wrapper: "div",
      groupAddon: "div"
    }
  });
});
InputNumber$2.displayName = "InputNumber";
const genRadiusStyle$2 = (a, s) => {
  let {
    componentCls: $,
    borderRadiusSM: _,
    borderRadiusLG: _e
  } = a;
  const tt = s === "lg" ? _e : _;
  return {
    [`&-${s}`]: {
      [`${$}-handler-wrap`]: {
        borderStartEndRadius: tt,
        borderEndEndRadius: tt
      },
      [`${$}-handler-up`]: {
        borderStartEndRadius: tt
      },
      [`${$}-handler-down`]: {
        borderEndEndRadius: tt
      }
    }
  };
}, genInputNumberStyles = (a) => {
  const {
    componentCls: s,
    lineWidth: $,
    lineType: _,
    colorBorder: _e,
    borderRadius: tt,
    fontSizeLG: nt,
    controlHeightLG: at,
    controlHeightSM: ot,
    colorError: rt,
    paddingInlineSM: st,
    colorTextDescription: lt,
    motionDurationMid: et,
    handleHoverColor: it,
    paddingInline: ut,
    paddingBlock: ft,
    handleBg: ht,
    handleActiveBg: dt,
    colorTextDisabled: gt,
    borderRadiusSM: pt,
    borderRadiusLG: mt,
    controlWidth: ct,
    handleOpacity: vt,
    handleBorderColor: At,
    calc: xt
  } = a;
  return [
    {
      [s]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genBasicInputStyle(a)), genStatusStyle(a, s)), {
        display: "inline-block",
        width: ct,
        margin: 0,
        padding: 0,
        border: `${unit$1($)} ${_} ${_e}`,
        borderRadius: tt,
        "&-rtl": {
          direction: "rtl",
          [`${s}-input`]: {
            direction: "rtl"
          }
        },
        "&-lg": {
          padding: 0,
          fontSize: nt,
          borderRadius: mt,
          [`input${s}-input`]: {
            height: xt(at).sub(xt($).mul(2)).equal()
          }
        },
        "&-sm": {
          padding: 0,
          borderRadius: pt,
          [`input${s}-input`]: {
            height: xt(ot).sub(xt($).mul(2)).equal(),
            padding: `0 ${unit$1(st)}`
          }
        },
        // ===================== Out Of Range =====================
        "&-out-of-range": {
          [`${s}-input-wrap`]: {
            input: {
              color: rt
            }
          }
        },
        // Style for input-group: input with label, with button or dropdown...
        "&-group": Object.assign(Object.assign(Object.assign({}, resetComponent(a)), genInputGroupStyle(a)), {
          "&-wrapper": {
            display: "inline-block",
            textAlign: "start",
            verticalAlign: "top",
            // https://github.com/ant-design/ant-design/issues/6403
            [`${s}-affix-wrapper`]: {
              width: "100%"
            },
            // Size
            "&-lg": {
              [`${s}-group-addon`]: {
                borderRadius: mt,
                fontSize: a.fontSizeLG
              }
            },
            "&-sm": {
              [`${s}-group-addon`]: {
                borderRadius: pt
              }
            },
            [`${s}-wrapper-disabled > ${s}-group-addon`]: Object.assign({}, genDisabledStyle(a)),
            // Fix the issue of using icons in Space Compact mode
            // https://github.com/ant-design/ant-design/issues/45764
            [`&:not(${s}-compact-first-item):not(${s}-compact-last-item)${s}-compact-item`]: {
              [`${s}, ${s}-group-addon`]: {
                borderRadius: 0
              }
            },
            [`&:not(${s}-compact-last-item)${s}-compact-first-item`]: {
              [`${s}, ${s}-group-addon`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
              }
            },
            [`&:not(${s}-compact-first-item)${s}-compact-last-item`]: {
              [`${s}, ${s}-group-addon`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
              }
            }
          }
        }),
        [`&-disabled ${s}-input`]: {
          cursor: "not-allowed"
        },
        [s]: {
          "&-input": Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
            width: "100%",
            padding: `${unit$1(ft)} ${unit$1(ut)}`,
            textAlign: "start",
            backgroundColor: "transparent",
            border: 0,
            borderRadius: tt,
            outline: 0,
            transition: `all ${et} linear`,
            appearance: "textfield",
            fontSize: "inherit"
          }), genPlaceholderStyle(a.colorTextPlaceholder)), {
            '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
              margin: 0,
              /* stylelint-disable-next-line property-no-vendor-prefix */
              webkitAppearance: "none",
              appearance: "none"
            }
          })
        }
      })
    },
    // Handler
    {
      [s]: Object.assign(Object.assign(Object.assign({
        [`&:hover ${s}-handler-wrap, &-focused ${s}-handler-wrap`]: {
          opacity: 1
        },
        [`${s}-handler-wrap`]: {
          position: "absolute",
          insetBlockStart: 0,
          insetInlineEnd: 0,
          width: a.handleWidth,
          height: "100%",
          background: ht,
          borderStartStartRadius: 0,
          borderStartEndRadius: tt,
          borderEndEndRadius: tt,
          borderEndStartRadius: 0,
          opacity: vt,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          transition: `opacity ${et} linear ${et}`,
          // Fix input number inside Menu makes icon too large
          // We arise the selector priority by nest selector here
          // https://github.com/ant-design/ant-design/issues/14367
          [`${s}-handler`]: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "auto",
            height: "40%",
            [`
              ${s}-handler-up-inner,
              ${s}-handler-down-inner
            `]: {
              marginInlineEnd: 0,
              fontSize: a.handleFontSize
            }
          }
        },
        [`${s}-handler`]: {
          height: "50%",
          overflow: "hidden",
          color: lt,
          fontWeight: "bold",
          lineHeight: 0,
          textAlign: "center",
          cursor: "pointer",
          borderInlineStart: `${unit$1($)} ${_} ${At}`,
          transition: `all ${et} linear`,
          "&:active": {
            background: dt
          },
          // Hover
          "&:hover": {
            height: "60%",
            [`
              ${s}-handler-up-inner,
              ${s}-handler-down-inner
            `]: {
              color: it
            }
          },
          "&-up-inner, &-down-inner": Object.assign(Object.assign({}, resetIcon()), {
            color: lt,
            transition: `all ${et} linear`,
            userSelect: "none"
          })
        },
        [`${s}-handler-up`]: {
          borderStartEndRadius: tt
        },
        [`${s}-handler-down`]: {
          borderBlockStart: `${unit$1($)} ${_} ${At}`,
          borderEndEndRadius: tt
        }
      }, genRadiusStyle$2(a, "lg")), genRadiusStyle$2(a, "sm")), {
        // Disabled
        "&-disabled, &-readonly": {
          [`${s}-handler-wrap`]: {
            display: "none"
          },
          [`${s}-input`]: {
            color: "inherit"
          }
        },
        [`
          ${s}-handler-up-disabled,
          ${s}-handler-down-disabled
        `]: {
          cursor: "not-allowed"
        },
        [`
          ${s}-handler-up-disabled:hover &-handler-up-inner,
          ${s}-handler-down-disabled:hover &-handler-down-inner
        `]: {
          color: gt
        }
      })
    },
    // Border-less
    {
      [`${s}-borderless`]: {
        borderColor: "transparent",
        boxShadow: "none",
        [`${s}-handler-down`]: {
          borderBlockStartWidth: 0
        }
      }
    }
  ];
}, genAffixWrapperStyles = (a) => {
  const {
    componentCls: s,
    paddingBlock: $,
    paddingInline: _,
    inputAffixPadding: _e,
    controlWidth: tt,
    borderRadiusLG: nt,
    borderRadiusSM: at
  } = a;
  return {
    [`${s}-affix-wrapper`]: Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(a)), genStatusStyle(a, `${s}-affix-wrapper`)), {
      // or number handler will cover form status
      position: "relative",
      display: "inline-flex",
      width: tt,
      padding: 0,
      paddingInlineStart: _,
      "&-lg": {
        borderRadius: nt
      },
      "&-sm": {
        borderRadius: at
      },
      [`&:not(${s}-affix-wrapper-disabled):hover`]: {
        zIndex: 1
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`&-disabled > ${s}-disabled`]: {
        background: "transparent"
      },
      [`> div${s}`]: {
        width: "100%",
        border: "none",
        outline: "none",
        [`&${s}-focused`]: {
          boxShadow: "none !important"
        }
      },
      [`input${s}-input`]: {
        padding: `${unit$1($)} 0`
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${s}-handler-wrap`]: {
        zIndex: 2
      },
      [s]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          pointerEvents: "none"
        },
        "&-prefix": {
          marginInlineEnd: _e
        },
        "&-suffix": {
          position: "absolute",
          insetBlockStart: 0,
          insetInlineEnd: 0,
          zIndex: 1,
          height: "100%",
          marginInlineEnd: _,
          marginInlineStart: _e
        }
      }
    })
  };
}, prepareComponentToken$f = (a) => Object.assign(Object.assign({}, initComponentToken$1(a)), {
  controlWidth: 90,
  handleWidth: a.controlHeightSM - a.lineWidth * 2,
  handleFontSize: a.fontSize / 2,
  handleVisible: "auto",
  handleActiveBg: a.colorFillAlter,
  handleBg: a.colorBgContainer,
  handleHoverColor: a.colorPrimary,
  handleBorderColor: a.colorBorder,
  handleOpacity: 0
}), formatComponentToken = (a) => Object.assign(Object.assign({}, a), {
  handleOpacity: a.handleVisible === !0 ? 1 : 0
}), useStyle$f = genStyleHooks("InputNumber", (a) => {
  const s = merge(a, initInputToken(a));
  return [
    genInputNumberStyles(s),
    genAffixWrapperStyles(s),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(s)
  ];
}, prepareComponentToken$f, {
  format: formatComponentToken,
  unitless: {
    handleOpacity: !0
  }
});
var __rest$C = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const InputNumber$1 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    getPrefixCls: $,
    direction: _
  } = reactExports.useContext(ConfigContext$1), _e = reactExports.useRef(null);
  reactExports.useImperativeHandle(s, () => _e.current);
  const {
    className: tt,
    rootClassName: nt,
    size: at,
    disabled: ot,
    prefixCls: rt,
    addonBefore: st,
    addonAfter: lt,
    prefix: et,
    bordered: it = !0,
    readOnly: ut,
    status: ft,
    controls: ht
  } = a, dt = __rest$C(a, ["className", "rootClassName", "size", "disabled", "prefixCls", "addonBefore", "addonAfter", "prefix", "bordered", "readOnly", "status", "controls"]), gt = $("input-number", rt), pt = useCSSVarCls$1(gt), [mt, ct, vt] = useStyle$f(gt, pt), {
    compactSize: At,
    compactItemClassnames: xt
  } = useCompactItemContext(gt, _);
  let bt = /* @__PURE__ */ reactExports.createElement(UpOutlined$1, {
    className: `${gt}-handler-up-inner`
  }), Et = /* @__PURE__ */ reactExports.createElement(DownOutlined$4, {
    className: `${gt}-handler-down-inner`
  });
  const St = typeof ht == "boolean" ? ht : void 0;
  typeof ht == "object" && (bt = typeof ht.upIcon > "u" ? bt : /* @__PURE__ */ reactExports.createElement("span", {
    className: `${gt}-handler-up-inner`
  }, ht.upIcon), Et = typeof ht.downIcon > "u" ? Et : /* @__PURE__ */ reactExports.createElement("span", {
    className: `${gt}-handler-down-inner`
  }, ht.downIcon));
  const {
    hasFeedback: Bt,
    status: Ot,
    isFormItemInput: Pt,
    feedbackIcon: wt
  } = reactExports.useContext(FormItemInputContext), Ct = getMergedStatus(Ot, ft), It = useSize$1((_t) => {
    var Nt;
    return (Nt = at ?? At) !== null && Nt !== void 0 ? Nt : _t;
  }), yt = reactExports.useContext(DisabledContext$1), Rt = ot ?? yt, kt = classnames({
    [`${gt}-lg`]: It === "large",
    [`${gt}-sm`]: It === "small",
    [`${gt}-rtl`]: _ === "rtl",
    [`${gt}-borderless`]: !it,
    [`${gt}-in-form-item`]: Pt
  }, getStatusClassNames(gt, Ct), ct), jt = `${gt}-group`, Ht = Bt && /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, wt), Ft = /* @__PURE__ */ reactExports.createElement(InputNumber$2, Object.assign({
    ref: _e,
    disabled: Rt,
    className: classnames(vt, pt, tt, nt, xt),
    upHandler: bt,
    downHandler: Et,
    prefixCls: gt,
    readOnly: ut,
    controls: St,
    prefix: et,
    suffix: Ht,
    addonAfter: lt && /* @__PURE__ */ reactExports.createElement(NoCompactStyle, null, /* @__PURE__ */ reactExports.createElement(NoFormStyle, {
      override: !0,
      status: !0
    }, lt)),
    addonBefore: st && /* @__PURE__ */ reactExports.createElement(NoCompactStyle, null, /* @__PURE__ */ reactExports.createElement(NoFormStyle, {
      override: !0,
      status: !0
    }, st)),
    classNames: {
      input: kt
    },
    classes: {
      affixWrapper: classnames(getStatusClassNames(`${gt}-affix-wrapper`, Ct, Bt), {
        [`${gt}-affix-wrapper-sm`]: It === "small",
        [`${gt}-affix-wrapper-lg`]: It === "large",
        [`${gt}-affix-wrapper-rtl`]: _ === "rtl",
        [`${gt}-affix-wrapper-borderless`]: !it
      }, ct),
      wrapper: classnames({
        [`${jt}-rtl`]: _ === "rtl",
        [`${gt}-wrapper-disabled`]: Rt
      }, ct),
      group: classnames({
        [`${gt}-group-wrapper-sm`]: It === "small",
        [`${gt}-group-wrapper-lg`]: It === "large",
        [`${gt}-group-wrapper-rtl`]: _ === "rtl"
      }, getStatusClassNames(`${gt}-group-wrapper`, Ct, Bt), ct)
    }
  }, dt));
  return mt(Ft);
}), TypedInputNumber = InputNumber$1, PureInputNumber = (a) => /* @__PURE__ */ reactExports.createElement(ThemeConfigProvider, {
  theme: {
    components: {
      InputNumber: {
        handleVisible: !0
      }
    }
  }
}, /* @__PURE__ */ reactExports.createElement(InputNumber$1, Object.assign({}, a)));
TypedInputNumber._InternalPanelDoNotUseOrYouWillBeFired = PureInputNumber;
const _InputNumber = TypedInputNumber, Group$1 = (a) => {
  const {
    getPrefixCls: s,
    direction: $
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: _,
    className: _e
  } = a, tt = s("input-group", _), nt = s("input"), [at, ot] = useStyle$n(nt), rt = classnames(tt, {
    [`${tt}-lg`]: a.size === "large",
    [`${tt}-sm`]: a.size === "small",
    [`${tt}-compact`]: a.compact,
    [`${tt}-rtl`]: $ === "rtl"
  }, ot, _e), st = reactExports.useContext(FormItemInputContext), lt = reactExports.useMemo(() => Object.assign(Object.assign({}, st), {
    isFormItemInput: !1
  }), [st]);
  return at(/* @__PURE__ */ reactExports.createElement("span", {
    className: rt,
    style: a.style,
    onMouseEnter: a.onMouseEnter,
    onMouseLeave: a.onMouseLeave,
    onFocus: a.onFocus,
    onBlur: a.onBlur
  }, /* @__PURE__ */ reactExports.createElement(FormItemInputContext.Provider, {
    value: lt
  }, a.children)));
}, Group$2 = Group$1;
function useRemovePasswordTimeout(a, s) {
  const $ = reactExports.useRef([]), _ = () => {
    $.current.push(setTimeout(() => {
      var _e, tt, nt, at;
      !((_e = a.current) === null || _e === void 0) && _e.input && ((tt = a.current) === null || tt === void 0 ? void 0 : tt.input.getAttribute("type")) === "password" && (!((nt = a.current) === null || nt === void 0) && nt.input.hasAttribute("value")) && ((at = a.current) === null || at === void 0 || at.input.removeAttribute("value"));
    }));
  };
  return reactExports.useEffect(() => (s && _(), () => $.current.forEach((_e) => {
    _e && clearTimeout(_e);
  })), []), _;
}
function hasPrefixSuffix(a) {
  return !!(a.prefix || a.suffix || a.allowClear);
}
var __rest$B = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function triggerFocus(a, s) {
  if (!a)
    return;
  a.focus(s);
  const {
    cursor: $
  } = s || {};
  if ($) {
    const _ = a.value.length;
    switch ($) {
      case "start":
        a.setSelectionRange(0, 0);
        break;
      case "end":
        a.setSelectionRange(_, _);
        break;
      default:
        a.setSelectionRange(0, _);
        break;
    }
  }
}
const Input$2 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var $;
  const {
    prefixCls: _,
    bordered: _e = !0,
    status: tt,
    size: nt,
    disabled: at,
    onBlur: ot,
    onFocus: rt,
    suffix: st,
    allowClear: lt,
    addonAfter: et,
    addonBefore: it,
    className: ut,
    style: ft,
    styles: ht,
    rootClassName: dt,
    onChange: gt,
    classNames: pt
  } = a, mt = __rest$B(a, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames"]), {
    getPrefixCls: ct,
    direction: vt,
    input: At
  } = React$a.useContext(ConfigContext$1), xt = ct("input", _), bt = reactExports.useRef(null), Et = useCSSVarCls$1(xt), [St, Bt, Ot] = useStyle$n(xt, Et), {
    compactSize: Pt,
    compactItemClassnames: wt
  } = useCompactItemContext(xt, vt), Ct = useSize$1((Dt) => {
    var Ut;
    return (Ut = nt ?? Pt) !== null && Ut !== void 0 ? Ut : Dt;
  }), It = React$a.useContext(DisabledContext$1), yt = at ?? It, {
    status: Rt,
    hasFeedback: kt,
    feedbackIcon: jt
  } = reactExports.useContext(FormItemInputContext), Ht = getMergedStatus(Rt, tt), Ft = hasPrefixSuffix(a) || !!kt;
  reactExports.useRef(Ft);
  const _t = useRemovePasswordTimeout(bt, !0), Nt = (Dt) => {
    _t(), ot == null || ot(Dt);
  }, Mt = (Dt) => {
    _t(), rt == null || rt(Dt);
  }, Lt = (Dt) => {
    _t(), gt == null || gt(Dt);
  }, $t = (kt || st) && /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, st, kt && jt);
  let Tt;
  return typeof lt == "object" && (lt != null && lt.clearIcon) ? Tt = lt : lt && (Tt = {
    clearIcon: /* @__PURE__ */ React$a.createElement(CloseCircleFilled$1, null)
  }), St(/* @__PURE__ */ React$a.createElement(Input$3, Object.assign({
    ref: composeRef(s, bt),
    prefixCls: xt,
    autoComplete: At == null ? void 0 : At.autoComplete
  }, mt, {
    disabled: yt,
    onBlur: Nt,
    onFocus: Mt,
    style: Object.assign(Object.assign({}, At == null ? void 0 : At.style), ft),
    styles: Object.assign(Object.assign({}, At == null ? void 0 : At.styles), ht),
    suffix: $t,
    allowClear: Tt,
    className: classnames(ut, dt, Ot, Et, Bt, wt, At == null ? void 0 : At.className),
    onChange: Lt,
    addonAfter: et && /* @__PURE__ */ React$a.createElement(NoCompactStyle, null, /* @__PURE__ */ React$a.createElement(NoFormStyle, {
      override: !0,
      status: !0
    }, et)),
    addonBefore: it && /* @__PURE__ */ React$a.createElement(NoCompactStyle, null, /* @__PURE__ */ React$a.createElement(NoFormStyle, {
      override: !0,
      status: !0
    }, it)),
    classNames: Object.assign(Object.assign(Object.assign({}, pt), At == null ? void 0 : At.classNames), {
      input: classnames({
        [`${xt}-sm`]: Ct === "small",
        [`${xt}-lg`]: Ct === "large",
        [`${xt}-rtl`]: vt === "rtl",
        [`${xt}-borderless`]: !_e
      }, !Ft && getStatusClassNames(xt, Ht), pt == null ? void 0 : pt.input, ($ = At == null ? void 0 : At.classNames) === null || $ === void 0 ? void 0 : $.input, Bt)
    }),
    classes: {
      affixWrapper: classnames({
        [`${xt}-affix-wrapper-sm`]: Ct === "small",
        [`${xt}-affix-wrapper-lg`]: Ct === "large",
        [`${xt}-affix-wrapper-rtl`]: vt === "rtl",
        [`${xt}-affix-wrapper-borderless`]: !_e
      }, getStatusClassNames(`${xt}-affix-wrapper`, Ht, kt), Bt),
      wrapper: classnames({
        [`${xt}-group-rtl`]: vt === "rtl"
      }, Bt),
      group: classnames({
        [`${xt}-group-wrapper-sm`]: Ct === "small",
        [`${xt}-group-wrapper-lg`]: Ct === "large",
        [`${xt}-group-wrapper-rtl`]: vt === "rtl",
        [`${xt}-group-wrapper-disabled`]: yt
      }, getStatusClassNames(`${xt}-group-wrapper`, Ht, kt), Bt)
    }
  })));
}), InternalInput = Input$2;
var EyeInvisibleOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" };
const EyeInvisibleOutlinedSvg = EyeInvisibleOutlined$2;
var EyeInvisibleOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: EyeInvisibleOutlinedSvg
  }));
};
const EyeInvisibleOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(EyeInvisibleOutlined);
var EyeOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
const EyeOutlinedSvg = EyeOutlined$2;
var EyeOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: EyeOutlinedSvg
  }));
};
const EyeOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(EyeOutlined);
var __rest$A = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const defaultIconRender = (a) => a ? /* @__PURE__ */ reactExports.createElement(EyeOutlined$1, null) : /* @__PURE__ */ reactExports.createElement(EyeInvisibleOutlined$1, null), ActionMap = {
  click: "onClick",
  hover: "onMouseOver"
}, Password = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    visibilityToggle: $ = !0
  } = a, _ = typeof $ == "object" && $.visible !== void 0, [_e, tt] = reactExports.useState(() => _ ? $.visible : !1), nt = reactExports.useRef(null);
  reactExports.useEffect(() => {
    _ && tt($.visible);
  }, [_, $]);
  const at = useRemovePasswordTimeout(nt), ot = () => {
    const {
      disabled: ct
    } = a;
    ct || (_e && at(), tt((vt) => {
      var At;
      const xt = !vt;
      return typeof $ == "object" && ((At = $.onVisibleChange) === null || At === void 0 || At.call($, xt)), xt;
    }));
  }, rt = (ct) => {
    const {
      action: vt = "click",
      iconRender: At = defaultIconRender
    } = a, xt = ActionMap[vt] || "", bt = At(_e), Et = {
      [xt]: ot,
      className: `${ct}-icon`,
      key: "passwordIcon",
      onMouseDown: (St) => {
        St.preventDefault();
      },
      onMouseUp: (St) => {
        St.preventDefault();
      }
    };
    return /* @__PURE__ */ reactExports.cloneElement(/* @__PURE__ */ reactExports.isValidElement(bt) ? bt : /* @__PURE__ */ reactExports.createElement("span", null, bt), Et);
  }, {
    className: st,
    prefixCls: lt,
    inputPrefixCls: et,
    size: it
  } = a, ut = __rest$A(a, ["className", "prefixCls", "inputPrefixCls", "size"]), {
    getPrefixCls: ft
  } = reactExports.useContext(ConfigContext$1), ht = ft("input", et), dt = ft("input-password", lt), gt = $ && rt(dt), pt = classnames(dt, st, {
    [`${dt}-${it}`]: !!it
  }), mt = Object.assign(Object.assign({}, omit(ut, ["suffix", "iconRender", "visibilityToggle"])), {
    type: _e ? "text" : "password",
    className: pt,
    prefixCls: ht,
    suffix: gt
  });
  return it && (mt.size = it), /* @__PURE__ */ reactExports.createElement(InternalInput, Object.assign({
    ref: composeRef(s, nt)
  }, mt));
}), Password$1 = Password;
var __rest$z = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Search = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: $,
    inputPrefixCls: _,
    className: _e,
    size: tt,
    suffix: nt,
    enterButton: at = !1,
    addonAfter: ot,
    loading: rt,
    disabled: st,
    onSearch: lt,
    onChange: et,
    onCompositionStart: it,
    onCompositionEnd: ut
  } = a, ft = __rest$z(a, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]), {
    getPrefixCls: ht,
    direction: dt
  } = reactExports.useContext(ConfigContext$1), gt = reactExports.useRef(!1), pt = ht("input-search", $), mt = ht("input", _), {
    compactSize: ct
  } = useCompactItemContext(pt, dt), vt = useSize$1((kt) => {
    var jt;
    return (jt = tt ?? ct) !== null && jt !== void 0 ? jt : kt;
  }), At = reactExports.useRef(null), xt = (kt) => {
    kt && kt.target && kt.type === "click" && lt && lt(kt.target.value, kt, {
      source: "clear"
    }), et && et(kt);
  }, bt = (kt) => {
    var jt;
    document.activeElement === ((jt = At.current) === null || jt === void 0 ? void 0 : jt.input) && kt.preventDefault();
  }, Et = (kt) => {
    var jt, Ht;
    lt && lt((Ht = (jt = At.current) === null || jt === void 0 ? void 0 : jt.input) === null || Ht === void 0 ? void 0 : Ht.value, kt, {
      source: "input"
    });
  }, St = (kt) => {
    gt.current || rt || Et(kt);
  }, Bt = typeof at == "boolean" ? /* @__PURE__ */ reactExports.createElement(SearchOutlined$1, null) : null, Ot = `${pt}-button`;
  let Pt;
  const wt = at || {}, Ct = wt.type && wt.type.__ANT_BUTTON === !0;
  Ct || wt.type === "button" ? Pt = cloneElement(wt, Object.assign({
    onMouseDown: bt,
    onClick: (kt) => {
      var jt, Ht;
      (Ht = (jt = wt == null ? void 0 : wt.props) === null || jt === void 0 ? void 0 : jt.onClick) === null || Ht === void 0 || Ht.call(jt, kt), Et(kt);
    },
    key: "enterButton"
  }, Ct ? {
    className: Ot,
    size: vt
  } : {})) : Pt = /* @__PURE__ */ reactExports.createElement(Button$2, {
    className: Ot,
    type: at ? "primary" : void 0,
    size: vt,
    disabled: st,
    key: "enterButton",
    onMouseDown: bt,
    onClick: Et,
    loading: rt,
    icon: Bt
  }, at), ot && (Pt = [Pt, cloneElement(ot, {
    key: "addonAfter"
  })]);
  const It = classnames(pt, {
    [`${pt}-rtl`]: dt === "rtl",
    [`${pt}-${vt}`]: !!vt,
    [`${pt}-with-button`]: !!at
  }, _e), yt = (kt) => {
    gt.current = !0, it == null || it(kt);
  }, Rt = (kt) => {
    gt.current = !1, ut == null || ut(kt);
  };
  return /* @__PURE__ */ reactExports.createElement(InternalInput, Object.assign({
    ref: composeRef(At, s),
    onPressEnter: St
  }, ft, {
    size: vt,
    onCompositionStart: yt,
    onCompositionEnd: Rt,
    prefixCls: mt,
    addonAfter: Pt,
    suffix: nt,
    onChange: xt,
    className: It,
    disabled: st
  }));
}), Search$1 = Search;
var HIDDEN_TEXTAREA_STYLE = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, SIZING_STYLE = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], computedStyleCache = {}, hiddenTextarea;
function calculateNodeStyling(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, $ = a.getAttribute("id") || a.getAttribute("data-reactid") || a.getAttribute("name");
  if (s && computedStyleCache[$])
    return computedStyleCache[$];
  var _ = window.getComputedStyle(a), _e = _.getPropertyValue("box-sizing") || _.getPropertyValue("-moz-box-sizing") || _.getPropertyValue("-webkit-box-sizing"), tt = parseFloat(_.getPropertyValue("padding-bottom")) + parseFloat(_.getPropertyValue("padding-top")), nt = parseFloat(_.getPropertyValue("border-bottom-width")) + parseFloat(_.getPropertyValue("border-top-width")), at = SIZING_STYLE.map(function(rt) {
    return "".concat(rt, ":").concat(_.getPropertyValue(rt));
  }).join(";"), ot = {
    sizingStyle: at,
    paddingSize: tt,
    borderSize: nt,
    boxSizing: _e
  };
  return s && $ && (computedStyleCache[$] = ot), ot;
}
function calculateAutoSizeStyle(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  hiddenTextarea || (hiddenTextarea = document.createElement("textarea"), hiddenTextarea.setAttribute("tab-index", "-1"), hiddenTextarea.setAttribute("aria-hidden", "true"), document.body.appendChild(hiddenTextarea)), a.getAttribute("wrap") ? hiddenTextarea.setAttribute("wrap", a.getAttribute("wrap")) : hiddenTextarea.removeAttribute("wrap");
  var _e = calculateNodeStyling(a, s), tt = _e.paddingSize, nt = _e.borderSize, at = _e.boxSizing, ot = _e.sizingStyle;
  hiddenTextarea.setAttribute("style", "".concat(ot, ";").concat(HIDDEN_TEXTAREA_STYLE)), hiddenTextarea.value = a.value || a.placeholder || "";
  var rt = void 0, st = void 0, lt, et = hiddenTextarea.scrollHeight;
  if (at === "border-box" ? et += nt : at === "content-box" && (et -= tt), $ !== null || _ !== null) {
    hiddenTextarea.value = " ";
    var it = hiddenTextarea.scrollHeight - tt;
    $ !== null && (rt = it * $, at === "border-box" && (rt = rt + tt + nt), et = Math.max(rt, et)), _ !== null && (st = it * _, at === "border-box" && (st = st + tt + nt), lt = et > st ? "" : "hidden", et = Math.min(st, et));
  }
  var ut = {
    height: et,
    overflowY: lt,
    resize: "none"
  };
  return rt && (ut.minHeight = rt), st && (ut.maxHeight = st), ut;
}
var _excluded$m = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], RESIZE_START = 0, RESIZE_MEASURING = 1, RESIZE_STABLE = 2, ResizableTextArea = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a, _ = $.prefixCls;
  $.onPressEnter;
  var _e = $.defaultValue, tt = $.value, nt = $.autoSize, at = $.onResize, ot = $.className, rt = $.style, st = $.disabled, lt = $.onChange;
  $.onInternalAutoSize;
  var et = _objectWithoutProperties$1($, _excluded$m), it = useMergedState(_e, {
    value: tt,
    postState: function(_t) {
      return _t ?? "";
    }
  }), ut = _slicedToArray$e(it, 2), ft = ut[0], ht = ut[1], dt = function(_t) {
    ht(_t.target.value), lt == null || lt(_t);
  }, gt = reactExports.useRef();
  reactExports.useImperativeHandle(s, function() {
    return {
      textArea: gt.current
    };
  });
  var pt = reactExports.useMemo(function() {
    return nt && _typeof$q(nt) === "object" ? [nt.minRows, nt.maxRows] : [];
  }, [nt]), mt = _slicedToArray$e(pt, 2), ct = mt[0], vt = mt[1], At = !!nt, xt = function() {
    try {
      if (document.activeElement === gt.current) {
        var _t = gt.current, Nt = _t.selectionStart, Mt = _t.selectionEnd, Lt = _t.scrollTop;
        gt.current.setSelectionRange(Nt, Mt), gt.current.scrollTop = Lt;
      }
    } catch {
    }
  }, bt = reactExports.useState(RESIZE_STABLE), Et = _slicedToArray$e(bt, 2), St = Et[0], Bt = Et[1], Ot = reactExports.useState(), Pt = _slicedToArray$e(Ot, 2), wt = Pt[0], Ct = Pt[1], It = function() {
    Bt(RESIZE_START);
  };
  useLayoutEffect$1(function() {
    At && It();
  }, [tt, ct, vt, At]), useLayoutEffect$1(function() {
    if (St === RESIZE_START)
      Bt(RESIZE_MEASURING);
    else if (St === RESIZE_MEASURING) {
      var Ft = calculateAutoSizeStyle(gt.current, !1, ct, vt);
      Bt(RESIZE_STABLE), Ct(Ft);
    } else
      xt();
  }, [St]);
  var yt = reactExports.useRef(), Rt = function() {
    wrapperRaf.cancel(yt.current);
  }, kt = function(_t) {
    St === RESIZE_STABLE && (at == null || at(_t), nt && (Rt(), yt.current = wrapperRaf(function() {
      It();
    })));
  };
  reactExports.useEffect(function() {
    return Rt;
  }, []);
  var jt = At ? wt : null, Ht = _objectSpread2$a(_objectSpread2$a({}, rt), jt);
  return (St === RESIZE_START || St === RESIZE_MEASURING) && (Ht.overflowY = "hidden", Ht.overflowX = "hidden"), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: kt,
    disabled: !(nt || at)
  }, /* @__PURE__ */ reactExports.createElement("textarea", _extends$2({}, et, {
    ref: gt,
    style: Ht,
    className: classnames(_, ot, _defineProperty$c({}, "".concat(_, "-disabled"), st)),
    disabled: st,
    value: ft,
    onChange: dt
  })));
}), _excluded$l = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "classes", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize"], TextArea$5 = /* @__PURE__ */ React$a.forwardRef(function(a, s) {
  var $, _, _e = a.defaultValue, tt = a.value, nt = a.onFocus, at = a.onBlur, ot = a.onChange, rt = a.allowClear, st = a.maxLength, lt = a.onCompositionStart, et = a.onCompositionEnd, it = a.suffix, ut = a.prefixCls, ft = ut === void 0 ? "rc-textarea" : ut, ht = a.classes, dt = a.showCount, gt = a.count, pt = a.className, mt = a.style, ct = a.disabled, vt = a.hidden, At = a.classNames, xt = a.styles, bt = a.onResize, Et = _objectWithoutProperties$1(a, _excluded$l), St = useMergedState(_e, {
    value: tt,
    defaultValue: _e
  }), Bt = _slicedToArray$e(St, 2), Ot = Bt[0], Pt = Bt[1], wt = Ot == null ? "" : String(Ot), Ct = React$a.useState(!1), It = _slicedToArray$e(Ct, 2), yt = It[0], Rt = It[1], kt = React$a.useRef(!1), jt = React$a.useState(null), Ht = _slicedToArray$e(jt, 2), Ft = Ht[0], _t = Ht[1], Nt = reactExports.useRef(null), Mt = function() {
    var lr;
    return (lr = Nt.current) === null || lr === void 0 ? void 0 : lr.textArea;
  }, Lt = function() {
    Mt().focus();
  };
  reactExports.useImperativeHandle(s, function() {
    return {
      resizableTextArea: Nt.current,
      focus: Lt,
      blur: function() {
        Mt().blur();
      }
    };
  }), reactExports.useEffect(function() {
    Rt(function(er) {
      return !ct && er;
    });
  }, [ct]);
  var $t = React$a.useState(null), Tt = _slicedToArray$e($t, 2), Dt = Tt[0], Ut = Tt[1];
  React$a.useEffect(function() {
    if (Dt) {
      var er;
      (er = Mt()).setSelectionRange.apply(er, _toConsumableArray$d(Dt));
    }
  }, [Dt]);
  var Vt = useCount(gt, dt), Qt = ($ = Vt.max) !== null && $ !== void 0 ? $ : st, qt = Number(Qt) > 0, Zt = Vt.strategy(wt), ar = !!Qt && Zt > Qt, Jt = function(lr, ur) {
    var pr = ur;
    !kt.current && Vt.exceedFormatter && Vt.max && Vt.strategy(ur) > Vt.max && (pr = Vt.exceedFormatter(ur, {
      max: Vt.max
    }), ur !== pr && Ut([Mt().selectionStart || 0, Mt().selectionEnd || 0])), Pt(pr), resolveOnChange(lr.currentTarget, lr, ot, pr);
  }, rr = function(lr) {
    kt.current = !0, lt == null || lt(lr);
  }, Yt = function(lr) {
    kt.current = !1, Jt(lr, lr.currentTarget.value), et == null || et(lr);
  }, Kt = function(lr) {
    Jt(lr, lr.target.value);
  }, nr = function(lr) {
    var ur = Et.onPressEnter, pr = Et.onKeyDown;
    lr.key === "Enter" && ur && ur(lr), pr == null || pr(lr);
  }, tr = function(lr) {
    Rt(!0), nt == null || nt(lr);
  }, ir = function(lr) {
    Rt(!1), at == null || at(lr);
  }, sr = function(lr) {
    Pt(""), Lt(), resolveOnChange(Mt(), lr, ot);
  }, cr = it, or;
  Vt.show && (Vt.showFormatter ? or = Vt.showFormatter({
    value: wt,
    count: Zt,
    maxLength: Qt
  }) : or = "".concat(Zt).concat(qt ? " / ".concat(Qt) : ""), cr = /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, cr, /* @__PURE__ */ React$a.createElement("span", {
    className: classnames("".concat(ft, "-data-count"), At == null ? void 0 : At.count),
    style: xt == null ? void 0 : xt.count
  }, or)));
  var Xt = function(lr) {
    var ur;
    bt == null || bt(lr), (ur = Mt()) !== null && ur !== void 0 && ur.style.height && _t(!0);
  }, Gt = !Et.autoSize && !dt && !rt, Wt = /* @__PURE__ */ React$a.createElement(BaseInput, {
    value: wt,
    allowClear: rt,
    handleReset: sr,
    suffix: cr,
    prefixCls: ft,
    classes: {
      affixWrapper: classnames(ht == null ? void 0 : ht.affixWrapper, (_ = {}, _defineProperty$c(_, "".concat(ft, "-show-count"), dt), _defineProperty$c(_, "".concat(ft, "-textarea-allow-clear"), rt), _))
    },
    disabled: ct,
    focused: yt,
    className: classnames(pt, ar && "".concat(ft, "-out-of-range")),
    style: _objectSpread2$a(_objectSpread2$a({}, mt), Ft && !Gt ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof or == "string" ? or : void 0
      }
    },
    hidden: vt,
    inputElement: /* @__PURE__ */ React$a.createElement(ResizableTextArea, _extends$2({}, Et, {
      maxLength: st,
      onKeyDown: nr,
      onChange: Kt,
      onFocus: tr,
      onBlur: ir,
      onCompositionStart: rr,
      onCompositionEnd: Yt,
      className: classnames(At == null ? void 0 : At.textarea),
      style: _objectSpread2$a(_objectSpread2$a({}, xt == null ? void 0 : xt.textarea), {}, {
        resize: mt == null ? void 0 : mt.resize
      }),
      disabled: ct,
      prefixCls: ft,
      onResize: Xt,
      ref: Nt
    }))
  });
  return Wt;
}), __rest$y = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const TextArea$3 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var $;
  const {
    prefixCls: _,
    bordered: _e = !0,
    size: tt,
    disabled: nt,
    status: at,
    allowClear: ot,
    classNames: rt,
    rootClassName: st,
    className: lt
  } = a, et = __rest$y(a, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className"]), {
    getPrefixCls: it,
    direction: ut
  } = reactExports.useContext(ConfigContext$1), ft = useSize$1(tt), ht = reactExports.useContext(DisabledContext$1), dt = nt ?? ht, {
    status: gt,
    hasFeedback: pt,
    feedbackIcon: mt
  } = reactExports.useContext(FormItemInputContext), ct = getMergedStatus(gt, at), vt = reactExports.useRef(null);
  reactExports.useImperativeHandle(s, () => {
    var Ot;
    return {
      resizableTextArea: (Ot = vt.current) === null || Ot === void 0 ? void 0 : Ot.resizableTextArea,
      focus: (Pt) => {
        var wt, Ct;
        triggerFocus((Ct = (wt = vt.current) === null || wt === void 0 ? void 0 : wt.resizableTextArea) === null || Ct === void 0 ? void 0 : Ct.textArea, Pt);
      },
      blur: () => {
        var Pt;
        return (Pt = vt.current) === null || Pt === void 0 ? void 0 : Pt.blur();
      }
    };
  });
  const At = it("input", _);
  let xt;
  typeof ot == "object" && (ot != null && ot.clearIcon) ? xt = ot : ot && (xt = {
    clearIcon: /* @__PURE__ */ reactExports.createElement(CloseCircleFilled$1, null)
  });
  const bt = useCSSVarCls$1(At), [Et, St, Bt] = useStyle$n(At, bt);
  return Et(/* @__PURE__ */ reactExports.createElement(TextArea$5, Object.assign({}, et, {
    disabled: dt,
    allowClear: xt,
    className: classnames(Bt, bt, lt, st),
    classes: {
      affixWrapper: classnames(`${At}-textarea-affix-wrapper`, {
        [`${At}-affix-wrapper-rtl`]: ut === "rtl",
        [`${At}-affix-wrapper-borderless`]: !_e,
        [`${At}-affix-wrapper-sm`]: ft === "small",
        [`${At}-affix-wrapper-lg`]: ft === "large",
        [`${At}-textarea-show-count`]: a.showCount || (($ = a.count) === null || $ === void 0 ? void 0 : $.show)
      }, getStatusClassNames(`${At}-affix-wrapper`, ct), St)
    },
    classNames: Object.assign(Object.assign({}, rt), {
      textarea: classnames({
        [`${At}-borderless`]: !_e,
        [`${At}-sm`]: ft === "small",
        [`${At}-lg`]: ft === "large"
      }, getStatusClassNames(At, ct), St, rt == null ? void 0 : rt.textarea)
    }),
    prefixCls: At,
    suffix: pt && /* @__PURE__ */ reactExports.createElement("span", {
      className: `${At}-textarea-suffix`
    }, mt),
    ref: vt
  })));
}), TextArea$4 = TextArea$3, Input$1 = InternalInput;
Input$1.Group = Group$2;
Input$1.Search = Search$1;
Input$1.TextArea = TextArea$4;
Input$1.Password = Password$1;
const _Input = Input$1;
var CalendarOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z" } }] }, name: "calendar", theme: "outlined" };
const CalendarOutlinedSvg = CalendarOutlined$2;
var CalendarOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: CalendarOutlinedSvg
  }));
};
const CalendarOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(CalendarOutlined);
var ClockCircleOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z" } }] }, name: "clock-circle", theme: "outlined" };
const ClockCircleOutlinedSvg = ClockCircleOutlined$2;
var ClockCircleOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: ClockCircleOutlinedSvg
  }));
};
const ClockCircleOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(ClockCircleOutlined);
var SwapRightOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z" } }] }, name: "swap-right", theme: "outlined" };
const SwapRightOutlinedSvg = SwapRightOutlined$2;
var SwapRightOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: SwapRightOutlinedSvg
  }));
};
const SwapRightOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(SwapRightOutlined);
function getPlaceholder(a, s, $) {
  return $ !== void 0 ? $ : s === "year" && a.lang.yearPlaceholder ? a.lang.yearPlaceholder : s === "quarter" && a.lang.quarterPlaceholder ? a.lang.quarterPlaceholder : s === "month" && a.lang.monthPlaceholder ? a.lang.monthPlaceholder : s === "week" && a.lang.weekPlaceholder ? a.lang.weekPlaceholder : s === "time" && a.timePickerLocale.placeholder ? a.timePickerLocale.placeholder : a.lang.placeholder;
}
function getRangePlaceholder(a, s, $) {
  return $ !== void 0 ? $ : s === "year" && a.lang.yearPlaceholder ? a.lang.rangeYearPlaceholder : s === "quarter" && a.lang.quarterPlaceholder ? a.lang.rangeQuarterPlaceholder : s === "month" && a.lang.monthPlaceholder ? a.lang.rangeMonthPlaceholder : s === "week" && a.lang.weekPlaceholder ? a.lang.rangeWeekPlaceholder : s === "time" && a.timePickerLocale.placeholder ? a.timePickerLocale.rangePlaceholder : a.lang.rangePlaceholder;
}
function transPlacement2DropdownAlign(a, s) {
  const $ = {
    adjustX: 1,
    adjustY: 1
  };
  switch (s) {
    case "bottomLeft":
      return {
        points: ["tl", "bl"],
        offset: [0, 4],
        overflow: $
      };
    case "bottomRight":
      return {
        points: ["tr", "br"],
        offset: [0, 4],
        overflow: $
      };
    case "topLeft":
      return {
        points: ["bl", "tl"],
        offset: [0, -4],
        overflow: $
      };
    case "topRight":
      return {
        points: ["br", "tr"],
        offset: [0, -4],
        overflow: $
      };
    default:
      return {
        points: a === "rtl" ? ["tr", "br"] : ["tl", "bl"],
        offset: [0, 4],
        overflow: $
      };
  }
}
function toArray$4(a) {
  return a ? Array.isArray(a) ? a : [a] : [];
}
function getTimeProps(a) {
  const {
    format: s,
    picker: $,
    showHour: _,
    showMinute: _e,
    showSecond: tt,
    use12Hours: nt
  } = a, at = toArray$4(s)[0], ot = Object.assign({}, a);
  return s && Array.isArray(s) && (ot.format = at), at && typeof at == "string" && (!at.includes("s") && tt === void 0 && (ot.showSecond = !1), !at.includes("m") && _e === void 0 && (ot.showMinute = !1), !at.includes("H") && !at.includes("h") && !at.includes("K") && !at.includes("k") && _ === void 0 && (ot.showHour = !1), (at.includes("a") || at.includes("A")) && nt === void 0 && (ot.use12Hours = !0)), $ === "time" ? ot : (typeof at == "function" && delete ot.format, {
    showTime: ot
  });
}
function mergeAllowClear(a, s, $) {
  if (a === !1)
    return !1;
  const _ = {
    clearIcon: s ?? $
  };
  return typeof a == "object" ? Object.assign(Object.assign({}, _), a) : _;
}
function PickerButton(a) {
  return /* @__PURE__ */ reactExports.createElement(Button$2, Object.assign({
    size: "small",
    type: "primary"
  }, a));
}
const Components = {
  button: PickerButton
}, Components$1 = Components;
var __rest$x = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function generateRangePicker(a) {
  return /* @__PURE__ */ reactExports.forwardRef(($, _) => {
    var _e;
    const {
      prefixCls: tt,
      getPopupContainer: nt,
      className: at,
      style: ot,
      placement: rt,
      size: st,
      disabled: lt,
      bordered: et = !0,
      placeholder: it,
      popupClassName: ut,
      dropdownClassName: ft,
      status: ht,
      clearIcon: dt,
      allowClear: gt,
      rootClassName: pt
    } = $, mt = __rest$x($, ["prefixCls", "getPopupContainer", "className", "style", "placement", "size", "disabled", "bordered", "placeholder", "popupClassName", "dropdownClassName", "status", "clearIcon", "allowClear", "rootClassName"]), ct = reactExports.useRef(null), {
      getPrefixCls: vt,
      direction: At,
      getPopupContainer: xt,
      rangePicker: bt
    } = reactExports.useContext(ConfigContext$1), Et = vt("picker", tt), {
      compactSize: St,
      compactItemClassnames: Bt
    } = useCompactItemContext(Et, At), {
      format: Ot,
      showTime: Pt,
      picker: wt
    } = $, Ct = vt(), It = useCSSVarCls$1(Et), [yt, Rt, kt] = useStyle$m(Et, It), jt = Object.assign(Object.assign({}, Pt ? getTimeProps(Object.assign({
      format: Ot,
      picker: wt
    }, Pt)) : {}), wt === "time" ? getTimeProps(Object.assign(Object.assign({
      format: Ot
    }, $), {
      picker: wt
    })) : {}), Ht = useSize$1((Qt) => {
      var qt;
      return (qt = st ?? St) !== null && qt !== void 0 ? qt : Qt;
    }), Ft = reactExports.useContext(DisabledContext$1), _t = lt ?? Ft, Nt = reactExports.useContext(FormItemInputContext), {
      hasFeedback: Mt,
      status: Lt,
      feedbackIcon: $t
    } = Nt, Tt = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, wt === "time" ? /* @__PURE__ */ reactExports.createElement(ClockCircleOutlined$1, null) : /* @__PURE__ */ reactExports.createElement(CalendarOutlined$1, null), Mt && $t);
    reactExports.useImperativeHandle(_, () => ({
      focus: () => {
        var Qt;
        return (Qt = ct.current) === null || Qt === void 0 ? void 0 : Qt.focus();
      },
      blur: () => {
        var Qt;
        return (Qt = ct.current) === null || Qt === void 0 ? void 0 : Qt.blur();
      }
    }));
    const [Dt] = useLocale$1("Calendar", enUS$1), Ut = Object.assign(Object.assign({}, Dt), $.locale), [Vt] = useZIndex("DatePicker", (_e = $.popupStyle) === null || _e === void 0 ? void 0 : _e.zIndex);
    return yt(/* @__PURE__ */ reactExports.createElement(RangePicker$2, Object.assign({
      separator: /* @__PURE__ */ reactExports.createElement("span", {
        "aria-label": "to",
        className: `${Et}-separator`
      }, /* @__PURE__ */ reactExports.createElement(SwapRightOutlined$1, null)),
      disabled: _t,
      ref: ct,
      dropdownAlign: transPlacement2DropdownAlign(At, rt),
      placeholder: getRangePlaceholder(Ut, wt, it),
      suffixIcon: Tt,
      prevIcon: /* @__PURE__ */ reactExports.createElement("span", {
        className: `${Et}-prev-icon`
      }),
      nextIcon: /* @__PURE__ */ reactExports.createElement("span", {
        className: `${Et}-next-icon`
      }),
      superPrevIcon: /* @__PURE__ */ reactExports.createElement("span", {
        className: `${Et}-super-prev-icon`
      }),
      superNextIcon: /* @__PURE__ */ reactExports.createElement("span", {
        className: `${Et}-super-next-icon`
      }),
      transitionName: `${Ct}-slide-up`
    }, mt, jt, {
      className: classnames({
        [`${Et}-${Ht}`]: Ht,
        [`${Et}-borderless`]: !et
      }, getStatusClassNames(Et, getMergedStatus(Lt, ht), Mt), Rt, Bt, at, bt == null ? void 0 : bt.className, kt, It, pt),
      style: Object.assign(Object.assign({}, bt == null ? void 0 : bt.style), ot),
      locale: Ut.lang,
      prefixCls: Et,
      getPopupContainer: nt || xt,
      generateConfig: a,
      components: Components$1,
      direction: At,
      dropdownClassName: classnames(Rt, ut || ft, kt, It, pt),
      popupStyle: Object.assign(Object.assign({}, $.popupStyle), {
        zIndex: Vt
      }),
      allowClear: mergeAllowClear(gt, dt, /* @__PURE__ */ reactExports.createElement(CloseCircleFilled$1, null))
    })));
  });
}
var __rest$w = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function generatePicker$1(a) {
  function s(ot, rt) {
    const st = rt === "TimePicker" ? "timePicker" : "datePicker", lt = /* @__PURE__ */ reactExports.forwardRef((et, it) => {
      var ut;
      const {
        prefixCls: ft,
        getPopupContainer: ht,
        style: dt,
        className: gt,
        rootClassName: pt,
        size: mt,
        bordered: ct = !0,
        placement: vt,
        placeholder: At,
        popupClassName: xt,
        dropdownClassName: bt,
        disabled: Et,
        status: St,
        clearIcon: Bt,
        allowClear: Ot
      } = et, Pt = __rest$w(et, ["prefixCls", "getPopupContainer", "style", "className", "rootClassName", "size", "bordered", "placement", "placeholder", "popupClassName", "dropdownClassName", "disabled", "status", "clearIcon", "allowClear"]), {
        getPrefixCls: wt,
        direction: Ct,
        getPopupContainer: It,
        // Consume different styles according to different names
        [st]: yt
      } = reactExports.useContext(ConfigContext$1), Rt = wt("picker", ft), {
        compactSize: kt,
        compactItemClassnames: jt
      } = useCompactItemContext(Rt, Ct), Ht = reactExports.useRef(null), {
        format: Ft,
        showTime: _t
      } = et, Nt = useCSSVarCls$1(Rt), [Mt, Lt, $t] = useStyle$m(Rt, Nt);
      reactExports.useImperativeHandle(it, () => ({
        focus: () => {
          var sr;
          return (sr = Ht.current) === null || sr === void 0 ? void 0 : sr.focus();
        },
        blur: () => {
          var sr;
          return (sr = Ht.current) === null || sr === void 0 ? void 0 : sr.blur();
        }
      }));
      const Tt = {
        showToday: !0
      };
      let Dt = {};
      ot && (Dt.picker = ot);
      const Ut = ot || et.picker;
      Dt = Object.assign(Object.assign(Object.assign({}, Dt), _t ? getTimeProps(Object.assign({
        format: Ft,
        picker: Ut
      }, _t)) : {}), Ut === "time" ? getTimeProps(Object.assign(Object.assign({
        format: Ft
      }, et), {
        picker: Ut
      })) : {});
      const Vt = wt(), Qt = useSize$1((sr) => {
        var cr;
        return (cr = mt ?? kt) !== null && cr !== void 0 ? cr : sr;
      }), qt = reactExports.useContext(DisabledContext$1), Zt = Et ?? qt, ar = reactExports.useContext(FormItemInputContext), {
        hasFeedback: Jt,
        status: rr,
        feedbackIcon: Yt
      } = ar, Kt = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, Ut === "time" ? /* @__PURE__ */ reactExports.createElement(ClockCircleOutlined$1, null) : /* @__PURE__ */ reactExports.createElement(CalendarOutlined$1, null), Jt && Yt), [nr] = useLocale$1("DatePicker", enUS$1), tr = Object.assign(Object.assign({}, nr), et.locale), [ir] = useZIndex("DatePicker", (ut = et.popupStyle) === null || ut === void 0 ? void 0 : ut.zIndex);
      return Mt(/* @__PURE__ */ reactExports.createElement(Picker, Object.assign({
        ref: Ht,
        placeholder: getPlaceholder(tr, Ut, At),
        suffixIcon: Kt,
        dropdownAlign: transPlacement2DropdownAlign(Ct, vt),
        prevIcon: /* @__PURE__ */ reactExports.createElement("span", {
          className: `${Rt}-prev-icon`
        }),
        nextIcon: /* @__PURE__ */ reactExports.createElement("span", {
          className: `${Rt}-next-icon`
        }),
        superPrevIcon: /* @__PURE__ */ reactExports.createElement("span", {
          className: `${Rt}-super-prev-icon`
        }),
        superNextIcon: /* @__PURE__ */ reactExports.createElement("span", {
          className: `${Rt}-super-next-icon`
        }),
        transitionName: `${Vt}-slide-up`
      }, Tt, Pt, Dt, {
        locale: tr.lang,
        className: classnames({
          [`${Rt}-${Qt}`]: Qt,
          [`${Rt}-borderless`]: !ct
        }, getStatusClassNames(Rt, getMergedStatus(rr, St), Jt), Lt, jt, yt == null ? void 0 : yt.className, gt, $t, Nt, pt),
        style: Object.assign(Object.assign({}, yt == null ? void 0 : yt.style), dt),
        prefixCls: Rt,
        getPopupContainer: ht || It,
        generateConfig: a,
        components: Components$1,
        direction: Ct,
        disabled: Zt,
        dropdownClassName: classnames(Lt, $t, Nt, pt, xt || bt),
        popupStyle: Object.assign(Object.assign({}, et.popupStyle), {
          zIndex: ir
        }),
        allowClear: mergeAllowClear(Ot, Bt, /* @__PURE__ */ reactExports.createElement(CloseCircleFilled$1, null))
      })));
    });
    return rt && (lt.displayName = rt), lt;
  }
  const $ = s(), _ = s("week", "WeekPicker"), _e = s("month", "MonthPicker"), tt = s("year", "YearPicker"), nt = s("time", "TimePicker"), at = s("quarter", "QuarterPicker");
  return {
    DatePicker: $,
    WeekPicker: _,
    MonthPicker: _e,
    YearPicker: tt,
    TimePicker: nt,
    QuarterPicker: at
  };
}
function generatePicker(a) {
  const {
    DatePicker: s,
    WeekPicker: $,
    MonthPicker: _,
    YearPicker: _e,
    TimePicker: tt,
    QuarterPicker: nt
  } = generatePicker$1(a), at = generateRangePicker(a), ot = s;
  return ot.WeekPicker = $, ot.MonthPicker = _, ot.YearPicker = _e, ot.RangePicker = at, ot.TimePicker = tt, ot.QuarterPicker = nt, ot;
}
var DrawerContext = /* @__PURE__ */ reactExports.createContext(null), RefContext = /* @__PURE__ */ reactExports.createContext({}), DrawerPanel$2 = function a(s) {
  var $ = s.prefixCls, _ = s.className, _e = s.style, tt = s.children, nt = s.containerRef, at = s.id, ot = s.onMouseEnter, rt = s.onMouseOver, st = s.onMouseLeave, lt = s.onClick, et = s.onKeyDown, it = s.onKeyUp, ut = {
    onMouseEnter: ot,
    onMouseOver: rt,
    onMouseLeave: st,
    onClick: lt,
    onKeyDown: et,
    onKeyUp: it
  }, ft = reactExports.useContext(RefContext), ht = ft.panel, dt = useComposeRef(ht, nt);
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    id: at,
    className: classnames("".concat($, "-content"), _),
    style: _objectSpread2$a({}, _e),
    "aria-modal": "true",
    role: "dialog",
    ref: dt
  }, ut), tt));
};
function parseWidthHeight(a) {
  return typeof a == "string" && String(Number(a)) === a ? (warningOnce(!1, "Invalid value type of `width` or `height` which should be number type instead."), Number(a)) : a;
}
var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none",
  position: "absolute"
};
function DrawerPopup(a, s) {
  var $, _, _e, tt, nt = a.prefixCls, at = a.open, ot = a.placement, rt = a.inline, st = a.push, lt = a.forceRender, et = a.autoFocus, it = a.keyboard, ut = a.classNames, ft = a.rootClassName, ht = a.rootStyle, dt = a.zIndex, gt = a.className, pt = a.id, mt = a.style, ct = a.motion, vt = a.width, At = a.height, xt = a.children, bt = a.contentWrapperStyle, Et = a.mask, St = a.maskClosable, Bt = a.maskMotion, Ot = a.maskClassName, Pt = a.maskStyle, wt = a.afterOpenChange, Ct = a.onClose, It = a.onMouseEnter, yt = a.onMouseOver, Rt = a.onMouseLeave, kt = a.onClick, jt = a.onKeyDown, Ht = a.onKeyUp, Ft = a.styles, _t = reactExports.useRef(), Nt = reactExports.useRef(), Mt = reactExports.useRef();
  reactExports.useImperativeHandle(s, function() {
    return _t.current;
  });
  var Lt = function(ir) {
    var sr = ir.keyCode, cr = ir.shiftKey;
    switch (sr) {
      case KeyCode.TAB: {
        if (sr === KeyCode.TAB) {
          if (!cr && document.activeElement === Mt.current) {
            var or;
            (or = Nt.current) === null || or === void 0 || or.focus({
              preventScroll: !0
            });
          } else if (cr && document.activeElement === Nt.current) {
            var Xt;
            (Xt = Mt.current) === null || Xt === void 0 || Xt.focus({
              preventScroll: !0
            });
          }
        }
        break;
      }
      case KeyCode.ESC: {
        Ct && it && (ir.stopPropagation(), Ct(ir));
        break;
      }
    }
  };
  reactExports.useEffect(function() {
    if (at && et) {
      var tr;
      (tr = _t.current) === null || tr === void 0 || tr.focus({
        preventScroll: !0
      });
    }
  }, [at]);
  var $t = reactExports.useState(!1), Tt = _slicedToArray$e($t, 2), Dt = Tt[0], Ut = Tt[1], Vt = reactExports.useContext(DrawerContext), Qt;
  st === !1 ? Qt = {
    distance: 0
  } : st === !0 ? Qt = {} : Qt = st || {};
  var qt = ($ = (_ = (_e = Qt) === null || _e === void 0 ? void 0 : _e.distance) !== null && _ !== void 0 ? _ : Vt == null ? void 0 : Vt.pushDistance) !== null && $ !== void 0 ? $ : 180, Zt = reactExports.useMemo(function() {
    return {
      pushDistance: qt,
      push: function() {
        Ut(!0);
      },
      pull: function() {
        Ut(!1);
      }
    };
  }, [qt]);
  reactExports.useEffect(function() {
    if (at) {
      var tr;
      Vt == null || (tr = Vt.push) === null || tr === void 0 || tr.call(Vt);
    } else {
      var ir;
      Vt == null || (ir = Vt.pull) === null || ir === void 0 || ir.call(Vt);
    }
  }, [at]), reactExports.useEffect(function() {
    return function() {
      var tr;
      Vt == null || (tr = Vt.pull) === null || tr === void 0 || tr.call(Vt);
    };
  }, []);
  var ar = Et && /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$2({
    key: "mask"
  }, Bt, {
    visible: at
  }), function(tr, ir) {
    var sr = tr.className, cr = tr.style;
    return /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames("".concat(nt, "-mask"), sr, ut == null ? void 0 : ut.mask, Ot),
      style: _objectSpread2$a(_objectSpread2$a(_objectSpread2$a({}, cr), Pt), Ft == null ? void 0 : Ft.mask),
      onClick: St && at ? Ct : void 0,
      ref: ir
    });
  }), Jt = typeof ct == "function" ? ct(ot) : ct, rr = {};
  if (Dt && qt)
    switch (ot) {
      case "top":
        rr.transform = "translateY(".concat(qt, "px)");
        break;
      case "bottom":
        rr.transform = "translateY(".concat(-qt, "px)");
        break;
      case "left":
        rr.transform = "translateX(".concat(qt, "px)");
        break;
      default:
        rr.transform = "translateX(".concat(-qt, "px)");
        break;
    }
  ot === "left" || ot === "right" ? rr.width = parseWidthHeight(vt) : rr.height = parseWidthHeight(At);
  var Yt = {
    onMouseEnter: It,
    onMouseOver: yt,
    onMouseLeave: Rt,
    onClick: kt,
    onKeyDown: jt,
    onKeyUp: Ht
  }, Kt = /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$2({
    key: "panel"
  }, Jt, {
    visible: at,
    forceRender: lt,
    onVisibleChanged: function(ir) {
      wt == null || wt(ir);
    },
    removeOnLeave: !1,
    leavedClassName: "".concat(nt, "-content-wrapper-hidden")
  }), function(tr, ir) {
    var sr = tr.className, cr = tr.style;
    return /* @__PURE__ */ reactExports.createElement("div", _extends$2({
      className: classnames("".concat(nt, "-content-wrapper"), ut == null ? void 0 : ut.wrapper, sr),
      style: _objectSpread2$a(_objectSpread2$a(_objectSpread2$a(_objectSpread2$a({}, rr), cr), bt), Ft == null ? void 0 : Ft.wrapper)
    }, pickAttrs(a, {
      data: !0
    })), /* @__PURE__ */ reactExports.createElement(DrawerPanel$2, _extends$2({
      id: pt,
      containerRef: ir,
      prefixCls: nt,
      className: classnames(gt, ut == null ? void 0 : ut.content),
      style: _objectSpread2$a(_objectSpread2$a({}, mt), Ft == null ? void 0 : Ft.content)
    }, Yt), xt));
  }), nr = _objectSpread2$a({}, ht);
  return dt && (nr.zIndex = dt), /* @__PURE__ */ reactExports.createElement(DrawerContext.Provider, {
    value: Zt
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(nt, "".concat(nt, "-").concat(ot), ft, (tt = {}, _defineProperty$c(tt, "".concat(nt, "-open"), at), _defineProperty$c(tt, "".concat(nt, "-inline"), rt), tt)),
    style: nr,
    tabIndex: -1,
    ref: _t,
    onKeyDown: Lt
  }, ar, /* @__PURE__ */ reactExports.createElement("div", {
    tabIndex: 0,
    ref: Nt,
    style: sentinelStyle,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), Kt, /* @__PURE__ */ reactExports.createElement("div", {
    tabIndex: 0,
    ref: Mt,
    style: sentinelStyle,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var RefDrawerPopup = /* @__PURE__ */ reactExports.forwardRef(DrawerPopup), Drawer$1 = function a(s) {
  var $ = s.open, _ = $ === void 0 ? !1 : $, _e = s.prefixCls, tt = _e === void 0 ? "rc-drawer" : _e, nt = s.placement, at = nt === void 0 ? "right" : nt, ot = s.autoFocus, rt = ot === void 0 ? !0 : ot, st = s.keyboard, lt = st === void 0 ? !0 : st, et = s.width, it = et === void 0 ? 378 : et, ut = s.mask, ft = ut === void 0 ? !0 : ut, ht = s.maskClosable, dt = ht === void 0 ? !0 : ht, gt = s.getContainer, pt = s.forceRender, mt = s.afterOpenChange, ct = s.destroyOnClose, vt = s.onMouseEnter, At = s.onMouseOver, xt = s.onMouseLeave, bt = s.onClick, Et = s.onKeyDown, St = s.onKeyUp, Bt = s.panelRef, Ot = reactExports.useState(!1), Pt = _slicedToArray$e(Ot, 2), wt = Pt[0], Ct = Pt[1], It = reactExports.useState(!1), yt = _slicedToArray$e(It, 2), Rt = yt[0], kt = yt[1];
  useLayoutEffect$1(function() {
    kt(!0);
  }, []);
  var jt = Rt ? _ : !1, Ht = reactExports.useRef(), Ft = reactExports.useRef();
  useLayoutEffect$1(function() {
    jt && (Ft.current = document.activeElement);
  }, [jt]);
  var _t = function(Tt) {
    var Dt;
    if (Ct(Tt), mt == null || mt(Tt), !Tt && Ft.current && !((Dt = Ht.current) !== null && Dt !== void 0 && Dt.contains(Ft.current))) {
      var Ut;
      (Ut = Ft.current) === null || Ut === void 0 || Ut.focus({
        preventScroll: !0
      });
    }
  }, Nt = reactExports.useMemo(function() {
    return {
      panel: Bt
    };
  }, [Bt]);
  if (!pt && !wt && !jt && ct)
    return null;
  var Mt = {
    onMouseEnter: vt,
    onMouseOver: At,
    onMouseLeave: xt,
    onClick: bt,
    onKeyDown: Et,
    onKeyUp: St
  }, Lt = _objectSpread2$a(_objectSpread2$a({}, s), {}, {
    open: jt,
    prefixCls: tt,
    placement: at,
    autoFocus: rt,
    keyboard: lt,
    width: it,
    mask: ft,
    maskClosable: dt,
    inline: gt === !1,
    afterOpenChange: _t,
    ref: Ht
  }, Mt);
  return /* @__PURE__ */ reactExports.createElement(RefContext.Provider, {
    value: Nt
  }, /* @__PURE__ */ reactExports.createElement(Portal, {
    open: jt || pt || wt,
    autoDestroy: !1,
    getContainer: gt,
    autoLock: ft && (jt || wt)
  }, /* @__PURE__ */ reactExports.createElement(RefDrawerPopup, Lt)));
};
const DrawerPanel = (a) => {
  var s, $;
  const {
    prefixCls: _,
    title: _e,
    footer: tt,
    extra: nt,
    closeIcon: at,
    closable: ot,
    onClose: rt,
    headerStyle: st,
    drawerStyle: lt,
    bodyStyle: et,
    footerStyle: it,
    children: ut,
    classNames: ft,
    styles: ht
  } = a, {
    drawer: dt
  } = reactExports.useContext(ConfigContext$1), gt = reactExports.useCallback((At) => /* @__PURE__ */ reactExports.createElement("button", {
    type: "button",
    onClick: rt,
    "aria-label": "Close",
    className: `${_}-close`
  }, At), [rt]), [pt, mt] = useClosable(ot, at, gt, void 0, !0), ct = reactExports.useMemo(() => {
    var At, xt;
    return !_e && !pt ? null : /* @__PURE__ */ reactExports.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, (At = dt == null ? void 0 : dt.styles) === null || At === void 0 ? void 0 : At.header), st), ht == null ? void 0 : ht.header),
      className: classnames(`${_}-header`, {
        [`${_}-header-close-only`]: pt && !_e && !nt
      }, (xt = dt == null ? void 0 : dt.classNames) === null || xt === void 0 ? void 0 : xt.header, ft == null ? void 0 : ft.header)
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: `${_}-header-title`
    }, mt, _e && /* @__PURE__ */ reactExports.createElement("div", {
      className: `${_}-title`
    }, _e)), nt && /* @__PURE__ */ reactExports.createElement("div", {
      className: `${_}-extra`
    }, nt));
  }, [pt, mt, nt, st, _, _e]), vt = reactExports.useMemo(() => {
    var At, xt;
    if (!tt)
      return null;
    const bt = `${_}-footer`;
    return /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames(bt, (At = dt == null ? void 0 : dt.classNames) === null || At === void 0 ? void 0 : At.footer, ft == null ? void 0 : ft.footer),
      style: Object.assign(Object.assign(Object.assign({}, (xt = dt == null ? void 0 : dt.styles) === null || xt === void 0 ? void 0 : xt.footer), it), ht == null ? void 0 : ht.footer)
    }, tt);
  }, [tt, it, _]);
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: `${_}-wrapper-body`,
    style: lt
  }, ct, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${_}-body`, ft == null ? void 0 : ft.body, (s = dt == null ? void 0 : dt.classNames) === null || s === void 0 ? void 0 : s.body),
    style: Object.assign(Object.assign(Object.assign({}, ($ = dt == null ? void 0 : dt.styles) === null || $ === void 0 ? void 0 : $.body), et), ht == null ? void 0 : ht.body)
  }, ut), vt);
}, DrawerPanel$1 = DrawerPanel, genMotionStyle$2 = (a) => {
  const {
    componentCls: s,
    motionDurationSlow: $
  } = a, _ = {
    "&-enter, &-appear, &-leave": {
      "&-start": {
        transition: "none"
      },
      "&-active": {
        transition: `all ${$}`
      }
    }
  };
  return {
    [s]: {
      // ======================== Mask ========================
      [`${s}-mask-motion`]: {
        "&-enter, &-appear, &-leave": {
          "&-active": {
            transition: `all ${$}`
          }
        },
        "&-enter, &-appear": {
          opacity: 0,
          "&-active": {
            opacity: 1
          }
        },
        "&-leave": {
          opacity: 1,
          "&-active": {
            opacity: 0
          }
        }
      },
      // ======================= Panel ========================
      [`${s}-panel-motion`]: {
        // Left
        "&-left": [_, {
          "&-enter, &-appear": {
            "&-start": {
              transform: "translateX(-100%) !important"
            },
            "&-active": {
              transform: "translateX(0)"
            }
          },
          "&-leave": {
            transform: "translateX(0)",
            "&-active": {
              transform: "translateX(-100%)"
            }
          }
        }],
        // Right
        "&-right": [_, {
          "&-enter, &-appear": {
            "&-start": {
              transform: "translateX(100%) !important"
            },
            "&-active": {
              transform: "translateX(0)"
            }
          },
          "&-leave": {
            transform: "translateX(0)",
            "&-active": {
              transform: "translateX(100%)"
            }
          }
        }],
        // Top
        "&-top": [_, {
          "&-enter, &-appear": {
            "&-start": {
              transform: "translateY(-100%) !important"
            },
            "&-active": {
              transform: "translateY(0)"
            }
          },
          "&-leave": {
            transform: "translateY(0)",
            "&-active": {
              transform: "translateY(-100%)"
            }
          }
        }],
        // Bottom
        "&-bottom": [_, {
          "&-enter, &-appear": {
            "&-start": {
              transform: "translateY(100%) !important"
            },
            "&-active": {
              transform: "translateY(0)"
            }
          },
          "&-leave": {
            transform: "translateY(0)",
            "&-active": {
              transform: "translateY(100%)"
            }
          }
        }]
      }
    }
  };
}, genMotionStyle$3 = genMotionStyle$2, genDrawerStyle = (a) => {
  const {
    componentCls: s,
    zIndexPopup: $,
    colorBgMask: _,
    colorBgElevated: _e,
    motionDurationSlow: tt,
    motionDurationMid: nt,
    padding: at,
    paddingLG: ot,
    fontSizeLG: rt,
    lineHeightLG: st,
    lineWidth: lt,
    lineType: et,
    colorSplit: it,
    marginSM: ut,
    colorIcon: ft,
    colorIconHover: ht,
    colorText: dt,
    fontWeightStrong: gt,
    footerPaddingBlock: pt,
    footerPaddingInline: mt
  } = a, ct = `${s}-content-wrapper`;
  return {
    [s]: {
      position: "fixed",
      inset: 0,
      zIndex: $,
      pointerEvents: "none",
      "&-pure": {
        position: "relative",
        background: _e,
        [`&${s}-left`]: {
          boxShadow: a.boxShadowDrawerLeft
        },
        [`&${s}-right`]: {
          boxShadow: a.boxShadowDrawerRight
        },
        [`&${s}-top`]: {
          boxShadow: a.boxShadowDrawerUp
        },
        [`&${s}-bottom`]: {
          boxShadow: a.boxShadowDrawerDown
        }
      },
      "&-inline": {
        position: "absolute"
      },
      // ====================== Mask ======================
      [`${s}-mask`]: {
        position: "absolute",
        inset: 0,
        zIndex: $,
        background: _,
        pointerEvents: "auto"
      },
      // ==================== Content =====================
      [ct]: {
        position: "absolute",
        zIndex: $,
        maxWidth: "100vw",
        transition: `all ${tt}`,
        "&-hidden": {
          display: "none"
        }
      },
      // Placement
      [`&-left > ${ct}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: !0,
          value: 0
        },
        boxShadow: a.boxShadowDrawerLeft
      },
      [`&-right > ${ct}`]: {
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: 0,
        boxShadow: a.boxShadowDrawerRight
      },
      [`&-top > ${ct}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: a.boxShadowDrawerUp
      },
      [`&-bottom > ${ct}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: a.boxShadowDrawerDown
      },
      [`${s}-content`]: {
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: _e,
        pointerEvents: "auto"
      },
      // ===================== Panel ======================
      [`${s}-wrapper-body`]: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%"
      },
      // Header
      [`${s}-header`]: {
        display: "flex",
        flex: 0,
        alignItems: "center",
        padding: `${unit$1(at)} ${unit$1(ot)}`,
        fontSize: rt,
        lineHeight: st,
        borderBottom: `${unit$1(lt)} ${et} ${it}`,
        "&-title": {
          display: "flex",
          flex: 1,
          alignItems: "center",
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${s}-extra`]: {
        flex: "none"
      },
      [`${s}-close`]: {
        display: "inline-block",
        marginInlineEnd: ut,
        color: ft,
        fontWeight: gt,
        fontSize: rt,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        textDecoration: "none",
        background: "transparent",
        border: 0,
        outline: 0,
        cursor: "pointer",
        transition: `color ${nt}`,
        textRendering: "auto",
        "&:focus, &:hover": {
          color: ht,
          textDecoration: "none"
        }
      },
      [`${s}-title`]: {
        flex: 1,
        margin: 0,
        color: dt,
        fontWeight: a.fontWeightStrong,
        fontSize: rt,
        lineHeight: st
      },
      // Body
      [`${s}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: ot,
        overflow: "auto"
      },
      // Footer
      [`${s}-footer`]: {
        flexShrink: 0,
        padding: `${unit$1(pt)} ${unit$1(mt)}`,
        borderTop: `${unit$1(lt)} ${et} ${it}`
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
}, prepareComponentToken$e = (a) => ({
  zIndexPopup: a.zIndexPopupBase,
  footerPaddingBlock: a.paddingXS,
  footerPaddingInline: a.padding
}), useStyle$e = genStyleHooks("Drawer", (a) => {
  const s = merge(a, {});
  return [genDrawerStyle(s), genMotionStyle$3(s)];
}, prepareComponentToken$e);
var __rest$v = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const defaultPushState = {
  distance: 180
}, Drawer = (a) => {
  var s, $, _, _e, tt, nt, at, ot;
  const {
    rootClassName: rt,
    width: st,
    height: lt,
    size: et = "default",
    mask: it = !0,
    push: ut = defaultPushState,
    open: ft,
    afterOpenChange: ht,
    onClose: dt,
    prefixCls: gt,
    getContainer: pt,
    style: mt,
    className: ct,
    // Deprecated
    visible: vt,
    afterVisibleChange: At
  } = a, xt = __rest$v(a, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "style", "className", "visible", "afterVisibleChange"]), {
    getPopupContainer: bt,
    getPrefixCls: Et,
    direction: St,
    drawer: Bt
  } = reactExports.useContext(ConfigContext$1), Ot = Et("drawer", gt), [Pt, wt, Ct] = useStyle$e(Ot), It = (
    // 有可能为 false，所以不能直接判断
    pt === void 0 && bt ? () => bt(document.body) : pt
  ), yt = classnames({
    "no-mask": !it,
    [`${Ot}-rtl`]: St === "rtl"
  }, rt, wt, Ct), Rt = reactExports.useMemo(() => st ?? (et === "large" ? 736 : 378), [st, et]), kt = reactExports.useMemo(() => lt ?? (et === "large" ? 736 : 378), [lt, et]), jt = {
    motionName: getTransitionName$1(Ot, "mask-motion"),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }, Ht = (Mt) => ({
    motionName: getTransitionName$1(Ot, `panel-motion-${Mt}`),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }), Ft = usePanelRef(), [_t, Nt] = useZIndex("Drawer", xt.zIndex);
  return Pt(/* @__PURE__ */ reactExports.createElement(NoCompactStyle, null, /* @__PURE__ */ reactExports.createElement(NoFormStyle, {
    status: !0,
    override: !0
  }, /* @__PURE__ */ reactExports.createElement(zIndexContext$1.Provider, {
    value: Nt
  }, /* @__PURE__ */ reactExports.createElement(Drawer$1, Object.assign({
    prefixCls: Ot,
    onClose: dt,
    maskMotion: jt,
    motion: Ht
  }, xt, {
    classNames: {
      mask: classnames((s = xt.classNames) === null || s === void 0 ? void 0 : s.mask, ($ = Bt == null ? void 0 : Bt.classNames) === null || $ === void 0 ? void 0 : $.mask),
      content: classnames((_ = xt.classNames) === null || _ === void 0 ? void 0 : _.content, (_e = Bt == null ? void 0 : Bt.classNames) === null || _e === void 0 ? void 0 : _e.content)
    },
    styles: {
      mask: Object.assign(Object.assign({}, (tt = xt.styles) === null || tt === void 0 ? void 0 : tt.mask), (nt = Bt == null ? void 0 : Bt.styles) === null || nt === void 0 ? void 0 : nt.mask),
      content: Object.assign(Object.assign({}, (at = xt.styles) === null || at === void 0 ? void 0 : at.content), (ot = Bt == null ? void 0 : Bt.styles) === null || ot === void 0 ? void 0 : ot.content)
    },
    open: ft ?? vt,
    mask: it,
    push: ut,
    width: Rt,
    height: kt,
    style: Object.assign(Object.assign({}, Bt == null ? void 0 : Bt.style), mt),
    className: classnames(Bt == null ? void 0 : Bt.className, ct),
    rootClassName: yt,
    getContainer: It,
    afterOpenChange: ht ?? At,
    panelRef: Ft,
    zIndex: _t
  }), /* @__PURE__ */ reactExports.createElement(DrawerPanel$1, Object.assign({
    prefixCls: Ot
  }, xt, {
    onClose: dt
  })))))));
}, PurePanel$3 = (a) => {
  const {
    prefixCls: s,
    style: $,
    className: _,
    placement: _e = "right"
  } = a, tt = __rest$v(a, ["prefixCls", "style", "className", "placement"]), {
    getPrefixCls: nt
  } = reactExports.useContext(ConfigContext$1), at = nt("drawer", s), [ot, rt, st] = useStyle$e(at), lt = classnames(at, `${at}-pure`, `${at}-${_e}`, rt, st, _);
  return ot(/* @__PURE__ */ reactExports.createElement("div", {
    className: lt,
    style: $
  }, /* @__PURE__ */ reactExports.createElement(DrawerPanel$1, Object.assign({
    prefixCls: at
  }, tt))));
};
Drawer._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$3;
const _Drawer = Drawer;
function isPresetSize(a) {
  return ["small", "middle", "large"].includes(a);
}
function isValidGapNumber(a) {
  return a ? typeof a == "number" && !Number.isNaN(a) : !1;
}
const SpaceContext = /* @__PURE__ */ React$a.createContext({
  latestIndex: 0
}), SpaceContextProvider = SpaceContext.Provider, Item$3 = (a) => {
  let {
    className: s,
    index: $,
    children: _,
    split: _e,
    style: tt
  } = a;
  const {
    latestIndex: nt
  } = reactExports.useContext(SpaceContext);
  return _ == null ? null : /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("div", {
    className: s,
    style: tt
  }, _), $ < nt && _e && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${s}-split`
  }, _e));
}, Item$4 = Item$3;
var __rest$u = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Space = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var $, _;
  const {
    getPrefixCls: _e,
    space: tt,
    direction: nt
  } = reactExports.useContext(ConfigContext$1), {
    size: at = (tt == null ? void 0 : tt.size) || "small",
    align: ot,
    className: rt,
    rootClassName: st,
    children: lt,
    direction: et = "horizontal",
    prefixCls: it,
    split: ut,
    style: ft,
    wrap: ht = !1,
    classNames: dt,
    styles: gt
  } = a, pt = __rest$u(a, ["size", "align", "className", "rootClassName", "children", "direction", "prefixCls", "split", "style", "wrap", "classNames", "styles"]), [mt, ct] = Array.isArray(at) ? at : [at, at], vt = isPresetSize(ct), At = isPresetSize(mt), xt = isValidGapNumber(ct), bt = isValidGapNumber(mt), Et = toArray$9(lt, {
    keepEmpty: !0
  }), St = ot === void 0 && et === "horizontal" ? "center" : ot, Bt = _e("space", it), [Ot, Pt, wt] = useStyle$v(Bt), Ct = classnames(Bt, tt == null ? void 0 : tt.className, Pt, `${Bt}-${et}`, {
    [`${Bt}-rtl`]: nt === "rtl",
    [`${Bt}-align-${St}`]: St,
    [`${Bt}-gap-row-${ct}`]: vt,
    [`${Bt}-gap-col-${mt}`]: At
  }, rt, st, wt), It = classnames(`${Bt}-item`, ($ = dt == null ? void 0 : dt.item) !== null && $ !== void 0 ? $ : (_ = tt == null ? void 0 : tt.classNames) === null || _ === void 0 ? void 0 : _.item);
  let yt = 0;
  const Rt = Et.map((Ht, Ft) => {
    var _t, Nt;
    Ht != null && (yt = Ft);
    const Mt = Ht && Ht.key || `${It}-${Ft}`;
    return /* @__PURE__ */ reactExports.createElement(Item$4, {
      className: It,
      key: Mt,
      index: Ft,
      split: ut,
      style: (_t = gt == null ? void 0 : gt.item) !== null && _t !== void 0 ? _t : (Nt = tt == null ? void 0 : tt.styles) === null || Nt === void 0 ? void 0 : Nt.item
    }, Ht);
  }), kt = reactExports.useMemo(() => ({
    latestIndex: yt
  }), [yt]);
  if (Et.length === 0)
    return null;
  const jt = {};
  return ht && (jt.flexWrap = "wrap"), !At && bt && (jt.columnGap = mt), !vt && xt && (jt.rowGap = ct), Ot(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    ref: s,
    className: Ct,
    style: Object.assign(Object.assign(Object.assign({}, jt), tt == null ? void 0 : tt.style), ft)
  }, pt), /* @__PURE__ */ reactExports.createElement(SpaceContextProvider, {
    value: kt
  }, Rt)));
}), CompoundedSpace = Space;
CompoundedSpace.Compact = Compact;
const _Space = CompoundedSpace;
var __rest$t = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const DropdownButton = (a) => {
  const {
    getPopupContainer: s,
    getPrefixCls: $,
    direction: _
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: _e,
    type: tt = "default",
    danger: nt,
    disabled: at,
    loading: ot,
    onClick: rt,
    htmlType: st,
    children: lt,
    className: et,
    menu: it,
    arrow: ut,
    autoFocus: ft,
    overlay: ht,
    trigger: dt,
    align: gt,
    open: pt,
    onOpenChange: mt,
    placement: ct,
    getPopupContainer: vt,
    href: At,
    icon: xt = /* @__PURE__ */ reactExports.createElement(EllipsisOutlined$1, null),
    title: bt,
    buttonsRender: Et = ($t) => $t,
    mouseEnterDelay: St,
    mouseLeaveDelay: Bt,
    overlayClassName: Ot,
    overlayStyle: Pt,
    destroyPopupOnHide: wt,
    dropdownRender: Ct
  } = a, It = __rest$t(a, ["prefixCls", "type", "danger", "disabled", "loading", "onClick", "htmlType", "children", "className", "menu", "arrow", "autoFocus", "overlay", "trigger", "align", "open", "onOpenChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyPopupOnHide", "dropdownRender"]), yt = $("dropdown", _e), Rt = `${yt}-button`, kt = {
    menu: it,
    arrow: ut,
    autoFocus: ft,
    align: gt,
    disabled: at,
    trigger: at ? [] : dt,
    onOpenChange: mt,
    getPopupContainer: vt || s,
    mouseEnterDelay: St,
    mouseLeaveDelay: Bt,
    overlayClassName: Ot,
    overlayStyle: Pt,
    destroyPopupOnHide: wt,
    dropdownRender: Ct
  }, {
    compactSize: jt,
    compactItemClassnames: Ht
  } = useCompactItemContext(yt, _), Ft = classnames(Rt, Ht, et);
  "overlay" in a && (kt.overlay = ht), "open" in a && (kt.open = pt), "placement" in a ? kt.placement = ct : kt.placement = _ === "rtl" ? "bottomLeft" : "bottomRight";
  const _t = /* @__PURE__ */ reactExports.createElement(Button$2, {
    type: tt,
    danger: nt,
    disabled: at,
    loading: ot,
    onClick: rt,
    htmlType: st,
    href: At,
    title: bt
  }, lt), Nt = /* @__PURE__ */ reactExports.createElement(Button$2, {
    type: tt,
    danger: nt,
    icon: xt
  }), [Mt, Lt] = Et([_t, Nt]);
  return /* @__PURE__ */ reactExports.createElement(_Space.Compact, Object.assign({
    className: Ft,
    size: jt,
    block: !0
  }, It), Mt, /* @__PURE__ */ reactExports.createElement(InternalDropdown, Object.assign({}, kt), Lt));
};
DropdownButton.__ANT_BUTTON = !0;
const DropdownButton$1 = DropdownButton, Dropdown = InternalDropdown;
Dropdown.Button = DropdownButton$1;
const Dropdown$1 = Dropdown;
function useDebounce(a) {
  const [s, $] = reactExports.useState(a);
  return reactExports.useEffect(() => {
    const _ = setTimeout(() => {
      $(a);
    }, a.length ? 0 : 10);
    return () => {
      clearTimeout(_);
    };
  }, [a]), s;
}
const genFormValidateMotionStyle = (a) => {
  const {
    componentCls: s
  } = a, $ = `${s}-show-help`, _ = `${s}-show-help-item`;
  return {
    [$]: {
      // Explain holder
      transition: `opacity ${a.motionDurationSlow} ${a.motionEaseInOut}`,
      "&-appear, &-enter": {
        opacity: 0,
        "&-active": {
          opacity: 1
        }
      },
      "&-leave": {
        opacity: 1,
        "&-active": {
          opacity: 0
        }
      },
      // Explain
      [_]: {
        overflow: "hidden",
        transition: `height ${a.motionDurationSlow} ${a.motionEaseInOut},
                     opacity ${a.motionDurationSlow} ${a.motionEaseInOut},
                     transform ${a.motionDurationSlow} ${a.motionEaseInOut} !important`,
        [`&${_}-appear, &${_}-enter`]: {
          transform: "translateY(-5px)",
          opacity: 0,
          "&-active": {
            transform: "translateY(0)",
            opacity: 1
          }
        },
        [`&${_}-leave-active`]: {
          transform: "translateY(-5px)"
        }
      }
    }
  };
}, genFormValidateMotionStyle$1 = genFormValidateMotionStyle, resetForm = (a) => ({
  legend: {
    display: "block",
    width: "100%",
    marginBottom: a.marginLG,
    padding: 0,
    color: a.colorTextDescription,
    fontSize: a.fontSizeLG,
    lineHeight: "inherit",
    border: 0,
    borderBottom: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`
  },
  label: {
    fontSize: a.fontSize
  },
  'input[type="search"]': {
    boxSizing: "border-box"
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: "normal"
  },
  'input[type="file"]': {
    display: "block"
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: "block",
    width: "100%"
  },
  // Make multiple select elements height not fixed
  "select[multiple], select[size]": {
    height: "auto"
  },
  // Focus for file, radio, and checkbox
  "input[type='file']:focus,\n  input[type='radio']:focus,\n  input[type='checkbox']:focus": {
    outline: 0,
    boxShadow: `0 0 0 ${unit$1(a.controlOutlineWidth)} ${a.controlOutline}`
  },
  // Adjust output element
  output: {
    display: "block",
    paddingTop: 15,
    color: a.colorText,
    fontSize: a.fontSize,
    lineHeight: a.lineHeight
  }
}), genFormSize = (a, s) => {
  const {
    formItemCls: $
  } = a;
  return {
    [$]: {
      [`${$}-label > label`]: {
        height: s
      },
      [`${$}-control-input`]: {
        minHeight: s
      }
    }
  };
}, genFormStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [a.componentCls]: Object.assign(Object.assign(Object.assign({}, resetComponent(a)), resetForm(a)), {
      [`${s}-text`]: {
        display: "inline-block",
        paddingInlineEnd: a.paddingSM
      },
      // ================================================================
      // =                             Size                             =
      // ================================================================
      "&-small": Object.assign({}, genFormSize(a, a.controlHeightSM)),
      "&-large": Object.assign({}, genFormSize(a, a.controlHeightLG))
    })
  };
}, genFormItemStyle = (a) => {
  const {
    formItemCls: s,
    iconCls: $,
    componentCls: _,
    rootPrefixCls: _e,
    labelRequiredMarkColor: tt,
    labelColor: nt,
    labelFontSize: at,
    labelHeight: ot,
    labelColonMarginInlineStart: rt,
    labelColonMarginInlineEnd: st,
    itemMarginBottom: lt
  } = a;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      marginBottom: lt,
      verticalAlign: "top",
      "&-with-help": {
        transition: "none"
      },
      [`&-hidden,
        &-hidden.${_e}-row`]: {
        // https://github.com/ant-design/ant-design/issues/26141
        display: "none"
      },
      "&-has-warning": {
        [`${s}-split`]: {
          color: a.colorError
        }
      },
      "&-has-error": {
        [`${s}-split`]: {
          color: a.colorWarning
        }
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`${s}-label`]: {
        flexGrow: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "end",
        verticalAlign: "middle",
        "&-left": {
          textAlign: "start"
        },
        "&-wrap": {
          overflow: "unset",
          lineHeight: a.lineHeight,
          whiteSpace: "unset"
        },
        "> label": {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          height: ot,
          color: nt,
          fontSize: at,
          [`> ${$}`]: {
            fontSize: a.fontSize,
            verticalAlign: "top"
          },
          // Required mark
          [`&${s}-required:not(${s}-required-mark-optional)::before`]: {
            display: "inline-block",
            marginInlineEnd: a.marginXXS,
            color: tt,
            fontSize: a.fontSize,
            fontFamily: "SimSun, sans-serif",
            lineHeight: 1,
            content: '"*"',
            [`${_}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${s}-optional`]: {
            display: "inline-block",
            marginInlineStart: a.marginXXS,
            color: a.colorTextDescription,
            [`${_}-hide-required-mark &`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${s}-tooltip`]: {
            color: a.colorTextDescription,
            cursor: "help",
            writingMode: "horizontal-tb",
            marginInlineStart: a.marginXXS
          },
          "&::after": {
            content: '":"',
            position: "relative",
            marginBlock: 0,
            marginInlineStart: rt,
            marginInlineEnd: st
          },
          [`&${s}-no-colon::after`]: {
            content: '"\\a0"'
          }
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`${s}-control`]: {
        "--ant-display": "flex",
        flexDirection: "column",
        flexGrow: 1,
        [`&:first-child:not([class^="'${_e}-col-'"]):not([class*="' ${_e}-col-'"])`]: {
          width: "100%"
        },
        "&-input": {
          position: "relative",
          display: "flex",
          alignItems: "center",
          minHeight: a.controlHeight,
          "&-content": {
            flex: "auto",
            maxWidth: "100%"
          }
        }
      },
      // ==============================================================
      // =                           Explain                          =
      // ==============================================================
      [s]: {
        "&-explain, &-extra": {
          clear: "both",
          color: a.colorTextDescription,
          fontSize: a.fontSize,
          lineHeight: a.lineHeight
        },
        "&-explain-connected": {
          width: "100%"
        },
        "&-extra": {
          minHeight: a.controlHeightSM,
          transition: `color ${a.motionDurationMid} ${a.motionEaseOut}`
          // sync input color transition
        },
        "&-explain": {
          "&-error": {
            color: a.colorError
          },
          "&-warning": {
            color: a.colorWarning
          }
        }
      },
      [`&-with-help ${s}-explain`]: {
        height: "auto",
        opacity: 1
      },
      // ==============================================================
      // =                        Feedback Icon                       =
      // ==============================================================
      [`${s}-feedback-icon`]: {
        fontSize: a.fontSize,
        textAlign: "center",
        visibility: "visible",
        animationName: zoomIn,
        animationDuration: a.motionDurationMid,
        animationTimingFunction: a.motionEaseOutBack,
        pointerEvents: "none",
        "&-success": {
          color: a.colorSuccess
        },
        "&-error": {
          color: a.colorError
        },
        "&-warning": {
          color: a.colorWarning
        },
        "&-validating": {
          color: a.colorPrimary
        }
      }
    })
  };
}, genHorizontalStyle$1 = (a) => {
  const {
    componentCls: s,
    formItemCls: $
  } = a;
  return {
    [`${s}-horizontal`]: {
      [`${$}-label`]: {
        flexGrow: 0
      },
      [`${$}-control`]: {
        flex: "1 1 0",
        // https://github.com/ant-design/ant-design/issues/32777
        // https://github.com/ant-design/ant-design/issues/33773
        minWidth: 0
      },
      // Do not change this to `ant-col-24`! `-24` match all the responsive rules
      // https://github.com/ant-design/ant-design/issues/32980
      // https://github.com/ant-design/ant-design/issues/34903
      // https://github.com/ant-design/ant-design/issues/44538
      [`${$}-label[class$='-24'], ${$}-label[class*='-24 ']`]: {
        [`& + ${$}-control`]: {
          minWidth: "unset"
        }
      }
    }
  };
}, genInlineStyle = (a) => {
  const {
    componentCls: s,
    formItemCls: $
  } = a;
  return {
    [`${s}-inline`]: {
      display: "flex",
      flexWrap: "wrap",
      [$]: {
        flex: "none",
        marginInlineEnd: a.margin,
        marginBottom: 0,
        "&-row": {
          flexWrap: "nowrap"
        },
        [`> ${$}-label,
        > ${$}-control`]: {
          display: "inline-block",
          verticalAlign: "top"
        },
        [`> ${$}-label`]: {
          flex: "none"
        },
        [`${s}-text`]: {
          display: "inline-block"
        },
        [`${$}-has-feedback`]: {
          display: "inline-block"
        }
      }
    }
  };
}, makeVerticalLayoutLabel = (a) => ({
  padding: a.verticalLabelPadding,
  margin: a.verticalLabelMargin,
  whiteSpace: "initial",
  textAlign: "start",
  "> label": {
    margin: 0,
    "&::after": {
      // https://github.com/ant-design/ant-design/issues/43538
      visibility: "hidden"
    }
  }
}), makeVerticalLayout = (a) => {
  const {
    componentCls: s,
    formItemCls: $,
    rootPrefixCls: _
  } = a;
  return {
    [`${$} ${$}-label`]: makeVerticalLayoutLabel(a),
    // ref: https://github.com/ant-design/ant-design/issues/45122
    [`${s}:not(${s}-inline)`]: {
      [$]: {
        flexWrap: "wrap",
        [`${$}-label, ${$}-control`]: {
          // When developer pass `xs: { span }`,
          // It should follow the `xs` screen config
          // ref: https://github.com/ant-design/ant-design/issues/44386
          [`&:not([class*=" ${_}-col-xs"])`]: {
            flex: "0 0 100%",
            maxWidth: "100%"
          }
        }
      }
    }
  };
}, genVerticalStyle$1 = (a) => {
  const {
    componentCls: s,
    formItemCls: $,
    rootPrefixCls: _
  } = a;
  return {
    [`${s}-vertical`]: {
      [$]: {
        "&-row": {
          flexDirection: "column"
        },
        "&-label > label": {
          height: "auto"
        },
        [`${s}-item-control`]: {
          width: "100%"
        }
      }
    },
    [`${s}-vertical ${$}-label,
      .${_}-col-24${$}-label,
      .${_}-col-xl-24${$}-label`]: makeVerticalLayoutLabel(a),
    [`@media (max-width: ${unit$1(a.screenXSMax)})`]: [makeVerticalLayout(a), {
      [s]: {
        [`.${_}-col-xs-24${$}-label`]: makeVerticalLayoutLabel(a)
      }
    }],
    [`@media (max-width: ${unit$1(a.screenSMMax)})`]: {
      [s]: {
        [`.${_}-col-sm-24${$}-label`]: makeVerticalLayoutLabel(a)
      }
    },
    [`@media (max-width: ${unit$1(a.screenMDMax)})`]: {
      [s]: {
        [`.${_}-col-md-24${$}-label`]: makeVerticalLayoutLabel(a)
      }
    },
    [`@media (max-width: ${unit$1(a.screenLGMax)})`]: {
      [s]: {
        [`.${_}-col-lg-24${$}-label`]: makeVerticalLayoutLabel(a)
      }
    }
  };
}, prepareComponentToken$d = (a) => ({
  labelRequiredMarkColor: a.colorError,
  labelColor: a.colorTextHeading,
  labelFontSize: a.fontSize,
  labelHeight: a.controlHeight,
  labelColonMarginInlineStart: a.marginXXS / 2,
  labelColonMarginInlineEnd: a.marginXS,
  itemMarginBottom: a.marginLG,
  verticalLabelPadding: `0 0 ${a.paddingXS}px`,
  verticalLabelMargin: 0
}), prepareToken$1 = (a, s) => merge(a, {
  formItemCls: `${a.componentCls}-item`,
  rootPrefixCls: s
}), useStyle$d = genStyleHooks("Form", (a, s) => {
  let {
    rootPrefixCls: $
  } = s;
  const _ = prepareToken$1(a, $);
  return [genFormStyle(_), genFormItemStyle(_), genFormValidateMotionStyle$1(_), genHorizontalStyle$1(_), genInlineStyle(_), genVerticalStyle$1(_), genCollapseMotion$1(_), zoomIn];
}, prepareComponentToken$d, {
  // Let From style before the Grid
  // ref https://github.com/ant-design/ant-design/issues/44386
  order: -1e3
}), EMPTY_LIST$2 = [];
function toErrorEntity(a, s, $) {
  let _ = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  return {
    key: typeof a == "string" ? a : `${s}-${_}`,
    error: a,
    errorStatus: $
  };
}
const ErrorList = (a) => {
  let {
    help: s,
    helpStatus: $,
    errors: _ = EMPTY_LIST$2,
    warnings: _e = EMPTY_LIST$2,
    className: tt,
    fieldId: nt,
    onVisibleChanged: at
  } = a;
  const {
    prefixCls: ot
  } = reactExports.useContext(FormItemPrefixContext), rt = `${ot}-item-explain`, st = useCSSVarCls$1(ot), [lt, et, it] = useStyle$d(ot, st), ut = reactExports.useMemo(() => initCollapseMotion$1(ot), [ot]), ft = useDebounce(_), ht = useDebounce(_e), dt = reactExports.useMemo(() => s != null ? [toErrorEntity(s, "help", $)] : [].concat(_toConsumableArray$d(ft.map((pt, mt) => toErrorEntity(pt, "error", "error", mt))), _toConsumableArray$d(ht.map((pt, mt) => toErrorEntity(pt, "warning", "warning", mt)))), [s, $, ft, ht]), gt = {};
  return nt && (gt.id = `${nt}_help`), lt(/* @__PURE__ */ reactExports.createElement(CSSMotion, {
    motionDeadline: ut.motionDeadline,
    motionName: `${ot}-show-help`,
    visible: !!dt.length,
    onVisibleChanged: at
  }, (pt) => {
    const {
      className: mt,
      style: ct
    } = pt;
    return /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, gt, {
      className: classnames(rt, mt, it, st, tt, et),
      style: ct,
      role: "alert"
    }), /* @__PURE__ */ reactExports.createElement(CSSMotionList, Object.assign({
      keys: dt
    }, initCollapseMotion$1(ot), {
      motionName: `${ot}-show-help-item`,
      component: !1
    }), (vt) => {
      const {
        key: At,
        error: xt,
        errorStatus: bt,
        className: Et,
        style: St
      } = vt;
      return /* @__PURE__ */ reactExports.createElement("div", {
        key: At,
        className: classnames(Et, {
          [`${rt}-${bt}`]: bt
        }),
        style: St
      }, xt);
    }));
  }));
}, ErrorList$1 = ErrorList, formItemNameBlackList = ["parentNode"], defaultItemNamePrefixCls = "form_item";
function toArray$3(a) {
  return a === void 0 || a === !1 ? [] : Array.isArray(a) ? a : [a];
}
function getFieldId(a, s) {
  if (!a.length)
    return;
  const $ = a.join("_");
  return s ? `${s}_${$}` : formItemNameBlackList.includes($) ? `${defaultItemNamePrefixCls}_${$}` : $;
}
function getStatus(a, s, $, _, _e, tt) {
  let nt = _;
  return tt !== void 0 ? nt = tt : $.validating ? nt = "validating" : a.length ? nt = "error" : s.length ? nt = "warning" : ($.touched || _e && $.validated) && (nt = "success"), nt;
}
function toNamePathStr(a) {
  return toArray$3(a).join("_");
}
function useForm$1(a) {
  const [s] = useForm$2(), $ = reactExports.useRef({}), _ = reactExports.useMemo(() => a ?? Object.assign(Object.assign({}, s), {
    __INTERNAL__: {
      itemRef: (_e) => (tt) => {
        const nt = toNamePathStr(_e);
        tt ? $.current[nt] = tt : delete $.current[nt];
      }
    },
    scrollToField: function(_e) {
      let tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const nt = toArray$3(_e), at = getFieldId(nt, _.__INTERNAL__.name), ot = at ? document.getElementById(at) : null;
      ot && e$1(ot, Object.assign({
        scrollMode: "if-needed",
        block: "nearest"
      }, tt));
    },
    getFieldInstance: (_e) => {
      const tt = toNamePathStr(_e);
      return $.current[tt];
    }
  }), [a, s]);
  return [_];
}
var __rest$s = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const InternalForm = (a, s) => {
  const $ = reactExports.useContext(DisabledContext$1), {
    getPrefixCls: _,
    direction: _e,
    form: tt
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: nt,
    className: at,
    rootClassName: ot,
    size: rt,
    disabled: st = $,
    form: lt,
    colon: et,
    labelAlign: it,
    labelWrap: ut,
    labelCol: ft,
    wrapperCol: ht,
    hideRequiredMark: dt,
    layout: gt = "horizontal",
    scrollToFirstError: pt,
    requiredMark: mt,
    onFinishFailed: ct,
    name: vt,
    style: At,
    feedbackIcons: xt
  } = a, bt = __rest$s(a, ["prefixCls", "className", "rootClassName", "size", "disabled", "form", "colon", "labelAlign", "labelWrap", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name", "style", "feedbackIcons"]), Et = useSize$1(rt), St = reactExports.useContext(ValidateMessagesContext), Bt = reactExports.useMemo(() => mt !== void 0 ? mt : dt ? !1 : tt && tt.requiredMark !== void 0 ? tt.requiredMark : !0, [dt, mt, tt]), Ot = et ?? (tt == null ? void 0 : tt.colon), Pt = _("form", nt), wt = useCSSVarCls$1(Pt), [Ct, It, yt] = useStyle$d(Pt, wt), Rt = classnames(Pt, `${Pt}-${gt}`, {
    [`${Pt}-hide-required-mark`]: Bt === !1,
    [`${Pt}-rtl`]: _e === "rtl",
    [`${Pt}-${Et}`]: Et
  }, yt, wt, It, tt == null ? void 0 : tt.className, at, ot), [kt] = useForm$1(lt), {
    __INTERNAL__: jt
  } = kt;
  jt.name = vt;
  const Ht = reactExports.useMemo(() => ({
    name: vt,
    labelAlign: it,
    labelCol: ft,
    labelWrap: ut,
    wrapperCol: ht,
    vertical: gt === "vertical",
    colon: Ot,
    requiredMark: Bt,
    itemRef: jt.itemRef,
    form: kt,
    feedbackIcons: xt
  }), [vt, it, ft, ht, gt, Ot, Bt, kt, xt]);
  reactExports.useImperativeHandle(s, () => kt);
  const Ft = (Nt, Mt) => {
    if (Nt) {
      let Lt = {
        block: "nearest"
      };
      typeof Nt == "object" && (Lt = Nt), kt.scrollToField(Mt, Lt);
    }
  }, _t = (Nt) => {
    if (ct == null || ct(Nt), Nt.errorFields.length) {
      const Mt = Nt.errorFields[0].name;
      if (pt !== void 0) {
        Ft(pt, Mt);
        return;
      }
      tt && tt.scrollToFirstError !== void 0 && Ft(tt.scrollToFirstError, Mt);
    }
  };
  return Ct(/* @__PURE__ */ reactExports.createElement(DisabledContextProvider, {
    disabled: st
  }, /* @__PURE__ */ reactExports.createElement(SizeContext$1.Provider, {
    value: Et
  }, /* @__PURE__ */ reactExports.createElement(FormProvider, {
    // This is not list in API, we pass with spread
    validateMessages: St
  }, /* @__PURE__ */ reactExports.createElement(FormContext.Provider, {
    value: Ht
  }, /* @__PURE__ */ reactExports.createElement(RefForm, Object.assign({
    id: vt
  }, bt, {
    name: vt,
    onFinishFailed: _t,
    form: kt,
    style: Object.assign(Object.assign({}, tt == null ? void 0 : tt.style), At),
    className: Rt
  })))))));
}, Form$4 = /* @__PURE__ */ reactExports.forwardRef(InternalForm), InternalForm$1 = Form$4;
function useChildren(a) {
  if (typeof a == "function")
    return a;
  const s = toArray$9(a);
  return s.length <= 1 ? s[0] : s;
}
const useFormItemStatus = () => {
  const {
    status: a,
    errors: s = [],
    warnings: $ = []
  } = reactExports.useContext(FormItemInputContext);
  return {
    status: a,
    errors: s,
    warnings: $
  };
};
useFormItemStatus.Context = FormItemInputContext;
const useFormItemStatus$1 = useFormItemStatus;
function useFrameState(a) {
  const [s, $] = reactExports.useState(a), _ = reactExports.useRef(null), _e = reactExports.useRef([]), tt = reactExports.useRef(!1);
  reactExports.useEffect(() => (tt.current = !1, () => {
    tt.current = !0, wrapperRaf.cancel(_.current), _.current = null;
  }), []);
  function nt(at) {
    tt.current || (_.current === null && (_e.current = [], _.current = wrapperRaf(() => {
      _.current = null, $((ot) => {
        let rt = ot;
        return _e.current.forEach((st) => {
          rt = st(rt);
        }), rt;
      });
    })), _e.current.push(at));
  }
  return [s, nt];
}
function useItemRef() {
  const {
    itemRef: a
  } = reactExports.useContext(FormContext), s = reactExports.useRef({});
  function $(_, _e) {
    const tt = _e && typeof _e == "object" && _e.ref, nt = _.join("_");
    return (s.current.name !== nt || s.current.originRef !== tt) && (s.current.name = nt, s.current.originRef = tt, s.current.ref = composeRef(a(_), tt)), s.current.ref;
  }
  return $;
}
const genFallbackStyle = (a) => {
  const {
    formItemCls: s
  } = a;
  return {
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
      // Fallback for IE, safe to remove we not support it anymore
      [`${s}-control`]: {
        display: "flex"
      }
    }
  };
}, FallbackCmp = genSubStyleComponent(["Form", "item-item"], (a, s) => {
  let {
    rootPrefixCls: $
  } = s;
  const _ = prepareToken$1(a, $);
  return [genFallbackStyle(_)];
}), FormItemInput = (a) => {
  const {
    prefixCls: s,
    status: $,
    wrapperCol: _,
    children: _e,
    errors: tt,
    warnings: nt,
    _internalItemRender: at,
    extra: ot,
    help: rt,
    fieldId: st,
    marginBottom: lt,
    onErrorVisibleChanged: et
  } = a, it = `${s}-item`, ut = reactExports.useContext(FormContext), ft = _ || ut.wrapperCol || {}, ht = classnames(`${it}-control`, ft.className), dt = reactExports.useMemo(() => Object.assign({}, ut), [ut]);
  delete dt.labelCol, delete dt.wrapperCol;
  const gt = /* @__PURE__ */ reactExports.createElement("div", {
    className: `${it}-control-input`
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${it}-control-input-content`
  }, _e)), pt = reactExports.useMemo(() => ({
    prefixCls: s,
    status: $
  }), [s, $]), mt = lt !== null || tt.length || nt.length ? /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "nowrap"
    }
  }, /* @__PURE__ */ reactExports.createElement(FormItemPrefixContext.Provider, {
    value: pt
  }, /* @__PURE__ */ reactExports.createElement(ErrorList$1, {
    fieldId: st,
    errors: tt,
    warnings: nt,
    help: rt,
    helpStatus: $,
    className: `${it}-explain-connected`,
    onVisibleChanged: et
  })), !!lt && /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      width: 0,
      height: lt
    }
  })) : null, ct = {};
  st && (ct.id = `${st}_extra`);
  const vt = ot ? /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, ct, {
    className: `${it}-extra`
  }), ot) : null, At = at && at.mark === "pro_table_render" && at.render ? at.render(a, {
    input: gt,
    errorList: mt,
    extra: vt
  }) : /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, gt, mt, vt);
  return /* @__PURE__ */ reactExports.createElement(FormContext.Provider, {
    value: dt
  }, /* @__PURE__ */ reactExports.createElement(Col$1, Object.assign({}, ft, {
    className: ht
  }), At), /* @__PURE__ */ reactExports.createElement(FallbackCmp, {
    prefixCls: s
  }));
}, FormItemInput$1 = FormItemInput;
var QuestionCircleOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" };
const QuestionCircleOutlinedSvg = QuestionCircleOutlined$2;
var QuestionCircleOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: QuestionCircleOutlinedSvg
  }));
};
const QuestionCircleOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(QuestionCircleOutlined);
var __rest$r = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function toTooltipProps(a) {
  return a ? typeof a == "object" && !/* @__PURE__ */ reactExports.isValidElement(a) ? a : {
    title: a
  } : null;
}
const FormItemLabel = (a) => {
  let {
    prefixCls: s,
    label: $,
    htmlFor: _,
    labelCol: _e,
    labelAlign: tt,
    colon: nt,
    required: at,
    requiredMark: ot,
    tooltip: rt
  } = a;
  var st;
  const [lt] = useLocale$1("Form"), {
    vertical: et,
    labelAlign: it,
    labelCol: ut,
    labelWrap: ft,
    colon: ht
  } = reactExports.useContext(FormContext);
  if (!$)
    return null;
  const dt = _e || ut || {}, gt = tt || it, pt = `${s}-item-label`, mt = classnames(pt, gt === "left" && `${pt}-left`, dt.className, {
    [`${pt}-wrap`]: !!ft
  });
  let ct = $;
  const vt = nt === !0 || ht !== !1 && nt !== !1;
  vt && !et && typeof $ == "string" && $.trim() !== "" && (ct = $.replace(/[:|：]\s*$/, ""));
  const xt = toTooltipProps(rt);
  if (xt) {
    const {
      icon: Bt = /* @__PURE__ */ reactExports.createElement(QuestionCircleOutlined$1, null)
    } = xt, Ot = __rest$r(xt, ["icon"]), Pt = /* @__PURE__ */ reactExports.createElement(_Tooltip, Object.assign({}, Ot), /* @__PURE__ */ reactExports.cloneElement(Bt, {
      className: `${s}-item-tooltip`,
      title: "",
      onClick: (wt) => {
        wt.preventDefault();
      },
      tabIndex: null
    }));
    ct = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, ct, Pt);
  }
  const bt = ot === "optional", Et = typeof ot == "function";
  Et ? ct = ot(ct, {
    required: !!at
  }) : bt && !at && (ct = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, ct, /* @__PURE__ */ reactExports.createElement("span", {
    className: `${s}-item-optional`,
    title: ""
  }, (lt == null ? void 0 : lt.optional) || ((st = defaultLocale.Form) === null || st === void 0 ? void 0 : st.optional))));
  const St = classnames({
    [`${s}-item-required`]: at,
    [`${s}-item-required-mark-optional`]: bt || Et,
    [`${s}-item-no-colon`]: !vt
  });
  return /* @__PURE__ */ reactExports.createElement(Col$1, Object.assign({}, dt, {
    className: mt
  }), /* @__PURE__ */ reactExports.createElement("label", {
    htmlFor: _,
    className: St,
    title: typeof $ == "string" ? $ : ""
  }, ct));
}, FormItemLabel$1 = FormItemLabel, iconMap = {
  success: CheckCircleFilled$1,
  warning: ExclamationCircleFilled$1,
  error: CloseCircleFilled$1,
  validating: LoadingOutlined$1
};
function StatusProvider(a) {
  let {
    children: s,
    errors: $,
    warnings: _,
    hasFeedback: _e,
    validateStatus: tt,
    prefixCls: nt,
    meta: at,
    noStyle: ot
  } = a;
  const rt = `${nt}-item`, {
    feedbackIcons: st
  } = reactExports.useContext(FormContext), lt = getStatus($, _, at, null, !!_e, tt), {
    isFormItemInput: et,
    status: it,
    hasFeedback: ut,
    feedbackIcon: ft
  } = reactExports.useContext(FormItemInputContext), ht = reactExports.useMemo(() => {
    var dt;
    let gt;
    if (_e) {
      const mt = _e !== !0 && _e.icons || st, ct = lt && ((dt = mt == null ? void 0 : mt({
        status: lt,
        errors: $,
        warnings: _
      })) === null || dt === void 0 ? void 0 : dt[lt]), vt = lt && iconMap[lt];
      gt = ct !== !1 && vt ? /* @__PURE__ */ reactExports.createElement("span", {
        className: classnames(`${rt}-feedback-icon`, `${rt}-feedback-icon-${lt}`)
      }, ct || /* @__PURE__ */ reactExports.createElement(vt, null)) : null;
    }
    const pt = {
      status: lt || "",
      errors: $,
      warnings: _,
      hasFeedback: !!_e,
      feedbackIcon: gt,
      isFormItemInput: !0
    };
    return ot && (pt.status = (lt ?? it) || "", pt.isFormItemInput = et, pt.hasFeedback = !!(_e ?? ut), pt.feedbackIcon = _e !== void 0 ? pt.feedbackIcon : ft), pt;
  }, [lt, _e, ot, et, it]);
  return /* @__PURE__ */ reactExports.createElement(FormItemInputContext.Provider, {
    value: ht
  }, s);
}
var __rest$q = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function ItemHolder(a) {
  const {
    prefixCls: s,
    className: $,
    rootClassName: _,
    style: _e,
    help: tt,
    errors: nt,
    warnings: at,
    validateStatus: ot,
    meta: rt,
    hasFeedback: st,
    hidden: lt,
    children: et,
    fieldId: it,
    required: ut,
    isRequired: ft,
    onSubItemMetaChange: ht
  } = a, dt = __rest$q(a, ["prefixCls", "className", "rootClassName", "style", "help", "errors", "warnings", "validateStatus", "meta", "hasFeedback", "hidden", "children", "fieldId", "required", "isRequired", "onSubItemMetaChange"]), gt = `${s}-item`, {
    requiredMark: pt
  } = reactExports.useContext(FormContext), mt = reactExports.useRef(null), ct = useDebounce(nt), vt = useDebounce(at), At = tt != null, xt = !!(At || nt.length || at.length), bt = !!mt.current && isVisible(mt.current), [Et, St] = reactExports.useState(null);
  useLayoutEffect$1(() => {
    if (xt && mt.current) {
      const Ct = getComputedStyle(mt.current);
      St(parseInt(Ct.marginBottom, 10));
    }
  }, [xt, bt]);
  const Bt = (Ct) => {
    Ct || St(null);
  }, Pt = function() {
    let Ct = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const It = Ct ? ct : rt.errors, yt = Ct ? vt : rt.warnings;
    return getStatus(It, yt, rt, "", !!st, ot);
  }(), wt = classnames(gt, $, _, {
    [`${gt}-with-help`]: At || ct.length || vt.length,
    // Status
    [`${gt}-has-feedback`]: Pt && st,
    [`${gt}-has-success`]: Pt === "success",
    [`${gt}-has-warning`]: Pt === "warning",
    [`${gt}-has-error`]: Pt === "error",
    [`${gt}-is-validating`]: Pt === "validating",
    [`${gt}-hidden`]: lt
  });
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: wt,
    style: _e,
    ref: mt
  }, /* @__PURE__ */ reactExports.createElement(Row$1, Object.assign({
    className: `${gt}-row`
  }, omit(dt, [
    "_internalItemRender",
    "colon",
    "dependencies",
    "extra",
    "fieldKey",
    "getValueFromEvent",
    "getValueProps",
    "htmlFor",
    "id",
    // It is deprecated because `htmlFor` is its replacement.
    "initialValue",
    "isListField",
    "label",
    "labelAlign",
    "labelCol",
    "labelWrap",
    "messageVariables",
    "name",
    "normalize",
    "noStyle",
    "preserve",
    "requiredMark",
    "rules",
    "shouldUpdate",
    "trigger",
    "tooltip",
    "validateFirst",
    "validateTrigger",
    "valuePropName",
    "wrapperCol",
    "validateDebounce"
  ])), /* @__PURE__ */ reactExports.createElement(FormItemLabel$1, Object.assign({
    htmlFor: it
  }, a, {
    requiredMark: pt,
    required: ut ?? ft,
    prefixCls: s
  })), /* @__PURE__ */ reactExports.createElement(FormItemInput$1, Object.assign({}, a, rt, {
    errors: ct,
    warnings: vt,
    prefixCls: s,
    status: Pt,
    help: tt,
    marginBottom: Et,
    onErrorVisibleChanged: Bt
  }), /* @__PURE__ */ reactExports.createElement(NoStyleItemContext.Provider, {
    value: ht
  }, /* @__PURE__ */ reactExports.createElement(StatusProvider, {
    prefixCls: s,
    meta: rt,
    errors: rt.errors,
    warnings: rt.warnings,
    hasFeedback: st,
    // Already calculated
    validateStatus: Pt
  }, et)))), !!Et && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${gt}-margin-offset`,
    style: {
      marginBottom: -Et
    }
  }));
}
const NAME_SPLIT = "__SPLIT__";
function isSimilarControl(a, s) {
  const $ = Object.keys(a), _ = Object.keys(s);
  return $.length === _.length && $.every((_e) => {
    const tt = a[_e], nt = s[_e];
    return tt === nt || typeof tt == "function" || typeof nt == "function";
  });
}
const MemoInput = /* @__PURE__ */ reactExports.memo((a) => {
  let {
    children: s
  } = a;
  return s;
}, (a, s) => isSimilarControl(a.control, s.control) && a.update === s.update && a.childProps.length === s.childProps.length && a.childProps.every(($, _) => $ === s.childProps[_]));
function genEmptyMeta() {
  return {
    errors: [],
    warnings: [],
    touched: !1,
    validating: !1,
    name: [],
    validated: !1
  };
}
function InternalFormItem(a) {
  const {
    name: s,
    noStyle: $,
    className: _,
    dependencies: _e,
    prefixCls: tt,
    shouldUpdate: nt,
    rules: at,
    children: ot,
    required: rt,
    label: st,
    messageVariables: lt,
    trigger: et = "onChange",
    validateTrigger: it,
    hidden: ut,
    help: ft
  } = a, {
    getPrefixCls: ht
  } = reactExports.useContext(ConfigContext$1), {
    name: dt
  } = reactExports.useContext(FormContext), gt = useChildren(ot), pt = typeof gt == "function", mt = reactExports.useContext(NoStyleItemContext), {
    validateTrigger: ct
  } = reactExports.useContext(Context$2), vt = it !== void 0 ? it : ct, At = s != null, xt = ht("form", tt), bt = useCSSVarCls$1(xt), [Et, St, Bt] = useStyle$d(xt, bt);
  devUseWarning();
  const Ot = reactExports.useContext(ListContext), Pt = reactExports.useRef(), [wt, Ct] = useFrameState({}), [It, yt] = useSafeState(() => genEmptyMeta()), Rt = (Mt) => {
    const Lt = Ot == null ? void 0 : Ot.getKey(Mt.name);
    if (yt(Mt.destroy ? genEmptyMeta() : Mt, !0), $ && ft !== !1 && mt) {
      let $t = Mt.name;
      if (Mt.destroy)
        $t = Pt.current || $t;
      else if (Lt !== void 0) {
        const [Tt, Dt] = Lt;
        $t = [Tt].concat(_toConsumableArray$d(Dt)), Pt.current = $t;
      }
      mt(Mt, $t);
    }
  }, kt = (Mt, Lt) => {
    Ct(($t) => {
      const Tt = Object.assign({}, $t), Ut = [].concat(_toConsumableArray$d(Mt.name.slice(0, -1)), _toConsumableArray$d(Lt)).join(NAME_SPLIT);
      return Mt.destroy ? delete Tt[Ut] : Tt[Ut] = Mt, Tt;
    });
  }, [jt, Ht] = reactExports.useMemo(() => {
    const Mt = _toConsumableArray$d(It.errors), Lt = _toConsumableArray$d(It.warnings);
    return Object.values(wt).forEach(($t) => {
      Mt.push.apply(Mt, _toConsumableArray$d($t.errors || [])), Lt.push.apply(Lt, _toConsumableArray$d($t.warnings || []));
    }), [Mt, Lt];
  }, [wt, It.errors, It.warnings]), Ft = useItemRef();
  function _t(Mt, Lt, $t) {
    return $ && !ut ? /* @__PURE__ */ reactExports.createElement(StatusProvider, {
      prefixCls: xt,
      hasFeedback: a.hasFeedback,
      validateStatus: a.validateStatus,
      meta: It,
      errors: jt,
      warnings: Ht,
      noStyle: !0
    }, Mt) : /* @__PURE__ */ reactExports.createElement(ItemHolder, Object.assign({
      key: "row"
    }, a, {
      className: classnames(_, Bt, bt, St),
      prefixCls: xt,
      fieldId: Lt,
      isRequired: $t,
      errors: jt,
      warnings: Ht,
      meta: It,
      onSubItemMetaChange: kt
    }), Mt);
  }
  if (!At && !pt && !_e)
    return Et(_t(gt));
  let Nt = {};
  return typeof st == "string" ? Nt.label = st : s && (Nt.label = String(s)), lt && (Nt = Object.assign(Object.assign({}, Nt), lt)), Et(/* @__PURE__ */ reactExports.createElement(WrapperField, Object.assign({}, a, {
    messageVariables: Nt,
    trigger: et,
    validateTrigger: vt,
    onMetaChange: Rt
  }), (Mt, Lt, $t) => {
    const Tt = toArray$3(s).length && Lt ? Lt.name : [], Dt = getFieldId(Tt, dt), Ut = rt !== void 0 ? rt : !!(at && at.some((qt) => {
      if (qt && typeof qt == "object" && qt.required && !qt.warningOnly)
        return !0;
      if (typeof qt == "function") {
        const Zt = qt($t);
        return Zt && Zt.required && !Zt.warningOnly;
      }
      return !1;
    })), Vt = Object.assign({}, Mt);
    let Qt = null;
    if (Array.isArray(gt) && At)
      Qt = gt;
    else if (!(pt && (!(nt || _e) || At))) {
      if (!(_e && !pt && !At))
        if (isValidElement(gt)) {
          const qt = Object.assign(Object.assign({}, gt.props), Vt);
          if (qt.id || (qt.id = Dt), ft || jt.length > 0 || Ht.length > 0 || a.extra) {
            const Jt = [];
            (ft || jt.length > 0) && Jt.push(`${Dt}_help`), a.extra && Jt.push(`${Dt}_extra`), qt["aria-describedby"] = Jt.join(" ");
          }
          jt.length > 0 && (qt["aria-invalid"] = "true"), Ut && (qt["aria-required"] = "true"), supportRef(gt) && (qt.ref = Ft(Tt, gt)), new Set([].concat(_toConsumableArray$d(toArray$3(et)), _toConsumableArray$d(toArray$3(vt)))).forEach((Jt) => {
            qt[Jt] = function() {
              for (var rr, Yt, Kt, nr, tr, ir = arguments.length, sr = new Array(ir), cr = 0; cr < ir; cr++)
                sr[cr] = arguments[cr];
              (Kt = Vt[Jt]) === null || Kt === void 0 || (rr = Kt).call.apply(rr, [Vt].concat(sr)), (tr = (nr = gt.props)[Jt]) === null || tr === void 0 || (Yt = tr).call.apply(Yt, [nr].concat(sr));
            };
          });
          const ar = [qt["aria-required"], qt["aria-invalid"], qt["aria-describedby"]];
          Qt = /* @__PURE__ */ reactExports.createElement(MemoInput, {
            control: Vt,
            update: gt,
            childProps: ar
          }, cloneElement(gt, qt));
        } else
          pt && (nt || _e) && !At ? Qt = gt($t) : Qt = gt;
    }
    return _t(Qt, Dt, Ut);
  }));
}
const FormItem = InternalFormItem;
FormItem.useStatus = useFormItemStatus$1;
const Item$2 = FormItem;
var __rest$p = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const FormList = (a) => {
  var {
    prefixCls: s,
    children: $
  } = a, _ = __rest$p(a, ["prefixCls", "children"]);
  const {
    getPrefixCls: _e
  } = reactExports.useContext(ConfigContext$1), tt = _e("form", s), nt = reactExports.useMemo(() => ({
    prefixCls: tt,
    status: "error"
  }), [tt]);
  return /* @__PURE__ */ reactExports.createElement(List$2, Object.assign({}, _), (at, ot, rt) => /* @__PURE__ */ reactExports.createElement(FormItemPrefixContext.Provider, {
    value: nt
  }, $(at.map((st) => Object.assign(Object.assign({}, st), {
    fieldKey: st.key
  })), ot, {
    errors: rt.errors,
    warnings: rt.warnings
  })));
}, List = FormList;
function useFormInstance() {
  const {
    form: a
  } = reactExports.useContext(FormContext);
  return a;
}
const Form$2 = InternalForm$1;
Form$2.Item = Item$2;
Form$2.List = List;
Form$2.ErrorList = ErrorList$1;
Form$2.useForm = useForm$1;
Form$2.useFormInstance = useFormInstance;
Form$2.useWatch = useWatch$1;
Form$2.Provider = FormProvider;
Form$2.create = () => {
};
const Form$3 = Form$2;
function getClientSize() {
  var a = document.documentElement.clientWidth, s = window.innerHeight || document.documentElement.clientHeight;
  return {
    width: a,
    height: s
  };
}
function getOffset$2(a) {
  var s = a.getBoundingClientRect(), $ = document.documentElement;
  return {
    left: s.left + (window.pageXOffset || $.scrollLeft) - ($.clientLeft || document.body.clientLeft || 0),
    top: s.top + (window.pageYOffset || $.scrollTop) - ($.clientTop || document.body.clientTop || 0)
  };
}
var COMMON_PROPS = ["crossOrigin", "decoding", "draggable", "loading", "referrerPolicy", "sizes", "srcSet", "useMap", "alt"], PreviewGroupContext = /* @__PURE__ */ reactExports.createContext(null), uid$4 = 0;
function useRegisterImage(a, s) {
  var $ = reactExports.useState(function() {
    return uid$4 += 1, String(uid$4);
  }), _ = _slicedToArray$e($, 1), _e = _[0], tt = reactExports.useContext(PreviewGroupContext), nt = {
    data: s,
    canPreview: a
  };
  return reactExports.useEffect(function() {
    if (tt)
      return tt.register(_e, nt);
  }, []), reactExports.useEffect(function() {
    tt && tt.register(_e, nt);
  }, [a, s]), _e;
}
function isImageValid(a) {
  return new Promise(function(s) {
    var $ = document.createElement("img");
    $.onerror = function() {
      return s(!1);
    }, $.onload = function() {
      return s(!0);
    }, $.src = a;
  });
}
function useStatus(a) {
  var s = a.src, $ = a.isCustomPlaceholder, _ = a.fallback, _e = reactExports.useState($ ? "loading" : "normal"), tt = _slicedToArray$e(_e, 2), nt = tt[0], at = tt[1], ot = reactExports.useRef(!1), rt = nt === "error";
  reactExports.useEffect(function() {
    var it = !0;
    return isImageValid(s).then(function(ut) {
      !ut && it && at("error");
    }), function() {
      it = !1;
    };
  }, [s]), reactExports.useEffect(function() {
    $ && !ot.current ? at("loading") : rt && at("normal");
  }, [s]);
  var st = function() {
    at("normal");
  }, lt = function(ut) {
    ot.current = !1, nt === "loading" && ut !== null && ut !== void 0 && ut.complete && (ut.naturalWidth || ut.naturalHeight) && (ot.current = !0, st());
  }, et = rt && _ ? {
    src: _
  } : {
    onLoad: st,
    src: s
  };
  return [lt, et, nt];
}
function addEventListenerWrap$3(a, s, $, _) {
  var _e = ReactDOM.unstable_batchedUpdates ? function(nt) {
    ReactDOM.unstable_batchedUpdates($, nt);
  } : $;
  return a != null && a.addEventListener && a.addEventListener(s, _e, _), {
    remove: function() {
      a != null && a.removeEventListener && a.removeEventListener(s, _e, _);
    }
  };
}
var initialTransform = {
  x: 0,
  y: 0,
  rotate: 0,
  scale: 1,
  flipX: !1,
  flipY: !1
};
function useImageTransform(a, s, $, _) {
  var _e = reactExports.useRef(null), tt = reactExports.useRef([]), nt = reactExports.useState(initialTransform), at = _slicedToArray$e(nt, 2), ot = at[0], rt = at[1], st = function(ut) {
    rt(initialTransform), _ && !isEqual$1(initialTransform, ot) && _({
      transform: initialTransform,
      action: ut
    });
  }, lt = function(ut, ft) {
    _e.current === null && (tt.current = [], _e.current = wrapperRaf(function() {
      rt(function(ht) {
        var dt = ht;
        return tt.current.forEach(function(gt) {
          dt = _objectSpread2$a(_objectSpread2$a({}, dt), gt);
        }), _e.current = null, _ == null || _({
          transform: dt,
          action: ft
        }), dt;
      });
    })), tt.current.push(_objectSpread2$a(_objectSpread2$a({}, ot), ut));
  }, et = function(ut, ft, ht, dt, gt) {
    var pt = a.current, mt = pt.width, ct = pt.height, vt = pt.offsetWidth, At = pt.offsetHeight, xt = pt.offsetLeft, bt = pt.offsetTop, Et = ut, St = ot.scale * ut;
    St > $ ? (St = $, Et = $ / ot.scale) : St < s && (St = gt ? St : s, Et = St / ot.scale);
    var Bt = ht ?? innerWidth / 2, Ot = dt ?? innerHeight / 2, Pt = Et - 1, wt = Pt * mt * 0.5, Ct = Pt * ct * 0.5, It = Pt * (Bt - ot.x - xt), yt = Pt * (Ot - ot.y - bt), Rt = ot.x - (It - wt), kt = ot.y - (yt - Ct);
    if (ut < 1 && St === 1) {
      var jt = vt * St, Ht = At * St, Ft = getClientSize(), _t = Ft.width, Nt = Ft.height;
      jt <= _t && Ht <= Nt && (Rt = 0, kt = 0);
    }
    lt({
      x: Rt,
      y: kt,
      scale: St
    }, ft);
  };
  return {
    transform: ot,
    resetTransform: st,
    updateTransform: lt,
    dispatchZoomChange: et
  };
}
function fixPoint(a, s, $, _) {
  var _e = s + $, tt = ($ - _) / 2;
  if ($ > _) {
    if (s > 0)
      return _defineProperty$c({}, a, tt);
    if (s < 0 && _e < _)
      return _defineProperty$c({}, a, -tt);
  } else if (s < 0 || _e > _)
    return _defineProperty$c({}, a, s < 0 ? tt : -tt);
  return {};
}
function getFixScaleEleTransPosition(a, s, $, _) {
  var _e = getClientSize(), tt = _e.width, nt = _e.height, at = null;
  return a <= tt && s <= nt ? at = {
    x: 0,
    y: 0
  } : (a > tt || s > nt) && (at = _objectSpread2$a(_objectSpread2$a({}, fixPoint("x", $, a, tt)), fixPoint("y", _, s, nt))), at;
}
var BASE_SCALE_RATIO = 1, WHEEL_MAX_SCALE_RATIO = 1;
function useMouseEvent(a, s, $, _, _e, tt, nt) {
  var at = _e.rotate, ot = _e.scale, rt = _e.x, st = _e.y, lt = reactExports.useState(!1), et = _slicedToArray$e(lt, 2), it = et[0], ut = et[1], ft = reactExports.useRef({
    diffX: 0,
    diffY: 0,
    transformX: 0,
    transformY: 0
  }), ht = function(ct) {
    !s || ct.button !== 0 || (ct.preventDefault(), ct.stopPropagation(), ft.current = {
      diffX: ct.pageX - rt,
      diffY: ct.pageY - st,
      transformX: rt,
      transformY: st
    }, ut(!0));
  }, dt = function(ct) {
    $ && it && tt({
      x: ct.pageX - ft.current.diffX,
      y: ct.pageY - ft.current.diffY
    }, "move");
  }, gt = function() {
    if ($ && it) {
      ut(!1);
      var ct = ft.current, vt = ct.transformX, At = ct.transformY, xt = rt !== vt && st !== At;
      if (!xt)
        return;
      var bt = a.current.offsetWidth * ot, Et = a.current.offsetHeight * ot, St = a.current.getBoundingClientRect(), Bt = St.left, Ot = St.top, Pt = at % 180 !== 0, wt = getFixScaleEleTransPosition(Pt ? Et : bt, Pt ? bt : Et, Bt, Ot);
      wt && tt(_objectSpread2$a({}, wt), "dragRebound");
    }
  }, pt = function(ct) {
    if (!(!$ || ct.deltaY == 0)) {
      var vt = Math.abs(ct.deltaY / 100), At = Math.min(vt, WHEEL_MAX_SCALE_RATIO), xt = BASE_SCALE_RATIO + At * _;
      ct.deltaY > 0 && (xt = BASE_SCALE_RATIO / xt), nt(xt, "wheel", ct.clientX, ct.clientY);
    }
  };
  return reactExports.useEffect(function() {
    var mt, ct, vt, At;
    if (s) {
      vt = addEventListenerWrap$3(window, "mouseup", gt, !1), At = addEventListenerWrap$3(window, "mousemove", dt, !1);
      try {
        window.top !== window.self && (mt = addEventListenerWrap$3(window.top, "mouseup", gt, !1), ct = addEventListenerWrap$3(window.top, "mousemove", dt, !1));
      } catch {
      }
    }
    return function() {
      var xt, bt, Et, St;
      (xt = vt) === null || xt === void 0 || xt.remove(), (bt = At) === null || bt === void 0 || bt.remove(), (Et = mt) === null || Et === void 0 || Et.remove(), (St = ct) === null || St === void 0 || St.remove();
    };
  }, [$, it, rt, st, at, s]), {
    isMoving: it,
    onMouseDown: ht,
    onMouseMove: dt,
    onMouseUp: gt,
    onWheel: pt
  };
}
function getDistance(a, s) {
  var $ = a.x - s.x, _ = a.y - s.y;
  return Math.hypot($, _);
}
function getCenter(a, s, $, _) {
  var _e = getDistance(a, $), tt = getDistance(s, _);
  if (_e === 0 && tt === 0)
    return [a.x, a.y];
  var nt = _e / (_e + tt), at = a.x + nt * (s.x - a.x), ot = a.y + nt * (s.y - a.y);
  return [at, ot];
}
function useTouchEvent(a, s, $, _, _e, tt, nt) {
  var at = _e.rotate, ot = _e.scale, rt = _e.x, st = _e.y, lt = reactExports.useState(!1), et = _slicedToArray$e(lt, 2), it = et[0], ut = et[1], ft = reactExports.useRef({
    point1: {
      x: 0,
      y: 0
    },
    point2: {
      x: 0,
      y: 0
    },
    eventType: "none"
  }), ht = function(ct) {
    ft.current = _objectSpread2$a(_objectSpread2$a({}, ft.current), ct);
  }, dt = function(ct) {
    if (s) {
      ct.stopPropagation(), ut(!0);
      var vt = ct.touches, At = vt === void 0 ? [] : vt;
      At.length > 1 ? ht({
        point1: {
          x: At[0].clientX,
          y: At[0].clientY
        },
        point2: {
          x: At[1].clientX,
          y: At[1].clientY
        },
        eventType: "touchZoom"
      }) : ht({
        point1: {
          x: At[0].clientX - rt,
          y: At[0].clientY - st
        },
        eventType: "move"
      });
    }
  }, gt = function(ct) {
    var vt = ct.touches, At = vt === void 0 ? [] : vt, xt = ft.current, bt = xt.point1, Et = xt.point2, St = xt.eventType;
    if (At.length > 1 && St === "touchZoom") {
      var Bt = {
        x: At[0].clientX,
        y: At[0].clientY
      }, Ot = {
        x: At[1].clientX,
        y: At[1].clientY
      }, Pt = getCenter(bt, Et, Bt, Ot), wt = _slicedToArray$e(Pt, 2), Ct = wt[0], It = wt[1], yt = getDistance(Bt, Ot) / getDistance(bt, Et);
      nt(yt, "touchZoom", Ct, It, !0), ht({
        point1: Bt,
        point2: Ot,
        eventType: "touchZoom"
      });
    } else
      St === "move" && (tt({
        x: At[0].clientX - bt.x,
        y: At[0].clientY - bt.y
      }, "move"), ht({
        eventType: "move"
      }));
  }, pt = function() {
    if ($) {
      if (it && ut(!1), ht({
        eventType: "none"
      }), _ > ot)
        return tt({
          x: 0,
          y: 0,
          scale: _
        }, "touchZoom");
      var ct = a.current.offsetWidth * ot, vt = a.current.offsetHeight * ot, At = a.current.getBoundingClientRect(), xt = At.left, bt = At.top, Et = at % 180 !== 0, St = getFixScaleEleTransPosition(Et ? vt : ct, Et ? ct : vt, xt, bt);
      St && tt(_objectSpread2$a({}, St), "dragRebound");
    }
  };
  return reactExports.useEffect(function() {
    var mt;
    return $ && s && (mt = addEventListenerWrap$3(window, "touchmove", function(ct) {
      return ct.preventDefault();
    }, {
      passive: !1
    })), function() {
      var ct;
      (ct = mt) === null || ct === void 0 || ct.remove();
    };
  }, [$, s]), {
    isTouching: it,
    onTouchStart: dt,
    onTouchMove: gt,
    onTouchEnd: pt
  };
}
var Operations = function a(s) {
  var $ = s.visible, _ = s.maskTransitionName, _e = s.getContainer, tt = s.prefixCls, nt = s.rootClassName, at = s.icons, ot = s.countRender, rt = s.showSwitch, st = s.showProgress, lt = s.current, et = s.transform, it = s.count, ut = s.scale, ft = s.minScale, ht = s.maxScale, dt = s.closeIcon, gt = s.onSwitchLeft, pt = s.onSwitchRight, mt = s.onClose, ct = s.onZoomIn, vt = s.onZoomOut, At = s.onRotateRight, xt = s.onRotateLeft, bt = s.onFlipX, Et = s.onFlipY, St = s.toolbarRender, Bt = s.zIndex, Ot = reactExports.useContext(PreviewGroupContext), Pt = at.rotateLeft, wt = at.rotateRight, Ct = at.zoomIn, It = at.zoomOut, yt = at.close, Rt = at.left, kt = at.right, jt = at.flipX, Ht = at.flipY, Ft = "".concat(tt, "-operations-operation");
  reactExports.useEffect(function() {
    var Lt = function(Tt) {
      Tt.keyCode === KeyCode.ESC && mt();
    };
    return $ && window.addEventListener("keydown", Lt), function() {
      window.removeEventListener("keydown", Lt);
    };
  }, [$]);
  var _t = [{
    icon: Ht,
    onClick: Et,
    type: "flipY"
  }, {
    icon: jt,
    onClick: bt,
    type: "flipX"
  }, {
    icon: Pt,
    onClick: xt,
    type: "rotateLeft"
  }, {
    icon: wt,
    onClick: At,
    type: "rotateRight"
  }, {
    icon: It,
    onClick: vt,
    type: "zoomOut",
    disabled: ut <= ft
  }, {
    icon: Ct,
    onClick: ct,
    type: "zoomIn",
    disabled: ut === ht
  }], Nt = _t.map(function(Lt) {
    var $t, Tt = Lt.icon, Dt = Lt.onClick, Ut = Lt.type, Vt = Lt.disabled;
    return /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames(Ft, ($t = {}, _defineProperty$c($t, "".concat(tt, "-operations-operation-").concat(Ut), !0), _defineProperty$c($t, "".concat(tt, "-operations-operation-disabled"), !!Vt), $t)),
      onClick: Dt,
      key: Ut
    }, Tt);
  }), Mt = /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(tt, "-operations")
  }, Nt);
  return /* @__PURE__ */ reactExports.createElement(CSSMotion, {
    visible: $,
    motionName: _
  }, function(Lt) {
    var $t = Lt.className, Tt = Lt.style;
    return /* @__PURE__ */ reactExports.createElement(Portal, {
      open: !0,
      getContainer: _e ?? document.body
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames("".concat(tt, "-operations-wrapper"), $t, nt),
      style: _objectSpread2$a(_objectSpread2$a({}, Tt), {}, {
        zIndex: Bt
      })
    }, dt === null ? null : /* @__PURE__ */ reactExports.createElement("button", {
      className: "".concat(tt, "-close"),
      onClick: mt
    }, dt || yt), rt && /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames("".concat(tt, "-switch-left"), _defineProperty$c({}, "".concat(tt, "-switch-left-disabled"), lt === 0)),
      onClick: gt
    }, Rt), /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames("".concat(tt, "-switch-right"), _defineProperty$c({}, "".concat(tt, "-switch-right-disabled"), lt === it - 1)),
      onClick: pt
    }, kt)), /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(tt, "-footer")
    }, st && /* @__PURE__ */ reactExports.createElement("div", {
      className: "".concat(tt, "-progress")
    }, ot ? ot(lt + 1, it) : "".concat(lt + 1, " / ").concat(it)), St ? St(Mt, _objectSpread2$a({
      icons: {
        flipYIcon: Nt[0],
        flipXIcon: Nt[1],
        rotateLeftIcon: Nt[2],
        rotateRightIcon: Nt[3],
        zoomOutIcon: Nt[4],
        zoomInIcon: Nt[5]
      },
      actions: {
        onFlipY: Et,
        onFlipX: bt,
        onRotateLeft: xt,
        onRotateRight: At,
        onZoomOut: vt,
        onZoomIn: ct
      },
      transform: et
    }, Ot ? {
      current: lt,
      total: it
    } : {})) : Mt)));
  });
}, _excluded$k = ["fallback", "src", "imgRef"], _excluded2$4 = ["prefixCls", "src", "alt", "fallback", "movable", "onClose", "visible", "icons", "rootClassName", "closeIcon", "getContainer", "current", "count", "countRender", "scaleStep", "minScale", "maxScale", "transitionName", "maskTransitionName", "imageRender", "imgCommonProps", "toolbarRender", "onTransform", "onChange"], PreviewImage = function a(s) {
  var $ = s.fallback, _ = s.src, _e = s.imgRef, tt = _objectWithoutProperties$1(s, _excluded$k), nt = useStatus({
    src: _,
    fallback: $
  }), at = _slicedToArray$e(nt, 2), ot = at[0], rt = at[1];
  return /* @__PURE__ */ React$a.createElement("img", _extends$2({
    ref: function(lt) {
      _e.current = lt, ot(lt);
    }
  }, tt, rt));
}, Preview$3 = function a(s) {
  var $ = s.prefixCls, _ = s.src, _e = s.alt, tt = s.fallback, nt = s.movable, at = nt === void 0 ? !0 : nt, ot = s.onClose, rt = s.visible, st = s.icons, lt = st === void 0 ? {} : st, et = s.rootClassName, it = s.closeIcon, ut = s.getContainer, ft = s.current, ht = ft === void 0 ? 0 : ft, dt = s.count, gt = dt === void 0 ? 1 : dt, pt = s.countRender, mt = s.scaleStep, ct = mt === void 0 ? 0.5 : mt, vt = s.minScale, At = vt === void 0 ? 1 : vt, xt = s.maxScale, bt = xt === void 0 ? 50 : xt, Et = s.transitionName, St = Et === void 0 ? "zoom" : Et, Bt = s.maskTransitionName, Ot = Bt === void 0 ? "fade" : Bt, Pt = s.imageRender, wt = s.imgCommonProps, Ct = s.toolbarRender, It = s.onTransform, yt = s.onChange, Rt = _objectWithoutProperties$1(s, _excluded2$4), kt = reactExports.useRef(), jt = reactExports.useContext(PreviewGroupContext), Ht = jt && gt > 1, Ft = jt && gt >= 1, _t = reactExports.useState(!0), Nt = _slicedToArray$e(_t, 2), Mt = Nt[0], Lt = Nt[1], $t = useImageTransform(kt, At, bt, It), Tt = $t.transform, Dt = $t.resetTransform, Ut = $t.updateTransform, Vt = $t.dispatchZoomChange, Qt = useMouseEvent(kt, at, rt, ct, Tt, Ut, Vt), qt = Qt.isMoving, Zt = Qt.onMouseDown, ar = Qt.onWheel, Jt = useTouchEvent(kt, at, rt, At, Tt, Ut, Vt), rr = Jt.isTouching, Yt = Jt.onTouchStart, Kt = Jt.onTouchMove, nr = Jt.onTouchEnd, tr = Tt.rotate, ir = Tt.scale, sr = classnames(_defineProperty$c({}, "".concat($, "-moving"), qt));
  reactExports.useEffect(function() {
    Mt || Lt(!0);
  }, [Mt]);
  var cr = function() {
    Dt("close");
  }, or = function() {
    Vt(BASE_SCALE_RATIO + ct, "zoomIn");
  }, Xt = function() {
    Vt(BASE_SCALE_RATIO / (BASE_SCALE_RATIO + ct), "zoomOut");
  }, Gt = function() {
    Ut({
      rotate: tr + 90
    }, "rotateRight");
  }, Wt = function() {
    Ut({
      rotate: tr - 90
    }, "rotateLeft");
  }, er = function() {
    Ut({
      flipX: !Tt.flipX
    }, "flipX");
  }, lr = function() {
    Ut({
      flipY: !Tt.flipY
    }, "flipY");
  }, ur = function(Ar) {
    Ar == null || Ar.preventDefault(), Ar == null || Ar.stopPropagation(), ht > 0 && (Lt(!1), Dt("prev"), yt == null || yt(ht - 1, ht));
  }, pr = function(Ar) {
    Ar == null || Ar.preventDefault(), Ar == null || Ar.stopPropagation(), ht < gt - 1 && (Lt(!1), Dt("next"), yt == null || yt(ht + 1, ht));
  }, yr = function(Ar) {
    !rt || !Ht || (Ar.keyCode === KeyCode.LEFT ? ur() : Ar.keyCode === KeyCode.RIGHT && pr());
  }, Er = function(Ar) {
    rt && (ir !== 1 ? Ut({
      x: 0,
      y: 0,
      scale: 1
    }, "doubleClick") : Vt(BASE_SCALE_RATIO + ct, "doubleClick", Ar.clientX, Ar.clientY));
  };
  reactExports.useEffect(function() {
    var gr = addEventListenerWrap$3(window, "keydown", yr, !1);
    return function() {
      gr.remove();
    };
  }, [rt, Ht, ht]);
  var br = /* @__PURE__ */ React$a.createElement(PreviewImage, _extends$2({}, wt, {
    width: s.width,
    height: s.height,
    imgRef: kt,
    className: "".concat($, "-img"),
    alt: _e,
    style: {
      transform: "translate3d(".concat(Tt.x, "px, ").concat(Tt.y, "px, 0) scale3d(").concat(Tt.flipX ? "-" : "").concat(ir, ", ").concat(Tt.flipY ? "-" : "").concat(ir, ", 1) rotate(").concat(tr, "deg)"),
      transitionDuration: (!Mt || rr) && "0s"
    },
    fallback: tt,
    src: _,
    onWheel: ar,
    onMouseDown: Zt,
    onDoubleClick: Er,
    onTouchStart: Yt,
    onTouchMove: Kt,
    onTouchEnd: nr,
    onTouchCancel: nr
  }));
  return /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(DialogWrap, _extends$2({
    transitionName: St,
    maskTransitionName: Ot,
    closable: !1,
    keyboard: !0,
    prefixCls: $,
    onClose: ot,
    visible: rt,
    classNames: {
      wrapper: sr
    },
    rootClassName: et,
    getContainer: ut
  }, Rt, {
    afterClose: cr
  }), /* @__PURE__ */ React$a.createElement("div", {
    className: "".concat($, "-img-wrapper")
  }, Pt ? Pt(br, _objectSpread2$a({
    transform: Tt
  }, jt ? {
    current: ht
  } : {})) : br)), /* @__PURE__ */ React$a.createElement(Operations, {
    visible: rt,
    transform: Tt,
    maskTransitionName: Ot,
    closeIcon: it,
    getContainer: ut,
    prefixCls: $,
    rootClassName: et,
    icons: lt,
    countRender: pt,
    showSwitch: Ht,
    showProgress: Ft,
    current: ht,
    count: gt,
    scale: ir,
    minScale: At,
    maxScale: bt,
    toolbarRender: Ct,
    onSwitchLeft: ur,
    onSwitchRight: pr,
    onZoomIn: or,
    onZoomOut: Xt,
    onRotateRight: Gt,
    onRotateLeft: Wt,
    onFlipX: er,
    onFlipY: lr,
    onClose: ot,
    zIndex: Rt.zIndex !== void 0 ? Rt.zIndex + 1 : void 0
  }));
};
function usePreviewItems(a) {
  var s = reactExports.useState({}), $ = _slicedToArray$e(s, 2), _ = $[0], _e = $[1], tt = reactExports.useCallback(function(at, ot) {
    return _e(function(rt) {
      return _objectSpread2$a(_objectSpread2$a({}, rt), {}, _defineProperty$c({}, at, ot));
    }), function() {
      _e(function(rt) {
        var st = _objectSpread2$a({}, rt);
        return delete st[at], st;
      });
    };
  }, []), nt = reactExports.useMemo(function() {
    return a ? a.map(function(at) {
      if (typeof at == "string")
        return {
          data: {
            src: at
          }
        };
      var ot = {};
      return Object.keys(at).forEach(function(rt) {
        ["src"].concat(_toConsumableArray$d(COMMON_PROPS)).includes(rt) && (ot[rt] = at[rt]);
      }), {
        data: ot
      };
    }) : Object.keys(_).reduce(function(at, ot) {
      var rt = _[ot], st = rt.canPreview, lt = rt.data;
      return st && at.push({
        data: lt,
        id: ot
      }), at;
    }, []);
  }, [a, _]);
  return [nt, tt];
}
var _excluded$j = ["visible", "onVisibleChange", "getContainer", "current", "movable", "minScale", "maxScale", "countRender", "closeIcon", "onChange", "onTransform", "toolbarRender", "imageRender"], _excluded2$3 = ["src"], Group = function a(s) {
  var $, _ = s.previewPrefixCls, _e = _ === void 0 ? "rc-image-preview" : _, tt = s.children, nt = s.icons, at = nt === void 0 ? {} : nt, ot = s.items, rt = s.preview, st = s.fallback, lt = _typeof$q(rt) === "object" ? rt : {}, et = lt.visible, it = lt.onVisibleChange, ut = lt.getContainer, ft = lt.current, ht = lt.movable, dt = lt.minScale, gt = lt.maxScale, pt = lt.countRender, mt = lt.closeIcon, ct = lt.onChange, vt = lt.onTransform, At = lt.toolbarRender, xt = lt.imageRender, bt = _objectWithoutProperties$1(lt, _excluded$j), Et = usePreviewItems(ot), St = _slicedToArray$e(Et, 2), Bt = St[0], Ot = St[1], Pt = useMergedState(0, {
    value: ft
  }), wt = _slicedToArray$e(Pt, 2), Ct = wt[0], It = wt[1], yt = reactExports.useState(!1), Rt = _slicedToArray$e(yt, 2), kt = Rt[0], jt = Rt[1], Ht = (($ = Bt[Ct]) === null || $ === void 0 ? void 0 : $.data) || {}, Ft = Ht.src, _t = _objectWithoutProperties$1(Ht, _excluded2$3), Nt = useMergedState(!!et, {
    value: et,
    onChange: function(rr, Yt) {
      it == null || it(rr, Yt, Ct);
    }
  }), Mt = _slicedToArray$e(Nt, 2), Lt = Mt[0], $t = Mt[1], Tt = reactExports.useState(null), Dt = _slicedToArray$e(Tt, 2), Ut = Dt[0], Vt = Dt[1], Qt = reactExports.useCallback(function(Jt, rr, Yt) {
    var Kt = Bt.findIndex(function(nr) {
      return nr.id === Jt;
    });
    $t(!0), Vt({
      x: rr,
      y: Yt
    }), It(Kt < 0 ? 0 : Kt), jt(!0);
  }, [Bt]);
  reactExports.useEffect(function() {
    Lt ? kt || It(0) : jt(!1);
  }, [Lt]);
  var qt = function(rr, Yt) {
    It(rr), ct == null || ct(rr, Yt);
  }, Zt = function() {
    $t(!1), Vt(null);
  }, ar = reactExports.useMemo(function() {
    return {
      register: Ot,
      onPreview: Qt
    };
  }, [Ot, Qt]);
  return /* @__PURE__ */ reactExports.createElement(PreviewGroupContext.Provider, {
    value: ar
  }, tt, /* @__PURE__ */ reactExports.createElement(Preview$3, _extends$2({
    "aria-hidden": !Lt,
    movable: ht,
    visible: Lt,
    prefixCls: _e,
    closeIcon: mt,
    onClose: Zt,
    mousePosition: Ut,
    imgCommonProps: _t,
    src: Ft,
    fallback: st,
    icons: at,
    minScale: dt,
    maxScale: gt,
    getContainer: ut,
    current: Ct,
    count: Bt.length,
    countRender: pt,
    onTransform: vt,
    toolbarRender: At,
    imageRender: xt,
    onChange: qt
  }, bt)));
}, _excluded$i = ["src", "alt", "onPreviewClose", "prefixCls", "previewPrefixCls", "placeholder", "fallback", "width", "height", "style", "preview", "className", "onClick", "onError", "wrapperClassName", "wrapperStyle", "rootClassName"], _excluded2$2 = ["src", "visible", "onVisibleChange", "getContainer", "mask", "maskClassName", "movable", "icons", "scaleStep", "minScale", "maxScale", "imageRender", "toolbarRender"], ImageInternal = function a(s) {
  var $ = s.src, _ = s.alt, _e = s.onPreviewClose, tt = s.prefixCls, nt = tt === void 0 ? "rc-image" : tt, at = s.previewPrefixCls, ot = at === void 0 ? "".concat(nt, "-preview") : at, rt = s.placeholder, st = s.fallback, lt = s.width, et = s.height, it = s.style, ut = s.preview, ft = ut === void 0 ? !0 : ut, ht = s.className, dt = s.onClick, gt = s.onError, pt = s.wrapperClassName, mt = s.wrapperStyle, ct = s.rootClassName, vt = _objectWithoutProperties$1(s, _excluded$i), At = rt && rt !== !0, xt = _typeof$q(ft) === "object" ? ft : {}, bt = xt.src, Et = xt.visible, St = Et === void 0 ? void 0 : Et, Bt = xt.onVisibleChange, Ot = Bt === void 0 ? _e : Bt, Pt = xt.getContainer, wt = Pt === void 0 ? void 0 : Pt, Ct = xt.mask, It = xt.maskClassName, yt = xt.movable, Rt = xt.icons, kt = xt.scaleStep, jt = xt.minScale, Ht = xt.maxScale, Ft = xt.imageRender, _t = xt.toolbarRender, Nt = _objectWithoutProperties$1(xt, _excluded2$2), Mt = bt ?? $, Lt = useMergedState(!!St, {
    value: St,
    onChange: Ot
  }), $t = _slicedToArray$e(Lt, 2), Tt = $t[0], Dt = $t[1], Ut = useStatus({
    src: $,
    isCustomPlaceholder: At,
    fallback: st
  }), Vt = _slicedToArray$e(Ut, 3), Qt = Vt[0], qt = Vt[1], Zt = Vt[2], ar = reactExports.useState(null), Jt = _slicedToArray$e(ar, 2), rr = Jt[0], Yt = Jt[1], Kt = reactExports.useContext(PreviewGroupContext), nr = !!ft, tr = function() {
    Dt(!1), Yt(null);
  }, ir = classnames(nt, pt, ct, _defineProperty$c({}, "".concat(nt, "-error"), Zt === "error")), sr = reactExports.useMemo(function() {
    var Gt = {};
    return COMMON_PROPS.forEach(function(Wt) {
      s[Wt] !== void 0 && (Gt[Wt] = s[Wt]);
    }), Gt;
  }, COMMON_PROPS.map(function(Gt) {
    return s[Gt];
  })), cr = reactExports.useMemo(function() {
    return _objectSpread2$a(_objectSpread2$a({}, sr), {}, {
      src: Mt
    });
  }, [Mt, sr]), or = useRegisterImage(nr, cr), Xt = function(Wt) {
    var er = getOffset$2(Wt.target), lr = er.left, ur = er.top;
    Kt ? Kt.onPreview(or, lr, ur) : (Yt({
      x: lr,
      y: ur
    }), Dt(!0)), dt == null || dt(Wt);
  };
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("div", _extends$2({}, vt, {
    className: ir,
    onClick: nr ? Xt : dt,
    style: _objectSpread2$a({
      width: lt,
      height: et
    }, mt)
  }), /* @__PURE__ */ reactExports.createElement("img", _extends$2({}, sr, {
    className: classnames("".concat(nt, "-img"), _defineProperty$c({}, "".concat(nt, "-img-placeholder"), rt === !0), ht),
    style: _objectSpread2$a({
      height: et
    }, it),
    ref: Qt
  }, qt, {
    width: lt,
    height: et,
    onError: gt
  })), Zt === "loading" && /* @__PURE__ */ reactExports.createElement("div", {
    "aria-hidden": "true",
    className: "".concat(nt, "-placeholder")
  }, rt), Ct && nr && /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(nt, "-mask"), It),
    style: {
      display: (it == null ? void 0 : it.display) === "none" ? "none" : void 0
    }
  }, Ct)), !Kt && nr && /* @__PURE__ */ reactExports.createElement(Preview$3, _extends$2({
    "aria-hidden": !Tt,
    visible: Tt,
    prefixCls: ot,
    onClose: tr,
    mousePosition: rr,
    src: Mt,
    alt: _,
    fallback: st,
    getContainer: wt,
    icons: Rt,
    movable: yt,
    scaleStep: kt,
    minScale: jt,
    maxScale: Ht,
    rootClassName: ct,
    imageRender: Ft,
    imgCommonProps: sr,
    toolbarRender: _t
  }, Nt)));
};
ImageInternal.PreviewGroup = Group;
ImageInternal.displayName = "Image";
var RotateLeftOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "defs", attrs: {}, children: [{ tag: "style", attrs: {} }] }, { tag: "path", attrs: { d: "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" } }, { tag: "path", attrs: { d: "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" } }] }, name: "rotate-left", theme: "outlined" };
const RotateLeftOutlinedSvg = RotateLeftOutlined$2;
var RotateLeftOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: RotateLeftOutlinedSvg
  }));
};
const RotateLeftOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(RotateLeftOutlined);
var RotateRightOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "defs", attrs: {}, children: [{ tag: "style", attrs: {} }] }, { tag: "path", attrs: { d: "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" } }, { tag: "path", attrs: { d: "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" } }] }, name: "rotate-right", theme: "outlined" };
const RotateRightOutlinedSvg = RotateRightOutlined$2;
var RotateRightOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: RotateRightOutlinedSvg
  }));
};
const RotateRightOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(RotateRightOutlined);
var SwapOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, name: "swap", theme: "outlined" };
const SwapOutlinedSvg = SwapOutlined$2;
var SwapOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: SwapOutlinedSvg
  }));
};
const SwapOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(SwapOutlined);
var ZoomInOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, name: "zoom-in", theme: "outlined" };
const ZoomInOutlinedSvg = ZoomInOutlined$2;
var ZoomInOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: ZoomInOutlinedSvg
  }));
};
const ZoomInOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(ZoomInOutlined);
var ZoomOutOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" } }] }, name: "zoom-out", theme: "outlined" };
const ZoomOutOutlinedSvg = ZoomOutOutlined$2;
var ZoomOutOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: ZoomOutOutlinedSvg
  }));
};
const ZoomOutOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(ZoomOutOutlined), genBoxStyle = (a) => ({
  position: a || "absolute",
  inset: 0
}), genImageMaskStyle = (a) => {
  const {
    iconCls: s,
    motionDurationSlow: $,
    paddingXXS: _,
    marginXXS: _e,
    prefixCls: tt,
    colorTextLightSolid: nt
  } = a;
  return {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: nt,
    background: new TinyColor("#000").setAlpha(0.5).toRgbString(),
    cursor: "pointer",
    opacity: 0,
    transition: `opacity ${$}`,
    [`.${tt}-mask-info`]: Object.assign(Object.assign({}, textEllipsis), {
      padding: `0 ${unit$1(_)}`,
      [s]: {
        marginInlineEnd: _e,
        svg: {
          verticalAlign: "baseline"
        }
      }
    })
  };
}, genPreviewOperationsStyle = (a) => {
  const {
    previewCls: s,
    modalMaskBg: $,
    paddingSM: _,
    marginXL: _e,
    margin: tt,
    paddingLG: nt,
    previewOperationColorDisabled: at,
    previewOperationHoverColor: ot,
    motionDurationSlow: rt,
    iconCls: st,
    colorTextLightSolid: lt
  } = a, et = new TinyColor($).setAlpha(0.1), it = et.clone().setAlpha(0.2);
  return {
    [`${s}-footer`]: {
      position: "fixed",
      bottom: _e,
      left: {
        _skip_check_: !0,
        value: 0
      },
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: a.previewOperationColor
    },
    [`${s}-progress`]: {
      marginBottom: tt
    },
    [`${s}-close`]: {
      position: "fixed",
      top: _e,
      right: {
        _skip_check_: !0,
        value: _e
      },
      display: "flex",
      color: lt,
      backgroundColor: et.toRgbString(),
      borderRadius: "50%",
      padding: _,
      outline: 0,
      border: 0,
      cursor: "pointer",
      transition: `all ${rt}`,
      "&:hover": {
        backgroundColor: it.toRgbString()
      },
      [`& > ${st}`]: {
        fontSize: a.previewOperationSize
      }
    },
    [`${s}-operations`]: {
      display: "flex",
      alignItems: "center",
      padding: `0 ${unit$1(nt)}`,
      backgroundColor: et.toRgbString(),
      borderRadius: 100,
      "&-operation": {
        marginInlineStart: _,
        padding: _,
        cursor: "pointer",
        transition: `all ${rt}`,
        userSelect: "none",
        [`&:not(${s}-operations-operation-disabled):hover > ${st}`]: {
          color: ot
        },
        "&-disabled": {
          color: at,
          cursor: "not-allowed"
        },
        "&:first-of-type": {
          marginInlineStart: 0
        },
        [`& > ${st}`]: {
          fontSize: a.previewOperationSize
        }
      }
    }
  };
}, genPreviewSwitchStyle = (a) => {
  const {
    modalMaskBg: s,
    iconCls: $,
    previewOperationColorDisabled: _,
    previewCls: _e,
    zIndexPopup: tt,
    motionDurationSlow: nt
  } = a, at = new TinyColor(s).setAlpha(0.1), ot = at.clone().setAlpha(0.2);
  return {
    [`${_e}-switch-left, ${_e}-switch-right`]: {
      position: "fixed",
      insetBlockStart: "50%",
      zIndex: a.calc(tt).add(1).equal({
        unit: !1
      }),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: a.imagePreviewSwitchSize,
      height: a.imagePreviewSwitchSize,
      marginTop: a.calc(a.imagePreviewSwitchSize).mul(-1).div(2).equal(),
      color: a.previewOperationColor,
      background: at.toRgbString(),
      borderRadius: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      transition: `all ${nt}`,
      userSelect: "none",
      "&:hover": {
        background: ot.toRgbString()
      },
      "&-disabled": {
        "&, &:hover": {
          color: _,
          background: "transparent",
          cursor: "not-allowed",
          [`> ${$}`]: {
            cursor: "not-allowed"
          }
        }
      },
      [`> ${$}`]: {
        fontSize: a.previewOperationSize
      }
    },
    [`${_e}-switch-left`]: {
      insetInlineStart: a.marginSM
    },
    [`${_e}-switch-right`]: {
      insetInlineEnd: a.marginSM
    }
  };
}, genImagePreviewStyle = (a) => {
  const {
    motionEaseOut: s,
    previewCls: $,
    motionDurationSlow: _,
    componentCls: _e
  } = a;
  return [
    {
      [`${_e}-preview-root`]: {
        [$]: {
          height: "100%",
          textAlign: "center",
          pointerEvents: "none"
        },
        [`${$}-body`]: Object.assign(Object.assign({}, genBoxStyle()), {
          overflow: "hidden"
        }),
        [`${$}-img`]: {
          maxWidth: "100%",
          maxHeight: "70%",
          verticalAlign: "middle",
          transform: "scale3d(1, 1, 1)",
          cursor: "grab",
          transition: `transform ${_} ${s} 0s`,
          userSelect: "none",
          "&-wrapper": Object.assign(Object.assign({}, genBoxStyle()), {
            transition: `transform ${_} ${s} 0s`,
            // https://github.com/ant-design/ant-design/issues/39913
            // TailwindCSS will reset img default style.
            // Let's set back.
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& > *": {
              pointerEvents: "auto"
            },
            "&::before": {
              display: "inline-block",
              width: 1,
              height: "50%",
              marginInlineEnd: -1,
              content: '""'
            }
          })
        },
        [`${$}-moving`]: {
          [`${$}-preview-img`]: {
            cursor: "grabbing",
            "&-wrapper": {
              transitionDuration: "0s"
            }
          }
        }
      }
    },
    // Override
    {
      [`${_e}-preview-root`]: {
        [`${$}-wrap`]: {
          zIndex: a.zIndexPopup
        }
      }
    },
    // Preview operations & switch
    {
      [`${_e}-preview-operations-wrapper`]: {
        position: "fixed",
        zIndex: a.calc(a.zIndexPopup).add(1).equal({
          unit: !1
        })
      },
      "&": [genPreviewOperationsStyle(a), genPreviewSwitchStyle(a)]
    }
  ];
}, genImageStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    // ============================== image ==============================
    [s]: {
      position: "relative",
      display: "inline-block",
      [`${s}-img`]: {
        width: "100%",
        height: "auto",
        verticalAlign: "middle"
      },
      [`${s}-img-placeholder`]: {
        backgroundColor: a.colorBgContainerDisabled,
        backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "30%"
      },
      [`${s}-mask`]: Object.assign({}, genImageMaskStyle(a)),
      [`${s}-mask:hover`]: {
        opacity: 1
      },
      [`${s}-placeholder`]: Object.assign({}, genBoxStyle())
    }
  };
}, genPreviewMotion = (a) => {
  const {
    previewCls: s
  } = a;
  return {
    [`${s}-root`]: initZoomMotion(a, "zoom"),
    "&": initFadeMotion(a, !0)
  };
}, prepareComponentToken$c = (a) => ({
  zIndexPopup: a.zIndexPopupBase + 80,
  previewOperationColor: new TinyColor(a.colorTextLightSolid).setAlpha(0.65).toRgbString(),
  previewOperationHoverColor: new TinyColor(a.colorTextLightSolid).setAlpha(0.85).toRgbString(),
  previewOperationColorDisabled: new TinyColor(a.colorTextLightSolid).setAlpha(0.25).toRgbString(),
  previewOperationSize: a.fontSizeIcon * 1.5
  // FIXME: fontSizeIconLG
}), useStyle$c = genStyleHooks("Image", (a) => {
  const s = `${a.componentCls}-preview`, $ = merge(a, {
    previewCls: s,
    modalMaskBg: new TinyColor("#000").setAlpha(0.45).toRgbString(),
    // FIXME: Shared Token
    imagePreviewSwitchSize: a.controlHeightLG
  });
  return [genImageStyle($), genImagePreviewStyle($), genModalMaskStyle(merge($, {
    componentCls: s
  })), genPreviewMotion($)];
}, prepareComponentToken$c);
var __rest$o = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const icons$1 = {
  rotateLeft: /* @__PURE__ */ reactExports.createElement(RotateLeftOutlined$1, null),
  rotateRight: /* @__PURE__ */ reactExports.createElement(RotateRightOutlined$1, null),
  zoomIn: /* @__PURE__ */ reactExports.createElement(ZoomInOutlined$1, null),
  zoomOut: /* @__PURE__ */ reactExports.createElement(ZoomOutOutlined$1, null),
  close: /* @__PURE__ */ reactExports.createElement(CloseOutlined$4, null),
  left: /* @__PURE__ */ reactExports.createElement(LeftOutlined$1, null),
  right: /* @__PURE__ */ reactExports.createElement(RightOutlined$1, null),
  flipX: /* @__PURE__ */ reactExports.createElement(SwapOutlined$1, null),
  flipY: /* @__PURE__ */ reactExports.createElement(SwapOutlined$1, {
    rotate: 90
  })
}, InternalPreviewGroup = (a) => {
  var {
    previewPrefixCls: s,
    preview: $
  } = a, _ = __rest$o(a, ["previewPrefixCls", "preview"]);
  const {
    getPrefixCls: _e
  } = reactExports.useContext(ConfigContext$1), tt = _e("image", s), nt = `${tt}-preview`, at = _e(), ot = useCSSVarCls$1(tt), [rt, st, lt] = useStyle$c(tt, ot), [et] = useZIndex("ImagePreview", typeof $ == "object" ? $.zIndex : void 0), it = reactExports.useMemo(() => {
    var ut;
    if ($ === !1)
      return $;
    const ft = typeof $ == "object" ? $ : {}, ht = classnames(st, lt, ot, (ut = ft.rootClassName) !== null && ut !== void 0 ? ut : "");
    return Object.assign(Object.assign({}, ft), {
      transitionName: getTransitionName$1(at, "zoom", ft.transitionName),
      maskTransitionName: getTransitionName$1(at, "fade", ft.maskTransitionName),
      rootClassName: ht,
      zIndex: et
    });
  }, [$]);
  return rt(/* @__PURE__ */ reactExports.createElement(ImageInternal.PreviewGroup, Object.assign({
    preview: it,
    previewPrefixCls: nt,
    icons: icons$1
  }, _)));
}, PreviewGroup = InternalPreviewGroup;
var __rest$n = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Image$1 = (a) => {
  const {
    prefixCls: s,
    preview: $,
    className: _,
    rootClassName: _e,
    style: tt
  } = a, nt = __rest$n(a, ["prefixCls", "preview", "className", "rootClassName", "style"]), {
    getPrefixCls: at,
    locale: ot = defaultLocale,
    getPopupContainer: rt,
    image: st
  } = reactExports.useContext(ConfigContext$1), lt = at("image", s), et = at(), it = ot.Image || defaultLocale.Image, ut = useCSSVarCls$1(lt), [ft, ht, dt] = useStyle$c(lt, ut), gt = classnames(_e, ht, dt, ut), pt = classnames(_, ht, st == null ? void 0 : st.className), [mt] = useZIndex("ImagePreview", typeof $ == "object" ? $.zIndex : void 0), ct = reactExports.useMemo(() => {
    if ($ === !1)
      return $;
    const At = typeof $ == "object" ? $ : {}, {
      getContainer: xt
    } = At, bt = __rest$n(At, ["getContainer"]);
    return Object.assign(Object.assign({
      mask: /* @__PURE__ */ reactExports.createElement("div", {
        className: `${lt}-mask-info`
      }, /* @__PURE__ */ reactExports.createElement(EyeOutlined$1, null), it == null ? void 0 : it.preview),
      icons: icons$1
    }, bt), {
      getContainer: xt || rt,
      transitionName: getTransitionName$1(et, "zoom", At.transitionName),
      maskTransitionName: getTransitionName$1(et, "fade", At.maskTransitionName),
      zIndex: mt
    });
  }, [$, it]), vt = Object.assign(Object.assign({}, st == null ? void 0 : st.style), tt);
  return ft(/* @__PURE__ */ reactExports.createElement(ImageInternal, Object.assign({
    prefixCls: lt,
    preview: ct,
    rootClassName: gt,
    className: pt,
    style: vt
  }, nt)));
};
Image$1.PreviewGroup = PreviewGroup;
const _Image = Image$1, extendsObject = function() {
  const a = Object.assign({}, arguments.length <= 0 ? void 0 : arguments[0]);
  for (let s = 1; s < arguments.length; s++) {
    const $ = s < 0 || arguments.length <= s ? void 0 : arguments[s];
    $ && Object.keys($).forEach((_) => {
      const _e = $[_];
      _e !== void 0 && (a[_] = _e);
    });
  }
  return a;
}, extendsObject$1 = extendsObject;
var DoubleLeftOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, name: "double-left", theme: "outlined" };
const DoubleLeftOutlinedSvg = DoubleLeftOutlined$2;
var DoubleLeftOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: DoubleLeftOutlinedSvg
  }));
};
const DoubleLeftOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(DoubleLeftOutlined);
var DoubleRightOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, name: "double-right", theme: "outlined" };
const DoubleRightOutlinedSvg = DoubleRightOutlined$2;
var DoubleRightOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: DoubleRightOutlinedSvg
  }));
};
const DoubleRightOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(DoubleRightOutlined);
var locale$8 = {
  // Options
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页",
  page_size: "页码"
}, defaultPageSizeOptions = ["10", "20", "50", "100"], Options = function a(s) {
  var $ = s.pageSizeOptions, _ = $ === void 0 ? defaultPageSizeOptions : $, _e = s.locale, tt = s.changeSize, nt = s.pageSize, at = s.goButton, ot = s.quickGo, rt = s.rootPrefixCls, st = s.selectComponentClass, lt = s.selectPrefixCls, et = s.disabled, it = s.buildOptionText, ut = React$a.useState(""), ft = _slicedToArray$e(ut, 2), ht = ft[0], dt = ft[1], gt = function() {
    return !ht || Number.isNaN(ht) ? void 0 : Number(ht);
  }, pt = typeof it == "function" ? it : function(Pt) {
    return "".concat(Pt, " ").concat(_e.items_per_page);
  }, mt = function(wt) {
    tt == null || tt(Number(wt));
  }, ct = function(wt) {
    dt(wt.target.value);
  }, vt = function(wt) {
    at || ht === "" || (dt(""), !(wt.relatedTarget && (wt.relatedTarget.className.indexOf("".concat(rt, "-item-link")) >= 0 || wt.relatedTarget.className.indexOf("".concat(rt, "-item")) >= 0)) && (ot == null || ot(gt())));
  }, At = function(wt) {
    ht !== "" && (wt.keyCode === KeyCode.ENTER || wt.type === "click") && (dt(""), ot == null || ot(gt()));
  }, xt = function() {
    return _.some(function(wt) {
      return wt.toString() === nt.toString();
    }) ? _ : _.concat([nt.toString()]).sort(function(wt, Ct) {
      var It = Number.isNaN(Number(wt)) ? 0 : Number(wt), yt = Number.isNaN(Number(Ct)) ? 0 : Number(Ct);
      return It - yt;
    });
  }, bt = "".concat(rt, "-options");
  if (!tt && !ot)
    return null;
  var Et = null, St = null, Bt = null;
  if (tt && st) {
    var Ot = xt().map(function(Pt, wt) {
      return /* @__PURE__ */ React$a.createElement(st.Option, {
        key: wt,
        value: Pt.toString()
      }, pt(Pt));
    });
    Et = /* @__PURE__ */ React$a.createElement(st, {
      disabled: et,
      prefixCls: lt,
      showSearch: !1,
      className: "".concat(bt, "-size-changer"),
      optionLabelProp: "children",
      popupMatchSelectWidth: !1,
      value: (nt || _[0]).toString(),
      onChange: mt,
      getPopupContainer: function(wt) {
        return wt.parentNode;
      },
      "aria-label": _e.page_size,
      defaultOpen: !1
    }, Ot);
  }
  return ot && (at && (Bt = typeof at == "boolean" ? /* @__PURE__ */ React$a.createElement("button", {
    type: "button",
    onClick: At,
    onKeyUp: At,
    disabled: et,
    className: "".concat(bt, "-quick-jumper-button")
  }, _e.jump_to_confirm) : /* @__PURE__ */ React$a.createElement("span", {
    onClick: At,
    onKeyUp: At
  }, at)), St = /* @__PURE__ */ React$a.createElement("div", {
    className: "".concat(bt, "-quick-jumper")
  }, _e.jump_to, /* @__PURE__ */ React$a.createElement("input", {
    disabled: et,
    type: "text",
    value: ht,
    onChange: ct,
    onKeyUp: At,
    onBlur: vt,
    "aria-label": _e.page
  }), _e.page, Bt)), /* @__PURE__ */ React$a.createElement("li", {
    className: bt
  }, Et, St);
}, Pager$1 = function a(s) {
  var $, _ = s.rootPrefixCls, _e = s.page, tt = s.active, nt = s.className, at = s.showTitle, ot = s.onClick, rt = s.onKeyPress, st = s.itemRender, lt = "".concat(_, "-item"), et = classnames(lt, "".concat(lt, "-").concat(_e), ($ = {}, _defineProperty$c($, "".concat(lt, "-active"), tt), _defineProperty$c($, "".concat(lt, "-disabled"), !_e), $), nt), it = function() {
    ot(_e);
  }, ut = function(dt) {
    rt(dt, ot, _e);
  }, ft = st(_e, "page", /* @__PURE__ */ React$a.createElement("a", {
    rel: "nofollow"
  }, _e));
  return ft ? /* @__PURE__ */ React$a.createElement("li", {
    title: at ? String(_e) : null,
    className: et,
    onClick: it,
    onKeyDown: ut,
    tabIndex: 0
  }, ft) : null;
}, defaultItemRender = function a(s, $, _) {
  return _;
};
function noop$3() {
}
function isInteger(a) {
  var s = Number(a);
  return typeof s == "number" && !Number.isNaN(s) && isFinite(s) && Math.floor(s) === s;
}
function calculatePage(a, s, $) {
  var _ = typeof a > "u" ? s : a;
  return Math.floor(($ - 1) / _) + 1;
}
var Pagination$2 = function a(s) {
  var $, _ = s.prefixCls, _e = _ === void 0 ? "rc-pagination" : _, tt = s.selectPrefixCls, nt = tt === void 0 ? "rc-select" : tt, at = s.className, ot = s.selectComponentClass, rt = s.current, st = s.defaultCurrent, lt = st === void 0 ? 1 : st, et = s.total, it = et === void 0 ? 0 : et, ut = s.pageSize, ft = s.defaultPageSize, ht = ft === void 0 ? 10 : ft, dt = s.onChange, gt = dt === void 0 ? noop$3 : dt, pt = s.hideOnSinglePage, mt = s.showPrevNextJumpers, ct = mt === void 0 ? !0 : mt, vt = s.showQuickJumper, At = s.showLessItems, xt = s.showTitle, bt = xt === void 0 ? !0 : xt, Et = s.onShowSizeChange, St = Et === void 0 ? noop$3 : Et, Bt = s.locale, Ot = Bt === void 0 ? locale$8 : Bt, Pt = s.style, wt = s.totalBoundaryShowSizeChanger, Ct = wt === void 0 ? 50 : wt, It = s.disabled, yt = s.simple, Rt = s.showTotal, kt = s.showSizeChanger, jt = s.pageSizeOptions, Ht = s.itemRender, Ft = Ht === void 0 ? defaultItemRender : Ht, _t = s.jumpPrevIcon, Nt = s.jumpNextIcon, Mt = s.prevIcon, Lt = s.nextIcon, $t = React$a.useRef(null), Tt = useMergedState(10, {
    value: ut,
    defaultValue: ht
  }), Dt = _slicedToArray$e(Tt, 2), Ut = Dt[0], Vt = Dt[1], Qt = useMergedState(1, {
    value: rt,
    defaultValue: lt,
    postState: function(Wr) {
      return Math.max(1, Math.min(Wr, calculatePage(void 0, Ut, it)));
    }
  }), qt = _slicedToArray$e(Qt, 2), Zt = qt[0], ar = qt[1], Jt = React$a.useState(Zt), rr = _slicedToArray$e(Jt, 2), Yt = rr[0], Kt = rr[1];
  reactExports.useEffect(function() {
    Kt(Zt);
  }, [Zt]);
  var nr = Math.max(1, Zt - (At ? 3 : 5)), tr = Math.min(calculatePage(void 0, Ut, it), Zt + (At ? 3 : 5));
  function ir(en, Wr) {
    var dn = en || /* @__PURE__ */ React$a.createElement("button", {
      type: "button",
      "aria-label": Wr,
      className: "".concat(_e, "-item-link")
    });
    return typeof en == "function" && (dn = /* @__PURE__ */ React$a.createElement(en, _objectSpread2$a({}, s))), dn;
  }
  function sr(en) {
    var Wr = en.target.value, dn = calculatePage(void 0, Ut, it), hn;
    return Wr === "" ? hn = Wr : Number.isNaN(Number(Wr)) ? hn = Yt : Wr >= dn ? hn = dn : hn = Number(Wr), hn;
  }
  function cr(en) {
    return isInteger(en) && en !== Zt && isInteger(it) && it > 0;
  }
  var or = it > Ut ? vt : !1;
  function Xt(en) {
    (en.keyCode === KeyCode.UP || en.keyCode === KeyCode.DOWN) && en.preventDefault();
  }
  function Gt(en) {
    var Wr = sr(en);
    switch (Wr !== Yt && Kt(Wr), en.keyCode) {
      case KeyCode.ENTER:
        lr(Wr);
        break;
      case KeyCode.UP:
        lr(Wr - 1);
        break;
      case KeyCode.DOWN:
        lr(Wr + 1);
        break;
    }
  }
  function Wt(en) {
    lr(sr(en));
  }
  function er(en) {
    var Wr = calculatePage(en, Ut, it), dn = Zt > Wr && Wr !== 0 ? Wr : Zt;
    Vt(en), Kt(dn), St == null || St(Zt, en), ar(dn), gt == null || gt(dn, en);
  }
  function lr(en) {
    if (cr(en) && !It) {
      var Wr = calculatePage(void 0, Ut, it), dn = en;
      return en > Wr ? dn = Wr : en < 1 && (dn = 1), dn !== Yt && Kt(dn), ar(dn), gt == null || gt(dn, Ut), dn;
    }
    return Zt;
  }
  var ur = Zt > 1, pr = Zt < calculatePage(void 0, Ut, it), yr = kt ?? it > Ct;
  function Er() {
    ur && lr(Zt - 1);
  }
  function br() {
    pr && lr(Zt + 1);
  }
  function gr() {
    lr(nr);
  }
  function Ar() {
    lr(tr);
  }
  function Sr(en, Wr) {
    if (en.key === "Enter" || en.charCode === KeyCode.ENTER || en.keyCode === KeyCode.ENTER) {
      for (var dn = arguments.length, hn = new Array(dn > 2 ? dn - 2 : 0), En = 2; En < dn; En++)
        hn[En - 2] = arguments[En];
      Wr.apply(void 0, hn);
    }
  }
  function Br(en) {
    Sr(en, Er);
  }
  function Ir(en) {
    Sr(en, br);
  }
  function hr(en) {
    Sr(en, gr);
  }
  function vr(en) {
    Sr(en, Ar);
  }
  function xr(en) {
    var Wr = Ft(en, "prev", ir(Mt, "prev page"));
    return /* @__PURE__ */ React$a.isValidElement(Wr) ? /* @__PURE__ */ React$a.cloneElement(Wr, {
      disabled: !ur
    }) : Wr;
  }
  function Pr(en) {
    var Wr = Ft(en, "next", ir(Lt, "next page"));
    return /* @__PURE__ */ React$a.isValidElement(Wr) ? /* @__PURE__ */ React$a.cloneElement(Wr, {
      disabled: !pr
    }) : Wr;
  }
  function Rr(en) {
    (en.type === "click" || en.keyCode === KeyCode.ENTER) && lr(Yt);
  }
  var Dr = null, Gr = pickAttrs(s, {
    aria: !0,
    data: !0
  }), Or = Rt && /* @__PURE__ */ React$a.createElement("li", {
    className: "".concat(_e, "-total-text")
  }, Rt(it, [it === 0 ? 0 : (Zt - 1) * Ut + 1, Zt * Ut > it ? it : Zt * Ut])), Hr = null, jr = calculatePage(void 0, Ut, it);
  if (pt && it <= Ut)
    return null;
  var Tr = [], fr = {
    rootPrefixCls: _e,
    onClick: lr,
    onKeyPress: Sr,
    showTitle: bt,
    itemRender: Ft,
    page: -1
  }, Cr = Zt - 1 > 0 ? Zt - 1 : 0, $r = Zt + 1 < jr ? Zt + 1 : jr, wr = vt && vt.goButton, Mr = wr, Fr = null;
  yt && (typeof wr == "boolean" && (Mr = /* @__PURE__ */ React$a.createElement("button", {
    type: "button",
    onClick: Rr,
    onKeyUp: Rr
  }, Ot.jump_to_confirm)), Mr = /* @__PURE__ */ React$a.createElement("li", {
    title: bt ? "".concat(Ot.jump_to).concat(Zt, "/").concat(jr) : null,
    className: "".concat(_e, "-simple-pager")
  }, Mr), Fr = /* @__PURE__ */ React$a.createElement("li", {
    title: bt ? "".concat(Zt, "/").concat(jr) : null,
    className: "".concat(_e, "-simple-pager")
  }, /* @__PURE__ */ React$a.createElement("input", {
    type: "text",
    value: Yt,
    disabled: It,
    onKeyDown: Xt,
    onKeyUp: Gt,
    onChange: Gt,
    onBlur: Wt,
    size: 3
  }), /* @__PURE__ */ React$a.createElement("span", {
    className: "".concat(_e, "-slash")
  }, "/"), jr));
  var Qr = At ? 1 : 2;
  if (jr <= 3 + Qr * 2) {
    jr || Tr.push(/* @__PURE__ */ React$a.createElement(Pager$1, _extends$2({}, fr, {
      key: "noPager",
      page: 1,
      className: "".concat(_e, "-item-disabled")
    })));
    for (var Yr = 1; Yr <= jr; Yr += 1)
      Tr.push(/* @__PURE__ */ React$a.createElement(Pager$1, _extends$2({}, fr, {
        key: Yr,
        page: Yr,
        active: Zt === Yr
      })));
  } else {
    var kr = At ? Ot.prev_3 : Ot.prev_5, Nr = At ? Ot.next_3 : Ot.next_5, Lr = Ft(nr, "jump-prev", ir(_t, "prev page")), zr = Ft(tr, "jump-next", ir(Nt, "next page"));
    ct && (Dr = Lr ? /* @__PURE__ */ React$a.createElement("li", {
      title: bt ? kr : null,
      key: "prev",
      onClick: gr,
      tabIndex: 0,
      onKeyDown: hr,
      className: classnames("".concat(_e, "-jump-prev"), _defineProperty$c({}, "".concat(_e, "-jump-prev-custom-icon"), !!_t))
    }, Lr) : null, Hr = zr ? /* @__PURE__ */ React$a.createElement("li", {
      title: bt ? Nr : null,
      key: "next",
      onClick: Ar,
      tabIndex: 0,
      onKeyDown: vr,
      className: classnames("".concat(_e, "-jump-next"), _defineProperty$c({}, "".concat(_e, "-jump-next-custom-icon"), !!Nt))
    }, zr) : null);
    var Vr = Math.max(1, Zt - Qr), an = Math.min(Zt + Qr, jr);
    Zt - 1 <= Qr && (an = 1 + Qr * 2), jr - Zt <= Qr && (Vr = jr - Qr * 2);
    for (var Zr = Vr; Zr <= an; Zr += 1)
      Tr.push(/* @__PURE__ */ React$a.createElement(Pager$1, _extends$2({}, fr, {
        key: Zr,
        page: Zr,
        active: Zt === Zr
      })));
    if (Zt - 1 >= Qr * 2 && Zt !== 3 && (Tr[0] = /* @__PURE__ */ React$a.cloneElement(Tr[0], {
      className: classnames("".concat(_e, "-item-after-jump-prev"), Tr[0].props.className)
    }), Tr.unshift(Dr)), jr - Zt >= Qr * 2 && Zt !== jr - 2) {
      var un = Tr[Tr.length - 1];
      Tr[Tr.length - 1] = /* @__PURE__ */ React$a.cloneElement(un, {
        className: classnames("".concat(_e, "-item-before-jump-next"), un.props.className)
      }), Tr.push(Hr);
    }
    Vr !== 1 && Tr.unshift(/* @__PURE__ */ React$a.createElement(Pager$1, _extends$2({}, fr, {
      key: 1,
      page: 1
    }))), an !== jr && Tr.push(/* @__PURE__ */ React$a.createElement(Pager$1, _extends$2({}, fr, {
      key: jr,
      page: jr
    })));
  }
  var Xr = xr(Cr);
  if (Xr) {
    var Kr = !ur || !jr;
    Xr = /* @__PURE__ */ React$a.createElement("li", {
      title: bt ? Ot.prev_page : null,
      onClick: Er,
      tabIndex: Kr ? null : 0,
      onKeyDown: Br,
      className: classnames("".concat(_e, "-prev"), _defineProperty$c({}, "".concat(_e, "-disabled"), Kr)),
      "aria-disabled": Kr
    }, Xr);
  }
  var rn = Pr($r);
  if (rn) {
    var nn, sn;
    yt ? (nn = !pr, sn = ur ? 0 : null) : (nn = !pr || !jr, sn = nn ? null : 0), rn = /* @__PURE__ */ React$a.createElement("li", {
      title: bt ? Ot.next_page : null,
      onClick: br,
      tabIndex: sn,
      onKeyDown: Ir,
      className: classnames("".concat(_e, "-next"), _defineProperty$c({}, "".concat(_e, "-disabled"), nn)),
      "aria-disabled": nn
    }, rn);
  }
  var gn = classnames(_e, at, ($ = {}, _defineProperty$c($, "".concat(_e, "-simple"), yt), _defineProperty$c($, "".concat(_e, "-disabled"), It), $));
  return /* @__PURE__ */ React$a.createElement("ul", _extends$2({
    className: gn,
    style: Pt,
    ref: $t
  }, Gr), Or, Xr, yt ? Fr : Tr, rn, /* @__PURE__ */ React$a.createElement(Options, {
    locale: Ot,
    rootPrefixCls: _e,
    disabled: It,
    selectComponentClass: ot,
    selectPrefixCls: nt,
    changeSize: yr ? er : null,
    pageSize: Ut,
    pageSizeOptions: jt,
    quickGo: or ? lr : null,
    goButton: Mr
  }));
};
const MiniSelect = (a) => /* @__PURE__ */ reactExports.createElement(_Select, Object.assign({}, a, {
  showSearch: !0,
  size: "small"
})), MiddleSelect = (a) => /* @__PURE__ */ reactExports.createElement(_Select, Object.assign({}, a, {
  showSearch: !0,
  size: "middle"
}));
MiniSelect.Option = _Select.Option;
MiddleSelect.Option = _Select.Option;
const genPaginationDisabledStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${s}-item-link`]: {
          color: a.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${s}-item-link`]: {
          color: a.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${s}-disabled`]: {
      cursor: "not-allowed",
      [`${s}-item`]: {
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: a.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: a.colorBorder,
          backgroundColor: a.itemActiveBgDisabled,
          "&:hover, &:active": {
            backgroundColor: a.itemActiveBgDisabled
          },
          a: {
            color: a.itemActiveColorDisabled
          }
        }
      },
      [`${s}-item-link`]: {
        color: a.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${s}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${s}-simple-pager`]: {
        color: a.colorTextDisabled
      },
      [`${s}-jump-prev, ${s}-jump-next`]: {
        [`${s}-item-link-icon`]: {
          opacity: 0
        },
        [`${s}-item-ellipsis`]: {
          opacity: 1
        }
      }
    },
    [`&${s}-simple`]: {
      [`${s}-prev, ${s}-next`]: {
        [`&${s}-disabled ${s}-item-link`]: {
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  };
}, genPaginationMiniStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`&${s}-mini ${s}-total-text, &${s}-mini ${s}-simple-pager`]: {
      height: a.itemSizeSM,
      lineHeight: unit$1(a.itemSizeSM)
    },
    [`&${s}-mini ${s}-item`]: {
      minWidth: a.itemSizeSM,
      height: a.itemSizeSM,
      margin: 0,
      lineHeight: unit$1(a.calc(a.itemSizeSM).sub(2).equal())
    },
    [`&${s}-mini:not(${s}-disabled) ${s}-item:not(${s}-item-active)`]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&:hover": {
        backgroundColor: a.colorBgTextHover
      },
      "&:active": {
        backgroundColor: a.colorBgTextActive
      }
    },
    [`&${s}-mini ${s}-prev, &${s}-mini ${s}-next`]: {
      minWidth: a.itemSizeSM,
      height: a.itemSizeSM,
      margin: 0,
      lineHeight: unit$1(a.itemSizeSM)
    },
    [`&${s}-mini:not(${s}-disabled)`]: {
      [`${s}-prev, ${s}-next`]: {
        [`&:hover ${s}-item-link`]: {
          backgroundColor: a.colorBgTextHover
        },
        [`&:active ${s}-item-link`]: {
          backgroundColor: a.colorBgTextActive
        },
        [`&${s}-disabled:hover ${s}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`
    &${s}-mini ${s}-prev ${s}-item-link,
    &${s}-mini ${s}-next ${s}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: a.itemSizeSM,
        lineHeight: unit$1(a.itemSizeSM)
      }
    },
    [`&${s}-mini ${s}-jump-prev, &${s}-mini ${s}-jump-next`]: {
      height: a.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: unit$1(a.itemSizeSM)
    },
    [`&${s}-mini ${s}-options`]: {
      marginInlineStart: a.paginationMiniOptionsMarginInlineStart,
      "&-size-changer": {
        top: a.miniOptionsSizeChangerTop
      },
      "&-quick-jumper": {
        height: a.itemSizeSM,
        lineHeight: unit$1(a.itemSizeSM),
        input: Object.assign(Object.assign({}, genInputSmallStyle(a)), {
          width: a.paginationMiniQuickJumperInputWidth,
          height: a.controlHeightSM
        })
      }
    }
  };
}, genPaginationSimpleStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`
    &${s}-simple ${s}-prev,
    &${s}-simple ${s}-next
    `]: {
      height: a.itemSizeSM,
      lineHeight: unit$1(a.itemSizeSM),
      verticalAlign: "top",
      [`${s}-item-link`]: {
        height: a.itemSizeSM,
        backgroundColor: "transparent",
        border: 0,
        "&:hover": {
          backgroundColor: a.colorBgTextHover
        },
        "&:active": {
          backgroundColor: a.colorBgTextActive
        },
        "&::after": {
          height: a.itemSizeSM,
          lineHeight: unit$1(a.itemSizeSM)
        }
      }
    },
    [`&${s}-simple ${s}-simple-pager`]: {
      display: "inline-block",
      height: a.itemSizeSM,
      marginInlineEnd: a.marginXS,
      input: {
        boxSizing: "border-box",
        height: "100%",
        marginInlineEnd: a.marginXS,
        padding: `0 ${unit$1(a.paginationItemPaddingInline)}`,
        textAlign: "center",
        backgroundColor: a.itemInputBg,
        border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
        borderRadius: a.borderRadius,
        outline: "none",
        transition: `border-color ${a.motionDurationMid}`,
        color: "inherit",
        "&:hover": {
          borderColor: a.colorPrimary
        },
        "&:focus": {
          borderColor: a.colorPrimaryHover,
          boxShadow: `${unit$1(a.inputOutlineOffset)} 0 ${unit$1(a.controlOutlineWidth)} ${a.controlOutline}`
        },
        "&[disabled]": {
          color: a.colorTextDisabled,
          backgroundColor: a.colorBgContainerDisabled,
          borderColor: a.colorBorder,
          cursor: "not-allowed"
        }
      }
    }
  };
}, genPaginationJumpStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-jump-prev, ${s}-jump-next`]: {
      outline: 0,
      [`${s}-item-container`]: {
        position: "relative",
        [`${s}-item-link-icon`]: {
          color: a.colorPrimary,
          fontSize: a.fontSizeSM,
          opacity: 0,
          transition: `all ${a.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${s}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: a.colorTextDisabled,
          fontFamily: "Arial, Helvetica, sans-serif",
          letterSpacing: a.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: a.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${a.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${s}-item-link-icon`]: {
          opacity: 1
        },
        [`${s}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${s}-prev,
    ${s}-jump-prev,
    ${s}-jump-next
    `]: {
      marginInlineEnd: a.marginXS
    },
    [`
    ${s}-prev,
    ${s}-next,
    ${s}-jump-prev,
    ${s}-jump-next
    `]: {
      display: "inline-block",
      minWidth: a.itemSize,
      height: a.itemSize,
      color: a.colorText,
      fontFamily: a.fontFamily,
      lineHeight: `${unit$1(a.itemSize)}`,
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: a.borderRadius,
      cursor: "pointer",
      transition: `all ${a.motionDurationMid}`
    },
    [`${s}-prev, ${s}-next`]: {
      fontFamily: "Arial, Helvetica, sans-serif",
      outline: 0,
      button: {
        color: a.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${s}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: a.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${unit$1(a.lineWidth)} ${a.lineType} transparent`,
        borderRadius: a.borderRadius,
        outline: "none",
        transition: `all ${a.motionDurationMid}`
      },
      [`&:hover ${s}-item-link`]: {
        backgroundColor: a.colorBgTextHover
      },
      [`&:active ${s}-item-link`]: {
        backgroundColor: a.colorBgTextActive
      },
      [`&${s}-disabled:hover`]: {
        [`${s}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${s}-slash`]: {
      marginInlineEnd: a.paginationSlashMarginInlineEnd,
      marginInlineStart: a.paginationSlashMarginInlineStart
    },
    [`${s}-options`]: {
      display: "inline-block",
      marginInlineStart: a.margin,
      verticalAlign: "middle",
      "&-size-changer.-select": {
        display: "inline-block",
        width: "auto"
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: a.controlHeight,
        marginInlineStart: a.marginXS,
        lineHeight: unit$1(a.controlHeight),
        verticalAlign: "top",
        input: Object.assign(Object.assign({}, genBasicInputStyle(a)), {
          width: a.calc(a.controlHeightLG).mul(1.25).equal(),
          height: a.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: a.marginXS,
          marginInlineEnd: a.marginXS
        })
      }
    }
  };
}, genPaginationItemStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-item`]: {
      display: "inline-block",
      minWidth: a.itemSize,
      height: a.itemSize,
      marginInlineEnd: a.marginXS,
      fontFamily: a.fontFamily,
      lineHeight: unit$1(a.calc(a.itemSize).sub(2).equal()),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: "transparent",
      border: `${unit$1(a.lineWidth)} ${a.lineType} transparent`,
      borderRadius: a.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${unit$1(a.paginationItemPaddingInline)}`,
        color: a.colorText,
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${s}-item-active)`]: {
        "&:hover": {
          transition: `all ${a.motionDurationMid}`,
          backgroundColor: a.colorBgTextHover
        },
        "&:active": {
          backgroundColor: a.colorBgTextActive
        }
      },
      "&-active": {
        fontWeight: a.fontWeightStrong,
        backgroundColor: a.itemActiveBg,
        borderColor: a.colorPrimary,
        a: {
          color: a.colorPrimary
        },
        "&:hover": {
          borderColor: a.colorPrimaryHover
        },
        "&:hover a": {
          color: a.colorPrimaryHover
        }
      }
    }
  };
}, genPaginationStyle$2 = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${s}-total-text`]: {
        display: "inline-block",
        height: a.itemSize,
        marginInlineEnd: a.marginXS,
        lineHeight: unit$1(a.calc(a.itemSize).sub(2).equal()),
        verticalAlign: "middle"
      }
    }), genPaginationItemStyle(a)), genPaginationJumpStyle(a)), genPaginationSimpleStyle(a)), genPaginationMiniStyle(a)), genPaginationDisabledStyle(a)), {
      // media query style
      [`@media only screen and (max-width: ${a.screenLG}px)`]: {
        [`${s}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${a.screenSM}px)`]: {
        [`${s}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${a.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
}, genPaginationFocusStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}:not(${s}-disabled)`]: {
      [`${s}-item`]: Object.assign({}, genFocusStyle(a)),
      [`${s}-jump-prev, ${s}-jump-next`]: {
        "&:focus-visible": Object.assign({
          [`${s}-item-link-icon`]: {
            opacity: 1
          },
          [`${s}-item-ellipsis`]: {
            opacity: 0
          }
        }, genFocusOutline(a))
      },
      [`${s}-prev, ${s}-next`]: {
        [`&:focus-visible ${s}-item-link`]: Object.assign({}, genFocusOutline(a))
      }
    }
  };
}, prepareComponentToken$b = (a) => Object.assign({
  itemBg: a.colorBgContainer,
  itemSize: a.controlHeight,
  itemSizeSM: a.controlHeightSM,
  itemActiveBg: a.colorBgContainer,
  itemLinkBg: a.colorBgContainer,
  itemActiveColorDisabled: a.colorTextDisabled,
  itemActiveBgDisabled: a.controlItemBgActiveDisabled,
  itemInputBg: a.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, initComponentToken$1(a)), prepareToken = (a) => merge(a, {
  inputOutlineOffset: 0,
  paginationMiniOptionsMarginInlineStart: a.calc(a.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: a.calc(a.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: a.calc(a.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: a.calc(a.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: a.marginXXS,
  paginationSlashMarginInlineEnd: a.marginSM,
  paginationEllipsisTextIndent: "0.13em"
  // magic for ui experience
}, initInputToken(a)), useStyle$b = genStyleHooks("Pagination", (a) => {
  const s = prepareToken(a);
  return [genPaginationStyle$2(s), genPaginationFocusStyle(s)];
}, prepareComponentToken$b), genBorderedStyle$2 = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}${s}-bordered${s}-disabled:not(${s}-mini)`]: {
      "&, &:hover": {
        [`${s}-item-link`]: {
          borderColor: a.colorBorder
        }
      },
      "&:focus-visible": {
        [`${s}-item-link`]: {
          borderColor: a.colorBorder
        }
      },
      [`${s}-item, ${s}-item-link`]: {
        backgroundColor: a.colorBgContainerDisabled,
        borderColor: a.colorBorder,
        [`&:hover:not(${s}-item-active)`]: {
          backgroundColor: a.colorBgContainerDisabled,
          borderColor: a.colorBorder,
          a: {
            color: a.colorTextDisabled
          }
        },
        [`&${s}-item-active`]: {
          backgroundColor: a.itemActiveBgDisabled
        }
      },
      [`${s}-prev, ${s}-next`]: {
        "&:hover button": {
          backgroundColor: a.colorBgContainerDisabled,
          borderColor: a.colorBorder,
          color: a.colorTextDisabled
        },
        [`${s}-item-link`]: {
          backgroundColor: a.colorBgContainerDisabled,
          borderColor: a.colorBorder
        }
      }
    },
    [`${s}${s}-bordered:not(${s}-mini)`]: {
      [`${s}-prev, ${s}-next`]: {
        "&:hover button": {
          borderColor: a.colorPrimaryHover,
          backgroundColor: a.itemBg
        },
        [`${s}-item-link`]: {
          backgroundColor: a.itemLinkBg,
          borderColor: a.colorBorder
        },
        [`&:hover ${s}-item-link`]: {
          borderColor: a.colorPrimary,
          backgroundColor: a.itemBg,
          color: a.colorPrimary
        },
        [`&${s}-disabled`]: {
          [`${s}-item-link`]: {
            borderColor: a.colorBorder,
            color: a.colorTextDisabled
          }
        }
      },
      [`${s}-item`]: {
        backgroundColor: a.itemBg,
        border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
        [`&:hover:not(${s}-item-active)`]: {
          borderColor: a.colorPrimary,
          backgroundColor: a.itemBg,
          a: {
            color: a.colorPrimary
          }
        },
        "&-active": {
          borderColor: a.colorPrimary
        }
      }
    }
  };
}, BorderedStyle = genSubStyleComponent(["Pagination", "bordered"], (a) => {
  const s = prepareToken(a);
  return [genBorderedStyle$2(s)];
}, prepareComponentToken$b);
var __rest$m = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Pagination = (a) => {
  const {
    prefixCls: s,
    selectPrefixCls: $,
    className: _,
    rootClassName: _e,
    style: tt,
    size: nt,
    locale: at,
    selectComponentClass: ot,
    responsive: rt,
    showSizeChanger: st
  } = a, lt = __rest$m(a, ["prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "selectComponentClass", "responsive", "showSizeChanger"]), {
    xs: et
  } = useBreakpoint(rt), [, it] = useToken$1(), {
    getPrefixCls: ut,
    direction: ft,
    pagination: ht = {}
  } = reactExports.useContext(ConfigContext$1), dt = ut("pagination", s), [gt, pt, mt] = useStyle$b(dt), ct = st ?? ht.showSizeChanger, vt = reactExports.useMemo(() => {
    const Pt = /* @__PURE__ */ reactExports.createElement("span", {
      className: `${dt}-item-ellipsis`
    }, "•••"), wt = /* @__PURE__ */ reactExports.createElement("button", {
      className: `${dt}-item-link`,
      type: "button",
      tabIndex: -1
    }, ft === "rtl" ? /* @__PURE__ */ reactExports.createElement(RightOutlined$1, null) : /* @__PURE__ */ reactExports.createElement(LeftOutlined$1, null)), Ct = /* @__PURE__ */ reactExports.createElement("button", {
      className: `${dt}-item-link`,
      type: "button",
      tabIndex: -1
    }, ft === "rtl" ? /* @__PURE__ */ reactExports.createElement(LeftOutlined$1, null) : /* @__PURE__ */ reactExports.createElement(RightOutlined$1, null)), It = /* @__PURE__ */ reactExports.createElement("a", {
      className: `${dt}-item-link`
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: `${dt}-item-container`
    }, ft === "rtl" ? /* @__PURE__ */ reactExports.createElement(DoubleRightOutlined$1, {
      className: `${dt}-item-link-icon`
    }) : /* @__PURE__ */ reactExports.createElement(DoubleLeftOutlined$1, {
      className: `${dt}-item-link-icon`
    }), Pt)), yt = /* @__PURE__ */ reactExports.createElement("a", {
      className: `${dt}-item-link`
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: `${dt}-item-container`
    }, ft === "rtl" ? /* @__PURE__ */ reactExports.createElement(DoubleLeftOutlined$1, {
      className: `${dt}-item-link-icon`
    }) : /* @__PURE__ */ reactExports.createElement(DoubleRightOutlined$1, {
      className: `${dt}-item-link-icon`
    }), Pt));
    return {
      prevIcon: wt,
      nextIcon: Ct,
      jumpPrevIcon: It,
      jumpNextIcon: yt
    };
  }, [ft, dt]), [At] = useLocale$1("Pagination", locale$c), xt = Object.assign(Object.assign({}, At), at), bt = useSize$1(nt), Et = bt === "small" || !!(et && !bt && rt), St = ut("select", $), Bt = classnames({
    [`${dt}-mini`]: Et,
    [`${dt}-rtl`]: ft === "rtl",
    [`${dt}-bordered`]: it.wireframe
  }, ht == null ? void 0 : ht.className, _, _e, pt, mt), Ot = Object.assign(Object.assign({}, ht == null ? void 0 : ht.style), tt);
  return gt(/* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, it.wireframe && /* @__PURE__ */ reactExports.createElement(BorderedStyle, {
    prefixCls: dt
  }), /* @__PURE__ */ reactExports.createElement(Pagination$2, Object.assign({}, vt, lt, {
    style: Ot,
    prefixCls: dt,
    selectPrefixCls: St,
    className: Bt,
    selectComponentClass: ot || (Et ? MiniSelect : MiddleSelect),
    locale: xt,
    showSizeChanger: ct
  }))));
}, Pagination$1 = Pagination, antSpinMove = new Keyframe("antSpinMove", {
  to: {
    opacity: 1
  }
}), antRotate = new Keyframe("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), genSpinStyle = (a) => {
  const {
    componentCls: s,
    calc: $
  } = a;
  return {
    [`${s}`]: Object.assign(Object.assign({}, resetComponent(a)), {
      position: "absolute",
      display: "none",
      color: a.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${a.motionDurationSlow} ${a.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "static",
        display: "inline-block",
        opacity: 1
      },
      [`${s}-text`]: {
        fontSize: a.fontSize,
        paddingTop: $($(a.dotSize).sub(a.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: a.colorBgMask,
        zIndex: a.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${a.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [`${s}-dot ${s}-dot-item`]: {
          backgroundColor: a.colorWhite
        },
        [`${s}-text`]: {
          color: a.colorTextLightSolid
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${s}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: a.contentHeight,
          [`${s}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: $(a.dotSize).mul(-1).div(2).equal()
          },
          [`${s}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${a.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${s}-show-text ${s}-dot`]: {
            marginTop: $(a.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${s}-dot`]: {
              margin: $(a.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${s}-text`]: {
              paddingTop: $($(a.dotSizeSM).sub(a.fontSize)).div(2).add(2).equal()
            },
            [`&${s}-show-text ${s}-dot`]: {
              marginTop: $(a.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${s}-dot`]: {
              margin: $(a.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${s}-text`]: {
              paddingTop: $($(a.dotSizeLG).sub(a.fontSize)).div(2).add(2).equal()
            },
            [`&${s}-show-text ${s}-dot`]: {
              marginTop: $(a.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${s}-container`]: {
          position: "relative",
          transition: `opacity ${a.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: a.colorBgContainer,
            opacity: 0,
            transition: `all ${a.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${s}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: a.spinDotDefault
      },
      // dots
      // ------------------------------
      [`${s}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: a.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: $(a.dotSize).sub($(a.marginXXS).div(2)).div(2).equal(),
          height: $(a.dotSize).sub($(a.marginXXS).div(2)).div(2).equal(),
          backgroundColor: a.colorPrimary,
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: antSpinMove,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: antRotate,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        }
      },
      // small
      [`&-sm ${s}-dot`]: {
        fontSize: a.dotSizeSM,
        i: {
          width: $($(a.dotSizeSM).sub($(a.marginXXS).div(2))).div(2).equal(),
          height: $($(a.dotSizeSM).sub($(a.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${s}-dot`]: {
        fontSize: a.dotSizeLG,
        i: {
          width: $($(a.dotSizeLG).sub(a.marginXXS)).div(2).equal(),
          height: $($(a.dotSizeLG).sub(a.marginXXS)).div(2).equal()
        }
      },
      [`&${s}-show-text ${s}-text`]: {
        display: "block"
      }
    })
  };
}, prepareComponentToken$a = (a) => {
  const {
    controlHeightLG: s,
    controlHeight: $
  } = a;
  return {
    contentHeight: 400,
    dotSize: s / 2,
    dotSizeSM: s * 0.35,
    dotSizeLG: $
  };
}, useStyle$a = genStyleHooks("Spin", (a) => {
  const s = merge(a, {
    spinDotDefault: a.colorTextDescription
  });
  return [genSpinStyle(s)];
}, prepareComponentToken$a);
var __rest$l = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
let defaultIndicator = null;
function renderIndicator(a, s) {
  const {
    indicator: $
  } = s, _ = `${a}-dot`;
  return $ === null ? null : isValidElement($) ? cloneElement($, {
    className: classnames($.props.className, _)
  }) : isValidElement(defaultIndicator) ? cloneElement(defaultIndicator, {
    className: classnames(defaultIndicator.props.className, _)
  }) : /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(_, `${a}-dot-spin`)
  }, /* @__PURE__ */ reactExports.createElement("i", {
    className: `${a}-dot-item`,
    key: 1
  }), /* @__PURE__ */ reactExports.createElement("i", {
    className: `${a}-dot-item`,
    key: 2
  }), /* @__PURE__ */ reactExports.createElement("i", {
    className: `${a}-dot-item`,
    key: 3
  }), /* @__PURE__ */ reactExports.createElement("i", {
    className: `${a}-dot-item`,
    key: 4
  }));
}
function shouldDelay(a, s) {
  return !!a && !!s && !isNaN(Number(s));
}
const Spin = (a) => {
  const {
    prefixCls: s,
    spinning: $ = !0,
    delay: _ = 0,
    className: _e,
    rootClassName: tt,
    size: nt = "default",
    tip: at,
    wrapperClassName: ot,
    style: rt,
    children: st,
    fullscreen: lt
  } = a, et = __rest$l(a, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen"]), {
    getPrefixCls: it
  } = reactExports.useContext(ConfigContext$1), ut = it("spin", s), [ft, ht, dt] = useStyle$a(ut), [gt, pt] = reactExports.useState(() => $ && !shouldDelay($, _));
  reactExports.useEffect(() => {
    if ($) {
      const Bt = debounce(_, () => {
        pt(!0);
      });
      return Bt(), () => {
        var Ot;
        (Ot = Bt == null ? void 0 : Bt.cancel) === null || Ot === void 0 || Ot.call(Bt);
      };
    }
    pt(!1);
  }, [_, $]);
  const mt = reactExports.useMemo(() => typeof st < "u" && !lt, [st, lt]), {
    direction: ct,
    spin: vt
  } = reactExports.useContext(ConfigContext$1), At = classnames(ut, vt == null ? void 0 : vt.className, {
    [`${ut}-sm`]: nt === "small",
    [`${ut}-lg`]: nt === "large",
    [`${ut}-spinning`]: gt,
    [`${ut}-show-text`]: !!at,
    [`${ut}-fullscreen`]: lt,
    [`${ut}-fullscreen-show`]: lt && gt,
    [`${ut}-rtl`]: ct === "rtl"
  }, _e, tt, ht, dt), xt = classnames(`${ut}-container`, {
    [`${ut}-blur`]: gt
  }), bt = omit(et, ["indicator"]), Et = Object.assign(Object.assign({}, vt == null ? void 0 : vt.style), rt), St = /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, bt, {
    style: Et,
    className: At,
    "aria-live": "polite",
    "aria-busy": gt
  }), renderIndicator(ut, a), at && (mt || lt) ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${ut}-text`
  }, at) : null);
  return ft(mt ? /* @__PURE__ */ reactExports.createElement("div", Object.assign({}, bt, {
    className: classnames(`${ut}-nested-loading`, ot, ht, dt)
  }), gt && /* @__PURE__ */ reactExports.createElement("div", {
    key: "loading"
  }, St), /* @__PURE__ */ reactExports.createElement("div", {
    className: xt,
    key: "container"
  }, st)) : St);
};
Spin.setDefaultIndicator = (a) => {
  defaultIndicator = a;
};
const Spin$1 = Spin;
let message = null, act = (a) => a(), taskQueue = [], defaultGlobalConfig = {};
function getGlobalContext() {
  const {
    prefixCls: a,
    getContainer: s,
    duration: $,
    rtl: _,
    maxCount: _e,
    top: tt
  } = defaultGlobalConfig, nt = a ?? globalConfig().getPrefixCls("message"), at = (s == null ? void 0 : s()) || document.body;
  return {
    prefixCls: nt,
    getContainer: () => at,
    duration: $,
    rtl: _,
    maxCount: _e,
    top: tt
  };
}
const GlobalHolder = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const [$, _] = reactExports.useState(getGlobalContext), [_e, tt] = useInternalMessage($), nt = globalConfig(), at = nt.getRootPrefixCls(), ot = nt.getIconPrefixCls(), rt = nt.getTheme(), st = () => {
    _(getGlobalContext);
  };
  return reactExports.useEffect(st, []), reactExports.useImperativeHandle(s, () => {
    const lt = Object.assign({}, _e);
    return Object.keys(lt).forEach((et) => {
      lt[et] = function() {
        return st(), _e[et].apply(_e, arguments);
      };
    }), {
      instance: lt,
      sync: st
    };
  }), /* @__PURE__ */ reactExports.createElement(ThemeConfigProvider, {
    prefixCls: at,
    iconPrefixCls: ot,
    theme: rt
  }, tt);
});
function flushNotice() {
  if (!message) {
    const a = document.createDocumentFragment(), s = {
      fragment: a
    };
    message = s, act(() => {
      render(/* @__PURE__ */ reactExports.createElement(GlobalHolder, {
        ref: ($) => {
          const {
            instance: _,
            sync: _e
          } = $ || {};
          Promise.resolve().then(() => {
            !s.instance && _ && (s.instance = _, s.sync = _e, flushNotice());
          });
        }
      }), a);
    });
    return;
  }
  message.instance && (taskQueue.forEach((a) => {
    const {
      type: s,
      skipped: $
    } = a;
    if (!$)
      switch (s) {
        case "open": {
          act(() => {
            const _ = message.instance.open(Object.assign(Object.assign({}, defaultGlobalConfig), a.config));
            _ == null || _.then(a.resolve), a.setCloseFn(_);
          });
          break;
        }
        case "destroy":
          act(() => {
            message == null || message.instance.destroy(a.key);
          });
          break;
        default:
          act(() => {
            var _;
            const _e = (_ = message.instance)[s].apply(_, _toConsumableArray$d(a.args));
            _e == null || _e.then(a.resolve), a.setCloseFn(_e);
          });
      }
  }), taskQueue = []);
}
function setMessageGlobalConfig(a) {
  defaultGlobalConfig = Object.assign(Object.assign({}, defaultGlobalConfig), a), act(() => {
    var s;
    (s = message == null ? void 0 : message.sync) === null || s === void 0 || s.call(message);
  });
}
function open(a) {
  const s = wrapPromiseFn(($) => {
    let _;
    const _e = {
      type: "open",
      config: a,
      resolve: $,
      setCloseFn: (tt) => {
        _ = tt;
      }
    };
    return taskQueue.push(_e), () => {
      _ ? act(() => {
        _();
      }) : _e.skipped = !0;
    };
  });
  return flushNotice(), s;
}
function typeOpen(a, s) {
  const $ = wrapPromiseFn((_) => {
    let _e;
    const tt = {
      type: a,
      args: s,
      resolve: _,
      setCloseFn: (nt) => {
        _e = nt;
      }
    };
    return taskQueue.push(tt), () => {
      _e ? act(() => {
        _e();
      }) : tt.skipped = !0;
    };
  });
  return flushNotice(), $;
}
function destroy(a) {
  taskQueue.push({
    type: "destroy",
    key: a
  }), flushNotice();
}
const methods = ["success", "info", "warning", "error", "loading"], baseStaticMethods = {
  open,
  destroy,
  config: setMessageGlobalConfig,
  useMessage,
  _InternalPanelDoNotUseOrYouWillBeFired: PurePanel$a
}, staticMethods = baseStaticMethods;
methods.forEach((a) => {
  staticMethods[a] = function() {
    for (var s = arguments.length, $ = new Array(s), _ = 0; _ < s; _++)
      $[_] = arguments[_];
    return typeOpen(a, $);
  };
});
const _message = staticMethods, genBaseStyle$6 = (a) => {
  const {
    componentCls: s,
    iconCls: $,
    antCls: _,
    zIndexPopup: _e,
    colorText: tt,
    colorWarning: nt,
    marginXXS: at,
    marginXS: ot,
    fontSize: rt,
    fontWeightStrong: st,
    colorTextHeading: lt
  } = a;
  return {
    [s]: {
      zIndex: _e,
      [`&${_}-popover`]: {
        fontSize: rt
      },
      [`${s}-message`]: {
        marginBottom: ot,
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${s}-message-icon ${$}`]: {
          color: nt,
          fontSize: rt,
          lineHeight: 1,
          marginInlineEnd: ot
        },
        [`${s}-title`]: {
          fontWeight: st,
          color: lt,
          "&:only-child": {
            fontWeight: "normal"
          }
        },
        [`${s}-description`]: {
          marginTop: at,
          color: tt
        }
      },
      [`${s}-buttons`]: {
        textAlign: "end",
        whiteSpace: "nowrap",
        button: {
          marginInlineStart: ot
        }
      }
    }
  };
}, prepareComponentToken$9 = (a) => {
  const {
    zIndexPopupBase: s
  } = a;
  return {
    zIndexPopup: s + 60
  };
}, useStyle$9 = genStyleHooks("Popconfirm", (a) => genBaseStyle$6(a), prepareComponentToken$9, {
  resetStyle: !1
});
var __rest$k = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Overlay = (a) => {
  const {
    prefixCls: s,
    okButtonProps: $,
    cancelButtonProps: _,
    title: _e,
    description: tt,
    cancelText: nt,
    okText: at,
    okType: ot = "primary",
    icon: rt = /* @__PURE__ */ reactExports.createElement(ExclamationCircleFilled$1, null),
    showCancel: st = !0,
    close: lt,
    onConfirm: et,
    onCancel: it,
    onPopupClick: ut
  } = a, {
    getPrefixCls: ft
  } = reactExports.useContext(ConfigContext$1), [ht] = useLocale$1("Popconfirm", defaultLocale.Popconfirm), dt = getRenderPropValue(_e), gt = getRenderPropValue(tt);
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-inner-content`,
    onClick: ut
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-message`
  }, rt && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${s}-message-icon`
  }, rt), /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-message-text`
  }, dt && /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${s}-title`)
  }, dt), gt && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-description`
  }, gt))), /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-buttons`
  }, st && /* @__PURE__ */ reactExports.createElement(Button$2, Object.assign({
    onClick: it,
    size: "small"
  }, _), nt ?? (ht == null ? void 0 : ht.cancelText)), /* @__PURE__ */ reactExports.createElement(ActionButton$1, {
    buttonProps: Object.assign(Object.assign({
      size: "small"
    }, convertLegacyProps(ot)), $),
    actionFn: et,
    close: lt,
    prefixCls: ft("btn"),
    quitOnNullishReturnValue: !0,
    emitEvent: !0
  }, at ?? (ht == null ? void 0 : ht.okText))));
}, PurePanel$1 = (a) => {
  const {
    prefixCls: s,
    placement: $,
    className: _,
    style: _e
  } = a, tt = __rest$k(a, ["prefixCls", "placement", "className", "style"]), {
    getPrefixCls: nt
  } = reactExports.useContext(ConfigContext$1), at = nt("popconfirm", s), [ot] = useStyle$9(at);
  return ot(/* @__PURE__ */ reactExports.createElement(PopoverPurePanel, {
    placement: $,
    className: classnames(at, _),
    style: _e,
    content: /* @__PURE__ */ reactExports.createElement(Overlay, Object.assign({
      prefixCls: at
    }, tt))
  }));
}, PurePanel$2 = PurePanel$1;
var __rest$j = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Popconfirm = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var $, _;
  const {
    prefixCls: _e,
    placement: tt = "top",
    trigger: nt = "click",
    okType: at = "primary",
    icon: ot = /* @__PURE__ */ reactExports.createElement(ExclamationCircleFilled$1, null),
    children: rt,
    overlayClassName: st,
    onOpenChange: lt,
    onVisibleChange: et
  } = a, it = __rest$j(a, ["prefixCls", "placement", "trigger", "okType", "icon", "children", "overlayClassName", "onOpenChange", "onVisibleChange"]), {
    getPrefixCls: ut
  } = reactExports.useContext(ConfigContext$1), [ft, ht] = useMergedState(!1, {
    value: ($ = a.open) !== null && $ !== void 0 ? $ : a.visible,
    defaultValue: (_ = a.defaultOpen) !== null && _ !== void 0 ? _ : a.defaultVisible
  }), dt = (Et, St) => {
    ht(Et, !0), et == null || et(Et), lt == null || lt(Et, St);
  }, gt = (Et) => {
    dt(!1, Et);
  }, pt = (Et) => {
    var St;
    return (St = a.onConfirm) === null || St === void 0 ? void 0 : St.call(void 0, Et);
  }, mt = (Et) => {
    var St;
    dt(!1, Et), (St = a.onCancel) === null || St === void 0 || St.call(void 0, Et);
  }, ct = (Et) => {
    Et.keyCode === KeyCode.ESC && ft && dt(!1, Et);
  }, vt = (Et) => {
    const {
      disabled: St = !1
    } = a;
    St || dt(Et);
  }, At = ut("popconfirm", _e), xt = classnames(At, st), [bt] = useStyle$9(At);
  return bt(/* @__PURE__ */ reactExports.createElement(_Popover, Object.assign({}, omit(it, ["title"]), {
    trigger: nt,
    placement: tt,
    onOpenChange: vt,
    open: ft,
    ref: s,
    overlayClassName: xt,
    content: /* @__PURE__ */ reactExports.createElement(Overlay, Object.assign({
      okType: at,
      icon: ot
    }, a, {
      prefixCls: At,
      close: gt,
      onConfirm: pt,
      onCancel: mt
    })),
    "data-popover-inject": !0
  }), cloneElement(rt, {
    onKeyDown: (Et) => {
      var St, Bt;
      /* @__PURE__ */ reactExports.isValidElement(rt) && ((Bt = rt == null ? void 0 : (St = rt.props).onKeyDown) === null || Bt === void 0 || Bt.call(St, Et)), ct(Et);
    }
  })));
});
Popconfirm._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$2;
const _Popconfirm = Popconfirm;
var defaultProps = {
  percent: 0,
  prefixCls: "rc-progress",
  strokeColor: "#2db7f5",
  strokeLinecap: "round",
  strokeWidth: 1,
  trailColor: "#D9D9D9",
  trailWidth: 1,
  gapPosition: "bottom"
}, useTransitionDuration = function a() {
  var s = reactExports.useRef([]), $ = reactExports.useRef(null);
  return reactExports.useEffect(function() {
    var _ = Date.now(), _e = !1;
    s.current.forEach(function(tt) {
      if (tt) {
        _e = !0;
        var nt = tt.style;
        nt.transitionDuration = ".3s, .3s, .3s, .06s", $.current && _ - $.current < 100 && (nt.transitionDuration = "0s, 0s");
      }
    }), _e && ($.current = Date.now());
  }), s.current;
}, uuid = 0, isBrowserClient = canUseDom$1();
function getUUID() {
  var a;
  return isBrowserClient ? (a = uuid, uuid += 1) : a = "TEST_OR_SSR", a;
}
const useId = function(a) {
  var s = reactExports.useState(), $ = _slicedToArray$e(s, 2), _ = $[0], _e = $[1];
  return reactExports.useEffect(function() {
    _e("rc_progress_".concat(getUUID()));
  }, []), a || _;
};
var Block = function a(s) {
  var $ = s.bg, _ = s.children;
  return /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      background: $
    }
  }, _);
};
function getPtgColors(a, s) {
  return Object.keys(a).map(function($) {
    var _ = parseFloat($), _e = "".concat(Math.floor(_ * s), "%");
    return "".concat(a[$], " ").concat(_e);
  });
}
var PtgCircle = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = a.color, _e = a.gradientId, tt = a.radius, nt = a.style, at = a.ptg, ot = a.strokeLinecap, rt = a.strokeWidth, st = a.size, lt = a.gapDegree, et = _ && _typeof$q(_) === "object", it = et ? "#FFF" : void 0, ut = st / 2, ft = /* @__PURE__ */ reactExports.createElement("circle", {
    className: "".concat($, "-circle-path"),
    r: tt,
    cx: ut,
    cy: ut,
    stroke: it,
    strokeLinecap: ot,
    strokeWidth: rt,
    opacity: at === 0 ? 0 : 1,
    style: nt,
    ref: s
  });
  if (!et)
    return ft;
  var ht = "".concat(_e, "-conic"), dt = lt ? "".concat(180 + lt / 2, "deg") : "0deg", gt = getPtgColors(_, (360 - lt) / 360), pt = getPtgColors(_, 1), mt = "conic-gradient(from ".concat(dt, ", ").concat(gt.join(", "), ")"), ct = "linear-gradient(to ".concat(lt ? "bottom" : "top", ", ").concat(pt.join(", "), ")");
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("mask", {
    id: ht
  }, ft), /* @__PURE__ */ reactExports.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: st,
    height: st,
    mask: "url(#".concat(ht, ")")
  }, /* @__PURE__ */ reactExports.createElement(Block, {
    bg: ct
  }, /* @__PURE__ */ reactExports.createElement(Block, {
    bg: mt
  }))));
}), VIEW_BOX_SIZE = 100, getCircleStyle = function a(s, $, _, _e, tt, nt, at, ot, rt, st) {
  var lt = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 0, et = _ / 100 * 360 * ((360 - nt) / 360), it = nt === 0 ? 0 : {
    bottom: 0,
    top: 180,
    left: 90,
    right: -90
  }[at], ut = (100 - _e) / 100 * $;
  rt === "round" && _e !== 100 && (ut += st / 2, ut >= $ && (ut = $ - 0.01));
  var ft = VIEW_BOX_SIZE / 2;
  return {
    stroke: typeof ot == "string" ? ot : void 0,
    strokeDasharray: "".concat($, "px ").concat(s),
    strokeDashoffset: ut + lt,
    transform: "rotate(".concat(tt + et + it, "deg)"),
    transformOrigin: "".concat(ft, "px ").concat(ft, "px"),
    transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
    fillOpacity: 0
  };
}, _excluded$h = ["id", "prefixCls", "steps", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor", "percent"];
function toArray$2(a) {
  var s = a ?? [];
  return Array.isArray(s) ? s : [s];
}
var Circle$2 = function a(s) {
  var $ = _objectSpread2$a(_objectSpread2$a({}, defaultProps), s), _ = $.id, _e = $.prefixCls, tt = $.steps, nt = $.strokeWidth, at = $.trailWidth, ot = $.gapDegree, rt = ot === void 0 ? 0 : ot, st = $.gapPosition, lt = $.trailColor, et = $.strokeLinecap, it = $.style, ut = $.className, ft = $.strokeColor, ht = $.percent, dt = _objectWithoutProperties$1($, _excluded$h), gt = VIEW_BOX_SIZE / 2, pt = useId(_), mt = "".concat(pt, "-gradient"), ct = gt - nt / 2, vt = Math.PI * 2 * ct, At = rt > 0 ? 90 + rt / 2 : -90, xt = vt * ((360 - rt) / 360), bt = _typeof$q(tt) === "object" ? tt : {
    count: tt,
    space: 2
  }, Et = bt.count, St = bt.space, Bt = toArray$2(ht), Ot = toArray$2(ft), Pt = Ot.find(function(jt) {
    return jt && _typeof$q(jt) === "object";
  }), wt = Pt && _typeof$q(Pt) === "object", Ct = wt ? "butt" : et, It = getCircleStyle(vt, xt, 0, 100, At, rt, st, lt, Ct, nt), yt = useTransitionDuration(), Rt = function() {
    var Ht = 0;
    return Bt.map(function(Ft, _t) {
      var Nt = Ot[_t] || Ot[Ot.length - 1], Mt = getCircleStyle(vt, xt, Ht, Ft, At, rt, st, Nt, Ct, nt);
      return Ht += Ft, /* @__PURE__ */ reactExports.createElement(PtgCircle, {
        key: _t,
        color: Nt,
        ptg: Ft,
        radius: ct,
        prefixCls: _e,
        gradientId: mt,
        style: Mt,
        strokeLinecap: Ct,
        strokeWidth: nt,
        gapDegree: rt,
        ref: function($t) {
          yt[_t] = $t;
        },
        size: VIEW_BOX_SIZE
      });
    }).reverse();
  }, kt = function() {
    var Ht = Math.round(Et * (Bt[0] / 100)), Ft = 100 / Et, _t = 0;
    return new Array(Et).fill(null).map(function(Nt, Mt) {
      var Lt = Mt <= Ht - 1 ? Ot[0] : lt, $t = Lt && _typeof$q(Lt) === "object" ? "url(#".concat(mt, ")") : void 0, Tt = getCircleStyle(vt, xt, _t, Ft, At, rt, st, Lt, "butt", nt, St);
      return _t += (xt - Tt.strokeDashoffset + St) * 100 / xt, /* @__PURE__ */ reactExports.createElement("circle", {
        key: Mt,
        className: "".concat(_e, "-circle-path"),
        r: ct,
        cx: gt,
        cy: gt,
        stroke: $t,
        strokeWidth: nt,
        opacity: 1,
        style: Tt,
        ref: function(Ut) {
          yt[Mt] = Ut;
        }
      });
    });
  };
  return /* @__PURE__ */ reactExports.createElement("svg", _extends$2({
    className: classnames("".concat(_e, "-circle"), ut),
    viewBox: "0 0 ".concat(VIEW_BOX_SIZE, " ").concat(VIEW_BOX_SIZE),
    style: it,
    id: _,
    role: "presentation"
  }, dt), !Et && /* @__PURE__ */ reactExports.createElement("circle", {
    className: "".concat(_e, "-circle-trail"),
    r: ct,
    cx: gt,
    cy: gt,
    stroke: lt,
    strokeLinecap: Ct,
    strokeWidth: at || nt,
    style: It
  }), Et ? kt() : Rt());
};
function validProgress(a) {
  return !a || a < 0 ? 0 : a > 100 ? 100 : a;
}
function getSuccessPercent(a) {
  let {
    success: s,
    successPercent: $
  } = a, _ = $;
  return s && "progress" in s && (_ = s.progress), s && "percent" in s && (_ = s.percent), _;
}
const getPercentage = (a) => {
  let {
    percent: s,
    success: $,
    successPercent: _
  } = a;
  const _e = validProgress(getSuccessPercent({
    success: $,
    successPercent: _
  }));
  return [_e, validProgress(validProgress(s) - _e)];
}, getStrokeColor = (a) => {
  let {
    success: s = {},
    strokeColor: $
  } = a;
  const {
    strokeColor: _
  } = s;
  return [_ || presetPrimaryColors$1.green, $ || null];
}, getSize$1 = (a, s, $) => {
  var _, _e, tt, nt;
  let at = -1, ot = -1;
  if (s === "step") {
    const rt = $.steps, st = $.strokeWidth;
    typeof a == "string" || typeof a > "u" ? (at = a === "small" ? 2 : 14, ot = st ?? 8) : typeof a == "number" ? [at, ot] = [a, a] : [at = 14, ot = 8] = a, at *= rt;
  } else if (s === "line") {
    const rt = $ == null ? void 0 : $.strokeWidth;
    typeof a == "string" || typeof a > "u" ? ot = rt || (a === "small" ? 6 : 8) : typeof a == "number" ? [at, ot] = [a, a] : [at = -1, ot = 8] = a;
  } else
    (s === "circle" || s === "dashboard") && (typeof a == "string" || typeof a > "u" ? [at, ot] = a === "small" ? [60, 60] : [120, 120] : typeof a == "number" ? [at, ot] = [a, a] : (at = (_e = (_ = a[0]) !== null && _ !== void 0 ? _ : a[1]) !== null && _e !== void 0 ? _e : 120, ot = (nt = (tt = a[0]) !== null && tt !== void 0 ? tt : a[1]) !== null && nt !== void 0 ? nt : 120));
  return [at, ot];
}, CIRCLE_MIN_STROKE_WIDTH = 3, getMinPercent = (a) => CIRCLE_MIN_STROKE_WIDTH / a * 100, Circle = (a) => {
  const {
    prefixCls: s,
    trailColor: $ = null,
    strokeLinecap: _ = "round",
    gapPosition: _e,
    gapDegree: tt,
    width: nt = 120,
    type: at,
    children: ot,
    success: rt,
    size: st = nt
  } = a, [lt, et] = getSize$1(st, "circle");
  let {
    strokeWidth: it
  } = a;
  it === void 0 && (it = Math.max(getMinPercent(lt), 6));
  const ut = {
    width: lt,
    height: et,
    fontSize: lt * 0.15 + 6
  }, ft = reactExports.useMemo(() => {
    if (tt || tt === 0)
      return tt;
    if (at === "dashboard")
      return 75;
  }, [tt, at]), ht = _e || at === "dashboard" && "bottom" || void 0, dt = Object.prototype.toString.call(a.strokeColor) === "[object Object]", gt = getStrokeColor({
    success: rt,
    strokeColor: a.strokeColor
  }), pt = classnames(`${s}-inner`, {
    [`${s}-circle-gradient`]: dt
  }), mt = /* @__PURE__ */ reactExports.createElement(Circle$2, {
    percent: getPercentage(a),
    strokeWidth: it,
    trailWidth: it,
    strokeColor: gt,
    strokeLinecap: _,
    trailColor: $,
    prefixCls: s,
    gapDegree: ft,
    gapPosition: ht
  });
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: pt,
    style: ut
  }, lt <= 20 ? /* @__PURE__ */ reactExports.createElement(_Tooltip, {
    title: ot
  }, /* @__PURE__ */ reactExports.createElement("span", null, mt)) : /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, mt, ot));
}, Circle$1 = Circle;
var __rest$i = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const sortGradient = (a) => {
  let s = [];
  return Object.keys(a).forEach(($) => {
    const _ = parseFloat($.replace(/%/g, ""));
    isNaN(_) || s.push({
      key: _,
      value: a[$]
    });
  }), s = s.sort(($, _) => $.key - _.key), s.map(($) => {
    let {
      key: _,
      value: _e
    } = $;
    return `${_e} ${_}%`;
  }).join(", ");
}, handleGradient = (a, s) => {
  const {
    from: $ = presetPrimaryColors$1.blue,
    to: _ = presetPrimaryColors$1.blue,
    direction: _e = s === "rtl" ? "to left" : "to right"
  } = a, tt = __rest$i(a, ["from", "to", "direction"]);
  if (Object.keys(tt).length !== 0) {
    const nt = sortGradient(tt);
    return {
      backgroundImage: `linear-gradient(${_e}, ${nt})`
    };
  }
  return {
    backgroundImage: `linear-gradient(${_e}, ${$}, ${_})`
  };
}, Line = (a) => {
  const {
    prefixCls: s,
    direction: $,
    percent: _,
    size: _e,
    strokeWidth: tt,
    strokeColor: nt,
    strokeLinecap: at = "round",
    children: ot,
    trailColor: rt = null,
    success: st
  } = a, {
    direction: lt
  } = reactExports.useContext(ConfigContext$1), et = nt && typeof nt != "string" ? handleGradient(nt, $) : {
    backgroundColor: nt
  }, it = at === "square" || at === "butt" ? 0 : void 0, ut = {
    backgroundColor: rt || void 0,
    borderRadius: it
  }, ft = _e ?? [-1, tt || (_e === "small" ? 6 : 8)], [ht, dt] = getSize$1(ft, "line", {
    strokeWidth: tt
  }), gt = at === "square" || at === "butt" ? 0 : "100px", pt = Object.assign({
    width: "100%",
    height: dt,
    borderRadius: it,
    clipPath: lt === "rtl" ? `inset(0 0 0 ${100 - validProgress(_)}% round ${gt})` : `inset(0 ${100 - validProgress(_)}% 0 0 round ${gt})`
  }, et), mt = getSuccessPercent(a), ct = {
    width: "100%",
    height: dt,
    borderRadius: it,
    clipPath: lt === "rtl" ? `inset(0 0 0 ${100 - validProgress(mt)}% round ${gt})` : `inset(0 ${100 - validProgress(mt)}% 0 0 round ${gt})`,
    backgroundColor: st == null ? void 0 : st.strokeColor
  }, vt = {
    width: ht < 0 ? "100%" : ht,
    height: dt
  };
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-outer`,
    style: vt
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-inner`,
    style: ut
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-bg`,
    style: pt
  }), mt !== void 0 ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-success-bg`,
    style: ct
  }) : null)), ot);
}, Line$1 = Line, Steps$1 = (a) => {
  const {
    size: s,
    steps: $,
    percent: _ = 0,
    strokeWidth: _e = 8,
    strokeColor: tt,
    trailColor: nt = null,
    prefixCls: at,
    children: ot
  } = a, rt = Math.round($ * (_ / 100)), lt = s ?? [s === "small" ? 2 : 14, _e], [et, it] = getSize$1(lt, "step", {
    steps: $,
    strokeWidth: _e
  }), ut = et / $, ft = new Array($);
  for (let ht = 0; ht < $; ht++) {
    const dt = Array.isArray(tt) ? tt[ht] : tt;
    ft[ht] = /* @__PURE__ */ reactExports.createElement("div", {
      key: ht,
      className: classnames(`${at}-steps-item`, {
        [`${at}-steps-item-active`]: ht <= rt - 1
      }),
      style: {
        backgroundColor: ht <= rt - 1 ? dt : nt,
        width: ut,
        height: it
      }
    });
  }
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: `${at}-steps-outer`
  }, ft, ot);
}, Steps$2 = Steps$1, genAntProgressActive = (a) => {
  const s = a ? "100%" : "-100%";
  return new Keyframe(`antProgress${a ? "RTL" : "LTR"}Active`, {
    "0%": {
      transform: `translateX(${s}) scaleX(0)`,
      opacity: 0.1
    },
    "20%": {
      transform: `translateX(${s}) scaleX(0)`,
      opacity: 0.5
    },
    to: {
      transform: "translateX(0) scaleX(1)",
      opacity: 0
    }
  });
}, genBaseStyle$5 = (a) => {
  const {
    componentCls: s,
    iconCls: $
  } = a;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      display: "inline-block",
      "&-rtl": {
        direction: "rtl"
      },
      "&-line": {
        position: "relative",
        width: "100%",
        fontSize: a.fontSize,
        marginInlineEnd: a.marginXS,
        marginBottom: a.marginXS
      },
      [`${s}-outer`]: {
        display: "inline-block",
        width: "100%"
      },
      [`&${s}-show-info`]: {
        [`${s}-outer`]: {
          marginInlineEnd: `calc(-2em - ${unit$1(a.marginXS)})`,
          paddingInlineEnd: `calc(2em + ${unit$1(a.paddingXS)})`
        }
      },
      [`${s}-inner`]: {
        position: "relative",
        display: "inline-block",
        width: "100%",
        overflow: "hidden",
        verticalAlign: "middle",
        backgroundColor: a.remainingColor,
        borderRadius: a.lineBorderRadius
      },
      [`${s}-inner:not(${s}-circle-gradient)`]: {
        [`${s}-circle-path`]: {
          stroke: a.defaultColor
        }
      },
      [`${s}-success-bg, ${s}-bg`]: {
        position: "relative",
        backgroundColor: a.defaultColor,
        borderRadius: a.lineBorderRadius,
        transition: `all ${a.motionDurationSlow} ${a.motionEaseInOutCirc}`
      },
      [`${s}-success-bg`]: {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        backgroundColor: a.colorSuccess
      },
      [`${s}-text`]: {
        display: "inline-block",
        width: "2em",
        marginInlineStart: a.marginXS,
        color: a.colorText,
        lineHeight: 1,
        whiteSpace: "nowrap",
        textAlign: "start",
        verticalAlign: "middle",
        wordBreak: "normal",
        [$]: {
          fontSize: a.fontSize
        }
      },
      [`&${s}-status-active`]: {
        [`${s}-bg::before`]: {
          position: "absolute",
          inset: 0,
          backgroundColor: a.colorBgContainer,
          borderRadius: a.lineBorderRadius,
          opacity: 0,
          animationName: genAntProgressActive(),
          animationDuration: a.progressActiveMotionDuration,
          animationTimingFunction: a.motionEaseOutQuint,
          animationIterationCount: "infinite",
          content: '""'
        }
      },
      [`&${s}-rtl${s}-status-active`]: {
        [`${s}-bg::before`]: {
          animationName: genAntProgressActive(!0)
        }
      },
      [`&${s}-status-exception`]: {
        [`${s}-bg`]: {
          backgroundColor: a.colorError
        },
        [`${s}-text`]: {
          color: a.colorError
        }
      },
      [`&${s}-status-exception ${s}-inner:not(${s}-circle-gradient)`]: {
        [`${s}-circle-path`]: {
          stroke: a.colorError
        }
      },
      [`&${s}-status-success`]: {
        [`${s}-bg`]: {
          backgroundColor: a.colorSuccess
        },
        [`${s}-text`]: {
          color: a.colorSuccess
        }
      },
      [`&${s}-status-success ${s}-inner:not(${s}-circle-gradient)`]: {
        [`${s}-circle-path`]: {
          stroke: a.colorSuccess
        }
      }
    })
  };
}, genCircleStyle = (a) => {
  const {
    componentCls: s,
    iconCls: $
  } = a;
  return {
    [s]: {
      [`${s}-circle-trail`]: {
        stroke: a.remainingColor
      },
      [`&${s}-circle ${s}-inner`]: {
        position: "relative",
        lineHeight: 1,
        backgroundColor: "transparent"
      },
      [`&${s}-circle ${s}-text`]: {
        position: "absolute",
        insetBlockStart: "50%",
        insetInlineStart: 0,
        width: "100%",
        margin: 0,
        padding: 0,
        color: a.circleTextColor,
        fontSize: a.circleTextFontSize,
        lineHeight: 1,
        whiteSpace: "normal",
        textAlign: "center",
        transform: "translateY(-50%)",
        [$]: {
          fontSize: a.circleIconFontSize
        }
      },
      [`${s}-circle&-status-exception`]: {
        [`${s}-text`]: {
          color: a.colorError
        }
      },
      [`${s}-circle&-status-success`]: {
        [`${s}-text`]: {
          color: a.colorSuccess
        }
      }
    },
    [`${s}-inline-circle`]: {
      lineHeight: 1,
      [`${s}-inner`]: {
        verticalAlign: "bottom"
      }
    }
  };
}, genStepStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: {
      [`${s}-steps`]: {
        display: "inline-block",
        "&-outer": {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        "&-item": {
          flexShrink: 0,
          minWidth: a.progressStepMinWidth,
          marginInlineEnd: a.progressStepMarginInlineEnd,
          backgroundColor: a.remainingColor,
          transition: `all ${a.motionDurationSlow}`,
          "&-active": {
            backgroundColor: a.defaultColor
          }
        }
      }
    }
  };
}, genSmallLine = (a) => {
  const {
    componentCls: s,
    iconCls: $
  } = a;
  return {
    [s]: {
      [`${s}-small&-line, ${s}-small&-line ${s}-text ${$}`]: {
        fontSize: a.fontSizeSM
      }
    }
  };
}, prepareComponentToken$8 = (a) => ({
  circleTextColor: a.colorText,
  defaultColor: a.colorInfo,
  remainingColor: a.colorFillSecondary,
  lineBorderRadius: 100,
  // magic for capsule shape, should be a very large number
  circleTextFontSize: "1em",
  circleIconFontSize: `${a.fontSize / a.fontSizeSM}em`
}), useStyle$8 = genStyleHooks("Progress", (a) => {
  const s = a.calc(a.marginXXS).div(2).equal(), $ = merge(a, {
    progressStepMarginInlineEnd: s,
    progressStepMinWidth: s,
    progressActiveMotionDuration: "2.4s"
  });
  return [genBaseStyle$5($), genCircleStyle($), genStepStyle($), genSmallLine($)];
}, prepareComponentToken$8);
var __rest$h = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const ProgressStatuses = ["normal", "exception", "active", "success"], Progress = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: $,
    className: _,
    rootClassName: _e,
    steps: tt,
    strokeColor: nt,
    percent: at = 0,
    size: ot = "default",
    showInfo: rt = !0,
    type: st = "line",
    status: lt,
    format: et,
    style: it
  } = a, ut = __rest$h(a, ["prefixCls", "className", "rootClassName", "steps", "strokeColor", "percent", "size", "showInfo", "type", "status", "format", "style"]), ft = reactExports.useMemo(() => {
    var Ot, Pt;
    const wt = getSuccessPercent(a);
    return parseInt(wt !== void 0 ? (Ot = wt ?? 0) === null || Ot === void 0 ? void 0 : Ot.toString() : (Pt = at ?? 0) === null || Pt === void 0 ? void 0 : Pt.toString(), 10);
  }, [at, a.success, a.successPercent]), ht = reactExports.useMemo(() => !ProgressStatuses.includes(lt) && ft >= 100 ? "success" : lt || "normal", [lt, ft]), {
    getPrefixCls: dt,
    direction: gt,
    progress: pt
  } = reactExports.useContext(ConfigContext$1), mt = dt("progress", $), [ct, vt, At] = useStyle$8(mt), xt = reactExports.useMemo(() => {
    if (!rt)
      return null;
    const Ot = getSuccessPercent(a);
    let Pt;
    const wt = et || ((It) => `${It}%`), Ct = st === "line";
    return et || ht !== "exception" && ht !== "success" ? Pt = wt(validProgress(at), validProgress(Ot)) : ht === "exception" ? Pt = Ct ? /* @__PURE__ */ reactExports.createElement(CloseCircleFilled$1, null) : /* @__PURE__ */ reactExports.createElement(CloseOutlined$4, null) : ht === "success" && (Pt = Ct ? /* @__PURE__ */ reactExports.createElement(CheckCircleFilled$1, null) : /* @__PURE__ */ reactExports.createElement(CheckOutlined$1, null)), /* @__PURE__ */ reactExports.createElement("span", {
      className: `${mt}-text`,
      title: typeof Pt == "string" ? Pt : void 0
    }, Pt);
  }, [rt, at, ft, ht, st, mt, et]), bt = Array.isArray(nt) ? nt[0] : nt, Et = typeof nt == "string" || Array.isArray(nt) ? nt : void 0;
  let St;
  st === "line" ? St = tt ? /* @__PURE__ */ reactExports.createElement(Steps$2, Object.assign({}, a, {
    strokeColor: Et,
    prefixCls: mt,
    steps: tt
  }), xt) : /* @__PURE__ */ reactExports.createElement(Line$1, Object.assign({}, a, {
    strokeColor: bt,
    prefixCls: mt,
    direction: gt
  }), xt) : (st === "circle" || st === "dashboard") && (St = /* @__PURE__ */ reactExports.createElement(Circle$1, Object.assign({}, a, {
    strokeColor: bt,
    prefixCls: mt,
    progressStatus: ht
  }), xt));
  const Bt = classnames(mt, `${mt}-status-${ht}`, `${mt}-${st === "dashboard" && "circle" || tt && "steps" || st}`, {
    [`${mt}-inline-circle`]: st === "circle" && getSize$1(ot, "circle")[0] <= 20,
    [`${mt}-show-info`]: rt,
    [`${mt}-${ot}`]: typeof ot == "string",
    [`${mt}-rtl`]: gt === "rtl"
  }, pt == null ? void 0 : pt.className, _, _e, vt, At);
  return ct(/* @__PURE__ */ reactExports.createElement("div", Object.assign({
    ref: s,
    style: Object.assign(Object.assign({}, pt == null ? void 0 : pt.style), it),
    className: Bt,
    role: "progressbar",
    "aria-valuenow": ft
  }, omit(ut, ["trailColor", "strokeWidth", "width", "gapDegree", "gapPosition", "strokeLinecap", "success", "successPercent"])), St));
}), Progress$1 = Progress;
var StarFilled$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z" } }] }, name: "star", theme: "filled" };
const StarFilledSvg = StarFilled$2;
var StarFilled = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: StarFilledSvg
  }));
};
const StarFilled$1 = /* @__PURE__ */ reactExports.forwardRef(StarFilled);
function Star(a, s) {
  var $ = a.disabled, _ = a.prefixCls, _e = a.character, tt = a.characterRender, nt = a.index, at = a.count, ot = a.value, rt = a.allowHalf, st = a.focused, lt = a.onHover, et = a.onClick, it = function(ct) {
    lt(ct, nt);
  }, ut = function(ct) {
    et(ct, nt);
  }, ft = function(ct) {
    ct.keyCode === KeyCode.ENTER && et(ct, nt);
  }, ht = nt + 1, dt = /* @__PURE__ */ new Set([_]);
  ot === 0 && nt === 0 && st ? dt.add("".concat(_, "-focused")) : rt && ot + 0.5 >= ht && ot < ht ? (dt.add("".concat(_, "-half")), dt.add("".concat(_, "-active")), st && dt.add("".concat(_, "-focused"))) : (ht <= ot ? dt.add("".concat(_, "-full")) : dt.add("".concat(_, "-zero")), ht === ot && st && dt.add("".concat(_, "-focused")));
  var gt = typeof _e == "function" ? _e(a) : _e, pt = /* @__PURE__ */ React$a.createElement("li", {
    className: classnames(Array.from(dt)),
    ref: s
  }, /* @__PURE__ */ React$a.createElement("div", {
    onClick: $ ? null : ut,
    onKeyDown: $ ? null : ft,
    onMouseMove: $ ? null : it,
    role: "radio",
    "aria-checked": ot > nt ? "true" : "false",
    "aria-posinset": nt + 1,
    "aria-setsize": at,
    tabIndex: $ ? -1 : 0
  }, /* @__PURE__ */ React$a.createElement("div", {
    className: "".concat(_, "-first")
  }, gt), /* @__PURE__ */ React$a.createElement("div", {
    className: "".concat(_, "-second")
  }, gt)));
  return tt && (pt = tt(pt, a)), pt;
}
const Star$1 = /* @__PURE__ */ React$a.forwardRef(Star);
function useRefs() {
  var a = reactExports.useRef({});
  function s(_) {
    return a.current[_];
  }
  function $(_) {
    return function(_e) {
      a.current[_] = _e;
    };
  }
  return [s, $];
}
function getScroll$1(a) {
  var s = a.pageXOffset, $ = "scrollLeft";
  if (typeof s != "number") {
    var _ = a.document;
    s = _.documentElement[$], typeof s != "number" && (s = _.body[$]);
  }
  return s;
}
function getClientPosition$1(a) {
  var s, $, _ = a.ownerDocument, _e = _.body, tt = _ && _.documentElement, nt = a.getBoundingClientRect();
  return s = nt.left, $ = nt.top, s -= tt.clientLeft || _e.clientLeft || 0, $ -= tt.clientTop || _e.clientTop || 0, {
    left: s,
    top: $
  };
}
function getOffsetLeft(a) {
  var s = getClientPosition$1(a), $ = a.ownerDocument, _ = $.defaultView || $.parentWindow;
  return s.left += getScroll$1(_), s.left;
}
var _excluded$g = ["prefixCls", "className", "defaultValue", "value", "count", "allowHalf", "allowClear", "character", "characterRender", "disabled", "direction", "tabIndex", "autoFocus", "onHoverChange", "onChange", "onFocus", "onBlur", "onKeyDown", "onMouseLeave"];
function Rate$1(a, s) {
  var $, _ = a.prefixCls, _e = _ === void 0 ? "rc-rate" : _, tt = a.className, nt = a.defaultValue, at = a.value, ot = a.count, rt = ot === void 0 ? 5 : ot, st = a.allowHalf, lt = st === void 0 ? !1 : st, et = a.allowClear, it = et === void 0 ? !0 : et, ut = a.character, ft = ut === void 0 ? "★" : ut, ht = a.characterRender, dt = a.disabled, gt = a.direction, pt = gt === void 0 ? "ltr" : gt, mt = a.tabIndex, ct = mt === void 0 ? 0 : mt, vt = a.autoFocus, At = a.onHoverChange, xt = a.onChange, bt = a.onFocus, Et = a.onBlur, St = a.onKeyDown, Bt = a.onMouseLeave, Ot = _objectWithoutProperties$1(a, _excluded$g), Pt = useRefs(), wt = _slicedToArray$e(Pt, 2), Ct = wt[0], It = wt[1], yt = React$a.useRef(null), Rt = function() {
    if (!dt) {
      var Xt;
      (Xt = yt.current) === null || Xt === void 0 || Xt.focus();
    }
  };
  React$a.useImperativeHandle(s, function() {
    return {
      focus: Rt,
      blur: function() {
        if (!dt) {
          var Xt;
          (Xt = yt.current) === null || Xt === void 0 || Xt.blur();
        }
      }
    };
  });
  var kt = useMergedState(nt || 0, {
    value: at
  }), jt = _slicedToArray$e(kt, 2), Ht = jt[0], Ft = jt[1], _t = useMergedState(null), Nt = _slicedToArray$e(_t, 2), Mt = Nt[0], Lt = Nt[1], $t = function(Xt, Gt) {
    var Wt = pt === "rtl", er = Xt + 1;
    if (lt) {
      var lr = Ct(Xt), ur = getOffsetLeft(lr), pr = lr.clientWidth;
      (Wt && Gt - ur > pr / 2 || !Wt && Gt - ur < pr / 2) && (er -= 0.5);
    }
    return er;
  }, Tt = function(Xt) {
    Ft(Xt), xt == null || xt(Xt);
  }, Dt = React$a.useState(!1), Ut = _slicedToArray$e(Dt, 2), Vt = Ut[0], Qt = Ut[1], qt = function() {
    Qt(!0), bt == null || bt();
  }, Zt = function() {
    Qt(!1), Et == null || Et();
  }, ar = React$a.useState(null), Jt = _slicedToArray$e(ar, 2), rr = Jt[0], Yt = Jt[1], Kt = function(Xt, Gt) {
    var Wt = $t(Gt, Xt.pageX);
    Wt !== Mt && (Yt(Wt), Lt(null)), At == null || At(Wt);
  }, nr = function(Xt) {
    dt || (Yt(null), Lt(null), At == null || At(void 0)), Xt && (Bt == null || Bt(Xt));
  }, tr = function(Xt, Gt) {
    var Wt = $t(Gt, Xt.pageX), er = !1;
    it && (er = Wt === Ht), nr(), Tt(er ? 0 : Wt), Lt(er ? Wt : null);
  }, ir = function(Xt) {
    var Gt = Xt.keyCode, Wt = pt === "rtl", er = Ht;
    Gt === KeyCode.RIGHT && er < rt && !Wt ? (lt ? er += 0.5 : er += 1, Tt(er), Xt.preventDefault()) : Gt === KeyCode.LEFT && er > 0 && !Wt || Gt === KeyCode.RIGHT && er > 0 && Wt ? (lt ? er -= 0.5 : er -= 1, Tt(er), Xt.preventDefault()) : Gt === KeyCode.LEFT && er < rt && Wt && (lt ? er += 0.5 : er += 1, Tt(er), Xt.preventDefault()), St == null || St(Xt);
  };
  React$a.useEffect(function() {
    vt && !dt && Rt();
  }, []);
  var sr = new Array(rt).fill(0).map(function(or, Xt) {
    return /* @__PURE__ */ React$a.createElement(Star$1, {
      ref: It(Xt),
      index: Xt,
      count: rt,
      disabled: dt,
      prefixCls: "".concat(_e, "-star"),
      allowHalf: lt,
      value: rr === null ? Ht : rr,
      onClick: tr,
      onHover: Kt,
      key: or || Xt,
      character: ft,
      characterRender: ht,
      focused: Vt
    });
  }), cr = classnames(_e, tt, ($ = {}, _defineProperty$c($, "".concat(_e, "-disabled"), dt), _defineProperty$c($, "".concat(_e, "-rtl"), pt === "rtl"), $));
  return /* @__PURE__ */ React$a.createElement("ul", _extends$2({
    className: cr,
    onMouseLeave: nr,
    tabIndex: dt ? -1 : ct,
    onFocus: dt ? null : qt,
    onBlur: dt ? null : Zt,
    onKeyDown: dt ? null : ir,
    ref: yt,
    role: "radiogroup"
  }, pickAttrs(Ot, {
    aria: !0,
    data: !0,
    attr: !0
  })), sr);
}
const Rate$2 = /* @__PURE__ */ React$a.forwardRef(Rate$1), genRateStarStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-star`]: {
      position: "relative",
      display: "inline-block",
      color: "inherit",
      cursor: "pointer",
      "&:not(:last-child)": {
        marginInlineEnd: a.marginXS
      },
      "> div": {
        transition: `all ${a.motionDurationMid}, outline 0s`,
        "&:hover": {
          transform: a.starHoverScale
        },
        "&:focus": {
          outline: 0
        },
        "&:focus-visible": {
          outline: `${unit$1(a.lineWidth)} dashed ${a.starColor}`,
          transform: a.starHoverScale
        }
      },
      "&-first, &-second": {
        color: a.starBg,
        transition: `all ${a.motionDurationMid}`,
        userSelect: "none"
      },
      "&-first": {
        position: "absolute",
        top: 0,
        insetInlineStart: 0,
        width: "50%",
        height: "100%",
        overflow: "hidden",
        opacity: 0
      },
      [`&-half ${s}-star-first, &-half ${s}-star-second`]: {
        opacity: 1
      },
      [`&-half ${s}-star-first, &-full ${s}-star-second`]: {
        color: "inherit"
      }
    }
  };
}, genRateRtlStyle = (a) => ({
  [`&-rtl${a.componentCls}`]: {
    direction: "rtl"
  }
}), genRateStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
      display: "inline-block",
      margin: 0,
      padding: 0,
      color: a.starColor,
      fontSize: a.starSize,
      lineHeight: 1,
      listStyle: "none",
      outline: "none",
      // disable styles
      [`&-disabled${s} ${s}-star`]: {
        cursor: "default",
        "> div:hover": {
          transform: "scale(1)"
        }
      }
    }), genRateStarStyle(a)), genRateRtlStyle(a))
  };
}, prepareComponentToken$7 = (a) => ({
  starColor: a.yellow6,
  starSize: a.controlHeightLG * 0.5,
  starHoverScale: "scale(1.1)",
  starBg: a.colorFillContent
}), useStyle$7 = genStyleHooks("Rate", (a) => {
  const s = merge(a, {});
  return [genRateStyle(s)];
}, prepareComponentToken$7);
var __rest$g = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Rate = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: $,
    className: _,
    rootClassName: _e,
    style: tt,
    tooltips: nt,
    character: at = /* @__PURE__ */ reactExports.createElement(StarFilled$1, null)
  } = a, ot = __rest$g(a, ["prefixCls", "className", "rootClassName", "style", "tooltips", "character"]), rt = (gt, pt) => {
    let {
      index: mt
    } = pt;
    return nt ? /* @__PURE__ */ reactExports.createElement(_Tooltip, {
      title: nt[mt]
    }, gt) : gt;
  }, {
    getPrefixCls: st,
    direction: lt,
    rate: et
  } = reactExports.useContext(ConfigContext$1), it = st("rate", $), [ut, ft, ht] = useStyle$7(it), dt = Object.assign(Object.assign({}, et == null ? void 0 : et.style), tt);
  return ut(/* @__PURE__ */ reactExports.createElement(Rate$2, Object.assign({
    ref: s,
    character: at,
    characterRender: rt
  }, ot, {
    className: classnames(_, _e, ft, ht, et == null ? void 0 : et.className),
    style: dt,
    prefixCls: it,
    direction: lt
  })));
}), _Rate = Rate;
var WarningFilled$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "warning", theme: "filled" };
const WarningFilledSvg = WarningFilled$2;
var WarningFilled = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: WarningFilledSvg
  }));
};
const WarningFilled$1 = /* @__PURE__ */ reactExports.forwardRef(WarningFilled), NoFound = () => /* @__PURE__ */ reactExports.createElement("svg", {
  width: "252",
  height: "294"
}, /* @__PURE__ */ reactExports.createElement("defs", null, /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 .387h251.772v251.772H0z"
})), /* @__PURE__ */ reactExports.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ reactExports.createElement("g", {
  transform: "translate(0 .012)"
}, /* @__PURE__ */ reactExports.createElement("mask", {
  fill: "#fff"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 127.32v-2.095C0 56.279 55.892.387 124.838.387h2.096c68.946 0 124.838 55.892 124.838 124.838v2.096c0 68.946-55.892 124.838-124.838 124.838h-2.096C55.892 252.16 0 196.267 0 127.321",
  fill: "#E4EBF7",
  mask: "url(#b)"
})), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M39.755 130.84a8.276 8.276 0 1 1-16.468-1.66 8.276 8.276 0 0 1 16.468 1.66",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M36.975 134.297l10.482 5.943M48.373 146.508l-12.648 10.788",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M39.875 159.352a5.667 5.667 0 1 1-11.277-1.136 5.667 5.667 0 0 1 11.277 1.136M57.588 143.247a5.708 5.708 0 1 1-11.358-1.145 5.708 5.708 0 0 1 11.358 1.145M99.018 26.875l29.82-.014a4.587 4.587 0 1 0-.003-9.175l-29.82.013a4.587 4.587 0 1 0 .003 9.176M110.424 45.211l29.82-.013a4.588 4.588 0 0 0-.004-9.175l-29.82.013a4.587 4.587 0 1 0 .004 9.175",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M112.798 26.861v-.002l15.784-.006a4.588 4.588 0 1 0 .003 9.175l-15.783.007v-.002a4.586 4.586 0 0 0-.004-9.172M184.523 135.668c-.553 5.485-5.447 9.483-10.931 8.93-5.485-.553-9.483-5.448-8.93-10.932.552-5.485 5.447-9.483 10.932-8.93 5.485.553 9.483 5.447 8.93 10.932",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M179.26 141.75l12.64 7.167M193.006 156.477l-15.255 13.011",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M184.668 170.057a6.835 6.835 0 1 1-13.6-1.372 6.835 6.835 0 0 1 13.6 1.372M203.34 153.325a6.885 6.885 0 1 1-13.7-1.382 6.885 6.885 0 0 1 13.7 1.382",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M151.931 192.324a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0zM225.27 116.056a2.222 2.222 0 1 1-4.445 0 2.222 2.222 0 0 1 4.444 0zM216.38 151.08a2.223 2.223 0 1 1-4.446-.001 2.223 2.223 0 0 1 4.446 0zM176.917 107.636a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM195.291 92.165a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM202.058 180.711a2.223 2.223 0 1 1-4.446 0 2.223 2.223 0 0 1 4.446 0z",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  stroke: "#FFF",
  strokeWidth: "2",
  d: "M214.404 153.302l-1.912 20.184-10.928 5.99M173.661 174.792l-6.356 9.814h-11.36l-4.508 6.484M174.941 125.168v-15.804M220.824 117.25l-12.84 7.901-15.31-7.902V94.39"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M166.588 65.936h-3.951a4.756 4.756 0 0 1-4.743-4.742 4.756 4.756 0 0 1 4.743-4.743h3.951a4.756 4.756 0 0 1 4.743 4.743 4.756 4.756 0 0 1-4.743 4.742",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M174.823 30.03c0-16.281 13.198-29.48 29.48-29.48 16.28 0 29.48 13.199 29.48 29.48 0 16.28-13.2 29.48-29.48 29.48-16.282 0-29.48-13.2-29.48-29.48",
  fill: "#1677ff"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M205.952 38.387c.5.5.785 1.142.785 1.928s-.286 1.465-.785 1.964c-.572.5-1.214.75-2 .75-.785 0-1.429-.285-1.929-.785-.572-.5-.82-1.143-.82-1.929s.248-1.428.82-1.928c.5-.5 1.144-.75 1.93-.75.785 0 1.462.25 1.999.75m4.285-19.463c1.428 1.249 2.143 2.963 2.143 5.142 0 1.712-.427 3.13-1.219 4.25-.067.096-.137.18-.218.265-.416.429-1.41 1.346-2.956 2.699a5.07 5.07 0 0 0-1.428 1.75 5.207 5.207 0 0 0-.536 2.357v.5h-4.107v-.5c0-1.357.215-2.536.714-3.5.464-.964 1.857-2.464 4.178-4.536l.43-.5c.643-.785.964-1.643.964-2.535 0-1.18-.358-2.108-1-2.785-.678-.68-1.643-1.001-2.858-1.001-1.536 0-2.642.464-3.357 1.43-.37.5-.621 1.135-.76 1.904a1.999 1.999 0 0 1-1.971 1.63h-.004c-1.277 0-2.257-1.183-1.98-2.43.337-1.518 1.02-2.78 2.073-3.784 1.536-1.5 3.607-2.25 6.25-2.25 2.32 0 4.214.607 5.642 1.894",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M52.04 76.131s21.81 5.36 27.307 15.945c5.575 10.74-6.352 9.26-15.73 4.935-10.86-5.008-24.7-11.822-11.577-20.88",
  fill: "#FFB594"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M90.483 67.504l-.449 2.893c-.753.49-4.748-2.663-4.748-2.663l-1.645.748-1.346-5.684s6.815-4.589 8.917-5.018c2.452-.501 9.884.94 10.7 2.278 0 0 1.32.486-2.227.69-3.548.203-5.043.447-6.79 3.132-1.747 2.686-2.412 3.624-2.412 3.624",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M128.055 111.367c-2.627-7.724-6.15-13.18-8.917-15.478-3.5-2.906-9.34-2.225-11.366-4.187-1.27-1.231-3.215-1.197-3.215-1.197s-14.98-3.158-16.828-3.479c-2.37-.41-2.124-.714-6.054-1.405-1.57-1.907-2.917-1.122-2.917-1.122l-7.11-1.383c-.853-1.472-2.423-1.023-2.423-1.023l-2.468-.897c-1.645 9.976-7.74 13.796-7.74 13.796 1.795 1.122 15.703 8.3 15.703 8.3l5.107 37.11s-3.321 5.694 1.346 9.109c0 0 19.883-3.743 34.921-.329 0 0 3.047-2.546.972-8.806.523-3.01 1.394-8.263 1.736-11.622.385.772 2.019 1.918 3.14 3.477 0 0 9.407-7.365 11.052-14.012-.832-.723-1.598-1.585-2.267-2.453-.567-.736-.358-2.056-.765-2.717-.669-1.084-1.804-1.378-1.907-1.682",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.09 289.998s4.295 2.041 7.354 1.021c2.821-.94 4.53.668 7.08 1.178 2.55.51 6.874 1.1 11.686-1.26-.103-5.51-6.889-3.98-11.96-6.713-2.563-1.38-3.784-4.722-3.598-8.799h-9.402s-1.392 10.52-1.16 14.573",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.067 289.826s2.428 1.271 6.759.653c3.058-.437 3.712.481 7.423 1.031 3.712.55 10.724-.069 11.823-.894.413 1.1-.343 2.063-.343 2.063s-1.512.603-4.812.824c-2.03.136-5.8.291-7.607-.503-1.787-1.375-5.247-1.903-5.728-.241-3.918.95-7.355-.286-7.355-.286l-.16-2.647z",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M108.341 276.044h3.094s-.103 6.702 4.536 8.558c-4.64.618-8.558-2.303-7.63-8.558",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M57.542 272.401s-2.107 7.416-4.485 12.306c-1.798 3.695-4.225 7.492 5.465 7.492 6.648 0 8.953-.48 7.423-6.599-1.53-6.12.266-13.199.266-13.199h-8.669z",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M51.476 289.793s2.097 1.169 6.633 1.169c6.083 0 8.249-1.65 8.249-1.65s.602 1.114-.619 2.165c-.993.855-3.597 1.591-7.39 1.546-4.145-.048-5.832-.566-6.736-1.168-.825-.55-.687-1.58-.137-2.062",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M58.419 274.304s.033 1.519-.314 2.93c-.349 1.42-1.078 3.104-1.13 4.139-.058 1.151 4.537 1.58 5.155.034.62-1.547 1.294-6.427 1.913-7.252.619-.825-4.903-2.119-5.624.15",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M99.66 278.514l13.378.092s1.298-54.52 1.853-64.403c.554-9.882 3.776-43.364 1.002-63.128l-12.547-.644-22.849.78s-.434 3.966-1.195 9.976c-.063.496-.682.843-.749 1.365-.075.585.423 1.354.32 1.966-2.364 14.08-6.377 33.104-8.744 46.677-.116.666-1.234 1.009-1.458 2.691-.04.302.211 1.525.112 1.795-6.873 18.744-10.949 47.842-14.277 61.885l14.607-.014s2.197-8.57 4.03-16.97c2.811-12.886 23.111-85.01 23.111-85.01l3.016-.521 1.043 46.35s-.224 1.234.337 2.02c.56.785-.56 1.123-.392 2.244l.392 1.794s-.449 7.178-.898 11.89c-.448 4.71-.092 39.165-.092 39.165",
  fill: "#7BB2F9"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M76.085 221.626c1.153.094 4.038-2.019 6.955-4.935M106.36 225.142s2.774-1.11 6.103-3.883",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M107.275 222.1s2.773-1.11 6.102-3.884",
  stroke: "#648BD8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M74.74 224.767s2.622-.591 6.505-3.365M86.03 151.634c-.27 3.106.3 8.525-4.336 9.123M103.625 149.88s.11 14.012-1.293 15.065c-2.219 1.664-2.99 1.944-2.99 1.944M99.79 150.438s.035 12.88-1.196 24.377M93.673 175.911s7.212-1.664 9.431-1.664M74.31 205.861a212.013 212.013 0 0 1-.979 4.56s-1.458 1.832-1.009 3.776c.449 1.944-.947 2.045-4.985 15.355-1.696 5.59-4.49 18.591-6.348 27.597l-.231 1.12M75.689 197.807a320.934 320.934 0 0 1-.882 4.754M82.591 152.233L81.395 162.7s-1.097.15-.5 2.244c.113 1.346-2.674 15.775-5.18 30.43M56.12 274.418h13.31",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M116.241 148.22s-17.047-3.104-35.893.2c.158 2.514-.003 4.15-.003 4.15s14.687-2.818 35.67-.312c.252-2.355.226-4.038.226-4.038",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M106.322 151.165l.003-4.911a.81.81 0 0 0-.778-.815c-2.44-.091-5.066-.108-7.836-.014a.818.818 0 0 0-.789.815l-.003 4.906a.81.81 0 0 0 .831.813c2.385-.06 4.973-.064 7.73.017a.815.815 0 0 0 .842-.81",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M105.207 150.233l.002-3.076a.642.642 0 0 0-.619-.646 94.321 94.321 0 0 0-5.866-.01.65.65 0 0 0-.63.647v3.072a.64.64 0 0 0 .654.644 121.12 121.12 0 0 1 5.794.011c.362.01.665-.28.665-.642",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M100.263 275.415h12.338M101.436 270.53c.006 3.387.042 5.79.111 6.506M101.451 264.548a915.75 915.75 0 0 0-.015 4.337M100.986 174.965l.898 44.642s.673 1.57-.225 2.692c-.897 1.122 2.468.673.898 2.243-1.57 1.57.897 1.122 0 3.365-.596 1.489-.994 21.1-1.096 35.146",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M46.876 83.427s-.516 6.045 7.223 5.552c11.2-.712 9.218-9.345 31.54-21.655-.786-2.708-2.447-4.744-2.447-4.744s-11.068 3.11-22.584 8.046c-6.766 2.9-13.395 6.352-13.732 12.801M104.46 91.057l.941-5.372-8.884-11.43-5.037 5.372-1.74 7.834a.321.321 0 0 0 .108.32c.965.8 6.5 5.013 14.347 3.544a.332.332 0 0 0 .264-.268",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M93.942 79.387s-4.533-2.853-2.432-6.855c1.623-3.09 4.513 1.133 4.513 1.133s.52-3.642 3.121-3.642c.52-1.04 1.561-4.162 1.561-4.162s11.445 2.601 13.526 3.121c0 5.203-2.304 19.424-7.84 19.861-8.892.703-12.449-9.456-12.449-9.456",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M113.874 73.446c2.601-2.081 3.47-9.722 3.47-9.722s-2.479-.49-6.64-2.05c-4.683-2.081-12.798-4.747-17.48.976-9.668 3.223-2.05 19.823-2.05 19.823l2.713-3.021s-3.935-3.287-2.08-6.243c2.17-3.462 3.92 1.073 3.92 1.073s.637-2.387 3.581-3.342c.355-.71 1.036-2.674 1.432-3.85a1.073 1.073 0 0 1 1.263-.704c2.4.558 8.677 2.019 11.356 2.662.522.125.871.615.82 1.15l-.305 3.248z",
  fill: "#520038"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M104.977 76.064c-.103.61-.582 1.038-1.07.956-.489-.083-.801-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.644.698 1.254M112.132 77.694c-.103.61-.582 1.038-1.07.956-.488-.083-.8-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.643.698 1.254",
  fill: "#552950"
}), /* @__PURE__ */ reactExports.createElement("path", {
  stroke: "#DB836E",
  strokeWidth: "1.118",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M110.13 74.84l-.896 1.61-.298 4.357h-2.228"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M110.846 74.481s1.79-.716 2.506.537",
  stroke: "#5C2552",
  strokeWidth: "1.118",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M92.386 74.282s.477-1.114 1.113-.716c.637.398 1.274 1.433.558 1.99-.717.556.159 1.67.159 1.67",
  stroke: "#DB836E",
  strokeWidth: "1.118",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M103.287 72.93s1.83 1.113 4.137.954",
  stroke: "#5C2552",
  strokeWidth: "1.118",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M103.685 81.762s2.227 1.193 4.376 1.193M104.64 84.308s.954.398 1.511.318M94.693 81.205s2.308 7.4 10.424 7.639",
  stroke: "#DB836E",
  strokeWidth: "1.118",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M81.45 89.384s.45 5.647-4.935 12.787M69 82.654s-.726 9.282-8.204 14.206",
  stroke: "#E4EBF7",
  strokeWidth: "1.101",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M129.405 122.865s-5.272 7.403-9.422 10.768",
  stroke: "#E4EBF7",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M119.306 107.329s.452 4.366-2.127 32.062",
  stroke: "#E4EBF7",
  strokeWidth: "1.101",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M150.028 151.232h-49.837a1.01 1.01 0 0 1-1.01-1.01v-31.688c0-.557.452-1.01 1.01-1.01h49.837c.558 0 1.01.453 1.01 1.01v31.688a1.01 1.01 0 0 1-1.01 1.01",
  fill: "#F2D7AD"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M150.29 151.232h-19.863v-33.707h20.784v32.786a.92.92 0 0 1-.92.92",
  fill: "#F4D19D"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M123.554 127.896H92.917a.518.518 0 0 1-.425-.816l6.38-9.113c.193-.277.51-.442.85-.442h31.092l-7.26 10.371z",
  fill: "#F2D7AD"
}), /* @__PURE__ */ reactExports.createElement("path", {
  fill: "#CC9B6E",
  d: "M123.689 128.447H99.25v-.519h24.169l7.183-10.26.424.298z"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M158.298 127.896h-18.669a2.073 2.073 0 0 1-1.659-.83l-7.156-9.541h19.965c.49 0 .95.23 1.244.622l6.69 8.92a.519.519 0 0 1-.415.83",
  fill: "#F4D19D"
}), /* @__PURE__ */ reactExports.createElement("path", {
  fill: "#CC9B6E",
  d: "M157.847 128.479h-19.384l-7.857-10.475.415-.31 7.7 10.266h19.126zM130.554 150.685l-.032-8.177.519-.002.032 8.177z"
}), /* @__PURE__ */ reactExports.createElement("path", {
  fill: "#CC9B6E",
  d: "M130.511 139.783l-.08-21.414.519-.002.08 21.414zM111.876 140.932l-.498-.143 1.479-5.167.498.143zM108.437 141.06l-2.679-2.935 2.665-3.434.41.318-2.397 3.089 2.384 2.612zM116.607 141.06l-.383-.35 2.383-2.612-2.397-3.089.41-.318 2.665 3.434z"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M154.316 131.892l-3.114-1.96.038 3.514-1.043.092c-1.682.115-3.634.23-4.789.23-1.902 0-2.693 2.258 2.23 2.648l-2.645-.596s-2.168 1.317.504 2.3c0 0-1.58 1.217.561 2.58-.584 3.504 5.247 4.058 7.122 3.59 1.876-.47 4.233-2.359 4.487-5.16.28-3.085-.89-5.432-3.35-7.238",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M153.686 133.577s-6.522.47-8.36.372c-1.836-.098-1.904 2.19 2.359 2.264 3.739.15 5.451-.044 5.451-.044",
  stroke: "#DB836E",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M145.16 135.877c-1.85 1.346.561 2.355.561 2.355s3.478.898 6.73.617",
  stroke: "#DB836E",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M151.89 141.71s-6.28.111-6.73-2.132c-.223-1.346.45-1.402.45-1.402M146.114 140.868s-1.103 3.16 5.44 3.533M151.202 129.932v3.477M52.838 89.286c3.533-.337 8.423-1.248 13.582-7.754",
  stroke: "#DB836E",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M168.567 248.318a6.647 6.647 0 0 1-6.647-6.647v-66.466a6.647 6.647 0 1 1 13.294 0v66.466a6.647 6.647 0 0 1-6.647 6.647",
  fill: "#5BA02E"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M176.543 247.653a6.647 6.647 0 0 1-6.646-6.647v-33.232a6.647 6.647 0 1 1 13.293 0v33.232a6.647 6.647 0 0 1-6.647 6.647",
  fill: "#92C110"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M186.443 293.613H158.92a3.187 3.187 0 0 1-3.187-3.187v-46.134a3.187 3.187 0 0 1 3.187-3.187h27.524a3.187 3.187 0 0 1 3.187 3.187v46.134a3.187 3.187 0 0 1-3.187 3.187",
  fill: "#F2D7AD"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M88.979 89.48s7.776 5.384 16.6 2.842",
  stroke: "#E4EBF7",
  strokeWidth: "1.101",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), noFound = NoFound, ServerError = () => /* @__PURE__ */ reactExports.createElement("svg", {
  width: "254",
  height: "294"
}, /* @__PURE__ */ reactExports.createElement("defs", null, /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 .335h253.49v253.49H0z"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 293.665h253.49V.401H0z"
})), /* @__PURE__ */ reactExports.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ reactExports.createElement("g", {
  transform: "translate(0 .067)"
}, /* @__PURE__ */ reactExports.createElement("mask", {
  fill: "#fff"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 128.134v-2.11C0 56.608 56.273.334 125.69.334h2.11c69.416 0 125.69 56.274 125.69 125.69v2.11c0 69.417-56.274 125.69-125.69 125.69h-2.11C56.273 253.824 0 197.551 0 128.134",
  fill: "#E4EBF7",
  mask: "url(#b)"
})), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M39.989 132.108a8.332 8.332 0 1 1-16.581-1.671 8.332 8.332 0 0 1 16.58 1.671",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M37.19 135.59l10.553 5.983M48.665 147.884l-12.734 10.861",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M40.11 160.816a5.706 5.706 0 1 1-11.354-1.145 5.706 5.706 0 0 1 11.354 1.145M57.943 144.6a5.747 5.747 0 1 1-11.436-1.152 5.747 5.747 0 0 1 11.436 1.153M99.656 27.434l30.024-.013a4.619 4.619 0 1 0-.004-9.238l-30.024.013a4.62 4.62 0 0 0 .004 9.238M111.14 45.896l30.023-.013a4.62 4.62 0 1 0-.004-9.238l-30.024.013a4.619 4.619 0 1 0 .004 9.238",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M113.53 27.421v-.002l15.89-.007a4.619 4.619 0 1 0 .005 9.238l-15.892.007v-.002a4.618 4.618 0 0 0-.004-9.234M150.167 70.091h-3.979a4.789 4.789 0 0 1-4.774-4.775 4.788 4.788 0 0 1 4.774-4.774h3.979a4.789 4.789 0 0 1 4.775 4.774 4.789 4.789 0 0 1-4.775 4.775",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M171.687 30.234c0-16.392 13.289-29.68 29.681-29.68 16.392 0 29.68 13.288 29.68 29.68 0 16.393-13.288 29.681-29.68 29.681s-29.68-13.288-29.68-29.68",
  fill: "#FF603B"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M203.557 19.435l-.676 15.035a1.514 1.514 0 0 1-3.026 0l-.675-15.035a2.19 2.19 0 1 1 4.377 0m-.264 19.378c.513.477.77 1.1.77 1.87s-.257 1.393-.77 1.907c-.55.476-1.21.733-1.943.733a2.545 2.545 0 0 1-1.87-.77c-.55-.514-.806-1.136-.806-1.87 0-.77.256-1.393.806-1.87.513-.513 1.137-.733 1.87-.733.77 0 1.43.22 1.943.733",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M119.3 133.275c4.426-.598 3.612-1.204 4.079-4.778.675-5.18-3.108-16.935-8.262-25.118-1.088-10.72-12.598-11.24-12.598-11.24s4.312 4.895 4.196 16.199c1.398 5.243.804 14.45.804 14.45s5.255 11.369 11.78 10.487",
  fill: "#FFB594"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M100.944 91.61s1.463-.583 3.211.582c8.08 1.398 10.368 6.706 11.3 11.368 1.864 1.282 1.864 2.33 1.864 3.496.365.777 1.515 3.03 1.515 3.03s-7.225 1.748-10.954 6.758c-1.399-6.41-6.936-25.235-6.936-25.235",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M94.008 90.5l1.019-5.815-9.23-11.874-5.233 5.581-2.593 9.863s8.39 5.128 16.037 2.246",
  fill: "#FFB594"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M82.931 78.216s-4.557-2.868-2.445-6.892c1.632-3.107 4.537 1.139 4.537 1.139s.524-3.662 3.139-3.662c.523-1.046 1.569-4.184 1.569-4.184s11.507 2.615 13.6 3.138c-.001 5.23-2.317 19.529-7.884 19.969-8.94.706-12.516-9.508-12.516-9.508",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M102.971 72.243c2.616-2.093 3.489-9.775 3.489-9.775s-2.492-.492-6.676-2.062c-4.708-2.092-12.867-4.771-17.575.982-9.54 4.41-2.062 19.93-2.062 19.93l2.729-3.037s-3.956-3.304-2.092-6.277c2.183-3.48 3.943 1.08 3.943 1.08s.64-2.4 3.6-3.36c.356-.714 1.04-2.69 1.44-3.872a1.08 1.08 0 0 1 1.27-.707c2.41.56 8.723 2.03 11.417 2.676.524.126.876.619.825 1.156l-.308 3.266z",
  fill: "#520038"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.22 76.514c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.961.491.083.805.647.702 1.26M94.26 75.074c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.96.491.082.805.646.702 1.26",
  fill: "#552950"
}), /* @__PURE__ */ reactExports.createElement("path", {
  stroke: "#DB836E",
  strokeWidth: "1.063",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M99.206 73.644l-.9 1.62-.3 4.38h-2.24"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M99.926 73.284s1.8-.72 2.52.54",
  stroke: "#5C2552",
  strokeWidth: "1.117",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M81.367 73.084s.48-1.12 1.12-.72c.64.4 1.28 1.44.56 2s.16 1.68.16 1.68",
  stroke: "#DB836E",
  strokeWidth: "1.117",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M92.326 71.724s1.84 1.12 4.16.96",
  stroke: "#5C2552",
  strokeWidth: "1.117",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M92.726 80.604s2.24 1.2 4.4 1.2M93.686 83.164s.96.4 1.52.32M83.687 80.044s1.786 6.547 9.262 7.954",
  stroke: "#DB836E",
  strokeWidth: "1.063",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M95.548 91.663s-1.068 2.821-8.298 2.105c-7.23-.717-10.29-5.044-10.29-5.044",
  stroke: "#E4EBF7",
  strokeWidth: "1.136",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M78.126 87.478s6.526 4.972 16.47 2.486c0 0 9.577 1.02 11.536 5.322 5.36 11.77.543 36.835 0 39.962 3.496 4.055-.466 8.483-.466 8.483-15.624-3.548-35.81-.6-35.81-.6-4.849-3.546-1.223-9.044-1.223-9.044L62.38 110.32c-2.485-15.227.833-19.803 3.549-20.743 3.03-1.049 8.04-1.282 8.04-1.282.496-.058 1.08-.076 1.37-.233 2.36-1.282 2.787-.583 2.787-.583",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M65.828 89.81s-6.875.465-7.59 8.156c-.466 8.857 3.03 10.954 3.03 10.954s6.075 22.102 16.796 22.957c8.39-2.176 4.758-6.702 4.661-11.42-.233-11.304-7.108-16.897-7.108-16.897s-4.212-13.75-9.789-13.75",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M71.716 124.225s.855 11.264 9.828 6.486c4.765-2.536 7.581-13.828 9.789-22.568 1.456-5.768 2.58-12.197 2.58-12.197l-4.973-1.709s-2.408 5.516-7.769 12.275c-4.335 5.467-9.144 11.11-9.455 17.713",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M108.463 105.191s1.747 2.724-2.331 30.535c2.376 2.216 1.053 6.012-.233 7.51",
  stroke: "#E4EBF7",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M123.262 131.527s-.427 2.732-11.77 1.981c-15.187-1.006-25.326-3.25-25.326-3.25l.933-5.8s.723.215 9.71-.068c11.887-.373 18.714-6.07 24.964-1.022 4.039 3.263 1.489 8.16 1.489 8.16",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M70.24 90.974s-5.593-4.739-11.054 2.68c-3.318 7.223.517 15.284 2.664 19.578-.31 3.729 2.33 4.311 2.33 4.311s.108.895 1.516 2.68c4.078-7.03 6.72-9.166 13.711-12.546-.328-.656-1.877-3.265-1.825-3.767.175-1.69-1.282-2.623-1.282-2.623s-.286-.156-1.165-2.738c-.788-2.313-2.036-5.177-4.895-7.575",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M90.232 288.027s4.855 2.308 8.313 1.155c3.188-1.063 5.12.755 8.002 1.331 2.881.577 7.769 1.243 13.207-1.424-.117-6.228-7.786-4.499-13.518-7.588-2.895-1.56-4.276-5.336-4.066-9.944H91.544s-1.573 11.89-1.312 16.47",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M90.207 287.833s2.745 1.437 7.639.738c3.456-.494 3.223.66 7.418 1.282 4.195.621 13.092-.194 14.334-1.126.466 1.242-.388 2.33-.388 2.33s-1.709.682-5.438.932c-2.295.154-8.098.276-10.14-.621-2.02-1.554-4.894-1.515-6.06-.234-4.427 1.075-7.184-.31-7.184-.31l-.181-2.991z",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M98.429 272.257h3.496s-.117 7.574 5.127 9.671c-5.244.7-9.672-2.602-8.623-9.671",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M44.425 272.046s-2.208 7.774-4.702 12.899c-1.884 3.874-4.428 7.854 5.729 7.854 6.97 0 9.385-.503 7.782-6.917-1.604-6.415.279-13.836.279-13.836h-9.088z",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M38.066 290.277s2.198 1.225 6.954 1.225c6.376 0 8.646-1.73 8.646-1.73s.63 1.168-.649 2.27c-1.04.897-3.77 1.668-7.745 1.621-4.347-.05-6.115-.593-7.062-1.224-.864-.577-.72-1.657-.144-2.162",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M45.344 274.041s.035 1.592-.329 3.07c-.365 1.49-1.13 3.255-1.184 4.34-.061 1.206 4.755 1.657 5.403.036.65-1.622 1.357-6.737 2.006-7.602.648-.865-5.14-2.222-5.896.156",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M89.476 277.57l13.899.095s1.349-56.643 1.925-66.909c.576-10.267 3.923-45.052 1.042-65.585l-13.037-.669-23.737.81s-.452 4.12-1.243 10.365c-.065.515-.708.874-.777 1.417-.078.608.439 1.407.332 2.044-2.455 14.627-5.797 32.736-8.256 46.837-.121.693-1.282 1.048-1.515 2.796-.042.314.22 1.584.116 1.865-7.14 19.473-12.202 52.601-15.66 67.19l15.176-.015s2.282-10.145 4.185-18.871c2.922-13.389 24.012-88.32 24.012-88.32l3.133-.954-.158 48.568s-.233 1.282.35 2.098c.583.815-.581 1.167-.408 2.331l.408 1.864s-.466 7.458-.932 12.352c-.467 4.895 1.145 40.69 1.145 40.69",
  fill: "#7BB2F9"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M64.57 218.881c1.197.099 4.195-2.097 7.225-5.127M96.024 222.534s2.881-1.152 6.34-4.034",
  stroke: "#648BD8",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M96.973 219.373s2.882-1.153 6.34-4.034",
  stroke: "#648BD8",
  strokeWidth: "1.032",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M63.172 222.144s2.724-.614 6.759-3.496M74.903 146.166c-.281 3.226.31 8.856-4.506 9.478M93.182 144.344s.115 14.557-1.344 15.65c-2.305 1.73-3.107 2.02-3.107 2.02M89.197 144.923s.269 13.144-1.01 25.088M83.525 170.71s6.81-1.051 9.116-1.051M46.026 270.045l-.892 4.538M46.937 263.289l-.815 4.157M62.725 202.503c-.33 1.618-.102 1.904-.449 3.438 0 0-2.756 1.903-2.29 3.923.466 2.02-.31 3.424-4.505 17.252-1.762 5.807-4.233 18.922-6.165 28.278-.03.144-.521 2.646-1.14 5.8M64.158 194.136c-.295 1.658-.6 3.31-.917 4.938M71.33 146.787l-1.244 10.877s-1.14.155-.519 2.33c.117 1.399-2.778 16.39-5.382 31.615M44.242 273.727H58.07",
  stroke: "#648BD8",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M106.18 142.117c-3.028-.489-18.825-2.744-36.219.2a.625.625 0 0 0-.518.644c.063 1.307.044 2.343.015 2.995a.617.617 0 0 0 .716.636c3.303-.534 17.037-2.412 35.664-.266.347.04.66-.214.692-.56.124-1.347.16-2.425.17-3.029a.616.616 0 0 0-.52-.62",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M96.398 145.264l.003-5.102a.843.843 0 0 0-.809-.847 114.104 114.104 0 0 0-8.141-.014.85.85 0 0 0-.82.847l-.003 5.097c0 .476.388.857.864.845 2.478-.064 5.166-.067 8.03.017a.848.848 0 0 0 .876-.843",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M95.239 144.296l.002-3.195a.667.667 0 0 0-.643-.672c-1.9-.061-3.941-.073-6.094-.01a.675.675 0 0 0-.654.672l-.002 3.192c0 .376.305.677.68.669 1.859-.042 3.874-.043 6.02.012.376.01.69-.291.691-.668",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M90.102 273.522h12.819M91.216 269.761c.006 3.519-.072 5.55 0 6.292M90.923 263.474c-.009 1.599-.016 2.558-.016 4.505M90.44 170.404l.932 46.38s.7 1.631-.233 2.796c-.932 1.166 2.564.7.932 2.33-1.63 1.633.933 1.166 0 3.497-.618 1.546-1.031 21.921-1.138 36.513",
  stroke: "#648BD8",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M73.736 98.665l2.214 4.312s2.098.816 1.865 2.68l.816 2.214M64.297 116.611c.233-.932 2.176-7.147 12.585-10.488M77.598 90.042s7.691 6.137 16.547 2.72",
  stroke: "#E4EBF7",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M91.974 86.954s5.476-.816 7.574-4.545c1.297-.345.72 2.212-.33 3.671-.7.971-1.01 1.554-1.01 1.554s.194.31.155.816c-.053.697-.175.653-.272 1.048-.081.335.108.657 0 1.049-.046.17-.198.5-.382.878-.12.249-.072.687-.2.948-.231.469-1.562 1.87-2.622 2.855-3.826 3.554-5.018 1.644-6.001-.408-.894-1.865-.661-5.127-.874-6.875-.35-2.914-2.622-3.03-1.923-4.429.343-.685 2.87.69 3.263 1.748.757 2.04 2.952 1.807 2.622 1.69",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M99.8 82.429c-.465.077-.35.272-.97 1.243-.622.971-4.817 2.932-6.39 3.224-2.589.48-2.278-1.56-4.254-2.855-1.69-1.107-3.562-.638-1.398 1.398.99.932.932 1.107 1.398 3.205.335 1.506-.64 3.67.7 5.593",
  stroke: "#DB836E",
  strokeWidth: ".774",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M79.543 108.673c-2.1 2.926-4.266 6.175-5.557 8.762",
  stroke: "#E59788",
  strokeWidth: ".774",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M87.72 124.768s-2.098-1.942-5.127-2.719c-3.03-.777-3.574-.155-5.516.078-1.942.233-3.885-.932-3.652.7.233 1.63 5.05 1.01 5.206 2.097.155 1.087-6.37 2.796-8.313 2.175-.777.777.466 1.864 2.02 2.175.233 1.554 2.253 1.554 2.253 1.554s.699 1.01 2.641 1.088c2.486 1.32 8.934-.7 10.954-1.554 2.02-.855-.466-5.594-.466-5.594",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M73.425 122.826s.66 1.127 3.167 1.418c2.315.27 2.563.583 2.563.583s-2.545 2.894-9.07 2.272M72.416 129.274s3.826.097 4.933-.718M74.98 130.75s1.961.136 3.36-.505M77.232 131.916s1.748.019 2.914-.505M73.328 122.321s-.595-1.032 1.262-.427c1.671.544 2.833.055 5.128.155 1.389.061 3.067-.297 3.982.15 1.606.784 3.632 2.181 3.632 2.181s10.526 1.204 19.033-1.127M78.864 108.104s-8.39 2.758-13.168 12.12",
  stroke: "#E59788",
  strokeWidth: ".774",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M109.278 112.533s3.38-3.613 7.575-4.662",
  stroke: "#E4EBF7",
  strokeWidth: "1.085",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M107.375 123.006s9.697-2.745 11.445-.88",
  stroke: "#E59788",
  strokeWidth: ".774",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M194.605 83.656l3.971-3.886M187.166 90.933l3.736-3.655M191.752 84.207l-4.462-4.56M198.453 91.057l-4.133-4.225M129.256 163.074l3.718-3.718M122.291 170.039l3.498-3.498M126.561 163.626l-4.27-4.27M132.975 170.039l-3.955-3.955",
  stroke: "#BFCDDD",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M190.156 211.779h-1.604a4.023 4.023 0 0 1-4.011-4.011V175.68a4.023 4.023 0 0 1 4.01-4.01h1.605a4.023 4.023 0 0 1 4.011 4.01v32.088a4.023 4.023 0 0 1-4.01 4.01",
  fill: "#A3B4C6"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M237.824 212.977a4.813 4.813 0 0 1-4.813 4.813h-86.636a4.813 4.813 0 0 1 0-9.626h86.636a4.813 4.813 0 0 1 4.813 4.813",
  fill: "#A3B4C6"
}), /* @__PURE__ */ reactExports.createElement("mask", {
  fill: "#fff"
}), /* @__PURE__ */ reactExports.createElement("path", {
  fill: "#A3B4C6",
  mask: "url(#d)",
  d: "M154.098 190.096h70.513v-84.617h-70.513z"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M224.928 190.096H153.78a3.219 3.219 0 0 1-3.208-3.209V167.92a3.219 3.219 0 0 1 3.208-3.21h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.219 3.219 0 0 1-3.21 3.209M224.928 130.832H153.78a3.218 3.218 0 0 1-3.208-3.208v-18.968a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.218 3.218 0 0 1-3.21 3.208",
  fill: "#BFCDDD",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M159.563 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 120.546h-22.461a.802.802 0 0 1-.802-.802v-3.208c0-.443.359-.803.802-.803h22.46c.444 0 .803.36.803.803v3.208c0 .443-.36.802-.802.802",
  fill: "#FFF",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M224.928 160.464H153.78a3.218 3.218 0 0 1-3.208-3.209v-18.967a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.209v18.967a3.218 3.218 0 0 1-3.21 3.209",
  fill: "#BFCDDD",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M173.455 130.832h49.301M164.984 130.832h6.089M155.952 130.832h6.75M173.837 160.613h49.3M165.365 160.613h6.089M155.57 160.613h6.751",
  stroke: "#7C90A5",
  strokeWidth: "1.124",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M159.563 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M166.98 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M174.397 151.038a2.407 2.407 0 1 1 .001-4.814 2.407 2.407 0 0 1 0 4.814M222.539 151.038h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802M159.563 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 179.987h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802",
  fill: "#FFF",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M203.04 221.108h-27.372a2.413 2.413 0 0 1-2.406-2.407v-11.448a2.414 2.414 0 0 1 2.406-2.407h27.372a2.414 2.414 0 0 1 2.407 2.407V218.7a2.413 2.413 0 0 1-2.407 2.407",
  fill: "#BFCDDD",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M177.259 207.217v11.52M201.05 207.217v11.52",
  stroke: "#A3B4C6",
  strokeWidth: "1.124",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M162.873 267.894a9.422 9.422 0 0 1-9.422-9.422v-14.82a9.423 9.423 0 0 1 18.845 0v14.82a9.423 9.423 0 0 1-9.423 9.422",
  fill: "#5BA02E",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M171.22 267.83a9.422 9.422 0 0 1-9.422-9.423v-3.438a9.423 9.423 0 0 1 18.845 0v3.438a9.423 9.423 0 0 1-9.422 9.423",
  fill: "#92C110",
  mask: "url(#d)"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M181.31 293.666h-27.712a3.209 3.209 0 0 1-3.209-3.21V269.79a3.209 3.209 0 0 1 3.209-3.21h27.711a3.209 3.209 0 0 1 3.209 3.21v20.668a3.209 3.209 0 0 1-3.209 3.209",
  fill: "#F2D7AD",
  mask: "url(#d)"
}))), serverError = ServerError, genBaseStyle$4 = (a) => {
  const {
    componentCls: s,
    lineHeightHeading3: $,
    iconCls: _,
    padding: _e,
    paddingXL: tt,
    paddingXS: nt,
    paddingLG: at,
    marginXS: ot,
    lineHeight: rt
  } = a;
  return {
    // Result
    [s]: {
      padding: `${unit$1(a.calc(at).mul(2).equal())} ${unit$1(tt)}`,
      // RTL
      "&-rtl": {
        direction: "rtl"
      }
    },
    // Exception Status image
    [`${s} ${s}-image`]: {
      width: a.imageWidth,
      height: a.imageHeight,
      margin: "auto"
    },
    [`${s} ${s}-icon`]: {
      marginBottom: at,
      textAlign: "center",
      [`& > ${_}`]: {
        fontSize: a.iconFontSize
      }
    },
    [`${s} ${s}-title`]: {
      color: a.colorTextHeading,
      fontSize: a.titleFontSize,
      lineHeight: $,
      marginBlock: ot,
      textAlign: "center"
    },
    [`${s} ${s}-subtitle`]: {
      color: a.colorTextDescription,
      fontSize: a.subtitleFontSize,
      lineHeight: rt,
      textAlign: "center"
    },
    [`${s} ${s}-content`]: {
      marginTop: at,
      padding: `${unit$1(at)} ${unit$1(a.calc(_e).mul(2.5).equal())}`,
      backgroundColor: a.colorFillAlter
    },
    [`${s} ${s}-extra`]: {
      margin: a.extraMargin,
      textAlign: "center",
      "& > *": {
        marginInlineEnd: nt,
        "&:last-child": {
          marginInlineEnd: 0
        }
      }
    }
  };
}, genStatusIconStyle = (a) => {
  const {
    componentCls: s,
    iconCls: $
  } = a;
  return {
    [`${s}-success ${s}-icon > ${$}`]: {
      color: a.resultSuccessIconColor
    },
    [`${s}-error ${s}-icon > ${$}`]: {
      color: a.resultErrorIconColor
    },
    [`${s}-info ${s}-icon > ${$}`]: {
      color: a.resultInfoIconColor
    },
    [`${s}-warning ${s}-icon > ${$}`]: {
      color: a.resultWarningIconColor
    }
  };
}, genResultStyle = (a) => [genBaseStyle$4(a), genStatusIconStyle(a)], getStyle = (a) => genResultStyle(a), prepareComponentToken$6 = (a) => ({
  titleFontSize: a.fontSizeHeading3,
  subtitleFontSize: a.fontSize,
  iconFontSize: a.fontSizeHeading3 * 3,
  extraMargin: `${a.paddingLG}px 0 0 0`
}), useStyle$6 = genStyleHooks("Result", (a) => {
  const s = a.colorInfo, $ = a.colorError, _ = a.colorSuccess, _e = a.colorWarning, tt = merge(a, {
    resultInfoIconColor: s,
    resultErrorIconColor: $,
    resultSuccessIconColor: _,
    resultWarningIconColor: _e,
    imageWidth: 250,
    imageHeight: 295
  });
  return [getStyle(tt)];
}, prepareComponentToken$6), Unauthorized = () => /* @__PURE__ */ reactExports.createElement("svg", {
  width: "251",
  height: "294"
}, /* @__PURE__ */ reactExports.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ reactExports.createElement("path", {
  d: "M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023",
  fill: "#E4EBF7"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z",
  stroke: "#FFF",
  strokeWidth: "2"
}), /* @__PURE__ */ reactExports.createElement("path", {
  stroke: "#FFF",
  strokeWidth: "2",
  d: "M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321",
  fill: "#A26EF4"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61",
  fill: "#5BA02E"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611",
  fill: "#92C110"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17",
  fill: "#F2D7AD"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367",
  fill: "#FFB594"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M78.18 94.656s.911 7.41-4.914 13.078",
  stroke: "#E4EBF7",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437",
  stroke: "#E4EBF7",
  strokeWidth: ".932",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91",
  fill: "#FFB594"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103",
  fill: "#5C2552"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  stroke: "#DB836E",
  strokeWidth: "1.145",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M100.843 77.099l1.701-.928-1.015-4.324.674-1.406"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32",
  fill: "#552950"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M91.132 86.786s5.269 4.957 12.679 2.327",
  stroke: "#DB836E",
  strokeWidth: "1.145",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25",
  fill: "#DB836E"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073",
  stroke: "#5C2552",
  strokeWidth: "1.526",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254",
  stroke: "#DB836E",
  strokeWidth: "1.145",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008",
  stroke: "#E4EBF7",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M66.508 86.763s-1.598 8.83-6.697 14.078",
  stroke: "#E4EBF7",
  strokeWidth: "1.114",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M128.31 87.934s3.013 4.121 4.06 11.785",
  stroke: "#E4EBF7",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M64.09 84.816s-6.03 9.912-13.607 9.903",
  stroke: "#DB836E",
  strokeWidth: ".795",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73",
  fill: "#FFC6A0"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M130.532 85.488s4.588 5.757 11.619 6.214",
  stroke: "#DB836E",
  strokeWidth: ".75",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M121.708 105.73s-.393 8.564-1.34 13.612",
  stroke: "#E4EBF7",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M115.784 161.512s-3.57-1.488-2.678-7.14",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z",
  fill: "#CBD1D1"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078",
  fill: "#2B0849"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15",
  fill: "#A4AABA"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954",
  fill: "#7BB2F9"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M108.459 220.905s2.759-1.104 6.07-3.863",
  stroke: "#648BD8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806",
  fill: "#FFF"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64",
  fill: "#192064"
}), /* @__PURE__ */ reactExports.createElement("path", {
  d: "M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956",
  stroke: "#648BD8",
  strokeWidth: "1.051",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), unauthorized = Unauthorized, IconMap = {
  success: CheckCircleFilled$1,
  error: CloseCircleFilled$1,
  info: ExclamationCircleFilled$1,
  warning: WarningFilled$1
}, ExceptionMap = {
  404: noFound,
  500: serverError,
  403: unauthorized
}, ExceptionStatus = Object.keys(ExceptionMap), Icon = (a) => {
  let {
    prefixCls: s,
    icon: $,
    status: _
  } = a;
  const _e = classnames(`${s}-icon`);
  if (ExceptionStatus.includes(`${_}`)) {
    const nt = ExceptionMap[_];
    return /* @__PURE__ */ reactExports.createElement("div", {
      className: `${_e} ${s}-image`
    }, /* @__PURE__ */ reactExports.createElement(nt, null));
  }
  const tt = /* @__PURE__ */ reactExports.createElement(IconMap[_]);
  return $ === null || $ === !1 ? null : /* @__PURE__ */ reactExports.createElement("div", {
    className: _e
  }, $ || tt);
}, Extra = (a) => {
  let {
    prefixCls: s,
    extra: $
  } = a;
  return $ ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${s}-extra`
  }, $) : null;
}, Result$1 = (a) => {
  let {
    prefixCls: s,
    className: $,
    rootClassName: _,
    subTitle: _e,
    title: tt,
    style: nt,
    children: at,
    status: ot = "info",
    icon: rt,
    extra: st
  } = a;
  const {
    getPrefixCls: lt,
    direction: et,
    result: it
  } = reactExports.useContext(ConfigContext$1), ut = lt("result", s), [ft, ht, dt] = useStyle$6(ut), gt = classnames(ut, `${ut}-${ot}`, $, it == null ? void 0 : it.className, _, {
    [`${ut}-rtl`]: et === "rtl"
  }, ht, dt), pt = Object.assign(Object.assign({}, it == null ? void 0 : it.style), nt);
  return ft(/* @__PURE__ */ reactExports.createElement("div", {
    className: gt,
    style: pt
  }, /* @__PURE__ */ reactExports.createElement(Icon, {
    prefixCls: ut,
    status: ot,
    icon: rt
  }), /* @__PURE__ */ reactExports.createElement("div", {
    className: `${ut}-title`
  }, tt), _e && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${ut}-subtitle`
  }, _e), /* @__PURE__ */ reactExports.createElement(Extra, {
    prefixCls: ut,
    extra: st
  }), at && /* @__PURE__ */ reactExports.createElement("div", {
    className: `${ut}-content`
  }, at)));
};
Result$1.PRESENTED_IMAGE_403 = ExceptionMap[403];
Result$1.PRESENTED_IMAGE_404 = ExceptionMap[404];
Result$1.PRESENTED_IMAGE_500 = ExceptionMap[500];
const Result$2 = Result$1;
var SliderContext = /* @__PURE__ */ reactExports.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
});
function getOffset$1(a, s, $) {
  return (a - s) / ($ - s);
}
function getDirectionStyle(a, s, $, _) {
  var _e = getOffset$1(s, $, _), tt = {};
  switch (a) {
    case "rtl":
      tt.right = "".concat(_e * 100, "%"), tt.transform = "translateX(50%)";
      break;
    case "btt":
      tt.bottom = "".concat(_e * 100, "%"), tt.transform = "translateY(50%)";
      break;
    case "ttb":
      tt.top = "".concat(_e * 100, "%"), tt.transform = "translateY(-50%)";
      break;
    default:
      tt.left = "".concat(_e * 100, "%"), tt.transform = "translateX(-50%)";
      break;
  }
  return tt;
}
function getIndex(a, s) {
  return Array.isArray(a) ? a[s] : a;
}
var _excluded$f = ["prefixCls", "value", "valueIndex", "onStartMove", "style", "render", "dragging", "onOffsetChange", "onChangeComplete"], Handle = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _, _e = a.prefixCls, tt = a.value, nt = a.valueIndex, at = a.onStartMove, ot = a.style, rt = a.render, st = a.dragging, lt = a.onOffsetChange, et = a.onChangeComplete, it = _objectWithoutProperties$1(a, _excluded$f), ut = reactExports.useContext(SliderContext), ft = ut.min, ht = ut.max, dt = ut.direction, gt = ut.disabled, pt = ut.keyboard, mt = ut.range, ct = ut.tabIndex, vt = ut.ariaLabelForHandle, At = ut.ariaLabelledByForHandle, xt = ut.ariaValueTextFormatterForHandle, bt = ut.styles, Et = ut.classNames, St = "".concat(_e, "-handle"), Bt = function(yt) {
    gt || at(yt, nt);
  }, Ot = function(yt) {
    if (!gt && pt) {
      var Rt = null;
      switch (yt.which || yt.keyCode) {
        case KeyCode.LEFT:
          Rt = dt === "ltr" || dt === "btt" ? -1 : 1;
          break;
        case KeyCode.RIGHT:
          Rt = dt === "ltr" || dt === "btt" ? 1 : -1;
          break;
        case KeyCode.UP:
          Rt = dt !== "ttb" ? 1 : -1;
          break;
        case KeyCode.DOWN:
          Rt = dt !== "ttb" ? -1 : 1;
          break;
        case KeyCode.HOME:
          Rt = "min";
          break;
        case KeyCode.END:
          Rt = "max";
          break;
        case KeyCode.PAGE_UP:
          Rt = 2;
          break;
        case KeyCode.PAGE_DOWN:
          Rt = -2;
          break;
      }
      Rt !== null && (yt.preventDefault(), lt(Rt, nt));
    }
  }, Pt = function(yt) {
    switch (yt.which || yt.keyCode) {
      case KeyCode.LEFT:
      case KeyCode.RIGHT:
      case KeyCode.UP:
      case KeyCode.DOWN:
      case KeyCode.HOME:
      case KeyCode.END:
      case KeyCode.PAGE_UP:
      case KeyCode.PAGE_DOWN:
        et == null || et();
        break;
    }
  }, wt = getDirectionStyle(dt, tt, ft, ht), Ct = /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    ref: s,
    className: classnames(St, ($ = {}, _defineProperty$c($, "".concat(St, "-").concat(nt + 1), mt), _defineProperty$c($, "".concat(St, "-dragging"), st), $), Et.handle),
    style: _objectSpread2$a(_objectSpread2$a(_objectSpread2$a({}, wt), ot), bt.handle),
    onMouseDown: Bt,
    onTouchStart: Bt,
    onKeyDown: Ot,
    onKeyUp: Pt,
    tabIndex: gt ? null : getIndex(ct, nt),
    role: "slider",
    "aria-valuemin": ft,
    "aria-valuemax": ht,
    "aria-valuenow": tt,
    "aria-disabled": gt,
    "aria-label": getIndex(vt, nt),
    "aria-labelledby": getIndex(At, nt),
    "aria-valuetext": (_ = getIndex(xt, nt)) === null || _ === void 0 ? void 0 : _(tt),
    "aria-orientation": dt === "ltr" || dt === "rtl" ? "horizontal" : "vertical"
  }, it));
  return rt && (Ct = rt(Ct, {
    index: nt,
    prefixCls: _e,
    value: tt,
    dragging: st
  })), Ct;
}), _excluded$e = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "draggingIndex"], Handles = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = a.style, _e = a.onStartMove, tt = a.onOffsetChange, nt = a.values, at = a.handleRender, ot = a.draggingIndex, rt = _objectWithoutProperties$1(a, _excluded$e), st = reactExports.useRef({});
  return reactExports.useImperativeHandle(s, function() {
    return {
      focus: function(et) {
        var it;
        (it = st.current[et]) === null || it === void 0 || it.focus();
      }
    };
  }), /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, nt.map(function(lt, et) {
    return /* @__PURE__ */ reactExports.createElement(Handle, _extends$2({
      ref: function(ut) {
        ut ? st.current[et] = ut : delete st.current[et];
      },
      dragging: ot === et,
      prefixCls: $,
      style: getIndex(_, et),
      key: et,
      value: lt,
      valueIndex: et,
      onStartMove: _e,
      onOffsetChange: tt,
      render: at
    }, rt));
  }));
});
function getPosition$1(a) {
  var s = "touches" in a ? a.touches[0] : a;
  return {
    pageX: s.pageX,
    pageY: s.pageY
  };
}
function useDrag(a, s, $, _, _e, tt, nt, at, ot) {
  var rt = reactExports.useState(null), st = _slicedToArray$e(rt, 2), lt = st[0], et = st[1], it = reactExports.useState(-1), ut = _slicedToArray$e(it, 2), ft = ut[0], ht = ut[1], dt = reactExports.useState($), gt = _slicedToArray$e(dt, 2), pt = gt[0], mt = gt[1], ct = reactExports.useState($), vt = _slicedToArray$e(ct, 2), At = vt[0], xt = vt[1], bt = reactExports.useRef(null), Et = reactExports.useRef(null);
  reactExports.useEffect(function() {
    ft === -1 && mt($);
  }, [$, ft]), reactExports.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", bt.current), document.removeEventListener("mouseup", Et.current), document.removeEventListener("touchmove", bt.current), document.removeEventListener("touchend", Et.current);
    };
  }, []);
  var St = function(It, yt) {
    pt.some(function(Rt, kt) {
      return Rt !== It[kt];
    }) && (yt !== void 0 && et(yt), mt(It), nt(It));
  }, Bt = function(It, yt) {
    if (It === -1) {
      var Rt = At[0], kt = At[At.length - 1], jt = _ - Rt, Ht = _e - kt, Ft = yt * (_e - _);
      Ft = Math.max(Ft, jt), Ft = Math.min(Ft, Ht);
      var _t = tt(Rt + Ft);
      Ft = _t - Rt;
      var Nt = At.map(function(Tt) {
        return Tt + Ft;
      });
      St(Nt);
    } else {
      var Mt = (_e - _) * yt, Lt = _toConsumableArray$d(pt);
      Lt[It] = At[It];
      var $t = ot(Lt, Mt, It, "dist");
      St($t.values, $t.value);
    }
  }, Ot = reactExports.useRef(Bt);
  Ot.current = Bt;
  var Pt = function(It, yt, Rt) {
    It.stopPropagation();
    var kt = Rt || $, jt = kt[yt];
    ht(yt), et(jt), xt(kt);
    var Ht = getPosition$1(It), Ft = Ht.pageX, _t = Ht.pageY, Nt = function($t) {
      $t.preventDefault();
      var Tt = getPosition$1($t), Dt = Tt.pageX, Ut = Tt.pageY, Vt = Dt - Ft, Qt = Ut - _t, qt = a.current.getBoundingClientRect(), Zt = qt.width, ar = qt.height, Jt;
      switch (s) {
        case "btt":
          Jt = -Qt / ar;
          break;
        case "ttb":
          Jt = Qt / ar;
          break;
        case "rtl":
          Jt = -Vt / Zt;
          break;
        default:
          Jt = Vt / Zt;
      }
      Ot.current(yt, Jt);
    }, Mt = function Lt($t) {
      $t.preventDefault(), document.removeEventListener("mouseup", Lt), document.removeEventListener("mousemove", Nt), document.removeEventListener("touchend", Lt), document.removeEventListener("touchmove", Nt), bt.current = null, Et.current = null, ht(-1), at();
    };
    document.addEventListener("mouseup", Mt), document.addEventListener("mousemove", Nt), document.addEventListener("touchend", Mt), document.addEventListener("touchmove", Nt), bt.current = Nt, Et.current = Mt;
  }, wt = reactExports.useMemo(function() {
    var Ct = _toConsumableArray$d($).sort(function(yt, Rt) {
      return yt - Rt;
    }), It = _toConsumableArray$d(pt).sort(function(yt, Rt) {
      return yt - Rt;
    });
    return Ct.every(function(yt, Rt) {
      return yt === It[Rt];
    }) ? pt : $;
  }, [$, pt]);
  return [ft, lt, wt, Pt];
}
function useOffset(a, s, $, _, _e, tt) {
  var nt = reactExports.useCallback(function(it) {
    var ut = isFinite(it) ? it : a;
    return ut = Math.min(s, it), ut = Math.max(a, ut), ut;
  }, [a, s]), at = reactExports.useCallback(function(it) {
    if ($ !== null) {
      var ut = a + Math.round((nt(it) - a) / $) * $, ft = function(pt) {
        return (String(pt).split(".")[1] || "").length;
      }, ht = Math.max(ft($), ft(s), ft(a)), dt = Number(ut.toFixed(ht));
      return a <= dt && dt <= s ? dt : null;
    }
    return null;
  }, [$, a, s, nt]), ot = reactExports.useCallback(function(it) {
    var ut = nt(it), ft = _.map(function(gt) {
      return gt.value;
    });
    $ !== null && ft.push(at(it)), ft.push(a, s);
    var ht = ft[0], dt = s - a;
    return ft.forEach(function(gt) {
      var pt = Math.abs(ut - gt);
      pt <= dt && (ht = gt, dt = pt);
    }), ht;
  }, [a, s, _, $, nt, at]), rt = function it(ut, ft, ht) {
    var dt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof ft == "number") {
      var gt, pt = ut[ht], mt = pt + ft, ct = [];
      _.forEach(function(Et) {
        ct.push(Et.value);
      }), ct.push(a, s), ct.push(at(pt));
      var vt = ft > 0 ? 1 : -1;
      dt === "unit" ? ct.push(at(pt + vt * $)) : ct.push(at(mt)), ct = ct.filter(function(Et) {
        return Et !== null;
      }).filter(function(Et) {
        return ft < 0 ? Et <= pt : Et >= pt;
      }), dt === "unit" && (ct = ct.filter(function(Et) {
        return Et !== pt;
      }));
      var At = dt === "unit" ? pt : mt;
      gt = ct[0];
      var xt = Math.abs(gt - At);
      if (ct.forEach(function(Et) {
        var St = Math.abs(Et - At);
        St < xt && (gt = Et, xt = St);
      }), gt === void 0)
        return ft < 0 ? a : s;
      if (dt === "dist")
        return gt;
      if (Math.abs(ft) > 1) {
        var bt = _toConsumableArray$d(ut);
        return bt[ht] = gt, it(bt, ft - vt, ht, dt);
      }
      return gt;
    } else {
      if (ft === "min")
        return a;
      if (ft === "max")
        return s;
    }
  }, st = function(ut, ft, ht) {
    var dt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", gt = ut[ht], pt = rt(ut, ft, ht, dt);
    return {
      value: pt,
      changed: pt !== gt
    };
  }, lt = function(ut) {
    return tt === null && ut === 0 || typeof tt == "number" && ut < tt;
  }, et = function(ut, ft, ht) {
    var dt = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", gt = ut.map(ot), pt = gt[ht], mt = rt(gt, ft, ht, dt);
    if (gt[ht] = mt, _e === !1) {
      var ct = tt || 0;
      ht > 0 && gt[ht - 1] !== pt && (gt[ht] = Math.max(gt[ht], gt[ht - 1] + ct)), ht < gt.length - 1 && gt[ht + 1] !== pt && (gt[ht] = Math.min(gt[ht], gt[ht + 1] - ct));
    } else if (typeof tt == "number" || tt === null) {
      for (var vt = ht + 1; vt < gt.length; vt += 1)
        for (var At = !0; lt(gt[vt] - gt[vt - 1]) && At; ) {
          var xt = st(gt, 1, vt);
          gt[vt] = xt.value, At = xt.changed;
        }
      for (var bt = ht; bt > 0; bt -= 1)
        for (var Et = !0; lt(gt[bt] - gt[bt - 1]) && Et; ) {
          var St = st(gt, -1, bt - 1);
          gt[bt - 1] = St.value, Et = St.changed;
        }
      for (var Bt = gt.length - 1; Bt > 0; Bt -= 1)
        for (var Ot = !0; lt(gt[Bt] - gt[Bt - 1]) && Ot; ) {
          var Pt = st(gt, -1, Bt - 1);
          gt[Bt - 1] = Pt.value, Ot = Pt.changed;
        }
      for (var wt = 0; wt < gt.length - 1; wt += 1)
        for (var Ct = !0; lt(gt[wt + 1] - gt[wt]) && Ct; ) {
          var It = st(gt, 1, wt + 1);
          gt[wt + 1] = It.value, Ct = It.changed;
        }
    }
    return {
      value: gt[ht],
      values: gt
    };
  };
  return [ot, et];
}
function Mark(a) {
  var s = a.prefixCls, $ = a.style, _ = a.children, _e = a.value, tt = a.onClick, nt = reactExports.useContext(SliderContext), at = nt.min, ot = nt.max, rt = nt.direction, st = nt.includedStart, lt = nt.includedEnd, et = nt.included, it = "".concat(s, "-text"), ut = getDirectionStyle(rt, _e, at, ot);
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(it, _defineProperty$c({}, "".concat(it, "-active"), et && st <= _e && _e <= lt)),
    style: _objectSpread2$a(_objectSpread2$a({}, ut), $),
    onMouseDown: function(ht) {
      ht.stopPropagation();
    },
    onClick: function() {
      tt(_e);
    }
  }, _);
}
function Marks(a) {
  var s = a.prefixCls, $ = a.marks, _ = a.onClick, _e = "".concat(s, "-mark");
  return $.length ? /* @__PURE__ */ reactExports.createElement("div", {
    className: _e
  }, $.map(function(tt) {
    var nt = tt.value, at = tt.style, ot = tt.label;
    return /* @__PURE__ */ reactExports.createElement(Mark, {
      key: nt,
      prefixCls: _e,
      style: at,
      value: nt,
      onClick: _
    }, ot);
  })) : null;
}
function Dot(a) {
  var s = a.prefixCls, $ = a.value, _ = a.style, _e = a.activeStyle, tt = reactExports.useContext(SliderContext), nt = tt.min, at = tt.max, ot = tt.direction, rt = tt.included, st = tt.includedStart, lt = tt.includedEnd, et = "".concat(s, "-dot"), it = rt && st <= $ && $ <= lt, ut = _objectSpread2$a(_objectSpread2$a({}, getDirectionStyle(ot, $, nt, at)), typeof _ == "function" ? _($) : _);
  return it && (ut = _objectSpread2$a(_objectSpread2$a({}, ut), typeof _e == "function" ? _e($) : _e)), /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(et, _defineProperty$c({}, "".concat(et, "-active"), it)),
    style: ut
  });
}
function Steps(a) {
  var s = a.prefixCls, $ = a.marks, _ = a.dots, _e = a.style, tt = a.activeStyle, nt = reactExports.useContext(SliderContext), at = nt.min, ot = nt.max, rt = nt.step, st = reactExports.useMemo(function() {
    var lt = /* @__PURE__ */ new Set();
    if ($.forEach(function(it) {
      lt.add(it.value);
    }), _ && rt !== null)
      for (var et = at; et <= ot; )
        lt.add(et), et += rt;
    return Array.from(lt);
  }, [at, ot, rt, _, $]);
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat(s, "-step")
  }, st.map(function(lt) {
    return /* @__PURE__ */ reactExports.createElement(Dot, {
      prefixCls: s,
      key: lt,
      value: lt,
      style: _e,
      activeStyle: tt
    });
  }));
}
function Track(a) {
  var s, $ = a.prefixCls, _ = a.style, _e = a.start, tt = a.end, nt = a.index, at = a.onStartMove, ot = a.replaceCls, rt = reactExports.useContext(SliderContext), st = rt.direction, lt = rt.min, et = rt.max, it = rt.disabled, ut = rt.range, ft = rt.classNames, ht = "".concat($, "-track"), dt = getOffset$1(_e, lt, et), gt = getOffset$1(tt, lt, et), pt = function(At) {
    !it && at && at(At, -1);
  }, mt = {};
  switch (st) {
    case "rtl":
      mt.right = "".concat(dt * 100, "%"), mt.width = "".concat(gt * 100 - dt * 100, "%");
      break;
    case "btt":
      mt.bottom = "".concat(dt * 100, "%"), mt.height = "".concat(gt * 100 - dt * 100, "%");
      break;
    case "ttb":
      mt.top = "".concat(dt * 100, "%"), mt.height = "".concat(gt * 100 - dt * 100, "%");
      break;
    default:
      mt.left = "".concat(dt * 100, "%"), mt.width = "".concat(gt * 100 - dt * 100, "%");
  }
  var ct = ot || classnames(ht, (s = {}, _defineProperty$c(s, "".concat(ht, "-").concat(nt + 1), nt !== null && ut), _defineProperty$c(s, "".concat($, "-track-draggable"), at), s), ft.track);
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: ct,
    style: _objectSpread2$a(_objectSpread2$a({}, mt), _),
    onMouseDown: pt,
    onTouchStart: pt
  });
}
function Tracks(a) {
  var s = a.prefixCls, $ = a.style, _ = a.values, _e = a.startPoint, tt = a.onStartMove, nt = reactExports.useContext(SliderContext), at = nt.included, ot = nt.range, rt = nt.min, st = nt.styles, lt = nt.classNames, et = reactExports.useMemo(function() {
    if (!ot) {
      if (_.length === 0)
        return [];
      var ut = _e ?? rt, ft = _[0];
      return [{
        start: Math.min(ut, ft),
        end: Math.max(ut, ft)
      }];
    }
    for (var ht = [], dt = 0; dt < _.length - 1; dt += 1)
      ht.push({
        start: _[dt],
        end: _[dt + 1]
      });
    return ht;
  }, [_, ot, _e, rt]), it = null;
  return (lt.tracks || st.tracks) && (it = /* @__PURE__ */ reactExports.createElement(Track, {
    index: null,
    prefixCls: s,
    start: et[0].start,
    end: et[et.length - 1].end,
    replaceCls: classnames(lt.tracks, "".concat(s, "-tracks")),
    style: st.tracks
  })), at ? /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, it, et.map(function(ut, ft) {
    var ht = ut.start, dt = ut.end;
    return /* @__PURE__ */ reactExports.createElement(Track, {
      index: ft,
      prefixCls: s,
      style: _objectSpread2$a(_objectSpread2$a({}, getIndex($, ft)), st.track),
      start: ht,
      end: dt,
      key: ft,
      onStartMove: tt
    });
  })) : null;
}
var Slider$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _ = a.prefixCls, _e = _ === void 0 ? "rc-slider" : _, tt = a.className, nt = a.style, at = a.classNames, ot = a.styles, rt = a.disabled, st = rt === void 0 ? !1 : rt, lt = a.keyboard, et = lt === void 0 ? !0 : lt, it = a.autoFocus, ut = a.onFocus, ft = a.onBlur, ht = a.min, dt = ht === void 0 ? 0 : ht, gt = a.max, pt = gt === void 0 ? 100 : gt, mt = a.step, ct = mt === void 0 ? 1 : mt, vt = a.value, At = a.defaultValue, xt = a.range, bt = a.count, Et = a.onChange, St = a.onBeforeChange, Bt = a.onAfterChange, Ot = a.onChangeComplete, Pt = a.allowCross, wt = Pt === void 0 ? !0 : Pt, Ct = a.pushable, It = Ct === void 0 ? !1 : Ct, yt = a.draggableTrack, Rt = a.reverse, kt = a.vertical, jt = a.included, Ht = jt === void 0 ? !0 : jt, Ft = a.startPoint, _t = a.trackStyle, Nt = a.handleStyle, Mt = a.railStyle, Lt = a.dotStyle, $t = a.activeDotStyle, Tt = a.marks, Dt = a.dots, Ut = a.handleRender, Vt = a.tabIndex, Qt = Vt === void 0 ? 0 : Vt, qt = a.ariaLabelForHandle, Zt = a.ariaLabelledByForHandle, ar = a.ariaValueTextFormatterForHandle, Jt = reactExports.useRef(), rr = reactExports.useRef(), Yt = reactExports.useMemo(function() {
    return kt ? Rt ? "ttb" : "btt" : Rt ? "rtl" : "ltr";
  }, [Rt, kt]), Kt = reactExports.useMemo(function() {
    return isFinite(dt) ? dt : 0;
  }, [dt]), nr = reactExports.useMemo(function() {
    return isFinite(pt) ? pt : 100;
  }, [pt]), tr = reactExports.useMemo(function() {
    return ct !== null && ct <= 0 ? 1 : ct;
  }, [ct]), ir = reactExports.useMemo(function() {
    return typeof It == "boolean" ? It ? tr : !1 : It >= 0 ? It : !1;
  }, [It, tr]), sr = reactExports.useMemo(function() {
    var Yr = Object.keys(Tt || {});
    return Yr.map(function(kr) {
      var Nr = Tt[kr], Lr = {
        value: Number(kr)
      };
      return Nr && _typeof$q(Nr) === "object" && !/* @__PURE__ */ reactExports.isValidElement(Nr) && ("label" in Nr || "style" in Nr) ? (Lr.style = Nr.style, Lr.label = Nr.label) : Lr.label = Nr, Lr;
    }).filter(function(kr) {
      var Nr = kr.label;
      return Nr || typeof Nr == "number";
    }).sort(function(kr, Nr) {
      return kr.value - Nr.value;
    });
  }, [Tt]), cr = useOffset(Kt, nr, tr, sr, wt, ir), or = _slicedToArray$e(cr, 2), Xt = or[0], Gt = or[1], Wt = useMergedState(At, {
    value: vt
  }), er = _slicedToArray$e(Wt, 2), lr = er[0], ur = er[1], pr = reactExports.useMemo(function() {
    var Yr = lr == null ? [] : Array.isArray(lr) ? lr : [lr], kr = _slicedToArray$e(Yr, 1), Nr = kr[0], Lr = Nr === void 0 ? Kt : Nr, zr = lr === null ? [] : [Lr];
    if (xt) {
      if (zr = _toConsumableArray$d(Yr), bt || lr === void 0) {
        var Vr = bt >= 0 ? bt + 1 : 2;
        for (zr = zr.slice(0, Vr); zr.length < Vr; ) {
          var an;
          zr.push((an = zr[zr.length - 1]) !== null && an !== void 0 ? an : Kt);
        }
      }
      zr.sort(function(Zr, un) {
        return Zr - un;
      });
    }
    return zr.forEach(function(Zr, un) {
      zr[un] = Xt(Zr);
    }), zr;
  }, [lr, xt, Kt, bt, Xt]), yr = reactExports.useRef(pr);
  yr.current = pr;
  var Er = function(kr) {
    return xt ? kr : kr[0];
  }, br = function(kr) {
    var Nr = _toConsumableArray$d(kr).sort(function(Lr, zr) {
      return Lr - zr;
    });
    Et && !isEqual$1(Nr, yr.current, !0) && Et(Er(Nr)), ur(Nr);
  }, gr = function() {
    Bt == null || Bt(Er(yr.current)), warningOnce(!Bt, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), Ot == null || Ot(Er(yr.current));
  }, Ar = useDrag(rr, Yt, pr, Kt, nr, Xt, br, gr, Gt), Sr = _slicedToArray$e(Ar, 4), Br = Sr[0], Ir = Sr[1], hr = Sr[2], vr = Sr[3], xr = function(kr, Nr) {
    if (!st) {
      var Lr = 0, zr = nr - Kt;
      pr.forEach(function(an, Zr) {
        var un = Math.abs(kr - an);
        un <= zr && (zr = un, Lr = Zr);
      });
      var Vr = _toConsumableArray$d(pr);
      Vr[Lr] = kr, xt && !pr.length && bt === void 0 && Vr.push(kr), St == null || St(Er(Vr)), br(Vr), Nr && vr(Nr, Lr, Vr);
    }
  }, Pr = function(kr) {
    kr.preventDefault();
    var Nr = rr.current.getBoundingClientRect(), Lr = Nr.width, zr = Nr.height, Vr = Nr.left, an = Nr.top, Zr = Nr.bottom, un = Nr.right, Xr = kr.clientX, Kr = kr.clientY, rn;
    switch (Yt) {
      case "btt":
        rn = (Zr - Kr) / zr;
        break;
      case "ttb":
        rn = (Kr - an) / zr;
        break;
      case "rtl":
        rn = (un - Xr) / Lr;
        break;
      default:
        rn = (Xr - Vr) / Lr;
    }
    var nn = Kt + rn * (nr - Kt);
    xr(Xt(nn), kr);
  }, Rr = reactExports.useState(null), Dr = _slicedToArray$e(Rr, 2), Gr = Dr[0], Or = Dr[1], Hr = function(kr, Nr) {
    if (!st) {
      var Lr = Gt(pr, kr, Nr);
      St == null || St(Er(pr)), br(Lr.values), Or(Lr.value);
    }
  };
  reactExports.useEffect(function() {
    if (Gr !== null) {
      var Yr = pr.indexOf(Gr);
      Yr >= 0 && Jt.current.focus(Yr);
    }
    Or(null);
  }, [Gr]);
  var jr = reactExports.useMemo(function() {
    return yt && tr === null ? !1 : yt;
  }, [yt, tr]), Tr = function(kr, Nr) {
    vr(kr, Nr), St == null || St(Er(yr.current));
  }, fr = Br !== -1;
  reactExports.useEffect(function() {
    if (!fr) {
      var Yr = pr.lastIndexOf(Ir);
      Jt.current.focus(Yr);
    }
  }, [fr]);
  var Cr = reactExports.useMemo(function() {
    return _toConsumableArray$d(hr).sort(function(Yr, kr) {
      return Yr - kr;
    });
  }, [hr]), $r = reactExports.useMemo(function() {
    return xt ? [Cr[0], Cr[Cr.length - 1]] : [Kt, Cr[0]];
  }, [Cr, xt, Kt]), wr = _slicedToArray$e($r, 2), Mr = wr[0], Fr = wr[1];
  reactExports.useImperativeHandle(s, function() {
    return {
      focus: function() {
        Jt.current.focus(0);
      },
      blur: function() {
        var kr = document, Nr = kr.activeElement;
        rr.current.contains(Nr) && (Nr == null || Nr.blur());
      }
    };
  }), reactExports.useEffect(function() {
    it && Jt.current.focus(0);
  }, []);
  var Qr = reactExports.useMemo(function() {
    return {
      min: Kt,
      max: nr,
      direction: Yt,
      disabled: st,
      keyboard: et,
      step: tr,
      included: Ht,
      includedStart: Mr,
      includedEnd: Fr,
      range: xt,
      tabIndex: Qt,
      ariaLabelForHandle: qt,
      ariaLabelledByForHandle: Zt,
      ariaValueTextFormatterForHandle: ar,
      styles: ot || {},
      classNames: at || {}
    };
  }, [Kt, nr, Yt, st, et, tr, Ht, Mr, Fr, xt, Qt, qt, Zt, ar, ot, at]);
  return /* @__PURE__ */ reactExports.createElement(SliderContext.Provider, {
    value: Qr
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: rr,
    className: classnames(_e, tt, ($ = {}, _defineProperty$c($, "".concat(_e, "-disabled"), st), _defineProperty$c($, "".concat(_e, "-vertical"), kt), _defineProperty$c($, "".concat(_e, "-horizontal"), !kt), _defineProperty$c($, "".concat(_e, "-with-marks"), sr.length), $)),
    style: nt,
    onMouseDown: Pr
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames("".concat(_e, "-rail"), at == null ? void 0 : at.rail),
    style: _objectSpread2$a(_objectSpread2$a({}, Mt), ot == null ? void 0 : ot.rail)
  }), /* @__PURE__ */ reactExports.createElement(Tracks, {
    prefixCls: _e,
    style: _t,
    values: Cr,
    startPoint: Ft,
    onStartMove: jr ? Tr : null
  }), /* @__PURE__ */ reactExports.createElement(Steps, {
    prefixCls: _e,
    marks: sr,
    dots: Dt,
    style: Lt,
    activeStyle: $t
  }), /* @__PURE__ */ reactExports.createElement(Handles, {
    ref: Jt,
    prefixCls: _e,
    style: Nt,
    values: hr,
    draggingIndex: Br,
    onStartMove: Tr,
    onOffsetChange: Hr,
    onFocus: ut,
    onBlur: ft,
    handleRender: Ut,
    onChangeComplete: gr
  }), /* @__PURE__ */ reactExports.createElement(Marks, {
    prefixCls: _e,
    marks: sr,
    onClick: xr
  })));
});
const SliderTooltip = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    open: $
  } = a, _ = reactExports.useRef(null), _e = reactExports.useRef(null);
  function tt() {
    wrapperRaf.cancel(_e.current), _e.current = null;
  }
  function nt() {
    _e.current = wrapperRaf(() => {
      var at;
      (at = _.current) === null || at === void 0 || at.forceAlign(), _e.current = null;
    });
  }
  return reactExports.useEffect(() => ($ ? nt() : tt(), tt), [$, a.title]), /* @__PURE__ */ reactExports.createElement(_Tooltip, Object.assign({
    ref: composeRef(_, s)
  }, a));
}), SliderTooltip$1 = SliderTooltip, genBaseStyle$3 = (a) => {
  const {
    componentCls: s,
    antCls: $,
    controlSize: _,
    dotSize: _e,
    marginFull: tt,
    marginPart: nt,
    colorFillContentHover: at,
    handleColorDisabled: ot,
    calc: rt
  } = a;
  return {
    [s]: Object.assign(Object.assign({}, resetComponent(a)), {
      position: "relative",
      height: _,
      margin: `${unit$1(nt)} ${unit$1(tt)}`,
      padding: 0,
      cursor: "pointer",
      touchAction: "none",
      "&-vertical": {
        margin: `${unit$1(tt)} ${unit$1(nt)}`
      },
      [`${s}-rail`]: {
        position: "absolute",
        backgroundColor: a.railBg,
        borderRadius: a.borderRadiusXS,
        transition: `background-color ${a.motionDurationMid}`
      },
      [`${s}-track,${s}-tracks`]: {
        position: "absolute",
        transition: `background-color ${a.motionDurationMid}`
      },
      [`${s}-track`]: {
        backgroundColor: a.trackBg,
        borderRadius: a.borderRadiusXS
      },
      [`${s}-track-draggable`]: {
        boxSizing: "content-box",
        backgroundClip: "content-box",
        border: "solid rgba(0,0,0,0)"
      },
      "&:hover": {
        [`${s}-rail`]: {
          backgroundColor: a.railHoverBg
        },
        [`${s}-track`]: {
          backgroundColor: a.trackHoverBg
        },
        [`${s}-dot`]: {
          borderColor: at
        },
        [`${s}-handle::after`]: {
          boxShadow: `0 0 0 ${unit$1(a.handleLineWidth)} ${a.colorPrimaryBorderHover}`
        },
        [`${s}-dot-active`]: {
          borderColor: a.dotActiveBorderColor
        }
      },
      [`${s}-handle`]: {
        position: "absolute",
        width: a.handleSize,
        height: a.handleSize,
        outline: "none",
        // 扩大选区
        "&::before": {
          content: '""',
          position: "absolute",
          insetInlineStart: rt(a.handleLineWidth).mul(-1).equal(),
          insetBlockStart: rt(a.handleLineWidth).mul(-1).equal(),
          width: rt(a.handleSize).add(rt(a.handleLineWidth).mul(2)).equal(),
          height: rt(a.handleSize).add(rt(a.handleLineWidth).mul(2)).equal(),
          backgroundColor: "transparent"
        },
        "&::after": {
          content: '""',
          position: "absolute",
          insetBlockStart: 0,
          insetInlineStart: 0,
          width: a.handleSize,
          height: a.handleSize,
          backgroundColor: a.colorBgElevated,
          boxShadow: `0 0 0 ${unit$1(a.handleLineWidth)} ${a.handleColor}`,
          borderRadius: "50%",
          cursor: "pointer",
          transition: `
            inset-inline-start ${a.motionDurationMid},
            inset-block-start ${a.motionDurationMid},
            width ${a.motionDurationMid},
            height ${a.motionDurationMid},
            box-shadow ${a.motionDurationMid}
          `
        },
        "&:hover, &:active, &:focus": {
          "&::before": {
            // -(
            //   (token.handleSizeHover - token.handleSize) / 2 +
            //   token.handleLineWidthHover
            // ),
            insetInlineStart: rt(a.handleSizeHover).sub(a.handleSize).div(2).add(a.handleLineWidthHover).mul(-1).equal(),
            insetBlockStart: rt(a.handleSizeHover).sub(a.handleSize).div(2).add(a.handleLineWidthHover).mul(-1).equal(),
            width: rt(a.handleSizeHover).add(rt(a.handleLineWidthHover).mul(2)).equal(),
            height: rt(a.handleSizeHover).add(rt(a.handleLineWidthHover).mul(2)).equal()
          },
          "&::after": {
            boxShadow: `0 0 0 ${unit$1(a.handleLineWidthHover)} ${a.handleActiveColor}`,
            width: a.handleSizeHover,
            height: a.handleSizeHover,
            insetInlineStart: a.calc(a.handleSize).sub(a.handleSizeHover).div(2).equal(),
            insetBlockStart: a.calc(a.handleSize).sub(a.handleSizeHover).div(2).equal()
          }
        }
      },
      [`${s}-mark`]: {
        position: "absolute",
        fontSize: a.fontSize
      },
      [`${s}-mark-text`]: {
        position: "absolute",
        display: "inline-block",
        color: a.colorTextDescription,
        textAlign: "center",
        wordBreak: "keep-all",
        cursor: "pointer",
        userSelect: "none",
        "&-active": {
          color: a.colorText
        }
      },
      [`${s}-step`]: {
        position: "absolute",
        background: "transparent",
        pointerEvents: "none"
      },
      [`${s}-dot`]: {
        position: "absolute",
        width: _e,
        height: _e,
        backgroundColor: a.colorBgElevated,
        border: `${unit$1(a.handleLineWidth)} solid ${a.dotBorderColor}`,
        borderRadius: "50%",
        cursor: "pointer",
        transition: `border-color ${a.motionDurationSlow}`,
        pointerEvents: "auto",
        "&-active": {
          borderColor: a.dotActiveBorderColor
        }
      },
      [`&${s}-disabled`]: {
        cursor: "not-allowed",
        [`${s}-rail`]: {
          backgroundColor: `${a.railBg} !important`
        },
        [`${s}-track`]: {
          backgroundColor: `${a.trackBgDisabled} !important`
        },
        [`
          ${s}-dot
        `]: {
          backgroundColor: a.colorBgElevated,
          borderColor: a.trackBgDisabled,
          boxShadow: "none",
          cursor: "not-allowed"
        },
        [`${s}-handle::after`]: {
          backgroundColor: a.colorBgElevated,
          cursor: "not-allowed",
          width: a.handleSize,
          height: a.handleSize,
          boxShadow: `0 0 0 ${unit$1(a.handleLineWidth)} ${ot}`,
          insetInlineStart: 0,
          insetBlockStart: 0
        },
        [`
          ${s}-mark-text,
          ${s}-dot
        `]: {
          cursor: "not-allowed !important"
        }
      },
      [`&-tooltip ${$}-tooltip-inner`]: {
        minWidth: "unset"
      }
    })
  };
}, genDirectionStyle = (a, s) => {
  const {
    componentCls: $,
    railSize: _,
    handleSize: _e,
    dotSize: tt,
    marginFull: nt,
    calc: at
  } = a, ot = s ? "paddingBlock" : "paddingInline", rt = s ? "width" : "height", st = s ? "height" : "width", lt = s ? "insetBlockStart" : "insetInlineStart", et = s ? "top" : "insetInlineStart", it = at(_).mul(3).sub(_e).div(2).equal(), ut = at(_e).sub(_).div(2).equal(), ft = s ? {
    borderWidth: `${unit$1(ut)} 0`,
    transform: `translateY(${unit$1(at(ut).mul(-1).equal())})`
  } : {
    borderWidth: `0 ${unit$1(ut)}`,
    transform: `translateX(${unit$1(a.calc(ut).mul(-1).equal())})`
  };
  return {
    [ot]: _,
    [st]: at(_).mul(3).equal(),
    [`${$}-rail`]: {
      [rt]: "100%",
      [st]: _
    },
    [`${$}-track,${$}-tracks`]: {
      [st]: _
    },
    [`${$}-track-draggable`]: Object.assign({}, ft),
    [`${$}-handle`]: {
      [lt]: it
    },
    [`${$}-mark`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      // https://github.com/ant-design/ant-design/issues/43731
      [et]: at(_).mul(3).add(s ? 0 : nt).equal(),
      [rt]: "100%"
    },
    [`${$}-step`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      [et]: _,
      [rt]: "100%",
      [st]: _
    },
    [`${$}-dot`]: {
      position: "absolute",
      [lt]: at(_).sub(tt).div(2).equal()
    }
  };
}, genHorizontalStyle = (a) => {
  const {
    componentCls: s,
    marginPartWithMark: $
  } = a;
  return {
    [`${s}-horizontal`]: Object.assign(Object.assign({}, genDirectionStyle(a, !0)), {
      [`&${s}-with-marks`]: {
        marginBottom: $
      }
    })
  };
}, genVerticalStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-vertical`]: Object.assign(Object.assign({}, genDirectionStyle(a, !1)), {
      height: "100%"
    })
  };
}, prepareComponentToken$5 = (a) => {
  const $ = a.controlHeightLG / 4, _ = a.controlHeightSM / 2, _e = a.lineWidth + 1, tt = a.lineWidth + 1 * 3;
  return {
    controlSize: $,
    railSize: 4,
    handleSize: $,
    handleSizeHover: _,
    dotSize: 8,
    handleLineWidth: _e,
    handleLineWidthHover: tt,
    railBg: a.colorFillTertiary,
    railHoverBg: a.colorFillSecondary,
    trackBg: a.colorPrimaryBorder,
    trackHoverBg: a.colorPrimaryBorderHover,
    handleColor: a.colorPrimaryBorder,
    handleActiveColor: a.colorPrimary,
    handleColorDisabled: new TinyColor(a.colorTextDisabled).onBackground(a.colorBgContainer).toHexShortString(),
    dotBorderColor: a.colorBorderSecondary,
    dotActiveBorderColor: a.colorPrimaryBorder,
    trackBgDisabled: a.colorBgContainerDisabled
  };
}, useStyle$5 = genStyleHooks("Slider", (a) => {
  const s = merge(a, {
    marginPart: a.calc(a.controlHeight).sub(a.controlSize).div(2).equal(),
    marginFull: a.calc(a.controlSize).div(2).equal(),
    marginPartWithMark: a.calc(a.controlHeightLG).sub(a.controlSize).equal()
  });
  return [genBaseStyle$3(s), genHorizontalStyle(s), genVerticalStyle(s)];
}, prepareComponentToken$5);
var __rest$f = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function getTipFormatter(a, s) {
  return a || a === null ? a : s || s === null ? s : ($) => typeof $ == "number" ? $.toString() : "";
}
const Slider$1 = /* @__PURE__ */ React$a.forwardRef((a, s) => {
  const {
    prefixCls: $,
    range: _,
    className: _e,
    rootClassName: tt,
    style: nt,
    disabled: at,
    // Deprecated Props
    tooltipPrefixCls: ot,
    tipFormatter: rt,
    tooltipVisible: st,
    getTooltipPopupContainer: lt,
    tooltipPlacement: et
  } = a, it = __rest$f(a, ["prefixCls", "range", "className", "rootClassName", "style", "disabled", "tooltipPrefixCls", "tipFormatter", "tooltipVisible", "getTooltipPopupContainer", "tooltipPlacement"]), {
    direction: ut,
    slider: ft,
    getPrefixCls: ht,
    getPopupContainer: dt
  } = React$a.useContext(ConfigContext$1), gt = React$a.useContext(DisabledContext$1), pt = at ?? gt, [mt, ct] = React$a.useState({}), vt = (It, yt) => {
    ct((Rt) => Object.assign(Object.assign({}, Rt), {
      [It]: yt
    }));
  }, At = (It, yt) => It || (yt ? ut === "rtl" ? "left" : "right" : "top"), xt = ht("slider", $), [bt, Et, St] = useStyle$5(xt), Bt = classnames(_e, ft == null ? void 0 : ft.className, tt, {
    [`${xt}-rtl`]: ut === "rtl"
  }, Et, St);
  ut === "rtl" && !it.vertical && (it.reverse = !it.reverse);
  const [Ot, Pt] = React$a.useMemo(() => _ ? typeof _ == "object" ? [!0, _.draggableTrack] : [!0, !1] : [!1], [_]), wt = (It, yt) => {
    var Rt;
    const {
      index: kt,
      dragging: jt
    } = yt, {
      tooltip: Ht = {},
      vertical: Ft
    } = a, _t = Object.assign({}, Ht), {
      open: Nt,
      placement: Mt,
      getPopupContainer: Lt,
      prefixCls: $t,
      formatter: Tt
    } = _t, Dt = getTipFormatter(Tt, rt), Ut = Dt ? mt[kt] || jt : !1, Vt = (Rt = Nt ?? st) !== null && Rt !== void 0 ? Rt : Nt === void 0 && Ut, Qt = Object.assign(Object.assign({}, It.props), {
      onMouseEnter: () => vt(kt, !0),
      onMouseLeave: () => vt(kt, !1),
      onFocus: (qt) => {
        var Zt;
        vt(kt, !0), (Zt = it.onFocus) === null || Zt === void 0 || Zt.call(it, qt);
      },
      onBlur: (qt) => {
        var Zt;
        vt(kt, !1), (Zt = it.onBlur) === null || Zt === void 0 || Zt.call(it, qt);
      }
    });
    return /* @__PURE__ */ React$a.createElement(SliderTooltip$1, Object.assign({}, _t, {
      prefixCls: ht("tooltip", $t ?? ot),
      title: Dt ? Dt(yt.value) : "",
      open: Vt,
      placement: At(Mt ?? et, Ft),
      key: kt,
      overlayClassName: `${xt}-tooltip`,
      getPopupContainer: Lt || lt || dt
    }), /* @__PURE__ */ React$a.cloneElement(It, Qt));
  }, Ct = Object.assign(Object.assign({}, ft == null ? void 0 : ft.style), nt);
  return bt(/* @__PURE__ */ React$a.createElement(Slider$2, Object.assign({}, it, {
    step: it.step,
    range: Ot,
    draggableTrack: Pt,
    className: Bt,
    style: Ct,
    disabled: pt,
    ref: s,
    prefixCls: xt,
    handleRender: wt
  })));
}), _Slider = Slider$1;
var _excluded$d = ["prefixCls", "className", "checked", "defaultChecked", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren", "onClick", "onChange", "onKeyDown"], Switch$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $, _ = a.prefixCls, _e = _ === void 0 ? "rc-switch" : _, tt = a.className, nt = a.checked, at = a.defaultChecked, ot = a.disabled, rt = a.loadingIcon, st = a.checkedChildren, lt = a.unCheckedChildren, et = a.onClick, it = a.onChange, ut = a.onKeyDown, ft = _objectWithoutProperties$1(a, _excluded$d), ht = useMergedState(!1, {
    value: nt,
    defaultValue: at
  }), dt = _slicedToArray$e(ht, 2), gt = dt[0], pt = dt[1];
  function mt(xt, bt) {
    var Et = gt;
    return ot || (Et = xt, pt(Et), it == null || it(Et, bt)), Et;
  }
  function ct(xt) {
    xt.which === KeyCode.LEFT ? mt(!1, xt) : xt.which === KeyCode.RIGHT && mt(!0, xt), ut == null || ut(xt);
  }
  function vt(xt) {
    var bt = mt(!gt, xt);
    et == null || et(bt, xt);
  }
  var At = classnames(_e, tt, ($ = {}, _defineProperty$c($, "".concat(_e, "-checked"), gt), _defineProperty$c($, "".concat(_e, "-disabled"), ot), $));
  return /* @__PURE__ */ reactExports.createElement("button", _extends$2({}, ft, {
    type: "button",
    role: "switch",
    "aria-checked": gt,
    disabled: ot,
    className: At,
    ref: s,
    onKeyDown: ct,
    onClick: vt
  }), rt, /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(_e, "-inner")
  }, /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(_e, "-inner-checked")
  }, st), /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(_e, "-inner-unchecked")
  }, lt)));
});
Switch$2.displayName = "Switch";
const genSwitchSmallStyle = (a) => {
  const {
    componentCls: s,
    trackHeightSM: $,
    trackPadding: _,
    trackMinWidthSM: _e,
    innerMinMarginSM: tt,
    innerMaxMarginSM: nt,
    handleSizeSM: at,
    calc: ot
  } = a, rt = `${s}-inner`, st = unit$1(ot(at).add(ot(_).mul(2)).equal()), lt = unit$1(ot(nt).mul(2).equal());
  return {
    [s]: {
      [`&${s}-small`]: {
        minWidth: _e,
        height: $,
        lineHeight: unit$1($),
        [`${s}-inner`]: {
          paddingInlineStart: nt,
          paddingInlineEnd: tt,
          [`${rt}-checked`]: {
            marginInlineStart: `calc(-100% + ${st} - ${lt})`,
            marginInlineEnd: `calc(100% - ${st} + ${lt})`
          },
          [`${rt}-unchecked`]: {
            marginTop: ot($).mul(-1).equal(),
            marginInlineStart: 0,
            marginInlineEnd: 0
          }
        },
        [`${s}-handle`]: {
          width: at,
          height: at
        },
        [`${s}-loading-icon`]: {
          top: ot(ot(at).sub(a.switchLoadingIconSize)).div(2).equal(),
          fontSize: a.switchLoadingIconSize
        },
        [`&${s}-checked`]: {
          [`${s}-inner`]: {
            paddingInlineStart: tt,
            paddingInlineEnd: nt,
            [`${rt}-checked`]: {
              marginInlineStart: 0,
              marginInlineEnd: 0
            },
            [`${rt}-unchecked`]: {
              marginInlineStart: `calc(100% - ${st} + ${lt})`,
              marginInlineEnd: `calc(-100% + ${st} - ${lt})`
            }
          },
          [`${s}-handle`]: {
            insetInlineStart: `calc(100% - ${unit$1(ot(at).add(_).equal())})`
          }
        },
        [`&:not(${s}-disabled):active`]: {
          [`&:not(${s}-checked) ${rt}`]: {
            [`${rt}-unchecked`]: {
              marginInlineStart: ot(a.marginXXS).div(2).equal(),
              marginInlineEnd: ot(a.marginXXS).mul(-1).div(2).equal()
            }
          },
          [`&${s}-checked ${rt}`]: {
            [`${rt}-checked`]: {
              marginInlineStart: ot(a.marginXXS).mul(-1).div(2).equal(),
              marginInlineEnd: ot(a.marginXXS).div(2).equal()
            }
          }
        }
      }
    }
  };
}, genSwitchLoadingStyle = (a) => {
  const {
    componentCls: s,
    handleSize: $,
    calc: _
  } = a;
  return {
    [s]: {
      [`${s}-loading-icon${a.iconCls}`]: {
        position: "relative",
        top: _(_($).sub(a.fontSize)).div(2).equal(),
        color: a.switchLoadingIconColor,
        verticalAlign: "top"
      },
      [`&${s}-checked ${s}-loading-icon`]: {
        color: a.switchColor
      }
    }
  };
}, genSwitchHandleStyle = (a) => {
  const {
    componentCls: s,
    trackPadding: $,
    handleBg: _,
    handleShadow: _e,
    handleSize: tt,
    calc: nt
  } = a, at = `${s}-handle`;
  return {
    [s]: {
      [at]: {
        position: "absolute",
        top: $,
        insetInlineStart: $,
        width: tt,
        height: tt,
        transition: `all ${a.switchDuration} ease-in-out`,
        "&::before": {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          backgroundColor: _,
          borderRadius: nt(tt).div(2).equal(),
          boxShadow: _e,
          transition: `all ${a.switchDuration} ease-in-out`,
          content: '""'
        }
      },
      [`&${s}-checked ${at}`]: {
        insetInlineStart: `calc(100% - ${unit$1(nt(tt).add($).equal())})`
      },
      [`&:not(${s}-disabled):active`]: {
        [`${at}::before`]: {
          insetInlineEnd: a.switchHandleActiveInset,
          insetInlineStart: 0
        },
        [`&${s}-checked ${at}::before`]: {
          insetInlineEnd: 0,
          insetInlineStart: a.switchHandleActiveInset
        }
      }
    }
  };
}, genSwitchInnerStyle = (a) => {
  const {
    componentCls: s,
    trackHeight: $,
    trackPadding: _,
    innerMinMargin: _e,
    innerMaxMargin: tt,
    handleSize: nt,
    calc: at
  } = a, ot = `${s}-inner`, rt = unit$1(at(nt).add(at(_).mul(2)).equal()), st = unit$1(at(tt).mul(2).equal());
  return {
    [s]: {
      [ot]: {
        display: "block",
        overflow: "hidden",
        borderRadius: 100,
        height: "100%",
        paddingInlineStart: tt,
        paddingInlineEnd: _e,
        transition: `padding-inline-start ${a.switchDuration} ease-in-out, padding-inline-end ${a.switchDuration} ease-in-out`,
        [`${ot}-checked, ${ot}-unchecked`]: {
          display: "block",
          color: a.colorTextLightSolid,
          fontSize: a.fontSizeSM,
          transition: `margin-inline-start ${a.switchDuration} ease-in-out, margin-inline-end ${a.switchDuration} ease-in-out`,
          pointerEvents: "none"
        },
        [`${ot}-checked`]: {
          marginInlineStart: `calc(-100% + ${rt} - ${st})`,
          marginInlineEnd: `calc(100% - ${rt} + ${st})`
        },
        [`${ot}-unchecked`]: {
          marginTop: at($).mul(-1).equal(),
          marginInlineStart: 0,
          marginInlineEnd: 0
        }
      },
      [`&${s}-checked ${ot}`]: {
        paddingInlineStart: _e,
        paddingInlineEnd: tt,
        [`${ot}-checked`]: {
          marginInlineStart: 0,
          marginInlineEnd: 0
        },
        [`${ot}-unchecked`]: {
          marginInlineStart: `calc(100% - ${rt} + ${st})`,
          marginInlineEnd: `calc(-100% + ${rt} - ${st})`
        }
      },
      [`&:not(${s}-disabled):active`]: {
        [`&:not(${s}-checked) ${ot}`]: {
          [`${ot}-unchecked`]: {
            marginInlineStart: at(_).mul(2).equal(),
            marginInlineEnd: at(_).mul(-1).mul(2).equal()
          }
        },
        [`&${s}-checked ${ot}`]: {
          [`${ot}-checked`]: {
            marginInlineStart: at(_).mul(-1).mul(2).equal(),
            marginInlineEnd: at(_).mul(2).equal()
          }
        }
      }
    }
  };
}, genSwitchStyle = (a) => {
  const {
    componentCls: s,
    trackHeight: $,
    trackMinWidth: _
  } = a;
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(a)), {
      position: "relative",
      display: "inline-block",
      boxSizing: "border-box",
      minWidth: _,
      height: $,
      lineHeight: `${unit$1($)}`,
      verticalAlign: "middle",
      background: a.colorTextQuaternary,
      border: "0",
      borderRadius: 100,
      cursor: "pointer",
      transition: `all ${a.motionDurationMid}`,
      userSelect: "none",
      [`&:hover:not(${s}-disabled)`]: {
        background: a.colorTextTertiary
      }
    }), genFocusStyle(a)), {
      [`&${s}-checked`]: {
        background: a.switchColor,
        [`&:hover:not(${s}-disabled)`]: {
          background: a.colorPrimaryHover
        }
      },
      [`&${s}-loading, &${s}-disabled`]: {
        cursor: "not-allowed",
        opacity: a.switchDisabledOpacity,
        "*": {
          boxShadow: "none",
          cursor: "not-allowed"
        }
      },
      // rtl style
      [`&${s}-rtl`]: {
        direction: "rtl"
      }
    })
  };
}, prepareComponentToken$4 = (a) => {
  const {
    fontSize: s,
    lineHeight: $,
    controlHeight: _,
    colorWhite: _e
  } = a, tt = s * $, nt = _ / 2, at = 2, ot = tt - at * 2, rt = nt - at * 2;
  return {
    trackHeight: tt,
    trackHeightSM: nt,
    trackMinWidth: ot * 2 + at * 4,
    trackMinWidthSM: rt * 2 + at * 2,
    trackPadding: at,
    // Fixed value
    handleBg: _e,
    handleSize: ot,
    handleSizeSM: rt,
    handleShadow: `0 2px 4px 0 ${new TinyColor("#00230b").setAlpha(0.2).toRgbString()}`,
    innerMinMargin: ot / 2,
    innerMaxMargin: ot + at + at * 2,
    innerMinMarginSM: rt / 2,
    innerMaxMarginSM: rt + at + at * 2
  };
}, useStyle$4 = genStyleHooks("Switch", (a) => {
  const s = merge(a, {
    switchDuration: a.motionDurationMid,
    switchColor: a.colorPrimary,
    switchDisabledOpacity: a.opacityLoading,
    switchLoadingIconSize: a.calc(a.fontSizeIcon).mul(0.75).equal(),
    switchLoadingIconColor: `rgba(0, 0, 0, ${a.opacityLoading})`,
    switchHandleActiveInset: "-30%"
  });
  return [
    genSwitchStyle(s),
    // inner style
    genSwitchInnerStyle(s),
    // handle style
    genSwitchHandleStyle(s),
    // loading style
    genSwitchLoadingStyle(s),
    // small style
    genSwitchSmallStyle(s)
  ];
}, prepareComponentToken$4);
var __rest$e = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Switch$1 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: $,
    size: _,
    disabled: _e,
    loading: tt,
    className: nt,
    rootClassName: at,
    style: ot,
    checked: rt,
    value: st,
    defaultChecked: lt,
    defaultValue: et,
    onChange: it
  } = a, ut = __rest$e(a, ["prefixCls", "size", "disabled", "loading", "className", "rootClassName", "style", "checked", "value", "defaultChecked", "defaultValue", "onChange"]), [ft, ht] = useMergedState(!1, {
    value: rt ?? st,
    defaultValue: lt ?? et
  }), {
    getPrefixCls: dt,
    direction: gt,
    switch: pt
  } = reactExports.useContext(ConfigContext$1), mt = reactExports.useContext(DisabledContext$1), ct = (_e ?? mt) || tt, vt = dt("switch", $), At = /* @__PURE__ */ reactExports.createElement("div", {
    className: `${vt}-handle`
  }, tt && /* @__PURE__ */ reactExports.createElement(LoadingOutlined$1, {
    className: `${vt}-loading-icon`
  })), [xt, bt, Et] = useStyle$4(vt), St = useSize$1(_), Bt = classnames(pt == null ? void 0 : pt.className, {
    [`${vt}-small`]: St === "small",
    [`${vt}-loading`]: tt,
    [`${vt}-rtl`]: gt === "rtl"
  }, nt, at, bt, Et), Ot = Object.assign(Object.assign({}, pt == null ? void 0 : pt.style), ot), Pt = function() {
    ht(arguments.length <= 0 ? void 0 : arguments[0]), it == null || it.apply(void 0, arguments);
  };
  return xt(/* @__PURE__ */ reactExports.createElement(Wave$1, {
    component: "Switch"
  }, /* @__PURE__ */ reactExports.createElement(Switch$2, Object.assign({}, ut, {
    checked: ft,
    onChange: Pt,
    prefixCls: vt,
    className: Bt,
    style: Ot,
    disabled: ct,
    ref: s,
    loadingIcon: At
  }))));
});
Switch$1.__ANT_SWITCH = !0;
const _Switch = Switch$1;
var EXPAND_COLUMN = {}, INTERNAL_HOOKS = "rc-table-internal-hook";
function createContext(a) {
  var s = /* @__PURE__ */ reactExports.createContext(void 0), $ = function(_e) {
    var tt = _e.value, nt = _e.children, at = reactExports.useRef(tt);
    at.current = tt;
    var ot = reactExports.useState(function() {
      return {
        getValue: function() {
          return at.current;
        },
        listeners: /* @__PURE__ */ new Set()
      };
    }), rt = _slicedToArray$e(ot, 1), st = rt[0];
    return useLayoutEffect$1(function() {
      reactDomExports.unstable_batchedUpdates(function() {
        st.listeners.forEach(function(lt) {
          lt(tt);
        });
      });
    }, [tt]), /* @__PURE__ */ reactExports.createElement(s.Provider, {
      value: st
    }, nt);
  };
  return {
    Context: s,
    Provider: $,
    defaultValue: a
  };
}
function useContext(a, s) {
  var $ = useEvent(typeof s == "function" ? s : function(lt) {
    if (s === void 0)
      return lt;
    if (!Array.isArray(s))
      return lt[s];
    var et = {};
    return s.forEach(function(it) {
      et[it] = lt[it];
    }), et;
  }), _ = reactExports.useContext(a == null ? void 0 : a.Context), _e = _ || {}, tt = _e.listeners, nt = _e.getValue, at = reactExports.useRef();
  at.current = $(_ ? nt() : a == null ? void 0 : a.defaultValue);
  var ot = reactExports.useState({}), rt = _slicedToArray$e(ot, 2), st = rt[1];
  return useLayoutEffect$1(function() {
    if (!_)
      return;
    function lt(et) {
      var it = $(et);
      isEqual$1(at.current, it, !0) || st({});
    }
    return tt.add(lt), function() {
      tt.delete(lt);
    };
  }, [_]), at.current;
}
function createImmutable() {
  var a = /* @__PURE__ */ reactExports.createContext(null);
  function s() {
    return reactExports.useContext(a);
  }
  function $(_e, tt) {
    var nt = supportRef(_e), at = function(rt, st) {
      var lt = nt ? {
        ref: st
      } : {}, et = reactExports.useRef(0), it = reactExports.useRef(rt), ut = s();
      return ut !== null ? /* @__PURE__ */ reactExports.createElement(_e, _extends$2({}, rt, lt)) : (
        // Always trigger re-render if not provide `notTriggerRender`
        ((!tt || tt(it.current, rt)) && (et.current += 1), it.current = rt, /* @__PURE__ */ reactExports.createElement(a.Provider, {
          value: et.current
        }, /* @__PURE__ */ reactExports.createElement(_e, _extends$2({}, rt, lt))))
      );
    };
    return nt ? /* @__PURE__ */ reactExports.forwardRef(at) : at;
  }
  function _(_e, tt) {
    var nt = supportRef(_e), at = function(rt, st) {
      var lt = nt ? {
        ref: st
      } : {};
      return s(), /* @__PURE__ */ reactExports.createElement(_e, _extends$2({}, rt, lt));
    };
    return nt ? /* @__PURE__ */ reactExports.memo(/* @__PURE__ */ reactExports.forwardRef(at), tt) : /* @__PURE__ */ reactExports.memo(at, tt);
  }
  return {
    makeImmutable: $,
    responseImmutable: _,
    useImmutableMark: s
  };
}
var _createImmutable = createImmutable(), makeImmutable = _createImmutable.makeImmutable, responseImmutable = _createImmutable.responseImmutable, useImmutableMark = _createImmutable.useImmutableMark, TableContext = createContext();
function useRenderTimes(a, s) {
  var $ = reactExports.useRef(0);
  $.current += 1;
  var _ = reactExports.useRef(a), _e = [];
  Object.keys(a || {}).map(function(nt) {
    var at;
    (a == null ? void 0 : a[nt]) !== ((at = _.current) === null || at === void 0 ? void 0 : at[nt]) && _e.push(nt);
  }), _.current = a;
  var tt = reactExports.useRef([]);
  return _e.length && (tt.current = _e), reactExports.useDebugValue($.current), reactExports.useDebugValue(tt.current.join(", ")), s && console.log("".concat(s, ":"), $.current, tt.current), $.current;
}
var RenderBlock = /* @__PURE__ */ reactExports.memo(function() {
  var a = useRenderTimes();
  return /* @__PURE__ */ reactExports.createElement("h1", null, "Render Times: ", a);
});
RenderBlock.displayName = "RenderBlock";
var PerfContext = /* @__PURE__ */ reactExports.createContext({
  renderWithProps: !1
}), INTERNAL_KEY_PREFIX = "RC_TABLE_KEY";
function toArray$1(a) {
  return a == null ? [] : Array.isArray(a) ? a : [a];
}
function getColumnsKey(a) {
  var s = [], $ = {};
  return a.forEach(function(_) {
    for (var _e = _ || {}, tt = _e.key, nt = _e.dataIndex, at = tt || toArray$1(nt).join("-") || INTERNAL_KEY_PREFIX; $[at]; )
      at = "".concat(at, "_next");
    $[at] = !0, s.push(at);
  }), s;
}
function validateValue(a) {
  return a != null;
}
function isRenderCell(a) {
  return a && _typeof$q(a) === "object" && !Array.isArray(a) && !/* @__PURE__ */ reactExports.isValidElement(a);
}
function useCellRender(a, s, $, _, _e, tt) {
  var nt = reactExports.useContext(PerfContext), at = useImmutableMark(), ot = useMemo(function() {
    if (validateValue(_))
      return [_];
    var rt = s == null || s === "" ? [] : Array.isArray(s) ? s : [s], st = get$1(a, rt), lt = st, et = void 0;
    if (_e) {
      var it = _e(st, a, $);
      isRenderCell(it) ? (lt = it.children, et = it.props, nt.renderWithProps = !0) : lt = it;
    }
    return [lt, et];
  }, [
    // Force update deps
    at,
    // Normal deps
    a,
    _,
    s,
    _e,
    $
  ], function(rt, st) {
    if (tt) {
      var lt = _slicedToArray$e(rt, 2), et = lt[1], it = _slicedToArray$e(st, 2), ut = it[1];
      return tt(ut, et);
    }
    return nt.renderWithProps ? !0 : !isEqual$1(rt, st, !0);
  });
  return ot;
}
function inHoverRange(a, s, $, _) {
  var _e = a + s - 1;
  return a <= _ && _e >= $;
}
function useHoverState(a, s) {
  return useContext(TableContext, function($) {
    var _ = inHoverRange(a, s || 1, $.hoverStartRow, $.hoverEndRow);
    return [_, $.onHover];
  });
}
var getTitleFromCellRenderChildren = function a(s) {
  var $ = s.ellipsis, _ = s.rowType, _e = s.children, tt, nt = $ === !0 ? {
    showTitle: !0
  } : $;
  return nt && (nt.showTitle || _ === "header") && (typeof _e == "string" || typeof _e == "number" ? tt = _e.toString() : /* @__PURE__ */ reactExports.isValidElement(_e) && typeof _e.props.children == "string" && (tt = _e.props.children)), tt;
};
function Cell(a) {
  var s, $, _, _e, tt, nt, at, ot, rt = a.component, st = a.children, lt = a.ellipsis, et = a.scope, it = a.prefixCls, ut = a.className, ft = a.align, ht = a.record, dt = a.render, gt = a.dataIndex, pt = a.renderIndex, mt = a.shouldCellUpdate, ct = a.index, vt = a.rowType, At = a.colSpan, xt = a.rowSpan, bt = a.fixLeft, Et = a.fixRight, St = a.firstFixLeft, Bt = a.lastFixLeft, Ot = a.firstFixRight, Pt = a.lastFixRight, wt = a.appendNode, Ct = a.additionalProps, It = Ct === void 0 ? {} : Ct, yt = a.isSticky, Rt = "".concat(it, "-cell"), kt = useContext(TableContext, ["supportSticky", "allColumnsFixedLeft"]), jt = kt.supportSticky, Ht = kt.allColumnsFixedLeft, Ft = useCellRender(ht, gt, pt, st, dt, mt), _t = _slicedToArray$e(Ft, 2), Nt = _t[0], Mt = _t[1], Lt = {}, $t = typeof bt == "number" && jt, Tt = typeof Et == "number" && jt;
  $t && (Lt.position = "sticky", Lt.left = bt), Tt && (Lt.position = "sticky", Lt.right = Et);
  var Dt = (s = ($ = (_ = Mt == null ? void 0 : Mt.colSpan) !== null && _ !== void 0 ? _ : It.colSpan) !== null && $ !== void 0 ? $ : At) !== null && s !== void 0 ? s : 1, Ut = (_e = (tt = (nt = Mt == null ? void 0 : Mt.rowSpan) !== null && nt !== void 0 ? nt : It.rowSpan) !== null && tt !== void 0 ? tt : xt) !== null && _e !== void 0 ? _e : 1, Vt = useHoverState(ct, Ut), Qt = _slicedToArray$e(Vt, 2), qt = Qt[0], Zt = Qt[1], ar = useEvent(function(ir) {
    var sr;
    ht && Zt(ct, ct + Ut - 1), It == null || (sr = It.onMouseEnter) === null || sr === void 0 || sr.call(It, ir);
  }), Jt = useEvent(function(ir) {
    var sr;
    ht && Zt(-1, -1), It == null || (sr = It.onMouseLeave) === null || sr === void 0 || sr.call(It, ir);
  });
  if (Dt === 0 || Ut === 0)
    return null;
  var rr = (at = It.title) !== null && at !== void 0 ? at : getTitleFromCellRenderChildren({
    rowType: vt,
    ellipsis: lt,
    children: Nt
  }), Yt = classnames(Rt, ut, (ot = {}, _defineProperty$c(ot, "".concat(Rt, "-fix-left"), $t && jt), _defineProperty$c(ot, "".concat(Rt, "-fix-left-first"), St && jt), _defineProperty$c(ot, "".concat(Rt, "-fix-left-last"), Bt && jt), _defineProperty$c(ot, "".concat(Rt, "-fix-left-all"), Bt && Ht && jt), _defineProperty$c(ot, "".concat(Rt, "-fix-right"), Tt && jt), _defineProperty$c(ot, "".concat(Rt, "-fix-right-first"), Ot && jt), _defineProperty$c(ot, "".concat(Rt, "-fix-right-last"), Pt && jt), _defineProperty$c(ot, "".concat(Rt, "-ellipsis"), lt), _defineProperty$c(ot, "".concat(Rt, "-with-append"), wt), _defineProperty$c(ot, "".concat(Rt, "-fix-sticky"), ($t || Tt) && yt && jt), _defineProperty$c(ot, "".concat(Rt, "-row-hover"), !Mt && qt), ot), It.className, Mt == null ? void 0 : Mt.className), Kt = {};
  ft && (Kt.textAlign = ft);
  var nr = _objectSpread2$a(_objectSpread2$a(_objectSpread2$a(_objectSpread2$a({}, Lt), It.style), Kt), Mt == null ? void 0 : Mt.style), tr = Nt;
  return _typeof$q(tr) === "object" && !Array.isArray(tr) && !/* @__PURE__ */ reactExports.isValidElement(tr) && (tr = null), lt && (Bt || Ot) && (tr = /* @__PURE__ */ reactExports.createElement("span", {
    className: "".concat(Rt, "-content")
  }, tr)), /* @__PURE__ */ reactExports.createElement(rt, _extends$2({}, Mt, It, {
    className: Yt,
    style: nr,
    title: rr,
    scope: et,
    onMouseEnter: ar,
    onMouseLeave: Jt,
    colSpan: Dt !== 1 ? Dt : null,
    rowSpan: Ut !== 1 ? Ut : null
  }), wt, tr);
}
const Cell$1 = /* @__PURE__ */ reactExports.memo(Cell);
function getCellFixedInfo(a, s, $, _, _e, tt) {
  var nt = $[a] || {}, at = $[s] || {}, ot, rt;
  nt.fixed === "left" ? ot = _.left[_e === "rtl" ? s : a] : at.fixed === "right" && (rt = _.right[_e === "rtl" ? a : s]);
  var st = !1, lt = !1, et = !1, it = !1, ut = $[s + 1], ft = $[a - 1], ht = !(tt != null && tt.children);
  if (_e === "rtl") {
    if (ot !== void 0) {
      var dt = ft && ft.fixed === "left";
      it = !dt && ht;
    } else if (rt !== void 0) {
      var gt = ut && ut.fixed === "right";
      et = !gt && ht;
    }
  } else if (ot !== void 0) {
    var pt = ut && ut.fixed === "left";
    st = !pt && ht;
  } else if (rt !== void 0) {
    var mt = ft && ft.fixed === "right";
    lt = !mt && ht;
  }
  return {
    fixLeft: ot,
    fixRight: rt,
    lastFixLeft: st,
    firstFixRight: lt,
    lastFixRight: et,
    firstFixLeft: it,
    isSticky: _.isSticky
  };
}
var SummaryContext = /* @__PURE__ */ reactExports.createContext({});
function SummaryCell(a) {
  var s = a.className, $ = a.index, _ = a.children, _e = a.colSpan, tt = _e === void 0 ? 1 : _e, nt = a.rowSpan, at = a.align, ot = useContext(TableContext, ["prefixCls", "direction"]), rt = ot.prefixCls, st = ot.direction, lt = reactExports.useContext(SummaryContext), et = lt.scrollColumnIndex, it = lt.stickyOffsets, ut = lt.flattenColumns, ft = lt.columns, ht = $ + tt - 1, dt = ht + 1 === et ? tt + 1 : tt, gt = getCellFixedInfo($, $ + dt - 1, ut, it, st, ft == null ? void 0 : ft[$]);
  return /* @__PURE__ */ reactExports.createElement(Cell$1, _extends$2({
    className: s,
    index: $,
    component: "td",
    prefixCls: rt,
    record: null,
    dataIndex: null,
    align: at,
    colSpan: dt,
    rowSpan: nt,
    render: function() {
      return _;
    }
  }, gt));
}
var _excluded$c = ["children"];
function FooterRow(a) {
  var s = a.children, $ = _objectWithoutProperties$1(a, _excluded$c);
  return /* @__PURE__ */ reactExports.createElement("tr", $, s);
}
function Summary(a) {
  var s = a.children;
  return s;
}
Summary.Row = FooterRow;
Summary.Cell = SummaryCell;
function Footer(a) {
  var s = a.children, $ = a.stickyOffsets, _ = a.flattenColumns, _e = a.columns, tt = useContext(TableContext, "prefixCls"), nt = _.length - 1, at = _[nt], ot = reactExports.useMemo(function() {
    return {
      stickyOffsets: $,
      flattenColumns: _,
      scrollColumnIndex: at != null && at.scrollbar ? nt : null,
      columns: _e
    };
  }, [at, _, nt, $, _e]);
  return /* @__PURE__ */ reactExports.createElement(SummaryContext.Provider, {
    value: ot
  }, /* @__PURE__ */ reactExports.createElement("tfoot", {
    className: "".concat(tt, "-summary")
  }, s));
}
const Footer$1 = responseImmutable(Footer);
var FooterComponents = Summary;
function Column$1(a) {
  return null;
}
function ColumnGroup$1(a) {
  return null;
}
function fillRecords(a, s, $, _, _e, tt, nt) {
  a.push({
    record: s,
    indent: $,
    index: nt
  });
  var at = tt(s), ot = _e == null ? void 0 : _e.has(at);
  if (s && Array.isArray(s[_]) && ot)
    for (var rt = 0; rt < s[_].length; rt += 1)
      fillRecords(a, s[_][rt], $ + 1, _, _e, tt, rt);
}
function useFlattenRecords(a, s, $, _) {
  var _e = reactExports.useMemo(function() {
    if ($ != null && $.size) {
      for (var tt = [], nt = 0; nt < (a == null ? void 0 : a.length); nt += 1) {
        var at = a[nt];
        fillRecords(tt, at, 0, s, $, _, nt);
      }
      return tt;
    }
    return a == null ? void 0 : a.map(function(ot, rt) {
      return {
        record: ot,
        indent: 0,
        index: rt
      };
    });
  }, [a, s, $, _]);
  return _e;
}
function useRowInfo(a, s, $, _) {
  var _e = useContext(TableContext, ["prefixCls", "fixedInfoList", "flattenColumns", "expandableType", "expandRowByClick", "onTriggerExpand", "rowClassName", "expandedRowClassName", "indentSize", "expandIcon", "expandedRowRender", "expandIconColumnIndex", "expandedKeys", "childrenColumnName", "rowExpandable", "onRow"]), tt = _e.flattenColumns, nt = _e.expandableType, at = _e.expandedKeys, ot = _e.childrenColumnName, rt = _e.onTriggerExpand, st = _e.rowExpandable, lt = _e.onRow, et = _e.expandRowByClick, it = _e.rowClassName, ut = nt === "nest", ft = nt === "row" && (!st || st(a)), ht = ft || ut, dt = at && at.has(s), gt = ot && a && a[ot], pt = useEvent(rt), mt = lt == null ? void 0 : lt(a, $), ct = mt == null ? void 0 : mt.onClick, vt = function(Et) {
    et && ht && rt(a, Et);
    for (var St = arguments.length, Bt = new Array(St > 1 ? St - 1 : 0), Ot = 1; Ot < St; Ot++)
      Bt[Ot - 1] = arguments[Ot];
    ct == null || ct.apply(void 0, [Et].concat(Bt));
  }, At;
  typeof it == "string" ? At = it : typeof it == "function" && (At = it(a, $, _));
  var xt = getColumnsKey(tt);
  return _objectSpread2$a(_objectSpread2$a({}, _e), {}, {
    columnsKey: xt,
    nestExpandable: ut,
    expanded: dt,
    hasNestChildren: gt,
    record: a,
    onTriggerExpand: pt,
    rowSupportExpand: ft,
    expandable: ht,
    rowProps: _objectSpread2$a(_objectSpread2$a({}, mt), {}, {
      className: classnames(At, mt == null ? void 0 : mt.className),
      onClick: vt
    })
  });
}
function ExpandedRow(a) {
  var s = a.prefixCls, $ = a.children, _ = a.component, _e = a.cellComponent, tt = a.className, nt = a.expanded, at = a.colSpan, ot = a.isEmpty, rt = useContext(TableContext, ["scrollbarSize", "fixHeader", "fixColumn", "componentWidth", "horizonScroll"]), st = rt.scrollbarSize, lt = rt.fixHeader, et = rt.fixColumn, it = rt.componentWidth, ut = rt.horizonScroll, ft = $;
  return (ot ? ut && it : et) && (ft = /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      width: it - (lt ? st : 0),
      position: "sticky",
      left: 0,
      overflow: "hidden"
    },
    className: "".concat(s, "-expanded-row-fixed")
  }, ft)), /* @__PURE__ */ reactExports.createElement(_, {
    className: tt,
    style: {
      display: nt ? null : "none"
    }
  }, /* @__PURE__ */ reactExports.createElement(Cell$1, {
    component: _e,
    prefixCls: s,
    colSpan: at
  }, ft));
}
function getCellProps(a, s, $, _, _e) {
  var tt = a.record, nt = a.prefixCls, at = a.columnsKey, ot = a.fixedInfoList, rt = a.expandIconColumnIndex, st = a.nestExpandable, lt = a.indentSize, et = a.expandIcon, it = a.expanded, ut = a.hasNestChildren, ft = a.onTriggerExpand, ht = at[$], dt = ot[$], gt;
  $ === (rt || 0) && st && (gt = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement("span", {
    style: {
      paddingLeft: "".concat(lt * _, "px")
    },
    className: "".concat(nt, "-row-indent indent-level-").concat(_)
  }), et({
    prefixCls: nt,
    expanded: it,
    expandable: ut,
    record: tt,
    onExpand: ft
  })));
  var pt;
  return s.onCell && (pt = s.onCell(tt, _e)), {
    key: ht,
    fixedInfo: dt,
    appendCellNode: gt,
    additionalCellProps: pt || {}
  };
}
function BodyRow(a) {
  var s = a.className, $ = a.style, _ = a.record, _e = a.index, tt = a.renderIndex, nt = a.rowKey, at = a.indent, ot = at === void 0 ? 0 : at, rt = a.rowComponent, st = a.cellComponent, lt = a.scopeCellComponent, et = useRowInfo(_, nt, _e, ot), it = et.prefixCls, ut = et.flattenColumns, ft = et.expandedRowClassName, ht = et.expandedRowRender, dt = et.rowProps, gt = et.expanded, pt = et.rowSupportExpand, mt = reactExports.useRef(!1);
  mt.current || (mt.current = gt);
  var ct = /* @__PURE__ */ reactExports.createElement(rt, _extends$2({}, dt, {
    "data-row-key": nt,
    className: classnames(s, "".concat(it, "-row"), "".concat(it, "-row-level-").concat(ot), dt == null ? void 0 : dt.className),
    style: _objectSpread2$a(_objectSpread2$a({}, $), dt == null ? void 0 : dt.style)
  }), ut.map(function(bt, Et) {
    var St = bt.render, Bt = bt.dataIndex, Ot = bt.className, Pt = getCellProps(et, bt, Et, ot, _e), wt = Pt.key, Ct = Pt.fixedInfo, It = Pt.appendCellNode, yt = Pt.additionalCellProps;
    return /* @__PURE__ */ reactExports.createElement(Cell$1, _extends$2({
      className: Ot,
      ellipsis: bt.ellipsis,
      align: bt.align,
      scope: bt.rowScope,
      component: bt.rowScope ? lt : st,
      prefixCls: it,
      key: wt,
      record: _,
      index: _e,
      renderIndex: tt,
      dataIndex: Bt,
      render: St,
      shouldCellUpdate: bt.shouldCellUpdate
    }, Ct, {
      appendNode: It,
      additionalProps: yt
    }));
  })), vt;
  if (pt && (mt.current || gt)) {
    var At = ht(_, _e, ot + 1, gt), xt = ft && ft(_, _e, ot);
    vt = /* @__PURE__ */ reactExports.createElement(ExpandedRow, {
      expanded: gt,
      className: classnames("".concat(it, "-expanded-row"), "".concat(it, "-expanded-row-level-").concat(ot + 1), xt),
      prefixCls: it,
      component: rt,
      cellComponent: st,
      colSpan: ut.length,
      isEmpty: !1
    }, At);
  }
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, ct, vt);
}
BodyRow.displayName = "BodyRow";
const BodyRow$1 = responseImmutable(BodyRow);
function MeasureCell(a) {
  var s = a.columnKey, $ = a.onColumnResize, _ = reactExports.useRef();
  return reactExports.useEffect(function() {
    _.current && $(s, _.current.offsetWidth);
  }, []), /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    data: s
  }, /* @__PURE__ */ reactExports.createElement("td", {
    ref: _,
    style: {
      padding: 0,
      border: 0,
      height: 0
    }
  }, /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      height: 0,
      overflow: "hidden"
    }
  }, " ")));
}
function MeasureRow(a) {
  var s = a.prefixCls, $ = a.columnsKey, _ = a.onColumnResize;
  return /* @__PURE__ */ reactExports.createElement("tr", {
    "aria-hidden": "true",
    className: "".concat(s, "-measure-row"),
    style: {
      height: 0,
      fontSize: 0
    }
  }, /* @__PURE__ */ reactExports.createElement(RefResizeObserver.Collection, {
    onBatchResize: function(tt) {
      tt.forEach(function(nt) {
        var at = nt.data, ot = nt.size;
        _(at, ot.offsetWidth);
      });
    }
  }, $.map(function(_e) {
    return /* @__PURE__ */ reactExports.createElement(MeasureCell, {
      key: _e,
      columnKey: _e,
      onColumnResize: _
    });
  })));
}
function Body(a) {
  var s = a.data, $ = a.measureColumnWidth, _ = useContext(TableContext, ["prefixCls", "getComponent", "onColumnResize", "flattenColumns", "getRowKey", "expandedKeys", "childrenColumnName", "emptyNode"]), _e = _.prefixCls, tt = _.getComponent, nt = _.onColumnResize, at = _.flattenColumns, ot = _.getRowKey, rt = _.expandedKeys, st = _.childrenColumnName, lt = _.emptyNode, et = useFlattenRecords(s, st, rt, ot), it = reactExports.useRef({
    renderWithProps: !1
  }), ut = tt(["body", "wrapper"], "tbody"), ft = tt(["body", "row"], "tr"), ht = tt(["body", "cell"], "td"), dt = tt(["body", "cell"], "th"), gt;
  s.length ? gt = et.map(function(mt, ct) {
    var vt = mt.record, At = mt.indent, xt = mt.index, bt = ot(vt, ct);
    return /* @__PURE__ */ reactExports.createElement(BodyRow$1, {
      key: bt,
      rowKey: bt,
      record: vt,
      index: ct,
      renderIndex: xt,
      rowComponent: ft,
      cellComponent: ht,
      scopeCellComponent: dt,
      getRowKey: ot,
      indent: At
    });
  }) : gt = /* @__PURE__ */ reactExports.createElement(ExpandedRow, {
    expanded: !0,
    className: "".concat(_e, "-placeholder"),
    prefixCls: _e,
    component: ft,
    cellComponent: ht,
    colSpan: at.length,
    isEmpty: !0
  }, lt);
  var pt = getColumnsKey(at);
  return /* @__PURE__ */ reactExports.createElement(PerfContext.Provider, {
    value: it.current
  }, /* @__PURE__ */ reactExports.createElement(ut, {
    className: "".concat(_e, "-tbody")
  }, $ && /* @__PURE__ */ reactExports.createElement(MeasureRow, {
    prefixCls: _e,
    columnsKey: pt,
    onColumnResize: nt
  }), gt));
}
Body.displayName = "Body";
const Body$1 = responseImmutable(Body);
var _excluded$b = ["expandable"], INTERNAL_COL_DEFINE = "RC_TABLE_INTERNAL_COL_DEFINE";
function getExpandableProps(a) {
  var s = a.expandable, $ = _objectWithoutProperties$1(a, _excluded$b), _;
  return "expandable" in a ? _ = _objectSpread2$a(_objectSpread2$a({}, $), s) : _ = $, _.showExpandColumn === !1 && (_.expandIconColumnIndex = -1), _;
}
var _excluded$a = ["columnType"];
function ColGroup(a) {
  for (var s = a.colWidths, $ = a.columns, _ = a.columCount, _e = [], tt = _ || $.length, nt = !1, at = tt - 1; at >= 0; at -= 1) {
    var ot = s[at], rt = $ && $[at], st = rt && rt[INTERNAL_COL_DEFINE];
    if (ot || st || nt) {
      var lt = st || {};
      lt.columnType;
      var et = _objectWithoutProperties$1(lt, _excluded$a);
      _e.unshift(/* @__PURE__ */ reactExports.createElement("col", _extends$2({
        key: at,
        style: {
          width: ot
        }
      }, et))), nt = !0;
    }
  }
  return /* @__PURE__ */ reactExports.createElement("colgroup", null, _e);
}
var _excluded$9 = ["className", "noData", "columns", "flattenColumns", "colWidths", "columCount", "stickyOffsets", "direction", "fixHeader", "stickyTopOffset", "stickyBottomOffset", "stickyClassName", "onScroll", "maxContentScroll", "children"];
function useColumnWidth(a, s) {
  return reactExports.useMemo(function() {
    for (var $ = [], _ = 0; _ < s; _ += 1) {
      var _e = a[_];
      if (_e !== void 0)
        $[_] = _e;
      else
        return null;
    }
    return $;
  }, [a.join("_"), s]);
}
var FixedHolder = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.className, _ = a.noData, _e = a.columns, tt = a.flattenColumns, nt = a.colWidths, at = a.columCount, ot = a.stickyOffsets, rt = a.direction, st = a.fixHeader, lt = a.stickyTopOffset, et = a.stickyBottomOffset, it = a.stickyClassName, ut = a.onScroll, ft = a.maxContentScroll, ht = a.children, dt = _objectWithoutProperties$1(a, _excluded$9), gt = useContext(TableContext, ["prefixCls", "scrollbarSize", "isSticky"]), pt = gt.prefixCls, mt = gt.scrollbarSize, ct = gt.isSticky, vt = ct && !st ? 0 : mt, At = reactExports.useRef(null), xt = reactExports.useCallback(function(Ct) {
    fillRef(s, Ct), fillRef(At, Ct);
  }, []);
  reactExports.useEffect(function() {
    var Ct;
    function It(yt) {
      var Rt = yt, kt = Rt.currentTarget, jt = Rt.deltaX;
      jt && (ut({
        currentTarget: kt,
        scrollLeft: kt.scrollLeft + jt
      }), yt.preventDefault());
    }
    return (Ct = At.current) === null || Ct === void 0 || Ct.addEventListener("wheel", It), function() {
      var yt;
      (yt = At.current) === null || yt === void 0 || yt.removeEventListener("wheel", It);
    };
  }, []);
  var bt = reactExports.useMemo(function() {
    return tt.every(function(Ct) {
      return Ct.width;
    });
  }, [tt]), Et = tt[tt.length - 1], St = {
    fixed: Et ? Et.fixed : null,
    scrollbar: !0,
    onHeaderCell: function() {
      return {
        className: "".concat(pt, "-cell-scrollbar")
      };
    }
  }, Bt = reactExports.useMemo(function() {
    return vt ? [].concat(_toConsumableArray$d(_e), [St]) : _e;
  }, [vt, _e]), Ot = reactExports.useMemo(function() {
    return vt ? [].concat(_toConsumableArray$d(tt), [St]) : tt;
  }, [vt, tt]), Pt = reactExports.useMemo(function() {
    var Ct = ot.right, It = ot.left;
    return _objectSpread2$a(_objectSpread2$a({}, ot), {}, {
      left: rt === "rtl" ? [].concat(_toConsumableArray$d(It.map(function(yt) {
        return yt + vt;
      })), [0]) : It,
      right: rt === "rtl" ? Ct : [].concat(_toConsumableArray$d(Ct.map(function(yt) {
        return yt + vt;
      })), [0]),
      isSticky: ct
    });
  }, [vt, ot, ct]), wt = useColumnWidth(nt, at);
  return /* @__PURE__ */ reactExports.createElement("div", {
    style: _objectSpread2$a({
      overflow: "hidden"
    }, ct ? {
      top: lt,
      bottom: et
    } : {}),
    ref: xt,
    className: classnames($, _defineProperty$c({}, it, !!it))
  }, /* @__PURE__ */ reactExports.createElement("table", {
    style: {
      tableLayout: "fixed",
      visibility: _ || wt ? null : "hidden"
    }
  }, (!_ || !ft || bt) && /* @__PURE__ */ reactExports.createElement(ColGroup, {
    colWidths: wt ? [].concat(_toConsumableArray$d(wt), [vt]) : [],
    columCount: at + 1,
    columns: Ot
  }), ht(_objectSpread2$a(_objectSpread2$a({}, dt), {}, {
    stickyOffsets: Pt,
    columns: Bt,
    flattenColumns: Ot
  }))));
});
FixedHolder.displayName = "FixedHolder";
const FixedHolder$1 = /* @__PURE__ */ reactExports.memo(FixedHolder);
function HeaderRow(a) {
  var s = a.cells, $ = a.stickyOffsets, _ = a.flattenColumns, _e = a.rowComponent, tt = a.cellComponent, nt = a.tdCellComponent, at = a.onHeaderRow, ot = a.index, rt = useContext(TableContext, ["prefixCls", "direction"]), st = rt.prefixCls, lt = rt.direction, et;
  at && (et = at(s.map(function(ut) {
    return ut.column;
  }), ot));
  var it = getColumnsKey(s.map(function(ut) {
    return ut.column;
  }));
  return /* @__PURE__ */ reactExports.createElement(_e, et, s.map(function(ut, ft) {
    var ht = ut.column, dt = getCellFixedInfo(ut.colStart, ut.colEnd, _, $, lt, ht), gt;
    return ht && ht.onHeaderCell && (gt = ut.column.onHeaderCell(ht)), /* @__PURE__ */ reactExports.createElement(Cell$1, _extends$2({}, ut, {
      scope: ht.title ? ut.colSpan > 1 ? "colgroup" : "col" : null,
      ellipsis: ht.ellipsis,
      align: ht.align,
      component: ht.title ? tt : nt,
      prefixCls: st,
      key: it[ft]
    }, dt, {
      additionalProps: gt,
      rowType: "header"
    }));
  }));
}
HeaderRow.displayName = "HeaderRow";
function parseHeaderRows(a) {
  var s = [];
  function $(nt, at) {
    var ot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    s[ot] = s[ot] || [];
    var rt = at, st = nt.filter(Boolean).map(function(lt) {
      var et = {
        key: lt.key,
        className: lt.className || "",
        children: lt.title,
        column: lt,
        colStart: rt
      }, it = 1, ut = lt.children;
      return ut && ut.length > 0 && (it = $(ut, rt, ot + 1).reduce(function(ft, ht) {
        return ft + ht;
      }, 0), et.hasSubColumns = !0), "colSpan" in lt && (it = lt.colSpan), "rowSpan" in lt && (et.rowSpan = lt.rowSpan), et.colSpan = it, et.colEnd = et.colStart + it - 1, s[ot].push(et), rt += it, it;
    });
    return st;
  }
  $(a, 0);
  for (var _ = s.length, _e = function(at) {
    s[at].forEach(function(ot) {
      !("rowSpan" in ot) && !ot.hasSubColumns && (ot.rowSpan = _ - at);
    });
  }, tt = 0; tt < _; tt += 1)
    _e(tt);
  return s;
}
function Header(a) {
  var s = a.stickyOffsets, $ = a.columns, _ = a.flattenColumns, _e = a.onHeaderRow, tt = useContext(TableContext, ["prefixCls", "getComponent"]), nt = tt.prefixCls, at = tt.getComponent, ot = reactExports.useMemo(function() {
    return parseHeaderRows($);
  }, [$]), rt = at(["header", "wrapper"], "thead"), st = at(["header", "row"], "tr"), lt = at(["header", "cell"], "th"), et = at(["header", "cell"], "td");
  return /* @__PURE__ */ reactExports.createElement(rt, {
    className: "".concat(nt, "-thead")
  }, ot.map(function(it, ut) {
    var ft = /* @__PURE__ */ reactExports.createElement(HeaderRow, {
      key: ut,
      flattenColumns: _,
      cells: it,
      stickyOffsets: s,
      rowComponent: st,
      cellComponent: lt,
      tdCellComponent: et,
      onHeaderRow: _e,
      index: ut
    });
    return ft;
  }));
}
const Header$1 = responseImmutable(Header);
function parseColWidth(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return typeof s == "number" ? s : s.endsWith("%") ? a * parseFloat(s) / 100 : null;
}
function useWidthColumns(a, s, $) {
  return reactExports.useMemo(function() {
    if (s && s > 0) {
      var _ = 0, _e = 0;
      a.forEach(function(et) {
        var it = parseColWidth(s, et.width);
        it ? _ += it : _e += 1;
      });
      var tt = Math.max(s, $), nt = Math.max(tt - _, _e), at = _e, ot = nt / _e, rt = 0, st = a.map(function(et) {
        var it = _objectSpread2$a({}, et), ut = parseColWidth(s, it.width);
        if (ut)
          it.width = ut;
        else {
          var ft = Math.floor(ot);
          it.width = at === 1 ? nt : ft, nt -= ft, at -= 1;
        }
        return rt += it.width, it;
      });
      if (rt < tt) {
        var lt = tt / rt;
        nt = tt, st.forEach(function(et, it) {
          var ut = Math.floor(et.width * lt);
          et.width = it === st.length - 1 ? nt : ut, nt -= ut;
        });
      }
      return [st, Math.max(rt, tt)];
    }
    return [a, s];
  }, [a, s, $]);
}
var _excluded$8 = ["children"], _excluded2$1 = ["fixed"];
function convertChildrenToColumns(a) {
  return toArray$9(a).filter(function(s) {
    return /* @__PURE__ */ reactExports.isValidElement(s);
  }).map(function(s) {
    var $ = s.key, _ = s.props, _e = _.children, tt = _objectWithoutProperties$1(_, _excluded$8), nt = _objectSpread2$a({
      key: $
    }, tt);
    return _e && (nt.children = convertChildrenToColumns(_e)), nt;
  });
}
function flatColumns(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "key";
  return a.filter(function($) {
    return $ && _typeof$q($) === "object";
  }).reduce(function($, _, _e) {
    var tt = _.fixed, nt = tt === !0 ? "left" : tt, at = "".concat(s, "-").concat(_e), ot = _.children;
    return ot && ot.length > 0 ? [].concat(_toConsumableArray$d($), _toConsumableArray$d(flatColumns(ot, at).map(function(rt) {
      return _objectSpread2$a({
        fixed: nt
      }, rt);
    }))) : [].concat(_toConsumableArray$d($), [_objectSpread2$a(_objectSpread2$a({
      key: at
    }, _), {}, {
      fixed: nt
    })]);
  }, []);
}
function revertForRtl(a) {
  return a.map(function(s) {
    var $ = s.fixed, _ = _objectWithoutProperties$1(s, _excluded2$1), _e = $;
    return $ === "left" ? _e = "right" : $ === "right" && (_e = "left"), _objectSpread2$a({
      fixed: _e
    }, _);
  });
}
function useColumns(a, s) {
  var $ = a.prefixCls, _ = a.columns, _e = a.children, tt = a.expandable, nt = a.expandedKeys, at = a.columnTitle, ot = a.getRowKey, rt = a.onTriggerExpand, st = a.expandIcon, lt = a.rowExpandable, et = a.expandIconColumnIndex, it = a.direction, ut = a.expandRowByClick, ft = a.columnWidth, ht = a.fixed, dt = a.scrollWidth, gt = a.clientWidth, pt = reactExports.useMemo(function() {
    return _ || convertChildrenToColumns(_e);
  }, [_, _e]), mt = reactExports.useMemo(function() {
    if (tt) {
      var St, Bt = pt.slice();
      if (!Bt.includes(EXPAND_COLUMN)) {
        var Ot = et || 0;
        Ot >= 0 && Bt.splice(Ot, 0, EXPAND_COLUMN);
      }
      var Pt = Bt.indexOf(EXPAND_COLUMN);
      Bt = Bt.filter(function(yt, Rt) {
        return yt !== EXPAND_COLUMN || Rt === Pt;
      });
      var wt = pt[Pt], Ct;
      (ht === "left" || ht) && !et ? Ct = "left" : (ht === "right" || ht) && et === pt.length ? Ct = "right" : Ct = wt ? wt.fixed : null;
      var It = (St = {}, _defineProperty$c(St, INTERNAL_COL_DEFINE, {
        className: "".concat($, "-expand-icon-col"),
        columnType: "EXPAND_COLUMN"
      }), _defineProperty$c(St, "title", at), _defineProperty$c(St, "fixed", Ct), _defineProperty$c(St, "className", "".concat($, "-row-expand-icon-cell")), _defineProperty$c(St, "width", ft), _defineProperty$c(St, "render", function(Rt, kt, jt) {
        var Ht = ot(kt, jt), Ft = nt.has(Ht), _t = lt ? lt(kt) : !0, Nt = st({
          prefixCls: $,
          expanded: Ft,
          expandable: _t,
          record: kt,
          onExpand: rt
        });
        return ut ? /* @__PURE__ */ reactExports.createElement("span", {
          onClick: function(Lt) {
            return Lt.stopPropagation();
          }
        }, Nt) : Nt;
      }), St);
      return Bt.map(function(yt) {
        return yt === EXPAND_COLUMN ? It : yt;
      });
    }
    return pt.filter(function(yt) {
      return yt !== EXPAND_COLUMN;
    });
  }, [tt, pt, ot, nt, st, it]), ct = reactExports.useMemo(function() {
    var St = mt;
    return s && (St = s(St)), St.length || (St = [{
      render: function() {
        return null;
      }
    }]), St;
  }, [s, mt, it]), vt = reactExports.useMemo(function() {
    return it === "rtl" ? revertForRtl(flatColumns(ct)) : flatColumns(ct);
  }, [ct, it, dt]), At = useWidthColumns(vt, dt, gt), xt = _slicedToArray$e(At, 2), bt = xt[0], Et = xt[1];
  return [ct, bt, Et];
}
function renderExpandIcon$1(a) {
  var s, $ = a.prefixCls, _ = a.record, _e = a.onExpand, tt = a.expanded, nt = a.expandable, at = "".concat($, "-row-expand-icon");
  if (!nt)
    return /* @__PURE__ */ reactExports.createElement("span", {
      className: classnames(at, "".concat($, "-row-spaced"))
    });
  var ot = function(st) {
    _e(_, st), st.stopPropagation();
  };
  return /* @__PURE__ */ reactExports.createElement("span", {
    className: classnames(at, (s = {}, _defineProperty$c(s, "".concat($, "-row-expanded"), tt), _defineProperty$c(s, "".concat($, "-row-collapsed"), !tt), s)),
    onClick: ot
  });
}
function findAllChildrenKeys(a, s, $) {
  var _ = [];
  function _e(tt) {
    (tt || []).forEach(function(nt, at) {
      _.push(s(nt, at)), _e(nt[$]);
    });
  }
  return _e(a), _;
}
function useExpand(a, s, $) {
  var _ = getExpandableProps(a), _e = _.expandIcon, tt = _.expandedRowKeys, nt = _.defaultExpandedRowKeys, at = _.defaultExpandAllRows, ot = _.expandedRowRender, rt = _.onExpand, st = _.onExpandedRowsChange, lt = _.childrenColumnName, et = _e || renderExpandIcon$1, it = lt || "children", ut = reactExports.useMemo(function() {
    return ot ? "row" : a.expandable && a.internalHooks === INTERNAL_HOOKS && a.expandable.__PARENT_RENDER_ICON__ || s.some(function(ct) {
      return ct && _typeof$q(ct) === "object" && ct[it];
    }) ? "nest" : !1;
  }, [!!ot, s]), ft = reactExports.useState(function() {
    return nt || (at ? findAllChildrenKeys(s, $, it) : []);
  }), ht = _slicedToArray$e(ft, 2), dt = ht[0], gt = ht[1], pt = reactExports.useMemo(function() {
    return new Set(tt || dt || []);
  }, [tt, dt]), mt = reactExports.useCallback(function(ct) {
    var vt = $(ct, s.indexOf(ct)), At, xt = pt.has(vt);
    xt ? (pt.delete(vt), At = _toConsumableArray$d(pt)) : At = [].concat(_toConsumableArray$d(pt), [vt]), gt(At), rt && rt(!xt, ct), st && st(At);
  }, [$, pt, s, rt, st]);
  return [_, ut, pt, et, it, mt];
}
function useFixedInfo(a, s, $, _) {
  var _e = a.map(function(tt, nt) {
    return getCellFixedInfo(nt, nt, a, s, $, _ == null ? void 0 : _[nt]);
  });
  return useMemo(function() {
    return _e;
  }, [_e], function(tt, nt) {
    return !isEqual$1(tt, nt);
  });
}
function useLayoutState(a) {
  var s = reactExports.useRef(a), $ = reactExports.useState({}), _ = _slicedToArray$e($, 2), _e = _[1], tt = reactExports.useRef(null), nt = reactExports.useRef([]);
  function at(ot) {
    nt.current.push(ot);
    var rt = Promise.resolve();
    tt.current = rt, rt.then(function() {
      if (tt.current === rt) {
        var st = nt.current, lt = s.current;
        nt.current = [], st.forEach(function(et) {
          s.current = et(s.current);
        }), tt.current = null, lt !== s.current && _e({});
      }
    });
  }
  return reactExports.useEffect(function() {
    return function() {
      tt.current = null;
    };
  }, []), [s.current, at];
}
function useTimeoutLock(a) {
  var s = reactExports.useRef(a || null), $ = reactExports.useRef();
  function _() {
    window.clearTimeout($.current);
  }
  function _e(nt) {
    s.current = nt, _(), $.current = window.setTimeout(function() {
      s.current = null, $.current = void 0;
    }, 100);
  }
  function tt() {
    return s.current;
  }
  return reactExports.useEffect(function() {
    return _;
  }, []), [_e, tt];
}
function useHover() {
  var a = reactExports.useState(-1), s = _slicedToArray$e(a, 2), $ = s[0], _ = s[1], _e = reactExports.useState(-1), tt = _slicedToArray$e(_e, 2), nt = tt[0], at = tt[1], ot = reactExports.useCallback(function(rt, st) {
    _(rt), at(st);
  }, []);
  return [$, nt, ot];
}
var defaultContainer = canUseDom$1() ? window : null;
function useSticky(a, s) {
  var $ = _typeof$q(a) === "object" ? a : {}, _ = $.offsetHeader, _e = _ === void 0 ? 0 : _, tt = $.offsetSummary, nt = tt === void 0 ? 0 : tt, at = $.offsetScroll, ot = at === void 0 ? 0 : at, rt = $.getContainer, st = rt === void 0 ? function() {
    return defaultContainer;
  } : rt, lt = st() || defaultContainer;
  return reactExports.useMemo(function() {
    var et = !!a;
    return {
      isSticky: et,
      stickyClassName: et ? "".concat(s, "-sticky-holder") : "",
      offsetHeader: _e,
      offsetSummary: nt,
      offsetScroll: ot,
      container: lt
    };
  }, [ot, _e, nt, s, lt]);
}
function useStickyOffsets(a, s, $) {
  var _ = reactExports.useMemo(function() {
    for (var _e = [], tt = [], nt = 0, at = 0, ot = 0; ot < s; ot += 1)
      if ($ === "rtl") {
        tt[ot] = at, at += a[ot] || 0;
        var rt = s - ot - 1;
        _e[rt] = nt, nt += a[rt] || 0;
      } else {
        _e[ot] = nt, nt += a[ot] || 0;
        var st = s - ot - 1;
        tt[st] = at, at += a[st] || 0;
      }
    return {
      left: _e,
      right: tt
    };
  }, [a, s, $]);
  return _;
}
function Panel$2(a) {
  var s = a.className, $ = a.children;
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: s
  }, $);
}
var StickyScrollBar = function a(s, $) {
  var _, _e, tt = s.scrollBodyRef, nt = s.onScroll, at = s.offsetScroll, ot = s.container, rt = useContext(TableContext, "prefixCls"), st = ((_ = tt.current) === null || _ === void 0 ? void 0 : _.scrollWidth) || 0, lt = ((_e = tt.current) === null || _e === void 0 ? void 0 : _e.clientWidth) || 0, et = st && lt * (lt / st), it = reactExports.useRef(), ut = useLayoutState({
    scrollLeft: 0,
    isHiddenScrollBar: !1
  }), ft = _slicedToArray$e(ut, 2), ht = ft[0], dt = ft[1], gt = reactExports.useRef({
    delta: 0,
    x: 0
  }), pt = reactExports.useState(!1), mt = _slicedToArray$e(pt, 2), ct = mt[0], vt = mt[1], At = function() {
    vt(!1);
  }, xt = function(Ot) {
    Ot.persist(), gt.current.delta = Ot.pageX - ht.scrollLeft, gt.current.x = 0, vt(!0), Ot.preventDefault();
  }, bt = function(Ot) {
    var Pt, wt = Ot || ((Pt = window) === null || Pt === void 0 ? void 0 : Pt.event), Ct = wt.buttons;
    if (!ct || Ct === 0) {
      ct && vt(!1);
      return;
    }
    var It = gt.current.x + Ot.pageX - gt.current.x - gt.current.delta;
    It <= 0 && (It = 0), It + et >= lt && (It = lt - et), nt({
      scrollLeft: It / lt * (st + 2)
    }), gt.current.x = Ot.pageX;
  }, Et = function() {
    if (tt.current) {
      var Ot = getOffset$2(tt.current).top, Pt = Ot + tt.current.offsetHeight, wt = ot === window ? document.documentElement.scrollTop + window.innerHeight : getOffset$2(ot).top + ot.clientHeight;
      Pt - getScrollBarSize() <= wt || Ot >= wt - at ? dt(function(Ct) {
        return _objectSpread2$a(_objectSpread2$a({}, Ct), {}, {
          isHiddenScrollBar: !0
        });
      }) : dt(function(Ct) {
        return _objectSpread2$a(_objectSpread2$a({}, Ct), {}, {
          isHiddenScrollBar: !1
        });
      });
    }
  }, St = function(Ot) {
    dt(function(Pt) {
      return _objectSpread2$a(_objectSpread2$a({}, Pt), {}, {
        scrollLeft: Ot / st * lt || 0
      });
    });
  };
  return reactExports.useImperativeHandle($, function() {
    return {
      setScrollLeft: St
    };
  }), reactExports.useEffect(function() {
    var Bt = addEventListenerWrap$3(document.body, "mouseup", At, !1), Ot = addEventListenerWrap$3(document.body, "mousemove", bt, !1);
    return Et(), function() {
      Bt.remove(), Ot.remove();
    };
  }, [et, ct]), reactExports.useEffect(function() {
    var Bt = addEventListenerWrap$3(ot, "scroll", Et, !1), Ot = addEventListenerWrap$3(window, "resize", Et, !1);
    return function() {
      Bt.remove(), Ot.remove();
    };
  }, [ot]), reactExports.useEffect(function() {
    ht.isHiddenScrollBar || dt(function(Bt) {
      var Ot = tt.current;
      return Ot ? _objectSpread2$a(_objectSpread2$a({}, Bt), {}, {
        scrollLeft: Ot.scrollLeft / Ot.scrollWidth * Ot.clientWidth
      }) : Bt;
    });
  }, [ht.isHiddenScrollBar]), st <= lt || !et || ht.isHiddenScrollBar ? null : /* @__PURE__ */ reactExports.createElement("div", {
    style: {
      height: getScrollBarSize(),
      width: lt,
      bottom: at
    },
    className: "".concat(rt, "-sticky-scroll")
  }, /* @__PURE__ */ reactExports.createElement("div", {
    onMouseDown: xt,
    ref: it,
    className: classnames("".concat(rt, "-sticky-scroll-bar"), _defineProperty$c({}, "".concat(rt, "-sticky-scroll-bar-active"), ct)),
    style: {
      width: "".concat(et, "px"),
      transform: "translate3d(".concat(ht.scrollLeft, "px, 0, 0)")
    }
  }));
};
const StickyScrollBar$1 = /* @__PURE__ */ reactExports.forwardRef(StickyScrollBar);
var DEFAULT_PREFIX = "rc-table", EMPTY_DATA = [], EMPTY_SCROLL_TARGET = {};
function defaultEmpty() {
  return "No Data";
}
function Table$2(a, s) {
  var $, _ = _objectSpread2$a({
    rowKey: "key",
    prefixCls: DEFAULT_PREFIX,
    emptyText: defaultEmpty
  }, a), _e = _.prefixCls, tt = _.className, nt = _.rowClassName, at = _.style, ot = _.data, rt = _.rowKey, st = _.scroll, lt = _.tableLayout, et = _.direction, it = _.title, ut = _.footer, ft = _.summary, ht = _.caption, dt = _.id, gt = _.showHeader, pt = _.components, mt = _.emptyText, ct = _.onRow, vt = _.onHeaderRow, At = _.internalHooks, xt = _.transformColumns, bt = _.internalRefs, Et = _.tailor, St = _.getContainerWidth, Bt = _.sticky, Ot = ot || EMPTY_DATA, Pt = !!Ot.length, wt = At === INTERNAL_HOOKS, Ct = reactExports.useCallback(function(Mn, Nn) {
    return get$1(pt, Mn) || Nn;
  }, [pt]), It = reactExports.useMemo(function() {
    return typeof rt == "function" ? rt : function(Mn) {
      var Nn = Mn && Mn[rt];
      return Nn;
    };
  }, [rt]), yt = Ct(["body"]), Rt = useHover(), kt = _slicedToArray$e(Rt, 3), jt = kt[0], Ht = kt[1], Ft = kt[2], _t = useExpand(_, Ot, It), Nt = _slicedToArray$e(_t, 6), Mt = Nt[0], Lt = Nt[1], $t = Nt[2], Tt = Nt[3], Dt = Nt[4], Ut = Nt[5], Vt = st == null ? void 0 : st.x, Qt = reactExports.useState(0), qt = _slicedToArray$e(Qt, 2), Zt = qt[0], ar = qt[1], Jt = useColumns(_objectSpread2$a(_objectSpread2$a(_objectSpread2$a({}, _), Mt), {}, {
    expandable: !!Mt.expandedRowRender,
    columnTitle: Mt.columnTitle,
    expandedKeys: $t,
    getRowKey: It,
    // https://github.com/ant-design/ant-design/issues/23894
    onTriggerExpand: Ut,
    expandIcon: Tt,
    expandIconColumnIndex: Mt.expandIconColumnIndex,
    direction: et,
    scrollWidth: wt && Et && typeof Vt == "number" ? Vt : null,
    clientWidth: Zt
  }), wt ? xt : null), rr = _slicedToArray$e(Jt, 3), Yt = rr[0], Kt = rr[1], nr = rr[2], tr = nr ?? Vt, ir = reactExports.useMemo(function() {
    return {
      columns: Yt,
      flattenColumns: Kt
    };
  }, [Yt, Kt]), sr = reactExports.useRef(), cr = reactExports.useRef(), or = reactExports.useRef(), Xt = reactExports.useRef();
  reactExports.useImperativeHandle(s, function() {
    return {
      nativeElement: sr.current,
      scrollTo: function(Nn) {
        var Wn;
        if (or.current instanceof HTMLElement) {
          var ca = Nn.index, qn = Nn.top, eo = Nn.key;
          if (qn) {
            var ro;
            (ro = or.current) === null || ro === void 0 || ro.scrollTo({
              top: qn
            });
          } else {
            var ao, so = eo ?? It(Ot[ca]);
            (ao = or.current.querySelector('[data-row-key="'.concat(so, '"]'))) === null || ao === void 0 || ao.scrollIntoView();
          }
        } else
          (Wn = or.current) !== null && Wn !== void 0 && Wn.scrollTo && or.current.scrollTo(Nn);
      }
    };
  });
  var Gt = reactExports.useRef(), Wt = reactExports.useState(!1), er = _slicedToArray$e(Wt, 2), lr = er[0], ur = er[1], pr = reactExports.useState(!1), yr = _slicedToArray$e(pr, 2), Er = yr[0], br = yr[1], gr = useLayoutState(/* @__PURE__ */ new Map()), Ar = _slicedToArray$e(gr, 2), Sr = Ar[0], Br = Ar[1], Ir = getColumnsKey(Kt), hr = Ir.map(function(Mn) {
    return Sr.get(Mn);
  }), vr = reactExports.useMemo(function() {
    return hr;
  }, [hr.join("_")]), xr = useStickyOffsets(vr, Kt.length, et), Pr = st && validateValue(st.y), Rr = st && validateValue(tr) || !!Mt.fixed, Dr = Rr && Kt.some(function(Mn) {
    var Nn = Mn.fixed;
    return Nn;
  }), Gr = reactExports.useRef(), Or = useSticky(Bt, _e), Hr = Or.isSticky, jr = Or.offsetHeader, Tr = Or.offsetSummary, fr = Or.offsetScroll, Cr = Or.stickyClassName, $r = Or.container, wr = reactExports.useMemo(function() {
    return ft == null ? void 0 : ft(Ot);
  }, [ft, Ot]), Mr = (Pr || Hr) && /* @__PURE__ */ reactExports.isValidElement(wr) && wr.type === Summary && wr.props.fixed, Fr, Qr, Yr;
  Pr && (Qr = {
    overflowY: "scroll",
    maxHeight: st.y
  }), Rr && (Fr = {
    overflowX: "auto"
  }, Pr || (Qr = {
    overflowY: "hidden"
  }), Yr = {
    width: tr === !0 ? "auto" : tr,
    minWidth: "100%"
  });
  var kr = reactExports.useCallback(function(Mn, Nn) {
    isVisible(sr.current) && Br(function(Wn) {
      if (Wn.get(Mn) !== Nn) {
        var ca = new Map(Wn);
        return ca.set(Mn, Nn), ca;
      }
      return Wn;
    });
  }, []), Nr = useTimeoutLock(null), Lr = _slicedToArray$e(Nr, 2), zr = Lr[0], Vr = Lr[1];
  function an(Mn, Nn) {
    Nn && (typeof Nn == "function" ? Nn(Mn) : Nn.scrollLeft !== Mn && (Nn.scrollLeft = Mn, Nn.scrollLeft !== Mn && setTimeout(function() {
      Nn.scrollLeft = Mn;
    }, 0)));
  }
  var Zr = useEvent(function(Mn) {
    var Nn = Mn.currentTarget, Wn = Mn.scrollLeft, ca = et === "rtl", qn = typeof Wn == "number" ? Wn : Nn.scrollLeft, eo = Nn || EMPTY_SCROLL_TARGET;
    if (!Vr() || Vr() === eo) {
      var ro;
      zr(eo), an(qn, cr.current), an(qn, or.current), an(qn, Gt.current), an(qn, (ro = Gr.current) === null || ro === void 0 ? void 0 : ro.setScrollLeft);
    }
    var ao = Nn || cr.current;
    if (ao) {
      var so = ao.scrollWidth, lo = ao.clientWidth;
      if (so === lo) {
        ur(!1), br(!1);
        return;
      }
      ca ? (ur(-qn < so - lo), br(-qn > 0)) : (ur(qn > 0), br(qn < so - lo));
    }
  }), un = function() {
    Rr && or.current ? Zr({
      currentTarget: or.current
    }) : (ur(!1), br(!1));
  }, Xr = function(Nn) {
    var Wn = Nn.width, ca = sr.current ? sr.current.offsetWidth : Wn;
    wt && St && sr.current && (ca = St(sr.current, ca) || ca), ca !== Zt && (un(), ar(ca));
  }, Kr = reactExports.useRef(!1);
  reactExports.useEffect(function() {
    Kr.current && un();
  }, [Rr, ot, Yt.length]), reactExports.useEffect(function() {
    Kr.current = !0;
  }, []);
  var rn = reactExports.useState(0), nn = _slicedToArray$e(rn, 2), sn = nn[0], gn = nn[1], en = reactExports.useState(!0), Wr = _slicedToArray$e(en, 2), dn = Wr[0], hn = Wr[1];
  reactExports.useEffect(function() {
    (!Et || !wt) && (or.current instanceof Element ? gn(getTargetScrollBarSize(or.current).width) : gn(getTargetScrollBarSize(Xt.current).width)), hn(isStyleSupport("position", "sticky"));
  }, []), reactExports.useEffect(function() {
    wt && bt && (bt.body.current = or.current);
  });
  var En = reactExports.useCallback(function(Mn) {
    return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(Header$1, Mn), Mr === "top" && /* @__PURE__ */ reactExports.createElement(Footer$1, Mn, wr));
  }, [Mr, wr]), bn = reactExports.useCallback(function(Mn) {
    return /* @__PURE__ */ reactExports.createElement(Footer$1, Mn, wr);
  }, [wr]), Cn = Ct(["table"], "table"), wn = reactExports.useMemo(function() {
    return lt || (Dr ? tr === "max-content" ? "auto" : "fixed" : Pr || Hr || Kt.some(function(Mn) {
      var Nn = Mn.ellipsis;
      return Nn;
    }) ? "fixed" : "auto");
  }, [Pr, Dr, Kt, lt, Hr]), vn, fn = {
    colWidths: vr,
    columCount: Kt.length,
    stickyOffsets: xr,
    onHeaderRow: vt,
    fixHeader: Pr,
    scroll: st
  }, on = reactExports.useMemo(function() {
    return Pt ? null : typeof mt == "function" ? mt() : mt;
  }, [Pt, mt]), pn = /* @__PURE__ */ reactExports.createElement(Body$1, {
    data: Ot,
    measureColumnWidth: Pr || Rr || Hr
  }), mn = /* @__PURE__ */ reactExports.createElement(ColGroup, {
    colWidths: Kt.map(function(Mn) {
      var Nn = Mn.width;
      return Nn;
    }),
    columns: Kt
  }), Pn = ht != null ? /* @__PURE__ */ reactExports.createElement("caption", {
    className: "".concat(_e, "-caption")
  }, ht) : void 0, An = pickAttrs(_, {
    data: !0
  }), yn = pickAttrs(_, {
    aria: !0
  });
  if (Pr || Hr) {
    var Bn;
    typeof yt == "function" ? (Bn = yt(Ot, {
      scrollbarSize: sn,
      ref: or,
      onScroll: Zr
    }), fn.colWidths = Kt.map(function(Mn, Nn) {
      var Wn = Mn.width, ca = Nn === Kt.length - 1 ? Wn - sn : Wn;
      return typeof ca == "number" && !Number.isNaN(ca) ? ca : 0;
    })) : Bn = /* @__PURE__ */ reactExports.createElement("div", {
      style: _objectSpread2$a(_objectSpread2$a({}, Fr), Qr),
      onScroll: Zr,
      ref: or,
      className: classnames("".concat(_e, "-body"))
    }, /* @__PURE__ */ reactExports.createElement(Cn, _extends$2({
      style: _objectSpread2$a(_objectSpread2$a({}, Yr), {}, {
        tableLayout: wn
      })
    }, yn), Pn, mn, pn, !Mr && wr && /* @__PURE__ */ reactExports.createElement(Footer$1, {
      stickyOffsets: xr,
      flattenColumns: Kt,
      columns: Yt
    }, wr)));
    var Fn = _objectSpread2$a(_objectSpread2$a(_objectSpread2$a({
      noData: !Ot.length,
      maxContentScroll: Rr && tr === "max-content"
    }, fn), ir), {}, {
      direction: et,
      stickyClassName: Cr,
      onScroll: Zr
    });
    vn = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, gt !== !1 && /* @__PURE__ */ reactExports.createElement(FixedHolder$1, _extends$2({}, Fn, {
      stickyTopOffset: jr,
      className: "".concat(_e, "-header"),
      ref: cr
    }), En), Bn, Mr && Mr !== "top" && /* @__PURE__ */ reactExports.createElement(FixedHolder$1, _extends$2({}, Fn, {
      stickyBottomOffset: Tr,
      className: "".concat(_e, "-summary"),
      ref: Gt
    }), bn), Hr && or.current && or.current instanceof Element && /* @__PURE__ */ reactExports.createElement(StickyScrollBar$1, {
      ref: Gr,
      offsetScroll: fr,
      scrollBodyRef: or,
      onScroll: Zr,
      container: $r
    }));
  } else
    vn = /* @__PURE__ */ reactExports.createElement("div", {
      style: _objectSpread2$a(_objectSpread2$a({}, Fr), Qr),
      className: classnames("".concat(_e, "-content")),
      onScroll: Zr,
      ref: or
    }, /* @__PURE__ */ reactExports.createElement(Cn, _extends$2({
      style: _objectSpread2$a(_objectSpread2$a({}, Yr), {}, {
        tableLayout: wn
      })
    }, yn), Pn, mn, gt !== !1 && /* @__PURE__ */ reactExports.createElement(Header$1, _extends$2({}, fn, ir)), pn, wr && /* @__PURE__ */ reactExports.createElement(Footer$1, {
      stickyOffsets: xr,
      flattenColumns: Kt,
      columns: Yt
    }, wr)));
  var zn = /* @__PURE__ */ reactExports.createElement("div", _extends$2({
    className: classnames(_e, tt, ($ = {}, _defineProperty$c($, "".concat(_e, "-rtl"), et === "rtl"), _defineProperty$c($, "".concat(_e, "-ping-left"), lr), _defineProperty$c($, "".concat(_e, "-ping-right"), Er), _defineProperty$c($, "".concat(_e, "-layout-fixed"), lt === "fixed"), _defineProperty$c($, "".concat(_e, "-fixed-header"), Pr), _defineProperty$c($, "".concat(_e, "-fixed-column"), Dr), _defineProperty$c($, "".concat(_e, "-scroll-horizontal"), Rr), _defineProperty$c($, "".concat(_e, "-has-fix-left"), Kt[0] && Kt[0].fixed), _defineProperty$c($, "".concat(_e, "-has-fix-right"), Kt[Kt.length - 1] && Kt[Kt.length - 1].fixed === "right"), $)),
    style: at,
    id: dt,
    ref: sr
  }, An), it && /* @__PURE__ */ reactExports.createElement(Panel$2, {
    className: "".concat(_e, "-title")
  }, it(Ot)), /* @__PURE__ */ reactExports.createElement("div", {
    ref: Xt,
    className: "".concat(_e, "-container")
  }, vn), ut && /* @__PURE__ */ reactExports.createElement(Panel$2, {
    className: "".concat(_e, "-footer")
  }, ut(Ot)));
  Rr && (zn = /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: Xr
  }, zn));
  var Zn = useFixedInfo(Kt, xr, et, Yt), to = reactExports.useMemo(function() {
    return {
      // Scroll
      scrollX: tr,
      // Table
      prefixCls: _e,
      getComponent: Ct,
      scrollbarSize: sn,
      direction: et,
      fixedInfoList: Zn,
      isSticky: Hr,
      supportSticky: dn,
      componentWidth: Zt,
      fixHeader: Pr,
      fixColumn: Dr,
      horizonScroll: Rr,
      // Body
      tableLayout: wn,
      rowClassName: nt,
      expandedRowClassName: Mt.expandedRowClassName,
      expandIcon: Tt,
      expandableType: Lt,
      expandRowByClick: Mt.expandRowByClick,
      expandedRowRender: Mt.expandedRowRender,
      onTriggerExpand: Ut,
      expandIconColumnIndex: Mt.expandIconColumnIndex,
      indentSize: Mt.indentSize,
      allColumnsFixedLeft: Kt.every(function(Mn) {
        return Mn.fixed === "left";
      }),
      emptyNode: on,
      // Column
      columns: Yt,
      flattenColumns: Kt,
      onColumnResize: kr,
      // Row
      hoverStartRow: jt,
      hoverEndRow: Ht,
      onHover: Ft,
      rowExpandable: Mt.rowExpandable,
      onRow: ct,
      getRowKey: It,
      expandedKeys: $t,
      childrenColumnName: Dt
    };
  }, [
    // Scroll
    tr,
    // Table
    _e,
    Ct,
    sn,
    et,
    Zn,
    Hr,
    dn,
    Zt,
    Pr,
    Dr,
    Rr,
    // Body
    wn,
    nt,
    Mt.expandedRowClassName,
    Tt,
    Lt,
    Mt.expandRowByClick,
    Mt.expandedRowRender,
    Ut,
    Mt.expandIconColumnIndex,
    Mt.indentSize,
    on,
    // Column
    Yt,
    Kt,
    kr,
    // Row
    jt,
    Ht,
    Ft,
    Mt.rowExpandable,
    ct,
    It,
    $t,
    Dt
  ]);
  return /* @__PURE__ */ reactExports.createElement(TableContext.Provider, {
    value: to
  }, zn);
}
var RefTable = /* @__PURE__ */ reactExports.forwardRef(Table$2);
function genTable(a) {
  return makeImmutable(RefTable, a);
}
var ImmutableTable = genTable();
ImmutableTable.EXPAND_COLUMN = EXPAND_COLUMN;
ImmutableTable.INTERNAL_HOOKS = INTERNAL_HOOKS;
ImmutableTable.Column = Column$1;
ImmutableTable.ColumnGroup = ColumnGroup$1;
ImmutableTable.Summary = FooterComponents;
var StaticContext = createContext(null), GridContext = createContext(null);
function getColumnWidth(a, s, $) {
  var _ = s || 1;
  return $[a + _] - ($[a] || 0);
}
function VirtualCell$1(a) {
  var s = a.rowInfo, $ = a.column, _ = a.colIndex, _e = a.indent, tt = a.index, nt = a.renderIndex, at = a.record, ot = a.style, rt = a.className, st = a.inverse, lt = a.getHeight, et = $.render, it = $.dataIndex, ut = $.className, ft = $.width, ht = useContext(GridContext, ["columnsOffset"]), dt = ht.columnsOffset, gt = getCellProps(s, $, _, _e, tt), pt = gt.key, mt = gt.fixedInfo, ct = gt.appendCellNode, vt = gt.additionalCellProps, At = vt.style, xt = vt.colSpan, bt = xt === void 0 ? 1 : xt, Et = vt.rowSpan, St = Et === void 0 ? 1 : Et, Bt = _ - 1, Ot = getColumnWidth(Bt, bt, dt), Pt = bt > 1 ? ft - Ot : 0, wt = _objectSpread2$a(_objectSpread2$a(_objectSpread2$a({}, At), ot), {}, {
    flex: "0 0 ".concat(Ot, "px"),
    width: "".concat(Ot, "px"),
    marginRight: Pt,
    pointerEvents: "auto"
  }), Ct = reactExports.useMemo(function() {
    return st ? St <= 1 : bt === 0 || St === 0 || St > 1;
  }, [St, bt, st]);
  Ct ? wt.visibility = "hidden" : st && (wt.height = lt == null ? void 0 : lt(St));
  var It = Ct ? function() {
    return null;
  } : et, yt = {};
  return (St === 0 || bt === 0) && (yt.rowSpan = 1, yt.colSpan = 1), /* @__PURE__ */ reactExports.createElement(Cell$1, _extends$2({
    className: classnames(ut, rt),
    ellipsis: $.ellipsis,
    align: $.align,
    scope: $.rowScope,
    component: "div",
    prefixCls: s.prefixCls,
    key: pt,
    record: at,
    index: tt,
    renderIndex: nt,
    dataIndex: it,
    render: It,
    shouldCellUpdate: $.shouldCellUpdate
  }, mt, {
    appendNode: ct,
    additionalProps: _objectSpread2$a(_objectSpread2$a({}, vt), {}, {
      style: wt
    }, yt)
  }));
}
var _excluded$7 = ["data", "index", "className", "rowKey", "style", "extra", "getHeight"], BodyLine = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.data, _ = a.index, _e = a.className, tt = a.rowKey, nt = a.style, at = a.extra, ot = a.getHeight, rt = _objectWithoutProperties$1(a, _excluded$7), st = $.record, lt = $.indent, et = $.index, it = useContext(TableContext, ["prefixCls", "flattenColumns", "fixColumn", "componentWidth", "scrollX"]), ut = it.scrollX, ft = it.flattenColumns, ht = it.prefixCls, dt = it.fixColumn, gt = it.componentWidth, pt = useRowInfo(st, tt, _, lt), mt = pt.rowSupportExpand, ct = pt.expanded, vt = pt.rowProps, At = pt.expandedRowRender, xt = pt.expandedRowClassName, bt;
  if (mt && ct) {
    var Et = At(st, _, lt + 1, ct), St = xt == null ? void 0 : xt(st, _, lt), Bt = {};
    dt && (Bt = {
      style: _defineProperty$c({}, "--virtual-width", "".concat(gt, "px"))
    });
    var Ot = "".concat(ht, "-expanded-row-cell");
    bt = /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames("".concat(ht, "-expanded-row"), "".concat(ht, "-expanded-row-level-").concat(lt + 1), St)
    }, /* @__PURE__ */ reactExports.createElement(Cell$1, {
      component: "div",
      prefixCls: ht,
      className: classnames(Ot, _defineProperty$c({}, "".concat(Ot, "-fixed"), dt)),
      additionalProps: Bt
    }, Et));
  }
  var Pt = _objectSpread2$a(_objectSpread2$a({}, nt), {}, {
    width: ut
  });
  at && (Pt.position = "absolute", Pt.pointerEvents = "none");
  var wt = /* @__PURE__ */ reactExports.createElement("div", _extends$2({}, vt, rt, {
    ref: mt ? null : s,
    className: classnames(_e, "".concat(ht, "-row"), vt == null ? void 0 : vt.className, _defineProperty$c({}, "".concat(ht, "-row-extra"), at)),
    style: _objectSpread2$a(_objectSpread2$a({}, Pt), vt == null ? void 0 : vt.style)
  }), ft.map(function(Ct, It) {
    return /* @__PURE__ */ reactExports.createElement(VirtualCell$1, {
      key: It,
      rowInfo: pt,
      column: Ct,
      colIndex: It,
      indent: lt,
      index: _,
      renderIndex: et,
      record: st,
      inverse: at,
      getHeight: ot
    });
  }));
  return mt ? /* @__PURE__ */ reactExports.createElement("div", {
    ref: s
  }, wt, bt) : wt;
}), ResponseBodyLine = responseImmutable(BodyLine), Grid = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.data, _ = a.onScroll, _e = useContext(TableContext, ["flattenColumns", "onColumnResize", "getRowKey", "prefixCls", "expandedKeys", "childrenColumnName", "emptyNode", "scrollX"]), tt = _e.flattenColumns, nt = _e.onColumnResize, at = _e.getRowKey, ot = _e.expandedKeys, rt = _e.prefixCls, st = _e.childrenColumnName, lt = _e.emptyNode, et = _e.scrollX, it = useContext(StaticContext), ut = it.sticky, ft = it.scrollY, ht = it.listItemHeight, dt = reactExports.useRef(), gt = useFlattenRecords($, st, ot, at), pt = reactExports.useMemo(function() {
    var St = 0;
    return tt.map(function(Bt) {
      var Ot = Bt.width, Pt = Bt.key;
      return St += Ot, [Pt, Ot, St];
    });
  }, [tt]), mt = reactExports.useMemo(function() {
    return pt.map(function(St) {
      return St[2];
    });
  }, [pt]);
  reactExports.useEffect(function() {
    pt.forEach(function(St) {
      var Bt = _slicedToArray$e(St, 2), Ot = Bt[0], Pt = Bt[1];
      nt(Ot, Pt);
    });
  }, [pt]), reactExports.useImperativeHandle(s, function() {
    var St = {
      scrollTo: function(Ot) {
        var Pt;
        (Pt = dt.current) === null || Pt === void 0 || Pt.scrollTo(Ot);
      }
    };
    return Object.defineProperty(St, "scrollLeft", {
      get: function() {
        var Ot;
        return ((Ot = dt.current) === null || Ot === void 0 ? void 0 : Ot.getScrollInfo().x) || 0;
      },
      set: function(Ot) {
        var Pt;
        (Pt = dt.current) === null || Pt === void 0 || Pt.scrollTo({
          left: Ot
        });
      }
    }), St;
  });
  var ct = function(Bt, Ot) {
    var Pt, wt = (Pt = gt[Ot]) === null || Pt === void 0 ? void 0 : Pt.record, Ct = Bt.onCell;
    if (Ct) {
      var It, yt = Ct(wt, Ot);
      return (It = yt == null ? void 0 : yt.rowSpan) !== null && It !== void 0 ? It : 1;
    }
    return 1;
  }, vt = function(Bt) {
    var Ot = Bt.start, Pt = Bt.end, wt = Bt.getSize, Ct = Bt.offsetY;
    if (Pt < 0)
      return null;
    for (var It = tt.filter(
      // rowSpan is 0
      function(Tt) {
        return ct(Tt, Ot) === 0;
      }
    ), yt = Ot, Rt = function(Dt) {
      if (It = It.filter(function(Ut) {
        return ct(Ut, Dt) === 0;
      }), !It.length)
        return yt = Dt, 1;
    }, kt = Ot; kt >= 0 && !Rt(kt); kt -= 1)
      ;
    for (var jt = tt.filter(
      // rowSpan is not 1
      function(Tt) {
        return ct(Tt, Pt) !== 1;
      }
    ), Ht = Pt, Ft = function(Dt) {
      if (jt = jt.filter(function(Ut) {
        return ct(Ut, Dt) !== 1;
      }), !jt.length)
        return Ht = Math.max(Dt - 1, Pt), 1;
    }, _t = Pt; _t < gt.length && !Ft(_t); _t += 1)
      ;
    for (var Nt = [], Mt = function(Dt) {
      var Ut = gt[Dt];
      if (!Ut)
        return 1;
      tt.some(function(Vt) {
        return ct(Vt, Dt) > 1;
      }) && Nt.push(Dt);
    }, Lt = yt; Lt <= Ht; Lt += 1)
      Mt(Lt);
    var $t = Nt.map(function(Tt) {
      var Dt = gt[Tt], Ut = at(Dt.record, Tt), Vt = function(Zt) {
        var ar = Tt + Zt - 1, Jt = at(gt[ar].record, ar), rr = wt(Ut, Jt);
        return rr.bottom - rr.top;
      }, Qt = wt(Ut);
      return /* @__PURE__ */ reactExports.createElement(ResponseBodyLine, {
        key: Tt,
        data: Dt,
        rowKey: Ut,
        index: Tt,
        style: {
          top: -Ct + Qt.top
        },
        extra: !0,
        getHeight: Vt
      });
    });
    return $t;
  }, At = reactExports.useMemo(function() {
    return {
      columnsOffset: mt
    };
  }, [mt]), xt = "".concat(rt, "-tbody"), bt;
  if (gt.length) {
    var Et = {};
    ut && (Et.position = "sticky", Et.bottom = 0, _typeof$q(ut) === "object" && ut.offsetScroll && (Et.bottom = ut.offsetScroll)), bt = /* @__PURE__ */ reactExports.createElement(List$1, {
      fullHeight: !1,
      ref: dt,
      styles: {
        horizontalScrollBar: Et
      },
      className: classnames(xt, "".concat(xt, "-virtual")),
      height: ft,
      itemHeight: ht || 24,
      data: gt,
      itemKey: function(Bt) {
        return at(Bt.record);
      },
      scrollWidth: et,
      onVirtualScroll: function(Bt) {
        var Ot = Bt.x;
        _({
          scrollLeft: Ot
        });
      },
      extraRender: vt
    }, function(St, Bt, Ot) {
      var Pt = at(St.record, Bt);
      return /* @__PURE__ */ reactExports.createElement(ResponseBodyLine, _extends$2({
        data: St,
        rowKey: Pt,
        index: Bt
      }, Ot));
    });
  } else
    bt = /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames("".concat(rt, "-placeholder"))
    }, /* @__PURE__ */ reactExports.createElement(Cell$1, {
      component: "div",
      prefixCls: rt
    }, lt));
  return /* @__PURE__ */ reactExports.createElement(GridContext.Provider, {
    value: At
  }, bt);
}), ResponseGrid = responseImmutable(Grid), renderBody = function a(s, $) {
  var _ = $.ref, _e = $.onScroll;
  return /* @__PURE__ */ reactExports.createElement(ResponseGrid, {
    ref: _,
    data: s,
    onScroll: _e
  });
};
function VirtualTable(a, s) {
  var $ = a.columns, _ = a.scroll, _e = a.sticky, tt = a.prefixCls, nt = tt === void 0 ? DEFAULT_PREFIX : tt, at = a.className, ot = a.listItemHeight, rt = a.components, st = _ || {}, lt = st.x, et = st.y;
  typeof lt != "number" && (lt = 1), typeof et != "number" && (et = 500);
  var it = reactExports.useMemo(function() {
    return {
      sticky: _e,
      scrollY: et,
      listItemHeight: ot
    };
  }, [_e, et, ot]);
  return /* @__PURE__ */ reactExports.createElement(StaticContext.Provider, {
    value: it
  }, /* @__PURE__ */ reactExports.createElement(ImmutableTable, _extends$2({}, a, {
    className: classnames(at, "".concat(nt, "-virtual")),
    scroll: _objectSpread2$a(_objectSpread2$a({}, _), {}, {
      x: lt
    }),
    components: _objectSpread2$a(_objectSpread2$a({}, rt), {}, {
      body: renderBody
    }),
    columns: $,
    internalHooks: INTERNAL_HOOKS,
    tailor: !0,
    ref: s
  })));
}
var RefVirtualTable = /* @__PURE__ */ reactExports.forwardRef(VirtualTable);
function genVirtualTable(a) {
  return makeImmutable(RefVirtualTable, a);
}
genVirtualTable();
function Column(a) {
  return null;
}
function ColumnGroup(a) {
  return null;
}
var TreeContext = /* @__PURE__ */ reactExports.createContext(null), Indent = function a(s) {
  for (var $ = s.prefixCls, _ = s.level, _e = s.isStart, tt = s.isEnd, nt = "".concat($, "-indent-unit"), at = [], ot = 0; ot < _; ot += 1) {
    var rt;
    at.push(/* @__PURE__ */ reactExports.createElement("span", {
      key: ot,
      className: classnames(nt, (rt = {}, _defineProperty$c(rt, "".concat(nt, "-start"), _e[ot]), _defineProperty$c(rt, "".concat(nt, "-end"), tt[ot]), rt))
    }));
  }
  return /* @__PURE__ */ reactExports.createElement("span", {
    "aria-hidden": "true",
    className: "".concat($, "-indent")
  }, at);
};
const Indent$1 = /* @__PURE__ */ reactExports.memo(Indent);
var _excluded$6 = ["eventKey", "className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "isStart", "isEnd", "expanded", "selected", "checked", "halfChecked", "loading", "domRef", "active", "data", "onMouseMove", "selectable"], ICON_OPEN = "open", ICON_CLOSE = "close", defaultTitle = "---", InternalTreeNode = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $() {
    var _;
    _classCallCheck(this, $);
    for (var _e = arguments.length, tt = new Array(_e), nt = 0; nt < _e; nt++)
      tt[nt] = arguments[nt];
    return _ = s.call.apply(s, [this].concat(tt)), _.state = {
      dragNodeHighlight: !1
    }, _.selectHandle = void 0, _.cacheIndent = void 0, _.onSelectorClick = function(at) {
      var ot = _.props.context.onNodeClick;
      ot(at, convertNodePropsToEventData(_.props)), _.isSelectable() ? _.onSelect(at) : _.onCheck(at);
    }, _.onSelectorDoubleClick = function(at) {
      var ot = _.props.context.onNodeDoubleClick;
      ot(at, convertNodePropsToEventData(_.props));
    }, _.onSelect = function(at) {
      if (!_.isDisabled()) {
        var ot = _.props.context.onNodeSelect;
        ot(at, convertNodePropsToEventData(_.props));
      }
    }, _.onCheck = function(at) {
      if (!_.isDisabled()) {
        var ot = _.props, rt = ot.disableCheckbox, st = ot.checked, lt = _.props.context.onNodeCheck;
        if (!(!_.isCheckable() || rt)) {
          var et = !st;
          lt(at, convertNodePropsToEventData(_.props), et);
        }
      }
    }, _.onMouseEnter = function(at) {
      var ot = _.props.context.onNodeMouseEnter;
      ot(at, convertNodePropsToEventData(_.props));
    }, _.onMouseLeave = function(at) {
      var ot = _.props.context.onNodeMouseLeave;
      ot(at, convertNodePropsToEventData(_.props));
    }, _.onContextMenu = function(at) {
      var ot = _.props.context.onNodeContextMenu;
      ot(at, convertNodePropsToEventData(_.props));
    }, _.onDragStart = function(at) {
      var ot = _.props.context.onNodeDragStart;
      at.stopPropagation(), _.setState({
        dragNodeHighlight: !0
      }), ot(at, _assertThisInitialized(_));
      try {
        at.dataTransfer.setData("text/plain", "");
      } catch {
      }
    }, _.onDragEnter = function(at) {
      var ot = _.props.context.onNodeDragEnter;
      at.preventDefault(), at.stopPropagation(), ot(at, _assertThisInitialized(_));
    }, _.onDragOver = function(at) {
      var ot = _.props.context.onNodeDragOver;
      at.preventDefault(), at.stopPropagation(), ot(at, _assertThisInitialized(_));
    }, _.onDragLeave = function(at) {
      var ot = _.props.context.onNodeDragLeave;
      at.stopPropagation(), ot(at, _assertThisInitialized(_));
    }, _.onDragEnd = function(at) {
      var ot = _.props.context.onNodeDragEnd;
      at.stopPropagation(), _.setState({
        dragNodeHighlight: !1
      }), ot(at, _assertThisInitialized(_));
    }, _.onDrop = function(at) {
      var ot = _.props.context.onNodeDrop;
      at.preventDefault(), at.stopPropagation(), _.setState({
        dragNodeHighlight: !1
      }), ot(at, _assertThisInitialized(_));
    }, _.onExpand = function(at) {
      var ot = _.props, rt = ot.loading, st = ot.context.onNodeExpand;
      rt || st(at, convertNodePropsToEventData(_.props));
    }, _.setSelectHandle = function(at) {
      _.selectHandle = at;
    }, _.getNodeState = function() {
      var at = _.props.expanded;
      return _.isLeaf() ? null : at ? ICON_OPEN : ICON_CLOSE;
    }, _.hasChildren = function() {
      var at = _.props.eventKey, ot = _.props.context.keyEntities, rt = getEntity(ot, at) || {}, st = rt.children;
      return !!(st || []).length;
    }, _.isLeaf = function() {
      var at = _.props, ot = at.isLeaf, rt = at.loaded, st = _.props.context.loadData, lt = _.hasChildren();
      return ot === !1 ? !1 : ot || !st && !lt || st && rt && !lt;
    }, _.isDisabled = function() {
      var at = _.props.disabled, ot = _.props.context.disabled;
      return !!(ot || at);
    }, _.isCheckable = function() {
      var at = _.props.checkable, ot = _.props.context.checkable;
      return !ot || at === !1 ? !1 : ot;
    }, _.syncLoadData = function(at) {
      var ot = at.expanded, rt = at.loading, st = at.loaded, lt = _.props.context, et = lt.loadData, it = lt.onNodeLoad;
      rt || et && ot && !_.isLeaf() && !_.hasChildren() && !st && it(convertNodePropsToEventData(_.props));
    }, _.isDraggable = function() {
      var at = _.props, ot = at.data, rt = at.context.draggable;
      return !!(rt && (!rt.nodeDraggable || rt.nodeDraggable(ot)));
    }, _.renderDragHandler = function() {
      var at = _.props.context, ot = at.draggable, rt = at.prefixCls;
      return ot != null && ot.icon ? /* @__PURE__ */ reactExports.createElement("span", {
        className: "".concat(rt, "-draggable-icon")
      }, ot.icon) : null;
    }, _.renderSwitcherIconDom = function(at) {
      var ot = _.props.switcherIcon, rt = _.props.context.switcherIcon, st = ot || rt;
      return typeof st == "function" ? st(_objectSpread2$a(_objectSpread2$a({}, _.props), {}, {
        isLeaf: at
      })) : st;
    }, _.renderSwitcher = function() {
      var at = _.props.expanded, ot = _.props.context.prefixCls;
      if (_.isLeaf()) {
        var rt = _.renderSwitcherIconDom(!0);
        return rt !== !1 ? /* @__PURE__ */ reactExports.createElement("span", {
          className: classnames("".concat(ot, "-switcher"), "".concat(ot, "-switcher-noop"))
        }, rt) : null;
      }
      var st = classnames("".concat(ot, "-switcher"), "".concat(ot, "-switcher_").concat(at ? ICON_OPEN : ICON_CLOSE)), lt = _.renderSwitcherIconDom(!1);
      return lt !== !1 ? /* @__PURE__ */ reactExports.createElement("span", {
        onClick: _.onExpand,
        className: st
      }, lt) : null;
    }, _.renderCheckbox = function() {
      var at = _.props, ot = at.checked, rt = at.halfChecked, st = at.disableCheckbox, lt = _.props.context.prefixCls, et = _.isDisabled(), it = _.isCheckable();
      if (!it)
        return null;
      var ut = typeof it != "boolean" ? it : null;
      return /* @__PURE__ */ reactExports.createElement("span", {
        className: classnames("".concat(lt, "-checkbox"), ot && "".concat(lt, "-checkbox-checked"), !ot && rt && "".concat(lt, "-checkbox-indeterminate"), (et || st) && "".concat(lt, "-checkbox-disabled")),
        onClick: _.onCheck
      }, ut);
    }, _.renderIcon = function() {
      var at = _.props.loading, ot = _.props.context.prefixCls;
      return /* @__PURE__ */ reactExports.createElement("span", {
        className: classnames("".concat(ot, "-iconEle"), "".concat(ot, "-icon__").concat(_.getNodeState() || "docu"), at && "".concat(ot, "-icon_loading"))
      });
    }, _.renderSelector = function() {
      var at = _.state.dragNodeHighlight, ot = _.props, rt = ot.title, st = rt === void 0 ? defaultTitle : rt, lt = ot.selected, et = ot.icon, it = ot.loading, ut = ot.data, ft = _.props.context, ht = ft.prefixCls, dt = ft.showIcon, gt = ft.icon, pt = ft.loadData, mt = ft.titleRender, ct = _.isDisabled(), vt = "".concat(ht, "-node-content-wrapper"), At;
      if (dt) {
        var xt = et || gt;
        At = xt ? /* @__PURE__ */ reactExports.createElement("span", {
          className: classnames("".concat(ht, "-iconEle"), "".concat(ht, "-icon__customize"))
        }, typeof xt == "function" ? xt(_.props) : xt) : _.renderIcon();
      } else
        pt && it && (At = _.renderIcon());
      var bt;
      typeof st == "function" ? bt = st(ut) : mt ? bt = mt(ut) : bt = st;
      var Et = /* @__PURE__ */ reactExports.createElement("span", {
        className: "".concat(ht, "-title")
      }, bt);
      return /* @__PURE__ */ reactExports.createElement("span", {
        ref: _.setSelectHandle,
        title: typeof st == "string" ? st : "",
        className: classnames("".concat(vt), "".concat(vt, "-").concat(_.getNodeState() || "normal"), !ct && (lt || at) && "".concat(ht, "-node-selected")),
        onMouseEnter: _.onMouseEnter,
        onMouseLeave: _.onMouseLeave,
        onContextMenu: _.onContextMenu,
        onClick: _.onSelectorClick,
        onDoubleClick: _.onSelectorDoubleClick
      }, At, Et, _.renderDropIndicator());
    }, _.renderDropIndicator = function() {
      var at = _.props, ot = at.disabled, rt = at.eventKey, st = _.props.context, lt = st.draggable, et = st.dropLevelOffset, it = st.dropPosition, ut = st.prefixCls, ft = st.indent, ht = st.dropIndicatorRender, dt = st.dragOverNodeKey, gt = st.direction, pt = !!lt, mt = !ot && pt && dt === rt, ct = ft ?? _.cacheIndent;
      return _.cacheIndent = ft, mt ? ht({
        dropPosition: it,
        dropLevelOffset: et,
        indent: ct,
        prefixCls: ut,
        direction: gt
      }) : null;
    }, _;
  }
  return _createClass($, [{
    key: "componentDidMount",
    value: (
      // Isomorphic needn't load data in server side
      function() {
        this.syncLoadData(this.props);
      }
    )
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "isSelectable",
    value: function() {
      var _e = this.props.selectable, tt = this.props.context.selectable;
      return typeof _e == "boolean" ? _e : tt;
    }
  }, {
    key: "render",
    value: (
      // =========================== Render ===========================
      function() {
        var _e, tt = this.props, nt = tt.eventKey, at = tt.className, ot = tt.style, rt = tt.dragOver, st = tt.dragOverGapTop, lt = tt.dragOverGapBottom, et = tt.isLeaf, it = tt.isStart, ut = tt.isEnd, ft = tt.expanded, ht = tt.selected, dt = tt.checked, gt = tt.halfChecked, pt = tt.loading, mt = tt.domRef, ct = tt.active;
        tt.data;
        var vt = tt.onMouseMove, At = tt.selectable, xt = _objectWithoutProperties$1(tt, _excluded$6), bt = this.props.context, Et = bt.prefixCls, St = bt.filterTreeNode, Bt = bt.keyEntities, Ot = bt.dropContainerKey, Pt = bt.dropTargetKey, wt = bt.draggingNodeKey, Ct = this.isDisabled(), It = pickAttrs(xt, {
          aria: !0,
          data: !0
        }), yt = getEntity(Bt, nt) || {}, Rt = yt.level, kt = ut[ut.length - 1], jt = this.isDraggable(), Ht = !Ct && jt, Ft = wt === nt, _t = At !== void 0 ? {
          "aria-selected": !!At
        } : void 0;
        return /* @__PURE__ */ reactExports.createElement("div", _extends$2({
          ref: mt,
          className: classnames(at, "".concat(Et, "-treenode"), (_e = {}, _defineProperty$c(_e, "".concat(Et, "-treenode-disabled"), Ct), _defineProperty$c(_e, "".concat(Et, "-treenode-switcher-").concat(ft ? "open" : "close"), !et), _defineProperty$c(_e, "".concat(Et, "-treenode-checkbox-checked"), dt), _defineProperty$c(_e, "".concat(Et, "-treenode-checkbox-indeterminate"), gt), _defineProperty$c(_e, "".concat(Et, "-treenode-selected"), ht), _defineProperty$c(_e, "".concat(Et, "-treenode-loading"), pt), _defineProperty$c(_e, "".concat(Et, "-treenode-active"), ct), _defineProperty$c(_e, "".concat(Et, "-treenode-leaf-last"), kt), _defineProperty$c(_e, "".concat(Et, "-treenode-draggable"), jt), _defineProperty$c(_e, "dragging", Ft), _defineProperty$c(_e, "drop-target", Pt === nt), _defineProperty$c(_e, "drop-container", Ot === nt), _defineProperty$c(_e, "drag-over", !Ct && rt), _defineProperty$c(_e, "drag-over-gap-top", !Ct && st), _defineProperty$c(_e, "drag-over-gap-bottom", !Ct && lt), _defineProperty$c(_e, "filter-node", St && St(convertNodePropsToEventData(this.props))), _e)),
          style: ot,
          draggable: Ht,
          "aria-grabbed": Ft,
          onDragStart: Ht ? this.onDragStart : void 0,
          onDragEnter: jt ? this.onDragEnter : void 0,
          onDragOver: jt ? this.onDragOver : void 0,
          onDragLeave: jt ? this.onDragLeave : void 0,
          onDrop: jt ? this.onDrop : void 0,
          onDragEnd: jt ? this.onDragEnd : void 0,
          onMouseMove: vt
        }, _t, It), /* @__PURE__ */ reactExports.createElement(Indent$1, {
          prefixCls: Et,
          level: Rt,
          isStart: it,
          isEnd: ut
        }), this.renderDragHandler(), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
      }
    )
  }]), $;
}(reactExports.Component), ContextTreeNode = function a(s) {
  return /* @__PURE__ */ reactExports.createElement(TreeContext.Consumer, null, function($) {
    return /* @__PURE__ */ reactExports.createElement(InternalTreeNode, _extends$2({}, s, {
      context: $
    }));
  });
};
ContextTreeNode.displayName = "TreeNode";
ContextTreeNode.isTreeNode = 1;
function arrDel(a, s) {
  if (!a)
    return [];
  var $ = a.slice(), _ = $.indexOf(s);
  return _ >= 0 && $.splice(_, 1), $;
}
function arrAdd(a, s) {
  var $ = (a || []).slice();
  return $.indexOf(s) === -1 && $.push(s), $;
}
function posToArr(a) {
  return a.split("-");
}
function getDragChildrenKeys(a, s) {
  var $ = [], _ = getEntity(s, a);
  function _e() {
    var tt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    tt.forEach(function(nt) {
      var at = nt.key, ot = nt.children;
      $.push(at), _e(ot);
    });
  }
  return _e(_.children), $;
}
function isLastChild(a) {
  if (a.parent) {
    var s = posToArr(a.pos);
    return Number(s[s.length - 1]) === a.parent.children.length - 1;
  }
  return !1;
}
function isFirstChild(a) {
  var s = posToArr(a.pos);
  return Number(s[s.length - 1]) === 0;
}
function calcDropPosition(a, s, $, _, _e, tt, nt, at, ot, rt) {
  var st, lt = a.clientX, et = a.clientY, it = a.target.getBoundingClientRect(), ut = it.top, ft = it.height, ht = (rt === "rtl" ? -1 : 1) * (((_e == null ? void 0 : _e.x) || 0) - lt), dt = (ht - 12) / _, gt = getEntity(at, $.props.eventKey);
  if (et < ut + ft / 2) {
    var pt = nt.findIndex(function(wt) {
      return wt.key === gt.key;
    }), mt = pt <= 0 ? 0 : pt - 1, ct = nt[mt].key;
    gt = getEntity(at, ct);
  }
  var vt = gt.key, At = gt, xt = gt.key, bt = 0, Et = 0;
  if (!ot.includes(vt))
    for (var St = 0; St < dt && isLastChild(gt); St += 1)
      gt = gt.parent, Et += 1;
  var Bt = s.props.data, Ot = gt.node, Pt = !0;
  return isFirstChild(gt) && gt.level === 0 && et < ut + ft / 2 && tt({
    dragNode: Bt,
    dropNode: Ot,
    dropPosition: -1
  }) && gt.key === $.props.eventKey ? bt = -1 : (At.children || []).length && ot.includes(xt) ? tt({
    dragNode: Bt,
    dropNode: Ot,
    dropPosition: 0
  }) ? bt = 0 : Pt = !1 : Et === 0 ? dt > -1.5 ? tt({
    dragNode: Bt,
    dropNode: Ot,
    dropPosition: 1
  }) ? bt = 1 : Pt = !1 : tt({
    dragNode: Bt,
    dropNode: Ot,
    dropPosition: 0
  }) ? bt = 0 : tt({
    dragNode: Bt,
    dropNode: Ot,
    dropPosition: 1
  }) ? bt = 1 : Pt = !1 : tt({
    dragNode: Bt,
    dropNode: Ot,
    dropPosition: 1
  }) ? bt = 1 : Pt = !1, {
    dropPosition: bt,
    dropLevelOffset: Et,
    dropTargetKey: gt.key,
    dropTargetPos: gt.pos,
    dragOverNodeKey: xt,
    dropContainerKey: bt === 0 ? null : ((st = gt.parent) === null || st === void 0 ? void 0 : st.key) || null,
    dropAllowed: Pt
  };
}
function calcSelectedKeys(a, s) {
  if (a) {
    var $ = s.multiple;
    return $ ? a.slice() : a.length ? [a[0]] : a;
  }
}
function parseCheckedKeys(a) {
  if (!a)
    return null;
  var s;
  if (Array.isArray(a))
    s = {
      checkedKeys: a,
      halfCheckedKeys: void 0
    };
  else if (_typeof$q(a) === "object")
    s = {
      checkedKeys: a.checked || void 0,
      halfCheckedKeys: a.halfChecked || void 0
    };
  else
    return warningOnce(!1, "`checkedKeys` is not an array or an object"), null;
  return s;
}
function conductExpandParent(a, s) {
  var $ = /* @__PURE__ */ new Set();
  function _(_e) {
    if (!$.has(_e)) {
      var tt = getEntity(s, _e);
      if (tt) {
        $.add(_e);
        var nt = tt.parent, at = tt.node;
        at.disabled || nt && _(nt.key);
      }
    }
  }
  return (a || []).forEach(function(_e) {
    _(_e);
  }), _toConsumableArray$d($);
}
function useMultipleSelect(a) {
  const [s, $] = reactExports.useState(null);
  return [reactExports.useCallback((tt, nt, at) => {
    const ot = s ?? tt, rt = Math.min(ot || 0, tt), st = Math.max(ot || 0, tt), lt = nt.slice(rt, st + 1).map((ut) => a(ut)), et = lt.some((ut) => !at.has(ut)), it = [];
    return lt.forEach((ut) => {
      et ? (at.has(ut) || it.push(ut), at.add(ut)) : (at.delete(ut), it.push(ut));
    }), $(et ? st : null), it;
  }, [s]), (tt) => {
    $(tt);
  }];
}
const SELECTION_COLUMN = {}, SELECTION_ALL = "SELECT_ALL", SELECTION_INVERT = "SELECT_INVERT", SELECTION_NONE = "SELECT_NONE", EMPTY_LIST$1 = [], flattenData = (a, s) => {
  let $ = [];
  return (s || []).forEach((_) => {
    $.push(_), _ && typeof _ == "object" && a in _ && ($ = [].concat(_toConsumableArray$d($), _toConsumableArray$d(flattenData(a, _[a]))));
  }), $;
}, useSelection = (a, s) => {
  const {
    preserveSelectedRowKeys: $,
    selectedRowKeys: _,
    defaultSelectedRowKeys: _e,
    getCheckboxProps: tt,
    onChange: nt,
    onSelect: at,
    onSelectAll: ot,
    onSelectInvert: rt,
    onSelectNone: st,
    onSelectMultiple: lt,
    columnWidth: et,
    type: it,
    selections: ut,
    fixed: ft,
    renderCell: ht,
    hideSelectAll: dt,
    checkStrictly: gt = !0
  } = s || {}, {
    prefixCls: pt,
    data: mt,
    pageData: ct,
    getRecordByKey: vt,
    getRowKey: At,
    expandType: xt,
    childrenColumnName: bt,
    locale: Et,
    getPopupContainer: St
  } = a, Bt = devUseWarning(), [Ot, Pt] = useMultipleSelect((Ut) => Ut), [wt, Ct] = useMergedState(_ || _e || EMPTY_LIST$1, {
    value: _
  }), It = reactExports.useRef(/* @__PURE__ */ new Map()), yt = reactExports.useCallback((Ut) => {
    if ($) {
      const Vt = /* @__PURE__ */ new Map();
      Ut.forEach((Qt) => {
        let qt = vt(Qt);
        !qt && It.current.has(Qt) && (qt = It.current.get(Qt)), Vt.set(Qt, qt);
      }), It.current = Vt;
    }
  }, [vt, $]);
  reactExports.useEffect(() => {
    yt(wt);
  }, [wt]);
  const {
    keyEntities: Rt
  } = reactExports.useMemo(() => {
    if (gt)
      return {
        keyEntities: null
      };
    let Ut = mt;
    if ($) {
      const Vt = new Set(mt.map((qt, Zt) => At(qt, Zt))), Qt = Array.from(It.current).reduce((qt, Zt) => {
        let [ar, Jt] = Zt;
        return Vt.has(ar) ? qt : qt.concat(Jt);
      }, []);
      Ut = [].concat(_toConsumableArray$d(Ut), _toConsumableArray$d(Qt));
    }
    return convertDataToEntities(Ut, {
      externalGetKey: At,
      childrenPropName: bt
    });
  }, [mt, At, gt, bt, $]), kt = reactExports.useMemo(() => flattenData(bt, ct), [bt, ct]), jt = reactExports.useMemo(() => {
    const Ut = /* @__PURE__ */ new Map();
    return kt.forEach((Vt, Qt) => {
      const qt = At(Vt, Qt), Zt = (tt ? tt(Vt) : null) || {};
      Ut.set(qt, Zt);
    }), Ut;
  }, [kt, At, tt]), Ht = reactExports.useCallback((Ut) => {
    var Vt;
    return !!(!((Vt = jt.get(At(Ut))) === null || Vt === void 0) && Vt.disabled);
  }, [jt, At]), [Ft, _t] = reactExports.useMemo(() => {
    if (gt)
      return [wt || [], []];
    const {
      checkedKeys: Ut,
      halfCheckedKeys: Vt
    } = conductCheck(wt, !0, Rt, Ht);
    return [Ut || [], Vt];
  }, [wt, gt, Rt, Ht]), Nt = reactExports.useMemo(() => {
    const Ut = it === "radio" ? Ft.slice(0, 1) : Ft;
    return new Set(Ut);
  }, [Ft, it]), Mt = reactExports.useMemo(() => it === "radio" ? /* @__PURE__ */ new Set() : new Set(_t), [_t, it]);
  reactExports.useEffect(() => {
    s || Ct(EMPTY_LIST$1);
  }, [!!s]);
  const Lt = reactExports.useCallback((Ut, Vt) => {
    let Qt, qt;
    yt(Ut), $ ? (Qt = Ut, qt = Ut.map((Zt) => It.current.get(Zt))) : (Qt = [], qt = [], Ut.forEach((Zt) => {
      const ar = vt(Zt);
      ar !== void 0 && (Qt.push(Zt), qt.push(ar));
    })), Ct(Qt), nt == null || nt(Qt, qt, {
      type: Vt
    });
  }, [Ct, vt, nt, $]), $t = reactExports.useCallback((Ut, Vt, Qt, qt) => {
    if (at) {
      const Zt = Qt.map((ar) => vt(ar));
      at(vt(Ut), Vt, Zt, qt);
    }
    Lt(Qt, "single");
  }, [at, vt, Lt]), Tt = reactExports.useMemo(() => !ut || dt ? null : (ut === !0 ? [SELECTION_ALL, SELECTION_INVERT, SELECTION_NONE] : ut).map((Vt) => Vt === SELECTION_ALL ? {
    key: "all",
    text: Et.selectionAll,
    onSelect() {
      Lt(mt.map((Qt, qt) => At(Qt, qt)).filter((Qt) => {
        const qt = jt.get(Qt);
        return !(qt != null && qt.disabled) || Nt.has(Qt);
      }), "all");
    }
  } : Vt === SELECTION_INVERT ? {
    key: "invert",
    text: Et.selectInvert,
    onSelect() {
      const Qt = new Set(Nt);
      ct.forEach((Zt, ar) => {
        const Jt = At(Zt, ar), rr = jt.get(Jt);
        rr != null && rr.disabled || (Qt.has(Jt) ? Qt.delete(Jt) : Qt.add(Jt));
      });
      const qt = Array.from(Qt);
      rt && (Bt.deprecated(!1, "onSelectInvert", "onChange"), rt(qt)), Lt(qt, "invert");
    }
  } : Vt === SELECTION_NONE ? {
    key: "none",
    text: Et.selectNone,
    onSelect() {
      st == null || st(), Lt(Array.from(Nt).filter((Qt) => {
        const qt = jt.get(Qt);
        return qt == null ? void 0 : qt.disabled;
      }), "none");
    }
  } : Vt).map((Vt) => Object.assign(Object.assign({}, Vt), {
    onSelect: function() {
      for (var Qt, qt, Zt = arguments.length, ar = new Array(Zt), Jt = 0; Jt < Zt; Jt++)
        ar[Jt] = arguments[Jt];
      (qt = Vt.onSelect) === null || qt === void 0 || (Qt = qt).call.apply(Qt, [Vt].concat(ar)), Pt(null);
    }
  })), [ut, Nt, ct, At, rt, Lt]);
  return [reactExports.useCallback((Ut) => {
    var Vt;
    if (!s)
      return Ut.filter((er) => er !== SELECTION_COLUMN);
    let Qt = _toConsumableArray$d(Ut);
    const qt = new Set(Nt), Zt = kt.map(At).filter((er) => !jt.get(er).disabled), ar = Zt.every((er) => qt.has(er)), Jt = Zt.some((er) => qt.has(er)), rr = () => {
      const er = [];
      ar ? Zt.forEach((ur) => {
        qt.delete(ur), er.push(ur);
      }) : Zt.forEach((ur) => {
        qt.has(ur) || (qt.add(ur), er.push(ur));
      });
      const lr = Array.from(qt);
      ot == null || ot(!ar, lr.map((ur) => vt(ur)), er.map((ur) => vt(ur))), Lt(lr, "all"), Pt(null);
    };
    let Yt, Kt;
    if (it !== "radio") {
      let er;
      if (Tt) {
        const Er = {
          getPopupContainer: St,
          items: Tt.map((br, gr) => {
            const {
              key: Ar,
              text: Sr,
              onSelect: Br
            } = br;
            return {
              key: Ar ?? gr,
              onClick: () => {
                Br == null || Br(Zt);
              },
              label: Sr
            };
          })
        };
        er = /* @__PURE__ */ reactExports.createElement("div", {
          className: `${pt}-selection-extra`
        }, /* @__PURE__ */ reactExports.createElement(Dropdown$1, {
          menu: Er,
          getPopupContainer: St
        }, /* @__PURE__ */ reactExports.createElement("span", null, /* @__PURE__ */ reactExports.createElement(DownOutlined$4, null))));
      }
      const lr = kt.map((Er, br) => {
        const gr = At(Er, br), Ar = jt.get(gr) || {};
        return Object.assign({
          checked: qt.has(gr)
        }, Ar);
      }).filter((Er) => {
        let {
          disabled: br
        } = Er;
        return br;
      }), ur = !!lr.length && lr.length === kt.length, pr = ur && lr.every((Er) => {
        let {
          checked: br
        } = Er;
        return br;
      }), yr = ur && lr.some((Er) => {
        let {
          checked: br
        } = Er;
        return br;
      });
      Kt = /* @__PURE__ */ reactExports.createElement(_Checkbox, {
        checked: ur ? pr : !!kt.length && ar,
        indeterminate: ur ? !pr && yr : !ar && Jt,
        onChange: rr,
        disabled: kt.length === 0 || ur,
        "aria-label": er ? "Custom selection" : "Select all",
        skipGroup: !0
      }), Yt = !dt && /* @__PURE__ */ reactExports.createElement("div", {
        className: `${pt}-selection`
      }, Kt, er);
    }
    let nr;
    it === "radio" ? nr = (er, lr, ur) => {
      const pr = At(lr, ur), yr = qt.has(pr);
      return {
        node: /* @__PURE__ */ reactExports.createElement(_Radio, Object.assign({}, jt.get(pr), {
          checked: yr,
          onClick: (Er) => Er.stopPropagation(),
          onChange: (Er) => {
            qt.has(pr) || $t(pr, !0, [pr], Er.nativeEvent);
          }
        })),
        checked: yr
      };
    } : nr = (er, lr, ur) => {
      var pr;
      const yr = At(lr, ur), Er = qt.has(yr), br = Mt.has(yr), gr = jt.get(yr);
      let Ar;
      return xt === "nest" ? Ar = br : Ar = (pr = gr == null ? void 0 : gr.indeterminate) !== null && pr !== void 0 ? pr : br, {
        node: /* @__PURE__ */ reactExports.createElement(_Checkbox, Object.assign({}, gr, {
          indeterminate: Ar,
          checked: Er,
          skipGroup: !0,
          onClick: (Sr) => Sr.stopPropagation(),
          onChange: (Sr) => {
            let {
              nativeEvent: Br
            } = Sr;
            const {
              shiftKey: Ir
            } = Br, hr = Zt.findIndex((xr) => xr === yr), vr = Ft.some((xr) => Zt.includes(xr));
            if (Ir && gt && vr) {
              const xr = Ot(hr, Zt, qt), Pr = Array.from(qt);
              lt == null || lt(!Er, Pr.map((Rr) => vt(Rr)), xr.map((Rr) => vt(Rr))), Lt(Pr, "multiple");
            } else {
              const xr = Ft;
              if (gt) {
                const Pr = Er ? arrDel(xr, yr) : arrAdd(xr, yr);
                $t(yr, !Er, Pr, Br);
              } else {
                const Pr = conductCheck([].concat(_toConsumableArray$d(xr), [yr]), !0, Rt, Ht), {
                  checkedKeys: Rr,
                  halfCheckedKeys: Dr
                } = Pr;
                let Gr = Rr;
                if (Er) {
                  const Or = new Set(Rr);
                  Or.delete(yr), Gr = conductCheck(Array.from(Or), {
                    checked: !1,
                    halfCheckedKeys: Dr
                  }, Rt, Ht).checkedKeys;
                }
                $t(yr, !Er, Gr, Br);
              }
            }
            Pt(Er ? null : hr);
          }
        })),
        checked: Er
      };
    };
    const tr = (er, lr, ur) => {
      const {
        node: pr,
        checked: yr
      } = nr(er, lr, ur);
      return ht ? ht(yr, lr, ur, pr) : pr;
    };
    if (!Qt.includes(SELECTION_COLUMN))
      if (Qt.findIndex((er) => {
        var lr;
        return ((lr = er[INTERNAL_COL_DEFINE]) === null || lr === void 0 ? void 0 : lr.columnType) === "EXPAND_COLUMN";
      }) === 0) {
        const [er, ...lr] = Qt;
        Qt = [er, SELECTION_COLUMN].concat(_toConsumableArray$d(lr));
      } else
        Qt = [SELECTION_COLUMN].concat(_toConsumableArray$d(Qt));
    const ir = Qt.indexOf(SELECTION_COLUMN);
    Qt = Qt.filter((er, lr) => er !== SELECTION_COLUMN || lr === ir);
    const sr = Qt[ir - 1], cr = Qt[ir + 1];
    let or = ft;
    or === void 0 && ((cr == null ? void 0 : cr.fixed) !== void 0 ? or = cr.fixed : (sr == null ? void 0 : sr.fixed) !== void 0 && (or = sr.fixed)), or && sr && ((Vt = sr[INTERNAL_COL_DEFINE]) === null || Vt === void 0 ? void 0 : Vt.columnType) === "EXPAND_COLUMN" && sr.fixed === void 0 && (sr.fixed = or);
    const Xt = classnames(`${pt}-selection-col`, {
      [`${pt}-selection-col-with-dropdown`]: ut && it === "checkbox"
    }), Gt = () => s != null && s.columnTitle ? typeof s.columnTitle == "function" ? s.columnTitle(Kt) : s.columnTitle : Yt, Wt = {
      fixed: or,
      width: et,
      className: `${pt}-selection-column`,
      title: Gt(),
      render: tr,
      onCell: s.onCell,
      [INTERNAL_COL_DEFINE]: {
        className: Xt
      }
    };
    return Qt.map((er) => er === SELECTION_COLUMN ? Wt : er);
  }, [At, kt, s, Ft, Nt, Mt, et, Tt, xt, jt, lt, $t, Ht]), Nt];
};
function fillProxy(a, s) {
  return a._antProxy = a._antProxy || {}, Object.keys(s).forEach(($) => {
    if (!($ in a._antProxy)) {
      const _ = a[$];
      a._antProxy[$] = _, a[$] = s[$];
    }
  }), a;
}
function useProxyImperativeHandle(a, s) {
  return reactExports.useImperativeHandle(a, () => {
    const $ = s(), {
      nativeElement: _
    } = $;
    return typeof Proxy < "u" ? new Proxy(_, {
      get(_e, tt) {
        return $[tt] ? $[tt] : Reflect.get(_e, tt);
      }
    }) : fillProxy(_, $);
  });
}
function renderExpandIcon(a) {
  return function($) {
    let {
      prefixCls: _,
      onExpand: _e,
      record: tt,
      expanded: nt,
      expandable: at
    } = $;
    const ot = `${_}-row-expand-icon`;
    return /* @__PURE__ */ reactExports.createElement("button", {
      type: "button",
      onClick: (rt) => {
        _e(tt, rt), rt.stopPropagation();
      },
      className: classnames(ot, {
        [`${ot}-spaced`]: !at,
        [`${ot}-expanded`]: at && nt,
        [`${ot}-collapsed`]: at && !nt
      }),
      "aria-label": nt ? a.collapse : a.expand,
      "aria-expanded": nt
    });
  };
}
function useContainerWidth(a) {
  return ($, _) => {
    const _e = $.querySelector(`.${a}-container`);
    let tt = _;
    if (_e) {
      const nt = getComputedStyle(_e), at = parseInt(nt.borderLeftWidth, 10), ot = parseInt(nt.borderRightWidth, 10);
      tt = _ - at - ot;
    }
    return tt;
  };
}
function getColumnKey(a, s) {
  return "key" in a && a.key !== void 0 && a.key !== null ? a.key : a.dataIndex ? Array.isArray(a.dataIndex) ? a.dataIndex.join(".") : a.dataIndex : s;
}
function getColumnPos(a, s) {
  return s ? `${s}-${a}` : `${a}`;
}
function renderColumnTitle(a, s) {
  return typeof a == "function" ? a(s) : a;
}
function safeColumnTitle(a, s) {
  const $ = renderColumnTitle(a, s);
  return Object.prototype.toString.call($) === "[object Object]" ? "" : $;
}
var FilterFilled$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z" } }] }, name: "filter", theme: "filled" };
const FilterFilledSvg = FilterFilled$2;
var FilterFilled = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: FilterFilledSvg
  }));
};
const FilterFilled$1 = /* @__PURE__ */ reactExports.forwardRef(FilterFilled);
function useSyncState(a) {
  const s = reactExports.useRef(a), $ = useForceUpdate();
  return [() => s.current, (_) => {
    s.current = _, $();
  }];
}
function DropIndicator(a) {
  var s = a.dropPosition, $ = a.dropLevelOffset, _ = a.indent, _e = {
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    backgroundColor: "red",
    height: 2
  };
  switch (s) {
    case -1:
      _e.top = 0, _e.left = -$ * _;
      break;
    case 1:
      _e.bottom = 0, _e.left = -$ * _;
      break;
    case 0:
      _e.bottom = 0, _e.left = _;
      break;
  }
  return /* @__PURE__ */ reactExports.createElement("div", {
    style: _e
  });
}
function _objectDestructuringEmpty(a) {
  if (a == null)
    throw new TypeError("Cannot destructure " + a);
}
function useUnmount$2(a, s) {
  var $ = reactExports.useState(!1), _ = _slicedToArray$e($, 2), _e = _[0], tt = _[1];
  useLayoutEffect$1(function() {
    if (_e)
      return a(), function() {
        s();
      };
  }, [_e]), useLayoutEffect$1(function() {
    return tt(!0), function() {
      tt(!1);
    };
  }, []);
}
var _excluded$5 = ["className", "style", "motion", "motionNodes", "motionType", "onMotionStart", "onMotionEnd", "active", "treeNodeRequiredProps"], MotionTreeNode = function a(s, $) {
  var _ = s.className, _e = s.style, tt = s.motion, nt = s.motionNodes, at = s.motionType, ot = s.onMotionStart, rt = s.onMotionEnd, st = s.active, lt = s.treeNodeRequiredProps, et = _objectWithoutProperties$1(s, _excluded$5), it = reactExports.useState(!0), ut = _slicedToArray$e(it, 2), ft = ut[0], ht = ut[1], dt = reactExports.useContext(TreeContext), gt = dt.prefixCls, pt = nt && at !== "hide";
  useLayoutEffect$1(function() {
    nt && pt !== ft && ht(pt);
  }, [nt]);
  var mt = function() {
    nt && ot();
  }, ct = reactExports.useRef(!1), vt = function() {
    nt && !ct.current && (ct.current = !0, rt());
  };
  useUnmount$2(mt, vt);
  var At = function(bt) {
    pt === bt && vt();
  };
  return nt ? /* @__PURE__ */ reactExports.createElement(CSSMotion, _extends$2({
    ref: $,
    visible: ft
  }, tt, {
    motionAppear: at === "show",
    onVisibleChanged: At
  }), function(xt, bt) {
    var Et = xt.className, St = xt.style;
    return /* @__PURE__ */ reactExports.createElement("div", {
      ref: bt,
      className: classnames("".concat(gt, "-treenode-motion"), Et),
      style: St
    }, nt.map(function(Bt) {
      var Ot = _extends$2({}, (_objectDestructuringEmpty(Bt.data), Bt.data)), Pt = Bt.title, wt = Bt.key, Ct = Bt.isStart, It = Bt.isEnd;
      delete Ot.children;
      var yt = getTreeNodeProps(wt, lt);
      return /* @__PURE__ */ reactExports.createElement(ContextTreeNode, _extends$2({}, Ot, yt, {
        title: Pt,
        active: st,
        data: Bt.data,
        key: wt,
        isStart: Ct,
        isEnd: It
      }));
    }));
  }) : /* @__PURE__ */ reactExports.createElement(ContextTreeNode, _extends$2({
    domRef: $,
    className: _,
    style: _e
  }, et, {
    active: st
  }));
};
MotionTreeNode.displayName = "MotionTreeNode";
var RefMotionTreeNode = /* @__PURE__ */ reactExports.forwardRef(MotionTreeNode);
function findExpandedKeys() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], $ = a.length, _ = s.length;
  if (Math.abs($ - _) !== 1)
    return {
      add: !1,
      key: null
    };
  function _e(tt, nt) {
    var at = /* @__PURE__ */ new Map();
    tt.forEach(function(rt) {
      at.set(rt, !0);
    });
    var ot = nt.filter(function(rt) {
      return !at.has(rt);
    });
    return ot.length === 1 ? ot[0] : null;
  }
  return $ < _ ? {
    add: !0,
    key: _e(a, s)
  } : {
    add: !1,
    key: _e(s, a)
  };
}
function getExpandRange(a, s, $) {
  var _ = a.findIndex(function(at) {
    return at.key === $;
  }), _e = a[_ + 1], tt = s.findIndex(function(at) {
    return at.key === $;
  });
  if (_e) {
    var nt = s.findIndex(function(at) {
      return at.key === _e.key;
    });
    return s.slice(tt + 1, nt);
  }
  return s.slice(tt + 1);
}
var _excluded$4 = ["prefixCls", "data", "selectable", "checkable", "expandedKeys", "selectedKeys", "checkedKeys", "loadedKeys", "loadingKeys", "halfCheckedKeys", "keyEntities", "disabled", "dragging", "dragOverNodeKey", "dropPosition", "motion", "height", "itemHeight", "virtual", "focusable", "activeItem", "focused", "tabIndex", "onKeyDown", "onFocus", "onBlur", "onActiveChange", "onListChangeStart", "onListChangeEnd"], HIDDEN_STYLE$1 = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, noop$2 = function a() {
}, MOTION_KEY = "RC_TREE_MOTION_".concat(Math.random()), MotionNode = {
  key: MOTION_KEY
}, MotionEntity = {
  key: MOTION_KEY,
  level: 0,
  index: 0,
  pos: "0",
  node: MotionNode,
  nodes: [MotionNode]
}, MotionFlattenData = {
  parent: null,
  children: [],
  pos: MotionEntity.pos,
  data: MotionNode,
  title: null,
  key: MOTION_KEY,
  /** Hold empty list here since we do not use it */
  isStart: [],
  isEnd: []
};
function getMinimumRangeTransitionRange(a, s, $, _) {
  return s === !1 || !$ ? a : a.slice(0, Math.ceil($ / _) + 1);
}
function itemKey(a) {
  var s = a.key, $ = a.pos;
  return getKey$1(s, $);
}
function getAccessibilityPath(a) {
  for (var s = String(a.data.key), $ = a; $.parent; )
    $ = $.parent, s = "".concat($.data.key, " > ").concat(s);
  return s;
}
var NodeList = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.prefixCls, _ = a.data;
  a.selectable, a.checkable;
  var _e = a.expandedKeys, tt = a.selectedKeys, nt = a.checkedKeys, at = a.loadedKeys, ot = a.loadingKeys, rt = a.halfCheckedKeys, st = a.keyEntities, lt = a.disabled, et = a.dragging, it = a.dragOverNodeKey, ut = a.dropPosition, ft = a.motion, ht = a.height, dt = a.itemHeight, gt = a.virtual, pt = a.focusable, mt = a.activeItem, ct = a.focused, vt = a.tabIndex, At = a.onKeyDown, xt = a.onFocus, bt = a.onBlur, Et = a.onActiveChange, St = a.onListChangeStart, Bt = a.onListChangeEnd, Ot = _objectWithoutProperties$1(a, _excluded$4), Pt = reactExports.useRef(null), wt = reactExports.useRef(null);
  reactExports.useImperativeHandle(s, function() {
    return {
      scrollTo: function(nr) {
        Pt.current.scrollTo(nr);
      },
      getIndentWidth: function() {
        return wt.current.offsetWidth;
      }
    };
  });
  var Ct = reactExports.useState(_e), It = _slicedToArray$e(Ct, 2), yt = It[0], Rt = It[1], kt = reactExports.useState(_), jt = _slicedToArray$e(kt, 2), Ht = jt[0], Ft = jt[1], _t = reactExports.useState(_), Nt = _slicedToArray$e(_t, 2), Mt = Nt[0], Lt = Nt[1], $t = reactExports.useState([]), Tt = _slicedToArray$e($t, 2), Dt = Tt[0], Ut = Tt[1], Vt = reactExports.useState(null), Qt = _slicedToArray$e(Vt, 2), qt = Qt[0], Zt = Qt[1], ar = reactExports.useRef(_);
  ar.current = _;
  function Jt() {
    var Kt = ar.current;
    Ft(Kt), Lt(Kt), Ut([]), Zt(null), Bt();
  }
  useLayoutEffect$1(function() {
    Rt(_e);
    var Kt = findExpandedKeys(yt, _e);
    if (Kt.key !== null)
      if (Kt.add) {
        var nr = Ht.findIndex(function(Xt) {
          var Gt = Xt.key;
          return Gt === Kt.key;
        }), tr = getMinimumRangeTransitionRange(getExpandRange(Ht, _, Kt.key), gt, ht, dt), ir = Ht.slice();
        ir.splice(nr + 1, 0, MotionFlattenData), Lt(ir), Ut(tr), Zt("show");
      } else {
        var sr = _.findIndex(function(Xt) {
          var Gt = Xt.key;
          return Gt === Kt.key;
        }), cr = getMinimumRangeTransitionRange(getExpandRange(_, Ht, Kt.key), gt, ht, dt), or = _.slice();
        or.splice(sr + 1, 0, MotionFlattenData), Lt(or), Ut(cr), Zt("hide");
      }
    else
      Ht !== _ && (Ft(_), Lt(_));
  }, [_e, _]), reactExports.useEffect(function() {
    et || Jt();
  }, [et]);
  var rr = ft ? Mt : _, Yt = {
    expandedKeys: _e,
    selectedKeys: tt,
    loadedKeys: at,
    loadingKeys: ot,
    checkedKeys: nt,
    halfCheckedKeys: rt,
    dragOverNodeKey: it,
    dropPosition: ut,
    keyEntities: st
  };
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, ct && mt && /* @__PURE__ */ reactExports.createElement("span", {
    style: HIDDEN_STYLE$1,
    "aria-live": "assertive"
  }, getAccessibilityPath(mt)), /* @__PURE__ */ reactExports.createElement("div", null, /* @__PURE__ */ reactExports.createElement("input", {
    style: HIDDEN_STYLE$1,
    disabled: pt === !1 || lt,
    tabIndex: pt !== !1 ? vt : null,
    onKeyDown: At,
    onFocus: xt,
    onBlur: bt,
    value: "",
    onChange: noop$2,
    "aria-label": "for screen reader"
  })), /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat($, "-treenode"),
    "aria-hidden": !0,
    style: {
      position: "absolute",
      pointerEvents: "none",
      visibility: "hidden",
      height: 0,
      overflow: "hidden",
      border: 0,
      padding: 0
    }
  }, /* @__PURE__ */ reactExports.createElement("div", {
    className: "".concat($, "-indent")
  }, /* @__PURE__ */ reactExports.createElement("div", {
    ref: wt,
    className: "".concat($, "-indent-unit")
  }))), /* @__PURE__ */ reactExports.createElement(List$1, _extends$2({}, Ot, {
    data: rr,
    itemKey,
    height: ht,
    fullHeight: !1,
    virtual: gt,
    itemHeight: dt,
    prefixCls: "".concat($, "-list"),
    ref: Pt,
    onVisibleChange: function(nr, tr) {
      var ir = new Set(nr), sr = tr.filter(function(cr) {
        return !ir.has(cr);
      });
      sr.some(function(cr) {
        return itemKey(cr) === MOTION_KEY;
      }) && Jt();
    }
  }), function(Kt) {
    var nr = Kt.pos, tr = _extends$2({}, (_objectDestructuringEmpty(Kt.data), Kt.data)), ir = Kt.title, sr = Kt.key, cr = Kt.isStart, or = Kt.isEnd, Xt = getKey$1(sr, nr);
    delete tr.key, delete tr.children;
    var Gt = getTreeNodeProps(Xt, Yt);
    return /* @__PURE__ */ reactExports.createElement(RefMotionTreeNode, _extends$2({}, tr, Gt, {
      title: ir,
      active: !!mt && sr === mt.key,
      pos: nr,
      data: Kt.data,
      isStart: cr,
      isEnd: or,
      motion: ft,
      motionNodes: sr === MOTION_KEY ? Dt : null,
      motionType: qt,
      onMotionStart: St,
      onMotionEnd: Jt,
      treeNodeRequiredProps: Yt,
      onMouseMove: function() {
        Et(null);
      }
    }));
  }));
});
NodeList.displayName = "NodeList";
var MAX_RETRY_TIMES = 10, Tree$3 = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $() {
    var _;
    _classCallCheck(this, $);
    for (var _e = arguments.length, tt = new Array(_e), nt = 0; nt < _e; nt++)
      tt[nt] = arguments[nt];
    return _ = s.call.apply(s, [this].concat(tt)), _.destroyed = !1, _.delayedDragEnterLogic = void 0, _.loadingRetryTimes = {}, _.state = {
      keyEntities: {},
      indent: null,
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      expandedKeys: [],
      draggingNodeKey: null,
      dragChildrenKeys: [],
      // dropTargetKey is the key of abstract-drop-node
      // the abstract-drop-node is the real drop node when drag and drop
      // not the DOM drag over node
      dropTargetKey: null,
      dropPosition: null,
      dropContainerKey: null,
      dropLevelOffset: null,
      dropTargetPos: null,
      dropAllowed: !0,
      // the abstract-drag-over-node
      // if mouse is on the bottom of top dom node or no the top of the bottom dom node
      // abstract-drag-over-node is the top node
      dragOverNodeKey: null,
      treeData: [],
      flattenNodes: [],
      focused: !1,
      activeKey: null,
      listChanging: !1,
      prevProps: null,
      fieldNames: fillFieldNames$1()
    }, _.dragStartMousePosition = null, _.dragNode = void 0, _.currentMouseOverDroppableNodeKey = null, _.listRef = /* @__PURE__ */ reactExports.createRef(), _.onNodeDragStart = function(at, ot) {
      var rt = _.state, st = rt.expandedKeys, lt = rt.keyEntities, et = _.props.onDragStart, it = ot.props.eventKey;
      _.dragNode = ot, _.dragStartMousePosition = {
        x: at.clientX,
        y: at.clientY
      };
      var ut = arrDel(st, it);
      _.setState({
        draggingNodeKey: it,
        dragChildrenKeys: getDragChildrenKeys(it, lt),
        indent: _.listRef.current.getIndentWidth()
      }), _.setExpandedKeys(ut), window.addEventListener("dragend", _.onWindowDragEnd), et == null || et({
        event: at,
        node: convertNodePropsToEventData(ot.props)
      });
    }, _.onNodeDragEnter = function(at, ot) {
      var rt = _.state, st = rt.expandedKeys, lt = rt.keyEntities, et = rt.dragChildrenKeys, it = rt.flattenNodes, ut = rt.indent, ft = _.props, ht = ft.onDragEnter, dt = ft.onExpand, gt = ft.allowDrop, pt = ft.direction, mt = ot.props, ct = mt.pos, vt = mt.eventKey, At = _assertThisInitialized(_), xt = At.dragNode;
      if (_.currentMouseOverDroppableNodeKey !== vt && (_.currentMouseOverDroppableNodeKey = vt), !xt) {
        _.resetDragState();
        return;
      }
      var bt = calcDropPosition(at, xt, ot, ut, _.dragStartMousePosition, gt, it, lt, st, pt), Et = bt.dropPosition, St = bt.dropLevelOffset, Bt = bt.dropTargetKey, Ot = bt.dropContainerKey, Pt = bt.dropTargetPos, wt = bt.dropAllowed, Ct = bt.dragOverNodeKey;
      if (
        // don't allow drop inside its children
        et.indexOf(Bt) !== -1 || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !wt
      ) {
        _.resetDragState();
        return;
      }
      if (_.delayedDragEnterLogic || (_.delayedDragEnterLogic = {}), Object.keys(_.delayedDragEnterLogic).forEach(function(It) {
        clearTimeout(_.delayedDragEnterLogic[It]);
      }), xt.props.eventKey !== ot.props.eventKey && (at.persist(), _.delayedDragEnterLogic[ct] = window.setTimeout(function() {
        if (_.state.draggingNodeKey !== null) {
          var It = _toConsumableArray$d(st), yt = getEntity(lt, ot.props.eventKey);
          yt && (yt.children || []).length && (It = arrAdd(st, ot.props.eventKey)), "expandedKeys" in _.props || _.setExpandedKeys(It), dt == null || dt(It, {
            node: convertNodePropsToEventData(ot.props),
            expanded: !0,
            nativeEvent: at.nativeEvent
          });
        }
      }, 800)), xt.props.eventKey === Bt && St === 0) {
        _.resetDragState();
        return;
      }
      _.setState({
        dragOverNodeKey: Ct,
        dropPosition: Et,
        dropLevelOffset: St,
        dropTargetKey: Bt,
        dropContainerKey: Ot,
        dropTargetPos: Pt,
        dropAllowed: wt
      }), ht == null || ht({
        event: at,
        node: convertNodePropsToEventData(ot.props),
        expandedKeys: st
      });
    }, _.onNodeDragOver = function(at, ot) {
      var rt = _.state, st = rt.dragChildrenKeys, lt = rt.flattenNodes, et = rt.keyEntities, it = rt.expandedKeys, ut = rt.indent, ft = _.props, ht = ft.onDragOver, dt = ft.allowDrop, gt = ft.direction, pt = _assertThisInitialized(_), mt = pt.dragNode;
      if (mt) {
        var ct = calcDropPosition(at, mt, ot, ut, _.dragStartMousePosition, dt, lt, et, it, gt), vt = ct.dropPosition, At = ct.dropLevelOffset, xt = ct.dropTargetKey, bt = ct.dropContainerKey, Et = ct.dropAllowed, St = ct.dropTargetPos, Bt = ct.dragOverNodeKey;
        st.indexOf(xt) !== -1 || !Et || (mt.props.eventKey === xt && At === 0 ? _.state.dropPosition === null && _.state.dropLevelOffset === null && _.state.dropTargetKey === null && _.state.dropContainerKey === null && _.state.dropTargetPos === null && _.state.dropAllowed === !1 && _.state.dragOverNodeKey === null || _.resetDragState() : vt === _.state.dropPosition && At === _.state.dropLevelOffset && xt === _.state.dropTargetKey && bt === _.state.dropContainerKey && St === _.state.dropTargetPos && Et === _.state.dropAllowed && Bt === _.state.dragOverNodeKey || _.setState({
          dropPosition: vt,
          dropLevelOffset: At,
          dropTargetKey: xt,
          dropContainerKey: bt,
          dropTargetPos: St,
          dropAllowed: Et,
          dragOverNodeKey: Bt
        }), ht == null || ht({
          event: at,
          node: convertNodePropsToEventData(ot.props)
        }));
      }
    }, _.onNodeDragLeave = function(at, ot) {
      _.currentMouseOverDroppableNodeKey === ot.props.eventKey && !at.currentTarget.contains(at.relatedTarget) && (_.resetDragState(), _.currentMouseOverDroppableNodeKey = null);
      var rt = _.props.onDragLeave;
      rt == null || rt({
        event: at,
        node: convertNodePropsToEventData(ot.props)
      });
    }, _.onWindowDragEnd = function(at) {
      _.onNodeDragEnd(at, null, !0), window.removeEventListener("dragend", _.onWindowDragEnd);
    }, _.onNodeDragEnd = function(at, ot) {
      var rt = _.props.onDragEnd;
      _.setState({
        dragOverNodeKey: null
      }), _.cleanDragState(), rt == null || rt({
        event: at,
        node: convertNodePropsToEventData(ot.props)
      }), _.dragNode = null, window.removeEventListener("dragend", _.onWindowDragEnd);
    }, _.onNodeDrop = function(at, ot) {
      var rt, st = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, lt = _.state, et = lt.dragChildrenKeys, it = lt.dropPosition, ut = lt.dropTargetKey, ft = lt.dropTargetPos, ht = lt.dropAllowed;
      if (ht) {
        var dt = _.props.onDrop;
        if (_.setState({
          dragOverNodeKey: null
        }), _.cleanDragState(), ut !== null) {
          var gt = _objectSpread2$a(_objectSpread2$a({}, getTreeNodeProps(ut, _.getTreeNodeRequiredProps())), {}, {
            active: ((rt = _.getActiveItem()) === null || rt === void 0 ? void 0 : rt.key) === ut,
            data: getEntity(_.state.keyEntities, ut).node
          }), pt = et.indexOf(ut) !== -1;
          warningOnce(!pt, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
          var mt = posToArr(ft), ct = {
            event: at,
            node: convertNodePropsToEventData(gt),
            dragNode: _.dragNode ? convertNodePropsToEventData(_.dragNode.props) : null,
            dragNodesKeys: [_.dragNode.props.eventKey].concat(et),
            dropToGap: it !== 0,
            dropPosition: it + Number(mt[mt.length - 1])
          };
          st || dt == null || dt(ct), _.dragNode = null;
        }
      }
    }, _.cleanDragState = function() {
      var at = _.state.draggingNodeKey;
      at !== null && _.setState({
        draggingNodeKey: null,
        dropPosition: null,
        dropContainerKey: null,
        dropTargetKey: null,
        dropLevelOffset: null,
        dropAllowed: !0,
        dragOverNodeKey: null
      }), _.dragStartMousePosition = null, _.currentMouseOverDroppableNodeKey = null;
    }, _.triggerExpandActionExpand = function(at, ot) {
      var rt = _.state, st = rt.expandedKeys, lt = rt.flattenNodes, et = ot.expanded, it = ot.key, ut = ot.isLeaf;
      if (!(ut || at.shiftKey || at.metaKey || at.ctrlKey)) {
        var ft = lt.filter(function(dt) {
          return dt.key === it;
        })[0], ht = convertNodePropsToEventData(_objectSpread2$a(_objectSpread2$a({}, getTreeNodeProps(it, _.getTreeNodeRequiredProps())), {}, {
          data: ft.data
        }));
        _.setExpandedKeys(et ? arrDel(st, it) : arrAdd(st, it)), _.onNodeExpand(at, ht);
      }
    }, _.onNodeClick = function(at, ot) {
      var rt = _.props, st = rt.onClick, lt = rt.expandAction;
      lt === "click" && _.triggerExpandActionExpand(at, ot), st == null || st(at, ot);
    }, _.onNodeDoubleClick = function(at, ot) {
      var rt = _.props, st = rt.onDoubleClick, lt = rt.expandAction;
      lt === "doubleClick" && _.triggerExpandActionExpand(at, ot), st == null || st(at, ot);
    }, _.onNodeSelect = function(at, ot) {
      var rt = _.state.selectedKeys, st = _.state, lt = st.keyEntities, et = st.fieldNames, it = _.props, ut = it.onSelect, ft = it.multiple, ht = ot.selected, dt = ot[et.key], gt = !ht;
      gt ? ft ? rt = arrAdd(rt, dt) : rt = [dt] : rt = arrDel(rt, dt);
      var pt = rt.map(function(mt) {
        var ct = getEntity(lt, mt);
        return ct ? ct.node : null;
      }).filter(function(mt) {
        return mt;
      });
      _.setUncontrolledState({
        selectedKeys: rt
      }), ut == null || ut(rt, {
        event: "select",
        selected: gt,
        node: ot,
        selectedNodes: pt,
        nativeEvent: at.nativeEvent
      });
    }, _.onNodeCheck = function(at, ot, rt) {
      var st = _.state, lt = st.keyEntities, et = st.checkedKeys, it = st.halfCheckedKeys, ut = _.props, ft = ut.checkStrictly, ht = ut.onCheck, dt = ot.key, gt, pt = {
        event: "check",
        node: ot,
        checked: rt,
        nativeEvent: at.nativeEvent
      };
      if (ft) {
        var mt = rt ? arrAdd(et, dt) : arrDel(et, dt), ct = arrDel(it, dt);
        gt = {
          checked: mt,
          halfChecked: ct
        }, pt.checkedNodes = mt.map(function(St) {
          return getEntity(lt, St);
        }).filter(function(St) {
          return St;
        }).map(function(St) {
          return St.node;
        }), _.setUncontrolledState({
          checkedKeys: mt
        });
      } else {
        var vt = conductCheck([].concat(_toConsumableArray$d(et), [dt]), !0, lt), At = vt.checkedKeys, xt = vt.halfCheckedKeys;
        if (!rt) {
          var bt = new Set(At);
          bt.delete(dt);
          var Et = conductCheck(Array.from(bt), {
            checked: !1,
            halfCheckedKeys: xt
          }, lt);
          At = Et.checkedKeys, xt = Et.halfCheckedKeys;
        }
        gt = At, pt.checkedNodes = [], pt.checkedNodesPositions = [], pt.halfCheckedKeys = xt, At.forEach(function(St) {
          var Bt = getEntity(lt, St);
          if (Bt) {
            var Ot = Bt.node, Pt = Bt.pos;
            pt.checkedNodes.push(Ot), pt.checkedNodesPositions.push({
              node: Ot,
              pos: Pt
            });
          }
        }), _.setUncontrolledState({
          checkedKeys: At
        }, !1, {
          halfCheckedKeys: xt
        });
      }
      ht == null || ht(gt, pt);
    }, _.onNodeLoad = function(at) {
      var ot = at.key, rt = new Promise(function(st, lt) {
        _.setState(function(et) {
          var it = et.loadedKeys, ut = it === void 0 ? [] : it, ft = et.loadingKeys, ht = ft === void 0 ? [] : ft, dt = _.props, gt = dt.loadData, pt = dt.onLoad;
          if (!gt || ut.indexOf(ot) !== -1 || ht.indexOf(ot) !== -1)
            return null;
          var mt = gt(at);
          return mt.then(function() {
            var ct = _.state.loadedKeys, vt = arrAdd(ct, ot);
            pt == null || pt(vt, {
              event: "load",
              node: at
            }), _.setUncontrolledState({
              loadedKeys: vt
            }), _.setState(function(At) {
              return {
                loadingKeys: arrDel(At.loadingKeys, ot)
              };
            }), st();
          }).catch(function(ct) {
            if (_.setState(function(At) {
              return {
                loadingKeys: arrDel(At.loadingKeys, ot)
              };
            }), _.loadingRetryTimes[ot] = (_.loadingRetryTimes[ot] || 0) + 1, _.loadingRetryTimes[ot] >= MAX_RETRY_TIMES) {
              var vt = _.state.loadedKeys;
              warningOnce(!1, "Retry for `loadData` many times but still failed. No more retry."), _.setUncontrolledState({
                loadedKeys: arrAdd(vt, ot)
              }), st();
            }
            lt(ct);
          }), {
            loadingKeys: arrAdd(ht, ot)
          };
        });
      });
      return rt.catch(function() {
      }), rt;
    }, _.onNodeMouseEnter = function(at, ot) {
      var rt = _.props.onMouseEnter;
      rt == null || rt({
        event: at,
        node: ot
      });
    }, _.onNodeMouseLeave = function(at, ot) {
      var rt = _.props.onMouseLeave;
      rt == null || rt({
        event: at,
        node: ot
      });
    }, _.onNodeContextMenu = function(at, ot) {
      var rt = _.props.onRightClick;
      rt && (at.preventDefault(), rt({
        event: at,
        node: ot
      }));
    }, _.onFocus = function() {
      var at = _.props.onFocus;
      _.setState({
        focused: !0
      });
      for (var ot = arguments.length, rt = new Array(ot), st = 0; st < ot; st++)
        rt[st] = arguments[st];
      at == null || at.apply(void 0, rt);
    }, _.onBlur = function() {
      var at = _.props.onBlur;
      _.setState({
        focused: !1
      }), _.onActiveChange(null);
      for (var ot = arguments.length, rt = new Array(ot), st = 0; st < ot; st++)
        rt[st] = arguments[st];
      at == null || at.apply(void 0, rt);
    }, _.getTreeNodeRequiredProps = function() {
      var at = _.state, ot = at.expandedKeys, rt = at.selectedKeys, st = at.loadedKeys, lt = at.loadingKeys, et = at.checkedKeys, it = at.halfCheckedKeys, ut = at.dragOverNodeKey, ft = at.dropPosition, ht = at.keyEntities;
      return {
        expandedKeys: ot || [],
        selectedKeys: rt || [],
        loadedKeys: st || [],
        loadingKeys: lt || [],
        checkedKeys: et || [],
        halfCheckedKeys: it || [],
        dragOverNodeKey: ut,
        dropPosition: ft,
        keyEntities: ht
      };
    }, _.setExpandedKeys = function(at) {
      var ot = _.state, rt = ot.treeData, st = ot.fieldNames, lt = flattenTreeData(rt, at, st);
      _.setUncontrolledState({
        expandedKeys: at,
        flattenNodes: lt
      }, !0);
    }, _.onNodeExpand = function(at, ot) {
      var rt = _.state.expandedKeys, st = _.state, lt = st.listChanging, et = st.fieldNames, it = _.props, ut = it.onExpand, ft = it.loadData, ht = ot.expanded, dt = ot[et.key];
      if (!lt) {
        var gt = rt.indexOf(dt), pt = !ht;
        if (warningOnce(ht && gt !== -1 || !ht && gt === -1, "Expand state not sync with index check"), pt ? rt = arrAdd(rt, dt) : rt = arrDel(rt, dt), _.setExpandedKeys(rt), ut == null || ut(rt, {
          node: ot,
          expanded: pt,
          nativeEvent: at.nativeEvent
        }), pt && ft) {
          var mt = _.onNodeLoad(ot);
          mt && mt.then(function() {
            var ct = flattenTreeData(_.state.treeData, rt, et);
            _.setUncontrolledState({
              flattenNodes: ct
            });
          }).catch(function() {
            var ct = _.state.expandedKeys, vt = arrDel(ct, dt);
            _.setExpandedKeys(vt);
          });
        }
      }
    }, _.onListChangeStart = function() {
      _.setUncontrolledState({
        listChanging: !0
      });
    }, _.onListChangeEnd = function() {
      setTimeout(function() {
        _.setUncontrolledState({
          listChanging: !1
        });
      });
    }, _.onActiveChange = function(at) {
      var ot = _.state.activeKey, rt = _.props, st = rt.onActiveChange, lt = rt.itemScrollOffset, et = lt === void 0 ? 0 : lt;
      ot !== at && (_.setState({
        activeKey: at
      }), at !== null && _.scrollTo({
        key: at,
        offset: et
      }), st == null || st(at));
    }, _.getActiveItem = function() {
      var at = _.state, ot = at.activeKey, rt = at.flattenNodes;
      return ot === null ? null : rt.find(function(st) {
        var lt = st.key;
        return lt === ot;
      }) || null;
    }, _.offsetActiveKey = function(at) {
      var ot = _.state, rt = ot.flattenNodes, st = ot.activeKey, lt = rt.findIndex(function(ut) {
        var ft = ut.key;
        return ft === st;
      });
      lt === -1 && at < 0 && (lt = rt.length), lt = (lt + at + rt.length) % rt.length;
      var et = rt[lt];
      if (et) {
        var it = et.key;
        _.onActiveChange(it);
      } else
        _.onActiveChange(null);
    }, _.onKeyDown = function(at) {
      var ot = _.state, rt = ot.activeKey, st = ot.expandedKeys, lt = ot.checkedKeys, et = ot.fieldNames, it = _.props, ut = it.onKeyDown, ft = it.checkable, ht = it.selectable;
      switch (at.which) {
        case KeyCode.UP: {
          _.offsetActiveKey(-1), at.preventDefault();
          break;
        }
        case KeyCode.DOWN: {
          _.offsetActiveKey(1), at.preventDefault();
          break;
        }
      }
      var dt = _.getActiveItem();
      if (dt && dt.data) {
        var gt = _.getTreeNodeRequiredProps(), pt = dt.data.isLeaf === !1 || !!(dt.data[et.children] || []).length, mt = convertNodePropsToEventData(_objectSpread2$a(_objectSpread2$a({}, getTreeNodeProps(rt, gt)), {}, {
          data: dt.data,
          active: !0
        }));
        switch (at.which) {
          case KeyCode.LEFT: {
            pt && st.includes(rt) ? _.onNodeExpand({}, mt) : dt.parent && _.onActiveChange(dt.parent.key), at.preventDefault();
            break;
          }
          case KeyCode.RIGHT: {
            pt && !st.includes(rt) ? _.onNodeExpand({}, mt) : dt.children && dt.children.length && _.onActiveChange(dt.children[0].key), at.preventDefault();
            break;
          }
          case KeyCode.ENTER:
          case KeyCode.SPACE: {
            ft && !mt.disabled && mt.checkable !== !1 && !mt.disableCheckbox ? _.onNodeCheck({}, mt, !lt.includes(rt)) : !ft && ht && !mt.disabled && mt.selectable !== !1 && _.onNodeSelect({}, mt);
            break;
          }
        }
      }
      ut == null || ut(at);
    }, _.setUncontrolledState = function(at) {
      var ot = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, rt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!_.destroyed) {
        var st = !1, lt = !0, et = {};
        Object.keys(at).forEach(function(it) {
          if (it in _.props) {
            lt = !1;
            return;
          }
          st = !0, et[it] = at[it];
        }), st && (!ot || lt) && _.setState(_objectSpread2$a(_objectSpread2$a({}, et), rt));
      }
    }, _.scrollTo = function(at) {
      _.listRef.current.scrollTo(at);
    }, _;
  }
  return _createClass($, [{
    key: "componentDidMount",
    value: function() {
      this.destroyed = !1, this.onUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.onUpdated();
    }
  }, {
    key: "onUpdated",
    value: function() {
      var _e = this.props, tt = _e.activeKey, nt = _e.itemScrollOffset, at = nt === void 0 ? 0 : nt;
      tt !== void 0 && tt !== this.state.activeKey && (this.setState({
        activeKey: tt
      }), tt !== null && this.scrollTo({
        key: tt,
        offset: at
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      window.removeEventListener("dragend", this.onWindowDragEnd), this.destroyed = !0;
    }
  }, {
    key: "resetDragState",
    value: function() {
      this.setState({
        dragOverNodeKey: null,
        dropPosition: null,
        dropLevelOffset: null,
        dropTargetKey: null,
        dropContainerKey: null,
        dropTargetPos: null,
        dropAllowed: !1
      });
    }
  }, {
    key: "render",
    value: function() {
      var _e, tt = this.state, nt = tt.focused, at = tt.flattenNodes, ot = tt.keyEntities, rt = tt.draggingNodeKey, st = tt.activeKey, lt = tt.dropLevelOffset, et = tt.dropContainerKey, it = tt.dropTargetKey, ut = tt.dropPosition, ft = tt.dragOverNodeKey, ht = tt.indent, dt = this.props, gt = dt.prefixCls, pt = dt.className, mt = dt.style, ct = dt.showLine, vt = dt.focusable, At = dt.tabIndex, xt = At === void 0 ? 0 : At, bt = dt.selectable, Et = dt.showIcon, St = dt.icon, Bt = dt.switcherIcon, Ot = dt.draggable, Pt = dt.checkable, wt = dt.checkStrictly, Ct = dt.disabled, It = dt.motion, yt = dt.loadData, Rt = dt.filterTreeNode, kt = dt.height, jt = dt.itemHeight, Ht = dt.virtual, Ft = dt.titleRender, _t = dt.dropIndicatorRender, Nt = dt.onContextMenu, Mt = dt.onScroll, Lt = dt.direction, $t = dt.rootClassName, Tt = dt.rootStyle, Dt = pickAttrs(this.props, {
        aria: !0,
        data: !0
      }), Ut;
      return Ot && (_typeof$q(Ot) === "object" ? Ut = Ot : typeof Ot == "function" ? Ut = {
        nodeDraggable: Ot
      } : Ut = {}), /* @__PURE__ */ reactExports.createElement(TreeContext.Provider, {
        value: {
          prefixCls: gt,
          selectable: bt,
          showIcon: Et,
          icon: St,
          switcherIcon: Bt,
          draggable: Ut,
          draggingNodeKey: rt,
          checkable: Pt,
          checkStrictly: wt,
          disabled: Ct,
          keyEntities: ot,
          dropLevelOffset: lt,
          dropContainerKey: et,
          dropTargetKey: it,
          dropPosition: ut,
          dragOverNodeKey: ft,
          indent: ht,
          direction: Lt,
          dropIndicatorRender: _t,
          loadData: yt,
          filterTreeNode: Rt,
          titleRender: Ft,
          onNodeClick: this.onNodeClick,
          onNodeDoubleClick: this.onNodeDoubleClick,
          onNodeExpand: this.onNodeExpand,
          onNodeSelect: this.onNodeSelect,
          onNodeCheck: this.onNodeCheck,
          onNodeLoad: this.onNodeLoad,
          onNodeMouseEnter: this.onNodeMouseEnter,
          onNodeMouseLeave: this.onNodeMouseLeave,
          onNodeContextMenu: this.onNodeContextMenu,
          onNodeDragStart: this.onNodeDragStart,
          onNodeDragEnter: this.onNodeDragEnter,
          onNodeDragOver: this.onNodeDragOver,
          onNodeDragLeave: this.onNodeDragLeave,
          onNodeDragEnd: this.onNodeDragEnd,
          onNodeDrop: this.onNodeDrop
        }
      }, /* @__PURE__ */ reactExports.createElement("div", {
        role: "tree",
        className: classnames(gt, pt, $t, (_e = {}, _defineProperty$c(_e, "".concat(gt, "-show-line"), ct), _defineProperty$c(_e, "".concat(gt, "-focused"), nt), _defineProperty$c(_e, "".concat(gt, "-active-focused"), st !== null), _e)),
        style: Tt
      }, /* @__PURE__ */ reactExports.createElement(NodeList, _extends$2({
        ref: this.listRef,
        prefixCls: gt,
        style: mt,
        data: at,
        disabled: Ct,
        selectable: bt,
        checkable: !!Pt,
        motion: It,
        dragging: rt !== null,
        height: kt,
        itemHeight: jt,
        virtual: Ht,
        focusable: vt,
        focused: nt,
        tabIndex: xt,
        activeItem: this.getActiveItem(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onActiveChange: this.onActiveChange,
        onListChangeStart: this.onListChangeStart,
        onListChangeEnd: this.onListChangeEnd,
        onContextMenu: Nt,
        onScroll: Mt
      }, this.getTreeNodeRequiredProps(), Dt))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(_e, tt) {
      var nt = tt.prevProps, at = {
        prevProps: _e
      };
      function ot(vt) {
        return !nt && vt in _e || nt && nt[vt] !== _e[vt];
      }
      var rt, st = tt.fieldNames;
      if (ot("fieldNames") && (st = fillFieldNames$1(_e.fieldNames), at.fieldNames = st), ot("treeData") ? rt = _e.treeData : ot("children") && (warningOnce(!1, "`children` of Tree is deprecated. Please use `treeData` instead."), rt = convertTreeToData(_e.children)), rt) {
        at.treeData = rt;
        var lt = convertDataToEntities(rt, {
          fieldNames: st
        });
        at.keyEntities = _objectSpread2$a(_defineProperty$c({}, MOTION_KEY, MotionEntity), lt.keyEntities);
      }
      var et = at.keyEntities || tt.keyEntities;
      if (ot("expandedKeys") || nt && ot("autoExpandParent"))
        at.expandedKeys = _e.autoExpandParent || !nt && _e.defaultExpandParent ? conductExpandParent(_e.expandedKeys, et) : _e.expandedKeys;
      else if (!nt && _e.defaultExpandAll) {
        var it = _objectSpread2$a({}, et);
        delete it[MOTION_KEY], at.expandedKeys = Object.keys(it).map(function(vt) {
          return it[vt].key;
        });
      } else
        !nt && _e.defaultExpandedKeys && (at.expandedKeys = _e.autoExpandParent || _e.defaultExpandParent ? conductExpandParent(_e.defaultExpandedKeys, et) : _e.defaultExpandedKeys);
      if (at.expandedKeys || delete at.expandedKeys, rt || at.expandedKeys) {
        var ut = flattenTreeData(rt || tt.treeData, at.expandedKeys || tt.expandedKeys, st);
        at.flattenNodes = ut;
      }
      if (_e.selectable && (ot("selectedKeys") ? at.selectedKeys = calcSelectedKeys(_e.selectedKeys, _e) : !nt && _e.defaultSelectedKeys && (at.selectedKeys = calcSelectedKeys(_e.defaultSelectedKeys, _e))), _e.checkable) {
        var ft;
        if (ot("checkedKeys") ? ft = parseCheckedKeys(_e.checkedKeys) || {} : !nt && _e.defaultCheckedKeys ? ft = parseCheckedKeys(_e.defaultCheckedKeys) || {} : rt && (ft = parseCheckedKeys(_e.checkedKeys) || {
          checkedKeys: tt.checkedKeys,
          halfCheckedKeys: tt.halfCheckedKeys
        }), ft) {
          var ht = ft, dt = ht.checkedKeys, gt = dt === void 0 ? [] : dt, pt = ht.halfCheckedKeys, mt = pt === void 0 ? [] : pt;
          if (!_e.checkStrictly) {
            var ct = conductCheck(gt, !0, et);
            gt = ct.checkedKeys, mt = ct.halfCheckedKeys;
          }
          at.checkedKeys = gt, at.halfCheckedKeys = mt;
        }
      }
      return ot("loadedKeys") && (at.loadedKeys = _e.loadedKeys), at;
    }
  }]), $;
}(reactExports.Component);
Tree$3.defaultProps = {
  prefixCls: "rc-tree",
  showLine: !1,
  showIcon: !0,
  selectable: !0,
  multiple: !1,
  checkable: !1,
  disabled: !1,
  checkStrictly: !1,
  draggable: !1,
  defaultExpandParent: !0,
  autoExpandParent: !1,
  defaultExpandAll: !1,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: [],
  dropIndicatorRender: DropIndicator,
  allowDrop: function a() {
    return !0;
  },
  expandAction: !1
};
Tree$3.TreeNode = ContextTreeNode;
var FileOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z" } }] }, name: "file", theme: "outlined" };
const FileOutlinedSvg = FileOutlined$2;
var FileOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: FileOutlinedSvg
  }));
};
const FileOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(FileOutlined);
var FolderOpenOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" } }] }, name: "folder-open", theme: "outlined" };
const FolderOpenOutlinedSvg = FolderOpenOutlined$2;
var FolderOpenOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: FolderOpenOutlinedSvg
  }));
};
const FolderOpenOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(FolderOpenOutlined);
var FolderOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z" } }] }, name: "folder", theme: "outlined" };
const FolderOutlinedSvg = FolderOutlined$2;
var FolderOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: FolderOutlinedSvg
  }));
};
const FolderOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(FolderOutlined);
var HolderOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, name: "holder", theme: "outlined" };
const HolderOutlinedSvg = HolderOutlined$2;
var HolderOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: HolderOutlinedSvg
  }));
};
const HolderOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(HolderOutlined), treeNodeFX = new Keyframe("ant-tree-node-fx-do-not-use", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), getSwitchStyle = (a, s) => ({
  [`.${a}-switcher-icon`]: {
    display: "inline-block",
    fontSize: 10,
    verticalAlign: "baseline",
    svg: {
      transition: `transform ${s.motionDurationSlow}`
    }
  }
}), getDropIndicatorStyle = (a, s) => ({
  [`.${a}-drop-indicator`]: {
    position: "absolute",
    // it should displayed over the following node
    zIndex: 1,
    height: 2,
    backgroundColor: s.colorPrimary,
    borderRadius: 1,
    pointerEvents: "none",
    "&:after": {
      position: "absolute",
      top: -3,
      insetInlineStart: -6,
      width: 8,
      height: 8,
      backgroundColor: "transparent",
      border: `${unit$1(s.lineWidthBold)} solid ${s.colorPrimary}`,
      borderRadius: "50%",
      content: '""'
    }
  }
}), genBaseStyle$2 = (a, s) => {
  const {
    treeCls: $,
    treeNodeCls: _,
    treeNodePadding: _e,
    titleHeight: tt,
    nodeSelectedBg: nt,
    nodeHoverBg: at
  } = s, ot = s.paddingXS;
  return {
    [$]: Object.assign(Object.assign({}, resetComponent(s)), {
      background: s.colorBgContainer,
      borderRadius: s.borderRadius,
      transition: `background-color ${s.motionDurationSlow}`,
      [`&${$}-rtl`]: {
        // >>> Switcher
        [`${$}-switcher`]: {
          "&_close": {
            [`${$}-switcher-icon`]: {
              svg: {
                transform: "rotate(90deg)"
              }
            }
          }
        }
      },
      [`&-focused:not(:hover):not(${$}-active-focused)`]: Object.assign({}, genFocusOutline(s)),
      // =================== Virtual List ===================
      [`${$}-list-holder-inner`]: {
        alignItems: "flex-start"
      },
      [`&${$}-block-node`]: {
        [`${$}-list-holder-inner`]: {
          alignItems: "stretch",
          // >>> Title
          [`${$}-node-content-wrapper`]: {
            flex: "auto"
          },
          // >>> Drag
          [`${_}.dragging`]: {
            position: "relative",
            "&:after": {
              position: "absolute",
              top: 0,
              insetInlineEnd: 0,
              bottom: _e,
              insetInlineStart: 0,
              border: `1px solid ${s.colorPrimary}`,
              opacity: 0,
              animationName: treeNodeFX,
              animationDuration: s.motionDurationSlow,
              animationPlayState: "running",
              animationFillMode: "forwards",
              content: '""',
              pointerEvents: "none"
            }
          }
        }
      },
      // ===================== TreeNode =====================
      [`${_}`]: {
        display: "flex",
        alignItems: "flex-start",
        padding: `0 0 ${unit$1(_e)} 0`,
        outline: "none",
        "&-rtl": {
          direction: "rtl"
        },
        // Disabled
        "&-disabled": {
          // >>> Title
          [`${$}-node-content-wrapper`]: {
            color: s.colorTextDisabled,
            cursor: "not-allowed",
            "&:hover": {
              background: "transparent"
            }
          }
        },
        [`&-active ${$}-node-content-wrapper`]: Object.assign({}, genFocusOutline(s)),
        [`&:not(${_}-disabled).filter-node ${$}-title`]: {
          color: "inherit",
          fontWeight: 500
        },
        "&-draggable": {
          [`${$}-draggable-icon`]: {
            // https://github.com/ant-design/ant-design/issues/41915
            flexShrink: 0,
            width: tt,
            lineHeight: `${unit$1(tt)}`,
            textAlign: "center",
            visibility: "visible",
            opacity: 0.2,
            transition: `opacity ${s.motionDurationSlow}`,
            [`${_}:hover &`]: {
              opacity: 0.45
            }
          },
          [`&${_}-disabled`]: {
            [`${$}-draggable-icon`]: {
              visibility: "hidden"
            }
          }
        }
      },
      // >>> Indent
      [`${$}-indent`]: {
        alignSelf: "stretch",
        whiteSpace: "nowrap",
        userSelect: "none",
        "&-unit": {
          display: "inline-block",
          width: tt
        }
      },
      // >>> Drag Handler
      [`${$}-draggable-icon`]: {
        visibility: "hidden"
      },
      // >>> Switcher
      [`${$}-switcher`]: Object.assign(Object.assign({}, getSwitchStyle(a, s)), {
        position: "relative",
        flex: "none",
        alignSelf: "stretch",
        width: tt,
        margin: 0,
        lineHeight: `${unit$1(tt)}`,
        textAlign: "center",
        cursor: "pointer",
        userSelect: "none",
        "&-noop": {
          cursor: "default"
        },
        "&_close": {
          [`${$}-switcher-icon`]: {
            svg: {
              transform: "rotate(-90deg)"
            }
          }
        },
        "&-loading-icon": {
          color: s.colorPrimary
        },
        "&-leaf-line": {
          position: "relative",
          zIndex: 1,
          display: "inline-block",
          width: "100%",
          height: "100%",
          // https://github.com/ant-design/ant-design/issues/31884
          "&:before": {
            position: "absolute",
            top: 0,
            insetInlineEnd: s.calc(tt).div(2).equal(),
            bottom: s.calc(_e).mul(-1).equal(),
            marginInlineStart: -1,
            borderInlineEnd: `1px solid ${s.colorBorder}`,
            content: '""'
          },
          "&:after": {
            position: "absolute",
            width: s.calc(s.calc(tt).div(2).equal()).mul(0.8).equal(),
            height: s.calc(tt).div(2).equal(),
            borderBottom: `1px solid ${s.colorBorder}`,
            content: '""'
          }
        }
      }),
      // >>> Checkbox
      [`${$}-checkbox`]: {
        top: "initial",
        marginInlineEnd: ot,
        alignSelf: "flex-start",
        marginTop: s.marginXXS
      },
      // >>> Title
      // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
      [`${$}-node-content-wrapper, ${$}-checkbox + span`]: {
        position: "relative",
        zIndex: "auto",
        minHeight: tt,
        margin: 0,
        padding: `0 ${unit$1(s.calc(s.paddingXS).div(2).equal())}`,
        color: "inherit",
        lineHeight: `${unit$1(tt)}`,
        background: "transparent",
        borderRadius: s.borderRadius,
        cursor: "pointer",
        transition: `all ${s.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`,
        "&:hover": {
          backgroundColor: at
        },
        [`&${$}-node-selected`]: {
          backgroundColor: nt
        },
        // Icon
        [`${$}-iconEle`]: {
          display: "inline-block",
          width: tt,
          height: tt,
          lineHeight: `${unit$1(tt)}`,
          textAlign: "center",
          verticalAlign: "top",
          "&:empty": {
            display: "none"
          }
        }
      },
      // https://github.com/ant-design/ant-design/issues/28217
      [`${$}-unselectable ${$}-node-content-wrapper:hover`]: {
        backgroundColor: "transparent"
      },
      // ==================== Draggable =====================
      [`${$}-node-content-wrapper`]: Object.assign({
        lineHeight: `${unit$1(tt)}`,
        userSelect: "none"
      }, getDropIndicatorStyle(a, s)),
      [`${_}.drop-container`]: {
        "> [draggable]": {
          boxShadow: `0 0 0 2px ${s.colorPrimary}`
        }
      },
      // ==================== Show Line =====================
      "&-show-line": {
        // ================ Indent lines ================
        [`${$}-indent`]: {
          "&-unit": {
            position: "relative",
            height: "100%",
            "&:before": {
              position: "absolute",
              top: 0,
              insetInlineEnd: s.calc(tt).div(2).equal(),
              bottom: s.calc(_e).mul(-1).equal(),
              borderInlineEnd: `1px solid ${s.colorBorder}`,
              content: '""'
            },
            "&-end": {
              "&:before": {
                display: "none"
              }
            }
          }
        },
        // ============== Cover Background ==============
        [`${$}-switcher`]: {
          background: "transparent",
          "&-line-icon": {
            // https://github.com/ant-design/ant-design/issues/32813
            verticalAlign: "-0.15em"
          }
        }
      },
      [`${_}-leaf-last`]: {
        [`${$}-switcher`]: {
          "&-leaf-line": {
            "&:before": {
              top: "auto !important",
              bottom: "auto !important",
              height: `${unit$1(s.calc(tt).div(2).equal())} !important`
            }
          }
        }
      }
    })
  };
}, genDirectoryStyle = (a) => {
  const {
    treeCls: s,
    treeNodeCls: $,
    treeNodePadding: _,
    directoryNodeSelectedBg: _e,
    directoryNodeSelectedColor: tt
  } = a;
  return {
    [`${s}${s}-directory`]: {
      // ================== TreeNode ==================
      [$]: {
        position: "relative",
        // Hover color
        "&:before": {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: _,
          insetInlineStart: 0,
          transition: `background-color ${a.motionDurationMid}`,
          content: '""',
          pointerEvents: "none"
        },
        "&:hover": {
          "&:before": {
            background: a.controlItemBgHover
          }
        },
        // Elements
        "> *": {
          zIndex: 1
        },
        // >>> Switcher
        [`${s}-switcher`]: {
          transition: `color ${a.motionDurationMid}`
        },
        // >>> Title
        [`${s}-node-content-wrapper`]: {
          borderRadius: 0,
          userSelect: "none",
          "&:hover": {
            background: "transparent"
          },
          [`&${s}-node-selected`]: {
            color: tt,
            background: "transparent"
          }
        },
        // ============= Selected =============
        "&-selected": {
          "\n            &:hover::before,\n            &::before\n          ": {
            background: _e
          },
          // >>> Switcher
          [`${s}-switcher`]: {
            color: tt
          },
          // >>> Title
          [`${s}-node-content-wrapper`]: {
            color: tt,
            background: "transparent"
          }
        }
      }
    }
  };
}, genTreeStyle = (a, s) => {
  const $ = `.${a}`, _ = `${$}-treenode`, _e = s.calc(s.paddingXS).div(2).equal(), tt = merge(s, {
    treeCls: $,
    treeNodeCls: _,
    treeNodePadding: _e
  });
  return [
    // Basic
    genBaseStyle$2(a, tt),
    // Directory
    genDirectoryStyle(tt)
  ];
}, initComponentToken = (a) => {
  const {
    controlHeightSM: s
  } = a;
  return {
    titleHeight: s,
    nodeHoverBg: a.controlItemBgHover,
    nodeSelectedBg: a.controlItemBgActive
  };
}, prepareComponentToken$3 = (a) => {
  const {
    colorTextLightSolid: s,
    colorPrimary: $
  } = a;
  return Object.assign(Object.assign({}, initComponentToken(a)), {
    directoryNodeSelectedColor: s,
    directoryNodeSelectedBg: $
  });
}, useStyle$3 = genStyleHooks("Tree", (a, s) => {
  let {
    prefixCls: $
  } = s;
  return [{
    [a.componentCls]: getStyle$1(`${$}-checkbox`, a)
  }, genTreeStyle($, a), genCollapseMotion$1(a)];
}, prepareComponentToken$3), offset = 4;
function dropIndicatorRender(a) {
  const {
    dropPosition: s,
    dropLevelOffset: $,
    prefixCls: _,
    indent: _e,
    direction: tt = "ltr"
  } = a, nt = tt === "ltr" ? "left" : "right", at = tt === "ltr" ? "right" : "left", ot = {
    [nt]: -$ * _e + offset,
    [at]: 0
  };
  switch (s) {
    case -1:
      ot.top = -3;
      break;
    case 1:
      ot.bottom = -3;
      break;
    default:
      ot.bottom = -3, ot[nt] = _e + offset;
      break;
  }
  return /* @__PURE__ */ React$a.createElement("div", {
    style: ot,
    className: `${_}-drop-indicator`
  });
}
var CaretDownFilled$2 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "filled" };
const CaretDownFilledSvg = CaretDownFilled$2;
var CaretDownFilled = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: CaretDownFilledSvg
  }));
};
const CaretDownFilled$1 = /* @__PURE__ */ reactExports.forwardRef(CaretDownFilled);
var MinusSquareOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "minus-square", theme: "outlined" };
const MinusSquareOutlinedSvg = MinusSquareOutlined$2;
var MinusSquareOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: MinusSquareOutlinedSvg
  }));
};
const MinusSquareOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(MinusSquareOutlined);
var PlusSquareOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z" } }, { tag: "path", attrs: { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z" } }] }, name: "plus-square", theme: "outlined" };
const PlusSquareOutlinedSvg = PlusSquareOutlined$2;
var PlusSquareOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: PlusSquareOutlinedSvg
  }));
};
const PlusSquareOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(PlusSquareOutlined), SwitcherIconCom = (a) => {
  const {
    prefixCls: s,
    switcherIcon: $,
    treeNodeProps: _,
    showLine: _e
  } = a, {
    isLeaf: tt,
    expanded: nt,
    loading: at
  } = _;
  if (at)
    return /* @__PURE__ */ reactExports.createElement(LoadingOutlined$1, {
      className: `${s}-switcher-loading-icon`
    });
  let ot;
  if (_e && typeof _e == "object" && (ot = _e.showLeafIcon), tt) {
    if (!_e)
      return null;
    if (typeof ot != "boolean" && ot) {
      const lt = typeof ot == "function" ? ot(_) : ot, et = `${s}-switcher-line-custom-icon`;
      return isValidElement(lt) ? cloneElement(lt, {
        className: classnames(lt.props.className || "", et)
      }) : lt;
    }
    return ot ? /* @__PURE__ */ reactExports.createElement(FileOutlined$1, {
      className: `${s}-switcher-line-icon`
    }) : /* @__PURE__ */ reactExports.createElement("span", {
      className: `${s}-switcher-leaf-line`
    });
  }
  const rt = `${s}-switcher-icon`, st = typeof $ == "function" ? $(_) : $;
  return isValidElement(st) ? cloneElement(st, {
    className: classnames(st.props.className || "", rt)
  }) : st !== void 0 ? st : _e ? nt ? /* @__PURE__ */ reactExports.createElement(MinusSquareOutlined$1, {
    className: `${s}-switcher-line-icon`
  }) : /* @__PURE__ */ reactExports.createElement(PlusSquareOutlined$1, {
    className: `${s}-switcher-line-icon`
  }) : /* @__PURE__ */ reactExports.createElement(CaretDownFilled$1, {
    className: rt
  });
}, SwitcherIconCom$1 = SwitcherIconCom, Tree$2 = /* @__PURE__ */ React$a.forwardRef((a, s) => {
  const {
    getPrefixCls: $,
    direction: _,
    virtual: _e,
    tree: tt
  } = React$a.useContext(ConfigContext$1), {
    prefixCls: nt,
    className: at,
    showIcon: ot = !1,
    showLine: rt,
    switcherIcon: st,
    blockNode: lt = !1,
    children: et,
    checkable: it = !1,
    selectable: ut = !0,
    draggable: ft,
    motion: ht,
    style: dt
  } = a, gt = $("tree", nt), pt = $(), mt = ht ?? Object.assign(Object.assign({}, initCollapseMotion$1(pt)), {
    motionAppear: !1
  }), ct = Object.assign(Object.assign({}, a), {
    checkable: it,
    selectable: ut,
    showIcon: ot,
    motion: mt,
    blockNode: lt,
    showLine: !!rt,
    dropIndicatorRender
  }), [vt, At, xt] = useStyle$3(gt), bt = React$a.useMemo(() => {
    if (!ft)
      return !1;
    let St = {};
    switch (typeof ft) {
      case "function":
        St.nodeDraggable = ft;
        break;
      case "object":
        St = Object.assign({}, ft);
        break;
    }
    return St.icon !== !1 && (St.icon = St.icon || /* @__PURE__ */ React$a.createElement(HolderOutlined$1, null)), St;
  }, [ft]), Et = (St) => /* @__PURE__ */ React$a.createElement(SwitcherIconCom$1, {
    prefixCls: gt,
    switcherIcon: st,
    treeNodeProps: St,
    showLine: rt
  });
  return vt(/* @__PURE__ */ React$a.createElement(Tree$3, Object.assign({
    itemHeight: 20,
    ref: s,
    virtual: _e
  }, ct, {
    // newProps may contain style so declare style below it
    style: Object.assign(Object.assign({}, tt == null ? void 0 : tt.style), dt),
    prefixCls: gt,
    className: classnames({
      [`${gt}-icon-hide`]: !ot,
      [`${gt}-block-node`]: lt,
      [`${gt}-unselectable`]: !ut,
      [`${gt}-rtl`]: _ === "rtl"
    }, tt == null ? void 0 : tt.className, at, At, xt),
    direction: _,
    checkable: it && /* @__PURE__ */ React$a.createElement("span", {
      className: `${gt}-checkbox-inner`
    }),
    selectable: ut,
    switcherIcon: Et,
    draggable: bt
  }), et));
}), TreePure = Tree$2;
var Record;
(function(a) {
  a[a.None = 0] = "None", a[a.Start = 1] = "Start", a[a.End = 2] = "End";
})(Record || (Record = {}));
function traverseNodesKey(a, s, $) {
  const {
    key: _,
    children: _e
  } = $;
  function tt(nt) {
    const at = nt[_], ot = nt[_e];
    s(at, nt) !== !1 && traverseNodesKey(ot || [], s, $);
  }
  a.forEach(tt);
}
function calcRangeKeys(a) {
  let {
    treeData: s,
    expandedKeys: $,
    startKey: _,
    endKey: _e,
    fieldNames: tt
  } = a;
  const nt = [];
  let at = Record.None;
  if (_ && _ === _e)
    return [_];
  if (!_ || !_e)
    return [];
  function ot(rt) {
    return rt === _ || rt === _e;
  }
  return traverseNodesKey(s, (rt) => {
    if (at === Record.End)
      return !1;
    if (ot(rt)) {
      if (nt.push(rt), at === Record.None)
        at = Record.Start;
      else if (at === Record.Start)
        return at = Record.End, !1;
    } else
      at === Record.Start && nt.push(rt);
    return $.includes(rt);
  }, fillFieldNames$1(tt)), nt;
}
function convertDirectoryKeysToNodes(a, s, $) {
  const _ = _toConsumableArray$d(s), _e = [];
  return traverseNodesKey(a, (tt, nt) => {
    const at = _.indexOf(tt);
    return at !== -1 && (_e.push(nt), _.splice(at, 1)), !!_.length;
  }, fillFieldNames$1($)), _e;
}
var __rest$d = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function getIcon(a) {
  const {
    isLeaf: s,
    expanded: $
  } = a;
  return s ? /* @__PURE__ */ reactExports.createElement(FileOutlined$1, null) : $ ? /* @__PURE__ */ reactExports.createElement(FolderOpenOutlined$1, null) : /* @__PURE__ */ reactExports.createElement(FolderOutlined$1, null);
}
function getTreeData(a) {
  let {
    treeData: s,
    children: $
  } = a;
  return s || convertTreeToData($);
}
const DirectoryTree = (a, s) => {
  var {
    defaultExpandAll: $,
    defaultExpandParent: _,
    defaultExpandedKeys: _e
  } = a, tt = __rest$d(a, ["defaultExpandAll", "defaultExpandParent", "defaultExpandedKeys"]);
  const nt = reactExports.useRef(), at = reactExports.useRef(), ot = () => {
    const {
      keyEntities: xt
    } = convertDataToEntities(getTreeData(tt));
    let bt;
    return $ ? bt = Object.keys(xt) : _ ? bt = conductExpandParent(tt.expandedKeys || _e || [], xt) : bt = tt.expandedKeys || _e, bt;
  }, [rt, st] = reactExports.useState(tt.selectedKeys || tt.defaultSelectedKeys || []), [lt, et] = reactExports.useState(() => ot());
  reactExports.useEffect(() => {
    "selectedKeys" in tt && st(tt.selectedKeys);
  }, [tt.selectedKeys]), reactExports.useEffect(() => {
    "expandedKeys" in tt && et(tt.expandedKeys);
  }, [tt.expandedKeys]);
  const it = (xt, bt) => {
    var Et;
    return "expandedKeys" in tt || et(xt), (Et = tt.onExpand) === null || Et === void 0 ? void 0 : Et.call(tt, xt, bt);
  }, ut = (xt, bt) => {
    var Et;
    const {
      multiple: St,
      fieldNames: Bt
    } = tt, {
      node: Ot,
      nativeEvent: Pt
    } = bt, {
      key: wt = ""
    } = Ot, Ct = getTreeData(tt), It = Object.assign(Object.assign({}, bt), {
      selected: !0
    }), yt = (Pt == null ? void 0 : Pt.ctrlKey) || (Pt == null ? void 0 : Pt.metaKey), Rt = Pt == null ? void 0 : Pt.shiftKey;
    let kt;
    St && yt ? (kt = xt, nt.current = wt, at.current = kt, It.selectedNodes = convertDirectoryKeysToNodes(Ct, kt, Bt)) : St && Rt ? (kt = Array.from(new Set([].concat(_toConsumableArray$d(at.current || []), _toConsumableArray$d(calcRangeKeys({
      treeData: Ct,
      expandedKeys: lt,
      startKey: wt,
      endKey: nt.current,
      fieldNames: Bt
    }))))), It.selectedNodes = convertDirectoryKeysToNodes(Ct, kt, Bt)) : (kt = [wt], nt.current = wt, at.current = kt, It.selectedNodes = convertDirectoryKeysToNodes(Ct, kt, Bt)), (Et = tt.onSelect) === null || Et === void 0 || Et.call(tt, kt, It), "selectedKeys" in tt || st(kt);
  }, {
    getPrefixCls: ft,
    direction: ht
  } = reactExports.useContext(ConfigContext$1), {
    prefixCls: dt,
    className: gt,
    showIcon: pt = !0,
    expandAction: mt = "click"
  } = tt, ct = __rest$d(tt, ["prefixCls", "className", "showIcon", "expandAction"]), vt = ft("tree", dt), At = classnames(`${vt}-directory`, {
    [`${vt}-directory-rtl`]: ht === "rtl"
  }, gt);
  return /* @__PURE__ */ reactExports.createElement(TreePure, Object.assign({
    icon: getIcon,
    ref: s,
    blockNode: !0
  }, ct, {
    showIcon: pt,
    expandAction: mt,
    prefixCls: vt,
    className: At,
    expandedKeys: lt,
    selectedKeys: rt,
    onSelect: ut,
    onExpand: it
  }));
}, ForwardDirectoryTree = /* @__PURE__ */ reactExports.forwardRef(DirectoryTree), DirectoryTree$1 = ForwardDirectoryTree, Tree = TreePure;
Tree.DirectoryTree = DirectoryTree$1;
Tree.TreeNode = ContextTreeNode;
const Tree$1 = Tree;
function FilterSearch(a) {
  let {
    value: s,
    onChange: $,
    filterSearch: _,
    tablePrefixCls: _e,
    locale: tt
  } = a;
  return _ ? /* @__PURE__ */ reactExports.createElement("div", {
    className: `${_e}-filter-dropdown-search`
  }, /* @__PURE__ */ reactExports.createElement(_Input, {
    prefix: /* @__PURE__ */ reactExports.createElement(SearchOutlined$1, null),
    placeholder: tt.filterSearchPlaceholder,
    onChange: $,
    value: s,
    // for skip min-width of input
    htmlSize: 1,
    className: `${_e}-filter-dropdown-search-input`
  })) : null;
}
const onKeyDown = (a) => {
  const {
    keyCode: s
  } = a;
  s === KeyCode.ENTER && a.stopPropagation();
}, FilterDropdownMenuWrapper = /* @__PURE__ */ reactExports.forwardRef((a, s) => /* @__PURE__ */ reactExports.createElement("div", {
  className: a.className,
  onClick: ($) => $.stopPropagation(),
  onKeyDown,
  ref: s
}, a.children)), FilterDropdownMenuWrapper$1 = FilterDropdownMenuWrapper;
function flattenKeys(a) {
  let s = [];
  return (a || []).forEach(($) => {
    let {
      value: _,
      children: _e
    } = $;
    s.push(_), _e && (s = [].concat(_toConsumableArray$d(s), _toConsumableArray$d(flattenKeys(_e))));
  }), s;
}
function hasSubMenu(a) {
  return a.some((s) => {
    let {
      children: $
    } = s;
    return $;
  });
}
function searchValueMatched(a, s) {
  return typeof s == "string" || typeof s == "number" ? s == null ? void 0 : s.toString().toLowerCase().includes(a.trim().toLowerCase()) : !1;
}
function renderFilterItems(a) {
  let {
    filters: s,
    prefixCls: $,
    filteredKeys: _,
    filterMultiple: _e,
    searchValue: tt,
    filterSearch: nt
  } = a;
  return s.map((at, ot) => {
    const rt = String(at.value);
    if (at.children)
      return {
        key: rt || ot,
        label: at.text,
        popupClassName: `${$}-dropdown-submenu`,
        children: renderFilterItems({
          filters: at.children,
          prefixCls: $,
          filteredKeys: _,
          filterMultiple: _e,
          searchValue: tt,
          filterSearch: nt
        })
      };
    const st = _e ? _Checkbox : _Radio, lt = {
      key: at.value !== void 0 ? rt : ot,
      label: /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(st, {
        checked: _.includes(rt)
      }), /* @__PURE__ */ reactExports.createElement("span", null, at.text))
    };
    return tt.trim() ? typeof nt == "function" ? nt(tt, at) ? lt : null : searchValueMatched(tt, at.text) ? lt : null : lt;
  });
}
function wrapStringListType(a) {
  return a || [];
}
function FilterDropdown(a) {
  var s, $;
  const {
    tablePrefixCls: _,
    prefixCls: _e,
    column: tt,
    dropdownPrefixCls: nt,
    columnKey: at,
    filterMultiple: ot,
    filterMode: rt = "menu",
    filterSearch: st = !1,
    filterState: lt,
    triggerFilter: et,
    locale: it,
    children: ut,
    getPopupContainer: ft,
    rootClassName: ht
  } = a, {
    filterDropdownOpen: dt,
    onFilterDropdownOpenChange: gt,
    filterResetToDefaultFilteredValue: pt,
    defaultFilteredValue: mt,
    // Deprecated
    filterDropdownVisible: ct,
    onFilterDropdownVisibleChange: vt
  } = tt, [At, xt] = reactExports.useState(!1), bt = !!(lt && (!((s = lt.filteredKeys) === null || s === void 0) && s.length || lt.forceFiltered)), Et = (ar) => {
    xt(ar), gt == null || gt(ar), vt == null || vt(ar);
  }, St = ($ = dt ?? ct) !== null && $ !== void 0 ? $ : At, Bt = lt == null ? void 0 : lt.filteredKeys, [Ot, Pt] = useSyncState(wrapStringListType(Bt)), wt = (ar) => {
    let {
      selectedKeys: Jt
    } = ar;
    Pt(Jt);
  }, Ct = (ar, Jt) => {
    let {
      node: rr,
      checked: Yt
    } = Jt;
    wt(ot ? {
      selectedKeys: ar
    } : {
      selectedKeys: Yt && rr.key ? [rr.key] : []
    });
  };
  reactExports.useEffect(() => {
    At && wt({
      selectedKeys: wrapStringListType(Bt)
    });
  }, [Bt]);
  const [It, yt] = reactExports.useState([]), Rt = (ar) => {
    yt(ar);
  }, [kt, jt] = reactExports.useState(""), Ht = (ar) => {
    const {
      value: Jt
    } = ar.target;
    jt(Jt);
  };
  reactExports.useEffect(() => {
    At || jt("");
  }, [At]);
  const Ft = (ar) => {
    const Jt = ar && ar.length ? ar : null;
    if (Jt === null && (!lt || !lt.filteredKeys) || isEqual$1(Jt, lt == null ? void 0 : lt.filteredKeys, !0))
      return null;
    et({
      column: tt,
      key: at,
      filteredKeys: Jt
    });
  }, _t = () => {
    Et(!1), Ft(Ot());
  }, Nt = function() {
    let {
      confirm: ar,
      closeDropdown: Jt
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      confirm: !1,
      closeDropdown: !1
    };
    ar && Ft([]), Jt && Et(!1), jt(""), Pt(pt ? (mt || []).map((rr) => String(rr)) : []);
  }, Mt = function() {
    let {
      closeDropdown: ar
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      closeDropdown: !0
    };
    ar && Et(!1), Ft(Ot());
  }, Lt = (ar, Jt) => {
    Jt.source === "trigger" && (ar && Bt !== void 0 && Pt(wrapStringListType(Bt)), Et(ar), !ar && !tt.filterDropdown && _t());
  }, $t = classnames({
    [`${nt}-menu-without-submenu`]: !hasSubMenu(tt.filters || [])
  }), Tt = (ar) => {
    if (ar.target.checked) {
      const Jt = flattenKeys(tt == null ? void 0 : tt.filters).map((rr) => String(rr));
      Pt(Jt);
    } else
      Pt([]);
  }, Dt = (ar) => {
    let {
      filters: Jt
    } = ar;
    return (Jt || []).map((rr, Yt) => {
      const Kt = String(rr.value), nr = {
        title: rr.text,
        key: rr.value !== void 0 ? Kt : String(Yt)
      };
      return rr.children && (nr.children = Dt({
        filters: rr.children
      })), nr;
    });
  }, Ut = (ar) => {
    var Jt;
    return Object.assign(Object.assign({}, ar), {
      text: ar.title,
      value: ar.key,
      children: ((Jt = ar.children) === null || Jt === void 0 ? void 0 : Jt.map((rr) => Ut(rr))) || []
    });
  };
  let Vt;
  if (typeof tt.filterDropdown == "function")
    Vt = tt.filterDropdown({
      prefixCls: `${nt}-custom`,
      setSelectedKeys: (ar) => wt({
        selectedKeys: ar
      }),
      selectedKeys: Ot(),
      confirm: Mt,
      clearFilters: Nt,
      filters: tt.filters,
      visible: St,
      close: () => {
        Et(!1);
      }
    });
  else if (tt.filterDropdown)
    Vt = tt.filterDropdown;
  else {
    const ar = Ot() || [], Jt = () => (tt.filters || []).length === 0 ? /* @__PURE__ */ reactExports.createElement(Empty$2, {
      image: Empty$2.PRESENTED_IMAGE_SIMPLE,
      description: it.filterEmptyText,
      imageStyle: {
        height: 24
      },
      style: {
        margin: 0,
        padding: "16px 0"
      }
    }) : rt === "tree" ? /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(FilterSearch, {
      filterSearch: st,
      value: kt,
      onChange: Ht,
      tablePrefixCls: _,
      locale: it
    }), /* @__PURE__ */ reactExports.createElement("div", {
      className: `${_}-filter-dropdown-tree`
    }, ot ? /* @__PURE__ */ reactExports.createElement(_Checkbox, {
      checked: ar.length === flattenKeys(tt.filters).length,
      indeterminate: ar.length > 0 && ar.length < flattenKeys(tt.filters).length,
      className: `${_}-filter-dropdown-checkall`,
      onChange: Tt
    }, it.filterCheckall) : null, /* @__PURE__ */ reactExports.createElement(Tree$1, {
      checkable: !0,
      selectable: !1,
      blockNode: !0,
      multiple: ot,
      checkStrictly: !ot,
      className: `${nt}-menu`,
      onCheck: Ct,
      checkedKeys: ar,
      selectedKeys: ar,
      showIcon: !1,
      treeData: Dt({
        filters: tt.filters
      }),
      autoExpandParent: !0,
      defaultExpandAll: !0,
      filterTreeNode: kt.trim() ? (Yt) => typeof st == "function" ? st(kt, Ut(Yt)) : searchValueMatched(kt, Yt.title) : void 0
    }))) : /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, /* @__PURE__ */ reactExports.createElement(FilterSearch, {
      filterSearch: st,
      value: kt,
      onChange: Ht,
      tablePrefixCls: _,
      locale: it
    }), /* @__PURE__ */ reactExports.createElement(Menu$1, {
      selectable: !0,
      multiple: ot,
      prefixCls: `${nt}-menu`,
      className: $t,
      onSelect: wt,
      onDeselect: wt,
      selectedKeys: ar,
      getPopupContainer: ft,
      openKeys: It,
      onOpenChange: Rt,
      items: renderFilterItems({
        filters: tt.filters || [],
        filterSearch: st,
        prefixCls: _e,
        filteredKeys: Ot(),
        filterMultiple: ot,
        searchValue: kt
      })
    })), rr = () => pt ? isEqual$1((mt || []).map((Yt) => String(Yt)), ar, !0) : ar.length === 0;
    Vt = /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, Jt(), /* @__PURE__ */ reactExports.createElement("div", {
      className: `${_e}-dropdown-btns`
    }, /* @__PURE__ */ reactExports.createElement(Button$2, {
      type: "link",
      size: "small",
      disabled: rr(),
      onClick: () => Nt()
    }, it.filterReset), /* @__PURE__ */ reactExports.createElement(Button$2, {
      type: "primary",
      size: "small",
      onClick: _t
    }, it.filterConfirm)));
  }
  tt.filterDropdown && (Vt = /* @__PURE__ */ reactExports.createElement(OverrideProvider, {
    selectable: void 0
  }, Vt));
  const Qt = () => /* @__PURE__ */ reactExports.createElement(FilterDropdownMenuWrapper$1, {
    className: `${_e}-dropdown`
  }, Vt);
  let qt;
  typeof tt.filterIcon == "function" ? qt = tt.filterIcon(bt) : tt.filterIcon ? qt = tt.filterIcon : qt = /* @__PURE__ */ reactExports.createElement(FilterFilled$1, null);
  const {
    direction: Zt
  } = reactExports.useContext(ConfigContext$1);
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: `${_e}-column`
  }, /* @__PURE__ */ reactExports.createElement("span", {
    className: `${_}-column-title`
  }, ut), /* @__PURE__ */ reactExports.createElement(Dropdown$1, {
    dropdownRender: Qt,
    trigger: ["click"],
    open: St,
    onOpenChange: Lt,
    getPopupContainer: ft,
    placement: Zt === "rtl" ? "bottomLeft" : "bottomRight",
    rootClassName: ht
  }, /* @__PURE__ */ reactExports.createElement("span", {
    role: "button",
    tabIndex: -1,
    className: classnames(`${_e}-trigger`, {
      active: bt
    }),
    onClick: (ar) => {
      ar.stopPropagation();
    }
  }, qt)));
}
function collectFilterStates(a, s, $) {
  let _ = [];
  return (a || []).forEach((_e, tt) => {
    var nt;
    const at = getColumnPos(tt, $);
    if (_e.filters || "filterDropdown" in _e || "onFilter" in _e)
      if ("filteredValue" in _e) {
        let ot = _e.filteredValue;
        "filterDropdown" in _e || (ot = (nt = ot == null ? void 0 : ot.map(String)) !== null && nt !== void 0 ? nt : ot), _.push({
          column: _e,
          key: getColumnKey(_e, at),
          filteredKeys: ot,
          forceFiltered: _e.filtered
        });
      } else
        _.push({
          column: _e,
          key: getColumnKey(_e, at),
          filteredKeys: s && _e.defaultFilteredValue ? _e.defaultFilteredValue : void 0,
          forceFiltered: _e.filtered
        });
    "children" in _e && (_ = [].concat(_toConsumableArray$d(_), _toConsumableArray$d(collectFilterStates(_e.children, s, at))));
  }), _;
}
function injectFilter(a, s, $, _, _e, tt, nt, at, ot) {
  return $.map((rt, st) => {
    const lt = getColumnPos(st, at), {
      filterMultiple: et = !0,
      filterMode: it,
      filterSearch: ut
    } = rt;
    let ft = rt;
    if (ft.filters || ft.filterDropdown) {
      const ht = getColumnKey(ft, lt), dt = _.find((gt) => {
        let {
          key: pt
        } = gt;
        return ht === pt;
      });
      ft = Object.assign(Object.assign({}, ft), {
        title: (gt) => /* @__PURE__ */ reactExports.createElement(FilterDropdown, {
          tablePrefixCls: a,
          prefixCls: `${a}-filter`,
          dropdownPrefixCls: s,
          column: ft,
          columnKey: ht,
          filterState: dt,
          filterMultiple: et,
          filterMode: it,
          filterSearch: ut,
          triggerFilter: tt,
          locale: _e,
          getPopupContainer: nt,
          rootClassName: ot
        }, renderColumnTitle(rt.title, gt))
      });
    }
    return "children" in ft && (ft = Object.assign(Object.assign({}, ft), {
      children: injectFilter(a, s, ft.children, _, _e, tt, nt, lt, ot)
    })), ft;
  });
}
function generateFilterInfo(a) {
  const s = {};
  return a.forEach(($) => {
    let {
      key: _,
      filteredKeys: _e,
      column: tt
    } = $;
    const nt = _, {
      filters: at,
      filterDropdown: ot
    } = tt;
    if (ot)
      s[nt] = _e || null;
    else if (Array.isArray(_e)) {
      const rt = flattenKeys(at);
      s[nt] = rt.filter((st) => _e.includes(String(st)));
    } else
      s[nt] = null;
  }), s;
}
function getFilterData(a, s) {
  return s.reduce(($, _) => {
    const {
      column: {
        onFilter: _e,
        filters: tt
      },
      filteredKeys: nt
    } = _;
    return _e && nt && nt.length ? $.filter((at) => nt.some((ot) => {
      const rt = flattenKeys(tt), st = rt.findIndex((et) => String(et) === String(ot)), lt = st !== -1 ? rt[st] : ot;
      return _e(lt, at);
    })) : $;
  }, a);
}
const getMergedColumns = (a) => a.flatMap((s) => "children" in s ? [s].concat(_toConsumableArray$d(getMergedColumns(s.children || []))) : [s]);
function useFilter(a) {
  let {
    prefixCls: s,
    dropdownPrefixCls: $,
    mergedColumns: _,
    onFilterChange: _e,
    getPopupContainer: tt,
    locale: nt,
    rootClassName: at
  } = a;
  devUseWarning();
  const ot = reactExports.useMemo(() => getMergedColumns(_ || []), [_]), [rt, st] = reactExports.useState(() => collectFilterStates(ot, !0)), lt = reactExports.useMemo(() => {
    const ft = collectFilterStates(ot, !1);
    if (ft.length === 0)
      return ft;
    let ht = !0;
    if (ft.forEach((dt) => {
      let {
        filteredKeys: gt
      } = dt;
      gt !== void 0 && (ht = !1);
    }), ht) {
      const dt = (ot || []).map((gt, pt) => getColumnKey(gt, getColumnPos(pt)));
      return rt.filter((gt) => {
        let {
          key: pt
        } = gt;
        return dt.includes(pt);
      }).map((gt) => {
        const pt = ot[dt.findIndex((mt) => mt === gt.key)];
        return Object.assign(Object.assign({}, gt), {
          column: Object.assign(Object.assign({}, gt.column), pt),
          forceFiltered: pt.filtered
        });
      });
    }
    return ft;
  }, [ot, rt]), et = reactExports.useMemo(() => generateFilterInfo(lt), [lt]), it = (ft) => {
    const ht = lt.filter((dt) => {
      let {
        key: gt
      } = dt;
      return gt !== ft.key;
    });
    ht.push(ft), st(ht), _e(generateFilterInfo(ht), ht);
  };
  return [(ft) => injectFilter(s, $, ft, lt, nt, it, tt, void 0, at), lt, et];
}
function useLazyKVMap(a, s, $) {
  const _ = reactExports.useRef({});
  function _e(tt) {
    if (!_.current || _.current.data !== a || _.current.childrenColumnName !== s || _.current.getRowKey !== $) {
      let at = function(ot) {
        ot.forEach((rt, st) => {
          const lt = $(rt, st);
          nt.set(lt, rt), rt && typeof rt == "object" && s in rt && at(rt[s] || []);
        });
      };
      const nt = /* @__PURE__ */ new Map();
      at(a), _.current = {
        data: a,
        childrenColumnName: s,
        kvMap: nt,
        getRowKey: $
      };
    }
    return _.current.kvMap.get(tt);
  }
  return [_e];
}
var __rest$c = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const DEFAULT_PAGE_SIZE = 10;
function getPaginationParam(a, s) {
  const $ = {
    current: a.current,
    pageSize: a.pageSize
  };
  return Object.keys(s && typeof s == "object" ? s : {}).forEach((_e) => {
    const tt = a[_e];
    typeof tt != "function" && ($[_e] = tt);
  }), $;
}
function usePagination(a, s, $) {
  const _ = $ && typeof $ == "object" ? $ : {}, {
    total: _e = 0
  } = _, tt = __rest$c(_, ["total"]), [nt, at] = reactExports.useState(() => ({
    current: "defaultCurrent" in tt ? tt.defaultCurrent : 1,
    pageSize: "defaultPageSize" in tt ? tt.defaultPageSize : DEFAULT_PAGE_SIZE
  })), ot = extendsObject$1(nt, tt, {
    total: _e > 0 ? _e : a
  }), rt = Math.ceil((_e || a) / ot.pageSize);
  ot.current > rt && (ot.current = rt || 1);
  const st = (et, it) => {
    at({
      current: et ?? 1,
      pageSize: it || ot.pageSize
    });
  }, lt = (et, it) => {
    var ut;
    $ && ((ut = $.onChange) === null || ut === void 0 || ut.call($, et, it)), st(et, it), s(et, it || (ot == null ? void 0 : ot.pageSize));
  };
  return $ === !1 ? [{}, () => {
  }] : [Object.assign(Object.assign({}, ot), {
    onChange: lt
  }), st];
}
var CaretDownOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" } }] }, name: "caret-down", theme: "outlined" };
const CaretDownOutlinedSvg = CaretDownOutlined$2;
var CaretDownOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: CaretDownOutlinedSvg
  }));
};
const CaretDownOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(CaretDownOutlined);
var CaretUpOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" } }] }, name: "caret-up", theme: "outlined" };
const CaretUpOutlinedSvg = CaretUpOutlined$2;
var CaretUpOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: CaretUpOutlinedSvg
  }));
};
const CaretUpOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(CaretUpOutlined), ASCEND = "ascend", DESCEND = "descend";
function getMultiplePriority(a) {
  return typeof a.sorter == "object" && typeof a.sorter.multiple == "number" ? a.sorter.multiple : !1;
}
function getSortFunction(a) {
  return typeof a == "function" ? a : a && typeof a == "object" && a.compare ? a.compare : !1;
}
function nextSortDirection(a, s) {
  return s ? a[a.indexOf(s) + 1] : a[0];
}
function collectSortStates(a, s, $) {
  let _ = [];
  function _e(tt, nt) {
    _.push({
      column: tt,
      key: getColumnKey(tt, nt),
      multiplePriority: getMultiplePriority(tt),
      sortOrder: tt.sortOrder
    });
  }
  return (a || []).forEach((tt, nt) => {
    const at = getColumnPos(nt, $);
    tt.children ? ("sortOrder" in tt && _e(tt, at), _ = [].concat(_toConsumableArray$d(_), _toConsumableArray$d(collectSortStates(tt.children, s, at)))) : tt.sorter && ("sortOrder" in tt ? _e(tt, at) : s && tt.defaultSortOrder && _.push({
      column: tt,
      key: getColumnKey(tt, at),
      multiplePriority: getMultiplePriority(tt),
      sortOrder: tt.defaultSortOrder
    }));
  }), _;
}
function injectSorter(a, s, $, _, _e, tt, nt, at) {
  return (s || []).map((ot, rt) => {
    const st = getColumnPos(rt, at);
    let lt = ot;
    if (lt.sorter) {
      const et = lt.sortDirections || _e, it = lt.showSorterTooltip === void 0 ? nt : lt.showSorterTooltip, ut = getColumnKey(lt, st), ft = $.find((xt) => {
        let {
          key: bt
        } = xt;
        return bt === ut;
      }), ht = ft ? ft.sortOrder : null, dt = nextSortDirection(et, ht);
      let gt;
      if (ot.sortIcon)
        gt = ot.sortIcon({
          sortOrder: ht
        });
      else {
        const xt = et.includes(ASCEND) && /* @__PURE__ */ reactExports.createElement(CaretUpOutlined$1, {
          className: classnames(`${a}-column-sorter-up`, {
            active: ht === ASCEND
          })
        }), bt = et.includes(DESCEND) && /* @__PURE__ */ reactExports.createElement(CaretDownOutlined$1, {
          className: classnames(`${a}-column-sorter-down`, {
            active: ht === DESCEND
          })
        });
        gt = /* @__PURE__ */ reactExports.createElement("span", {
          className: classnames(`${a}-column-sorter`, {
            [`${a}-column-sorter-full`]: !!(xt && bt)
          })
        }, /* @__PURE__ */ reactExports.createElement("span", {
          className: `${a}-column-sorter-inner`,
          "aria-hidden": "true"
        }, xt, bt));
      }
      const {
        cancelSort: pt,
        triggerAsc: mt,
        triggerDesc: ct
      } = tt || {};
      let vt = pt;
      dt === DESCEND ? vt = ct : dt === ASCEND && (vt = mt);
      const At = typeof it == "object" ? Object.assign({
        title: vt
      }, it) : {
        title: vt
      };
      lt = Object.assign(Object.assign({}, lt), {
        className: classnames(lt.className, {
          [`${a}-column-sort`]: ht
        }),
        title: (xt) => {
          const bt = /* @__PURE__ */ reactExports.createElement("div", {
            className: `${a}-column-sorters`
          }, /* @__PURE__ */ reactExports.createElement("span", {
            className: `${a}-column-title`
          }, renderColumnTitle(ot.title, xt)), gt);
          return it ? /* @__PURE__ */ reactExports.createElement(_Tooltip, Object.assign({}, At), bt) : bt;
        },
        onHeaderCell: (xt) => {
          const bt = ot.onHeaderCell && ot.onHeaderCell(xt) || {}, Et = bt.onClick, St = bt.onKeyDown;
          bt.onClick = (Pt) => {
            _({
              column: ot,
              key: ut,
              sortOrder: dt,
              multiplePriority: getMultiplePriority(ot)
            }), Et == null || Et(Pt);
          }, bt.onKeyDown = (Pt) => {
            Pt.keyCode === KeyCode.ENTER && (_({
              column: ot,
              key: ut,
              sortOrder: dt,
              multiplePriority: getMultiplePriority(ot)
            }), St == null || St(Pt));
          };
          const Bt = safeColumnTitle(ot.title, {}), Ot = Bt == null ? void 0 : Bt.toString();
          return ht ? bt["aria-sort"] = ht === "ascend" ? "ascending" : "descending" : bt["aria-label"] = Ot || "", bt.className = classnames(bt.className, `${a}-column-has-sorters`), bt.tabIndex = 0, ot.ellipsis && (bt.title = (Bt ?? "").toString()), bt;
        }
      });
    }
    return "children" in lt && (lt = Object.assign(Object.assign({}, lt), {
      children: injectSorter(a, lt.children, $, _, _e, tt, nt, st)
    })), lt;
  });
}
function stateToInfo(a) {
  const {
    column: s,
    sortOrder: $
  } = a;
  return {
    column: s,
    order: $,
    field: s.dataIndex,
    columnKey: s.key
  };
}
function generateSorterInfo(a) {
  const s = a.filter(($) => {
    let {
      sortOrder: _
    } = $;
    return _;
  }).map(stateToInfo);
  return s.length === 0 && a.length ? Object.assign(Object.assign({}, stateToInfo(a[a.length - 1])), {
    column: void 0
  }) : s.length <= 1 ? s[0] || {} : s;
}
function getSortData(a, s, $) {
  const _ = s.slice().sort((nt, at) => at.multiplePriority - nt.multiplePriority), _e = a.slice(), tt = _.filter((nt) => {
    let {
      column: {
        sorter: at
      },
      sortOrder: ot
    } = nt;
    return getSortFunction(at) && ot;
  });
  return tt.length ? _e.sort((nt, at) => {
    for (let ot = 0; ot < tt.length; ot += 1) {
      const rt = tt[ot], {
        column: {
          sorter: st
        },
        sortOrder: lt
      } = rt, et = getSortFunction(st);
      if (et && lt) {
        const it = et(nt, at, lt);
        if (it !== 0)
          return lt === ASCEND ? it : -it;
      }
    }
    return 0;
  }).map((nt) => {
    const at = nt[$];
    return at ? Object.assign(Object.assign({}, nt), {
      [$]: getSortData(at, s, $)
    }) : nt;
  }) : _e;
}
function useFilterSorter(a) {
  let {
    prefixCls: s,
    mergedColumns: $,
    onSorterChange: _,
    sortDirections: _e,
    tableLocale: tt,
    showSorterTooltip: nt
  } = a;
  const [at, ot] = reactExports.useState(collectSortStates($, !0)), rt = reactExports.useMemo(() => {
    let ut = !0;
    const ft = collectSortStates($, !1);
    if (!ft.length)
      return at;
    const ht = [];
    function dt(pt) {
      ut ? ht.push(pt) : ht.push(Object.assign(Object.assign({}, pt), {
        sortOrder: null
      }));
    }
    let gt = null;
    return ft.forEach((pt) => {
      gt === null ? (dt(pt), pt.sortOrder && (pt.multiplePriority === !1 ? ut = !1 : gt = !0)) : (gt && pt.multiplePriority !== !1 || (ut = !1), dt(pt));
    }), ht;
  }, [$, at]), st = reactExports.useMemo(() => {
    const ut = rt.map((ft) => {
      let {
        column: ht,
        sortOrder: dt
      } = ft;
      return {
        column: ht,
        order: dt
      };
    });
    return {
      sortColumns: ut,
      // Legacy
      sortColumn: ut[0] && ut[0].column,
      sortOrder: ut[0] && ut[0].order
    };
  }, [rt]);
  function lt(ut) {
    let ft;
    ut.multiplePriority === !1 || !rt.length || rt[0].multiplePriority === !1 ? ft = [ut] : ft = [].concat(_toConsumableArray$d(rt.filter((ht) => {
      let {
        key: dt
      } = ht;
      return dt !== ut.key;
    })), [ut]), ot(ft), _(generateSorterInfo(ft), ft);
  }
  return [(ut) => injectSorter(s, ut, rt, lt, _e, tt, nt), rt, st, () => generateSorterInfo(rt)];
}
function fillTitle(a, s) {
  return a.map(($) => {
    const _ = Object.assign({}, $);
    return _.title = renderColumnTitle($.title, s), "children" in _ && (_.children = fillTitle(_.children, s)), _;
  });
}
function useTitleColumns(a) {
  return [reactExports.useCallback(($) => fillTitle($, a), [a])];
}
const RcTable = genTable((a, s) => {
  const {
    _renderTimes: $
  } = a, {
    _renderTimes: _
  } = s;
  return $ !== _;
}), RcVirtualTable = genVirtualTable((a, s) => {
  const {
    _renderTimes: $
  } = a, {
    _renderTimes: _
  } = s;
  return $ !== _;
}), genBorderedStyle = (a) => {
  const {
    componentCls: s,
    lineWidth: $,
    lineType: _,
    tableBorderColor: _e,
    tableHeaderBg: tt,
    tablePaddingVertical: nt,
    tablePaddingHorizontal: at,
    calc: ot
  } = a, rt = `${unit$1($)} ${_} ${_e}`, st = (lt, et, it) => ({
    [`&${s}-${lt}`]: {
      [`> ${s}-container`]: {
        [`> ${s}-content, > ${s}-body`]: {
          "\n            > table > tbody > tr > th,\n            > table > tbody > tr > td\n          ": {
            [`> ${s}-expanded-row-fixed`]: {
              margin: `${unit$1(ot(et).mul(-1).equal())}
              ${unit$1(ot(ot(it).add($)).mul(-1).equal())}`
            }
          }
        }
      }
    }
  });
  return {
    [`${s}-wrapper`]: {
      [`${s}${s}-bordered`]: Object.assign(Object.assign(Object.assign({
        // ============================ Title =============================
        [`> ${s}-title`]: {
          border: rt,
          borderBottom: 0
        },
        // ============================ Content ============================
        [`> ${s}-container`]: {
          borderInlineStart: rt,
          borderTop: rt,
          [`
            > ${s}-content,
            > ${s}-header,
            > ${s}-body,
            > ${s}-summary
          `]: {
            "> table": {
              // ============================= Cell =============================
              "\n                > thead > tr > th,\n                > thead > tr > td,\n                > tbody > tr > th,\n                > tbody > tr > td,\n                > tfoot > tr > th,\n                > tfoot > tr > td\n              ": {
                borderInlineEnd: rt
              },
              // ============================ Header ============================
              "> thead": {
                "> tr:not(:last-child) > th": {
                  borderBottom: rt
                },
                "> tr > th::before": {
                  backgroundColor: "transparent !important"
                }
              },
              // Fixed right should provides additional border
              "\n                > thead > tr,\n                > tbody > tr,\n                > tfoot > tr\n              ": {
                [`> ${s}-cell-fix-right-first::after`]: {
                  borderInlineEnd: rt
                }
              },
              // ========================== Expandable ==========================
              "\n                > tbody > tr > th,\n                > tbody > tr > td\n              ": {
                [`> ${s}-expanded-row-fixed`]: {
                  margin: `${unit$1(ot(nt).mul(-1).equal())} ${unit$1(ot(ot(at).add($)).mul(-1).equal())}`,
                  "&::after": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: $,
                    bottom: 0,
                    borderInlineEnd: rt,
                    content: '""'
                  }
                }
              }
            }
          }
        },
        // ============================ Scroll ============================
        [`&${s}-scroll-horizontal`]: {
          [`> ${s}-container > ${s}-body`]: {
            "> table > tbody": {
              [`
                > tr${s}-expanded-row,
                > tr${s}-placeholder
              `]: {
                "> th, > td": {
                  borderInlineEnd: 0
                }
              }
            }
          }
        }
      }, st("middle", a.tablePaddingVerticalMiddle, a.tablePaddingHorizontalMiddle)), st("small", a.tablePaddingVerticalSmall, a.tablePaddingHorizontalSmall)), {
        // ============================ Footer ============================
        [`> ${s}-footer`]: {
          border: rt,
          borderTop: 0
        }
      }),
      // ============================ Nested ============================
      [`${s}-cell`]: {
        [`${s}-container:first-child`]: {
          // :first-child to avoid the case when bordered and title is set
          borderTop: 0
        },
        // https://github.com/ant-design/ant-design/issues/35577
        "&-scrollbar:not([rowspan])": {
          boxShadow: `0 ${unit$1($)} 0 ${unit$1($)} ${tt}`
        }
      },
      [`${s}-bordered ${s}-cell-scrollbar`]: {
        borderInlineEnd: rt
      }
    }
  };
}, genBorderedStyle$1 = genBorderedStyle, genEllipsisStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-wrapper`]: {
      [`${s}-cell-ellipsis`]: Object.assign(Object.assign({}, textEllipsis), {
        wordBreak: "keep-all",
        // Fixed first or last should special process
        [`
          &${s}-cell-fix-left-last,
          &${s}-cell-fix-right-first
        `]: {
          overflow: "visible",
          [`${s}-cell-content`]: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        },
        [`${s}-column-title`]: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "keep-all"
        }
      })
    }
  };
}, genEllipsisStyle$1 = genEllipsisStyle, genEmptyStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-wrapper`]: {
      [`${s}-tbody > tr${s}-placeholder`]: {
        textAlign: "center",
        color: a.colorTextDisabled,
        "\n          &:hover > th,\n          &:hover > td,\n        ": {
          background: a.colorBgContainer
        }
      }
    }
  };
}, genEmptyStyle$1 = genEmptyStyle, genExpandStyle = (a) => {
  const {
    componentCls: s,
    antCls: $,
    motionDurationSlow: _,
    lineWidth: _e,
    paddingXS: tt,
    lineType: nt,
    tableBorderColor: at,
    tableExpandIconBg: ot,
    tableExpandColumnWidth: rt,
    borderRadius: st,
    tablePaddingVertical: lt,
    tablePaddingHorizontal: et,
    tableExpandedRowBg: it,
    paddingXXS: ut,
    expandIconMarginTop: ft,
    expandIconSize: ht,
    expandIconHalfInner: dt,
    expandIconScale: gt,
    calc: pt
  } = a, mt = `${unit$1(_e)} ${nt} ${at}`, ct = pt(ut).sub(_e).equal();
  return {
    [`${s}-wrapper`]: {
      [`${s}-expand-icon-col`]: {
        width: rt
      },
      [`${s}-row-expand-icon-cell`]: {
        textAlign: "center",
        [`${s}-row-expand-icon`]: {
          display: "inline-flex",
          float: "none",
          verticalAlign: "sub"
        }
      },
      [`${s}-row-indent`]: {
        height: 1,
        float: "left"
      },
      [`${s}-row-expand-icon`]: Object.assign(Object.assign({}, operationUnit(a)), {
        position: "relative",
        float: "left",
        boxSizing: "border-box",
        width: ht,
        height: ht,
        padding: 0,
        color: "inherit",
        lineHeight: unit$1(ht),
        background: ot,
        border: mt,
        borderRadius: st,
        transform: `scale(${gt})`,
        transition: `all ${_}`,
        userSelect: "none",
        "&:focus, &:hover, &:active": {
          borderColor: "currentcolor"
        },
        "&::before, &::after": {
          position: "absolute",
          background: "currentcolor",
          transition: `transform ${_} ease-out`,
          content: '""'
        },
        "&::before": {
          top: dt,
          insetInlineEnd: ct,
          insetInlineStart: ct,
          height: _e
        },
        "&::after": {
          top: ct,
          bottom: ct,
          insetInlineStart: dt,
          width: _e,
          transform: "rotate(90deg)"
        },
        // Motion effect
        "&-collapsed::before": {
          transform: "rotate(-180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        },
        "&-spaced": {
          "&::before, &::after": {
            display: "none",
            content: "none"
          },
          background: "transparent",
          border: 0,
          visibility: "hidden"
        }
      }),
      [`${s}-row-indent + ${s}-row-expand-icon`]: {
        marginTop: ft,
        marginInlineEnd: tt
      },
      [`tr${s}-expanded-row`]: {
        "&, &:hover": {
          "> th, > td": {
            background: it
          }
        },
        // https://github.com/ant-design/ant-design/issues/25573
        [`${$}-descriptions-view`]: {
          display: "flex",
          table: {
            flex: "auto",
            width: "auto"
          }
        }
      },
      // With fixed
      [`${s}-expanded-row-fixed`]: {
        position: "relative",
        margin: `${unit$1(pt(lt).mul(-1).equal())} ${unit$1(pt(et).mul(-1).equal())}`,
        padding: `${unit$1(lt)} ${unit$1(et)}`
      }
    }
  };
}, genExpandStyle$1 = genExpandStyle, genFilterStyle = (a) => {
  const {
    componentCls: s,
    antCls: $,
    iconCls: _,
    tableFilterDropdownWidth: _e,
    tableFilterDropdownSearchWidth: tt,
    paddingXXS: nt,
    paddingXS: at,
    colorText: ot,
    lineWidth: rt,
    lineType: st,
    tableBorderColor: lt,
    headerIconColor: et,
    fontSizeSM: it,
    tablePaddingHorizontal: ut,
    borderRadius: ft,
    motionDurationSlow: ht,
    colorTextDescription: dt,
    colorPrimary: gt,
    tableHeaderFilterActiveBg: pt,
    colorTextDisabled: mt,
    tableFilterDropdownBg: ct,
    tableFilterDropdownHeight: vt,
    controlItemBgHover: At,
    controlItemBgActive: xt,
    boxShadowSecondary: bt,
    filterDropdownMenuBg: Et,
    calc: St
  } = a, Bt = `${$}-dropdown`, Ot = `${s}-filter-dropdown`, Pt = `${$}-tree`, wt = `${unit$1(rt)} ${st} ${lt}`;
  return [
    {
      [`${s}-wrapper`]: {
        [`${s}-filter-column`]: {
          display: "flex",
          justifyContent: "space-between"
        },
        [`${s}-filter-trigger`]: {
          position: "relative",
          display: "flex",
          alignItems: "center",
          marginBlock: St(nt).mul(-1).equal(),
          marginInline: `${unit$1(nt)} ${unit$1(St(ut).div(2).mul(-1).equal())}`,
          padding: `0 ${unit$1(nt)}`,
          color: et,
          fontSize: it,
          borderRadius: ft,
          cursor: "pointer",
          transition: `all ${ht}`,
          "&:hover": {
            color: dt,
            background: pt
          },
          "&.active": {
            color: gt
          }
        }
      }
    },
    {
      // Dropdown
      [`${$}-dropdown`]: {
        [Ot]: Object.assign(Object.assign({}, resetComponent(a)), {
          minWidth: _e,
          backgroundColor: ct,
          borderRadius: ft,
          boxShadow: bt,
          overflow: "hidden",
          // Reset menu
          [`${Bt}-menu`]: {
            // https://github.com/ant-design/ant-design/issues/4916
            // https://github.com/ant-design/ant-design/issues/19542
            maxHeight: vt,
            overflowX: "hidden",
            border: 0,
            boxShadow: "none",
            borderRadius: "unset",
            backgroundColor: Et,
            "&:empty::after": {
              display: "block",
              padding: `${unit$1(at)} 0`,
              color: mt,
              fontSize: it,
              textAlign: "center",
              content: '"Not Found"'
            }
          },
          [`${Ot}-tree`]: {
            paddingBlock: `${unit$1(at)} 0`,
            paddingInline: at,
            [Pt]: {
              padding: 0
            },
            [`${Pt}-treenode ${Pt}-node-content-wrapper:hover`]: {
              backgroundColor: At
            },
            [`${Pt}-treenode-checkbox-checked ${Pt}-node-content-wrapper`]: {
              "&, &:hover": {
                backgroundColor: xt
              }
            }
          },
          [`${Ot}-search`]: {
            padding: at,
            borderBottom: wt,
            "&-input": {
              input: {
                minWidth: tt
              },
              [_]: {
                color: mt
              }
            }
          },
          [`${Ot}-checkall`]: {
            width: "100%",
            marginBottom: nt,
            marginInlineStart: nt
          },
          // Operation
          [`${Ot}-btns`]: {
            display: "flex",
            justifyContent: "space-between",
            padding: `${unit$1(St(at).sub(rt).equal())} ${unit$1(at)}`,
            overflow: "hidden",
            borderTop: wt
          }
        })
      }
    },
    // Dropdown Menu & SubMenu
    {
      // submenu of table filter dropdown
      [`${$}-dropdown ${Ot}, ${Ot}-submenu`]: {
        // Checkbox
        [`${$}-checkbox-wrapper + span`]: {
          paddingInlineStart: at,
          color: ot
        },
        "> ul": {
          maxHeight: "calc(100vh - 130px)",
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    }
  ];
}, genFilterStyle$1 = genFilterStyle, genFixedStyle = (a) => {
  const {
    componentCls: s,
    lineWidth: $,
    colorSplit: _,
    motionDurationSlow: _e,
    zIndexTableFixed: tt,
    tableBg: nt,
    zIndexTableSticky: at,
    calc: ot
  } = a, rt = _;
  return {
    [`${s}-wrapper`]: {
      [`
        ${s}-cell-fix-left,
        ${s}-cell-fix-right
      `]: {
        position: "sticky !important",
        zIndex: tt,
        background: nt
      },
      [`
        ${s}-cell-fix-left-first::after,
        ${s}-cell-fix-left-last::after
      `]: {
        position: "absolute",
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: ot($).mul(-1).equal(),
        width: 30,
        transform: "translateX(100%)",
        transition: `box-shadow ${_e}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${s}-cell-fix-left-all::after`]: {
        display: "none"
      },
      [`
        ${s}-cell-fix-right-first::after,
        ${s}-cell-fix-right-last::after
      `]: {
        position: "absolute",
        top: 0,
        bottom: ot($).mul(-1).equal(),
        left: {
          _skip_check_: !0,
          value: 0
        },
        width: 30,
        transform: "translateX(-100%)",
        transition: `box-shadow ${_e}`,
        content: '""',
        pointerEvents: "none"
      },
      [`${s}-container`]: {
        "&::before, &::after": {
          position: "absolute",
          top: 0,
          bottom: 0,
          zIndex: ot(at).add(1).equal({
            unit: !1
          }),
          width: 30,
          transition: `box-shadow ${_e}`,
          content: '""',
          pointerEvents: "none"
        },
        "&::before": {
          insetInlineStart: 0
        },
        "&::after": {
          insetInlineEnd: 0
        }
      },
      [`${s}-ping-left`]: {
        [`&:not(${s}-has-fix-left) ${s}-container`]: {
          position: "relative",
          "&::before": {
            boxShadow: `inset 10px 0 8px -8px ${rt}`
          }
        },
        [`
          ${s}-cell-fix-left-first::after,
          ${s}-cell-fix-left-last::after
        `]: {
          boxShadow: `inset 10px 0 8px -8px ${rt}`
        },
        [`${s}-cell-fix-left-last::before`]: {
          backgroundColor: "transparent !important"
        }
      },
      [`${s}-ping-right`]: {
        [`&:not(${s}-has-fix-right) ${s}-container`]: {
          position: "relative",
          "&::after": {
            boxShadow: `inset -10px 0 8px -8px ${rt}`
          }
        },
        [`
          ${s}-cell-fix-right-first::after,
          ${s}-cell-fix-right-last::after
        `]: {
          boxShadow: `inset -10px 0 8px -8px ${rt}`
        }
      }
    }
  };
}, genFixedStyle$1 = genFixedStyle, genPaginationStyle = (a) => {
  const {
    componentCls: s,
    antCls: $,
    margin: _
  } = a;
  return {
    [`${s}-wrapper`]: {
      // ========================== Pagination ==========================
      [`${s}-pagination${$}-pagination`]: {
        margin: `${unit$1(_)} 0`
      },
      [`${s}-pagination`]: {
        display: "flex",
        flexWrap: "wrap",
        rowGap: a.paddingXS,
        "> *": {
          flex: "none"
        },
        "&-left": {
          justifyContent: "flex-start"
        },
        "&-center": {
          justifyContent: "center"
        },
        "&-right": {
          justifyContent: "flex-end"
        }
      }
    }
  };
}, genPaginationStyle$1 = genPaginationStyle, genRadiusStyle = (a) => {
  const {
    componentCls: s,
    tableRadius: $
  } = a;
  return {
    [`${s}-wrapper`]: {
      [s]: {
        // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
        [`${s}-title, ${s}-header`]: {
          borderRadius: `${unit$1($)} ${unit$1($)} 0 0`
        },
        [`${s}-title + ${s}-container`]: {
          borderStartStartRadius: 0,
          borderStartEndRadius: 0,
          // https://github.com/ant-design/ant-design/issues/41975
          [`${s}-header, table`]: {
            borderRadius: 0
          },
          "table > thead > tr:first-child": {
            "th:first-child, th:last-child, td:first-child, td:last-child": {
              borderRadius: 0
            }
          }
        },
        "&-container": {
          borderStartStartRadius: $,
          borderStartEndRadius: $,
          "table > thead > tr:first-child": {
            "> *:first-child": {
              borderStartStartRadius: $
            },
            "> *:last-child": {
              borderStartEndRadius: $
            }
          }
        },
        "&-footer": {
          borderRadius: `0 0 ${unit$1($)} ${unit$1($)}`
        }
      }
    }
  };
}, genRadiusStyle$1 = genRadiusStyle, genStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-wrapper-rtl`]: {
      direction: "rtl",
      table: {
        direction: "rtl"
      },
      [`${s}-pagination-left`]: {
        justifyContent: "flex-end"
      },
      [`${s}-pagination-right`]: {
        justifyContent: "flex-start"
      },
      [`${s}-row-expand-icon`]: {
        float: "right",
        "&::after": {
          transform: "rotate(-90deg)"
        },
        "&-collapsed::before": {
          transform: "rotate(180deg)"
        },
        "&-collapsed::after": {
          transform: "rotate(0deg)"
        }
      },
      [`${s}-container`]: {
        "&::before": {
          insetInlineStart: "unset",
          insetInlineEnd: 0
        },
        "&::after": {
          insetInlineStart: 0,
          insetInlineEnd: "unset"
        },
        [`${s}-row-indent`]: {
          float: "right"
        }
      }
    }
  };
}, genRtlStyle$2 = genStyle, genSelectionStyle = (a) => {
  const {
    componentCls: s,
    antCls: $,
    iconCls: _,
    fontSizeIcon: _e,
    padding: tt,
    paddingXS: nt,
    headerIconColor: at,
    headerIconHoverColor: ot,
    tableSelectionColumnWidth: rt,
    tableSelectedRowBg: st,
    tableSelectedRowHoverBg: lt,
    tableRowHoverBg: et,
    tablePaddingHorizontal: it,
    calc: ut
  } = a;
  return {
    [`${s}-wrapper`]: {
      // ========================== Selections ==========================
      [`${s}-selection-col`]: {
        width: rt,
        [`&${s}-selection-col-with-dropdown`]: {
          width: ut(rt).add(_e).add(ut(tt).div(4)).equal()
        }
      },
      [`${s}-bordered ${s}-selection-col`]: {
        width: ut(rt).add(ut(nt).mul(2)).equal(),
        [`&${s}-selection-col-with-dropdown`]: {
          width: ut(rt).add(_e).add(ut(tt).div(4)).add(ut(nt).mul(2)).equal()
        }
      },
      [`
        table tr th${s}-selection-column,
        table tr td${s}-selection-column,
        ${s}-selection-column
      `]: {
        paddingInlineEnd: a.paddingXS,
        paddingInlineStart: a.paddingXS,
        textAlign: "center",
        [`${$}-radio-wrapper`]: {
          marginInlineEnd: 0
        }
      },
      [`table tr th${s}-selection-column${s}-cell-fix-left`]: {
        zIndex: a.zIndexTableFixed + 1
      },
      [`table tr th${s}-selection-column::after`]: {
        backgroundColor: "transparent !important"
      },
      [`${s}-selection`]: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column"
      },
      [`${s}-selection-extra`]: {
        position: "absolute",
        top: 0,
        zIndex: 1,
        cursor: "pointer",
        transition: `all ${a.motionDurationSlow}`,
        marginInlineStart: "100%",
        paddingInlineStart: unit$1(ut(it).div(4).equal()),
        [_]: {
          color: at,
          fontSize: _e,
          verticalAlign: "baseline",
          "&:hover": {
            color: ot
          }
        }
      },
      // ============================= Rows =============================
      [`${s}-tbody`]: {
        [`${s}-row`]: {
          [`&${s}-row-selected`]: {
            [`> ${s}-cell`]: {
              background: st,
              "&-row-hover": {
                background: lt
              }
            }
          },
          [`> ${s}-cell-row-hover`]: {
            background: et
          }
        }
      }
    }
  };
}, genSelectionStyle$1 = genSelectionStyle, genSizeStyle = (a) => {
  const {
    componentCls: s,
    tableExpandColumnWidth: $,
    calc: _
  } = a, _e = (tt, nt, at, ot) => ({
    [`${s}${s}-${tt}`]: {
      fontSize: ot,
      [`
        ${s}-title,
        ${s}-footer,
        ${s}-cell,
        ${s}-thead > tr > th,
        ${s}-tbody > tr > th,
        ${s}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
        padding: `${unit$1(nt)} ${unit$1(at)}`
      },
      [`${s}-filter-trigger`]: {
        marginInlineEnd: unit$1(_(at).div(2).mul(-1).equal())
      },
      [`${s}-expanded-row-fixed`]: {
        margin: `${unit$1(_(nt).mul(-1).equal())} ${unit$1(_(at).mul(-1).equal())}`
      },
      [`${s}-tbody`]: {
        // ========================= Nest Table ===========================
        [`${s}-wrapper:only-child ${s}`]: {
          marginBlock: unit$1(_(nt).mul(-1).equal()),
          marginInline: `${unit$1(_($).sub(at).equal())} ${unit$1(_(at).mul(-1).equal())}`
        }
      },
      // https://github.com/ant-design/ant-design/issues/35167
      [`${s}-selection-extra`]: {
        paddingInlineStart: unit$1(_(at).div(4).equal())
      }
    }
  });
  return {
    [`${s}-wrapper`]: Object.assign(Object.assign({}, _e("middle", a.tablePaddingVerticalMiddle, a.tablePaddingHorizontalMiddle, a.tableFontSizeMiddle)), _e("small", a.tablePaddingVerticalSmall, a.tablePaddingHorizontalSmall, a.tableFontSizeSmall))
  };
}, genSizeStyle$1 = genSizeStyle, genSorterStyle = (a) => {
  const {
    componentCls: s,
    marginXXS: $,
    fontSizeIcon: _,
    headerIconColor: _e,
    headerIconHoverColor: tt
  } = a;
  return {
    [`${s}-wrapper`]: {
      [`${s}-thead th${s}-column-has-sorters`]: {
        outline: "none",
        cursor: "pointer",
        transition: `all ${a.motionDurationSlow}`,
        "&:hover": {
          background: a.tableHeaderSortHoverBg,
          "&::before": {
            backgroundColor: "transparent !important"
          }
        },
        "&:focus-visible": {
          color: a.colorPrimary
        },
        // https://github.com/ant-design/ant-design/issues/30969
        [`
          &${s}-cell-fix-left:hover,
          &${s}-cell-fix-right:hover
        `]: {
          background: a.tableFixedHeaderSortActiveBg
        }
      },
      [`${s}-thead th${s}-column-sort`]: {
        background: a.tableHeaderSortBg,
        "&::before": {
          backgroundColor: "transparent !important"
        }
      },
      [`td${s}-column-sort`]: {
        background: a.tableBodySortBg
      },
      [`${s}-column-title`]: {
        position: "relative",
        zIndex: 1,
        flex: 1
      },
      [`${s}-column-sorters`]: {
        display: "flex",
        flex: "auto",
        alignItems: "center",
        justifyContent: "space-between",
        "&::after": {
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          content: '""'
        }
      },
      [`${s}-column-sorter`]: {
        marginInlineStart: $,
        color: _e,
        fontSize: 0,
        transition: `color ${a.motionDurationSlow}`,
        "&-inner": {
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center"
        },
        "&-up, &-down": {
          fontSize: _,
          "&.active": {
            color: a.colorPrimary
          }
        },
        [`${s}-column-sorter-up + ${s}-column-sorter-down`]: {
          marginTop: "-0.3em"
        }
      },
      [`${s}-column-sorters:hover ${s}-column-sorter`]: {
        color: tt
      }
    }
  };
}, genSorterStyle$1 = genSorterStyle, genStickyStyle = (a) => {
  const {
    componentCls: s,
    opacityLoading: $,
    tableScrollThumbBg: _,
    tableScrollThumbBgHover: _e,
    tableScrollThumbSize: tt,
    tableScrollBg: nt,
    zIndexTableSticky: at,
    stickyScrollBarBorderRadius: ot,
    lineWidth: rt,
    lineType: st,
    tableBorderColor: lt
  } = a, et = `${unit$1(rt)} ${st} ${lt}`;
  return {
    [`${s}-wrapper`]: {
      [`${s}-sticky`]: {
        "&-holder": {
          position: "sticky",
          zIndex: at,
          background: a.colorBgContainer
        },
        "&-scroll": {
          position: "sticky",
          bottom: 0,
          height: `${unit$1(tt)} !important`,
          zIndex: at,
          display: "flex",
          alignItems: "center",
          background: nt,
          borderTop: et,
          opacity: $,
          "&:hover": {
            transformOrigin: "center bottom"
          },
          // fake scrollbar style of sticky
          "&-bar": {
            height: tt,
            backgroundColor: _,
            borderRadius: ot,
            transition: `all ${a.motionDurationSlow}, transform none`,
            position: "absolute",
            bottom: 0,
            "&:hover, &-active": {
              backgroundColor: _e
            }
          }
        }
      }
    }
  };
}, genStickyStyle$1 = genStickyStyle, genSummaryStyle = (a) => {
  const {
    componentCls: s,
    lineWidth: $,
    tableBorderColor: _,
    calc: _e
  } = a, tt = `${unit$1($)} ${a.lineType} ${_}`;
  return {
    [`${s}-wrapper`]: {
      [`${s}-summary`]: {
        position: "relative",
        zIndex: a.zIndexTableFixed,
        background: a.tableBg,
        "> tr": {
          "> th, > td": {
            borderBottom: tt
          }
        }
      },
      [`div${s}-summary`]: {
        boxShadow: `0 ${unit$1(_e($).mul(-1).equal())} 0 ${_}`
      }
    }
  };
}, genSummaryStyle$1 = genSummaryStyle, genVirtualStyle = (a) => {
  const {
    componentCls: s,
    motionDurationMid: $,
    lineWidth: _,
    lineType: _e,
    tableBorderColor: tt,
    calc: nt
  } = a, at = `${unit$1(_)} ${_e} ${tt}`, ot = `${s}-expanded-row-cell`;
  return {
    [`${s}-wrapper`]: {
      // ========================== Row ==========================
      [`${s}-tbody-virtual`]: {
        [`${s}-row`]: {
          display: "flex",
          boxSizing: "border-box",
          width: "100%"
        },
        [`${s}-cell`]: {
          borderBottom: at,
          transition: `background ${$}`
        },
        [`${s}-expanded-row`]: {
          [`${ot}${ot}-fixed`]: {
            position: "sticky",
            insetInlineStart: 0,
            overflow: "hidden",
            width: `calc(var(--virtual-width) - ${unit$1(_)})`,
            borderInlineEnd: "none"
          }
        }
      },
      // ======================== Border =========================
      [`${s}-bordered`]: {
        [`${s}-tbody-virtual`]: {
          "&:after": {
            content: '""',
            insetInline: 0,
            bottom: 0,
            borderBottom: at,
            position: "absolute"
          },
          [`${s}-cell`]: {
            borderInlineEnd: at,
            [`&${s}-cell-fix-right-first:before`]: {
              content: '""',
              position: "absolute",
              insetBlock: 0,
              insetInlineStart: nt(_).mul(-1).equal(),
              borderInlineStart: at
            }
          }
        },
        // Empty placeholder
        [`&${s}-virtual`]: {
          [`${s}-placeholder ${s}-cell`]: {
            borderInlineEnd: at,
            borderBottom: at
          }
        }
      }
    }
  };
}, genVirtualStyle$1 = genVirtualStyle, genTableStyle = (a) => {
  const {
    componentCls: s,
    fontWeightStrong: $,
    tablePaddingVertical: _,
    tablePaddingHorizontal: _e,
    tableExpandColumnWidth: tt,
    lineWidth: nt,
    lineType: at,
    tableBorderColor: ot,
    tableFontSize: rt,
    tableBg: st,
    tableRadius: lt,
    tableHeaderTextColor: et,
    motionDurationMid: it,
    tableHeaderBg: ut,
    tableHeaderCellSplitColor: ft,
    tableFooterTextColor: ht,
    tableFooterBg: dt,
    calc: gt
  } = a, pt = `${unit$1(nt)} ${at} ${ot}`;
  return {
    [`${s}-wrapper`]: Object.assign(Object.assign({
      clear: "both",
      maxWidth: "100%"
    }, clearFix()), {
      [s]: Object.assign(Object.assign({}, resetComponent(a)), {
        fontSize: rt,
        background: st,
        borderRadius: `${unit$1(lt)} ${unit$1(lt)} 0 0`
      }),
      // https://github.com/ant-design/ant-design/issues/17611
      table: {
        width: "100%",
        textAlign: "start",
        borderRadius: `${unit$1(lt)} ${unit$1(lt)} 0 0`,
        borderCollapse: "separate",
        borderSpacing: 0
      },
      // ============================= Cell ==============================
      [`
          ${s}-cell,
          ${s}-thead > tr > th,
          ${s}-tbody > tr > th,
          ${s}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
        position: "relative",
        padding: `${unit$1(_)} ${unit$1(_e)}`,
        overflowWrap: "break-word"
      },
      // ============================ Title =============================
      [`${s}-title`]: {
        padding: `${unit$1(_)} ${unit$1(_e)}`
      },
      // ============================ Header ============================
      [`${s}-thead`]: {
        "\n          > tr > th,\n          > tr > td\n        ": {
          position: "relative",
          color: et,
          fontWeight: $,
          textAlign: "start",
          background: ut,
          borderBottom: pt,
          transition: `background ${it} ease`,
          "&[colspan]:not([colspan='1'])": {
            textAlign: "center"
          },
          [`&:not(:last-child):not(${s}-selection-column):not(${s}-row-expand-icon-cell):not([colspan])::before`]: {
            position: "absolute",
            top: "50%",
            insetInlineEnd: 0,
            width: 1,
            height: "1.6em",
            backgroundColor: ft,
            transform: "translateY(-50%)",
            transition: `background-color ${it}`,
            content: '""'
          }
        },
        "> tr:not(:last-child) > th[colspan]": {
          borderBottom: 0
        }
      },
      // ============================ Body ============================
      [`${s}-tbody`]: {
        "> tr": {
          "> th, > td": {
            transition: `background ${it}, border-color ${it}`,
            borderBottom: pt,
            // ========================= Nest Table ===========================
            [`
              > ${s}-wrapper:only-child,
              > ${s}-expanded-row-fixed > ${s}-wrapper:only-child
            `]: {
              [s]: {
                marginBlock: unit$1(gt(_).mul(-1).equal()),
                marginInline: `${unit$1(gt(tt).sub(_e).equal())}
                ${unit$1(gt(_e).mul(-1).equal())}`,
                [`${s}-tbody > tr:last-child > td`]: {
                  borderBottom: 0,
                  "&:first-child, &:last-child": {
                    borderRadius: 0
                  }
                }
              }
            }
          },
          "> th": {
            position: "relative",
            color: et,
            fontWeight: $,
            textAlign: "start",
            background: ut,
            borderBottom: pt,
            transition: `background ${it} ease`
          }
        }
      },
      // ============================ Footer ============================
      [`${s}-footer`]: {
        padding: `${unit$1(_)} ${unit$1(_e)}`,
        color: ht,
        background: dt
      }
    })
  };
}, prepareComponentToken$2 = (a) => {
  const {
    colorFillAlter: s,
    colorBgContainer: $,
    colorTextHeading: _,
    colorFillSecondary: _e,
    colorFillContent: tt,
    controlItemBgActive: nt,
    controlItemBgActiveHover: at,
    padding: ot,
    paddingSM: rt,
    paddingXS: st,
    colorBorderSecondary: lt,
    borderRadiusLG: et,
    controlHeight: it,
    colorTextPlaceholder: ut,
    fontSize: ft,
    fontSizeSM: ht,
    lineHeight: dt,
    lineWidth: gt,
    colorIcon: pt,
    colorIconHover: mt,
    opacityLoading: ct,
    controlInteractiveSize: vt
  } = a, At = new TinyColor(_e).onBackground($).toHexShortString(), xt = new TinyColor(tt).onBackground($).toHexShortString(), bt = new TinyColor(s).onBackground($).toHexShortString(), Et = new TinyColor(pt), St = new TinyColor(mt), Bt = vt / 2 - gt, Ot = Bt * 2 + gt * 3;
  return {
    headerBg: bt,
    headerColor: _,
    headerSortActiveBg: At,
    headerSortHoverBg: xt,
    bodySortBg: bt,
    rowHoverBg: bt,
    rowSelectedBg: nt,
    rowSelectedHoverBg: at,
    rowExpandedBg: s,
    cellPaddingBlock: ot,
    cellPaddingInline: ot,
    cellPaddingBlockMD: rt,
    cellPaddingInlineMD: st,
    cellPaddingBlockSM: st,
    cellPaddingInlineSM: st,
    borderColor: lt,
    headerBorderRadius: et,
    footerBg: bt,
    footerColor: _,
    cellFontSize: ft,
    cellFontSizeMD: ft,
    cellFontSizeSM: ft,
    headerSplitColor: lt,
    fixedHeaderSortActiveBg: At,
    headerFilterHoverBg: tt,
    filterDropdownMenuBg: $,
    filterDropdownBg: $,
    expandIconBg: $,
    selectionColumnWidth: it,
    stickyScrollBarBg: ut,
    stickyScrollBarBorderRadius: 100,
    expandIconMarginTop: (ft * dt - gt * 3) / 2 - Math.ceil((ht * 1.4 - gt * 3) / 2),
    headerIconColor: Et.clone().setAlpha(Et.getAlpha() * ct).toRgbString(),
    headerIconHoverColor: St.clone().setAlpha(St.getAlpha() * ct).toRgbString(),
    expandIconHalfInner: Bt,
    expandIconSize: Ot,
    expandIconScale: vt / Ot
  };
}, useStyle$2 = genStyleHooks("Table", (a) => {
  const {
    colorTextHeading: s,
    colorSplit: $,
    colorBgContainer: _,
    controlInteractiveSize: _e,
    headerBg: tt,
    headerColor: nt,
    headerSortActiveBg: at,
    headerSortHoverBg: ot,
    bodySortBg: rt,
    rowHoverBg: st,
    rowSelectedBg: lt,
    rowSelectedHoverBg: et,
    rowExpandedBg: it,
    cellPaddingBlock: ut,
    cellPaddingInline: ft,
    cellPaddingBlockMD: ht,
    cellPaddingInlineMD: dt,
    cellPaddingBlockSM: gt,
    cellPaddingInlineSM: pt,
    borderColor: mt,
    footerBg: ct,
    footerColor: vt,
    headerBorderRadius: At,
    cellFontSize: xt,
    cellFontSizeMD: bt,
    cellFontSizeSM: Et,
    headerSplitColor: St,
    fixedHeaderSortActiveBg: Bt,
    headerFilterHoverBg: Ot,
    filterDropdownBg: Pt,
    expandIconBg: wt,
    selectionColumnWidth: Ct,
    stickyScrollBarBg: It,
    calc: yt
  } = a, Rt = 2, kt = merge(a, {
    tableFontSize: xt,
    tableBg: _,
    tableRadius: At,
    tablePaddingVertical: ut,
    tablePaddingHorizontal: ft,
    tablePaddingVerticalMiddle: ht,
    tablePaddingHorizontalMiddle: dt,
    tablePaddingVerticalSmall: gt,
    tablePaddingHorizontalSmall: pt,
    tableBorderColor: mt,
    tableHeaderTextColor: nt,
    tableHeaderBg: tt,
    tableFooterTextColor: vt,
    tableFooterBg: ct,
    tableHeaderCellSplitColor: St,
    tableHeaderSortBg: at,
    tableHeaderSortHoverBg: ot,
    tableBodySortBg: rt,
    tableFixedHeaderSortActiveBg: Bt,
    tableHeaderFilterActiveBg: Ot,
    tableFilterDropdownBg: Pt,
    tableRowHoverBg: st,
    tableSelectedRowBg: lt,
    tableSelectedRowHoverBg: et,
    zIndexTableFixed: Rt,
    zIndexTableSticky: Rt + 1,
    tableFontSizeMiddle: bt,
    tableFontSizeSmall: Et,
    tableSelectionColumnWidth: Ct,
    tableExpandIconBg: wt,
    tableExpandColumnWidth: yt(_e).add(yt(a.padding).mul(2)).equal(),
    tableExpandedRowBg: it,
    // Dropdown
    tableFilterDropdownWidth: 120,
    tableFilterDropdownHeight: 264,
    tableFilterDropdownSearchWidth: 140,
    // Virtual Scroll Bar
    tableScrollThumbSize: 8,
    // Mac scroll bar size
    tableScrollThumbBg: It,
    tableScrollThumbBgHover: s,
    tableScrollBg: $
  });
  return [genTableStyle(kt), genPaginationStyle$1(kt), genSummaryStyle$1(kt), genSorterStyle$1(kt), genFilterStyle$1(kt), genBorderedStyle$1(kt), genRadiusStyle$1(kt), genExpandStyle$1(kt), genSummaryStyle$1(kt), genEmptyStyle$1(kt), genSelectionStyle$1(kt), genFixedStyle$1(kt), genStickyStyle$1(kt), genEllipsisStyle$1(kt), genSizeStyle$1(kt), genRtlStyle$2(kt), genVirtualStyle$1(kt)];
}, prepareComponentToken$2, {
  unitless: {
    expandIconScale: !0
  }
}), EMPTY_LIST = [], InternalTable = (a, s) => {
  const {
    prefixCls: $,
    className: _,
    rootClassName: _e,
    style: tt,
    size: nt,
    bordered: at,
    dropdownPrefixCls: ot,
    dataSource: rt,
    pagination: st,
    rowSelection: lt,
    rowKey: et = "key",
    rowClassName: it,
    columns: ut,
    children: ft,
    childrenColumnName: ht,
    onChange: dt,
    getPopupContainer: gt,
    loading: pt,
    expandIcon: mt,
    expandable: ct,
    expandedRowRender: vt,
    expandIconColumnIndex: At,
    indentSize: xt,
    scroll: bt,
    sortDirections: Et,
    locale: St,
    showSorterTooltip: Bt = !0,
    virtual: Ot
  } = a;
  devUseWarning();
  const Pt = reactExports.useMemo(() => ut || convertChildrenToColumns(ft), [ut, ft]), wt = reactExports.useMemo(() => Pt.some((wr) => wr.responsive), [Pt]), Ct = useBreakpoint(wt), It = reactExports.useMemo(() => {
    const wr = new Set(Object.keys(Ct).filter((Mr) => Ct[Mr]));
    return Pt.filter((Mr) => !Mr.responsive || Mr.responsive.some((Fr) => wr.has(Fr)));
  }, [Pt, Ct]), yt = omit(a, ["className", "style", "columns"]), {
    locale: Rt = defaultLocale,
    direction: kt,
    table: jt,
    renderEmpty: Ht,
    getPrefixCls: Ft,
    getPopupContainer: _t
  } = reactExports.useContext(ConfigContext$1), Nt = useSize$1(nt), Mt = Object.assign(Object.assign({}, Rt.Table), St), Lt = rt || EMPTY_LIST, $t = Ft("table", $), Tt = Ft("dropdown", ot), [, Dt] = useToken$1(), Ut = useCSSVarCls$1($t), [Vt, Qt, qt] = useStyle$2($t, Ut), Zt = Object.assign({
    childrenColumnName: ht,
    expandIconColumnIndex: At
  }, ct), {
    childrenColumnName: ar = "children"
  } = Zt, Jt = reactExports.useMemo(() => Lt.some((wr) => wr == null ? void 0 : wr[ar]) ? "nest" : vt || ct && ct.expandedRowRender ? "row" : null, [Lt]), rr = {
    body: reactExports.useRef()
  }, Yt = useContainerWidth($t), Kt = reactExports.useRef(null), nr = reactExports.useRef(null);
  useProxyImperativeHandle(s, () => Object.assign(Object.assign({}, nr.current), {
    nativeElement: Kt.current
  }));
  const tr = reactExports.useMemo(() => typeof et == "function" ? et : (wr) => wr == null ? void 0 : wr[et], [et]), [ir] = useLazyKVMap(Lt, ar, tr), sr = {}, cr = function(wr, Mr) {
    let Fr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    var Qr, Yr, kr;
    const Nr = Object.assign(Object.assign({}, sr), wr);
    Fr && ((Qr = sr.resetPagination) === null || Qr === void 0 || Qr.call(sr), !((Yr = Nr.pagination) === null || Yr === void 0) && Yr.current && (Nr.pagination.current = 1), st && st.onChange && st.onChange(1, (kr = Nr.pagination) === null || kr === void 0 ? void 0 : kr.pageSize)), bt && bt.scrollToFirstRowOnChange !== !1 && rr.body.current && scrollTo$1(0, {
      getContainer: () => rr.body.current
    }), dt == null || dt(Nr.pagination, Nr.filters, Nr.sorter, {
      currentDataSource: getFilterData(getSortData(Lt, Nr.sorterStates, ar), Nr.filterStates),
      action: Mr
    });
  }, or = (wr, Mr) => {
    cr({
      sorter: wr,
      sorterStates: Mr
    }, "sort", !1);
  }, [Xt, Gt, Wt, er] = useFilterSorter({
    prefixCls: $t,
    mergedColumns: It,
    onSorterChange: or,
    sortDirections: Et || ["ascend", "descend"],
    tableLocale: Mt,
    showSorterTooltip: Bt
  }), lr = reactExports.useMemo(() => getSortData(Lt, Gt, ar), [Lt, Gt]);
  sr.sorter = er(), sr.sorterStates = Gt;
  const ur = (wr, Mr) => {
    cr({
      filters: wr,
      filterStates: Mr
    }, "filter", !0);
  }, [pr, yr, Er] = useFilter({
    prefixCls: $t,
    locale: Mt,
    dropdownPrefixCls: Tt,
    mergedColumns: It,
    onFilterChange: ur,
    getPopupContainer: gt || _t,
    rootClassName: classnames(_e, Ut)
  }), br = getFilterData(lr, yr);
  sr.filters = Er, sr.filterStates = yr;
  const gr = reactExports.useMemo(() => {
    const wr = {};
    return Object.keys(Er).forEach((Mr) => {
      Er[Mr] !== null && (wr[Mr] = Er[Mr]);
    }), Object.assign(Object.assign({}, Wt), {
      filters: wr
    });
  }, [Wt, Er]), [Ar] = useTitleColumns(gr), Sr = (wr, Mr) => {
    cr({
      pagination: Object.assign(Object.assign({}, sr.pagination), {
        current: wr,
        pageSize: Mr
      })
    }, "paginate");
  }, [Br, Ir] = usePagination(br.length, Sr, st);
  sr.pagination = st === !1 ? {} : getPaginationParam(Br, st), sr.resetPagination = Ir;
  const hr = reactExports.useMemo(() => {
    if (st === !1 || !Br.pageSize)
      return br;
    const {
      current: wr = 1,
      total: Mr,
      pageSize: Fr = DEFAULT_PAGE_SIZE
    } = Br;
    return br.length < Mr ? br.length > Fr ? br.slice((wr - 1) * Fr, wr * Fr) : br : br.slice((wr - 1) * Fr, wr * Fr);
  }, [!!st, br, Br && Br.current, Br && Br.pageSize, Br && Br.total]), [vr, xr] = useSelection({
    prefixCls: $t,
    data: br,
    pageData: hr,
    getRowKey: tr,
    getRecordByKey: ir,
    expandType: Jt,
    childrenColumnName: ar,
    locale: Mt,
    getPopupContainer: gt || _t
  }, lt), Pr = (wr, Mr, Fr) => {
    let Qr;
    return typeof it == "function" ? Qr = classnames(it(wr, Mr, Fr)) : Qr = classnames(it), classnames({
      [`${$t}-row-selected`]: xr.has(tr(wr, Mr))
    }, Qr);
  };
  Zt.__PARENT_RENDER_ICON__ = Zt.expandIcon, Zt.expandIcon = Zt.expandIcon || mt || renderExpandIcon(Mt), Jt === "nest" && Zt.expandIconColumnIndex === void 0 ? Zt.expandIconColumnIndex = lt ? 1 : 0 : Zt.expandIconColumnIndex > 0 && lt && (Zt.expandIconColumnIndex -= 1), typeof Zt.indentSize != "number" && (Zt.indentSize = typeof xt == "number" ? xt : 15);
  const Rr = reactExports.useCallback((wr) => Ar(vr(pr(Xt(wr)))), [Xt, pr, vr]);
  let Dr, Gr;
  if (st !== !1 && (Br != null && Br.total)) {
    let wr;
    Br.size ? wr = Br.size : wr = Nt === "small" || Nt === "middle" ? "small" : void 0;
    const Mr = (Yr) => /* @__PURE__ */ reactExports.createElement(Pagination$1, Object.assign({}, Br, {
      className: classnames(`${$t}-pagination ${$t}-pagination-${Yr}`, Br.className),
      size: wr
    })), Fr = kt === "rtl" ? "left" : "right", {
      position: Qr
    } = Br;
    if (Qr !== null && Array.isArray(Qr)) {
      const Yr = Qr.find((Lr) => Lr.includes("top")), kr = Qr.find((Lr) => Lr.includes("bottom")), Nr = Qr.every((Lr) => `${Lr}` == "none");
      !Yr && !kr && !Nr && (Gr = Mr(Fr)), Yr && (Dr = Mr(Yr.toLowerCase().replace("top", ""))), kr && (Gr = Mr(kr.toLowerCase().replace("bottom", "")));
    } else
      Gr = Mr(Fr);
  }
  let Or;
  typeof pt == "boolean" ? Or = {
    spinning: pt
  } : typeof pt == "object" && (Or = Object.assign({
    spinning: !0
  }, pt));
  const Hr = classnames(qt, Ut, `${$t}-wrapper`, jt == null ? void 0 : jt.className, {
    [`${$t}-wrapper-rtl`]: kt === "rtl"
  }, _, _e, Qt), jr = Object.assign(Object.assign({}, jt == null ? void 0 : jt.style), tt), Tr = St && St.emptyText || (Ht == null ? void 0 : Ht("Table")) || /* @__PURE__ */ reactExports.createElement(DefaultRenderEmpty$1, {
    componentName: "Table"
  }), fr = Ot ? RcVirtualTable : RcTable, Cr = {}, $r = reactExports.useMemo(() => {
    const {
      fontSize: wr,
      lineHeight: Mr,
      padding: Fr,
      paddingXS: Qr,
      paddingSM: Yr
    } = Dt, kr = Math.floor(wr * Mr);
    switch (Nt) {
      case "large":
        return Fr * 2 + kr;
      case "small":
        return Qr * 2 + kr;
      default:
        return Yr * 2 + kr;
    }
  }, [Dt, Nt]);
  return Ot && (Cr.listItemHeight = $r), Vt(/* @__PURE__ */ reactExports.createElement("div", {
    ref: Kt,
    className: Hr,
    style: jr
  }, /* @__PURE__ */ reactExports.createElement(Spin$1, Object.assign({
    spinning: !1
  }, Or), Dr, /* @__PURE__ */ reactExports.createElement(fr, Object.assign({}, Cr, yt, {
    ref: nr,
    columns: It,
    direction: kt,
    expandable: Zt,
    prefixCls: $t,
    className: classnames({
      [`${$t}-middle`]: Nt === "middle",
      [`${$t}-small`]: Nt === "small",
      [`${$t}-bordered`]: at,
      [`${$t}-empty`]: Lt.length === 0
    }, qt, Ut, Qt),
    data: hr,
    rowKey: tr,
    rowClassName: Pr,
    emptyText: Tr,
    // Internal
    internalHooks: INTERNAL_HOOKS,
    internalRefs: rr,
    transformColumns: Rr,
    getContainerWidth: Yt
  })), Gr)));
}, InternalTable$1 = /* @__PURE__ */ reactExports.forwardRef(InternalTable), Table = (a, s) => {
  const $ = reactExports.useRef(0);
  return $.current += 1, /* @__PURE__ */ reactExports.createElement(InternalTable$1, Object.assign({}, a, {
    ref: s,
    _renderTimes: $.current
  }));
}, ForwardTable = /* @__PURE__ */ reactExports.forwardRef(Table);
ForwardTable.SELECTION_COLUMN = SELECTION_COLUMN;
ForwardTable.EXPAND_COLUMN = EXPAND_COLUMN;
ForwardTable.SELECTION_ALL = SELECTION_ALL;
ForwardTable.SELECTION_INVERT = SELECTION_INVERT;
ForwardTable.SELECTION_NONE = SELECTION_NONE;
ForwardTable.Column = Column;
ForwardTable.ColumnGroup = ColumnGroup;
ForwardTable.Summary = FooterComponents;
const Table$1 = ForwardTable, getDesignToken = (a) => {
  const s = a != null && a.algorithm ? createTheme(a.algorithm) : createTheme(derivative$2), $ = Object.assign(Object.assign({}, seedToken), a == null ? void 0 : a.token);
  return getComputedToken$1($, {
    override: a == null ? void 0 : a.token
  }, s, formatToken);
}, getDesignToken$1 = getDesignToken;
function genSizeMapToken(a) {
  const {
    sizeUnit: s,
    sizeStep: $
  } = a, _ = $ - 2;
  return {
    sizeXXL: s * (_ + 10),
    sizeXL: s * (_ + 6),
    sizeLG: s * (_ + 2),
    sizeMD: s * (_ + 2),
    sizeMS: s * (_ + 1),
    size: s * _,
    sizeSM: s * _,
    sizeXS: s * (_ - 1),
    sizeXXS: s * (_ - 1)
  };
}
const derivative$1 = (a, s) => {
  const $ = s ?? derivative$2(a), _ = $.fontSizeSM, _e = $.controlHeight - 4;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $), genSizeMapToken(s ?? a)), genFontMapToken$1(_)), {
    // controlHeight
    controlHeight: _e
  }), genControlHeight$1(Object.assign(Object.assign({}, $), {
    controlHeight: _e
  })));
}, compactAlgorithm = derivative$1, getAlphaColor = (a, s) => new TinyColor(a).setAlpha(s).toRgbString(), getSolidColor = (a, s) => new TinyColor(a).lighten(s).toHexString(), generateColorPalettes = (a) => {
  const s = generate$2(a, {
    theme: "dark"
  });
  return {
    1: s[0],
    2: s[1],
    3: s[2],
    4: s[3],
    5: s[6],
    6: s[5],
    7: s[4],
    8: s[6],
    9: s[5],
    10: s[4]
    // 8: colors[9],
    // 9: colors[8],
    // 10: colors[7],
  };
}, generateNeutralColorPalettes = (a, s) => {
  const $ = a || "#000", _ = s || "#fff";
  return {
    colorBgBase: $,
    colorTextBase: _,
    colorText: getAlphaColor(_, 0.85),
    colorTextSecondary: getAlphaColor(_, 0.65),
    colorTextTertiary: getAlphaColor(_, 0.45),
    colorTextQuaternary: getAlphaColor(_, 0.25),
    colorFill: getAlphaColor(_, 0.18),
    colorFillSecondary: getAlphaColor(_, 0.12),
    colorFillTertiary: getAlphaColor(_, 0.08),
    colorFillQuaternary: getAlphaColor(_, 0.04),
    colorBgElevated: getSolidColor($, 12),
    colorBgContainer: getSolidColor($, 8),
    colorBgLayout: getSolidColor($, 0),
    colorBgSpotlight: getSolidColor($, 26),
    colorBgBlur: getAlphaColor(_, 0.04),
    colorBorder: getSolidColor($, 26),
    colorBorderSecondary: getSolidColor($, 19)
  };
}, derivative = (a, s) => {
  const $ = Object.keys(defaultPresetColors).map((_e) => {
    const tt = generate$2(a[_e], {
      theme: "dark"
    });
    return new Array(10).fill(1).reduce((nt, at, ot) => (nt[`${_e}-${ot + 1}`] = tt[ot], nt[`${_e}${ot + 1}`] = tt[ot], nt), {});
  }).reduce((_e, tt) => (_e = Object.assign(Object.assign({}, _e), tt), _e), {}), _ = s ?? derivative$2(a);
  return Object.assign(Object.assign(Object.assign({}, _), $), genColorMapToken(a, {
    generateColorPalettes,
    generateNeutralColorPalettes
  }));
}, darkAlgorithm = derivative;
function useToken() {
  const [a, s, $] = useToken$1();
  return {
    theme: a,
    token: s,
    hashId: $
  };
}
const theme = {
  /** @private Test Usage. Do not use in production. */
  defaultConfig,
  /** Default seedToken */
  defaultSeed: defaultConfig.token,
  useToken,
  defaultAlgorithm: derivative$2,
  darkAlgorithm,
  compactAlgorithm,
  getDesignToken: getDesignToken$1
};
var DeleteOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, name: "delete", theme: "outlined" };
const DeleteOutlinedSvg = DeleteOutlined$2;
var DeleteOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: DeleteOutlinedSvg
  }));
};
const DeleteOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(DeleteOutlined);
var __rest$b = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const inlineStyle = {
  border: 0,
  background: "transparent",
  padding: 0,
  lineHeight: "inherit",
  display: "inline-block"
}, TransButton = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const $ = (rt) => {
    const {
      keyCode: st
    } = rt;
    st === KeyCode.ENTER && rt.preventDefault();
  }, _ = (rt) => {
    const {
      keyCode: st
    } = rt, {
      onClick: lt
    } = a;
    st === KeyCode.ENTER && lt && lt();
  }, {
    style: _e,
    noStyle: tt,
    disabled: nt
  } = a, at = __rest$b(a, ["style", "noStyle", "disabled"]);
  let ot = {};
  return tt || (ot = Object.assign({}, inlineStyle)), nt && (ot.pointerEvents = "none"), ot = Object.assign(Object.assign({}, ot), _e), /* @__PURE__ */ reactExports.createElement("div", Object.assign({
    role: "button",
    tabIndex: 0,
    ref: s
  }, at, {
    onKeyDown: $,
    onKeyUp: _,
    style: ot
  }));
}), TransButton$1 = TransButton, useCache = function(a) {
  var s = reactExports.useRef({
    valueLabels: /* @__PURE__ */ new Map()
  });
  return reactExports.useMemo(function() {
    var $ = s.current.valueLabels, _ = /* @__PURE__ */ new Map(), _e = a.map(function(tt) {
      var nt, at = tt.value, ot = (nt = tt.label) !== null && nt !== void 0 ? nt : $.get(at);
      return _.set(at, ot), _objectSpread2$a(_objectSpread2$a({}, tt), {}, {
        label: ot
      });
    });
    return s.current.valueLabels = _, [_e];
  }, [a]);
}, useCheckedKeys = function(a, s, $, _) {
  return reactExports.useMemo(function() {
    var _e = a.map(function(ot) {
      var rt = ot.value;
      return rt;
    }), tt = s.map(function(ot) {
      var rt = ot.value;
      return rt;
    }), nt = _e.filter(function(ot) {
      return !_[ot];
    });
    if ($) {
      var at = conductCheck(_e, !0, _);
      _e = at.checkedKeys, tt = at.halfCheckedKeys;
    }
    return [
      // Checked keys should fill with missing keys which should de-duplicated
      Array.from(new Set([].concat(_toConsumableArray$d(nt), _toConsumableArray$d(_e)))),
      // Half checked keys
      tt
    ];
  }, [a, s, $, _]);
};
function toArray(a) {
  return Array.isArray(a) ? a : a !== void 0 ? [a] : [];
}
function fillFieldNames(a) {
  var s = a || {}, $ = s.label, _ = s.value, _e = s.children, tt = _ || "value";
  return {
    _title: $ ? [$] : ["title", "label"],
    value: tt,
    key: tt,
    children: _e || "children"
  };
}
function isCheckDisabled(a) {
  return !a || a.disabled || a.disableCheckbox || a.checkable === !1;
}
function getAllKeys$1(a, s) {
  var $ = [];
  function _(_e) {
    _e.forEach(function(tt) {
      var nt = tt[s.children];
      nt && ($.push(tt[s.value]), _(nt));
    });
  }
  return _(a), $;
}
function isNil(a) {
  return a == null;
}
const useDataEntities = function(a, s) {
  return reactExports.useMemo(function() {
    var $ = convertDataToEntities(a, {
      fieldNames: s,
      initWrapper: function(_e) {
        return _objectSpread2$a(_objectSpread2$a({}, _e), {}, {
          valueEntities: /* @__PURE__ */ new Map()
        });
      },
      processEntity: function(_e, tt) {
        var nt = _e.node[s.value];
        tt.valueEntities.set(nt, _e);
      }
    });
    return $;
  }, [a, s]);
};
var TreeNode = function a() {
  return null;
}, _excluded$3 = ["children", "value"];
function convertChildrenToData(a) {
  return toArray$9(a).map(function(s) {
    if (!/* @__PURE__ */ reactExports.isValidElement(s) || !s.type)
      return null;
    var $ = s, _ = $.key, _e = $.props, tt = _e.children, nt = _e.value, at = _objectWithoutProperties$1(_e, _excluded$3), ot = _objectSpread2$a({
      key: _,
      value: nt
    }, at), rt = convertChildrenToData(tt);
    return rt.length && (ot.children = rt), ot;
  }).filter(function(s) {
    return s;
  });
}
function fillLegacyProps(a) {
  if (!a)
    return a;
  var s = _objectSpread2$a({}, a);
  return "props" in s || Object.defineProperty(s, "props", {
    get: function() {
      return warningOnce(!1, "New `rc-tree-select` not support return node instance as argument anymore. Please consider to remove `props` access."), s;
    }
  }), s;
}
function fillAdditionalInfo(a, s, $, _, _e, tt) {
  var nt = null, at = null;
  function ot() {
    function rt(st) {
      var lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0", et = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      return st.map(function(it, ut) {
        var ft = "".concat(lt, "-").concat(ut), ht = it[tt.value], dt = $.includes(ht), gt = rt(it[tt.children] || [], ft, dt), pt = /* @__PURE__ */ reactExports.createElement(TreeNode, it, gt.map(function(ct) {
          return ct.node;
        }));
        if (s === ht && (nt = pt), dt) {
          var mt = {
            pos: ft,
            node: pt,
            children: gt
          };
          return et || at.push(mt), mt;
        }
        return null;
      }).filter(function(it) {
        return it;
      });
    }
    at || (at = [], rt(_), at.sort(function(st, lt) {
      var et = st.node.props.value, it = lt.node.props.value, ut = $.indexOf(et), ft = $.indexOf(it);
      return ut - ft;
    }));
  }
  Object.defineProperty(a, "triggerNode", {
    get: function() {
      return warningOnce(!1, "`triggerNode` is deprecated. Please consider decoupling data with node."), ot(), nt;
    }
  }), Object.defineProperty(a, "allCheckedNodes", {
    get: function() {
      return warningOnce(!1, "`allCheckedNodes` is deprecated. Please consider decoupling data with node."), ot(), _e ? at : at.map(function(st) {
        var lt = st.node;
        return lt;
      });
    }
  });
}
const useFilterTreeData = function(a, s, $) {
  var _ = $.treeNodeFilterProp, _e = $.filterTreeNode, tt = $.fieldNames, nt = tt.children;
  return reactExports.useMemo(function() {
    if (!s || _e === !1)
      return a;
    var at;
    if (typeof _e == "function")
      at = _e;
    else {
      var ot = s.toUpperCase();
      at = function(lt, et) {
        var it = et[_];
        return String(it).toUpperCase().includes(ot);
      };
    }
    function rt(st) {
      var lt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      return st.reduce(function(et, it) {
        var ut = it[nt], ft = lt || at(s, fillLegacyProps(it)), ht = rt(ut || [], ft);
        return (ft || ht.length) && et.push(_objectSpread2$a(_objectSpread2$a({}, it), {}, _defineProperty$c({
          isLeaf: void 0
        }, nt, ht))), et;
      }, []);
    }
    return rt(a);
  }, [a, s, nt, _, _e]);
};
function useRefFunc(a) {
  var s = reactExports.useRef();
  s.current = a;
  var $ = reactExports.useCallback(function() {
    return s.current.apply(s, arguments);
  }, []);
  return $;
}
function parseSimpleTreeData(a, s) {
  var $ = s.id, _ = s.pId, _e = s.rootPId, tt = {}, nt = [], at = a.map(function(ot) {
    var rt = _objectSpread2$a({}, ot), st = rt[$];
    return tt[st] = rt, rt.key = rt.key || st, rt;
  });
  return at.forEach(function(ot) {
    var rt = ot[_], st = tt[rt];
    st && (st.children = st.children || [], st.children.push(ot)), (rt === _e || !st && _e === null) && nt.push(ot);
  }), nt;
}
function useTreeData(a, s, $) {
  return reactExports.useMemo(function() {
    return a ? $ ? parseSimpleTreeData(a, _objectSpread2$a({
      id: "id",
      pId: "pId",
      rootPId: null
    }, $ !== !0 ? $ : {})) : a : convertChildrenToData(s);
  }, [s, $, a]);
}
var LegacySelectContext = /* @__PURE__ */ reactExports.createContext(null), TreeSelectContext = /* @__PURE__ */ reactExports.createContext(null), HIDDEN_STYLE = {
  width: 0,
  height: 0,
  display: "flex",
  overflow: "hidden",
  opacity: 0,
  border: 0,
  padding: 0,
  margin: 0
}, OptionList = function a(s, $) {
  var _ = useBaseProps(), _e = _.prefixCls, tt = _.multiple, nt = _.searchValue, at = _.toggleOpen, ot = _.open, rt = _.notFoundContent, st = reactExports.useContext(TreeSelectContext), lt = st.virtual, et = st.listHeight, it = st.listItemHeight, ut = st.listItemScrollOffset, ft = st.treeData, ht = st.fieldNames, dt = st.onSelect, gt = st.dropdownMatchSelectWidth, pt = st.treeExpandAction, mt = reactExports.useContext(LegacySelectContext), ct = mt.checkable, vt = mt.checkedKeys, At = mt.halfCheckedKeys, xt = mt.treeExpandedKeys, bt = mt.treeDefaultExpandAll, Et = mt.treeDefaultExpandedKeys, St = mt.onTreeExpand, Bt = mt.treeIcon, Ot = mt.showTreeIcon, Pt = mt.switcherIcon, wt = mt.treeLine, Ct = mt.treeNodeFilterProp, It = mt.loadData, yt = mt.treeLoadedKeys, Rt = mt.treeMotion, kt = mt.onTreeLoad, jt = mt.keyEntities, Ht = reactExports.useRef(), Ft = useMemo(function() {
    return ft;
  }, [ot, ft], function(cr, or) {
    return or[0] && cr[1] !== or[1];
  }), _t = reactExports.useState(null), Nt = _slicedToArray$e(_t, 2), Mt = Nt[0], Lt = Nt[1], $t = jt[Mt], Tt = reactExports.useMemo(function() {
    return ct ? {
      checked: vt,
      halfChecked: At
    } : null;
  }, [ct, vt, At]);
  reactExports.useEffect(function() {
    if (ot && !tt && vt.length) {
      var cr;
      (cr = Ht.current) === null || cr === void 0 || cr.scrollTo({
        key: vt[0]
      }), Lt(vt[0]);
    }
  }, [ot]);
  var Dt = String(nt).toLowerCase(), Ut = function(or) {
    return Dt ? String(or[Ct]).toLowerCase().includes(Dt) : !1;
  }, Vt = reactExports.useState(Et), Qt = _slicedToArray$e(Vt, 2), qt = Qt[0], Zt = Qt[1], ar = reactExports.useState(null), Jt = _slicedToArray$e(ar, 2), rr = Jt[0], Yt = Jt[1], Kt = reactExports.useMemo(function() {
    return xt ? _toConsumableArray$d(xt) : nt ? rr : qt;
  }, [qt, rr, xt, nt]);
  reactExports.useEffect(function() {
    nt && Yt(getAllKeys$1(ft, ht));
  }, [nt]);
  var nr = function(or) {
    Zt(or), Yt(or), St && St(or);
  }, tr = function(or) {
    or.preventDefault();
  }, ir = function(or, Xt) {
    var Gt = Xt.node;
    ct && isCheckDisabled(Gt) || (dt(Gt.key, {
      selected: !vt.includes(Gt.key)
    }), tt || at(!1));
  };
  if (reactExports.useImperativeHandle($, function() {
    var cr;
    return {
      scrollTo: (cr = Ht.current) === null || cr === void 0 ? void 0 : cr.scrollTo,
      onKeyDown: function(Xt) {
        var Gt, Wt = Xt.which;
        switch (Wt) {
          case KeyCode.UP:
          case KeyCode.DOWN:
          case KeyCode.LEFT:
          case KeyCode.RIGHT:
            (Gt = Ht.current) === null || Gt === void 0 || Gt.onKeyDown(Xt);
            break;
          case KeyCode.ENTER: {
            if ($t) {
              var er = ($t == null ? void 0 : $t.node) || {}, lr = er.selectable, ur = er.value;
              lr !== !1 && ir(null, {
                node: {
                  key: Mt
                },
                selected: !vt.includes(ur)
              });
            }
            break;
          }
          case KeyCode.ESC:
            at(!1);
        }
      },
      onKeyUp: function() {
      }
    };
  }), Ft.length === 0)
    return /* @__PURE__ */ reactExports.createElement("div", {
      role: "listbox",
      className: "".concat(_e, "-empty"),
      onMouseDown: tr
    }, rt);
  var sr = {
    fieldNames: ht
  };
  return yt && (sr.loadedKeys = yt), Kt && (sr.expandedKeys = Kt), /* @__PURE__ */ reactExports.createElement("div", {
    onMouseDown: tr
  }, $t && ot && /* @__PURE__ */ reactExports.createElement("span", {
    style: HIDDEN_STYLE,
    "aria-live": "assertive"
  }, $t.node.value), /* @__PURE__ */ reactExports.createElement(Tree$3, _extends$2({
    ref: Ht,
    focusable: !1,
    prefixCls: "".concat(_e, "-tree"),
    treeData: Ft,
    height: et,
    itemHeight: it,
    itemScrollOffset: ut,
    virtual: lt !== !1 && gt !== !1,
    multiple: tt,
    icon: Bt,
    showIcon: Ot,
    switcherIcon: Pt,
    showLine: wt,
    loadData: nt ? null : It,
    motion: Rt,
    activeKey: Mt,
    checkable: ct,
    checkStrictly: !0,
    checkedKeys: Tt,
    selectedKeys: ct ? [] : vt,
    defaultExpandAll: bt
  }, sr, {
    // Proxy event out
    onActiveChange: Lt,
    onSelect: ir,
    onCheck: ir,
    onExpand: nr,
    onLoad: kt,
    filterTreeNode: Ut,
    expandAction: pt
  })));
}, RefOptionList = /* @__PURE__ */ reactExports.forwardRef(OptionList);
RefOptionList.displayName = "OptionList";
var SHOW_ALL = "SHOW_ALL", SHOW_PARENT = "SHOW_PARENT", SHOW_CHILD = "SHOW_CHILD";
function formatStrategyValues(a, s, $, _) {
  var _e = new Set(a);
  return s === SHOW_CHILD ? a.filter(function(tt) {
    var nt = $[tt];
    return !(nt && nt.children && nt.children.some(function(at) {
      var ot = at.node;
      return _e.has(ot[_.value]);
    }) && nt.children.every(function(at) {
      var ot = at.node;
      return isCheckDisabled(ot) || _e.has(ot[_.value]);
    }));
  }) : s === SHOW_PARENT ? a.filter(function(tt) {
    var nt = $[tt], at = nt ? nt.parent : null;
    return !(at && !isCheckDisabled(at.node) && _e.has(at.key));
  }) : a;
}
var _excluded$2 = ["id", "prefixCls", "value", "defaultValue", "onChange", "onSelect", "onDeselect", "searchValue", "inputValue", "onSearch", "autoClearSearchValue", "filterTreeNode", "treeNodeFilterProp", "showCheckedStrategy", "treeNodeLabelProp", "multiple", "treeCheckable", "treeCheckStrictly", "labelInValue", "fieldNames", "treeDataSimpleMode", "treeData", "children", "loadData", "treeLoadedKeys", "onTreeLoad", "treeDefaultExpandAll", "treeExpandedKeys", "treeDefaultExpandedKeys", "onTreeExpand", "treeExpandAction", "virtual", "listHeight", "listItemHeight", "listItemScrollOffset", "onDropdownVisibleChange", "dropdownMatchSelectWidth", "treeLine", "treeIcon", "showTreeIcon", "switcherIcon", "treeMotion"];
function isRawValue(a) {
  return !a || _typeof$q(a) !== "object";
}
var TreeSelect$2 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  var $ = a.id, _ = a.prefixCls, _e = _ === void 0 ? "rc-tree-select" : _, tt = a.value, nt = a.defaultValue, at = a.onChange, ot = a.onSelect, rt = a.onDeselect, st = a.searchValue, lt = a.inputValue, et = a.onSearch, it = a.autoClearSearchValue, ut = it === void 0 ? !0 : it, ft = a.filterTreeNode, ht = a.treeNodeFilterProp, dt = ht === void 0 ? "value" : ht, gt = a.showCheckedStrategy, pt = a.treeNodeLabelProp, mt = a.multiple, ct = a.treeCheckable, vt = a.treeCheckStrictly, At = a.labelInValue, xt = a.fieldNames, bt = a.treeDataSimpleMode, Et = a.treeData, St = a.children, Bt = a.loadData, Ot = a.treeLoadedKeys, Pt = a.onTreeLoad, wt = a.treeDefaultExpandAll, Ct = a.treeExpandedKeys, It = a.treeDefaultExpandedKeys, yt = a.onTreeExpand, Rt = a.treeExpandAction, kt = a.virtual, jt = a.listHeight, Ht = jt === void 0 ? 200 : jt, Ft = a.listItemHeight, _t = Ft === void 0 ? 20 : Ft, Nt = a.listItemScrollOffset, Mt = Nt === void 0 ? 0 : Nt, Lt = a.onDropdownVisibleChange, $t = a.dropdownMatchSelectWidth, Tt = $t === void 0 ? !0 : $t, Dt = a.treeLine, Ut = a.treeIcon, Vt = a.showTreeIcon, Qt = a.switcherIcon, qt = a.treeMotion, Zt = _objectWithoutProperties$1(a, _excluded$2), ar = useId$1($), Jt = ct && !vt, rr = ct || vt, Yt = vt || At, Kt = rr || mt, nr = useMergedState(nt, {
    value: tt
  }), tr = _slicedToArray$e(nr, 2), ir = tr[0], sr = tr[1], cr = reactExports.useMemo(function() {
    return ct ? gt || SHOW_CHILD : SHOW_ALL;
  }, [gt, ct]), or = reactExports.useMemo(
    function() {
      return fillFieldNames(xt);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [JSON.stringify(xt)]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), Xt = useMergedState("", {
    value: st !== void 0 ? st : lt,
    postState: function(Nr) {
      return Nr || "";
    }
  }), Gt = _slicedToArray$e(Xt, 2), Wt = Gt[0], er = Gt[1], lr = function(Nr) {
    er(Nr), et == null || et(Nr);
  }, ur = useTreeData(Et, St, bt), pr = useDataEntities(ur, or), yr = pr.keyEntities, Er = pr.valueEntities, br = reactExports.useCallback(function(kr) {
    var Nr = [], Lr = [];
    return kr.forEach(function(zr) {
      Er.has(zr) ? Lr.push(zr) : Nr.push(zr);
    }), {
      missingRawValues: Nr,
      existRawValues: Lr
    };
  }, [Er]), gr = useFilterTreeData(ur, Wt, {
    fieldNames: or,
    treeNodeFilterProp: dt,
    filterTreeNode: ft
  }), Ar = reactExports.useCallback(function(kr) {
    if (kr) {
      if (pt)
        return kr[pt];
      for (var Nr = or._title, Lr = 0; Lr < Nr.length; Lr += 1) {
        var zr = kr[Nr[Lr]];
        if (zr !== void 0)
          return zr;
      }
    }
  }, [or, pt]), Sr = reactExports.useCallback(function(kr) {
    var Nr = toArray(kr);
    return Nr.map(function(Lr) {
      return isRawValue(Lr) ? {
        value: Lr
      } : Lr;
    });
  }, []), Br = reactExports.useCallback(function(kr) {
    var Nr = Sr(kr);
    return Nr.map(function(Lr) {
      var zr = Lr.label, Vr = Lr.value, an = Lr.halfChecked, Zr, un = Er.get(Vr);
      if (un) {
        var Xr;
        zr = (Xr = zr) !== null && Xr !== void 0 ? Xr : Ar(un.node), Zr = un.node.disabled;
      } else if (zr === void 0) {
        var Kr = Sr(ir).find(function(rn) {
          return rn.value === Vr;
        });
        zr = Kr.label;
      }
      return {
        label: zr,
        value: Vr,
        halfChecked: an,
        disabled: Zr
      };
    });
  }, [Er, Ar, Sr, ir]), Ir = reactExports.useMemo(function() {
    return Sr(ir);
  }, [Sr, ir]), hr = reactExports.useMemo(function() {
    var kr = [], Nr = [];
    return Ir.forEach(function(Lr) {
      Lr.halfChecked ? Nr.push(Lr) : kr.push(Lr);
    }), [kr, Nr];
  }, [Ir]), vr = _slicedToArray$e(hr, 2), xr = vr[0], Pr = vr[1], Rr = reactExports.useMemo(function() {
    return xr.map(function(kr) {
      return kr.value;
    });
  }, [xr]), Dr = useCheckedKeys(xr, Pr, Jt, yr), Gr = _slicedToArray$e(Dr, 2), Or = Gr[0], Hr = Gr[1], jr = reactExports.useMemo(function() {
    var kr = formatStrategyValues(Or, cr, yr, or), Nr = kr.map(function(an) {
      var Zr, un;
      return (Zr = (un = yr[an]) === null || un === void 0 || (un = un.node) === null || un === void 0 ? void 0 : un[or.value]) !== null && Zr !== void 0 ? Zr : an;
    }), Lr = Nr.map(function(an) {
      var Zr = xr.find(function(un) {
        return un.value === an;
      });
      return {
        value: an,
        label: Zr == null ? void 0 : Zr.label
      };
    }), zr = Br(Lr), Vr = zr[0];
    return !Kt && Vr && isNil(Vr.value) && isNil(Vr.label) ? [] : zr.map(function(an) {
      var Zr;
      return _objectSpread2$a(_objectSpread2$a({}, an), {}, {
        label: (Zr = an.label) !== null && Zr !== void 0 ? Zr : an.value
      });
    });
  }, [or, Kt, Or, xr, Br, cr, yr]), Tr = useCache(jr), fr = _slicedToArray$e(Tr, 1), Cr = fr[0], $r = useRefFunc(function(kr, Nr, Lr) {
    var zr = Br(kr);
    if (sr(zr), ut && er(""), at) {
      var Vr = kr;
      if (Jt) {
        var an = formatStrategyValues(kr, cr, yr, or);
        Vr = an.map(function(Wr) {
          var dn = Er.get(Wr);
          return dn ? dn.node[or.value] : Wr;
        });
      }
      var Zr = Nr || {
        triggerValue: void 0,
        selected: void 0
      }, un = Zr.triggerValue, Xr = Zr.selected, Kr = Vr;
      if (vt) {
        var rn = Pr.filter(function(Wr) {
          return !Vr.includes(Wr.value);
        });
        Kr = [].concat(_toConsumableArray$d(Kr), _toConsumableArray$d(rn));
      }
      var nn = Br(Kr), sn = {
        // [Legacy] Always return as array contains label & value
        preValue: xr,
        triggerValue: un
      }, gn = !0;
      (vt || Lr === "selection" && !Xr) && (gn = !1), fillAdditionalInfo(sn, un, kr, ur, gn, or), rr ? sn.checked = Xr : sn.selected = Xr;
      var en = Yt ? nn : nn.map(function(Wr) {
        return Wr.value;
      });
      at(Kt ? en : en[0], Yt ? null : nn.map(function(Wr) {
        return Wr.label;
      }), sn);
    }
  }), wr = reactExports.useCallback(function(kr, Nr) {
    var Lr, zr = Nr.selected, Vr = Nr.source, an = yr[kr], Zr = an == null ? void 0 : an.node, un = (Lr = Zr == null ? void 0 : Zr[or.value]) !== null && Lr !== void 0 ? Lr : kr;
    if (!Kt)
      $r([un], {
        selected: !0,
        triggerValue: un
      }, "option");
    else {
      var Xr = zr ? [].concat(_toConsumableArray$d(Rr), [un]) : Or.filter(function(dn) {
        return dn !== un;
      });
      if (Jt) {
        var Kr = br(Xr), rn = Kr.missingRawValues, nn = Kr.existRawValues, sn = nn.map(function(dn) {
          return Er.get(dn).key;
        }), gn;
        if (zr) {
          var en = conductCheck(sn, !0, yr);
          gn = en.checkedKeys;
        } else {
          var Wr = conductCheck(sn, {
            checked: !1,
            halfCheckedKeys: Hr
          }, yr);
          gn = Wr.checkedKeys;
        }
        Xr = [].concat(_toConsumableArray$d(rn), _toConsumableArray$d(gn.map(function(dn) {
          return yr[dn].node[or.value];
        })));
      }
      $r(Xr, {
        selected: zr,
        triggerValue: un
      }, Vr || "option");
    }
    zr || !Kt ? ot == null || ot(un, fillLegacyProps(Zr)) : rt == null || rt(un, fillLegacyProps(Zr));
  }, [br, Er, yr, or, Kt, Rr, $r, Jt, ot, rt, Or, Hr]), Mr = reactExports.useCallback(function(kr) {
    if (Lt) {
      var Nr = {};
      Object.defineProperty(Nr, "documentClickClose", {
        get: function() {
          return warningOnce(!1, "Second param of `onDropdownVisibleChange` has been removed."), !1;
        }
      }), Lt(kr, Nr);
    }
  }, [Lt]), Fr = useRefFunc(function(kr, Nr) {
    var Lr = kr.map(function(zr) {
      return zr.value;
    });
    if (Nr.type === "clear") {
      $r(Lr, {}, "selection");
      return;
    }
    Nr.values.length && wr(Nr.values[0].value, {
      selected: !1,
      source: "selection"
    });
  }), Qr = reactExports.useMemo(function() {
    return {
      virtual: kt,
      dropdownMatchSelectWidth: Tt,
      listHeight: Ht,
      listItemHeight: _t,
      listItemScrollOffset: Mt,
      treeData: gr,
      fieldNames: or,
      onSelect: wr,
      treeExpandAction: Rt
    };
  }, [kt, Tt, Ht, _t, Mt, gr, or, wr, Rt]), Yr = reactExports.useMemo(function() {
    return {
      checkable: rr,
      loadData: Bt,
      treeLoadedKeys: Ot,
      onTreeLoad: Pt,
      checkedKeys: Or,
      halfCheckedKeys: Hr,
      treeDefaultExpandAll: wt,
      treeExpandedKeys: Ct,
      treeDefaultExpandedKeys: It,
      onTreeExpand: yt,
      treeIcon: Ut,
      treeMotion: qt,
      showTreeIcon: Vt,
      switcherIcon: Qt,
      treeLine: Dt,
      treeNodeFilterProp: dt,
      keyEntities: yr
    };
  }, [rr, Bt, Ot, Pt, Or, Hr, wt, Ct, It, yt, Ut, qt, Vt, Qt, Dt, dt, yr]);
  return /* @__PURE__ */ reactExports.createElement(TreeSelectContext.Provider, {
    value: Qr
  }, /* @__PURE__ */ reactExports.createElement(LegacySelectContext.Provider, {
    value: Yr
  }, /* @__PURE__ */ reactExports.createElement(BaseSelect, _extends$2({
    ref: s
  }, Zt, {
    // >>> MISC
    id: ar,
    prefixCls: _e,
    mode: Kt ? "multiple" : void 0,
    displayValues: Cr,
    onDisplayValuesChange: Fr,
    searchValue: Wt,
    onSearch: lr,
    OptionList: RefOptionList,
    emptyOptions: !ur.length,
    onDropdownVisibleChange: Mr,
    dropdownMatchSelectWidth: Tt
  }))));
}), GenericTreeSelect = TreeSelect$2;
GenericTreeSelect.TreeNode = TreeNode;
GenericTreeSelect.SHOW_ALL = SHOW_ALL;
GenericTreeSelect.SHOW_PARENT = SHOW_PARENT;
GenericTreeSelect.SHOW_CHILD = SHOW_CHILD;
const genBaseStyle$1 = (a) => {
  const {
    componentCls: s,
    treePrefixCls: $,
    colorBgElevated: _
  } = a, _e = `.${$}`;
  return [
    // ======================================================
    // ==                     Dropdown                     ==
    // ======================================================
    {
      [`${s}-dropdown`]: [
        {
          padding: `${unit$1(a.paddingXS)} ${unit$1(a.calc(a.paddingXS).div(2).equal())}`
        },
        // ====================== Tree ======================
        genTreeStyle($, merge(a, {
          colorBgContainer: _
        })),
        {
          [_e]: {
            borderRadius: 0,
            [`${_e}-list-holder-inner`]: {
              alignItems: "stretch",
              [`${_e}-treenode`]: {
                [`${_e}-node-content-wrapper`]: {
                  flex: "auto"
                }
              }
            }
          }
        },
        // ==================== Checkbox ====================
        getStyle$1(`${$}-checkbox`, a),
        // ====================== RTL =======================
        {
          "&-rtl": {
            direction: "rtl",
            [`${_e}-switcher${_e}-switcher_close`]: {
              [`${_e}-switcher-icon svg`]: {
                transform: "rotate(90deg)"
              }
            }
          }
        }
      ]
    }
  ];
};
function useTreeSelectStyle(a, s, $) {
  return genStyleHooks("TreeSelect", (_) => {
    const _e = merge(_, {
      treePrefixCls: s
    });
    return [genBaseStyle$1(_e)];
  }, initComponentToken)(a, $);
}
var __rest$a = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const InternalTreeSelect = (a, s) => {
  var $, _, {
    prefixCls: _e,
    size: tt,
    disabled: nt,
    bordered: at = !0,
    className: ot,
    rootClassName: rt,
    treeCheckable: st,
    multiple: lt,
    listHeight: et = 256,
    listItemHeight: it = 26,
    placement: ut,
    notFoundContent: ft,
    switcherIcon: ht,
    treeLine: dt,
    getPopupContainer: gt,
    popupClassName: pt,
    dropdownClassName: mt,
    treeIcon: ct = !1,
    transitionName: vt,
    choiceTransitionName: At = "",
    status: xt,
    treeExpandAction: bt,
    builtinPlacements: Et,
    dropdownMatchSelectWidth: St,
    popupMatchSelectWidth: Bt,
    allowClear: Ot
  } = a, Pt = __rest$a(a, ["prefixCls", "size", "disabled", "bordered", "className", "rootClassName", "treeCheckable", "multiple", "listHeight", "listItemHeight", "placement", "notFoundContent", "switcherIcon", "treeLine", "getPopupContainer", "popupClassName", "dropdownClassName", "treeIcon", "transitionName", "choiceTransitionName", "status", "treeExpandAction", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "allowClear"]);
  const {
    getPopupContainer: wt,
    getPrefixCls: Ct,
    renderEmpty: It,
    direction: yt,
    virtual: Rt,
    popupMatchSelectWidth: kt,
    popupOverflow: jt
  } = reactExports.useContext(ConfigContext$1), Ht = Ct(), Ft = Ct("select", _e), _t = Ct("select-tree", _e), Nt = Ct("tree-select", _e), {
    compactSize: Mt,
    compactItemClassnames: Lt
  } = useCompactItemContext(Ft, yt), $t = useCSSVarCls$1(Ft), Tt = useCSSVarCls$1(Nt), [Dt, Ut, Vt] = useSelectStyle(Ft, $t), [Qt] = useTreeSelectStyle(Nt, _t, Tt), qt = classnames(pt || mt, `${Nt}-dropdown`, {
    [`${Nt}-dropdown-rtl`]: yt === "rtl"
  }, rt, Vt, $t, Tt, Ut), Zt = !!(st || lt), ar = useShowArrow(Pt.suffixIcon, Pt.showArrow), Jt = ($ = Bt ?? St) !== null && $ !== void 0 ? $ : kt, {
    status: rr,
    hasFeedback: Yt,
    isFormItemInput: Kt,
    feedbackIcon: nr
  } = reactExports.useContext(FormItemInputContext), tr = getMergedStatus(rr, xt), {
    suffixIcon: ir,
    removeIcon: sr,
    clearIcon: cr
  } = useIcons(Object.assign(Object.assign({}, Pt), {
    multiple: Zt,
    showSuffixIcon: ar,
    hasFeedback: Yt,
    feedbackIcon: nr,
    prefixCls: Ft,
    componentName: "TreeSelect"
  })), or = Ot === !0 ? {
    clearIcon: cr
  } : Ot;
  let Xt;
  ft !== void 0 ? Xt = ft : Xt = (It == null ? void 0 : It("Select")) || /* @__PURE__ */ reactExports.createElement(DefaultRenderEmpty$1, {
    componentName: "Select"
  });
  const Gt = omit(Pt, ["suffixIcon", "itemIcon", "removeIcon", "clearIcon", "switcherIcon"]), Wt = reactExports.useMemo(() => ut !== void 0 ? ut : yt === "rtl" ? "bottomRight" : "bottomLeft", [ut, yt]), er = useBuiltinPlacements(Et, jt), lr = useSize$1((Ar) => {
    var Sr;
    return (Sr = tt ?? Mt) !== null && Sr !== void 0 ? Sr : Ar;
  }), ur = reactExports.useContext(DisabledContext$1), pr = nt ?? ur, yr = classnames(!_e && Nt, {
    [`${Ft}-lg`]: lr === "large",
    [`${Ft}-sm`]: lr === "small",
    [`${Ft}-rtl`]: yt === "rtl",
    [`${Ft}-borderless`]: !at,
    [`${Ft}-in-form-item`]: Kt
  }, getStatusClassNames(Ft, tr, Yt), Lt, ot, rt, Vt, $t, Tt, Ut), Er = (Ar) => /* @__PURE__ */ reactExports.createElement(SwitcherIconCom$1, {
    prefixCls: _t,
    switcherIcon: ht,
    treeNodeProps: Ar,
    showLine: dt
  }), [br] = useZIndex("SelectLike", (_ = Pt.dropdownStyle) === null || _ === void 0 ? void 0 : _.zIndex), gr = /* @__PURE__ */ reactExports.createElement(GenericTreeSelect, Object.assign({
    virtual: Rt,
    disabled: pr
  }, Gt, {
    dropdownMatchSelectWidth: Jt,
    builtinPlacements: er,
    ref: s,
    prefixCls: Ft,
    className: yr,
    listHeight: et,
    listItemHeight: it,
    treeCheckable: st && /* @__PURE__ */ reactExports.createElement("span", {
      className: `${Ft}-tree-checkbox-inner`
    }),
    treeLine: !!dt,
    suffixIcon: ir,
    multiple: Zt,
    placement: Wt,
    removeIcon: sr,
    allowClear: or,
    switcherIcon: Er,
    showTreeIcon: ct,
    notFoundContent: Xt,
    getPopupContainer: gt || wt,
    treeMotion: null,
    dropdownClassName: qt,
    dropdownStyle: Object.assign(Object.assign({}, Pt.dropdownStyle), {
      zIndex: br
    }),
    choiceTransitionName: getTransitionName$1(Ht, "", At),
    transitionName: getTransitionName$1(Ht, "slide-up", vt),
    treeExpandAction: bt
  }));
  return Dt(Qt(gr));
}, TreeSelectRef = /* @__PURE__ */ reactExports.forwardRef(InternalTreeSelect), TreeSelect$1 = TreeSelectRef, PurePanel = genPurePanel$1(TreeSelect$1);
TreeSelect$1.TreeNode = TreeNode;
TreeSelect$1.SHOW_ALL = SHOW_ALL;
TreeSelect$1.SHOW_PARENT = SHOW_PARENT;
TreeSelect$1.SHOW_CHILD = SHOW_CHILD;
TreeSelect$1._InternalPanelDoNotUseOrYouWillBeFired = PurePanel;
const _TreeSelect = TreeSelect$1;
var CopyOutlined$5 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" };
const CopyOutlinedSvg = CopyOutlined$5;
var CopyOutlined$3 = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: CopyOutlinedSvg
  }));
};
const CopyOutlined$4 = /* @__PURE__ */ reactExports.forwardRef(CopyOutlined$3);
var EditOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" };
const EditOutlinedSvg = EditOutlined$2;
var EditOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: EditOutlinedSvg
  }));
};
const EditOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(EditOutlined);
var toggleSelection = function() {
  var a = document.getSelection();
  if (!a.rangeCount)
    return function() {
    };
  for (var s = document.activeElement, $ = [], _ = 0; _ < a.rangeCount; _++)
    $.push(a.getRangeAt(_));
  switch (s.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      s.blur();
      break;
    default:
      s = null;
      break;
  }
  return a.removeAllRanges(), function() {
    a.type === "Caret" && a.removeAllRanges(), a.rangeCount || $.forEach(function(_e) {
      a.addRange(_e);
    }), s && s.focus();
  };
}, deselectCurrent = toggleSelection, clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, defaultMessage = "Copy to clipboard: #{key}, Enter";
function format(a) {
  var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return a.replace(/#{\s*key\s*}/g, s);
}
function copy(a, s) {
  var $, _, _e, tt, nt, at, ot = !1;
  s || (s = {}), $ = s.debug || !1;
  try {
    _e = deselectCurrent(), tt = document.createRange(), nt = document.getSelection(), at = document.createElement("span"), at.textContent = a, at.ariaHidden = "true", at.style.all = "unset", at.style.position = "fixed", at.style.top = 0, at.style.clip = "rect(0, 0, 0, 0)", at.style.whiteSpace = "pre", at.style.webkitUserSelect = "text", at.style.MozUserSelect = "text", at.style.msUserSelect = "text", at.style.userSelect = "text", at.addEventListener("copy", function(st) {
      if (st.stopPropagation(), s.format)
        if (st.preventDefault(), typeof st.clipboardData > "u") {
          $ && console.warn("unable to use e.clipboardData"), $ && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var lt = clipboardToIE11Formatting[s.format] || clipboardToIE11Formatting.default;
          window.clipboardData.setData(lt, a);
        } else
          st.clipboardData.clearData(), st.clipboardData.setData(s.format, a);
      s.onCopy && (st.preventDefault(), s.onCopy(st.clipboardData));
    }), document.body.appendChild(at), tt.selectNodeContents(at), nt.addRange(tt);
    var rt = document.execCommand("copy");
    if (!rt)
      throw new Error("copy command was unsuccessful");
    ot = !0;
  } catch (st) {
    $ && console.error("unable to copy using execCommand: ", st), $ && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(s.format || "text", a), s.onCopy && s.onCopy(window.clipboardData), ot = !0;
    } catch (lt) {
      $ && console.error("unable to copy using clipboardData: ", lt), $ && console.error("falling back to prompt"), _ = format("message" in s ? s.message : defaultMessage), window.prompt(_, a);
    }
  } finally {
    nt && (typeof nt.removeRange == "function" ? nt.removeRange(tt) : nt.removeAllRanges()), at && document.body.removeChild(at), _e();
  }
  return ot;
}
var copyToClipboard = copy;
const copy$1 = /* @__PURE__ */ getDefaultExportFromCjs(copyToClipboard);
var EnterOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, name: "enter", theme: "outlined" };
const EnterOutlinedSvg = EnterOutlined$2;
var EnterOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: EnterOutlinedSvg
  }));
};
const EnterOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(EnterOutlined), getTitleStyle = (a, s, $, _) => {
  const {
    titleMarginBottom: _e,
    fontWeightStrong: tt
  } = _;
  return {
    marginBottom: _e,
    color: $,
    fontWeight: tt,
    fontSize: a,
    lineHeight: s
  };
}, getTitleStyles = (a) => {
  const s = [1, 2, 3, 4, 5], $ = {};
  return s.forEach((_) => {
    $[`
      h${_}&,
      div&-h${_},
      div&-h${_} > textarea,
      h${_}
    `] = getTitleStyle(a[`fontSizeHeading${_}`], a[`lineHeightHeading${_}`], a.colorTextHeading, a);
  }), $;
}, getLinkStyles = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    "a&, a": Object.assign(Object.assign({}, operationUnit(a)), {
      textDecoration: a.linkDecoration,
      "&:active, &:hover": {
        textDecoration: a.linkHoverDecoration
      },
      [`&[disabled], &${s}-disabled`]: {
        color: a.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: a.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
}, getResetStyles = (a) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: a.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: a.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: gold$1[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: 600
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: a.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
}), getEditableStyles = (a) => {
  const {
    componentCls: s,
    paddingSM: $
  } = a, _ = $;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: a.calc(a.paddingSM).mul(-1).equal(),
        marginTop: a.calc(_).mul(-1).equal(),
        marginBottom: `calc(1em - ${unit$1(_)})`
      },
      [`${s}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: a.calc(a.marginXS).add(2).equal(),
        insetBlockEnd: a.marginXS,
        color: a.colorTextDescription,
        // default style
        fontWeight: "normal",
        fontSize: a.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
}, getCopyableStyles = (a) => ({
  "&-copy-success": {
    "\n    &,\n    &:hover,\n    &:focus": {
      color: a.colorSuccess
    }
  }
}), getEllipsisStyles = () => ({
  "\n  a&-ellipsis,\n  span&-ellipsis\n  ": {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-single-line": {
    whiteSpace: "nowrap"
  },
  "&-ellipsis-single-line": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
}), genTypographyStyle = (a) => {
  const {
    componentCls: s,
    titleMarginTop: $
  } = a;
  return {
    [s]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: a.colorText,
      wordBreak: "break-word",
      lineHeight: a.lineHeight,
      [`&${s}-secondary`]: {
        color: a.colorTextDescription
      },
      [`&${s}-success`]: {
        color: a.colorSuccess
      },
      [`&${s}-warning`]: {
        color: a.colorWarning
      },
      [`&${s}-danger`]: {
        color: a.colorError,
        "a&:active, a&:focus": {
          color: a.colorErrorActive
        },
        "a&:hover": {
          color: a.colorErrorHover
        }
      },
      [`&${s}-disabled`]: {
        color: a.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      "\n        div&,\n        p\n      ": {
        marginBottom: "1em"
      }
    }, getTitleStyles(a)), {
      [`
      & + h1${s},
      & + h2${s},
      & + h3${s},
      & + h4${s},
      & + h5${s}
      `]: {
        marginTop: $
      },
      "\n      div,\n      ul,\n      li,\n      p,\n      h1,\n      h2,\n      h3,\n      h4,\n      h5": {
        "\n        + h1,\n        + h2,\n        + h3,\n        + h4,\n        + h5\n        ": {
          marginTop: $
        }
      }
    }), getResetStyles(a)), getLinkStyles(a)), {
      // Operation
      [`
        ${s}-expand,
        ${s}-edit,
        ${s}-copy
      `]: Object.assign(Object.assign({}, operationUnit(a)), {
        marginInlineStart: a.marginXXS
      })
    }), getEditableStyles(a)), getCopyableStyles(a)), getEllipsisStyles()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
}, prepareComponentToken$1 = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
}), useStyle$1 = genStyleHooks("Typography", (a) => [genTypographyStyle(a)], prepareComponentToken$1), Editable = (a) => {
  const {
    prefixCls: s,
    "aria-label": $,
    className: _,
    style: _e,
    direction: tt,
    maxLength: nt,
    autoSize: at = !0,
    value: ot,
    onSave: rt,
    onCancel: st,
    onEnd: lt,
    component: et,
    enterIcon: it = /* @__PURE__ */ reactExports.createElement(EnterOutlined$1, null)
  } = a, ut = reactExports.useRef(null), ft = reactExports.useRef(!1), ht = reactExports.useRef(), [dt, gt] = reactExports.useState(ot);
  reactExports.useEffect(() => {
    gt(ot);
  }, [ot]), reactExports.useEffect(() => {
    if (ut.current && ut.current.resizableTextArea) {
      const {
        textArea: wt
      } = ut.current.resizableTextArea;
      wt.focus();
      const {
        length: Ct
      } = wt.value;
      wt.setSelectionRange(Ct, Ct);
    }
  }, []);
  const pt = (wt) => {
    let {
      target: Ct
    } = wt;
    gt(Ct.value.replace(/[\n\r]/g, ""));
  }, mt = () => {
    ft.current = !0;
  }, ct = () => {
    ft.current = !1;
  }, vt = (wt) => {
    let {
      keyCode: Ct
    } = wt;
    ft.current || (ht.current = Ct);
  }, At = () => {
    rt(dt.trim());
  }, xt = (wt) => {
    let {
      keyCode: Ct,
      ctrlKey: It,
      altKey: yt,
      metaKey: Rt,
      shiftKey: kt
    } = wt;
    ht.current === Ct && !ft.current && !It && !yt && !Rt && !kt && (Ct === KeyCode.ENTER ? (At(), lt == null || lt()) : Ct === KeyCode.ESC && st());
  }, bt = () => {
    At();
  }, Et = et ? `${s}-${et}` : "", [St, Bt, Ot] = useStyle$1(s), Pt = classnames(s, `${s}-edit-content`, {
    [`${s}-rtl`]: tt === "rtl"
  }, _, Et, Bt, Ot);
  return St(/* @__PURE__ */ reactExports.createElement("div", {
    className: Pt,
    style: _e
  }, /* @__PURE__ */ reactExports.createElement(TextArea$4, {
    ref: ut,
    maxLength: nt,
    value: dt,
    onChange: pt,
    onKeyDown: vt,
    onKeyUp: xt,
    onCompositionStart: mt,
    onCompositionEnd: ct,
    onBlur: bt,
    "aria-label": $,
    rows: 1,
    autoSize: at
  }), it !== null ? cloneElement(it, {
    className: `${s}-edit-content-confirm`
  }) : null));
}, Editable$1 = Editable;
var __rest$9 = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Typography$2 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    prefixCls: $,
    component: _ = "article",
    className: _e,
    rootClassName: tt,
    setContentRef: nt,
    children: at,
    direction: ot,
    style: rt
  } = a, st = __rest$9(a, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]), {
    getPrefixCls: lt,
    direction: et,
    typography: it
  } = reactExports.useContext(ConfigContext$1), ut = ot ?? et;
  let ft = s;
  nt && (ft = composeRef(s, nt));
  const ht = lt("typography", $), [dt, gt, pt] = useStyle$1(ht), mt = classnames(ht, it == null ? void 0 : it.className, {
    [`${ht}-rtl`]: ut === "rtl"
  }, _e, tt, gt, pt), ct = Object.assign(Object.assign({}, it == null ? void 0 : it.style), rt);
  return dt(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ reactExports.createElement(_, Object.assign({
      className: mt,
      style: ct,
      ref: ft
    }, st), at)
  );
}), OriginTypography = Typography$2;
function useMergedConfig(a, s) {
  return reactExports.useMemo(() => {
    const $ = !!a;
    return [$, Object.assign(Object.assign({}, s), $ && typeof a == "object" ? a : null)];
  }, [a]);
}
const useUpdatedEffect = (a, s) => {
  const $ = reactExports.useRef(!1);
  reactExports.useEffect(() => {
    $.current ? a() : $.current = !0;
  }, s);
}, useUpdatedEffect$1 = useUpdatedEffect;
function cuttable(a) {
  const s = typeof a;
  return s === "string" || s === "number";
}
function getNodesLen(a) {
  let s = 0;
  return a.forEach(($) => {
    cuttable($) ? s += String($).length : s += 1;
  }), s;
}
function sliceNodes(a, s) {
  let $ = 0;
  const _ = [];
  for (let _e = 0; _e < a.length; _e += 1) {
    if ($ === s)
      return _;
    const tt = a[_e], at = cuttable(tt) ? String(tt).length : 1, ot = $ + at;
    if (ot > s) {
      const rt = s - $;
      return _.push(String(tt).slice(0, rt)), _;
    }
    _.push(tt), $ = ot;
  }
  return a;
}
const NONE = 0, PREPARE = 1, WALKING = 2, DONE_WITH_ELLIPSIS = 3, DONE_WITHOUT_ELLIPSIS = 4, Ellipsis = (a) => {
  let {
    enabledMeasure: s,
    children: $,
    text: _,
    width: _e,
    fontSize: tt,
    rows: nt,
    onEllipsis: at
  } = a;
  const [[ot, rt, st], lt] = reactExports.useState([0, 0, 0]), [et, it] = reactExports.useState(0), [ut, ft] = reactExports.useState(NONE), [ht, dt] = reactExports.useState(0), gt = reactExports.useRef(null), pt = reactExports.useRef(null), mt = reactExports.useMemo(() => toArray$9(_), [_]), ct = reactExports.useMemo(() => getNodesLen(mt), [mt]), vt = reactExports.useMemo(() => !s || ut !== DONE_WITH_ELLIPSIS ? et && ut !== DONE_WITHOUT_ELLIPSIS && s ? $(sliceNodes(mt, et), et < ct) : $(mt, !1) : $(sliceNodes(mt, rt), rt < ct), [s, ut, $, mt, rt, ct]);
  useLayoutEffect$1(() => {
    s && _e && tt && ct && (ft(PREPARE), lt([0, Math.ceil(ct / 2), ct]));
  }, [s, _e, tt, _, ct, nt]), useLayoutEffect$1(() => {
    var Et;
    ut === PREPARE && dt(((Et = gt.current) === null || Et === void 0 ? void 0 : Et.offsetHeight) || 0);
  }, [ut]), useLayoutEffect$1(() => {
    var Et, St;
    if (ht) {
      if (ut === PREPARE) {
        const Bt = ((Et = pt.current) === null || Et === void 0 ? void 0 : Et.offsetHeight) || 0, Ot = nt * ht;
        Bt <= Ot ? (ft(DONE_WITHOUT_ELLIPSIS), at(!1)) : ft(WALKING);
      } else if (ut === WALKING)
        if (ot !== st) {
          const Bt = ((St = pt.current) === null || St === void 0 ? void 0 : St.offsetHeight) || 0, Ot = nt * ht;
          let Pt = ot, wt = st;
          ot === st - 1 ? wt = ot : Bt <= Ot ? Pt = rt : wt = rt;
          const Ct = Math.ceil((Pt + wt) / 2);
          lt([Pt, Ct, wt]);
        } else
          ft(DONE_WITH_ELLIPSIS), it(rt), at(!0);
    }
  }, [ut, ot, st, nt, ht]);
  const At = {
    width: _e,
    whiteSpace: "normal",
    margin: 0,
    padding: 0
  }, xt = (Et, St, Bt) => /* @__PURE__ */ reactExports.createElement("span", {
    "aria-hidden": !0,
    ref: St,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      zIndex: -9999,
      visibility: "hidden",
      pointerEvents: "none",
      fontSize: Math.ceil(tt / 2) * 2
    }, Bt)
  }, Et), bt = (Et, St) => {
    const Bt = sliceNodes(mt, Et);
    return xt($(Bt, !0), St, At);
  };
  return /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, vt, s && ut !== DONE_WITH_ELLIPSIS && ut !== DONE_WITHOUT_ELLIPSIS && /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, xt("lg", gt, {
    wordBreak: "keep-all",
    whiteSpace: "nowrap"
  }), ut === PREPARE ? xt($(mt, !1), pt, At) : bt(rt, pt)));
}, Ellipsis$1 = Ellipsis, EllipsisTooltip = (a) => {
  let {
    enabledEllipsis: s,
    isEllipsis: $,
    children: _,
    tooltipProps: _e
  } = a;
  return !(_e != null && _e.title) || !s ? _ : /* @__PURE__ */ reactExports.createElement(_Tooltip, Object.assign({
    open: $ ? void 0 : !1
  }, _e), _);
}, EllipsisTooltip$1 = EllipsisTooltip;
var __rest$8 = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
function wrapperDecorations(a, s) {
  let {
    mark: $,
    code: _,
    underline: _e,
    delete: tt,
    strong: nt,
    keyboard: at,
    italic: ot
  } = a, rt = s;
  function st(lt, et) {
    et && (rt = /* @__PURE__ */ reactExports.createElement(lt, {}, rt));
  }
  return st("strong", nt), st("u", _e), st("del", tt), st("code", _), st("mark", $), st("kbd", at), st("i", ot), rt;
}
function getNode(a, s, $) {
  return a === !0 || a === void 0 ? s : a || $ && s;
}
function toList(a) {
  return a === !1 ? [!1, !1] : Array.isArray(a) ? a : [a];
}
const ELLIPSIS_STR = "...", Base = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var $, _, _e;
  const {
    prefixCls: tt,
    className: nt,
    style: at,
    type: ot,
    disabled: rt,
    children: st,
    ellipsis: lt,
    editable: et,
    copyable: it,
    component: ut,
    title: ft
  } = a, ht = __rest$8(a, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]), {
    getPrefixCls: dt,
    direction: gt
  } = reactExports.useContext(ConfigContext$1), [pt] = useLocale$1("Text"), mt = reactExports.useRef(null), ct = reactExports.useRef(null), vt = dt("typography", tt), At = omit(ht, ["mark", "code", "delete", "underline", "strong", "keyboard", "italic"]), [xt, bt] = useMergedConfig(et), [Et, St] = useMergedState(!1, {
    value: bt.editing
  }), {
    triggerType: Bt = ["icon"]
  } = bt, Ot = (Br) => {
    var Ir;
    Br && ((Ir = bt.onStart) === null || Ir === void 0 || Ir.call(bt)), St(Br);
  };
  useUpdatedEffect$1(() => {
    var Br;
    Et || (Br = ct.current) === null || Br === void 0 || Br.focus();
  }, [Et]);
  const Pt = (Br) => {
    Br == null || Br.preventDefault(), Ot(!0);
  }, wt = (Br) => {
    var Ir;
    (Ir = bt.onChange) === null || Ir === void 0 || Ir.call(bt, Br), Ot(!1);
  }, Ct = () => {
    var Br;
    (Br = bt.onCancel) === null || Br === void 0 || Br.call(bt), Ot(!1);
  }, [It, yt] = useMergedConfig(it), [Rt, kt] = reactExports.useState(!1), jt = reactExports.useRef(null), Ht = {};
  yt.format && (Ht.format = yt.format);
  const Ft = () => {
    jt.current && clearTimeout(jt.current);
  }, _t = (Br) => {
    var Ir;
    Br == null || Br.preventDefault(), Br == null || Br.stopPropagation(), copy$1(yt.text || String(st) || "", Ht), kt(!0), Ft(), jt.current = setTimeout(() => {
      kt(!1);
    }, 3e3), (Ir = yt.onCopy) === null || Ir === void 0 || Ir.call(yt, Br);
  };
  reactExports.useEffect(() => Ft, []);
  const [Nt, Mt] = reactExports.useState(!1), [Lt, $t] = reactExports.useState(!1), [Tt, Dt] = reactExports.useState(!1), [Ut, Vt] = reactExports.useState(!1), [Qt, qt] = reactExports.useState(!1), [Zt, ar] = reactExports.useState(!0), [Jt, rr] = useMergedConfig(lt, {
    expandable: !1
  }), Yt = Jt && !Tt, {
    rows: Kt = 1
  } = rr, nr = reactExports.useMemo(() => (
    // Disable ellipsis
    !Yt || // Provide suffix
    rr.suffix !== void 0 || rr.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    rr.expandable || xt || It
  ), [Yt, rr, xt, It]);
  useLayoutEffect$1(() => {
    Jt && !nr && (Mt(isStyleSupport("webkitLineClamp")), $t(isStyleSupport("textOverflow")));
  }, [nr, Jt]);
  const tr = reactExports.useMemo(() => nr ? !1 : Kt === 1 ? Lt : Nt, [nr, Lt, Nt]), ir = Yt && (tr ? Qt : Ut), sr = Yt && Kt === 1 && tr, cr = Yt && Kt > 1 && tr, or = (Br) => {
    var Ir;
    Dt(!0), (Ir = rr.onExpand) === null || Ir === void 0 || Ir.call(rr, Br);
  }, [Xt, Gt] = reactExports.useState(0), [Wt, er] = reactExports.useState(0), lr = (Br, Ir) => {
    let {
      offsetWidth: hr
    } = Br;
    var vr;
    Gt(hr), er(parseInt((vr = window.getComputedStyle) === null || vr === void 0 ? void 0 : vr.call(window, Ir).fontSize, 10) || 0);
  }, ur = (Br) => {
    var Ir;
    Vt(Br), Ut !== Br && ((Ir = rr.onEllipsis) === null || Ir === void 0 || Ir.call(rr, Br));
  };
  reactExports.useEffect(() => {
    const Br = mt.current;
    if (Jt && tr && Br) {
      const Ir = cr ? Br.offsetHeight < Br.scrollHeight : Br.offsetWidth < Br.scrollWidth;
      Qt !== Ir && qt(Ir);
    }
  }, [Jt, tr, st, cr, Zt]), reactExports.useEffect(() => {
    const Br = mt.current;
    if (typeof IntersectionObserver > "u" || !Br || !tr || !Yt)
      return;
    const Ir = new IntersectionObserver(() => {
      ar(!!Br.offsetParent);
    });
    return Ir.observe(Br), () => {
      Ir.disconnect();
    };
  }, [tr, Yt]);
  let pr = {};
  rr.tooltip === !0 ? pr = {
    title: ($ = bt.text) !== null && $ !== void 0 ? $ : st
  } : /* @__PURE__ */ reactExports.isValidElement(rr.tooltip) ? pr = {
    title: rr.tooltip
  } : typeof rr.tooltip == "object" ? pr = Object.assign({
    title: (_ = bt.text) !== null && _ !== void 0 ? _ : st
  }, rr.tooltip) : pr = {
    title: rr.tooltip
  };
  const yr = reactExports.useMemo(() => {
    const Br = (Ir) => ["string", "number"].includes(typeof Ir);
    if (!(!Jt || tr)) {
      if (Br(bt.text))
        return bt.text;
      if (Br(st))
        return st;
      if (Br(ft))
        return ft;
      if (Br(pr.title))
        return pr.title;
    }
  }, [Jt, tr, ft, pr.title, ir]);
  if (Et)
    return /* @__PURE__ */ reactExports.createElement(Editable$1, {
      value: (_e = bt.text) !== null && _e !== void 0 ? _e : typeof st == "string" ? st : "",
      onSave: wt,
      onCancel: Ct,
      onEnd: bt.onEnd,
      prefixCls: vt,
      className: nt,
      style: at,
      direction: gt,
      component: ut,
      maxLength: bt.maxLength,
      autoSize: bt.autoSize,
      enterIcon: bt.enterIcon
    });
  const Er = () => {
    const {
      expandable: Br,
      symbol: Ir
    } = rr;
    if (!Br)
      return null;
    let hr;
    return Ir ? hr = Ir : hr = pt == null ? void 0 : pt.expand, /* @__PURE__ */ reactExports.createElement("a", {
      key: "expand",
      className: `${vt}-expand`,
      onClick: or,
      "aria-label": pt == null ? void 0 : pt.expand
    }, hr);
  }, br = () => {
    if (!xt)
      return;
    const {
      icon: Br,
      tooltip: Ir
    } = bt, hr = toArray$9(Ir)[0] || (pt == null ? void 0 : pt.edit), vr = typeof hr == "string" ? hr : "";
    return Bt.includes("icon") ? /* @__PURE__ */ reactExports.createElement(_Tooltip, {
      key: "edit",
      title: Ir === !1 ? "" : hr
    }, /* @__PURE__ */ reactExports.createElement(TransButton$1, {
      ref: ct,
      className: `${vt}-edit`,
      onClick: Pt,
      "aria-label": vr
    }, Br || /* @__PURE__ */ reactExports.createElement(EditOutlined$1, {
      role: "button"
    }))) : null;
  }, gr = () => {
    if (!It)
      return;
    const {
      tooltips: Br,
      icon: Ir
    } = yt, hr = toList(Br), vr = toList(Ir), xr = Rt ? getNode(hr[1], pt == null ? void 0 : pt.copied) : getNode(hr[0], pt == null ? void 0 : pt.copy), Pr = Rt ? pt == null ? void 0 : pt.copied : pt == null ? void 0 : pt.copy, Rr = typeof xr == "string" ? xr : Pr;
    return /* @__PURE__ */ reactExports.createElement(_Tooltip, {
      key: "copy",
      title: xr
    }, /* @__PURE__ */ reactExports.createElement(TransButton$1, {
      className: classnames(`${vt}-copy`, Rt && `${vt}-copy-success`),
      onClick: _t,
      "aria-label": Rr
    }, Rt ? getNode(vr[1], /* @__PURE__ */ reactExports.createElement(CheckOutlined$1, null), !0) : getNode(vr[0], /* @__PURE__ */ reactExports.createElement(CopyOutlined$4, null), !0)));
  }, Ar = (Br) => [Br && Er(), br(), gr()], Sr = (Br) => [Br && /* @__PURE__ */ reactExports.createElement("span", {
    "aria-hidden": !0,
    key: "ellipsis"
  }, ELLIPSIS_STR), rr.suffix, Ar(Br)];
  return /* @__PURE__ */ reactExports.createElement(RefResizeObserver, {
    onResize: lr,
    disabled: !Yt || tr
  }, (Br) => /* @__PURE__ */ reactExports.createElement(EllipsisTooltip$1, {
    tooltipProps: pr,
    enabledEllipsis: Yt,
    isEllipsis: ir
  }, /* @__PURE__ */ reactExports.createElement(OriginTypography, Object.assign({
    className: classnames({
      [`${vt}-${ot}`]: ot,
      [`${vt}-disabled`]: rt,
      [`${vt}-ellipsis`]: Jt,
      [`${vt}-single-line`]: Yt && Kt === 1,
      [`${vt}-ellipsis-single-line`]: sr,
      [`${vt}-ellipsis-multiple-line`]: cr
    }, nt),
    prefixCls: tt,
    style: Object.assign(Object.assign({}, at), {
      WebkitLineClamp: cr ? Kt : void 0
    }),
    component: ut,
    ref: composeRef(Br, mt, s),
    direction: gt,
    onClick: Bt.includes("text") ? Pt : void 0,
    "aria-label": yr == null ? void 0 : yr.toString(),
    title: ft
  }, At), /* @__PURE__ */ reactExports.createElement(Ellipsis$1, {
    enabledMeasure: Yt && !tr,
    text: st,
    rows: Kt,
    width: Xt,
    fontSize: Wt,
    onEllipsis: ur
  }, (Ir, hr) => {
    let vr = Ir;
    return Ir.length && hr && yr && (vr = /* @__PURE__ */ reactExports.createElement("span", {
      key: "show-content",
      "aria-hidden": !0
    }, vr)), wrapperDecorations(a, /* @__PURE__ */ reactExports.createElement(reactExports.Fragment, null, vr, Sr(hr)));
  }))));
}), Base$1 = Base;
var __rest$7 = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Link$1 = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var {
    ellipsis: $,
    rel: _
  } = a, _e = __rest$7(a, ["ellipsis", "rel"]);
  const tt = Object.assign(Object.assign({}, _e), {
    rel: _ === void 0 && _e.target === "_blank" ? "noopener noreferrer" : _
  });
  return delete tt.navigate, /* @__PURE__ */ reactExports.createElement(Base$1, Object.assign({}, tt, {
    ref: s,
    ellipsis: !!$,
    component: "a"
  }));
}), Link$2 = Link$1, Paragraph = /* @__PURE__ */ reactExports.forwardRef((a, s) => /* @__PURE__ */ reactExports.createElement(Base$1, Object.assign({
  ref: s
}, a, {
  component: "div"
}))), Paragraph$1 = Paragraph;
var __rest$6 = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Text$5 = (a, s) => {
  var {
    ellipsis: $
  } = a, _ = __rest$6(a, ["ellipsis"]);
  const _e = reactExports.useMemo(() => $ && typeof $ == "object" ? omit($, ["expandable", "rows"]) : $, [$]);
  return /* @__PURE__ */ reactExports.createElement(Base$1, Object.assign({
    ref: s
  }, _, {
    ellipsis: _e,
    component: "span"
  }));
}, Text$6 = /* @__PURE__ */ reactExports.forwardRef(Text$5);
var __rest$5 = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const TITLE_ELE_LIST = [1, 2, 3, 4, 5], Title = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  const {
    level: $ = 1
  } = a, _ = __rest$5(a, ["level"]);
  let _e;
  return TITLE_ELE_LIST.includes($) ? _e = `h${$}` : _e = "h1", /* @__PURE__ */ reactExports.createElement(Base$1, Object.assign({
    ref: s
  }, _, {
    component: _e
  }));
}), Title$1 = Title, Typography = OriginTypography;
Typography.Text = Text$6;
Typography.Link = Link$2;
Typography.Title = Title$1;
Typography.Paragraph = Paragraph$1;
const Typography$1 = Typography;
function getError(a, s) {
  var $ = "cannot ".concat(a.method, " ").concat(a.action, " ").concat(s.status, "'"), _ = new Error($);
  return _.status = s.status, _.method = a.method, _.url = a.action, _;
}
function getBody(a) {
  var s = a.responseText || a.response;
  if (!s)
    return s;
  try {
    return JSON.parse(s);
  } catch {
    return s;
  }
}
function upload(a) {
  var s = new XMLHttpRequest();
  a.onProgress && s.upload && (s.upload.onprogress = function(tt) {
    tt.total > 0 && (tt.percent = tt.loaded / tt.total * 100), a.onProgress(tt);
  });
  var $ = new FormData();
  a.data && Object.keys(a.data).forEach(function(_e) {
    var tt = a.data[_e];
    if (Array.isArray(tt)) {
      tt.forEach(function(nt) {
        $.append("".concat(_e, "[]"), nt);
      });
      return;
    }
    $.append(_e, tt);
  }), a.file instanceof Blob ? $.append(a.filename, a.file, a.file.name) : $.append(a.filename, a.file), s.onerror = function(tt) {
    a.onError(tt);
  }, s.onload = function() {
    return s.status < 200 || s.status >= 300 ? a.onError(getError(a, s), getBody(s)) : a.onSuccess(getBody(s), s);
  }, s.open(a.method, a.action, !0), a.withCredentials && "withCredentials" in s && (s.withCredentials = !0);
  var _ = a.headers || {};
  return _["X-Requested-With"] !== null && s.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(_).forEach(function(_e) {
    _[_e] !== null && s.setRequestHeader(_e, _[_e]);
  }), s.send($), {
    abort: function() {
      s.abort();
    }
  };
}
var now$1 = +/* @__PURE__ */ new Date(), index$3 = 0;
function uid$3() {
  return "rc-upload-".concat(now$1, "-").concat(++index$3);
}
const attrAccept = function(a, s) {
  if (a && s) {
    var $ = Array.isArray(s) ? s : s.split(","), _ = a.name || "", _e = a.type || "", tt = _e.replace(/\/.*$/, "");
    return $.some(function(nt) {
      var at = nt.trim();
      if (/^\*(\/\*)?$/.test(nt))
        return !0;
      if (at.charAt(0) === ".") {
        var ot = _.toLowerCase(), rt = at.toLowerCase(), st = [rt];
        return (rt === ".jpg" || rt === ".jpeg") && (st = [".jpg", ".jpeg"]), st.some(function(lt) {
          return ot.endsWith(lt);
        });
      }
      return /\/\*$/.test(at) ? tt === at.replace(/\/.*$/, "") : _e === at ? !0 : /^\w+$/.test(at) ? (warningOnce(!1, "Upload takes an invalidate 'accept' type '".concat(at, "'.Skip for check.")), !0) : !1;
    });
  }
  return !0;
};
function loopFiles(a, s) {
  var $ = a.createReader(), _ = [];
  function _e() {
    $.readEntries(function(tt) {
      var nt = Array.prototype.slice.apply(tt);
      _ = _.concat(nt);
      var at = !nt.length;
      at ? s(_) : _e();
    });
  }
  _e();
}
var traverseFileTree = function a(s, $, _) {
  var _e = function tt(nt, at) {
    nt && (nt.path = at || "", nt.isFile ? nt.file(function(ot) {
      _(ot) && (nt.fullPath && !ot.webkitRelativePath && (Object.defineProperties(ot, {
        webkitRelativePath: {
          writable: !0
        }
      }), ot.webkitRelativePath = nt.fullPath.replace(/^\//, ""), Object.defineProperties(ot, {
        webkitRelativePath: {
          writable: !1
        }
      })), $([ot]));
    }) : nt.isDirectory && loopFiles(nt, function(ot) {
      ot.forEach(function(rt) {
        tt(rt, "".concat(at).concat(nt.name, "/"));
      });
    }));
  };
  s.forEach(function(tt) {
    _e(tt.webkitGetAsEntry());
  });
}, _excluded$1 = ["component", "prefixCls", "className", "disabled", "id", "style", "multiple", "accept", "capture", "children", "directory", "openFileDialogOnClick", "onMouseEnter", "onMouseLeave"], AjaxUploader = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $() {
    var _;
    _classCallCheck(this, $);
    for (var _e = arguments.length, tt = new Array(_e), nt = 0; nt < _e; nt++)
      tt[nt] = arguments[nt];
    return _ = s.call.apply(s, [this].concat(tt)), _.state = {
      uid: uid$3()
    }, _.reqs = {}, _.fileInput = void 0, _._isMounted = void 0, _.onChange = function(at) {
      var ot = _.props, rt = ot.accept, st = ot.directory, lt = at.target.files, et = _toConsumableArray$d(lt).filter(function(it) {
        return !st || attrAccept(it, rt);
      });
      _.uploadFiles(et), _.reset();
    }, _.onClick = function(at) {
      var ot = _.fileInput;
      if (ot) {
        var rt = at.target, st = _.props.onClick;
        if (rt && rt.tagName === "BUTTON") {
          var lt = ot.parentNode;
          lt.focus(), rt.blur();
        }
        ot.click(), st && st(at);
      }
    }, _.onKeyDown = function(at) {
      at.key === "Enter" && _.onClick(at);
    }, _.onFileDrop = function(at) {
      var ot = _.props.multiple;
      if (at.preventDefault(), at.type !== "dragover")
        if (_.props.directory)
          traverseFileTree(Array.prototype.slice.call(at.dataTransfer.items), _.uploadFiles, function(st) {
            return attrAccept(st, _.props.accept);
          });
        else {
          var rt = _toConsumableArray$d(at.dataTransfer.files).filter(function(st) {
            return attrAccept(st, _.props.accept);
          });
          ot === !1 && (rt = rt.slice(0, 1)), _.uploadFiles(rt);
        }
    }, _.uploadFiles = function(at) {
      var ot = _toConsumableArray$d(at), rt = ot.map(function(st) {
        return st.uid = uid$3(), _.processFile(st, ot);
      });
      Promise.all(rt).then(function(st) {
        var lt = _.props.onBatchStart;
        lt == null || lt(st.map(function(et) {
          var it = et.origin, ut = et.parsedFile;
          return {
            file: it,
            parsedFile: ut
          };
        })), st.filter(function(et) {
          return et.parsedFile !== null;
        }).forEach(function(et) {
          _.post(et);
        });
      });
    }, _.processFile = /* @__PURE__ */ function() {
      var at = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime$3().mark(function ot(rt, st) {
        var lt, et, it, ut, ft, ht, dt, gt, pt;
        return _regeneratorRuntime$3().wrap(function(ct) {
          for (; ; )
            switch (ct.prev = ct.next) {
              case 0:
                if (lt = _.props.beforeUpload, et = rt, !lt) {
                  ct.next = 14;
                  break;
                }
                return ct.prev = 3, ct.next = 6, lt(rt, st);
              case 6:
                et = ct.sent, ct.next = 12;
                break;
              case 9:
                ct.prev = 9, ct.t0 = ct.catch(3), et = !1;
              case 12:
                if (et !== !1) {
                  ct.next = 14;
                  break;
                }
                return ct.abrupt("return", {
                  origin: rt,
                  parsedFile: null,
                  action: null,
                  data: null
                });
              case 14:
                if (it = _.props.action, typeof it != "function") {
                  ct.next = 21;
                  break;
                }
                return ct.next = 18, it(rt);
              case 18:
                ut = ct.sent, ct.next = 22;
                break;
              case 21:
                ut = it;
              case 22:
                if (ft = _.props.data, typeof ft != "function") {
                  ct.next = 29;
                  break;
                }
                return ct.next = 26, ft(rt);
              case 26:
                ht = ct.sent, ct.next = 30;
                break;
              case 29:
                ht = ft;
              case 30:
                return dt = // string type is from legacy `transformFile`.
                // Not sure if this will work since no related test case works with it
                (_typeof$q(et) === "object" || typeof et == "string") && et ? et : rt, dt instanceof File ? gt = dt : gt = new File([dt], rt.name, {
                  type: rt.type
                }), pt = gt, pt.uid = rt.uid, ct.abrupt("return", {
                  origin: rt,
                  data: ht,
                  parsedFile: pt,
                  action: ut
                });
              case 35:
              case "end":
                return ct.stop();
            }
        }, ot, null, [[3, 9]]);
      }));
      return function(ot, rt) {
        return at.apply(this, arguments);
      };
    }(), _.saveFileInput = function(at) {
      _.fileInput = at;
    }, _;
  }
  return _createClass($, [{
    key: "componentDidMount",
    value: function() {
      this._isMounted = !0;
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._isMounted = !1, this.abort();
    }
  }, {
    key: "post",
    value: function(_e) {
      var tt = this, nt = _e.data, at = _e.origin, ot = _e.action, rt = _e.parsedFile;
      if (this._isMounted) {
        var st = this.props, lt = st.onStart, et = st.customRequest, it = st.name, ut = st.headers, ft = st.withCredentials, ht = st.method, dt = at.uid, gt = et || upload, pt = {
          action: ot,
          filename: it,
          data: nt,
          file: rt,
          headers: ut,
          withCredentials: ft,
          method: ht || "post",
          onProgress: function(ct) {
            var vt = tt.props.onProgress;
            vt == null || vt(ct, rt);
          },
          onSuccess: function(ct, vt) {
            var At = tt.props.onSuccess;
            At == null || At(ct, rt, vt), delete tt.reqs[dt];
          },
          onError: function(ct, vt) {
            var At = tt.props.onError;
            At == null || At(ct, vt, rt), delete tt.reqs[dt];
          }
        };
        lt(at), this.reqs[dt] = gt(pt);
      }
    }
  }, {
    key: "reset",
    value: function() {
      this.setState({
        uid: uid$3()
      });
    }
  }, {
    key: "abort",
    value: function(_e) {
      var tt = this.reqs;
      if (_e) {
        var nt = _e.uid ? _e.uid : _e;
        tt[nt] && tt[nt].abort && tt[nt].abort(), delete tt[nt];
      } else
        Object.keys(tt).forEach(function(at) {
          tt[at] && tt[at].abort && tt[at].abort(), delete tt[at];
        });
    }
  }, {
    key: "render",
    value: function() {
      var _e = this.props, tt = _e.component, nt = _e.prefixCls, at = _e.className, ot = _e.disabled, rt = _e.id, st = _e.style, lt = _e.multiple, et = _e.accept, it = _e.capture, ut = _e.children, ft = _e.directory, ht = _e.openFileDialogOnClick, dt = _e.onMouseEnter, gt = _e.onMouseLeave, pt = _objectWithoutProperties$1(_e, _excluded$1), mt = classnames(_defineProperty$c(_defineProperty$c(_defineProperty$c({}, nt, !0), "".concat(nt, "-disabled"), ot), at, at)), ct = ft ? {
        directory: "directory",
        webkitdirectory: "webkitdirectory"
      } : {}, vt = ot ? {} : {
        onClick: ht ? this.onClick : function() {
        },
        onKeyDown: ht ? this.onKeyDown : function() {
        },
        onMouseEnter: dt,
        onMouseLeave: gt,
        onDrop: this.onFileDrop,
        onDragOver: this.onFileDrop,
        tabIndex: "0"
      };
      return /* @__PURE__ */ React$a.createElement(tt, _extends$2({}, vt, {
        className: mt,
        role: "button",
        style: st
      }), /* @__PURE__ */ React$a.createElement("input", _extends$2({}, pickAttrs(pt, {
        aria: !0,
        data: !0
      }), {
        id: rt,
        disabled: ot,
        type: "file",
        ref: this.saveFileInput,
        onClick: function(xt) {
          return xt.stopPropagation();
        },
        key: this.state.uid,
        style: {
          display: "none"
        },
        accept: et
      }, ct, {
        multiple: lt,
        onChange: this.onChange
      }, it != null ? {
        capture: it
      } : {})), ut);
    }
  }]), $;
}(reactExports.Component);
function empty() {
}
var Upload$2 = /* @__PURE__ */ function(a) {
  _inherits($, a);
  var s = _createSuper($);
  function $() {
    var _;
    _classCallCheck(this, $);
    for (var _e = arguments.length, tt = new Array(_e), nt = 0; nt < _e; nt++)
      tt[nt] = arguments[nt];
    return _ = s.call.apply(s, [this].concat(tt)), _.uploader = void 0, _.saveUploader = function(at) {
      _.uploader = at;
    }, _;
  }
  return _createClass($, [{
    key: "abort",
    value: function(_e) {
      this.uploader.abort(_e);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ React$a.createElement(AjaxUploader, _extends$2({}, this.props, {
        ref: this.saveUploader
      }));
    }
  }]), $;
}(reactExports.Component);
Upload$2.defaultProps = {
  component: "span",
  prefixCls: "rc-upload",
  data: {},
  headers: {},
  name: "file",
  multipart: !1,
  onStart: empty,
  onError: empty,
  onSuccess: empty,
  multiple: !1,
  beforeUpload: null,
  customRequest: null,
  withCredentials: !1,
  openFileDialogOnClick: !0
};
const genDraggerStyle = (a) => {
  const {
    componentCls: s,
    iconCls: $
  } = a;
  return {
    [`${s}-wrapper`]: {
      [`${s}-drag`]: {
        position: "relative",
        width: "100%",
        height: "100%",
        textAlign: "center",
        background: a.colorFillAlter,
        border: `${unit$1(a.lineWidth)} dashed ${a.colorBorder}`,
        borderRadius: a.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${a.motionDurationSlow}`,
        [s]: {
          padding: a.padding
        },
        [`${s}-btn`]: {
          display: "table",
          width: "100%",
          height: "100%",
          outline: "none"
        },
        [`${s}-drag-container`]: {
          display: "table-cell",
          verticalAlign: "middle"
        },
        [`
          &:not(${s}-disabled):hover,
          &-hover:not(${s}-disabled)
        `]: {
          borderColor: a.colorPrimaryHover
        },
        [`p${s}-drag-icon`]: {
          marginBottom: a.margin,
          [$]: {
            color: a.colorPrimary,
            fontSize: a.uploadThumbnailSize
          }
        },
        [`p${s}-text`]: {
          margin: `0 0 ${unit$1(a.marginXXS)}`,
          color: a.colorTextHeading,
          fontSize: a.fontSizeLG
        },
        [`p${s}-hint`]: {
          color: a.colorTextDescription,
          fontSize: a.fontSize
        },
        // ===================== Disabled =====================
        [`&${s}-disabled`]: {
          [`p${s}-drag-icon ${$},
            p${s}-text,
            p${s}-hint
          `]: {
            color: a.colorTextDisabled
          }
        }
      }
    }
  };
}, genDraggerStyle$1 = genDraggerStyle, genListStyle = (a) => {
  const {
    componentCls: s,
    antCls: $,
    iconCls: _,
    fontSize: _e,
    lineHeight: tt,
    calc: nt
  } = a, at = `${s}-list-item`, ot = `${at}-actions`, rt = `${at}-action`, st = a.fontHeightSM;
  return {
    [`${s}-wrapper`]: {
      [`${s}-list`]: Object.assign(Object.assign({}, clearFix()), {
        lineHeight: a.lineHeight,
        [at]: {
          position: "relative",
          height: nt(a.lineHeight).mul(_e).equal(),
          marginTop: a.marginXS,
          fontSize: _e,
          display: "flex",
          alignItems: "center",
          transition: `background-color ${a.motionDurationSlow}`,
          "&:hover": {
            backgroundColor: a.controlItemBgHover
          },
          [`${at}-name`]: Object.assign(Object.assign({}, textEllipsis), {
            padding: `0 ${unit$1(a.paddingXS)}`,
            lineHeight: tt,
            flex: "auto",
            transition: `all ${a.motionDurationSlow}`
          }),
          [ot]: {
            [rt]: {
              opacity: 0
            },
            [_]: {
              color: a.actionsColor,
              transition: `all ${a.motionDurationSlow}`
            },
            [`
              ${rt}:focus-visible,
              &.picture ${rt}
            `]: {
              opacity: 1
            },
            [`${rt}${$}-btn`]: {
              height: st,
              border: 0,
              lineHeight: 1
            }
          },
          [`${s}-icon ${_}`]: {
            color: a.colorTextDescription,
            fontSize: _e
          },
          [`${at}-progress`]: {
            position: "absolute",
            bottom: a.calc(a.uploadProgressOffset).mul(-1).equal(),
            width: "100%",
            paddingInlineStart: nt(_e).add(a.paddingXS).equal(),
            fontSize: _e,
            lineHeight: 0,
            pointerEvents: "none",
            "> div": {
              margin: 0
            }
          }
        },
        [`${at}:hover ${rt}`]: {
          opacity: 1
        },
        [`${at}-error`]: {
          color: a.colorError,
          [`${at}-name, ${s}-icon ${_}`]: {
            color: a.colorError
          },
          [ot]: {
            [`${_}, ${_}:hover`]: {
              color: a.colorError
            },
            [rt]: {
              opacity: 1
            }
          }
        },
        [`${s}-list-item-container`]: {
          transition: `opacity ${a.motionDurationSlow}, height ${a.motionDurationSlow}`,
          // For smooth removing animation
          "&::before": {
            display: "table",
            width: 0,
            height: 0,
            content: '""'
          }
        }
      })
    }
  };
}, genListStyle$1 = genListStyle, uploadAnimateInlineIn = new Keyframe("uploadAnimateInlineIn", {
  from: {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0
  }
}), uploadAnimateInlineOut = new Keyframe("uploadAnimateInlineOut", {
  to: {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0
  }
}), genMotionStyle = (a) => {
  const {
    componentCls: s
  } = a, $ = `${s}-animate-inline`;
  return [{
    [`${s}-wrapper`]: {
      [`${$}-appear, ${$}-enter, ${$}-leave`]: {
        animationDuration: a.motionDurationSlow,
        animationTimingFunction: a.motionEaseInOutCirc,
        animationFillMode: "forwards"
      },
      [`${$}-appear, ${$}-enter`]: {
        animationName: uploadAnimateInlineIn
      },
      [`${$}-leave`]: {
        animationName: uploadAnimateInlineOut
      }
    }
  }, {
    [`${s}-wrapper`]: initFadeMotion(a)
  }, uploadAnimateInlineIn, uploadAnimateInlineOut];
}, genMotionStyle$1 = genMotionStyle, genPictureStyle = (a) => {
  const {
    componentCls: s,
    iconCls: $,
    uploadThumbnailSize: _,
    uploadProgressOffset: _e,
    calc: tt
  } = a, nt = `${s}-list`, at = `${nt}-item`;
  return {
    [`${s}-wrapper`]: {
      // ${listCls} 增加优先级
      [`
        ${nt}${nt}-picture,
        ${nt}${nt}-picture-card,
        ${nt}${nt}-picture-circle
      `]: {
        [at]: {
          position: "relative",
          height: tt(_).add(tt(a.lineWidth).mul(2)).add(tt(a.paddingXS).mul(2)).equal(),
          padding: a.paddingXS,
          border: `${unit$1(a.lineWidth)} ${a.lineType} ${a.colorBorder}`,
          borderRadius: a.borderRadiusLG,
          "&:hover": {
            background: "transparent"
          },
          [`${at}-thumbnail`]: Object.assign(Object.assign({}, textEllipsis), {
            width: _,
            height: _,
            lineHeight: unit$1(tt(_).add(a.paddingSM).equal()),
            textAlign: "center",
            flex: "none",
            [$]: {
              fontSize: a.fontSizeHeading2,
              color: a.colorPrimary
            },
            img: {
              display: "block",
              width: "100%",
              height: "100%",
              overflow: "hidden"
            }
          }),
          [`${at}-progress`]: {
            bottom: _e,
            width: `calc(100% - ${unit$1(tt(a.paddingSM).mul(2).equal())})`,
            marginTop: 0,
            paddingInlineStart: tt(_).add(a.paddingXS).equal()
          }
        },
        [`${at}-error`]: {
          borderColor: a.colorError,
          // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
          [`${at}-thumbnail ${$}`]: {
            [`svg path[fill='${blue$1[0]}']`]: {
              fill: a.colorErrorBg
            },
            [`svg path[fill='${blue$1.primary}']`]: {
              fill: a.colorError
            }
          }
        },
        [`${at}-uploading`]: {
          borderStyle: "dashed",
          [`${at}-name`]: {
            marginBottom: _e
          }
        }
      },
      [`${nt}${nt}-picture-circle ${at}`]: {
        [`&, &::before, ${at}-thumbnail`]: {
          borderRadius: "50%"
        }
      }
    }
  };
}, genPictureCardStyle = (a) => {
  const {
    componentCls: s,
    iconCls: $,
    fontSizeLG: _,
    colorTextLightSolid: _e,
    calc: tt
  } = a, nt = `${s}-list`, at = `${nt}-item`, ot = a.uploadPicCardSize;
  return {
    [`
      ${s}-wrapper${s}-picture-card-wrapper,
      ${s}-wrapper${s}-picture-circle-wrapper
    `]: Object.assign(Object.assign({}, clearFix()), {
      display: "inline-block",
      width: "100%",
      [`${s}${s}-select`]: {
        width: ot,
        height: ot,
        marginInlineEnd: a.marginXS,
        marginBottom: a.marginXS,
        textAlign: "center",
        verticalAlign: "top",
        backgroundColor: a.colorFillAlter,
        border: `${unit$1(a.lineWidth)} dashed ${a.colorBorder}`,
        borderRadius: a.borderRadiusLG,
        cursor: "pointer",
        transition: `border-color ${a.motionDurationSlow}`,
        [`> ${s}`]: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center"
        },
        [`&:not(${s}-disabled):hover`]: {
          borderColor: a.colorPrimary
        }
      },
      // list
      [`${nt}${nt}-picture-card, ${nt}${nt}-picture-circle`]: {
        [`${nt}-item-container`]: {
          display: "inline-block",
          width: ot,
          height: ot,
          marginBlock: `0 ${unit$1(a.marginXS)}`,
          marginInline: `0 ${unit$1(a.marginXS)}`,
          verticalAlign: "top"
        },
        "&::after": {
          display: "none"
        },
        [at]: {
          height: "100%",
          margin: 0,
          "&::before": {
            position: "absolute",
            zIndex: 1,
            width: `calc(100% - ${unit$1(tt(a.paddingXS).mul(2).equal())})`,
            height: `calc(100% - ${unit$1(tt(a.paddingXS).mul(2).equal())})`,
            backgroundColor: a.colorBgMask,
            opacity: 0,
            transition: `all ${a.motionDurationSlow}`,
            content: '" "'
          }
        },
        [`${at}:hover`]: {
          [`&::before, ${at}-actions`]: {
            opacity: 1
          }
        },
        [`${at}-actions`]: {
          position: "absolute",
          insetInlineStart: 0,
          zIndex: 10,
          width: "100%",
          whiteSpace: "nowrap",
          textAlign: "center",
          opacity: 0,
          transition: `all ${a.motionDurationSlow}`,
          [`
            ${$}-eye,
            ${$}-download,
            ${$}-delete
          `]: {
            zIndex: 10,
            width: _,
            margin: `0 ${unit$1(a.marginXXS)}`,
            fontSize: _,
            cursor: "pointer",
            transition: `all ${a.motionDurationSlow}`,
            color: _e,
            "&:hover": {
              color: _e
            },
            svg: {
              verticalAlign: "baseline"
            }
          }
        },
        [`${at}-thumbnail, ${at}-thumbnail img`]: {
          position: "static",
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "contain"
        },
        [`${at}-name`]: {
          display: "none",
          textAlign: "center"
        },
        [`${at}-file + ${at}-name`]: {
          position: "absolute",
          bottom: a.margin,
          display: "block",
          width: `calc(100% - ${unit$1(tt(a.paddingXS).mul(2).equal())})`
        },
        [`${at}-uploading`]: {
          [`&${at}`]: {
            backgroundColor: a.colorFillAlter
          },
          [`&::before, ${$}-eye, ${$}-download, ${$}-delete`]: {
            display: "none"
          }
        },
        [`${at}-progress`]: {
          bottom: a.marginXL,
          width: `calc(100% - ${unit$1(tt(a.paddingXS).mul(2).equal())})`,
          paddingInlineStart: 0
        }
      }
    }),
    [`${s}-wrapper${s}-picture-circle-wrapper`]: {
      [`${s}${s}-select`]: {
        borderRadius: "50%"
      }
    }
  };
}, genRtlStyle = (a) => {
  const {
    componentCls: s
  } = a;
  return {
    [`${s}-rtl`]: {
      direction: "rtl"
    }
  };
}, genRtlStyle$1 = genRtlStyle, genBaseStyle = (a) => {
  const {
    componentCls: s,
    colorTextDisabled: $
  } = a;
  return {
    [`${s}-wrapper`]: Object.assign(Object.assign({}, resetComponent(a)), {
      [s]: {
        outline: 0,
        "input[type='file']": {
          cursor: "pointer"
        }
      },
      [`${s}-select`]: {
        display: "inline-block"
      },
      [`${s}-disabled`]: {
        color: $,
        cursor: "not-allowed"
      }
    })
  };
}, prepareComponentToken = (a) => ({
  actionsColor: a.colorTextDescription
}), useStyle = genStyleHooks("Upload", (a) => {
  const {
    fontSizeHeading3: s,
    fontHeight: $,
    lineWidth: _,
    controlHeightLG: _e,
    calc: tt
  } = a, nt = merge(a, {
    uploadThumbnailSize: tt(s).mul(2).equal(),
    uploadProgressOffset: tt(tt($).div(2)).add(_).equal(),
    uploadPicCardSize: tt(_e).mul(2.55).equal()
  });
  return [genBaseStyle(nt), genDraggerStyle$1(nt), genPictureStyle(nt), genPictureCardStyle(nt), genListStyle$1(nt), genMotionStyle$1(nt), genRtlStyle$1(nt), genCollapseMotion$1(nt)];
}, prepareComponentToken);
var FileTwoTone$2 = { icon: function a(s, $) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z", fill: $ } }, { tag: "path", attrs: { d: "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z", fill: s } }] };
}, name: "file", theme: "twotone" };
const FileTwoToneSvg = FileTwoTone$2;
var FileTwoTone = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: FileTwoToneSvg
  }));
};
const FileTwoTone$1 = /* @__PURE__ */ reactExports.forwardRef(FileTwoTone);
var PaperClipOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z" } }] }, name: "paper-clip", theme: "outlined" };
const PaperClipOutlinedSvg = PaperClipOutlined$2;
var PaperClipOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: PaperClipOutlinedSvg
  }));
};
const PaperClipOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(PaperClipOutlined);
var PictureTwoTone$2 = { icon: function a(s, $) {
  return { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z", fill: s } }, { tag: "path", attrs: { d: "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z", fill: $ } }, { tag: "path", attrs: { d: "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z", fill: $ } }, { tag: "path", attrs: { d: "M276 368a28 28 0 1056 0 28 28 0 10-56 0z", fill: $ } }, { tag: "path", attrs: { d: "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z", fill: s } }] };
}, name: "picture", theme: "twotone" };
const PictureTwoToneSvg = PictureTwoTone$2;
var PictureTwoTone = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: PictureTwoToneSvg
  }));
};
const PictureTwoTone$1 = /* @__PURE__ */ reactExports.forwardRef(PictureTwoTone);
function file2Obj(a) {
  return Object.assign(Object.assign({}, a), {
    lastModified: a.lastModified,
    lastModifiedDate: a.lastModifiedDate,
    name: a.name,
    size: a.size,
    type: a.type,
    uid: a.uid,
    percent: 0,
    originFileObj: a
  });
}
function updateFileList(a, s) {
  const $ = _toConsumableArray$d(s), _ = $.findIndex((_e) => {
    let {
      uid: tt
    } = _e;
    return tt === a.uid;
  });
  return _ === -1 ? $.push(a) : $[_] = a, $;
}
function getFileItem(a, s) {
  const $ = a.uid !== void 0 ? "uid" : "name";
  return s.filter((_) => _[$] === a[$])[0];
}
function removeFileItem(a, s) {
  const $ = a.uid !== void 0 ? "uid" : "name", _ = s.filter((_e) => _e[$] !== a[$]);
  return _.length === s.length ? null : _;
}
const extname = function() {
  const s = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").split("/"), _ = s[s.length - 1].split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(_) || [""])[0];
}, isImageFileType = (a) => a.indexOf("image/") === 0, isImageUrl = (a) => {
  if (a.type && !a.thumbUrl)
    return isImageFileType(a.type);
  const s = a.thumbUrl || a.url || "", $ = extname(s);
  return /^data:image\//.test(s) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test($) ? !0 : !(/^data:/.test(s) || $);
}, MEASURE_SIZE = 200;
function previewImage(a) {
  return new Promise((s) => {
    if (!a.type || !isImageFileType(a.type)) {
      s("");
      return;
    }
    const $ = document.createElement("canvas");
    $.width = MEASURE_SIZE, $.height = MEASURE_SIZE, $.style.cssText = `position: fixed; left: 0; top: 0; width: ${MEASURE_SIZE}px; height: ${MEASURE_SIZE}px; z-index: 9999; display: none;`, document.body.appendChild($);
    const _ = $.getContext("2d"), _e = new Image();
    if (_e.onload = () => {
      const {
        width: tt,
        height: nt
      } = _e;
      let at = MEASURE_SIZE, ot = MEASURE_SIZE, rt = 0, st = 0;
      tt > nt ? (ot = nt * (MEASURE_SIZE / tt), st = -(ot - at) / 2) : (at = tt * (MEASURE_SIZE / nt), rt = -(at - ot) / 2), _.drawImage(_e, rt, st, at, ot);
      const lt = $.toDataURL();
      document.body.removeChild($), window.URL.revokeObjectURL(_e.src), s(lt);
    }, _e.crossOrigin = "anonymous", a.type.startsWith("image/svg+xml")) {
      const tt = new FileReader();
      tt.onload = () => {
        tt.result && (_e.src = tt.result);
      }, tt.readAsDataURL(a);
    } else if (a.type.startsWith("image/gif")) {
      const tt = new FileReader();
      tt.onload = () => {
        tt.result && s(tt.result);
      }, tt.readAsDataURL(a);
    } else
      _e.src = window.URL.createObjectURL(a);
  });
}
var DownloadOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, name: "download", theme: "outlined" };
const DownloadOutlinedSvg = DownloadOutlined$2;
var DownloadOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: DownloadOutlinedSvg
  }));
};
const DownloadOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(DownloadOutlined), ListItem = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  let {
    prefixCls: $,
    className: _,
    style: _e,
    locale: tt,
    listType: nt,
    file: at,
    items: ot,
    progress: rt,
    iconRender: st,
    actionIconRender: lt,
    itemRender: et,
    isImgUrl: it,
    showPreviewIcon: ut,
    showRemoveIcon: ft,
    showDownloadIcon: ht,
    previewIcon: dt,
    removeIcon: gt,
    downloadIcon: pt,
    onPreview: mt,
    onDownload: ct,
    onClose: vt
  } = a;
  var At, xt;
  const {
    status: bt
  } = at, [Et, St] = reactExports.useState(bt);
  reactExports.useEffect(() => {
    bt !== "removed" && St(bt);
  }, [bt]);
  const [Bt, Ot] = reactExports.useState(!1);
  reactExports.useEffect(() => {
    const Dt = setTimeout(() => {
      Ot(!0);
    }, 300);
    return () => {
      clearTimeout(Dt);
    };
  }, []);
  const Pt = st(at);
  let wt = /* @__PURE__ */ reactExports.createElement("div", {
    className: `${$}-icon`
  }, Pt);
  if (nt === "picture" || nt === "picture-card" || nt === "picture-circle")
    if (Et === "uploading" || !at.thumbUrl && !at.url) {
      const Dt = classnames(`${$}-list-item-thumbnail`, {
        [`${$}-list-item-file`]: Et !== "uploading"
      });
      wt = /* @__PURE__ */ reactExports.createElement("div", {
        className: Dt
      }, Pt);
    } else {
      const Dt = it != null && it(at) ? /* @__PURE__ */ reactExports.createElement("img", {
        src: at.thumbUrl || at.url,
        alt: at.name,
        className: `${$}-list-item-image`,
        crossOrigin: at.crossOrigin
      }) : Pt, Ut = classnames(`${$}-list-item-thumbnail`, {
        [`${$}-list-item-file`]: it && !it(at)
      });
      wt = /* @__PURE__ */ reactExports.createElement("a", {
        className: Ut,
        onClick: (Vt) => mt(at, Vt),
        href: at.url || at.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, Dt);
    }
  const Ct = classnames(`${$}-list-item`, `${$}-list-item-${Et}`), It = typeof at.linkProps == "string" ? JSON.parse(at.linkProps) : at.linkProps, yt = ft ? lt(
    (typeof gt == "function" ? gt(at) : gt) || /* @__PURE__ */ reactExports.createElement(DeleteOutlined$1, null),
    () => vt(at),
    $,
    tt.removeFile,
    // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    !0
  ) : null, Rt = ht && Et === "done" ? lt((typeof pt == "function" ? pt(at) : pt) || /* @__PURE__ */ reactExports.createElement(DownloadOutlined$1, null), () => ct(at), $, tt.downloadFile) : null, kt = nt !== "picture-card" && nt !== "picture-circle" && /* @__PURE__ */ reactExports.createElement("span", {
    key: "download-delete",
    className: classnames(`${$}-list-item-actions`, {
      picture: nt === "picture"
    })
  }, Rt, yt), jt = classnames(`${$}-list-item-name`), Ht = at.url ? [/* @__PURE__ */ reactExports.createElement("a", Object.assign({
    key: "view",
    target: "_blank",
    rel: "noopener noreferrer",
    className: jt,
    title: at.name
  }, It, {
    href: at.url,
    onClick: (Dt) => mt(at, Dt)
  }), at.name), kt] : [/* @__PURE__ */ reactExports.createElement("span", {
    key: "view",
    className: jt,
    onClick: (Dt) => mt(at, Dt),
    title: at.name
  }, at.name), kt], Ft = ut && (at.url || at.thumbUrl) ? /* @__PURE__ */ reactExports.createElement("a", {
    href: at.url || at.thumbUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (Dt) => mt(at, Dt),
    title: tt.previewFile
  }, typeof dt == "function" ? dt(at) : dt || /* @__PURE__ */ reactExports.createElement(EyeOutlined$1, null)) : null, _t = (nt === "picture-card" || nt === "picture-circle") && Et !== "uploading" && /* @__PURE__ */ reactExports.createElement("span", {
    className: `${$}-list-item-actions`
  }, Ft, Et === "done" && Rt, yt), {
    getPrefixCls: Nt
  } = reactExports.useContext(ConfigContext$1), Mt = Nt(), Lt = /* @__PURE__ */ reactExports.createElement("div", {
    className: Ct
  }, wt, Ht, _t, Bt && /* @__PURE__ */ reactExports.createElement(CSSMotion, {
    motionName: `${Mt}-fade`,
    visible: Et === "uploading",
    motionDeadline: 2e3
  }, (Dt) => {
    let {
      className: Ut
    } = Dt;
    const Vt = "percent" in at ? /* @__PURE__ */ reactExports.createElement(Progress$1, Object.assign({}, rt, {
      type: "line",
      percent: at.percent,
      "aria-label": at["aria-label"],
      "aria-labelledby": at["aria-labelledby"]
    })) : null;
    return /* @__PURE__ */ reactExports.createElement("div", {
      className: classnames(`${$}-list-item-progress`, Ut)
    }, Vt);
  })), $t = at.response && typeof at.response == "string" ? at.response : ((At = at.error) === null || At === void 0 ? void 0 : At.statusText) || ((xt = at.error) === null || xt === void 0 ? void 0 : xt.message) || tt.uploadError, Tt = Et === "error" ? /* @__PURE__ */ reactExports.createElement(_Tooltip, {
    title: $t,
    getPopupContainer: (Dt) => Dt.parentNode
  }, Lt) : Lt;
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: classnames(`${$}-list-item-container`, _),
    style: _e,
    ref: s
  }, et ? et(Tt, at, ot, {
    download: ct.bind(null, at),
    preview: mt.bind(null, at),
    remove: vt.bind(null, at)
  }) : Tt);
}), ListItem$1 = ListItem, InternalUploadList = (a, s) => {
  const {
    listType: $ = "text",
    previewFile: _ = previewImage,
    onPreview: _e,
    onDownload: tt,
    onRemove: nt,
    locale: at,
    iconRender: ot,
    isImageUrl: rt = isImageUrl,
    prefixCls: st,
    items: lt = [],
    showPreviewIcon: et = !0,
    showRemoveIcon: it = !0,
    showDownloadIcon: ut = !1,
    removeIcon: ft,
    previewIcon: ht,
    downloadIcon: dt,
    progress: gt = {
      size: [-1, 2],
      showInfo: !1
    },
    appendAction: pt,
    appendActionVisible: mt = !0,
    itemRender: ct,
    disabled: vt
  } = a, At = useForceUpdate(), [xt, bt] = reactExports.useState(!1);
  reactExports.useEffect(() => {
    $ !== "picture" && $ !== "picture-card" && $ !== "picture-circle" || (lt || []).forEach((Ft) => {
      typeof document > "u" || typeof window > "u" || !window.FileReader || !window.File || !(Ft.originFileObj instanceof File || Ft.originFileObj instanceof Blob) || Ft.thumbUrl !== void 0 || (Ft.thumbUrl = "", _ && _(Ft.originFileObj).then((_t) => {
        Ft.thumbUrl = _t || "", At();
      }));
    });
  }, [$, lt, _]), reactExports.useEffect(() => {
    bt(!0);
  }, []);
  const Et = (Ft, _t) => {
    if (_e)
      return _t == null || _t.preventDefault(), _e(Ft);
  }, St = (Ft) => {
    typeof tt == "function" ? tt(Ft) : Ft.url && window.open(Ft.url);
  }, Bt = (Ft) => {
    nt == null || nt(Ft);
  }, Ot = (Ft) => {
    if (ot)
      return ot(Ft, $);
    const _t = Ft.status === "uploading", Nt = rt && rt(Ft) ? /* @__PURE__ */ reactExports.createElement(PictureTwoTone$1, null) : /* @__PURE__ */ reactExports.createElement(FileTwoTone$1, null);
    let Mt = _t ? /* @__PURE__ */ reactExports.createElement(LoadingOutlined$1, null) : /* @__PURE__ */ reactExports.createElement(PaperClipOutlined$1, null);
    return $ === "picture" ? Mt = _t ? /* @__PURE__ */ reactExports.createElement(LoadingOutlined$1, null) : Nt : ($ === "picture-card" || $ === "picture-circle") && (Mt = _t ? at.uploading : Nt), Mt;
  }, Pt = (Ft, _t, Nt, Mt, Lt) => {
    const $t = {
      type: "text",
      size: "small",
      title: Mt,
      onClick: (Tt) => {
        _t(), isValidElement(Ft) && Ft.props.onClick && Ft.props.onClick(Tt);
      },
      className: `${Nt}-list-item-action`
    };
    if (Lt && ($t.disabled = vt), isValidElement(Ft)) {
      const Tt = cloneElement(Ft, Object.assign(Object.assign({}, Ft.props), {
        onClick: () => {
        }
      }));
      return /* @__PURE__ */ reactExports.createElement(Button$2, Object.assign({}, $t, {
        icon: Tt
      }));
    }
    return /* @__PURE__ */ reactExports.createElement(Button$2, Object.assign({}, $t), /* @__PURE__ */ reactExports.createElement("span", null, Ft));
  };
  reactExports.useImperativeHandle(s, () => ({
    handlePreview: Et,
    handleDownload: St
  }));
  const {
    getPrefixCls: wt
  } = reactExports.useContext(ConfigContext$1), Ct = wt("upload", st), It = wt(), yt = classnames(`${Ct}-list`, `${Ct}-list-${$}`), Rt = _toConsumableArray$d(lt.map((Ft) => ({
    key: Ft.uid,
    file: Ft
  })));
  let jt = {
    motionDeadline: 2e3,
    motionName: `${Ct}-${$ === "picture-card" || $ === "picture-circle" ? "animate-inline" : "animate"}`,
    keys: Rt,
    motionAppear: xt
  };
  const Ht = reactExports.useMemo(() => {
    const Ft = Object.assign({}, initCollapseMotion$1(It));
    return delete Ft.onAppearEnd, delete Ft.onEnterEnd, delete Ft.onLeaveEnd, Ft;
  }, [It]);
  return $ !== "picture-card" && $ !== "picture-circle" && (jt = Object.assign(Object.assign({}, Ht), jt)), /* @__PURE__ */ reactExports.createElement("div", {
    className: yt
  }, /* @__PURE__ */ reactExports.createElement(CSSMotionList, Object.assign({}, jt, {
    component: !1
  }), (Ft) => {
    let {
      key: _t,
      file: Nt,
      className: Mt,
      style: Lt
    } = Ft;
    return /* @__PURE__ */ reactExports.createElement(ListItem$1, {
      key: _t,
      locale: at,
      prefixCls: Ct,
      className: Mt,
      style: Lt,
      file: Nt,
      items: lt,
      progress: gt,
      listType: $,
      isImgUrl: rt,
      showPreviewIcon: et,
      showRemoveIcon: it,
      showDownloadIcon: ut,
      removeIcon: ft,
      previewIcon: ht,
      downloadIcon: dt,
      iconRender: Ot,
      actionIconRender: Pt,
      itemRender: ct,
      onPreview: Et,
      onDownload: St,
      onClose: Bt
    });
  }), pt && /* @__PURE__ */ reactExports.createElement(CSSMotion, Object.assign({}, jt, {
    visible: mt,
    forceRender: !0
  }), (Ft) => {
    let {
      className: _t,
      style: Nt
    } = Ft;
    return cloneElement(pt, (Mt) => ({
      className: classnames(Mt.className, _t),
      style: Object.assign(Object.assign(Object.assign({}, Nt), {
        // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
        pointerEvents: _t ? "none" : void 0
      }), Mt.style)
    }));
  }));
}, UploadList = /* @__PURE__ */ reactExports.forwardRef(InternalUploadList), UploadList$1 = UploadList;
var __awaiter$1 = function(a, s, $, _) {
  function _e(tt) {
    return tt instanceof $ ? tt : new $(function(nt) {
      nt(tt);
    });
  }
  return new ($ || ($ = Promise))(function(tt, nt) {
    function at(st) {
      try {
        rt(_.next(st));
      } catch (lt) {
        nt(lt);
      }
    }
    function ot(st) {
      try {
        rt(_.throw(st));
      } catch (lt) {
        nt(lt);
      }
    }
    function rt(st) {
      st.done ? tt(st.value) : _e(st.value).then(at, ot);
    }
    rt((_ = _.apply(a, s || [])).next());
  });
};
const LIST_IGNORE = `__LIST_IGNORE_${Date.now()}__`, InternalUpload = (a, s) => {
  const {
    fileList: $,
    defaultFileList: _,
    onRemove: _e,
    showUploadList: tt = !0,
    listType: nt = "text",
    onPreview: at,
    onDownload: ot,
    onChange: rt,
    onDrop: st,
    previewFile: lt,
    disabled: et,
    locale: it,
    iconRender: ut,
    isImageUrl: ft,
    progress: ht,
    prefixCls: dt,
    className: gt,
    type: pt = "select",
    children: mt,
    style: ct,
    itemRender: vt,
    maxCount: At,
    data: xt = {},
    multiple: bt = !1,
    action: Et = "",
    accept: St = "",
    supportServerRender: Bt = !0,
    rootClassName: Ot
  } = a, Pt = reactExports.useContext(DisabledContext$1), wt = et ?? Pt, [Ct, It] = useMergedState(_ || [], {
    value: $,
    postState: (ur) => ur ?? []
  }), [yt, Rt] = reactExports.useState("drop"), kt = reactExports.useRef(null);
  reactExports.useMemo(() => {
    const ur = Date.now();
    ($ || []).forEach((pr, yr) => {
      !pr.uid && !Object.isFrozen(pr) && (pr.uid = `__AUTO__${ur}_${yr}__`);
    });
  }, [$]);
  const jt = (ur, pr, yr) => {
    let Er = _toConsumableArray$d(pr), br = !1;
    At === 1 ? Er = Er.slice(-1) : At && (br = Er.length > At, Er = Er.slice(0, At)), reactDomExports.flushSync(() => {
      It(Er);
    });
    const gr = {
      file: ur,
      fileList: Er
    };
    yr && (gr.event = yr), (!br || // We should ignore event if current file is exceed `maxCount`
    Er.some((Ar) => Ar.uid === ur.uid)) && reactDomExports.flushSync(() => {
      rt == null || rt(gr);
    });
  }, Ht = (ur, pr) => __awaiter$1(void 0, void 0, void 0, function* () {
    const {
      beforeUpload: yr,
      transformFile: Er
    } = a;
    let br = ur;
    if (yr) {
      const gr = yield yr(ur, pr);
      if (gr === !1)
        return !1;
      if (delete ur[LIST_IGNORE], gr === LIST_IGNORE)
        return Object.defineProperty(ur, LIST_IGNORE, {
          value: !0,
          configurable: !0
        }), !1;
      typeof gr == "object" && gr && (br = gr);
    }
    return Er && (br = yield Er(br)), br;
  }), Ft = (ur) => {
    const pr = ur.filter((br) => !br.file[LIST_IGNORE]);
    if (!pr.length)
      return;
    const yr = pr.map((br) => file2Obj(br.file));
    let Er = _toConsumableArray$d(Ct);
    yr.forEach((br) => {
      Er = updateFileList(br, Er);
    }), yr.forEach((br, gr) => {
      let Ar = br;
      if (pr[gr].parsedFile)
        br.status = "uploading";
      else {
        const {
          originFileObj: Sr
        } = br;
        let Br;
        try {
          Br = new File([Sr], Sr.name, {
            type: Sr.type
          });
        } catch {
          Br = new Blob([Sr], {
            type: Sr.type
          }), Br.name = Sr.name, Br.lastModifiedDate = /* @__PURE__ */ new Date(), Br.lastModified = (/* @__PURE__ */ new Date()).getTime();
        }
        Br.uid = br.uid, Ar = Br;
      }
      jt(Ar, Er);
    });
  }, _t = (ur, pr, yr) => {
    try {
      typeof ur == "string" && (ur = JSON.parse(ur));
    } catch {
    }
    if (!getFileItem(pr, Ct))
      return;
    const Er = file2Obj(pr);
    Er.status = "done", Er.percent = 100, Er.response = ur, Er.xhr = yr;
    const br = updateFileList(Er, Ct);
    jt(Er, br);
  }, Nt = (ur, pr) => {
    if (!getFileItem(pr, Ct))
      return;
    const yr = file2Obj(pr);
    yr.status = "uploading", yr.percent = ur.percent;
    const Er = updateFileList(yr, Ct);
    jt(yr, Er, ur);
  }, Mt = (ur, pr, yr) => {
    if (!getFileItem(yr, Ct))
      return;
    const Er = file2Obj(yr);
    Er.error = ur, Er.response = pr, Er.status = "error";
    const br = updateFileList(Er, Ct);
    jt(Er, br);
  }, Lt = (ur) => {
    let pr;
    Promise.resolve(typeof _e == "function" ? _e(ur) : _e).then((yr) => {
      var Er;
      if (yr === !1)
        return;
      const br = removeFileItem(ur, Ct);
      br && (pr = Object.assign(Object.assign({}, ur), {
        status: "removed"
      }), Ct == null || Ct.forEach((gr) => {
        const Ar = pr.uid !== void 0 ? "uid" : "name";
        gr[Ar] === pr[Ar] && !Object.isFrozen(gr) && (gr.status = "removed");
      }), (Er = kt.current) === null || Er === void 0 || Er.abort(pr), jt(pr, br));
    });
  }, $t = (ur) => {
    Rt(ur.type), ur.type === "drop" && (st == null || st(ur));
  };
  reactExports.useImperativeHandle(s, () => ({
    onBatchStart: Ft,
    onSuccess: _t,
    onProgress: Nt,
    onError: Mt,
    fileList: Ct,
    upload: kt.current
  }));
  const {
    getPrefixCls: Tt,
    direction: Dt,
    upload: Ut
  } = reactExports.useContext(ConfigContext$1), Vt = Tt("upload", dt), Qt = Object.assign(Object.assign({
    onBatchStart: Ft,
    onError: Mt,
    onProgress: Nt,
    onSuccess: _t
  }, a), {
    data: xt,
    multiple: bt,
    action: Et,
    accept: St,
    supportServerRender: Bt,
    prefixCls: Vt,
    disabled: wt,
    beforeUpload: Ht,
    onChange: void 0
  });
  delete Qt.className, delete Qt.style, (!mt || wt) && delete Qt.id;
  const qt = `${Vt}-wrapper`, [Zt, ar, Jt] = useStyle(Vt, qt), [rr] = useLocale$1("Upload", defaultLocale.Upload), {
    showRemoveIcon: Yt,
    showPreviewIcon: Kt,
    showDownloadIcon: nr,
    removeIcon: tr,
    previewIcon: ir,
    downloadIcon: sr
  } = typeof tt == "boolean" ? {} : tt, cr = typeof Yt > "u" ? !wt : !!Yt, or = (ur, pr) => tt ? /* @__PURE__ */ reactExports.createElement(UploadList$1, {
    prefixCls: Vt,
    listType: nt,
    items: Ct,
    previewFile: lt,
    onPreview: at,
    onDownload: ot,
    onRemove: Lt,
    showRemoveIcon: cr,
    showPreviewIcon: Kt,
    showDownloadIcon: nr,
    removeIcon: tr,
    previewIcon: ir,
    downloadIcon: sr,
    iconRender: ut,
    locale: Object.assign(Object.assign({}, rr), it),
    isImageUrl: ft,
    progress: ht,
    appendAction: ur,
    appendActionVisible: pr,
    itemRender: vt,
    disabled: wt
  }) : ur, Xt = classnames(qt, gt, Ot, ar, Jt, Ut == null ? void 0 : Ut.className, {
    [`${Vt}-rtl`]: Dt === "rtl",
    [`${Vt}-picture-card-wrapper`]: nt === "picture-card",
    [`${Vt}-picture-circle-wrapper`]: nt === "picture-circle"
  }), Gt = Object.assign(Object.assign({}, Ut == null ? void 0 : Ut.style), ct);
  if (pt === "drag") {
    const ur = classnames(ar, Vt, `${Vt}-drag`, {
      [`${Vt}-drag-uploading`]: Ct.some((pr) => pr.status === "uploading"),
      [`${Vt}-drag-hover`]: yt === "dragover",
      [`${Vt}-disabled`]: wt,
      [`${Vt}-rtl`]: Dt === "rtl"
    });
    return Zt(/* @__PURE__ */ reactExports.createElement("span", {
      className: Xt
    }, /* @__PURE__ */ reactExports.createElement("div", {
      className: ur,
      style: Gt,
      onDrop: $t,
      onDragOver: $t,
      onDragLeave: $t
    }, /* @__PURE__ */ reactExports.createElement(Upload$2, Object.assign({}, Qt, {
      ref: kt,
      className: `${Vt}-btn`
    }), /* @__PURE__ */ reactExports.createElement("div", {
      className: `${Vt}-drag-container`
    }, mt))), or()));
  }
  const Wt = classnames(Vt, `${Vt}-select`, {
    [`${Vt}-disabled`]: wt
  }), lr = ((ur) => /* @__PURE__ */ reactExports.createElement("div", {
    className: Wt,
    style: ur
  }, /* @__PURE__ */ reactExports.createElement(Upload$2, Object.assign({}, Qt, {
    ref: kt
  }))))(mt ? void 0 : {
    display: "none"
  });
  return Zt(nt === "picture-card" || nt === "picture-circle" ? /* @__PURE__ */ reactExports.createElement("span", {
    className: Xt
  }, or(lr, !!mt)) : /* @__PURE__ */ reactExports.createElement("span", {
    className: Xt
  }, lr, or()));
}, Upload$1 = /* @__PURE__ */ reactExports.forwardRef(InternalUpload), InternalUpload$1 = Upload$1;
var __rest$4 = function(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
};
const Dragger = /* @__PURE__ */ reactExports.forwardRef((a, s) => {
  var {
    style: $,
    height: _
  } = a, _e = __rest$4(a, ["style", "height"]);
  return /* @__PURE__ */ reactExports.createElement(InternalUpload$1, Object.assign({
    ref: s
  }, _e, {
    type: "drag",
    style: Object.assign(Object.assign({}, $), {
      height: _
    })
  }));
}), Dragger$1 = Dragger, Upload = InternalUpload$1;
Upload.Dragger = Dragger$1;
Upload.LIST_IGNORE = LIST_IGNORE;
const _Upload = Upload;
var ArrowLeftOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, name: "arrow-left", theme: "outlined" };
const ArrowLeftOutlinedSvg = ArrowLeftOutlined$2;
var ArrowLeftOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: ArrowLeftOutlinedSvg
  }));
};
const ArrowLeftOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(ArrowLeftOutlined);
var ArrowRightOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" } }] }, name: "arrow-right", theme: "outlined" };
const ArrowRightOutlinedSvg = ArrowRightOutlined$2;
var ArrowRightOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: ArrowRightOutlinedSvg
  }));
};
const ArrowRightOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(ArrowRightOutlined);
var ExclamationCircleOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, name: "exclamation-circle", theme: "outlined" };
const ExclamationCircleOutlinedSvg = ExclamationCircleOutlined$2;
var ExclamationCircleOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: ExclamationCircleOutlinedSvg
  }));
};
const ExclamationCircleOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(ExclamationCircleOutlined);
var LockOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" } }] }, name: "lock", theme: "outlined" };
const LockOutlinedSvg = LockOutlined$2;
var LockOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: LockOutlinedSvg
  }));
};
const LockOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(LockOutlined);
var MenuOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" } }] }, name: "menu", theme: "outlined" };
const MenuOutlinedSvg = MenuOutlined$2;
var MenuOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: MenuOutlinedSvg
  }));
};
const MenuOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(MenuOutlined);
var MinusOutlined$2 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" } }] }, name: "minus", theme: "outlined" };
const MinusOutlinedSvg = MinusOutlined$2;
var MinusOutlined = function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement(AntdIcon$1, _extends$2({}, s, {
    ref: $,
    icon: MinusOutlinedSvg
  }));
};
const MinusOutlined$1 = /* @__PURE__ */ reactExports.forwardRef(MinusOutlined), dictEn = {
  cancel: "Cancel",
  close: "Close",
  field: "field",
  fieldName: "Name",
  align: "Align",
  width: "Width",
  height: "Height",
  opacity: "Opacity",
  rotate: "Rotate",
  required: "Required",
  editable: "Editable",
  edit: "Edit",
  plsInputName: "Please input name",
  fieldMustUniq: "Name of field is not unique",
  notUniq: "(Not unique name)",
  noKeyName: "No name",
  fieldsList: "Field List",
  editField: "Edit Field",
  type: "Type",
  errorOccurred: "An error occurred",
  errorBulkUpdateFieldName: "Cannot commit the change because the number of items has been changed.",
  commitBulkUpdateFieldName: "Commit Changes",
  bulkUpdateFieldName: "Bulk update field names",
  addPageAfter: "Add Page After",
  removePage: "Remove Current Page",
  removePageConfirm: "Are you sure you want to delete this page? This action cannot be undone.",
  "validation.hexColor": "Please enter a valid hex color code.",
  "validation.uniqueName": "Please enter a unique name.",
  "schemas.color": "Color",
  "schemas.borderWidth": "Border Width",
  "schemas.borderColor": "Border Color",
  "schemas.backgroundColor": "Background Color",
  "schemas.textColor": "Text Color",
  "schemas.bgColor": "Background Color",
  "schemas.horizontal": "Horizontal",
  "schemas.vertical": "Vertical",
  "schemas.left": "Left",
  "schemas.center": "Center",
  "schemas.right": "Right",
  "schemas.top": "Top",
  "schemas.middle": "Middle",
  "schemas.bottom": "Bottom",
  "schemas.padding": "Padding",
  "schemas.text.fontName": "Font Name",
  "schemas.text.size": "Size",
  "schemas.text.spacing": "Spacing",
  "schemas.text.textAlign": "Text Align",
  "schemas.text.verticalAlign": "Vertical Align",
  "schemas.text.lineHeight": "Line Height",
  "schemas.text.min": "Min",
  "schemas.text.max": "Max",
  "schemas.text.fit": "Fit",
  "schemas.text.dynamicFontSize": "Dynamic Font Size",
  "schemas.text.format": "Format",
  "schemas.mvt.typingInstructions": "Add variables by typing words surrounded by curly brackets, e.g.",
  "schemas.mvt.sampleField": "name",
  "schemas.mvt.variablesSampleData": "Variables Sample Data",
  "schemas.barcodes.barColor": "Bar Color",
  "schemas.barcodes.includetext": "Include Text",
  "schemas.table.alternateBackgroundColor": "Alternate Background Color",
  "schemas.table.tableStyle": "Table Style",
  "schemas.table.headStyle": "Header Style",
  "schemas.table.bodyStyle": "Body Style",
  "schemas.table.columnStyle": "Column Style",
  "schemas.date.format": "Date Format",
  "schemas.select.options": "Options",
  "schemas.select.optionPlaceholder": "Enter an option"
}, dictZh = {
  cancel: "取消",
  close: "关闭",
  field: "字段",
  fieldName: "名称",
  align: "对齐",
  width: "宽度",
  height: "高度",
  opacity: "透明度",
  rotate: "旋转",
  required: "必需的",
  editable: "可编辑的",
  edit: "编辑",
  plsInputName: "请输入名称",
  fieldMustUniq: "字段名称必须唯一",
  notUniq: "（名称不唯一）",
  noKeyName: "无名称",
  fieldsList: "字段列表",
  editField: "编辑字段",
  type: "类型",
  errorOccurred: "发生错误",
  errorBulkUpdateFieldName: "由于项目数量已更改，无法提交更改。",
  commitBulkUpdateFieldName: "提交更改",
  bulkUpdateFieldName: "批量更新字段名称",
  addPageAfter: "在之后添加页面",
  removePage: "删除当前页面",
  removePageConfirm: "您确定要删除此页面吗？此操作无法撤销。",
  "validation.hexColor": "请输入有效的十六进制颜色代码。",
  "validation.uniqueName": "请输入一个唯一的名称。",
  "schemas.color": "颜色",
  "schemas.borderWidth": "边框宽度",
  "schemas.borderColor": "边框颜色",
  "schemas.backgroundColor": "背景颜色",
  "schemas.textColor": "文字颜色",
  "schemas.bgColor": "背景颜色",
  "schemas.horizontal": "水平",
  "schemas.vertical": "垂直",
  "schemas.left": "左",
  "schemas.center": "中",
  "schemas.right": "右",
  "schemas.top": "顶",
  "schemas.middle": "中间",
  "schemas.bottom": "底",
  "schemas.padding": "填充",
  "schemas.text.fontName": "字体名称",
  "schemas.text.size": "大小",
  "schemas.text.spacing": "间距",
  "schemas.text.textAlign": "文本对齐",
  "schemas.text.verticalAlign": "垂直对齐",
  "schemas.text.lineHeight": "行高",
  "schemas.text.min": "最小",
  "schemas.text.max": "最大",
  "schemas.text.fit": "适应",
  "schemas.text.dynamicFontSize": "动态字体大小",
  "schemas.text.format": "格式",
  "schemas.mvt.typingInstructions": "通过输入用花括号括起来的单词来添加变量，例如",
  "schemas.mvt.sampleField": "姓名",
  "schemas.mvt.variablesSampleData": "变量样本数据",
  "schemas.barcodes.barColor": "条码颜色",
  "schemas.barcodes.includetext": "包括文本",
  "schemas.table.alternateBackgroundColor": "交替背景颜色",
  "schemas.table.tableStyle": "表格样式",
  "schemas.table.headStyle": "表头样式",
  "schemas.table.bodyStyle": "表体样式",
  "schemas.table.columnStyle": "列样式",
  "schemas.date.format": "日期格式",
  "schemas.select.options": "选项",
  "schemas.select.optionPlaceholder": "请输入选项"
}, dictJa = {
  cancel: "キャンセル",
  close: "閉じる",
  field: "入力項目",
  fieldName: "項目名",
  align: "整列",
  width: "幅",
  height: "高さ",
  opacity: "不透明度",
  rotate: "回転",
  required: "必須",
  editable: "編集可能",
  edit: "編集する",
  plsInputName: "項目名を入力してください",
  fieldMustUniq: "他の入力項目名と被っています",
  notUniq: "(他の項目名と重複しています)",
  noKeyName: "項目名なし",
  fieldsList: "入力項目一覧",
  editField: "入力項目を編集",
  type: "タイプ",
  errorOccurred: "エラーが発生しました",
  errorBulkUpdateFieldName: "項目数が変更されているため変更をコミットできません。",
  commitBulkUpdateFieldName: "変更を反映",
  bulkUpdateFieldName: "項目名を一括変更",
  addPageAfter: "次にページを追加",
  removePage: "現在のページを削除",
  removePageConfirm: "ページを削除してもよろしいですか？この操作は元に戻せません。",
  "validation.hexColor": "有効な16進数のカラーコードを入力してください。",
  "validation.uniqueName": "一意の名前を入力してください。",
  "schemas.color": "色",
  "schemas.borderWidth": "枠線の太さ",
  "schemas.borderColor": "枠線の色",
  "schemas.backgroundColor": "背景色",
  "schemas.textColor": "テキストの色",
  "schemas.bgColor": "背景色",
  "schemas.horizontal": "水平",
  "schemas.vertical": "垂直",
  "schemas.left": "左",
  "schemas.center": "中央",
  "schemas.right": "右",
  "schemas.top": "上",
  "schemas.middle": "中間",
  "schemas.bottom": "下",
  "schemas.padding": "パディング",
  "schemas.text.fontName": "フォント名",
  "schemas.text.size": "サイズ",
  "schemas.text.spacing": "間隔",
  "schemas.text.textAlign": "テキストの揃え",
  "schemas.text.verticalAlign": "垂直方向の揃え",
  "schemas.text.lineHeight": "行の高さ",
  "schemas.text.min": "最小",
  "schemas.text.max": "最大",
  "schemas.text.fit": "フィット",
  "schemas.text.dynamicFontSize": "動的フォントサイズ",
  "schemas.text.format": "書式",
  "schemas.mvt.typingInstructions": "中括弧で囲まれた単語を入力して変数を追加します。例:",
  "schemas.mvt.sampleField": "名前",
  "schemas.mvt.variablesSampleData": "変数サンプルデータ",
  "schemas.barcodes.barColor": "バーの色",
  "schemas.barcodes.includetext": "テキストを含める",
  "schemas.table.alternateBackgroundColor": "交互の背景色",
  "schemas.table.tableStyle": "テーブルスタイル",
  "schemas.table.headStyle": "ヘッダースタイル",
  "schemas.table.bodyStyle": "ボディスタイル",
  "schemas.table.columnStyle": "カラムスタイル",
  "schemas.date.format": "日付形式",
  "schemas.select.options": "オプション",
  "schemas.select.optionPlaceholder": "オプションを入力してください"
}, dictKo = {
  cancel: "취소",
  close: "닫기",
  field: "필드",
  fieldName: "이름",
  align: "정렬",
  width: "너비",
  height: "높이",
  opacity: "투명도",
  rotate: "회전",
  required: "필수의",
  editable: "편집 가능한",
  edit: "편집",
  plsInputName: "이름을 입력하세요",
  fieldMustUniq: "필드 이름은 유일해야 합니다",
  notUniq: "（유일하지 않은 이름）",
  noKeyName: "이름 없음",
  fieldsList: "필드 목록",
  editField: "필드 편집",
  type: "유형",
  errorOccurred: "오류 발생",
  errorBulkUpdateFieldName: "항목 수가 변경되어 변경을 커밋할 수 없습니다.",
  commitBulkUpdateFieldName: "변경 사항 커밋",
  bulkUpdateFieldName: "필드 이름 일괄 업데이트",
  addPageAfter: "다음에 페이지 추가",
  removePage: "현재 페이지 제거",
  removePageConfirm: "이 페이지를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.",
  "validation.hexColor": "유효한 16진수 색상 코드를 입력하세요.",
  "validation.uniqueName": "고유한 이름을 입력하세요.",
  "schemas.color": "색상",
  "schemas.borderWidth": "테두리 너비",
  "schemas.borderColor": "테두리 색상",
  "schemas.backgroundColor": "배경색",
  "schemas.textColor": "텍스트 색상",
  "schemas.bgColor": "배경색",
  "schemas.horizontal": "수평",
  "schemas.vertical": "수직",
  "schemas.left": "왼쪽",
  "schemas.center": "중앙",
  "schemas.right": "오른쪽",
  "schemas.top": "상단",
  "schemas.middle": "중간",
  "schemas.bottom": "하단",
  "schemas.padding": "패딩",
  "schemas.text.fontName": "글꼴 이름",
  "schemas.text.size": "크기",
  "schemas.text.spacing": "간격",
  "schemas.text.textAlign": "텍스트 정렬",
  "schemas.text.verticalAlign": "수직 정렬",
  "schemas.text.lineHeight": "줄 높이",
  "schemas.text.min": "최소",
  "schemas.text.max": "최대",
  "schemas.text.fit": "맞춤",
  "schemas.text.dynamicFontSize": "동적 폰트 크기",
  "schemas.text.format": "형식",
  "schemas.mvt.typingInstructions": "중괄호로 묶인 단어를 입력하여 변수를 추가하세요.",
  "schemas.mvt.sampleField": "이름",
  "schemas.mvt.variablesSampleData": "변수 샘플 데이터",
  "schemas.barcodes.barColor": "바코드 색상",
  "schemas.barcodes.includetext": "텍스트 포함",
  "schemas.table.alternateBackgroundColor": "대체 배경색",
  "schemas.table.tableStyle": "테이블 스타일",
  "schemas.table.headStyle": "헤더 스타일",
  "schemas.table.bodyStyle": "본문 스타일",
  "schemas.table.columnStyle": "열 스타일",
  "schemas.date.format": "날짜 형식",
  "schemas.select.options": "옵션",
  "schemas.select.optionPlaceholder": "옵션을 입력하세요"
}, dictAr = {
  cancel: "إلغاء",
  close: "إغلاق",
  field: "الحقل",
  fieldName: "اسم الحقل",
  align: "محاذاة",
  width: "العرض",
  height: "الارتفاع",
  opacity: "الشفافية",
  rotate: "تدوير",
  required: "مطلوب",
  editable: "قابل للتحرير",
  edit: "تعديل",
  plsInputName: "الرجاء إدخال الاسم",
  fieldMustUniq: "يجب أن يكون الحقل فريداً",
  notUniq: "(غير فريد)",
  noKeyName: "لا يوجد اسم للحقل",
  fieldsList: "قائمة الحقول",
  editField: "تعديل الحقل",
  type: "النوع",
  errorOccurred: "حدث خطأ",
  errorBulkUpdateFieldName: "لا يمكن تنفيذ التغيير لأنه تم تغيير عدد العناصر.",
  commitBulkUpdateFieldName: "تنفيذ التغييرات",
  bulkUpdateFieldName: "تغيير الأسماء",
  addPageAfter: "إضافة صفحة بعد",
  removePage: "احذف الصفحة الحالية",
  removePageConfirm: "هل أنت متأكد من رغبتك في حذف هذه الصفحة؟ لا يمكن التراجع عن هذا الإجراء.",
  "validation.hexColor": "الرجاء إدخال رمز لون سداسي عشري صالح.",
  "validation.uniqueName": "الرجاء إدخال اسم فريد.",
  "schemas.color": "اللون",
  "schemas.borderWidth": "عرض الحدود",
  "schemas.borderColor": "لون الحدود",
  "schemas.backgroundColor": "لون الخلفية",
  "schemas.textColor": "لون الخط",
  "schemas.bgColor": "لون الخلفية",
  "schemas.horizontal": "أفقي",
  "schemas.vertical": "عمودي",
  "schemas.left": "يسار",
  "schemas.center": "مركز",
  "schemas.right": "يمين",
  "schemas.top": "أعلى",
  "schemas.middle": "وسط",
  "schemas.bottom": "أسفل",
  "schemas.padding": "التبطين",
  "schemas.text.fontName": "اسم الخط",
  "schemas.text.size": "الحجم",
  "schemas.text.spacing": "التباعد",
  "schemas.text.textAlign": "محاذاة النص",
  "schemas.text.verticalAlign": "محاذاة عمودية",
  "schemas.text.lineHeight": "ارتفاع السطر",
  "schemas.text.min": "الحد الأدنى",
  "schemas.text.max": "الحد الأقصى",
  "schemas.text.fit": "ملاءمة",
  "schemas.text.dynamicFontSize": "حجم الخط الديناميكي",
  "schemas.text.format": "تنسيق",
  "schemas.mvt.typingInstructions": "قم بإضافة المتغيرات عن طريق كتابة الكلمات المحاطة بأقواس متعرجة، على سبيل المثال:",
  "schemas.mvt.sampleField": "اسم",
  "schemas.mvt.variablesSampleData": "بيانات عينة المتغيرات",
  "schemas.barcodes.barColor": "لون الشريط",
  "schemas.barcodes.includetext": "تضمين النص",
  "schemas.table.alternateBackgroundColor": "لون الخلفية البديل",
  "schemas.table.tableStyle": "أسلوب الجدول",
  "schemas.table.headStyle": "أسلوب الرأس",
  "schemas.table.bodyStyle": "أسلوب الجسم",
  "schemas.table.columnStyle": "أسلوب العمود",
  "schemas.date.format": "تنسيق التاريخ",
  "schemas.select.options": "خيارات",
  "schemas.select.optionPlaceholder": "أدخل خيارًا"
}, dictTh = {
  cancel: "ยกเลิก",
  close: "ปิด",
  field: "ฟิลด์",
  fieldName: "ชื่อฟิลด์",
  align: "จัดเรียง",
  width: "ความกว้าง",
  height: "ความสูง",
  opacity: "ความทึบ",
  rotate: "หมุน",
  required: "ที่จำเป็น",
  editable: "แก้ไขได้",
  edit: "แก้ไข",
  plsInputName: "กรุณาใส่ชื่อ",
  fieldMustUniq: "ชื่อฟิลด์ต้องไม่ซ้ำกัน",
  notUniq: "(ชื่อฟิลด์ซ้ำกัน)",
  noKeyName: "ไม่มีชื่อ",
  fieldsList: "รายการฟิลด์ทั้งหมด",
  editField: "แก้ไขฟิลด์",
  type: "ประเภท",
  errorOccurred: "เกิดข้อผิดพลาด",
  errorBulkUpdateFieldName: "ไม่สามารถยืนยันการแก้ไขได้เนื่องจากจำนวนรายการมีการเปลี่ยนแปลง",
  commitBulkUpdateFieldName: "ยืนยันการแก้ไข",
  bulkUpdateFieldName: "แก้ไขชื่อฟิลด์เป็นชุด",
  addPageAfter: "เพิ่มหน้าถัดไป",
  removePage: "ลบหน้าปัจจุบัน",
  removePageConfirm: "คุณแน่ใจหรือไม่ว่าต้องการลบหน้านี้? การกระทำนี้ไม่สามารถย้อนกลับได้",
  "validation.hexColor": "กรุณาใส่รหัสสีแบบฐานสิบหกที่ถูกต้อง",
  "validation.uniqueName": "กรุณาระบุชื่อที่ไม่ซ้ำ",
  "schemas.color": "สี",
  "schemas.borderWidth": "ความกว้างของเส้นขอบ",
  "schemas.borderColor": "สีขอบ",
  "schemas.backgroundColor": "สีพื้นหลัง",
  "schemas.textColor": "สีข้อความ",
  "schemas.bgColor": "สีพื้นหลัง",
  "schemas.horizontal": "แนวนอน",
  "schemas.vertical": "แนวตั้ง",
  "schemas.left": "ซ้าย",
  "schemas.center": "ตรงกลาง",
  "schemas.right": "ขวา",
  "schemas.top": "ด้านบน",
  "schemas.middle": "ตรงกลาง",
  "schemas.bottom": "ด้านล่าง",
  "schemas.padding": "การเพิ่มพื้นที่",
  "schemas.text.fontName": "ชื่อแบบอักษร",
  "schemas.text.size": "ขนาด",
  "schemas.text.spacing": "ระยะห่าง",
  "schemas.text.textAlign": "จัดแนวข้อความ",
  "schemas.text.verticalAlign": "จัดแนวแนวตั้ง",
  "schemas.text.lineHeight": "ความสูงของบรรทัด",
  "schemas.text.min": "ต่ำสุด",
  "schemas.text.max": "สูงสุด",
  "schemas.text.fit": "พอดี",
  "schemas.text.dynamicFontSize": "ขนาดตัวอักษรแบบไดนามิก",
  "schemas.text.format": "รูปแบบ",
  "schemas.mvt.typingInstructions": "เพิ่มตัวแปรโดยพิมพ์คำที่ล้อมรอบด้วยวงเล็บปีกกา เช่น",
  "schemas.mvt.sampleField": "ชื่อ",
  "schemas.mvt.variablesSampleData": "ข้อมูลตัวอย่างตัวแปร",
  "schemas.barcodes.barColor": "สีบาร์",
  "schemas.barcodes.includetext": "รวมข้อความ",
  "schemas.table.alternateBackgroundColor": "สีพื้นหลังสลับกัน",
  "schemas.table.tableStyle": "สไตล์ตาราง",
  "schemas.table.headStyle": "สไตล์หัวข้อ",
  "schemas.table.bodyStyle": "สไตล์เนื้อหา",
  "schemas.table.columnStyle": "สไตล์คอลัมน์",
  "schemas.date.format": "รูปแบบวันที่",
  "schemas.select.options": "ตัวเลือก",
  "schemas.select.optionPlaceholder": "กรอกตัวเลือก"
}, dictIt = {
  cancel: "Annulla",
  close: "Chiudi",
  field: "Campo",
  fieldName: "Nome",
  align: "Allinea",
  width: "Larghezza",
  height: "Altezza",
  opacity: "Opacità",
  rotate: "Ruota",
  required: "Necessaria",
  editable: "Modificabile",
  edit: "Modifica",
  plsInputName: "Inserisci il nome per favore",
  fieldMustUniq: "Il nome del campo non è univoco",
  notUniq: "(Nome non univoco)",
  noKeyName: "Nessun nome",
  fieldsList: "Lista campi",
  editField: "Modifica campo",
  type: "Tipo",
  errorOccurred: "Riscontrato errore",
  errorBulkUpdateFieldName: "Non è possibile salvare le modifiche perché il numero di elementi è cambiato.",
  commitBulkUpdateFieldName: "Salva cambiamenti",
  bulkUpdateFieldName: "Modifica nomi campi in blocco",
  addPageAfter: "Aggiungi pagina dopo",
  removePage: "Rimuovi la Pagina Corrente",
  removePageConfirm: "Sei sicuro di voler eliminare questa pagina? Questa azione non può essere annullata.",
  "validation.hexColor": "Inserisci un codice colore esadecimale valido.",
  "validation.uniqueName": "Inserisci un nome univoco.",
  "schemas.color": "Colore",
  "schemas.borderWidth": "Spessore bordo",
  "schemas.borderColor": "Colore bordo",
  "schemas.backgroundColor": "Colore di Sfondo",
  "schemas.textColor": "Colore testo",
  "schemas.bgColor": "Colore sfondo",
  "schemas.horizontal": "Orizzontale",
  "schemas.vertical": "Verticale",
  "schemas.left": "Sinistra",
  "schemas.center": "Centro",
  "schemas.right": "Destra",
  "schemas.top": "Sopra",
  "schemas.middle": "Medio",
  "schemas.bottom": "Sotto",
  "schemas.padding": "Padding",
  "schemas.text.fontName": "Nome del font",
  "schemas.text.size": "Dimensione",
  "schemas.text.spacing": "Spaziatura",
  "schemas.text.textAlign": "Allineamento testo",
  "schemas.text.verticalAlign": "Allineamento verticale",
  "schemas.text.lineHeight": "Altezza della linea",
  "schemas.text.min": "Minimo",
  "schemas.text.max": "Massimo",
  "schemas.text.fit": "Adatta",
  "schemas.text.dynamicFontSize": "Dimensione font dinamica",
  "schemas.text.format": "Formato",
  "schemas.mvt.typingInstructions": "Aggiungi variabili digitando parole circondate da parentesi graffe, ad es.",
  "schemas.mvt.sampleField": "nome",
  "schemas.mvt.variablesSampleData": "Dati di esempio variabili",
  "schemas.barcodes.barColor": "Colore barra",
  "schemas.barcodes.includetext": "Includi testo",
  "schemas.table.alternateBackgroundColor": "Colore di Sfondo Alternato",
  "schemas.table.tableStyle": "Stile della Tabella",
  "schemas.table.headStyle": "Stile dell'Intestazione",
  "schemas.table.bodyStyle": "Stile del Corpo",
  "schemas.table.columnStyle": "Stile della Colonna",
  "schemas.date.format": "Formato data",
  "schemas.select.options": "Opzioni",
  "schemas.select.optionPlaceholder": "Inserisci un'opzione"
}, dictPl = {
  cancel: "Anuluj",
  close: "Zamknij",
  field: "pole",
  fieldName: "Klucz pola",
  align: "Wyrównanie",
  width: "Szerokość",
  height: "Wysokość",
  opacity: "przezroczystość",
  rotate: "Obrót",
  required: "Wymagany",
  editable: "Edytowalny",
  edit: "Edytuj",
  plsInputName: "Wymagane wprowadzenie klucza pola",
  fieldMustUniq: "Klucz pola nie jest unikalny",
  notUniq: "(Klucz pola nie jest unikalny)",
  noKeyName: "Brak nazwy klucza pola",
  fieldsList: "Lista pól",
  editField: "Edytuj pole",
  type: "Typ pola",
  errorOccurred: "Wystąpił błąd",
  errorBulkUpdateFieldName: "Nie można wprowadzić zmian ponieważ liczba elementów uległa zmianie.",
  commitBulkUpdateFieldName: "Zaakceptuj zmiany",
  bulkUpdateFieldName: "Masowo aktualizuj klucze pól",
  addPageAfter: "Dodaj stronę po",
  removePage: "Usuń Bieżącą Stronę",
  removePageConfirm: "Czy na pewno chcesz usunąć tę stronę? Tej operacji nie można cofnąć.",
  "validation.hexColor": "Wprowadź poprawny kod koloru szesnastkowego.",
  "validation.uniqueName": "Proszę wpisać unikalną nazwę.",
  "schemas.color": "Kolor",
  "schemas.borderWidth": "Szerokość obramowania",
  "schemas.borderColor": "Kolor obramowania",
  "schemas.backgroundColor": "Kolor tła",
  "schemas.textColor": "Kolor tekstu",
  "schemas.bgColor": "Kolor tła",
  "schemas.horizontal": "Poziomo",
  "schemas.vertical": "Pionowo",
  "schemas.left": "Lewo",
  "schemas.center": "Centrum",
  "schemas.right": "Prawo",
  "schemas.top": "Góra",
  "schemas.middle": "Środek",
  "schemas.bottom": "Dół",
  "schemas.padding": "Odsadzenie",
  "schemas.text.fontName": "Nazwa czcionki",
  "schemas.text.size": "Rozmiar",
  "schemas.text.spacing": "Odstępy",
  "schemas.text.textAlign": "Wyrównanie tekstu",
  "schemas.text.verticalAlign": "Wyrównanie pionowe",
  "schemas.text.lineHeight": "Wysokość linii",
  "schemas.text.min": "Minimum",
  "schemas.text.max": "Maksimum",
  "schemas.text.fit": "Dopasowanie",
  "schemas.text.dynamicFontSize": "Dynamiczny rozmiar czcionki",
  "schemas.text.format": "Format",
  "schemas.mvt.typingInstructions": "Dodaj zmienne, wpisując słowa ujęte w nawiasy klamrowe, np.",
  "schemas.mvt.sampleField": "nazwa",
  "schemas.mvt.variablesSampleData": "Zmienne Przykładowe dane",
  "schemas.barcodes.barColor": "Kolor paska",
  "schemas.barcodes.includetext": "Dołącz tekst",
  "schemas.table.alternateBackgroundColor": "Alternatywny kolor tła",
  "schemas.table.tableStyle": "Styl tabeli",
  "schemas.table.headStyle": "Styl nagłówka",
  "schemas.table.bodyStyle": "Styl ciała",
  "schemas.table.columnStyle": "Styl kolumny",
  "schemas.date.format": "Format daty",
  "schemas.select.options": "Opcje",
  "schemas.select.optionPlaceholder": "Wpisz opcję"
}, dictDe = {
  cancel: "Abbrechen",
  close: "Schließen",
  field: "Feld",
  fieldName: "Name",
  align: "Ausrichten",
  width: "Breite",
  height: "Höhe",
  opacity: "Opazität",
  rotate: "Drehen",
  required: "Erforderlich",
  editable: "Bearbeitbar",
  edit: "Bearbeiten",
  plsInputName: "Bitte geben Sie einen Namen ein",
  fieldMustUniq: "Feldname ist nicht eindeutig",
  notUniq: "(Nicht eindeutiger Name)",
  noKeyName: "Kein Name",
  fieldsList: "Feldliste",
  editField: "Feld bearbeiten",
  type: "Typ",
  errorOccurred: "Ein Fehler ist aufgetreten",
  errorBulkUpdateFieldName: "Die Änderung kann nicht übernommen werden, weil die Anzahl der Elemente geändert wurde.",
  commitBulkUpdateFieldName: "Änderungen übernehmen",
  bulkUpdateFieldName: "Mehrfachaktualisierung der Feldnamen",
  addPageAfter: "Seite danach hinzufügen",
  removePage: "Aktuelle Seite entfernen",
  removePageConfirm: "Sind Sie sicher, dass Sie diese Seite löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
  "validation.hexColor": "Bitte geben Sie einen gültigen Hex-Farbcode ein.",
  "validation.uniqueName": "Bitte geben Sie einen eindeutigen Namen ein.",
  "schemas.color": "Farbe",
  "schemas.borderWidth": "Rahmenbreite",
  "schemas.borderColor": "Rahmenfarbe",
  "schemas.backgroundColor": "Hintergrundfarbe",
  "schemas.textColor": "Textfarbe",
  "schemas.bgColor": "Hintergrundfarbe",
  "schemas.horizontal": "Horizontal",
  "schemas.vertical": "Vertikal",
  "schemas.left": "Links",
  "schemas.center": "Zentriert",
  "schemas.right": "Rechts",
  "schemas.top": "Oben",
  "schemas.middle": "Mitte",
  "schemas.bottom": "Unten",
  "schemas.padding": "Polsterung",
  "schemas.text.fontName": "Schriftart",
  "schemas.text.size": "Größe",
  "schemas.text.spacing": "Abstand",
  "schemas.text.textAlign": "Ausrichtung",
  "schemas.text.verticalAlign": "vert. Ausr.",
  "schemas.text.lineHeight": "Zeilenhöhe",
  "schemas.text.min": "Min",
  "schemas.text.max": "Max",
  "schemas.text.fit": "Anpassen",
  "schemas.text.dynamicFontSize": "Dynamische Schriftgröße",
  "schemas.text.format": "Format",
  "schemas.mvt.typingInstructions": "Fügen Sie Variablen hinzu, indem Sie Wörter in geschweiften Klammern eingeben, z. B.",
  "schemas.mvt.sampleField": "Name",
  "schemas.mvt.variablesSampleData": "Variablen Beispieldaten",
  "schemas.barcodes.barColor": "Strichcodefarbe",
  "schemas.barcodes.includetext": "Text anzeigen",
  "schemas.table.alternateBackgroundColor": "Wechselnde Hintergrundfarbe",
  "schemas.table.tableStyle": "Tabellenstil",
  "schemas.table.headStyle": "Kopfzeilenstil",
  "schemas.table.bodyStyle": "Körperstil",
  "schemas.table.columnStyle": "Spaltenstil",
  "schemas.date.format": "Datumsformat",
  "schemas.select.options": "Optionen",
  "schemas.select.optionPlaceholder": "Geben Sie eine Option ein"
}, dictEs = {
  cancel: "Cancelar",
  close: "Cerrar",
  field: "campo",
  fieldName: "Nombre",
  align: "Alinear",
  width: "Anchura",
  height: "Altura",
  opacity: "Opacidad",
  rotate: "Rotar",
  required: "Requerido",
  editable: "Editable",
  edit: "Editar",
  plsInputName: "Introduce el nombre",
  fieldMustUniq: "El nombre del campo no es único",
  notUniq: "(Nombre no único)",
  noKeyName: "Sin nombre",
  fieldsList: "Lista de campos",
  editField: "Editar campo",
  type: "Tipo",
  errorOccurred: "Ocurrió un error",
  errorBulkUpdateFieldName: "No se puede confirmar el cambio porque el número de elementos ha cambiado.",
  commitBulkUpdateFieldName: "Confirmar cambios",
  bulkUpdateFieldName: "Actualizar en bloque el nombre de los campos",
  addPageAfter: "Insertar página",
  removePage: "Eliminar página actual",
  removePageConfirm: "¿Estás seguro de que quieres eliminar esta página? Esta acción no se puede deshacer.",
  "validation.hexColor": "Introduce un código de color hexadecimal válido.",
  "validation.uniqueName": "Por favor, introduzca un nombre único.",
  "schemas.color": "Color",
  "schemas.borderWidth": "Ancho del borde",
  "schemas.borderColor": "Color del borde",
  "schemas.backgroundColor": "Color de fondo",
  "schemas.textColor": "Color del texto",
  "schemas.bgColor": "Color del fondo",
  "schemas.horizontal": "Horizontal",
  "schemas.vertical": "Vertical",
  "schemas.left": "Izquierda",
  "schemas.center": "Centro",
  "schemas.right": "Derecha",
  "schemas.top": "Arriba",
  "schemas.middle": "Medio",
  "schemas.bottom": "Abajo",
  "schemas.padding": "Relleno",
  "schemas.text.fontName": "Nombre de la fuente",
  "schemas.text.size": "Tamaño",
  "schemas.text.spacing": "Espaciado",
  "schemas.text.textAlign": "Alineación del texto",
  "schemas.text.verticalAlign": "Alineación vertical",
  "schemas.text.lineHeight": "Altura de línea",
  "schemas.text.min": "Mín",
  "schemas.text.max": "Máx",
  "schemas.text.fit": "Ajustar",
  "schemas.text.dynamicFontSize": "Tamaño de fuente dinámico",
  "schemas.text.format": "Formato",
  "schemas.mvt.typingInstructions": "Agregue variables escribiendo palabras entre llaves, p.",
  "schemas.mvt.sampleField": "nombre",
  "schemas.mvt.variablesSampleData": "Variables Datos de muestra",
  "schemas.barcodes.barColor": "Color de la barra",
  "schemas.barcodes.includetext": "Incluir texto",
  "schemas.table.alternateBackgroundColor": "Color de fondo alternativo",
  "schemas.table.tableStyle": "Estilo de tabla",
  "schemas.table.headStyle": "Estilo de cabecera",
  "schemas.table.bodyStyle": "Estilo de cuerpo",
  "schemas.table.columnStyle": "Estilo de columna",
  "schemas.date.format": "Formato de fecha",
  "schemas.select.options": "Opciones",
  "schemas.select.optionPlaceholder": "Ingrese una opción"
}, dictFr = {
  cancel: "Annuler",
  close: "Fermer",
  field: "Champ",
  fieldName: "Nom",
  align: "Aligner",
  width: "Largeur",
  height: "Hauteur",
  opacity: "Opacité",
  rotate: "Rotation",
  required: "Requis",
  editable: "Modifiable",
  edit: "Éditer",
  plsInputName: "Veuillez saisir le nom",
  fieldMustUniq: "Le nom du champ n'est pas unique",
  notUniq: "(Nombre non unique)",
  noKeyName: "Pas de nom",
  fieldsList: "Liste des champs",
  editField: "Éditer le champ",
  type: "Type",
  errorOccurred: "Une erreur est survenue",
  errorBulkUpdateFieldName: "Impossible de confirmer le changement car le nombre d'éléments a changé.",
  commitBulkUpdateFieldName: "Confirmer les changements",
  bulkUpdateFieldName: "Modifier les noms de champs en masse",
  addPageAfter: "Ajouter une page après",
  removePage: "Supprimer la page actuelle",
  removePageConfirm: "Êtes-vous sûr de vouloir supprimer cette page ? Cette action est irréversible.",
  "validation.hexColor": "Veuillez entrer un code couleur hexadécimal valide.",
  "validation.uniqueName": "Veuillez saisir un nom unique.",
  "schemas.color": "Couleur",
  "schemas.borderWidth": "Largeur de la bordure",
  "schemas.borderColor": "Couleur de la bordure",
  "schemas.backgroundColor": "Couleur de fond",
  "schemas.textColor": "Couleur du texte",
  "schemas.bgColor": "Couleur de fond",
  "schemas.horizontal": "Horizontal",
  "schemas.vertical": "Vertical",
  "schemas.left": "Gauche",
  "schemas.center": "Centre",
  "schemas.right": "Droite",
  "schemas.top": "Haut",
  "schemas.middle": "Milieu",
  "schemas.bottom": "Bas",
  "schemas.padding": "Zone de remplissage",
  "schemas.text.fontName": "Nom de la police",
  "schemas.text.size": "Taille",
  "schemas.text.spacing": "Espacement",
  "schemas.text.textAlign": "Alignement du texte",
  "schemas.text.verticalAlign": "Alignement vertical",
  "schemas.text.lineHeight": "Hauteur de ligne",
  "schemas.text.min": "Min",
  "schemas.text.max": "Max",
  "schemas.text.fit": "Ajustement",
  "schemas.text.dynamicFontSize": "Taille de police dynamique",
  "schemas.text.format": "Format",
  "schemas.mvt.typingInstructions": "Ajoutez des variables en tapant des mots entourés d'accolades, par ex.",
  "schemas.mvt.sampleField": "nom",
  "schemas.mvt.variablesSampleData": "Variables Exemples de données",
  "schemas.barcodes.barColor": "Couleur de la barre",
  "schemas.barcodes.includetext": "Inclure le texte",
  "schemas.table.alternateBackgroundColor": "Couleur de fond alternative",
  "schemas.table.tableStyle": "Style de tableau",
  "schemas.table.headStyle": "Style d'en-tête",
  "schemas.table.bodyStyle": "Style de corps",
  "schemas.table.columnStyle": "Style de colonne",
  "schemas.date.format": "Format de date",
  "schemas.select.options": "Options",
  "schemas.select.optionPlaceholder": "Entrez une option"
}, dictionaries = {
  en: dictEn,
  zh: dictZh,
  ja: dictJa,
  ko: dictKo,
  ar: dictAr,
  th: dictTh,
  it: dictIt,
  pl: dictPl,
  de: dictDe,
  es: dictEs,
  fr: dictFr
}, getDict = (a) => dictionaries[a] || dictionaries[DEFAULT_LANG], i18n = (a, s) => (s || getDict(DEFAULT_LANG))[a], I18nContext = reactExports.createContext(i18n), FontContext = reactExports.createContext(getDefaultFont()), PluginsRegistry = reactExports.createContext(builtInPlugins), OptionsContext = reactExports.createContext({});
function arrayMove(a, s, $) {
  const _ = a.slice();
  return _.splice($ < 0 ? _.length + $ : $, 0, _.splice(s, 1)[0]), _;
}
function getSortedRects(a, s) {
  return a.reduce(($, _, _e) => {
    const tt = s.get(_);
    return tt && ($[_e] = tt), $;
  }, Array(a.length));
}
function isValidIndex(a) {
  return a !== null && a >= 0;
}
function itemsEqual(a, s) {
  if (a === s)
    return !0;
  if (a.length !== s.length)
    return !1;
  for (let $ = 0; $ < a.length; $++)
    if (a[$] !== s[$])
      return !1;
  return !0;
}
function normalizeDisabled(a) {
  return typeof a == "boolean" ? {
    draggable: a,
    droppable: a
  } : a;
}
const rectSortingStrategy = (a) => {
  let {
    rects: s,
    activeIndex: $,
    overIndex: _,
    index: _e
  } = a;
  const tt = arrayMove(s, _, $), nt = s[_e], at = tt[_e];
  return !at || !nt ? null : {
    x: at.left - nt.left,
    y: at.top - nt.top,
    scaleX: at.width / nt.width,
    scaleY: at.height / nt.height
  };
}, defaultScale$1 = {
  scaleX: 1,
  scaleY: 1
}, verticalListSortingStrategy = (a) => {
  var s;
  let {
    activeIndex: $,
    activeNodeRect: _,
    index: _e,
    rects: tt,
    overIndex: nt
  } = a;
  const at = (s = tt[$]) != null ? s : _;
  if (!at)
    return null;
  if (_e === $) {
    const rt = tt[nt];
    return rt ? {
      x: 0,
      y: $ < nt ? rt.top + rt.height - (at.top + at.height) : rt.top - at.top,
      ...defaultScale$1
    } : null;
  }
  const ot = getItemGap$1(tt, _e, $);
  return _e > $ && _e <= nt ? {
    x: 0,
    y: -at.height - ot,
    ...defaultScale$1
  } : _e < $ && _e >= nt ? {
    x: 0,
    y: at.height + ot,
    ...defaultScale$1
  } : {
    x: 0,
    y: 0,
    ...defaultScale$1
  };
};
function getItemGap$1(a, s, $) {
  const _ = a[s], _e = a[s - 1], tt = a[s + 1];
  return _ ? $ < s ? _e ? _.top - (_e.top + _e.height) : tt ? tt.top - (_.top + _.height) : 0 : tt ? tt.top - (_.top + _.height) : _e ? _.top - (_e.top + _e.height) : 0 : 0;
}
const ID_PREFIX = "Sortable", Context$1 = /* @__PURE__ */ React$a.createContext({
  activeIndex: -1,
  containerId: ID_PREFIX,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: rectSortingStrategy,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function SortableContext(a) {
  let {
    children: s,
    id: $,
    items: _,
    strategy: _e = rectSortingStrategy,
    disabled: tt = !1
  } = a;
  const {
    active: nt,
    dragOverlay: at,
    droppableRects: ot,
    over: rt,
    measureDroppableContainers: st
  } = useDndContext(), lt = useUniqueId(ID_PREFIX, $), et = at.rect !== null, it = reactExports.useMemo(() => _.map((vt) => typeof vt == "object" && "id" in vt ? vt.id : vt), [_]), ut = nt != null, ft = nt ? it.indexOf(nt.id) : -1, ht = rt ? it.indexOf(rt.id) : -1, dt = reactExports.useRef(it), gt = !itemsEqual(it, dt.current), pt = ht !== -1 && ft === -1 || gt, mt = normalizeDisabled(tt);
  useIsomorphicLayoutEffect$1(() => {
    gt && ut && st(it);
  }, [gt, it, ut, st]), reactExports.useEffect(() => {
    dt.current = it;
  }, [it]);
  const ct = reactExports.useMemo(
    () => ({
      activeIndex: ft,
      containerId: lt,
      disabled: mt,
      disableTransforms: pt,
      items: it,
      overIndex: ht,
      useDragOverlay: et,
      sortedRects: getSortedRects(it, ot),
      strategy: _e
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ft, lt, mt.draggable, mt.droppable, pt, it, ht, ot, et, _e]
  );
  return React$a.createElement(Context$1.Provider, {
    value: ct
  }, s);
}
const defaultNewIndexGetter = (a) => {
  let {
    id: s,
    items: $,
    activeIndex: _,
    overIndex: _e
  } = a;
  return arrayMove($, _, _e).indexOf(s);
}, defaultAnimateLayoutChanges = (a) => {
  let {
    containerId: s,
    isSorting: $,
    wasDragging: _,
    index: _e,
    items: tt,
    newIndex: nt,
    previousItems: at,
    previousContainerId: ot,
    transition: rt
  } = a;
  return !rt || !_ || at !== tt && _e === nt ? !1 : $ ? !0 : nt !== _e && s === ot;
}, defaultTransition = {
  duration: 200,
  easing: "ease"
}, transitionProperty = "transform", disabledTransition = /* @__PURE__ */ CSS$1.Transition.toString({
  property: transitionProperty,
  duration: 0,
  easing: "linear"
}), defaultAttributes = {
  roleDescription: "sortable"
};
function useDerivedTransform(a) {
  let {
    disabled: s,
    index: $,
    node: _,
    rect: _e
  } = a;
  const [tt, nt] = reactExports.useState(null), at = reactExports.useRef($);
  return useIsomorphicLayoutEffect$1(() => {
    if (!s && $ !== at.current && _.current) {
      const ot = _e.current;
      if (ot) {
        const rt = getClientRect$1(_.current, {
          ignoreTransform: !0
        }), st = {
          x: ot.left - rt.left,
          y: ot.top - rt.top,
          scaleX: ot.width / rt.width,
          scaleY: ot.height / rt.height
        };
        (st.x || st.y) && nt(st);
      }
    }
    $ !== at.current && (at.current = $);
  }, [s, $, _, _e]), reactExports.useEffect(() => {
    tt && nt(null);
  }, [tt]), tt;
}
function useSortable(a) {
  let {
    animateLayoutChanges: s = defaultAnimateLayoutChanges,
    attributes: $,
    disabled: _,
    data: _e,
    getNewIndex: tt = defaultNewIndexGetter,
    id: nt,
    strategy: at,
    resizeObserverConfig: ot,
    transition: rt = defaultTransition
  } = a;
  const {
    items: st,
    containerId: lt,
    activeIndex: et,
    disabled: it,
    disableTransforms: ut,
    sortedRects: ft,
    overIndex: ht,
    useDragOverlay: dt,
    strategy: gt
  } = reactExports.useContext(Context$1), pt = normalizeLocalDisabled(_, it), mt = st.indexOf(nt), ct = reactExports.useMemo(() => ({
    sortable: {
      containerId: lt,
      index: mt,
      items: st
    },
    ..._e
  }), [lt, _e, mt, st]), vt = reactExports.useMemo(() => st.slice(st.indexOf(nt)), [st, nt]), {
    rect: At,
    node: xt,
    isOver: bt,
    setNodeRef: Et
  } = useDroppable({
    id: nt,
    data: ct,
    disabled: pt.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: vt,
      ...ot
    }
  }), {
    active: St,
    activatorEvent: Bt,
    activeNodeRect: Ot,
    attributes: Pt,
    setNodeRef: wt,
    listeners: Ct,
    isDragging: It,
    over: yt,
    setActivatorNodeRef: Rt,
    transform: kt
  } = useDraggable({
    id: nt,
    data: ct,
    attributes: {
      ...defaultAttributes,
      ...$
    },
    disabled: pt.draggable
  }), jt = useCombinedRefs(Et, wt), Ht = !!St, Ft = Ht && !ut && isValidIndex(et) && isValidIndex(ht), _t = !dt && It, Nt = _t && Ft ? kt : null, Lt = Ft ? Nt ?? (at ?? gt)({
    rects: ft,
    activeNodeRect: Ot,
    activeIndex: et,
    overIndex: ht,
    index: mt
  }) : null, $t = isValidIndex(et) && isValidIndex(ht) ? tt({
    id: nt,
    items: st,
    activeIndex: et,
    overIndex: ht
  }) : mt, Tt = St == null ? void 0 : St.id, Dt = reactExports.useRef({
    activeId: Tt,
    items: st,
    newIndex: $t,
    containerId: lt
  }), Ut = st !== Dt.current.items, Vt = s({
    active: St,
    containerId: lt,
    isDragging: It,
    isSorting: Ht,
    id: nt,
    index: mt,
    items: st,
    newIndex: Dt.current.newIndex,
    previousItems: Dt.current.items,
    previousContainerId: Dt.current.containerId,
    transition: rt,
    wasDragging: Dt.current.activeId != null
  }), Qt = useDerivedTransform({
    disabled: !Vt,
    index: mt,
    node: xt,
    rect: At
  });
  return reactExports.useEffect(() => {
    Ht && Dt.current.newIndex !== $t && (Dt.current.newIndex = $t), lt !== Dt.current.containerId && (Dt.current.containerId = lt), st !== Dt.current.items && (Dt.current.items = st);
  }, [Ht, $t, lt, st]), reactExports.useEffect(() => {
    if (Tt === Dt.current.activeId)
      return;
    if (Tt && !Dt.current.activeId) {
      Dt.current.activeId = Tt;
      return;
    }
    const Zt = setTimeout(() => {
      Dt.current.activeId = Tt;
    }, 50);
    return () => clearTimeout(Zt);
  }, [Tt]), {
    active: St,
    activeIndex: et,
    attributes: Pt,
    data: ct,
    rect: At,
    index: mt,
    newIndex: $t,
    items: st,
    isOver: bt,
    isSorting: Ht,
    isDragging: It,
    listeners: Ct,
    node: xt,
    overIndex: ht,
    over: yt,
    setNodeRef: jt,
    setActivatorNodeRef: Rt,
    setDroppableNodeRef: Et,
    setDraggableNodeRef: wt,
    transform: Qt ?? Lt,
    transition: qt()
  };
  function qt() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      Qt || // Or to prevent items jumping to back to their "new" position when items change
      Ut && Dt.current.newIndex === mt
    )
      return disabledTransition;
    if (!(_t && !isKeyboardEvent(Bt) || !rt) && (Ht || Vt))
      return CSS$1.Transition.toString({
        ...rt,
        property: transitionProperty
      });
  }
}
function normalizeLocalDisabled(a, s) {
  var $, _;
  return typeof a == "boolean" ? {
    draggable: a,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: ($ = a == null ? void 0 : a.draggable) != null ? $ : s.draggable,
    droppable: (_ = a == null ? void 0 : a.droppable) != null ? _ : s.droppable
  };
}
function hasSortableData(a) {
  if (!a)
    return !1;
  const s = a.data.current;
  return !!(s && "sortable" in s && typeof s.sortable == "object" && "containerId" in s.sortable && "items" in s.sortable && "index" in s.sortable);
}
const directions = [KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left], sortableKeyboardCoordinates = (a, s) => {
  let {
    context: {
      active: $,
      collisionRect: _,
      droppableRects: _e,
      droppableContainers: tt,
      over: nt,
      scrollableAncestors: at
    }
  } = s;
  if (directions.includes(a.code)) {
    if (a.preventDefault(), !$ || !_)
      return;
    const ot = [];
    tt.getEnabled().forEach((lt) => {
      if (!lt || lt != null && lt.disabled)
        return;
      const et = _e.get(lt.id);
      if (et)
        switch (a.code) {
          case KeyboardCode.Down:
            _.top < et.top && ot.push(lt);
            break;
          case KeyboardCode.Up:
            _.top > et.top && ot.push(lt);
            break;
          case KeyboardCode.Left:
            _.left > et.left && ot.push(lt);
            break;
          case KeyboardCode.Right:
            _.left < et.left && ot.push(lt);
            break;
        }
    });
    const rt = closestCorners({
      active: $,
      collisionRect: _,
      droppableRects: _e,
      droppableContainers: ot,
      pointerCoordinates: null
    });
    let st = getFirstCollision(rt, "id");
    if (st === (nt == null ? void 0 : nt.id) && rt.length > 1 && (st = rt[1].id), st != null) {
      const lt = tt.get($.id), et = tt.get(st), it = et ? _e.get(et.id) : null, ut = et == null ? void 0 : et.node.current;
      if (ut && it && lt && et) {
        const ht = getScrollableAncestors(ut).some((vt, At) => at[At] !== vt), dt = isSameContainer(lt, et), gt = isAfter(lt, et), pt = ht || !dt ? {
          x: 0,
          y: 0
        } : {
          x: gt ? _.width - it.width : 0,
          y: gt ? _.height - it.height : 0
        }, mt = {
          x: it.left,
          y: it.top
        };
        return pt.x && pt.y ? mt : subtract(mt, pt);
      }
    }
  }
};
function isSameContainer(a, s) {
  return !hasSortableData(a) || !hasSortableData(s) ? !1 : a.data.current.sortable.containerId === s.data.current.sortable.containerId;
}
function isAfter(a, s) {
  return !hasSortableData(a) || !hasSortableData(s) || !isSameContainer(a, s) ? !1 : a.data.current.sortable.index < s.data.current.sortable.index;
}
const { Text: Text$4 } = Typography$1, Item = React$a.memo(
  React$a.forwardRef(
    ({
      icon: a,
      value: s,
      status: $,
      title: _,
      required: _e,
      readOnly: tt,
      style: nt,
      dragOverlay: at,
      onClick: ot,
      onMouseEnter: rt,
      onMouseLeave: st,
      dragging: lt,
      fadeIn: et,
      listeners: it,
      sorting: ut,
      transition: ft,
      transform: ht,
      ...dt
    }, gt) => {
      const pt = reactExports.useContext(I18nContext);
      reactExports.useEffect(() => {
        if (at)
          return document.body.style.cursor = "grabbing", () => {
            document.body.style.cursor = "";
          };
      }, [at]);
      const { x: mt, y: ct, scaleX: vt, scaleY: At } = ht || { x: 0, y: 0, scaleX: 1, scaleY: 1 };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "li",
        {
          style: {
            marginTop: 10,
            transition: ft,
            transform: `translate(${mt}px, ${ct}px) scale(${vt}, ${At})`
          },
          onMouseEnter: rt,
          onMouseLeave: st,
          ref: gt,
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                ...nt
              },
              ...dt,
              onClick: () => ot && ot(),
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Button$2,
                  {
                    ...it,
                    style: {
                      display: "flex",
                      alignItems: "center",
                      background: "none",
                      boxShadow: "none",
                      border: "none",
                      paddingLeft: "0.25rem"
                    },
                    icon: /* @__PURE__ */ jsxRuntimeExports.jsx(HolderOutlined$1, { style: { cursor: "grab" } })
                  }
                ),
                a,
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  Text$4,
                  {
                    style: {
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      width: "100%"
                    },
                    title: _ || "",
                    children: [
                      $ === void 0 ? s : /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
                        /* @__PURE__ */ jsxRuntimeExports.jsx(ExclamationCircleOutlined$1, { width: 15, style: { marginRight: "0.5rem" } }),
                        $ === "is-warning" ? pt("noKeyName") : s,
                        $ === "is-danger" ? pt("notUniq") : ""
                      ] }),
                      tt && /* @__PURE__ */ jsxRuntimeExports.jsx(LockOutlined$1, { style: { marginLeft: "0.5rem" } }),
                      _e && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { color: "red", marginLeft: "0.5rem" }, children: "*" })
                    ]
                  }
                )
              ]
            }
          )
        }
      );
    }
  )
), Item$1 = Item, usePrevious = (a) => {
  const s = reactExports.useRef(null);
  return reactExports.useEffect(() => {
    s.current = a;
  }), s.current;
}, getScale = (a, s) => Math.floor((a / s > 1 ? 1 : a / s) * 100) / 100, useUIPreProcessor = ({ template: a, size: s, zoomLevel: $ }) => {
  const [_, _e] = reactExports.useState([]), [tt, nt] = reactExports.useState([]), [at, ot] = reactExports.useState(0), [rt, st] = reactExports.useState(null), lt = async (et) => {
    const {
      template: { basePdf: it, schemas: ut },
      size: ft
    } = et;
    let ht, dt, gt, pt;
    if (isBlankPdf(it)) {
      const { width: ct, height: vt } = it;
      ht = ct * ZOOM, dt = vt * ZOOM, gt = ut.map(
        () => "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdj+P///38ACfsD/QVDRcoAAAAASUVORK5CYII="
      ), pt = ut.map(() => ({ width: ct, height: vt }));
    } else {
      const ct = await getB64BasePdf(it), vt = b64toBlob(ct);
      pt = await getPdfPageSizes(vt), ht = pt[0].width * ZOOM, dt = pt[0].height * ZOOM, gt = await pdf2Pngs(vt, ht);
    }
    const mt = Math.min(
      getScale(ft.width, ht),
      getScale(ft.height - RULER_HEIGHT, dt)
    );
    return { backgrounds: gt, pageSizes: pt, scale: mt };
  };
  return reactExports.useEffect(() => {
    lt({ template: a, size: s }).then(({ pageSizes: et, scale: it, backgrounds: ut }) => {
      nt(et), ot(it), _e(ut);
    }).catch((et) => {
      st(et), console.error(`[@pdfme/ui] ${et}`);
    });
  }, [a, s]), {
    backgrounds: _,
    pageSizes: tt,
    scale: at * $,
    error: rt,
    refresh: (et) => lt({ template: et, size: s }).then(({ pageSizes: it, scale: ut, backgrounds: ft }) => {
      nt(it), ot(ut), _e(ft);
    })
  };
}, useScrollPageCursor = ({
  ref: a,
  pageSizes: s,
  scale: $,
  pageCursor: _,
  onChangePageCursor: _e
}) => {
  const tt = reactExports.useCallback(() => {
    if (!s[0] || !a.current)
      return;
    const nt = a.current.scrollTop, { top: at } = a.current.getBoundingClientRect(), ot = s.reduce((st, lt, et) => {
      let it = (lt.height * ZOOM + RULER_HEIGHT) * $;
      return et === 0 ? it += at - it / 2 : it += st[et - 1], st.concat(it);
    }, []);
    let rt = 0;
    ot.forEach((st, lt) => {
      nt > st && (rt = lt + 1 >= ot.length ? ot.length - 1 : lt + 1);
    }), rt !== _ && _e(rt);
  }, [_e, _, s, a, $]);
  reactExports.useEffect(() => {
    var nt;
    return (nt = a.current) == null || nt.addEventListener("scroll", tt), () => {
      var at;
      (at = a.current) == null || at.removeEventListener("scroll", tt);
    };
  }, [a, tt]);
}, useMountStatus = () => {
  const [a, s] = reactExports.useState(!1);
  return reactExports.useEffect(() => {
    const $ = setTimeout(() => s(!0), 500);
    return () => clearTimeout($);
  }, []), a;
}, useInitEvents = ({
  pageCursor: a,
  pageSizes: s,
  activeElements: $,
  template: _,
  schemasList: _e,
  changeSchemas: tt,
  commitSchemas: nt,
  removeSchemas: at,
  onSaveTemplate: ot,
  past: rt,
  future: st,
  setSchemasList: lt,
  onEdit: et,
  onEditEnd: it
}) => {
  const ut = reactExports.useRef(null), ft = reactExports.useCallback(() => {
    const dt = () => {
      const pt = $.map((mt) => mt.id);
      return _e[a].filter((mt) => pt.includes(mt.id));
    }, gt = (pt) => {
      const mt = pt === "undo", ct = mt ? rt : st;
      if (ct.current.length <= 0)
        return;
      (mt ? st : rt).current.push(cloneDeep$1(_e[a]));
      const vt = cloneDeep$1(_e);
      vt[a] = ct.current.pop(), lt(vt);
    };
    initShortCuts({
      move: (pt, mt) => {
        const ct = s[a], vt = dt(), At = moveCommandToChangeSchemasArg({ command: pt, activeSchemas: vt, pageSize: ct, isShift: mt });
        tt(At);
      },
      copy: () => {
        const pt = dt();
        pt.length !== 0 && (ut.current = pt);
      },
      paste: () => {
        if (!ut.current || ut.current.length === 0)
          return;
        const pt = _e[a], mt = [], ct = ut.current.map((vt) => {
          const At = uuid$6(), xt = getUniqueSchemaName({ copiedSchemaName: vt.name, schema: pt, stackUniqueSchemaNames: mt }), { height: bt, width: Et, position: St } = vt, Bt = s[a], Ot = {
            x: St.x + 10 > Bt.width - Et ? Bt.width - Et : St.x + 10,
            y: St.y + 10 > Bt.height - bt ? Bt.height - bt : St.y + 10
          };
          return Object.assign(cloneDeep$1(vt), { id: At, name: xt, position: Ot });
        });
        nt(_e[a].concat(ct)), et(ct.map((vt) => document.getElementById(vt.id))), ut.current = ct;
      },
      redo: () => gt("redo"),
      undo: () => gt("undo"),
      save: () => ot && ot(schemasList2template(_e, _.basePdf)),
      remove: () => at(dt().map((pt) => pt.id)),
      esc: it,
      selectAll: () => et(_e[a].map((pt) => document.getElementById(pt.id)))
    });
  }, [
    _,
    $,
    a,
    s,
    tt,
    nt,
    _e,
    ot,
    at,
    rt,
    st,
    lt,
    ut,
    et,
    it
  ]), ht = reactExports.useCallback(() => {
    destroyShortCuts();
  }, []);
  reactExports.useEffect(() => (ft(), ht), [ft, ht]);
}, getWithModifiedSize = (a, s, $, _) => {
  const tt = new DOMParser().parseFromString(a, "text/html"), nt = (at) => {
    (at.tagName === "SVG" || at.tagName === "svg") && (at.setAttribute("width", $.toString()), at.setAttribute("height", $.toString())), Array.from(at.children).forEach((ot) => nt(ot));
  };
  return Array.from(tt.body.children).forEach((at) => nt(at)), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: _, title: s, dangerouslySetInnerHTML: { __html: tt.body.innerHTML } });
}, PluginIcon = (a) => {
  var rt;
  const { plugin: s, label: $, size: _, styles: _e } = a, { token: tt } = theme.useToken(), at = ((rt = reactExports.useContext(OptionsContext).icons) == null ? void 0 : rt[s.propPanel.defaultSchema.type]) ?? s.icon, ot = { ..._e, color: tt.colorText, display: "flex", justifyContent: "center" };
  return at ? _ ? getWithModifiedSize(at, $, _, ot) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: ot, title: $, dangerouslySetInnerHTML: { __html: at } }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { ..._e, overflow: "hidden", fontSize: 10 }, title: $, children: $ });
}, PluginIcon$1 = PluginIcon, SelectableSortableItem = ({
  isSelected: a,
  style: s,
  onSelect: $,
  onEdit: _,
  schema: _e,
  schemas: tt,
  onMouseEnter: nt,
  onMouseLeave: at
}) => {
  const { token: ot } = theme.useToken(), rt = reactExports.useContext(I18nContext), st = reactExports.useContext(PluginsRegistry), { setNodeRef: lt, listeners: et, isDragging: it, isSorting: ut, transform: ft, transition: ht } = useSortable({
    id: _e.id
  }), dt = useMountStatus(), gt = it && !dt, pt = {
    ...et,
    onClick: (Et) => $(_e.id, Et.shiftKey)
  }, [mt, ct] = Object.entries(st).find(
    ([Et, St]) => (St == null ? void 0 : St.propPanel.defaultSchema.type) === _e.type
  ), vt = { width: 20, marginRight: "0.5rem" };
  let At;
  _e.name ? tt.find((Et) => _e.name && Et.name === _e.name && Et.id !== _e.id) && (At = "is-danger") : At = "is-warning";
  let xt = rt("edit");
  At === "is-warning" ? xt = rt("plsInputName") : At === "is-danger" && (xt = rt("fieldMustUniq"));
  const bt = a ? { background: ot.colorPrimary, opacity: ut || it ? 0.5 : 1 } : {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Item$1,
    {
      ref: lt,
      onMouseEnter: nt,
      onMouseLeave: at,
      onClick: () => _(_e.id),
      icon: ct && /* @__PURE__ */ jsxRuntimeExports.jsx(PluginIcon$1, { plugin: ct, label: mt, size: 20, styles: vt }),
      value: _e.name,
      status: At,
      title: xt,
      required: _e.required,
      readOnly: _e.readOnly,
      style: { ...bt, ...s },
      dragging: it,
      sorting: ut,
      transition: ht,
      transform: ft,
      fadeIn: gt,
      listeners: pt
    }
  );
}, SelectableSortableItem$1 = SelectableSortableItem, SelectableSortableContainer = (a) => {
  const { token: s } = theme.useToken(), { schemas: $, onEdit: _, onSortEnd: _e, hoveringSchemaId: tt, onChangeHoveringSchemaId: nt } = a, [at, ot] = reactExports.useState([]), [rt, st] = reactExports.useState(null), [lt, et] = reactExports.useState(null), it = reactExports.useContext(PluginsRegistry), ut = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 15 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  ), ft = (gt) => at.map((pt) => pt.id).includes(gt), ht = (gt, pt) => {
    if (pt)
      if (ft(gt)) {
        const mt = at.filter((ct) => ct.id !== gt);
        ot(mt);
      } else {
        const mt = $.find((vt) => vt.id === gt), ct = at.concat(mt);
        ot(ct);
      }
    else
      ot([]);
  }, dt = (gt) => {
    const pt = typeof gt == "string" ? $.find((vt) => vt.id === gt) : gt, [mt, ct] = Object.entries(it).find(
      ([vt, At]) => (At == null ? void 0 : At.propPanel.defaultSchema.type) === (pt == null ? void 0 : pt.type)
    );
    return ct ? /* @__PURE__ */ jsxRuntimeExports.jsx(PluginIcon$1, { plugin: ct, label: mt, size: 20, styles: { marginRight: "0.5rem" } }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DndContext,
    {
      sensors: ut,
      collisionDetection: closestCorners,
      onDragStart: ({ active: gt }) => {
        et(String(gt.id)), st($), ft(String(gt.id)) ? at.length > 0 && _e(
          at.reduce((pt, mt) => mt.id === String(gt.id) ? pt : pt.filter((ct) => ct !== mt), $)
        ) : ot([]);
      },
      onDragEnd: ({ active: gt, over: pt }) => {
        const mt = (pt == null ? void 0 : pt.id) || "", ct = $.map((At) => At.id).indexOf(String(gt.id)), vt = $.map((At) => At.id).indexOf(String(mt));
        if (at.length) {
          let At = [...$];
          At = arrayMove(At, ct, vt), At.splice(
            vt + 1,
            0,
            ...at.filter((xt) => xt.id !== lt)
          ), _e(At), ot([]);
        } else
          ct !== vt && _e(arrayMove($, ct, vt));
        et(null);
      },
      onDragCancel: () => {
        rt && _e(rt), et(null), st(null);
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { height: "100%", overflowY: "auto" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SortableContext, { items: $, strategy: verticalListSortingStrategy, children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { style: { margin: 0, padding: 0, listStyle: "none", borderRadius: 5 }, children: $.map((gt) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          SelectableSortableItem$1,
          {
            style: {
              border: `1px solid ${gt.id === tt ? s.colorPrimary : "transparent"}`
            },
            schema: gt,
            schemas: $,
            isSelected: ft(gt.id) || lt === gt.id,
            onEdit: _,
            onSelect: ht,
            onMouseEnter: () => nt(gt.id),
            onMouseLeave: () => nt(null)
          },
          gt.id
        )) }) }) }),
        reactDomExports.createPortal(
          /* @__PURE__ */ jsxRuntimeExports.jsx(DragOverlay, { adjustScale: !0, children: lt ? (() => {
            const gt = $.find((pt) => pt.id === lt);
            return gt ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { style: { margin: 0, padding: 0, listStyle: "none" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                Item$1,
                {
                  icon: dt(lt),
                  value: gt.name,
                  required: gt.required,
                  readOnly: gt.readOnly,
                  style: { background: s.colorPrimary },
                  dragOverlay: !0
                }
              ) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { style: { margin: 0, padding: 0, listStyle: "none" }, children: at.filter((pt) => pt.id !== lt).map((pt) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                Item$1,
                {
                  icon: dt(pt),
                  value: pt.name,
                  required: pt.required,
                  readOnly: pt.readOnly,
                  style: { background: s.colorPrimary },
                  dragOverlay: !0
                },
                pt.id
              )) })
            ] }) : null;
          })() : null }),
          document.body
        )
      ] })
    }
  );
}, SelectableSortableContainer$1 = SelectableSortableContainer, { Text: Text$3 } = Typography$1, { TextArea: TextArea$2 } = _Input, headHeight = 40, ListView = (a) => {
  const {
    schemas: s,
    onSortEnd: $,
    onEdit: _,
    size: _e,
    hoveringSchemaId: tt,
    onChangeHoveringSchemaId: nt,
    changeSchemas: at
  } = a, { token: ot } = theme.useToken(), rt = reactExports.useContext(I18nContext), [st, lt] = reactExports.useState(!1), [et, it] = reactExports.useState(""), ut = getSidebarContentHeight(_e.height), ft = () => {
    const dt = et.split(`
`);
    dt.length !== s.length ? alert(rt("errorBulkUpdateFieldName")) : (at(
      dt.map((gt, pt) => ({
        key: "name",
        value: gt,
        schemaId: s[pt].id
      }))
    ), lt(!1));
  }, ht = () => {
    it(s.map((dt) => dt.name).join(`
`)), lt(!0);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { height: headHeight, display: "flex", alignItems: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$3, { strong: !0, style: { textAlign: "center", width: "100%" }, children: rt("fieldsList") }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider$1, { style: { marginTop: ot.marginXS, marginBottom: ot.marginXS } }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { height: ut - headHeight }, children: [
      st ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        TextArea$2,
        {
          wrap: "off",
          value: et,
          onChange: (dt) => it(dt.target.value),
          style: {
            paddingLeft: 30,
            height: ut - headHeight,
            width: RIGHT_SIDEBAR_WIDTH - 35,
            lineHeight: "2.75rem"
          }
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        SelectableSortableContainer$1,
        {
          schemas: s,
          hoveringSchemaId: tt,
          onChangeHoveringSchemaId: nt,
          onSortEnd: $,
          onEdit: _
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { paddingTop: "0.5rem", display: "flex", alignItems: "center", justifyContent: "flex-end" }, children: st ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, { size: "small", type: "text", onClick: ft, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("u", { children: [
          " ",
          rt("commitBulkUpdateFieldName")
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { margin: "0 1rem" }, children: "/" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, { size: "small", type: "text", onClick: () => lt(!1), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("u", { children: [
          " ",
          rt("cancel")
        ] }) })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, { size: "small", type: "text", onClick: ht, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("u", { children: [
        " ",
        rt("bulkUpdateFieldName")
      ] }) }) })
    ] })
  ] });
}, ListView$1 = ListView;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest$3(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
}
function __awaiter(a, s, $, _) {
  function _e(tt) {
    return tt instanceof $ ? tt : new $(function(nt) {
      nt(tt);
    });
  }
  return new ($ || ($ = Promise))(function(tt, nt) {
    function at(st) {
      try {
        rt(_.next(st));
      } catch (lt) {
        nt(lt);
      }
    }
    function ot(st) {
      try {
        rt(_.throw(st));
      } catch (lt) {
        nt(lt);
      }
    }
    function rt(st) {
      st.done ? tt(st.value) : _e(st.value).then(at, ot);
    }
    rt((_ = _.apply(a, s || [])).next());
  });
}
var freeGlobal$2 = typeof global == "object" && global && global.Object === Object && global;
const freeGlobal$3 = freeGlobal$2;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self, root$2 = freeGlobal$3 || freeSelf$1 || Function("return this")();
const root$3 = root$2;
var Symbol$5 = root$3.Symbol;
const Symbol$6 = Symbol$5;
var objectProto$h = Object.prototype, hasOwnProperty$e = objectProto$h.hasOwnProperty, nativeObjectToString$3 = objectProto$h.toString, symToStringTag$3 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function getRawTag$2(a) {
  var s = hasOwnProperty$e.call(a, symToStringTag$3), $ = a[symToStringTag$3];
  try {
    a[symToStringTag$3] = void 0;
    var _ = !0;
  } catch {
  }
  var _e = nativeObjectToString$3.call(a);
  return _ && (s ? a[symToStringTag$3] = $ : delete a[symToStringTag$3]), _e;
}
var objectProto$g = Object.prototype, nativeObjectToString$2 = objectProto$g.toString;
function objectToString$2(a) {
  return nativeObjectToString$2.call(a);
}
var nullTag$1 = "[object Null]", undefinedTag$1 = "[object Undefined]", symToStringTag$2 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function baseGetTag$2(a) {
  return a == null ? a === void 0 ? undefinedTag$1 : nullTag$1 : symToStringTag$2 && symToStringTag$2 in Object(a) ? getRawTag$2(a) : objectToString$2(a);
}
function isObjectLike$2(a) {
  return a != null && typeof a == "object";
}
var symbolTag$4 = "[object Symbol]";
function isSymbol$2(a) {
  return typeof a == "symbol" || isObjectLike$2(a) && baseGetTag$2(a) == symbolTag$4;
}
function arrayMap(a, s) {
  for (var $ = -1, _ = a == null ? 0 : a.length, _e = Array(_); ++$ < _; )
    _e[$] = s(a[$], $, a);
  return _e;
}
var isArray$4 = Array.isArray;
const isArray$5 = isArray$4;
var INFINITY$1 = 1 / 0, symbolProto$2 = Symbol$6 ? Symbol$6.prototype : void 0, symbolToString = symbolProto$2 ? symbolProto$2.toString : void 0;
function baseToString(a) {
  if (typeof a == "string")
    return a;
  if (isArray$5(a))
    return arrayMap(a, baseToString) + "";
  if (isSymbol$2(a))
    return symbolToString ? symbolToString.call(a) : "";
  var s = a + "";
  return s == "0" && 1 / a == -INFINITY$1 ? "-0" : s;
}
function isObject$7(a) {
  var s = typeof a;
  return a != null && (s == "object" || s == "function");
}
function identity$1(a) {
  return a;
}
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$3(a) {
  if (!isObject$7(a))
    return !1;
  var s = baseGetTag$2(a);
  return s == funcTag$2 || s == genTag$1 || s == asyncTag || s == proxyTag;
}
var coreJsData = root$3["__core-js_shared__"];
const coreJsData$1 = coreJsData;
var maskSrcKey = function() {
  var a = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return a ? "Symbol(src)_1." + a : "";
}();
function isMasked(a) {
  return !!maskSrcKey && maskSrcKey in a;
}
var funcProto$1 = Function.prototype, funcToString$1 = funcProto$1.toString;
function toSource(a) {
  if (a != null) {
    try {
      return funcToString$1.call(a);
    } catch {
    }
    try {
      return a + "";
    } catch {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto = Function.prototype, objectProto$f = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$d = objectProto$f.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$d).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(a) {
  if (!isObject$7(a) || isMasked(a))
    return !1;
  var s = isFunction$3(a) ? reIsNative : reIsHostCtor;
  return s.test(toSource(a));
}
function getValue$1(a, s) {
  return a == null ? void 0 : a[s];
}
function getNative(a, s) {
  var $ = getValue$1(a, s);
  return baseIsNative($) ? $ : void 0;
}
var WeakMap$1 = getNative(root$3, "WeakMap");
const WeakMap$2 = WeakMap$1;
var objectCreate = Object.create, baseCreate = /* @__PURE__ */ function() {
  function a() {
  }
  return function(s) {
    if (!isObject$7(s))
      return {};
    if (objectCreate)
      return objectCreate(s);
    a.prototype = s;
    var $ = new a();
    return a.prototype = void 0, $;
  };
}();
const baseCreate$1 = baseCreate;
function copyArray(a, s) {
  var $ = -1, _ = a.length;
  for (s || (s = Array(_)); ++$ < _; )
    s[$] = a[$];
  return s;
}
var defineProperty$4 = function() {
  try {
    var a = getNative(Object, "defineProperty");
    return a({}, "", {}), a;
  } catch {
  }
}();
const defineProperty$5 = defineProperty$4;
function arrayEach(a, s) {
  for (var $ = -1, _ = a == null ? 0 : a.length; ++$ < _ && s(a[$], $, a) !== !1; )
    ;
  return a;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(a, s) {
  var $ = typeof a;
  return s = s ?? MAX_SAFE_INTEGER$1, !!s && ($ == "number" || $ != "symbol" && reIsUint.test(a)) && a > -1 && a % 1 == 0 && a < s;
}
function baseAssignValue(a, s, $) {
  s == "__proto__" && defineProperty$5 ? defineProperty$5(a, s, {
    configurable: !0,
    enumerable: !0,
    value: $,
    writable: !0
  }) : a[s] = $;
}
function eq(a, s) {
  return a === s || a !== a && s !== s;
}
var objectProto$e = Object.prototype, hasOwnProperty$c = objectProto$e.hasOwnProperty;
function assignValue(a, s, $) {
  var _ = a[s];
  (!(hasOwnProperty$c.call(a, s) && eq(_, $)) || $ === void 0 && !(s in a)) && baseAssignValue(a, s, $);
}
function copyObject(a, s, $, _) {
  var _e = !$;
  $ || ($ = {});
  for (var tt = -1, nt = s.length; ++tt < nt; ) {
    var at = s[tt], ot = _ ? _($[at], a[at], at, $, a) : void 0;
    ot === void 0 && (ot = a[at]), _e ? baseAssignValue($, at, ot) : assignValue($, at, ot);
  }
  return $;
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(a) {
  return typeof a == "number" && a > -1 && a % 1 == 0 && a <= MAX_SAFE_INTEGER;
}
function isArrayLike(a) {
  return a != null && isLength(a.length) && !isFunction$3(a);
}
function isIterateeCall(a, s, $) {
  if (!isObject$7($))
    return !1;
  var _ = typeof s;
  return (_ == "number" ? isArrayLike($) && isIndex(s, $.length) : _ == "string" && s in $) ? eq($[s], a) : !1;
}
var objectProto$d = Object.prototype;
function isPrototype(a) {
  var s = a && a.constructor, $ = typeof s == "function" && s.prototype || objectProto$d;
  return a === $;
}
function baseTimes(a, s) {
  for (var $ = -1, _ = Array(a); ++$ < a; )
    _[$] = s($);
  return _;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(a) {
  return isObjectLike$2(a) && baseGetTag$2(a) == argsTag$3;
}
var objectProto$c = Object.prototype, hasOwnProperty$b = objectProto$c.hasOwnProperty, propertyIsEnumerable$1 = objectProto$c.propertyIsEnumerable, isArguments = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(a) {
  return isObjectLike$2(a) && hasOwnProperty$b.call(a, "callee") && !propertyIsEnumerable$1.call(a, "callee");
};
const isArguments$1 = isArguments;
function stubFalse() {
  return !1;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$2 = moduleExports$2 ? root$3.Buffer : void 0, nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : void 0, isBuffer = nativeIsBuffer || stubFalse;
const isBuffer$1 = isBuffer;
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$1 = "[object Function]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", objectTag$3 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", weakMapTag$2 = "[object WeakMap]", arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = !0;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = !1;
function baseIsTypedArray(a) {
  return isObjectLike$2(a) && isLength(a.length) && !!typedArrayTags[baseGetTag$2(a)];
}
function baseUnary(a) {
  return function(s) {
    return a(s);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, freeProcess = moduleExports$1 && freeGlobal$3.process, nodeUtil = function() {
  try {
    var a = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    return a || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch {
  }
}();
const nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray, isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
const isTypedArray$1 = isTypedArray;
var objectProto$b = Object.prototype, hasOwnProperty$a = objectProto$b.hasOwnProperty;
function arrayLikeKeys(a, s) {
  var $ = isArray$5(a), _ = !$ && isArguments$1(a), _e = !$ && !_ && isBuffer$1(a), tt = !$ && !_ && !_e && isTypedArray$1(a), nt = $ || _ || _e || tt, at = nt ? baseTimes(a.length, String) : [], ot = at.length;
  for (var rt in a)
    (s || hasOwnProperty$a.call(a, rt)) && !(nt && // Safari 9 has enumerable `arguments.length` in strict mode.
    (rt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    _e && (rt == "offset" || rt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    tt && (rt == "buffer" || rt == "byteLength" || rt == "byteOffset") || // Skip index properties.
    isIndex(rt, ot))) && at.push(rt);
  return at;
}
function overArg(a, s) {
  return function($) {
    return a(s($));
  };
}
var nativeKeys = overArg(Object.keys, Object);
const nativeKeys$1 = nativeKeys;
var objectProto$a = Object.prototype, hasOwnProperty$9 = objectProto$a.hasOwnProperty;
function baseKeys(a) {
  if (!isPrototype(a))
    return nativeKeys$1(a);
  var s = [];
  for (var $ in Object(a))
    hasOwnProperty$9.call(a, $) && $ != "constructor" && s.push($);
  return s;
}
function keys(a) {
  return isArrayLike(a) ? arrayLikeKeys(a) : baseKeys(a);
}
function nativeKeysIn(a) {
  var s = [];
  if (a != null)
    for (var $ in Object(a))
      s.push($);
  return s;
}
var objectProto$9 = Object.prototype, hasOwnProperty$8 = objectProto$9.hasOwnProperty;
function baseKeysIn(a) {
  if (!isObject$7(a))
    return nativeKeysIn(a);
  var s = isPrototype(a), $ = [];
  for (var _ in a)
    _ == "constructor" && (s || !hasOwnProperty$8.call(a, _)) || $.push(_);
  return $;
}
function keysIn(a) {
  return isArrayLike(a) ? arrayLikeKeys(a, !0) : baseKeysIn(a);
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(a, s) {
  if (isArray$5(a))
    return !1;
  var $ = typeof a;
  return $ == "number" || $ == "symbol" || $ == "boolean" || a == null || isSymbol$2(a) ? !0 : reIsPlainProp.test(a) || !reIsDeepProp.test(a) || s != null && a in Object(s);
}
var nativeCreate = getNative(Object, "create");
const nativeCreate$1 = nativeCreate;
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {}, this.size = 0;
}
function hashDelete(a) {
  var s = this.has(a) && delete this.__data__[a];
  return this.size -= s ? 1 : 0, s;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$8 = Object.prototype, hasOwnProperty$7 = objectProto$8.hasOwnProperty;
function hashGet(a) {
  var s = this.__data__;
  if (nativeCreate$1) {
    var $ = s[a];
    return $ === HASH_UNDEFINED$2 ? void 0 : $;
  }
  return hasOwnProperty$7.call(s, a) ? s[a] : void 0;
}
var objectProto$7 = Object.prototype, hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function hashHas(a) {
  var s = this.__data__;
  return nativeCreate$1 ? s[a] !== void 0 : hasOwnProperty$6.call(s, a);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(a, s) {
  var $ = this.__data__;
  return this.size += this.has(a) ? 0 : 1, $[a] = nativeCreate$1 && s === void 0 ? HASH_UNDEFINED$1 : s, this;
}
function Hash(a) {
  var s = -1, $ = a == null ? 0 : a.length;
  for (this.clear(); ++s < $; ) {
    var _ = a[s];
    this.set(_[0], _[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype.delete = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
function assocIndexOf(a, s) {
  for (var $ = a.length; $--; )
    if (eq(a[$][0], s))
      return $;
  return -1;
}
var arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete(a) {
  var s = this.__data__, $ = assocIndexOf(s, a);
  if ($ < 0)
    return !1;
  var _ = s.length - 1;
  return $ == _ ? s.pop() : splice.call(s, $, 1), --this.size, !0;
}
function listCacheGet(a) {
  var s = this.__data__, $ = assocIndexOf(s, a);
  return $ < 0 ? void 0 : s[$][1];
}
function listCacheHas(a) {
  return assocIndexOf(this.__data__, a) > -1;
}
function listCacheSet(a, s) {
  var $ = this.__data__, _ = assocIndexOf($, a);
  return _ < 0 ? (++this.size, $.push([a, s])) : $[_][1] = s, this;
}
function ListCache(a) {
  var s = -1, $ = a == null ? 0 : a.length;
  for (this.clear(); ++s < $; ) {
    var _ = a[s];
    this.set(_[0], _[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype.delete = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root$3, "Map");
const Map$2 = Map$1;
function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$2 || ListCache)(),
    string: new Hash()
  };
}
function isKeyable(a) {
  var s = typeof a;
  return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? a !== "__proto__" : a === null;
}
function getMapData(a, s) {
  var $ = a.__data__;
  return isKeyable(s) ? $[typeof s == "string" ? "string" : "hash"] : $.map;
}
function mapCacheDelete(a) {
  var s = getMapData(this, a).delete(a);
  return this.size -= s ? 1 : 0, s;
}
function mapCacheGet(a) {
  return getMapData(this, a).get(a);
}
function mapCacheHas(a) {
  return getMapData(this, a).has(a);
}
function mapCacheSet(a, s) {
  var $ = getMapData(this, a), _ = $.size;
  return $.set(a, s), this.size += $.size == _ ? 0 : 1, this;
}
function MapCache(a) {
  var s = -1, $ = a == null ? 0 : a.length;
  for (this.clear(); ++s < $; ) {
    var _ = a[s];
    this.set(_[0], _[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype.delete = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize(a, s) {
  if (typeof a != "function" || s != null && typeof s != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  var $ = function() {
    var _ = arguments, _e = s ? s.apply(this, _) : _[0], tt = $.cache;
    if (tt.has(_e))
      return tt.get(_e);
    var nt = a.apply(this, _);
    return $.cache = tt.set(_e, nt) || tt, nt;
  };
  return $.cache = new (memoize.Cache || MapCache)(), $;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(a) {
  var s = memoize(a, function(_) {
    return $.size === MAX_MEMOIZE_SIZE && $.clear(), _;
  }), $ = s.cache;
  return s;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = memoizeCapped(function(a) {
  var s = [];
  return a.charCodeAt(0) === 46 && s.push(""), a.replace(rePropName, function($, _, _e, tt) {
    s.push(_e ? tt.replace(reEscapeChar, "$1") : _ || $);
  }), s;
});
const stringToPath$1 = stringToPath;
function toString$2(a) {
  return a == null ? "" : baseToString(a);
}
function castPath(a, s) {
  return isArray$5(a) ? a : isKey(a, s) ? [a] : stringToPath$1(toString$2(a));
}
var INFINITY = 1 / 0;
function toKey(a) {
  if (typeof a == "string" || isSymbol$2(a))
    return a;
  var s = a + "";
  return s == "0" && 1 / a == -INFINITY ? "-0" : s;
}
function baseGet(a, s) {
  s = castPath(s, a);
  for (var $ = 0, _ = s.length; a != null && $ < _; )
    a = a[toKey(s[$++])];
  return $ && $ == _ ? a : void 0;
}
function get(a, s, $) {
  var _ = a == null ? void 0 : baseGet(a, s);
  return _ === void 0 ? $ : _;
}
function arrayPush(a, s) {
  for (var $ = -1, _ = s.length, _e = a.length; ++$ < _; )
    a[_e + $] = s[$];
  return a;
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
const getPrototype$1 = getPrototype;
function baseSlice(a, s, $) {
  var _ = -1, _e = a.length;
  s < 0 && (s = -s > _e ? 0 : _e + s), $ = $ > _e ? _e : $, $ < 0 && ($ += _e), _e = s > $ ? 0 : $ - s >>> 0, s >>>= 0;
  for (var tt = Array(_e); ++_ < _e; )
    tt[_] = a[_ + s];
  return tt;
}
function stackClear() {
  this.__data__ = new ListCache(), this.size = 0;
}
function stackDelete(a) {
  var s = this.__data__, $ = s.delete(a);
  return this.size = s.size, $;
}
function stackGet(a) {
  return this.__data__.get(a);
}
function stackHas(a) {
  return this.__data__.has(a);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(a, s) {
  var $ = this.__data__;
  if ($ instanceof ListCache) {
    var _ = $.__data__;
    if (!Map$2 || _.length < LARGE_ARRAY_SIZE - 1)
      return _.push([a, s]), this.size = ++$.size, this;
    $ = this.__data__ = new MapCache(_);
  }
  return $.set(a, s), this.size = $.size, this;
}
function Stack(a) {
  var s = this.__data__ = new ListCache(a);
  this.size = s.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype.delete = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
function baseAssign(a, s) {
  return a && copyObject(s, keys(s), a);
}
function baseAssignIn(a, s) {
  return a && copyObject(s, keysIn(s), a);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, Buffer$1 = moduleExports ? root$3.Buffer : void 0, allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : void 0;
function cloneBuffer(a, s) {
  if (s)
    return a.slice();
  var $ = a.length, _ = allocUnsafe ? allocUnsafe($) : new a.constructor($);
  return a.copy(_), _;
}
function arrayFilter(a, s) {
  for (var $ = -1, _ = a == null ? 0 : a.length, _e = 0, tt = []; ++$ < _; ) {
    var nt = a[$];
    s(nt, $, a) && (tt[_e++] = nt);
  }
  return tt;
}
function stubArray() {
  return [];
}
var objectProto$6 = Object.prototype, propertyIsEnumerable = objectProto$6.propertyIsEnumerable, nativeGetSymbols$1 = Object.getOwnPropertySymbols, getSymbols = nativeGetSymbols$1 ? function(a) {
  return a == null ? [] : (a = Object(a), arrayFilter(nativeGetSymbols$1(a), function(s) {
    return propertyIsEnumerable.call(a, s);
  }));
} : stubArray;
const getSymbols$1 = getSymbols;
function copySymbols(a, s) {
  return copyObject(a, getSymbols$1(a), s);
}
var nativeGetSymbols = Object.getOwnPropertySymbols, getSymbolsIn = nativeGetSymbols ? function(a) {
  for (var s = []; a; )
    arrayPush(s, getSymbols$1(a)), a = getPrototype$1(a);
  return s;
} : stubArray;
const getSymbolsIn$1 = getSymbolsIn;
function copySymbolsIn(a, s) {
  return copyObject(a, getSymbolsIn$1(a), s);
}
function baseGetAllKeys(a, s, $) {
  var _ = s(a);
  return isArray$5(a) ? _ : arrayPush(_, $(a));
}
function getAllKeys(a) {
  return baseGetAllKeys(a, keys, getSymbols$1);
}
function getAllKeysIn(a) {
  return baseGetAllKeys(a, keysIn, getSymbolsIn$1);
}
var DataView$1 = getNative(root$3, "DataView");
const DataView$2 = DataView$1;
var Promise$1 = getNative(root$3, "Promise");
const Promise$2 = Promise$1;
var Set$1 = getNative(root$3, "Set");
const Set$2 = Set$1;
var mapTag$4 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$4 = "[object Set]", weakMapTag$1 = "[object WeakMap]", dataViewTag$3 = "[object DataView]", dataViewCtorString = toSource(DataView$2), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$2), getTag = baseGetTag$2;
(DataView$2 && getTag(new DataView$2(new ArrayBuffer(1))) != dataViewTag$3 || Map$2 && getTag(new Map$2()) != mapTag$4 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$4 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag$1) && (getTag = function(a) {
  var s = baseGetTag$2(a), $ = s == objectTag$2 ? a.constructor : void 0, _ = $ ? toSource($) : "";
  if (_)
    switch (_) {
      case dataViewCtorString:
        return dataViewTag$3;
      case mapCtorString:
        return mapTag$4;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag$4;
      case weakMapCtorString:
        return weakMapTag$1;
    }
  return s;
});
const getTag$1 = getTag;
var objectProto$5 = Object.prototype, hasOwnProperty$5 = objectProto$5.hasOwnProperty;
function initCloneArray(a) {
  var s = a.length, $ = new a.constructor(s);
  return s && typeof a[0] == "string" && hasOwnProperty$5.call(a, "index") && ($.index = a.index, $.input = a.input), $;
}
var Uint8Array$1 = root$3.Uint8Array;
const Uint8Array$2 = Uint8Array$1;
function cloneArrayBuffer(a) {
  var s = new a.constructor(a.byteLength);
  return new Uint8Array$2(s).set(new Uint8Array$2(a)), s;
}
function cloneDataView(a, s) {
  var $ = s ? cloneArrayBuffer(a.buffer) : a.buffer;
  return new a.constructor($, a.byteOffset, a.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(a) {
  var s = new a.constructor(a.source, reFlags.exec(a));
  return s.lastIndex = a.lastIndex, s;
}
var symbolProto$1 = Symbol$6 ? Symbol$6.prototype : void 0, symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function cloneSymbol(a) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(a)) : {};
}
function cloneTypedArray(a, s) {
  var $ = s ? cloneArrayBuffer(a.buffer) : a.buffer;
  return new a.constructor($, a.byteOffset, a.length);
}
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", symbolTag$3 = "[object Symbol]", arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(a, s, $) {
  var _ = a.constructor;
  switch (s) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(a);
    case boolTag$2:
    case dateTag$2:
      return new _(+a);
    case dataViewTag$2:
      return cloneDataView(a, $);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(a, $);
    case mapTag$3:
      return new _();
    case numberTag$2:
    case stringTag$2:
      return new _(a);
    case regexpTag$2:
      return cloneRegExp(a);
    case setTag$3:
      return new _();
    case symbolTag$3:
      return cloneSymbol(a);
  }
}
function initCloneObject(a) {
  return typeof a.constructor == "function" && !isPrototype(a) ? baseCreate$1(getPrototype$1(a)) : {};
}
var mapTag$2 = "[object Map]";
function baseIsMap(a) {
  return isObjectLike$2(a) && getTag$1(a) == mapTag$2;
}
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap, isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
const isMap$1 = isMap;
var setTag$2 = "[object Set]";
function baseIsSet(a) {
  return isObjectLike$2(a) && getTag$1(a) == setTag$2;
}
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet, isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
const isSet$1 = isSet;
var CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$1 = 4, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", objectTag$1 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$1 = "[object Set]", stringTag$1 = "[object String]", symbolTag$2 = "[object Symbol]", weakMapTag = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$1] = cloneableTags[numberTag$1] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$1] = cloneableTags[stringTag$1] = cloneableTags[symbolTag$2] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = !0;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = !1;
function baseClone(a, s, $, _, _e, tt) {
  var nt, at = s & CLONE_DEEP_FLAG$1, ot = s & CLONE_FLAT_FLAG, rt = s & CLONE_SYMBOLS_FLAG$1;
  if ($ && (nt = _e ? $(a, _, _e, tt) : $(a)), nt !== void 0)
    return nt;
  if (!isObject$7(a))
    return a;
  var st = isArray$5(a);
  if (st) {
    if (nt = initCloneArray(a), !at)
      return copyArray(a, nt);
  } else {
    var lt = getTag$1(a), et = lt == funcTag || lt == genTag;
    if (isBuffer$1(a))
      return cloneBuffer(a, at);
    if (lt == objectTag$1 || lt == argsTag$1 || et && !_e) {
      if (nt = ot || et ? {} : initCloneObject(a), !at)
        return ot ? copySymbolsIn(a, baseAssignIn(nt, a)) : copySymbols(a, baseAssign(nt, a));
    } else {
      if (!cloneableTags[lt])
        return _e ? a : {};
      nt = initCloneByTag(a, lt, at);
    }
  }
  tt || (tt = new Stack());
  var it = tt.get(a);
  if (it)
    return it;
  tt.set(a, nt), isSet$1(a) ? a.forEach(function(ht) {
    nt.add(baseClone(ht, s, $, ht, a, tt));
  }) : isMap$1(a) && a.forEach(function(ht, dt) {
    nt.set(dt, baseClone(ht, s, $, dt, a, tt));
  });
  var ut = rt ? ot ? getAllKeysIn : getAllKeys : ot ? keysIn : keys, ft = st ? void 0 : ut(a);
  return arrayEach(ft || a, function(ht, dt) {
    ft && (dt = ht, ht = a[dt]), assignValue(nt, dt, baseClone(ht, s, $, dt, a, tt));
  }), nt;
}
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
function cloneDeep(a) {
  return baseClone(a, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(a) {
  return this.__data__.set(a, HASH_UNDEFINED), this;
}
function setCacheHas(a) {
  return this.__data__.has(a);
}
function SetCache(a) {
  var s = -1, $ = a == null ? 0 : a.length;
  for (this.__data__ = new MapCache(); ++s < $; )
    this.add(a[s]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(a, s) {
  for (var $ = -1, _ = a == null ? 0 : a.length; ++$ < _; )
    if (s(a[$], $, a))
      return !0;
  return !1;
}
function cacheHas(a, s) {
  return a.has(s);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(a, s, $, _, _e, tt) {
  var nt = $ & COMPARE_PARTIAL_FLAG$5, at = a.length, ot = s.length;
  if (at != ot && !(nt && ot > at))
    return !1;
  var rt = tt.get(a), st = tt.get(s);
  if (rt && st)
    return rt == s && st == a;
  var lt = -1, et = !0, it = $ & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (tt.set(a, s), tt.set(s, a); ++lt < at; ) {
    var ut = a[lt], ft = s[lt];
    if (_)
      var ht = nt ? _(ft, ut, lt, s, a, tt) : _(ut, ft, lt, a, s, tt);
    if (ht !== void 0) {
      if (ht)
        continue;
      et = !1;
      break;
    }
    if (it) {
      if (!arraySome(s, function(dt, gt) {
        if (!cacheHas(it, gt) && (ut === dt || _e(ut, dt, $, _, tt)))
          return it.push(gt);
      })) {
        et = !1;
        break;
      }
    } else if (!(ut === ft || _e(ut, ft, $, _, tt))) {
      et = !1;
      break;
    }
  }
  return tt.delete(a), tt.delete(s), et;
}
function mapToArray(a) {
  var s = -1, $ = Array(a.size);
  return a.forEach(function(_, _e) {
    $[++s] = [_e, _];
  }), $;
}
function setToArray(a) {
  var s = -1, $ = Array(a.size);
  return a.forEach(function(_) {
    $[++s] = _;
  }), $;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag$1 = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", symbolProto = Symbol$6 ? Symbol$6.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(a, s, $, _, _e, tt, nt) {
  switch ($) {
    case dataViewTag:
      if (a.byteLength != s.byteLength || a.byteOffset != s.byteOffset)
        return !1;
      a = a.buffer, s = s.buffer;
    case arrayBufferTag:
      return !(a.byteLength != s.byteLength || !tt(new Uint8Array$2(a), new Uint8Array$2(s)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+a, +s);
    case errorTag:
      return a.name == s.name && a.message == s.message;
    case regexpTag:
    case stringTag:
      return a == s + "";
    case mapTag:
      var at = mapToArray;
    case setTag:
      var ot = _ & COMPARE_PARTIAL_FLAG$4;
      if (at || (at = setToArray), a.size != s.size && !ot)
        return !1;
      var rt = nt.get(a);
      if (rt)
        return rt == s;
      _ |= COMPARE_UNORDERED_FLAG$2, nt.set(a, s);
      var st = equalArrays(at(a), at(s), _, _e, tt, nt);
      return nt.delete(a), st;
    case symbolTag$1:
      if (symbolValueOf)
        return symbolValueOf.call(a) == symbolValueOf.call(s);
  }
  return !1;
}
var COMPARE_PARTIAL_FLAG$3 = 1, objectProto$4 = Object.prototype, hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function equalObjects(a, s, $, _, _e, tt) {
  var nt = $ & COMPARE_PARTIAL_FLAG$3, at = getAllKeys(a), ot = at.length, rt = getAllKeys(s), st = rt.length;
  if (ot != st && !nt)
    return !1;
  for (var lt = ot; lt--; ) {
    var et = at[lt];
    if (!(nt ? et in s : hasOwnProperty$4.call(s, et)))
      return !1;
  }
  var it = tt.get(a), ut = tt.get(s);
  if (it && ut)
    return it == s && ut == a;
  var ft = !0;
  tt.set(a, s), tt.set(s, a);
  for (var ht = nt; ++lt < ot; ) {
    et = at[lt];
    var dt = a[et], gt = s[et];
    if (_)
      var pt = nt ? _(gt, dt, et, s, a, tt) : _(dt, gt, et, a, s, tt);
    if (!(pt === void 0 ? dt === gt || _e(dt, gt, $, _, tt) : pt)) {
      ft = !1;
      break;
    }
    ht || (ht = et == "constructor");
  }
  if (ft && !ht) {
    var mt = a.constructor, ct = s.constructor;
    mt != ct && "constructor" in a && "constructor" in s && !(typeof mt == "function" && mt instanceof mt && typeof ct == "function" && ct instanceof ct) && (ft = !1);
  }
  return tt.delete(a), tt.delete(s), ft;
}
var COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto$3 = Object.prototype, hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function baseIsEqualDeep(a, s, $, _, _e, tt) {
  var nt = isArray$5(a), at = isArray$5(s), ot = nt ? arrayTag : getTag$1(a), rt = at ? arrayTag : getTag$1(s);
  ot = ot == argsTag ? objectTag : ot, rt = rt == argsTag ? objectTag : rt;
  var st = ot == objectTag, lt = rt == objectTag, et = ot == rt;
  if (et && isBuffer$1(a)) {
    if (!isBuffer$1(s))
      return !1;
    nt = !0, st = !1;
  }
  if (et && !st)
    return tt || (tt = new Stack()), nt || isTypedArray$1(a) ? equalArrays(a, s, $, _, _e, tt) : equalByTag(a, s, ot, $, _, _e, tt);
  if (!($ & COMPARE_PARTIAL_FLAG$2)) {
    var it = st && hasOwnProperty$3.call(a, "__wrapped__"), ut = lt && hasOwnProperty$3.call(s, "__wrapped__");
    if (it || ut) {
      var ft = it ? a.value() : a, ht = ut ? s.value() : s;
      return tt || (tt = new Stack()), _e(ft, ht, $, _, tt);
    }
  }
  return et ? (tt || (tt = new Stack()), equalObjects(a, s, $, _, _e, tt)) : !1;
}
function baseIsEqual(a, s, $, _, _e) {
  return a === s ? !0 : a == null || s == null || !isObjectLike$2(a) && !isObjectLike$2(s) ? a !== a && s !== s : baseIsEqualDeep(a, s, $, _, baseIsEqual, _e);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(a, s, $, _) {
  var _e = $.length, tt = _e, nt = !_;
  if (a == null)
    return !tt;
  for (a = Object(a); _e--; ) {
    var at = $[_e];
    if (nt && at[2] ? at[1] !== a[at[0]] : !(at[0] in a))
      return !1;
  }
  for (; ++_e < tt; ) {
    at = $[_e];
    var ot = at[0], rt = a[ot], st = at[1];
    if (nt && at[2]) {
      if (rt === void 0 && !(ot in a))
        return !1;
    } else {
      var lt = new Stack();
      if (_)
        var et = _(rt, st, ot, a, s, lt);
      if (!(et === void 0 ? baseIsEqual(st, rt, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, _, lt) : et))
        return !1;
    }
  }
  return !0;
}
function isStrictComparable(a) {
  return a === a && !isObject$7(a);
}
function getMatchData(a) {
  for (var s = keys(a), $ = s.length; $--; ) {
    var _ = s[$], _e = a[_];
    s[$] = [_, _e, isStrictComparable(_e)];
  }
  return s;
}
function matchesStrictComparable(a, s) {
  return function($) {
    return $ == null ? !1 : $[a] === s && (s !== void 0 || a in Object($));
  };
}
function baseMatches(a) {
  var s = getMatchData(a);
  return s.length == 1 && s[0][2] ? matchesStrictComparable(s[0][0], s[0][1]) : function($) {
    return $ === a || baseIsMatch($, a, s);
  };
}
function baseHasIn(a, s) {
  return a != null && s in Object(a);
}
function hasPath(a, s, $) {
  s = castPath(s, a);
  for (var _ = -1, _e = s.length, tt = !1; ++_ < _e; ) {
    var nt = toKey(s[_]);
    if (!(tt = a != null && $(a, nt)))
      break;
    a = a[nt];
  }
  return tt || ++_ != _e ? tt : (_e = a == null ? 0 : a.length, !!_e && isLength(_e) && isIndex(nt, _e) && (isArray$5(a) || isArguments$1(a)));
}
function hasIn(a, s) {
  return a != null && hasPath(a, s, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(a, s) {
  return isKey(a) && isStrictComparable(s) ? matchesStrictComparable(toKey(a), s) : function($) {
    var _ = get($, a);
    return _ === void 0 && _ === s ? hasIn($, a) : baseIsEqual(s, _, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(a) {
  return function(s) {
    return s == null ? void 0 : s[a];
  };
}
function basePropertyDeep(a) {
  return function(s) {
    return baseGet(s, a);
  };
}
function property(a) {
  return isKey(a) ? baseProperty(toKey(a)) : basePropertyDeep(a);
}
function baseIteratee(a) {
  return typeof a == "function" ? a : a == null ? identity$1 : typeof a == "object" ? isArray$5(a) ? baseMatchesProperty(a[0], a[1]) : baseMatches(a) : property(a);
}
function createBaseFor(a) {
  return function(s, $, _) {
    for (var _e = -1, tt = Object(s), nt = _(s), at = nt.length; at--; ) {
      var ot = nt[a ? at : ++_e];
      if ($(tt[ot], ot, tt) === !1)
        break;
    }
    return s;
  };
}
var baseFor = createBaseFor();
const baseFor$1 = baseFor;
function baseForOwn(a, s) {
  return a && baseFor$1(a, s, keys);
}
function createBaseEach(a, s) {
  return function($, _) {
    if ($ == null)
      return $;
    if (!isArrayLike($))
      return a($, _);
    for (var _e = $.length, tt = s ? _e : -1, nt = Object($); (s ? tt-- : ++tt < _e) && _(nt[tt], tt, nt) !== !1; )
      ;
    return $;
  };
}
var baseEach = createBaseEach(baseForOwn);
const baseEach$1 = baseEach;
function last(a) {
  var s = a == null ? 0 : a.length;
  return s ? a[s - 1] : void 0;
}
var objectProto$2 = Object.prototype, hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseHas(a, s) {
  return a != null && hasOwnProperty$2.call(a, s);
}
function has$5(a, s) {
  return a != null && hasPath(a, s, baseHas);
}
function parent(a, s) {
  return s.length < 2 ? a : baseGet(a, baseSlice(s, 0, -1));
}
function isMatch(a, s) {
  return a === s || baseIsMatch(a, s, getMatchData(s));
}
function isUndefined$1(a) {
  return a === void 0;
}
var FUNC_ERROR_TEXT = "Expected a function";
function negate(a) {
  if (typeof a != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return function() {
    var s = arguments;
    switch (s.length) {
      case 0:
        return !a.call(this);
      case 1:
        return !a.call(this, s[0]);
      case 2:
        return !a.call(this, s[0], s[1]);
      case 3:
        return !a.call(this, s[0], s[1], s[2]);
    }
    return !a.apply(this, s);
  };
}
function baseUnset(a, s) {
  return s = castPath(s, a), a = parent(a, s), a == null || delete a[toKey(last(s))];
}
function baseSet(a, s, $, _) {
  if (!isObject$7(a))
    return a;
  s = castPath(s, a);
  for (var _e = -1, tt = s.length, nt = tt - 1, at = a; at != null && ++_e < tt; ) {
    var ot = toKey(s[_e]), rt = $;
    if (ot === "__proto__" || ot === "constructor" || ot === "prototype")
      return a;
    if (_e != nt) {
      var st = at[ot];
      rt = _ ? _(st, ot, at) : void 0, rt === void 0 && (rt = isObject$7(st) ? st : isIndex(s[_e + 1]) ? [] : {});
    }
    assignValue(at, ot, rt), at = at[ot];
  }
  return a;
}
function basePickBy(a, s, $) {
  for (var _ = -1, _e = s.length, tt = {}; ++_ < _e; ) {
    var nt = s[_], at = baseGet(a, nt);
    $(at, nt) && baseSet(tt, castPath(nt, a), at);
  }
  return tt;
}
function pickBy(a, s) {
  if (a == null)
    return {};
  var $ = arrayMap(getAllKeysIn(a), function(_) {
    return [_];
  });
  return s = baseIteratee(s), basePickBy(a, $, function(_, _e) {
    return s(_, _e[0]);
  });
}
function omitBy(a, s) {
  return pickBy(a, negate(baseIteratee(s)));
}
function set(a, s, $) {
  return a == null ? a : baseSet(a, s, $);
}
function baseSome(a, s) {
  var $;
  return baseEach$1(a, function(_, _e, tt) {
    return $ = s(_, _e, tt), !$;
  }), !!$;
}
function some$1(a, s, $) {
  var _ = isArray$5(a) ? arraySome : baseSome;
  return $ && isIterateeCall(a, s, $) && (s = void 0), _(a, baseIteratee(s));
}
function unset$1(a, s) {
  return a == null ? !0 : baseUnset(a, s);
}
var define_import_meta_env_default$1 = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const createStoreImpl = (a) => {
  let s;
  const $ = /* @__PURE__ */ new Set(), _ = (ot, rt) => {
    const st = typeof ot == "function" ? ot(s) : ot;
    if (!Object.is(st, s)) {
      const lt = s;
      s = rt ?? (typeof st != "object" || st === null) ? st : Object.assign({}, s, st), $.forEach((et) => et(s, lt));
    }
  }, _e = () => s, at = { setState: _, getState: _e, subscribe: (ot) => ($.add(ot), () => $.delete(ot)), destroy: () => {
    (define_import_meta_env_default$1 ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), $.clear();
  } };
  return s = a(_, _e, at), at;
}, createStore$1 = (a) => a ? createStoreImpl(a) : createStoreImpl;
var withSelector = { exports: {} }, withSelector_production_min = {}, shim = { exports: {} }, useSyncExternalStoreShim_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e = reactExports;
function h$2(a, s) {
  return a === s && (a !== 0 || 1 / a === 1 / s) || a !== a && s !== s;
}
var k$1 = typeof Object.is == "function" ? Object.is : h$2, l = e.useState, m = e.useEffect, n$1 = e.useLayoutEffect, p$1 = e.useDebugValue;
function q$1(a, s) {
  var $ = s(), _ = l({ inst: { value: $, getSnapshot: s } }), _e = _[0].inst, tt = _[1];
  return n$1(function() {
    _e.value = $, _e.getSnapshot = s, r$1(_e) && tt({ inst: _e });
  }, [a, $, s]), m(function() {
    return r$1(_e) && tt({ inst: _e }), a(function() {
      r$1(_e) && tt({ inst: _e });
    });
  }, [a]), p$1($), $;
}
function r$1(a) {
  var s = a.getSnapshot;
  a = a.value;
  try {
    var $ = s();
    return !k$1(a, $);
  } catch {
    return !0;
  }
}
function t$1(a, s) {
  return s();
}
var u$1 = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? t$1 : q$1;
useSyncExternalStoreShim_production_min.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u$1;
shim.exports = useSyncExternalStoreShim_production_min;
var shimExports = shim.exports;
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h$1 = reactExports, n = shimExports;
function p(a, s) {
  return a === s && (a !== 0 || 1 / a === 1 / s) || a !== a && s !== s;
}
var q = typeof Object.is == "function" ? Object.is : p, r = n.useSyncExternalStore, t = h$1.useRef, u = h$1.useEffect, v = h$1.useMemo, w = h$1.useDebugValue;
withSelector_production_min.useSyncExternalStoreWithSelector = function(a, s, $, _, _e) {
  var tt = t(null);
  if (tt.current === null) {
    var nt = { hasValue: !1, value: null };
    tt.current = nt;
  } else
    nt = tt.current;
  tt = v(function() {
    function ot(it) {
      if (!rt) {
        if (rt = !0, st = it, it = _(it), _e !== void 0 && nt.hasValue) {
          var ut = nt.value;
          if (_e(ut, it))
            return lt = ut;
        }
        return lt = it;
      }
      if (ut = lt, q(st, it))
        return ut;
      var ft = _(it);
      return _e !== void 0 && _e(ut, ft) ? ut : (st = it, lt = ft);
    }
    var rt = !1, st, lt, et = $ === void 0 ? null : $;
    return [function() {
      return ot(s());
    }, et === null ? void 0 : function() {
      return ot(et());
    }];
  }, [s, $, _, _e]);
  var at = r(a, tt[0], tt[1]);
  return u(function() {
    nt.hasValue = !0, nt.value = at;
  }, [at]), w(at), at;
};
withSelector.exports = withSelector_production_min;
var withSelectorExports = withSelector.exports;
const useSyncExternalStoreExports = /* @__PURE__ */ getDefaultExportFromCjs(withSelectorExports);
var define_import_meta_env_default = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const { useDebugValue } = React$a, { useSyncExternalStoreWithSelector } = useSyncExternalStoreExports;
let didWarnAboutEqualityFn = !1;
function useStore(a, s = a.getState, $) {
  (define_import_meta_env_default ? "production" : void 0) !== "production" && $ && !didWarnAboutEqualityFn && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), didWarnAboutEqualityFn = !0);
  const _ = useSyncExternalStoreWithSelector(
    a.subscribe,
    a.getState,
    a.getServerState || a.getState,
    s,
    $
  );
  return useDebugValue(_), _;
}
var FRContext = /* @__PURE__ */ reactExports.createContext(null), ConfigContext = /* @__PURE__ */ reactExports.createContext(null), displayTypeEnum = {
  column: "vertical",
  row: "horizontal",
  inline: "inline"
}, transformProps = function a(s) {
  var $ = s.schema, _ = s.beforeFinish, _e = s.onMount, tt = s.displayType, nt = tt === void 0 ? "column" : tt, at = s.watch, ot = s.removeHiddenData, rt = ot === void 0 ? !0 : ot, st = s.readOnly, lt = s.column, et = lt === void 0 ? 1 : lt, it = s.mapping, ut = s.debugCss, ft = s.locale, ht = s.configProvider, dt = s.validateMessages, gt = s.debug, pt = s.id, mt = s.labelWidth, ct = s.maxWidth, vt = s.form, At = s.onFinish, xt = s.onFinishFailed, bt = s.footer, Et = s.operateExtra, St = s.logOnMount, Bt = s.logOnSubmit, Ot = s.labelCol, Pt = s.fieldCol, wt = s.disabled, Ct = s.className, It = s.validateTrigger, yt = s.antdVersion, Rt = __rest$3(s, ["schema", "beforeFinish", "onMount", "displayType", "watch", "removeHiddenData", "readOnly", "column", "mapping", "debugCss", "locale", "configProvider", "validateMessages", "debug", "id", "labelWidth", "maxWidth", "form", "onFinish", "onFinishFailed", "footer", "operateExtra", "logOnMount", "logOnSubmit", "labelCol", "fieldCol", "disabled", "className", "validateTrigger", "antdVersion"]), kt = Object.assign({}, Rt);
  return nt && (kt.layout = displayTypeEnum[nt] || "horizontal"), {
    formProps: kt,
    schema: $,
    displayType: nt,
    onFinish: At,
    beforeFinish: _,
    onMount: _e,
    watch: at,
    readOnly: st,
    disabled: wt,
    column: et,
    mapping: it,
    debugCss: ut,
    locale: ft,
    configProvider: ht,
    footer: bt,
    form: vt,
    labelWidth: mt,
    validateMessages: dt,
    debug: gt,
    id: pt,
    onFinishFailed: xt,
    removeHiddenData: rt,
    operateExtra: Et,
    logOnMount: St,
    logOnSubmit: Bt,
    labelCol: Ot,
    fieldCol: Pt,
    maxWidth: ct,
    className: Ct,
    validateTrigger: It,
    antdVersion: yt
  };
}, _set = set, _get = get, _cloneDeep = cloneDeep, _has$1 = has$5, _some = some$1, _isMatch = isMatch, isObject$6 = function a(s) {
  var $ = Object.prototype.toString.call(s);
  return $.indexOf("Object") > -1;
}, isArray$3 = function a(s) {
  var $ = Object.prototype.toString.call(s);
  return $.indexOf("Array") > -1;
}, isFunction$2 = function a(s) {
  return typeof s == "function";
};
function isUrl$1(a) {
  var s = /^(?:\w+:)?\/\/(\S+)$/;
  return typeof a != "string" ? !1 : s.test(a);
}
var isNumber = function a(s) {
  return !isNaN(Number(s));
}, getArray = function a(s) {
  var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return Array.isArray(s) ? s : $;
};
function isObjType(a) {
  return (a == null ? void 0 : a.type) === "object" && (a == null ? void 0 : a.properties) && (a == null ? void 0 : a.widgetType) !== "field";
}
function isListType(a) {
  return (a == null ? void 0 : a.type) === "array" && isObjType(a == null ? void 0 : a.items) && (a == null ? void 0 : a.enum) === void 0;
}
function isCheckBoxType(a, s) {
  if (s)
    return !1;
  if (a.widget === "checkbox")
    return !0;
  if (a && a.type === "boolean")
    return a.enum ? !1 : a.widget === void 0;
}
var translation$1 = function a(s) {
  return function($) {
    var _ = s == null ? void 0 : s.locale.FormRender;
    return _[$];
  };
}, hasFuncProperty = function a(s) {
  return _some(s, function($) {
    return isFunction$2($) ? !0 : isObject$6($) ? a($) : !1;
  });
};
function _typeof$p(a) {
  "@babel/helpers - typeof";
  return _typeof$p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$p(a);
}
function _defineProperty$b(a, s, $) {
  return s = _toPropertyKey$7(s), s in a ? Object.defineProperty(a, s, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = $, a;
}
function _toPropertyKey$7(a) {
  var s = _toPrimitive$8(a, "string");
  return _typeof$p(s) === "symbol" ? s : String(s);
}
function _toPrimitive$8(a, s) {
  if (_typeof$p(a) !== "object" || a === null)
    return a;
  var $ = a[Symbol.toPrimitive];
  if ($ !== void 0) {
    var _ = $.call(a, s || "default");
    if (_typeof$p(_) !== "object")
      return _;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _toConsumableArray$c(a) {
  return _arrayWithoutHoles$c(a) || _iterableToArray$c(a) || _unsupportedIterableToArray$k(a) || _nonIterableSpread$c();
}
function _nonIterableSpread$c() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _arrayWithoutHoles$c(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$k(a);
}
function _toArray(a) {
  return _arrayWithHoles$e(a) || _iterableToArray$c(a) || _unsupportedIterableToArray$k(a) || _nonIterableRest$e();
}
function _nonIterableRest$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$k(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$k(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$k(a, s);
  }
}
function _arrayLikeToArray$k(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArray$c(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithHoles$e(a) {
  if (Array.isArray(a))
    return a;
}
var isMultiBind = function a(s) {
  return isArray$3(s) && s.every(function($) {
    return typeof $ == "string";
  });
}, transformPath = function a(s) {
  var $ = [], _ = function _e(tt) {
    var nt = tt.indexOf("[]");
    if (nt === -1) {
      $.push(tt);
      return;
    }
    $.push(tt.substring(0, nt)), _e(tt.substring(nt + 3));
  };
  return _(s), $.length === 1 ? $[0] : $;
}, transformValueToBind = function a(s, $, _) {
  if (_ === !1) {
    unset$1(s, $);
    return;
  }
  if (typeof _ == "string") {
    var _e = get(s, $), tt = get(s, _);
    isObject$6(tt) && (_e = Object.assign(Object.assign({}, tt), _e)), set(s, _, _e), unset$1(s, $);
    return;
  }
  if (isMultiBind(_)) {
    var nt = get(s, $);
    unset$1(s, $), Array.isArray(nt) && nt.forEach(function(at, ot) {
      var rt = _[ot];
      rt && set(s, rt, at);
    });
  }
}, transformBindToValue = function a(s, $, _) {
  if (typeof _ == "string") {
    var _e = get(s, _), tt = get(s, $);
    isObject$6(tt) && (_e = Object.assign(Object.assign({}, tt), _e)), set(s, $, _e), unset$1(s, _);
    return;
  }
  if (isMultiBind(_)) {
    var nt = [];
    _.forEach(function(at) {
      var ot = get(s, at);
      nt.push(ot), unset$1(s, at);
    }), nt.length > 0 && set(s, $, nt);
  }
}, parseValuesToBind = function a(s, $) {
  if (!JSON.stringify($).includes("bind"))
    return s;
  var _ = _cloneDeep(s), _e = function tt(nt, at, ot) {
    var rt = _toArray(at), st = rt[0], lt = rt.slice(1);
    if (lt.length === 1) {
      var et = get(nt, st, []);
      et.forEach(function(ut, ft) {
        var ht = get(ut, lt[0]);
        if (ot === "root") {
          et[ft] = ht;
          return;
        }
        transformValueToBind(ut, lt[0], ot);
      });
    }
    if (isArray$3(nt))
      nt.forEach(function(ut) {
        return tt(ut, [st].concat(_toConsumableArray$c(lt)), ot);
      });
    else if (isObject$6(nt)) {
      var it = get(nt, st);
      tt(it, lt, ot);
    }
  };
  return Object.keys($).forEach(function(tt) {
    var nt, at, ot = (at = (nt = $[tt]) === null || nt === void 0 ? void 0 : nt.schema) === null || at === void 0 ? void 0 : at.bind;
    if (ot !== void 0) {
      var rt = transformPath(tt);
      isArray$3(rt) ? _e(_, rt, ot) : transformValueToBind(_, rt, ot);
    }
  }), _;
}, parseBindToValues = function a(s, $) {
  if (!JSON.stringify($).includes("bind"))
    return s;
  var _ = _cloneDeep(s), _e = function tt(nt, at, ot) {
    var rt = _toArray(at), st = rt[0], lt = rt.slice(1);
    if (lt.length === 1) {
      var et = get(nt, st, []);
      et.forEach(function(ut, ft) {
        if (ot === "root") {
          et[ft] = _defineProperty$b({}, lt[0], ut);
          return;
        }
        transformBindToValue(ut, lt[0], ot);
      });
    }
    if (isArray$3(nt))
      nt.forEach(function(ut) {
        return tt(ut, [st].concat(_toConsumableArray$c(lt)), ot);
      });
    else if (isObject$6(nt)) {
      var it = get(nt, st);
      tt(it, lt, ot);
    }
  };
  return Object.keys($).forEach(function(tt) {
    var nt, at, ot = (at = (nt = $[tt]) === null || nt === void 0 ? void 0 : nt.schema) === null || at === void 0 ? void 0 : at.bind;
    if (ot !== void 0) {
      var rt = transformPath(tt);
      isArray$3(rt) ? _e(_, rt, ot) : transformBindToValue(_, rt, ot);
    }
  }), _;
}, transformHidden = function a(s) {
  var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof s != "string")
    return !!s;
  var _e = s.replace(/^{\s*{/g, "").replace(/}\s*}$/g, "").trim(), tt = `
    return `.concat(_e.replace(/formData/g, JSON.stringify($)).replace(/rootValue/g, JSON.stringify(_)), `
  `);
  try {
    var nt = Function(tt)();
    return nt;
  } catch {
    return !1;
  }
};
const filterValuesHidden = function(a, s) {
  var $ = function(tt, nt) {
    return tt.map(function(at) {
      return isObject$6(at) ? _(at, nt, at) : at;
    });
  }, _ = function _e(tt, nt, at) {
    for (var ot, rt, st = 0, lt = Object.keys(tt); st < lt.length; st++) {
      var et = lt[st], it = tt[et], ut = nt ? "".concat(nt, ".").concat(et) : et, ft = (ot = s[ut]) === null || ot === void 0 ? void 0 : ot.schema;
      if (isArray$3(it) && !ft && (ut = nt ? "".concat(nt, ".").concat(et, "[]") : "".concat(et, "[]"), ft = (rt = s[ut]) === null || rt === void 0 ? void 0 : rt.schema), ft != null && ft.hidden) {
        var ht = transformHidden(ft.hidden, a, at);
        if (ht) {
          tt[et] = void 0;
          continue;
        }
      }
      if (isObject$6(it)) {
        tt[et] = _e(it, ut, at);
        continue;
      }
      if (isArray$3(it) && (ft != null && ft.items)) {
        tt[et] = $(it, ut) || [];
        continue;
      }
      tt[et] = it;
    }
    return tt;
  };
  return _(a) || {};
}, filterValuesUndefined = function(a, s) {
  var $ = function _e(tt) {
    var nt = tt.map(function(at) {
      return isObject$6(at) ? _(at, !1) : isArray$3(at) ? _e(at) : at;
    });
    if (Object.keys(nt).length !== 0)
      return nt;
  }, _ = function _e(tt) {
    var nt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    if (tt._isAMomentObject)
      return tt;
    var at = omitBy(tt, isUndefined$1);
    if (Object.keys(at).forEach(function(ot) {
      var rt = at[ot];
      if (isObject$6(rt) && (at[ot] = _e(rt)), isArray$3(rt)) {
        var st = $(rt);
        at[ot] = st, !s && st && (at[ot] = st.filter(function(lt) {
          return lt !== void 0;
        }));
      }
    }), at = omitBy(at, isUndefined$1), !(Object.keys(at).length === 0 && nt))
      return at;
  };
  return _(a) || {};
};
var getFormItemLayout = function a(s, $, _) {
  var _e = _.labelWidth, tt = _.displayType, nt = _._labelCol, at = _._fieldCol, ot = {
    span: 5
  }, rt = {
    span: 9
  };
  return s === 2 && (ot = {
    span: 6
  }, rt = {
    span: 14
  }), s > 2 && (ot = {
    span: 7
  }, rt = {
    span: 16
  }), tt === "column" && (ot = {}, rt = {}), nt && (ot = nt, tt === "column" && (ot = {})), at && (rt = at, typeof at == "number" && (rt = {
    span: at
  })), tt === "inline" && (ot = {}, rt = {}), (_e || _e === 0) && tt !== "column" && (ot = {
    flex: _e + "px"
  }, rt = {
    flex: "auto"
  }), $.cellSpan && (rt = {}), ($.labelCol || $.labelCol === 0) && (ot = $.labelCol), ($.fieldCol || $.fieldCol === 0) && (rt = $.fieldCol), typeof ot == "number" && (ot = {
    span: ot
  }), typeof rt == "number" && (rt = {
    span: rt
  }), {
    labelCol: ot,
    fieldCol: rt
  };
};
function _toConsumableArray$b(a) {
  return _arrayWithoutHoles$b(a) || _iterableToArray$b(a) || _unsupportedIterableToArray$j(a) || _nonIterableSpread$b();
}
function _nonIterableSpread$b() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$j(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$j(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$j(a, s);
  }
}
function _iterableToArray$b(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$b(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$j(a);
}
function _arrayLikeToArray$j(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
var executeCallBack = function a(s, $, _, _e) {
  if (isFunction$2(s))
    try {
      s($, _e);
    } catch (tt) {
      console.log("".concat(_, "对应的watch函数执行报错："), tt);
    }
  if (isFunction$2(s == null ? void 0 : s.handler))
    try {
      s.handler($, _e);
    } catch (tt) {
      console.log("".concat(_, "对应的watch函数执行报错："), tt);
    }
}, traverseValues = function a(s) {
  var $ = s.changedValues, _ = s.allValues, _e = s.flatValues, tt = function at(ot, rt, st, lt) {
    if (ot.length) {
      var et = st += "[]", it = ot.filter(function(ht) {
        return ht || ht === void 0;
      }).length, ut = it !== rt.length || ot.length === 1, ft = !1;
      it > 1 && it < rt.length && (ut = !1, ft = !0), ot.forEach(function(ht, dt) {
        ft || (_e[et] = {
          value: rt[dt],
          index: lt
        }), isObject$6(ht) && nt(ht, rt[dt], et, [].concat(_toConsumableArray$b(lt), [dt]), !ut), isArray$3(ht) && at(ht, rt[dt], et, [].concat(_toConsumableArray$b(lt), [dt]));
      });
    }
  }, nt = function at(ot, rt, st, lt, et) {
    Object.keys(ot).forEach(function(it) {
      var ut = ot[it], ft = rt == null ? void 0 : rt[it], ht = ut, dt = st ? st + "." + it : it, gt = !0;
      isArray$3(ut) && (ht = ft && _toConsumableArray$b(ft), gt = !1, tt(ut, ft, dt, lt)), isObject$6(ut) && (gt = !1, at(ut, ft, dt, lt, et)), (!gt || !et) && (_e[dt] = {
        value: ht,
        index: lt
      });
    });
  };
  nt($, _, null, []);
}, valuesWatch = function a(s, $, _) {
  var _e;
  if (((_e = Object.keys(_ || {})) === null || _e === void 0 ? void 0 : _e.length) !== 0) {
    var tt = {
      "#": {
        value: $,
        index: s
      }
    };
    traverseValues({
      changedValues: s,
      allValues: $,
      flatValues: tt
    }), Object.keys(_).forEach(function(nt) {
      if (_has$1(tt, nt)) {
        var at = _get(tt, nt), ot = at.value, rt = at.index, st = _[nt];
        executeCallBack(st, ot, nt, rt);
      }
    });
  }
}, transformFieldsData = function a(s, $) {
  var _ = s;
  if (isObject$6(_) && (_ = [_]), !!(isArray$3(_) && _.length > 0))
    return _.map(function(_e) {
      return Object.assign(Object.assign({
        errors: _e.error
      }, _e), {
        name: $(_e.name)
      });
    });
}, immediateWatch = function a(s, $) {
  var _;
  if (((_ = Object.keys(s || {})) === null || _ === void 0 ? void 0 : _.length) !== 0) {
    var _e = {};
    Object.keys(s).forEach(function(tt) {
      var nt = s[tt];
      nt != null && nt.immediate && isFunction$2(nt == null ? void 0 : nt.handler) && (_e[tt] = nt);
    }), valuesWatch($, $, _e);
  }
}, getSchemaFullPath = function a(s, $) {
  if (!s || !s.includes("."))
    return "properties." + s;
  for (; s.includes("[]"); ) {
    var _ = s.indexOf("[]");
    s = s.substring(0, _) + ".items" + s.substring(_ + 2);
  }
  var _e = "properties";
  return s.split(".").forEach(function(tt) {
    var nt = _e + "." + tt, at = _get($, nt, {});
    if (isObjType(at)) {
      _e = nt + ".properties";
      return;
    }
    _e = nt;
  }), _e;
};
function yymmdd(a) {
  var s = new Date(Number(a)), $ = function(st) {
    return ("0" + st).slice(-2);
  }, _ = $(s.getDate()), _e = $(s.getMonth()), tt = s.getFullYear(), nt = $(s.getHours()), at = $(s.getMinutes()), ot = $(s.getSeconds());
  return "".concat(tt, "-").concat(_e, "-").concat(_, " ").concat(nt, ":").concat(at, ":").concat(ot);
}
function msToTime(a) {
  var s = Math.floor(a / 1e3 % 60), $ = Math.floor(a / (1e3 * 60) % 60), _ = Math.floor(a / (1e3 * 60 * 60) % 24);
  return _ = _ < 10 ? "0" + _ : _, $ = $ < 10 ? "0" + $ : $, s = s < 10 ? "0" + s : s, _ + ":" + $ + ":" + s;
}
var getSessionItem = function a(s) {
  return Number(sessionStorage.getItem(s) || 0);
}, setSessionItem = function a(s, $) {
  sessionStorage.setItem(s, $ + "");
};
function _toConsumableArray$a(a) {
  return _arrayWithoutHoles$a(a) || _iterableToArray$a(a) || _unsupportedIterableToArray$i(a) || _nonIterableSpread$a();
}
function _nonIterableSpread$a() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$i(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$i(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$i(a, s);
  }
}
function _iterableToArray$a(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$a(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$i(a);
}
function _arrayLikeToArray$i(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
var filterHiddenData = function a(s) {
  if (!isArray$3(s))
    return s;
  for (var $ = [], _ = 0; _ < s.length; _++) {
    var _e = s[_];
    if (!_e.hidden) {
      var tt = Object.assign({}, _e);
      if (_e.children) {
        var nt = a(_e.children);
        nt.length > 0 && (tt.children = nt);
      }
      if (_e.items) {
        var at = a(_e.items);
        at.length > 0 && (tt.items = at);
      }
      $.push(tt);
    }
  }
  return $;
}, getPathObj = function a(s) {
  var $ = s.rootPath, _ = $ === void 0 ? [] : $, _e = s.path, tt = (_e || "").split("."), nt = [], at = [], ot = [];
  _.forEach(function(it, ut) {
    if (isNumber(it)) {
      nt.push(it);
      return;
    }
    isNumber(_[ut + 1]) ? at.push("".concat(it, "[]")) : at.push(it);
  });
  var rt = _toConsumableArray$a(_);
  rt.pop(), rt = [].concat(_toConsumableArray$a(rt), _toConsumableArray$a(tt)), rt.forEach(function(it, ut) {
    isNumber(it) ? ot.push("[".concat(it, "]")) : ot.push(it);
  });
  var st = ot.join("."), lt = tt;
  lt[0] && isNumber(lt[0]) && lt.splice(0, 1);
  var et = [].concat(at, [lt]).join(".");
  return {
    dataIndex: nt,
    dataPath: st,
    schemaPath: et
  };
}, getPath = function a(s) {
  return s ? isArray$3(s) ? s.join(".") : s : null;
}, getLabel$1 = function a(s, $, _, _e) {
  var tt = s.title, nt = s.description, at = s.descWidget, ot = s.labelWidget, rt = _[ot];
  if (rt)
    return /* @__PURE__ */ React$a.createElement(rt, {
      schema: s,
      addons: _e
    });
  if (!nt && !at)
    return tt;
  var st = function() {
    var et = _[at];
    return et ? /* @__PURE__ */ React$a.createElement(et, {
      schema: s,
      addons: _e
    }) : nt ? /* @__PURE__ */ React$a.createElement("span", {
      className: "fr-desc"
    }, "(", nt, ")") : null;
  };
  return /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, tt, /* @__PURE__ */ React$a.createElement(st, null));
}, getTooltip$4 = function a(s, $) {
  var _ = s.descType, _e = s.description, tt = s.tooltip;
  return tt ? typeof tt == "string" ? {
    title: /* @__PURE__ */ React$a.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: tt
      }
    })
  } : Object.assign(Object.assign({}, tt), {
    title: /* @__PURE__ */ React$a.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: tt.title
      }
    })
  }) : _ === "widget" || !_e ? null : $ === "column" && _ === "icon" ? {
    title: _e
  } : null;
}, getExtraView = function a(s, $, _) {
  var _e = $[s];
  if (_e) {
    var tt = _e == null ? void 0 : _e.widget;
    if (tt) {
      var nt = _[tt];
      return nt ? /* @__PURE__ */ React$a.createElement(nt, {
        schema: $
      }) : void 0;
    }
    var at = "";
    if (typeof _e == "string" && (at = _e), _e != null && _e.text && (at = _e.text), !!at)
      return /* @__PURE__ */ React$a.createElement("div", {
        className: "fr-form-item-extra",
        dangerouslySetInnerHTML: {
          __html: at
        }
      });
  }
}, getColSpan = function a(s, $, _) {
  var _e = 24, tt = getParamValue$1(s, $, _)("column");
  return tt && (_e = 24 / tt), _.width && (_.width === "100%" ? _e = 24 : _.width === "50%" ? _e = 12 : _.width === "20%" ? _e = 5 : _.width < "50%" && (_e = 8)), _.cellSpan && (_e = _.cellSpan * _e), _.span && (_e = _.span), _e;
}, getParamValue$1 = function a(s, $, _) {
  return function(_e) {
    var tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, nt, at, ot;
    return tt ? (at = (nt = _[_e]) !== null && nt !== void 0 ? nt : $[_e]) !== null && at !== void 0 ? at : s[_e] : (ot = _[_e]) !== null && ot !== void 0 ? ot : $[_e];
  };
}, getFieldProps = function a(s, $, _) {
  var _e = _.widgets, tt = _.methods, nt = _.form, at = _.dependValues, ot = _.globalProps, rt = _.path, st = _.rootPath, lt = _.fieldRef, et, it = getPathObj({
    path: rt,
    rootPath: st
  }), ut = Object.assign(Object.assign({}, $.props), {
    addons: Object.assign(Object.assign(Object.assign({}, nt), {
      globalProps: ot,
      dependValues: at,
      fieldRef: lt
    }), it)
  });
  if ((at == null ? void 0 : at.length) > 0 && (ut.dependValues = at), ["placeholder", "disabled", "format", "onStatusChange"].forEach(function(gt) {
    $[gt] && (ut[gt] = $[gt]);
  }), $.enum && !(!((et = $.props) === null || et === void 0) && et.options)) {
    var ft = $.enum, ht = $.enumNames;
    ut.options = getArray(ft).map(function(gt, pt) {
      var mt = ht && Array.isArray(ht) ? ht[pt] : gt, ct = typeof mt == "string" && mt[0] === "<";
      return ct && (mt = /* @__PURE__ */ React$a.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: mt
        }
      })), {
        label: mt,
        value: gt
      };
    });
  }
  if (isArray$3(ut.options) && (ut = Object.assign(Object.assign({}, ut), {
    options: filterHiddenData(ut.options)
  })), Object.keys($).forEach(function(gt) {
    typeof gt == "string" && gt.toLowerCase().indexOf("props") > -1 && gt.length > 5 && (ut[gt] = $[gt]);
  }), isObject$6(ut.addonAfter) && ut.addonAfter.widget) {
    var dt = _e[ut.addonAfter.widget];
    ut.addonAfter = /* @__PURE__ */ React$a.createElement(dt, Object.assign({}, $));
  }
  return ["treeSelect", "inputNumber", "multiSelect", "select"].includes(s) && (ut.style = Object.assign({
    width: "100%"
  }, ut.style)), s === "multiSelect" && (ut.mode = "multiple"), isObject$6($.methods) && Object.keys($.methods).forEach(function(gt) {
    var pt = $.methods[gt];
    ut[gt] = tt[pt];
  }), ut.schema = $, ut;
}, getDependValues = function a(s, $, _, _e) {
  var tt = /\[[0-9]*\]/;
  if (tt.test($)) {
    var nt = _get(_, "path.0"), at = $.match(tt)[0].replace("[", "").replace("]", ""), ot = $.split(tt)[0], rt = at || nt, st = $.replace("".concat(ot, "[").concat(at, "]."), ""), lt = _get(s, "".concat(ot, "[").concat(rt, "]"));
    return _e.push(ot, rt), a(lt, st, _, _e);
  }
  return _e.push.apply(_e, _toConsumableArray$a($.split("."))), _get(s, $);
};
function _typeof$o(a) {
  "@babel/helpers - typeof";
  return _typeof$o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$o(a);
}
var createDataSkeleton = function a(s, $) {
  var _ = _cloneDeep($), _e = _;
  return isObjType(s) ? ((_ === void 0 || _typeof$o(_) !== "object") && (_ = {}, _e = {}), Object.keys(s.properties).forEach(function(tt) {
    var nt = s.properties[tt], at = _[tt], ot = a(nt, at);
    _e[tt] = ot;
  })) : _ !== void 0 || (s.default !== void 0 ? _e = _cloneDeep(s.default) : isListType(s) ? _e = [a(s.items)] : (s.type === "boolean" && s.widget, _e = void 0)), _e;
}, isExpression = function a(s) {
  if (typeof s != "string")
    return !1;
  var $ = /^\{\s*\{([\s\S]+)\}\s*\}$/, _ = /^{\s*{function\(.+}\s*}$/;
  return s.match($) && !s.match(_);
}, isHasExpression = function a(s) {
  var $ = Object.keys(s).some(function(_) {
    var _e = s[_];
    if (_ === "properties")
      return !1;
    var tt = function nt(at) {
      var ot = at.some(function(rt) {
        return isArray$3(rt) ? nt(rt) : isObject$6(rt) ? a(rt) : isExpression(rt);
      });
      return ot;
    };
    return isArray$3(_e) ? tt(_e) : isObject$6(_e) ? a(_e) : isExpression(_e);
  });
  return $;
}, parseExpression = function a(s) {
  var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = arguments.length > 2 ? arguments[2] : void 0, _e = get($, _) || {};
  if (typeof s == "string") {
    var tt = s.replace(/^{\s*{/g, "").replace(/}\s*}$/g, "").trim(), nt = `
      return `.concat(tt.replace(/formData/g, JSON.stringify($)).replace(/rootValue/g, JSON.stringify(_e)), `
    `);
    try {
      var at = Function(nt)();
      return at;
    } catch (ot) {
      return console.log(ot, nt, _), null;
    }
  }
  return s;
}, parseAllExpression = function a(s, $, _, _e) {
  var tt = _cloneDeep(s), nt = $;
  _e && (nt = createDataSkeleton(_e, nt));
  var at = function ot(rt) {
    var st = rt.map(function(lt) {
      return isArray$3(lt) ? ot(lt) : isObject$6(lt) ? a(lt, nt, _) : isExpression(lt) ? parseExpression(lt, nt, _) : lt;
    });
    return st;
  };
  return Object.keys(tt).forEach(function(ot) {
    var rt, st = tt[ot];
    isArray$3(st) && (tt[ot] = at(st)), isObject$6(st) && (!((rt = st.mustacheParse) !== null && rt !== void 0) || rt) ? tt[ot] = a(st, nt, _) : isExpression(st) && (tt[ot] = parseExpression(st, nt, _));
  }), tt;
}, extractFormDataStrings = function a(s) {
  var $ = [];
  return s.forEach(function(_) {
    var _e = /formData.\w+(.\w+)*(\(.*\))?/g, tt = _.match(_e);
    tt && ($ = $.concat(tt));
  }), $;
}, extractRootValueStrings = function a(s) {
  var $ = [];
  return s.forEach(function(_) {
    var _e = /rootValue.\w+(.\w+)*(\(.*\))?/g, tt = _.match(_e);
    tt && ($ = $.concat(tt));
  }), $;
}, findStrList = function a(s, $) {
  for (var _ = /{{(.*?)}}/g, _e = [], tt; (tt = _.exec(s)) !== null; )
    _e.push(tt[1]);
  return $ === "formData" ? extractFormDataStrings(_e) : $ === "rootValue" ? extractRootValueStrings(_e) : [];
}, getListEveryResult = function a(s, $, _, _e) {
  return s.every(function(tt) {
    var nt = parseExpression(tt, $, _e), at = parseExpression(tt, _, _e);
    return nt === at;
  });
};
const fieldShouldUpdate = function(a, s, $, _) {
  return function(_e, tt) {
    if ($)
      return !0;
    var nt = findStrList(a, "formData"), at = findStrList(a, "rootValue"), ot = getListEveryResult(nt, _e, tt, s), rt = getListEveryResult(at, _e, tt, s);
    return !(ot && rt);
  };
};
var mapping = {
  default: "input",
  string: "input",
  array: "list",
  boolean: "checkbox",
  integer: "number",
  number: "inputNumber",
  object: "map",
  html: "html",
  card: "card",
  collapse: "collapse",
  lineTitle: "lineTitle",
  line: "line",
  subItem: "subItem",
  panel: "panel",
  "string:upload": "upload",
  "string:url": "urlInput",
  "string:dateTime": "datePicker",
  "string:date": "datePicker",
  "string:year": "datePicker",
  "string:month": "datePicker",
  "string:week": "datePicker",
  "string:quarter": "datePicker",
  "string:time": "timePicker",
  "string:textarea": "textArea",
  "string:color": "color",
  "string:image": "imageInput",
  "range:time": "timeRange",
  "range:dateTime": "dateRange",
  "range:date": "dateRange",
  "range:year": "dateRange",
  "range:month": "dateRange",
  "range:week": "dateRange",
  "range:quarter": "dateRange",
  "*?enum": "radio",
  "*?enum_long": "select",
  "array?enum": "checkboxes",
  "array?enum_long": "multiSelect",
  "*?readOnly": "html"
  // TODO: html widgets for list / object
};
function getWidgetName(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : mapping, $ = a.type, _ = a.format, _e = a.enum, tt = a.readOnly;
  a.widget;
  var nt = a.props;
  if (a["ui:widget"] || a.widget)
    return a["ui:widget"] || a.widget;
  var at = [];
  tt && (at.push("".concat($, "?readOnly")), at.push("*?readOnly")), _e && (Array.isArray(_e) && ($ === "array" && _e.length > 6 || $ !== "array" && _e.length > 2) ? (at.push("".concat($, "?enum_long")), at.push("*?enum_long")) : (at.push("".concat($, "?enum")), at.push("*?enum"))), nt != null && nt.options && ($ === "array" && nt.options.length > 6 || $ !== "array" && nt.options.length > 2 ? (at.push("".concat($, "?enum_long")), at.push("*?enum_long")) : (at.push("".concat($, "?enum")), at.push("*?enum")));
  var ot = _;
  ot && at.push("".concat($, ":").concat(ot)), $ === "object" ? at.push((a.theme === "tile" ? "lineTitle" : a.theme) || "collapse") : at.push($);
  var rt = "";
  return at.some(function(st) {
    return rt = s[st], !!rt;
  }), rt;
}
function capitalizeFirstLetter(a) {
  return a && a.charAt(0).toUpperCase() + a.slice(1);
}
var getWidget = function a(s, $) {
  var _ = $[s];
  return _ || (_ = $[capitalizeFirstLetter(s)]), _ || (_ = $.Html || null), _;
}, conversions$2 = { exports: {} }, cssKeywords = colorName, reverseKeywords = {};
for (var key in cssKeywords)
  cssKeywords.hasOwnProperty(key) && (reverseKeywords[cssKeywords[key]] = key);
var convert$2 = conversions$2.exports = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
for (var model in convert$2)
  if (convert$2.hasOwnProperty(model)) {
    if (!("channels" in convert$2[model]))
      throw new Error("missing channels property: " + model);
    if (!("labels" in convert$2[model]))
      throw new Error("missing channel labels property: " + model);
    if (convert$2[model].labels.length !== convert$2[model].channels)
      throw new Error("channel and label counts mismatch: " + model);
    var channels = convert$2[model].channels, labels = convert$2[model].labels;
    delete convert$2[model].channels, delete convert$2[model].labels, Object.defineProperty(convert$2[model], "channels", { value: channels }), Object.defineProperty(convert$2[model], "labels", { value: labels });
  }
convert$2.rgb.hsl = function(a) {
  var s = a[0] / 255, $ = a[1] / 255, _ = a[2] / 255, _e = Math.min(s, $, _), tt = Math.max(s, $, _), nt = tt - _e, at, ot, rt;
  return tt === _e ? at = 0 : s === tt ? at = ($ - _) / nt : $ === tt ? at = 2 + (_ - s) / nt : _ === tt && (at = 4 + (s - $) / nt), at = Math.min(at * 60, 360), at < 0 && (at += 360), rt = (_e + tt) / 2, tt === _e ? ot = 0 : rt <= 0.5 ? ot = nt / (tt + _e) : ot = nt / (2 - tt - _e), [at, ot * 100, rt * 100];
};
convert$2.rgb.hsv = function(a) {
  var s, $, _, _e, tt, nt = a[0] / 255, at = a[1] / 255, ot = a[2] / 255, rt = Math.max(nt, at, ot), st = rt - Math.min(nt, at, ot), lt = function(et) {
    return (rt - et) / 6 / st + 1 / 2;
  };
  return st === 0 ? _e = tt = 0 : (tt = st / rt, s = lt(nt), $ = lt(at), _ = lt(ot), nt === rt ? _e = _ - $ : at === rt ? _e = 1 / 3 + s - _ : ot === rt && (_e = 2 / 3 + $ - s), _e < 0 ? _e += 1 : _e > 1 && (_e -= 1)), [
    _e * 360,
    tt * 100,
    rt * 100
  ];
};
convert$2.rgb.hwb = function(a) {
  var s = a[0], $ = a[1], _ = a[2], _e = convert$2.rgb.hsl(a)[0], tt = 1 / 255 * Math.min(s, Math.min($, _));
  return _ = 1 - 1 / 255 * Math.max(s, Math.max($, _)), [_e, tt * 100, _ * 100];
};
convert$2.rgb.cmyk = function(a) {
  var s = a[0] / 255, $ = a[1] / 255, _ = a[2] / 255, _e, tt, nt, at;
  return at = Math.min(1 - s, 1 - $, 1 - _), _e = (1 - s - at) / (1 - at) || 0, tt = (1 - $ - at) / (1 - at) || 0, nt = (1 - _ - at) / (1 - at) || 0, [_e * 100, tt * 100, nt * 100, at * 100];
};
function comparativeDistance(a, s) {
  return Math.pow(a[0] - s[0], 2) + Math.pow(a[1] - s[1], 2) + Math.pow(a[2] - s[2], 2);
}
convert$2.rgb.keyword = function(a) {
  var s = reverseKeywords[a];
  if (s)
    return s;
  var $ = 1 / 0, _;
  for (var _e in cssKeywords)
    if (cssKeywords.hasOwnProperty(_e)) {
      var tt = cssKeywords[_e], nt = comparativeDistance(a, tt);
      nt < $ && ($ = nt, _ = _e);
    }
  return _;
};
convert$2.keyword.rgb = function(a) {
  return cssKeywords[a];
};
convert$2.rgb.xyz = function(a) {
  var s = a[0] / 255, $ = a[1] / 255, _ = a[2] / 255;
  s = s > 0.04045 ? Math.pow((s + 0.055) / 1.055, 2.4) : s / 12.92, $ = $ > 0.04045 ? Math.pow(($ + 0.055) / 1.055, 2.4) : $ / 12.92, _ = _ > 0.04045 ? Math.pow((_ + 0.055) / 1.055, 2.4) : _ / 12.92;
  var _e = s * 0.4124 + $ * 0.3576 + _ * 0.1805, tt = s * 0.2126 + $ * 0.7152 + _ * 0.0722, nt = s * 0.0193 + $ * 0.1192 + _ * 0.9505;
  return [_e * 100, tt * 100, nt * 100];
};
convert$2.rgb.lab = function(a) {
  var s = convert$2.rgb.xyz(a), $ = s[0], _ = s[1], _e = s[2], tt, nt, at;
  return $ /= 95.047, _ /= 100, _e /= 108.883, $ = $ > 8856e-6 ? Math.pow($, 1 / 3) : 7.787 * $ + 16 / 116, _ = _ > 8856e-6 ? Math.pow(_, 1 / 3) : 7.787 * _ + 16 / 116, _e = _e > 8856e-6 ? Math.pow(_e, 1 / 3) : 7.787 * _e + 16 / 116, tt = 116 * _ - 16, nt = 500 * ($ - _), at = 200 * (_ - _e), [tt, nt, at];
};
convert$2.hsl.rgb = function(a) {
  var s = a[0] / 360, $ = a[1] / 100, _ = a[2] / 100, _e, tt, nt, at, ot;
  if ($ === 0)
    return ot = _ * 255, [ot, ot, ot];
  _ < 0.5 ? tt = _ * (1 + $) : tt = _ + $ - _ * $, _e = 2 * _ - tt, at = [0, 0, 0];
  for (var rt = 0; rt < 3; rt++)
    nt = s + 1 / 3 * -(rt - 1), nt < 0 && nt++, nt > 1 && nt--, 6 * nt < 1 ? ot = _e + (tt - _e) * 6 * nt : 2 * nt < 1 ? ot = tt : 3 * nt < 2 ? ot = _e + (tt - _e) * (2 / 3 - nt) * 6 : ot = _e, at[rt] = ot * 255;
  return at;
};
convert$2.hsl.hsv = function(a) {
  var s = a[0], $ = a[1] / 100, _ = a[2] / 100, _e = $, tt = Math.max(_, 0.01), nt, at;
  return _ *= 2, $ *= _ <= 1 ? _ : 2 - _, _e *= tt <= 1 ? tt : 2 - tt, at = (_ + $) / 2, nt = _ === 0 ? 2 * _e / (tt + _e) : 2 * $ / (_ + $), [s, nt * 100, at * 100];
};
convert$2.hsv.rgb = function(a) {
  var s = a[0] / 60, $ = a[1] / 100, _ = a[2] / 100, _e = Math.floor(s) % 6, tt = s - Math.floor(s), nt = 255 * _ * (1 - $), at = 255 * _ * (1 - $ * tt), ot = 255 * _ * (1 - $ * (1 - tt));
  switch (_ *= 255, _e) {
    case 0:
      return [_, ot, nt];
    case 1:
      return [at, _, nt];
    case 2:
      return [nt, _, ot];
    case 3:
      return [nt, at, _];
    case 4:
      return [ot, nt, _];
    case 5:
      return [_, nt, at];
  }
};
convert$2.hsv.hsl = function(a) {
  var s = a[0], $ = a[1] / 100, _ = a[2] / 100, _e = Math.max(_, 0.01), tt, nt, at;
  return at = (2 - $) * _, tt = (2 - $) * _e, nt = $ * _e, nt /= tt <= 1 ? tt : 2 - tt, nt = nt || 0, at /= 2, [s, nt * 100, at * 100];
};
convert$2.hwb.rgb = function(a) {
  var s = a[0] / 360, $ = a[1] / 100, _ = a[2] / 100, _e = $ + _, tt, nt, at, ot;
  _e > 1 && ($ /= _e, _ /= _e), tt = Math.floor(6 * s), nt = 1 - _, at = 6 * s - tt, tt & 1 && (at = 1 - at), ot = $ + at * (nt - $);
  var rt, st, lt;
  switch (tt) {
    default:
    case 6:
    case 0:
      rt = nt, st = ot, lt = $;
      break;
    case 1:
      rt = ot, st = nt, lt = $;
      break;
    case 2:
      rt = $, st = nt, lt = ot;
      break;
    case 3:
      rt = $, st = ot, lt = nt;
      break;
    case 4:
      rt = ot, st = $, lt = nt;
      break;
    case 5:
      rt = nt, st = $, lt = ot;
      break;
  }
  return [rt * 255, st * 255, lt * 255];
};
convert$2.cmyk.rgb = function(a) {
  var s = a[0] / 100, $ = a[1] / 100, _ = a[2] / 100, _e = a[3] / 100, tt, nt, at;
  return tt = 1 - Math.min(1, s * (1 - _e) + _e), nt = 1 - Math.min(1, $ * (1 - _e) + _e), at = 1 - Math.min(1, _ * (1 - _e) + _e), [tt * 255, nt * 255, at * 255];
};
convert$2.xyz.rgb = function(a) {
  var s = a[0] / 100, $ = a[1] / 100, _ = a[2] / 100, _e, tt, nt;
  return _e = s * 3.2406 + $ * -1.5372 + _ * -0.4986, tt = s * -0.9689 + $ * 1.8758 + _ * 0.0415, nt = s * 0.0557 + $ * -0.204 + _ * 1.057, _e = _e > 31308e-7 ? 1.055 * Math.pow(_e, 1 / 2.4) - 0.055 : _e * 12.92, tt = tt > 31308e-7 ? 1.055 * Math.pow(tt, 1 / 2.4) - 0.055 : tt * 12.92, nt = nt > 31308e-7 ? 1.055 * Math.pow(nt, 1 / 2.4) - 0.055 : nt * 12.92, _e = Math.min(Math.max(0, _e), 1), tt = Math.min(Math.max(0, tt), 1), nt = Math.min(Math.max(0, nt), 1), [_e * 255, tt * 255, nt * 255];
};
convert$2.xyz.lab = function(a) {
  var s = a[0], $ = a[1], _ = a[2], _e, tt, nt;
  return s /= 95.047, $ /= 100, _ /= 108.883, s = s > 8856e-6 ? Math.pow(s, 1 / 3) : 7.787 * s + 16 / 116, $ = $ > 8856e-6 ? Math.pow($, 1 / 3) : 7.787 * $ + 16 / 116, _ = _ > 8856e-6 ? Math.pow(_, 1 / 3) : 7.787 * _ + 16 / 116, _e = 116 * $ - 16, tt = 500 * (s - $), nt = 200 * ($ - _), [_e, tt, nt];
};
convert$2.lab.xyz = function(a) {
  var s = a[0], $ = a[1], _ = a[2], _e, tt, nt;
  tt = (s + 16) / 116, _e = $ / 500 + tt, nt = tt - _ / 200;
  var at = Math.pow(tt, 3), ot = Math.pow(_e, 3), rt = Math.pow(nt, 3);
  return tt = at > 8856e-6 ? at : (tt - 16 / 116) / 7.787, _e = ot > 8856e-6 ? ot : (_e - 16 / 116) / 7.787, nt = rt > 8856e-6 ? rt : (nt - 16 / 116) / 7.787, _e *= 95.047, tt *= 100, nt *= 108.883, [_e, tt, nt];
};
convert$2.lab.lch = function(a) {
  var s = a[0], $ = a[1], _ = a[2], _e, tt, nt;
  return _e = Math.atan2(_, $), tt = _e * 360 / 2 / Math.PI, tt < 0 && (tt += 360), nt = Math.sqrt($ * $ + _ * _), [s, nt, tt];
};
convert$2.lch.lab = function(a) {
  var s = a[0], $ = a[1], _ = a[2], _e, tt, nt;
  return nt = _ / 360 * 2 * Math.PI, _e = $ * Math.cos(nt), tt = $ * Math.sin(nt), [s, _e, tt];
};
convert$2.rgb.ansi16 = function(a) {
  var s = a[0], $ = a[1], _ = a[2], _e = 1 in arguments ? arguments[1] : convert$2.rgb.hsv(a)[2];
  if (_e = Math.round(_e / 50), _e === 0)
    return 30;
  var tt = 30 + (Math.round(_ / 255) << 2 | Math.round($ / 255) << 1 | Math.round(s / 255));
  return _e === 2 && (tt += 60), tt;
};
convert$2.hsv.ansi16 = function(a) {
  return convert$2.rgb.ansi16(convert$2.hsv.rgb(a), a[2]);
};
convert$2.rgb.ansi256 = function(a) {
  var s = a[0], $ = a[1], _ = a[2];
  if (s === $ && $ === _)
    return s < 8 ? 16 : s > 248 ? 231 : Math.round((s - 8) / 247 * 24) + 232;
  var _e = 16 + 36 * Math.round(s / 255 * 5) + 6 * Math.round($ / 255 * 5) + Math.round(_ / 255 * 5);
  return _e;
};
convert$2.ansi16.rgb = function(a) {
  var s = a % 10;
  if (s === 0 || s === 7)
    return a > 50 && (s += 3.5), s = s / 10.5 * 255, [s, s, s];
  var $ = (~~(a > 50) + 1) * 0.5, _ = (s & 1) * $ * 255, _e = (s >> 1 & 1) * $ * 255, tt = (s >> 2 & 1) * $ * 255;
  return [_, _e, tt];
};
convert$2.ansi256.rgb = function(a) {
  if (a >= 232) {
    var s = (a - 232) * 10 + 8;
    return [s, s, s];
  }
  a -= 16;
  var $, _ = Math.floor(a / 36) / 5 * 255, _e = Math.floor(($ = a % 36) / 6) / 5 * 255, tt = $ % 6 / 5 * 255;
  return [_, _e, tt];
};
convert$2.rgb.hex = function(a) {
  var s = ((Math.round(a[0]) & 255) << 16) + ((Math.round(a[1]) & 255) << 8) + (Math.round(a[2]) & 255), $ = s.toString(16).toUpperCase();
  return "000000".substring($.length) + $;
};
convert$2.hex.rgb = function(a) {
  var s = a.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!s)
    return [0, 0, 0];
  var $ = s[0];
  s[0].length === 3 && ($ = $.split("").map(function(at) {
    return at + at;
  }).join(""));
  var _ = parseInt($, 16), _e = _ >> 16 & 255, tt = _ >> 8 & 255, nt = _ & 255;
  return [_e, tt, nt];
};
convert$2.rgb.hcg = function(a) {
  var s = a[0] / 255, $ = a[1] / 255, _ = a[2] / 255, _e = Math.max(Math.max(s, $), _), tt = Math.min(Math.min(s, $), _), nt = _e - tt, at, ot;
  return nt < 1 ? at = tt / (1 - nt) : at = 0, nt <= 0 ? ot = 0 : _e === s ? ot = ($ - _) / nt % 6 : _e === $ ? ot = 2 + (_ - s) / nt : ot = 4 + (s - $) / nt + 4, ot /= 6, ot %= 1, [ot * 360, nt * 100, at * 100];
};
convert$2.hsl.hcg = function(a) {
  var s = a[1] / 100, $ = a[2] / 100, _ = 1, _e = 0;
  return $ < 0.5 ? _ = 2 * s * $ : _ = 2 * s * (1 - $), _ < 1 && (_e = ($ - 0.5 * _) / (1 - _)), [a[0], _ * 100, _e * 100];
};
convert$2.hsv.hcg = function(a) {
  var s = a[1] / 100, $ = a[2] / 100, _ = s * $, _e = 0;
  return _ < 1 && (_e = ($ - _) / (1 - _)), [a[0], _ * 100, _e * 100];
};
convert$2.hcg.rgb = function(a) {
  var s = a[0] / 360, $ = a[1] / 100, _ = a[2] / 100;
  if ($ === 0)
    return [_ * 255, _ * 255, _ * 255];
  var _e = [0, 0, 0], tt = s % 1 * 6, nt = tt % 1, at = 1 - nt, ot = 0;
  switch (Math.floor(tt)) {
    case 0:
      _e[0] = 1, _e[1] = nt, _e[2] = 0;
      break;
    case 1:
      _e[0] = at, _e[1] = 1, _e[2] = 0;
      break;
    case 2:
      _e[0] = 0, _e[1] = 1, _e[2] = nt;
      break;
    case 3:
      _e[0] = 0, _e[1] = at, _e[2] = 1;
      break;
    case 4:
      _e[0] = nt, _e[1] = 0, _e[2] = 1;
      break;
    default:
      _e[0] = 1, _e[1] = 0, _e[2] = at;
  }
  return ot = (1 - $) * _, [
    ($ * _e[0] + ot) * 255,
    ($ * _e[1] + ot) * 255,
    ($ * _e[2] + ot) * 255
  ];
};
convert$2.hcg.hsv = function(a) {
  var s = a[1] / 100, $ = a[2] / 100, _ = s + $ * (1 - s), _e = 0;
  return _ > 0 && (_e = s / _), [a[0], _e * 100, _ * 100];
};
convert$2.hcg.hsl = function(a) {
  var s = a[1] / 100, $ = a[2] / 100, _ = $ * (1 - s) + 0.5 * s, _e = 0;
  return _ > 0 && _ < 0.5 ? _e = s / (2 * _) : _ >= 0.5 && _ < 1 && (_e = s / (2 * (1 - _))), [a[0], _e * 100, _ * 100];
};
convert$2.hcg.hwb = function(a) {
  var s = a[1] / 100, $ = a[2] / 100, _ = s + $ * (1 - s);
  return [a[0], (_ - s) * 100, (1 - _) * 100];
};
convert$2.hwb.hcg = function(a) {
  var s = a[1] / 100, $ = a[2] / 100, _ = 1 - $, _e = _ - s, tt = 0;
  return _e < 1 && (tt = (_ - _e) / (1 - _e)), [a[0], _e * 100, tt * 100];
};
convert$2.apple.rgb = function(a) {
  return [a[0] / 65535 * 255, a[1] / 65535 * 255, a[2] / 65535 * 255];
};
convert$2.rgb.apple = function(a) {
  return [a[0] / 255 * 65535, a[1] / 255 * 65535, a[2] / 255 * 65535];
};
convert$2.gray.rgb = function(a) {
  return [a[0] / 100 * 255, a[0] / 100 * 255, a[0] / 100 * 255];
};
convert$2.gray.hsl = convert$2.gray.hsv = function(a) {
  return [0, 0, a[0]];
};
convert$2.gray.hwb = function(a) {
  return [0, 100, a[0]];
};
convert$2.gray.cmyk = function(a) {
  return [0, 0, 0, a[0]];
};
convert$2.gray.lab = function(a) {
  return [a[0], 0, 0];
};
convert$2.gray.hex = function(a) {
  var s = Math.round(a[0] / 100 * 255) & 255, $ = (s << 16) + (s << 8) + s, _ = $.toString(16).toUpperCase();
  return "000000".substring(_.length) + _;
};
convert$2.rgb.gray = function(a) {
  var s = (a[0] + a[1] + a[2]) / 3;
  return [s / 255 * 100];
};
var conversionsExports = conversions$2.exports, conversions$1 = conversionsExports;
function buildGraph() {
  for (var a = {}, s = Object.keys(conversions$1), $ = s.length, _ = 0; _ < $; _++)
    a[s[_]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return a;
}
function deriveBFS(a) {
  var s = buildGraph(), $ = [a];
  for (s[a].distance = 0; $.length; )
    for (var _ = $.pop(), _e = Object.keys(conversions$1[_]), tt = _e.length, nt = 0; nt < tt; nt++) {
      var at = _e[nt], ot = s[at];
      ot.distance === -1 && (ot.distance = s[_].distance + 1, ot.parent = _, $.unshift(at));
    }
  return s;
}
function link(a, s) {
  return function($) {
    return s(a($));
  };
}
function wrapConversion(a, s) {
  for (var $ = [s[a].parent, a], _ = conversions$1[s[a].parent][a], _e = s[a].parent; s[_e].parent; )
    $.unshift(s[_e].parent), _ = link(conversions$1[s[_e].parent][_e], _), _e = s[_e].parent;
  return _.conversion = $, _;
}
var route$1 = function(a) {
  for (var s = deriveBFS(a), $ = {}, _ = Object.keys(s), _e = _.length, tt = 0; tt < _e; tt++) {
    var nt = _[tt], at = s[nt];
    at.parent !== null && ($[nt] = wrapConversion(nt, s));
  }
  return $;
}, conversions = conversionsExports, route = route$1, convert$1 = {}, models = Object.keys(conversions);
function wrapRaw(a) {
  var s = function($) {
    return $ == null ? $ : (arguments.length > 1 && ($ = Array.prototype.slice.call(arguments)), a($));
  };
  return "conversion" in a && (s.conversion = a.conversion), s;
}
function wrapRounded(a) {
  var s = function($) {
    if ($ == null)
      return $;
    arguments.length > 1 && ($ = Array.prototype.slice.call(arguments));
    var _ = a($);
    if (typeof _ == "object")
      for (var _e = _.length, tt = 0; tt < _e; tt++)
        _[tt] = Math.round(_[tt]);
    return _;
  };
  return "conversion" in a && (s.conversion = a.conversion), s;
}
models.forEach(function(a) {
  convert$1[a] = {}, Object.defineProperty(convert$1[a], "channels", { value: conversions[a].channels }), Object.defineProperty(convert$1[a], "labels", { value: conversions[a].labels });
  var s = route(a), $ = Object.keys(s);
  $.forEach(function(_) {
    var _e = s[_];
    convert$1[a][_] = wrapRounded(_e), convert$1[a][_].raw = wrapRaw(_e);
  });
});
var colorConvert = convert$1, colorString = colorStringExports, convert = colorConvert, _slice = [].slice, skippedModels = [
  // to be honest, I don't really feel like keyword belongs in color convert, but eh.
  "keyword",
  // gray conflicts with some method names, and has its own method defined.
  "gray",
  // shouldn't really be in color-convert either...
  "hex"
], hashedModelKeys = {};
Object.keys(convert).forEach(function(a) {
  hashedModelKeys[_slice.call(convert[a].labels).sort().join("")] = a;
});
var limiters = {};
function Color$1(a, s) {
  if (!(this instanceof Color$1))
    return new Color$1(a, s);
  if (s && s in skippedModels && (s = null), s && !(s in convert))
    throw new Error("Unknown model: " + s);
  var $, _;
  if (a == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (a instanceof Color$1)
    this.model = a.model, this.color = a.color.slice(), this.valpha = a.valpha;
  else if (typeof a == "string") {
    var _e = colorString.get(a);
    if (_e === null)
      throw new Error("Unable to parse color from string: " + a);
    this.model = _e.model, _ = convert[this.model].channels, this.color = _e.value.slice(0, _), this.valpha = typeof _e.value[_] == "number" ? _e.value[_] : 1;
  } else if (a.length) {
    this.model = s || "rgb", _ = convert[this.model].channels;
    var tt = _slice.call(a, 0, _);
    this.color = zeroArray(tt, _), this.valpha = typeof a[_] == "number" ? a[_] : 1;
  } else if (typeof a == "number")
    a &= 16777215, this.model = "rgb", this.color = [
      a >> 16 & 255,
      a >> 8 & 255,
      a & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    var nt = Object.keys(a);
    "alpha" in a && (nt.splice(nt.indexOf("alpha"), 1), this.valpha = typeof a.alpha == "number" ? a.alpha : 0);
    var at = nt.sort().join("");
    if (!(at in hashedModelKeys))
      throw new Error("Unable to parse color from object: " + JSON.stringify(a));
    this.model = hashedModelKeys[at];
    var ot = convert[this.model].labels, rt = [];
    for ($ = 0; $ < ot.length; $++)
      rt.push(a[ot[$]]);
    this.color = zeroArray(rt);
  }
  if (limiters[this.model])
    for (_ = convert[this.model].channels, $ = 0; $ < _; $++) {
      var st = limiters[this.model][$];
      st && (this.color[$] = st(this.color[$]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
Color$1.prototype = {
  toString: function() {
    return this.string();
  },
  toJSON: function() {
    return this[this.model]();
  },
  string: function(a) {
    var s = this.model in colorString.to ? this : this.rgb();
    s = s.round(typeof a == "number" ? a : 1);
    var $ = s.valpha === 1 ? s.color : s.color.concat(this.valpha);
    return colorString.to[s.model]($);
  },
  percentString: function(a) {
    var s = this.rgb().round(typeof a == "number" ? a : 1), $ = s.valpha === 1 ? s.color : s.color.concat(this.valpha);
    return colorString.to.rgb.percent($);
  },
  array: function() {
    return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
  },
  object: function() {
    for (var a = {}, s = convert[this.model].channels, $ = convert[this.model].labels, _ = 0; _ < s; _++)
      a[$[_]] = this.color[_];
    return this.valpha !== 1 && (a.alpha = this.valpha), a;
  },
  unitArray: function() {
    var a = this.rgb().color;
    return a[0] /= 255, a[1] /= 255, a[2] /= 255, this.valpha !== 1 && a.push(this.valpha), a;
  },
  unitObject: function() {
    var a = this.rgb().object();
    return a.r /= 255, a.g /= 255, a.b /= 255, this.valpha !== 1 && (a.alpha = this.valpha), a;
  },
  round: function(a) {
    return a = Math.max(a || 0, 0), new Color$1(this.color.map(roundToPlace(a)).concat(this.valpha), this.model);
  },
  alpha: function(a) {
    return arguments.length ? new Color$1(this.color.concat(Math.max(0, Math.min(1, a))), this.model) : this.valpha;
  },
  // rgb
  red: getset("rgb", 0, maxfn(255)),
  green: getset("rgb", 1, maxfn(255)),
  blue: getset("rgb", 2, maxfn(255)),
  hue: getset(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function(a) {
    return (a % 360 + 360) % 360;
  }),
  // eslint-disable-line brace-style
  saturationl: getset("hsl", 1, maxfn(100)),
  lightness: getset("hsl", 2, maxfn(100)),
  saturationv: getset("hsv", 1, maxfn(100)),
  value: getset("hsv", 2, maxfn(100)),
  chroma: getset("hcg", 1, maxfn(100)),
  gray: getset("hcg", 2, maxfn(100)),
  white: getset("hwb", 1, maxfn(100)),
  wblack: getset("hwb", 2, maxfn(100)),
  cyan: getset("cmyk", 0, maxfn(100)),
  magenta: getset("cmyk", 1, maxfn(100)),
  yellow: getset("cmyk", 2, maxfn(100)),
  black: getset("cmyk", 3, maxfn(100)),
  x: getset("xyz", 0, maxfn(100)),
  y: getset("xyz", 1, maxfn(100)),
  z: getset("xyz", 2, maxfn(100)),
  l: getset("lab", 0, maxfn(100)),
  a: getset("lab", 1),
  b: getset("lab", 2),
  keyword: function(a) {
    return arguments.length ? new Color$1(a) : convert[this.model].keyword(this.color);
  },
  hex: function(a) {
    return arguments.length ? new Color$1(a) : colorString.to.hex(this.rgb().round().color);
  },
  rgbNumber: function() {
    var a = this.rgb().color;
    return (a[0] & 255) << 16 | (a[1] & 255) << 8 | a[2] & 255;
  },
  luminosity: function() {
    for (var a = this.rgb().color, s = [], $ = 0; $ < a.length; $++) {
      var _ = a[$] / 255;
      s[$] = _ <= 0.03928 ? _ / 12.92 : Math.pow((_ + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * s[0] + 0.7152 * s[1] + 0.0722 * s[2];
  },
  contrast: function(a) {
    var s = this.luminosity(), $ = a.luminosity();
    return s > $ ? (s + 0.05) / ($ + 0.05) : ($ + 0.05) / (s + 0.05);
  },
  level: function(a) {
    var s = this.contrast(a);
    return s >= 7.1 ? "AAA" : s >= 4.5 ? "AA" : "";
  },
  isDark: function() {
    var a = this.rgb().color, s = (a[0] * 299 + a[1] * 587 + a[2] * 114) / 1e3;
    return s < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  negate: function() {
    for (var a = this.rgb(), s = 0; s < 3; s++)
      a.color[s] = 255 - a.color[s];
    return a;
  },
  lighten: function(a) {
    var s = this.hsl();
    return s.color[2] += s.color[2] * a, s;
  },
  darken: function(a) {
    var s = this.hsl();
    return s.color[2] -= s.color[2] * a, s;
  },
  saturate: function(a) {
    var s = this.hsl();
    return s.color[1] += s.color[1] * a, s;
  },
  desaturate: function(a) {
    var s = this.hsl();
    return s.color[1] -= s.color[1] * a, s;
  },
  whiten: function(a) {
    var s = this.hwb();
    return s.color[1] += s.color[1] * a, s;
  },
  blacken: function(a) {
    var s = this.hwb();
    return s.color[2] += s.color[2] * a, s;
  },
  grayscale: function() {
    var a = this.rgb().color, s = a[0] * 0.3 + a[1] * 0.59 + a[2] * 0.11;
    return Color$1.rgb(s, s, s);
  },
  fade: function(a) {
    return this.alpha(this.valpha - this.valpha * a);
  },
  opaquer: function(a) {
    return this.alpha(this.valpha + this.valpha * a);
  },
  rotate: function(a) {
    var s = this.hsl(), $ = s.color[0];
    return $ = ($ + a) % 360, $ = $ < 0 ? 360 + $ : $, s.color[0] = $, s;
  },
  mix: function(a, s) {
    if (!a || !a.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof a);
    var $ = a.rgb(), _ = this.rgb(), _e = s === void 0 ? 0.5 : s, tt = 2 * _e - 1, nt = $.alpha() - _.alpha(), at = ((tt * nt === -1 ? tt : (tt + nt) / (1 + tt * nt)) + 1) / 2, ot = 1 - at;
    return Color$1.rgb(
      at * $.red() + ot * _.red(),
      at * $.green() + ot * _.green(),
      at * $.blue() + ot * _.blue(),
      $.alpha() * _e + _.alpha() * (1 - _e)
    );
  }
};
Object.keys(convert).forEach(function(a) {
  if (skippedModels.indexOf(a) === -1) {
    var s = convert[a].channels;
    Color$1.prototype[a] = function() {
      if (this.model === a)
        return new Color$1(this);
      if (arguments.length)
        return new Color$1(arguments, a);
      var $ = typeof arguments[s] == "number" ? s : this.valpha;
      return new Color$1(assertArray(convert[this.model][a].raw(this.color)).concat($), a);
    }, Color$1[a] = function($) {
      return typeof $ == "number" && ($ = zeroArray(_slice.call(arguments), s)), new Color$1($, a);
    };
  }
});
function roundTo(a, s) {
  return Number(a.toFixed(s));
}
function roundToPlace(a) {
  return function(s) {
    return roundTo(s, a);
  };
}
function getset(a, s, $) {
  return a = Array.isArray(a) ? a : [a], a.forEach(function(_) {
    (limiters[_] || (limiters[_] = []))[s] = $;
  }), a = a[0], function(_) {
    var _e;
    return arguments.length ? ($ && (_ = $(_)), _e = this[a](), _e.color[s] = _, _e) : (_e = this[a]().color[s], $ && (_e = $(_e)), _e);
  };
}
function maxfn(a) {
  return function(s) {
    return Math.max(0, Math.min(a, s));
  };
}
function assertArray(a) {
  return Array.isArray(a) ? a : [a];
}
function zeroArray(a, s) {
  for (var $ = 0; $ < s; $++)
    typeof a[$] != "number" && (a[$] = 0);
  return a;
}
var color$1 = Color$1;
const Color$2 = /* @__PURE__ */ getDefaultExportFromCjs(color$1);
function _typeof$n(a) {
  "@babel/helpers - typeof";
  return _typeof$n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$n(a);
}
function _toConsumableArray$9(a) {
  return _arrayWithoutHoles$9(a) || _iterableToArray$9(a) || _unsupportedIterableToArray$h(a) || _nonIterableSpread$9();
}
function _nonIterableSpread$9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$h(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$h(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$h(a, s);
  }
}
function _iterableToArray$9(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$9(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$h(a);
}
function _arrayLikeToArray$h(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _regeneratorRuntime$2() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime$2 = function() {
    return s;
  };
  var a, s = {}, $ = Object.prototype, _ = $.hasOwnProperty, _e = Object.defineProperty || function(Ct, It, yt) {
    Ct[It] = yt.value;
  }, tt = typeof Symbol == "function" ? Symbol : {}, nt = tt.iterator || "@@iterator", at = tt.asyncIterator || "@@asyncIterator", ot = tt.toStringTag || "@@toStringTag";
  function rt(Ct, It, yt) {
    return Object.defineProperty(Ct, It, { value: yt, enumerable: !0, configurable: !0, writable: !0 }), Ct[It];
  }
  try {
    rt({}, "");
  } catch {
    rt = function(yt, Rt, kt) {
      return yt[Rt] = kt;
    };
  }
  function st(Ct, It, yt, Rt) {
    var kt = It && It.prototype instanceof dt ? It : dt, jt = Object.create(kt.prototype), Ht = new Pt(Rt || []);
    return _e(jt, "_invoke", { value: Et(Ct, yt, Ht) }), jt;
  }
  function lt(Ct, It, yt) {
    try {
      return { type: "normal", arg: Ct.call(It, yt) };
    } catch (Rt) {
      return { type: "throw", arg: Rt };
    }
  }
  s.wrap = st;
  var et = "suspendedStart", it = "suspendedYield", ut = "executing", ft = "completed", ht = {};
  function dt() {
  }
  function gt() {
  }
  function pt() {
  }
  var mt = {};
  rt(mt, nt, function() {
    return this;
  });
  var ct = Object.getPrototypeOf, vt = ct && ct(ct(wt([])));
  vt && vt !== $ && _.call(vt, nt) && (mt = vt);
  var At = pt.prototype = dt.prototype = Object.create(mt);
  function xt(Ct) {
    ["next", "throw", "return"].forEach(function(It) {
      rt(Ct, It, function(yt) {
        return this._invoke(It, yt);
      });
    });
  }
  function bt(Ct, It) {
    function yt(kt, jt, Ht, Ft) {
      var _t = lt(Ct[kt], Ct, jt);
      if (_t.type !== "throw") {
        var Nt = _t.arg, Mt = Nt.value;
        return Mt && _typeof$n(Mt) == "object" && _.call(Mt, "__await") ? It.resolve(Mt.__await).then(function(Lt) {
          yt("next", Lt, Ht, Ft);
        }, function(Lt) {
          yt("throw", Lt, Ht, Ft);
        }) : It.resolve(Mt).then(function(Lt) {
          Nt.value = Lt, Ht(Nt);
        }, function(Lt) {
          return yt("throw", Lt, Ht, Ft);
        });
      }
      Ft(_t.arg);
    }
    var Rt;
    _e(this, "_invoke", { value: function(jt, Ht) {
      function Ft() {
        return new It(function(_t, Nt) {
          yt(jt, Ht, _t, Nt);
        });
      }
      return Rt = Rt ? Rt.then(Ft, Ft) : Ft();
    } });
  }
  function Et(Ct, It, yt) {
    var Rt = et;
    return function(kt, jt) {
      if (Rt === ut)
        throw new Error("Generator is already running");
      if (Rt === ft) {
        if (kt === "throw")
          throw jt;
        return { value: a, done: !0 };
      }
      for (yt.method = kt, yt.arg = jt; ; ) {
        var Ht = yt.delegate;
        if (Ht) {
          var Ft = St(Ht, yt);
          if (Ft) {
            if (Ft === ht)
              continue;
            return Ft;
          }
        }
        if (yt.method === "next")
          yt.sent = yt._sent = yt.arg;
        else if (yt.method === "throw") {
          if (Rt === et)
            throw Rt = ft, yt.arg;
          yt.dispatchException(yt.arg);
        } else
          yt.method === "return" && yt.abrupt("return", yt.arg);
        Rt = ut;
        var _t = lt(Ct, It, yt);
        if (_t.type === "normal") {
          if (Rt = yt.done ? ft : it, _t.arg === ht)
            continue;
          return { value: _t.arg, done: yt.done };
        }
        _t.type === "throw" && (Rt = ft, yt.method = "throw", yt.arg = _t.arg);
      }
    };
  }
  function St(Ct, It) {
    var yt = It.method, Rt = Ct.iterator[yt];
    if (Rt === a)
      return It.delegate = null, yt === "throw" && Ct.iterator.return && (It.method = "return", It.arg = a, St(Ct, It), It.method === "throw") || yt !== "return" && (It.method = "throw", It.arg = new TypeError("The iterator does not provide a '" + yt + "' method")), ht;
    var kt = lt(Rt, Ct.iterator, It.arg);
    if (kt.type === "throw")
      return It.method = "throw", It.arg = kt.arg, It.delegate = null, ht;
    var jt = kt.arg;
    return jt ? jt.done ? (It[Ct.resultName] = jt.value, It.next = Ct.nextLoc, It.method !== "return" && (It.method = "next", It.arg = a), It.delegate = null, ht) : jt : (It.method = "throw", It.arg = new TypeError("iterator result is not an object"), It.delegate = null, ht);
  }
  function Bt(Ct) {
    var It = { tryLoc: Ct[0] };
    1 in Ct && (It.catchLoc = Ct[1]), 2 in Ct && (It.finallyLoc = Ct[2], It.afterLoc = Ct[3]), this.tryEntries.push(It);
  }
  function Ot(Ct) {
    var It = Ct.completion || {};
    It.type = "normal", delete It.arg, Ct.completion = It;
  }
  function Pt(Ct) {
    this.tryEntries = [{ tryLoc: "root" }], Ct.forEach(Bt, this), this.reset(!0);
  }
  function wt(Ct) {
    if (Ct || Ct === "") {
      var It = Ct[nt];
      if (It)
        return It.call(Ct);
      if (typeof Ct.next == "function")
        return Ct;
      if (!isNaN(Ct.length)) {
        var yt = -1, Rt = function kt() {
          for (; ++yt < Ct.length; )
            if (_.call(Ct, yt))
              return kt.value = Ct[yt], kt.done = !1, kt;
          return kt.value = a, kt.done = !0, kt;
        };
        return Rt.next = Rt;
      }
    }
    throw new TypeError(_typeof$n(Ct) + " is not iterable");
  }
  return gt.prototype = pt, _e(At, "constructor", { value: pt, configurable: !0 }), _e(pt, "constructor", { value: gt, configurable: !0 }), gt.displayName = rt(pt, ot, "GeneratorFunction"), s.isGeneratorFunction = function(Ct) {
    var It = typeof Ct == "function" && Ct.constructor;
    return !!It && (It === gt || (It.displayName || It.name) === "GeneratorFunction");
  }, s.mark = function(Ct) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(Ct, pt) : (Ct.__proto__ = pt, rt(Ct, ot, "GeneratorFunction")), Ct.prototype = Object.create(At), Ct;
  }, s.awrap = function(Ct) {
    return { __await: Ct };
  }, xt(bt.prototype), rt(bt.prototype, at, function() {
    return this;
  }), s.AsyncIterator = bt, s.async = function(Ct, It, yt, Rt, kt) {
    kt === void 0 && (kt = Promise);
    var jt = new bt(st(Ct, It, yt, Rt), kt);
    return s.isGeneratorFunction(It) ? jt : jt.next().then(function(Ht) {
      return Ht.done ? Ht.value : jt.next();
    });
  }, xt(At), rt(At, ot, "Generator"), rt(At, nt, function() {
    return this;
  }), rt(At, "toString", function() {
    return "[object Generator]";
  }), s.keys = function(Ct) {
    var It = Object(Ct), yt = [];
    for (var Rt in It)
      yt.push(Rt);
    return yt.reverse(), function kt() {
      for (; yt.length; ) {
        var jt = yt.pop();
        if (jt in It)
          return kt.value = jt, kt.done = !1, kt;
      }
      return kt.done = !0, kt;
    };
  }, s.values = wt, Pt.prototype = { constructor: Pt, reset: function(It) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = a, this.done = !1, this.delegate = null, this.method = "next", this.arg = a, this.tryEntries.forEach(Ot), !It)
      for (var yt in this)
        yt.charAt(0) === "t" && _.call(this, yt) && !isNaN(+yt.slice(1)) && (this[yt] = a);
  }, stop: function() {
    this.done = !0;
    var It = this.tryEntries[0].completion;
    if (It.type === "throw")
      throw It.arg;
    return this.rval;
  }, dispatchException: function(It) {
    if (this.done)
      throw It;
    var yt = this;
    function Rt(Nt, Mt) {
      return Ht.type = "throw", Ht.arg = It, yt.next = Nt, Mt && (yt.method = "next", yt.arg = a), !!Mt;
    }
    for (var kt = this.tryEntries.length - 1; kt >= 0; --kt) {
      var jt = this.tryEntries[kt], Ht = jt.completion;
      if (jt.tryLoc === "root")
        return Rt("end");
      if (jt.tryLoc <= this.prev) {
        var Ft = _.call(jt, "catchLoc"), _t = _.call(jt, "finallyLoc");
        if (Ft && _t) {
          if (this.prev < jt.catchLoc)
            return Rt(jt.catchLoc, !0);
          if (this.prev < jt.finallyLoc)
            return Rt(jt.finallyLoc);
        } else if (Ft) {
          if (this.prev < jt.catchLoc)
            return Rt(jt.catchLoc, !0);
        } else {
          if (!_t)
            throw new Error("try statement without catch or finally");
          if (this.prev < jt.finallyLoc)
            return Rt(jt.finallyLoc);
        }
      }
    }
  }, abrupt: function(It, yt) {
    for (var Rt = this.tryEntries.length - 1; Rt >= 0; --Rt) {
      var kt = this.tryEntries[Rt];
      if (kt.tryLoc <= this.prev && _.call(kt, "finallyLoc") && this.prev < kt.finallyLoc) {
        var jt = kt;
        break;
      }
    }
    jt && (It === "break" || It === "continue") && jt.tryLoc <= yt && yt <= jt.finallyLoc && (jt = null);
    var Ht = jt ? jt.completion : {};
    return Ht.type = It, Ht.arg = yt, jt ? (this.method = "next", this.next = jt.finallyLoc, ht) : this.complete(Ht);
  }, complete: function(It, yt) {
    if (It.type === "throw")
      throw It.arg;
    return It.type === "break" || It.type === "continue" ? this.next = It.arg : It.type === "return" ? (this.rval = this.arg = It.arg, this.method = "return", this.next = "end") : It.type === "normal" && yt && (this.next = yt), ht;
  }, finish: function(It) {
    for (var yt = this.tryEntries.length - 1; yt >= 0; --yt) {
      var Rt = this.tryEntries[yt];
      if (Rt.finallyLoc === It)
        return this.complete(Rt.completion, Rt.afterLoc), Ot(Rt), ht;
    }
  }, catch: function(It) {
    for (var yt = this.tryEntries.length - 1; yt >= 0; --yt) {
      var Rt = this.tryEntries[yt];
      if (Rt.tryLoc === It) {
        var kt = Rt.completion;
        if (kt.type === "throw") {
          var jt = kt.arg;
          Ot(Rt);
        }
        return jt;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(It, yt, Rt) {
    return this.delegate = { iterator: wt(It), resultName: yt, nextLoc: Rt }, this.method === "next" && (this.arg = a), ht;
  } }, s;
}
var insertLengthRule = function a(s, $) {
  var _ = s.type, _e = s.max, tt = s.min, nt = s.message;
  (_e || _e === 0) && $.push({
    type: _,
    max: _e,
    message: nt == null ? void 0 : nt.max
  }), (tt || tt === 0) && $.push({
    type: _,
    min: tt,
    message: nt == null ? void 0 : nt.min
  });
}, insertRequiredRule = function a(s, $) {
  var _, _e = s.type, tt = s.format, nt = s.required, at = s.message, ot = s.widget, rt = s.title, st = (_ = s == null ? void 0 : s.rules) === null || _ === void 0 ? void 0 : _.some(function(et) {
    return et == null ? void 0 : et.required;
  });
  if (!(!nt || st)) {
    var lt = {
      required: !0,
      message: at == null ? void 0 : at.required
    };
    ["year", "quarter", "month", "week", "date", "dateTime", "time"].includes(tt) && _e === "range" ? lt = {
      type: "array",
      required: !0,
      len: 2,
      fields: {
        0: {
          type: "string",
          required: !0
        },
        1: {
          type: "string",
          required: !0
        }
      }
    } : ot === "checkbox" ? lt = {
      type: _e,
      required: !0,
      whitespace: !0,
      message: rt + "必填"
    } : _e === "string" && (lt = {
      type: "string",
      required: !0,
      whitespace: !0,
      message: (at == null ? void 0 : at.required) || (rt ? void 0 : "内容必填")
    }), $.push(lt);
  }
}, transformRules = function a() {
  var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], $ = arguments.length > 1 ? arguments[1] : void 0, _ = arguments.length > 2 ? arguments[2] : void 0;
  return s.map(function(_e) {
    if (_e.validator && !_e.transformed) {
      var tt = isFunction$2(_e.validator) ? _e.validator : $[_e.validator];
      _e.validator = function(nt, at) {
        return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime$2().mark(function ot() {
          var rt;
          return _regeneratorRuntime$2().wrap(function(lt) {
            for (; ; )
              switch (lt.prev = lt.next) {
                case 0:
                  return lt.next = 2, tt(nt, at, {
                    form: _
                  });
                case 2:
                  if (rt = lt.sent, !isObject$6(rt)) {
                    lt.next = 5;
                    break;
                  }
                  return lt.abrupt("return", rt != null && rt.status ? Promise.resolve() : Promise.reject(new Error(rt.message || _e.message)));
                case 5:
                  return lt.abrupt("return", rt ? Promise.resolve() : Promise.reject(new Error(_e.message)));
                case 6:
                case "end":
                  return lt.stop();
              }
          }, ot);
        }));
      }, _e.transformed = !0;
    }
    return _e;
  });
};
const getRuleList = function(a, s, $, _) {
  var _e, tt, nt = cloneDeep(a), at = nt.format, ot = nt.rules, rt = ot === void 0 ? [] : ot, st = nt.pattern, lt = nt.message, et = _toConsumableArray$9(rt);
  return insertRequiredRule(nt, et), insertLengthRule(nt, et), et.push({
    validator: function(ut) {
      return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime$2().mark(function ft() {
        var ht, dt, gt;
        return _regeneratorRuntime$2().wrap(function(mt) {
          for (; ; )
            switch (mt.prev = mt.next) {
              case 0:
                if (isFunction$2((ht = _ == null ? void 0 : _.current) === null || ht === void 0 ? void 0 : ht.validator)) {
                  mt.next = 2;
                  break;
                }
                return mt.abrupt("return", !0);
              case 2:
                return mt.next = 4, (dt = _.current) === null || dt === void 0 ? void 0 : dt.validator();
              case 4:
                return gt = mt.sent, mt.abrupt("return", gt);
              case 6:
              case "end":
                return mt.stop();
            }
        }, ft);
      }));
    }
  }), st && et.push({
    pattern: st,
    message: lt == null ? void 0 : lt.pattern
  }), at === "url" && et.push({
    type: "url",
    message: lt == null ? void 0 : lt.url
  }), at === "email" && et.push({
    type: "email",
    message: lt == null ? void 0 : lt.email
  }), at === "image" && et.push({
    validator: function(ut, ft) {
      if (!ft)
        return !0;
      var ht = "([/|.|w|s|-])*.(?:jpg|gif|png|bmp|apng|webp|jpeg|json)", dt = isUrl$1(ft), gt = new RegExp(ht).test(ft);
      return dt || gt;
    },
    message: (_e = lt == null ? void 0 : lt.email) !== null && _e !== void 0 ? _e : "请输入正确的图片格式"
  }), at === "color" && et.push({
    validator: function(ut, ft) {
      try {
        return Color$2(ft || null), !0;
      } catch {
        return !1;
      }
    },
    message: (tt = lt == null ? void 0 : lt.color) !== null && tt !== void 0 ? tt : "请填写正确的颜色格式"
  }), transformRules(et, $, s);
};
var createUpdateEffect = function(a) {
  return function(s, $) {
    var _ = reactExports.useRef(!1);
    a(function() {
      return function() {
        _.current = !1;
      };
    }, []), a(function() {
      if (!_.current)
        _.current = !0;
      else
        return s();
    }, $);
  };
}, isFunction$1 = function(a) {
  return typeof a == "function";
}, isDev = !1;
const isDev$1 = isDev, useUpdateEffect = createUpdateEffect(reactExports.useEffect);
function useLatest(a) {
  var s = reactExports.useRef(a);
  return s.current = a, s;
}
var useUnmount = function(a) {
  isDev$1 && (isFunction$1(a) || console.error("useUnmount expected parameter is a function, got ".concat(typeof a)));
  var s = useLatest(a);
  reactExports.useEffect(function() {
    return function() {
      s.current();
    };
  }, []);
};
const useUnmount$1 = useUnmount;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$1 = freeGlobal || freeSelf || Function("return this")(), _root = root$1, root = _root, Symbol$4 = root.Symbol, _Symbol = Symbol$4, Symbol$3 = _Symbol, objectProto$1 = Object.prototype, hasOwnProperty$1 = objectProto$1.hasOwnProperty, nativeObjectToString$1 = objectProto$1.toString, symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : void 0;
function getRawTag$1(a) {
  var s = hasOwnProperty$1.call(a, symToStringTag$1), $ = a[symToStringTag$1];
  try {
    a[symToStringTag$1] = void 0;
    var _ = !0;
  } catch {
  }
  var _e = nativeObjectToString$1.call(a);
  return _ && (s ? a[symToStringTag$1] = $ : delete a[symToStringTag$1]), _e;
}
var _getRawTag = getRawTag$1, objectProto = Object.prototype, nativeObjectToString = objectProto.toString;
function objectToString$1(a) {
  return nativeObjectToString.call(a);
}
var _objectToString = objectToString$1, Symbol$2 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag$1(a) {
  return a == null ? a === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(a) ? getRawTag(a) : objectToString(a);
}
var _baseGetTag = baseGetTag$1;
function isObjectLike$1(a) {
  return a != null && typeof a == "object";
}
var isObjectLike_1 = isObjectLike$1, baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1, symbolTag = "[object Symbol]";
function isSymbol$1(a) {
  return typeof a == "symbol" || isObjectLike(a) && baseGetTag(a) == symbolTag;
}
var isSymbol_1 = isSymbol$1, isArray$2 = Array.isArray, isArray_1 = isArray$2, FieldWrapperStatus = function a(s) {
  var $ = s.Field, _ = s.fieldProps, _e = s.maxWidth, tt = s.initialValue, nt = __rest$3(s, ["Field", "fieldProps", "maxWidth", "initialValue"]), at = _.onStatusChange, ot = _.addons, rt = __rest$3(_, ["onStatusChange", "addons"]), st = Object.assign(_e ? {
    maxWidth: _e
  } : {}, _ == null ? void 0 : _.style), lt = Form$3.Item.useStatus(), et = lt.status, it = ot.getFieldError(ot.dataPath);
  return reactExports.useEffect(function() {
    at && at(et, it);
  }, [JSON.stringify(it)]), useUpdateEffect(function() {
    nt.onChange(tt);
  }, [JSON.stringify(tt)]), /* @__PURE__ */ React$a.createElement($, Object.assign({}, nt, rt, {
    style: st,
    addons: ot
  }));
}, FieldWrapper = function a(s) {
  var $ = s.Field, _ = s.fieldProps, _e = s.maxWidth, tt = s.initialValue, nt = __rest$3(s, ["Field", "fieldProps", "maxWidth", "initialValue"]), at = _.addons, ot = _.schema, rt = Object.assign(_e ? {
    maxWidth: _e
  } : {}, _ == null ? void 0 : _.style), st = ot.removeBtn, lt = reactExports.useContext(ThemeConfigProvider.ConfigContext), et = translation$1(lt);
  useUpdateEffect(function() {
    nt.onChange(tt);
  }, [JSON.stringify(tt)]);
  var it = function() {
    if (isFunction$2(st == null ? void 0 : st.onClick)) {
      st.onClick(function() {
        at.setSchemaByPath(at.schemaPath, {
          hidden: !0
        });
      });
      return;
    }
    at.setSchemaByPath(at.schemaPath, {
      hidden: !0
    });
  };
  return /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement($, Object.assign({}, nt, _, {
    style: rt
  })), st && /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({
    type: "link",
    danger: !0
  }, st, {
    onClick: it
  }), (st == null ? void 0 : st.text) || et("delete")));
};
function _typeof$m(a) {
  "@babel/helpers - typeof";
  return _typeof$m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$m(a);
}
function _defineProperty$a(a, s, $) {
  return s = _toPropertyKey$6(s), s in a ? Object.defineProperty(a, s, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = $, a;
}
function _toPropertyKey$6(a) {
  var s = _toPrimitive$7(a, "string");
  return _typeof$m(s) === "symbol" ? s : String(s);
}
function _toPrimitive$7(a, s) {
  if (_typeof$m(a) !== "object" || a === null)
    return a;
  var $ = a[Symbol.toPrimitive];
  if ($ !== void 0) {
    var _ = $.call(a, s || "default");
    if (_typeof$m(_) !== "object")
      return _;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
var UpperContext$1 = /* @__PURE__ */ reactExports.createContext(function() {
}), valuePropNameMap = {
  checkbox: "checked",
  switch: "checked",
  Checkbox: "checked",
  Switch: "checked"
};
const Main$2 = function(a) {
  var s, $, _ = a.configCtx, _e = a.store, tt = a.schema, nt = a.path, at = a.children, ot = a.dependValues, rt = a.rootPath, st = reactExports.useRef(), lt = useStore(_e, function(Kt) {
    return Kt.context;
  }), et = reactExports.useContext(UpperContext$1), it = _.form, ut = _.widgets, ft = _.methods, ht = _.globalProps, dt = tt.reserveLabel, gt = tt.hidden;
  tt.properties;
  var pt = tt.dependencies, mt = tt.inlineMode;
  tt.remove, tt.removeText;
  var ct = tt.visible, vt = ct === void 0 ? !0 : ct, At = __rest$3(tt, ["reserveLabel", "hidden", "properties", "dependencies", "inlineMode", "remove", "removeText", "visible"]), xt = getParamValue$1(lt, et, tt), bt = getWidgetName(tt), Et = getWidget(bt, ut), St = getFieldProps(bt, tt, {
    widgets: ut,
    methods: ft,
    form: it,
    dependValues: ot,
    globalProps: ht,
    path: getPath(nt),
    rootPath: rt,
    fieldRef: st
  });
  if (reactExports.useEffect(function() {
    it.setFieldRef(St.addons.dataPath, st);
  }, []), tt != null && tt.hidden)
    return null;
  if (!bt) {
    var Bt = ut.errorSchema || ut.ErrorSchema;
    return /* @__PURE__ */ React$a.createElement(Bt, {
      schema: tt
    });
  }
  if (tt.type === "void")
    return /* @__PURE__ */ React$a.createElement(Col$1, {
      span: 24
    }, /* @__PURE__ */ React$a.createElement(Et, Object.assign({}, St)));
  var Ot = xt("displayType"), Pt = mt || (et == null ? void 0 : et.displayType) === "inline";
  et.exist || (Pt = mt || (lt == null ? void 0 : lt.displayType) === "inline");
  var wt = Ot === "inline", Ct = xt("labelWidth");
  if (at) {
    var It = /* @__PURE__ */ React$a.createElement("div", {
      className: "fr-inline-container"
    }, at);
    if (!wt) {
      var yt = {
        row: 16,
        column: 24
      }[Ot];
      It = /* @__PURE__ */ React$a.createElement(Row$1, {
        gutter: yt
      }, at);
    }
    St.children = It;
    var Rt = /* @__PURE__ */ React$a.createElement(Et, Object.assign({
      labelWidth: Ct,
      displayType: tt.displayType
    }, St, At));
    return /* @__PURE__ */ React$a.createElement(UpperContext$1.Provider, {
      value: {
        column: tt.column,
        labelCol: tt.labelCol,
        fieldCol: tt.fieldCol,
        displayType: tt.displayType,
        labelWidth: tt.labelWidth,
        noStyle: tt.noStyle,
        exist: !0
      }
    }, Pt ? Rt : /* @__PURE__ */ React$a.createElement(Col$1, {
      span: 24,
      className: classnames("fr-obj-col", _defineProperty$a({}, tt.className, !!tt.className))
    }, Rt));
  }
  var kt = getLabel$1(tt, Ot, ut, St.addons), jt = xt("noStyle"), Ht = getColSpan(lt, et, tt), Ft = getExtraView("extra", tt, ut), _t = getExtraView("help", tt, ut), Nt = getTooltip$4(tt, Ot), Mt = getRuleList(tt, it, ft, st), Lt = xt("readOnly"), $t = xt("disabled"), Tt = xt("validateTrigger"), Dt = xt("labelCol"), Ut = xt("fieldCol"), Vt = xt("maxWidth"), Qt = getFormItemLayout(Math.floor(24 / Ht * 1), tt, {
    displayType: Ot,
    labelWidth: Ct,
    _labelCol: Dt,
    _fieldCol: Ut
  }), qt = Qt.labelCol, Zt = Qt.fieldCol, ar = tt.valuePropName || valuePropNameMap[bt] || void 0;
  Lt && (St.readOnly = Lt), $t && (St.disabled = $t), dt && !kt && Ot !== "column" && (kt = "fr-hide-label"), Lt && (Et = ut[tt.readOnlyWidget] || ut.Html), isCheckBoxType(tt, Lt) && (St.title = kt, kt = null, Ot === "row" && (kt = "fr-hide-label"));
  var Jt = (s = tt.default) !== null && s !== void 0 ? s : tt.defaultValue, rr = _defineProperty$a({
    "fr-hide-label": kt === "fr-hide-label",
    "fr-inline-field": Pt,
    "fr-field-visibility": !vt
  }, tt.className, !!tt.className), Yt = /* @__PURE__ */ React$a.createElement(Form$3.Item, {
    className: classnames("fr-field", rr),
    label: kt,
    name: nt,
    valuePropName: ar,
    rules: Lt ? [] : Mt,
    hidden: gt,
    tooltip: Nt,
    extra: Ft,
    help: _t,
    initialValue: Jt,
    labelCol: qt,
    wrapperCol: Zt,
    noStyle: jt,
    dependencies: pt,
    validateTrigger: Tt ?? (($ = st == null ? void 0 : st.current) === null || $ === void 0 ? void 0 : $.validator) ? "onSubmit" : "onChange"
  }, St.onStatusChange ? /* @__PURE__ */ React$a.createElement(FieldWrapperStatus, {
    Field: Et,
    fieldProps: St,
    maxWidth: Vt,
    initialValue: Jt
  }) : /* @__PURE__ */ React$a.createElement(FieldWrapper, {
    Field: Et,
    fieldProps: St,
    maxWidth: Vt,
    initialValue: Jt
  }));
  return Pt ? jt ? /* @__PURE__ */ React$a.createElement("div", {
    className: classnames("fr-inline-field", _defineProperty$a({
      "fr-field-visibility": !vt
    }, tt.className, !!tt.className))
  }, Yt) : Yt : /* @__PURE__ */ React$a.createElement(Col$1, {
    span: Ht,
    className: classnames(null, {
      "fr-field-visibility": !vt
    })
  }, Yt);
}, FieldItem = function(a) {
  var s, $, _ = a.schema, _e = a.rootPath, tt = __rest$3(a, ["schema", "rootPath"]), nt = reactExports.useContext(FRContext), at = nt.getState(), ot = at.schema, rt = reactExports.useContext(ConfigContext), st = (s = rt == null ? void 0 : rt.globalConfig) === null || s === void 0 ? void 0 : s.mustacheDisabled;
  ($ = rt == null ? void 0 : rt.globalConfig) === null || $ === void 0 || $.shouldUpdateOpen;
  var lt = _ == null ? void 0 : _.dependencies;
  if (!isHasExpression(_) && !st && (!lt || !(lt != null && lt.length)))
    return /* @__PURE__ */ React$a.createElement(Main$2, Object.assign({}, a, {
      store: nt,
      configCtx: rt
    }));
  var et = JSON.stringify(_);
  return /* @__PURE__ */ React$a.createElement(Form$3.Item, {
    noStyle: !0,
    shouldUpdate: fieldShouldUpdate(et, _e, lt)
  }, function(it) {
    var ut = it.getFieldsValue(!0), ft = [], ht = (lt || []).map(function(gt) {
      var pt = [];
      return ft.push(pt), getDependValues(ut, gt, a, pt);
    }), dt = st ? _ : parseAllExpression(_, ut, _e, ot);
    return /* @__PURE__ */ React$a.createElement(Main$2, Object.assign({
      schema: Object.assign(Object.assign({}, dt), {
        dependencies: ft
      }),
      rootPath: _e
    }, tt, {
      dependValues: ht,
      store: nt,
      configCtx: rt
    }));
  });
};
var getParamValue = function a(s, $, _) {
  return function(_e) {
    var tt, nt;
    return (nt = (tt = _[_e]) !== null && tt !== void 0 ? tt : $[_e]) !== null && nt !== void 0 ? nt : s[_e];
  };
}, getFormListLayout = function a(s, $) {
  var _ = s("labelCol"), _e = s("fieldCol"), tt = s("labelWidth"), nt = {
    span: 5
  }, at = {
    flex: 1
  };
  return tt && $ !== "column" && (nt = {
    flex: tt + "px"
  }), _ && (nt = _), _e && (at = _e), typeof _ == "number" && (nt = {
    span: _
  }), typeof _e == "number" && (at = {
    span: _e
  }), {
    labelCol: nt,
    fieldCol: at
  };
}, getLabel = function a(s, $, _) {
  var _e = s.title, tt = s.description, nt = s.descWidget, at = s.labelWidget, ot = _[at];
  if (ot)
    return /* @__PURE__ */ React$a.createElement(ot, {
      schema: s
    });
  if (!tt && !nt)
    return _e;
  var rt = function() {
    var lt = _[nt];
    return lt ? /* @__PURE__ */ React$a.createElement(lt, {
      schema: s
    }) : tt ? /* @__PURE__ */ React$a.createElement("span", {
      className: "fr-desc"
    }, "(", tt, ")") : null;
  };
  return $ === "inline" ? _e : /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, _e, /* @__PURE__ */ React$a.createElement(rt, null));
}, getTooltip$3 = function a(s, $) {
  var _ = s.descType, _e = s.description, tt = s.tooltip;
  return tt ? typeof tt == "string" ? {
    title: /* @__PURE__ */ React$a.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: tt
      }
    })
  } : Object.assign(Object.assign({}, tt), {
    title: /* @__PURE__ */ React$a.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: tt.title
      }
    })
  }) : _ === "widget" || !_e ? null : $ === "column" && _ === "icon" ? {
    title: _e
  } : null;
};
function _typeof$l(a) {
  "@babel/helpers - typeof";
  return _typeof$l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$l(a);
}
function _regeneratorRuntime$1() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime$1 = function() {
    return s;
  };
  var a, s = {}, $ = Object.prototype, _ = $.hasOwnProperty, _e = Object.defineProperty || function(Ct, It, yt) {
    Ct[It] = yt.value;
  }, tt = typeof Symbol == "function" ? Symbol : {}, nt = tt.iterator || "@@iterator", at = tt.asyncIterator || "@@asyncIterator", ot = tt.toStringTag || "@@toStringTag";
  function rt(Ct, It, yt) {
    return Object.defineProperty(Ct, It, { value: yt, enumerable: !0, configurable: !0, writable: !0 }), Ct[It];
  }
  try {
    rt({}, "");
  } catch {
    rt = function(yt, Rt, kt) {
      return yt[Rt] = kt;
    };
  }
  function st(Ct, It, yt, Rt) {
    var kt = It && It.prototype instanceof dt ? It : dt, jt = Object.create(kt.prototype), Ht = new Pt(Rt || []);
    return _e(jt, "_invoke", { value: Et(Ct, yt, Ht) }), jt;
  }
  function lt(Ct, It, yt) {
    try {
      return { type: "normal", arg: Ct.call(It, yt) };
    } catch (Rt) {
      return { type: "throw", arg: Rt };
    }
  }
  s.wrap = st;
  var et = "suspendedStart", it = "suspendedYield", ut = "executing", ft = "completed", ht = {};
  function dt() {
  }
  function gt() {
  }
  function pt() {
  }
  var mt = {};
  rt(mt, nt, function() {
    return this;
  });
  var ct = Object.getPrototypeOf, vt = ct && ct(ct(wt([])));
  vt && vt !== $ && _.call(vt, nt) && (mt = vt);
  var At = pt.prototype = dt.prototype = Object.create(mt);
  function xt(Ct) {
    ["next", "throw", "return"].forEach(function(It) {
      rt(Ct, It, function(yt) {
        return this._invoke(It, yt);
      });
    });
  }
  function bt(Ct, It) {
    function yt(kt, jt, Ht, Ft) {
      var _t = lt(Ct[kt], Ct, jt);
      if (_t.type !== "throw") {
        var Nt = _t.arg, Mt = Nt.value;
        return Mt && _typeof$l(Mt) == "object" && _.call(Mt, "__await") ? It.resolve(Mt.__await).then(function(Lt) {
          yt("next", Lt, Ht, Ft);
        }, function(Lt) {
          yt("throw", Lt, Ht, Ft);
        }) : It.resolve(Mt).then(function(Lt) {
          Nt.value = Lt, Ht(Nt);
        }, function(Lt) {
          return yt("throw", Lt, Ht, Ft);
        });
      }
      Ft(_t.arg);
    }
    var Rt;
    _e(this, "_invoke", { value: function(jt, Ht) {
      function Ft() {
        return new It(function(_t, Nt) {
          yt(jt, Ht, _t, Nt);
        });
      }
      return Rt = Rt ? Rt.then(Ft, Ft) : Ft();
    } });
  }
  function Et(Ct, It, yt) {
    var Rt = et;
    return function(kt, jt) {
      if (Rt === ut)
        throw new Error("Generator is already running");
      if (Rt === ft) {
        if (kt === "throw")
          throw jt;
        return { value: a, done: !0 };
      }
      for (yt.method = kt, yt.arg = jt; ; ) {
        var Ht = yt.delegate;
        if (Ht) {
          var Ft = St(Ht, yt);
          if (Ft) {
            if (Ft === ht)
              continue;
            return Ft;
          }
        }
        if (yt.method === "next")
          yt.sent = yt._sent = yt.arg;
        else if (yt.method === "throw") {
          if (Rt === et)
            throw Rt = ft, yt.arg;
          yt.dispatchException(yt.arg);
        } else
          yt.method === "return" && yt.abrupt("return", yt.arg);
        Rt = ut;
        var _t = lt(Ct, It, yt);
        if (_t.type === "normal") {
          if (Rt = yt.done ? ft : it, _t.arg === ht)
            continue;
          return { value: _t.arg, done: yt.done };
        }
        _t.type === "throw" && (Rt = ft, yt.method = "throw", yt.arg = _t.arg);
      }
    };
  }
  function St(Ct, It) {
    var yt = It.method, Rt = Ct.iterator[yt];
    if (Rt === a)
      return It.delegate = null, yt === "throw" && Ct.iterator.return && (It.method = "return", It.arg = a, St(Ct, It), It.method === "throw") || yt !== "return" && (It.method = "throw", It.arg = new TypeError("The iterator does not provide a '" + yt + "' method")), ht;
    var kt = lt(Rt, Ct.iterator, It.arg);
    if (kt.type === "throw")
      return It.method = "throw", It.arg = kt.arg, It.delegate = null, ht;
    var jt = kt.arg;
    return jt ? jt.done ? (It[Ct.resultName] = jt.value, It.next = Ct.nextLoc, It.method !== "return" && (It.method = "next", It.arg = a), It.delegate = null, ht) : jt : (It.method = "throw", It.arg = new TypeError("iterator result is not an object"), It.delegate = null, ht);
  }
  function Bt(Ct) {
    var It = { tryLoc: Ct[0] };
    1 in Ct && (It.catchLoc = Ct[1]), 2 in Ct && (It.finallyLoc = Ct[2], It.afterLoc = Ct[3]), this.tryEntries.push(It);
  }
  function Ot(Ct) {
    var It = Ct.completion || {};
    It.type = "normal", delete It.arg, Ct.completion = It;
  }
  function Pt(Ct) {
    this.tryEntries = [{ tryLoc: "root" }], Ct.forEach(Bt, this), this.reset(!0);
  }
  function wt(Ct) {
    if (Ct || Ct === "") {
      var It = Ct[nt];
      if (It)
        return It.call(Ct);
      if (typeof Ct.next == "function")
        return Ct;
      if (!isNaN(Ct.length)) {
        var yt = -1, Rt = function kt() {
          for (; ++yt < Ct.length; )
            if (_.call(Ct, yt))
              return kt.value = Ct[yt], kt.done = !1, kt;
          return kt.value = a, kt.done = !0, kt;
        };
        return Rt.next = Rt;
      }
    }
    throw new TypeError(_typeof$l(Ct) + " is not iterable");
  }
  return gt.prototype = pt, _e(At, "constructor", { value: pt, configurable: !0 }), _e(pt, "constructor", { value: gt, configurable: !0 }), gt.displayName = rt(pt, ot, "GeneratorFunction"), s.isGeneratorFunction = function(Ct) {
    var It = typeof Ct == "function" && Ct.constructor;
    return !!It && (It === gt || (It.displayName || It.name) === "GeneratorFunction");
  }, s.mark = function(Ct) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(Ct, pt) : (Ct.__proto__ = pt, rt(Ct, ot, "GeneratorFunction")), Ct.prototype = Object.create(At), Ct;
  }, s.awrap = function(Ct) {
    return { __await: Ct };
  }, xt(bt.prototype), rt(bt.prototype, at, function() {
    return this;
  }), s.AsyncIterator = bt, s.async = function(Ct, It, yt, Rt, kt) {
    kt === void 0 && (kt = Promise);
    var jt = new bt(st(Ct, It, yt, Rt), kt);
    return s.isGeneratorFunction(It) ? jt : jt.next().then(function(Ht) {
      return Ht.done ? Ht.value : jt.next();
    });
  }, xt(At), rt(At, ot, "Generator"), rt(At, nt, function() {
    return this;
  }), rt(At, "toString", function() {
    return "[object Generator]";
  }), s.keys = function(Ct) {
    var It = Object(Ct), yt = [];
    for (var Rt in It)
      yt.push(Rt);
    return yt.reverse(), function kt() {
      for (; yt.length; ) {
        var jt = yt.pop();
        if (jt in It)
          return kt.value = jt, kt.done = !1, kt;
      }
      return kt.done = !0, kt;
    };
  }, s.values = wt, Pt.prototype = { constructor: Pt, reset: function(It) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = a, this.done = !1, this.delegate = null, this.method = "next", this.arg = a, this.tryEntries.forEach(Ot), !It)
      for (var yt in this)
        yt.charAt(0) === "t" && _.call(this, yt) && !isNaN(+yt.slice(1)) && (this[yt] = a);
  }, stop: function() {
    this.done = !0;
    var It = this.tryEntries[0].completion;
    if (It.type === "throw")
      throw It.arg;
    return this.rval;
  }, dispatchException: function(It) {
    if (this.done)
      throw It;
    var yt = this;
    function Rt(Nt, Mt) {
      return Ht.type = "throw", Ht.arg = It, yt.next = Nt, Mt && (yt.method = "next", yt.arg = a), !!Mt;
    }
    for (var kt = this.tryEntries.length - 1; kt >= 0; --kt) {
      var jt = this.tryEntries[kt], Ht = jt.completion;
      if (jt.tryLoc === "root")
        return Rt("end");
      if (jt.tryLoc <= this.prev) {
        var Ft = _.call(jt, "catchLoc"), _t = _.call(jt, "finallyLoc");
        if (Ft && _t) {
          if (this.prev < jt.catchLoc)
            return Rt(jt.catchLoc, !0);
          if (this.prev < jt.finallyLoc)
            return Rt(jt.finallyLoc);
        } else if (Ft) {
          if (this.prev < jt.catchLoc)
            return Rt(jt.catchLoc, !0);
        } else {
          if (!_t)
            throw new Error("try statement without catch or finally");
          if (this.prev < jt.finallyLoc)
            return Rt(jt.finallyLoc);
        }
      }
    }
  }, abrupt: function(It, yt) {
    for (var Rt = this.tryEntries.length - 1; Rt >= 0; --Rt) {
      var kt = this.tryEntries[Rt];
      if (kt.tryLoc <= this.prev && _.call(kt, "finallyLoc") && this.prev < kt.finallyLoc) {
        var jt = kt;
        break;
      }
    }
    jt && (It === "break" || It === "continue") && jt.tryLoc <= yt && yt <= jt.finallyLoc && (jt = null);
    var Ht = jt ? jt.completion : {};
    return Ht.type = It, Ht.arg = yt, jt ? (this.method = "next", this.next = jt.finallyLoc, ht) : this.complete(Ht);
  }, complete: function(It, yt) {
    if (It.type === "throw")
      throw It.arg;
    return It.type === "break" || It.type === "continue" ? this.next = It.arg : It.type === "return" ? (this.rval = this.arg = It.arg, this.method = "return", this.next = "end") : It.type === "normal" && yt && (this.next = yt), ht;
  }, finish: function(It) {
    for (var yt = this.tryEntries.length - 1; yt >= 0; --yt) {
      var Rt = this.tryEntries[yt];
      if (Rt.finallyLoc === It)
        return this.complete(Rt.completion, Rt.afterLoc), Ot(Rt), ht;
    }
  }, catch: function(It) {
    for (var yt = this.tryEntries.length - 1; yt >= 0; --yt) {
      var Rt = this.tryEntries[yt];
      if (Rt.tryLoc === It) {
        var kt = Rt.completion;
        if (kt.type === "throw") {
          var jt = kt.arg;
          Ot(Rt);
        }
        return jt;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(It, yt, Rt) {
    return this.delegate = { iterator: wt(It), resultName: yt, nextLoc: Rt }, this.method === "next" && (this.arg = a), ht;
  } }, s;
}
function _toConsumableArray$8(a) {
  return _arrayWithoutHoles$8(a) || _iterableToArray$8(a) || _unsupportedIterableToArray$g(a) || _nonIterableSpread$8();
}
function _nonIterableSpread$8() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$g(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$g(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$g(a, s);
  }
}
function _iterableToArray$8(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$8(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$g(a);
}
function _arrayLikeToArray$g(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
const Main$1 = function(a) {
  var s, $, _ = a.form, _e = a.schema, tt = a.path, nt = a.parentLitPath, at = a.renderCore, ot = a.rootPath, rt = a.methods, st = a.upperCtx, lt = a.formCtx, et = a.configContext, it = a.setListData, ut = et.widgets, ft = et.globalConfig, ht = reactExports.useContext(ThemeConfigProvider.ConfigContext), dt = translation$1(ht), gt = {
    type: "dashed",
    block: !0,
    children: dt("add_item")
  }, pt = {
    title: dt("confirm_delete"),
    okText: dt("confirm"),
    cancelText: dt("cancel")
  }, mt = {
    colHeaderText: dt("operate")
  }, ct = _e.widget || "cardList", vt = getWidget(ct, ut), At = _e.props, xt = _e.removeBtn, bt = _e.rules, Et = bt === void 0 ? [] : bt, St = __rest$3(_e, ["props", "removeBtn", "rules"]), Bt = At || {}, Ot = Bt.addBtnProps, Pt = Bt.delConfirmProps, wt = Bt.actionColumnProps, Ct = Bt.hideAdd, It = Bt.hideCopy, yt = Bt.hideMove, Rt = Bt.hideDelete, kt = Bt.onAdd, jt = Bt.onRemove, Ht = Bt.onMove, Ft = Bt.onCopy, _t = __rest$3(Bt, ["addBtnProps", "delConfirmProps", "actionColumnProps", "hideAdd", "hideCopy", "hideMove", "hideDelete", "onAdd", "onRemove", "onMove", "onCopy"]), Nt = getParamValue(lt, st, _e), Mt = Nt("readOnly"), Lt = _toConsumableArray$8(ot || []).splice(0, ot.length - 1), $t = Nt("displayType");
  yt === void 0 && (!((s = ft == null ? void 0 : ft.listOperate) === null || s === void 0) && s.hideMove) && (yt = ft == null ? void 0 : ft.listOperate.hideMove);
  var Tt = _.getFieldValue([].concat(_toConsumableArray$8(Lt), _toConsumableArray$8(tt))) || [];
  (St == null ? void 0 : St.min) > 0 && Tt.length <= (St == null ? void 0 : St.min) && (Rt = !0), (St == null ? void 0 : St.max) > 0 && (St == null ? void 0 : St.max) <= Tt.length && (Ct = !0), Ct && (It = !0), Mt && (Ct = !0, It = !0, Rt = !0, yt = !0);
  var Dt = reactExports.useMemo(function() {
    var rr, Yt = (rr = _e.default) !== null && rr !== void 0 ? rr : _e.defaultValue;
    return Yt === void 0 && (Yt = _.getFieldValue([].concat(_toConsumableArray$8(Lt), _toConsumableArray$8(tt))), !Yt && !["drawerList", "list1"].includes(ct) && (Yt = [{}])), Yt;
  }, []);
  reactExports.useEffect(function() {
    it(Dt || []);
  }, []);
  var Ut = function(Yt) {
    return function(Kt) {
      var nr = kt;
      if (typeof kt == "string" && (nr = rt[kt]), isFunction$2(nr)) {
        nr(function(tr) {
          return Yt(tr || Kt);
        }, {
          schema: _e,
          data: Kt
        });
        return;
      }
      Yt(Kt);
    };
  }, Vt = function(Yt) {
    return function(Kt) {
      var nr = jt;
      if (typeof jt == "string" && (nr = rt[jt]), isFunction$2(nr)) {
        var tr = _.getFieldValue([].concat(_toConsumableArray$8(Lt), _toConsumableArray$8(tt), [Kt]));
        nr(function() {
          return Yt(Kt);
        }, {
          schema: _e,
          index: Kt,
          data: tr
        });
        return;
      }
      Yt(Kt);
    };
  }, Qt = function(Yt) {
    return function(Kt, nr) {
      var tr = Ht;
      if (typeof tr == "string" && (tr = rt[Ht]), isFunction$2(tr)) {
        tr(function() {
          return Yt(Kt, nr);
        }, {
          schema: _e,
          form: Kt,
          to: nr
        });
        return;
      }
      Yt(Kt, nr);
    };
  }, qt = function(Yt, Kt) {
    return function(nr) {
      if (_e.max && Kt.length === _e.max)
        return _message.warning(dt("copy_max_tip"));
      var tr = Ft;
      if (typeof Ft == "string" && (tr = rt[Ft]), isFunction$2(tr)) {
        tr(function(ir) {
          return Yt(ir || nr);
        }, {
          schema: _e,
          data: nr
        });
        return;
      }
      Yt(nr);
    };
  }, Zt = function() {
    if (isFunction$2(xt == null ? void 0 : xt.onClick)) {
      xt.onClick(function() {
        _.setSchemaByPath(tt, {
          hidden: !0
        });
      });
      return;
    }
    _.setSchemaByPath(tt, {
      hidden: !0
    });
  }, ar = ($ = ft == null ? void 0 : ft.listOperate) === null || $ === void 0 ? void 0 : $.btnType, Jt = [];
  return Mt || (Jt = [{
    validator: function(Yt, Kt) {
      return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime$1().mark(function nr() {
        var tr;
        return _regeneratorRuntime$1().wrap(function(sr) {
          for (; ; )
            switch (sr.prev = sr.next) {
              case 0:
                if (it(Kt), St != null && St.min) {
                  sr.next = 3;
                  break;
                }
                return sr.abrupt("return");
              case 3:
                if (!(!Kt || Kt.length < St.min)) {
                  sr.next = 5;
                  break;
                }
                return sr.abrupt("return", Promise.reject(new Error(((tr = St == null ? void 0 : St.message) === null || tr === void 0 ? void 0 : tr.min) || "数据长度必须大于等于".concat(St.min))));
              case 5:
              case "end":
                return sr.stop();
            }
        }, nr);
      }));
    }
  }].concat(_toConsumableArray$8(transformRules(Et || [], rt, _)))), /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(Form$3.List, {
    name: tt,
    initialValue: Dt,
    rules: Jt
  }, function(rr, Yt, Kt) {
    var nr = Kt.errors;
    return /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(vt, Object.assign({}, _t, {
      configContext: et,
      form: _,
      schema: St,
      fields: rr,
      operation: Yt,
      path: tt,
      listName: tt,
      parentLitPath: nt,
      rootPath: [].concat(_toConsumableArray$8(Lt), _toConsumableArray$8(tt)),
      readOnly: Mt,
      methods: rt,
      renderCore: at,
      widgets: ut,
      hideAdd: Ct,
      hideCopy: It,
      hideDelete: Rt,
      hideMove: yt,
      addItem: Ut(Yt.add),
      removeItem: Vt(Yt.remove),
      moveItem: Qt(Yt.move),
      copyItem: qt(Yt.add, rr),
      temporary: {
        displayType: $t
      },
      addBtnProps: Object.assign(Object.assign({}, gt), Ot),
      delConfirmProps: Object.assign(Object.assign({}, pt), Pt),
      actionColumnProps: Object.assign(Object.assign({}, mt), wt),
      copyBtnProps: {
        children: dt("copy"),
        btnType: ar
      },
      editorBtnProps: {
        children: dt("edit"),
        btnType: ar
      },
      deleteBtnProps: {
        children: dt("delete"),
        btnType: ar
      },
      moveUpBtnProps: {
        children: dt("moveUp"),
        btnType: ar
      },
      moveDownBtnProps: {
        children: dt("moveDown"),
        btnType: ar
      }
    })), (nr == null ? void 0 : nr.length) !== 0 && /* @__PURE__ */ React$a.createElement("div", {
      style: {
        marginBottom: "12px"
      }
    }, /* @__PURE__ */ React$a.createElement(Form$3.ErrorList, {
      errors: nr
    })));
  }), xt && /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({
    type: "link",
    danger: !0
  }, xt, {
    onClick: Zt
  }), (xt == null ? void 0 : xt.text) || dt("delete")));
};
function _toConsumableArray$7(a) {
  return _arrayWithoutHoles$7(a) || _iterableToArray$7(a) || _unsupportedIterableToArray$f(a) || _nonIterableSpread$7();
}
function _nonIterableSpread$7() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$7(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$7(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$f(a);
}
function _slicedToArray$d(a, s) {
  return _arrayWithHoles$d(a) || _iterableToArrayLimit$d(a, s) || _unsupportedIterableToArray$f(a, s) || _nonIterableRest$d();
}
function _nonIterableRest$d() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$f(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$f(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$f(a, s);
  }
}
function _arrayLikeToArray$f(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$d(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$d(a) {
  if (Array.isArray(a))
    return a;
}
var UpperContext = /* @__PURE__ */ reactExports.createContext(function() {
});
const Main = function(a) {
  var s = reactExports.useState([]), $ = _slicedToArray$d(s, 2);
  $[0];
  var _ = $[1], _e = a.configContext, tt = reactExports.useContext(FRContext), nt = useStore(tt, function(It) {
    return It.context;
  }), at = reactExports.useContext(UpperContext), ot = _e.form, rt = _e.widgets, st = _e.methods, lt = _e.globalConfig, et = nt.displayType, it = et === "column", ut = a.schema, ft = ot.getFieldsValue(!0), ht = tt.getState(), dt = ht.schema, gt = ut.items, pt = ut.className, mt = __rest$3(ut, ["items", "className"]), ct = lt != null && lt.mustacheDisabled ? ut : Object.assign({
    items: gt
  }, parseAllExpression(mt, ft, a.rootPath, dt)), vt = ct.widget, At = vt || "list1", xt = getParamValue(nt, at, ct), bt = getLabel(ct, et, rt), Et = getTooltip$3(ct, et), St = getFormListLayout(xt, et), Bt = St.labelCol, Ot = St.fieldCol, Pt = ct.display === "inline", wt = _toConsumableArray$7(a.rootPath || []).splice(0, a.rootPath.length - 1), Ct = ot.getFieldValue([].concat(_toConsumableArray$7(wt), _toConsumableArray$7(a.path)));
  return !(Ct != null && Ct.length) && At !== "drawerList" && (Pt = !0), ct.hidden ? null : /* @__PURE__ */ React$a.createElement(Col$1, {
    span: 24,
    className: pt
  }, !Pt && !it && bt && /* @__PURE__ */ React$a.createElement(Form$3.Item, {
    className: "ant-form-item-optional-hide",
    label: bt,
    labelAlign: "left",
    colon: !1,
    tooltip: Et,
    style: {
      marginBottom: 0
    },
    labelCol: {
      span: 24
    }
  }), /* @__PURE__ */ React$a.createElement(Form$3.Item, {
    label: bt,
    labelCol: it ? {
      span: 24
    } : Bt,
    wrapperCol: Ot,
    noStyle: !Pt && !it,
    tooltip: Et
  }, /* @__PURE__ */ React$a.createElement(Main$1, Object.assign({}, a, {
    form: ot,
    methods: st,
    formCtx: nt,
    upperCtx: at,
    widgets: rt,
    configContext: _e,
    setListData: _
  }))));
}, FieldList = function(a) {
  var s, $ = a.schema, _ = a.rootPath, _e = $ || {}, tt = _e.items, nt = __rest$3(_e, ["items"]), at = reactExports.useContext(FRContext), ot = at.getState(), rt = ot.schema, st = reactExports.useContext(ConfigContext), lt = (s = st == null ? void 0 : st.globalConfig) === null || s === void 0 ? void 0 : s.mustacheDisabled, et = $ == null ? void 0 : $.dependencies;
  return !isHasExpression($) && !lt && (!et || !(et != null && et.length)) ? /* @__PURE__ */ React$a.createElement(Main, Object.assign({
    configContext: st
  }, a)) : /* @__PURE__ */ React$a.createElement(Form$3.Item, {
    noStyle: !0,
    shouldUpdate: fieldShouldUpdate(JSON.stringify(nt || {}), _, et)
  }, function(it) {
    var ut = it.getFieldsValue(!0), ft = lt ? $ : parseAllExpression(nt, ut, _, rt);
    return /* @__PURE__ */ React$a.createElement(Main, Object.assign({
      configContext: st
    }, a, {
      schema: Object.assign({
        items: tt
      }, ft),
      rootPath: _
    }));
  });
};
function _slicedToArray$c(a, s) {
  return _arrayWithHoles$c(a) || _iterableToArrayLimit$c(a, s) || _unsupportedIterableToArray$e(a, s) || _nonIterableRest$c();
}
function _nonIterableRest$c() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$e(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$e(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$e(a, s);
  }
}
function _arrayLikeToArray$e(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$c(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$c(a) {
  if (Array.isArray(a))
    return a;
}
const sortProperties = function(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "order", $ = /* @__PURE__ */ new Map(), _ = [], _e = function(at) {
    var ot = _slicedToArray$c(at, 2), rt = ot[1];
    if (typeof rt[s] != "number") {
      _.push(at);
      return;
    }
    $.has(rt[s]) ? $.get(rt[s]).push(at) : $.set(rt[s], [at]);
  };
  a.forEach(function(nt) {
    return _e(nt);
  });
  var tt = Array.from($.entries()).sort(function(nt, at) {
    var ot = _slicedToArray$c(nt, 1), rt = ot[0], st = _slicedToArray$c(at, 1), lt = st[0];
    return rt - lt;
  }).flatMap(function(nt) {
    var at = _slicedToArray$c(nt, 2), ot = at[1];
    return ot;
  });
  return tt.concat(_);
};
function _toConsumableArray$6(a) {
  return _arrayWithoutHoles$6(a) || _iterableToArray$6(a) || _unsupportedIterableToArray$d(a) || _nonIterableSpread$6();
}
function _nonIterableSpread$6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$6(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$6(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$d(a);
}
function _slicedToArray$b(a, s) {
  return _arrayWithHoles$b(a) || _iterableToArrayLimit$b(a, s) || _unsupportedIterableToArray$d(a, s) || _nonIterableRest$b();
}
function _nonIterableRest$b() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$d(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$d(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$d(a, s);
  }
}
function _arrayLikeToArray$d(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$b(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$b(a) {
  if (Array.isArray(a))
    return a;
}
var renderItem = function a(s) {
  var $, _ = s.schema, _e = s.key, tt = s.path, nt = s.rootPath;
  if (_.type === "array" && (($ = _.items) === null || $ === void 0 ? void 0 : $.type) === "object")
    return /* @__PURE__ */ React$a.createElement(FieldList, {
      key: _e,
      schema: _,
      path: tt,
      rootPath: nt,
      renderCore: RenderCore
    });
  var at = null;
  return _ != null && _.properties && (_ == null ? void 0 : _.widgetType) !== "field" && (at = RenderCore({
    schema: _,
    parentPath: tt,
    rootPath: nt
  })), /* @__PURE__ */ React$a.createElement(FieldItem, {
    key: _e,
    schema: _,
    path: tt,
    rootPath: nt,
    children: at,
    renderCore: RenderCore
  });
}, RenderCore = function a(s) {
  var $ = s.schema, _ = s.parentPath, _e = _ === void 0 ? [] : _, tt = s.rootPath, nt = tt === void 0 ? [] : tt;
  return !$ || Object.keys($).length === 0 ? null : $ != null && $.items ? renderItem({
    schema: $.items,
    path: _e,
    rootPath: nt
  }) : sortProperties(Object.entries($.properties || {})).map(function(at) {
    var ot = _slicedToArray$b(at, 2), rt = ot[0], st = ot[1], lt = [].concat(_toConsumableArray$6(_e), [rt]);
    return renderItem({
      schema: st,
      path: lt,
      key: rt,
      rootPath: nt
    });
  });
};
function _typeof$k(a) {
  "@babel/helpers - typeof";
  return _typeof$k = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$k(a);
}
function _defineProperty$9(a, s, $) {
  return s = _toPropertyKey$5(s), s in a ? Object.defineProperty(a, s, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = $, a;
}
function _toPropertyKey$5(a) {
  var s = _toPrimitive$6(a, "string");
  return _typeof$k(s) === "symbol" ? s : String(s);
}
function _toPrimitive$6(a, s) {
  if (_typeof$k(a) !== "object" || a === null)
    return a;
  var $ = a[Symbol.toPrimitive];
  if ($ !== void 0) {
    var _ = $.call(a, s || "default");
    if (_typeof$k(_) !== "object")
      return _;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function() {
    return s;
  };
  var a, s = {}, $ = Object.prototype, _ = $.hasOwnProperty, _e = Object.defineProperty || function(Ct, It, yt) {
    Ct[It] = yt.value;
  }, tt = typeof Symbol == "function" ? Symbol : {}, nt = tt.iterator || "@@iterator", at = tt.asyncIterator || "@@asyncIterator", ot = tt.toStringTag || "@@toStringTag";
  function rt(Ct, It, yt) {
    return Object.defineProperty(Ct, It, { value: yt, enumerable: !0, configurable: !0, writable: !0 }), Ct[It];
  }
  try {
    rt({}, "");
  } catch {
    rt = function(yt, Rt, kt) {
      return yt[Rt] = kt;
    };
  }
  function st(Ct, It, yt, Rt) {
    var kt = It && It.prototype instanceof dt ? It : dt, jt = Object.create(kt.prototype), Ht = new Pt(Rt || []);
    return _e(jt, "_invoke", { value: Et(Ct, yt, Ht) }), jt;
  }
  function lt(Ct, It, yt) {
    try {
      return { type: "normal", arg: Ct.call(It, yt) };
    } catch (Rt) {
      return { type: "throw", arg: Rt };
    }
  }
  s.wrap = st;
  var et = "suspendedStart", it = "suspendedYield", ut = "executing", ft = "completed", ht = {};
  function dt() {
  }
  function gt() {
  }
  function pt() {
  }
  var mt = {};
  rt(mt, nt, function() {
    return this;
  });
  var ct = Object.getPrototypeOf, vt = ct && ct(ct(wt([])));
  vt && vt !== $ && _.call(vt, nt) && (mt = vt);
  var At = pt.prototype = dt.prototype = Object.create(mt);
  function xt(Ct) {
    ["next", "throw", "return"].forEach(function(It) {
      rt(Ct, It, function(yt) {
        return this._invoke(It, yt);
      });
    });
  }
  function bt(Ct, It) {
    function yt(kt, jt, Ht, Ft) {
      var _t = lt(Ct[kt], Ct, jt);
      if (_t.type !== "throw") {
        var Nt = _t.arg, Mt = Nt.value;
        return Mt && _typeof$k(Mt) == "object" && _.call(Mt, "__await") ? It.resolve(Mt.__await).then(function(Lt) {
          yt("next", Lt, Ht, Ft);
        }, function(Lt) {
          yt("throw", Lt, Ht, Ft);
        }) : It.resolve(Mt).then(function(Lt) {
          Nt.value = Lt, Ht(Nt);
        }, function(Lt) {
          return yt("throw", Lt, Ht, Ft);
        });
      }
      Ft(_t.arg);
    }
    var Rt;
    _e(this, "_invoke", { value: function(jt, Ht) {
      function Ft() {
        return new It(function(_t, Nt) {
          yt(jt, Ht, _t, Nt);
        });
      }
      return Rt = Rt ? Rt.then(Ft, Ft) : Ft();
    } });
  }
  function Et(Ct, It, yt) {
    var Rt = et;
    return function(kt, jt) {
      if (Rt === ut)
        throw new Error("Generator is already running");
      if (Rt === ft) {
        if (kt === "throw")
          throw jt;
        return { value: a, done: !0 };
      }
      for (yt.method = kt, yt.arg = jt; ; ) {
        var Ht = yt.delegate;
        if (Ht) {
          var Ft = St(Ht, yt);
          if (Ft) {
            if (Ft === ht)
              continue;
            return Ft;
          }
        }
        if (yt.method === "next")
          yt.sent = yt._sent = yt.arg;
        else if (yt.method === "throw") {
          if (Rt === et)
            throw Rt = ft, yt.arg;
          yt.dispatchException(yt.arg);
        } else
          yt.method === "return" && yt.abrupt("return", yt.arg);
        Rt = ut;
        var _t = lt(Ct, It, yt);
        if (_t.type === "normal") {
          if (Rt = yt.done ? ft : it, _t.arg === ht)
            continue;
          return { value: _t.arg, done: yt.done };
        }
        _t.type === "throw" && (Rt = ft, yt.method = "throw", yt.arg = _t.arg);
      }
    };
  }
  function St(Ct, It) {
    var yt = It.method, Rt = Ct.iterator[yt];
    if (Rt === a)
      return It.delegate = null, yt === "throw" && Ct.iterator.return && (It.method = "return", It.arg = a, St(Ct, It), It.method === "throw") || yt !== "return" && (It.method = "throw", It.arg = new TypeError("The iterator does not provide a '" + yt + "' method")), ht;
    var kt = lt(Rt, Ct.iterator, It.arg);
    if (kt.type === "throw")
      return It.method = "throw", It.arg = kt.arg, It.delegate = null, ht;
    var jt = kt.arg;
    return jt ? jt.done ? (It[Ct.resultName] = jt.value, It.next = Ct.nextLoc, It.method !== "return" && (It.method = "next", It.arg = a), It.delegate = null, ht) : jt : (It.method = "throw", It.arg = new TypeError("iterator result is not an object"), It.delegate = null, ht);
  }
  function Bt(Ct) {
    var It = { tryLoc: Ct[0] };
    1 in Ct && (It.catchLoc = Ct[1]), 2 in Ct && (It.finallyLoc = Ct[2], It.afterLoc = Ct[3]), this.tryEntries.push(It);
  }
  function Ot(Ct) {
    var It = Ct.completion || {};
    It.type = "normal", delete It.arg, Ct.completion = It;
  }
  function Pt(Ct) {
    this.tryEntries = [{ tryLoc: "root" }], Ct.forEach(Bt, this), this.reset(!0);
  }
  function wt(Ct) {
    if (Ct || Ct === "") {
      var It = Ct[nt];
      if (It)
        return It.call(Ct);
      if (typeof Ct.next == "function")
        return Ct;
      if (!isNaN(Ct.length)) {
        var yt = -1, Rt = function kt() {
          for (; ++yt < Ct.length; )
            if (_.call(Ct, yt))
              return kt.value = Ct[yt], kt.done = !1, kt;
          return kt.value = a, kt.done = !0, kt;
        };
        return Rt.next = Rt;
      }
    }
    throw new TypeError(_typeof$k(Ct) + " is not iterable");
  }
  return gt.prototype = pt, _e(At, "constructor", { value: pt, configurable: !0 }), _e(pt, "constructor", { value: gt, configurable: !0 }), gt.displayName = rt(pt, ot, "GeneratorFunction"), s.isGeneratorFunction = function(Ct) {
    var It = typeof Ct == "function" && Ct.constructor;
    return !!It && (It === gt || (It.displayName || It.name) === "GeneratorFunction");
  }, s.mark = function(Ct) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(Ct, pt) : (Ct.__proto__ = pt, rt(Ct, ot, "GeneratorFunction")), Ct.prototype = Object.create(At), Ct;
  }, s.awrap = function(Ct) {
    return { __await: Ct };
  }, xt(bt.prototype), rt(bt.prototype, at, function() {
    return this;
  }), s.AsyncIterator = bt, s.async = function(Ct, It, yt, Rt, kt) {
    kt === void 0 && (kt = Promise);
    var jt = new bt(st(Ct, It, yt, Rt), kt);
    return s.isGeneratorFunction(It) ? jt : jt.next().then(function(Ht) {
      return Ht.done ? Ht.value : jt.next();
    });
  }, xt(At), rt(At, ot, "Generator"), rt(At, nt, function() {
    return this;
  }), rt(At, "toString", function() {
    return "[object Generator]";
  }), s.keys = function(Ct) {
    var It = Object(Ct), yt = [];
    for (var Rt in It)
      yt.push(Rt);
    return yt.reverse(), function kt() {
      for (; yt.length; ) {
        var jt = yt.pop();
        if (jt in It)
          return kt.value = jt, kt.done = !1, kt;
      }
      return kt.done = !0, kt;
    };
  }, s.values = wt, Pt.prototype = { constructor: Pt, reset: function(It) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = a, this.done = !1, this.delegate = null, this.method = "next", this.arg = a, this.tryEntries.forEach(Ot), !It)
      for (var yt in this)
        yt.charAt(0) === "t" && _.call(this, yt) && !isNaN(+yt.slice(1)) && (this[yt] = a);
  }, stop: function() {
    this.done = !0;
    var It = this.tryEntries[0].completion;
    if (It.type === "throw")
      throw It.arg;
    return this.rval;
  }, dispatchException: function(It) {
    if (this.done)
      throw It;
    var yt = this;
    function Rt(Nt, Mt) {
      return Ht.type = "throw", Ht.arg = It, yt.next = Nt, Mt && (yt.method = "next", yt.arg = a), !!Mt;
    }
    for (var kt = this.tryEntries.length - 1; kt >= 0; --kt) {
      var jt = this.tryEntries[kt], Ht = jt.completion;
      if (jt.tryLoc === "root")
        return Rt("end");
      if (jt.tryLoc <= this.prev) {
        var Ft = _.call(jt, "catchLoc"), _t = _.call(jt, "finallyLoc");
        if (Ft && _t) {
          if (this.prev < jt.catchLoc)
            return Rt(jt.catchLoc, !0);
          if (this.prev < jt.finallyLoc)
            return Rt(jt.finallyLoc);
        } else if (Ft) {
          if (this.prev < jt.catchLoc)
            return Rt(jt.catchLoc, !0);
        } else {
          if (!_t)
            throw new Error("try statement without catch or finally");
          if (this.prev < jt.finallyLoc)
            return Rt(jt.finallyLoc);
        }
      }
    }
  }, abrupt: function(It, yt) {
    for (var Rt = this.tryEntries.length - 1; Rt >= 0; --Rt) {
      var kt = this.tryEntries[Rt];
      if (kt.tryLoc <= this.prev && _.call(kt, "finallyLoc") && this.prev < kt.finallyLoc) {
        var jt = kt;
        break;
      }
    }
    jt && (It === "break" || It === "continue") && jt.tryLoc <= yt && yt <= jt.finallyLoc && (jt = null);
    var Ht = jt ? jt.completion : {};
    return Ht.type = It, Ht.arg = yt, jt ? (this.method = "next", this.next = jt.finallyLoc, ht) : this.complete(Ht);
  }, complete: function(It, yt) {
    if (It.type === "throw")
      throw It.arg;
    return It.type === "break" || It.type === "continue" ? this.next = It.arg : It.type === "return" ? (this.rval = this.arg = It.arg, this.method = "return", this.next = "end") : It.type === "normal" && yt && (this.next = yt), ht;
  }, finish: function(It) {
    for (var yt = this.tryEntries.length - 1; yt >= 0; --yt) {
      var Rt = this.tryEntries[yt];
      if (Rt.finallyLoc === It)
        return this.complete(Rt.completion, Rt.afterLoc), Ot(Rt), ht;
    }
  }, catch: function(It) {
    for (var yt = this.tryEntries.length - 1; yt >= 0; --yt) {
      var Rt = this.tryEntries[yt];
      if (Rt.tryLoc === It) {
        var kt = Rt.completion;
        if (kt.type === "throw") {
          var jt = kt.arg;
          Ot(Rt);
        }
        return jt;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(It, yt, Rt) {
    return this.delegate = { iterator: wt(It), resultName: yt, nextLoc: Rt }, this.method === "next" && (this.arg = a), ht;
  } }, s;
}
var FormCore = function a(s) {
  var $, _, _e, tt, nt, at = reactExports.useContext(FRContext), ot = useStore(at, function(Vt) {
    return Vt.schema;
  }), rt = useStore(at, function(Vt) {
    return Vt.flattenSchema;
  }), st = useStore(at, function(Vt) {
    return Vt.setContext;
  }), lt = reactExports.useContext(ThemeConfigProvider.ConfigContext), et = translation$1(lt), it = ot || {};
  it.type, it.properties;
  var ut = __rest$3(it, ["type", "properties"]), ft = transformProps(Object.assign(Object.assign({}, s), ut)), ht = ft.formProps, dt = ft.displayType, gt = ft.beforeFinish, pt = ft.watch, mt = ft.onMount, ct = ft.column, vt = ft.labelWidth, At = ft.labelCol, xt = ft.fieldCol, bt = ft.maxWidth, Et = ft.form, St = ft.onFinish, Bt = ft.onFinishFailed, Ot = ft.readOnly, Pt = ft.disabled, wt = ft.footer, Ct = ft.removeHiddenData, It = ft.operateExtra, yt = ft.logOnMount, Rt = ft.logOnSubmit, kt = ft.id, jt = ft.className, Ht = ft.validateTrigger, Ft = ft.antdVersion;
  reactExports.useEffect(function() {
    Et.__initStore(at), setTimeout(_t, 0), window.antdVersion = Ft;
  }, []), reactExports.useEffect(function() {
    Et.setSchema(s.schema, !0);
  }, [JSON.stringify(s.schema || {})]), reactExports.useEffect(function() {
    at.setState({
      removeHiddenData: Ct
    });
  }, [Ct]), reactExports.useEffect(function() {
    var Vt = {
      column: ct,
      readOnly: Ot,
      disabled: Pt,
      labelWidth: vt,
      displayType: dt,
      labelCol: At,
      fieldCol: xt,
      maxWidth: bt,
      validateTrigger: Ht
    };
    st(Vt);
  }, [ct, At, xt, dt, vt, bt, Ot, Pt, Ht]);
  var _t = function() {
    return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime().mark(function Qt() {
      return _regeneratorRuntime().wrap(function(Zt) {
        for (; ; )
          switch (Zt.prev = Zt.next) {
            case 0:
              if (Zt.t0 = mt, !Zt.t0) {
                Zt.next = 4;
                break;
              }
              return Zt.next = 4, mt();
            case 4:
              Nt(), setTimeout(function() {
                var ar = Et.getValues();
                immediateWatch(pt, ar);
              }, 0);
            case 6:
            case "end":
              return Zt.stop();
          }
      }, Qt);
    }));
  }, Nt = function() {
    var Qt = (/* @__PURE__ */ new Date()).getTime();
    if ((isFunction$2(yt) || isFunction$2(Rt)) && (setSessionItem("FORM_MOUNT_TIME", Qt), setSessionItem("FORM_START", Qt)), isFunction$2(yt)) {
      var qt = {
        schema: s.schema,
        url: location.href,
        formData: JSON.stringify(Et.getValues()),
        formMount: yymmdd(Qt)
      };
      kt && (qt.id = kt), yt(qt);
    }
    isFunction$2(Rt) && (setSessionItem("NUMBER_OF_SUBMITS", 0), setSessionItem("FAILED_ATTEMPTS", 0));
  }, Mt = function(Qt) {
    if (isFunction$2(Rt)) {
      var qt = getSessionItem("FORM_START"), Zt = getSessionItem("FORM_MOUNT_TIME"), ar = getSessionItem("NUMBER_OF_SUBMITS") + 1, Jt = (/* @__PURE__ */ new Date()).getTime(), rr = getSessionItem("FAILED_ATTEMPTS");
      Qt.errorFields.length > 0 && (rr = rr + 1);
      var Yt = {
        formMount: yymmdd(Zt),
        ms: Jt - qt,
        duration: msToTime(Jt - qt),
        numberOfSubmits: ar,
        failedAttempts: rr,
        url: location.href,
        formData: JSON.stringify(Qt.values),
        errors: JSON.stringify(Qt.errorFields),
        schema: JSON.stringify(ot)
      };
      kt && (Yt.id = kt), Rt(Yt), setSessionItem("FORM_START", Jt), setSessionItem("NUMBER_OF_SUBMITS", ar), setSessionItem("FAILED_ATTEMPTS", rr);
    }
  }, Lt = function(Qt, qt) {
    var Zt = filterValuesUndefined(qt, !0);
    valuesWatch(Qt, Zt, pt);
  }, $t = function(Qt) {
    var qt = cloneDeep(Qt);
    return qt = Ct ? filterValuesHidden(qt, rt) : cloneDeep(Et.getFieldsValue(!0)), qt = parseValuesToBind(qt, rt), qt = filterValuesUndefined(qt), qt;
  }, Tt = function(Qt) {
    return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime().mark(function qt() {
      var Zt, ar;
      return _regeneratorRuntime().wrap(function(rr) {
        for (; ; )
          switch (rr.prev = rr.next) {
            case 0:
              if (Zt = $t(Qt), !gt) {
                rr.next = 7;
                break;
              }
              return rr.next = 4, gt({
                data: Zt,
                schema: ot,
                errors: []
              });
            case 4:
              rr.t0 = rr.sent, rr.next = 8;
              break;
            case 7:
              rr.t0 = null;
            case 8:
              if (ar = rr.t0, !((ar == null ? void 0 : ar.length) > 0)) {
                rr.next = 12;
                break;
              }
              return Et.setFields(ar), rr.abrupt("return");
            case 12:
              Mt({
                values: Zt
              }), St && St(Zt, []);
            case 14:
            case "end":
              return rr.stop();
          }
      }, qt);
    }));
  }, Dt = function(Qt) {
    return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ _regeneratorRuntime().mark(function qt() {
      var Zt;
      return _regeneratorRuntime().wrap(function(Jt) {
        for (; ; )
          switch (Jt.prev = Jt.next) {
            case 0:
              if (Zt = $t(Qt.values), Mt(Object.assign(Object.assign({}, Qt), {
                values: Zt
              })), Bt) {
                Jt.next = 4;
                break;
              }
              return Jt.abrupt("return");
            case 4:
              Bt(Object.assign(Object.assign({}, Qt), {
                values: Zt
              }));
            case 5:
            case "end":
              return Jt.stop();
          }
      }, qt);
    }));
  }, Ut = ($ = getFormItemLayout(ct, {}, {
    labelWidth: vt
  })) === null || $ === void 0 ? void 0 : $.labelCol;
  return /* @__PURE__ */ React$a.createElement(Form$3, Object.assign({
    className: classnames("fr-form", _defineProperty$9({}, jt, !!jt)),
    labelWrap: !0
  }, ht, {
    disabled: Pt,
    form: Et,
    onFinish: Tt,
    onFinishFailed: Dt,
    onValuesChange: Lt
  }), /* @__PURE__ */ React$a.createElement(Row$1, {
    gutter: dt === "row" ? 16 : 24
  }, /* @__PURE__ */ React$a.createElement(RenderCore, {
    schema: ot
  }), It), ot && !!wt && /* @__PURE__ */ React$a.createElement(Row$1, {
    gutter: dt === "row" ? 16 : 24
  }, /* @__PURE__ */ React$a.createElement(Col$1, {
    span: 24 / ct
  }, /* @__PURE__ */ React$a.createElement(Form$3.Item, {
    label: dt !== "column" ? "hideLabel" : null,
    labelCol: Ut,
    className: "fr-hide-label"
  }, isFunction$2(wt) ? /* @__PURE__ */ React$a.createElement(_Space, null, wt()) : /* @__PURE__ */ React$a.createElement(_Space, null, !(!((_ = wt == null ? void 0 : wt.reset) === null || _ === void 0) && _.hide) && /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({}, wt == null ? void 0 : wt.reset, {
    onClick: function() {
      return Et.resetFields();
    }
  }), ((_e = wt == null ? void 0 : wt.reset) === null || _e === void 0 ? void 0 : _e.text) || et("reset")), !(!((tt = wt == null ? void 0 : wt.submit) === null || tt === void 0) && tt.hide) && /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({
    type: "primary",
    onClick: Et.submit
  }, wt == null ? void 0 : wt.submit), ((nt = wt == null ? void 0 : wt.submit) === null || nt === void 0 ? void 0 : nt.text) || et("submit")))))));
}, zh_CN$5 = {}, interopRequireDefault = { exports: {} };
(function(a) {
  function s($) {
    return $ && $.__esModule ? $ : {
      default: $
    };
  }
  a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports, zh_CN$4 = {};
Object.defineProperty(zh_CN$4, "__esModule", {
  value: !0
});
zh_CN$4.default = void 0;
var locale$7 = {
  // Options
  items_per_page: "条/页",
  jump_to: "跳至",
  jump_to_confirm: "确定",
  page: "页",
  // Pagination
  prev_page: "上一页",
  next_page: "下一页",
  prev_5: "向前 5 页",
  next_5: "向后 5 页",
  prev_3: "向前 3 页",
  next_3: "向后 3 页",
  page_size: "页码"
};
zh_CN$4.default = locale$7;
var zh_CN$3 = {}, zh_CN$2 = {}, zh_CN$1 = {};
Object.defineProperty(zh_CN$1, "__esModule", {
  value: !0
});
zh_CN$1.default = void 0;
var locale$6 = {
  locale: "zh_CN",
  today: "今天",
  now: "此刻",
  backToToday: "返回今天",
  ok: "确定",
  timeSelect: "选择时间",
  dateSelect: "选择日期",
  weekSelect: "选择周",
  clear: "清除",
  month: "月",
  year: "年",
  previousMonth: "上个月 (翻页上键)",
  nextMonth: "下个月 (翻页下键)",
  monthSelect: "选择月份",
  yearSelect: "选择年份",
  decadeSelect: "选择年代",
  yearFormat: "YYYY年",
  dayFormat: "D日",
  dateFormat: "YYYY年M月D日",
  dateTimeFormat: "YYYY年M月D日 HH时mm分ss秒",
  previousYear: "上一年 (Control键加左方向键)",
  nextYear: "下一年 (Control键加右方向键)",
  previousDecade: "上一年代",
  nextDecade: "下一年代",
  previousCentury: "上一世纪",
  nextCentury: "下一世纪"
};
zh_CN$1.default = locale$6;
var zh_CN = {};
Object.defineProperty(zh_CN, "__esModule", {
  value: !0
});
zh_CN.default = void 0;
const locale$5 = {
  placeholder: "请选择时间",
  rangePlaceholder: ["开始时间", "结束时间"]
};
zh_CN.default = locale$5;
var _interopRequireDefault$n = interopRequireDefaultExports.default;
Object.defineProperty(zh_CN$2, "__esModule", {
  value: !0
});
zh_CN$2.default = void 0;
var _zh_CN$2 = _interopRequireDefault$n(zh_CN$1), _zh_CN2$1 = _interopRequireDefault$n(zh_CN);
const locale$4 = {
  lang: Object.assign({
    placeholder: "请选择日期",
    yearPlaceholder: "请选择年份",
    quarterPlaceholder: "请选择季度",
    monthPlaceholder: "请选择月份",
    weekPlaceholder: "请选择周",
    rangePlaceholder: ["开始日期", "结束日期"],
    rangeYearPlaceholder: ["开始年份", "结束年份"],
    rangeMonthPlaceholder: ["开始月份", "结束月份"],
    rangeQuarterPlaceholder: ["开始季度", "结束季度"],
    rangeWeekPlaceholder: ["开始周", "结束周"]
  }, _zh_CN$2.default),
  timePickerLocale: Object.assign({}, _zh_CN2$1.default)
};
locale$4.lang.ok = "确定";
zh_CN$2.default = locale$4;
var _interopRequireDefault$m = interopRequireDefaultExports.default;
Object.defineProperty(zh_CN$3, "__esModule", {
  value: !0
});
zh_CN$3.default = void 0;
var _zh_CN$1 = _interopRequireDefault$m(zh_CN$2);
zh_CN$3.default = _zh_CN$1.default;
var _interopRequireDefault$l = interopRequireDefaultExports.default;
Object.defineProperty(zh_CN$5, "__esModule", {
  value: !0
});
var default_1$a = zh_CN$5.default = void 0, _zh_CN = _interopRequireDefault$l(zh_CN$4), _zh_CN2 = _interopRequireDefault$l(zh_CN$3), _zh_CN3 = _interopRequireDefault$l(zh_CN$2), _zh_CN4 = _interopRequireDefault$l(zh_CN);
const typeTemplate$2 = "${label}不是一个有效的${type}", localeValues$1 = {
  locale: "zh-cn",
  Pagination: _zh_CN.default,
  DatePicker: _zh_CN3.default,
  TimePicker: _zh_CN4.default,
  Calendar: _zh_CN2.default,
  // locales for all components
  global: {
    placeholder: "请选择"
  },
  Table: {
    filterTitle: "筛选",
    filterConfirm: "确定",
    filterReset: "重置",
    filterEmptyText: "无筛选项",
    filterCheckall: "全选",
    filterSearchPlaceholder: "在筛选项中搜索",
    selectAll: "全选当页",
    selectInvert: "反选当页",
    selectNone: "清空所有",
    selectionAll: "全选所有",
    sortTitle: "排序",
    expand: "展开行",
    collapse: "关闭行",
    triggerDesc: "点击降序",
    triggerAsc: "点击升序",
    cancelSort: "取消排序"
  },
  Modal: {
    okText: "确定",
    cancelText: "取消",
    justOkText: "知道了"
  },
  Tour: {
    Next: "下一步",
    Previous: "上一步",
    Finish: "结束导览"
  },
  Popconfirm: {
    cancelText: "取消",
    okText: "确定"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "请输入搜索内容",
    itemUnit: "项",
    itemsUnit: "项",
    remove: "删除",
    selectCurrent: "全选当页",
    removeCurrent: "删除当页",
    selectAll: "全选所有",
    removeAll: "删除全部",
    selectInvert: "反选当页"
  },
  Upload: {
    uploading: "文件上传中",
    removeFile: "删除文件",
    uploadError: "上传错误",
    previewFile: "预览文件",
    downloadFile: "下载文件"
  },
  Empty: {
    description: "暂无数据"
  },
  Icon: {
    icon: "图标"
  },
  Text: {
    edit: "编辑",
    copy: "复制",
    copied: "复制成功",
    expand: "展开"
  },
  PageHeader: {
    back: "返回"
  },
  Form: {
    optional: "（可选）",
    defaultValidateMessages: {
      default: "字段验证错误${label}",
      required: "请输入${label}",
      enum: "${label}必须是其中一个[${enum}]",
      whitespace: "${label}不能为空字符",
      date: {
        format: "${label}日期格式无效",
        parse: "${label}不能转换为日期",
        invalid: "${label}是一个无效日期"
      },
      types: {
        string: typeTemplate$2,
        method: typeTemplate$2,
        array: typeTemplate$2,
        object: typeTemplate$2,
        number: typeTemplate$2,
        date: typeTemplate$2,
        boolean: typeTemplate$2,
        integer: typeTemplate$2,
        float: typeTemplate$2,
        regexp: typeTemplate$2,
        email: typeTemplate$2,
        url: typeTemplate$2,
        hex: typeTemplate$2
      },
      string: {
        len: "${label}须为${len}个字符",
        min: "${label}最少${min}个字符",
        max: "${label}最多${max}个字符",
        range: "${label}须在${min}-${max}字符之间"
      },
      number: {
        len: "${label}必须等于${len}",
        min: "${label}最小值为${min}",
        max: "${label}最大值为${max}",
        range: "${label}须在${min}-${max}之间"
      },
      array: {
        len: "须为${len}个${label}",
        min: "最少${min}个${label}",
        max: "最多${max}个${label}",
        range: "${label}数量须在${min}-${max}之间"
      },
      pattern: {
        mismatch: "${label}与模式不匹配${pattern}"
      }
    }
  },
  Image: {
    preview: "预览"
  },
  QRCode: {
    expired: "二维码过期",
    refresh: "点击刷新"
  },
  ColorPicker: {
    presetEmpty: "暂无"
  }
};
default_1$a = zh_CN$5.default = localeValues$1;
var en_US$5 = {}, en_US$4 = {};
Object.defineProperty(en_US$4, "__esModule", {
  value: !0
});
en_US$4.default = void 0;
var locale$3 = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
};
en_US$4.default = locale$3;
var en_US$3 = {}, en_US$2 = {}, en_US$1 = {};
Object.defineProperty(en_US$1, "__esModule", {
  value: !0
});
en_US$1.default = void 0;
var locale$2 = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
en_US$1.default = locale$2;
var en_US = {};
Object.defineProperty(en_US, "__esModule", {
  value: !0
});
en_US.default = void 0;
const locale$1 = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
};
en_US.default = locale$1;
var _interopRequireDefault$k = interopRequireDefaultExports.default;
Object.defineProperty(en_US$2, "__esModule", {
  value: !0
});
en_US$2.default = void 0;
var _en_US$2 = _interopRequireDefault$k(en_US$1), _en_US2$1 = _interopRequireDefault$k(en_US);
const locale = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, _en_US$2.default),
  timePickerLocale: Object.assign({}, _en_US2$1.default)
};
en_US$2.default = locale;
var _interopRequireDefault$j = interopRequireDefaultExports.default;
Object.defineProperty(en_US$3, "__esModule", {
  value: !0
});
en_US$3.default = void 0;
var _en_US$1 = _interopRequireDefault$j(en_US$2);
en_US$3.default = _en_US$1.default;
var _interopRequireDefault$i = interopRequireDefaultExports.default;
Object.defineProperty(en_US$5, "__esModule", {
  value: !0
});
var default_1$9 = en_US$5.default = void 0, _en_US = _interopRequireDefault$i(en_US$4), _en_US2 = _interopRequireDefault$i(en_US$3), _en_US3 = _interopRequireDefault$i(en_US$2), _en_US4 = _interopRequireDefault$i(en_US);
const typeTemplate$1 = "${label} is not a valid ${type}", localeValues = {
  locale: "en",
  Pagination: _en_US.default,
  DatePicker: _en_US3.default,
  TimePicker: _en_US4.default,
  Calendar: _en_US2.default,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  PageHeader: {
    back: "Back"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: typeTemplate$1,
        method: typeTemplate$1,
        array: typeTemplate$1,
        object: typeTemplate$1,
        number: typeTemplate$1,
        date: typeTemplate$1,
        boolean: typeTemplate$1,
        integer: typeTemplate$1,
        float: typeTemplate$1,
        regexp: typeTemplate$1,
        email: typeTemplate$1,
        url: typeTemplate$1,
        hex: typeTemplate$1
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh"
  },
  ColorPicker: {
    presetEmpty: "Empty"
  }
};
default_1$9 = en_US$5.default = localeValues;
const enUS = {
  copy_max_tip: "The maximum number of table items has been reached and cannot be copied",
  copy: "Copy",
  add_item: "Add a new line",
  confirm_delete: "Are you sure to delete?",
  confirm: "Yes",
  cancel: "No",
  operate: "Operate",
  delete: "Delete",
  edit: "Edit",
  img_src_error: "Image address error",
  upload: "Upload",
  upload_success: "upload success",
  upload_fail: "upload failed",
  uploaded_address: "Uploaded address",
  test_src: "Test address",
  schema_not_match: "Schema does not match the display component：",
  item: "Item",
  search: "Search",
  reset: "Reset",
  expand: "Expand",
  fold: "Fold",
  submit: "Submit",
  save: "Save",
  moveDown: "Move Down",
  moveUp: "Move Up"
}, zhCN = {
  copy_max_tip: "已达表单项数量上限，无法复制！",
  copy: "复制",
  add_item: "新增一条",
  confirm_delete: "确定删除?",
  confirm: "确定",
  cancel: "取消",
  operate: "操作",
  delete: "删除",
  edit: "编辑",
  img_src_error: "图片地址错误",
  upload: "上传",
  upload_success: "上传成功",
  upload_fail: "上传失败",
  uploaded_address: "已上传地址",
  test_src: "测试链接",
  schema_not_match: "schema未匹配到展示组件：",
  item: "项目",
  search: "查询",
  reset: "重置",
  expand: "展开",
  fold: "收起",
  submit: "提交",
  save: "保存",
  moveDown: "下移",
  moveUp: "上移"
}, locales = {
  "en-US": enUS,
  "zh-CN": zhCN
};
var zhCn = { exports: {} };
(function(a, s) {
  (function($, _) {
    a.exports = _(dayjs_minExports);
  })(commonjsGlobal, function($) {
    function _(nt) {
      return nt && typeof nt == "object" && "default" in nt ? nt : { default: nt };
    }
    var _e = _($), tt = { name: "zh-cn", weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"), weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"), weekdaysMin: "日_一_二_三_四_五_六".split("_"), months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(nt, at) {
      return at === "W" ? nt + "周" : nt + "日";
    }, weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日Ah点mm分", LLLL: "YYYY年M月D日ddddAh点mm分", l: "YYYY/M/D", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日dddd HH:mm" }, relativeTime: { future: "%s内", past: "%s前", s: "几秒", m: "1 分钟", mm: "%d 分钟", h: "1 小时", hh: "%d 小时", d: "1 天", dd: "%d 天", M: "1 个月", MM: "%d 个月", y: "1 年", yy: "%d 年" }, meridiem: function(nt, at) {
      var ot = 100 * nt + at;
      return ot < 600 ? "凌晨" : ot < 900 ? "早上" : ot < 1100 ? "上午" : ot < 1300 ? "中午" : ot < 1800 ? "下午" : "晚上";
    } };
    return _e.default.locale(tt, null, !0), tt;
  });
})(zhCn);
var createStore = function a() {
  return createStore$1(function(s, $) {
    return {
      initialized: !1,
      schema: {},
      flattenSchema: {},
      context: {},
      init: function(_e) {
        return s(Object.assign({
          initialized: !0
        }, _e));
      },
      setContext: function(_e) {
        return s({
          context: _e
        });
      }
    };
  });
}, typeTemplate = "'${label}' is not a valid ${type}", typeTemplateCN = "数据类型必须是 ${type}", validateMessagesEN = {
  default: "Validation error on field '${label}'",
  required: "'${label}' is required",
  enum: "'${label}' must be one of [${enum}]",
  whitespace: "'${label}' cannot be empty",
  date: {
    format: "'${label}' is invalid for format date",
    parse: "'${label}' could not be parsed as date",
    invalid: "'${label}' is invalid date"
  },
  types: {
    string: typeTemplate,
    method: typeTemplate,
    array: typeTemplate,
    object: typeTemplate,
    number: typeTemplate,
    date: typeTemplate,
    boolean: typeTemplate,
    integer: typeTemplate,
    float: typeTemplate,
    regexp: typeTemplate,
    email: typeTemplate,
    url: typeTemplate,
    hex: typeTemplate
  },
  string: {
    len: "'${label}' must be exactly ${len} characters",
    min: "'${label}' must be at least ${min} characters",
    max: "'${label}' cannot be longer than ${max} characters",
    range: "'${label}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${label}' must equal ${len}",
    min: "'${label}' cannot be less than ${min}",
    max: "'${label}' cannot be greater than ${max}",
    range: "'${label}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${label}' must be exactly ${len} in length",
    min: "'${label}' cannot be less than ${min} in length",
    max: "'${label}' cannot be greater than ${max} in length",
    range: "'${label}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${label}' does not match pattern ${pattern}"
  }
}, validateMessagesCN = {
  default: "${label}未通过校验",
  required: "${label}必填",
  whitespace: "${label}不能为空",
  date: {
    format: "${label}的格式错误",
    parse: "${label}无法被解析",
    invalid: "${label}数据不合法"
  },
  types: {
    string: typeTemplateCN,
    method: typeTemplateCN,
    array: typeTemplateCN,
    object: typeTemplateCN,
    number: typeTemplateCN,
    date: typeTemplateCN,
    boolean: typeTemplateCN,
    integer: typeTemplateCN,
    float: typeTemplateCN,
    regexp: typeTemplateCN,
    email: typeTemplateCN,
    url: typeTemplateCN,
    hex: typeTemplateCN
  },
  string: {
    len: "${label}长度不是${len}",
    min: "${label}长度不能小于${min}",
    max: "${label}长度不能大于${max}",
    range: "${label}长度需在${min}与${max}之间"
  },
  number: {
    len: "${label}不等于${len}",
    min: "${label}不能小于${min}",
    max: "${label}不能大于${max}",
    range: "${label}需在${min}与${max}之间"
  },
  array: {
    len: "${label}长度不是${len}",
    min: "${label}长度不能小于${min}",
    max: "${label}长度不能大于${max}",
    range: "${label}长度需在${min}与${max}之间"
  },
  pattern: {
    mismatch: "${label}未通过正则判断${pattern}"
  }
};
function withProvider(a, s) {
  return function($) {
    var _ = $.configProvider, _e = $.locale, tt = _e === void 0 ? "zh-CN" : _e, nt = $.widgets, at = $.methods, ot = $.form, rt = $.validateMessages, st = $.globalProps, lt = st === void 0 ? {} : st, et = $.globalConfig, it = et === void 0 ? {} : et, ut = __rest$3($, ["configProvider", "locale", "widgets", "methods", "form", "validateMessages", "globalProps", "globalConfig"]), ft = reactExports.useRef(createStore()), ht = ft.current;
    if (reactExports.useEffect(function() {
      if (tt === "en-US") {
        dayjs.locale("en");
        return;
      }
      dayjs.locale("zh-cn");
    }, [tt]), useUnmount$1(function() {
      ot.resetFields();
    }), !ot)
      return console.warn("Please provide a form instance to FormRender"), null;
    var dt = tt === "zh-CN" ? default_1$a : default_1$9, gt = tt === "zh-CN" ? validateMessagesCN : validateMessagesEN, pt = {
      locale: tt,
      widgets: Object.assign(Object.assign({}, s), nt),
      methods: at,
      form: ot,
      globalProps: lt,
      globalConfig: it
    }, mt = Object.assign(Object.assign(Object.assign({}, dt), {
      FormRender: locales[tt]
    }), _ == null ? void 0 : _.locale);
    return /* @__PURE__ */ React$a.createElement(ThemeConfigProvider, Object.assign({}, _, {
      locale: mt,
      form: {
        validateMessages: Object.assign(Object.assign({}, gt), rt)
      }
    }), /* @__PURE__ */ React$a.createElement(ConfigContext.Provider, {
      value: pt
    }, /* @__PURE__ */ React$a.createElement(FRContext.Provider, {
      value: ht
    }, /* @__PURE__ */ React$a.createElement(a, Object.assign({
      form: ot
    }, ut)))));
  };
}
var getProps = function a(s, $) {
  var _ = {};
  return Object.keys(s).forEach(function(_e) {
    $.includes(_e) || (_[_e] = s[_e]);
  }), _;
};
const withFieldWrap = function(a) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ["addons", "schema", "dependValues"];
  return function($) {
    return /* @__PURE__ */ React$a.createElement(a, Object.assign({}, getProps($, s)));
  };
}, Input = withFieldWrap(_Input), InputNumber = withFieldWrap(_InputNumber);
var TextArea = function a(s) {
  var $ = Object.assign({
    autoSize: {
      minRows: 3
    }
  }, s);
  return $.rows && delete $.autoSize, /* @__PURE__ */ React$a.createElement(_Input.TextArea, Object.assign({}, $));
};
const TextArea$1 = withFieldWrap(TextArea), MultiSelect = withFieldWrap(_Select), Switch = withFieldWrap(_Switch);
var RadioComp = function a(s) {
  var $ = s.direction, _ = $ === void 0 ? "row" : $, _e = s.options, tt = _e === void 0 ? [] : _e, nt = __rest$3(s, ["direction", "options"]);
  return _ === "column" ? /* @__PURE__ */ React$a.createElement(_Radio.Group, Object.assign({}, nt), /* @__PURE__ */ React$a.createElement(_Space, {
    direction: "vertical"
  }, tt.map(function(at) {
    var ot = at.value, rt = at.label, st = __rest$3(at, ["value", "label"]);
    return /* @__PURE__ */ React$a.createElement(_Radio, Object.assign({
      key: ot,
      value: ot
    }, st), rt);
  }))) : /* @__PURE__ */ React$a.createElement(_Radio.Group, Object.assign({}, nt, {
    options: tt
  }));
};
const Radio = withFieldWrap(RadioComp), index$2 = withFieldWrap(_Rate), TreeSelect = withFieldWrap(_TreeSelect);
var CheckBox = function a(s) {
  var $ = s.title, _ = __rest$3(s, ["title"]);
  return /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(_Checkbox, Object.assign({}, _)), /* @__PURE__ */ React$a.createElement("span", {
    style: {
      marginLeft: "12px"
    }
  }, $));
};
const Checkbox = withFieldWrap(CheckBox);
var Checkboxes = function a(s) {
  var $ = s.direction, _ = $ === void 0 ? "row" : $, _e = s.options, tt = _e === void 0 ? [] : _e, nt = __rest$3(s, ["direction", "options"]);
  return _ === "column" ? /* @__PURE__ */ React$a.createElement(_Checkbox.Group, Object.assign({}, nt), /* @__PURE__ */ React$a.createElement(_Space, {
    direction: "vertical"
  }, tt.map(function(at) {
    var ot = at.value, rt = at.label, st = __rest$3(at, ["value", "label"]);
    return /* @__PURE__ */ React$a.createElement(_Checkbox, Object.assign({
      key: ot,
      value: ot
    }, st), rt);
  }))) : /* @__PURE__ */ React$a.createElement(_Checkbox.Group, Object.assign({}, nt, {
    options: tt
  }));
};
const Checkboxes$1 = withFieldWrap(Checkboxes);
var lib$1 = { exports: {} }, ColorPicker$1 = { exports: {} }, propTypes = { exports: {} }, ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", ReactPropTypesSecret_1 = ReactPropTypesSecret$1, ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function a(_, _e, tt, nt, at, ot) {
    if (ot !== ReactPropTypesSecret) {
      var rt = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw rt.name = "Invariant Violation", rt;
    }
  }
  a.isRequired = a;
  function s() {
    return a;
  }
  var $ = {
    array: a,
    bigint: a,
    bool: a,
    func: a,
    number: a,
    object: a,
    string: a,
    symbol: a,
    any: a,
    arrayOf: s,
    element: a,
    elementType: a,
    instanceOf: s,
    node: a,
    objectOf: s,
    oneOf: s,
    oneOfType: s,
    shape: s,
    exact: s,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  return $.PropTypes = $, $;
};
propTypes.exports = factoryWithThrowingShims();
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var _global = { exports: {} }, global$5 = _global.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
typeof __g == "number" && (__g = global$5);
var _globalExports = _global.exports, _core = { exports: {} }, core$3 = _core.exports = { version: "2.6.12" };
typeof __e == "number" && (__e = core$3);
var _coreExports = _core.exports, _aFunction = function(a) {
  if (typeof a != "function")
    throw TypeError(a + " is not a function!");
  return a;
}, aFunction = _aFunction, _ctx = function(a, s, $) {
  if (aFunction(a), s === void 0)
    return a;
  switch ($) {
    case 1:
      return function(_) {
        return a.call(s, _);
      };
    case 2:
      return function(_, _e) {
        return a.call(s, _, _e);
      };
    case 3:
      return function(_, _e, tt) {
        return a.call(s, _, _e, tt);
      };
  }
  return function() {
    return a.apply(s, arguments);
  };
}, _objectDp = {}, _isObject = function(a) {
  return typeof a == "object" ? a !== null : typeof a == "function";
}, isObject$5 = _isObject, _anObject = function(a) {
  if (!isObject$5(a))
    throw TypeError(a + " is not an object!");
  return a;
}, _fails, hasRequired_fails;
function require_fails() {
  return hasRequired_fails || (hasRequired_fails = 1, _fails = function(a) {
    try {
      return !!a();
    } catch {
      return !0;
    }
  }), _fails;
}
var _descriptors, hasRequired_descriptors;
function require_descriptors() {
  return hasRequired_descriptors || (hasRequired_descriptors = 1, _descriptors = !require_fails()(function() {
    return Object.defineProperty({}, "a", { get: function() {
      return 7;
    } }).a != 7;
  })), _descriptors;
}
var _domCreate, hasRequired_domCreate;
function require_domCreate() {
  if (hasRequired_domCreate)
    return _domCreate;
  hasRequired_domCreate = 1;
  var a = _isObject, s = _globalExports.document, $ = a(s) && a(s.createElement);
  return _domCreate = function(_) {
    return $ ? s.createElement(_) : {};
  }, _domCreate;
}
var _ie8DomDefine = !require_descriptors() && !require_fails()(function() {
  return Object.defineProperty(require_domCreate()("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), isObject$4 = _isObject, _toPrimitive$5 = function(a, s) {
  if (!isObject$4(a))
    return a;
  var $, _;
  if (s && typeof ($ = a.toString) == "function" && !isObject$4(_ = $.call(a)) || typeof ($ = a.valueOf) == "function" && !isObject$4(_ = $.call(a)) || !s && typeof ($ = a.toString) == "function" && !isObject$4(_ = $.call(a)))
    return _;
  throw TypeError("Can't convert object to primitive value");
}, anObject$3 = _anObject, IE8_DOM_DEFINE$1 = _ie8DomDefine, toPrimitive$3 = _toPrimitive$5, dP$3 = Object.defineProperty;
_objectDp.f = require_descriptors() ? Object.defineProperty : function a(s, $, _) {
  if (anObject$3(s), $ = toPrimitive$3($, !0), anObject$3(_), IE8_DOM_DEFINE$1)
    try {
      return dP$3(s, $, _);
    } catch {
    }
  if ("get" in _ || "set" in _)
    throw TypeError("Accessors not supported!");
  return "value" in _ && (s[$] = _.value), s;
};
var _propertyDesc = function(a, s) {
  return {
    enumerable: !(a & 1),
    configurable: !(a & 2),
    writable: !(a & 4),
    value: s
  };
}, dP$2 = _objectDp, createDesc$2 = _propertyDesc, _hide = require_descriptors() ? function(a, s, $) {
  return dP$2.f(a, s, createDesc$2(1, $));
} : function(a, s, $) {
  return a[s] = $, a;
}, hasOwnProperty = {}.hasOwnProperty, _has = function(a, s) {
  return hasOwnProperty.call(a, s);
}, global$4 = _globalExports, core$2 = _coreExports, ctx = _ctx, hide$1 = _hide, has$4 = _has, PROTOTYPE$2 = "prototype", $export$5 = function(a, s, $) {
  var _ = a & $export$5.F, _e = a & $export$5.G, tt = a & $export$5.S, nt = a & $export$5.P, at = a & $export$5.B, ot = a & $export$5.W, rt = _e ? core$2 : core$2[s] || (core$2[s] = {}), st = rt[PROTOTYPE$2], lt = _e ? global$4 : tt ? global$4[s] : (global$4[s] || {})[PROTOTYPE$2], et, it, ut;
  _e && ($ = s);
  for (et in $)
    it = !_ && lt && lt[et] !== void 0, !(it && has$4(rt, et)) && (ut = it ? lt[et] : $[et], rt[et] = _e && typeof lt[et] != "function" ? $[et] : at && it ? ctx(ut, global$4) : ot && lt[et] == ut ? function(ft) {
      var ht = function(dt, gt, pt) {
        if (this instanceof ft) {
          switch (arguments.length) {
            case 0:
              return new ft();
            case 1:
              return new ft(dt);
            case 2:
              return new ft(dt, gt);
          }
          return new ft(dt, gt, pt);
        }
        return ft.apply(this, arguments);
      };
      return ht[PROTOTYPE$2] = ft[PROTOTYPE$2], ht;
    }(ut) : nt && typeof ut == "function" ? ctx(Function.call, ut) : ut, nt && ((rt.virtual || (rt.virtual = {}))[et] = ut, a & $export$5.R && st && !st[et] && hide$1(st, et, ut)));
};
$export$5.F = 1;
$export$5.G = 2;
$export$5.S = 4;
$export$5.P = 8;
$export$5.B = 16;
$export$5.W = 32;
$export$5.U = 64;
$export$5.R = 128;
var _export = $export$5, _cof, hasRequired_cof;
function require_cof() {
  if (hasRequired_cof)
    return _cof;
  hasRequired_cof = 1;
  var a = {}.toString;
  return _cof = function(s) {
    return a.call(s).slice(8, -1);
  }, _cof;
}
var _iobject, hasRequired_iobject;
function require_iobject() {
  if (hasRequired_iobject)
    return _iobject;
  hasRequired_iobject = 1;
  var a = require_cof();
  return _iobject = Object("z").propertyIsEnumerable(0) ? Object : function(s) {
    return a(s) == "String" ? s.split("") : Object(s);
  }, _iobject;
}
var _defined, hasRequired_defined;
function require_defined() {
  return hasRequired_defined || (hasRequired_defined = 1, _defined = function(a) {
    if (a == null)
      throw TypeError("Can't call method on  " + a);
    return a;
  }), _defined;
}
var IObject = require_iobject(), defined$1 = require_defined(), _toIobject = function(a) {
  return IObject(defined$1(a));
}, ceil = Math.ceil, floor = Math.floor, _toInteger = function(a) {
  return isNaN(a = +a) ? 0 : (a > 0 ? floor : ceil)(a);
}, _toLength, hasRequired_toLength;
function require_toLength() {
  if (hasRequired_toLength)
    return _toLength;
  hasRequired_toLength = 1;
  var a = _toInteger, s = Math.min;
  return _toLength = function($) {
    return $ > 0 ? s(a($), 9007199254740991) : 0;
  }, _toLength;
}
var _toAbsoluteIndex, hasRequired_toAbsoluteIndex;
function require_toAbsoluteIndex() {
  if (hasRequired_toAbsoluteIndex)
    return _toAbsoluteIndex;
  hasRequired_toAbsoluteIndex = 1;
  var a = _toInteger, s = Math.max, $ = Math.min;
  return _toAbsoluteIndex = function(_, _e) {
    return _ = a(_), _ < 0 ? s(_ + _e, 0) : $(_, _e);
  }, _toAbsoluteIndex;
}
var _arrayIncludes, hasRequired_arrayIncludes;
function require_arrayIncludes() {
  if (hasRequired_arrayIncludes)
    return _arrayIncludes;
  hasRequired_arrayIncludes = 1;
  var a = _toIobject, s = require_toLength(), $ = require_toAbsoluteIndex();
  return _arrayIncludes = function(_) {
    return function(_e, tt, nt) {
      var at = a(_e), ot = s(at.length), rt = $(nt, ot), st;
      if (_ && tt != tt) {
        for (; ot > rt; )
          if (st = at[rt++], st != st)
            return !0;
      } else
        for (; ot > rt; rt++)
          if ((_ || rt in at) && at[rt] === tt)
            return _ || rt || 0;
      return !_ && -1;
    };
  }, _arrayIncludes;
}
var _shared = { exports: {} }, _library = !0, core$1 = _coreExports, global$3 = _globalExports, SHARED = "__core-js_shared__", store$1 = global$3[SHARED] || (global$3[SHARED] = {});
(_shared.exports = function(a, s) {
  return store$1[a] || (store$1[a] = s !== void 0 ? s : {});
})("versions", []).push({
  version: core$1.version,
  mode: "pure",
  copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
});
var _sharedExports = _shared.exports, id$1 = 0, px = Math.random(), _uid = function(a) {
  return "Symbol(".concat(a === void 0 ? "" : a, ")_", (++id$1 + px).toString(36));
}, shared$1 = _sharedExports("keys"), uid$2 = _uid, _sharedKey = function(a) {
  return shared$1[a] || (shared$1[a] = uid$2(a));
}, _objectKeysInternal, hasRequired_objectKeysInternal;
function require_objectKeysInternal() {
  if (hasRequired_objectKeysInternal)
    return _objectKeysInternal;
  hasRequired_objectKeysInternal = 1;
  var a = _has, s = _toIobject, $ = require_arrayIncludes()(!1), _ = _sharedKey("IE_PROTO");
  return _objectKeysInternal = function(_e, tt) {
    var nt = s(_e), at = 0, ot = [], rt;
    for (rt in nt)
      rt != _ && a(nt, rt) && ot.push(rt);
    for (; tt.length > at; )
      a(nt, rt = tt[at++]) && (~$(ot, rt) || ot.push(rt));
    return ot;
  }, _objectKeysInternal;
}
var _enumBugKeys = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","), _objectKeys, hasRequired_objectKeys;
function require_objectKeys() {
  if (hasRequired_objectKeys)
    return _objectKeys;
  hasRequired_objectKeys = 1;
  var a = require_objectKeysInternal(), s = _enumBugKeys;
  return _objectKeys = Object.keys || function(_) {
    return a(_, s);
  }, _objectKeys;
}
var _objectGops = {}, hasRequired_objectGops;
function require_objectGops() {
  return hasRequired_objectGops || (hasRequired_objectGops = 1, _objectGops.f = Object.getOwnPropertySymbols), _objectGops;
}
var _objectPie = {}, hasRequired_objectPie;
function require_objectPie() {
  return hasRequired_objectPie || (hasRequired_objectPie = 1, _objectPie.f = {}.propertyIsEnumerable), _objectPie;
}
var _toObject, hasRequired_toObject;
function require_toObject() {
  if (hasRequired_toObject)
    return _toObject;
  hasRequired_toObject = 1;
  var a = require_defined();
  return _toObject = function(s) {
    return Object(a(s));
  }, _toObject;
}
var _objectAssign, hasRequired_objectAssign;
function require_objectAssign() {
  if (hasRequired_objectAssign)
    return _objectAssign;
  hasRequired_objectAssign = 1;
  var a = require_descriptors(), s = require_objectKeys(), $ = require_objectGops(), _ = require_objectPie(), _e = require_toObject(), tt = require_iobject(), nt = Object.assign;
  return _objectAssign = !nt || require_fails()(function() {
    var at = {}, ot = {}, rt = Symbol(), st = "abcdefghijklmnopqrst";
    return at[rt] = 7, st.split("").forEach(function(lt) {
      ot[lt] = lt;
    }), nt({}, at)[rt] != 7 || Object.keys(nt({}, ot)).join("") != st;
  }) ? function(ot, rt) {
    for (var st = _e(ot), lt = arguments.length, et = 1, it = $.f, ut = _.f; lt > et; )
      for (var ft = tt(arguments[et++]), ht = it ? s(ft).concat(it(ft)) : s(ft), dt = ht.length, gt = 0, pt; dt > gt; )
        pt = ht[gt++], (!a || ut.call(ft, pt)) && (st[pt] = ft[pt]);
    return st;
  } : nt, _objectAssign;
}
var $export$4 = _export;
$export$4($export$4.S + $export$4.F, "Object", { assign: require_objectAssign() });
var assign$1 = _coreExports.Object.assign, assign = { default: assign$1, __esModule: !0 }, _assign$1 = assign, _assign2 = _interopRequireDefault$h(_assign$1);
function _interopRequireDefault$h(a) {
  return a && a.__esModule ? a : { default: a };
}
var _default$i = _assign2.default || function(a) {
  for (var s = 1; s < arguments.length; s++) {
    var $ = arguments[s];
    for (var _ in $)
      Object.prototype.hasOwnProperty.call($, _) && (a[_] = $[_]);
  }
  return a;
}, _assign = objectAssign, emptyObject = {};
function _invariant(a, s, $, _, _e, tt, nt, at) {
  if (!a) {
    var ot;
    if (s === void 0)
      ot = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var rt = [$, _, _e, tt, nt, at], st = 0;
      ot = new Error(s.replace(/%s/g, function() {
        return rt[st++];
      })), ot.name = "Invariant Violation";
    }
    throw ot.framesToPop = 1, ot;
  }
}
var MIXINS_KEY = "mixins";
function identity(a) {
  return a;
}
function factory$1(a, s, $) {
  var _ = [], _e = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: "DEFINE_MANY",
    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: "DEFINE_MANY",
    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: "DEFINE_MANY",
    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: "DEFINE_MANY",
    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: "DEFINE_MANY",
    // ==== Definition methods ====
    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: "DEFINE_MANY_MERGED",
    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: "DEFINE_MANY_MERGED",
    /**
     * @return {object}
     * @optional
     */
    getChildContext: "DEFINE_MANY_MERGED",
    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: "DEFINE_ONCE",
    // ==== Delegate methods ====
    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: "DEFINE_MANY",
    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: "DEFINE_MANY",
    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: "DEFINE_MANY",
    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: "DEFINE_ONCE",
    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: "DEFINE_MANY",
    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: "DEFINE_MANY",
    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: "DEFINE_MANY",
    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: "DEFINE_MANY",
    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: "DEFINE_MANY",
    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: "DEFINE_MANY",
    // ==== Advanced methods ====
    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: "OVERRIDE_BASE"
  }, tt = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: "DEFINE_MANY_MERGED"
  }, nt = {
    displayName: function(mt, ct) {
      mt.displayName = ct;
    },
    mixins: function(mt, ct) {
      if (ct)
        for (var vt = 0; vt < ct.length; vt++)
          ot(mt, ct[vt]);
    },
    childContextTypes: function(mt, ct) {
      mt.childContextTypes = _assign(
        {},
        mt.childContextTypes,
        ct
      );
    },
    contextTypes: function(mt, ct) {
      mt.contextTypes = _assign(
        {},
        mt.contextTypes,
        ct
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(mt, ct) {
      mt.getDefaultProps ? mt.getDefaultProps = lt(
        mt.getDefaultProps,
        ct
      ) : mt.getDefaultProps = ct;
    },
    propTypes: function(mt, ct) {
      mt.propTypes = _assign({}, mt.propTypes, ct);
    },
    statics: function(mt, ct) {
      rt(mt, ct);
    },
    autobind: function() {
    }
  };
  function at(mt, ct) {
    var vt = _e.hasOwnProperty(ct) ? _e[ct] : null;
    dt.hasOwnProperty(ct) && _invariant(
      vt === "OVERRIDE_BASE",
      "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",
      ct
    ), mt && _invariant(
      vt === "DEFINE_MANY" || vt === "DEFINE_MANY_MERGED",
      "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
      ct
    );
  }
  function ot(mt, ct) {
    if (ct) {
      _invariant(
        typeof ct != "function",
        "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."
      ), _invariant(
        !s(ct),
        "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object."
      );
      var vt = mt.prototype, At = vt.__reactAutoBindPairs;
      ct.hasOwnProperty(MIXINS_KEY) && nt.mixins(mt, ct.mixins);
      for (var xt in ct)
        if (ct.hasOwnProperty(xt) && xt !== MIXINS_KEY) {
          var bt = ct[xt], Et = vt.hasOwnProperty(xt);
          if (at(Et, xt), nt.hasOwnProperty(xt))
            nt[xt](mt, bt);
          else {
            var St = _e.hasOwnProperty(xt), Bt = typeof bt == "function", Ot = Bt && !St && !Et && ct.autobind !== !1;
            if (Ot)
              At.push(xt, bt), vt[xt] = bt;
            else if (Et) {
              var Pt = _e[xt];
              _invariant(
                St && (Pt === "DEFINE_MANY_MERGED" || Pt === "DEFINE_MANY"),
                "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",
                Pt,
                xt
              ), Pt === "DEFINE_MANY_MERGED" ? vt[xt] = lt(vt[xt], bt) : Pt === "DEFINE_MANY" && (vt[xt] = et(vt[xt], bt));
            } else
              vt[xt] = bt;
          }
        }
    }
  }
  function rt(mt, ct) {
    if (ct)
      for (var vt in ct) {
        var At = ct[vt];
        if (ct.hasOwnProperty(vt)) {
          var xt = vt in nt;
          _invariant(
            !xt,
            'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',
            vt
          );
          var bt = vt in mt;
          if (bt) {
            var Et = tt.hasOwnProperty(vt) ? tt[vt] : null;
            _invariant(
              Et === "DEFINE_MANY_MERGED",
              "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
              vt
            ), mt[vt] = lt(mt[vt], At);
            return;
          }
          mt[vt] = At;
        }
      }
  }
  function st(mt, ct) {
    _invariant(
      mt && ct && typeof mt == "object" && typeof ct == "object",
      "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects."
    );
    for (var vt in ct)
      ct.hasOwnProperty(vt) && (_invariant(
        mt[vt] === void 0,
        "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",
        vt
      ), mt[vt] = ct[vt]);
    return mt;
  }
  function lt(mt, ct) {
    return function() {
      var At = mt.apply(this, arguments), xt = ct.apply(this, arguments);
      if (At == null)
        return xt;
      if (xt == null)
        return At;
      var bt = {};
      return st(bt, At), st(bt, xt), bt;
    };
  }
  function et(mt, ct) {
    return function() {
      mt.apply(this, arguments), ct.apply(this, arguments);
    };
  }
  function it(mt, ct) {
    var vt = ct.bind(mt);
    return vt;
  }
  function ut(mt) {
    for (var ct = mt.__reactAutoBindPairs, vt = 0; vt < ct.length; vt += 2) {
      var At = ct[vt], xt = ct[vt + 1];
      mt[At] = it(mt, xt);
    }
  }
  var ft = {
    componentDidMount: function() {
      this.__isMounted = !0;
    }
  }, ht = {
    componentWillUnmount: function() {
      this.__isMounted = !1;
    }
  }, dt = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(mt, ct) {
      this.updater.enqueueReplaceState(this, mt, ct);
    },
    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      return !!this.__isMounted;
    }
  }, gt = function() {
  };
  _assign(
    gt.prototype,
    a.prototype,
    dt
  );
  function pt(mt) {
    var ct = function(At, xt, bt) {
      this.__reactAutoBindPairs.length && ut(this), this.props = At, this.context = xt, this.refs = emptyObject, this.updater = bt || $, this.state = null;
      var Et = this.getInitialState ? this.getInitialState() : null;
      _invariant(
        typeof Et == "object" && !Array.isArray(Et),
        "%s.getInitialState(): must return an object or null",
        ct.displayName || "ReactCompositeComponent"
      ), this.state = Et;
    };
    ct.prototype = new gt(), ct.prototype.constructor = ct, ct.prototype.__reactAutoBindPairs = [], _.forEach(ot.bind(null, ct)), ot(ct, ft), ot(ct, mt), ot(ct, ht), ct.getDefaultProps && (ct.defaultProps = ct.getDefaultProps()), _invariant(
      ct.prototype.render,
      "createClass(...): Class specification must implement a `render` method."
    );
    for (var vt in _e)
      ct.prototype[vt] || (ct.prototype[vt] = null);
    return ct;
  }
  return pt;
}
var factory_1 = factory$1, React$9 = reactExports, factory = factory_1;
if (typeof React$9 > "u")
  throw Error(
    "create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class."
  );
var ReactNoopUpdateQueue = new React$9.Component().updater, createReactClass = factory(
  React$9.Component,
  React$9.isValidElement,
  ReactNoopUpdateQueue
);
const createReactClass$1 = /* @__PURE__ */ getDefaultExportFromCjs(createReactClass);
function contains$2(a, s) {
  for (var $ = s; $; ) {
    if ($ === a)
      return !0;
    $ = $.parentNode;
  }
  return !1;
}
var addEventListener$2 = {}, lib = { exports: {} }, EventObject = { exports: {} }, EventBaseObject = { exports: {} };
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  function $() {
    return !1;
  }
  function _() {
    return !0;
  }
  function _e() {
    this.timeStamp = Date.now(), this.target = void 0, this.currentTarget = void 0;
  }
  _e.prototype = {
    isEventObject: 1,
    constructor: _e,
    isDefaultPrevented: $,
    isPropagationStopped: $,
    isImmediatePropagationStopped: $,
    preventDefault: function() {
      this.isDefaultPrevented = _;
    },
    stopPropagation: function() {
      this.isPropagationStopped = _;
    },
    stopImmediatePropagation: function() {
      this.isImmediatePropagationStopped = _, this.stopPropagation();
    },
    halt: function(nt) {
      nt ? this.stopImmediatePropagation() : this.stopPropagation(), this.preventDefault();
    }
  }, s.default = _e, a.exports = s.default;
})(EventBaseObject, EventBaseObject.exports);
var EventBaseObjectExports = EventBaseObject.exports;
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  function $(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  }
  var _ = EventBaseObjectExports, _e = $(_), tt = objectAssign, nt = $(tt), at = !0, ot = !1, rt = ["altKey", "bubbles", "cancelable", "ctrlKey", "currentTarget", "eventPhase", "metaKey", "shiftKey", "target", "timeStamp", "view", "type"];
  function st(ht) {
    return ht == null;
  }
  var lt = [{
    reg: /^key/,
    props: ["char", "charCode", "key", "keyCode", "which"],
    fix: function(dt, gt) {
      st(dt.which) && (dt.which = st(gt.charCode) ? gt.keyCode : gt.charCode), dt.metaKey === void 0 && (dt.metaKey = dt.ctrlKey);
    }
  }, {
    reg: /^touch/,
    props: ["touches", "changedTouches", "targetTouches"]
  }, {
    reg: /^hashchange$/,
    props: ["newURL", "oldURL"]
  }, {
    reg: /^gesturechange$/i,
    props: ["rotation", "scale"]
  }, {
    reg: /^(mousewheel|DOMMouseScroll)$/,
    props: [],
    fix: function(dt, gt) {
      var pt = void 0, mt = void 0, ct = void 0, vt = gt.wheelDelta, At = gt.axis, xt = gt.wheelDeltaY, bt = gt.wheelDeltaX, Et = gt.detail;
      vt && (ct = vt / 120), Et && (ct = 0 - (Et % 3 === 0 ? Et / 3 : Et)), At !== void 0 && (At === dt.HORIZONTAL_AXIS ? (mt = 0, pt = 0 - ct) : At === dt.VERTICAL_AXIS && (pt = 0, mt = ct)), xt !== void 0 && (mt = xt / 120), bt !== void 0 && (pt = -1 * bt / 120), !pt && !mt && (mt = ct), pt !== void 0 && (dt.deltaX = pt), mt !== void 0 && (dt.deltaY = mt), ct !== void 0 && (dt.delta = ct);
    }
  }, {
    reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
    props: ["buttons", "clientX", "clientY", "button", "offsetX", "relatedTarget", "which", "fromElement", "toElement", "offsetY", "pageX", "pageY", "screenX", "screenY"],
    fix: function(dt, gt) {
      var pt = void 0, mt = void 0, ct = void 0, vt = dt.target, At = gt.button;
      return vt && st(dt.pageX) && !st(gt.clientX) && (pt = vt.ownerDocument || document, mt = pt.documentElement, ct = pt.body, dt.pageX = gt.clientX + (mt && mt.scrollLeft || ct && ct.scrollLeft || 0) - (mt && mt.clientLeft || ct && ct.clientLeft || 0), dt.pageY = gt.clientY + (mt && mt.scrollTop || ct && ct.scrollTop || 0) - (mt && mt.clientTop || ct && ct.clientTop || 0)), !dt.which && At !== void 0 && (At & 1 ? dt.which = 1 : At & 2 ? dt.which = 3 : At & 4 ? dt.which = 2 : dt.which = 0), !dt.relatedTarget && dt.fromElement && (dt.relatedTarget = dt.fromElement === vt ? dt.toElement : dt.fromElement), dt;
    }
  }];
  function et() {
    return at;
  }
  function it() {
    return ot;
  }
  function ut(ht) {
    var dt = ht.type, gt = typeof ht.stopPropagation == "function" || typeof ht.cancelBubble == "boolean";
    _e.default.call(this), this.nativeEvent = ht;
    var pt = it;
    "defaultPrevented" in ht ? pt = ht.defaultPrevented ? et : it : "getPreventDefault" in ht ? pt = ht.getPreventDefault() ? et : it : "returnValue" in ht && (pt = ht.returnValue === ot ? et : it), this.isDefaultPrevented = pt;
    var mt = [], ct = void 0, vt = void 0, At = void 0, xt = rt.concat();
    for (lt.forEach(function(bt) {
      dt.match(bt.reg) && (xt = xt.concat(bt.props), bt.fix && mt.push(bt.fix));
    }), vt = xt.length; vt; )
      At = xt[--vt], this[At] = ht[At];
    for (!this.target && gt && (this.target = ht.srcElement || document), this.target && this.target.nodeType === 3 && (this.target = this.target.parentNode), vt = mt.length; vt; )
      ct = mt[--vt], ct(this, ht);
    this.timeStamp = ht.timeStamp || Date.now();
  }
  var ft = _e.default.prototype;
  (0, nt.default)(ut.prototype, ft, {
    constructor: ut,
    preventDefault: function() {
      var dt = this.nativeEvent;
      dt.preventDefault ? dt.preventDefault() : dt.returnValue = ot, ft.preventDefault.call(this);
    },
    stopPropagation: function() {
      var dt = this.nativeEvent;
      dt.stopPropagation ? dt.stopPropagation() : dt.cancelBubble = at, ft.stopPropagation.call(this);
    }
  }), s.default = ut, a.exports = s.default;
})(EventObject, EventObject.exports);
var EventObjectExports = EventObject.exports;
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = tt;
  function $(nt) {
    return nt && nt.__esModule ? nt : { default: nt };
  }
  var _ = EventObjectExports, _e = $(_);
  function tt(nt, at, ot, rt) {
    function st(et) {
      var it = new _e.default(et);
      ot.call(nt, it);
    }
    if (nt.addEventListener) {
      var lt = function() {
        var et = !1;
        return typeof rt == "object" ? et = rt.capture || !1 : typeof rt == "boolean" && (et = rt), nt.addEventListener(at, st, rt || !1), {
          v: {
            remove: function() {
              nt.removeEventListener(at, st, et);
            }
          }
        };
      }();
      if (typeof lt == "object")
        return lt.v;
    } else if (nt.attachEvent)
      return nt.attachEvent("on" + at, st), {
        remove: function() {
          nt.detachEvent("on" + at, st);
        }
      };
  }
  a.exports = s.default;
})(lib, lib.exports);
var libExports$1 = lib.exports;
const addDOMEventListener = /* @__PURE__ */ getDefaultExportFromCjs(libExports$1);
Object.defineProperty(addEventListener$2, "__esModule", {
  value: !0
});
var _default$h = addEventListener$2.default = addEventListenerWrap$2, _addDomEventListener$1 = _interopRequireDefault$g(libExports$1), _reactDom$2 = _interopRequireDefault$g(reactDomExports);
function _interopRequireDefault$g(a) {
  return a && a.__esModule ? a : { default: a };
}
function addEventListenerWrap$2(a, s, $, _) {
  var _e = _reactDom$2.default.unstable_batchedUpdates ? function(nt) {
    _reactDom$2.default.unstable_batchedUpdates($, nt);
  } : $;
  return (0, _addDomEventListener$1.default)(a, s, _e, _);
}
var _default$g = function(a, s) {
  if (!(a instanceof s))
    throw new TypeError("Cannot call a class as a function");
}, $export$3 = _export;
$export$3($export$3.S + $export$3.F * !require_descriptors(), "Object", { defineProperty: _objectDp.f });
var $Object$1 = _coreExports.Object, defineProperty$3 = function a(s, $, _) {
  return $Object$1.defineProperty(s, $, _);
}, defineProperty$2 = { default: defineProperty$3, __esModule: !0 }, _defineProperty$8 = defineProperty$2, _defineProperty2$1 = _interopRequireDefault$f(_defineProperty$8);
function _interopRequireDefault$f(a) {
  return a && a.__esModule ? a : { default: a };
}
var _default$f = /* @__PURE__ */ function() {
  function a(s, $) {
    for (var _ = 0; _ < $.length; _++) {
      var _e = $[_];
      _e.enumerable = _e.enumerable || !1, _e.configurable = !0, "value" in _e && (_e.writable = !0), (0, _defineProperty2$1.default)(s, _e.key, _e);
    }
  }
  return function(s, $, _) {
    return $ && a(s.prototype, $), _ && a(s, _), s;
  };
}(), _typeof$j = {}, toInteger = _toInteger, defined = require_defined(), _stringAt = function(a) {
  return function(s, $) {
    var _ = String(defined(s)), _e = toInteger($), tt = _.length, nt, at;
    return _e < 0 || _e >= tt ? a ? "" : void 0 : (nt = _.charCodeAt(_e), nt < 55296 || nt > 56319 || _e + 1 === tt || (at = _.charCodeAt(_e + 1)) < 56320 || at > 57343 ? a ? _.charAt(_e) : nt : a ? _.slice(_e, _e + 2) : (nt - 55296 << 10) + (at - 56320) + 65536);
  };
}, _redefine = _hide, _iterators = {}, dP$1 = _objectDp, anObject$2 = _anObject, getKeys$2 = require_objectKeys(), _objectDps = require_descriptors() ? Object.defineProperties : function a(s, $) {
  anObject$2(s);
  for (var _ = getKeys$2($), _e = _.length, tt = 0, nt; _e > tt; )
    dP$1.f(s, nt = _[tt++], $[nt]);
  return s;
}, _html, hasRequired_html;
function require_html() {
  if (hasRequired_html)
    return _html;
  hasRequired_html = 1;
  var a = _globalExports.document;
  return _html = a && a.documentElement, _html;
}
var anObject$1 = _anObject, dPs = _objectDps, enumBugKeys = _enumBugKeys, IE_PROTO = _sharedKey("IE_PROTO"), Empty = function() {
}, PROTOTYPE$1 = "prototype", createDict = function() {
  var a = require_domCreate()("iframe"), s = enumBugKeys.length, $ = "<", _ = ">", _e;
  for (a.style.display = "none", require_html().appendChild(a), a.src = "javascript:", _e = a.contentWindow.document, _e.open(), _e.write($ + "script" + _ + "document.F=Object" + $ + "/script" + _), _e.close(), createDict = _e.F; s--; )
    delete createDict[PROTOTYPE$1][enumBugKeys[s]];
  return createDict();
}, _objectCreate = Object.create || function a(s, $) {
  var _;
  return s !== null ? (Empty[PROTOTYPE$1] = anObject$1(s), _ = new Empty(), Empty[PROTOTYPE$1] = null, _[IE_PROTO] = s) : _ = createDict(), $ === void 0 ? _ : dPs(_, $);
}, _wks = { exports: {} }, store = _sharedExports("wks"), uid$1 = _uid, Symbol$1 = _globalExports.Symbol, USE_SYMBOL = typeof Symbol$1 == "function", $exports = _wks.exports = function(a) {
  return store[a] || (store[a] = USE_SYMBOL && Symbol$1[a] || (USE_SYMBOL ? Symbol$1 : uid$1)("Symbol." + a));
};
$exports.store = store;
var _wksExports = _wks.exports, def = _objectDp.f, has$3 = _has, TAG = _wksExports("toStringTag"), _setToStringTag = function(a, s, $) {
  a && !has$3(a = $ ? a : a.prototype, TAG) && def(a, TAG, { configurable: !0, value: s });
}, _iterCreate, hasRequired_iterCreate;
function require_iterCreate() {
  if (hasRequired_iterCreate)
    return _iterCreate;
  hasRequired_iterCreate = 1;
  var a = _objectCreate, s = _propertyDesc, $ = _setToStringTag, _ = {};
  return _hide(_, _wksExports("iterator"), function() {
    return this;
  }), _iterCreate = function(_e, tt, nt) {
    _e.prototype = a(_, { next: s(1, nt) }), $(_e, tt + " Iterator");
  }, _iterCreate;
}
var _objectGpo, hasRequired_objectGpo;
function require_objectGpo() {
  if (hasRequired_objectGpo)
    return _objectGpo;
  hasRequired_objectGpo = 1;
  var a = _has, s = require_toObject(), $ = _sharedKey("IE_PROTO"), _ = Object.prototype;
  return _objectGpo = Object.getPrototypeOf || function(_e) {
    return _e = s(_e), a(_e, $) ? _e[$] : typeof _e.constructor == "function" && _e instanceof _e.constructor ? _e.constructor.prototype : _e instanceof Object ? _ : null;
  }, _objectGpo;
}
var _iterDefine, hasRequired_iterDefine;
function require_iterDefine() {
  if (hasRequired_iterDefine)
    return _iterDefine;
  hasRequired_iterDefine = 1;
  var a = _export, s = _redefine, $ = _hide, _ = _iterators, _e = require_iterCreate(), tt = _setToStringTag, nt = require_objectGpo(), at = _wksExports("iterator"), ot = !([].keys && "next" in [].keys()), rt = "@@iterator", st = "keys", lt = "values", et = function() {
    return this;
  };
  return _iterDefine = function(it, ut, ft, ht, dt, gt, pt) {
    _e(ft, ut, ht);
    var mt = function(Ct) {
      if (!ot && Ct in xt)
        return xt[Ct];
      switch (Ct) {
        case st:
          return function() {
            return new ft(this, Ct);
          };
        case lt:
          return function() {
            return new ft(this, Ct);
          };
      }
      return function() {
        return new ft(this, Ct);
      };
    }, ct = ut + " Iterator", vt = dt == lt, At = !1, xt = it.prototype, bt = xt[at] || xt[rt] || dt && xt[dt], Et = bt || mt(dt), St = dt ? vt ? mt("entries") : Et : void 0, Bt = ut == "Array" && xt.entries || bt, Ot, Pt, wt;
    if (Bt && (wt = nt(Bt.call(new it())), wt !== Object.prototype && wt.next && tt(wt, ct, !0)), vt && bt && bt.name !== lt && (At = !0, Et = function() {
      return bt.call(this);
    }), pt && (ot || At || !xt[at]) && $(xt, at, Et), _[ut] = Et, _[ct] = et, dt)
      if (Ot = {
        values: vt ? Et : mt(lt),
        keys: gt ? Et : mt(st),
        entries: St
      }, pt)
        for (Pt in Ot)
          Pt in xt || s(xt, Pt, Ot[Pt]);
      else
        a(a.P + a.F * (ot || At), ut, Ot);
    return Ot;
  }, _iterDefine;
}
var $at = _stringAt(!0);
require_iterDefine()(String, "String", function(a) {
  this._t = String(a), this._i = 0;
}, function() {
  var a = this._t, s = this._i, $;
  return s >= a.length ? { value: void 0, done: !0 } : ($ = $at(a, s), this._i += $.length, { value: $, done: !1 });
});
var _iterStep = function(a, s) {
  return { value: s, done: !!a };
}, step = _iterStep, Iterators$1 = _iterators, toIObject$3 = _toIobject;
require_iterDefine()(Array, "Array", function(a, s) {
  this._t = toIObject$3(a), this._i = 0, this._k = s;
}, function() {
  var a = this._t, s = this._k, $ = this._i++;
  return !a || $ >= a.length ? (this._t = void 0, step(1)) : s == "keys" ? step(0, $) : s == "values" ? step(0, a[$]) : step(0, [$, a[$]]);
}, "values");
Iterators$1.Arguments = Iterators$1.Array;
var global$2 = _globalExports, hide = _hide, Iterators = _iterators, TO_STRING_TAG = _wksExports("toStringTag"), DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(",");
for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i], Collection = global$2[NAME], proto = Collection && Collection.prototype;
  proto && !proto[TO_STRING_TAG] && hide(proto, TO_STRING_TAG, NAME), Iterators[NAME] = Iterators.Array;
}
var _wksExt = {};
_wksExt.f = _wksExports;
var iterator$1 = _wksExt.f("iterator"), iterator = { default: iterator$1, __esModule: !0 }, _meta = { exports: {} }, META$1 = _uid("meta"), isObject$3 = _isObject, has$2 = _has, setDesc = _objectDp.f, id = 0, isExtensible = Object.isExtensible || function() {
  return !0;
}, FREEZE = !require_fails()(function() {
  return isExtensible(Object.preventExtensions({}));
}), setMeta = function(a) {
  setDesc(a, META$1, { value: {
    i: "O" + ++id,
    // object ID
    w: {}
    // weak collections IDs
  } });
}, fastKey = function(a, s) {
  if (!isObject$3(a))
    return typeof a == "symbol" ? a : (typeof a == "string" ? "S" : "P") + a;
  if (!has$2(a, META$1)) {
    if (!isExtensible(a))
      return "F";
    if (!s)
      return "E";
    setMeta(a);
  }
  return a[META$1].i;
}, getWeak = function(a, s) {
  if (!has$2(a, META$1)) {
    if (!isExtensible(a))
      return !0;
    if (!s)
      return !1;
    setMeta(a);
  }
  return a[META$1].w;
}, onFreeze = function(a) {
  return FREEZE && meta.NEED && isExtensible(a) && !has$2(a, META$1) && setMeta(a), a;
}, meta = _meta.exports = {
  KEY: META$1,
  NEED: !1,
  fastKey,
  getWeak,
  onFreeze
}, _metaExports = _meta.exports, core = _coreExports, wksExt$1 = _wksExt, defineProperty$1 = _objectDp.f, _wksDefine = function(a) {
  var s = core.Symbol || (core.Symbol = {});
  a.charAt(0) != "_" && !(a in s) && defineProperty$1(s, a, { value: wksExt$1.f(a) });
}, getKeys$1 = require_objectKeys(), gOPS = require_objectGops(), pIE$1 = require_objectPie(), _enumKeys = function(a) {
  var s = getKeys$1(a), $ = gOPS.f;
  if ($)
    for (var _ = $(a), _e = pIE$1.f, tt = 0, nt; _.length > tt; )
      _e.call(a, nt = _[tt++]) && s.push(nt);
  return s;
}, cof = require_cof(), _isArray = Array.isArray || function a(s) {
  return cof(s) == "Array";
}, _objectGopnExt = {}, _objectGopn = {}, $keys$1 = require_objectKeysInternal(), hiddenKeys = _enumBugKeys.concat("length", "prototype");
_objectGopn.f = Object.getOwnPropertyNames || function a(s) {
  return $keys$1(s, hiddenKeys);
};
var toIObject$2 = _toIobject, gOPN$1 = _objectGopn.f, toString$1 = {}.toString, windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], getWindowNames = function(a) {
  try {
    return gOPN$1(a);
  } catch {
    return windowNames.slice();
  }
};
_objectGopnExt.f = function a(s) {
  return windowNames && toString$1.call(s) == "[object Window]" ? getWindowNames(s) : gOPN$1(toIObject$2(s));
};
var _objectGopd = {}, pIE = require_objectPie(), createDesc$1 = _propertyDesc, toIObject$1 = _toIobject, toPrimitive$2 = _toPrimitive$5, has$1 = _has, IE8_DOM_DEFINE = _ie8DomDefine, gOPD$1 = Object.getOwnPropertyDescriptor;
_objectGopd.f = require_descriptors() ? gOPD$1 : function a(s, $) {
  if (s = toIObject$1(s), $ = toPrimitive$2($, !0), IE8_DOM_DEFINE)
    try {
      return gOPD$1(s, $);
    } catch {
    }
  if (has$1(s, $))
    return createDesc$1(!pIE.f.call(s, $), s[$]);
};
var global$1 = _globalExports, has = _has, DESCRIPTORS = require_descriptors(), $export$2 = _export, redefine = _redefine, META = _metaExports.KEY, $fails = require_fails(), shared = _sharedExports, setToStringTag = _setToStringTag, uid = _uid, wks = _wksExports, wksExt = _wksExt, wksDefine = _wksDefine, enumKeys = _enumKeys, isArray$1 = _isArray, anObject = _anObject, isObject$2 = _isObject, toObject = require_toObject(), toIObject = _toIobject, toPrimitive$1 = _toPrimitive$5, createDesc = _propertyDesc, _create$1 = _objectCreate, gOPNExt = _objectGopnExt, $GOPD = _objectGopd, $GOPS = require_objectGops(), $DP = _objectDp, $keys = require_objectKeys(), gOPD = $GOPD.f, dP = $DP.f, gOPN = gOPNExt.f, $Symbol = global$1.Symbol, $JSON = global$1.JSON, _stringify = $JSON && $JSON.stringify, PROTOTYPE = "prototype", HIDDEN = wks("_hidden"), TO_PRIMITIVE = wks("toPrimitive"), isEnum = {}.propertyIsEnumerable, SymbolRegistry = shared("symbol-registry"), AllSymbols = shared("symbols"), OPSymbols = shared("op-symbols"), ObjectProto = Object[PROTOTYPE], USE_NATIVE = typeof $Symbol == "function" && !!$GOPS.f, QObject = global$1.QObject, setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild, setSymbolDesc = DESCRIPTORS && $fails(function() {
  return _create$1(dP({}, "a", {
    get: function() {
      return dP(this, "a", { value: 7 }).a;
    }
  })).a != 7;
}) ? function(a, s, $) {
  var _ = gOPD(ObjectProto, s);
  _ && delete ObjectProto[s], dP(a, s, $), _ && a !== ObjectProto && dP(ObjectProto, s, _);
} : dP, wrap = function(a) {
  var s = AllSymbols[a] = _create$1($Symbol[PROTOTYPE]);
  return s._k = a, s;
}, isSymbol = USE_NATIVE && typeof $Symbol.iterator == "symbol" ? function(a) {
  return typeof a == "symbol";
} : function(a) {
  return a instanceof $Symbol;
}, $defineProperty = function a(s, $, _) {
  return s === ObjectProto && $defineProperty(OPSymbols, $, _), anObject(s), $ = toPrimitive$1($, !0), anObject(_), has(AllSymbols, $) ? (_.enumerable ? (has(s, HIDDEN) && s[HIDDEN][$] && (s[HIDDEN][$] = !1), _ = _create$1(_, { enumerable: createDesc(0, !1) })) : (has(s, HIDDEN) || dP(s, HIDDEN, createDesc(1, {})), s[HIDDEN][$] = !0), setSymbolDesc(s, $, _)) : dP(s, $, _);
}, $defineProperties = function a(s, $) {
  anObject(s);
  for (var _ = enumKeys($ = toIObject($)), _e = 0, tt = _.length, nt; tt > _e; )
    $defineProperty(s, nt = _[_e++], $[nt]);
  return s;
}, $create = function a(s, $) {
  return $ === void 0 ? _create$1(s) : $defineProperties(_create$1(s), $);
}, $propertyIsEnumerable = function a(s) {
  var $ = isEnum.call(this, s = toPrimitive$1(s, !0));
  return this === ObjectProto && has(AllSymbols, s) && !has(OPSymbols, s) ? !1 : $ || !has(this, s) || !has(AllSymbols, s) || has(this, HIDDEN) && this[HIDDEN][s] ? $ : !0;
}, $getOwnPropertyDescriptor = function a(s, $) {
  if (s = toIObject(s), $ = toPrimitive$1($, !0), !(s === ObjectProto && has(AllSymbols, $) && !has(OPSymbols, $))) {
    var _ = gOPD(s, $);
    return _ && has(AllSymbols, $) && !(has(s, HIDDEN) && s[HIDDEN][$]) && (_.enumerable = !0), _;
  }
}, $getOwnPropertyNames = function a(s) {
  for (var $ = gOPN(toIObject(s)), _ = [], _e = 0, tt; $.length > _e; )
    !has(AllSymbols, tt = $[_e++]) && tt != HIDDEN && tt != META && _.push(tt);
  return _;
}, $getOwnPropertySymbols = function a(s) {
  for (var $ = s === ObjectProto, _ = gOPN($ ? OPSymbols : toIObject(s)), _e = [], tt = 0, nt; _.length > tt; )
    has(AllSymbols, nt = _[tt++]) && (!$ || has(ObjectProto, nt)) && _e.push(AllSymbols[nt]);
  return _e;
};
USE_NATIVE || ($Symbol = function() {
  if (this instanceof $Symbol)
    throw TypeError("Symbol is not a constructor!");
  var s = uid(arguments.length > 0 ? arguments[0] : void 0), $ = function(_) {
    this === ObjectProto && $.call(OPSymbols, _), has(this, HIDDEN) && has(this[HIDDEN], s) && (this[HIDDEN][s] = !1), setSymbolDesc(this, s, createDesc(1, _));
  };
  return DESCRIPTORS && setter && setSymbolDesc(ObjectProto, s, { configurable: !0, set: $ }), wrap(s);
}, redefine($Symbol[PROTOTYPE], "toString", function() {
  return this._k;
}), $GOPD.f = $getOwnPropertyDescriptor, $DP.f = $defineProperty, _objectGopn.f = gOPNExt.f = $getOwnPropertyNames, require_objectPie().f = $propertyIsEnumerable, $GOPS.f = $getOwnPropertySymbols, DESCRIPTORS && !_library && redefine(ObjectProto, "propertyIsEnumerable", $propertyIsEnumerable), wksExt.f = function(a) {
  return wrap(wks(a));
});
$export$2($export$2.G + $export$2.W + $export$2.F * !USE_NATIVE, { Symbol: $Symbol });
for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(",")
), j = 0; es6Symbols.length > j; )
  wks(es6Symbols[j++]);
for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k; )
  wksDefine(wellKnownSymbols[k++]);
$export$2($export$2.S + $export$2.F * !USE_NATIVE, "Symbol", {
  // 19.4.2.1 Symbol.for(key)
  for: function(a) {
    return has(SymbolRegistry, a += "") ? SymbolRegistry[a] : SymbolRegistry[a] = $Symbol(a);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function a(s) {
    if (!isSymbol(s))
      throw TypeError(s + " is not a symbol!");
    for (var $ in SymbolRegistry)
      if (SymbolRegistry[$] === s)
        return $;
  },
  useSetter: function() {
    setter = !0;
  },
  useSimple: function() {
    setter = !1;
  }
});
$export$2($export$2.S + $export$2.F * !USE_NATIVE, "Object", {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});
var FAILS_ON_PRIMITIVES = $fails(function() {
  $GOPS.f(1);
});
$export$2($export$2.S + $export$2.F * FAILS_ON_PRIMITIVES, "Object", {
  getOwnPropertySymbols: function a(s) {
    return $GOPS.f(toObject(s));
  }
});
$JSON && $export$2($export$2.S + $export$2.F * (!USE_NATIVE || $fails(function() {
  var a = $Symbol();
  return _stringify([a]) != "[null]" || _stringify({ a }) != "{}" || _stringify(Object(a)) != "{}";
})), "JSON", {
  stringify: function a(s) {
    for (var $ = [s], _ = 1, _e, tt; arguments.length > _; )
      $.push(arguments[_++]);
    if (tt = _e = $[1], !(!isObject$2(_e) && s === void 0 || isSymbol(s)))
      return isArray$1(_e) || (_e = function(nt, at) {
        if (typeof tt == "function" && (at = tt.call(this, nt, at)), !isSymbol(at))
          return at;
      }), $[1] = _e, _stringify.apply($JSON, $);
  }
});
$Symbol[PROTOTYPE][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
setToStringTag($Symbol, "Symbol");
setToStringTag(Math, "Math", !0);
setToStringTag(global$1.JSON, "JSON", !0);
_wksDefine("asyncIterator");
_wksDefine("observable");
var symbol$1 = _coreExports.Symbol, symbol = { default: symbol$1, __esModule: !0 };
_typeof$j.__esModule = !0;
var _iterator = iterator, _iterator2 = _interopRequireDefault$e(_iterator), _symbol = symbol, _symbol2 = _interopRequireDefault$e(_symbol), _typeof$i = typeof _symbol2.default == "function" && typeof _iterator2.default == "symbol" ? function(a) {
  return typeof a;
} : function(a) {
  return a && typeof _symbol2.default == "function" && a.constructor === _symbol2.default && a !== _symbol2.default.prototype ? "symbol" : typeof a;
};
function _interopRequireDefault$e(a) {
  return a && a.__esModule ? a : { default: a };
}
var _default$e = _typeof$j.default = typeof _symbol2.default == "function" && _typeof$i(_iterator2.default) === "symbol" ? function(a) {
  return typeof a > "u" ? "undefined" : _typeof$i(a);
} : function(a) {
  return a && typeof _symbol2.default == "function" && a.constructor === _symbol2.default && a !== _symbol2.default.prototype ? "symbol" : typeof a > "u" ? "undefined" : _typeof$i(a);
}, _typeof2$1 = _typeof$j, _typeof3$1 = _interopRequireDefault$d(_typeof2$1);
function _interopRequireDefault$d(a) {
  return a && a.__esModule ? a : { default: a };
}
var _default$d = function(a, s) {
  if (!a)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return s && ((typeof s > "u" ? "undefined" : (0, _typeof3$1.default)(s)) === "object" || typeof s == "function") ? s : a;
}, _setProto, hasRequired_setProto;
function require_setProto() {
  if (hasRequired_setProto)
    return _setProto;
  hasRequired_setProto = 1;
  var a = _isObject, s = _anObject, $ = function(_, _e) {
    if (s(_), !a(_e) && _e !== null)
      throw TypeError(_e + ": can't set as prototype!");
  };
  return _setProto = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? (
      // eslint-disable-line
      function(_, _e, tt) {
        try {
          tt = _ctx(Function.call, _objectGopd.f(Object.prototype, "__proto__").set, 2), tt(_, []), _e = !(_ instanceof Array);
        } catch {
          _e = !0;
        }
        return function(at, ot) {
          return $(at, ot), _e ? at.__proto__ = ot : tt(at, ot), at;
        };
      }({}, !1)
    ) : void 0),
    check: $
  }, _setProto;
}
var $export$1 = _export;
$export$1($export$1.S, "Object", { setPrototypeOf: require_setProto().set });
var setPrototypeOf$1 = _coreExports.Object.setPrototypeOf, setPrototypeOf = { default: setPrototypeOf$1, __esModule: !0 }, $export = _export;
$export($export.S, "Object", { create: _objectCreate });
var $Object = _coreExports.Object, create$1 = function a(s, $) {
  return $Object.create(s, $);
}, create = { default: create$1, __esModule: !0 }, _setPrototypeOf = setPrototypeOf, _setPrototypeOf2 = _interopRequireDefault$c(_setPrototypeOf), _create = create, _create2 = _interopRequireDefault$c(_create), _typeof2 = _typeof$j, _typeof3 = _interopRequireDefault$c(_typeof2);
function _interopRequireDefault$c(a) {
  return a && a.__esModule ? a : { default: a };
}
var _default$c = function(a, s) {
  if (typeof s != "function" && s !== null)
    throw new TypeError("Super expression must either be null or a function, not " + (typeof s > "u" ? "undefined" : (0, _typeof3.default)(s)));
  a.prototype = (0, _create2.default)(s && s.prototype, {
    constructor: {
      value: a,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), s && (_setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(a, s) : a.__proto__ = s);
};
function ownKeys$2(a, s) {
  var $ = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var _ = Object.getOwnPropertySymbols(a);
    s && (_ = _.filter(function(_e) {
      return Object.getOwnPropertyDescriptor(a, _e).enumerable;
    })), $.push.apply($, _);
  }
  return $;
}
function _objectSpread2$9(a) {
  for (var s = 1; s < arguments.length; s++) {
    var $ = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$2(Object($), !0).forEach(function(_) {
      _defineProperty$7(a, _, $[_]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors($)) : ownKeys$2(Object($)).forEach(function(_) {
      Object.defineProperty(a, _, Object.getOwnPropertyDescriptor($, _));
    });
  }
  return a;
}
function _typeof$h(a) {
  "@babel/helpers - typeof";
  return _typeof$h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$h(a);
}
function _defineProperty$7(a, s, $) {
  return s in a ? Object.defineProperty(a, s, {
    value: $,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[s] = $, a;
}
var vendorPrefix, jsCssMap = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  // IE did it wrong again ...
  ms: "-ms-",
  O: "-o-"
};
function getVendorPrefix() {
  if (vendorPrefix !== void 0)
    return vendorPrefix;
  vendorPrefix = "";
  var a = document.createElement("p").style, s = "Transform";
  for (var $ in jsCssMap)
    $ + s in a && (vendorPrefix = $);
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : "transform";
}
function setTransitionProperty(a, s) {
  var $ = getTransitionName();
  $ && (a.style[$] = s, $ !== "transitionProperty" && (a.style.transitionProperty = s));
}
function setTransform(a, s) {
  var $ = getTransformName();
  $ && (a.style[$] = s, $ !== "transform" && (a.style.transform = s));
}
function getTransitionProperty(a) {
  return a.style.transitionProperty || a.style[getTransitionName()];
}
function getTransformXY(a) {
  var s = window.getComputedStyle(a, null), $ = s.getPropertyValue("transform") || s.getPropertyValue(getTransformName());
  if ($ && $ !== "none") {
    var _ = $.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(_[12] || _[4], 0),
      y: parseFloat(_[13] || _[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/, matrix3d$1 = /matrix3d\((.*)\)/;
function setTransformXY(a, s) {
  var $ = window.getComputedStyle(a, null), _ = $.getPropertyValue("transform") || $.getPropertyValue(getTransformName());
  if (_ && _ !== "none") {
    var _e, tt = _.match(matrix2d);
    if (tt)
      tt = tt[1], _e = tt.split(",").map(function(at) {
        return parseFloat(at, 10);
      }), _e[4] = s.x, _e[5] = s.y, setTransform(a, "matrix(".concat(_e.join(","), ")"));
    else {
      var nt = _.match(matrix3d$1)[1];
      _e = nt.split(",").map(function(at) {
        return parseFloat(at, 10);
      }), _e[12] = s.x, _e[13] = s.y, setTransform(a, "matrix3d(".concat(_e.join(","), ")"));
    }
  } else
    setTransform(a, "translateX(".concat(s.x, "px) translateY(").concat(s.y, "px) translateZ(0)"));
}
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source, getComputedStyleX;
function forceRelayout(a) {
  var s = a.style.display;
  a.style.display = "none", a.offsetHeight, a.style.display = s;
}
function css(a, s, $) {
  var _ = $;
  if (_typeof$h(s) === "object") {
    for (var _e in s)
      s.hasOwnProperty(_e) && css(a, _e, s[_e]);
    return;
  }
  if (typeof _ < "u") {
    typeof _ == "number" && (_ = "".concat(_, "px")), a.style[s] = _;
    return;
  }
  return getComputedStyleX(a, s);
}
function getClientPosition(a) {
  var s, $, _, _e = a.ownerDocument, tt = _e.body, nt = _e && _e.documentElement;
  return s = a.getBoundingClientRect(), $ = Math.floor(s.left), _ = Math.floor(s.top), $ -= nt.clientLeft || tt.clientLeft || 0, _ -= nt.clientTop || tt.clientTop || 0, {
    left: $,
    top: _
  };
}
function getScroll(a, s) {
  var $ = a["page".concat(s ? "Y" : "X", "Offset")], _ = "scroll".concat(s ? "Top" : "Left");
  if (typeof $ != "number") {
    var _e = a.document;
    $ = _e.documentElement[_], typeof $ != "number" && ($ = _e.body[_]);
  }
  return $;
}
function getScrollLeft(a) {
  return getScroll(a);
}
function getScrollTop(a) {
  return getScroll(a, !0);
}
function getOffset(a) {
  var s = getClientPosition(a), $ = a.ownerDocument, _ = $.defaultView || $.parentWindow;
  return s.left += getScrollLeft(_), s.top += getScrollTop(_), s;
}
function isWindow$2(a) {
  return a != null && a == a.window;
}
function getDocument$1(a) {
  return isWindow$2(a) ? a.document : a.nodeType === 9 ? a : a.ownerDocument;
}
function _getComputedStyle(a, s, $) {
  var _ = $, _e = "", tt = getDocument$1(a);
  return _ = _ || tt.defaultView.getComputedStyle(a, null), _ && (_e = _.getPropertyValue(s) || _[s]), _e;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), "i"), RE_POS = /^(top|right|bottom|left)$/, CURRENT_STYLE = "currentStyle", RUNTIME_STYLE = "runtimeStyle", LEFT = "left", PX = "px";
function _getComputedStyleIE(a, s) {
  var $ = a[CURRENT_STYLE] && a[CURRENT_STYLE][s];
  if (_RE_NUM_NO_PX.test($) && !RE_POS.test(s)) {
    var _ = a.style, _e = _[LEFT], tt = a[RUNTIME_STYLE][LEFT];
    a[RUNTIME_STYLE][LEFT] = a[CURRENT_STYLE][LEFT], _[LEFT] = s === "fontSize" ? "1em" : $ || 0, $ = _.pixelLeft + PX, _[LEFT] = _e, a[RUNTIME_STYLE][LEFT] = tt;
  }
  return $ === "" ? "auto" : $;
}
typeof window < "u" && (getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE);
function getOffsetDirection(a, s) {
  return a === "left" ? s.useCssRight ? "right" : a : s.useCssBottom ? "bottom" : a;
}
function oppositeOffsetDirection(a) {
  if (a === "left")
    return "right";
  if (a === "right")
    return "left";
  if (a === "top")
    return "bottom";
  if (a === "bottom")
    return "top";
}
function setLeftTop(a, s, $) {
  css(a, "position") === "static" && (a.style.position = "relative");
  var _ = -999, _e = -999, tt = getOffsetDirection("left", $), nt = getOffsetDirection("top", $), at = oppositeOffsetDirection(tt), ot = oppositeOffsetDirection(nt);
  tt !== "left" && (_ = 999), nt !== "top" && (_e = 999);
  var rt = "", st = getOffset(a);
  ("left" in s || "top" in s) && (rt = getTransitionProperty(a) || "", setTransitionProperty(a, "none")), "left" in s && (a.style[at] = "", a.style[tt] = "".concat(_, "px")), "top" in s && (a.style[ot] = "", a.style[nt] = "".concat(_e, "px")), forceRelayout(a);
  var lt = getOffset(a), et = {};
  for (var it in s)
    if (s.hasOwnProperty(it)) {
      var ut = getOffsetDirection(it, $), ft = it === "left" ? _ : _e, ht = st[it] - lt[it];
      ut === it ? et[ut] = ft + ht : et[ut] = ft - ht;
    }
  css(a, et), forceRelayout(a), ("left" in s || "top" in s) && setTransitionProperty(a, rt);
  var dt = {};
  for (var gt in s)
    if (s.hasOwnProperty(gt)) {
      var pt = getOffsetDirection(gt, $), mt = s[gt] - st[gt];
      gt === pt ? dt[pt] = et[pt] + mt : dt[pt] = et[pt] - mt;
    }
  css(a, dt);
}
function setTransform$1(a, s) {
  var $ = getOffset(a), _ = getTransformXY(a), _e = {
    x: _.x,
    y: _.y
  };
  "left" in s && (_e.x = _.x + s.left - $.left), "top" in s && (_e.y = _.y + s.top - $.top), setTransformXY(a, _e);
}
function setOffset(a, s, $) {
  if ($.ignoreShake) {
    var _ = getOffset(a), _e = _.left.toFixed(0), tt = _.top.toFixed(0), nt = s.left.toFixed(0), at = s.top.toFixed(0);
    if (_e === nt && tt === at)
      return;
  }
  $.useCssRight || $.useCssBottom ? setLeftTop(a, s, $) : $.useCssTransform && getTransformName() in document.body.style ? setTransform$1(a, s) : setLeftTop(a, s, $);
}
function each(a, s) {
  for (var $ = 0; $ < a.length; $++)
    s(a[$]);
}
function isBorderBoxFn(a) {
  return getComputedStyleX(a, "boxSizing") === "border-box";
}
var BOX_MODELS = ["margin", "border", "padding"], CONTENT_INDEX = -1, PADDING_INDEX = 2, BORDER_INDEX = 1, MARGIN_INDEX = 0;
function swap$1(a, s, $) {
  var _ = {}, _e = a.style, tt;
  for (tt in s)
    s.hasOwnProperty(tt) && (_[tt] = _e[tt], _e[tt] = s[tt]);
  $.call(a);
  for (tt in s)
    s.hasOwnProperty(tt) && (_e[tt] = _[tt]);
}
function getPBMWidth(a, s, $) {
  var _ = 0, _e, tt, nt;
  for (tt = 0; tt < s.length; tt++)
    if (_e = s[tt], _e)
      for (nt = 0; nt < $.length; nt++) {
        var at = void 0;
        _e === "border" ? at = "".concat(_e).concat($[nt], "Width") : at = _e + $[nt], _ += parseFloat(getComputedStyleX(a, at)) || 0;
      }
  return _;
}
var domUtils = {
  getParent: function a(s) {
    var $ = s;
    do
      $.nodeType === 11 && $.host ? $ = $.host : $ = $.parentNode;
    while ($ && $.nodeType !== 1 && $.nodeType !== 9);
    return $;
  }
};
each(["Width", "Height"], function(a) {
  domUtils["doc".concat(a)] = function(s) {
    var $ = s.document;
    return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      $.documentElement["scroll".concat(a)],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      $.body["scroll".concat(a)],
      domUtils["viewport".concat(a)]($)
    );
  }, domUtils["viewport".concat(a)] = function(s) {
    var $ = "client".concat(a), _ = s.document, _e = _.body, tt = _.documentElement, nt = tt[$];
    return _.compatMode === "CSS1Compat" && nt || _e && _e[$] || nt;
  };
});
function getWH(a, s, $) {
  var _ = $;
  if (isWindow$2(a))
    return s === "width" ? domUtils.viewportWidth(a) : domUtils.viewportHeight(a);
  if (a.nodeType === 9)
    return s === "width" ? domUtils.docWidth(a) : domUtils.docHeight(a);
  var _e = s === "width" ? ["Left", "Right"] : ["Top", "Bottom"], tt = Math.floor(s === "width" ? a.getBoundingClientRect().width : a.getBoundingClientRect().height), nt = isBorderBoxFn(a), at = 0;
  (tt == null || tt <= 0) && (tt = void 0, at = getComputedStyleX(a, s), (at == null || Number(at) < 0) && (at = a.style[s] || 0), at = Math.floor(parseFloat(at)) || 0), _ === void 0 && (_ = nt ? BORDER_INDEX : CONTENT_INDEX);
  var ot = tt !== void 0 || nt, rt = tt || at;
  return _ === CONTENT_INDEX ? ot ? rt - getPBMWidth(a, ["border", "padding"], _e) : at : ot ? _ === BORDER_INDEX ? rt : rt + (_ === PADDING_INDEX ? -getPBMWidth(a, ["border"], _e) : getPBMWidth(a, ["margin"], _e)) : at + getPBMWidth(a, BOX_MODELS.slice(_), _e);
}
var cssShow = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function getWHIgnoreDisplay() {
  for (var a = arguments.length, s = new Array(a), $ = 0; $ < a; $++)
    s[$] = arguments[$];
  var _, _e = s[0];
  return _e.offsetWidth !== 0 ? _ = getWH.apply(void 0, s) : swap$1(_e, cssShow, function() {
    _ = getWH.apply(void 0, s);
  }), _;
}
each(["width", "height"], function(a) {
  var s = a.charAt(0).toUpperCase() + a.slice(1);
  domUtils["outer".concat(s)] = function(_, _e) {
    return _ && getWHIgnoreDisplay(_, a, _e ? MARGIN_INDEX : BORDER_INDEX);
  };
  var $ = a === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  domUtils[a] = function(_, _e) {
    var tt = _e;
    if (tt !== void 0) {
      if (_) {
        var nt = isBorderBoxFn(_);
        return nt && (tt += getPBMWidth(_, ["padding", "border"], $)), css(_, a, tt);
      }
      return;
    }
    return _ && getWHIgnoreDisplay(_, a, CONTENT_INDEX);
  };
});
function mix$1(a, s) {
  for (var $ in s)
    s.hasOwnProperty($) && (a[$] = s[$]);
  return a;
}
var utils$1 = {
  getWindow: function a(s) {
    if (s && s.document && s.setTimeout)
      return s;
    var $ = s.ownerDocument || s;
    return $.defaultView || $.parentWindow;
  },
  getDocument: getDocument$1,
  offset: function a(s, $, _) {
    if (typeof $ < "u")
      setOffset(s, $, _ || {});
    else
      return getOffset(s);
  },
  isWindow: isWindow$2,
  each,
  css,
  clone: function a(s) {
    var $, _ = {};
    for ($ in s)
      s.hasOwnProperty($) && (_[$] = s[$]);
    var _e = s.overflow;
    if (_e)
      for ($ in s)
        s.hasOwnProperty($) && (_.overflow[$] = s.overflow[$]);
    return _;
  },
  mix: mix$1,
  getWindowScrollLeft: function a(s) {
    return getScrollLeft(s);
  },
  getWindowScrollTop: function a(s) {
    return getScrollTop(s);
  },
  merge: function a() {
    for (var s = {}, $ = 0; $ < arguments.length; $++)
      utils$1.mix(s, $ < 0 || arguments.length <= $ ? void 0 : arguments[$]);
    return s;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix$1(utils$1, domUtils);
var getParent = utils$1.getParent;
function getOffsetParent(a) {
  if (utils$1.isWindow(a) || a.nodeType === 9)
    return null;
  var s = utils$1.getDocument(a), $ = s.body, _, _e = utils$1.css(a, "position"), tt = _e === "fixed" || _e === "absolute";
  if (!tt)
    return a.nodeName.toLowerCase() === "html" ? null : getParent(a);
  for (_ = getParent(a); _ && _ !== $ && _.nodeType !== 9; _ = getParent(_))
    if (_e = utils$1.css(_, "position"), _e !== "static")
      return _;
  return null;
}
var getParent$1 = utils$1.getParent;
function isAncestorFixed(a) {
  if (utils$1.isWindow(a) || a.nodeType === 9)
    return !1;
  var s = utils$1.getDocument(a), $ = s.body, _ = null;
  for (
    _ = getParent$1(a);
    // 修复元素位于 document.documentElement 下导致崩溃问题
    _ && _ !== $ && _ !== s;
    _ = getParent$1(_)
  ) {
    var _e = utils$1.css(_, "position");
    if (_e === "fixed")
      return !0;
  }
  return !1;
}
function getVisibleRectForElement(a, s) {
  for (var $ = {
    left: 0,
    right: 1 / 0,
    top: 0,
    bottom: 1 / 0
  }, _ = getOffsetParent(a), _e = utils$1.getDocument(a), tt = _e.defaultView || _e.parentWindow, nt = _e.body, at = _e.documentElement; _; ) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || _.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    _ !== nt && _ !== at && utils$1.css(_, "overflow") !== "visible") {
      var ot = utils$1.offset(_);
      ot.left += _.clientLeft, ot.top += _.clientTop, $.top = Math.max($.top, ot.top), $.right = Math.min(
        $.right,
        // consider area without scrollBar
        ot.left + _.clientWidth
      ), $.bottom = Math.min($.bottom, ot.top + _.clientHeight), $.left = Math.max($.left, ot.left);
    } else if (_ === nt || _ === at)
      break;
    _ = getOffsetParent(_);
  }
  var rt = null;
  if (!utils$1.isWindow(a) && a.nodeType !== 9) {
    rt = a.style.position;
    var st = utils$1.css(a, "position");
    st === "absolute" && (a.style.position = "fixed");
  }
  var lt = utils$1.getWindowScrollLeft(tt), et = utils$1.getWindowScrollTop(tt), it = utils$1.viewportWidth(tt), ut = utils$1.viewportHeight(tt), ft = at.scrollWidth, ht = at.scrollHeight, dt = window.getComputedStyle(nt);
  if (dt.overflowX === "hidden" && (ft = tt.innerWidth), dt.overflowY === "hidden" && (ht = tt.innerHeight), a.style && (a.style.position = rt), s || isAncestorFixed(a))
    $.left = Math.max($.left, lt), $.top = Math.max($.top, et), $.right = Math.min($.right, lt + it), $.bottom = Math.min($.bottom, et + ut);
  else {
    var gt = Math.max(ft, lt + it);
    $.right = Math.min($.right, gt);
    var pt = Math.max(ht, et + ut);
    $.bottom = Math.min($.bottom, pt);
  }
  return $.top >= 0 && $.left >= 0 && $.bottom > $.top && $.right > $.left ? $ : null;
}
function adjustForViewport(a, s, $, _) {
  var _e = utils$1.clone(a), tt = {
    width: s.width,
    height: s.height
  };
  return _.adjustX && _e.left < $.left && (_e.left = $.left), _.resizeWidth && _e.left >= $.left && _e.left + tt.width > $.right && (tt.width -= _e.left + tt.width - $.right), _.adjustX && _e.left + tt.width > $.right && (_e.left = Math.max($.right - tt.width, $.left)), _.adjustY && _e.top < $.top && (_e.top = $.top), _.resizeHeight && _e.top >= $.top && _e.top + tt.height > $.bottom && (tt.height -= _e.top + tt.height - $.bottom), _.adjustY && _e.top + tt.height > $.bottom && (_e.top = Math.max($.bottom - tt.height, $.top)), utils$1.mix(_e, tt);
}
function getRegion(a) {
  var s, $, _;
  if (!utils$1.isWindow(a) && a.nodeType !== 9)
    s = utils$1.offset(a), $ = utils$1.outerWidth(a), _ = utils$1.outerHeight(a);
  else {
    var _e = utils$1.getWindow(a);
    s = {
      left: utils$1.getWindowScrollLeft(_e),
      top: utils$1.getWindowScrollTop(_e)
    }, $ = utils$1.viewportWidth(_e), _ = utils$1.viewportHeight(_e);
  }
  return s.width = $, s.height = _, s;
}
function getAlignOffset(a, s) {
  var $ = s.charAt(0), _ = s.charAt(1), _e = a.width, tt = a.height, nt = a.left, at = a.top;
  return $ === "c" ? at += tt / 2 : $ === "b" && (at += tt), _ === "c" ? nt += _e / 2 : _ === "r" && (nt += _e), {
    left: nt,
    top: at
  };
}
function getElFuturePos(a, s, $, _, _e) {
  var tt = getAlignOffset(s, $[1]), nt = getAlignOffset(a, $[0]), at = [nt.left - tt.left, nt.top - tt.top];
  return {
    left: Math.round(a.left - at[0] + _[0] - _e[0]),
    top: Math.round(a.top - at[1] + _[1] - _e[1])
  };
}
function isFailX(a, s, $) {
  return a.left < $.left || a.left + s.width > $.right;
}
function isFailY(a, s, $) {
  return a.top < $.top || a.top + s.height > $.bottom;
}
function isCompleteFailX(a, s, $) {
  return a.left > $.right || a.left + s.width < $.left;
}
function isCompleteFailY(a, s, $) {
  return a.top > $.bottom || a.top + s.height < $.top;
}
function flip(a, s, $) {
  var _ = [];
  return utils$1.each(a, function(_e) {
    _.push(_e.replace(s, function(tt) {
      return $[tt];
    }));
  }), _;
}
function flipOffset(a, s) {
  return a[s] = -a[s], a;
}
function convertOffset(a, s) {
  var $;
  return /%$/.test(a) ? $ = parseInt(a.substring(0, a.length - 1), 10) / 100 * s : $ = parseInt(a, 10), $ || 0;
}
function normalizeOffset(a, s) {
  a[0] = convertOffset(a[0], s.width), a[1] = convertOffset(a[1], s.height);
}
function doAlign(a, s, $, _) {
  var _e = $.points, tt = $.offset || [0, 0], nt = $.targetOffset || [0, 0], at = $.overflow, ot = $.source || a;
  tt = [].concat(tt), nt = [].concat(nt), at = at || {};
  var rt = {}, st = 0, lt = !!(at && at.alwaysByViewport), et = getVisibleRectForElement(ot, lt), it = getRegion(ot);
  normalizeOffset(tt, it), normalizeOffset(nt, s);
  var ut = getElFuturePos(it, s, _e, tt, nt), ft = utils$1.merge(it, ut);
  if (et && (at.adjustX || at.adjustY) && _) {
    if (at.adjustX && isFailX(ut, it, et)) {
      var ht = flip(_e, /[lr]/gi, {
        l: "r",
        r: "l"
      }), dt = flipOffset(tt, 0), gt = flipOffset(nt, 0), pt = getElFuturePos(it, s, ht, dt, gt);
      isCompleteFailX(pt, it, et) || (st = 1, _e = ht, tt = dt, nt = gt);
    }
    if (at.adjustY && isFailY(ut, it, et)) {
      var mt = flip(_e, /[tb]/gi, {
        t: "b",
        b: "t"
      }), ct = flipOffset(tt, 1), vt = flipOffset(nt, 1), At = getElFuturePos(it, s, mt, ct, vt);
      isCompleteFailY(At, it, et) || (st = 1, _e = mt, tt = ct, nt = vt);
    }
    st && (ut = getElFuturePos(it, s, _e, tt, nt), utils$1.mix(ft, ut));
    var xt = isFailX(ut, it, et), bt = isFailY(ut, it, et);
    if (xt || bt) {
      var Et = _e;
      xt && (Et = flip(_e, /[lr]/gi, {
        l: "r",
        r: "l"
      })), bt && (Et = flip(_e, /[tb]/gi, {
        t: "b",
        b: "t"
      })), _e = Et, tt = $.offset || [0, 0], nt = $.targetOffset || [0, 0];
    }
    rt.adjustX = at.adjustX && xt, rt.adjustY = at.adjustY && bt, (rt.adjustX || rt.adjustY) && (ft = adjustForViewport(ut, it, et, rt));
  }
  return ft.width !== it.width && utils$1.css(ot, "width", utils$1.width(ot) + ft.width - it.width), ft.height !== it.height && utils$1.css(ot, "height", utils$1.height(ot) + ft.height - it.height), utils$1.offset(ot, {
    left: ft.left,
    top: ft.top
  }, {
    useCssRight: $.useCssRight,
    useCssBottom: $.useCssBottom,
    useCssTransform: $.useCssTransform,
    ignoreShake: $.ignoreShake
  }), {
    points: _e,
    offset: tt,
    targetOffset: nt,
    overflow: rt
  };
}
function isOutOfVisibleRect(a, s) {
  var $ = getVisibleRectForElement(a, s), _ = getRegion(a);
  return !$ || _.left + _.width <= $.left || _.top + _.height <= $.top || _.left >= $.right || _.top >= $.bottom;
}
function alignElement(a, s, $) {
  var _ = $.target || s, _e = getRegion(_), tt = !isOutOfVisibleRect(_, $.overflow && $.overflow.alwaysByViewport);
  return doAlign(a, _e, $, tt);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;
function alignPoint(a, s, $) {
  var _, _e, tt = utils$1.getDocument(a), nt = tt.defaultView || tt.parentWindow, at = utils$1.getWindowScrollLeft(nt), ot = utils$1.getWindowScrollTop(nt), rt = utils$1.viewportWidth(nt), st = utils$1.viewportHeight(nt);
  "pageX" in s ? _ = s.pageX : _ = at + s.clientX, "pageY" in s ? _e = s.pageY : _e = ot + s.clientY;
  var lt = {
    left: _,
    top: _e,
    width: 0,
    height: 0
  }, et = _ >= 0 && _ <= at + rt && _e >= 0 && _e <= ot + st, it = [$.points[0], "cc"];
  return doAlign(a, lt, _objectSpread2$9(_objectSpread2$9({}, $), {}, {
    points: it
  }), et);
}
function addEventListenerWrap$1(a, s, $, _) {
  var _e = ReactDOM.unstable_batchedUpdates ? function(nt) {
    ReactDOM.unstable_batchedUpdates($, nt);
  } : $;
  return addDOMEventListener(a, s, _e, _);
}
function contains$1(a, s) {
  for (var $ = s; $; ) {
    if ($ === a)
      return !0;
    $ = $.parentNode;
  }
  return !1;
}
function buffer(a, s) {
  var $ = void 0;
  function _() {
    $ && (clearTimeout($), $ = null);
  }
  function _e() {
    _(), $ = setTimeout(a, s);
  }
  return _e.clear = _, _e;
}
function isSamePoint$1(a, s) {
  return a === s ? !0 : !a || !s ? !1 : "pageX" in s && "pageY" in s ? a.pageX === s.pageX && a.pageY === s.pageY : "clientX" in s && "clientY" in s ? a.clientX === s.clientX && a.clientY === s.clientY : !1;
}
function isWindow$1(a) {
  return a && typeof a == "object" && a.window === a;
}
function isSimilarValue(a, s) {
  var $ = Math.floor(a), _ = Math.floor(s);
  return Math.abs($ - _) <= 1;
}
function restoreFocus(a, s) {
  a !== document.activeElement && contains$1(s, a) && a.focus();
}
function getElement(a) {
  return typeof a != "function" || !a ? null : a();
}
function getPoint(a) {
  return typeof a != "object" || !a ? null : a;
}
var Align = function(a) {
  _default$c(s, a);
  function s() {
    var $, _, _e, tt;
    _default$g(this, s);
    for (var nt = arguments.length, at = Array(nt), ot = 0; ot < nt; ot++)
      at[ot] = arguments[ot];
    return tt = (_ = (_e = _default$d(this, ($ = s.__proto__ || Object.getPrototypeOf(s)).call.apply($, [this].concat(at))), _e), _e.forceAlign = function() {
      var rt = _e.props, st = rt.disabled, lt = rt.target, et = rt.align, it = rt.onAlign;
      if (!st && lt) {
        var ut = ReactDOM.findDOMNode(_e), ft = void 0, ht = getElement(lt), dt = getPoint(lt), gt = document.activeElement;
        ht ? ft = alignElement(ut, ht, et) : dt && (ft = alignPoint(ut, dt, et)), restoreFocus(gt, ut), it && it(ut, ft);
      }
    }, _), _default$d(_e, tt);
  }
  return _default$f(s, [{
    key: "componentDidMount",
    value: function() {
      var _ = this.props;
      this.forceAlign(), !_.disabled && _.monitorWindowResize && this.startMonitorWindowResize();
    }
  }, {
    key: "componentDidUpdate",
    value: function(_) {
      var _e = !1, tt = this.props;
      if (!tt.disabled) {
        var nt = ReactDOM.findDOMNode(this), at = nt ? nt.getBoundingClientRect() : null;
        if (_.disabled)
          _e = !0;
        else {
          var ot = getElement(_.target), rt = getElement(tt.target), st = getPoint(_.target), lt = getPoint(tt.target);
          isWindow$1(ot) && isWindow$1(rt) ? _e = !1 : (ot !== rt || // Element change
          ot && !rt && lt || // Change from element to point
          st && lt && rt || // Change from point to element
          lt && !isSamePoint$1(st, lt)) && (_e = !0);
          var et = this.sourceRect || {};
          !_e && nt && (!isSimilarValue(et.width, at.width) || !isSimilarValue(et.height, at.height)) && (_e = !0);
        }
        this.sourceRect = at;
      }
      _e && this.forceAlign(), tt.monitorWindowResize && !tt.disabled ? this.startMonitorWindowResize() : this.stopMonitorWindowResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: "startMonitorWindowResize",
    value: function() {
      this.resizeHandler || (this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime), this.resizeHandler = addEventListenerWrap$1(window, "resize", this.bufferMonitor));
    }
  }, {
    key: "stopMonitorWindowResize",
    value: function() {
      this.resizeHandler && (this.bufferMonitor.clear(), this.resizeHandler.remove(), this.resizeHandler = null);
    }
  }, {
    key: "render",
    value: function() {
      var _ = this, _e = this.props, tt = _e.childrenProps, nt = _e.children, at = React$a.Children.only(nt);
      if (tt) {
        var ot = {}, rt = Object.keys(tt);
        return rt.forEach(function(st) {
          ot[st] = _.props[tt[st]];
        }), React$a.cloneElement(at, ot);
      }
      return at;
    }
  }]), s;
}(reactExports.Component);
Align.propTypes = {
  childrenProps: PropTypes.object,
  align: PropTypes.object.isRequired,
  target: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    clientX: PropTypes.number,
    clientY: PropTypes.number,
    pageX: PropTypes.number,
    pageY: PropTypes.number
  })]),
  onAlign: PropTypes.func,
  monitorBufferTime: PropTypes.number,
  monitorWindowResize: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.any
};
Align.defaultProps = {
  target: function a() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: !1,
  disabled: !1
};
var _defineProperty$6 = defineProperty$2, _defineProperty2 = _interopRequireDefault$b(_defineProperty$6);
function _interopRequireDefault$b(a) {
  return a && a.__esModule ? a : { default: a };
}
var _default$b = function(a, s, $) {
  return s in a ? (0, _defineProperty2.default)(a, s, {
    value: $,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[s] = $, a;
}, unsafeLifecyclesPolyfill = function a(s) {
  var $ = s.prototype;
  if (!$ || !$.isReactComponent)
    throw new Error("Can only polyfill class components");
  return typeof $.componentWillReceiveProps != "function" || !React$a.Profiler || ($.UNSAFE_componentWillReceiveProps = $.componentWillReceiveProps, delete $.componentWillReceiveProps), s;
};
function toArrayChildren(a) {
  var s = [];
  return React$a.Children.forEach(a, function($) {
    s.push($);
  }), s;
}
function findChildInChildrenByKey(a, s) {
  var $ = null;
  return a && a.forEach(function(_) {
    $ || _ && _.key === s && ($ = _);
  }), $;
}
function findShownChildInChildrenByKey(a, s, $) {
  var _ = null;
  return a && a.forEach(function(_e) {
    if (_e && _e.key === s && _e.props[$]) {
      if (_)
        throw new Error("two child with same key for <rc-animate> children");
      _ = _e;
    }
  }), _;
}
function isSameChildren(a, s, $) {
  var _ = a.length === s.length;
  return _ && a.forEach(function(_e, tt) {
    var nt = s[tt];
    _e && nt && (_e && !nt || !_e && nt || _e.key !== nt.key || $ && _e.props[$] !== nt.props[$]) && (_ = !1);
  }), _;
}
function mergeChildren(a, s) {
  var $ = [], _ = {}, _e = [];
  return a.forEach(function(tt) {
    tt && findChildInChildrenByKey(s, tt.key) ? _e.length && (_[tt.key] = _e, _e = []) : _e.push(tt);
  }), s.forEach(function(tt) {
    tt && Object.prototype.hasOwnProperty.call(_, tt.key) && ($ = $.concat(_[tt.key])), $.push(tt);
  }), $ = $.concat(_e), $;
}
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: "transitionstart",
    WebkitTransition: "webkitTransitionStart",
    MozTransition: "mozTransitionStart",
    OTransition: "oTransitionStart",
    msTransition: "MSTransitionStart"
  },
  animationstart: {
    animation: "animationstart",
    WebkitAnimation: "webkitAnimationStart",
    MozAnimation: "mozAnimationStart",
    OAnimation: "oAnimationStart",
    msAnimation: "MSAnimationStart"
  }
}, END_EVENT_NAME_MAP = {
  transitionend: {
    transition: "transitionend",
    WebkitTransition: "webkitTransitionEnd",
    MozTransition: "mozTransitionEnd",
    OTransition: "oTransitionEnd",
    msTransition: "MSTransitionEnd"
  },
  animationend: {
    animation: "animationend",
    WebkitAnimation: "webkitAnimationEnd",
    MozAnimation: "mozAnimationEnd",
    OAnimation: "oAnimationEnd",
    msAnimation: "MSAnimationEnd"
  }
}, startEvents = [], endEvents = [];
function detectEvents() {
  var a = document.createElement("div"), s = a.style;
  "AnimationEvent" in window || (delete START_EVENT_NAME_MAP.animationstart.animation, delete END_EVENT_NAME_MAP.animationend.animation), "TransitionEvent" in window || (delete START_EVENT_NAME_MAP.transitionstart.transition, delete END_EVENT_NAME_MAP.transitionend.transition);
  function $(_, _e) {
    for (var tt in _)
      if (_.hasOwnProperty(tt)) {
        var nt = _[tt];
        for (var at in nt)
          if (at in s) {
            _e.push(nt[at]);
            break;
          }
      }
  }
  $(START_EVENT_NAME_MAP, startEvents), $(END_EVENT_NAME_MAP, endEvents);
}
typeof window < "u" && typeof document < "u" && detectEvents();
function addEventListener$1(a, s, $) {
  a.addEventListener(s, $, !1);
}
function removeEventListener(a, s, $) {
  a.removeEventListener(s, $, !1);
}
var TransitionEvents = {
  // Start events
  startEvents,
  addStartEventListener: function a(s, $) {
    if (startEvents.length === 0) {
      window.setTimeout($, 0);
      return;
    }
    startEvents.forEach(function(_) {
      addEventListener$1(s, _, $);
    });
  },
  removeStartEventListener: function a(s, $) {
    startEvents.length !== 0 && startEvents.forEach(function(_) {
      removeEventListener(s, _, $);
    });
  },
  // End events
  endEvents,
  addEndEventListener: function a(s, $) {
    if (endEvents.length === 0) {
      window.setTimeout($, 0);
      return;
    }
    endEvents.forEach(function(_) {
      addEventListener$1(s, _, $);
    });
  },
  removeEndEventListener: function a(s, $) {
    endEvents.length !== 0 && endEvents.forEach(function(_) {
      removeEventListener(s, _, $);
    });
  }
}, componentIndexof, hasRequiredComponentIndexof;
function requireComponentIndexof() {
  return hasRequiredComponentIndexof || (hasRequiredComponentIndexof = 1, componentIndexof = function(a, s) {
    if (a.indexOf)
      return a.indexOf(s);
    for (var $ = 0; $ < a.length; ++$)
      if (a[$] === s)
        return $;
    return -1;
  }), componentIndexof;
}
try {
  var index$1 = requireComponentIndexof();
} catch (a) {
  var index$1 = requireComponentIndexof();
}
var re = /\s+/, toString = Object.prototype.toString, componentClasses = function(a) {
  return new ClassList(a);
};
function ClassList(a) {
  if (!a || !a.nodeType)
    throw new Error("A DOM element reference is required");
  this.el = a, this.list = a.classList;
}
ClassList.prototype.add = function(a) {
  if (this.list)
    return this.list.add(a), this;
  var s = this.array(), $ = index$1(s, a);
  return ~$ || s.push(a), this.el.className = s.join(" "), this;
};
ClassList.prototype.remove = function(a) {
  if (toString.call(a) == "[object RegExp]")
    return this.removeMatching(a);
  if (this.list)
    return this.list.remove(a), this;
  var s = this.array(), $ = index$1(s, a);
  return ~$ && s.splice($, 1), this.el.className = s.join(" "), this;
};
ClassList.prototype.removeMatching = function(a) {
  for (var s = this.array(), $ = 0; $ < s.length; $++)
    a.test(s[$]) && this.remove(s[$]);
  return this;
};
ClassList.prototype.toggle = function(a, s) {
  return this.list ? (typeof s < "u" ? s !== this.list.toggle(a, s) && this.list.toggle(a) : this.list.toggle(a), this) : (typeof s < "u" ? s ? this.add(a) : this.remove(a) : this.has(a) ? this.remove(a) : this.add(a), this);
};
ClassList.prototype.array = function() {
  var a = this.el.getAttribute("class") || "", s = a.replace(/^\s+|\s+$/g, ""), $ = s.split(re);
  return $[0] === "" && $.shift(), $;
};
ClassList.prototype.has = ClassList.prototype.contains = function(a) {
  return this.list ? this.list.contains(a) : !!~index$1(this.array(), a);
};
const classes = /* @__PURE__ */ getDefaultExportFromCjs(componentClasses);
var isCssAnimationSupported = TransitionEvents.endEvents.length !== 0, capitalPrefixes = [
  "Webkit",
  "Moz",
  "O",
  // ms is special .... !
  "ms"
], prefixes = ["-webkit-", "-moz-", "-o-", "ms-", ""];
function getStyleProperty(a, s) {
  for (var $ = window.getComputedStyle(a, null), _ = "", _e = 0; _e < prefixes.length && (_ = $.getPropertyValue(prefixes[_e] + s), !_); _e++)
    ;
  return _;
}
function fixBrowserByTimeout(a) {
  if (isCssAnimationSupported) {
    var s = parseFloat(getStyleProperty(a, "transition-delay")) || 0, $ = parseFloat(getStyleProperty(a, "transition-duration")) || 0, _ = parseFloat(getStyleProperty(a, "animation-delay")) || 0, _e = parseFloat(getStyleProperty(a, "animation-duration")) || 0, tt = Math.max($ + s, _e + _);
    a.rcEndAnimTimeout = setTimeout(function() {
      a.rcEndAnimTimeout = null, a.rcEndListener && a.rcEndListener();
    }, tt * 1e3 + 200);
  }
}
function clearBrowserBugTimeout(a) {
  a.rcEndAnimTimeout && (clearTimeout(a.rcEndAnimTimeout), a.rcEndAnimTimeout = null);
}
var cssAnimation = function a(s, $, _) {
  var _e = (typeof $ > "u" ? "undefined" : _default$e($)) === "object", tt = _e ? $.name : $, nt = _e ? $.active : $ + "-active", at = _, ot = void 0, rt = void 0, st = classes(s);
  return _ && Object.prototype.toString.call(_) === "[object Object]" && (at = _.end, ot = _.start, rt = _.active), s.rcEndListener && s.rcEndListener(), s.rcEndListener = function(lt) {
    lt && lt.target !== s || (s.rcAnimTimeout && (clearTimeout(s.rcAnimTimeout), s.rcAnimTimeout = null), clearBrowserBugTimeout(s), st.remove(tt), st.remove(nt), TransitionEvents.removeEndEventListener(s, s.rcEndListener), s.rcEndListener = null, at && at());
  }, TransitionEvents.addEndEventListener(s, s.rcEndListener), ot && ot(), st.add(tt), s.rcAnimTimeout = setTimeout(function() {
    s.rcAnimTimeout = null, st.add(nt), rt && setTimeout(rt, 0), fixBrowserByTimeout(s);
  }, 30), {
    stop: function() {
      s.rcEndListener && s.rcEndListener();
    }
  };
};
cssAnimation.style = function(a, s, $) {
  a.rcEndListener && a.rcEndListener(), a.rcEndListener = function(_) {
    _ && _.target !== a || (a.rcAnimTimeout && (clearTimeout(a.rcAnimTimeout), a.rcAnimTimeout = null), clearBrowserBugTimeout(a), TransitionEvents.removeEndEventListener(a, a.rcEndListener), a.rcEndListener = null, $ && $());
  }, TransitionEvents.addEndEventListener(a, a.rcEndListener), a.rcAnimTimeout = setTimeout(function() {
    for (var _ in s)
      s.hasOwnProperty(_) && (a.style[_] = s[_]);
    a.rcAnimTimeout = null, fixBrowserByTimeout(a);
  }, 0);
};
cssAnimation.setTransition = function(a, s, $) {
  var _ = s, _e = $;
  $ === void 0 && (_e = _, _ = ""), _ = _ || "", capitalPrefixes.forEach(function(tt) {
    a.style[tt + "Transition" + _] = _e;
  });
};
cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
var util = {
  isAppearSupported: function a(s) {
    return s.transitionName && s.transitionAppear || s.animation.appear;
  },
  isEnterSupported: function a(s) {
    return s.transitionName && s.transitionEnter || s.animation.enter;
  },
  isLeaveSupported: function a(s) {
    return s.transitionName && s.transitionLeave || s.animation.leave;
  },
  allowAppearCallback: function a(s) {
    return s.transitionAppear || s.animation.appear;
  },
  allowEnterCallback: function a(s) {
    return s.transitionEnter || s.animation.enter;
  },
  allowLeaveCallback: function a(s) {
    return s.transitionLeave || s.animation.leave;
  }
}, transitionMap = {
  enter: "transitionEnter",
  appear: "transitionAppear",
  leave: "transitionLeave"
}, AnimateChild = function(a) {
  _default$c(s, a);
  function s() {
    return _default$g(this, s), _default$d(this, (s.__proto__ || Object.getPrototypeOf(s)).apply(this, arguments));
  }
  return _default$f(s, [{
    key: "componentWillUnmount",
    value: function() {
      this.stop();
    }
  }, {
    key: "componentWillEnter",
    value: function(_) {
      util.isEnterSupported(this.props) ? this.transition("enter", _) : _();
    }
  }, {
    key: "componentWillAppear",
    value: function(_) {
      util.isAppearSupported(this.props) ? this.transition("appear", _) : _();
    }
  }, {
    key: "componentWillLeave",
    value: function(_) {
      util.isLeaveSupported(this.props) ? this.transition("leave", _) : _();
    }
  }, {
    key: "transition",
    value: function(_, _e) {
      var tt = this, nt = ReactDOM.findDOMNode(this), at = this.props, ot = at.transitionName, rt = typeof ot == "object";
      this.stop();
      var st = function() {
        tt.stopper = null, _e();
      };
      if ((isCssAnimationSupported || !at.animation[_]) && ot && at[transitionMap[_]]) {
        var lt = rt ? ot[_] : ot + "-" + _, et = lt + "-active";
        rt && ot[_ + "Active"] && (et = ot[_ + "Active"]), this.stopper = cssAnimation(nt, {
          name: lt,
          active: et
        }, st);
      } else
        this.stopper = at.animation[_](nt, st);
    }
  }, {
    key: "stop",
    value: function() {
      var _ = this.stopper;
      _ && (this.stopper = null, _.stop());
    }
  }, {
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), s;
}(React$a.Component);
AnimateChild.propTypes = {
  children: PropTypes.any,
  animation: PropTypes.any,
  transitionName: PropTypes.any
};
var defaultKey = "rc_animate_" + Date.now();
function getChildrenFromProps(a) {
  var s = a.children;
  return React$a.isValidElement(s) && !s.key ? React$a.cloneElement(s, {
    key: defaultKey
  }) : s;
}
function noop$1() {
}
var Animate = function(a) {
  _default$c(s, a);
  function s($) {
    _default$g(this, s);
    var _ = _default$d(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this, $));
    return _initialiseProps$1.call(_), _.currentlyAnimatingKeys = {}, _.keysToEnter = [], _.keysToLeave = [], _.state = {
      children: toArrayChildren(getChildrenFromProps($))
    }, _.childrenRefs = {}, _;
  }
  return _default$f(s, [{
    key: "componentDidMount",
    value: function() {
      var _ = this, _e = this.props.showProp, tt = this.state.children;
      _e && (tt = tt.filter(function(nt) {
        return !!nt.props[_e];
      })), tt.forEach(function(nt) {
        nt && _.performAppear(nt.key);
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function(_) {
      var _e = this;
      this.nextProps = _;
      var tt = toArrayChildren(getChildrenFromProps(_)), nt = this.props;
      nt.exclusive && Object.keys(this.currentlyAnimatingKeys).forEach(function(lt) {
        _e.stop(lt);
      });
      var at = nt.showProp, ot = this.currentlyAnimatingKeys, rt = nt.exclusive ? toArrayChildren(getChildrenFromProps(nt)) : this.state.children, st = [];
      at ? (rt.forEach(function(lt) {
        var et = lt && findChildInChildrenByKey(tt, lt.key), it = void 0;
        (!et || !et.props[at]) && lt.props[at] ? it = React$a.cloneElement(et || lt, _default$b({}, at, !0)) : it = et, it && st.push(it);
      }), tt.forEach(function(lt) {
        (!lt || !findChildInChildrenByKey(rt, lt.key)) && st.push(lt);
      })) : st = mergeChildren(rt, tt), this.setState({
        children: st
      }), tt.forEach(function(lt) {
        var et = lt && lt.key;
        if (!(lt && ot[et])) {
          var it = lt && findChildInChildrenByKey(rt, et);
          if (at) {
            var ut = lt.props[at];
            if (it) {
              var ft = findShownChildInChildrenByKey(rt, et, at);
              !ft && ut && _e.keysToEnter.push(et);
            } else
              ut && _e.keysToEnter.push(et);
          } else
            it || _e.keysToEnter.push(et);
        }
      }), rt.forEach(function(lt) {
        var et = lt && lt.key;
        if (!(lt && ot[et])) {
          var it = lt && findChildInChildrenByKey(tt, et);
          if (at) {
            var ut = lt.props[at];
            if (it) {
              var ft = findShownChildInChildrenByKey(tt, et, at);
              !ft && ut && _e.keysToLeave.push(et);
            } else
              ut && _e.keysToLeave.push(et);
          } else
            it || _e.keysToLeave.push(et);
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var _ = this.keysToEnter;
      this.keysToEnter = [], _.forEach(this.performEnter);
      var _e = this.keysToLeave;
      this.keysToLeave = [], _e.forEach(this.performLeave);
    }
  }, {
    key: "isValidChildByKey",
    value: function(_, _e) {
      var tt = this.props.showProp;
      return tt ? findShownChildInChildrenByKey(_, _e, tt) : findChildInChildrenByKey(_, _e);
    }
  }, {
    key: "stop",
    value: function(_) {
      delete this.currentlyAnimatingKeys[_];
      var _e = this.childrenRefs[_];
      _e && _e.stop();
    }
  }, {
    key: "render",
    value: function() {
      var _ = this, _e = this.props;
      this.nextProps = _e;
      var tt = this.state.children, nt = null;
      tt && (nt = tt.map(function(rt) {
        if (rt == null)
          return rt;
        if (!rt.key)
          throw new Error("must set key for <rc-animate> children");
        return React$a.createElement(
          AnimateChild,
          {
            key: rt.key,
            ref: function(lt) {
              _.childrenRefs[rt.key] = lt;
            },
            animation: _e.animation,
            transitionName: _e.transitionName,
            transitionEnter: _e.transitionEnter,
            transitionAppear: _e.transitionAppear,
            transitionLeave: _e.transitionLeave
          },
          rt
        );
      }));
      var at = _e.component;
      if (at) {
        var ot = _e;
        return typeof at == "string" && (ot = _default$i({
          className: _e.className,
          style: _e.style
        }, _e.componentProps)), React$a.createElement(
          at,
          ot,
          nt
        );
      }
      return nt[0] || null;
    }
  }]), s;
}(React$a.Component);
Animate.isAnimate = !0;
Animate.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  component: PropTypes.any,
  componentProps: PropTypes.object,
  animation: PropTypes.object,
  transitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  transitionEnter: PropTypes.bool,
  transitionAppear: PropTypes.bool,
  exclusive: PropTypes.bool,
  transitionLeave: PropTypes.bool,
  onEnd: PropTypes.func,
  onEnter: PropTypes.func,
  onLeave: PropTypes.func,
  onAppear: PropTypes.func,
  showProp: PropTypes.string,
  children: PropTypes.node
};
Animate.defaultProps = {
  animation: {},
  component: "span",
  componentProps: {},
  transitionEnter: !0,
  transitionLeave: !0,
  transitionAppear: !1,
  onEnd: noop$1,
  onEnter: noop$1,
  onLeave: noop$1,
  onAppear: noop$1
};
var _initialiseProps$1 = function a() {
  var s = this;
  this.performEnter = function($) {
    s.childrenRefs[$] && (s.currentlyAnimatingKeys[$] = !0, s.childrenRefs[$].componentWillEnter(s.handleDoneAdding.bind(s, $, "enter")));
  }, this.performAppear = function($) {
    s.childrenRefs[$] && (s.currentlyAnimatingKeys[$] = !0, s.childrenRefs[$].componentWillAppear(s.handleDoneAdding.bind(s, $, "appear")));
  }, this.handleDoneAdding = function($, _) {
    var _e = s.props;
    if (delete s.currentlyAnimatingKeys[$], !(_e.exclusive && _e !== s.nextProps)) {
      var tt = toArrayChildren(getChildrenFromProps(_e));
      s.isValidChildByKey(tt, $) ? _ === "appear" ? util.allowAppearCallback(_e) && (_e.onAppear($), _e.onEnd($, !0)) : util.allowEnterCallback(_e) && (_e.onEnter($), _e.onEnd($, !0)) : s.performLeave($);
    }
  }, this.performLeave = function($) {
    s.childrenRefs[$] && (s.currentlyAnimatingKeys[$] = !0, s.childrenRefs[$].componentWillLeave(s.handleDoneLeaving.bind(s, $)));
  }, this.handleDoneLeaving = function($) {
    var _ = s.props;
    if (delete s.currentlyAnimatingKeys[$], !(_.exclusive && _ !== s.nextProps)) {
      var _e = toArrayChildren(getChildrenFromProps(_));
      if (s.isValidChildByKey(_e, $))
        s.performEnter($);
      else {
        var tt = function() {
          util.allowLeaveCallback(_) && (_.onLeave($), _.onEnd($, !1));
        };
        isSameChildren(s.state.children, _e, _.showProp) ? tt() : s.setState({
          children: _e
        }, tt);
      }
    }
  };
};
const Animate$1 = unsafeLifecyclesPolyfill(Animate);
var _default$a = function(a, s) {
  var $ = {};
  for (var _ in a)
    s.indexOf(_) >= 0 || Object.prototype.hasOwnProperty.call(a, _) && ($[_] = a[_]);
  return $;
}, LazyRenderBox = function(a) {
  _default$c(s, a);
  function s() {
    return _default$g(this, s), _default$d(this, (s.__proto__ || Object.getPrototypeOf(s)).apply(this, arguments));
  }
  return _default$f(s, [{
    key: "shouldComponentUpdate",
    value: function(_) {
      return _.hiddenClassName || _.visible;
    }
  }, {
    key: "render",
    value: function() {
      var _ = this.props, _e = _.hiddenClassName, tt = _.visible, nt = _default$a(_, ["hiddenClassName", "visible"]);
      return _e || React$a.Children.count(nt.children) > 1 ? (!tt && _e && (nt.className += " " + _e), React$a.createElement("div", nt)) : React$a.Children.only(nt.children);
    }
  }]), s;
}(reactExports.Component);
LazyRenderBox.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  visible: PropTypes.bool,
  hiddenClassName: PropTypes.string
};
var PopupInner = function(a) {
  _default$c(s, a);
  function s() {
    return _default$g(this, s), _default$d(this, (s.__proto__ || Object.getPrototypeOf(s)).apply(this, arguments));
  }
  return _default$f(s, [{
    key: "render",
    value: function() {
      var _ = this.props, _e = _.className;
      return _.visible || (_e += " " + _.hiddenClassName), React$a.createElement(
        "div",
        {
          className: _e,
          onMouseEnter: _.onMouseEnter,
          onMouseLeave: _.onMouseLeave,
          style: _.style
        },
        React$a.createElement(
          LazyRenderBox,
          { className: _.prefixCls + "-content", visible: _.visible },
          _.children
        )
      );
    }
  }]), s;
}(reactExports.Component);
PopupInner.propTypes = {
  hiddenClassName: PropTypes.string,
  className: PropTypes.string,
  prefixCls: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  children: PropTypes.any
};
function isPointsEq(a, s) {
  return a[0] === s[0] && a[1] === s[1];
}
function getAlignFromPlacement(a, s, $) {
  var _ = a[s] || {};
  return _default$i({}, _, $);
}
function getPopupClassNameFromAlign(a, s, $) {
  var _ = $.points;
  for (var _e in a)
    if (a.hasOwnProperty(_e) && isPointsEq(a[_e].points, _))
      return s + "-placement-" + _e;
  return "";
}
function saveRef(a, s) {
  this[a] = s;
}
var Popup = function(a) {
  _default$c(s, a);
  function s($) {
    _default$g(this, s);
    var _ = _default$d(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this, $));
    return _initialiseProps.call(_), _.savePopupRef = saveRef.bind(_, "popupInstance"), _.saveAlignRef = saveRef.bind(_, "alignInstance"), _;
  }
  return _default$f(s, [{
    key: "componentDidMount",
    value: function() {
      this.rootNode = this.getPopupDomNode();
    }
  }, {
    key: "getPopupDomNode",
    value: function() {
      return ReactDOM.findDOMNode(this.popupInstance);
    }
  }, {
    key: "getMaskTransitionName",
    value: function() {
      var _ = this.props, _e = _.maskTransitionName, tt = _.maskAnimation;
      return !_e && tt && (_e = _.prefixCls + "-" + tt), _e;
    }
  }, {
    key: "getTransitionName",
    value: function() {
      var _ = this.props, _e = _.transitionName;
      return !_e && _.animation && (_e = _.prefixCls + "-" + _.animation), _e;
    }
  }, {
    key: "getClassName",
    value: function(_) {
      return this.props.prefixCls + " " + this.props.className + " " + _;
    }
  }, {
    key: "getPopupElement",
    value: function() {
      var _ = this.savePopupRef, _e = this.props, tt = _e.align, nt = _e.style, at = _e.visible, ot = _e.prefixCls, rt = _e.destroyPopupOnHide, st = this.getClassName(this.currentAlignClassName || _e.getClassNameFromAlign(tt)), lt = ot + "-hidden";
      at || (this.currentAlignClassName = null);
      var et = _default$i({}, nt, this.getZIndexStyle()), it = {
        className: st,
        prefixCls: ot,
        ref: _,
        onMouseEnter: _e.onMouseEnter,
        onMouseLeave: _e.onMouseLeave,
        style: et
      };
      return rt ? React$a.createElement(
        Animate$1,
        {
          component: "",
          exclusive: !0,
          transitionAppear: !0,
          transitionName: this.getTransitionName()
        },
        at ? React$a.createElement(
          Align,
          {
            target: this.getTarget,
            key: "popup",
            ref: this.saveAlignRef,
            monitorWindowResize: !0,
            align: tt,
            onAlign: this.onAlign
          },
          React$a.createElement(
            PopupInner,
            _default$i({
              visible: !0
            }, it),
            _e.children
          )
        ) : null
      ) : React$a.createElement(
        Animate$1,
        {
          component: "",
          exclusive: !0,
          transitionAppear: !0,
          transitionName: this.getTransitionName(),
          showProp: "xVisible"
        },
        React$a.createElement(
          Align,
          {
            target: this.getTarget,
            key: "popup",
            ref: this.saveAlignRef,
            monitorWindowResize: !0,
            xVisible: at,
            childrenProps: { visible: "xVisible" },
            disabled: !at,
            align: tt,
            onAlign: this.onAlign
          },
          React$a.createElement(
            PopupInner,
            _default$i({
              hiddenClassName: lt
            }, it),
            _e.children
          )
        )
      );
    }
  }, {
    key: "getZIndexStyle",
    value: function() {
      var _ = {}, _e = this.props;
      return _e.zIndex !== void 0 && (_.zIndex = _e.zIndex), _;
    }
  }, {
    key: "getMaskElement",
    value: function() {
      var _ = this.props, _e = void 0;
      if (_.mask) {
        var tt = this.getMaskTransitionName();
        _e = React$a.createElement(LazyRenderBox, {
          style: this.getZIndexStyle(),
          key: "mask",
          className: _.prefixCls + "-mask",
          hiddenClassName: _.prefixCls + "-mask-hidden",
          visible: _.visible
        }), tt && (_e = React$a.createElement(
          Animate$1,
          {
            key: "mask",
            showProp: "visible",
            transitionAppear: !0,
            component: "",
            transitionName: tt
          },
          _e
        ));
      }
      return _e;
    }
  }, {
    key: "render",
    value: function() {
      return React$a.createElement(
        "div",
        null,
        this.getMaskElement(),
        this.getPopupElement()
      );
    }
  }]), s;
}(reactExports.Component);
Popup.propTypes = {
  visible: PropTypes.bool,
  style: PropTypes.object,
  getClassNameFromAlign: PropTypes.func,
  onAlign: PropTypes.func,
  getRootDomNode: PropTypes.func,
  onMouseEnter: PropTypes.func,
  align: PropTypes.any,
  destroyPopupOnHide: PropTypes.bool,
  className: PropTypes.string,
  prefixCls: PropTypes.string,
  onMouseLeave: PropTypes.func
};
var _initialiseProps = function a() {
  var s = this;
  this.onAlign = function($, _) {
    var _e = s.props, tt = _e.getClassNameFromAlign(_);
    s.currentAlignClassName !== tt && (s.currentAlignClassName = tt, $.className = s.getClassName(tt)), _e.onAlign($, _);
  }, this.getTarget = function() {
    return s.props.getRootDomNode();
  };
}, getContainerRenderMixin$1 = {};
Object.defineProperty(getContainerRenderMixin$1, "__esModule", {
  value: !0
});
var _default$9 = getContainerRenderMixin$1.default = getContainerRenderMixin, _reactDom$1 = _interopRequireDefault$a(reactDomExports);
function _interopRequireDefault$a(a) {
  return a && a.__esModule ? a : { default: a };
}
function ownKeys$1(a, s) {
  var $ = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var _ = Object.getOwnPropertySymbols(a);
    s && (_ = _.filter(function(_e) {
      return Object.getOwnPropertyDescriptor(a, _e).enumerable;
    })), $.push.apply($, _);
  }
  return $;
}
function _objectSpread$1(a) {
  for (var s = 1; s < arguments.length; s++) {
    var $ = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$1(Object($), !0).forEach(function(_) {
      _defineProperty$5(a, _, $[_]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors($)) : ownKeys$1(Object($)).forEach(function(_) {
      Object.defineProperty(a, _, Object.getOwnPropertyDescriptor($, _));
    });
  }
  return a;
}
function _defineProperty$5(a, s, $) {
  return s in a ? Object.defineProperty(a, s, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = $, a;
}
function defaultGetContainer() {
  var a = document.createElement("div");
  return document.body.appendChild(a), a;
}
function getContainerRenderMixin(a) {
  var s = a.autoMount, $ = s === void 0 ? !0 : s, _ = a.autoDestroy, _e = _ === void 0 ? !0 : _, tt = a.isVisible, nt = a.isForceRender, at = a.getComponent, ot = a.getContainer, rt = ot === void 0 ? defaultGetContainer : ot, st;
  function lt(it, ut, ft) {
    if (!tt || it._component || tt(it) || nt && nt(it)) {
      it._container || (it._container = rt(it));
      var ht;
      it.getComponent ? ht = it.getComponent(ut) : ht = at(it, ut), _reactDom$1.default.unstable_renderSubtreeIntoContainer(it, ht, it._container, function() {
        it._component = this, ft && ft.call(this);
      });
    }
  }
  $ && (st = _objectSpread$1(_objectSpread$1({}, st), {}, {
    componentDidMount: function() {
      lt(this);
    },
    componentDidUpdate: function() {
      lt(this);
    }
  })), (!$ || !_e) && (st = _objectSpread$1(_objectSpread$1({}, st), {}, {
    renderComponent: function(ut, ft) {
      lt(this, ut, ft);
    }
  }));
  function et(it) {
    if (it._container) {
      var ut = it._container;
      _reactDom$1.default.unmountComponentAtNode(ut), ut.parentNode.removeChild(ut), it._container = null;
    }
  }
  return _e ? st = _objectSpread$1(_objectSpread$1({}, st), {}, {
    componentWillUnmount: function() {
      et(this);
    }
  }) : st = _objectSpread$1(_objectSpread$1({}, st), {}, {
    removeContainer: function() {
      et(this);
    }
  }), st;
}
function noop() {
}
function returnEmptyString() {
  return "";
}
function returnDocument() {
  return window.document;
}
var isMobile = typeof navigator < "u" && !!navigator.userAgent.match(/(Android|iPhone|iPad|iPod|iOS|UCWEB)/i), ALL_HANDLERS = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"], Trigger = createReactClass$1({
  displayName: "Trigger",
  propTypes: {
    children: PropTypes.any,
    action: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    showAction: PropTypes.any,
    hideAction: PropTypes.any,
    getPopupClassNameFromAlign: PropTypes.any,
    onPopupVisibleChange: PropTypes.func,
    afterPopupVisibleChange: PropTypes.func,
    popup: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    popupStyle: PropTypes.object,
    prefixCls: PropTypes.string,
    popupClassName: PropTypes.string,
    popupPlacement: PropTypes.string,
    builtinPlacements: PropTypes.object,
    popupTransitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    popupAnimation: PropTypes.any,
    mouseEnterDelay: PropTypes.number,
    mouseLeaveDelay: PropTypes.number,
    zIndex: PropTypes.number,
    focusDelay: PropTypes.number,
    blurDelay: PropTypes.number,
    getPopupContainer: PropTypes.func,
    getDocument: PropTypes.func,
    destroyPopupOnHide: PropTypes.bool,
    mask: PropTypes.bool,
    maskClosable: PropTypes.bool,
    onPopupAlign: PropTypes.func,
    popupAlign: PropTypes.object,
    popupVisible: PropTypes.bool,
    maskTransitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    maskAnimation: PropTypes.string
  },
  mixins: [_default$9({
    autoMount: !1,
    isVisible: function a(s) {
      return s.state.popupVisible;
    },
    getContainer: function a(s) {
      var $ = s.props, _ = document.createElement("div");
      _.style.position = "absolute", _.style.top = "0", _.style.left = "0", _.style.width = "100%";
      var _e = $.getPopupContainer ? $.getPopupContainer(reactDomExports.findDOMNode(s)) : $.getDocument().body;
      return _e.appendChild(_), _;
    }
  })],
  getDefaultProps: function a() {
    return {
      prefixCls: "rc-trigger-popup",
      getPopupClassNameFromAlign: returnEmptyString,
      getDocument: returnDocument,
      onPopupVisibleChange: noop,
      afterPopupVisibleChange: noop,
      onPopupAlign: noop,
      popupClassName: "",
      mouseEnterDelay: 0,
      mouseLeaveDelay: 0.1,
      focusDelay: 0,
      blurDelay: 0.15,
      popupStyle: {},
      destroyPopupOnHide: !1,
      popupAlign: {},
      defaultPopupVisible: !1,
      mask: !1,
      maskClosable: !0,
      action: [],
      showAction: [],
      hideAction: []
    };
  },
  getInitialState: function a() {
    var s = this.props, $ = void 0;
    return "popupVisible" in s ? $ = !!s.popupVisible : $ = !!s.defaultPopupVisible, {
      popupVisible: $
    };
  },
  componentWillMount: function a() {
    var s = this;
    ALL_HANDLERS.forEach(function($) {
      s["fire" + $] = function(_) {
        s.fireEvents($, _);
      };
    });
  },
  componentDidMount: function a() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  },
  componentWillReceiveProps: function a(s) {
    var $ = s.popupVisible;
    $ !== void 0 && this.setState({
      popupVisible: $
    });
  },
  componentDidUpdate: function a(s, $) {
    var _ = this.props, _e = this.state;
    if (this.renderComponent(null, function() {
      $.popupVisible !== _e.popupVisible && _.afterPopupVisibleChange(_e.popupVisible);
    }), _e.popupVisible) {
      var tt = void 0;
      !this.clickOutsideHandler && this.isClickToHide() && (tt = _.getDocument(), this.clickOutsideHandler = _default$h(tt, "mousedown", this.onDocumentClick)), !this.touchOutsideHandler && isMobile && (tt = tt || _.getDocument(), this.touchOutsideHandler = _default$h(tt, "click", this.onDocumentClick));
      return;
    }
    this.clearOutsideHandler();
  },
  componentWillUnmount: function a() {
    this.clearDelayTimer(), this.clearOutsideHandler();
  },
  onMouseEnter: function a(s) {
    this.fireEvents("onMouseEnter", s), this.delaySetPopupVisible(!0, this.props.mouseEnterDelay);
  },
  onMouseLeave: function a(s) {
    this.fireEvents("onMouseLeave", s), this.delaySetPopupVisible(!1, this.props.mouseLeaveDelay);
  },
  onPopupMouseEnter: function a() {
    this.clearDelayTimer();
  },
  onPopupMouseLeave: function a(s) {
    s.relatedTarget && !s.relatedTarget.setTimeout && this._component && this._component.getPopupDomNode && contains$2(this._component.getPopupDomNode(), s.relatedTarget) || this.delaySetPopupVisible(!1, this.props.mouseLeaveDelay);
  },
  onFocus: function a(s) {
    this.fireEvents("onFocus", s), this.clearDelayTimer(), this.isFocusToShow() && (this.focusTime = Date.now(), this.delaySetPopupVisible(!0, this.props.focusDelay));
  },
  onMouseDown: function a(s) {
    this.fireEvents("onMouseDown", s), this.preClickTime = Date.now();
  },
  onTouchStart: function a(s) {
    this.fireEvents("onTouchStart", s), this.preTouchTime = Date.now();
  },
  onBlur: function a(s) {
    this.fireEvents("onBlur", s), this.clearDelayTimer(), this.isBlurToHide() && this.delaySetPopupVisible(!1, this.props.blurDelay);
  },
  onClick: function a(s) {
    if (this.fireEvents("onClick", s), this.focusTime) {
      var $ = void 0;
      if (this.preClickTime && this.preTouchTime ? $ = Math.min(this.preClickTime, this.preTouchTime) : this.preClickTime ? $ = this.preClickTime : this.preTouchTime && ($ = this.preTouchTime), Math.abs($ - this.focusTime) < 20)
        return;
      this.focusTime = 0;
    }
    this.preClickTime = 0, this.preTouchTime = 0, s.preventDefault();
    var _ = !this.state.popupVisible;
    (this.isClickToHide() && !_ || _ && this.isClickToShow()) && this.setPopupVisible(!this.state.popupVisible);
  },
  onDocumentClick: function a(s) {
    if (!(this.props.mask && !this.props.maskClosable)) {
      var $ = s.target, _ = reactDomExports.findDOMNode(this), _e = this.getPopupDomNode();
      !contains$2(_, $) && !contains$2(_e, $) && this.close();
    }
  },
  getPopupDomNode: function a() {
    return this._component && this._component.getPopupDomNode ? this._component.getPopupDomNode() : null;
  },
  getRootDomNode: function a() {
    return reactDomExports.findDOMNode(this);
  },
  getPopupClassNameFromAlign: function a(s) {
    var $ = [], _ = this.props, _e = _.popupPlacement, tt = _.builtinPlacements, nt = _.prefixCls;
    return _e && tt && $.push(getPopupClassNameFromAlign(tt, nt, s)), _.getPopupClassNameFromAlign && $.push(_.getPopupClassNameFromAlign(s)), $.join(" ");
  },
  getPopupAlign: function a() {
    var s = this.props, $ = s.popupPlacement, _ = s.popupAlign, _e = s.builtinPlacements;
    return $ && _e ? getAlignFromPlacement(_e, $, _) : _;
  },
  getComponent: function a() {
    var s = this.props, $ = this.state, _ = {};
    return this.isMouseEnterToShow() && (_.onMouseEnter = this.onPopupMouseEnter), this.isMouseLeaveToHide() && (_.onMouseLeave = this.onPopupMouseLeave), React$a.createElement(
      Popup,
      _default$i({
        prefixCls: s.prefixCls,
        destroyPopupOnHide: s.destroyPopupOnHide,
        visible: $.popupVisible,
        className: s.popupClassName,
        action: s.action,
        align: this.getPopupAlign(),
        onAlign: s.onPopupAlign,
        animation: s.popupAnimation,
        getClassNameFromAlign: this.getPopupClassNameFromAlign
      }, _, {
        getRootDomNode: this.getRootDomNode,
        style: s.popupStyle,
        mask: s.mask,
        zIndex: s.zIndex,
        transitionName: s.popupTransitionName,
        maskAnimation: s.maskAnimation,
        maskTransitionName: s.maskTransitionName
      }),
      typeof s.popup == "function" ? s.popup() : s.popup
    );
  },
  setPopupVisible: function a(s) {
    this.clearDelayTimer(), this.state.popupVisible !== s && ("popupVisible" in this.props || this.setState({
      popupVisible: s
    }), this.props.onPopupVisibleChange(s));
  },
  delaySetPopupVisible: function a(s, $) {
    var _ = this, _e = $ * 1e3;
    this.clearDelayTimer(), _e ? this.delayTimer = setTimeout(function() {
      _.setPopupVisible(s), _.clearDelayTimer();
    }, _e) : this.setPopupVisible(s);
  },
  clearDelayTimer: function a() {
    this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
  },
  clearOutsideHandler: function a() {
    this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
  },
  createTwoChains: function a(s) {
    var $ = this.props.children.props, _ = this.props;
    return $[s] && _[s] ? this["fire" + s] : $[s] || _[s];
  },
  isClickToShow: function a() {
    var s = this.props, $ = s.action, _ = s.showAction;
    return $.indexOf("click") !== -1 || _.indexOf("click") !== -1;
  },
  isClickToHide: function a() {
    var s = this.props, $ = s.action, _ = s.hideAction;
    return $.indexOf("click") !== -1 || _.indexOf("click") !== -1;
  },
  isMouseEnterToShow: function a() {
    var s = this.props, $ = s.action, _ = s.showAction;
    return $.indexOf("hover") !== -1 || _.indexOf("mouseEnter") !== -1;
  },
  isMouseLeaveToHide: function a() {
    var s = this.props, $ = s.action, _ = s.hideAction;
    return $.indexOf("hover") !== -1 || _.indexOf("mouseLeave") !== -1;
  },
  isFocusToShow: function a() {
    var s = this.props, $ = s.action, _ = s.showAction;
    return $.indexOf("focus") !== -1 || _.indexOf("focus") !== -1;
  },
  isBlurToHide: function a() {
    var s = this.props, $ = s.action, _ = s.hideAction;
    return $.indexOf("focus") !== -1 || _.indexOf("blur") !== -1;
  },
  forcePopupAlign: function a() {
    this.state.popupVisible && this._component && this._component.alignInstance && this._component.alignInstance.forceAlign();
  },
  fireEvents: function a(s, $) {
    var _ = this.props.children.props[s];
    _ && _($);
    var _e = this.props[s];
    _e && _e($);
  },
  close: function a() {
    this.setPopupVisible(!1);
  },
  render: function a() {
    var s = this.props, $ = s.children, _ = React$a.Children.only($), _e = {};
    return this.isClickToHide() || this.isClickToShow() ? (_e.onClick = this.onClick, _e.onMouseDown = this.onMouseDown, _e.onTouchStart = this.onTouchStart) : (_e.onClick = this.createTwoChains("onClick"), _e.onMouseDown = this.createTwoChains("onMouseDown"), _e.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? _e.onMouseEnter = this.onMouseEnter : _e.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? _e.onMouseLeave = this.onMouseLeave : _e.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (_e.onFocus = this.onFocus, _e.onBlur = this.onBlur) : (_e.onFocus = this.createTwoChains("onFocus"), _e.onBlur = this.createTwoChains("onBlur")), React$a.cloneElement(_, _e);
  }
});
const es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Trigger
}, Symbol.toStringTag, { value: "Module" })), require$$3$1 = /* @__PURE__ */ getAugmentedNamespace(es);
var Panel$1 = { exports: {} }, color = { exports: {} }, tinycolor = { exports: {} };
(function(a, s) {
  (function($, _) {
    a.exports = _();
  })(commonjsGlobal, function() {
    function $($t) {
      "@babel/helpers - typeof";
      return $ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Tt) {
        return typeof Tt;
      } : function(Tt) {
        return Tt && typeof Symbol == "function" && Tt.constructor === Symbol && Tt !== Symbol.prototype ? "symbol" : typeof Tt;
      }, $($t);
    }
    var _ = /^\s+/, _e = /\s+$/;
    function tt($t, Tt) {
      if ($t = $t || "", Tt = Tt || {}, $t instanceof tt)
        return $t;
      if (!(this instanceof tt))
        return new tt($t, Tt);
      var Dt = nt($t);
      this._originalInput = $t, this._r = Dt.r, this._g = Dt.g, this._b = Dt.b, this._a = Dt.a, this._roundA = Math.round(100 * this._a) / 100, this._format = Tt.format || Dt.format, this._gradientType = Tt.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = Dt.ok;
    }
    tt.prototype = {
      isDark: function() {
        return this.getBrightness() < 128;
      },
      isLight: function() {
        return !this.isDark();
      },
      isValid: function() {
        return this._ok;
      },
      getOriginalInput: function() {
        return this._originalInput;
      },
      getFormat: function() {
        return this._format;
      },
      getAlpha: function() {
        return this._a;
      },
      getBrightness: function() {
        var Tt = this.toRgb();
        return (Tt.r * 299 + Tt.g * 587 + Tt.b * 114) / 1e3;
      },
      getLuminance: function() {
        var Tt = this.toRgb(), Dt, Ut, Vt, Qt, qt, Zt;
        return Dt = Tt.r / 255, Ut = Tt.g / 255, Vt = Tt.b / 255, Dt <= 0.03928 ? Qt = Dt / 12.92 : Qt = Math.pow((Dt + 0.055) / 1.055, 2.4), Ut <= 0.03928 ? qt = Ut / 12.92 : qt = Math.pow((Ut + 0.055) / 1.055, 2.4), Vt <= 0.03928 ? Zt = Vt / 12.92 : Zt = Math.pow((Vt + 0.055) / 1.055, 2.4), 0.2126 * Qt + 0.7152 * qt + 0.0722 * Zt;
      },
      setAlpha: function(Tt) {
        return this._a = Pt(Tt), this._roundA = Math.round(100 * this._a) / 100, this;
      },
      toHsv: function() {
        var Tt = st(this._r, this._g, this._b);
        return {
          h: Tt.h * 360,
          s: Tt.s,
          v: Tt.v,
          a: this._a
        };
      },
      toHsvString: function() {
        var Tt = st(this._r, this._g, this._b), Dt = Math.round(Tt.h * 360), Ut = Math.round(Tt.s * 100), Vt = Math.round(Tt.v * 100);
        return this._a == 1 ? "hsv(" + Dt + ", " + Ut + "%, " + Vt + "%)" : "hsva(" + Dt + ", " + Ut + "%, " + Vt + "%, " + this._roundA + ")";
      },
      toHsl: function() {
        var Tt = ot(this._r, this._g, this._b);
        return {
          h: Tt.h * 360,
          s: Tt.s,
          l: Tt.l,
          a: this._a
        };
      },
      toHslString: function() {
        var Tt = ot(this._r, this._g, this._b), Dt = Math.round(Tt.h * 360), Ut = Math.round(Tt.s * 100), Vt = Math.round(Tt.l * 100);
        return this._a == 1 ? "hsl(" + Dt + ", " + Ut + "%, " + Vt + "%)" : "hsla(" + Dt + ", " + Ut + "%, " + Vt + "%, " + this._roundA + ")";
      },
      toHex: function(Tt) {
        return et(this._r, this._g, this._b, Tt);
      },
      toHexString: function(Tt) {
        return "#" + this.toHex(Tt);
      },
      toHex8: function(Tt) {
        return it(this._r, this._g, this._b, this._a, Tt);
      },
      toHex8String: function(Tt) {
        return "#" + this.toHex8(Tt);
      },
      toRgb: function() {
        return {
          r: Math.round(this._r),
          g: Math.round(this._g),
          b: Math.round(this._b),
          a: this._a
        };
      },
      toRgbString: function() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function() {
        return {
          r: Math.round(wt(this._r, 255) * 100) + "%",
          g: Math.round(wt(this._g, 255) * 100) + "%",
          b: Math.round(wt(this._b, 255) * 100) + "%",
          a: this._a
        };
      },
      toPercentageRgbString: function() {
        return this._a == 1 ? "rgb(" + Math.round(wt(this._r, 255) * 100) + "%, " + Math.round(wt(this._g, 255) * 100) + "%, " + Math.round(wt(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(wt(this._r, 255) * 100) + "%, " + Math.round(wt(this._g, 255) * 100) + "%, " + Math.round(wt(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function() {
        return this._a === 0 ? "transparent" : this._a < 1 ? !1 : Bt[et(this._r, this._g, this._b, !0)] || !1;
      },
      toFilter: function(Tt) {
        var Dt = "#" + ut(this._r, this._g, this._b, this._a), Ut = Dt, Vt = this._gradientType ? "GradientType = 1, " : "";
        if (Tt) {
          var Qt = tt(Tt);
          Ut = "#" + ut(Qt._r, Qt._g, Qt._b, Qt._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + Vt + "startColorstr=" + Dt + ",endColorstr=" + Ut + ")";
      },
      toString: function(Tt) {
        var Dt = !!Tt;
        Tt = Tt || this._format;
        var Ut = !1, Vt = this._a < 1 && this._a >= 0, Qt = !Dt && Vt && (Tt === "hex" || Tt === "hex6" || Tt === "hex3" || Tt === "hex4" || Tt === "hex8" || Tt === "name");
        return Qt ? Tt === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (Tt === "rgb" && (Ut = this.toRgbString()), Tt === "prgb" && (Ut = this.toPercentageRgbString()), (Tt === "hex" || Tt === "hex6") && (Ut = this.toHexString()), Tt === "hex3" && (Ut = this.toHexString(!0)), Tt === "hex4" && (Ut = this.toHex8String(!0)), Tt === "hex8" && (Ut = this.toHex8String()), Tt === "name" && (Ut = this.toName()), Tt === "hsl" && (Ut = this.toHslString()), Tt === "hsv" && (Ut = this.toHsvString()), Ut || this.toHexString());
      },
      clone: function() {
        return tt(this.toString());
      },
      _applyModification: function(Tt, Dt) {
        var Ut = Tt.apply(null, [this].concat([].slice.call(Dt)));
        return this._r = Ut._r, this._g = Ut._g, this._b = Ut._b, this.setAlpha(Ut._a), this;
      },
      lighten: function() {
        return this._applyModification(gt, arguments);
      },
      brighten: function() {
        return this._applyModification(pt, arguments);
      },
      darken: function() {
        return this._applyModification(mt, arguments);
      },
      desaturate: function() {
        return this._applyModification(ft, arguments);
      },
      saturate: function() {
        return this._applyModification(ht, arguments);
      },
      greyscale: function() {
        return this._applyModification(dt, arguments);
      },
      spin: function() {
        return this._applyModification(ct, arguments);
      },
      _applyCombination: function(Tt, Dt) {
        return Tt.apply(null, [this].concat([].slice.call(Dt)));
      },
      analogous: function() {
        return this._applyCombination(bt, arguments);
      },
      complement: function() {
        return this._applyCombination(vt, arguments);
      },
      monochromatic: function() {
        return this._applyCombination(Et, arguments);
      },
      splitcomplement: function() {
        return this._applyCombination(xt, arguments);
      },
      // Disabled until https://github.com/bgrins/TinyColor/issues/254
      // polyad: function (number) {
      //   return this._applyCombination(polyad, [number]);
      // },
      triad: function() {
        return this._applyCombination(At, [3]);
      },
      tetrad: function() {
        return this._applyCombination(At, [4]);
      }
    }, tt.fromRatio = function($t, Tt) {
      if ($($t) == "object") {
        var Dt = {};
        for (var Ut in $t)
          $t.hasOwnProperty(Ut) && (Ut === "a" ? Dt[Ut] = $t[Ut] : Dt[Ut] = jt($t[Ut]));
        $t = Dt;
      }
      return tt($t, Tt);
    };
    function nt($t) {
      var Tt = {
        r: 0,
        g: 0,
        b: 0
      }, Dt = 1, Ut = null, Vt = null, Qt = null, qt = !1, Zt = !1;
      return typeof $t == "string" && ($t = Mt($t)), $($t) == "object" && (Nt($t.r) && Nt($t.g) && Nt($t.b) ? (Tt = at($t.r, $t.g, $t.b), qt = !0, Zt = String($t.r).substr(-1) === "%" ? "prgb" : "rgb") : Nt($t.h) && Nt($t.s) && Nt($t.v) ? (Ut = jt($t.s), Vt = jt($t.v), Tt = lt($t.h, Ut, Vt), qt = !0, Zt = "hsv") : Nt($t.h) && Nt($t.s) && Nt($t.l) && (Ut = jt($t.s), Qt = jt($t.l), Tt = rt($t.h, Ut, Qt), qt = !0, Zt = "hsl"), $t.hasOwnProperty("a") && (Dt = $t.a)), Dt = Pt(Dt), {
        ok: qt,
        format: $t.format || Zt,
        r: Math.min(255, Math.max(Tt.r, 0)),
        g: Math.min(255, Math.max(Tt.g, 0)),
        b: Math.min(255, Math.max(Tt.b, 0)),
        a: Dt
      };
    }
    function at($t, Tt, Dt) {
      return {
        r: wt($t, 255) * 255,
        g: wt(Tt, 255) * 255,
        b: wt(Dt, 255) * 255
      };
    }
    function ot($t, Tt, Dt) {
      $t = wt($t, 255), Tt = wt(Tt, 255), Dt = wt(Dt, 255);
      var Ut = Math.max($t, Tt, Dt), Vt = Math.min($t, Tt, Dt), Qt, qt, Zt = (Ut + Vt) / 2;
      if (Ut == Vt)
        Qt = qt = 0;
      else {
        var ar = Ut - Vt;
        switch (qt = Zt > 0.5 ? ar / (2 - Ut - Vt) : ar / (Ut + Vt), Ut) {
          case $t:
            Qt = (Tt - Dt) / ar + (Tt < Dt ? 6 : 0);
            break;
          case Tt:
            Qt = (Dt - $t) / ar + 2;
            break;
          case Dt:
            Qt = ($t - Tt) / ar + 4;
            break;
        }
        Qt /= 6;
      }
      return {
        h: Qt,
        s: qt,
        l: Zt
      };
    }
    function rt($t, Tt, Dt) {
      var Ut, Vt, Qt;
      $t = wt($t, 360), Tt = wt(Tt, 100), Dt = wt(Dt, 100);
      function qt(Jt, rr, Yt) {
        return Yt < 0 && (Yt += 1), Yt > 1 && (Yt -= 1), Yt < 1 / 6 ? Jt + (rr - Jt) * 6 * Yt : Yt < 1 / 2 ? rr : Yt < 2 / 3 ? Jt + (rr - Jt) * (2 / 3 - Yt) * 6 : Jt;
      }
      if (Tt === 0)
        Ut = Vt = Qt = Dt;
      else {
        var Zt = Dt < 0.5 ? Dt * (1 + Tt) : Dt + Tt - Dt * Tt, ar = 2 * Dt - Zt;
        Ut = qt(ar, Zt, $t + 1 / 3), Vt = qt(ar, Zt, $t), Qt = qt(ar, Zt, $t - 1 / 3);
      }
      return {
        r: Ut * 255,
        g: Vt * 255,
        b: Qt * 255
      };
    }
    function st($t, Tt, Dt) {
      $t = wt($t, 255), Tt = wt(Tt, 255), Dt = wt(Dt, 255);
      var Ut = Math.max($t, Tt, Dt), Vt = Math.min($t, Tt, Dt), Qt, qt, Zt = Ut, ar = Ut - Vt;
      if (qt = Ut === 0 ? 0 : ar / Ut, Ut == Vt)
        Qt = 0;
      else {
        switch (Ut) {
          case $t:
            Qt = (Tt - Dt) / ar + (Tt < Dt ? 6 : 0);
            break;
          case Tt:
            Qt = (Dt - $t) / ar + 2;
            break;
          case Dt:
            Qt = ($t - Tt) / ar + 4;
            break;
        }
        Qt /= 6;
      }
      return {
        h: Qt,
        s: qt,
        v: Zt
      };
    }
    function lt($t, Tt, Dt) {
      $t = wt($t, 360) * 6, Tt = wt(Tt, 100), Dt = wt(Dt, 100);
      var Ut = Math.floor($t), Vt = $t - Ut, Qt = Dt * (1 - Tt), qt = Dt * (1 - Vt * Tt), Zt = Dt * (1 - (1 - Vt) * Tt), ar = Ut % 6, Jt = [Dt, qt, Qt, Qt, Zt, Dt][ar], rr = [Zt, Dt, Dt, qt, Qt, Qt][ar], Yt = [Qt, Qt, Zt, Dt, Dt, qt][ar];
      return {
        r: Jt * 255,
        g: rr * 255,
        b: Yt * 255
      };
    }
    function et($t, Tt, Dt, Ut) {
      var Vt = [kt(Math.round($t).toString(16)), kt(Math.round(Tt).toString(16)), kt(Math.round(Dt).toString(16))];
      return Ut && Vt[0].charAt(0) == Vt[0].charAt(1) && Vt[1].charAt(0) == Vt[1].charAt(1) && Vt[2].charAt(0) == Vt[2].charAt(1) ? Vt[0].charAt(0) + Vt[1].charAt(0) + Vt[2].charAt(0) : Vt.join("");
    }
    function it($t, Tt, Dt, Ut, Vt) {
      var Qt = [kt(Math.round($t).toString(16)), kt(Math.round(Tt).toString(16)), kt(Math.round(Dt).toString(16)), kt(Ht(Ut))];
      return Vt && Qt[0].charAt(0) == Qt[0].charAt(1) && Qt[1].charAt(0) == Qt[1].charAt(1) && Qt[2].charAt(0) == Qt[2].charAt(1) && Qt[3].charAt(0) == Qt[3].charAt(1) ? Qt[0].charAt(0) + Qt[1].charAt(0) + Qt[2].charAt(0) + Qt[3].charAt(0) : Qt.join("");
    }
    function ut($t, Tt, Dt, Ut) {
      var Vt = [kt(Ht(Ut)), kt(Math.round($t).toString(16)), kt(Math.round(Tt).toString(16)), kt(Math.round(Dt).toString(16))];
      return Vt.join("");
    }
    tt.equals = function($t, Tt) {
      return !$t || !Tt ? !1 : tt($t).toRgbString() == tt(Tt).toRgbString();
    }, tt.random = function() {
      return tt.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
      });
    };
    function ft($t, Tt) {
      Tt = Tt === 0 ? 0 : Tt || 10;
      var Dt = tt($t).toHsl();
      return Dt.s -= Tt / 100, Dt.s = Ct(Dt.s), tt(Dt);
    }
    function ht($t, Tt) {
      Tt = Tt === 0 ? 0 : Tt || 10;
      var Dt = tt($t).toHsl();
      return Dt.s += Tt / 100, Dt.s = Ct(Dt.s), tt(Dt);
    }
    function dt($t) {
      return tt($t).desaturate(100);
    }
    function gt($t, Tt) {
      Tt = Tt === 0 ? 0 : Tt || 10;
      var Dt = tt($t).toHsl();
      return Dt.l += Tt / 100, Dt.l = Ct(Dt.l), tt(Dt);
    }
    function pt($t, Tt) {
      Tt = Tt === 0 ? 0 : Tt || 10;
      var Dt = tt($t).toRgb();
      return Dt.r = Math.max(0, Math.min(255, Dt.r - Math.round(255 * -(Tt / 100)))), Dt.g = Math.max(0, Math.min(255, Dt.g - Math.round(255 * -(Tt / 100)))), Dt.b = Math.max(0, Math.min(255, Dt.b - Math.round(255 * -(Tt / 100)))), tt(Dt);
    }
    function mt($t, Tt) {
      Tt = Tt === 0 ? 0 : Tt || 10;
      var Dt = tt($t).toHsl();
      return Dt.l -= Tt / 100, Dt.l = Ct(Dt.l), tt(Dt);
    }
    function ct($t, Tt) {
      var Dt = tt($t).toHsl(), Ut = (Dt.h + Tt) % 360;
      return Dt.h = Ut < 0 ? 360 + Ut : Ut, tt(Dt);
    }
    function vt($t) {
      var Tt = tt($t).toHsl();
      return Tt.h = (Tt.h + 180) % 360, tt(Tt);
    }
    function At($t, Tt) {
      if (isNaN(Tt) || Tt <= 0)
        throw new Error("Argument to polyad must be a positive number");
      for (var Dt = tt($t).toHsl(), Ut = [tt($t)], Vt = 360 / Tt, Qt = 1; Qt < Tt; Qt++)
        Ut.push(tt({
          h: (Dt.h + Qt * Vt) % 360,
          s: Dt.s,
          l: Dt.l
        }));
      return Ut;
    }
    function xt($t) {
      var Tt = tt($t).toHsl(), Dt = Tt.h;
      return [tt($t), tt({
        h: (Dt + 72) % 360,
        s: Tt.s,
        l: Tt.l
      }), tt({
        h: (Dt + 216) % 360,
        s: Tt.s,
        l: Tt.l
      })];
    }
    function bt($t, Tt, Dt) {
      Tt = Tt || 6, Dt = Dt || 30;
      var Ut = tt($t).toHsl(), Vt = 360 / Dt, Qt = [tt($t)];
      for (Ut.h = (Ut.h - (Vt * Tt >> 1) + 720) % 360; --Tt; )
        Ut.h = (Ut.h + Vt) % 360, Qt.push(tt(Ut));
      return Qt;
    }
    function Et($t, Tt) {
      Tt = Tt || 6;
      for (var Dt = tt($t).toHsv(), Ut = Dt.h, Vt = Dt.s, Qt = Dt.v, qt = [], Zt = 1 / Tt; Tt--; )
        qt.push(tt({
          h: Ut,
          s: Vt,
          v: Qt
        })), Qt = (Qt + Zt) % 1;
      return qt;
    }
    tt.mix = function($t, Tt, Dt) {
      Dt = Dt === 0 ? 0 : Dt || 50;
      var Ut = tt($t).toRgb(), Vt = tt(Tt).toRgb(), Qt = Dt / 100, qt = {
        r: (Vt.r - Ut.r) * Qt + Ut.r,
        g: (Vt.g - Ut.g) * Qt + Ut.g,
        b: (Vt.b - Ut.b) * Qt + Ut.b,
        a: (Vt.a - Ut.a) * Qt + Ut.a
      };
      return tt(qt);
    }, tt.readability = function($t, Tt) {
      var Dt = tt($t), Ut = tt(Tt);
      return (Math.max(Dt.getLuminance(), Ut.getLuminance()) + 0.05) / (Math.min(Dt.getLuminance(), Ut.getLuminance()) + 0.05);
    }, tt.isReadable = function($t, Tt, Dt) {
      var Ut = tt.readability($t, Tt), Vt, Qt;
      switch (Qt = !1, Vt = Lt(Dt), Vt.level + Vt.size) {
        case "AAsmall":
        case "AAAlarge":
          Qt = Ut >= 4.5;
          break;
        case "AAlarge":
          Qt = Ut >= 3;
          break;
        case "AAAsmall":
          Qt = Ut >= 7;
          break;
      }
      return Qt;
    }, tt.mostReadable = function($t, Tt, Dt) {
      var Ut = null, Vt = 0, Qt, qt, Zt, ar;
      Dt = Dt || {}, qt = Dt.includeFallbackColors, Zt = Dt.level, ar = Dt.size;
      for (var Jt = 0; Jt < Tt.length; Jt++)
        Qt = tt.readability($t, Tt[Jt]), Qt > Vt && (Vt = Qt, Ut = tt(Tt[Jt]));
      return tt.isReadable($t, Ut, {
        level: Zt,
        size: ar
      }) || !qt ? Ut : (Dt.includeFallbackColors = !1, tt.mostReadable($t, ["#fff", "#000"], Dt));
    };
    var St = tt.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    }, Bt = tt.hexNames = Ot(St);
    function Ot($t) {
      var Tt = {};
      for (var Dt in $t)
        $t.hasOwnProperty(Dt) && (Tt[$t[Dt]] = Dt);
      return Tt;
    }
    function Pt($t) {
      return $t = parseFloat($t), (isNaN($t) || $t < 0 || $t > 1) && ($t = 1), $t;
    }
    function wt($t, Tt) {
      yt($t) && ($t = "100%");
      var Dt = Rt($t);
      return $t = Math.min(Tt, Math.max(0, parseFloat($t))), Dt && ($t = parseInt($t * Tt, 10) / 100), Math.abs($t - Tt) < 1e-6 ? 1 : $t % Tt / parseFloat(Tt);
    }
    function Ct($t) {
      return Math.min(1, Math.max(0, $t));
    }
    function It($t) {
      return parseInt($t, 16);
    }
    function yt($t) {
      return typeof $t == "string" && $t.indexOf(".") != -1 && parseFloat($t) === 1;
    }
    function Rt($t) {
      return typeof $t == "string" && $t.indexOf("%") != -1;
    }
    function kt($t) {
      return $t.length == 1 ? "0" + $t : "" + $t;
    }
    function jt($t) {
      return $t <= 1 && ($t = $t * 100 + "%"), $t;
    }
    function Ht($t) {
      return Math.round(parseFloat($t) * 255).toString(16);
    }
    function Ft($t) {
      return It($t) / 255;
    }
    var _t = function() {
      var $t = "[-\\+]?\\d+%?", Tt = "[-\\+]?\\d*\\.\\d+%?", Dt = "(?:" + Tt + ")|(?:" + $t + ")", Ut = "[\\s|\\(]+(" + Dt + ")[,|\\s]+(" + Dt + ")[,|\\s]+(" + Dt + ")\\s*\\)?", Vt = "[\\s|\\(]+(" + Dt + ")[,|\\s]+(" + Dt + ")[,|\\s]+(" + Dt + ")[,|\\s]+(" + Dt + ")\\s*\\)?";
      return {
        CSS_UNIT: new RegExp(Dt),
        rgb: new RegExp("rgb" + Ut),
        rgba: new RegExp("rgba" + Vt),
        hsl: new RegExp("hsl" + Ut),
        hsla: new RegExp("hsla" + Vt),
        hsv: new RegExp("hsv" + Ut),
        hsva: new RegExp("hsva" + Vt),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
    }();
    function Nt($t) {
      return !!_t.CSS_UNIT.exec($t);
    }
    function Mt($t) {
      $t = $t.replace(_, "").replace(_e, "").toLowerCase();
      var Tt = !1;
      if (St[$t])
        $t = St[$t], Tt = !0;
      else if ($t == "transparent")
        return {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
          format: "name"
        };
      var Dt;
      return (Dt = _t.rgb.exec($t)) ? {
        r: Dt[1],
        g: Dt[2],
        b: Dt[3]
      } : (Dt = _t.rgba.exec($t)) ? {
        r: Dt[1],
        g: Dt[2],
        b: Dt[3],
        a: Dt[4]
      } : (Dt = _t.hsl.exec($t)) ? {
        h: Dt[1],
        s: Dt[2],
        l: Dt[3]
      } : (Dt = _t.hsla.exec($t)) ? {
        h: Dt[1],
        s: Dt[2],
        l: Dt[3],
        a: Dt[4]
      } : (Dt = _t.hsv.exec($t)) ? {
        h: Dt[1],
        s: Dt[2],
        v: Dt[3]
      } : (Dt = _t.hsva.exec($t)) ? {
        h: Dt[1],
        s: Dt[2],
        v: Dt[3],
        a: Dt[4]
      } : (Dt = _t.hex8.exec($t)) ? {
        r: It(Dt[1]),
        g: It(Dt[2]),
        b: It(Dt[3]),
        a: Ft(Dt[4]),
        format: Tt ? "name" : "hex8"
      } : (Dt = _t.hex6.exec($t)) ? {
        r: It(Dt[1]),
        g: It(Dt[2]),
        b: It(Dt[3]),
        format: Tt ? "name" : "hex"
      } : (Dt = _t.hex4.exec($t)) ? {
        r: It(Dt[1] + "" + Dt[1]),
        g: It(Dt[2] + "" + Dt[2]),
        b: It(Dt[3] + "" + Dt[3]),
        a: Ft(Dt[4] + "" + Dt[4]),
        format: Tt ? "name" : "hex8"
      } : (Dt = _t.hex3.exec($t)) ? {
        r: It(Dt[1] + "" + Dt[1]),
        g: It(Dt[2] + "" + Dt[2]),
        b: It(Dt[3] + "" + Dt[3]),
        format: Tt ? "name" : "hex"
      } : !1;
    }
    function Lt($t) {
      var Tt, Dt;
      return $t = $t || {
        level: "AA",
        size: "small"
      }, Tt = ($t.level || "AA").toUpperCase(), Dt = ($t.size || "small").toLowerCase(), Tt !== "AA" && Tt !== "AAA" && (Tt = "AA"), Dt !== "small" && Dt !== "large" && (Dt = "small"), {
        level: Tt,
        size: Dt
      };
    }
    return tt;
  });
})(tinycolor);
var tinycolorExports = tinycolor.exports;
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var $ = Object.assign || function(rt) {
    for (var st = 1; st < arguments.length; st++) {
      var lt = arguments[st];
      for (var et in lt)
        Object.prototype.hasOwnProperty.call(lt, et) && (rt[et] = lt[et]);
    }
    return rt;
  }, _ = /* @__PURE__ */ function() {
    function rt(st, lt) {
      for (var et = 0; et < lt.length; et++) {
        var it = lt[et];
        it.enumerable = it.enumerable || !1, it.configurable = !0, "value" in it && (it.writable = !0), Object.defineProperty(st, it.key, it);
      }
    }
    return function(st, lt, et) {
      return lt && rt(st.prototype, lt), et && rt(st, et), st;
    };
  }(), _e = tinycolorExports, tt = nt(_e);
  function nt(rt) {
    return rt && rt.__esModule ? rt : { default: rt };
  }
  function at(rt, st) {
    if (!(rt instanceof st))
      throw new TypeError("Cannot call a class as a function");
  }
  var ot = function() {
    function rt(st) {
      var lt = this;
      at(this, rt), this.initRgb = function() {
        var it = lt.color.toRgb(), ut = it.r, ft = it.g, ht = it.b;
        lt.redValue = ut, lt.greenValue = ft, lt.blueValue = ht;
      }, this.initHsb = function() {
        var it = lt.color.toHsv(), ut = it.h, ft = it.s, ht = it.v;
        lt.hueValue = ut, lt.saturationValue = ft, lt.brightnessValue = ht;
      }, this.toHexString = function() {
        return lt.color.toHexString();
      }, this.toRgbString = function() {
        return lt.color.toRgbString();
      }, this.color = (0, tt.default)(st), this.initRgb(), this.initHsb();
      var et = st && st.alpha || this.color.toRgb().a;
      this.alphaValue = Math.min(1, et) * 100;
    }
    return rt.isValidHex = function(lt) {
      return (0, tt.default)(lt).isValid();
    }, _(rt, [{
      key: "hex",
      get: function() {
        return this.color.toHex();
      }
      // 色调
    }, {
      key: "hue",
      set: function(lt) {
        this.color = (0, tt.default)({
          h: lt,
          s: this.saturation,
          v: this.brightness
        }), this.initRgb(), this.hueValue = lt;
      },
      get: function() {
        return this.hueValue;
      }
      // 饱和度
    }, {
      key: "saturation",
      set: function(lt) {
        this.color = (0, tt.default)({
          h: this.hue,
          s: lt,
          v: this.brightness
        }), this.initRgb(), this.saturationValue = lt;
      },
      get: function() {
        return this.saturationValue;
      }
      // 亮度
    }, {
      key: "lightness",
      set: function(lt) {
        this.color = (0, tt.default)({
          h: this.hue,
          s: this.saturation,
          l: lt
        }), this.initRgb(), this.lightnessValue = lt;
      },
      get: function() {
        return this.lightnessValue;
      }
    }, {
      key: "brightness",
      set: function(lt) {
        this.color = (0, tt.default)({
          h: this.hue,
          s: this.saturation,
          v: lt
        }), this.initRgb(), this.brightnessValue = lt;
      },
      get: function() {
        return this.brightnessValue;
      }
      // red
    }, {
      key: "red",
      set: function(lt) {
        var et = this.color.toRgb();
        this.color = (0, tt.default)($({}, et, {
          r: lt
        })), this.initHsb(), this.redValue = lt;
      },
      get: function() {
        return this.redValue;
      }
      // green
    }, {
      key: "green",
      set: function(lt) {
        var et = this.color.toRgb();
        this.color = (0, tt.default)($({}, et, {
          g: lt
        })), this.initHsb(), this.greenValue = lt;
      },
      get: function() {
        return this.greenValue;
      }
      // blue
    }, {
      key: "blue",
      set: function(lt) {
        var et = this.color.toRgb();
        this.color = (0, tt.default)($({}, et, {
          b: lt
        })), this.initHsb(), this.blueValue = lt;
      },
      get: function() {
        return this.blueValue;
      }
      // alpha
    }, {
      key: "alpha",
      set: function(lt) {
        this.color.setAlpha(lt / 100);
      },
      get: function() {
        return this.color.getAlpha() * 100;
      }
    }, {
      key: "RGB",
      get: function() {
        return [this.red, this.green, this.blue];
      }
    }, {
      key: "HSB",
      get: function() {
        return [this.hue, this.saturation, this.brightness];
      }
    }]), rt;
  }();
  s.default = ot, a.exports = s.default;
})(color, color.exports);
var colorExports = color.exports, Board = { exports: {} }, addEventListener = {};
Object.defineProperty(addEventListener, "__esModule", {
  value: !0
});
addEventListener.default = addEventListenerWrap;
var _addDomEventListener = _interopRequireDefault$9(libExports$1), _reactDom = _interopRequireDefault$9(reactDomExports);
function _interopRequireDefault$9(a) {
  return a && a.__esModule ? a : { default: a };
}
function addEventListenerWrap(a, s, $, _) {
  var _e = _reactDom.default.unstable_batchedUpdates ? function(nt) {
    _reactDom.default.unstable_batchedUpdates($, nt);
  } : $;
  return (0, _addDomEventListener.default)(a, s, _e, _);
}
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var $ = reactExports, _ = et($), _e = reactDomExports, tt = et(_e), nt = propTypesExports, at = et(nt), ot = addEventListener, rt = et(ot), st = colorExports, lt = et(st);
  function et(mt) {
    return mt && mt.__esModule ? mt : { default: mt };
  }
  function it(mt, ct) {
    for (var vt = Object.getOwnPropertyNames(ct), At = 0; At < vt.length; At++) {
      var xt = vt[At], bt = Object.getOwnPropertyDescriptor(ct, xt);
      bt && bt.configurable && mt[xt] === void 0 && Object.defineProperty(mt, xt, bt);
    }
    return mt;
  }
  function ut(mt, ct) {
    if (!(mt instanceof ct))
      throw new TypeError("Cannot call a class as a function");
  }
  function ft(mt, ct) {
    if (!mt)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return ct && (typeof ct == "object" || typeof ct == "function") ? ct : mt;
  }
  function ht(mt, ct) {
    if (typeof ct != "function" && ct !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof ct);
    mt.prototype = Object.create(ct && ct.prototype, { constructor: { value: mt, enumerable: !1, writable: !0, configurable: !0 } }), ct && (Object.setPrototypeOf ? Object.setPrototypeOf(mt, ct) : it(mt, ct));
  }
  var dt = 200, gt = 150, pt = function(mt) {
    ht(ct, mt);
    function ct(vt) {
      ut(this, ct);
      var At = ft(this, mt.call(this, vt));
      return At.onBoardMouseDown = function(xt) {
        var bt = xt.buttons;
        if (bt === 1) {
          var Et = xt.clientX, St = xt.clientY;
          At.pointMoveTo({
            x: Et,
            y: St
          }), At.removeListeners(), At.dragListener = (0, rt.default)(window, "mousemove", At.onBoardDrag), At.dragUpListener = (0, rt.default)(window, "mouseup", At.onBoardDragEnd);
        }
      }, At.onBoardTouchStart = function(xt) {
        if (xt.touches.length === 1) {
          At.removeTouchListeners();
          var bt = xt.targetTouches[0].clientX, Et = xt.targetTouches[0].clientY;
          At.pointMoveTo({
            x: bt,
            y: Et
          }), At.touchMoveListener = (0, rt.default)(window, "touchmove", At.onBoardTouchMove), At.touchEndListener = (0, rt.default)(window, "touchend", At.onBoardTouchEnd);
        }
      }, At.onBoardTouchMove = function(xt) {
        xt.preventDefault && xt.preventDefault();
        var bt = xt.targetTouches[0].clientX, Et = xt.targetTouches[0].clientY;
        At.pointMoveTo({
          x: bt,
          y: Et
        });
      }, At.onBoardTouchEnd = function() {
        At.removeTouchListeners();
      }, At.onBoardDrag = function(xt) {
        var bt = xt.clientX, Et = xt.clientY;
        At.pointMoveTo({
          x: bt,
          y: Et
        });
      }, At.onBoardDragEnd = function(xt) {
        var bt = xt.clientX, Et = xt.clientY;
        At.pointMoveTo({
          x: bt,
          y: Et
        }), At.removeListeners();
      }, At.getPrefixCls = function() {
        return At.props.rootPrefixCls + "-board";
      }, At.removeTouchListeners = function() {
        At.touchMoveListener && (At.touchMoveListener.remove(), At.touchMoveListener = null), At.touchEndListener && (At.touchEndListener.remove(), At.touchEndListener = null);
      }, At.removeListeners = function() {
        At.dragListener && (At.dragListener.remove(), At.dragListener = null), At.dragUpListener && (At.dragUpListener.remove(), At.dragUpListener = null);
      }, At.pointMoveTo = function(xt) {
        var bt = tt.default.findDOMNode(At).getBoundingClientRect(), Et = xt.x - bt.left, St = xt.y - bt.top, Bt = bt.width || dt, Ot = bt.height || gt;
        Et = Math.max(0, Et), Et = Math.min(Et, Bt), St = Math.max(0, St), St = Math.min(St, Ot);
        var Pt = At.props.color;
        Pt.saturation = Et / Bt, Pt.brightness = 1 - St / Ot, At.props.onChange(Pt);
      }, At;
    }
    return ct.prototype.componentWillUnmount = function() {
      this.removeListeners(), this.removeTouchListeners();
    }, ct.prototype.render = function() {
      var At = this.getPrefixCls(), xt = this.props.color, bt = {
        h: xt.hue,
        s: 1,
        v: 1
      }, Et = new lt.default(bt).toHexString(), St = xt.saturation * 100, Bt = (1 - xt.brightness) * 100;
      return _.default.createElement(
        "div",
        { className: At },
        _.default.createElement(
          "div",
          { className: At + "-hsv", style: { backgroundColor: Et } },
          _.default.createElement("div", { className: At + "-value" }),
          _.default.createElement("div", { className: At + "-saturation" })
        ),
        _.default.createElement("span", { style: { left: St + "%", top: Bt + "%" } }),
        _.default.createElement("div", {
          className: At + "-handler",
          onMouseDown: this.onBoardMouseDown,
          onTouchStart: this.onBoardTouchStart
        })
      );
    }, ct;
  }(_.default.Component);
  s.default = pt, pt.propTypes = {
    color: at.default.object,
    onChange: at.default.func,
    rootPrefixCls: at.default.string
  }, a.exports = s.default;
})(Board, Board.exports);
var BoardExports = Board.exports, Preview$2 = { exports: {} };
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var $ = reactExports, _ = ot($), _e = propTypesExports, tt = ot(_e), nt = colorExports, at = ot(nt);
  function ot(ut) {
    return ut && ut.__esModule ? ut : { default: ut };
  }
  function rt(ut, ft) {
    for (var ht = Object.getOwnPropertyNames(ft), dt = 0; dt < ht.length; dt++) {
      var gt = ht[dt], pt = Object.getOwnPropertyDescriptor(ft, gt);
      pt && pt.configurable && ut[gt] === void 0 && Object.defineProperty(ut, gt, pt);
    }
    return ut;
  }
  function st(ut, ft) {
    if (!(ut instanceof ft))
      throw new TypeError("Cannot call a class as a function");
  }
  function lt(ut, ft) {
    if (!ut)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return ft && (typeof ft == "object" || typeof ft == "function") ? ft : ut;
  }
  function et(ut, ft) {
    if (typeof ft != "function" && ft !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof ft);
    ut.prototype = Object.create(ft && ft.prototype, { constructor: { value: ut, enumerable: !1, writable: !0, configurable: !0 } }), ft && (Object.setPrototypeOf ? Object.setPrototypeOf(ut, ft) : rt(ut, ft));
  }
  var it = function(ut) {
    et(ft, ut);
    function ft() {
      var ht, dt, gt;
      st(this, ft);
      for (var pt = arguments.length, mt = Array(pt), ct = 0; ct < pt; ct++)
        mt[ct] = arguments[ct];
      return gt = (ht = (dt = lt(this, ut.call.apply(ut, [this].concat(mt))), dt), dt.onChange = function(vt) {
        var At = vt.target.value, xt = new at.default(At);
        dt.props.onChange(xt), vt.stopPropagation();
      }, dt.getPrefixCls = function() {
        return dt.props.rootPrefixCls + "-preview";
      }, ht), lt(dt, gt);
    }
    return ft.prototype.render = function() {
      var dt = this.getPrefixCls(), gt = this.props.color.toHexString();
      return _.default.createElement(
        "div",
        { className: dt },
        _.default.createElement("span", {
          style: {
            backgroundColor: gt,
            opacity: this.props.alpha / 100
          }
        }),
        _.default.createElement("input", {
          type: "color",
          value: gt,
          onChange: this.onChange,
          onClick: this.props.onInputClick
        })
      );
    }, ft;
  }(_.default.Component);
  s.default = it, it.propTypes = {
    rootPrefixCls: tt.default.string,
    color: tt.default.object,
    alpha: tt.default.number,
    onChange: tt.default.func,
    onInputClick: tt.default.func
  }, a.exports = s.default;
})(Preview$2, Preview$2.exports);
var PreviewExports = Preview$2.exports, Ribbon = { exports: {} };
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var $ = reactExports, _ = st($), _e = reactDomExports, tt = st(_e), nt = propTypesExports, at = st(nt), ot = addEventListener, rt = st(ot);
  function st(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  }
  function lt(ht, dt) {
    for (var gt = Object.getOwnPropertyNames(dt), pt = 0; pt < gt.length; pt++) {
      var mt = gt[pt], ct = Object.getOwnPropertyDescriptor(dt, mt);
      ct && ct.configurable && ht[mt] === void 0 && Object.defineProperty(ht, mt, ct);
    }
    return ht;
  }
  function et(ht, dt) {
    if (!(ht instanceof dt))
      throw new TypeError("Cannot call a class as a function");
  }
  function it(ht, dt) {
    if (!ht)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return dt && (typeof dt == "object" || typeof dt == "function") ? dt : ht;
  }
  function ut(ht, dt) {
    if (typeof dt != "function" && dt !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof dt);
    ht.prototype = Object.create(dt && dt.prototype, { constructor: { value: ht, enumerable: !1, writable: !0, configurable: !0 } }), dt && (Object.setPrototypeOf ? Object.setPrototypeOf(ht, dt) : lt(ht, dt));
  }
  var ft = function(ht) {
    ut(dt, ht);
    function dt(gt) {
      et(this, dt);
      var pt = it(this, ht.call(this, gt));
      return pt.onMouseDown = function(mt) {
        var ct = mt.clientX, vt = mt.clientY;
        pt.pointMoveTo({
          x: ct,
          y: vt
        }), pt.dragListener = (0, rt.default)(window, "mousemove", pt.onDrag), pt.dragUpListener = (0, rt.default)(window, "mouseup", pt.onDragEnd);
      }, pt.onDrag = function(mt) {
        var ct = mt.clientX, vt = mt.clientY;
        pt.pointMoveTo({
          x: ct,
          y: vt
        });
      }, pt.onDragEnd = function(mt) {
        var ct = mt.clientX, vt = mt.clientY;
        pt.pointMoveTo({
          x: ct,
          y: vt
        }), pt.removeListeners();
      }, pt.getPrefixCls = function() {
        return pt.props.rootPrefixCls + "-ribbon";
      }, pt.pointMoveTo = function(mt) {
        var ct = tt.default.findDOMNode(pt).getBoundingClientRect(), vt = ct.width, At = mt.x - ct.left;
        At = Math.max(0, At), At = Math.min(At, vt);
        var xt = At / vt, bt = xt * 360, Et = pt.props.color;
        Et.hue = bt, pt.props.onChange(Et);
      }, pt.removeListeners = function() {
        pt.dragListener && (pt.dragListener.remove(), pt.dragListener = null), pt.dragUpListener && (pt.dragUpListener.remove(), pt.dragUpListener = null);
      }, pt;
    }
    return dt.prototype.componentWillUnmount = function() {
      this.removeListeners();
    }, dt.prototype.render = function() {
      var pt = this.getPrefixCls(), mt = this.props.color.hue, ct = mt / 360 * 100;
      return _.default.createElement(
        "div",
        { className: pt },
        _.default.createElement("span", { ref: "point", style: { left: ct + "%" } }),
        _.default.createElement("div", { className: pt + "-handler", onMouseDown: this.onMouseDown })
      );
    }, dt;
  }(_.default.Component);
  s.default = ft, ft.propTypes = {
    rootPrefixCls: at.default.string,
    color: at.default.object,
    onChange: at.default.func
  }, a.exports = s.default;
})(Ribbon, Ribbon.exports);
var RibbonExports = Ribbon.exports, Alpha = { exports: {} };
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var $ = reactExports, _ = rt($), _e = reactDomExports, tt = propTypesExports, nt = rt(tt), at = addEventListener, ot = rt(at);
  function rt(ht) {
    return ht && ht.__esModule ? ht : { default: ht };
  }
  function st(ht, dt) {
    for (var gt = Object.getOwnPropertyNames(dt), pt = 0; pt < gt.length; pt++) {
      var mt = gt[pt], ct = Object.getOwnPropertyDescriptor(dt, mt);
      ct && ct.configurable && ht[mt] === void 0 && Object.defineProperty(ht, mt, ct);
    }
    return ht;
  }
  function lt(ht, dt) {
    if (!(ht instanceof dt))
      throw new TypeError("Cannot call a class as a function");
  }
  function et(ht, dt) {
    if (!ht)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return dt && (typeof dt == "object" || typeof dt == "function") ? dt : ht;
  }
  function it(ht, dt) {
    if (typeof dt != "function" && dt !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof dt);
    ht.prototype = Object.create(dt && dt.prototype, { constructor: { value: ht, enumerable: !1, writable: !0, configurable: !0 } }), dt && (Object.setPrototypeOf ? Object.setPrototypeOf(ht, dt) : st(ht, dt));
  }
  function ut(ht, dt, gt, pt) {
    return "rgba(" + [ht, dt, gt, pt / 100].join(",") + ")";
  }
  var ft = function(ht) {
    it(dt, ht);
    function dt(gt) {
      lt(this, dt);
      var pt = et(this, ht.call(this, gt));
      return pt.onMouseDown = function(mt) {
        var ct = mt.clientX, vt = mt.clientY;
        pt.pointMoveTo({
          x: ct,
          y: vt
        }), pt.dragListener = (0, ot.default)(window, "mousemove", pt.onDrag), pt.dragUpListener = (0, ot.default)(window, "mouseup", pt.onDragEnd);
      }, pt.onDrag = function(mt) {
        var ct = mt.clientX, vt = mt.clientY;
        pt.pointMoveTo({
          x: ct,
          y: vt
        });
      }, pt.onDragEnd = function(mt) {
        var ct = mt.clientX, vt = mt.clientY;
        pt.pointMoveTo({
          x: ct,
          y: vt
        }), pt.removeListeners();
      }, pt.getBackground = function() {
        var mt = pt.props.color, ct = mt.red, vt = mt.green, At = mt.blue, xt = "linear-gradient(to right, " + ut(ct, vt, At, 0) + " , " + ut(ct, vt, At, 100) + ")";
        return xt;
      }, pt.getPrefixCls = function() {
        return pt.props.rootPrefixCls + "-alpha";
      }, pt.pointMoveTo = function(mt) {
        var ct = (0, _e.findDOMNode)(pt).getBoundingClientRect(), vt = ct.width, At = mt.x - ct.left;
        At = Math.max(0, At), At = Math.min(At, vt);
        var xt = Math.round(At / vt * 100);
        pt.props.onChange(xt);
      }, pt.removeListeners = function() {
        pt.dragListener && (pt.dragListener.remove(), pt.dragListener = null), pt.dragUpListener && (pt.dragUpListener.remove(), pt.dragUpListener = null);
      }, pt;
    }
    return dt.prototype.componentWillUnmount = function() {
      this.removeListeners();
    }, dt.prototype.render = function() {
      var pt = this.getPrefixCls();
      return _.default.createElement(
        "div",
        { className: pt },
        _.default.createElement("div", { ref: "bg", className: pt + "-bg", style: { background: this.getBackground() } }),
        _.default.createElement("span", { style: { left: this.props.alpha + "%" } }),
        _.default.createElement("div", { className: pt + "-handler", onMouseDown: this.onMouseDown })
      );
    }, dt;
  }(_.default.Component);
  s.default = ft, ft.propTypes = {
    color: nt.default.object,
    onChange: nt.default.func,
    rootPrefixCls: nt.default.string,
    alpha: nt.default.number
  }, a.exports = s.default;
})(Alpha, Alpha.exports);
var AlphaExports = Alpha.exports, Params = { exports: {} }, percentage = { exports: {} };
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), s.default = $;
  function $(_) {
    return Math.round(_ * 100);
  }
  a.exports = s.default;
})(percentage, percentage.exports);
var percentageExports = percentage.exports;
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var $ = reactExports, _ = et($), _e = propTypesExports, tt = et(_e), nt = classnamesExports, at = et(nt), ot = colorExports, rt = et(ot), st = percentageExports, lt = et(st);
  function et(mt) {
    return mt && mt.__esModule ? mt : { default: mt };
  }
  function it(mt, ct) {
    for (var vt = Object.getOwnPropertyNames(ct), At = 0; At < vt.length; At++) {
      var xt = vt[At], bt = Object.getOwnPropertyDescriptor(ct, xt);
      bt && bt.configurable && mt[xt] === void 0 && Object.defineProperty(mt, xt, bt);
    }
    return mt;
  }
  function ut(mt, ct, vt) {
    return ct in mt ? Object.defineProperty(mt, ct, { value: vt, enumerable: !0, configurable: !0, writable: !0 }) : mt[ct] = vt, mt;
  }
  function ft(mt, ct) {
    if (!(mt instanceof ct))
      throw new TypeError("Cannot call a class as a function");
  }
  function ht(mt, ct) {
    if (!mt)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return ct && (typeof ct == "object" || typeof ct == "function") ? ct : mt;
  }
  function dt(mt, ct) {
    if (typeof ct != "function" && ct !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof ct);
    mt.prototype = Object.create(ct && ct.prototype, { constructor: { value: mt, enumerable: !1, writable: !0, configurable: !0 } }), ct && (Object.setPrototypeOf ? Object.setPrototypeOf(mt, ct) : it(mt, ct));
  }
  var gt = ["RGB", "HSB"], pt = function(mt) {
    dt(ct, mt);
    function ct(vt) {
      ft(this, ct);
      var At = ht(this, mt.call(this, vt));
      return At.getChannelInRange = function(xt, bt) {
        var Et = {
          RGB: [[0, 255], [0, 255], [0, 255]],
          HSB: [[0, 359], [0, 100], [0, 100]]
        }, St = At.state.mode, Bt = Et[St][bt], Ot = parseInt(xt, 10);
        return isNaN(Ot) && (Ot = 0), Ot = Math.max(Bt[0], Ot), Ot = Math.min(Ot, Bt[1]), Ot;
      }, At.getPrefixCls = function() {
        return At.props.rootPrefixCls + "-params";
      }, At.handleHexBlur = function() {
        var xt = At.state.hex, bt = null;
        rt.default.isValidHex(xt) && (bt = new rt.default(xt)), bt !== null && (At.setState({
          color: bt,
          hex: xt
        }), At.props.onChange(bt, !1));
      }, At.handleHexPress = function(xt) {
        var bt = At.state.hex;
        if (xt.nativeEvent.which === 13) {
          var Et = null;
          rt.default.isValidHex(bt) && (Et = new rt.default(bt)), Et !== null && (At.setState({
            color: Et,
            hex: bt
          }), At.props.onChange(Et, !1));
        }
      }, At.handleHexChange = function(xt) {
        var bt = xt.target.value;
        At.setState({
          hex: bt
        });
      }, At.handleModeChange = function() {
        var xt = At.state.mode, bt = (gt.indexOf(xt) + 1) % gt.length;
        xt = gt[bt], At.setState({
          mode: xt
        });
      }, At.handleAlphaHandler = function(xt) {
        var bt = parseInt(xt.target.value, 10);
        isNaN(bt) && (bt = 0), bt = Math.max(0, bt), bt = Math.min(bt, 100), At.props.onAlphaChange(bt);
      }, At.updateColorByChanel = function(xt, bt) {
        var Et = At.props.color, St = At.state.mode;
        return St === "HSB" ? xt === "H" ? Et.hue = parseInt(bt, 10) : xt === "S" ? Et.saturation = parseInt(bt, 10) / 100 : xt === "B" && (Et.brightness = parseInt(bt, 10) / 100) : xt === "R" ? Et.red = parseInt(bt, 10) : xt === "G" ? Et.green = parseInt(bt, 10) : xt === "B" && (Et.blue = parseInt(bt, 10)), Et;
      }, At.handleColorChannelChange = function(xt, bt) {
        var Et = At.getChannelInRange(bt.target.value, xt), St = At.state.mode, Bt = St[xt], Ot = At.updateColorByChanel(Bt, Et);
        At.setState({
          hex: Ot.hex,
          color: Ot
        }, function() {
          At.props.onChange(Ot, !1);
        });
      }, At.state = {
        mode: vt.mode,
        hex: vt.color.hex,
        color: vt.color
        // instanceof tinycolor
      }, At;
    }
    return ct.prototype.componentWillReceiveProps = function(At) {
      var xt = At.color;
      this.setState({
        color: xt,
        hex: xt.hex
      });
    }, ct.prototype.render = function() {
      var At, xt = this.getPrefixCls(), bt = this.props.enableAlpha, Et = this.state, St = Et.mode, Bt = Et.color, Ot = Bt[St];
      St === "HSB" && (Ot[0] = parseInt(Ot[0], 10), Ot[1] = (0, lt.default)(Ot[1]), Ot[2] = (0, lt.default)(Ot[2]));
      var Pt = (0, at.default)((At = {}, ut(At, xt, !0), ut(At, xt + "-has-alpha", bt), At));
      return _.default.createElement(
        "div",
        { className: Pt },
        _.default.createElement(
          "div",
          { className: xt + "-input" },
          _.default.createElement("input", {
            className: xt + "-hex",
            type: "text",
            maxLength: "6",
            onKeyPress: this.handleHexPress,
            onBlur: this.handleHexBlur,
            onChange: this.handleHexChange,
            value: this.state.hex.toLowerCase()
          }),
          _.default.createElement("input", {
            type: "number",
            ref: "channel_0",
            value: Ot[0],
            onChange: this.handleColorChannelChange.bind(null, 0)
          }),
          _.default.createElement("input", {
            type: "number",
            ref: "channel_1",
            value: Ot[1],
            onChange: this.handleColorChannelChange.bind(null, 1)
          }),
          _.default.createElement("input", {
            type: "number",
            ref: "channel_2",
            value: Ot[2],
            onChange: this.handleColorChannelChange.bind(null, 2)
          }),
          bt && _.default.createElement("input", {
            type: "number",
            value: Math.round(this.props.alpha),
            onChange: this.handleAlphaHandler
          })
        ),
        _.default.createElement(
          "div",
          { className: xt + "-lable" },
          _.default.createElement(
            "label",
            { className: xt + "-lable-hex" },
            "Hex"
          ),
          _.default.createElement(
            "label",
            { className: xt + "-lable-number", onClick: this.handleModeChange },
            St[0]
          ),
          _.default.createElement(
            "label",
            { className: xt + "-lable-number", onClick: this.handleModeChange },
            St[1]
          ),
          _.default.createElement(
            "label",
            { className: xt + "-lable-number", onClick: this.handleModeChange },
            St[2]
          ),
          bt && _.default.createElement(
            "label",
            { className: xt + "-lable-alpha" },
            "A"
          )
        )
      );
    }, ct;
  }(_.default.Component);
  s.default = pt, pt.propTypes = {
    alpha: tt.default.number,
    enableAlpha: tt.default.bool,
    color: tt.default.object.isRequired,
    mode: tt.default.oneOf(gt),
    onAlphaChange: tt.default.func,
    onChange: tt.default.func,
    rootPrefixCls: tt.default.string
  }, pt.defaultProps = {
    mode: gt[0],
    enableAlpha: !0
  }, a.exports = s.default;
})(Params, Params.exports);
var ParamsExports = Params.exports, validationColor = function a(s, $, _) {
  if (s[$] && !/^#[0-9a-fA-F]{3,6}$/.test(s[$]))
    return new Error(_ + ".props." + $ + " Validation failed!");
};
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var $ = reactExports, _ = vt($), _e = propTypesExports, tt = vt(_e), nt = colorExports, at = vt(nt), ot = BoardExports, rt = vt(ot), st = PreviewExports, lt = vt(st), et = RibbonExports, it = vt(et), ut = AlphaExports, ft = vt(ut), ht = ParamsExports, dt = vt(ht), gt = classnamesExports, pt = vt(gt), mt = validationColor, ct = vt(mt);
  function vt(wt) {
    return wt && wt.__esModule ? wt : { default: wt };
  }
  function At(wt, Ct) {
    for (var It = Object.getOwnPropertyNames(Ct), yt = 0; yt < It.length; yt++) {
      var Rt = It[yt], kt = Object.getOwnPropertyDescriptor(Ct, Rt);
      kt && kt.configurable && wt[Rt] === void 0 && Object.defineProperty(wt, Rt, kt);
    }
    return wt;
  }
  function xt(wt, Ct, It) {
    return Ct in wt ? Object.defineProperty(wt, Ct, { value: It, enumerable: !0, configurable: !0, writable: !0 }) : wt[Ct] = It, wt;
  }
  function bt(wt, Ct) {
    if (!(wt instanceof Ct))
      throw new TypeError("Cannot call a class as a function");
  }
  function Et(wt, Ct) {
    if (!wt)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return Ct && (typeof Ct == "object" || typeof Ct == "function") ? Ct : wt;
  }
  function St(wt, Ct) {
    if (typeof Ct != "function" && Ct !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof Ct);
    wt.prototype = Object.create(Ct && Ct.prototype, { constructor: { value: wt, enumerable: !1, writable: !0, configurable: !0 } }), Ct && (Object.setPrototypeOf ? Object.setPrototypeOf(wt, Ct) : At(wt, Ct));
  }
  function Bt() {
  }
  var Ot = function(wt) {
    St(Ct, wt);
    function Ct(It) {
      bt(this, Ct);
      var yt = Et(this, wt.call(this, It));
      Pt.call(yt);
      var Rt = typeof It.alpha > "u" ? It.defaultAlpha : Math.min(It.alpha, It.defaultAlpha), kt = new at.default(It.color || It.defaultColor);
      return yt.state = {
        color: kt,
        alpha: Rt
      }, yt;
    }
    return Ct.prototype.componentDidMount = function() {
      this.props.onMount(this.ref);
    }, Ct.prototype.componentWillReceiveProps = function(yt) {
      if (yt.color) {
        var Rt = new at.default(yt.color);
        this.setState({
          color: Rt
        });
      }
      yt.alpha !== void 0 && this.setState({
        alpha: yt.alpha
      });
    }, Ct.prototype.render = function() {
      var yt, Rt = this, kt = this.props, jt = kt.prefixCls, Ht = kt.enableAlpha, Ft = this.state, _t = Ft.color, Nt = Ft.alpha, Mt = (0, pt.default)((yt = {}, xt(yt, jt + "-wrap", !0), xt(yt, jt + "-wrap-has-alpha", Ht), yt));
      return _.default.createElement(
        "div",
        {
          ref: function($t) {
            return Rt.ref = $t;
          },
          className: [jt, this.props.className].join(" "),
          style: this.props.style,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          tabIndex: "0"
        },
        _.default.createElement(
          "div",
          { className: jt + "-inner" },
          _.default.createElement(rt.default, { rootPrefixCls: jt, color: _t, onChange: this.handleChange }),
          _.default.createElement(
            "div",
            { className: Mt },
            _.default.createElement(
              "div",
              { className: jt + "-wrap-ribbon" },
              _.default.createElement(it.default, { rootPrefixCls: jt, color: _t, onChange: this.handleChange })
            ),
            Ht && _.default.createElement(
              "div",
              { className: jt + "-wrap-alpha" },
              _.default.createElement(ft.default, {
                rootPrefixCls: jt,
                alpha: Nt,
                color: _t,
                onChange: this.handleAlphaChange
              })
            ),
            _.default.createElement(
              "div",
              { className: jt + "-wrap-preview" },
              _.default.createElement(lt.default, {
                rootPrefixCls: jt,
                alpha: Nt,
                onChange: this.handleChange,
                onInputClick: this.onSystemColorPickerOpen,
                color: _t
              })
            )
          ),
          _.default.createElement(
            "div",
            { className: jt + "-wrap", style: { height: 40, marginTop: 6 } },
            _.default.createElement(dt.default, {
              rootPrefixCls: jt,
              color: _t,
              alpha: Nt,
              onAlphaChange: this.handleAlphaChange,
              onChange: this.handleChange,
              mode: this.props.mode,
              enableAlpha: this.props.enableAlpha
            })
          )
        )
      );
    }, Ct;
  }(_.default.Component), Pt = function() {
    var Ct = this;
    this.onSystemColorPickerOpen = function(It) {
      It.target.type === "color" && (Ct.systemColorPickerOpen = !0);
    }, this.onFocus = function() {
      Ct._blurTimer ? (clearTimeout(Ct._blurTimer), Ct._blurTimer = null) : Ct.props.onFocus();
    }, this.onBlur = function() {
      Ct._blurTimer && clearTimeout(Ct._blurTimer), Ct._blurTimer = setTimeout(function() {
        if (Ct.systemColorPickerOpen) {
          Ct.systemColorPickerOpen = !1;
          return;
        }
        Ct.props.onBlur();
      }, 100);
    }, this.handleAlphaChange = function(It) {
      var yt = Ct.state.color;
      yt.alpha = It, Ct.setState({
        alpha: It,
        color: yt
      }), Ct.props.onChange({
        color: yt.toHexString(),
        alpha: It
      });
    }, this.handleChange = function(It) {
      var yt = Ct.state.alpha;
      It.alpha = yt, Ct.setState({ color: It }), Ct.props.onChange({
        color: It.toHexString(),
        alpha: It.alpha
      });
    };
  };
  s.default = Ot, Ot.propTypes = {
    alpha: tt.default.number,
    className: tt.default.string,
    color: ct.default,
    // Hex string
    defaultAlpha: tt.default.number,
    defaultColor: ct.default,
    // Hex string
    enableAlpha: tt.default.bool,
    mode: tt.default.oneOf(["RGB", "HSL", "HSB"]),
    onBlur: tt.default.func,
    onChange: tt.default.func,
    onFocus: tt.default.func,
    onMount: tt.default.func,
    prefixCls: tt.default.string,
    style: tt.default.object
  }, Ot.defaultProps = {
    className: "",
    defaultAlpha: 100,
    defaultColor: "#ff0000",
    enableAlpha: !0,
    mode: "RGB",
    onBlur: Bt,
    onChange: Bt,
    onFocus: Bt,
    onMount: Bt,
    prefixCls: "rc-color-picker-panel",
    style: {}
  }, a.exports = s.default;
})(Panel$1, Panel$1.exports);
var PanelExports = Panel$1.exports, placements = { exports: {} };
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var $ = {
    adjustX: 1,
    adjustY: 1
  }, _ = [0, 0], _e = {
    topLeft: {
      points: ["bl", "tl"],
      overflow: $,
      offset: [0, -5],
      targetOffset: _
    },
    topRight: {
      points: ["br", "tr"],
      overflow: $,
      offset: [0, -5],
      targetOffset: _
    },
    bottomLeft: {
      points: ["tl", "bl"],
      overflow: $,
      offset: [0, 5],
      targetOffset: _
    },
    bottomRight: {
      points: ["tr", "br"],
      overflow: $,
      offset: [0, 5],
      targetOffset: _
    }
  };
  s.default = _e, a.exports = s.default;
})(placements, placements.exports);
var placementsExports = placements.exports;
(function(a, s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  });
  var $ = /* @__PURE__ */ function() {
    function bt(Et, St) {
      var Bt = [], Ot = !0, Pt = !1, wt = void 0;
      try {
        for (var Ct = Et[Symbol.iterator](), It; !(Ot = (It = Ct.next()).done) && (Bt.push(It.value), !(St && Bt.length === St)); Ot = !0)
          ;
      } catch (yt) {
        Pt = !0, wt = yt;
      } finally {
        try {
          !Ot && Ct.return && Ct.return();
        } finally {
          if (Pt)
            throw wt;
        }
      }
      return Bt;
    }
    return function(Et, St) {
      if (Array.isArray(Et))
        return Et;
      if (Symbol.iterator in Object(Et))
        return bt(Et, St);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }(), _ = Object.assign || function(bt) {
    for (var Et = 1; Et < arguments.length; Et++) {
      var St = arguments[Et];
      for (var Bt in St)
        Object.prototype.hasOwnProperty.call(St, Bt) && (bt[Bt] = St[Bt]);
    }
    return bt;
  }, _e = reactExports, tt = dt(_e), nt = reactDomExports, at = propTypesExports, ot = dt(at), rt = require$$3$1, st = dt(rt), lt = PanelExports, et = dt(lt), it = placementsExports, ut = dt(it), ft = colorExports, ht = dt(ft);
  function dt(bt) {
    return bt && bt.__esModule ? bt : { default: bt };
  }
  function gt(bt, Et) {
    for (var St = Object.getOwnPropertyNames(Et), Bt = 0; Bt < St.length; Bt++) {
      var Ot = St[Bt], Pt = Object.getOwnPropertyDescriptor(Et, Ot);
      Pt && Pt.configurable && bt[Ot] === void 0 && Object.defineProperty(bt, Ot, Pt);
    }
    return bt;
  }
  function pt(bt, Et) {
    if (!(bt instanceof Et))
      throw new TypeError("Cannot call a class as a function");
  }
  function mt(bt, Et) {
    if (!bt)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return Et && (typeof Et == "object" || typeof Et == "function") ? Et : bt;
  }
  function ct(bt, Et) {
    if (typeof Et != "function" && Et !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof Et);
    bt.prototype = Object.create(Et && Et.prototype, { constructor: { value: bt, enumerable: !1, writable: !0, configurable: !0 } }), Et && (Object.setPrototypeOf ? Object.setPrototypeOf(bt, Et) : gt(bt, Et));
  }
  function vt(bt, Et) {
    this[bt] = Et;
  }
  function At(bt) {
    bt.preventDefault();
  }
  var xt = function(bt) {
    ct(Et, bt);
    function Et(St) {
      pt(this, Et);
      var Bt = mt(this, bt.call(this, St)), Ot = typeof St.alpha > "u" ? St.defaultAlpha : Math.min(St.alpha, St.defaultAlpha);
      Bt.state = {
        color: St.color || St.defaultColor,
        alpha: Ot,
        open: !1
      };
      var Pt = ["onTriggerClick", "onChange", "onBlur", "getPickerElement", "getRootDOMNode", "getTriggerDOMNode", "onVisibleChange", "onPanelMount", "setOpen", "open", "close", "focus"];
      return Pt.forEach(function(wt) {
        Bt[wt] = Bt[wt].bind(Bt);
      }), Bt.saveTriggerRef = vt.bind(Bt, "triggerInstance"), Bt;
    }
    return Et.prototype.componentWillReceiveProps = function(Bt) {
      Bt.color && this.setState({
        color: Bt.color
      }), Bt.alpha !== null && Bt.alpha !== void 0 && this.setState({
        alpha: Bt.alpha
      });
    }, Et.prototype.onTriggerClick = function() {
      this.setState({
        open: !this.state.open
      });
    }, Et.prototype.onChange = function(Bt) {
      var Ot = this;
      this.setState(_({}, Bt), function() {
        Ot.props.onChange(Ot.state);
      });
    }, Et.prototype.onBlur = function() {
      this.setOpen(!1);
    }, Et.prototype.onVisibleChange = function(Bt) {
      this.setOpen(Bt);
    }, Et.prototype.onPanelMount = function(Bt) {
      this.state.open && setTimeout(function() {
        Bt.focus();
      }, 1);
    }, Et.prototype.setOpen = function(Bt, Ot) {
      var Pt = this;
      this.state.open !== Bt && this.setState({
        open: Bt
      }, function() {
        typeof Ot == "function" && Ot();
        var wt = Pt.props, Ct = wt.onOpen, It = wt.onClose;
        Pt.state.open ? Ct(Pt.state) : It(Pt.state);
      });
    }, Et.prototype.getRootDOMNode = function() {
      return (0, nt.findDOMNode)(this);
    }, Et.prototype.getTriggerDOMNode = function() {
      return (0, nt.findDOMNode)(this.triggerInstance);
    }, Et.prototype.getPickerElement = function() {
      return tt.default.createElement(et.default, {
        onMount: this.onPanelMount,
        defaultColor: this.state.color,
        alpha: this.state.alpha,
        enableAlpha: this.props.enableAlpha,
        prefixCls: this.props.prefixCls + "-panel",
        onChange: this.onChange,
        onBlur: this.onBlur,
        mode: this.props.mode,
        className: this.props.className
      });
    }, Et.prototype.open = function(Bt) {
      this.setOpen(!0, Bt);
    }, Et.prototype.close = function(Bt) {
      this.setOpen(!1, Bt);
    }, Et.prototype.focus = function() {
      this.state.open || (0, nt.findDOMNode)(this).focus();
    }, Et.prototype.render = function() {
      var Bt = this.props, Ot = this.state, Pt = [Bt.prefixCls + "-wrap", Bt.className];
      Ot.open && Pt.push(Bt.prefixCls + "-open");
      var wt = Bt.children, Ct = $(new ht.default(this.state.color).RGB, 3), It = Ct[0], yt = Ct[1], Rt = Ct[2], kt = [It, yt, Rt];
      kt.push(this.state.alpha / 100), wt && (wt = tt.default.cloneElement(wt, {
        ref: this.saveTriggerRef,
        unselectable: "unselectable",
        style: {
          backgroundColor: "rgba(" + kt.join(",") + ")"
        },
        onClick: this.onTriggerClick,
        onMouseDown: At
      }));
      var jt = Bt.prefixCls, Ht = Bt.placement, Ft = Bt.style, _t = Bt.getCalendarContainer, Nt = Bt.align, Mt = Bt.animation, Lt = Bt.disabled, $t = Bt.transitionName;
      return tt.default.createElement(
        "div",
        { className: Pt.join(" ") },
        tt.default.createElement(
          st.default,
          {
            popup: this.getPickerElement(),
            popupAlign: Nt,
            builtinPlacements: ut.default,
            popupPlacement: Ht,
            action: Lt ? [] : ["click"],
            destroyPopupOnHide: !0,
            getPopupContainer: _t,
            popupStyle: Ft,
            popupAnimation: Mt,
            popupTransitionName: $t,
            popupVisible: Ot.open,
            onPopupVisibleChange: this.onVisibleChange,
            prefixCls: jt
          },
          wt
        )
      );
    }, Et;
  }(tt.default.Component);
  s.default = xt, xt.propTypes = {
    defaultColor: ot.default.string,
    defaultAlpha: ot.default.number,
    // can custom
    alpha: ot.default.number,
    children: ot.default.node.isRequired,
    className: ot.default.string,
    color: ot.default.string,
    enableAlpha: ot.default.bool,
    mode: ot.default.oneOf(["RGB", "HSL", "HSB"]),
    onChange: ot.default.func,
    onClose: ot.default.func,
    onOpen: ot.default.func,
    placement: ot.default.oneOf(["topLeft", "topRight", "bottomLeft", "bottomRight"]),
    prefixCls: ot.default.string.isRequired,
    style: ot.default.object
  }, xt.defaultProps = {
    defaultColor: "#F00",
    defaultAlpha: 100,
    onChange: function() {
    },
    onOpen: function() {
    },
    onClose: function() {
    },
    children: tt.default.createElement("span", { className: "rc-color-picker-trigger" }),
    className: "",
    enableAlpha: !0,
    placement: "topLeft",
    prefixCls: "rc-color-picker",
    style: {}
  }, a.exports = s.default;
})(ColorPicker$1, ColorPicker$1.exports);
var ColorPickerExports = ColorPicker$1.exports;
lib$1.exports = ColorPickerExports;
lib$1.exports.Panel = PanelExports;
var libExports = lib$1.exports;
const ColorPicker = /* @__PURE__ */ getDefaultExportFromCjs(libExports), alphaHexMap = {
  "1.00": "FF",
  0.99: "FC",
  0.98: "FA",
  0.97: "F7",
  0.96: "F5",
  0.95: "F2",
  0.94: "F0",
  0.93: "ED",
  0.92: "EB",
  0.91: "E8",
  "0.90": "E6",
  0.89: "E3",
  0.88: "E0",
  0.87: "DE",
  0.86: "DB",
  0.85: "D9",
  0.84: "D6",
  0.83: "D4",
  0.82: "D1",
  0.81: "CF",
  "0.80": "CC",
  0.79: "C9",
  0.78: "C7",
  0.77: "C4",
  0.76: "C2",
  0.75: "BF",
  0.74: "BD",
  0.73: "BA",
  0.72: "B8",
  0.71: "B5",
  "0.70": "B3",
  0.69: "B0",
  0.68: "AD",
  0.67: "AB",
  0.66: "A8",
  0.65: "A6",
  0.64: "A3",
  0.63: "A1",
  0.62: "9E",
  0.61: "9C",
  "0.60": "99",
  0.59: "96",
  0.58: "94",
  0.57: "91",
  0.56: "8F",
  0.55: "8C",
  0.54: "8A",
  0.53: "87",
  0.52: "85",
  0.51: "82",
  "0.50": "80",
  0.49: "7D",
  0.48: "7A",
  0.47: "78",
  0.46: "75",
  0.45: "73",
  0.44: "70",
  0.43: "6E",
  0.42: "6B",
  0.41: "69",
  "0.40": "66",
  0.39: "63",
  0.38: "61",
  0.37: "5E",
  0.36: "5C",
  0.35: "59",
  0.34: "57",
  0.33: "54",
  0.32: "52",
  0.31: "4F",
  "0.30": "4D",
  0.29: "4A",
  0.28: "47",
  0.27: "45",
  0.26: "42",
  0.25: "40",
  0.24: "3D",
  0.23: "3B",
  0.22: "38",
  0.21: "36",
  "0.20": "33",
  0.19: "30",
  0.18: "2E",
  0.17: "2B",
  0.16: "29",
  0.15: "26",
  0.14: "24",
  0.13: "21",
  0.12: "1F",
  0.11: "1C",
  "0.10": "1A",
  0.09: "17",
  0.08: "14",
  0.07: "12",
  0.06: "0F",
  0.05: "0D",
  0.04: "0A",
  0.03: "08",
  0.02: "05",
  0.01: "03",
  "0.00": "00"
};
var getAlphaFromHex = function a() {
  var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "#ffffff", $ = s.slice(7), _ = 100;
  for (var _e in alphaHexMap)
    alphaHexMap[_e] === $.toUpperCase() && (_ = Number(_e) * 100);
  return _;
}, Color = function a(s) {
  var $ = s.className, _ = s.schema, _e = s.disabled, tt = s.readOnly, nt = s.value, at = s.onChange, ot = s.style, rt = function(et) {
    if (!(_e || tt)) {
      var it = alphaHexMap[(et.alpha / 100).toFixed(2)], ut = et.color + (et.alpha === 100 ? "" : it);
      at(ut);
    }
  }, st = function(et) {
    at(et.target.value);
  };
  return /* @__PURE__ */ React$a.createElement("div", {
    className: "fr-color-picker",
    style: ot
  }, _e || tt ? /* @__PURE__ */ React$a.createElement("span", {
    className: "rc-color-picker-trigger",
    style: {
      backgroundColor: nt || "#ffffff"
    }
  }) : /* @__PURE__ */ React$a.createElement(ColorPicker, {
    type: _ == null ? void 0 : _.format,
    animation: "slide-up",
    color: nt && nt.slice(0, 7) || "#ffffff",
    alpha: getAlphaFromHex(nt),
    onChange: rt,
    disabled: !0
  }), tt ? /* @__PURE__ */ React$a.createElement("span", null, nt || "#ffffff") : /* @__PURE__ */ React$a.createElement(_Input, {
    className: $,
    placeholder: "#ffffff",
    disabled: _e,
    value: nt,
    onChange: st
  }));
}, quarterOfYear$1 = { exports: {} };
(function(a, s) {
  (function($, _) {
    a.exports = _();
  })(commonjsGlobal, function() {
    var $ = "month", _ = "quarter";
    return function(_e, tt) {
      var nt = tt.prototype;
      nt.quarter = function(rt) {
        return this.$utils().u(rt) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (rt - 1));
      };
      var at = nt.add;
      nt.add = function(rt, st) {
        return rt = Number(rt), this.$utils().p(st) === _ ? this.add(3 * rt, $) : at.bind(this)(rt, st);
      };
      var ot = nt.startOf;
      nt.startOf = function(rt, st) {
        var lt = this.$utils(), et = !!lt.u(st) || st;
        if (lt.p(rt) === _) {
          var it = this.quarter() - 1;
          return et ? this.month(3 * it).startOf($).startOf("day") : this.month(3 * it + 2).endOf($).endOf("day");
        }
        return ot.bind(this)(rt, st);
      };
    };
  });
})(quarterOfYear$1);
var quarterOfYearExports = quarterOfYear$1.exports;
const quarterOfYear = /* @__PURE__ */ getDefaultExportFromCjs(quarterOfYearExports);
function _slicedToArray$a(a, s) {
  return _arrayWithHoles$a(a) || _iterableToArrayLimit$a(a, s) || _unsupportedIterableToArray$c(a, s) || _nonIterableRest$a();
}
function _nonIterableRest$a() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$c(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$c(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$c(a, s);
  }
}
function _arrayLikeToArray$c(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$a(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$a(a) {
  if (Array.isArray(a))
    return a;
}
dayjs.extend(weekOfYear);
function isUrl(a) {
  var s = /^(?:\w+:)?\/\/(\S+)$/;
  return typeof a != "string" ? !1 : s.test(a);
}
function getFormat(a) {
  var s;
  switch (a) {
    case "date":
      s = "YYYY-MM-DD";
      break;
    case "time":
      s = "HH:mm:ss";
      break;
    case "dateTime":
      s = "YYYY-MM-DD HH:mm:ss";
      break;
    case "week":
      s = "YYYY-w";
      break;
    case "year":
      s = "YYYY";
      break;
    case "quarter":
      s = "YYYY-Q";
      break;
    case "month":
      s = "YYYY-MM";
      break;
    default:
      typeof a == "string" ? s = a : s = "YYYY-MM-DD";
  }
  return s;
}
var transformDateValue = function a(s, $, _) {
  var _e, tt = s || void 0;
  if (typeof s == "string") {
    if ($ === "week") {
      var nt = s.split("-"), at = _slicedToArray$a(nt, 2), ot = at[0], rt = at[1];
      tt = (_e = dayjs(ot)) === null || _e === void 0 ? void 0 : _e.week(Number(rt));
    }
    if ($ === "quarter") {
      var st = s.split("-"), lt = _slicedToArray$a(st, 2), et = lt[0], it = lt[1];
      tt = dayjs(et).quarter(it);
    }
  }
  return tt && (tt = dayjs(tt, _)), tt;
}, translation = function a(s) {
  return function($) {
    var _, _e = (_ = s == null ? void 0 : s.locale) === null || _ === void 0 ? void 0 : _.FormRender;
    return _e[$];
  };
}, DatePicker$1 = generatePicker(generateConfig);
dayjs.extend(quarterOfYear);
var DateCmpt = function a(s) {
  var $ = s.onChange, _ = s.format, _e = s.value, tt = s.style, nt = __rest$3(s, ["onChange", "format", "value", "style"]), at = getFormat(_), ot = reactExports.useMemo(function() {
    return transformDateValue(_e, _, at);
  }, [_e]), rt = function(et, it) {
    var ut = it;
    (_ === "week" || _ === "quarter") && (ut = dayjs(et).format(at)), $(ut);
  }, st = {
    value: ot,
    style: Object.assign({
      width: "100%"
    }, tt),
    onChange: rt
  };
  return _ === "dateTime" && (st.showTime = !0), ["week", "month", "quarter", "year"].indexOf(_) > -1 && (st.picker = _), at === _ && (st.format = _), /* @__PURE__ */ React$a.createElement(DatePicker$1, Object.assign({}, st, nt));
};
const DatePicker = withFieldWrap(DateCmpt);
dayjs.extend(quarterOfYear);
var RangePicker$1 = DatePicker$1.RangePicker, DateRange = function a(s) {
  var $ = s.onChange, _ = s.format, _e = s.value, tt = s.style, nt = __rest$3(s, ["onChange", "format", "value", "style"]), at = getFormat(_), ot = reactExports.useMemo(function() {
    return _e && _e.map(function(lt) {
      return transformDateValue(lt, _, at);
    });
  }, [_e]), rt = function(et, it) {
    var ut = it;
    ["week", "quarter"].includes(_) && (ut = (et || []).map(function(ht) {
      return dayjs(ht).format(at);
    }));
    var ft = ut.every(function(ht) {
      return !!ht;
    });
    ft || (ut = null), $(ut);
  }, st = {
    value: ot,
    style: Object.assign({
      width: "100%"
    }, tt),
    onChange: rt
  };
  return _ === "dateTime" && (st.showTime = !0), ["week", "month", "quarter", "year"].indexOf(_) > -1 && (st.picker = _), st = Object.assign(Object.assign({}, st), nt), at === _ && (st.format = _), /* @__PURE__ */ React$a.createElement(RangePicker$1, Object.assign({}, st));
};
const DateRange$1 = withFieldWrap(DateRange);
var TimePicker$1 = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  return /* @__PURE__ */ reactExports.createElement(DatePicker$1, Object.assign({}, a, {
    picker: "time",
    mode: void 0,
    ref: s
  }));
});
TimePicker$1.displayName = "TimePicker";
TimePicker$1.RangePicker = /* @__PURE__ */ reactExports.forwardRef(function(a, s) {
  return /* @__PURE__ */ reactExports.createElement(DatePicker$1.RangePicker, Object.assign({}, a, {
    picker: "time",
    mode: void 0,
    ref: s
  }));
});
var Time = function a(s) {
  var $ = s.onChange, _ = s.format, _e = _ === void 0 ? "time" : _, tt = s.value, nt = s.style, at = __rest$3(s, ["onChange", "format", "value", "style"]), ot = getFormat(_e), rt = tt ? dayjs(tt, ot) : void 0, st = function(it, ut) {
    $(ut);
  }, lt = Object.assign({
    value: rt,
    style: Object.assign({
      width: "100%"
    }, nt),
    onChange: st,
    format: ot
  }, at);
  return /* @__PURE__ */ React$a.createElement(TimePicker$1, Object.assign({}, lt));
};
const TimePicker = withFieldWrap(Time);
function _slicedToArray$9(a, s) {
  return _arrayWithHoles$9(a) || _iterableToArrayLimit$9(a, s) || _unsupportedIterableToArray$b(a, s) || _nonIterableRest$9();
}
function _nonIterableRest$9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$b(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$b(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$b(a, s);
  }
}
function _arrayLikeToArray$b(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$9(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$9(a) {
  if (Array.isArray(a))
    return a;
}
var RangePicker = TimePicker$1.RangePicker, TimeRange = function a(s) {
  var $ = s.onChange, _ = s.format, _e = _ === void 0 ? "time" : _, tt = s.value, nt = s.style, at = s.schema, ot, rt, st = getFormat(_e), lt = Array.isArray(tt) ? tt : [], et = _slicedToArray$9(lt, 2), it = et[0], ut = et[1], ft = it && ut ? [dayjs(it, ((ot = at == null ? void 0 : at.props) === null || ot === void 0 ? void 0 : ot.format) || st), dayjs(ut, ((rt = at == null ? void 0 : at.props) === null || rt === void 0 ? void 0 : rt.format) || st)] : [], ht = function(pt, mt) {
    var ct = mt[0] === "" || mt[1] === "", vt = mt[0] === void 0 || mt[1] === void 0;
    $(ct || vt ? void 0 : mt);
  }, dt = Object.assign({
    style: Object.assign({
      width: "100%"
    }, nt),
    value: ft,
    onChange: ht
  }, at.props || {});
  return /* @__PURE__ */ React$a.createElement(RangePicker, Object.assign({}, dt));
}, PictureOutlined$2 = {}, _typeof$g = { exports: {} };
(function(a) {
  function s($) {
    "@babel/helpers - typeof";
    return a.exports = s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
      return typeof _;
    } : function(_) {
      return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
    }, a.exports.__esModule = !0, a.exports.default = a.exports, s($);
  }
  a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
})(_typeof$g);
var _typeofExports = _typeof$g.exports, objectSpread2 = { exports: {} }, defineProperty = { exports: {} }, toPropertyKey = { exports: {} }, toPrimitive = { exports: {} }, hasRequiredToPrimitive;
function requireToPrimitive() {
  return hasRequiredToPrimitive || (hasRequiredToPrimitive = 1, function(a) {
    var s = _typeofExports.default;
    function $(_, _e) {
      if (s(_) != "object" || !_)
        return _;
      var tt = _[Symbol.toPrimitive];
      if (tt !== void 0) {
        var nt = tt.call(_, _e || "default");
        if (s(nt) != "object")
          return nt;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (_e === "string" ? String : Number)(_);
    }
    a.exports = $, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(toPrimitive)), toPrimitive.exports;
}
var hasRequiredToPropertyKey;
function requireToPropertyKey() {
  return hasRequiredToPropertyKey || (hasRequiredToPropertyKey = 1, function(a) {
    var s = _typeofExports.default, $ = requireToPrimitive();
    function _(_e) {
      var tt = $(_e, "string");
      return s(tt) == "symbol" ? tt : String(tt);
    }
    a.exports = _, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(toPropertyKey)), toPropertyKey.exports;
}
var hasRequiredDefineProperty;
function requireDefineProperty() {
  return hasRequiredDefineProperty || (hasRequiredDefineProperty = 1, function(a) {
    var s = requireToPropertyKey();
    function $(_, _e, tt) {
      return _e = s(_e), _e in _ ? Object.defineProperty(_, _e, {
        value: tt,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : _[_e] = tt, _;
    }
    a.exports = $, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(defineProperty)), defineProperty.exports;
}
var hasRequiredObjectSpread2;
function requireObjectSpread2() {
  return hasRequiredObjectSpread2 || (hasRequiredObjectSpread2 = 1, function(a) {
    var s = requireDefineProperty();
    function $(_e, tt) {
      var nt = Object.keys(_e);
      if (Object.getOwnPropertySymbols) {
        var at = Object.getOwnPropertySymbols(_e);
        tt && (at = at.filter(function(ot) {
          return Object.getOwnPropertyDescriptor(_e, ot).enumerable;
        })), nt.push.apply(nt, at);
      }
      return nt;
    }
    function _(_e) {
      for (var tt = 1; tt < arguments.length; tt++) {
        var nt = arguments[tt] != null ? arguments[tt] : {};
        tt % 2 ? $(Object(nt), !0).forEach(function(at) {
          s(_e, at, nt[at]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(_e, Object.getOwnPropertyDescriptors(nt)) : $(Object(nt)).forEach(function(at) {
          Object.defineProperty(_e, at, Object.getOwnPropertyDescriptor(nt, at));
        });
      }
      return _e;
    }
    a.exports = _, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(objectSpread2)), objectSpread2.exports;
}
var PictureOutlined$1 = {}, hasRequiredPictureOutlined;
function requirePictureOutlined() {
  if (hasRequiredPictureOutlined)
    return PictureOutlined$1;
  hasRequiredPictureOutlined = 1, Object.defineProperty(PictureOutlined$1, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" } }] }, name: "picture", theme: "outlined" };
  return PictureOutlined$1.default = a, PictureOutlined$1;
}
var AntdIcon = {}, slicedToArray = { exports: {} }, arrayWithHoles = { exports: {} }, hasRequiredArrayWithHoles;
function requireArrayWithHoles() {
  return hasRequiredArrayWithHoles || (hasRequiredArrayWithHoles = 1, function(a) {
    function s($) {
      if (Array.isArray($))
        return $;
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(arrayWithHoles)), arrayWithHoles.exports;
}
var iterableToArrayLimit = { exports: {} }, hasRequiredIterableToArrayLimit;
function requireIterableToArrayLimit() {
  return hasRequiredIterableToArrayLimit || (hasRequiredIterableToArrayLimit = 1, function(a) {
    function s($, _) {
      var _e = $ == null ? null : typeof Symbol < "u" && $[Symbol.iterator] || $["@@iterator"];
      if (_e != null) {
        var tt, nt, at, ot, rt = [], st = !0, lt = !1;
        try {
          if (at = (_e = _e.call($)).next, _ === 0) {
            if (Object(_e) !== _e)
              return;
            st = !1;
          } else
            for (; !(st = (tt = at.call(_e)).done) && (rt.push(tt.value), rt.length !== _); st = !0)
              ;
        } catch (et) {
          lt = !0, nt = et;
        } finally {
          try {
            if (!st && _e.return != null && (ot = _e.return(), Object(ot) !== ot))
              return;
          } finally {
            if (lt)
              throw nt;
          }
        }
        return rt;
      }
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(iterableToArrayLimit)), iterableToArrayLimit.exports;
}
var unsupportedIterableToArray = { exports: {} }, arrayLikeToArray = { exports: {} }, hasRequiredArrayLikeToArray;
function requireArrayLikeToArray() {
  return hasRequiredArrayLikeToArray || (hasRequiredArrayLikeToArray = 1, function(a) {
    function s($, _) {
      (_ == null || _ > $.length) && (_ = $.length);
      for (var _e = 0, tt = new Array(_); _e < _; _e++)
        tt[_e] = $[_e];
      return tt;
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(arrayLikeToArray)), arrayLikeToArray.exports;
}
var hasRequiredUnsupportedIterableToArray;
function requireUnsupportedIterableToArray() {
  return hasRequiredUnsupportedIterableToArray || (hasRequiredUnsupportedIterableToArray = 1, function(a) {
    var s = requireArrayLikeToArray();
    function $(_, _e) {
      if (_) {
        if (typeof _ == "string")
          return s(_, _e);
        var tt = Object.prototype.toString.call(_).slice(8, -1);
        if (tt === "Object" && _.constructor && (tt = _.constructor.name), tt === "Map" || tt === "Set")
          return Array.from(_);
        if (tt === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(tt))
          return s(_, _e);
      }
    }
    a.exports = $, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(unsupportedIterableToArray)), unsupportedIterableToArray.exports;
}
var nonIterableRest = { exports: {} }, hasRequiredNonIterableRest;
function requireNonIterableRest() {
  return hasRequiredNonIterableRest || (hasRequiredNonIterableRest = 1, function(a) {
    function s() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(nonIterableRest)), nonIterableRest.exports;
}
var hasRequiredSlicedToArray;
function requireSlicedToArray() {
  return hasRequiredSlicedToArray || (hasRequiredSlicedToArray = 1, function(a) {
    var s = requireArrayWithHoles(), $ = requireIterableToArrayLimit(), _ = requireUnsupportedIterableToArray(), _e = requireNonIterableRest();
    function tt(nt, at) {
      return s(nt) || $(nt, at) || _(nt, at) || _e();
    }
    a.exports = tt, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(slicedToArray)), slicedToArray.exports;
}
var objectWithoutProperties = { exports: {} }, objectWithoutPropertiesLoose = { exports: {} }, hasRequiredObjectWithoutPropertiesLoose;
function requireObjectWithoutPropertiesLoose() {
  return hasRequiredObjectWithoutPropertiesLoose || (hasRequiredObjectWithoutPropertiesLoose = 1, function(a) {
    function s($, _) {
      if ($ == null)
        return {};
      var _e = {}, tt = Object.keys($), nt, at;
      for (at = 0; at < tt.length; at++)
        nt = tt[at], !(_.indexOf(nt) >= 0) && (_e[nt] = $[nt]);
      return _e;
    }
    a.exports = s, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(objectWithoutPropertiesLoose)), objectWithoutPropertiesLoose.exports;
}
var hasRequiredObjectWithoutProperties;
function requireObjectWithoutProperties() {
  return hasRequiredObjectWithoutProperties || (hasRequiredObjectWithoutProperties = 1, function(a) {
    var s = requireObjectWithoutPropertiesLoose();
    function $(_, _e) {
      if (_ == null)
        return {};
      var tt = s(_, _e), nt, at;
      if (Object.getOwnPropertySymbols) {
        var ot = Object.getOwnPropertySymbols(_);
        for (at = 0; at < ot.length; at++)
          nt = ot[at], !(_e.indexOf(nt) >= 0) && Object.prototype.propertyIsEnumerable.call(_, nt) && (tt[nt] = _[nt]);
      }
      return tt;
    }
    a.exports = $, a.exports.__esModule = !0, a.exports.default = a.exports;
  }(objectWithoutProperties)), objectWithoutProperties.exports;
}
var Context = {}, hasRequiredContext;
function requireContext() {
  if (hasRequiredContext)
    return Context;
  hasRequiredContext = 1, Object.defineProperty(Context, "__esModule", {
    value: !0
  }), Context.default = void 0;
  var a = reactExports, s = /* @__PURE__ */ (0, a.createContext)({}), $ = s;
  return Context.default = $, Context;
}
var IconBase = {}, utils = {}, hueStep = 2, saturationStep = 0.16, saturationStep2 = 0.05, brightnessStep1 = 0.05, brightnessStep2 = 0.15, lightColorCount = 5, darkColorCount = 4, darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function toHsv(a) {
  var s = a.r, $ = a.g, _ = a.b, _e = rgbToHsv(s, $, _);
  return {
    h: _e.h * 360,
    s: _e.s,
    v: _e.v
  };
}
function toHex(a) {
  var s = a.r, $ = a.g, _ = a.b;
  return "#".concat(rgbToHex(s, $, _, !1));
}
function mix(a, s, $) {
  var _ = $ / 100, _e = {
    r: (s.r - a.r) * _ + a.r,
    g: (s.g - a.g) * _ + a.g,
    b: (s.b - a.b) * _ + a.b
  };
  return _e;
}
function getHue(a, s, $) {
  var _;
  return Math.round(a.h) >= 60 && Math.round(a.h) <= 240 ? _ = $ ? Math.round(a.h) - hueStep * s : Math.round(a.h) + hueStep * s : _ = $ ? Math.round(a.h) + hueStep * s : Math.round(a.h) - hueStep * s, _ < 0 ? _ += 360 : _ >= 360 && (_ -= 360), _;
}
function getSaturation(a, s, $) {
  if (a.h === 0 && a.s === 0)
    return a.s;
  var _;
  return $ ? _ = a.s - saturationStep * s : s === darkColorCount ? _ = a.s + saturationStep : _ = a.s + saturationStep2 * s, _ > 1 && (_ = 1), $ && s === lightColorCount && _ > 0.1 && (_ = 0.1), _ < 0.06 && (_ = 0.06), Number(_.toFixed(2));
}
function getValue(a, s, $) {
  var _;
  return $ ? _ = a.v + brightnessStep1 * s : _ = a.v - brightnessStep2 * s, _ > 1 && (_ = 1), Number(_.toFixed(2));
}
function generate(a) {
  for (var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, $ = [], _ = inputToRGB(a), _e = lightColorCount; _e > 0; _e -= 1) {
    var tt = toHsv(_), nt = toHex(inputToRGB({
      h: getHue(tt, _e, !0),
      s: getSaturation(tt, _e, !0),
      v: getValue(tt, _e, !0)
    }));
    $.push(nt);
  }
  $.push(toHex(_));
  for (var at = 1; at <= darkColorCount; at += 1) {
    var ot = toHsv(_), rt = toHex(inputToRGB({
      h: getHue(ot, at),
      s: getSaturation(ot, at),
      v: getValue(ot, at)
    }));
    $.push(rt);
  }
  return s.theme === "dark" ? darkColorMap.map(function(st) {
    var lt = st.index, et = st.opacity, it = toHex(mix(inputToRGB(s.backgroundColor || "#141414"), inputToRGB($[lt]), et * 100));
    return it;
  }) : $;
}
var presetPrimaryColors = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1890FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, presetPalettes = {}, presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function(a) {
  presetPalettes[a] = generate(presetPrimaryColors[a]), presetPalettes[a].primary = presetPalettes[a][5], presetDarkPalettes[a] = generate(presetPrimaryColors[a], {
    theme: "dark",
    backgroundColor: "#141414"
  }), presetDarkPalettes[a].primary = presetDarkPalettes[a][5];
});
var red = presetPalettes.red, volcano = presetPalettes.volcano, gold = presetPalettes.gold, orange = presetPalettes.orange, yellow = presetPalettes.yellow, lime = presetPalettes.lime, green = presetPalettes.green, cyan = presetPalettes.cyan, blue = presetPalettes.blue, geekblue = presetPalettes.geekblue, purple = presetPalettes.purple, magenta = presetPalettes.magenta, grey = presetPalettes.grey;
const index_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  blue,
  cyan,
  geekblue,
  generate,
  gold,
  green,
  grey,
  lime,
  magenta,
  orange,
  presetDarkPalettes,
  presetPalettes,
  presetPrimaryColors,
  purple,
  red,
  volcano,
  yellow
}, Symbol.toStringTag, { value: "Module" })), require$$3 = /* @__PURE__ */ getAugmentedNamespace(index_esm);
var warning = {}, hasRequiredWarning;
function requireWarning() {
  if (hasRequiredWarning)
    return warning;
  hasRequiredWarning = 1, Object.defineProperty(warning, "__esModule", {
    value: !0
  }), warning.call = tt, warning.default = void 0, warning.note = _, warning.noteOnce = at, warning.preMessage = void 0, warning.resetWarned = _e, warning.warning = $, warning.warningOnce = nt;
  var a = {}, s = warning.preMessage = function(rt) {
  };
  function $(ot, rt) {
  }
  function _(ot, rt) {
  }
  function _e() {
    a = {};
  }
  function tt(ot, rt, st) {
    !rt && !a[st] && (ot(!1, st), a[st] = !0);
  }
  function nt(ot, rt) {
    tt($, ot, rt);
  }
  function at(ot, rt) {
    tt(_, ot, rt);
  }
  return nt.preMessage = s, nt.resetWarned = _e, nt.noteOnce = at, warning.default = nt, warning;
}
var dynamicCSS = {}, canUseDom = {}, hasRequiredCanUseDom;
function requireCanUseDom() {
  if (hasRequiredCanUseDom)
    return canUseDom;
  hasRequiredCanUseDom = 1, Object.defineProperty(canUseDom, "__esModule", {
    value: !0
  }), canUseDom.default = a;
  function a() {
    return !!(typeof window < "u" && window.document && window.document.createElement);
  }
  return canUseDom;
}
var contains = {}, hasRequiredContains;
function requireContains() {
  if (hasRequiredContains)
    return contains;
  hasRequiredContains = 1, Object.defineProperty(contains, "__esModule", {
    value: !0
  }), contains.default = a;
  function a(s, $) {
    if (!s)
      return !1;
    if (s.contains)
      return s.contains($);
    for (var _ = $; _; ) {
      if (_ === s)
        return !0;
      _ = _.parentNode;
    }
    return !1;
  }
  return contains;
}
var hasRequiredDynamicCSS;
function requireDynamicCSS() {
  if (hasRequiredDynamicCSS)
    return dynamicCSS;
  hasRequiredDynamicCSS = 1;
  var a = interopRequireDefaultExports.default;
  Object.defineProperty(dynamicCSS, "__esModule", {
    value: !0
  }), dynamicCSS.clearContainerCache = ft, dynamicCSS.injectCSS = lt, dynamicCSS.removeCSS = it, dynamicCSS.updateCSS = ht;
  var s = a(requireCanUseDom()), $ = a(requireContains()), _ = "data-rc-order", _e = "data-rc-priority", tt = "rc-util-key", nt = /* @__PURE__ */ new Map();
  function at() {
    var dt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, gt = dt.mark;
    return gt ? gt.startsWith("data-") ? gt : "data-".concat(gt) : tt;
  }
  function ot(dt) {
    if (dt.attachTo)
      return dt.attachTo;
    var gt = document.querySelector("head");
    return gt || document.body;
  }
  function rt(dt) {
    return dt === "queue" ? "prependQueue" : dt ? "prepend" : "append";
  }
  function st(dt) {
    return Array.from((nt.get(dt) || dt).children).filter(function(gt) {
      return gt.tagName === "STYLE";
    });
  }
  function lt(dt) {
    var gt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!(0, s.default)())
      return null;
    var pt = gt.csp, mt = gt.prepend, ct = gt.priority, vt = ct === void 0 ? 0 : ct, At = rt(mt), xt = At === "prependQueue", bt = document.createElement("style");
    bt.setAttribute(_, At), xt && vt && bt.setAttribute(_e, "".concat(vt)), pt != null && pt.nonce && (bt.nonce = pt == null ? void 0 : pt.nonce), bt.innerHTML = dt;
    var Et = ot(gt), St = Et.firstChild;
    if (mt) {
      if (xt) {
        var Bt = st(Et).filter(function(Ot) {
          if (!["prepend", "prependQueue"].includes(Ot.getAttribute(_)))
            return !1;
          var Pt = Number(Ot.getAttribute(_e) || 0);
          return vt >= Pt;
        });
        if (Bt.length)
          return Et.insertBefore(bt, Bt[Bt.length - 1].nextSibling), bt;
      }
      Et.insertBefore(bt, St);
    } else
      Et.appendChild(bt);
    return bt;
  }
  function et(dt) {
    var gt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pt = ot(gt);
    return st(pt).find(function(mt) {
      return mt.getAttribute(at(gt)) === dt;
    });
  }
  function it(dt) {
    var gt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pt = et(dt, gt);
    if (pt) {
      var mt = ot(gt);
      mt.removeChild(pt);
    }
  }
  function ut(dt, gt) {
    var pt = nt.get(dt);
    if (!pt || !(0, $.default)(document, pt)) {
      var mt = lt("", gt), ct = mt.parentNode;
      nt.set(dt, ct), dt.removeChild(mt);
    }
  }
  function ft() {
    nt.clear();
  }
  function ht(dt, gt) {
    var pt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, mt = ot(pt);
    ut(mt, pt);
    var ct = et(gt, pt);
    if (ct) {
      var vt, At;
      if ((vt = pt.csp) !== null && vt !== void 0 && vt.nonce && ct.nonce !== ((At = pt.csp) === null || At === void 0 ? void 0 : At.nonce)) {
        var xt;
        ct.nonce = (xt = pt.csp) === null || xt === void 0 ? void 0 : xt.nonce;
      }
      return ct.innerHTML !== dt && (ct.innerHTML = dt), ct;
    }
    var bt = lt(dt, pt);
    return bt.setAttribute(at(pt), gt), bt;
  }
  return dynamicCSS;
}
var _arrayMap, hasRequired_arrayMap;
function require_arrayMap() {
  if (hasRequired_arrayMap)
    return _arrayMap;
  hasRequired_arrayMap = 1;
  function a(s, $) {
    for (var _ = -1, _e = s == null ? 0 : s.length, tt = Array(_e); ++_ < _e; )
      tt[_] = $(s[_], _, s);
    return tt;
  }
  return _arrayMap = a, _arrayMap;
}
var _baseToString, hasRequired_baseToString;
function require_baseToString() {
  if (hasRequired_baseToString)
    return _baseToString;
  hasRequired_baseToString = 1;
  var a = _Symbol, s = require_arrayMap(), $ = isArray_1, _ = isSymbol_1, _e = 1 / 0, tt = a ? a.prototype : void 0, nt = tt ? tt.toString : void 0;
  function at(ot) {
    if (typeof ot == "string")
      return ot;
    if ($(ot))
      return s(ot, at) + "";
    if (_(ot))
      return nt ? nt.call(ot) : "";
    var rt = ot + "";
    return rt == "0" && 1 / ot == -_e ? "-0" : rt;
  }
  return _baseToString = at, _baseToString;
}
var toString_1, hasRequiredToString;
function requireToString() {
  if (hasRequiredToString)
    return toString_1;
  hasRequiredToString = 1;
  var a = require_baseToString();
  function s($) {
    return $ == null ? "" : a($);
  }
  return toString_1 = s, toString_1;
}
var _baseSlice, hasRequired_baseSlice;
function require_baseSlice() {
  if (hasRequired_baseSlice)
    return _baseSlice;
  hasRequired_baseSlice = 1;
  function a(s, $, _) {
    var _e = -1, tt = s.length;
    $ < 0 && ($ = -$ > tt ? 0 : tt + $), _ = _ > tt ? tt : _, _ < 0 && (_ += tt), tt = $ > _ ? 0 : _ - $ >>> 0, $ >>>= 0;
    for (var nt = Array(tt); ++_e < tt; )
      nt[_e] = s[_e + $];
    return nt;
  }
  return _baseSlice = a, _baseSlice;
}
var _castSlice, hasRequired_castSlice;
function require_castSlice() {
  if (hasRequired_castSlice)
    return _castSlice;
  hasRequired_castSlice = 1;
  var a = require_baseSlice();
  function s($, _, _e) {
    var tt = $.length;
    return _e = _e === void 0 ? tt : _e, !_ && _e >= tt ? $ : a($, _, _e);
  }
  return _castSlice = s, _castSlice;
}
var _hasUnicode, hasRequired_hasUnicode;
function require_hasUnicode() {
  if (hasRequired_hasUnicode)
    return _hasUnicode;
  hasRequired_hasUnicode = 1;
  var a = "\\ud800-\\udfff", s = "\\u0300-\\u036f", $ = "\\ufe20-\\ufe2f", _ = "\\u20d0-\\u20ff", _e = s + $ + _, tt = "\\ufe0e\\ufe0f", nt = "\\u200d", at = RegExp("[" + nt + a + _e + tt + "]");
  function ot(rt) {
    return at.test(rt);
  }
  return _hasUnicode = ot, _hasUnicode;
}
var _asciiToArray, hasRequired_asciiToArray;
function require_asciiToArray() {
  if (hasRequired_asciiToArray)
    return _asciiToArray;
  hasRequired_asciiToArray = 1;
  function a(s) {
    return s.split("");
  }
  return _asciiToArray = a, _asciiToArray;
}
var _unicodeToArray, hasRequired_unicodeToArray;
function require_unicodeToArray() {
  if (hasRequired_unicodeToArray)
    return _unicodeToArray;
  hasRequired_unicodeToArray = 1;
  var a = "\\ud800-\\udfff", s = "\\u0300-\\u036f", $ = "\\ufe20-\\ufe2f", _ = "\\u20d0-\\u20ff", _e = s + $ + _, tt = "\\ufe0e\\ufe0f", nt = "[" + a + "]", at = "[" + _e + "]", ot = "\\ud83c[\\udffb-\\udfff]", rt = "(?:" + at + "|" + ot + ")", st = "[^" + a + "]", lt = "(?:\\ud83c[\\udde6-\\uddff]){2}", et = "[\\ud800-\\udbff][\\udc00-\\udfff]", it = "\\u200d", ut = rt + "?", ft = "[" + tt + "]?", ht = "(?:" + it + "(?:" + [st, lt, et].join("|") + ")" + ft + ut + ")*", dt = ft + ut + ht, gt = "(?:" + [st + at + "?", at, lt, et, nt].join("|") + ")", pt = RegExp(ot + "(?=" + ot + ")|" + gt + dt, "g");
  function mt(ct) {
    return ct.match(pt) || [];
  }
  return _unicodeToArray = mt, _unicodeToArray;
}
var _stringToArray, hasRequired_stringToArray;
function require_stringToArray() {
  if (hasRequired_stringToArray)
    return _stringToArray;
  hasRequired_stringToArray = 1;
  var a = require_asciiToArray(), s = require_hasUnicode(), $ = require_unicodeToArray();
  function _(_e) {
    return s(_e) ? $(_e) : a(_e);
  }
  return _stringToArray = _, _stringToArray;
}
var _createCaseFirst, hasRequired_createCaseFirst;
function require_createCaseFirst() {
  if (hasRequired_createCaseFirst)
    return _createCaseFirst;
  hasRequired_createCaseFirst = 1;
  var a = require_castSlice(), s = require_hasUnicode(), $ = require_stringToArray(), _ = requireToString();
  function _e(tt) {
    return function(nt) {
      nt = _(nt);
      var at = s(nt) ? $(nt) : void 0, ot = at ? at[0] : nt.charAt(0), rt = at ? a(at, 1).join("") : nt.slice(1);
      return ot[tt]() + rt;
    };
  }
  return _createCaseFirst = _e, _createCaseFirst;
}
var upperFirst_1, hasRequiredUpperFirst;
function requireUpperFirst() {
  if (hasRequiredUpperFirst)
    return upperFirst_1;
  hasRequiredUpperFirst = 1;
  var a = require_createCaseFirst(), s = a("toUpperCase");
  return upperFirst_1 = s, upperFirst_1;
}
var capitalize_1, hasRequiredCapitalize;
function requireCapitalize() {
  if (hasRequiredCapitalize)
    return capitalize_1;
  hasRequiredCapitalize = 1;
  var a = requireToString(), s = requireUpperFirst();
  function $(_) {
    return s(a(_).toLowerCase());
  }
  return capitalize_1 = $, capitalize_1;
}
var _arrayReduce, hasRequired_arrayReduce;
function require_arrayReduce() {
  if (hasRequired_arrayReduce)
    return _arrayReduce;
  hasRequired_arrayReduce = 1;
  function a(s, $, _, _e) {
    var tt = -1, nt = s == null ? 0 : s.length;
    for (_e && nt && (_ = s[++tt]); ++tt < nt; )
      _ = $(_, s[tt], tt, s);
    return _;
  }
  return _arrayReduce = a, _arrayReduce;
}
var _basePropertyOf, hasRequired_basePropertyOf;
function require_basePropertyOf() {
  if (hasRequired_basePropertyOf)
    return _basePropertyOf;
  hasRequired_basePropertyOf = 1;
  function a(s) {
    return function($) {
      return s == null ? void 0 : s[$];
    };
  }
  return _basePropertyOf = a, _basePropertyOf;
}
var _deburrLetter, hasRequired_deburrLetter;
function require_deburrLetter() {
  if (hasRequired_deburrLetter)
    return _deburrLetter;
  hasRequired_deburrLetter = 1;
  var a = require_basePropertyOf(), s = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, $ = a(s);
  return _deburrLetter = $, _deburrLetter;
}
var deburr_1, hasRequiredDeburr;
function requireDeburr() {
  if (hasRequiredDeburr)
    return deburr_1;
  hasRequiredDeburr = 1;
  var a = require_deburrLetter(), s = requireToString(), $ = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, _ = "\\u0300-\\u036f", _e = "\\ufe20-\\ufe2f", tt = "\\u20d0-\\u20ff", nt = _ + _e + tt, at = "[" + nt + "]", ot = RegExp(at, "g");
  function rt(st) {
    return st = s(st), st && st.replace($, a).replace(ot, "");
  }
  return deburr_1 = rt, deburr_1;
}
var _asciiWords, hasRequired_asciiWords;
function require_asciiWords() {
  if (hasRequired_asciiWords)
    return _asciiWords;
  hasRequired_asciiWords = 1;
  var a = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function s($) {
    return $.match(a) || [];
  }
  return _asciiWords = s, _asciiWords;
}
var _hasUnicodeWord, hasRequired_hasUnicodeWord;
function require_hasUnicodeWord() {
  if (hasRequired_hasUnicodeWord)
    return _hasUnicodeWord;
  hasRequired_hasUnicodeWord = 1;
  var a = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function s($) {
    return a.test($);
  }
  return _hasUnicodeWord = s, _hasUnicodeWord;
}
var _unicodeWords, hasRequired_unicodeWords;
function require_unicodeWords() {
  if (hasRequired_unicodeWords)
    return _unicodeWords;
  hasRequired_unicodeWords = 1;
  var a = "\\ud800-\\udfff", s = "\\u0300-\\u036f", $ = "\\ufe20-\\ufe2f", _ = "\\u20d0-\\u20ff", _e = s + $ + _, tt = "\\u2700-\\u27bf", nt = "a-z\\xdf-\\xf6\\xf8-\\xff", at = "\\xac\\xb1\\xd7\\xf7", ot = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rt = "\\u2000-\\u206f", st = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", lt = "A-Z\\xc0-\\xd6\\xd8-\\xde", et = "\\ufe0e\\ufe0f", it = at + ot + rt + st, ut = "['’]", ft = "[" + it + "]", ht = "[" + _e + "]", dt = "\\d+", gt = "[" + tt + "]", pt = "[" + nt + "]", mt = "[^" + a + it + dt + tt + nt + lt + "]", ct = "\\ud83c[\\udffb-\\udfff]", vt = "(?:" + ht + "|" + ct + ")", At = "[^" + a + "]", xt = "(?:\\ud83c[\\udde6-\\uddff]){2}", bt = "[\\ud800-\\udbff][\\udc00-\\udfff]", Et = "[" + lt + "]", St = "\\u200d", Bt = "(?:" + pt + "|" + mt + ")", Ot = "(?:" + Et + "|" + mt + ")", Pt = "(?:" + ut + "(?:d|ll|m|re|s|t|ve))?", wt = "(?:" + ut + "(?:D|LL|M|RE|S|T|VE))?", Ct = vt + "?", It = "[" + et + "]?", yt = "(?:" + St + "(?:" + [At, xt, bt].join("|") + ")" + It + Ct + ")*", Rt = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", kt = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", jt = It + Ct + yt, Ht = "(?:" + [gt, xt, bt].join("|") + ")" + jt, Ft = RegExp([
    Et + "?" + pt + "+" + Pt + "(?=" + [ft, Et, "$"].join("|") + ")",
    Ot + "+" + wt + "(?=" + [ft, Et + Bt, "$"].join("|") + ")",
    Et + "?" + Bt + "+" + Pt,
    Et + "+" + wt,
    kt,
    Rt,
    dt,
    Ht
  ].join("|"), "g");
  function _t(Nt) {
    return Nt.match(Ft) || [];
  }
  return _unicodeWords = _t, _unicodeWords;
}
var words_1, hasRequiredWords;
function requireWords() {
  if (hasRequiredWords)
    return words_1;
  hasRequiredWords = 1;
  var a = require_asciiWords(), s = require_hasUnicodeWord(), $ = requireToString(), _ = require_unicodeWords();
  function _e(tt, nt, at) {
    return tt = $(tt), nt = at ? void 0 : nt, nt === void 0 ? s(tt) ? _(tt) : a(tt) : tt.match(nt) || [];
  }
  return words_1 = _e, words_1;
}
var _createCompounder, hasRequired_createCompounder;
function require_createCompounder() {
  if (hasRequired_createCompounder)
    return _createCompounder;
  hasRequired_createCompounder = 1;
  var a = require_arrayReduce(), s = requireDeburr(), $ = requireWords(), _ = "['’]", _e = RegExp(_, "g");
  function tt(nt) {
    return function(at) {
      return a($(s(at).replace(_e, "")), nt, "");
    };
  }
  return _createCompounder = tt, _createCompounder;
}
var camelCase_1, hasRequiredCamelCase;
function requireCamelCase() {
  if (hasRequiredCamelCase)
    return camelCase_1;
  hasRequiredCamelCase = 1;
  var a = requireCapitalize(), s = require_createCompounder(), $ = s(function(_, _e, tt) {
    return _e = _e.toLowerCase(), _ + (tt ? a(_e) : _e);
  });
  return camelCase_1 = $, camelCase_1;
}
var hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils)
    return utils;
  hasRequiredUtils = 1;
  var a = interopRequireDefaultExports, s = _typeofExports;
  Object.defineProperty(utils, "__esModule", {
    value: !0
  }), utils.generate = ft, utils.getSecondaryColor = ht, utils.iconStyles = void 0, utils.isIconDefinition = it, utils.normalizeAttrs = ut, utils.normalizeTwoToneColors = dt, utils.useInsertStyles = utils.svgBaseProps = void 0, utils.warning = et;
  var $ = a(requireObjectSpread2()), _ = a(_typeofExports), _e = require$$3, tt = lt(reactExports), nt = a(requireWarning()), at = requireDynamicCSS(), ot = a(requireContext()), rt = a(requireCamelCase());
  function st(ct) {
    if (typeof WeakMap != "function")
      return null;
    var vt = /* @__PURE__ */ new WeakMap(), At = /* @__PURE__ */ new WeakMap();
    return (st = function(bt) {
      return bt ? At : vt;
    })(ct);
  }
  function lt(ct, vt) {
    if (!vt && ct && ct.__esModule)
      return ct;
    if (ct === null || s(ct) !== "object" && typeof ct != "function")
      return { default: ct };
    var At = st(vt);
    if (At && At.has(ct))
      return At.get(ct);
    var xt = {}, bt = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var Et in ct)
      if (Et !== "default" && Object.prototype.hasOwnProperty.call(ct, Et)) {
        var St = bt ? Object.getOwnPropertyDescriptor(ct, Et) : null;
        St && (St.get || St.set) ? Object.defineProperty(xt, Et, St) : xt[Et] = ct[Et];
      }
    return xt.default = ct, At && At.set(ct, xt), xt;
  }
  function et(ct, vt) {
    (0, nt.default)(ct, "[@ant-design/icons] ".concat(vt));
  }
  function it(ct) {
    return (0, _.default)(ct) === "object" && typeof ct.name == "string" && typeof ct.theme == "string" && ((0, _.default)(ct.icon) === "object" || typeof ct.icon == "function");
  }
  function ut() {
    var ct = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Object.keys(ct).reduce(function(vt, At) {
      var xt = ct[At];
      switch (At) {
        case "class":
          vt.className = xt, delete vt.class;
          break;
        default:
          delete vt[At], vt[(0, rt.default)(At)] = xt;
      }
      return vt;
    }, {});
  }
  function ft(ct, vt, At) {
    return At ? /* @__PURE__ */ tt.default.createElement(ct.tag, (0, $.default)((0, $.default)({
      key: vt
    }, ut(ct.attrs)), At), (ct.children || []).map(function(xt, bt) {
      return ft(xt, "".concat(vt, "-").concat(ct.tag, "-").concat(bt));
    })) : /* @__PURE__ */ tt.default.createElement(ct.tag, (0, $.default)({
      key: vt
    }, ut(ct.attrs)), (ct.children || []).map(function(xt, bt) {
      return ft(xt, "".concat(vt, "-").concat(ct.tag, "-").concat(bt));
    }));
  }
  function ht(ct) {
    return (0, _e.generate)(ct)[0];
  }
  function dt(ct) {
    return ct ? Array.isArray(ct) ? ct : [ct] : [];
  }
  var gt = {
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
  };
  utils.svgBaseProps = gt;
  var pt = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
  utils.iconStyles = pt;
  var mt = function() {
    var vt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : pt, At = (0, tt.useContext)(ot.default), xt = At.csp;
    (0, tt.useEffect)(function() {
      (0, at.updateCSS)(vt, "@ant-design-icons", {
        prepend: !0,
        csp: xt
      });
    }, []);
  };
  return utils.useInsertStyles = mt, utils;
}
var hasRequiredIconBase;
function requireIconBase() {
  if (hasRequiredIconBase)
    return IconBase;
  hasRequiredIconBase = 1;
  var a = interopRequireDefaultExports;
  Object.defineProperty(IconBase, "__esModule", {
    value: !0
  }), IconBase.default = void 0;
  var s = a(requireObjectWithoutProperties()), $ = a(requireObjectSpread2()), _ = requireUtils(), _e = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], tt = {
    primaryColor: "#333",
    secondaryColor: "#E6E6E6",
    calculated: !1
  };
  function nt(st) {
    var lt = st.primaryColor, et = st.secondaryColor;
    tt.primaryColor = lt, tt.secondaryColor = et || (0, _.getSecondaryColor)(lt), tt.calculated = !!et;
  }
  function at() {
    return (0, $.default)({}, tt);
  }
  var ot = function(lt) {
    var et = lt.icon, it = lt.className, ut = lt.onClick, ft = lt.style, ht = lt.primaryColor, dt = lt.secondaryColor, gt = (0, s.default)(lt, _e), pt = tt;
    if (ht && (pt = {
      primaryColor: ht,
      secondaryColor: dt || (0, _.getSecondaryColor)(ht)
    }), (0, _.useInsertStyles)(), (0, _.warning)((0, _.isIconDefinition)(et), "icon should be icon definiton, but got ".concat(et)), !(0, _.isIconDefinition)(et))
      return null;
    var mt = et;
    return mt && typeof mt.icon == "function" && (mt = (0, $.default)((0, $.default)({}, mt), {}, {
      icon: mt.icon(pt.primaryColor, pt.secondaryColor)
    })), (0, _.generate)(mt.icon, "svg-".concat(mt.name), (0, $.default)({
      className: it,
      onClick: ut,
      style: ft,
      "data-icon": mt.name,
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true"
    }, gt));
  };
  ot.displayName = "IconReact", ot.getTwoToneColors = at, ot.setTwoToneColors = nt;
  var rt = ot;
  return IconBase.default = rt, IconBase;
}
var twoTonePrimaryColor = {}, hasRequiredTwoTonePrimaryColor;
function requireTwoTonePrimaryColor() {
  if (hasRequiredTwoTonePrimaryColor)
    return twoTonePrimaryColor;
  hasRequiredTwoTonePrimaryColor = 1;
  var a = interopRequireDefaultExports;
  Object.defineProperty(twoTonePrimaryColor, "__esModule", {
    value: !0
  }), twoTonePrimaryColor.getTwoToneColor = tt, twoTonePrimaryColor.setTwoToneColor = _e;
  var s = a(requireSlicedToArray()), $ = a(requireIconBase()), _ = requireUtils();
  function _e(nt) {
    var at = (0, _.normalizeTwoToneColors)(nt), ot = (0, s.default)(at, 2), rt = ot[0], st = ot[1];
    return $.default.setTwoToneColors({
      primaryColor: rt,
      secondaryColor: st
    });
  }
  function tt() {
    var nt = $.default.getTwoToneColors();
    return nt.calculated ? [nt.primaryColor, nt.secondaryColor] : nt.primaryColor;
  }
  return twoTonePrimaryColor;
}
var hasRequiredAntdIcon;
function requireAntdIcon() {
  if (hasRequiredAntdIcon)
    return AntdIcon;
  hasRequiredAntdIcon = 1;
  var a = interopRequireDefaultExports, s = _typeofExports;
  Object.defineProperty(AntdIcon, "__esModule", {
    value: !0
  }), AntdIcon.default = void 0;
  var $ = a(requireObjectSpread2()), _ = a(requireSlicedToArray()), _e = a(requireDefineProperty()), tt = a(requireObjectWithoutProperties()), nt = ut(reactExports), at = a(classnamesExports), ot = a(requireContext()), rt = a(requireIconBase()), st = requireTwoTonePrimaryColor(), lt = requireUtils(), et = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
  function it(dt) {
    if (typeof WeakMap != "function")
      return null;
    var gt = /* @__PURE__ */ new WeakMap(), pt = /* @__PURE__ */ new WeakMap();
    return (it = function(ct) {
      return ct ? pt : gt;
    })(dt);
  }
  function ut(dt, gt) {
    if (!gt && dt && dt.__esModule)
      return dt;
    if (dt === null || s(dt) !== "object" && typeof dt != "function")
      return { default: dt };
    var pt = it(gt);
    if (pt && pt.has(dt))
      return pt.get(dt);
    var mt = {}, ct = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var vt in dt)
      if (vt !== "default" && Object.prototype.hasOwnProperty.call(dt, vt)) {
        var At = ct ? Object.getOwnPropertyDescriptor(dt, vt) : null;
        At && (At.get || At.set) ? Object.defineProperty(mt, vt, At) : mt[vt] = dt[vt];
      }
    return mt.default = dt, pt && pt.set(dt, mt), mt;
  }
  (0, st.setTwoToneColor)("#1890ff");
  var ft = /* @__PURE__ */ nt.forwardRef(function(dt, gt) {
    var pt, mt = dt.className, ct = dt.icon, vt = dt.spin, At = dt.rotate, xt = dt.tabIndex, bt = dt.onClick, Et = dt.twoToneColor, St = (0, tt.default)(dt, et), Bt = nt.useContext(ot.default), Ot = Bt.prefixCls, Pt = Ot === void 0 ? "anticon" : Ot, wt = Bt.rootClassName, Ct = (0, at.default)(wt, Pt, (pt = {}, (0, _e.default)(pt, "".concat(Pt, "-").concat(ct.name), !!ct.name), (0, _e.default)(pt, "".concat(Pt, "-spin"), !!vt || ct.name === "loading"), pt), mt), It = xt;
    It === void 0 && bt && (It = -1);
    var yt = At ? {
      msTransform: "rotate(".concat(At, "deg)"),
      transform: "rotate(".concat(At, "deg)")
    } : void 0, Rt = (0, lt.normalizeTwoToneColors)(Et), kt = (0, _.default)(Rt, 2), jt = kt[0], Ht = kt[1];
    return /* @__PURE__ */ nt.createElement("span", (0, $.default)((0, $.default)({
      role: "img",
      "aria-label": ct.name
    }, St), {}, {
      ref: gt,
      tabIndex: It,
      onClick: bt,
      className: Ct
    }), /* @__PURE__ */ nt.createElement(rt.default, {
      icon: ct,
      primaryColor: jt,
      secondaryColor: Ht,
      style: yt
    }));
  });
  ft.displayName = "AntdIcon", ft.getTwoToneColor = st.getTwoToneColor, ft.setTwoToneColor = st.setTwoToneColor;
  var ht = ft;
  return AntdIcon.default = ht, AntdIcon;
}
var _interopRequireDefault$8 = interopRequireDefaultExports, _typeof$f = _typeofExports;
Object.defineProperty(PictureOutlined$2, "__esModule", {
  value: !0
});
var default_1$8 = PictureOutlined$2.default = void 0, _objectSpread2$8 = _interopRequireDefault$8(requireObjectSpread2()), React$8 = _interopRequireWildcard$8(reactExports), _PictureOutlined = _interopRequireDefault$8(requirePictureOutlined()), _AntdIcon$8 = _interopRequireDefault$8(requireAntdIcon());
function _getRequireWildcardCache$8(a) {
  if (typeof WeakMap != "function")
    return null;
  var s = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$8 = function(_e) {
    return _e ? $ : s;
  })(a);
}
function _interopRequireWildcard$8(a, s) {
  if (!s && a && a.__esModule)
    return a;
  if (a === null || _typeof$f(a) !== "object" && typeof a != "function")
    return { default: a };
  var $ = _getRequireWildcardCache$8(s);
  if ($ && $.has(a))
    return $.get(a);
  var _ = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var tt in a)
    if (tt !== "default" && Object.prototype.hasOwnProperty.call(a, tt)) {
      var nt = _e ? Object.getOwnPropertyDescriptor(a, tt) : null;
      nt && (nt.get || nt.set) ? Object.defineProperty(_, tt, nt) : _[tt] = a[tt];
    }
  return _.default = a, $ && $.set(a, _), _;
}
var PictureOutlined = function a(s, $) {
  return /* @__PURE__ */ React$8.createElement(_AntdIcon$8.default, (0, _objectSpread2$8.default)((0, _objectSpread2$8.default)({}, s), {}, {
    ref: $,
    icon: _PictureOutlined.default
  }));
};
PictureOutlined.displayName = "PictureOutlined";
var _default$8 = /* @__PURE__ */ React$8.forwardRef(PictureOutlined);
default_1$8 = PictureOutlined$2.default = _default$8;
var DEFAULT_IMG = "https://img.alicdn.com/tfs/TB14tSiKhTpK1RjSZFKXXa2wXXa-354-330.png", PreviewNode = function a(s) {
  var $ = s.value, _ = reactExports.useContext(ThemeConfigProvider.ConfigContext), _e = translation(_);
  return /* @__PURE__ */ React$a.createElement(_Popover, {
    content: /* @__PURE__ */ React$a.createElement("img", {
      src: $ || DEFAULT_IMG,
      alt: _e("img_src_error"),
      className: "fr-preview-image"
    }),
    className: "fr-preview",
    placement: "bottom"
  }, /* @__PURE__ */ React$a.createElement(default_1$8, null));
}, ImageInput = function a(s) {
  var $ = s.value, _ = __rest$3(s, ["value"]);
  return /* @__PURE__ */ React$a.createElement(_Input, Object.assign({
    value: $,
    addonAfter: /* @__PURE__ */ React$a.createElement(PreviewNode, {
      value: $
    })
  }, _));
};
const ImageInput$1 = withFieldWrap(ImageInput);
var UrlNode = function a(s) {
  var $ = reactExports.useContext(ThemeConfigProvider.ConfigContext), _ = translation($), _e = s.value, tt = s.addonText, nt = tt === void 0 ? _("test_src") : tt, at = isUrl(_e);
  return at ? /* @__PURE__ */ React$a.createElement("a", {
    target: "_blank",
    href: _e
  }, nt) : /* @__PURE__ */ React$a.createElement("div", null, nt);
}, UrlInput = function a(s) {
  var $ = s.value, _ = s.prefix, _e = s.suffix, tt = s.addonText, nt = s.onChange, at = __rest$3(s, ["value", "prefix", "suffix", "addonText", "onChange"]), ot = $ || "";
  _ && (ot = ot.replace(_, "")), _e && (ot = ot.replace(_e, ""));
  var rt = function(lt) {
    var et = lt.target.value;
    if (!et) {
      nt == null || nt(et);
      return;
    }
    _ && (et = _ + et), _e && (et = et + _e), nt == null || nt(et);
  };
  return /* @__PURE__ */ React$a.createElement(_Input, Object.assign({
    value: ot,
    prefix: _,
    suffix: _e,
    onChange: rt,
    addonAfter: /* @__PURE__ */ React$a.createElement(UrlNode, {
      value: $,
      addonText: tt
    })
  }, at));
};
const UrlInput$1 = withFieldWrap(UrlInput);
var SliderWithNumber = function a(s) {
  var $ = s.schema, _ = s.value, _e = s.onChange, tt = s.hideInput, nt = s.inputProps, at = s.style, ot = __rest$3(s, ["schema", "value", "onChange", "hideInput", "inputProps", "style"]), rt = $.max, st = $.min, lt = $.step, et = {};
  return (rt || rt === 0) && (et = {
    max: rt
  }), (st || st === 0) && (et = Object.assign(Object.assign({}, et), {
    min: st
  })), lt && (et = Object.assign(Object.assign({}, et), {
    step: lt
  })), /* @__PURE__ */ React$a.createElement("div", {
    className: "fr-slider",
    style: at
  }, /* @__PURE__ */ React$a.createElement(_Slider, Object.assign({
    style: {
      flexGrow: 1,
      marginRight: tt ? 0 : 12
    }
  }, et, {
    onChange: _e,
    value: typeof _ == "number" ? _ : st || 0
  }, ot)), tt ? null : /* @__PURE__ */ React$a.createElement(_InputNumber, Object.assign({}, et, nt, {
    style: {
      width: "90px"
    },
    value: _,
    onChange: _e
  })));
};
const Slider = withFieldWrap(SliderWithNumber, ["addons", "dependValues"]);
var UploadOutlined$2 = {}, UploadOutlined$1 = {}, hasRequiredUploadOutlined;
function requireUploadOutlined() {
  if (hasRequiredUploadOutlined)
    return UploadOutlined$1;
  hasRequiredUploadOutlined = 1, Object.defineProperty(UploadOutlined$1, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] }, name: "upload", theme: "outlined" };
  return UploadOutlined$1.default = a, UploadOutlined$1;
}
var _interopRequireDefault$7 = interopRequireDefaultExports, _typeof$e = _typeofExports;
Object.defineProperty(UploadOutlined$2, "__esModule", {
  value: !0
});
var default_1$7 = UploadOutlined$2.default = void 0, _objectSpread2$7 = _interopRequireDefault$7(requireObjectSpread2()), React$7 = _interopRequireWildcard$7(reactExports), _UploadOutlined = _interopRequireDefault$7(requireUploadOutlined()), _AntdIcon$7 = _interopRequireDefault$7(requireAntdIcon());
function _getRequireWildcardCache$7(a) {
  if (typeof WeakMap != "function")
    return null;
  var s = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$7 = function(_e) {
    return _e ? $ : s;
  })(a);
}
function _interopRequireWildcard$7(a, s) {
  if (!s && a && a.__esModule)
    return a;
  if (a === null || _typeof$e(a) !== "object" && typeof a != "function")
    return { default: a };
  var $ = _getRequireWildcardCache$7(s);
  if ($ && $.has(a))
    return $.get(a);
  var _ = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var tt in a)
    if (tt !== "default" && Object.prototype.hasOwnProperty.call(a, tt)) {
      var nt = _e ? Object.getOwnPropertyDescriptor(a, tt) : null;
      nt && (nt.get || nt.set) ? Object.defineProperty(_, tt, nt) : _[tt] = a[tt];
    }
  return _.default = a, $ && $.set(a, _), _;
}
var UploadOutlined = function a(s, $) {
  return /* @__PURE__ */ React$7.createElement(_AntdIcon$7.default, (0, _objectSpread2$7.default)((0, _objectSpread2$7.default)({}, s), {}, {
    ref: $,
    icon: _UploadOutlined.default
  }));
};
UploadOutlined.displayName = "UploadOutlined";
var _default$7 = /* @__PURE__ */ React$7.forwardRef(UploadOutlined);
default_1$7 = UploadOutlined$2.default = _default$7;
var FrUpload = function a(s) {
  var $ = s.action, _ = s.value, _e = s.onChange, tt = s.uploadProps, nt = s.buttonProps, at = s.schema, ot = reactExports.useContext(ThemeConfigProvider.ConfigContext), rt = translation(ot), st = Object.assign({
    name: "file",
    type: "file",
    action: $,
    onChange: function(ut) {
      if (ut.file.status === "done") {
        _message.success("".concat(ut.file.name, " ").concat(rt("upload_success")));
        var ft = get(at, "props.path", ""), ht = ft ? get(ut.file.response, ft) : ut.file.response.url;
        _e(ht);
      } else
        ut.file.status === "error" && _message.error("".concat(ut.file.name, " ").concat(rt("upload_fail")));
    },
    onRemove: function() {
      _e("");
    }
  }, tt), lt = {
    icon: /* @__PURE__ */ React$a.createElement(default_1$7, null),
    children: rt("upload")
  }, et = Object.assign(Object.assign({}, lt), nt);
  return /* @__PURE__ */ React$a.createElement("div", {
    className: "fr-upload-mod"
  }, /* @__PURE__ */ React$a.createElement(_Upload, Object.assign({}, st, {
    className: "fr-upload-file"
  }), /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({}, et))), _ && /* @__PURE__ */ React$a.createElement("a", {
    href: _,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "fr-upload-preview"
  }, rt("uploaded_address")));
};
function _typeof$d(a) {
  "@babel/helpers - typeof";
  return _typeof$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$d(a);
}
function html(a) {
  var s = a.value, $ = a.options, _ = a.schema, _e = _ === void 0 ? {} : _, tt = "-";
  if (_e.type === "boolean")
    tt = s === !0 ? "✔" : "✘";
  else if (($ == null ? void 0 : $.length) > 0) {
    if (["string", "number"].indexOf(_typeof$d(s)) > -1) {
      var nt = $.find(function(ot) {
        return ot.value === s;
      });
      tt = (nt == null ? void 0 : nt.label) || "-";
    } else if (Array.isArray(s)) {
      var at = "-";
      s.forEach(function(ot) {
        var rt = $.find(function(lt) {
          return lt.value === ot;
        }), st = rt.label;
        st && (at += "," + st);
      }), tt = at.replace("-,", "");
    }
  } else
    typeof s == "number" ? tt = String(s) : typeof s == "string" ? tt = s : _e.type === "range" && Array.isArray(s) && s[0] && s[1] ? tt = "".concat(s[0], " - ").concat(s[1]) : s && ["number", "string"].indexOf(_typeof$d(s)) === -1 && (tt = JSON.stringify(s));
  return _e.format === "image" ? /* @__PURE__ */ React$a.createElement(_Image, Object.assign({
    height: 56,
    src: s
  }, _e.imageProps)) : /* @__PURE__ */ React$a.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: tt
    }
  });
}
var PercentSlider = function a(s) {
  var $ = s.schema, _ = $.max, _e = $.min, tt = $.step, nt = {};
  (_ || _ === 0) && (nt = {
    max: _
  }), (_e || _e === 0) && (nt = Object.assign(Object.assign({}, nt), {
    min: _e
  })), tt && (nt = Object.assign(Object.assign({}, nt), {
    step: tt
  }));
  var at = !1;
  s.options && s.options.hideNumber && (at = !0);
  var ot = function(it) {
    return typeof it == "string" && it.endsWith("%");
  }, rt = 100;
  if (ot(s.value))
    try {
      rt = Number(s.value.split("%")[0]), Number.isNaN(rt) && (rt = 100);
    } catch {
    }
  var st = function(it) {
    var ut = it + "%";
    s.onChange(ut);
  }, lt = s.readonly ? /* @__PURE__ */ reactExports.createElement("span", {
    style: {
      width: "80px"
    }
  }, s.value === "" ? "-" : s.value + "%") : /* @__PURE__ */ reactExports.createElement(_InputNumber, Object.assign({}, s.options, nt, {
    style: {
      width: "80px"
    },
    value: rt,
    disabled: s.disabled,
    onChange: st,
    formatter: function(it) {
      return "".concat(it, "%");
    },
    parser: function(it) {
      return Number(it.replace("%", ""));
    }
  }));
  return /* @__PURE__ */ reactExports.createElement("div", {
    className: "fr-slider"
  }, /* @__PURE__ */ reactExports.createElement(_Slider, Object.assign({
    style: {
      flexGrow: 1,
      marginRight: at ? 0 : 12
    }
  }, nt, {
    onChange: st,
    max: 100,
    tooltip: {
      formatter: function(it) {
        return it + "%";
      }
    },
    value: rt || 100,
    disabled: s.disabled || s.readonly
  })), at ? null : lt);
}, PanelView = function a(s) {
  var $ = s.children, _ = s.bordered;
  return /* @__PURE__ */ React$a.createElement("div", {
    className: classnames("fr-panel", {
      "fr-panel-bordered": _
    })
  }, $);
}, BoxCard = function a(s) {
  var $ = s.children, _ = s.title, _e = s.description;
  return _ ? /* @__PURE__ */ React$a.createElement(_Card, {
    className: "fr-obj-card",
    title: /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, _, _e && /* @__PURE__ */ React$a.createElement("span", {
      className: "fr-header-desc "
    }, _e))
  }, $) : /* @__PURE__ */ React$a.createElement(PanelView, null, $);
}, DownOutlined$2 = {}, DownOutlined$1 = {}, hasRequiredDownOutlined;
function requireDownOutlined() {
  if (hasRequiredDownOutlined)
    return DownOutlined$1;
  hasRequiredDownOutlined = 1, Object.defineProperty(DownOutlined$1, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
  return DownOutlined$1.default = a, DownOutlined$1;
}
var _interopRequireDefault$6 = interopRequireDefaultExports, _typeof$c = _typeofExports;
Object.defineProperty(DownOutlined$2, "__esModule", {
  value: !0
});
var default_1$6 = DownOutlined$2.default = void 0, _objectSpread2$6 = _interopRequireDefault$6(requireObjectSpread2()), React$6 = _interopRequireWildcard$6(reactExports), _DownOutlined = _interopRequireDefault$6(requireDownOutlined()), _AntdIcon$6 = _interopRequireDefault$6(requireAntdIcon());
function _getRequireWildcardCache$6(a) {
  if (typeof WeakMap != "function")
    return null;
  var s = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$6 = function(_e) {
    return _e ? $ : s;
  })(a);
}
function _interopRequireWildcard$6(a, s) {
  if (!s && a && a.__esModule)
    return a;
  if (a === null || _typeof$c(a) !== "object" && typeof a != "function")
    return { default: a };
  var $ = _getRequireWildcardCache$6(s);
  if ($ && $.has(a))
    return $.get(a);
  var _ = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var tt in a)
    if (tt !== "default" && Object.prototype.hasOwnProperty.call(a, tt)) {
      var nt = _e ? Object.getOwnPropertyDescriptor(a, tt) : null;
      nt && (nt.get || nt.set) ? Object.defineProperty(_, tt, nt) : _[tt] = a[tt];
    }
  return _.default = a, $ && $.set(a, _), _;
}
var DownOutlined = function a(s, $) {
  return /* @__PURE__ */ React$6.createElement(_AntdIcon$6.default, (0, _objectSpread2$6.default)((0, _objectSpread2$6.default)({}, s), {}, {
    ref: $,
    icon: _DownOutlined.default
  }));
};
DownOutlined.displayName = "DownOutlined";
var _default$6 = /* @__PURE__ */ React$6.forwardRef(DownOutlined);
default_1$6 = DownOutlined$2.default = _default$6;
function _slicedToArray$8(a, s) {
  return _arrayWithHoles$8(a) || _iterableToArrayLimit$8(a, s) || _unsupportedIterableToArray$a(a, s) || _nonIterableRest$8();
}
function _nonIterableRest$8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$a(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$a(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$a(a, s);
  }
}
function _arrayLikeToArray$a(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$8(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$8(a) {
  if (Array.isArray(a))
    return a;
}
var Panel = Collapse$1.Panel, BoxCollapse = function a(s) {
  var $ = s.style, _ = s.children, _e = s.title, tt = s.description, nt = s.collapsed, at = nt === void 0 ? !0 : nt, ot = s.displayType, rt = s.bordered, st = rt === void 0 ? !1 : rt, lt = s.ghost, et = lt === void 0 ? !0 : lt;
  if (!_e)
    return /* @__PURE__ */ React$a.createElement(PanelView, {
      bordered: ot !== "inline"
    }, _);
  var it = reactExports.useState(at ? "single" : ""), ut = _slicedToArray$8(it, 2), ft = ut[0], ht = ut[1], dt = /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, _e && /* @__PURE__ */ React$a.createElement("div", {
    className: "collapse-title"
  }, _e), tt && /* @__PURE__ */ React$a.createElement("span", {
    className: "fr-header-desc "
  }, tt)), gt = function(mt) {
    var ct = mt.isActive;
    return /* @__PURE__ */ React$a.createElement("div", {
      className: "expand-icon-box"
    }, /* @__PURE__ */ React$a.createElement(default_1$6, {
      rotate: ct ? 0 : -90,
      style: {
        fontSize: "16px"
      }
    }));
  };
  return /* @__PURE__ */ React$a.createElement(Collapse$1, {
    className: "fr-obj-collapse",
    style: $,
    bordered: st,
    ghost: et,
    activeKey: [ft],
    expandIcon: gt,
    onChange: function() {
      return ht(ft ? "" : "single");
    }
  }, /* @__PURE__ */ React$a.createElement(Panel, {
    key: "single",
    header: dt,
    forceRender: !0
  }, _));
}, BoxSubInline = function a(s) {
  var $ = s.children, _ = s.title, _e = s.hasBackground, tt = _e === void 0 ? !0 : _e, nt = s.description, at = s.tooltip, ot = s.fieldCol, rt = s.labelCol, st = s.labelWidth;
  s.displayType;
  var lt = __rest$3(s, ["children", "title", "hasBackground", "description", "tooltip", "fieldCol", "labelCol", "labelWidth", "displayType"]), et = null, it = {
    span: 3
  }, ut = {
    flex: 1
  };
  return nt && (et = {
    title: nt
  }), at && (et = at), st && (it = {
    flex: st + "px"
  }), rt && (it = rt), ot && (ut = ot), /* @__PURE__ */ React$a.createElement(Form$3.Item, Object.assign({}, lt, {
    className: classnames("fr-obj-subinline", {
      "fr-obj-subinline-label-hidden": !_,
      "fr-obj-subinline-background": tt
    }),
    label: _ || "notitle",
    labelCol: it,
    wrapperCol: ut,
    tooltip: et
  }), $);
}, FLineTitle = function a(s) {
  var $ = s.children, _ = s.title, _e = s.description;
  return _ ? /* @__PURE__ */ React$a.createElement("div", {
    className: "fr-obj-line-title"
  }, /* @__PURE__ */ React$a.createElement("div", {
    className: "fr-obj-header"
  }, /* @__PURE__ */ React$a.createElement("span", {
    className: "fr-header-title"
  }, _), _e && /* @__PURE__ */ React$a.createElement("span", {
    className: "fr-header-desc"
  }, _e)), /* @__PURE__ */ React$a.createElement("div", {
    className: "fr-obj-content"
  }, $)) : /* @__PURE__ */ React$a.createElement(PanelView, null, $);
}, PlusOutlined$2 = {}, PlusOutlined$1 = {}, hasRequiredPlusOutlined;
function requirePlusOutlined() {
  if (hasRequiredPlusOutlined)
    return PlusOutlined$1;
  hasRequiredPlusOutlined = 1, Object.defineProperty(PlusOutlined$1, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" } }, { tag: "path", attrs: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z" } }] }, name: "plus", theme: "outlined" };
  return PlusOutlined$1.default = a, PlusOutlined$1;
}
var _interopRequireDefault$5 = interopRequireDefaultExports, _typeof$b = _typeofExports;
Object.defineProperty(PlusOutlined$2, "__esModule", {
  value: !0
});
var default_1$5 = PlusOutlined$2.default = void 0, _objectSpread2$5 = _interopRequireDefault$5(requireObjectSpread2()), React$5 = _interopRequireWildcard$5(reactExports), _PlusOutlined = _interopRequireDefault$5(requirePlusOutlined()), _AntdIcon$5 = _interopRequireDefault$5(requireAntdIcon());
function _getRequireWildcardCache$5(a) {
  if (typeof WeakMap != "function")
    return null;
  var s = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$5 = function(_e) {
    return _e ? $ : s;
  })(a);
}
function _interopRequireWildcard$5(a, s) {
  if (!s && a && a.__esModule)
    return a;
  if (a === null || _typeof$b(a) !== "object" && typeof a != "function")
    return { default: a };
  var $ = _getRequireWildcardCache$5(s);
  if ($ && $.has(a))
    return $.get(a);
  var _ = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var tt in a)
    if (tt !== "default" && Object.prototype.hasOwnProperty.call(a, tt)) {
      var nt = _e ? Object.getOwnPropertyDescriptor(a, tt) : null;
      nt && (nt.get || nt.set) ? Object.defineProperty(_, tt, nt) : _[tt] = a[tt];
    }
  return _.default = a, $ && $.set(a, _), _;
}
var PlusOutlined = function a(s, $) {
  return /* @__PURE__ */ React$5.createElement(_AntdIcon$5.default, (0, _objectSpread2$5.default)((0, _objectSpread2$5.default)({}, s), {}, {
    ref: $,
    icon: _PlusOutlined.default
  }));
};
PlusOutlined.displayName = "PlusOutlined";
var _default$5 = /* @__PURE__ */ React$5.forwardRef(PlusOutlined);
default_1$5 = PlusOutlined$2.default = _default$5;
var CopyOutlined$2 = {}, CopyOutlined$1 = {}, hasRequiredCopyOutlined;
function requireCopyOutlined() {
  if (hasRequiredCopyOutlined)
    return CopyOutlined$1;
  hasRequiredCopyOutlined = 1, Object.defineProperty(CopyOutlined$1, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" };
  return CopyOutlined$1.default = a, CopyOutlined$1;
}
var _interopRequireDefault$4 = interopRequireDefaultExports, _typeof$a = _typeofExports;
Object.defineProperty(CopyOutlined$2, "__esModule", {
  value: !0
});
var default_1$4 = CopyOutlined$2.default = void 0, _objectSpread2$4 = _interopRequireDefault$4(requireObjectSpread2()), React$4 = _interopRequireWildcard$4(reactExports), _CopyOutlined = _interopRequireDefault$4(requireCopyOutlined()), _AntdIcon$4 = _interopRequireDefault$4(requireAntdIcon());
function _getRequireWildcardCache$4(a) {
  if (typeof WeakMap != "function")
    return null;
  var s = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$4 = function(_e) {
    return _e ? $ : s;
  })(a);
}
function _interopRequireWildcard$4(a, s) {
  if (!s && a && a.__esModule)
    return a;
  if (a === null || _typeof$a(a) !== "object" && typeof a != "function")
    return { default: a };
  var $ = _getRequireWildcardCache$4(s);
  if ($ && $.has(a))
    return $.get(a);
  var _ = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var tt in a)
    if (tt !== "default" && Object.prototype.hasOwnProperty.call(a, tt)) {
      var nt = _e ? Object.getOwnPropertyDescriptor(a, tt) : null;
      nt && (nt.get || nt.set) ? Object.defineProperty(_, tt, nt) : _[tt] = a[tt];
    }
  return _.default = a, $ && $.set(a, _), _;
}
var CopyOutlined = function a(s, $) {
  return /* @__PURE__ */ React$4.createElement(_AntdIcon$4.default, (0, _objectSpread2$4.default)((0, _objectSpread2$4.default)({}, s), {}, {
    ref: $,
    icon: _CopyOutlined.default
  }));
};
CopyOutlined.displayName = "CopyOutlined";
var _default$4 = /* @__PURE__ */ React$4.forwardRef(CopyOutlined);
default_1$4 = CopyOutlined$2.default = _default$4;
var CloseOutlined$2 = {}, CloseOutlined$1 = {}, hasRequiredCloseOutlined;
function requireCloseOutlined() {
  if (hasRequiredCloseOutlined)
    return CloseOutlined$1;
  hasRequiredCloseOutlined = 1, Object.defineProperty(CloseOutlined$1, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
  return CloseOutlined$1.default = a, CloseOutlined$1;
}
var _interopRequireDefault$3 = interopRequireDefaultExports, _typeof$9 = _typeofExports;
Object.defineProperty(CloseOutlined$2, "__esModule", {
  value: !0
});
var default_1$3 = CloseOutlined$2.default = void 0, _objectSpread2$3 = _interopRequireDefault$3(requireObjectSpread2()), React$3 = _interopRequireWildcard$3(reactExports), _CloseOutlined = _interopRequireDefault$3(requireCloseOutlined()), _AntdIcon$3 = _interopRequireDefault$3(requireAntdIcon());
function _getRequireWildcardCache$3(a) {
  if (typeof WeakMap != "function")
    return null;
  var s = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$3 = function(_e) {
    return _e ? $ : s;
  })(a);
}
function _interopRequireWildcard$3(a, s) {
  if (!s && a && a.__esModule)
    return a;
  if (a === null || _typeof$9(a) !== "object" && typeof a != "function")
    return { default: a };
  var $ = _getRequireWildcardCache$3(s);
  if ($ && $.has(a))
    return $.get(a);
  var _ = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var tt in a)
    if (tt !== "default" && Object.prototype.hasOwnProperty.call(a, tt)) {
      var nt = _e ? Object.getOwnPropertyDescriptor(a, tt) : null;
      nt && (nt.get || nt.set) ? Object.defineProperty(_, tt, nt) : _[tt] = a[tt];
    }
  return _.default = a, $ && $.set(a, _), _;
}
var CloseOutlined = function a(s, $) {
  return /* @__PURE__ */ React$3.createElement(_AntdIcon$3.default, (0, _objectSpread2$3.default)((0, _objectSpread2$3.default)({}, s), {}, {
    ref: $,
    icon: _CloseOutlined.default
  }));
};
CloseOutlined.displayName = "CloseOutlined";
var _default$3 = /* @__PURE__ */ React$3.forwardRef(CloseOutlined);
default_1$3 = CloseOutlined$2.default = _default$3;
var ArrowDownOutlined$2 = {}, ArrowDownOutlined$1 = {}, hasRequiredArrowDownOutlined;
function requireArrowDownOutlined() {
  if (hasRequiredArrowDownOutlined)
    return ArrowDownOutlined$1;
  hasRequiredArrowDownOutlined = 1, Object.defineProperty(ArrowDownOutlined$1, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z" } }] }, name: "arrow-down", theme: "outlined" };
  return ArrowDownOutlined$1.default = a, ArrowDownOutlined$1;
}
var _interopRequireDefault$2 = interopRequireDefaultExports, _typeof$8 = _typeofExports;
Object.defineProperty(ArrowDownOutlined$2, "__esModule", {
  value: !0
});
var default_1$2 = ArrowDownOutlined$2.default = void 0, _objectSpread2$2 = _interopRequireDefault$2(requireObjectSpread2()), React$2 = _interopRequireWildcard$2(reactExports), _ArrowDownOutlined = _interopRequireDefault$2(requireArrowDownOutlined()), _AntdIcon$2 = _interopRequireDefault$2(requireAntdIcon());
function _getRequireWildcardCache$2(a) {
  if (typeof WeakMap != "function")
    return null;
  var s = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$2 = function(_e) {
    return _e ? $ : s;
  })(a);
}
function _interopRequireWildcard$2(a, s) {
  if (!s && a && a.__esModule)
    return a;
  if (a === null || _typeof$8(a) !== "object" && typeof a != "function")
    return { default: a };
  var $ = _getRequireWildcardCache$2(s);
  if ($ && $.has(a))
    return $.get(a);
  var _ = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var tt in a)
    if (tt !== "default" && Object.prototype.hasOwnProperty.call(a, tt)) {
      var nt = _e ? Object.getOwnPropertyDescriptor(a, tt) : null;
      nt && (nt.get || nt.set) ? Object.defineProperty(_, tt, nt) : _[tt] = a[tt];
    }
  return _.default = a, $ && $.set(a, _), _;
}
var ArrowDownOutlined = function a(s, $) {
  return /* @__PURE__ */ React$2.createElement(_AntdIcon$2.default, (0, _objectSpread2$2.default)((0, _objectSpread2$2.default)({}, s), {}, {
    ref: $,
    icon: _ArrowDownOutlined.default
  }));
};
ArrowDownOutlined.displayName = "ArrowDownOutlined";
var _default$2 = /* @__PURE__ */ React$2.forwardRef(ArrowDownOutlined);
default_1$2 = ArrowDownOutlined$2.default = _default$2;
var ArrowUpOutlined$2 = {}, ArrowUpOutlined$1 = {}, hasRequiredArrowUpOutlined;
function requireArrowUpOutlined() {
  if (hasRequiredArrowUpOutlined)
    return ArrowUpOutlined$1;
  hasRequiredArrowUpOutlined = 1, Object.defineProperty(ArrowUpOutlined$1, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z" } }] }, name: "arrow-up", theme: "outlined" };
  return ArrowUpOutlined$1.default = a, ArrowUpOutlined$1;
}
var _interopRequireDefault$1 = interopRequireDefaultExports, _typeof$7 = _typeofExports;
Object.defineProperty(ArrowUpOutlined$2, "__esModule", {
  value: !0
});
var default_1$1 = ArrowUpOutlined$2.default = void 0, _objectSpread2$1 = _interopRequireDefault$1(requireObjectSpread2()), React$1 = _interopRequireWildcard$1(reactExports), _ArrowUpOutlined = _interopRequireDefault$1(requireArrowUpOutlined()), _AntdIcon$1 = _interopRequireDefault$1(requireAntdIcon());
function _getRequireWildcardCache$1(a) {
  if (typeof WeakMap != "function")
    return null;
  var s = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$1 = function(_e) {
    return _e ? $ : s;
  })(a);
}
function _interopRequireWildcard$1(a, s) {
  if (!s && a && a.__esModule)
    return a;
  if (a === null || _typeof$7(a) !== "object" && typeof a != "function")
    return { default: a };
  var $ = _getRequireWildcardCache$1(s);
  if ($ && $.has(a))
    return $.get(a);
  var _ = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var tt in a)
    if (tt !== "default" && Object.prototype.hasOwnProperty.call(a, tt)) {
      var nt = _e ? Object.getOwnPropertyDescriptor(a, tt) : null;
      nt && (nt.get || nt.set) ? Object.defineProperty(_, tt, nt) : _[tt] = a[tt];
    }
  return _.default = a, $ && $.set(a, _), _;
}
var ArrowUpOutlined = function a(s, $) {
  return /* @__PURE__ */ React$1.createElement(_AntdIcon$1.default, (0, _objectSpread2$1.default)((0, _objectSpread2$1.default)({}, s), {}, {
    ref: $,
    icon: _ArrowUpOutlined.default
  }));
};
ArrowUpOutlined.displayName = "ArrowUpOutlined";
var _default$1 = /* @__PURE__ */ React$1.forwardRef(ArrowUpOutlined);
default_1$1 = ArrowUpOutlined$2.default = _default$1;
var HeaderTitle = function a(s) {
  var $ = s.icon, _ = s.children, _e = s.btnType, tt = __rest$3(s, ["icon", "children", "btnType"]), nt = Object.assign({}, tt);
  return _e === "icon" ? (nt.icon = $, nt.size = "small") : nt.children = _, /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({
    type: "link",
    style: {
      padding: 0
    }
  }, nt));
};
function _toConsumableArray$5(a) {
  return _arrayWithoutHoles$5(a) || _iterableToArray$5(a) || _unsupportedIterableToArray$9(a) || _nonIterableSpread$5();
}
function _nonIterableSpread$5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$9(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$9(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$9(a, s);
  }
}
function _iterableToArray$5(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$5(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$9(a);
}
function _arrayLikeToArray$9(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
var getHasBackground = function a(s, $) {
  var _ = $;
  return s.length === 0 && (_ = !1), _;
}, SimpleList = function a(s) {
  var $ = s.form, _ = s.schema, _e = s.fields, tt = s.rootPath, nt = s.renderCore, at = s.hasBackground, ot = s.operateBtnType, rt = s.addBtnProps, st = s.delConfirmProps, lt = s.copyBtnProps, et = s.deleteBtnProps, it = s.moveUpBtnProps, ut = s.moveDownBtnProps, ft = s.hideDelete, ht = s.hideCopy, dt = s.hideMove, gt = s.hideAdd, pt = s.addItem, mt = s.copyItem, ct = s.moveItem, vt = s.removeItem, At = s.temporary;
  _.items.displayType || (_.items.displayType = "inline", _.items.inlineMode = !0);
  var xt = function(St) {
    var Bt = $.getFieldValue(tt.concat(St));
    mt(Bt);
  }, bt = At.displayType === "column";
  return /* @__PURE__ */ React$a.createElement("div", {
    className: classnames("fr-list-simple", {
      "fr-list-simple-background": getHasBackground(_e, at),
      "fr-list-simple-column": bt
    })
  }, _e.map(function(Et) {
    var St = Et.key, Bt = Et.name, Ot = _e.length;
    return /* @__PURE__ */ React$a.createElement("div", {
      key: St,
      className: "fr-list-item"
    }, nt({
      schema: _,
      parentPath: [Bt],
      rootPath: [].concat(_toConsumableArray$5(tt), [Bt])
    }), /* @__PURE__ */ React$a.createElement(_Space, {
      className: classnames("fr-list-item-operate"),
      split: ot !== "icon" && /* @__PURE__ */ React$a.createElement(Divider$1, {
        type: "vertical"
      })
    }, !dt && /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
      disabled: Bt === 0,
      onClick: function() {
        return ct(Bt, Bt - 1);
      },
      icon: /* @__PURE__ */ React$a.createElement(default_1$1, null)
    }, it)), /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
      disabled: Bt === Ot - 1,
      onClick: function() {
        return ct(Bt, Bt + 1);
      },
      icon: /* @__PURE__ */ React$a.createElement(default_1$2, null),
      children: "下移"
    }, ut))), !ft && /* @__PURE__ */ React$a.createElement(_Popconfirm, Object.assign({
      onConfirm: function() {
        return vt(Bt);
      }
    }, st), /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
      icon: /* @__PURE__ */ React$a.createElement(default_1$3, null),
      children: "删除",
      btnType: ot
    }, et))), !ht && /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
      onClick: function() {
        return xt(Bt);
      },
      icon: /* @__PURE__ */ React$a.createElement(default_1$4, null),
      children: "复制"
    }, lt))));
  }), (!_.max || _e.length < _.max) && !gt && /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({
    className: "add-btn",
    icon: /* @__PURE__ */ React$a.createElement(default_1$5, null),
    onClick: function() {
      return pt();
    },
    block: _e.length > 0
  }, rt)));
};
function _toConsumableArray$4(a) {
  return _arrayWithoutHoles$4(a) || _iterableToArray$4(a) || _unsupportedIterableToArray$8(a) || _nonIterableSpread$4();
}
function _nonIterableSpread$4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$8(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$8(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$8(a, s);
  }
}
function _iterableToArray$4(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$4(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$8(a);
}
function _arrayLikeToArray$8(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
var getOperateFixed = function a(s) {
  var $, _, _e = !0;
  return !((_ = ($ = s == null ? void 0 : s.items) === null || $ === void 0 ? void 0 : $.props) === null || _ === void 0) && _.extra && (_e = !1), _e;
}, getOperateStyle = function a(s) {
  var $, _, _e, tt, nt, at = {}, ot = (($ = s == null ? void 0 : s.items) === null || $ === void 0 ? void 0 : $.theme) || ((_ = s == null ? void 0 : s.items) === null || _ === void 0 ? void 0 : _.widget) || "collapse";
  return ["card", "collapse", "lineTitle"].includes(ot) && !(!((tt = (_e = s == null ? void 0 : s.items) === null || _e === void 0 ? void 0 : _e.props) === null || tt === void 0) && tt.extra) && (at.top = "14px", ["lineTitle"].includes(ot) && (at.top = "3px", at.padding = 0), !((nt = s == null ? void 0 : s.items) === null || nt === void 0) && nt.title || (at.right = "0")), at;
}, CardList = function a(s) {
  var $ = s.form, _ = s.schema, _e = s.fields, tt = s.rootPath, nt = s.renderCore, at = s.hasBackground, ot = s.operateBtnType, rt = s.addBtnProps, st = s.delConfirmProps, lt = s.copyBtnProps, et = s.deleteBtnProps, it = s.moveUpBtnProps, ut = s.moveDownBtnProps, ft = s.hideDelete, ht = s.hideCopy, dt = s.hideMove, gt = s.hideAdd, pt = s.addItem, mt = s.copyItem, ct = s.moveItem, vt = s.removeItem, At = function(bt) {
    var Et = $.getFieldValue(tt.concat(bt));
    mt(Et);
  };
  return /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement("div", {
    className: classnames("fr-list-card", {
      "fr-list-card-background": at
    })
  }, _e.map(function(xt) {
    var bt = xt.key, Et = xt.name, St = _e.length, Bt = cloneDeep(_);
    return Bt.items.title && typeof Bt.items.title == "string" && (Bt.items.title += " ".concat(Et + 1)), /* @__PURE__ */ React$a.createElement("div", {
      key: bt,
      className: "fr-list-item"
    }, /* @__PURE__ */ React$a.createElement("div", {
      style: {
        width: 0,
        flex: 1
      }
    }, nt({
      schema: Bt,
      parentPath: [Et],
      rootPath: [].concat(_toConsumableArray$4(tt), [Et])
    })), /* @__PURE__ */ React$a.createElement(_Space, {
      className: classnames("fr-list-item-operate", {
        "fr-list-item-operate-fixed": getOperateFixed(_)
      }),
      style: getOperateStyle(_),
      split: ot !== "icon" && /* @__PURE__ */ React$a.createElement(Divider$1, {
        type: "vertical"
      })
    }, !dt && /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
      disabled: Et === 0,
      onClick: function() {
        return ct(Et, Et - 1);
      },
      icon: /* @__PURE__ */ React$a.createElement(default_1$1, null)
    }, it)), /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
      disabled: Et === St - 1,
      onClick: function() {
        return ct(Et, Et + 1);
      },
      icon: /* @__PURE__ */ React$a.createElement(default_1$2, null)
    }, ut))), !ft && /* @__PURE__ */ React$a.createElement(_Popconfirm, Object.assign({
      onConfirm: function() {
        return vt(Et);
      }
    }, st), /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
      icon: /* @__PURE__ */ React$a.createElement(default_1$3, null)
    }, et))), !ht && /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
      onClick: function() {
        return At(Et);
      },
      icon: /* @__PURE__ */ React$a.createElement(default_1$4, null)
    }, lt))));
  }), !gt && /* @__PURE__ */ React$a.createElement("div", {
    className: "fr-list-add-btn"
  }, /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({}, rt, {
    onClick: function() {
      return pt();
    },
    icon: /* @__PURE__ */ React$a.createElement(default_1$5, null),
    block: _e.length > 0
  })))));
}, InfoCircleOutlined$2 = {}, InfoCircleOutlined$1 = {}, hasRequiredInfoCircleOutlined;
function requireInfoCircleOutlined() {
  if (hasRequiredInfoCircleOutlined)
    return InfoCircleOutlined$1;
  hasRequiredInfoCircleOutlined = 1, Object.defineProperty(InfoCircleOutlined$1, "__esModule", { value: !0 });
  var a = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, name: "info-circle", theme: "outlined" };
  return InfoCircleOutlined$1.default = a, InfoCircleOutlined$1;
}
var _interopRequireDefault = interopRequireDefaultExports, _typeof$6 = _typeofExports;
Object.defineProperty(InfoCircleOutlined$2, "__esModule", {
  value: !0
});
var default_1 = InfoCircleOutlined$2.default = void 0, _objectSpread2 = _interopRequireDefault(requireObjectSpread2()), React = _interopRequireWildcard(reactExports), _InfoCircleOutlined = _interopRequireDefault(requireInfoCircleOutlined()), _AntdIcon = _interopRequireDefault(requireAntdIcon());
function _getRequireWildcardCache(a) {
  if (typeof WeakMap != "function")
    return null;
  var s = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache = function(_e) {
    return _e ? $ : s;
  })(a);
}
function _interopRequireWildcard(a, s) {
  if (!s && a && a.__esModule)
    return a;
  if (a === null || _typeof$6(a) !== "object" && typeof a != "function")
    return { default: a };
  var $ = _getRequireWildcardCache(s);
  if ($ && $.has(a))
    return $.get(a);
  var _ = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var tt in a)
    if (tt !== "default" && Object.prototype.hasOwnProperty.call(a, tt)) {
      var nt = _e ? Object.getOwnPropertyDescriptor(a, tt) : null;
      nt && (nt.get || nt.set) ? Object.defineProperty(_, tt, nt) : _[tt] = a[tt];
    }
  return _.default = a, $ && $.set(a, _), _;
}
var InfoCircleOutlined = function a(s, $) {
  return /* @__PURE__ */ React.createElement(_AntdIcon.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, s), {}, {
    ref: $,
    icon: _InfoCircleOutlined.default
  }));
};
InfoCircleOutlined.displayName = "InfoCircleOutlined";
var _default = /* @__PURE__ */ React.forwardRef(InfoCircleOutlined);
default_1 = InfoCircleOutlined$2.default = _default;
function _slicedToArray$7(a, s) {
  return _arrayWithHoles$7(a) || _iterableToArrayLimit$7(a, s) || _unsupportedIterableToArray$7(a, s) || _nonIterableRest$7();
}
function _nonIterableRest$7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$7(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$7(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$7(a, s);
  }
}
function _arrayLikeToArray$7(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$7(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$7(a) {
  if (Array.isArray(a))
    return a;
}
var TableCell = function a(s) {
  var $ = s.renderCore, _ = s.schema, _e = s.dataIndex, tt = __rest$3(s, ["renderCore", "schema", "dataIndex"]), nt = reactExports.useState(null), at = _slicedToArray$7(nt, 2), ot = at[0], rt = at[1], st = reactExports.useState(), lt = _slicedToArray$7(st, 2), et = lt[0], it = lt[1], ut = reactExports.useRef(), ft = function(pt, mt) {
    var ct = mt[0] || null;
    rt(ct), ut.current && ct && it(!0);
  };
  _.properties[_e].onStatusChange || (_.properties[_e].onStatusChange = ft);
  var ht = et && ot, dt = {
    open: ht
  };
  return window.antdVersion === "v4" && (dt = {
    visible: ht
  }), /* @__PURE__ */ React$a.createElement("div", {
    className: "fr-table-cell-content",
    onMouseEnter: function() {
      ut.current = !0, it(!0);
    },
    onMouseLeave: function() {
      ut.current = !1, it(!1);
    }
  }, /* @__PURE__ */ React$a.createElement(_Popover, Object.assign({
    overlayClassName: "fr-popover-error",
    content: ot,
    placement: "topRight"
  }, dt), $(Object.assign(Object.assign({}, tt), {
    schema: _
  }))));
};
function _typeof$5(a) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$5(a);
}
function _toConsumableArray$3(a) {
  return _arrayWithoutHoles$3(a) || _iterableToArray$3(a) || _unsupportedIterableToArray$6(a) || _nonIterableSpread$3();
}
function _nonIterableSpread$3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$3(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$3(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$6(a);
}
function _defineProperty$4(a, s, $) {
  return s = _toPropertyKey$4(s), s in a ? Object.defineProperty(a, s, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = $, a;
}
function _toPropertyKey$4(a) {
  var s = _toPrimitive$4(a, "string");
  return _typeof$5(s) === "symbol" ? s : String(s);
}
function _toPrimitive$4(a, s) {
  if (_typeof$5(a) !== "object" || a === null)
    return a;
  var $ = a[Symbol.toPrimitive];
  if ($ !== void 0) {
    var _ = $.call(a, s || "default");
    if (_typeof$5(_) !== "object")
      return _;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _slicedToArray$6(a, s) {
  return _arrayWithHoles$6(a) || _iterableToArrayLimit$6(a, s) || _unsupportedIterableToArray$6(a, s) || _nonIterableRest$6();
}
function _nonIterableRest$6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$6(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$6(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$6(a, s);
  }
}
function _arrayLikeToArray$6(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$6(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$6(a) {
  if (Array.isArray(a))
    return a;
}
var getTooltip$2 = function a(s) {
  if (s)
    return typeof s == "string" ? {
      title: /* @__PURE__ */ React$a.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s
        }
      })
    } : Object.assign(Object.assign({}, s), {
      title: /* @__PURE__ */ React$a.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s.title
        }
      })
    });
}, TableList$1 = function a(s) {
  var $, _, _e = s.form, tt = s.schema, nt = s.fields, at = s.rootPath, ot = s.renderCore, rt = s.readOnly, st = s.operateBtnType, lt = s.addBtnProps, et = s.delConfirmProps, it = s.copyBtnProps, ut = s.deleteBtnProps, ft = s.moveUpBtnProps, ht = s.moveDownBtnProps, dt = s.actionColumnProps, gt = s.pagination, pt = s.hideDelete, mt = s.hideCopy, ct = s.hideMove, vt = s.hideAdd, At = s.hideOperate, xt = s.addItem, bt = s.copyItem, Et = s.moveItem, St = s.removeItem, Bt = s.configContext, Ot = s.validatePopover, Pt = __rest$3(s, ["form", "schema", "fields", "rootPath", "renderCore", "readOnly", "operateBtnType", "addBtnProps", "delConfirmProps", "copyBtnProps", "deleteBtnProps", "moveUpBtnProps", "moveDownBtnProps", "actionColumnProps", "pagination", "hideDelete", "hideCopy", "hideMove", "hideAdd", "hideOperate", "addItem", "copyItem", "moveItem", "removeItem", "configContext", "validatePopover"]), wt = Bt.globalConfig, Ct = ($ = Ot ?? (wt == null ? void 0 : wt.listValidatePopover)) !== null && $ !== void 0 ? $ : !0, It = dt.colHeaderText, yt = __rest$3(dt, ["colHeaderText"]), Rt = ((_ = tt == null ? void 0 : tt.items) === null || _ === void 0 ? void 0 : _.properties) || {}, kt = Object.assign({
    size: "small",
    hideOnSinglePage: !0
  }, gt), jt = function(_t) {
    var Nt = _e.getFieldValue(at.concat(_t));
    bt(Nt);
  }, Ht = sortProperties(Object.entries(Rt)).map(function(Ft) {
    var _t = _slicedToArray$6(Ft, 2), Nt = _t[0], Mt = _t[1], Lt = Mt.required, $t = Mt.title, Tt = Mt.width, Dt = Mt.tooltip, Ut = getTooltip$2(Dt);
    return {
      dataIndex: Nt,
      width: Tt,
      title: /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, Lt && /* @__PURE__ */ React$a.createElement("span", {
        style: {
          color: "red",
          marginRight: "3px"
        }
      }, "*"), /* @__PURE__ */ React$a.createElement("span", null, $t), Ut && /* @__PURE__ */ React$a.createElement(_Tooltip, Object.assign({
        placement: "top"
      }, Ut), /* @__PURE__ */ React$a.createElement(default_1, {
        style: {
          marginLeft: 6
        }
      }))),
      render: function(Qt, qt) {
        var Zt = {
          type: "object",
          properties: _defineProperty$4({}, Nt, Object.assign(Object.assign({}, Rt[Nt]), {
            fieldCol: 24
          }))
        };
        return Ct ? /* @__PURE__ */ React$a.createElement(TableCell, {
          renderCore: ot,
          schema: Zt,
          parentPath: [qt.name],
          rootPath: [].concat(_toConsumableArray$3(at), [qt.name]),
          dataIndex: Nt
        }) : /* @__PURE__ */ React$a.createElement("div", {
          className: "fr-table-cell-content"
        }, ot({
          parentPath: [qt.name],
          rootPath: [].concat(_toConsumableArray$3(at), [qt.name]),
          schema: Zt
        }));
      }
    };
  });
  return !rt && !At && Ht.push(Object.assign(Object.assign({
    title: It,
    width: "190px",
    fixed: "right"
  }, yt), {
    render: function(_t, Nt) {
      return /* @__PURE__ */ React$a.createElement(Form$3.Item, null, /* @__PURE__ */ React$a.createElement(_Space, {
        className: "fr-list-item-operate",
        split: st !== "icon" && /* @__PURE__ */ React$a.createElement(Divider$1, {
          type: "vertical"
        })
      }, !ct && /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        disabled: Nt.name === 0,
        onClick: function() {
          return Et(Nt.name, Nt.name - 1);
        },
        icon: /* @__PURE__ */ React$a.createElement(default_1$1, null)
      }, ft)), /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        disabled: Nt.name === nt.length - 1,
        onClick: function() {
          return Et(Nt.name, Nt.name + 1);
        },
        icon: /* @__PURE__ */ React$a.createElement(default_1$2, null)
      }, ht))), !pt && /* @__PURE__ */ React$a.createElement(_Popconfirm, Object.assign({
        onConfirm: function() {
          return St(Nt.name);
        }
      }, et), /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        icon: /* @__PURE__ */ React$a.createElement(default_1$3, null),
        btnType: st
      }, ut))), !mt && /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        onClick: function() {
          return jt(Nt.name);
        },
        icon: /* @__PURE__ */ React$a.createElement(default_1$4, null)
      }, it))));
    }
  })), /* @__PURE__ */ React$a.createElement("div", {
    className: classnames("fr-table-list", {
      "fr-table-list-no-popover": !Ct
    })
  }, /* @__PURE__ */ React$a.createElement(Table$1, Object.assign({
    size: "middle",
    scroll: {
      x: "max-content"
    },
    style: {
      marginBottom: "12px"
    }
  }, Pt, {
    columns: Ht,
    dataSource: nt,
    pagination: kt
  })), (!tt.max || nt.length < tt.max) && !vt && /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({
    icon: /* @__PURE__ */ React$a.createElement(default_1$5, null),
    onClick: function() {
      return xt();
    }
  }, lt)));
}, DrawerForm = function a(s) {
  var $ = s.schema, _ = s.widgets, _e = s.onClose, tt = s.data, nt = s.configContext, at = useForm(), ot = reactExports.useContext(ThemeConfigProvider.ConfigContext), rt = translation(ot), st = function(ut) {
    _e(ut);
  }, lt = function() {
    _e();
  }, et = {
    open: !0
  };
  return window.antdVersion === "v4" && (et = {
    visible: !0
  }), /* @__PURE__ */ React$a.createElement(_Drawer, Object.assign({}, et, {
    width: 600,
    title: rt("operate"),
    onClose: lt,
    extra: /* @__PURE__ */ React$a.createElement(_Space, null, /* @__PURE__ */ React$a.createElement(Button$2, {
      onClick: lt
    }, rt("cancel")), /* @__PURE__ */ React$a.createElement(Button$2, {
      type: "primary",
      onClick: at.submit
    }, rt("confirm")))
  }), /* @__PURE__ */ React$a.createElement(FormRender, {
    schema: $.items,
    initialValues: tt,
    form: at,
    labelCol: {
      span: 8
    },
    widgets: _,
    onFinish: st,
    locale: nt == null ? void 0 : nt.locale,
    maxWidth: "auto"
  }));
};
function _typeof$4(a) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$4(a);
}
function _defineProperty$3(a, s, $) {
  return s = _toPropertyKey$3(s), s in a ? Object.defineProperty(a, s, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = $, a;
}
function _toPropertyKey$3(a) {
  var s = _toPrimitive$3(a, "string");
  return _typeof$4(s) === "symbol" ? s : String(s);
}
function _toPrimitive$3(a, s) {
  if (_typeof$4(a) !== "object" || a === null)
    return a;
  var $ = a[Symbol.toPrimitive];
  if ($ !== void 0) {
    var _ = $.call(a, s || "default");
    if (_typeof$4(_) !== "object")
      return _;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _toConsumableArray$2(a) {
  return _arrayWithoutHoles$2(a) || _iterableToArray$2(a) || _unsupportedIterableToArray$5(a) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$2(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$2(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$5(a);
}
function _slicedToArray$5(a, s) {
  return _arrayWithHoles$5(a) || _iterableToArrayLimit$5(a, s) || _unsupportedIterableToArray$5(a, s) || _nonIterableRest$5();
}
function _nonIterableRest$5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$5(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$5(a, s);
  }
}
function _arrayLikeToArray$5(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$5(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$5(a) {
  if (Array.isArray(a))
    return a;
}
var getTooltip$1 = function a(s) {
  if (s)
    return typeof s == "string" ? {
      title: /* @__PURE__ */ React$a.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s
        }
      })
    } : Object.assign(Object.assign({}, s), {
      title: /* @__PURE__ */ React$a.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s.title
        }
      })
    });
}, TableList = function a(s) {
  var $, _ = s.form, _e = s.schema, tt = s.fields, nt = s.rootPath, at = s.renderCore, ot = s.readOnly, rt = s.widgets, st = s.pagination, lt = s.operateBtnType, et = s.addBtnProps, it = s.delConfirmProps, ut = s.copyBtnProps, ft = s.deleteBtnProps, ht = s.moveUpBtnProps, dt = s.moveDownBtnProps, gt = s.actionColumnProps, pt = s.editorBtnProps, mt = s.hideDelete, ct = s.hideCopy, vt = s.hideMove, At = s.hideAdd, xt = s.hideEdit, bt = s.addItem, Et = s.copyItem, St = s.moveItem, Bt = s.removeItem, Ot = s.configContext, Pt = gt.colHeaderText, wt = __rest$3(gt, ["colHeaderText"]);
  reactExports.useContext(ThemeConfigProvider.ConfigContext);
  var Ct = Object.assign({
    size: "small",
    hideOnSinglePage: !0
  }, st), It = (($ = _e == null ? void 0 : _e.items) === null || $ === void 0 ? void 0 : $.properties) || {}, yt = reactExports.useState(!1), Rt = _slicedToArray$5(yt, 2), kt = Rt[0], jt = Rt[1], Ht = reactExports.useState(null), Ft = _slicedToArray$5(Ht, 2), _t = Ft[0], Nt = Ft[1], Mt = reactExports.useRef(null), Lt = function(Vt) {
    var Qt = _.getFieldValue(nt.concat(Vt));
    Et(Qt);
  }, $t = function() {
    Mt.current = -1, jt(!0);
  }, Tt = function(Vt) {
    jt(!1), Nt(null), Vt && (Mt.current === -1 ? bt(Vt) : _.setFieldValue([].concat(_toConsumableArray$2(nt), [Mt.current]), Vt), Mt.current);
  }, Dt = Object.keys(It).map(function(Ut) {
    var Vt = It[Ut], Qt = Vt.title, qt = Vt.tooltip, Zt = Vt.width, ar = getTooltip$1(qt);
    return {
      dataIndex: Ut,
      width: Zt,
      title: /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement("span", null, Qt), ar && /* @__PURE__ */ React$a.createElement(_Tooltip, Object.assign({
        placement: "top"
      }, ar), /* @__PURE__ */ React$a.createElement(default_1, {
        style: {
          marginLeft: 6
        }
      }))),
      render: function(rr, Yt) {
        var Kt = {
          type: "object",
          properties: _defineProperty$3({}, Ut, Object.assign(Object.assign({}, It[Ut]), {
            noStyle: !0,
            readOnly: !0
          }))
        };
        return at({
          schema: Kt,
          parentPath: [Yt.name],
          rootPath: [].concat(_toConsumableArray$2(nt), [Yt.name])
        });
      }
    };
  });
  return ot || Dt.push(Object.assign(Object.assign({
    title: Pt,
    width: "190px",
    fixed: "right"
  }, wt), {
    render: function(Vt, Qt) {
      return /* @__PURE__ */ React$a.createElement(Form$3.Item, null, /* @__PURE__ */ React$a.createElement(_Space, {
        className: "fr-list-item-operate",
        split: lt !== "icon" && /* @__PURE__ */ React$a.createElement(Divider$1, {
          type: "vertical"
        })
      }, !vt && /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        disabled: Qt.name === 0,
        onClick: function() {
          return St(Qt.name, Qt.name - 1);
        },
        icon: /* @__PURE__ */ React$a.createElement(default_1$1, null)
      }, ht)), /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        disabled: Qt.name === tt.length - 1,
        onClick: function() {
          return St(Qt.name, Qt.name + 1);
        },
        icon: /* @__PURE__ */ React$a.createElement(default_1$2, null)
      }, dt))), !mt && /* @__PURE__ */ React$a.createElement(_Popconfirm, Object.assign({
        onConfirm: function() {
          return Bt(Qt.name);
        }
      }, it), /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        icon: /* @__PURE__ */ React$a.createElement(default_1$3, null),
        btnType: lt
      }, ft))), !ct && /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        onClick: function() {
          return Lt(Qt.name);
        },
        icon: /* @__PURE__ */ React$a.createElement(default_1$4, null)
      }, ut)), !xt && /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        onClick: function() {
          jt(!0), Mt.current = Qt.name, Nt(_.getFieldValue(nt.concat(Qt.name)));
        },
        icon: /* @__PURE__ */ React$a.createElement(default_1$4, null)
      }, pt))));
    }
  })), /* @__PURE__ */ React$a.createElement("div", {
    className: "fr-list-drawer"
  }, /* @__PURE__ */ React$a.createElement(Table$1, {
    size: "middle",
    dataSource: tt,
    columns: Dt,
    style: {
      marginBottom: "12px"
    },
    scroll: {
      x: "max-content"
    },
    pagination: Ct
  }), (!_e.max || tt.length < _e.max) && !At && /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({
    icon: /* @__PURE__ */ React$a.createElement(default_1$5, null),
    onClick: $t
  }, et)), kt && /* @__PURE__ */ React$a.createElement(DrawerForm, {
    schema: _e,
    data: _t,
    widgets: rt,
    configContext: Ot,
    onClose: Tt
  }));
};
function _slicedToArray$4(a, s) {
  return _arrayWithHoles$4(a) || _iterableToArrayLimit$4(a, s) || _unsupportedIterableToArray$4(a, s) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$4(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$4(a, s);
  }
}
function _arrayLikeToArray$4(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$4(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$4(a) {
  if (Array.isArray(a))
    return a;
}
var VirtualCell = function a(s) {
  var $ = s.renderCore, _ = s.schema, _e = s.dataIndex, tt = __rest$3(s, ["renderCore", "schema", "dataIndex"]), nt = reactExports.useState(null), at = _slicedToArray$4(nt, 2), ot = at[0], rt = at[1], st = reactExports.useState(), lt = _slicedToArray$4(st, 2), et = lt[0], it = lt[1], ut = reactExports.useRef(), ft = function(pt, mt) {
    var ct = mt[0] || null;
    rt(ct), ut.current && ct && it(!0);
  };
  _.properties[_e].onStatusChange || (_.properties[_e].onStatusChange = ft);
  var ht = et && ot, dt = {
    open: ht
  };
  return window.antdVersion === "v4" && (dt = {
    visible: ht
  }), /* @__PURE__ */ React$a.createElement("div", {
    onMouseEnter: function() {
      ut.current = !0, it(!0);
    },
    onMouseLeave: function() {
      ut.current = !1, it(!1);
    }
  }, /* @__PURE__ */ React$a.createElement(_Popover, Object.assign({
    overlayClassName: "fr-popover-error",
    content: ot,
    placement: "topRight"
  }, dt), $(Object.assign(Object.assign({}, tt), {
    schema: _
  }))));
};
function _typeof$3(a) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$3(a);
}
var _excluded = ["style", "context"], _excluded2 = ["ctx"];
function ownKeys(a, s) {
  var $ = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var _ = Object.getOwnPropertySymbols(a);
    s && (_ = _.filter(function(_e) {
      return Object.getOwnPropertyDescriptor(a, _e).enumerable;
    })), $.push.apply($, _);
  }
  return $;
}
function _objectSpread(a) {
  for (var s = 1; s < arguments.length; s++) {
    var $ = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys(Object($), !0).forEach(function(_) {
      _defineProperty$2(a, _, $[_]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors($)) : ownKeys(Object($)).forEach(function(_) {
      Object.defineProperty(a, _, Object.getOwnPropertyDescriptor($, _));
    });
  }
  return a;
}
function _defineProperty$2(a, s, $) {
  return s = _toPropertyKey$2(s), s in a ? Object.defineProperty(a, s, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = $, a;
}
function _toPropertyKey$2(a) {
  var s = _toPrimitive$2(a, "string");
  return _typeof$3(s) === "symbol" ? s : String(s);
}
function _toPrimitive$2(a, s) {
  if (_typeof$3(a) !== "object" || a === null)
    return a;
  var $ = a[Symbol.toPrimitive];
  if ($ !== void 0) {
    var _ = $.call(a, s || "default");
    if (_typeof$3(_) !== "object")
      return _;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _objectWithoutProperties(a, s) {
  if (a == null)
    return {};
  var $ = _objectWithoutPropertiesLoose(a, s), _, _e;
  if (Object.getOwnPropertySymbols) {
    var tt = Object.getOwnPropertySymbols(a);
    for (_e = 0; _e < tt.length; _e++)
      _ = tt[_e], !(s.indexOf(_) >= 0) && Object.prototype.propertyIsEnumerable.call(a, _) && ($[_] = a[_]);
  }
  return $;
}
function _objectWithoutPropertiesLoose(a, s) {
  if (a == null)
    return {};
  var $ = {}, _ = Object.keys(a), _e, tt;
  for (tt = 0; tt < _.length; tt++)
    _e = _[tt], !(s.indexOf(_e) >= 0) && ($[_e] = a[_e]);
  return $;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(a) {
    for (var s = 1; s < arguments.length; s++) {
      var $ = arguments[s];
      for (var _ in $)
        Object.prototype.hasOwnProperty.call($, _) && (a[_] = $[_]);
    }
    return a;
  }, _extends.apply(this, arguments);
}
var SCROLLEVT_NULL = 0, SCROLLEVT_INIT = 1, SCROLLEVT_RECOMPUTE = 2, SCROLLEVT_NATIVE = 8, SCROLLEVT_BY_HOOK = 64, TOP_CONTINUE = 0, TOP_DONE = 1, e_VT_STATE;
(function(a) {
  a[a.INIT = 1] = "INIT", a[a.LOADED = 2] = "LOADED", a[a.RUNNING = 4] = "RUNNING";
})(e_VT_STATE || (e_VT_STATE = {}));
function default_context() {
  return {
    vt_state: e_VT_STATE.INIT,
    possible_hight_per_tr: -1,
    computed_h: 0,
    re_computed: 0,
    row_height: [],
    row_count: 0,
    prev_row_count: 0,
    _offset_top: 0,
    _offset_head: 0,
    _offset_tail: 1,
    WH: 0,
    // the wrapper's height
    top: 0,
    left: 0,
    evt: SCROLLEVT_NULL,
    end: !1,
    final_top: 0,
    f_final_top: TOP_DONE,
    update_count: 0,
    indexMap: /* @__PURE__ */ new WeakMap(),
    HND_PAINT: 0,
    retry_count: 5
  };
}
function log_debug(a, s) {
  if (a.debug) {
    if (s[0] === "+")
      return console.debug(s.slice(1));
    var $ = /* @__PURE__ */ new Date(), _ = "".concat($.toLocaleTimeString(), ".").concat($.getMilliseconds());
    console.debug("%c[".concat(a.id, "][").concat(_, "][").concat(s, "]"), "color:#a00", a);
  }
}
var TableImpl = /* @__PURE__ */ reactExports.forwardRef(function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement("table", _extends({
    ref: $
  }, s));
});
function WrapperImpl(a) {
  return /* @__PURE__ */ reactExports.createElement("tbody", a);
}
var RowImpl = /* @__PURE__ */ reactExports.forwardRef(function a(s, $) {
  return /* @__PURE__ */ reactExports.createElement("tr", _extends({
    ref: $
  }, s));
});
function scroll_with_offset(a, s) {
  var $ = a.row_height, _ = a.row_count, _e = a.overscanRowCount;
  a._scroll_y = a.scroll.y, typeof a._scroll_y == "number" ? a._y = a._scroll_y : (typeof a._scroll_y == "string" || console.assert(!1, "VT: did you forget to set `scroll.y`?"), a._y = a.wrap_inst.current.parentElement.offsetHeight), console.assert(a._y >= 0);
  var tt = 0, nt = 0, at = 0, ot = 0;
  if (s === -1 && _ > 0) {
    for (nt = _; nt > 0 && ot < a._y; )
      ot += $[--nt];
    return [0 | nt, 0 | _, 0 | a.computed_h - ot];
  }
  for (; nt < _ && tt < s; ++nt)
    tt += $[nt];
  for (at = nt; at < _ && ot < a._y; ++at)
    ot += $[at];
  for (var rt = _e < 0 ? 0 : _e; nt > 0 && rt--; )
    tt -= $[--nt];
  return at += _e, at > _ && (at = _), [0 | nt, 0 | at, 0 | tt];
}
function set_offset(a, s, $, _) {
  a._offset_top = 0 | s, a._offset_head = 0 | $, a._offset_tail = 0 | _;
}
function set_scroll(a, s, $, _, _e) {
  a.top = s, a.left = $, a.evt = _, a.end = _e;
}
function scroll_to(a, s, $) {
  if (a.wrap_inst.current) {
    var _ = a.wrap_inst.current.parentElement;
    _.scrollTop = s, _.scrollLeft = Math.max($, _.scrollLeft);
  }
}
function repainting(a) {
  if (!a.HND_PAINT) {
    var s = a.cq, $ = a.wrap_inst, _ = function() {
      a.HND_PAINT = 0;
      for (var tt = 0; tt < s.length; ++tt)
        s[tt].index >= a._offset_head && s[tt].index < a._offset_tail && s[tt].func();
      if (!(a.vt_state !== e_VT_STATE.RUNNING || !$.current)) {
        var nt = a.computed_h;
        if (a.WH !== nt) {
          a.WH = nt;
          var at = $.current.style;
          at.height = nt ? (at.maxHeight = nt + "px", at.maxHeight) : (at.maxHeight = "unset", at.maxHeight), a.on_update_wrap_style();
        }
      }
    };
    a.HND_PAINT = a.evt === SCROLLEVT_NATIVE ? window.requestAnimationFrame(_) : window.setTimeout(_);
  }
}
function srs_expand(a, s, $, _) {
  var _e = s - $, tt = new Array(_e).fill(_);
  a.row_height = a.row_height.concat(tt), a.computed_h += _e * _;
}
function srs_shrink(a, s, $) {
  if (s === 0) {
    a.computed_h = 0, a.row_height.length = 0, a.top = 0;
    return;
  }
  for (var _ = a.row_height, _e = 0, tt = s; tt < $; ++tt)
    _e += _[tt];
  a.computed_h -= _e;
}
function set_tr_cnt(a, s) {
  a.re_computed = s - a.row_count, a.prev_row_count = a.row_count, a.row_count = s;
}
var VTable = function a(s, $) {
  var _ = s.style, _e = s.context, tt = _objectWithoutProperties(s, _excluded), nt = reactExports.useState(0), at = reactExports.useRef(function() {
  }), ot, rt = reactExports.useMemo(function() {
    return /* @__PURE__ */ reactExports.createRef();
  }, []), st = reactExports.useContext(_e);
  reactExports.useMemo(function() {
    Object.assign(st, default_context()), st.wrap_inst && st.wrap_inst.current && st.wrap_inst.current.parentElement.removeEventListener("scroll", ot), st.wrap_inst = rt, st.top = st.initTop, st.on_update_wrap_style = function() {
      st._y === 0 && "".concat(st._scroll_y).length && ot({
        flag: SCROLLEVT_BY_HOOK,
        target: {
          scrollTop: st.top,
          scrollLeft: st.left
        }
      });
    }, st.cq = [];
    var dt = 0, gt = 0;
    st.cq.push = function(pt) {
      if (st.vt_state === e_VT_STATE.RUNNING) {
        var mt = st._offset_tail - st._offset_head + st.overscanRowCount * 2 + 10;
        return gt = Math.max(gt, mt), dt > gt && (dt = 0), st.cq[dt++] = pt, 0;
      }
    };
  }, []);
  var lt = reactExports.useRef([]).current, et;
  ot = reactExports.useCallback(function(dt) {
    if (st.vt_state === e_VT_STATE.RUNNING) {
      var gt = performance.now();
      if (dt) {
        if ("flag" in dt)
          lt.push(dt);
        else {
          var pt = dt.target, mt = Math.max(pt.scrollTop, 0);
          lt.push({
            target: {
              scrollTop: mt,
              scrollLeft: pt.scrollLeft
            },
            end: Math.abs(pt.scrollHeight - pt.clientHeight - Math.round(mt)) <= (st.offset || 0),
            flag: SCROLLEVT_NATIVE
          });
        }
        if (st.f_final_top === TOP_CONTINUE)
          return et(gt);
      }
      st.HND_RAF || (st.HND_RAF = window.setTimeout(function() {
        return Promise.resolve().then(function() {
          return et(gt);
        });
      }));
    }
  }, []), et = reactExports.useCallback(function(dt) {
    st.HND_RAF = 0;
    var gt = performance.now();
    if (gt - dt > 10 && st.retry_count-- > 0) {
      ot();
      return;
    }
    if (st.retry_count = 5, st.vt_state === e_VT_STATE.RUNNING) {
      var pt = lt, mt;
      if (pt.length) {
        mt = pt.pop(), pt.length = 0;
        var ct = mt.target.scrollTop, vt = mt.target.scrollLeft, At = mt.flag;
        log_debug(st, "top: ".concat(ct, ", left: ").concat(vt));
        var xt = scroll_with_offset(st, st.f_final_top === TOP_CONTINUE ? st.final_top : ct), bt = xt[0], Et = xt[1], St = xt[2], Bt = st._offset_head, Ot = st._offset_tail, Pt = st._offset_top, wt = !1;
        switch (At) {
          case SCROLLEVT_INIT:
            log_debug(st, "SCROLLEVT_INIT");
            break;
          case SCROLLEVT_BY_HOOK:
            log_debug(st, "SCROLLEVT_BY_HOOK"), bt === Bt && Et === Ot && St === Pt ? (st.f_final_top = TOP_DONE, st.final_top === -1 && (ct = st.computed_h - st._y), wt = !0) : st.final_top === -1 && (ct = St);
            break;
          case SCROLLEVT_RECOMPUTE:
            if (bt === Bt && Et === Ot && St === Pt)
              return;
            log_debug(st, "SCROLLEVT_RECOMPUTE");
            break;
          case SCROLLEVT_NATIVE:
            if (bt === Bt && Et === Ot && St === Pt)
              return;
            log_debug(st, "SCROLLEVT_NATIVE"), st.onScroll && st.onScroll({
              top: ct,
              left: vt,
              isEnd: mt.end
            }), wt = mt.end;
            break;
        }
        set_offset(st, St, bt, Et), set_scroll(st, ct, vt, At, wt), nt[1](++st.update_count);
      }
    }
  }, []), reactExports.useImperativeHandle($, function() {
    var dt = function(pt) {
      st.f_final_top = TOP_CONTINUE, st.final_top = pt, ot({
        target: {
          scrollTop: pt,
          scrollLeft: -1
        },
        flag: SCROLLEVT_BY_HOOK
      });
    };
    return {
      scrollTo: function(pt) {
        at.current = function() {
          return dt(pt);
        }, at.current();
      },
      scrollToIndex: function(pt) {
        at.current = function() {
          pt > st.row_count - 1 && (pt = st.row_count - 1), pt < 0 && (pt = 0);
          for (var mt = 0, ct = 0; ct < pt; ++ct)
            mt += st.row_height[ct];
          dt(mt);
        }, at.current();
      }
    };
  }, []), reactExports.useEffect(function() {
    var dt = rt.current.parentElement;
    try {
      dt.addEventListener("scroll", ot, {
        passive: !0
      });
    } catch {
      dt.addEventListener("scroll", ot, !1);
    }
  }, [rt.current]), reactExports.useEffect(function() {
    ot({
      flag: SCROLLEVT_BY_HOOK,
      target: {
        scrollLeft: st.left,
        scrollTop: st.top
      }
    });
  }, [st.scroll.y]), reactExports.useEffect(function() {
    switch (st.evt) {
      case SCROLLEVT_BY_HOOK:
        st.f_final_top === TOP_CONTINUE ? at.current() : scroll_to(st, st.top, st.left);
        break;
      case SCROLLEVT_INIT:
      case SCROLLEVT_RECOMPUTE:
        scroll_to(st, st.top, st.left);
        break;
    }
  }, [
    nt[0]
    /* for performance. */
  ]), reactExports.useEffect(function() {
    switch (st.vt_state) {
      case e_VT_STATE.LOADED:
        st.vt_state = e_VT_STATE.RUNNING, ot({
          target: {
            scrollTop: st.top,
            scrollLeft: 0
          },
          flag: SCROLLEVT_BY_HOOK
        });
        break;
      case e_VT_STATE.RUNNING:
        st.re_computed !== 0 && (st.re_computed = 0, ot({
          target: {
            scrollTop: st.top,
            scrollLeft: st.left
          },
          flag: SCROLLEVT_RECOMPUTE
        }));
        break;
    }
  });
  var it = reactExports.useMemo(function() {
    return {
      width: _.width,
      minWidth: "100%",
      position: "relative",
      transform: "translate(0)"
    };
  }, [_.width]), ut = reactExports.useMemo(function() {
    return _objectSpread(_objectSpread({}, _), {}, {
      width: void 0,
      position: "relative",
      top: st._offset_top,
      transform: "translate(0)"
    });
  }, [st._offset_top]), ft = reactExports.useMemo(function() {
    return _objectSpread({}, st);
  }, [st.update_count]), ht = st.components.table;
  return /* @__PURE__ */ reactExports.createElement("div", {
    ref: rt,
    style: it
  }, /* @__PURE__ */ reactExports.createElement(_e.Provider, {
    value: ft
  }, /* @__PURE__ */ reactExports.createElement(ht, _extends({}, tt, {
    style: ut
  }))));
}, VWrapper = function a(s) {
  var $ = s.children, _ = s.className, _e = s.ctx, tt = $[0], nt = $[1], at = Array.isArray(nt) ? nt.length : 0, ot = _e._offset_head, rt = _e._offset_tail, st = [];
  switch (_e.vt_state) {
    case e_VT_STATE.INIT:
      at >= 0 && (console.assert(ot === 0), console.assert(rt === 1), Array.isArray(nt) ? (st = nt.slice(ot, rt), _e.indexMap.set(st[0].props.record, 0)) : st = nt, _e.re_computed = at, _e.prev_row_count = at, _e.row_count = at);
      break;
    case e_VT_STATE.RUNNING:
      {
        if (rt > at) {
          var lt = rt - at;
          rt -= lt, ot -= lt, ot < 0 && (ot = 0), rt < 0 && (rt = 0), set_offset(_e, _e._offset_top, ot, rt);
        }
        _e.row_count !== at && set_tr_cnt(_e, at), at = _e.row_count;
        var et = _e.prev_row_count;
        if (at < et)
          srs_shrink(_e, at, et);
        else if (at > et) {
          var it = _e.row_height;
          at - it.length > 0 ? srs_expand(_e, at, et, _e.possible_hight_per_tr) : (it.fill(_e.possible_hight_per_tr, et, at), _e.computed_h += _e.possible_hight_per_tr * (at - et));
        }
        if (at) {
          var ut = ot;
          st = nt.slice(ut, rt), st.forEach(function(ht) {
            return _e.indexMap.set(ht.props.record, ut++);
          });
        } else
          st = nt;
        _e.prev_row_count = _e.row_count;
      }
      break;
    case e_VT_STATE.LOADED:
      console.assert(!1);
      break;
  }
  var ft = _e.components.body.wrapper;
  return /* @__PURE__ */ reactExports.createElement(ft, {
    className: _
  }, tt, st);
}, VTRow = function a(s) {
  var $ = /* @__PURE__ */ reactExports.createRef(), _ = s.ctx, _e = _objectWithoutProperties(s, _excluded2), tt = s.children, nt = _.components.body.row;
  if (!Array.isArray(tt))
    return /* @__PURE__ */ reactExports.createElement(nt, _e, tt);
  var at = tt[0].props, ot = _.indexMap.get(at.record), rt = reactExports.useRef(ot), st = reactExports.useMemo(function() {
    return ".".concat(at.prefixCls, "-expanded-row");
  }, [at.prefixCls]), lt = performance.now();
  return reactExports.useLayoutEffect(function() {
    var et = performance.now();
    return log_debug(_, "+idx ".concat(ot, " tooks ").concat(et - lt, " ms")), _.vt_state === e_VT_STATE.RUNNING ? repainting(_) : (_.possible_hight_per_tr = $.current.offsetHeight, srs_expand(_, _.row_count, 0, _.possible_hight_per_tr), repainting(_), _.vt_state = e_VT_STATE.LOADED), function() {
      repainting(_);
    };
  }, []), reactExports.useEffect(function() {
    _.cq.push({
      index: ot,
      func: function() {
        var it = $.current;
        if (it) {
          for (var ut = it.offsetHeight, ft = it.nextSibling; ft && ft.matches(st); )
            ut += ft.offsetHeight, ft = ft.nextSibling;
          var ht = _.row_height[ot], dt = _.row_height[rt.current];
          _.computed_h -= ht, _.computed_h += dt, _.computed_h += ut - dt, _.row_height[ot] = ut;
        }
      }
    }), repainting(_);
  }), /* @__PURE__ */ reactExports.createElement(nt, _extends({}, _e, {
    ref: $
  }));
};
function _set_components(a, s) {
  var $ = s.table, _ = s.body, _e = s.header;
  a.components.body = _objectSpread(_objectSpread({}, a.components.body), _), _ && _.cell && (a._vtcomponents.body.cell = _.cell), _e && (a.components.header = _e, a._vtcomponents.header = _e), $ && (a.components.table = $);
}
function init(a, s) {
  var $ = reactExports.useRef(/* @__PURE__ */ reactExports.createContext({})).current, _ = reactExports.useContext($), _e = reactExports.useRef({
    scrollTo: function(nt) {
    },
    scrollToIndex: function(nt) {
    }
  });
  return reactExports.useMemo(function() {
    return Object.assign(_, {
      id: (+/* @__PURE__ */ new Date()).toString(36).slice(4),
      initTop: 0,
      overscanRowCount: 5,
      debug: !1,
      ref: _e
    }, a());
  }, s), reactExports.useMemo(function() {
    var tt = /* @__PURE__ */ reactExports.forwardRef(VTable);
    _._vtcomponents = {
      table: function(at) {
        return /* @__PURE__ */ reactExports.createElement(tt, _extends({}, at, {
          context: $,
          ref: _.ref
        }));
      },
      body: {
        // https://github.com/react-component/table/blob/master/src/Body/index.tsx#L114
        wrapper: function(at) {
          return /* @__PURE__ */ reactExports.createElement($.Consumer, null, function() {
            return /* @__PURE__ */ reactExports.createElement(VWrapper, _extends({}, at, {
              ctx: _
            }));
          });
        },
        row: function(at) {
          return /* @__PURE__ */ reactExports.createElement(VTRow, _extends({}, at, {
            ctx: _
          }));
        }
      }
    }, _.components = {}, _set_components(_, {
      table: TableImpl,
      body: {
        wrapper: WrapperImpl,
        row: RowImpl
      }
    }), _.vt_state = e_VT_STATE.INIT;
  }, []), _;
}
function _typeof$2(a) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$2(a);
}
var _brower = 1, _node = 2;
(function() {
  var a = (typeof window > "u" ? "undefined" : _typeof$2(window)) === "object" && window instanceof Window ? _brower : _node;
  if (a & _brower && !Object.hasOwnProperty.call(window, "requestAnimationFrame") && !window.requestAnimationFrame)
    throw new Error("Please using the modern browers or appropriate polyfill!");
})();
function useVT(a, s) {
  var $ = init(a, s || []);
  return [$._vtcomponents, function(_) {
    return _set_components($, _);
  }, $.ref];
}
function _typeof$1(a) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$1(a);
}
function _toConsumableArray$1(a) {
  return _arrayWithoutHoles$1(a) || _iterableToArray$1(a) || _unsupportedIterableToArray$3(a) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$1(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles$1(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$3(a);
}
function _defineProperty$1(a, s, $) {
  return s = _toPropertyKey$1(s), s in a ? Object.defineProperty(a, s, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = $, a;
}
function _toPropertyKey$1(a) {
  var s = _toPrimitive$1(a, "string");
  return _typeof$1(s) === "symbol" ? s : String(s);
}
function _toPrimitive$1(a, s) {
  if (_typeof$1(a) !== "object" || a === null)
    return a;
  var $ = a[Symbol.toPrimitive];
  if ($ !== void 0) {
    var _ = $.call(a, s || "default");
    if (_typeof$1(_) !== "object")
      return _;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
function _slicedToArray$3(a, s) {
  return _arrayWithHoles$3(a) || _iterableToArrayLimit$3(a, s) || _unsupportedIterableToArray$3(a, s) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$3(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$3(a, s);
  }
}
function _arrayLikeToArray$3(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$3(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$3(a) {
  if (Array.isArray(a))
    return a;
}
var getTooltip = function a(s) {
  if (s)
    return typeof s == "string" ? {
      title: /* @__PURE__ */ React$a.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s
        }
      })
    } : Object.assign(Object.assign({}, s), {
      title: /* @__PURE__ */ React$a.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: s.title
        }
      })
    });
}, VirtualList = function a(s) {
  var $, _, _e = s.form, tt = s.schema, nt = s.fields, at = s.rootPath, ot = s.renderCore, rt = s.readOnly, st = s.operateBtnType, lt = s.addBtnProps, et = s.delConfirmProps, it = s.copyBtnProps, ut = s.deleteBtnProps, ft = s.moveUpBtnProps, ht = s.moveDownBtnProps, dt = s.actionColumnProps, gt = s.scrollY, pt = gt === void 0 ? 600 : gt, mt = s.hideDelete, ct = s.hideCopy, vt = s.hideMove, At = s.hideAdd, xt = s.hideOperate, bt = s.addItem, Et = s.copyItem, St = s.moveItem, Bt = s.removeItem, Ot = s.configContext, Pt = s.validatePopover, wt = Ot.globalConfig, Ct = ($ = Pt ?? (wt == null ? void 0 : wt.listValidatePopover)) !== null && $ !== void 0 ? $ : !0, It = dt.colHeaderText, yt = __rest$3(dt, ["colHeaderText"]), Rt = ((_ = tt == null ? void 0 : tt.items) === null || _ === void 0 ? void 0 : _.properties) || {}, kt = useVT(function() {
    return {
      scroll: {
        y: pt
      }
    };
  }, []), jt = _slicedToArray$3(kt, 2), Ht = jt[0];
  jt[1];
  var Ft = function(Mt) {
    var Lt = _e.getFieldValue(at.concat(Mt));
    Et(Lt);
  }, _t = sortProperties(Object.entries(Rt)).map(function(Nt) {
    var Mt = _slicedToArray$3(Nt, 2), Lt = Mt[0], $t = Mt[1], Tt = $t.required, Dt = $t.title, Ut = $t.width, Vt = $t.tooltip, Qt = getTooltip(Vt);
    return {
      dataIndex: Lt,
      width: Ut,
      title: /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, Tt && /* @__PURE__ */ React$a.createElement("span", {
        style: {
          color: "red",
          marginRight: "3px"
        }
      }, "*"), /* @__PURE__ */ React$a.createElement("span", null, Dt), Qt && /* @__PURE__ */ React$a.createElement(_Tooltip, Object.assign({
        placement: "top"
      }, Qt), /* @__PURE__ */ React$a.createElement(default_1, {
        style: {
          marginLeft: 6
        }
      }))),
      render: function(Zt, ar) {
        var Jt = {
          type: "object",
          properties: _defineProperty$1({}, Lt, Object.assign(Object.assign({}, Rt[Lt]), {
            fieldCol: 24
          }))
        };
        return Ct ? /* @__PURE__ */ React$a.createElement(VirtualCell, {
          renderCore: ot,
          schema: Jt,
          parentPath: [ar.name],
          rootPath: [].concat(_toConsumableArray$1(at), [ar.name]),
          dataIndex: Lt
        }) : /* @__PURE__ */ React$a.createElement("div", {
          className: "fr-table-cell-content"
        }, ot({
          parentPath: [ar.name],
          rootPath: [].concat(_toConsumableArray$1(at), [ar.name]),
          schema: Jt
        }));
      }
    };
  });
  return !rt && !xt && _t.push(Object.assign(Object.assign({
    title: It,
    width: "190px",
    fixed: "right"
  }, yt), {
    render: function(Mt, Lt) {
      return /* @__PURE__ */ React$a.createElement(Form$3.Item, null, /* @__PURE__ */ React$a.createElement(_Space, {
        className: "fr-list-item-operate",
        split: st !== "icon" && /* @__PURE__ */ React$a.createElement(Divider$1, {
          type: "vertical"
        })
      }, !vt && /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        disabled: Lt.name === 0,
        onClick: function() {
          return St(Lt.name, Lt.name - 1);
        },
        icon: /* @__PURE__ */ React$a.createElement(default_1$1, null)
      }, ft)), /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        disabled: Lt.name === nt.length - 1,
        onClick: function() {
          return St(Lt.name, Lt.name + 1);
        },
        icon: /* @__PURE__ */ React$a.createElement(default_1$2, null)
      }, ht))), !mt && /* @__PURE__ */ React$a.createElement(_Popconfirm, Object.assign({
        onConfirm: function() {
          return Bt(Lt.name);
        }
      }, et), /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        icon: /* @__PURE__ */ React$a.createElement(default_1$3, null),
        btnType: st
      }, ut))), !ct && /* @__PURE__ */ React$a.createElement(HeaderTitle, Object.assign({
        onClick: function() {
          return Ft(Lt.name);
        },
        icon: /* @__PURE__ */ React$a.createElement(default_1$4, null)
      }, it))));
    }
  })), /* @__PURE__ */ React$a.createElement(React$a.Fragment, null, /* @__PURE__ */ React$a.createElement(Table$1, {
    className: classnames("fr-virtual-list", {
      "fr-virtual-list-no-popover": !Ct
    }),
    size: "middle",
    columns: _t,
    dataSource: nt,
    pagination: !1,
    scroll: {
      y: pt
    },
    components: Ht
  }), (!tt.max || nt.length < tt.max) && !At && /* @__PURE__ */ React$a.createElement(Button$2, Object.assign({
    icon: /* @__PURE__ */ React$a.createElement(default_1$5, null),
    onClick: function() {
      return bt();
    }
  }, lt)));
};
function _slicedToArray$2(a, s) {
  return _arrayWithHoles$2(a) || _iterableToArrayLimit$2(a, s) || _unsupportedIterableToArray$2(a, s) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$2(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$2(a) {
  if (Array.isArray(a))
    return a;
}
function _toConsumableArray(a) {
  return _arrayWithoutHoles(a) || _iterableToArray(a) || _unsupportedIterableToArray$2(a) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$2(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$2(a, s);
  }
}
function _iterableToArray(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function _arrayWithoutHoles(a) {
  if (Array.isArray(a))
    return _arrayLikeToArray$2(a);
}
function _arrayLikeToArray$2(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
var TabPaneContent = function a(s) {
  var $ = s.renderCore, _ = s.name, _e = s.schema, tt = s.rootPath;
  return reactExports.useMemo(function() {
    return /* @__PURE__ */ React$a.createElement("div", {
      style: {
        flex: 1
      }
    }, $({
      schema: _e,
      parentPath: [_],
      rootPath: [].concat(_toConsumableArray(tt), [_])
    }));
  }, [JSON.stringify(s)]);
}, TabList = function a(s) {
  var $ = s.schema, _ = s.fields, _e = s.rootPath, tt = s.renderCore, nt = s.readOnly, at = s.delConfirmProps, ot = s.tabName, rt = s.hideDelete, st = s.hideAdd, lt = s.addItem, et = s.removeItem, it = s.tabItemProps, ut = it === void 0 ? {} : it, ft = s.activeKey, ht = __rest$3(s, ["schema", "fields", "rootPath", "renderCore", "readOnly", "delConfirmProps", "tabName", "hideDelete", "hideAdd", "addItem", "removeItem", "tabItemProps", "activeKey"]), dt = reactExports.useState("0"), gt = _slicedToArray$2(dt, 2), pt = gt[0], mt = gt[1], ct = reactExports.useContext(ThemeConfigProvider.ConfigContext), vt = translation(ct);
  reactExports.useEffect(function() {
    mt(ft || "0");
  }, [ft]);
  var At = function(Bt) {
    return ot instanceof Array ? ot[Bt] || Bt + 1 : "".concat(ot || vt("item"), " ").concat(Bt + 1);
  }, xt = function(Bt) {
    et(Bt), mt("".concat(Bt > 1 ? Bt - 1 : 0));
  }, bt = function(Bt, Ot) {
    if (Ot === "add" && (!$.max || _.length < $.max) && !nt && !st) {
      lt();
      var Pt = _.length;
      mt("".concat(Pt));
    }
  }, Et = function(Bt) {
    return !nt && !rt ? /* @__PURE__ */ React$a.createElement(_Popconfirm, Object.assign({
      onConfirm: function() {
        return xt(Bt);
      }
    }, at), /* @__PURE__ */ React$a.createElement(default_1$3, null)) : /* @__PURE__ */ React$a.createElement(React$a.Fragment, null);
  };
  return /* @__PURE__ */ React$a.createElement(_Tabs, Object.assign({
    className: "fr-tab-list",
    type: "editable-card"
  }, ht, {
    onChange: mt,
    activeKey: "".concat(pt),
    onEdit: bt,
    hideAdd: nt || st
  }), _.map(function(St) {
    var Bt = St.key, Ot = St.name;
    return /* @__PURE__ */ React$a.createElement(_Tabs.TabPane, Object.assign({
      key: Bt,
      className: "fr-list-item"
    }, ut, {
      tab: At(Ot),
      closeIcon: Et(Ot)
    }), /* @__PURE__ */ React$a.createElement(TabPaneContent, {
      name: Ot,
      rootPath: _e,
      schema: $,
      renderCore: tt
    }));
  }));
};
function _typeof(a) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof(a);
}
function _defineProperty(a, s, $) {
  return s = _toPropertyKey(s), s in a ? Object.defineProperty(a, s, { value: $, enumerable: !0, configurable: !0, writable: !0 }) : a[s] = $, a;
}
function _toPropertyKey(a) {
  var s = _toPrimitive(a, "string");
  return _typeof(s) === "symbol" ? s : String(s);
}
function _toPrimitive(a, s) {
  if (_typeof(a) !== "object" || a === null)
    return a;
  var $ = a[Symbol.toPrimitive];
  if ($ !== void 0) {
    var _ = $.call(a, s || "default");
    if (_typeof(_) !== "object")
      return _;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(a);
}
const index = function(a) {
  var s = a.schema;
  return /* @__PURE__ */ React$a.createElement("div", {
    className: classnames("fr-void-title", _defineProperty({}, s == null ? void 0 : s.className, !!(s != null && s.className)))
  }, s.title);
};
var ErrorSchema = function a(s) {
  var $ = reactExports.useContext(ThemeConfigProvider.ConfigContext), _ = translation($);
  return /* @__PURE__ */ React$a.createElement("div", null, /* @__PURE__ */ React$a.createElement("div", {
    style: {
      color: "red"
    }
  }, _("schema_not_match")), /* @__PURE__ */ React$a.createElement("div", null, JSON.stringify(s)));
};
const defaultWidgets = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Card: BoxCard,
  CardList,
  Checkbox,
  Checkboxes: Checkboxes$1,
  Collapse: BoxCollapse,
  Color,
  DatePicker,
  DateRange: DateRange$1,
  DrawerList: TableList,
  ErrorSchema,
  Html: html,
  ImageInput: ImageInput$1,
  Input,
  InputNumber,
  LineTitle: FLineTitle,
  MultiSelect,
  PercentSlider,
  Radio,
  Rate: index$2,
  Select: MultiSelect,
  SimpleList,
  Slider,
  SubInline: BoxSubInline,
  Switch,
  TabList,
  TableList: TableList$1,
  TextArea: TextArea$1,
  TimePicker,
  TimeRange,
  TreeSelect,
  Upload: FrUpload,
  UrlInput: UrlInput$1,
  VirtualList,
  VoidTitle: index
}, Symbol.toStringTag, { value: "Module" }));
function _slicedToArray$1(a, s) {
  return _arrayWithHoles$1(a) || _iterableToArrayLimit$1(a, s) || _unsupportedIterableToArray$1(a, s) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray$1(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray$1(a, s);
  }
}
function _arrayLikeToArray$1(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit$1(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles$1(a) {
  if (Array.isArray(a))
    return a;
}
function flattenSchema() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 ? arguments[1] : void 0, $ = arguments.length > 2 ? arguments[2] : void 0, _ = arguments.length > 3 ? arguments[3] : void 0, _e = _ || {}, tt = _cloneDeep(a) || {}, nt = s || "#";
  tt.$id || (tt.$id = nt);
  var at = [];
  return isObjType(tt) && (sortProperties(Object.entries(tt.properties)).forEach(function(ot) {
    var rt = _slicedToArray$1(ot, 2), st = rt[0], lt = rt[1], et = isListType(lt) ? st + "[]" : st, it = nt === "#" ? et : nt + "." + et;
    at.push(it), flattenSchema(lt, it, nt, _e);
  }), tt.properties = {}), isListType(tt) && (sortProperties(Object.entries(tt.items.properties)).forEach(function(ot) {
    var rt = _slicedToArray$1(ot, 2), st = rt[0], lt = rt[1], et = isListType(lt) ? st + "[]" : st, it = nt === "#" ? et : nt + "." + et;
    at.push(it), flattenSchema(lt, it, nt, _e);
  }), tt.items.properties = {}), tt.type && (_e[nt] = {
    parent: $,
    schema: tt,
    children: at
  }), _e;
}
function _slicedToArray(a, s) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, s) || _unsupportedIterableToArray(a, s) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(a, s) {
  if (a) {
    if (typeof a == "string")
      return _arrayLikeToArray(a, s);
    var $ = Object.prototype.toString.call(a).slice(8, -1);
    if ($ === "Object" && a.constructor && ($ = a.constructor.name), $ === "Map" || $ === "Set")
      return Array.from(a);
    if ($ === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test($))
      return _arrayLikeToArray(a, s);
  }
}
function _arrayLikeToArray(a, s) {
  (s == null || s > a.length) && (s = a.length);
  for (var $ = 0, _ = new Array(s); $ < s; $++)
    _[$] = a[$];
  return _;
}
function _iterableToArrayLimit(a, s) {
  var $ = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if ($ != null) {
    var _, _e, tt, nt, at = [], ot = !0, rt = !1;
    try {
      if (tt = ($ = $.call(a)).next, s === 0) {
        if (Object($) !== $)
          return;
        ot = !1;
      } else
        for (; !(ot = (_ = tt.call($)).done) && (at.push(_.value), at.length !== s); ot = !0)
          ;
    } catch (st) {
      rt = !0, _e = st;
    } finally {
      try {
        if (!ot && $.return != null && (nt = $.return(), Object(nt) !== nt))
          return;
      } finally {
        if (rt)
          throw _e;
      }
    }
    return at;
  }
}
function _arrayWithHoles(a) {
  if (Array.isArray(a))
    return a;
}
var updateSchemaByPath = function a(s, $, _) {
  var _e = getSchemaFullPath(s, _), tt = _get(_, _e, {}), nt = isFunction$2($) ? $(tt) : $, at = Object.assign(Object.assign({}, tt), nt);
  nt.props && (at.props = Object.assign(Object.assign({}, tt == null ? void 0 : tt.props), nt.props)), _set(_, _e, at);
}, getFieldName = function a(s) {
  if (s) {
    if (typeof s == "boolean")
      return s;
    var $ = [];
    return isArray$3(s) && ($ = s.map(function(_) {
      return _.split(".").map(function(_e) {
        return isNaN(Number(_e)) ? _e : _e * 1;
      });
    })), $ = s.split(".").map(function(_) {
      return isNaN(Number(_)) ? _ : _ * 1;
    }), $ = $.map(function(_) {
      return typeof _ == "string" && (_ == null ? void 0 : _.indexOf("[")) === 0 && (_ == null ? void 0 : _.indexOf("]")) === (_ == null ? void 0 : _.length) - 1 ? Number(_.substring(1, _.length - 1)) : _;
    }), $;
  }
}, useForm = function a() {
  var s = Form$3.useForm(), $ = _slicedToArray(s, 1), _ = $[0], _e = reactExports.useRef({}), tt = reactExports.useRef(), nt = reactExports.useRef({}), at = reactExports.useRef({});
  _.getFieldError;
  var ot = _.getFieldsError, rt = _.getFieldInstance, st = _.setFieldsValue, lt = _.setFields, et = _.scrollToField, it = _.isFieldsTouched, ut = _.isFieldTouched, ft = _.isFieldValidating, ht = _.resetFields, dt = _.validateFields, gt = __rest$3(_, ["getFieldError", "getFieldsError", "getFieldInstance", "setFieldsValue", "setFields", "scrollToField", "isFieldsTouched", "isFieldTouched", "isFieldValidating", "resetFields", "validateFields"]), pt = gt, mt = function(At) {
    var xt = tt.current.setState;
    xt || setTimeout(function() {
      xt({
        schema: nt.current,
        flattenSchema: _e.current
      });
    }, 0), xt(At);
  }, ct = function(At) {
    _e.current = flattenSchema(At) || {}, nt.current = At, mt({
      schema: At,
      flattenSchema: _e.current
    });
  };
  return pt.setSchema = function(vt) {
    var At = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (isObject$6(vt)) {
      if (At) {
        ct(vt);
        return;
      }
      var xt = cloneDeep(nt.current);
      Object.keys(vt || {}).forEach(function(bt) {
        updateSchemaByPath(bt, vt[bt], xt);
      }), ct(xt);
    }
  }, pt.setSchemaByPath = function(vt, At) {
    if (!(!hasFuncProperty(At) && _isMatch(At, pt.getSchemaByPath(vt)))) {
      var xt = cloneDeep(nt.current);
      updateSchemaByPath(vt, At, xt), ct(xt);
    }
  }, pt.setValues = function(vt) {
    var At = parseBindToValues(vt, _e.current);
    st(At);
  }, pt.getValues = function(vt, At) {
    var xt, bt = cloneDeep(_.getFieldsValue(getFieldName(vt), At)), Et = ((xt = tt.current) === null || xt === void 0 ? void 0 : xt.getState()) || {}, St = Et.removeHiddenData;
    return St && (bt = filterValuesHidden(bt, _e.current)), bt = filterValuesUndefined(bt), parseValuesToBind(bt, _e.current);
  }, pt.getValueByPath = function(vt) {
    var At = getFieldName(vt);
    return _.getFieldValue(At);
  }, pt.setValueByPath = function(vt, At) {
    if (!_.setFieldValue) {
      var xt = _.getFieldsValue();
      _set(xt, vt, At), pt.setValues(xt);
      return;
    }
    var bt = getFieldName(vt);
    _.setFieldValue(bt, At);
    try {
      JSON.stringify(_.getFieldValue(bt)) !== JSON.stringify(At) && _.setFieldValue(bt, At);
    } catch {
    }
  }, pt.getSchemaByPath = function(vt) {
    typeof vt != "string" && console.warn("请输入正确的路径");
    var At = getSchemaFullPath(vt, nt.current);
    return _get(nt.current, At);
  }, pt.getSchema = function() {
    return nt.current;
  }, pt.setErrorFields = function(vt) {
    var At = transformFieldsData(vt, getFieldName);
    At && lt(At);
  }, pt.removeErrorField = function(vt) {
    lt([{
      name: getFieldName(vt),
      errors: []
    }]);
  }, pt.getFieldError = function(vt) {
    var At = getFieldName(vt);
    return _.getFieldError(At);
  }, pt.getFieldsError = function(vt) {
    var At = getFieldName(vt);
    return ot(At);
  }, pt.getFieldInstance = function(vt) {
    var At = getFieldName(vt);
    return rt(At);
  }, pt.getHiddenValues = function() {
    var vt = pt.getValues(), At = pt.getValues(!0), xt = {}, bt = function Et(St, Bt, Ot) {
      Object.keys(St).forEach(function(Pt) {
        var wt = St[Pt], Ct = Ot ? "".concat(Ot, ".").concat(Pt) : Pt;
        if (!Bt.hasOwnProperty(Pt)) {
          _set(xt, Ct, wt);
          return;
        }
        isObject$6(wt) && Et(wt, Bt[Pt], Ct), isArray$3(wt) && wt.map(function(It, yt) {
          Et(It, _get(Bt, "".concat(Pt, "[").concat(yt, "]"), []), "".concat(Ct, "[").concat(yt, "]"));
        });
      });
    };
    return bt(At, vt, null), xt;
  }, pt.setFields = function(vt) {
    var At = transformFieldsData(vt, getFieldName);
    At && lt(At);
  }, pt.__initStore = function(vt) {
    tt.current = vt;
  }, pt.scrollToPath = function(vt) {
    for (var At = getFieldName(vt), xt = arguments.length, bt = new Array(xt > 1 ? xt - 1 : 0), Et = 1; Et < xt; Et++)
      bt[Et - 1] = arguments[Et];
    et.apply(void 0, [At].concat(bt));
  }, pt.isFieldsTouched = function(vt, At) {
    var xt = (vt || []).map(function(bt) {
      return getFieldName(bt);
    });
    return it(xt, At);
  }, pt.isFieldTouched = function(vt) {
    var At = getFieldName(vt);
    return ut(At);
  }, pt.isFieldValidating = function(vt) {
    var At = getFieldName(vt);
    return ft(At);
  }, pt.resetFields = function(vt) {
    var At = (vt || []).map(function(xt) {
      return getFieldName(xt);
    });
    At.length > 0 ? ht(At) : ht();
  }, pt.validateFields = function(vt) {
    var At = (vt || []).map(function(xt) {
      return getFieldName(xt);
    });
    return At.length > 0 ? dt(At) : dt();
  }, pt.getFlattenSchema = function(vt) {
    var At;
    return vt ? (At = _e.current) === null || At === void 0 ? void 0 : At[vt] : _e.current;
  }, pt.onItemChange = pt.setValueByPath, pt.setFieldRef = function(vt, At) {
    vt && (at.current[vt] = At);
  }, pt.getFieldRef = function(vt) {
    return at.current[vt];
  }, pt;
};
const FormRender = withProvider(FormCore, defaultWidgets), svgBaseProp = {
  style: { width: "90%", height: "90%" },
  xmlns: "http://www.w3.org/2000/svg",
  enableBackground: "new 0 0 24 24",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#000000"
}, createSvgIcon = (a) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { ...svgBaseProp, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { fill: "none", height: "24", width: "24" }),
  a
] }), createButtonConfig = (a, s, $) => ({
  id: a,
  icon: createSvgIcon(s),
  onClick: $
}), AlignWidget = (a) => {
  const { activeElements: s, changeSchemas: $, schemas: _, pageSize: _e, schema: tt } = a, nt = (rt) => {
    const st = s.map((ct) => ct.id), lt = _.filter((ct) => st.includes(ct.id)), et = ["left", "center", "right"].includes(rt), it = et ? "x" : "y", ut = et ? "width" : "height", ft = lt.length === 1, ht = _e[ut], dt = ft ? 0 : Math.min(...lt.map((ct) => ct.position[it])), gt = ft ? ht : Math.max(...lt.map((ct) => ct.position[it] + ct[ut]));
    let pt = dt, mt = (ct) => 0;
    ["center", "middle"].includes(rt) ? (pt = (dt + gt) / 2, mt = (ct) => ct / 2) : ["right", "bottom"].includes(rt) && (pt = gt, mt = (ct) => ct), $(
      lt.map((ct) => ({
        key: `position.${it}`,
        value: round(pt - mt(ct[ut]), 2),
        schemaId: ct.id
      }))
    );
  }, at = (rt) => {
    const st = s.map((At) => At.id), lt = _.filter((At) => st.includes(At.id)), et = rt === "vertical", it = et ? "y" : "x", ut = et ? "height" : "width", ft = Math.min(...lt.map((At) => At.position[it])), ht = Math.max(...lt.map((At) => At.position[it] + At[ut]));
    if (lt.length < 3)
      return;
    const dt = ft, gt = ht - ft, pt = lt.reduce((At, xt) => At + xt[ut], 0), ct = (gt - pt) / (lt.length - 1);
    let vt = 0;
    $(
      lt.map((At, xt) => {
        vt += xt === 0 ? 0 : lt[xt - 1][ut] + ct;
        const bt = round(dt + vt, 2);
        return { key: `position.${it}`, value: bt, schemaId: At.id };
      })
    );
  }, ot = [
    createButtonConfig(
      "left",
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4,22H2V2h2V22z M22,7H6v3h16V7z M16,14H6v3h10V14z" }),
      () => nt("left")
    ),
    createButtonConfig(
      "center",
      /* @__PURE__ */ jsxRuntimeExports.jsx("polygon", { points: "11,2 13,2 13,7 21,7 21,10 13,10 13,14 18,14 18,17 13,17 13,22 11,22 11,17 6,17 6,14 11,14 11,10 3,10 3,7 11,7" }),
      () => nt("center")
    ),
    createButtonConfig(
      "right",
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M20,2h2v20h-2V2z M2,10h16V7H2V10z M8,17h10v-3H8V17z" }),
      () => nt("right")
    ),
    createButtonConfig(
      "top",
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M22,2v2H2V2H22z M7,22h3V6H7V22z M14,16h3V6h-3V16z" }),
      () => nt("top")
    ),
    createButtonConfig(
      "middle",
      /* @__PURE__ */ jsxRuntimeExports.jsx("polygon", { points: "22,11 17,11 17,6 14,6 14,11 10,11 10,3 7,3 7,11 1.84,11 1.84,13 7,13 7,21 10,21 10,13 14,13 14,18 17,18 17,13 22,13" }),
      () => nt("middle")
    ),
    createButtonConfig(
      "bottom",
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M22,22H2v-2h20V22z M10,2H7v16h3V2z M17,8h-3v10h3V8z" }),
      () => nt("bottom")
    ),
    createButtonConfig(
      "vertical",
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M22,2v2H2V2H22z M7,10.5v3h10v-3H7z M2,20v2h20v-2H2z" }),
      () => at("vertical")
    ),
    createButtonConfig(
      "horizontal",
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4,22H2V2h2V22z M22,2h-2v20h2V2z M13.5,7h-3v10h3V7z" }),
      () => at("horizontal")
    )
  ];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Form$3.Item, { label: tt.title, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2.Group, { children: ot.map((rt) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button$2,
    {
      style: { padding: 7 },
      disabled: s.length <= 2 && ["vertical", "horizontal"].includes(rt.id),
      ...rt
    },
    rt.id
  )) }) });
}, AlignWidget$1 = AlignWidget, WidgetRenderer = (a) => {
  const { widget: s, ...$ } = a, _ = reactExports.useRef(null);
  return reactExports.useEffect(() => (_.current && (_.current.innerHTML = "", s({ ...$, rootElement: _.current })), () => {
    _.current && (_.current.innerHTML = "");
  }), [a.activeSchema]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: _ });
}, WidgetRenderer$1 = WidgetRenderer, ButtonGroupWidget = (a) => {
  const { activeElements: s, changeSchemas: $, schemas: _, schema: _e } = a, tt = (ot) => {
    const rt = ot.key, st = ot.type, lt = s.map((it) => it.id), et = _.filter((it) => lt.includes(it.id));
    $(
      et.map((it) => {
        const ut = it[rt] ?? !1, ft = st === "boolean" ? !ut : ot.value;
        return { key: rt, value: ft, schemaId: it.id };
      })
    );
  }, nt = (ot) => {
    const rt = ot.key, st = ot.type;
    let lt = !1;
    const et = s.map((ut) => ut.id);
    return _.filter((ut) => et.includes(ut.id)).forEach((ut) => {
      lt = st === "boolean" ? ut[rt] ?? !1 : ut[rt] === ot.value;
    }), lt;
  }, at = (ot) => {
    const rt = `data:image/svg+xml;utf8,${encodeURIComponent(ot)}`;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("img", { width: 17, height: 17, src: rt });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Form$3.Item, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2.Group, { children: _e.buttons.map((ot, rt) => {
    const st = nt(ot);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$2,
      {
        type: st ? "primary" : void 0,
        ghost: st,
        onClick: () => tt(ot),
        style: {
          padding: 7,
          zIndex: st ? 2 : 0
        },
        icon: at(ot.icon)
      },
      rt
    );
  }) }) });
}, ButtonGroupWidget$1 = ButtonGroupWidget, { Text: Text$2 } = Typography$1, DetailView = (a) => {
  const { token: s } = theme.useToken(), { size: $, schemasList: _, changeSchemas: _e, deselectSchema: tt, activeSchema: nt } = a, at = useForm(), ot = reactExports.useContext(I18nContext), rt = reactExports.useContext(PluginsRegistry), st = reactExports.useContext(OptionsContext), [lt, et] = reactExports.useState({});
  reactExports.useEffect(() => {
    const ct = {
      AlignWidget: (vt) => /* @__PURE__ */ jsxRuntimeExports.jsx(AlignWidget$1, { ...vt, ...a, options: st }),
      Divider: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Divider$1, { style: { marginTop: s.marginXS, marginBottom: s.marginXS } }),
      ButtonGroup: (vt) => /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupWidget$1, { ...vt, ...a, options: st })
    };
    for (const vt of Object.values(rt)) {
      const At = (vt == null ? void 0 : vt.propPanel.widgets) || {};
      Object.entries(At).forEach(([xt, bt]) => {
        ct[xt] = (Et) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          WidgetRenderer$1,
          {
            ...Et,
            ...a,
            options: st,
            theme: s,
            i18n: ot,
            widget: bt
          }
        );
      });
    }
    et(ct);
  }, [nt, rt, JSON.stringify(st)]), reactExports.useEffect(() => {
    const ct = { ...nt };
    ct.editable = !ct.readOnly, at.setValues(ct);
  }, [nt, at]), reactExports.useEffect(() => at.resetFields(), [nt.id]), reactExports.useEffect(() => {
    it.current = (ct) => {
      for (const vt of _)
        for (const At of Object.values(vt))
          if (At.name === ct && At.id !== nt.id)
            return !1;
      return !0;
    };
  }, [_, nt]);
  const it = reactExports.useRef((ct) => !0), ut = (ct, vt) => it.current(vt), ft = debounce$1((ct) => {
    const vt = (xt, bt) => typeof xt == "object" ? JSON.stringify(xt) !== JSON.stringify(bt) : xt !== bt;
    let At = [];
    for (const xt in ct) {
      if (["id", "content"].includes(xt))
        continue;
      let bt = ct[xt];
      if (vt(bt, nt[xt])) {
        if (bt === null && ["rotate", "opacity"].includes(xt) && (bt = void 0), xt === "editable") {
          const Et = !bt;
          At.push({ key: "readOnly", value: Et, schemaId: nt.id }), Et && At.push({ key: "required", value: !1, schemaId: nt.id });
          continue;
        }
        At.push({ key: xt, value: bt, schemaId: nt.id });
      }
    }
    At.length && at.validateFields().then(() => _e(At)).catch((xt) => {
      xt.errorFields.length && (At = At.filter((bt) => !xt.errorFields.find(
        (Et) => Et.name.includes(bt.key)
      ))), At.length && _e(At);
    });
  }, 100), ht = Object.values(rt).find(
    (ct) => (ct == null ? void 0 : ct.propPanel.defaultSchema.type) === nt.type
  ), dt = ht == null ? void 0 : ht.propPanel.schema;
  dt || console.error(`[@pdfme/ui] No propPanel.schema for ${nt.type}.
Check this document: https://pdfme.com/docs/custom-schemas`);
  const gt = Object.entries(rt).map(([ct, vt]) => ({
    label: ct,
    value: vt == null ? void 0 : vt.propPanel.defaultSchema.type
  })), pt = ht.propPanel.defaultSchema, mt = {
    type: "object",
    column: 2,
    properties: {
      type: {
        title: ot("type"),
        type: "string",
        widget: "select",
        props: { options: gt },
        required: !0,
        span: 12
      },
      name: {
        title: ot("fieldName"),
        type: "string",
        required: !0,
        span: 12,
        rules: [{
          validator: ut,
          message: ot("validation.uniqueName")
        }],
        props: { autoComplete: "off" }
      },
      editable: { title: ot("editable"), type: "boolean", span: 8, hidden: (pt == null ? void 0 : pt.readOnly) !== void 0 },
      required: { title: ot("required"), type: "boolean", span: 16, hidden: "{{!formData.editable}}" },
      "-": { type: "void", widget: "Divider" },
      align: { title: ot("align"), type: "void", widget: "AlignWidget" },
      position: {
        type: "object",
        widget: "card",
        properties: {
          x: { title: "X", type: "number", widget: "inputNumber", required: !0, span: 8, min: 0 },
          y: { title: "Y", type: "number", widget: "inputNumber", required: !0, span: 8, min: 0 }
        }
      },
      width: {
        title: ot("width"),
        type: "number",
        widget: "inputNumber",
        required: !0,
        span: 6,
        props: { min: 0 }
      },
      height: {
        title: ot("height"),
        type: "number",
        widget: "inputNumber",
        required: !0,
        span: 6,
        props: { min: 0 }
      },
      rotate: {
        title: ot("rotate"),
        type: "number",
        widget: "inputNumber",
        disabled: (pt == null ? void 0 : pt.rotate) === void 0,
        max: 360,
        props: { min: 0 },
        span: 6
      },
      opacity: {
        title: ot("opacity"),
        type: "number",
        widget: "inputNumber",
        disabled: (pt == null ? void 0 : pt.opacity) === void 0,
        props: { step: 0.1, min: 0, max: 1 },
        span: 6
      }
    }
  };
  if (typeof dt == "function") {
    const { schemasList: ct, ...vt } = a, At = dt({
      ...vt,
      options: st,
      theme: s,
      i18n: ot
    }) || {};
    mt.properties = {
      ...mt.properties,
      ...Object.keys(At).length === 0 ? {} : { "--": { type: "void", widget: "Divider" } },
      ...At
    };
  } else {
    const ct = dt || {};
    mt.properties = {
      ...mt.properties,
      ...Object.keys(ct).length === 0 ? {} : { "--": { type: "void", widget: "Divider" } },
      ...ct
    };
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { height: 40, display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$2,
        {
          style: {
            position: "absolute",
            zIndex: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          onClick: tt,
          icon: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuOutlined$1, {})
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$2, { strong: !0, style: { textAlign: "center", width: "100%" }, children: ot("editField") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider$1, { style: { marginTop: s.marginXS, marginBottom: s.marginXS } }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        style: {
          height: getSidebarContentHeight($.height),
          overflowY: "auto",
          overflowX: "hidden"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          FormRender,
          {
            form: at,
            schema: mt,
            widgets: lt,
            watch: { "#": ft },
            locale: "en-US"
          }
        )
      }
    )
  ] });
}, propsAreUnchanged = (a, s) => JSON.stringify(a.activeSchema) == JSON.stringify(s.activeSchema), DetailView$1 = React$a.memo(DetailView, propsAreUnchanged), Sidebar = (a) => {
  const { sidebarOpen: s, setSidebarOpen: $, activeElements: _, schemas: _e } = a, { token: tt } = theme.useToken(), nt = () => _e.filter((ot) => _.map((rt) => rt.id).includes(ot.id)), at = () => {
    const ot = nt();
    return ot[ot.length - 1];
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        position: "absolute",
        right: 0,
        zIndex: 1,
        height: "100%",
        width: s ? RIGHT_SIDEBAR_WIDTH : 0
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button$2,
          {
            style: {
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              top: "1rem",
              right: "1rem",
              zIndex: 100
            },
            icon: s ? /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowRightOutlined$1, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowLeftOutlined$1, {}),
            onClick: () => $(!s)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            style: {
              width: RIGHT_SIDEBAR_WIDTH,
              height: "100%",
              display: s ? "block" : "none",
              top: 0,
              right: 0,
              position: "absolute",
              padding: "0.7rem 1rem",
              overflowY: "auto",
              fontFamily: "'Open Sans', sans-serif",
              boxSizing: "border-box",
              background: tt.colorBgLayout
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: nt().length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ListView$1, { ...a }) : /* @__PURE__ */ jsxRuntimeExports.jsx(DetailView$1, { ...a, activeSchema: at() }) })
          }
        )
      ] })
    }
  );
}, RightSidebar = Sidebar, useRerenderDependencies = ({ plugin: a, value: s, mode: $, scale: _, schema: _e, options: tt }) => reactExports.useMemo(() => a.uninterruptedEditMode && $ === "designer" ? [$] : [s, $, _, JSON.stringify(_e), JSON.stringify(tt)], [s, $, _, _e, tt]), Wrapper = ({
  children: a,
  outline: s,
  onChangeHoveringSchemaId: $,
  schema: _
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    title: _.name,
    onMouseEnter: () => $ && $(_.id),
    onMouseLeave: () => $ && $(null),
    className: SELECTABLE_CLASSNAME,
    id: _.id,
    style: {
      position: "absolute",
      cursor: _.readOnly ? "initial" : "pointer",
      height: _.height * ZOOM,
      width: _.width * ZOOM,
      top: _.position.y * ZOOM,
      left: _.position.x * ZOOM,
      transform: `rotate(${_.rotate ?? 0}deg)`,
      opacity: _.opacity ?? 1,
      outline: s
    },
    children: [
      _.required && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {
        color: "red",
        position: "absolute",
        top: -12,
        left: -12,
        fontSize: 18,
        fontWeight: 700
      }, children: "*" }),
      a
    ]
  }
), Renderer = (a) => {
  const s = reactExports.useContext(PluginsRegistry), $ = reactExports.useContext(OptionsContext), _ = reactExports.useContext(I18nContext), { token: _e } = theme.useToken(), { schema: tt, basePdf: nt, value: at, mode: ot, onChange: rt, stopEditing: st, tabIndex: lt, placeholder: et, scale: it } = a, ut = reactExports.useRef(null), ft = reactExports.useRef(/* @__PURE__ */ new Map()), ht = Object.values(s).find(
    (gt) => (gt == null ? void 0 : gt.propPanel.defaultSchema.type) === tt.type
  );
  if (!ht || !ht.ui)
    return console.error(`[@pdfme/ui] Renderer for type ${tt.type} not found. 
Check this document: https://pdfme.com/docs/custom-schemas`), /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  const dt = useRerenderDependencies({ plugin: ht, value: at, mode: ot, scale: it, schema: tt, options: $ });
  return reactExports.useEffect(() => {
    if (ut.current && tt.type) {
      ut.current.innerHTML = "";
      const gt = ht.ui;
      gt({
        value: at,
        schema: tt,
        basePdf: nt,
        rootElement: ut.current,
        mode: ot,
        onChange: rt,
        stopEditing: st,
        tabIndex: lt,
        placeholder: et,
        options: $,
        theme: _e,
        i18n: _,
        pdfJs,
        _cache: ft.current
      });
    }
    return () => {
      ut.current && (ut.current.innerHTML = "");
    };
  }, dt), /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper, { ...a, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { height: "100%", width: "100%" }, ref: ut }) });
}, Renderer$1 = Renderer, Draggable$1 = (a) => {
  const { scale: s, basePdf: $, plugin: _ } = a, { token: _e } = theme.useToken(), tt = _.propPanel.defaultSchema, nt = useDraggable({ id: tt.type, data: tt }), { listeners: at, setNodeRef: ot, attributes: rt, transform: st, isDragging: lt } = nt, et = { transform: CSS$1.Translate.toString(st) };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: ot, style: et, ...at, ...rt, children: [
    lt && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { transform: `scale(${s})` }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Renderer$1,
      {
        schema: { ...tt, id: tt.type },
        basePdf: $,
        value: tt.content || "",
        onChangeHoveringSchemaId: () => {
        },
        mode: "viewer",
        outline: `1px solid ${_e.colorPrimary}`,
        scale: s
      },
      tt.type
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { visibility: lt ? "hidden" : "visible" }, children: a.children })
  ] });
}, LeftSidebar = ({ height: a, scale: s, basePdf: $ }) => {
  const { token: _ } = theme.useToken(), _e = reactExports.useContext(PluginsRegistry), [tt, nt] = reactExports.useState(!1);
  return reactExports.useEffect(() => {
    const at = () => {
      tt && nt(!1);
    };
    return document.addEventListener("mouseup", at), () => {
      document.removeEventListener("mouseup", at);
    };
  }, [tt]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        left: 0,
        right: 0,
        position: "absolute",
        zIndex: 1,
        height: a,
        width: 45,
        background: _.colorBgLayout,
        textAlign: "center",
        overflow: tt ? "visible" : "auto"
      },
      children: Object.entries(_e).map(([at, ot]) => ot != null && ot.propPanel.defaultSchema ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        Draggable$1,
        {
          scale: s,
          basePdf: $,
          plugin: ot,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$2,
            {
              onMouseDown: () => nt(!0),
              style: { width: 35, height: 35, marginTop: "0.25rem", padding: "0.25rem" },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(PluginIcon$1, { plugin: ot, label: at })
            }
          )
        },
        at
      ) : null)
    }
  );
}, LeftSidebar$1 = LeftSidebar, Paper = (a) => {
  const {
    paperRefs: s,
    scale: $,
    size: _,
    schemasList: _e,
    pageSizes: tt,
    backgrounds: nt,
    renderPaper: at,
    renderSchema: ot,
    hasRulers: rt
  } = a, st = reactExports.useContext(FontContext), lt = rt ? RULER_HEIGHT : 0;
  return tt.length !== nt.length || tt.length !== _e.length ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        transform: `scale(${$})`,
        transformOrigin: "top left",
        // NOTE: These values do not impact the UI unless they exceed the Paper sizes.
        // We set them to the scale value to ensure the container is redrawn when you zoom in/out.
        height: $,
        width: $
      },
      children: nt.map((et, it) => {
        const ut = tt[it], ft = { width: ut.width * ZOOM, height: ut.height * ZOOM }, ht = ft.width * $ + lt < _.width ? `${(_.width / $ - ft.width) / 2}px` : `${lt}px`;
        let dt = it > 0 ? (lt + PAGE_GAP) * (it + 1) : lt;
        return rt || (dt += PAGE_GAP * 2), /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            ref: (gt) => {
              gt && (s.current[it] = gt);
            },
            onMouseDown: (gt) => {
              gt.currentTarget === gt.target && document && document.hasFocus() && document.activeElement instanceof HTMLElement && document.activeElement.blur();
            },
            style: {
              fontFamily: `'${getFallbackFontName(st)}'`,
              top: `${dt}px`,
              left: ht,
              position: "relative",
              backgroundImage: `url(${et})`,
              backgroundSize: `${ft.width}px ${ft.height}px`,
              ...ft
            },
            children: [
              at && at({ paperSize: ft, index: it }),
              _e[it].map((gt, pt) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: ot({
                schema: gt,
                index: it === 0 ? pt : pt + _e[it - 1].length
              }) }, gt.id))
            ]
          },
          String(it) + JSON.stringify(ft)
        );
      })
    }
  );
}, Paper$1 = Paper;
var FUNCTION = "function", OBJECT = "object", STRING = "string", UNDEFINED = "undefined", doc = typeof document !== UNDEFINED && document, OPEN_CLOSED_CHARACTERS = [{
  open: "(",
  close: ")"
}, {
  open: '"',
  close: '"'
}, {
  open: "'",
  close: "'"
}, {
  open: '\\"',
  close: '\\"'
}, {
  open: "\\'",
  close: "\\'"
}], TINY_NUM$1 = 1e-7, DEFAULT_UNIT_PRESETS = {
  cm: function(a) {
    return a * 96 / 2.54;
  },
  mm: function(a) {
    return a * 96 / 254;
  },
  in: function(a) {
    return a * 96;
  },
  pt: function(a) {
    return a * 96 / 72;
  },
  pc: function(a) {
    return a * 96 / 6;
  },
  "%": function(a, s) {
    return a * s / 100;
  },
  vw: function(a, s) {
    return s === void 0 && (s = window.innerWidth), a / 100 * s;
  },
  vh: function(a, s) {
    return s === void 0 && (s = window.innerHeight), a / 100 * s;
  },
  vmax: function(a, s) {
    return s === void 0 && (s = Math.max(window.innerWidth, window.innerHeight)), a / 100 * s;
  },
  vmin: function(a, s) {
    return s === void 0 && (s = Math.min(window.innerWidth, window.innerHeight)), a / 100 * s;
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __spreadArrays$3() {
  for (var a = 0, s = 0, $ = arguments.length; s < $; s++)
    a += arguments[s].length;
  for (var _ = Array(a), _e = 0, s = 0; s < $; s++)
    for (var tt = arguments[s], nt = 0, at = tt.length; nt < at; nt++, _e++)
      _[_e] = tt[nt];
  return _;
}
function dot(a, s, $, _) {
  return (a * _ + s * $) / ($ + _);
}
function isUndefined(a) {
  return typeof a === UNDEFINED;
}
function isObject$1(a) {
  return a && typeof a === OBJECT;
}
function isArray(a) {
  return Array.isArray(a);
}
function isString(a) {
  return typeof a === STRING;
}
function isFunction(a) {
  return typeof a === FUNCTION;
}
function isEqualSeparator(a, s) {
  var $ = a === "" || a == " ", _ = s === "" || s == " ";
  return _ && $ || a === s;
}
function findOpen(a, s, $, _, _e) {
  var tt = findIgnore(a, s, $);
  return tt ? $ : findClose(a, s, $ + 1, _, _e);
}
function findIgnore(a, s, $) {
  if (!a.ignore)
    return null;
  var _ = s.slice(Math.max($ - 3, 0), $ + 3).join("");
  return new RegExp(a.ignore).exec(_);
}
function findClose(a, s, $, _, _e) {
  for (var tt = function(rt) {
    var st = s[rt].trim();
    if (st === a.close && !findIgnore(a, s, rt))
      return {
        value: rt
      };
    var lt = rt, et = find$1(_e, function(it) {
      var ut = it.open;
      return ut === st;
    });
    if (et && (lt = findOpen(et, s, rt, _, _e)), lt === -1)
      return nt = rt, "break";
    rt = lt, nt = rt;
  }, nt, at = $; at < _; ++at) {
    var ot = tt(at);
    if (at = nt, typeof ot == "object")
      return ot.value;
    if (ot === "break")
      break;
  }
  return -1;
}
function splitText(a, s) {
  var $ = isString(s) ? {
    separator: s
  } : s, _ = $.separator, _e = _ === void 0 ? "," : _, tt = $.isSeparateFirst, nt = $.isSeparateOnlyOpenClose, at = $.isSeparateOpenClose, ot = at === void 0 ? nt : at, rt = $.openCloseCharacters, st = rt === void 0 ? OPEN_CLOSED_CHARACTERS : rt, lt = st.map(function(At) {
    var xt = At.open, bt = At.close;
    return xt === bt ? xt : xt + "|" + bt;
  }).join("|"), et = "(\\s*" + _e + "\\s*|" + lt + "|\\s+)", it = new RegExp(et, "g"), ut = a.split(it).filter(function(At) {
    return At && At !== "undefined";
  }), ft = ut.length, ht = [], dt = [];
  function gt() {
    return dt.length ? (ht.push(dt.join("")), dt = [], !0) : !1;
  }
  for (var pt = function(At) {
    var xt = ut[At].trim(), bt = At, Et = find$1(st, function(Ot) {
      var Pt = Ot.open;
      return Pt === xt;
    }), St = find$1(st, function(Ot) {
      var Pt = Ot.close;
      return Pt === xt;
    });
    if (Et) {
      if (bt = findOpen(Et, ut, At, ft, st), bt !== -1 && ot)
        return gt() && tt || (ht.push(ut.slice(At, bt + 1).join("")), At = bt, tt) ? (mt = At, "break") : (mt = At, "continue");
    } else if (St && !findIgnore(St, ut, At)) {
      var Bt = __spreadArrays$3(st);
      return Bt.splice(st.indexOf(St), 1), {
        value: splitText(a, {
          separator: _e,
          isSeparateFirst: tt,
          isSeparateOnlyOpenClose: nt,
          isSeparateOpenClose: ot,
          openCloseCharacters: Bt
        })
      };
    } else if (isEqualSeparator(xt, _e) && !nt)
      return gt(), tt ? (mt = At, "break") : (mt = At, "continue");
    bt === -1 && (bt = ft - 1), dt.push(ut.slice(At, bt + 1).join("")), At = bt, mt = At;
  }, mt, ct = 0; ct < ft; ++ct) {
    var vt = pt(ct);
    if (ct = mt, typeof vt == "object")
      return vt.value;
    if (vt === "break")
      break;
  }
  return dt.length && ht.push(dt.join("")), ht;
}
function splitSpace(a) {
  return splitText(a, "");
}
function splitComma(a) {
  return splitText(a, ",");
}
function splitBracket(a) {
  var s = /([^(]*)\(([\s\S]*)\)([\s\S]*)/g.exec(a);
  return !s || s.length < 4 ? {} : {
    prefix: s[1],
    value: s[2],
    suffix: s[3]
  };
}
function splitUnit(a) {
  var s = /^([^\d|e|\-|\+]*)((?:\d|\.|-|e-|e\+)+)(\S*)$/g.exec(a);
  if (!s)
    return {
      prefix: "",
      unit: "",
      value: NaN
    };
  var $ = s[1], _ = s[2], _e = s[3];
  return {
    prefix: $,
    unit: _e,
    value: parseFloat(_)
  };
}
function camelize(a) {
  return a.replace(/[\s-_]+([^\s-_])/g, function(s, $) {
    return $.toUpperCase();
  });
}
function now() {
  return Date.now ? Date.now() : (/* @__PURE__ */ new Date()).getTime();
}
function findIndex(a, s, $) {
  $ === void 0 && ($ = -1);
  for (var _ = a.length, _e = 0; _e < _; ++_e)
    if (s(a[_e], _e, a))
      return _e;
  return $;
}
function find$1(a, s, $) {
  var _ = findIndex(a, s);
  return _ > -1 ? a[_] : $;
}
function getKeys(a) {
  return Object.keys(a);
}
function convertUnitSize(a, s) {
  var $ = splitUnit(a), _ = $.value, _e = $.unit;
  if (isObject$1(s)) {
    var tt = s[_e];
    if (tt) {
      if (isFunction(tt))
        return tt(_);
      if (DEFAULT_UNIT_PRESETS[_e])
        return DEFAULT_UNIT_PRESETS[_e](_, tt);
    }
  } else if (_e === "%")
    return _ * s / 100;
  return DEFAULT_UNIT_PRESETS[_e] ? DEFAULT_UNIT_PRESETS[_e](_) : _;
}
function between(a, s, $) {
  return Math.max(s, Math.min(a, $));
}
function checkBoundSize(a, s, $, _) {
  return _ === void 0 && (_ = a[0] / a[1]), [[throttle(s[0], TINY_NUM$1), throttle(s[0] / _, TINY_NUM$1)], [throttle(s[1] * _, TINY_NUM$1), throttle(s[1], TINY_NUM$1)]].filter(function(_e) {
    return _e.every(function(tt, nt) {
      var at = s[nt], ot = throttle(at, TINY_NUM$1);
      return $ ? tt <= at || tt <= ot : tt >= at || tt >= ot;
    });
  })[0] || a;
}
function calculateBoundSize(a, s, $, _) {
  if (!_)
    return a.map(function(it, ut) {
      return between(it, s[ut], $[ut]);
    });
  var _e = a[0], tt = a[1], nt = _ === !0 ? _e / tt : _, at = checkBoundSize(a, s, !1, nt), ot = at[0], rt = at[1], st = checkBoundSize(a, $, !0, nt), lt = st[0], et = st[1];
  return _e < ot || tt < rt ? (_e = ot, tt = rt) : (_e > lt || tt > et) && (_e = lt, tt = et), [_e, tt];
}
function sum(a) {
  for (var s = a.length, $ = 0, _ = s - 1; _ >= 0; --_)
    $ += a[_];
  return $;
}
function average(a) {
  for (var s = a.length, $ = 0, _ = s - 1; _ >= 0; --_)
    $ += a[_];
  return s ? $ / s : 0;
}
function getRad$1(a, s) {
  var $ = s[0] - a[0], _ = s[1] - a[1], _e = Math.atan2(_, $);
  return _e >= 0 ? _e : _e + Math.PI * 2;
}
function getCenterPoint(a) {
  return [0, 1].map(function(s) {
    return average(a.map(function($) {
      return $[s];
    }));
  });
}
function getShapeDirection(a) {
  var s = getCenterPoint(a), $ = getRad$1(s, a[0]), _ = getRad$1(s, a[1]);
  return $ < _ && _ - $ < Math.PI || $ > _ && _ - $ < -Math.PI ? 1 : -1;
}
function getDist$2(a, s) {
  return Math.sqrt(Math.pow((s ? s[0] : 0) - a[0], 2) + Math.pow((s ? s[1] : 0) - a[1], 2));
}
function throttle(a, s) {
  if (!s)
    return a;
  var $ = 1 / s;
  return Math.round(a / s) / $;
}
function throttleArray(a, s) {
  return a.forEach(function($, _) {
    a[_] = throttle(a[_], s);
  }), a;
}
function hasClass(a, s) {
  return a.classList ? a.classList.contains(s) : !!a.className.match(new RegExp("(\\s|^)" + s + "(\\s|$)"));
}
function addClass(a, s) {
  a.classList ? a.classList.add(s) : a.className += " " + s;
}
function removeClass(a, s) {
  if (a.classList)
    a.classList.remove(s);
  else {
    var $ = new RegExp("(\\s|^)" + s + "(\\s|$)");
    a.className = a.className.replace($, " ");
  }
}
function addEvent(a, s, $, _) {
  a.addEventListener(s, $, _);
}
function removeEvent(a, s, $, _) {
  a.removeEventListener(s, $, _);
}
function getDocument(a) {
  return (a == null ? void 0 : a.ownerDocument) || doc;
}
function getWindow(a) {
  var s;
  return ((s = a == null ? void 0 : a.ownerDocument) === null || s === void 0 ? void 0 : s.defaultView) || window;
}
function isWindow(a) {
  return a && "postMessage" in a && "blur" in a && "self" in a;
}
function isNode(a) {
  return isObject$1(a) && a.nodeName && a.nodeType && "ownerDocument" in a;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$8 = function() {
  return __assign$8 = Object.assign || function(s) {
    for (var $, _ = 1, _e = arguments.length; _ < _e; _++) {
      $ = arguments[_];
      for (var tt in $)
        Object.prototype.hasOwnProperty.call($, tt) && (s[tt] = $[tt]);
    }
    return s;
  }, __assign$8.apply(this, arguments);
};
function __spreadArrays$2() {
  for (var a = 0, s = 0, $ = arguments.length; s < $; s++)
    a += arguments[s].length;
  for (var _ = Array(a), _e = 0, s = 0; s < $; s++)
    for (var tt = arguments[s], nt = 0, at = tt.length; nt < at; nt++, _e++)
      _[_e] = tt[nt];
  return _;
}
var EventEmitter = /* @__PURE__ */ function() {
  function a() {
    this._events = {};
  }
  var s = a.prototype;
  return s.on = function($, _) {
    if (isObject$1($))
      for (var _e in $)
        this.on(_e, $[_e]);
    else
      this._addEvent($, _, {});
    return this;
  }, s.off = function($, _) {
    if (!$)
      this._events = {};
    else if (isObject$1($))
      for (var _e in $)
        this.off(_e);
    else if (!_)
      this._events[$] = [];
    else {
      var tt = this._events[$];
      if (tt) {
        var nt = findIndex(tt, function(at) {
          return at.listener === _;
        });
        nt > -1 && tt.splice(nt, 1);
      }
    }
    return this;
  }, s.once = function($, _) {
    var _e = this;
    return _ && this._addEvent($, _, {
      once: !0
    }), new Promise(function(tt) {
      _e._addEvent($, tt, {
        once: !0
      });
    });
  }, s.emit = function($, _) {
    var _e = this;
    _ === void 0 && (_ = {});
    var tt = this._events[$];
    if (!$ || !tt)
      return !0;
    var nt = !1;
    return _.eventType = $, _.stop = function() {
      nt = !0;
    }, _.currentTarget = this, __spreadArrays$2(tt).forEach(function(at) {
      at.listener(_), at.once && _e.off($, at.listener);
    }), !nt;
  }, s.trigger = function($, _) {
    return _ === void 0 && (_ = {}), this.emit($, _);
  }, s._addEvent = function($, _, _e) {
    var tt = this._events;
    tt[$] = tt[$] || [];
    var nt = tt[$];
    nt.push(__assign$8({
      listener: _
    }, _e));
  }, a;
}();
const EventEmitter$1 = EventEmitter;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics$9 = function(a, s) {
  return extendStatics$9 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function($, _) {
    $.__proto__ = _;
  } || function($, _) {
    for (var _e in _)
      _.hasOwnProperty(_e) && ($[_e] = _[_e]);
  }, extendStatics$9(a, s);
};
function __extends$9(a, s) {
  extendStatics$9(a, s);
  function $() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : ($.prototype = s.prototype, new $());
}
var __assign$7 = function() {
  return __assign$7 = Object.assign || function(s) {
    for (var $, _ = 1, _e = arguments.length; _ < _e; _++) {
      $ = arguments[_];
      for (var tt in $)
        Object.prototype.hasOwnProperty.call($, tt) && (s[tt] = $[tt]);
    }
    return s;
  }, __assign$7.apply(this, arguments);
};
function getRad(a, s) {
  var $ = s[0] - a[0], _ = s[1] - a[1], _e = Math.atan2(_, $);
  return _e >= 0 ? _e : _e + Math.PI * 2;
}
function getRotatiion(a) {
  return getRad([
    a[0].clientX,
    a[0].clientY
  ], [
    a[1].clientX,
    a[1].clientY
  ]) / Math.PI * 180;
}
function isMultiTouch(a) {
  return a.touches && a.touches.length >= 2;
}
function getEventClients(a) {
  return a ? a.touches ? getClients(a.touches) : [getClient$1(a)] : [];
}
function isMouseEvent(a) {
  return a && (a.type.indexOf("mouse") > -1 || "button" in a);
}
function getPosition(a, s, $) {
  var _ = $.length, _e = getAverageClient(a, _), tt = _e.clientX, nt = _e.clientY, at = _e.originalClientX, ot = _e.originalClientY, rt = getAverageClient(s, _), st = rt.clientX, lt = rt.clientY, et = getAverageClient($, _), it = et.clientX, ut = et.clientY, ft = tt - st, ht = nt - lt, dt = tt - it, gt = nt - ut;
  return {
    clientX: at,
    clientY: ot,
    deltaX: ft,
    deltaY: ht,
    distX: dt,
    distY: gt
  };
}
function getDist$1(a) {
  return Math.sqrt(Math.pow(a[0].clientX - a[1].clientX, 2) + Math.pow(a[0].clientY - a[1].clientY, 2));
}
function getClients(a) {
  for (var s = Math.min(a.length, 2), $ = [], _ = 0; _ < s; ++_)
    $.push(getClient$1(a[_]));
  return $;
}
function getClient$1(a) {
  return {
    clientX: a.clientX,
    clientY: a.clientY
  };
}
function getAverageClient(a, s) {
  s === void 0 && (s = a.length);
  for (var $ = {
    clientX: 0,
    clientY: 0,
    originalClientX: 0,
    originalClientY: 0
  }, _ = Math.min(a.length, s), _e = 0; _e < _; ++_e) {
    var tt = a[_e];
    $.originalClientX += "originalClientX" in tt ? tt.originalClientX : tt.clientX, $.originalClientY += "originalClientY" in tt ? tt.originalClientY : tt.clientY, $.clientX += tt.clientX, $.clientY += tt.clientY;
  }
  return s ? {
    clientX: $.clientX / s,
    clientY: $.clientY / s,
    originalClientX: $.originalClientX / s,
    originalClientY: $.originalClientY / s
  } : $;
}
var ClientStore = /* @__PURE__ */ function() {
  function a(s) {
    this.prevClients = [], this.startClients = [], this.movement = 0, this.length = 0, this.startClients = s, this.prevClients = s, this.length = s.length;
  }
  return a.prototype.getAngle = function(s) {
    return s === void 0 && (s = this.prevClients), getRotatiion(s);
  }, a.prototype.getRotation = function(s) {
    return s === void 0 && (s = this.prevClients), getRotatiion(s) - getRotatiion(this.startClients);
  }, a.prototype.getPosition = function(s, $) {
    s === void 0 && (s = this.prevClients);
    var _ = getPosition(s || this.prevClients, this.prevClients, this.startClients), _e = _.deltaX, tt = _.deltaY;
    return this.movement += Math.sqrt(_e * _e + tt * tt), this.prevClients = s, _;
  }, a.prototype.getPositions = function(s) {
    s === void 0 && (s = this.prevClients);
    for (var $ = this.prevClients, _ = this.startClients, _e = Math.min(this.length, $.length), tt = [], nt = 0; nt < _e; ++nt)
      tt[nt] = getPosition([s[nt]], [$[nt]], [_[nt]]);
    return tt;
  }, a.prototype.getMovement = function(s) {
    var $ = this.movement;
    if (!s)
      return $;
    var _ = getAverageClient(s, this.length), _e = getAverageClient(this.prevClients, this.length), tt = _.clientX - _e.clientX, nt = _.clientY - _e.clientY;
    return Math.sqrt(tt * tt + nt * nt) + $;
  }, a.prototype.getDistance = function(s) {
    return s === void 0 && (s = this.prevClients), getDist$1(s);
  }, a.prototype.getScale = function(s) {
    return s === void 0 && (s = this.prevClients), getDist$1(s) / getDist$1(this.startClients);
  }, a.prototype.move = function(s, $) {
    this.startClients.forEach(function(_) {
      _.clientX -= s, _.clientY -= $;
    }), this.prevClients.forEach(function(_) {
      _.clientX -= s, _.clientY -= $;
    });
  }, a;
}(), INPUT_TAGNAMES = ["textarea", "input"], Gesto = /* @__PURE__ */ function(a) {
  __extends$9(s, a);
  function s($, _) {
    _ === void 0 && (_ = {});
    var _e = a.call(this) || this;
    _e.options = {}, _e.flag = !1, _e.pinchFlag = !1, _e.data = {}, _e.isDrag = !1, _e.isPinch = !1, _e.clientStores = [], _e.targets = [], _e.prevTime = 0, _e.doubleFlag = !1, _e._useMouse = !1, _e._useTouch = !1, _e._useDrag = !1, _e._dragFlag = !1, _e._isTrusted = !1, _e._isMouseEvent = !1, _e._isSecondaryButton = !1, _e._preventMouseEvent = !1, _e._prevInputEvent = null, _e._isDragAPI = !1, _e._isIdle = !0, _e._preventMouseEventId = 0, _e._window = window, _e.onDragStart = function(et, it) {
      if (it === void 0 && (it = !0), !(!_e.flag && et.cancelable === !1)) {
        var ut = et.type.indexOf("drag") >= -1;
        if (!(_e.flag && ut)) {
          _e._isDragAPI = !0;
          var ft = _e.options, ht = ft.container, dt = ft.pinchOutside, gt = ft.preventWheelClick, pt = ft.preventRightClick, mt = ft.preventDefault, ct = ft.checkInput, vt = ft.dragFocusedInput, At = ft.preventClickEventOnDragStart, xt = ft.preventClickEventOnDrag, bt = ft.preventClickEventByCondition, Et = _e._useTouch, St = !_e.flag;
          if (_e._isSecondaryButton = et.which === 3 || et.button === 2, gt && (et.which === 2 || et.button === 1) || pt && (et.which === 3 || et.button === 2))
            return _e.stop(), !1;
          if (St) {
            var Bt = _e._window.document.activeElement, Ot = et.target;
            if (Ot) {
              var Pt = Ot.tagName.toLowerCase(), wt = INPUT_TAGNAMES.indexOf(Pt) > -1, Ct = Ot.isContentEditable;
              if (wt || Ct) {
                if (ct || !vt && Bt === Ot)
                  return !1;
                if (Bt && (Bt === Ot || Ct && Bt.isContentEditable && Bt.contains(Ot)))
                  if (vt)
                    Ot.blur();
                  else
                    return !1;
              } else if ((mt || et.type === "touchstart") && Bt) {
                var It = Bt.tagName.toLowerCase();
                (Bt.isContentEditable || INPUT_TAGNAMES.indexOf(It) > -1) && Bt.blur();
              }
              (At || xt || bt) && addEvent(_e._window, "click", _e._onClick, !0);
            }
            _e.clientStores = [new ClientStore(getEventClients(et))], _e._isIdle = !1, _e.flag = !0, _e.isDrag = !1, _e._isTrusted = it, _e._dragFlag = !0, _e._prevInputEvent = et, _e.data = {}, _e.doubleFlag = now() - _e.prevTime < 200, _e._isMouseEvent = isMouseEvent(et), !_e._isMouseEvent && _e._preventMouseEvent && _e._allowMouseEvent();
            var yt = _e._preventMouseEvent || _e.emit("dragStart", __assign$7(__assign$7({ data: _e.data, datas: _e.data, inputEvent: et, isMouseEvent: _e._isMouseEvent, isSecondaryButton: _e._isSecondaryButton, isTrusted: it, isDouble: _e.doubleFlag }, _e.getCurrentStore().getPosition()), { preventDefault: function() {
              et.preventDefault();
            }, preventDrag: function() {
              _e._dragFlag = !1;
            } }));
            yt === !1 && _e.stop(), _e._isMouseEvent && _e.flag && mt && et.preventDefault();
          }
          if (!_e.flag)
            return !1;
          var Rt = 0;
          if (St ? (_e._attchDragEvent(), Et && dt && (Rt = setTimeout(function() {
            addEvent(ht, "touchstart", _e.onDragStart, {
              passive: !1
            });
          }))) : Et && dt && removeEvent(ht, "touchstart", _e.onDragStart), _e.flag && isMultiTouch(et)) {
            if (clearTimeout(Rt), St && et.touches.length !== et.changedTouches.length)
              return;
            _e.pinchFlag || _e.onPinchStart(et);
          }
        }
      }
    }, _e.onDrag = function(et, it) {
      if (_e.flag) {
        var ut = _e.options.preventDefault;
        !_e._isMouseEvent && ut && et.preventDefault(), _e._prevInputEvent = et;
        var ft = getEventClients(et), ht = _e.moveClients(ft, et, !1);
        if (_e._dragFlag) {
          if (_e.pinchFlag || ht.deltaX || ht.deltaY) {
            var dt = _e._preventMouseEvent || _e.emit("drag", __assign$7(__assign$7({}, ht), { isScroll: !!it, inputEvent: et }));
            if (dt === !1) {
              _e.stop();
              return;
            }
          }
          _e.pinchFlag && _e.onPinch(et, ft);
        }
        _e.getCurrentStore().getPosition(ft, !0);
      }
    }, _e.onDragEnd = function(et) {
      if (_e.flag) {
        var it = _e.options, ut = it.pinchOutside, ft = it.container, ht = it.preventClickEventOnDrag, dt = it.preventClickEventOnDragStart, gt = it.preventClickEventByCondition, pt = _e.isDrag;
        (ht || dt || gt) && requestAnimationFrame(function() {
          _e._allowClickEvent();
        }), !gt && !dt && ht && !pt && _e._allowClickEvent(), _e._useTouch && ut && removeEvent(ft, "touchstart", _e.onDragStart), _e.pinchFlag && _e.onPinchEnd(et);
        var mt = et != null && et.touches ? getEventClients(et) : [], ct = mt.length;
        ct === 0 || !_e.options.keepDragging ? _e.flag = !1 : _e._addStore(new ClientStore(mt));
        var vt = _e._getPosition(), At = now(), xt = !pt && _e.doubleFlag;
        _e._prevInputEvent = null, _e.prevTime = pt || xt ? 0 : At, _e.flag || (_e._dettachDragEvent(), _e._preventMouseEvent || _e.emit("dragEnd", __assign$7({ data: _e.data, datas: _e.data, isDouble: xt, isDrag: pt, isClick: !pt, isMouseEvent: _e._isMouseEvent, isSecondaryButton: _e._isSecondaryButton, inputEvent: et, isTrusted: _e._isTrusted }, vt)), _e.clientStores = [], _e._isMouseEvent || (_e._preventMouseEvent = !0, clearTimeout(_e._preventMouseEventId), _e._preventMouseEventId = setTimeout(function() {
          _e._preventMouseEvent = !1;
        }, 200)), _e._isIdle = !0);
      }
    }, _e.onBlur = function() {
      _e.onDragEnd();
    }, _e._allowClickEvent = function() {
      removeEvent(_e._window, "click", _e._onClick, !0);
    }, _e._onClick = function(et) {
      _e._allowClickEvent(), _e._allowMouseEvent();
      var it = _e.options.preventClickEventByCondition;
      it != null && it(et) || (et.stopPropagation(), et.preventDefault());
    }, _e._onContextMenu = function(et) {
      var it = _e.options;
      it.preventRightClick ? _e.onDragEnd(et) : et.preventDefault();
    }, _e._passCallback = function() {
    };
    var tt = [].concat($), nt = tt[0];
    _e._window = isWindow(nt) ? nt : getWindow(nt), _e.options = __assign$7({ checkInput: !1, container: nt && !("document" in nt) ? getWindow(nt) : nt, preventRightClick: !0, preventWheelClick: !0, preventClickEventOnDragStart: !1, preventClickEventOnDrag: !1, preventClickEventByCondition: null, preventDefault: !0, checkWindowBlur: !1, keepDragging: !1, pinchThreshold: 0, events: ["touch", "mouse"] }, _);
    var at = _e.options, ot = at.container, rt = at.events, st = at.checkWindowBlur;
    if (_e._useDrag = rt.indexOf("drag") > -1, _e._useTouch = rt.indexOf("touch") > -1, _e._useMouse = rt.indexOf("mouse") > -1, _e.targets = tt, _e._useDrag && tt.forEach(function(et) {
      addEvent(et, "dragstart", _e.onDragStart);
    }), _e._useMouse && (tt.forEach(function(et) {
      addEvent(et, "mousedown", _e.onDragStart), addEvent(et, "mousemove", _e._passCallback);
    }), addEvent(ot, "contextmenu", _e._onContextMenu)), st && addEvent(getWindow(), "blur", _e.onBlur), _e._useTouch) {
      var lt = {
        passive: !1
      };
      tt.forEach(function(et) {
        addEvent(et, "touchstart", _e.onDragStart, lt), addEvent(et, "touchmove", _e._passCallback, lt);
      });
    }
    return _e;
  }
  return s.prototype.stop = function() {
    this.isDrag = !1, this.data = {}, this.clientStores = [], this.pinchFlag = !1, this.doubleFlag = !1, this.prevTime = 0, this.flag = !1, this._isIdle = !0, this._allowClickEvent(), this._dettachDragEvent(), this._isDragAPI = !1;
  }, s.prototype.getMovement = function($) {
    return this.getCurrentStore().getMovement($) + this.clientStores.slice(1).reduce(function(_, _e) {
      return _ + _e.movement;
    }, 0);
  }, s.prototype.isDragging = function() {
    return this.isDrag;
  }, s.prototype.isIdle = function() {
    return this._isIdle;
  }, s.prototype.isFlag = function() {
    return this.flag;
  }, s.prototype.isPinchFlag = function() {
    return this.pinchFlag;
  }, s.prototype.isDoubleFlag = function() {
    return this.doubleFlag;
  }, s.prototype.isPinching = function() {
    return this.isPinch;
  }, s.prototype.scrollBy = function($, _, _e, tt) {
    tt === void 0 && (tt = !0), this.flag && (this.clientStores[0].move($, _), tt && this.onDrag(_e, !0));
  }, s.prototype.move = function($, _) {
    var _e = $[0], tt = $[1], nt = this.getCurrentStore(), at = nt.prevClients;
    return this.moveClients(at.map(function(ot) {
      var rt = ot.clientX, st = ot.clientY;
      return {
        clientX: rt + _e,
        clientY: st + tt,
        originalClientX: rt,
        originalClientY: st
      };
    }), _, !0);
  }, s.prototype.triggerDragStart = function($) {
    this.onDragStart($, !1);
  }, s.prototype.setEventData = function($) {
    var _ = this.data;
    for (var _e in $)
      _[_e] = $[_e];
    return this;
  }, s.prototype.setEventDatas = function($) {
    return this.setEventData($);
  }, s.prototype.getCurrentEvent = function($) {
    return $ === void 0 && ($ = this._prevInputEvent), __assign$7(__assign$7({ data: this.data, datas: this.data }, this._getPosition()), { movement: this.getMovement(), isDrag: this.isDrag, isPinch: this.isPinch, isScroll: !1, inputEvent: $ });
  }, s.prototype.getEventData = function() {
    return this.data;
  }, s.prototype.getEventDatas = function() {
    return this.data;
  }, s.prototype.unset = function() {
    var $ = this, _ = this.targets, _e = this.options.container;
    this.off(), removeEvent(this._window, "blur", this.onBlur), this._useDrag && _.forEach(function(tt) {
      removeEvent(tt, "dragstart", $.onDragStart);
    }), this._useMouse && (_.forEach(function(tt) {
      removeEvent(tt, "mousedown", $.onDragStart);
    }), removeEvent(_e, "contextmenu", this._onContextMenu)), this._useTouch && (_.forEach(function(tt) {
      removeEvent(tt, "touchstart", $.onDragStart);
    }), removeEvent(_e, "touchstart", this.onDragStart)), this._prevInputEvent = null, this._allowClickEvent(), this._dettachDragEvent();
  }, s.prototype.onPinchStart = function($) {
    var _ = this, _e = this.options.pinchThreshold;
    if (!(this.isDrag && this.getMovement() > _e)) {
      var tt = new ClientStore(getEventClients($));
      this.pinchFlag = !0, this._addStore(tt);
      var nt = this.emit("pinchStart", __assign$7(__assign$7({ data: this.data, datas: this.data, angle: tt.getAngle(), touches: this.getCurrentStore().getPositions() }, tt.getPosition()), { inputEvent: $, isTrusted: this._isTrusted, preventDefault: function() {
        $.preventDefault();
      }, preventDrag: function() {
        _._dragFlag = !1;
      } }));
      nt === !1 && (this.pinchFlag = !1);
    }
  }, s.prototype.onPinch = function($, _) {
    if (!(!this.flag || !this.pinchFlag || _.length < 2)) {
      var _e = this.getCurrentStore();
      this.isPinch = !0, this.emit("pinch", __assign$7(__assign$7({ data: this.data, datas: this.data, movement: this.getMovement(_), angle: _e.getAngle(_), rotation: _e.getRotation(_), touches: _e.getPositions(_), scale: _e.getScale(_), distance: _e.getDistance(_) }, _e.getPosition(_)), { inputEvent: $, isTrusted: this._isTrusted }));
    }
  }, s.prototype.onPinchEnd = function($) {
    if (this.pinchFlag) {
      var _ = this.isPinch;
      this.isPinch = !1, this.pinchFlag = !1;
      var _e = this.getCurrentStore();
      this.emit("pinchEnd", __assign$7(__assign$7({ data: this.data, datas: this.data, isPinch: _, touches: _e.getPositions() }, _e.getPosition()), { inputEvent: $ }));
    }
  }, s.prototype.getCurrentStore = function() {
    return this.clientStores[0];
  }, s.prototype.moveClients = function($, _, _e) {
    var tt = this._getPosition($, _e), nt = this.isDrag;
    (tt.deltaX || tt.deltaY) && (this.isDrag = !0);
    var at = !1;
    return !nt && this.isDrag && (at = !0), __assign$7(__assign$7({ data: this.data, datas: this.data }, tt), { movement: this.getMovement($), isDrag: this.isDrag, isPinch: this.isPinch, isScroll: !1, isMouseEvent: this._isMouseEvent, isSecondaryButton: this._isSecondaryButton, inputEvent: _, isTrusted: this._isTrusted, isFirstDrag: at });
  }, s.prototype._addStore = function($) {
    this.clientStores.splice(0, 0, $);
  }, s.prototype._getPosition = function($, _) {
    var _e = this.getCurrentStore(), tt = _e.getPosition($, _), nt = this.clientStores.slice(1).reduce(function(rt, st) {
      var lt = st.getPosition();
      return rt.distX += lt.distX, rt.distY += lt.distY, rt;
    }, tt), at = nt.distX, ot = nt.distY;
    return __assign$7(__assign$7({}, tt), { distX: at, distY: ot });
  }, s.prototype._attchDragEvent = function() {
    var $ = this._window, _ = this.options.container, _e = {
      passive: !1
    };
    this._isDragAPI && (addEvent(_, "dragover", this.onDrag, _e), addEvent($, "dragend", this.onDragEnd)), this._useMouse && (addEvent(_, "mousemove", this.onDrag), addEvent($, "mouseup", this.onDragEnd)), this._useTouch && (addEvent(_, "touchmove", this.onDrag, _e), addEvent($, "touchend", this.onDragEnd, _e), addEvent($, "touchcancel", this.onDragEnd, _e));
  }, s.prototype._dettachDragEvent = function() {
    var $ = this._window, _ = this.options.container;
    this._isDragAPI && (removeEvent(_, "dragover", this.onDrag), removeEvent($, "dragend", this.onDragEnd)), this._useMouse && (removeEvent(_, "mousemove", this.onDrag), removeEvent($, "mouseup", this.onDragEnd)), this._useTouch && (removeEvent(_, "touchstart", this.onDragStart), removeEvent(_, "touchmove", this.onDrag), removeEvent($, "touchend", this.onDragEnd), removeEvent($, "touchcancel", this.onDragEnd));
  }, s.prototype._allowMouseEvent = function() {
    this._preventMouseEvent = !1, clearTimeout(this._preventMouseEventId);
  }, s;
}(EventEmitter$1);
function prefixNames(a) {
  for (var s = [], $ = 1; $ < arguments.length; $++)
    s[$ - 1] = arguments[$];
  return s.map(function(_) {
    return _.split(" ").map(function(_e) {
      return _e ? "" + a + _e : "";
    }).join(" ");
  }).join(" ");
}
function prefixCSS(a, s) {
  return s.replace(/([^}{]*){/gm, function($, _) {
    return _.replace(/\.([^{,\s\d.]+)/g, "." + a + "$1") + "{";
  });
}
function ref(a, s) {
  return function($) {
    $ && (a[s] = $);
  };
}
function refs(a, s, $) {
  return function(_) {
    _ && (a[s][$] = _);
  };
}
function Properties(a, s) {
  return function($) {
    var _ = $.prototype;
    a.forEach(function(_e) {
      s(_, _e);
    });
  };
}
function withMethods(a, s) {
  return s === void 0 && (s = {}), function($, _) {
    a.forEach(function(_e) {
      var tt = s[_e] || _e;
      tt in $ || ($[tt] = function() {
        for (var nt, at = [], ot = 0; ot < arguments.length; ot++)
          at[ot] = arguments[ot];
        var rt = (nt = this[_])[_e].apply(nt, at);
        return rt === this[_] ? this : rt;
      });
    });
  };
}
var PolyMap = /* @__PURE__ */ function() {
  function a() {
    this.keys = [], this.values = [];
  }
  var s = a.prototype;
  return s.get = function($) {
    return this.values[this.keys.indexOf($)];
  }, s.set = function($, _) {
    var _e = this.keys, tt = this.values, nt = _e.indexOf($), at = nt === -1 ? _e.length : nt;
    _e[at] = $, tt[at] = _;
  }, a;
}(), HashMap = /* @__PURE__ */ function() {
  function a() {
    this.object = {};
  }
  var s = a.prototype;
  return s.get = function($) {
    return this.object[$];
  }, s.set = function($, _) {
    this.object[$] = _;
  }, a;
}(), SUPPORT_MAP = typeof Map == "function", Link = /* @__PURE__ */ function() {
  function a() {
  }
  var s = a.prototype;
  return s.connect = function($, _) {
    this.prev = $, this.next = _, $ && ($.next = this), _ && (_.prev = this);
  }, s.disconnect = function() {
    var $ = this.prev, _ = this.next;
    $ && ($.next = _), _ && (_.prev = $);
  }, s.getIndex = function() {
    for (var $ = this, _ = -1; $; )
      $ = $.prev, ++_;
    return _;
  }, a;
}();
function orderChanged(a, s) {
  var $ = [], _ = [];
  return a.forEach(function(_e) {
    var tt = _e[0], nt = _e[1], at = new Link();
    $[tt] = at, _[nt] = at;
  }), $.forEach(function(_e, tt) {
    _e.connect($[tt - 1]);
  }), a.filter(function(_e, tt) {
    return !s[tt];
  }).map(function(_e, tt) {
    var nt = _e[0], at = _e[1];
    if (nt === at)
      return [0, 0];
    var ot = $[nt], rt = _[at - 1], st = ot.getIndex();
    ot.disconnect(), rt ? ot.connect(rt, rt.next) : ot.connect(void 0, $[0]);
    var lt = ot.getIndex();
    return [st, lt];
  });
}
var Result = /* @__PURE__ */ function() {
  function a($, _, _e, tt, nt, at, ot, rt) {
    this.prevList = $, this.list = _, this.added = _e, this.removed = tt, this.changed = nt, this.maintained = at, this.changedBeforeAdded = ot, this.fixed = rt;
  }
  var s = a.prototype;
  return Object.defineProperty(s, "ordered", {
    get: function() {
      return this.cacheOrdered || this.caculateOrdered(), this.cacheOrdered;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(s, "pureChanged", {
    get: function() {
      return this.cachePureChanged || this.caculateOrdered(), this.cachePureChanged;
    },
    enumerable: !0,
    configurable: !0
  }), s.caculateOrdered = function() {
    var $ = orderChanged(this.changedBeforeAdded, this.fixed), _ = this.changed, _e = [];
    this.cacheOrdered = $.filter(function(tt, nt) {
      var at = tt[0], ot = tt[1], rt = _[nt], st = rt[0], lt = rt[1];
      if (at !== ot)
        return _e.push([st, lt]), !0;
    }), this.cachePureChanged = _e;
  }, a;
}();
function diff$1(a, s, $) {
  var _ = SUPPORT_MAP ? Map : $ ? HashMap : PolyMap, _e = $ || function(gt) {
    return gt;
  }, tt = [], nt = [], at = [], ot = a.map(_e), rt = s.map(_e), st = new _(), lt = new _(), et = [], it = [], ut = {}, ft = [], ht = 0, dt = 0;
  return ot.forEach(function(gt, pt) {
    st.set(gt, pt);
  }), rt.forEach(function(gt, pt) {
    lt.set(gt, pt);
  }), ot.forEach(function(gt, pt) {
    var mt = lt.get(gt);
    typeof mt > "u" ? (++dt, nt.push(pt)) : ut[mt] = dt;
  }), rt.forEach(function(gt, pt) {
    var mt = st.get(gt);
    typeof mt > "u" ? (tt.push(pt), ++ht) : (at.push([mt, pt]), dt = ut[pt] || 0, et.push([mt - dt, pt - ht]), it.push(pt === mt), mt !== pt && ft.push([mt, pt]));
  }), nt.reverse(), new Result(a, s, tt, nt, ft, at, et, it);
}
var ListDiffer = /* @__PURE__ */ function() {
  function a($, _) {
    $ === void 0 && ($ = []), this.findKeyCallback = _, this.list = [].slice.call($);
  }
  var s = a.prototype;
  return s.update = function($) {
    var _ = [].slice.call($), _e = diff$1(this.list, _, this.findKeyCallback);
    return this.list = _, _e;
  }, a;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics$8 = function(a, s) {
  return extendStatics$8 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function($, _) {
    $.__proto__ = _;
  } || function($, _) {
    for (var _e in _)
      _.hasOwnProperty(_e) && ($[_e] = _[_e]);
  }, extendStatics$8(a, s);
};
function __extends$8(a, s) {
  extendStatics$8(a, s);
  function $() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : ($.prototype = s.prototype, new $());
}
var findKeyCallback = typeof Map == "function" ? void 0 : /* @__PURE__ */ function() {
  var a = 0;
  return function(s) {
    return s.__DIFF_KEY__ || (s.__DIFF_KEY__ = ++a);
  };
}(), ChildrenDiffer = /* @__PURE__ */ function(a) {
  __extends$8(s, a);
  function s($) {
    return $ === void 0 && ($ = []), a.call(this, $, findKeyCallback) || this;
  }
  return s;
}(ListDiffer);
function diff(a, s) {
  return diff$1(a, s, findKeyCallback);
}
const ChildrenDiffer$1 = ChildrenDiffer;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics$7 = function(a, s) {
  return extendStatics$7 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function($, _) {
    $.__proto__ = _;
  } || function($, _) {
    for (var _e in _)
      _.hasOwnProperty(_e) && ($[_e] = _[_e]);
  }, extendStatics$7(a, s);
};
function __extends$7(a, s) {
  extendStatics$7(a, s);
  function $() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : ($.prototype = s.prototype, new $());
}
var __assign$6 = function() {
  return __assign$6 = Object.assign || function(s) {
    for (var $, _ = 1, _e = arguments.length; _ < _e; _++) {
      $ = arguments[_];
      for (var tt in $)
        Object.prototype.hasOwnProperty.call($, tt) && (s[tt] = $[tt]);
    }
    return s;
  }, __assign$6.apply(this, arguments);
};
function getDefaultScrollPosition$1(a) {
  var s = a.container;
  return s === document.body ? [s.scrollLeft || document.documentElement.scrollLeft, s.scrollTop || document.documentElement.scrollTop] : [s.scrollLeft, s.scrollTop];
}
function checkDefaultScrollEvent(a, s) {
  return a.addEventListener("scroll", s), function() {
    a.removeEventListener("scroll", s);
  };
}
function getContainerElement(a) {
  if (a) {
    if (isString(a))
      return document.querySelector(a);
  } else
    return null;
  if (isFunction(a))
    return a();
  if (a instanceof Element)
    return a;
  if ("current" in a)
    return a.current;
  if ("value" in a)
    return a.value;
}
var DragScroll = /* @__PURE__ */ function(a) {
  __extends$7(s, a);
  function s() {
    var _ = a !== null && a.apply(this, arguments) || this;
    return _._startRect = null, _._startPos = [], _._prevTime = 0, _._timer = 0, _._prevScrollPos = [0, 0], _._isWait = !1, _._flag = !1, _._currentOptions = null, _._lock = !1, _._unregister = null, _._onScroll = function() {
      var _e = _._currentOptions;
      _._lock || !_e || _.emit("scrollDrag", {
        next: function(tt) {
          _.checkScroll({
            container: _e.container,
            inputEvent: tt
          });
        }
      });
    }, _;
  }
  var $ = s.prototype;
  return $.dragStart = function(_, _e) {
    var tt = getContainerElement(_e.container);
    if (!tt) {
      this._flag = !1;
      return;
    }
    var nt = 0, at = 0, ot = 0, rt = 0;
    if (tt === document.body)
      ot = window.innerWidth, rt = window.innerHeight;
    else {
      var st = tt.getBoundingClientRect();
      nt = st.top, at = st.left, ot = st.width, rt = st.height;
    }
    this._flag = !0, this._startPos = [_.clientX, _.clientY], this._startRect = {
      top: nt,
      left: at,
      width: ot,
      height: rt
    }, this._prevScrollPos = this._getScrollPosition([0, 0], _e), this._currentOptions = _e, this._registerScrollEvent(_e);
  }, $.drag = function(_, _e) {
    if (clearTimeout(this._timer), !!this._flag) {
      var tt = _.clientX, nt = _.clientY, at = _e.threshold, ot = at === void 0 ? 0 : at, rt = this, st = rt._startRect, lt = rt._startPos;
      this._currentOptions = _e;
      var et = [0, 0];
      return st.top > nt - ot ? (lt[1] > st.top || nt < lt[1]) && (et[1] = -1) : st.top + st.height < nt + ot && (lt[1] < st.top + st.height || nt > lt[1]) && (et[1] = 1), st.left > tt - ot ? (lt[0] > st.left || tt < lt[0]) && (et[0] = -1) : st.left + st.width < tt + ot && (lt[0] < st.left + st.width || tt > lt[0]) && (et[0] = 1), !et[0] && !et[1] ? !1 : this._continueDrag(__assign$6(__assign$6({}, _e), {
        direction: et,
        inputEvent: _,
        isDrag: !0
      }));
    }
  }, $.checkScroll = function(_) {
    var _e = this;
    if (this._isWait)
      return !1;
    var tt = _.prevScrollPos, nt = tt === void 0 ? this._prevScrollPos : tt, at = _.direction, ot = _.throttleTime, rt = ot === void 0 ? 0 : ot, st = _.inputEvent, lt = _.isDrag, et = this._getScrollPosition(at || [0, 0], _), it = et[0] - nt[0], ut = et[1] - nt[1], ft = at || [it ? Math.abs(it) / it : 0, ut ? Math.abs(ut) / ut : 0];
    return this._prevScrollPos = et, this._lock = !1, !it && !ut ? !1 : (this.emit("move", {
      offsetX: ft[0] ? it : 0,
      offsetY: ft[1] ? ut : 0,
      inputEvent: st
    }), rt && lt && (clearTimeout(this._timer), this._timer = window.setTimeout(function() {
      _e._continueDrag(_);
    }, rt)), !0);
  }, $.dragEnd = function() {
    this._flag = !1, this._lock = !1, clearTimeout(this._timer), this._unregisterScrollEvent();
  }, $._getScrollPosition = function(_, _e) {
    var tt = _e.container, nt = _e.getScrollPosition, at = nt === void 0 ? getDefaultScrollPosition$1 : nt;
    return at({
      container: getContainerElement(tt),
      direction: _
    });
  }, $._continueDrag = function(_) {
    var _e = this, tt, nt = _.container, at = _.direction, ot = _.throttleTime, rt = _.useScroll, st = _.isDrag, lt = _.inputEvent;
    if (!(!this._flag || st && this._isWait)) {
      var et = now(), it = Math.max(ot + this._prevTime - et, 0);
      if (it > 0)
        return clearTimeout(this._timer), this._timer = window.setTimeout(function() {
          _e._continueDrag(_);
        }, it), !1;
      this._prevTime = et;
      var ut = this._getScrollPosition(at, _);
      this._prevScrollPos = ut, st && (this._isWait = !0), rt || (this._lock = !0);
      var ft = {
        container: getContainerElement(nt),
        direction: at,
        inputEvent: lt
      };
      return (tt = _.requestScroll) === null || tt === void 0 || tt.call(_, ft), this.emit("scroll", ft), this._isWait = !1, rt || this.checkScroll(__assign$6(__assign$6({}, _), {
        prevScrollPos: ut,
        direction: at,
        inputEvent: lt
      }));
    }
  }, $._registerScrollEvent = function(_) {
    this._unregisterScrollEvent();
    var _e = _.checkScrollEvent;
    if (_e) {
      var tt = _e === !0 ? checkDefaultScrollEvent : _e, nt = getContainerElement(_.container);
      _e === !0 && (nt === document.body || nt === document.documentElement) ? this._unregister = checkDefaultScrollEvent(window, this._onScroll) : this._unregister = tt(nt, this._onScroll);
    }
  }, $._unregisterScrollEvent = function() {
    var _;
    (_ = this._unregister) === null || _ === void 0 || _.call(this), this._unregister = null;
  }, s;
}(EventEmitter$1);
const DragScroll$1 = DragScroll;
var extendStatics$6 = function(a, s) {
  return extendStatics$6 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function($, _) {
    $.__proto__ = _;
  } || function($, _) {
    for (var _e in _)
      Object.prototype.hasOwnProperty.call(_, _e) && ($[_e] = _[_e]);
  }, extendStatics$6(a, s);
};
function __extends$6(a, s) {
  if (typeof s != "function" && s !== null)
    throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
  extendStatics$6(a, s);
  function $() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : ($.prototype = s.prototype, new $());
}
function createCommonjsModule(a, s) {
  return s = {
    exports: {}
  }, a(s, s.exports), s.exports;
}
var keycode = createCommonjsModule(function(a, s) {
  function $(ot) {
    if (ot && typeof ot == "object") {
      var rt = ot.which || ot.keyCode || ot.charCode;
      rt && (ot = rt);
    }
    if (typeof ot == "number")
      return nt[ot];
    var st = String(ot), lt = _[st.toLowerCase()];
    if (lt)
      return lt;
    var lt = _e[st.toLowerCase()];
    if (lt)
      return lt;
    if (st.length === 1)
      return st.charCodeAt(0);
  }
  $.isEventKey = function(rt, st) {
    if (rt && typeof rt == "object") {
      var lt = rt.which || rt.keyCode || rt.charCode;
      if (lt == null)
        return !1;
      if (typeof st == "string") {
        var et = _[st.toLowerCase()];
        if (et)
          return et === lt;
        var et = _e[st.toLowerCase()];
        if (et)
          return et === lt;
      } else if (typeof st == "number")
        return st === lt;
      return !1;
    }
  }, s = a.exports = $;
  var _ = s.code = s.codes = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    "pause/break": 19,
    "caps lock": 20,
    esc: 27,
    space: 32,
    "page up": 33,
    "page down": 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    delete: 46,
    command: 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
  }, _e = s.aliases = {
    windows: 91,
    "⇧": 16,
    "⌥": 18,
    "⌃": 17,
    "⌘": 91,
    ctl: 17,
    control: 17,
    option: 18,
    pause: 19,
    break: 19,
    caps: 20,
    return: 13,
    escape: 27,
    spc: 32,
    spacebar: 32,
    pgup: 33,
    pgdn: 34,
    ins: 45,
    del: 46,
    cmd: 91
  };
  /*!
   * Programatically add the following
   */
  for (tt = 97; tt < 123; tt++)
    _[String.fromCharCode(tt)] = tt - 32;
  for (var tt = 48; tt < 58; tt++)
    _[tt - 48] = tt;
  for (tt = 1; tt < 13; tt++)
    _["f" + tt] = tt + 111;
  for (tt = 0; tt < 10; tt++)
    _["numpad " + tt] = tt + 96;
  var nt = s.names = s.title = {};
  for (tt in _)
    nt[_[tt]] = tt;
  for (var at in _e)
    _[at] = _e[at];
});
keycode.code;
keycode.codes;
keycode.aliases;
var keycode_4 = keycode.names;
keycode.title;
var codeData = {
  "+": "plus",
  "left command": "meta",
  "right command": "meta"
}, keysSort = {
  shift: 1,
  ctrl: 2,
  alt: 3,
  meta: 4
};
function getKey(a, s) {
  var $ = (keycode_4[a] || s || "").toLowerCase();
  for (var _ in codeData)
    $ = $.replace(_, codeData[_]);
  return $.replace(/\s/g, "");
}
function getCombi(a, s) {
  s === void 0 && (s = getKey(a.keyCode, a.key));
  var $ = getModifierCombi(a);
  return $.indexOf(s) === -1 && $.push(s), $.filter(Boolean);
}
function getModifierCombi(a) {
  var s = [a.shiftKey && "shift", a.ctrlKey && "ctrl", a.altKey && "alt", a.metaKey && "meta"];
  return s.filter(Boolean);
}
function getArrangeCombi(a) {
  var s = a.slice();
  return s.sort(function($, _) {
    var _e = keysSort[$] || 5, tt = keysSort[_] || 5;
    return _e - tt;
  }), s;
}
var globalKeyController, KeyController = /* @__PURE__ */ function(a) {
  __extends$6(s, a);
  function s(_) {
    _ === void 0 && (_ = window);
    var _e = a.call(this) || this;
    return _e.container = _, _e.ctrlKey = !1, _e.altKey = !1, _e.shiftKey = !1, _e.metaKey = !1, _e.clear = function() {
      return _e.ctrlKey = !1, _e.altKey = !1, _e.shiftKey = !1, _e.metaKey = !1, _e;
    }, _e.keydownEvent = function(tt) {
      _e.triggerEvent("keydown", tt);
    }, _e.keyupEvent = function(tt) {
      _e.triggerEvent("keyup", tt);
    }, _e.blur = function() {
      _e.clear(), _e.trigger("blur");
    }, addEvent(_, "blur", _e.blur), addEvent(_, "keydown", _e.keydownEvent), addEvent(_, "keyup", _e.keyupEvent), _e;
  }
  var $ = s.prototype;
  return Object.defineProperty(s, "global", {
    /**
     */
    get: function() {
      return globalKeyController || (globalKeyController = new s());
    },
    enumerable: !1,
    configurable: !0
  }), s.setGlobal = function() {
    return this.global;
  }, $.destroy = function() {
    var _ = this.container;
    this.clear(), this.off(), removeEvent(_, "blur", this.blur), removeEvent(_, "keydown", this.keydownEvent), removeEvent(_, "keyup", this.keyupEvent);
  }, $.keydown = function(_, _e) {
    return this.addEvent("keydown", _, _e);
  }, $.offKeydown = function(_, _e) {
    return this.removeEvent("keydown", _, _e);
  }, $.offKeyup = function(_, _e) {
    return this.removeEvent("keyup", _, _e);
  }, $.keyup = function(_, _e) {
    return this.addEvent("keyup", _, _e);
  }, $.addEvent = function(_, _e, tt) {
    return isArray(_e) ? this.on("".concat(_, ".").concat(getArrangeCombi(_e).join(".")), tt) : isString(_e) ? this.on("".concat(_, ".").concat(_e), tt) : this.on(_, _e), this;
  }, $.removeEvent = function(_, _e, tt) {
    return isArray(_e) ? this.off("".concat(_, ".").concat(getArrangeCombi(_e).join(".")), tt) : isString(_e) ? this.off("".concat(_, ".").concat(_e), tt) : this.off(_, _e), this;
  }, $.triggerEvent = function(_, _e) {
    this.ctrlKey = _e.ctrlKey, this.shiftKey = _e.shiftKey, this.altKey = _e.altKey, this.metaKey = _e.metaKey;
    var tt = getKey(_e.keyCode, _e.key), nt = tt === "ctrl" || tt === "shift" || tt === "meta" || tt === "alt", at = {
      key: tt,
      isToggle: nt,
      inputEvent: _e,
      keyCode: _e.keyCode,
      ctrlKey: _e.ctrlKey,
      altKey: _e.altKey,
      shiftKey: _e.shiftKey,
      metaKey: _e.metaKey
    };
    this.trigger(_, at), this.trigger("".concat(_, ".").concat(tt), at);
    var ot = getCombi(_e, tt);
    ot.length > 1 && this.trigger("".concat(_, ".").concat(ot.join(".")), at);
  }, s;
}(EventEmitter$1);
const KeyController$1 = KeyController;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __spreadArrays$1() {
  for (var a = 0, s = 0, $ = arguments.length; s < $; s++)
    a += arguments[s].length;
  for (var _ = Array(a), _e = 0, s = 0; s < $; s++)
    for (var tt = arguments[s], nt = 0, at = tt.length; nt < at; nt++, _e++)
      _[_e] = tt[nt];
  return _;
}
function tinyThrottle(a) {
  return throttle(a, TINY_NUM$1);
}
function isSameConstants(a, s) {
  return a.every(function($, _) {
    return tinyThrottle($ - s[_]) === 0;
  });
}
function isSamePoint(a, s) {
  return !tinyThrottle(a[0] - s[0]) && !tinyThrottle(a[1] - s[1]);
}
function getAreaSize(a) {
  return a.length < 3 ? 0 : Math.abs(sum(a.map(function(s, $) {
    var _ = a[$ + 1] || a[0];
    return s[0] * _[1] - _[0] * s[1];
  }))) / 2;
}
function fitPoints(a, s) {
  var $ = s.width, _ = s.height, _e = s.left, tt = s.top, nt = getMinMaxs(a), at = nt.minX, ot = nt.minY, rt = nt.maxX, st = nt.maxY, lt = $ / (rt - at), et = _ / (st - ot);
  return a.map(function(it) {
    return [_e + (it[0] - at) * lt, tt + (it[1] - ot) * et];
  });
}
function getMinMaxs(a) {
  var s = a.map(function(_) {
    return _[0];
  }), $ = a.map(function(_) {
    return _[1];
  });
  return {
    minX: Math.min.apply(Math, s),
    minY: Math.min.apply(Math, $),
    maxX: Math.max.apply(Math, s),
    maxY: Math.max.apply(Math, $)
  };
}
function isInside(a, s, $) {
  var _ = a[0], _e = a[1], tt = getMinMaxs(s), nt = tt.minX, at = tt.maxX, ot = [[nt, _e], [at, _e]], rt = getLinearConstants(ot[0], ot[1]), st = convertLines(s), lt = [];
  if (st.forEach(function(ut) {
    var ft = getLinearConstants(ut[0], ut[1]), ht = ut[0];
    if (isSameConstants(rt, ft))
      lt.push({
        pos: a,
        line: ut,
        type: "line"
      });
    else {
      var dt = getPointsOnLines(getIntersectionPointsByConstants(rt, ft), [ot, ut]);
      dt.forEach(function(gt) {
        ut.some(function(pt) {
          return isSamePoint(pt, gt);
        }) ? lt.push({
          pos: gt,
          line: ut,
          type: "point"
        }) : tinyThrottle(ht[1] - _e) !== 0 && lt.push({
          pos: gt,
          line: ut,
          type: "intersection"
        });
      });
    }
  }), !$ && find$1(lt, function(ut) {
    return ut[0] === _;
  }))
    return !0;
  var et = 0, it = {};
  return lt.forEach(function(ut) {
    var ft = ut.pos, ht = ut.type, dt = ut.line;
    if (!(ft[0] > _))
      if (ht === "intersection")
        ++et;
      else {
        if (ht === "line")
          return;
        if (ht === "point") {
          var gt = find$1(dt, function(ct) {
            return ct[1] !== _e;
          }), pt = it[ft[0]], mt = gt[1] > _e ? 1 : -1;
          pt ? pt !== mt && ++et : it[ft[0]] = mt;
        }
      }
  }), et % 2 === 1;
}
function getLinearConstants(a, s) {
  var $ = a[0], _ = a[1], _e = s[0], tt = s[1], nt = _e - $, at = tt - _;
  Math.abs(nt) < TINY_NUM$1 && (nt = 0), Math.abs(at) < TINY_NUM$1 && (at = 0);
  var ot = 0, rt = 0, st = 0;
  return nt ? at ? (ot = -at / nt, rt = 1, st = -ot * $ - _) : (rt = 1, st = -_) : at && (ot = -1, st = $), [ot, rt, st];
}
function getIntersectionPointsByConstants(a, s) {
  var $ = a[0], _ = a[1], _e = a[2], tt = s[0], nt = s[1], at = s[2], ot = $ === 0 && tt === 0, rt = _ === 0 && nt === 0, st = [];
  if (ot && rt)
    return [];
  if (ot) {
    var lt = -_e / _, et = -at / nt;
    return lt !== et ? [] : [[-1 / 0, lt], [1 / 0, lt]];
  } else if (rt) {
    var it = -_e / $, ut = -at / tt;
    return it !== ut ? [] : [[it, -1 / 0], [it, 1 / 0]];
  } else if ($ === 0) {
    var ft = -_e / _, ht = -(nt * ft + at) / tt;
    st = [[ht, ft]];
  } else if (tt === 0) {
    var ft = -at / nt, ht = -(_ * ft + _e) / $;
    st = [[ht, ft]];
  } else if (_ === 0) {
    var ht = -_e / $, ft = -(tt * ht + at) / nt;
    st = [[ht, ft]];
  } else if (nt === 0) {
    var ht = -at / tt, ft = -($ * ht + _e) / _;
    st = [[ht, ft]];
  } else {
    var ht = (_ * at - nt * _e) / (nt * $ - _ * tt), ft = -($ * ht + _e) / _;
    st = [[ht, ft]];
  }
  return st.map(function(dt) {
    return [dt[0], dt[1]];
  });
}
function getPointsOnLines(a, s) {
  var $ = s.map(function(lt) {
    return [0, 1].map(function(et) {
      return [Math.min(lt[0][et], lt[1][et]), Math.max(lt[0][et], lt[1][et])];
    });
  }), _ = [];
  if (a.length === 2) {
    var _e = a[0], tt = _e[0], nt = _e[1];
    if (tinyThrottle(tt - a[1][0])) {
      if (!tinyThrottle(nt - a[1][1])) {
        var rt = Math.max.apply(Math, $.map(function(lt) {
          return lt[0][0];
        })), st = Math.min.apply(Math, $.map(function(lt) {
          return lt[0][1];
        }));
        if (tinyThrottle(rt - st) > 0)
          return [];
        _ = [[rt, nt], [st, nt]];
      }
    } else {
      var at = Math.max.apply(Math, $.map(function(lt) {
        return lt[1][0];
      })), ot = Math.min.apply(Math, $.map(function(lt) {
        return lt[1][1];
      }));
      if (tinyThrottle(at - ot) > 0)
        return [];
      _ = [[tt, at], [tt, ot]];
    }
  }
  return _.length || (_ = a.filter(function(lt) {
    var et = lt[0], it = lt[1];
    return $.every(function(ut) {
      return 0 <= tinyThrottle(et - ut[0][0]) && 0 <= tinyThrottle(ut[0][1] - et) && 0 <= tinyThrottle(it - ut[1][0]) && 0 <= tinyThrottle(ut[1][1] - it);
    });
  })), _.map(function(lt) {
    return [tinyThrottle(lt[0]), tinyThrottle(lt[1])];
  });
}
function convertLines(a) {
  return __spreadArrays$1(a.slice(1), [a[0]]).map(function(s, $) {
    return [a[$], s];
  });
}
function getOverlapPointInfos(a, s) {
  var $ = a.slice(), _ = s.slice();
  getShapeDirection($) === -1 && $.reverse(), getShapeDirection(_) === -1 && _.reverse();
  var _e = convertLines($), tt = convertLines(_), nt = _e.map(function(st) {
    return getLinearConstants(st[0], st[1]);
  }), at = tt.map(function(st) {
    return getLinearConstants(st[0], st[1]);
  }), ot = [];
  nt.forEach(function(st, lt) {
    var et = _e[lt], it = [];
    at.forEach(function(ut, ft) {
      var ht = getIntersectionPointsByConstants(st, ut), dt = getPointsOnLines(ht, [et, tt[ft]]);
      it.push.apply(it, dt.map(function(gt) {
        return {
          index1: lt,
          index2: ft,
          pos: gt,
          type: "intersection"
        };
      }));
    }), it.sort(function(ut, ft) {
      return getDist$2(et[0], ut.pos) - getDist$2(et[0], ft.pos);
    }), ot.push.apply(ot, it), isInside(et[1], _) && ot.push({
      index1: lt,
      index2: -1,
      pos: et[1],
      type: "inside"
    });
  }), tt.forEach(function(st, lt) {
    if (isInside(st[1], $)) {
      var et = !1, it = findIndex(ot, function(ut) {
        var ft = ut.index2;
        return ft === lt ? (et = !0, !1) : !!et;
      });
      it === -1 && (et = !1, it = findIndex(ot, function(ut) {
        var ft = ut.index1, ht = ut.index2;
        return ft === -1 && ht + 1 === lt ? (et = !0, !1) : !!et;
      })), it === -1 ? ot.push({
        index1: -1,
        index2: lt,
        pos: st[1],
        type: "inside"
      }) : ot.splice(it, 0, {
        index1: -1,
        index2: lt,
        pos: st[1],
        type: "inside"
      });
    }
  });
  var rt = {};
  return ot.filter(function(st) {
    var lt = st.pos, et = lt[0] + "x" + lt[1];
    return rt[et] ? !1 : (rt[et] = !0, !0);
  });
}
function getOverlapPoints(a, s) {
  var $ = getOverlapPointInfos(a, s);
  return $.map(function(_) {
    var _e = _.pos;
    return _e;
  });
}
function getOverlapSize(a, s) {
  var $ = getOverlapPoints(a, s);
  return getAreaSize($);
}
function add(a, s, $, _, _e, tt) {
  for (var nt = 0; nt < _e; ++nt) {
    var at = $ + nt * _e, ot = _ + nt * _e;
    a[at] += a[ot] * tt, s[at] += s[ot] * tt;
  }
}
function swap(a, s, $, _, _e) {
  for (var tt = 0; tt < _e; ++tt) {
    var nt = $ + tt * _e, at = _ + tt * _e, ot = a[nt], rt = s[nt];
    a[nt] = a[at], a[at] = ot, s[nt] = s[at], s[at] = rt;
  }
}
function divide(a, s, $, _, _e) {
  for (var tt = 0; tt < _; ++tt) {
    var nt = $ + tt * _;
    a[nt] /= _e, s[nt] /= _e;
  }
}
function ignoreDimension(a, s, $) {
  $ === void 0 && ($ = Math.sqrt(a.length));
  for (var _ = a.slice(), _e = 0; _e < $; ++_e)
    _[_e * $ + s - 1] = 0, _[(s - 1) * $ + _e] = 0;
  return _[(s - 1) * ($ + 1)] = 1, _;
}
function invert(a, s) {
  s === void 0 && (s = Math.sqrt(a.length));
  for (var $ = a.slice(), _ = createIdentityMatrix(s), _e = 0; _e < s; ++_e) {
    var tt = s * _e + _e;
    if (!throttle($[tt], TINY_NUM$1)) {
      for (var nt = _e + 1; nt < s; ++nt)
        if ($[s * _e + nt]) {
          swap($, _, _e, nt, s);
          break;
        }
    }
    if (!throttle($[tt], TINY_NUM$1))
      return [];
    divide($, _, _e, s, $[tt]);
    for (var nt = 0; nt < s; ++nt) {
      var at = nt, ot = nt + _e * s, rt = $[ot];
      !throttle(rt, TINY_NUM$1) || _e === nt || add($, _, at, _e, s, -rt);
    }
  }
  return _;
}
function transpose(a, s) {
  s === void 0 && (s = Math.sqrt(a.length));
  for (var $ = [], _ = 0; _ < s; ++_)
    for (var _e = 0; _e < s; ++_e)
      $[_e * s + _] = a[s * _ + _e];
  return $;
}
function getOrigin(a, s) {
  s === void 0 && (s = Math.sqrt(a.length));
  for (var $ = [], _ = a[s * s - 1], _e = 0; _e < s - 1; ++_e)
    $[_e] = a[s * (s - 1) + _e] / _;
  return $[s - 1] = 0, $;
}
function fromTranslation(a, s) {
  for (var $ = createIdentityMatrix(s), _ = 0; _ < s - 1; ++_)
    $[s * (s - 1) + _] = a[_] || 0;
  return $;
}
function convertPositionMatrix(a, s) {
  for (var $ = a.slice(), _ = a.length; _ < s - 1; ++_)
    $[_] = 0;
  return $[s - 1] = 1, $;
}
function convertDimension(a, s, $) {
  if (s === void 0 && (s = Math.sqrt(a.length)), s === $)
    return a;
  for (var _ = createIdentityMatrix($), _e = Math.min(s, $), tt = 0; tt < _e - 1; ++tt) {
    for (var nt = 0; nt < _e - 1; ++nt)
      _[tt * $ + nt] = a[tt * s + nt];
    _[(tt + 1) * $ - 1] = a[(tt + 1) * s - 1], _[($ - 1) * $ + tt] = a[(s - 1) * s + tt];
  }
  return _[$ * $ - 1] = a[s * s - 1], _;
}
function multiplies(a) {
  for (var s = [], $ = 1; $ < arguments.length; $++)
    s[$ - 1] = arguments[$];
  var _ = createIdentityMatrix(a);
  return s.forEach(function(_e) {
    _ = multiply(_, _e, a);
  }), _;
}
function multiply(a, s, $) {
  $ === void 0 && ($ = Math.sqrt(a.length));
  var _ = [], _e = a.length / $, tt = s.length / _e;
  if (_e) {
    if (!tt)
      return a;
  } else
    return s;
  for (var nt = 0; nt < $; ++nt)
    for (var at = 0; at < tt; ++at) {
      _[at * $ + nt] = 0;
      for (var ot = 0; ot < _e; ++ot)
        _[at * $ + nt] += a[ot * $ + nt] * s[at * _e + ot];
    }
  return _;
}
function plus(a, s) {
  for (var $ = Math.min(a.length, s.length), _ = a.slice(), _e = 0; _e < $; ++_e)
    _[_e] = _[_e] + s[_e];
  return _;
}
function minus(a, s) {
  for (var $ = Math.min(a.length, s.length), _ = a.slice(), _e = 0; _e < $; ++_e)
    _[_e] = _[_e] - s[_e];
  return _;
}
function convertCSStoMatrix(a, s) {
  return s === void 0 && (s = a.length === 6), s ? [a[0], a[1], 0, a[2], a[3], 0, a[4], a[5], 1] : a;
}
function convertMatrixtoCSS(a, s) {
  return s === void 0 && (s = a.length === 9), s ? [a[0], a[1], a[3], a[4], a[6], a[7]] : a;
}
function calculate(a, s, $) {
  $ === void 0 && ($ = s.length);
  var _ = multiply(a, s, $), _e = _[$ - 1];
  return _.map(function(tt) {
    return tt / _e;
  });
}
function rotateX3d(a, s) {
  return multiply(a, [1, 0, 0, 0, 0, Math.cos(s), Math.sin(s), 0, 0, -Math.sin(s), Math.cos(s), 0, 0, 0, 0, 1], 4);
}
function rotateY3d(a, s) {
  return multiply(a, [Math.cos(s), 0, -Math.sin(s), 0, 0, 1, 0, 0, Math.sin(s), 0, Math.cos(s), 0, 0, 0, 0, 1], 4);
}
function rotateZ3d(a, s) {
  return multiply(a, createRotateMatrix(s, 4));
}
function scale3d(a, s) {
  var $ = s[0], _ = $ === void 0 ? 1 : $, _e = s[1], tt = _e === void 0 ? 1 : _e, nt = s[2], at = nt === void 0 ? 1 : nt;
  return multiply(a, [_, 0, 0, 0, 0, tt, 0, 0, 0, 0, at, 0, 0, 0, 0, 1], 4);
}
function rotate(a, s) {
  return calculate(createRotateMatrix(s, 3), convertPositionMatrix(a, 3));
}
function translate3d(a, s) {
  var $ = s[0], _ = $ === void 0 ? 0 : $, _e = s[1], tt = _e === void 0 ? 0 : _e, nt = s[2], at = nt === void 0 ? 0 : nt;
  return multiply(a, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, _, tt, at, 1], 4);
}
function matrix3d(a, s) {
  return multiply(a, s, 4);
}
function createRotateMatrix(a, s) {
  var $ = Math.cos(a), _ = Math.sin(a), _e = createIdentityMatrix(s);
  return _e[0] = $, _e[1] = _, _e[s] = -_, _e[s + 1] = $, _e;
}
function createIdentityMatrix(a) {
  for (var s = a * a, $ = [], _ = 0; _ < s; ++_)
    $[_] = _ % (a + 1) ? 0 : 1;
  return $;
}
function createScaleMatrix(a, s) {
  for (var $ = createIdentityMatrix(s), _ = Math.min(a.length, s - 1), _e = 0; _e < _; ++_e)
    $[(s + 1) * _e] = a[_e];
  return $;
}
function createOriginMatrix(a, s) {
  for (var $ = createIdentityMatrix(s), _ = Math.min(a.length, s - 1), _e = 0; _e < _; ++_e)
    $[s * (s - 1) + _e] = a[_e];
  return $;
}
function createWarpMatrix(a, s, $, _, _e, tt, nt, at) {
  var ot = a[0], rt = a[1], st = s[0], lt = s[1], et = $[0], it = $[1], ut = _[0], ft = _[1], ht = _e[0], dt = _e[1], gt = tt[0], pt = tt[1], mt = nt[0], ct = nt[1], vt = at[0], At = at[1], xt = [ot, 0, st, 0, et, 0, ut, 0, rt, 0, lt, 0, it, 0, ft, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, ot, 0, st, 0, et, 0, ut, 0, rt, 0, lt, 0, it, 0, ft, 0, 1, 0, 1, 0, 1, 0, 1, -ht * ot, -dt * ot, -gt * st, -pt * st, -mt * et, -ct * et, -vt * ut, -At * ut, -ht * rt, -dt * rt, -gt * lt, -pt * lt, -mt * it, -ct * it, -vt * ft, -At * ft], bt = invert(xt, 8);
  if (!bt.length)
    return [];
  var Et = multiply(bt, [ht, dt, gt, pt, mt, ct, vt, At], 8);
  return Et[8] = 1, convertDimension(transpose(Et), 3, 4);
}
var __assign$5 = function() {
  return __assign$5 = Object.assign || function(s) {
    for (var $, _ = 1, _e = arguments.length; _ < _e; _++) {
      $ = arguments[_];
      for (var tt in $)
        Object.prototype.hasOwnProperty.call($, tt) && (s[tt] = $[tt]);
    }
    return s;
  }, __assign$5.apply(this, arguments);
};
function createMatrix() {
  return [
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1
  ];
}
function parseMat(a, s) {
  return s === void 0 && (s = 0), toMat(parse(a, s));
}
function calculateMatrixDist(a, s) {
  var $ = calculate(a, [s[0], s[1] || 0, s[2] || 0, 1], 4), _ = $[3] || 1;
  return [
    $[0] / _,
    $[1] / _,
    $[2] / _
  ];
}
function getDistElementMatrix(a, s) {
  s === void 0 && (s = document.body);
  for (var $ = a, _ = createMatrix(); $; ) {
    var _e = getComputedStyle($).transform;
    if (_ = matrix3d(parseMat(_e), _), $ === s)
      break;
    $ = $.parentElement;
  }
  return _ = invert(_, 4), _[12] = 0, _[13] = 0, _[14] = 0, _;
}
function toMat(a) {
  var s = createMatrix();
  return a.forEach(function($) {
    var _ = $.matrixFunction, _e = $.functionValue;
    _ && (s = _(s, _e));
  }), s;
}
function parse(a, s) {
  s === void 0 && (s = 0);
  var $ = isArray(a) ? a : splitSpace(a);
  return $.map(function(_) {
    var _e = splitBracket(_), tt = _e.prefix, nt = _e.value, at = null, ot = tt, rt = "";
    if (tt === "translate" || tt === "translateX" || tt === "translate3d") {
      var st = isObject$1(s) ? __assign$5(__assign$5({}, s), { "o%": s["%"] }) : {
        "%": s,
        "o%": s
      }, lt = splitComma(nt).map(function(Ot, Pt) {
        return Pt === 0 && "x%" in st ? st["%"] = s["x%"] : Pt === 1 && "y%" in st ? st["%"] = s["y%"] : st["%"] = s["o%"], convertUnitSize(Ot, st);
      }), et = lt[0], it = lt[1], ut = it === void 0 ? 0 : it, ft = lt[2], ht = ft === void 0 ? 0 : ft;
      at = translate3d, rt = [et, ut, ht];
    } else if (tt === "translateY") {
      var dt = isObject$1(s) ? __assign$5({ "%": s["y%"] }, s) : {
        "%": s
      }, ut = convertUnitSize(nt, dt);
      at = translate3d, rt = [0, ut, 0];
    } else if (tt === "translateZ") {
      var ht = parseFloat(nt);
      at = translate3d, rt = [0, 0, ht];
    } else if (tt === "scale" || tt === "scale3d") {
      var gt = splitComma(nt).map(function(Ot) {
        return parseFloat(Ot);
      }), pt = gt[0], mt = gt[1], ct = mt === void 0 ? pt : mt, vt = gt[2], At = vt === void 0 ? 1 : vt;
      at = scale3d, rt = [pt, ct, At];
    } else if (tt === "scaleX") {
      var pt = parseFloat(nt);
      at = scale3d, rt = [pt, 1, 1];
    } else if (tt === "scaleY") {
      var ct = parseFloat(nt);
      at = scale3d, rt = [1, ct, 1];
    } else if (tt === "scaleZ") {
      var At = parseFloat(nt);
      at = scale3d, rt = [1, 1, At];
    } else if (tt === "rotate" || tt === "rotateZ" || tt === "rotateX" || tt === "rotateY") {
      var xt = splitUnit(nt), bt = xt.unit, Et = xt.value, St = bt === "rad" ? Et : Et * Math.PI / 180;
      tt === "rotate" || tt === "rotateZ" ? (ot = "rotateZ", at = rotateZ3d) : tt === "rotateX" ? at = rotateX3d : tt === "rotateY" && (at = rotateY3d), rt = St;
    } else if (tt === "matrix3d")
      at = matrix3d, rt = splitComma(nt).map(function(Ot) {
        return parseFloat(Ot);
      });
    else if (tt === "matrix") {
      var Bt = splitComma(nt).map(function(Ot) {
        return parseFloat(Ot);
      });
      at = matrix3d, rt = [
        Bt[0],
        Bt[1],
        0,
        0,
        Bt[2],
        Bt[3],
        0,
        0,
        0,
        0,
        1,
        0,
        Bt[4],
        Bt[5],
        0,
        1
      ];
    } else
      ot = "";
    return {
      name: tt,
      functionName: ot,
      value: nt,
      matrixFunction: at,
      functionValue: rt
    };
  });
}
function hash(a) {
  for (var s = 5381, $ = a.length; $; )
    s = s * 33 ^ a.charCodeAt(--$);
  return s >>> 0;
}
var stringHash = hash;
function getHash(a) {
  return stringHash(a).toString(36);
}
function getShadowRoot(a) {
  if (a && a.getRootNode) {
    var s = a.getRootNode();
    if (s.nodeType === 11)
      return s;
  }
}
function replaceStyle(a, s, $) {
  return $.original ? s : s.replace(/([^};{\s}][^};{]*|^\s*){/mg, function(_, _e) {
    var tt = _e.trim();
    return (tt ? splitComma(tt) : [""]).map(function(nt) {
      var at = nt.trim();
      return at.indexOf("@") === 0 ? at : at.indexOf(":global") > -1 ? at.replace(/\:global/g, "") : at.indexOf(":host") > -1 ? "".concat(at.replace(/\:host/g, ".".concat(a))) : at ? ".".concat(a, " ").concat(at) : ".".concat(a);
    }).join(", ") + " {";
  });
}
function injectStyle(a, s, $, _, _e) {
  var tt = getDocument(_), nt = tt.createElement("style");
  return nt.setAttribute("type", "text/css"), nt.setAttribute("data-styled-id", a), nt.setAttribute("data-styled-count", "1"), $.nonce && nt.setAttribute("nonce", $.nonce), nt.innerHTML = replaceStyle(a, s, $), (_e || tt.head || tt.body).appendChild(nt), nt;
}
function styled(a) {
  var s = "rCS" + getHash(a);
  return {
    className: s,
    inject: function($, _) {
      _ === void 0 && (_ = {});
      var _e = getShadowRoot($), tt = (_e || $.ownerDocument || document).querySelector('style[data-styled-id="'.concat(s, '"]'));
      if (!tt)
        tt = injectStyle(s, a, _, $, _e);
      else {
        var nt = parseFloat(tt.getAttribute("data-styled-count")) || 0;
        tt.setAttribute("data-styled-count", "".concat(nt + 1));
      }
      return {
        destroy: function() {
          var at, ot = parseFloat(tt.getAttribute("data-styled-count")) || 0;
          ot <= 1 ? (tt.remove ? tt.remove() : (at = tt.parentNode) === null || at === void 0 || at.removeChild(tt), tt = null) : tt.setAttribute("data-styled-count", "".concat(ot - 1));
        }
      };
    }
  };
}
var extendStatics$5 = function(a, s) {
  return extendStatics$5 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function($, _) {
    $.__proto__ = _;
  } || function($, _) {
    for (var _e in _)
      Object.prototype.hasOwnProperty.call(_, _e) && ($[_e] = _[_e]);
  }, extendStatics$5(a, s);
};
function __extends$5(a, s) {
  if (typeof s != "function" && s !== null)
    throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
  extendStatics$5(a, s);
  function $() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : ($.prototype = s.prototype, new $());
}
var __assign$4 = function() {
  return __assign$4 = Object.assign || function(s) {
    for (var $, _ = 1, _e = arguments.length; _ < _e; _++) {
      $ = arguments[_];
      for (var tt in $)
        Object.prototype.hasOwnProperty.call($, tt) && (s[tt] = $[tt]);
    }
    return s;
  }, __assign$4.apply(this, arguments);
};
function __rest$2(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
}
function __decorate$2(a, s, $, _) {
  var _e = arguments.length, tt = _e < 3 ? s : _ === null ? _ = Object.getOwnPropertyDescriptor(s, $) : _, nt;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    tt = Reflect.decorate(a, s, $, _);
  else
    for (var at = a.length - 1; at >= 0; at--)
      (nt = a[at]) && (tt = (_e < 3 ? nt(tt) : _e > 3 ? nt(s, $, tt) : nt(s, $)) || tt);
  return _e > 3 && tt && Object.defineProperty(s, $, tt), tt;
}
function __spreadArray(a, s, $) {
  if ($ || arguments.length === 2)
    for (var _ = 0, _e = s.length, tt; _ < _e; _++)
      (tt || !(_ in s)) && (tt || (tt = Array.prototype.slice.call(s, 0, _)), tt[_] = s[_]);
  return a.concat(tt || Array.prototype.slice.call(s));
}
function getClient(a) {
  if ("touches" in a) {
    var s = a.touches[0] || a.changedTouches[0];
    return {
      clientX: s.clientX,
      clientY: s.clientY
    };
  } else
    return {
      clientX: a.clientX,
      clientY: a.clientY
    };
}
function filterDuplicated(a) {
  if (typeof Map > "u")
    return a.filter(function($, _) {
      return a.indexOf($) === _;
    });
  var s = /* @__PURE__ */ new Map();
  return a.filter(function($) {
    return s.has($) ? !1 : (s.set($, !0), !0);
  });
}
function elementFromPoint(a, s, $) {
  var _ = getDocument(a);
  return _.elementFromPoint && _.elementFromPoint(s, $) || null;
}
function createElement(a, s, $) {
  var _ = a.tag, _e = a.children, tt = a.attributes, nt = a.className, at = a.style, ot = s || getDocument($).createElement(_);
  for (var rt in tt)
    ot.setAttribute(rt, tt[rt]);
  var st = ot.children;
  if (_e.forEach(function(et, it) {
    createElement(et, st[it], ot);
  }), nt && nt.split(/\s+/g).forEach(function(et) {
    et && !hasClass(ot, et) && addClass(ot, et);
  }), at) {
    var lt = ot.style;
    for (var rt in at)
      lt[rt] = at[rt];
  }
  return !s && $ && $.appendChild(ot), ot;
}
function h(a, s) {
  for (var $ = [], _ = 2; _ < arguments.length; _++)
    $[_ - 2] = arguments[_];
  var _e = s || {}, tt = _e.className, nt = tt === void 0 ? "" : tt, at = _e.style, ot = at === void 0 ? {} : at, rt = __rest$2(_e, ["className", "style"]);
  return {
    tag: a,
    className: nt,
    style: ot,
    attributes: rt,
    children: $
  };
}
function diffValue(a, s, $) {
  a !== s && $(a, s);
}
function getRect$1(a, s, $) {
  var _;
  $ === void 0 && ($ = a.data.boundArea);
  var _e = a.distX, tt = _e === void 0 ? 0 : _e, nt = a.distY, at = nt === void 0 ? 0 : nt, ot = a.data, rt = ot.startX, st = ot.startY;
  if (s > 0) {
    var lt = Math.sqrt((tt * tt + at * at) / (1 + s * s)), et = s * lt;
    tt = (tt >= 0 ? 1 : -1) * et, at = (at >= 0 ? 1 : -1) * lt;
  }
  var it = Math.abs(tt), ut = Math.abs(at), ft = tt < 0 ? rt - $.left : $.right - rt, ht = at < 0 ? st - $.top : $.bottom - st;
  _ = calculateBoundSize([it, ut], [0, 0], [ft, ht], !!s), it = _[0], ut = _[1], tt = (tt >= 0 ? 1 : -1) * it, at = (at >= 0 ? 1 : -1) * ut;
  var dt = Math.min(0, tt), gt = Math.min(0, at), pt = rt + dt, mt = st + gt;
  return {
    left: pt,
    top: mt,
    right: pt + it,
    bottom: mt + ut,
    width: it,
    height: ut
  };
}
function getDefaultElementRect(a) {
  var s = a.getBoundingClientRect(), $ = s.left, _ = s.top, _e = s.width, tt = s.height;
  return {
    pos1: [$, _],
    pos2: [$ + _e, _],
    pos3: [$, _ + tt],
    pos4: [$ + _e, _ + tt]
  };
}
function passTargets(a, s, $) {
  var _ = diff(a, s), _e = _.list, tt = _.prevList, nt = _.added, at = _.removed, ot = _.maintained;
  return __spreadArray(__spreadArray(__spreadArray([], nt.map(function(rt) {
    return _e[rt];
  }), !0), at.map(function(rt) {
    return tt[rt];
  }), !0), $ ? ot.map(function(rt) {
    var st = rt[1];
    return _e[st];
  }) : [], !0);
}
function getLineSize(a) {
  for (var s = 0, $ = a.length, _ = 1; _ < $; ++_)
    s = Math.max(getDist$2(a[_], a[_ - 1]), s);
  return s;
}
var injector = styled(`
:host {
    position: fixed;
    display: none;
    border: 1px solid #4af;
    background: rgba(68, 170, 255, 0.5);
    pointer-events: none;
    will-change: transform;
    z-index: 100;
}
`), CLASS_NAME = "selecto-selection ".concat(injector.className), PROPERTIES$1 = ["className", "boundContainer", "selectableTargets", "selectByClick", "selectFromInside", "continueSelect", "continueSelectWithoutDeselect", "toggleContinueSelect", "toggleContinueSelectWithoutDeselect", "keyContainer", "hitRate", "scrollOptions", "checkInput", "preventDefault", "ratio", "getElementRect", "preventDragFromInside", "rootContainer", "dragCondition", "clickBySelectEnd", "checkOverflow", "innerScrollOptions"], OPTIONS = __spreadArray([
  // ignore target, container,
  "dragContainer",
  "cspNonce",
  "preventClickEventOnDrag",
  "preventClickEventOnDragStart",
  "preventRightClick"
], PROPERTIES$1, !0), EVENTS = ["dragStart", "drag", "dragEnd", "selectStart", "select", "selectEnd", "keydown", "keyup", "scroll", "innerScroll"], METHODS = ["clickTarget", "getSelectableElements", "setSelectedTargets", "getElementPoints", "getSelectedTargets", "findSelectableTargets", "triggerDragStart", "checkScroll", "selectTargetsByPoints", "setSelectedTargetsByPoints"], Selecto$3 = /* @__PURE__ */ function(a) {
  __extends$5(s, a);
  function s(_) {
    _ === void 0 && (_ = {});
    var _e = a.call(this) || this;
    _e.selectedTargets = [], _e.dragScroll = new DragScroll$1(), _e._onDragStart = function(at, ot) {
      var rt = at.data, st = at.clientX, lt = at.clientY, et = at.inputEvent, it = _e.options, ut = it.selectFromInside, ft = it.selectByClick, ht = it.rootContainer, dt = it.boundContainer, gt = it.preventDragFromInside, pt = gt === void 0 ? !0 : gt, mt = it.clickBySelectEnd, ct = it.dragCondition;
      if (ct && !ct(at)) {
        at.stop();
        return;
      }
      rt.data = {};
      var vt = getWindow(_e.container);
      rt.innerWidth = vt.innerWidth, rt.innerHeight = vt.innerHeight, _e.findSelectableTargets(rt), rt.startSelectedTargets = _e.selectedTargets, rt.scaleMatrix = createMatrix(), rt.containerX = 0, rt.containerY = 0;
      var At = _e.container, xt = {
        left: -1 / 0,
        top: -1 / 0,
        right: 1 / 0,
        bottom: 1 / 0
      };
      if (ht) {
        var bt = _e.container.getBoundingClientRect();
        rt.containerX = bt.left, rt.containerY = bt.top, rt.scaleMatrix = getDistElementMatrix(_e.container, ht);
      }
      if (dt) {
        var Et = isObject$1(dt) && "element" in dt ? __assign$4({
          left: !0,
          top: !0,
          bottom: !0,
          right: !0
        }, dt) : {
          element: dt,
          left: !0,
          top: !0,
          bottom: !0,
          right: !0
        }, St = Et.element, Bt = void 0;
        if (St) {
          isString(St) ? Bt = getDocument(At).querySelector(St) : St === !0 ? Bt = _e.container : Bt = St;
          var Ot = Bt.getBoundingClientRect();
          Et.left && (xt.left = Ot.left), Et.top && (xt.top = Ot.top), Et.right && (xt.right = Ot.right), Et.bottom && (xt.bottom = Ot.bottom);
        }
      }
      rt.boundArea = xt;
      var Pt = {
        left: st,
        top: lt,
        right: st,
        bottom: lt,
        width: 0,
        height: 0
      }, wt = [], Ct = ft && !mt, It = !1;
      if (!ut || Ct) {
        var yt = _e._findElement(
          ot || et.target,
          // elementFromPoint(clientX, clientY),
          rt.selectableTargets
        );
        It = !!yt, Ct && (wt = yt ? [yt] : []);
      }
      var Rt = !ut && It;
      if (Rt && !ft)
        return at.stop(), !1;
      var kt = et.type, jt = kt === "mousedown" || kt === "touchstart", Ht = !at.isClick && jt ? _e.emit("dragStart", __assign$4(__assign$4({}, at), {
        data: rt.data
      })) : !0;
      if (!Ht)
        return at.stop(), !1;
      if (_e.continueSelect ? (wt = passTargets(_e.selectedTargets, wt, _e.continueSelectWithoutDeselect), rt.startPassedTargets = _e.selectedTargets) : rt.startPassedTargets = [], _e._select(wt, Pt, at, !0, Rt && ft && !mt && pt), rt.startX = st, rt.startY = lt, rt.selectFlag = !1, rt.preventDragFromInside = !1, et.target) {
        var Ft = calculateMatrixDist(rt.scaleMatrix, [st - rt.containerX, lt - rt.containerY]);
        _e.target.style.cssText += "position: ".concat(ht ? "absolute" : "fixed", ";") + "left:0px;top:0px;" + "transform: translate(".concat(Ft[0], "px, ").concat(Ft[1], "px)");
      }
      if (Rt && ft && !mt)
        et.preventDefault(), pt && (_e._selectEnd(rt.startSelectedTargets, rt.startPassedTargets, Pt, at, !0), rt.preventDragFromInside = !0);
      else {
        rt.selectFlag = !0;
        var _t = _e.options, Nt = _t.scrollOptions, Mt = _t.innerScrollOptions, Lt = !1;
        if (Mt) {
          for (var $t = at.inputEvent, Tt = $t.target, Dt = null, Ut = Tt; Ut && Ut !== getDocument(At).body; ) {
            var Vt = getComputedStyle(Ut).overflow !== "visible";
            if (Vt) {
              Dt = Ut;
              break;
            }
            Ut = Ut.parentElement;
          }
          Dt && (rt.innerScrollOptions = __assign$4({
            container: Dt,
            checkScrollEvent: !0
          }, Mt === !0 ? {} : Mt), _e.dragScroll.dragStart(at, rt.innerScrollOptions), Lt = !0);
        }
        !Lt && Nt && Nt.container && _e.dragScroll.dragStart(at, Nt), Rt && ft && mt && (rt.selectFlag = !1, at.preventDrag());
      }
      return !0;
    }, _e._onDrag = function(at) {
      if (at.data.selectFlag) {
        var ot = _e.scrollOptions, rt = at.data.innerScrollOptions, st = rt || (ot == null ? void 0 : ot.container);
        if (st && !at.isScroll && _e.dragScroll.drag(at, rt || ot))
          return;
      }
      _e._checkSelected(at);
    }, _e._onDragEnd = function(at) {
      var ot = at.data, rt = at.inputEvent, st = getRect$1(at, _e.options.ratio), lt = ot.selectFlag, et = _e.container;
      if (rt && _e.emit("dragEnd", __assign$4(__assign$4({
        isDouble: !!at.isDouble,
        isClick: !!at.isClick,
        isDrag: !1,
        isSelect: lt
      }, at), {
        data: ot.data,
        rect: st
      })), _e.target.style.cssText += "display: none;", lt)
        ot.selectFlag = !1, _e.dragScroll.dragEnd();
      else if (_e.selectByClick && _e.clickBySelectEnd) {
        var it = _e._findElement((rt == null ? void 0 : rt.target) || elementFromPoint(et, at.clientX, at.clientY), ot.selectableTargets);
        _e._select(it ? [it] : [], st, at);
      }
      ot.preventDragFromInside || _e._selectEnd(ot.startSelectedTargets, ot.startPassedTargets, st, at);
    }, _e._onKeyDown = function(at) {
      var ot = _e.options, rt = !1;
      if (!_e._keydownContinueSelect) {
        var st = _e._sameCombiKey(at, ot.toggleContinueSelect);
        _e._keydownContinueSelect = st, rt || (rt = st);
      }
      if (!_e._keydownContinueSelectWithoutDeselection) {
        var st = _e._sameCombiKey(at, ot.toggleContinueSelectWithoutDeselect);
        _e._keydownContinueSelectWithoutDeselection = st, rt || (rt = st);
      }
      rt && _e.emit("keydown", {
        keydownContinueSelect: _e._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: _e._keydownContinueSelectWithoutDeselection
      });
    }, _e._onKeyUp = function(at) {
      var ot = _e.options, rt = !1;
      if (_e._keydownContinueSelect) {
        var st = _e._sameCombiKey(at, ot.toggleContinueSelect, !0);
        _e._keydownContinueSelect = !st, rt || (rt = st);
      }
      if (_e._keydownContinueSelectWithoutDeselection) {
        var st = _e._sameCombiKey(at, ot.toggleContinueSelectWithoutDeselect, !0);
        _e._keydownContinueSelectWithoutDeselection = !st, rt || (rt = st);
      }
      rt && _e.emit("keyup", {
        keydownContinueSelect: _e._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: _e._keydownContinueSelectWithoutDeselection
      });
    }, _e._onBlur = function() {
      (_e._keydownContinueSelect || _e._keydownContinueSelectWithoutDeselection) && (_e._keydownContinueSelect = !1, _e._keydownContinueSelectWithoutDeselection = !1, _e.emit("keyup", {
        keydownContinueSelect: _e._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: _e._keydownContinueSelectWithoutDeselection
      }));
    }, _e._onDocumentSelectStart = function(at) {
      var ot = getDocument(_e.container);
      if (_e.gesto.isFlag()) {
        var rt = _e.dragContainer;
        rt === getWindow(_e.container) && (rt = ot.documentElement);
        var st = isNode(rt) ? [rt] : [].slice.call(rt), lt = at.target;
        st.some(function(et) {
          if (et === lt || et.contains(lt))
            return at.preventDefault(), !0;
        });
      }
    }, _e.target = _.portalContainer;
    var tt = _.container;
    _e.options = __assign$4({
      className: "",
      portalContainer: null,
      container: null,
      dragContainer: null,
      selectableTargets: [],
      selectByClick: !0,
      selectFromInside: !0,
      clickBySelectEnd: !1,
      hitRate: 100,
      continueSelect: !1,
      continueSelectWithoutDeselect: !1,
      toggleContinueSelect: null,
      toggleContinueSelectWithoutDeselect: null,
      keyContainer: null,
      scrollOptions: null,
      checkInput: !1,
      preventDefault: !1,
      boundContainer: !1,
      preventDragFromInside: !0,
      dragCondition: null,
      rootContainer: null,
      checkOverflow: !1,
      innerScrollOptions: !1,
      getElementRect: getDefaultElementRect,
      cspNonce: "",
      ratio: 0
    }, _);
    var nt = _e.options.portalContainer;
    return nt && (tt = nt.parentElement), _e.container = tt || document.body, _e.initElement(), _e.initDragScroll(), _e.setKeyController(), _e;
  }
  var $ = s.prototype;
  return $.setSelectedTargets = function(_) {
    var _e = this.selectedTargets, tt = diff(_e, _), nt = tt.added, at = tt.removed, ot = tt.prevList, rt = tt.list;
    return this.selectedTargets = _, {
      added: nt.map(function(st) {
        return rt[st];
      }),
      removed: at.map(function(st) {
        return ot[st];
      }),
      beforeSelected: _e,
      selected: _
    };
  }, $.setSelectedTargetsByPoints = function(_, _e) {
    var tt = Math.min(_[0], _e[0]), nt = Math.min(_[1], _e[1]), at = Math.max(_[0], _e[0]), ot = Math.max(_[1], _e[1]), rt = {
      left: tt,
      top: nt,
      right: at,
      bottom: ot,
      width: at - tt,
      height: ot - nt
    }, st = {
      ignoreClick: !0
    };
    this.findSelectableTargets(st);
    var lt = this.hitTest(rt, st, !0, null), et = this.setSelectedTargets(lt);
    return __assign$4(__assign$4({}, et), {
      rect: rt
    });
  }, $.selectTargetsByPoints = function(_, _e) {
    var tt = new MouseEvent("mousedown", {
      clientX: _[0],
      clientY: _[1],
      cancelable: !0,
      bubbles: !0
    }), nt = new MouseEvent("mousemove", {
      clientX: _e[0],
      clientY: _e[1],
      cancelable: !0,
      bubbles: !0
    }), at = new MouseEvent("mousemove", {
      clientX: _e[0],
      clientY: _e[1],
      cancelable: !0,
      bubbles: !0
    }), ot = this.gesto, rt = ot.onDragStart(tt);
    rt !== !1 && (ot.onDrag(nt), ot.onDragEnd(at));
  }, $.getSelectedTargets = function() {
    return this.selectedTargets;
  }, $.triggerDragStart = function(_) {
    return this.gesto.triggerDragStart(_), this;
  }, $.destroy = function() {
    var _;
    this.off(), this.keycon && this.keycon.destroy(), this.gesto.unset(), this.injectResult.destroy(), this.dragScroll.dragEnd(), removeEvent(document, "selectstart", this._onDocumentSelectStart), this.options.portalContainer || (_ = this.target.parentElement) === null || _ === void 0 || _.removeChild(this.target), this.keycon = null, this.gesto = null, this.injectResult = null, this.target = null, this.container = null, this.options = null;
  }, $.getElementPoints = function(_) {
    var _e = this.getElementRect || getDefaultElementRect, tt = _e(_), nt = [tt.pos1, tt.pos2, tt.pos4, tt.pos3];
    if (_e !== getDefaultElementRect) {
      var at = _.getBoundingClientRect();
      return fitPoints(nt, at);
    }
    return nt;
  }, $.getSelectableElements = function() {
    var _ = this.container, _e = [];
    return this.options.selectableTargets.forEach(function(tt) {
      if (isFunction(tt)) {
        var nt = tt();
        nt && _e.push.apply(_e, [].slice.call(nt));
      } else if (isNode(tt))
        _e.push(tt);
      else if (isObject$1(tt))
        _e.push(tt.value || tt.current);
      else {
        var at = [].slice.call(getDocument(_).querySelectorAll(tt));
        _e.push.apply(_e, at);
      }
    }), _e;
  }, $.checkScroll = function() {
    if (this.gesto.isFlag()) {
      var _ = this.scrollOptions, _e = this.gesto.getEventData().innerScrollOptions, tt = _e || (_ == null ? void 0 : _.container);
      tt && this.dragScroll.checkScroll(__assign$4({
        inputEvent: this.gesto.getCurrentEvent()
      }, _e || _));
    }
  }, $.findSelectableTargets = function(_) {
    var _e = this;
    _ === void 0 && (_ = this.gesto.getEventData());
    var tt = this.getSelectableElements(), nt = tt.map(function(lt) {
      return _e.getElementPoints(lt);
    });
    _.selectableTargets = tt, _.selectablePoints = nt, _.selectableParentMap = null;
    var at = this.options, ot = at.checkOverflow || at.innerScrollOptions, rt = getDocument(this.container);
    if (ot) {
      var st = /* @__PURE__ */ new Map();
      _.selectableInnerScrollParentMap = st, _.selectableInnerScrollPathsList = tt.map(function(lt, et) {
        for (var it = lt.parentElement, ut = [], ft = [], ht = function() {
          var dt = st.get(it);
          if (!dt) {
            var gt = getComputedStyle(it).overflow !== "visible";
            if (gt) {
              var pt = getDefaultElementRect(it);
              dt = {
                parentElement: it,
                indexes: [],
                points: [pt.pos1, pt.pos2, pt.pos4, pt.pos3],
                paths: __spreadArray([], ft, !0)
              }, ut.push(it), ut.forEach(function(mt) {
                st.set(mt, dt);
              }), ut = [];
            }
          }
          dt ? (it = dt.parentElement, st.get(it).indexes.push(et), ft.push(it)) : ut.push(it), it = it.parentElement;
        }; it && it !== rt.body; )
          ht();
        return ft;
      });
    }
    return at.checkOverflow || (_.selectableInners = tt.map(function() {
      return !0;
    })), this._refreshGroups(_), tt;
  }, $.clickTarget = function(_, _e) {
    var tt = getClient(_), nt = tt.clientX, at = tt.clientY, ot = {
      data: {
        selectFlag: !1
      },
      clientX: nt,
      clientY: at,
      inputEvent: _,
      isClick: !0,
      isTrusted: !1,
      stop: function() {
        return !1;
      }
    };
    return this._onDragStart(ot, _e) && this._onDragEnd(ot), this;
  }, $.setKeyController = function() {
    var _ = this.options, _e = _.keyContainer, tt = _.toggleContinueSelect, nt = _.toggleContinueSelectWithoutDeselect;
    this.keycon && (this.keycon.destroy(), this.keycon = null), (tt || nt) && (this.keycon = new KeyController$1(_e || getWindow(this.container)), this.keycon.keydown(this._onKeyDown).keyup(this._onKeyUp).on("blur", this._onBlur));
  }, $.setClassName = function(_) {
    this.options.className = _, this.target.setAttribute("class", "".concat(CLASS_NAME, " ").concat(_ || ""));
  }, $.setKeyEvent = function() {
    var _ = this.options, _e = _.toggleContinueSelect, tt = _.toggleContinueSelectWithoutDeselect;
    !_e && !tt || this.keycon || this.setKeyController();
  }, $.setKeyContainer = function(_) {
    var _e = this, tt = this.options;
    diffValue(tt.keyContainer, _, function() {
      tt.keyContainer = _, _e.setKeyController();
    });
  }, $.getContinueSelect = function() {
    var _ = this.options, _e = _.continueSelect, tt = _.toggleContinueSelect;
    return !tt || !this._keydownContinueSelect ? _e : !_e;
  }, $.getContinueSelectWithoutDeselect = function() {
    var _ = this.options, _e = _.continueSelectWithoutDeselect, tt = _.toggleContinueSelectWithoutDeselect;
    return !tt || !this._keydownContinueSelectWithoutDeselection ? _e : !_e;
  }, $.setToggleContinueSelect = function(_) {
    var _e = this, tt = this.options;
    diffValue(tt.toggleContinueSelect, _, function() {
      tt.toggleContinueSelect = _, _e.setKeyEvent();
    });
  }, $.setToggleContinueSelectWithoutDeselect = function(_) {
    var _e = this, tt = this.options;
    diffValue(tt.toggleContinueSelectWithoutDeselect, _, function() {
      tt.toggleContinueSelectWithoutDeselect = _, _e.setKeyEvent();
    });
  }, $.setPreventDefault = function(_) {
    this.gesto.options.preventDefault = _;
  }, $.setCheckInput = function(_) {
    this.gesto.options.checkInput = _;
  }, $.initElement = function() {
    var _ = this.options, _e = _.dragContainer, tt = _.checkInput, nt = _.preventDefault, at = _.preventClickEventOnDragStart, ot = _.preventClickEventOnDrag, rt = _.preventClickEventByCondition, st = _.preventRightClick, lt = st === void 0 ? !0 : st, et = _.className, it = this.container;
    this.target = createElement(h("div", {
      className: "".concat(CLASS_NAME, " ").concat(et || "")
    }), this.target, it);
    var ut = this.target;
    this.dragContainer = typeof _e == "string" ? [].slice.call(getDocument(it).querySelectorAll(_e)) : _e || this.target.parentNode, this.gesto = new Gesto(this.dragContainer, {
      checkWindowBlur: !0,
      container: getWindow(it),
      checkInput: tt,
      preventDefault: nt,
      preventClickEventOnDragStart: at,
      preventClickEventOnDrag: ot,
      preventClickEventByCondition: rt,
      preventRightClick: lt
    }).on({
      dragStart: this._onDragStart,
      drag: this._onDrag,
      dragEnd: this._onDragEnd
    }), addEvent(document, "selectstart", this._onDocumentSelectStart), this.injectResult = injector.inject(ut, {
      nonce: this.options.cspNonce
    });
  }, $.hitTest = function(_, _e, tt, nt) {
    var at = this.options, ot = at.hitRate, rt = at.selectByClick, st = _.left, lt = _.top, et = _.right, it = _.bottom, ut = _e.innerGroups, ft = _e.innerWidth, ht = _e.innerHeight, dt = nt == null ? void 0 : nt.clientX, gt = nt == null ? void 0 : nt.clientY, pt = _e.ignoreClick, mt = [[st, lt], [et, lt], [et, it], [st, it]], ct = function(yt, Rt) {
      var kt = splitUnit(typeof ot == "function" ? "".concat(ot(Rt)) : "".concat(ot)), jt = pt ? !1 : isInside([dt, gt], yt);
      if (!tt && rt && jt)
        return !0;
      var Ht = getOverlapPoints(mt, yt);
      if (!Ht.length)
        return !1;
      var Ft = getAreaSize(Ht), _t = 0;
      if (Ft === 0 && getAreaSize(yt) === 0 ? (_t = getLineSize(yt), Ft = getLineSize(Ht)) : _t = getAreaSize(yt), kt.unit === "px")
        return Ft >= kt.value;
      var Nt = between(Math.round(Ft / _t * 100), 0, 100);
      return Nt >= Math.min(100, kt.value);
    }, vt = _e.selectableTargets, At = _e.selectablePoints, xt = _e.selectableInners;
    if (!ut)
      return vt.filter(function(yt, Rt) {
        return xt[Rt] ? ct(At[Rt], vt[Rt]) : !1;
      });
    for (var bt = [], Et = Math.floor(st / ft), St = Math.floor(et / ft), Bt = Math.floor(lt / ht), Ot = Math.floor(it / ht), Pt = Et; Pt <= St; ++Pt) {
      var wt = ut[Pt];
      if (wt)
        for (var Ct = Bt; Ct <= Ot; ++Ct) {
          var It = wt[Ct];
          It && It.forEach(function(yt) {
            var Rt = At[yt], kt = xt[yt], jt = vt[yt];
            kt && ct(Rt, jt) && bt.push(jt);
          });
        }
    }
    return filterDuplicated(bt);
  }, $.initDragScroll = function() {
    var _ = this;
    this.dragScroll.on("scrollDrag", function(_e) {
      var tt = _e.next;
      tt(_.gesto.getCurrentEvent());
    }).on("scroll", function(_e) {
      var tt = _e.container, nt = _e.direction, at = _.gesto.getEventData().innerScrollOptions;
      at ? _.emit("innerScroll", {
        container: tt,
        direction: nt
      }) : _.emit("scroll", {
        container: tt,
        direction: nt
      });
    }).on("move", function(_e) {
      var tt = _e.offsetX, nt = _e.offsetY, at = _e.inputEvent, ot = _.gesto;
      if (!(!ot || !ot.isFlag())) {
        var rt = _.gesto.getEventData(), st = rt.boundArea;
        rt.startX -= tt, rt.startY -= nt;
        var lt = _.gesto.getEventData().innerScrollOptions, et = lt == null ? void 0 : lt.container, it = !1;
        if (et) {
          var ut = rt.selectableInnerScrollParentMap, ft = ut.get(et);
          ft && (ft.paths.forEach(function(ht) {
            var dt = ut.get(ht);
            dt.points.forEach(function(gt) {
              gt[0] -= tt, gt[1] -= nt;
            });
          }), ft.indexes.forEach(function(ht) {
            rt.selectablePoints[ht].forEach(function(dt) {
              dt[0] -= tt, dt[1] -= nt;
            });
          }), it = !0);
        }
        it || rt.selectablePoints.forEach(function(ht) {
          ht.forEach(function(dt) {
            dt[0] -= tt, dt[1] -= nt;
          });
        }), _._refreshGroups(rt), st.left -= tt, st.right -= tt, st.top -= nt, st.bottom -= nt, _.gesto.scrollBy(tt, nt, at.inputEvent), _._checkSelected(_.gesto.getCurrentEvent());
      }
    });
  }, $._select = function(_, _e, tt, nt, at) {
    at === void 0 && (at = !1);
    var ot = tt.inputEvent, rt = tt.data, st = this.setSelectedTargets(_), lt = diff(rt.startSelectedTargets, _), et = lt.added, it = lt.removed, ut = lt.prevList, ft = lt.list, ht = {
      startSelected: ut,
      startAdded: et.map(function(dt) {
        return ft[dt];
      }),
      startRemoved: it.map(function(dt) {
        return ut[dt];
      })
    };
    nt && this.emit("selectStart", __assign$4(__assign$4(__assign$4({}, st), ht), {
      rect: _e,
      inputEvent: ot,
      data: rt.data,
      isTrusted: tt.isTrusted,
      isDragStartEnd: at
    })), (st.added.length || st.removed.length) && this.emit("select", __assign$4(__assign$4(__assign$4({}, st), ht), {
      rect: _e,
      inputEvent: ot,
      data: rt.data,
      isTrusted: tt.isTrusted,
      isDragStartEnd: at
    }));
  }, $._selectEnd = function(_, _e, tt, nt, at) {
    at === void 0 && (at = !1);
    var ot = nt.inputEvent, rt = nt.isDouble, st = nt.data, lt = ot && ot.type, et = lt === "mousedown" || lt === "touchstart", it = diff(_, this.selectedTargets), ut = it.added, ft = it.removed, ht = it.prevList, dt = it.list, gt = diff(_e, this.selectedTargets), pt = gt.added, mt = gt.removed, ct = gt.prevList, vt = gt.list;
    this.emit("selectEnd", {
      startSelected: _,
      beforeSelected: _e,
      selected: this.selectedTargets,
      added: ut.map(function(At) {
        return dt[At];
      }),
      removed: ft.map(function(At) {
        return ht[At];
      }),
      afterAdded: pt.map(function(At) {
        return vt[At];
      }),
      afterRemoved: mt.map(function(At) {
        return ct[At];
      }),
      isDragStart: et && at,
      isDragStartEnd: et && at,
      isClick: !!nt.isClick,
      isDouble: !!rt,
      rect: tt,
      inputEvent: ot,
      data: st.data,
      isTrusted: nt.isTrusted
    });
  }, $._checkSelected = function(_, _e) {
    _e === void 0 && (_e = getRect$1(_, this.options.ratio));
    var tt = _.data, nt = _e.top, at = _e.left, ot = _e.width, rt = _e.height, st = tt.selectFlag, lt = tt.containerX, et = tt.containerY, it = tt.scaleMatrix, ut = calculateMatrixDist(it, [at - lt, nt - et]), ft = calculateMatrixDist(it, [ot, rt]), ht = [];
    if (st) {
      this.target.style.cssText += "display: block;left:0px;top:0px;" + "transform: translate(".concat(ut[0], "px, ").concat(ut[1], "px);") + "width:".concat(ft[0], "px;height:").concat(ft[1], "px;");
      var dt = this.hitTest(_e, tt, !0, _);
      ht = passTargets(tt.startPassedTargets, dt, this.continueSelect && this.continueSelectWithoutDeselect);
    }
    var gt = this.emit("drag", __assign$4(__assign$4({}, _), {
      data: tt.data,
      isSelect: st,
      rect: _e
    }));
    if (gt === !1) {
      this.target.style.cssText += "display: none;", _.stop();
      return;
    }
    st && this._select(ht, _e, _);
  }, $._sameCombiKey = function(_, _e, tt) {
    if (!_e)
      return !1;
    var nt = getCombi(_.inputEvent, _.key), at = [].concat(_e), ot = isArray(at[0]) ? at : [at];
    if (tt) {
      var rt = _.key;
      return ot.some(function(st) {
        return st.some(function(lt) {
          return lt === rt;
        });
      });
    }
    return ot.some(function(st) {
      return st.every(function(lt) {
        return nt.indexOf(lt) > -1;
      });
    });
  }, $._findElement = function(_, _e) {
    for (var tt = _; tt && !(_e.indexOf(tt) > -1); )
      tt = tt.parentElement;
    return tt;
  }, $._refreshGroups = function(_) {
    var _e, tt = _.innerWidth, nt = _.innerHeight, at = _.selectablePoints;
    if (this.options.checkOverflow) {
      var ot = (_e = this.gesto.getEventData().innerScrollOptions) === null || _e === void 0 ? void 0 : _e.container, rt = _.selectableInnerScrollParentMap, st = _.selectableInnerScrollPathsList;
      _.selectableInners = st.map(function(it, ut) {
        var ft = !1;
        return it.every(function(ht) {
          if (ft)
            return !0;
          if (ht === ot)
            return ft = !0, !0;
          var dt = rt.get(ht);
          if (dt) {
            var gt = at[ut], pt = dt.points, mt = getOverlapPoints(gt, pt);
            if (!mt.length)
              return !1;
          }
          return !0;
        });
      });
    }
    if (!tt || !nt)
      _.innerGroups = null;
    else {
      var lt = _.selectablePoints, et = {};
      lt.forEach(function(it, ut) {
        var ft = 1 / 0, ht = -1 / 0, dt = 1 / 0, gt = -1 / 0;
        it.forEach(function(ct) {
          var vt = Math.floor(ct[0] / tt), At = Math.floor(ct[1] / nt);
          ft = Math.min(vt, ft), ht = Math.max(vt, ht), dt = Math.min(At, dt), gt = Math.max(At, gt);
        });
        for (var pt = ft; pt <= ht; ++pt)
          for (var mt = dt; mt <= gt; ++mt)
            et[pt] = et[pt] || {}, et[pt][mt] = et[pt][mt] || [], et[pt][mt].push(ut);
      }), _.innerGroups = et;
    }
  }, s = __decorate$2([Properties(PROPERTIES$1, function(_, _e) {
    var tt = {
      enumerable: !0,
      configurable: !0,
      get: function() {
        return this.options[_e];
      }
    }, nt = camelize("get ".concat(_e));
    _[nt] ? tt.get = function() {
      return this[nt]();
    } : tt.get = function() {
      return this.options[_e];
    };
    var at = camelize("set ".concat(_e));
    _[at] ? tt.set = function(ot) {
      this[at](ot);
    } : tt.set = function(ot) {
      this.options[_e] = ot;
    }, Object.defineProperty(_, _e, tt);
  })], s), s;
}(EventEmitter$1), Selecto$1$1 = /* @__PURE__ */ function(a) {
  __extends$5(s, a);
  function s() {
    return a !== null && a.apply(this, arguments) || this;
  }
  return s;
}(Selecto$3);
const VanillaSelecto = Selecto$1$1;
var extendStatics$4 = function(a, s) {
  return extendStatics$4 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function($, _) {
    $.__proto__ = _;
  } || function($, _) {
    for (var _e in _)
      Object.prototype.hasOwnProperty.call(_, _e) && ($[_e] = _[_e]);
  }, extendStatics$4(a, s);
};
function __extends$4(a, s) {
  if (typeof s != "function" && s !== null)
    throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
  extendStatics$4(a, s);
  function $() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : ($.prototype = s.prototype, new $());
}
var __assign$3 = function() {
  return __assign$3 = Object.assign || function(s) {
    for (var $, _ = 1, _e = arguments.length; _ < _e; _++) {
      $ = arguments[_];
      for (var tt in $)
        Object.prototype.hasOwnProperty.call($, tt) && (s[tt] = $[tt]);
    }
    return s;
  }, __assign$3.apply(this, arguments);
};
function __decorate$1(a, s, $, _) {
  var _e = arguments.length, tt = _e < 3 ? s : _ === null ? _ = Object.getOwnPropertyDescriptor(s, $) : _, nt;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    tt = Reflect.decorate(a, s, $, _);
  else
    for (var at = a.length - 1; at >= 0; at--)
      (nt = a[at]) && (tt = (_e < 3 ? nt(tt) : _e > 3 ? nt(s, $, tt) : nt(s, $)) || tt);
  return _e > 3 && tt && Object.defineProperty(s, $, tt), tt;
}
var REACT_EVENTS = EVENTS.map(function(a) {
  return camelize("on ".concat(a));
}), Selecto$1 = /* @__PURE__ */ function(a) {
  __extends$4(s, a);
  function s() {
    return a !== null && a.apply(this, arguments) || this;
  }
  var $ = s.prototype;
  return $.render = function() {
    return reactExports.createElement("div", {
      className: CLASS_NAME,
      ref: ref(this, "selectionElement")
    });
  }, $.componentDidMount = function() {
    var _ = this, _e = this.props, tt = {};
    OPTIONS.forEach(function(nt) {
      nt in _e && (tt[nt] = _e[nt]);
    }), this.selecto = new VanillaSelecto(__assign$3(__assign$3({}, tt), {
      portalContainer: this.selectionElement
    })), EVENTS.forEach(function(nt, at) {
      _.selecto.on(nt, function(ot) {
        var rt = _.props, st = rt[REACT_EVENTS[at]] && rt[REACT_EVENTS[at]](ot);
        st === !1 && ot.stop();
      });
    });
  }, $.componentDidUpdate = function(_) {
    var _e = this.props, tt = this.selecto;
    PROPERTIES$1.forEach(function(nt) {
      _[nt] !== _e[nt] && (tt[nt] = _e[nt]);
    });
  }, $.componentWillUnmount = function() {
    this.selecto.destroy();
  }, __decorate$1([withMethods(METHODS)], s.prototype, "selecto", void 0), s;
}(reactExports.PureComponent);
const Selecto$2 = Selecto$1, className$1 = "pdfme-selecto", _Selecto = (a) => {
  const { token: s } = theme.useToken();
  return reactExports.useEffect(() => {
    const $ = document.querySelector("." + className$1);
    $ && ($.style.backgroundColor = s.colorPrimary, $.style.opacity = "0.75", $.style.borderColor = s.colorPrimaryBorder);
  }, [a.container]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Selecto$2,
    {
      className: className$1,
      selectFromInside: !1,
      selectByClick: !0,
      preventDefault: !0,
      hitRate: 0,
      selectableTargets: [`.${SELECTABLE_CLASSNAME}`],
      container: a.container,
      continueSelect: a.continueSelect,
      onDragStart: a.onDragStart,
      onSelect: a.onSelect
    }
  );
}, Selecto = _Selecto;
function some(a, s) {
  for (var $ = a.length, _ = 0; _ < $; ++_)
    if (s(a[_], _))
      return !0;
  return !1;
}
function find(a, s) {
  for (var $ = a.length, _ = 0; _ < $; ++_)
    if (s(a[_], _))
      return a[_];
  return null;
}
function getUserAgentString(a) {
  var s = a;
  if (typeof s > "u") {
    if (typeof navigator > "u" || !navigator)
      return "";
    s = navigator.userAgent || "";
  }
  return s.toLowerCase();
}
function execRegExp(a, s) {
  try {
    return new RegExp(a, "g").exec(s);
  } catch {
    return null;
  }
}
function hasUserAgentData() {
  if (typeof navigator > "u" || !navigator || !navigator.userAgentData)
    return !1;
  var a = navigator.userAgentData, s = a.brands || a.uaList;
  return !!(s && s.length);
}
function findVersion(a, s) {
  var $ = execRegExp("(" + a + ")((?:\\/|\\s|:)([0-9|\\.|_]+))", s);
  return $ ? $[3] : "";
}
function convertVersion(a) {
  return a.replace(/_/g, ".");
}
function findPreset(a, s) {
  var $ = null, _ = "-1";
  return some(a, function(_e) {
    var tt = execRegExp("(" + _e.test + ")((?:\\/|\\s|:)([0-9|\\.|_]+))?", s);
    return !tt || _e.brand ? !1 : ($ = _e, _ = tt[3] || "-1", _e.versionAlias ? _ = _e.versionAlias : _e.versionTest && (_ = findVersion(_e.versionTest.toLowerCase(), s) || _), _ = convertVersion(_), !0);
  }), {
    preset: $,
    version: _
  };
}
function findPresetBrand(a, s) {
  var $ = {
    brand: "",
    version: "-1"
  };
  return some(a, function(_) {
    var _e = findBrand(s, _);
    return _e ? ($.brand = _.id, $.version = _.versionAlias || _e.version, $.version !== "-1") : !1;
  }), $;
}
function findBrand(a, s) {
  return find(a, function($) {
    var _ = $.brand;
    return execRegExp("" + s.test, _.toLowerCase());
  });
}
var BROWSER_PRESETS = [{
  test: "phantomjs",
  id: "phantomjs"
}, {
  test: "whale",
  id: "whale"
}, {
  test: "edgios|edge|edg",
  id: "edge"
}, {
  test: "msie|trident|windows phone",
  id: "ie",
  versionTest: "iemobile|msie|rv"
}, {
  test: "miuibrowser",
  id: "miui browser"
}, {
  test: "samsungbrowser",
  id: "samsung internet"
}, {
  test: "samsung",
  id: "samsung internet",
  versionTest: "version"
}, {
  test: "chrome|crios",
  id: "chrome"
}, {
  test: "firefox|fxios",
  id: "firefox"
}, {
  test: "android",
  id: "android browser",
  versionTest: "version"
}, {
  test: "safari|iphone|ipad|ipod",
  id: "safari",
  versionTest: "version"
}], CHROMIUM_PRESETS = [{
  test: "(?=.*applewebkit/(53[0-7]|5[0-2]|[0-4]))(?=.*\\schrome)",
  id: "chrome",
  versionTest: "chrome"
}, {
  test: "chromium",
  id: "chrome"
}, {
  test: "whale",
  id: "chrome",
  versionAlias: "-1",
  brand: !0
}], WEBKIT_PRESETS = [{
  test: "applewebkit",
  id: "webkit",
  versionTest: "applewebkit|safari"
}], WEBVIEW_PRESETS = [{
  test: "(?=(iphone|ipad))(?!(.*version))",
  id: "webview"
}, {
  test: "(?=(android|iphone|ipad))(?=.*(naver|daum|; wv))",
  id: "webview"
}, {
  // test webview
  test: "webview",
  id: "webview"
}], OS_PRESETS = [{
  test: "windows phone",
  id: "windows phone"
}, {
  test: "windows 2000",
  id: "window",
  versionAlias: "5.0"
}, {
  test: "windows nt",
  id: "window"
}, {
  test: "win32|windows",
  id: "window"
}, {
  test: "iphone|ipad|ipod",
  id: "ios",
  versionTest: "iphone os|cpu os"
}, {
  test: "macos|macintel|mac os x",
  id: "mac"
}, {
  test: "android|linux armv81",
  id: "android"
}, {
  test: "tizen",
  id: "tizen"
}, {
  test: "webos|web0s",
  id: "webos"
}];
function isWebView(a) {
  return !!findPreset(WEBVIEW_PRESETS, a).preset;
}
function getLegacyAgent(a) {
  var s = getUserAgentString(a), $ = !!/mobi/g.exec(s), _ = {
    name: "unknown",
    version: "-1",
    majorVersion: -1,
    webview: isWebView(s),
    chromium: !1,
    chromiumVersion: "-1",
    webkit: !1,
    webkitVersion: "-1"
  }, _e = {
    name: "unknown",
    version: "-1",
    majorVersion: -1
  }, tt = findPreset(BROWSER_PRESETS, s), nt = tt.preset, at = tt.version, ot = findPreset(OS_PRESETS, s), rt = ot.preset, st = ot.version, lt = findPreset(CHROMIUM_PRESETS, s);
  if (_.chromium = !!lt.preset, _.chromiumVersion = lt.version, !_.chromium) {
    var et = findPreset(WEBKIT_PRESETS, s);
    _.webkit = !!et.preset, _.webkitVersion = et.version;
  }
  return rt && (_e.name = rt.id, _e.version = st, _e.majorVersion = parseInt(st, 10)), nt && (_.name = nt.id, _.version = at, _.webview && _e.name === "ios" && _.name !== "safari" && (_.webview = !1)), _.majorVersion = parseInt(_.version, 10), {
    browser: _,
    os: _e,
    isMobile: $,
    isHints: !1
  };
}
function getClientHintsAgent(a) {
  var s = navigator.userAgentData, $ = (s.uaList || s.brands).slice(), _ = a && a.fullVersionList, _e = s.mobile || !1, tt = $[0], nt = (a && a.platform || s.platform || navigator.platform).toLowerCase(), at = {
    name: tt.brand,
    version: tt.version,
    majorVersion: -1,
    webkit: !1,
    webkitVersion: "-1",
    chromium: !1,
    chromiumVersion: "-1",
    webview: !!findPresetBrand(WEBVIEW_PRESETS, $).brand || isWebView(getUserAgentString())
  }, ot = {
    name: "unknown",
    version: "-1",
    majorVersion: -1
  };
  at.webkit = !at.chromium && some(WEBKIT_PRESETS, function(ut) {
    return findBrand($, ut);
  });
  var rt = findPresetBrand(CHROMIUM_PRESETS, $);
  if (at.chromium = !!rt.brand, at.chromiumVersion = rt.version, !at.chromium) {
    var st = findPresetBrand(WEBKIT_PRESETS, $);
    at.webkit = !!st.brand, at.webkitVersion = st.version;
  }
  var lt = find(OS_PRESETS, function(ut) {
    return new RegExp("" + ut.test, "g").exec(nt);
  });
  if (ot.name = lt ? lt.id : "", a && (ot.version = a.platformVersion), _ && _.length) {
    var et = findPresetBrand(BROWSER_PRESETS, _);
    at.name = et.brand || at.name, at.version = et.version || at.version;
  } else {
    var it = findPresetBrand(BROWSER_PRESETS, $);
    at.name = it.brand || at.name, at.version = it.brand && a ? a.uaFullVersion : it.version;
  }
  return at.webkit && (ot.name = _e ? "ios" : "mac"), ot.name === "ios" && at.webview && (at.version = "-1"), ot.version = convertVersion(ot.version), at.version = convertVersion(at.version), ot.majorVersion = parseInt(ot.version, 10), at.majorVersion = parseInt(at.version, 10), {
    browser: at,
    os: ot,
    isMobile: _e,
    isHints: !0
  };
}
function agent$1(a) {
  return typeof a > "u" && hasUserAgentData() ? getClientHintsAgent() : getLegacyAgent(a);
}
var extendStatics$3 = function(a, s) {
  return extendStatics$3 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function($, _) {
    $.__proto__ = _;
  } || function($, _) {
    for (var _e in _)
      Object.prototype.hasOwnProperty.call(_, _e) && ($[_e] = _[_e]);
  }, extendStatics$3(a, s);
};
function __extends$3(a, s) {
  if (typeof s != "function" && s !== null)
    throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
  extendStatics$3(a, s);
  function $() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : ($.prototype = s.prototype, new $());
}
var __assign$2 = function() {
  return __assign$2 = Object.assign || function(s) {
    for (var $, _ = 1, _e = arguments.length; _ < _e; _++) {
      $ = arguments[_];
      for (var tt in $)
        Object.prototype.hasOwnProperty.call($, tt) && (s[tt] = $[tt]);
    }
    return s;
  }, __assign$2.apply(this, arguments);
};
function __rest$1(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
}
var StyledElement = /* @__PURE__ */ function(a) {
  __extends$3(s, a);
  function s() {
    var _ = a !== null && a.apply(this, arguments) || this;
    return _.injectResult = null, _.tag = "div", _;
  }
  var $ = s.prototype;
  return $.render = function() {
    var _ = this.props, _e = _.className, tt = _e === void 0 ? "" : _e;
    _.cspNonce;
    var nt = _.portalContainer, at = __rest$1(_, ["className", "cspNonce", "portalContainer"]), ot = this.injector.className, rt = this.tag, st = {};
    return (reactExports.version || "").indexOf("simple") > -1 && nt && (st = {
      portalContainer: nt
    }), reactExports.createElement(rt, __assign$2(__assign$2({
      ref: ref(this, "element"),
      "data-styled-id": ot,
      className: "".concat(tt, " ").concat(ot)
    }, st), at));
  }, $.componentDidMount = function() {
    this.injectResult = this.injector.inject(this.element, {
      nonce: this.props.cspNonce
    });
  }, $.componentWillUnmount = function() {
    this.injectResult.destroy(), this.injectResult = null;
  }, $.getElement = function() {
    return this.element;
  }, s;
}(reactExports.Component);
function defaultStyled(a, s) {
  var $ = styled(s);
  return /* @__PURE__ */ function(_) {
    __extends$3(_e, _);
    function _e() {
      var tt = _ !== null && _.apply(this, arguments) || this;
      return tt.injector = $, tt.tag = a, tt;
    }
    return _e;
  }(StyledElement);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics$2 = function(a, s) {
  return extendStatics$2 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function($, _) {
    $.__proto__ = _;
  } || function($, _) {
    for (var _e in _)
      _.hasOwnProperty(_e) && ($[_e] = _[_e]);
  }, extendStatics$2(a, s);
};
function __extends$2(a, s) {
  extendStatics$2(a, s);
  function $() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : ($.prototype = s.prototype, new $());
}
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(s) {
    for (var $, _ = 1, _e = arguments.length; _ < _e; _++) {
      $ = arguments[_];
      for (var tt in $)
        Object.prototype.hasOwnProperty.call($, tt) && (s[tt] = $[tt]);
    }
    return s;
  }, __assign$1.apply(this, arguments);
};
function __rest(a, s) {
  var $ = {};
  for (var _ in a)
    Object.prototype.hasOwnProperty.call(a, _) && s.indexOf(_) < 0 && ($[_] = a[_]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var _e = 0, _ = Object.getOwnPropertySymbols(a); _e < _.length; _e++)
      s.indexOf(_[_e]) < 0 && Object.prototype.propertyIsEnumerable.call(a, _[_e]) && ($[_[_e]] = a[_[_e]]);
  return $;
}
function __decorate(a, s, $, _) {
  var _e = arguments.length, tt = _e < 3 ? s : _ === null ? _ = Object.getOwnPropertyDescriptor(s, $) : _, nt;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    tt = Reflect.decorate(a, s, $, _);
  else
    for (var at = a.length - 1; at >= 0; at--)
      (nt = a[at]) && (tt = (_e < 3 ? nt(tt) : _e > 3 ? nt(s, $, tt) : nt(s, $)) || tt);
  return _e > 3 && tt && Object.defineProperty(s, $, tt), tt;
}
function __spreadArrays() {
  for (var a = 0, s = 0, $ = arguments.length; s < $; s++)
    a += arguments[s].length;
  for (var _ = Array(a), _e = 0, s = 0; s < $; s++)
    for (var tt = arguments[s], nt = 0, at = tt.length; nt < at; nt++, _e++)
      _[_e] = tt[nt];
  return _;
}
function makeAble(a, s) {
  var $;
  return __assign$1({
    events: {},
    props: ($ = {}, $[a] = Boolean, $),
    name: a
  }, s);
}
function getSVGCursor(a, s) {
  return 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="' + 32 * a + 'px" height="' + 32 * a + 'px" viewBox="0 0 32 32" ><path d="M 16,5 L 12,10 L 14.5,10 L 14.5,22 L 12,22 L 16,27 L 20,22 L 17.5,22 L 17.5,10 L 20, 10 L 16,5 Z" stroke-linejoin="round" stroke-width="1.2" fill="black" stroke="white" style="transform:rotate(' + s + 'deg);transform-origin: 16px 16px"></path></svg>';
}
function getCursorCSS(a) {
  var s = getSVGCursor(1, a), $ = getSVGCursor(2, a), _ = Math.round(a / 45) * 45 % 180, _e = "ns-resize";
  return _ === 135 ? _e = "nwse-resize" : _ === 45 ? _e = "nesw-resize" : _ === 90 && (_e = "ew-resize"), "cursor:" + _e + ";cursor: url('" + s + "') 16 16, " + _e + ";cursor: -webkit-image-set(url('" + s + "') 1x, url('" + $ + "') 2x) 16 16, " + _e + ";";
}
var agent = agent$1(), IS_WEBKIT = agent.browser.webkit, IS_WEBKIT605 = IS_WEBKIT && function() {
  var a = typeof window > "u" ? {
    userAgent: ""
  } : window.navigator, s = /applewebkit\/([^\s]+)/g.exec(a.userAgent.toLowerCase());
  return s ? parseFloat(s[1]) < 605 : !1;
}(), PREFIX = "moveable-", MOVEABLE_CSS = `
{
	position: absolute;
	width: 1px;
	height: 1px;
	left: 0;
	top: 0;
    z-index: 3000;
    --moveable-color: #4af;
    --zoom: 1;
    --zoompx: 1px;
    will-change: transform;
}
.control-box {
    z-index: 0;
}
.line, .control {
    position: absolute;
	left: 0;
    top: 0;
    will-change: transform;
}
.control {
	width: 14px;
	height: 14px;
	border-radius: 50%;
	border: 2px solid #fff;
	box-sizing: border-box;
    background: #4af;
    background: var(--moveable-color);
	margin-top: -7px;
    margin-left: -7px;
    border: 2px solid #fff;
    z-index: 10;
}
.padding {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100px;
    height: 100px;
    transform-origin: 0 0;
}
.line {
	width: 1px;
    height: 1px;
    background: #4af;
    background: var(--moveable-color);
	transform-origin: 0px 50%;
}
.line.dashed {
    box-sizing: border-box;
    background: transparent;
}
.line.dashed.horizontal {
    border-top: 1px dashed #4af;
    border-top-color: #4af;
    border-top-color: var(--moveable-color);
}
.line.dashed.vertical {
    border-left: 1px dashed #4af;
    border-left-color: #4af;
    border-left-color: var(--moveable-color);
}
.line.vertical {
    transform: translateX(-50%);
}
.line.horizontal {
    transform: translateY(-50%);
}
.line.vertical.bold {
    width: 2px;
}
.line.horizontal.bold {
    height: 2px;
}

.control.origin {
	border-color: #f55;
	background: #fff;
	width: 12px;
	height: 12px;
	margin-top: -6px;
    margin-left: -6px;
	pointer-events: none;
}
` + [0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165].map(function(a) {
  return `
.direction[data-rotation="` + a + `"] {
	` + getCursorCSS(a) + `
}
`;
}).join(`
`) + `
.group {
    z-index: -1;
}
.area {
    position: absolute;
}
.area-pieces {
    position: absolute;
    top: 0;
    left: 0;
    display: none;
}
.area.avoid, .area.pass {
    pointer-events: none;
}
.area.avoid+.area-pieces {
    display: block;
}
.area-piece {
    position: absolute;
}

` + (IS_WEBKIT605 ? `:global svg *:before {
	content:"";
	transform-origin: inherit;
}` : "") + `
`, NEARBY_POS = [[0, 1, 2], [1, 0, 3], [2, 0, 3], [3, 1, 2]], FLOAT_POINT_NUM = 1e-4, TINY_NUM = 1e-7, MIN_SCALE = 1e-9, MAX_NUM = Math.pow(10, 10), MIN_NUM = -MAX_NUM, DIRECTIONS = ["n", "w", "s", "e", "nw", "ne", "sw", "se"], DIRECTION_INDEXES = {
  n: [0, 1],
  s: [2, 3],
  w: [2, 0],
  e: [1, 3],
  nw: [0],
  ne: [1],
  sw: [2],
  se: [3]
}, DIRECTION_ROTATIONS = {
  n: 0,
  s: 180,
  w: 270,
  e: 90,
  nw: 315,
  ne: 45,
  sw: 225,
  se: 135
}, MOVEABLE_METHODS = ["isMoveableElement", "updateRect", "updateTarget", "destroy", "dragStart", "isInside", "hitTest", "setState", "getRect", "request", "isDragging", "getManager"];
function multiply2(a, s) {
  return [a[0] * s[0], a[1] * s[1]];
}
function prefix$1() {
  for (var a = [], s = 0; s < arguments.length; s++)
    a[s] = arguments[s];
  return prefixNames.apply(void 0, __spreadArrays([PREFIX], a));
}
function getTransformMatrix(a) {
  if (!a || a === "none")
    return [1, 0, 0, 1, 0, 0];
  if (isObject$1(a))
    return a;
  var s = splitBracket(a).value;
  return s.split(/s*,\s*/g).map(function($) {
    return parseFloat($);
  });
}
function getAbsoluteMatrix(a, s, $) {
  return multiplies(s, createOriginMatrix($, s), a, createOriginMatrix($.map(function(_) {
    return -_;
  }), s));
}
function measureSVGSize(a, s, $) {
  if (s === "%") {
    var _ = getSVGViewBox(a.ownerSVGElement);
    return _[$ ? "width" : "height"] / 100;
  }
  return 1;
}
function getBeforeTransformOrigin(a) {
  var s = getTransformOrigin(getComputedStyle$1(a, ":before"));
  return s.map(function($, _) {
    var _e = splitUnit($), tt = _e.value, nt = _e.unit;
    return tt * measureSVGSize(a, nt, _ === 0);
  });
}
function getTransformOrigin(a) {
  var s = a.transformOrigin;
  return s ? s.split(" ") : ["0", "0"];
}
function getOffsetInfo(a, s, $) {
  for (var _ = document.body, _e = !a || $ ? a : a.parentElement, tt = a === s || _e === s, nt = "relative"; _e && _e !== _; ) {
    s === _e && (tt = !0);
    var at = getComputedStyle$1(_e), ot = at.transform;
    if (nt = at.position, _e.tagName.toLowerCase() === "svg" || nt !== "static" || ot && ot !== "none")
      break;
    _e = _e.parentElement, nt = "relative";
  }
  return {
    isStatic: nt === "static",
    isEnd: tt || !_e || _e === _,
    offsetParent: _e || _
  };
}
function getOffsetPosInfo(a, s, $, _) {
  var _e, tt = a.tagName.toLowerCase(), nt = a.offsetLeft, at = a.offsetTop;
  if (_) {
    var ot = (s || document.documentElement).getBoundingClientRect();
    nt -= ot.left, at -= ot.top;
  }
  var rt = isUndefined(nt), st = !rt, lt, et;
  return !st && tt !== "svg" ? (lt = IS_WEBKIT605 ? getBeforeTransformOrigin(a) : getTransformOrigin($).map(function(it) {
    return parseFloat(it);
  }), et = lt.slice(), st = !0, _e = getSVGGraphicsOffset(a, lt), nt = _e[0], at = _e[1], lt[0] = _e[2], lt[1] = _e[3]) : (lt = getTransformOrigin($).map(function(it) {
    return parseFloat(it);
  }), et = lt.slice()), {
    tagName: tt,
    isSVG: rt,
    hasOffset: st,
    offset: [nt || 0, at || 0],
    origin: lt,
    targetOrigin: et
  };
}
function getBodyOffset(a, s, $) {
  $ === void 0 && ($ = getComputedStyle$1(a));
  var _ = getComputedStyle$1(document.body), _e = _.position;
  if (!s && (!_e || _e === "static"))
    return [0, 0];
  var tt = parseInt(_.marginLeft, 10), nt = parseInt(_.marginTop, 10);
  return $.position === "absolute" && (($.top !== "auto" || $.bottom !== "auto") && (nt = 0), ($.left !== "auto" || $.right !== "auto") && (tt = 0)), [tt, nt];
}
function convert3DMatrixes(a) {
  a.forEach(function(s) {
    var $ = s.matrix;
    $ && (s.matrix = convertDimension($, 3, 4));
  });
}
function getMatrixStackInfo(a, s, $) {
  for (var _ = a, _e = [], tt = !$ && a === s, nt = tt, at = !1, ot = 3, rt, st, lt, et = getOffsetInfo(s, s, !0).offsetParent; _ && !nt; ) {
    nt = tt;
    var it = getComputedStyle$1(_), ut = it.position, ft = ut === "fixed", ht = convertCSStoMatrix(getTransformMatrix(it.transform)), dt = ht.length;
    !at && dt === 16 && (at = !0, ot = 4, convert3DMatrixes(_e), lt && (lt = convertDimension(lt, 3, 4))), at && dt === 9 && (ht = convertDimension(ht, 3, 4));
    var gt = getOffsetPosInfo(_, s, it, ft), pt = gt.tagName, mt = gt.hasOffset, ct = gt.isSVG, vt = gt.origin, At = gt.targetOrigin, xt = gt.offset, bt = xt[0], Et = xt[1];
    pt === "svg" && lt ? (_e.push({
      type: "target",
      target: _,
      matrix: getSVGMatrix(_, ot)
    }), _e.push({
      type: "offset",
      target: _,
      matrix: createIdentityMatrix(ot)
    })) : pt === "g" && a !== _ && (bt = 0, Et = 0);
    var St = getOffsetInfo(_, s), Bt = St.offsetParent, Ot = St.isEnd, Pt = St.isStatic;
    IS_WEBKIT && mt && !ct && Pt && (ut === "relative" || ut === "static") && (bt -= Bt.offsetLeft, Et -= Bt.offsetTop, tt = tt || Ot);
    var wt = 0, Ct = 0;
    if (mt && et !== Bt && (wt = Bt.clientLeft, Ct = Bt.clientTop), mt && Bt === document.body) {
      var It = getBodyOffset(_, !1, it);
      bt += It[0], Et += It[1];
    }
    if (_e.push({
      type: "target",
      target: _,
      matrix: getAbsoluteMatrix(ht, ot, vt)
    }), mt ? _e.push({
      type: "offset",
      target: _,
      matrix: createOriginMatrix([bt - _.scrollLeft + wt, Et - _.scrollTop + Ct], ot)
    }) : _e.push({
      type: "offset",
      target: _,
      origin: vt
    }), lt || (lt = ht), rt || (rt = vt), st || (st = At), nt || ft)
      break;
    _ = Bt, tt = Ot, (!$ || _ === document.body) && (nt = tt);
  }
  return lt || (lt = createIdentityMatrix(ot)), rt || (rt = [0, 0]), st || (st = [0, 0]), {
    offsetContainer: et,
    matrixes: _e,
    targetMatrix: lt,
    transformOrigin: rt,
    targetOrigin: st,
    is3d: at
  };
}
function calculateElementInfo(a, s, $, _) {
  var _e;
  $ === void 0 && ($ = s);
  var tt = 0, nt = 0, at = 0, ot = {};
  if (a) {
    var rt = getComputedStyle$1(a);
    tt = a.offsetWidth, nt = a.offsetHeight, isUndefined(tt) && (_e = getSize(a, rt, !0), tt = _e[0], nt = _e[1]);
  }
  if (a) {
    var st = calculateMatrixStack(a, s, $, _), lt = calculateMoveablePosition(st.allMatrix, st.transformOrigin, tt, nt);
    ot = __assign$1(__assign$1({}, st), lt);
    var et = calculateMoveablePosition(st.allMatrix, [50, 50], 100, 100);
    at = getRotationRad([et.pos1, et.pos2], et.direction);
  }
  var it = _ ? 4 : 3;
  return __assign$1({
    width: tt,
    height: nt,
    rotation: at,
    // rootMatrix: number[];
    // beforeMatrix: number[];
    // offsetMatrix: number[];
    // allMatrix: number[];
    // targetMatrix: number[];
    // targetTransform: string;
    // transformOrigin: number[];
    // targetOrigin: number[];
    // is3d: boolean;
    rootMatrix: createIdentityMatrix(it),
    beforeMatrix: createIdentityMatrix(it),
    offsetMatrix: createIdentityMatrix(it),
    allMatrix: createIdentityMatrix(it),
    targetMatrix: createIdentityMatrix(it),
    targetTransform: "",
    transformOrigin: [0, 0],
    targetOrigin: [0, 0],
    is3d: !!_,
    // left: number;
    // top: number;
    // right: number;
    // bottom: number;
    // origin: number[];
    // pos1: number[];
    // pos2: number[];
    // pos3: number[];
    // pos4: number[];
    // direction: 1 | -1;
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    origin: [0, 0],
    pos1: [0, 0],
    pos2: [0, 0],
    pos3: [0, 0],
    pos4: [0, 0],
    direction: 1
  }, ot);
}
function calculateMatrixStack(a, s, $, _) {
  $ === void 0 && ($ = s);
  var _e = getMatrixStackInfo(a, s), tt = _e.matrixes, nt = _e.is3d, at = _e.targetMatrix, ot = _e.transformOrigin, rt = _e.targetOrigin, st = _e.offsetContainer, lt = getMatrixStackInfo(st, $, !0), et = lt.matrixes, it = lt.is3d, ut = _ || it || nt, ft = ut ? 4 : 3, ht = a.tagName.toLowerCase() !== "svg" && "ownerSVGElement" in a, dt = at, gt = createIdentityMatrix(ft), pt = createIdentityMatrix(ft), mt = createIdentityMatrix(ft), ct = createIdentityMatrix(ft), vt = tt.length, At = $ || document.body, xt = getOffsetInfo(At, At, !0).offsetParent;
  et.reverse(), tt.reverse(), !nt && ut && (dt = convertDimension(dt, 3, 4), convert3DMatrixes(tt)), !it && ut && convert3DMatrixes(et), et.forEach(function(St) {
    pt = multiply(pt, St.matrix, ft);
  }), tt.forEach(function(St, Bt) {
    if (vt - 2 === Bt && (mt = gt.slice()), vt - 1 === Bt && (ct = gt.slice()), !St.matrix) {
      var Ot = tt[Bt + 1], Pt = getSVGOffset(St, Ot, xt, ft, multiply(pt, gt, ft));
      St.matrix = createOriginMatrix(Pt, ft);
    }
    gt = multiply(gt, St.matrix, ft);
  });
  var bt = !ht && nt;
  dt || (dt = createIdentityMatrix(bt ? 4 : 3));
  var Et = makeMatrixCSS(ht && dt.length === 16 ? convertDimension(dt, 4, 3) : dt, bt);
  return pt = ignoreDimension(pt, ft, ft), {
    rootMatrix: pt,
    beforeMatrix: mt,
    offsetMatrix: ct,
    allMatrix: gt,
    targetMatrix: dt,
    targetTransform: Et,
    transformOrigin: ot,
    targetOrigin: rt,
    is3d: ut
  };
}
function makeMatrixCSS(a, s) {
  return s === void 0 && (s = a.length > 9), (s ? "matrix3d" : "matrix") + "(" + convertMatrixtoCSS(a, !s).join(",") + ")";
}
function getSVGViewBox(a) {
  var s = a.clientWidth, $ = a.clientHeight;
  if (!a)
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      clientWidth: s,
      clientHeight: $
    };
  var _ = a.viewBox, _e = _ && _.baseVal || {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  return {
    x: _e.x,
    y: _e.y,
    width: _e.width || s,
    height: _e.height || $,
    clientWidth: s,
    clientHeight: $
  };
}
function getSVGMatrix(a, s) {
  var $ = getSVGViewBox(a), _ = $.width, _e = $.height, tt = $.clientWidth, nt = $.clientHeight, at = tt / _, ot = nt / _e, rt = a.preserveAspectRatio.baseVal, st = rt.align, lt = rt.meetOrSlice, et = [0, 0], it = [at, ot], ut = [0, 0];
  if (st !== 1) {
    var ft = (st - 2) % 3, ht = Math.floor((st - 2) / 3);
    et[0] = _ * ft / 2, et[1] = _e * ht / 2;
    var dt = lt === 2 ? Math.max(ot, at) : Math.min(at, ot);
    it[0] = dt, it[1] = dt, ut[0] = (tt - _) / 2 * ft, ut[1] = (nt - _e) / 2 * ht;
  }
  var gt = createScaleMatrix(it, s);
  return gt[s * (s - 1)] = ut[0], gt[s * (s - 1) + 1] = ut[1], getAbsoluteMatrix(gt, s, et);
}
function getSVGGraphicsOffset(a, s) {
  if (!a.getBBox)
    return [0, 0];
  var $ = a.getBBox(), _ = getSVGViewBox(a.ownerSVGElement), _e = $.x - _.x, tt = $.y - _.y;
  return [_e, tt, s[0] - _e, s[1] - tt];
}
function calculatePosition(a, s, $) {
  return calculate(a, convertPositionMatrix(s, $), $);
}
function calculatePoses(a, s, $, _) {
  return [[0, 0], [s, 0], [0, $], [s, $]].map(function(_e) {
    return calculatePosition(a, _e, _);
  });
}
function getRect(a) {
  var s = a.map(function(rt) {
    return rt[0];
  }), $ = a.map(function(rt) {
    return rt[1];
  }), _ = Math.min.apply(Math, s), _e = Math.min.apply(Math, $), tt = Math.max.apply(Math, s), nt = Math.max.apply(Math, $), at = tt - _, ot = nt - _e;
  return {
    left: _,
    top: _e,
    right: tt,
    bottom: nt,
    width: at,
    height: ot
  };
}
function calculateRect(a, s, $, _) {
  var _e = calculatePoses(a, s, $, _);
  return getRect(_e);
}
function getSVGOffset(a, s, $, _, _e) {
  var tt, nt = a.target, at = a.origin, ot = s.matrix, rt = getSize(nt, void 0, !0), st = rt[0], lt = rt[1], et = $.getBoundingClientRect(), it = [0, 0];
  $ === document.body && (it = getBodyOffset(nt, !0));
  for (var ut = nt.getBoundingClientRect(), ft = ut.left - et.left + $.scrollLeft - ($.clientLeft || 0) + it[0], ht = ut.top - et.top + $.scrollTop - ($.clientTop || 0) + it[1], dt = ut.width, gt = ut.height, pt = multiplies(_, _e, ot), mt = calculateRect(pt, st, lt, _), ct = mt.left, vt = mt.top, At = mt.width, xt = mt.height, bt = calculatePosition(pt, at, _), Et = minus(bt, [ct, vt]), St = [ft + Et[0] * dt / At, ht + Et[1] * gt / xt], Bt = [0, 0], Ot = 0; ++Ot < 10; ) {
    var Pt = invert(_e, _);
    tt = minus(calculatePosition(Pt, St, _), calculatePosition(Pt, bt, _)), Bt[0] = tt[0], Bt[1] = tt[1];
    var wt = multiplies(_, _e, createOriginMatrix(Bt, _), ot), Ct = calculateRect(wt, st, lt, _), It = Ct.left, yt = Ct.top, Rt = It - ft, kt = yt - ht;
    if (Math.abs(Rt) < 2 && Math.abs(kt) < 2)
      break;
    St[0] -= Rt, St[1] -= kt;
  }
  return Bt.map(function(jt) {
    return Math.round(jt);
  });
}
function calculateMoveablePosition(a, s, $, _) {
  var _e = a.length === 16, tt = _e ? 4 : 3, nt = calculatePoses(a, $, _, tt), at = nt[0], ot = at[0], rt = at[1], st = nt[1], lt = st[0], et = st[1], it = nt[2], ut = it[0], ft = it[1], ht = nt[3], dt = ht[0], gt = ht[1], pt = calculatePosition(a, s, tt), mt = pt[0], ct = pt[1], vt = Math.min(ot, lt, ut, dt), At = Math.min(rt, et, ft, gt), xt = Math.max(ot, lt, ut, dt), bt = Math.max(rt, et, ft, gt);
  ot = ot - vt || 0, lt = lt - vt || 0, ut = ut - vt || 0, dt = dt - vt || 0, rt = rt - At || 0, et = et - At || 0, ft = ft - At || 0, gt = gt - At || 0, mt = mt - vt || 0, ct = ct - At || 0;
  var Et = getShapeDirection(nt);
  return {
    left: vt,
    top: At,
    right: xt,
    bottom: bt,
    origin: [mt, ct],
    pos1: [ot, rt],
    pos2: [lt, et],
    pos3: [ut, ft],
    pos4: [dt, gt],
    direction: Et
  };
}
function getDistSize(a) {
  return Math.sqrt(a[0] * a[0] + a[1] * a[1]);
}
function getDiagonalSize(a, s) {
  return getDistSize([s[0] - a[0], s[1] - a[1]]);
}
function getLineStyle(a, s, $, _) {
  $ === void 0 && ($ = 1), _ === void 0 && (_ = getRad$1(a, s));
  var _e = getDiagonalSize(a, s);
  return {
    transform: "translateY(-50%) translate(" + a[0] + "px, " + a[1] + "px) rotate(" + _ + "rad) scaleY(" + $ + ")",
    width: _e + "px"
  };
}
function getControlTransform(a, s) {
  for (var $ = [], _ = 2; _ < arguments.length; _++)
    $[_ - 2] = arguments[_];
  var _e = $.length, tt = $.reduce(function(at, ot) {
    return at + ot[0];
  }, 0) / _e, nt = $.reduce(function(at, ot) {
    return at + ot[1];
  }, 0) / _e;
  return {
    transform: "translateZ(0px) translate(" + tt + "px, " + nt + "px) rotate(" + a + "rad) scale(" + s + ")"
  };
}
function getCSSSize(a) {
  var s = getComputedStyle$1(a);
  return [parseFloat(s.width), parseFloat(s.height)];
}
function getSize(a, s, $, _) {
  s === void 0 && (s = getComputedStyle$1(a)), _ === void 0 && (_ = $ || s.boxSizing === "border-box");
  var _e = a.offsetWidth, tt = a.offsetHeight, nt = !isUndefined(_e);
  if (($ || _) && nt)
    return [_e, tt];
  if (!nt && a.tagName.toLowerCase() !== "svg") {
    var at = a.getBBox();
    return [at.width, at.height];
  }
  if (_e = a.clientWidth, tt = a.clientHeight, $ || _) {
    var ot = parseFloat(s.borderLeftWidth) || 0, rt = parseFloat(s.borderRightWidth) || 0, st = parseFloat(s.borderTopWidth) || 0, lt = parseFloat(s.borderBottomWidth) || 0;
    return [_e + ot + rt, tt + st + lt];
  } else {
    var et = parseFloat(s.paddingLeft) || 0, it = parseFloat(s.paddingRight) || 0, ut = parseFloat(s.paddingTop) || 0, ft = parseFloat(s.paddingBottom) || 0;
    return [_e - et - it, tt - ut - ft];
  }
}
function getRotationRad(a, s) {
  return getRad$1(s > 0 ? a[0] : a[1], s > 0 ? a[1] : a[0]);
}
function getTargetInfo(a, s, $, _, _e) {
  var tt = 1, nt = [0, 0], at = resetClientRect(), ot = resetClientRect(), rt = resetClientRect(), st = calculateElementInfo(s, $, _e, !1);
  if (s) {
    var lt = st.is3d ? 4 : 3, et = calculateMoveablePosition(st.offsetMatrix, plus(st.transformOrigin, getOrigin(st.targetMatrix, lt)), st.width, st.height);
    tt = et.direction, nt = plus(et.origin, [et.left - st.left, et.top - st.top]), at = getClientRect(s), ot = getClientRect(getOffsetInfo(_, _, !0).offsetParent || document.body, !0), a && (rt = getClientRect(a));
  }
  return __assign$1({
    targetClientRect: at,
    containerClientRect: ot,
    moveableClientRect: rt,
    beforeDirection: tt,
    beforeOrigin: nt,
    originalBeforeOrigin: nt,
    target: s
  }, st);
}
function resetClientRect() {
  return {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: 0,
    height: 0,
    clientLeft: 0,
    clientTop: 0,
    clientWidth: 0,
    clientHeight: 0,
    scrollWidth: 0,
    scrollHeight: 0
  };
}
function getClientRect(a, s) {
  var $ = 0, _ = 0, _e = 0, tt = 0;
  if (a === document.body || a === document.documentElement)
    _e = window.innerWidth, tt = window.innerHeight, $ = -(document.documentElement.scrollLeft || document.body.scrollLeft), _ = -(document.documentElement.scrollTop || document.body.scrollTop);
  else {
    var nt = a.getBoundingClientRect();
    $ = nt.left, _ = nt.top, _e = nt.width, tt = nt.height;
  }
  var at = {
    left: $,
    right: $ + _e,
    top: _,
    bottom: _ + tt,
    width: _e,
    height: tt
  };
  return s && (at.clientLeft = a.clientLeft, at.clientTop = a.clientTop, at.clientWidth = a.clientWidth, at.clientHeight = a.clientHeight, at.scrollWidth = a.scrollWidth, at.scrollHeight = a.scrollHeight, at.overflow = getComputedStyle$1(a).overflow !== "visible"), at;
}
function getDirection(a) {
  if (a) {
    var s = a.getAttribute("data-direction");
    if (s) {
      var $ = [0, 0];
      return s.indexOf("w") > -1 && ($[0] = -1), s.indexOf("e") > -1 && ($[0] = 1), s.indexOf("n") > -1 && ($[1] = -1), s.indexOf("s") > -1 && ($[1] = 1), $;
    }
  }
}
function getAbsolutePoses(a, s) {
  return [plus(s, a[0]), plus(s, a[1]), plus(s, a[2]), plus(s, a[3])];
}
function getAbsolutePosesByState(a) {
  var s = a.left, $ = a.top, _ = a.pos1, _e = a.pos2, tt = a.pos3, nt = a.pos4;
  return getAbsolutePoses([_, _e, tt, nt], [s, $]);
}
function roundSign(a) {
  return Math.round(a % 1 === -0.5 ? a - 1 : a);
}
function unset(a, s) {
  a[s] && (a[s].unset(), a[s] = null);
}
function fillParams(a, s, $) {
  var _ = s.datas;
  _.datas || (_.datas = {});
  var _e = __assign$1(__assign$1({}, $), {
    target: a.state.target,
    clientX: s.clientX,
    clientY: s.clientY,
    inputEvent: s.inputEvent,
    currentTarget: a,
    moveable: a,
    datas: _.datas
  });
  return _.isStartEvent ? _.lastEvent = _e : _.isStartEvent = !0, _e;
}
function fillEndParams(a, s, $) {
  var _ = s.datas, _e = "isDrag" in $ ? $.isDrag : s.isDrag;
  return _.datas || (_.datas = {}), __assign$1(__assign$1({
    isDrag: _e
  }, $), {
    moveable: a,
    target: a.state.target,
    clientX: s.clientX,
    clientY: s.clientY,
    inputEvent: s.inputEvent,
    currentTarget: a,
    lastEvent: _.lastEvent,
    isDouble: s.isDouble,
    datas: _.datas
  });
}
function triggerEvent(a, s, $, _) {
  return a.triggerEvent(s, $, _);
}
function getComputedStyle$1(a, s) {
  return window.getComputedStyle(a, s);
}
function filterAbles(a, s, $) {
  var _ = {}, _e = {};
  return a.filter(function(tt) {
    var nt = tt.name;
    if (_[nt] || !s.some(function(at) {
      return tt[at];
    }))
      return !1;
    if (!$ && tt.ableGroup) {
      if (_e[tt.ableGroup])
        return !1;
      _e[tt.ableGroup] = !0;
    }
    return _[nt] = !0, !0;
  });
}
function equals(a, s) {
  return a === s || a == null && s == null;
}
function selectValue() {
  for (var a = [], s = 0; s < arguments.length; s++)
    a[s] = arguments[s];
  for (var $ = a.length - 1, _ = 0; _ < $; ++_) {
    var _e = a[_];
    if (!isUndefined(_e))
      return _e;
  }
  return a[$];
}
function groupBy(a, s) {
  var $ = [], _ = [];
  return a.forEach(function(_e, tt) {
    var nt = s(_e, tt, a), at = _.indexOf(nt), ot = $[at] || [];
    at === -1 && (_.push(nt), $.push(ot)), ot.push(_e);
  }), $;
}
function groupByMap(a, s) {
  var $ = [], _ = {};
  return a.forEach(function(_e, tt) {
    var nt = s(_e, tt, a), at = _[nt];
    at || (at = [], _[nt] = at, $.push(at)), at.push(_e);
  }), $;
}
function flat(a) {
  return a.reduce(function(s, $) {
    return s.concat($);
  }, []);
}
function maxOffset() {
  for (var a = [], s = 0; s < arguments.length; s++)
    a[s] = arguments[s];
  return a.sort(function($, _) {
    return Math.abs(_) - Math.abs($);
  }), a[0];
}
function calculateInversePosition(a, s, $) {
  return calculate(invert(a, $), convertPositionMatrix(s, $), $);
}
function convertDragDist(a, s) {
  var $, _ = a.is3d, _e = a.rootMatrix, tt = _ ? 4 : 3;
  return $ = calculateInversePosition(_e, [s.distX, s.distY], tt), s.distX = $[0], s.distY = $[1], s;
}
function calculatePadding(a, s, $, _, _e) {
  return minus(calculatePosition(a, plus($, s), _e), _);
}
function convertCSSSize(a, s, $) {
  return $ ? a / s * 100 + "%" : a + "px";
}
function moveControlPos(a, s, $, _) {
  var _e = a[s], tt = _e.direction, nt = _e.sub, at = a.map(function() {
    return [0, 0];
  }), ot = tt ? tt.split("") : [];
  if (_ && s < 8) {
    var rt = ot.filter(function(lt) {
      return lt === "w" || lt === "e";
    })[0], st = ot.filter(function(lt) {
      return lt === "n" || lt === "s";
    })[0];
    at[s] = $, a.forEach(function(lt, et) {
      var it = lt.direction;
      it && (it.indexOf(rt) > -1 && (at[et][0] = $[0]), it.indexOf(st) > -1 && (at[et][1] = $[1]));
    }), rt && (at[1][0] = $[0] / 2, at[5][0] = $[0] / 2), st && (at[3][1] = $[1] / 2, at[7][1] = $[1] / 2);
  } else
    tt && !nt ? ot.forEach(function(lt) {
      var et = lt === "n" || lt === "s";
      a.forEach(function(it, ut) {
        var ft = it.direction, ht = it.horizontal, dt = it.vertical;
        !ft || ft.indexOf(lt) === -1 || (at[ut] = [et || !ht ? 0 : $[0], !et || !dt ? 0 : $[1]]);
      });
    }) : at[s] = $;
  return at;
}
function getTinyDist(a) {
  return Math.abs(a) <= TINY_NUM ? 0 : a;
}
function directionCondition(a, s) {
  return s.isRequest ? s.requestAble === "resizable" || s.requestAble === "scalable" ? s.parentDirection : !1 : hasClass(s.inputEvent.target, prefix$1("direction"));
}
function getTransform(a, s) {
  var $ = a.slice(0, s < 0 ? void 0 : s), _ = a.slice(0, s < 0 ? void 0 : s + 1), _e = a[s] || "", tt = s < 0 ? [] : a.slice(s), nt = s < 0 ? [] : a.slice(s + 1), at = parse($), ot = parse(_), rt = parse([_e]), st = parse(tt), lt = parse(nt), et = toMat(at), it = toMat(ot), ut = toMat(st), ft = toMat(lt), ht = multiply(et, ut, 4);
  return {
    transforms: a,
    beforeFunctionMatrix: et,
    beforeFunctionMatrix2: it,
    targetFunctionMatrix: toMat(rt),
    afterFunctionMatrix: ut,
    afterFunctionMatrix2: ft,
    allFunctionMatrix: ht,
    beforeFunctions: at,
    beforeFunctions2: ot,
    targetFunction: rt[0],
    afterFunctions: st,
    afterFunctions2: lt,
    beforeFunctionTexts: $,
    beforeFunctionTexts2: _,
    targetFunctionText: _e,
    afterFunctionTexts: tt,
    afterFunctionTexts2: nt
  };
}
function isArrayFormat(a) {
  return !a || !isObject$1(a) ? !1 : isArray(a) || "length" in a;
}
function getRefTarget(a, s) {
  return a ? isString(a) ? s ? document.querySelector(a) : a : isFunction(a) ? a() : "current" in a ? a.current : a : null;
}
function getRefTargets(a, s) {
  if (!a)
    return [];
  var $ = isArrayFormat(a) ? [].slice.call(a) : [a];
  return $.reduce(function(_, _e) {
    return isString(_e) && s ? __spreadArrays(_, [].slice.call(document.querySelectorAll(_e))) : (_.push(getRefTarget(_e, s)), _);
  }, []);
}
function getElementTargets(a, s) {
  var $ = [];
  return a.forEach(function(_) {
    if (_) {
      if (isString(_)) {
        s[_] && $.push.apply($, s[_]);
        return;
      }
      $.push(_);
    }
  }), $;
}
function getAbsoluteRotation(a, s, $) {
  var _ = getRad$1(a, s) / Math.PI * 180;
  return _ = $ >= 0 ? _ : 180 - _, _ = _ >= 0 ? _ : 360 + _, _;
}
function getDragDistByState(a, s) {
  var $ = a.rootMatrix, _ = a.is3d, _e = _ ? 4 : 3, tt = invert($, _e);
  return _ || (tt = convertDimension(tt, 3, 4)), tt[12] = 0, tt[13] = 0, tt[14] = 0, calculateMatrixDist(tt, s);
}
var Pinchable = makeAble("pinchable", {
  events: {
    onPinchStart: "pinchStart",
    onPinch: "pinch",
    onPinchEnd: "pinchEnd",
    onPinchGroupStart: "pinchGroupStart",
    onPinchGroup: "pinchGroup",
    onPinchGroupEnd: "pinchGroupEnd"
  },
  dragStart: function() {
    return !0;
  },
  pinchStart: function(a, s) {
    var $ = s.datas, _ = s.targets, _e = s.angle, tt = s.originalDatas, nt = a.props, at = nt.pinchable, ot = nt.ables;
    if (!at)
      return !1;
    var rt = "onPinch" + (_ ? "Group" : "") + "Start", st = "drag" + (_ ? "Group" : "") + "ControlStart", lt = (at === !0 ? a.controlAbles : ot.filter(function(ft) {
      return at.indexOf(ft.name) > -1;
    })).filter(function(ft) {
      return ft.canPinch && ft[st];
    }), et = fillParams(a, s, {});
    _ && (et.targets = _);
    var it = triggerEvent(a, rt, et);
    $.isPinch = it !== !1, $.ables = lt;
    var ut = $.isPinch;
    return ut ? (lt.forEach(function(ft) {
      if (tt[ft.name] = tt[ft.name] || {}, !!ft[st]) {
        var ht = __assign$1(__assign$1({}, s), {
          datas: tt[ft.name],
          parentRotate: _e,
          isPinch: !0
        });
        ft[st](a, ht);
      }
    }), a.state.snapRenderInfo = {
      request: s.isRequest,
      direction: [0, 0]
    }, ut) : !1;
  },
  pinch: function(a, s) {
    var $ = s.datas, _ = s.scale, _e = s.distance, tt = s.originalDatas, nt = s.inputEvent, at = s.targets, ot = s.angle;
    if ($.isPinch) {
      var rt = _e * (1 - 1 / _), st = fillParams(a, s, {});
      at && (st.targets = at);
      var lt = "onPinch" + (at ? "Group" : "");
      triggerEvent(a, lt, st);
      var et = $.ables, it = "drag" + (at ? "Group" : "") + "Control";
      return et.forEach(function(ut) {
        ut[it] && ut[it](a, __assign$1(__assign$1({}, s), {
          datas: tt[ut.name],
          inputEvent: nt,
          parentDistance: rt,
          parentRotate: ot,
          isPinch: !0
        }));
      }), st;
    }
  },
  pinchEnd: function(a, s) {
    var $ = s.datas, _ = s.isPinch, _e = s.inputEvent, tt = s.targets, nt = s.originalDatas;
    if ($.isPinch) {
      var at = "onPinch" + (tt ? "Group" : "") + "End", ot = fillEndParams(a, s, {
        isDrag: _
      });
      tt && (ot.targets = tt), triggerEvent(a, at, ot);
      var rt = $.ables, st = "drag" + (tt ? "Group" : "") + "ControlEnd";
      return rt.forEach(function(lt) {
        lt[st] && lt[st](a, __assign$1(__assign$1({}, s), {
          isDrag: _,
          datas: nt[lt.name],
          inputEvent: _e,
          isPinch: !0
        }));
      }), _;
    }
  },
  pinchGroupStart: function(a, s) {
    return this.pinchStart(a, __assign$1(__assign$1({}, s), {
      targets: a.props.targets
    }));
  },
  pinchGroup: function(a, s) {
    return this.pinch(a, __assign$1(__assign$1({}, s), {
      targets: a.props.targets
    }));
  },
  pinchGroupEnd: function(a, s) {
    return this.pinchEnd(a, __assign$1(__assign$1({}, s), {
      targets: a.props.targets
    }));
  }
});
function setCustomDrag(a, s, $, _, _e) {
  var tt = s.gesto.move($, a.inputEvent), nt = tt.originalDatas || tt.datas, at = nt.draggable || (nt.draggable = {});
  return __assign$1(__assign$1({}, _e ? convertDragDist(s, tt) : tt), {
    isDrag: !0,
    isPinch: !!_,
    parentEvent: !0,
    datas: at,
    originalDatas: a.originalDatas
  });
}
var CustomGesto = /* @__PURE__ */ function() {
  function a() {
    this.prevX = 0, this.prevY = 0, this.startX = 0, this.startY = 0, this.isDrag = !1, this.isFlag = !1, this.datas = {
      draggable: {}
    };
  }
  var s = a.prototype;
  return s.dragStart = function($, _) {
    this.isDrag = !1, this.isFlag = !1;
    var _e = _.originalDatas;
    return this.datas = _e, _e.draggable || (_e.draggable = {}), __assign$1(__assign$1({}, this.move($, _.inputEvent)), {
      type: "dragstart"
    });
  }, s.drag = function($, _) {
    return this.move([$[0] - this.prevX, $[1] - this.prevY], _);
  }, s.move = function($, _) {
    var _e, tt;
    return this.isFlag ? (_e = this.prevX + $[0], tt = this.prevY + $[1], this.isDrag = !0) : (this.prevX = $[0], this.prevY = $[1], this.startX = $[0], this.startY = $[1], _e = $[0], tt = $[1], this.isFlag = !0), this.prevX = _e, this.prevY = tt, {
      type: "drag",
      clientX: _e,
      clientY: tt,
      inputEvent: _,
      isDrag: this.isDrag,
      distX: _e - this.startX,
      distY: tt - this.startY,
      deltaX: $[0],
      deltaY: $[1],
      datas: this.datas.draggable,
      originalDatas: this.datas,
      parentEvent: !0,
      parentGesto: this
    };
  }, a;
}();
function fillChildEvents(a, s, $) {
  var _ = $.originalDatas;
  _.groupable = _.groupable || {};
  var _e = _.groupable;
  _e.childDatas = _e.childDatas || [];
  var tt = _e.childDatas;
  return a.moveables.map(function(nt, at) {
    return tt[at] = tt[at] || {}, tt[at][s] = tt[at][s] || {}, __assign$1(__assign$1({}, $), {
      datas: tt[at][s],
      originalDatas: tt[at]
    });
  });
}
function triggerChildGesto(a, s, $, _, _e, tt) {
  var nt = !!$.match(/Start$/g), at = !!$.match(/End$/g), ot = _e.isPinch, rt = _e.datas, st = fillChildEvents(a, s.name, _e), lt = a.moveables, et = st.map(function(it, ut) {
    var ft = lt[ut], ht = it;
    nt ? ht = new CustomGesto().dragStart(_, it) : (ft.state.gesto || (ft.state.gesto = rt.childGestos[ut]), ht = setCustomDrag(it, ft.state, _, ot, tt));
    var dt = s[$](ft, __assign$1(__assign$1({}, ht), {
      parentFlag: !0
    }));
    return at && (ft.state.gesto = null), dt;
  });
  return nt && (rt.childGestos = lt.map(function(it) {
    return it.state.gesto;
  })), et;
}
function triggerChildAbles(a, s, $, _, _e, tt) {
  _e === void 0 && (_e = function(st, lt) {
    return lt;
  });
  var nt = !!$.match(/End$/g), at = fillChildEvents(a, s.name, _), ot = a.moveables, rt = at.map(function(st, lt) {
    var et = ot[lt], it = st;
    it = _e(et, st);
    var ut = s[$](et, __assign$1(__assign$1({}, it), {
      parentFlag: !0
    }));
    return ut && tt && tt(et, st, ut, lt), nt && (et.state.gesto = null), ut;
  });
  return rt;
}
function calculatePointerDist(a, s) {
  var $ = s.clientX, _ = s.clientY, _e = s.datas, tt = a.state, nt = tt.moveableClientRect, at = tt.rootMatrix, ot = tt.is3d, rt = tt.pos1, st = nt.left, lt = nt.top, et = ot ? 4 : 3, it = minus(calculateInversePosition(at, [$ - st, _ - lt], et), rt), ut = it[0], ft = it[1], ht = getDragDist({
    datas: _e,
    distX: ut,
    distY: ft
  }), dt = ht[0], gt = ht[1];
  return [dt, gt];
}
function setDragStart(a, s) {
  var $ = s.datas, _ = a.state, _e = _.allMatrix, tt = _.beforeMatrix, nt = _.is3d, at = _.left, ot = _.top, rt = _.origin, st = _.offsetMatrix, lt = _.targetMatrix, et = _.transformOrigin, it = nt ? 4 : 3;
  $.is3d = nt, $.matrix = _e, $.targetMatrix = lt, $.beforeMatrix = tt, $.offsetMatrix = st, $.transformOrigin = et, $.inverseMatrix = invert(_e, it), $.inverseBeforeMatrix = invert(tt, it), $.absoluteOrigin = convertPositionMatrix(plus([at, ot], rt), it), $.startDragBeforeDist = calculate($.inverseBeforeMatrix, $.absoluteOrigin, it), $.startDragDist = calculate($.inverseMatrix, $.absoluteOrigin, it);
}
function getTransformDirection(a) {
  return calculateMoveablePosition(a.datas.beforeTransform, [50, 50], 100, 100).direction;
}
function resolveTransformEvent(a, s) {
  var $ = a.datas, _ = a.originalDatas.beforeRenderable, _e = $.transformIndex, tt = _.nextTransforms, nt = _.nextTransformAppendedIndexes, at = _e === -1 ? tt.length : _e + nt.filter(function(lt) {
    return lt < _e;
  }).length, ot = getTransform(tt, at), rt = ot.targetFunction, st = s === "rotate" ? "rotateZ" : s;
  $.beforeFunctionTexts = ot.beforeFunctionTexts, $.afterFunctionTexts = ot.afterFunctionTexts, $.beforeTransform = ot.beforeFunctionMatrix, $.beforeTransform2 = ot.beforeFunctionMatrix2, $.targetTansform = ot.targetFunctionMatrix, $.afterTransform = ot.afterFunctionMatrix, $.afterTransform2 = ot.afterFunctionMatrix2, $.targetAllTransform = ot.allFunctionMatrix, rt.functionName === st ? ($.afterFunctionTexts.splice(0, 1), $.isAppendTransform = !1) : ($.isAppendTransform = !0, _.nextTransformAppendedIndexes = __spreadArrays(nt, [at]));
}
function convertTransformFormat(a, s, $) {
  return a.beforeFunctionTexts.join(" ") + " " + (a.isAppendTransform ? $ : s) + " " + a.afterFunctionTexts.join(" ");
}
function getTransformDist(a) {
  var s = a.datas, $ = a.distX, _ = a.distY, _e = getBeforeDragDist({
    datas: s,
    distX: $,
    distY: _
  }), tt = _e[0], nt = _e[1], at = getTransfromMatrix(s, fromTranslation([tt, nt], 4));
  return calculate(at, convertPositionMatrix([0, 0, 0], 4), 4);
}
function getTransfromMatrix(a, s, $) {
  var _ = a.beforeTransform, _e = a.afterTransform, tt = a.beforeTransform2, nt = a.afterTransform2, at = a.targetAllTransform, ot = $ ? multiply(at, s, 4) : multiply(s, at, 4), rt = multiply(invert($ ? tt : _, 4), ot, 4), st = multiply(rt, invert($ ? nt : _e, 4), 4);
  return st;
}
function getBeforeDragDist(a) {
  var s = a.datas, $ = a.distX, _ = a.distY, _e = s.inverseBeforeMatrix, tt = s.is3d, nt = s.startDragBeforeDist, at = s.absoluteOrigin, ot = tt ? 4 : 3;
  return minus(calculate(_e, plus(at, [$, _]), ot), nt);
}
function getDragDist(a, s) {
  var $ = a.datas, _ = a.distX, _e = a.distY, tt = $.inverseBeforeMatrix, nt = $.inverseMatrix, at = $.is3d, ot = $.startDragBeforeDist, rt = $.startDragDist, st = $.absoluteOrigin, lt = at ? 4 : 3;
  return minus(calculate(s ? tt : nt, plus(st, [_, _e]), lt), s ? ot : rt);
}
function getInverseDragDist(a, s) {
  var $ = a.datas, _ = a.distX, _e = a.distY, tt = $.beforeMatrix, nt = $.matrix, at = $.is3d, ot = $.startDragBeforeDist, rt = $.startDragDist, st = $.absoluteOrigin, lt = at ? 4 : 3;
  return minus(calculate(s ? tt : nt, plus(s ? ot : rt, [_, _e]), lt), st);
}
function calculateTransformOrigin(a, s, $, _, _e, tt) {
  return _ === void 0 && (_ = s), _e === void 0 && (_e = $), tt === void 0 && (tt = [0, 0]), a ? a.map(function(nt, at) {
    var ot = splitUnit(nt), rt = ot.value, st = ot.unit, lt = at ? _e : _, et = at ? $ : s;
    if (nt === "%" || isNaN(rt)) {
      var it = lt ? tt[at] / lt : 0;
      return et * it;
    } else if (st !== "%")
      return rt;
    return et * rt / 100;
  }) : tt;
}
function getPosIndexesByDirection(a) {
  var s = [];
  return a[1] >= 0 && (a[0] >= 0 && s.push(3), a[0] <= 0 && s.push(2)), a[1] <= 0 && (a[0] >= 0 && s.push(1), a[0] <= 0 && s.push(0)), s;
}
function getPosesByDirection(a, s) {
  return getPosIndexesByDirection(s).map(function($) {
    return a[$];
  });
}
function getPosByDirection(a, s) {
  var $ = getPosesByDirection(a, s);
  return [average($.map(function(_) {
    return _[0];
  })), average($.map(function(_) {
    return _[1];
  }))];
}
function getPosByReverseDirection(a, s) {
  return getPosByDirection(a, s.map(function($) {
    return -$;
  }));
}
function getDist(a, s, $, _, _e, tt) {
  var nt = calculatePoses(s, $, _, _e), at = getPosByDirection(nt, tt), ot = a[0] - at[0], rt = a[1] - at[1];
  return [ot, rt];
}
function getNextMatrix(a, s, $, _) {
  return multiply(a, getAbsoluteMatrix(s, _, $), _);
}
function getNextTransformMatrix(a, s, $) {
  var _ = a.transformOrigin, _e = a.offsetMatrix, tt = a.is3d, nt = s.beforeTransform, at = s.afterTransform, ot = tt ? 4 : 3, rt = parseMat([$]);
  return getNextMatrix(_e, convertDimension(multiply(multiply(nt, rt, 4), at, 4), 4, ot), _, ot);
}
function scaleMatrix(a, s) {
  var $ = a.transformOrigin, _ = a.offsetMatrix, _e = a.is3d, tt = a.targetMatrix, nt = _e ? 4 : 3;
  return getNextMatrix(_, multiply(tt, createScaleMatrix(s, nt), nt), $, nt);
}
function fillTransformStartEvent(a) {
  var s = a.originalDatas.beforeRenderable;
  return {
    setTransform: function($, _) {
      _ === void 0 && (_ = -1), s.startTransforms = isArray($) ? $ : splitSpace($), setTransformIndex(a, _);
    },
    setTransformIndex: function($) {
      setTransformIndex(a, $);
    }
  };
}
function setDefaultTransformIndex(a, s) {
  var $ = a.originalDatas.beforeRenderable, _ = $.startTransforms;
  setTransformIndex(a, findIndex(_, function(_e) {
    return _e.indexOf(s + "(") === 0;
  }));
}
function setTransformIndex(a, s) {
  var $ = a.originalDatas.beforeRenderable, _ = a.datas;
  if (_.transformIndex = s, s !== -1) {
    var _e = $.startTransforms[s];
    if (_e) {
      var tt = parse([_e]);
      _.startValue = tt[0].functionValue;
    }
  }
}
function fillOriginalTransform(a, s) {
  var $ = a.originalDatas.beforeRenderable;
  $.nextTransforms = splitSpace(s);
}
function fillTransformEvent(a, s, $, _, _e) {
  return fillOriginalTransform(_e, s), {
    transform: s,
    drag: Draggable.drag(a, setCustomDrag(_e, a.state, $, _, !1))
  };
}
function getTranslateDist(a, s, $, _, _e) {
  var tt = a.state, nt = tt.left, at = tt.top, ot = a.props.groupable, rt = getNextTransformMatrix(a.state, _e, s), st = ot ? nt : 0, lt = ot ? at : 0, et = getDirectionOffset(a, $, rt), it = minus(_, et);
  return minus(it, [st, lt]);
}
function getScaleDist(a, s, $, _, _e) {
  return getTranslateDist(a, "scale(" + s.join(", ") + ")", $, _, _e);
}
function getOriginDirection(a) {
  var s = a.state, $ = s.width, _ = s.height, _e = s.transformOrigin;
  return [-1 + _e[0] / ($ / 2), -1 + _e[1] / (_ / 2)];
}
function getDirectionOffset(a, s, $) {
  $ === void 0 && ($ = a.state.allMatrix);
  var _ = a.state, _e = _.width, tt = _.height, nt = _.is3d, at = nt ? 4 : 3, ot = [_e / 2 * (1 + s[0]), tt / 2 * (1 + s[1])];
  return calculatePosition($, ot, at);
}
function getRotateDist(a, s, $, _) {
  var _e = getOriginDirection(a);
  return getTranslateDist(a, "rotate(" + s + "deg)", _e, $, _);
}
function getResizeDist(a, s, $, _, _e, tt) {
  var nt = a.props.groupable, at = a.state, ot = at.transformOrigin, rt = at.targetMatrix, st = at.offsetMatrix, lt = at.is3d, et = at.width, it = at.height, ut = at.left, ft = at.top, ht = lt ? 4 : 3, dt = calculateTransformOrigin(tt, s, $, et, it, ot), gt = nt ? ut : 0, pt = nt ? ft : 0, mt = getNextMatrix(st, rt, dt, ht), ct = getDist(_e, mt, s, $, ht, _);
  return minus(ct, [gt, pt]);
}
function getAbsolutePosition(a, s) {
  return getPosByDirection(getAbsolutePosesByState(a.state), s);
}
var VERTICAL_NAMES = ["left", "right", "center"], HORIZONTAL_NAMES = ["top", "bottom", "middle"], VERTICAL_NAMES_MAP = {
  start: "left",
  end: "right",
  center: "center"
}, HORIZONTAL_NAMES_MAP = {
  start: "top",
  end: "bottom",
  center: "middle"
};
function hasGuidelines(a, s) {
  var $ = a.props, _ = $.snappable, _e = $.bounds, tt = $.innerBounds, nt = $.verticalGuidelines, at = $.horizontalGuidelines, ot = $.snapGridWidth, rt = $.snapGridHeight, st = a.state, lt = st.guidelines, et = st.enableSnap;
  return !_ || !et || s && _ !== !0 && _.indexOf(s) < 0 ? !1 : !!(ot || rt || _e || tt || lt && lt.length || nt && nt.length || at && at.length);
}
function getSnapDirections(a) {
  return a === !1 ? {} : a === !0 || !a ? {
    left: !0,
    right: !0,
    top: !0,
    bottom: !0
  } : a;
}
function mapSnapDirectionPoses(a, s) {
  var $ = getSnapDirections(a), _ = {};
  for (var _e in $)
    _e in s && $[_e] && (_[_e] = s[_e]);
  return _;
}
function splitSnapDirectionPoses(a, s) {
  var $ = mapSnapDirectionPoses(a, s), _ = HORIZONTAL_NAMES.filter(function(tt) {
    return tt in $;
  }), _e = VERTICAL_NAMES.filter(function(tt) {
    return tt in $;
  });
  return {
    horizontal: _.map(function(tt) {
      return $[tt];
    }),
    vertical: _e.map(function(tt) {
      return $[tt];
    })
  };
}
function getGapGuidelines(a, s, $) {
  var _ = a.state.elementRects, _e = [];
  return [["vertical", VERTICAL_NAMES_MAP, HORIZONTAL_NAMES_MAP], ["horizontal", HORIZONTAL_NAMES_MAP, VERTICAL_NAMES_MAP]].forEach(function(tt) {
    var nt = tt[0], at = tt[1], ot = tt[2], rt = s[at.start], st = s[at.end], lt = s[at.center], et = s[ot.start], it = s[ot.end];
    function ut(dt) {
      var gt = dt.rect;
      return gt[at.end] < rt + $ ? rt - gt[at.end] : st - $ < gt[at.start] ? gt[at.start] - st : -1;
    }
    var ft = _.filter(function(dt) {
      var gt = dt.rect;
      return gt[ot.start] > it || gt[ot.end] < et ? !1 : ut(dt) > 0;
    }).sort(function(dt, gt) {
      return ut(dt) - ut(gt);
    }), ht = [];
    ft.forEach(function(dt) {
      ft.forEach(function(gt) {
        if (dt !== gt) {
          var pt = dt.rect, mt = gt.rect, ct = pt[ot.start], vt = pt[ot.end], At = mt[ot.start], xt = mt[ot.end];
          ct > xt || At > vt || ht.push([dt, gt]);
        }
      });
    }), ht.forEach(function(dt) {
      var gt = dt[0], pt = dt[1], mt = gt.rect, ct = pt.rect, vt = mt[at.start], At = mt[at.end], xt = ct[at.start], bt = ct[at.end], Et = 0, St = 0, Bt = !1, Ot = !1, Pt = !1;
      if (At <= rt && st <= xt) {
        if (Ot = !0, Et = (xt - At - (st - rt)) / 2, St = At + Et + (st - rt) / 2, Math.abs(St - lt) > $)
          return;
      } else if (At < xt && bt < rt + $) {
        if (Bt = !0, Et = xt - At, St = bt + Et, Math.abs(St - rt) > $)
          return;
      } else if (At < xt && st - $ < vt) {
        if (Pt = !0, Et = xt - At, St = vt - Et, Math.abs(St - st) > $)
          return;
      } else
        return;
      Et && _e.push({
        type: nt,
        pos: nt === "vertical" ? [St, 0] : [0, St],
        element: pt.element,
        size: 0,
        className: pt.className,
        isStart: Bt,
        isCenter: Ot,
        isEnd: Pt,
        gap: Et,
        hide: !0,
        gapRects: [gt, pt]
      });
    });
  }), _e;
}
function getDefaultGuidelines(a, s, $, _, _e, tt, nt) {
  _e === void 0 && (_e = 0), tt === void 0 && (tt = 0), nt === void 0 && (nt = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  });
  var at = [], ot = nt.left, rt = nt.top, st = nt.bottom, lt = nt.right, et = $ + lt - ot, it = _ + st - rt;
  return a && a.forEach(function(ut) {
    at.push({
      type: "horizontal",
      pos: [ot, throttle(ut - tt + rt, 0.1)],
      size: et
    });
  }), s && s.forEach(function(ut) {
    at.push({
      type: "vertical",
      pos: [throttle(ut - _e + ot, 0.1), rt],
      size: it
    });
  }), at;
}
function calculateContainerPos(a, s, $) {
  var _ = calculatePosition(a, [s.clientLeft, s.clientTop], $);
  return [s.left + _[0], s.top + _[1]];
}
function getSnapElementRects(a, s) {
  if (!s.length)
    return [];
  var $ = a.state, _ = $.containerClientRect, _e = $.targetClientRect, tt = _e.top, nt = _e.left, at = $.rootMatrix, ot = $.is3d, rt = ot ? 4 : 3, st = calculateContainerPos(at, _, rt), lt = st[0], et = st[1], it = getAbsolutePosesByState($), ut = getMinMaxs(it), ft = ut.minX, ht = ut.minY, dt = minus([ft, ht], calculateInversePosition(at, [nt - lt, tt - et], rt)).map(function(mt) {
    return roundSign(mt);
  }), gt = dt[0], pt = dt[1];
  return s.map(function(mt) {
    var ct = mt.element.getBoundingClientRect(), vt = ct.left - lt, At = ct.top - et, xt = At + ct.height, bt = vt + ct.width, Et = calculateInversePosition(at, [vt, At], rt), St = Et[0], Bt = Et[1], Ot = calculateInversePosition(at, [bt, xt], rt), Pt = Ot[0], wt = Ot[1];
    return __assign$1(__assign$1({}, mt), {
      rect: {
        left: St + gt,
        right: Pt + gt,
        top: Bt + pt,
        bottom: wt + pt,
        center: (St + Pt) / 2 + gt,
        middle: (Bt + wt) / 2 + pt
      }
    });
  });
}
function getElementGuidelines(a) {
  var s = a.state, $ = a.props.elementGuidelines, _ = $ === void 0 ? [] : $;
  if (!_.length)
    return s.elementRects = [], [];
  var _e = (s.elementRects || []).filter(function(et) {
    return !et.refresh;
  }), tt = _.map(function(et) {
    return isObject$1(et) && "element" in et ? et : {
      element: getRefTarget(et, !0)
    };
  }).filter(function(et) {
    return et.element;
  }), nt = diff(_e.map(function(et) {
    return et.element;
  }), tt.map(function(et) {
    return et.element;
  })), at = nt.maintained, ot = nt.added, rt = [];
  at.forEach(function(et) {
    var it = et[0], ut = et[1];
    rt[ut] = _e[it];
  }), getSnapElementRects(a, ot.map(function(et) {
    return tt[et];
  })).map(function(et, it) {
    rt[ot[it]] = et;
  }), s.elementRects = rt;
  var st = getSnapDirections(a.props.elementSnapDirections), lt = [];
  return rt.forEach(function(et) {
    var it = et.element, ut = et.top, ft = ut === void 0 ? st.top : ut, ht = et.left, dt = ht === void 0 ? st.left : ht, gt = et.right, pt = gt === void 0 ? st.right : gt, mt = et.bottom, ct = mt === void 0 ? st.bottom : mt, vt = et.center, At = vt === void 0 ? st.center : vt, xt = et.middle, bt = xt === void 0 ? st.middle : xt, Et = et.className, St = et.rect, Bt = splitSnapDirectionPoses({
      top: ft,
      right: pt,
      left: dt,
      bottom: ct,
      center: At,
      middle: bt
    }, St), Ot = Bt.horizontal, Pt = Bt.vertical, wt = St.top, Ct = St.left, It = St.right - Ct, yt = St.bottom - wt, Rt = [It, yt];
    Pt.forEach(function(kt) {
      lt.push({
        type: "vertical",
        element: it,
        pos: [throttle(kt, 0.1), wt],
        size: yt,
        sizes: Rt,
        className: Et,
        elementRect: et
      });
    }), Ot.forEach(function(kt) {
      lt.push({
        type: "horizontal",
        element: it,
        pos: [Ct, throttle(kt, 0.1)],
        size: It,
        sizes: Rt,
        className: Et,
        elementRect: et
      });
    });
  }), lt;
}
function getTotalGuidelines(a) {
  var s = a.state, $ = s.snapOffset, _ = s.containerClientRect, _e = _.overflow, tt = _.scrollHeight, nt = _.scrollWidth, at = _.clientHeight, ot = _.clientWidth, rt = _.clientLeft, st = _.clientTop, lt = a.props, et = lt.snapGap, it = et === void 0 ? !0 : et, ut = lt.verticalGuidelines, ft = lt.horizontalGuidelines, ht = lt.snapThreshold, dt = ht === void 0 ? 5 : ht, gt = lt.snapGridWidth, pt = gt === void 0 ? 0 : gt, mt = lt.snapGridHeight, ct = mt === void 0 ? 0 : mt, vt = getElementGuidelines(a), At = __spreadArrays(vt);
  if (it) {
    var xt = getRect(getAbsolutePosesByState(a.state)), bt = xt.top, Et = xt.left, St = xt.bottom, Bt = xt.right;
    At.push.apply(At, getGapGuidelines(a, {
      top: bt,
      left: Et,
      bottom: St,
      right: Bt,
      center: (Et + Bt) / 2,
      middle: (bt + St) / 2
    }, dt));
  }
  return At.push.apply(At, getGridGuidelines(pt, ct, _e ? nt : ot, _e ? tt : at, rt, st)), At.push.apply(At, getDefaultGuidelines(ft || !1, ut || !1, _e ? nt : ot, _e ? tt : at, rt, st, $)), At;
}
function getGridGuidelines(a, s, $, _, _e, tt) {
  _e === void 0 && (_e = 0), tt === void 0 && (tt = 0);
  var nt = [];
  if (s)
    for (var at = 0; at <= _; at += s)
      nt.push({
        type: "horizontal",
        pos: [0, throttle(at - tt, 0.1)],
        size: $,
        hide: !0
      });
  if (a)
    for (var at = 0; at <= $; at += a)
      nt.push({
        type: "vertical",
        pos: [throttle(at - _e, 0.1), 0],
        size: _,
        hide: !0
      });
  return nt;
}
function checkMoveableSnapPoses(a, s, $, _) {
  var _e = a.props, tt = selectValue(_, _e.snapThreshold, 5);
  return checkSnapPoses(a.state.guidelines, s, $, tt);
}
function checkSnapPoses(a, s, $, _) {
  return {
    vertical: checkSnap(a, "vertical", s, _),
    horizontal: checkSnap(a, "horizontal", $, _)
  };
}
function checkSnapKeepRatio(a, s, $) {
  var _ = $[0], _e = $[1], tt = s[0], nt = s[1], at = minus($, s), ot = at[0], rt = at[1], st = rt > 0, lt = ot > 0;
  ot = getTinyDist(ot), rt = getTinyDist(rt);
  var et = {
    isSnap: !1,
    offset: 0,
    pos: 0
  }, it = {
    isSnap: !1,
    offset: 0,
    pos: 0
  };
  if (ot === 0 && rt === 0)
    return {
      vertical: et,
      horizontal: it
    };
  var ut = checkMoveableSnapPoses(a, ot ? [_] : [], rt ? [_e] : []), ft = ut.vertical, ht = ut.horizontal;
  ft.posInfos.filter(function(Pt) {
    var wt = Pt.pos;
    return lt ? wt >= tt : wt <= tt;
  }), ht.posInfos.filter(function(Pt) {
    var wt = Pt.pos;
    return st ? wt >= nt : wt <= nt;
  }), ft.isSnap = ft.posInfos.length > 0, ht.isSnap = ht.posInfos.length > 0;
  var dt = getNearestSnapGuidelineInfo(ft), gt = dt.isSnap, pt = dt.guideline, mt = getNearestSnapGuidelineInfo(ht), ct = mt.isSnap, vt = mt.guideline, At = ct ? vt.pos[1] : 0, xt = gt ? pt.pos[0] : 0;
  if (ot === 0)
    ct && (it.isSnap = !0, it.pos = vt.pos[1], it.offset = _e - it.pos);
  else if (rt === 0)
    gt && (et.isSnap = !0, et.pos = xt, et.offset = _ - xt);
  else {
    var bt = rt / ot, Et = $[1] - bt * _, St = 0, Bt = 0, Ot = !1;
    gt ? (Bt = xt, St = bt * Bt + Et, Ot = !0) : ct && (St = At, Bt = (St - Et) / bt, Ot = !0), Ot && (et.isSnap = !0, et.pos = Bt, et.offset = _ - Bt, it.isSnap = !0, it.pos = St, it.offset = _e - St);
  }
  return {
    vertical: et,
    horizontal: it
  };
}
function checkSnaps(a, s, $) {
  var _ = splitSnapDirectionPoses(a.props.snapDirections, s);
  return checkMoveableSnapPoses(a, _.vertical, _.horizontal, $);
}
function getNearestSnapGuidelineInfo(a) {
  var s = a.isSnap;
  if (!s)
    return {
      isSnap: !1,
      offset: 0,
      dist: -1,
      pos: 0,
      guideline: null
    };
  var $ = a.posInfos[0], _ = $.guidelineInfos[0], _e = _.offset, tt = _.dist, nt = _.guideline;
  return {
    isSnap: s,
    offset: _e,
    dist: tt,
    pos: $.pos,
    guideline: nt
  };
}
function checkSnap(a, s, $, _) {
  if (!a || !a.length)
    return {
      isSnap: !1,
      index: -1,
      posInfos: []
    };
  var _e = s === "vertical", tt = _e ? 0 : 1, nt = $.map(function(ot, rt) {
    var st = a.map(function(lt) {
      var et = lt.pos, it = ot - et[tt];
      return {
        offset: it,
        dist: Math.abs(it),
        guideline: lt
      };
    }).filter(function(lt) {
      var et = lt.guideline, it = lt.dist, ut = et.type;
      return !(ut !== s || it > _);
    }).sort(function(lt, et) {
      return lt.dist - et.dist;
    });
    return {
      pos: ot,
      index: rt,
      guidelineInfos: st
    };
  }).filter(function(ot) {
    return ot.guidelineInfos.length > 0;
  }).sort(function(ot, rt) {
    return ot.guidelineInfos[0].dist - rt.guidelineInfos[0].dist;
  }), at = nt.length > 0;
  return {
    isSnap: at,
    index: at ? nt[0].index : -1,
    posInfos: nt
  };
}
function getSnapInfosByDirection(a, s, $) {
  var _ = [];
  if ($[0] && $[1])
    _ = [$, [-$[0], $[1]], [$[0], -$[1]]].map(function(nt) {
      return getPosByDirection(s, nt);
    });
  else if (!$[0] && !$[1])
    for (var _e = [s[0], s[1], s[3], s[2], s[0]], tt = 0; tt < 4; ++tt)
      _.push(_e[tt]), _.push([(_e[tt][0] + _e[tt + 1][0]) / 2, (_e[tt][1] + _e[tt + 1][1]) / 2]);
  else
    a.props.keepRatio ? _ = [[-1, -1], [-1, 1], [1, -1], [1, 1], $].map(function(nt) {
      return getPosByDirection(s, nt);
    }) : (_ = getPosesByDirection(s, $), _.length > 1 && _.push([(_[0][0] + _[1][0]) / 2, (_[0][1] + _[1][1]) / 2]));
  return checkMoveableSnapPoses(a, _.map(function(nt) {
    return nt[0];
  }), _.map(function(nt) {
    return nt[1];
  }), 1);
}
function checkSnapBoundPriority(a, s) {
  var $ = Math.abs(a.offset), _ = Math.abs(s.offset);
  return a.isBound && s.isBound ? _ - $ : a.isBound ? -1 : s.isBound ? 1 : a.isSnap && s.isSnap ? _ - $ : a.isSnap ? -1 : s.isSnap || $ < TINY_NUM ? 1 : _ < TINY_NUM ? -1 : $ - _;
}
function getNearOffsetInfo(a, s) {
  return a.slice().sort(function($, _) {
    var _e = $.sign[s], tt = _.sign[s], nt = $.offset[s], at = _.offset[s];
    if (_e) {
      if (!tt)
        return -1;
    } else
      return 1;
    return checkSnapBoundPriority({
      isBound: $.isBound,
      isSnap: $.isSnap,
      offset: nt
    }, {
      isBound: _.isBound,
      isSnap: _.isSnap,
      offset: at
    });
  })[0];
}
function getCheckSnapDirections(a, s) {
  var $ = [], _ = [-a[0], -a[1]];
  return a[0] && a[1] ? ($.push([_, [a[0], -a[1]]], [_, [-a[0], a[1]]]), s && $.push([_, a])) : a[0] ? s ? $.push([_, [_[0], -1]], [_, [_[0], 1]], [_, [a[0], -1]], [_, a], [_, [a[0], 1]]) : $.push([[_[0], -1], [a[0], -1]], [[_[0], 0], [a[0], 0]], [[_[0], 1], [a[0], 1]]) : a[1] ? s ? $.push([_, [-1, _[1]]], [_, [1, _[1]]], [_, [-1, a[1]]], [_, [1, a[1]]], [_, a]) : $.push([[-1, _[1]], [-1, a[1]]], [[0, _[1]], [0, a[1]]], [[1, _[1]], [1, a[1]]]) : $.push([_, [1, 0]], [_, [-1, 0]], [_, [0, -1]], [_, [0, 1]], [[1, 0], [1, -1]], [[1, 0], [1, 1]], [[0, 1], [1, 1]], [[0, 1], [-1, 1]], [[-1, 0], [-1, -1]], [[-1, 0], [-1, 1]], [[0, -1], [1, -1]], [[0, -1], [-1, -1]]), $;
}
function isStartLine(a, s) {
  var $ = average([s[0][0], s[1][0]]), _ = average([s[0][1], s[1][1]]);
  return {
    vertical: $ <= a[0],
    horizontal: _ <= a[1]
  };
}
function hitTestLine(a, s) {
  var $ = s[0], _ = s[1], _e = _[0] - $[0], tt = _[1] - $[1];
  Math.abs(_e) < TINY_NUM && (_e = 0), Math.abs(tt) < TINY_NUM && (tt = 0);
  var nt, at;
  if (!_e)
    nt = $[0], at = a[0];
  else if (!tt)
    nt = $[1], at = a[1];
  else {
    var ot = tt / _e;
    nt = ot * (a[0] - $[0]) + $[1], at = a[1];
  }
  return nt - at;
}
function isSameStartLine(a, s, $) {
  $ === void 0 && ($ = TINY_NUM);
  var _ = hitTestLine(a[0], s) <= 0;
  return a.slice(1).every(function(_e) {
    var tt = hitTestLine(_e, s), nt = tt <= 0;
    return nt === _ || Math.abs(tt) <= $;
  });
}
function checkInnerBoundDot(a, s, $, _, _e) {
  return _e === void 0 && (_e = 0), _ && s - _e <= a || !_ && a <= $ + _e ? {
    isBound: !0,
    offset: _ ? s - a : $ - a
  } : {
    isBound: !1,
    offset: 0
  };
}
function checkInnerBound(a, s, $) {
  var _ = a.props.innerBounds;
  if (!_)
    return {
      isAllBound: !1,
      isBound: !1,
      isVerticalBound: !1,
      isHorizontalBound: !1,
      offset: [0, 0]
    };
  var _e = _.left, tt = _.top, nt = _.width, at = _.height, ot = [[_e, tt], [_e, tt + at]], rt = [[_e, tt], [_e + nt, tt]], st = [[_e + nt, tt], [_e + nt, tt + at]], lt = [[_e, tt + at], [_e + nt, tt + at]], et = isStartLine($, s), it = et.horizontal, ut = et.vertical;
  if (isSameStartLine([$, [_e, tt], [_e + nt, tt], [_e, tt + at], [_e + nt, tt + at]], s))
    return {
      isAllBound: !1,
      isBound: !1,
      isVerticalBound: !1,
      isHorizontalBound: !1,
      offset: [0, 0]
    };
  var ft = checkLineBoundCollision(s, rt, ut), ht = checkLineBoundCollision(s, lt, ut), dt = checkLineBoundCollision(s, ot, it), gt = checkLineBoundCollision(s, st, it), pt = ft.isBound && ht.isBound, mt = ft.isBound || ht.isBound, ct = dt.isBound && gt.isBound, vt = dt.isBound || gt.isBound, At = maxOffset(ft.offset, ht.offset), xt = maxOffset(dt.offset, gt.offset), bt = [0, 0], Et = !1, St = !1;
  return Math.abs(xt) < Math.abs(At) ? (bt = [At, 0], Et = mt, St = pt) : (bt = [0, xt], Et = vt, St = ct), {
    isAllBound: St,
    isVerticalBound: mt,
    isHorizontalBound: vt,
    isBound: Et,
    offset: bt
  };
}
function checkLineBoundCollision(a, s, $, _, _e) {
  var tt = a[0], nt = a[1], at = s[0], ot = s[1], rt = getTinyDist(nt[1] - tt[1]), st = getTinyDist(nt[0] - tt[0]), lt = getTinyDist(ot[1] - at[1]), et = getTinyDist(ot[0] - at[0]);
  if (et) {
    if (!lt) {
      if (_e && !st)
        return {
          isBound: !1,
          offset: 0
        };
      if (rt) {
        var ht = (at[1] - tt[1]) / (rt / st) + tt[0];
        return checkInnerBoundDot(ht, at[0], ot[0], $, _);
      } else {
        var ut = at[1] - tt[1], ft = Math.abs(ut) <= (_ || 0);
        return {
          isBound: ft,
          offset: ft ? ut : 0
        };
      }
    }
  } else {
    if (_e && !rt)
      return {
        isBound: !1,
        offset: 0
      };
    if (st) {
      var it = rt / st * (at[0] - tt[0]) + tt[1];
      return checkInnerBoundDot(it, at[1], ot[1], $, _);
    } else {
      var ut = at[0] - tt[0], ft = Math.abs(ut) <= (_ || 0);
      return {
        isBound: ft,
        offset: ft ? ut : 0
      };
    }
  }
  return {
    isBound: !1,
    offset: 0
  };
}
function getInnerBoundInfo(a, s, $, _) {
  return s.map(function(_e) {
    var tt = _e[0], nt = _e[1], at = _e[2], ot = checkInnerBound(a, [nt, at], $), rt = ot.isBound, st = ot.offset, lt = ot.isVerticalBound, et = ot.isHorizontalBound, it = getDragDist({
      datas: _,
      distX: st[0],
      distY: st[1]
    }).map(function(ut, ft) {
      return ut * (tt[ft] ? 2 / tt[ft] : 0);
    });
    return {
      sign: tt,
      isBound: rt,
      isVerticalBound: lt,
      isHorizontalBound: et,
      isSnap: !1,
      offset: it
    };
  });
}
function getInnerBoundDragInfo(a, s, $) {
  var _, _e = getCheckInnerBoundLines(s, [0, 0], !1).map(function(et) {
    var it = et[0], ut = et[1], ft = et[2];
    return [it.map(function(ht) {
      return Math.abs(ht) * 2;
    }), ut, ft];
  }), tt = getInnerBoundInfo(a, _e, getPosByDirection(s, [0, 0]), $), nt = getNearOffsetInfo(tt, 0), at = getNearOffsetInfo(tt, 1), ot = 0, rt = 0, st = nt.isVerticalBound || at.isVerticalBound, lt = nt.isHorizontalBound || at.isHorizontalBound;
  return (st || lt) && (_ = getInverseDragDist({
    datas: $,
    distX: -nt.offset[0],
    distY: -at.offset[1]
  }), ot = _[0], rt = _[1]), {
    vertical: {
      isBound: st,
      offset: ot
    },
    horizontal: {
      isBound: lt,
      offset: rt
    }
  };
}
function getCheckSnapLineDirections(a, s) {
  var $ = [], _ = a[0], _e = a[1];
  return _ && _e ? $.push([[0, _e * 2], a, [-_, _e]], [[_ * 2, 0], a, [_, -_e]]) : _ ? ($.push([[_ * 2, 0], [_, 1], [_, -1]]), s && $.push([[0, -1], [_, -1], [-_, -1]], [[0, 1], [_, 1], [-_, 1]])) : _e ? ($.push([[0, _e * 2], [1, _e], [-1, _e]]), s && $.push([[-1, 0], [-1, _e], [-1, -_e]], [[1, 0], [1, _e], [1, -_e]])) : $.push([[-1, 0], [-1, -1], [-1, 1]], [[1, 0], [1, -1], [1, 1]], [[0, -1], [-1, -1], [1, -1]], [[0, 1], [-1, 1], [1, 1]]), $;
}
function getCheckInnerBoundLines(a, s, $) {
  return getCheckSnapLineDirections(s, $).map(function(_) {
    var _e = _[0], tt = _[1], nt = _[2];
    return [_e, getPosByDirection(a, tt), getPosByDirection(a, nt)];
  });
}
function isBoundRotate(a, s, $, _) {
  var _e = _ ? a.map(function(nt) {
    return rotate(nt, _);
  }) : a, tt = __spreadArrays([$], s);
  return [[_e[0], _e[1]], [_e[1], _e[3]], [_e[3], _e[2]], [_e[2], _e[0]]].some(function(nt) {
    return !isSameStartLine(tt, nt);
  });
}
function getDistPointLine(a) {
  var s = a[0], $ = a[1], _ = $[0] - s[0], _e = $[1] - s[1];
  if (!_)
    return Math.abs(s[0]);
  if (!_e)
    return Math.abs(s[1]);
  var tt = _e / _;
  return Math.abs((-tt * s[0] + s[1]) / Math.sqrt(Math.pow(tt, 2) + 1));
}
function solveReverseLine(a) {
  var s = a[0], $ = a[1], _ = $[0] - s[0], _e = $[1] - s[1];
  if (!_)
    return [s[0], 0];
  if (!_e)
    return [0, s[1]];
  var tt = _e / _, nt = -tt * s[0] + s[1];
  return [-nt / (tt + 1 / tt), nt / (tt * tt + 1)];
}
function checkRotateInnerBounds(a, s, $, _, _e) {
  var tt = a.props.innerBounds, nt = _e * Math.PI / 180;
  if (!tt)
    return [];
  var at = tt.left, ot = tt.top, rt = tt.width, st = tt.height, lt = at - _[0], et = at + rt - _[0], it = ot - _[1], ut = ot + st - _[1], ft = [[lt, it], [et, it], [lt, ut], [et, ut]], ht = getPosByDirection($, [0, 0]);
  if (!isBoundRotate($, ft, ht, 0))
    return [];
  var dt = [], gt = ft.map(function(pt) {
    return [getDistSize(pt), getRad$1([0, 0], pt)];
  });
  return [[$[0], $[1]], [$[1], $[3]], [$[3], $[2]], [$[2], $[0]]].forEach(function(pt) {
    var mt = getRad$1([0, 0], solveReverseLine(pt)), ct = getDistPointLine(pt);
    dt.push.apply(dt, gt.filter(function(vt) {
      var At = vt[0];
      return At && ct <= At;
    }).map(function(vt) {
      var At = vt[0], xt = vt[1], bt = Math.acos(At ? ct / At : 0), Et = xt + bt, St = xt - bt;
      return [nt + Et - mt, nt + St - mt];
    }).reduce(function(vt, At) {
      return vt.push.apply(vt, At), vt;
    }, []).filter(function(vt) {
      return !isBoundRotate(s, ft, ht, vt);
    }).map(function(vt) {
      return throttle(vt * 180 / Math.PI, TINY_NUM);
    }));
  }), dt;
}
function checkInnerBoundPoses(a) {
  var s = a.props.innerBounds;
  if (!s)
    return {
      vertical: [],
      horizontal: []
    };
  var $ = a.getRect(), _ = $.pos1, _e = $.pos2, tt = $.pos3, nt = $.pos4, at = [_, _e, tt, nt], ot = getPosByDirection(at, [0, 0]), rt = s.left, st = s.top, lt = s.width, et = s.height, it = [[rt, st], [rt, st + et]], ut = [[rt, st], [rt + lt, st]], ft = [[rt + lt, st], [rt + lt, st + et]], ht = [[rt, st + et], [rt + lt, st + et]], dt = [[_, _e], [_e, nt], [nt, tt], [tt, _]], gt = [], pt = [], mt = {
    top: !1,
    bottom: !1,
    left: !1,
    right: !1
  };
  return dt.forEach(function(ct) {
    var vt = isStartLine(ot, ct), At = vt.horizontal, xt = vt.vertical, bt = checkLineBoundCollision(ct, ut, xt, 1, !0), Et = checkLineBoundCollision(ct, ht, xt, 1, !0), St = checkLineBoundCollision(ct, it, At, 1, !0), Bt = checkLineBoundCollision(ct, ft, At, 1, !0);
    bt.isBound && !mt.top && (gt.push(st), mt.top = !0), Et.isBound && !mt.bottom && (gt.push(st + et), mt.bottom = !0), St.isBound && !mt.left && (pt.push(rt), mt.left = !0), Bt.isBound && !mt.right && (pt.push(rt + lt), mt.right = !0);
  }), {
    horizontal: gt,
    vertical: pt
  };
}
function checkBoundPoses(a, s, $) {
  var _ = a || {}, _e = _.position, tt = _e === void 0 ? "client" : _e, nt = _.left, at = nt === void 0 ? -1 / 0 : nt, ot = _.top, rt = ot === void 0 ? -1 / 0 : ot, st = _.right, lt = st === void 0 ? 1 / 0 : st, et = _.bottom, it = et === void 0 ? 1 / 0 : et, ut = {
    position: tt,
    left: at,
    top: rt,
    right: lt,
    bottom: it
  };
  return {
    vertical: checkBounds(ut, s, !0),
    horizontal: checkBounds(ut, $, !1)
  };
}
function getBounds(a, s) {
  var $ = a.state, _ = $.containerClientRect, _e = _.clientHeight, tt = _.clientWidth, nt = _.clientLeft, at = _.clientTop, ot = $.snapOffset, rt = ot.left, st = ot.top, lt = ot.right, et = ot.bottom, it = s || a.props.bounds || {}, ut = it.position || "client", ft = ut === "css", ht = it.left, dt = ht === void 0 ? -1 / 0 : ht, gt = it.top, pt = gt === void 0 ? -1 / 0 : gt, mt = it.right, ct = mt === void 0 ? ft ? -1 / 0 : 1 / 0 : mt, vt = it.bottom, At = vt === void 0 ? ft ? -1 / 0 : 1 / 0 : vt;
  return ft && (ct = tt + lt - rt - ct, At = _e + et - st - At), {
    left: dt + rt - nt,
    right: ct + rt - nt,
    top: pt + st - at,
    bottom: At + st - at
  };
}
function checkBoundKeepRatio(a, s, $) {
  var _ = getBounds(a), _e = _.left, tt = _.top, nt = _.right, at = _.bottom, ot = $[0], rt = $[1], st = minus($, s), lt = st[0], et = st[1];
  Math.abs(lt) < TINY_NUM && (lt = 0), Math.abs(et) < TINY_NUM && (et = 0);
  var it = et > 0, ut = lt > 0, ft = {
    isBound: !1,
    offset: 0,
    pos: 0
  }, ht = {
    isBound: !1,
    offset: 0,
    pos: 0
  };
  if (lt === 0 && et === 0)
    return {
      vertical: ft,
      horizontal: ht
    };
  if (lt === 0)
    it ? at < rt && (ht.pos = at, ht.offset = rt - at) : tt > rt && (ht.pos = tt, ht.offset = rt - tt);
  else if (et === 0)
    ut ? nt < ot && (ft.pos = nt, ft.offset = ot - nt) : _e > ot && (ft.pos = _e, ft.offset = ot - _e);
  else {
    var dt = et / lt, gt = $[1] - dt * ot, pt = 0, mt = 0, ct = !1;
    ut && nt <= ot ? (pt = dt * nt + gt, mt = nt, ct = !0) : !ut && ot <= _e && (pt = dt * _e + gt, mt = _e, ct = !0), ct && (pt < tt || pt > at) && (ct = !1), ct || (it && at <= rt ? (pt = at, mt = (pt - gt) / dt, ct = !0) : !it && rt <= tt && (pt = tt, mt = (pt - gt) / dt, ct = !0)), ct && (ft.isBound = !0, ft.pos = mt, ft.offset = ot - mt, ht.isBound = !0, ht.pos = pt, ht.offset = rt - pt);
  }
  return {
    vertical: ft,
    horizontal: ht
  };
}
function checkBounds(a, s, $) {
  var _ = a[$ ? "left" : "top"], _e = a[$ ? "right" : "bottom"], tt = Math.min.apply(Math, s), nt = Math.max.apply(Math, s), at = [];
  return _ + 1 > tt && at.push({
    isBound: !0,
    offset: tt - _,
    pos: _
  }), _e - 1 < nt && at.push({
    isBound: !0,
    offset: nt - _e,
    pos: _e
  }), at.length || at.push({
    isBound: !1,
    offset: 0,
    pos: 0
  }), at.sort(function(ot, rt) {
    return Math.abs(rt.offset) - Math.abs(ot.offset);
  });
}
function isBoundRotate$1(a, s, $) {
  var _ = $ ? a.map(function(_e) {
    return rotate(_e, $);
  }) : a;
  return _.some(function(_e) {
    return _e[0] < s.left && Math.abs(_e[0] - s.left) > 0.1 || _e[0] > s.right && Math.abs(_e[0] - s.right) > 0.1 || _e[1] < s.top && Math.abs(_e[1] - s.top) > 0.1 || _e[1] > s.bottom && Math.abs(_e[1] - s.bottom) > 0.1;
  });
}
function boundRotate(a, s, $) {
  var _ = getDistSize(a), _e = Math.sqrt(_ * _ - s * s) || 0;
  return [_e, -_e].sort(function(tt, nt) {
    return Math.abs(tt - a[$ ? 0 : 1]) - Math.abs(nt - a[$ ? 0 : 1]);
  }).map(function(tt) {
    return getRad$1([0, 0], $ ? [tt, s] : [s, tt]);
  });
}
function checkRotateBounds(a, s, $, _, _e) {
  if (!a.props.bounds)
    return [];
  var tt = _e * Math.PI / 180, nt = getBounds(a), at = nt.left, ot = nt.top, rt = nt.right, st = nt.bottom, lt = at - _[0], et = rt - _[0], it = ot - _[1], ut = st - _[1], ft = {
    left: lt,
    top: it,
    right: et,
    bottom: ut
  };
  if (!isBoundRotate$1($, ft, 0))
    return [];
  var ht = [];
  return [[lt, 0], [et, 0], [it, 1], [ut, 1]].forEach(function(dt) {
    var gt = dt[0], pt = dt[1];
    $.forEach(function(mt) {
      var ct = getRad$1([0, 0], mt);
      ht.push.apply(ht, boundRotate(mt, gt, pt).map(function(vt) {
        return tt + vt - ct;
      }).filter(function(vt) {
        return !isBoundRotate$1(s, ft, vt);
      }).map(function(vt) {
        return throttle(vt * 180 / Math.PI, TINY_NUM);
      }));
    });
  }), ht;
}
function renderGuideline(a, s) {
  var $, _ = a.direction, _e = a.classNames, tt = a.size, nt = a.pos, at = a.zoom, ot = a.key, rt = _ === "horizontal", st = rt ? "Y" : "X";
  return s.createElement("div", {
    key: ot,
    className: _e.join(" "),
    style: ($ = {}, $[rt ? "width" : "height"] = "" + tt, $.transform = "translate(" + nt[0] + ", " + nt[1] + ") translate" + st + "(-50%) scale" + st + "(" + at + ")", $)
  });
}
function renderInnerGuideline(a, s) {
  return renderGuideline(__assign$1(__assign$1({}, a), {
    classNames: __spreadArrays([prefix$1("line", "guideline", a.direction)], a.classNames).filter(function($) {
      return $;
    }),
    size: a.size || a.sizeValue + "px",
    pos: a.pos || a.posValue.map(function($) {
      return throttle($, 0.1) + "px";
    })
  }), s);
}
function renderSnapPoses(a, s, $, _, _e, tt, nt, at) {
  var ot = a.props.zoom;
  return $.map(function(rt, st) {
    var lt = rt.type, et = rt.pos, it = [0, 0];
    return it[nt] = _, it[nt ? 0 : 1] = -_e + et, renderInnerGuideline({
      key: s + "TargetGuideline" + st,
      classNames: [prefix$1("target", "bold", lt)],
      posValue: it,
      sizeValue: tt,
      zoom: ot,
      direction: s
    }, at);
  });
}
function renderGuidelines(a, s, $, _, _e, tt) {
  var nt = a.props, at = nt.zoom, ot = nt.isDisplayInnerSnapDigit, rt = s === "horizontal" ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP, st = _e[rt.start], lt = _e[rt.end];
  return $.filter(function(et) {
    var it = et.hide, ut = et.elementRect;
    if (it)
      return !1;
    if (ot && ut) {
      var ft = ut.rect;
      if (ft[rt.start] <= st && lt <= ft[rt.end])
        return !1;
    }
    return !0;
  }).map(function(et, it) {
    var ut = et.pos, ft = et.size, ht = et.element, dt = [-_[0] + ut[0], -_[1] + ut[1]];
    return renderInnerGuideline({
      key: s + "-default-guideline-" + it,
      classNames: ht ? [prefix$1("bold")] : [],
      direction: s,
      posValue: dt,
      sizeValue: ft,
      zoom: at
    }, tt);
  });
}
function renderDigitLine(a, s, $, _, _e, tt, nt, at) {
  var ot, rt = a.props, st = rt.snapDigit, lt = st === void 0 ? 0 : st, et = rt.isDisplaySnapDigit, it = et === void 0 ? !0 : et, ut = rt.snapDistFormat, ft = ut === void 0 ? function(ct) {
    return ct;
  } : ut, ht = rt.zoom, dt = s === "horizontal" ? "X" : "Y", gt = s === "vertical" ? "height" : "width", pt = Math.abs(_e), mt = it ? parseFloat(pt.toFixed(lt)) : 0;
  return at.createElement("div", {
    key: s + "-" + $ + "-guideline-" + _,
    className: prefix$1("guideline-group", s),
    style: (ot = {
      left: tt[0] + "px",
      top: tt[1] + "px"
    }, ot[gt] = pt + "px", ot)
  }, renderInnerGuideline({
    direction: s,
    classNames: [prefix$1($), nt],
    size: "100%",
    posValue: [0, 0],
    sizeValue: pt,
    zoom: ht
  }, at), at.createElement("div", {
    className: prefix$1("size-value", "gap"),
    style: {
      transform: "translate" + dt + "(-50%) scale(" + ht + ")"
    }
  }, mt > 0 ? ft(mt) : ""));
}
function groupByElementGuidelines(a, s, $, _) {
  var _e = a === "vertical" ? 0 : 1, tt = a === "vertical" ? 1 : 0, nt = _e ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP, at = $[nt.start], ot = $[nt.end];
  return groupBy(s, function(rt) {
    return rt.pos[_e];
  }).map(function(rt) {
    var st = [], lt = [], et = [];
    return rt.forEach(function(it) {
      var ut, ft, ht = it.element, dt = it.elementRect.rect;
      if (dt[nt.end] < at)
        st.push(it);
      else if (ot < dt[nt.start])
        lt.push(it);
      else if (dt[nt.start] <= at && ot <= dt[nt.end] && _) {
        var gt = it.pos, pt = {
          element: ht,
          rect: __assign$1(__assign$1({}, dt), (ut = {}, ut[nt.end] = dt[nt.start], ut))
        }, mt = {
          element: ht,
          rect: __assign$1(__assign$1({}, dt), (ft = {}, ft[nt.start] = dt[nt.end], ft))
        }, ct = [0, 0], vt = [0, 0];
        ct[_e] = gt[_e], ct[tt] = gt[tt], vt[_e] = gt[_e], vt[tt] = gt[tt] + it.size, st.push({
          type: a,
          pos: ct,
          size: 0,
          elementRect: pt
        }), lt.push({
          type: a,
          pos: vt,
          size: 0,
          elementRect: mt
        });
      }
    }), st.sort(function(it, ut) {
      return ut.pos[tt] - it.pos[tt];
    }), lt.sort(function(it, ut) {
      return it.pos[tt] - ut.pos[tt];
    }), {
      total: rt,
      start: st,
      end: lt,
      inner: et
    };
  });
}
function renderDashedGuidelines(a, s, $, _, _e) {
  var tt = a.props.isDisplayInnerSnapDigit, nt = [];
  return ["vertical", "horizontal"].forEach(function(at) {
    var ot = s.filter(function(ht) {
      return ht.type === at;
    }), rt = at === "vertical" ? 1 : 0, st = rt ? 0 : 1, lt = groupByElementGuidelines(at, ot, _, tt), et = rt ? HORIZONTAL_NAMES_MAP : VERTICAL_NAMES_MAP, it = rt ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP, ut = _[et.start], ft = _[et.end];
    lt.forEach(function(ht) {
      var dt = ht.total, gt = ht.start, pt = ht.end, mt = ht.inner, ct = $[st] + dt[0].pos[st] - _[it.start], vt = _;
      gt.forEach(function(At) {
        var xt = At.elementRect.rect, bt = vt[et.start] - xt[et.end];
        if (bt > 0) {
          var Et = [0, 0];
          Et[rt] = $[rt] + vt[et.start] - ut - bt, Et[st] = ct, nt.push(renderDigitLine(a, at, "dashed", nt.length, bt, Et, At.className, _e));
        }
        vt = xt;
      }), vt = _, pt.forEach(function(At) {
        var xt = At.elementRect.rect, bt = xt[et.start] - vt[et.end];
        if (bt > 0) {
          var Et = [0, 0];
          Et[rt] = $[rt] + vt[et.end] - ut, Et[st] = ct, nt.push(renderDigitLine(a, at, "dashed", nt.length, bt, Et, At.className, _e));
        }
        vt = xt;
      }), mt.forEach(function(At) {
        var xt = At.elementRect.rect, bt = ut - xt[et.start], Et = xt[et.end] - ft, St = [0, 0], Bt = [0, 0];
        St[rt] = $[rt] - bt, St[st] = ct, Bt[rt] = $[rt] + ft - ut, Bt[st] = ct, nt.push(renderDigitLine(a, at, "dashed", nt.length, bt, St, At.className, _e)), nt.push(renderDigitLine(a, at, "dashed", nt.length, Et, Bt, At.className, _e));
      });
    });
  }), nt;
}
function renderGapGuidelines(a, s, $, _, _e) {
  var tt = [];
  return ["horizontal", "vertical"].forEach(function(nt) {
    var at = s.filter(function(ht) {
      return ht.type === nt;
    }), ot = nt === "vertical" ? 0 : 1, rt = ot ? 0 : 1, st = ot ? HORIZONTAL_NAMES_MAP : VERTICAL_NAMES_MAP, lt = ot ? VERTICAL_NAMES_MAP : HORIZONTAL_NAMES_MAP, et = _[st.start], it = _[st.end], ut = _[lt.start], ft = _[lt.end];
    at.forEach(function(ht) {
      var dt = ht.gap, gt = ht.gapRects, pt = ht.className, mt = Math.max.apply(Math, __spreadArrays([ut], gt.map(function(At) {
        var xt = At.rect;
        return xt[lt.start];
      }))), ct = Math.min.apply(Math, __spreadArrays([ft], gt.map(function(At) {
        var xt = At.rect;
        return xt[lt.end];
      }))), vt = (mt + ct) / 2;
      mt === ct || vt === (ut + ft) / 2 || gt.forEach(function(At) {
        var xt = At.rect, bt = [$[0], $[1]];
        if (xt[st.end] < et)
          bt[ot] += xt[st.end] - et;
        else if (it < xt[st.start])
          bt[ot] += xt[st.start] - et - dt;
        else
          return;
        bt[rt] += vt - ut, tt.push(renderDigitLine(a, ot ? "vertical" : "horizontal", "gap", tt.length, dt, bt, pt, _e));
      });
    });
  }), tt;
}
function solveEquation(a, s, $, _) {
  var _e = s[0] - a[0], tt = s[1] - a[1];
  if (Math.abs(_e) < TINY_NUM$1 && (_e = 0), Math.abs(tt) < TINY_NUM$1 && (tt = 0), !_e)
    return _ ? [0, 0] : [0, $];
  if (!tt)
    return _ ? [$, 0] : [0, 0];
  var nt = tt / _e, at = a[1] - nt * a[0];
  if (_) {
    var ot = nt * (s[0] + $) + at;
    return [$, ot - s[1]];
  } else {
    var rt = (s[1] + $ - at) / nt;
    return [rt - s[0], $];
  }
}
function solveNextOffset(a, s, $, _, _e) {
  var tt = solveEquation(a, s, $, _);
  if (!tt)
    return {
      isOutside: !1,
      offset: [0, 0]
    };
  var nt = getDist$2(a, s), at = getDist$2(tt, a), ot = getDist$2(tt, s), rt = at > nt || ot > nt, st = getDragDist({
    datas: _e,
    distX: tt[0],
    distY: tt[1]
  }), lt = st[0], et = st[1];
  return {
    offset: [lt, et],
    isOutside: rt
  };
}
function getSnapBound(a, s) {
  return a.isBound ? a.offset : s.isSnap ? getNearestSnapGuidelineInfo(s).offset : 0;
}
function checkThrottleDragRotate(a, s, $, _, _e) {
  var tt = s[0], nt = s[1], at = $[0], ot = $[1], rt = _[0], st = _[1], lt = _e[0], et = _e[1], it = -lt, ut = -et;
  if (a && tt && nt) {
    it = 0, ut = 0;
    var ft = [];
    if (at && ot ? ft.push([0, et], [lt, 0]) : at ? ft.push([lt, 0]) : ot ? ft.push([0, et]) : rt && st ? ft.push([0, et], [lt, 0]) : rt ? ft.push([lt, 0]) : st && ft.push([0, et]), ft.length) {
      ft.sort(function(pt, mt) {
        return getDistSize(minus([tt, nt], pt)) - getDistSize(minus([tt, nt], mt));
      });
      var ht = ft[0];
      if (ht[0] && Math.abs(tt) > TINY_NUM$1)
        it = -ht[0], ut = nt * Math.abs(tt + it) / Math.abs(tt) - nt;
      else if (ht[1] && Math.abs(nt) > TINY_NUM$1) {
        var dt = nt;
        ut = -ht[1], it = tt * Math.abs(nt + ut) / Math.abs(dt) - tt;
      }
      if (a && ot && at)
        if (Math.abs(it) > TINY_NUM$1 && Math.abs(it) < Math.abs(lt)) {
          var gt = Math.abs(lt) / Math.abs(it);
          it *= gt, ut *= gt;
        } else if (Math.abs(ut) > TINY_NUM$1 && Math.abs(ut) < Math.abs(et)) {
          var gt = Math.abs(et) / Math.abs(ut);
          it *= gt, ut *= gt;
        } else
          it = maxOffset(-lt, it), ut = maxOffset(-et, ut);
    }
  } else
    it = tt || at ? -lt : 0, ut = nt || ot ? -et : 0;
  return [it, ut];
}
function checkSnapBoundsDrag(a, s, $, _, _e, tt) {
  if (!hasGuidelines(a, "draggable"))
    return [{
      isSnap: !1,
      isBound: !1,
      offset: 0
    }, {
      isSnap: !1,
      isBound: !1,
      offset: 0
    }];
  var nt = getAbsolutePoses(tt.absolutePoses, [s, $]), at = getRect(nt), ot = at.left, rt = at.right, st = at.top, lt = at.bottom, et = {
    horizontal: nt.map(function(Pt) {
      return Pt[1];
    }),
    vertical: nt.map(function(Pt) {
      return Pt[0];
    })
  }, it = getSnapDirections(a.props.snapDirections), ut = splitSnapDirectionPoses(it, {
    left: ot,
    right: rt,
    top: st,
    bottom: lt,
    center: (ot + rt) / 2,
    middle: (st + lt) / 2
  }), ft = checkMoveableSnapBounds(a, _e, ut, et), ht = ft.vertical, dt = ft.horizontal, gt = getInnerBoundDragInfo(a, nt, tt), pt = gt.vertical, mt = gt.horizontal, ct = ht.isSnap, vt = dt.isSnap, At = ht.isBound || pt.isBound, xt = dt.isBound || mt.isBound, bt = maxOffset(ht.offset, pt.offset), Et = maxOffset(dt.offset, mt.offset), St = checkThrottleDragRotate(_, [s, $], [At, xt], [ct, vt], [bt, Et]), Bt = St[0], Ot = St[1];
  return [{
    isBound: At,
    isSnap: ct,
    offset: Bt
  }, {
    isBound: xt,
    isSnap: vt,
    offset: Ot
  }];
}
function checkMoveableSnapBounds(a, s, $, _) {
  _ === void 0 && (_ = $);
  var _e = checkBoundPoses(getBounds(a), _.vertical, _.horizontal), tt = _e.horizontal, nt = _e.vertical, at = s ? {
    horizontal: {
      isSnap: !1,
      index: -1
    },
    vertical: {
      isSnap: !1,
      index: -1
    }
  } : checkMoveableSnapPoses(a, $.vertical, $.horizontal), ot = at.horizontal, rt = at.vertical, st = getSnapBound(tt[0], ot), lt = getSnapBound(nt[0], rt), et = Math.abs(st), it = Math.abs(lt);
  return {
    horizontal: {
      isBound: tt[0].isBound,
      isSnap: ot.isSnap,
      snapIndex: ot.index,
      offset: st,
      dist: et,
      bounds: tt,
      snap: ot
    },
    vertical: {
      isBound: nt[0].isBound,
      isSnap: rt.isSnap,
      snapIndex: rt.index,
      offset: lt,
      dist: it,
      bounds: nt,
      snap: rt
    }
  };
}
function checkSnapBounds(a, s, $, _, _e) {
  var tt = checkBoundPoses(s, $, _), nt = tt.horizontal, at = tt.vertical, ot = checkSnapPoses(a, $, _, _e), rt = ot.horizontal, st = ot.vertical, lt = getSnapBound(nt[0], rt), et = getSnapBound(at[0], st), it = Math.abs(lt), ut = Math.abs(et);
  return {
    horizontal: {
      isBound: nt[0].isBound,
      isSnap: rt.isSnap,
      snapIndex: rt.index,
      offset: lt,
      dist: it,
      bounds: nt,
      snap: rt
    },
    vertical: {
      isBound: at[0].isBound,
      isSnap: st.isSnap,
      snapIndex: st.index,
      offset: et,
      dist: ut,
      bounds: at,
      snap: st
    }
  };
}
function checkSnapRightLine(a, s, $, _) {
  var _e = getRad$1(a, s) / Math.PI * 180, tt = $.vertical, nt = tt.isBound, at = tt.isSnap, ot = tt.dist, rt = $.horizontal, st = rt.isBound, lt = rt.isSnap, et = rt.dist, it = _e % 180, ut = it < 3 || it > 177, ft = it > 87 && it < 93;
  return et < ot && (nt || at && !ft && (!_ || !ut)) ? "vertical" : st || lt && !ut && (!_ || !ft) ? "horizontal" : "";
}
function getSnapBoundInfo(a, s, $, _, _e, tt) {
  return $.map(function(nt) {
    var at = nt[0], ot = nt[1], rt = getPosByDirection(s, at), st = getPosByDirection(s, ot), lt = _ ? checkSnapBoundsKeepRatio(a, rt, st, _e) : checkMoveableSnapBounds(a, _e, {
      vertical: [st[0]],
      horizontal: [st[1]]
    }), et = lt.horizontal, it = et.offset, ut = et.isBound, ft = et.isSnap, ht = lt.vertical, dt = ht.offset, gt = ht.isBound, pt = ht.isSnap, mt = minus(ot, at);
    if (!dt && !it)
      return {
        isBound: gt || ut,
        isSnap: pt || ft,
        sign: mt,
        offset: [0, 0]
      };
    var ct = checkSnapRightLine(rt, st, lt, _);
    if (!ct)
      return {
        sign: mt,
        isBound: !1,
        isSnap: !1,
        offset: [0, 0]
      };
    var vt = ct === "vertical", At = solveNextOffset(rt, st, -(vt ? dt : it), vt, tt).offset.map(function(xt, bt) {
      return xt * (mt[bt] ? 2 / mt[bt] : 0);
    });
    return {
      sign: mt,
      isBound: vt ? gt : ut,
      isSnap: vt ? pt : ft,
      offset: At
    };
  });
}
function getSnapBoundOffset(a, s) {
  return a.isBound ? a.offset : s.isSnap ? s.offset : 0;
}
function checkSnapBoundsKeepRatio(a, s, $, _) {
  var _e = checkBoundKeepRatio(a, s, $), tt = _e.horizontal, nt = _e.vertical, at = _ ? {
    horizontal: {
      isSnap: !1
    },
    vertical: {
      isSnap: !1
    }
  } : checkSnapKeepRatio(a, s, $), ot = at.horizontal, rt = at.vertical, st = getSnapBoundOffset(tt, ot), lt = getSnapBoundOffset(nt, rt), et = Math.abs(st), it = Math.abs(lt);
  return {
    horizontal: {
      isBound: tt.isBound,
      isSnap: ot.isSnap,
      offset: st,
      dist: et
    },
    vertical: {
      isBound: nt.isBound,
      isSnap: rt.isSnap,
      offset: lt,
      dist: it
    }
  };
}
function checkMaxBounds(a, s, $, _, _e) {
  var tt = [-$[0], -$[1]], nt = a.state, at = nt.width, ot = nt.height, rt = a.props.bounds, st = 1 / 0, lt = 1 / 0;
  if (rt) {
    var et = [[$[0], -$[1]], [-$[0], $[1]]], it = rt.left, ut = it === void 0 ? -1 / 0 : it, ft = rt.top, ht = ft === void 0 ? -1 / 0 : ft, dt = rt.right, gt = dt === void 0 ? 1 / 0 : dt, pt = rt.bottom, mt = pt === void 0 ? 1 / 0 : pt;
    et.forEach(function(ct) {
      var vt = ct[0] !== tt[0], At = ct[1] !== tt[1], xt = getPosByDirection(s, ct), bt = getRad$1(_, xt) * 360 / Math.PI;
      if (At) {
        var Et = xt.slice();
        (Math.abs(bt - 360) < 2 || Math.abs(bt - 180) < 2) && (Et[1] = _[1]);
        var St = solveNextOffset(_, Et, (_[1] < xt[1] ? mt : ht) - xt[1], !1, _e), Bt = St.offset, Ot = Bt[1], Pt = St.isOutside;
        isNaN(Ot) || (lt = ot + (Pt ? 1 : -1) * Math.abs(Ot));
      }
      if (vt) {
        var Et = xt.slice();
        (Math.abs(bt - 90) < 2 || Math.abs(bt - 270) < 2) && (Et[0] = _[0]);
        var wt = solveNextOffset(_, Et, (_[0] < xt[0] ? gt : ut) - xt[0], !0, _e), Ct = wt.offset[0], It = wt.isOutside;
        isNaN(Ct) || (st = at + (It ? 1 : -1) * Math.abs(Ct));
      }
    });
  }
  return {
    maxWidth: st,
    maxHeight: lt
  };
}
function snapStart(a) {
  var s = a.state;
  if (!(s.guidelines && s.guidelines.length)) {
    var $ = a.state.container, _ = a.props.snapContainer || $, _e = s.containerClientRect, tt = {
      left: 0,
      top: 0,
      bottom: 0,
      right: 0
    };
    if ($ !== _) {
      var nt = getRefTarget(_, !0);
      if (nt) {
        var at = getClientRect(nt), ot = getDragDistByState(s, [at.left - _e.left, at.top - _e.top]), rt = getDragDistByState(s, [at.right - _e.right, at.bottom - _e.bottom]);
        tt.left = throttle(ot[0], 0.1), tt.top = throttle(ot[1], 0.1), tt.right = throttle(rt[0], 0.1), tt.bottom = throttle(rt[1], 0.1);
      }
    }
    s.snapOffset = tt, s.guidelines = getTotalGuidelines(a), s.enableSnap = !0;
  }
}
function getNextFixedPoses(a, s, $, _, _e, tt) {
  var nt = calculatePoses(a, s, $, tt ? 4 : 3), at = getPosByReverseDirection(nt, _e);
  return getAbsolutePoses(nt, minus(_, at));
}
function getSizeOffsetInfo(a, s, $, _, _e, tt) {
  var nt = getCheckSnapDirections($, _), at = getCheckInnerBoundLines(s, $, _), ot = __spreadArrays(getSnapBoundInfo(a, s, nt, _, _e, tt), getInnerBoundInfo(a, at, getPosByDirection(s, [0, 0]), tt)), rt = getNearOffsetInfo(ot, 0), st = getNearOffsetInfo(ot, 1);
  return {
    width: {
      isBound: rt.isBound,
      offset: rt.offset[0]
    },
    height: {
      isBound: st.isBound,
      offset: st.offset[1]
    }
  };
}
function recheckSizeByTwoDirection(a, s, $, _, _e, tt, nt, at, ot) {
  var rt = getPosByDirection(s, nt), st = checkMoveableSnapBounds(a, at, {
    vertical: [rt[0]],
    horizontal: [rt[1]]
  }), lt = st.horizontal.offset, et = st.vertical.offset;
  if (et || lt) {
    var it = getDragDist({
      datas: ot,
      distX: -et,
      distY: -lt
    }), ut = it[0], ft = it[1], ht = Math.min(_e || 1 / 0, $ + nt[0] * ut), dt = Math.min(tt || 1 / 0, _ + nt[1] * ft);
    return [ht - $, dt - _];
  }
  return [0, 0];
}
function checkSizeDist(a, s, $, _, _e, tt, nt, at) {
  for (var ot = getAbsolutePosesByState(a.state), rt = a.props.keepRatio, st = 0, lt = 0, et = 0; et < 2; ++et) {
    var it = s(st, lt), ut = getSizeOffsetInfo(a, it, _e, rt, nt, at), ft = ut.width, ht = ut.height, dt = ft.isBound, gt = ht.isBound, pt = ft.offset, mt = ht.offset;
    if (et === 1 && (dt || (pt = 0), gt || (mt = 0)), et === 0 && nt && !dt && !gt)
      return [0, 0];
    if (rt) {
      var ct = Math.abs(pt) * ($ ? 1 / $ : 1), vt = Math.abs(mt) * (_ ? 1 / _ : 1), At = dt && gt ? ct < vt : gt || !dt && ct < vt;
      At ? pt = $ * mt / _ : mt = _ * pt / $;
    }
    st += pt, lt += mt;
  }
  if (_e[0] && _e[1]) {
    var xt = checkMaxBounds(a, ot, _e, tt, at), bt = xt.maxWidth, Et = xt.maxHeight, St = recheckSizeByTwoDirection(a, s(st, lt).map(function(Pt) {
      return Pt.map(function(wt) {
        return throttle(wt, FLOAT_POINT_NUM);
      });
    }), $ + st, _ + lt, bt, Et, _e, nt, at), pt = St[0], mt = St[1];
    st += pt, lt += mt;
  }
  return [st, lt];
}
function checkSnapRotate(a, s, $, _) {
  if (!hasGuidelines(a, "rotatable"))
    return _;
  var _e = s.pos1, tt = s.pos2, nt = s.pos3, at = s.pos4, ot = _ * Math.PI / 180, rt = [_e, tt, nt, at].map(function(et) {
    return minus(et, $);
  }), st = rt.map(function(et) {
    return rotate(et, ot);
  }), lt = __spreadArrays(checkRotateBounds(a, rt, st, $, _), checkRotateInnerBounds(a, rt, st, $, _));
  return lt.sort(function(et, it) {
    return Math.abs(et - _) - Math.abs(it - _);
  }), lt.length ? lt[0] : _;
}
function checkSnapResize(a, s, $, _, _e, tt, nt) {
  if (!hasGuidelines(a, "resizable"))
    return [0, 0];
  var at = a.state, ot = at.allMatrix, rt = at.is3d;
  return checkSizeDist(a, function(st, lt) {
    return getNextFixedPoses(ot, s + st, $ + lt, _e, _, rt);
  }, s, $, _, _e, tt, nt);
}
function checkSnapScale(a, s, $, _, _e) {
  var tt = _e.width, nt = _e.height, at = _e.fixedPosition;
  if (!hasGuidelines(a, "scalable"))
    return [0, 0];
  var ot = _e.is3d, rt = checkSizeDist(a, function(st, lt) {
    return getNextFixedPoses(scaleMatrix(_e, plus(s, [st / tt, lt / nt])), tt, nt, at, $, ot);
  }, tt, nt, $, at, _, _e);
  return [rt[0] / tt, rt[1] / nt];
}
function startCheckSnapDrag(a, s) {
  s.absolutePoses = getAbsolutePosesByState(a.state);
}
function getSnapGuidelines(a) {
  var s = [];
  return a.forEach(function($) {
    $.guidelineInfos.forEach(function(_) {
      var _e = _.guideline;
      s.indexOf(_e) > -1 || s.push(_e);
    });
  }), s;
}
function addBoundGuidelines(a, s, $, _, _e, tt) {
  var nt = checkBoundPoses(getBounds(a, tt), s, $), at = nt.vertical, ot = nt.horizontal;
  at.forEach(function(et) {
    et.isBound && _.push({
      type: "bounds",
      pos: et.pos
    });
  }), ot.forEach(function(et) {
    et.isBound && _e.push({
      type: "bounds",
      pos: et.pos
    });
  });
  var rt = checkInnerBoundPoses(a), st = rt.vertical, lt = rt.horizontal;
  st.forEach(function(et) {
    findIndex(_, function(it) {
      var ut = it.type, ft = it.pos;
      return ut === "bounds" && ft === et;
    }) >= 0 || _.push({
      type: "bounds",
      pos: et
    });
  }), lt.forEach(function(et) {
    findIndex(_e, function(it) {
      var ut = it.type, ft = it.pos;
      return ut === "bounds" && ft === et;
    }) >= 0 || _e.push({
      type: "bounds",
      pos: et
    });
  });
}
var Snappable = {
  name: "snappable",
  props: {
    snappable: [Boolean, Array],
    snapContainer: Object,
    snapDirections: [Boolean, Object],
    elementSnapDirections: [Boolean, Object],
    snapGap: Boolean,
    snapGridWidth: Number,
    snapGridHeight: Number,
    isDisplaySnapDigit: Boolean,
    isDisplayInnerSnapDigit: Boolean,
    snapDigit: Number,
    snapThreshold: Number,
    horizontalGuidelines: Array,
    verticalGuidelines: Array,
    elementGuidelines: Array,
    bounds: Object,
    innerBounds: Object,
    snapDistFormat: Function
  },
  events: {
    onSnap: "snap"
  },
  css: [`:host {
    --bounds-color: #d66;
}
.guideline {
    pointer-events: none;
    z-index: 2;
}
.guideline.bounds {
    background: #d66;
    background: var(--bounds-color);
}
.guideline-group {
    position: absolute;
    top: 0;
    left: 0;
}
.guideline-group .size-value {
    position: absolute;
    color: #f55;
    font-size: 12px;
    font-weight: bold;
}
.guideline-group.horizontal .size-value {
    transform-origin: 50% 100%;
    transform: translateX(-50%);
    left: 50%;
    bottom: 5px;
}
.guideline-group.vertical .size-value {
    transform-origin: 0% 50%;
    top: 50%;
    transform: translateY(-50%);
    left: 5px;
}
.guideline.gap {
    background: #f55;
}
.size-value.gap {
    color: #f55;
}
`],
  render: function(a, s) {
    var $ = a.state, _ = $.top, _e = $.left, tt = $.pos1, nt = $.pos2, at = $.pos3, ot = $.pos4, rt = $.snapRenderInfo;
    if (!rt || !hasGuidelines(a, ""))
      return [];
    $.guidelines = getTotalGuidelines(a);
    var st = Math.min(tt[0], nt[0], at[0], ot[0]), lt = Math.min(tt[1], nt[1], at[1], ot[1]), et = rt.externalPoses || [], it = getAbsolutePosesByState(a.state), ut = [], ft = [], ht = [], dt = [], gt = [], pt = getRect(it), mt = pt.width, ct = pt.height, vt = pt.top, At = pt.left, xt = pt.bottom, bt = pt.right, Et = {
      left: At,
      right: bt,
      top: vt,
      bottom: xt,
      center: (At + bt) / 2,
      middle: (vt + xt) / 2
    }, St = et.length > 0, Bt = St ? getRect(et) : {};
    if (!rt.request) {
      if (rt.direction && gt.push(getSnapInfosByDirection(a, it, rt.direction)), rt.snap) {
        var Ot = getRect(it);
        rt.center && (Ot.middle = (Ot.top + Ot.bottom) / 2, Ot.center = (Ot.left + Ot.right) / 2), gt.push(checkSnaps(a, Ot, 1));
      }
      St && (rt.center && (Bt.middle = (Bt.top + Bt.bottom) / 2, Bt.center = (Bt.left + Bt.right) / 2), gt.push(checkSnaps(a, Bt, 1))), gt.forEach(function(It) {
        var yt = It.vertical.posInfos, Rt = It.horizontal.posInfos;
        ut.push.apply(ut, yt.filter(function(kt) {
          var jt = kt.guidelineInfos;
          return jt.some(function(Ht) {
            var Ft = Ht.guideline;
            return !Ft.hide;
          });
        }).map(function(kt) {
          return {
            type: "snap",
            pos: kt.pos
          };
        })), ft.push.apply(ft, Rt.filter(function(kt) {
          var jt = kt.guidelineInfos;
          return jt.some(function(Ht) {
            var Ft = Ht.guideline;
            return !Ft.hide;
          });
        }).map(function(kt) {
          return {
            type: "snap",
            pos: kt.pos
          };
        })), ht.push.apply(ht, getSnapGuidelines(yt)), dt.push.apply(dt, getSnapGuidelines(Rt));
      });
    }
    addBoundGuidelines(a, [At, bt], [vt, xt], ut, ft), St && addBoundGuidelines(a, [Bt.left, Bt.right], [Bt.top, Bt.bottom], ut, ft, rt.externalBounds);
    var Pt = __spreadArrays(ht, dt), wt = Pt.filter(function(It) {
      return It.element && !It.gapRects;
    }), Ct = Pt.filter(function(It) {
      return It.gapRects;
    });
    return triggerEvent(a, "onSnap", {
      guidelines: Pt.filter(function(It) {
        var yt = It.element;
        return !yt;
      }),
      elements: wt,
      gaps: Ct
    }, !0), __spreadArrays(renderDashedGuidelines(a, wt, [st, lt], Et, s), renderGapGuidelines(a, Ct, [st, lt], Et, s), renderGuidelines(a, "horizontal", dt, [_e, _], Et, s), renderGuidelines(a, "vertical", ht, [_e, _], Et, s), renderSnapPoses(a, "horizontal", ft, st, _, mt, 0, s), renderSnapPoses(a, "vertical", ut, lt, _e, ct, 1, s));
  },
  dragStart: function(a, s) {
    a.state.snapRenderInfo = {
      request: s.isRequest,
      snap: !0,
      center: !0
    }, snapStart(a);
  },
  drag: function(a) {
    var s = a.state;
    s.guidelines = getTotalGuidelines(a);
  },
  pinchStart: function(a) {
    this.unset(a);
  },
  dragEnd: function(a) {
    this.unset(a);
  },
  dragControlCondition: function(a, s) {
    if (directionCondition(a, s) || dragControlCondition(a, s))
      return !0;
    if (!s.isRequest && s.inputEvent)
      return hasClass(s.inputEvent.target, prefix$1("snap-control"));
  },
  dragControlStart: function(a) {
    a.state.snapRenderInfo = null, snapStart(a);
  },
  dragControl: function(a) {
    this.drag(a);
  },
  dragControlEnd: function(a) {
    this.unset(a);
  },
  dragGroupStart: function(a, s) {
    this.dragStart(a, s);
  },
  dragGroup: function(a) {
    this.drag(a);
  },
  dragGroupEnd: function(a) {
    this.unset(a);
  },
  dragGroupControlStart: function(a) {
    a.state.snapRenderInfo = null, snapStart(a);
  },
  dragGroupControl: function(a) {
    this.drag(a);
  },
  dragGroupControlEnd: function(a) {
    this.unset(a);
  },
  unset: function(a) {
    var s = a.state;
    s.enableSnap = !1, s.guidelines = [], s.snapRenderInfo = null, s.elementRects = [];
  }
}, Draggable = {
  name: "draggable",
  props: {
    draggable: Boolean,
    throttleDrag: Number,
    throttleDragRotate: Number,
    startDragRotate: Number,
    edgeDraggable: Boolean
  },
  events: {
    onDragStart: "dragStart",
    onDrag: "drag",
    onDragEnd: "dragEnd",
    onDragGroupStart: "dragGroupStart",
    onDragGroup: "dragGroup",
    onDragGroupEnd: "dragGroupEnd"
  },
  render: function(a, s) {
    var $ = a.props, _ = $.throttleDragRotate, _e = $.zoom, tt = a.state, nt = tt.dragInfo, at = tt.beforeOrigin;
    if (!_ || !nt)
      return [];
    var ot = nt.dist;
    if (!ot[0] && !ot[1])
      return [];
    var rt = getDistSize(ot), st = getRad$1(ot, [0, 0]);
    return [s.createElement("div", {
      className: prefix$1("line", "horizontal", "dragline", "dashed"),
      key: "dragRotateGuideline",
      style: {
        width: rt + "px",
        transform: "translate(" + at[0] + "px, " + at[1] + "px) rotate(" + st + "rad) scaleY(" + _e + ")"
      }
    })];
  },
  dragStart: function(a, s) {
    var $ = s.datas, _ = s.parentEvent, _e = s.parentGesto, tt = a.state, nt = tt.target, at = tt.gesto;
    if (at)
      return !1;
    tt.gesto = _e || a.targetGesto;
    var ot = getComputedStyle$1(nt);
    $.datas = {}, $.left = parseFloat(ot.left || "") || 0, $.top = parseFloat(ot.top || "") || 0, $.bottom = parseFloat(ot.bottom || "") || 0, $.right = parseFloat(ot.right || "") || 0, $.startValue = [0, 0], setDragStart(a, s), setDefaultTransformIndex(s, "translate"), startCheckSnapDrag(a, $), $.prevDist = [0, 0], $.prevBeforeDist = [0, 0], $.isDrag = !1, $.deltaOffset = [0, 0], $.distOffset = [0, 0];
    var rt = fillParams(a, s, __assign$1({
      set: function(lt) {
        $.startValue = lt;
      }
    }, fillTransformStartEvent(s))), st = _ || triggerEvent(a, "onDragStart", rt);
    return st !== !1 ? ($.isDrag = !0, a.state.dragInfo = {
      startRect: a.getRect(),
      dist: [0, 0]
    }) : (tt.gesto = null, $.isPinch = !1), $.isDrag ? rt : !1;
  },
  drag: function(a, s) {
    if (s) {
      resolveTransformEvent(s, "translate");
      var $ = s.datas, _ = s.parentEvent, _e = s.parentFlag, tt = s.isPinch, nt = s.isRequest, at = s.distX, ot = s.distY, rt = $.isDrag, st = $.prevDist, lt = $.prevBeforeDist, et = $.startValue, it = $.distOffset;
      if (rt) {
        at += it[0], ot += it[1];
        var ut = a.props, ft = ut.parentMoveable, ht = _ ? 0 : ut.throttleDrag || 0, dt = _ ? 0 : ut.throttleDragRotate || 0, gt = !1, pt = 0;
        if (!_ && dt > 0 && (at || ot)) {
          var mt = ut.startDragRotate || 0, ct = throttle(mt + getRad$1([0, 0], [at, ot]) * 180 / Math.PI, dt) - mt, vt = ot * Math.abs(Math.cos((ct - 90) / 180 * Math.PI)), At = at * Math.abs(Math.cos(ct / 180 * Math.PI)), xt = getDistSize([At, vt]);
          pt = ct * Math.PI / 180, at = xt * Math.cos(pt), ot = xt * Math.sin(pt);
        }
        if (!tt && !_ && !_e && (!dt || at || ot)) {
          var bt = checkSnapBoundsDrag(a, at, ot, dt, nt, $), Et = bt[0], St = bt[1], Bt = Et.isSnap, Ot = Et.isBound, Pt = Et.offset, wt = St.isSnap, Ct = St.isBound, It = St.offset;
          gt = Bt || wt || Ot || Ct, at += Pt, ot += It;
        }
        var yt = plus(getBeforeDragDist({
          datas: $,
          distX: at,
          distY: ot
        }), et), Rt = plus(getTransformDist({
          datas: $,
          distX: at,
          distY: ot
        }), et);
        !dt && !gt && (throttleArray(Rt, ht), throttleArray(yt, ht));
        var kt = minus(yt, et), jt = minus(Rt, et), Ht = minus(jt, st), Ft = minus(kt, lt);
        $.prevDist = jt, $.prevBeforeDist = kt, $.passDelta = Ht, $.passDist = jt;
        var _t = $.left + kt[0], Nt = $.top + kt[1], Mt = $.right - kt[0], Lt = $.bottom - kt[1], $t = convertTransformFormat($, "translate(" + Rt[0] + "px, " + Rt[1] + "px)", "translate(" + jt[0] + "px, " + jt[1] + "px)");
        if (a.state.dragInfo.dist = _ ? [0, 0] : jt, !(!_ && !ft && Ht.every(function(Qt) {
          return !Qt;
        }) && Ft.some(function(Qt) {
          return !Qt;
        }))) {
          var Tt = a.state, Dt = Tt.width, Ut = Tt.height, Vt = fillParams(a, s, {
            transform: $t,
            dist: jt,
            delta: Ht,
            translate: Rt,
            beforeDist: kt,
            beforeDelta: Ft,
            beforeTranslate: yt,
            left: _t,
            top: Nt,
            right: Mt,
            bottom: Lt,
            width: Dt,
            height: Ut,
            isPinch: tt
          });
          return !_ && triggerEvent(a, "onDrag", Vt), Vt;
        }
      }
    }
  },
  dragAfter: function(a, s) {
    var $ = s.datas, _ = s.datas, _e = _.deltaOffset, tt = _.distOffset;
    return _e[0] || _e[1] ? ($.deltaOffset = [0, 0], tt[0] += _e[0], tt[1] += _e[1], this.drag(a, s)) : !1;
  },
  dragEnd: function(a, s) {
    var $ = s.parentEvent, _ = s.datas, _e = s.isDrag;
    if (a.state.gesto = null, a.state.dragInfo = null, !!_.isDrag)
      return _.isDrag = !1, !$ && triggerEvent(a, "onDragEnd", fillEndParams(a, s, {})), _e;
  },
  dragGroupStart: function(a, s) {
    var $ = s.datas, _ = s.clientX, _e = s.clientY, tt = this.dragStart(a, s);
    if (!tt)
      return !1;
    var nt = triggerChildGesto(a, this, "dragStart", [_ || 0, _e || 0], s, !1), at = __assign$1(__assign$1({}, tt), {
      targets: a.props.targets,
      events: nt
    }), ot = triggerEvent(a, "onDragGroupStart", at);
    return $.isDrag = ot !== !1, $.isDrag ? tt : !1;
  },
  dragGroup: function(a, s) {
    var $ = s.datas;
    if ($.isDrag) {
      var _ = this.drag(a, s), _e = s.datas.passDelta, tt = triggerChildGesto(a, this, "drag", _e, s, !1);
      if (_) {
        var nt = __assign$1({
          targets: a.props.targets,
          events: tt
        }, _);
        return triggerEvent(a, "onDragGroup", nt), nt;
      }
    }
  },
  dragGroupEnd: function(a, s) {
    var $ = s.isDrag, _ = s.datas;
    if (_.isDrag)
      return this.dragEnd(a, s), triggerChildGesto(a, this, "dragEnd", [0, 0], s, !1), triggerEvent(a, "onDragGroupEnd", fillEndParams(a, s, {
        targets: a.props.targets
      })), $;
  },
  /**
   * @method Moveable.Draggable#request
   * @param {object} [e] - the draggable's request parameter
   * @param {number} [e.x] - x position
   * @param {number} [e.y] - y position
   * @param {number} [e.deltaX] - X number to move
   * @param {number} [e.deltaY] - Y number to move
   * @return {Moveable.Requester} Moveable Requester
   * @example
    * // Instantly Request (requestStart - request - requestEnd)
   * // Use Relative Value
   * moveable.request("draggable", { deltaX: 10, deltaY: 10 }, true);
   * // Use Absolute Value
   * moveable.request("draggable", { x: 200, y: 100 }, true);
   *
   * // requestStart
   * const requester = moveable.request("draggable");
   *
   * // request
   * // Use Relative Value
   * requester.request({ deltaX: 10, deltaY: 10 });
   * requester.request({ deltaX: 10, deltaY: 10 });
   * requester.request({ deltaX: 10, deltaY: 10 });
   * // Use Absolute Value
   * moveable.request("draggable", { x: 200, y: 100 });
   * moveable.request("draggable", { x: 220, y: 100 });
   * moveable.request("draggable", { x: 240, y: 100 });
   *
   * // requestEnd
   * requester.requestEnd();
   */
  request: function(a) {
    var s = {}, $ = a.getRect(), _ = 0, _e = 0;
    return {
      isControl: !1,
      requestStart: function() {
        return {
          datas: s
        };
      },
      request: function(tt) {
        return "x" in tt ? _ = tt.x - $.left : "deltaX" in tt && (_ += tt.deltaX), "y" in tt ? _e = tt.y - $.top : "deltaY" in tt && (_e += tt.deltaY), {
          datas: s,
          distX: _,
          distY: _e
        };
      },
      requestEnd: function() {
        return {
          datas: s,
          isDrag: !0
        };
      }
    };
  },
  unset: function(a) {
    a.state.dragInfo = null;
  }
};
function renderDirectionControls(a, s, $, _) {
  _ === void 0 && (_ = "");
  var _e = a.state, tt = _e.renderPoses, nt = _e.rotation, at = _e.direction, ot = a.props, rt = ot.renderDirections, st = rt === void 0 ? s : rt, lt = ot.zoom, et = {};
  if (!st)
    return [];
  var it = at > 0 ? 1 : -1, ut = st === !0 ? DIRECTIONS : st, ft = nt / Math.PI * 180;
  return ut.forEach(function(ht) {
    et[ht] = !0;
  }), ut.map(function(ht) {
    var dt = DIRECTION_INDEXES[ht];
    if (!dt || !et[ht])
      return null;
    var gt = (throttle(ft, 15) + it * DIRECTION_ROTATIONS[ht] + 720) % 180;
    return $.createElement("div", {
      className: prefix$1("control", "direction", ht, _),
      "data-rotation": gt,
      "data-direction": ht,
      key: "direction-" + ht,
      style: getControlTransform.apply(void 0, __spreadArrays([nt, lt], dt.map(function(pt) {
        return tt[pt];
      })))
    });
  });
}
function renderLine(a, s, $, _, _e, tt) {
  for (var nt = [], at = 6; at < arguments.length; at++)
    nt[at - 6] = arguments[at];
  var ot = getRad$1($, _), rt = s ? throttle(ot / Math.PI * 180, 15) % 180 : -1;
  return a.createElement("div", {
    key: "line" + tt,
    className: prefix$1.apply(void 0, __spreadArrays(["line", "direction", s], nt)),
    "data-rotation": rt,
    "data-line-index": tt,
    "data-direction": s,
    style: getLineStyle($, _, _e, ot)
  });
}
function renderAllDirections(a, s) {
  return renderDirectionControls(a, DIRECTIONS, s);
}
function renderDiagonalDirections(a, s) {
  return renderDirectionControls(a, ["nw", "ne", "sw", "se"], s);
}
function setRotateStartInfo(a, s, $, _, _e, tt) {
  var nt = a.state.is3d ? 4 : 3, at = calculatePosition(a.state.rootMatrix, _e, nt), ot = plus([tt.left, tt.top], at);
  s.startAbsoluteOrigin = ot, s.prevDeg = getRad$1(ot, [$, _]) / Math.PI * 180, s.prevSnapDeg = s.prevDeg, s.startDeg = s.prevDeg, s.loop = 0;
}
function getParentDeg(a, s, $, _, _e, tt) {
  var nt = $.prevDeg, at = checkSnapRotate(a, s, $.origin, _);
  $.prevDeg = at;
  var ot = at - nt;
  return [ot, at, tt + at];
}
function getDeg(a, s, $, _, _e, tt, nt, at) {
  var ot = $.prevDeg, rt = $.prevSnapDeg, st = $.startDeg, lt = $.loop;
  ot > _ && ot > 270 && _ < 90 ? ++$.loop : ot < _ && ot < 90 && _ > 270 && --$.loop;
  var et = $.loop, it = lt * 360 + rt - st + tt, ut = et * 360 + _ - st + tt;
  $.prevDeg = ut - et * 360 + st - tt, ut = throttle(ut, nt);
  var ft = _e * (ut - tt);
  at && (ft = checkSnapRotate(a, s, $.origin, ft), ut = ft / _e + tt), $.prevSnapDeg = ut - et * 360 + st - tt;
  var ht = _e * (ut - it);
  return [ht, ft, tt + ft];
}
function getRotateInfo(a, s, $, _, _e, tt, nt, at) {
  return getDeg(a, s, $, getRad$1($.startAbsoluteOrigin, [_e, tt]) / Math.PI * 180, _, nt, at, !0);
}
function getRotationPositions(a, s, $) {
  var _ = s[0], _e = s[1], tt = s[2], nt = s[3];
  if (a !== "none") {
    var at = (a || "top").split("-"), ot = at[0], rt = at[1], st = [_, _e];
    ot === "left" ? st = [tt, _] : ot === "right" ? st = [_e, nt] : ot === "bottom" && (st = [nt, tt]);
    var lt = [(st[0][0] + st[1][0]) / 2, (st[0][1] + st[1][1]) / 2], et = getRotationRad(st, $);
    if (rt) {
      var it = rt === "top" || rt === "left", ut = ot === "bottom" || ot === "left";
      lt = st[it && !ut || !it && ut ? 0 : 1];
    }
    return [lt, et];
  }
}
function dragControlCondition(a, s) {
  if (s.isRequest)
    return s.requestAble === "rotatable";
  var $ = s.inputEvent.target;
  if (hasClass($, prefix$1("rotation-control")))
    return !0;
  var _ = a.props.rotationTarget;
  return _ ? getRefTargets(_, !0).some(function(_e) {
    return _e ? $ === _e || $.contains(_e) : !1;
  }) : !1;
}
var Rotatable = {
  name: "rotatable",
  canPinch: !0,
  props: {
    rotatable: Boolean,
    rotationPosition: String,
    throttleRotate: Number,
    renderDirections: Object,
    rotationTarget: Object
  },
  events: {
    onRotateStart: "rotateStart",
    onRotate: "rotate",
    onRotateEnd: "rotateEnd",
    onRotateGroupStart: "rotateGroupStart",
    onRotateGroup: "rotateGroup",
    onRotateGroupEnd: "rotateGroupEnd"
  },
  css: [`.rotation {
            position: absolute;
            height: 40px;
            width: 1px;
            transform-origin: 50% 100%;
            height: calc(40px * var(--zoom));
            top: auto;
            left: 0;
            bottom: 100%;
            will-change: transform;
        }
        .rotation .rotation-line {
            display: block;
            width: 100%;
            height: 100%;
            transform-origin: 50% 50%;
        }
        .rotation .rotation-control {
            border-color: #4af;
            border-color: var(--moveable-color);
            background:#fff;
            cursor: alias;
        }`],
  render: function(a, s) {
    var $ = a.props, _ = $.rotatable, _e = $.rotationPosition, tt = $.zoom, nt = $.renderDirections, at = a.state, ot = at.renderPoses, rt = at.direction;
    if (!_)
      return null;
    var st = getRotationPositions(_e, ot, rt), lt = [];
    if (st) {
      var et = st[0], it = st[1];
      lt.push(s.createElement("div", {
        key: "rotation",
        className: prefix$1("rotation"),
        style: {
          // tslint:disable-next-line: max-line-length
          transform: "translate(-50%) translate(" + et[0] + "px, " + et[1] + "px) rotate(" + it + "rad)"
        }
      }, s.createElement("div", {
        className: prefix$1("line rotation-line"),
        style: {
          transform: "scaleX(" + tt + ")"
        }
      }), s.createElement("div", {
        className: prefix$1("control rotation-control"),
        style: {
          transform: "translate(0.5px) scale(" + tt + ")"
        }
      })));
    }
    return nt && lt.push.apply(lt, renderDirectionControls(a, [], s)), lt;
  },
  dragControlCondition,
  dragControlStart: function(a, s) {
    var $ = s.datas, _ = s.clientX, _e = s.clientY, tt = s.parentRotate, nt = s.parentFlag, at = s.isPinch, ot = s.isRequest, rt = a.state, st = rt.target, lt = rt.left, et = rt.top, it = rt.origin, ut = rt.beforeOrigin, ft = rt.direction, ht = rt.beforeDirection, dt = rt.targetTransform, gt = rt.moveableClientRect;
    if (!ot && !st)
      return !1;
    var pt = a.getRect();
    if ($.rect = pt, $.transform = dt, $.left = lt, $.top = et, $.fixedPosition = getDirectionOffset(a, getOriginDirection(a)), $.absoluteInfo = {
      origin: pt.origin,
      startValue: pt.rotation
    }, setRotateStartInfo(a, $.absoluteInfo, _, _e, it, gt), ot || at || nt) {
      var mt = tt || 0;
      $.beforeInfo = {
        origin: pt.beforeOrigin,
        prevDeg: mt,
        startDeg: mt,
        prevSnapDeg: mt,
        loop: 0
      }, $.afterInfo = {
        origin: pt.origin,
        prevDeg: mt,
        startDeg: mt,
        prevSnapDeg: mt,
        loop: 0
      };
    } else
      $.beforeInfo = {
        origin: pt.beforeOrigin
      }, $.afterInfo = {
        origin: pt.origin
      }, setRotateStartInfo(a, $.beforeInfo, _, _e, ut, gt), setRotateStartInfo(a, $.afterInfo, _, _e, it, gt);
    $.direction = ft, $.beforeDirection = ht, $.startValue = 0, $.datas = {}, setDefaultTransformIndex(s, "rotate");
    var ct = fillParams(a, s, __assign$1(__assign$1({
      set: function(At) {
        $.startValue = At * Math.PI / 180;
      }
    }, fillTransformStartEvent(s)), {
      dragStart: Draggable.dragStart(a, new CustomGesto().dragStart([0, 0], s))
    })), vt = triggerEvent(a, "onRotateStart", ct);
    return $.isRotate = vt !== !1, a.state.snapRenderInfo = {
      request: s.isRequest
    }, $.isRotate ? ct : !1;
  },
  dragControl: function(a, s) {
    var $, _, _e, tt, nt, at, ot, rt, st, lt = s.datas, et = s.clientX, it = s.clientY, ut = s.parentRotate, ft = s.parentFlag, ht = s.isPinch, dt = s.groupDelta, gt = lt.beforeDirection, pt = lt.beforeInfo, mt = lt.afterInfo, ct = lt.absoluteInfo, vt = lt.isRotate, At = lt.startValue, xt = lt.rect;
    if (vt) {
      resolveTransformEvent(s, "rotate");
      var bt = getTransformDirection(s), Et = gt * bt, St = a.props, Bt = St.throttleRotate, Ot = Bt === void 0 ? 0 : Bt, Pt = St.parentMoveable, wt, Ct, It, yt, Rt, kt, jt, Ht, Ft, _t = 180 / Math.PI * At, Nt = ct.startValue;
      if (!ft && "parentDist" in s) {
        var Mt = s.parentDist;
        $ = getParentDeg(a, xt, mt, Mt, Et, _t), wt = $[0], Ct = $[1], It = $[2], _ = getParentDeg(a, xt, pt, Mt, gt, _t), yt = _[0], Rt = _[1], kt = _[2], _e = getParentDeg(a, xt, ct, Mt, Et, Nt), jt = _e[0], Ht = _e[1], Ft = _e[2];
      } else
        ht || ft ? (tt = getDeg(a, xt, mt, ut, Et, _t, Ot), wt = tt[0], Ct = tt[1], It = tt[2], nt = getDeg(a, xt, pt, ut, gt, _t, Ot), yt = nt[0], Rt = nt[1], kt = nt[2], at = getDeg(a, xt, ct, ut, Et, Nt, Ot), jt = at[0], Ht = at[1], Ft = at[2]) : (ot = getRotateInfo(a, xt, mt, Et, et, it, _t, Ot), wt = ot[0], Ct = ot[1], It = ot[2], rt = getRotateInfo(a, xt, pt, gt, et, it, _t, Ot), yt = rt[0], Rt = rt[1], kt = rt[2], st = getRotateInfo(a, xt, ct, Et, et, it, Nt, Ot), jt = st[0], Ht = st[1], Ft = st[2]);
      if (!(!jt && !wt && !yt && !Pt)) {
        var Lt = convertTransformFormat(lt, "rotate(" + It + "deg)", "rotate(" + Ct + "deg)"), $t = getRotateDist(a, Ct, lt.fixedPosition, lt), Tt = minus(plus(dt || [0, 0], $t), lt.prevInverseDist || [0, 0]);
        lt.prevInverseDist = $t;
        var Dt = fillParams(a, s, __assign$1({
          delta: wt,
          dist: Ct,
          rotate: It,
          beforeDist: Rt,
          beforeDelta: yt,
          beforeRotate: kt,
          absoluteDist: Ht,
          absoluteDelta: jt,
          absoluteRotate: Ft,
          isPinch: !!ht
        }, fillTransformEvent(a, Lt, Tt, ht, s)));
        return triggerEvent(a, "onRotate", Dt), Dt;
      }
    }
  },
  dragControlEnd: function(a, s) {
    var $ = s.datas, _ = s.isDrag;
    return $.isRotate ? ($.isRotate = !1, triggerEvent(a, "onRotateEnd", fillEndParams(a, s, {})), _) : !1;
  },
  dragGroupControlCondition: dragControlCondition,
  dragGroupControlStart: function(a, s) {
    var $ = s.datas, _ = a.state, _e = _.left, tt = _.top, nt = _.beforeOrigin, at = this.dragControlStart(a, s);
    if (!at)
      return !1;
    at.set($.beforeDirection * a.rotation);
    var ot = triggerChildAbles(a, this, "dragControlStart", s, function(lt, et) {
      var it = lt.state, ut = it.left, ft = it.top, ht = it.beforeOrigin, dt = plus(minus([ut, ft], [_e, tt]), minus(ht, nt));
      return et.datas.groupClient = dt, __assign$1(__assign$1({}, et), {
        parentRotate: 0
      });
    }), rt = __assign$1(__assign$1({}, at), {
      targets: a.props.targets,
      events: ot
    }), st = triggerEvent(a, "onRotateGroupStart", rt);
    return $.isRotate = st !== !1, $.isRotate ? at : !1;
  },
  dragGroupControl: function(a, s) {
    var $ = s.datas;
    if ($.isRotate) {
      var _ = this.dragControl(a, s);
      if (_) {
        var _e = $.beforeDirection, tt = _.beforeDist, nt = _.beforeDelta, at = nt / 180 * Math.PI, ot = triggerChildAbles(a, this, "dragControl", s, function(st, lt) {
          var et = lt.datas.groupClient, it = et[0], ut = et[1], ft = rotate([it, ut], at * _e), ht = ft[0], dt = ft[1], gt = [ht - it, dt - ut];
          return lt.datas.groupClient = [ht, dt], __assign$1(__assign$1({}, lt), {
            parentRotate: tt,
            groupDelta: gt
          });
        });
        a.rotation = _e * _.beforeRotate;
        var rt = __assign$1({
          targets: a.props.targets,
          events: ot,
          set: function(st) {
            a.rotation = st;
          }
        }, _);
        return triggerEvent(a, "onRotateGroup", rt), rt;
      }
    }
  },
  dragGroupControlEnd: function(a, s) {
    var $ = s.isDrag, _ = s.datas;
    if (_.isRotate) {
      this.dragControlEnd(a, s), triggerChildAbles(a, this, "dragControlEnd", s);
      var _e = fillEndParams(a, s, {
        targets: a.props.targets
      });
      return triggerEvent(a, "onRotateGroupEnd", _e), $;
    }
  },
  /**
   * @method Moveable.Rotatable#request
   * @param {object} [e] - the Resizable's request parameter
   * @param {number} [e.deltaRotate=0] -  delta number of rotation
   * @param {number} [e.rotate=0] - absolute number of moveable's rotation
   * @return {Moveable.Requester} Moveable Requester
   * @example
    * // Instantly Request (requestStart - request - requestEnd)
   * moveable.request("rotatable", { deltaRotate: 10 }, true);
   *
   * * moveable.request("rotatable", { rotate: 10 }, true);
   *
   * // requestStart
   * const requester = moveable.request("rotatable");
   *
   * // request
   * requester.request({ deltaRotate: 10 });
   * requester.request({ deltaRotate: 10 });
   * requester.request({ deltaRotate: 10 });
   *
   * requester.request({ rotate: 10 });
   * requester.request({ rotate: 20 });
   * requester.request({ rotate: 30 });
   *
   * // requestEnd
   * requester.requestEnd();
   */
  request: function(a) {
    var s = {}, $ = 0, _ = a.getRotation();
    return {
      isControl: !0,
      requestStart: function() {
        return {
          datas: s
        };
      },
      request: function(_e) {
        return "deltaRotate" in _e ? $ += _e.deltaRotate : "rotate" in _e && ($ = _e.rotate - _), {
          datas: s,
          parentDist: $
        };
      },
      requestEnd: function() {
        return {
          datas: s,
          isDrag: !0
        };
      }
    };
  }
}, Resizable = {
  name: "resizable",
  ableGroup: "size",
  canPinch: !0,
  props: {
    resizable: Boolean,
    throttleResize: Number,
    renderDirections: Array,
    keepRatio: Boolean
  },
  events: {
    onResizeStart: "resizeStart",
    onResize: "resize",
    onResizeEnd: "resizeEnd",
    onResizeGroupStart: "resizeGroupStart",
    onResizeGroup: "resizeGroup",
    onResizeGroupEnd: "resizeGroupEnd"
  },
  render: function(a, s) {
    var $ = a.props, _ = $.resizable, _e = $.edge;
    if (_)
      return _e ? renderDiagonalDirections(a, s) : renderAllDirections(a, s);
  },
  dragControlCondition: directionCondition,
  dragControlStart: function(a, s) {
    var $, _ = s.inputEvent, _e = s.isPinch, tt = s.parentDirection, nt = s.datas, at = s.parentFlag, ot = tt || (_e ? [0, 0] : getDirection(_.target)), rt = a.state, st = rt.target, lt = rt.width, et = rt.height;
    if (!ot || !st)
      return !1;
    !_e && setDragStart(a, s), nt.datas = {}, nt.direction = ot, nt.startOffsetWidth = lt, nt.startOffsetHeight = et, nt.prevWidth = 0, nt.prevHeight = 0, $ = getCSSSize(st), nt.startWidth = $[0], nt.startHeight = $[1];
    var it = [Math.max(0, lt - nt.startWidth), Math.max(0, et - nt.startHeight)];
    if (nt.minSize = it, nt.maxSize = [1 / 0, 1 / 0], !at) {
      var ut = getComputedStyle$1(st), ft = ut.position, ht = ut.minWidth, dt = ut.minHeight, gt = ut.maxWidth, pt = ut.maxHeight, mt = ft === "static" || ft === "relative", ct = mt ? st.parentElement : st.offsetParent, vt = lt, At = et;
      if (ct && (vt = ct.clientWidth, At = ct.clientHeight, mt)) {
        var xt = getComputedStyle$1(ct);
        vt -= parseFloat(xt.paddingLeft) || 0, At -= parseFloat(xt.paddingTop) || 0;
      }
      nt.minSize = plus([convertUnitSize(ht, vt) || 0, convertUnitSize(dt, At) || 0], it), nt.maxSize = plus([convertUnitSize(gt, vt) || 1 / 0, convertUnitSize(pt, At) || 1 / 0], it);
    }
    var bt = a.props.transformOrigin || "% %";
    nt.transformOrigin = bt && isString(bt) ? bt.split(" ") : bt, nt.isWidth = !ot[0] && !ot[1] || ot[0] || !ot[1];
    function Et(Pt) {
      nt.ratio = Pt && isFinite(Pt) ? Pt : 0;
    }
    function St(Pt) {
      nt.fixedDirection = Pt, nt.fixedPosition = getAbsolutePosition(a, Pt);
    }
    Et(lt / et), St([-ot[0], -ot[1]]);
    var Bt = fillParams(a, s, {
      direction: ot,
      set: function(Pt) {
        var wt = Pt[0], Ct = Pt[1];
        nt.startWidth = wt, nt.startHeight = Ct;
      },
      setMin: function(Pt) {
        nt.minSize = Pt;
      },
      setMax: function(Pt) {
        nt.maxSize = [Pt[0] || 1 / 0, Pt[1] || 1 / 0];
      },
      setRatio: Et,
      setFixedDirection: St,
      setOrigin: function(Pt) {
        nt.transformOrigin = Pt;
      },
      dragStart: Draggable.dragStart(a, new CustomGesto().dragStart([0, 0], s))
    }), Ot = triggerEvent(a, "onResizeStart", Bt);
    return Ot !== !1 && (nt.isResize = !0, a.state.snapRenderInfo = {
      request: s.isRequest,
      direction: ot
    }), nt.isResize ? Bt : !1;
  },
  dragControl: function(a, s) {
    var $, _ = s.datas, _e = s.distX, tt = s.distY, nt = s.parentFlag, at = s.isPinch, ot = s.parentDistance, rt = s.parentScale, st = s.parentKeepRatio, lt = s.dragClient, et = s.parentDist, it = s.isRequest, ut = _.isResize, ft = _.transformOrigin, ht = _.fixedDirection, dt = _.startWidth, gt = _.startHeight, pt = _.prevWidth, mt = _.prevHeight, ct = _.minSize, vt = _.maxSize, At = _.ratio, xt = _.isWidth, bt = _.startOffsetWidth, Et = _.startOffsetHeight;
    if (ut) {
      var St = a.props, Bt = St.throttleResize, Ot = Bt === void 0 ? 0 : Bt, Pt = St.parentMoveable, wt = St.snapThreshold, Ct = wt === void 0 ? 5 : wt, It = _.direction, yt = It, Rt = 0, kt = 0;
      !It[0] && !It[1] && (yt = [1, 1]);
      var jt = At && (a.props.keepRatio || st), Ht = lt;
      if (lt || (!nt && at ? Ht = getAbsolutePosition(a, [0, 0]) : Ht = _.fixedPosition), et)
        Rt = et[0], kt = et[1], jt && (Rt ? kt || (kt = Rt / At) : Rt = kt * At);
      else if (rt)
        Rt = (rt[0] - 1) * bt, kt = (rt[1] - 1) * Et;
      else if (at)
        ot && (Rt = ot, kt = ot * Et / bt);
      else {
        var Ft = getDragDist({
          datas: _,
          distX: _e,
          distY: tt
        });
        if (Rt = yt[0] * Ft[0], kt = yt[1] * Ft[1], jt && bt && Et) {
          var _t = getRad$1([0, 0], Ft), Nt = getRad$1([0, 0], yt), Mt = getDistSize([Rt, kt]), Lt = Math.cos(_t - Nt) * Mt;
          if (!yt[0])
            kt = Lt, Rt = kt / At;
          else if (!yt[1])
            Rt = Lt, kt = Rt * At;
          else {
            var $t = yt[0] * 2 * bt, Tt = yt[1] * 2 * Et, Dt = getDistSize([$t + Ft[0], Tt + Ft[1]]) - getDistSize([$t, Tt]), Ut = getRad$1([0, 0], [At, 1]);
            Rt = Math.cos(Ut) * Dt, kt = Math.sin(Ut) * Dt;
          }
        } else if (!jt) {
          var Vt = __spreadArrays(It);
          bt || (Ft[0] < 0 ? Vt[0] = -1 : Ft[0] > 0 && (Vt[0] = 1)), Et || (Ft[1] < 0 ? Vt[1] = -1 : Ft[1] > 0 && (Vt[1] = 1)), It = Vt, yt = Vt, Rt = yt[0] * Ft[0], kt = yt[1] * Ft[1];
        }
      }
      var Qt = yt[0] || jt ? Math.max(bt + Rt, TINY_NUM) : bt, qt = yt[1] || jt ? Math.max(Et + kt, TINY_NUM) : Et;
      jt && bt && Et && (xt ? qt = Qt / At : Qt = qt * At);
      var Zt = [0, 0];
      if (at || (Zt = checkSnapResize(a, Qt, qt, It, Ht, it, _)), et && (!et[0] && (Zt[0] = 0), !et[1] && (Zt[1] = 0)), jt) {
        yt[0] && yt[1] && Zt[0] && Zt[1] && (Math.abs(Zt[0]) > Math.abs(Zt[1]) ? Zt[1] = 0 : Zt[0] = 0);
        var ar = !Zt[0] && !Zt[1];
        ar && (xt ? Qt = throttle(Qt, Ot) : qt = throttle(qt, Ot)), yt[0] && !yt[1] || Zt[0] && !Zt[1] || ar && xt ? (Qt += Zt[0], qt = Qt / At) : (!yt[0] && yt[1] || !Zt[0] && Zt[1] || ar && !xt) && (qt += Zt[1], Qt = qt * At);
      } else
        bt + Rt < -Ct && (Zt[0] = 0), bt + kt < -Ct && (Zt[1] = 0), Qt += Zt[0], qt += Zt[1], Zt[0] || (Qt = throttle(Qt, Ot)), Zt[1] || (qt = throttle(qt, Ot));
      $ = calculateBoundSize([Qt, qt], ct, vt, jt), Qt = $[0], qt = $[1], Qt = Math.round(Qt), qt = Math.round(qt), Rt = Qt - bt, kt = qt - Et;
      var Jt = [Rt - pt, kt - mt];
      _.prevWidth = Rt, _.prevHeight = kt;
      var rr = getResizeDist(a, Qt, qt, ht, Ht, ft);
      if (!(!Pt && Jt.every(function(Kt) {
        return !Kt;
      }) && rr.every(function(Kt) {
        return !Kt;
      }))) {
        var Yt = fillParams(a, s, {
          width: dt + Rt,
          height: gt + kt,
          offsetWidth: Qt,
          offsetHeight: qt,
          direction: It,
          dist: [Rt, kt],
          delta: Jt,
          isPinch: !!at,
          drag: Draggable.drag(a, setCustomDrag(s, a.state, rr, !!at, !1))
        });
        return triggerEvent(a, "onResize", Yt), Yt;
      }
    }
  },
  dragControlAfter: function(a, s) {
    var $ = s.datas, _ = $.isResize, _e = $.startOffsetWidth, tt = $.startOffsetHeight, nt = $.prevWidth, at = $.prevHeight;
    if (_) {
      var ot = a.state, rt = ot.width, st = ot.height, lt = rt - (_e + nt), et = st - (tt + at), it = Math.abs(lt) > 3, ut = Math.abs(et) > 3;
      if (it && ($.startWidth += lt, $.startOffsetWidth += lt, $.prevWidth += lt), ut && ($.startHeight += et, $.startOffsetHeight += et, $.prevHeight += et), it || ut)
        return this.dragControl(a, s), !0;
    }
  },
  dragControlEnd: function(a, s) {
    var $ = s.datas, _ = s.isDrag;
    if (!$.isResize)
      return !1;
    $.isResize = !1;
    var _e = fillEndParams(a, s, {});
    return triggerEvent(a, "onResizeEnd", _e), _;
  },
  dragGroupControlCondition: directionCondition,
  dragGroupControlStart: function(a, s) {
    var $ = s.datas, _ = this.dragControlStart(a, s);
    if (!_)
      return !1;
    var _e = fillChildEvents(a, "resizable", s);
    function tt(rt, st) {
      var lt = $.fixedDirection, et = $.fixedPosition, it = getAbsolutePosition(rt, lt), ut = calculate(createRotateMatrix(-a.rotation / 180 * Math.PI, 3), [it[0] - et[0], it[1] - et[1], 1], 3), ft = ut[0], ht = ut[1];
      return st.datas.originalX = ft, st.datas.originalY = ht, st;
    }
    var nt = triggerChildAbles(a, this, "dragControlStart", s, function(rt, st) {
      return tt(rt, st);
    }), at = __assign$1(__assign$1({}, _), {
      targets: a.props.targets,
      events: nt,
      setFixedDirection: function(rt) {
        _.setFixedDirection(rt), nt.forEach(function(st, lt) {
          st.setFixedDirection(rt), tt(a.moveables[lt], _e[lt]);
        });
      }
    }), ot = triggerEvent(a, "onResizeGroupStart", at);
    return $.isResize = ot !== !1, $.isResize ? _ : !1;
  },
  dragGroupControl: function(a, s) {
    var $ = s.datas;
    if ($.isResize) {
      var _ = this.dragControl(a, s);
      if (_) {
        var _e = _.offsetWidth, tt = _.offsetHeight, nt = _.dist, at = a.props.keepRatio, ot = [_e / (_e - nt[0]), tt / (tt - nt[1])], rt = $.fixedPosition, st = triggerChildAbles(a, this, "dragControl", s, function(et, it) {
          var ut = calculate(createRotateMatrix(a.rotation / 180 * Math.PI, 3), [it.datas.originalX * ot[0], it.datas.originalY * ot[1], 1], 3), ft = ut[0], ht = ut[1];
          return __assign$1(__assign$1({}, it), {
            parentDist: null,
            parentScale: ot,
            dragClient: plus(rt, [ft, ht]),
            parentKeepRatio: at
          });
        }), lt = __assign$1({
          targets: a.props.targets,
          events: st
        }, _);
        return triggerEvent(a, "onResizeGroup", lt), lt;
      }
    }
  },
  dragGroupControlEnd: function(a, s) {
    var $ = s.isDrag, _ = s.datas;
    if (_.isResize) {
      this.dragControlEnd(a, s), triggerChildAbles(a, this, "dragControlEnd", s);
      var _e = fillEndParams(a, s, {
        targets: a.props.targets
      });
      return triggerEvent(a, "onResizeGroupEnd", _e), $;
    }
  },
  /**
   * @method Moveable.Resizable#request
   * @param {object} [e] - the Resizable's request parameter
   * @param {number} [e.direction=[1, 1]] - Direction to resize
   * @param {number} [e.deltaWidth] - delta number of width
   * @param {number} [e.deltaHeight] - delta number of height
   * @param {number} [e.offsetWidth] - offset number of width
   * @param {number} [e.offsetHeight] - offset number of height
   * @param {number} [e.isInstant] - Whether to execute the request instantly
   * @return {Moveable.Requester} Moveable Requester
   * @example
    * // Instantly Request (requestStart - request - requestEnd)
   * // Use Relative Value
   * moveable.request("resizable", { deltaWidth: 10, deltaHeight: 10 }, true);
   *
   * // Use Absolute Value
   * moveable.request("resizable", { offsetWidth: 100, offsetHeight: 100 }, true);
   *
   * // requestStart
   * const requester = moveable.request("resizable");
   *
   * // request
   * // Use Relative Value
   * requester.request({ deltaWidth: 10, deltaHeight: 10 });
   * requester.request({ deltaWidth: 10, deltaHeight: 10 });
   * requester.request({ deltaWidth: 10, deltaHeight: 10 });
   *
   * // Use Absolute Value
   * moveable.request("resizable", { offsetWidth: 100, offsetHeight: 100 });
   * moveable.request("resizable", { offsetWidth: 110, offsetHeight: 100 });
   * moveable.request("resizable", { offsetWidth: 120, offsetHeight: 100 });
   *
   * // requestEnd
   * requester.requestEnd();
   */
  request: function(a) {
    var s = {}, $ = 0, _ = 0, _e = a.getRect();
    return {
      isControl: !0,
      requestStart: function(tt) {
        return {
          datas: s,
          parentDirection: tt.direction || [1, 1]
        };
      },
      request: function(tt) {
        return "offsetWidth" in tt ? $ = tt.offsetWidth - _e.offsetWidth : "deltaWidth" in tt && ($ += tt.deltaWidth), "offsetHeight" in tt ? _ = tt.offsetHeight - _e.offsetHeight : "deltaHeight" in tt && (_ += tt.deltaHeight), {
          datas: s,
          parentDist: [$, _]
        };
      },
      requestEnd: function() {
        return {
          datas: s,
          isDrag: !0
        };
      }
    };
  }
}, Scalable = {
  name: "scalable",
  ableGroup: "size",
  canPinch: !0,
  props: {
    scalable: Boolean,
    throttleScale: Number,
    renderDirections: String,
    keepRatio: Boolean
  },
  events: {
    onScaleStart: "scaleStart",
    onScale: "scale",
    onScaleEnd: "scaleEnd",
    onScaleGroupStart: "scaleGroupStart",
    onScaleGroup: "scaleGroup",
    onScaleGroupEnd: "scaleGroupEnd"
  },
  render: function(a, s) {
    var $ = a.props, _ = $.resizable, _e = $.scalable, tt = $.edge;
    if (!_ && _e)
      return tt ? renderDiagonalDirections(a, s) : renderAllDirections(a, s);
  },
  dragControlCondition: directionCondition,
  dragControlStart: function(a, s) {
    var $ = s.datas, _ = s.isPinch, _e = s.inputEvent, tt = s.parentDirection, nt = tt || (_ ? [0, 0] : getDirection(_e.target)), at = a.state, ot = at.width, rt = at.height, st = at.targetTransform, lt = at.target, et = at.pos1, it = at.pos2, ut = at.pos4;
    if (!nt || !lt)
      return !1;
    _ || setDragStart(a, s), $.datas = {}, $.transform = st, $.prevDist = [1, 1], $.direction = nt, $.width = ot, $.height = rt, $.startValue = [1, 1];
    var ft = getDist$2(et, it), ht = getDist$2(it, ut), dt = !nt[0] && !nt[1] || nt[0] || !nt[1];
    $.scaleWidth = ft, $.scaleHeight = ht, $.scaleXRatio = ft / ot, $.scaleYRatio = ht / rt, setDefaultTransformIndex(s, "scale"), $.isWidth = dt;
    function gt(vt) {
      $.ratio = vt && isFinite(vt) ? vt : 0;
    }
    function pt(vt) {
      $.fixedDirection = vt, $.fixedPosition = getAbsolutePosition(a, vt);
    }
    gt(getDist$2(et, it) / getDist$2(it, ut)), pt([-nt[0], -nt[1]]);
    var mt = fillParams(a, s, __assign$1(__assign$1({
      direction: nt,
      set: function(vt) {
        $.startValue = vt;
      },
      setRatio: gt,
      setFixedDirection: pt
    }, fillTransformStartEvent(s)), {
      dragStart: Draggable.dragStart(a, new CustomGesto().dragStart([0, 0], s))
    })), ct = triggerEvent(a, "onScaleStart", mt);
    return ct !== !1 && ($.isScale = !0, a.state.snapRenderInfo = {
      request: s.isRequest,
      direction: nt
    }), $.isScale ? mt : !1;
  },
  dragControl: function(a, s) {
    resolveTransformEvent(s, "scale");
    var $ = s.datas, _ = s.distX, _e = s.distY, tt = s.parentScale, nt = s.parentDistance, at = s.parentKeepRatio, ot = s.parentFlag, rt = s.isPinch, st = s.dragClient, lt = s.parentDist, et = s.isRequest, it = $.prevDist, ut = $.direction, ft = $.width, ht = $.height, dt = $.isScale, gt = $.startValue, pt = $.isWidth, mt = $.ratio, ct = $.fixedDirection, vt = $.scaleXRatio, At = $.scaleYRatio;
    if (!dt)
      return !1;
    var xt = a.props, bt = xt.throttleScale, Et = xt.parentMoveable, St = ut;
    !ut[0] && !ut[1] && (St = [1, 1]);
    var Bt = mt && (a.props.keepRatio || at), Ot = a.state, Pt = 1, wt = 1, Ct = st;
    if (st || (!ot && rt ? Ct = getAbsolutePosition(a, [0, 0]) : Ct = $.fixedPosition), lt)
      Pt = (ft + lt[0]) / ft, wt = (ht + lt[1]) / ht;
    else if (tt)
      Pt = tt[0], wt = tt[1];
    else if (rt)
      nt && (Pt = (ft + nt) / ft, wt = (ht + nt * ht / ft) / ht);
    else {
      var It = getDragDist({
        datas: $,
        distX: _,
        distY: _e
      }), yt = St[0] * It[0] * vt, Rt = St[1] * It[1] * At;
      if (Bt && ft && ht)
        if (!St[0])
          yt = Rt * mt;
        else if (!St[1])
          Rt = yt / mt;
        else {
          var kt = getDistSize([yt, Rt]), jt = getRad$1([0, 0], It), Ht = getRad$1([0, 0], St), Ft = Math.cos(jt - Ht) * kt, _t = getRad$1([0, 0], [mt, 1]);
          yt = Math.cos(_t) * Ft, Rt = Math.sin(_t) * Ft;
        }
      Pt = (ft + yt / vt) / ft, wt = (ht + Rt / At) / ht;
    }
    Pt = St[0] || Bt ? Pt * gt[0] : gt[0], wt = St[1] || Bt ? wt * gt[1] : gt[1], Pt === 0 && (Pt = (it[0] > 0 ? 1 : -1) * MIN_SCALE), wt === 0 && (wt = (it[1] > 0 ? 1 : -1) * MIN_SCALE);
    var Nt = [Pt / gt[0], wt / gt[1]], Mt = [Pt, wt];
    if (!rt && a.props.groupable) {
      var Lt = Ot.snapRenderInfo || {}, $t = Lt.direction;
      isArray($t) && ($t[0] || $t[1]) && (Ot.snapRenderInfo = {
        direction: ut,
        request: s.isRequest
      });
    }
    var Tt = [0, 0];
    if (rt || (Tt = checkSnapScale(a, Nt, ut, et, $)), Bt) {
      St[0] && St[1] && Tt[0] && Tt[1] && (Math.abs(Tt[0] * ft) > Math.abs(Tt[1] * ht) ? Tt[1] = 0 : Tt[0] = 0);
      var Dt = !Tt[0] && !Tt[1];
      if (Dt && (pt ? Nt[0] = throttle(Nt[0] * gt[0], bt) / gt[0] : Nt[1] = throttle(Nt[1] * gt[1], bt) / gt[1]), St[0] && !St[1] || Tt[0] && !Tt[1] || Dt && pt) {
        Nt[0] += Tt[0];
        var Ut = ft * Nt[0] * gt[0] / mt;
        Nt[1] = Ut / ht / gt[1];
      } else if (!St[0] && St[1] || !Tt[0] && Tt[1] || Dt && !pt) {
        Nt[1] += Tt[1];
        var Vt = ht * Nt[1] * gt[1] * mt;
        Nt[0] = Vt / ft / gt[0];
      }
    } else
      Nt[0] += Tt[0], Nt[1] += Tt[1], Tt[0] || (Nt[0] = throttle(Nt[0] * gt[0], bt) / gt[0]), Tt[1] || (Nt[1] = throttle(Nt[1] * gt[1], bt) / gt[1]);
    Nt[0] === 0 && (Nt[0] = (it[0] > 0 ? 1 : -1) * MIN_SCALE), Nt[1] === 0 && (Nt[1] = (it[1] > 0 ? 1 : -1) * MIN_SCALE);
    var Qt = [Nt[0] / it[0], Nt[1] / it[1]];
    Mt = multiply2(Nt, gt);
    var qt = getScaleDist(a, Nt, ct, Ct, $), Zt = minus(qt, $.prevInverseDist || [0, 0]);
    if ($.prevDist = Nt, $.prevInverseDist = qt, Pt === it[0] && wt === it[1] && Zt.every(function(rr) {
      return !rr;
    }) && !Et)
      return !1;
    var ar = convertTransformFormat($, "scale(" + Mt.join(", ") + ")", "scale(" + Nt.join(", ") + ")"), Jt = fillParams(a, s, __assign$1({
      offsetWidth: ft,
      offsetHeight: ht,
      direction: ut,
      // beforeScale,
      // beforeDist,
      // beforeDelta,
      scale: Mt,
      dist: Nt,
      delta: Qt,
      isPinch: !!rt
    }, fillTransformEvent(a, ar, Zt, rt, s)));
    return triggerEvent(a, "onScale", Jt), Jt;
  },
  dragControlEnd: function(a, s) {
    var $ = s.datas, _ = s.isDrag;
    return $.isScale ? ($.isScale = !1, triggerEvent(a, "onScaleEnd", fillEndParams(a, s, {})), _) : !1;
  },
  dragGroupControlCondition: directionCondition,
  dragGroupControlStart: function(a, s) {
    var $ = s.datas, _ = this.dragControlStart(a, s);
    if (!_)
      return !1;
    var _e = fillChildEvents(a, "resizable", s);
    function tt(rt, st) {
      var lt = $.fixedDirection, et = $.fixedPosition, it = getAbsolutePosition(rt, lt), ut = calculate(createRotateMatrix(-a.rotation / 180 * Math.PI, 3), [it[0] - et[0], it[1] - et[1], 1], 3), ft = ut[0], ht = ut[1];
      return st.datas.originalX = ft, st.datas.originalY = ht, st;
    }
    $.moveableScale = a.scale;
    var nt = triggerChildAbles(a, this, "dragControlStart", s, function(rt, st) {
      return tt(rt, st);
    }), at = __assign$1(__assign$1({}, _), {
      targets: a.props.targets,
      events: nt,
      setFixedDirection: function(rt) {
        _.setFixedDirection(rt), nt.forEach(function(st, lt) {
          st.setFixedDirection(rt), tt(a.moveables[lt], _e[lt]);
        });
      }
    }), ot = triggerEvent(a, "onScaleGroupStart", at);
    return $.isScale = ot !== !1, $.isScale ? at : !1;
  },
  dragGroupControl: function(a, s) {
    var $ = s.datas;
    if ($.isScale) {
      var _ = this.dragControl(a, s);
      if (_) {
        var _e = $.moveableScale;
        a.scale = [_.scale[0] * _e[0], _.scale[1] * _e[1]];
        var tt = a.props.keepRatio, nt = _.dist, at = _.scale, ot = $.fixedPosition, rt = triggerChildAbles(a, this, "dragControl", s, function(lt, et) {
          var it = calculate(createRotateMatrix(a.rotation / 180 * Math.PI, 3), [et.datas.originalX * nt[0], et.datas.originalY * nt[1], 1], 3), ut = it[0], ft = it[1];
          return __assign$1(__assign$1({}, et), {
            parentDist: null,
            parentScale: at,
            parentKeepRatio: tt,
            dragClient: plus(ot, [ut, ft])
          });
        }), st = __assign$1({
          targets: a.props.targets,
          events: rt
        }, _);
        return triggerEvent(a, "onScaleGroup", st), st;
      }
    }
  },
  dragGroupControlEnd: function(a, s) {
    var $ = s.isDrag, _ = s.datas;
    if (_.isScale) {
      this.dragControlEnd(a, s), triggerChildAbles(a, this, "dragControlEnd", s);
      var _e = fillEndParams(a, s, {
        targets: a.props.targets
      });
      return triggerEvent(a, "onScaleGroupEnd", _e), $;
    }
  },
  /**
   * @method Moveable.Scalable#request
   * @param {object} [e] - the Resizable's request parameter
   * @param {number} [e.direction=[1, 1]] - Direction to scale
   * @param {number} [e.deltaWidth] - delta number of width
   * @param {number} [e.deltaHeight] - delta number of height
   * @return {Moveable.Requester} Moveable Requester
   * @example
    * // Instantly Request (requestStart - request - requestEnd)
   * moveable.request("scalable", { deltaWidth: 10, deltaHeight: 10 }, true);
   *
   * // requestStart
   * const requester = moveable.request("scalable");
   *
   * // request
   * requester.request({ deltaWidth: 10, deltaHeight: 10 });
   * requester.request({ deltaWidth: 10, deltaHeight: 10 });
   * requester.request({ deltaWidth: 10, deltaHeight: 10 });
   *
   * // requestEnd
   * requester.requestEnd();
   */
  request: function() {
    var a = {}, s = 0, $ = 0;
    return {
      isControl: !0,
      requestStart: function(_) {
        return {
          datas: a,
          parentDirection: _.direction || [1, 1]
        };
      },
      request: function(_) {
        return s += _.deltaWidth, $ += _.deltaHeight, {
          datas: a,
          parentDist: [s, $]
        };
      },
      requestEnd: function() {
        return {
          datas: a,
          isDrag: !0
        };
      }
    };
  }
};
function getMiddleLinePos(a, s) {
  return a.map(function($, _) {
    return dot($, s[_], 1, 2);
  });
}
function getTriangleRad(a, s, $) {
  var _ = getRad$1(a, s), _e = getRad$1(a, $), tt = _e - _;
  return tt >= 0 ? tt : tt + 2 * Math.PI;
}
function isValidPos(a, s) {
  var $ = getTriangleRad(a[0], a[1], a[2]), _ = getTriangleRad(s[0], s[1], s[2]), _e = Math.PI;
  return !($ >= _e && _ <= _e || $ <= _e && _ >= _e);
}
var Warpable = {
  name: "warpable",
  ableGroup: "size",
  props: {
    warpable: Boolean,
    renderDirections: Array
  },
  events: {
    onWarpStart: "warpStart",
    onWarp: "warp",
    onWarpEnd: "warpEnd"
  },
  render: function(a, s) {
    var $ = a.props, _ = $.resizable, _e = $.scalable, tt = $.warpable, nt = $.zoom;
    if (_ || _e || !tt)
      return [];
    var at = a.state, ot = at.pos1, rt = at.pos2, st = at.pos3, lt = at.pos4, et = getMiddleLinePos(ot, rt), it = getMiddleLinePos(rt, ot), ut = getMiddleLinePos(ot, st), ft = getMiddleLinePos(st, ot), ht = getMiddleLinePos(st, lt), dt = getMiddleLinePos(lt, st), gt = getMiddleLinePos(rt, lt), pt = getMiddleLinePos(lt, rt);
    return __spreadArrays([s.createElement("div", {
      className: prefix$1("line"),
      key: "middeLine1",
      style: getLineStyle(et, ht, nt)
    }), s.createElement("div", {
      className: prefix$1("line"),
      key: "middeLine2",
      style: getLineStyle(it, dt, nt)
    }), s.createElement("div", {
      className: prefix$1("line"),
      key: "middeLine3",
      style: getLineStyle(ut, gt, nt)
    }), s.createElement("div", {
      className: prefix$1("line"),
      key: "middeLine4",
      style: getLineStyle(ft, pt, nt)
    })], renderAllDirections(a, s));
  },
  dragControlCondition: function(a, s) {
    return s.isRequest ? !1 : hasClass(s.inputEvent.target, prefix$1("direction"));
  },
  dragControlStart: function(a, s) {
    var $ = s.datas, _ = s.inputEvent, _e = a.props.target, tt = _.target, nt = getDirection(tt);
    if (!nt || !_e)
      return !1;
    var at = a.state, ot = at.transformOrigin, rt = at.is3d, st = at.targetTransform, lt = at.targetMatrix, et = at.width, it = at.height, ut = at.left, ft = at.top;
    $.datas = {}, $.targetTransform = st, $.warpTargetMatrix = rt ? lt : convertDimension(lt, 3, 4), $.targetInverseMatrix = ignoreDimension(invert($.warpTargetMatrix, 4), 3, 4), $.direction = nt, $.left = ut, $.top = ft, $.poses = [[0, 0], [et, 0], [0, it], [et, it]].map(function(gt) {
      return minus(gt, ot);
    }), $.nextPoses = $.poses.map(function(gt) {
      var pt = gt[0], mt = gt[1];
      return calculate($.warpTargetMatrix, [pt, mt, 0, 1], 4);
    }), $.startValue = createIdentityMatrix(4), $.prevMatrix = createIdentityMatrix(4), $.absolutePoses = getAbsolutePosesByState(at), $.posIndexes = getPosIndexesByDirection(nt), setDragStart(a, s), setDefaultTransformIndex(s, "matrix3d"), at.snapRenderInfo = {
      request: s.isRequest,
      direction: nt
    };
    var ht = fillParams(a, s, __assign$1({
      set: function(gt) {
        $.startValue = gt;
      }
    }, fillTransformStartEvent(s))), dt = triggerEvent(a, "onWarpStart", ht);
    return dt !== !1 && ($.isWarp = !0), $.isWarp;
  },
  dragControl: function(a, s) {
    var $ = s.datas, _ = s.isRequest, _e = s.distX, tt = s.distY, nt = $.targetInverseMatrix, at = $.prevMatrix, ot = $.isWarp, rt = $.startValue, st = $.poses, lt = $.posIndexes, et = $.absolutePoses;
    if (!ot)
      return !1;
    if (resolveTransformEvent(s, "matrix3d"), hasGuidelines(a, "warpable")) {
      var it = lt.map(function(bt) {
        return et[bt];
      });
      it.length > 1 && it.push([(it[0][0] + it[1][0]) / 2, (it[0][1] + it[1][1]) / 2]);
      var ut = checkMoveableSnapBounds(a, _, {
        horizontal: it.map(function(bt) {
          return bt[1] + tt;
        }),
        vertical: it.map(function(bt) {
          return bt[0] + _e;
        })
      }), ft = ut.horizontal, ht = ut.vertical;
      tt -= ft.offset, _e -= ht.offset;
    }
    var dt = getDragDist({
      datas: $,
      distX: _e,
      distY: tt
    }, !0), gt = $.nextPoses.slice();
    if (lt.forEach(function(bt) {
      gt[bt] = plus(gt[bt], dt);
    }), !NEARBY_POS.every(function(bt) {
      return isValidPos(bt.map(function(Et) {
        return st[Et];
      }), bt.map(function(Et) {
        return gt[Et];
      }));
    }))
      return !1;
    var pt = createWarpMatrix(st[0], st[2], st[1], st[3], gt[0], gt[2], gt[1], gt[3]);
    if (!pt.length)
      return !1;
    var mt = multiply(nt, pt, 4), ct = getTransfromMatrix($, mt, !0), vt = multiply(invert(at, 4), ct, 4);
    $.prevMatrix = ct;
    var At = multiply(rt, ct, 4), xt = convertTransformFormat($, "matrix3d(" + At.join(", ") + ")", "matrix3d(" + ct.join(", ") + ")");
    return fillOriginalTransform(s, xt), triggerEvent(a, "onWarp", fillParams(a, s, {
      delta: vt,
      matrix: At,
      dist: ct,
      multiply,
      transform: xt
    })), !0;
  },
  dragControlEnd: function(a, s) {
    var $ = s.datas, _ = s.isDrag;
    return $.isWarp ? ($.isWarp = !1, triggerEvent(a, "onWarpEnd", fillEndParams(a, s, {})), _) : !1;
  }
}, AREA_PIECES = /* @__PURE__ */ prefix$1("area-pieces"), AREA_PIECE = /* @__PURE__ */ prefix$1("area-piece"), AVOID = /* @__PURE__ */ prefix$1("avoid");
function restoreStyle(a) {
  var s = a.areaElement, $ = a.state, _ = $.width, _e = $.height;
  removeClass(s, AVOID), s.style.cssText += "left: 0px; top: 0px; width: " + _ + "px; height: " + _e + "px";
}
function renderPieces(a) {
  return a.createElement("div", {
    key: "area_pieces",
    className: AREA_PIECES
  }, a.createElement("div", {
    className: AREA_PIECE
  }), a.createElement("div", {
    className: AREA_PIECE
  }), a.createElement("div", {
    className: AREA_PIECE
  }), a.createElement("div", {
    className: AREA_PIECE
  }));
}
var DragArea = {
  name: "dragArea",
  props: {
    dragArea: Boolean,
    passDragArea: Boolean
  },
  events: {
    onClick: "click",
    onClickGroup: "clickGroup"
  },
  render: function(a, s) {
    var $ = a.props, _ = $.target, _e = $.dragArea, tt = $.groupable, nt = $.passDragArea, at = a.state, ot = at.width, rt = at.height, st = at.renderPoses, lt = nt ? prefix$1("area", "pass") : prefix$1("area");
    if (tt)
      return [s.createElement("div", {
        key: "area",
        ref: ref(a, "areaElement"),
        className: lt
      }), renderPieces(s)];
    if (!_ || !_e)
      return [];
    var et = createWarpMatrix([0, 0], [ot, 0], [0, rt], [ot, rt], st[0], st[1], st[2], st[3]), it = et.length ? makeMatrixCSS(et, !0) : "none";
    return [s.createElement("div", {
      key: "area",
      ref: ref(a, "areaElement"),
      className: lt,
      style: {
        top: "0px",
        left: "0px",
        width: ot + "px",
        height: rt + "px",
        transformOrigin: "0 0",
        transform: it
      }
    }), renderPieces(s)];
  },
  dragStart: function(a, s) {
    var $ = s.datas, _ = s.clientX, _e = s.clientY, tt = s.inputEvent;
    if (!tt)
      return !1;
    $.isDragArea = !1;
    var nt = a.areaElement, at = a.state, ot = at.moveableClientRect, rt = at.renderPoses, st = at.rootMatrix, lt = at.is3d, et = ot.left, it = ot.top, ut = getRect(rt), ft = ut.left, ht = ut.top, dt = ut.width, gt = ut.height, pt = lt ? 4 : 3, mt = calculateInversePosition(st, [_ - et, _e - it], pt), ct = mt[0], vt = mt[1];
    ct -= ft, vt -= ht;
    var At = [{
      left: ft,
      top: ht,
      width: dt,
      height: vt - 10
    }, {
      left: ft,
      top: ht,
      width: ct - 10,
      height: gt
    }, {
      left: ft,
      top: ht + vt + 10,
      width: dt,
      height: gt - vt - 10
    }, {
      left: ft + ct + 10,
      top: ht,
      width: dt - ct - 10,
      height: gt
    }], xt = [].slice.call(nt.nextElementSibling.children);
    At.forEach(function(bt, Et) {
      xt[Et].style.cssText = "left: " + bt.left + "px;top: " + bt.top + "px; width: " + bt.width + "px; height: " + bt.height + "px;";
    }), addClass(nt, AVOID), at.disableNativeEvent = !0;
  },
  drag: function(a, s) {
    var $ = s.datas, _ = s.inputEvent;
    if (this.enableNativeEvent(a), !_)
      return !1;
    $.isDragArea || ($.isDragArea = !0, restoreStyle(a));
  },
  dragEnd: function(a, s) {
    this.enableNativeEvent(a);
    var $ = s.inputEvent, _ = s.datas;
    if (!$)
      return !1;
    _.isDragArea || restoreStyle(a);
  },
  dragGroupStart: function(a, s) {
    return this.dragStart(a, s);
  },
  dragGroup: function(a, s) {
    return this.drag(a, s);
  },
  dragGroupEnd: function(a, s) {
    return this.dragEnd(a, s);
  },
  unset: function(a) {
    restoreStyle(a), a.state.disableNativeEvent = !1;
  },
  enableNativeEvent: function(a) {
    var s = a.state;
    s.disableNativeEvent && requestAnimationFrame(function() {
      s.disableNativeEvent = !1;
    });
  }
}, Origin = makeAble("origin", {
  render: function(a, s) {
    var $ = a.props.zoom, _ = a.state, _e = _.beforeOrigin, tt = _.rotation;
    return [s.createElement("div", {
      className: prefix$1("control", "origin"),
      style: getControlTransform(tt, $, _e),
      key: "beforeOrigin"
    })];
  }
});
function getDefaultScrollPosition(a) {
  var s = a.scrollContainer;
  return [s.scrollLeft, s.scrollTop];
}
var Scrollable = {
  name: "scrollable",
  canPinch: !0,
  props: {
    scrollable: Boolean,
    scrollContainer: Object,
    scrollThreshold: Number,
    getScrollPosition: Function
  },
  events: {
    onScroll: "scroll",
    onScrollGroup: "scrollGroup"
  },
  dragStart: function(a, s) {
    var $ = a.props, _ = $.scrollContainer, _e = _ === void 0 ? a.getContainer() : _, tt = new DragScroll$1(), nt = getRefTarget(_e, !0);
    s.datas.dragScroll = tt;
    var at = s.isControl ? "controlGesto" : "targetGesto", ot = s.targets;
    tt.on("scroll", function(rt) {
      var st = rt.container, lt = rt.direction, et = fillParams(a, s, {
        scrollContainer: st,
        direction: lt
      }), it = ot ? "onScrollGroup" : "onScroll";
      ot && (et.targets = ot), triggerEvent(a, it, et);
    }).on("move", function(rt) {
      var st = rt.offsetX, lt = rt.offsetY;
      a[at].scrollBy(st, lt, s.inputEvent, !1);
    }), tt.dragStart(s, {
      container: nt
    });
  },
  checkScroll: function(a, s) {
    var $ = s.datas.dragScroll;
    if ($) {
      var _ = a.props, _e = _.scrollContainer, tt = _e === void 0 ? a.getContainer() : _e, nt = _.scrollThreshold, at = nt === void 0 ? 0 : nt, ot = _.getScrollPosition, rt = ot === void 0 ? getDefaultScrollPosition : ot;
      return $.drag(s, {
        container: tt,
        threshold: at,
        getScrollPosition: function(st) {
          return rt({
            scrollContainer: st.container,
            direction: st.direction
          });
        }
      }), !0;
    }
  },
  drag: function(a, s) {
    return this.checkScroll(a, s);
  },
  dragEnd: function(a, s) {
    s.datas.dragScroll.dragEnd(), s.datas.dragScroll = null;
  },
  dragControlStart: function(a, s) {
    return this.dragStart(a, __assign$1(__assign$1({}, s), {
      isControl: !0
    }));
  },
  dragControl: function(a, s) {
    return this.drag(a, s);
  },
  dragControlEnd: function(a, s) {
    return this.dragEnd(a, s);
  },
  dragGroupStart: function(a, s) {
    return this.dragStart(a, __assign$1(__assign$1({}, s), {
      targets: a.props.targets
    }));
  },
  dragGroup: function(a, s) {
    return this.drag(a, __assign$1(__assign$1({}, s), {
      targets: a.props.targets
    }));
  },
  dragGroupEnd: function(a, s) {
    return this.dragEnd(a, __assign$1(__assign$1({}, s), {
      targets: a.props.targets
    }));
  },
  dragGroupControlStart: function(a, s) {
    return this.dragStart(a, __assign$1(__assign$1({}, s), {
      targets: a.props.targets,
      isControl: !0
    }));
  },
  dragGroupContro: function(a, s) {
    return this.drag(a, __assign$1(__assign$1({}, s), {
      targets: a.props.targets
    }));
  },
  dragGroupControEnd: function(a, s) {
    return this.dragEnd(a, __assign$1(__assign$1({}, s), {
      targets: a.props.targets
    }));
  }
}, Default = {
  name: "",
  props: {
    target: Object,
    dragTarget: Object,
    container: Object,
    portalContainer: Object,
    rootContainer: Object,
    zoom: Number,
    transformOrigin: Array,
    edge: Boolean,
    ables: Array,
    className: String,
    pinchThreshold: Number,
    pinchOutside: Boolean,
    triggerAblesSimultaneously: Boolean,
    checkInput: Boolean,
    cspNonce: String,
    translateZ: Number,
    hideDefaultLines: Boolean,
    props: Object
  },
  events: {}
}, Padding$2 = makeAble("padding", {
  render: function(a, s) {
    var $ = a.props;
    if ($.dragArea)
      return [];
    var _ = $.padding || {}, _e = _.left, tt = _e === void 0 ? 0 : _e, nt = _.top, at = nt === void 0 ? 0 : nt, ot = _.right, rt = ot === void 0 ? 0 : ot, st = _.bottom, lt = st === void 0 ? 0 : st, et = a.state, it = et.renderPoses, ut = et.pos1, ft = et.pos2, ht = et.pos3, dt = et.pos4, gt = [ut, ft, ht, dt], pt = [];
    return tt > 0 && pt.push([0, 2]), at > 0 && pt.push([0, 1]), rt > 0 && pt.push([1, 3]), lt > 0 && pt.push([2, 3]), pt.map(function(mt, ct) {
      var vt = mt[0], At = mt[1], xt = gt[vt], bt = gt[At], Et = it[vt], St = it[At], Bt = createWarpMatrix([0, 0], [100, 0], [0, 100], [100, 100], xt, bt, Et, St);
      if (Bt.length)
        return s.createElement("div", {
          key: "padding" + ct,
          className: prefix$1("padding"),
          style: {
            transform: makeMatrixCSS(Bt, !0)
          }
        });
    });
  }
}), RADIUS_DIRECTIONS = ["nw", "ne", "se", "sw"];
function calculateRatio(a, s) {
  var $ = a[0] + a[1], _ = $ > s ? s / $ : 1;
  return a[0] *= _, a[1] = s - a[1] * _, a;
}
var HORIZONTAL_RADIUS_ORDER = [1, 2, 5, 6], VERTICAL_RADIUS_ORDER = [0, 3, 4, 7], HORIZONTAL_RADIUS_DIRECTIONS = [1, -1, -1, 1], VERTICAL_RADIUS_DIRECTIONS = [1, 1, -1, -1];
function getRadiusStyles(a, s, $, _, _e, tt, nt, at, ot) {
  tt === void 0 && (tt = 0), nt === void 0 && (nt = 0), at === void 0 && (at = _), ot === void 0 && (ot = _e);
  var rt = [], st = !1, lt = a.map(function(et, it) {
    var ut = s[it], ft = ut.horizontal, ht = ut.vertical;
    if (ht && !st && (st = !0, rt.push("/")), st) {
      var dt = Math.max(0, ht === 1 ? et[1] - nt : ot - et[1]);
      return rt.push(convertCSSSize(dt, _e, $)), dt;
    } else {
      var dt = Math.max(0, ft === 1 ? et[0] - tt : at - et[0]);
      return rt.push(convertCSSSize(dt, _, $)), dt;
    }
  });
  return {
    styles: rt,
    raws: lt
  };
}
function getRadiusRange(a) {
  for (var s = [0, 0], $ = [0, 0], _ = a.length, _e = 0; _e < _; ++_e) {
    var tt = a[_e];
    tt.sub && (tt.horizontal && (s[1] === 0 && (s[0] = _e), s[1] = _e - s[0] + 1, $[0] = _e + 1), tt.vertical && ($[1] === 0 && ($[0] = _e), $[1] = _e - $[0] + 1));
  }
  return {
    horizontalRange: s,
    verticalRange: $
  };
}
function getRadiusValues(a, s, $, _, _e, tt) {
  var nt, at, ot, rt;
  tt === void 0 && (tt = [0, 0]);
  var st = a.indexOf("/"), lt = (st > -1 ? a.slice(0, st) : a).length, et = a.slice(0, lt), it = a.slice(lt + 1), ut = et[0], ft = ut === void 0 ? "0px" : ut, ht = et[1], dt = ht === void 0 ? ft : ht, gt = et[2], pt = gt === void 0 ? ft : gt, mt = et[3], ct = mt === void 0 ? dt : mt, vt = it[0], At = vt === void 0 ? ft : vt, xt = it[1], bt = xt === void 0 ? At : xt, Et = it[2], St = Et === void 0 ? At : Et, Bt = it[3], Ot = Bt === void 0 ? bt : Bt, Pt = [ft, dt, pt, ct].map(function(kt) {
    return convertUnitSize(kt, s);
  }), wt = [At, bt, St, Ot].map(function(kt) {
    return convertUnitSize(kt, $);
  }), Ct = Pt.slice(), It = wt.slice();
  nt = calculateRatio([Ct[0], Ct[1]], s), Ct[0] = nt[0], Ct[1] = nt[1], at = calculateRatio([Ct[3], Ct[2]], s), Ct[3] = at[0], Ct[2] = at[1], ot = calculateRatio([It[0], It[3]], $), It[0] = ot[0], It[3] = ot[1], rt = calculateRatio([It[1], It[2]], $), It[1] = rt[0], It[2] = rt[1];
  var yt = Ct.slice(0, Math.max(tt[0], et.length)), Rt = It.slice(0, Math.max(tt[1], it.length));
  return __spreadArrays(yt.map(function(kt, jt) {
    var Ht = RADIUS_DIRECTIONS[jt];
    return {
      horizontal: HORIZONTAL_RADIUS_DIRECTIONS[jt],
      vertical: 0,
      pos: [_ + kt, _e + (VERTICAL_RADIUS_DIRECTIONS[jt] === -1 ? $ : 0)],
      sub: !0,
      raw: Pt[jt],
      direction: Ht
    };
  }), Rt.map(function(kt, jt) {
    var Ht = RADIUS_DIRECTIONS[jt];
    return {
      horizontal: 0,
      vertical: VERTICAL_RADIUS_DIRECTIONS[jt],
      pos: [_ + (HORIZONTAL_RADIUS_DIRECTIONS[jt] === -1 ? s : 0), _e + kt],
      sub: !0,
      raw: wt[jt],
      direction: Ht
    };
  }));
}
function removeRadiusPos(a, s, $, _, _e) {
  _e === void 0 && (_e = s.length);
  var tt = getRadiusRange(a.slice(_)), nt = tt.horizontalRange, at = tt.verticalRange, ot = $ - _, rt = 0;
  if (ot === 0)
    rt = _e;
  else if (ot > 0 && ot < nt[1])
    rt = nt[1] - ot;
  else if (ot >= at[0])
    rt = at[0] + at[1] - ot;
  else
    return;
  a.splice($, rt), s.splice($, rt);
}
function addRadiusPos(a, s, $, _, _e, tt, nt, at, ot, rt, st) {
  rt === void 0 && (rt = 0), st === void 0 && (st = 0);
  var lt = getRadiusRange(a.slice($)), et = lt.horizontalRange, it = lt.verticalRange;
  if (_ > -1)
    for (var ut = HORIZONTAL_RADIUS_DIRECTIONS[_] === 1 ? tt - rt : at - tt, ft = et[1]; ft <= _; ++ft) {
      var ht = VERTICAL_RADIUS_DIRECTIONS[ft] === 1 ? st : ot, dt = 0;
      if (_ === ft ? dt = tt : ft === 0 ? dt = rt + ut : HORIZONTAL_RADIUS_DIRECTIONS[ft] === -1 && (dt = at - (s[$][0] - rt)), a.splice($ + ft, 0, {
        horizontal: HORIZONTAL_RADIUS_DIRECTIONS[ft],
        vertical: 0,
        pos: [dt, ht]
      }), s.splice($ + ft, 0, [dt, ht]), ft === 0)
        break;
    }
  else if (_e > -1) {
    var gt = VERTICAL_RADIUS_DIRECTIONS[_e] === 1 ? nt - st : ot - nt;
    if (et[1] === 0 && it[1] === 0) {
      var pt = [rt + gt, st];
      a.push({
        horizontal: HORIZONTAL_RADIUS_DIRECTIONS[0],
        vertical: 0,
        pos: pt
      }), s.push(pt);
    }
    for (var mt = it[0], ft = it[1]; ft <= _e; ++ft) {
      var dt = HORIZONTAL_RADIUS_DIRECTIONS[ft] === 1 ? rt : at, ht = 0;
      if (_e === ft ? ht = nt : ft === 0 ? ht = st + gt : VERTICAL_RADIUS_DIRECTIONS[ft] === 1 ? ht = s[$ + mt][1] : VERTICAL_RADIUS_DIRECTIONS[ft] === -1 && (ht = ot - (s[$ + mt][1] - st)), a.push({
        horizontal: 0,
        vertical: VERTICAL_RADIUS_DIRECTIONS[ft],
        pos: [dt, ht]
      }), s.push([dt, ht]), ft === 0)
        break;
    }
  }
}
function splitRadiusPoses(a, s) {
  s === void 0 && (s = a.map(function(_e) {
    return _e.raw;
  }));
  var $ = a.map(function(_e, tt) {
    return _e.horizontal ? s[tt] : null;
  }).filter(function(_e) {
    return _e != null;
  }), _ = a.map(function(_e, tt) {
    return _e.vertical ? s[tt] : null;
  }).filter(function(_e) {
    return _e != null;
  });
  return {
    horizontals: $,
    verticals: _
  };
}
var CLIP_DIRECTIONS = [[0, -1, "n"], [1, 0, "e"]], CLIP_RECT_DIRECTIONS = [[-1, -1, "nw"], [0, -1, "n"], [1, -1, "ne"], [1, 0, "e"], [1, 1, "se"], [0, 1, "s"], [-1, 1, "sw"], [-1, 0, "w"]];
function getClipStyles(a, s, $) {
  var _ = a.props.clipRelative, _e = a.state, tt = _e.width, nt = _e.height, at = s, ot = at.type, rt = at.poses, st = ot === "rect", lt = ot === "circle";
  if (ot === "polygon")
    return $.map(function(vt) {
      return convertCSSSize(vt[0], tt, _) + " " + convertCSSSize(vt[1], nt, _);
    });
  if (st || ot === "inset") {
    var et = $[1][1], it = $[3][0], ut = $[7][0], ft = $[5][1];
    if (st)
      return [et, it, ft, ut].map(function(vt) {
        return vt + "px";
      });
    var ht = [et, tt - it, nt - ft, ut].map(function(vt, At) {
      return convertCSSSize(vt, At % 2 ? tt : nt, _);
    });
    if ($.length > 8) {
      var dt = minus($[4], $[0]), gt = dt[0], pt = dt[1];
      ht.push.apply(ht, __spreadArrays(["round"], getRadiusStyles($.slice(8), rt.slice(8), _, gt, pt, ut, et, it, ft).styles));
    }
    return ht;
  } else if (lt || ot === "ellipse") {
    var mt = $[0], ct = convertCSSSize(Math.abs($[1][1] - mt[1]), lt ? Math.sqrt((tt * tt + nt * nt) / 2) : nt, _), ht = lt ? [ct] : [convertCSSSize(Math.abs($[2][0] - mt[0]), tt, _), ct];
    return ht.push("at", convertCSSSize(mt[0], tt, _), convertCSSSize(mt[1], nt, _)), ht;
  }
}
function getRectPoses(a, s, $, _) {
  var _e = [_, (_ + s) / 2, s], tt = [a, (a + $) / 2, $];
  return CLIP_RECT_DIRECTIONS.map(function(nt) {
    var at = nt[0], ot = nt[1], rt = nt[2], st = _e[at + 1], lt = tt[ot + 1];
    return {
      vertical: Math.abs(ot),
      horizontal: Math.abs(at),
      direction: rt,
      pos: [st, lt]
    };
  });
}
function getClipPath(a, s, $, _, _e) {
  var tt, nt, at, ot, rt, st, lt, et = _e;
  if (!et) {
    var it = getComputedStyle$1(a), ut = it.clipPath;
    et = ut !== "none" ? ut : it.clip;
  }
  if (!((!et || et === "none" || et === "auto") && (et = _, !et))) {
    var ft = splitBracket(et), ht = ft.prefix, dt = ht === void 0 ? et : ht, gt = ft.value, pt = gt === void 0 ? "" : gt, mt = dt === "circle", ct = " ";
    if (dt === "polygon") {
      var vt = splitComma(pt || "0% 0%, 100% 0%, 100% 100%, 0% 100%");
      ct = ",";
      var At = vt.map(function(Jt) {
        var rr = Jt.split(" "), Yt = rr[0], Kt = rr[1];
        return {
          vertical: 1,
          horizontal: 1,
          pos: [convertUnitSize(Yt, s), convertUnitSize(Kt, $)]
        };
      });
      return {
        type: dt,
        clipText: et,
        poses: At,
        splitter: ct
      };
    } else if (mt || dt === "ellipse") {
      var xt = "", bt = "", Et = 0, St = 0, vt = splitSpace(pt);
      if (mt) {
        var Bt = "";
        tt = vt[0], Bt = tt === void 0 ? "50%" : tt, nt = vt[2], xt = nt === void 0 ? "50%" : nt, at = vt[3], bt = at === void 0 ? "50%" : at, Et = convertUnitSize(Bt, Math.sqrt((s * s + $ * $) / 2)), St = Et;
      } else {
        var Ot = "", Pt = "";
        ot = vt[0], Ot = ot === void 0 ? "50%" : ot, rt = vt[1], Pt = rt === void 0 ? "50%" : rt, st = vt[3], xt = st === void 0 ? "50%" : st, lt = vt[4], bt = lt === void 0 ? "50%" : lt, Et = convertUnitSize(Ot, s), St = convertUnitSize(Pt, $);
      }
      var wt = [convertUnitSize(xt, s), convertUnitSize(bt, $)], At = __spreadArrays([{
        vertical: 1,
        horizontal: 1,
        pos: wt,
        direction: "nesw"
      }], CLIP_DIRECTIONS.slice(0, mt ? 1 : 2).map(function(Yt) {
        return {
          vertical: Math.abs(Yt[1]),
          horizontal: Yt[0],
          direction: Yt[2],
          sub: !0,
          pos: [wt[0] + Yt[0] * Et, wt[1] + Yt[1] * St]
        };
      }));
      return {
        type: dt,
        clipText: et,
        radiusX: Et,
        radiusY: St,
        left: wt[0] - Et,
        top: wt[1] - St,
        poses: At,
        splitter: ct
      };
    } else if (dt === "inset") {
      var vt = splitSpace(pt || "0 0 0 0"), Ct = vt.indexOf("round"), It = (Ct > -1 ? vt.slice(0, Ct) : vt).length, yt = vt.slice(It + 1), Rt = vt.slice(0, It), kt = Rt[0], jt = Rt[1], Ht = jt === void 0 ? kt : jt, Ft = Rt[2], _t = Ft === void 0 ? kt : Ft, Nt = Rt[3], Mt = Nt === void 0 ? Ht : Nt, Lt = [kt, _t].map(function(Yt) {
        return convertUnitSize(Yt, $);
      }), $t = Lt[0], Tt = Lt[1], Dt = [Mt, Ht].map(function(Yt) {
        return convertUnitSize(Yt, s);
      }), Ut = Dt[0], Vt = Dt[1], Qt = s - Vt, qt = $ - Tt, Zt = getRadiusValues(yt, Qt - Ut, qt - $t, Ut, $t), At = __spreadArrays(getRectPoses($t, Qt, qt, Ut), Zt);
      return {
        type: "inset",
        clipText: et,
        poses: At,
        top: $t,
        left: Ut,
        right: Qt,
        bottom: qt,
        radius: yt,
        splitter: ct
      };
    } else if (dt === "rect") {
      var vt = splitComma(pt || "0px, " + s + "px, " + $ + "px, 0px");
      ct = ",";
      var ar = vt.map(function(ir) {
        var sr = splitUnit(ir).value;
        return sr;
      }), $t = ar[0], Vt = ar[1], Tt = ar[2], Ut = ar[3], At = getRectPoses($t, Vt, Tt, Ut);
      return {
        type: "rect",
        clipText: et,
        poses: At,
        top: $t,
        right: Vt,
        bottom: Tt,
        left: Ut,
        values: vt,
        splitter: ct
      };
    }
  }
}
function addClipPath(a, s) {
  var $ = calculatePointerDist(a, s), _ = $[0], _e = $[1], tt = s.datas, nt = tt.clipPath, at = tt.index, ot = nt, rt = ot.type, st = ot.poses, lt = ot.splitter, et = st.map(function(dt) {
    return dt.pos;
  });
  if (rt === "polygon")
    et.splice(at, 0, [_, _e]);
  else if (rt === "inset") {
    var it = HORIZONTAL_RADIUS_ORDER.indexOf(at), ut = VERTICAL_RADIUS_ORDER.indexOf(at), ft = st.length;
    if (addRadiusPos(st, et, 8, it, ut, _, _e, et[4][0], et[4][1], et[0][0], et[0][1]), ft === st.length)
      return;
  } else
    return;
  var ht = getClipStyles(a, nt, et);
  triggerEvent(a, "onClip", fillParams(a, s, {
    clipEventType: "added",
    clipType: rt,
    poses: et,
    clipStyles: ht,
    clipStyle: rt + "(" + ht.join(lt) + ")",
    distX: 0,
    distY: 0
  }));
}
function removeClipPath(a, s) {
  var $ = s.datas, _ = $.clipPath, _e = $.index, tt = _, nt = tt.type, at = tt.poses, ot = tt.splitter, rt = at.map(function(et) {
    return et.pos;
  }), st = rt.length;
  if (nt === "polygon")
    at.splice(_e, 1), rt.splice(_e, 1);
  else if (nt === "inset") {
    if (_e < 8 || (removeRadiusPos(at, rt, _e, 8, st), st === at.length))
      return;
  } else
    return;
  var lt = getClipStyles(a, _, rt);
  triggerEvent(a, "onClip", fillParams(a, s, {
    clipEventType: "removed",
    clipType: nt,
    poses: rt,
    clipStyles: lt,
    clipStyle: nt + "(" + lt.join(ot) + ")",
    distX: 0,
    distY: 0
  }));
}
var Clippable = {
  name: "clippable",
  props: {
    clippable: Boolean,
    defaultClipPath: String,
    customClipPath: String,
    clipRelative: Boolean,
    clipArea: Boolean,
    dragWithClip: Boolean,
    clipTargetBounds: Boolean,
    clipVerticalGuidelines: Array,
    clipHorizontalGuidelines: Array,
    clipSnapThreshold: Boolean
  },
  events: {
    onClipStart: "clipStart",
    onClip: "clip",
    onClipEnd: "clipEnd"
  },
  css: [`.control.clip-control {
    background: #6d6;
    cursor: pointer;
}
.control.clip-control.clip-radius {
    background: #d66;
}
.line.clip-line {
    background: #6e6;
    cursor: move;
    z-index: 1;
}
.clip-area {
    position: absolute;
    top: 0;
    left: 0;
}
.clip-ellipse {
    position: absolute;
    cursor: move;
    border: 1px solid #6d6;
    border: var(--zoompx) solid #6d6;
    border-radius: 50%;
    transform-origin: 0px 0px;
}`, `:host {
    --bounds-color: #d66;
}`, `.guideline {
    pointer-events: none;
    z-index: 2;
}`, `.line.guideline.bounds {
    background: #d66;
    background: var(--bounds-color);
}`],
  render: function(a, s) {
    var $ = a.props, _ = $.customClipPath, _e = $.defaultClipPath, tt = $.clipArea, nt = $.zoom, at = a.state, ot = at.target, rt = at.width, st = at.height, lt = at.allMatrix, et = at.is3d, it = at.left, ut = at.top, ft = at.pos1, ht = at.pos2, dt = at.pos3, gt = at.pos4, pt = at.clipPathState, mt = at.snapBoundInfos;
    if (!ot)
      return [];
    var ct = getClipPath(ot, rt, st, _e || "inset", pt || _);
    if (!ct)
      return [];
    var vt = et ? 4 : 3, At = ct.type, xt = ct.poses, bt = xt.map(function(Qt) {
      var qt = calculatePosition(lt, Qt.pos, vt);
      return [qt[0] - it, qt[1] - ut];
    }), Et = [], St = [], Bt = At === "rect", Ot = At === "inset", Pt = At === "polygon";
    if (Bt || Ot || Pt) {
      var wt = Ot ? bt.slice(0, 8) : bt;
      St = wt.map(function(Qt, qt) {
        var Zt = qt === 0 ? wt[wt.length - 1] : wt[qt - 1], ar = getRad$1(Zt, Qt), Jt = getDiagonalSize(Zt, Qt);
        return s.createElement("div", {
          key: "clipLine" + qt,
          className: prefix$1("line", "clip-line", "snap-control"),
          "data-clip-index": qt,
          style: {
            width: Jt + "px",
            transform: "translate(" + Zt[0] + "px, " + Zt[1] + "px) rotate(" + ar + "rad) scaleY(" + nt + ")"
          }
        });
      });
    }
    if (Et = bt.map(function(Qt, qt) {
      return s.createElement("div", {
        key: "clipControl" + qt,
        className: prefix$1("control", "clip-control", "snap-control"),
        "data-clip-index": qt,
        style: {
          transform: "translate(" + Qt[0] + "px, " + Qt[1] + "px) scale(" + nt + ")"
        }
      });
    }), Ot && Et.push.apply(Et, bt.slice(8).map(function(Qt, qt) {
      return s.createElement("div", {
        key: "clipRadiusControl" + qt,
        className: prefix$1("control", "clip-control", "clip-radius", "snap-control"),
        "data-clip-index": 8 + qt,
        style: {
          transform: "translate(" + Qt[0] + "px, " + Qt[1] + "px) scale(" + nt + ")"
        }
      });
    })), At === "circle" || At === "ellipse") {
      var Ct = ct.left, It = ct.top, yt = ct.radiusX, Rt = ct.radiusY, kt = minus(calculatePosition(lt, [Ct, It], vt), calculatePosition(lt, [0, 0], vt)), jt = kt[0], Ht = kt[1], Ft = "none";
      if (!tt) {
        for (var _t = Math.max(10, yt / 5, Rt / 5), Nt = [], Mt = 0; Mt <= _t; ++Mt) {
          var Lt = Math.PI * 2 / _t * Mt;
          Nt.push([yt + (yt - nt) * Math.cos(Lt), Rt + (Rt - nt) * Math.sin(Lt)]);
        }
        Nt.push([yt, -2]), Nt.push([-2, -2]), Nt.push([-2, Rt * 2 + 2]), Nt.push([yt * 2 + 2, Rt * 2 + 2]), Nt.push([yt * 2 + 2, -2]), Nt.push([yt, -2]), Ft = "polygon(" + Nt.map(function(Qt) {
          return Qt[0] + "px " + Qt[1] + "px";
        }).join(", ") + ")";
      }
      Et.push(s.createElement("div", {
        key: "clipEllipse",
        className: prefix$1("clip-ellipse", "snap-control"),
        style: {
          width: yt * 2 + "px",
          height: Rt * 2 + "px",
          clipPath: Ft,
          transform: "translate(" + (-it + jt) + "px, " + (-ut + Ht) + "px) " + makeMatrixCSS(lt)
        }
      }));
    }
    if (tt) {
      var $t = getRect(__spreadArrays([ft, ht, dt, gt], bt)), Tt = $t.width, Dt = $t.height, Ut = $t.left, Vt = $t.top;
      if (Pt || Bt || Ot) {
        var Nt = Ot ? bt.slice(0, 8) : bt;
        Et.push(s.createElement("div", {
          key: "clipArea",
          className: prefix$1("clip-area", "snap-control"),
          style: {
            width: Tt + "px",
            height: Dt + "px",
            transform: "translate(" + Ut + "px, " + Vt + "px)",
            clipPath: "polygon(" + Nt.map(function(qt) {
              return qt[0] - Ut + "px " + (qt[1] - Vt) + "px";
            }).join(", ") + ")"
          }
        }));
      }
    }
    return mt && ["vertical", "horizontal"].forEach(function(Qt) {
      var qt = mt[Qt], Zt = Qt === "horizontal";
      qt.isSnap && St.push.apply(St, qt.snap.posInfos.map(function(ar, Jt) {
        var rr = ar.pos, Yt = minus(calculatePosition(lt, Zt ? [0, rr] : [rr, 0], vt), [it, ut]), Kt = minus(calculatePosition(lt, Zt ? [rt, rr] : [rr, st], vt), [it, ut]);
        return renderLine(s, "", Yt, Kt, nt, "clip" + Qt + "snap" + Jt, "guideline");
      })), qt.isBound && St.push.apply(St, qt.bounds.map(function(ar, Jt) {
        var rr = ar.pos, Yt = minus(calculatePosition(lt, Zt ? [0, rr] : [rr, 0], vt), [it, ut]), Kt = minus(calculatePosition(lt, Zt ? [rt, rr] : [rr, st], vt), [it, ut]);
        return renderLine(s, "", Yt, Kt, nt, "clip" + Qt + "bounds" + Jt, "guideline", "bounds", "bold");
      }));
    }), __spreadArrays(Et, St);
  },
  dragControlCondition: function(a, s) {
    return s.inputEvent && (s.inputEvent.target.getAttribute("class") || "").indexOf("clip") > -1;
  },
  dragStart: function(a, s) {
    var $ = a.props, _ = $.dragWithClip, _e = _ === void 0 ? !0 : _;
    return _e ? !1 : this.dragControlStart(a, s);
  },
  drag: function(a, s) {
    return this.dragControl(a, s);
  },
  dragEnd: function(a, s) {
    return this.dragControlEnd(a, s);
  },
  dragControlStart: function(a, s) {
    var $ = a.state, _ = a.props, _e = _.defaultClipPath, tt = _.customClipPath, nt = $.target, at = $.width, ot = $.height, rt = s.inputEvent ? s.inputEvent.target : null, st = rt ? rt.getAttribute("class") : "", lt = s.datas, et = getClipPath(nt, at, ot, _e || "inset", tt);
    if (!et)
      return !1;
    var it = et.clipText, ut = et.type, ft = et.poses, ht = triggerEvent(a, "onClipStart", fillParams(a, s, {
      clipType: ut,
      clipStyle: it,
      poses: ft.map(function(dt) {
        return dt.pos;
      })
    }));
    return ht === !1 ? (lt.isClipStart = !1, !1) : (lt.isControl = st.indexOf("clip-control") > -1, lt.isLine = st.indexOf("clip-line") > -1, lt.isArea = st.indexOf("clip-area") > -1 || st.indexOf("clip-ellipse") > -1, lt.index = rt ? parseInt(rt.getAttribute("data-clip-index"), 10) : -1, lt.clipPath = et, lt.isClipStart = !0, $.clipPathState = it, setDragStart(a, s), !0);
  },
  dragControl: function(a, s) {
    var $ = s.datas, _ = s.originalDatas;
    if (!$.isClipStart)
      return !1;
    var _e = _ && _.draggable || {}, tt = $, nt = tt.isControl, at = tt.isLine, ot = tt.isArea, rt = tt.index, st = tt.clipPath;
    if (!st)
      return !1;
    var lt = _e.isDrag ? _e.prevDist : getDragDist(s), et = lt[0], it = lt[1], ut = a.props, ft = a.state, ht = ft.width, dt = ft.height, gt = !ot && !nt && !at, pt = st.type, mt = st.poses, ct = st.splitter, vt = mt.map(function(Zt) {
      return Zt.pos;
    });
    gt && (et = -et, it = -it);
    var At = !nt || mt[rt].direction === "nesw", xt = pt === "inset" || pt === "rect", bt = mt.map(function() {
      return [0, 0];
    });
    if (nt && !At) {
      var Et = mt[rt], St = Et.horizontal, Bt = Et.vertical, Ot = [et * Math.abs(St), it * Math.abs(Bt)];
      bt = moveControlPos(mt, rt, Ot, xt);
    } else
      At && (bt = vt.map(function() {
        return [et, it];
      }));
    var Pt = vt.map(function(Zt, ar) {
      return plus(Zt, bt[ar]);
    }), wt = __spreadArrays(Pt);
    ft.snapBoundInfos = null;
    var Ct = st.type === "circle", It = st.type === "ellipse";
    if (Ct || It) {
      var yt = getRect(Pt), Rt = Math.abs(yt.bottom - yt.top), kt = Math.abs(It ? yt.right - yt.left : Rt), jt = Pt[0][1] + Rt, Ht = Pt[0][0] - kt, Ft = Pt[0][0] + kt;
      Ct && (wt.push([Ft, yt.bottom]), bt.push([1, 0])), wt.push([yt.left, jt]), bt.push([0, 1]), wt.push([Ht, yt.bottom]), bt.push([1, 0]);
    }
    var _t = getDefaultGuidelines((ut.clipHorizontalGuidelines || []).map(function(Zt) {
      return convertUnitSize("" + Zt, dt);
    }), (ut.clipVerticalGuidelines || []).map(function(Zt) {
      return convertUnitSize("" + Zt, ht);
    }), ht, dt), Nt = [], Mt = [];
    if (Ct || It)
      Nt = [wt[4][0], wt[2][0]], Mt = [wt[1][1], wt[3][1]];
    else if (xt) {
      var Lt = [wt[0], wt[2], wt[4], wt[6]], $t = [bt[0], bt[2], bt[4], bt[6]];
      Nt = Lt.filter(function(Zt, ar) {
        return $t[ar][0];
      }).map(function(Zt) {
        return Zt[0];
      }), Mt = Lt.filter(function(Zt, ar) {
        return $t[ar][1];
      }).map(function(Zt) {
        return Zt[1];
      });
    } else
      Nt = wt.filter(function(Zt, ar) {
        return bt[ar][0];
      }).map(function(Zt) {
        return Zt[0];
      }), Mt = wt.filter(function(Zt, ar) {
        return bt[ar][1];
      }).map(function(Zt) {
        return Zt[1];
      });
    for (var Tt = [0, 0], Dt = function(Zt) {
      var ar = checkSnapBounds(_t, ut.clipTargetBounds && {
        left: 0,
        top: 0,
        right: ht,
        bottom: dt
      }, Nt, Mt, 5), Jt = ar.horizontal, rr = ar.vertical, Yt = Jt.offset, Kt = rr.offset;
      if (Jt.isBound && (Tt[1] += Yt), rr.isBound && (Tt[0] += Kt), (It || Ct) && bt[0][0] === 0 && bt[0][1] === 0) {
        var nr = getRect(Pt), tr = nr.bottom - nr.top, ir = It ? nr.right - nr.left : tr, sr = rr.isBound ? Math.abs(Kt) : rr.snapIndex === 0 ? -Kt : Kt, cr = Jt.isBound ? Math.abs(Yt) : Jt.snapIndex === 0 ? -Yt : Yt;
        ir -= sr, tr -= cr, Ct && (tr = checkSnapBoundPriority(rr, Jt) > 0 ? tr : ir, ir = tr);
        var or = wt[0];
        wt[1][1] = or[1] - tr, wt[2][0] = or[0] + ir, wt[3][1] = or[1] + tr, wt[4][0] = or[0] - ir;
      } else
        return wt.forEach(function(Xt, Gt) {
          var Wt = bt[Gt];
          Wt[0] && (Xt[0] -= Kt), Wt[1] && (Xt[1] -= Yt);
        }), "break";
    }, Ut = 0; Ut < 2; ++Ut) {
      var Vt = Dt();
      if (Vt === "break")
        break;
    }
    var Qt = getClipStyles(a, st, Pt), qt = pt + "(" + Qt.join(ct) + ")";
    if (ft.clipPathState = qt, Ct || It)
      Nt = [wt[4][0], wt[2][0]], Mt = [wt[1][1], wt[3][1]];
    else if (xt) {
      var Lt = [wt[0], wt[2], wt[4], wt[6]];
      Nt = Lt.map(function(ar) {
        return ar[0];
      }), Mt = Lt.map(function(ar) {
        return ar[1];
      });
    } else
      Nt = wt.map(function(Zt) {
        return Zt[0];
      }), Mt = wt.map(function(Zt) {
        return Zt[1];
      });
    return ft.snapBoundInfos = checkSnapBounds(_t, ut.clipTargetBounds && {
      left: 0,
      top: 0,
      right: ht,
      bottom: dt
    }, Nt, Mt, 1), _.draggable && (_.draggable.deltaOffset = Tt), triggerEvent(a, "onClip", fillParams(a, s, {
      clipEventType: "changed",
      clipType: pt,
      poses: Pt,
      clipStyle: qt,
      clipStyles: Qt,
      distX: et,
      distY: it
    })), !0;
  },
  dragControlEnd: function(a, s) {
    this.unset(a);
    var $ = s.isDrag, _ = s.datas, _e = s.isDouble, tt = _.isLine, nt = _.isClipStart, at = _.isControl;
    return nt ? (triggerEvent(a, "onClipEnd", fillEndParams(a, s, {})), _e && (at ? removeClipPath(a, s) : tt && addClipPath(a, s)), _e || $) : !1;
  },
  unset: function(a) {
    a.state.clipPathState = "", a.state.snapBoundInfos = null;
  }
}, OriginDraggable = {
  name: "originDraggable",
  props: {
    originDraggable: Boolean,
    originRelative: Boolean
  },
  events: {
    onDragOriginStart: "dragOriginStart",
    onDragOrigin: "dragOrigin",
    onDragOriginEnd: "dragOriginEnd"
  },
  css: [`:host[data-able-origindraggable] .control.origin {
    pointer-events: auto;
}`],
  dragControlCondition: function(a, s) {
    return s.isRequest ? s.requestAble === "originDraggable" : hasClass(s.inputEvent.target, prefix$1("origin"));
  },
  dragControlStart: function(a, s) {
    var $ = s.datas;
    setDragStart(a, s);
    var _ = fillParams(a, s, {
      dragStart: Draggable.dragStart(a, new CustomGesto().dragStart([0, 0], s))
    }), _e = triggerEvent(a, "onDragOriginStart", _);
    return $.startOrigin = a.state.transformOrigin, $.startTargetOrigin = a.state.targetOrigin, $.prevOrigin = [0, 0], $.isDragOrigin = !0, _e === !1 ? ($.isDragOrigin = !1, !1) : _;
  },
  dragControl: function(a, s) {
    var $ = s.datas, _ = s.isPinch, _e = s.isRequest;
    if (!$.isDragOrigin)
      return !1;
    var tt = getDragDist(s), nt = tt[0], at = tt[1], ot = a.state, rt = ot.width, st = ot.height, lt = ot.offsetMatrix, et = ot.targetMatrix, it = ot.is3d, ut = a.props.originRelative, ft = ut === void 0 ? !0 : ut, ht = it ? 4 : 3, dt = [nt, at];
    if (_e) {
      var gt = s.distOrigin;
      (gt[0] || gt[1]) && (dt = gt);
    }
    var pt = plus($.startOrigin, dt), mt = plus($.startTargetOrigin, dt), ct = minus(dt, $.prevOrigin), vt = getNextMatrix(lt, et, pt, ht), At = a.getRect(), xt = getRect(calculatePoses(vt, rt, st, ht)), bt = [At.left - xt.left, At.top - xt.top];
    $.prevOrigin = dt;
    var Et = [convertCSSSize(mt[0], rt, ft), convertCSSSize(mt[1], st, ft)].join(" "), St = fillParams(a, s, {
      width: rt,
      height: st,
      origin: pt,
      dist: dt,
      delta: ct,
      transformOrigin: Et,
      drag: Draggable.drag(a, setCustomDrag(s, a.state, bt, !!_, !1))
    });
    return triggerEvent(a, "onDragOrigin", St), St;
  },
  dragControlEnd: function(a, s) {
    var $ = s.datas;
    return $.isDragOrigin ? (triggerEvent(a, "onDragOriginEnd", fillEndParams(a, s, {})), !0) : !1;
  },
  dragGroupControlCondition: function(a, s) {
    return this.dragControlCondition(a, s);
  },
  dragGroupControlStart: function(a, s) {
    var $ = this.dragControlStart(a, s);
    return !!$;
  },
  dragGroupControl: function(a, s) {
    var $ = this.dragControl(a, s);
    return $ ? (a.transformOrigin = $.transformOrigin, !0) : !1;
  },
  /**
  * @method Moveable.OriginDraggable#request
  * @param {object} e - the OriginDraggable's request parameter
  * @param {number} [e.x] - x position
  * @param {number} [e.y] - y position
  * @param {number} [e.deltaX] - x number to move
  * @param {number} [e.deltaY] - y number to move
  * @param {array} [e.deltaOrigin] - left, top number to move transform-origin
  * @param {array} [e.origin] - transform-origin position
  * @param {number} [e.isInstant] - Whether to execute the request instantly
  * @return {Moveable.Requester} Moveable Requester
  * @example
   * // Instantly Request (requestStart - request - requestEnd)
  * // Use Relative Value
  * moveable.request("originDraggable", { deltaX: 10, deltaY: 10 }, true);
  * // Use Absolute Value
  * moveable.request("originDraggable", { x: 200, y: 100 }, true);
  * // Use Transform Value
  * moveable.request("originDraggable", { deltaOrigin: [10, 0] }, true);
  * moveable.request("originDraggable", { origin: [100, 0] }, true);
  * // requestStart
  * const requester = moveable.request("originDraggable");
  *
  * // request
  * // Use Relative Value
  * requester.request({ deltaX: 10, deltaY: 10 });
  * requester.request({ deltaX: 10, deltaY: 10 });
  * requester.request({ deltaX: 10, deltaY: 10 });
  * // Use Absolute Value
  * moveable.request("originDraggable", { x: 200, y: 100 });
  * moveable.request("originDraggable", { x: 220, y: 100 });
  * moveable.request("originDraggable", { x: 240, y: 100 });
  *
  * // requestEnd
  * requester.requestEnd();
  */
  request: function(a) {
    var s = {}, $ = a.getRect(), _ = 0, _e = 0, tt = $.transformOrigin, nt = [0, 0];
    return {
      isControl: !0,
      requestStart: function() {
        return {
          datas: s
        };
      },
      request: function(at) {
        return "deltaOrigin" in at ? (nt[0] += at.deltaOrigin[0], nt[1] += at.deltaOrigin[1]) : "origin" in at ? (nt[0] = at.origin[0] - tt[0], nt[1] = at.origin[1] - tt[1]) : ("x" in at ? _ = at.x - $.left : "deltaX" in at && (_ += at.deltaX), "y" in at ? _e = at.y - $.top : "deltaY" in at && (_e += at.deltaY)), {
          datas: s,
          distX: _,
          distY: _e,
          distOrigin: nt
        };
      },
      requestEnd: function() {
        return {
          datas: s,
          isDrag: !0
        };
      }
    };
  }
};
function addBorderRadius(a, s, $, _, _e, tt, nt) {
  var at = splitRadiusPoses(a), ot = at.horizontals, rt = at.verticals, st = ot.length, lt = rt.length, et = -1, it = -1;
  $ === 0 ? st === 0 ? et = 0 : st === 1 && (et = 1) : $ === 3 && (st <= 2 ? et = 2 : st <= 3 && (et = 3)), $ === 2 ? lt === 0 ? it = 0 : lt < 4 && (it = 3) : $ === 1 && (lt <= 1 ? it = 1 : lt <= 2 && (it = 2)), addRadiusPos(a, s, 0, et, it, _, _e, tt, nt);
}
function getBorderRadius(a, s, $, _, _e) {
  _ === void 0 && (_ = [0, 0]);
  var tt, nt = [];
  if (_e)
    tt = _e;
  else {
    var at = getComputedStyle$1(a);
    tt = at && at.borderRadius || "";
  }
  return !tt || !_e && tt === "0px" ? nt = [] : nt = splitSpace(tt), getRadiusValues(nt, s, $, 0, 0, _);
}
function triggerRoundEvent(a, s, $, _, _e, tt) {
  var nt = a.state, at = nt.width, ot = nt.height, rt = getRadiusStyles(tt, _e, a.props.roundRelative, at, ot), st = rt.raws, lt = rt.styles, et = splitRadiusPoses(_e, st), it = et.horizontals, ut = et.verticals, ft = lt.join(" ");
  nt.borderRadiusState = ft, triggerEvent(a, "onRound", fillParams(a, s, {
    horizontals: it,
    verticals: ut,
    borderRadius: ft,
    width: at,
    height: ot,
    delta: _,
    dist: $
  }));
}
var Roundable = {
  name: "roundable",
  props: {
    roundable: Boolean,
    roundRelative: Boolean,
    minRoundControls: Array,
    maxRoundControls: Array,
    roundClickable: Boolean
  },
  events: {
    onRoundStart: "roundStart",
    onRound: "round",
    onRoundEnd: "roundEnd"
  },
  css: [`.control.border-radius {
    background: #d66;
    cursor: pointer;
}`, `:host[data-able-roundable] .line.direction {
    cursor: pointer;
}`],
  render: function(a, s) {
    var $ = a.state, _ = $.target, _e = $.width, tt = $.height, nt = $.allMatrix, at = $.is3d, ot = $.left, rt = $.top, st = $.borderRadiusState, lt = a.props, et = lt.minRoundControls, it = et === void 0 ? [0, 0] : et, ut = lt.maxRoundControls, ft = ut === void 0 ? [4, 4] : ut, ht = lt.zoom;
    if (!_)
      return null;
    var dt = at ? 4 : 3, gt = getBorderRadius(_, _e, tt, it, st);
    if (!gt)
      return null;
    var pt = 0, mt = 0;
    return gt.map(function(ct, vt) {
      mt += Math.abs(ct.horizontal), pt += Math.abs(ct.vertical);
      var At = minus(calculatePosition(nt, ct.pos, dt), [ot, rt]), xt = ct.vertical ? pt <= ft[1] : mt <= ft[0];
      return s.createElement("div", {
        key: "borderRadiusControl" + vt,
        className: prefix$1("control", "border-radius"),
        "data-radius-index": vt,
        style: {
          display: xt ? "block" : "none",
          transform: "translate(" + At[0] + "px, " + At[1] + "px) scale(" + ht + ")"
        }
      });
    });
  },
  dragControlCondition: function(a, s) {
    if (!s.inputEvent || s.isRequest)
      return !1;
    var $ = s.inputEvent.target.getAttribute("class") || "";
    return $.indexOf("border-radius") > -1 || $.indexOf("moveable-line") > -1 && $.indexOf("moveable-direction") > -1;
  },
  dragControlStart: function(a, s) {
    var $ = s.inputEvent, _ = s.datas, _e = $.target, tt = _e.getAttribute("class") || "", nt = tt.indexOf("border-radius") > -1, at = tt.indexOf("moveable-line") > -1 && tt.indexOf("moveable-direction") > -1, ot = nt ? parseInt(_e.getAttribute("data-radius-index"), 10) : -1, rt = at ? parseInt(_e.getAttribute("data-line-index"), 10) : -1;
    if (!nt && !at)
      return !1;
    var st = triggerEvent(a, "onRoundStart", fillParams(a, s, {}));
    if (st === !1)
      return !1;
    _.lineIndex = rt, _.controlIndex = ot, _.isControl = nt, _.isLine = at, setDragStart(a, s);
    var lt = a.props, et = lt.roundRelative, it = lt.minRoundControls, ut = it === void 0 ? [0, 0] : it, ft = a.state, ht = ft.target, dt = ft.width, gt = ft.height;
    _.isRound = !0, _.prevDist = [0, 0];
    var pt = getBorderRadius(ht, dt, gt, ut) || [];
    return _.controlPoses = pt, ft.borderRadiusState = getRadiusStyles(pt.map(function(mt) {
      return mt.pos;
    }), pt, et, dt, gt).styles.join(" "), !0;
  },
  dragControl: function(a, s) {
    var $ = s.datas;
    if (!$.isRound || !$.isControl || !$.controlPoses.length)
      return !1;
    var _ = $.controlIndex, _e = $.controlPoses, tt = getDragDist(s), nt = tt[0], at = tt[1], ot = [nt, at], rt = minus(ot, $.prevDist), st = a.props.maxRoundControls, lt = st === void 0 ? [4, 4] : st, et = a.state, it = et.width, ut = et.height, ft = _e[_], ht = ft.vertical, dt = ft.horizontal, gt = _e.map(function(mt) {
      var ct = mt.horizontal, vt = mt.vertical, At = [ct * dt * ot[0], vt * ht * ot[1]];
      if (ct) {
        if (lt[0] === 1)
          return At;
        if (lt[0] < 4 && ct !== dt)
          return At;
      } else {
        if (lt[1] === 0)
          return At[1] = vt * dt * ot[0] / it * ut, At;
        if (ht) {
          if (lt[1] === 1)
            return At;
          if (lt[1] < 4 && vt !== ht)
            return At;
        }
      }
      return [0, 0];
    });
    gt[_] = ot;
    var pt = _e.map(function(mt, ct) {
      return plus(mt.pos, gt[ct]);
    });
    return $.prevDist = [nt, at], triggerRoundEvent(a, s, ot, rt, _e, pt), !0;
  },
  dragControlEnd: function(a, s) {
    var $ = a.state;
    $.borderRadiusState = "";
    var _ = s.datas, _e = s.isDouble;
    if (!_.isRound)
      return !1;
    var tt = $.width, nt = $.height, at = _.isControl, ot = _.controlIndex, rt = _.isLine, st = _.lineIndex, lt = _.controlPoses, et = lt.map(function(pt) {
      return pt.pos;
    }), it = et.length, ut = a.props.roundClickable, ft = ut === void 0 ? !0 : ut;
    if (_e && ft) {
      if (at)
        removeRadiusPos(lt, et, ot, 0);
      else if (rt) {
        var ht = calculatePointerDist(a, s), dt = ht[0], gt = ht[1];
        addBorderRadius(lt, et, st, dt, gt, tt, nt);
      }
      it !== lt.length && triggerRoundEvent(a, s, [0, 0], [0, 0], lt, et);
    }
    return triggerEvent(a, "onRoundEnd", fillEndParams(a, s, {})), $.borderRadiusState = "", !0;
  },
  unset: function(a) {
    a.state.borderRadiusState = "";
  }
}, BeforeRenderable = {
  isPinch: !0,
  name: "beforeRenderable",
  props: {},
  events: {
    onBeforeRenderStart: "beforeRenderStart",
    onBeforeRender: "beforeRender",
    onBeforeRenderEnd: "beforeRenderEnd",
    onBeforeRenderGroupStart: "beforeRenderGroupStart",
    onBeforeRenderGroup: "beforeRenderGroup",
    onBeforeRenderGroupEnd: "beforeRenderGroupEnd"
  },
  setTransform: function(a, s) {
    var $ = a.state, _ = $.is3d, _e = $.target, tt = $.targetMatrix, nt = _e == null ? void 0 : _e.style.transform, at = _ ? "matrix3d(" + tt.join(",") + ")" : "matrix(" + convertMatrixtoCSS(tt, !0) + ")";
    s.datas.startTransforms = !nt || nt === "none" ? [at] : splitSpace(nt);
  },
  resetTransform: function(a, s) {
    s.datas.nextTransforms = s.datas.startTransforms, s.datas.nextTransformAppendedIndexes = [];
  },
  fillDragStartParams: function(a, s) {
    return fillParams(a, s, {
      setTransform: function($) {
        s.datas.startTransforms = isArray($) ? $ : splitSpace($);
      },
      isPinch: !!s.isPinch
    });
  },
  fillDragParams: function(a, s) {
    return fillParams(a, s, {
      isPinch: !!s.isPinch
    });
  },
  dragStart: function(a, s) {
    this.setTransform(a, s), triggerEvent(a, "onBeforeRenderStart", this.fillDragStartParams(a, s));
  },
  drag: function(a, s) {
    this.resetTransform(a, s), triggerEvent(a, "onBeforeRender", fillParams(a, s, {
      isPinch: !!s.isPinch
    }));
  },
  dragEnd: function(a, s) {
    triggerEvent(a, "onBeforeRenderEnd", fillParams(a, s, {
      isPinch: !!s.isPinch,
      isDrag: s.isDrag
    }));
  },
  dragGroupStart: function(a, s) {
    var $ = this;
    this.dragStart(a, s);
    var _ = fillChildEvents(a, "beforeRenderable", s), _e = a.moveables, tt = _.map(function(nt, at) {
      var ot = _e[at];
      return $.setTransform(ot, nt), $.fillDragStartParams(ot, nt);
    });
    triggerEvent(a, "onBeforeRenderGroupStart", fillParams(a, s, {
      isPinch: !!s.isPinch,
      targets: a.props.targets,
      setTransform: function() {
      },
      events: tt
    }));
  },
  dragGroup: function(a, s) {
    var $ = this;
    this.drag(a, s);
    var _ = fillChildEvents(a, "beforeRenderable", s), _e = a.moveables, tt = _.map(function(nt, at) {
      var ot = _e[at];
      return $.resetTransform(ot, nt), $.fillDragParams(ot, nt);
    });
    triggerEvent(a, "onBeforeRenderGroup", fillParams(a, s, {
      isPinch: !!s.isPinch,
      targets: a.props.targets,
      events: tt
    }));
  },
  dragGroupEnd: function(a, s) {
    this.dragEnd(a, s), triggerEvent(a, "onBeforeRenderGroupEnd", fillParams(a, s, {
      isPinch: !!s.isPinch,
      isDrag: s.isDrag,
      targets: a.props.targets
    }));
  },
  dragControlStart: function(a, s) {
    return this.dragStart(a, s);
  },
  dragControl: function(a, s) {
    return this.drag(a, s);
  },
  dragControlEnd: function(a, s) {
    return this.dragEnd(a, s);
  },
  dragGroupControlStart: function(a, s) {
    return this.dragGroupStart(a, s);
  },
  dragGroupControl: function(a, s) {
    return this.dragGroup(a, s);
  },
  dragGroupControlEnd: function(a, s) {
    return this.dragGroupEnd(a, s);
  }
}, Renderable = {
  name: "renderable",
  props: {},
  events: {
    onRenderStart: "renderStart",
    onRender: "render",
    onRenderEnd: "renderEnd",
    onRenderGroupStart: "renderGroupStart",
    onRenderGroup: "renderGroup",
    onRenderGroupEnd: "renderGroupEnd"
  },
  dragStart: function(a, s) {
    triggerEvent(a, "onRenderStart", fillParams(a, s, {
      isPinch: !!s.isPinch
    }));
  },
  drag: function(a, s) {
    triggerEvent(a, "onRender", fillParams(a, s, {
      isPinch: !!s.isPinch
    }));
  },
  dragEnd: function(a, s) {
    triggerEvent(a, "onRenderEnd", fillParams(a, s, {
      isPinch: !!s.isPinch,
      isDrag: s.isDrag
    }));
  },
  dragGroupStart: function(a, s) {
    triggerEvent(a, "onRenderGroupStart", fillParams(a, s, {
      isPinch: !!s.isPinch,
      targets: a.props.targets
    }));
  },
  dragGroup: function(a, s) {
    triggerEvent(a, "onRenderGroup", fillParams(a, s, {
      isPinch: !!s.isPinch,
      targets: a.props.targets
    }));
  },
  dragGroupEnd: function(a, s) {
    triggerEvent(a, "onRenderGroupEnd", fillParams(a, s, {
      isPinch: !!s.isPinch,
      isDrag: s.isDrag,
      targets: a.props.targets
    }));
  },
  dragControlStart: function(a, s) {
    return this.dragStart(a, s);
  },
  dragControl: function(a, s) {
    return this.drag(a, s);
  },
  dragControlEnd: function(a, s) {
    return this.dragEnd(a, s);
  },
  dragGroupControlStart: function(a, s) {
    return this.dragGroupStart(a, s);
  },
  dragGroupControl: function(a, s) {
    return this.dragGroup(a, s);
  },
  dragGroupControlEnd: function(a, s) {
    return this.dragGroupEnd(a, s);
  }
};
function triggerAble(a, s, $, _, _e, tt, nt) {
  var at = _e === "Start", ot = a.state.target, rt = tt.isRequest;
  if (!ot || at && _.indexOf("Control") > -1 && !rt && a.areaElement === tt.inputEvent.target)
    return !1;
  var st = "" + $ + _ + _e, lt = "" + $ + _ + "Condition", et = _e === "End", it = _e.indexOf("After") > -1, ut = at && (!a.targetGesto || !a.controlGesto || !a.targetGesto.isFlag() || !a.controlGesto.isFlag());
  ut && a.updateRect(_e, !0, !1), _e === "" && !it && !rt && convertDragDist(a.state, tt);
  var ft = __spreadArrays([BeforeRenderable], a[s], [Renderable]);
  if (rt) {
    var ht = tt.requestAble;
    ft.some(function(xt) {
      return xt.name === ht;
    }) || ft.push.apply(ft, a.props.ables.filter(function(xt) {
      return xt.name === ht;
    }));
  }
  if (!ft.length)
    return !1;
  var dt = ft.filter(function(xt) {
    return xt[st];
  }), gt = tt.datas;
  ut && dt.forEach(function(xt) {
    xt.unset && xt.unset(a);
  });
  var pt = tt.inputEvent, mt;
  et && pt && (mt = document.elementFromPoint(tt.clientX, tt.clientY) || pt.target);
  var ct = dt.filter(function(xt) {
    var bt = xt.name, Et = gt[bt] || (gt[bt] = {});
    return at && (Et.isEventStart = !xt[lt] || xt[lt](a, tt)), Et.isEventStart ? xt[st](a, __assign$1(__assign$1({}, tt), {
      datas: Et,
      originalDatas: gt,
      inputTarget: mt
    })) : !1;
  }), vt = ct.length, At = at && dt.length && !vt;
  return (et || At) && (a.state.gesto = null, a.moveables && a.moveables.forEach(function(xt) {
    xt.state.gesto = null;
  })), ut && At && dt.forEach(function(xt) {
    xt.unset && xt.unset(a);
  }), a.isUnmounted || At ? !1 : ((!at && vt && !nt || et) && (a.updateRect(_e, !0, !1), a.forceUpdate()), !at && !et && !it && vt && !nt && triggerAble(a, s, $, _, _e + "After", tt), !0);
}
function getTargetAbleGesto(a, s, $) {
  var _ = a.controlBox.getElement(), _e = [];
  _e.push(_), (!a.props.dragArea || a.props.dragTarget) && _e.push(s);
  var tt = function(nt) {
    var at = nt.inputEvent.target, ot = a.areaElement;
    return at === ot || !a.isMoveableElement(at) || hasClass(at, "moveable-area") || hasClass(at, "moveable-padding");
  };
  return getAbleGesto(a, _e, "targetAbles", $, {
    dragStart: tt,
    pinchStart: tt
  });
}
function getAbleGesto(a, s, $, _, _e) {
  _e === void 0 && (_e = {});
  var tt = a.props, nt = tt.pinchOutside, at = tt.pinchThreshold, ot = {
    container: window,
    pinchThreshold: at,
    pinchOutside: nt
  }, rt = new Gesto(s, ot);
  return ["drag", "pinch"].forEach(function(st) {
    ["Start", "", "End"].forEach(function(lt) {
      rt.on("" + st + lt, function(et) {
        var it = et.eventType;
        if (_e[it] && !_e[it](et)) {
          et.stop();
          return;
        }
        var ut = triggerAble(a, $, st, _, lt, et);
        ut || et.stop();
      });
    });
  }), rt;
}
var EventManager = /* @__PURE__ */ function() {
  function a($, _, _e) {
    var tt = this;
    this.target = $, this.moveable = _, this.eventName = _e, this.ables = [], this.onEvent = function(nt) {
      var at = tt.eventName, ot = tt.moveable;
      ot.state.disableNativeEvent || tt.ables.forEach(function(rt) {
        rt[at](ot, {
          inputEvent: nt
        });
      });
    }, this.target.addEventListener(this.eventName.toLowerCase(), this.onEvent);
  }
  var s = a.prototype;
  return s.setAbles = function($) {
    this.ables = $;
  }, s.destroy = function() {
    this.target.removeEventListener(this.eventName.toLowerCase(), this.onEvent), this.target = null, this.moveable = null;
  }, a;
}(), MoveableManager = /* @__PURE__ */ function(a) {
  __extends$2(s, a);
  function s() {
    var _ = a !== null && a.apply(this, arguments) || this;
    return _.state = __assign$1({
      container: null,
      gesto: null,
      renderPoses: [[0, 0], [0, 0], [0, 0], [0, 0]],
      disableNativeEvent: !1
    }, getTargetInfo(null)), _.enabledAbles = [], _.targetAbles = [], _.controlAbles = [], _.rotation = 0, _.scale = [1, 1], _.isUnmounted = !1, _.events = {
      mouseEnter: null,
      mouseLeave: null
    }, _.onPreventClick = function(_e) {
      _e.stopPropagation(), removeEvent(window, "click", _.onPreventClick, !0);
    }, _;
  }
  var $ = s.prototype;
  return $.render = function() {
    var _ = this.props, _e = this.state, tt = _.parentPosition, nt = _.className, at = _.target, ot = _.zoom, rt = _.cspNonce, st = _.translateZ, lt = _.cssStyled, et = _.portalContainer;
    this.checkUpdate(), this.updateRenderPoses();
    var it = tt || {
      left: 0,
      top: 0
    }, ut = it.left, ft = it.top, ht = _e.left, dt = _e.top, gt = _e.target, pt = _e.direction, mt = _.targets, ct = (mt && mt.length || at) && gt, vt = this.isDragging(), At = {};
    return this.getEnabledAbles().forEach(function(xt) {
      At["data-able-" + xt.name.toLowerCase()] = !0;
    }), reactExports.createElement(lt, __assign$1({
      cspNonce: rt,
      ref: ref(this, "controlBox"),
      className: prefix$1("control-box", pt === -1 ? "reverse" : "", vt ? "dragging" : "") + " " + nt
    }, At, {
      onClick: this.onPreventClick,
      portalContainer: et,
      style: {
        position: "absolute",
        display: ct ? "block" : "none",
        transform: "translate3d(" + (ht - ut) + "px, " + (dt - ft) + "px, " + st + ")",
        "--zoom": ot,
        "--zoompx": ot + "px"
      }
    }), this.renderAbles(), this._renderLines());
  }, $.componentDidMount = function() {
    this.controlBox.getElement();
    var _ = this.props, _e = _.parentMoveable, tt = _.container, nt = _.wrapperMoveable;
    this.updateEvent(_), this.updateNativeEvents(_), !tt && !_e && !nt && this.updateRect("", !1, !0), this.updateCheckInput();
  }, $.componentDidUpdate = function(_) {
    this.updateNativeEvents(_), this.updateEvent(_), this.updateCheckInput();
  }, $.componentWillUnmount = function() {
    this.isUnmounted = !0, unset(this, "targetGesto"), unset(this, "controlGesto");
    var _ = this.events;
    for (var _e in _) {
      var tt = _[_e];
      tt && tt.destroy();
    }
  }, $.getContainer = function() {
    var _ = this.props, _e = _.parentMoveable, tt = _.wrapperMoveable, nt = _.container;
    return nt || tt && tt.getContainer() || _e && _e.getContainer() || this.controlBox.getElement().parentElement;
  }, $.isMoveableElement = function(_) {
    return _ && (_.getAttribute("class") || "").indexOf(PREFIX) > -1;
  }, $.dragStart = function(_) {
    return this.targetGesto && this.targetGesto.triggerDragStart(_), this;
  }, $.hitTest = function(_) {
    var _e = this.state, tt = _e.target, nt = _e.pos1, at = _e.pos2, ot = _e.pos3, rt = _e.pos4, st = _e.targetClientRect;
    if (!tt)
      return 0;
    var lt;
    if (_ instanceof Element) {
      var et = _.getBoundingClientRect();
      lt = {
        left: et.left,
        top: et.top,
        width: et.width,
        height: et.height
      };
    } else
      lt = __assign$1({
        width: 0,
        height: 0
      }, _);
    var it = lt.left, ut = lt.top, ft = lt.width, ht = lt.height, dt = fitPoints([nt, at, rt, ot], st), gt = getOverlapSize(dt, [[it, ut], [it + ft, ut], [it + ft, ut + ht], [it, ut + ht]]), pt = getAreaSize(dt);
    return !gt || !pt ? 0 : Math.min(100, gt / pt * 100);
  }, $.isInside = function(_, _e) {
    var tt = this.state, nt = tt.target, at = tt.pos1, ot = tt.pos2, rt = tt.pos3, st = tt.pos4, lt = tt.targetClientRect;
    return nt ? isInside([_, _e], fitPoints([at, ot, st, rt], lt)) : !1;
  }, $.updateRect = function(_, _e, tt) {
    tt === void 0 && (tt = !0);
    var nt = this.props, at = nt.parentMoveable, ot = this.state, rt = ot.target || this.props.target, st = this.getContainer(), lt = at ? at.props.rootContainer : nt.rootContainer;
    this.updateState(getTargetInfo(this.controlBox && this.controlBox.getElement(), rt, st, st, lt || st), at ? !1 : tt);
  }, $.isTargetChanged = function(_, _e) {
    var tt = this.props, nt = tt.dragTarget || tt.target, at = _.dragTarget || _.target, ot = tt.dragArea, rt = _.dragArea, st = !ot && at !== nt;
    return st || (_e || ot) && rt !== ot;
  }, $.updateNativeEvents = function(_) {
    var _e = this, tt = this.props, nt = tt.dragArea ? this.areaElement : this.state.target, at = this.events, ot = getKeys(at);
    if (this.isTargetChanged(_))
      for (var rt in at) {
        var st = at[rt];
        st && st.destroy(), at[rt] = null;
      }
    if (nt) {
      var lt = this.enabledAbles;
      ot.forEach(function(et) {
        var it = filterAbles(lt, [et]), ut = it.length > 0, ft = at[et];
        if (!ut) {
          ft && (ft.destroy(), at[et] = null);
          return;
        }
        ft || (ft = new EventManager(nt, _e, et), at[et] = ft), ft.setAbles(it);
      });
    }
  }, $.updateEvent = function(_) {
    var _e = this.controlBox.getElement(), tt = this.targetAbles.length, nt = this.controlAbles.length, at = this.props, ot = at.dragTarget || at.target, rt = this.isTargetChanged(_, !0), st = !tt && this.targetGesto || rt;
    st && (unset(this, "targetGesto"), this.updateState({
      gesto: null
    })), nt || unset(this, "controlGesto"), ot && tt && !this.targetGesto && (this.targetGesto = getTargetAbleGesto(this, ot, "")), !this.controlGesto && nt && (this.controlGesto = getAbleGesto(this, _e, "controlAbles", "Control")), st && this.unsetAbles();
  }, $.isDragging = function() {
    return (this.targetGesto ? this.targetGesto.isFlag() : !1) || (this.controlGesto ? this.controlGesto.isFlag() : !1);
  }, $.updateTarget = function(_) {
    this.updateRect(_, !0);
  }, $.getRect = function() {
    var _ = this.state, _e = getAbsolutePosesByState(this.state), tt = _e[0], nt = _e[1], at = _e[2], ot = _e[3], rt = getRect(_e), st = _.width, lt = _.height, et = rt.width, it = rt.height, ut = rt.left, ft = rt.top, ht = [_.left, _.top], dt = plus(ht, _.origin), gt = plus(ht, _.beforeOrigin), pt = _.transformOrigin;
    return {
      width: et,
      height: it,
      left: ut,
      top: ft,
      pos1: tt,
      pos2: nt,
      pos3: at,
      pos4: ot,
      offsetWidth: st,
      offsetHeight: lt,
      beforeOrigin: gt,
      origin: dt,
      transformOrigin: pt,
      rotation: this.getRotation()
    };
  }, $.getManager = function() {
    return this;
  }, $.getRotation = function() {
    var _ = this.state, _e = _.pos1, tt = _.pos2, nt = _.direction;
    return getAbsoluteRotation(_e, tt, nt);
  }, $.request = function(_, _e, tt) {
    _e === void 0 && (_e = {});
    var nt = this.props, at = nt.ables, ot = nt.groupable, rt = at.filter(function(ht) {
      return ht.name === _;
    })[0];
    if (this.isDragging() || !rt || !rt.request)
      return {
        request: function() {
          return this;
        },
        requestEnd: function() {
          return this;
        }
      };
    var st = this, lt = rt.request(this), et = tt || _e.isInstant, it = lt.isControl ? "controlAbles" : "targetAbles", ut = (ot ? "Group" : "") + (lt.isControl ? "Control" : ""), ft = {
      request: function(ht) {
        return triggerAble(st, it, "drag", ut, "", __assign$1(__assign$1({}, lt.request(ht)), {
          requestAble: _,
          isRequest: !0
        }), et), this;
      },
      requestEnd: function() {
        return triggerAble(st, it, "drag", ut, "End", __assign$1(__assign$1({}, lt.requestEnd()), {
          requestAble: _,
          isRequest: !0
        }), et), this;
      }
    };
    return triggerAble(st, it, "drag", ut, "Start", __assign$1(__assign$1({}, lt.requestStart(_e)), {
      requestAble: _,
      isRequest: !0
    }), et), et ? ft.request(_e).requestEnd() : ft;
  }, $.destroy = function() {
    this.componentWillUnmount();
  }, $.updateRenderPoses = function() {
    var _ = this.state, _e = this.props, tt = _.originalBeforeOrigin, nt = _.transformOrigin, at = _.allMatrix, ot = _.is3d, rt = _.pos1, st = _.pos2, lt = _.pos3, et = _.pos4, it = _.left, ut = _.top, ft = _e.padding || {}, ht = ft.left, dt = ht === void 0 ? 0 : ht, gt = ft.top, pt = gt === void 0 ? 0 : gt, mt = ft.bottom, ct = mt === void 0 ? 0 : mt, vt = ft.right, At = vt === void 0 ? 0 : vt, xt = ot ? 4 : 3, bt = _e.groupable ? tt : plus(tt, [it, ut]);
    _.renderPoses = [plus(rt, calculatePadding(at, [-dt, -pt], nt, bt, xt)), plus(st, calculatePadding(at, [At, -pt], nt, bt, xt)), plus(lt, calculatePadding(at, [-dt, ct], nt, bt, xt)), plus(et, calculatePadding(at, [At, ct], nt, bt, xt))];
  }, $.checkUpdate = function() {
    var _ = this.props, _e = _.target, tt = _.container, nt = _.parentMoveable, at = this.state, ot = at.target, rt = at.container;
    if (!(!ot && !_e)) {
      this.updateAbles();
      var st = !equals(ot, _e) || !equals(rt, tt);
      st && (this.updateState({
        target: _e,
        container: tt
      }), !nt && (tt || this.controlBox) && this.updateRect("End", !1, !1));
    }
  }, $.triggerEvent = function(_, _e) {
    var tt = this.props[_];
    return tt && tt(_e);
  }, $.useCSS = function(_, _e) {
    var tt = this.props.customStyledMap, nt = _ + _e;
    return tt[nt] || (tt[nt] = defaultStyled(_, _e)), tt[nt];
  }, $.unsetAbles = function() {
    var _ = this;
    this.targetAbles.filter(function(_e) {
      return _e.unset ? (_e.unset(_), !0) : !1;
    }).length && this.forceUpdate();
  }, $.updateAbles = function(_, _e) {
    _ === void 0 && (_ = this.props.ables), _e === void 0 && (_e = "");
    var tt = this.props, nt = tt.triggerAblesSimultaneously, at = _.filter(function(it) {
      return it && (it.always || tt[it.name]);
    }), ot = "drag" + _e + "Start", rt = "pinch" + _e + "Start", st = "drag" + _e + "ControlStart", lt = filterAbles(at, [ot, rt], nt), et = filterAbles(at, [st], nt);
    this.enabledAbles = at, this.targetAbles = lt, this.controlAbles = et;
  }, $.updateState = function(_, _e) {
    if (_e)
      this.setState(_);
    else {
      var tt = this.state;
      for (var nt in _)
        tt[nt] = _[nt];
    }
  }, $.getEnabledAbles = function() {
    var _ = this.props, _e = _.ables;
    return _e.filter(function(tt) {
      return tt && _[tt.name];
    });
  }, $.renderAbles = function() {
    var _ = this, _e = this.props, tt = _e.triggerAblesSimultaneously, nt = {
      createElement: reactExports.createElement
    };
    return groupByMap(flat(filterAbles(this.getEnabledAbles(), ["render"], tt).map(function(at) {
      var ot = at.render;
      return ot(_, nt) || [];
    })).filter(function(at) {
      return at;
    }), function(at) {
      var ot = at.key;
      return ot;
    }).map(function(at) {
      return at[0];
    });
  }, $.updateCheckInput = function() {
    this.targetGesto && (this.targetGesto.options.checkInput = this.props.checkInput);
  }, $._renderLines = function() {
    var _ = this.props, _e = _.edge, tt = _.zoom, nt = _.hideDefaultLines;
    if (nt)
      return [];
    var at = this.state.renderPoses, ot = {
      createElement: reactExports.createElement
    };
    return [renderLine(ot, _e ? "n" : "", at[0], at[1], tt, 0), renderLine(ot, _e ? "e" : "", at[1], at[3], tt, 1), renderLine(ot, _e ? "w" : "", at[0], at[2], tt, 2), renderLine(ot, _e ? "s" : "", at[2], at[3], tt, 3)];
  }, s.defaultProps = {
    target: null,
    dragTarget: null,
    container: null,
    rootContainer: null,
    origin: !0,
    edge: !1,
    parentMoveable: null,
    wrapperMoveable: null,
    parentPosition: null,
    portalContainer: null,
    ables: [],
    pinchThreshold: 20,
    dragArea: !1,
    passDragArea: !1,
    transformOrigin: "",
    className: "",
    zoom: 1,
    triggerAblesSimultaneously: !1,
    padding: {},
    pinchOutside: !0,
    checkInput: !1,
    groupable: !1,
    hideDefaultLines: !1,
    cspNonce: "",
    translateZ: 0,
    cssStyled: null,
    customStyledMap: {},
    props: {}
  }, s;
}(reactExports.PureComponent), Groupable = {
  name: "groupable",
  props: {
    defaultGroupRotate: Number,
    defaultGroupOrigin: String,
    groupable: Boolean
  },
  events: {},
  render: function(a, s) {
    var $ = a.props.targets || [];
    a.moveables = [];
    var _ = a.state, _e = _.left, tt = _.top, nt = {
      left: _e,
      top: tt
    };
    return $.map(function(at, ot) {
      return s.createElement(MoveableManager, {
        key: "moveable" + ot,
        ref: refs(a, "moveables", ot),
        target: at,
        origin: !1,
        cssStyled: a.props.cssStyled,
        customStyledMap: a.props.customStyledMap,
        parentMoveable: a,
        parentPosition: nt
      });
    });
  }
}, Clickable = makeAble("clickable", {
  props: {},
  events: {
    onClick: "click",
    onClickGroup: "clickGroup"
  },
  always: !0,
  dragStart: function(a, s) {
    s.isRequest || addEvent(window, "click", a.onPreventClick, !0);
  },
  dragControlStart: function(a, s) {
    this.dragStart(a, s);
  },
  dragGroupStart: function(a, s) {
    this.dragStart(a, s), s.datas.inputTarget = s.inputEvent && s.inputEvent.target;
  },
  dragEnd: function(a, s) {
    this.endEvent(a);
    var $ = a.state.target, _ = s.inputEvent, _e = s.inputTarget;
    if (s.isDrag || this.unset(a), !(!_ || !_e || s.isDrag || a.isMoveableElement(_e))) {
      var tt = $.contains(_e);
      triggerEvent(a, "onClick", fillParams(a, s, {
        isDouble: s.isDouble,
        inputTarget: _e,
        isTarget: $ === _e,
        containsTarget: tt
      }));
    }
  },
  dragGroupEnd: function(a, s) {
    this.endEvent(a);
    var $ = s.inputEvent, _ = s.inputTarget;
    if (!(!$ || !_ || s.isDrag || a.isMoveableElement(_) || s.datas.inputTarget === _)) {
      var _e = a.props.targets, tt = _e.indexOf(_), nt = tt > -1, at = !1;
      tt === -1 && (tt = findIndex(_e, function(ot) {
        return ot.contains(_);
      }), at = tt > -1), triggerEvent(a, "onClickGroup", fillParams(a, s, {
        isDouble: s.isDouble,
        targets: _e,
        inputTarget: _,
        targetIndex: tt,
        isTarget: nt,
        containsTarget: at
      }));
    }
  },
  dragControlEnd: function(a) {
    this.endEvent(a);
  },
  dragGroupControlEnd: function(a) {
    this.endEvent(a);
  },
  endEvent: function(a) {
    var s = this;
    requestAnimationFrame(function() {
      s.unset(a);
    });
  },
  unset: function(a) {
    removeEvent(window, "click", a.onPreventClick, !0);
  }
});
function getDraggableEvent(a) {
  var s = a.originalDatas.draggable;
  return s || (a.originalDatas.draggable = {}, s = a.originalDatas.draggable), __assign$1(__assign$1({}, a), {
    datas: s
  });
}
var edgeDraggable = makeAble("edgeDraggable", {
  dragControlCondition: function(a, s) {
    if (!a.props.edgeDraggable || !s.inputEvent)
      return !1;
    var $ = s.inputEvent.target;
    return hasClass($, prefix$1("direction")) && hasClass($, prefix$1("line"));
  },
  dragControlStart: function(a, s) {
    return Draggable.dragStart(a, getDraggableEvent(s));
  },
  dragControl: function(a, s) {
    return Draggable.drag(a, getDraggableEvent(s));
  },
  dragControlEnd: function(a, s) {
    return Draggable.dragEnd(a, getDraggableEvent(s));
  },
  dragGroupControlCondition: function(a, s) {
    if (!a.props.edgeDraggable || !s.inputEvent)
      return !1;
    var $ = s.inputEvent.target;
    return hasClass($, prefix$1("direction")) && hasClass($, prefix$1("line"));
  },
  dragGroupControlStart: function(a, s) {
    return Draggable.dragGroupStart(a, getDraggableEvent(s));
  },
  dragGroupControl: function(a, s) {
    return Draggable.dragGroup(a, getDraggableEvent(s));
  },
  dragGroupControlEnd: function(a, s) {
    return Draggable.dragGroupEnd(a, getDraggableEvent(s));
  },
  unset: function(a) {
    a.state.dragInfo = null;
  }
}), IndividualGroupable = {
  name: "individualGroupable",
  props: {
    individualGroupable: Boolean
  },
  events: {}
}, MOVEABLE_ABLES = [BeforeRenderable, Default, Snappable, Pinchable, Draggable, edgeDraggable, Rotatable, Resizable, Scalable, Warpable, Scrollable, Padding$2, Origin, OriginDraggable, Clippable, Roundable, Groupable, IndividualGroupable, Clickable, DragArea, Renderable];
function getMaxPos(a, s) {
  return Math.max.apply(Math, a.map(function($) {
    var _ = $[0], _e = $[1], tt = $[2], nt = $[3];
    return Math.max(_[s], _e[s], tt[s], nt[s]);
  }));
}
function getMinPos(a, s) {
  return Math.min.apply(Math, a.map(function($) {
    var _ = $[0], _e = $[1], tt = $[2], nt = $[3];
    return Math.min(_[s], _e[s], tt[s], nt[s]);
  }));
}
function getGroupRect(a, s) {
  if (!a.length)
    return [0, 0, 0, 0];
  var $ = a.map(function(ft) {
    var ht = ft.state;
    return getAbsolutePosesByState(ht);
  }), _ = MAX_NUM, _e = MAX_NUM, tt = 0, nt = 0, at = throttle(s, TINY_NUM);
  if (at % 90) {
    var ot = at / 180 * Math.PI, rt = Math.tan(ot), st = -1 / rt, lt = [MIN_NUM, MAX_NUM], et = [MIN_NUM, MAX_NUM];
    $.forEach(function(ft) {
      ft.forEach(function(ht) {
        var dt = ht[1] - rt * ht[0], gt = ht[1] - st * ht[0];
        lt[0] = Math.max(lt[0], dt), lt[1] = Math.min(lt[1], dt), et[0] = Math.max(et[0], gt), et[1] = Math.min(et[1], gt);
      });
    }), lt.forEach(function(ft) {
      et.forEach(function(ht) {
        var dt = (ht - ft) / (rt - st), gt = rt * dt + ft;
        _ = Math.min(_, dt), _e = Math.min(_e, gt);
      });
    });
    var it = $.map(function(ft) {
      var ht = ft[0], dt = ft[1], gt = ft[2], pt = ft[3];
      return [rotate(ht, -ot), rotate(dt, -ot), rotate(gt, -ot), rotate(pt, -ot)];
    });
    tt = getMaxPos(it, 0) - getMinPos(it, 0), nt = getMaxPos(it, 1) - getMinPos(it, 1);
  } else if (_ = getMinPos($, 0), _e = getMinPos($, 1), tt = getMaxPos($, 0) - _, nt = getMaxPos($, 1) - _e, at % 180) {
    var ut = tt;
    tt = nt, nt = ut;
  }
  return [_, _e, tt, nt];
}
var MoveableGroup = /* @__PURE__ */ function(a) {
  __extends$2(s, a);
  function s() {
    var _ = a !== null && a.apply(this, arguments) || this;
    return _.differ = new ChildrenDiffer$1(), _.moveables = [], _.transformOrigin = "50% 50%", _;
  }
  var $ = s.prototype;
  return $.updateEvent = function(_) {
    var _e = this.state, tt = this.props, nt = _.dragTarget || _e.target, at = tt.dragTarget || this.areaElement;
    nt !== at && (unset(this, "targetGesto"), unset(this, "controlGesto"), _e.target = null), _e.target || (_e.target = this.areaElement, this.controlBox.getElement().style.display = "block", this.targetGesto = getTargetAbleGesto(this, at, "Group"), this.controlGesto = getAbleGesto(this, this.controlBox.getElement(), "controlAbles", "GroupControl"));
    var ot = !equals(_.container, tt.container);
    ot && (_e.container = tt.container);
    var rt = this.differ.update(tt.targets), st = rt.added, lt = rt.changed, et = rt.removed;
    (ot || st.length || lt.length || et.length) && this.updateRect();
  }, $.checkUpdate = function() {
    this.updateAbles();
  }, $.updateRect = function(_, _e, tt) {
    if (tt === void 0 && (tt = !0), !!this.controlBox) {
      this.moveables.forEach(function(Ot) {
        Ot.updateRect(_, !1, !1);
      });
      var nt = this.state, at = this.props, ot = nt.target || at.target;
      (!_e || _ !== "" && at.updateGroup) && (this.rotation = at.defaultGroupRotate, this.transformOrigin = at.defaultGroupOrigin || "50% 50%", this.scale = [1, 1]);
      var rt = this.rotation, st = this.scale, lt = getGroupRect(this.moveables, rt), et = lt[0], it = lt[1], ut = lt[2], ft = lt[3], ht = "rotate(" + rt + "deg) scale(" + (st[0] >= 0 ? 1 : -1) + ", " + (st[1] >= 0 ? 1 : -1) + ")";
      ot.style.cssText += "left:0px;top:0px; transform-origin: " + this.transformOrigin + "; width:" + ut + "px; height:" + ft + "px;" + ("transform:" + ht), nt.width = ut, nt.height = ft;
      var dt = this.getContainer(), gt = getTargetInfo(this.controlBox.getElement(), ot, this.controlBox.getElement(), this.getContainer(), this.props.rootContainer || dt), pt = [gt.left, gt.top], mt = getAbsolutePosesByState(gt), ct = mt[0], vt = mt[1], At = mt[2], xt = mt[3], bt = getMinMaxs([ct, vt, At, xt]), Et = [bt.minX, bt.minY];
      gt.pos1 = minus(ct, Et), gt.pos2 = minus(vt, Et), gt.pos3 = minus(At, Et), gt.pos4 = minus(xt, Et), gt.left = et - gt.left + Et[0], gt.top = it - gt.top + Et[1], gt.origin = minus(plus(pt, gt.origin), Et), gt.beforeOrigin = minus(plus(pt, gt.beforeOrigin), Et), gt.originalBeforeOrigin = plus(pt, gt.originalBeforeOrigin);
      var St = gt.targetClientRect, Bt = st[0] * st[1] > 0 ? 1 : -1;
      St.top += gt.top - nt.top, St.left += gt.left - nt.left, ot.style.transform = "translate(" + -Et[0] + "px, " + -Et[1] + "px) " + ht, this.updateState(__assign$1(__assign$1({}, gt), {
        direction: Bt,
        beforeDirection: Bt
      }), tt);
    }
  }, $.getRect = function() {
    return __assign$1(__assign$1({}, a.prototype.getRect.call(this)), {
      children: this.moveables.map(function(_) {
        return _.getRect();
      })
    });
  }, $.triggerEvent = function(_, _e, tt) {
    if (tt || _.indexOf("Group") > -1)
      return a.prototype.triggerEvent.call(this, _, _e);
  }, $.updateAbles = function() {
    a.prototype.updateAbles.call(this, __spreadArrays(this.props.ables, [Groupable]), "Group");
  }, s.defaultProps = __assign$1(__assign$1({}, MoveableManager.defaultProps), {
    transformOrigin: ["50%", "50%"],
    groupable: !0,
    dragArea: !0,
    keepRatio: !0,
    targets: [],
    defaultGroupRotate: 0,
    defaultGroupOrigin: "50% 50%"
  }), s;
}(MoveableManager), MoveableIndividualGroup = /* @__PURE__ */ function(a) {
  __extends$2(s, a);
  function s() {
    var _ = a !== null && a.apply(this, arguments) || this;
    return _.moveables = [], _;
  }
  var $ = s.prototype;
  return $.render = function() {
    var _ = this, _e = this.props, tt = _e.cspNonce, nt = _e.cssStyled, at = _e.targets;
    return reactExports.createElement(nt, {
      cspNonce: tt,
      ref: ref(this, "controlBox"),
      className: prefix$1("control-box")
    }, at.map(function(ot, rt) {
      return reactExports.createElement(MoveableManager, __assign$1({
        key: "moveable" + rt,
        ref: refs(_, "moveables", rt)
      }, _.props, {
        target: ot,
        wrapperMoveable: _
      }));
    }));
  }, $.componentDidUpdate = function() {
  }, $.updateRect = function(_, _e, tt) {
    tt === void 0 && (tt = !0), this.moveables.forEach(function(nt) {
      nt.updateRect(_, _e, tt);
    });
  }, $.getRect = function() {
    return __assign$1(__assign$1({}, a.prototype.getRect.call(this)), {
      children: this.moveables.map(function(_) {
        return _.getRect();
      })
    });
  }, $.request = function() {
    return {
      request: function() {
        return this;
      },
      requestEnd: function() {
        return this;
      }
    };
  }, $.dragStart = function() {
    return this;
  }, $.hitTest = function() {
    return 0;
  }, $.isInside = function() {
    return !1;
  }, $.isDragging = function() {
    return !1;
  }, $.updateRenderPoses = function() {
  }, $.updateEvent = function() {
  }, $.checkUpdate = function() {
  }, $.triggerEvent = function() {
  }, $.updateAbles = function() {
  }, s;
}(MoveableManager), InitialMoveable = /* @__PURE__ */ function(a) {
  __extends$2(s, a);
  function s() {
    var _ = a !== null && a.apply(this, arguments) || this;
    return _.refTargets = [], _.selectorMap = {}, _;
  }
  var $ = s.prototype;
  return s.makeStyled = function() {
    var _ = {}, _e = this.getTotalAbles();
    _e.forEach(function(nt) {
      var at = nt.css;
      at && at.forEach(function(ot) {
        _[ot] = !0;
      });
    });
    var tt = getKeys(_).join(`
`);
    this.defaultStyled = defaultStyled("div", prefixCSS(PREFIX, MOVEABLE_CSS + tt));
  }, s.getTotalAbles = function() {
    return __spreadArrays([Default, Groupable, IndividualGroupable, DragArea], this.defaultAbles);
  }, $.render = function() {
    var _ = this.constructor;
    _.defaultStyled || _.makeStyled();
    var _e = this.props, tt = _e.ables, nt = _e.props, at = __rest(_e, ["ables", "props"]), ot = getRefTargets(at.target || at.targets), rt = getElementTargets(ot, this.selectorMap);
    this.refTargets = ot;
    var st = rt.length > 1, lt = _.getTotalAbles(), et = __spreadArrays(lt, tt || []), it = __assign$1(__assign$1(__assign$1({}, at), nt || {}), {
      ables: et,
      cssStyled: _.defaultStyled,
      customStyledMap: _.customStyledMap
    });
    return st ? at.individualGroupable ? reactExports.createElement(MoveableIndividualGroup, __assign$1({
      key: "individual-group",
      ref: ref(this, "moveable")
    }, it, {
      target: null,
      targets: rt
    })) : reactExports.createElement(MoveableGroup, __assign$1({
      key: "group",
      ref: ref(this, "moveable")
    }, it, {
      target: null,
      targets: rt
    })) : reactExports.createElement(MoveableManager, __assign$1({
      key: "single",
      ref: ref(this, "moveable")
    }, it, {
      target: rt[0]
    }));
  }, $.componentDidMount = function() {
    this.updateRefs();
  }, $.componentDidUpdate = function() {
    this.updateRefs();
  }, $.updateRefs = function(_) {
    var _e = getRefTargets(this.props.target || this.props.targets), tt = this.refTargets.some(function(ot, rt) {
      var st = _e[rt];
      return !ot && !st ? !1 : ot !== st;
    }), nt = _ ? {} : this.selectorMap, at = {};
    this.refTargets.forEach(function(ot) {
      isString(ot) && (nt[ot] ? at[ot] = nt[ot] : (tt = !0, at[ot] = [].slice.call(document.querySelectorAll(ot))));
    }), this.selectorMap = at, tt && this.forceUpdate();
  }, $.getManager = function() {
    return this.moveable;
  }, s.defaultAbles = [], s.customStyledMap = {}, s.defaultStyled = null, __decorate([withMethods(MOVEABLE_METHODS)], s.prototype, "moveable", void 0), s;
}(reactExports.PureComponent), Moveable$1 = /* @__PURE__ */ function(a) {
  __extends$2(s, a);
  function s() {
    return a !== null && a.apply(this, arguments) || this;
  }
  return s.defaultAbles = MOVEABLE_ABLES, s;
}(InitialMoveable);
const Moveable$2 = Moveable$1, className = "pdfme-moveable", _Moveable = (a, s) => {
  const { token: $ } = theme.useToken();
  return reactExports.useEffect(() => {
    const _ = document.querySelector(`.${className}`), _e = document.querySelectorAll(
      `.${className} .moveable-line`
    );
    _ && (_.style.setProperty("--moveable-color", $.colorPrimary), Array.from(_e).map(
      (tt) => tt.style.setProperty("--moveable-color", $.colorPrimary)
    ));
  }, [a.target]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Moveable$2,
    {
      style: { zIndex: 1 },
      className,
      rootContainer: document ? document.body : void 0,
      snappable: !0,
      snapCenter: !0,
      draggable: !0,
      rotatable: a.rotatable,
      resizable: !0,
      throttleDrag: 1,
      throttleRotate: 1,
      throttleResize: 1,
      ref: s,
      target: a.target,
      bounds: a.bounds,
      horizontalGuidelines: a.horizontalGuidelines,
      verticalGuidelines: a.verticalGuidelines,
      keepRatio: a.keepRatio,
      onRotate: a.onRotate,
      onRotateEnd: a.onRotateEnd,
      onRotateGroup: ({ events: _ }) => {
        _.forEach(a.onRotate);
      },
      onRotateGroupEnd: a.onRotateGroupEnd,
      onDrag: a.onDrag,
      onDragGroup: ({ events: _ }) => {
        _.forEach(a.onDrag);
      },
      onDragEnd: a.onDragEnd,
      onDragGroupEnd: a.onDragGroupEnd,
      onResize: a.onResize,
      onResizeGroup: ({ events: _ }) => {
        _.forEach(a.onResize);
      },
      onResizeEnd: a.onResizeEnd,
      onResizeGroupEnd: a.onResizeGroupEnd,
      onClick: a.onClick
    }
  );
}, Moveable = reactExports.forwardRef(_Moveable);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics$1 = function(a, s) {
  return extendStatics$1 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function($, _) {
    $.__proto__ = _;
  } || function($, _) {
    for (var _e in _)
      _.hasOwnProperty(_e) && ($[_e] = _[_e]);
  }, extendStatics$1(a, s);
};
function __extends$1(a, s) {
  extendStatics$1(a, s);
  function $() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : ($.prototype = s.prototype, new $());
}
var Ruler = /* @__PURE__ */ function(a) {
  __extends$1(s, a);
  function s() {
    var _ = a !== null && a.apply(this, arguments) || this;
    return _.state = {
      scrollPos: 0
    }, _.width = 0, _.height = 0, _;
  }
  var $ = s.prototype;
  return $.render = function() {
    return reactExports.createElement("canvas", {
      ref: ref(this, "canvasElement"),
      style: this.props.style
    });
  }, $.componentDidMount = function() {
    var _ = this.canvasElement, _e = _.getContext("2d");
    this.canvasContext = _e, this.resize();
  }, $.componentDidUpdate = function() {
    this.resize();
  }, $.scroll = function(_) {
    this.draw(_);
  }, $.resize = function() {
    var _ = this.canvasElement, _e = this.props, tt = _e.width, nt = _e.height, at = _e.scrollPos;
    this.width = tt || _.offsetWidth, this.height = nt || _.offsetHeight, _.width = this.width * 2, _.height = this.height * 2, this.draw(at);
  }, $.draw = function(_) {
    _ === void 0 && (_ = this.state.scrollPos);
    var _e = this.props, tt = _e, nt = tt.unit, at = tt.zoom, ot = tt.type, rt = tt.backgroundColor, st = tt.lineColor, lt = tt.textColor, et = tt.direction, it = tt.negativeRuler, ut = it === void 0 ? !0 : it, ft = tt.segment, ht = ft === void 0 ? 10 : ft, dt = tt.textFormat, gt = this.width, pt = this.height, mt = this.state;
    mt.scrollPos = _;
    var ct = this.canvasContext, vt = ot === "horizontal", At = et === "start", xt = ut !== !1, bt = _e.font || "10px sans-serif", Et = _e.textAlign || "left", St = _e.textOffset || [0, 0], Bt = vt ? pt : gt, Ot = convertUnitSize("" + (_e.mainLineSize || "100%"), Bt), Pt = convertUnitSize("" + (_e.longLineSize || 10), Bt), wt = convertUnitSize("" + (_e.shortLineSize || 7), Bt);
    rt === "transparent" ? ct.clearRect(0, 0, gt * 2, pt * 2) : (ct.rect(0, 0, gt * 2, pt * 2), ct.fillStyle = rt, ct.fill()), ct.save(), ct.scale(2, 2), ct.strokeStyle = st, ct.lineWidth = 1, ct.font = bt, ct.fillStyle = lt, At && (ct.textBaseline = "top"), ct.translate(0.5, 0), ct.beginPath();
    for (var Ct = vt ? gt : pt, It = at * nt, yt = Math.floor(_ * at / It), Rt = Math.ceil((_ * at + Ct) / It), kt = Rt - yt, jt = Math.max(["left", "center", "right"].indexOf(Et) - 1, -1), Ht = 0; Ht <= kt; ++Ht) {
      var Ft = Ht + yt;
      if (!(!xt && Ft < 0)) {
        for (var _t = (Ft * nt - _) * at, Nt = 0; Nt < ht; ++Nt) {
          var Mt = _t + Nt / ht * It;
          if (!(Mt < 0 || Mt >= Ct)) {
            var Lt = Nt === 0 ? Ot : Nt % 2 === 0 ? Pt : wt, $t = vt ? [Mt, At ? 0 : pt - Lt] : [At ? 0 : gt - Lt, Mt], Tt = $t[0], Dt = $t[1], Ut = vt ? [Tt, Dt + Lt] : [Tt + Lt, Dt], Vt = Ut[0], Qt = Ut[1];
            ct.moveTo(Tt, Dt), ct.lineTo(Vt, Qt);
          }
        }
        if (_t >= -It && _t < Ct + nt * at) {
          var qt = vt ? [_t + jt * -3, At ? 17 : pt - 17] : [At ? 17 : gt - 17, _t + jt * 3], Zt = qt[0], ar = qt[1], Jt = "" + Ft * nt;
          dt && (Jt = dt(Ft * nt)), ct.textAlign = Et, vt ? ct.fillText(Jt, Zt + St[0], ar + St[1]) : (ct.save(), ct.translate(Zt + St[0], ar + St[1]), ct.rotate(-Math.PI / 2), ct.fillText(Jt, 0, 0), ct.restore());
        }
      }
    }
    ct.stroke(), ct.restore();
  }, s.defaultProps = {
    type: "horizontal",
    zoom: 1,
    width: 0,
    height: 0,
    unit: 50,
    negativeRuler: !0,
    mainLineSize: "100%",
    longLineSize: 10,
    shortLineSize: 7,
    segment: 10,
    direction: "end",
    style: {
      width: "100%",
      height: "100%"
    },
    backgroundColor: "#333333",
    font: "10px sans-serif",
    textColor: "#ffffff",
    lineColor: "#777777"
  }, s;
}(reactExports.PureComponent), PROPERTIES = ["type", "width", "height", "unit", "zoom", "style", "backgroundColor", "lineColor", "textColor", "direction", "textFormat", "scrollPos", "textAlign", "mainLineSize", "longLineSize", "shortLineSize", "negativeRuler", "textOffset", "font", "segment"];
const Ruler$1 = Ruler;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(a, s) {
  return extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function($, _) {
    $.__proto__ = _;
  } || function($, _) {
    for (var _e in _)
      _.hasOwnProperty(_e) && ($[_e] = _[_e]);
  }, extendStatics(a, s);
};
function __extends(a, s) {
  extendStatics(a, s);
  function $() {
    this.constructor = a;
  }
  a.prototype = s === null ? Object.create(s) : ($.prototype = s.prototype, new $());
}
var __assign = function() {
  return __assign = Object.assign || function(s) {
    for (var $, _ = 1, _e = arguments.length; _ < _e; _++) {
      $ = arguments[_];
      for (var tt in $)
        Object.prototype.hasOwnProperty.call($, tt) && (s[tt] = $[tt]);
    }
    return s;
  }, __assign.apply(this, arguments);
};
function prefix() {
  for (var a = [], s = 0; s < arguments.length; s++)
    a[s] = arguments[s];
  return prefixNames.apply(void 0, ["scena-"].concat(a));
}
prefix("ruler");
var ADDER = prefix("guide", "adder"), GUIDES = prefix("guides"), GUIDE = prefix("guide"), DRAGGING = prefix("dragging"), DISPLAY_DRAG = prefix("display-drag"), GUIDES_CSS = prefixCSS("scena-", `
{
    position: relative;
    width: 100%;
    height: 100%;
}
canvas {
    position: relative;
}
.guide-origin {
    position: absolute;
    width: 1px;
    height: 1px;
    top: 0;
    left: 0;
    opacity: 0;
}
.guides {
    position: absolute;
    top: 0;
    left: 0;
    will-change: transform;
    z-index: 2000;
}
.display-drag {
    position: absolute;
    will-change: transform;
    z-index: 2000;
    font-weight: bold;
    font-size: 12px;
    display: none;
    left: 20px;
    top: -20px;
    color: #f33;
}
:host.horizontal .guides {
    width: 100%;
    height: 0;
    top: 30px;
}
:host.vertical .guides {
    height: 100%;
    width: 0;
    left: 30px;
}
.guide {
    position: absolute;
    background: #f33;
    z-index: 2;
}
.guide.dragging:before {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
:host.horizontal .guide {
    width: 100%;
    height: 1px;
    cursor: row-resize;
}
:host.vertical .guide {
    width: 1px;
    height: 100%;
    cursor: col-resize;
}
.mobile :host.horizontal .guide {
    transform: scale(1, 2);
}
.mobile :host.vertical .guide {
    transform: scale(2, 1);
}
:host.horizontal .guide:before {
    height: 20px;
}
:host.vertical .guide:before {
    width: 20px;
}
.adder {
    display: none;
}
.adder.dragging {
    display: block;
}
`), GuidesElement = defaultStyled("div", GUIDES_CSS), Guides$1 = /* @__PURE__ */ function(a) {
  __extends(s, a);
  function s() {
    var _ = a !== null && a.apply(this, arguments) || this;
    return _.state = {
      guides: []
    }, _.scrollPos = 0, _.guideElements = [], _.onDragStart = function(_e) {
      var tt = _e.datas, nt = _e.inputEvent, at = _.props.onDragStart;
      addClass(tt.target, DRAGGING), _.onDrag(_e), at(__assign({}, _e, {
        dragElement: tt.target
      })), nt.stopPropagation(), nt.preventDefault();
    }, _.onDrag = function(_e) {
      var tt = _.movePos(_e);
      return _.props.onDrag(__assign({}, _e, {
        dragElement: _e.datas.target
      })), tt;
    }, _.onDragEnd = function(_e) {
      var tt = _e.datas, nt = _e.isDouble, at = _e.distX, ot = _e.distY, rt = _.movePos(_e), st = _.state.guides, lt = _.props, et = lt.onChangeGuides, it = lt.zoom, ut = lt.displayDragPos, ft = lt.digit, ht = lt.lockGuides, dt = parseFloat((rt / it).toFixed(ft || 0));
      if (ut && (_.displayElement.style.cssText += "display: none;"), removeClass(tt.target, DRAGGING), _.props.onDragEnd(__assign({}, _e, {
        dragElement: tt.target
      })), tt.fromRuler)
        rt >= _.scrollPos && st.indexOf(dt) < 0 && _.setState({
          guides: st.concat([dt])
        }, function() {
          et({
            guides: _.state.guides,
            distX: at,
            distY: ot,
            isAdd: !0,
            isRemove: !1,
            isChange: !1
          });
        });
      else {
        var gt = tt.target.getAttribute("data-index"), pt = !1, mt = !1;
        if (st = st.slice(), nt || dt < _.scrollPos) {
          if (ht && (ht === !0 || ht.indexOf("remove") > -1))
            return;
          st.splice(gt, 1), pt = !0;
        } else {
          if (st.indexOf(dt) > -1)
            return;
          if (ht && (ht === !0 || ht.indexOf("change") > -1))
            return;
          st[gt] = dt, mt = !0;
        }
        _.setState({
          guides: st
        }, function() {
          var ct = _.state.guides;
          et({
            distX: at,
            distY: ot,
            guides: ct,
            isAdd: !1,
            isChange: mt,
            isRemove: pt
          });
        });
      }
    }, _;
  }
  var $ = s.prototype;
  return $.render = function() {
    var _ = this.props, _e = _.className, tt = _.type, nt = _.zoom, at = _.style, ot = _.rulerStyle, rt = _.displayDragPos, st = _.cspNonce, lt = _.dragGuideStyle, et = _.portalContainer, it = this.props, ut = this.getTranslateName(), ft = {};
    return PROPERTIES.forEach(function(ht) {
      ht !== "style" && (ft[ht] = it[ht]);
    }), reactExports.createElement(GuidesElement, {
      ref: ref(this, "manager"),
      cspNonce: st,
      className: prefix("manager", tt) + " " + _e,
      portalContainer: et,
      style: at
    }, reactExports.createElement("div", {
      className: prefix("guide-origin"),
      ref: ref(this, "originElement")
    }), reactExports.createElement(Ruler$1, __assign({
      ref: ref(this, "ruler"),
      style: ot
    }, ft)), reactExports.createElement("div", {
      className: GUIDES,
      ref: ref(this, "guidesElement"),
      style: {
        transform: ut + "(" + -this.scrollPos * nt + "px)"
      }
    }, rt && reactExports.createElement("div", {
      className: DISPLAY_DRAG,
      ref: ref(this, "displayElement"),
      style: lt
    }), reactExports.createElement("div", {
      className: ADDER,
      ref: ref(this, "adderElement")
    }), this.renderGuides()));
  }, $.renderGuides = function() {
    var _ = this, _e = this.props, tt = _e.type, nt = _e.zoom, at = _e.showGuides, ot = _e.guideStyle, rt = this.getTranslateName(), st = this.state.guides;
    if (this.guideElements = [], at)
      return st.map(function(lt, et) {
        return reactExports.createElement("div", {
          className: prefix("guide", tt),
          ref: refs(_, "guideElements", et),
          key: et,
          "data-index": et,
          "data-pos": lt,
          style: __assign({}, ot, {
            transform: rt + "(" + lt * nt + "px) translateZ(0px)"
          })
        });
      });
  }, $.componentDidMount = function() {
    var _ = this;
    this.gesto = new Gesto(this.manager.getElement(), {
      container: document.body
    }).on("dragStart", function(_e) {
      var tt = _.props, nt = tt.type, at = tt.zoom, ot = tt.lockGuides;
      if (ot === !0) {
        _e.stop();
        return;
      }
      var rt = _e.inputEvent, st = rt.target, lt = _e.datas, et = _.ruler.canvasElement, it = _.guidesElement, ut = nt === "horizontal", ft = _.originElement.getBoundingClientRect(), ht = getDistElementMatrix(_.manager.getElement()), dt = calculateMatrixDist(ht, [_e.clientX - ft.left, _e.clientY - ft.top]);
      dt[0] -= it.offsetLeft, dt[1] -= it.offsetTop, dt[ut ? 1 : 0] += _.scrollPos * at, lt.offsetPos = dt, lt.matrix = ht;
      var gt = ot && ot.indexOf("add") > -1, pt = ot && ot.indexOf("remove") > -1, mt = ot && ot.indexOf("change") > -1;
      if (st === et) {
        if (gt) {
          _e.stop();
          return;
        }
        lt.fromRuler = !0, lt.target = _.adderElement;
      } else if (hasClass(st, GUIDE)) {
        if (pt && mt) {
          _e.stop();
          return;
        }
        lt.target = st;
      } else
        return _e.stop(), !1;
      _.onDragStart(_e);
    }).on("drag", this.onDrag).on("dragEnd", this.onDragEnd), this.setState({
      guides: this.props.defaultGuides || []
    });
  }, $.componentWillUnmount = function() {
    this.gesto.unset();
  }, $.componentDidUpdate = function(_) {
    _.defaultGuides !== this.props.defaultGuides && this.setState({
      guides: this.props.defaultGuides || []
    });
  }, $.loadGuides = function(_) {
    this.setState({
      guides: _
    });
  }, $.getGuides = function() {
    return this.state.guides;
  }, $.scrollGuides = function(_) {
    var _e = this.props.zoom, tt = this.guidesElement;
    this.scrollPos = _, tt.style.transform = this.getTranslateName() + "(" + -_ * _e + "px)";
    var nt = this.state.guides;
    this.guideElements.forEach(function(at, ot) {
      at && (at.style.display = -_ + nt[ot] < 0 ? "none" : "block");
    });
  }, $.resize = function() {
    this.ruler.resize();
  }, $.scroll = function(_) {
    this.ruler.scroll(_);
  }, $.movePos = function(_) {
    var _e = _.datas, tt = _.distX, nt = _.distY, at = this.props, ot = at.type, rt = at.zoom, st = at.snaps, lt = at.snapThreshold, et = at.displayDragPos, it = at.digit, ut = at.dragPosFormat || function(xt) {
      return xt;
    }, ft = ot === "horizontal", ht = calculateMatrixDist(_e.matrix, [tt, nt]), dt = _e.offsetPos, gt = ht[0] + dt[0], pt = ht[1] + dt[1], mt = Math.round(ft ? pt : gt), ct = parseFloat((mt / rt).toFixed(it || 0)), vt = st.slice().sort(function(xt, bt) {
      return Math.abs(ct - xt) - Math.abs(ct - bt);
    });
    if (vt.length && Math.abs(vt[0] * rt - mt) < lt && (ct = vt[0], mt = ct * rt), et) {
      var At = ot === "horizontal" ? [gt, mt] : [mt, pt];
      this.displayElement.style.cssText += "display: block;transform: translate(-50%, -50%) " + ("translate(" + At.map(function(xt) {
        return xt + "px";
      }).join(", ") + ")"), this.displayElement.innerHTML = "" + ut(ct);
    }
    return _e.target.setAttribute("data-pos", ct), _e.target.style.transform = this.getTranslateName() + "(" + mt + "px)", mt;
  }, $.getTranslateName = function() {
    return this.props.type === "horizontal" ? "translateY" : "translateX";
  }, s.defaultProps = {
    className: "",
    type: "horizontal",
    zoom: 1,
    style: {},
    snapThreshold: 5,
    snaps: [],
    digit: 0,
    onChangeGuides: function() {
    },
    onDragStart: function() {
    },
    onDrag: function() {
    },
    onDragEnd: function() {
    },
    displayDragPos: !1,
    dragPosFormat: function(_) {
      return _;
    },
    defaultGuides: [],
    lockGuides: !1,
    showGuides: !0,
    guideStyle: {},
    dragGuideStyle: {},
    portalContainer: null
  }, s;
}(reactExports.PureComponent);
const Guides$2 = Guides$1, guideStyle = (a, s, $, _) => ({
  position: "absolute",
  top: a,
  left: s,
  height: $,
  width: _,
  background: "#333333"
}), _Guides = ({
  paperSize: a,
  horizontalRef: s,
  verticalRef: $
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "ruler-container",
      style: guideStyle(-RULER_HEIGHT, -RULER_HEIGHT, RULER_HEIGHT, RULER_HEIGHT)
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Guides$2,
    {
      zoom: ZOOM,
      style: guideStyle(-RULER_HEIGHT, 0, RULER_HEIGHT, a.width),
      type: "horizontal",
      ref: s
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Guides$2,
    {
      zoom: ZOOM,
      style: guideStyle(0, -RULER_HEIGHT, a.height, RULER_HEIGHT),
      type: "vertical",
      ref: $
    }
  )
] }), Guides = _Guides, Mask = ({ width: a, height: s }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    style: {
      position: "absolute",
      top: -RULER_HEIGHT,
      left: -RULER_HEIGHT,
      zIndex: 100,
      width: a,
      height: s,
      background: theme.useToken().token.colorBgMask
    }
  }
), Mask$1 = Mask, getPaddingStyle = (a, s, $) => {
  const _ = {
    position: "absolute",
    background: $,
    opacity: 0.25,
    pointerEvents: "none"
  };
  switch (a) {
    case 0:
      _.top = 0, _.height = `${s * ZOOM}px`, _.left = 0, _.right = 0;
      break;
    case 1:
      _.right = 0, _.width = `${s * ZOOM}px`, _.top = 0, _.bottom = 0;
      break;
    case 2:
      _.bottom = 0, _.height = `${s * ZOOM}px`, _.left = 0, _.right = 0;
      break;
    case 3:
      _.left = 0, _.width = `${s * ZOOM}px`, _.top = 0, _.bottom = 0;
      break;
  }
  return _;
}, Padding = ({ basePdf: a }) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: isBlankPdf(a) && a.padding.map((s, $) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: getPaddingStyle($, s, theme.useToken().token.colorError) }, String($))) }), Padding$1 = Padding, mm2px = (a) => a * 3.7795275591, DELETE_BTN_ID = uuid$6(), fmt4Num = (a) => Number(a.replace("px", "")), fmt = (a) => round(fmt4Num(a) / ZOOM, 2), isTopLeftResize = (a) => a === "-1,-1" || a === "-1,0" || a === "0,-1", normalizeRotate = (a) => (a % 360 + 360) % 360, DeleteButton = ({ activeElements: a }) => {
  const { token: s } = theme.useToken(), $ = 26, _ = Math.min(...a.map(({ style: tt }) => fmt4Num(tt.top))), _e = Math.max(...a.map(({ style: tt }) => fmt4Num(tt.left) + fmt4Num(tt.width))) + 10;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button$2,
    {
      id: DELETE_BTN_ID,
      style: {
        position: "absolute",
        zIndex: 1,
        top: _,
        left: _e,
        width: $,
        height: $,
        padding: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: s.borderRadius,
        color: s.colorWhite,
        background: s.colorPrimary
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseOutlined$4, { style: { pointerEvents: "none" } })
    }
  );
}, Canvas = (a, s) => {
  const {
    basePdf: $,
    pageCursor: _,
    scale: _e,
    backgrounds: tt,
    pageSizes: nt,
    size: at,
    activeElements: ot,
    schemasList: rt,
    hoveringSchemaId: st,
    onEdit: lt,
    changeSchemas: et,
    removeSchemas: it,
    onChangeHoveringSchemaId: ut,
    paperRefs: ft,
    sidebarOpen: ht
  } = a, { token: dt } = theme.useToken(), gt = reactExports.useContext(PluginsRegistry), pt = reactExports.useRef([]), mt = reactExports.useRef([]), ct = reactExports.useRef(null), [vt, At] = reactExports.useState(!1), [xt, bt] = reactExports.useState(!1), Et = usePrevious(rt[_]), St = (Lt) => {
    Lt.shiftKey && At(!0);
  }, Bt = (Lt) => {
    (Lt.key === "Shift" || !Lt.shiftKey) && At(!1), (Lt.key === "Escape" || Lt.key === "Esc") && bt(!1);
  }, Ot = reactExports.useCallback(() => {
    window.addEventListener("keydown", St), window.addEventListener("keyup", Bt);
  }, []), Pt = reactExports.useCallback(() => {
    window.removeEventListener("keydown", St), window.removeEventListener("keyup", Bt);
  }, []);
  reactExports.useEffect(() => (Ot(), Pt), [Ot, Pt]), reactExports.useEffect(() => {
    var Tt, Dt;
    if ((Tt = ct.current) == null || Tt.updateRect(), !Et)
      return;
    const Lt = JSON.stringify(Et[_] || {}), $t = JSON.stringify(rt[_] || {});
    Lt === $t && ((Dt = ct.current) == null || Dt.updateRect());
  }, [_, rt, Et]);
  const wt = ({ target: Lt, top: $t, left: Tt }) => {
    const { width: Dt, height: Ut } = Lt.style, Vt = fmt(Dt), Qt = fmt(Ut), qt = $t / ZOOM, Zt = Tt / ZOOM, { width: ar, height: Jt } = nt[_];
    let rr = 0, Yt = 0, Kt = 0, nr = 0;
    if (isBlankPdf($)) {
      const [tr, ir, sr, cr] = $.padding;
      rr = tr * ZOOM, Yt = ir, Kt = sr, nr = cr * ZOOM;
    }
    qt + Qt > Jt - Kt ? Lt.style.top = `${(Jt - Qt - Kt) * ZOOM}px` : Lt.style.top = `${$t < rr ? rr : $t}px`, Zt + Vt > ar - Yt ? Lt.style.left = `${(ar - Vt - Yt) * ZOOM}px` : Lt.style.left = `${Tt < nr ? nr : Tt}px`;
  }, Ct = ({ target: Lt }) => {
    const { top: $t, left: Tt } = Lt.style;
    et([
      { key: "position.y", value: fmt($t), schemaId: Lt.id },
      { key: "position.x", value: fmt(Tt), schemaId: Lt.id }
    ]);
  }, It = ({ targets: Lt }) => {
    const $t = Lt.map(({ style: { top: Tt, left: Dt }, id: Ut }) => [
      { key: "position.y", value: fmt(Tt), schemaId: Ut },
      { key: "position.x", value: fmt(Dt), schemaId: Ut }
    ]);
    et(flatten($t));
  }, yt = ({ target: Lt, rotate: $t }) => {
    Lt.style.transform = `rotate(${$t}deg)`;
  }, Rt = ({ target: Lt }) => {
    const { transform: $t } = Lt.style, Tt = Number($t.replace("rotate(", "").replace("deg)", "")), Dt = normalizeRotate(Tt);
    et([{ key: "rotate", value: Dt, schemaId: Lt.id }]);
  }, kt = ({ targets: Lt }) => {
    const $t = Lt.map(({ style: { transform: Tt }, id: Dt }) => {
      const Ut = Number(Tt.replace("rotate(", "").replace("deg)", ""));
      return [{ key: "rotate", value: normalizeRotate(Ut), schemaId: Dt }];
    });
    et(flatten($t));
  }, jt = ({ target: Lt }) => {
    const { id: $t, style: Tt } = Lt, { width: Dt, height: Ut, top: Vt, left: Qt } = Tt;
    et([
      { key: "position.x", value: fmt(Qt), schemaId: $t },
      { key: "position.y", value: fmt(Vt), schemaId: $t },
      { key: "width", value: fmt(Dt), schemaId: $t },
      { key: "height", value: fmt(Ut), schemaId: $t }
    ]);
    const qt = rt[_].find((Zt) => Zt.id === $t);
    qt && (qt.position.x = fmt(Qt), qt.position.y = fmt(Vt), qt.width = fmt(Dt), qt.height = fmt(Ut));
  }, Ht = ({ targets: Lt }) => {
    const $t = Lt.map(({ style: { width: Tt, height: Dt, top: Ut, left: Vt }, id: Qt }) => [
      { key: "width", value: fmt(Tt), schemaId: Qt },
      { key: "height", value: fmt(Dt), schemaId: Qt },
      { key: "position.y", value: fmt(Ut), schemaId: Qt },
      { key: "position.x", value: fmt(Vt), schemaId: Qt }
    ]);
    et(flatten($t));
  }, Ft = ({ target: Lt, width: $t, height: Tt, direction: Dt }) => {
    if (!Lt)
      return;
    let Ut = 0, Vt = 0, Qt = 0, qt = 0;
    if (isBlankPdf($)) {
      const [tr, ir, sr, cr] = $.padding;
      Ut = tr * ZOOM, Vt = mm2px(ir), Qt = mm2px(sr), qt = cr * ZOOM;
    }
    const Zt = mm2px(nt[_].width), ar = mm2px(nt[_].height), Jt = {
      width: `${$t}px`,
      height: `${Tt}px`
    }, rr = Lt.style;
    let Yt = fmt4Num(rr.left) + (fmt4Num(rr.width) - $t), Kt = fmt4Num(rr.top) + (fmt4Num(rr.height) - Tt);
    Yt < qt && (Yt = qt), Kt < Ut && (Kt = Ut), Yt + $t > Zt - Vt && (Jt.width = `${Zt - Vt - Yt}px`), Kt + Tt > ar - Qt && (Jt.height = `${ar - Qt - Kt}px`);
    const nr = Dt.toString();
    isTopLeftResize(nr) ? (Jt.top = `${Kt}px`, Jt.left = `${Yt}px`) : nr === "1,-1" ? Jt.top = `${Kt}px` : nr === "-1,1" && (Jt.left = `${Yt}px`), Object.assign(rr, Jt);
  }, _t = (Lt, $t) => Lt[$t] && Lt[$t].getGuides().map((Tt) => Tt * ZOOM), Nt = (Lt) => {
    Lt.inputEvent.stopPropagation(), bt(!0);
  }, Mt = reactExports.useMemo(() => {
    const $t = (rt[_] || []).filter(
      (Ut) => ot.map((Vt) => Vt.id).includes(Ut.id)
    ).map((Ut) => Ut.type), Tt = [...new Set($t)], Dt = Object.values(gt).map(
      (Ut) => Ut == null ? void 0 : Ut.propPanel.defaultSchema
    );
    return Tt.every(
      (Ut) => {
        var Vt;
        return ((Vt = Dt.find((Qt) => Qt.type === Ut)) == null ? void 0 : Vt.rotate) !== void 0;
      }
    );
  }, [ot, _, rt, gt]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: {
        position: "relative",
        overflow: "auto",
        marginRight: ht ? RIGHT_SIDEBAR_WIDTH : 0,
        ...at
      },
      ref: s,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Selecto,
          {
            container: ft.current[_],
            continueSelect: vt,
            onDragStart: (Lt) => {
              var Dt, Ut;
              const { inputEvent: $t } = Lt, Tt = (Dt = ct.current) == null ? void 0 : Dt.isMoveableElement($t.target);
              ($t.type === "touchstart" && Lt.isTrusted || Tt) && Lt.stop(), ft.current[_] === $t.target && lt([]), ((Ut = $t.target) == null ? void 0 : Ut.id) === DELETE_BTN_ID && it(ot.map((Vt) => Vt.id));
            },
            onSelect: ({ added: Lt, removed: $t, selected: Tt, inputEvent: Dt }) => {
              const Ut = Dt.type === "mousedown";
              let Vt = Ut ? Tt : [];
              !Ut && Lt.length > 0 && (Vt = ot.concat(Lt)), !Ut && $t.length > 0 && (Vt = ot.filter((Qt) => !$t.includes(Qt))), lt(Vt), Vt != ot && bt(!1), Dt.shiftKey || At(!1);
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Paper$1,
          {
            paperRefs: ft,
            scale: _e,
            size: at,
            schemasList: rt,
            pageSizes: nt,
            backgrounds: tt,
            hasRulers: !0,
            renderPaper: ({ index: Lt, paperSize: $t }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              !xt && ot.length > 0 && _ === Lt && /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteButton, { activeElements: ot }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Padding$1, { basePdf: $ }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Guides,
                {
                  paperSize: $t,
                  horizontalRef: (Tt) => {
                    Tt && (mt.current[Lt] = Tt);
                  },
                  verticalRef: (Tt) => {
                    Tt && (pt.current[Lt] = Tt);
                  }
                }
              ),
              _ !== Lt ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                Mask$1,
                {
                  width: $t.width + RULER_HEIGHT,
                  height: $t.height + RULER_HEIGHT
                }
              ) : !xt && /* @__PURE__ */ jsxRuntimeExports.jsx(
                Moveable,
                {
                  ref: ct,
                  target: ot,
                  bounds: { left: 0, top: 0, bottom: $t.height, right: $t.width },
                  horizontalGuidelines: _t(mt.current, Lt),
                  verticalGuidelines: _t(pt.current, Lt),
                  keepRatio: vt,
                  rotatable: Mt,
                  onDrag: wt,
                  onDragEnd: Ct,
                  onDragGroupEnd: It,
                  onRotate: yt,
                  onRotateEnd: Rt,
                  onRotateGroupEnd: kt,
                  onResize: Ft,
                  onResizeEnd: jt,
                  onResizeGroupEnd: Ht,
                  onClick: Nt
                }
              )
            ] }),
            renderSchema: ({ schema: Lt }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              Renderer$1,
              {
                schema: Lt,
                basePdf: $,
                value: Lt.content || "",
                onChangeHoveringSchemaId: ut,
                mode: xt && ot.map(($t) => $t.id).includes(Lt.id) ? "designer" : "viewer",
                onChange: ($t) => {
                  const Tt = Array.isArray($t) ? $t : [$t];
                  et(Tt.map(({ key: Dt, value: Ut }) => ({ key: Dt, value: Ut, schemaId: Lt.id })));
                },
                stopEditing: () => bt(!1),
                outline: `1px ${st === Lt.id ? "solid" : "dashed"} ${Lt.readOnly && st !== Lt.id ? "transparent" : dt.colorPrimary}`,
                scale: _e
              },
              Lt.id
            )
          }
        )
      ]
    }
  );
}, Canvas$1 = reactExports.forwardRef(Canvas), Spinner = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Spin$1,
  {
    style: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    indicator: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOutlined$1, { style: { fontSize: 50 }, spin: !0 })
  }
), Spinner$1 = Spinner, Root = ({ size: a, scale: s, children: $ }, _) => {
  const _e = reactExports.useContext(FontContext);
  return reactExports.useEffect(() => {
    if (!document || !document.fonts)
      return;
    const nt = Object.entries(_e).map(
      ([at, { data: ot }]) => new FontFace(at, typeof ot == "string" ? `url(${ot})` : ot, {
        display: "swap"
      })
    ).filter((at) => !document.fonts.has(at));
    Promise.allSettled(nt.map((at) => at.load())).then((at) => {
      at.forEach((ot) => {
        ot.status === "fulfilled" && document.fonts.add(ot.value);
      });
    });
  }, [_e]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: _, style: { position: "relative", background: BACKGROUND_COLOR, ...a }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { margin: "0 auto", ...a }, children: s === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner$1, {}) : $ }) });
}, Root$1 = reactExports.forwardRef(Root), ErrorScreen = ({ size: a, error: s }) => {
  const $ = reactExports.useContext(I18nContext), { token: _ } = theme.useToken();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        background: BACKGROUND_COLOR,
        ...a
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { width: 300, margin: "0 auto", background: _.colorBgLayout }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Result$2,
        {
          icon: null,
          title: "ERROR",
          subTitle: $("errorOccurred"),
          extra: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: s.message })
        }
      ) })
    }
  );
}, ErrorScreen$1 = ErrorScreen, { Text: Text$1 } = Typography$1, Zoom = ({ zoomLevel: a, setZoomLevel: s, style: $ }) => {
  const nt = a - 0.25, at = a + 0.25;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$2,
      {
        type: "text",
        disabled: 0.25 >= nt,
        onClick: () => s(nt),
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(MinusOutlined$1, { style: { color: $.textStyle.color } })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { strong: !0, style: $.textStyle, children: [
      Math.round(a * 100),
      "%"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$2,
      {
        type: "text",
        disabled: 2 < at,
        onClick: () => s(at),
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(PlusOutlined$4, { style: { color: $.textStyle.color } })
      }
    )
  ] });
}, Pager = ({ pageCursor: a, pageNum: s, setPageCursor: $, style: _ }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, { type: "text", disabled: a <= 0, onClick: () => $(a - 1), children: /* @__PURE__ */ jsxRuntimeExports.jsx(LeftOutlined$1, { style: { color: _.textStyle.color } }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { strong: !0, style: _.textStyle, children: [
    a + 1,
    "/",
    s
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button$2,
    {
      type: "text",
      disabled: a + 1 >= s,
      onClick: () => $(a + 1),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(RightOutlined$1, { style: { color: _.textStyle.color } })
    }
  )
] }), ContextMenu = ({ items: a, style: s }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Dropdown$1, { menu: { items: a }, placement: "top", arrow: !0, trigger: ["click"], children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, { type: "text", children: /* @__PURE__ */ jsxRuntimeExports.jsx(EllipsisOutlined$1, { style: { color: s.textStyle.color } }) }) }), CtlBar = (a) => {
  const { token: s } = theme.useToken(), $ = reactExports.useContext(I18nContext), {
    size: _,
    pageCursor: _e,
    pageNum: tt,
    setPageCursor: nt,
    zoomLevel: at,
    setZoomLevel: ot,
    addPageAfter: rt,
    removePage: st
  } = a, lt = [];
  rt && lt.push({
    key: "1",
    label: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: rt, children: $("addPageAfter") })
  }), st && tt > 1 && _e !== 0 && lt.push({
    key: "2",
    label: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: st, children: $("removePage") })
  });
  const et = 300, it = lt.length > 0 ? 50 : 0, ut = (tt > 1 ? et : et / 2) + it, ft = {
    color: s.colorWhite,
    fontSize: s.fontSize,
    margin: s.marginXS
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { position: "absolute", top: "auto", bottom: "6%", width: _.width }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        position: "relative",
        zIndex: 1,
        left: `calc(50% - ${ut / 2}px)`,
        width: ut,
        height: 40,
        boxSizing: "border-box",
        padding: s.paddingSM,
        borderRadius: s.borderRadius,
        backgroundColor: s.colorBgMask
      },
      children: [
        tt > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Pager,
          {
            style: { textStyle: ft },
            pageCursor: _e,
            pageNum: tt,
            setPageCursor: nt
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Zoom, { style: { textStyle: ft }, zoomLevel: at, setZoomLevel: ot }),
        lt.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(ContextMenu, { items: lt, style: { textStyle: ft } })
      ]
    }
  ) });
}, CtlBar$1 = CtlBar, scaleDragPosAdjustment = (a, s) => s > 1 ? a * (s - 1) : s < 1 ? a * -(1 - s) : 0, TemplateEditor = ({
  template: a,
  size: s,
  onSaveTemplate: $,
  onChangeTemplate: _,
  onPageCursorChange: _e
}) => {
  const tt = reactExports.useRef([]), nt = reactExports.useRef([]), at = reactExports.useRef(null), ot = reactExports.useRef([]), rt = reactExports.useContext(I18nContext), st = reactExports.useContext(PluginsRegistry), lt = reactExports.useContext(OptionsContext), [et, it] = reactExports.useState(null), [ut, ft] = reactExports.useState([]), [ht, dt] = reactExports.useState([[]]), [gt, pt] = reactExports.useState(0), [mt, ct] = reactExports.useState(1), [vt, At] = reactExports.useState(!0), [xt, bt] = reactExports.useState(null), { backgrounds: Et, pageSizes: St, scale: Bt, error: Ot, refresh: Pt } = useUIPreProcessor({ template: a, size: s, zoomLevel: mt }), wt = (Tt) => {
    ft(Tt), it(null);
  }, Ct = () => {
    ft([]), it(null);
  };
  useScrollPageCursor({
    ref: at,
    pageSizes: St,
    scale: Bt,
    pageCursor: gt,
    onChangePageCursor: (Tt) => {
      pt(Tt), _e(Tt), Ct();
    }
  });
  const It = reactExports.useCallback(
    (Tt) => {
      nt.current = [], tt.current.push(cloneDeep$1(ht[gt]));
      const Dt = cloneDeep$1(ht);
      Dt[gt] = Tt, dt(Dt), _(schemasList2template(Dt, a.basePdf));
    },
    [a, ht, gt, _]
  ), yt = reactExports.useCallback(
    (Tt) => {
      It(ht[gt].filter((Dt) => !Tt.includes(Dt.id))), Ct();
    },
    [ht, gt, It]
  ), Rt = reactExports.useCallback(
    (Tt) => {
      changeSchemas({
        objs: Tt,
        schemas: ht[gt],
        basePdf: a.basePdf,
        pluginsRegistry: st,
        pageSize: St[gt],
        commitSchemas: It
      });
    },
    [It, gt, ht, st, St, a.basePdf]
  );
  useInitEvents({
    pageCursor: gt,
    pageSizes: St,
    activeElements: ut,
    template: a,
    schemasList: ht,
    changeSchemas: Rt,
    commitSchemas: It,
    removeSchemas: yt,
    onSaveTemplate: $,
    past: tt,
    future: nt,
    setSchemasList: dt,
    onEdit: wt,
    onEditEnd: Ct
  });
  const kt = reactExports.useCallback(async (Tt) => {
    var Ut;
    const Dt = await template2SchemasList(Tt);
    dt(Dt), Ct(), pt(0), (Ut = at.current) != null && Ut.scroll && at.current.scroll({ top: 0, behavior: "smooth" });
  }, []), jt = (Tt) => {
    const [Dt, Ut, Vt, Qt] = isBlankPdf(a.basePdf) ? a.basePdf.padding : [0, 0, 0, 0], qt = St[gt], Zt = (rr) => {
      let Yt = ht.reduce((nr, tr) => nr + tr.length, 1), Kt = rr + Yt;
      for (; ht.some((nr) => nr.find((tr) => tr.name === Kt)); )
        Yt++, Kt = rr + Yt;
      return Kt;
    }, ar = (rr, Yt, Kt) => Math.min(Math.max(rr, Yt), Kt), Jt = {
      id: uuid$6(),
      ...Tt,
      name: Zt(rt("field")),
      position: {
        x: ar(Qt, Tt.position.x, qt.width - Ut - Tt.width),
        y: ar(Dt, Tt.position.y, qt.height - Vt - Tt.height)
      },
      required: Tt.readOnly ? !1 : lt.requiredByDefault || Tt.required || !1
    };
    if (Tt.position.y === 0) {
      const rr = ot.current[gt], Yt = rr ? rr.getBoundingClientRect().top : 0;
      Jt.position.y = Yt > 0 ? Dt : St[gt].height / 2;
    }
    It(ht[gt].concat(Jt)), setTimeout(() => wt([document.getElementById(Jt.id)]));
  }, Ht = (Tt) => {
    It(Tt);
  }, Ft = (Tt) => {
    it(Tt);
  }, _t = async (Tt, Dt) => {
    pt(Dt);
    const Ut = schemasList2template(Tt, a.basePdf);
    _(Ut), await kt(Ut), Pt(Ut), setTimeout(
      () => at.current && (at.current.scrollTop = getPagesScrollTopByIndex(St, Dt, Bt), 0)
    );
  }, Nt = () => {
    if (gt === 0 || !window.confirm(rt("removePageConfirm")))
      return;
    const Tt = cloneDeep$1(ht);
    Tt.splice(gt, 1), _t(Tt, gt - 1);
  }, Mt = () => {
    const Tt = cloneDeep$1(ht);
    Tt.splice(gt + 1, 0, []), _t(Tt, gt + 1);
  };
  xt !== a && (bt(a), kt(a));
  const Lt = {
    width: vt ? s.width - RIGHT_SIDEBAR_WIDTH : s.width,
    height: s.height
  };
  if (Ot)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorScreen$1, { size: s, error: Ot });
  const $t = isBlankPdf(a.basePdf) ? { addPageAfter: Mt, removePage: Nt } : {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Root$1, { size: s, scale: Bt, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    DndContext,
    {
      onDragEnd: (Tt) => {
        var Yt, Kt;
        if (!Tt.active)
          return;
        const Dt = Tt.active, Ut = ot.current[gt].getBoundingClientRect(), Vt = ((Yt = Dt.rect.current.initial) == null ? void 0 : Yt.left) || 0, Qt = ((Kt = Dt.rect.current.initial) == null ? void 0 : Kt.top) || 0, qt = Ut.left - Vt + scaleDragPosAdjustment(20, Bt), Zt = Ut.top - Qt, ar = (Tt.delta.y - Zt) / Bt, Jt = (Tt.delta.x - qt) / Bt, rr = { x: round(px2mm(Math.max(0, Jt)), 2), y: round(px2mm(Math.max(0, ar)), 2) };
        jt({ ...Dt.data.current, position: rr });
      },
      onDragStart: Ct,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CtlBar$1,
          {
            size: Lt,
            pageCursor: gt,
            pageNum: ht.length,
            setPageCursor: (Tt) => {
              at.current && (at.current.scrollTop = getPagesScrollTopByIndex(St, Tt, Bt), pt(Tt), Ct());
            },
            zoomLevel: mt,
            setZoomLevel: ct,
            ...$t
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          LeftSidebar$1,
          {
            height: at.current ? at.current.clientHeight : 0,
            scale: Bt,
            basePdf: a.basePdf
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          RightSidebar,
          {
            hoveringSchemaId: et,
            onChangeHoveringSchemaId: Ft,
            height: at.current ? at.current.clientHeight : 0,
            size: s,
            pageSize: St[gt] ?? [],
            activeElements: ut,
            schemasList: ht,
            schemas: ht[gt] ?? [],
            changeSchemas: Rt,
            onSortEnd: Ht,
            onEdit: (Tt) => {
              const Dt = document.getElementById(Tt);
              Dt && wt([Dt]);
            },
            onEditEnd: Ct,
            deselectSchema: Ct,
            sidebarOpen: vt,
            setSidebarOpen: At
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Canvas$1,
          {
            ref: at,
            paperRefs: ot,
            basePdf: a.basePdf,
            hoveringSchemaId: et,
            onChangeHoveringSchemaId: Ft,
            height: s.height - RULER_HEIGHT * ZOOM,
            pageCursor: gt,
            scale: Bt,
            size: Lt,
            pageSizes: St,
            backgrounds: Et,
            activeElements: ut,
            schemasList: ht,
            changeSchemas: Rt,
            removeSchemas: yt,
            sidebarOpen: vt,
            onEdit: wt
          }
        )
      ]
    }
  ) });
}, DesignerComponent = TemplateEditor, defaultTheme = {
  token: {
    colorPrimary: "#38a0ff"
  },
  components: {
    Form: {
      fontSize: 12,
      margin: 8,
      marginLG: 12,
      marginXS: 4,
      padding: 8,
      paddingLG: 12,
      paddingXS: 4,
      itemMarginBottom: 4,
      verticalLabelPadding: "0 0 2px"
    }
  }
}, isObject = (a) => a && typeof a == "object" && !Array.isArray(a), deepMerge = (a, s) => {
  let $ = { ...a };
  return isObject(a) && isObject(s) && Object.keys(s).forEach((_) => {
    isObject(s[_]) ? _ in a ? $[_] = deepMerge(a[_], s[_]) : Object.assign($, { [_]: s[_] }) : Object.assign($, { [_]: s[_] });
  }), $;
}, AppContextProvider = ({ children: a, lang: s, font: $, plugins: _, options: _e }) => {
  let tt = defaultTheme;
  _e.theme && (tt = deepMerge(tt, _e.theme));
  let nt = getDict(s);
  return _e.labels && (nt = deepMerge(nt, _e.labels)), /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeConfigProvider, { theme: tt, children: /* @__PURE__ */ jsxRuntimeExports.jsx(I18nContext.Provider, { value: (at) => i18n(at, nt), children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontContext.Provider, { value: $, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PluginsRegistry.Provider, { value: _, children: /* @__PURE__ */ jsxRuntimeExports.jsx(OptionsContext.Provider, { value: _e, children: a }) }) }) }) });
}, AppContextProvider$1 = AppContextProvider;
class Designer extends BaseUIClass {
  constructor(s) {
    super(s), this.pageCursor = 0, checkDesignerProps(s);
  }
  saveTemplate() {
    if (!this.domContainer)
      throw Error(DESTROYED_ERR_MSG);
    this.onSaveTemplateCallback && this.onSaveTemplateCallback(this.template);
  }
  updateTemplate(s) {
    if (checkTemplate(s), !this.domContainer)
      throw Error(DESTROYED_ERR_MSG);
    this.template = cloneDeep$1(s), this.onChangeTemplateCallback && this.onChangeTemplateCallback(s), this.render();
  }
  onSaveTemplate(s) {
    this.onSaveTemplateCallback = s;
  }
  onChangeTemplate(s) {
    this.onChangeTemplateCallback = s;
  }
  getPageCursor() {
    return this.pageCursor;
  }
  render() {
    if (!this.domContainer)
      throw Error(DESTROYED_ERR_MSG);
    ReactDOM.render(
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AppContextProvider$1,
        {
          lang: this.getLang(),
          font: this.getFont(),
          plugins: this.getPluginsRegistry(),
          options: this.getOptions(),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            DesignerComponent,
            {
              template: this.template,
              onSaveTemplate: (s) => {
                this.template = s, this.template.pdfmeVersion = PDFME_VERSION, this.onSaveTemplateCallback && this.onSaveTemplateCallback(s);
              },
              onChangeTemplate: (s) => {
                this.template = s, this.template.pdfmeVersion = PDFME_VERSION, this.onChangeTemplateCallback && this.onChangeTemplateCallback(s);
              },
              onPageCursorChange: (s) => {
                this.pageCursor = s;
              },
              size: this.size
            }
          )
        }
      ),
      this.domContainer
    );
  }
}
const Designer$1 = Designer, { Text } = Typography$1, icons = {
  left: LeftOutlined$1,
  right: RightOutlined$1,
  doubleLeft: DoubleLeftOutlined$1,
  doubleRight: DoubleRightOutlined$1
}, UnitButton = ({ type: a, onClick: s, disabled: $, textStyle: _ }) => {
  const _e = icons[a];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, { type: "text", onClick: s, disabled: $, children: /* @__PURE__ */ jsxRuntimeExports.jsx(_e, { style: { color: _.color } }) });
}, UnitPager = ({ size: a, unitCursor: s, unitNum: $, setUnitCursor: _ }) => {
  if ($ <= 1)
    return null;
  const { token: _e } = theme.useToken(), tt = {
    pointerEvents: "initial",
    position: "sticky",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: 40,
    padding: _e.paddingSM,
    borderRadius: _e.borderRadius,
    backgroundColor: _e.colorBgMask
  }, nt = {
    color: _e.colorWhite,
    fontSize: _e.fontSize,
    margin: _e.marginXS
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { position: "absolute", ...a }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      style: {
        position: "sticky",
        width: "100%",
        zIndex: 1,
        top: `calc(50% - ${tt.height / 2}px)`,
        display: "flex",
        alignItems: "center"
      },
      children: [
        s > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { left: "1rem", marginLeft: "1rem", ...tt }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            UnitButton,
            {
              type: "doubleLeft",
              onClick: () => _(0),
              disabled: s <= 0,
              textStyle: nt
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            UnitButton,
            {
              type: "left",
              onClick: () => _(s - 1),
              disabled: s <= 0,
              textStyle: nt
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { strong: !0, style: nt, children: [
            s + 1,
            "/",
            $
          ] })
        ] }),
        s + 1 < $ && /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            style: { right: "1rem", marginLeft: "auto", marginRight: "1rem", ...tt },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { strong: !0, style: nt, children: [
                s + 1,
                "/",
                $
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                UnitButton,
                {
                  type: "right",
                  onClick: () => _(s + 1),
                  disabled: s + 1 >= $,
                  textStyle: nt
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                UnitButton,
                {
                  type: "doubleRight",
                  onClick: () => _($ - 1),
                  disabled: s + 1 >= $,
                  textStyle: nt
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}, UnitPager$1 = UnitPager, _cache = /* @__PURE__ */ new Map(), Preview = ({
  template: a,
  inputs: s,
  size: $,
  onChangeInput: _
}) => {
  const { token: _e } = theme.useToken(), tt = reactExports.useContext(FontContext), nt = reactExports.useRef(null), at = reactExports.useRef([]), [ot, rt] = reactExports.useState(0), [st, lt] = reactExports.useState(0), [et, it] = reactExports.useState(1), [ut, ft] = reactExports.useState([[]]), { backgrounds: ht, pageSizes: dt, scale: gt, error: pt, refresh: mt } = useUIPreProcessor({ template: a, size: $, zoomLevel: et }), ct = !!_, vt = s[ot], At = (bt) => {
    getDynamicTemplate({
      template: bt,
      input: vt,
      options: { font: tt },
      _cache,
      getDynamicHeights: (St, Bt) => {
        switch (Bt.schema.type) {
          case "table":
            return getDynamicHeightsForTable(St, Bt);
          default:
            return Promise.resolve([Bt.schema.height]);
        }
      }
    }).then(async (St) => {
      const Bt = await template2SchemasList(St);
      ft(Bt), await mt(St);
    }).catch((St) => console.error("[@pdfme/ui] ", St));
  };
  reactExports.useEffect(() => {
    ot > s.length - 1 && rt(s.length - 1), At(a);
  }, [a, s, $]), useScrollPageCursor({
    ref: nt,
    pageSizes: dt,
    scale: gt,
    pageCursor: st,
    onChangePageCursor: lt
  });
  const xt = ({ name: bt, value: Et }) => _ && _({ index: ot, name: bt, value: Et });
  return pt ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorScreen$1, { size: $, error: pt }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Root$1, { size: $, scale: gt, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CtlBar$1,
      {
        size: $,
        pageCursor: st,
        pageNum: ut.length,
        setPageCursor: (bt) => {
          nt.current && (nt.current.scrollTop = getPagesScrollTopByIndex(dt, bt, gt), lt(bt));
        },
        zoomLevel: et,
        setZoomLevel: it
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      UnitPager$1,
      {
        size: $,
        unitCursor: ot,
        unitNum: s.length,
        setUnitCursor: rt
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: nt, style: { ...$, position: "relative", overflow: "auto" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Paper$1,
      {
        paperRefs: at,
        scale: gt,
        size: $,
        schemasList: ut,
        pageSizes: dt,
        backgrounds: ht,
        renderSchema: ({ schema: bt, index: Et }) => {
          const { name: St, readOnly: Bt } = bt, Ot = Bt ? String(bt.content) || "" : String(vt && vt[St] || "");
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            Renderer$1,
            {
              schema: bt,
              basePdf: a.basePdf,
              value: Ot,
              mode: ct ? "form" : "viewer",
              placeholder: bt.content,
              tabIndex: Et + 100,
              onChange: (Pt) => {
                const wt = Array.isArray(Pt) ? Pt : [Pt];
                let Ct = !1;
                wt.forEach(({ key: It, value: yt }) => {
                  if (It === "content") {
                    const Rt = yt, kt = (vt == null ? void 0 : vt[St]) || "";
                    if (Rt === kt)
                      return;
                    xt({ name: St, value: Rt }), bt.type === "table" && (Ct = !0);
                  } else {
                    const Rt = ut[st].find(
                      (kt) => kt.id === bt.id
                    );
                    if (!Rt)
                      return;
                    Rt[It] = yt;
                  }
                }), Ct && At(a), ft([...ut]);
              },
              outline: ct && !bt.readOnly ? `1px dashed ${_e.colorPrimary}` : "transparent",
              scale: gt
            },
            bt.id
          );
        }
      }
    ) })
  ] });
}, Preview$1 = Preview;
class Form extends PreviewUI {
  constructor(s) {
    super(s);
  }
  onChangeInput(s) {
    this.onChangeInputCallback = s;
  }
  setInputs(s) {
    const $ = this.getInputs();
    super.setInputs(s);
    const _ = [];
    s.forEach((_e, tt) => {
      const nt = $[tt] || {};
      (/* @__PURE__ */ new Set([...Object.keys(_e), ...Object.keys(nt)])).forEach((ot) => {
        const rt = _e[ot], st = nt[ot];
        rt !== st && _.push({ index: tt, name: ot, value: rt });
      });
    }), _.forEach((_e) => {
      this.onChangeInputCallback && this.onChangeInputCallback(_e);
    });
  }
  render() {
    if (!this.domContainer)
      throw Error(DESTROYED_ERR_MSG);
    ReactDOM.render(
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AppContextProvider$1,
        {
          lang: this.getLang(),
          font: this.getFont(),
          plugins: this.getPluginsRegistry(),
          options: this.getOptions(),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Preview$1,
            {
              template: this.template,
              size: this.size,
              inputs: this.inputs,
              onChangeInput: (s) => {
                const { index: $, value: _, name: _e } = s;
                this.onChangeInputCallback && this.onChangeInputCallback({ index: $, value: _, name: _e }), this.inputs && this.inputs[$] && this.inputs[$][_e] !== _ && (this.inputs[$][_e] = _, this.render());
              }
            }
          )
        }
      ),
      this.domContainer
    );
  }
}
const Form$1 = Form;
class Viewer extends PreviewUI {
  constructor(s) {
    super(s);
  }
  render() {
    if (!this.domContainer)
      throw Error(DESTROYED_ERR_MSG);
    ReactDOM.render(
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AppContextProvider$1,
        {
          lang: this.getLang(),
          font: this.getFont(),
          plugins: this.getPluginsRegistry(),
          options: this.getOptions(),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(Preview$1, { template: this.template, size: this.size, inputs: this.inputs })
        }
      ),
      this.domContainer
    );
  }
}
const Viewer$1 = Viewer;
export {
  Designer$1 as Designer,
  Form$1 as Form,
  Viewer$1 as Viewer
};
